//region block: polyfills
(function () {
  if (typeof globalThis === 'object')
    return;
  Object.defineProperty(Object.prototype, '__magic__', {get: function () {
    return this;
  }, configurable: true});
  __magic__.globalThis = __magic__;
  delete Object.prototype.__magic__;
}());
if (typeof Math.imul === 'undefined') {
  Math.imul = function imul(a, b) {
    return (a & 4.29490176E9) * (b & 65535) + (a & 65535) * (b | 0) | 0;
  };
}
if (typeof ArrayBuffer.isView === 'undefined') {
  ArrayBuffer.isView = function (a) {
    return a != null && a.__proto__ != null && a.__proto__.__proto__ === Int8Array.prototype.__proto__;
  };
}
if (typeof Array.prototype.fill === 'undefined') {
  // Polyfill from https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/fill#Polyfill
  Object.defineProperty(Array.prototype, 'fill', {value: function (value) {
    // Steps 1-2.
    if (this == null) {
      throw new TypeError('this is null or not defined');
    }
    var O = Object(this); // Steps 3-5.
    var len = O.length >>> 0; // Steps 6-7.
    var start = arguments[1];
    var relativeStart = start >> 0; // Step 8.
    var k = relativeStart < 0 ? Math.max(len + relativeStart, 0) : Math.min(relativeStart, len); // Steps 9-10.
    var end = arguments[2];
    var relativeEnd = end === undefined ? len : end >> 0; // Step 11.
    var finalValue = relativeEnd < 0 ? Math.max(len + relativeEnd, 0) : Math.min(relativeEnd, len); // Step 12.
    while (k < finalValue) {
      O[k] = value;
      k++;
    }
    ; // Step 13.
    return O;
  }});
}
[Int8Array, Int16Array, Uint16Array, Int32Array, Float32Array, Float64Array].forEach(function (TypedArray) {
  if (typeof TypedArray.prototype.fill === 'undefined') {
    Object.defineProperty(TypedArray.prototype, 'fill', {value: Array.prototype.fill});
  }
});
if (typeof Math.clz32 === 'undefined') {
  Math.clz32 = function (log, LN2) {
    return function (x) {
      var asUint = x >>> 0;
      if (asUint === 0) {
        return 32;
      }
      return 31 - (log(asUint) / LN2 | 0) | 0; // the "| 0" acts like math.floor
    };
  }(Math.log, Math.LN2);
}
if (typeof Math.sign === 'undefined') {
  Math.sign = function (x) {
    x = +x; // convert to a number
    if (x === 0 || isNaN(x)) {
      return Number(x);
    }
    return x > 0 ? 1 : -1;
  };
}
if (typeof Math.log10 === 'undefined') {
  Math.log10 = function (x) {
    return Math.log(x) * Math.LOG10E;
  };
}
if (typeof Math.trunc === 'undefined') {
  Math.trunc = function (x) {
    if (isNaN(x)) {
      return NaN;
    }
    if (x > 0) {
      return Math.floor(x);
    }
    return Math.ceil(x);
  };
}
if (typeof String.prototype.endsWith === 'undefined') {
  Object.defineProperty(String.prototype, 'endsWith', {value: function (searchString, position) {
    var subjectString = this.toString();
    if (position === undefined || position > subjectString.length) {
      position = subjectString.length;
    }
    position -= searchString.length;
    var lastIndex = subjectString.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
  }});
}
if (typeof String.prototype.startsWith === 'undefined') {
  Object.defineProperty(String.prototype, 'startsWith', {value: function (searchString, position) {
    position = position || 0;
    return this.lastIndexOf(searchString, position) === position;
  }});
}
//endregion
(function (factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports'], factory);
  else if (typeof exports === 'object')
    factory(module.exports);
  else
    globalThis['org.jetbrains.biokb:editor-adapters'] = factory(typeof globalThis['org.jetbrains.biokb:editor-adapters'] === 'undefined' ? {} : globalThis['org.jetbrains.biokb:editor-adapters']);
}(function (_) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var trunc = Math.trunc;
  var isView = ArrayBuffer.isView;
  var clz32 = Math.clz32;
  var sign = Math.sign;
  var log10 = Math.log10;
  //endregion
  //region block: pre-declaration
  initMetadataForInterface(CharSequence, 'CharSequence');
  initMetadataForInterface(Comparable, 'Comparable');
  initMetadataForClass(Error_0, 'Error', Error_init_$Create$, Error);
  initMetadataForClass(IrLinkageError, 'IrLinkageError', VOID, Error_0);
  initMetadataForInterface(Sequence, 'Sequence');
  initMetadataForClass(asSequence$$inlined$Sequence$1, VOID, VOID, VOID, [Sequence]);
  initMetadataForClass(asSequence$$inlined$Sequence$1_0, VOID, VOID, VOID, [Sequence]);
  initMetadataForClass(asIterable$$inlined$Iterable$1);
  initMetadataForClass(Exception, 'Exception', Exception_init_$Create$, Error);
  initMetadataForClass(RuntimeException, 'RuntimeException', RuntimeException_init_$Create$, Exception);
  initMetadataForClass(KotlinNothingValueException, 'KotlinNothingValueException', KotlinNothingValueException_init_$Create$, RuntimeException);
  initMetadataForCompanion(Companion);
  initMetadataForClass(Char, 'Char', VOID, VOID, [Comparable]);
  initMetadataForCompanion(Companion_0);
  initMetadataForInterface(Collection, 'Collection');
  function asJsReadonlyArrayView() {
    return createJsReadonlyArrayViewFrom(this);
  }
  initMetadataForInterface(KtList, 'List', VOID, VOID, [Collection]);
  initMetadataForInterface(MutableIterable, 'MutableIterable');
  initMetadataForInterface(MutableCollection, 'MutableCollection', VOID, VOID, [Collection, MutableIterable]);
  initMetadataForInterface(KtMutableList, 'MutableList', VOID, VOID, [KtList, MutableCollection]);
  initMetadataForInterface(KtSet, 'Set', VOID, VOID, [Collection]);
  initMetadataForInterface(KtMutableSet, 'MutableSet', VOID, VOID, [KtSet, MutableCollection]);
  initMetadataForInterface(Entry, 'Entry');
  initMetadataForInterface(KtMap, 'Map');
  initMetadataForInterface(MutableEntry, 'MutableEntry', VOID, VOID, [Entry]);
  initMetadataForInterface(KtMutableMap, 'MutableMap', VOID, VOID, [KtMap]);
  initMetadataForCompanion(Companion_1);
  initMetadataForClass(Enum, 'Enum', VOID, VOID, [Comparable]);
  initMetadataForCompanion(Companion_2);
  initMetadataForInterface(FunctionAdapter, 'FunctionAdapter');
  initMetadataForClass(arrayIterator$1);
  initMetadataForClass(JsArrayView, 'JsArrayView', JsArrayView, Array);
  initMetadataForObject(ByteCompanionObject, 'ByteCompanionObject');
  initMetadataForObject(ShortCompanionObject, 'ShortCompanionObject');
  initMetadataForObject(IntCompanionObject, 'IntCompanionObject');
  initMetadataForObject(FloatCompanionObject, 'FloatCompanionObject');
  initMetadataForObject(DoubleCompanionObject, 'DoubleCompanionObject');
  initMetadataForObject(StringCompanionObject, 'StringCompanionObject');
  initMetadataForObject(BooleanCompanionObject, 'BooleanCompanionObject');
  initMetadataForObject(Digit, 'Digit');
  initMetadataForObject(Letter, 'Letter');
  initMetadataForObject(OtherLowercase, 'OtherLowercase');
  initMetadataForClass(AbstractCollection, 'AbstractCollection', VOID, VOID, [Collection]);
  initMetadataForClass(AbstractList, 'AbstractList', VOID, AbstractCollection, [AbstractCollection, KtList]);
  initMetadataForInterface(RandomAccess, 'RandomAccess');
  initMetadataForClass(asList$1, VOID, VOID, AbstractList, [AbstractList, RandomAccess]);
  initMetadataForInterface(Comparator, 'Comparator');
  initMetadataForObject(Unit, 'Unit');
  initMetadataForClass(AbstractMutableCollection, 'AbstractMutableCollection', VOID, AbstractCollection, [AbstractCollection, MutableCollection]);
  initMetadataForClass(IteratorImpl, 'IteratorImpl');
  initMetadataForClass(ListIteratorImpl, 'ListIteratorImpl', VOID, IteratorImpl);
  initMetadataForClass(AbstractMutableList, 'AbstractMutableList', VOID, AbstractMutableCollection, [AbstractMutableCollection, KtMutableList]);
  initMetadataForClass(SubList, 'SubList', VOID, AbstractMutableList, [AbstractMutableList, RandomAccess]);
  initMetadataForClass(AbstractMap, 'AbstractMap', VOID, VOID, [KtMap]);
  initMetadataForClass(AbstractMutableMap, 'AbstractMutableMap', VOID, AbstractMap, [AbstractMap, KtMutableMap]);
  initMetadataForClass(AbstractMutableSet, 'AbstractMutableSet', VOID, AbstractMutableCollection, [AbstractMutableCollection, KtMutableSet]);
  initMetadataForCompanion(Companion_3);
  initMetadataForClass(ArrayList, 'ArrayList', ArrayList_init_$Create$, AbstractMutableList, [AbstractMutableList, KtMutableList, RandomAccess]);
  initMetadataForClass(HashMap, 'HashMap', HashMap_init_$Create$, AbstractMutableMap, [AbstractMutableMap, KtMutableMap]);
  initMetadataForClass(HashMapKeys, 'HashMapKeys', VOID, AbstractMutableSet, [KtMutableSet, AbstractMutableSet]);
  initMetadataForClass(HashMapValues, 'HashMapValues', VOID, AbstractMutableCollection, [MutableCollection, AbstractMutableCollection]);
  initMetadataForClass(HashMapEntrySetBase, 'HashMapEntrySetBase', VOID, AbstractMutableSet, [KtMutableSet, AbstractMutableSet]);
  initMetadataForClass(HashMapEntrySet, 'HashMapEntrySet', VOID, HashMapEntrySetBase);
  initMetadataForClass(HashMapKeysDefault$iterator$1);
  initMetadataForClass(HashMapKeysDefault, 'HashMapKeysDefault', VOID, AbstractMutableSet);
  initMetadataForClass(HashMapValuesDefault$iterator$1);
  initMetadataForClass(HashMapValuesDefault, 'HashMapValuesDefault', VOID, AbstractMutableCollection);
  initMetadataForClass(HashSet, 'HashSet', HashSet_init_$Create$, AbstractMutableSet, [AbstractMutableSet, KtMutableSet]);
  initMetadataForCompanion(Companion_4);
  initMetadataForClass(Itr, 'Itr');
  initMetadataForClass(KeysItr, 'KeysItr', VOID, Itr);
  initMetadataForClass(ValuesItr, 'ValuesItr', VOID, Itr);
  initMetadataForClass(EntriesItr, 'EntriesItr', VOID, Itr);
  initMetadataForClass(EntryRef, 'EntryRef', VOID, VOID, [MutableEntry]);
  function containsAllEntries(m) {
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var tmp;
      if (isInterface(m, Collection)) {
        tmp = m.s();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
      var _iterator__ex2g4s = m.m();
      while (_iterator__ex2g4s.n()) {
        var element = _iterator__ex2g4s.o();
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var entry = element;
        var tmp_0;
        if (!(entry == null) ? isInterface(entry, Entry) : false) {
          tmp_0 = this.m8(entry);
        } else {
          tmp_0 = false;
        }
        if (!tmp_0) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
      }
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  }
  initMetadataForInterface(InternalMap, 'InternalMap');
  initMetadataForClass(InternalHashMap, 'InternalHashMap', InternalHashMap_init_$Create$, VOID, [InternalMap]);
  initMetadataForObject(EmptyHolder, 'EmptyHolder');
  initMetadataForClass(LinkedHashMap, 'LinkedHashMap', LinkedHashMap_init_$Create$, HashMap, [HashMap, KtMutableMap]);
  initMetadataForObject(EmptyHolder_0, 'EmptyHolder');
  initMetadataForClass(LinkedHashSet, 'LinkedHashSet', LinkedHashSet_init_$Create$, HashSet, [HashSet, KtMutableSet]);
  initMetadataForClass(BaseOutput, 'BaseOutput');
  initMetadataForClass(NodeJsOutput, 'NodeJsOutput', VOID, BaseOutput);
  initMetadataForClass(BufferedOutput, 'BufferedOutput', BufferedOutput, BaseOutput);
  initMetadataForClass(BufferedOutputToConsoleLog, 'BufferedOutputToConsoleLog', BufferedOutputToConsoleLog, BufferedOutput);
  initMetadataForInterface(Continuation, 'Continuation');
  initMetadataForClass(InterceptedCoroutine, 'InterceptedCoroutine', VOID, VOID, [Continuation]);
  initMetadataForClass(CoroutineImpl, 'CoroutineImpl', VOID, InterceptedCoroutine, [InterceptedCoroutine, Continuation]);
  initMetadataForObject(CompletedContinuation, 'CompletedContinuation', VOID, VOID, [Continuation]);
  initMetadataForClass(IllegalStateException, 'IllegalStateException', IllegalStateException_init_$Create$, RuntimeException);
  initMetadataForClass(CancellationException, 'CancellationException', CancellationException_init_$Create$, IllegalStateException);
  initMetadataForClass(createCoroutineUnintercepted$$inlined$createCoroutineFromSuspendFunction$1, VOID, VOID, CoroutineImpl);
  initMetadataForClass(createSimpleCoroutineForSuspendFunction$1, VOID, VOID, CoroutineImpl);
  initMetadataForClass(IllegalArgumentException, 'IllegalArgumentException', IllegalArgumentException_init_$Create$, RuntimeException);
  initMetadataForClass(UnsupportedOperationException, 'UnsupportedOperationException', UnsupportedOperationException_init_$Create$, RuntimeException);
  initMetadataForClass(NoSuchElementException, 'NoSuchElementException', NoSuchElementException_init_$Create$, RuntimeException);
  initMetadataForClass(IndexOutOfBoundsException, 'IndexOutOfBoundsException', IndexOutOfBoundsException_init_$Create$, RuntimeException);
  initMetadataForClass(NullPointerException, 'NullPointerException', NullPointerException_init_$Create$, RuntimeException);
  initMetadataForClass(AssertionError, 'AssertionError', AssertionError_init_$Create$, Error_0);
  initMetadataForClass(ArithmeticException, 'ArithmeticException', ArithmeticException_init_$Create$, RuntimeException);
  initMetadataForClass(NumberFormatException, 'NumberFormatException', NumberFormatException_init_$Create$, IllegalArgumentException);
  initMetadataForClass(ConcurrentModificationException, 'ConcurrentModificationException', ConcurrentModificationException_init_$Create$, RuntimeException);
  initMetadataForClass(ClassCastException, 'ClassCastException', ClassCastException_init_$Create$, RuntimeException);
  initMetadataForClass(NoWhenBranchMatchedException, 'NoWhenBranchMatchedException', NoWhenBranchMatchedException_init_$Create$, RuntimeException);
  initMetadataForClass(UninitializedPropertyAccessException, 'UninitializedPropertyAccessException', UninitializedPropertyAccessException_init_$Create$, RuntimeException);
  initMetadataForInterface(KClass, 'KClass');
  initMetadataForClass(KClassImpl, 'KClassImpl', VOID, VOID, [KClass]);
  initMetadataForObject(NothingKClassImpl, 'NothingKClassImpl', VOID, KClassImpl);
  initMetadataForClass(PrimitiveKClassImpl, 'PrimitiveKClassImpl', VOID, KClassImpl);
  initMetadataForClass(SimpleKClassImpl, 'SimpleKClassImpl', VOID, KClassImpl);
  initMetadataForInterface(KProperty0, 'KProperty0');
  initMetadataForInterface(KProperty1, 'KProperty1');
  initMetadataForInterface(KMutableProperty0, 'KMutableProperty0', VOID, VOID, [KProperty0]);
  initMetadataForClass(KTypeImpl, 'KTypeImpl');
  initMetadataForObject(PrimitiveClasses, 'PrimitiveClasses');
  initMetadataForClass(ConstrainedOnceSequence, 'ConstrainedOnceSequence', VOID, VOID, [Sequence]);
  initMetadataForClass(CharacterCodingException, 'CharacterCodingException', CharacterCodingException_init_$Create$, Exception);
  initMetadataForClass(StringBuilder, 'StringBuilder', StringBuilder_init_$Create$_1, VOID, [CharSequence]);
  initMetadataForCompanion(Companion_5);
  initMetadataForClass(Regex, 'Regex');
  initMetadataForClass(MatchGroup, 'MatchGroup');
  initMetadataForInterface(MatchNamedGroupCollection, 'MatchNamedGroupCollection', VOID, VOID, [Collection]);
  initMetadataForClass(findNext$1$groups$1, VOID, VOID, AbstractCollection, [MatchNamedGroupCollection, AbstractCollection]);
  initMetadataForClass(findNext$1);
  initMetadataForClass(sam$kotlin_Comparator$0, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
  initMetadataForClass(ExceptionTraceBuilder, 'ExceptionTraceBuilder', ExceptionTraceBuilder);
  initMetadataForClass(DurationUnit, 'DurationUnit', VOID, Enum);
  initMetadataForObject(MonotonicTimeSource, 'MonotonicTimeSource');
  initMetadataForClass(Reading, 'Reading');
  initMetadataForClass(HrTimeSource, 'HrTimeSource');
  initMetadataForClass(PerformanceTimeSource, 'PerformanceTimeSource');
  initMetadataForObject(DateNowTimeSource, 'DateNowTimeSource');
  initMetadataForClass(SubList_0, 'SubList', VOID, AbstractList, [AbstractList, RandomAccess]);
  initMetadataForClass(IteratorImpl_0, 'IteratorImpl');
  initMetadataForClass(ListIteratorImpl_0, 'ListIteratorImpl', VOID, IteratorImpl_0);
  initMetadataForCompanion(Companion_6);
  initMetadataForClass(AbstractMap$keys$1$iterator$1);
  initMetadataForClass(AbstractMap$values$1$iterator$1);
  initMetadataForCompanion(Companion_7);
  initMetadataForClass(AbstractSet, 'AbstractSet', VOID, AbstractCollection, [AbstractCollection, KtSet]);
  initMetadataForClass(AbstractMap$keys$1, VOID, VOID, AbstractSet);
  initMetadataForClass(AbstractMap$values$1, VOID, VOID, AbstractCollection);
  initMetadataForCompanion(Companion_8);
  initMetadataForCompanion(Companion_9);
  initMetadataForClass(ArrayDeque, 'ArrayDeque', ArrayDeque_init_$Create$, AbstractMutableList);
  initMetadataForObject(EmptyList, 'EmptyList', VOID, VOID, [KtList, RandomAccess]);
  initMetadataForObject(EmptyIterator, 'EmptyIterator');
  initMetadataForClass(ArrayAsCollection, 'ArrayAsCollection', VOID, VOID, [Collection]);
  initMetadataForClass(IndexedValue, 'IndexedValue');
  initMetadataForClass(IndexingIterable, 'IndexingIterable');
  initMetadataForClass(IndexingIterator, 'IndexingIterator');
  initMetadataForInterface(MapWithDefault, 'MapWithDefault', VOID, VOID, [KtMap]);
  initMetadataForObject(EmptyMap, 'EmptyMap', VOID, VOID, [KtMap]);
  initMetadataForClass(IntIterator, 'IntIterator');
  initMetadataForClass(CharIterator, 'CharIterator');
  initMetadataForClass(ReversedList$listIterator$1);
  initMetadataForClass(ReversedList, 'ReversedList', VOID, AbstractMutableList);
  initMetadataForClass(ReversedListReadOnly$listIterator$1);
  initMetadataForClass(ReversedListReadOnly, 'ReversedListReadOnly', VOID, AbstractList);
  initMetadataForClass(SequenceScope, 'SequenceScope', VOID, VOID, VOID, [1]);
  initMetadataForClass(SequenceBuilderIterator, 'SequenceBuilderIterator', SequenceBuilderIterator, SequenceScope, [SequenceScope, Continuation], [1]);
  initMetadataForClass(sequence$$inlined$Sequence$1, VOID, VOID, VOID, [Sequence]);
  initMetadataForClass(FlatteningSequence$iterator$1);
  initMetadataForClass(FlatteningSequence, 'FlatteningSequence', VOID, VOID, [Sequence]);
  initMetadataForClass(TransformingSequence$iterator$1);
  initMetadataForClass(TransformingSequence, 'TransformingSequence', VOID, VOID, [Sequence]);
  initMetadataForClass(FilteringSequence$iterator$1);
  initMetadataForClass(FilteringSequence, 'FilteringSequence', VOID, VOID, [Sequence]);
  initMetadataForInterface(DropTakeSequence, 'DropTakeSequence', VOID, VOID, [Sequence]);
  initMetadataForClass(TakeSequence$iterator$1);
  initMetadataForClass(TakeSequence, 'TakeSequence', VOID, VOID, [Sequence, DropTakeSequence]);
  initMetadataForObject(EmptySequence, 'EmptySequence', VOID, VOID, [Sequence, DropTakeSequence]);
  initMetadataForClass(GeneratorSequence$iterator$1);
  initMetadataForClass(GeneratorSequence, 'GeneratorSequence', VOID, VOID, [Sequence]);
  initMetadataForClass(asSequence$$inlined$Sequence$1_1, VOID, VOID, VOID, [Sequence]);
  initMetadataForObject(EmptySet, 'EmptySet', VOID, VOID, [KtSet]);
  initMetadataForObject(Key, 'Key');
  function plus(context) {
    var tmp;
    if (context === EmptyCoroutineContext_instance) {
      tmp = this;
    } else {
      tmp = context.vi(this, CoroutineContext$plus$lambda);
    }
    return tmp;
  }
  initMetadataForInterface(CoroutineContext, 'CoroutineContext');
  function get(key) {
    var tmp;
    if (equals(this.z(), key)) {
      tmp = isInterface(this, Element_0) ? this : THROW_CCE();
    } else {
      tmp = null;
    }
    return tmp;
  }
  function fold(initial, operation) {
    return operation(initial, this);
  }
  function minusKey(key) {
    return equals(this.z(), key) ? EmptyCoroutineContext_instance : this;
  }
  initMetadataForInterface(Element_0, 'Element', VOID, VOID, [CoroutineContext]);
  function releaseInterceptedContinuation(continuation) {
  }
  function get_0(key) {
    if (key instanceof AbstractCoroutineContextKey) {
      var tmp;
      if (key.ti(this.z())) {
        var tmp_0 = key.si(this);
        tmp = (!(tmp_0 == null) ? isInterface(tmp_0, Element_0) : false) ? tmp_0 : null;
      } else {
        tmp = null;
      }
      return tmp;
    }
    var tmp_1;
    if (Key_instance === key) {
      tmp_1 = isInterface(this, Element_0) ? this : THROW_CCE();
    } else {
      tmp_1 = null;
    }
    return tmp_1;
  }
  function minusKey_0(key) {
    if (key instanceof AbstractCoroutineContextKey) {
      return key.ti(this.z()) && !(key.si(this) == null) ? EmptyCoroutineContext_instance : this;
    }
    return Key_instance === key ? EmptyCoroutineContext_instance : this;
  }
  initMetadataForInterface(ContinuationInterceptor, 'ContinuationInterceptor', VOID, VOID, [Element_0]);
  initMetadataForObject(EmptyCoroutineContext, 'EmptyCoroutineContext', VOID, VOID, [CoroutineContext]);
  initMetadataForClass(CombinedContext, 'CombinedContext', VOID, VOID, [CoroutineContext]);
  initMetadataForClass(AbstractCoroutineContextKey, 'AbstractCoroutineContextKey');
  initMetadataForClass(AbstractCoroutineContextElement, 'AbstractCoroutineContextElement', VOID, VOID, [Element_0]);
  initMetadataForClass(CoroutineSingletons, 'CoroutineSingletons', VOID, Enum);
  initMetadataForClass(EnumEntriesList, 'EnumEntriesList', VOID, AbstractList, [KtList, AbstractList]);
  initMetadataForClass(Random, 'Random');
  initMetadataForObject(Default, 'Default', VOID, Random);
  initMetadataForCompanion(Companion_10);
  initMetadataForClass(XorWowRandom, 'XorWowRandom', VOID, Random);
  initMetadataForCompanion(Companion_11);
  initMetadataForClass(IntProgression, 'IntProgression');
  initMetadataForClass(IntRange, 'IntRange', VOID, IntProgression);
  initMetadataForCompanion(Companion_12);
  initMetadataForClass(CharProgression, 'CharProgression');
  initMetadataForClass(CharRange, 'CharRange', VOID, CharProgression);
  initMetadataForClass(IntProgressionIterator, 'IntProgressionIterator', VOID, IntIterator);
  initMetadataForClass(CharProgressionIterator, 'CharProgressionIterator', VOID, CharIterator);
  initMetadataForCompanion(Companion_13);
  initMetadataForCompanion(Companion_14);
  initMetadataForInterface(KTypeParameter, 'KTypeParameter');
  initMetadataForCompanion(Companion_15);
  initMetadataForClass(KTypeProjection, 'KTypeProjection');
  initMetadataForClass(KVariance, 'KVariance', VOID, Enum);
  initMetadataForObject(State, 'State');
  initMetadataForClass(LinesIterator, 'LinesIterator');
  initMetadataForClass(DelimitedRangesSequence$iterator$1);
  initMetadataForClass(DelimitedRangesSequence, 'DelimitedRangesSequence', VOID, VOID, [Sequence]);
  initMetadataForClass(lineSequence$$inlined$Sequence$1, VOID, VOID, VOID, [Sequence]);
  initMetadataForCompanion(Companion_16);
  initMetadataForClass(Duration, 'Duration', VOID, VOID, [Comparable]);
  function compareTo(other) {
    return Duration__compareTo_impl_pchp0f(this.fl(other), Companion_getInstance_16().qe_1);
  }
  initMetadataForInterface(ComparableTimeMark, 'ComparableTimeMark', VOID, VOID, [Comparable]);
  initMetadataForClass(ValueTimeMark, 'ValueTimeMark', VOID, VOID, [ComparableTimeMark]);
  initMetadataForObject(Monotonic, 'Monotonic');
  initMetadataForClass(TimedValue, 'TimedValue');
  initMetadataForClass(DeepRecursiveScope, 'DeepRecursiveScope', VOID, VOID, VOID, [1, 2]);
  initMetadataForClass(DeepRecursiveFunction, 'DeepRecursiveFunction');
  initMetadataForClass(DeepRecursiveScopeImpl, 'DeepRecursiveScopeImpl', VOID, DeepRecursiveScope, [DeepRecursiveScope, Continuation], [1, 2]);
  initMetadataForClass(LazyThreadSafetyMode, 'LazyThreadSafetyMode', VOID, Enum);
  initMetadataForClass(UnsafeLazyImpl, 'UnsafeLazyImpl');
  initMetadataForObject(UNINITIALIZED_VALUE, 'UNINITIALIZED_VALUE');
  initMetadataForCompanion(Companion_17);
  initMetadataForClass(Failure, 'Failure');
  initMetadataForClass(Result, 'Result');
  initMetadataForClass(NotImplementedError, 'NotImplementedError', NotImplementedError, Error_0);
  initMetadataForClass(Pair, 'Pair');
  initMetadataForClass(Triple, 'Triple');
  initMetadataForCompanion(Companion_18);
  initMetadataForClass(UByte, 'UByte', VOID, VOID, [Comparable]);
  initMetadataForClass(Iterator, 'Iterator');
  initMetadataForClass(UByteArray, 'UByteArray', VOID, VOID, [Collection]);
  initMetadataForCompanion(Companion_19);
  initMetadataForClass(UInt, 'UInt', VOID, VOID, [Comparable]);
  initMetadataForClass(Iterator_0, 'Iterator');
  initMetadataForClass(UIntArray, 'UIntArray', VOID, VOID, [Collection]);
  initMetadataForCompanion(Companion_20);
  initMetadataForClass(ULong, 'ULong', VOID, VOID, [Comparable]);
  initMetadataForClass(Iterator_1, 'Iterator');
  initMetadataForClass(ULongArray, 'ULongArray', VOID, VOID, [Collection]);
  initMetadataForCompanion(Companion_21);
  initMetadataForClass(UShort, 'UShort', VOID, VOID, [Comparable]);
  initMetadataForClass(Iterator_2, 'Iterator');
  initMetadataForClass(UShortArray, 'UShortArray', VOID, VOID, [Collection]);
  initMetadataForClass(atomicfu$AtomicRefArray$ref, 'AtomicArray');
  initMetadataForClass(atomicfu$TraceBase, 'TraceBase');
  initMetadataForObject(None, 'None', VOID, atomicfu$TraceBase);
  initMetadataForClass(AtomicBoolean, 'AtomicBoolean');
  initMetadataForClass(AtomicRef, 'AtomicRef');
  initMetadataForClass(AtomicInt, 'AtomicInt');
  initMetadataForClass(AtomicLong, 'AtomicLong');
  function cancel$default(cause, $super) {
    cause = cause === VOID ? null : cause;
    var tmp;
    if ($super === VOID) {
      this.rp(cause);
      tmp = Unit_instance;
    } else {
      tmp = $super.rp.call(this, cause);
    }
    return tmp;
  }
  function invokeOnCompletion$default(onCancelling, invokeImmediately, handler, $super) {
    onCancelling = onCancelling === VOID ? false : onCancelling;
    invokeImmediately = invokeImmediately === VOID ? true : invokeImmediately;
    return $super === VOID ? this.lp(onCancelling, invokeImmediately, handler) : $super.lp.call(this, onCancelling, invokeImmediately, handler);
  }
  initMetadataForInterface(Job, 'Job', VOID, VOID, [Element_0], [0]);
  initMetadataForInterface(ParentJob, 'ParentJob', VOID, VOID, [Job], [0]);
  initMetadataForClass(JobSupport, 'JobSupport', VOID, VOID, [Job, ParentJob], [0]);
  initMetadataForInterface(CoroutineScope, 'CoroutineScope');
  initMetadataForClass(AbstractCoroutine, 'AbstractCoroutine', VOID, JobSupport, [JobSupport, Job, Continuation, CoroutineScope], [0]);
  initMetadataForClass(StandaloneCoroutine, 'StandaloneCoroutine', VOID, AbstractCoroutine, VOID, [0]);
  initMetadataForClass(LazyStandaloneCoroutine, 'LazyStandaloneCoroutine', VOID, StandaloneCoroutine, VOID, [0]);
  initMetadataForClass(ScopeCoroutine, 'ScopeCoroutine', VOID, AbstractCoroutine, VOID, [0]);
  initMetadataForClass(DispatchedCoroutine, 'DispatchedCoroutine', VOID, ScopeCoroutine, VOID, [0]);
  initMetadataForCoroutine($awaitCOROUTINE$, CoroutineImpl);
  initMetadataForClass(DeferredCoroutine, 'DeferredCoroutine', VOID, AbstractCoroutine, [AbstractCoroutine, Job], [0]);
  initMetadataForClass(LazyDeferredCoroutine, 'LazyDeferredCoroutine', VOID, DeferredCoroutine, VOID, [0]);
  initMetadataForInterface(CancellableContinuation, 'CancellableContinuation', VOID, VOID, [Continuation]);
  initMetadataForClass(CancelHandlerBase, 'CancelHandlerBase');
  initMetadataForInterface(NotCompleted, 'NotCompleted');
  initMetadataForClass(CancelHandler, 'CancelHandler', VOID, CancelHandlerBase, [CancelHandlerBase, NotCompleted]);
  initMetadataForClass(DisposeOnCancel, 'DisposeOnCancel', VOID, CancelHandler);
  initMetadataForInterface(Runnable, 'Runnable');
  initMetadataForClass(SchedulerTask, 'SchedulerTask', VOID, VOID, [Runnable]);
  initMetadataForClass(DispatchedTask, 'DispatchedTask', VOID, SchedulerTask);
  initMetadataForInterface(Waiter, 'Waiter');
  initMetadataForClass(CancellableContinuationImpl, 'CancellableContinuationImpl', VOID, DispatchedTask, [DispatchedTask, CancellableContinuation, Waiter]);
  initMetadataForObject(Active, 'Active', VOID, VOID, [NotCompleted]);
  initMetadataForClass(CompletedContinuation_0, 'CompletedContinuation');
  initMetadataForClass(InvokeOnCancel, 'InvokeOnCancel', VOID, CancelHandler);
  initMetadataForCoroutine($awaitCOROUTINE$_0, CoroutineImpl);
  initMetadataForClass(CompletableDeferredImpl, 'CompletableDeferredImpl', VOID, JobSupport, [JobSupport, Job], [0]);
  initMetadataForInterface(CompletableJob, 'CompletableJob', VOID, VOID, [Job], [0]);
  initMetadataForClass(CompletedExceptionally, 'CompletedExceptionally');
  initMetadataForClass(CancelledContinuation, 'CancelledContinuation', VOID, CompletedExceptionally);
  initMetadataForClass(CompletedWithCancellation, 'CompletedWithCancellation');
  initMetadataForObject(Key_0, 'Key', VOID, AbstractCoroutineContextKey);
  initMetadataForClass(CoroutineDispatcher, 'CoroutineDispatcher', VOID, AbstractCoroutineContextElement, [AbstractCoroutineContextElement, ContinuationInterceptor]);
  initMetadataForObject(Key_1, 'Key');
  initMetadataForObject(Key_2, 'Key');
  initMetadataForClass(CoroutineName, 'CoroutineName', VOID, AbstractCoroutineContextElement);
  initMetadataForObject(GlobalScope, 'GlobalScope', VOID, VOID, [CoroutineScope]);
  initMetadataForClass(CoroutineStart, 'CoroutineStart', VOID, Enum);
  function invokeOnTimeout(timeMillis, block, context) {
    return get_DefaultDelay().ev(timeMillis, block, context);
  }
  initMetadataForInterface(Delay, 'Delay', VOID, VOID, VOID, [1]);
  initMetadataForInterface(DelayWithTimeoutDiagnostics, 'DelayWithTimeoutDiagnostics', VOID, VOID, [Delay], [1]);
  initMetadataForClass(EventLoop, 'EventLoop', VOID, CoroutineDispatcher);
  initMetadataForObject(ThreadLocalEventLoop, 'ThreadLocalEventLoop');
  initMetadataForClass(CompletionHandlerException, 'CompletionHandlerException', VOID, RuntimeException);
  initMetadataForClass(CoroutinesInternalError, 'CoroutinesInternalError', VOID, Error_0);
  initMetadataForObject(Key_3, 'Key');
  initMetadataForInterface(DisposableHandle, 'DisposableHandle');
  initMetadataForInterface(ChildHandle, 'ChildHandle', VOID, VOID, [DisposableHandle]);
  initMetadataForObject(NonDisposableHandle, 'NonDisposableHandle', VOID, VOID, [DisposableHandle, ChildHandle]);
  initMetadataForClass(LinkedListNode, 'LinkedListNode', LinkedListNode, VOID, [DisposableHandle]);
  initMetadataForClass(CompletionHandlerBase, 'CompletionHandlerBase', VOID, LinkedListNode);
  initMetadataForInterface(Incomplete, 'Incomplete');
  initMetadataForClass(JobNode, 'JobNode', VOID, CompletionHandlerBase, [CompletionHandlerBase, DisposableHandle, Incomplete]);
  initMetadataForClass(JobCancellingNode, 'JobCancellingNode', VOID, JobNode);
  initMetadataForClass(ChildContinuation, 'ChildContinuation', VOID, JobCancellingNode);
  initMetadataForClass(SelectOnJoinCompletionHandler, 'SelectOnJoinCompletionHandler', VOID, JobNode);
  initMetadataForClass(Finishing, 'Finishing', VOID, VOID, [Incomplete]);
  initMetadataForClass(ChildCompletion, 'ChildCompletion', VOID, JobNode);
  initMetadataForClass(AwaitContinuation, 'AwaitContinuation', VOID, CancellableContinuationImpl);
  initMetadataForClass(JobImpl, 'JobImpl', VOID, JobSupport, [JobSupport, CompletableJob], [0]);
  initMetadataForClass(Empty, 'Empty', VOID, VOID, [Incomplete]);
  initMetadataForClass(IncompleteStateBox, 'IncompleteStateBox');
  initMetadataForClass(LinkedListHead, 'LinkedListHead', LinkedListHead, LinkedListNode);
  initMetadataForClass(NodeList, 'NodeList', NodeList, LinkedListHead, [LinkedListHead, Incomplete]);
  initMetadataForClass(InactiveNodeList, 'InactiveNodeList', VOID, VOID, [Incomplete]);
  initMetadataForClass(ChildHandleNode, 'ChildHandleNode', VOID, JobCancellingNode, [JobCancellingNode, ChildHandle]);
  initMetadataForClass(InvokeOnCancelling, 'InvokeOnCancelling', VOID, JobCancellingNode);
  initMetadataForClass(InvokeOnCompletion, 'InvokeOnCompletion', VOID, JobNode);
  initMetadataForClass(ResumeOnCompletion, 'ResumeOnCompletion', VOID, JobNode);
  initMetadataForClass(ResumeAwaitOnCompletion, 'ResumeAwaitOnCompletion', VOID, JobNode);
  initMetadataForClass(DisposeOnCompletion, 'DisposeOnCompletion', VOID, JobNode);
  initMetadataForClass(MainCoroutineDispatcher, 'MainCoroutineDispatcher', VOID, CoroutineDispatcher);
  initMetadataForClass(SupervisorJobImpl, 'SupervisorJobImpl', VOID, JobImpl, VOID, [0]);
  initMetadataForClass(TimeoutCancellationException, 'TimeoutCancellationException', VOID, CancellationException);
  initMetadataForClass(TimeoutCoroutine, 'TimeoutCoroutine', VOID, ScopeCoroutine, [ScopeCoroutine, Runnable], [0]);
  initMetadataForCoroutine($withTimeoutOrNullCOROUTINE$, CoroutineImpl);
  initMetadataForObject(Key_4, 'Key');
  initMetadataForClass(YieldContext, 'YieldContext', YieldContext, AbstractCoroutineContextElement);
  initMetadataForObject(Unconfined, 'Unconfined', VOID, CoroutineDispatcher);
  initMetadataForClass(BufferOverflow, 'BufferOverflow', VOID, Enum);
  initMetadataForClass(ConcurrentLinkedListNode, 'ConcurrentLinkedListNode');
  initMetadataForClass(Segment, 'Segment', VOID, ConcurrentLinkedListNode, [ConcurrentLinkedListNode, NotCompleted]);
  initMetadataForClass(ChannelSegment, 'ChannelSegment', VOID, Segment);
  initMetadataForCoroutine($hasNextCOROUTINE$, CoroutineImpl);
  initMetadataForClass(SendBroadcast, 'SendBroadcast', VOID, VOID, [Waiter]);
  initMetadataForClass(BufferedChannelIterator, 'BufferedChannelIterator', VOID, VOID, [Waiter], [0, 3]);
  initMetadataForCoroutine($sendCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($receiveCOROUTINE$, CoroutineImpl);
  function close$default(cause, $super) {
    cause = cause === VOID ? null : cause;
    return $super === VOID ? this.g16(cause) : $super.g16.call(this, cause);
  }
  initMetadataForInterface(SendChannel, 'SendChannel', VOID, VOID, VOID, [1]);
  function cancel$default_0(cause, $super) {
    cause = cause === VOID ? null : cause;
    var tmp;
    if ($super === VOID) {
      this.rp(cause);
      tmp = Unit_instance;
    } else {
      tmp = $super.rp.call(this, cause);
    }
    return tmp;
  }
  initMetadataForInterface(ReceiveChannel, 'ReceiveChannel', VOID, VOID, VOID, [0]);
  initMetadataForClass(BufferedChannel, 'BufferedChannel', VOID, VOID, [SendChannel, ReceiveChannel], [1, 4, 0, 3]);
  initMetadataForClass(WaiterEB, 'WaiterEB');
  initMetadataForClass(ReceiveCatching, 'ReceiveCatching', VOID, VOID, [Waiter]);
  initMetadataForObject(Factory, 'Factory');
  initMetadataForClass(Failed, 'Failed', Failed);
  initMetadataForClass(Closed, 'Closed', VOID, Failed);
  initMetadataForCompanion(Companion_22);
  initMetadataForClass(ChannelResult, 'ChannelResult');
  initMetadataForClass(ClosedSendChannelException, 'ClosedSendChannelException', VOID, IllegalStateException);
  initMetadataForClass(ClosedReceiveChannelException, 'ClosedReceiveChannelException', VOID, NoSuchElementException);
  initMetadataForClass(ChannelCoroutine, 'ChannelCoroutine', VOID, AbstractCoroutine, [AbstractCoroutine, SendChannel, ReceiveChannel], [0, 1]);
  initMetadataForClass(ConflatedBufferedChannel, 'ConflatedBufferedChannel', VOID, BufferedChannel, VOID, [1, 0]);
  initMetadataForInterface(ProducerScope, 'ProducerScope', VOID, VOID, [CoroutineScope, SendChannel], [1]);
  initMetadataForClass(ProducerCoroutine, 'ProducerCoroutine', VOID, ChannelCoroutine, [ChannelCoroutine, ProducerScope], [0, 1]);
  initMetadataForInterface(Flow, 'Flow', VOID, VOID, VOID, [1]);
  function fuse$default(context, capacity, onBufferOverflow, $super) {
    context = context === VOID ? EmptyCoroutineContext_instance : context;
    capacity = capacity === VOID ? -3 : capacity;
    onBufferOverflow = onBufferOverflow === VOID ? BufferOverflow_SUSPEND_getInstance() : onBufferOverflow;
    return $super === VOID ? this.c18(context, capacity, onBufferOverflow) : $super.c18.call(this, context, capacity, onBufferOverflow);
  }
  initMetadataForInterface(FusibleFlow, 'FusibleFlow', VOID, VOID, [Flow], [1]);
  initMetadataForClass(ChannelFlow, 'ChannelFlow', VOID, VOID, [FusibleFlow], [1]);
  initMetadataForClass(ChannelFlowBuilder, 'ChannelFlowBuilder', VOID, ChannelFlow, VOID, [1]);
  initMetadataForInterface(CancellableFlow, 'CancellableFlow', VOID, VOID, [Flow], [1]);
  initMetadataForClass(AbstractFlow, 'AbstractFlow', VOID, VOID, [Flow, CancellableFlow], [1]);
  initMetadataForClass(SafeFlow, 'SafeFlow', VOID, AbstractFlow, VOID, [1]);
  initMetadataForObject(EmptyFlow, 'EmptyFlow', VOID, VOID, [Flow], [1]);
  initMetadataForCoroutine($collectCOROUTINE$, CoroutineImpl);
  initMetadataForClass(asFlow$$inlined$unsafeFlow$1, VOID, VOID, VOID, [Flow], [1]);
  initMetadataForCoroutine($collectCOROUTINE$_0, CoroutineImpl);
  initMetadataForClass(asFlow$$inlined$unsafeFlow$2, VOID, VOID, VOID, [Flow], [1]);
  initMetadataForCoroutine($collectCOROUTINE$_1, CoroutineImpl);
  initMetadataForClass(flowOf$$inlined$unsafeFlow$1, VOID, VOID, VOID, [Flow], [1]);
  initMetadataForCoroutine($collectCOROUTINE$_2, CoroutineImpl);
  initMetadataForClass(ChannelAsFlow, 'ChannelAsFlow', VOID, ChannelFlow, VOID, [1]);
  initMetadataForCoroutine($emitAllImplCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($collectCOROUTINE$_3, CoroutineImpl);
  initMetadataForInterface(FlowCollector, 'FlowCollector', VOID, VOID, VOID, [1]);
  initMetadataForClass(Emitter, 'Emitter', VOID, VOID, [DisposableHandle]);
  initMetadataForCoroutine($collectCOROUTINE$_4, CoroutineImpl);
  initMetadataForClass(AbstractSharedFlow, 'AbstractSharedFlow');
  initMetadataForClass(SharedFlowImpl, 'SharedFlowImpl', VOID, AbstractSharedFlow, [AbstractSharedFlow, Flow, FlowCollector, CancellableFlow, FusibleFlow], [1]);
  initMetadataForClass(AbstractSharedFlowSlot, 'AbstractSharedFlowSlot');
  initMetadataForClass(SharedFlowSlot, 'SharedFlowSlot', SharedFlowSlot, AbstractSharedFlowSlot);
  initMetadataForCompanion(Companion_23);
  initMetadataForClass(StartedEagerly, 'StartedEagerly', StartedEagerly);
  initMetadataForLambda(StartedLazily$command$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
  initMetadataForLambda(StartedLazily$command$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(StartedLazily, 'StartedLazily', StartedLazily);
  initMetadataForClass(SharingCommand, 'SharingCommand', VOID, Enum);
  initMetadataForInterface(StateFlow, 'StateFlow', VOID, VOID, [Flow], [1]);
  initMetadataForCoroutine($collectCOROUTINE$_5, CoroutineImpl);
  initMetadataForClass(StateFlowImpl, 'StateFlowImpl', VOID, AbstractSharedFlow, [AbstractSharedFlow, StateFlow, Flow, FlowCollector, CancellableFlow, FusibleFlow], [1]);
  initMetadataForClass(StateFlowSlot, 'StateFlowSlot', StateFlowSlot, AbstractSharedFlowSlot, VOID, [0]);
  initMetadataForClass(SubscriptionCountStateFlow, 'SubscriptionCountStateFlow', VOID, SharedFlowImpl, [StateFlow, SharedFlowImpl], [1]);
  initMetadataForLambda(ChannelFlow$_get_collectToFun_$slambda_j53z2e, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(ChannelFlow$collect$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(ChannelFlowOperator, 'ChannelFlowOperator', VOID, ChannelFlow, VOID, [1, 2]);
  initMetadataForClass(ChannelFlowOperatorImpl, 'ChannelFlowOperatorImpl', VOID, ChannelFlowOperator, VOID, [1]);
  initMetadataForLambda(ChannelFlowOperator$collectWithContextUndispatched$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($collectCOROUTINE$_6, CoroutineImpl);
  initMetadataForLambda(UndispatchedContextCollector$emitRef$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(UndispatchedContextCollector, 'UndispatchedContextCollector', VOID, VOID, [FlowCollector], [1]);
  initMetadataForClass(StackFrameContinuation, 'StackFrameContinuation', VOID, VOID, [Continuation]);
  initMetadataForLambda(ChannelFlowTransformLatest$flowCollect$slambda$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(ChannelFlowTransformLatest$flowCollect$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0_0, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
  initMetadataForLambda(ChannelFlowTransformLatest$flowCollect$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(ChannelFlowTransformLatest, 'ChannelFlowTransformLatest', VOID, ChannelFlowOperator, VOID, [1]);
  initMetadataForObject(NopCollector, 'NopCollector', VOID, VOID, [FlowCollector], [1]);
  initMetadataForClass(SendingCollector, 'SendingCollector', VOID, VOID, [FlowCollector], [1]);
  initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0_1, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
  initMetadataForLambda(CancellableFlowImpl$collect$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(CancellableFlowImpl, 'CancellableFlowImpl', VOID, VOID, [CancellableFlow], [1]);
  initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0_2, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
  initMetadataForLambda(DistinctFlowImpl$collect$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(DistinctFlowImpl, 'DistinctFlowImpl', VOID, VOID, [Flow], [1]);
  initMetadataForClass(ThrowingCollector, 'ThrowingCollector', VOID, VOID, [FlowCollector], [1]);
  initMetadataForCoroutine($collectCOROUTINE$_7, CoroutineImpl);
  initMetadataForClass(onStart$$inlined$unsafeFlow$1, VOID, VOID, VOID, [Flow], [1]);
  initMetadataForCoroutine($collectCOROUTINE$_8, CoroutineImpl);
  initMetadataForClass(onCompletion$$inlined$unsafeFlow$1, VOID, VOID, VOID, [Flow], [1]);
  initMetadataForCoroutine($invokeSafelyCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($emitCOROUTINE$, CoroutineImpl);
  initMetadataForClass(transformWhile$2$$inlined$collectWhile$1, VOID, VOID, VOID, [FlowCollector], [1]);
  initMetadataForLambda(transformWhile$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($emitCOROUTINE$_0, CoroutineImpl);
  initMetadataForClass(takeWhile$$inlined$unsafeFlow$1$collect$2, VOID, VOID, VOID, [FlowCollector], [1]);
  initMetadataForCoroutine($collectCOROUTINE$_9, CoroutineImpl);
  initMetadataForClass(takeWhile$$inlined$unsafeFlow$1, VOID, VOID, VOID, [Flow], [1]);
  initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0_3, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
  initMetadataForLambda(flatMapConcat$o$collect$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($collectCOROUTINE$_10, CoroutineImpl);
  initMetadataForClass(flatMapConcat$$inlined$map$1, VOID, VOID, VOID, [Flow], [1]);
  initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0_4, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
  initMetadataForLambda(flattenConcat$o$collect$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($collectCOROUTINE$_11, CoroutineImpl);
  initMetadataForClass(flattenConcat$$inlined$unsafeFlow$1, VOID, VOID, VOID, [Flow], [1]);
  initMetadataForLambda(mapLatest$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForCoroutine($onSubscriptionCOROUTINE$, CoroutineImpl);
  initMetadataForClass(SubscribedFlowCollector, 'SubscribedFlowCollector', VOID, VOID, [FlowCollector], [1, 0]);
  initMetadataForClass(SharingConfig, 'SharingConfig');
  initMetadataForCoroutine($collectCOROUTINE$_12, CoroutineImpl);
  initMetadataForClass(ReadonlySharedFlow, 'ReadonlySharedFlow', VOID, VOID, [Flow, CancellableFlow, FusibleFlow], [1]);
  initMetadataForCoroutine($collectCOROUTINE$_13, CoroutineImpl);
  initMetadataForClass(ReadonlyStateFlow, 'ReadonlyStateFlow', VOID, VOID, [StateFlow, CancellableFlow, FusibleFlow], [1]);
  initMetadataForLambda(launchSharing$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(launchSharing$slambda$slambda_1, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(launchSharing$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0_5, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
  initMetadataForLambda(launchSharingDeferred$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(launchSharingDeferred$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0_6, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
  initMetadataForLambda(toCollection$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($toCollectionCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($emitCOROUTINE$_1, CoroutineImpl);
  initMetadataForClass(first$$inlined$collectWhile$1, VOID, VOID, VOID, [FlowCollector], [1]);
  initMetadataForClass(firstOrNull$$inlined$collectWhile$1, VOID, VOID, VOID, [FlowCollector], [1]);
  initMetadataForCoroutine($emitCOROUTINE$_2, CoroutineImpl);
  initMetadataForClass(firstOrNull$$inlined$collectWhile$2, VOID, VOID, VOID, [FlowCollector], [1]);
  initMetadataForCoroutine($firstCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($firstOrNullCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($firstOrNullCOROUTINE$_0, CoroutineImpl);
  initMetadataForClass(OpDescriptor, 'OpDescriptor');
  initMetadataForClass(SegmentOrClosed, 'SegmentOrClosed');
  initMetadataForObject(ExceptionSuccessfullyProcessed, 'ExceptionSuccessfullyProcessed', VOID, Exception);
  initMetadataForClass(DispatchedContinuation, 'DispatchedContinuation', VOID, DispatchedTask, [DispatchedTask, Continuation]);
  initMetadataForClass(UndeliveredElementException, 'UndeliveredElementException', VOID, RuntimeException);
  initMetadataForClass(ContextScope, 'ContextScope', VOID, VOID, [CoroutineScope]);
  initMetadataForClass(Symbol_0, 'Symbol');
  initMetadataForClass(SelectClause0Impl, 'SelectClause0Impl');
  initMetadataForInterface(SelectInstance, 'SelectInstance');
  initMetadataForCoroutine($invokeBlockCOROUTINE$, CoroutineImpl);
  initMetadataForClass(ClauseData, 'ClauseData', VOID, VOID, VOID, [1]);
  initMetadataForCoroutine($doSelectCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($doSelectSuspendCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($completeCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($processResultAndInvokeBlockRecoveringExceptionCOROUTINE$, CoroutineImpl);
  initMetadataForClass(SelectImplementation, 'SelectImplementation', VOID, CancelHandler, [CancelHandler, SelectInstance, Waiter], [0, 2]);
  initMetadataForClass(TrySelectDetailedResult, 'TrySelectDetailedResult', VOID, Enum);
  initMetadataForClass(UndispatchedCoroutine, 'UndispatchedCoroutine', VOID, ScopeCoroutine, VOID, [0]);
  initMetadataForObject(Dispatchers, 'Dispatchers');
  initMetadataForClass(JsMainDispatcher, 'JsMainDispatcher', VOID, MainCoroutineDispatcher);
  initMetadataForClass(UnconfinedEventLoop, 'UnconfinedEventLoop', UnconfinedEventLoop, EventLoop);
  initMetadataForClass(JobCancellationException, 'JobCancellationException', VOID, CancellationException);
  initMetadataForClass(SetTimeoutBasedDispatcher, 'SetTimeoutBasedDispatcher', VOID, CoroutineDispatcher, [CoroutineDispatcher, Delay], [1]);
  initMetadataForObject(NodeDispatcher, 'NodeDispatcher', VOID, SetTimeoutBasedDispatcher, VOID, [1]);
  initMetadataForObject(SetTimeoutDispatcher, 'SetTimeoutDispatcher', VOID, SetTimeoutBasedDispatcher, VOID, [1]);
  initMetadataForClass(MessageQueue, 'MessageQueue', VOID, VOID, [KtMutableList]);
  initMetadataForClass(ScheduledMessageQueue, 'ScheduledMessageQueue', VOID, MessageQueue);
  initMetadataForClass(ClearTimeout, 'ClearTimeout', VOID, CancelHandler, [CancelHandler, DisposableHandle]);
  initMetadataForClass(WindowClearTimeout, 'WindowClearTimeout', VOID, ClearTimeout);
  initMetadataForClass(WindowDispatcher, 'WindowDispatcher', VOID, CoroutineDispatcher, [CoroutineDispatcher, Delay], [1]);
  initMetadataForClass(WindowMessageQueue, 'WindowMessageQueue', VOID, MessageQueue);
  initMetadataForClass(AbortFlowException, 'AbortFlowException', VOID, CancellationException);
  initMetadataForClass(ChildCancelledException, 'ChildCancelledException', ChildCancelledException, CancellationException);
  initMetadataForClass(SafeCollector, 'SafeCollector', VOID, VOID, [FlowCollector], [1]);
  initMetadataForClass(DiagnosticCoroutineContextException, 'DiagnosticCoroutineContextException', VOID, RuntimeException);
  initMetadataForClass(CommonThreadLocal, 'CommonThreadLocal', CommonThreadLocal);
  initMetadataForObject(EnumInfoFactory, 'EnumInfoFactory');
  initMetadataForClass(EnumInfoImpl, 'EnumInfoImpl');
  initMetadataForObject(Enums, 'Enums');
  function isNullString(value) {
    return value == null;
  }
  function isNullValue(value) {
    return value == null;
  }
  initMetadataForInterface(NullPersister, 'NullPersister');
  initMetadataForClass(DefaultValueNullPersister, 'DefaultValueNullPersister', VOID, VOID, [NullPersister]);
  initMetadataForClass(EmptyStringNullPersister, 'EmptyStringNullPersister', EmptyStringNullPersister, VOID, [NullPersister]);
  initMetadataForClass(ExceptionNullPersister, 'ExceptionNullPersister', ExceptionNullPersister, VOID, [NullPersister]);
  initMetadataForInterface(NonNullPersister, 'NonNullPersister');
  initMetadataForClass(NonNullPersisters$STRING_PERSISTER$1, VOID, VOID, VOID, [NonNullPersister]);
  initMetadataForClass(NonNullPersisters$INT_PERSISTER$1, VOID, VOID, VOID, [NonNullPersister]);
  initMetadataForClass(NonNullPersisters$LONG_PERSISTER$1, VOID, VOID, VOID, [NonNullPersister]);
  initMetadataForClass(NonNullPersisters$BOOLEAN_PERSISTER$1, VOID, VOID, VOID, [NonNullPersister]);
  initMetadataForClass(NonNullPersisters$DOUBLE_PERSISTER$1, VOID, VOID, VOID, [NonNullPersister]);
  initMetadataForObject(NonNullPersisters, 'NonNullPersisters');
  initMetadataForClass(NullPersisterForNullable, 'NullPersisterForNullable', NullPersisterForNullable, VOID, [NullPersister]);
  function deserialize(value) {
    var tmp;
    if (this.m25().u24(value)) {
      var tmp_0 = this.m25().t24();
      tmp = (tmp_0 == null ? true : !(tmp_0 == null)) ? tmp_0 : THROW_CCE();
    } else {
      tmp = this.o25(ensureNotNull(value));
    }
    return tmp;
  }
  function serialize(value) {
    var tmp;
    if (this.m25().r24(value)) {
      tmp = this.m25().s24();
    } else {
      tmp = this.n25(ensureNotNull(value));
    }
    return tmp;
  }
  initMetadataForInterface(Persister, 'Persister');
  initMetadataForObject(Persisters, 'Persisters');
  initMetadataForClass(SimplePersister, 'SimplePersister', VOID, VOID, [Persister]);
  function parseString$default(string, base, $super) {
    base = base === VOID ? 10 : base;
    return $super === VOID ? this.f26(string, base) : $super.f26.call(this, string, base);
  }
  function tryFromFloat$default(float, exactRequired, $super) {
    exactRequired = exactRequired === VOID ? false : exactRequired;
    return $super === VOID ? this.i26(float, exactRequired) : $super.i26.call(this, float, exactRequired);
  }
  function tryFromDouble$default(double, exactRequired, $super) {
    exactRequired = exactRequired === VOID ? false : exactRequired;
    return $super === VOID ? this.k26(double, exactRequired) : $super.k26.call(this, double, exactRequired);
  }
  initMetadataForInterface(Creator, 'Creator');
  function plus_0(other) {
    return this.n26().p26(other);
  }
  function minus(other) {
    return this.n26().r26(other);
  }
  function times(other) {
    return this.n26().t26(other);
  }
  function div(other) {
    return this.n26().v26(other);
  }
  function plus_1(int) {
    return this.n26().p26(this.m26().h26(int));
  }
  function times_0(int) {
    return this.n26().t26(this.m26().h26(int));
  }
  function minus_0(int) {
    return this.n26().r26(this.m26().h26(int));
  }
  function div_0(int) {
    return this.n26().v26(this.m26().h26(int));
  }
  function rem(int) {
    return this.n26().b27(this.m26().h26(int));
  }
  initMetadataForInterface(CommonBigNumberOperations, 'CommonBigNumberOperations');
  initMetadataForClass(SignificantDecider, 'SignificantDecider', VOID, Enum);
  initMetadataForCompanion(Companion_24, VOID, [Creator]);
  initMetadataForClass(ScaleOps, 'ScaleOps', VOID, Enum);
  initMetadataForClass(BigDecimal, 'BigDecimal', VOID, VOID, [CommonBigNumberOperations, Comparable]);
  initMetadataForCompanion(Companion_25);
  initMetadataForClass(DecimalMode, 'DecimalMode', DecimalMode);
  initMetadataForClass(RoundingMode, 'RoundingMode', VOID, Enum);
  initMetadataForCompanion(Companion_26, VOID, [Creator]);
  initMetadataForClass(QuotientAndRemainder, 'QuotientAndRemainder');
  initMetadataForClass(BigInteger, 'BigInteger', VOID, VOID, [CommonBigNumberOperations, Comparable]);
  initMetadataForClass(Sign, 'Sign', VOID, Enum);
  initMetadataForClass(Platform, 'Platform', VOID, Enum);
  initMetadataForClass(Sextuple, 'Sextuple');
  initMetadataForClass(Quadruple, 'Quadruple');
  initMetadataForClass(SignedUIntArray, 'SignedUIntArray');
  initMetadataForObject(BigInteger32Arithmetic, 'BigInteger32Arithmetic');
  initMetadataForClass(SignedULongArray, 'SignedULongArray');
  initMetadataForObject(BigInteger63Arithmetic, 'BigInteger63Arithmetic');
  initMetadataForObject(RuntimePlatform, 'RuntimePlatform');
  initMetadataForClass(DefaultJsonSupport, 'DefaultJsonSupport', DefaultJsonSupport);
  initMetadataForClass(IndentBuilder, 'IndentBuilder');
  initMetadataForObject(Json, 'Json');
  initMetadataForCompanion(Companion_27);
  initMetadataForClass(JsonValue, 'JsonValue');
  initMetadataForClass(JsonArray, 'JsonArray', JsonArray, JsonValue);
  initMetadataForClass(JsonBoolean, 'JsonBoolean', VOID, JsonValue);
  initMetadataForClass(JsonLexer, 'JsonLexer');
  initMetadataForClass(JsonNull, 'JsonNull', JsonNull, JsonValue);
  initMetadataForClass(JsonNumber, 'JsonNumber', VOID, JsonValue);
  initMetadataForClass(JsonObject, 'JsonObject', JsonObject, JsonValue);
  initMetadataForClass(JsonParsingException, 'JsonParsingException', JsonParsingException_init_$Create$, RuntimeException);
  initMetadataForClass(JsonString, 'JsonString', VOID, JsonValue);
  initMetadataForClass(JsonTokenKind, 'JsonTokenKind', VOID, Enum);
  initMetadataForObject(JsonUtil, 'JsonUtil');
  initMetadataForClass(StringJsonLexer, 'StringJsonLexer', VOID, JsonLexer);
  initMetadataForObject(BaseJsonReaderSupport, 'BaseJsonReaderSupport');
  initMetadataForInterface(JsonArrayReader, 'JsonArrayReader');
  initMetadataForClass(JsonArrayReaderImpl, 'JsonArrayReaderImpl', VOID, VOID, [JsonArrayReader]);
  initMetadataForClass(JsonObjectReaderImpl, 'JsonObjectReaderImpl');
  initMetadataForClass(CommonApiJsonIterator, 'CommonApiJsonIterator');
  initMetadataForObject(CommonJsonIterSupport, 'CommonJsonIterSupport');
  initMetadataForClass(CommonJsonIteratorFactory, 'CommonJsonIteratorFactory', CommonJsonIteratorFactory);
  initMetadataForObject(Hex, 'Hex');
  initMetadataForClass(JsonException, 'JsonException', VOID, RuntimeException);
  initMetadataForCompanion(Companion_28);
  initMetadataForClass(JsonIterator, 'JsonIterator');
  initMetadataForClass(JsonIterArrayReader, 'JsonIterArrayReader', VOID, VOID, [JsonArrayReader]);
  initMetadataForClass(JsonIterObjectReader, 'JsonIterObjectReader');
  initMetadataForClass(JsonIterReader, 'JsonIterReader', VOID, VOID, [JsonArrayReader]);
  initMetadataForClass(JsonIterReaderFactory, 'JsonIterReaderFactory');
  initMetadataForObject(JsonStreamIterSupport, 'JsonStreamIterSupport');
  initMetadataForObject(CommonJsonStreamIterSupport, 'CommonJsonStreamIterSupport');
  function plus_2(disposable) {
    return toDisposable_0([this, disposable]);
  }
  initMetadataForInterface(Disposable, 'Disposable');
  initMetadataForClass(CompositeDisposable, 'CompositeDisposable', VOID, VOID, [Disposable]);
  initMetadataForCompanion(Companion_29);
  initMetadataForClass(toDisposable$$inlined$toDisposable$1, VOID, VOID, VOID, [Disposable]);
  initMetadataForClass(DisposableMap, 'DisposableMap', DisposableMap);
  initMetadataForClass(SafeIterationList, 'SafeIterationList');
  initMetadataForClass(AddAtEndSafeIterationList, 'AddAtEndSafeIterationList', AddAtEndSafeIterationList, SafeIterationList);
  initMetadataForClass(ListMap$keySet$1$iterator$spec$1);
  initMetadataForClass(ListMap$values$1$iterator$spec$1);
  initMetadataForClass(ListMap$entrySet$1$iterator$spec$1);
  initMetadataForClass(Entry_0, 'Entry');
  initMetadataForCompanion(Companion_30);
  initMetadataForClass(ListMap$keySet$1, VOID, VOID, AbstractMutableSet);
  initMetadataForClass(ListMap$values$1, VOID, VOID, AbstractCollection);
  initMetadataForClass(ListMap$entrySet$1, VOID, VOID, AbstractSet);
  initMetadataForClass(ListMap$mapIterator$1);
  initMetadataForClass(ListMap, 'ListMap', ListMap);
  initMetadataForClass(Op, 'Op');
  initMetadataForCompanion(Companion_31);
  initMetadataForClass(ItemIterator, 'ItemIterator');
  initMetadataForClass(SafeIterationListIterable, 'SafeIterationListIterable');
  initMetadataForClass(SimpleCopyOnWriteList, 'SimpleCopyOnWriteList');
  initMetadataForClass(SimpleCopyOnWriteAddAtStartList, 'SimpleCopyOnWriteAddAtStartList', SimpleCopyOnWriteAddAtStartList, SimpleCopyOnWriteList);
  initMetadataForCompanion(Companion_32);
  initMetadataForClass(NaiveTreeMap$TailMapView$iterator$1);
  initMetadataForClass(Entry_1, 'Entry', VOID, VOID, [MutableEntry]);
  initMetadataForClass(TailMapView, 'TailMapView', VOID, AbstractMutableSet);
  initMetadataForClass(NaiveTreeMap$entries$1, VOID, VOID, TailMapView);
  initMetadataForClass(NaiveTreeMap$tailMap0$entrySet$1, VOID, VOID, TailMapView);
  initMetadataForClass(NaiveTreeMap$tailMap0$1, VOID, VOID, AbstractMutableMap);
  initMetadataForClass(NaiveTreeMap, 'NaiveTreeMap', VOID, AbstractMutableMap, [AbstractMutableMap, KtMap, KtMutableMap]);
  initMetadataForObject(Present, 'Present');
  initMetadataForClass(NaiveTreeSet, 'NaiveTreeSet', VOID, AbstractMutableSet);
  function withLock(f) {
    this.r2o();
    try {
      return f();
    }finally {
      this.s2o();
    }
  }
  initMetadataForInterface(Lock, 'Lock');
  initMetadataForClass(emptyThreadSafeChecker$1);
  initMetadataForClass(AtomicLongJs, 'AtomicLongJs');
  initMetadataForClass(AtomicBooleanJs, 'AtomicBooleanJs');
  initMetadataForClass(newLock$1, VOID, VOID, VOID, [Lock]);
  initMetadataForClass(SimpleThreadLocalJs, 'SimpleThreadLocalJs');
  initMetadataForClass(FormattingAppender, 'FormattingAppender');
  initMetadataForObject(DirectLoggerFactory, 'DirectLoggerFactory');
  initMetadataForClass(DefaultMessageFormatter, 'DefaultMessageFormatter', DefaultMessageFormatter);
  function debug(message) {
    return this.y2p(null, null, message);
  }
  function debug_0(marker, throwable, message) {
    var tmp = Level_DEBUG_getInstance();
    return this.z2p(tmp, marker, KLogger$debug$lambda(message, throwable));
  }
  function info(message) {
    return this.b2q(null, null, message);
  }
  function info_0(marker, throwable, message) {
    var tmp = Level_INFO_getInstance();
    return this.z2p(tmp, marker, KLogger$info$lambda(message, throwable));
  }
  function warn(message) {
    return this.d2q(null, null, message);
  }
  function warn_0(throwable, message) {
    return this.d2q(null, throwable, message);
  }
  function warn_1(marker, throwable, message) {
    var tmp = Level_WARN_getInstance();
    return this.z2p(tmp, marker, KLogger$warn$lambda(message, throwable));
  }
  function error(message) {
    return this.g2q(null, null, message);
  }
  function error_0(throwable, message) {
    return this.g2q(null, throwable, message);
  }
  function error_1(marker, throwable, message) {
    var tmp = Level_ERROR_getInstance();
    return this.z2p(tmp, marker, KLogger$error$lambda(message, throwable));
  }
  initMetadataForInterface(KLogger, 'KLogger');
  initMetadataForClass(KLoggingEvent, 'KLoggingEvent');
  initMetadataForClass(KLoggingEventBuilder, 'KLoggingEventBuilder', KLoggingEventBuilder);
  initMetadataForObject(KotlinLogging, 'KotlinLogging');
  initMetadataForClass(Level, 'Level', VOID, Enum);
  initMetadataForClass(KLoggerDirect, 'KLoggerDirect', VOID, VOID, [KLogger]);
  initMetadataForObject(DefaultErrorMessageProducer, 'DefaultErrorMessageProducer');
  initMetadataForClass(ConsoleOutputAppender, 'ConsoleOutputAppender', ConsoleOutputAppender, FormattingAppender);
  initMetadataForClass(KotlinLoggingConfiguration$direct$1);
  initMetadataForObject(KotlinLoggingConfiguration, 'KotlinLoggingConfiguration');
  initMetadataForObject(KLoggerNameResolver, 'KLoggerNameResolver');
  initMetadataForClass(sam$jetbrains_ocelot_base_disposable_Disposable$0, 'sam$jetbrains_ocelot_base_disposable_Disposable$0', VOID, VOID, [Disposable, FunctionAdapter]);
  initMetadataForClass(MyEventSource, 'MyEventSource', MyEventSource);
  initMetadataForCompanion(Companion_33);
  initMetadataForClass(sam$jetbrains_ocelot_base_disposable_Disposable$0_0, 'sam$jetbrains_ocelot_base_disposable_Disposable$0', VOID, VOID, [Disposable, FunctionAdapter]);
  initMetadataForClass(ThrowableHandler, 'ThrowableHandler');
  initMetadataForObject(ThrowableHandlers, 'ThrowableHandlers');
  initMetadataForInterface(CollectionListener, 'CollectionListener');
  initMetadataForClass(CollectionAdapter, 'CollectionAdapter', CollectionAdapter, VOID, [CollectionListener]);
  initMetadataForClass(CollectionIndexOutOfBoundsException, 'CollectionIndexOutOfBoundsException', CollectionIndexOutOfBoundsException_init_$Create$, RuntimeException);
  initMetadataForClass(EventType, 'EventType', VOID, Enum);
  initMetadataForClass(CollectionItemEvent, 'CollectionItemEvent');
  function addHandler(handler) {
    // Inline function 'jetbrains.ocelot.base.observable.event.eventHandler' call
    var tmp$ret$0 = new EventSource$addHandler$$inlined$eventHandler$1(handler);
    return this.y2r(tmp$ret$0);
  }
  initMetadataForInterface(EventSource, 'EventSource');
  initMetadataForInterface(MutableObservableCollection, 'MutableObservableCollection', VOID, VOID, [EventSource, Collection, MutableCollection]);
  initMetadataForClass(Listeners, 'Listeners', Listeners);
  initMetadataForClass(CollectionListeners, 'CollectionListeners', VOID, Listeners);
  initMetadataForClass(AbstractObservableList$addHandler$listener$1, VOID, VOID, VOID, [CollectionListener]);
  initMetadataForInterface(ObservableList, 'ObservableList', VOID, VOID, [KtList, EventSource, Collection]);
  initMetadataForInterface(MutableObservableList, 'MutableObservableList', VOID, VOID, [ObservableList, KtMutableList, MutableObservableCollection]);
  initMetadataForClass(AbstractObservableList, 'AbstractObservableList', VOID, AbstractMutableList, [AbstractMutableList, MutableObservableList]);
  initMetadataForCompanion(Companion_34);
  initMetadataForClass(ConstantObservableListAdapter, 'ConstantObservableListAdapter', VOID, VOID, [ObservableList, KtList]);
  initMetadataForClass(ObservableArrayList, 'ObservableArrayList', ObservableArrayList, AbstractObservableList);
  initMetadataForClass(AbstractObservableSet$iterator$1);
  initMetadataForClass(AbstractObservableSet$addHandler$listener$1, VOID, VOID, CollectionAdapter);
  initMetadataForClass(AbstractObservableSet, 'AbstractObservableSet', VOID, AbstractMutableSet, [AbstractMutableSet, KtSet, EventSource, MutableObservableCollection, KtMutableSet, Collection]);
  initMetadataForCompanion(Companion_35);
  initMetadataForClass(ConstantObservableSetAdapter, 'ConstantObservableSetAdapter', VOID, VOID, [KtSet, EventSource, Collection]);
  initMetadataForClass(ObservableHashSet, 'ObservableHashSet', ObservableHashSet_init_$Create$, AbstractObservableSet);
  initMetadataForClass(ObservableListWrapper, 'ObservableListWrapper', VOID, AbstractMutableList, [AbstractMutableList, MutableObservableList]);
  initMetadataForClass(ObservableSetWrapper$iterator$1);
  initMetadataForClass(ObservableSetWrapper, 'ObservableSetWrapper', VOID, VOID, [KtSet, EventSource, MutableObservableCollection, KtMutableSet, Collection]);
  initMetadataForClass(RelayCollectionListener, 'RelayCollectionListener', VOID, VOID, [CollectionListener]);
  initMetadataForClass(EventHandlerListeners, 'EventHandlerListeners', EventHandlerListeners, Listeners);
  initMetadataForClass(EventSource$addHandler$$inlined$eventHandler$1);
  initMetadataForClass(EventListeners, 'EventListeners', EventListeners, Listeners);
  initMetadataForClass(CompositeEventSource$addHandler$1, VOID, VOID, EventHandlerListeners);
  initMetadataForClass(CompositeEventSource, 'CompositeEventSource', VOID, VOID, [EventSource]);
  initMetadataForObject(EventSources, 'EventSources');
  initMetadataForClass(Listeners$add$$inlined$toDisposable$1, VOID, VOID, VOID, [Disposable]);
  initMetadataForClass(ListenersDelegate, 'ListenersDelegate', VOID, Listeners);
  initMetadataForClass(ListenersMap$add$$inlined$toDisposable$1, VOID, VOID, VOID, [Disposable]);
  initMetadataForClass(ListenersMap, 'ListenersMap', ListenersMap);
  initMetadataForClass(BaseDerivedProperty$addHandler$1, VOID, VOID, EventHandlerListeners);
  function invoke() {
    return this.uv();
  }
  initMetadataForInterface(ReadableProperty, 'ReadableProperty', VOID, VOID, [EventSource]);
  initMetadataForClass(BaseReadableProperty, 'BaseReadableProperty', VOID, VOID, [ReadableProperty]);
  initMetadataForClass(BaseDerivedProperty, 'BaseDerivedProperty', VOID, BaseReadableProperty);
  initMetadataForClass(DelayedValueProperty$addHandler$1, VOID, VOID, EventHandlerListeners);
  function invoke_0(value) {
    return this.d2x(value);
  }
  initMetadataForInterface(WritableProperty, 'WritableProperty');
  initMetadataForInterface(Property, 'Property', VOID, VOID, [ReadableProperty, WritableProperty]);
  initMetadataForClass(DelayedValueProperty, 'DelayedValueProperty', DelayedValueProperty, BaseReadableProperty, [BaseReadableProperty, Property]);
  initMetadataForClass(DerivedProperty, 'DerivedProperty', VOID, BaseDerivedProperty);
  initMetadataForClass(toDerivedProperty$1, VOID, VOID, DerivedProperty);
  initMetadataForClass(Properties$and$1, VOID, VOID, DerivedProperty);
  initMetadataForClass(Properties$or$1, VOID, VOID, DerivedProperty);
  initMetadataForObject(Properties, 'Properties');
  initMetadataForClass(AbstractSelectProperty, 'AbstractSelectProperty', VOID, BaseDerivedProperty);
  initMetadataForClass(map$1, VOID, VOID, DerivedProperty);
  initMetadataForClass(map$2, VOID, VOID, VOID, [Property]);
  initMetadataForClass(and$1, VOID, VOID, DerivedProperty);
  initMetadataForClass(asValidatedProp$ValidatedProperty, 'ValidatedProperty', VOID, DerivedProperty, [DerivedProperty, Property]);
  initMetadataForClass(select$1, VOID, VOID, AbstractSelectProperty);
  initMetadataForClass(constantProp$1, VOID, VOID, BaseReadableProperty);
  initMetadataForClass(ifProp$1, VOID, VOID, DerivedProperty);
  initMetadataForClass(isEqual$1, VOID, VOID, DerivedProperty);
  initMetadataForClass(PropertyBinding$bindTwoWay$UpdatingEventHandler, 'UpdatingEventHandler');
  initMetadataForObject(PropertyBinding, 'PropertyBinding');
  initMetadataForClass(PropertyChangeEvent, 'PropertyChangeEvent');
  initMetadataForClass(UpdatableProperty, 'UpdatableProperty', VOID, BaseDerivedProperty);
  initMetadataForClass(ValueProperty$initializedHandlers$1, VOID, VOID, EventHandlerListeners);
  initMetadataForClass(ValueProperty, 'ValueProperty', VOID, BaseReadableProperty, [BaseReadableProperty, Property]);
  initMetadataForClass(toWritableProperty$1, VOID, VOID, VOID, [WritableProperty]);
  initMetadataForClass(SimpleCollectionProperty, 'SimpleCollectionProperty', VOID, BaseDerivedProperty);
  initMetadataForClass(isEmptyProp$1, VOID, VOID, SimpleCollectionProperty);
  initMetadataForClass(SimpleCollectionProperty$doAddListeners$listener$1, VOID, VOID, VOID, [CollectionListener]);
  initMetadataForClass(SingleItemCollectionProperty$addHandler$listener$1, VOID, VOID, CollectionAdapter);
  initMetadataForClass(SingleItemCollectionProperty, 'SingleItemCollectionProperty', VOID, VOID, [Property]);
  initMetadataForCoroutine($awaitNotNullCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($awaitValueCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($awaitMatchingCOROUTINE$, CoroutineImpl);
  initMetadataForClass(BaseTransformer, 'BaseTransformer');
  initMetadataForClass(IdentityHashMap$entries$1$iterator$1$next$1, VOID, VOID, VOID, [MutableEntry]);
  initMetadataForClass(IdentityHashMap$entries$1$iterator$1);
  initMetadataForClass(IdentityHashMap$keys$1$iterator$1);
  initMetadataForClass(IdentityHashMap$entries$1, VOID, VOID, VOID, [KtMutableSet]);
  initMetadataForClass(IdentityHashMap$mapEntry$1, VOID, VOID, VOID, [MutableEntry]);
  initMetadataForClass(IdentityHashMap$keys$1, VOID, VOID, VOID, [KtMutableSet]);
  initMetadataForClass(IdentityHashMap, 'IdentityHashMap', IdentityHashMap, VOID, [KtMutableMap]);
  initMetadataForClass(Wrapper, 'Wrapper');
  initMetadataForClass(TerminalTransformation, 'TerminalTransformation', VOID, VOID, [Disposable]);
  initMetadataForClass(Transformation, 'Transformation', VOID, TerminalTransformation);
  initMetadataForClass(SimpleTransformation, 'SimpleTransformation', VOID, Transformation);
  initMetadataForClass(Transformers$fromFun$1$transform$1, VOID, VOID, Transformation);
  initMetadataForClass(Transformers$listMap$1$transform$listener$1, VOID, VOID, VOID, [CollectionListener]);
  initMetadataForClass(Transformers$listMap$1$transform$$inlined$toDisposable$1, VOID, VOID, VOID, [Disposable]);
  initMetadataForClass(Transformers$flattenList$5$transform$sourceListener$1$watch$1, VOID, VOID, VOID, [CollectionListener]);
  initMetadataForClass(Transformers$flattenList$5$transform$sourceListener$1, VOID, VOID, CollectionAdapter);
  initMetadataForClass(Transformers$flattenList$5$transform$$inlined$toDisposable$1, VOID, VOID, VOID, [Disposable]);
  initMetadataForClass(Transformers$withPlaceHoldersIfEmpty$1$transform$fromRegistration$1, VOID, VOID, CollectionAdapter);
  initMetadataForClass(Transformers$fromFun$1, VOID, VOID, BaseTransformer);
  initMetadataForClass(Transformers$listMap$1, VOID, VOID, BaseTransformer);
  initMetadataForClass(Transformers$flattenList$5, VOID, VOID, BaseTransformer);
  initMetadataForClass(Transformers$withPlaceHoldersIfEmpty$1, VOID, VOID, BaseTransformer);
  initMetadataForClass(Transformers$propertyToList$1, VOID, VOID, BaseTransformer);
  initMetadataForObject(Transformers, 'Transformers');
  initMetadataForInterface(Composite, 'Composite');
  initMetadataForObject(Composites, 'Composites');
  initMetadataForCompanion(Companion_36);
  initMetadataForClass(BaseId, 'BaseId', BaseId);
  initMetadataForObject(IdGenerator, 'IdGenerator');
  initMetadataForClass(IdNames, 'IdNames', IdNames);
  initMetadataForClass(Interval$reverseIterable$1$iterator$1);
  initMetadataForCompanion(Companion_37);
  initMetadataForClass(Interval$iterable$1);
  initMetadataForClass(Interval$reverseIterable$1);
  initMetadataForClass(Interval$iterator$1);
  initMetadataForClass(Interval, 'Interval');
  initMetadataForClass(Asyncs$constant$1);
  initMetadataForClass(Asyncs$failure$1);
  initMetadataForObject(Asyncs, 'Asyncs');
  initMetadataForClass(SuccessItem, 'SuccessItem');
  initMetadataForClass(SimpleAsync$onResult$$inlined$toDisposable$1, VOID, VOID, VOID, [Disposable]);
  initMetadataForClass(SimpleAsync, 'SimpleAsync', SimpleAsync);
  initMetadataForClass(ThrowableCollectionException, 'ThrowableCollectionException', VOID, RuntimeException);
  function plus_3(other) {
    return compound(this, other);
  }
  initMetadataForInterface(AsyncGuardedExecution, 'AsyncGuardedExecution', VOID, VOID, [Disposable], [0]);
  initMetadataForObject(EmptyRunnable, 'EmptyRunnable');
  initMetadataForClass(compound$1$prepare$2);
  initMetadataForCoroutine($prepareCOROUTINE$, CoroutineImpl);
  initMetadataForClass(compound$1, VOID, VOID, VOID, [AsyncGuardedExecution], [0]);
  function workStarted() {
  }
  function workFinished() {
  }
  initMetadataForInterface(AsyncTracker, 'AsyncTracker');
  initMetadataForClass(AsyncTracker$Companion$EMPTY$1, VOID, VOID, VOID, [AsyncTracker]);
  initMetadataForCompanion(Companion_38);
  initMetadataForLambda(launchWith$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(DefaultAsyncEdt, 'DefaultAsyncEdt');
  initMetadataForClass(EdtException, 'EdtException', VOID, RuntimeException);
  initMetadataForInterface(EdtTask, 'EdtTask');
  initMetadataForClass(NullEventDispatchThread, 'NullEventDispatchThread', NullEventDispatchThread, DefaultAsyncEdt);
  initMetadataForClass(sam$jetbrains_ocelot_base_edt_EdtTask$0, 'sam$jetbrains_ocelot_base_edt_EdtTask$0', VOID, VOID, [EdtTask, FunctionAdapter]);
  initMetadataForClass(sam$jetbrains_ocelot_base_edt_EdtTask$0_0, 'sam$jetbrains_ocelot_base_edt_EdtTask$0', VOID, VOID, [EdtTask, FunctionAdapter]);
  initMetadataForClass(sam$jetbrains_ocelot_base_edt_EdtTask$0_1, 'sam$jetbrains_ocelot_base_edt_EdtTask$0', VOID, VOID, [EdtTask, FunctionAdapter]);
  initMetadataForClass(sam$kotlinx_coroutines_DisposableHandle$0, 'sam$kotlinx_coroutines_DisposableHandle$0', VOID, VOID, [DisposableHandle, FunctionAdapter]);
  initMetadataForClass(EdtCoroutineDispatcher, 'EdtCoroutineDispatcher', VOID, CoroutineDispatcher, [CoroutineDispatcher, Delay], [1]);
  initMetadataForClass(JsEventDispatchThread$timerDisposable$$inlined$toDisposable$1, VOID, VOID, VOID, [Disposable]);
  initMetadataForObject(JsEventDispatchThread, 'JsEventDispatchThread', VOID, DefaultAsyncEdt);
  initMetadataForCompanion(Companion_39);
  initMetadataForClass(Task, 'Task');
  initMetadataForClass(Flusher, 'Flusher');
  initMetadataForClass(Rescuer, 'Rescuer');
  initMetadataForCompanion(Companion_40);
  initMetadataForClass(SchedulerImpl, 'SchedulerImpl', SchedulerImpl);
  initMetadataForClass(Timer, 'Timer');
  function get_default() {
    var message = 'No default service provided for ' + toString_1(this);
    throw IllegalStateException_init_$Create$_0(toString_1(message));
  }
  function invoke_1(container) {
    var tmp0_elvis_lhs = container.h3b(this);
    return tmp0_elvis_lhs == null ? this.g3b() : tmp0_elvis_lhs;
  }
  function invoke_2() {
    return new ServiceAdapter(Service$Key$invoke$lambda(this));
  }
  function optional(container) {
    return container.h3b(this);
  }
  initMetadataForInterface(Key_5, 'Key');
  initMetadataForCompanion(Companion_41);
  initMetadataForClass(AnonymousResourceServiceKey, 'AnonymousResourceServiceKey', AnonymousResourceServiceKey, VOID, [Key_5]);
  initMetadataForClass(Service, 'Service');
  initMetadataForClass(ServiceAdapter, 'ServiceAdapter');
  initMetadataForCompanion(Companion_42);
  initMetadataForClass(ServiceInstance$$inlined$toDisposable$1, VOID, VOID, VOID, [Disposable]);
  initMetadataForClass(ServiceInstance, 'ServiceInstance', VOID, VOID, [Disposable]);
  initMetadataForClass(ServiceEntry, 'ServiceEntry');
  function getValue(_this__u8e3s4, thisRef, property) {
    return _this__u8e3s4.u3b(this);
  }
  initMetadataForInterface(ServicesScope, 'ServicesScope');
  initMetadataForClass(ServiceManager, 'ServiceManager', VOID, VOID, [Disposable, ServicesScope]);
  initMetadataForObject(CoroutineContextService, 'CoroutineContextService', VOID, VOID, [Key_5]);
  initMetadataForClass(Configuration, 'Configuration', Configuration_init_$Create$);
  initMetadataForClass(ConfigurationPersistentContext, 'ConfigurationPersistentContext');
  initMetadataForClass(ConfigurationPersister, 'ConfigurationPersister');
  initMetadataForInterface(PersistentParameter, 'PersistentParameter');
  initMetadataForObject(LoggingUtils, 'LoggingUtils');
  initMetadataForClass(OtRejectionException, 'OtRejectionException', OtRejectionException, RuntimeException);
  initMetadataForClass(RejectionReason, 'RejectionReason', VOID, Enum);
  initMetadataForClass(ThreadSafeProperty, 'ThreadSafeProperty', VOID, ValueProperty);
  initMetadataForObject(Entities, 'Entities');
  initMetadataForClass(Entity$SafeObservableHashSet$1, VOID, VOID, CollectionAdapter);
  initMetadataForClass(ModelListenerData, 'ModelListenerData');
  initMetadataForClass(SafeObservableHashSet, 'SafeObservableHashSet', VOID, ObservableHashSet);
  initMetadataForClass(Entity$modelProperty$1, VOID, VOID, VOID, [Property]);
  initMetadataForClass(Entity$get$1, VOID, VOID, SafeObservableHashSet);
  initMetadataForInterface(EntitySet, 'EntitySet', VOID, VOID, [KtSet, EventSource, MutableObservableCollection, KtMutableSet, Collection]);
  initMetadataForClass(EntityHashSet, 'EntityHashSet', EntityHashSet, AbstractObservableSet, [AbstractObservableSet, EntitySet]);
  initMetadataForClass(SafeEntityHashSet, 'SafeEntityHashSet', VOID, EntityHashSet);
  initMetadataForClass(Entity$get$2, VOID, VOID, SafeEntityHashSet);
  initMetadataForClass(Entity$get$3, VOID, VOID, CollectionAdapter);
  initMetadataForClass(Entity, 'Entity');
  initMetadataForClass(MetaId, 'MetaId', VOID, BaseId);
  initMetadataForClass(RoleId, 'RoleId', VOID, MetaId);
  initMetadataForClass(EntityChildId, 'EntityChildId', VOID, RoleId);
  initMetadataForCompanion(Companion_43);
  initMetadataForClass(EntityConceptId, 'EntityConceptId', EntityConceptId_init_$Create$, MetaId);
  initMetadataForClass(EntityConceptIdFlag, 'EntityConceptIdFlag', VOID, Enum);
  initMetadataForClass(EntityContext$SafeEntityHashSet$1, VOID, VOID, CollectionAdapter);
  initMetadataForClass(EntityContext$rootEntities$1, VOID, VOID, SafeEntityHashSet);
  initMetadataForClass(EntityContext$1, VOID, VOID, CollectionAdapter);
  initMetadataForInterface(ModelListener, 'ModelListener');
  initMetadataForClass(ModelAdapter, 'ModelAdapter', VOID, VOID, [ModelListener]);
  initMetadataForClass(EntityContext$watchModelBlob$nodeFeatureChangedRegistration$1, VOID, VOID, ModelAdapter);
  initMetadataForClass(EntityContext, 'EntityContext', EntityContext);
  initMetadataForClass(EntityId, 'EntityId', EntityId_init_$Create$, BaseId);
  initMetadataForClass(EntityModelBlobId, 'EntityModelBlobId', EntityModelBlobId_init_$Create$, BaseId);
  initMetadataForClass(EntityPropertyId, 'EntityPropertyId', EntityPropertyId_init_$Create$, BaseId);
  initMetadataForCompanion(Companion_44);
  initMetadataForClass(EntityReference, 'EntityReference');
  initMetadataForClass(EntityReferenceId, 'EntityReferenceId', VOID, RoleId);
  initMetadataForClass(ReferenceStatus, 'ReferenceStatus', VOID, Enum);
  initMetadataForClass(EntityEvent, 'EntityEvent');
  initMetadataForClass(EntityChildEvent, 'EntityChildEvent', VOID, EntityEvent);
  initMetadataForClass(EntityChildAddedEvent, 'EntityChildAddedEvent', VOID, EntityChildEvent);
  initMetadataForClass(EntityChildRemovedEvent, 'EntityChildRemovedEvent', VOID, EntityChildEvent);
  function onRootAdded(event) {
    this.y3j(event);
  }
  function onRootRemoved(event) {
    this.y3j(event);
  }
  function onChildAdded(event) {
    this.y3j(event);
  }
  function onChildRemoved(event) {
    this.y3j(event);
  }
  function onChildMoved(event) {
    this.y3j(event);
  }
  function onPropertyChanged(event) {
    this.y3j(event);
  }
  function onReferenceAdded(event) {
    this.y3j(event);
  }
  function onReferenceRemoved(event) {
    this.y3j(event);
  }
  function onModelBlobChanged(event) {
    this.y3j(event);
  }
  function onNodeEvent(event) {
    this.y3j(event);
  }
  function onEntityFeatureChanged(event) {
  }
  initMetadataForInterface(EntityContextListener, 'EntityContextListener');
  initMetadataForClass(EntityModelBlobChangedEvent, 'EntityModelBlobChangedEvent', VOID, EntityEvent);
  initMetadataForClass(EntityMovedEvent, 'EntityMovedEvent', VOID, EntityEvent);
  initMetadataForClass(EntityNodeEvent, 'EntityNodeEvent', VOID, EntityEvent);
  initMetadataForClass(EntityPropertyChangedEvent, 'EntityPropertyChangedEvent', VOID, EntityEvent);
  initMetadataForClass(EntityReferenceEvent, 'EntityReferenceEvent', VOID, EntityEvent);
  initMetadataForClass(EntityReferenceAddedEvent, 'EntityReferenceAddedEvent', VOID, EntityReferenceEvent);
  initMetadataForClass(EntityReferenceRemovedEvent, 'EntityReferenceRemovedEvent', VOID, EntityReferenceEvent);
  initMetadataForClass(RootAddedEvent, 'RootAddedEvent', VOID, EntityEvent);
  initMetadataForClass(RootRemovedEvent, 'RootRemovedEvent', VOID, EntityEvent);
  initMetadataForClass(EventStateHolder, 'EventStateHolder', EventStateHolder);
  initMetadataForClass(NullEventStateHolder, 'NullEventStateHolder', NullEventStateHolder, EventStateHolder);
  initMetadataForClass(OtException, 'OtException', OtException_init_$Create$, RuntimeException);
  initMetadataForCompanion(Companion_45);
  initMetadataForClass(Json2EntityConverter, 'Json2EntityConverter', Json2EntityConverter);
  initMetadataForClass(Json2NodeConverter, 'Json2NodeConverter');
  initMetadataForCompanion(Companion_46);
  initMetadataForClass(Entity2JsonConverter, 'Entity2JsonConverter', Entity2JsonConverter);
  initMetadataForClass(Node2JsonConverter, 'Node2JsonConverter');
  initMetadataForObject(MessageBundle, 'MessageBundle');
  initMetadataForClass(BaseOtNodeProperty, 'BaseOtNodeProperty', VOID, BaseReadableProperty, [BaseReadableProperty, Property]);
  initMetadataForClass(BaseOtNodeTextProperty$addHandler$$inlined$eventHandler$1);
  initMetadataForClass(BaseOtNodeTextProperty, 'BaseOtNodeTextProperty', VOID, VOID, [ReadableProperty]);
  initMetadataForClass(MetaIdFactory, 'MetaIdFactory');
  initMetadataForClass(UnionNodeCollectionView, 'UnionNodeCollectionView', VOID, AbstractCollection);
  initMetadataForClass(Model, 'Model');
  initMetadataForClass(Node$getTextProperty$1, VOID, VOID, BaseOtNodeTextProperty);
  initMetadataForClass(OtNode, 'OtNode', VOID, VOID, [CollectionListener]);
  initMetadataForClass(Node_0, 'Node', VOID, OtNode);
  initMetadataForClass(NodeChildId, 'NodeChildId', VOID, RoleId);
  initMetadataForObject(NodeChildIdFactory, 'NodeChildIdFactory');
  initMetadataForClass(NodeConceptId, 'NodeConceptId', VOID, MetaId);
  initMetadataForObject(NodeConceptIdFactory, 'NodeConceptIdFactory');
  initMetadataForClass(NodeConceptIdFlag, 'NodeConceptIdFlag', VOID, Enum);
  initMetadataForClass(NodeCopier, 'NodeCopier');
  initMetadataForClass(NodeId, 'NodeId', NodeId, BaseId);
  initMetadataForClass(NodePropertyChangeEvent, 'NodePropertyChangeEvent');
  initMetadataForClass(NodePropertyId, 'NodePropertyId', VOID, BaseId);
  initMetadataForObject(NodePropertyIdFactory, 'NodePropertyIdFactory');
  initMetadataForClass(RemoveChildOperationData, 'RemoveChildOperationData');
  initMetadataForClass(MyProperty, 'MyProperty', VOID, BaseReadableProperty, [BaseReadableProperty, Property]);
  initMetadataForClass(ChildrenObservableList, 'ChildrenObservableList', VOID, ObservableArrayList);
  initMetadataForCompanion(Companion_47);
  initMetadataForClass(OtNode$deepChangeListeners$1, VOID, VOID, EventHandlerListeners);
  initMetadataForClass(OtNode$copy$nodeCopier$1, VOID, VOID, NodeCopier);
  initMetadataForLambda(OtNode$descendants$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(OtNode$allChildren$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(OtNode$addPropertyHandler$$inlined$eventHandler$1);
  function createNode$default(conceptId, nodeId, $super) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(conceptId) : nodeId;
    return $super === VOID ? this.d3m(conceptId, nodeId) : $super.d3m.call(this, conceptId, nodeId);
  }
  initMetadataForInterface(OtNodeFactory, 'OtNodeFactory');
  initMetadataForClass(PropertyEventHandlerWrapper, 'PropertyEventHandlerWrapper');
  initMetadataForObject(RawNodeFactory, 'RawNodeFactory', VOID, VOID, [OtNodeFactory]);
  initMetadataForClass(NodeEvent, 'NodeEvent');
  initMetadataForClass(NodeChildEvent, 'NodeChildEvent', VOID, NodeEvent);
  initMetadataForClass(NodeChildAddedChildCollectionSplitEvent, 'NodeChildAddedChildCollectionSplitEvent', VOID, NodeChildEvent);
  initMetadataForClass(NodeChildAddedEvent, 'NodeChildAddedEvent', VOID, NodeChildEvent);
  initMetadataForClass(NodeChildAddedPropertySplitEvent, 'NodeChildAddedPropertySplitEvent', VOID, NodeChildEvent);
  initMetadataForClass(NodeChildCollectionMergedChildRemovedEvent, 'NodeChildCollectionMergedChildRemovedEvent', VOID, NodeChildEvent);
  initMetadataForClass(NodeChildRemovedEvent, 'NodeChildRemovedEvent', VOID, NodeChildEvent);
  initMetadataForClass(NodeChildSetEvent, 'NodeChildSetEvent', VOID, NodeChildEvent);
  initMetadataForClass(NodePropertyChangedEvent, 'NodePropertyChangedEvent', VOID, NodeEvent);
  initMetadataForClass(NodeDeletedInPropertyEvent, 'NodeDeletedInPropertyEvent', VOID, NodePropertyChangedEvent);
  initMetadataForClass(NodeInsertedInPropertyEvent, 'NodeInsertedInPropertyEvent', VOID, NodePropertyChangedEvent);
  initMetadataForClass(NodePropertyMergedChildRemovedEvent, 'NodePropertyMergedChildRemovedEvent', VOID, NodeChildEvent);
  initMetadataForClass(NodePropertySetEvent, 'NodePropertySetEvent', VOID, NodeEvent);
  initMetadataForObject(NodeUtil, 'NodeUtil');
  initMetadataForObject(Nodes, 'Nodes');
  function validate(operationRootId, op) {
  }
  function reset() {
  }
  initMetadataForInterface(OperationValidator, 'OperationValidator');
  initMetadataForClass(AddRemoveConsistencyValidator, 'AddRemoveConsistencyValidator', AddRemoveConsistencyValidator, VOID, [OperationValidator]);
  initMetadataForCompanion(Companion_48);
  initMetadataForClass(ErrorAppender, 'ErrorAppender');
  initMetadataForClass(MyEventStateHolder, 'MyEventStateHolder', VOID, EventStateHolder);
  initMetadataForCompanion(Companion_49);
  initMetadataForClass(EntityContextOperationsTracker, 'EntityContextOperationsTracker', VOID, VOID, [Disposable]);
  initMetadataForClass(EntityContextCommandProcessor$1, VOID, VOID, EntityContextOperationsTracker);
  initMetadataForClass(EntityContextCommandProcessor$addOperationValidator$$inlined$toDisposable$1, VOID, VOID, VOID, [Disposable]);
  initMetadataForClass(EntityContextCommandProcessor$appendToCurrentError$1, VOID, VOID, ErrorAppender);
  initMetadataForClass(EntityContextCommandProcessor$appendToGlobalError$1, VOID, VOID, ErrorAppender);
  initMetadataForClass(EntityContextCommandProcessor, 'EntityContextCommandProcessor', VOID, VOID, [Disposable]);
  initMetadataForClass(ModelOperationsTracker, 'ModelOperationsTracker', VOID, VOID, [ModelListener]);
  initMetadataForClass(MyModelOperationTracker, 'MyModelOperationTracker', MyModelOperationTracker, ModelOperationsTracker);
  initMetadataForCompanion(Companion_50);
  initMetadataForClass(EntityContextOperationsTracker$1, VOID, VOID, CollectionAdapter);
  initMetadataForClass(EntityContextOperationsTracker$2, VOID, VOID, VOID, [EntityContextListener]);
  initMetadataForCompanion(Companion_51);
  initMetadataForClass(MergeNavAndEmptyUndoGroupId, 'MergeNavAndEmptyUndoGroupId');
  initMetadataForClass(OtCommandEvent, 'OtCommandEvent');
  function onCommandStarted(event) {
  }
  function onOperationPerformed(op) {
  }
  function onCommandCommitted(op) {
  }
  function onExternalOperationStarted() {
  }
  function onExternalOperationPerformed(op) {
  }
  function onExternalOperationFailed() {
  }
  initMetadataForInterface(OtCommandListener, 'OtCommandListener');
  initMetadataForCompanion(Companion_52);
  initMetadataForClass(EntityAssemblyOperationBuilder, 'EntityAssemblyOperationBuilder');
  initMetadataForObject(EntityPrintOperationUtil, 'EntityPrintOperationUtil');
  initMetadataForClass(Descriptor, 'Descriptor', Descriptor);
  initMetadataForCompanion(Companion_53);
  initMetadataForClass(OperationCondition, 'OperationCondition');
  initMetadataForClass(LeafOperationsCollector, 'LeafOperationsCollector', VOID, OperationCondition);
  initMetadataForObject(OperationBuilder, 'OperationBuilder');
  initMetadataForObject(OperationConverter, 'OperationConverter');
  initMetadataForClass(OperationRootIdInfo, 'OperationRootIdInfo');
  initMetadataForInterface(RootOperation, 'RootOperation');
  function execute$default(model, nodeFactory, $super) {
    nodeFactory = nodeFactory === VOID ? RawNodeFactory_instance : nodeFactory;
    return $super === VOID ? this.y3x(model, nodeFactory) : $super.y3x.call(this, model, nodeFactory);
  }
  initMetadataForInterface(Operation, 'Operation');
  initMetadataForClass(BaseOperation, 'BaseOperation', VOID, VOID, [Operation]);
  initMetadataForClass(ChildOperation, 'ChildOperation', VOID, BaseOperation);
  initMetadataForInterface(WithConsecutiveOperation, 'WithConsecutiveOperation');
  initMetadataForClass(AddChildOperation, 'AddChildOperation', VOID, ChildOperation, [ChildOperation, WithConsecutiveOperation]);
  initMetadataForInterface(HasOperationTargetData, 'HasOperationTargetData');
  initMetadataForClass(CustomExecuteOperation, 'CustomExecuteOperation', VOID, BaseOperation);
  initMetadataForInterface(OperationContainer, 'OperationContainer');
  initMetadataForClass(TargetedOperation, 'TargetedOperation', VOID, CustomExecuteOperation, [HasOperationTargetData, CustomExecuteOperation, OperationContainer]);
  initMetadataForClass(ChangeChildOperation, 'ChangeChildOperation', VOID, TargetedOperation, [TargetedOperation, WithConsecutiveOperation]);
  initMetadataForClass(ChildOperationUtil, 'ChildOperationUtil', ChildOperationUtil);
  initMetadataForClass(EntityChildOperationData, 'EntityChildOperationData');
  initMetadataForClass(RemoveChildOperation, 'RemoveChildOperation', VOID, ChildOperation);
  initMetadataForClass(RootEntityOperation, 'RootEntityOperation', VOID, BaseOperation, [BaseOperation, RootOperation]);
  initMetadataForClass(AddRootOperation, 'AddRootOperation', VOID, RootEntityOperation, [RootEntityOperation, WithConsecutiveOperation]);
  initMetadataForClass(RootOperationsExecutorChecker, 'RootOperationsExecutorChecker', VOID, VOID, [EntityContextListener]);
  initMetadataForClass(AddRootOperationExecutor$installChecker$1, VOID, VOID, RootOperationsExecutorChecker);
  initMetadataForClass(BaseOperationExecutor, 'BaseOperationExecutor');
  initMetadataForClass(BaseAddOperationExecutor, 'BaseAddOperationExecutor', VOID, BaseOperationExecutor);
  initMetadataForClass(AddRootOperationExecutor, 'AddRootOperationExecutor', AddRootOperationExecutor, BaseAddOperationExecutor);
  initMetadataForClass(BuildRootOperation, 'BuildRootOperation', VOID, BaseOperation, [BaseOperation, RootOperation]);
  initMetadataForClass(ChangeRootEntityOperation, 'ChangeRootEntityOperation', VOID, TargetedOperation, [TargetedOperation, RootOperation, WithConsecutiveOperation]);
  initMetadataForClass(ChangeRootOperationExecutor$installChecker$1, VOID, VOID, RootOperationsExecutorChecker);
  initMetadataForClass(BaseRemoveOperationExecutor, 'BaseRemoveOperationExecutor', VOID, BaseOperationExecutor);
  initMetadataForClass(ChangeRootOperationExecutor, 'ChangeRootOperationExecutor', ChangeRootOperationExecutor, BaseRemoveOperationExecutor);
  initMetadataForClass(RemoveRootOperation, 'RemoveRootOperation', VOID, RootEntityOperation);
  initMetadataForClass(RootOperationData, 'RootOperationData');
  initMetadataForClass(RootOperationUtil, 'RootOperationUtil', RootOperationUtil);
  initMetadataForObject(RootOperationsExecutorUtil, 'RootOperationsExecutorUtil');
  initMetadataForClass(SafeBuildRootOperation, 'SafeBuildRootOperation', VOID, BuildRootOperation);
  initMetadataForClass(UnsafeBuildRootOperation, 'UnsafeBuildRootOperation', VOID, BuildRootOperation);
  initMetadataForClass(EntityDiffBuilder, 'EntityDiffBuilder');
  initMetadataForObject(EntityMessages, 'EntityMessages');
  initMetadataForClass(ModelBlobOperation, 'ModelBlobOperation', VOID, BaseOperation);
  initMetadataForClass(AddModelBlobOperation, 'AddModelBlobOperation', VOID, ModelBlobOperation, [ModelBlobOperation, WithConsecutiveOperation]);
  initMetadataForClass(ModelOperationsExecutorChecker, 'ModelOperationsExecutorChecker', VOID, VOID, [EntityContextListener]);
  initMetadataForClass(AddModelOperationExecutor$installChecker$1, VOID, VOID, ModelOperationsExecutorChecker);
  initMetadataForClass(AddModelOperationExecutor, 'AddModelOperationExecutor', AddModelOperationExecutor, BaseAddOperationExecutor);
  initMetadataForClass(ChangeModelBlobOperation, 'ChangeModelBlobOperation', VOID, TargetedOperation, [TargetedOperation, WithConsecutiveOperation]);
  initMetadataForClass(ChangeModelOperationExecutor$installChecker$1, VOID, VOID, ModelOperationsExecutorChecker);
  initMetadataForClass(ChangeModelOperationExecutor, 'ChangeModelOperationExecutor', ChangeModelOperationExecutor, BaseRemoveOperationExecutor);
  initMetadataForObject(ModelBlobMessages, 'ModelBlobMessages');
  initMetadataForClass(ModelBlobOperationData, 'ModelBlobOperationData');
  initMetadataForClass(ModelBlobOperationUtil, 'ModelBlobOperationUtil', ModelBlobOperationUtil);
  initMetadataForObject(ModelOperationsExecutorUtil, 'ModelOperationsExecutorUtil');
  initMetadataForClass(RemoveModelBlobOperation, 'RemoveModelBlobOperation', VOID, ModelBlobOperation);
  initMetadataForObject(DestroyOperationTransformer, 'DestroyOperationTransformer');
  initMetadataForClass(PathItem, 'PathItem');
  initMetadataForClass(EntityPathItem, 'EntityPathItem', VOID, PathItem);
  initMetadataForCompanion(Companion_54);
  initMetadataForClass(MoveOperation$containsRemoveMovingOperation$1, VOID, VOID, OperationCondition);
  initMetadataForClass(MoveOperation$containsRemoveNewParentOperation$1, VOID, VOID, OperationCondition);
  initMetadataForClass(MoveOperation$containsAddMovingOperation$1, VOID, VOID, OperationCondition);
  initMetadataForClass(MoveOperation, 'MoveOperation', VOID, BaseOperation, [BaseOperation, RootOperation]);
  initMetadataForObject(PathItemUtil, 'PathItemUtil');
  initMetadataForCompanion(Companion_55);
  initMetadataForClass(RolePathItem, 'RolePathItem', VOID, PathItem);
  initMetadataForClass(OrderedOperation, 'OrderedOperation');
  initMetadataForClass(RootOperationTransformer, 'RootOperationTransformer');
  initMetadataForCompanion(Companion_56);
  initMetadataForClass(RootPathItem, 'RootPathItem', VOID, PathItem);
  initMetadataForClass(EntityOperationsExecutorChecker, 'EntityOperationsExecutorChecker', VOID, VOID, [EntityContextListener]);
  initMetadataForClass(AddChildOperationExecutor$installChecker$1, VOID, VOID, EntityOperationsExecutorChecker);
  initMetadataForClass(AddChildOperationExecutor, 'AddChildOperationExecutor', AddChildOperationExecutor, BaseAddOperationExecutor);
  initMetadataForClass(ChangeChildOperationExecutor$installChecker$1, VOID, VOID, EntityOperationsExecutorChecker);
  initMetadataForClass(ChangeChildOperationExecutor, 'ChangeChildOperationExecutor', ChangeChildOperationExecutor, BaseRemoveOperationExecutor);
  initMetadataForCompanion(Companion_57);
  initMetadataForClass(ChildSetOperation, 'ChildSetOperation', VOID, TargetedOperation);
  initMetadataForObject(EntityOperationsExecutorUtil, 'EntityOperationsExecutorUtil');
  initMetadataForClass(SetPropertyOperation, 'SetPropertyOperation', VOID, TargetedOperation);
  initMetadataForCompanion(Companion_58);
  initMetadataForClass(SetReferenceOperation, 'SetReferenceOperation', VOID, TargetedOperation);
  initMetadataForClass(MainOpPos, 'MainOpPos', VOID, Enum);
  initMetadataForInterface(IndexedOperation, 'IndexedOperation', VOID, VOID, [Operation]);
  initMetadataForInterface(IndexedAddOperation, 'IndexedAddOperation', VOID, VOID, [IndexedOperation]);
  initMetadataForClass(IndexedOperationTransformer, 'IndexedOperationTransformer', IndexedOperationTransformer);
  initMetadataForInterface(IndexedRemoveOperation, 'IndexedRemoveOperation', VOID, VOID, [IndexedOperation]);
  initMetadataForInterface(IndexedReplaceOperation, 'IndexedReplaceOperation', VOID, VOID, [IndexedOperation]);
  initMetadataForClass(Priority, 'Priority', VOID, Enum);
  initMetadataForInterface(Accumulator, 'Accumulator');
  initMetadataForClass(AnnotationData, 'AnnotationData', AnnotationData);
  initMetadataForClass(MergerBasedAccumulator, 'MergerBasedAccumulator', VOID, VOID, [Accumulator]);
  initMetadataForClass(AddChangeRemoveAccumulator, 'AddChangeRemoveAccumulator', VOID, MergerBasedAccumulator);
  initMetadataForClass(RootOperationsAccumulator, 'RootOperationsAccumulator', VOID, AddChangeRemoveAccumulator);
  initMetadataForClass(EntityChildAccumulator, 'EntityChildAccumulator', VOID, AddChangeRemoveAccumulator);
  initMetadataForClass(ModelAccumulator, 'ModelAccumulator', VOID, AddChangeRemoveAccumulator);
  initMetadataForCompanion(Companion_59);
  initMetadataForClass(AccumulatorBasedMerger, 'AccumulatorBasedMerger', AccumulatorBasedMerger);
  initMetadataForClass(AddChangeRemoveAccumulator$addOp$1);
  initMetadataForClass(ChangeModelAccumulator, 'ChangeModelAccumulator', ChangeModelAccumulator, MergerBasedAccumulator);
  initMetadataForClass(TargetedOperationAccumulator, 'TargetedOperationAccumulator', VOID, MergerBasedAccumulator);
  initMetadataForClass(EntityChildSetAccumulator, 'EntityChildSetAccumulator', VOID, TargetedOperationAccumulator);
  initMetadataForClass(ReferenceOperationUtil, 'ReferenceOperationUtil', ReferenceOperationUtil);
  initMetadataForClass(EntityReferenceData, 'EntityReferenceData');
  initMetadataForClass(EntityReferenceAccumulator, 'EntityReferenceAccumulator', EntityReferenceAccumulator, AddChangeRemoveAccumulator);
  initMetadataForClass(OperationsInfo, 'OperationsInfo');
  initMetadataForClass(SetPropertyAccumulator, 'SetPropertyAccumulator', VOID, TargetedOperationAccumulator);
  initMetadataForClass(SetReferenceAccumulator, 'SetReferenceAccumulator', VOID, TargetedOperationAccumulator);
  initMetadataForClass(SetValueAccumulator, 'SetValueAccumulator', SetValueAccumulator, VOID, [Accumulator]);
  initMetadataForClass(BaseMergeOperationsRule, 'BaseMergeOperationsRule');
  initMetadataForClass(BaseDataOperationRule, 'BaseDataOperationRule', VOID, BaseMergeOperationsRule);
  initMetadataForClass(BaseMutuallyInverseOperationRule, 'BaseMutuallyInverseOperationRule', VOID, BaseDataOperationRule);
  initMetadataForClass(EntityChildAddRemoveRule, 'EntityChildAddRemoveRule', EntityChildAddRemoveRule, BaseMutuallyInverseOperationRule);
  initMetadataForClass(MergeContainerOperationsRule, 'MergeContainerOperationsRule', VOID, BaseMergeOperationsRule);
  initMetadataForClass(MergeCompositeOperationsRule, 'MergeCompositeOperationsRule', VOID, MergeContainerOperationsRule);
  initMetadataForClass(MergeSetValueOperationsRule, 'MergeSetValueOperationsRule', MergeSetValueOperationsRule, BaseMergeOperationsRule);
  initMetadataForClass(MergeTargetedOperationsRule, 'MergeTargetedOperationsRule', VOID, MergeContainerOperationsRule);
  initMetadataForClass(ModelAddRemoveRule, 'ModelAddRemoveRule', ModelAddRemoveRule, BaseMutuallyInverseOperationRule);
  initMetadataForClass(NodeChildAddRemoveRule, 'NodeChildAddRemoveRule', NodeChildAddRemoveRule, BaseMutuallyInverseOperationRule);
  initMetadataForClass(NodeChildAddReplaceRule, 'NodeChildAddReplaceRule', NodeChildAddReplaceRule, BaseDataOperationRule);
  initMetadataForClass(NodeChildReplaceRemoveRule, 'NodeChildReplaceRemoveRule', NodeChildReplaceRemoveRule, BaseDataOperationRule);
  initMetadataForClass(NodeChildReplaceReplaceRule, 'NodeChildReplaceReplaceRule', NodeChildReplaceReplaceRule, BaseDataOperationRule);
  initMetadataForClass(NopOperationRule, 'NopOperationRule', NopOperationRule, BaseMergeOperationsRule);
  initMetadataForClass(RootAddRemoveRule, 'RootAddRemoveRule', RootAddRemoveRule, BaseMutuallyInverseOperationRule);
  initMetadataForCompanion(Companion_60);
  initMetadataForClass(SimpleAnnotatorPreservingOperationsMerger, 'SimpleAnnotatorPreservingOperationsMerger');
  initMetadataForClass(NodeAssemblyOperationBuilder, 'NodeAssemblyOperationBuilder');
  initMetadataForObject(OperationBuilder_0, 'OperationBuilder');
  initMetadataForClass(BaseListItemOperation, 'BaseListItemOperation', VOID, BaseOperation, [BaseOperation, IndexedOperation]);
  initMetadataForClass(ChildOperation_0, 'ChildOperation', VOID, BaseListItemOperation);
  initMetadataForClass(AddChildOperation_0, 'AddChildOperation', VOID, ChildOperation_0, [ChildOperation_0, IndexedAddOperation, WithConsecutiveOperation]);
  initMetadataForClass(ChangeChildOperation_0, 'ChangeChildOperation', VOID, TargetedOperation, [TargetedOperation, WithConsecutiveOperation]);
  initMetadataForObject(ChildOperationMessages, 'ChildOperationMessages');
  initMetadataForClass(NodeChildOperationData, 'NodeChildOperationData');
  initMetadataForClass(RemoveChildOperation_0, 'RemoveChildOperation', VOID, ChildOperation_0, [ChildOperation_0, IndexedRemoveOperation]);
  initMetadataForCompanion(Companion_61);
  initMetadataForClass(ReplaceChildOperation, 'ReplaceChildOperation', VOID, BaseListItemOperation, [BaseListItemOperation, IndexedReplaceOperation]);
  initMetadataForClass(NodeDiffBuilder, 'NodeDiffBuilder');
  initMetadataForClass(InPlaceNodeDiffBuilder, 'InPlaceNodeDiffBuilder', VOID, NodeDiffBuilder);
  initMetadataForClass(ModifiedSource$addChildAndSplitChildCollection$disposable$1, VOID, VOID, ModelAdapter);
  initMetadataForClass(ModifiedSource$mergeChildCollectionAndRemoveChild$disposable$1, VOID, VOID, ModelAdapter);
  initMetadataForClass(ModifiedSource, 'ModifiedSource');
  initMetadataForObject(NodeDiff, 'NodeDiff');
  initMetadataForClass(MyTask, 'MyTask');
  initMetadataForObject(NodeInspectionUtil, 'NodeInspectionUtil');
  initMetadataForClass(Element_1, 'Element');
  initMetadataForCompanion(Companion_62);
  initMetadataForClass(NodePath, 'NodePath');
  initMetadataForClass(NodeWithRegistry, 'NodeWithRegistry');
  initMetadataForClass(SplitMergeAwareNodeDiffBuilder$MoveToData$Companion$REVERSE_PARENT_ORDER_COMPARATOR$1, VOID, VOID, VOID, [Comparator]);
  initMetadataForCompanion(Companion_63);
  initMetadataForClass(MoveFromData, 'MoveFromData');
  initMetadataForClass(MoveToData, 'MoveToData');
  initMetadataForClass(MyAttachedNode, 'MyAttachedNode', VOID, NodeWithRegistry);
  initMetadataForClass(MyNotAttachedNode, 'MyNotAttachedNode', VOID, NodeWithRegistry);
  initMetadataForClass(SplitMergeAwareNodeDiffBuilder, 'SplitMergeAwareNodeDiffBuilder', VOID, NodeDiffBuilder);
  initMetadataForObject(ModelOperationConverter, 'ModelOperationConverter');
  initMetadataForClass(NodeOperationsExecutorChecker, 'NodeOperationsExecutorChecker', VOID, ModelAdapter);
  initMetadataForClass(NodeChildOperationsExecutorChecker, 'NodeChildOperationsExecutorChecker', VOID, NodeOperationsExecutorChecker);
  initMetadataForClass(AddChildOperationExecutor$installChecker$1_0, VOID, VOID, NodeChildOperationsExecutorChecker);
  initMetadataForClass(AddChildOperationExecutor_0, 'AddChildOperationExecutor', AddChildOperationExecutor_0, BaseAddOperationExecutor);
  initMetadataForClass(ChangeChildOperationExecutor_0, 'ChangeChildOperationExecutor', ChangeChildOperationExecutor_0);
  initMetadataForClass(ChangePropertyOperation, 'ChangePropertyOperation', VOID, TargetedOperation);
  initMetadataForClass(ChildListOperation, 'ChildListOperation', VOID, TargetedOperation);
  initMetadataForObject(NodeOperationsExecutorUtil, 'NodeOperationsExecutorUtil');
  initMetadataForClass(RemoveChildOperationExecutor$installChecker$1, VOID, VOID, NodeChildOperationsExecutorChecker);
  initMetadataForClass(RemoveChildOperationExecutor, 'RemoveChildOperationExecutor', RemoveChildOperationExecutor, BaseRemoveOperationExecutor);
  initMetadataForClass(ReplaceChildOperationExecutor$installChecker$1, VOID, VOID, NodeOperationsExecutorChecker);
  initMetadataForClass(ReplaceChildOperationExecutor, 'ReplaceChildOperationExecutor', ReplaceChildOperationExecutor, BaseOperationExecutor);
  initMetadataForCompanion(Companion_64);
  initMetadataForClass(SetModelOperation, 'SetModelOperation', VOID, TargetedOperation);
  initMetadataForClass(BaseAddChildSplitOperation, 'BaseAddChildSplitOperation', VOID, BaseOperation, [BaseOperation, IndexedAddOperation]);
  initMetadataForClass(AddChildSplitChildCollectionOperation, 'AddChildSplitChildCollectionOperation', VOID, BaseAddChildSplitOperation);
  initMetadataForCompanion(Companion_65);
  initMetadataForClass(AddChildSplitPropertyOperation, 'AddChildSplitPropertyOperation', VOID, BaseAddChildSplitOperation);
  initMetadataForObject(AssertionUtil, 'AssertionUtil');
  initMetadataForCompanion(Companion_66);
  initMetadataForCompanion(Companion_67);
  initMetadataForClass(BaseMergeRemoveChildOperation, 'BaseMergeRemoveChildOperation', VOID, BaseOperation, [BaseOperation, IndexedRemoveOperation]);
  initMetadataForClass(MergeChildCollectionRemoveChildOperation, 'MergeChildCollectionRemoveChildOperation', VOID, BaseMergeRemoveChildOperation);
  initMetadataForClass(MergePropertyRemoveChildOperation, 'MergePropertyRemoveChildOperation', VOID, BaseMergeRemoveChildOperation);
  initMetadataForClass(NodeOperation, 'NodeOperation');
  initMetadataForClass(SplitMergeOperationsUtil$getChildCollectionCompositeOperation$provider$1);
  initMetadataForClass(SplitMergeOperationsUtil$getPropertyCompositeOperation$provider$1);
  initMetadataForClass(SplitMergeOperationsUtil$findListOperation$nodeOperationCondition$1, VOID, VOID, OperationCondition);
  initMetadataForClass(SplitMergeOperationsUtil$findStringOperation$nodeOperationCondition$1, VOID, VOID, OperationCondition);
  initMetadataForObject(SplitMergeOperationsUtil, 'SplitMergeOperationsUtil');
  initMetadataForClass(AnnotatedOperation, 'AnnotatedOperation', VOID, BaseOperation, [BaseOperation, OperationContainer]);
  initMetadataForCompanion(Companion_68);
  initMetadataForClass(CompositeOperation, 'CompositeOperation', VOID, CustomExecuteOperation, [CustomExecuteOperation, OperationContainer]);
  initMetadataForCompanion(Companion_69);
  initMetadataForClass(ExecutionResult, 'ExecutionResult');
  initMetadataForClass(NoSubjectOperation, 'NoSubjectOperation', VOID, BaseOperation);
  initMetadataForClass(NopOperation, 'NopOperation', NopOperation, NoSubjectOperation);
  initMetadataForClass(OperationKind, 'OperationKind', VOID, Enum);
  initMetadataForObject(PrintOperationUtil, 'PrintOperationUtil');
  initMetadataForClass(AnnotatedOperationPersister, 'AnnotatedOperationPersister', AnnotatedOperationPersister);
  initMetadataForClass(CompositeOperationPersister, 'CompositeOperationPersister', CompositeOperationPersister);
  initMetadataForClass(NopOperationPersister, 'NopOperationPersister', NopOperationPersister);
  initMetadataForClass(PersisterNotFoundException, 'PersisterNotFoundException', VOID, RuntimeException);
  initMetadataForClass(OperationPersistenceContext, 'OperationPersistenceContext');
  initMetadataForClass(TargetedOperationPersister, 'TargetedOperationPersister');
  initMetadataForClass(DictionaryAwarePersister, 'DictionaryAwarePersister');
  initMetadataForClass(DictionaryAwareDeserializer, 'DictionaryAwareDeserializer', VOID, DictionaryAwarePersister);
  initMetadataForClass(DictionaryAwareSerializer, 'DictionaryAwareSerializer', VOID, DictionaryAwarePersister);
  initMetadataForClass(ChildOperationPersister, 'ChildOperationPersister');
  initMetadataForClass(AddChildOperationPersister, 'AddChildOperationPersister', AddChildOperationPersister, ChildOperationPersister);
  initMetadataForClass(ChangeChildOperationPersister, 'ChangeChildOperationPersister', ChangeChildOperationPersister);
  initMetadataForClass(RemoveChildOperationPersister, 'RemoveChildOperationPersister', RemoveChildOperationPersister, ChildOperationPersister);
  initMetadataForClass(AddRootOperationPersister, 'AddRootOperationPersister', AddRootOperationPersister);
  initMetadataForClass(Deserializer, 'Deserializer', VOID, DictionaryAwareDeserializer);
  initMetadataForClass(Serializer, 'Serializer', VOID, DictionaryAwareSerializer);
  initMetadataForClass(BuildRootOperationPersister, 'BuildRootOperationPersister', BuildRootOperationPersister);
  initMetadataForClass(ChangeRootEntityOperationPersister, 'ChangeRootEntityOperationPersister', ChangeRootEntityOperationPersister);
  initMetadataForClass(RemoveRootOperationPersister, 'RemoveRootOperationPersister', RemoveRootOperationPersister);
  initMetadataForClass(MetaIdPersister, 'MetaIdPersister', VOID, VOID, [Persister]);
  initMetadataForClass(EntityConceptIdPersister, 'EntityConceptIdPersister', EntityConceptIdPersister, MetaIdPersister);
  initMetadataForClass(BaseIdPersistenceContext, 'BaseIdPersistenceContext');
  initMetadataForClass(EntityIdPersistenceContext, 'EntityIdPersistenceContext', EntityIdPersistenceContext, BaseIdPersistenceContext);
  initMetadataForClass(RoleIdPersister, 'RoleIdPersister', VOID, MetaIdPersister);
  initMetadataForClass(EntityIdPersisters$childIdPersister$1, VOID, VOID, RoleIdPersister);
  initMetadataForClass(EntityIdPersisters$referenceIdPersister$1, VOID, VOID, RoleIdPersister);
  initMetadataForClass(EntityIdPersisters$entityReferencePersister$1, VOID, VOID, VOID, [Persister]);
  initMetadataForObject(EntityIdPersisters, 'EntityIdPersisters');
  initMetadataForClass(DefaultIdPersister, 'DefaultIdPersister', VOID, VOID, [Persister]);
  initMetadataForClass(PrivateEntityIdPersisters$idPersister$1, VOID, VOID, DefaultIdPersister);
  initMetadataForClass(PrivateEntityIdPersisters$propertyIdPersister$1, VOID, VOID, DefaultIdPersister);
  initMetadataForClass(PrivateEntityIdPersisters$modelBlobIdPersister$1, VOID, VOID, DefaultIdPersister);
  initMetadataForObject(PrivateEntityIdPersisters, 'PrivateEntityIdPersisters');
  initMetadataForClass(ModelBlobOperationPersister, 'ModelBlobOperationPersister');
  initMetadataForClass(AddModelBlobOperationPersister, 'AddModelBlobOperationPersister', AddModelBlobOperationPersister, ModelBlobOperationPersister);
  initMetadataForClass(ChangeModelBlobOperationPersister, 'ChangeModelBlobOperationPersister', VOID, TargetedOperationPersister);
  initMetadataForClass(RemoveModelBlobOperationPersister, 'RemoveModelBlobOperationPersister', RemoveModelBlobOperationPersister, ModelBlobOperationPersister);
  initMetadataForObject(EntityIdModelKinds, 'EntityIdModelKinds');
  initMetadataForObject(EntityModelKinds, 'EntityModelKinds');
  initMetadataForClass(MoveOperationPersister, 'MoveOperationPersister', MoveOperationPersister);
  initMetadataForCompanion(Companion_70);
  initMetadataForClass(EntityOperationPersistenceContext, 'EntityOperationPersistenceContext', EntityOperationPersistenceContext, OperationPersistenceContext);
  initMetadataForClass(ChildSetOperationPersister, 'ChildSetOperationPersister', ChildSetOperationPersister);
  initMetadataForClass(SetPropertyOperationPersister, 'SetPropertyOperationPersister', SetPropertyOperationPersister);
  initMetadataForClass(SetReferenceOperationPersister, 'SetReferenceOperationPersister', SetReferenceOperationPersister);
  initMetadataForClass(MyPersister, 'MyPersister');
  initMetadataForClass(IdCompressor, 'IdCompressor');
  initMetadataForClass(SelfUpdatingIdCompressor, 'SelfUpdatingIdCompressor', VOID, IdCompressor);
  initMetadataForClass(BulkUpdateIdCompressor, 'BulkUpdateIdCompressor', VOID, SelfUpdatingIdCompressor);
  initMetadataForClass(CompressingIdPersister, 'CompressingIdPersister', VOID, VOID, [Persister]);
  initMetadataForCompanion(Companion_71);
  initMetadataForClass(DefaultSelfUpdatingIdCompressor, 'DefaultSelfUpdatingIdCompressor', DefaultSelfUpdatingIdCompressor_init_$Create$, BulkUpdateIdCompressor);
  initMetadataForClass(NullableIdPersister, 'NullableIdPersister', VOID, VOID, [NonNullPersister]);
  initMetadataForClass(IdPersisters$ENTITY_ID_PERSISTER$1, VOID, VOID, NullableIdPersister);
  initMetadataForClass(IdPersisters$NODE_ID_PERSISTER$1, VOID, VOID, NullableIdPersister);
  initMetadataForObject(IdPersisters, 'IdPersisters');
  initMetadataForCompanion(Companion_72);
  initMetadataForClass(ShortcutConverter, 'ShortcutConverter', ShortcutConverter);
  initMetadataForClass(UpdatableIdCompressor, 'UpdatableIdCompressor', UpdatableIdCompressor, IdCompressor);
  initMetadataForClass(ModelKind, 'ModelKind');
  initMetadataForClass(ChildOperationPersister_0, 'ChildOperationPersister');
  initMetadataForClass(AddChildOperationPersister_0, 'AddChildOperationPersister', AddChildOperationPersister_0, ChildOperationPersister_0);
  initMetadataForClass(ChangeChildOperationPersister_0, 'ChangeChildOperationPersister', ChangeChildOperationPersister_0);
  initMetadataForClass(RemoveChildOperationPersister_0, 'RemoveChildOperationPersister', RemoveChildOperationPersister_0, ChildOperationPersister_0);
  initMetadataForClass(ReplaceChildOperationPersister, 'ReplaceChildOperationPersister', ReplaceChildOperationPersister);
  initMetadataForClass(NodeConceptIdPersister, 'NodeConceptIdPersister', NodeConceptIdPersister, MetaIdPersister);
  initMetadataForClass(NodeIdPersistenceContext, 'NodeIdPersistenceContext', NodeIdPersistenceContext, BaseIdPersistenceContext);
  initMetadataForClass(NodeIdPersisters$childIdPersister$1, VOID, VOID, RoleIdPersister);
  initMetadataForObject(NodeIdPersisters, 'NodeIdPersisters');
  initMetadataForClass(PrivateNodeIdPersisters$propertyIdPersister$basePersister$1, VOID, VOID, DefaultIdPersister);
  initMetadataForObject(PrivateNodeIdPersisters, 'PrivateNodeIdPersisters');
  initMetadataForObject(NodeIdModelKinds, 'NodeIdModelKinds');
  initMetadataForObject(NodeModelKinds, 'NodeModelKinds');
  initMetadataForClass(ChangePropertyOperationPersister, 'ChangePropertyOperationPersister', ChangePropertyOperationPersister);
  initMetadataForClass(ChildListOperationPersister, 'ChildListOperationPersister', VOID, TargetedOperationPersister);
  initMetadataForClass(NodeOperationsPersistenceContext, 'NodeOperationsPersistenceContext', VOID, OperationPersistenceContext);
  initMetadataForClass(SetModelOperationPersister, 'SetModelOperationPersister', SetModelOperationPersister, TargetedOperationPersister);
  initMetadataForClass(BaseAddChildSplitOperationPersister, 'BaseAddChildSplitOperationPersister');
  initMetadataForClass(AddChildSplitChildCollectionOperationPersister, 'AddChildSplitChildCollectionOperationPersister', AddChildSplitChildCollectionOperationPersister, BaseAddChildSplitOperationPersister);
  initMetadataForClass(AddChildSplitPropertyOperationPersister, 'AddChildSplitPropertyOperationPersister', AddChildSplitPropertyOperationPersister, BaseAddChildSplitOperationPersister);
  initMetadataForClass(BaseMergeRemoveChildOperationPersister, 'BaseMergeRemoveChildOperationPersister');
  initMetadataForClass(DeserializationData, 'DeserializationData');
  initMetadataForClass(MergeChildCollectionRemoveChildOperationPersister, 'MergeChildCollectionRemoveChildOperationPersister', MergeChildCollectionRemoveChildOperationPersister, BaseMergeRemoveChildOperationPersister);
  initMetadataForClass(MergePropertyRemoveChildOperationPersister, 'MergePropertyRemoveChildOperationPersister', MergePropertyRemoveChildOperationPersister, BaseMergeRemoveChildOperationPersister);
  initMetadataForClass(ChangeSetOperationPersister, 'ChangeSetOperationPersister');
  initMetadataForClass(AddToSetOperationPersister, 'AddToSetOperationPersister', VOID, ChangeSetOperationPersister);
  initMetadataForClass(RemoveFromSetOperationPersister, 'RemoveFromSetOperationPersister', VOID, ChangeSetOperationPersister);
  initMetadataForCompanion(Companion_73);
  initMetadataForClass(DeleteTextOperationPersister, 'DeleteTextOperationPersister', DeleteTextOperationPersister);
  initMetadataForClass(InsertTextOperationsPersister, 'InsertTextOperationsPersister', InsertTextOperationsPersister);
  initMetadataForClass(SetValueOperationPersister, 'SetValueOperationPersister');
  initMetadataForClass(ChangeSetOperation, 'ChangeSetOperation', VOID, BaseOperation);
  initMetadataForClass(AddToSetOperation, 'AddToSetOperation', VOID, ChangeSetOperation);
  initMetadataForClass(RemoveFromSetOperation, 'RemoveFromSetOperation', VOID, ChangeSetOperation);
  initMetadataForClass(TextOperation, 'TextOperation', VOID, BaseOperation, [BaseOperation, IndexedOperation]);
  initMetadataForClass(DeleteTextOperation, 'DeleteTextOperation', VOID, TextOperation, [TextOperation, IndexedRemoveOperation]);
  initMetadataForClass(InsertTextOperation, 'InsertTextOperation', VOID, TextOperation, [TextOperation, IndexedAddOperation]);
  initMetadataForObject(TextOperationUtil, 'TextOperationUtil');
  initMetadataForClass(SetValueOperation, 'SetValueOperation', VOID, BaseOperation);
  initMetadataForClass(OtTransactionState, 'OtTransactionState', VOID, Enum);
  initMetadataForClass(UndoStackImpl, 'UndoStackImpl');
  initMetadataForClass(UndoCommandListener, 'UndoCommandListener', VOID, VOID, [OtCommandListener]);
  initMetadataForClass(BaseUndoManager$addStateProvider$$inlined$toDisposable$1, VOID, VOID, VOID, [Disposable]);
  initMetadataForClass(BaseUndoManager, 'BaseUndoManager', VOID, VOID, [Disposable]);
  initMetadataForInterface(OtAware, 'OtAware');
  initMetadataForClass(SimpleUndoStackId, 'SimpleUndoStackId');
  initMetadataForClass(Kind, 'Kind', VOID, Enum);
  initMetadataForClass(UndoRejectionInfo, 'UndoRejectionInfo');
  initMetadataForCompanion(Companion_74);
  initMetadataForClass(UndoState, 'UndoState');
  initMetadataForObject(UndoUtils, 'UndoUtils');
  initMetadataForClass(UndoableCommand, 'UndoableCommand');
  initMetadataForClass(UndoableCommandData, 'UndoableCommandData');
  initMetadataForClass(UndoableCommandDataBuilder, 'UndoableCommandDataBuilder');
  initMetadataForClass(Kind_0, 'Kind', VOID, Enum);
  initMetadataForClass(UndoableTransaction, 'UndoableTransaction');
  initMetadataForInterface(ViewStateProvider, 'ViewStateProvider');
  initMetadataForClass(UndoCommandType, 'UndoCommandType', VOID, Enum);
  initMetadataForClass(SingleStackUndoManager$simpleStateProperty$1, VOID, VOID, DerivedProperty);
  initMetadataForClass(SingleStackUndoManager, 'SingleStackUndoManager', VOID, BaseUndoManager);
  initMetadataForClass(Command, 'Command');
  initMetadataForClass(CommandId, 'CommandId', CommandId_init_$Create$, BaseId);
  initMetadataForClass(LoadCommandId, 'LoadCommandId');
  initMetadataForCompanion(Companion_75);
  initMetadataForClass(OtOperationRecord, 'OtOperationRecord');
  initMetadataForClass(RootCommandId, 'RootCommandId');
  initMetadataForCompanion(Companion_76);
  initMetadataForClass(RoleIdFlag, 'RoleIdFlag', VOID, Enum);
  initMetadataForClass(AdditionalModelContext, 'AdditionalModelContext', AdditionalModelContext);
  initMetadataForClass(EntityWrapper$1, VOID, VOID, DerivedProperty);
  initMetadataForClass(EntityWrapper, 'EntityWrapper');
  initMetadataForClass(NodeWrapper$parentProperty$1, VOID, VOID, DerivedProperty);
  initMetadataForClass(NodeWrapper$propertyByStringProperty$1, VOID, VOID, BaseReadableProperty, [BaseReadableProperty, Property]);
  initMetadataForClass(NodeWrapper, 'NodeWrapper');
  initMetadataForClass(NodeWrapperFactory, 'NodeWrapperFactory');
  initMetadataForClass(DefaultLoadingPeer, 'DefaultLoadingPeer');
  initMetadataForCompanion(Companion_77);
  initMetadataForClass(WrapperContext$1);
  initMetadataForClass(WrapperContext$modelAttachListener$1);
  initMetadataForClass(WrapperContext$watchModel$disposable$1);
  initMetadataForClass(WrapperContext$put$$inlined$toDisposable$1, VOID, VOID, VOID, [Disposable]);
  initMetadataForClass(WrapperContext, 'WrapperContext', VOID, VOID, [Disposable]);
  initMetadataForClass(WrapperContextKey, 'WrapperContextKey');
  initMetadataForObject(WrapperContextService, 'WrapperContextService', VOID, VOID, [Key_5]);
  function onReferencedEntityAdded() {
  }
  function onReferencedEntityRemoved() {
  }
  initMetadataForInterface(ReferenceListener, 'ReferenceListener');
  initMetadataForInterface(SerializationStrategy, 'SerializationStrategy');
  initMetadataForInterface(DeserializationStrategy, 'DeserializationStrategy');
  initMetadataForInterface(KSerializer, 'KSerializer', VOID, VOID, [SerializationStrategy, DeserializationStrategy]);
  initMetadataForClass(ContextualSerializer, 'ContextualSerializer', VOID, VOID, [KSerializer]);
  initMetadataForClass(AbstractPolymorphicSerializer, 'AbstractPolymorphicSerializer', VOID, VOID, [KSerializer]);
  initMetadataForClass(PolymorphicSerializer, 'PolymorphicSerializer', VOID, AbstractPolymorphicSerializer);
  initMetadataForClass(SealedClassSerializer$$inlined$groupingBy$1);
  initMetadataForClass(SealedClassSerializer, 'SealedClassSerializer', VOID, AbstractPolymorphicSerializer);
  initMetadataForInterface(BinaryFormat, 'BinaryFormat');
  initMetadataForInterface(StringFormat, 'StringFormat');
  initMetadataForClass(SerializationException, 'SerializationException', SerializationException_init_$Create$, IllegalArgumentException);
  initMetadataForClass(UnknownFieldException, 'UnknownFieldException', VOID, SerializationException);
  initMetadataForClass(MissingFieldException, 'MissingFieldException', VOID, SerializationException);
  function get_isNullable() {
    return false;
  }
  function get_isInline() {
    return false;
  }
  function get_annotations() {
    return emptyList();
  }
  initMetadataForInterface(SerialDescriptor, 'SerialDescriptor');
  initMetadataForClass(ContextDescriptor, 'ContextDescriptor', VOID, VOID, [SerialDescriptor]);
  initMetadataForClass(elementNames$1);
  initMetadataForClass(elementNames$$inlined$Iterable$1);
  initMetadataForClass(elementDescriptors$1);
  initMetadataForClass(elementDescriptors$$inlined$Iterable$1);
  initMetadataForClass(ClassSerialDescriptorBuilder, 'ClassSerialDescriptorBuilder');
  initMetadataForInterface(CachedNames, 'CachedNames');
  initMetadataForClass(SerialDescriptorImpl, 'SerialDescriptorImpl', VOID, VOID, [SerialDescriptor, CachedNames]);
  initMetadataForClass(SerialKind, 'SerialKind');
  initMetadataForClass(PrimitiveKind, 'PrimitiveKind', VOID, SerialKind);
  initMetadataForObject(BOOLEAN, 'BOOLEAN', VOID, PrimitiveKind);
  initMetadataForObject(BYTE, 'BYTE', VOID, PrimitiveKind);
  initMetadataForObject(CHAR, 'CHAR', VOID, PrimitiveKind);
  initMetadataForObject(SHORT, 'SHORT', VOID, PrimitiveKind);
  initMetadataForObject(INT, 'INT', VOID, PrimitiveKind);
  initMetadataForObject(LONG, 'LONG', VOID, PrimitiveKind);
  initMetadataForObject(FLOAT, 'FLOAT', VOID, PrimitiveKind);
  initMetadataForObject(DOUBLE, 'DOUBLE', VOID, PrimitiveKind);
  initMetadataForObject(STRING, 'STRING', VOID, PrimitiveKind);
  initMetadataForObject(ENUM, 'ENUM', VOID, SerialKind);
  initMetadataForObject(CONTEXTUAL, 'CONTEXTUAL', VOID, SerialKind);
  initMetadataForClass(StructureKind, 'StructureKind', VOID, SerialKind);
  initMetadataForObject(CLASS, 'CLASS', VOID, StructureKind);
  initMetadataForObject(LIST, 'LIST', VOID, StructureKind);
  initMetadataForObject(MAP, 'MAP', VOID, StructureKind);
  initMetadataForObject(OBJECT, 'OBJECT', VOID, StructureKind);
  initMetadataForClass(PolymorphicKind, 'PolymorphicKind', VOID, SerialKind);
  initMetadataForObject(SEALED_0, 'SEALED', VOID, PolymorphicKind);
  initMetadataForObject(OPEN, 'OPEN', VOID, PolymorphicKind);
  function decodeSerializableValue(deserializer) {
    return deserializer.j59(this);
  }
  initMetadataForInterface(Decoder, 'Decoder');
  function decodeSequentially() {
    return false;
  }
  function decodeCollectionSize(descriptor) {
    return -1;
  }
  function decodeSerializableElement$default(descriptor, index, deserializer, previousValue, $super) {
    previousValue = previousValue === VOID ? null : previousValue;
    return $super === VOID ? this.s5c(descriptor, index, deserializer, previousValue) : $super.s5c.call(this, descriptor, index, deserializer, previousValue);
  }
  initMetadataForInterface(CompositeDecoder, 'CompositeDecoder');
  initMetadataForClass(AbstractDecoder, 'AbstractDecoder', VOID, VOID, [Decoder, CompositeDecoder]);
  function encodeNotNullMark() {
  }
  function beginCollection(descriptor, collectionSize) {
    return this.g5c(descriptor);
  }
  function encodeSerializableValue(serializer, value) {
    serializer.i59(this, value);
  }
  function encodeNullableSerializableValue(serializer, value) {
    var isNullabilitySupported = serializer.v58().i5a();
    if (isNullabilitySupported) {
      return this.h59(isInterface(serializer, SerializationStrategy) ? serializer : THROW_CCE(), value);
    }
    if (value == null) {
      this.a5d();
    } else {
      this.z5d();
      this.h59(serializer, value);
    }
  }
  initMetadataForInterface(Encoder, 'Encoder');
  function shouldEncodeElementDefault(descriptor, index) {
    return true;
  }
  initMetadataForInterface(CompositeEncoder, 'CompositeEncoder');
  initMetadataForClass(AbstractEncoder, 'AbstractEncoder', VOID, VOID, [Encoder, CompositeEncoder]);
  initMetadataForObject(NothingSerializer_0, 'NothingSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(DurationSerializer, 'DurationSerializer', VOID, VOID, [KSerializer]);
  initMetadataForClass(ListLikeDescriptor, 'ListLikeDescriptor', VOID, VOID, [SerialDescriptor]);
  initMetadataForClass(ArrayListClassDesc, 'ArrayListClassDesc', VOID, ListLikeDescriptor);
  initMetadataForClass(LinkedHashSetClassDesc, 'LinkedHashSetClassDesc', VOID, ListLikeDescriptor);
  initMetadataForClass(HashSetClassDesc, 'HashSetClassDesc', VOID, ListLikeDescriptor);
  initMetadataForClass(MapLikeDescriptor, 'MapLikeDescriptor', VOID, VOID, [SerialDescriptor]);
  initMetadataForClass(HashMapClassDesc, 'HashMapClassDesc', VOID, MapLikeDescriptor);
  initMetadataForClass(LinkedHashMapClassDesc, 'LinkedHashMapClassDesc', VOID, MapLikeDescriptor);
  initMetadataForClass(ArrayClassDesc, 'ArrayClassDesc', VOID, ListLikeDescriptor);
  initMetadataForClass(PrimitiveArrayDescriptor, 'PrimitiveArrayDescriptor', VOID, ListLikeDescriptor);
  initMetadataForClass(AbstractCollectionSerializer, 'AbstractCollectionSerializer', VOID, VOID, [KSerializer]);
  initMetadataForClass(CollectionLikeSerializer, 'CollectionLikeSerializer', VOID, AbstractCollectionSerializer);
  initMetadataForClass(CollectionSerializer, 'CollectionSerializer', VOID, CollectionLikeSerializer);
  initMetadataForClass(ArrayListSerializer, 'ArrayListSerializer', VOID, CollectionSerializer);
  initMetadataForClass(MapLikeSerializer, 'MapLikeSerializer', VOID, AbstractCollectionSerializer);
  initMetadataForClass(LinkedHashSetSerializer, 'LinkedHashSetSerializer', VOID, CollectionSerializer);
  initMetadataForClass(HashSetSerializer, 'HashSetSerializer', VOID, CollectionSerializer);
  initMetadataForClass(HashMapSerializer, 'HashMapSerializer', VOID, MapLikeSerializer);
  initMetadataForClass(LinkedHashMapSerializer, 'LinkedHashMapSerializer', VOID, MapLikeSerializer);
  initMetadataForClass(ReferenceArraySerializer, 'ReferenceArraySerializer', VOID, CollectionLikeSerializer);
  initMetadataForClass(PrimitiveArraySerializer, 'PrimitiveArraySerializer', VOID, CollectionLikeSerializer);
  initMetadataForClass(PrimitiveArrayBuilder, 'PrimitiveArrayBuilder');
  initMetadataForCompanion(Companion_78);
  initMetadataForClass(ElementMarker, 'ElementMarker');
  initMetadataForClass(EnumSerializer, 'EnumSerializer', VOID, VOID, [KSerializer]);
  initMetadataForClass(PluginGeneratedSerialDescriptor, 'PluginGeneratedSerialDescriptor', VOID, VOID, [SerialDescriptor, CachedNames]);
  initMetadataForClass(EnumDescriptor, 'EnumDescriptor', VOID, PluginGeneratedSerialDescriptor);
  initMetadataForClass(InlineClassDescriptor, 'InlineClassDescriptor', VOID, PluginGeneratedSerialDescriptor);
  function typeParametersSerializers() {
    return get_EMPTY_SERIALIZER_ARRAY();
  }
  initMetadataForInterface(GeneratedSerializer, 'GeneratedSerializer', VOID, VOID, [KSerializer]);
  initMetadataForClass(InlinePrimitiveDescriptor$1, VOID, VOID, VOID, [GeneratedSerializer]);
  initMetadataForObject(NoOpEncoder, 'NoOpEncoder', VOID, AbstractEncoder);
  initMetadataForObject(NothingSerialDescriptor, 'NothingSerialDescriptor', VOID, VOID, [SerialDescriptor]);
  initMetadataForClass(NullableSerializer, 'NullableSerializer', VOID, VOID, [KSerializer]);
  initMetadataForClass(SerialDescriptorForNullable, 'SerialDescriptorForNullable', VOID, VOID, [SerialDescriptor, CachedNames]);
  initMetadataForClass(ObjectSerializer, 'ObjectSerializer', VOID, VOID, [KSerializer]);
  initMetadataForInterface(SerializerFactory, 'SerializerFactory');
  initMetadataForObject(ByteArraySerializer_0, 'ByteArraySerializer', VOID, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
  initMetadataForClass(ByteArrayBuilder, 'ByteArrayBuilder', VOID, PrimitiveArrayBuilder);
  initMetadataForObject(CharArraySerializer_0, 'CharArraySerializer', VOID, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
  initMetadataForObject(DoubleArraySerializer_0, 'DoubleArraySerializer', VOID, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
  initMetadataForObject(FloatArraySerializer_0, 'FloatArraySerializer', VOID, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
  initMetadataForObject(LongArraySerializer_0, 'LongArraySerializer', VOID, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
  initMetadataForObject(ULongArraySerializer_0, 'ULongArraySerializer', VOID, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
  initMetadataForObject(IntArraySerializer_0, 'IntArraySerializer', VOID, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
  initMetadataForObject(UIntArraySerializer_0, 'UIntArraySerializer', VOID, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
  initMetadataForObject(ShortArraySerializer_0, 'ShortArraySerializer', VOID, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
  initMetadataForObject(UShortArraySerializer_0, 'UShortArraySerializer', VOID, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
  initMetadataForObject(UByteArraySerializer_0, 'UByteArraySerializer', VOID, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
  initMetadataForObject(BooleanArraySerializer_0, 'BooleanArraySerializer', VOID, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
  initMetadataForClass(CharArrayBuilder, 'CharArrayBuilder', VOID, PrimitiveArrayBuilder);
  initMetadataForClass(DoubleArrayBuilder, 'DoubleArrayBuilder', VOID, PrimitiveArrayBuilder);
  initMetadataForClass(FloatArrayBuilder, 'FloatArrayBuilder', VOID, PrimitiveArrayBuilder);
  initMetadataForClass(LongArrayBuilder, 'LongArrayBuilder', VOID, PrimitiveArrayBuilder);
  initMetadataForClass(ULongArrayBuilder, 'ULongArrayBuilder', VOID, PrimitiveArrayBuilder);
  initMetadataForClass(IntArrayBuilder, 'IntArrayBuilder', VOID, PrimitiveArrayBuilder);
  initMetadataForClass(UIntArrayBuilder, 'UIntArrayBuilder', VOID, PrimitiveArrayBuilder);
  initMetadataForClass(ShortArrayBuilder, 'ShortArrayBuilder', VOID, PrimitiveArrayBuilder);
  initMetadataForClass(UShortArrayBuilder, 'UShortArrayBuilder', VOID, PrimitiveArrayBuilder);
  initMetadataForClass(UByteArrayBuilder, 'UByteArrayBuilder', VOID, PrimitiveArrayBuilder);
  initMetadataForClass(BooleanArrayBuilder, 'BooleanArrayBuilder', VOID, PrimitiveArrayBuilder);
  initMetadataForObject(StringSerializer, 'StringSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(BooleanSerializer, 'BooleanSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(IntSerializer, 'IntSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(LongSerializer, 'LongSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(UnitSerializer, 'UnitSerializer', VOID, VOID, [KSerializer]);
  initMetadataForClass(PrimitiveSerialDescriptor_0, 'PrimitiveSerialDescriptor', VOID, VOID, [SerialDescriptor]);
  initMetadataForObject(ByteSerializer, 'ByteSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(CharSerializer, 'CharSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(DoubleSerializer, 'DoubleSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(FloatSerializer, 'FloatSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(ShortSerializer, 'ShortSerializer', VOID, VOID, [KSerializer]);
  initMetadataForClass(TaggedDecoder, 'TaggedDecoder', VOID, VOID, [Decoder, CompositeDecoder]);
  initMetadataForClass(NamedValueDecoder, 'NamedValueDecoder', VOID, TaggedDecoder);
  initMetadataForClass(TaggedEncoder, 'TaggedEncoder', VOID, VOID, [Encoder, CompositeEncoder]);
  initMetadataForClass(NamedValueEncoder, 'NamedValueEncoder', VOID, TaggedEncoder);
  initMetadataForClass(KeyValueSerializer, 'KeyValueSerializer', VOID, VOID, [KSerializer]);
  initMetadataForClass(PairSerializer_0, 'PairSerializer', VOID, KeyValueSerializer);
  initMetadataForClass(TripleSerializer_0, 'TripleSerializer', VOID, VOID, [KSerializer]);
  initMetadataForClass(MapEntry, 'MapEntry', VOID, VOID, [Entry]);
  initMetadataForClass(MapEntrySerializer_0, 'MapEntrySerializer', VOID, KeyValueSerializer);
  initMetadataForObject(ULongSerializer, 'ULongSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(UIntSerializer, 'UIntSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(UByteSerializer, 'UByteSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(UShortSerializer, 'UShortSerializer', VOID, VOID, [KSerializer]);
  initMetadataForClass(SerializersModule, 'SerializersModule');
  initMetadataForClass(SerialModuleImpl, 'SerialModuleImpl', VOID, SerializersModule);
  initMetadataForClass(ContextualProvider, 'ContextualProvider');
  initMetadataForClass(Argless, 'Argless', VOID, ContextualProvider);
  initMetadataForClass(WithTypeArguments, 'WithTypeArguments', VOID, ContextualProvider);
  function contextual(kClass, serializer) {
    return this.i5t(kClass, SerializersModuleCollector$contextual$lambda(serializer));
  }
  initMetadataForInterface(SerializersModuleCollector, 'SerializersModuleCollector');
  initMetadataForClass(SerializersModuleBuilder, 'SerializersModuleBuilder', VOID, VOID, [SerializersModuleCollector]);
  initMetadataForClass(SerializerAlreadyRegisteredException, 'SerializerAlreadyRegisteredException', VOID, IllegalArgumentException);
  initMetadataForClass(SerializableWith, 'SerializableWith', VOID, VOID, VOID, VOID, 0);
  initMetadataForClass(createCache$1);
  initMetadataForClass(createParametrizedCache$1);
  initMetadataForClass(AlreadyInvalidException, 'AlreadyInvalidException', VOID, Exception);
  initMetadataForClass(Invalidation$ALWAYS_INVALIDATE$1);
  initMetadataForObject(Invalidation, 'Invalidation');
  initMetadataForClass(ValueHolder, 'ValueHolder');
  initMetadataForClass(EagerInvalidatable$myListeners$1, VOID, VOID, EventHandlerListeners);
  initMetadataForClass(EagerInvalidatable$recompute$1);
  initMetadataForClass(EagerInvalidatable, 'EagerInvalidatable', VOID, VOID, [ReadableProperty]);
  initMetadataForClass(InvalidatableBase, 'InvalidatableBase');
  initMetadataForClass(InvalidationPointBase$addHandler$$inlined$toDisposable$1, VOID, VOID, VOID, [Disposable]);
  initMetadataForClass(InvalidationPointBase, 'InvalidationPointBase', VOID, VOID, [EventSource]);
  initMetadataForClass(Dependencies, 'Dependencies', Dependencies);
  initMetadataForClass(SourceKey, 'SourceKey');
  initMetadataForClass(Invalidator$1, VOID, VOID, InvalidationPointBase);
  initMetadataForClass(Invalidator$createEventHandler$1);
  initMetadataForClass(Invalidator$createEventHandler$$inlined$eventHandler$1);
  initMetadataForClass(Invalidator$value$3, VOID, VOID, InvalidatableBase);
  initMetadataForClass(Invalidator$failure$3, VOID, VOID, InvalidatableBase);
  initMetadataForClass(Invalidator, 'Invalidator', Invalidator, VOID, [Disposable]);
  initMetadataForClass(NonTrackingInvalidationContext$Companion$INVALIDATION_POINT$1, VOID, VOID, InvalidationPointBase);
  initMetadataForCompanion(Companion_79);
  initMetadataForClass(NonTrackingInvalidationContext$value$1, VOID, VOID, InvalidatableBase);
  initMetadataForClass(NonTrackingInvalidationContext$failure$1, VOID, VOID, InvalidatableBase);
  initMetadataForClass(NonTrackingInvalidationContext, 'NonTrackingInvalidationContext', VOID, VOID, [Disposable]);
  initMetadataForCompanion(Companion_80);
  initMetadataForClass(InvalidateOnAttributeChanged, 'InvalidateOnAttributeChanged');
  function runSuspend(builder, $completion) {
    return this.n5w(builder);
  }
  initMetadataForInterface(Query, 'Query', VOID, VOID, VOID, [1]);
  initMetadataForClass(attributeQuery$$inlined$query$1, VOID, VOID, VOID, [Query], [1]);
  initMetadataForClass(Execution, 'Execution');
  initMetadataForClass(Result_0, 'Result');
  initMetadataForClass(Ready, 'Ready', VOID, Result_0);
  initMetadataForObject(NotReady, 'NotReady', VOID, Result_0);
  initMetadataForClass(Outcome, 'Outcome');
  initMetadataForClass(Success, 'Success', VOID, Outcome);
  initMetadataForClass(Failure_0, 'Failure', VOID, Outcome);
  initMetadataForLambda(LoopingQuery$_init_$slambda_vmyece, CoroutineImpl, VOID, [1]);
  initMetadataForClass(LoopingQuery$listeners$1, VOID, VOID, Listeners);
  initMetadataForLambda(LoopingQuery$launchComputingJob$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(LoopingQuery, 'LoopingQuery', VOID, VOID, [ReadableProperty]);
  function get_size() {
    var tmp = this.m5y();
    return attributeQuery(tmp, QCollectionBase$_get_size_$lambda_5cjhst);
  }
  function contains(element) {
    var tmp = this.m5y();
    return attributeQuery(tmp, QCollectionBase$contains$lambda(element));
  }
  initMetadataForInterface(QCollectionBase, 'QCollectionBase', VOID, VOID, [Query], [1]);
  function add(element) {
    return execute_0(this).j(element);
  }
  function remove(element) {
    return execute_0(this).h2(element);
  }
  function addAll(elements) {
    return execute_0(this).q(elements);
  }
  function clear() {
    return execute_0(this).k2();
  }
  initMetadataForInterface(QMutableCollectionBase, 'QMutableCollectionBase', VOID, VOID, [QCollectionBase], [1]);
  function add_0(index, element) {
    return execute_0(this).m2(index, element);
  }
  initMetadataForInterface(QMutableListBase, 'QMutableListBase', VOID, VOID, [QMutableCollectionBase, QCollectionBase], [1]);
  initMetadataForClass(toReified$1, VOID, VOID, VOID, [Query, WritableProperty], [1]);
  initMetadataForClass(sam$jetbrains_ocelot_base_disposable_Disposable$0_1, 'sam$jetbrains_ocelot_base_disposable_Disposable$0', VOID, VOID, [Disposable, FunctionAdapter]);
  initMetadataForObject(QueryInit, 'QueryInit');
  initMetadataForClass(constant$$inlined$query$1, VOID, VOID, VOID, [Query], [1]);
  initMetadataForClass(sam$jetbrains_ocelot_base_disposable_Disposable$0_2, 'sam$jetbrains_ocelot_base_disposable_Disposable$0', VOID, VOID, [Disposable, FunctionAdapter]);
  initMetadataForLambda(supervise$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($executeCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($superviseCOROUTINE$, CoroutineImpl);
  initMetadataForCompanion(Companion_81);
  initMetadataForClass(QueryBuilder, 'QueryBuilder', VOID, VOID, VOID, [1]);
  initMetadataForCoroutine($runSuspendCOROUTINE$, CoroutineImpl);
  initMetadataForClass(waitUntilNot$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(QPropertyAdapter, 'QPropertyAdapter', VOID, VOID, [Query, WritableProperty], [1]);
  initMetadataForClass(QMutableListAdapter, 'QMutableListAdapter', VOID, VOID, [QMutableListBase], [1]);
  initMetadataForClass(QReadablePropertyAdapter, 'QReadablePropertyAdapter', VOID, VOID, [Query], [1]);
  initMetadataForClass(QListAdapter, 'QListAdapter', VOID, VOID, [QCollectionBase], [1]);
  initMetadataForClass(QCollectionAdapter, 'QCollectionAdapter', VOID, VOID, [QCollectionBase], [1]);
  initMetadataForClass(QTextPropertyAdapter, 'QTextPropertyAdapter', VOID, VOID, [Query], [1]);
  initMetadataForClass(QMutableCollectionAdapter, 'QMutableCollectionAdapter', VOID, VOID, [QMutableCollectionBase], [1]);
  initMetadataForClass(asProperty$1);
  initMetadataForClass(Json_0, 'Json', VOID, VOID, [StringFormat]);
  initMetadataForObject(Default_0, 'Default', VOID, Json_0);
  initMetadataForClass(JsonBuilder, 'JsonBuilder');
  initMetadataForClass(JsonImpl, 'JsonImpl', VOID, Json_0);
  initMetadataForClass(JsonClassDiscriminator, 'JsonClassDiscriminator');
  initMetadataForClass(JsonNames, 'JsonNames');
  initMetadataForClass(JsonConfiguration, 'JsonConfiguration');
  initMetadataForInterface(JsonDecoder, 'JsonDecoder', VOID, VOID, [Decoder, CompositeDecoder]);
  initMetadataForCompanion(Companion_82);
  initMetadataForClass(JsonElement, 'JsonElement', VOID, VOID, VOID, VOID, VOID, {0: JsonElementSerializer_getInstance});
  initMetadataForClass(JsonPrimitive, 'JsonPrimitive', VOID, JsonElement, VOID, VOID, VOID, {0: JsonPrimitiveSerializer_getInstance});
  initMetadataForCompanion(Companion_83);
  initMetadataForCompanion(Companion_84);
  initMetadataForClass(JsonObject_0, 'JsonObject', VOID, JsonElement, [JsonElement, KtMap], VOID, VOID, {0: JsonObjectSerializer_getInstance});
  initMetadataForObject(JsonNull_0, 'JsonNull', VOID, JsonPrimitive, [JsonPrimitive, SerializerFactory], VOID, VOID, {0: JsonNull_getInstance});
  initMetadataForClass(JsonLiteral, 'JsonLiteral', VOID, JsonPrimitive);
  initMetadataForCompanion(Companion_85);
  initMetadataForClass(JsonArray_0, 'JsonArray', VOID, JsonElement, [JsonElement, KtList], VOID, VOID, {0: JsonArraySerializer_getInstance});
  initMetadataForClass(JsonObjectBuilder, 'JsonObjectBuilder');
  initMetadataForClass(JsonArrayBuilder, 'JsonArrayBuilder');
  initMetadataForObject(JsonElementSerializer, 'JsonElementSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(JsonPrimitiveSerializer, 'JsonPrimitiveSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(JsonObjectDescriptor, 'JsonObjectDescriptor', VOID, VOID, [SerialDescriptor]);
  initMetadataForObject(JsonObjectSerializer, 'JsonObjectSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(JsonNullSerializer, 'JsonNullSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(JsonLiteralSerializer, 'JsonLiteralSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(JsonArrayDescriptor, 'JsonArrayDescriptor', VOID, VOID, [SerialDescriptor]);
  initMetadataForObject(JsonArraySerializer, 'JsonArraySerializer', VOID, VOID, [KSerializer]);
  initMetadataForClass(defer$1, VOID, VOID, VOID, [SerialDescriptor]);
  initMetadataForInterface(JsonEncoder, 'JsonEncoder', VOID, VOID, [Encoder, CompositeEncoder]);
  initMetadataForClass(Composer, 'Composer');
  initMetadataForClass(ComposerForUnsignedNumbers, 'ComposerForUnsignedNumbers', VOID, Composer);
  initMetadataForClass(ComposerForUnquotedLiterals, 'ComposerForUnquotedLiterals', VOID, Composer);
  initMetadataForClass(ComposerWithPrettyPrint, 'ComposerWithPrettyPrint', VOID, Composer);
  initMetadataForClass(JsonElementMarker, 'JsonElementMarker');
  initMetadataForClass(JsonException_0, 'JsonException', VOID, SerializationException);
  initMetadataForClass(JsonDecodingException, 'JsonDecodingException', VOID, JsonException_0);
  initMetadataForClass(JsonEncodingException, 'JsonEncodingException', VOID, JsonException_0);
  initMetadataForObject(Tombstone, 'Tombstone');
  initMetadataForClass(JsonPath, 'JsonPath', JsonPath);
  initMetadataForLambda(JsonTreeReader$readDeepRecursive$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForCoroutine($readObjectCOROUTINE$, CoroutineImpl);
  initMetadataForClass(JsonTreeReader, 'JsonTreeReader', VOID, VOID, VOID, [1]);
  initMetadataForClass(PolymorphismValidator, 'PolymorphismValidator', VOID, VOID, [SerializersModuleCollector]);
  initMetadataForClass(Key_6, 'Key', Key_6);
  initMetadataForClass(DescriptorSchemaCache, 'DescriptorSchemaCache', DescriptorSchemaCache);
  initMetadataForClass(DiscriminatorHolder, 'DiscriminatorHolder');
  initMetadataForClass(StreamingJsonDecoder, 'StreamingJsonDecoder', VOID, AbstractDecoder, [JsonDecoder, AbstractDecoder]);
  initMetadataForClass(JsonDecoderForUnsignedTypes, 'JsonDecoderForUnsignedTypes', VOID, AbstractDecoder);
  initMetadataForClass(StreamingJsonEncoder, 'StreamingJsonEncoder', VOID, AbstractEncoder, [JsonEncoder, AbstractEncoder]);
  initMetadataForClass(AbstractJsonTreeDecoder, 'AbstractJsonTreeDecoder', VOID, NamedValueDecoder, [NamedValueDecoder, JsonDecoder]);
  initMetadataForClass(JsonTreeDecoder, 'JsonTreeDecoder', VOID, AbstractJsonTreeDecoder);
  initMetadataForClass(JsonTreeListDecoder, 'JsonTreeListDecoder', VOID, AbstractJsonTreeDecoder);
  initMetadataForClass(JsonPrimitiveDecoder, 'JsonPrimitiveDecoder', VOID, AbstractJsonTreeDecoder);
  initMetadataForClass(JsonTreeMapDecoder, 'JsonTreeMapDecoder', VOID, JsonTreeDecoder);
  initMetadataForClass(AbstractJsonTreeEncoder, 'AbstractJsonTreeEncoder', VOID, NamedValueEncoder, [NamedValueEncoder, JsonEncoder]);
  initMetadataForClass(JsonTreeEncoder, 'JsonTreeEncoder', VOID, AbstractJsonTreeEncoder);
  initMetadataForClass(AbstractJsonTreeEncoder$inlineUnsignedNumberEncoder$1, VOID, VOID, AbstractEncoder);
  initMetadataForClass(AbstractJsonTreeEncoder$inlineUnquotedLiteralEncoder$1, VOID, VOID, AbstractEncoder);
  initMetadataForClass(JsonPrimitiveEncoder, 'JsonPrimitiveEncoder', VOID, AbstractJsonTreeEncoder);
  initMetadataForClass(JsonTreeListEncoder, 'JsonTreeListEncoder', VOID, AbstractJsonTreeEncoder);
  initMetadataForClass(JsonTreeMapEncoder, 'JsonTreeMapEncoder', VOID, JsonTreeEncoder);
  initMetadataForClass(WriteMode, 'WriteMode', VOID, Enum);
  initMetadataForClass(AbstractJsonLexer, 'AbstractJsonLexer');
  initMetadataForObject(CharMappings, 'CharMappings');
  initMetadataForClass(StringJsonLexer_0, 'StringJsonLexer', VOID, AbstractJsonLexer);
  initMetadataForClass(DynamicInput, 'DynamicInput', VOID, NamedValueDecoder, [NamedValueDecoder, JsonDecoder]);
  initMetadataForClass(PrimitiveDynamicInput, 'PrimitiveDynamicInput', VOID, DynamicInput);
  initMetadataForClass(DynamicListInput, 'DynamicListInput', VOID, DynamicInput);
  initMetadataForClass(DynamicMapInput, 'DynamicMapInput', VOID, DynamicInput);
  initMetadataForClass(JsonToStringWriter, 'JsonToStringWriter', JsonToStringWriter);
  initMetadataForClass(Language, 'Language');
  initMetadataForInterface(LanguageAspect, 'LanguageAspect');
  initMetadataForClass(LanguageBuilderImpl, 'LanguageBuilderImpl', LanguageBuilderImpl);
  initMetadataForClass(LanguageConfigurationException, 'LanguageConfigurationException', LanguageConfigurationException_init_$Create$, Exception);
  initMetadataForObject(DefaultNodeStorage, 'DefaultNodeStorage');
  initMetadataForClass(LocalNodePointerSupport$node$$inlined$query$1, VOID, VOID, VOID, [Query], [1]);
  initMetadataForClass(LocalNodePointerSupport, 'LocalNodePointerSupport', VOID, VOID, [Disposable]);
  initMetadataForCompanion(Companion_86);
  initMetadataForClass(NodePointer, 'NodePointer', VOID, VOID, VOID, VOID, VOID, {0: NodePointerSerializer_getInstance});
  initMetadataForObject(NodePointerSerializer, 'NodePointerSerializer', VOID, VOID, [KSerializer]);
  initMetadataForCompanion(Companion_87);
  initMetadataForClass(NodePointerFormatException, 'NodePointerFormatException', NodePointerFormatException_init_$Create$, IllegalArgumentException);
  initMetadataForCompanion(Companion_88, VOID, [Key_5]);
  initMetadataForClass(NodePointersService, 'NodePointersService');
  initMetadataForObject(EmptyNodeStorage, 'EmptyNodeStorage');
  initMetadataForCompanion(Companion_89, VOID, [Key_5]);
  initMetadataForClass(NodeStorageService, 'NodeStorageService');
  initMetadataForObject(OtNodeFactoryService, 'OtNodeFactoryService', VOID, VOID, [Key_5]);
  initMetadataForCompanion(Companion_90);
  initMetadataForObject($serializer, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(SerializedNode, 'SerializedNode', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance});
  initMetadataForInterface(NodePersister, 'NodePersister', VOID, VOID, [Persister]);
  initMetadataForClass(DomainNodePersister, 'DomainNodePersister', VOID, VOID, [NodePersister]);
  initMetadataForClass(FindNodeQueryProvider$createNodeRegisterListener$1);
  initMetadataForClass(FindNodeQueryProvider$activeNodeQueries$1, VOID, VOID, ListenersMap);
  initMetadataForClass(FindNodeQueryProvider$findNode$1, VOID, VOID, VOID, [EventSource]);
  initMetadataForClass(FindNodeQueryProvider$findNode$$inlined$query$1, VOID, VOID, VOID, [Query], [1]);
  initMetadataForClass(FindNodeQueryProvider, 'FindNodeQueryProvider', VOID, VOID, [Disposable]);
  initMetadataForObject(OTLinkPersister, 'OTLinkPersister');
  initMetadataForCompanion(Companion_91);
  initMetadataForClass(PersistableLink, 'PersistableLink');
  initMetadataForClass(OTNodePersister, 'OTNodePersister', VOID, VOID, [Persister]);
  initMetadataForCompanion(Companion_92, VOID, [Key_5]);
  initMetadataForClass(SameModelNodeFinder$find$$inlined$map$1, VOID, VOID, VOID, [Query], [1]);
  function pointer(source, refContents) {
    return null;
  }
  initMetadataForInterface(NodeFinder, 'NodeFinder');
  initMetadataForClass(SameModelNodeFinder, 'SameModelNodeFinder', VOID, VOID, [NodeFinder, Disposable]);
  initMetadataForClass(SingleRootNodePointerSupport$node$$inlined$query$1, VOID, VOID, VOID, [Query], [1]);
  initMetadataForClass(SingleRootNodePointerSupport, 'SingleRootNodePointerSupport', VOID, VOID, [Disposable]);
  initMetadataForClass(OTChildLink, 'OTChildLink');
  function get_parent() {
    return this.x6i().uv();
  }
  initMetadataForInterface(DomainNode, 'DomainNode');
  initMetadataForInterface(TypedOtNode, 'TypedOtNode', VOID, VOID, [DomainNode]);
  initMetadataForClass(BaseNodeGen, 'BaseNodeGen', VOID, NodeWrapper, [NodeWrapper, TypedOtNode]);
  initMetadataForClass(OTRoleData, 'OTRoleData');
  initMetadataForInterface(ChildProperty, 'ChildProperty', VOID, VOID, [Query, WritableProperty], [1]);
  initMetadataForInterface(OtChildProperty, 'OtChildProperty', VOID, VOID, [ChildProperty], [1]);
  initMetadataForClass(OTChildPropertyAdapter, 'OTChildPropertyAdapter', VOID, QPropertyAdapter, [OtChildProperty, QPropertyAdapter], [1]);
  initMetadataForInterface(ChildrenList, 'ChildrenList', VOID, VOID, [QMutableListBase], [1]);
  initMetadataForInterface(OtChildrenList, 'OtChildrenList', VOID, VOID, [ChildrenList], [1]);
  initMetadataForClass(OTChildrenListAdapter, 'OTChildrenListAdapter', VOID, QMutableListAdapter, [OtChildrenList, QMutableListAdapter], [1]);
  initMetadataForClass(BaseTypedOtNode, 'BaseTypedOtNode', VOID, OtNode, [OtNode, TypedOtNode]);
  function getNodeFactory(referenceFactoryRegistry) {
    return RawNodeFactory_instance;
  }
  initMetadataForInterface(NodeWrapperConceptRegistry, 'NodeWrapperConceptRegistry');
  initMetadataForCompanion(Companion_93);
  initMetadataForClass(NodeSetupContext, 'NodeSetupContext');
  initMetadataForObject(NodeSetupContextService, 'NodeSetupContextService', VOID, VOID, [Key_5]);
  initMetadataForCompanion(Companion_94);
  initMetadataForClass(OTAbstractConceptDescriptor, 'OTAbstractConceptDescriptor');
  function createNode$default_0(nodeSetupContext, id, $super) {
    id = id === VOID ? new NodeId() : id;
    return $super === VOID ? this.r6l(nodeSetupContext, id) : $super.r6l.call(this, nodeSetupContext, id);
  }
  initMetadataForInterface(DomainNodeFactory, 'DomainNodeFactory');
  initMetadataForInterface(OTConcept, 'OTConcept', VOID, VOID, [DomainNodeFactory]);
  initMetadataForInterface(DomainNodeWrapperFactory, 'DomainNodeWrapperFactory', VOID, VOID, [DomainNodeFactory]);
  initMetadataForInterface(OTConceptWrapper, 'OTConceptWrapper', VOID, VOID, [OTConcept, DomainNodeWrapperFactory]);
  initMetadataForClass(OTConceptImpl, 'OTConceptImpl', VOID, VOID, [OTConcept, DomainNodeFactory]);
  initMetadataForClass(DomainNodeFactoryImpl, 'DomainNodeFactoryImpl', VOID, VOID, [DomainNodeFactory]);
  initMetadataForObject(ErrorNodeFactory, 'ErrorNodeFactory', VOID, VOID, [DomainNodeWrapperFactory]);
  initMetadataForClass(OTConceptWrapperImpl, 'OTConceptWrapperImpl', VOID, VOID, [OTConceptWrapper, DomainNodeWrapperFactory]);
  initMetadataForClass(DomainNodeWrapperFactoryImpl, 'DomainNodeWrapperFactoryImpl', VOID, VOID, [DomainNodeWrapperFactory]);
  initMetadataForClass(IdMapping, 'IdMapping');
  initMetadataForClass(plus$1);
  initMetadataForClass(OTSplitMergeSupportFactory, 'OTSplitMergeSupportFactory');
  initMetadataForClass(OTSplitMergeSupport, 'OTSplitMergeSupport');
  initMetadataForClass(OtConceptDescriptor, 'OtConceptDescriptor', VOID, OTAbstractConceptDescriptor);
  initMetadataForClass(TypedNodeContext, 'TypedNodeContext');
  initMetadataForObject(UseExperimentalNodeService, 'UseExperimentalNodeService', VOID, VOID, [Key_5]);
  initMetadataForClass(BaseDomainNodeProperty, 'BaseDomainNodeProperty', VOID, BaseOtNodeProperty, [BaseOtNodeProperty, Query, WritableProperty], [1]);
  initMetadataForClass(DomainNodeChildProperty, 'DomainNodeChildProperty', VOID, SingleItemCollectionProperty, [SingleItemCollectionProperty, OtChildProperty], [1]);
  initMetadataForClass(DomainNodeChildrenProperty, 'DomainNodeChildrenProperty', VOID, QMutableListAdapter, [QMutableListAdapter, OtChildrenList], [1]);
  initMetadataForClass(DomainNodeInMemoryProperty, 'DomainNodeInMemoryProperty', VOID, ValueProperty, [ValueProperty, Query, WritableProperty], [1]);
  initMetadataForClass(DomainNodeProperty, 'DomainNodeProperty', VOID, BaseDomainNodeProperty, VOID, [1]);
  initMetadataForClass(DomainNodeReferenceProperty, 'DomainNodeReferenceProperty', VOID, BaseDomainNodeProperty, [BaseDomainNodeProperty, Query, WritableProperty], [1]);
  initMetadataForClass(DomainNodeTextProperty, 'DomainNodeTextProperty', VOID, BaseOtNodeTextProperty, [BaseOtNodeTextProperty, Query], [1]);
  initMetadataForClass(DomainNodeChildPropertyDescriptor, 'DomainNodeChildPropertyDescriptor');
  initMetadataForClass(DomainNodeChildrenPropertyDescriptor, 'DomainNodeChildrenPropertyDescriptor');
  initMetadataForClass(DomainNodePropertyDescriptor, 'DomainNodePropertyDescriptor');
  initMetadataForClass(DomainNodeReferencePropertyDescriptor, 'DomainNodeReferencePropertyDescriptor');
  initMetadataForClass(DomainNodeTextPropertyDescriptor, 'DomainNodeTextPropertyDescriptor');
  function get_regular() {
    return this.z6o().m5y();
  }
  function set(newValue) {
    return this.z6o().d2x(newValue);
  }
  function invoke_3(target) {
    return this.a6p(target);
  }
  function runSuspend_0(builder, $completion) {
    return this.w6o().r5w(builder, $completion);
  }
  initMetadataForInterface(Reference, 'Reference', VOID, VOID, [WritableProperty], [1]);
  initMetadataForClass(PropertyBasedReference, 'PropertyBasedReference', VOID, VOID, [Reference], [1]);
  initMetadataForClass(ConstantReference, 'ConstantReference', VOID, PropertyBasedReference, VOID, [1]);
  initMetadataForClass(ElementsContext, 'ElementsContext');
  initMetadataForClass(EnclosingNodeContext, 'EnclosingNodeContext', VOID, ElementsContext);
  initMetadataForClass(SourceNodeContext, 'SourceNodeContext', VOID, ElementsContext);
  initMetadataForCompanion(Companion_95, VOID, [Key_5]);
  initMetadataForClass(GlobalNodeFinder$find$$inlined$query$1, VOID, VOID, VOID, [Query], [1]);
  initMetadataForClass(GlobalNodeFinder, 'GlobalNodeFinder', VOID, VOID, [NodeFinder]);
  initMetadataForClass(RefTag, 'RefTag');
  initMetadataForInterface(ReferenceFactory, 'ReferenceFactory');
  initMetadataForClass(sam$jetbrains_ocelot_langDef_references_ReferenceFactory$0, 'sam$jetbrains_ocelot_langDef_references_ReferenceFactory$0', VOID, VOID, [ReferenceFactory, FunctionAdapter]);
  initMetadataForClass(PrecalculatedResolutionReference$Companion$throwIfMissing$$inlined$query$1, VOID, VOID, VOID, [Query], [1]);
  initMetadataForCompanion(Companion_96);
  initMetadataForClass(PrecalculatedResolutionReference$resolve$$inlined$map$1, VOID, VOID, VOID, [Query], [1]);
  initMetadataForClass(PrecalculatedResolutionReference$find$$inlined$map$1, VOID, VOID, VOID, [Query], [1]);
  initMetadataForClass(PrecalculatedResolutionReference, 'PrecalculatedResolutionReference', VOID, PropertyBasedReference, VOID, [1]);
  initMetadataForCompanion(Companion_97);
  initMetadataForClass(PrecalculatedResolutionReferenceValue, 'PrecalculatedResolutionReferenceValue');
  function find(source, refContent) {
    return this.i6q(source, refContent);
  }
  initMetadataForInterface(ReferenceResolver, 'ReferenceResolver');
  initMetadataForClass(ReferenceTargetItem, 'ReferenceTargetItem');
  initMetadataForInterface(ReferenceTargetsSupplier, 'ReferenceTargetsSupplier');
  initMetadataForObject(Empty_0, 'Empty', VOID, VOID, [ReferenceTargetsSupplier]);
  initMetadataForClass(NodeLink, 'NodeLink');
  initMetadataForClass(ReferenceLink, 'ReferenceLink', VOID, NodeLink);
  initMetadataForClass(ReferenceData, 'ReferenceData');
  initMetadataForClass(TargetInfo, 'TargetInfo', VOID, ReferenceTargetItem);
  initMetadataForInterface(TargetPresentationProvider, 'TargetPresentationProvider');
  initMetadataForClass(sam$jetbrains_ocelot_langDef_references_TargetPresentationProvider$0, 'sam$jetbrains_ocelot_langDef_references_TargetPresentationProvider$0', VOID, VOID, [TargetPresentationProvider, FunctionAdapter]);
  initMetadataForClass(sam$jetbrains_ocelot_langDef_references_TargetPresentationProvider$0_0, 'sam$jetbrains_ocelot_langDef_references_TargetPresentationProvider$0', VOID, VOID, [TargetPresentationProvider, FunctionAdapter]);
  initMetadataForCompanion(Companion_98);
  initMetadataForCompanion(Companion_99);
  initMetadataForObject($serializer_0, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(TextFilter, 'TextFilter', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_0});
  initMetadataForClass(TextFilterSettings$Companion$invoke$1);
  initMetadataForClass(TextFilterSettings$Companion$DEFAULT$1);
  initMetadataForCompanion(Companion_100);
  initMetadataForCompanion(Companion_101);
  initMetadataForObject($serializer_1, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(TokenizedText, 'TokenizedText', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_1});
  initMetadataForClass(sam$jetbrains_ocelot_langDef_references_ReferenceFactory$0_0, 'sam$jetbrains_ocelot_langDef_references_ReferenceFactory$0', VOID, VOID, [ReferenceFactory, FunctionAdapter]);
  initMetadataForCoroutine($runSuspendCOROUTINE$_0, CoroutineImpl);
  initMetadataForCoroutine($runSuspendCOROUTINE$_1, CoroutineImpl);
  initMetadataForCompanion(Companion_102);
  initMetadataForClass(TrivialReference$resolve$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(TrivialReference$find$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(TrivialReference, 'TrivialReference', VOID, PropertyBasedReference, VOID, [1]);
  initMetadataForObject(ReferenceFactoryRegistryService, 'ReferenceFactoryRegistryService', VOID, VOID, [Key_5]);
  initMetadataForObject(ReferenceFactoryRegistryAspect, 'ReferenceFactoryRegistryAspect', VOID, VOID, [LanguageAspect]);
  initMetadataForClass(ReferenceFactoryRegistryDefinition, 'ReferenceFactoryRegistryDefinition');
  initMetadataForClass(ReferenceFactoryRegistryBuilderImpl, 'ReferenceFactoryRegistryBuilderImpl', VOID, VOID, [ServicesScope]);
  initMetadataForClass(sam$jetbrains_ocelot_langDef_references_ReferenceFactory$0_1, 'sam$jetbrains_ocelot_langDef_references_ReferenceFactory$0', VOID, VOID, [ReferenceFactory, FunctionAdapter]);
  initMetadataForClass(ReferenceFactoryRegistryImpl, 'ReferenceFactoryRegistryImpl');
  initMetadataForObject(ReferenceTargetPresentationProvidersRegistryService, 'ReferenceTargetPresentationProvidersRegistryService', VOID, VOID, [Key_5]);
  initMetadataForObject(ReferenceTargetPresentationProvidersRegistryAspect, 'ReferenceTargetPresentationProvidersRegistryAspect', VOID, VOID, [LanguageAspect]);
  initMetadataForClass(ReferenceTargetPresentationProvidersRegistryDefinition, 'ReferenceTargetPresentationProvidersRegistryDefinition');
  function referenceTargetPresentation$default(tag, presentationProvider, $super) {
    presentationProvider = presentationProvider === VOID ? Companion_getInstance_98().z6q_1 : presentationProvider;
    var tmp;
    if ($super === VOID) {
      this.s6t(tag, presentationProvider);
      tmp = Unit_instance;
    } else {
      tmp = $super.s6t.call(this, tag, presentationProvider);
    }
    return tmp;
  }
  initMetadataForInterface(ReferenceTargetPresentationProvidersRegistryBuilder, 'ReferenceTargetPresentationProvidersRegistryBuilder', VOID, VOID, [ServicesScope]);
  initMetadataForClass(ReferenceTargetPresentationProvidersRegistryBuilderImpl, 'ReferenceTargetPresentationProvidersRegistryBuilderImpl', VOID, VOID, [ReferenceTargetPresentationProvidersRegistryBuilder, ServicesScope]);
  initMetadataForClass(ReferenceTargetPresentationProvidersRegistryImpl, 'ReferenceTargetPresentationProvidersRegistryImpl');
  initMetadataForObject(ReferenceTargetsSuppliersRegistryService, 'ReferenceTargetsSuppliersRegistryService', VOID, VOID, [Key_5]);
  initMetadataForObject(ReferenceTargetsSuppliersRegistryAspect, 'ReferenceTargetsSuppliersRegistryAspect', VOID, VOID, [LanguageAspect]);
  initMetadataForClass(ReferenceTargetsSuppliersRegistryDefinition, 'ReferenceTargetsSuppliersRegistryDefinition');
  initMetadataForClass(ReferenceTargetsSuppliersRegistryBuilderImpl, 'ReferenceTargetsSuppliersRegistryBuilderImpl', VOID, VOID, [ServicesScope]);
  initMetadataForClass(ReferenceTargetsSuppliersRegistryImpl, 'ReferenceTargetsSuppliersRegistryImpl');
  initMetadataForClass(ResolveConfigImpl, 'ResolveConfigImpl');
  initMetadataForObject(ResolveConfigService, 'ResolveConfigService', VOID, VOID, [Key_5]);
  initMetadataForCompanion(Companion_103);
  initMetadataForObject($serializer_2, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(ReferenceContent, 'ReferenceContent', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_105});
  initMetadataForClass(QualifiedReferenceContent, 'QualifiedReferenceContent', VOID, ReferenceContent, VOID, VOID, VOID, {0: $serializer_getInstance_2});
  initMetadataForCompanion(Companion_104);
  initMetadataForObject($serializer_3, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(LocalReferenceContent, 'LocalReferenceContent', VOID, ReferenceContent, VOID, VOID, VOID, {0: $serializer_getInstance_3});
  initMetadataForCompanion(Companion_105, VOID, [SerializerFactory]);
  initMetadataForCompanion(Companion_106);
  initMetadataForObject($serializer_4, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(DynamicReferenceContent, 'DynamicReferenceContent', DynamicReferenceContent, ReferenceContent, VOID, VOID, VOID, {0: $serializer_getInstance_4});
  initMetadataForInterface(ContentFactory, 'ContentFactory');
  initMetadataForClass(sam$jetbrains_ocelot_langDef_references_content_ReferenceContentFactories_ContentFactory$0, 'sam$jetbrains_ocelot_langDef_references_content_ReferenceContentFactories_ContentFactory$0', VOID, VOID, [ContentFactory, FunctionAdapter]);
  initMetadataForObject(ReferenceContentFactories, 'ReferenceContentFactories');
  initMetadataForClass(DelegatePersister, 'DelegatePersister', VOID, VOID, [NonNullPersister]);
  initMetadataForObject(ReferenceContentPersisters, 'ReferenceContentPersisters');
  function provide(enclosingNode) {
    // Inline function 'jetbrains.ocelot.langDef.query.query' call
    return new DocumentContainerProvider$provide$$inlined$query$1(this);
  }
  initMetadataForInterface(DocumentContainerProvider, 'DocumentContainerProvider');
  initMetadataForClass(BaseDocumentRepository, 'BaseDocumentRepository', VOID, VOID, [DocumentContainerProvider, Disposable]);
  initMetadataForCompanion(Companion_107, VOID, [Key_5]);
  initMetadataForClass(LocalDocumentRepository, 'LocalDocumentRepository', VOID, BaseDocumentRepository);
  initMetadataForCompanion(Companion_108);
  initMetadataForClass(sam$jetbrains_ocelot_base_observable_event_EventSource$0, 'sam$jetbrains_ocelot_base_observable_event_EventSource$0', VOID, VOID, [EventSource, FunctionAdapter]);
  initMetadataForClass(BaseDocumentContainer$documents$$inlined$query$1, VOID, VOID, VOID, [Query], [1]);
  initMetadataForClass(BaseDocumentContainer$getDocumentQuery$$inlined$query$1, VOID, VOID, VOID, [Query], [1]);
  initMetadataForClass(BaseDocumentContainer, 'BaseDocumentContainer', VOID, VOID, [Disposable]);
  initMetadataForCompanion(Companion_109, VOID, [Key_5]);
  initMetadataForClass(DocumentContainerProvider$provide$$inlined$query$1, VOID, VOID, VOID, [Query], [1]);
  initMetadataForClass(AttributePersisters$baseDecimalPersister$1, VOID, VOID, VOID, [NonNullPersister]);
  initMetadataForObject(AttributePersisters, 'AttributePersisters');
  initMetadataForObject(NodeIdSerializer, 'NodeIdSerializer', VOID, VOID, [KSerializer]);
  initMetadataForCompanion(Companion_110, VOID, [Key_5]);
  initMetadataForClass(serialization$2$builder$1, VOID, VOID, VOID, [ServicesScope]);
  initMetadataForClass(serialization$2$1);
  initMetadataForObject(DocumentIdUtil, 'DocumentIdUtil');
  initMetadataForInterface(DocumentNode, 'DocumentNode', VOID, VOID, [DomainNode]);
  function get_id() {
    return new NodeId();
  }
  function get_conceptId() {
    return NodeConceptIdFactory_getInstance().u3q('non-concept');
  }
  function get_root() {
    return null;
  }
  function get_observableParent() {
    return new ValueProperty(null);
  }
  function get_roleInParent() {
    return null;
  }
  function clone() {
    return this;
  }
  function detach() {
    return Unit_instance;
  }
  function replaceWith(new_0) {
    return Unit_instance;
  }
  function getDescendants(includeSelf) {
    return emptySequence();
  }
  function getAllChildren() {
    return emptySequence();
  }
  initMetadataForInterface(LightDomainNode, 'LightDomainNode', VOID, VOID, [DomainNode]);
  initMetadataForInterface(Named, 'Named', VOID, VOID, [DomainNode]);
  initMetadataForInterface(DirectlyNamed, 'DirectlyNamed', VOID, VOID, [Named]);
  initMetadataForClass(NodeFactory, 'NodeFactory');
  initMetadataForClass(ChildLink, 'ChildLink', VOID, NodeLink);
  initMetadataForClass(MultipleChildLink, 'MultipleChildLink', VOID, ChildLink);
  initMetadataForClass(AttributeLink, 'AttributeLink', VOID, NodeLink);
  initMetadataForClass(ValueAttributeLink, 'ValueAttributeLink', VOID, AttributeLink);
  initMetadataForClass(SingleChildLink, 'SingleChildLink', VOID, ChildLink);
  initMetadataForClass(TextAttributeLink, 'TextAttributeLink', VOID, AttributeLink);
  initMetadataForCompanion(Companion_111);
  initMetadataForObject($serializer_5, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(SerializedChildLink, 'SerializedChildLink', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_5});
  initMetadataForClass(ChildContext, 'ChildContext');
  initMetadataForInterface(KnowsTargetConcept, 'KnowsTargetConcept');
  initMetadataForClass(WrapStep, 'WrapStep', VOID, VOID, [KnowsTargetConcept]);
  initMetadataForClass(WrapStep$Companion$create$1, VOID, VOID, WrapStep);
  initMetadataForCompanion(Companion_112);
  initMetadataForInterface(UnwrapStep, 'UnwrapStep');
  initMetadataForClass(IdentityStep, 'IdentityStep', VOID, VOID, [KnowsTargetConcept]);
  initMetadataForClass(TransformStep, 'TransformStep', VOID, VOID, [KnowsTargetConcept]);
  initMetadataForClass(TransformStep$Companion$create$1, VOID, VOID, TransformStep);
  initMetadataForCompanion(Companion_113);
  initMetadataForClass(sam$jetbrains_ocelot_langDef_structure_adaptation_UnwrapStep$0, 'sam$jetbrains_ocelot_langDef_structure_adaptation_UnwrapStep$0', VOID, VOID, [UnwrapStep, FunctionAdapter]);
  initMetadataForClass(NodeAdaptationSupportImpl$findPath$Context, 'Context');
  initMetadataForClass(NodeAdaptationSupportImpl, 'NodeAdaptationSupportImpl');
  initMetadataForCompanion(Companion_114);
  initMetadataForClass(NodeAdapter, 'NodeAdapter');
  initMetadataForClass(sam$jetbrains_ocelot_langDef_structure_adaptation_UnwrapStep$0_0, 'sam$jetbrains_ocelot_langDef_structure_adaptation_UnwrapStep$0', VOID, VOID, [UnwrapStep, FunctionAdapter]);
  initMetadataForCompanion(Companion_115);
  initMetadataForClass(BaseConceptRegistry, 'BaseConceptRegistry');
  initMetadataForClass(ConceptImplementationRegistryRecord, 'ConceptImplementationRegistryRecord');
  initMetadataForClass(ConceptRegistryBasedNodeFactory, 'ConceptRegistryBasedNodeFactory', VOID, NodeFactory);
  initMetadataForClass(ConceptRegistryBuilderImpl, 'ConceptRegistryBuilderImpl', VOID, VOID, [ServicesScope]);
  initMetadataForClass(ConceptRegistryRecord, 'ConceptRegistryRecord');
  initMetadataForClass(DomainNodeConceptRegistry$getNodeFactory$1, VOID, VOID, VOID, [OtNodeFactory]);
  initMetadataForClass(DomainNodeConceptRegistry, 'DomainNodeConceptRegistry', VOID, BaseConceptRegistry);
  initMetadataForClass(NodeWrapperConceptRegistryImpl$nodeWrapperFactory$1, VOID, VOID, NodeWrapperFactory);
  initMetadataForClass(NodeWrapperConceptRegistryImpl, 'NodeWrapperConceptRegistryImpl', VOID, BaseConceptRegistry, [BaseConceptRegistry, NodeWrapperConceptRegistry]);
  initMetadataForObject(StructureAspect, 'StructureAspect', VOID, VOID, [LanguageAspect]);
  initMetadataForObject(ConceptRegistryService, 'ConceptRegistryService', VOID, VOID, [Key_5]);
  initMetadataForClass(ConceptDefinitions, 'ConceptDefinitions');
  initMetadataForClass(ConceptData, 'ConceptData');
  initMetadataForClass(ChildrenMemberData, 'ChildrenMemberData');
  initMetadataForClass(AttributeData, 'AttributeData');
  initMetadataForClass(AttributeType, 'AttributeType');
  initMetadataForClass(SimpleAttributeType, 'SimpleAttributeType', VOID, AttributeType);
  initMetadataForClass(ReferenceMemberData, 'ReferenceMemberData');
  initMetadataForClass(EnumAttributeType, 'EnumAttributeType', VOID, SimpleAttributeType);
  initMetadataForClass(BaseStructureModel, 'BaseStructureModel', VOID, VOID, [Disposable]);
  initMetadataForCompanion(Companion_116);
  initMetadataForClass(EntityNodeLayout, 'EntityNodeLayout');
  initMetadataForClass(SingleRootHolder$Companion$wrapperFactory$$inlined$entityWrapperFactory$1);
  initMetadataForCompanion(Companion_117, VOID, [Key_5]);
  initMetadataForClass(SingleRootEntityWrapper, 'SingleRootEntityWrapper', VOID, EntityWrapper);
  initMetadataForClass(SingleRootHolder, 'SingleRootHolder');
  initMetadataForClass(SingleRootStructureModel, 'SingleRootStructureModel', VOID, BaseStructureModel);
  initMetadataForClass(ancestorOrSelf$$inlined$query$1, VOID, VOID, VOID, [Query], [1]);
  initMetadataForClass(ErrorBase, 'ErrorBase');
  initMetadataForClass(ErrorForAllNode, 'ErrorForAllNode', VOID, ErrorBase);
  initMetadataForClass(ErrorForDescendants, 'ErrorForDescendants', VOID, ErrorBase);
  initMetadataForClass(ErrorKind, 'ErrorKind', VOID, Enum);
  initMetadataForCompanion(Companion_118, VOID, [Key_5]);
  initMetadataForInterface(ErrorCheckConfig, 'ErrorCheckConfig');
  initMetadataForObject(Empty_1, 'Empty', VOID, VOID, [ErrorCheckConfig]);
  initMetadataForObject(EmptyErrorCheckConfig, 'EmptyErrorCheckConfig', VOID, VOID, [ErrorCheckConfig]);
  initMetadataForClass(ErrorCheckConfigBuilder, 'ErrorCheckConfigBuilder', VOID, VOID, [ServicesScope]);
  initMetadataForClass(ErrorCheckConfigBuilderImpl$build$1, VOID, VOID, VOID, [ErrorCheckConfig]);
  initMetadataForClass(ErrorCheckConfigBuilderImpl, 'ErrorCheckConfigBuilderImpl', VOID, ErrorCheckConfigBuilder, [ErrorCheckConfigBuilder, ServicesScope]);
  initMetadataForClass(asChecker$1);
  initMetadataForCoroutine($runSuspendCOROUTINE$_2, CoroutineImpl);
  initMetadataForClass(CompositeScopeFilter$apply$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForInterface(ScopeFilter, 'ScopeFilter');
  initMetadataForClass(CompositeScopeFilter, 'CompositeScopeFilter', VOID, VOID, [ScopeFilter]);
  initMetadataForClass(sam$jetbrains_ocelot_langDef_scopes_api_ScopeFilter$0, 'sam$jetbrains_ocelot_langDef_scopes_api_ScopeFilter$0', VOID, VOID, [ScopeFilter, FunctionAdapter]);
  initMetadataForCoroutine($runSuspendCOROUTINE$_3, CoroutineImpl);
  initMetadataForClass(anyOf$2$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForCompanion(Companion_119);
  initMetadataForClass(NamingInfo, 'NamingInfo');
  initMetadataForClass(NamedNode, 'NamedNode');
  initMetadataForObject(NoopScopeFilter, 'NoopScopeFilter', VOID, VOID, [ScopeFilter]);
  initMetadataForClass(Origin, 'Origin');
  initMetadataForClass(DefaultOrigin, 'DefaultOrigin', VOID, Origin);
  initMetadataForClass(ImportOrigin, 'ImportOrigin', VOID, Origin);
  initMetadataForClass(LexicalOrigin, 'LexicalOrigin', VOID, Origin);
  initMetadataForClass(ChildPlaceholderOrigin, 'ChildPlaceholderOrigin', VOID, LexicalOrigin);
  function find_0(pointer) {
    return Companion_getInstance_81().g60_1;
  }
  function applyFilter(filter) {
    var tmp;
    if (filter instanceof NoopScopeFilter) {
      tmp = this;
    } else {
      tmp = new FilteredScope(this, filter);
    }
    return tmp;
  }
  initMetadataForInterface(Scope, 'Scope');
  initMetadataForCoroutine($runSuspendCOROUTINE$_4, CoroutineImpl);
  initMetadataForClass(sam$jetbrains_ocelot_langDef_scopes_api_ScopeFilter$0_0, 'sam$jetbrains_ocelot_langDef_scopes_api_ScopeFilter$0', VOID, VOID, [ScopeFilter, FunctionAdapter]);
  initMetadataForClass(ScopeFilter$Companion$query$2$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForCompanion(Companion_120);
  initMetadataForClass(FallbackScopingRulesProvider$namespace$1);
  initMetadataForClass(FallbackScopingRulesProvider, 'FallbackScopingRulesProvider');
  initMetadataForObject(ScopeAspect, 'ScopeAspect', VOID, VOID, [LanguageAspect]);
  initMetadataForClass(ScopeDefinition, 'ScopeDefinition');
  initMetadataForClass(ScopeConstraintRuleSpec, 'ScopeConstraintRuleSpec');
  initMetadataForClass(ConstraintProviderSpec, 'ConstraintProviderSpec');
  function with_0(_this__u8e3s4, constraint) {
    return new ScopeConstraintRuleSpec(_this__u8e3s4.r74_1, constraint);
  }
  initMetadataForInterface(ScopeConfigBuilder, 'ScopeConfigBuilder', VOID, VOID, [ServicesScope]);
  initMetadataForClass(ScopingRuleSpec, 'ScopingRuleSpec');
  initMetadataForClass(ScopeConfigBuilder0, 'ScopeConfigBuilder0', VOID, VOID, [ServicesScope]);
  initMetadataForClass(ScopeConfigBuilder0Fallback, 'ScopeConfigBuilder0Fallback', VOID, ScopeConfigBuilder0, [ScopeConfigBuilder0, ScopeConfigBuilder]);
  initMetadataForCoroutine($runSuspendCOROUTINE$_5, CoroutineImpl);
  initMetadataForInterface(ScopeConstraintProvider, 'ScopeConstraintProvider');
  initMetadataForClass(sam$jetbrains_ocelot_langDef_scopes_config_api_ScopeConstraintProvider$0, 'sam$jetbrains_ocelot_langDef_scopes_config_api_ScopeConstraintProvider$0', VOID, VOID, [ScopeConstraintProvider, FunctionAdapter]);
  initMetadataForClass(ScopeConfigBuilderImpl$by$4$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(ScopeConfigBuilderImpl, 'ScopeConfigBuilderImpl', VOID, VOID, [ScopeConfigBuilder, ServicesScope]);
  initMetadataForClass(CollectionScopeFactory$Companion$Default$1);
  initMetadataForClass(CollectionScopeFactory$Companion$Indexed$1);
  initMetadataForCompanion(Companion_121);
  initMetadataForCoroutine($runSuspendCOROUTINE$_6, CoroutineImpl);
  initMetadataForClass(createIndexingScope$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(OriginSelector, 'OriginSelector');
  initMetadataForObject(Any, 'Any', VOID, OriginSelector);
  initMetadataForObject(Lexical, 'Lexical', VOID, OriginSelector);
  initMetadataForObject(Import, 'Import', VOID, OriginSelector);
  initMetadataForClass(LexicalWithRole, 'LexicalWithRole', VOID, OriginSelector);
  initMetadataForCompanion(Companion_122);
  initMetadataForClass(RuleEvaluationScope, 'RuleEvaluationScope');
  initMetadataForClass(RuleEvaluationStrategy, 'RuleEvaluationStrategy', VOID, Enum);
  initMetadataForCoroutine($constrainedInAncestorsCOROUTINE$, CoroutineImpl);
  initMetadataForClass(ScopeBuilder, 'ScopeBuilder', VOID, QueryBuilder, VOID, [1, 0]);
  initMetadataForClass(ScopeBuilderWithProvider, 'ScopeBuilderWithProvider', VOID, ScopeBuilder, VOID, [0, 2, 1]);
  initMetadataForCoroutine($importScopeCOROUTINE$, CoroutineImpl);
  initMetadataForObject(ScopeConfigService, 'ScopeConfigService', VOID, VOID, [Key_5]);
  initMetadataForClass(ScopeConstraintBuilder, 'ScopeConstraintBuilder', VOID, QueryBuilder, VOID, [1]);
  initMetadataForClass(ScopeConstraintId, 'ScopeConstraintId', ScopeConstraintId);
  initMetadataForInterface(ScopeProvidersRegistry, 'ScopeProvidersRegistry');
  initMetadataForClass(ScopingRuleDefinition, 'ScopingRuleDefinition');
  initMetadataForClass(ProvideScope, 'ProvideScope', VOID, ScopingRuleDefinition);
  initMetadataForClass(DefaultScope, 'DefaultScope', VOID, ScopingRuleDefinition);
  initMetadataForClass(ConstrainScope, 'ConstrainScope', VOID, ScopingRuleDefinition);
  initMetadataForClass(ProvideName, 'ProvideName', VOID, ScopingRuleDefinition);
  initMetadataForCoroutine($runSuspendCOROUTINE$_7, CoroutineImpl);
  initMetadataForClass(ScopeKey, 'ScopeKey');
  initMetadataForCompanion(Companion_123, VOID, [Key_5]);
  initMetadataForClass(SharedScopesContainer$indexingScopeFor$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForObject(Empty_2, 'Empty');
  initMetadataForCompanion(Companion_124, VOID, [Key_5]);
  initMetadataForCoroutine($runSuspendCOROUTINE$_8, CoroutineImpl);
  initMetadataForClass(DefaultScopesManager$getScope$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(DefaultScopesManager, 'DefaultScopesManager');
  initMetadataForClass(NameProvidersManager, 'NameProvidersManager');
  initMetadataForObject(NoScopeSpecificationContext, 'NoScopeSpecificationContext');
  initMetadataForCompanion(Companion_125);
  initMetadataForClass(NodeLocation, 'NodeLocation');
  initMetadataForCoroutine($runSuspendCOROUTINE$_9, CoroutineImpl);
  initMetadataForClass(ParentChildScopes$nearestEnclosingOrDefaultScope$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(ParentChildScopes, 'ParentChildScopes');
  initMetadataForCoroutine($runSuspendCOROUTINE$_10, CoroutineImpl);
  initMetadataForCoroutine($runSuspendCOROUTINE$_11, CoroutineImpl);
  initMetadataForClass(ParentScopeConstraints$collectConstraints$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(ParentScopeConstraints$tryConstraintRule$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(ParentScopeConstraints, 'ParentScopeConstraints');
  initMetadataForClass(ProviderSpec, 'ProviderSpec');
  initMetadataForClass(ProvideScopeRulesContainer, 'ProvideScopeRulesContainer');
  initMetadataForClass(ProvidedScopeSpec, 'ProvidedScopeSpec');
  initMetadataForCoroutine($runSuspendCOROUTINE$_12, CoroutineImpl);
  initMetadataForClass(ConstraintSpec, 'ConstraintSpec');
  initMetadataForClass(ScopeConstraintsManager$getScopeConstraint$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(ScopeConstraintsManager, 'ScopeConstraintsManager');
  initMetadataForCoroutine($runSuspendCOROUTINE$_13, CoroutineImpl);
  initMetadataForCoroutine($runSuspendCOROUTINE$_14, CoroutineImpl);
  initMetadataForCoroutine($runSuspendCOROUTINE$_15, CoroutineImpl);
  initMetadataForCoroutine($runSuspendCOROUTINE$_16, CoroutineImpl);
  initMetadataForClass(ScopeContextImpl$parentScope$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(ScopeContextImpl$importScope$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(ScopeContextImpl$importScope$$inlined$suspendingQuery$2, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(ScopeContextImpl$defaultScope$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(ScopeContextImpl, 'ScopeContextImpl');
  initMetadataForCoroutine($runSuspendCOROUTINE$_17, CoroutineImpl);
  initMetadataForClass(ScopeProvidersManager$ProvidedScopesContainer$readScopeProperty$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForCoroutine($runSuspendCOROUTINE$_18, CoroutineImpl);
  initMetadataForClass(ScopeProvidersManager$populateScopesFor$2$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForCoroutine($runSuspendCOROUTINE$_19, CoroutineImpl);
  initMetadataForClass(ProvidedScopesContainer, 'ProvidedScopesContainer', VOID, VOID, [Disposable]);
  initMetadataForCompanion(Companion_126);
  initMetadataForLambda(ScopeProvidersManager$populateScopesFor$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(ScopeProvidersManager$getScope$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(ScopeProvidersManager, 'ScopeProvidersManager', VOID, VOID, [Disposable]);
  initMetadataForCompanion(Companion_127, VOID, [Key_5]);
  initMetadataForCoroutine($runSuspendCOROUTINE$_20, CoroutineImpl);
  initMetadataForCoroutine($runSuspendCOROUTINE$_21, CoroutineImpl);
  initMetadataForCoroutine($runSuspendCOROUTINE$_22, CoroutineImpl);
  initMetadataForClass(sam$jetbrains_ocelot_langDef_scopes_config_api_ScopeConstraintProvider$0_0, 'sam$jetbrains_ocelot_langDef_scopes_config_api_ScopeConstraintProvider$0', VOID, VOID, [ScopeConstraintProvider, FunctionAdapter]);
  initMetadataForClass(sam$jetbrains_ocelot_base_disposable_Disposable$0_3, 'sam$jetbrains_ocelot_base_disposable_Disposable$0', VOID, VOID, [Disposable, FunctionAdapter]);
  initMetadataForClass(sam$jetbrains_ocelot_langDef_scopes_config_api_ScopeProvidersRegistry$0, 'sam$jetbrains_ocelot_langDef_scopes_config_api_ScopeProvidersRegistry$0', VOID, VOID, [ScopeProvidersRegistry, FunctionAdapter]);
  initMetadataForClass(ScopingRulesEngine$getDefaultScope$$inlined$mapSuspending$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(ScopingRulesEngine$getDocumentScope$$inlined$map$1, VOID, VOID, VOID, [Query], [1]);
  initMetadataForClass(ScopingRulesEngine$getDocumentScope$$inlined$map$2, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(ScopingRulesEngine$getScopeConstraint$2$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(ScopingRulesEngine, 'ScopingRulesEngine');
  initMetadataForClass(ScopingRulesEngineRemoteAdapter, 'ScopingRulesEngineRemoteAdapter');
  initMetadataForClass(AnnotatedDocumentsList, 'AnnotatedDocumentsList', VOID, VOID, [ObservableList]);
  initMetadataForLambda(CollectionScope$getElements$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(CollectionScope, 'CollectionScope', VOID, VOID, [Scope]);
  initMetadataForCoroutine($runSuspendCOROUTINE$_23, CoroutineImpl);
  initMetadataForCoroutine($runSuspendCOROUTINE$_24, CoroutineImpl);
  initMetadataForClass(CompositeScope$find$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(CompositeScope$contains$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForLambda(CompositeScope$getElements$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(CompositeScope, 'CompositeScope', VOID, VOID, [Scope]);
  initMetadataForClass(DelegatingScope, 'DelegatingScope', VOID, VOID, [Scope]);
  initMetadataForClass(EmptyScope, 'EmptyScope', EmptyScope, VOID, [Scope]);
  initMetadataForCoroutine($runSuspendCOROUTINE$_25, CoroutineImpl);
  initMetadataForCoroutine($runSuspendCOROUTINE$_26, CoroutineImpl);
  initMetadataForLambda(FilteredScope$getElements$o$collect$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($collectCOROUTINE$_14, CoroutineImpl);
  initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0_7, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
  initMetadataForClass(FilteredScope$find$$inlined$flatMap$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(FilteredScope$contains$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(FilteredScope$getElements$$inlined$filter$1, VOID, VOID, VOID, [Flow], [1]);
  initMetadataForClass(FilteredScope, 'FilteredScope', VOID, DelegatingScope);
  initMetadataForClass(sam$jetbrains_ocelot_langDef_scopes_api_ScopeFilter$0_1, 'sam$jetbrains_ocelot_langDef_scopes_api_ScopeFilter$0', VOID, VOID, [ScopeFilter, FunctionAdapter]);
  initMetadataForCoroutine($runSuspendCOROUTINE$_27, CoroutineImpl);
  initMetadataForClass(filter$2$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForCompanion(Companion_128);
  initMetadataForCoroutine($runSuspendCOROUTINE$_28, CoroutineImpl);
  initMetadataForCoroutine($runSuspendCOROUTINE$_29, CoroutineImpl);
  initMetadataForClass(ItemData, 'ItemData');
  initMetadataForClass(ItemRecord, 'ItemRecord');
  initMetadataForClass(sam$kotlin_Comparator$0_0, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
  initMetadataForClass(sam$kotlin_Comparator$0_1, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
  function onTargetAdded(target, name) {
    return this.v7s(target, EventType_ADD_getInstance(), name);
  }
  function onTargetRenamed(target, name) {
    return this.v7s(target, EventType_SET_getInstance(), name);
  }
  function onTargetRemoved(target) {
    return this.v7s(target, EventType_REMOVE_getInstance(), null);
  }
  initMetadataForInterface(ScopeListenerAdapter, 'ScopeListenerAdapter');
  initMetadataForClass(sam$jetbrains_ocelot_langDef_scopes_helper_ScopeListenerAdapter$0, 'sam$jetbrains_ocelot_langDef_scopes_helper_ScopeListenerAdapter$0', VOID, VOID, [ScopeListenerAdapter, FunctionAdapter]);
  initMetadataForClass(IndexingScope$depend$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(IndexingScope$contains$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForLambda(IndexingScope$getElements$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(IndexingScope, 'IndexingScope', VOID, VOID, [Scope]);
  initMetadataForLambda(IndexingCollectionScope$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($IndexingCollectionScopeCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($IndexingCollectionScope$insertItemCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($IndexingCollectionScope$populateScopeCOROUTINE$, CoroutineImpl);
  initMetadataForClass(LocatableScope, 'LocatableScope', VOID, DelegatingScope);
  initMetadataForObject(Scopes, 'Scopes');
  initMetadataForCoroutine($runSuspendCOROUTINE$_30, CoroutineImpl);
  initMetadataForCoroutine($runSuspendCOROUTINE$_31, CoroutineImpl);
  initMetadataForClass(UniqueSumScope$find$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(UniqueSumScope$contains$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForLambda(UniqueSumScope$getElements$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(UniqueSumScope, 'UniqueSumScope', VOID, VOID, [Scope]);
  initMetadataForClass(AbstractScopedReferenceResolver, 'AbstractScopedReferenceResolver', VOID, VOID, [ReferenceResolver], [2]);
  initMetadataForLambda(AbstractScopedReferenceTargetsSupplier$getElements$slambda$o$runSuspend$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(AbstractScopedReferenceTargetsSupplier$getElements$slambda$o$runSuspend$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(AbstractScopedReferenceTargetsSupplier$getElements$slambda$o$runSuspend$slambda_1, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($runSuspendCOROUTINE$_32, CoroutineImpl);
  initMetadataForClass(AbstractScopedReferenceTargetsSupplier$getElements$2$$inlined$executeSuspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0_8, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
  initMetadataForLambda(AbstractScopedReferenceTargetsSupplier$getElements$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(AbstractScopedReferenceTargetsSupplier, 'AbstractScopedReferenceTargetsSupplier', VOID, VOID, [ReferenceTargetsSupplier]);
  initMetadataForClass(ScopedReferenceFactoryRegistryBuilder, 'ScopedReferenceFactoryRegistryBuilder');
  initMetadataForCoroutine($runSuspendCOROUTINE$_33, CoroutineImpl);
  initMetadataForCoroutine($runSuspendCOROUTINE$_34, CoroutineImpl);
  initMetadataForClass(ScopedReferenceResolver$resolve$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(ScopedReferenceResolver$find$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForCoroutine($findByPointerCOROUTINE$, CoroutineImpl);
  initMetadataForClass(ScopedReferenceResolver, 'ScopedReferenceResolver', VOID, AbstractScopedReferenceResolver, VOID, [3, 2]);
  initMetadataForCoroutine($runSuspendCOROUTINE$_35, CoroutineImpl);
  initMetadataForClass(ScopedReferenceTargetPresentationProvider$getPresentation$$inlined$flatMap$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(ScopedReferenceTargetPresentationProvider, 'ScopedReferenceTargetPresentationProvider', VOID, VOID, [TargetPresentationProvider]);
  initMetadataForClass(ScopedReferenceTargetsSupplier$referenceContents$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(ScopedReferenceTargetsSupplier, 'ScopedReferenceTargetsSupplier', VOID, AbstractScopedReferenceTargetsSupplier);
  initMetadataForInterface(TargetInfoStub, 'TargetInfoStub', VOID, VOID, [LightDomainNode]);
  initMetadataForObject(AbsentScopeOwner, 'AbsentScopeOwner');
  initMetadataForClass(ScopeContent, 'ScopeContent');
  initMetadataForClass(ScopeId, 'ScopeId');
  initMetadataForClass(Default_1, 'Default', VOID, ScopeId);
  initMetadataForClass(Exported, 'Exported', VOID, ScopeId);
  initMetadataForClass(Lexical_0, 'Lexical', VOID, ScopeId);
  initMetadataForClass(Children, 'Children', VOID, ScopeId);
  initMetadataForClass(Collection_0, 'Collection', Collection_0, ScopeId);
  initMetadataForCompanion(Companion_129);
  initMetadataForClass(ScopeSpecification, 'ScopeSpecification');
  initMetadataForCompanion(Companion_130);
  initMetadataForClass(ScopeTree, 'ScopeTree');
  initMetadataForObject(FindUsagesAspect, 'FindUsagesAspect', VOID, VOID, [LanguageAspect]);
  initMetadataForClass(FindUsagesDefinition, 'FindUsagesDefinition');
  initMetadataForObject(FindUsagesConfigService, 'FindUsagesConfigService', VOID, VOID, [Key_5]);
  initMetadataForClass(FindUsagesData, 'FindUsagesData');
  initMetadataForClass(ProperUsage, 'ProperUsage', VOID, FindUsagesData);
  initMetadataForObject(DontKnow, 'DontKnow', VOID, FindUsagesData);
  initMetadataForClass(ReferenceContext, 'ReferenceContext');
  initMetadataForClass(FindUsagesConfigBuilderImpl$build$1);
  initMetadataForClass(FindUsagesConfigBuilderImpl, 'FindUsagesConfigBuilderImpl');
  initMetadataForClass(UsagePresentationData, 'UsagePresentationData', VOID, VOID, [LightDomainNode]);
  initMetadataForClass(UsageKind, 'UsageKind');
  initMetadataForObject(DefaultUsageKind, 'DefaultUsageKind', VOID, UsageKind);
  initMetadataForClass(DefaultUsagePresentation, 'DefaultUsagePresentation', VOID, UsagePresentationData);
  initMetadataForClass(Usage, 'Usage');
  initMetadataForClass(MapperUpdater, 'MapperUpdater');
  function dispose() {
    return this.e6j();
  }
  initMetadataForInterface(Synchronizer, 'Synchronizer', VOID, VOID, [Disposable]);
  initMetadataForClass(BaseRoleSynchronizer, 'BaseRoleSynchronizer', VOID, VOID, [Synchronizer]);
  initMetadataForClass(BaseCollectionRoleSynchronizer, 'BaseCollectionRoleSynchronizer', VOID, BaseRoleSynchronizer);
  initMetadataForCompanion(Companion_131);
  initMetadataForClass(ByTargetIndex$1);
  initMetadataForClass(ByTargetIndex, 'ByTargetIndex', VOID, VOID, [Disposable]);
  initMetadataForClass(DifferenceItem, 'DifferenceItem');
  initMetadataForClass(DifferenceBuilder, 'DifferenceBuilder');
  initMetadataForClass(DisposableSynchronizer, 'DisposableSynchronizer', VOID, VOID, [Synchronizer]);
  initMetadataForClass(syncOneWay$1, VOID, VOID, DisposableSynchronizer);
  initMetadataForClass(syncTwoWay$1, VOID, VOID, VOID, [Synchronizer]);
  initMetadataForInterface(ChildContainer, 'ChildContainer');
  initMetadataForClass(ChildProperty_0, 'ChildProperty', VOID, ValueProperty, [ValueProperty, ChildContainer]);
  initMetadataForClass(ChildList, 'ChildList', VOID, ObservableArrayList, [ObservableArrayList, ChildContainer]);
  initMetadataForClass(ChildSet, 'ChildSet', VOID, ObservableHashSet, [ObservableHashSet, ChildContainer]);
  initMetadataForClass(State_0, 'State', VOID, Enum);
  initMetadataForCompanion(Companion_132);
  initMetadataForClass(Mapper$instantiateSynchronizers$1);
  initMetadataForClass(Mapper$attach$synchronizerContext$1);
  initMetadataForClass(Mapper, 'Mapper');
  initMetadataForClass(Mappers$attachRoot$$inlined$toDisposable$1, VOID, VOID, VOID, [Disposable]);
  initMetadataForClass(Mappers$augment$1, VOID, VOID, Mapper);
  initMetadataForObject(Mappers, 'Mappers');
  initMetadataForClass(MappingContext, 'MappingContext', MappingContext);
  initMetadataForClass(MappingContextProperty, 'MappingContextProperty');
  initMetadataForClass(ObservableCollectionRoleSynchronizer$onAttach$1, VOID, VOID, CollectionAdapter);
  initMetadataForClass(ObservableCollectionRoleSynchronizer, 'ObservableCollectionRoleSynchronizer', VOID, BaseCollectionRoleSynchronizer);
  initMetadataForClass(SingleChildRoleSynchronizer, 'SingleChildRoleSynchronizer', VOID, BaseRoleSynchronizer);
  initMetadataForClass(Synchronizers$forProperty$$inlined$forEventSource$1, VOID, VOID, DisposableSynchronizer);
  initMetadataForClass(Synchronizers$forDisposables$1, VOID, VOID, VOID, [Synchronizer]);
  initMetadataForClass(Synchronizers$composite$1, VOID, VOID, VOID, [Synchronizer]);
  initMetadataForObject(Synchronizers, 'Synchronizers');
  initMetadataForClass(State_1, 'State', VOID, Enum);
  initMetadataForClass(ReloadableSynchronizer, 'ReloadableSynchronizer', ReloadableSynchronizer, VOID, [Synchronizer]);
  initMetadataForCompanion(Companion_133);
  initMetadataForClass(DoubleRectangle, 'DoubleRectangle');
  initMetadataForClass(DoubleSegment, 'DoubleSegment');
  initMetadataForCompanion(Companion_134);
  initMetadataForClass(DoubleVector, 'DoubleVector');
  initMetadataForCompanion(Companion_135);
  initMetadataForClass(Rectangle, 'Rectangle');
  initMetadataForObject(Rectangles, 'Rectangles');
  initMetadataForCompanion(Companion_136);
  initMetadataForClass(Vector, 'Vector');
  initMetadataForClass(DomUtil$nodeChildren$1, VOID, VOID, AbstractMutableList);
  initMetadataForClass(DomUtil$timerBasedProperty$1, VOID, VOID, UpdatableProperty);
  initMetadataForObject(DomUtil, 'DomUtil');
  initMetadataForClass(CssUnit, 'CssUnit', VOID, Enum);
  initMetadataForClass(CssAlignItem, 'CssAlignItem', VOID, Enum);
  initMetadataForClass(CssBorderStyle, 'CssBorderStyle', VOID, Enum);
  initMetadataForClass(CssClear, 'CssClear', VOID, Enum);
  initMetadataForClass(CssDisplay, 'CssDisplay', VOID, Enum);
  initMetadataForClass(CssFloat, 'CssFloat', VOID, Enum);
  initMetadataForClass(CssFontStyle, 'CssFontStyle', VOID, Enum);
  initMetadataForClass(CssFontWeight, 'CssFontWeight', VOID, Enum);
  initMetadataForClass(CssOutlineStyle, 'CssOutlineStyle', VOID, Enum);
  initMetadataForCompanion(Companion_137);
  initMetadataForClass(CssOverflow, 'CssOverflow', VOID, Enum);
  initMetadataForCompanion(Companion_138);
  initMetadataForClass(CssPosition, 'CssPosition', VOID, Enum);
  initMetadataForClass(CssVerticalAlign, 'CssVerticalAlign', VOID, Enum);
  initMetadataForClass(CssVisibility, 'CssVisibility', VOID, Enum);
  initMetadataForClass(CssWhiteSpace, 'CssWhiteSpace', VOID, Enum);
  initMetadataForObject(DomApi, 'DomApi');
  initMetadataForClass(on$eventListener$1);
  initMetadataForClass(onEvent$eventListener$1);
  initMetadataForClass(onEvent$$inlined$toDisposable$1, VOID, VOID, VOID, [Disposable]);
  initMetadataForCompanion(Companion_139);
  initMetadataForClass(DomEventType, 'DomEventType');
  initMetadataForObject(DomImmediatePolyfill, 'DomImmediatePolyfill');
  initMetadataForObject(StyleInjector, 'StyleInjector');
  function toText() {
    throw UnsupportedOperationException_init_$Create$_0(toString_1(getKClassFromExpression(this)));
  }
  initMetadataForInterface(ClipboardContent, 'ClipboardContent');
  initMetadataForClass(Event_0, 'Event', Event_0);
  initMetadataForClass(CompositionEvent, 'CompositionEvent', VOID, Event_0);
  initMetadataForClass(CopyCutEvent, 'CopyCutEvent', CopyCutEvent, Event_0);
  initMetadataForClass(DerivedEvent, 'DerivedEvent', VOID, Event_0);
  initMetadataForClass(DerivedCopyCutEvent, 'DerivedCopyCutEvent', VOID, DerivedEvent);
  initMetadataForObject(EmptyClipboardContent, 'EmptyClipboardContent', VOID, VOID, [ClipboardContent]);
  initMetadataForClass(Key_7, 'Key', VOID, Enum);
  initMetadataForClass(KeyEvent, 'KeyEvent', VOID, Event_0);
  initMetadataForCompanion(Companion_140);
  initMetadataForClass(KeyModifiers, 'KeyModifiers');
  initMetadataForClass(KeyStroke, 'KeyStroke');
  initMetadataForClass(KeyStrokeSpec, 'KeyStrokeSpec');
  initMetadataForObject(KeyStrokeSpecs, 'KeyStrokeSpecs');
  initMetadataForClass(ModifierKey, 'ModifierKey', VOID, Enum);
  initMetadataForClass(MouseButton, 'MouseButton', VOID, Enum);
  initMetadataForCompanion(Companion_141);
  initMetadataForClass(PointEvent, 'PointEvent', VOID, Event_0);
  initMetadataForClass(MouseEvent, 'MouseEvent', VOID, PointEvent);
  initMetadataForClass(PasteEvent, 'PasteEvent', VOID, Event_0);
  initMetadataForClass(TouchEvent, 'TouchEvent', VOID, PointEvent);
  initMetadataForClass(SimpleContentKind, 'SimpleContentKind');
  initMetadataForClass(ListContentKind, 'ListContentKind');
  initMetadataForObject(ContentKinds, 'ContentKinds');
  initMetadataForClass(MultilineTextClipboardContent, 'MultilineTextClipboardContent', VOID, VOID, [ClipboardContent]);
  initMetadataForClass(SingleLineTextClipboardContent, 'SingleLineTextClipboardContent', VOID, VOID, [ClipboardContent]);
  initMetadataForClass(LinesIterator_0, 'LinesIterator');
  initMetadataForClass(TextContentHelper$splitByNewline$1);
  initMetadataForObject(TextContentHelper, 'TextContentHelper');
  initMetadataForCompanion(Companion_142);
  initMetadataForClass(DomClipboardSupport, 'DomClipboardSupport');
  initMetadataForObject(DomEventUtil, 'DomEventUtil');
  initMetadataForObject(DomKeyCodeMapper, 'DomKeyCodeMapper');
  initMetadataForObject(KeyEventUtil, 'KeyEventUtil');
  initMetadataForCompanion(Companion_143);
  initMetadataForClass(MouseTranslator, 'MouseTranslator');
  initMetadataForClass(SimpleKeyTranslator, 'SimpleKeyTranslator');
  initMetadataForClass(TextAreaKeyTranslator, 'TextAreaKeyTranslator');
  initMetadataForCompanion(Companion_144);
  initMetadataForInterface(ClipboardAdapter, 'ClipboardAdapter');
  initMetadataForClass(sam$jetbrains_ocelot_base_clipboard_ClipboardAdapter$0, 'sam$jetbrains_ocelot_base_clipboard_ClipboardAdapter$0', VOID, VOID, [ClipboardAdapter, FunctionAdapter]);
  initMetadataForClass(ClipboardAdapterBuilder, 'ClipboardAdapterBuilder');
  initMetadataForClass(CompositeClipboardContentSerialization, 'CompositeClipboardContentSerialization');
  initMetadataForCoroutine($retrieveCOROUTINE$, CoroutineImpl);
  initMetadataForClass(OnlyTextExternalClipboard, 'OnlyTextExternalClipboard', VOID, VOID, VOID, [0]);
  initMetadataForCoroutine($retrieveCOROUTINE$_0, CoroutineImpl);
  initMetadataForClass(RestoringExternalClipboard, 'RestoringExternalClipboard', VOID, VOID, VOID, [0]);
  initMetadataForCoroutine($retrieveCOROUTINE$_1, CoroutineImpl);
  initMetadataForClass(SerializingExternalClipboard, 'SerializingExternalClipboard', VOID, VOID, VOID, [0]);
  initMetadataForObject(TextClipboardSerialization, 'TextClipboardSerialization');
  initMetadataForClass(MimeTypedData, 'MimeTypedData');
  initMetadataForClass(TrivialSystemClipboard, 'TrivialSystemClipboard', TrivialSystemClipboard, VOID, VOID, [0]);
  initMetadataForCoroutine($retrieveCOROUTINE$_2, CoroutineImpl);
  initMetadataForObject(JsSystemClipboard, 'JsSystemClipboard', VOID, VOID, VOID, [0]);
  function subList(fromIndex, toIndex) {
    return new SubList_1(this, fromIndex, toIndex);
  }
  initMetadataForInterface(ImmutableList, 'ImmutableList', VOID, VOID, [KtList, Collection]);
  initMetadataForClass(SubList_1, 'SubList', VOID, AbstractList, [ImmutableList, AbstractList]);
  initMetadataForClass(AbstractListIterator, 'AbstractListIterator');
  initMetadataForClass(AbstractPersistentList, 'AbstractPersistentList', VOID, AbstractList, [Collection, ImmutableList, AbstractList]);
  initMetadataForClass(BufferIterator, 'BufferIterator', VOID, AbstractListIterator);
  initMetadataForClass(PersistentVector, 'PersistentVector', VOID, AbstractPersistentList, [Collection, ImmutableList, AbstractPersistentList]);
  initMetadataForClass(PersistentVectorIterator, 'PersistentVectorIterator', VOID, AbstractListIterator);
  initMetadataForCompanion(Companion_145);
  initMetadataForClass(SmallPersistentVector, 'SmallPersistentVector', VOID, AbstractPersistentList, [ImmutableList, AbstractPersistentList]);
  initMetadataForClass(TrieIterator, 'TrieIterator', VOID, AbstractListIterator);
  initMetadataForObject(ListImplementation, 'ListImplementation');
  initMetadataForClass(BoundsComposites, 'BoundsComposites');
  initMetadataForClass(NavCompositeBounds, 'NavCompositeBounds');
  initMetadataForClass(CompositeFocusables, 'CompositeFocusables');
  initMetadataForClass(NavCompositeFocusables, 'NavCompositeFocusables');
  initMetadataForClass(TextDecoration, 'TextDecoration');
  initMetadataForClass(BackgroundHighlightTextDecoration, 'BackgroundHighlightTextDecoration', VOID, TextDecoration);
  initMetadataForClass(RedUnderlineTextDecoration, 'RedUnderlineTextDecoration', VOID, TextDecoration);
  initMetadataForClass(sam$kotlin_Comparator$0_2, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
  initMetadataForObject(TextDecorations, 'TextDecorations');
  initMetadataForClass(TreePath$Companion$sorted$comparator$1, VOID, VOID, VOID, [Comparator]);
  initMetadataForCompanion(Companion_146);
  initMetadataForClass(TreePath, 'TreePath', VOID, VOID, [Comparable]);
  initMetadataForObject(Validators, 'Validators');
  initMetadataForClass(Alignment, 'Alignment', VOID, Enum);
  initMetadataForClass(Kind_1, 'Kind', VOID, Enum);
  initMetadataForCompanion(Companion_147);
  initMetadataForClass(Border, 'Border');
  initMetadataForClass(Side, 'Side');
  initMetadataForClass(Block, 'Block');
  initMetadataForClass(CompoundBlock, 'CompoundBlock', VOID, Block);
  initMetadataForClass(HorizontalBlock, 'HorizontalBlock', VOID, CompoundBlock);
  initMetadataForClass(TextBlock, 'TextBlock', VOID, Block);
  initMetadataForClass(IndentationBlock, 'IndentationBlock', VOID, Block);
  initMetadataForClass(VerticalBlock, 'VerticalBlock', VOID, CompoundBlock);
  initMetadataForClass(BlockData, 'BlockData');
  initMetadataForClass(BlockBuilder, 'BlockBuilder', VOID, BlockData);
  initMetadataForClass(Orientation, 'Orientation', VOID, Enum);
  initMetadataForClass(ReadyBlock, 'ReadyBlock', VOID, BlockData);
  initMetadataForClass(IndentUpdater, 'IndentUpdater');
  initMetadataForClass(BlockIndentUpdater, 'BlockIndentUpdater', VOID, IndentUpdater);
  initMetadataForClass(BlockIndentUpdaterTarget, 'BlockIndentUpdaterTarget', BlockIndentUpdaterTarget);
  initMetadataForClass(StaticCellWrapper, 'StaticCellWrapper');
  function onPropertyChanged_0(prop, event) {
  }
  function onChildAdded_0(event) {
  }
  function onChildRemoved_0(event) {
  }
  function onParentChanged(event) {
  }
  function onAttach(container) {
  }
  function onDetach(container) {
  }
  initMetadataForInterface(CellListener, 'CellListener');
  initMetadataForClass(BaseCell$ExternalChildList$addListener$cellListener$1, VOID, VOID, VOID, [CellListener]);
  initMetadataForClass(BaseCell$ExternalChildList$addHandler$listener$1, VOID, VOID, VOID, [CollectionListener]);
  initMetadataForClass(BaseCell$cellContainer$1$addHandler$cellListener$1, VOID, VOID, VOID, [CellListener]);
  initMetadataForClass(BaseCell$getProp$MyProperty$addHandler$cellListener$1, VOID, VOID, VOID, [CellListener]);
  initMetadataForClass(ChildList_0, 'ChildList', VOID, ObservableArrayList);
  initMetadataForClass(ExternalChildList, 'ExternalChildList', VOID, AbstractMutableList, [AbstractMutableList, MutableObservableList]);
  initMetadataForCompanion(Companion_148);
  initMetadataForClass(BaseCell$addTrait$$inlined$toDisposable$1, VOID, VOID, VOID, [Disposable]);
  initMetadataForClass(BaseCell$cellContainer$1, VOID, VOID, VOID, [ReadableProperty]);
  initMetadataForClass(BaseCell$set$$inlined$toDisposable$1, VOID, VOID, VOID, [Disposable]);
  initMetadataForClass(BaseCell$getProp$MyProperty, 'MyProperty', VOID, BaseReadableProperty, [BaseReadableProperty, Property]);
  initMetadataForClass(CellTrait, 'CellTrait');
  initMetadataForClass(BaseCell$set$trait$1, VOID, VOID, CellTrait);
  initMetadataForInterface(Cell, 'Cell', VOID, VOID, [Composite]);
  initMetadataForInterface(BaseCellInternal, 'BaseCellInternal');
  initMetadataForClass(BaseCell, 'BaseCell', VOID, VOID, [Cell, BaseCellInternal]);
  initMetadataForInterface(CellContainerInternal, 'CellContainerInternal');
  function onBeforeCommand() {
  }
  function onAfterCommand() {
  }
  function onCellPropertyChanged(cell, prop, change) {
  }
  function onChildAdded_1(parent, change) {
  }
  function onChildRemoved_1(parent, change) {
  }
  initMetadataForInterface(CellContainerListener, 'CellContainerListener');
  function scrollTo(rectSupplier, cell) {
    this.b93(rectSupplier, cell);
  }
  initMetadataForInterface(CellContainerPeer, 'CellContainerPeer', VOID, VOID, VOID, [2]);
  initMetadataForCompanion(Companion_149);
  initMetadataForClass(CellEventContext, 'CellEventContext');
  initMetadataForClass(CellPropertySpec, 'CellPropertySpec');
  initMetadataForObject(Hints, 'Hints');
  initMetadataForClass(LayoutCell, 'LayoutCell', LayoutCell, BaseCell);
  initMetadataForClass(HorizontalCell, 'HorizontalCell', HorizontalCell, LayoutCell);
  initMetadataForCompanion(Companion_150);
  initMetadataForCompanion(Companion_151);
  function get_isLowPriority() {
    return false;
  }
  initMetadataForInterface(PopupSpec, 'PopupSpec');
  initMetadataForCompanion(Companion_152);
  initMetadataForClass(ScrollTrait, 'ScrollTrait', ScrollTrait, CellTrait);
  initMetadataForClass(ScrollPopupSpec, 'ScrollPopupSpec', ScrollPopupSpec, VOID, [PopupSpec]);
  initMetadataForCompanion(Companion_153);
  initMetadataForClass(ScrollCell, 'ScrollCell', ScrollCell, BaseCell);
  initMetadataForClass(Selection, 'Selection');
  initMetadataForCompanion(Companion_154);
  initMetadataForClass(TextCell, 'TextCell', TextCell_init_$Create$, BaseCell);
  initMetadataForCompanion(Companion_155);
  initMetadataForClass(TextPlaceholderCell, 'TextPlaceholderCell', TextPlaceholderCell, BaseCell);
  initMetadataForCompanion(Companion_156);
  initMetadataForClass(VerticalCell, 'VerticalCell', VerticalCell, LayoutCell);
  initMetadataForObject(AmountOfWorkInProgress, 'AmountOfWorkInProgress');
  initMetadataForClass(OurListeners, 'OurListeners', VOID, Listeners);
  initMetadataForObject(AsyncWorkNotifier, 'AsyncWorkNotifier');
  initMetadataForClass(onAsyncWorkDone$1, VOID, VOID, VOID, [AsyncTracker]);
  initMetadataForClass(CellAsyncTracker, 'CellAsyncTracker', VOID, VOID, [AsyncTracker]);
  initMetadataForCompanion(Companion_157);
  initMetadataForClass(sam$jetbrains_ocelot_base_edt_EdtTask$0_2, 'sam$jetbrains_ocelot_base_edt_EdtTask$0', VOID, VOID, [EdtTask, FunctionAdapter]);
  initMetadataForClass(WaitingMapper, 'WaitingMapper', VOID, Mapper);
  initMetadataForClass(TemporaryCell, 'TemporaryCell', TemporaryCell);
  initMetadataForCompanion(Companion_158);
  initMetadataForClass(BaseCellMapper, 'BaseCellMapper', VOID, Mapper);
  initMetadataForClass(CounterSpec, 'CounterSpec');
  initMetadataForObject(CounterUtil, 'CounterUtil');
  initMetadataForCompanion(Companion_159);
  initMetadataForClass(Counters, 'Counters', Counters);
  initMetadataForLambda(AsyncCompletionSupport$whenCompletionReadyOrNull$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(AsyncCompletionSupport$whenCompletionReady$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(AsyncCompletionSupport$whenCompletionReadyOrNull$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(AsyncCompletionSupport$launchWithAsyncCompletion$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForObject(AsyncCompletionSupport, 'AsyncCompletionSupport');
  initMetadataForClass(BaseCompletionConfig, 'BaseCompletionConfig', BaseCompletionConfig);
  initMetadataForCompanion(Companion_160);
  initMetadataForLambda(CellCompletionController$initCompletionResult$slambda, CoroutineImpl, VOID, [0]);
  initMetadataForClass(CellCompletionController, 'CellCompletionController');
  initMetadataForObject(Completion, 'Completion');
  initMetadataForCompanion(Companion_161);
  initMetadataForClass(CompletionContentCell, 'CompletionContentCell', VOID, VerticalCell);
  initMetadataForCompanion(Companion_162);
  initMetadataForClass(sam$jetbrains_ocelot_base_edt_EdtTask$0_3, 'sam$jetbrains_ocelot_base_edt_EdtTask$0', VOID, VOID, [EdtTask, FunctionAdapter]);
  initMetadataForClass(sam$jetbrains_ocelot_base_edt_EdtTask$0_4, 'sam$jetbrains_ocelot_base_edt_EdtTask$0', VOID, VOID, [EdtTask, FunctionAdapter]);
  initMetadataForClass(CompletionMenu$CompletionMenuModelMapper$registerSynchronizers$$inlined$forEventSource$1, VOID, VOID, DisposableSynchronizer);
  initMetadataForClass(CompletionMenu$CompletionMenuModelMapper$registerSynchronizers$$inlined$eventHandler$1);
  initMetadataForClass(CompletionMenu$CompletionMenuModelMapper$registerSynchronizers$docCell$1, VOID, VOID, DerivedProperty);
  initMetadataForClass(CompletionMenu$CompletionMenuModelMapper$registerSynchronizers$$inlined$writableProperty$1, VOID, VOID, VOID, [WritableProperty]);
  initMetadataForClass(CompletionMenu$CompletionMenuModelMapper$initPlaceholders$2$1, VOID, VOID, CellTrait);
  initMetadataForCompanion(Companion_163);
  initMetadataForClass(sam$jetbrains_ocelot_base_edt_EdtTask$0_5, 'sam$jetbrains_ocelot_base_edt_EdtTask$0', VOID, VOID, [EdtTask, FunctionAdapter]);
  initMetadataForClass(CompletionMenu$CompletionItemMapper$registerSynchronizers$1, VOID, VOID, CellTrait);
  initMetadataForClass(CompletionMenu$CompletionItemMapper$registerSynchronizers$$inlined$writableProperty$1, VOID, VOID, VOID, [WritableProperty]);
  initMetadataForClass(CompletionMenuCell, 'CompletionMenuCell', VOID, HorizontalCell);
  initMetadataForClass(CompletionMenuSpec, 'CompletionMenuSpec', CompletionMenuSpec, VOID, [PopupSpec]);
  initMetadataForClass(CompletionMenuTrait, 'CompletionMenuTrait', CompletionMenuTrait, CellTrait);
  initMetadataForClass(CompletionMenuModelMapper, 'CompletionMenuModelMapper', VOID, Mapper);
  initMetadataForClass(CompletionItemMapper, 'CompletionItemMapper', VOID, Mapper);
  initMetadataForClass(ColorScheme, 'ColorScheme', ColorScheme);
  initMetadataForClass(ItemColors, 'ItemColors');
  initMetadataForClass(TextColors, 'TextColors');
  initMetadataForClass(CompletionMenu$createCell$$inlined$toDisposable$1, VOID, VOID, VOID, [Disposable]);
  initMetadataForObject(CompletionMenu, 'CompletionMenu');
  initMetadataForClass(CompletionMode, 'CompletionMode', VOID, Enum);
  initMetadataForClass(_no_name_provided__qut3iv);
  initMetadataForClass(BaseCompletionContext, 'BaseCompletionContext', BaseCompletionContext);
  initMetadataForClass(CompletionSupport$showSideTransformPopup$textEditingTrait$1$wrap$1, VOID, VOID, BaseCompletionContext);
  initMetadataForClass(Completer, 'Completer');
  initMetadataForClass(sam$jetbrains_ocelot_base_edt_EdtTask$0_6, 'sam$jetbrains_ocelot_base_edt_EdtTask$0', VOID, VOID, [EdtTask, FunctionAdapter]);
  initMetadataForClass(CompletionSupport$TRAIT$1, VOID, VOID, CellTrait);
  initMetadataForClass(CompletionSupport$showCompletion$$inlined$toDisposable$1, VOID, VOID, VOID, [Disposable]);
  initMetadataForClass(CompletionSupport$showCompletion$$inlined$writableProperty$1, VOID, VOID, VOID, [WritableProperty]);
  initMetadataForClass(CompletionSupport$showCompletion$$inlined$toDisposable$2, VOID, VOID, VOID, [Disposable]);
  initMetadataForClass(CompletionSupport$showCompletion$5, VOID, VOID, CellTrait);
  initMetadataForClass(CompletionSupport$showCompletion$$inlined$toDisposable$3, VOID, VOID, VOID, [Disposable]);
  initMetadataForClass(CompletionSupport$showCompletion$$inlined$toDisposable$4, VOID, VOID, VOID, [Disposable]);
  initMetadataForClass(CompletionSupport$prefixText$1, VOID, VOID, DerivedProperty);
  initMetadataForInterface(CompletionItem, 'CompletionItem');
  initMetadataForClass(WrapperCompletionItem, 'WrapperCompletionItem', VOID, VOID, [CompletionItem]);
  initMetadataForClass(CompletionSupport$showSideTransformPopup$wrap$2$1, VOID, VOID, WrapperCompletionItem);
  initMetadataForClass(CompositeCellTrait, 'CompositeCellTrait', VOID, CellTrait);
  initMetadataForClass(TextEditingTrait, 'TextEditingTrait', TextEditingTrait, CompositeCellTrait);
  initMetadataForClass(CompletionSupport$showSideTransformPopup$textEditingTrait$1, VOID, VOID, TextEditingTrait);
  initMetadataForObject(CompletionSupport, 'CompletionSupport');
  initMetadataForClass(DefaultCompletionConfig, 'DefaultCompletionConfig', DefaultCompletionConfig, BaseCompletionConfig);
  initMetadataForClass(PopupCompletionEditor$1, VOID, VOID, TextEditingTrait);
  initMetadataForClass(PopupCompletionEditor$$inlined$toDisposable$1, VOID, VOID, VOID, [Disposable]);
  initMetadataForClass(PopupCompletionEditor, 'PopupCompletionEditor', VOID, VOID, [Disposable]);
  initMetadataForClass(Side_0, 'Side', VOID, Enum);
  initMetadataForClass(Side$LEFT, 'LEFT', VOID, Side_0);
  initMetadataForClass(Side$RIGHT, 'RIGHT', VOID, Side_0);
  initMetadataForClass(SimpleCompletionEditor, 'SimpleCompletionEditor', VOID, VOID, [Disposable]);
  initMetadataForClass(CompletionContext$Companion$MENU$1, VOID, VOID, BaseCompletionContext);
  initMetadataForClass(CompletionContext$Companion$BULK$1, VOID, VOID, BaseCompletionContext);
  initMetadataForClass(CompletionContext$Companion$TOKENIZATION$1, VOID, VOID, BaseCompletionContext);
  initMetadataForCompanion(Companion_164);
  initMetadataForObject(CompletionSupplement, 'CompletionSupplement');
  initMetadataForClass(EMPTY_COMPLETION_SUPPLIER$$inlined$completionSupplier$1);
  initMetadataForClass(toCompletionSupplier$$inlined$completionSupplier$1);
  initMetadataForCompanion(Companion_165);
  initMetadataForClass(CompletionItemSelectionMode, 'CompletionItemSelectionMode', VOID, Enum);
  initMetadataForClass(LoadDirection, 'LoadDirection', VOID, Enum);
  initMetadataForClass(CompletionMenuModel$LoadDirection$DOWN, 'DOWN', VOID, LoadDirection);
  initMetadataForClass(CompletionMenuModel$LoadDirection$UP, 'UP', VOID, LoadDirection);
  initMetadataForClass(CompletionMenuModel$Companion$ITEMS_COMPARATOR$1, VOID, VOID, VOID, [Comparator]);
  initMetadataForClass(MyVisibleItemsUpdater, 'MyVisibleItemsUpdater', VOID, VOID, [Disposable]);
  initMetadataForClass(Builder, 'Builder');
  initMetadataForCompanion(Companion_166);
  initMetadataForClass(CompletionMenuModel, 'CompletionMenuModel', VOID, VOID, [Disposable]);
  initMetadataForClass(Builder_0, 'Builder');
  initMetadataForCompanion(Companion_167);
  initMetadataForClass(CompletionParameters, 'CompletionParameters');
  initMetadataForClass(BaseCompletionItem, 'BaseCompletionItem', VOID, VOID, [CompletionItem]);
  initMetadataForClass(CompletionItemByTextMatcher, 'CompletionItemByTextMatcher', VOID, BaseCompletionItem);
  initMetadataForClass(CompletionItems, 'CompletionItems');
  initMetadataForCompanion(Companion_168);
  function get_items() {
    return emptyList();
  }
  function transform() {
    return new CompletionResultTransformer(this);
  }
  initMetadataForInterface(CompletionResult, 'CompletionResult', VOID, VOID, [EventSource, Disposable]);
  initMetadataForCoroutine($awaitCOROUTINE$_1, CoroutineImpl);
  initMetadataForClass(CompletionResultChangeEvent, 'CompletionResultChangeEvent');
  initMetadataForObject(CompletionItemsAddedEvent, 'CompletionItemsAddedEvent', VOID, CompletionResultChangeEvent);
  initMetadataForClass(ErrorDuringCompletionItems, 'ErrorDuringCompletionItems', VOID, CompletionResultChangeEvent);
  initMetadataForClass(CompletionResultTransformer$add$1$addHandler$$inlined$eventHandler$1);
  initMetadataForClass(TransformedCompletionResult, 'TransformedCompletionResult', VOID, VOID, [CompletionResult]);
  initMetadataForCompanion(Companion_169);
  initMetadataForClass(CompletionResultTransformer$add$1, VOID, VOID, VOID, [CompletionResult]);
  initMetadataForClass(CompletionResultTransformer$map$transformedCompletionResult$1, VOID, VOID, TransformedCompletionResult);
  initMetadataForClass(CompletionResultTransformer, 'CompletionResultTransformer');
  initMetadataForClass(ReadyCompletionResult, 'ReadyCompletionResult', ReadyCompletionResult, VOID, [CompletionResult]);
  initMetadataForClass(EmptyCompletionResult, 'EmptyCompletionResult', EmptyCompletionResult, ReadyCompletionResult);
  initMetadataForLambda(FlowBasedCompletionResult$completionCollectorJob$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0_9, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
  initMetadataForLambda(FlowBasedCompletionResult$completionCollectorJob$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(FlowBasedCompletionResult, 'FlowBasedCompletionResult', VOID, VOID, [CompletionResult]);
  initMetadataForClass(SimpleCompletionItem, 'SimpleCompletionItem', VOID, BaseCompletionItem);
  initMetadataForClass(SimpleCompletionResult, 'SimpleCompletionResult', VOID, ReadyCompletionResult);
  initMetadataForClass(SimpleCaseSensitiveMatcher, 'SimpleCaseSensitiveMatcher');
  initMetadataForClass(SimpleIgnoreCaseMatcher, 'SimpleIgnoreCaseMatcher');
  initMetadataForClass(CellContainerPeerAdapter, 'CellContainerPeerAdapter', VOID, VOID, [CellContainerPeer], [2]);
  initMetadataForLambda(launch$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCompanion(Companion_170);
  initMetadataForClass(CellEventSpec, 'CellEventSpec');
  initMetadataForClass(CompletionEvent, 'CompletionEvent', CompletionEvent, Event_0);
  initMetadataForClass(EventPriority, 'EventPriority', VOID, Enum);
  initMetadataForClass(FocusEvent, 'FocusEvent', VOID, Event_0);
  initMetadataForCompanion(Companion_171);
  initMetadataForClass(ImageCell, 'ImageCell', ImageCell, BaseCell);
  initMetadataForClass(sam$jetbrains_ocelot_base_clipboard_ClipboardAdapter$0_0, 'sam$jetbrains_ocelot_base_clipboard_ClipboardAdapter$0', VOID, VOID, [ClipboardAdapter, FunctionAdapter]);
  initMetadataForCompanion(Companion_172);
  initMetadataForClass(CellContainerImpl$createFocusedCellProp$1, VOID, VOID, ValueProperty);
  initMetadataForLambda(CellContainerImpl$pasteFromExternalClipboard$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(CellContainerImpl, 'CellContainerImpl', CellContainerImpl, VOID, [CellContainerInternal]);
  initMetadataForClass(RootCell, 'RootCell', VOID, BaseCell);
  initMetadataForClass(IndentCell$addListener$$inlined$toDisposable$1, VOID, VOID, VOID, [Disposable]);
  initMetadataForClass(IndentCell, 'IndentCell', IndentCell, BaseCell);
  initMetadataForClass(NewLineCell, 'NewLineCell', NewLineCell, IndentCell);
  initMetadataForClass(BaseIndentUpdatingListener, 'BaseIndentUpdatingListener');
  initMetadataForClass(IndentUpdater$toEnd$1);
  initMetadataForClass(IndentUpdater$range$1);
  initMetadataForClass(Position$nextLeaves$1$iterator$1);
  initMetadataForClass(Position$nextLeaves$1);
  initMetadataForClass(Position, 'Position');
  initMetadataForObject(AncestorUtil, 'AncestorUtil');
  initMetadataForClass(CellMapperContext, 'CellMapperContext');
  initMetadataForObject(CellMapperUtils, 'CellMapperUtils');
  initMetadataForObject(IndentUtil, 'IndentUtil');
  initMetadataForCompanion(Companion_173);
  function setFontStyle(textCell) {
    textCell.i90(Companion_getInstance_154().f8x_1, MessageController_getInstance().s9y_1);
    textCell.i90(Companion_getInstance_154().i8x_1, 13);
  }
  initMetadataForInterface(MessageView, 'MessageView');
  initMetadataForClass(EmptyView, 'EmptyView', VOID, VOID, [MessageView]);
  initMetadataForClass(Message, 'Message', Message);
  initMetadataForClass(MessageCell$Companion$TRAIT$1, VOID, VOID, CellTrait);
  initMetadataForClass(MessagePopupSpec, 'MessagePopupSpec', MessagePopupSpec, VOID, [PopupSpec]);
  initMetadataForCompanion(Companion_174);
  initMetadataForClass(MessageCell, 'MessageCell', VOID, VerticalCell);
  initMetadataForObject(MessageController, 'MessageController');
  initMetadataForClass(setBackingToDefault$$inlined$toDisposable$1, VOID, VOID, VOID, [Disposable]);
  initMetadataForCompanion(Companion_175);
  initMetadataForClass(MessagePopupSupport$$inlined$eventHandler$1);
  initMetadataForClass(MessagePopupSupport$$inlined$eventHandler$2);
  initMetadataForClass(MessagePopupSupport$$inlined$eventHandler$3);
  initMetadataForClass(MessagePopupSupport$doSubscribe$$inlined$toDisposable$1, VOID, VOID, VOID, [Disposable]);
  initMetadataForClass(MessagePopupSupport, 'MessagePopupSupport', VOID, VOID, [Disposable]);
  initMetadataForCompanion(Companion_176);
  initMetadataForClass(MessageStyler$setProp$$inlined$toDisposable$1, VOID, VOID, VOID, [Disposable]);
  initMetadataForClass(MessageStyler, 'MessageStyler', MessageStyler);
  initMetadataForClass(sam$jetbrains_ocelot_base_edt_EdtTask$0_7, 'sam$jetbrains_ocelot_base_edt_EdtTask$0', VOID, VOID, [EdtTask, FunctionAdapter]);
  initMetadataForClass(MessageTrait$MyHoverController$schedule$$inlined$toDisposable$1, VOID, VOID, VOID, [Disposable]);
  initMetadataForClass(HoverState, 'HoverState', VOID, Enum);
  initMetadataForClass(MyHoverController, 'MyHoverController');
  initMetadataForCompanion(Companion_177);
  initMetadataForClass(sam$jetbrains_ocelot_base_edt_EdtTask$0_8, 'sam$jetbrains_ocelot_base_edt_EdtTask$0', VOID, VOID, [EdtTask, FunctionAdapter]);
  initMetadataForClass(MessageTrait, 'MessageTrait', VOID, CellTrait);
  initMetadataForClass(MessageViewWithLink, 'MessageViewWithLink', VOID, VOID, [MessageView]);
  initMetadataForClass(SimpleMessageView, 'SimpleMessageView', VOID, VOID, [MessageView]);
  initMetadataForCompanion(Companion_178);
  initMetadataForClass(StyleApplicator, 'StyleApplicator');
  initMetadataForClass(Metrics, 'Metrics', Metrics);
  initMetadataForClass(Line, 'Line');
  initMetadataForClass(WordWrapper$iterator$1);
  initMetadataForClass(WordWrapper, 'WordWrapper');
  initMetadataForClass(BasePopupManager, 'BasePopupManager', VOID, VOID, [Disposable]);
  initMetadataForCompanion(Companion_179);
  initMetadataForClass(ConsumeMouseButtonTrait, 'ConsumeMouseButtonTrait', VOID, CellTrait);
  initMetadataForClass(Context, 'Context');
  initMetadataForCompanion(Companion_180);
  initMetadataForClass(PopupPositionUpdater, 'PopupPositionUpdater');
  initMetadataForClass(DefaultPositionHandler, 'DefaultPositionHandler');
  initMetadataForClass(CellDefaultPositionHandler, 'CellDefaultPositionHandler', VOID, DefaultPositionHandler);
  initMetadataForClass(DefaultPositionHandler$caretOffset$1, VOID, VOID, VOID, [Property]);
  initMetadataForClass(NewLineCellPositionHandler, 'NewLineCellPositionHandler', VOID, DefaultPositionHandler);
  initMetadataForClass(SetPositionResult, 'SetPositionResult');
  initMetadataForCompanion(Companion_181);
  initMetadataForObject(Positions, 'Positions');
  initMetadataForClass(TextPositionHandler$caretOffset$derivedOffset$1, VOID, VOID, DerivedProperty);
  initMetadataForClass(TextPositionHandler$caretOffset$1, VOID, VOID, VOID, [Property]);
  initMetadataForClass(TextPositionHandler, 'TextPositionHandler');
  initMetadataForClass(InputMethodEditorUtil$showComposite$$inlined$toDisposable$1, VOID, VOID, VOID, [Disposable]);
  initMetadataForObject(InputMethodEditorUtil, 'InputMethodEditorUtil');
  initMetadataForInterface(CellStateHandler, 'CellStateHandler');
  initMetadataForClass(TextEditorStateHandler, 'TextEditorStateHandler', VOID, VOID, [CellStateHandler]);
  initMetadataForClass(STATE_HANDLER$1, VOID, VOID, TextEditorStateHandler);
  initMetadataForClass(STATE_HANDLER_WITH_VALID$1, VOID, VOID, TextEditorStateHandler);
  initMetadataForClass(TextCopyTrait, 'TextCopyTrait', TextCopyTrait, CellTrait);
  initMetadataForClass(TextCopyPasteTrait, 'TextCopyPasteTrait', VOID, TextCopyTrait);
  initMetadataForClass(DerivedCellTrait, 'DerivedCellTrait', VOID, CellTrait);
  initMetadataForClass(BaseDerivedCellTrait, 'BaseDerivedCellTrait', VOID, DerivedCellTrait);
  initMetadataForClass(TextEditing$TEXT_NAVIGATION_TRAIT$1, VOID, VOID, BaseDerivedCellTrait);
  initMetadataForClass(TextEditing$TEXT_EDITING_TRAIT$1, VOID, VOID, BaseDerivedCellTrait);
  initMetadataForClass(TextEditing$textNavigation$1, VOID, VOID, DerivedCellTrait);
  initMetadataForClass(TextEditing$textNavigation$2, VOID, VOID, DerivedCellTrait);
  initMetadataForClass(TextEditing$validTextEditing$2, VOID, VOID, DerivedCellTrait);
  initMetadataForClass(TextEditing$adaptMultilinePaste$$inlined$propertyTrait$1, VOID, VOID, CellTrait);
  initMetadataForObject(TextEditing, 'TextEditing');
  initMetadataForCompanion(Companion_182);
  initMetadataForClass(CopyPasteTrait, 'CopyPasteTrait', VOID, TextCopyPasteTrait);
  initMetadataForClass(TextCellStateBeforeCompletion, 'TextCellStateBeforeCompletion');
  initMetadataForCompanion(Companion_183);
  initMetadataForLambda(TextEditingTrait$onComplete$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(TextEditorCellState, 'TextEditorCellState');
  initMetadataForObject(TextEditorUtil, 'TextEditorUtil');
  initMetadataForClass(Selection_0, 'Selection');
  initMetadataForCompanion(Companion_184);
  initMetadataForClass(TextNavigationTrait, 'TextNavigationTrait', TextNavigationTrait, CellTrait);
  initMetadataForCompanion(Companion_185);
  initMetadataForClass(sam$jetbrains_ocelot_base_disposable_Disposable$0_4, 'sam$jetbrains_ocelot_base_disposable_Disposable$0', VOID, VOID, [Disposable, FunctionAdapter]);
  initMetadataForClass(ValidTextEditingTrait$validate$$inlined$toDisposable$1, VOID, VOID, VOID, [Disposable]);
  initMetadataForLambda(ValidTextEditingTrait$onAfterTextAdded$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(ValidTextEditingTrait, 'ValidTextEditingTrait', ValidTextEditingTrait, TextEditingTrait);
  initMetadataForObject(ValidTextEditingTraitSpecs, 'ValidTextEditingTraitSpecs');
  initMetadataForClass(CellTrait$Companion$EMPTY$1, VOID, VOID, CellTrait);
  initMetadataForCompanion(Companion_186);
  initMetadataForClass(CellTraitEventSpec, 'CellTraitEventSpec');
  initMetadataForClass(CellTraitPropertySpec, 'CellTraitPropertySpec');
  initMetadataForClass(CellTraits$captureTo$rootReg$1, VOID, VOID, CellTrait);
  initMetadataForClass(CellTraits$captureTo$$inlined$toDisposable$1, VOID, VOID, VOID, [Disposable]);
  initMetadataForObject(CellTraits, 'CellTraits');
  initMetadataForClass(CompositeCellTraits$forConstant$1, VOID, VOID, CompositeCellTrait);
  initMetadataForObject(CompositeCellTraits, 'CompositeCellTraits');
  initMetadataForClass(SpecMatchResult, 'SpecMatchResult');
  initMetadataForClass(CellAttachWatcher, 'CellAttachWatcher', VOID, VOID, [CellContainerListener]);
  initMetadataForCompanion(Companion_187);
  initMetadataForClass(TraitController, 'TraitController', VOID, CellAttachWatcher, [CellAttachWatcher, Disposable]);
  initMetadataForObject(CellFactory, 'CellFactory');
  initMetadataForClass(CellVisibleTree, 'CellVisibleTree', VOID, VOID, [Composite]);
  initMetadataForObject(Cells, 'Cells');
  initMetadataForClass(whenAttached$$inlined$toDisposable$1, VOID, VOID, VOID, [Disposable]);
  initMetadataForClass(SeparatedList, 'SeparatedList', VOID, AbstractMutableList);
  initMetadataForClass(SeparatedCellList, 'SeparatedCellList', VOID, SeparatedList);
  initMetadataForClass(CellLists$separated$$inlined$separated$1, VOID, VOID, SeparatedCellList);
  initMetadataForClass(CellLists$newLineSeparated$$inlined$separated$1, VOID, VOID, SeparatedCellList);
  initMetadataForClass(CellLists$verticallySpaced$$inlined$separated$1, VOID, VOID, SeparatedCellList);
  initMetadataForObject(CellLists, 'CellLists');
  initMetadataForCompanion(Companion_188);
  initMetadataForClass(CellStateDifference, 'CellStateDifference', VOID, Enum);
  initMetadataForCompanion(Companion_189);
  initMetadataForCompanion(Companion_190);
  initMetadataForClass(DerivedVisibilityEvent, 'DerivedVisibilityEvent', VOID, Event_0);
  initMetadataForClass(DisambiguationCellSupport, 'DisambiguationCellSupport', VOID, CellTrait);
  initMetadataForClass(DisambiguationCellSupport$Companion$invoke$1, VOID, VOID, DisambiguationCellSupport);
  initMetadataForClass(DisambiguationCell, 'DisambiguationCell', VOID, HorizontalCell);
  initMetadataForClass(OutermostLeafCellFocusListener, 'OutermostLeafCellFocusListener', OutermostLeafCellFocusListener);
  initMetadataForClass(MyFocusListener, 'MyFocusListener', VOID, OutermostLeafCellFocusListener);
  initMetadataForClass(DisambiguationCellTrait, 'DisambiguationCellTrait', VOID, CellTrait);
  initMetadataForCompanion(Companion_191);
  initMetadataForClass(sam$jetbrains_ocelot_base_edt_EdtTask$0_9, 'sam$jetbrains_ocelot_base_edt_EdtTask$0', VOID, VOID, [EdtTask, FunctionAdapter]);
  initMetadataForClass(sam$jetbrains_ocelot_base_edt_EdtTask$0_10, 'sam$jetbrains_ocelot_base_edt_EdtTask$0', VOID, VOID, [EdtTask, FunctionAdapter]);
  initMetadataForObject(EffectiveVisibilityTrackingTrait, 'EffectiveVisibilityTrackingTrait', VOID, CellTrait);
  initMetadataForClass(ExtraCell, 'ExtraCell', VOID, TextCell);
  initMetadataForClass(ExtraCellTrait, 'ExtraCellTrait', VOID, CompositeCellTrait);
  initMetadataForClass(FocusTrait, 'FocusTrait', VOID, CellTrait);
  initMetadataForClass(sam$jetbrains_ocelot_base_edt_EdtTask$0_11, 'sam$jetbrains_ocelot_base_edt_EdtTask$0', VOID, VOID, [EdtTask, FunctionAdapter]);
  initMetadataForClass(LastCaretPositionSupport$onPropertyChanged$$inlined$toDisposable$1, VOID, VOID, VOID, [Disposable]);
  initMetadataForObject(LastCaretPositionSupport, 'LastCaretPositionSupport', VOID, CompositeCellTrait);
  initMetadataForClass(Side_1, 'Side', VOID, Enum);
  initMetadataForClass(LeafCellTrackingTrait$Side$LEFT, 'LEFT', VOID, Side_1);
  initMetadataForClass(LeafCellTrackingTrait$Side$RIGHT, 'RIGHT', VOID, Side_1);
  initMetadataForObject(LeafCellTrackingTrait, 'LeafCellTrackingTrait', VOID, CellTrait);
  initMetadataForCompanion(Companion_192);
  initMetadataForCompanion(Companion_193);
  initMetadataForClass(OutermostLeafCellTracker, 'OutermostLeafCellTracker', VOID, CellTrait);
  initMetadataForClass(CellSides, 'CellSides', VOID, Enum);
  initMetadataForObject(OutermostLeafTrackers, 'OutermostLeafTrackers');
  initMetadataForClass(attachToPlaceholder$1, VOID, VOID, CellTrait);
  initMetadataForClass(attachToPlaceholder$2, VOID, VOID, CellTrait);
  initMetadataForClass(CellScope, 'CellScope');
  initMetadataForClass(FocusableCellScope, 'FocusableCellScope', VOID, CellScope);
  initMetadataForObject(CellScopes, 'CellScopes');
  initMetadataForClass(TargetBuilder, 'TargetBuilder');
  initMetadataForObject(CellScrolling, 'CellScrolling');
  initMetadataForClass(Builder_1, 'Builder');
  initMetadataForCompanion(Companion_194);
  initMetadataForClass(ScrollingParameters, 'ScrollingParameters');
  initMetadataForObject(ScrollingUtil, 'ScrollingUtil');
  initMetadataForObject(Snapping, 'Snapping');
  initMetadataForObject(SnappingHome, 'SnappingHome');
  initMetadataForClass(OneAxisSnapping, 'OneAxisSnapping');
  initMetadataForClass(Builder_2, 'Builder');
  initMetadataForCompanion(Companion_195);
  initMetadataForClass(SnappingParameters, 'SnappingParameters');
  initMetadataForCompanion(Companion_196);
  initMetadataForClass(URLCellTrait, 'URLCellTrait', VOID, CellTrait);
  initMetadataForClass(_no_name_provided__qut3iv_0, VOID, VOID, SimpleCompletionItem);
  initMetadataForClass(_no_name_provided__qut3iv_1, VOID, VOID, SimpleCompletionItem);
  initMetadataForClass(_no_name_provided__qut3iv_2, VOID, VOID, SimpleCompletionItem);
  initMetadataForClass(ValueEditors$getEnumValidatedProperty$trait$1, VOID, VOID, BaseDerivedCellTrait);
  initMetadataForClass(ValueEditors$booleanProperty$trait$1, VOID, VOID, BaseDerivedCellTrait);
  initMetadataForObject(ValueEditors, 'ValueEditors');
  initMetadataForClass(ViewCell, 'ViewCell', VOID, BaseCell);
  initMetadataForInterface(ToCellMapping, 'ToCellMapping');
  initMetadataForClass(getMapperCellFinder$1);
  initMetadataForCompanion(Companion_197);
  initMetadataForClass(MapperCellProvider, 'MapperCellProvider');
  initMetadataForClass(FocusedCellHandler, 'FocusedCellHandler', FocusedCellHandler, VOID, [Disposable]);
  initMetadataForClass(PageUpDown, 'PageUpDown');
  initMetadataForCompanion(Companion_198);
  initMetadataForClass(CellNavigationController$install$5, VOID, VOID, CellTrait);
  initMetadataForClass(CellNavigationController$handleKeyPress$pageUpDown$1, VOID, VOID, PageUpDown);
  initMetadataForClass(CellNavigationController$handleKeyPress$pageUpDown$2, VOID, VOID, PageUpDown);
  initMetadataForClass(UpDown, 'UpDown');
  initMetadataForClass(CellNavigationController$upperClosest$upDown$1, VOID, VOID, UpDown);
  initMetadataForClass(CellNavigationController$lowerClosest$upDown$1, VOID, VOID, UpDown);
  initMetadataForClass(CellNavigationController, 'CellNavigationController');
  initMetadataForClass(HighlightUtil$highlightFocused$$inlined$toDisposable$1, VOID, VOID, VOID, [Disposable]);
  initMetadataForObject(HighlightUtil, 'HighlightUtil');
  initMetadataForObject(MatchingConstructs, 'MatchingConstructs');
  initMetadataForObject(PairUtil, 'PairUtil');
  initMetadataForCompanion(Companion_199);
  initMetadataForObject(RootController, 'RootController');
  initMetadataForClass(InstallRootResult, 'InstallRootResult');
  initMetadataForLambda(BaseProjectionalSynchronizer$CopyPasteTrait$pastePostProcess$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(BaseProjectionalSynchronizer$TargetCellList$getPlaceholderTrait$trait$1$get$matchers$1);
  initMetadataForClass(BaseProjectionalSynchronizer$TargetCellList$getPlaceholderTrait$trait$1, VOID, VOID, BaseDerivedCellTrait);
  initMetadataForClass(RoleSynchronizerCopyTrait, 'RoleSynchronizerCopyTrait', VOID, CellTrait);
  initMetadataForClass(RoleSynchronizerCopyPasteTrait, 'RoleSynchronizerCopyPasteTrait', VOID, RoleSynchronizerCopyTrait);
  initMetadataForClass(CopyPasteTrait_0, 'CopyPasteTrait', VOID, RoleSynchronizerCopyPasteTrait);
  initMetadataForClass(TargetCellTrait, 'TargetCellTrait', VOID, BaseDerivedCellTrait);
  initMetadataForClass(TargetCellList, 'TargetCellList', VOID, AbstractMutableList);
  initMetadataForClass(SourceList, 'SourceList', VOID, AbstractList);
  initMetadataForClass(SelectionCaptureTrait, 'SelectionCaptureTrait', VOID, BaseDerivedCellTrait);
  initMetadataForClass(BaseProjectionalSynchronizer$attach$4);
  initMetadataForClass(BaseProjectionalSynchronizer, 'BaseProjectionalSynchronizer', VOID, VOID, [Synchronizer]);
  initMetadataForClass(CollectionEditor, 'CollectionEditor');
  initMetadataForClass(DefaultProjectionalItemHandler, 'DefaultProjectionalItemHandler');
  initMetadataForClass(NewItemOnly, 'NewItemOnly', VOID, DefaultProjectionalItemHandler);
  initMetadataForCompanion(Companion_200);
  initMetadataForClass(DeleteHandler$Companion$EMPTY$1);
  initMetadataForCompanion(Companion_201);
  initMetadataForObject(JoinChildrenEvent, 'JoinChildrenEvent');
  initMetadataForInterface(CreateNewElementHandle, 'CreateNewElementHandle');
  initMetadataForClass(ProjectionalSynchronizerSettings, 'ProjectionalSynchronizerSettings');
  initMetadataForClass(ProjectionalListSynchronizerSettings, 'ProjectionalListSynchronizerSettings', ProjectionalListSynchronizerSettings, ProjectionalSynchronizerSettings);
  initMetadataForClass(DefaultCreateNewItemCellTrait, 'DefaultCreateNewItemCellTrait', VOID, CellTrait);
  initMetadataForClass(sam$jetbrains_ocelot_projectional_editor_cell_ProjectionalListSynchronizerSettings_CreateNewElementHandle$0, 'sam$jetbrains_ocelot_projectional_editor_cell_ProjectionalListSynchronizerSettings_CreateNewElementHandle$0', VOID, VOID, [CreateNewElementHandle, FunctionAdapter]);
  initMetadataForClass(ProjectionalObservableListSynchronizer$currentChildCompletion$role$1);
  initMetadataForClass(ProjectionalObservableListSynchronizer$doRegisterChild$trait$1, VOID, VOID, CompositeCellTrait);
  initMetadataForClass(ProjectionalObservableListSynchronizer$getCollectionEditor$1, VOID, VOID, CollectionEditor);
  initMetadataForClass(ProjectionalObservableListSynchronizer, 'ProjectionalObservableListSynchronizer', VOID, BaseProjectionalSynchronizer);
  initMetadataForClass(ProjectionalPropertySynchronizer$completion$1);
  initMetadataForClass(ProjectionalPropertySynchronizer$doRegisterChild$trait$1, VOID, VOID, DerivedCellTrait);
  initMetadataForClass(ProjectionalPropertySynchronizer, 'ProjectionalPropertySynchronizer', VOID, BaseProjectionalSynchronizer);
  initMetadataForClass(ProjectionalPropertySynchronizerSettings, 'ProjectionalPropertySynchronizerSettings', ProjectionalPropertySynchronizerSettings, ProjectionalSynchronizerSettings);
  initMetadataForObject(ProjectionalSynchronizers, 'ProjectionalSynchronizers');
  initMetadataForClass(ReadOnlyProjectionalSynchronizers$forSingleRole$target$1, VOID, VOID, VOID, [WritableProperty]);
  initMetadataForObject(ReadOnlyProjectionalSynchronizers, 'ReadOnlyProjectionalSynchronizers');
  initMetadataForCompanion(Companion_202);
  initMetadataForClass(SplitChildEvent, 'SplitChildEvent', VOID, DerivedEvent);
  initMetadataForCompanion(Companion_203);
  initMetadataForClass(ClipboardParameters, 'ClipboardParameters');
  function copy$default(sourceItem, preserveMode, $super) {
    preserveMode = preserveMode === VOID ? false : preserveMode;
    return $super === VOID ? this.cav(sourceItem, preserveMode) : $super.cav.call(this, sourceItem, preserveMode);
  }
  function copyList$default(sourceItems, preserveMode, $super) {
    preserveMode = preserveMode === VOID ? false : preserveMode;
    return $super === VOID ? this.dav(sourceItems, preserveMode) : $super.dav.call(this, sourceItems, preserveMode);
  }
  initMetadataForInterface(ClonerSupport, 'ClonerSupport');
  function plus_4(other) {
    var tmp = PasteHandler$plus$lambda(this, other);
    return new sam$jetbrains_ocelot_projectional_editor_cell_clipboard_PasteHandler$0(tmp);
  }
  initMetadataForInterface(PasteHandler, 'PasteHandler');
  initMetadataForClass(sam$jetbrains_ocelot_projectional_editor_cell_clipboard_PasteHandler$0, 'sam$jetbrains_ocelot_projectional_editor_cell_clipboard_PasteHandler$0', VOID, VOID, [PasteHandler, FunctionAdapter]);
  initMetadataForClass(ProjectionalClipboardContent, 'ProjectionalClipboardContent', VOID, VOID, [ClipboardContent]);
  initMetadataForCompanion(Companion_204);
  initMetadataForClass(ProjectionalClipboardContentSerializationAsHtml$deserialize$1, VOID, VOID, VOID, [ClipboardContent]);
  initMetadataForClass(ProjectionalClipboardContentSerializationAsHtml$doGetPersister$1, VOID, VOID, VOID, [Persister]);
  initMetadataForClass(ProjectionalClipboardContentSerializationAsHtml$doGetListPersister$1, VOID, VOID, VOID, [Persister]);
  initMetadataForClass(ProjectionalClipboardContentSerializationAsHtml, 'ProjectionalClipboardContentSerializationAsHtml');
  initMetadataForInterface(OurClipboardContent, 'OurClipboardContent');
  initMetadataForClass(ProjectionalClipboardHandler$createClipboardContent$1, VOID, VOID, ProjectionalClipboardContent, [ProjectionalClipboardContent, OurClipboardContent]);
  initMetadataForClass(ProjectionalClipboardHandler, 'ProjectionalClipboardHandler');
  initMetadataForInterface(RoleCompletion, 'RoleCompletion');
  initMetadataForClass(sam$jetbrains_ocelot_projectional_editor_generic_roleCompletion_RoleCompletion$0, 'sam$jetbrains_ocelot_projectional_editor_generic_roleCompletion_RoleCompletion$0', VOID, VOID, [RoleCompletion, FunctionAdapter]);
  initMetadataForClass(sam$jetbrains_ocelot_projectional_editor_generic_roleCompletion_RoleCompletion$0_0, 'sam$jetbrains_ocelot_projectional_editor_generic_roleCompletion_RoleCompletion$0', VOID, VOID, [RoleCompletion, FunctionAdapter]);
  initMetadataForClass(NotSupported, 'NotSupported', NotSupported);
  initMetadataForClass(JoinDirection, 'JoinDirection', VOID, Enum);
  initMetadataForClass(BaseSelectionCaptureTrait, 'BaseSelectionCaptureTrait', VOID, CellTrait);
  initMetadataForClass(KeyDirection, 'KeyDirection', VOID, Enum);
  initMetadataForClass(BaseSelectionSpec$KeyDirection$FORWARD, 'FORWARD', VOID, KeyDirection);
  initMetadataForClass(BaseSelectionSpec$KeyDirection$BACKWARD, 'BACKWARD', VOID, KeyDirection);
  initMetadataForClass(KeyboardOperationContext, 'KeyboardOperationContext');
  initMetadataForClass(BaseSelectionSpec$createTargetTrait$1, VOID, VOID, BaseDerivedCellTrait);
  initMetadataForClass(BaseSelectionSpec, 'BaseSelectionSpec', BaseSelectionSpec);
  initMetadataForClass(SelectionCellScope, 'SelectionCellScope', VOID, CellScope);
  initMetadataForClass(BaseSelectionTargetTrait, 'BaseSelectionTargetTrait', VOID, CellTrait);
  initMetadataForClass(CellSelection, 'CellSelection');
  initMetadataForCompanion(Companion_205);
  initMetadataForClass(SelectionBound, 'SelectionBound');
  initMetadataForClass(EditorSelectionBound, 'EditorSelectionBound', VOID, SelectionBound);
  initMetadataForClass(MouseHandleResult, 'MouseHandleResult', VOID, Enum);
  initMetadataForClass(MouseChange, 'MouseChange');
  initMetadataForClass(MouseChangeKind, 'MouseChangeKind', VOID, Enum);
  initMetadataForClass(MouseSelectionHandler, 'MouseSelectionHandler');
  initMetadataForObject(ProjectionalSelection, 'ProjectionalSelection');
  initMetadataForClass(RoleSynchronizerSelectionSupport$1, VOID, VOID, CollectionAdapter);
  initMetadataForClass(RoleSynchronizerSelectionSupport, 'RoleSynchronizerSelectionSupport', VOID, VOID, [Disposable]);
  initMetadataForCompanion(Companion_206);
  initMetadataForClass(SelectionId, 'SelectionId', SelectionId, BaseId);
  initMetadataForCompanion(Companion_207);
  initMetadataForClass(TargetList, 'TargetList', VOID, AbstractList);
  initMetadataForCompanion(Companion_208);
  initMetadataForClass(SelectionSupport, 'SelectionSupport', VOID, VOID, [Disposable]);
  initMetadataForClass(SelectionSupports$selectionSupports$1$iterator$1);
  initMetadataForClass(SelectionSupports$selectionSupports$1);
  initMetadataForObject(SelectionSupports, 'SelectionSupports');
  initMetadataForObject(SelectionUtil, 'SelectionUtil');
  initMetadataForClass(SimpleCellSelection, 'SimpleCellSelection', VOID, CellSelection);
  initMetadataForCompanion(Companion_209);
  initMetadataForClass(SimpleSelectionBound, 'SimpleSelectionBound', VOID, SelectionBound);
  initMetadataForClass(SourceUpdateHandler, 'SourceUpdateHandler');
  initMetadataForCompanion(Companion_210);
  initMetadataForClass(Color, 'Color');
  initMetadataForClass(Font, 'Font');
  initMetadataForCompanion(Companion_211);
  initMetadataForClass(FontFamily, 'FontFamily');
  initMetadataForClass(ImageData, 'ImageData');
  initMetadataForClass(EmptyImageData, 'EmptyImageData', VOID, ImageData);
  initMetadataForCompanion(Companion_212);
  initMetadataForClass(UrlImageData, 'UrlImageData', VOID, ImageData);
  initMetadataForObject(AlignmentProperties, 'AlignmentProperties');
  initMetadataForClass(CustomViewFeatureSpec, 'CustomViewFeatureSpec');
  initMetadataForObject(ExternalPasteContent, 'ExternalPasteContent', VOID, VOID, [ClipboardContent]);
  initMetadataForClass(View, 'View', VOID, VOID, [Composite]);
  initMetadataForClass(GroupView, 'GroupView', GroupView, View);
  initMetadataForClass(HorizontalView, 'HorizontalView', HorizontalView, View);
  initMetadataForClass(ImageView, 'ImageView', VOID, View);
  initMetadataForCompanion(Companion_213);
  initMetadataForClass(LineView, 'LineView', VOID, View);
  initMetadataForCompanion(Companion_214);
  initMetadataForClass(MultiPointView, 'MultiPointView', VOID, View);
  initMetadataForClass(NullViewContainerPeer, 'NullViewContainerPeer', NullViewContainerPeer);
  initMetadataForClass(PolyLineView, 'PolyLineView', VOID, MultiPointView);
  initMetadataForCompanion(Companion_215);
  initMetadataForClass(ScrollView, 'ScrollView', VOID, View);
  initMetadataForCompanion(Companion_216);
  initMetadataForClass(TextView, 'TextView', VOID, View);
  initMetadataForCompanion(Companion_217);
  initMetadataForClass(VerticalView, 'VerticalView', VerticalView, View);
  initMetadataForClass(View$ChildList$1, VOID, VOID, CollectionAdapter);
  function onPropertySet(prop, event) {
  }
  function onViewValidated() {
  }
  function onViewInvalidated() {
  }
  function onViewAttached() {
  }
  function onViewDetached() {
  }
  function onBoundsChanged(change) {
  }
  function onToRootDeltaChanged(change) {
  }
  function onChildAdded_2(event) {
  }
  function onChildRemoved_2(event) {
  }
  function onParentChanged_0(event) {
  }
  initMetadataForInterface(ViewListener, 'ViewListener');
  initMetadataForClass(View$ExternalChildList$addListener$1, VOID, VOID, VOID, [ViewListener]);
  initMetadataForClass(View$ExternalChildList$addHandler$1, VOID, VOID, VOID, [CollectionListener]);
  initMetadataForClass(View$getProp$1$addHandler$1, VOID, VOID, VOID, [ViewListener]);
  initMetadataForClass(View$customFeatureChange$1$addHandler$1, VOID, VOID, VOID, [ViewListener]);
  initMetadataForClass(View$valid$1$addHandler$1, VOID, VOID, VOID, [ViewListener]);
  initMetadataForClass(View$toRootDelta$1$addHandler$reg$1, VOID, VOID, VOID, [ViewListener]);
  initMetadataForClass(View$toRootDelta$1$addHandler$$inlined$toDisposable$1, VOID, VOID, VOID, [Disposable]);
  initMetadataForClass(View$boundsProp$1$addHandler$3, VOID, VOID, VOID, [ViewListener]);
  initMetadataForClass(View$attachEvents$1$addHandler$1, VOID, VOID, VOID, [ViewListener]);
  initMetadataForClass(ValidationContext, 'ValidationContext');
  initMetadataForClass(ChildList_1, 'ChildList', VOID, ObservableArrayList);
  initMetadataForClass(ExternalChildList_0, 'ExternalChildList', VOID, AbstractMutableList, [AbstractMutableList, MutableObservableList]);
  initMetadataForClass(ToParentOffsetProperty, 'ToParentOffsetProperty', VOID, DerivedProperty, [DerivedProperty, Property]);
  initMetadataForCompanion(Companion_218);
  initMetadataForClass(View$getProp$1, VOID, VOID, VOID, [Property]);
  initMetadataForClass(View$addListener$$inlined$toDisposable$1, VOID, VOID, VOID, [Disposable]);
  initMetadataForClass(View$customFeatureChange$1, VOID, VOID, VOID, [EventSource]);
  initMetadataForClass(View$valid$1, VOID, VOID, BaseReadableProperty);
  initMetadataForClass(View$toRootDelta$1, VOID, VOID, BaseReadableProperty);
  initMetadataForClass(View$boundsProp$1, VOID, VOID, BaseReadableProperty);
  initMetadataForClass(View$attachEvents$1, VOID, VOID, VOID, [EventSource]);
  initMetadataForClass(ViewContainer$RootView$1, VOID, VOID, VOID, [ViewListener]);
  initMetadataForClass(RootView, 'RootView', VOID, View);
  initMetadataForClass(FocusedViewProperty, 'FocusedViewProperty', VOID, ValueProperty);
  initMetadataForClass(ViewContainer, 'ViewContainer', ViewContainer);
  function onBeforeCommand_0() {
  }
  function onAfterCommand_0() {
  }
  function onPropertySet_0(view, prop, event) {
  }
  function onChildAdded_3(parent, change) {
  }
  function onChildRemoved_3(parent, change) {
  }
  function onViewAttached_0(view) {
  }
  function onViewDetached_0(view) {
  }
  initMetadataForInterface(ViewContainerListener, 'ViewContainerListener');
  initMetadataForClass(ViewEventSpec, 'ViewEventSpec');
  initMetadataForObject(ViewEvents, 'ViewEvents');
  initMetadataForClass(ViewPropertyKind, 'ViewPropertyKind', VOID, Enum);
  initMetadataForClass(ViewPropertyKind$NONE, 'NONE', VOID, ViewPropertyKind);
  initMetadataForClass(ViewPropertyKind$REPAINT, 'REPAINT', VOID, ViewPropertyKind);
  initMetadataForClass(ViewPropertyKind$RELAYOUT, 'RELAYOUT', VOID, ViewPropertyKind);
  initMetadataForClass(ViewPropertyKind$RELAYOUT_AND_REPAINT, 'RELAYOUT_AND_REPAINT', VOID, ViewPropertyKind);
  initMetadataForClass(ViewPropertyKind$RELAYOUT_PARENT, 'RELAYOUT_PARENT', VOID, ViewPropertyKind);
  initMetadataForClass(ViewPropertySpec, 'ViewPropertySpec');
  initMetadataForCompanion(Companion_219);
  initMetadataForClass(CellToDomCss, 'CellToDomCss', CellToDomCss);
  initMetadataForCompanion(Companion_220);
  initMetadataForClass(DomCell, 'DomCell', VOID, BaseCell);
  initMetadataForClass(AlignmentSynchronizers$bindStyle$$inlined$writableProperty$1, VOID, VOID, VOID, [WritableProperty]);
  initMetadataForObject(AlignmentSynchronizers, 'AlignmentSynchronizers');
  initMetadataForCompanion(Companion_221);
  initMetadataForClass(DomPopupManager, 'DomPopupManager', VOID, BasePopupManager);
  initMetadataForClass(BaseCellToDomMapper$createPopupManager$1, VOID, VOID, DomPopupManager);
  initMetadataForClass(BaseCellToDomMapper, 'BaseCellToDomMapper', VOID, BaseCellMapper);
  initMetadataForCompanion(Companion_222);
  initMetadataForClass(CellContainerToDomMapper$registerSynchronizers$$inlined$writableProperty$1, VOID, VOID, VOID, [WritableProperty]);
  initMetadataForClass(CellContainerToDomMapper$registerSynchronizers$2, VOID, VOID, VOID, [CellContainerListener]);
  initMetadataForClass(CellContainerToDomMapper$createCellContainerPeer$1, VOID, VOID, VOID, [CellContainerPeer], [2]);
  initMetadataForClass(CellContainerToDomMapper$registerListeners$mouseTranslator$1, VOID, VOID, MouseTranslator);
  initMetadataForClass(CellContainerToDomMapper$registerListeners$1);
  initMetadataForClass(CellContainerToDomMapper, 'CellContainerToDomMapper', VOID, Mapper);
  initMetadataForCompanion(Companion_223);
  initMetadataForClass(CellMapperRefresher$registerHideable$$inlined$toDisposable$1, VOID, VOID, VOID, [Disposable]);
  initMetadataForClass(CellMapperRefresher, 'CellMapperRefresher');
  initMetadataForObject(CellMappers, 'CellMappers');
  initMetadataForClass(CellToDomConfig, 'CellToDomConfig', CellToDomConfig);
  initMetadataForClass(CellToDomContext, 'CellToDomContext', VOID, CellMapperContext, [CellMapperContext, Disposable]);
  initMetadataForClass(DefaultCellMapper, 'DefaultCellMapper', VOID, BaseCellToDomMapper);
  initMetadataForClass(HighlightLayout, 'HighlightLayout');
  initMetadataForCompanion(Companion_224);
  initMetadataForClass(sam$jetbrains_ocelot_base_edt_EdtTask$0_12, 'sam$jetbrains_ocelot_base_edt_EdtTask$0', VOID, VOID, [EdtTask, FunctionAdapter]);
  initMetadataForClass(sam$jetbrains_ocelot_base_edt_EdtTask$0_13, 'sam$jetbrains_ocelot_base_edt_EdtTask$0', VOID, VOID, [EdtTask, FunctionAdapter]);
  initMetadataForClass(sam$jetbrains_ocelot_base_edt_EdtTask$0_14, 'sam$jetbrains_ocelot_base_edt_EdtTask$0', VOID, VOID, [EdtTask, FunctionAdapter]);
  initMetadataForClass(DefaultLineHighlight, 'DefaultLineHighlight', VOID, VOID, [Disposable]);
  initMetadataForClass(DomCellMapper$registerSynchronizers$$inlined$writableProperty$1, VOID, VOID, VOID, [WritableProperty]);
  initMetadataForClass(DomCellMapper$registerSynchronizers$3, VOID, VOID, CellTrait);
  initMetadataForClass(DomCellMapper, 'DomCellMapper', VOID, BaseCellToDomMapper);
  initMetadataForClass(UpdatePositionTask, 'UpdatePositionTask');
  initMetadataForCompanion(Companion_225);
  initMetadataForClass(sam$jetbrains_ocelot_base_edt_EdtTask$0_15, 'sam$jetbrains_ocelot_base_edt_EdtTask$0', VOID, VOID, [EdtTask, FunctionAdapter]);
  initMetadataForClass(DomPopupManager$setPopupUpdate$$inlined$toDisposable$1, VOID, VOID, VOID, [Disposable]);
  initMetadataForObject(DomProperties, 'DomProperties');
  initMetadataForClass(DomTextInput, 'DomTextInput', VOID, VOID, [Disposable]);
  initMetadataForClass(EmptyLineHighlight, 'EmptyLineHighlight', EmptyLineHighlight, VOID, [Disposable]);
  initMetadataForObject(HiddenTextAreaHelper, 'HiddenTextAreaHelper');
  initMetadataForClass(HorizontalCellMapper, 'HorizontalCellMapper', VOID, BaseCellToDomMapper);
  initMetadataForCompanion(Companion_226);
  initMetadataForClass(ImageCellMapper$registerSynchronizers$$inlined$writableProperty$1, VOID, VOID, VOID, [WritableProperty]);
  initMetadataForClass(ImageCellMapper, 'ImageCellMapper', VOID, BaseCellToDomMapper);
  initMetadataForClass(IndentRootCellMapper$2$wrap$1);
  initMetadataForClass(IndentRootCellMapper$2);
  initMetadataForClass(IndentRootCellMapper$1, VOID, VOID, IndentUpdater);
  initMetadataForClass(IndentRootCellMapper$onAttach$1, VOID, VOID, BaseIndentUpdatingListener);
  initMetadataForClass(IndentRootCellMapper$createPopupManager$1, VOID, VOID, DomPopupManager);
  initMetadataForClass(IndentRootCellMapper, 'IndentRootCellMapper', VOID, BaseCellToDomMapper);
  initMetadataForCompanion(Companion_227);
  initMetadataForCompanion(Companion_228);
  initMetadataForClass(PopupPositioner, 'PopupPositioner', VOID, PopupPositionUpdater);
  initMetadataForClass(RootCellMapper, 'RootCellMapper', VOID, BaseCellToDomMapper);
  initMetadataForClass(ScrollCellMapper, 'ScrollCellMapper', VOID, BaseCellToDomMapper);
  initMetadataForCompanion(Companion_229);
  initMetadataForClass(TextCellMapper$refreshProperties$$inlined$toDisposable$1, VOID, VOID, VOID, [Disposable]);
  initMetadataForClass(TextCellMapper, 'TextCellMapper', VOID, BaseCellToDomMapper);
  initMetadataForClass(TextPlaceholderCellMapper$registerSynchronizers$$inlined$writableProperty$1, VOID, VOID, VOID, [WritableProperty]);
  initMetadataForClass(TextPlaceholderCellMapper$registerSynchronizers$$inlined$writableProperty$2, VOID, VOID, VOID, [WritableProperty]);
  initMetadataForClass(TextPlaceholderCellMapper, 'TextPlaceholderCellMapper', VOID, BaseCellToDomMapper);
  initMetadataForClass(Tooltip$injectCornerStyle$$inlined$toDisposable$1, VOID, VOID, VOID, [Disposable]);
  initMetadataForObject(Tooltip, 'Tooltip');
  initMetadataForClass(VerticalCellMapper, 'VerticalCellMapper', VOID, BaseCellToDomMapper);
  initMetadataForClass(ViewCellMapper$registerSynchronizers$$inlined$writableProperty$1, VOID, VOID, VOID, [WritableProperty]);
  initMetadataForClass(ViewCellMapper, 'ViewCellMapper', VOID, BaseCellToDomMapper);
  initMetadataForCompanion(Companion_230);
  initMetadataForClass(DomTextEditor, 'DomTextEditor');
  initMetadataForClass(DomUtil$scheduleDeferred$$inlined$toDisposable$1, VOID, VOID, VOID, [Disposable]);
  initMetadataForObject(DomUtil_0, 'DomUtil');
  initMetadataForObject(Scrolling, 'Scrolling');
  initMetadataForClass(TextMetricsCalculator$calculateApprox$1);
  initMetadataForClass(TextMetricsCalculator$calculate$1);
  initMetadataForObject(TextMetricsCalculator, 'TextMetricsCalculator');
  initMetadataForClass(DomView, 'DomView', VOID, View);
  initMetadataForClass(BaseViewMapper$registerSynchronizers$$inlined$forEventSource$1, VOID, VOID, DisposableSynchronizer);
  initMetadataForClass(BaseViewMapper$registerSynchronizers$$inlined$writableProperty$1, VOID, VOID, VOID, [WritableProperty]);
  initMetadataForClass(BaseViewMapper$registerSynchronizers$$inlined$forEventSource$2, VOID, VOID, DisposableSynchronizer);
  initMetadataForClass(BaseViewMapper$registerSynchronizers$$inlined$writableProperty$2, VOID, VOID, VOID, [WritableProperty]);
  initMetadataForClass(BaseViewMapper$registerSynchronizers$$inlined$writableProperty$3, VOID, VOID, VOID, [WritableProperty]);
  initMetadataForClass(BaseViewMapper, 'BaseViewMapper', VOID, Mapper);
  initMetadataForClass(CompositeViewMapper, 'CompositeViewMapper', VOID, BaseViewMapper);
  initMetadataForClass(DomViewMapper$registerSynchronizers$$inlined$forEventSource$1, VOID, VOID, DisposableSynchronizer);
  initMetadataForClass(DomViewMapper$registerSynchronizers$$inlined$writableProperty$1, VOID, VOID, VOID, [WritableProperty]);
  initMetadataForClass(DomViewMapper$registerSynchronizers$$inlined$writableProperty$2, VOID, VOID, VOID, [WritableProperty]);
  initMetadataForClass(DomViewMapper, 'DomViewMapper', VOID, BaseViewMapper);
  initMetadataForClass(DomViewSynchronizers$boundsSynchronizer$$inlined$writableProperty$1, VOID, VOID, VOID, [WritableProperty]);
  initMetadataForObject(DomViewSynchronizers, 'DomViewSynchronizers');
  initMetadataForClass(HorizontalViewMapper, 'HorizontalViewMapper', VOID, BaseViewMapper);
  initMetadataForClass(ImageViewMapper$registerSynchronizers$$inlined$writableProperty$1, VOID, VOID, VOID, [WritableProperty]);
  initMetadataForClass(ImageViewMapper, 'ImageViewMapper', VOID, BaseViewMapper);
  initMetadataForClass(LineViewMapper$registerSynchronizers$$inlined$writableProperty$1, VOID, VOID, VOID, [WritableProperty]);
  initMetadataForClass(LineViewMapper$registerSynchronizers$$inlined$writableProperty$2, VOID, VOID, VOID, [WritableProperty]);
  initMetadataForClass(LineViewMapper$registerSynchronizers$$inlined$writableProperty$3, VOID, VOID, VOID, [WritableProperty]);
  initMetadataForClass(LineViewMapper$registerSynchronizers$$inlined$writableProperty$4, VOID, VOID, VOID, [WritableProperty]);
  initMetadataForClass(LineViewMapper, 'LineViewMapper', VOID, BaseViewMapper);
  initMetadataForCompanion(Companion_231);
  initMetadataForClass(MultiPointViewMapper$registerSynchronizers$1, VOID, VOID, VOID, [Synchronizer]);
  initMetadataForClass(MultiPointViewMapper$registerSynchronizers$$inlined$writableProperty$1, VOID, VOID, VOID, [WritableProperty]);
  initMetadataForClass(MultiPointViewMapper$registerSynchronizers$$inlined$writableProperty$2, VOID, VOID, VOID, [WritableProperty]);
  initMetadataForClass(MultiPointViewMapper, 'MultiPointViewMapper', VOID, BaseViewMapper);
  initMetadataForClass(ScrollViewMapper$registerSynchronizers$$inlined$writableProperty$1, VOID, VOID, VOID, [WritableProperty]);
  initMetadataForClass(ScrollViewMapper$registerSynchronizers$$inlined$writableProperty$2, VOID, VOID, VOID, [WritableProperty]);
  initMetadataForClass(ScrollViewMapper, 'ScrollViewMapper', VOID, CompositeViewMapper);
  initMetadataForObject(SvgUtil, 'SvgUtil');
  initMetadataForClass(TextViewMapper$registerSynchronizers$$inlined$writableProperty$1, VOID, VOID, VOID, [WritableProperty]);
  initMetadataForClass(TextViewMapper$registerSynchronizers$$inlined$writableProperty$2, VOID, VOID, VOID, [WritableProperty]);
  initMetadataForClass(TextViewMapper$registerSynchronizers$$inlined$writableProperty$3, VOID, VOID, VOID, [WritableProperty]);
  initMetadataForClass(TextViewMapper$registerSynchronizers$$inlined$writableProperty$4, VOID, VOID, VOID, [WritableProperty]);
  initMetadataForClass(TextViewMapper$registerSynchronizers$$inlined$writableProperty$5, VOID, VOID, VOID, [WritableProperty]);
  initMetadataForClass(TextViewMapper$registerSynchronizers$$inlined$writableProperty$6, VOID, VOID, VOID, [WritableProperty]);
  initMetadataForClass(TextViewMapper$registerSynchronizers$$inlined$writableProperty$7, VOID, VOID, VOID, [WritableProperty]);
  initMetadataForClass(TextViewMapper$registerSynchronizers$$inlined$writableProperty$8, VOID, VOID, VOID, [WritableProperty]);
  initMetadataForClass(TextViewMapper$registerSynchronizers$$inlined$writableProperty$9, VOID, VOID, VOID, [WritableProperty]);
  initMetadataForClass(TextViewMapper$registerSynchronizers$$inlined$writableProperty$10, VOID, VOID, VOID, [WritableProperty]);
  initMetadataForClass(TextViewMapper$registerSynchronizers$$inlined$writableProperty$11, VOID, VOID, VOID, [WritableProperty]);
  initMetadataForClass(TextViewMapper, 'TextViewMapper', VOID, BaseViewMapper);
  initMetadataForClass(VerticalViewMapper$registerSynchronizers$$inlined$writableProperty$1, VOID, VOID, VOID, [WritableProperty]);
  initMetadataForClass(VerticalViewMapper, 'VerticalViewMapper', VOID, CompositeViewMapper);
  initMetadataForClass(ViewContainerToElementMapper$viewToDomContext$1);
  initMetadataForClass(ViewContainerToElementMapper$registerSynchronizers$$inlined$writableProperty$1, VOID, VOID, VOID, [WritableProperty]);
  initMetadataForClass(ViewContainerToElementMapper$registerListeners$mouseTranslator$1, VOID, VOID, MouseTranslator);
  initMetadataForClass(ViewContainerToElementMapper$onAttach$1);
  initMetadataForClass(ViewContainerToElementMapper, 'ViewContainerToElementMapper', VOID, Mapper);
  initMetadataForObject(ViewMapperFactory, 'ViewMapperFactory');
  initMetadataForObject(ViewToDom, 'ViewToDom');
  initMetadataForCompanion(Companion_232);
  initMetadataForClass(CellContainerState, 'CellContainerState', VOID, VOID, [OtAware]);
  initMetadataForClass(CellOperation, 'CellOperation', VOID, BaseOperation);
  initMetadataForCompanion(Companion_233);
  initMetadataForClass(CellPath, 'CellPath');
  initMetadataForClass(CellStateAfterExternalOpRestorer, 'CellStateAfterExternalOpRestorer', VOID, VOID, [OtCommandListener]);
  initMetadataForClass(CellStateManager$1, VOID, VOID, VOID, [CellContainerListener]);
  initMetadataForClass(CellStateManager, 'CellStateManager', VOID, VOID, [Disposable]);
  initMetadataForClass(CellStateOperation, 'CellStateOperation', VOID, CellOperation);
  initMetadataForClass(ModelOperationSupplier, 'ModelOperationSupplier');
  initMetadataForClass(DefaultOperationProvider, 'DefaultOperationProvider');
  initMetadataForClass(FocusOperation, 'FocusOperation', VOID, CellOperation);
  initMetadataForClass(MyStack, 'MyStack');
  initMetadataForClass(NavigationManager$1, VOID, VOID, CellTrait);
  initMetadataForClass(NavigationManager$2, VOID, VOID, VOID, [OtCommandListener]);
  initMetadataForClass(NavigationManager, 'NavigationManager', VOID, VOID, [Disposable]);
  initMetadataForClass(NodeCellState$restore$1, VOID, VOID, OperationCondition);
  initMetadataForClass(NodeCellState, 'NodeCellState');
  initMetadataForClass(NonChildNodeOperation, 'NonChildNodeOperation', VOID, CellOperation, [CellOperation, HasOperationTargetData]);
  initMetadataForClass(UndoTrait, 'UndoTrait', VOID, CellTrait);
  initMetadataForClass(CellContainerCommandWatcher, 'CellContainerCommandWatcher', VOID, VOID, [CellContainerListener, Disposable]);
  initMetadataForCompanion(Companion_234);
  initMetadataForClass(OtSupport, 'OtSupport', VOID, VOID, [Disposable]);
  initMetadataForClass(OtViewStateProvider, 'OtViewStateProvider', OtViewStateProvider, VOID, [ViewStateProvider]);
  initMetadataForClass(SimpleUndoStateHandler, 'SimpleUndoStateHandler', SimpleUndoStateHandler);
  initMetadataForInterface(TransformableCellState, 'TransformableCellState');
  initMetadataForClass(ActionKind, 'ActionKind', VOID, Enum);
  initMetadataForCompanion(Companion_235);
  function getNode$default(cell, predicate, $super) {
    var tmp;
    if (predicate === VOID) {
      tmp = NodeCellProvider$getNode$lambda;
    } else {
      tmp = predicate;
    }
    predicate = tmp;
    return $super === VOID ? this.nc9(cell, predicate) : $super.nc9.call(this, cell, predicate);
  }
  initMetadataForInterface(NodeCellProvider, 'NodeCellProvider');
  initMetadataForClass(NodeWrapperCellProvider$getCells$sourcePath$1);
  initMetadataForClass(NodeWrapperCellProvider, 'NodeWrapperCellProvider', VOID, VOID, [NodeCellProvider]);
  initMetadataForClass(OtNodeCellProvider$getCells$sourcePath$1);
  initMetadataForClass(OtNodeCellProvider, 'OtNodeCellProvider', VOID, VOID, [NodeCellProvider]);
  initMetadataForClass(OtSupportBuilder, 'OtSupportBuilder', OtSupportBuilder);
  initMetadataForClass(SingleNavigationManager, 'SingleNavigationManager', VOID, NavigationManager);
  initMetadataForClass(HighlightErrorsSynchronizer$trait$1, VOID, VOID, CellTrait);
  initMetadataForClass(HighlightErrorsSynchronizer, 'HighlightErrorsSynchronizer', VOID, VOID, [Synchronizer]);
  initMetadataForCompanion(Companion_236);
  initMetadataForClass(HighlightingMapper, 'HighlightingMapper', VOID, Mapper);
  initMetadataForClass(highlighted$1);
  initMetadataForCompanion(Companion_237);
  initMetadataForClass(ErrorHighlighterBase, 'ErrorHighlighterBase', VOID, Mapper);
  initMetadataForClass(ProjectionalHighlightMapper, 'ProjectionalHighlightMapper', VOID, ErrorHighlighterBase);
  initMetadataForObject(ErrorHighlighterTrait, 'ErrorHighlighterTrait', VOID, CellTrait);
  initMetadataForObject(ErrorHighlightingController, 'ErrorHighlightingController');
  initMetadataForCompanion(Companion_238);
  initMetadataForClass(ErrorSupport$addError$$inlined$toDisposable$1, VOID, VOID, VOID, [Disposable]);
  initMetadataForClass(ErrorSupport, 'ErrorSupport');
  initMetadataForCompanion(Companion_239);
  initMetadataForClass(MouseTracker, 'MouseTracker', MouseTracker, CellTrait);
  initMetadataForObject(NumberOfMessages, 'NumberOfMessages');
  initMetadataForCompanion(Companion_240);
  initMetadataForClass(ShowCellGroupTrait, 'ShowCellGroupTrait', VOID, CellTrait);
  initMetadataForClass(CheckNodeMapper, 'CheckNodeMapper', VOID, Mapper);
  initMetadataForClass(CheckResultEntry, 'CheckResultEntry');
  initMetadataForCompanion(Companion_241);
  initMetadataForLambda(CheckNodeSynchronizer$prepare$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(CheckNodeSynchronizer$run$$inlined$eventHandler$1);
  initMetadataForCoroutine($runCOROUTINE$, CoroutineImpl);
  initMetadataForClass(CheckNodeSynchronizer, 'CheckNodeSynchronizer', VOID, VOID, [Synchronizer], [1]);
  initMetadataForCompanion(Companion_242);
  initMetadataForClass(ErrorHighlighterBase$registerSynchronizers$1, VOID, VOID, VOID, [Synchronizer]);
  initMetadataForClass(ErrorHighlighterBase$registerSynchronizers$$inlined$forEventSource$1, VOID, VOID, DisposableSynchronizer);
  initMetadataForClass(sam$jetbrains_ocelot_projectional_editor_generic_roleCompletion_RoleCompletion$0_1, 'sam$jetbrains_ocelot_projectional_editor_generic_roleCompletion_RoleCompletion$0', VOID, VOID, [RoleCompletion, FunctionAdapter]);
  initMetadataForLambda(CellAwareCompletionSupplier$createEventHandler$o$onEvent$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(CellAwareCompletionSupplier$asSupplier$$inlined$completionSupplier$1);
  initMetadataForClass(CellAwareCompletionSupplier$invoke$$inlined$eventHandler$1);
  initMetadataForClass(CellAwareCompletionSupplier$createEventHandler$$inlined$eventHandler$1);
  initMetadataForClass(CellAwareCompletionSupplier, 'CellAwareCompletionSupplier');
  initMetadataForClass(CompletionItemKindProvider, 'CompletionItemKindProvider', CompletionItemKindProvider);
  initMetadataForClass(CompletionBuilder, 'CompletionBuilder', VOID, CompletionItemKindProvider);
  initMetadataForClass(CompletionBuilderBase$does$2$$inlined$simpleCompletionItem$1, VOID, VOID, SimpleCompletionItem);
  initMetadataForClass(CompletionBuilderBase, 'CompletionBuilderBase', VOID, CompletionBuilder);
  initMetadataForLambda(CompletionBuilderImpl$async$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(CompletionBuilderImpl$async$2$$inlined$completionSupplier$1);
  initMetadataForClass(CompletionBuilderImpl, 'CompletionBuilderImpl', VOID, CompletionBuilderBase);
  initMetadataForLambda(CoroutineCompletionBuilder$item$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(CoroutineCompletionBuilder$async$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(CoroutineCompletionBuilder, 'CoroutineCompletionBuilder', VOID, CompletionBuilderBase);
  initMetadataForClass(CompletionItemKind, 'CompletionItemKind');
  initMetadataForClass(ReferenceKind, 'ReferenceKind', VOID, CompletionItemKind);
  initMetadataForClass(CustomCompletionKind, 'CustomCompletionKind', VOID, CompletionItemKind);
  initMetadataForObject(NumberKind, 'NumberKind', VOID, CompletionItemKind);
  initMetadataForObject(StringKind, 'StringKind', VOID, CompletionItemKind);
  initMetadataForClass(OtherCompletionKind, 'OtherCompletionKind', VOID, CompletionItemKind);
  initMetadataForClass(CompletionOptions, 'CompletionOptions', CompletionOptions);
  initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0_10, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
  initMetadataForLambda(completionResult$o$collect$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($collectCOROUTINE$_15, CoroutineImpl);
  initMetadataForClass(completionResult$$inlined$map$1, VOID, VOID, VOID, [Flow], [1]);
  initMetadataForClass(NodeCompletionBuilder, 'NodeCompletionBuilder', VOID, CompletionItemKindProvider);
  initMetadataForClass(NodeProducerBuilder, 'NodeProducerBuilder');
  initMetadataForInterface(ActionOnCell, 'ActionOnCell');
  initMetadataForClass(sam$jetbrains_ocelot_langDef_completion_ActionOnCell$0, 'sam$jetbrains_ocelot_langDef_completion_ActionOnCell$0', VOID, VOID, [ActionOnCell, FunctionAdapter]);
  initMetadataForClass(Builder_3, 'Builder', VOID, NodeProducerBuilder);
  initMetadataForClass(PrefixBasedCompletionSupplier, 'PrefixBasedCompletionSupplier', VOID, CellAwareCompletionSupplier);
  initMetadataForClass(ReferenceCompletionBase, 'ReferenceCompletionBase', VOID, PrefixBasedCompletionSupplier);
  initMetadataForClass(NodeCompletionBuilderBase$produces$8$referenceCompletion$1, VOID, VOID, ReferenceCompletionBase);
  initMetadataForClass(NodeCompletionBuilderBase, 'NodeCompletionBuilderBase', VOID, NodeCompletionBuilder);
  initMetadataForClass(NodeCompletionBuilderImpl$produces$transformRole$1);
  initMetadataForLambda(NodeCompletionBuilderImpl$async$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(NodeCompletionBuilderImpl, 'NodeCompletionBuilderImpl', VOID, NodeCompletionBuilderBase);
  initMetadataForClass(ReferenceCompletion, 'ReferenceCompletion', VOID, ReferenceCompletionBase);
  initMetadataForLambda(ReferenceCompletionBase$getSortedElements$o$collect$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($collectCOROUTINE$_16, CoroutineImpl);
  initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0_11, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
  initMetadataForClass(ReferenceCompletionBase$getSortedElements$$inlined$map$1, VOID, VOID, VOID, [Flow], [1]);
  initMetadataForCompanion(Companion_243);
  initMetadataForClass(SortPriorityRange, 'SortPriorityRange');
  initMetadataForClass(SortedReferenceTargetItem, 'SortedReferenceTargetItem');
  initMetadataForClass(TextMatcherByFilterSettings, 'TextMatcherByFilterSettings');
  initMetadataForClass(completes$$inlined$simpleCompletionItem$1, VOID, VOID, SimpleCompletionItem);
  initMetadataForClass(simpleCompletion$1$createRoleCompletion$completionItem$$inlined$simpleCompletionItem$1, VOID, VOID, SimpleCompletionItem);
  initMetadataForClass(simpleCompletion$1, VOID, VOID, VOID, [RoleCompletion]);
  initMetadataForClass(intRoleCompletion$1, VOID, VOID, VOID, [RoleCompletion]);
  initMetadataForClass(completionItemForNumber$1, VOID, VOID, BaseCompletionItem);
  initMetadataForClass(completionItemForValidator$1, VOID, VOID, BaseCompletionItem);
  initMetadataForClass(sam$jetbrains_ocelot_projectional_editor_generic_roleCompletion_RoleCompletion$0_2, 'sam$jetbrains_ocelot_projectional_editor_generic_roleCompletion_RoleCompletion$0', VOID, VOID, [RoleCompletion, FunctionAdapter]);
  initMetadataForClass(sam$jetbrains_ocelot_projectional_editor_generic_roleCompletion_RoleCompletion$0_3, 'sam$jetbrains_ocelot_projectional_editor_generic_roleCompletion_RoleCompletion$0', VOID, VOID, [RoleCompletion, FunctionAdapter]);
  initMetadataForClass(map$3);
  initMetadataForClass(plus$$inlined$completionSupplier$1);
  initMetadataForClass(sam$jetbrains_ocelot_langDef_completion_ActionOnCell$0_0, 'sam$jetbrains_ocelot_langDef_completion_ActionOnCell$0', VOID, VOID, [ActionOnCell, FunctionAdapter]);
  initMetadataForClass(editorString$1, VOID, VOID, CustomCompletionKind);
  initMetadataForClass(nodeRefCompletion$1$createRoleCompletion$completionBase$1, VOID, VOID, ReferenceCompletionBase);
  initMetadataForClass(nodeRefCompletion$1, VOID, VOID, VOID, [RoleCompletion]);
  initMetadataForClass(BaseCellBuilder, 'BaseCellBuilder');
  initMetadataForClass(CellBuildResult, 'CellBuildResult');
  function getCell(builder, id) {
    var contextKey = new ContextKey(builder, id);
    return this.hcq(contextKey);
  }
  initMetadataForInterface(CellBuilderContext, 'CellBuilderContext');
  initMetadataForClass(indentLabel$1);
  initMetadataForClass(_no_name_provided__qut3iv_3, VOID, VOID, VOID, [WritableProperty]);
  initMetadataForClass(CellBuilderId, 'CellBuilderId', VOID, BaseId);
  initMetadataForClass(rightTransform$2$$inlined$propertyTrait$1, VOID, VOID, CellTrait);
  initMetadataForClass(trait$2$$inlined$propertyTrait$1, VOID, VOID, CellTrait);
  initMetadataForClass(addTraitOnAttachGeneric$2$sync$1, VOID, VOID, DisposableSynchronizer);
  initMetadataForClass(completion$2$$inlined$propertyTrait$1, VOID, VOID, CellTrait);
  initMetadataForClass(completion$4$$inlined$propertyTrait$1, VOID, VOID, CellTrait);
  initMetadataForClass(CellCreationResult, 'CellCreationResult');
  initMetadataForClass(CompositeMapperBuilder, 'CompositeMapperBuilder');
  initMetadataForClass(ContextKey, 'ContextKey');
  initMetadataForClass(EditorScope, 'EditorScope', EditorScope);
  initMetadataForClass(LazyMapperBuilder, 'LazyMapperBuilder');
  initMetadataForClass(invalidMapperBuilder$1);
  initMetadataForClass(projectionalChild$4$2$target$1, VOID, VOID, VOID, [WritableProperty]);
  initMetadataForClass(NamedCellFactory, 'NamedCellFactory');
  function referenceTextProperty$default(placeholderText, validator, property, $super) {
    validator = validator === VOID ? null : validator;
    return $super === VOID ? this.jcs(placeholderText, validator, property) : $super.jcs.call(this, placeholderText, validator, property);
  }
  initMetadataForInterface(ReferenceCellBuilder, 'ReferenceCellBuilder');
  initMetadataForClass(SimpleCellBuilder, 'SimpleCellBuilder', VOID, BaseCellBuilder);
  initMetadataForClass(RootCellBuilderImpl, 'RootCellBuilderImpl');
  initMetadataForClass(SimpleMapperBuilder$build$builderContext$1, VOID, VOID, VOID, [CellBuilderContext]);
  initMetadataForClass(SimpleMapperBuilder$build$1, VOID, VOID, Mapper);
  initMetadataForClass(SimpleMapperBuilder, 'SimpleMapperBuilder');
  initMetadataForClass(SimpleProjectionalRoleSynchronizerBuilder, 'SimpleProjectionalRoleSynchronizerBuilder');
  initMetadataForObject(NodeContentKind, 'NodeContentKind');
  initMetadataForClass(EditorNode, 'EditorNode');
  initMetadataForCompanion(Companion_244);
  initMetadataForClass(PresentationMode, 'PresentationMode');
  initMetadataForClass(SourceMode, 'SourceMode', VOID, Enum);
  initMetadataForClass(spaceDoesntCloseCompletion$$inlined$propertyTrait$1, VOID, VOID, CellTrait);
  initMetadataForClass(Side_2, 'Side', VOID, Enum);
  initMetadataForClass(CompoundSideTransformTrait$Side$LEFT, 'LEFT', VOID, Side_2);
  initMetadataForClass(CompoundSideTransformTrait$Side$RIGHT, 'RIGHT', VOID, Side_2);
  initMetadataForObject(CompoundSideTransformTrait, 'CompoundSideTransformTrait', VOID, CellTrait);
  initMetadataForClass(LineMapper$registerSynchronizers$$inlined$writableProperty$1, VOID, VOID, VOID, [WritableProperty]);
  initMetadataForClass(LineMapper, 'LineMapper', VOID, Mapper);
  initMetadataForCompanion(Companion_245);
  initMetadataForClass(MultilineSelection, 'MultilineSelection');
  initMetadataForCompanion(Companion_246);
  initMetadataForClass(MultilineTextCell, 'MultilineTextCell', VOID, VerticalCell);
  initMetadataForClass(MultilinePasteOnPlaceholder, 'MultilinePasteOnPlaceholder', VOID, CellTrait);
  initMetadataForClass(CopyCutOnWholeMultilineTextCell, 'CopyCutOnWholeMultilineTextCell', VOID, CellTrait);
  initMetadataForClass(sam$jetbrains_ocelot_projectional_editor_generic_roleCompletion_RoleCompletion$0_4, 'sam$jetbrains_ocelot_projectional_editor_generic_roleCompletion_RoleCompletion$0', VOID, VOID, [RoleCompletion, FunctionAdapter]);
  initMetadataForClass(MultilineTextSynchronizerFactory$SynchronizerSetup$completion$2$1, VOID, VOID, BaseCompletionItem);
  initMetadataForClass(SynchronizerSetup, 'SynchronizerSetup');
  initMetadataForClass(MultilineTextSynchronizerFactory, 'MultilineTextSynchronizerFactory');
  initMetadataForCompanion(Companion_247);
  initMetadataForClass(Position_0, 'Position', VOID, VOID, [Comparable]);
  initMetadataForClass(PositionHandler, 'PositionHandler', VOID, VOID, [CellStateHandler]);
  initMetadataForClass(SimpleTextPositionHandler, 'SimpleTextPositionHandler', SimpleTextPositionHandler, PositionHandler);
  initMetadataForClass(TextPositionState, 'TextPositionState');
  initMetadataForClass(defaultTextPositionStateHandlerTrait$$inlined$propertyTrait$1, VOID, VOID, CellTrait);
  initMetadataForLambda(TextFormatter$breakLongString$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(TextFormatter, 'TextFormatter');
  initMetadataForClass(ReadOnlyTextCellTrait, 'ReadOnlyTextCellTrait', VOID, CellTrait);
  initMetadataForClass(EditableTextCellTrait, 'EditableTextCellTrait', VOID, ReadOnlyTextCellTrait);
  initMetadataForClass(TextMapper, 'TextMapper', VOID, Mapper);
  initMetadataForClass(TextModel, 'TextModel');
  initMetadataForClass(TransformablePositionStateTrait, 'TransformablePositionStateTrait', VOID, CellTrait);
  initMetadataForClass(TransformableTextPositionState, 'TransformableTextPositionState', VOID, TextPositionState, [TextPositionState, TransformableCellState]);
  initMetadataForCompanion(Companion_248);
  initMetadataForClass(TransformableTextPositionStateHandler, 'TransformableTextPositionStateHandler', VOID, PositionHandler);
  initMetadataForClass(ChildBuilder, 'ChildBuilder');
  initMetadataForClass(indentLabel$2$prevIsPlaceholder$1);
  initMetadataForClass(indentLabel$2$$inlined$writableProperty$1, VOID, VOID, VOID, [WritableProperty]);
  initMetadataForClass(considerEmptyBy$1, VOID, VOID, CellTrait);
  initMetadataForClass(rightTransform$2$$inlined$propertyTrait$1_0, VOID, VOID, CellTrait);
  initMetadataForCompanion(Companion_249);
  initMetadataForClass(CellMark$trait$1, VOID, VOID, CellTrait);
  initMetadataForClass(CellMark, 'CellMark', CellMark);
  initMetadataForClass(Layout, 'Layout', VOID, Enum);
  initMetadataForClass(separatorSideTransform$2$$inlined$propertyFromCellTrait$1, VOID, VOID, CellTrait);
  function createMapper(source) {
    var rootSourceClass = getKClassFromExpression(source);
    return this.pd2(source, rootSourceClass);
  }
  initMetadataForInterface(EditorMapperFactory, 'EditorMapperFactory');
  initMetadataForClass(EditorMapperFactoryImpl, 'EditorMapperFactoryImpl', VOID, VOID, [EditorMapperFactory]);
  initMetadataForClass(attachCompletion$2$$inlined$propertyTrait$2, VOID, VOID, CellTrait);
  initMetadataForClass(createOnAttachSynchronizer$1, VOID, VOID, DisposableSynchronizer);
  initMetadataForClass(TextSpecification, 'TextSpecification');
  initMetadataForClass(RoleDefaults, 'RoleDefaults');
  initMetadataForClass(ChildRoleDefaults, 'ChildRoleDefaults', VOID, RoleDefaults);
  initMetadataForClass(ChildrenRoleDefaults, 'ChildrenRoleDefaults', VOID, RoleDefaults);
  initMetadataForInterface(EditorBuilder, 'EditorBuilder');
  initMetadataForClass(RoleEditorDefinition, 'RoleEditorDefinition');
  initMetadataForClass(EditorDefinition, 'EditorDefinition', VOID, RoleEditorDefinition);
  initMetadataForClass(HierarchyEditorDefinition, 'HierarchyEditorDefinition', VOID, RoleEditorDefinition);
  initMetadataForClass(InvalidatingEditorBuilder, 'InvalidatingEditorBuilder', VOID, QueryBuilder, [QueryBuilder, EditorBuilder], [1]);
  initMetadataForClass(CollectionSeparator, 'CollectionSeparator');
  initMetadataForClass(StringSeparator, 'StringSeparator', VOID, CollectionSeparator);
  initMetadataForClass(EmptyLinesSeparator, 'EmptyLinesSeparator', EmptyLinesSeparator, CollectionSeparator);
  initMetadataForObject(NewLineSeparator, 'NewLineSeparator', VOID, CollectionSeparator);
  function get_highlightErrors() {
    return this.nd0().yct_1;
  }
  function get_readOnly() {
    return this.nd0().acu();
  }
  initMetadataForInterface(InternalEditorBuilderConfig, 'InternalEditorBuilderConfig');
  initMetadataForClass(EditorBuilderConfigImpl, 'EditorBuilderConfigImpl', VOID, VOID, [InternalEditorBuilderConfig]);
  initMetadataForCompanion(Companion_250);
  initMetadataForClass(EditorRegistryImpl, 'EditorRegistryImpl');
  initMetadataForClass(BaseRoleSpec, 'BaseRoleSpec');
  initMetadataForClass(ChildRoleSpec, 'ChildRoleSpec', VOID, BaseRoleSpec);
  initMetadataForClass(ChildrenRoleSpec, 'ChildrenRoleSpec', VOID, BaseRoleSpec);
  initMetadataForInterface(InternalEditorBuilder, 'InternalEditorBuilder', VOID, VOID, [EditorBuilder]);
  initMetadataForClass(WaitingMapperFactory, 'WaitingMapperFactory');
  initMetadataForClass(sam$jetbrains_ocelot_base_edt_EdtTask$0_16, 'sam$jetbrains_ocelot_base_edt_EdtTask$0', VOID, VOID, [EdtTask, FunctionAdapter]);
  initMetadataForClass(BaseEditor$createMapper$triggerContentUpdateSynchronizer$1, VOID, VOID, VOID, [Synchronizer]);
  initMetadataForClass(BaseEditor$createMapperFactory$$inlined$mapperFactory$1);
  initMetadataForClass(RoleEditor, 'RoleEditor');
  initMetadataForClass(BaseEditor, 'BaseEditor', VOID, RoleEditor);
  initMetadataForClass(Editor$getDefaultCompletionSuppliers$$inlined$map$1$getCompletionItems$1, VOID, VOID, SimpleCompletionItem);
  initMetadataForClass(Editor$getDefaultCompletionSuppliers$$inlined$map$1);
  initMetadataForClass(Editor$getCompletionSuppliers$completionSupplier$1);
  initMetadataForClass(Editor, 'Editor', VOID, BaseEditor);
  initMetadataForClass(EditorBuilderMapper, 'EditorBuilderMapper', VOID, Mapper);
  initMetadataForClass(HierarchyRoleEditor$createMapperFactory$$inlined$mapperFactory$1);
  initMetadataForClass(HierarchyRoleEditor, 'HierarchyRoleEditor', VOID, RoleEditor);
  initMetadataForCoroutine($prepareCOROUTINE$_0, CoroutineImpl);
  initMetadataForClass(Update, 'Update');
  initMetadataForClass(NodeWrapperReferenceAdapter$afterPaste$1, VOID, VOID, VOID, [AsyncGuardedExecution], [0]);
  initMetadataForClass(NodeWrapperReferenceAdapter, 'NodeWrapperReferenceAdapter', VOID, VOID, [PasteHandler]);
  initMetadataForClass(SimpleEditorBuilder$addKeyPressedHandler$$inlined$keyPressedCellTrait$1, VOID, VOID, CellTrait);
  initMetadataForClass(SimpleEditorBuilder$invalidating$1, VOID, VOID, InvalidatingEditorBuilder, [InvalidatingEditorBuilder, InternalEditorBuilder], [1]);
  initMetadataForLambda(SimpleEditorBuilder$buildAsync$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(SimpleEditorBuilder, 'SimpleEditorBuilder', VOID, VOID, [InternalEditorBuilder]);
  initMetadataForClass(BaseNodeCloneSupport$copyListNoPreservation$nodeCopier$1, VOID, VOID, NodeCopier);
  initMetadataForClass(BaseNodeCloneSupport, 'BaseNodeCloneSupport', VOID, VOID, [ClonerSupport]);
  initMetadataForCoroutine($runSuspendCOROUTINE$_36, CoroutineImpl);
  initMetadataForClass(referenceTarget$2$$inlined$mapSuspending$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(referenceTarget$4$$inlined$propertyFromCellTrait$1, VOID, VOID, CellTrait);
  initMetadataForClass(referenceTarget$8$focusKeeper$1);
  initMetadataForClass(getReferenceRoleEditor$2$2$2$$inlined$propertyTrait$1, VOID, VOID, CellTrait);
  initMetadataForClass(getReferenceRoleEditor$2$4$1, VOID, VOID, VOID, [CellListener]);
  initMetadataForClass(getReferenceRoleEditor$2$4$textProp$1, VOID, VOID, DerivedProperty);
  initMetadataForClass(getCollectionPlaceholderCompletionSupplier$role$1);
  initMetadataForObject(ReferenceCells, 'ReferenceCells');
  initMetadataForCoroutine($runSuspendCOROUTINE$_37, CoroutineImpl);
  initMetadataForClass(ReferenceTrait$get$2$$inlined$executeSuspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForLambda(ReferenceTrait$get$slambda, CoroutineImpl, VOID, [0]);
  initMetadataForClass(ReferenceTrait, 'ReferenceTrait', VOID, CellTrait);
  initMetadataForLambda(constantReferenceTrait$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(referenceTrait$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(focusGuarded$1, VOID, VOID, VOID, [WritableProperty]);
  initMetadataForClass(RefCompletionArgs, 'RefCompletionArgs');
  initMetadataForCompanion(Companion_251);
  initMetadataForClass(ReferenceData_0, 'ReferenceData');
  initMetadataForClass(sam$jetbrains_ocelot_base_disposable_Disposable$0_5, 'sam$jetbrains_ocelot_base_disposable_Disposable$0', VOID, VOID, [Disposable, FunctionAdapter]);
  initMetadataForClass(connectWithRefSupport$2$1, VOID, VOID, CellTrait);
  initMetadataForLambda(ReferenceSynchronizers$forReferenceTarget$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForObject(ReferenceSynchronizers, 'ReferenceSynchronizers');
  initMetadataForClass(ResolveKind, 'ResolveKind', VOID, Enum);
  initMetadataForClass(referenceOutOfScopeSynchronizer$outOfScopeMessage$1, VOID, VOID, VOID, [WritableProperty]);
  initMetadataForClass(referenceOutOfScopeSynchronizer$$inlined$forDisposable$1, VOID, VOID, DisposableSynchronizer);
  initMetadataForClass(highlightReferenceTargetOutOfSync$visual$1, VOID, VOID, VOID, [WritableProperty]);
  initMetadataForClass(FindUsagesViewConfig, 'FindUsagesViewConfig');
  initMetadataForClass(FindUsagesViewConfigImpl, 'FindUsagesViewConfigImpl', VOID, FindUsagesViewConfig);
  initMetadataForClass(FindUsagesViewBuilderImpl, 'FindUsagesViewBuilderImpl', FindUsagesViewBuilderImpl);
  function severe$default(msg, thrown, $super) {
    thrown = thrown === VOID ? null : thrown;
    var tmp;
    if ($super === VOID) {
      this.sde(msg, thrown);
      tmp = Unit_instance;
    } else {
      tmp = $super.sde.call(this, msg, thrown);
    }
    return tmp;
  }
  function warning$default(msg, thrown, $super) {
    thrown = thrown === VOID ? null : thrown;
    var tmp;
    if ($super === VOID) {
      this.ude(msg, thrown);
      tmp = Unit_instance;
    } else {
      tmp = $super.ude.call(this, msg, thrown);
    }
    return tmp;
  }
  initMetadataForInterface(Logger, 'Logger');
  initMetadataForObject(JSLogger, 'JSLogger', VOID, VOID, [Logger]);
  initMetadataForCompanion(Companion_252);
  initMetadataForClass(DomainModel, 'DomainModel', VOID, VOID, [Disposable]);
  initMetadataForCoroutine($awaitAtLeastNBytesAvailableForWriteCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($awaitAtLeastNBytesAvailableForReadCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($writeFullyCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($writeFullyCOROUTINE$_0, CoroutineImpl);
  initMetadataForCoroutine($readRemainingCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($readRemainingSuspendCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($readAvailableCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($readAvailableCOROUTINE$_0, CoroutineImpl);
  initMetadataForCoroutine($awaitInternalAtLeast1COROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($awaitSuspendCOROUTINE$, CoroutineImpl);
  function readRemaining$default(limit, $completion, $super) {
    limit = limit === VOID ? 9223372036854775807n : limit;
    return $super === VOID ? this.gdm(limit, $completion) : $super.gdm.call(this, limit, $completion);
  }
  initMetadataForInterface(ByteReadChannel_1, 'ByteReadChannel', VOID, VOID, VOID, [3, 1, 2, 0, 5]);
  initMetadataForClass(ByteChannelSequentialBase, 'ByteChannelSequentialBase', VOID, VOID, [ByteReadChannel_1], [1, 3, 0, 2, 5]);
  initMetadataForClass(ClosedWriteChannelException, 'ClosedWriteChannelException', VOID, CancellationException);
  initMetadataForClass(CloseElement, 'CloseElement');
  initMetadataForInterface(WriterScope, 'WriterScope', VOID, VOID, [CoroutineScope]);
  initMetadataForClass(ChannelJob, 'ChannelJob', VOID, VOID, [Job], [0]);
  initMetadataForClass(ChannelScope, 'ChannelScope', VOID, VOID, [CoroutineScope, WriterScope]);
  initMetadataForLambda(launchChannel$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCompanion(Companion_253);
  initMetadataForClass(Buffer, 'Buffer');
  initMetadataForClass(InsufficientSpaceException, 'InsufficientSpaceException', InsufficientSpaceException, Exception);
  initMetadataForInterface(Closeable, 'Closeable');
  function close() {
    this.zr();
  }
  initMetadataForInterface(ObjectPool, 'ObjectPool', VOID, VOID, [Closeable]);
  initMetadataForClass(DefaultPool, 'DefaultPool', VOID, VOID, [ObjectPool]);
  initMetadataForClass(DefaultBufferPool, 'DefaultBufferPool', DefaultBufferPool, DefaultPool);
  initMetadataForClass(Output, 'Output', VOID, VOID, [Closeable]);
  initMetadataForClass(BytePacketBuilder, 'BytePacketBuilder', BytePacketBuilder, Output);
  initMetadataForCompanion(Companion_254);
  initMetadataForClass(Input, 'Input', VOID, VOID, [Closeable]);
  initMetadataForClass(ByteReadPacket, 'ByteReadPacket', VOID, Input);
  initMetadataForCompanion(Companion_255);
  initMetadataForClass(ChunkBuffer$Companion$EmptyPool$1, VOID, VOID, VOID, [ObjectPool]);
  initMetadataForClass(NoPoolImpl, 'NoPoolImpl', VOID, VOID, [ObjectPool]);
  initMetadataForClass(ChunkBuffer$Companion$NoPool$1, VOID, VOID, NoPoolImpl);
  initMetadataForClass(ChunkBuffer$Companion$NoPoolManuallyManaged$1, VOID, VOID, NoPoolImpl);
  initMetadataForCompanion(Companion_256);
  initMetadataForClass(ChunkBuffer, 'ChunkBuffer', VOID, Buffer);
  initMetadataForClass(MalformedUTF8InputException, 'MalformedUTF8InputException', VOID, Exception);
  initMetadataForCoroutine($sleepCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($trySuspendCOROUTINE$, CoroutineImpl);
  initMetadataForClass(AwaitingSlot, 'AwaitingSlot', AwaitingSlot, VOID, VOID, [1]);
  initMetadataForCoroutine($copyToSequentialImplCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($copyToTailCOROUTINE$, CoroutineImpl);
  initMetadataForClass(ByteArrayPool$1, VOID, VOID, DefaultPool);
  initMetadataForClass(ByteChannelJS, 'ByteChannelJS', VOID, ByteChannelSequentialBase, VOID, [3, 1, 0, 2, 5]);
  initMetadataForCompanion(Companion_257);
  initMetadataForObject(DefaultAllocator, 'DefaultAllocator');
  initMetadataForCompanion(Companion_258);
  initMetadataForClass(Memory, 'Memory');
  initMetadataForClass(MalformedInputException, 'MalformedInputException', VOID, Error);
  initMetadataForCompanion(Companion_259);
  initMetadataForClass(Charset, 'Charset');
  initMetadataForObject(Charsets, 'Charsets');
  initMetadataForClass(CharsetDecoder, 'CharsetDecoder');
  initMetadataForClass(CharsetEncoder, 'CharsetEncoder');
  initMetadataForClass(CharsetImpl, 'CharsetImpl', VOID, Charset);
  initMetadataForClass(CharsetEncoderImpl, 'CharsetEncoderImpl', VOID, CharsetEncoder);
  initMetadataForClass(CharsetDecoderImpl, 'CharsetDecoderImpl', VOID, CharsetDecoder);
  initMetadataForClass(DecodeBufferResult, 'DecodeBufferResult');
  initMetadataForClass(IOException, 'IOException', VOID, Exception);
  initMetadataForClass(EOFException, 'EOFException', VOID, IOException);
  initMetadataForClass(toKtor$1);
  initMetadataForClass(TextDecoderFallback, 'TextDecoderFallback');
  function get_1(key) {
    var tmp0_elvis_lhs = this.mdu(key);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalStateException_init_$Create$_0('No instance for key ' + key.toString());
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  initMetadataForInterface(Attributes, 'Attributes');
  initMetadataForClass(AttributeKey, 'AttributeKey');
  initMetadataForCoroutine($toByteArrayCOROUTINE$, CoroutineImpl);
  initMetadataForClass(CaseInsensitiveMap, 'CaseInsensitiveMap', CaseInsensitiveMap, VOID, [KtMutableMap]);
  initMetadataForClass(Entry_2, 'Entry', VOID, VOID, [MutableEntry]);
  initMetadataForClass(SilentSupervisor$$inlined$CoroutineExceptionHandler$1, VOID, VOID, AbstractCoroutineContextElement, [AbstractCoroutineContextElement, Element_0]);
  initMetadataForClass(DelegatingMutableSet$iterator$1);
  initMetadataForClass(DelegatingMutableSet, 'DelegatingMutableSet', VOID, VOID, [KtMutableSet]);
  initMetadataForObject(PlatformUtils, 'PlatformUtils');
  initMetadataForClass(Platform_0, 'Platform', VOID, Enum);
  function get_2(name) {
    var tmp0_safe_receiver = this.kdw(name);
    return tmp0_safe_receiver == null ? null : firstOrNull_1(tmp0_safe_receiver);
  }
  function forEach(body) {
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = this.hdw().m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      // Inline function 'kotlin.collections.component1' call
      var k = element.z();
      // Inline function 'kotlin.collections.component2' call
      var v = element.a1();
      body(k, v);
    }
    return Unit_instance;
  }
  initMetadataForInterface(StringValues, 'StringValues');
  initMetadataForClass(StringValuesBuilderImpl, 'StringValuesBuilderImpl', StringValuesBuilderImpl);
  initMetadataForClass(StringValuesImpl, 'StringValuesImpl', StringValuesImpl, VOID, [StringValues]);
  initMetadataForClass(CaseInsensitiveString, 'CaseInsensitiveString');
  initMetadataForClass(ChannelIOException, 'ChannelIOException', VOID, IOException);
  initMetadataForClass(CopyOnWriteHashMap, 'CopyOnWriteHashMap', CopyOnWriteHashMap);
  initMetadataForCompanion(Companion_260);
  initMetadataForClass(GMTDate, 'GMTDate', VOID, VOID, [Comparable]);
  initMetadataForCompanion(Companion_261);
  initMetadataForClass(WeekDay, 'WeekDay', VOID, Enum);
  initMetadataForCompanion(Companion_262);
  initMetadataForClass(Month, 'Month', VOID, Enum);
  initMetadataForClass(LockFreeLinkedListNode, 'LockFreeLinkedListNode');
  initMetadataForClass(Symbol_1, 'Symbol');
  initMetadataForClass(Removed, 'Removed');
  initMetadataForClass(OpDescriptor_0, 'OpDescriptor');
  initMetadataForCoroutine($proceedLoopCOROUTINE$, CoroutineImpl);
  initMetadataForClass(PipelineContext, 'PipelineContext', VOID, VOID, [CoroutineScope], [1, 0]);
  initMetadataForClass(DebugPipelineContext, 'DebugPipelineContext', VOID, PipelineContext, VOID, [1, 0]);
  initMetadataForCompanion(Companion_263);
  initMetadataForClass(PhaseContent, 'PhaseContent');
  initMetadataForClass(Pipeline, 'Pipeline', VOID, VOID, VOID, [2]);
  initMetadataForClass(PipelinePhase, 'PipelinePhase');
  initMetadataForClass(InvalidPhaseException, 'InvalidPhaseException', VOID, Error);
  initMetadataForClass(PipelinePhaseRelation, 'PipelinePhaseRelation');
  initMetadataForClass(After, 'After', VOID, PipelinePhaseRelation);
  initMetadataForClass(Before, 'Before', VOID, PipelinePhaseRelation);
  initMetadataForObject(Last, 'Last', VOID, PipelinePhaseRelation);
  initMetadataForClass(SuspendFunctionGun$continuation$1, VOID, VOID, VOID, [Continuation]);
  initMetadataForClass(SuspendFunctionGun, 'SuspendFunctionGun', VOID, PipelineContext, VOID, [0, 1]);
  initMetadataForClass(TypeInfo, 'TypeInfo');
  initMetadataForClass(AttributesJs, 'AttributesJs', AttributesJs, VOID, [Attributes]);
  initMetadataForClass(InvalidTimestampException, 'InvalidTimestampException', VOID, IllegalStateException);
  initMetadataForClass(KtorSimpleLogger$1);
  initMetadataForClass(LogLevel, 'LogLevel', VOID, Enum);
  initMetadataForObject(JsType, 'JsType');
  initMetadataForCompanion(Companion_264);
  initMetadataForClass(Codes, 'Codes', VOID, Enum);
  initMetadataForClass(CloseReason, 'CloseReason');
  function send(frame, $completion) {
    return this.ue0().z15(frame, $completion);
  }
  initMetadataForInterface(WebSocketSession, 'WebSocketSession', VOID, VOID, [CoroutineScope], [1, 0]);
  initMetadataForInterface(DefaultWebSocketSession, 'DefaultWebSocketSession', VOID, VOID, [WebSocketSession], [1, 0]);
  initMetadataForCompanion(Companion_265);
  initMetadataForLambda(DefaultWebSocketSessionImpl$runIncomingProcessor$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(DefaultWebSocketSessionImpl$runOutgoingProcessor$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(DefaultWebSocketSessionImpl$runOrCancelPinger$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($outgoingProcessorLoopCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($sendCloseSequenceCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($checkMaxFrameSizeCOROUTINE$, CoroutineImpl);
  initMetadataForClass(DefaultWebSocketSessionImpl, 'DefaultWebSocketSessionImpl', VOID, VOID, [DefaultWebSocketSession, WebSocketSession], [1, 0, 2]);
  initMetadataForObject(NonDisposableHandle_0, 'NonDisposableHandle', VOID, VOID, [DisposableHandle]);
  initMetadataForClass(FrameTooBigException, 'FrameTooBigException', VOID, Exception);
  initMetadataForCompanion(Companion_266);
  initMetadataForClass(FrameType, 'FrameType', VOID, Enum);
  initMetadataForLambda(ponger$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(pinger$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(pinger$slambda$slambda_1, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(pinger$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(WebSocketExtensionsConfig, 'WebSocketExtensionsConfig', WebSocketExtensionsConfig);
  initMetadataForClass(WebSocketExtensionHeader, 'WebSocketExtensionHeader');
  initMetadataForCoroutine($closeCOROUTINE$, CoroutineImpl);
  initMetadataForClass(Frame, 'Frame');
  initMetadataForClass(Binary, 'Binary', VOID, Frame);
  initMetadataForClass(Text, 'Text', VOID, Frame);
  initMetadataForClass(Close, 'Close', Close_init_$Create$_0, Frame);
  initMetadataForClass(Ping, 'Ping', VOID, Frame);
  initMetadataForClass(Pong, 'Pong', VOID, Frame);
  initMetadataForCompanion(Companion_267);
  initMetadataForClass(ProtoBuf, 'ProtoBuf', VOID, VOID, [BinaryFormat]);
  initMetadataForObject(Default_2, 'Default', VOID, ProtoBuf);
  initMetadataForClass(ProtoBufBuilder, 'ProtoBufBuilder');
  initMetadataForClass(ProtoBufImpl, 'ProtoBufImpl', VOID, ProtoBuf);
  initMetadataForClass(ProtoIntegerType, 'ProtoIntegerType', VOID, Enum);
  initMetadataForClass(ProtoNumber, 'ProtoNumber');
  initMetadataForClass(ProtoType, 'ProtoType');
  initMetadataForClass(ProtoPacked, 'ProtoPacked');
  initMetadataForClass(ProtobufDecodingException, 'ProtobufDecodingException', VOID, SerializationException);
  initMetadataForClass(ProtobufTaggedBase, 'ProtobufTaggedBase');
  initMetadataForClass(ProtobufTaggedDecoder, 'ProtobufTaggedDecoder', VOID, ProtobufTaggedBase, [ProtobufTaggedBase, Decoder, CompositeDecoder]);
  initMetadataForClass(ProtobufDecoder, 'ProtobufDecoder', VOID, ProtobufTaggedDecoder);
  initMetadataForClass(PackedArrayDecoder, 'PackedArrayDecoder', VOID, ProtobufDecoder);
  initMetadataForClass(ProtobufTaggedEncoder, 'ProtobufTaggedEncoder', VOID, ProtobufTaggedBase, [ProtobufTaggedBase, Encoder, CompositeEncoder]);
  initMetadataForClass(ProtobufEncoder, 'ProtobufEncoder', VOID, ProtobufTaggedEncoder);
  initMetadataForClass(NestedRepeatedEncoder, 'NestedRepeatedEncoder', VOID, ProtobufEncoder);
  initMetadataForClass(PackedArrayEncoder, 'PackedArrayEncoder', VOID, NestedRepeatedEncoder);
  initMetadataForClass(RepeatedDecoder, 'RepeatedDecoder', VOID, ProtobufDecoder);
  initMetadataForClass(MapEntryReader, 'MapEntryReader', VOID, ProtobufDecoder);
  initMetadataForClass(RepeatedEncoder, 'RepeatedEncoder', VOID, ProtobufEncoder);
  initMetadataForClass(ObjectEncoder, 'ObjectEncoder', VOID, ProtobufEncoder);
  initMetadataForClass(MapRepeatedEncoder, 'MapRepeatedEncoder', VOID, ObjectEncoder);
  initMetadataForClass(ProtobufReader, 'ProtobufReader');
  initMetadataForClass(NullableMode, 'NullableMode', VOID, Enum);
  initMetadataForClass(ProtobufWriter, 'ProtobufWriter');
  initMetadataForCompanion(Companion_268);
  initMetadataForClass(ByteArrayOutput, 'ByteArrayOutput', ByteArrayOutput);
  initMetadataForClass(ByteArrayInput, 'ByteArrayInput');
  initMetadataForCompanion(Companion_269);
  initMetadataForObject($serializer_6, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(MethodId, 'MethodId', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_6});
  initMetadataForCompanion(Companion_270, VOID, [SerializerFactory]);
  initMetadataForClass(InstanceId, 'InstanceId', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_270});
  initMetadataForCompanion(Companion_271);
  initMetadataForObject($serializer_7, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(PublishedInstanceId, 'PublishedInstanceId', VOID, InstanceId, VOID, VOID, VOID, {0: $serializer_getInstance_7});
  initMetadataForCompanion(Companion_272);
  initMetadataForObject($serializer_8, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(RemoteInstanceId, 'RemoteInstanceId', VOID, InstanceId, VOID, VOID, VOID, {0: $serializer_getInstance_8});
  initMetadataForInterface(ImmediateMethodHandle, 'ImmediateMethodHandle');
  initMetadataForClass(InstanceDescriptor, 'InstanceDescriptor');
  initMetadataForInterface(InstancePublication, 'InstancePublication', VOID, VOID, [Disposable]);
  initMetadataForClass(LocalInstancePublication, 'LocalInstancePublication', VOID, VOID, [InstancePublication, Disposable]);
  initMetadataForClass(RemoteInstancePublication, 'RemoteInstancePublication', VOID, VOID, [InstancePublication]);
  initMetadataForClass(InstancePublicationSerializer, 'InstancePublicationSerializer', VOID, VOID, [KSerializer]);
  initMetadataForCompanion(Companion_273);
  initMetadataForObject($serializer_9, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(InstancePublicationTransfer, 'InstancePublicationTransfer', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_9});
  initMetadataForObject(OppositeInstanceIdSerializer, 'OppositeInstanceIdSerializer', VOID, VOID, [KSerializer]);
  initMetadataForClass(MethodDescriptorImpl, 'MethodDescriptorImpl', VOID, VOID, VOID, [2]);
  initMetadataForClass(RemoteInvocationException, 'RemoteInvocationException', VOID, RuntimeException);
  initMetadataForClass(RpcEndpointMethod, 'RpcEndpointMethod', VOID, VOID, [Job], [0]);
  initMetadataForClass(CallRemote, 'CallRemote', VOID, RpcEndpointMethod, VOID, [0]);
  initMetadataForClass(DisposeRemote, 'DisposeRemote', VOID, RpcEndpointMethod, VOID, [0]);
  function publishInstance$default(instance, instanceDescriptor, instanceDisposal, $completion, $super) {
    instanceDisposal = instanceDisposal === VOID ? Companion_getInstance_29().m2l_1 : instanceDisposal;
    return $super === VOID ? this.yeg(instance, instanceDescriptor, instanceDisposal, $completion) : $super.yeg.call(this, instance, instanceDescriptor, instanceDisposal, $completion);
  }
  initMetadataForInterface(RpcFacade, 'RpcFacade', VOID, VOID, VOID, [3]);
  initMetadataForClass(RpcFacadeCancellationException, 'RpcFacadeCancellationException', RpcFacadeCancellationException, CancellationException);
  initMetadataForCoroutine($callRemoteCOROUTINE$, CoroutineImpl);
  initMetadataForClass(RpcEndpointImpl, 'RpcEndpointImpl', VOID, VOID, [Disposable], [4]);
  initMetadataForClass(sam$jetbrains_ocelot_base_disposable_Disposable$0_6, 'sam$jetbrains_ocelot_base_disposable_Disposable$0', VOID, VOID, [Disposable, FunctionAdapter]);
  initMetadataForClass(sam$jetbrains_ocelot_base_disposable_Disposable$0_7, 'sam$jetbrains_ocelot_base_disposable_Disposable$0', VOID, VOID, [Disposable, FunctionAdapter]);
  initMetadataForClass(RpcFacadeImpl, 'RpcFacadeImpl', VOID, VOID, [RpcFacade], [3]);
  initMetadataForClass(BinaryFormatsImpl, 'BinaryFormatsImpl');
  initMetadataForLambda(rpcFacade$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(rpcIncomingMessagesProcessor$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(rpcOutgoingCallsProcessor$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForObject(RpcFacadeStub, 'RpcFacadeStub', VOID, VOID, [SerializerFactory], VOID, VOID, {0: RpcFacadeStub_getInstance});
  initMetadataForClass(RpcFacadeIntrinsicSerializer, 'RpcFacadeIntrinsicSerializer', VOID, VOID, [KSerializer]);
  initMetadataForCompanion(Companion_274, VOID, [SerializerFactory]);
  initMetadataForClass($serializer_10, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(RpcFacadeMixin, 'RpcFacadeMixin', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_274});
  initMetadataForClass(mixinFacade$1, VOID, VOID, VOID, VOID, [2]);
  initMetadataForLambda(RpcIncomingCalls$launchCall$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($processCallCOROUTINE$, CoroutineImpl);
  initMetadataForClass(RpcIncomingCalls, 'RpcIncomingCalls', VOID, VOID, VOID, [4]);
  initMetadataForClass(RpcInstancesPublisher, 'RpcInstancesPublisher', VOID, VOID, [Disposable]);
  initMetadataForLambda(PublicationEntry$asHandle$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(PublicationEntry, 'PublicationEntry');
  initMetadataForClass(MissingInstanceException, 'MissingInstanceException', VOID, RuntimeException);
  initMetadataForClass(PublishedMethodHandle, 'PublishedMethodHandle', VOID, VOID, VOID, [1]);
  initMetadataForClass(MissingMethodException, 'MissingMethodException', VOID, RuntimeException);
  initMetadataForCompanion(Companion_275);
  initMetadataForObject($serializer_11, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForCompanion(Companion_276);
  initMetadataForObject($serializer_12, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForCompanion(Companion_277);
  initMetadataForObject($serializer_13, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForCompanion(Companion_278);
  initMetadataForObject($serializer_14, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(RpcMessage, 'RpcMessage', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_279});
  initMetadataForClass(Call, 'Call', VOID, RpcMessage, VOID, VOID, VOID, {0: $serializer_getInstance_10});
  initMetadataForClass(Dispose, 'Dispose', VOID, RpcMessage, VOID, VOID, VOID, {0: $serializer_getInstance_11});
  initMetadataForClass(Answer, 'Answer', VOID, RpcMessage, VOID, VOID, VOID, {0: $serializer_getInstance_12});
  initMetadataForClass(ErrorAnswer, 'ErrorAnswer', VOID, RpcMessage, VOID, VOID, VOID, {0: $serializer_getInstance_13});
  initMetadataForCompanion(Companion_279, VOID, [SerializerFactory]);
  initMetadataForCoroutine($startCallCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($completeCallCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($failCallCOROUTINE$, CoroutineImpl);
  initMetadataForClass(RpcOutgoingCalls, 'RpcOutgoingCalls', VOID, VOID, VOID, [1, 2]);
  initMetadataForClass(RpcOutgoingCallsMessage, 'RpcOutgoingCallsMessage');
  initMetadataForClass(InitiateCall, 'InitiateCall', VOID, RpcOutgoingCallsMessage);
  initMetadataForClass(CompleteCall, 'CompleteCall', VOID, RpcOutgoingCallsMessage);
  initMetadataForClass(FailCall, 'FailCall', VOID, RpcOutgoingCallsMessage);
  initMetadataForClass(MissingOutgoingCallException, 'MissingOutgoingCallException', VOID, RuntimeException);
  initMetadataForLambda(rpcOutgoingCalls$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForInterface(Runnable_0, 'Runnable', VOID, VOID, VOID, [0]);
  initMetadataForObject(RunnableSerializer, 'RunnableSerializer', VOID, InstancePublicationSerializer);
  initMetadataForLambda(RemoteRunnable$Descriptor$run$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForObject(Descriptor_0, 'Descriptor', VOID, InstanceDescriptor);
  initMetadataForClass(RemoteRunnable, 'RemoteRunnable', VOID, VOID, [Runnable_0], [0]);
  initMetadataForCompanion(Companion_280, VOID, [Key_5]);
  initMetadataForClass(RpcFacadeContainer, 'RpcFacadeContainer', RpcFacadeContainer);
  initMetadataForLambda(flowBasedMethod$slambda$slambda$o$collect$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($collectCOROUTINE$_17, CoroutineImpl);
  initMetadataForClass(flowBasedMethod$2$2$$inlined$map$1, VOID, VOID, VOID, [Flow], [1]);
  initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0_12, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
  initMetadataForLambda(flowBasedMethod$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(flowBasedMethod$2$$inlined$toDisposable$1, VOID, VOID, VOID, [Disposable]);
  initMetadataForLambda(flowBasedMethod$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(flowBasedMethod$o$call$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(flowBasedMethod$o$call$slambda_1, CoroutineImpl, VOID, [2]);
  initMetadataForCoroutine($callCOROUTINE$, CoroutineImpl);
  initMetadataForClass(flowBasedMethod$1, VOID, VOID, VOID, VOID, [2]);
  initMetadataForClass(StopHandle, 'StopHandle', StopHandle, VOID, [Runnable_0], [0]);
  initMetadataForClass(sam$jetbrains_ocelot_langDef_rpc_ImmediateMethodHandle$0, 'sam$jetbrains_ocelot_langDef_rpc_ImmediateMethodHandle$0', VOID, VOID, [ImmediateMethodHandle, FunctionAdapter]);
  initMetadataForLambda(flowMethod$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(flowMethod$slambda$o$collect$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($collectCOROUTINE$_18, CoroutineImpl);
  initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0_13, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
  initMetadataForLambda(flowMethod$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(flowMethod$2$$inlined$map$1, VOID, VOID, VOID, [Flow], [1]);
  initMetadataForLambda(flowMethod$slambda_1, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(flowMethod$lambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(flowMethod$lambda$o$collect$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($collectCOROUTINE$_19, CoroutineImpl);
  initMetadataForClass(flowMethod$2$$inlined$map$2, VOID, VOID, VOID, [Flow], [1]);
  initMetadataForClass(PublishedFlowCollectorSerializer, 'PublishedFlowCollectorSerializer', VOID, InstancePublicationSerializer);
  initMetadataForLambda(RemoteFlowCollector$Descriptor$emit$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForClass(Descriptor_1, 'Descriptor', VOID, InstanceDescriptor);
  initMetadataForClass(RemoteFlowCollector, 'RemoteFlowCollector', VOID, VOID, [FlowCollector], [1]);
  initMetadataForClass(FlowMessage, 'FlowMessage');
  initMetadataForClass(Element_2, 'Element', VOID, FlowMessage);
  initMetadataForClass(End, 'End', End, FlowMessage);
  initMetadataForClass(Error_1, 'Error', VOID, FlowMessage);
  initMetadataForCompanion(Companion_281, VOID, [SerializerFactory]);
  initMetadataForClass($serializer_15, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(FlowMessageData, 'FlowMessageData', FlowMessageData, VOID, VOID, VOID, VOID, {0: Companion_getInstance_281});
  initMetadataForObject(PublishedDisposableSerializer, 'PublishedDisposableSerializer', VOID, InstancePublicationSerializer);
  initMetadataForCompanion(Companion_282, InstanceDescriptor);
  initMetadataForClass(RemoteDisposable, 'RemoteDisposable', VOID, VOID, [Disposable]);
  initMetadataForClass(RpcClient, 'RpcClient', VOID, VOID, [CoroutineScope]);
  initMetadataForLambda(rpcClient$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(rpcClient$slambda_1, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(wsEntryPoints$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(wsEntryPoints$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(sessionJob$$inlined$CoroutineExceptionHandler$1, VOID, VOID, AbstractCoroutineContextElement, [AbstractCoroutineContextElement, Element_0]);
  initMetadataForInterface(RpcInitiationHandler, 'RpcInitiationHandler');
  initMetadataForClass(sam$jetbrains_ocelot_langDef_rpc_session_RpcInitiationHandler$0, 'sam$jetbrains_ocelot_langDef_rpc_session_RpcInitiationHandler$0', VOID, VOID, [RpcInitiationHandler, FunctionAdapter]);
  initMetadataForClass(sam$jetbrains_ocelot_langDef_rpc_session_RpcInitiationHandler$0_0, 'sam$jetbrains_ocelot_langDef_rpc_session_RpcInitiationHandler$0', VOID, VOID, [RpcInitiationHandler, FunctionAdapter]);
  initMetadataForClass(sam$jetbrains_ocelot_langDef_rpc_session_RpcInitiationHandler$0_1, 'sam$jetbrains_ocelot_langDef_rpc_session_RpcInitiationHandler$0', VOID, VOID, [RpcInitiationHandler, FunctionAdapter]);
  initMetadataForLambda(ClientRpcInitiationHandler$lambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(ServerRpcInitiationHandler$lambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(RpcSchema$connect$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(RpcSchema, 'RpcSchema', VOID, VOID, VOID, [2]);
  initMetadataForCompanion(Companion_283);
  initMetadataForClass(RpcSessionCounter, 'RpcSessionCounter', RpcSessionCounter, AbstractCoroutineContextElement);
  initMetadataForClass(WsRpcSession, 'WsRpcSession');
  initMetadataForLambda(rpcSession$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(rpcSession$slambda$slambda_1, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(rpcSession$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(WsSession, 'WsSession');
  initMetadataForLambda(WsSessionScope$bind$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(WsSessionScope$bind$slambda$slambda_1, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(WsSessionScope$bind$slambda$slambda_3, CoroutineImpl, VOID, [0]);
  initMetadataForLambda(WsSessionScope$bind$slambda$slambda_5, CoroutineImpl, VOID, [0]);
  initMetadataForLambda(WsSessionScope$bind$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(WsSessionScope, 'WsSessionScope', VOID, VOID, VOID, [3]);
  initMetadataForLambda(WsSessionProvider$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(WsSession$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCompanion(Companion_284);
  initMetadataForObject($serializer_16, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(NodeErrorInfo, 'NodeErrorInfo', NodeErrorInfo, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_14});
  initMetadataForCompanion(Companion_285);
  initMetadataForObject($serializer_17, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(SerializedError, 'SerializedError', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_15});
  initMetadataForClass(deserialize$1);
  initMetadataForCompanion(Companion_286);
  initMetadataForObject($serializer_18, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(SerializedNodeErrors, 'SerializedNodeErrors', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_16});
  initMetadataForCompanion(Companion_287);
  initMetadataForObject($serializer_19, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForCompanion(Companion_288);
  initMetadataForObject($serializer_20, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(NodeErrorInfoMessage, 'NodeErrorInfoMessage', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_289});
  initMetadataForClass(StateReceived, 'StateReceived', VOID, NodeErrorInfoMessage, VOID, VOID, VOID, {0: $serializer_getInstance_17});
  initMetadataForClass(UpdateReceived, 'UpdateReceived', VOID, NodeErrorInfoMessage, VOID, VOID, VOID, {0: $serializer_getInstance_18});
  initMetadataForCompanion(Companion_289, VOID, [SerializerFactory]);
  initMetadataForCompanion(Companion_290);
  initMetadataForObject($serializer_21, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(NodeErrorInfoUpdate, 'NodeErrorInfoUpdate', NodeErrorInfoUpdate, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_19});
  initMetadataForClass(NodeErrorProvider, 'NodeErrorProvider');
  initMetadataForCompanion(Companion_291);
  initMetadataForObject($serializer_22, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(NodeResolveInfo, 'NodeResolveInfo', NodeResolveInfo, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_20});
  initMetadataForObject($serializer_23, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(SerializedReference, 'SerializedReference', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_21});
  initMetadataForCompanion(Companion_292);
  initMetadataForObject($serializer_24, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(SerializedReferenceLocation, 'SerializedReferenceLocation', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_22});
  initMetadataForCompanion(Companion_293);
  initMetadataForObject($serializer_25, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(SerializedReferenceValue, 'SerializedReferenceValue', SerializedReferenceValue, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_23});
  initMetadataForCompanion(Companion_294);
  initMetadataForClass(NodeResolutionProvider, 'NodeResolutionProvider');
  initMetadataForCompanion(Companion_295);
  initMetadataForObject($serializer_26, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForCompanion(Companion_296);
  initMetadataForObject($serializer_27, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(NodeResolveInfoMessage, 'NodeResolveInfoMessage', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_297});
  initMetadataForClass(StateReceived_0, 'StateReceived', VOID, NodeResolveInfoMessage, VOID, VOID, VOID, {0: $serializer_getInstance_24});
  initMetadataForClass(UpdateReceived_0, 'UpdateReceived', VOID, NodeResolveInfoMessage, VOID, VOID, VOID, {0: $serializer_getInstance_25});
  initMetadataForCompanion(Companion_297, VOID, [SerializerFactory]);
  initMetadataForCompanion(Companion_298);
  initMetadataForObject($serializer_28, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(NodeResolveInfoUpdate, 'NodeResolveInfoUpdate', NodeResolveInfoUpdate, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_26});
  initMetadataForCompanion(Companion_299);
  initMetadataForObject($serializer_29, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(Remote, 'Remote');
  initMetadataForCompanion(Companion_300, InstanceDescriptor);
  initMetadataForObject(Empty_3, 'Empty');
  initMetadataForClass(ElementsParameters, 'ElementsParameters', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_27});
  initMetadataForObject(Serializer_0, 'Serializer', VOID, InstancePublicationSerializer);
  initMetadataForCompanion(Companion_301);
  initMetadataForObject($serializer_30, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(ReferenceTargetsBatch, 'ReferenceTargetsBatch', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_28});
  initMetadataForCompanion(Companion_302);
  initMetadataForObject($serializer_31, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(ReferenceTarget, 'ReferenceTarget', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_29});
  initMetadataForCompanion(Companion_303);
  initMetadataForObject($serializer_32, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(SerializedResolvedNode, 'SerializedResolvedNode', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_30});
  initMetadataForCompanion(Companion_304);
  initMetadataForObject($serializer_33, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForCompanion(Companion_305);
  initMetadataForObject($serializer_34, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(DerivedDataMessage, 'DerivedDataMessage', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_306});
  initMetadataForClass(Resolution, 'Resolution', VOID, DerivedDataMessage, VOID, VOID, VOID, {0: $serializer_getInstance_31});
  initMetadataForClass(Error_2, 'Error', VOID, DerivedDataMessage, VOID, VOID, VOID, {0: $serializer_getInstance_32});
  initMetadataForCompanion(Companion_306, VOID, [SerializerFactory]);
  initMetadataForLambda(derivedDataMethod$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForCoroutine($callCOROUTINE$_0, CoroutineImpl);
  initMetadataForClass(derivedDataMethod$1, VOID, VOID, VOID, VOID, [2]);
  initMetadataForClass(DerivedDataProvider, 'DerivedDataProvider');
  initMetadataForClass(RemoteErrorCheckConfig$checking$1$check$$inlined$query$1, VOID, VOID, VOID, [Query], [1]);
  initMetadataForClass(sam$jetbrains_ocelot_base_observable_event_EventSource$0_0, 'sam$jetbrains_ocelot_base_observable_event_EventSource$0', VOID, VOID, [EventSource, FunctionAdapter]);
  initMetadataForClass(RemoteErrorCheckConfig$checking$1);
  initMetadataForClass(RemoteErrorCheckConfig, 'RemoteErrorCheckConfig', VOID, VOID, [ErrorCheckConfig]);
  initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0_14, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
  initMetadataForLambda(remoteErrorCheck$lambda$slambda$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(remoteErrorCheck$lambda$slambda$slambda_1, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(remoteErrorCheck$lambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(LiveResolutionClient, 'LiveResolutionClient');
  initMetadataForClass(sam$jetbrains_ocelot_base_observable_event_EventSource$0_1, 'sam$jetbrains_ocelot_base_observable_event_EventSource$0', VOID, VOID, [EventSource, FunctionAdapter]);
  initMetadataForClass(LiveResolutionClientState$findTarget$$inlined$query$1, VOID, VOID, VOID, [Query], [1]);
  initMetadataForClass(LiveResolutionClientState$findLocalTarget$$inlined$query$1, VOID, VOID, VOID, [Query], [1]);
  initMetadataForClass(LiveResolutionClientState, 'LiveResolutionClientState');
  initMetadataForLambda(LiveResolutionClient$slambda$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0_15, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
  initMetadataForLambda(LiveResolutionClient$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(LiveResolutionClient$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(LiveResolutionClient$slambda_1, CoroutineImpl, VOID, [1]);
  initMetadataForClass(createReferenceActivatorNodeListener$1);
  initMetadataForClass(LiveResolutionClientMessage, 'LiveResolutionClientMessage');
  initMetadataForClass(MessageReceived, 'MessageReceived', VOID, LiveResolutionClientMessage);
  initMetadataForClass(ReferenceActivated, 'ReferenceActivated', VOID, LiveResolutionClientMessage);
  initMetadataForClass(sam$jetbrains_ocelot_langDef_references_ReferenceFactory$0_2, 'sam$jetbrains_ocelot_langDef_references_ReferenceFactory$0', VOID, VOID, [ReferenceFactory, FunctionAdapter]);
  initMetadataForCoroutine($runSuspendCOROUTINE$_38, CoroutineImpl);
  initMetadataForCoroutine($runSuspendCOROUTINE$_39, CoroutineImpl);
  initMetadataForCompanion(Companion_307);
  initMetadataForClass(LiveResolutionReference$resolve$$inlined$flatMap$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(LiveResolutionReference$find$$inlined$flatMap$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(LiveResolutionReference, 'LiveResolutionReference', VOID, PropertyBasedReference, VOID, [1]);
  initMetadataForCompanion(Companion_308);
  initMetadataForClass(LiveResolutionReferenceValue, 'LiveResolutionReferenceValue');
  initMetadataForLambda(RemoteReferenceTargetsSupplier$getElements$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0_16, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
  initMetadataForLambda(RemoteReferenceTargetsSupplier$getElements$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(RemoteReferenceTargetsSupplier, 'RemoteReferenceTargetsSupplier', VOID, VOID, [ReferenceTargetsSupplier]);
  initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0_17, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
  initMetadataForLambda(remote$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(remote$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCompanion(Companion_309, VOID, [Key_5]);
  initMetadataForClass(PrecalculatedResolutionService, 'PrecalculatedResolutionService');
  initMetadataForCompanion(Companion_310, VOID, [Key_5]);
  initMetadataForClass(LiveDerivedDataService, 'LiveDerivedDataService');
  initMetadataForLambda(LiveDerivedDataService$slambda$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(LiveDerivedDataService$slambda$slambda$slambda_1, CoroutineImpl, VOID, [1]);
  initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0_18, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
  initMetadataForLambda(LiveDerivedDataService$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(LiveDerivedDataService$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(NodeDerivedDataProvider, 'NodeDerivedDataProvider');
  initMetadataForClass(BioKbOtStructureRuntime, 'BioKbOtStructureRuntime', BioKbOtStructureRuntime);
  initMetadataForObject(BtbMetaModel, 'BtbMetaModel');
  initMetadataForObject(GeneratedBioKbStuff, 'GeneratedBioKbStuff');
  initMetadataForObject(AbstractBindingDeclarationConcept, 'AbstractBindingDeclarationConcept', VOID, OTAbstractConceptDescriptor);
  initMetadataForObject(AbstractBindingEntryConcept, 'AbstractBindingEntryConcept', VOID, OTAbstractConceptDescriptor);
  initMetadataForObject(AbstractBindingValueConcept, 'AbstractBindingValueConcept', VOID, OTAbstractConceptDescriptor);
  initMetadataForObject(AbstractBindingValueQueryConcept, 'AbstractBindingValueQueryConcept', VOID, OTAbstractConceptDescriptor);
  initMetadataForObject(AbstractLinkConcept, 'AbstractLinkConcept', VOID, OTAbstractConceptDescriptor);
  initMetadataForObject(AbstractNotionConcept, 'AbstractNotionConcept', VOID, OTAbstractConceptDescriptor);
  initMetadataForObject(AbstractOntologyRelationConcept, 'AbstractOntologyRelationConcept', VOID, OTAbstractConceptDescriptor);
  initMetadataForObject(AbstractProcessSpecificationConcept, 'AbstractProcessSpecificationConcept', VOID, OTAbstractConceptDescriptor);
  initMetadataForObject(AbstractPropertyConcept, 'AbstractPropertyConcept', VOID, OTAbstractConceptDescriptor);
  initMetadataForObject(AbstractValueConcept, 'AbstractValueConcept', VOID, OTAbstractConceptDescriptor);
  initMetadataForObject(AllowedComplexNotionTypeConcept, 'AllowedComplexNotionTypeConcept', VOID, OTAbstractConceptDescriptor);
  initMetadataForObject(AllowedComplexNotionValueConcept, 'AllowedComplexNotionValueConcept', VOID, OTAbstractConceptDescriptor);
  initMetadataForObject(AnonymousClassConcept, 'AnonymousClassConcept', VOID, OTAbstractConceptDescriptor);
  initMetadataForObject(AuthorConcept, 'AuthorConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(AuthoredWorkConcept, 'AuthoredWorkConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(BTBDocumentConcept, 'BTBDocumentConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(BTBNodeConcept, 'BTBNodeConcept', VOID, OTAbstractConceptDescriptor);
  initMetadataForObject(BindingPropertyConcept, 'BindingPropertyConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(BindingValueMaskConcept, 'BindingValueMaskConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(BindingValuePlaceholderConcept, 'BindingValuePlaceholderConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(BindingValuePlaceholderQueryConcept, 'BindingValuePlaceholderQueryConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(BookConcept, 'BookConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(CardinalityBoundConcept, 'CardinalityBoundConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(CardinalityBoundConstantConcept, 'CardinalityBoundConstantConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(CardinalityBoundNConcept, 'CardinalityBoundNConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(CardinalityBoundPlaceholderConcept, 'CardinalityBoundPlaceholderConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(CardinalityConcept, 'CardinalityConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(CardinalityCustomCellConcept, 'CardinalityCustomCellConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(CategoryConcept, 'CategoryConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(ClassDeclarationConcept, 'ClassDeclarationConcept', VOID, OTAbstractConceptDescriptor);
  initMetadataForObject(ClassExpressionConcept, 'ClassExpressionConcept', VOID, OTAbstractConceptDescriptor);
  initMetadataForObject(ClassExpressionPlaceholderConcept, 'ClassExpressionPlaceholderConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(ClassExpressionTypeConcept, 'ClassExpressionTypeConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(CommandConcept, 'CommandConcept', VOID, OTAbstractConceptDescriptor);
  initMetadataForObject(ComplexNotionConcept, 'ComplexNotionConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(ComplexNotionElementConcept, 'ComplexNotionElementConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(ComplexNotionElementValueConcept, 'ComplexNotionElementValueConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(ComplexNotionTemplateConcept, 'ComplexNotionTemplateConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(ComplexNotionTemplateElementConcept, 'ComplexNotionTemplateElementConcept', VOID, OTAbstractConceptDescriptor);
  initMetadataForObject(ComplexNotionTemplatePlaceholderConcept, 'ComplexNotionTemplatePlaceholderConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(ComplexNotionTemplateRefElementConcept, 'ComplexNotionTemplateRefElementConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(ComplexNotionTemplateTextElementConcept, 'ComplexNotionTemplateTextElementConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(ComplexNotionValueConcept, 'ComplexNotionValueConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(ConstantCustomCellConcept, 'ConstantCustomCellConcept', VOID, OtConceptDescriptor);
  initMetadataForClass(ConstantPreconditionConcept$KIND_PERSISTER$$inlined$enumPersister$1, VOID, VOID, VOID, [NonNullPersister]);
  initMetadataForClass(ConstantPreconditionConcept$kindPropertyDescriptor$$inlined$enumPersister$1, VOID, VOID, VOID, [NonNullPersister]);
  initMetadataForObject(ConstantPreconditionConcept, 'ConstantPreconditionConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(ContextConcept, 'ContextConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(ContextQueryConcept, 'ContextQueryConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(CustomCellConcept, 'CustomCellConcept', VOID, OTAbstractConceptDescriptor);
  initMetadataForObject(CustomEditorConcept, 'CustomEditorConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(DeclarationNameCustomCellConcept, 'DeclarationNameCustomCellConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(DeclarationValueQueryConcept, 'DeclarationValueQueryConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(DocumentNodeConcept, 'DocumentNodeConcept', VOID, OTAbstractConceptDescriptor);
  initMetadataForObject(EmptyBindingEntryConcept, 'EmptyBindingEntryConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(EmptyPropertyLibraryElementConcept, 'EmptyPropertyLibraryElementConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(EnumValueConcept, 'EnumValueConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(EnumerableNotionConcept, 'EnumerableNotionConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(EnumerationConstantConcept, 'EnumerationConstantConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(ExtensionDeclarationConcept, 'ExtensionDeclarationConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(ExtensionFieldReferenceConcept, 'ExtensionFieldReferenceConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(ExtensionLibraryConcept, 'ExtensionLibraryConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(ExternallyNamedConcept, 'ExternallyNamedConcept', VOID, OTAbstractConceptDescriptor);
  initMetadataForObject(FactConcept, 'FactConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(FactExpressionConcept, 'FactExpressionConcept', VOID, OTAbstractConceptDescriptor);
  initMetadataForObject(FactExpressionPlaceholderConcept, 'FactExpressionPlaceholderConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(FactPreconditionConcept, 'FactPreconditionConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(FactReferenceConcept, 'FactReferenceConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(FactSetConcept, 'FactSetConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(FieldDeclarationConcept, 'FieldDeclarationConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(FindConnectionCommandConcept, 'FindConnectionCommandConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(FindNewConnectionCommandConcept, 'FindNewConnectionCommandConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(FunctionDeclarationConcept, 'FunctionDeclarationConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(FunctionLibraryConcept, 'FunctionLibraryConcept', VOID, OtConceptDescriptor);
  initMetadataForClass(FunctionTermConcept$SPECIFICATOR_PERSISTER$$inlined$enumPersister$1, VOID, VOID, VOID, [NonNullPersister]);
  initMetadataForClass(FunctionTermConcept$specificatorPropertyDescriptor$$inlined$enumPersister$1, VOID, VOID, VOID, [NonNullPersister]);
  initMetadataForObject(FunctionTermConcept, 'FunctionTermConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(HasCommentsConcept, 'HasCommentsConcept', VOID, OTAbstractConceptDescriptor);
  initMetadataForObject(HasFactExpressionConcept, 'HasFactExpressionConcept', VOID, OTAbstractConceptDescriptor);
  initMetadataForObject(HasKnowledgeSourcesConcept, 'HasKnowledgeSourcesConcept', VOID, OTAbstractConceptDescriptor);
  initMetadataForObject(HasPropertyConstraintsConcept, 'HasPropertyConstraintsConcept', VOID, OTAbstractConceptDescriptor);
  initMetadataForObject(HasQueryLabelsConcept, 'HasQueryLabelsConcept', VOID, OTAbstractConceptDescriptor);
  initMetadataForObject(HasVariablesConcept, 'HasVariablesConcept', VOID, OTAbstractConceptDescriptor);
  initMetadataForObject(ImportedLinkConcept, 'ImportedLinkConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(ImportedPropertyConcept, 'ImportedPropertyConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(InheritedProcessPropertyConcept, 'InheritedProcessPropertyConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(InstanceRelationDeclarationConcept, 'InstanceRelationDeclarationConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(InstanceRelationValueConcept, 'InstanceRelationValueConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(InstanceRelationValuePlaceholderConcept, 'InstanceRelationValuePlaceholderConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(IntegerValueConcept, 'IntegerValueConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(IsExpressionConcept, 'IsExpressionConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(KindCustomCellConcept, 'KindCustomCellConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(KnowledgeSourceReferenceConcept, 'KnowledgeSourceReferenceConcept', VOID, OTAbstractConceptDescriptor);
  initMetadataForObject(KnowledgeSourceReferencePlaceholderConcept, 'KnowledgeSourceReferencePlaceholderConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(LibraryItemConcept, 'LibraryItemConcept', VOID, OTAbstractConceptDescriptor);
  initMetadataForObject(LibraryItemPlaceholderConcept, 'LibraryItemPlaceholderConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(LibraryProcessSpecificationConcept, 'LibraryProcessSpecificationConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(LibraryProcessSpecificationQueryConcept, 'LibraryProcessSpecificationQueryConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(LinkCustomCellConcept, 'LinkCustomCellConcept', VOID, OtConceptDescriptor);
  initMetadataForClass(LinkDeclarationConcept$SPECIFICATOR_PERSISTER$$inlined$enumPersister$1, VOID, VOID, VOID, [NonNullPersister]);
  initMetadataForClass(LinkDeclarationConcept$specificatorPropertyDescriptor$$inlined$enumPersister$1, VOID, VOID, VOID, [NonNullPersister]);
  initMetadataForObject(LinkDeclarationConcept, 'LinkDeclarationConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(LinkLibraryConcept, 'LinkLibraryConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(LocalOntologyElementReferenceConcept, 'LocalOntologyElementReferenceConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(MeasurableNotionConcept, 'MeasurableNotionConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(MeasurableValueConcept, 'MeasurableValueConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(MeasurementUnitConcept, 'MeasurementUnitConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(ModifierContainerConcept, 'ModifierContainerConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(ModifierDeclarationConcept, 'ModifierDeclarationConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(ModifierFactExpressionConcept, 'ModifierFactExpressionConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(MultilineTextConcept, 'MultilineTextConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(MultipleProcessPropertyValueRangeConcept, 'MultipleProcessPropertyValueRangeConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(MultiplePropertyValueRangeConcept, 'MultiplePropertyValueRangeConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(MultipliedExpressionConcept, 'MultipliedExpressionConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(NewFactConcept, 'NewFactConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(NewFactReferenceConcept, 'NewFactReferenceConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(NoValuesConcept, 'NoValuesConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(NotionLibraryConcept, 'NotionLibraryConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(NotionPlaceholderConcept, 'NotionPlaceholderConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(NotionTypeConcept, 'NotionTypeConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(ObjectPropertiesLibraryConcept, 'ObjectPropertiesLibraryConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(ObjectPropertyDeclarationConcept, 'ObjectPropertyDeclarationConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(ObjectPropertyReferenceValueConcept, 'ObjectPropertyReferenceValueConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(OldPublishedSourceConcept, 'OldPublishedSourceConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(OneOfConcept, 'OneOfConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(OntologyCardinalityRelationConcept, 'OntologyCardinalityRelationConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(OntologyElementConcept, 'OntologyElementConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(OntologyElementDefinitionConcept, 'OntologyElementDefinitionConcept', VOID, OtConceptDescriptor);
  initMetadataForClass(OntologyElementPropertyTypeConcept$SPECIFICATOR_PERSISTER$$inlined$enumPersister$1, VOID, VOID, VOID, [NonNullPersister]);
  initMetadataForClass(OntologyElementPropertyTypeConcept$specificatorPropertyDescriptor$$inlined$enumPersister$1, VOID, VOID, VOID, [NonNullPersister]);
  initMetadataForObject(OntologyElementPropertyTypeConcept, 'OntologyElementPropertyTypeConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(OntologyElementReferenceConcept, 'OntologyElementReferenceConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(OntologyElementReferenceProviderConcept, 'OntologyElementReferenceProviderConcept', VOID, OTAbstractConceptDescriptor);
  initMetadataForObject(OntologyElementReferenceValueConcept, 'OntologyElementReferenceValueConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(OntologyElementReferenceValueLibraryConcept, 'OntologyElementReferenceValueLibraryConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(OntologyElementSynonymConcept, 'OntologyElementSynonymConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(OntologyElementTypeConcept, 'OntologyElementTypeConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(OntologyImportConcept, 'OntologyImportConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(OntologyImportRootConcept, 'OntologyImportRootConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(OntologyImportRootReferenceConcept, 'OntologyImportRootReferenceConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(OntologyIsRelationConcept, 'OntologyIsRelationConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(OntologyLibraryConcept, 'OntologyLibraryConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(OntologyLibraryReferenceConcept, 'OntologyLibraryReferenceConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(OntologyLinkConcept, 'OntologyLinkConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(OntologyLinkDeclarationValueQueryConcept, 'OntologyLinkDeclarationValueQueryConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(OntologyLinkValueConcept, 'OntologyLinkValueConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(OrValueQueryConcept, 'OrValueQueryConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(PageConcept, 'PageConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(PageRangeConcept, 'PageRangeConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(PageSpecificationConcept, 'PageSpecificationConcept', VOID, OTAbstractConceptDescriptor);
  initMetadataForObject(PaperConcept, 'PaperConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(PartReferenceOperationConcept, 'PartReferenceOperationConcept', VOID, OTAbstractConceptDescriptor);
  initMetadataForObject(PartValueConcept, 'PartValueConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(PatternConcept, 'PatternConcept', VOID, OTAbstractConceptDescriptor);
  initMetadataForObject(PreconditionConcept, 'PreconditionConcept', VOID, OtConceptDescriptor);
  initMetadataForClass(PrimitiveNotionTypeConcept$PRIMITIVE_KIND_PERSISTER$$inlined$enumPersister$1, VOID, VOID, VOID, [NonNullPersister]);
  initMetadataForClass(PrimitiveNotionTypeConcept$primitiveKindPropertyDescriptor$$inlined$enumPersister$1, VOID, VOID, VOID, [NonNullPersister]);
  initMetadataForObject(PrimitiveNotionTypeConcept, 'PrimitiveNotionTypeConcept', VOID, OtConceptDescriptor);
  initMetadataForClass(PrimitivePropertyTypeConcept$PRIMITIVE_KIND_PERSISTER$$inlined$enumPersister$1, VOID, VOID, VOID, [NonNullPersister]);
  initMetadataForClass(PrimitivePropertyTypeConcept$primitiveKindPropertyDescriptor$$inlined$enumPersister$1, VOID, VOID, VOID, [NonNullPersister]);
  initMetadataForObject(PrimitivePropertyTypeConcept, 'PrimitivePropertyTypeConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(ProcessDeclarationConcept, 'ProcessDeclarationConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(ProcessEffectConcept, 'ProcessEffectConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(ProcessKindConcept, 'ProcessKindConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(ProcessKindContainerConcept, 'ProcessKindContainerConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(ProcessLibraryConcept, 'ProcessLibraryConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(ProcessPrerequisiteConcept, 'ProcessPrerequisiteConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(ProcessPropertyConcept, 'ProcessPropertyConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(ProcessPropertyCustomCellConcept, 'ProcessPropertyCustomCellConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(ProcessPropertyDefaultConcept, 'ProcessPropertyDefaultConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(ProcessPropertyReferenceConcept, 'ProcessPropertyReferenceConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(ProcessPropertyTypeConcept, 'ProcessPropertyTypeConcept', VOID, OTAbstractConceptDescriptor);
  initMetadataForObject(ProcessPropertyValueConcept, 'ProcessPropertyValueConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(ProcessPropertyValueRangeConcept, 'ProcessPropertyValueRangeConcept', VOID, OTAbstractConceptDescriptor);
  initMetadataForObject(ProcessProviderConcept, 'ProcessProviderConcept', VOID, OTAbstractConceptDescriptor);
  initMetadataForObject(ProcessReferenceConcept, 'ProcessReferenceConcept', VOID, OtConceptDescriptor);
  initMetadataForClass(ProcessRelationDeclarationConcept$DIRECTION_PERSISTER$$inlined$enumPersister$1, VOID, VOID, VOID, [NonNullPersister]);
  initMetadataForClass(ProcessRelationDeclarationConcept$EFFECT_PERSISTER$$inlined$enumPersister$1, VOID, VOID, VOID, [NonNullPersister]);
  initMetadataForClass(ProcessRelationDeclarationConcept$directionPropertyDescriptor$$inlined$enumPersister$1, VOID, VOID, VOID, [NonNullPersister]);
  initMetadataForClass(ProcessRelationDeclarationConcept$effectPropertyDescriptor$$inlined$enumPersister$1, VOID, VOID, VOID, [NonNullPersister]);
  initMetadataForObject(ProcessRelationDeclarationConcept, 'ProcessRelationDeclarationConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(ProcessTypeConcept, 'ProcessTypeConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(PropertiesCustomCellConcept, 'PropertiesCustomCellConcept', VOID, OtConceptDescriptor);
  initMetadataForClass(PropertyConstraintConcept$OPERATION_PERSISTER$$inlined$enumPersister$1, VOID, VOID, VOID, [NonNullPersister]);
  initMetadataForClass(PropertyConstraintConcept$operationPropertyDescriptor$$inlined$enumPersister$1, VOID, VOID, VOID, [NonNullPersister]);
  initMetadataForObject(PropertyConstraintConcept, 'PropertyConstraintConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(PropertyCustomCellConcept, 'PropertyCustomCellConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(PropertyDeclarationConcept, 'PropertyDeclarationConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(PropertyDeclarationValueQueryConcept, 'PropertyDeclarationValueQueryConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(PropertyLibraryConcept, 'PropertyLibraryConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(PropertyLibraryElementConcept, 'PropertyLibraryElementConcept', VOID, OTAbstractConceptDescriptor);
  initMetadataForObject(PropertyReferenceOperationConcept, 'PropertyReferenceOperationConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(PropertyValueConcept, 'PropertyValueConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(PropertyValueRangeConcept, 'PropertyValueRangeConcept', VOID, OTAbstractConceptDescriptor);
  initMetadataForObject(PubMedSourceReferenceConcept, 'PubMedSourceReferenceConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(PublishedSourceReferenceConcept, 'PublishedSourceReferenceConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(PublishedSourcesLibraryConcept, 'PublishedSourcesLibraryConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(PublishedWorkConcept, 'PublishedWorkConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(QualifiedOntologyElementReferenceConcept, 'QualifiedOntologyElementReferenceConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(QueryCommandsConcept, 'QueryCommandsConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(QueryLabelsFactExpressionContainerConcept, 'QueryLabelsFactExpressionContainerConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(QueryParametersBlackListConcept, 'QueryParametersBlackListConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(RelationContainerConcept, 'RelationContainerConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(RelationFactExpressionConcept, 'RelationFactExpressionConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(ReturnTypeCustomCellConcept, 'ReturnTypeCustomCellConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(SetExpressionConcept, 'SetExpressionConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(SetValuedPropertyParameterConcept, 'SetValuedPropertyParameterConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(SimplePropertyTypeConcept, 'SimplePropertyTypeConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(SinglePropertyValueRangeConcept, 'SinglePropertyValueRangeConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(StringValueConcept, 'StringValueConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(TextLineConcept, 'TextLineConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(TypeConcept, 'TypeConcept', VOID, OTAbstractConceptDescriptor);
  initMetadataForObject(TypePlaceholderConcept, 'TypePlaceholderConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(UnionClassConcept, 'UnionClassConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(UnknownComplexNotionValueConcept, 'UnknownComplexNotionValueConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(UrlConcept, 'UrlConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(UrlKnowledgeSourceReferenceConcept, 'UrlKnowledgeSourceReferenceConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(ValueWithRelationsConcept, 'ValueWithRelationsConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(VariableDeclarationConcept, 'VariableDeclarationConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(VariableInitializerConcept, 'VariableInitializerConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(VariablePatternConcept, 'VariablePatternConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(VariableReferenceValueConcept, 'VariableReferenceValueConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(VariableSpecificationConcept, 'VariableSpecificationConcept', VOID, OTAbstractConceptDescriptor);
  initMetadataForObject(XRefContainerConcept, 'XRefContainerConcept', VOID, OtConceptDescriptor);
  initMetadataForInterface(BTBNode, 'BTBNode', VOID, VOID, [DomainNode]);
  initMetadataForClass(BTBNodeImpl, 'BTBNodeImpl', VOID, BaseNodeGen, [BaseNodeGen, BTBNode]);
  initMetadataForInterface(HasComments, 'HasComments', VOID, VOID, [DomainNode]);
  initMetadataForInterface(AbstractBindingDeclaration, 'AbstractBindingDeclaration', VOID, VOID, [BTBNode, DirectlyNamed, HasComments]);
  initMetadataForClass(AbstractBindingDeclarationImpl, 'AbstractBindingDeclarationImpl', VOID, BTBNodeImpl, [BTBNodeImpl, AbstractBindingDeclaration]);
  initMetadataForInterface(AbstractBindingEntry, 'AbstractBindingEntry', VOID, VOID, [BTBNode, Named]);
  initMetadataForClass(AbstractBindingEntryImpl, 'AbstractBindingEntryImpl', VOID, BTBNodeImpl, [BTBNodeImpl, AbstractBindingEntry]);
  initMetadataForInterface(BindingValuePlaceholder_1, 'BindingValuePlaceholder', VOID, VOID, [BTBNode]);
  initMetadataForClass(BindingValuePlaceholderImpl, 'BindingValuePlaceholderImpl', VOID, BTBNodeImpl, [BTBNodeImpl, BindingValuePlaceholder_1]);
  initMetadataForInterface(AbstractBindingValue, 'AbstractBindingValue', VOID, VOID, [BindingValuePlaceholder_1]);
  initMetadataForClass(AbstractBindingValueImpl, 'AbstractBindingValueImpl', VOID, BindingValuePlaceholderImpl, [BindingValuePlaceholderImpl, AbstractBindingValue]);
  initMetadataForInterface(BindingValuePlaceholderQuery_1, 'BindingValuePlaceholderQuery', VOID, VOID, [BTBNode]);
  initMetadataForClass(BindingValuePlaceholderQueryImpl, 'BindingValuePlaceholderQueryImpl', VOID, BTBNodeImpl, [BTBNodeImpl, BindingValuePlaceholderQuery_1]);
  initMetadataForInterface(AbstractBindingValueQuery, 'AbstractBindingValueQuery', VOID, VOID, [BindingValuePlaceholderQuery_1]);
  initMetadataForClass(AbstractBindingValueQueryImpl, 'AbstractBindingValueQueryImpl', VOID, BindingValuePlaceholderQueryImpl, [BindingValuePlaceholderQueryImpl, AbstractBindingValueQuery]);
  function get_defaultLibraryReference() {
    return constant(null);
  }
  initMetadataForInterface(AbstractLink, 'AbstractLink', VOID, VOID, [AbstractBindingEntry]);
  initMetadataForClass(AbstractLinkImpl, 'AbstractLinkImpl', VOID, AbstractBindingEntryImpl, [AbstractBindingEntryImpl, AbstractLink]);
  initMetadataForInterface(AbstractNotion, 'AbstractNotion', VOID, VOID, [BTBNode, DirectlyNamed]);
  initMetadataForClass(AbstractNotionImpl, 'AbstractNotionImpl', VOID, BTBNodeImpl, [BTBNodeImpl, AbstractNotion]);
  initMetadataForInterface(AbstractOntologyRelation, 'AbstractOntologyRelation', VOID, VOID, [BTBNode]);
  initMetadataForClass(AbstractOntologyRelationImpl, 'AbstractOntologyRelationImpl', VOID, BTBNodeImpl, [BTBNodeImpl, AbstractOntologyRelation]);
  initMetadataForInterface(AbstractProcessSpecification, 'AbstractProcessSpecification', VOID, VOID, [BTBNode]);
  initMetadataForClass(AbstractProcessSpecificationImpl, 'AbstractProcessSpecificationImpl', VOID, BTBNodeImpl, [BTBNodeImpl, AbstractProcessSpecification]);
  initMetadataForInterface(AbstractProperty, 'AbstractProperty', VOID, VOID, [AbstractBindingEntry]);
  initMetadataForClass(AbstractPropertyImpl, 'AbstractPropertyImpl', VOID, AbstractBindingEntryImpl, [AbstractBindingEntryImpl, AbstractProperty]);
  initMetadataForInterface(Author_1, 'Author', VOID, VOID, [DirectlyNamed, BTBNode]);
  initMetadataForClass(AuthorImpl, 'AuthorImpl', VOID, BTBNodeImpl, [BTBNodeImpl, Author_1]);
  initMetadataForInterface(AuthoredWork, 'AuthoredWork', VOID, VOID, [BTBNode]);
  initMetadataForClass(AuthoredWorkImpl, 'AuthoredWorkImpl', VOID, BTBNodeImpl, [BTBNodeImpl, AuthoredWork]);
  initMetadataForInterface(ExternallyNamed, 'ExternallyNamed', VOID, VOID, [DirectlyNamed]);
  initMetadataForInterface(DocumentNode_0, 'DocumentNode', VOID, VOID, [BTBNode, DocumentNode, ExternallyNamed]);
  initMetadataForClass(DocumentNodeImpl, 'DocumentNodeImpl', VOID, BTBNodeImpl, [BTBNodeImpl, DocumentNode_0]);
  function librariesForElement(element) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new BTBDocument$librariesForElement$$inlined$suspendingQuery$1(this, element);
  }
  initMetadataForInterface(BTBDocument_1, 'BTBDocument', VOID, VOID, [DocumentNode_0]);
  initMetadataForClass(BTBDocumentImpl, 'BTBDocumentImpl', VOID, DocumentNodeImpl, [DocumentNodeImpl, BTBDocument_1]);
  function get_name() {
    // Inline function 'jetbrains.ocelot.langDef.query.query' call
    return new BindingProperty$name$$inlined$query$1(this);
  }
  function get_type() {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new BindingProperty$type$$inlined$suspendingQuery$1(this);
  }
  initMetadataForInterface(BindingProperty_1, 'BindingProperty', VOID, VOID, [AbstractProperty]);
  initMetadataForClass(BindingPropertyImpl, 'BindingPropertyImpl', VOID, AbstractPropertyImpl, [AbstractPropertyImpl, BindingProperty_1]);
  initMetadataForInterface(BindingValueMask_1, 'BindingValueMask', VOID, VOID, [AbstractBindingValueQuery]);
  initMetadataForClass(BindingValueMaskImpl, 'BindingValueMaskImpl', VOID, AbstractBindingValueQueryImpl, [AbstractBindingValueQueryImpl, BindingValueMask_1]);
  function get_name_0() {
    return this.wfp();
  }
  function citation() {
    // Inline function 'jetbrains.ocelot.langDef.query.query' call
    return new PublishedWork$citation$$inlined$query$1(this);
  }
  initMetadataForInterface(PublishedWork, 'PublishedWork', VOID, VOID, [AuthoredWork, DirectlyNamed]);
  initMetadataForClass(PublishedWorkImpl, 'PublishedWorkImpl', VOID, AuthoredWorkImpl, [AuthoredWorkImpl, PublishedWork]);
  initMetadataForInterface(LibraryItem, 'LibraryItem', VOID, VOID, [BTBNode]);
  initMetadataForInterface(Book_1, 'Book', VOID, VOID, [PublishedWork, LibraryItem]);
  initMetadataForClass(BookImpl, 'BookImpl', VOID, PublishedWorkImpl, [PublishedWorkImpl, Book_1]);
  initMetadataForInterface(CardinalityBound, 'CardinalityBound', VOID, VOID, [BTBNode]);
  initMetadataForClass(CardinalityBoundImpl, 'CardinalityBoundImpl', VOID, BTBNodeImpl, [BTBNodeImpl, CardinalityBound]);
  initMetadataForInterface(CardinalityBoundConstant_1, 'CardinalityBoundConstant', VOID, VOID, [CardinalityBound, BTBNode]);
  initMetadataForClass(CardinalityBoundConstantImpl, 'CardinalityBoundConstantImpl', VOID, CardinalityBoundImpl, [CardinalityBoundImpl, CardinalityBoundConstant_1]);
  initMetadataForInterface(CardinalityBoundN_1, 'CardinalityBoundN', VOID, VOID, [CardinalityBound]);
  initMetadataForClass(CardinalityBoundNImpl, 'CardinalityBoundNImpl', VOID, CardinalityBoundImpl, [CardinalityBoundImpl, CardinalityBoundN_1]);
  initMetadataForInterface(CardinalityBoundPlaceholder_1, 'CardinalityBoundPlaceholder', VOID, VOID, [BTBNode]);
  initMetadataForClass(CardinalityBoundPlaceholderImpl, 'CardinalityBoundPlaceholderImpl', VOID, BTBNodeImpl, [BTBNodeImpl, CardinalityBoundPlaceholder_1]);
  initMetadataForInterface(CustomCell, 'CustomCell', VOID, VOID, [BTBNode]);
  initMetadataForClass(CustomCellImpl, 'CustomCellImpl', VOID, BTBNodeImpl, [BTBNodeImpl, CustomCell]);
  initMetadataForInterface(CardinalityCustomCell_1, 'CardinalityCustomCell', VOID, VOID, [CustomCell]);
  initMetadataForClass(CardinalityCustomCellImpl, 'CardinalityCustomCellImpl', VOID, CustomCellImpl, [CustomCellImpl, CardinalityCustomCell_1]);
  initMetadataForInterface(Cardinality_1, 'Cardinality', VOID, VOID, [BTBNode]);
  initMetadataForClass(CardinalityImpl, 'CardinalityImpl', VOID, BTBNodeImpl, [BTBNodeImpl, Cardinality_1]);
  initMetadataForInterface(Category_1, 'Category', VOID, VOID, [BTBNode]);
  initMetadataForClass(CategoryImpl, 'CategoryImpl', VOID, BTBNodeImpl, [BTBNodeImpl, Category_1]);
  initMetadataForInterface(ClassExpressionPlaceholder_1, 'ClassExpressionPlaceholder', VOID, VOID, [BTBNode]);
  initMetadataForClass(ClassExpressionPlaceholderImpl, 'ClassExpressionPlaceholderImpl', VOID, BTBNodeImpl, [BTBNodeImpl, ClassExpressionPlaceholder_1]);
  initMetadataForInterface(VariableSpecification, 'VariableSpecification', VOID, VOID, [BTBNode]);
  initMetadataForClass(VariableSpecificationImpl, 'VariableSpecificationImpl', VOID, BTBNodeImpl, [BTBNodeImpl, VariableSpecification]);
  initMetadataForInterface(Type, 'Type', VOID, VOID, [VariableSpecification]);
  initMetadataForClass(TypeImpl, 'TypeImpl', VOID, VariableSpecificationImpl, [VariableSpecificationImpl, Type]);
  initMetadataForInterface(ProcessPropertyValueRange, 'ProcessPropertyValueRange', VOID, VOID, [BTBNode]);
  function get_type_0() {
    // Inline function 'jetbrains.ocelot.langDef.query.query' call
    return new ProcessPropertyType$type$$inlined$query$1(this);
  }
  initMetadataForInterface(ProcessPropertyType, 'ProcessPropertyType', VOID, VOID, [ProcessPropertyValueRange]);
  initMetadataForInterface(ClassExpressionType_1, 'ClassExpressionType', VOID, VOID, [Type, ProcessPropertyType]);
  initMetadataForClass(ClassExpressionTypeImpl, 'ClassExpressionTypeImpl', VOID, TypeImpl, [TypeImpl, ClassExpressionType_1]);
  initMetadataForInterface(Command_0, 'Command', VOID, VOID, [BTBNode]);
  initMetadataForClass(CommandImpl, 'CommandImpl', VOID, BTBNodeImpl, [BTBNodeImpl, Command_0]);
  initMetadataForInterface(ComplexNotionElement_1, 'ComplexNotionElement', VOID, VOID, [BTBNode, DirectlyNamed]);
  initMetadataForClass(ComplexNotionElementImpl, 'ComplexNotionElementImpl', VOID, BTBNodeImpl, [BTBNodeImpl, ComplexNotionElement_1]);
  initMetadataForInterface(ComplexNotionElementValue_1, 'ComplexNotionElementValue', VOID, VOID, [BTBNode]);
  initMetadataForClass(ComplexNotionElementValueImpl, 'ComplexNotionElementValueImpl', VOID, BTBNodeImpl, [BTBNodeImpl, ComplexNotionElementValue_1]);
  initMetadataForInterface(ComplexNotion_1, 'ComplexNotion', VOID, VOID, [AbstractNotion]);
  initMetadataForClass(ComplexNotionImpl, 'ComplexNotionImpl', VOID, AbstractNotionImpl, [AbstractNotionImpl, ComplexNotion_1]);
  initMetadataForInterface(ComplexNotionTemplateElement, 'ComplexNotionTemplateElement', VOID, VOID, [BTBNode]);
  initMetadataForClass(ComplexNotionTemplateElementImpl, 'ComplexNotionTemplateElementImpl', VOID, BTBNodeImpl, [BTBNodeImpl, ComplexNotionTemplateElement]);
  initMetadataForInterface(ComplexNotionTemplate_1, 'ComplexNotionTemplate', VOID, VOID, [BTBNode]);
  initMetadataForClass(ComplexNotionTemplateImpl, 'ComplexNotionTemplateImpl', VOID, BTBNodeImpl, [BTBNodeImpl, ComplexNotionTemplate_1]);
  initMetadataForInterface(ComplexNotionTemplatePlaceholder_1, 'ComplexNotionTemplatePlaceholder', VOID, VOID, [ComplexNotionTemplateElement]);
  initMetadataForClass(ComplexNotionTemplatePlaceholderImpl, 'ComplexNotionTemplatePlaceholderImpl', VOID, ComplexNotionTemplateElementImpl, [ComplexNotionTemplateElementImpl, ComplexNotionTemplatePlaceholder_1]);
  initMetadataForInterface(ComplexNotionTemplateRefElement_1, 'ComplexNotionTemplateRefElement', VOID, VOID, [ComplexNotionTemplateElement]);
  initMetadataForClass(ComplexNotionTemplateRefElementImpl, 'ComplexNotionTemplateRefElementImpl', VOID, ComplexNotionTemplateElementImpl, [ComplexNotionTemplateElementImpl, ComplexNotionTemplateRefElement_1]);
  initMetadataForInterface(ComplexNotionTemplateTextElement_1, 'ComplexNotionTemplateTextElement', VOID, VOID, [ComplexNotionTemplateElement]);
  initMetadataForClass(ComplexNotionTemplateTextElementImpl, 'ComplexNotionTemplateTextElementImpl', VOID, ComplexNotionTemplateElementImpl, [ComplexNotionTemplateElementImpl, ComplexNotionTemplateTextElement_1]);
  function transformToPropertyReferenceValue(wrapperContext) {
    // Inline function 'kotlin.also' call
    var this_0 = propertyReferenceValue(this, wrapperContext);
    this.d6j(this_0);
    return this_0;
  }
  initMetadataForInterface(AbstractValue, 'AbstractValue', VOID, VOID, [BTBNode]);
  initMetadataForInterface(FactExpressionPlaceholder, 'FactExpressionPlaceholder', VOID, VOID, [BTBNode]);
  initMetadataForInterface(FactExpression, 'FactExpression', VOID, VOID, [FactExpressionPlaceholder]);
  initMetadataForInterface(ComplexNotionValue_1, 'ComplexNotionValue', VOID, VOID, [AbstractValue, FactExpression]);
  initMetadataForClass(ComplexNotionValueImpl, 'ComplexNotionValueImpl', VOID, BTBNodeImpl, [BTBNodeImpl, ComplexNotionValue_1]);
  initMetadataForInterface(ConstantCustomCell_1, 'ConstantCustomCell', VOID, VOID, [CustomCell]);
  initMetadataForClass(ConstantCustomCellImpl, 'ConstantCustomCellImpl', VOID, CustomCellImpl, [CustomCellImpl, ConstantCustomCell_1]);
  initMetadataForInterface(Precondition, 'Precondition', VOID, VOID, [BTBNode]);
  initMetadataForClass(PreconditionImpl, 'PreconditionImpl', VOID, BTBNodeImpl, [BTBNodeImpl, Precondition]);
  initMetadataForInterface(ConstantPrecondition_0, 'ConstantPrecondition', VOID, VOID, [Precondition]);
  initMetadataForClass(ConstantPreconditionImpl, 'ConstantPreconditionImpl', VOID, PreconditionImpl, [PreconditionImpl, ConstantPrecondition_0]);
  initMetadataForInterface(Context_2, 'Context', VOID, VOID, [BTBNode, DirectlyNamed]);
  initMetadataForClass(ContextImpl, 'ContextImpl', VOID, BTBNodeImpl, [BTBNodeImpl, Context_2]);
  initMetadataForInterface(ContextQuery_1, 'ContextQuery', VOID, VOID, [BTBNode]);
  initMetadataForClass(ContextQueryImpl, 'ContextQueryImpl', VOID, BTBNodeImpl, [BTBNodeImpl, ContextQuery_1]);
  initMetadataForInterface(CustomEditor, 'CustomEditor', VOID, VOID, [BTBNode]);
  initMetadataForClass(CustomEditorImpl, 'CustomEditorImpl', VOID, BTBNodeImpl, [BTBNodeImpl, CustomEditor]);
  initMetadataForInterface(DeclarationNameCustomCell_1, 'DeclarationNameCustomCell', VOID, VOID, [CustomCell]);
  initMetadataForClass(DeclarationNameCustomCellImpl, 'DeclarationNameCustomCellImpl', VOID, CustomCellImpl, [CustomCellImpl, DeclarationNameCustomCell_1]);
  initMetadataForInterface(DeclarationValueQuery, 'DeclarationValueQuery', VOID, VOID, [AbstractBindingValueQuery]);
  initMetadataForClass(DeclarationValueQueryImpl, 'DeclarationValueQueryImpl', VOID, AbstractBindingValueQueryImpl, [AbstractBindingValueQueryImpl, DeclarationValueQuery]);
  function get_name_1() {
    return constant('');
  }
  initMetadataForInterface(EmptyBindingEntry_1, 'EmptyBindingEntry', VOID, VOID, [AbstractBindingEntry]);
  initMetadataForClass(EmptyBindingEntryImpl, 'EmptyBindingEntryImpl', VOID, AbstractBindingEntryImpl, [AbstractBindingEntryImpl, EmptyBindingEntry_1]);
  initMetadataForInterface(PropertyLibraryElement, 'PropertyLibraryElement', VOID, VOID, [BTBNode]);
  initMetadataForInterface(EmptyPropertyLibraryElement_1, 'EmptyPropertyLibraryElement', VOID, VOID, [PropertyLibraryElement]);
  initMetadataForClass(EmptyPropertyLibraryElementImpl, 'EmptyPropertyLibraryElementImpl', VOID, BTBNodeImpl, [BTBNodeImpl, EmptyPropertyLibraryElement_1]);
  initMetadataForInterface(AllowedComplexNotionValue, 'AllowedComplexNotionValue', VOID, VOID, [BTBNode]);
  initMetadataForInterface(EnumValue_1, 'EnumValue', VOID, VOID, [AbstractValue, FactExpression, AllowedComplexNotionValue]);
  initMetadataForClass(EnumValueImpl, 'EnumValueImpl', VOID, BTBNodeImpl, [BTBNodeImpl, EnumValue_1]);
  initMetadataForInterface(EnumerableNotion_1, 'EnumerableNotion', VOID, VOID, [AbstractNotion]);
  initMetadataForClass(EnumerableNotionImpl, 'EnumerableNotionImpl', VOID, AbstractNotionImpl, [AbstractNotionImpl, EnumerableNotion_1]);
  initMetadataForInterface(EnumerationConstant_1, 'EnumerationConstant', VOID, VOID, [BTBNode, DirectlyNamed]);
  initMetadataForClass(EnumerationConstantImpl, 'EnumerationConstantImpl', VOID, BTBNodeImpl, [BTBNodeImpl, EnumerationConstant_1]);
  initMetadataForInterface(ExtensionDeclaration_1, 'ExtensionDeclaration', VOID, VOID, [BTBNode, DirectlyNamed]);
  initMetadataForClass(ExtensionDeclarationImpl, 'ExtensionDeclarationImpl', VOID, BTBNodeImpl, [BTBNodeImpl, ExtensionDeclaration_1]);
  initMetadataForInterface(PartReferenceOperation, 'PartReferenceOperation', VOID, VOID, [BTBNode]);
  initMetadataForClass(PartReferenceOperationImpl, 'PartReferenceOperationImpl', VOID, BTBNodeImpl, [BTBNodeImpl, PartReferenceOperation]);
  initMetadataForInterface(ExtensionFieldReference_1, 'ExtensionFieldReference', VOID, VOID, [PartReferenceOperation]);
  initMetadataForClass(ExtensionFieldReferenceImpl, 'ExtensionFieldReferenceImpl', VOID, PartReferenceOperationImpl, [PartReferenceOperationImpl, ExtensionFieldReference_1]);
  initMetadataForInterface(ExtensionLibrary_1, 'ExtensionLibrary', VOID, VOID, [DocumentNode_0]);
  initMetadataForClass(ExtensionLibraryImpl, 'ExtensionLibraryImpl', VOID, DocumentNodeImpl, [DocumentNodeImpl, ExtensionLibrary_1]);
  initMetadataForClass(FactExpressionPlaceholderImpl, 'FactExpressionPlaceholderImpl', VOID, BTBNodeImpl, [BTBNodeImpl, FactExpressionPlaceholder]);
  initMetadataForInterface(Fact_1, 'Fact', VOID, VOID, [BTBNode, DirectlyNamed]);
  initMetadataForClass(FactImpl, 'FactImpl', VOID, BTBNodeImpl, [BTBNodeImpl, Fact_1]);
  initMetadataForInterface(FactPrecondition_1, 'FactPrecondition', VOID, VOID, [Precondition]);
  initMetadataForClass(FactPreconditionImpl, 'FactPreconditionImpl', VOID, PreconditionImpl, [PreconditionImpl, FactPrecondition_1]);
  initMetadataForInterface(FactReference_1, 'FactReference', VOID, VOID, [BTBNode]);
  initMetadataForClass(FactReferenceImpl, 'FactReferenceImpl', VOID, BTBNodeImpl, [BTBNodeImpl, FactReference_1]);
  initMetadataForInterface(HasKnowledgeSources, 'HasKnowledgeSources', VOID, VOID, [BTBNode]);
  initMetadataForInterface(HasVariables, 'HasVariables', VOID, VOID, [BTBNode]);
  initMetadataForInterface(FactSet_1, 'FactSet', VOID, VOID, [BTBNode, DirectlyNamed, HasKnowledgeSources, HasComments, HasVariables]);
  initMetadataForClass(FactSetImpl, 'FactSetImpl', VOID, BTBNodeImpl, [BTBNodeImpl, FactSet_1]);
  initMetadataForInterface(FieldDeclaration_1, 'FieldDeclaration', VOID, VOID, [BTBNode, DirectlyNamed]);
  initMetadataForClass(FieldDeclarationImpl, 'FieldDeclarationImpl', VOID, BTBNodeImpl, [BTBNodeImpl, FieldDeclaration_1]);
  initMetadataForInterface(FindConnectionCommand_1, 'FindConnectionCommand', VOID, VOID, [Command_0]);
  initMetadataForClass(FindConnectionCommandImpl, 'FindConnectionCommandImpl', VOID, CommandImpl, [CommandImpl, FindConnectionCommand_1]);
  initMetadataForInterface(FindNewConnectionCommand_1, 'FindNewConnectionCommand', VOID, VOID, [Command_0, HasVariables]);
  initMetadataForClass(FindNewConnectionCommandImpl, 'FindNewConnectionCommandImpl', VOID, CommandImpl, [CommandImpl, FindNewConnectionCommand_1]);
  initMetadataForInterface(FunctionDeclaration_1, 'FunctionDeclaration', VOID, VOID, [AbstractBindingDeclaration]);
  initMetadataForClass(FunctionDeclarationImpl, 'FunctionDeclarationImpl', VOID, AbstractBindingDeclarationImpl, [AbstractBindingDeclarationImpl, FunctionDeclaration_1]);
  initMetadataForInterface(FunctionLibrary_1, 'FunctionLibrary', VOID, VOID, [DocumentNode_0]);
  initMetadataForClass(FunctionLibraryImpl, 'FunctionLibraryImpl', VOID, DocumentNodeImpl, [DocumentNodeImpl, FunctionLibrary_1]);
  initMetadataForInterface(FunctionTerm_1, 'FunctionTerm', VOID, VOID, [AbstractValue]);
  initMetadataForClass(FunctionTermImpl, 'FunctionTermImpl', VOID, BTBNodeImpl, [BTBNodeImpl, FunctionTerm_1]);
  function get_name_2() {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new ImportedLink$name$$inlined$suspendingQuery$1(this);
  }
  function get_specificator() {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new ImportedLink$specificator$$inlined$suspendingQuery$1(this);
  }
  function get_element() {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new ImportedLink$element$$inlined$suspendingQuery$1(this);
  }
  initMetadataForInterface(ImportedLink_1, 'ImportedLink', VOID, VOID, [AbstractLink]);
  initMetadataForClass(ImportedLinkImpl, 'ImportedLinkImpl', VOID, AbstractLinkImpl, [AbstractLinkImpl, ImportedLink_1]);
  function get_name_3() {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new ImportedProperty$name$$inlined$suspendingQuery$1(this);
  }
  function get_type_1() {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new ImportedProperty$type$$inlined$suspendingQuery$1(this);
  }
  initMetadataForInterface(ImportedProperty_1, 'ImportedProperty', VOID, VOID, [AbstractProperty]);
  initMetadataForClass(ImportedPropertyImpl, 'ImportedPropertyImpl', VOID, AbstractPropertyImpl, [AbstractPropertyImpl, ImportedProperty_1]);
  initMetadataForInterface(InheritedProcessProperty, 'InheritedProcessProperty', VOID, VOID, [BTBNode, DirectlyNamed]);
  initMetadataForClass(InheritedProcessPropertyImpl, 'InheritedProcessPropertyImpl', VOID, BTBNodeImpl, [BTBNodeImpl, InheritedProcessProperty]);
  initMetadataForInterface(InstanceRelationDeclaration, 'InstanceRelationDeclaration', VOID, VOID, [BTBNode, DirectlyNamed]);
  initMetadataForClass(InstanceRelationDeclarationImpl, 'InstanceRelationDeclarationImpl', VOID, BTBNodeImpl, [BTBNodeImpl, InstanceRelationDeclaration]);
  initMetadataForInterface(InstanceRelationValuePlaceholder, 'InstanceRelationValuePlaceholder', VOID, VOID, [BTBNode]);
  initMetadataForClass(InstanceRelationValuePlaceholderImpl, 'InstanceRelationValuePlaceholderImpl', VOID, BTBNodeImpl, [BTBNodeImpl, InstanceRelationValuePlaceholder]);
  initMetadataForInterface(InstanceRelationValue, 'InstanceRelationValue', VOID, VOID, [InstanceRelationValuePlaceholder]);
  initMetadataForClass(InstanceRelationValueImpl, 'InstanceRelationValueImpl', VOID, InstanceRelationValuePlaceholderImpl, [InstanceRelationValuePlaceholderImpl, InstanceRelationValue]);
  initMetadataForInterface(IntegerValue_1, 'IntegerValue', VOID, VOID, [AbstractValue, FactExpression, AllowedComplexNotionValue]);
  initMetadataForClass(IntegerValueImpl, 'IntegerValueImpl', VOID, BTBNodeImpl, [BTBNodeImpl, IntegerValue_1]);
  initMetadataForInterface(IsExpression_1, 'IsExpression', VOID, VOID, [FactExpression]);
  initMetadataForClass(IsExpressionImpl, 'IsExpressionImpl', VOID, BTBNodeImpl, [BTBNodeImpl, IsExpression_1]);
  initMetadataForInterface(KindCustomCell_1, 'KindCustomCell', VOID, VOID, [CustomCell]);
  initMetadataForClass(KindCustomCellImpl, 'KindCustomCellImpl', VOID, CustomCellImpl, [CustomCellImpl, KindCustomCell_1]);
  initMetadataForInterface(KnowledgeSourceReference, 'KnowledgeSourceReference', VOID, VOID, [BTBNode]);
  initMetadataForClass(KnowledgeSourceReferenceImpl, 'KnowledgeSourceReferenceImpl', VOID, BTBNodeImpl, [BTBNodeImpl, KnowledgeSourceReference]);
  initMetadataForInterface(KnowledgeSourceReferencePlaceholder_1, 'KnowledgeSourceReferencePlaceholder', VOID, VOID, [KnowledgeSourceReference]);
  initMetadataForClass(KnowledgeSourceReferencePlaceholderImpl, 'KnowledgeSourceReferencePlaceholderImpl', VOID, KnowledgeSourceReferenceImpl, [KnowledgeSourceReferenceImpl, KnowledgeSourceReferencePlaceholder_1]);
  initMetadataForInterface(LibraryItemPlaceholder_1, 'LibraryItemPlaceholder', VOID, VOID, [LibraryItem]);
  initMetadataForClass(LibraryItemPlaceholderImpl, 'LibraryItemPlaceholderImpl', VOID, BTBNodeImpl, [BTBNodeImpl, LibraryItemPlaceholder_1]);
  initMetadataForInterface(ProcessProvider, 'ProcessProvider', VOID, VOID, [BTBNode]);
  function meaningfulParametersNewStructure() {
    // Inline function 'kotlin.collections.filterIsInstance' call
    var tmp0 = this.kfr().m5y();
    // Inline function 'kotlin.collections.filterIsInstanceTo' call
    var destination = ArrayList_init_$Create$();
    var _iterator__ex2g4s = tmp0.m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      if (!(element == null) ? isInterface(element, ProcessPropertyValue_1) : false) {
        destination.j(element);
      }
    }
    return destination;
  }
  initMetadataForInterface(LibraryProcessSpecification_1, 'LibraryProcessSpecification', VOID, VOID, [AbstractProcessSpecification, ProcessProvider, FactExpression]);
  initMetadataForClass(LibraryProcessSpecificationImpl, 'LibraryProcessSpecificationImpl', VOID, AbstractProcessSpecificationImpl, [AbstractProcessSpecificationImpl, LibraryProcessSpecification_1]);
  initMetadataForInterface(LibraryProcessSpecificationQuery_1, 'LibraryProcessSpecificationQuery', VOID, VOID, [BTBNode, ProcessProvider]);
  initMetadataForClass(LibraryProcessSpecificationQueryImpl, 'LibraryProcessSpecificationQueryImpl', VOID, BTBNodeImpl, [BTBNodeImpl, LibraryProcessSpecificationQuery_1]);
  initMetadataForInterface(LinkCustomCell_1, 'LinkCustomCell', VOID, VOID, [CustomCell]);
  initMetadataForClass(LinkCustomCellImpl, 'LinkCustomCellImpl', VOID, CustomCellImpl, [CustomCellImpl, LinkCustomCell_1]);
  initMetadataForInterface(LinkDeclaration_1, 'LinkDeclaration', VOID, VOID, [BTBNode, DirectlyNamed]);
  initMetadataForClass(LinkDeclarationImpl, 'LinkDeclarationImpl', VOID, BTBNodeImpl, [BTBNodeImpl, LinkDeclaration_1]);
  initMetadataForInterface(LinkLibrary_1, 'LinkLibrary', VOID, VOID, [DocumentNode_0]);
  initMetadataForClass(LinkLibraryImpl, 'LinkLibraryImpl', VOID, DocumentNodeImpl, [DocumentNodeImpl, LinkLibrary_1]);
  initMetadataForInterface(ClassExpression, 'ClassExpression', VOID, VOID, [ClassExpressionPlaceholder_1]);
  function get_getClassDeclaration() {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new OntologyElementReferenceProvider$getClassDeclaration$$inlined$suspendingQuery$1(this);
  }
  initMetadataForInterface(OntologyElementReferenceProvider, 'OntologyElementReferenceProvider', VOID, VOID, [ClassExpression]);
  initMetadataForInterface(LocalOntologyElementReference_1, 'LocalOntologyElementReference', VOID, VOID, [BTBNode, OntologyElementReferenceProvider]);
  initMetadataForClass(LocalOntologyElementReferenceImpl, 'LocalOntologyElementReferenceImpl', VOID, BTBNodeImpl, [BTBNodeImpl, LocalOntologyElementReference_1]);
  initMetadataForInterface(MeasurableNotion_1, 'MeasurableNotion', VOID, VOID, [AbstractNotion]);
  initMetadataForClass(MeasurableNotionImpl, 'MeasurableNotionImpl', VOID, AbstractNotionImpl, [AbstractNotionImpl, MeasurableNotion_1]);
  function intAmount(value) {
    return this.yfr().d2x(Companion_getInstance_24().h26(value));
  }
  initMetadataForInterface(MeasurableValue_1, 'MeasurableValue', VOID, VOID, [AbstractValue, FactExpression, AllowedComplexNotionValue]);
  initMetadataForClass(MeasurableValueImpl, 'MeasurableValueImpl', VOID, BTBNodeImpl, [BTBNodeImpl, MeasurableValue_1]);
  initMetadataForInterface(MeasurementUnit_1, 'MeasurementUnit', VOID, VOID, [BTBNode, DirectlyNamed]);
  initMetadataForClass(MeasurementUnitImpl, 'MeasurementUnitImpl', VOID, BTBNodeImpl, [BTBNodeImpl, MeasurementUnit_1]);
  initMetadataForInterface(ModifierContainer, 'ModifierContainer', VOID, VOID, [DocumentNode_0]);
  initMetadataForClass(ModifierContainerImpl, 'ModifierContainerImpl', VOID, DocumentNodeImpl, [DocumentNodeImpl, ModifierContainer]);
  initMetadataForInterface(ModifierDeclaration, 'ModifierDeclaration', VOID, VOID, [BTBNode, DirectlyNamed]);
  initMetadataForClass(ModifierDeclarationImpl, 'ModifierDeclarationImpl', VOID, BTBNodeImpl, [BTBNodeImpl, ModifierDeclaration]);
  initMetadataForInterface(ModifierFactExpression_0, 'ModifierFactExpression', VOID, VOID, [FactExpression]);
  initMetadataForClass(ModifierFactExpressionImpl, 'ModifierFactExpressionImpl', VOID, BTBNodeImpl, [BTBNodeImpl, ModifierFactExpression_0]);
  initMetadataForInterface(MultilineText, 'MultilineText', VOID, VOID, [BTBNode]);
  initMetadataForClass(MultilineTextImpl, 'MultilineTextImpl', VOID, BTBNodeImpl, [BTBNodeImpl, MultilineText]);
  initMetadataForInterface(MultipleProcessPropertyValueRange_1, 'MultipleProcessPropertyValueRange', VOID, VOID, [ProcessPropertyValueRange]);
  initMetadataForClass(MultipleProcessPropertyValueRangeImpl, 'MultipleProcessPropertyValueRangeImpl', VOID, BTBNodeImpl, [BTBNodeImpl, MultipleProcessPropertyValueRange_1]);
  initMetadataForInterface(PropertyValueRange, 'PropertyValueRange', VOID, VOID, [BTBNode]);
  initMetadataForClass(PropertyValueRangeImpl, 'PropertyValueRangeImpl', VOID, BTBNodeImpl, [BTBNodeImpl, PropertyValueRange]);
  initMetadataForInterface(MultiplePropertyValueRange_1, 'MultiplePropertyValueRange', VOID, VOID, [PropertyValueRange]);
  initMetadataForClass(MultiplePropertyValueRangeImpl, 'MultiplePropertyValueRangeImpl', VOID, PropertyValueRangeImpl, [PropertyValueRangeImpl, MultiplePropertyValueRange_1]);
  function get_multiplier() {
    var tmp = this.dfs().m5y();
    var tmp_0 = MultipliedExpression$Companion$toMultiplierValue$ref(Companion_instance_356);
    return get_forQueries(map_1(tmp, tmp_0, MultipliedExpression$Companion$toStoredMultiplier$ref(Companion_instance_356)));
  }
  initMetadataForInterface(MultipliedExpression_1, 'MultipliedExpression', VOID, VOID, [FactExpression]);
  initMetadataForClass(MultipliedExpressionImpl, 'MultipliedExpressionImpl', VOID, BTBNodeImpl, [BTBNodeImpl, MultipliedExpression_1]);
  initMetadataForInterface(NewFact, 'NewFact', VOID, VOID, [BTBNode, DirectlyNamed]);
  initMetadataForClass(NewFactImpl, 'NewFactImpl', VOID, BTBNodeImpl, [BTBNodeImpl, NewFact]);
  initMetadataForInterface(NewFactReference_0, 'NewFactReference', VOID, VOID, [FactExpression]);
  initMetadataForClass(NewFactReferenceImpl, 'NewFactReferenceImpl', VOID, BTBNodeImpl, [BTBNodeImpl, NewFactReference_0]);
  function get_types() {
    return constant(emptyList());
  }
  initMetadataForInterface(NoValues_1, 'NoValues', VOID, VOID, [PropertyValueRange]);
  initMetadataForClass(NoValuesImpl, 'NoValuesImpl', VOID, PropertyValueRangeImpl, [PropertyValueRangeImpl, NoValues_1]);
  initMetadataForInterface(NotionLibrary_1, 'NotionLibrary', VOID, VOID, [DocumentNode_0]);
  initMetadataForClass(NotionLibraryImpl, 'NotionLibraryImpl', VOID, DocumentNodeImpl, [DocumentNodeImpl, NotionLibrary_1]);
  initMetadataForInterface(NotionPlaceholder_1, 'NotionPlaceholder', VOID, VOID, [AbstractNotion]);
  initMetadataForClass(NotionPlaceholderImpl, 'NotionPlaceholderImpl', VOID, AbstractNotionImpl, [AbstractNotionImpl, NotionPlaceholder_1]);
  initMetadataForInterface(AllowedComplexNotionType, 'AllowedComplexNotionType', VOID, VOID, [BTBNode]);
  initMetadataForInterface(NotionType_0, 'NotionType', VOID, VOID, [Type, AllowedComplexNotionType]);
  initMetadataForClass(NotionTypeImpl, 'NotionTypeImpl', VOID, TypeImpl, [TypeImpl, NotionType_0]);
  initMetadataForInterface(ObjectPropertiesLibrary, 'ObjectPropertiesLibrary', VOID, VOID, [DocumentNode_0]);
  initMetadataForClass(ObjectPropertiesLibraryImpl, 'ObjectPropertiesLibraryImpl', VOID, DocumentNodeImpl, [DocumentNodeImpl, ObjectPropertiesLibrary]);
  initMetadataForInterface(ObjectPropertyDeclaration_1, 'ObjectPropertyDeclaration', VOID, VOID, [BTBNode, DirectlyNamed, HasComments]);
  initMetadataForClass(ObjectPropertyDeclarationImpl, 'ObjectPropertyDeclarationImpl', VOID, BTBNodeImpl, [BTBNodeImpl, ObjectPropertyDeclaration_1]);
  function removePropertyReference() {
    // Inline function 'jetbrains.ocelot.langDef.query.executeQuery' call
    // Inline function 'jetbrains.ocelot.langDef.query.query' call
    var tmp$ret$0 = new ObjectPropertyReferenceValue$removePropertyReference$$inlined$executeQuery$1(this);
    return execute_0(tmp$ret$0);
  }
  initMetadataForInterface(ObjectPropertyReferenceValue_1, 'ObjectPropertyReferenceValue', VOID, VOID, [AbstractValue, FactExpression]);
  initMetadataForClass(ObjectPropertyReferenceValueImpl, 'ObjectPropertyReferenceValueImpl', VOID, BTBNodeImpl, [BTBNodeImpl, ObjectPropertyReferenceValue_1]);
  function get_name_4() {
    return this.lfs();
  }
  function citation_0() {
    return get_forQueries(this.lfs().m5y());
  }
  initMetadataForInterface(OldPublishedSource, 'OldPublishedSource', VOID, VOID, [LibraryItem, PublishedWork]);
  initMetadataForClass(OldPublishedSourceImpl, 'OldPublishedSourceImpl', VOID, PublishedWorkImpl, [PublishedWorkImpl, OldPublishedSource]);
  initMetadataForInterface(OneOf_1, 'OneOf', VOID, VOID, [Type]);
  initMetadataForClass(OneOfImpl, 'OneOfImpl', VOID, TypeImpl, [TypeImpl, OneOf_1]);
  initMetadataForInterface(OntologyCardinalityRelation_1, 'OntologyCardinalityRelation', VOID, VOID, [AbstractOntologyRelation]);
  initMetadataForClass(OntologyCardinalityRelationImpl, 'OntologyCardinalityRelationImpl', VOID, AbstractOntologyRelationImpl, [AbstractOntologyRelationImpl, OntologyCardinalityRelation_1]);
  initMetadataForInterface(HasPropertyConstraints, 'HasPropertyConstraints', VOID, VOID, [BTBNode]);
  initMetadataForInterface(OntologyElementDefinition_1, 'OntologyElementDefinition', VOID, VOID, [BTBNode, HasPropertyConstraints]);
  initMetadataForClass(OntologyElementDefinitionImpl, 'OntologyElementDefinitionImpl', VOID, BTBNodeImpl, [BTBNodeImpl, OntologyElementDefinition_1]);
  initMetadataForInterface(ClassDeclaration, 'ClassDeclaration', VOID, VOID, [BTBNode]);
  function allTaxonElements() {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new OntologyElement$allTaxonElements$$inlined$suspendingQuery$1(this);
  }
  initMetadataForInterface(OntologyElement_1, 'OntologyElement', VOID, VOID, [BTBNode, DirectlyNamed, ClassDeclaration, HasPropertyConstraints, HasComments]);
  initMetadataForClass(OntologyElementImpl, 'OntologyElementImpl', VOID, BTBNodeImpl, [BTBNodeImpl, OntologyElement_1]);
  initMetadataForInterface(OntologyElementPropertyType_1, 'OntologyElementPropertyType', VOID, VOID, [ProcessPropertyType]);
  initMetadataForClass(OntologyElementPropertyTypeImpl, 'OntologyElementPropertyTypeImpl', VOID, BTBNodeImpl, [BTBNodeImpl, OntologyElementPropertyType_1]);
  initMetadataForInterface(OntologyElementReference_1, 'OntologyElementReference', VOID, VOID, [BTBNode, OntologyElementReferenceProvider]);
  initMetadataForClass(OntologyElementReferenceImpl, 'OntologyElementReferenceImpl', VOID, BTBNodeImpl, [BTBNodeImpl, OntologyElementReference_1]);
  initMetadataForInterface(OntologyElementReferenceValue_1, 'OntologyElementReferenceValue', VOID, VOID, [AbstractValue, FactExpression]);
  initMetadataForClass(OntologyElementReferenceValueImpl, 'OntologyElementReferenceValueImpl', VOID, BTBNodeImpl, [BTBNodeImpl, OntologyElementReferenceValue_1]);
  initMetadataForInterface(OntologyElementReferenceValueLibrary_1, 'OntologyElementReferenceValueLibrary', VOID, VOID, [OntologyElementReferenceValue_1]);
  initMetadataForClass(OntologyElementReferenceValueLibraryImpl, 'OntologyElementReferenceValueLibraryImpl', VOID, OntologyElementReferenceValueImpl, [OntologyElementReferenceValueImpl, OntologyElementReferenceValueLibrary_1]);
  initMetadataForInterface(OntologyElementSynonym_1, 'OntologyElementSynonym', VOID, VOID, [BTBNode]);
  initMetadataForClass(OntologyElementSynonymImpl, 'OntologyElementSynonymImpl', VOID, BTBNodeImpl, [BTBNodeImpl, OntologyElementSynonym_1]);
  initMetadataForInterface(OntologyElementType_1, 'OntologyElementType', VOID, VOID, [Type]);
  initMetadataForClass(OntologyElementTypeImpl, 'OntologyElementTypeImpl', VOID, TypeImpl, [TypeImpl, OntologyElementType_1]);
  initMetadataForInterface(OntologyImport_1, 'OntologyImport', VOID, VOID, [BTBNode]);
  initMetadataForClass(OntologyImportImpl, 'OntologyImportImpl', VOID, BTBNodeImpl, [BTBNodeImpl, OntologyImport_1]);
  initMetadataForInterface(OntologyImportRoot_1, 'OntologyImportRoot', VOID, VOID, [DocumentNode_0]);
  initMetadataForClass(OntologyImportRootImpl, 'OntologyImportRootImpl', VOID, DocumentNodeImpl, [DocumentNodeImpl, OntologyImportRoot_1]);
  initMetadataForInterface(OntologyImportRootReference_1, 'OntologyImportRootReference', VOID, VOID, [BTBNode]);
  initMetadataForClass(OntologyImportRootReferenceImpl, 'OntologyImportRootReferenceImpl', VOID, BTBNodeImpl, [BTBNodeImpl, OntologyImportRootReference_1]);
  function getElementReference() {
    // Inline function 'jetbrains.ocelot.langDef.query.executeQuery' call
    // Inline function 'jetbrains.ocelot.langDef.query.query' call
    var tmp$ret$0 = new OntologyIsRelation$getElementReference$$inlined$executeQuery$1(this);
    return execute_0(tmp$ret$0);
  }
  initMetadataForInterface(OntologyIsRelation_1, 'OntologyIsRelation', VOID, VOID, [AbstractOntologyRelation]);
  initMetadataForClass(OntologyIsRelationImpl, 'OntologyIsRelationImpl', VOID, AbstractOntologyRelationImpl, [AbstractOntologyRelationImpl, OntologyIsRelation_1]);
  initMetadataForInterface(OntologyLibrary_1, 'OntologyLibrary', VOID, VOID, [DocumentNode_0]);
  initMetadataForClass(OntologyLibraryImpl, 'OntologyLibraryImpl', VOID, DocumentNodeImpl, [DocumentNodeImpl, OntologyLibrary_1]);
  initMetadataForInterface(OntologyLibraryReference_1, 'OntologyLibraryReference', VOID, VOID, [BTBNode]);
  initMetadataForClass(OntologyLibraryReferenceImpl, 'OntologyLibraryReferenceImpl', VOID, BTBNodeImpl, [BTBNodeImpl, OntologyLibraryReference_1]);
  initMetadataForInterface(OntologyLinkDeclarationValueQuery_1, 'OntologyLinkDeclarationValueQuery', VOID, VOID, [DeclarationValueQuery]);
  initMetadataForClass(OntologyLinkDeclarationValueQueryImpl, 'OntologyLinkDeclarationValueQueryImpl', VOID, DeclarationValueQueryImpl, [DeclarationValueQueryImpl, OntologyLinkDeclarationValueQuery_1]);
  function get_name_5() {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new OntologyLink$name$$inlined$suspendingQuery$1(this);
  }
  function get_element_0() {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new OntologyLink$element$$inlined$suspendingQuery$1(this);
  }
  function get_specificator_0() {
    // Inline function 'jetbrains.ocelot.langDef.query.query' call
    return new OntologyLink$specificator$$inlined$query$1(this);
  }
  initMetadataForInterface(OntologyLink_1, 'OntologyLink', VOID, VOID, [AbstractLink]);
  initMetadataForClass(OntologyLinkImpl, 'OntologyLinkImpl', VOID, AbstractLinkImpl, [AbstractLinkImpl, OntologyLink_1]);
  function importedLibraries() {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new OntologyLinkValue$importedLibraries$$inlined$suspendingQuery$1(this);
  }
  initMetadataForInterface(OntologyLinkValue_1, 'OntologyLinkValue', VOID, VOID, [AbstractBindingValue]);
  initMetadataForClass(OntologyLinkValueImpl, 'OntologyLinkValueImpl', VOID, AbstractBindingValueImpl, [AbstractBindingValueImpl, OntologyLinkValue_1]);
  initMetadataForInterface(OrValueQuery_1, 'OrValueQuery', VOID, VOID, [AbstractBindingValueQuery]);
  initMetadataForClass(OrValueQueryImpl, 'OrValueQueryImpl', VOID, AbstractBindingValueQueryImpl, [AbstractBindingValueQueryImpl, OrValueQuery_1]);
  initMetadataForInterface(PageSpecification, 'PageSpecification', VOID, VOID, [BTBNode]);
  initMetadataForClass(PageSpecificationImpl, 'PageSpecificationImpl', VOID, BTBNodeImpl, [BTBNodeImpl, PageSpecification]);
  initMetadataForInterface(Page_1, 'Page', VOID, VOID, [PageSpecification]);
  initMetadataForClass(PageImpl, 'PageImpl', VOID, PageSpecificationImpl, [PageSpecificationImpl, Page_1]);
  initMetadataForInterface(PageRange_1, 'PageRange', VOID, VOID, [PageSpecification]);
  initMetadataForClass(PageRangeImpl, 'PageRangeImpl', VOID, PageSpecificationImpl, [PageSpecificationImpl, PageRange_1]);
  initMetadataForInterface(Paper_1, 'Paper', VOID, VOID, [PublishedWork, LibraryItem]);
  initMetadataForClass(PaperImpl, 'PaperImpl', VOID, PublishedWorkImpl, [PublishedWorkImpl, Paper_1]);
  function transformToVariableReference() {
    // Inline function 'jetbrains.ocelot.langDef.query.executeQuery' call
    // Inline function 'jetbrains.ocelot.langDef.query.query' call
    var tmp$ret$0 = new PartValue$transformToVariableReference$$inlined$executeQuery$1(this);
    return execute_0(tmp$ret$0);
  }
  initMetadataForInterface(PartValue, 'PartValue', VOID, VOID, [AbstractValue]);
  initMetadataForClass(PartValueImpl, 'PartValueImpl', VOID, BTBNodeImpl, [BTBNodeImpl, PartValue]);
  initMetadataForInterface(Pattern, 'Pattern', VOID, VOID, [BTBNode]);
  initMetadataForClass(PatternImpl, 'PatternImpl', VOID, BTBNodeImpl, [BTBNodeImpl, Pattern]);
  initMetadataForInterface(PrimitiveNotionType_1, 'PrimitiveNotionType', VOID, VOID, [Type, AllowedComplexNotionType]);
  initMetadataForClass(PrimitiveNotionTypeImpl, 'PrimitiveNotionTypeImpl', VOID, TypeImpl, [TypeImpl, PrimitiveNotionType_1]);
  initMetadataForInterface(PrimitivePropertyType_1, 'PrimitivePropertyType', VOID, VOID, [ProcessPropertyType]);
  initMetadataForClass(PrimitivePropertyTypeImpl, 'PrimitivePropertyTypeImpl', VOID, BTBNodeImpl, [BTBNodeImpl, PrimitivePropertyType_1]);
  function aliasedProperties() {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new ProcessDeclaration$aliasedProperties$$inlined$suspendingQuery$1(this);
  }
  function allEntries() {
    return allEntries_0(this, mutableListOf([this]));
  }
  function allProperties() {
    return allProperties_0(this, emptySet(), setOf(this));
  }
  function allSuperProperties() {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new ProcessDeclaration$allSuperProperties$$inlined$suspendingQuery$1(this);
  }
  function allInheritedProcesses() {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new ProcessDeclaration$allInheritedProcesses$$inlined$suspendingQuery$1(this);
  }
  function cycleInExtends() {
    return cycleInExtends_0(this, this, mutableListOf([this]));
  }
  initMetadataForInterface(ProcessDeclaration_1, 'ProcessDeclaration', VOID, VOID, [AbstractBindingDeclaration, HasVariables]);
  initMetadataForClass(ProcessDeclarationImpl, 'ProcessDeclarationImpl', VOID, AbstractBindingDeclarationImpl, [AbstractBindingDeclarationImpl, ProcessDeclaration_1]);
  initMetadataForInterface(HasQueryLabels, 'HasQueryLabels', VOID, VOID, [BTBNode]);
  initMetadataForInterface(HasFactExpression, 'HasFactExpression', VOID, VOID, [BTBNode]);
  initMetadataForInterface(ProcessEffect_0, 'ProcessEffect', VOID, VOID, [HasQueryLabels, HasFactExpression]);
  initMetadataForClass(ProcessEffectImpl, 'ProcessEffectImpl', VOID, BTBNodeImpl, [BTBNodeImpl, ProcessEffect_0]);
  initMetadataForInterface(ProcessKindContainer_1, 'ProcessKindContainer', VOID, VOID, [DocumentNode_0]);
  initMetadataForClass(ProcessKindContainerImpl, 'ProcessKindContainerImpl', VOID, DocumentNodeImpl, [DocumentNodeImpl, ProcessKindContainer_1]);
  initMetadataForInterface(ProcessKind_1, 'ProcessKind', VOID, VOID, [BTBNode, DirectlyNamed]);
  initMetadataForClass(ProcessKindImpl, 'ProcessKindImpl', VOID, BTBNodeImpl, [BTBNodeImpl, ProcessKind_1]);
  initMetadataForInterface(ProcessLibrary_1, 'ProcessLibrary', VOID, VOID, [DocumentNode_0]);
  initMetadataForClass(ProcessLibraryImpl, 'ProcessLibraryImpl', VOID, DocumentNodeImpl, [DocumentNodeImpl, ProcessLibrary_1]);
  initMetadataForInterface(ProcessPrerequisite_0, 'ProcessPrerequisite', VOID, VOID, [HasQueryLabels, HasFactExpression]);
  initMetadataForClass(ProcessPrerequisiteImpl, 'ProcessPrerequisiteImpl', VOID, BTBNodeImpl, [BTBNodeImpl, ProcessPrerequisite_0]);
  initMetadataForInterface(ProcessPropertyCustomCell_1, 'ProcessPropertyCustomCell', VOID, VOID, [CustomCell]);
  initMetadataForClass(ProcessPropertyCustomCellImpl, 'ProcessPropertyCustomCellImpl', VOID, CustomCellImpl, [CustomCellImpl, ProcessPropertyCustomCell_1]);
  initMetadataForInterface(ProcessPropertyDefault_1, 'ProcessPropertyDefault', VOID, VOID, [BTBNode]);
  initMetadataForClass(ProcessPropertyDefaultImpl, 'ProcessPropertyDefaultImpl', VOID, BTBNodeImpl, [BTBNodeImpl, ProcessPropertyDefault_1]);
  initMetadataForInterface(ProcessProperty_1, 'ProcessProperty', VOID, VOID, [BTBNode, DirectlyNamed]);
  initMetadataForClass(ProcessPropertyImpl, 'ProcessPropertyImpl', VOID, BTBNodeImpl, [BTBNodeImpl, ProcessProperty_1]);
  initMetadataForInterface(VariableInitializer, 'VariableInitializer', VOID, VOID, [VariableSpecification]);
  initMetadataForClass(VariableInitializerImpl, 'VariableInitializerImpl', VOID, VariableSpecificationImpl, [VariableSpecificationImpl, VariableInitializer]);
  initMetadataForInterface(ProcessPropertyReference, 'ProcessPropertyReference', VOID, VOID, [FactExpression, AbstractValue, VariableInitializer]);
  initMetadataForClass(ProcessPropertyReferenceImpl, 'ProcessPropertyReferenceImpl', VOID, VariableInitializerImpl, [VariableInitializerImpl, ProcessPropertyReference]);
  initMetadataForInterface(ProcessPropertyValue_1, 'ProcessPropertyValue', VOID, VOID, [BindingValuePlaceholder_1, HasQueryLabels]);
  initMetadataForClass(ProcessPropertyValueImpl, 'ProcessPropertyValueImpl', VOID, BindingValuePlaceholderImpl, [BindingValuePlaceholderImpl, ProcessPropertyValue_1]);
  initMetadataForInterface(ProcessReference_1, 'ProcessReference', VOID, VOID, [BTBNode]);
  initMetadataForClass(ProcessReferenceImpl, 'ProcessReferenceImpl', VOID, BTBNodeImpl, [BTBNodeImpl, ProcessReference_1]);
  function isValid() {
    // Inline function 'jetbrains.ocelot.langDef.query.query' call
    return new ProcessRelationDeclaration$isValid$$inlined$query$1(this);
  }
  initMetadataForInterface(ProcessRelationDeclaration_1, 'ProcessRelationDeclaration', VOID, VOID, [BTBNode, DirectlyNamed]);
  initMetadataForClass(ProcessRelationDeclarationImpl, 'ProcessRelationDeclarationImpl', VOID, BTBNodeImpl, [BTBNodeImpl, ProcessRelationDeclaration_1]);
  initMetadataForInterface(ProcessType_1, 'ProcessType', VOID, VOID, [Type]);
  initMetadataForClass(ProcessTypeImpl, 'ProcessTypeImpl', VOID, TypeImpl, [TypeImpl, ProcessType_1]);
  initMetadataForInterface(PropertiesCustomCell_1, 'PropertiesCustomCell', VOID, VOID, [CustomCell]);
  initMetadataForClass(PropertiesCustomCellImpl, 'PropertiesCustomCellImpl', VOID, CustomCellImpl, [CustomCellImpl, PropertiesCustomCell_1]);
  initMetadataForInterface(PropertyConstraint_1, 'PropertyConstraint', VOID, VOID, [BTBNode, HasPropertyConstraints]);
  initMetadataForClass(PropertyConstraintImpl, 'PropertyConstraintImpl', VOID, BTBNodeImpl, [BTBNodeImpl, PropertyConstraint_1]);
  initMetadataForInterface(PropertyCustomCell_1, 'PropertyCustomCell', VOID, VOID, [CustomCell]);
  initMetadataForClass(PropertyCustomCellImpl, 'PropertyCustomCellImpl', VOID, CustomCellImpl, [CustomCellImpl, PropertyCustomCell_1]);
  initMetadataForInterface(PropertyDeclaration_1, 'PropertyDeclaration', VOID, VOID, [BTBNode, DirectlyNamed, PropertyLibraryElement]);
  initMetadataForClass(PropertyDeclarationImpl, 'PropertyDeclarationImpl', VOID, BTBNodeImpl, [BTBNodeImpl, PropertyDeclaration_1]);
  initMetadataForInterface(PropertyDeclarationValueQuery_1, 'PropertyDeclarationValueQuery', VOID, VOID, [DeclarationValueQuery]);
  initMetadataForClass(PropertyDeclarationValueQueryImpl, 'PropertyDeclarationValueQueryImpl', VOID, DeclarationValueQueryImpl, [DeclarationValueQueryImpl, PropertyDeclarationValueQuery_1]);
  function get_properties() {
    // Inline function 'jetbrains.ocelot.langDef.query.map' call
    var this_0 = this.ifq();
    // Inline function 'jetbrains.ocelot.langDef.query.query' call
    return new PropertyLibrary$properties$$inlined$map$1(this_0);
  }
  initMetadataForInterface(PropertyLibrary_1, 'PropertyLibrary', VOID, VOID, [DocumentNode_0]);
  initMetadataForClass(PropertyLibraryImpl, 'PropertyLibraryImpl', VOID, DocumentNodeImpl, [DocumentNodeImpl, PropertyLibrary_1]);
  initMetadataForInterface(PropertyReferenceOperation_1, 'PropertyReferenceOperation', VOID, VOID, [BTBNode]);
  initMetadataForClass(PropertyReferenceOperationImpl, 'PropertyReferenceOperationImpl', VOID, BTBNodeImpl, [BTBNodeImpl, PropertyReferenceOperation_1]);
  initMetadataForInterface(PropertyValue_1, 'PropertyValue', VOID, VOID, [AbstractBindingValue]);
  initMetadataForClass(PropertyValueImpl, 'PropertyValueImpl', VOID, AbstractBindingValueImpl, [AbstractBindingValueImpl, PropertyValue_1]);
  initMetadataForInterface(PubMedSourceReference_1, 'PubMedSourceReference', VOID, VOID, [KnowledgeSourceReference]);
  initMetadataForClass(PubMedSourceReferenceImpl, 'PubMedSourceReferenceImpl', VOID, KnowledgeSourceReferenceImpl, [KnowledgeSourceReferenceImpl, PubMedSourceReference_1]);
  initMetadataForInterface(PublishedSourceReference_1, 'PublishedSourceReference', VOID, VOID, [KnowledgeSourceReference]);
  initMetadataForClass(PublishedSourceReferenceImpl, 'PublishedSourceReferenceImpl', VOID, KnowledgeSourceReferenceImpl, [KnowledgeSourceReferenceImpl, PublishedSourceReference_1]);
  initMetadataForInterface(PublishedSourcesLibrary_1, 'PublishedSourcesLibrary', VOID, VOID, [BTBNode, DocumentNode_0]);
  initMetadataForClass(PublishedSourcesLibraryImpl, 'PublishedSourcesLibraryImpl', VOID, DocumentNodeImpl, [DocumentNodeImpl, PublishedSourcesLibrary_1]);
  function get_element_1() {
    // Inline function 'jetbrains.ocelot.langDef.query.executeQuery' call
    // Inline function 'jetbrains.ocelot.langDef.query.query' call
    var tmp$ret$0 = new QualifiedOntologyElementReference$element$$inlined$executeQuery$1(this);
    return execute_0(tmp$ret$0);
  }
  initMetadataForInterface(QualifiedOntologyElementReference_1, 'QualifiedOntologyElementReference', VOID, VOID, [OntologyElementReferenceProvider]);
  initMetadataForClass(QualifiedOntologyElementReferenceImpl, 'QualifiedOntologyElementReferenceImpl', VOID, BTBNodeImpl, [BTBNodeImpl, QualifiedOntologyElementReference_1]);
  initMetadataForInterface(QueryCommands_1, 'QueryCommands', VOID, VOID, [DocumentNode_0]);
  initMetadataForClass(QueryCommandsImpl, 'QueryCommandsImpl', VOID, DocumentNodeImpl, [DocumentNodeImpl, QueryCommands_1]);
  initMetadataForInterface(QueryLabelsFactExpressionContainer_0, 'QueryLabelsFactExpressionContainer', VOID, VOID, [HasQueryLabels, HasFactExpression]);
  initMetadataForClass(QueryLabelsFactExpressionContainerImpl, 'QueryLabelsFactExpressionContainerImpl', VOID, BTBNodeImpl, [BTBNodeImpl, QueryLabelsFactExpressionContainer_0]);
  initMetadataForInterface(QueryParametersBlackList, 'QueryParametersBlackList', VOID, VOID, [DocumentNode_0]);
  initMetadataForClass(QueryParametersBlackListImpl, 'QueryParametersBlackListImpl', VOID, DocumentNodeImpl, [DocumentNodeImpl, QueryParametersBlackList]);
  initMetadataForInterface(RelationContainer_1, 'RelationContainer', VOID, VOID, [DocumentNode_0]);
  initMetadataForClass(RelationContainerImpl, 'RelationContainerImpl', VOID, DocumentNodeImpl, [DocumentNodeImpl, RelationContainer_1]);
  initMetadataForInterface(RelationFactExpression_1, 'RelationFactExpression', VOID, VOID, [FactExpression]);
  initMetadataForClass(RelationFactExpressionImpl, 'RelationFactExpressionImpl', VOID, BTBNodeImpl, [BTBNodeImpl, RelationFactExpression_1]);
  initMetadataForInterface(ReturnTypeCustomCell_1, 'ReturnTypeCustomCell', VOID, VOID, [CustomCell]);
  initMetadataForClass(ReturnTypeCustomCellImpl, 'ReturnTypeCustomCellImpl', VOID, CustomCellImpl, [CustomCellImpl, ReturnTypeCustomCell_1]);
  initMetadataForInterface(SetExpression_1, 'SetExpression', VOID, VOID, [AbstractValue, FactExpression]);
  initMetadataForClass(SetExpressionImpl, 'SetExpressionImpl', VOID, BTBNodeImpl, [BTBNodeImpl, SetExpression_1]);
  initMetadataForInterface(SetValuedPropertyParameter_1, 'SetValuedPropertyParameter', VOID, VOID, [BTBNode]);
  initMetadataForClass(SetValuedPropertyParameterImpl, 'SetValuedPropertyParameterImpl', VOID, BTBNodeImpl, [BTBNodeImpl, SetValuedPropertyParameter_1]);
  initMetadataForInterface(SimplePropertyType, 'SimplePropertyType', VOID, VOID, [ProcessPropertyType]);
  initMetadataForClass(SimplePropertyTypeImpl, 'SimplePropertyTypeImpl', VOID, BTBNodeImpl, [BTBNodeImpl, SimplePropertyType]);
  initMetadataForInterface(SinglePropertyValueRange_1, 'SinglePropertyValueRange', VOID, VOID, [PropertyValueRange]);
  initMetadataForClass(SinglePropertyValueRangeImpl, 'SinglePropertyValueRangeImpl', VOID, PropertyValueRangeImpl, [PropertyValueRangeImpl, SinglePropertyValueRange_1]);
  initMetadataForInterface(StringValue_1, 'StringValue', VOID, VOID, [AbstractValue, FactExpression, AllowedComplexNotionValue]);
  initMetadataForClass(StringValueImpl, 'StringValueImpl', VOID, BTBNodeImpl, [BTBNodeImpl, StringValue_1]);
  initMetadataForInterface(TextLine, 'TextLine', VOID, VOID, [BTBNode]);
  initMetadataForClass(TextLineImpl, 'TextLineImpl', VOID, BTBNodeImpl, [BTBNodeImpl, TextLine]);
  initMetadataForInterface(TypePlaceholder_1, 'TypePlaceholder', VOID, VOID, [Type]);
  initMetadataForClass(TypePlaceholderImpl, 'TypePlaceholderImpl', VOID, TypeImpl, [TypeImpl, TypePlaceholder_1]);
  initMetadataForClass(TypedBTBNodeImpl, 'TypedBTBNodeImpl', VOID, BaseTypedOtNode, [BaseTypedOtNode, BTBNode]);
  initMetadataForClass(TypedAbstractBindingDeclarationImpl, 'TypedAbstractBindingDeclarationImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, AbstractBindingDeclaration]);
  initMetadataForClass(TypedAbstractBindingEntryImpl, 'TypedAbstractBindingEntryImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, AbstractBindingEntry]);
  initMetadataForClass(TypedBindingValuePlaceholderImpl, 'TypedBindingValuePlaceholderImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, BindingValuePlaceholder_1]);
  initMetadataForClass(TypedAbstractBindingValueImpl, 'TypedAbstractBindingValueImpl', VOID, TypedBindingValuePlaceholderImpl, [TypedBindingValuePlaceholderImpl, AbstractBindingValue]);
  initMetadataForClass(TypedBindingValuePlaceholderQueryImpl, 'TypedBindingValuePlaceholderQueryImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, BindingValuePlaceholderQuery_1]);
  initMetadataForClass(TypedAbstractBindingValueQueryImpl, 'TypedAbstractBindingValueQueryImpl', VOID, TypedBindingValuePlaceholderQueryImpl, [TypedBindingValuePlaceholderQueryImpl, AbstractBindingValueQuery]);
  initMetadataForClass(TypedAbstractLinkImpl, 'TypedAbstractLinkImpl', VOID, TypedAbstractBindingEntryImpl, [TypedAbstractBindingEntryImpl, AbstractLink]);
  initMetadataForClass(TypedAbstractNotionImpl, 'TypedAbstractNotionImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, AbstractNotion]);
  initMetadataForClass(TypedAbstractOntologyRelationImpl, 'TypedAbstractOntologyRelationImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, AbstractOntologyRelation]);
  initMetadataForClass(TypedAbstractProcessSpecificationImpl, 'TypedAbstractProcessSpecificationImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, AbstractProcessSpecification]);
  initMetadataForClass(TypedAbstractPropertyImpl, 'TypedAbstractPropertyImpl', VOID, TypedAbstractBindingEntryImpl, [TypedAbstractBindingEntryImpl, AbstractProperty]);
  initMetadataForClass(TypedAuthorImpl, 'TypedAuthorImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, Author_1]);
  initMetadataForClass(TypedAuthoredWorkImpl, 'TypedAuthoredWorkImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, AuthoredWork]);
  initMetadataForClass(TypedDocumentNodeImpl, 'TypedDocumentNodeImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, DocumentNode_0]);
  initMetadataForClass(TypedBTBDocumentImpl, 'TypedBTBDocumentImpl', VOID, TypedDocumentNodeImpl, [TypedDocumentNodeImpl, BTBDocument_1]);
  initMetadataForClass(TypedBindingPropertyImpl, 'TypedBindingPropertyImpl', VOID, TypedAbstractPropertyImpl, [TypedAbstractPropertyImpl, BindingProperty_1]);
  initMetadataForClass(TypedBindingValueMaskImpl, 'TypedBindingValueMaskImpl', VOID, TypedAbstractBindingValueQueryImpl, [TypedAbstractBindingValueQueryImpl, BindingValueMask_1]);
  initMetadataForClass(TypedPublishedWorkImpl, 'TypedPublishedWorkImpl', VOID, TypedAuthoredWorkImpl, [TypedAuthoredWorkImpl, PublishedWork]);
  initMetadataForClass(TypedBookImpl, 'TypedBookImpl', VOID, TypedPublishedWorkImpl, [TypedPublishedWorkImpl, Book_1]);
  initMetadataForClass(TypedCardinalityBoundImpl, 'TypedCardinalityBoundImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, CardinalityBound]);
  initMetadataForClass(TypedCardinalityBoundConstantImpl, 'TypedCardinalityBoundConstantImpl', VOID, TypedCardinalityBoundImpl, [TypedCardinalityBoundImpl, CardinalityBoundConstant_1]);
  initMetadataForClass(TypedCardinalityBoundNImpl, 'TypedCardinalityBoundNImpl', VOID, TypedCardinalityBoundImpl, [TypedCardinalityBoundImpl, CardinalityBoundN_1]);
  initMetadataForClass(TypedCardinalityBoundPlaceholderImpl, 'TypedCardinalityBoundPlaceholderImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, CardinalityBoundPlaceholder_1]);
  initMetadataForClass(TypedCustomCellImpl, 'TypedCustomCellImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, CustomCell]);
  initMetadataForClass(TypedCardinalityCustomCellImpl, 'TypedCardinalityCustomCellImpl', VOID, TypedCustomCellImpl, [TypedCustomCellImpl, CardinalityCustomCell_1]);
  initMetadataForClass(TypedCardinalityImpl, 'TypedCardinalityImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, Cardinality_1]);
  initMetadataForClass(TypedCategoryImpl, 'TypedCategoryImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, Category_1]);
  initMetadataForClass(TypedClassExpressionPlaceholderImpl, 'TypedClassExpressionPlaceholderImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, ClassExpressionPlaceholder_1]);
  initMetadataForClass(TypedVariableSpecificationImpl, 'TypedVariableSpecificationImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, VariableSpecification]);
  initMetadataForClass(TypedTypeImpl, 'TypedTypeImpl', VOID, TypedVariableSpecificationImpl, [TypedVariableSpecificationImpl, Type]);
  initMetadataForClass(TypedClassExpressionTypeImpl, 'TypedClassExpressionTypeImpl', VOID, TypedTypeImpl, [TypedTypeImpl, ClassExpressionType_1]);
  initMetadataForClass(TypedCommandImpl, 'TypedCommandImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, Command_0]);
  initMetadataForClass(TypedComplexNotionElementImpl, 'TypedComplexNotionElementImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, ComplexNotionElement_1]);
  initMetadataForClass(TypedComplexNotionElementValueImpl, 'TypedComplexNotionElementValueImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, ComplexNotionElementValue_1]);
  initMetadataForClass(TypedComplexNotionImpl, 'TypedComplexNotionImpl', VOID, TypedAbstractNotionImpl, [TypedAbstractNotionImpl, ComplexNotion_1]);
  initMetadataForClass(TypedComplexNotionTemplateElementImpl, 'TypedComplexNotionTemplateElementImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, ComplexNotionTemplateElement]);
  initMetadataForClass(TypedComplexNotionTemplateImpl, 'TypedComplexNotionTemplateImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, ComplexNotionTemplate_1]);
  initMetadataForClass(TypedComplexNotionTemplatePlaceholderImpl, 'TypedComplexNotionTemplatePlaceholderImpl', VOID, TypedComplexNotionTemplateElementImpl, [TypedComplexNotionTemplateElementImpl, ComplexNotionTemplatePlaceholder_1]);
  initMetadataForClass(TypedComplexNotionTemplateRefElementImpl, 'TypedComplexNotionTemplateRefElementImpl', VOID, TypedComplexNotionTemplateElementImpl, [TypedComplexNotionTemplateElementImpl, ComplexNotionTemplateRefElement_1]);
  initMetadataForClass(TypedComplexNotionTemplateTextElementImpl, 'TypedComplexNotionTemplateTextElementImpl', VOID, TypedComplexNotionTemplateElementImpl, [TypedComplexNotionTemplateElementImpl, ComplexNotionTemplateTextElement_1]);
  initMetadataForClass(TypedComplexNotionValueImpl, 'TypedComplexNotionValueImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, ComplexNotionValue_1]);
  initMetadataForClass(TypedConstantCustomCellImpl, 'TypedConstantCustomCellImpl', VOID, TypedCustomCellImpl, [TypedCustomCellImpl, ConstantCustomCell_1]);
  initMetadataForClass(TypedPreconditionImpl, 'TypedPreconditionImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, Precondition]);
  initMetadataForClass(TypedConstantPreconditionImpl, 'TypedConstantPreconditionImpl', VOID, TypedPreconditionImpl, [TypedPreconditionImpl, ConstantPrecondition_0]);
  initMetadataForClass(TypedContextImpl, 'TypedContextImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, Context_2]);
  initMetadataForClass(TypedContextQueryImpl, 'TypedContextQueryImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, ContextQuery_1]);
  initMetadataForClass(TypedCustomEditorImpl, 'TypedCustomEditorImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, CustomEditor]);
  initMetadataForClass(TypedDeclarationNameCustomCellImpl, 'TypedDeclarationNameCustomCellImpl', VOID, TypedCustomCellImpl, [TypedCustomCellImpl, DeclarationNameCustomCell_1]);
  initMetadataForClass(TypedDeclarationValueQueryImpl, 'TypedDeclarationValueQueryImpl', VOID, TypedAbstractBindingValueQueryImpl, [TypedAbstractBindingValueQueryImpl, DeclarationValueQuery]);
  initMetadataForClass(TypedEmptyBindingEntryImpl, 'TypedEmptyBindingEntryImpl', VOID, TypedAbstractBindingEntryImpl, [TypedAbstractBindingEntryImpl, EmptyBindingEntry_1]);
  initMetadataForClass(TypedEmptyPropertyLibraryElementImpl, 'TypedEmptyPropertyLibraryElementImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, EmptyPropertyLibraryElement_1]);
  initMetadataForClass(TypedEnumValueImpl, 'TypedEnumValueImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, EnumValue_1]);
  initMetadataForClass(TypedEnumerableNotionImpl, 'TypedEnumerableNotionImpl', VOID, TypedAbstractNotionImpl, [TypedAbstractNotionImpl, EnumerableNotion_1]);
  initMetadataForClass(TypedEnumerationConstantImpl, 'TypedEnumerationConstantImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, EnumerationConstant_1]);
  initMetadataForClass(TypedExtensionDeclarationImpl, 'TypedExtensionDeclarationImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, ExtensionDeclaration_1]);
  initMetadataForClass(TypedPartReferenceOperationImpl, 'TypedPartReferenceOperationImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, PartReferenceOperation]);
  initMetadataForClass(TypedExtensionFieldReferenceImpl, 'TypedExtensionFieldReferenceImpl', VOID, TypedPartReferenceOperationImpl, [TypedPartReferenceOperationImpl, ExtensionFieldReference_1]);
  initMetadataForClass(TypedExtensionLibraryImpl, 'TypedExtensionLibraryImpl', VOID, TypedDocumentNodeImpl, [TypedDocumentNodeImpl, ExtensionLibrary_1]);
  initMetadataForClass(TypedFactExpressionPlaceholderImpl, 'TypedFactExpressionPlaceholderImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, FactExpressionPlaceholder]);
  initMetadataForClass(TypedFactImpl, 'TypedFactImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, Fact_1]);
  initMetadataForClass(TypedFactPreconditionImpl, 'TypedFactPreconditionImpl', VOID, TypedPreconditionImpl, [TypedPreconditionImpl, FactPrecondition_1]);
  initMetadataForClass(TypedFactReferenceImpl, 'TypedFactReferenceImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, FactReference_1]);
  initMetadataForClass(TypedFactSetImpl, 'TypedFactSetImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, FactSet_1]);
  initMetadataForClass(TypedFieldDeclarationImpl, 'TypedFieldDeclarationImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, FieldDeclaration_1]);
  initMetadataForClass(TypedFindConnectionCommandImpl, 'TypedFindConnectionCommandImpl', VOID, TypedCommandImpl, [TypedCommandImpl, FindConnectionCommand_1]);
  initMetadataForClass(TypedFindNewConnectionCommandImpl, 'TypedFindNewConnectionCommandImpl', VOID, TypedCommandImpl, [TypedCommandImpl, FindNewConnectionCommand_1]);
  initMetadataForClass(TypedFunctionDeclarationImpl, 'TypedFunctionDeclarationImpl', VOID, TypedAbstractBindingDeclarationImpl, [TypedAbstractBindingDeclarationImpl, FunctionDeclaration_1]);
  initMetadataForClass(TypedFunctionLibraryImpl, 'TypedFunctionLibraryImpl', VOID, TypedDocumentNodeImpl, [TypedDocumentNodeImpl, FunctionLibrary_1]);
  initMetadataForClass(TypedFunctionTermImpl, 'TypedFunctionTermImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, FunctionTerm_1]);
  initMetadataForClass(TypedImportedLinkImpl, 'TypedImportedLinkImpl', VOID, TypedAbstractLinkImpl, [TypedAbstractLinkImpl, ImportedLink_1]);
  initMetadataForClass(TypedImportedPropertyImpl, 'TypedImportedPropertyImpl', VOID, TypedAbstractPropertyImpl, [TypedAbstractPropertyImpl, ImportedProperty_1]);
  initMetadataForClass(TypedInheritedProcessPropertyImpl, 'TypedInheritedProcessPropertyImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, InheritedProcessProperty]);
  initMetadataForClass(TypedInstanceRelationDeclarationImpl, 'TypedInstanceRelationDeclarationImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, InstanceRelationDeclaration]);
  initMetadataForClass(TypedInstanceRelationValuePlaceholderImpl, 'TypedInstanceRelationValuePlaceholderImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, InstanceRelationValuePlaceholder]);
  initMetadataForClass(TypedInstanceRelationValueImpl, 'TypedInstanceRelationValueImpl', VOID, TypedInstanceRelationValuePlaceholderImpl, [TypedInstanceRelationValuePlaceholderImpl, InstanceRelationValue]);
  initMetadataForClass(TypedIntegerValueImpl, 'TypedIntegerValueImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, IntegerValue_1]);
  initMetadataForClass(TypedIsExpressionImpl, 'TypedIsExpressionImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, IsExpression_1]);
  initMetadataForClass(TypedKindCustomCellImpl, 'TypedKindCustomCellImpl', VOID, TypedCustomCellImpl, [TypedCustomCellImpl, KindCustomCell_1]);
  initMetadataForClass(TypedKnowledgeSourceReferenceImpl, 'TypedKnowledgeSourceReferenceImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, KnowledgeSourceReference]);
  initMetadataForClass(TypedKnowledgeSourceReferencePlaceholderImpl, 'TypedKnowledgeSourceReferencePlaceholderImpl', VOID, TypedKnowledgeSourceReferenceImpl, [TypedKnowledgeSourceReferenceImpl, KnowledgeSourceReferencePlaceholder_1]);
  initMetadataForClass(TypedLibraryItemPlaceholderImpl, 'TypedLibraryItemPlaceholderImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, LibraryItemPlaceholder_1]);
  initMetadataForClass(TypedLibraryProcessSpecificationImpl, 'TypedLibraryProcessSpecificationImpl', VOID, TypedAbstractProcessSpecificationImpl, [TypedAbstractProcessSpecificationImpl, LibraryProcessSpecification_1]);
  initMetadataForClass(TypedLibraryProcessSpecificationQueryImpl, 'TypedLibraryProcessSpecificationQueryImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, LibraryProcessSpecificationQuery_1]);
  initMetadataForClass(TypedLinkCustomCellImpl, 'TypedLinkCustomCellImpl', VOID, TypedCustomCellImpl, [TypedCustomCellImpl, LinkCustomCell_1]);
  initMetadataForClass(TypedLinkDeclarationImpl, 'TypedLinkDeclarationImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, LinkDeclaration_1]);
  initMetadataForClass(TypedLinkLibraryImpl, 'TypedLinkLibraryImpl', VOID, TypedDocumentNodeImpl, [TypedDocumentNodeImpl, LinkLibrary_1]);
  initMetadataForClass(TypedLocalOntologyElementReferenceImpl, 'TypedLocalOntologyElementReferenceImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, LocalOntologyElementReference_1]);
  initMetadataForClass(TypedMeasurableNotionImpl, 'TypedMeasurableNotionImpl', VOID, TypedAbstractNotionImpl, [TypedAbstractNotionImpl, MeasurableNotion_1]);
  initMetadataForClass(TypedMeasurableValueImpl, 'TypedMeasurableValueImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, MeasurableValue_1]);
  initMetadataForClass(TypedMeasurementUnitImpl, 'TypedMeasurementUnitImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, MeasurementUnit_1]);
  initMetadataForClass(TypedModifierContainerImpl, 'TypedModifierContainerImpl', VOID, TypedDocumentNodeImpl, [TypedDocumentNodeImpl, ModifierContainer]);
  initMetadataForClass(TypedModifierDeclarationImpl, 'TypedModifierDeclarationImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, ModifierDeclaration]);
  initMetadataForClass(TypedModifierFactExpressionImpl, 'TypedModifierFactExpressionImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, ModifierFactExpression_0]);
  initMetadataForClass(TypedMultilineTextImpl, 'TypedMultilineTextImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, MultilineText]);
  initMetadataForClass(TypedMultipleProcessPropertyValueRangeImpl, 'TypedMultipleProcessPropertyValueRangeImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, MultipleProcessPropertyValueRange_1]);
  initMetadataForClass(TypedPropertyValueRangeImpl, 'TypedPropertyValueRangeImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, PropertyValueRange]);
  initMetadataForClass(TypedMultiplePropertyValueRangeImpl, 'TypedMultiplePropertyValueRangeImpl', VOID, TypedPropertyValueRangeImpl, [TypedPropertyValueRangeImpl, MultiplePropertyValueRange_1]);
  initMetadataForClass(TypedMultipliedExpressionImpl, 'TypedMultipliedExpressionImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, MultipliedExpression_1]);
  initMetadataForClass(TypedNewFactImpl, 'TypedNewFactImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, NewFact]);
  initMetadataForClass(TypedNewFactReferenceImpl, 'TypedNewFactReferenceImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, NewFactReference_0]);
  initMetadataForClass(TypedNoValuesImpl, 'TypedNoValuesImpl', VOID, TypedPropertyValueRangeImpl, [TypedPropertyValueRangeImpl, NoValues_1]);
  initMetadataForClass(TypedNotionLibraryImpl, 'TypedNotionLibraryImpl', VOID, TypedDocumentNodeImpl, [TypedDocumentNodeImpl, NotionLibrary_1]);
  initMetadataForClass(TypedNotionPlaceholderImpl, 'TypedNotionPlaceholderImpl', VOID, TypedAbstractNotionImpl, [TypedAbstractNotionImpl, NotionPlaceholder_1]);
  initMetadataForClass(TypedNotionTypeImpl, 'TypedNotionTypeImpl', VOID, TypedTypeImpl, [TypedTypeImpl, NotionType_0]);
  initMetadataForClass(TypedObjectPropertiesLibraryImpl, 'TypedObjectPropertiesLibraryImpl', VOID, TypedDocumentNodeImpl, [TypedDocumentNodeImpl, ObjectPropertiesLibrary]);
  initMetadataForClass(TypedObjectPropertyDeclarationImpl, 'TypedObjectPropertyDeclarationImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, ObjectPropertyDeclaration_1]);
  initMetadataForClass(TypedObjectPropertyReferenceValueImpl, 'TypedObjectPropertyReferenceValueImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, ObjectPropertyReferenceValue_1]);
  initMetadataForClass(TypedOldPublishedSourceImpl, 'TypedOldPublishedSourceImpl', VOID, TypedPublishedWorkImpl, [TypedPublishedWorkImpl, OldPublishedSource]);
  initMetadataForClass(TypedOneOfImpl, 'TypedOneOfImpl', VOID, TypedTypeImpl, [TypedTypeImpl, OneOf_1]);
  initMetadataForClass(TypedOntologyCardinalityRelationImpl, 'TypedOntologyCardinalityRelationImpl', VOID, TypedAbstractOntologyRelationImpl, [TypedAbstractOntologyRelationImpl, OntologyCardinalityRelation_1]);
  initMetadataForClass(TypedOntologyElementDefinitionImpl, 'TypedOntologyElementDefinitionImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, OntologyElementDefinition_1]);
  initMetadataForClass(TypedOntologyElementImpl, 'TypedOntologyElementImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, OntologyElement_1]);
  initMetadataForClass(TypedOntologyElementPropertyTypeImpl, 'TypedOntologyElementPropertyTypeImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, OntologyElementPropertyType_1]);
  initMetadataForClass(TypedOntologyElementReferenceImpl, 'TypedOntologyElementReferenceImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, OntologyElementReference_1]);
  initMetadataForClass(TypedOntologyElementReferenceValueImpl, 'TypedOntologyElementReferenceValueImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, OntologyElementReferenceValue_1]);
  initMetadataForClass(TypedOntologyElementReferenceValueLibraryImpl, 'TypedOntologyElementReferenceValueLibraryImpl', VOID, TypedOntologyElementReferenceValueImpl, [TypedOntologyElementReferenceValueImpl, OntologyElementReferenceValueLibrary_1]);
  initMetadataForClass(TypedOntologyElementSynonymImpl, 'TypedOntologyElementSynonymImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, OntologyElementSynonym_1]);
  initMetadataForClass(TypedOntologyElementTypeImpl, 'TypedOntologyElementTypeImpl', VOID, TypedTypeImpl, [TypedTypeImpl, OntologyElementType_1]);
  initMetadataForClass(TypedOntologyImportImpl, 'TypedOntologyImportImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, OntologyImport_1]);
  initMetadataForClass(TypedOntologyImportRootImpl, 'TypedOntologyImportRootImpl', VOID, TypedDocumentNodeImpl, [TypedDocumentNodeImpl, OntologyImportRoot_1]);
  initMetadataForClass(TypedOntologyImportRootReferenceImpl, 'TypedOntologyImportRootReferenceImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, OntologyImportRootReference_1]);
  initMetadataForClass(TypedOntologyIsRelationImpl, 'TypedOntologyIsRelationImpl', VOID, TypedAbstractOntologyRelationImpl, [TypedAbstractOntologyRelationImpl, OntologyIsRelation_1]);
  initMetadataForClass(TypedOntologyLibraryImpl, 'TypedOntologyLibraryImpl', VOID, TypedDocumentNodeImpl, [TypedDocumentNodeImpl, OntologyLibrary_1]);
  initMetadataForClass(TypedOntologyLibraryReferenceImpl, 'TypedOntologyLibraryReferenceImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, OntologyLibraryReference_1]);
  initMetadataForClass(TypedOntologyLinkDeclarationValueQueryImpl, 'TypedOntologyLinkDeclarationValueQueryImpl', VOID, TypedDeclarationValueQueryImpl, [TypedDeclarationValueQueryImpl, OntologyLinkDeclarationValueQuery_1]);
  initMetadataForClass(TypedOntologyLinkImpl, 'TypedOntologyLinkImpl', VOID, TypedAbstractLinkImpl, [TypedAbstractLinkImpl, OntologyLink_1]);
  initMetadataForClass(TypedOntologyLinkValueImpl, 'TypedOntologyLinkValueImpl', VOID, TypedAbstractBindingValueImpl, [TypedAbstractBindingValueImpl, OntologyLinkValue_1]);
  initMetadataForClass(TypedOrValueQueryImpl, 'TypedOrValueQueryImpl', VOID, TypedAbstractBindingValueQueryImpl, [TypedAbstractBindingValueQueryImpl, OrValueQuery_1]);
  initMetadataForClass(TypedPageSpecificationImpl, 'TypedPageSpecificationImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, PageSpecification]);
  initMetadataForClass(TypedPageImpl, 'TypedPageImpl', VOID, TypedPageSpecificationImpl, [TypedPageSpecificationImpl, Page_1]);
  initMetadataForClass(TypedPageRangeImpl, 'TypedPageRangeImpl', VOID, TypedPageSpecificationImpl, [TypedPageSpecificationImpl, PageRange_1]);
  initMetadataForClass(TypedPaperImpl, 'TypedPaperImpl', VOID, TypedPublishedWorkImpl, [TypedPublishedWorkImpl, Paper_1]);
  initMetadataForClass(TypedPartValueImpl, 'TypedPartValueImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, PartValue]);
  initMetadataForClass(TypedPatternImpl, 'TypedPatternImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, Pattern]);
  initMetadataForClass(TypedPrimitiveNotionTypeImpl, 'TypedPrimitiveNotionTypeImpl', VOID, TypedTypeImpl, [TypedTypeImpl, PrimitiveNotionType_1]);
  initMetadataForClass(TypedPrimitivePropertyTypeImpl, 'TypedPrimitivePropertyTypeImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, PrimitivePropertyType_1]);
  initMetadataForClass(TypedProcessDeclarationImpl, 'TypedProcessDeclarationImpl', VOID, TypedAbstractBindingDeclarationImpl, [TypedAbstractBindingDeclarationImpl, ProcessDeclaration_1]);
  initMetadataForClass(TypedProcessEffectImpl, 'TypedProcessEffectImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, ProcessEffect_0]);
  initMetadataForClass(TypedProcessKindContainerImpl, 'TypedProcessKindContainerImpl', VOID, TypedDocumentNodeImpl, [TypedDocumentNodeImpl, ProcessKindContainer_1]);
  initMetadataForClass(TypedProcessKindImpl, 'TypedProcessKindImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, ProcessKind_1]);
  initMetadataForClass(TypedProcessLibraryImpl, 'TypedProcessLibraryImpl', VOID, TypedDocumentNodeImpl, [TypedDocumentNodeImpl, ProcessLibrary_1]);
  initMetadataForClass(TypedProcessPrerequisiteImpl, 'TypedProcessPrerequisiteImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, ProcessPrerequisite_0]);
  initMetadataForClass(TypedProcessPropertyCustomCellImpl, 'TypedProcessPropertyCustomCellImpl', VOID, TypedCustomCellImpl, [TypedCustomCellImpl, ProcessPropertyCustomCell_1]);
  initMetadataForClass(TypedProcessPropertyDefaultImpl, 'TypedProcessPropertyDefaultImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, ProcessPropertyDefault_1]);
  initMetadataForClass(TypedProcessPropertyImpl, 'TypedProcessPropertyImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, ProcessProperty_1]);
  initMetadataForClass(TypedVariableInitializerImpl, 'TypedVariableInitializerImpl', VOID, TypedVariableSpecificationImpl, [TypedVariableSpecificationImpl, VariableInitializer]);
  initMetadataForClass(TypedProcessPropertyReferenceImpl, 'TypedProcessPropertyReferenceImpl', VOID, TypedVariableInitializerImpl, [TypedVariableInitializerImpl, ProcessPropertyReference]);
  initMetadataForClass(TypedProcessPropertyValueImpl, 'TypedProcessPropertyValueImpl', VOID, TypedBindingValuePlaceholderImpl, [TypedBindingValuePlaceholderImpl, ProcessPropertyValue_1]);
  initMetadataForClass(TypedProcessReferenceImpl, 'TypedProcessReferenceImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, ProcessReference_1]);
  initMetadataForClass(TypedProcessRelationDeclarationImpl, 'TypedProcessRelationDeclarationImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, ProcessRelationDeclaration_1]);
  initMetadataForClass(TypedProcessTypeImpl, 'TypedProcessTypeImpl', VOID, TypedTypeImpl, [TypedTypeImpl, ProcessType_1]);
  initMetadataForClass(TypedPropertiesCustomCellImpl, 'TypedPropertiesCustomCellImpl', VOID, TypedCustomCellImpl, [TypedCustomCellImpl, PropertiesCustomCell_1]);
  initMetadataForClass(TypedPropertyConstraintImpl, 'TypedPropertyConstraintImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, PropertyConstraint_1]);
  initMetadataForClass(TypedPropertyCustomCellImpl, 'TypedPropertyCustomCellImpl', VOID, TypedCustomCellImpl, [TypedCustomCellImpl, PropertyCustomCell_1]);
  initMetadataForClass(TypedPropertyDeclarationImpl, 'TypedPropertyDeclarationImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, PropertyDeclaration_1]);
  initMetadataForClass(TypedPropertyDeclarationValueQueryImpl, 'TypedPropertyDeclarationValueQueryImpl', VOID, TypedDeclarationValueQueryImpl, [TypedDeclarationValueQueryImpl, PropertyDeclarationValueQuery_1]);
  initMetadataForClass(TypedPropertyLibraryImpl, 'TypedPropertyLibraryImpl', VOID, TypedDocumentNodeImpl, [TypedDocumentNodeImpl, PropertyLibrary_1]);
  initMetadataForClass(TypedPropertyReferenceOperationImpl, 'TypedPropertyReferenceOperationImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, PropertyReferenceOperation_1]);
  initMetadataForClass(TypedPropertyValueImpl, 'TypedPropertyValueImpl', VOID, TypedAbstractBindingValueImpl, [TypedAbstractBindingValueImpl, PropertyValue_1]);
  initMetadataForClass(TypedPubMedSourceReferenceImpl, 'TypedPubMedSourceReferenceImpl', VOID, TypedKnowledgeSourceReferenceImpl, [TypedKnowledgeSourceReferenceImpl, PubMedSourceReference_1]);
  initMetadataForClass(TypedPublishedSourceReferenceImpl, 'TypedPublishedSourceReferenceImpl', VOID, TypedKnowledgeSourceReferenceImpl, [TypedKnowledgeSourceReferenceImpl, PublishedSourceReference_1]);
  initMetadataForClass(TypedPublishedSourcesLibraryImpl, 'TypedPublishedSourcesLibraryImpl', VOID, TypedDocumentNodeImpl, [TypedDocumentNodeImpl, PublishedSourcesLibrary_1]);
  initMetadataForClass(TypedQualifiedOntologyElementReferenceImpl, 'TypedQualifiedOntologyElementReferenceImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, QualifiedOntologyElementReference_1]);
  initMetadataForClass(TypedQueryCommandsImpl, 'TypedQueryCommandsImpl', VOID, TypedDocumentNodeImpl, [TypedDocumentNodeImpl, QueryCommands_1]);
  initMetadataForClass(TypedQueryLabelsFactExpressionContainerImpl, 'TypedQueryLabelsFactExpressionContainerImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, QueryLabelsFactExpressionContainer_0]);
  initMetadataForClass(TypedQueryParametersBlackListImpl, 'TypedQueryParametersBlackListImpl', VOID, TypedDocumentNodeImpl, [TypedDocumentNodeImpl, QueryParametersBlackList]);
  initMetadataForClass(TypedRelationContainerImpl, 'TypedRelationContainerImpl', VOID, TypedDocumentNodeImpl, [TypedDocumentNodeImpl, RelationContainer_1]);
  initMetadataForClass(TypedRelationFactExpressionImpl, 'TypedRelationFactExpressionImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, RelationFactExpression_1]);
  initMetadataForClass(TypedReturnTypeCustomCellImpl, 'TypedReturnTypeCustomCellImpl', VOID, TypedCustomCellImpl, [TypedCustomCellImpl, ReturnTypeCustomCell_1]);
  initMetadataForClass(TypedSetExpressionImpl, 'TypedSetExpressionImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, SetExpression_1]);
  initMetadataForClass(TypedSetValuedPropertyParameterImpl, 'TypedSetValuedPropertyParameterImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, SetValuedPropertyParameter_1]);
  initMetadataForClass(TypedSimplePropertyTypeImpl, 'TypedSimplePropertyTypeImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, SimplePropertyType]);
  initMetadataForClass(TypedSinglePropertyValueRangeImpl, 'TypedSinglePropertyValueRangeImpl', VOID, TypedPropertyValueRangeImpl, [TypedPropertyValueRangeImpl, SinglePropertyValueRange_1]);
  initMetadataForClass(TypedStringValueImpl, 'TypedStringValueImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, StringValue_1]);
  initMetadataForClass(TypedTextLineImpl, 'TypedTextLineImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, TextLine]);
  initMetadataForClass(TypedTypePlaceholderImpl, 'TypedTypePlaceholderImpl', VOID, TypedTypeImpl, [TypedTypeImpl, TypePlaceholder_1]);
  function get_getClassDeclaration_0() {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new AnonymousClass$getClassDeclaration$$inlined$suspendingQuery$1(this);
  }
  initMetadataForInterface(AnonymousClass, 'AnonymousClass', VOID, VOID, [ClassExpression, ClassDeclaration, AbstractValue, FactExpression]);
  initMetadataForInterface(UnionClass_1, 'UnionClass', VOID, VOID, [AnonymousClass]);
  initMetadataForClass(TypedUnionClassImpl, 'TypedUnionClassImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, UnionClass_1]);
  initMetadataForInterface(UnknownComplexNotionValue_1, 'UnknownComplexNotionValue', VOID, VOID, [AllowedComplexNotionValue]);
  initMetadataForClass(TypedUnknownComplexNotionValueImpl, 'TypedUnknownComplexNotionValueImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, UnknownComplexNotionValue_1]);
  initMetadataForInterface(Url_1, 'Url', VOID, VOID, [BTBNode]);
  initMetadataForClass(TypedUrlImpl, 'TypedUrlImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, Url_1]);
  initMetadataForInterface(UrlKnowledgeSourceReference_1, 'UrlKnowledgeSourceReference', VOID, VOID, [KnowledgeSourceReference]);
  initMetadataForClass(TypedUrlKnowledgeSourceReferenceImpl, 'TypedUrlKnowledgeSourceReferenceImpl', VOID, TypedKnowledgeSourceReferenceImpl, [TypedKnowledgeSourceReferenceImpl, UrlKnowledgeSourceReference_1]);
  initMetadataForInterface(ValueWithRelations, 'ValueWithRelations', VOID, VOID, [AbstractValue]);
  initMetadataForClass(TypedValueWithRelationsImpl, 'TypedValueWithRelationsImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, ValueWithRelations]);
  initMetadataForInterface(VariableDeclaration_1, 'VariableDeclaration', VOID, VOID, [BTBNode, DirectlyNamed, HasQueryLabels, HasPropertyConstraints]);
  initMetadataForClass(TypedVariableDeclarationImpl, 'TypedVariableDeclarationImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, VariableDeclaration_1]);
  initMetadataForInterface(VariablePattern_1, 'VariablePattern', VOID, VOID, [Pattern]);
  initMetadataForClass(TypedVariablePatternImpl, 'TypedVariablePatternImpl', VOID, TypedPatternImpl, [TypedPatternImpl, VariablePattern_1]);
  initMetadataForInterface(VariableReferenceValue_1, 'VariableReferenceValue', VOID, VOID, [AbstractValue, FactExpression, VariableInitializer]);
  initMetadataForClass(TypedVariableReferenceValueImpl, 'TypedVariableReferenceValueImpl', VOID, TypedVariableInitializerImpl, [TypedVariableInitializerImpl, VariableReferenceValue_1]);
  initMetadataForInterface(XRefContainer, 'XRefContainer', VOID, VOID, [BTBNode]);
  initMetadataForClass(TypedXRefContainerImpl, 'TypedXRefContainerImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, XRefContainer]);
  initMetadataForClass(UnionClassImpl, 'UnionClassImpl', VOID, BTBNodeImpl, [BTBNodeImpl, UnionClass_1]);
  initMetadataForClass(UnknownComplexNotionValueImpl, 'UnknownComplexNotionValueImpl', VOID, BTBNodeImpl, [BTBNodeImpl, UnknownComplexNotionValue_1]);
  initMetadataForClass(UrlImpl, 'UrlImpl', VOID, BTBNodeImpl, [BTBNodeImpl, Url_1]);
  initMetadataForClass(UrlKnowledgeSourceReferenceImpl, 'UrlKnowledgeSourceReferenceImpl', VOID, KnowledgeSourceReferenceImpl, [KnowledgeSourceReferenceImpl, UrlKnowledgeSourceReference_1]);
  initMetadataForClass(ValueWithRelationsImpl, 'ValueWithRelationsImpl', VOID, BTBNodeImpl, [BTBNodeImpl, ValueWithRelations]);
  initMetadataForClass(VariableDeclarationImpl, 'VariableDeclarationImpl', VOID, BTBNodeImpl, [BTBNodeImpl, VariableDeclaration_1]);
  initMetadataForClass(VariablePatternImpl, 'VariablePatternImpl', VOID, PatternImpl, [PatternImpl, VariablePattern_1]);
  initMetadataForClass(VariableReferenceValueImpl, 'VariableReferenceValueImpl', VOID, VariableInitializerImpl, [VariableInitializerImpl, VariableReferenceValue_1]);
  initMetadataForClass(XRefContainerImpl, 'XRefContainerImpl', VOID, BTBNodeImpl, [BTBNodeImpl, XRefContainer]);
  initMetadataForObject(LinkStubConcept, 'LinkStubConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(NotionStubConcept, 'NotionStubConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(PropertyStubConcept, 'PropertyStubConcept', VOID, OtConceptDescriptor);
  function get_specializes() {
    throw UnsupportedOperationException_init_$Create$();
  }
  function get_element_2() {
    throw UnsupportedOperationException_init_$Create$();
  }
  function get_specificator_1() {
    throw UnsupportedOperationException_init_$Create$();
  }
  initMetadataForInterface(LinkStub, 'LinkStub', VOID, VOID, [AbstractLink, ExternallyNamed]);
  initMetadataForClass(LinkStubImpl, 'LinkStubImpl', VOID, AbstractLinkImpl, [AbstractLinkImpl, LinkStub]);
  initMetadataForInterface(NotionStub, 'NotionStub', VOID, VOID, [AbstractNotion, DirectlyNamed]);
  initMetadataForClass(NotionStubImpl, 'NotionStubImpl', VOID, AbstractNotionImpl, [AbstractNotionImpl, NotionStub]);
  initMetadataForInterface(PropertyStub, 'PropertyStub', VOID, VOID, [AbstractProperty, ExternallyNamed]);
  initMetadataForClass(PropertyStubImpl, 'PropertyStubImpl', VOID, AbstractPropertyImpl, [AbstractPropertyImpl, PropertyStub]);
  initMetadataForClass(TypedLinkStubImpl, 'TypedLinkStubImpl', VOID, TypedAbstractLinkImpl, [TypedAbstractLinkImpl, LinkStub]);
  initMetadataForClass(TypedNotionStubImpl, 'TypedNotionStubImpl', VOID, TypedAbstractNotionImpl, [TypedAbstractNotionImpl, NotionStub]);
  initMetadataForClass(TypedPropertyStubImpl, 'TypedPropertyStubImpl', VOID, TypedAbstractPropertyImpl, [TypedAbstractPropertyImpl, PropertyStub]);
  initMetadataForObject(DirectlyNamedConcept, 'DirectlyNamedConcept', VOID, OTAbstractConceptDescriptor);
  initMetadataForObject(DocumentNodeConcept_0, 'DocumentNodeConcept', VOID, OTAbstractConceptDescriptor);
  initMetadataForCoroutine($runSuspendCOROUTINE$_40, CoroutineImpl);
  initMetadataForClass(BTBDocument$librariesForElement$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForCompanion(Companion_311);
  initMetadataForCompanion(Companion_312);
  initMetadataForCompanion(Companion_313);
  initMetadataForClass(When, 'When', VOID, Enum);
  initMetadataForCompanion(Companion_314);
  initMetadataForCompanion(Companion_315);
  initMetadataForCompanion(Companion_316);
  initMetadataForCompanion(Companion_317);
  initMetadataForClass(BTBNodePersister, 'BTBNodePersister', VOID, DomainNodePersister);
  initMetadataForClass(BtbOtNodePersister, 'BtbOtNodePersister', VOID, VOID, [Persister]);
  initMetadataForClass(NodeWithName, 'NodeWithName');
  initMetadataForCompanion(Companion_318);
  initMetadataForClass(AnonymousClass$getClassDeclaration$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForCompanion(Companion_319);
  initMetadataForCompanion(Companion_320);
  initMetadataForCompanion(Companion_321);
  initMetadataForCompanion(Companion_322);
  initMetadataForCompanion(Companion_323);
  initMetadataForCompanion(Companion_324);
  initMetadataForCompanion(Companion_325);
  initMetadataForCompanion(Companion_326);
  initMetadataForClass(CardinalitySpecificator, 'CardinalitySpecificator', VOID, Enum);
  initMetadataForCompanion(Companion_327);
  initMetadataForCompanion(Companion_328);
  initMetadataForCompanion(Companion_329);
  initMetadataForClass(LinkTypeSpecificator, 'LinkTypeSpecificator', VOID, Enum);
  initMetadataForCoroutine($runSuspendCOROUTINE$_41, CoroutineImpl);
  initMetadataForClass(OntologyLink$name$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(OntologyLink$element$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(OntologyLink$specificator$$inlined$query$1, VOID, VOID, VOID, [Query], [1]);
  initMetadataForCoroutine($runSuspendCOROUTINE$_42, CoroutineImpl);
  initMetadataForCoroutine($runSuspendCOROUTINE$_43, CoroutineImpl);
  initMetadataForCoroutine($runSuspendCOROUTINE$_44, CoroutineImpl);
  initMetadataForCompanion(Companion_330);
  initMetadataForClass(ImportedLink$name$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(ImportedLink$specificator$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(ImportedLink$element$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForCoroutine($runSuspendCOROUTINE$_45, CoroutineImpl);
  initMetadataForCompanion(Companion_331);
  initMetadataForClass(OntologyLinkValue$importedLibraries$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForCompanion(Companion_332);
  initMetadataForCompanion(Companion_333);
  initMetadataForCompanion(Companion_334);
  initMetadataForClass(ConstraintOperation, 'ConstraintOperation', VOID, Enum);
  initMetadataForCompanion(Companion_335);
  initMetadataForCompanion(Companion_336);
  initMetadataForCoroutine($runSuspendCOROUTINE$_46, CoroutineImpl);
  initMetadataForClass(OntologyElementReferenceProvider$getClassDeclaration$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForCoroutine($runSuspendCOROUTINE$_47, CoroutineImpl);
  initMetadataForClass(OntologyElement$allTaxonElements$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForCompanion(Companion_337);
  initMetadataForClass(QualifiedOntologyElementReference$element$$inlined$executeQuery$1, VOID, VOID, VOID, [Query], [1]);
  initMetadataForClass(OntologyIsRelation$getElementReference$$inlined$executeQuery$1, VOID, VOID, VOID, [Query], [1]);
  initMetadataForCoroutine($runSuspendCOROUTINE$_48, CoroutineImpl);
  initMetadataForCoroutine($runSuspendCOROUTINE$_49, CoroutineImpl);
  initMetadataForCoroutine($runSuspendCOROUTINE$_50, CoroutineImpl);
  initMetadataForCoroutine($runSuspendCOROUTINE$_51, CoroutineImpl);
  initMetadataForCoroutine($runSuspendCOROUTINE$_52, CoroutineImpl);
  initMetadataForCoroutine($runSuspendCOROUTINE$_53, CoroutineImpl);
  initMetadataForCompanion(Companion_338);
  initMetadataForClass(ProcessDeclaration$aliasedProperties$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(ProcessDeclaration$allSuperProperties$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(ProcessDeclaration$allInheritedProcesses$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(ProcessDeclaration$cycleInExtends$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(ProcessDeclaration$allEntries$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(ProcessDeclaration$allProperties$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForCompanion(Companion_339);
  initMetadataForCompanion(Companion_340);
  initMetadataForCompanion(Companion_341);
  initMetadataForClass(ProcessPropertyType$type$$inlined$query$1, VOID, VOID, VOID, [Query], [1]);
  initMetadataForCompanion(Companion_342);
  initMetadataForCompanion(Companion_343);
  initMetadataForClass(BindingProperty$name$$inlined$query$1, VOID, VOID, VOID, [Query], [1]);
  initMetadataForClass(BindingProperty$type$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForCoroutine($runSuspendCOROUTINE$_54, CoroutineImpl);
  initMetadataForCoroutine($runSuspendCOROUTINE$_55, CoroutineImpl);
  initMetadataForCompanion(Companion_344);
  initMetadataForClass(ImportedProperty$name$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(ImportedProperty$type$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(PropertyLibrary$properties$$inlined$map$1, VOID, VOID, VOID, [Query], [1]);
  initMetadataForClass(PublishedWork$citation$$inlined$query$1, VOID, VOID, VOID, [Query], [1]);
  initMetadataForClass(PublishedWork$authorsPart$$inlined$query$1, VOID, VOID, VOID, [Query], [1]);
  initMetadataForCompanion(Companion_345);
  initMetadataForCompanion(Companion_346);
  initMetadataForCompanion(Companion_347);
  initMetadataForCompanion(Companion_348);
  initMetadataForCompanion(Companion_349);
  initMetadataForCompanion(Companion_350);
  initMetadataForClass(ProcessRelationDeclaration$isValid$$inlined$query$1, VOID, VOID, VOID, [Query], [1]);
  initMetadataForClass(RelationDirection, 'RelationDirection', VOID, Enum);
  initMetadataForClass(RelationEffect, 'RelationEffect', VOID, Enum);
  initMetadataForCompanion(Companion_351);
  initMetadataForClass(PrimitiveKind_0, 'PrimitiveKind', VOID, Enum);
  initMetadataForCompanion(Companion_352);
  initMetadataForCompanion(Companion_353);
  initMetadataForCompanion(Companion_354);
  initMetadataForClass(PartValue$transformToVariableReference$$inlined$executeQuery$1, VOID, VOID, VOID, [Query], [1]);
  initMetadataForClass(ObjectPropertyReferenceValue$removePropertyReference$$inlined$executeQuery$1, VOID, VOID, VOID, [Query], [1]);
  initMetadataForCompanion(Companion_355);
  initMetadataForCompanion(Companion_356);
  function toMultiplierText() {
    var tmp;
    if (equals(this, ImplicitOne_instance)) {
      tmp = '';
    } else {
      if (equals(this, Unknown_instance)) {
        tmp = 'N';
      } else {
        if (this instanceof Exact) {
          tmp = this.hlv_1.toString();
        } else {
          noWhenBranchMatchedException();
        }
      }
    }
    return tmp;
  }
  initMetadataForInterface(MultiplierValue, 'MultiplierValue');
  initMetadataForObject(ImplicitOne, 'ImplicitOne', VOID, VOID, [MultiplierValue]);
  initMetadataForObject(Unknown, 'Unknown', VOID, VOID, [MultiplierValue]);
  initMetadataForClass(Exact, 'Exact', VOID, VOID, [MultiplierValue]);
  initMetadataForCompanion(Companion_357);
  initMetadataForClass(BTBConfigurationBuilder, 'BTBConfigurationBuilder');
  initMetadataForClass(RemoteDocumentClient, 'RemoteDocumentClient');
  initMetadataForClass(btbErrorChecking$2$6$$inlined$query$1, VOID, VOID, VOID, [Query], [1]);
  initMetadataForCoroutine($runSuspendCOROUTINE$_56, CoroutineImpl);
  initMetadataForClass(btbErrorChecking$2$8$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(btbErrorChecking$2$10$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForCoroutine($runSuspendCOROUTINE$_57, CoroutineImpl);
  initMetadataForClass(btbErrorChecking$2$12$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(btbErrorChecking$2$14$$inlined$query$1, VOID, VOID, VOID, [Query], [1]);
  initMetadataForCoroutine($runSuspendCOROUTINE$_58, CoroutineImpl);
  initMetadataForClass(btbErrorChecking$2$16$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(btbErrorChecking$2$18$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(btbErrorChecking$2$20$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForCoroutine($runSuspendCOROUTINE$_59, CoroutineImpl);
  initMetadataForClass(btbErrorChecking$2$22$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForCoroutine($runSuspendCOROUTINE$_60, CoroutineImpl);
  initMetadataForClass(btbErrorChecking$2$40$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForCoroutine($runSuspendCOROUTINE$_61, CoroutineImpl);
  initMetadataForClass(btbErrorChecking$2$52$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(btbErrorChecking$2$54$$inlined$query$1, VOID, VOID, VOID, [Query], [1]);
  initMetadataForCoroutine($runSuspendCOROUTINE$_62, CoroutineImpl);
  initMetadataForClass(btbErrorChecking$2$56$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForCoroutine($runSuspendCOROUTINE$_63, CoroutineImpl);
  initMetadataForClass(btbErrorChecking$2$58$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(btbErrorChecking$2$60$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(btbErrorChecking$2$72$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForCoroutine($runSuspendCOROUTINE$_64, CoroutineImpl);
  initMetadataForClass(btbErrorChecking$2$74$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForCoroutine($runSuspendCOROUTINE$_65, CoroutineImpl);
  initMetadataForClass(btbErrorChecking$2$76$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForCoroutine($runSuspendCOROUTINE$_66, CoroutineImpl);
  initMetadataForClass(checkNewFact$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForCoroutine($runSuspendCOROUTINE$_67, CoroutineImpl);
  initMetadataForClass(checkOntologyElement$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(checkOntologyElementDefinition$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(checkProcessRelationDeclaration$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(duplicatesBy$$inlined$query$1, VOID, VOID, VOID, [Query], [1]);
  initMetadataForCoroutine($checkForCycleInVariableSpecsCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($checkForDuplicatePropertiesInConstraintsCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($checkPropertyConstraintOperationCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($checkForCycleInProcessDefaultsCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($isProcessExpressionCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($checkProcessRelationCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($checkPropertyConstraintOperation$isPropertyRangeMultipleCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($runSuspendCOROUTINE$_68, CoroutineImpl);
  initMetadataForCoroutine($runSuspendCOROUTINE$_69, CoroutineImpl);
  initMetadataForCoroutine($runSuspendCOROUTINE$_70, CoroutineImpl);
  initMetadataForClass(OntologyProcessor$checkErrors$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(OntologyProcessor$detectDefinitionCycles$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(OntologyProcessor$analyzeSupertypes$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(OntologyProcessor, 'OntologyProcessor');
  initMetadataForClass(SupertypeTraversalResult, 'SupertypeTraversalResult');
  initMetadataForCoroutine($runSuspendCOROUTINE$_71, CoroutineImpl);
  initMetadataForCoroutine($runSuspendCOROUTINE$_72, CoroutineImpl);
  initMetadataForClass(SupertypeGraphAnalyzer$enqueue$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(SupertypeGraphAnalyzer$analyze$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(SupertypeGraphAnalyzer, 'SupertypeGraphAnalyzer');
  initMetadataForCoroutine($runSuspendCOROUTINE$_73, CoroutineImpl);
  initMetadataForClass(resolveSuperElement$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForObject(ReferenceAspects, 'ReferenceAspects');
  initMetadataForClass(OntologyElementUsageByAnotherElement, 'OntologyElementUsageByAnotherElement', VOID, UsagePresentationData);
  initMetadataForClass(OntologyElementRelatedToAnotherElementUsage, 'OntologyElementRelatedToAnotherElementUsage', VOID, OntologyElementUsageByAnotherElement);
  initMetadataForClass(SuperElementUsage, 'SuperElementUsage', VOID, OntologyElementRelatedToAnotherElementUsage);
  initMetadataForClass(PartOfElementUsage, 'PartOfElementUsage', VOID, OntologyElementRelatedToAnotherElementUsage);
  initMetadataForClass(ElementsTaxonUsage, 'ElementsTaxonUsage', VOID, OntologyElementUsageByAnotherElement);
  initMetadataForClass(CategoryOntologyUsage, 'CategoryOntologyUsage', VOID, UsagePresentationData);
  initMetadataForClass(FactSetContextOntologyUsage, 'FactSetContextOntologyUsage', VOID, UsagePresentationData);
  initMetadataForClass(SomethingAsVariableSpecUsage, 'SomethingAsVariableSpecUsage', VOID, UsagePresentationData);
  initMetadataForClass(AnyUsageInFact, 'AnyUsageInFact', VOID, UsagePresentationData);
  initMetadataForClass(UsageInProcess, 'UsageInProcess', VOID, UsagePresentationData);
  initMetadataForClass(ProcessKindUsage, 'ProcessKindUsage', VOID, UsageInProcess);
  initMetadataForClass(ExtendedProcessUsage, 'ExtendedProcessUsage', VOID, UsageInProcess);
  initMetadataForClass(UsageInBindingDeclaration, 'UsageInBindingDeclaration', VOID, UsagePresentationData);
  initMetadataForClass(OntologyElementInBindingDeclarationUsage, 'OntologyElementInBindingDeclarationUsage', VOID, UsageInBindingDeclaration);
  initMetadataForClass(InheritedProcessUsage, 'InheritedProcessUsage', VOID, UsageInProcess);
  initMetadataForClass(AnythingInsideCustomEditorUsage, 'AnythingInsideCustomEditorUsage', VOID, UsageInBindingDeclaration);
  initMetadataForClass(UsageInBindingProperty, 'UsageInBindingProperty', VOID, UsagePresentationData);
  initMetadataForClass(AliasedBindingPropertyUsage, 'AliasedBindingPropertyUsage', VOID, UsageInBindingProperty);
  initMetadataForClass(PropertyTypeUsage, 'PropertyTypeUsage', VOID, UsageInBindingProperty);
  initMetadataForClass(OldPropertyTypeNotionUsage, 'OldPropertyTypeNotionUsage', VOID, UsageInBindingDeclaration);
  initMetadataForClass(OldLinkOntologyUsage, 'OldLinkOntologyUsage', VOID, UsageInBindingDeclaration);
  initMetadataForClass(OntologyInFunctionReturnTypeUsage, 'OntologyInFunctionReturnTypeUsage', VOID, UsagePresentationData);
  initMetadataForClass(OldImportedPropertyUsage, 'OldImportedPropertyUsage', VOID, UsageInBindingDeclaration);
  initMetadataForClass(OldImportedLinkUsage, 'OldImportedLinkUsage', VOID, UsageInBindingDeclaration);
  initMetadataForClass(UsageInOntologyImport, 'UsageInOntologyImport', VOID, UsagePresentationData);
  initMetadataForClass(InOntologyImportForOntologyUsage, 'InOntologyImportForOntologyUsage', VOID, UsageInOntologyImport);
  initMetadataForClass(InOntologyImportOntologyToUseUsage, 'InOntologyImportOntologyToUseUsage', VOID, UsageInOntologyImport);
  initMetadataForClass(OntologyInExtensionTypeUsage, 'OntologyInExtensionTypeUsage', VOID, UsagePresentationData);
  initMetadataForClass(OntologyInExtensionFieldUsage, 'OntologyInExtensionFieldUsage', VOID, UsagePresentationData);
  initMetadataForClass(ImportOntologyImportRootUsage, 'ImportOntologyImportRootUsage', VOID, UsagePresentationData);
  initMetadataForClass(PublishedSourceUsage, 'PublishedSourceUsage', VOID, UsagePresentationData);
  initMetadataForClass(TypeOfOldPropertyDeclarationUsage, 'TypeOfOldPropertyDeclarationUsage', VOID, UsagePresentationData);
  initMetadataForClass(TypeOfOldLinkDeclarationUsage, 'TypeOfOldLinkDeclarationUsage', VOID, UsagePresentationData);
  initMetadataForClass(OldLinkSpecializesLinkUsage, 'OldLinkSpecializesLinkUsage', VOID, UsageInBindingDeclaration);
  initMetadataForClass(ObjectPropertyUsageByAnotherProperty, 'ObjectPropertyUsageByAnotherProperty', VOID, UsagePresentationData);
  initMetadataForClass(ObjectPropertyUsageByAnotherPropertyKind, 'ObjectPropertyUsageByAnotherPropertyKind', VOID, Enum);
  initMetadataForClass(OntologyTargetKind, 'OntologyTargetKind', VOID, Enum);
  initMetadataForObject(SuperElementUsageKind, 'SuperElementUsageKind', VOID, UsageKind);
  initMetadataForObject(OntologyInSuperElementUsageKind, 'OntologyInSuperElementUsageKind', VOID, UsageKind);
  initMetadataForObject(PartOfElementUsageKind, 'PartOfElementUsageKind', VOID, UsageKind);
  initMetadataForObject(OntologyInPartOfElementUsageKind, 'OntologyInPartOfElementUsageKind', VOID, UsageKind);
  initMetadataForObject(ElementsTaxonUsageKind, 'ElementsTaxonUsageKind', VOID, UsageKind);
  initMetadataForObject(OntologyInElementsTaxonUsageKind, 'OntologyInElementsTaxonUsageKind', VOID, UsageKind);
  initMetadataForObject(OntologyInCategoryUsageKind, 'OntologyInCategoryUsageKind', VOID, UsageKind);
  initMetadataForObject(ElementInCategoryUsageKind, 'ElementInCategoryUsageKind', VOID, UsageKind);
  initMetadataForObject(ElementInFactSetContextUsageKind, 'ElementInFactSetContextUsageKind', VOID, UsageKind);
  initMetadataForObject(OntologyInFactSetContextUsageKind, 'OntologyInFactSetContextUsageKind', VOID, UsageKind);
  initMetadataForObject(AnythingInsideFactUsageKind, 'AnythingInsideFactUsageKind', VOID, UsageKind);
  initMetadataForObject(SomethingAsVariableSpecUsageKind, 'SomethingAsVariableSpecUsageKind', VOID, UsageKind);
  initMetadataForObject(ProcessKindUsageKind, 'ProcessKindUsageKind', VOID, UsageKind);
  initMetadataForObject(ExtendedProcessUsageKind, 'ExtendedProcessUsageKind', VOID, UsageKind);
  initMetadataForObject(InheritedProcessUsageKind, 'InheritedProcessUsageKind', VOID, UsageKind);
  initMetadataForObject(FunctionReturnTypeOntologyUsageKind, 'FunctionReturnTypeOntologyUsageKind', VOID, UsageKind);
  initMetadataForObject(FunctionReturnTypeOntologyElementUsageKind, 'FunctionReturnTypeOntologyElementUsageKind', VOID, UsageKind);
  initMetadataForObject(AnythingInsideCustomEditorUsageKind, 'AnythingInsideCustomEditorUsageKind', VOID, UsageKind);
  initMetadataForObject(OntologyElementInAbstractBindingElementsUsageKind, 'OntologyElementInAbstractBindingElementsUsageKind', VOID, UsageKind);
  initMetadataForObject(OntologyInAbstractBindingElementsUsageKind, 'OntologyInAbstractBindingElementsUsageKind', VOID, UsageKind);
  initMetadataForObject(AliasedPropertyUsageKind, 'AliasedPropertyUsageKind', VOID, UsageKind);
  initMetadataForObject(PropertyTypeOntologyUsageKind, 'PropertyTypeOntologyUsageKind', VOID, UsageKind);
  initMetadataForObject(PropertyTypeOntologyElementUsageKind, 'PropertyTypeOntologyElementUsageKind', VOID, UsageKind);
  initMetadataForObject(PropertyTypeNotionUsageKind, 'PropertyTypeNotionUsageKind', VOID, UsageKind);
  initMetadataForObject(OldPropertyTypeNotionUsageKind, 'OldPropertyTypeNotionUsageKind', VOID, UsageKind);
  initMetadataForObject(OldImportedPropertyUsageKind, 'OldImportedPropertyUsageKind', VOID, UsageKind);
  initMetadataForObject(OldLinkOntologyUsageKind, 'OldLinkOntologyUsageKind', VOID, UsageKind);
  initMetadataForObject(OldLinkOntologyElementUsageKind, 'OldLinkOntologyElementUsageKind', VOID, UsageKind);
  initMetadataForObject(OldImportedLinkUsageKind, 'OldImportedLinkUsageKind', VOID, UsageKind);
  initMetadataForObject(OldLinkSpecializesLinkUsageKind, 'OldLinkSpecializesLinkUsageKind', VOID, UsageKind);
  initMetadataForObject(InOntologyImportForOntologyUsageKind, 'InOntologyImportForOntologyUsageKind', VOID, UsageKind);
  initMetadataForObject(InOntologyImportForOntologyElementUsageKind, 'InOntologyImportForOntologyElementUsageKind', VOID, UsageKind);
  initMetadataForObject(InOntologyImportOntologyToUseUsageKind, 'InOntologyImportOntologyToUseUsageKind', VOID, UsageKind);
  initMetadataForObject(ExtensionTypeOntologyUsageKind, 'ExtensionTypeOntologyUsageKind', VOID, UsageKind);
  initMetadataForObject(ExtensionTypeOntologyElementUsageKind, 'ExtensionTypeOntologyElementUsageKind', VOID, UsageKind);
  initMetadataForObject(ExtensionFieldOntologyUsageKind, 'ExtensionFieldOntologyUsageKind', VOID, UsageKind);
  initMetadataForObject(ExtensionFieldOntologyElementUsageKind, 'ExtensionFieldOntologyElementUsageKind', VOID, UsageKind);
  initMetadataForObject(ImportOntologyImportRootUsageKind, 'ImportOntologyImportRootUsageKind', VOID, UsageKind);
  initMetadataForObject(TypeOfOldPropertyNotionUsageKind, 'TypeOfOldPropertyNotionUsageKind', VOID, UsageKind);
  initMetadataForObject(TypeOfOldLinkOntologyUsageKind, 'TypeOfOldLinkOntologyUsageKind', VOID, UsageKind);
  initMetadataForObject(TypeOfOldLinkOntologyElementUsageKind, 'TypeOfOldLinkOntologyElementUsageKind', VOID, UsageKind);
  initMetadataForObject(SuperPropertyUsageKind, 'SuperPropertyUsageKind', VOID, UsageKind);
  initMetadataForObject(InversePropertyUsageKind, 'InversePropertyUsageKind', VOID, UsageKind);
  initMetadataForObject(PublishedSourceUsageKind, 'PublishedSourceUsageKind', VOID, UsageKind);
  initMetadataForLambda(btbLanguageWithLocalResolve$lambda$lambda$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForClass(sam$jetbrains_ocelot_langDef_references_TargetPresentationProvider$0_1, 'sam$jetbrains_ocelot_langDef_references_TargetPresentationProvider$0', VOID, VOID, [TargetPresentationProvider, FunctionAdapter]);
  initMetadataForClass(sam$jetbrains_ocelot_langDef_references_TargetPresentationProvider$0_2, 'sam$jetbrains_ocelot_langDef_references_TargetPresentationProvider$0', VOID, VOID, [TargetPresentationProvider, FunctionAdapter]);
  initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0_19, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
  initMetadataForLambda(btbScopes$lambda$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_1, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_3, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_5, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_7, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda$slambda_1, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_9, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_11, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_13, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_15, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda$slambda_3, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_17, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda$slambda_5, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_19, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda$slambda_7, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_21, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda$slambda_9, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_23, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_25, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda$slambda_11, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_27, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_29, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_31, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_33, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(btbScopes$lambda$slambda_35, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_37, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_39, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_41, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_43, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_45, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_47, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_49, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda$slambda_13, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_51, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda$o$collect$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($collectCOROUTINE$_20, CoroutineImpl);
  initMetadataForClass(btbScopes$2$56$$inlined$filter$1, VOID, VOID, VOID, [Flow], [1]);
  initMetadataForLambda(btbScopes$lambda$slambda_53, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_55, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_57, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_59, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_61, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_63, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_65, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_67, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_69, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_71, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_73, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_75, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_77, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_79, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_81, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_83, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_85, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_87, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_89, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_91, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_93, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_95, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_97, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_99, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_101, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_103, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_105, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_107, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_109, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_111, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_113, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_115, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_117, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_119, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_121, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_123, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda$slambda_15, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_125, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_127, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_129, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_131, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_133, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_135, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_137, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_139, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_141, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_143, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_145, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_147, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_149, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_151, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_153, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_155, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_157, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_159, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_161, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_163, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_165, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_167, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_169, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_171, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_173, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_175, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_177, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_179, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_181, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_183, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_185, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_187, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda$slambda_17, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_189, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_191, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_193, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda$slambda_19, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda$slambda_21, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_195, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_197, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_199, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_201, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda$slambda_23, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_203, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda$slambda_25, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_205, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_207, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_209, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda$slambda_27, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_211, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_213, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda$slambda_29, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_215, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_217, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_219, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_221, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_223, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_225, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_227, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_229, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_231, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_233, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_235, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_237, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_239, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_241, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_243, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_245, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_247, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_249, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_251, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda$slambda_31, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda$slambda_33, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_253, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_255, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda$slambda_35, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_257, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_259, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_261, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_263, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_265, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda$slambda_37, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_267, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_269, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_271, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_273, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_275, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_277, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_279, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda$slambda_39, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_281, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_283, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_285, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_287, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(btbScopes$lambda$slambda_289, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(btbScopes$lambda$slambda_291, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(btbScopes$lambda$slambda_293, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(btbScopes$lambda$slambda_295, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(btbScopes$lambda$slambda_297, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(btbScopes$lambda$slambda_299, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(btbScopes$lambda$slambda_301, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(btbScopes$lambda$slambda_303, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(btbScopes$lambda$slambda_305, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(btbScopes$lambda$slambda_307, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(btbScopes$lambda$slambda_309, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($runSuspendCOROUTINE$_74, CoroutineImpl);
  initMetadataForClass(btbScopes$2$336$$inlined$suspendingQuery$1$runSuspend$2, VOID, VOID, VOID, VOID, [1]);
  initMetadataForCoroutine($runSuspendCOROUTINE$_75, CoroutineImpl);
  initMetadataForClass(btbScopes$2$336$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(btbScopes$2$338$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForCoroutine($runSuspendCOROUTINE$_76, CoroutineImpl);
  initMetadataForClass(_no_name_provided__qut3iv_4, VOID, VOID, VOID, VOID, [1]);
  initMetadataForCoroutine($runSuspendCOROUTINE$_77, CoroutineImpl);
  initMetadataForClass(propertyTypeElements$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForCoroutine($runSuspendCOROUTINE$_78, CoroutineImpl);
  initMetadataForClass(propertyTypeElements$$inlined$flatMap$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForCoroutine($runSuspendCOROUTINE$_79, CoroutineImpl);
  initMetadataForClass(typeElements$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForLambda(filterOntologyElementsByPropertyRange$o$runSuspend$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForCoroutine($runSuspendCOROUTINE$_80, CoroutineImpl);
  initMetadataForClass(filterOntologyElementsByPropertyRange$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForLambda(filterByPropertyRange$o$runSuspend$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForCoroutine($runSuspendCOROUTINE$_81, CoroutineImpl);
  initMetadataForClass(filterByPropertyRange$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForCoroutine($runSuspendCOROUTINE$_82, CoroutineImpl);
  initMetadataForClass(filterByValueType$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForLambda(filterInstanceRelations$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(filterInstanceRelations$slambda_1, CoroutineImpl, VOID, [2]);
  initMetadataForCoroutine($runSuspendCOROUTINE$_83, CoroutineImpl);
  initMetadataForClass(filterByVariableSpecification$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForCoroutine($runSuspendCOROUTINE$_84, CoroutineImpl);
  initMetadataForClass(filterByDomainType$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForCoroutine($runSuspendCOROUTINE$_85, CoroutineImpl);
  initMetadataForClass(filterByProcessPropertyType$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForCoroutine($runSuspendCOROUTINE$_86, CoroutineImpl);
  initMetadataForClass(filterByFactExpressionType$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForCoroutine($importOntologyLibrariesCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($processPropertyElementsCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($getCustomEditorPropertiesScopeCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($libraryElementsScopeCOROUTINE$, CoroutineImpl);
  initMetadataForClass(DocumentNodeFinder$find$$inlined$query$1, VOID, VOID, VOID, [Query], [1]);
  initMetadataForClass(DocumentNodeFinder, 'DocumentNodeFinder', VOID, VOID, [NodeFinder]);
  initMetadataForClass(NonGroupingFilter$apply$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(NonGroupingFilter, 'NonGroupingFilter', NonGroupingFilter, VOID, [ScopeFilter]);
  initMetadataForInterface(NonGroupingFilterService, 'NonGroupingFilterService');
  initMetadataForClass(sam$jetbrains_biokb_lang_model_resolve_NonGroupingFilterService$0, 'sam$jetbrains_biokb_lang_model_resolve_NonGroupingFilterService$0', VOID, VOID, [NonGroupingFilterService, FunctionAdapter]);
  initMetadataForCompanion(Companion_358, VOID, [Key_5]);
  initMetadataForCoroutine($runSuspendCOROUTINE$_87, CoroutineImpl);
  initMetadataForClass(ObjectPropertyDomainNotionFilter$apply$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(ObjectPropertyDomainNotionFilter, 'ObjectPropertyDomainNotionFilter', VOID, VOID, [ScopeFilter]);
  initMetadataForCoroutine($runSuspendCOROUTINE$_88, CoroutineImpl);
  initMetadataForClass(ObjectPropertyDomainElementsFilter$apply$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(ObjectPropertyDomainElementsFilter, 'ObjectPropertyDomainElementsFilter', VOID, VOID, [ScopeFilter]);
  initMetadataForClass(ObjectPropertyDomainFilterService$Companion$default$1);
  initMetadataForCompanion(Companion_359, VOID, [Key_5]);
  initMetadataForClass(PublishedWorkReferenceResolver$resolve$$inlined$map$1, VOID, VOID, VOID, [Query], [1]);
  initMetadataForClass(PublishedWorkReferenceResolver, 'PublishedWorkReferenceResolver', VOID, VOID, [ReferenceResolver]);
  initMetadataForClass(PublishedWorkReferenceTargetPresentationProvider, 'PublishedWorkReferenceTargetPresentationProvider', PublishedWorkReferenceTargetPresentationProvider, VOID, [TargetPresentationProvider]);
  initMetadataForLambda(PublishedWorkReferenceTargetsSupplier$getElements$slambda$o$runSuspend$o$collect$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($collectCOROUTINE$_21, CoroutineImpl);
  initMetadataForLambda(PublishedWorkReferenceTargetsSupplier$getElements$slambda$o$runSuspend$o$collect$slambda_1, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($collectCOROUTINE$_22, CoroutineImpl);
  initMetadataForLambda(PublishedWorkReferenceTargetsSupplier$getElements$slambda$o$runSuspend$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(PublishedWorkReferenceTargetsSupplier$getElements$2$$inlined$suspendingQuery$1$runSuspend$2, VOID, VOID, VOID, [Flow], [1]);
  initMetadataForClass(PublishedWorkReferenceTargetsSupplier$getElements$2$$inlined$suspendingQuery$1$runSuspend$3, VOID, VOID, VOID, [Flow], [1]);
  initMetadataForLambda(PublishedWorkReferenceTargetsSupplier$getElements$slambda$o$runSuspend$slambda_1, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($runSuspendCOROUTINE$_89, CoroutineImpl);
  initMetadataForClass(PublishedWorkReferenceTargetsSupplier$getElements$2$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0_20, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
  initMetadataForLambda(PublishedWorkReferenceTargetsSupplier$getElements$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(PublishedWorkReferenceTargetsSupplier, 'PublishedWorkReferenceTargetsSupplier', VOID, VOID, [ReferenceTargetsSupplier]);
  initMetadataForClass(SubtypeScopeFilter, 'SubtypeScopeFilter', VOID, VOID, [ScopeFilter]);
  function provideFilterFor(element) {
    return this.cml(setOf(element));
  }
  initMetadataForInterface(SubtypeScopeFilterService, 'SubtypeScopeFilterService');
  initMetadataForClass(SubtypeScopeFilterService$Companion$default$1, VOID, VOID, VOID, [SubtypeScopeFilterService]);
  initMetadataForCompanion(Companion_360, VOID, [Key_5]);
  initMetadataForCoroutine($runSuspendCOROUTINE$_90, CoroutineImpl);
  initMetadataForClass(TaxonScopeFilter$apply$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(TaxonScopeFilter, 'TaxonScopeFilter', VOID, VOID, [ScopeFilter]);
  function provideFilterFor_0(element) {
    return this.cml(setOf(element));
  }
  initMetadataForInterface(TaxonScopeFilterService, 'TaxonScopeFilterService');
  initMetadataForClass(TaxonScopeFilterService$Companion$default$1, VOID, VOID, VOID, [TaxonScopeFilterService]);
  initMetadataForCompanion(Companion_361, VOID, [Key_5]);
  initMetadataForCompanion(Companion_362);
  initMetadataForObject($serializer_35, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(PropertiesUpdate, 'PropertiesUpdate', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_33});
  initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0_21, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
  initMetadataForLambda(InheritedPropertiesCalculator$applyPropertiesFromFlow$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForObject(InheritedPropertiesCalculator, 'InheritedPropertiesCalculator', VOID, VOID, VOID, [4, 2]);
  initMetadataForCompanion(Companion_363);
  initMetadataForCompanion(Companion_364);
  initMetadataForClass(FlowBounds, 'FlowBounds');
  initMetadataForClass(TraversalContext$getFrames$1);
  initMetadataForClass(TraversalContext, 'TraversalContext');
  initMetadataForClass(Frame_0, 'Frame');
  initMetadataForClass(PostProcessChildNodeFrame, 'PostProcessChildNodeFrame', VOID, Frame_0);
  initMetadataForClass(PreProcessNodeFrame, 'PreProcessNodeFrame', VOID, Frame_0);
  initMetadataForClass(PostProcessNodeFrame, 'PostProcessNodeFrame', VOID, Frame_0);
  initMetadataForCompanion(Companion_365);
  initMetadataForClass(MaxFlowGraph, 'MaxFlowGraph');
  initMetadataForClass(LeftNode, 'LeftNode');
  initMetadataForClass(RightNode, 'RightNode');
  initMetadataForClass(MatchingMode, 'MatchingMode', VOID, Enum);
  initMetadataForCompanion(Companion_366);
  initMetadataForClass(MultisetMatching, 'MultisetMatching');
  initMetadataForClass(MultisetElement, 'MultisetElement');
  initMetadataForClass(LowerBoundFlowNetwork, 'LowerBoundFlowNetwork');
  initMetadataForClass(FeasibleFlowNetwork, 'FeasibleFlowNetwork', VOID, LowerBoundFlowNetwork);
  initMetadataForInterface(AbstractOntologyElement, 'AbstractOntologyElement');
  function resolve($completion) {
    return execute_1(this.gfq(), $completion);
  }
  initMetadataForInterface(AbstractClassReference, 'AbstractClassReference', VOID, VOID, VOID, [1, 0]);
  initMetadataForInterface(AbstractElementDefinition, 'AbstractElementDefinition');
  initMetadataForObject(Unknown_0, 'Unknown');
  initMetadataForClass(Known, 'Known');
  initMetadataForInterface(Constrainable, 'Constrainable');
  initMetadataForObject(None_0, 'None', VOID, VOID, [Constrainable]);
  initMetadataForClass(Enum_0, 'Enum', VOID, VOID, [Constrainable]);
  initMetadataForClass(Measurable, 'Measurable', VOID, VOID, [Constrainable]);
  initMetadataForClass(StringVal, 'StringVal', VOID, VOID, [Constrainable]);
  initMetadataForClass(IntegerVal, 'IntegerVal', VOID, VOID, [Constrainable]);
  initMetadataForClass(ComplexNotion_2, 'ComplexNotion', VOID, VOID, [Constrainable]);
  initMetadataForClass(ClassValue, 'ClassValue', VOID, VOID, [Constrainable]);
  initMetadataForClass(SetValue, 'SetValue', VOID, VOID, [Constrainable]);
  initMetadataForClass(SetType, 'SetType', VOID, Enum);
  initMetadataForClass(Constraint, 'Constraint');
  initMetadataForClass(ConstrainedValue, 'ConstrainedValue');
  initMetadataForClass(RelationFactExpressionDescriptor, 'RelationFactExpressionDescriptor');
  initMetadataForInterface(LibraryProcessSpecificationDescriptor, 'LibraryProcessSpecificationDescriptor', VOID, VOID, [Constrainable]);
  initMetadataForClass(ParameterBinding, 'ParameterBinding');
  initMetadataForClass(PropertyConstraintValue, 'PropertyConstraintValue');
  initMetadataForInterface(AbstractNotionDescriptor, 'AbstractNotionDescriptor');
  initMetadataForClass(ValueConstraintDescriptor$property$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(ValueConstraintDescriptor$value$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(ValueConstraintDescriptor$constraints$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(ValueConstraintDescriptor$operation$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(ValueConstraintDescriptor, 'ValueConstraintDescriptor');
  initMetadataForClass(AdapterCache, 'AdapterCache', AdapterCache);
  initMetadataForClass(OntologyElementAdapter$superElements$$inlined$cachedSuspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(OntologyElementAdapter$definition$$inlined$cachedSuspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(OntologyElementAdapter$ownProperties$$inlined$cachedSuspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(OntologyElementAdapter, 'OntologyElementAdapter', VOID, VOID, [AbstractOntologyElement]);
  initMetadataForClass(UnionClassAdapter$constraints$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(UnionClassAdapter, 'UnionClassAdapter', VOID, VOID, [AbstractElementDefinition]);
  initMetadataForClass(ClassDeclarationSetAdapter$classes$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(ClassDeclarationSetAdapter$constraints$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(ClassDeclarationSetAdapter, 'ClassDeclarationSetAdapter', VOID, VOID, [AbstractElementDefinition]);
  initMetadataForCoroutine($runSuspendCOROUTINE$_91, CoroutineImpl);
  initMetadataForClass(OntologyElementReferenceAdapter$element$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(OntologyElementReferenceAdapter, 'OntologyElementReferenceAdapter', VOID, VOID, [AbstractClassReference], [1, 0]);
  initMetadataForCoroutine($runSuspendCOROUTINE$_92, CoroutineImpl);
  initMetadataForClass(OntologyElementDefinitionAdapter$classes$$inlined$cachedSuspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(OntologyElementDefinitionAdapter$constraints$$inlined$cachedSuspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(OntologyElementDefinitionAdapter, 'OntologyElementDefinitionAdapter', VOID, VOID, [AbstractElementDefinition]);
  initMetadataForCoroutine($runSuspendCOROUTINE$_93, CoroutineImpl);
  initMetadataForCoroutine($runSuspendCOROUTINE$_94, CoroutineImpl);
  initMetadataForCoroutine($runSuspendCOROUTINE$_95, CoroutineImpl);
  initMetadataForClass(DomainPropertyConstraintAdapter$property$$inlined$cachedSuspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(DomainPropertyConstraintAdapter$normalizedValue$$inlined$cachedSuspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(DomainPropertyConstraintAdapter$value$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(DomainPropertyConstraintAdapter$constraints$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(DomainPropertyConstraintAdapter, 'DomainPropertyConstraintAdapter');
  initMetadataForCoroutine($runSuspendCOROUTINE$_96, CoroutineImpl);
  initMetadataForClass(DomainPropertyDeclAdapter$superProperty$$inlined$cachedSuspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(DomainPropertyDeclAdapter, 'DomainPropertyDeclAdapter');
  initMetadataForCoroutine($runSuspendCOROUTINE$_97, CoroutineImpl);
  initMetadataForClass(extractClassAdapters$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(DomainFactExpressionAdapterContext$adaptProcessProperty$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForObject(DomainFactExpressionAdapterContext, 'DomainFactExpressionAdapterContext');
  initMetadataForCompanion(Companion_367);
  initMetadataForLambda(FactExpressionToAdapterConverter$adaptAbstractValue$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForCoroutine($adaptFactExpressionCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($adaptNewFactReferenceCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($adaptAbstractValueCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($adaptRelationFactExpressionCOROUTINE$, CoroutineImpl);
  initMetadataForClass(FactExpressionToAdapterConverter, 'FactExpressionToAdapterConverter', VOID, VOID, VOID, [3]);
  initMetadataForClass(RelationAdapter$direction$$inlined$cachedSuspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(RelationAdapter, 'RelationAdapter');
  initMetadataForCoroutine($runSuspendCOROUTINE$_98, CoroutineImpl);
  initMetadataForClass(toAdapter$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(buildSetValueDescriptor$$inlined$groupingBy$1);
  initMetadataForCoroutine($runSuspendCOROUTINE$_99, CoroutineImpl);
  initMetadataForClass(toAdapter$$inlined$suspendingQuery$2, VOID, VOID, VOID, VOID, [1]);
  initMetadataForCoroutine($buildSetValueDescriptorCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($toConstraintCOROUTINE$, CoroutineImpl);
  initMetadataForClass(IsExpressionSubject, 'IsExpressionSubject', VOID, VOID, VOID, [3]);
  initMetadataForClass(IsExpressionAdapter$classes$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(IsExpressionAdapter$constraints$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(IsExpressionAdapter, 'IsExpressionAdapter', VOID, VOID, [AbstractElementDefinition]);
  initMetadataForClass(PropertyReference, 'PropertyReference');
  initMetadataForClass(IsExpressionConstraintAdapter$property$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(IsExpressionConstraintAdapter$constraints$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(IsExpressionConstraintAdapter$operation$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(IsExpressionConstraintAdapter$value$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(IsExpressionConstraintAdapter, 'IsExpressionConstraintAdapter');
  initMetadataForLambda(toAdapter$o$runSuspend$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForCoroutine($runSuspendCOROUTINE$_100, CoroutineImpl);
  initMetadataForClass(toAdapter$$inlined$suspendingQuery$1_0, VOID, VOID, VOID, VOID, [1]);
  initMetadataForCoroutine($classAdapterCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($runSuspendCOROUTINE$_101, CoroutineImpl);
  initMetadataForClass(LibraryProcessSpecificationAdapter$LibraryProcessSpecificationContext$adaptProcessProperty$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(LibraryProcessSpecificationAdapter$LibraryProcessSpecificationContext$foldSpecifiedValues$$inlined$groupingBy$1);
  initMetadataForCoroutine($foldSpecifiedValuesCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($runSuspendCOROUTINE$_102, CoroutineImpl);
  initMetadataForClass(LibraryProcessSpecificationContext, 'LibraryProcessSpecificationContext', VOID, VOID, VOID, [3]);
  initMetadataForClass(LibraryProcessSpecificationAdapter$parameters$$inlined$cachedSuspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(LibraryProcessSpecificationAdapter, 'LibraryProcessSpecificationAdapter', VOID, VOID, [LibraryProcessSpecificationDescriptor]);
  initMetadataForCoroutine($runSuspendCOROUTINE$_103, CoroutineImpl);
  initMetadataForClass(ProcessDeclarationAdapter$selfAndAncestors$$inlined$cachedSuspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(ProcessDeclarationAdapter, 'ProcessDeclarationAdapter');
  initMetadataForClass(ProcessParameterAdapter, 'ProcessParameterAdapter');
  initMetadataForCoroutine($runSuspendCOROUTINE$_104, CoroutineImpl);
  initMetadataForClass(toAdapter$$inlined$suspendingQuery$1_1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForCoroutine($runSuspendCOROUTINE$_105, CoroutineImpl);
  initMetadataForClass(VariableDeclarationAdapter$classes$$inlined$cachedSuspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(VariableDeclarationAdapter$constraints$$inlined$cachedSuspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(VariableDeclarationAdapter, 'VariableDeclarationAdapter', VOID, VOID, [AbstractElementDefinition]);
  initMetadataForClass(NotionDescriptorAdapter, 'NotionDescriptorAdapter', VOID, VOID, [AbstractNotionDescriptor]);
  initMetadataForClass(PrimitiveNotionDescriptorAdapter, 'PrimitiveNotionDescriptorAdapter', VOID, VOID, [AbstractNotionDescriptor]);
  initMetadataForCoroutine($runSuspendCOROUTINE$_106, CoroutineImpl);
  initMetadataForClass(OneOfAdapter$classes$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(OneOfAdapter$constraints$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(OneOfAdapter, 'OneOfAdapter', VOID, VOID, [AbstractElementDefinition]);
  initMetadataForCoroutine($runSuspendCOROUTINE$_107, CoroutineImpl);
  initMetadataForClass(toAdapter$$inlined$suspendingQuery$1_2, VOID, VOID, VOID, VOID, [1]);
  initMetadataForCoroutine($unwrapCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($adaptProcessPropertyReferenceCOROUTINE$, CoroutineImpl);
  initMetadataForObject(ConstraintOperations, 'ConstraintOperations');
  initMetadataForClass(DnfNormalizer, 'DnfNormalizer', DnfNormalizer);
  initMetadataForClass(ConjTerm, 'ConjTerm', ConjTerm);
  initMetadataForCompanion(Companion_368);
  initMetadataForClass(NormalizedType, 'NormalizedType');
  initMetadataForClass(Source, 'Source', VOID, Enum);
  initMetadataForClass(HasProperty, 'HasProperty');
  initMetadataForClass(Clause, 'Clause', Clause);
  initMetadataForClass(Union, 'Union');
  initMetadataForCompanion(Companion_369);
  initMetadataForClass(NormalizedValueOperands, 'NormalizedValueOperands');
  initMetadataForCoroutine($runSuspendCOROUTINE$_108, CoroutineImpl);
  initMetadataForCoroutine($runSuspendCOROUTINE$_109, CoroutineImpl);
  initMetadataForCoroutine($runSuspendCOROUTINE$_110, CoroutineImpl);
  initMetadataForCoroutine($runSuspendCOROUTINE$_111, CoroutineImpl);
  initMetadataForCompanion(Companion_370);
  initMetadataForClass(OntologyHierarchyImpl$isNatural$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(OntologyHierarchyImpl$getAssertedDefinitionElements$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(OntologyHierarchyImpl$getAllNaturalDefinitionElements$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(OntologyHierarchyImpl$getAllSuperElements$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForCoroutine($getAllSuperElementsCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($isNaturalCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($getAssertedDefinitionElementsCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($collectExternalElementsCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($calculateElementsToAllNaturalDefinitionsCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($getAllNaturalDefinitionsCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($getAssertedSuperElementsCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($calculateElementToAllSuperElementsCOROUTINE$, CoroutineImpl);
  initMetadataForClass(OntologyHierarchyImpl, 'OntologyHierarchyImpl', VOID, VOID, VOID, [2]);
  initMetadataForClass(getAllNaturalDefinitionElements$$inlined$map$1, VOID, VOID, VOID, [Query], [1]);
  initMetadataForCoroutine($runSuspendCOROUTINE$_112, CoroutineImpl);
  initMetadataForClass(getAllNaturalDefinitionElements$$inlined$map$2, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(getAssertedDefinitionElements$$inlined$map$1, VOID, VOID, VOID, [Query], [1]);
  initMetadataForCoroutine($runSuspendCOROUTINE$_113, CoroutineImpl);
  initMetadataForClass(getAssertedDefinitionElements$$inlined$map$2, VOID, VOID, VOID, VOID, [1]);
  initMetadataForCoroutine($aliasRootsCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($aliasRoots$aliasedPropertiesCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($runSuspendCOROUTINE$_114, CoroutineImpl);
  initMetadataForClass(expectedClass$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForCoroutine($runSuspendCOROUTINE$_115, CoroutineImpl);
  initMetadataForClass(expectedClassesForValue$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForCoroutine($runSuspendCOROUTINE$_116, CoroutineImpl);
  initMetadataForClass(expectedClass$$inlined$suspendingQuery$2, VOID, VOID, VOID, VOID, [1]);
  initMetadataForCoroutine($runSuspendCOROUTINE$_117, CoroutineImpl);
  initMetadataForCoroutine($runSuspendCOROUTINE$_118, CoroutineImpl);
  initMetadataForCoroutine($runSuspendCOROUTINE$_119, CoroutineImpl);
  initMetadataForCoroutine($runSuspendCOROUTINE$_120, CoroutineImpl);
  initMetadataForCoroutine($runSuspendCOROUTINE$_121, CoroutineImpl);
  initMetadataForCoroutine($runSuspendCOROUTINE$_122, CoroutineImpl);
  initMetadataForCoroutine($runSuspendCOROUTINE$_123, CoroutineImpl);
  initMetadataForCoroutine($runSuspendCOROUTINE$_124, CoroutineImpl);
  initMetadataForCoroutine($runSuspendCOROUTINE$_125, CoroutineImpl);
  initMetadataForCoroutine($runSuspendCOROUTINE$_126, CoroutineImpl);
  initMetadataForCoroutine($runSuspendCOROUTINE$_127, CoroutineImpl);
  initMetadataForCoroutine($runSuspendCOROUTINE$_128, CoroutineImpl);
  initMetadataForCoroutine($runSuspendCOROUTINE$_129, CoroutineImpl);
  initMetadataForClass(TypeComparer$StatefulComparer$descriptorIsA$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(TypeComparer$StatefulComparer$isA$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(TypeComparer$StatefulComparer$isA$$inlined$suspendingQuery$2, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(TypeComparer$StatefulComparer$satisfyBase$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(TypeComparer$StatefulComparer$satisfyAllProperties$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(TypeComparer$StatefulComparer$valueIsA$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(TypeComparer$StatefulComparer$compareNormalizedPair$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(TypeComparer$StatefulComparer$checkConstraints$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(TypeComparer$StatefulComparer$compareSetValues$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(TypeComparer$StatefulComparer$processIsA$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(TypeComparer$StatefulComparer$compatibleMatching$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(TypeComparer$StatefulComparer$isSubtypeOf$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(TypeComparer$StatefulComparer$isSubPropertyOf$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(StatefulComparer, 'StatefulComparer', VOID, VOID, VOID, [2, 1]);
  initMetadataForClass(TypeComparer, 'TypeComparer');
  initMetadataForCoroutine($runSuspendCOROUTINE$_130, CoroutineImpl);
  initMetadataForCoroutine($runSuspendCOROUTINE$_131, CoroutineImpl);
  initMetadataForCoroutine($runSuspendCOROUTINE$_132, CoroutineImpl);
  initMetadataForCoroutine($runSuspendCOROUTINE$_133, CoroutineImpl);
  initMetadataForCoroutine($runSuspendCOROUTINE$_134, CoroutineImpl);
  initMetadataForCoroutine($runSuspendCOROUTINE$_135, CoroutineImpl);
  initMetadataForCoroutine($runSuspendCOROUTINE$_136, CoroutineImpl);
  initMetadataForCoroutine($runSuspendCOROUTINE$_137, CoroutineImpl);
  initMetadataForClass(TypeExpressionConverter$toTypeExpression$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(TypeExpressionConverter$elementToTypeExpression$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(TypeExpressionConverter$normalizeDefinedType$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(TypeExpressionConverter$normalizeNaturalType$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(TypeExpressionConverter$getAllInherentProperties$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(TypeExpressionConverter$getAllInherentProperties$$inlined$suspendingQuery$2, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(TypeExpressionConverter$convertToDescriptor$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(TypeExpressionConverter$resolveConstraints$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(TypeExpressionConverter$convertToValueConstraints$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(TypeExpressionConverter, 'TypeExpressionConverter', TypeExpressionConverter);
  initMetadataForClass(ConstrainedElementDefinition$classes$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(ConstrainedElementDefinition$constraints$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(ConstrainedElementDefinition, 'ConstrainedElementDefinition', VOID, VOID, [AbstractElementDefinition]);
  initMetadataForCoroutine($runSuspendCOROUTINE$_138, CoroutineImpl);
  initMetadataForClass(TypeNormalizer$normalize$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(TypeNormalizer, 'TypeNormalizer', TypeNormalizer, VOID, VOID, [2]);
  initMetadataForObject(ValueDescriptorOperations, 'ValueDescriptorOperations');
  initMetadataForCompanion(Companion_371);
  initMetadataForObject($serializer_36, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(UsageDto, 'UsageDto', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_34});
  initMetadataForCompanion(Companion_372);
  initMetadataForObject($serializer_37, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(PubMedPaperLoadResultDto, 'PubMedPaperLoadResultDto', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_35});
  initMetadataForClass(DocPersistence, 'DocPersistence');
  initMetadataForObject(RawDocPersistence, 'RawDocPersistence', VOID, DocPersistence);
  initMetadataForClass(HandlerRegistration, 'HandlerRegistration', VOID, LockFreeLinkedListNode, [LockFreeLinkedListNode, DisposableHandle]);
  initMetadataForClass(Events, 'Events', Events);
  initMetadataForClass(EventDefinition, 'EventDefinition', EventDefinition);
  initMetadataForClass(URLDecodeException, 'URLDecodeException', VOID, Exception);
  initMetadataForCompanion(Companion_373);
  initMetadataForObject(Application, 'Application');
  initMetadataForObject(Text_0, 'Text');
  initMetadataForClass(HeaderValueWithParameters, 'HeaderValueWithParameters');
  initMetadataForClass(ContentType, 'ContentType', VOID, HeaderValueWithParameters);
  initMetadataForClass(BadContentTypeFormatException, 'BadContentTypeFormatException', VOID, Exception);
  initMetadataForCompanion(Companion_374);
  initMetadataForCompanion(Companion_375);
  initMetadataForClass(HeadersBuilder, 'HeadersBuilder', HeadersBuilder, StringValuesBuilderImpl);
  initMetadataForObject(EmptyHeaders, 'EmptyHeaders', VOID, VOID, [StringValues]);
  initMetadataForClass(HeadersImpl, 'HeadersImpl', HeadersImpl, StringValuesImpl, [StringValues, StringValuesImpl]);
  initMetadataForClass(HeaderValueParam, 'HeaderValueParam');
  initMetadataForClass(HeaderValue, 'HeaderValue');
  initMetadataForClass(sam$kotlin_Comparator$0_3, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
  initMetadataForObject(HttpHeaders, 'HttpHeaders');
  initMetadataForClass(UnsafeHeaderException, 'UnsafeHeaderException', VOID, IllegalArgumentException);
  initMetadataForClass(IllegalHeaderNameException, 'IllegalHeaderNameException', VOID, IllegalArgumentException);
  initMetadataForClass(IllegalHeaderValueException, 'IllegalHeaderValueException', VOID, IllegalArgumentException);
  initMetadataForCompanion(Companion_376);
  initMetadataForClass(HttpMethod, 'HttpMethod');
  initMetadataForCompanion(Companion_377);
  initMetadataForClass(HttpProtocolVersion, 'HttpProtocolVersion');
  initMetadataForCompanion(Companion_378);
  initMetadataForClass(HttpStatusCode, 'HttpStatusCode', VOID, VOID, [Comparable]);
  initMetadataForCompanion(Companion_379);
  initMetadataForInterface(Parameters, 'Parameters', VOID, VOID, [StringValues]);
  initMetadataForObject(EmptyParameters, 'EmptyParameters', VOID, VOID, [Parameters]);
  initMetadataForClass(ParametersBuilderImpl, 'ParametersBuilderImpl', ParametersBuilderImpl, StringValuesBuilderImpl);
  initMetadataForClass(ParametersImpl, 'ParametersImpl', ParametersImpl, StringValuesImpl, [Parameters, StringValuesImpl]);
  initMetadataForCompanion(Companion_380);
  initMetadataForClass(URLBuilder, 'URLBuilder', URLBuilder);
  initMetadataForClass(URLParserException, 'URLParserException', VOID, IllegalStateException);
  initMetadataForCompanion(Companion_381);
  initMetadataForClass(URLProtocol, 'URLProtocol');
  initMetadataForCompanion(Companion_382);
  initMetadataForClass(Url_3, 'Url');
  initMetadataForClass(UrlDecodedParametersBuilder, 'UrlDecodedParametersBuilder');
  initMetadataForClass(OutgoingContent, 'OutgoingContent');
  initMetadataForClass(ByteArrayContent_0, 'ByteArrayContent', VOID, OutgoingContent);
  initMetadataForClass(ByteArrayContent, 'ByteArrayContent', VOID, ByteArrayContent_0);
  initMetadataForClass(NoContent, 'NoContent', VOID, OutgoingContent);
  initMetadataForClass(ReadChannelContent, 'ReadChannelContent', VOID, OutgoingContent);
  initMetadataForClass(WriteChannelContent, 'WriteChannelContent', VOID, OutgoingContent, VOID, [1]);
  initMetadataForClass(ProtocolUpgrade, 'ProtocolUpgrade', VOID, OutgoingContent, VOID, [4]);
  initMetadataForObject(NullBody, 'NullBody');
  initMetadataForClass(TextContent, 'TextContent', VOID, ByteArrayContent_0);
  initMetadataForClass(ContentConvertException, 'ContentConvertException', VOID, Exception);
  initMetadataForClass(JsonConvertException, 'JsonConvertException', VOID, ContentConvertException);
  function register$default(contentType, converter, configuration, $super) {
    var tmp;
    if (configuration === VOID) {
      tmp = Configuration$register$lambda;
    } else {
      tmp = configuration;
    }
    configuration = tmp;
    var tmp_0;
    if ($super === VOID) {
      this.ir8(contentType, converter, configuration);
      tmp_0 = Unit_instance;
    } else {
      tmp_0 = $super.ir8.call(this, contentType, converter, configuration);
    }
    return tmp_0;
  }
  initMetadataForInterface(Configuration_0, 'Configuration');
  function serialize_0(contentType, charset, typeInfo, value, $completion) {
    return this.lr8(contentType, charset, typeInfo, value, $completion);
  }
  function serializeNullable(contentType, charset, typeInfo, value, $completion) {
    return this.kr8(contentType, charset, typeInfo, ensureNotNull(value), $completion);
  }
  initMetadataForInterface(ContentConverter, 'ContentConverter', VOID, VOID, VOID, [4, 3]);
  initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0_22, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
  initMetadataForLambda(deserialize$o$collect$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($collectCOROUTINE$_23, CoroutineImpl);
  initMetadataForClass(deserialize$$inlined$map$1, VOID, VOID, VOID, [Flow], [1]);
  initMetadataForLambda(deserialize$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($deserializeCOROUTINE$, CoroutineImpl);
  initMetadataForLambda(HttpClient$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(HttpClient$slambda_1, CoroutineImpl, VOID, [2]);
  initMetadataForCoroutine($executeCOROUTINE$_0, CoroutineImpl);
  initMetadataForClass(HttpClient, 'HttpClient', VOID, VOID, [CoroutineScope, Closeable], [1]);
  initMetadataForClass(HttpClientConfig, 'HttpClientConfig', HttpClientConfig);
  initMetadataForCompanion(Companion_383);
  initMetadataForCoroutine($bodyNullableCOROUTINE$, CoroutineImpl);
  initMetadataForClass(HttpClientCall, 'HttpClientCall', VOID, VOID, [CoroutineScope], [0, 1]);
  initMetadataForClass(DoubleReceiveException, 'DoubleReceiveException', VOID, IllegalStateException);
  initMetadataForClass(NoTransformationFoundException, 'NoTransformationFoundException', VOID, UnsupportedOperationException);
  initMetadataForClass(SavedHttpCall, 'SavedHttpCall', VOID, HttpClientCall, VOID, [0, 1]);
  function get_coroutineContext() {
    return this.vrf().ho();
  }
  initMetadataForInterface(HttpRequest_0, 'HttpRequest', VOID, VOID, [CoroutineScope]);
  initMetadataForClass(SavedHttpRequest, 'SavedHttpRequest', VOID, VOID, [HttpRequest_0]);
  initMetadataForClass(HttpResponse, 'HttpResponse', VOID, VOID, [CoroutineScope]);
  initMetadataForClass(SavedHttpResponse, 'SavedHttpResponse', VOID, HttpResponse);
  initMetadataForCoroutine($saveCOROUTINE$, CoroutineImpl);
  initMetadataForClass(UnsupportedContentTypeException, 'UnsupportedContentTypeException', VOID, IllegalStateException);
  initMetadataForLambda(ObservableContent$content$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(ObservableContent, 'ObservableContent', VOID, ReadChannelContent);
  initMetadataForLambda(HttpClientEngine$install$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(HttpClientEngine$executeWithinCallContext$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($executeWithinCallContextCOROUTINE$, CoroutineImpl);
  function get_supportedCapabilities() {
    return emptySet();
  }
  function install(client) {
    var tmp = Phases_getInstance_0().krd_1;
    client.vra_1.ndz(tmp, HttpClientEngine$install$slambda_0(client, this, null));
  }
  initMetadataForInterface(HttpClientEngine, 'HttpClientEngine', VOID, VOID, [CoroutineScope, Closeable], [1]);
  initMetadataForClass(ClientEngineClosedException, 'ClientEngineClosedException', ClientEngineClosedException, IllegalStateException);
  initMetadataForClass(HttpClientEngineBase, 'HttpClientEngineBase', VOID, VOID, [HttpClientEngine], [1]);
  initMetadataForClass(HttpClientEngineConfig, 'HttpClientEngineConfig', HttpClientEngineConfig);
  initMetadataForCompanion(Companion_384);
  initMetadataForClass(KtorCallContextElement, 'KtorCallContextElement', VOID, VOID, [Element_0]);
  initMetadataForInterface(HttpClientPlugin, 'HttpClientPlugin');
  initMetadataForObject(Plugin, 'Plugin', VOID, VOID, [HttpClientPlugin]);
  initMetadataForLambda(BodyProgress$handle$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(BodyProgress$handle$slambda_1, CoroutineImpl, VOID, [2]);
  initMetadataForClass(BodyProgress, 'BodyProgress');
  initMetadataForClass(ResponseException, 'ResponseException', VOID, IllegalStateException);
  initMetadataForClass(RedirectResponseException, 'RedirectResponseException', VOID, ResponseException);
  initMetadataForClass(ClientRequestException, 'ClientRequestException', VOID, ResponseException);
  initMetadataForClass(ServerResponseException, 'ServerResponseException', VOID, ResponseException);
  initMetadataForLambda(addDefaultResponseValidation$lambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(defaultTransformers$2$content$1, VOID, VOID, ByteArrayContent_0);
  initMetadataForClass(defaultTransformers$2$content$2, VOID, VOID, ReadChannelContent);
  initMetadataForLambda(defaultTransformers$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(defaultTransformers$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(defaultTransformers$slambda_1, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(HttpCallValidator$Companion$install$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(HttpCallValidator$Companion$install$slambda_1, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(HttpCallValidator$Companion$install$slambda_3, CoroutineImpl, VOID, [2]);
  initMetadataForClass(Config, 'Config', Config);
  initMetadataForCompanion(Companion_385, VOID, [HttpClientPlugin]);
  initMetadataForCoroutine($validateResponseCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($processExceptionCOROUTINE$, CoroutineImpl);
  initMetadataForClass(HttpCallValidator, 'HttpCallValidator', VOID, VOID, VOID, [1, 2]);
  initMetadataForClass(ExceptionHandlerWrapper, 'ExceptionHandlerWrapper');
  initMetadataForClass(RequestExceptionHandlerWrapper, 'RequestExceptionHandlerWrapper');
  initMetadataForClass(HttpRequest$1, VOID, VOID, VOID, [HttpRequest_0]);
  initMetadataForLambda(HttpPlainText$Plugin$install$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(HttpPlainText$Plugin$install$slambda_1, CoroutineImpl, VOID, [2]);
  initMetadataForClass(Config_0, 'Config', Config_0);
  initMetadataForObject(Plugin_0, 'Plugin', VOID, VOID, [HttpClientPlugin]);
  initMetadataForClass(sam$kotlin_Comparator$0_4, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
  initMetadataForClass(HttpPlainText, 'HttpPlainText');
  initMetadataForLambda(HttpRedirect$Plugin$install$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForCoroutine($handleCallCOROUTINE$, CoroutineImpl);
  initMetadataForClass(Config_1, 'Config', Config_1);
  initMetadataForObject(Plugin_1, 'Plugin', VOID, VOID, [HttpClientPlugin], [5]);
  initMetadataForClass(HttpRedirect, 'HttpRedirect');
  initMetadataForLambda(HttpRequestLifecycle$Plugin$install$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForObject(Plugin_2, 'Plugin', VOID, VOID, [HttpClientPlugin]);
  initMetadataForClass(HttpRequestLifecycle, 'HttpRequestLifecycle');
  initMetadataForLambda(HttpSend$Plugin$install$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForCoroutine($executeCOROUTINE$_1, CoroutineImpl);
  initMetadataForClass(Config_2, 'Config', Config_2);
  initMetadataForObject(Plugin_3, 'Plugin', VOID, VOID, [HttpClientPlugin]);
  initMetadataForInterface(Sender, 'Sender', VOID, VOID, VOID, [1]);
  initMetadataForClass(InterceptedSender, 'InterceptedSender', VOID, VOID, [Sender], [1]);
  initMetadataForClass(DefaultSender, 'DefaultSender', VOID, VOID, [Sender], [1]);
  initMetadataForClass(HttpSend, 'HttpSend');
  initMetadataForClass(SendCountExceedException, 'SendCountExceedException', VOID, IllegalStateException);
  initMetadataForCompanion(Companion_386);
  initMetadataForLambda(HttpTimeout$Plugin$install$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(HttpTimeout$Plugin$install$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForClass(HttpTimeoutCapabilityConfiguration, 'HttpTimeoutCapabilityConfiguration', HttpTimeoutCapabilityConfiguration_init_$Create$);
  initMetadataForObject(Plugin_4, 'Plugin', VOID, VOID, [HttpClientPlugin]);
  initMetadataForClass(HttpTimeout, 'HttpTimeout');
  initMetadataForClass(HttpRequestTimeoutException, 'HttpRequestTimeoutException', VOID, IOException);
  initMetadataForClass(DelegatedCall, 'DelegatedCall', VOID, HttpClientCall, VOID, [0, 1]);
  initMetadataForClass(DelegatedRequest, 'DelegatedRequest', VOID, VOID, [HttpRequest_0]);
  initMetadataForClass(DelegatedResponse, 'DelegatedResponse', VOID, HttpResponse);
  initMetadataForClass(DefaultClientWebSocketSession, 'DefaultClientWebSocketSession', VOID, VOID, [WebSocketSession, DefaultWebSocketSession], [0, 1]);
  initMetadataForClass(DelegatingClientWebSocketSession, 'DelegatingClientWebSocketSession', VOID, VOID, [WebSocketSession], [0, 1]);
  initMetadataForClass(ClientUpgradeContent, 'ClientUpgradeContent', VOID, NoContent, VOID, [1]);
  initMetadataForClass(WebSocketContent, 'WebSocketContent', WebSocketContent, ClientUpgradeContent, VOID, [1]);
  initMetadataForLambda(WebSockets$Plugin$install$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(WebSockets$Plugin$install$slambda_1, CoroutineImpl, VOID, [2]);
  initMetadataForClass(Config_3, 'Config', Config_3);
  initMetadataForObject(Plugin_5, 'Plugin', VOID, VOID, [HttpClientPlugin]);
  initMetadataForClass(WebSockets, 'WebSockets');
  initMetadataForObject(WebSocketExtensionsCapability, 'WebSocketExtensionsCapability');
  initMetadataForObject(WebSocketCapability, 'WebSocketCapability');
  initMetadataForClass(WebSocketException, 'WebSocketException', VOID, IllegalStateException);
  initMetadataForCoroutine($webSocketCOROUTINE$, CoroutineImpl);
  initMetadataForClass(DefaultHttpRequest, 'DefaultHttpRequest', VOID, VOID, [HttpRequest_0]);
  initMetadataForCompanion(Companion_387);
  initMetadataForClass(HttpRequestBuilder, 'HttpRequestBuilder', HttpRequestBuilder);
  initMetadataForClass(HttpRequestData, 'HttpRequestData');
  initMetadataForClass(HttpResponseData, 'HttpResponseData');
  initMetadataForObject(Phases, 'Phases');
  initMetadataForClass(HttpRequestPipeline, 'HttpRequestPipeline', HttpRequestPipeline, Pipeline, VOID, [2]);
  initMetadataForObject(Phases_0, 'Phases');
  initMetadataForClass(HttpSendPipeline, 'HttpSendPipeline', HttpSendPipeline, Pipeline, VOID, [2]);
  initMetadataForClass(DefaultHttpResponse, 'DefaultHttpResponse', VOID, HttpResponse);
  initMetadataForCoroutine($bodyAsTextCOROUTINE$, CoroutineImpl);
  initMetadataForObject(Phases_1, 'Phases');
  initMetadataForClass(HttpResponsePipeline, 'HttpResponsePipeline', HttpResponsePipeline, Pipeline, VOID, [2]);
  initMetadataForObject(Phases_2, 'Phases');
  initMetadataForClass(HttpReceivePipeline, 'HttpReceivePipeline', HttpReceivePipeline, Pipeline, VOID, [2]);
  initMetadataForClass(HttpResponseContainer, 'HttpResponseContainer');
  initMetadataForLambda(HttpStatement$execute$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($executeCOROUTINE$_2, CoroutineImpl);
  initMetadataForCoroutine($executeUnsafeCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($cleanupCOROUTINE$, CoroutineImpl);
  initMetadataForClass(HttpStatement, 'HttpStatement', VOID, VOID, VOID, [1, 0]);
  initMetadataForLambda(observable$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(HttpResponseReceiveFail, 'HttpResponseReceiveFail');
  initMetadataForObject(EmptyContent, 'EmptyContent', VOID, NoContent);
  initMetadataForObject(Js, 'Js');
  initMetadataForClass(JsClientEngine$createWebSocket$headers_capturingHack$1);
  initMetadataForCoroutine($executeCOROUTINE$_3, CoroutineImpl);
  initMetadataForCoroutine($executeWebSocketRequestCOROUTINE$, CoroutineImpl);
  initMetadataForClass(JsClientEngine, 'JsClientEngine', VOID, HttpClientEngineBase, VOID, [1, 2]);
  initMetadataForClass(JsError, 'JsError', VOID, Error);
  initMetadataForLambda(toRaw$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($toRawCOROUTINE$, CoroutineImpl);
  initMetadataForLambda(channelFromStream$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(readBodyNode$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(JsWebSocketSession$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(JsWebSocketSession, 'JsWebSocketSession', VOID, VOID, [DefaultWebSocketSession], [0, 1]);
  initMetadataForCompanion(Companion_388);
  initMetadataForObject($serializer_38, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(UsageEntryDocumentDto, 'UsageEntryDocumentDto', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_36});
  initMetadataForCompanion(Companion_389);
  initMetadataForObject($serializer_39, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(FindUsageServiceRequest, 'FindUsageServiceRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_37});
  initMetadataForCompanion(Companion_390);
  initMetadataForObject($serializer_40, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(FindUsageDocumentInfo, 'FindUsageDocumentInfo', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_38});
  initMetadataForClass(FindUsagePageEntry, 'FindUsagePageEntry');
  initMetadataForInterface(FindUsageRequestController, 'FindUsageRequestController', VOID, VOID, [Disposable], [0, 1]);
  initMetadataForCompanion(Companion_391);
  initMetadataForObject($serializer_41, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(FindUsageResultTotals, 'FindUsageResultTotals', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_39});
  initMetadataForClass(FindUsageResultsPaged, 'FindUsageResultsPaged', VOID, VOID, VOID, [0]);
  initMetadataForLambda(createFindUsageResultsPaged$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(createFindUsageResultsPaged$slambda_1, CoroutineImpl, VOID, [0]);
  initMetadataForLambda(createFindUsageResultsPaged$slambda_3, CoroutineImpl, VOID, [0]);
  initMetadataForLambda(createFindUsageResultsPaged$slambda_5, CoroutineImpl, VOID, [0]);
  initMetadataForLambda(createFindUsageNodesPaged$slambda, CoroutineImpl, VOID, [0]);
  initMetadataForLambda(createFindUsageNodesPaged$slambda_1, CoroutineImpl, VOID, [0]);
  initMetadataForCoroutine($createFindUsageResultsPagedCOROUTINE$, CoroutineImpl);
  initMetadataForCompanion(Companion_392, VOID, [SerializerFactory]);
  initMetadataForClass($serializer_42, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(Page_2, 'Page', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_392});
  initMetadataForCoroutine($toNextPageCOROUTINE$, CoroutineImpl);
  initMetadataForClass(Paged$Companion$invoke$1, VOID, VOID, VOID, VOID, [0]);
  initMetadataForCompanion(Companion_393);
  initMetadataForFunctionReference(Paged$total$ref, VOID, VOID, [0]);
  initMetadataForLambda(map$slambda, CoroutineImpl, VOID, [0]);
  initMetadataForCoroutine($nextPageCOROUTINE$, CoroutineImpl);
  initMetadataForObject(PublishedFindUsageRequestControllerSerializer, 'PublishedFindUsageRequestControllerSerializer', VOID, InstancePublicationSerializer);
  initMetadataForLambda(RemoteFindUsageRequestController$Companion$nextDocuments$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(RemoteFindUsageRequestController$Companion$nextNodeEntries$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(RemoteFindUsageRequestController$Companion$totals$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForCompanion(Companion_394, InstanceDescriptor);
  initMetadataForClass(RemoteFindUsageRequestController, 'RemoteFindUsageRequestController', VOID, VOID, [FindUsageRequestController], [0, 1]);
  initMetadataForLambda(PerformanceMonitoringClient$job$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(PerformanceMonitoringClient, 'PerformanceMonitoringClient');
  initMetadataForClass(MetricKind, 'MetricKind', VOID, Enum);
  initMetadataForCompanion(Companion_395);
  initMetadataForObject($serializer_43, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(PerformanceMonitoringMetric, 'PerformanceMonitoringMetric', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_40});
  initMetadataForCompanion(Companion_396);
  initMetadataForObject($serializer_44, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(AccessionDto, 'AccessionDto', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_41});
  initMetadataForCompanion(Companion_397);
  initMetadataForObject($serializer_45, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(DraftQueryCoordinates, 'DraftQueryCoordinates', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_42});
  initMetadataForLambda(EditorService$Companion$openDocument$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(EditorService$Companion$findUsages$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(EditorService$Companion$openDraftQuery$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForInterface(EditorService, 'EditorService', VOID, VOID, [CoroutineScope], [1, 2]);
  initMetadataForClass(Remote_0, 'Remote', VOID, VOID, [EditorService, CoroutineScope], [1, 2]);
  initMetadataForCompanion(Companion_398, InstanceDescriptor);
  initMetadataForLambda(EditorServiceClient$openDocument$o$collect$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($collectCOROUTINE$_24, CoroutineImpl);
  initMetadataForLambda(EditorServiceClient$openDraftQuery$o$collect$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($collectCOROUTINE$_25, CoroutineImpl);
  initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0_23, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
  initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0_24, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
  initMetadataForClass(EditorServiceClient$openDocument$$inlined$map$1, VOID, VOID, VOID, [Flow], [1]);
  initMetadataForClass(EditorServiceClient$openDraftQuery$$inlined$map$1, VOID, VOID, VOID, [Flow], [1]);
  initMetadataForCoroutine($findUsagesCOROUTINE$, CoroutineImpl);
  initMetadataForClass(EditorServiceClient, 'EditorServiceClient', VOID, VOID, VOID, [1, 2]);
  initMetadataForLambda(editorServiceClient$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(createEditorServiceClient$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(WebsocketEditorServiceProvider$client$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(WebsocketEditorServiceProvider$client$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(WebsocketEditorServiceProvider, 'WebsocketEditorServiceProvider', VOID, VOID, [Disposable], [0]);
  initMetadataForCompanion(Companion_399);
  initMetadataForClass(ClientId, 'ClientId', ClientId_init_$Create$, BaseId);
  initMetadataForCompanion(Companion_400);
  initMetadataForClass(ConnectionId, 'ConnectionId', ConnectionId_init_$Create$, BaseId);
  initMetadataForInterface(StringChannel, 'StringChannel');
  initMetadataForInterface(JsonChannel, 'JsonChannel');
  initMetadataForClass(JsonService$Companion$toStringPort$1$setOutput$$inlined$jsonChannel$1, VOID, VOID, VOID, [JsonChannel]);
  initMetadataForClass(JsonService$Companion$toStringPort$$inlined$stringChannel$1, VOID, VOID, VOID, [StringChannel]);
  initMetadataForClass(JsonService$Companion$toStringPort$1, VOID, VOID, VOID, [Disposable]);
  initMetadataForCompanion(Companion_401);
  initMetadataForClass(JsonServiceEndpoint, 'JsonServiceEndpoint', VOID, VOID, [Disposable]);
  initMetadataForClass(AsyncsListHandler, 'AsyncsListHandler', AsyncsListHandler);
  initMetadataForClass(LoadedEntitiesTree, 'LoadedEntitiesTree', LoadedEntitiesTree);
  initMetadataForCompanion(Companion_402);
  initMetadataForClass(LoadedEntitiesTreeElement, 'LoadedEntitiesTreeElement');
  initMetadataForClass(LoadedEntitiesTreeReconnectHelper, 'LoadedEntitiesTreeReconnectHelper');
  initMetadataForInterface(OtChannel, 'OtChannel');
  initMetadataForClass(OtChannelAdapter, 'OtChannelAdapter', OtChannelAdapter, VOID, [OtChannel]);
  initMetadataForClass(OtChannelDelegate, 'OtChannelDelegate', VOID, VOID, [OtChannel]);
  initMetadataForClass(sam$jetbrains_ocelot_base_edt_EdtTask$0_17, 'sam$jetbrains_ocelot_base_edt_EdtTask$0', VOID, VOID, [EdtTask, FunctionAdapter]);
  initMetadataForClass(PortExecutingDelegate, 'PortExecutingDelegate', VOID, VOID, [Disposable]);
  initMetadataForObject(RootOperationsUtil, 'RootOperationsUtil');
  initMetadataForClass(RootReconnectData, 'RootReconnectData');
  initMetadataForCompanion(Companion_403);
  initMetadataForClass(sam$jetbrains_ocelot_base_edt_EdtTask$0_18, 'sam$jetbrains_ocelot_base_edt_EdtTask$0', VOID, VOID, [EdtTask, FunctionAdapter]);
  initMetadataForClass(ThrottlingJsonPort$createChannelDelegate$$inlined$jsonChannel$1, VOID, VOID, VOID, [JsonChannel]);
  initMetadataForClass(ThrottlingJsonPort, 'ThrottlingJsonPort', VOID, PortExecutingDelegate);
  initMetadataForClass(ProtocolPersistentParameter, 'ProtocolPersistentParameter', VOID, VOID, [PersistentParameter]);
  initMetadataForClass(BooleanPersistentParameter, 'BooleanPersistentParameter', VOID, ProtocolPersistentParameter);
  initMetadataForClass(LongPersistentParameter, 'LongPersistentParameter', VOID, ProtocolPersistentParameter);
  initMetadataForClass(StringPersistentParameter, 'StringPersistentParameter', VOID, ProtocolPersistentParameter);
  initMetadataForClass(ProtocolParameters$RECONNECT_ENABLED$1, VOID, VOID, BooleanPersistentParameter);
  initMetadataForClass(ProtocolParameters$PING_TIMEOUT_MS$1, VOID, VOID, LongPersistentParameter);
  initMetadataForClass(ProtocolParameters$ID_COMPRESSION_ENABLED$1, VOID, VOID, BooleanPersistentParameter);
  initMetadataForClass(ProtocolParameters$PARTIAL_LOADING_ENABLED$1, VOID, VOID, BooleanPersistentParameter);
  initMetadataForClass(ProtocolParameters$OT_VERSION$1, VOID, VOID, StringPersistentParameter);
  initMetadataForObject(ProtocolParameters, 'ProtocolParameters');
  initMetadataForClass(ProtocolPersistentContext, 'ProtocolPersistentContext', ProtocolPersistentContext, ConfigurationPersistentContext);
  initMetadataForCompanion(Companion_404);
  initMetadataForClass(CommandDeserializer, 'CommandDeserializer', VOID, VOID, [Disposable]);
  initMetadataForCompanion(Companion_405);
  initMetadataForClass(CommandSerializer, 'CommandSerializer');
  initMetadataForClass(DictionaryAwareOperationDeserializer, 'DictionaryAwareOperationDeserializer', VOID, DictionaryAwareDeserializer);
  initMetadataForClass(DictionaryAwareOperationSerializer, 'DictionaryAwareOperationSerializer', VOID, DictionaryAwareSerializer);
  initMetadataForClass(Json2OtChannelAdapter$Companion$getFullSerializerFactory$$inlined$commandSerializerFactory$1);
  initMetadataForCompanion(Companion_406);
  initMetadataForClass(Json2OtChannelAdapter$$inlined$entityOperationPersistenceContextFactory$1);
  initMetadataForClass(JsonReconnectHelper, 'JsonReconnectHelper');
  initMetadataForClass(Json2OtChannelAdapter$1, VOID, VOID, JsonReconnectHelper);
  initMetadataForClass(Json2OtChannelAdapter, 'Json2OtChannelAdapter', VOID, VOID, [OtChannel]);
  initMetadataForClass(Data, 'Data');
  initMetadataForClass(LoadedEntitiesTreeElementPersister, 'LoadedEntitiesTreeElementPersister', LoadedEntitiesTreeElementPersister);
  initMetadataForClass(MyRootCommandData, 'MyRootCommandData');
  initMetadataForClass(Ot2JsonChannelAdapter$persistenceContextFactory$$inlined$entityOperationPersistenceContextFactory$1);
  initMetadataForClass(Ot2JsonChannelAdapter$reconnectHelper$1, VOID, VOID, JsonReconnectHelper);
  initMetadataForClass(Ot2JsonChannelAdapter, 'Ot2JsonChannelAdapter', VOID, VOID, [JsonChannel]);
  initMetadataForClass(RootReconnectDataPersister, 'RootReconnectDataPersister', RootReconnectDataPersister);
  initMetadataForClass(EndpointMultiplexPort$ServiceEndpointPort$setOutput$$inlined$stringChannel$1, VOID, VOID, VOID, [StringChannel]);
  initMetadataForClass(ServiceEndpointPort, 'ServiceEndpointPort', VOID, VOID, [Disposable]);
  initMetadataForCompanion(Companion_407);
  initMetadataForInterface(ServiceContainerChannel, 'ServiceContainerChannel');
  initMetadataForClass(EndpointMultiplexPort$input$$inlined$serviceContainerChannel$1, VOID, VOID, VOID, [ServiceContainerChannel]);
  initMetadataForClass(EndpointMultiplexPort$outputChannel$$inlined$serviceContainerChannel$1, VOID, VOID, VOID, [ServiceContainerChannel]);
  initMetadataForClass(EndpointMultiplexPort, 'EndpointMultiplexPort', VOID, VOID, [Disposable]);
  initMetadataForClass(EndpointMultiplexPortState, 'EndpointMultiplexPortState', VOID, Enum);
  initMetadataForClass(FatalEndpointException, 'FatalEndpointException', FatalEndpointException_init_$Create$, RuntimeException);
  initMetadataForClass(sam$jetbrains_ocelot_base_edt_EdtTask$0_19, 'sam$jetbrains_ocelot_base_edt_EdtTask$0', VOID, VOID, [EdtTask, FunctionAdapter]);
  initMetadataForClass(JsonChannelExecutingDelegate, 'JsonChannelExecutingDelegate', VOID, VOID, [JsonChannel]);
  initMetadataForClass(JsonPortExecutingDelegate$setOutput$$inlined$jsonChannel$1, VOID, VOID, VOID, [JsonChannel]);
  initMetadataForClass(JsonPortExecutingDelegate, 'JsonPortExecutingDelegate', VOID, PortExecutingDelegate);
  initMetadataForObject(PingPongServiceConstants, 'PingPongServiceConstants');
  initMetadataForClass(sam$jetbrains_ocelot_base_edt_EdtTask$0_20, 'sam$jetbrains_ocelot_base_edt_EdtTask$0', VOID, VOID, [EdtTask, FunctionAdapter]);
  initMetadataForClass(PingPongServiceEndpoint$MyPort$input$$inlined$jsonChannel$1, VOID, VOID, VOID, [JsonChannel]);
  initMetadataForClass(MyPort, 'MyPort', VOID, VOID, [Disposable]);
  initMetadataForCompanion(Companion_408);
  initMetadataForClass(PingPongServiceEndpoint, 'PingPongServiceEndpoint', VOID, JsonServiceEndpoint);
  initMetadataForObject(ServiceContainerConstants, 'ServiceContainerConstants');
  initMetadataForClass(ServiceContainerMessage, 'ServiceContainerMessage');
  initMetadataForClass(ServiceContainerMessagePersister, 'ServiceContainerMessagePersister', ServiceContainerMessagePersister, VOID, [NonNullPersister]);
  initMetadataForObject(ServiceContainerMessageUtil, 'ServiceContainerMessageUtil');
  initMetadataForClass(ServiceContainerSystemMessage, 'ServiceContainerSystemMessage');
  initMetadataForCompanion(Companion_409);
  initMetadataForClass(ServiceEndpointContainer$addConfigurableService$configurableService$1);
  initMetadataForClass(ServiceEndpointContainer, 'ServiceEndpointContainer', ServiceEndpointContainer, VOID, [Disposable]);
  initMetadataForClass(ServiceEndpointContainerState, 'ServiceEndpointContainerState', VOID, Enum);
  initMetadataForClass(SynchronizedAtomicReference, 'SynchronizedAtomicReference');
  initMetadataForClass(VersionMismatchException, 'VersionMismatchException', VersionMismatchException_init_$Create$, RuntimeException);
  initMetadataForCompanion(Companion_410);
  initMetadataForCompanion(Companion_411);
  initMetadataForClass(State_2, 'State', VOID, Enum);
  initMetadataForClass(EmptyListener, 'EmptyListener');
  initMetadataForClass(SocketHandler, 'SocketHandler');
  initMetadataForClass(SocketConnection$connect$socketHandler$1, VOID, VOID, SocketHandler);
  initMetadataForClass(SocketConnection$connect$6$$inlined$serviceContainerChannel$1, VOID, VOID, VOID, [ServiceContainerChannel]);
  initMetadataForClass(SocketConnection, 'SocketConnection', VOID, VOID, [Disposable]);
  initMetadataForCompanion(Companion_412);
  initMetadataForClass(sam$jetbrains_ocelot_base_edt_EdtTask$0_21, 'sam$jetbrains_ocelot_base_edt_EdtTask$0', VOID, VOID, [EdtTask, FunctionAdapter]);
  initMetadataForClass(SocketManager$1);
  initMetadataForClass(SocketManager, 'SocketManager');
  initMetadataForClass(sam$jetbrains_ocelot_base_edt_EdtTask$0_22, 'sam$jetbrains_ocelot_base_edt_EdtTask$0', VOID, VOID, [EdtTask, FunctionAdapter]);
  initMetadataForClass(ReconnectStrategy, 'ReconnectStrategy', VOID, VOID, [Disposable]);
  initMetadataForClass(UniformDelays$delays$1);
  initMetadataForClass(UniformDelays, 'UniformDelays');
  initMetadataForClass(JsWebsocket, 'JsWebsocket');
  initMetadataForClass(JsWebsocketFactory, 'JsWebsocketFactory', JsWebsocketFactory);
  initMetadataForCompanion(Companion_413);
  initMetadataForClass(AsyncWithDisposable, 'AsyncWithDisposable');
  initMetadataForClass(Client$MyPort$1, VOID, VOID, OtChannelAdapter);
  initMetadataForClass(Client$MyPort$setOutput$1, VOID, VOID, OtChannelDelegate);
  initMetadataForClass(MyPort_0, 'MyPort', VOID, VOID, [Disposable]);
  initMetadataForCompanion(Companion_414);
  initMetadataForClass(Client$init$validator$1, VOID, VOID, VOID, [OperationValidator]);
  initMetadataForClass(Client$init$listener$1, VOID, VOID, VOID, [OtCommandListener]);
  initMetadataForClass(Client, 'Client', VOID, VOID, [Disposable]);
  initMetadataForClass(ClientBuilder, 'ClientBuilder', ClientBuilder);
  initMetadataForCompanion(Companion_415);
  initMetadataForClass(ClientLoadingPeer, 'ClientLoadingPeer');
  initMetadataForClass(State_3, 'State', VOID, Enum);
  initMetadataForClass(LoadHandler, 'LoadHandler');
  initMetadataForClass(ReconnectHandler, 'ReconnectHandler');
  initMetadataForClass(EventHandler, 'EventHandler');
  initMetadataForClass(CommandEventHandler, 'CommandEventHandler', VOID, EventHandler);
  initMetadataForClass(ClientRootImpl$load$$inlined$toDisposable$1, VOID, VOID, VOID, [Disposable]);
  initMetadataForClass(ClientRootImpl, 'ClientRootImpl');
  initMetadataForClass(CommandQueue, 'CommandQueue');
  initMetadataForClass(LoadingRootData, 'LoadingRootData');
  initMetadataForClass(LoadingReferences, 'LoadingReferences', LoadingReferences);
  initMetadataForClass(Memento, 'Memento', Memento_init_$Create$);
  initMetadataForClass(OtServiceEndpoint$MyThrottlingJsonPort$2$wrappedClientPort$1$input$1, VOID, VOID, OtChannelDelegate);
  initMetadataForClass(OtServiceEndpoint$MyThrottlingJsonPort$2$wrappedClientPort$1, VOID, VOID, VOID, [Disposable]);
  initMetadataForClass(OtServiceEndpoint$CommonJsonPort$$inlined$jsonChannel$1, VOID, VOID, VOID, [JsonChannel]);
  initMetadataForClass(ExecutingJsonPort, 'ExecutingJsonPort', VOID, JsonPortExecutingDelegate);
  initMetadataForClass(MyThrottlingJsonPort, 'MyThrottlingJsonPort', VOID, ThrottlingJsonPort);
  initMetadataForClass(CommonJsonPort, 'CommonJsonPort', VOID, VOID, [Disposable]);
  initMetadataForCompanion(Companion_416);
  initMetadataForClass(OtServiceEndpoint, 'OtServiceEndpoint', VOID, JsonServiceEndpoint);
  function onCommandExecuted(command) {
  }
  function onCommandTransited(command) {
  }
  function onCommandReceived(command) {
  }
  function onAlreadyProcessed(command) {
  }
  function onReconnectRejected(id, reason) {
  }
  function onCommandAccepted(id) {
  }
  function onCommandRejected(id, reason) {
  }
  function onUnloadHandled(id, rootIds) {
  }
  function onConnectionEstablished() {
  }
  function onConnectionBroken() {
  }
  function onCommandUnprocessed(id) {
  }
  function onLoadRequested(reference) {
  }
  function onLoadAccepted(reference) {
  }
  function onLoadRejected(reference, reason) {
  }
  function onHistoryAccepted(id, history) {
  }
  function onHistoryRejected(id, reason) {
  }
  initMetadataForInterface(ProtocolListener, 'ProtocolListener');
  initMetadataForClass(IncomingAcceptance, 'IncomingAcceptance');
  initMetadataForClass(IncomingRejection, 'IncomingRejection');
  initMetadataForClass(IncomingRequest, 'IncomingRequest', IncomingRequest);
  initMetadataForClass(OutgoingRequest, 'OutgoingRequest', OutgoingRequest);
  initMetadataForCoroutine($runSuspendCOROUTINE$_139, CoroutineImpl);
  initMetadataForClass(ResolveResult, 'ResolveResult');
  initMetadataForClass(sam$jetbrains_ocelot_base_disposable_Disposable$0_8, 'sam$jetbrains_ocelot_base_disposable_Disposable$0', VOID, VOID, [Disposable, FunctionAdapter]);
  initMetadataForClass(BTBCategoriesWatcher$watch$2$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(BTBCategoriesWatcher, 'BTBCategoriesWatcher');
  initMetadataForInterface(CachingNodeEditor, 'CachingNodeEditor', VOID, VOID, [Disposable], [1]);
  initMetadataForClass(EditorCache, 'EditorCache');
  initMetadataForLambda(CachingNodeEditorImpl$open$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($openCOROUTINE$, CoroutineImpl);
  initMetadataForClass(NodeEditorBase, 'NodeEditorBase', VOID, VOID, [Disposable], [1]);
  initMetadataForClass(CachingNodeEditorImpl, 'CachingNodeEditorImpl', VOID, NodeEditorBase, [NodeEditorBase, CachingNodeEditor], [1]);
  initMetadataForClass(serializeProjectionalContentKind$1$persister$1, VOID, VOID, VOID, [Persister]);
  initMetadataForClass(serializeProjectionalContentKind$1, VOID, VOID, ProjectionalClipboardContentSerializationAsHtml);
  initMetadataForClass(EditableNodePart, 'EditableNodePart');
  initMetadataForCompanion(Companion_417);
  initMetadataForCoroutine($findUsagesOfCurrentNodeCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($navigateCOROUTINE$, CoroutineImpl);
  initMetadataForClass(EditorComponent, 'EditorComponent', VOID, VOID, [Disposable], [0]);
  initMetadataForInterface(EditorOpeningMonitoring, 'EditorOpeningMonitoring');
  initMetadataForClass(sam$jetbrains_biokb_editor_EditorOpeningMonitoring$0, 'sam$jetbrains_biokb_editor_EditorOpeningMonitoring$0', VOID, VOID, [EditorOpeningMonitoring, FunctionAdapter]);
  initMetadataForCompanion(Companion_418);
  initMetadataForClass(ByEditorService, 'ByEditorService', VOID, VOID, [EditorOpeningMonitoring]);
  initMetadataForLambda(NodeEditorBase$findUsagesOfCurrentNode$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(NodeEditorBase$navigate$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(NodeEditorBase$singleOpenTask$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(ContentChangeListener, 'ContentChangeListener', VOID, VOID, [OtCommandListener]);
  initMetadataForCompanion(Companion_419);
  initMetadataForClass(sam$jetbrains_ocelot_base_disposable_Disposable$0_9, 'sam$jetbrains_ocelot_base_disposable_Disposable$0', VOID, VOID, [Disposable, FunctionAdapter]);
  initMetadataForLambda(NodeEditorBase$findUsagesOfCurrentNode$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(NodeEditorBase$navigate$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(NodeEditorBase$registerActions$1, VOID, VOID, CellTrait);
  initMetadataForLambda(NodeEditorBase$singleOpenTask$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(NodeEditorBase$doOpen$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($doOpenCOROUTINE$, CoroutineImpl);
  initMetadataForClass(NodeEditorPart, 'NodeEditorPart');
  initMetadataForClass(sam$jetbrains_ocelot_base_edt_EdtTask$0_23, 'sam$jetbrains_ocelot_base_edt_EdtTask$0', VOID, VOID, [EdtTask, FunctionAdapter]);
  initMetadataForClass(NodeSelection, 'NodeSelection', VOID, Enum);
  initMetadataForClass(NodeSelection$CARET, 'CARET', VOID, NodeSelection);
  initMetadataForClass(NodeSelection$BACKGROUND, 'BACKGROUND', VOID, NodeSelection);
  initMetadataForLambda(NonCachingNodeEditor$open$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($doOpenCOROUTINE$_0, CoroutineImpl);
  initMetadataForClass(NonCachingNodeEditor, 'NonCachingNodeEditor', VOID, NodeEditorBase, [NodeEditorBase, Disposable], [1]);
  initMetadataForLambda(OneJobRunner$run$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(OneJobRunner$run$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(OneJobRunner, 'OneJobRunner', OneJobRunner, VOID, VOID, [1]);
  initMetadataForClass(readOnlyBlock$2$readOnlyConfig$1, VOID, VOID, VOID, [InternalEditorBuilderConfig]);
  initMetadataForClass(createReadOnlyBuilder$1, VOID, VOID, VOID, [InternalEditorBuilder]);
  initMetadataForObject(URLHandler, 'URLHandler', VOID, URLCellTrait);
  initMetadataForCoroutine($getDocumentContentCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($getReferenceToPaperCOROUTINE$, CoroutineImpl);
  initMetadataForClass(EditorDocumentsApi, 'EditorDocumentsApi', VOID, VOID, VOID, [1]);
  initMetadataForCoroutine($calculateResolversCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($measureMetricsCOROUTINE$, CoroutineImpl);
  initMetadataForClass(EditorsApi, 'EditorsApi', VOID, VOID, VOID, [2, 1]);
  initMetadataForCoroutine($getDocumentResolvedCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($getDocumentResolvedCOROUTINE$_0, CoroutineImpl);
  initMetadataForClass(ExplorerApi, 'ExplorerApi', VOID, VOID, VOID, [3]);
  initMetadataForCoroutine($getQueryResolvedCOROUTINE$, CoroutineImpl);
  initMetadataForClass(QueriesApi, 'QueriesApi', VOID, VOID, VOID, [1]);
  initMetadataForClass(EventType_0, 'EventType', EventType_0);
  initMetadataForClass(Event_1, 'Event', Event_1);
  initMetadataForClass(NodePointerEvent, 'NodePointerEvent', VOID, Event_1);
  initMetadataForClass(FindUsagesEvent, 'FindUsagesEvent', VOID, NodePointerEvent);
  initMetadataForClass(CategoryInfo, 'CategoryInfo');
  initMetadataForClass(BTBCategoryEvent, 'BTBCategoryEvent', VOID, Event_1);
  initMetadataForClass(FactSelectionEvent, 'FactSelectionEvent', VOID, Event_1);
  initMetadataForClass(ErrorEvent, 'ErrorEvent', VOID, Event_1);
  initMetadataForClass(BTBCategoryEventKind, 'BTBCategoryEventKind', VOID, Enum);
  initMetadataForClass(FIRST_EDIT$1, VOID, VOID, EventType_0);
  initMetadataForClass(NAVIGATE$1, VOID, VOID, EventType_0);
  initMetadataForClass(FIND_USAGES$1, VOID, VOID, EventType_0);
  initMetadataForClass(BTB_CATEGORY_EVENT$1, VOID, VOID, EventType_0);
  initMetadataForClass(FACT_SELECTION_EVENT$1, VOID, VOID, EventType_0);
  initMetadataForClass(ERROR_EVENT$1, VOID, VOID, EventType_0);
  initMetadataForClass(Notifier$subscribe$$inlined$toDisposable$1, VOID, VOID, VOID, [Disposable]);
  initMetadataForClass(Notifier, 'Notifier', Notifier);
  initMetadataForClass(ExplorableNodeInfo, 'ExplorableNodeInfo', VOID, VOID, [Disposable]);
  initMetadataForClass(EditableNodeInfo, 'EditableNodeInfo', VOID, ExplorableNodeInfo);
  initMetadataForClass(OtDocumentInfo, 'OtDocumentInfo');
  initMetadataForClass(sam$jetbrains_ocelot_base_disposable_Disposable$0_10, 'sam$jetbrains_ocelot_base_disposable_Disposable$0', VOID, VOID, [Disposable, FunctionAdapter]);
  initMetadataForClass(ClientConnection, 'ClientConnection');
  initMetadataForCompanion(Companion_420);
  initMetadataForClass(OtEnvironment$clientConnectionLazy$2$1);
  initMetadataForClass(OtEnvironment, 'OtEnvironment', VOID, VOID, [Disposable], [1]);
  initMetadataForInterface(DocumentSource, 'DocumentSource');
  initMetadataForClass(DocumentSourceDescriptor, 'DocumentSourceDescriptor');
  initMetadataForLambda(DraftQuerySource$load$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(DraftQuerySource$load$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(DraftQuerySource, 'DraftQuerySource', VOID, VOID, [DocumentSource], [0]);
  initMetadataForLambda(EditedDocumentSource$load$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(EditedDocumentSource$load$slambda$slambda_1, CoroutineImpl, VOID, [1]);
  initMetadataForCompanion(Companion_421);
  initMetadataForClass(sam$jetbrains_ocelot_base_disposable_Disposable$0_11, 'sam$jetbrains_ocelot_base_disposable_Disposable$0', VOID, VOID, [Disposable, FunctionAdapter]);
  initMetadataForLambda(EditedDocumentSource$load$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(EditedDocumentSource$launchPropertiesSync$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(EditedDocumentSource, 'EditedDocumentSource', VOID, VOID, [DocumentSource], [0]);
  initMetadataForCoroutine($loadSerializedResolvedNodeCOROUTINE$, CoroutineImpl);
  initMetadataForClass(PrecalculatedResolversDocumentSource, 'PrecalculatedResolversDocumentSource', VOID, VOID, [DocumentSource], [0]);
  initMetadataForClass(EditedOntologyBrowserSource, 'EditedOntologyBrowserSource', VOID, PrecalculatedResolversDocumentSource, VOID, [0]);
  initMetadataForLambda(EditedWorkingCopySource$load$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(EditedWorkingCopySource$load$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(EditedWorkingCopySource, 'EditedWorkingCopySource', VOID, VOID, [DocumentSource], [0]);
  initMetadataForClass(ExploredDocumentSource, 'ExploredDocumentSource', VOID, PrecalculatedResolversDocumentSource, VOID, [0]);
  initMetadataForCoroutine($loadSerializedResolvedNodeCOROUTINE$_0, CoroutineImpl);
  initMetadataForClass(ExploredOntologyBrowserSource, 'ExploredOntologyBrowserSource', VOID, PrecalculatedResolversDocumentSource, VOID, [0]);
  initMetadataForClass(HistoryPanelDocumentSource, 'HistoryPanelDocumentSource', VOID, PrecalculatedResolversDocumentSource, VOID, [0]);
  initMetadataForClass(PathEntrySource, 'PathEntrySource', VOID, PrecalculatedResolversDocumentSource, VOID, [0]);
  initMetadataForCoroutine($loadCOROUTINE$, CoroutineImpl);
  initMetadataForClass(PublishedQuerySource, 'PublishedQuerySource', VOID, PrecalculatedResolversDocumentSource, VOID, [0]);
  initMetadataForClass(UsageEntrySource, 'UsageEntrySource', VOID, VOID, [DocumentSource], [0]);
  initMetadataForClass(BTBUsageDeserializerImpl, 'BTBUsageDeserializerImpl');
  initMetadataForObject(BTBEditor, 'BTBEditor', VOID, EditorScope);
  initMetadataForClass(_no_name_provided__qut3iv_5, VOID, VOID, CellTrait);
  initMetadataForClass(_no_name_provided__qut3iv_6, VOID, VOID, VOID, [ReferenceCellBuilder]);
  initMetadataForClass(_no_name_provided__qut3iv_7, VOID, VOID, CellTrait);
  initMetadataForClass(_no_name_provided__qut3iv_8, VOID, VOID, VOID, [ReferenceCellBuilder]);
  initMetadataForClass(_no_name_provided__qut3iv_9, VOID, VOID, CellTrait);
  initMetadataForClass(_no_name_provided__qut3iv_10, VOID, VOID, VOID, [ReferenceCellBuilder]);
  initMetadataForClass(_no_name_provided__qut3iv_11, VOID, VOID, CellTrait);
  initMetadataForClass(_no_name_provided__qut3iv_12, VOID, VOID, VOID, [ReferenceCellBuilder]);
  initMetadataForClass(_no_name_provided__qut3iv_13, VOID, VOID, CellTrait);
  initMetadataForClass(_no_name_provided__qut3iv_14, VOID, VOID, VOID, [ReferenceCellBuilder]);
  initMetadataForClass(_no_name_provided__qut3iv_15, VOID, VOID, CellTrait);
  initMetadataForClass(_no_name_provided__qut3iv_16, VOID, VOID, VOID, [ReferenceCellBuilder]);
  initMetadataForClass(_no_name_provided__qut3iv_17, VOID, VOID, CellTrait);
  initMetadataForClass(_no_name_provided__qut3iv_18, VOID, VOID, VOID, [ReferenceCellBuilder]);
  initMetadataForClass(_no_name_provided__qut3iv_19, VOID, VOID, CellTrait);
  initMetadataForClass(_no_name_provided__qut3iv_20, VOID, VOID, VOID, [ReferenceCellBuilder]);
  initMetadataForClass(_no_name_provided__qut3iv_21, VOID, VOID, CellTrait);
  initMetadataForClass(_no_name_provided__qut3iv_22, VOID, VOID, VOID, [ReferenceCellBuilder]);
  initMetadataForClass(_no_name_provided__qut3iv_23, VOID, VOID, CellTrait);
  initMetadataForClass(_no_name_provided__qut3iv_24, VOID, VOID, VOID, [ReferenceCellBuilder]);
  initMetadataForClass(_no_name_provided__qut3iv_25, VOID, VOID, CellTrait);
  initMetadataForClass(_no_name_provided__qut3iv_26, VOID, VOID, VOID, [ReferenceCellBuilder]);
  initMetadataForClass(_no_name_provided__qut3iv_27, VOID, VOID, CellTrait);
  initMetadataForClass(_no_name_provided__qut3iv_28, VOID, VOID, VOID, [ReferenceCellBuilder]);
  initMetadataForClass(_no_name_provided__qut3iv_29, VOID, VOID, CellTrait);
  initMetadataForClass(_no_name_provided__qut3iv_30, VOID, VOID, VOID, [ReferenceCellBuilder]);
  initMetadataForClass(_no_name_provided__qut3iv_31, VOID, VOID, CellTrait);
  initMetadataForClass(_no_name_provided__qut3iv_32, VOID, VOID, VOID, [ReferenceCellBuilder]);
  initMetadataForClass(_no_name_provided__qut3iv_33, VOID, VOID, CellTrait);
  initMetadataForClass(_no_name_provided__qut3iv_34, VOID, VOID, VOID, [ReferenceCellBuilder]);
  initMetadataForClass(_no_name_provided__qut3iv_35, VOID, VOID, CellTrait);
  initMetadataForClass(_no_name_provided__qut3iv_36, VOID, VOID, VOID, [ReferenceCellBuilder]);
  initMetadataForClass(_no_name_provided__qut3iv_37, VOID, VOID, CellTrait);
  initMetadataForClass(_no_name_provided__qut3iv_38, VOID, VOID, VOID, [ReferenceCellBuilder]);
  initMetadataForClass(_no_name_provided__qut3iv_39, VOID, VOID, CellTrait);
  initMetadataForClass(_no_name_provided__qut3iv_40, VOID, VOID, VOID, [ReferenceCellBuilder]);
  initMetadataForClass(_no_name_provided__qut3iv_41, VOID, VOID, CellTrait);
  initMetadataForClass(_no_name_provided__qut3iv_42, VOID, VOID, VOID, [ReferenceCellBuilder]);
  initMetadataForClass(_no_name_provided__qut3iv_43, VOID, VOID, CellTrait);
  initMetadataForClass(_no_name_provided__qut3iv_44, VOID, VOID, VOID, [ReferenceCellBuilder]);
  initMetadataForClass(_no_name_provided__qut3iv_45, VOID, VOID, CellTrait);
  initMetadataForClass(_no_name_provided__qut3iv_46, VOID, VOID, VOID, [ReferenceCellBuilder]);
  initMetadataForClass(_no_name_provided__qut3iv_47, VOID, VOID, VOID, [Query], [1]);
  initMetadataForClass(_no_name_provided__qut3iv_48, VOID, VOID, CellTrait);
  initMetadataForClass(_no_name_provided__qut3iv_49, VOID, VOID, VOID, [ReferenceCellBuilder]);
  initMetadataForClass(_no_name_provided__qut3iv_50, VOID, VOID, CellTrait);
  initMetadataForClass(_no_name_provided__qut3iv_51, VOID, VOID, VOID, [ReferenceCellBuilder]);
  initMetadataForClass(_no_name_provided__qut3iv_52, VOID, VOID, CellTrait);
  initMetadataForClass(_no_name_provided__qut3iv_53, VOID, VOID, VOID, [ReferenceCellBuilder]);
  initMetadataForInterface(BTBEditorBuilderConfig, 'BTBEditorBuilderConfig', VOID, VOID, [InternalEditorBuilderConfig]);
  initMetadataForClass(BTBEditorBuilderConfigImpl, 'BTBEditorBuilderConfigImpl', VOID, EditorBuilderConfigImpl, [EditorBuilderConfigImpl, BTBEditorBuilderConfig]);
  function get_isReadOnly() {
    return this.wtr().ntf_1.acu();
  }
  function get_highlightErrors_0() {
    return this.wtr().ntf_1.yct_1;
  }
  initMetadataForInterface(BTBEditorConfiguration, 'BTBEditorConfiguration', VOID, VOID, [CoroutineScope, ErrorCheckConfig]);
  initMetadataForClass(createBTBEditorConfiguration$1, VOID, VOID, VOID, [BTBEditorConfiguration, CoroutineScope, ErrorCheckConfig]);
  initMetadataForClass(BTBEditorUIConfig, 'BTBEditorUIConfig');
  initMetadataForCompanion(Companion_422);
  initMetadataForClass(BTBPresentation, 'BTBPresentation');
  initMetadataForClass(getEditorBuildersRootMapperFactory$1$createRootMapper$commonConfig$1, VOID, VOID, VOID, [CoroutineScope]);
  initMetadataForClass(getEditorBuildersRootMapperFactory$1);
  initMetadataForClass(btbProgramEditors$22$addTraitDeleteRelations$2$$inlined$createDeleteTransformTrait$1$doWork$1, VOID, VOID, VOID, [Query], [1]);
  initMetadataForClass(DeleteTransformTrait, 'DeleteTransformTrait', VOID, CellTrait);
  initMetadataForClass(btbProgramEditors$22$addTraitDeleteRelations$2$$inlined$createDeleteTransformTrait$1, VOID, VOID, DeleteTransformTrait);
  initMetadataForLambda(btbProgramEditors$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(btbProgramEditors$lambda$slambda, CoroutineImpl, VOID, [0]);
  initMetadataForClass(btbProgramEditors$46$6$2$6$$inlined$executeQuery$1, VOID, VOID, VOID, [Query], [1]);
  initMetadataForClass(btbProgramEditors$50$$inlined$forDisposable$1, VOID, VOID, DisposableSynchronizer);
  initMetadataForClass(btbProgramEditors$76$2$$inlined$forDisposable$1, VOID, VOID, DisposableSynchronizer);
  initMetadataForClass(btbProgramEditors$76$$inlined$forDisposable$1, VOID, VOID, DisposableSynchronizer);
  initMetadataForClass(setExpressionEditor$2$$inlined$executeQuery$1, VOID, VOID, VOID, [Query], [1]);
  initMetadataForClass(setExpressionEditor$2$$inlined$executeQuery$2, VOID, VOID, VOID, [Query], [1]);
  initMetadataForClass(sam$jetbrains_ocelot_base_edt_EdtTask$0_24, 'sam$jetbrains_ocelot_base_edt_EdtTask$0', VOID, VOID, [EdtTask, FunctionAdapter]);
  initMetadataForClass(propertyReferenceValueEditor$2$5$doAttach$2$$inlined$executeQuery$1, VOID, VOID, VOID, [Query], [1]);
  initMetadataForClass(propertyReferenceValueEditor$2$5, VOID, VOID, DisposableSynchronizer);
  initMetadataForClass(variablesEditor$$inlined$keyPressedCellTrait$1, VOID, VOID, CellTrait);
  initMetadataForCoroutine($runSuspendCOROUTINE$_140, CoroutineImpl);
  initMetadataForClass(sam$jetbrains_ocelot_langDef_completion_ActionOnCell$0_1, 'sam$jetbrains_ocelot_langDef_completion_ActionOnCell$0', VOID, VOID, [ActionOnCell, FunctionAdapter]);
  initMetadataForClass(measurableValueWithDefaultUnitCompletion$2$$inlined$executeSuspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(measurableValueWithDefaultUnitCompletion$2$$inlined$executeQuery$1, VOID, VOID, VOID, [Query], [1]);
  initMetadataForLambda(measurableValueWithDefaultUnitCompletion$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(stringValueCompletion$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(integerValueCompletion$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($runSuspendCOROUTINE$_141, CoroutineImpl);
  initMetadataForClass(getExpectedPrimitiveKind$$inlined$executeSuspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(getExpectedPrimitiveKind$$inlined$executeSuspendingQuery$2, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(getExpectedPrimitiveKind$$inlined$executeSuspendingQuery$3, VOID, VOID, VOID, VOID, [1]);
  initMetadataForCoroutine($getExpectedPrimitiveKindCOROUTINE$, CoroutineImpl);
  initMetadataForClass(preventBackspaceAtBeginningTrait$1, VOID, VOID, CellTrait);
  initMetadataForLambda(complexNotionValueEditor$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(complexNotionValueEditor$lambda$slambda, CoroutineImpl, VOID, [0]);
  initMetadataForCoroutine($runSuspendCOROUTINE$_142, CoroutineImpl);
  initMetadataForClass(complexNotionElementValueEditor$2$$inlined$executeSuspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForLambda(complexNotionElementValueEditor$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(complexNotionElementValueEditor$lambda$slambda, CoroutineImpl, VOID, [0]);
  initMetadataForCoroutine($runSuspendCOROUTINE$_143, CoroutineImpl);
  initMetadataForClass(unknownValueCompletion$2$$inlined$executeSuspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForLambda(unknownValueCompletion$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(_no_name_provided__qut3iv_54, VOID, VOID, CellTrait);
  initMetadataForClass(unknownValueMode$$inlined$forEach$1, VOID, VOID, DisposableSynchronizer);
  initMetadataForClass(unknownValueModeItem$1, VOID, VOID, SimpleCompletionItem);
  initMetadataForCoroutine($renderElementValueCOROUTINE$, CoroutineImpl);
  initMetadataForObject(BTBEditorParts, 'BTBEditorParts');
  initMetadataForClass(functionLibraryEditors$10$$inlined$forDisposable$1, VOID, VOID, DisposableSynchronizer);
  initMetadataForClass(PrefixedURLTrait, 'PrefixedURLTrait', VOID, BaseDerivedCellTrait);
  initMetadataForLambda(addImportFromPubMedAction$lambda$o$onKeyPressed$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(addImportFromPubMedAction$2$1, VOID, VOID, CellTrait);
  initMetadataForClass(_no_name_provided__qut3iv_55, VOID, VOID, CellTrait);
  initMetadataForClass(multiplierTextSynchronizer$1, VOID, VOID, DisposableSynchronizer);
  initMetadataForClass(multiplierCompletionItem$1, VOID, VOID, SimpleCompletionItem);
  initMetadataForClass(CommonQueryLabel, 'CommonQueryLabel', VOID, Enum);
  initMetadataForClass(QueryLabelDeleteTrait$onKeyPressed$$inlined$executeQuery$1, VOID, VOID, VOID, [Query], [1]);
  initMetadataForClass(QueryLabelDeleteTrait, 'QueryLabelDeleteTrait', VOID, CellTrait);
  initMetadataForObject(EntryQueryLabel, 'EntryQueryLabel');
  initMetadataForClass(newFactEditors$14$2$ReplaceWithLeftTrait$onKeyPressed$$inlined$executeQuery$1, VOID, VOID, VOID, [Query], [1]);
  initMetadataForClass(newFactEditors$14$2$ReplaceWithLeftTrait$onKeyPressed$$inlined$executeQuery$2, VOID, VOID, VOID, [Query], [1]);
  initMetadataForClass(newFactEditors$14$2$ReplaceWithLeftTrait, 'ReplaceWithLeftTrait', VOID, CellTrait);
  initMetadataForClass(newFactEditors$22$$inlined$forDisposable$1, VOID, VOID, DisposableSynchronizer);
  initMetadataForClass(queryLabelsCell$$inlined$forDisposable$1, VOID, VOID, DisposableSynchronizer);
  initMetadataForClass(setQueryLabelRightTransform$2$$inlined$executeQuery$1, VOID, VOID, VOID, [Query], [1]);
  initMetadataForClass(notionLibraryEditors$16$2$2$2$2$$inlined$createDeleteTransformTrait$1, VOID, VOID, DeleteTransformTrait);
  initMetadataForClass(notionLibraryEditors$16$2$$inlined$forDisposable$1, VOID, VOID, DisposableSynchronizer);
  initMetadataForClass(propertyConstraints$$inlined$apply$1, VOID, VOID, CellTrait);
  initMetadataForClass(propertyConstraints$2$2$$inlined$keyPressedCellTrait$1, VOID, VOID, CellTrait);
  initMetadataForClass(propertyConstraints$$inlined$forDisposable$1, VOID, VOID, DisposableSynchronizer);
  initMetadataForClass(excludingClassExpressionCompletion$$inlined$executeQuery$1, VOID, VOID, VOID, [Query], [1]);
  initMetadataForClass(processLibraryEditors$14$2$4$$inlined$executeQuery$1, VOID, VOID, VOID, [Query], [1]);
  initMetadataForClass(processLibraryEditors$14$2$4$2$$inlined$executeQuery$1, VOID, VOID, VOID, [Query], [1]);
  initMetadataForClass(processLibraryEditors$26$BraceDeleteTrait$onKeyPressed$$inlined$executeQuery$1, VOID, VOID, VOID, [Query], [1]);
  initMetadataForClass(processLibraryEditors$26$BraceDeleteTrait, 'BraceDeleteTrait', VOID, CellTrait);
  initMetadataForLambda(libraryProcessSpecificationEditor$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(libraryProcessSpecificationEditor$lambda$slambda, CoroutineImpl, VOID, [0]);
  initMetadataForClass(optionalSpecializedLink$$inlined$forDisposable$1, VOID, VOID, DisposableSynchronizer);
  initMetadataForClass(shouldShowSpecialized$$inlined$query$1, VOID, VOID, VOID, [Query], [1]);
  initMetadataForClass(queryCommandEditors$34$5$2$2$$inlined$executeQuery$1, VOID, VOID, VOID, [Query], [1]);
  initMetadataForCoroutine($showCustomEditorCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($showCustomCellCOROUTINE$, CoroutineImpl);
  initMetadataForClass(urlPlaceholderPasteTrait$1, VOID, VOID, CellTrait);
  initMetadataForClass(BTBEditorImplementation, 'BTBEditorImplementation', VOID, Enum);
  initMetadataForClass(getDeleteTransformTrait$$inlined$createDeleteTransformTrait$1, VOID, VOID, DeleteTransformTrait);
  initMetadataForClass(NewSingleFactSelected, 'NewSingleFactSelected', VOID, Event_0);
  initMetadataForClass(FactToggleEvent, 'FactToggleEvent', VOID, Event_0);
  initMetadataForCompanion(Companion_423);
  initMetadataForClass(FactsClearEvent, 'FactsClearEvent', FactsClearEvent, Event_0);
  initMetadataForCompanion(Companion_424);
  initMetadataForClass(FactSelectionToggle$imageCellTrait$1, VOID, VOID, CellTrait);
  initMetadataForClass(FactSelectionToggle$factCellTrait$1, VOID, VOID, CellTrait);
  initMetadataForClass(FactSelectionToggle, 'FactSelectionToggle');
  initMetadataForClass(BTBDocumentFactSelectionTrait, 'BTBDocumentFactSelectionTrait', VOID, CellTrait);
  initMetadataForClass(FactSetFactSelectionTrait, 'FactSetFactSelectionTrait', VOID, CellTrait);
  initMetadataForClass(Id, 'Id');
  initMetadataForClass(OrdinalId, 'OrdinalId', VOID, Id);
  initMetadataForClass(ArbitraryId, 'ArbitraryId', VOID, Id);
  initMetadataForClass(FactSetIdManager$pasteHandler$2$1$prepare$2);
  initMetadataForClass(FactSetId, 'FactSetId');
  initMetadataForClass(sam$jetbrains_ocelot_projectional_editor_cell_clipboard_PasteHandler$0_0, 'sam$jetbrains_ocelot_projectional_editor_cell_clipboard_PasteHandler$0', VOID, VOID, [PasteHandler, FunctionAdapter]);
  initMetadataForClass(FactSetIdManager$pasteHandler$2$1, VOID, VOID, VOID, [AsyncGuardedExecution], [0]);
  initMetadataForClass(FactSetIdManager, 'FactSetIdManager');
  initMetadataForClass(getDeleteTransformTrait$$inlined$createDeleteTransformTrait$1$doWork$1, VOID, VOID, VOID, [Query], [1]);
  initMetadataForClass(getDeleteTransformTrait$$inlined$createDeleteTransformTrait$1_0, VOID, VOID, DeleteTransformTrait);
  initMetadataForCoroutine($runSuspendCOROUTINE$_144, CoroutineImpl);
  initMetadataForClass(targetName$2$$inlined$executeSuspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForLambda(targetName$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(FindUsagePageEntryAdapter, 'FindUsagePageEntryAdapter');
  initMetadataForLambda(FindUsagePagedAdapter$totalNodes$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(PagedAdapter, 'PagedAdapter');
  initMetadataForClass(FindUsagePagedAdapter, 'FindUsagePagedAdapter', VOID, PagedAdapter);
  initMetadataForClass(HtmlNodeEditorView$attach$$inlined$toDisposable$1, VOID, VOID, VOID, [Disposable]);
  initMetadataForClass(HtmlNodeEditorView, 'HtmlNodeEditorView');
  initMetadataForLambda(NodeEditorAdapter$open$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(NodeEditorAdapter, 'NodeEditorAdapter');
  initMetadataForClass(PageAdapter, 'PageAdapter');
  initMetadataForLambda(PagedAdapter$total$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(PagedAdapter$nextPage$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(KotlinxSerializationConverter$serializeNullable$o$collect$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($collectCOROUTINE$_26, CoroutineImpl);
  initMetadataForLambda(KotlinxSerializationConverter$deserialize$o$collect$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($collectCOROUTINE$_27, CoroutineImpl);
  initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0_25, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
  initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0_26, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
  initMetadataForClass(KotlinxSerializationConverter$serializeNullable$$inlined$map$1, VOID, VOID, VOID, [Flow], [1]);
  initMetadataForLambda(KotlinxSerializationConverter$serializeNullable$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(KotlinxSerializationConverter$deserialize$$inlined$map$1, VOID, VOID, VOID, [Flow], [1]);
  initMetadataForLambda(KotlinxSerializationConverter$deserialize$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($serializeNullableCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($deserializeCOROUTINE$_0, CoroutineImpl);
  initMetadataForClass(KotlinxSerializationConverter, 'KotlinxSerializationConverter', VOID, VOID, [ContentConverter], [4, 3]);
  initMetadataForCompanion(Companion_425);
  initMetadataForClass(KotlinxSerializer, 'KotlinxSerializer', KotlinxSerializer);
  initMetadataForObject(SerializerInitializer, 'SerializerInitializer');
  initMetadataForClass(ConverterRegistration, 'ConverterRegistration');
  initMetadataForClass(ContentNegotiation$Config$defaultMatcher$1);
  initMetadataForLambda(ContentNegotiation$Plugin$install$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(ContentNegotiation$Plugin$install$slambda_1, CoroutineImpl, VOID, [2]);
  initMetadataForClass(Config_4, 'Config', Config_4, VOID, [Configuration_0]);
  initMetadataForObject(Plugin_6, 'Plugin', VOID, VOID, [HttpClientPlugin]);
  initMetadataForCoroutine($convertRequestCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($convertResponseCOROUTINE$, CoroutineImpl);
  initMetadataForClass(ContentNegotiation, 'ContentNegotiation', VOID, VOID, VOID, [2, 5]);
  initMetadataForClass(ContentConverterException, 'ContentConverterException', VOID, Exception);
  initMetadataForObject(JsonContentTypeMatcher, 'JsonContentTypeMatcher');
  initMetadataForObject(ApiGateway, 'ApiGateway');
  initMetadataForClass(CapturingView, 'CapturingView', CapturingView);
  initMetadataForCoroutine($renderDocumentToDomCOROUTINE$, CoroutineImpl);
  initMetadataForLambda(EditorEnvironment$monitoringClient$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForObject(EditorEnvironment, 'EditorEnvironment');
  initMetadataForLambda(findUsages$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForObject(EditorEvents, 'EditorEvents');
  initMetadataForClass(EntryPoint, 'EntryPoint', EntryPoint);
  initMetadataForLambda(getHtmlForUsage$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(getHtmlForResolvedNode$slambda, CoroutineImpl, VOID, [1]);
  //endregion
  function CharSequence() {
  }
  function Comparable() {
  }
  function throwIrLinkageError(message) {
    throw new IrLinkageError(message);
  }
  function IrLinkageError(message) {
    Error_init_$Init$_0(message, this);
    captureStack(this, IrLinkageError);
  }
  function toList(_this__u8e3s4) {
    switch (_this__u8e3s4.length) {
      case 0:
        return emptyList();
      case 1:
        return listOf(_this__u8e3s4[0]);
      default:
        return toMutableList(_this__u8e3s4);
    }
  }
  function contains_0(_this__u8e3s4, element) {
    return indexOf(_this__u8e3s4, element) >= 0;
  }
  function indexOf(_this__u8e3s4, element) {
    if (element == null) {
      var inductionVariable = 0;
      var last = _this__u8e3s4.length - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          if (_this__u8e3s4[index] == null) {
            return index;
          }
        }
         while (inductionVariable <= last);
    } else {
      var inductionVariable_0 = 0;
      var last_0 = _this__u8e3s4.length - 1 | 0;
      if (inductionVariable_0 <= last_0)
        do {
          var index_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          if (equals(element, _this__u8e3s4[index_0])) {
            return index_0;
          }
        }
         while (inductionVariable_0 <= last_0);
    }
    return -1;
  }
  function asSequence(_this__u8e3s4) {
    // Inline function 'kotlin.collections.isEmpty' call
    if (_this__u8e3s4.length === 0)
      return emptySequence();
    // Inline function 'kotlin.sequences.Sequence' call
    return new asSequence$$inlined$Sequence$1(_this__u8e3s4);
  }
  function get_indices(_this__u8e3s4) {
    return new IntRange(0, get_lastIndex_0(_this__u8e3s4));
  }
  function indexOf_0(_this__u8e3s4, element) {
    var inductionVariable = 0;
    var last = _this__u8e3s4.length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (element === _this__u8e3s4[index]) {
          return index;
        }
      }
       while (inductionVariable <= last);
    return -1;
  }
  function toSet(_this__u8e3s4) {
    switch (_this__u8e3s4.length) {
      case 0:
        return emptySet();
      case 1:
        return setOf(_this__u8e3s4[0]);
      default:
        return toCollection(_this__u8e3s4, LinkedHashSet_init_$Create$_1(mapCapacity(_this__u8e3s4.length)));
    }
  }
  function toMutableList(_this__u8e3s4) {
    return ArrayList_init_$Create$_1(asCollection(_this__u8e3s4));
  }
  function joinToString(_this__u8e3s4, separator, prefix, postfix, limit, truncated, transform) {
    separator = separator === VOID ? ', ' : separator;
    prefix = prefix === VOID ? '' : prefix;
    postfix = postfix === VOID ? '' : postfix;
    limit = limit === VOID ? -1 : limit;
    truncated = truncated === VOID ? '...' : truncated;
    transform = transform === VOID ? null : transform;
    return joinTo(_this__u8e3s4, StringBuilder_init_$Create$_1(), separator, prefix, postfix, limit, truncated, transform).toString();
  }
  function firstOrNull(_this__u8e3s4) {
    var tmp;
    // Inline function 'kotlin.collections.isEmpty' call
    if (_this__u8e3s4.length === 0) {
      tmp = null;
    } else {
      tmp = _this__u8e3s4[0];
    }
    return tmp;
  }
  function lastIndexOf(_this__u8e3s4, element) {
    if (element == null) {
      var inductionVariable = _this__u8e3s4.length - 1 | 0;
      if (0 <= inductionVariable)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + -1 | 0;
          if (_this__u8e3s4[index] == null) {
            return index;
          }
        }
         while (0 <= inductionVariable);
    } else {
      var inductionVariable_0 = _this__u8e3s4.length - 1 | 0;
      if (0 <= inductionVariable_0)
        do {
          var index_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + -1 | 0;
          if (equals(element, _this__u8e3s4[index_0])) {
            return index_0;
          }
        }
         while (0 <= inductionVariable_0);
    }
    return -1;
  }
  function zip(_this__u8e3s4, other) {
    // Inline function 'kotlin.collections.zip' call
    var tmp0 = _this__u8e3s4.length;
    // Inline function 'kotlin.comparisons.minOf' call
    var b = other.length;
    var size = Math.min(tmp0, b);
    var list = ArrayList_init_$Create$_0(size);
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp0_0 = _this__u8e3s4[i];
        var t2 = other[i];
        var tmp$ret$1 = to(tmp0_0, t2);
        list.j(tmp$ret$1);
      }
       while (inductionVariable < size);
    return list;
  }
  function withIndex(_this__u8e3s4) {
    return new IndexingIterable(withIndex$lambda(_this__u8e3s4));
  }
  function get_lastIndex(_this__u8e3s4) {
    return _this__u8e3s4.length - 1 | 0;
  }
  function get_indices_0(_this__u8e3s4) {
    return new IntRange(0, get_lastIndex_1(_this__u8e3s4));
  }
  function single(_this__u8e3s4) {
    var tmp;
    switch (_this__u8e3s4.length) {
      case 0:
        throw NoSuchElementException_init_$Create$_0('Array is empty.');
      case 1:
        tmp = _this__u8e3s4[0];
        break;
      default:
        throw IllegalArgumentException_init_$Create$_0('Array has more than one element.');
    }
    return tmp;
  }
  function get_lastIndex_0(_this__u8e3s4) {
    return _this__u8e3s4.length - 1 | 0;
  }
  function toCollection(_this__u8e3s4, destination) {
    var inductionVariable = 0;
    var last = _this__u8e3s4.length;
    while (inductionVariable < last) {
      var item = _this__u8e3s4[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      destination.j(item);
    }
    return destination;
  }
  function joinTo(_this__u8e3s4, buffer, separator, prefix, postfix, limit, truncated, transform) {
    separator = separator === VOID ? ', ' : separator;
    prefix = prefix === VOID ? '' : prefix;
    postfix = postfix === VOID ? '' : postfix;
    limit = limit === VOID ? -1 : limit;
    truncated = truncated === VOID ? '...' : truncated;
    transform = transform === VOID ? null : transform;
    buffer.k(prefix);
    var count = 0;
    var inductionVariable = 0;
    var last = _this__u8e3s4.length;
    $l$loop: while (inductionVariable < last) {
      var element = _this__u8e3s4[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      count = count + 1 | 0;
      if (count > 1) {
        buffer.k(separator);
      }
      if (limit < 0 || count <= limit) {
        appendElement(buffer, element, transform);
      } else
        break $l$loop;
    }
    if (limit >= 0 && count > limit) {
      buffer.k(truncated);
    }
    buffer.k(postfix);
    return buffer;
  }
  function get_lastIndex_1(_this__u8e3s4) {
    return _this__u8e3s4.length - 1 | 0;
  }
  function contains_1(_this__u8e3s4, element) {
    return indexOf_1(_this__u8e3s4, element) >= 0;
  }
  function contains_2(_this__u8e3s4, element) {
    return indexOf_2(_this__u8e3s4, element) >= 0;
  }
  function contains_3(_this__u8e3s4, element) {
    return indexOf_3(_this__u8e3s4, element) >= 0;
  }
  function contains_4(_this__u8e3s4, element) {
    return indexOf_4(_this__u8e3s4, element) >= 0;
  }
  function indexOf_1(_this__u8e3s4, element) {
    var inductionVariable = 0;
    var last = _this__u8e3s4.length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (element === _this__u8e3s4[index]) {
          return index;
        }
      }
       while (inductionVariable <= last);
    return -1;
  }
  function indexOf_2(_this__u8e3s4, element) {
    var inductionVariable = 0;
    var last = _this__u8e3s4.length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (element === _this__u8e3s4[index]) {
          return index;
        }
      }
       while (inductionVariable <= last);
    return -1;
  }
  function indexOf_3(_this__u8e3s4, element) {
    var inductionVariable = 0;
    var last = _this__u8e3s4.length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (element === _this__u8e3s4[index]) {
          return index;
        }
      }
       while (inductionVariable <= last);
    return -1;
  }
  function indexOf_4(_this__u8e3s4, element) {
    var inductionVariable = 0;
    var last = _this__u8e3s4.length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (element === _this__u8e3s4[index]) {
          return index;
        }
      }
       while (inductionVariable <= last);
    return -1;
  }
  function lastIndexOf_0(_this__u8e3s4, element) {
    var inductionVariable = _this__u8e3s4.length - 1 | 0;
    if (0 <= inductionVariable)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        if (element === _this__u8e3s4[index]) {
          return index;
        }
      }
       while (0 <= inductionVariable);
    return -1;
  }
  function getOrNull(_this__u8e3s4, index) {
    return (0 <= index ? index <= (_this__u8e3s4.length - 1 | 0) : false) ? _this__u8e3s4[index] : null;
  }
  function asSequence$$inlined$Sequence$1($this_asSequence) {
    this.l_1 = $this_asSequence;
  }
  protoOf(asSequence$$inlined$Sequence$1).m = function () {
    return arrayIterator(this.l_1);
  };
  function withIndex$lambda($this_withIndex) {
    return function () {
      return arrayIterator($this_withIndex);
    };
  }
  function joinToString_0(_this__u8e3s4, separator, prefix, postfix, limit, truncated, transform) {
    separator = separator === VOID ? ', ' : separator;
    prefix = prefix === VOID ? '' : prefix;
    postfix = postfix === VOID ? '' : postfix;
    limit = limit === VOID ? -1 : limit;
    truncated = truncated === VOID ? '...' : truncated;
    transform = transform === VOID ? null : transform;
    return joinTo_0(_this__u8e3s4, StringBuilder_init_$Create$_1(), separator, prefix, postfix, limit, truncated, transform).toString();
  }
  function joinTo_0(_this__u8e3s4, buffer, separator, prefix, postfix, limit, truncated, transform) {
    separator = separator === VOID ? ', ' : separator;
    prefix = prefix === VOID ? '' : prefix;
    postfix = postfix === VOID ? '' : postfix;
    limit = limit === VOID ? -1 : limit;
    truncated = truncated === VOID ? '...' : truncated;
    transform = transform === VOID ? null : transform;
    buffer.k(prefix);
    var count = 0;
    var _iterator__ex2g4s = _this__u8e3s4.m();
    $l$loop: while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      count = count + 1 | 0;
      if (count > 1) {
        buffer.k(separator);
      }
      if (limit < 0 || count <= limit) {
        appendElement(buffer, element, transform);
      } else
        break $l$loop;
    }
    if (limit >= 0 && count > limit) {
      buffer.k(truncated);
    }
    buffer.k(postfix);
    return buffer;
  }
  function plus_5(_this__u8e3s4, elements) {
    if (isInterface(elements, Collection)) {
      var result = ArrayList_init_$Create$_0(_this__u8e3s4.p() + elements.p() | 0);
      result.q(_this__u8e3s4);
      result.q(elements);
      return result;
    } else {
      var result_0 = ArrayList_init_$Create$_1(_this__u8e3s4);
      addAll_1(result_0, elements);
      return result_0;
    }
  }
  function firstOrNull_0(_this__u8e3s4) {
    if (isInterface(_this__u8e3s4, KtList)) {
      if (_this__u8e3s4.s())
        return null;
      else
        return _this__u8e3s4.r(0);
    } else {
      var iterator = _this__u8e3s4.m();
      if (!iterator.n())
        return null;
      return iterator.o();
    }
  }
  function first(_this__u8e3s4) {
    if (_this__u8e3s4.s())
      throw NoSuchElementException_init_$Create$_0('List is empty.');
    return _this__u8e3s4.r(0);
  }
  function firstOrNull_1(_this__u8e3s4) {
    return _this__u8e3s4.s() ? null : _this__u8e3s4.r(0);
  }
  function withIndex_0(_this__u8e3s4) {
    return new IndexingIterable(withIndex$lambda_0(_this__u8e3s4));
  }
  function maxOrNull(_this__u8e3s4) {
    var iterator = _this__u8e3s4.m();
    if (!iterator.n())
      return null;
    var max = iterator.o();
    while (iterator.n()) {
      var e = iterator.o();
      if (compareTo_0(max, e) < 0)
        max = e;
    }
    return max;
  }
  function last(_this__u8e3s4) {
    if (_this__u8e3s4.s())
      throw NoSuchElementException_init_$Create$_0('List is empty.');
    return _this__u8e3s4.r(get_lastIndex_2(_this__u8e3s4));
  }
  function toMutableSet(_this__u8e3s4) {
    var tmp;
    if (isInterface(_this__u8e3s4, Collection)) {
      tmp = LinkedHashSet_init_$Create$_0(_this__u8e3s4);
    } else {
      tmp = toCollection_0(_this__u8e3s4, LinkedHashSet_init_$Create$());
    }
    return tmp;
  }
  function toSet_0(_this__u8e3s4) {
    if (isInterface(_this__u8e3s4, Collection)) {
      var tmp;
      switch (_this__u8e3s4.p()) {
        case 0:
          tmp = emptySet();
          break;
        case 1:
          var tmp_0;
          if (isInterface(_this__u8e3s4, KtList)) {
            tmp_0 = _this__u8e3s4.r(0);
          } else {
            tmp_0 = _this__u8e3s4.m().o();
          }

          tmp = setOf(tmp_0);
          break;
        default:
          tmp = toCollection_0(_this__u8e3s4, LinkedHashSet_init_$Create$_1(mapCapacity(_this__u8e3s4.p())));
          break;
      }
      return tmp;
    }
    return optimizeReadOnlySet(toCollection_0(_this__u8e3s4, LinkedHashSet_init_$Create$()));
  }
  function distinct(_this__u8e3s4) {
    return toList_0(toMutableSet(_this__u8e3s4));
  }
  function subtract(_this__u8e3s4, other) {
    var set = toMutableSet(_this__u8e3s4);
    removeAll(set, other);
    return set;
  }
  function plus_6(_this__u8e3s4, element) {
    var result = ArrayList_init_$Create$_0(_this__u8e3s4.p() + 1 | 0);
    result.q(_this__u8e3s4);
    result.j(element);
    return result;
  }
  function take(_this__u8e3s4, n) {
    // Inline function 'kotlin.require' call
    if (!(n >= 0)) {
      var message = 'Requested element count ' + n + ' is less than zero.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    if (n === 0)
      return emptyList();
    if (isInterface(_this__u8e3s4, Collection)) {
      if (n >= _this__u8e3s4.p())
        return toList_0(_this__u8e3s4);
      if (n === 1)
        return listOf(first_0(_this__u8e3s4));
    }
    var count = 0;
    var list = ArrayList_init_$Create$_0(n);
    var _iterator__ex2g4s = _this__u8e3s4.m();
    $l$loop: while (_iterator__ex2g4s.n()) {
      var item = _iterator__ex2g4s.o();
      list.j(item);
      count = count + 1 | 0;
      if (count === n)
        break $l$loop;
    }
    return optimizeReadOnlyList(list);
  }
  function minus_1(_this__u8e3s4, element) {
    var result = ArrayList_init_$Create$_0(collectionSizeOrDefault(_this__u8e3s4, 10));
    var removed = false;
    // Inline function 'kotlin.collections.filterTo' call
    var _iterator__ex2g4s = _this__u8e3s4.m();
    while (_iterator__ex2g4s.n()) {
      var element_0 = _iterator__ex2g4s.o();
      var tmp;
      if (!removed && equals(element_0, element)) {
        removed = true;
        tmp = false;
      } else {
        tmp = true;
      }
      if (tmp) {
        result.j(element_0);
      }
    }
    return result;
  }
  function first_0(_this__u8e3s4) {
    if (isInterface(_this__u8e3s4, KtList))
      return first(_this__u8e3s4);
    else {
      var iterator = _this__u8e3s4.m();
      if (!iterator.n())
        throw NoSuchElementException_init_$Create$_0('Collection is empty.');
      return iterator.o();
    }
  }
  function contains_5(_this__u8e3s4, element) {
    if (isInterface(_this__u8e3s4, Collection))
      return _this__u8e3s4.t(element);
    return indexOf_6(_this__u8e3s4, element) >= 0;
  }
  function single_0(_this__u8e3s4) {
    var tmp;
    switch (_this__u8e3s4.p()) {
      case 0:
        throw NoSuchElementException_init_$Create$_0('List is empty.');
      case 1:
        tmp = _this__u8e3s4.r(0);
        break;
      default:
        throw IllegalArgumentException_init_$Create$_0('List has more than one element.');
    }
    return tmp;
  }
  function reversed(_this__u8e3s4) {
    var tmp;
    if (isInterface(_this__u8e3s4, Collection)) {
      tmp = _this__u8e3s4.p() <= 1;
    } else {
      tmp = false;
    }
    if (tmp)
      return toList_0(_this__u8e3s4);
    var list = toMutableList_1(_this__u8e3s4);
    reverse(list);
    return list;
  }
  function asSequence_0(_this__u8e3s4) {
    // Inline function 'kotlin.sequences.Sequence' call
    return new asSequence$$inlined$Sequence$1_0(_this__u8e3s4);
  }
  function toList_0(_this__u8e3s4) {
    if (isInterface(_this__u8e3s4, Collection)) {
      var tmp;
      switch (_this__u8e3s4.p()) {
        case 0:
          tmp = emptyList();
          break;
        case 1:
          var tmp_0;
          if (isInterface(_this__u8e3s4, KtList)) {
            tmp_0 = _this__u8e3s4.r(0);
          } else {
            tmp_0 = _this__u8e3s4.m().o();
          }

          tmp = listOf(tmp_0);
          break;
        default:
          tmp = toMutableList_0(_this__u8e3s4);
          break;
      }
      return tmp;
    }
    return optimizeReadOnlyList(toMutableList_1(_this__u8e3s4));
  }
  function singleOrNull(_this__u8e3s4) {
    return _this__u8e3s4.p() === 1 ? _this__u8e3s4.r(0) : null;
  }
  function intersect(_this__u8e3s4, other) {
    var set = toMutableSet(_this__u8e3s4);
    retainAll(set, other);
    return set;
  }
  function lastOrNull(_this__u8e3s4) {
    return _this__u8e3s4.s() ? null : _this__u8e3s4.r(_this__u8e3s4.p() - 1 | 0);
  }
  function drop(_this__u8e3s4, n) {
    // Inline function 'kotlin.require' call
    if (!(n >= 0)) {
      var message = 'Requested element count ' + n + ' is less than zero.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    if (n === 0)
      return toList_0(_this__u8e3s4);
    var list;
    if (isInterface(_this__u8e3s4, Collection)) {
      var resultSize = _this__u8e3s4.p() - n | 0;
      if (resultSize <= 0)
        return emptyList();
      if (resultSize === 1)
        return listOf(last_0(_this__u8e3s4));
      list = ArrayList_init_$Create$_0(resultSize);
      if (isInterface(_this__u8e3s4, KtList)) {
        if (isInterface(_this__u8e3s4, RandomAccess)) {
          var inductionVariable = n;
          var last = _this__u8e3s4.p();
          if (inductionVariable < last)
            do {
              var index = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              list.j(_this__u8e3s4.r(index));
            }
             while (inductionVariable < last);
        } else {
          // Inline function 'kotlin.collections.iterator' call
          var _iterator__ex2g4s = _this__u8e3s4.u(n);
          while (_iterator__ex2g4s.n()) {
            var item = _iterator__ex2g4s.o();
            list.j(item);
          }
        }
        return list;
      }
    } else {
      list = ArrayList_init_$Create$();
    }
    var count = 0;
    var _iterator__ex2g4s_0 = _this__u8e3s4.m();
    while (_iterator__ex2g4s_0.n()) {
      var item_0 = _iterator__ex2g4s_0.o();
      if (count >= n)
        list.j(item_0);
      else {
        count = count + 1 | 0;
      }
    }
    return optimizeReadOnlyList(list);
  }
  function sortedWith(_this__u8e3s4, comparator) {
    if (isInterface(_this__u8e3s4, Collection)) {
      if (_this__u8e3s4.p() <= 1)
        return toList_0(_this__u8e3s4);
      // Inline function 'kotlin.collections.toTypedArray' call
      var tmp = copyToArray(_this__u8e3s4);
      // Inline function 'kotlin.apply' call
      var this_0 = isArray(tmp) ? tmp : THROW_CCE();
      sortWith(this_0, comparator);
      return asList(this_0);
    }
    // Inline function 'kotlin.apply' call
    var this_1 = toMutableList_1(_this__u8e3s4);
    sortWith_0(this_1, comparator);
    return this_1;
  }
  function lastIndexOf_1(_this__u8e3s4, element) {
    return _this__u8e3s4.v(element);
  }
  function indexOf_5(_this__u8e3s4, element) {
    return _this__u8e3s4.w(element);
  }
  function plus_7(_this__u8e3s4, elements) {
    var result = ArrayList_init_$Create$_0(_this__u8e3s4.p() + 10 | 0);
    result.q(_this__u8e3s4);
    addAll_2(result, elements);
    return result;
  }
  function singleOrNull_0(_this__u8e3s4) {
    if (isInterface(_this__u8e3s4, KtList))
      return _this__u8e3s4.p() === 1 ? _this__u8e3s4.r(0) : null;
    else {
      var iterator = _this__u8e3s4.m();
      if (!iterator.n())
        return null;
      var single = iterator.o();
      if (iterator.n())
        return null;
      return single;
    }
  }
  function getOrNull_0(_this__u8e3s4, index) {
    return (0 <= index ? index < _this__u8e3s4.p() : false) ? _this__u8e3s4.r(index) : null;
  }
  function indexOf_6(_this__u8e3s4, element) {
    if (isInterface(_this__u8e3s4, KtList))
      return _this__u8e3s4.w(element);
    var index = 0;
    var _iterator__ex2g4s = _this__u8e3s4.m();
    while (_iterator__ex2g4s.n()) {
      var item = _iterator__ex2g4s.o();
      checkIndexOverflow(index);
      if (equals(element, item))
        return index;
      index = index + 1 | 0;
    }
    return -1;
  }
  function dropLast(_this__u8e3s4, n) {
    // Inline function 'kotlin.require' call
    if (!(n >= 0)) {
      var message = 'Requested element count ' + n + ' is less than zero.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    return take(_this__u8e3s4, coerceAtLeast(_this__u8e3s4.p() - n | 0, 0));
  }
  function filterNotNull(_this__u8e3s4) {
    return filterNotNullTo(_this__u8e3s4, ArrayList_init_$Create$());
  }
  function plus_8(_this__u8e3s4, elements) {
    if (isInterface(_this__u8e3s4, Collection))
      return plus_5(_this__u8e3s4, elements);
    var result = ArrayList_init_$Create$();
    addAll_1(result, _this__u8e3s4);
    addAll_1(result, elements);
    return result;
  }
  function toMutableList_0(_this__u8e3s4) {
    return ArrayList_init_$Create$_1(_this__u8e3s4);
  }
  function toHashSet(_this__u8e3s4) {
    return toCollection_0(_this__u8e3s4, HashSet_init_$Create$_1(mapCapacity(collectionSizeOrDefault(_this__u8e3s4, 12))));
  }
  function toBooleanArray(_this__u8e3s4) {
    var result = booleanArray(_this__u8e3s4.p());
    var index = 0;
    var _iterator__ex2g4s = _this__u8e3s4.m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      var _unary__edvuaz = index;
      index = _unary__edvuaz + 1 | 0;
      result[_unary__edvuaz] = element;
    }
    return result;
  }
  function toCollection_0(_this__u8e3s4, destination) {
    var _iterator__ex2g4s = _this__u8e3s4.m();
    while (_iterator__ex2g4s.n()) {
      var item = _iterator__ex2g4s.o();
      destination.j(item);
    }
    return destination;
  }
  function toMutableList_1(_this__u8e3s4) {
    if (isInterface(_this__u8e3s4, Collection))
      return toMutableList_0(_this__u8e3s4);
    return toCollection_0(_this__u8e3s4, ArrayList_init_$Create$());
  }
  function last_0(_this__u8e3s4) {
    if (isInterface(_this__u8e3s4, KtList))
      return last(_this__u8e3s4);
    else {
      var iterator = _this__u8e3s4.m();
      if (!iterator.n())
        throw NoSuchElementException_init_$Create$_0('Collection is empty.');
      var last_0 = iterator.o();
      while (iterator.n())
        last_0 = iterator.o();
      return last_0;
    }
  }
  function filterNotNullTo(_this__u8e3s4, destination) {
    var _iterator__ex2g4s = _this__u8e3s4.m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      if (!(element == null)) {
        destination.j(element);
      }
    }
    return destination;
  }
  function single_1(_this__u8e3s4) {
    if (isInterface(_this__u8e3s4, KtList))
      return single_0(_this__u8e3s4);
    else {
      var iterator = _this__u8e3s4.m();
      if (!iterator.n())
        throw NoSuchElementException_init_$Create$_0('Collection is empty.');
      var single = iterator.o();
      if (iterator.n())
        throw IllegalArgumentException_init_$Create$_0('Collection has more than one element.');
      return single;
    }
  }
  function minOrNull(_this__u8e3s4) {
    var iterator = _this__u8e3s4.m();
    if (!iterator.n())
      return null;
    var min = iterator.o();
    while (iterator.n()) {
      var e = iterator.o();
      if (compareTo_0(min, e) > 0)
        min = e;
    }
    return min;
  }
  function withIndex$lambda_0($this_withIndex) {
    return function () {
      return $this_withIndex.m();
    };
  }
  function asSequence$$inlined$Sequence$1_0($this_asSequence) {
    this.x_1 = $this_asSequence;
  }
  protoOf(asSequence$$inlined$Sequence$1_0).m = function () {
    return this.x_1.m();
  };
  function toList_1(_this__u8e3s4) {
    if (_this__u8e3s4.p() === 0)
      return emptyList();
    var iterator = _this__u8e3s4.y().m();
    if (!iterator.n())
      return emptyList();
    var first = iterator.o();
    if (!iterator.n()) {
      // Inline function 'kotlin.collections.toPair' call
      var tmp$ret$0 = new Pair(first.z(), first.a1());
      return listOf(tmp$ret$0);
    }
    var result = ArrayList_init_$Create$_0(_this__u8e3s4.p());
    // Inline function 'kotlin.collections.toPair' call
    var tmp$ret$1 = new Pair(first.z(), first.a1());
    result.j(tmp$ret$1);
    do {
      // Inline function 'kotlin.collections.toPair' call
      var this_0 = iterator.o();
      var tmp$ret$2 = new Pair(this_0.z(), this_0.a1());
      result.j(tmp$ret$2);
    }
     while (iterator.n());
    return result;
  }
  function asSequence_1(_this__u8e3s4) {
    return asSequence_0(_this__u8e3s4.y());
  }
  function titlecaseImpl(_this__u8e3s4) {
    // Inline function 'kotlin.text.uppercase' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.js.unsafeCast' call
    var uppercase = toString(_this__u8e3s4).toUpperCase();
    if (uppercase.length > 1) {
      var tmp;
      if (_this__u8e3s4 === _Char___init__impl__6a9atx(329)) {
        tmp = uppercase;
      } else {
        var tmp0 = charCodeAt(uppercase, 0);
        // Inline function 'kotlin.text.lowercase' call
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.text.plus' call
        var other = substring_0(uppercase, 1).toLowerCase();
        tmp = toString(tmp0) + other;
      }
      return tmp;
    }
    return toString(titlecaseChar(_this__u8e3s4));
  }
  function until(_this__u8e3s4, to) {
    if (to <= -2147483648)
      return Companion_getInstance_11().b1_1;
    return numberRangeToNumber(_this__u8e3s4, to - 1 | 0);
  }
  function reversed_0(_this__u8e3s4) {
    return Companion_instance_13.f1(_this__u8e3s4.d1_1, _this__u8e3s4.c1_1, -_this__u8e3s4.e1_1 | 0);
  }
  function downTo(_this__u8e3s4, to) {
    return Companion_instance_13.f1(_this__u8e3s4, to, -1);
  }
  function coerceAtMost(_this__u8e3s4, maximumValue) {
    return _this__u8e3s4 > maximumValue ? maximumValue : _this__u8e3s4;
  }
  function coerceAtLeast(_this__u8e3s4, minimumValue) {
    return _this__u8e3s4 < minimumValue ? minimumValue : _this__u8e3s4;
  }
  function coerceAtMost_0(_this__u8e3s4, maximumValue) {
    return _this__u8e3s4 > maximumValue ? maximumValue : _this__u8e3s4;
  }
  function coerceAtLeast_0(_this__u8e3s4, minimumValue) {
    return _this__u8e3s4 < minimumValue ? minimumValue : _this__u8e3s4;
  }
  function coerceIn(_this__u8e3s4, minimumValue, maximumValue) {
    if (minimumValue > maximumValue)
      throw IllegalArgumentException_init_$Create$_0('Cannot coerce value to an empty range: maximum ' + maximumValue.toString() + ' is less than minimum ' + minimumValue.toString() + '.');
    if (_this__u8e3s4 < minimumValue)
      return minimumValue;
    if (_this__u8e3s4 > maximumValue)
      return maximumValue;
    return _this__u8e3s4;
  }
  function step(_this__u8e3s4, step) {
    checkStepIsPositive(step > 0, step);
    return Companion_instance_13.f1(_this__u8e3s4.c1_1, _this__u8e3s4.d1_1, _this__u8e3s4.e1_1 > 0 ? step : -step | 0);
  }
  function coerceIn_0(_this__u8e3s4, minimumValue, maximumValue) {
    if (minimumValue > maximumValue)
      throw IllegalArgumentException_init_$Create$_0('Cannot coerce value to an empty range: maximum ' + maximumValue + ' is less than minimum ' + minimumValue + '.');
    if (_this__u8e3s4 < minimumValue)
      return minimumValue;
    if (_this__u8e3s4 > maximumValue)
      return maximumValue;
    return _this__u8e3s4;
  }
  function toList_2(_this__u8e3s4) {
    var it = _this__u8e3s4.m();
    if (!it.n())
      return emptyList();
    var element = it.o();
    if (!it.n())
      return listOf(element);
    var dst = ArrayList_init_$Create$();
    dst.j(element);
    while (it.n()) {
      dst.j(it.o());
    }
    return dst;
  }
  function flatMap(_this__u8e3s4, transform) {
    return new FlatteningSequence(_this__u8e3s4, transform, Iterable$iterator$ref());
  }
  function map(_this__u8e3s4, transform) {
    return new TransformingSequence(_this__u8e3s4, transform);
  }
  function toSet_1(_this__u8e3s4) {
    var it = _this__u8e3s4.m();
    if (!it.n())
      return emptySet();
    var element = it.o();
    if (!it.n())
      return setOf(element);
    var dst = LinkedHashSet_init_$Create$();
    dst.j(element);
    while (it.n()) {
      dst.j(it.o());
    }
    return dst;
  }
  function filter(_this__u8e3s4, predicate) {
    return new FilteringSequence(_this__u8e3s4, true, predicate);
  }
  function first_1(_this__u8e3s4) {
    var iterator = _this__u8e3s4.m();
    if (!iterator.n())
      throw NoSuchElementException_init_$Create$_0('Sequence is empty.');
    return iterator.o();
  }
  function filterNotNull_0(_this__u8e3s4) {
    var tmp = filterNot(_this__u8e3s4, filterNotNull$lambda);
    return isInterface(tmp, Sequence) ? tmp : THROW_CCE();
  }
  function last_1(_this__u8e3s4) {
    var iterator = _this__u8e3s4.m();
    if (!iterator.n())
      throw NoSuchElementException_init_$Create$_0('Sequence is empty.');
    var last = iterator.o();
    while (iterator.n())
      last = iterator.o();
    return last;
  }
  function plus_9(_this__u8e3s4, elements) {
    return flatten_1(sequenceOf([_this__u8e3s4, elements]));
  }
  function firstOrNull_2(_this__u8e3s4) {
    var iterator = _this__u8e3s4.m();
    if (!iterator.n())
      return null;
    return iterator.o();
  }
  function take_0(_this__u8e3s4, n) {
    // Inline function 'kotlin.require' call
    if (!(n >= 0)) {
      var message = 'Requested element count ' + n + ' is less than zero.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    var tmp;
    if (n === 0) {
      tmp = emptySequence();
    } else {
      if (isInterface(_this__u8e3s4, DropTakeSequence)) {
        tmp = _this__u8e3s4.h1(n);
      } else {
        tmp = new TakeSequence(_this__u8e3s4, n);
      }
    }
    return tmp;
  }
  function asIterable(_this__u8e3s4) {
    // Inline function 'kotlin.collections.Iterable' call
    return new asIterable$$inlined$Iterable$1(_this__u8e3s4);
  }
  function filterNot(_this__u8e3s4, predicate) {
    return new FilteringSequence(_this__u8e3s4, false, predicate);
  }
  function contains_6(_this__u8e3s4, element) {
    return indexOf_7(_this__u8e3s4, element) >= 0;
  }
  function indexOf_7(_this__u8e3s4, element) {
    var index = 0;
    var _iterator__ex2g4s = _this__u8e3s4.m();
    while (_iterator__ex2g4s.n()) {
      var item = _iterator__ex2g4s.o();
      checkIndexOverflow(index);
      if (equals(element, item))
        return index;
      index = index + 1 | 0;
    }
    return -1;
  }
  function Iterable$iterator$ref() {
    var l = function (p0) {
      return p0.m();
    };
    l.callableName = 'iterator';
    return l;
  }
  function filterNotNull$lambda(it) {
    return it == null;
  }
  function asIterable$$inlined$Iterable$1($this_asIterable) {
    this.i1_1 = $this_asIterable;
  }
  protoOf(asIterable$$inlined$Iterable$1).m = function () {
    return this.i1_1.m();
  };
  function plus_10(_this__u8e3s4, elements) {
    var tmp0_safe_receiver = collectionSizeOrNull(elements);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp = _this__u8e3s4.p() + tmp0_safe_receiver | 0;
    }
    var tmp1_elvis_lhs = tmp;
    var result = LinkedHashSet_init_$Create$_1(mapCapacity(tmp1_elvis_lhs == null ? imul(_this__u8e3s4.p(), 2) : tmp1_elvis_lhs));
    result.q(_this__u8e3s4);
    addAll_1(result, elements);
    return result;
  }
  function plus_11(_this__u8e3s4, element) {
    var result = LinkedHashSet_init_$Create$_1(mapCapacity(_this__u8e3s4.p() + 1 | 0));
    result.q(_this__u8e3s4);
    result.j(element);
    return result;
  }
  function minus_2(_this__u8e3s4, element) {
    var result = LinkedHashSet_init_$Create$_1(mapCapacity(_this__u8e3s4.p()));
    var removed = false;
    // Inline function 'kotlin.collections.filterTo' call
    var _iterator__ex2g4s = _this__u8e3s4.m();
    while (_iterator__ex2g4s.n()) {
      var element_0 = _iterator__ex2g4s.o();
      var tmp;
      if (!removed && equals(element_0, element)) {
        removed = true;
        tmp = false;
      } else {
        tmp = true;
      }
      if (tmp) {
        result.j(element_0);
      }
    }
    return result;
  }
  function minus_3(_this__u8e3s4, elements) {
    var other = convertToListIfNotCollection(elements);
    if (other.s())
      return toSet_0(_this__u8e3s4);
    if (isInterface(other, KtSet)) {
      // Inline function 'kotlin.collections.filterNotTo' call
      var destination = LinkedHashSet_init_$Create$();
      var _iterator__ex2g4s = _this__u8e3s4.m();
      while (_iterator__ex2g4s.n()) {
        var element = _iterator__ex2g4s.o();
        if (!other.t(element)) {
          destination.j(element);
        }
      }
      return destination;
    }
    var result = LinkedHashSet_init_$Create$_0(_this__u8e3s4);
    result.j1(other);
    return result;
  }
  function take_1(_this__u8e3s4, n) {
    // Inline function 'kotlin.require' call
    if (!(n >= 0)) {
      var message = 'Requested character count ' + n + ' is less than zero.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    return substring(_this__u8e3s4, 0, coerceAtMost(n, _this__u8e3s4.length));
  }
  function dropLast_0(_this__u8e3s4, n) {
    // Inline function 'kotlin.require' call
    if (!(n >= 0)) {
      var message = 'Requested character count ' + n + ' is less than zero.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    return take_1(_this__u8e3s4, coerceAtLeast(_this__u8e3s4.length - n | 0, 0));
  }
  function first_2(_this__u8e3s4) {
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0)
      throw NoSuchElementException_init_$Create$_0('Char sequence is empty.');
    return charSequenceGet(_this__u8e3s4, 0);
  }
  function last_2(_this__u8e3s4) {
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0)
      throw NoSuchElementException_init_$Create$_0('Char sequence is empty.');
    return charSequenceGet(_this__u8e3s4, get_lastIndex_3(_this__u8e3s4));
  }
  function single_2(_this__u8e3s4) {
    var tmp;
    switch (charSequenceLength(_this__u8e3s4)) {
      case 0:
        throw NoSuchElementException_init_$Create$_0('Char sequence is empty.');
      case 1:
        tmp = charSequenceGet(_this__u8e3s4, 0);
        break;
      default:
        throw IllegalArgumentException_init_$Create$_0('Char sequence has more than one element.');
    }
    return tmp;
  }
  function drop_0(_this__u8e3s4, n) {
    // Inline function 'kotlin.require' call
    if (!(n >= 0)) {
      var message = 'Requested character count ' + n + ' is less than zero.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    return substring_0(_this__u8e3s4, coerceAtMost(n, _this__u8e3s4.length));
  }
  function reversed_1(_this__u8e3s4) {
    return StringBuilder_init_$Create$_0(_this__u8e3s4).l1();
  }
  function slice(_this__u8e3s4, indices) {
    if (indices.s()) {
      // Inline function 'kotlin.collections.listOf' call
      return emptyList();
    }
    var tmp2 = indices.p1();
    // Inline function 'kotlin.collections.copyOfRange' call
    var toIndex = indices.q1() + 1 | 0;
    var tmp$ret$1 = _ULongArray___init__impl__twm1l3(copyOfRange(_ULongArray___get_storage__impl__28e64j(_this__u8e3s4), tmp2, toIndex));
    return asList_0(tmp$ret$1);
  }
  function toULongArray(_this__u8e3s4) {
    var result = _ULongArray___init__impl__twm1l3_0(_this__u8e3s4.p());
    var index = 0;
    var _iterator__ex2g4s = _this__u8e3s4.m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o().r1_1;
      var _unary__edvuaz = index;
      index = _unary__edvuaz + 1 | 0;
      ULongArray__set_impl_z19mvh(result, _unary__edvuaz, element);
    }
    return result;
  }
  function KotlinNothingValueException_init_$Init$($this) {
    RuntimeException_init_$Init$($this);
    KotlinNothingValueException.call($this);
    return $this;
  }
  function KotlinNothingValueException_init_$Create$() {
    var tmp = KotlinNothingValueException_init_$Init$(objectCreate(protoOf(KotlinNothingValueException)));
    captureStack(tmp, KotlinNothingValueException_init_$Create$);
    return tmp;
  }
  function KotlinNothingValueException() {
    captureStack(this, KotlinNothingValueException);
  }
  function _Char___init__impl__6a9atx(value) {
    return value;
  }
  function _get_value__a43j40($this) {
    return $this;
  }
  function _Char___init__impl__6a9atx_0(code) {
    // Inline function 'kotlin.UShort.toInt' call
    var tmp$ret$0 = _UShort___get_data__impl__g0245(code) & 65535;
    return _Char___init__impl__6a9atx(tmp$ret$0);
  }
  function Char__compareTo_impl_ypi4mb($this, other) {
    return _get_value__a43j40($this) - _get_value__a43j40(other) | 0;
  }
  function Char__compareTo_impl_ypi4mb_0($this, other) {
    return Char__compareTo_impl_ypi4mb($this.s1_1, other instanceof Char ? other.s1_1 : THROW_CCE());
  }
  function Char__plus_impl_qi7pgj($this, other) {
    return numberToChar(_get_value__a43j40($this) + other | 0);
  }
  function Char__minus_impl_a2frrh($this, other) {
    return _get_value__a43j40($this) - _get_value__a43j40(other) | 0;
  }
  function Char__minus_impl_a2frrh_0($this, other) {
    return numberToChar(_get_value__a43j40($this) - other | 0);
  }
  function Char__rangeTo_impl_tkncvp($this, other) {
    return new CharRange($this, other);
  }
  function Char__toInt_impl_vasixd($this) {
    return _get_value__a43j40($this);
  }
  function toString($this) {
    // Inline function 'kotlin.js.unsafeCast' call
    return String.fromCharCode(_get_value__a43j40($this));
  }
  function Char__equals_impl_x6719k($this, other) {
    if (!(other instanceof Char))
      return false;
    return _get_value__a43j40($this) === _get_value__a43j40(other.s1_1);
  }
  function Char__hashCode_impl_otmys($this) {
    return _get_value__a43j40($this);
  }
  function Companion() {
    Companion_instance = this;
    this.t1_1 = _Char___init__impl__6a9atx(0);
    this.u1_1 = _Char___init__impl__6a9atx(65535);
    this.v1_1 = _Char___init__impl__6a9atx(55296);
    this.w1_1 = _Char___init__impl__6a9atx(56319);
    this.x1_1 = _Char___init__impl__6a9atx(56320);
    this.y1_1 = _Char___init__impl__6a9atx(57343);
    this.z1_1 = _Char___init__impl__6a9atx(55296);
    this.a2_1 = _Char___init__impl__6a9atx(57343);
    this.b2_1 = 2;
    this.c2_1 = 16;
  }
  var Companion_instance;
  function Companion_getInstance() {
    if (Companion_instance == null)
      new Companion();
    return Companion_instance;
  }
  function Char(value) {
    Companion_getInstance();
    this.s1_1 = value;
  }
  protoOf(Char).d2 = function (other) {
    return Char__compareTo_impl_ypi4mb(this.s1_1, other);
  };
  protoOf(Char).d = function (other) {
    return Char__compareTo_impl_ypi4mb_0(this, other);
  };
  protoOf(Char).toString = function () {
    return toString(this.s1_1);
  };
  protoOf(Char).equals = function (other) {
    return Char__equals_impl_x6719k(this.s1_1, other);
  };
  protoOf(Char).hashCode = function () {
    return Char__hashCode_impl_otmys(this.s1_1);
  };
  protoOf(Companion_0).fromJsArray = function (array) {
    return createListFrom(array);
  };
  function Companion_0() {
  }
  var Companion_instance_0;
  function Companion_getInstance_0() {
    return Companion_instance_0;
  }
  function KtList() {
  }
  function Collection() {
  }
  function KtMutableList() {
  }
  function KtSet() {
  }
  function KtMutableSet() {
  }
  function Entry() {
  }
  function KtMap() {
  }
  function MutableEntry() {
  }
  function KtMutableMap() {
  }
  function MutableCollection() {
  }
  function MutableIterable() {
  }
  function Companion_1() {
  }
  var Companion_instance_1;
  function Companion_getInstance_1() {
    return Companion_instance_1;
  }
  function Enum(name, ordinal) {
    this.w2_1 = name;
    this.x2_1 = ordinal;
  }
  protoOf(Enum).y2 = function () {
    return this.w2_1;
  };
  protoOf(Enum).z2 = function () {
    return this.x2_1;
  };
  protoOf(Enum).a3 = function (other) {
    return compareTo_0(this.x2_1, other.x2_1);
  };
  protoOf(Enum).d = function (other) {
    return this.a3(other instanceof Enum ? other : THROW_CCE());
  };
  protoOf(Enum).equals = function (other) {
    return this === other;
  };
  protoOf(Enum).hashCode = function () {
    return identityHashCode(this);
  };
  protoOf(Enum).toString = function () {
    return this.w2_1;
  };
  function arrayOf(elements) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return elements;
  }
  function toString_0(_this__u8e3s4) {
    var tmp1_elvis_lhs = _this__u8e3s4 == null ? null : toString_1(_this__u8e3s4);
    return tmp1_elvis_lhs == null ? 'null' : tmp1_elvis_lhs;
  }
  function plus_12(_this__u8e3s4, other) {
    var tmp1_elvis_lhs = _this__u8e3s4 == null ? null : toString_1(_this__u8e3s4);
    var tmp = tmp1_elvis_lhs == null ? 'null' : tmp1_elvis_lhs;
    var tmp3_elvis_lhs = other == null ? null : toString_1(other);
    return tmp + (tmp3_elvis_lhs == null ? 'null' : tmp3_elvis_lhs);
  }
  function Companion_2() {
    this.b3_1 = -9223372036854775808n;
    this.c3_1 = 9223372036854775807n;
    this.d3_1 = 8;
    this.e3_1 = 64;
  }
  var Companion_instance_2;
  function Companion_getInstance_2() {
    return Companion_instance_2;
  }
  function abs(_this__u8e3s4) {
    var tmp;
    // Inline function 'kotlin.js.internal.isNegative' call
    if (_this__u8e3s4 < 0) {
      // Inline function 'kotlin.js.internal.unaryMinus' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = -_this__u8e3s4;
    } else {
      tmp = _this__u8e3s4;
    }
    return tmp;
  }
  function implement(interfaces) {
    var maxSize = 1;
    var masks = [];
    var inductionVariable = 0;
    var last = interfaces.length;
    while (inductionVariable < last) {
      var i = interfaces[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      var currentSize = maxSize;
      var tmp0_elvis_lhs = i.prototype.$imask$;
      var imask = tmp0_elvis_lhs == null ? i.$imask$ : tmp0_elvis_lhs;
      if (!(imask == null)) {
        masks.push(imask);
        currentSize = imask.length;
      }
      var iid = i.$metadata$.iid;
      var tmp;
      if (iid == null) {
        tmp = null;
      } else {
        // Inline function 'kotlin.let' call
        tmp = bitMaskWith(iid);
      }
      var iidImask = tmp;
      if (!(iidImask == null)) {
        masks.push(iidImask);
        currentSize = Math.max(currentSize, iidImask.length);
      }
      if (currentSize > maxSize) {
        maxSize = currentSize;
      }
    }
    return compositeBitMask(maxSize, masks);
  }
  function bitMaskWith(activeBit) {
    var numberIndex = activeBit >> 5;
    var intArray = new Int32Array(numberIndex + 1 | 0);
    var positionInNumber = activeBit & 31;
    var numberWithSettledBit = 1 << positionInNumber;
    intArray[numberIndex] = intArray[numberIndex] | numberWithSettledBit;
    return intArray;
  }
  function compositeBitMask(capacity, masks) {
    var tmp = 0;
    var tmp_0 = new Int32Array(capacity);
    while (tmp < capacity) {
      var tmp_1 = tmp;
      var result = 0;
      var inductionVariable = 0;
      var last = masks.length;
      while (inductionVariable < last) {
        var mask = masks[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        if (tmp_1 < mask.length) {
          result = result | mask[tmp_1];
        }
      }
      tmp_0[tmp_1] = result;
      tmp = tmp + 1 | 0;
    }
    return tmp_0;
  }
  function isBitSet(_this__u8e3s4, possibleActiveBit) {
    var numberIndex = possibleActiveBit >> 5;
    if (numberIndex > _this__u8e3s4.length)
      return false;
    var positionInNumber = possibleActiveBit & 31;
    var numberWithSettledBit = 1 << positionInNumber;
    return !((_this__u8e3s4[numberIndex] & numberWithSettledBit) === 0);
  }
  function FunctionAdapter() {
  }
  function arrayIterator(array) {
    return new arrayIterator$1(array);
  }
  function booleanArray(size) {
    var tmp0 = 'BooleanArray';
    // Inline function 'withType' call
    var array = fillArrayVal(Array(size), false);
    array.$type$ = tmp0;
    // Inline function 'kotlin.js.unsafeCast' call
    return array;
  }
  function fillArrayVal(array, initValue) {
    var inductionVariable = 0;
    var last = array.length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        array[i] = initValue;
      }
       while (!(i === last));
    return array;
  }
  function charArray(size) {
    var tmp0 = 'CharArray';
    // Inline function 'withType' call
    var array = new Uint16Array(size);
    array.$type$ = tmp0;
    // Inline function 'kotlin.js.unsafeCast' call
    return array;
  }
  function longArray(size) {
    var tmp0 = 'LongArray';
    // Inline function 'withType' call
    var array = fillArrayVal(Array(size), 0n);
    array.$type$ = tmp0;
    // Inline function 'kotlin.js.unsafeCast' call
    return array;
  }
  function charArrayOf(arr) {
    var tmp0 = 'CharArray';
    // Inline function 'withType' call
    var array = new Uint16Array(arr);
    array.$type$ = tmp0;
    // Inline function 'kotlin.js.unsafeCast' call
    return array;
  }
  function longArrayOf(arr) {
    var tmp0 = 'LongArray';
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'withType' call
    var array = arr.slice();
    array.$type$ = tmp0;
    // Inline function 'kotlin.js.unsafeCast' call
    return array;
  }
  function arrayIterator$1($array) {
    this.h3_1 = $array;
    this.g3_1 = 0;
  }
  protoOf(arrayIterator$1).n = function () {
    return !(this.g3_1 === this.h3_1.length);
  };
  protoOf(arrayIterator$1).o = function () {
    var tmp;
    if (!(this.g3_1 === this.h3_1.length)) {
      var _unary__edvuaz = this.g3_1;
      this.g3_1 = _unary__edvuaz + 1 | 0;
      tmp = this.h3_1[_unary__edvuaz];
    } else {
      throw NoSuchElementException_init_$Create$_0('' + this.g3_1);
    }
    return tmp;
  };
  function get_buf() {
    _init_properties_bitUtils_kt__nfcg4k();
    return buf;
  }
  var buf;
  function get_bufFloat64() {
    _init_properties_bitUtils_kt__nfcg4k();
    return bufFloat64;
  }
  var bufFloat64;
  function get_bufFloat32() {
    _init_properties_bitUtils_kt__nfcg4k();
    return bufFloat32;
  }
  var bufFloat32;
  function get_bufInt32() {
    _init_properties_bitUtils_kt__nfcg4k();
    return bufInt32;
  }
  var bufInt32;
  function get_lowIndex() {
    _init_properties_bitUtils_kt__nfcg4k();
    return lowIndex;
  }
  var lowIndex;
  function get_highIndex() {
    _init_properties_bitUtils_kt__nfcg4k();
    return highIndex;
  }
  var highIndex;
  function floatToRawBits(value) {
    _init_properties_bitUtils_kt__nfcg4k();
    get_bufFloat32()[0] = value;
    return get_bufInt32()[0];
  }
  function doubleToRawBits(value) {
    _init_properties_bitUtils_kt__nfcg4k();
    get_bufFloat64()[0] = value;
    return longFromTwoInts(get_bufInt32()[get_lowIndex()], get_bufInt32()[get_highIndex()]);
  }
  function floatFromBits(value) {
    _init_properties_bitUtils_kt__nfcg4k();
    get_bufInt32()[0] = value;
    return get_bufFloat32()[0];
  }
  function doubleFromBits(value) {
    _init_properties_bitUtils_kt__nfcg4k();
    get_bufInt32()[get_lowIndex()] = lowBits(value);
    get_bufInt32()[get_highIndex()] = highBits(value);
    return get_bufFloat64()[0];
  }
  function getNumberHashCode(obj) {
    _init_properties_bitUtils_kt__nfcg4k();
    // Inline function 'kotlin.js.jsBitwiseOr' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    if ((obj | 0) === obj) {
      return numberToInt(obj);
    }
    get_bufFloat64()[0] = obj;
    return imul(get_bufInt32()[get_highIndex()], 31) + get_bufInt32()[get_lowIndex()] | 0;
  }
  var properties_initialized_bitUtils_kt_i2bo3e;
  function _init_properties_bitUtils_kt__nfcg4k() {
    if (!properties_initialized_bitUtils_kt_i2bo3e) {
      properties_initialized_bitUtils_kt_i2bo3e = true;
      buf = new ArrayBuffer(8);
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      bufFloat64 = new Float64Array(get_buf());
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      bufFloat32 = new Float32Array(get_buf());
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      bufInt32 = new Int32Array(get_buf());
      // Inline function 'kotlin.run' call
      get_bufFloat64()[0] = -1.0;
      lowIndex = !(get_bufInt32()[0] === 0) ? 1 : 0;
      highIndex = 1 - get_lowIndex() | 0;
    }
  }
  function get_ZERO() {
    _init_properties_boxedLong_kt__v24qrw();
    return ZERO;
  }
  var ZERO;
  function get_ONE() {
    _init_properties_boxedLong_kt__v24qrw();
    return ONE;
  }
  var ONE;
  var NEG_ONE;
  function get_MAX_VALUE() {
    _init_properties_boxedLong_kt__v24qrw();
    return MAX_VALUE;
  }
  var MAX_VALUE;
  function get_MIN_VALUE() {
    _init_properties_boxedLong_kt__v24qrw();
    return MIN_VALUE;
  }
  var MIN_VALUE;
  function get_TWO_PWR_24_() {
    _init_properties_boxedLong_kt__v24qrw();
    return TWO_PWR_24_;
  }
  var TWO_PWR_24_;
  function compare(_this__u8e3s4, other) {
    _init_properties_boxedLong_kt__v24qrw();
    if (equalsLong(_this__u8e3s4, other)) {
      return 0;
    }
    var thisNeg = isNegative(_this__u8e3s4);
    var otherNeg = isNegative(other);
    return thisNeg && !otherNeg ? -1 : !thisNeg && otherNeg ? 1 : isNegative(subtract_0(_this__u8e3s4, other)) ? -1 : 1;
  }
  function add_1(_this__u8e3s4, other) {
    _init_properties_boxedLong_kt__v24qrw();
    var a48 = highBits(_this__u8e3s4) >>> 16 | 0;
    var a32 = highBits(_this__u8e3s4) & 65535;
    var a16 = lowBits(_this__u8e3s4) >>> 16 | 0;
    var a00 = lowBits(_this__u8e3s4) & 65535;
    var b48 = highBits(other) >>> 16 | 0;
    var b32 = highBits(other) & 65535;
    var b16 = lowBits(other) >>> 16 | 0;
    var b00 = lowBits(other) & 65535;
    var c48 = 0;
    var c32 = 0;
    var c16 = 0;
    var c00 = 0;
    c00 = c00 + (a00 + b00 | 0) | 0;
    c16 = c16 + (c00 >>> 16 | 0) | 0;
    c00 = c00 & 65535;
    c16 = c16 + (a16 + b16 | 0) | 0;
    c32 = c32 + (c16 >>> 16 | 0) | 0;
    c16 = c16 & 65535;
    c32 = c32 + (a32 + b32 | 0) | 0;
    c48 = c48 + (c32 >>> 16 | 0) | 0;
    c32 = c32 & 65535;
    c48 = c48 + (a48 + b48 | 0) | 0;
    c48 = c48 & 65535;
    return longFromTwoInts(c16 << 16 | c00, c48 << 16 | c32);
  }
  function subtract_0(_this__u8e3s4, other) {
    _init_properties_boxedLong_kt__v24qrw();
    return add_1(_this__u8e3s4, negate_0(other));
  }
  function multiply(_this__u8e3s4, other) {
    _init_properties_boxedLong_kt__v24qrw();
    if (isZero(_this__u8e3s4)) {
      return get_ZERO();
    } else if (isZero(other)) {
      return get_ZERO();
    }
    if (equalsLong(_this__u8e3s4, get_MIN_VALUE())) {
      return isOdd(other) ? get_MIN_VALUE() : get_ZERO();
    } else if (equalsLong(other, get_MIN_VALUE())) {
      return isOdd(_this__u8e3s4) ? get_MIN_VALUE() : get_ZERO();
    }
    if (isNegative(_this__u8e3s4)) {
      var tmp;
      if (isNegative(other)) {
        tmp = multiply(negate(_this__u8e3s4), negate(other));
      } else {
        tmp = negate(multiply(negate(_this__u8e3s4), other));
      }
      return tmp;
    } else if (isNegative(other)) {
      return negate(multiply(_this__u8e3s4, negate(other)));
    }
    if (lessThan(_this__u8e3s4, get_TWO_PWR_24_()) && lessThan(other, get_TWO_PWR_24_())) {
      return fromNumber(toNumber(_this__u8e3s4) * toNumber(other));
    }
    var a48 = highBits(_this__u8e3s4) >>> 16 | 0;
    var a32 = highBits(_this__u8e3s4) & 65535;
    var a16 = lowBits(_this__u8e3s4) >>> 16 | 0;
    var a00 = lowBits(_this__u8e3s4) & 65535;
    var b48 = highBits(other) >>> 16 | 0;
    var b32 = highBits(other) & 65535;
    var b16 = lowBits(other) >>> 16 | 0;
    var b00 = lowBits(other) & 65535;
    var c48 = 0;
    var c32 = 0;
    var c16 = 0;
    var c00 = 0;
    c00 = c00 + imul(a00, b00) | 0;
    c16 = c16 + (c00 >>> 16 | 0) | 0;
    c00 = c00 & 65535;
    c16 = c16 + imul(a16, b00) | 0;
    c32 = c32 + (c16 >>> 16 | 0) | 0;
    c16 = c16 & 65535;
    c16 = c16 + imul(a00, b16) | 0;
    c32 = c32 + (c16 >>> 16 | 0) | 0;
    c16 = c16 & 65535;
    c32 = c32 + imul(a32, b00) | 0;
    c48 = c48 + (c32 >>> 16 | 0) | 0;
    c32 = c32 & 65535;
    c32 = c32 + imul(a16, b16) | 0;
    c48 = c48 + (c32 >>> 16 | 0) | 0;
    c32 = c32 & 65535;
    c32 = c32 + imul(a00, b32) | 0;
    c48 = c48 + (c32 >>> 16 | 0) | 0;
    c32 = c32 & 65535;
    c48 = c48 + (((imul(a48, b00) + imul(a32, b16) | 0) + imul(a16, b32) | 0) + imul(a00, b48) | 0) | 0;
    c48 = c48 & 65535;
    return longFromTwoInts(c16 << 16 | c00, c48 << 16 | c32);
  }
  function invert(_this__u8e3s4) {
    _init_properties_boxedLong_kt__v24qrw();
    return longFromTwoInts(~lowBits(_this__u8e3s4), ~highBits(_this__u8e3s4));
  }
  function toNumber(_this__u8e3s4) {
    _init_properties_boxedLong_kt__v24qrw();
    return highBits(_this__u8e3s4) * 4.294967296E9 + getLowBitsUnsigned(_this__u8e3s4);
  }
  function toStringImpl(_this__u8e3s4, radix) {
    _init_properties_boxedLong_kt__v24qrw();
    if (isZero(_this__u8e3s4)) {
      return '0';
    }
    if (isNegative(_this__u8e3s4)) {
      if (equalsLong(_this__u8e3s4, get_MIN_VALUE())) {
        var radixLong = fromInt(radix);
        var div = divide(_this__u8e3s4, radixLong);
        var rem = convertToInt(subtract_0(multiply(div, radixLong), _this__u8e3s4));
        var tmp = toStringImpl(div, radix);
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.unsafeCast' call
        return tmp + rem.toString(radix);
      } else {
        return '-' + toStringImpl(negate(_this__u8e3s4), radix);
      }
    }
    var digitsPerTime = radix === 2 ? 31 : radix <= 10 ? 9 : radix <= 21 ? 7 : radix <= 35 ? 6 : 5;
    var radixToPower = fromNumber(Math.pow(radix, digitsPerTime));
    var rem_0 = _this__u8e3s4;
    var result = '';
    while (true) {
      var remDiv = divide(rem_0, radixToPower);
      var intval = convertToInt(subtract_0(rem_0, multiply(remDiv, radixToPower)));
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.unsafeCast' call
      var digits = intval.toString(radix);
      rem_0 = remDiv;
      if (isZero(rem_0)) {
        return digits + result;
      } else {
        while (digits.length < digitsPerTime) {
          digits = '0' + digits;
        }
        result = digits + result;
      }
    }
  }
  function equalsLong(_this__u8e3s4, other) {
    _init_properties_boxedLong_kt__v24qrw();
    return highBits(_this__u8e3s4) === highBits(other) && lowBits(_this__u8e3s4) === lowBits(other);
  }
  function fromInt(value) {
    _init_properties_boxedLong_kt__v24qrw();
    return longFromTwoInts(value, value < 0 ? -1 : 0);
  }
  function isNegative(_this__u8e3s4) {
    _init_properties_boxedLong_kt__v24qrw();
    return highBits(_this__u8e3s4) < 0;
  }
  function isZero(_this__u8e3s4) {
    _init_properties_boxedLong_kt__v24qrw();
    return highBits(_this__u8e3s4) === 0 && lowBits(_this__u8e3s4) === 0;
  }
  function isOdd(_this__u8e3s4) {
    _init_properties_boxedLong_kt__v24qrw();
    return (lowBits(_this__u8e3s4) & 1) === 1;
  }
  function negate(_this__u8e3s4) {
    _init_properties_boxedLong_kt__v24qrw();
    return add_2(invert(_this__u8e3s4), 1n);
  }
  function lessThan(_this__u8e3s4, other) {
    _init_properties_boxedLong_kt__v24qrw();
    return compare(_this__u8e3s4, other) < 0;
  }
  function fromNumber(value) {
    _init_properties_boxedLong_kt__v24qrw();
    if (isNaN_0(value)) {
      return get_ZERO();
    } else if (value <= -9.223372036854776E18) {
      return get_MIN_VALUE();
    } else if (value + 1 >= 9.223372036854776E18) {
      return get_MAX_VALUE();
    } else if (value < 0) {
      return negate(fromNumber(-value));
    } else {
      var twoPwr32 = 4.294967296E9;
      // Inline function 'kotlin.js.jsBitwiseOr' call
      var tmp = value % twoPwr32 | 0;
      // Inline function 'kotlin.js.jsBitwiseOr' call
      var tmp$ret$1 = value / twoPwr32 | 0;
      return longFromTwoInts(tmp, tmp$ret$1);
    }
  }
  function getLowBitsUnsigned(_this__u8e3s4) {
    _init_properties_boxedLong_kt__v24qrw();
    return lowBits(_this__u8e3s4) >= 0 ? lowBits(_this__u8e3s4) : 4.294967296E9 + lowBits(_this__u8e3s4);
  }
  var properties_initialized_boxedLong_kt_lfwt2;
  function _init_properties_boxedLong_kt__v24qrw() {
    if (!properties_initialized_boxedLong_kt_lfwt2) {
      properties_initialized_boxedLong_kt_lfwt2 = true;
      ZERO = fromInt(0);
      ONE = fromInt(1);
      NEG_ONE = fromInt(-1);
      MAX_VALUE = longFromTwoInts(-1, 2147483647);
      MIN_VALUE = longFromTwoInts(0, -2147483648);
      TWO_PWR_24_ = fromInt(16777216);
    }
  }
  function charSequenceGet(a, index) {
    var tmp;
    if (isString(a)) {
      tmp = charCodeAt(a, index);
    } else {
      tmp = a.b(index);
    }
    return tmp;
  }
  function isString(a) {
    return typeof a === 'string';
  }
  function charCodeAt(_this__u8e3s4, index) {
    // Inline function 'kotlin.js.asDynamic' call
    return _this__u8e3s4.charCodeAt(index);
  }
  function charSequenceLength(a) {
    var tmp;
    if (isString(a)) {
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.unsafeCast' call
      tmp = a.length;
    } else {
      tmp = a.a();
    }
    return tmp;
  }
  function charSequenceSubSequence(a, startIndex, endIndex) {
    var tmp;
    if (isString(a)) {
      tmp = substring(a, startIndex, endIndex);
    } else {
      tmp = a.c(startIndex, endIndex);
    }
    return tmp;
  }
  function arrayToString(array) {
    return joinToString(array, ', ', '[', ']', VOID, VOID, arrayToString$lambda);
  }
  function contentEqualsInternal(_this__u8e3s4, other) {
    // Inline function 'kotlin.js.asDynamic' call
    var a = _this__u8e3s4;
    // Inline function 'kotlin.js.asDynamic' call
    var b = other;
    if (a === b)
      return true;
    if (a == null || b == null || !isArrayish(b) || a.length != b.length)
      return false;
    var inductionVariable = 0;
    var last = a.length;
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!equals(a[i], b[i])) {
          return false;
        }
      }
       while (inductionVariable < last);
    return true;
  }
  function contentHashCodeInternal(_this__u8e3s4) {
    // Inline function 'kotlin.js.asDynamic' call
    var a = _this__u8e3s4;
    if (a == null)
      return 0;
    var result = 1;
    var inductionVariable = 0;
    var last = a.length;
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        result = imul(result, 31) + hashCode(a[i]) | 0;
      }
       while (inductionVariable < last);
    return result;
  }
  function arrayToString$lambda(it) {
    return toString_1(it);
  }
  function createJsReadonlyArrayViewFrom(list) {
    var tmp = createJsReadonlyArrayViewFrom$lambda(list);
    var tmp_0 = createJsReadonlyArrayViewFrom$lambda_0(list);
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_1 = UNSUPPORTED_OPERATION$ref();
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_2 = UNSUPPORTED_OPERATION$ref_0();
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$2 = UNSUPPORTED_OPERATION$ref_1();
    return createJsArrayViewWith(tmp, tmp_0, tmp_1, tmp_2, tmp$ret$2);
  }
  function createJsArrayViewWith(listSize, listGet, listSet, listDecreaseSize, listIncreaseSize) {
    var arrayView = new Array();
    var tmp = Object;
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$0 = JsArrayView;
    tmp.setPrototypeOf(arrayView, tmp$ret$0.prototype);
    return new Proxy(arrayView, {get: function (target, prop, receiver) {
      if (prop === 'length')
        return listSize();
      var type = typeof prop;
      var index = type === 'string' || type === 'number' ? +prop : undefined;
      if (!isNaN(index))
        return listGet(index);
      return target[prop];
    }, has: function (target, key) {
      return !isNaN(key) && key < listSize();
    }, set: function (obj, prop, value) {
      if (prop === 'length') {
        var size = listSize();
        var newSize = type === 'string' || type === 'number' ? +prop : undefined;
        if (isNaN(newSize))
          throw new RangeError('invalid array length');
        if (newSize < size)
          listDecreaseSize(size - newSize);
        else
          listIncreaseSize(newSize - size);
        return true;
      }
      var type = typeof prop;
      var index = type === 'string' || type === 'number' ? +prop : undefined;
      if (isNaN(index))
        return false;
      listSet(index, value);
      return true;
    }});
  }
  function UNSUPPORTED_OPERATION() {
    throw UnsupportedOperationException_init_$Create$();
  }
  function JsArrayView() {
    Array.call(this);
  }
  function createListFrom(array) {
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp$ret$1 = array.slice();
    return (new ArrayList(tmp$ret$1)).i3();
  }
  function createJsReadonlyArrayViewFrom$lambda($list) {
    return function () {
      return $list.p();
    };
  }
  function createJsReadonlyArrayViewFrom$lambda_0($list) {
    return function (i) {
      return $list.r(i);
    };
  }
  function UNSUPPORTED_OPERATION$ref() {
    var l = function () {
      UNSUPPORTED_OPERATION();
      return Unit_instance;
    };
    l.callableName = 'UNSUPPORTED_OPERATION';
    return l;
  }
  function UNSUPPORTED_OPERATION$ref_0() {
    var l = function () {
      UNSUPPORTED_OPERATION();
      return Unit_instance;
    };
    l.callableName = 'UNSUPPORTED_OPERATION';
    return l;
  }
  function UNSUPPORTED_OPERATION$ref_1() {
    var l = function () {
      UNSUPPORTED_OPERATION();
      return Unit_instance;
    };
    l.callableName = 'UNSUPPORTED_OPERATION';
    return l;
  }
  function compareTo_0(a, b) {
    var tmp;
    switch (typeof a) {
      case 'number':
        var tmp_0;
        if (typeof b === 'number') {
          tmp_0 = doubleCompareTo(a, b);
        } else {
          if (!(b == null) ? typeof b === 'bigint' : false) {
            tmp_0 = doubleCompareTo(a, toNumber_0(b));
          } else {
            tmp_0 = primitiveCompareTo(a, b);
          }
        }

        tmp = tmp_0;
        break;
      case 'string':
      case 'boolean':
      case 'bigint':
        tmp = primitiveCompareTo(a, b);
        break;
      default:
        tmp = compareToDoNotIntrinsicify(a, b);
        break;
    }
    return tmp;
  }
  function doubleCompareTo(a, b) {
    var tmp;
    if (a < b) {
      tmp = -1;
    } else if (a > b) {
      tmp = 1;
    } else if (a === b) {
      var tmp_0;
      if (a !== 0) {
        tmp_0 = 0;
      } else {
        // Inline function 'kotlin.js.asDynamic' call
        var ia = 1 / a;
        var tmp_1;
        // Inline function 'kotlin.js.asDynamic' call
        if (ia === 1 / b) {
          tmp_1 = 0;
        } else {
          if (ia < 0) {
            tmp_1 = -1;
          } else {
            tmp_1 = 1;
          }
        }
        tmp_0 = tmp_1;
      }
      tmp = tmp_0;
    } else if (a !== a) {
      tmp = b !== b ? 0 : 1;
    } else {
      tmp = -1;
    }
    return tmp;
  }
  function primitiveCompareTo(a, b) {
    return a < b ? -1 : a > b ? 1 : 0;
  }
  function compareToDoNotIntrinsicify(a, b) {
    return a.d(b);
  }
  function identityHashCode(obj) {
    return getObjectHashCode(obj);
  }
  function getObjectHashCode(obj) {
    // Inline function 'kotlin.js.jsIn' call
    if (!('kotlinHashCodeValue$' in obj)) {
      var hash = calculateRandomHash();
      var descriptor = new Object();
      descriptor.value = hash;
      descriptor.enumerable = false;
      Object.defineProperty(obj, 'kotlinHashCodeValue$', descriptor);
    }
    // Inline function 'kotlin.js.unsafeCast' call
    return obj['kotlinHashCodeValue$'];
  }
  function calculateRandomHash() {
    // Inline function 'kotlin.js.jsBitwiseOr' call
    return Math.random() * 4.294967296E9 | 0;
  }
  function objectCreate(proto) {
    proto = proto === VOID ? null : proto;
    return Object.create(proto);
  }
  function defineProp(obj, name, getter, setter, enumerable) {
    return Object.defineProperty(obj, name, {configurable: true, get: getter, set: setter, enumerable: enumerable});
  }
  function toString_1(o) {
    var tmp;
    if (o == null) {
      tmp = 'null';
    } else if (isArrayish(o)) {
      tmp = '[...]';
    } else if (!(typeof o.toString === 'function')) {
      tmp = anyToString(o);
    } else {
      // Inline function 'kotlin.js.unsafeCast' call
      tmp = o.toString();
    }
    return tmp;
  }
  function equals(obj1, obj2) {
    if (obj1 == null) {
      return obj2 == null;
    }
    if (obj2 == null) {
      return false;
    }
    if (typeof obj1 === 'object' && typeof obj1.equals === 'function') {
      return obj1.equals(obj2);
    }
    if (obj1 !== obj1) {
      return obj2 !== obj2;
    }
    if (typeof obj1 === 'number' && typeof obj2 === 'number') {
      var tmp;
      if (obj1 === obj2) {
        var tmp_0;
        if (obj1 !== 0) {
          tmp_0 = true;
        } else {
          // Inline function 'kotlin.js.asDynamic' call
          var tmp_1 = 1 / obj1;
          // Inline function 'kotlin.js.asDynamic' call
          tmp_0 = tmp_1 === 1 / obj2;
        }
        tmp = tmp_0;
      } else {
        tmp = false;
      }
      return tmp;
    }
    return obj1 === obj2;
  }
  function hashCode(obj) {
    if (obj == null)
      return 0;
    var typeOf = typeof obj;
    var tmp;
    switch (typeOf) {
      case 'object':
        tmp = 'function' === typeof obj.hashCode ? obj.hashCode() : getObjectHashCode(obj);
        break;
      case 'function':
        tmp = getObjectHashCode(obj);
        break;
      case 'number':
        tmp = getNumberHashCode(obj);
        break;
      case 'boolean':
        // Inline function 'kotlin.js.unsafeCast' call

        tmp = getBooleanHashCode(obj);
        break;
      case 'string':
        tmp = getStringHashCode(String(obj));
        break;
      case 'bigint':
        // Inline function 'kotlin.js.unsafeCast' call

        tmp = getBigIntHashCode(obj);
        break;
      case 'symbol':
        tmp = getSymbolHashCode(obj);
        break;
      default:
        tmp = function () {
          throw new Error('Unexpected typeof `' + typeOf + '`');
        }();
        break;
    }
    return tmp;
  }
  function anyToString(o) {
    return Object.prototype.toString.call(o);
  }
  function getBooleanHashCode(value) {
    return value ? 1231 : 1237;
  }
  function getStringHashCode(str) {
    var hash = 0;
    var length = str.length;
    var inductionVariable = 0;
    var last = length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        var code = str.charCodeAt(i);
        hash = imul(hash, 31) + code | 0;
      }
       while (!(i === last));
    return hash;
  }
  function getBigIntHashCode(value) {
    var shiftNumber = BigInt(32);
    var mask = BigInt(4.294967295E9);
    var bigNumber = abs(value);
    var hashCode = 0;
    var tmp;
    // Inline function 'kotlin.js.internal.isNegative' call
    if (value < 0) {
      tmp = -1;
    } else {
      tmp = 1;
    }
    var signum = tmp;
    $l$loop: while (true) {
      // Inline function 'kotlin.js.internal.isZero' call
      if (!!(bigNumber == 0)) {
        break $l$loop;
      }
      // Inline function 'kotlin.js.internal.and' call
      // Inline function 'kotlin.js.jsBitwiseAnd' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.internal.toNumber' call
      var self_0 = bigNumber & mask;
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var chunk = Number(self_0);
      hashCode = imul(31, hashCode) + chunk | 0;
      // Inline function 'kotlin.js.internal.shr' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      bigNumber = bigNumber >> shiftNumber;
    }
    return imul(hashCode, signum);
  }
  function getSymbolHashCode(value) {
    var hashCodeMap = symbolIsSharable(value) ? getSymbolMap() : getSymbolWeakMap();
    var cachedHashCode = hashCodeMap.get(value);
    if (cachedHashCode !== VOID)
      return cachedHashCode;
    var hash = calculateRandomHash();
    hashCodeMap.set(value, hash);
    return hash;
  }
  function symbolIsSharable(symbol) {
    return Symbol.keyFor(symbol) != VOID;
  }
  function getSymbolMap() {
    if (symbolMap === VOID) {
      symbolMap = new Map();
    }
    return symbolMap;
  }
  function getSymbolWeakMap() {
    if (symbolWeakMap === VOID) {
      symbolWeakMap = new WeakMap();
    }
    return symbolWeakMap;
  }
  var symbolMap;
  var symbolWeakMap;
  function boxIntrinsic(x) {
    var message = 'Should be lowered';
    throw IllegalStateException_init_$Create$_0(toString_1(message));
  }
  function unboxIntrinsic(x) {
    var message = 'Should be lowered';
    throw IllegalStateException_init_$Create$_0(toString_1(message));
  }
  function captureStack(instance, constructorFunction) {
    if (Error.captureStackTrace != null) {
      Error.captureStackTrace(instance, constructorFunction);
    } else {
      // Inline function 'kotlin.js.asDynamic' call
      instance.stack = (new Error()).stack;
    }
  }
  function protoOf(constructor) {
    return constructor.prototype;
  }
  function defineMessage(message, cause) {
    var tmp;
    if (isUndefined(message)) {
      var tmp_0;
      if (isUndefined(cause)) {
        tmp_0 = message;
      } else {
        var tmp1_elvis_lhs = cause == null ? null : cause.toString();
        tmp_0 = tmp1_elvis_lhs == null ? VOID : tmp1_elvis_lhs;
      }
      tmp = tmp_0;
    } else {
      tmp = message == null ? VOID : message;
    }
    return tmp;
  }
  function isUndefined(value) {
    return value === VOID;
  }
  function extendThrowable(this_, message, cause) {
    defineFieldOnInstance(this_, 'message', defineMessage(message, cause));
    defineFieldOnInstance(this_, 'cause', cause);
    defineFieldOnInstance(this_, 'name', Object.getPrototypeOf(this_).constructor.name);
  }
  function defineFieldOnInstance(this_, name, value) {
    Object.defineProperty(this_, name, {configurable: true, writable: true, value: value});
  }
  function returnIfSuspended(argument, $completion) {
    return (argument == null ? true : !(argument == null)) ? argument : THROW_CCE();
  }
  function ensureNotNull(v) {
    var tmp;
    if (v == null) {
      THROW_NPE();
    } else {
      tmp = v;
    }
    return tmp;
  }
  function THROW_NPE() {
    throw NullPointerException_init_$Create$();
  }
  function noWhenBranchMatchedException() {
    throw NoWhenBranchMatchedException_init_$Create$();
  }
  function THROW_CCE() {
    throw ClassCastException_init_$Create$();
  }
  function throwUninitializedPropertyAccessException(name) {
    throw UninitializedPropertyAccessException_init_$Create$_0('lateinit property ' + name + ' has not been initialized');
  }
  function throwUnsupportedOperationException(message) {
    throw UnsupportedOperationException_init_$Create$_0(message);
  }
  function throwKotlinNothingValueException() {
    throw KotlinNothingValueException_init_$Create$();
  }
  function THROW_IAE(msg) {
    throw IllegalArgumentException_init_$Create$_0(msg);
  }
  function negate_0(_this__u8e3s4) {
    var tmp = BigInt;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.js.internal.unaryMinus' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$4 = -_this__u8e3s4;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return tmp.asIntN(64, tmp$ret$4);
  }
  function add_2(_this__u8e3s4, other) {
    // Inline function 'kotlin.js.internal.longAsBigInt.wrappingArithmetic' call
    var tmp = BigInt;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.js.internal.plus' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$7 = _this__u8e3s4 + other;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return tmp.asIntN(64, tmp$ret$7);
  }
  function subtract_1(_this__u8e3s4, other) {
    // Inline function 'kotlin.js.internal.longAsBigInt.wrappingArithmetic' call
    var tmp = BigInt;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.js.internal.minus' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$7 = _this__u8e3s4 - other;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return tmp.asIntN(64, tmp$ret$7);
  }
  function multiply_0(_this__u8e3s4, other) {
    // Inline function 'kotlin.js.internal.longAsBigInt.wrappingArithmetic' call
    var tmp = BigInt;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.js.internal.times' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$7 = _this__u8e3s4 * other;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return tmp.asIntN(64, tmp$ret$7);
  }
  function divide(_this__u8e3s4, other) {
    // Inline function 'kotlin.js.internal.longAsBigInt.wrappingArithmetic' call
    var tmp = BigInt;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.js.internal.div' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$7 = _this__u8e3s4 / other;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return tmp.asIntN(64, tmp$ret$7);
  }
  function modulo(_this__u8e3s4, other) {
    // Inline function 'kotlin.js.internal.longAsBigInt.wrappingArithmetic' call
    var tmp = BigInt;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.js.internal.rem' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$7 = _this__u8e3s4 % other;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return tmp.asIntN(64, tmp$ret$7);
  }
  function shiftLeft(_this__u8e3s4, numBits) {
    // Inline function 'kotlin.js.internal.longAsBigInt.wrappingArithmetic' call
    var tmp = BigInt;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.js.internal.shl' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$7 = _this__u8e3s4 << fromInt_0(sanitizeBitShiftRHS(numBits));
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return tmp.asIntN(64, tmp$ret$7);
  }
  function sanitizeBitShiftRHS(numBits) {
    return numBits & 63;
  }
  function shiftRight(_this__u8e3s4, numBits) {
    // Inline function 'kotlin.js.internal.longAsBigInt.wrappingArithmetic' call
    var tmp = BigInt;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.js.internal.shr' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$7 = _this__u8e3s4 >> fromInt_0(sanitizeBitShiftRHS(numBits));
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return tmp.asIntN(64, tmp$ret$7);
  }
  function shiftRightUnsigned(_this__u8e3s4, numBits) {
    // Inline function 'kotlin.js.internal.longAsBigInt.wrappingArithmetic' call
    var tmp = BigInt;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var rhs = fromInt_0(sanitizeBitShiftRHS(numBits));
    // Inline function 'kotlin.js.internal.shr' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$7 = BigInt.asUintN(64, _this__u8e3s4) >> rhs;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return tmp.asIntN(64, tmp$ret$7);
  }
  function numberToLong(value) {
    var tmp0_elvis_lhs = (!(value == null) ? typeof value === 'bigint' : false) ? value : null;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.js.unsafeCast' call
      tmp = fromNumber_0(value);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function fromNumber_0(value) {
    var tmp;
    if (isNaN_0(value)) {
      tmp = 0n;
    } else if (value <= -9.223372036854776E18) {
      tmp = -9223372036854775808n;
    } else if (value + 1 >= 9.223372036854776E18) {
      tmp = 9223372036854775807n;
    } else {
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = BigInt(trunc(value));
    }
    return tmp;
  }
  function fromInt_0(value) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return BigInt(value);
  }
  function convertToByte(_this__u8e3s4) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return truncating(_this__u8e3s4, 8);
  }
  function truncating(_this__u8e3s4, bitSize) {
    var tmp = BigInt;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.js.internal.toNumber' call
    var self_0 = tmp.asIntN(bitSize, _this__u8e3s4);
    // Inline function 'kotlin.js.unsafeCast' call
    return Number(self_0);
  }
  function toNumber_0(_this__u8e3s4) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.js.internal.toNumber' call
    var self_0 = _this__u8e3s4;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return Number(self_0);
  }
  function convertToShort(_this__u8e3s4) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return truncating(_this__u8e3s4, 16);
  }
  function convertToInt(_this__u8e3s4) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return truncating(_this__u8e3s4, 32);
  }
  function longFromTwoInts(low, high) {
    return shiftLeft(fromInt_0(high), 32) | fromInt_0(low) & 4294967295n;
  }
  function lowBits(_this__u8e3s4) {
    return convertToInt(_this__u8e3s4);
  }
  function highBits(_this__u8e3s4) {
    return convertToInt(shiftRight(_this__u8e3s4, 32));
  }
  function toStringImpl_0(_this__u8e3s4, radix) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return _this__u8e3s4.toString(radix);
  }
  function createMetadata(kind, name, defaultConstructor, associatedObjectKey, associatedObjects, suspendArity) {
    var undef = VOID;
    var iid = kind === 'interface' ? generateInterfaceId() : VOID;
    return {kind: kind, simpleName: name, associatedObjectKey: associatedObjectKey, associatedObjects: associatedObjects, suspendArity: suspendArity, $kClass$: undef, defaultConstructor: defaultConstructor, iid: iid};
  }
  function generateInterfaceId() {
    if (globalInterfaceId === VOID) {
      globalInterfaceId = 0;
    }
    // Inline function 'kotlin.js.unsafeCast' call
    globalInterfaceId = globalInterfaceId + 1 | 0;
    // Inline function 'kotlin.js.unsafeCast' call
    return globalInterfaceId;
  }
  var globalInterfaceId;
  function initMetadataForClass(ctor, name, defaultConstructor, parent, interfaces, suspendArity, associatedObjectKey, associatedObjects) {
    var kind = 'class';
    initMetadataFor(kind, ctor, name, defaultConstructor, parent, interfaces, suspendArity, associatedObjectKey, associatedObjects);
  }
  function initMetadataFor(kind, ctor, name, defaultConstructor, parent, interfaces, suspendArity, associatedObjectKey, associatedObjects) {
    if (!(parent == null)) {
      ctor.prototype = Object.create(parent.prototype);
      ctor.prototype.constructor = ctor;
    }
    var metadata = createMetadata(kind, name, defaultConstructor, associatedObjectKey, associatedObjects, suspendArity);
    ctor.$metadata$ = metadata;
    if (!(interfaces == null)) {
      var receiver = !equals(metadata.iid, VOID) ? ctor : ctor.prototype;
      receiver.$imask$ = implement(interfaces);
    }
  }
  function initMetadataForObject(ctor, name, defaultConstructor, parent, interfaces, suspendArity, associatedObjectKey, associatedObjects) {
    var kind = 'object';
    initMetadataFor(kind, ctor, name, defaultConstructor, parent, interfaces, suspendArity, associatedObjectKey, associatedObjects);
  }
  function initMetadataForInterface(ctor, name, defaultConstructor, parent, interfaces, suspendArity, associatedObjectKey, associatedObjects) {
    var kind = 'interface';
    initMetadataFor(kind, ctor, name, defaultConstructor, parent, interfaces, suspendArity, associatedObjectKey, associatedObjects);
  }
  function initMetadataForLambda(ctor, parent, interfaces, suspendArity) {
    initMetadataForClass(ctor, 'Lambda', VOID, parent, interfaces, suspendArity, VOID, VOID);
  }
  function initMetadataForCoroutine(ctor, parent, interfaces, suspendArity) {
    initMetadataForClass(ctor, 'Coroutine', VOID, parent, interfaces, suspendArity, VOID, VOID);
  }
  function initMetadataForFunctionReference(ctor, parent, interfaces, suspendArity) {
    initMetadataForClass(ctor, 'FunctionReference', VOID, parent, interfaces, suspendArity, VOID, VOID);
  }
  function initMetadataForCompanion(ctor, parent, interfaces, suspendArity) {
    initMetadataForObject(ctor, 'Companion', VOID, parent, interfaces, suspendArity, VOID, VOID);
  }
  function primitiveArrayConcat(args) {
    var size_local = 0;
    var inductionVariable = 0;
    var last = args.length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = size_local;
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        size_local = tmp + args[i].length | 0;
      }
       while (!(i === last));
    var a = args[0];
    // Inline function 'kotlin.js.unsafeCast' call
    var result = new a.constructor(size_local);
    // Inline function 'kotlin.js.asDynamic' call
    if (a.$type$ != null) {
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'withType' call
      result.$type$ = a.$type$;
    }
    size_local = 0;
    var inductionVariable_0 = 0;
    var last_0 = args.length - 1 | 0;
    if (inductionVariable_0 <= last_0)
      do {
        var i_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var arr = args[i_0];
        var inductionVariable_1 = 0;
        var last_1 = arr.length - 1 | 0;
        if (inductionVariable_1 <= last_1)
          do {
            var j = inductionVariable_1;
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            var _unary__edvuaz = size_local;
            size_local = _unary__edvuaz + 1 | 0;
            result[_unary__edvuaz] = arr[j];
          }
           while (!(j === last_1));
      }
       while (!(i_0 === last_0));
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return result;
  }
  function arrayConcat(args) {
    var len = args.length;
    // Inline function 'kotlin.js.unsafeCast' call
    var typed = Array(len);
    var inductionVariable = 0;
    var last = len - 1 | 0;
    if (inductionVariable <= last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var arr = args[i];
        if (!(!(arr == null) ? isArray(arr) : false)) {
          typed[i] = [].slice.call(arr);
        } else {
          typed[i] = arr;
        }
      }
       while (!(i === last));
    return [].concat.apply([], typed);
  }
  function toByte(a) {
    // Inline function 'kotlin.js.unsafeCast' call
    return a << 24 >> 24;
  }
  function numberToInt(a) {
    var tmp;
    if (!(a == null) ? typeof a === 'bigint' : false) {
      tmp = convertToInt(a);
    } else {
      tmp = doubleToInt(a);
    }
    return tmp;
  }
  function doubleToInt(a) {
    var tmp;
    if (a > 2147483647) {
      tmp = 2147483647;
    } else if (a < -2147483648) {
      tmp = -2147483648;
    } else {
      // Inline function 'kotlin.js.jsBitwiseOr' call
      tmp = a | 0;
    }
    return tmp;
  }
  function numberToDouble(a) {
    // Inline function 'kotlin.js.unsafeCast' call
    return Number(a);
  }
  function toShort(a) {
    // Inline function 'kotlin.js.unsafeCast' call
    return a << 16 >> 16;
  }
  function numberToChar(a) {
    // Inline function 'kotlin.toUShort' call
    var this_0 = numberToInt(a);
    var tmp$ret$0 = _UShort___init__impl__jigrne(toShort(this_0));
    return _Char___init__impl__6a9atx_0(tmp$ret$0);
  }
  function ByteCompanionObject() {
    this.MIN_VALUE = -128;
    this.MAX_VALUE = 127;
    this.SIZE_BYTES = 1;
    this.SIZE_BITS = 8;
  }
  protoOf(ByteCompanionObject).j3 = function () {
    return this.MIN_VALUE;
  };
  protoOf(ByteCompanionObject).k3 = function () {
    return this.MAX_VALUE;
  };
  protoOf(ByteCompanionObject).l3 = function () {
    return this.SIZE_BYTES;
  };
  protoOf(ByteCompanionObject).m3 = function () {
    return this.SIZE_BITS;
  };
  var ByteCompanionObject_instance;
  function ByteCompanionObject_getInstance() {
    return ByteCompanionObject_instance;
  }
  function ShortCompanionObject() {
    this.MIN_VALUE = -32768;
    this.MAX_VALUE = 32767;
    this.SIZE_BYTES = 2;
    this.SIZE_BITS = 16;
  }
  protoOf(ShortCompanionObject).j3 = function () {
    return this.MIN_VALUE;
  };
  protoOf(ShortCompanionObject).k3 = function () {
    return this.MAX_VALUE;
  };
  protoOf(ShortCompanionObject).l3 = function () {
    return this.SIZE_BYTES;
  };
  protoOf(ShortCompanionObject).m3 = function () {
    return this.SIZE_BITS;
  };
  var ShortCompanionObject_instance;
  function ShortCompanionObject_getInstance() {
    return ShortCompanionObject_instance;
  }
  function IntCompanionObject() {
    this.MIN_VALUE = -2147483648;
    this.MAX_VALUE = 2147483647;
    this.SIZE_BYTES = 4;
    this.SIZE_BITS = 32;
  }
  protoOf(IntCompanionObject).j3 = function () {
    return this.MIN_VALUE;
  };
  protoOf(IntCompanionObject).k3 = function () {
    return this.MAX_VALUE;
  };
  protoOf(IntCompanionObject).l3 = function () {
    return this.SIZE_BYTES;
  };
  protoOf(IntCompanionObject).m3 = function () {
    return this.SIZE_BITS;
  };
  var IntCompanionObject_instance;
  function IntCompanionObject_getInstance() {
    return IntCompanionObject_instance;
  }
  function FloatCompanionObject() {
    this.MIN_VALUE = 1.4E-45;
    this.MAX_VALUE = 3.4028235E38;
    this.POSITIVE_INFINITY = Infinity;
    this.NEGATIVE_INFINITY = -Infinity;
    this.NaN = NaN;
    this.SIZE_BYTES = 4;
    this.SIZE_BITS = 32;
  }
  protoOf(FloatCompanionObject).j3 = function () {
    return this.MIN_VALUE;
  };
  protoOf(FloatCompanionObject).k3 = function () {
    return this.MAX_VALUE;
  };
  protoOf(FloatCompanionObject).n3 = function () {
    return this.POSITIVE_INFINITY;
  };
  protoOf(FloatCompanionObject).o3 = function () {
    return this.NEGATIVE_INFINITY;
  };
  protoOf(FloatCompanionObject).p3 = function () {
    return this.NaN;
  };
  protoOf(FloatCompanionObject).l3 = function () {
    return this.SIZE_BYTES;
  };
  protoOf(FloatCompanionObject).m3 = function () {
    return this.SIZE_BITS;
  };
  var FloatCompanionObject_instance;
  function FloatCompanionObject_getInstance() {
    return FloatCompanionObject_instance;
  }
  function DoubleCompanionObject() {
    this.MIN_VALUE = 4.9E-324;
    this.MAX_VALUE = 1.7976931348623157E308;
    this.POSITIVE_INFINITY = Infinity;
    this.NEGATIVE_INFINITY = -Infinity;
    this.NaN = NaN;
    this.SIZE_BYTES = 8;
    this.SIZE_BITS = 64;
  }
  protoOf(DoubleCompanionObject).j3 = function () {
    return this.MIN_VALUE;
  };
  protoOf(DoubleCompanionObject).k3 = function () {
    return this.MAX_VALUE;
  };
  protoOf(DoubleCompanionObject).n3 = function () {
    return this.POSITIVE_INFINITY;
  };
  protoOf(DoubleCompanionObject).o3 = function () {
    return this.NEGATIVE_INFINITY;
  };
  protoOf(DoubleCompanionObject).p3 = function () {
    return this.NaN;
  };
  protoOf(DoubleCompanionObject).l3 = function () {
    return this.SIZE_BYTES;
  };
  protoOf(DoubleCompanionObject).m3 = function () {
    return this.SIZE_BITS;
  };
  var DoubleCompanionObject_instance;
  function DoubleCompanionObject_getInstance() {
    return DoubleCompanionObject_instance;
  }
  function StringCompanionObject() {
  }
  var StringCompanionObject_instance;
  function StringCompanionObject_getInstance() {
    return StringCompanionObject_instance;
  }
  function BooleanCompanionObject() {
  }
  var BooleanCompanionObject_instance;
  function BooleanCompanionObject_getInstance() {
    return BooleanCompanionObject_instance;
  }
  function numberRangeToNumber(start, endInclusive) {
    return new IntRange(start, endInclusive);
  }
  function get_propertyRefClassMetadataCache() {
    _init_properties_reflectRuntime_kt__5r4uu3();
    return propertyRefClassMetadataCache;
  }
  var propertyRefClassMetadataCache;
  function metadataObject() {
    _init_properties_reflectRuntime_kt__5r4uu3();
    return createMetadata('class', VOID, VOID, VOID, VOID, VOID);
  }
  function getPropertyCallableRef(name, paramCount, superType, getter, setter, linkageError) {
    linkageError = linkageError === VOID ? null : linkageError;
    _init_properties_reflectRuntime_kt__5r4uu3();
    getter.get = getter;
    getter.set = setter;
    if (!(linkageError == null)) {
      throwLinkageErrorInCallableName(getter, linkageError);
    } else {
      getter.callableName = name;
    }
    // Inline function 'kotlin.js.unsafeCast' call
    return getPropertyRefClass(getter, getKPropMetadata(paramCount, setter), getInterfaceMaskFor(getter, superType));
  }
  function throwLinkageErrorInCallableName(function_0, linkageError) {
    _init_properties_reflectRuntime_kt__5r4uu3();
    defineProp(function_0, 'callableName', throwLinkageErrorInCallableName$lambda(linkageError), VOID, true);
  }
  function getPropertyRefClass(obj, metadata, imask) {
    _init_properties_reflectRuntime_kt__5r4uu3();
    obj.$metadata$ = metadata;
    obj.constructor = obj;
    obj.$imask$ = imask;
    return obj;
  }
  function getKPropMetadata(paramCount, setter) {
    _init_properties_reflectRuntime_kt__5r4uu3();
    return get_propertyRefClassMetadataCache()[paramCount][setter == null ? 0 : 1];
  }
  function getInterfaceMaskFor(obj, superType) {
    _init_properties_reflectRuntime_kt__5r4uu3();
    var tmp0_elvis_lhs = obj.$imask$;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$2 = [superType];
      tmp = implement(tmp$ret$2);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function getLocalDelegateReference(name, superType, mutable) {
    _init_properties_reflectRuntime_kt__5r4uu3();
    var lambda = getLocalDelegateReference$lambda();
    return getPropertyCallableRef(name, 0, superType, lambda, mutable ? lambda : null, VOID);
  }
  function throwLinkageErrorInCallableName$lambda($linkageError) {
    return function () {
      throwIrLinkageError($linkageError);
    };
  }
  function getLocalDelegateReference$lambda() {
    return function () {
      throwUnsupportedOperationException('Not supported for local property reference.');
    };
  }
  var properties_initialized_reflectRuntime_kt_inkhwd;
  function _init_properties_reflectRuntime_kt__5r4uu3() {
    if (!properties_initialized_reflectRuntime_kt_inkhwd) {
      properties_initialized_reflectRuntime_kt_inkhwd = true;
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp = [metadataObject(), metadataObject()];
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp_0 = [metadataObject(), metadataObject()];
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      propertyRefClassMetadataCache = [tmp, tmp_0, [metadataObject(), metadataObject()]];
    }
  }
  function isArrayish(o) {
    return isJsArray(o) || isView(o);
  }
  function isJsArray(obj) {
    // Inline function 'kotlin.js.unsafeCast' call
    return Array.isArray(obj);
  }
  function isInterface(obj, iface) {
    return isInterfaceImpl(obj, iface.$metadata$.iid);
  }
  function isInterfaceImpl(obj, iface) {
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp0_elvis_lhs = obj.$imask$;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var mask = tmp;
    return isBitSet(mask, iface);
  }
  function isArray(obj) {
    var tmp;
    if (isJsArray(obj)) {
      // Inline function 'kotlin.js.asDynamic' call
      tmp = !obj.$type$;
    } else {
      tmp = false;
    }
    return tmp;
  }
  function isSuspendFunction(obj, arity) {
    var objTypeOf = typeof obj;
    if (objTypeOf === 'function') {
      // Inline function 'kotlin.js.unsafeCast' call
      return obj.$arity === arity;
    }
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp1_safe_receiver = obj == null ? null : obj.constructor;
    var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.$metadata$;
    var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.suspendArity;
    var tmp;
    if (tmp3_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp3_elvis_lhs;
    }
    var suspendArity = tmp;
    var result = false;
    var inductionVariable = 0;
    var last = suspendArity.length;
    $l$loop: while (inductionVariable < last) {
      var item = suspendArity[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (arity === item) {
        result = true;
        break $l$loop;
      }
    }
    return result;
  }
  function isNumber(a) {
    var tmp;
    if (typeof a === 'number') {
      tmp = true;
    } else {
      tmp = !(a == null) ? typeof a === 'bigint' : false;
    }
    return tmp;
  }
  function isComparable(value) {
    var type = typeof value;
    return type === 'string' || type === 'boolean' || isNumber(value) || isInterface(value, Comparable);
  }
  function isCharSequence(value) {
    return typeof value === 'string' || isInterface(value, CharSequence);
  }
  function isBooleanArray(a) {
    return isJsArray(a) && a.$type$ === 'BooleanArray';
  }
  function isByteArray(a) {
    // Inline function 'kotlin.js.jsInstanceOf' call
    return a instanceof Int8Array;
  }
  function isShortArray(a) {
    // Inline function 'kotlin.js.jsInstanceOf' call
    return a instanceof Int16Array;
  }
  function isCharArray(a) {
    var tmp;
    // Inline function 'kotlin.js.jsInstanceOf' call
    if (a instanceof Uint16Array) {
      tmp = a.$type$ === 'CharArray';
    } else {
      tmp = false;
    }
    return tmp;
  }
  function isIntArray(a) {
    // Inline function 'kotlin.js.jsInstanceOf' call
    return a instanceof Int32Array;
  }
  function isFloatArray(a) {
    // Inline function 'kotlin.js.jsInstanceOf' call
    return a instanceof Float32Array;
  }
  function isLongArray(a) {
    return isJsArray(a) && a.$type$ === 'LongArray';
  }
  function isDoubleArray(a) {
    // Inline function 'kotlin.js.jsInstanceOf' call
    return a instanceof Float64Array;
  }
  function jsIsType(obj, jsClass) {
    if (jsClass === Object) {
      return obj != null;
    }
    var objType = typeof obj;
    var jsClassType = typeof jsClass;
    if (obj == null || jsClass == null || (!(objType === 'object') && !(objType === 'function'))) {
      return false;
    }
    var constructor = jsClassType === 'object' ? jsGetPrototypeOf(jsClass) : jsClass;
    var klassMetadata = constructor.$metadata$;
    if ((klassMetadata == null ? null : klassMetadata.kind) === 'interface') {
      // Inline function 'kotlin.js.unsafeCast' call
      var tmp0_elvis_lhs = klassMetadata.iid;
      var tmp;
      if (tmp0_elvis_lhs == null) {
        return false;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var iid = tmp;
      return isInterfaceImpl(obj, iid);
    }
    // Inline function 'kotlin.js.jsInstanceOf' call
    return obj instanceof constructor;
  }
  function jsGetPrototypeOf(jsClass) {
    return Object.getPrototypeOf(jsClass);
  }
  function get_VOID() {
    _init_properties_void_kt__3zg9as();
    return VOID;
  }
  var VOID;
  var properties_initialized_void_kt_e4ret2;
  function _init_properties_void_kt__3zg9as() {
    if (!properties_initialized_void_kt_e4ret2) {
      properties_initialized_void_kt_e4ret2 = true;
      VOID = void 0;
    }
  }
  function fill(_this__u8e3s4, element, fromIndex, toIndex) {
    fromIndex = fromIndex === VOID ? 0 : fromIndex;
    toIndex = toIndex === VOID ? _this__u8e3s4.length : toIndex;
    Companion_instance_6.r3(fromIndex, toIndex, _this__u8e3s4.length);
    // Inline function 'kotlin.js.nativeFill' call
    // Inline function 'kotlin.js.asDynamic' call
    _this__u8e3s4.fill(element, fromIndex, toIndex);
  }
  function copyOf(_this__u8e3s4, newSize) {
    // Inline function 'kotlin.require' call
    if (!(newSize >= 0)) {
      var message = 'Invalid new array size: ' + newSize + '.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    return fillFrom(_this__u8e3s4, new Int32Array(newSize));
  }
  function asList(_this__u8e3s4) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return new ArrayList(_this__u8e3s4);
  }
  function copyOf_0(_this__u8e3s4, newSize) {
    // Inline function 'kotlin.require' call
    if (!(newSize >= 0)) {
      var message = 'Invalid new array size: ' + newSize + '.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    return fillFrom(_this__u8e3s4, new Int8Array(newSize));
  }
  function contentEquals(_this__u8e3s4, other) {
    return contentEqualsInternal(_this__u8e3s4, other);
  }
  function copyOf_1(_this__u8e3s4, newSize) {
    // Inline function 'kotlin.require' call
    if (!(newSize >= 0)) {
      var message = 'Invalid new array size: ' + newSize + '.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    return arrayCopyResize(_this__u8e3s4, newSize, null);
  }
  function copyOf_2(_this__u8e3s4, newSize) {
    // Inline function 'kotlin.require' call
    if (!(newSize >= 0)) {
      var message = 'Invalid new array size: ' + newSize + '.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    var tmp0 = 'LongArray';
    // Inline function 'withType' call
    var array = arrayCopyResize(_this__u8e3s4, newSize, 0n);
    array.$type$ = tmp0;
    return array;
  }
  function fill_0(_this__u8e3s4, element, fromIndex, toIndex) {
    fromIndex = fromIndex === VOID ? 0 : fromIndex;
    toIndex = toIndex === VOID ? _this__u8e3s4.length : toIndex;
    Companion_instance_6.r3(fromIndex, toIndex, _this__u8e3s4.length);
    // Inline function 'kotlin.js.nativeFill' call
    // Inline function 'kotlin.js.asDynamic' call
    _this__u8e3s4.fill(element, fromIndex, toIndex);
  }
  function contentEquals_0(_this__u8e3s4, other) {
    return contentEqualsInternal(_this__u8e3s4, other);
  }
  function contentToString(_this__u8e3s4) {
    var tmp1_elvis_lhs = _this__u8e3s4 == null ? null : joinToString(_this__u8e3s4, ', ', '[', ']');
    return tmp1_elvis_lhs == null ? 'null' : tmp1_elvis_lhs;
  }
  function contentHashCode(_this__u8e3s4) {
    return contentHashCodeInternal(_this__u8e3s4);
  }
  function copyOf_3(_this__u8e3s4, newSize) {
    // Inline function 'kotlin.require' call
    if (!(newSize >= 0)) {
      var message = 'Invalid new array size: ' + newSize + '.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    var tmp0 = 'CharArray';
    // Inline function 'withType' call
    var array = fillFrom(_this__u8e3s4, charArray(newSize));
    array.$type$ = tmp0;
    return array;
  }
  function copyOf_4(_this__u8e3s4, newSize) {
    // Inline function 'kotlin.require' call
    if (!(newSize >= 0)) {
      var message = 'Invalid new array size: ' + newSize + '.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    return fillFrom(_this__u8e3s4, new Float64Array(newSize));
  }
  function copyOf_5(_this__u8e3s4, newSize) {
    // Inline function 'kotlin.require' call
    if (!(newSize >= 0)) {
      var message = 'Invalid new array size: ' + newSize + '.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    return fillFrom(_this__u8e3s4, new Float32Array(newSize));
  }
  function copyOf_6(_this__u8e3s4, newSize) {
    // Inline function 'kotlin.require' call
    if (!(newSize >= 0)) {
      var message = 'Invalid new array size: ' + newSize + '.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    return fillFrom(_this__u8e3s4, new Int16Array(newSize));
  }
  function copyOf_7(_this__u8e3s4, newSize) {
    // Inline function 'kotlin.require' call
    if (!(newSize >= 0)) {
      var message = 'Invalid new array size: ' + newSize + '.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    var tmp0 = 'BooleanArray';
    // Inline function 'withType' call
    var array = arrayCopyResize(_this__u8e3s4, newSize, false);
    array.$type$ = tmp0;
    return array;
  }
  function sortWith(_this__u8e3s4, comparator) {
    if (_this__u8e3s4.length > 1) {
      sortArrayWith(_this__u8e3s4, comparator);
    }
  }
  function copyOf_8(_this__u8e3s4) {
    var tmp0 = 'LongArray';
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'withType' call
    var array = _this__u8e3s4.slice();
    array.$type$ = tmp0;
    return array;
  }
  function copyOfRange(_this__u8e3s4, fromIndex, toIndex) {
    Companion_instance_6.r3(fromIndex, toIndex, _this__u8e3s4.length);
    var tmp0 = 'LongArray';
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'withType' call
    var array = _this__u8e3s4.slice(fromIndex, toIndex);
    array.$type$ = tmp0;
    return array;
  }
  function copyOfRange_0(_this__u8e3s4, fromIndex, toIndex) {
    Companion_instance_6.r3(fromIndex, toIndex, _this__u8e3s4.length);
    // Inline function 'kotlin.js.asDynamic' call
    return _this__u8e3s4.slice(fromIndex, toIndex);
  }
  function toTypedArray(_this__u8e3s4) {
    return [].slice.call(_this__u8e3s4);
  }
  function decodeVarLenBase64(base64, fromBase64, resultLength) {
    var result = new Int32Array(resultLength);
    var index = 0;
    var int = 0;
    var shift = 0;
    var inductionVariable = 0;
    var last = base64.length;
    while (inductionVariable < last) {
      var char = charCodeAt(base64, inductionVariable);
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'kotlin.code' call
      var sixBit = fromBase64[Char__toInt_impl_vasixd(char)];
      int = int | (sixBit & 31) << shift;
      if (sixBit < 32) {
        var _unary__edvuaz = index;
        index = _unary__edvuaz + 1 | 0;
        result[_unary__edvuaz] = int;
        int = 0;
        shift = 0;
      } else {
        shift = shift + 5 | 0;
      }
    }
    return result;
  }
  function reverse(_this__u8e3s4) {
    var midPoint = (_this__u8e3s4.p() / 2 | 0) - 1 | 0;
    if (midPoint < 0)
      return Unit_instance;
    var reverseIndex = get_lastIndex_2(_this__u8e3s4);
    var inductionVariable = 0;
    if (inductionVariable <= midPoint)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = _this__u8e3s4.r(index);
        _this__u8e3s4.l2(index, _this__u8e3s4.r(reverseIndex));
        _this__u8e3s4.l2(reverseIndex, tmp);
        reverseIndex = reverseIndex - 1 | 0;
      }
       while (!(index === midPoint));
  }
  function digitToIntImpl(_this__u8e3s4) {
    // Inline function 'kotlin.code' call
    var ch = Char__toInt_impl_vasixd(_this__u8e3s4);
    var index = binarySearchRange(Digit_getInstance().s3_1, ch);
    var diff = ch - Digit_getInstance().s3_1[index] | 0;
    return diff < 10 ? diff : -1;
  }
  function binarySearchRange(array, needle) {
    var bottom = 0;
    var top = array.length - 1 | 0;
    var middle = -1;
    var value = 0;
    while (bottom <= top) {
      middle = (bottom + top | 0) / 2 | 0;
      value = array[middle];
      if (needle > value)
        bottom = middle + 1 | 0;
      else if (needle === value)
        return middle;
      else
        top = middle - 1 | 0;
    }
    return middle - (needle < value ? 1 : 0) | 0;
  }
  function Digit() {
    Digit_instance = this;
    var tmp = this;
    // Inline function 'kotlin.intArrayOf' call
    tmp.s3_1 = new Int32Array([48, 1632, 1776, 1984, 2406, 2534, 2662, 2790, 2918, 3046, 3174, 3302, 3430, 3558, 3664, 3792, 3872, 4160, 4240, 6112, 6160, 6470, 6608, 6784, 6800, 6992, 7088, 7232, 7248, 42528, 43216, 43264, 43472, 43504, 43600, 44016, 65296]);
  }
  var Digit_instance;
  function Digit_getInstance() {
    if (Digit_instance == null)
      new Digit();
    return Digit_instance;
  }
  function isLowerCaseImpl(_this__u8e3s4) {
    var tmp;
    if (getLetterType(_this__u8e3s4) === 1) {
      tmp = true;
    } else {
      // Inline function 'kotlin.code' call
      var tmp$ret$0 = Char__toInt_impl_vasixd(_this__u8e3s4);
      tmp = isOtherLowercase(tmp$ret$0);
    }
    return tmp;
  }
  function getLetterType(_this__u8e3s4) {
    // Inline function 'kotlin.code' call
    var ch = Char__toInt_impl_vasixd(_this__u8e3s4);
    var index = binarySearchRange(Letter_getInstance().t3_1, ch);
    var rangeStart = Letter_getInstance().t3_1[index];
    var rangeEnd = (rangeStart + Letter_getInstance().u3_1[index] | 0) - 1 | 0;
    var code = Letter_getInstance().v3_1[index];
    if (ch > rangeEnd) {
      return 0;
    }
    var lastTwoBits = code & 3;
    if (lastTwoBits === 0) {
      var shift = 2;
      var threshold = rangeStart;
      var inductionVariable = 0;
      if (inductionVariable <= 1)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          threshold = threshold + (code >> shift & 127) | 0;
          if (threshold > ch) {
            return 3;
          }
          shift = shift + 7 | 0;
          threshold = threshold + (code >> shift & 127) | 0;
          if (threshold > ch) {
            return 0;
          }
          shift = shift + 7 | 0;
        }
         while (inductionVariable <= 1);
      return 3;
    }
    if (code <= 7) {
      return lastTwoBits;
    }
    var distance = ch - rangeStart | 0;
    var shift_0 = code <= 31 ? distance % 2 | 0 : distance;
    return code >> imul(2, shift_0) & 3;
  }
  function Letter() {
    Letter_instance = this;
    var toBase64 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    var fromBase64 = new Int32Array(128);
    var inductionVariable = 0;
    var last = charSequenceLength(toBase64) - 1 | 0;
    if (inductionVariable <= last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlin.code' call
        var this_0 = charCodeAt(toBase64, i);
        fromBase64[Char__toInt_impl_vasixd(this_0)] = i;
      }
       while (inductionVariable <= last);
    var rangeStartDiff = 'hCgBpCQGYHZH5BRpBPPPPPPRMP5BPPlCPP6BkEPPPPcPXPzBvBrB3BOiDoBHwD+E3DauCnFmBmB2D6E1BlBTiBmBlBP5BhBiBrBvBjBqBnBPRtBiCmCtBlB0BmB5BiB7BmBgEmChBZgCoEoGVpBSfRhBPqKQ2BwBYoFgB4CJuTiEvBuCuDrF5DgEgFlJ1DgFmBQtBsBRGsB+BPiBlD1EIjDPRPPPQPPPPPGQSQS/DxENVNU+B9zCwBwBPPCkDPNnBPqDYY1R8B7FkFgTgwGgwUwmBgKwBuBScmEP/BPPPPPPrBP8B7F1B/ErBqC6B7BiBmBfQsBUwCw/KwqIwLwETPcPjQgJxFgBlBsD';
    var diff = decodeVarLenBase64(rangeStartDiff, fromBase64, 222);
    var start = new Int32Array(diff.length);
    var inductionVariable_0 = 0;
    var last_0 = diff.length - 1 | 0;
    if (inductionVariable_0 <= last_0)
      do {
        var i_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        if (i_0 === 0) {
          start[i_0] = diff[i_0];
        } else {
          start[i_0] = start[i_0 - 1 | 0] + diff[i_0] | 0;
        }
      }
       while (inductionVariable_0 <= last_0);
    this.t3_1 = start;
    var rangeLength = 'aaMBXHYH5BRpBPPPPPPRMP5BPPlCPPzBDOOPPcPXPzBvBjB3BOhDmBBpB7DoDYxB+EiBP1DoExBkBQhBekBPmBgBhBctBiBMWOOXhCsBpBkBUV3Ba4BkB0DlCgBXgBtD4FSdBfPhBPpKP0BvBXjEQ2CGsT8DhBtCqDpFvD1D3E0IrD2EkBJrBDOBsB+BPiBlB1EIjDPPPPPPPPPPPGPPMNLsBNPNPKCvBvBPPCkDPBmBPhDXXgD4B6FzEgDguG9vUtkB9JcuBSckEP/BPPPPPPBPf4FrBjEhBpC3B5BKaWPrBOwCk/KsCuLqDHPbPxPsFtEaaqDL';
    this.u3_1 = decodeVarLenBase64(rangeLength, fromBase64, 222);
    var rangeCategory = 'GFjgggUHGGFFZZZmzpz5qB6s6020B60ptltB6smt2sB60mz22B1+vv+8BZZ5s2850BW5q1ymtB506smzBF3q1q1qB1q1q1+Bgii4wDTm74g3KiggxqM60q1q1Bq1o1q1BF1qlrqrBZ2q5wprBGFZWWZGHFsjiooLowgmOowjkwCkgoiIk7ligGogiioBkwkiYkzj2oNoi+sbkwj04DghhkQ8wgiYkgoioDsgnkwC4gikQ//v+85BkwvoIsgoyI4yguI0whiwEowri4CoghsJowgqYowgm4DkwgsY/nwnzPowhmYkg6wI8yggZswikwHgxgmIoxgqYkwgk4DkxgmIkgoioBsgssoBgzgyI8g9gL8g9kI0wgwJoxgkoC0wgioFkw/wI0w53iF4gioYowjmgBHGq1qkgwBF1q1q8qBHwghuIwghyKk0goQkwgoQk3goQHGFHkyg0pBgxj6IoinkxDswno7Ikwhz9Bo0gioB8z48Rwli0xN0mpjoX8w78pDwltoqKHFGGwwgsIHFH3q1q16BFHWFZ1q10q1B2qlwq1B1q10q1B2q1yq1B6q1gq1Biq1qhxBir1qp1Bqt1q1qB1g1q1+B//3q16B///q1qBH/qlqq9Bholqq9B1i00a1q10qD1op1HkwmigEigiy6Cptogq1Bixo1kDq7/j00B2qgoBWGFm1lz50B6s5q1+BGWhggzhwBFFhgk4//Bo2jigE8wguI8wguI8wgugUog1qoB4qjmIwwi2KgkYHHH4lBgiFWkgIWoghssMmz5smrBZ3q1y50B5sm7gzBtz1smzB5smz50BqzqtmzB5sgzqzBF2/9//5BowgoIwmnkzPkwgk4C8ys65BkgoqI0wgy6FghquZo2giY0ghiIsgh24B4ghsQ8QF/v1q1OFs0O8iCHHF1qggz/B8wg6Iznv+//B08QgohsjK0QGFk7hsQ4gB';
    this.v3_1 = decodeVarLenBase64(rangeCategory, fromBase64, 222);
  }
  var Letter_instance;
  function Letter_getInstance() {
    if (Letter_instance == null)
      new Letter();
    return Letter_instance;
  }
  function isOtherLowercase(_this__u8e3s4) {
    var index = binarySearchRange(OtherLowercase_getInstance().w3_1, _this__u8e3s4);
    return index >= 0 && _this__u8e3s4 < (OtherLowercase_getInstance().w3_1[index] + OtherLowercase_getInstance().x3_1[index] | 0);
  }
  function OtherLowercase() {
    OtherLowercase_instance = this;
    var tmp = this;
    // Inline function 'kotlin.intArrayOf' call
    tmp.w3_1 = new Int32Array([170, 186, 688, 704, 736, 837, 890, 7468, 7544, 7579, 8305, 8319, 8336, 8560, 9424, 11388, 42652, 42864, 43000, 43868]);
    var tmp_0 = this;
    // Inline function 'kotlin.intArrayOf' call
    tmp_0.x3_1 = new Int32Array([1, 1, 9, 2, 5, 1, 1, 63, 1, 37, 1, 1, 13, 16, 26, 2, 2, 1, 2, 4]);
  }
  var OtherLowercase_instance;
  function OtherLowercase_getInstance() {
    if (OtherLowercase_instance == null)
      new OtherLowercase();
    return OtherLowercase_instance;
  }
  function titlecaseCharImpl(_this__u8e3s4) {
    // Inline function 'kotlin.code' call
    var code = Char__toInt_impl_vasixd(_this__u8e3s4);
    if ((452 <= code ? code <= 460 : false) || (497 <= code ? code <= 499 : false)) {
      return numberToChar(imul(3, (code + 1 | 0) / 3 | 0));
    }
    if ((4304 <= code ? code <= 4346 : false) || (4349 <= code ? code <= 4351 : false)) {
      return _this__u8e3s4;
    }
    return uppercaseChar(_this__u8e3s4);
  }
  function asList_0(_this__u8e3s4) {
    return new asList$1(_this__u8e3s4);
  }
  function asList$1($this_asList) {
    this.y3_1 = $this_asList;
    AbstractList.call(this);
  }
  protoOf(asList$1).p = function () {
    return _ULongArray___get_size__impl__ju6dtr(this.y3_1);
  };
  protoOf(asList$1).s = function () {
    return ULongArray__isEmpty_impl_c3yngu(this.y3_1);
  };
  protoOf(asList$1).z3 = function (element) {
    return ULongArray__contains_impl_v9bgai(this.y3_1, element);
  };
  protoOf(asList$1).t = function (element) {
    if (!(element instanceof ULong))
      return false;
    return this.z3(element instanceof ULong ? element.r1_1 : THROW_CCE());
  };
  protoOf(asList$1).a4 = function (index) {
    Companion_instance_6.b4(index, this.p());
    return ULongArray__get_impl_pr71q9(this.y3_1, index);
  };
  protoOf(asList$1).r = function (index) {
    return new ULong(this.a4(index));
  };
  protoOf(asList$1).c4 = function (element) {
    var tmp = !(new ULong(element) == null) ? new ULong(element) : THROW_CCE();
    if (!(tmp instanceof ULong))
      return -1;
    // Inline function 'kotlin.collections.indexOf' call
    var this_0 = this.y3_1;
    var tmp_0 = _ULongArray___get_storage__impl__28e64j(this_0);
    // Inline function 'kotlin.ULong.toLong' call
    var tmp$ret$0 = _ULong___get_data__impl__fggpzb(element);
    return indexOf_1(tmp_0, tmp$ret$0);
  };
  protoOf(asList$1).w = function (element) {
    if (!(element instanceof ULong))
      return -1;
    return this.c4(element instanceof ULong ? element.r1_1 : THROW_CCE());
  };
  protoOf(asList$1).d4 = function (element) {
    var tmp = !(new ULong(element) == null) ? new ULong(element) : THROW_CCE();
    if (!(tmp instanceof ULong))
      return -1;
    // Inline function 'kotlin.collections.lastIndexOf' call
    var this_0 = this.y3_1;
    var tmp_0 = _ULongArray___get_storage__impl__28e64j(this_0);
    // Inline function 'kotlin.ULong.toLong' call
    var tmp$ret$0 = _ULong___get_data__impl__fggpzb(element);
    return lastIndexOf_0(tmp_0, tmp$ret$0);
  };
  protoOf(asList$1).v = function (element) {
    if (!(element instanceof ULong))
      return -1;
    return this.d4(element instanceof ULong ? element.r1_1 : THROW_CCE());
  };
  function isWhitespaceImpl(_this__u8e3s4) {
    // Inline function 'kotlin.code' call
    var ch = Char__toInt_impl_vasixd(_this__u8e3s4);
    return (9 <= ch ? ch <= 13 : false) || (28 <= ch ? ch <= 32 : false) || ch === 160 || (ch > 4096 && (ch === 5760 || (8192 <= ch ? ch <= 8202 : false) || ch === 8232 || ch === 8233 || ch === 8239 || ch === 8287 || ch === 12288));
  }
  function Comparator() {
  }
  function eachCount(_this__u8e3s4) {
    // Inline function 'kotlin.collections.fold' call
    // Inline function 'kotlin.collections.aggregate' call
    // Inline function 'kotlin.collections.mutableMapOf' call
    // Inline function 'kotlin.collections.aggregateTo' call
    var destination = LinkedHashMap_init_$Create$();
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s = _this__u8e3s4.e4();
    while (_iterator__ex2g4s.n()) {
      var e = _iterator__ex2g4s.o();
      var key = _this__u8e3s4.f4(e);
      var accumulator = destination.q2(key);
      var tmp;
      if (accumulator == null && !destination.o2(key)) {
        tmp = 0;
      } else {
        tmp = (accumulator == null ? true : !(accumulator == null)) ? accumulator : THROW_CCE();
      }
      // Inline function 'kotlin.collections.set' call
      var value = tmp + 1 | 0;
      destination.t2(key, value);
    }
    return destination;
  }
  function isNaN_0(_this__u8e3s4) {
    return !(_this__u8e3s4 === _this__u8e3s4);
  }
  function toRawBits(_this__u8e3s4) {
    return floatToRawBits(_this__u8e3s4);
  }
  function toRawBits_0(_this__u8e3s4) {
    return doubleToRawBits(_this__u8e3s4);
  }
  function takeHighestOneBit(_this__u8e3s4) {
    var tmp;
    if (_this__u8e3s4 === 0) {
      tmp = 0;
    } else {
      // Inline function 'kotlin.countLeadingZeroBits' call
      tmp = 1 << (31 - clz32(_this__u8e3s4) | 0);
    }
    return tmp;
  }
  function countLeadingZeroBits(_this__u8e3s4) {
    var high = highBits(_this__u8e3s4);
    var tmp;
    if (high === 0) {
      // Inline function 'kotlin.countLeadingZeroBits' call
      var this_0 = lowBits(_this__u8e3s4);
      tmp = 32 + clz32(this_0) | 0;
    } else {
      // Inline function 'kotlin.countLeadingZeroBits' call
      tmp = clz32(high);
    }
    return tmp;
  }
  function isFinite(_this__u8e3s4) {
    return !isInfinite_0(_this__u8e3s4) && !isNaN_1(_this__u8e3s4);
  }
  function isFinite_0(_this__u8e3s4) {
    return !isInfinite(_this__u8e3s4) && !isNaN_0(_this__u8e3s4);
  }
  function countTrailingZeroBits(_this__u8e3s4) {
    var low = lowBits(_this__u8e3s4);
    return low === 0 ? 32 + countTrailingZeroBits_0(highBits(_this__u8e3s4)) | 0 : countTrailingZeroBits_0(low);
  }
  function isInfinite(_this__u8e3s4) {
    return _this__u8e3s4 === Infinity || _this__u8e3s4 === -Infinity;
  }
  function isInfinite_0(_this__u8e3s4) {
    return _this__u8e3s4 === Infinity || _this__u8e3s4 === -Infinity;
  }
  function isNaN_1(_this__u8e3s4) {
    return !(_this__u8e3s4 === _this__u8e3s4);
  }
  function countTrailingZeroBits_0(_this__u8e3s4) {
    // Inline function 'kotlin.countLeadingZeroBits' call
    var this_0 = ~(_this__u8e3s4 | (-_this__u8e3s4 | 0));
    return 32 - clz32(this_0) | 0;
  }
  function Unit() {
  }
  protoOf(Unit).toString = function () {
    return 'kotlin.Unit';
  };
  var Unit_instance;
  function Unit_getInstance() {
    return Unit_instance;
  }
  function uintCompare(v1, v2) {
    return compareTo_0(v1 ^ -2147483648, v2 ^ -2147483648);
  }
  function uintDivide(v1, v2) {
    // Inline function 'kotlin.UInt.toLong' call
    // Inline function 'kotlin.uintToLong' call
    var value = _UInt___get_data__impl__f0vqqw(v1);
    var tmp = fromInt_0(value) & 4294967295n;
    // Inline function 'kotlin.UInt.toLong' call
    // Inline function 'kotlin.uintToLong' call
    var value_0 = _UInt___get_data__impl__f0vqqw(v2);
    var tmp$ret$3 = fromInt_0(value_0) & 4294967295n;
    // Inline function 'kotlin.toUInt' call
    var this_0 = divide(tmp, tmp$ret$3);
    return _UInt___init__impl__l7qpdl(convertToInt(this_0));
  }
  function uintRemainder(v1, v2) {
    // Inline function 'kotlin.UInt.toLong' call
    // Inline function 'kotlin.uintToLong' call
    var value = _UInt___get_data__impl__f0vqqw(v1);
    var tmp = fromInt_0(value) & 4294967295n;
    // Inline function 'kotlin.UInt.toLong' call
    // Inline function 'kotlin.uintToLong' call
    var value_0 = _UInt___get_data__impl__f0vqqw(v2);
    var tmp$ret$3 = fromInt_0(value_0) & 4294967295n;
    // Inline function 'kotlin.toUInt' call
    var this_0 = modulo(tmp, tmp$ret$3);
    return _UInt___init__impl__l7qpdl(convertToInt(this_0));
  }
  function ulongCompare(v1, v2) {
    return compareTo_0(v1 ^ -9223372036854775808n, v2 ^ -9223372036854775808n);
  }
  function ulongDivide(v1, v2) {
    // Inline function 'kotlin.ULong.toLong' call
    var dividend = _ULong___get_data__impl__fggpzb(v1);
    // Inline function 'kotlin.ULong.toLong' call
    var divisor = _ULong___get_data__impl__fggpzb(v2);
    if (divisor < 0n) {
      var tmp;
      // Inline function 'kotlin.ULong.compareTo' call
      if (ulongCompare(_ULong___get_data__impl__fggpzb(v1), _ULong___get_data__impl__fggpzb(v2)) < 0) {
        tmp = _ULong___init__impl__c78o9k(0n);
      } else {
        tmp = _ULong___init__impl__c78o9k(1n);
      }
      return tmp;
    }
    if (dividend >= 0n) {
      return _ULong___init__impl__c78o9k(divide(dividend, divisor));
    }
    var quotient = shiftLeft(divide(shiftRightUnsigned(dividend, 1), divisor), 1);
    var rem = subtract_1(dividend, multiply_0(quotient, divisor));
    var tmp_0;
    var tmp0 = _ULong___init__impl__c78o9k(rem);
    // Inline function 'kotlin.ULong.compareTo' call
    var other = _ULong___init__impl__c78o9k(divisor);
    if (ulongCompare(_ULong___get_data__impl__fggpzb(tmp0), _ULong___get_data__impl__fggpzb(other)) >= 0) {
      tmp_0 = 1;
    } else {
      tmp_0 = 0;
    }
    // Inline function 'kotlin.Long.plus' call
    var other_0 = tmp_0;
    var tmp$ret$4 = add_2(quotient, fromInt_0(other_0));
    return _ULong___init__impl__c78o9k(tmp$ret$4);
  }
  function ulongRemainder(v1, v2) {
    // Inline function 'kotlin.ULong.toLong' call
    var dividend = _ULong___get_data__impl__fggpzb(v1);
    // Inline function 'kotlin.ULong.toLong' call
    var divisor = _ULong___get_data__impl__fggpzb(v2);
    if (divisor < 0n) {
      var tmp;
      // Inline function 'kotlin.ULong.compareTo' call
      if (ulongCompare(_ULong___get_data__impl__fggpzb(v1), _ULong___get_data__impl__fggpzb(v2)) < 0) {
        tmp = v1;
      } else {
        // Inline function 'kotlin.ULong.minus' call
        tmp = _ULong___init__impl__c78o9k(subtract_1(_ULong___get_data__impl__fggpzb(v1), _ULong___get_data__impl__fggpzb(v2)));
      }
      return tmp;
    }
    if (dividend >= 0n) {
      return _ULong___init__impl__c78o9k(modulo(dividend, divisor));
    }
    var quotient = shiftLeft(divide(shiftRightUnsigned(dividend, 1), divisor), 1);
    var rem = subtract_1(dividend, multiply_0(quotient, divisor));
    var tmp_0;
    var tmp0 = _ULong___init__impl__c78o9k(rem);
    // Inline function 'kotlin.ULong.compareTo' call
    var other = _ULong___init__impl__c78o9k(divisor);
    if (ulongCompare(_ULong___get_data__impl__fggpzb(tmp0), _ULong___get_data__impl__fggpzb(other)) >= 0) {
      tmp_0 = divisor;
    } else {
      tmp_0 = 0n;
    }
    return _ULong___init__impl__c78o9k(subtract_1(rem, tmp_0));
  }
  function ulongToString(value, base) {
    if (value >= 0n)
      return toString_2(value, base);
    // Inline function 'kotlin.Long.div' call
    var this_0 = shiftRightUnsigned(value, 1);
    var tmp$ret$0 = divide(this_0, fromInt_0(base));
    var quotient = shiftLeft(tmp$ret$0, 1);
    // Inline function 'kotlin.Long.times' call
    var this_1 = quotient;
    var tmp$ret$1 = multiply_0(this_1, fromInt_0(base));
    var rem = subtract_1(value, tmp$ret$1);
    if (rem >= fromInt_0(base)) {
      // Inline function 'kotlin.Long.minus' call
      var this_2 = rem;
      rem = subtract_1(this_2, fromInt_0(base));
      // Inline function 'kotlin.Long.plus' call
      var this_3 = quotient;
      quotient = add_2(this_3, fromInt_0(1));
    }
    return toString_2(quotient, base) + toString_2(rem, base);
  }
  function collectionToArray(collection) {
    return collectionToArrayCommonImpl(collection);
  }
  function terminateCollectionToArray(collectionSize, array) {
    return array;
  }
  function arrayOfNulls(reference, size) {
    // Inline function 'kotlin.arrayOfNulls' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return Array(size);
  }
  function listOf(element) {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$2 = [element];
    return new ArrayList(tmp$ret$2);
  }
  function setOf(element) {
    return hashSetOf([element]);
  }
  function mapOf(pair) {
    return hashMapOf([pair]);
  }
  function sortWith_0(_this__u8e3s4, comparator) {
    collectionsSort(_this__u8e3s4, comparator);
  }
  function mapCapacity(expectedSize) {
    return expectedSize;
  }
  function checkIndexOverflow(index) {
    if (index < 0) {
      throwIndexOverflow();
    }
    return index;
  }
  function copyToArray(collection) {
    var tmp;
    // Inline function 'kotlin.js.asDynamic' call
    if (collection.toArray !== undefined) {
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.unsafeCast' call
      tmp = collection.toArray();
    } else {
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = collectionToArray(collection);
    }
    return tmp;
  }
  function collectionsSort(list, comparator) {
    if (list.p() <= 1)
      return Unit_instance;
    var array = copyToArray(list);
    sortArrayWith(array, comparator);
    var inductionVariable = 0;
    var last = array.length;
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        list.l2(i, array[i]);
      }
       while (inductionVariable < last);
  }
  function arrayCopy(source, destination, destinationOffset, startIndex, endIndex) {
    Companion_instance_6.r3(startIndex, endIndex, source.length);
    var rangeSize = endIndex - startIndex | 0;
    Companion_instance_6.r3(destinationOffset, destinationOffset + rangeSize | 0, destination.length);
    if (isView(destination) && isView(source)) {
      // Inline function 'kotlin.js.asDynamic' call
      var subrange = source.subarray(startIndex, endIndex);
      // Inline function 'kotlin.js.asDynamic' call
      destination.set(subrange, destinationOffset);
    } else {
      if (!(source === destination) || destinationOffset <= startIndex) {
        var inductionVariable = 0;
        if (inductionVariable < rangeSize)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            destination[destinationOffset + index | 0] = source[startIndex + index | 0];
          }
           while (inductionVariable < rangeSize);
      } else {
        var inductionVariable_0 = rangeSize - 1 | 0;
        if (0 <= inductionVariable_0)
          do {
            var index_0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + -1 | 0;
            destination[destinationOffset + index_0 | 0] = source[startIndex + index_0 | 0];
          }
           while (0 <= inductionVariable_0);
      }
    }
  }
  function AbstractMutableCollection$removeAll$lambda($elements) {
    return function (it) {
      return $elements.t(it);
    };
  }
  function AbstractMutableCollection$retainAll$lambda($elements) {
    return function (it) {
      return !$elements.t(it);
    };
  }
  function AbstractMutableCollection() {
    AbstractCollection.call(this);
  }
  protoOf(AbstractMutableCollection).h2 = function (element) {
    this.g4();
    var iterator = this.m();
    while (iterator.n()) {
      if (equals(iterator.o(), element)) {
        iterator.h4();
        return true;
      }
    }
    return false;
  };
  protoOf(AbstractMutableCollection).q = function (elements) {
    this.g4();
    var modified = false;
    var _iterator__ex2g4s = elements.m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      if (this.j(element))
        modified = true;
    }
    return modified;
  };
  protoOf(AbstractMutableCollection).j1 = function (elements) {
    this.g4();
    var tmp = isInterface(this, MutableIterable) ? this : THROW_CCE();
    return removeAll_1(tmp, AbstractMutableCollection$removeAll$lambda(elements));
  };
  protoOf(AbstractMutableCollection).j2 = function (elements) {
    this.g4();
    var tmp = isInterface(this, MutableIterable) ? this : THROW_CCE();
    return removeAll_1(tmp, AbstractMutableCollection$retainAll$lambda(elements));
  };
  protoOf(AbstractMutableCollection).k2 = function () {
    this.g4();
    var iterator = this.m();
    while (iterator.n()) {
      iterator.o();
      iterator.h4();
    }
  };
  protoOf(AbstractMutableCollection).toJSON = function () {
    return this.toArray();
  };
  protoOf(AbstractMutableCollection).g4 = function () {
  };
  function IteratorImpl($outer) {
    this.k4_1 = $outer;
    this.i4_1 = 0;
    this.j4_1 = -1;
  }
  protoOf(IteratorImpl).n = function () {
    return this.i4_1 < this.k4_1.p();
  };
  protoOf(IteratorImpl).o = function () {
    if (!this.n())
      throw NoSuchElementException_init_$Create$();
    var tmp = this;
    var _unary__edvuaz = this.i4_1;
    this.i4_1 = _unary__edvuaz + 1 | 0;
    tmp.j4_1 = _unary__edvuaz;
    return this.k4_1.r(this.j4_1);
  };
  protoOf(IteratorImpl).h4 = function () {
    // Inline function 'kotlin.check' call
    if (!!(this.j4_1 === -1)) {
      var message = 'Call next() or previous() before removing element from the iterator.';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    this.k4_1.n2(this.j4_1);
    this.i4_1 = this.j4_1;
    this.j4_1 = -1;
  };
  function ListIteratorImpl($outer, index) {
    this.p4_1 = $outer;
    IteratorImpl.call(this, $outer);
    Companion_instance_6.q4(index, this.p4_1.p());
    this.i4_1 = index;
  }
  protoOf(ListIteratorImpl).r4 = function () {
    return this.i4_1 > 0;
  };
  protoOf(ListIteratorImpl).s4 = function () {
    return this.i4_1;
  };
  protoOf(ListIteratorImpl).t4 = function () {
    if (!this.r4())
      throw NoSuchElementException_init_$Create$();
    var tmp = this;
    this.i4_1 = this.i4_1 - 1 | 0;
    tmp.j4_1 = this.i4_1;
    return this.p4_1.r(this.j4_1);
  };
  protoOf(ListIteratorImpl).u4 = function () {
    return this.i4_1 - 1 | 0;
  };
  function SubList(list, fromIndex, toIndex) {
    AbstractMutableList.call(this);
    this.w4_1 = list;
    this.x4_1 = fromIndex;
    this.y4_1 = 0;
    Companion_instance_6.r3(this.x4_1, toIndex, this.w4_1.p());
    this.y4_1 = toIndex - this.x4_1 | 0;
  }
  protoOf(SubList).m2 = function (index, element) {
    Companion_instance_6.q4(index, this.y4_1);
    this.w4_1.m2(this.x4_1 + index | 0, element);
    this.y4_1 = this.y4_1 + 1 | 0;
  };
  protoOf(SubList).r = function (index) {
    Companion_instance_6.b4(index, this.y4_1);
    return this.w4_1.r(this.x4_1 + index | 0);
  };
  protoOf(SubList).n2 = function (index) {
    Companion_instance_6.b4(index, this.y4_1);
    var result = this.w4_1.n2(this.x4_1 + index | 0);
    this.y4_1 = this.y4_1 - 1 | 0;
    return result;
  };
  protoOf(SubList).l2 = function (index, element) {
    Companion_instance_6.b4(index, this.y4_1);
    return this.w4_1.l2(this.x4_1 + index | 0, element);
  };
  protoOf(SubList).z4 = function (fromIndex, toIndex) {
    this.w4_1.z4(this.x4_1 + fromIndex | 0, this.x4_1 + toIndex | 0);
    this.y4_1 = this.y4_1 - (toIndex - fromIndex | 0) | 0;
  };
  protoOf(SubList).p = function () {
    return this.y4_1;
  };
  protoOf(SubList).g4 = function () {
    return this.w4_1.g4();
  };
  function AbstractMutableList$removeAll$lambda($elements) {
    return function (it) {
      return $elements.t(it);
    };
  }
  function AbstractMutableList$retainAll$lambda($elements) {
    return function (it) {
      return !$elements.t(it);
    };
  }
  function AbstractMutableList() {
    AbstractMutableCollection.call(this);
    this.l4_1 = 0;
  }
  protoOf(AbstractMutableList).j = function (element) {
    this.g4();
    this.m2(this.p(), element);
    return true;
  };
  protoOf(AbstractMutableList).i2 = function (index, elements) {
    Companion_instance_6.q4(index, this.p());
    this.g4();
    var _index = index;
    var changed = false;
    var _iterator__ex2g4s = elements.m();
    while (_iterator__ex2g4s.n()) {
      var e = _iterator__ex2g4s.o();
      var _unary__edvuaz = _index;
      _index = _unary__edvuaz + 1 | 0;
      this.m2(_unary__edvuaz, e);
      changed = true;
    }
    return changed;
  };
  protoOf(AbstractMutableList).k2 = function () {
    this.g4();
    this.z4(0, this.p());
  };
  protoOf(AbstractMutableList).j1 = function (elements) {
    this.g4();
    return removeAll_0(this, AbstractMutableList$removeAll$lambda(elements));
  };
  protoOf(AbstractMutableList).j2 = function (elements) {
    this.g4();
    return removeAll_0(this, AbstractMutableList$retainAll$lambda(elements));
  };
  protoOf(AbstractMutableList).m = function () {
    return new IteratorImpl(this);
  };
  protoOf(AbstractMutableList).t = function (element) {
    return this.w(element) >= 0;
  };
  protoOf(AbstractMutableList).w = function (element) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.indexOfFirst' call
      var index = 0;
      var _iterator__ex2g4s = this.m();
      while (_iterator__ex2g4s.n()) {
        var item = _iterator__ex2g4s.o();
        if (equals(item, element)) {
          tmp$ret$1 = index;
          break $l$block;
        }
        index = index + 1 | 0;
      }
      tmp$ret$1 = -1;
    }
    return tmp$ret$1;
  };
  protoOf(AbstractMutableList).v = function (element) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.indexOfLast' call
      var iterator = this.u(this.p());
      while (iterator.r4()) {
        var it = iterator.t4();
        if (equals(it, element)) {
          tmp$ret$1 = iterator.s4();
          break $l$block;
        }
      }
      tmp$ret$1 = -1;
    }
    return tmp$ret$1;
  };
  protoOf(AbstractMutableList).f2 = function () {
    return this.u(0);
  };
  protoOf(AbstractMutableList).u = function (index) {
    return new ListIteratorImpl(this, index);
  };
  protoOf(AbstractMutableList).g2 = function (fromIndex, toIndex) {
    return new SubList(this, fromIndex, toIndex);
  };
  protoOf(AbstractMutableList).z4 = function (fromIndex, toIndex) {
    var iterator = this.u(fromIndex);
    // Inline function 'kotlin.repeat' call
    var times = toIndex - fromIndex | 0;
    var inductionVariable = 0;
    if (inductionVariable < times)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        iterator.o();
        iterator.h4();
      }
       while (inductionVariable < times);
  };
  protoOf(AbstractMutableList).equals = function (other) {
    if (other === this)
      return true;
    if (!(!(other == null) ? isInterface(other, KtList) : false))
      return false;
    return Companion_instance_6.a5(this, other);
  };
  protoOf(AbstractMutableList).hashCode = function () {
    return Companion_instance_6.b5(this);
  };
  function AbstractMutableMap() {
    AbstractMap.call(this);
    this.e5_1 = null;
    this.f5_1 = null;
  }
  protoOf(AbstractMutableMap).g5 = function () {
    return new HashMapKeysDefault(this);
  };
  protoOf(AbstractMutableMap).h5 = function () {
    return new HashMapValuesDefault(this);
  };
  protoOf(AbstractMutableMap).r2 = function () {
    var tmp0_elvis_lhs = this.e5_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.also' call
      var this_0 = this.g5();
      this.e5_1 = this_0;
      tmp = this_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  protoOf(AbstractMutableMap).s2 = function () {
    var tmp0_elvis_lhs = this.f5_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.also' call
      var this_0 = this.h5();
      this.f5_1 = this_0;
      tmp = this_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  protoOf(AbstractMutableMap).k2 = function () {
    this.y().k2();
  };
  protoOf(AbstractMutableMap).v2 = function (from) {
    this.g4();
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s = from.y().m();
    while (_iterator__ex2g4s.n()) {
      var _destruct__k2r9zo = _iterator__ex2g4s.o();
      // Inline function 'kotlin.collections.component1' call
      var key = _destruct__k2r9zo.z();
      // Inline function 'kotlin.collections.component2' call
      var value = _destruct__k2r9zo.a1();
      this.t2(key, value);
    }
  };
  protoOf(AbstractMutableMap).u2 = function (key) {
    this.g4();
    var iter = this.y().m();
    while (iter.n()) {
      var entry = iter.o();
      var k = entry.z();
      if (equals(key, k)) {
        var value = entry.a1();
        iter.h4();
        return value;
      }
    }
    return null;
  };
  protoOf(AbstractMutableMap).g4 = function () {
  };
  function AbstractMutableSet() {
    AbstractMutableCollection.call(this);
  }
  protoOf(AbstractMutableSet).equals = function (other) {
    if (other === this)
      return true;
    if (!(!(other == null) ? isInterface(other, KtSet) : false))
      return false;
    return Companion_instance_8.l5(this, other);
  };
  protoOf(AbstractMutableSet).hashCode = function () {
    return Companion_instance_8.m5(this);
  };
  function arrayOfUninitializedElements(capacity) {
    // Inline function 'kotlin.require' call
    if (!(capacity >= 0)) {
      var message = 'capacity must be non-negative.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    // Inline function 'kotlin.arrayOfNulls' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return Array(capacity);
  }
  function resetRange(_this__u8e3s4, fromIndex, toIndex) {
    // Inline function 'kotlin.js.nativeFill' call
    // Inline function 'kotlin.js.asDynamic' call
    _this__u8e3s4.fill(null, fromIndex, toIndex);
  }
  function copyOfUninitializedElements(_this__u8e3s4, newSize) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return copyOf_1(_this__u8e3s4, newSize);
  }
  function resetAt(_this__u8e3s4, index) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    _this__u8e3s4[index] = null;
  }
  function Companion_3() {
    Companion_instance_3 = this;
    var tmp = this;
    // Inline function 'kotlin.also' call
    var this_0 = ArrayList_init_$Create$_0(0);
    this_0.i_1 = true;
    tmp.n5_1 = this_0;
  }
  var Companion_instance_3;
  function Companion_getInstance_3() {
    if (Companion_instance_3 == null)
      new Companion_3();
    return Companion_instance_3;
  }
  function ArrayList_init_$Init$($this) {
    // Inline function 'kotlin.emptyArray' call
    var tmp$ret$0 = [];
    ArrayList.call($this, tmp$ret$0);
    return $this;
  }
  function ArrayList_init_$Create$() {
    return ArrayList_init_$Init$(objectCreate(protoOf(ArrayList)));
  }
  function ArrayList_init_$Init$_0(initialCapacity, $this) {
    // Inline function 'kotlin.emptyArray' call
    var tmp$ret$0 = [];
    ArrayList.call($this, tmp$ret$0);
    // Inline function 'kotlin.require' call
    if (!(initialCapacity >= 0)) {
      var message = 'Negative initial capacity: ' + initialCapacity;
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    return $this;
  }
  function ArrayList_init_$Create$_0(initialCapacity) {
    return ArrayList_init_$Init$_0(initialCapacity, objectCreate(protoOf(ArrayList)));
  }
  function ArrayList_init_$Init$_1(elements, $this) {
    // Inline function 'kotlin.collections.toTypedArray' call
    var tmp$ret$0 = copyToArray(elements);
    ArrayList.call($this, tmp$ret$0);
    return $this;
  }
  function ArrayList_init_$Create$_1(elements) {
    return ArrayList_init_$Init$_1(elements, objectCreate(protoOf(ArrayList)));
  }
  function increaseLength($this, amount) {
    var previous = $this.p();
    // Inline function 'kotlin.js.asDynamic' call
    $this.h_1.length = $this.p() + amount | 0;
    return previous;
  }
  function rangeCheck($this, index) {
    // Inline function 'kotlin.apply' call
    Companion_instance_6.b4(index, $this.p());
    return index;
  }
  function insertionRangeCheck($this, index) {
    // Inline function 'kotlin.apply' call
    Companion_instance_6.q4(index, $this.p());
    return index;
  }
  function ArrayList(array) {
    Companion_getInstance_3();
    AbstractMutableList.call(this);
    this.h_1 = array;
    this.i_1 = false;
  }
  protoOf(ArrayList).i3 = function () {
    this.g4();
    this.i_1 = true;
    return this.p() > 0 ? this : Companion_getInstance_3().n5_1;
  };
  protoOf(ArrayList).o5 = function (minCapacity) {
  };
  protoOf(ArrayList).p = function () {
    return this.h_1.length;
  };
  protoOf(ArrayList).r = function (index) {
    var tmp = this.h_1[rangeCheck(this, index)];
    return (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
  };
  protoOf(ArrayList).l2 = function (index, element) {
    this.g4();
    rangeCheck(this, index);
    // Inline function 'kotlin.apply' call
    var this_0 = this.h_1[index];
    this.h_1[index] = element;
    var tmp = this_0;
    return (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
  };
  protoOf(ArrayList).j = function (element) {
    this.g4();
    // Inline function 'kotlin.js.asDynamic' call
    this.h_1.push(element);
    this.l4_1 = this.l4_1 + 1 | 0;
    return true;
  };
  protoOf(ArrayList).m2 = function (index, element) {
    this.g4();
    // Inline function 'kotlin.js.asDynamic' call
    this.h_1.splice(insertionRangeCheck(this, index), 0, element);
    this.l4_1 = this.l4_1 + 1 | 0;
  };
  protoOf(ArrayList).q = function (elements) {
    this.g4();
    if (elements.s())
      return false;
    var offset = increaseLength(this, elements.p());
    // Inline function 'kotlin.collections.forEachIndexed' call
    var index = 0;
    var _iterator__ex2g4s = elements.m();
    while (_iterator__ex2g4s.n()) {
      var item = _iterator__ex2g4s.o();
      var _unary__edvuaz = index;
      index = _unary__edvuaz + 1 | 0;
      var index_0 = checkIndexOverflow(_unary__edvuaz);
      this.h_1[offset + index_0 | 0] = item;
    }
    this.l4_1 = this.l4_1 + 1 | 0;
    return true;
  };
  protoOf(ArrayList).i2 = function (index, elements) {
    this.g4();
    insertionRangeCheck(this, index);
    if (index === this.p())
      return this.q(elements);
    if (elements.s())
      return false;
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.js.unsafeCast' call
    var tail = this.h_1.splice(index);
    this.q(elements);
    var offset = increaseLength(this, tail.length);
    // Inline function 'kotlin.repeat' call
    var times = tail.length;
    var inductionVariable = 0;
    if (inductionVariable < times)
      do {
        var index_0 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.h_1[offset + index_0 | 0] = tail[index_0];
      }
       while (inductionVariable < times);
    this.l4_1 = this.l4_1 + 1 | 0;
    return true;
  };
  protoOf(ArrayList).n2 = function (index) {
    this.g4();
    rangeCheck(this, index);
    this.l4_1 = this.l4_1 + 1 | 0;
    var tmp;
    if (index === get_lastIndex_2(this)) {
      // Inline function 'kotlin.js.asDynamic' call
      tmp = this.h_1.pop();
    } else {
      // Inline function 'kotlin.js.asDynamic' call
      tmp = this.h_1.splice(index, 1)[0];
    }
    return tmp;
  };
  protoOf(ArrayList).h2 = function (element) {
    this.g4();
    var inductionVariable = 0;
    var last = this.h_1.length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (equals(this.h_1[index], element)) {
          // Inline function 'kotlin.js.asDynamic' call
          this.h_1.splice(index, 1);
          this.l4_1 = this.l4_1 + 1 | 0;
          return true;
        }
      }
       while (inductionVariable <= last);
    return false;
  };
  protoOf(ArrayList).z4 = function (fromIndex, toIndex) {
    this.g4();
    this.l4_1 = this.l4_1 + 1 | 0;
    // Inline function 'kotlin.js.asDynamic' call
    this.h_1.splice(fromIndex, toIndex - fromIndex | 0);
  };
  protoOf(ArrayList).k2 = function () {
    this.g4();
    var tmp = this;
    // Inline function 'kotlin.emptyArray' call
    tmp.h_1 = [];
    this.l4_1 = this.l4_1 + 1 | 0;
  };
  protoOf(ArrayList).w = function (element) {
    return indexOf(this.h_1, element);
  };
  protoOf(ArrayList).v = function (element) {
    return lastIndexOf(this.h_1, element);
  };
  protoOf(ArrayList).toString = function () {
    return arrayToString(this.h_1);
  };
  protoOf(ArrayList).p5 = function () {
    return [].slice.call(this.h_1);
  };
  protoOf(ArrayList).toArray = function () {
    return this.p5();
  };
  protoOf(ArrayList).g4 = function () {
    if (this.i_1)
      throw UnsupportedOperationException_init_$Create$();
  };
  var _stableSortingIsSupported;
  function sortArrayWith(array, comparator) {
    if (getStableSortingIsSupported()) {
      var comparison = sortArrayWith$lambda(comparator);
      // Inline function 'kotlin.js.asDynamic' call
      array.sort(comparison);
    } else {
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      mergeSort(array, 0, get_lastIndex_0(array), comparator);
    }
  }
  function getStableSortingIsSupported() {
    var tmp0_safe_receiver = _stableSortingIsSupported;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      return tmp0_safe_receiver;
    }
    _stableSortingIsSupported = false;
    // Inline function 'kotlin.js.unsafeCast' call
    var array = [];
    var inductionVariable = 0;
    if (inductionVariable < 600)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        array.push(index);
      }
       while (inductionVariable < 600);
    var comparison = getStableSortingIsSupported$lambda;
    // Inline function 'kotlin.js.asDynamic' call
    array.sort(comparison);
    var inductionVariable_0 = 1;
    var last = array.length;
    if (inductionVariable_0 < last)
      do {
        var index_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var a = array[index_0 - 1 | 0];
        var b = array[index_0];
        if ((a & 3) === (b & 3) && a >= b)
          return false;
      }
       while (inductionVariable_0 < last);
    _stableSortingIsSupported = true;
    return true;
  }
  function mergeSort(array, start, endInclusive, comparator) {
    // Inline function 'kotlin.arrayOfNulls' call
    var size = array.length;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var buffer = Array(size);
    var result = mergeSort_0(array, buffer, start, endInclusive, comparator);
    if (!(result === array)) {
      var inductionVariable = start;
      if (inductionVariable <= endInclusive)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          array[i] = result[i];
        }
         while (!(i === endInclusive));
    }
  }
  function mergeSort_0(array, buffer, start, end, comparator) {
    if (start === end) {
      return array;
    }
    var median = (start + end | 0) / 2 | 0;
    var left = mergeSort_0(array, buffer, start, median, comparator);
    var right = mergeSort_0(array, buffer, median + 1 | 0, end, comparator);
    var target = left === buffer ? array : buffer;
    var leftIndex = start;
    var rightIndex = median + 1 | 0;
    var inductionVariable = start;
    if (inductionVariable <= end)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (leftIndex <= median && rightIndex <= end) {
          var leftValue = left[leftIndex];
          var rightValue = right[rightIndex];
          if (comparator.compare(leftValue, rightValue) <= 0) {
            target[i] = leftValue;
            leftIndex = leftIndex + 1 | 0;
          } else {
            target[i] = rightValue;
            rightIndex = rightIndex + 1 | 0;
          }
        } else if (leftIndex <= median) {
          target[i] = left[leftIndex];
          leftIndex = leftIndex + 1 | 0;
        } else {
          target[i] = right[rightIndex];
          rightIndex = rightIndex + 1 | 0;
        }
      }
       while (!(i === end));
    return target;
  }
  function sortArrayWith$lambda($comparator) {
    return function (a, b) {
      return $comparator.compare(a, b);
    };
  }
  function getStableSortingIsSupported$lambda(a, b) {
    return (a & 3) - (b & 3) | 0;
  }
  function HashMap_init_$Init$(internalMap, $this) {
    AbstractMutableMap.call($this);
    HashMap.call($this);
    $this.u5_1 = internalMap;
    return $this;
  }
  function HashMap_init_$Init$_0($this) {
    HashMap_init_$Init$(InternalHashMap_init_$Create$(), $this);
    return $this;
  }
  function HashMap_init_$Create$() {
    return HashMap_init_$Init$_0(objectCreate(protoOf(HashMap)));
  }
  function HashMap_init_$Init$_1(initialCapacity, loadFactor, $this) {
    HashMap_init_$Init$(InternalHashMap_init_$Create$_2(initialCapacity, loadFactor), $this);
    return $this;
  }
  function HashMap_init_$Init$_2(initialCapacity, $this) {
    HashMap_init_$Init$_1(initialCapacity, 1.0, $this);
    return $this;
  }
  function HashMap_init_$Create$_0(initialCapacity) {
    return HashMap_init_$Init$_2(initialCapacity, objectCreate(protoOf(HashMap)));
  }
  function HashMap_init_$Init$_3(original, $this) {
    HashMap_init_$Init$(InternalHashMap_init_$Create$_1(original), $this);
    return $this;
  }
  function HashMap_init_$Create$_1(original) {
    return HashMap_init_$Init$_3(original, objectCreate(protoOf(HashMap)));
  }
  protoOf(HashMap).k2 = function () {
    this.u5_1.k2();
  };
  protoOf(HashMap).o2 = function (key) {
    return this.u5_1.w5(key);
  };
  protoOf(HashMap).p2 = function (value) {
    return this.u5_1.p2(value);
  };
  protoOf(HashMap).g5 = function () {
    return new HashMapKeys(this.u5_1);
  };
  protoOf(HashMap).h5 = function () {
    return new HashMapValues(this.u5_1);
  };
  protoOf(HashMap).y = function () {
    var tmp0_elvis_lhs = this.v5_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.also' call
      var this_0 = new HashMapEntrySet(this.u5_1);
      this.v5_1 = this_0;
      tmp = this_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  protoOf(HashMap).q2 = function (key) {
    return this.u5_1.q2(key);
  };
  protoOf(HashMap).t2 = function (key, value) {
    return this.u5_1.t2(key, value);
  };
  protoOf(HashMap).u2 = function (key) {
    return this.u5_1.u2(key);
  };
  protoOf(HashMap).p = function () {
    return this.u5_1.p();
  };
  protoOf(HashMap).v2 = function (from) {
    return this.u5_1.v2(from);
  };
  function HashMap() {
    this.v5_1 = null;
  }
  function HashMapKeys(backing) {
    AbstractMutableSet.call(this);
    this.x5_1 = backing;
  }
  protoOf(HashMapKeys).p = function () {
    return this.x5_1.p();
  };
  protoOf(HashMapKeys).s = function () {
    return this.x5_1.p() === 0;
  };
  protoOf(HashMapKeys).t = function (element) {
    return this.x5_1.w5(element);
  };
  protoOf(HashMapKeys).k2 = function () {
    return this.x5_1.k2();
  };
  protoOf(HashMapKeys).j = function (element) {
    throw UnsupportedOperationException_init_$Create$();
  };
  protoOf(HashMapKeys).q = function (elements) {
    throw UnsupportedOperationException_init_$Create$();
  };
  protoOf(HashMapKeys).h2 = function (element) {
    return this.x5_1.y5(element);
  };
  protoOf(HashMapKeys).m = function () {
    return this.x5_1.z5();
  };
  protoOf(HashMapKeys).g4 = function () {
    return this.x5_1.a6();
  };
  function HashMapValues(backing) {
    AbstractMutableCollection.call(this);
    this.b6_1 = backing;
  }
  protoOf(HashMapValues).p = function () {
    return this.b6_1.p();
  };
  protoOf(HashMapValues).s = function () {
    return this.b6_1.p() === 0;
  };
  protoOf(HashMapValues).c6 = function (element) {
    return this.b6_1.p2(element);
  };
  protoOf(HashMapValues).t = function (element) {
    if (!(element == null ? true : !(element == null)))
      return false;
    return this.c6((element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  protoOf(HashMapValues).d6 = function (element) {
    throw UnsupportedOperationException_init_$Create$();
  };
  protoOf(HashMapValues).j = function (element) {
    return this.d6((element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  protoOf(HashMapValues).e6 = function (elements) {
    throw UnsupportedOperationException_init_$Create$();
  };
  protoOf(HashMapValues).q = function (elements) {
    return this.e6(elements);
  };
  protoOf(HashMapValues).k2 = function () {
    return this.b6_1.k2();
  };
  protoOf(HashMapValues).m = function () {
    return this.b6_1.f6();
  };
  protoOf(HashMapValues).g6 = function (element) {
    return this.b6_1.h6(element);
  };
  protoOf(HashMapValues).h2 = function (element) {
    if (!(element == null ? true : !(element == null)))
      return false;
    return this.g6((element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  protoOf(HashMapValues).g4 = function () {
    return this.b6_1.a6();
  };
  function HashMapEntrySet(backing) {
    HashMapEntrySetBase.call(this, backing);
  }
  protoOf(HashMapEntrySet).m = function () {
    return this.j6_1.k6();
  };
  function HashMapEntrySetBase(backing) {
    AbstractMutableSet.call(this);
    this.j6_1 = backing;
  }
  protoOf(HashMapEntrySetBase).p = function () {
    return this.j6_1.p();
  };
  protoOf(HashMapEntrySetBase).s = function () {
    return this.j6_1.p() === 0;
  };
  protoOf(HashMapEntrySetBase).l6 = function (element) {
    return this.j6_1.o6(element);
  };
  protoOf(HashMapEntrySetBase).t = function (element) {
    if (!(!(element == null) ? isInterface(element, Entry) : false))
      return false;
    return this.l6((!(element == null) ? isInterface(element, Entry) : false) ? element : THROW_CCE());
  };
  protoOf(HashMapEntrySetBase).k2 = function () {
    return this.j6_1.k2();
  };
  protoOf(HashMapEntrySetBase).m6 = function (element) {
    throw UnsupportedOperationException_init_$Create$();
  };
  protoOf(HashMapEntrySetBase).j = function (element) {
    return this.m6((!(element == null) ? isInterface(element, Entry) : false) ? element : THROW_CCE());
  };
  protoOf(HashMapEntrySetBase).q = function (elements) {
    throw UnsupportedOperationException_init_$Create$();
  };
  protoOf(HashMapEntrySetBase).n6 = function (element) {
    return this.j6_1.p6(element);
  };
  protoOf(HashMapEntrySetBase).h2 = function (element) {
    if (!(!(element == null) ? isInterface(element, Entry) : false))
      return false;
    return this.n6((!(element == null) ? isInterface(element, Entry) : false) ? element : THROW_CCE());
  };
  protoOf(HashMapEntrySetBase).e2 = function (elements) {
    return this.j6_1.q6(elements);
  };
  protoOf(HashMapEntrySetBase).g4 = function () {
    return this.j6_1.a6();
  };
  function HashMapKeysDefault$iterator$1($entryIterator) {
    this.r6_1 = $entryIterator;
  }
  protoOf(HashMapKeysDefault$iterator$1).n = function () {
    return this.r6_1.n();
  };
  protoOf(HashMapKeysDefault$iterator$1).o = function () {
    return this.r6_1.o().z();
  };
  protoOf(HashMapKeysDefault$iterator$1).h4 = function () {
    return this.r6_1.h4();
  };
  function HashMapKeysDefault(backingMap) {
    AbstractMutableSet.call(this);
    this.s6_1 = backingMap;
  }
  protoOf(HashMapKeysDefault).t6 = function (element) {
    throw UnsupportedOperationException_init_$Create$_0('Add is not supported on keys');
  };
  protoOf(HashMapKeysDefault).j = function (element) {
    return this.t6((element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  protoOf(HashMapKeysDefault).k2 = function () {
    return this.s6_1.k2();
  };
  protoOf(HashMapKeysDefault).w5 = function (element) {
    return this.s6_1.o2(element);
  };
  protoOf(HashMapKeysDefault).t = function (element) {
    if (!(element == null ? true : !(element == null)))
      return false;
    return this.w5((element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  protoOf(HashMapKeysDefault).m = function () {
    var entryIterator = this.s6_1.y().m();
    return new HashMapKeysDefault$iterator$1(entryIterator);
  };
  protoOf(HashMapKeysDefault).u2 = function (element) {
    this.g4();
    if (this.s6_1.o2(element)) {
      this.s6_1.u2(element);
      return true;
    }
    return false;
  };
  protoOf(HashMapKeysDefault).h2 = function (element) {
    if (!(element == null ? true : !(element == null)))
      return false;
    return this.u2((element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  protoOf(HashMapKeysDefault).p = function () {
    return this.s6_1.p();
  };
  protoOf(HashMapKeysDefault).g4 = function () {
    return this.s6_1.g4();
  };
  function HashMapValuesDefault$iterator$1($entryIterator) {
    this.u6_1 = $entryIterator;
  }
  protoOf(HashMapValuesDefault$iterator$1).n = function () {
    return this.u6_1.n();
  };
  protoOf(HashMapValuesDefault$iterator$1).o = function () {
    return this.u6_1.o().a1();
  };
  protoOf(HashMapValuesDefault$iterator$1).h4 = function () {
    return this.u6_1.h4();
  };
  function HashMapValuesDefault(backingMap) {
    AbstractMutableCollection.call(this);
    this.v6_1 = backingMap;
  }
  protoOf(HashMapValuesDefault).d6 = function (element) {
    throw UnsupportedOperationException_init_$Create$_0('Add is not supported on values');
  };
  protoOf(HashMapValuesDefault).j = function (element) {
    return this.d6((element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  protoOf(HashMapValuesDefault).k2 = function () {
    return this.v6_1.k2();
  };
  protoOf(HashMapValuesDefault).c6 = function (element) {
    return this.v6_1.p2(element);
  };
  protoOf(HashMapValuesDefault).t = function (element) {
    if (!(element == null ? true : !(element == null)))
      return false;
    return this.c6((element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  protoOf(HashMapValuesDefault).m = function () {
    var entryIterator = this.v6_1.y().m();
    return new HashMapValuesDefault$iterator$1(entryIterator);
  };
  protoOf(HashMapValuesDefault).p = function () {
    return this.v6_1.p();
  };
  protoOf(HashMapValuesDefault).g4 = function () {
    return this.v6_1.g4();
  };
  function HashSet_init_$Init$(map, $this) {
    AbstractMutableSet.call($this);
    HashSet.call($this);
    $this.g1_1 = map;
    return $this;
  }
  function HashSet_init_$Init$_0($this) {
    HashSet_init_$Init$(InternalHashMap_init_$Create$(), $this);
    return $this;
  }
  function HashSet_init_$Create$() {
    return HashSet_init_$Init$_0(objectCreate(protoOf(HashSet)));
  }
  function HashSet_init_$Init$_1(elements, $this) {
    HashSet_init_$Init$(InternalHashMap_init_$Create$_0(elements.p()), $this);
    var _iterator__ex2g4s = elements.m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      $this.g1_1.t2(element, true);
    }
    return $this;
  }
  function HashSet_init_$Create$_0(elements) {
    return HashSet_init_$Init$_1(elements, objectCreate(protoOf(HashSet)));
  }
  function HashSet_init_$Init$_2(initialCapacity, loadFactor, $this) {
    HashSet_init_$Init$(InternalHashMap_init_$Create$_2(initialCapacity, loadFactor), $this);
    return $this;
  }
  function HashSet_init_$Init$_3(initialCapacity, $this) {
    HashSet_init_$Init$_2(initialCapacity, 1.0, $this);
    return $this;
  }
  function HashSet_init_$Create$_1(initialCapacity) {
    return HashSet_init_$Init$_3(initialCapacity, objectCreate(protoOf(HashSet)));
  }
  protoOf(HashSet).j = function (element) {
    return this.g1_1.t2(element, true) == null;
  };
  protoOf(HashSet).k2 = function () {
    this.g1_1.k2();
  };
  protoOf(HashSet).t = function (element) {
    return this.g1_1.w5(element);
  };
  protoOf(HashSet).s = function () {
    return this.g1_1.p() === 0;
  };
  protoOf(HashSet).m = function () {
    return this.g1_1.z5();
  };
  protoOf(HashSet).h2 = function (element) {
    return !(this.g1_1.u2(element) == null);
  };
  protoOf(HashSet).p = function () {
    return this.g1_1.p();
  };
  function HashSet() {
  }
  function computeHashSize($this, capacity) {
    return takeHighestOneBit(imul(coerceAtLeast(capacity, 1), 3));
  }
  function computeShift($this, hashSize) {
    // Inline function 'kotlin.countLeadingZeroBits' call
    return clz32(hashSize) + 1 | 0;
  }
  function checkForComodification($this) {
    if (!($this.g7_1.d7_1 === $this.i7_1))
      throw ConcurrentModificationException_init_$Create$_0('The backing map has been modified after this entry was obtained.');
  }
  function InternalHashMap_init_$Init$($this) {
    InternalHashMap_init_$Init$_0(8, $this);
    return $this;
  }
  function InternalHashMap_init_$Create$() {
    return InternalHashMap_init_$Init$(objectCreate(protoOf(InternalHashMap)));
  }
  function InternalHashMap_init_$Init$_0(initialCapacity, $this) {
    InternalHashMap.call($this, arrayOfUninitializedElements(initialCapacity), null, new Int32Array(initialCapacity), new Int32Array(computeHashSize(Companion_instance_4, initialCapacity)), 2, 0);
    return $this;
  }
  function InternalHashMap_init_$Create$_0(initialCapacity) {
    return InternalHashMap_init_$Init$_0(initialCapacity, objectCreate(protoOf(InternalHashMap)));
  }
  function InternalHashMap_init_$Init$_1(original, $this) {
    InternalHashMap_init_$Init$_0(original.p(), $this);
    $this.v2(original);
    return $this;
  }
  function InternalHashMap_init_$Create$_1(original) {
    return InternalHashMap_init_$Init$_1(original, objectCreate(protoOf(InternalHashMap)));
  }
  function InternalHashMap_init_$Init$_2(initialCapacity, loadFactor, $this) {
    InternalHashMap_init_$Init$_0(initialCapacity, $this);
    // Inline function 'kotlin.require' call
    if (!(loadFactor > 0)) {
      var message = 'Non-positive load factor: ' + loadFactor;
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    return $this;
  }
  function InternalHashMap_init_$Create$_2(initialCapacity, loadFactor) {
    return InternalHashMap_init_$Init$_2(initialCapacity, loadFactor, objectCreate(protoOf(InternalHashMap)));
  }
  function _get_capacity__a9k9f3($this) {
    return $this.w6_1.length;
  }
  function _get_hashSize__tftcho($this) {
    return $this.z6_1.length;
  }
  function registerModification($this) {
    $this.d7_1 = $this.d7_1 + 1 | 0;
  }
  function ensureExtraCapacity($this, n) {
    if (shouldCompact($this, n)) {
      compact($this, true);
    } else {
      ensureCapacity($this, $this.b7_1 + n | 0);
    }
  }
  function shouldCompact($this, extraCapacity) {
    var spareCapacity = _get_capacity__a9k9f3($this) - $this.b7_1 | 0;
    var gaps = $this.b7_1 - $this.p() | 0;
    return spareCapacity < extraCapacity && (gaps + spareCapacity | 0) >= extraCapacity && gaps >= (_get_capacity__a9k9f3($this) / 4 | 0);
  }
  function ensureCapacity($this, minCapacity) {
    if (minCapacity < 0)
      throw RuntimeException_init_$Create$_0('too many elements');
    if (minCapacity > _get_capacity__a9k9f3($this)) {
      var newSize = Companion_instance_6.j7(_get_capacity__a9k9f3($this), minCapacity);
      $this.w6_1 = copyOfUninitializedElements($this.w6_1, newSize);
      var tmp = $this;
      var tmp0_safe_receiver = $this.x6_1;
      tmp.x6_1 = tmp0_safe_receiver == null ? null : copyOfUninitializedElements(tmp0_safe_receiver, newSize);
      $this.y6_1 = copyOf($this.y6_1, newSize);
      var newHashSize = computeHashSize(Companion_instance_4, newSize);
      if (newHashSize > _get_hashSize__tftcho($this)) {
        rehash($this, newHashSize);
      }
    }
  }
  function allocateValuesArray($this) {
    var curValuesArray = $this.x6_1;
    if (!(curValuesArray == null))
      return curValuesArray;
    var newValuesArray = arrayOfUninitializedElements(_get_capacity__a9k9f3($this));
    $this.x6_1 = newValuesArray;
    return newValuesArray;
  }
  function hash($this, key) {
    return key == null ? 0 : imul(hashCode(key), -1640531527) >>> $this.c7_1 | 0;
  }
  function compact($this, updateHashArray) {
    var i = 0;
    var j = 0;
    var valuesArray = $this.x6_1;
    while (i < $this.b7_1) {
      var hash = $this.y6_1[i];
      if (hash >= 0) {
        $this.w6_1[j] = $this.w6_1[i];
        if (!(valuesArray == null)) {
          valuesArray[j] = valuesArray[i];
        }
        if (updateHashArray) {
          $this.y6_1[j] = hash;
          $this.z6_1[hash] = j + 1 | 0;
        }
        j = j + 1 | 0;
      }
      i = i + 1 | 0;
    }
    resetRange($this.w6_1, j, $this.b7_1);
    if (valuesArray == null)
      null;
    else {
      resetRange(valuesArray, j, $this.b7_1);
    }
    $this.b7_1 = j;
  }
  function rehash($this, newHashSize) {
    registerModification($this);
    if ($this.b7_1 > $this.e7_1) {
      compact($this, false);
    }
    $this.z6_1 = new Int32Array(newHashSize);
    $this.c7_1 = computeShift(Companion_instance_4, newHashSize);
    var i = 0;
    while (i < $this.b7_1) {
      var _unary__edvuaz = i;
      i = _unary__edvuaz + 1 | 0;
      if (!putRehash($this, _unary__edvuaz)) {
        throw IllegalStateException_init_$Create$_0('This cannot happen with fixed magic multiplier and grow-only hash array. Have object hashCodes changed?');
      }
    }
  }
  function putRehash($this, i) {
    var hash_0 = hash($this, $this.w6_1[i]);
    var probesLeft = $this.a7_1;
    while (true) {
      var index = $this.z6_1[hash_0];
      if (index === 0) {
        $this.z6_1[hash_0] = i + 1 | 0;
        $this.y6_1[i] = hash_0;
        return true;
      }
      probesLeft = probesLeft - 1 | 0;
      if (probesLeft < 0)
        return false;
      var _unary__edvuaz = hash_0;
      hash_0 = _unary__edvuaz - 1 | 0;
      if (_unary__edvuaz === 0)
        hash_0 = _get_hashSize__tftcho($this) - 1 | 0;
    }
  }
  function findKey($this, key) {
    var hash_0 = hash($this, key);
    var probesLeft = $this.a7_1;
    while (true) {
      var index = $this.z6_1[hash_0];
      if (index === 0)
        return -1;
      if (index > 0 && equals($this.w6_1[index - 1 | 0], key))
        return index - 1 | 0;
      probesLeft = probesLeft - 1 | 0;
      if (probesLeft < 0)
        return -1;
      var _unary__edvuaz = hash_0;
      hash_0 = _unary__edvuaz - 1 | 0;
      if (_unary__edvuaz === 0)
        hash_0 = _get_hashSize__tftcho($this) - 1 | 0;
    }
  }
  function findValue($this, value) {
    var i = $this.b7_1;
    $l$loop: while (true) {
      i = i - 1 | 0;
      if (!(i >= 0)) {
        break $l$loop;
      }
      if ($this.y6_1[i] >= 0 && equals(ensureNotNull($this.x6_1)[i], value))
        return i;
    }
    return -1;
  }
  function addKey($this, key) {
    $this.a6();
    retry: while (true) {
      var hash_0 = hash($this, key);
      var tentativeMaxProbeDistance = coerceAtMost(imul($this.a7_1, 2), _get_hashSize__tftcho($this) / 2 | 0);
      var probeDistance = 0;
      while (true) {
        var index = $this.z6_1[hash_0];
        if (index <= 0) {
          if ($this.b7_1 >= _get_capacity__a9k9f3($this)) {
            ensureExtraCapacity($this, 1);
            continue retry;
          }
          var _unary__edvuaz = $this.b7_1;
          $this.b7_1 = _unary__edvuaz + 1 | 0;
          var putIndex = _unary__edvuaz;
          $this.w6_1[putIndex] = key;
          $this.y6_1[putIndex] = hash_0;
          $this.z6_1[hash_0] = putIndex + 1 | 0;
          $this.e7_1 = $this.e7_1 + 1 | 0;
          registerModification($this);
          if (probeDistance > $this.a7_1)
            $this.a7_1 = probeDistance;
          return putIndex;
        }
        if (equals($this.w6_1[index - 1 | 0], key)) {
          return -index | 0;
        }
        probeDistance = probeDistance + 1 | 0;
        if (probeDistance > tentativeMaxProbeDistance) {
          rehash($this, imul(_get_hashSize__tftcho($this), 2));
          continue retry;
        }
        var _unary__edvuaz_0 = hash_0;
        hash_0 = _unary__edvuaz_0 - 1 | 0;
        if (_unary__edvuaz_0 === 0)
          hash_0 = _get_hashSize__tftcho($this) - 1 | 0;
      }
    }
  }
  function removeEntryAt($this, index) {
    resetAt($this.w6_1, index);
    var tmp0_safe_receiver = $this.x6_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      resetAt(tmp0_safe_receiver, index);
    }
    removeHashAt($this, $this.y6_1[index]);
    $this.y6_1[index] = -1;
    $this.e7_1 = $this.e7_1 - 1 | 0;
    registerModification($this);
  }
  function removeHashAt($this, removedHash) {
    var hash_0 = removedHash;
    var hole = removedHash;
    var probeDistance = 0;
    var patchAttemptsLeft = coerceAtMost(imul($this.a7_1, 2), _get_hashSize__tftcho($this) / 2 | 0);
    while (true) {
      var _unary__edvuaz = hash_0;
      hash_0 = _unary__edvuaz - 1 | 0;
      if (_unary__edvuaz === 0)
        hash_0 = _get_hashSize__tftcho($this) - 1 | 0;
      probeDistance = probeDistance + 1 | 0;
      if (probeDistance > $this.a7_1) {
        $this.z6_1[hole] = 0;
        return Unit_instance;
      }
      var index = $this.z6_1[hash_0];
      if (index === 0) {
        $this.z6_1[hole] = 0;
        return Unit_instance;
      }
      if (index < 0) {
        $this.z6_1[hole] = -1;
        hole = hash_0;
        probeDistance = 0;
      } else {
        var otherHash = hash($this, $this.w6_1[index - 1 | 0]);
        if (((otherHash - hash_0 | 0) & (_get_hashSize__tftcho($this) - 1 | 0)) >= probeDistance) {
          $this.z6_1[hole] = index;
          $this.y6_1[index - 1 | 0] = hole;
          hole = hash_0;
          probeDistance = 0;
        }
      }
      patchAttemptsLeft = patchAttemptsLeft - 1 | 0;
      if (patchAttemptsLeft < 0) {
        $this.z6_1[hole] = -1;
        return Unit_instance;
      }
    }
  }
  function contentEquals_1($this, other) {
    return $this.e7_1 === other.p() && $this.q6(other.y());
  }
  function putEntry($this, entry) {
    var index = addKey($this, entry.z());
    var valuesArray = allocateValuesArray($this);
    if (index >= 0) {
      valuesArray[index] = entry.a1();
      return true;
    }
    var oldValue = valuesArray[(-index | 0) - 1 | 0];
    if (!equals(entry.a1(), oldValue)) {
      valuesArray[(-index | 0) - 1 | 0] = entry.a1();
      return true;
    }
    return false;
  }
  function putAllEntries($this, from) {
    if (from.s())
      return false;
    ensureExtraCapacity($this, from.p());
    var it = from.m();
    var updated = false;
    while (it.n()) {
      if (putEntry($this, it.o()))
        updated = true;
    }
    return updated;
  }
  function Companion_4() {
    this.k7_1 = -1640531527;
    this.l7_1 = 8;
    this.m7_1 = 2;
    this.n7_1 = -1;
  }
  var Companion_instance_4;
  function Companion_getInstance_4() {
    return Companion_instance_4;
  }
  function Itr(map) {
    this.o7_1 = map;
    this.p7_1 = 0;
    this.q7_1 = -1;
    this.r7_1 = this.o7_1.d7_1;
    this.s7();
  }
  protoOf(Itr).s7 = function () {
    while (this.p7_1 < this.o7_1.b7_1 && this.o7_1.y6_1[this.p7_1] < 0) {
      this.p7_1 = this.p7_1 + 1 | 0;
    }
  };
  protoOf(Itr).n = function () {
    return this.p7_1 < this.o7_1.b7_1;
  };
  protoOf(Itr).h4 = function () {
    this.t7();
    // Inline function 'kotlin.check' call
    if (!!(this.q7_1 === -1)) {
      var message = 'Call next() before removing element from the iterator.';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    this.o7_1.a6();
    removeEntryAt(this.o7_1, this.q7_1);
    this.q7_1 = -1;
    this.r7_1 = this.o7_1.d7_1;
  };
  protoOf(Itr).t7 = function () {
    if (!(this.o7_1.d7_1 === this.r7_1))
      throw ConcurrentModificationException_init_$Create$();
  };
  function KeysItr(map) {
    Itr.call(this, map);
  }
  protoOf(KeysItr).o = function () {
    this.t7();
    if (this.p7_1 >= this.o7_1.b7_1)
      throw NoSuchElementException_init_$Create$();
    var tmp = this;
    var _unary__edvuaz = this.p7_1;
    this.p7_1 = _unary__edvuaz + 1 | 0;
    tmp.q7_1 = _unary__edvuaz;
    var result = this.o7_1.w6_1[this.q7_1];
    this.s7();
    return result;
  };
  function ValuesItr(map) {
    Itr.call(this, map);
  }
  protoOf(ValuesItr).o = function () {
    this.t7();
    if (this.p7_1 >= this.o7_1.b7_1)
      throw NoSuchElementException_init_$Create$();
    var tmp = this;
    var _unary__edvuaz = this.p7_1;
    this.p7_1 = _unary__edvuaz + 1 | 0;
    tmp.q7_1 = _unary__edvuaz;
    var result = ensureNotNull(this.o7_1.x6_1)[this.q7_1];
    this.s7();
    return result;
  };
  function EntriesItr(map) {
    Itr.call(this, map);
  }
  protoOf(EntriesItr).o = function () {
    this.t7();
    if (this.p7_1 >= this.o7_1.b7_1)
      throw NoSuchElementException_init_$Create$();
    var tmp = this;
    var _unary__edvuaz = this.p7_1;
    this.p7_1 = _unary__edvuaz + 1 | 0;
    tmp.q7_1 = _unary__edvuaz;
    var result = new EntryRef(this.o7_1, this.q7_1);
    this.s7();
    return result;
  };
  protoOf(EntriesItr).g8 = function () {
    if (this.p7_1 >= this.o7_1.b7_1)
      throw NoSuchElementException_init_$Create$();
    var tmp = this;
    var _unary__edvuaz = this.p7_1;
    this.p7_1 = _unary__edvuaz + 1 | 0;
    tmp.q7_1 = _unary__edvuaz;
    // Inline function 'kotlin.hashCode' call
    var tmp0_safe_receiver = this.o7_1.w6_1[this.q7_1];
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    var tmp_0 = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    // Inline function 'kotlin.hashCode' call
    var tmp0_safe_receiver_0 = ensureNotNull(this.o7_1.x6_1)[this.q7_1];
    var tmp1_elvis_lhs_0 = tmp0_safe_receiver_0 == null ? null : hashCode(tmp0_safe_receiver_0);
    var result = tmp_0 ^ (tmp1_elvis_lhs_0 == null ? 0 : tmp1_elvis_lhs_0);
    this.s7();
    return result;
  };
  protoOf(EntriesItr).h8 = function (sb) {
    if (this.p7_1 >= this.o7_1.b7_1)
      throw NoSuchElementException_init_$Create$();
    var tmp = this;
    var _unary__edvuaz = this.p7_1;
    this.p7_1 = _unary__edvuaz + 1 | 0;
    tmp.q7_1 = _unary__edvuaz;
    var key = this.o7_1.w6_1[this.q7_1];
    if (equals(key, this.o7_1))
      sb.j8('(this Map)');
    else
      sb.i8(key);
    sb.k8(_Char___init__impl__6a9atx(61));
    var value = ensureNotNull(this.o7_1.x6_1)[this.q7_1];
    if (equals(value, this.o7_1))
      sb.j8('(this Map)');
    else
      sb.i8(value);
    this.s7();
  };
  function EntryRef(map, index) {
    this.g7_1 = map;
    this.h7_1 = index;
    this.i7_1 = this.g7_1.d7_1;
  }
  protoOf(EntryRef).z = function () {
    checkForComodification(this);
    return this.g7_1.w6_1[this.h7_1];
  };
  protoOf(EntryRef).a1 = function () {
    checkForComodification(this);
    return ensureNotNull(this.g7_1.x6_1)[this.h7_1];
  };
  protoOf(EntryRef).equals = function (other) {
    var tmp;
    var tmp_0;
    if (!(other == null) ? isInterface(other, Entry) : false) {
      tmp_0 = equals(other.z(), this.z());
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = equals(other.a1(), this.a1());
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(EntryRef).hashCode = function () {
    // Inline function 'kotlin.hashCode' call
    var tmp0_safe_receiver = this.z();
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    var tmp = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    // Inline function 'kotlin.hashCode' call
    var tmp0_safe_receiver_0 = this.a1();
    var tmp1_elvis_lhs_0 = tmp0_safe_receiver_0 == null ? null : hashCode(tmp0_safe_receiver_0);
    return tmp ^ (tmp1_elvis_lhs_0 == null ? 0 : tmp1_elvis_lhs_0);
  };
  protoOf(EntryRef).toString = function () {
    return toString_0(this.z()) + '=' + toString_0(this.a1());
  };
  function InternalHashMap(keysArray, valuesArray, presenceArray, hashArray, maxProbeDistance, length) {
    this.w6_1 = keysArray;
    this.x6_1 = valuesArray;
    this.y6_1 = presenceArray;
    this.z6_1 = hashArray;
    this.a7_1 = maxProbeDistance;
    this.b7_1 = length;
    this.c7_1 = computeShift(Companion_instance_4, _get_hashSize__tftcho(this));
    this.d7_1 = 0;
    this.e7_1 = 0;
    this.f7_1 = false;
  }
  protoOf(InternalHashMap).p = function () {
    return this.e7_1;
  };
  protoOf(InternalHashMap).l8 = function () {
    this.a6();
    this.f7_1 = true;
  };
  protoOf(InternalHashMap).p2 = function (value) {
    return findValue(this, value) >= 0;
  };
  protoOf(InternalHashMap).q2 = function (key) {
    var index = findKey(this, key);
    if (index < 0)
      return null;
    return ensureNotNull(this.x6_1)[index];
  };
  protoOf(InternalHashMap).w5 = function (key) {
    return findKey(this, key) >= 0;
  };
  protoOf(InternalHashMap).t2 = function (key, value) {
    var index = addKey(this, key);
    var valuesArray = allocateValuesArray(this);
    if (index < 0) {
      var oldValue = valuesArray[(-index | 0) - 1 | 0];
      valuesArray[(-index | 0) - 1 | 0] = value;
      return oldValue;
    } else {
      valuesArray[index] = value;
      return null;
    }
  };
  protoOf(InternalHashMap).v2 = function (from) {
    this.a6();
    putAllEntries(this, from.y());
  };
  protoOf(InternalHashMap).u2 = function (key) {
    this.a6();
    var index = findKey(this, key);
    if (index < 0)
      return null;
    var oldValue = ensureNotNull(this.x6_1)[index];
    removeEntryAt(this, index);
    return oldValue;
  };
  protoOf(InternalHashMap).k2 = function () {
    this.a6();
    var inductionVariable = 0;
    var last = this.b7_1 - 1 | 0;
    if (inductionVariable <= last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var hash = this.y6_1[i];
        if (hash >= 0) {
          this.z6_1[hash] = 0;
          this.y6_1[i] = -1;
        }
      }
       while (!(i === last));
    resetRange(this.w6_1, 0, this.b7_1);
    var tmp0_safe_receiver = this.x6_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      resetRange(tmp0_safe_receiver, 0, this.b7_1);
    }
    this.e7_1 = 0;
    this.b7_1 = 0;
    registerModification(this);
  };
  protoOf(InternalHashMap).equals = function (other) {
    var tmp;
    if (other === this) {
      tmp = true;
    } else {
      var tmp_0;
      if (!(other == null) ? isInterface(other, KtMap) : false) {
        tmp_0 = contentEquals_1(this, other);
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  protoOf(InternalHashMap).hashCode = function () {
    var result = 0;
    var it = this.k6();
    while (it.n()) {
      result = result + it.g8() | 0;
    }
    return result;
  };
  protoOf(InternalHashMap).toString = function () {
    var sb = StringBuilder_init_$Create$(2 + imul(this.e7_1, 3) | 0);
    sb.j8('{');
    var i = 0;
    var it = this.k6();
    while (it.n()) {
      if (i > 0) {
        sb.j8(', ');
      }
      it.h8(sb);
      i = i + 1 | 0;
    }
    sb.j8('}');
    return sb.toString();
  };
  protoOf(InternalHashMap).a6 = function () {
    if (this.f7_1)
      throw UnsupportedOperationException_init_$Create$();
  };
  protoOf(InternalHashMap).y5 = function (key) {
    this.a6();
    var index = findKey(this, key);
    if (index < 0)
      return false;
    removeEntryAt(this, index);
    return true;
  };
  protoOf(InternalHashMap).o6 = function (entry) {
    var index = findKey(this, entry.z());
    if (index < 0)
      return false;
    return equals(ensureNotNull(this.x6_1)[index], entry.a1());
  };
  protoOf(InternalHashMap).m8 = function (entry) {
    return this.o6(isInterface(entry, Entry) ? entry : THROW_CCE());
  };
  protoOf(InternalHashMap).p6 = function (entry) {
    this.a6();
    var index = findKey(this, entry.z());
    if (index < 0)
      return false;
    if (!equals(ensureNotNull(this.x6_1)[index], entry.a1()))
      return false;
    removeEntryAt(this, index);
    return true;
  };
  protoOf(InternalHashMap).h6 = function (value) {
    this.a6();
    var index = findValue(this, value);
    if (index < 0)
      return false;
    removeEntryAt(this, index);
    return true;
  };
  protoOf(InternalHashMap).z5 = function () {
    return new KeysItr(this);
  };
  protoOf(InternalHashMap).f6 = function () {
    return new ValuesItr(this);
  };
  protoOf(InternalHashMap).k6 = function () {
    return new EntriesItr(this);
  };
  function InternalMap() {
  }
  function LinkedHashMap_init_$Init$($this) {
    HashMap_init_$Init$_0($this);
    LinkedHashMap.call($this);
    return $this;
  }
  function LinkedHashMap_init_$Create$() {
    return LinkedHashMap_init_$Init$(objectCreate(protoOf(LinkedHashMap)));
  }
  function LinkedHashMap_init_$Init$_0(initialCapacity, $this) {
    HashMap_init_$Init$_2(initialCapacity, $this);
    LinkedHashMap.call($this);
    return $this;
  }
  function LinkedHashMap_init_$Create$_0(initialCapacity) {
    return LinkedHashMap_init_$Init$_0(initialCapacity, objectCreate(protoOf(LinkedHashMap)));
  }
  function LinkedHashMap_init_$Init$_1(original, $this) {
    HashMap_init_$Init$_3(original, $this);
    LinkedHashMap.call($this);
    return $this;
  }
  function LinkedHashMap_init_$Create$_1(original) {
    return LinkedHashMap_init_$Init$_1(original, objectCreate(protoOf(LinkedHashMap)));
  }
  function LinkedHashMap_init_$Init$_2(internalMap, $this) {
    HashMap_init_$Init$(internalMap, $this);
    LinkedHashMap.call($this);
    return $this;
  }
  function LinkedHashMap_init_$Create$_2(internalMap) {
    return LinkedHashMap_init_$Init$_2(internalMap, objectCreate(protoOf(LinkedHashMap)));
  }
  function EmptyHolder() {
    EmptyHolder_instance = this;
    var tmp = this;
    // Inline function 'kotlin.also' call
    var this_0 = InternalHashMap_init_$Create$_0(0);
    this_0.l8();
    tmp.n8_1 = LinkedHashMap_init_$Create$_2(this_0);
  }
  var EmptyHolder_instance;
  function EmptyHolder_getInstance() {
    if (EmptyHolder_instance == null)
      new EmptyHolder();
    return EmptyHolder_instance;
  }
  protoOf(LinkedHashMap).i3 = function () {
    this.u5_1.l8();
    var tmp;
    if (this.p() > 0) {
      tmp = this;
    } else {
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = EmptyHolder_getInstance().n8_1;
    }
    return tmp;
  };
  protoOf(LinkedHashMap).g4 = function () {
    return this.u5_1.a6();
  };
  function LinkedHashMap() {
  }
  function LinkedHashSet_init_$Init$($this) {
    HashSet_init_$Init$_0($this);
    LinkedHashSet.call($this);
    return $this;
  }
  function LinkedHashSet_init_$Create$() {
    return LinkedHashSet_init_$Init$(objectCreate(protoOf(LinkedHashSet)));
  }
  function LinkedHashSet_init_$Init$_0(elements, $this) {
    HashSet_init_$Init$_1(elements, $this);
    LinkedHashSet.call($this);
    return $this;
  }
  function LinkedHashSet_init_$Create$_0(elements) {
    return LinkedHashSet_init_$Init$_0(elements, objectCreate(protoOf(LinkedHashSet)));
  }
  function LinkedHashSet_init_$Init$_1(initialCapacity, loadFactor, $this) {
    HashSet_init_$Init$_2(initialCapacity, loadFactor, $this);
    LinkedHashSet.call($this);
    return $this;
  }
  function LinkedHashSet_init_$Init$_2(initialCapacity, $this) {
    LinkedHashSet_init_$Init$_1(initialCapacity, 1.0, $this);
    return $this;
  }
  function LinkedHashSet_init_$Create$_1(initialCapacity) {
    return LinkedHashSet_init_$Init$_2(initialCapacity, objectCreate(protoOf(LinkedHashSet)));
  }
  function LinkedHashSet_init_$Init$_3(internalMap, $this) {
    HashSet_init_$Init$(internalMap, $this);
    LinkedHashSet.call($this);
    return $this;
  }
  function LinkedHashSet_init_$Create$_2(internalMap) {
    return LinkedHashSet_init_$Init$_3(internalMap, objectCreate(protoOf(LinkedHashSet)));
  }
  function EmptyHolder_0() {
    EmptyHolder_instance_0 = this;
    var tmp = this;
    // Inline function 'kotlin.also' call
    var this_0 = InternalHashMap_init_$Create$_0(0);
    this_0.l8();
    tmp.u8_1 = LinkedHashSet_init_$Create$_2(this_0);
  }
  var EmptyHolder_instance_0;
  function EmptyHolder_getInstance_0() {
    if (EmptyHolder_instance_0 == null)
      new EmptyHolder_0();
    return EmptyHolder_instance_0;
  }
  protoOf(LinkedHashSet).i3 = function () {
    this.g1_1.l8();
    return this.p() > 0 ? this : EmptyHolder_getInstance_0().u8_1;
  };
  protoOf(LinkedHashSet).g4 = function () {
    return this.g1_1.a6();
  };
  function LinkedHashSet() {
  }
  function RandomAccess() {
  }
  function get_output() {
    _init_properties_console_kt__rfg7jv();
    return output;
  }
  var output;
  function BaseOutput() {
  }
  protoOf(BaseOutput).w8 = function () {
    this.x8('\n');
  };
  protoOf(BaseOutput).y8 = function (message) {
    this.x8(message);
    this.w8();
  };
  function NodeJsOutput(outputStream) {
    BaseOutput.call(this);
    this.z8_1 = outputStream;
  }
  protoOf(NodeJsOutput).x8 = function (message) {
    // Inline function 'kotlin.io.String' call
    var tmp1_elvis_lhs = message == null ? null : toString_1(message);
    var messageString = tmp1_elvis_lhs == null ? 'null' : tmp1_elvis_lhs;
    this.z8_1.write(messageString);
  };
  function BufferedOutputToConsoleLog() {
    BufferedOutput.call(this);
  }
  protoOf(BufferedOutputToConsoleLog).x8 = function (message) {
    // Inline function 'kotlin.io.String' call
    var tmp1_elvis_lhs = message == null ? null : toString_1(message);
    var s = tmp1_elvis_lhs == null ? 'null' : tmp1_elvis_lhs;
    // Inline function 'kotlin.text.nativeLastIndexOf' call
    // Inline function 'kotlin.js.asDynamic' call
    var i = s.lastIndexOf('\n', 0);
    if (i >= 0) {
      this.b9_1 = this.b9_1 + substring(s, 0, i);
      this.c9();
      s = substring_0(s, i + 1 | 0);
    }
    this.b9_1 = this.b9_1 + s;
  };
  protoOf(BufferedOutputToConsoleLog).c9 = function () {
    console.log(this.b9_1);
    this.b9_1 = '';
  };
  function BufferedOutput() {
    BaseOutput.call(this);
    this.b9_1 = '';
  }
  protoOf(BufferedOutput).x8 = function (message) {
    var tmp = this;
    var tmp_0 = this.b9_1;
    // Inline function 'kotlin.io.String' call
    var tmp1_elvis_lhs = message == null ? null : toString_1(message);
    tmp.b9_1 = tmp_0 + (tmp1_elvis_lhs == null ? 'null' : tmp1_elvis_lhs);
  };
  function println(message) {
    _init_properties_console_kt__rfg7jv();
    get_output().y8(message);
  }
  var properties_initialized_console_kt_gll9dl;
  function _init_properties_console_kt__rfg7jv() {
    if (!properties_initialized_console_kt_gll9dl) {
      properties_initialized_console_kt_gll9dl = true;
      // Inline function 'kotlin.run' call
      var isNode = typeof process !== 'undefined' && process.versions && !!process.versions.node;
      output = isNode ? new NodeJsOutput(process.stdout) : new BufferedOutputToConsoleLog();
    }
  }
  function CoroutineImpl(resultContinuation) {
    InterceptedCoroutine.call(this);
    this.e9_1 = resultContinuation;
    this.f9_1 = 0;
    this.g9_1 = 0;
    this.h9_1 = null;
    this.i9_1 = null;
    this.j9_1 = null;
    var tmp = this;
    var tmp0_safe_receiver = this.e9_1;
    tmp.k9_1 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.l9();
  }
  protoOf(CoroutineImpl).l9 = function () {
    return ensureNotNull(this.k9_1);
  };
  protoOf(CoroutineImpl).m9 = function (result) {
    var current = this;
    // Inline function 'kotlin.Result.getOrNull' call
    var tmp;
    if (_Result___get_isFailure__impl__jpiriv(result)) {
      tmp = null;
    } else {
      var tmp_0 = _Result___get_value__impl__bjfvqg(result);
      tmp = (tmp_0 == null ? true : !(tmp_0 == null)) ? tmp_0 : THROW_CCE();
    }
    var currentResult = tmp;
    var currentException = Result__exceptionOrNull_impl_p6xea9(result);
    while (true) {
      // Inline function 'kotlin.with' call
      var $this$with = current;
      if (currentException == null) {
        $this$with.h9_1 = currentResult;
      } else {
        $this$with.f9_1 = $this$with.g9_1;
        $this$with.i9_1 = currentException;
      }
      try {
        var outcome = $this$with.n9();
        if (outcome === get_COROUTINE_SUSPENDED())
          return Unit_instance;
        currentResult = outcome;
        currentException = null;
      } catch ($p) {
        var exception = $p;
        currentResult = null;
        // Inline function 'kotlin.js.unsafeCast' call
        currentException = exception;
      }
      $this$with.p9();
      var completion = ensureNotNull($this$with.e9_1);
      if (completion instanceof CoroutineImpl) {
        current = completion;
      } else {
        if (!(currentException == null)) {
          // Inline function 'kotlin.coroutines.resumeWithException' call
          // Inline function 'kotlin.Companion.failure' call
          var exception_0 = ensureNotNull(currentException);
          var tmp$ret$2 = _Result___init__impl__xyqfz8(createFailure(exception_0));
          completion.q9(tmp$ret$2);
        } else {
          // Inline function 'kotlin.coroutines.resume' call
          // Inline function 'kotlin.Companion.success' call
          var value = currentResult;
          var tmp$ret$4 = _Result___init__impl__xyqfz8(value);
          completion.q9(tmp$ret$4);
        }
        return Unit_instance;
      }
    }
  };
  protoOf(CoroutineImpl).q9 = function (result) {
    return this.m9(result);
  };
  function CompletedContinuation() {
  }
  protoOf(CompletedContinuation).l9 = function () {
    var message = 'This continuation is already complete';
    throw IllegalStateException_init_$Create$_0(toString_1(message));
  };
  protoOf(CompletedContinuation).m9 = function (result) {
    // Inline function 'kotlin.error' call
    var message = 'This continuation is already complete';
    throw IllegalStateException_init_$Create$_0(toString_1(message));
  };
  protoOf(CompletedContinuation).q9 = function (result) {
    return this.m9(result);
  };
  protoOf(CompletedContinuation).toString = function () {
    return 'This continuation is already complete';
  };
  var CompletedContinuation_instance;
  function CompletedContinuation_getInstance() {
    return CompletedContinuation_instance;
  }
  function InterceptedCoroutine() {
    this.o9_1 = null;
  }
  protoOf(InterceptedCoroutine).r9 = function () {
    var tmp0_elvis_lhs = this.o9_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp1_safe_receiver = this.l9().s9(Key_instance);
      var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.t9(this);
      // Inline function 'kotlin.also' call
      var this_0 = tmp2_elvis_lhs == null ? this : tmp2_elvis_lhs;
      this.o9_1 = this_0;
      tmp = this_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  protoOf(InterceptedCoroutine).p9 = function () {
    var intercepted = this.o9_1;
    if (!(intercepted == null) && !(intercepted === this)) {
      ensureNotNull(this.l9().s9(Key_instance)).u9(intercepted);
    }
    this.o9_1 = CompletedContinuation_instance;
  };
  function CancellationException_init_$Init$($this) {
    IllegalStateException_init_$Init$($this);
    CancellationException.call($this);
    return $this;
  }
  function CancellationException_init_$Create$() {
    var tmp = CancellationException_init_$Init$(objectCreate(protoOf(CancellationException)));
    captureStack(tmp, CancellationException_init_$Create$);
    return tmp;
  }
  function CancellationException_init_$Init$_0(message, $this) {
    IllegalStateException_init_$Init$_0(message, $this);
    CancellationException.call($this);
    return $this;
  }
  function CancellationException_init_$Create$_0(message) {
    var tmp = CancellationException_init_$Init$_0(message, objectCreate(protoOf(CancellationException)));
    captureStack(tmp, CancellationException_init_$Create$_0);
    return tmp;
  }
  function CancellationException_init_$Init$_1(message, cause, $this) {
    IllegalStateException_init_$Init$_1(message, cause, $this);
    CancellationException.call($this);
    return $this;
  }
  function CancellationException_init_$Create$_1(message, cause) {
    var tmp = CancellationException_init_$Init$_1(message, cause, objectCreate(protoOf(CancellationException)));
    captureStack(tmp, CancellationException_init_$Create$_1);
    return tmp;
  }
  function CancellationException() {
    captureStack(this, CancellationException);
  }
  function intercepted(_this__u8e3s4) {
    var tmp0_safe_receiver = _this__u8e3s4 instanceof InterceptedCoroutine ? _this__u8e3s4 : null;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.r9();
    return tmp1_elvis_lhs == null ? _this__u8e3s4 : tmp1_elvis_lhs;
  }
  function createCoroutineUnintercepted(_this__u8e3s4, receiver, completion) {
    // Inline function 'kotlin.coroutines.intrinsics.createCoroutineFromSuspendFunction' call
    return new createCoroutineUnintercepted$$inlined$createCoroutineFromSuspendFunction$1(completion, _this__u8e3s4, receiver, completion);
  }
  function invokeSuspendSuperTypeWithReceiver(_this__u8e3s4, receiver, completion) {
    throw new NotImplementedError('It is intrinsic method');
  }
  function startCoroutineUninterceptedOrReturnNonGeneratorVersion(_this__u8e3s4, receiver, completion) {
    var tmp;
    if (!(completion instanceof InterceptedCoroutine)) {
      tmp = createSimpleCoroutineForSuspendFunction(completion);
    } else {
      tmp = completion;
    }
    var wrappedCompletion = tmp;
    // Inline function 'kotlin.js.asDynamic' call
    var a = _this__u8e3s4;
    return typeof a === 'function' ? a(receiver, wrappedCompletion) : _this__u8e3s4.v9(receiver, wrappedCompletion);
  }
  function createSimpleCoroutineForSuspendFunction(completion) {
    return new createSimpleCoroutineForSuspendFunction$1(completion);
  }
  function startCoroutineUninterceptedOrReturnNonGeneratorVersion_0(_this__u8e3s4, receiver, param, completion) {
    var tmp;
    if (!(completion instanceof InterceptedCoroutine)) {
      tmp = createSimpleCoroutineForSuspendFunction(completion);
    } else {
      tmp = completion;
    }
    var wrappedCompletion = tmp;
    // Inline function 'kotlin.js.asDynamic' call
    var a = _this__u8e3s4;
    return typeof a === 'function' ? a(receiver, param, wrappedCompletion) : _this__u8e3s4.w9(receiver, param, wrappedCompletion);
  }
  function invokeSuspendSuperTypeWithReceiverAndParam(_this__u8e3s4, receiver, param, completion) {
    throw new NotImplementedError('It is intrinsic method');
  }
  function createCoroutineUnintercepted$$inlined$createCoroutineFromSuspendFunction$1($completion, $this_createCoroutineUnintercepted, $receiver, $completion$1) {
    this.fa_1 = $this_createCoroutineUnintercepted;
    this.ga_1 = $receiver;
    this.ha_1 = $completion$1;
    CoroutineImpl.call(this, isInterface($completion, Continuation) ? $completion : THROW_CCE());
  }
  protoOf(createCoroutineUnintercepted$$inlined$createCoroutineFromSuspendFunction$1).n9 = function () {
    if (this.i9_1 != null)
      throw this.i9_1;
    // Inline function 'kotlin.js.asDynamic' call
    var a = this.fa_1;
    return typeof a === 'function' ? a(this.ga_1, this.ha_1) : this.fa_1.v9(this.ga_1, this.ha_1);
  };
  function createSimpleCoroutineForSuspendFunction$1($completion) {
    CoroutineImpl.call(this, isInterface($completion, Continuation) ? $completion : THROW_CCE());
  }
  protoOf(createSimpleCoroutineForSuspendFunction$1).n9 = function () {
    if (this.i9_1 != null)
      throw this.i9_1;
    return this.h9_1;
  };
  function Exception_init_$Init$($this) {
    extendThrowable($this);
    Exception.call($this);
    return $this;
  }
  function Exception_init_$Create$() {
    var tmp = Exception_init_$Init$(objectCreate(protoOf(Exception)));
    captureStack(tmp, Exception_init_$Create$);
    return tmp;
  }
  function Exception_init_$Init$_0(message, $this) {
    extendThrowable($this, message);
    Exception.call($this);
    return $this;
  }
  function Exception_init_$Init$_1(message, cause, $this) {
    extendThrowable($this, message, cause);
    Exception.call($this);
    return $this;
  }
  function Exception_init_$Init$_2(cause, $this) {
    extendThrowable($this, VOID, cause);
    Exception.call($this);
    return $this;
  }
  function Exception() {
    captureStack(this, Exception);
  }
  function IllegalArgumentException_init_$Init$($this) {
    RuntimeException_init_$Init$($this);
    IllegalArgumentException.call($this);
    return $this;
  }
  function IllegalArgumentException_init_$Create$() {
    var tmp = IllegalArgumentException_init_$Init$(objectCreate(protoOf(IllegalArgumentException)));
    captureStack(tmp, IllegalArgumentException_init_$Create$);
    return tmp;
  }
  function IllegalArgumentException_init_$Init$_0(message, $this) {
    RuntimeException_init_$Init$_0(message, $this);
    IllegalArgumentException.call($this);
    return $this;
  }
  function IllegalArgumentException_init_$Create$_0(message) {
    var tmp = IllegalArgumentException_init_$Init$_0(message, objectCreate(protoOf(IllegalArgumentException)));
    captureStack(tmp, IllegalArgumentException_init_$Create$_0);
    return tmp;
  }
  function IllegalArgumentException_init_$Init$_1(message, cause, $this) {
    RuntimeException_init_$Init$_1(message, cause, $this);
    IllegalArgumentException.call($this);
    return $this;
  }
  function IllegalArgumentException_init_$Create$_1(message, cause) {
    var tmp = IllegalArgumentException_init_$Init$_1(message, cause, objectCreate(protoOf(IllegalArgumentException)));
    captureStack(tmp, IllegalArgumentException_init_$Create$_1);
    return tmp;
  }
  function IllegalArgumentException_init_$Init$_2(cause, $this) {
    RuntimeException_init_$Init$_2(cause, $this);
    IllegalArgumentException.call($this);
    return $this;
  }
  function IllegalArgumentException() {
    captureStack(this, IllegalArgumentException);
  }
  function IllegalStateException_init_$Init$($this) {
    RuntimeException_init_$Init$($this);
    IllegalStateException.call($this);
    return $this;
  }
  function IllegalStateException_init_$Create$() {
    var tmp = IllegalStateException_init_$Init$(objectCreate(protoOf(IllegalStateException)));
    captureStack(tmp, IllegalStateException_init_$Create$);
    return tmp;
  }
  function IllegalStateException_init_$Init$_0(message, $this) {
    RuntimeException_init_$Init$_0(message, $this);
    IllegalStateException.call($this);
    return $this;
  }
  function IllegalStateException_init_$Create$_0(message) {
    var tmp = IllegalStateException_init_$Init$_0(message, objectCreate(protoOf(IllegalStateException)));
    captureStack(tmp, IllegalStateException_init_$Create$_0);
    return tmp;
  }
  function IllegalStateException_init_$Init$_1(message, cause, $this) {
    RuntimeException_init_$Init$_1(message, cause, $this);
    IllegalStateException.call($this);
    return $this;
  }
  function IllegalStateException_init_$Create$_1(message, cause) {
    var tmp = IllegalStateException_init_$Init$_1(message, cause, objectCreate(protoOf(IllegalStateException)));
    captureStack(tmp, IllegalStateException_init_$Create$_1);
    return tmp;
  }
  function IllegalStateException() {
    captureStack(this, IllegalStateException);
  }
  function UnsupportedOperationException_init_$Init$($this) {
    RuntimeException_init_$Init$($this);
    UnsupportedOperationException.call($this);
    return $this;
  }
  function UnsupportedOperationException_init_$Create$() {
    var tmp = UnsupportedOperationException_init_$Init$(objectCreate(protoOf(UnsupportedOperationException)));
    captureStack(tmp, UnsupportedOperationException_init_$Create$);
    return tmp;
  }
  function UnsupportedOperationException_init_$Init$_0(message, $this) {
    RuntimeException_init_$Init$_0(message, $this);
    UnsupportedOperationException.call($this);
    return $this;
  }
  function UnsupportedOperationException_init_$Create$_0(message) {
    var tmp = UnsupportedOperationException_init_$Init$_0(message, objectCreate(protoOf(UnsupportedOperationException)));
    captureStack(tmp, UnsupportedOperationException_init_$Create$_0);
    return tmp;
  }
  function UnsupportedOperationException() {
    captureStack(this, UnsupportedOperationException);
  }
  function RuntimeException_init_$Init$($this) {
    Exception_init_$Init$($this);
    RuntimeException.call($this);
    return $this;
  }
  function RuntimeException_init_$Create$() {
    var tmp = RuntimeException_init_$Init$(objectCreate(protoOf(RuntimeException)));
    captureStack(tmp, RuntimeException_init_$Create$);
    return tmp;
  }
  function RuntimeException_init_$Init$_0(message, $this) {
    Exception_init_$Init$_0(message, $this);
    RuntimeException.call($this);
    return $this;
  }
  function RuntimeException_init_$Create$_0(message) {
    var tmp = RuntimeException_init_$Init$_0(message, objectCreate(protoOf(RuntimeException)));
    captureStack(tmp, RuntimeException_init_$Create$_0);
    return tmp;
  }
  function RuntimeException_init_$Init$_1(message, cause, $this) {
    Exception_init_$Init$_1(message, cause, $this);
    RuntimeException.call($this);
    return $this;
  }
  function RuntimeException_init_$Create$_1(message, cause) {
    var tmp = RuntimeException_init_$Init$_1(message, cause, objectCreate(protoOf(RuntimeException)));
    captureStack(tmp, RuntimeException_init_$Create$_1);
    return tmp;
  }
  function RuntimeException_init_$Init$_2(cause, $this) {
    Exception_init_$Init$_2(cause, $this);
    RuntimeException.call($this);
    return $this;
  }
  function RuntimeException_init_$Create$_2(cause) {
    var tmp = RuntimeException_init_$Init$_2(cause, objectCreate(protoOf(RuntimeException)));
    captureStack(tmp, RuntimeException_init_$Create$_2);
    return tmp;
  }
  function RuntimeException() {
    captureStack(this, RuntimeException);
  }
  function NoSuchElementException_init_$Init$($this) {
    RuntimeException_init_$Init$($this);
    NoSuchElementException.call($this);
    return $this;
  }
  function NoSuchElementException_init_$Create$() {
    var tmp = NoSuchElementException_init_$Init$(objectCreate(protoOf(NoSuchElementException)));
    captureStack(tmp, NoSuchElementException_init_$Create$);
    return tmp;
  }
  function NoSuchElementException_init_$Init$_0(message, $this) {
    RuntimeException_init_$Init$_0(message, $this);
    NoSuchElementException.call($this);
    return $this;
  }
  function NoSuchElementException_init_$Create$_0(message) {
    var tmp = NoSuchElementException_init_$Init$_0(message, objectCreate(protoOf(NoSuchElementException)));
    captureStack(tmp, NoSuchElementException_init_$Create$_0);
    return tmp;
  }
  function NoSuchElementException() {
    captureStack(this, NoSuchElementException);
  }
  function Error_init_$Init$($this) {
    extendThrowable($this);
    Error_0.call($this);
    return $this;
  }
  function Error_init_$Create$() {
    var tmp = Error_init_$Init$(objectCreate(protoOf(Error_0)));
    captureStack(tmp, Error_init_$Create$);
    return tmp;
  }
  function Error_init_$Init$_0(message, $this) {
    extendThrowable($this, message);
    Error_0.call($this);
    return $this;
  }
  function Error_init_$Create$_0(message) {
    var tmp = Error_init_$Init$_0(message, objectCreate(protoOf(Error_0)));
    captureStack(tmp, Error_init_$Create$_0);
    return tmp;
  }
  function Error_init_$Init$_1(message, cause, $this) {
    extendThrowable($this, message, cause);
    Error_0.call($this);
    return $this;
  }
  function Error_init_$Create$_1(message, cause) {
    var tmp = Error_init_$Init$_1(message, cause, objectCreate(protoOf(Error_0)));
    captureStack(tmp, Error_init_$Create$_1);
    return tmp;
  }
  function Error_0() {
    captureStack(this, Error_0);
  }
  function IndexOutOfBoundsException_init_$Init$($this) {
    RuntimeException_init_$Init$($this);
    IndexOutOfBoundsException.call($this);
    return $this;
  }
  function IndexOutOfBoundsException_init_$Create$() {
    var tmp = IndexOutOfBoundsException_init_$Init$(objectCreate(protoOf(IndexOutOfBoundsException)));
    captureStack(tmp, IndexOutOfBoundsException_init_$Create$);
    return tmp;
  }
  function IndexOutOfBoundsException_init_$Init$_0(message, $this) {
    RuntimeException_init_$Init$_0(message, $this);
    IndexOutOfBoundsException.call($this);
    return $this;
  }
  function IndexOutOfBoundsException_init_$Create$_0(message) {
    var tmp = IndexOutOfBoundsException_init_$Init$_0(message, objectCreate(protoOf(IndexOutOfBoundsException)));
    captureStack(tmp, IndexOutOfBoundsException_init_$Create$_0);
    return tmp;
  }
  function IndexOutOfBoundsException() {
    captureStack(this, IndexOutOfBoundsException);
  }
  function NullPointerException_init_$Init$($this) {
    RuntimeException_init_$Init$($this);
    NullPointerException.call($this);
    return $this;
  }
  function NullPointerException_init_$Create$() {
    var tmp = NullPointerException_init_$Init$(objectCreate(protoOf(NullPointerException)));
    captureStack(tmp, NullPointerException_init_$Create$);
    return tmp;
  }
  function NullPointerException_init_$Init$_0(message, $this) {
    RuntimeException_init_$Init$_0(message, $this);
    NullPointerException.call($this);
    return $this;
  }
  function NullPointerException_init_$Create$_0(message) {
    var tmp = NullPointerException_init_$Init$_0(message, objectCreate(protoOf(NullPointerException)));
    captureStack(tmp, NullPointerException_init_$Create$_0);
    return tmp;
  }
  function NullPointerException() {
    captureStack(this, NullPointerException);
  }
  function AssertionError_init_$Init$($this) {
    Error_init_$Init$($this);
    AssertionError.call($this);
    return $this;
  }
  function AssertionError_init_$Create$() {
    var tmp = AssertionError_init_$Init$(objectCreate(protoOf(AssertionError)));
    captureStack(tmp, AssertionError_init_$Create$);
    return tmp;
  }
  function AssertionError_init_$Init$_0(message, $this) {
    Error_init_$Init$_0(message, $this);
    AssertionError.call($this);
    return $this;
  }
  function AssertionError_init_$Create$_0(message) {
    var tmp = AssertionError_init_$Init$_0(message, objectCreate(protoOf(AssertionError)));
    captureStack(tmp, AssertionError_init_$Create$_0);
    return tmp;
  }
  function AssertionError_init_$Init$_1(message, $this) {
    var tmp = message == null ? null : toString_1(message);
    Error_init_$Init$_1(tmp, message instanceof Error ? message : null, $this);
    AssertionError.call($this);
    return $this;
  }
  function AssertionError_init_$Create$_1(message) {
    var tmp = AssertionError_init_$Init$_1(message, objectCreate(protoOf(AssertionError)));
    captureStack(tmp, AssertionError_init_$Create$_1);
    return tmp;
  }
  function AssertionError() {
    captureStack(this, AssertionError);
  }
  function ArithmeticException_init_$Init$($this) {
    RuntimeException_init_$Init$($this);
    ArithmeticException.call($this);
    return $this;
  }
  function ArithmeticException_init_$Create$() {
    var tmp = ArithmeticException_init_$Init$(objectCreate(protoOf(ArithmeticException)));
    captureStack(tmp, ArithmeticException_init_$Create$);
    return tmp;
  }
  function ArithmeticException_init_$Init$_0(message, $this) {
    RuntimeException_init_$Init$_0(message, $this);
    ArithmeticException.call($this);
    return $this;
  }
  function ArithmeticException_init_$Create$_0(message) {
    var tmp = ArithmeticException_init_$Init$_0(message, objectCreate(protoOf(ArithmeticException)));
    captureStack(tmp, ArithmeticException_init_$Create$_0);
    return tmp;
  }
  function ArithmeticException() {
    captureStack(this, ArithmeticException);
  }
  function NumberFormatException_init_$Init$($this) {
    IllegalArgumentException_init_$Init$($this);
    NumberFormatException.call($this);
    return $this;
  }
  function NumberFormatException_init_$Create$() {
    var tmp = NumberFormatException_init_$Init$(objectCreate(protoOf(NumberFormatException)));
    captureStack(tmp, NumberFormatException_init_$Create$);
    return tmp;
  }
  function NumberFormatException_init_$Init$_0(message, $this) {
    IllegalArgumentException_init_$Init$_0(message, $this);
    NumberFormatException.call($this);
    return $this;
  }
  function NumberFormatException_init_$Create$_0(message) {
    var tmp = NumberFormatException_init_$Init$_0(message, objectCreate(protoOf(NumberFormatException)));
    captureStack(tmp, NumberFormatException_init_$Create$_0);
    return tmp;
  }
  function NumberFormatException() {
    captureStack(this, NumberFormatException);
  }
  function ConcurrentModificationException_init_$Init$($this) {
    RuntimeException_init_$Init$($this);
    ConcurrentModificationException.call($this);
    return $this;
  }
  function ConcurrentModificationException_init_$Create$() {
    var tmp = ConcurrentModificationException_init_$Init$(objectCreate(protoOf(ConcurrentModificationException)));
    captureStack(tmp, ConcurrentModificationException_init_$Create$);
    return tmp;
  }
  function ConcurrentModificationException_init_$Init$_0(message, $this) {
    RuntimeException_init_$Init$_0(message, $this);
    ConcurrentModificationException.call($this);
    return $this;
  }
  function ConcurrentModificationException_init_$Create$_0(message) {
    var tmp = ConcurrentModificationException_init_$Init$_0(message, objectCreate(protoOf(ConcurrentModificationException)));
    captureStack(tmp, ConcurrentModificationException_init_$Create$_0);
    return tmp;
  }
  function ConcurrentModificationException() {
    captureStack(this, ConcurrentModificationException);
  }
  function ClassCastException_init_$Init$($this) {
    RuntimeException_init_$Init$($this);
    ClassCastException.call($this);
    return $this;
  }
  function ClassCastException_init_$Create$() {
    var tmp = ClassCastException_init_$Init$(objectCreate(protoOf(ClassCastException)));
    captureStack(tmp, ClassCastException_init_$Create$);
    return tmp;
  }
  function ClassCastException_init_$Init$_0(message, $this) {
    RuntimeException_init_$Init$_0(message, $this);
    ClassCastException.call($this);
    return $this;
  }
  function ClassCastException_init_$Create$_0(message) {
    var tmp = ClassCastException_init_$Init$_0(message, objectCreate(protoOf(ClassCastException)));
    captureStack(tmp, ClassCastException_init_$Create$_0);
    return tmp;
  }
  function ClassCastException() {
    captureStack(this, ClassCastException);
  }
  function NoWhenBranchMatchedException_init_$Init$($this) {
    RuntimeException_init_$Init$($this);
    NoWhenBranchMatchedException.call($this);
    return $this;
  }
  function NoWhenBranchMatchedException_init_$Create$() {
    var tmp = NoWhenBranchMatchedException_init_$Init$(objectCreate(protoOf(NoWhenBranchMatchedException)));
    captureStack(tmp, NoWhenBranchMatchedException_init_$Create$);
    return tmp;
  }
  function NoWhenBranchMatchedException() {
    captureStack(this, NoWhenBranchMatchedException);
  }
  function UninitializedPropertyAccessException_init_$Init$($this) {
    RuntimeException_init_$Init$($this);
    UninitializedPropertyAccessException.call($this);
    return $this;
  }
  function UninitializedPropertyAccessException_init_$Create$() {
    var tmp = UninitializedPropertyAccessException_init_$Init$(objectCreate(protoOf(UninitializedPropertyAccessException)));
    captureStack(tmp, UninitializedPropertyAccessException_init_$Create$);
    return tmp;
  }
  function UninitializedPropertyAccessException_init_$Init$_0(message, $this) {
    RuntimeException_init_$Init$_0(message, $this);
    UninitializedPropertyAccessException.call($this);
    return $this;
  }
  function UninitializedPropertyAccessException_init_$Create$_0(message) {
    var tmp = UninitializedPropertyAccessException_init_$Init$_0(message, objectCreate(protoOf(UninitializedPropertyAccessException)));
    captureStack(tmp, UninitializedPropertyAccessException_init_$Create$_0);
    return tmp;
  }
  function UninitializedPropertyAccessException() {
    captureStack(this, UninitializedPropertyAccessException);
  }
  function lazy(initializer) {
    return new UnsafeLazyImpl(initializer);
  }
  function lazy_0(mode, initializer) {
    return new UnsafeLazyImpl(initializer);
  }
  function fillFrom(src, dst) {
    var srcLen = src.length;
    var dstLen = dst.length;
    var index = 0;
    // Inline function 'kotlin.js.unsafeCast' call
    var arr = dst;
    while (index < srcLen && index < dstLen) {
      var tmp = index;
      var _unary__edvuaz = index;
      index = _unary__edvuaz + 1 | 0;
      arr[tmp] = src[_unary__edvuaz];
    }
    return dst;
  }
  function arrayCopyResize(source, newSize, defaultValue) {
    // Inline function 'kotlin.js.unsafeCast' call
    var result = source.slice(0, newSize);
    // Inline function 'kotlin.copyArrayType' call
    if (source.$type$ !== undefined) {
      result.$type$ = source.$type$;
    }
    var index = source.length;
    if (newSize > index) {
      // Inline function 'kotlin.js.asDynamic' call
      result.length = newSize;
      while (index < newSize) {
        var _unary__edvuaz = index;
        index = _unary__edvuaz + 1 | 0;
        result[_unary__edvuaz] = defaultValue;
      }
    }
    return result;
  }
  function roundToInt(_this__u8e3s4) {
    var tmp;
    if (isNaN_0(_this__u8e3s4)) {
      throw IllegalArgumentException_init_$Create$_0('Cannot round NaN value.');
    } else if (_this__u8e3s4 > 2147483647) {
      tmp = 2147483647;
    } else if (_this__u8e3s4 < -2147483648) {
      tmp = -2147483648;
    } else {
      tmp = numberToInt(Math.round(_this__u8e3s4));
    }
    return tmp;
  }
  function abs_0(n) {
    return n < 0 ? -n | 0 | 0 : n;
  }
  function roundToLong(_this__u8e3s4) {
    var tmp;
    if (isNaN_0(_this__u8e3s4)) {
      throw IllegalArgumentException_init_$Create$_0('Cannot round NaN value.');
    } else if (_this__u8e3s4 > toNumber_0(9223372036854775807n)) {
      tmp = 9223372036854775807n;
    } else if (_this__u8e3s4 < toNumber_0(-9223372036854775808n)) {
      tmp = -9223372036854775808n;
    } else {
      tmp = numberToLong(Math.round(_this__u8e3s4));
    }
    return tmp;
  }
  function abs_1(n) {
    return n < 0n ? negate_0(n) : n;
  }
  function get_INV_2_26() {
    _init_properties_PlatformRandom_kt__6kjv62();
    return INV_2_26;
  }
  var INV_2_26;
  function get_INV_2_53() {
    _init_properties_PlatformRandom_kt__6kjv62();
    return INV_2_53;
  }
  var INV_2_53;
  function doubleFromParts(hi26, low27) {
    _init_properties_PlatformRandom_kt__6kjv62();
    return hi26 * get_INV_2_26() + low27 * get_INV_2_53();
  }
  function defaultPlatformRandom() {
    _init_properties_PlatformRandom_kt__6kjv62();
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp$ret$0 = Math.random() * Math.pow(2, 32) | 0;
    return Random_0(tmp$ret$0);
  }
  var properties_initialized_PlatformRandom_kt_uibhw8;
  function _init_properties_PlatformRandom_kt__6kjv62() {
    if (!properties_initialized_PlatformRandom_kt_uibhw8) {
      properties_initialized_PlatformRandom_kt_uibhw8 = true;
      // Inline function 'kotlin.math.pow' call
      INV_2_26 = Math.pow(2.0, -26);
      // Inline function 'kotlin.math.pow' call
      INV_2_53 = Math.pow(2.0, -53);
    }
  }
  function get_js(_this__u8e3s4) {
    return (_this__u8e3s4 instanceof KClassImpl ? _this__u8e3s4 : THROW_CCE()).qa();
  }
  function KClass() {
  }
  function KClassImpl() {
  }
  protoOf(KClassImpl).equals = function (other) {
    var tmp;
    if (other instanceof NothingKClassImpl) {
      tmp = false;
    } else {
      if (other instanceof KClassImpl) {
        tmp = equals(this.qa(), other.qa());
      } else {
        tmp = false;
      }
    }
    return tmp;
  };
  protoOf(KClassImpl).hashCode = function () {
    var tmp0_safe_receiver = this.ra();
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : getStringHashCode(tmp0_safe_receiver);
    return tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
  };
  protoOf(KClassImpl).toString = function () {
    return 'class ' + this.ra();
  };
  function NothingKClassImpl() {
    NothingKClassImpl_instance = this;
    KClassImpl.call(this);
    this.ta_1 = 'Nothing';
  }
  protoOf(NothingKClassImpl).ra = function () {
    return this.ta_1;
  };
  protoOf(NothingKClassImpl).sa = function (value) {
    return false;
  };
  protoOf(NothingKClassImpl).qa = function () {
    throw UnsupportedOperationException_init_$Create$_0("There's no native JS class for Nothing type");
  };
  protoOf(NothingKClassImpl).equals = function (other) {
    return other === this;
  };
  protoOf(NothingKClassImpl).hashCode = function () {
    return 0;
  };
  var NothingKClassImpl_instance;
  function NothingKClassImpl_getInstance() {
    if (NothingKClassImpl_instance == null)
      new NothingKClassImpl();
    return NothingKClassImpl_instance;
  }
  function PrimitiveKClassImpl(jClass, givenSimpleName, isInstanceFunction) {
    KClassImpl.call(this);
    this.ua_1 = jClass;
    this.va_1 = givenSimpleName;
    this.wa_1 = isInstanceFunction;
  }
  protoOf(PrimitiveKClassImpl).qa = function () {
    return this.ua_1;
  };
  protoOf(PrimitiveKClassImpl).equals = function (other) {
    if (!(other instanceof PrimitiveKClassImpl))
      return false;
    return protoOf(KClassImpl).equals.call(this, other) && this.va_1 === other.va_1;
  };
  protoOf(PrimitiveKClassImpl).ra = function () {
    return this.va_1;
  };
  protoOf(PrimitiveKClassImpl).sa = function (value) {
    return this.wa_1(value);
  };
  function SimpleKClassImpl(jClass) {
    KClassImpl.call(this);
    this.xa_1 = jClass;
    var tmp = this;
    // Inline function 'kotlin.js.asDynamic' call
    var tmp0_safe_receiver = this.xa_1.$metadata$;
    // Inline function 'kotlin.js.unsafeCast' call
    tmp.ya_1 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.simpleName;
  }
  protoOf(SimpleKClassImpl).qa = function () {
    return this.xa_1;
  };
  protoOf(SimpleKClassImpl).ra = function () {
    return this.ya_1;
  };
  protoOf(SimpleKClassImpl).sa = function (value) {
    return jsIsType(value, this.xa_1);
  };
  function KProperty0() {
  }
  function KProperty1() {
  }
  function KMutableProperty0() {
  }
  function createKType(classifier, arguments_0, isMarkedNullable) {
    return new KTypeImpl(classifier, asList(arguments_0), isMarkedNullable);
  }
  function createInvariantKTypeProjection(type) {
    return Companion_getInstance_15().bb(type);
  }
  function KTypeImpl(classifier, arguments_0, isMarkedNullable) {
    this.cb_1 = classifier;
    this.db_1 = arguments_0;
    this.eb_1 = isMarkedNullable;
  }
  protoOf(KTypeImpl).fb = function () {
    return this.cb_1;
  };
  protoOf(KTypeImpl).gb = function () {
    return this.db_1;
  };
  protoOf(KTypeImpl).hb = function () {
    return this.eb_1;
  };
  protoOf(KTypeImpl).equals = function (other) {
    var tmp;
    var tmp_0;
    var tmp_1;
    if (other instanceof KTypeImpl) {
      tmp_1 = equals(this.cb_1, other.cb_1);
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = equals(this.db_1, other.db_1);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.eb_1 === other.eb_1;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(KTypeImpl).hashCode = function () {
    return imul(imul(hashCode(this.cb_1), 31) + hashCode(this.db_1) | 0, 31) + getBooleanHashCode(this.eb_1) | 0;
  };
  protoOf(KTypeImpl).toString = function () {
    var tmp = this.cb_1;
    var kClass = isInterface(tmp, KClass) ? tmp : null;
    var classifierName = kClass == null ? toString_1(this.cb_1) : !(kClass.ra() == null) ? kClass.ra() : '(non-denotable type)';
    var args = this.db_1.s() ? '' : joinToString_0(this.db_1, ', ', '<', '>');
    var nullable = this.eb_1 ? '?' : '';
    return plus_12(classifierName, args) + nullable;
  };
  function get_functionClasses() {
    _init_properties_primitives_kt__3fums4();
    return functionClasses;
  }
  var functionClasses;
  function PrimitiveClasses$anyClass$lambda(it) {
    return !(it == null);
  }
  function PrimitiveClasses$numberClass$lambda(it) {
    return isNumber(it);
  }
  function PrimitiveClasses$booleanClass$lambda(it) {
    return !(it == null) ? typeof it === 'boolean' : false;
  }
  function PrimitiveClasses$byteClass$lambda(it) {
    return !(it == null) ? typeof it === 'number' : false;
  }
  function PrimitiveClasses$shortClass$lambda(it) {
    return !(it == null) ? typeof it === 'number' : false;
  }
  function PrimitiveClasses$intClass$lambda(it) {
    return !(it == null) ? typeof it === 'number' : false;
  }
  function PrimitiveClasses$longClass$lambda(it) {
    return !(it == null) ? typeof it === 'bigint' : false;
  }
  function PrimitiveClasses$floatClass$lambda(it) {
    return !(it == null) ? typeof it === 'number' : false;
  }
  function PrimitiveClasses$doubleClass$lambda(it) {
    return !(it == null) ? typeof it === 'number' : false;
  }
  function PrimitiveClasses$arrayClass$lambda(it) {
    return !(it == null) ? isArray(it) : false;
  }
  function PrimitiveClasses$stringClass$lambda(it) {
    return !(it == null) ? typeof it === 'string' : false;
  }
  function PrimitiveClasses$throwableClass$lambda(it) {
    return it instanceof Error;
  }
  function PrimitiveClasses$booleanArrayClass$lambda(it) {
    return !(it == null) ? isBooleanArray(it) : false;
  }
  function PrimitiveClasses$charArrayClass$lambda(it) {
    return !(it == null) ? isCharArray(it) : false;
  }
  function PrimitiveClasses$byteArrayClass$lambda(it) {
    return !(it == null) ? isByteArray(it) : false;
  }
  function PrimitiveClasses$shortArrayClass$lambda(it) {
    return !(it == null) ? isShortArray(it) : false;
  }
  function PrimitiveClasses$intArrayClass$lambda(it) {
    return !(it == null) ? isIntArray(it) : false;
  }
  function PrimitiveClasses$longArrayClass$lambda(it) {
    return !(it == null) ? isLongArray(it) : false;
  }
  function PrimitiveClasses$floatArrayClass$lambda(it) {
    return !(it == null) ? isFloatArray(it) : false;
  }
  function PrimitiveClasses$doubleArrayClass$lambda(it) {
    return !(it == null) ? isDoubleArray(it) : false;
  }
  function PrimitiveClasses$functionClass$lambda($arity) {
    return function (it) {
      var tmp;
      if (typeof it === 'function') {
        // Inline function 'kotlin.js.asDynamic' call
        tmp = it.length === $arity;
      } else {
        tmp = false;
      }
      return tmp;
    };
  }
  function PrimitiveClasses() {
    PrimitiveClasses_instance = this;
    var tmp = this;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp_0 = Object;
    tmp.anyClass = new PrimitiveKClassImpl(tmp_0, 'Any', PrimitiveClasses$anyClass$lambda);
    var tmp_1 = this;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp_2 = Number;
    tmp_1.numberClass = new PrimitiveKClassImpl(tmp_2, 'Number', PrimitiveClasses$numberClass$lambda);
    this.nothingClass = NothingKClassImpl_getInstance();
    var tmp_3 = this;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp_4 = Boolean;
    tmp_3.booleanClass = new PrimitiveKClassImpl(tmp_4, 'Boolean', PrimitiveClasses$booleanClass$lambda);
    var tmp_5 = this;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp_6 = Number;
    tmp_5.byteClass = new PrimitiveKClassImpl(tmp_6, 'Byte', PrimitiveClasses$byteClass$lambda);
    var tmp_7 = this;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp_8 = Number;
    tmp_7.shortClass = new PrimitiveKClassImpl(tmp_8, 'Short', PrimitiveClasses$shortClass$lambda);
    var tmp_9 = this;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp_10 = Number;
    tmp_9.intClass = new PrimitiveKClassImpl(tmp_10, 'Int', PrimitiveClasses$intClass$lambda);
    var tmp_11 = this;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_12 = typeof BigInt === 'undefined' ? VOID : BigInt;
    tmp_11.longClass = new PrimitiveKClassImpl(tmp_12, 'Long', PrimitiveClasses$longClass$lambda);
    var tmp_13 = this;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp_14 = Number;
    tmp_13.floatClass = new PrimitiveKClassImpl(tmp_14, 'Float', PrimitiveClasses$floatClass$lambda);
    var tmp_15 = this;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp_16 = Number;
    tmp_15.doubleClass = new PrimitiveKClassImpl(tmp_16, 'Double', PrimitiveClasses$doubleClass$lambda);
    var tmp_17 = this;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp_18 = Array;
    tmp_17.arrayClass = new PrimitiveKClassImpl(tmp_18, 'Array', PrimitiveClasses$arrayClass$lambda);
    var tmp_19 = this;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp_20 = String;
    tmp_19.stringClass = new PrimitiveKClassImpl(tmp_20, 'String', PrimitiveClasses$stringClass$lambda);
    var tmp_21 = this;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp_22 = Error;
    tmp_21.throwableClass = new PrimitiveKClassImpl(tmp_22, 'Throwable', PrimitiveClasses$throwableClass$lambda);
    var tmp_23 = this;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp_24 = Array;
    tmp_23.booleanArrayClass = new PrimitiveKClassImpl(tmp_24, 'BooleanArray', PrimitiveClasses$booleanArrayClass$lambda);
    var tmp_25 = this;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp_26 = Uint16Array;
    tmp_25.charArrayClass = new PrimitiveKClassImpl(tmp_26, 'CharArray', PrimitiveClasses$charArrayClass$lambda);
    var tmp_27 = this;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp_28 = Int8Array;
    tmp_27.byteArrayClass = new PrimitiveKClassImpl(tmp_28, 'ByteArray', PrimitiveClasses$byteArrayClass$lambda);
    var tmp_29 = this;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp_30 = Int16Array;
    tmp_29.shortArrayClass = new PrimitiveKClassImpl(tmp_30, 'ShortArray', PrimitiveClasses$shortArrayClass$lambda);
    var tmp_31 = this;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp_32 = Int32Array;
    tmp_31.intArrayClass = new PrimitiveKClassImpl(tmp_32, 'IntArray', PrimitiveClasses$intArrayClass$lambda);
    var tmp_33 = this;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp_34 = Array;
    tmp_33.longArrayClass = new PrimitiveKClassImpl(tmp_34, 'LongArray', PrimitiveClasses$longArrayClass$lambda);
    var tmp_35 = this;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp_36 = Float32Array;
    tmp_35.floatArrayClass = new PrimitiveKClassImpl(tmp_36, 'FloatArray', PrimitiveClasses$floatArrayClass$lambda);
    var tmp_37 = this;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp_38 = Float64Array;
    tmp_37.doubleArrayClass = new PrimitiveKClassImpl(tmp_38, 'DoubleArray', PrimitiveClasses$doubleArrayClass$lambda);
  }
  protoOf(PrimitiveClasses).ib = function () {
    return this.anyClass;
  };
  protoOf(PrimitiveClasses).jb = function () {
    return this.numberClass;
  };
  protoOf(PrimitiveClasses).kb = function () {
    return this.nothingClass;
  };
  protoOf(PrimitiveClasses).lb = function () {
    return this.booleanClass;
  };
  protoOf(PrimitiveClasses).mb = function () {
    return this.byteClass;
  };
  protoOf(PrimitiveClasses).nb = function () {
    return this.shortClass;
  };
  protoOf(PrimitiveClasses).ob = function () {
    return this.intClass;
  };
  protoOf(PrimitiveClasses).pb = function () {
    return this.longClass;
  };
  protoOf(PrimitiveClasses).qb = function () {
    return this.floatClass;
  };
  protoOf(PrimitiveClasses).rb = function () {
    return this.doubleClass;
  };
  protoOf(PrimitiveClasses).sb = function () {
    return this.arrayClass;
  };
  protoOf(PrimitiveClasses).tb = function () {
    return this.stringClass;
  };
  protoOf(PrimitiveClasses).ub = function () {
    return this.throwableClass;
  };
  protoOf(PrimitiveClasses).vb = function () {
    return this.booleanArrayClass;
  };
  protoOf(PrimitiveClasses).wb = function () {
    return this.charArrayClass;
  };
  protoOf(PrimitiveClasses).xb = function () {
    return this.byteArrayClass;
  };
  protoOf(PrimitiveClasses).yb = function () {
    return this.shortArrayClass;
  };
  protoOf(PrimitiveClasses).zb = function () {
    return this.intArrayClass;
  };
  protoOf(PrimitiveClasses).ac = function () {
    return this.longArrayClass;
  };
  protoOf(PrimitiveClasses).bc = function () {
    return this.floatArrayClass;
  };
  protoOf(PrimitiveClasses).cc = function () {
    return this.doubleArrayClass;
  };
  protoOf(PrimitiveClasses).functionClass = function (arity) {
    var tmp0_elvis_lhs = get_functionClasses()[arity];
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.run' call
      // Inline function 'kotlin.js.unsafeCast' call
      var tmp_0 = Function;
      var tmp_1 = 'Function' + arity;
      var result = new PrimitiveKClassImpl(tmp_0, tmp_1, PrimitiveClasses$functionClass$lambda(arity));
      // Inline function 'kotlin.js.asDynamic' call
      get_functionClasses()[arity] = result;
      tmp = result;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  var PrimitiveClasses_instance;
  function PrimitiveClasses_getInstance() {
    if (PrimitiveClasses_instance == null)
      new PrimitiveClasses();
    return PrimitiveClasses_instance;
  }
  var properties_initialized_primitives_kt_jle18u;
  function _init_properties_primitives_kt__3fums4() {
    if (!properties_initialized_primitives_kt_jle18u) {
      properties_initialized_primitives_kt_jle18u = true;
      // Inline function 'kotlin.arrayOfNulls' call
      functionClasses = Array(0);
    }
  }
  function getKClass(jClass) {
    if (jClass === String) {
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      return PrimitiveClasses_getInstance().stringClass;
    }
    // Inline function 'kotlin.js.asDynamic' call
    var metadata = jClass.$metadata$;
    var tmp;
    if (metadata != null) {
      var tmp_0;
      if (metadata.$kClass$ == null) {
        var kClass = new SimpleKClassImpl(jClass);
        metadata.$kClass$ = kClass;
        tmp_0 = kClass;
      } else {
        tmp_0 = metadata.$kClass$;
      }
      tmp = tmp_0;
    } else {
      tmp = new SimpleKClassImpl(jClass);
    }
    return tmp;
  }
  function getKClassFromExpression(e) {
    var tmp;
    switch (typeof e) {
      case 'string':
        tmp = PrimitiveClasses_getInstance().stringClass;
        break;
      case 'number':
        var tmp_0;
        // Inline function 'kotlin.js.jsBitwiseOr' call

        // Inline function 'kotlin.js.asDynamic' call

        if ((e | 0) === e) {
          tmp_0 = PrimitiveClasses_getInstance().intClass;
        } else {
          tmp_0 = PrimitiveClasses_getInstance().doubleClass;
        }

        tmp = tmp_0;
        break;
      case 'boolean':
        tmp = PrimitiveClasses_getInstance().booleanClass;
        break;
      case 'function':
        var tmp_1 = PrimitiveClasses_getInstance();
        // Inline function 'kotlin.js.asDynamic' call

        tmp = tmp_1.functionClass(e.length);
        break;
      default:
        var tmp_2;
        if (isBooleanArray(e)) {
          tmp_2 = PrimitiveClasses_getInstance().booleanArrayClass;
        } else {
          if (isCharArray(e)) {
            tmp_2 = PrimitiveClasses_getInstance().charArrayClass;
          } else {
            if (isByteArray(e)) {
              tmp_2 = PrimitiveClasses_getInstance().byteArrayClass;
            } else {
              if (isShortArray(e)) {
                tmp_2 = PrimitiveClasses_getInstance().shortArrayClass;
              } else {
                if (isIntArray(e)) {
                  tmp_2 = PrimitiveClasses_getInstance().intArrayClass;
                } else {
                  if (isLongArray(e)) {
                    tmp_2 = PrimitiveClasses_getInstance().longArrayClass;
                  } else {
                    if (isFloatArray(e)) {
                      tmp_2 = PrimitiveClasses_getInstance().floatArrayClass;
                    } else {
                      if (isDoubleArray(e)) {
                        tmp_2 = PrimitiveClasses_getInstance().doubleArrayClass;
                      } else {
                        if (isInterface(e, KClass)) {
                          tmp_2 = getKClass(KClass);
                        } else {
                          if (isArray(e)) {
                            tmp_2 = PrimitiveClasses_getInstance().arrayClass;
                          } else {
                            var constructor = Object.getPrototypeOf(e).constructor;
                            var tmp_3;
                            if (constructor === Object) {
                              tmp_3 = PrimitiveClasses_getInstance().anyClass;
                            } else if (constructor === Error) {
                              tmp_3 = PrimitiveClasses_getInstance().throwableClass;
                            } else {
                              var jsClass = constructor;
                              tmp_3 = getKClass(jsClass);
                            }
                            tmp_2 = tmp_3;
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }

        tmp = tmp_2;
        break;
    }
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return tmp;
  }
  function findAssociatedObject(_this__u8e3s4, annotationClass) {
    var tmp;
    var tmp_0;
    if (_this__u8e3s4 instanceof KClassImpl) {
      tmp_0 = annotationClass instanceof KClassImpl;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$0 = annotationClass.qa();
      var tmp0_elvis_lhs = getAssociatedObjectId(tmp$ret$0);
      var tmp_1;
      if (tmp0_elvis_lhs == null) {
        return null;
      } else {
        tmp_1 = tmp0_elvis_lhs;
      }
      var key = tmp_1;
      // Inline function 'kotlin.js.asDynamic' call
      var tmp1_safe_receiver = _this__u8e3s4.qa().$metadata$;
      var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.associatedObjects;
      var tmp_2;
      if (tmp2_elvis_lhs == null) {
        return null;
      } else {
        tmp_2 = tmp2_elvis_lhs;
      }
      var map = tmp_2;
      var tmp3_elvis_lhs = map[key];
      var tmp_3;
      if (tmp3_elvis_lhs == null) {
        return null;
      } else {
        tmp_3 = tmp3_elvis_lhs;
      }
      var factory = tmp_3;
      return factory();
    } else {
      tmp = null;
    }
    return tmp;
  }
  function getAssociatedObjectId(annotationClass) {
    var tmp0_safe_receiver = annotationClass.$metadata$;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.associatedObjectKey;
    var tmp;
    if (tmp1_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.js.unsafeCast' call
      tmp = tmp1_safe_receiver;
    }
    return tmp;
  }
  function reset_0(_this__u8e3s4) {
    _this__u8e3s4.lastIndex = 0;
  }
  function ConstrainedOnceSequence(sequence) {
    this.dc_1 = sequence;
  }
  protoOf(ConstrainedOnceSequence).m = function () {
    var tmp0_elvis_lhs = this.dc_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalStateException_init_$Create$_0('This sequence can be consumed only once.');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var sequence = tmp;
    this.dc_1 = null;
    return sequence.m();
  };
  function CharacterCodingException_init_$Init$($this) {
    CharacterCodingException.call($this, null);
    return $this;
  }
  function CharacterCodingException_init_$Create$() {
    var tmp = CharacterCodingException_init_$Init$(objectCreate(protoOf(CharacterCodingException)));
    captureStack(tmp, CharacterCodingException_init_$Create$);
    return tmp;
  }
  function CharacterCodingException(message) {
    Exception_init_$Init$_0(message, this);
    captureStack(this, CharacterCodingException);
  }
  function StringBuilder_init_$Init$(capacity, $this) {
    StringBuilder_init_$Init$_1($this);
    return $this;
  }
  function StringBuilder_init_$Create$(capacity) {
    return StringBuilder_init_$Init$(capacity, objectCreate(protoOf(StringBuilder)));
  }
  function StringBuilder_init_$Init$_0(content, $this) {
    StringBuilder.call($this, toString_1(content));
    return $this;
  }
  function StringBuilder_init_$Create$_0(content) {
    return StringBuilder_init_$Init$_0(content, objectCreate(protoOf(StringBuilder)));
  }
  function StringBuilder_init_$Init$_1($this) {
    StringBuilder.call($this, '');
    return $this;
  }
  function StringBuilder_init_$Create$_1() {
    return StringBuilder_init_$Init$_1(objectCreate(protoOf(StringBuilder)));
  }
  function StringBuilder(content) {
    this.k1_1 = content;
  }
  protoOf(StringBuilder).a = function () {
    // Inline function 'kotlin.js.asDynamic' call
    return this.k1_1.length;
  };
  protoOf(StringBuilder).b = function (index) {
    // Inline function 'kotlin.text.getOrElse' call
    var this_0 = this.k1_1;
    var tmp;
    if (0 <= index ? index <= (charSequenceLength(this_0) - 1 | 0) : false) {
      tmp = charSequenceGet(this_0, index);
    } else {
      throw IndexOutOfBoundsException_init_$Create$_0('index: ' + index + ', length: ' + this.a() + '}');
    }
    return tmp;
  };
  protoOf(StringBuilder).c = function (startIndex, endIndex) {
    return substring(this.k1_1, startIndex, endIndex);
  };
  protoOf(StringBuilder).k8 = function (value) {
    this.k1_1 = this.k1_1 + toString(value);
    return this;
  };
  protoOf(StringBuilder).k = function (value) {
    this.k1_1 = this.k1_1 + toString_0(value);
    return this;
  };
  protoOf(StringBuilder).ec = function (value, startIndex, endIndex) {
    return this.fc(value == null ? 'null' : value, startIndex, endIndex);
  };
  protoOf(StringBuilder).l1 = function () {
    var reversed = '';
    var index = this.k1_1.length - 1 | 0;
    while (index >= 0) {
      var tmp = this.k1_1;
      var _unary__edvuaz = index;
      index = _unary__edvuaz - 1 | 0;
      var low = charCodeAt(tmp, _unary__edvuaz);
      if (isLowSurrogate(low) && index >= 0) {
        var tmp_0 = this.k1_1;
        var _unary__edvuaz_0 = index;
        index = _unary__edvuaz_0 - 1 | 0;
        var high = charCodeAt(tmp_0, _unary__edvuaz_0);
        if (isHighSurrogate(high)) {
          reversed = reversed + new Char(high) + toString(low);
        } else {
          reversed = reversed + new Char(low) + toString(high);
        }
      } else {
        reversed = reversed + toString(low);
      }
    }
    this.k1_1 = reversed;
    return this;
  };
  protoOf(StringBuilder).i8 = function (value) {
    this.k1_1 = this.k1_1 + toString_0(value);
    return this;
  };
  protoOf(StringBuilder).gc = function (value) {
    return this.j8(value.toString());
  };
  protoOf(StringBuilder).hc = function (value) {
    return this.j8(value.toString());
  };
  protoOf(StringBuilder).j8 = function (value) {
    var tmp = this;
    var tmp_0 = this.k1_1;
    tmp.k1_1 = tmp_0 + (value == null ? 'null' : value);
    return this;
  };
  protoOf(StringBuilder).ic = function (index, value) {
    Companion_instance_6.q4(index, this.a());
    this.k1_1 = substring(this.k1_1, 0, index) + toString(value) + substring_0(this.k1_1, index);
    return this;
  };
  protoOf(StringBuilder).jc = function (index, value) {
    Companion_instance_6.q4(index, this.a());
    var toInsert = value == null ? 'null' : value;
    this.k1_1 = substring(this.k1_1, 0, index) + toInsert + substring_0(this.k1_1, index);
    return this;
  };
  protoOf(StringBuilder).kc = function (newLength) {
    if (newLength < 0) {
      throw IllegalArgumentException_init_$Create$_0('Negative new length: ' + newLength + '.');
    }
    if (newLength <= this.a()) {
      this.k1_1 = substring(this.k1_1, 0, newLength);
    } else {
      var inductionVariable = this.a();
      if (inductionVariable < newLength)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          this.k1_1 = this.k1_1 + toString(_Char___init__impl__6a9atx(0));
        }
         while (inductionVariable < newLength);
    }
  };
  protoOf(StringBuilder).lc = function (startIndex) {
    Companion_instance_6.q4(startIndex, this.a());
    return substring_0(this.k1_1, startIndex);
  };
  protoOf(StringBuilder).toString = function () {
    return this.k1_1;
  };
  protoOf(StringBuilder).mc = function () {
    this.k1_1 = '';
    return this;
  };
  protoOf(StringBuilder).nc = function (index) {
    Companion_instance_6.b4(index, this.a());
    this.k1_1 = substring(this.k1_1, 0, index) + substring_0(this.k1_1, index + 1 | 0);
    return this;
  };
  protoOf(StringBuilder).fc = function (value, startIndex, endIndex) {
    var stringCsq = toString_1(value);
    Companion_instance_6.oc(startIndex, endIndex, stringCsq.length);
    this.k1_1 = this.k1_1 + substring(stringCsq, startIndex, endIndex);
    return this;
  };
  function uppercaseChar(_this__u8e3s4) {
    // Inline function 'kotlin.text.uppercase' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.js.unsafeCast' call
    var uppercase = toString(_this__u8e3s4).toUpperCase();
    return uppercase.length > 1 ? _this__u8e3s4 : charCodeAt(uppercase, 0);
  }
  function isLowSurrogate(_this__u8e3s4) {
    return _Char___init__impl__6a9atx(56320) <= _this__u8e3s4 ? _this__u8e3s4 <= _Char___init__impl__6a9atx(57343) : false;
  }
  function isHighSurrogate(_this__u8e3s4) {
    return _Char___init__impl__6a9atx(55296) <= _this__u8e3s4 ? _this__u8e3s4 <= _Char___init__impl__6a9atx(56319) : false;
  }
  function isWhitespace(_this__u8e3s4) {
    return isWhitespaceImpl(_this__u8e3s4);
  }
  function isLowerCase(_this__u8e3s4) {
    if (_Char___init__impl__6a9atx(97) <= _this__u8e3s4 ? _this__u8e3s4 <= _Char___init__impl__6a9atx(122) : false) {
      return true;
    }
    if (Char__compareTo_impl_ypi4mb(_this__u8e3s4, _Char___init__impl__6a9atx(128)) < 0) {
      return false;
    }
    return isLowerCaseImpl(_this__u8e3s4);
  }
  function titlecaseChar(_this__u8e3s4) {
    return titlecaseCharImpl(_this__u8e3s4);
  }
  function toString_2(_this__u8e3s4, radix) {
    return toStringImpl_0(_this__u8e3s4, checkRadix(radix));
  }
  function checkRadix(radix) {
    if (!(2 <= radix ? radix <= 36 : false)) {
      throw IllegalArgumentException_init_$Create$_0('radix ' + radix + ' was not in valid range 2..36');
    }
    return radix;
  }
  function toInt(_this__u8e3s4) {
    var tmp0_elvis_lhs = toIntOrNull(_this__u8e3s4);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      numberFormatError(_this__u8e3s4);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function toString_3(_this__u8e3s4, radix) {
    // Inline function 'kotlin.js.asDynamic' call
    return _this__u8e3s4.toString(checkRadix(radix));
  }
  function toLong(_this__u8e3s4) {
    var tmp0_elvis_lhs = toLongOrNull(_this__u8e3s4);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      numberFormatError(_this__u8e3s4);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function toBoolean(_this__u8e3s4) {
    var tmp;
    if (!(_this__u8e3s4 == null)) {
      // Inline function 'kotlin.text.lowercase' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = _this__u8e3s4.toLowerCase() === 'true';
    } else {
      tmp = false;
    }
    return tmp;
  }
  function toInt_0(_this__u8e3s4, radix) {
    var tmp0_elvis_lhs = toIntOrNull_0(_this__u8e3s4, radix);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      numberFormatError(_this__u8e3s4);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function toDouble(_this__u8e3s4) {
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.also' call
    var this_0 = +_this__u8e3s4;
    if (isNaN_0(this_0) && !isNaN_2(_this__u8e3s4) || (this_0 === 0.0 && isBlank(_this__u8e3s4))) {
      numberFormatError(_this__u8e3s4);
    }
    return this_0;
  }
  function toLong_0(_this__u8e3s4, radix) {
    var tmp0_elvis_lhs = toLongOrNull_0(_this__u8e3s4, radix);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      numberFormatError(_this__u8e3s4);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function toDoubleOrNull(_this__u8e3s4) {
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.takeIf' call
    var this_0 = +_this__u8e3s4;
    var tmp;
    if (!(isNaN_0(this_0) && !isNaN_2(_this__u8e3s4) || (this_0 === 0.0 && isBlank(_this__u8e3s4)))) {
      tmp = this_0;
    } else {
      tmp = null;
    }
    return tmp;
  }
  function digitOf(char, radix) {
    // Inline function 'kotlin.let' call
    var it = Char__compareTo_impl_ypi4mb(char, _Char___init__impl__6a9atx(48)) >= 0 && Char__compareTo_impl_ypi4mb(char, _Char___init__impl__6a9atx(57)) <= 0 ? Char__minus_impl_a2frrh(char, _Char___init__impl__6a9atx(48)) : Char__compareTo_impl_ypi4mb(char, _Char___init__impl__6a9atx(65)) >= 0 && Char__compareTo_impl_ypi4mb(char, _Char___init__impl__6a9atx(90)) <= 0 ? Char__minus_impl_a2frrh(char, _Char___init__impl__6a9atx(65)) + 10 | 0 : Char__compareTo_impl_ypi4mb(char, _Char___init__impl__6a9atx(97)) >= 0 && Char__compareTo_impl_ypi4mb(char, _Char___init__impl__6a9atx(122)) <= 0 ? Char__minus_impl_a2frrh(char, _Char___init__impl__6a9atx(97)) + 10 | 0 : Char__compareTo_impl_ypi4mb(char, _Char___init__impl__6a9atx(128)) < 0 ? -1 : Char__compareTo_impl_ypi4mb(char, _Char___init__impl__6a9atx(65313)) >= 0 && Char__compareTo_impl_ypi4mb(char, _Char___init__impl__6a9atx(65338)) <= 0 ? Char__minus_impl_a2frrh(char, _Char___init__impl__6a9atx(65313)) + 10 | 0 : Char__compareTo_impl_ypi4mb(char, _Char___init__impl__6a9atx(65345)) >= 0 && Char__compareTo_impl_ypi4mb(char, _Char___init__impl__6a9atx(65370)) <= 0 ? Char__minus_impl_a2frrh(char, _Char___init__impl__6a9atx(65345)) + 10 | 0 : digitToIntImpl(char);
    return it >= radix ? -1 : it;
  }
  function isNaN_2(_this__u8e3s4) {
    // Inline function 'kotlin.text.lowercase' call
    // Inline function 'kotlin.js.asDynamic' call
    switch (_this__u8e3s4.toLowerCase()) {
      case 'nan':
      case '+nan':
      case '-nan':
        return true;
      default:
        return false;
    }
  }
  function Regex_init_$Init$(pattern, $this) {
    Regex.call($this, pattern, emptySet());
    return $this;
  }
  function Regex_init_$Create$(pattern) {
    return Regex_init_$Init$(pattern, objectCreate(protoOf(Regex)));
  }
  function Companion_5() {
    Companion_instance_5 = this;
    this.pc_1 = new RegExp('[\\\\^$*+?.()|[\\]{}]', 'g');
    this.qc_1 = new RegExp('[\\\\$]', 'g');
    this.rc_1 = new RegExp('\\$', 'g');
  }
  protoOf(Companion_5).sc = function (literal) {
    // Inline function 'kotlin.text.nativeReplace' call
    var pattern = this.pc_1;
    // Inline function 'kotlin.js.asDynamic' call
    return literal.replace(pattern, '\\$&');
  };
  protoOf(Companion_5).tc = function (literal) {
    // Inline function 'kotlin.text.nativeReplace' call
    var pattern = this.rc_1;
    // Inline function 'kotlin.js.asDynamic' call
    return literal.replace(pattern, '$$$$');
  };
  var Companion_instance_5;
  function Companion_getInstance_5() {
    if (Companion_instance_5 == null)
      new Companion_5();
    return Companion_instance_5;
  }
  function Regex$findAll$lambda(this$0, $input, $startIndex) {
    return function () {
      return this$0.zc($input, $startIndex);
    };
  }
  function Regex$findAll$lambda_0(match) {
    return match.o();
  }
  function Regex$replace$lambda($replacement) {
    return function (it) {
      return substituteGroupRefs(it, $replacement);
    };
  }
  function Regex(pattern, options) {
    Companion_getInstance_5();
    this.uc_1 = pattern;
    this.vc_1 = toSet_0(options);
    this.wc_1 = new RegExp(pattern, toFlags(options, 'gu'));
    this.xc_1 = null;
    this.yc_1 = null;
  }
  protoOf(Regex).ad = function (input) {
    reset_0(this.wc_1);
    var match = this.wc_1.exec(toString_1(input));
    return !(match == null) && match.index === 0 && this.wc_1.lastIndex === charSequenceLength(input);
  };
  protoOf(Regex).bd = function (input) {
    reset_0(this.wc_1);
    return this.wc_1.test(toString_1(input));
  };
  protoOf(Regex).zc = function (input, startIndex) {
    if (startIndex < 0 || startIndex > charSequenceLength(input)) {
      throw IndexOutOfBoundsException_init_$Create$_0('Start index out of bounds: ' + startIndex + ', input length: ' + charSequenceLength(input));
    }
    return findNext(this.wc_1, toString_1(input), startIndex, this.wc_1);
  };
  protoOf(Regex).cd = function (input, startIndex, $super) {
    startIndex = startIndex === VOID ? 0 : startIndex;
    return $super === VOID ? this.zc(input, startIndex) : $super.zc.call(this, input, startIndex);
  };
  protoOf(Regex).dd = function (input, startIndex) {
    if (startIndex < 0 || startIndex > charSequenceLength(input)) {
      throw IndexOutOfBoundsException_init_$Create$_0('Start index out of bounds: ' + startIndex + ', input length: ' + charSequenceLength(input));
    }
    var tmp = Regex$findAll$lambda(this, input, startIndex);
    return generateSequence_0(tmp, Regex$findAll$lambda_0);
  };
  protoOf(Regex).ed = function (input, startIndex, $super) {
    startIndex = startIndex === VOID ? 0 : startIndex;
    return $super === VOID ? this.dd(input, startIndex) : $super.dd.call(this, input, startIndex);
  };
  protoOf(Regex).fd = function (input, replacement) {
    if (!contains_9(replacement, _Char___init__impl__6a9atx(92)) && !contains_9(replacement, _Char___init__impl__6a9atx(36))) {
      var tmp0 = toString_1(input);
      // Inline function 'kotlin.text.nativeReplace' call
      var pattern = this.wc_1;
      // Inline function 'kotlin.js.asDynamic' call
      return tmp0.replace(pattern, replacement);
    }
    return this.gd(input, Regex$replace$lambda(replacement));
  };
  protoOf(Regex).gd = function (input, transform) {
    var match = this.cd(input);
    if (match == null)
      return toString_1(input);
    var lastStart = 0;
    var length = charSequenceLength(input);
    var sb = StringBuilder_init_$Create$(length);
    do {
      var foundMatch = ensureNotNull(match);
      sb.ec(input, lastStart, foundMatch.hd().p1());
      sb.k(transform(foundMatch));
      lastStart = foundMatch.hd().q1() + 1 | 0;
      match = foundMatch.o();
    }
     while (lastStart < length && !(match == null));
    if (lastStart < length) {
      sb.ec(input, lastStart, length);
    }
    return sb.toString();
  };
  protoOf(Regex).id = function (input, limit) {
    requireNonNegativeLimit(limit);
    // Inline function 'kotlin.let' call
    var it = this.ed(input);
    var matches = limit === 0 ? it : take_0(it, limit - 1 | 0);
    // Inline function 'kotlin.collections.mutableListOf' call
    var result = ArrayList_init_$Create$();
    var lastStart = 0;
    var _iterator__ex2g4s = matches.m();
    while (_iterator__ex2g4s.n()) {
      var match = _iterator__ex2g4s.o();
      result.j(toString_1(charSequenceSubSequence(input, lastStart, match.hd().p1())));
      lastStart = match.hd().q1() + 1 | 0;
    }
    result.j(toString_1(charSequenceSubSequence(input, lastStart, charSequenceLength(input))));
    return result;
  };
  protoOf(Regex).toString = function () {
    return this.wc_1.toString();
  };
  function MatchGroup(value) {
    this.jd_1 = value;
  }
  protoOf(MatchGroup).toString = function () {
    return 'MatchGroup(value=' + this.jd_1 + ')';
  };
  protoOf(MatchGroup).hashCode = function () {
    return getStringHashCode(this.jd_1);
  };
  protoOf(MatchGroup).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof MatchGroup))
      return false;
    if (!(this.jd_1 === other.jd_1))
      return false;
    return true;
  };
  function toFlags(_this__u8e3s4, prepend) {
    return joinToString_0(_this__u8e3s4, '', prepend, VOID, VOID, VOID, toFlags$lambda);
  }
  function findNext(_this__u8e3s4, input, from, nextPattern) {
    _this__u8e3s4.lastIndex = from;
    var match = _this__u8e3s4.exec(input);
    if (match == null)
      return null;
    var range = numberRangeToNumber(match.index, _this__u8e3s4.lastIndex - 1 | 0);
    return new findNext$1(range, match, nextPattern, input);
  }
  function substituteGroupRefs(match, replacement) {
    var index = 0;
    var result = StringBuilder_init_$Create$_1();
    while (index < replacement.length) {
      var _unary__edvuaz = index;
      index = _unary__edvuaz + 1 | 0;
      var char = charCodeAt(replacement, _unary__edvuaz);
      if (char === _Char___init__impl__6a9atx(92)) {
        if (index === replacement.length)
          throw IllegalArgumentException_init_$Create$_0('The Char to be escaped is missing');
        var _unary__edvuaz_0 = index;
        index = _unary__edvuaz_0 + 1 | 0;
        result.k8(charCodeAt(replacement, _unary__edvuaz_0));
      } else if (char === _Char___init__impl__6a9atx(36)) {
        if (index === replacement.length)
          throw IllegalArgumentException_init_$Create$_0('Capturing group index is missing');
        if (charCodeAt(replacement, index) === _Char___init__impl__6a9atx(123)) {
          index = index + 1 | 0;
          var endIndex = readGroupName(replacement, index);
          if (index === endIndex)
            throw IllegalArgumentException_init_$Create$_0('Named capturing group reference should have a non-empty name');
          if (endIndex === replacement.length || !(charCodeAt(replacement, endIndex) === _Char___init__impl__6a9atx(125)))
            throw IllegalArgumentException_init_$Create$_0("Named capturing group reference is missing trailing '}'");
          var groupName = substring(replacement, index, endIndex);
          var tmp0_safe_receiver = get_3(match.kd(), groupName);
          var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.jd_1;
          result.j8(tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs);
          index = endIndex + 1 | 0;
        } else {
          var containsArg = charCodeAt(replacement, index);
          if (!(_Char___init__impl__6a9atx(48) <= containsArg ? containsArg <= _Char___init__impl__6a9atx(57) : false))
            throw IllegalArgumentException_init_$Create$_0('Invalid capturing group reference');
          var groups = match.kd();
          var endIndex_0 = readGroupIndex(replacement, index, groups.p());
          var groupIndex = toInt(substring(replacement, index, endIndex_0));
          if (groupIndex >= groups.p())
            throw IndexOutOfBoundsException_init_$Create$_0('Group with index ' + groupIndex + ' does not exist');
          var tmp2_safe_receiver = groups.r(groupIndex);
          var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.jd_1;
          result.j8(tmp3_elvis_lhs == null ? '' : tmp3_elvis_lhs);
          index = endIndex_0;
        }
      } else {
        result.k8(char);
      }
    }
    return result.toString();
  }
  function readGroupName(_this__u8e3s4, startIndex) {
    var index = startIndex;
    $l$loop: while (index < _this__u8e3s4.length) {
      if (charCodeAt(_this__u8e3s4, index) === _Char___init__impl__6a9atx(125)) {
        break $l$loop;
      } else {
        index = index + 1 | 0;
      }
    }
    return index;
  }
  function get_3(_this__u8e3s4, name) {
    var tmp0_elvis_lhs = isInterface(_this__u8e3s4, MatchNamedGroupCollection) ? _this__u8e3s4 : null;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw UnsupportedOperationException_init_$Create$_0('Retrieving groups by name is not supported on this platform.');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var namedGroups = tmp;
    return namedGroups.ld(name);
  }
  function readGroupIndex(_this__u8e3s4, startIndex, groupCount) {
    var index = startIndex + 1 | 0;
    var groupIndex = Char__minus_impl_a2frrh(charCodeAt(_this__u8e3s4, startIndex), _Char___init__impl__6a9atx(48));
    $l$loop_0: while (true) {
      var tmp;
      if (index < _this__u8e3s4.length) {
        var containsArg = charCodeAt(_this__u8e3s4, index);
        tmp = _Char___init__impl__6a9atx(48) <= containsArg ? containsArg <= _Char___init__impl__6a9atx(57) : false;
      } else {
        tmp = false;
      }
      if (!tmp) {
        break $l$loop_0;
      }
      var newGroupIndex = imul(groupIndex, 10) + Char__minus_impl_a2frrh(charCodeAt(_this__u8e3s4, index), _Char___init__impl__6a9atx(48)) | 0;
      if (0 <= newGroupIndex ? newGroupIndex < groupCount : false) {
        groupIndex = newGroupIndex;
        index = index + 1 | 0;
      } else {
        break $l$loop_0;
      }
    }
    return index;
  }
  function toFlags$lambda(it) {
    return it.od_1;
  }
  function findNext$o$groups$o$iterator$lambda(this$0) {
    return function (it) {
      return this$0.r(it);
    };
  }
  function hasOwnPrototypeProperty($this, o, name) {
    // Inline function 'kotlin.js.unsafeCast' call
    return Object.prototype.hasOwnProperty.call(o, name);
  }
  function advanceToNextCharacter($this, index) {
    if (index < get_lastIndex_3($this.xd_1)) {
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.unsafeCast' call
      var code1 = $this.xd_1.charCodeAt(index);
      if (55296 <= code1 ? code1 <= 56319 : false) {
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.unsafeCast' call
        var code2 = $this.xd_1.charCodeAt(index + 1 | 0);
        if (56320 <= code2 ? code2 <= 57343 : false) {
          return index + 2 | 0;
        }
      }
    }
    return index + 1 | 0;
  }
  function findNext$1$groups$1($match, this$0) {
    this.pd_1 = $match;
    this.qd_1 = this$0;
    AbstractCollection.call(this);
  }
  protoOf(findNext$1$groups$1).p = function () {
    return this.pd_1.length;
  };
  protoOf(findNext$1$groups$1).m = function () {
    var tmp = asSequence_0(get_indices_1(this));
    return map(tmp, findNext$o$groups$o$iterator$lambda(this)).m();
  };
  protoOf(findNext$1$groups$1).r = function (index) {
    // Inline function 'kotlin.js.get' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp0_safe_receiver = this.pd_1[index];
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp = new MatchGroup(tmp0_safe_receiver);
    }
    return tmp;
  };
  protoOf(findNext$1$groups$1).ld = function (name) {
    // Inline function 'kotlin.js.asDynamic' call
    var tmp0_elvis_lhs = this.pd_1.groups;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalArgumentException_init_$Create$_0('Capturing group with name {' + name + '} does not exist. No named capturing group was defined in Regex');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var groups = tmp;
    if (!hasOwnPrototypeProperty(this.qd_1, groups, name))
      throw IllegalArgumentException_init_$Create$_0('Capturing group with name {' + name + '} does not exist');
    var value = groups[name];
    var tmp_0;
    if (value == undefined) {
      tmp_0 = null;
    } else {
      tmp_0 = new MatchGroup((!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
    }
    return tmp_0;
  };
  function findNext$1($range, $match, $nextPattern, $input) {
    this.ud_1 = $range;
    this.vd_1 = $match;
    this.wd_1 = $nextPattern;
    this.xd_1 = $input;
    this.rd_1 = $range;
    var tmp = this;
    tmp.sd_1 = new findNext$1$groups$1($match, this);
    this.td_1 = null;
  }
  protoOf(findNext$1).hd = function () {
    return this.rd_1;
  };
  protoOf(findNext$1).a1 = function () {
    // Inline function 'kotlin.js.get' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = this.vd_1[0];
    return ensureNotNull(tmp$ret$1);
  };
  protoOf(findNext$1).kd = function () {
    return this.sd_1;
  };
  protoOf(findNext$1).o = function () {
    return findNext(this.wd_1, this.xd_1, this.ud_1.s() ? advanceToNextCharacter(this, this.ud_1.p1()) : this.ud_1.q1() + 1 | 0, this.wd_1);
  };
  function get_STRING_CASE_INSENSITIVE_ORDER() {
    _init_properties_stringJs_kt__bg7zye();
    return STRING_CASE_INSENSITIVE_ORDER;
  }
  var STRING_CASE_INSENSITIVE_ORDER;
  function substring(_this__u8e3s4, startIndex, endIndex) {
    _init_properties_stringJs_kt__bg7zye();
    // Inline function 'kotlin.js.asDynamic' call
    return _this__u8e3s4.substring(startIndex, endIndex);
  }
  function substring_0(_this__u8e3s4, startIndex) {
    _init_properties_stringJs_kt__bg7zye();
    // Inline function 'kotlin.js.asDynamic' call
    return _this__u8e3s4.substring(startIndex);
  }
  function compareTo_1(_this__u8e3s4, other, ignoreCase) {
    ignoreCase = ignoreCase === VOID ? false : ignoreCase;
    _init_properties_stringJs_kt__bg7zye();
    if (ignoreCase) {
      var n1 = _this__u8e3s4.length;
      var n2 = other.length;
      // Inline function 'kotlin.comparisons.minOf' call
      var min = Math.min(n1, n2);
      if (min === 0)
        return n1 - n2 | 0;
      var inductionVariable = 0;
      if (inductionVariable < min)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var thisChar = charCodeAt(_this__u8e3s4, index);
          var otherChar = charCodeAt(other, index);
          if (!(thisChar === otherChar)) {
            thisChar = uppercaseChar(thisChar);
            otherChar = uppercaseChar(otherChar);
            if (!(thisChar === otherChar)) {
              // Inline function 'kotlin.text.lowercaseChar' call
              // Inline function 'kotlin.text.lowercase' call
              var this_0 = thisChar;
              // Inline function 'kotlin.js.asDynamic' call
              // Inline function 'kotlin.js.unsafeCast' call
              var tmp$ret$3 = toString(this_0).toLowerCase();
              thisChar = charCodeAt(tmp$ret$3, 0);
              // Inline function 'kotlin.text.lowercaseChar' call
              // Inline function 'kotlin.text.lowercase' call
              var this_1 = otherChar;
              // Inline function 'kotlin.js.asDynamic' call
              // Inline function 'kotlin.js.unsafeCast' call
              var tmp$ret$7 = toString(this_1).toLowerCase();
              otherChar = charCodeAt(tmp$ret$7, 0);
              if (!(thisChar === otherChar)) {
                return Char__compareTo_impl_ypi4mb(thisChar, otherChar);
              }
            }
          }
        }
         while (inductionVariable < min);
      return n1 - n2 | 0;
    } else {
      return compareTo_0(_this__u8e3s4, other);
    }
  }
  function concatToString(_this__u8e3s4) {
    _init_properties_stringJs_kt__bg7zye();
    var result = '';
    var inductionVariable = 0;
    var last = _this__u8e3s4.length;
    while (inductionVariable < last) {
      var char = _this__u8e3s4[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      result = result + toString(char);
    }
    return result;
  }
  function concatToString_0(_this__u8e3s4, startIndex, endIndex) {
    startIndex = startIndex === VOID ? 0 : startIndex;
    endIndex = endIndex === VOID ? _this__u8e3s4.length : endIndex;
    _init_properties_stringJs_kt__bg7zye();
    Companion_instance_6.oc(startIndex, endIndex, _this__u8e3s4.length);
    var result = '';
    var inductionVariable = startIndex;
    if (inductionVariable < endIndex)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        result = result + toString(_this__u8e3s4[index]);
      }
       while (inductionVariable < endIndex);
    return result;
  }
  function encodeToByteArray(_this__u8e3s4) {
    _init_properties_stringJs_kt__bg7zye();
    return encodeUtf8(_this__u8e3s4, 0, _this__u8e3s4.length, false);
  }
  function get_CASE_INSENSITIVE_ORDER(_this__u8e3s4) {
    _init_properties_stringJs_kt__bg7zye();
    return get_STRING_CASE_INSENSITIVE_ORDER();
  }
  function decodeToString(_this__u8e3s4) {
    _init_properties_stringJs_kt__bg7zye();
    return decodeUtf8(_this__u8e3s4, 0, _this__u8e3s4.length, false);
  }
  function decodeToString_0(_this__u8e3s4, startIndex, endIndex, throwOnInvalidSequence) {
    startIndex = startIndex === VOID ? 0 : startIndex;
    endIndex = endIndex === VOID ? _this__u8e3s4.length : endIndex;
    throwOnInvalidSequence = throwOnInvalidSequence === VOID ? false : throwOnInvalidSequence;
    _init_properties_stringJs_kt__bg7zye();
    Companion_instance_6.oc(startIndex, endIndex, _this__u8e3s4.length);
    return decodeUtf8(_this__u8e3s4, startIndex, endIndex, throwOnInvalidSequence);
  }
  function sam$kotlin_Comparator$0(function_0) {
    this.yd_1 = function_0;
  }
  protoOf(sam$kotlin_Comparator$0).zd = function (a, b) {
    return this.yd_1(a, b);
  };
  protoOf(sam$kotlin_Comparator$0).compare = function (a, b) {
    return this.zd(a, b);
  };
  protoOf(sam$kotlin_Comparator$0).f3 = function () {
    return this.yd_1;
  };
  protoOf(sam$kotlin_Comparator$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Comparator) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlin_Comparator$0).hashCode = function () {
    return hashCode(this.f3());
  };
  function STRING_CASE_INSENSITIVE_ORDER$lambda(a, b) {
    _init_properties_stringJs_kt__bg7zye();
    return compareTo_1(a, b, true);
  }
  var properties_initialized_stringJs_kt_nta8o4;
  function _init_properties_stringJs_kt__bg7zye() {
    if (!properties_initialized_stringJs_kt_nta8o4) {
      properties_initialized_stringJs_kt_nta8o4 = true;
      var tmp = STRING_CASE_INSENSITIVE_ORDER$lambda;
      STRING_CASE_INSENSITIVE_ORDER = new sam$kotlin_Comparator$0(tmp);
    }
  }
  function endsWith(_this__u8e3s4, suffix, ignoreCase) {
    ignoreCase = ignoreCase === VOID ? false : ignoreCase;
    if (!ignoreCase) {
      // Inline function 'kotlin.text.nativeEndsWith' call
      // Inline function 'kotlin.js.asDynamic' call
      return _this__u8e3s4.endsWith(suffix);
    } else
      return regionMatches(_this__u8e3s4, _this__u8e3s4.length - suffix.length | 0, suffix, 0, suffix.length, ignoreCase);
  }
  function equals_0(_this__u8e3s4, other, ignoreCase) {
    ignoreCase = ignoreCase === VOID ? false : ignoreCase;
    if (_this__u8e3s4 == null)
      return other == null;
    if (other == null)
      return false;
    if (!ignoreCase)
      return _this__u8e3s4 == other;
    if (!(_this__u8e3s4.length === other.length))
      return false;
    var inductionVariable = 0;
    var last = _this__u8e3s4.length;
    if (inductionVariable < last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var thisChar = charCodeAt(_this__u8e3s4, index);
        var otherChar = charCodeAt(other, index);
        if (!equals_1(thisChar, otherChar, ignoreCase)) {
          return false;
        }
      }
       while (inductionVariable < last);
    return true;
  }
  function startsWith(_this__u8e3s4, prefix, ignoreCase) {
    ignoreCase = ignoreCase === VOID ? false : ignoreCase;
    if (!ignoreCase) {
      // Inline function 'kotlin.text.nativeStartsWith' call
      // Inline function 'kotlin.js.asDynamic' call
      return _this__u8e3s4.startsWith(prefix, 0);
    } else
      return regionMatches(_this__u8e3s4, 0, prefix, 0, prefix.length, ignoreCase);
  }
  function replace(_this__u8e3s4, oldValue, newValue, ignoreCase) {
    ignoreCase = ignoreCase === VOID ? false : ignoreCase;
    var tmp2 = new RegExp(Companion_getInstance_5().sc(oldValue), ignoreCase ? 'gui' : 'gu');
    // Inline function 'kotlin.text.nativeReplace' call
    var replacement = Companion_getInstance_5().tc(newValue);
    // Inline function 'kotlin.js.asDynamic' call
    return _this__u8e3s4.replace(tmp2, replacement);
  }
  function repeat(_this__u8e3s4, n) {
    // Inline function 'kotlin.require' call
    if (!(n >= 0)) {
      var message = "Count 'n' must be non-negative, but was " + n + '.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    var tmp;
    switch (n) {
      case 0:
        tmp = '';
        break;
      case 1:
        tmp = toString_1(_this__u8e3s4);
        break;
      default:
        var result = '';
        // Inline function 'kotlin.text.isEmpty' call

        if (!(charSequenceLength(_this__u8e3s4) === 0)) {
          var s = toString_1(_this__u8e3s4);
          var count = n;
          $l$loop: while (true) {
            if ((count & 1) === 1) {
              result = result + s;
            }
            count = count >>> 1 | 0;
            if (count === 0) {
              break $l$loop;
            }
            s = s + s;
          }
        }

        return result;
    }
    return tmp;
  }
  function startsWith_0(_this__u8e3s4, prefix, startIndex, ignoreCase) {
    ignoreCase = ignoreCase === VOID ? false : ignoreCase;
    if (!ignoreCase) {
      // Inline function 'kotlin.text.nativeStartsWith' call
      // Inline function 'kotlin.js.asDynamic' call
      return _this__u8e3s4.startsWith(prefix, startIndex);
    } else
      return regionMatches(_this__u8e3s4, startIndex, prefix, 0, prefix.length, ignoreCase);
  }
  function replace_0(_this__u8e3s4, oldChar, newChar, ignoreCase) {
    ignoreCase = ignoreCase === VOID ? false : ignoreCase;
    var tmp2 = new RegExp(Companion_getInstance_5().sc(toString(oldChar)), ignoreCase ? 'gui' : 'gu');
    // Inline function 'kotlin.text.nativeReplace' call
    var replacement = toString(newChar);
    // Inline function 'kotlin.js.asDynamic' call
    return _this__u8e3s4.replace(tmp2, replacement);
  }
  function regionMatches(_this__u8e3s4, thisOffset, other, otherOffset, length, ignoreCase) {
    ignoreCase = ignoreCase === VOID ? false : ignoreCase;
    return regionMatchesImpl(_this__u8e3s4, thisOffset, other, otherOffset, length, ignoreCase);
  }
  function get_REPLACEMENT_BYTE_SEQUENCE() {
    _init_properties_utf8Encoding_kt__9thjs4();
    return REPLACEMENT_BYTE_SEQUENCE;
  }
  var REPLACEMENT_BYTE_SEQUENCE;
  function encodeUtf8(string, startIndex, endIndex, throwOnMalformed) {
    _init_properties_utf8Encoding_kt__9thjs4();
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.require' call
    if (!(startIndex >= 0 && endIndex <= string.length && startIndex <= endIndex)) {
      var message = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    var bytes = new Int8Array(imul(endIndex - startIndex | 0, 3));
    var byteIndex = 0;
    var charIndex = startIndex;
    while (charIndex < endIndex) {
      var _unary__edvuaz = charIndex;
      charIndex = _unary__edvuaz + 1 | 0;
      // Inline function 'kotlin.code' call
      var this_0 = charCodeAt(string, _unary__edvuaz);
      var code = Char__toInt_impl_vasixd(this_0);
      if (code < 128) {
        var _unary__edvuaz_0 = byteIndex;
        byteIndex = _unary__edvuaz_0 + 1 | 0;
        bytes[_unary__edvuaz_0] = toByte(code);
      } else if (code < 2048) {
        var _unary__edvuaz_1 = byteIndex;
        byteIndex = _unary__edvuaz_1 + 1 | 0;
        bytes[_unary__edvuaz_1] = toByte(code >> 6 | 192);
        var _unary__edvuaz_2 = byteIndex;
        byteIndex = _unary__edvuaz_2 + 1 | 0;
        bytes[_unary__edvuaz_2] = toByte(code & 63 | 128);
      } else if (code < 55296 || code >= 57344) {
        var _unary__edvuaz_3 = byteIndex;
        byteIndex = _unary__edvuaz_3 + 1 | 0;
        bytes[_unary__edvuaz_3] = toByte(code >> 12 | 224);
        var _unary__edvuaz_4 = byteIndex;
        byteIndex = _unary__edvuaz_4 + 1 | 0;
        bytes[_unary__edvuaz_4] = toByte(code >> 6 & 63 | 128);
        var _unary__edvuaz_5 = byteIndex;
        byteIndex = _unary__edvuaz_5 + 1 | 0;
        bytes[_unary__edvuaz_5] = toByte(code & 63 | 128);
      } else {
        var codePoint = codePointFromSurrogate(string, code, charIndex, endIndex, throwOnMalformed);
        if (codePoint <= 0) {
          var _unary__edvuaz_6 = byteIndex;
          byteIndex = _unary__edvuaz_6 + 1 | 0;
          bytes[_unary__edvuaz_6] = get_REPLACEMENT_BYTE_SEQUENCE()[0];
          var _unary__edvuaz_7 = byteIndex;
          byteIndex = _unary__edvuaz_7 + 1 | 0;
          bytes[_unary__edvuaz_7] = get_REPLACEMENT_BYTE_SEQUENCE()[1];
          var _unary__edvuaz_8 = byteIndex;
          byteIndex = _unary__edvuaz_8 + 1 | 0;
          bytes[_unary__edvuaz_8] = get_REPLACEMENT_BYTE_SEQUENCE()[2];
        } else {
          var _unary__edvuaz_9 = byteIndex;
          byteIndex = _unary__edvuaz_9 + 1 | 0;
          bytes[_unary__edvuaz_9] = toByte(codePoint >> 18 | 240);
          var _unary__edvuaz_10 = byteIndex;
          byteIndex = _unary__edvuaz_10 + 1 | 0;
          bytes[_unary__edvuaz_10] = toByte(codePoint >> 12 & 63 | 128);
          var _unary__edvuaz_11 = byteIndex;
          byteIndex = _unary__edvuaz_11 + 1 | 0;
          bytes[_unary__edvuaz_11] = toByte(codePoint >> 6 & 63 | 128);
          var _unary__edvuaz_12 = byteIndex;
          byteIndex = _unary__edvuaz_12 + 1 | 0;
          bytes[_unary__edvuaz_12] = toByte(codePoint & 63 | 128);
          charIndex = charIndex + 1 | 0;
        }
      }
    }
    return bytes.length === byteIndex ? bytes : copyOf_0(bytes, byteIndex);
  }
  function decodeUtf8(bytes, startIndex, endIndex, throwOnMalformed) {
    _init_properties_utf8Encoding_kt__9thjs4();
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.require' call
    if (!(startIndex >= 0 && endIndex <= bytes.length && startIndex <= endIndex)) {
      var message = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    var byteIndex = startIndex;
    var stringBuilder = StringBuilder_init_$Create$_1();
    while (byteIndex < endIndex) {
      var _unary__edvuaz = byteIndex;
      byteIndex = _unary__edvuaz + 1 | 0;
      var byte = bytes[_unary__edvuaz];
      if (byte >= 0)
        stringBuilder.k8(numberToChar(byte));
      else if (byte >> 5 === -2) {
        var code = codePointFrom2(bytes, byte, byteIndex, endIndex, throwOnMalformed);
        if (code <= 0) {
          stringBuilder.k8(_Char___init__impl__6a9atx(65533));
          byteIndex = byteIndex + (-code | 0) | 0;
        } else {
          stringBuilder.k8(numberToChar(code));
          byteIndex = byteIndex + 1 | 0;
        }
      } else if (byte >> 4 === -2) {
        var code_0 = codePointFrom3(bytes, byte, byteIndex, endIndex, throwOnMalformed);
        if (code_0 <= 0) {
          stringBuilder.k8(_Char___init__impl__6a9atx(65533));
          byteIndex = byteIndex + (-code_0 | 0) | 0;
        } else {
          stringBuilder.k8(numberToChar(code_0));
          byteIndex = byteIndex + 2 | 0;
        }
      } else if (byte >> 3 === -2) {
        var code_1 = codePointFrom4(bytes, byte, byteIndex, endIndex, throwOnMalformed);
        if (code_1 <= 0) {
          stringBuilder.k8(_Char___init__impl__6a9atx(65533));
          byteIndex = byteIndex + (-code_1 | 0) | 0;
        } else {
          var high = (code_1 - 65536 | 0) >> 10 | 55296;
          var low = code_1 & 1023 | 56320;
          stringBuilder.k8(numberToChar(high));
          stringBuilder.k8(numberToChar(low));
          byteIndex = byteIndex + 3 | 0;
        }
      } else {
        malformed(0, byteIndex, throwOnMalformed);
        stringBuilder.k8(_Char___init__impl__6a9atx(65533));
      }
    }
    return stringBuilder.toString();
  }
  function codePointFromSurrogate(string, high, index, endIndex, throwOnMalformed) {
    _init_properties_utf8Encoding_kt__9thjs4();
    if (!(55296 <= high ? high <= 56319 : false) || index >= endIndex) {
      return malformed(0, index, throwOnMalformed);
    }
    // Inline function 'kotlin.code' call
    var this_0 = charCodeAt(string, index);
    var low = Char__toInt_impl_vasixd(this_0);
    if (!(56320 <= low ? low <= 57343 : false)) {
      return malformed(0, index, throwOnMalformed);
    }
    return 65536 + ((high & 1023) << 10) | 0 | low & 1023;
  }
  function codePointFrom2(bytes, byte1, index, endIndex, throwOnMalformed) {
    _init_properties_utf8Encoding_kt__9thjs4();
    if ((byte1 & 30) === 0 || index >= endIndex) {
      return malformed(0, index, throwOnMalformed);
    }
    var byte2 = bytes[index];
    if (!((byte2 & 192) === 128)) {
      return malformed(0, index, throwOnMalformed);
    }
    return byte1 << 6 ^ byte2 ^ 3968;
  }
  function codePointFrom3(bytes, byte1, index, endIndex, throwOnMalformed) {
    _init_properties_utf8Encoding_kt__9thjs4();
    if (index >= endIndex) {
      return malformed(0, index, throwOnMalformed);
    }
    var byte2 = bytes[index];
    if ((byte1 & 15) === 0) {
      if (!((byte2 & 224) === 160)) {
        return malformed(0, index, throwOnMalformed);
      }
    } else if ((byte1 & 15) === 13) {
      if (!((byte2 & 224) === 128)) {
        return malformed(0, index, throwOnMalformed);
      }
    } else if (!((byte2 & 192) === 128)) {
      return malformed(0, index, throwOnMalformed);
    }
    if ((index + 1 | 0) === endIndex) {
      return malformed(1, index, throwOnMalformed);
    }
    var byte3 = bytes[index + 1 | 0];
    if (!((byte3 & 192) === 128)) {
      return malformed(1, index, throwOnMalformed);
    }
    return byte1 << 12 ^ byte2 << 6 ^ byte3 ^ -123008;
  }
  function codePointFrom4(bytes, byte1, index, endIndex, throwOnMalformed) {
    _init_properties_utf8Encoding_kt__9thjs4();
    if (index >= endIndex) {
      return malformed(0, index, throwOnMalformed);
    }
    var byte2 = bytes[index];
    if ((byte1 & 15) === 0) {
      if ((byte2 & 240) <= 128) {
        return malformed(0, index, throwOnMalformed);
      }
    } else if ((byte1 & 15) === 4) {
      if (!((byte2 & 240) === 128)) {
        return malformed(0, index, throwOnMalformed);
      }
    } else if ((byte1 & 15) > 4) {
      return malformed(0, index, throwOnMalformed);
    }
    if (!((byte2 & 192) === 128)) {
      return malformed(0, index, throwOnMalformed);
    }
    if ((index + 1 | 0) === endIndex) {
      return malformed(1, index, throwOnMalformed);
    }
    var byte3 = bytes[index + 1 | 0];
    if (!((byte3 & 192) === 128)) {
      return malformed(1, index, throwOnMalformed);
    }
    if ((index + 2 | 0) === endIndex) {
      return malformed(2, index, throwOnMalformed);
    }
    var byte4 = bytes[index + 2 | 0];
    if (!((byte4 & 192) === 128)) {
      return malformed(2, index, throwOnMalformed);
    }
    return byte1 << 18 ^ byte2 << 12 ^ byte3 << 6 ^ byte4 ^ 3678080;
  }
  function malformed(size, index, throwOnMalformed) {
    _init_properties_utf8Encoding_kt__9thjs4();
    if (throwOnMalformed)
      throw new CharacterCodingException('Malformed sequence starting at ' + (index - 1 | 0));
    return -size | 0;
  }
  var properties_initialized_utf8Encoding_kt_eee1vq;
  function _init_properties_utf8Encoding_kt__9thjs4() {
    if (!properties_initialized_utf8Encoding_kt_eee1vq) {
      properties_initialized_utf8Encoding_kt_eee1vq = true;
      // Inline function 'kotlin.byteArrayOf' call
      REPLACEMENT_BYTE_SEQUENCE = new Int8Array([-17, -65, -67]);
    }
  }
  function stackTraceToString(_this__u8e3s4) {
    return (new ExceptionTraceBuilder()).ee(_this__u8e3s4);
  }
  function addSuppressed(_this__u8e3s4, exception) {
    if (!(_this__u8e3s4 === exception)) {
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.unsafeCast' call
      var suppressed = _this__u8e3s4._suppressed;
      if (suppressed == null) {
        // Inline function 'kotlin.js.asDynamic' call
        _this__u8e3s4._suppressed = mutableListOf([exception]);
      } else {
        suppressed.j(exception);
      }
    }
  }
  function hasSeen($this, exception) {
    var tmp0 = $this.be_1;
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.any' call
      var inductionVariable = 0;
      var last = tmp0.length;
      while (inductionVariable < last) {
        var element = tmp0[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        if (element === exception) {
          tmp$ret$1 = true;
          break $l$block;
        }
      }
      tmp$ret$1 = false;
    }
    return tmp$ret$1;
  }
  function dumpFullTrace($this, _this__u8e3s4, indent, qualifier) {
    if (dumpSelfTrace($this, _this__u8e3s4, indent, qualifier))
      true;
    else
      return Unit_instance;
    var cause = _this__u8e3s4.cause;
    while (!(cause == null)) {
      if (dumpSelfTrace($this, cause, indent, 'Caused by: '))
        true;
      else
        return Unit_instance;
      cause = cause.cause;
    }
  }
  function dumpSelfTrace($this, _this__u8e3s4, indent, qualifier) {
    $this.ae_1.j8(indent).j8(qualifier);
    var shortInfo = _this__u8e3s4.toString();
    if (hasSeen($this, _this__u8e3s4)) {
      $this.ae_1.j8('[CIRCULAR REFERENCE, SEE ABOVE: ').j8(shortInfo).j8(']\n');
      return false;
    }
    // Inline function 'kotlin.js.asDynamic' call
    $this.be_1.push(_this__u8e3s4);
    // Inline function 'kotlin.js.asDynamic' call
    var tmp = _this__u8e3s4.stack;
    var stack = (tmp == null ? true : typeof tmp === 'string') ? tmp : THROW_CCE();
    if (!(stack == null)) {
      // Inline function 'kotlin.let' call
      var it = indexOf_9(stack, shortInfo);
      var stackStart = it < 0 ? 0 : it + shortInfo.length | 0;
      if (stackStart === 0) {
        $this.ae_1.j8(shortInfo).j8('\n');
      }
      // Inline function 'kotlin.text.isEmpty' call
      var this_0 = $this.ce_1;
      if (charSequenceLength(this_0) === 0) {
        $this.ce_1 = stack;
        $this.de_1 = stackStart;
      } else {
        stack = dropCommonFrames($this, stack, stackStart);
      }
      // Inline function 'kotlin.text.isNotEmpty' call
      if (charSequenceLength(indent) > 0) {
        var tmp_0;
        if (stackStart === 0) {
          tmp_0 = 0;
        } else {
          // Inline function 'kotlin.text.count' call
          var count = 0;
          var inductionVariable = 0;
          while (inductionVariable < charSequenceLength(shortInfo)) {
            var element = charSequenceGet(shortInfo, inductionVariable);
            inductionVariable = inductionVariable + 1 | 0;
            if (element === _Char___init__impl__6a9atx(10)) {
              count = count + 1 | 0;
            }
          }
          tmp_0 = 1 + count | 0;
        }
        var messageLines = tmp_0;
        // Inline function 'kotlin.sequences.forEachIndexed' call
        var index = 0;
        var _iterator__ex2g4s = lineSequence(stack).m();
        while (_iterator__ex2g4s.n()) {
          var item = _iterator__ex2g4s.o();
          var _unary__edvuaz = index;
          index = _unary__edvuaz + 1 | 0;
          if (checkIndexOverflow(_unary__edvuaz) >= messageLines) {
            $this.ae_1.j8(indent);
          }
          $this.ae_1.j8(item).j8('\n');
        }
      } else {
        $this.ae_1.j8(stack).j8('\n');
      }
    } else {
      $this.ae_1.j8(shortInfo).j8('\n');
    }
    var suppressed = get_suppressedExceptions(_this__u8e3s4);
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!suppressed.s()) {
      var suppressedIndent = indent + '    ';
      var _iterator__ex2g4s_0 = suppressed.m();
      while (_iterator__ex2g4s_0.n()) {
        var s = _iterator__ex2g4s_0.o();
        dumpFullTrace($this, s, suppressedIndent, 'Suppressed: ');
      }
    }
    return true;
  }
  function dropCommonFrames($this, stack, stackStart) {
    var commonFrames = 0;
    var lastBreak = 0;
    var preLastBreak = 0;
    var inductionVariable = 0;
    var tmp0 = $this.ce_1.length - $this.de_1 | 0;
    // Inline function 'kotlin.comparisons.minOf' call
    var b = stack.length - stackStart | 0;
    var last = Math.min(tmp0, b);
    if (inductionVariable < last)
      $l$loop: do {
        var pos = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var c = charCodeAt(stack, get_lastIndex_3(stack) - pos | 0);
        if (!(c === charCodeAt($this.ce_1, get_lastIndex_3($this.ce_1) - pos | 0)))
          break $l$loop;
        if (c === _Char___init__impl__6a9atx(10)) {
          commonFrames = commonFrames + 1 | 0;
          preLastBreak = lastBreak;
          lastBreak = pos;
        }
      }
       while (inductionVariable < last);
    if (commonFrames <= 1)
      return stack;
    while (preLastBreak > 0 && charCodeAt(stack, get_lastIndex_3(stack) - (preLastBreak - 1 | 0) | 0) === _Char___init__impl__6a9atx(32))
      preLastBreak = preLastBreak - 1 | 0;
    return dropLast_0(stack, preLastBreak) + ('... and ' + (commonFrames - 1 | 0) + ' more common stack frames skipped');
  }
  function ExceptionTraceBuilder() {
    this.ae_1 = StringBuilder_init_$Create$_1();
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.be_1 = [];
    this.ce_1 = '';
    this.de_1 = 0;
  }
  protoOf(ExceptionTraceBuilder).ee = function (exception) {
    dumpFullTrace(this, exception, '', '');
    return this.ae_1.toString();
  };
  function get_suppressedExceptions(_this__u8e3s4) {
    // Inline function 'kotlin.js.asDynamic' call
    var tmp0_safe_receiver = _this__u8e3s4._suppressed;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.js.unsafeCast' call
      tmp = tmp0_safe_receiver;
    }
    var tmp1_elvis_lhs = tmp;
    return tmp1_elvis_lhs == null ? emptyList() : tmp1_elvis_lhs;
  }
  function formatToExactDecimals(value, decimals) {
    var tmp;
    if (decimals === 0) {
      tmp = value;
    } else {
      // Inline function 'kotlin.math.pow' call
      var pow = Math.pow(10.0, decimals);
      var tmp_0 = Math;
      // Inline function 'kotlin.math.abs' call
      var tmp$ret$1 = Math.abs(value);
      var tmp_1 = tmp_0.round(tmp$ret$1 * pow) / pow;
      // Inline function 'kotlin.math.sign' call
      tmp = tmp_1 * sign(value);
    }
    var rounded = tmp;
    var tmp_2;
    // Inline function 'kotlin.math.abs' call
    if (Math.abs(rounded) < 1.0E21) {
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.unsafeCast' call
      tmp_2 = rounded.toFixed(decimals);
    } else {
      // Inline function 'kotlin.math.abs' call
      var positive = Math.abs(rounded);
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.math.log10' call
      // Inline function 'kotlin.math.ceil' call
      var x = log10(positive);
      var tmp$ret$9 = Math.ceil(x);
      // Inline function 'kotlin.js.unsafeCast' call
      var positiveString = positive.toPrecision(tmp$ret$9 + decimals);
      tmp_2 = rounded < 0 ? '-' + positiveString : positiveString;
    }
    return tmp_2;
  }
  var DurationUnit_NANOSECONDS_instance;
  var DurationUnit_MICROSECONDS_instance;
  var DurationUnit_MILLISECONDS_instance;
  var DurationUnit_SECONDS_instance;
  var DurationUnit_MINUTES_instance;
  var DurationUnit_HOURS_instance;
  var DurationUnit_DAYS_instance;
  var DurationUnit_entriesInitialized;
  function DurationUnit_initEntries() {
    if (DurationUnit_entriesInitialized)
      return Unit_instance;
    DurationUnit_entriesInitialized = true;
    DurationUnit_NANOSECONDS_instance = new DurationUnit('NANOSECONDS', 0, 1.0);
    DurationUnit_MICROSECONDS_instance = new DurationUnit('MICROSECONDS', 1, 1000.0);
    DurationUnit_MILLISECONDS_instance = new DurationUnit('MILLISECONDS', 2, 1000000.0);
    DurationUnit_SECONDS_instance = new DurationUnit('SECONDS', 3, 1.0E9);
    DurationUnit_MINUTES_instance = new DurationUnit('MINUTES', 4, 6.0E10);
    DurationUnit_HOURS_instance = new DurationUnit('HOURS', 5, 3.6E12);
    DurationUnit_DAYS_instance = new DurationUnit('DAYS', 6, 8.64E13);
  }
  function DurationUnit(name, ordinal, scale) {
    Enum.call(this, name, ordinal);
    this.he_1 = scale;
  }
  function convertDurationUnit(value, sourceUnit, targetUnit) {
    var sourceCompareTarget = compareTo_0(sourceUnit.he_1, targetUnit.he_1);
    return sourceCompareTarget > 0 ? value * (sourceUnit.he_1 / targetUnit.he_1) : sourceCompareTarget < 0 ? value / (targetUnit.he_1 / sourceUnit.he_1) : value;
  }
  function convertDurationUnit_0(value, sourceUnit, targetUnit) {
    var sourceCompareTarget = compareTo_0(sourceUnit.he_1, targetUnit.he_1);
    var tmp;
    if (sourceCompareTarget > 0) {
      var scale = numberToLong(sourceUnit.he_1 / targetUnit.he_1);
      var result = multiply_0(value, scale);
      tmp = divide(result, scale) === value ? result : value > 0n ? 9223372036854775807n : -9223372036854775808n;
    } else if (sourceCompareTarget < 0) {
      tmp = divide(value, numberToLong(targetUnit.he_1 / sourceUnit.he_1));
    } else {
      tmp = value;
    }
    return tmp;
  }
  function convertDurationUnitOverflow(value, sourceUnit, targetUnit) {
    var sourceCompareTarget = compareTo_0(sourceUnit.he_1, targetUnit.he_1);
    return sourceCompareTarget > 0 ? multiply_0(value, numberToLong(sourceUnit.he_1 / targetUnit.he_1)) : sourceCompareTarget < 0 ? divide(value, numberToLong(targetUnit.he_1 / sourceUnit.he_1)) : value;
  }
  function DurationUnit_NANOSECONDS_getInstance() {
    DurationUnit_initEntries();
    return DurationUnit_NANOSECONDS_instance;
  }
  function DurationUnit_MICROSECONDS_getInstance() {
    DurationUnit_initEntries();
    return DurationUnit_MICROSECONDS_instance;
  }
  function DurationUnit_MILLISECONDS_getInstance() {
    DurationUnit_initEntries();
    return DurationUnit_MILLISECONDS_instance;
  }
  function DurationUnit_SECONDS_getInstance() {
    DurationUnit_initEntries();
    return DurationUnit_SECONDS_instance;
  }
  function DurationUnit_MINUTES_getInstance() {
    DurationUnit_initEntries();
    return DurationUnit_MINUTES_instance;
  }
  function DurationUnit_HOURS_getInstance() {
    DurationUnit_initEntries();
    return DurationUnit_HOURS_instance;
  }
  function DurationUnit_DAYS_getInstance() {
    DurationUnit_initEntries();
    return DurationUnit_DAYS_instance;
  }
  function MonotonicTimeSource() {
    MonotonicTimeSource_instance = this;
    var tmp = this;
    // Inline function 'kotlin.run' call
    var isNode = typeof process !== 'undefined' && process.versions && !!process.versions.node;
    var tmp_0;
    if (isNode) {
      // Inline function 'kotlin.js.unsafeCast' call
      var tmp$ret$0 = process;
      tmp_0 = new HrTimeSource(tmp$ret$0);
    } else {
      // Inline function 'kotlin.js.unsafeCast' call
      var tmp0_safe_receiver = typeof self !== 'undefined' ? self : globalThis;
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.performance;
      var tmp_1;
      if (tmp1_safe_receiver == null) {
        tmp_1 = null;
      } else {
        // Inline function 'kotlin.let' call
        tmp_1 = new PerformanceTimeSource(tmp1_safe_receiver);
      }
      var tmp2_elvis_lhs = tmp_1;
      tmp_0 = tmp2_elvis_lhs == null ? DateNowTimeSource_instance : tmp2_elvis_lhs;
    }
    tmp.ie_1 = tmp_0;
  }
  protoOf(MonotonicTimeSource).je = function () {
    return this.ie_1.je();
  };
  protoOf(MonotonicTimeSource).ke = function () {
    return new ValueTimeMark(this.je());
  };
  protoOf(MonotonicTimeSource).le = function (timeMark) {
    return this.ie_1.le(timeMark);
  };
  protoOf(MonotonicTimeSource).me = function (one, another) {
    return this.ie_1.me(one, another);
  };
  var MonotonicTimeSource_instance;
  function MonotonicTimeSource_getInstance() {
    if (MonotonicTimeSource_instance == null)
      new MonotonicTimeSource();
    return MonotonicTimeSource_instance;
  }
  function Reading(components) {
    this.ne_1 = components;
  }
  protoOf(Reading).equals = function (other) {
    var tmp;
    if (other instanceof Reading) {
      tmp = contentEquals_0(this.ne_1, other.ne_1);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(Reading).hashCode = function () {
    return contentHashCode(this.ne_1);
  };
  protoOf(Reading).toString = function () {
    return contentToString(this.ne_1);
  };
  function HrTimeSource(process) {
    this.oe_1 = process;
  }
  protoOf(HrTimeSource).je = function () {
    return _ValueTimeMark___init__impl__uyfl2m(new Reading(this.oe_1.hrtime()));
  };
  protoOf(HrTimeSource).ke = function () {
    return new ValueTimeMark(this.je());
  };
  protoOf(HrTimeSource).le = function (timeMark) {
    var tmp = _ValueTimeMark___get_reading__impl__5qz8rd(timeMark);
    // Inline function 'kotlin.let' call
    var destruct = this.oe_1.hrtime((tmp instanceof Reading ? tmp : THROW_CCE()).ne_1);
    // Inline function 'kotlin.collections.component1' call
    var seconds = destruct[0];
    // Inline function 'kotlin.collections.component2' call
    var nanos = destruct[1];
    return Duration__plus_impl_yu9v8f(toDuration_1(seconds, DurationUnit_SECONDS_getInstance()), toDuration_1(nanos, DurationUnit_NANOSECONDS_getInstance()));
  };
  protoOf(HrTimeSource).me = function (one, another) {
    var tmp = _ValueTimeMark___get_reading__impl__5qz8rd(one);
    var _destruct__k2r9zo = tmp instanceof Reading ? tmp : THROW_CCE();
    // Inline function 'kotlin.time.Reading.component1' call
    // Inline function 'kotlin.collections.component1' call
    var s1 = _destruct__k2r9zo.ne_1[0];
    // Inline function 'kotlin.time.Reading.component2' call
    // Inline function 'kotlin.collections.component2' call
    var n1 = _destruct__k2r9zo.ne_1[1];
    var tmp_0 = _ValueTimeMark___get_reading__impl__5qz8rd(another);
    var _destruct__k2r9zo_0 = tmp_0 instanceof Reading ? tmp_0 : THROW_CCE();
    // Inline function 'kotlin.time.Reading.component1' call
    // Inline function 'kotlin.collections.component1' call
    var s2 = _destruct__k2r9zo_0.ne_1[0];
    // Inline function 'kotlin.time.Reading.component2' call
    // Inline function 'kotlin.collections.component2' call
    var n2 = _destruct__k2r9zo_0.ne_1[1];
    return Duration__plus_impl_yu9v8f(s1 === s2 && n1 === n2 ? Companion_getInstance_16().qe_1 : toDuration_1(s1 - s2, DurationUnit_SECONDS_getInstance()), toDuration_1(n1 - n2, DurationUnit_NANOSECONDS_getInstance()));
  };
  protoOf(HrTimeSource).toString = function () {
    return 'TimeSource(process.hrtime())';
  };
  function read($this) {
    return $this.te_1.now();
  }
  function PerformanceTimeSource(performance) {
    this.te_1 = performance;
  }
  protoOf(PerformanceTimeSource).je = function () {
    return _ValueTimeMark___init__impl__uyfl2m(read(this));
  };
  protoOf(PerformanceTimeSource).ke = function () {
    return new ValueTimeMark(this.je());
  };
  protoOf(PerformanceTimeSource).le = function (timeMark) {
    Companion_getInstance_16();
    var tmp = read(this);
    var tmp_0 = _ValueTimeMark___get_reading__impl__5qz8rd(timeMark);
    // Inline function 'kotlin.time.Companion.milliseconds' call
    var this_0 = tmp - (typeof tmp_0 === 'number' ? tmp_0 : THROW_CCE());
    return toDuration_1(this_0, DurationUnit_MILLISECONDS_getInstance());
  };
  protoOf(PerformanceTimeSource).me = function (one, another) {
    var tmp = _ValueTimeMark___get_reading__impl__5qz8rd(one);
    var ms1 = typeof tmp === 'number' ? tmp : THROW_CCE();
    var tmp_0 = _ValueTimeMark___get_reading__impl__5qz8rd(another);
    var ms2 = typeof tmp_0 === 'number' ? tmp_0 : THROW_CCE();
    var tmp_1;
    if (ms1 === ms2) {
      tmp_1 = Companion_getInstance_16().qe_1;
    } else {
      Companion_getInstance_16();
      // Inline function 'kotlin.time.Companion.milliseconds' call
      var this_0 = ms1 - ms2;
      tmp_1 = toDuration_1(this_0, DurationUnit_MILLISECONDS_getInstance());
    }
    return tmp_1;
  };
  protoOf(PerformanceTimeSource).toString = function () {
    return 'TimeSource(self.performance.now())';
  };
  function read_0($this) {
    return Date.now();
  }
  function DateNowTimeSource() {
  }
  protoOf(DateNowTimeSource).je = function () {
    return _ValueTimeMark___init__impl__uyfl2m(read_0(this));
  };
  protoOf(DateNowTimeSource).ke = function () {
    return new ValueTimeMark(this.je());
  };
  protoOf(DateNowTimeSource).le = function (timeMark) {
    Companion_getInstance_16();
    var tmp = read_0(this);
    var tmp_0 = _ValueTimeMark___get_reading__impl__5qz8rd(timeMark);
    // Inline function 'kotlin.time.Companion.milliseconds' call
    var this_0 = tmp - (typeof tmp_0 === 'number' ? tmp_0 : THROW_CCE());
    return toDuration_1(this_0, DurationUnit_MILLISECONDS_getInstance());
  };
  protoOf(DateNowTimeSource).me = function (one, another) {
    var tmp = _ValueTimeMark___get_reading__impl__5qz8rd(one);
    var ms1 = typeof tmp === 'number' ? tmp : THROW_CCE();
    var tmp_0 = _ValueTimeMark___get_reading__impl__5qz8rd(another);
    var ms2 = typeof tmp_0 === 'number' ? tmp_0 : THROW_CCE();
    var tmp_1;
    if (ms1 === ms2) {
      tmp_1 = Companion_getInstance_16().qe_1;
    } else {
      Companion_getInstance_16();
      // Inline function 'kotlin.time.Companion.milliseconds' call
      var this_0 = ms1 - ms2;
      tmp_1 = toDuration_1(this_0, DurationUnit_MILLISECONDS_getInstance());
    }
    return tmp_1;
  };
  protoOf(DateNowTimeSource).toString = function () {
    return 'TimeSource(Date.now())';
  };
  var DateNowTimeSource_instance;
  function DateNowTimeSource_getInstance() {
    return DateNowTimeSource_instance;
  }
  function AbstractCollection$toString$lambda(this$0) {
    return function (it) {
      return it === this$0 ? '(this Collection)' : toString_0(it);
    };
  }
  function AbstractCollection() {
  }
  protoOf(AbstractCollection).t = function (element) {
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.any' call
      var tmp;
      if (isInterface(this, Collection)) {
        tmp = this.s();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = false;
        break $l$block_0;
      }
      var _iterator__ex2g4s = this.m();
      while (_iterator__ex2g4s.n()) {
        var element_0 = _iterator__ex2g4s.o();
        if (equals(element_0, element)) {
          tmp$ret$0 = true;
          break $l$block_0;
        }
      }
      tmp$ret$0 = false;
    }
    return tmp$ret$0;
  };
  protoOf(AbstractCollection).e2 = function (elements) {
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var tmp;
      if (isInterface(elements, Collection)) {
        tmp = elements.s();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
      var _iterator__ex2g4s = elements.m();
      while (_iterator__ex2g4s.n()) {
        var element = _iterator__ex2g4s.o();
        if (!this.t(element)) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
      }
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  };
  protoOf(AbstractCollection).s = function () {
    return this.p() === 0;
  };
  protoOf(AbstractCollection).toString = function () {
    return joinToString_0(this, ', ', '[', ']', VOID, VOID, AbstractCollection$toString$lambda(this));
  };
  protoOf(AbstractCollection).toArray = function () {
    return collectionToArray(this);
  };
  function SubList_0(list, fromIndex, toIndex) {
    AbstractList.call(this);
    this.ue_1 = list;
    this.ve_1 = fromIndex;
    this.we_1 = 0;
    Companion_instance_6.r3(this.ve_1, toIndex, this.ue_1.p());
    this.we_1 = toIndex - this.ve_1 | 0;
  }
  protoOf(SubList_0).r = function (index) {
    Companion_instance_6.b4(index, this.we_1);
    return this.ue_1.r(this.ve_1 + index | 0);
  };
  protoOf(SubList_0).p = function () {
    return this.we_1;
  };
  protoOf(SubList_0).g2 = function (fromIndex, toIndex) {
    Companion_instance_6.r3(fromIndex, toIndex, this.we_1);
    return new SubList_0(this.ue_1, this.ve_1 + fromIndex | 0, this.ve_1 + toIndex | 0);
  };
  function IteratorImpl_0($outer) {
    this.ye_1 = $outer;
    this.xe_1 = 0;
  }
  protoOf(IteratorImpl_0).n = function () {
    return this.xe_1 < this.ye_1.p();
  };
  protoOf(IteratorImpl_0).o = function () {
    if (!this.n())
      throw NoSuchElementException_init_$Create$();
    var _unary__edvuaz = this.xe_1;
    this.xe_1 = _unary__edvuaz + 1 | 0;
    return this.ye_1.r(_unary__edvuaz);
  };
  function ListIteratorImpl_0($outer, index) {
    this.bf_1 = $outer;
    IteratorImpl_0.call(this, $outer);
    Companion_instance_6.q4(index, this.bf_1.p());
    this.xe_1 = index;
  }
  protoOf(ListIteratorImpl_0).r4 = function () {
    return this.xe_1 > 0;
  };
  protoOf(ListIteratorImpl_0).s4 = function () {
    return this.xe_1;
  };
  protoOf(ListIteratorImpl_0).t4 = function () {
    if (!this.r4())
      throw NoSuchElementException_init_$Create$();
    this.xe_1 = this.xe_1 - 1 | 0;
    return this.bf_1.r(this.xe_1);
  };
  protoOf(ListIteratorImpl_0).u4 = function () {
    return this.xe_1 - 1 | 0;
  };
  function Companion_6() {
    this.q3_1 = 2147483639;
  }
  protoOf(Companion_6).b4 = function (index, size) {
    if (index < 0 || index >= size) {
      throw IndexOutOfBoundsException_init_$Create$_0('index: ' + index + ', size: ' + size);
    }
  };
  protoOf(Companion_6).q4 = function (index, size) {
    if (index < 0 || index > size) {
      throw IndexOutOfBoundsException_init_$Create$_0('index: ' + index + ', size: ' + size);
    }
  };
  protoOf(Companion_6).r3 = function (fromIndex, toIndex, size) {
    if (fromIndex < 0 || toIndex > size) {
      throw IndexOutOfBoundsException_init_$Create$_0('fromIndex: ' + fromIndex + ', toIndex: ' + toIndex + ', size: ' + size);
    }
    if (fromIndex > toIndex) {
      throw IllegalArgumentException_init_$Create$_0('fromIndex: ' + fromIndex + ' > toIndex: ' + toIndex);
    }
  };
  protoOf(Companion_6).oc = function (startIndex, endIndex, size) {
    if (startIndex < 0 || endIndex > size) {
      throw IndexOutOfBoundsException_init_$Create$_0('startIndex: ' + startIndex + ', endIndex: ' + endIndex + ', size: ' + size);
    }
    if (startIndex > endIndex) {
      throw IllegalArgumentException_init_$Create$_0('startIndex: ' + startIndex + ' > endIndex: ' + endIndex);
    }
  };
  protoOf(Companion_6).j7 = function (oldCapacity, minCapacity) {
    var newCapacity = oldCapacity + (oldCapacity >> 1) | 0;
    if ((newCapacity - minCapacity | 0) < 0)
      newCapacity = minCapacity;
    if ((newCapacity - 2147483639 | 0) > 0)
      newCapacity = minCapacity > 2147483639 ? 2147483647 : 2147483639;
    return newCapacity;
  };
  protoOf(Companion_6).b5 = function (c) {
    var hashCode_0 = 1;
    var _iterator__ex2g4s = c.m();
    while (_iterator__ex2g4s.n()) {
      var e = _iterator__ex2g4s.o();
      var tmp = imul(31, hashCode_0);
      var tmp1_elvis_lhs = e == null ? null : hashCode(e);
      hashCode_0 = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
    }
    return hashCode_0;
  };
  protoOf(Companion_6).a5 = function (c, other) {
    if (!(c.p() === other.p()))
      return false;
    var otherIterator = other.m();
    var _iterator__ex2g4s = c.m();
    while (_iterator__ex2g4s.n()) {
      var elem = _iterator__ex2g4s.o();
      var elemOther = otherIterator.o();
      if (!equals(elem, elemOther)) {
        return false;
      }
    }
    return true;
  };
  var Companion_instance_6;
  function Companion_getInstance_6() {
    return Companion_instance_6;
  }
  function AbstractList() {
    AbstractCollection.call(this);
  }
  protoOf(AbstractList).m = function () {
    return new IteratorImpl_0(this);
  };
  protoOf(AbstractList).w = function (element) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.indexOfFirst' call
      var index = 0;
      var _iterator__ex2g4s = this.m();
      while (_iterator__ex2g4s.n()) {
        var item = _iterator__ex2g4s.o();
        if (equals(item, element)) {
          tmp$ret$1 = index;
          break $l$block;
        }
        index = index + 1 | 0;
      }
      tmp$ret$1 = -1;
    }
    return tmp$ret$1;
  };
  protoOf(AbstractList).v = function (element) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.indexOfLast' call
      var iterator = this.u(this.p());
      while (iterator.r4()) {
        var it = iterator.t4();
        if (equals(it, element)) {
          tmp$ret$1 = iterator.s4();
          break $l$block;
        }
      }
      tmp$ret$1 = -1;
    }
    return tmp$ret$1;
  };
  protoOf(AbstractList).f2 = function () {
    return new ListIteratorImpl_0(this, 0);
  };
  protoOf(AbstractList).u = function (index) {
    return new ListIteratorImpl_0(this, index);
  };
  protoOf(AbstractList).g2 = function (fromIndex, toIndex) {
    return new SubList_0(this, fromIndex, toIndex);
  };
  protoOf(AbstractList).equals = function (other) {
    if (other === this)
      return true;
    if (!(!(other == null) ? isInterface(other, KtList) : false))
      return false;
    return Companion_instance_6.a5(this, other);
  };
  protoOf(AbstractList).hashCode = function () {
    return Companion_instance_6.b5(this);
  };
  function AbstractMap$keys$1$iterator$1($entryIterator) {
    this.cf_1 = $entryIterator;
  }
  protoOf(AbstractMap$keys$1$iterator$1).n = function () {
    return this.cf_1.n();
  };
  protoOf(AbstractMap$keys$1$iterator$1).o = function () {
    return this.cf_1.o().z();
  };
  function AbstractMap$values$1$iterator$1($entryIterator) {
    this.df_1 = $entryIterator;
  }
  protoOf(AbstractMap$values$1$iterator$1).n = function () {
    return this.df_1.n();
  };
  protoOf(AbstractMap$values$1$iterator$1).o = function () {
    return this.df_1.o().a1();
  };
  function toString_4($this, entry) {
    return toString_5($this, entry.z()) + '=' + toString_5($this, entry.a1());
  }
  function toString_5($this, o) {
    return o === $this ? '(this Map)' : toString_0(o);
  }
  function implFindEntry($this, key) {
    var tmp0 = $this.y();
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var _iterator__ex2g4s = tmp0.m();
      while (_iterator__ex2g4s.n()) {
        var element = _iterator__ex2g4s.o();
        if (equals(element.z(), key)) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    return tmp$ret$1;
  }
  function Companion_7() {
  }
  var Companion_instance_7;
  function Companion_getInstance_7() {
    return Companion_instance_7;
  }
  function AbstractMap$keys$1(this$0) {
    this.ef_1 = this$0;
    AbstractSet.call(this);
  }
  protoOf(AbstractMap$keys$1).w5 = function (element) {
    return this.ef_1.o2(element);
  };
  protoOf(AbstractMap$keys$1).t = function (element) {
    if (!(element == null ? true : !(element == null)))
      return false;
    return this.w5((element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  protoOf(AbstractMap$keys$1).m = function () {
    var entryIterator = this.ef_1.y().m();
    return new AbstractMap$keys$1$iterator$1(entryIterator);
  };
  protoOf(AbstractMap$keys$1).p = function () {
    return this.ef_1.p();
  };
  function AbstractMap$toString$lambda(this$0) {
    return function (it) {
      return toString_4(this$0, it);
    };
  }
  function AbstractMap$values$1(this$0) {
    this.ff_1 = this$0;
    AbstractCollection.call(this);
  }
  protoOf(AbstractMap$values$1).c6 = function (element) {
    return this.ff_1.p2(element);
  };
  protoOf(AbstractMap$values$1).t = function (element) {
    if (!(element == null ? true : !(element == null)))
      return false;
    return this.c6((element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  protoOf(AbstractMap$values$1).m = function () {
    var entryIterator = this.ff_1.y().m();
    return new AbstractMap$values$1$iterator$1(entryIterator);
  };
  protoOf(AbstractMap$values$1).p = function () {
    return this.ff_1.p();
  };
  function AbstractMap() {
    this.i5_1 = null;
    this.j5_1 = null;
  }
  protoOf(AbstractMap).o2 = function (key) {
    return !(implFindEntry(this, key) == null);
  };
  protoOf(AbstractMap).p2 = function (value) {
    var tmp0 = this.y();
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.any' call
      var tmp;
      if (isInterface(tmp0, Collection)) {
        tmp = tmp0.s();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = false;
        break $l$block_0;
      }
      var _iterator__ex2g4s = tmp0.m();
      while (_iterator__ex2g4s.n()) {
        var element = _iterator__ex2g4s.o();
        if (equals(element.a1(), value)) {
          tmp$ret$0 = true;
          break $l$block_0;
        }
      }
      tmp$ret$0 = false;
    }
    return tmp$ret$0;
  };
  protoOf(AbstractMap).k5 = function (entry) {
    if (!(!(entry == null) ? isInterface(entry, Entry) : false))
      return false;
    var key = entry.z();
    var value = entry.a1();
    // Inline function 'kotlin.collections.get' call
    var ourValue = (isInterface(this, KtMap) ? this : THROW_CCE()).q2(key);
    if (!equals(value, ourValue)) {
      return false;
    }
    var tmp;
    if (ourValue == null) {
      // Inline function 'kotlin.collections.containsKey' call
      tmp = !(isInterface(this, KtMap) ? this : THROW_CCE()).o2(key);
    } else {
      tmp = false;
    }
    if (tmp) {
      return false;
    }
    return true;
  };
  protoOf(AbstractMap).equals = function (other) {
    if (other === this)
      return true;
    if (!(!(other == null) ? isInterface(other, KtMap) : false))
      return false;
    if (!(this.p() === other.p()))
      return false;
    var tmp0 = other.y();
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var tmp;
      if (isInterface(tmp0, Collection)) {
        tmp = tmp0.s();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
      var _iterator__ex2g4s = tmp0.m();
      while (_iterator__ex2g4s.n()) {
        var element = _iterator__ex2g4s.o();
        if (!this.k5(element)) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
      }
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  };
  protoOf(AbstractMap).q2 = function (key) {
    var tmp0_safe_receiver = implFindEntry(this, key);
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.a1();
  };
  protoOf(AbstractMap).hashCode = function () {
    return hashCode(this.y());
  };
  protoOf(AbstractMap).s = function () {
    return this.p() === 0;
  };
  protoOf(AbstractMap).p = function () {
    return this.y().p();
  };
  protoOf(AbstractMap).r2 = function () {
    if (this.i5_1 == null) {
      var tmp = this;
      tmp.i5_1 = new AbstractMap$keys$1(this);
    }
    return ensureNotNull(this.i5_1);
  };
  protoOf(AbstractMap).toString = function () {
    var tmp = this.y();
    return joinToString_0(tmp, ', ', '{', '}', VOID, VOID, AbstractMap$toString$lambda(this));
  };
  protoOf(AbstractMap).s2 = function () {
    if (this.j5_1 == null) {
      var tmp = this;
      tmp.j5_1 = new AbstractMap$values$1(this);
    }
    return ensureNotNull(this.j5_1);
  };
  function Companion_8() {
  }
  protoOf(Companion_8).m5 = function (c) {
    var hashCode_0 = 0;
    var _iterator__ex2g4s = c.m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      var tmp = hashCode_0;
      var tmp1_elvis_lhs = element == null ? null : hashCode(element);
      hashCode_0 = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
    }
    return hashCode_0;
  };
  protoOf(Companion_8).l5 = function (c, other) {
    if (!(c.p() === other.p()))
      return false;
    return c.e2(other);
  };
  var Companion_instance_8;
  function Companion_getInstance_8() {
    return Companion_instance_8;
  }
  function AbstractSet() {
    AbstractCollection.call(this);
  }
  protoOf(AbstractSet).equals = function (other) {
    if (other === this)
      return true;
    if (!(!(other == null) ? isInterface(other, KtSet) : false))
      return false;
    return Companion_instance_8.l5(this, other);
  };
  protoOf(AbstractSet).hashCode = function () {
    return Companion_instance_8.m5(this);
  };
  function ArrayDeque_init_$Init$($this) {
    AbstractMutableList.call($this);
    ArrayDeque.call($this);
    $this.if_1 = Companion_getInstance_9().kf_1;
    return $this;
  }
  function ArrayDeque_init_$Create$() {
    return ArrayDeque_init_$Init$(objectCreate(protoOf(ArrayDeque)));
  }
  function ensureCapacity_0($this, minCapacity) {
    if (minCapacity < 0)
      throw IllegalStateException_init_$Create$_0('Deque is too big.');
    if (minCapacity <= $this.if_1.length)
      return Unit_instance;
    if ($this.if_1 === Companion_getInstance_9().kf_1) {
      var tmp = $this;
      // Inline function 'kotlin.arrayOfNulls' call
      var size = coerceAtLeast(minCapacity, 10);
      tmp.if_1 = Array(size);
      return Unit_instance;
    }
    var newCapacity = Companion_instance_6.j7($this.if_1.length, minCapacity);
    copyElements($this, newCapacity);
  }
  function copyElements($this, newCapacity) {
    // Inline function 'kotlin.arrayOfNulls' call
    var newElements = Array(newCapacity);
    var tmp0 = $this.if_1;
    var tmp6 = $this.hf_1;
    // Inline function 'kotlin.collections.copyInto' call
    var endIndex = $this.if_1.length;
    arrayCopy(tmp0, newElements, 0, tmp6, endIndex);
    var tmp0_0 = $this.if_1;
    var tmp4 = $this.if_1.length - $this.hf_1 | 0;
    // Inline function 'kotlin.collections.copyInto' call
    var endIndex_0 = $this.hf_1;
    arrayCopy(tmp0_0, newElements, tmp4, 0, endIndex_0);
    $this.hf_1 = 0;
    $this.if_1 = newElements;
  }
  function positiveMod($this, index) {
    return index >= $this.if_1.length ? index - $this.if_1.length | 0 : index;
  }
  function negativeMod($this, index) {
    return index < 0 ? index + $this.if_1.length | 0 : index;
  }
  function incremented($this, index) {
    return index === get_lastIndex_0($this.if_1) ? 0 : index + 1 | 0;
  }
  function decremented($this, index) {
    return index === 0 ? get_lastIndex_0($this.if_1) : index - 1 | 0;
  }
  function copyCollectionElements($this, internalIndex, elements) {
    var iterator = elements.m();
    var inductionVariable = internalIndex;
    var last = $this.if_1.length;
    if (inductionVariable < last)
      $l$loop: do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!iterator.n())
          break $l$loop;
        $this.if_1[index] = iterator.o();
      }
       while (inductionVariable < last);
    var inductionVariable_0 = 0;
    var last_0 = $this.hf_1;
    if (inductionVariable_0 < last_0)
      $l$loop_0: do {
        var index_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        if (!iterator.n())
          break $l$loop_0;
        $this.if_1[index_0] = iterator.o();
      }
       while (inductionVariable_0 < last_0);
    $this.jf_1 = $this.jf_1 + elements.p() | 0;
  }
  function removeRangeShiftPreceding($this, fromIndex, toIndex) {
    // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
    var index = fromIndex - 1 | 0;
    var copyFromIndex = positiveMod($this, $this.hf_1 + index | 0);
    // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
    var index_0 = toIndex - 1 | 0;
    var copyToIndex = positiveMod($this, $this.hf_1 + index_0 | 0);
    var copyCount = fromIndex;
    while (copyCount > 0) {
      var tmp0 = copyCount;
      var tmp2 = copyFromIndex + 1 | 0;
      // Inline function 'kotlin.comparisons.minOf' call
      var c = copyToIndex + 1 | 0;
      var segmentLength = Math.min(tmp0, tmp2, c);
      var tmp0_0 = $this.if_1;
      var tmp2_0 = $this.if_1;
      var tmp4 = (copyToIndex - segmentLength | 0) + 1 | 0;
      var tmp6 = (copyFromIndex - segmentLength | 0) + 1 | 0;
      // Inline function 'kotlin.collections.copyInto' call
      var endIndex = copyFromIndex + 1 | 0;
      arrayCopy(tmp0_0, tmp2_0, tmp4, tmp6, endIndex);
      copyFromIndex = negativeMod($this, copyFromIndex - segmentLength | 0);
      copyToIndex = negativeMod($this, copyToIndex - segmentLength | 0);
      copyCount = copyCount - segmentLength | 0;
    }
  }
  function removeRangeShiftSucceeding($this, fromIndex, toIndex) {
    // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
    var copyFromIndex = positiveMod($this, $this.hf_1 + toIndex | 0);
    // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
    var copyToIndex = positiveMod($this, $this.hf_1 + fromIndex | 0);
    var copyCount = $this.jf_1 - toIndex | 0;
    while (copyCount > 0) {
      var tmp0 = copyCount;
      var tmp2 = $this.if_1.length - copyFromIndex | 0;
      // Inline function 'kotlin.comparisons.minOf' call
      var c = $this.if_1.length - copyToIndex | 0;
      var segmentLength = Math.min(tmp0, tmp2, c);
      var tmp0_0 = $this.if_1;
      var tmp2_0 = $this.if_1;
      var tmp4 = copyToIndex;
      var tmp6 = copyFromIndex;
      // Inline function 'kotlin.collections.copyInto' call
      var endIndex = copyFromIndex + segmentLength | 0;
      arrayCopy(tmp0_0, tmp2_0, tmp4, tmp6, endIndex);
      copyFromIndex = positiveMod($this, copyFromIndex + segmentLength | 0);
      copyToIndex = positiveMod($this, copyToIndex + segmentLength | 0);
      copyCount = copyCount - segmentLength | 0;
    }
  }
  function nullifyNonEmpty($this, internalFromIndex, internalToIndex) {
    if (internalFromIndex < internalToIndex) {
      fill_0($this.if_1, null, internalFromIndex, internalToIndex);
    } else {
      fill_0($this.if_1, null, internalFromIndex, $this.if_1.length);
      fill_0($this.if_1, null, 0, internalToIndex);
    }
  }
  function registerModification_0($this) {
    $this.l4_1 = $this.l4_1 + 1 | 0;
  }
  function Companion_9() {
    Companion_instance_9 = this;
    var tmp = this;
    // Inline function 'kotlin.emptyArray' call
    tmp.kf_1 = [];
    this.lf_1 = 10;
  }
  var Companion_instance_9;
  function Companion_getInstance_9() {
    if (Companion_instance_9 == null)
      new Companion_9();
    return Companion_instance_9;
  }
  protoOf(ArrayDeque).p = function () {
    return this.jf_1;
  };
  protoOf(ArrayDeque).s = function () {
    return this.jf_1 === 0;
  };
  protoOf(ArrayDeque).mf = function () {
    var tmp;
    if (this.s()) {
      throw NoSuchElementException_init_$Create$_0('ArrayDeque is empty.');
    } else {
      // Inline function 'kotlin.collections.ArrayDeque.internalGet' call
      var internalIndex = this.hf_1;
      var tmp_0 = this.if_1[internalIndex];
      tmp = (tmp_0 == null ? true : !(tmp_0 == null)) ? tmp_0 : THROW_CCE();
    }
    return tmp;
  };
  protoOf(ArrayDeque).nf = function () {
    var tmp;
    if (this.s()) {
      tmp = null;
    } else {
      // Inline function 'kotlin.collections.ArrayDeque.internalGet' call
      var internalIndex = this.hf_1;
      var tmp_0 = this.if_1[internalIndex];
      tmp = (tmp_0 == null ? true : !(tmp_0 == null)) ? tmp_0 : THROW_CCE();
    }
    return tmp;
  };
  protoOf(ArrayDeque).of = function (element) {
    registerModification_0(this);
    ensureCapacity_0(this, this.jf_1 + 1 | 0);
    this.hf_1 = decremented(this, this.hf_1);
    this.if_1[this.hf_1] = element;
    this.jf_1 = this.jf_1 + 1 | 0;
  };
  protoOf(ArrayDeque).pf = function (element) {
    registerModification_0(this);
    ensureCapacity_0(this, this.jf_1 + 1 | 0);
    var tmp = this.if_1;
    // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
    var index = this.jf_1;
    tmp[positiveMod(this, this.hf_1 + index | 0)] = element;
    this.jf_1 = this.jf_1 + 1 | 0;
  };
  protoOf(ArrayDeque).qf = function () {
    if (this.s())
      throw NoSuchElementException_init_$Create$_0('ArrayDeque is empty.');
    registerModification_0(this);
    // Inline function 'kotlin.collections.ArrayDeque.internalGet' call
    var internalIndex = this.hf_1;
    var tmp = this.if_1[internalIndex];
    var element = (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
    this.if_1[this.hf_1] = null;
    this.hf_1 = incremented(this, this.hf_1);
    this.jf_1 = this.jf_1 - 1 | 0;
    return element;
  };
  protoOf(ArrayDeque).rf = function () {
    return this.s() ? null : this.qf();
  };
  protoOf(ArrayDeque).sf = function () {
    if (this.s())
      throw NoSuchElementException_init_$Create$_0('ArrayDeque is empty.');
    registerModification_0(this);
    // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
    var index = get_lastIndex_2(this);
    var internalLastIndex = positiveMod(this, this.hf_1 + index | 0);
    // Inline function 'kotlin.collections.ArrayDeque.internalGet' call
    var tmp = this.if_1[internalLastIndex];
    var element = (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
    this.if_1[internalLastIndex] = null;
    this.jf_1 = this.jf_1 - 1 | 0;
    return element;
  };
  protoOf(ArrayDeque).j = function (element) {
    this.pf(element);
    return true;
  };
  protoOf(ArrayDeque).m2 = function (index, element) {
    Companion_instance_6.q4(index, this.jf_1);
    if (index === this.jf_1) {
      this.pf(element);
      return Unit_instance;
    } else if (index === 0) {
      this.of(element);
      return Unit_instance;
    }
    registerModification_0(this);
    ensureCapacity_0(this, this.jf_1 + 1 | 0);
    // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
    var internalIndex = positiveMod(this, this.hf_1 + index | 0);
    if (index < (this.jf_1 + 1 | 0) >> 1) {
      var decrementedInternalIndex = decremented(this, internalIndex);
      var decrementedHead = decremented(this, this.hf_1);
      if (decrementedInternalIndex >= this.hf_1) {
        this.if_1[decrementedHead] = this.if_1[this.hf_1];
        var tmp0 = this.if_1;
        var tmp2 = this.if_1;
        var tmp4 = this.hf_1;
        var tmp6 = this.hf_1 + 1 | 0;
        // Inline function 'kotlin.collections.copyInto' call
        var endIndex = decrementedInternalIndex + 1 | 0;
        arrayCopy(tmp0, tmp2, tmp4, tmp6, endIndex);
      } else {
        var tmp0_0 = this.if_1;
        var tmp2_0 = this.if_1;
        var tmp4_0 = this.hf_1 - 1 | 0;
        var tmp6_0 = this.hf_1;
        // Inline function 'kotlin.collections.copyInto' call
        var endIndex_0 = this.if_1.length;
        arrayCopy(tmp0_0, tmp2_0, tmp4_0, tmp6_0, endIndex_0);
        this.if_1[this.if_1.length - 1 | 0] = this.if_1[0];
        var tmp0_1 = this.if_1;
        var tmp2_1 = this.if_1;
        // Inline function 'kotlin.collections.copyInto' call
        var endIndex_1 = decrementedInternalIndex + 1 | 0;
        arrayCopy(tmp0_1, tmp2_1, 0, 1, endIndex_1);
      }
      this.if_1[decrementedInternalIndex] = element;
      this.hf_1 = decrementedHead;
    } else {
      // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
      var index_0 = this.jf_1;
      var tail = positiveMod(this, this.hf_1 + index_0 | 0);
      if (internalIndex < tail) {
        var tmp0_2 = this.if_1;
        var tmp2_2 = this.if_1;
        // Inline function 'kotlin.collections.copyInto' call
        var destinationOffset = internalIndex + 1 | 0;
        arrayCopy(tmp0_2, tmp2_2, destinationOffset, internalIndex, tail);
      } else {
        var tmp0_3 = this.if_1;
        // Inline function 'kotlin.collections.copyInto' call
        var destination = this.if_1;
        arrayCopy(tmp0_3, destination, 1, 0, tail);
        this.if_1[0] = this.if_1[this.if_1.length - 1 | 0];
        var tmp0_4 = this.if_1;
        var tmp2_3 = this.if_1;
        var tmp4_1 = internalIndex + 1 | 0;
        // Inline function 'kotlin.collections.copyInto' call
        var endIndex_2 = this.if_1.length - 1 | 0;
        arrayCopy(tmp0_4, tmp2_3, tmp4_1, internalIndex, endIndex_2);
      }
      this.if_1[internalIndex] = element;
    }
    this.jf_1 = this.jf_1 + 1 | 0;
  };
  protoOf(ArrayDeque).q = function (elements) {
    if (elements.s())
      return false;
    registerModification_0(this);
    ensureCapacity_0(this, this.jf_1 + elements.p() | 0);
    // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
    var index = this.jf_1;
    var tmp$ret$0 = positiveMod(this, this.hf_1 + index | 0);
    copyCollectionElements(this, tmp$ret$0, elements);
    return true;
  };
  protoOf(ArrayDeque).i2 = function (index, elements) {
    Companion_instance_6.q4(index, this.jf_1);
    if (elements.s()) {
      return false;
    } else if (index === this.jf_1) {
      return this.q(elements);
    }
    registerModification_0(this);
    ensureCapacity_0(this, this.jf_1 + elements.p() | 0);
    // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
    var index_0 = this.jf_1;
    var tail = positiveMod(this, this.hf_1 + index_0 | 0);
    // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
    var internalIndex = positiveMod(this, this.hf_1 + index | 0);
    var elementsSize = elements.p();
    if (index < (this.jf_1 + 1 | 0) >> 1) {
      var shiftedHead = this.hf_1 - elementsSize | 0;
      if (internalIndex >= this.hf_1) {
        if (shiftedHead >= 0) {
          var tmp0 = this.if_1;
          var tmp2 = this.if_1;
          var tmp4 = shiftedHead;
          // Inline function 'kotlin.collections.copyInto' call
          var startIndex = this.hf_1;
          arrayCopy(tmp0, tmp2, tmp4, startIndex, internalIndex);
        } else {
          shiftedHead = shiftedHead + this.if_1.length | 0;
          var elementsToShift = internalIndex - this.hf_1 | 0;
          var shiftToBack = this.if_1.length - shiftedHead | 0;
          if (shiftToBack >= elementsToShift) {
            var tmp0_0 = this.if_1;
            var tmp2_0 = this.if_1;
            var tmp4_0 = shiftedHead;
            // Inline function 'kotlin.collections.copyInto' call
            var startIndex_0 = this.hf_1;
            arrayCopy(tmp0_0, tmp2_0, tmp4_0, startIndex_0, internalIndex);
          } else {
            var tmp0_1 = this.if_1;
            var tmp2_1 = this.if_1;
            var tmp4_1 = shiftedHead;
            var tmp6 = this.hf_1;
            // Inline function 'kotlin.collections.copyInto' call
            var endIndex = this.hf_1 + shiftToBack | 0;
            arrayCopy(tmp0_1, tmp2_1, tmp4_1, tmp6, endIndex);
            var tmp0_2 = this.if_1;
            var tmp2_2 = this.if_1;
            // Inline function 'kotlin.collections.copyInto' call
            var startIndex_1 = this.hf_1 + shiftToBack | 0;
            arrayCopy(tmp0_2, tmp2_2, 0, startIndex_1, internalIndex);
          }
        }
      } else {
        var tmp0_3 = this.if_1;
        var tmp2_3 = this.if_1;
        var tmp4_2 = shiftedHead;
        var tmp6_0 = this.hf_1;
        // Inline function 'kotlin.collections.copyInto' call
        var endIndex_0 = this.if_1.length;
        arrayCopy(tmp0_3, tmp2_3, tmp4_2, tmp6_0, endIndex_0);
        if (elementsSize >= internalIndex) {
          var tmp0_4 = this.if_1;
          var tmp2_4 = this.if_1;
          // Inline function 'kotlin.collections.copyInto' call
          var destinationOffset = this.if_1.length - elementsSize | 0;
          arrayCopy(tmp0_4, tmp2_4, destinationOffset, 0, internalIndex);
        } else {
          var tmp0_5 = this.if_1;
          var tmp2_5 = this.if_1;
          // Inline function 'kotlin.collections.copyInto' call
          var destinationOffset_0 = this.if_1.length - elementsSize | 0;
          arrayCopy(tmp0_5, tmp2_5, destinationOffset_0, 0, elementsSize);
          var tmp0_6 = this.if_1;
          // Inline function 'kotlin.collections.copyInto' call
          var destination = this.if_1;
          arrayCopy(tmp0_6, destination, 0, elementsSize, internalIndex);
        }
      }
      this.hf_1 = shiftedHead;
      copyCollectionElements(this, negativeMod(this, internalIndex - elementsSize | 0), elements);
    } else {
      var shiftedInternalIndex = internalIndex + elementsSize | 0;
      if (internalIndex < tail) {
        if ((tail + elementsSize | 0) <= this.if_1.length) {
          var tmp0_7 = this.if_1;
          // Inline function 'kotlin.collections.copyInto' call
          var destination_0 = this.if_1;
          arrayCopy(tmp0_7, destination_0, shiftedInternalIndex, internalIndex, tail);
        } else {
          if (shiftedInternalIndex >= this.if_1.length) {
            var tmp0_8 = this.if_1;
            var tmp2_6 = this.if_1;
            // Inline function 'kotlin.collections.copyInto' call
            var destinationOffset_1 = shiftedInternalIndex - this.if_1.length | 0;
            arrayCopy(tmp0_8, tmp2_6, destinationOffset_1, internalIndex, tail);
          } else {
            var shiftToFront = (tail + elementsSize | 0) - this.if_1.length | 0;
            var tmp0_9 = this.if_1;
            var tmp2_7 = this.if_1;
            // Inline function 'kotlin.collections.copyInto' call
            var startIndex_2 = tail - shiftToFront | 0;
            arrayCopy(tmp0_9, tmp2_7, 0, startIndex_2, tail);
            var tmp0_10 = this.if_1;
            var tmp2_8 = this.if_1;
            // Inline function 'kotlin.collections.copyInto' call
            var endIndex_1 = tail - shiftToFront | 0;
            arrayCopy(tmp0_10, tmp2_8, shiftedInternalIndex, internalIndex, endIndex_1);
          }
        }
      } else {
        var tmp0_11 = this.if_1;
        // Inline function 'kotlin.collections.copyInto' call
        var destination_1 = this.if_1;
        arrayCopy(tmp0_11, destination_1, elementsSize, 0, tail);
        if (shiftedInternalIndex >= this.if_1.length) {
          var tmp0_12 = this.if_1;
          var tmp2_9 = this.if_1;
          var tmp4_3 = shiftedInternalIndex - this.if_1.length | 0;
          // Inline function 'kotlin.collections.copyInto' call
          var endIndex_2 = this.if_1.length;
          arrayCopy(tmp0_12, tmp2_9, tmp4_3, internalIndex, endIndex_2);
        } else {
          var tmp0_13 = this.if_1;
          var tmp2_10 = this.if_1;
          var tmp6_1 = this.if_1.length - elementsSize | 0;
          // Inline function 'kotlin.collections.copyInto' call
          var endIndex_3 = this.if_1.length;
          arrayCopy(tmp0_13, tmp2_10, 0, tmp6_1, endIndex_3);
          var tmp0_14 = this.if_1;
          var tmp2_11 = this.if_1;
          // Inline function 'kotlin.collections.copyInto' call
          var endIndex_4 = this.if_1.length - elementsSize | 0;
          arrayCopy(tmp0_14, tmp2_11, shiftedInternalIndex, internalIndex, endIndex_4);
        }
      }
      copyCollectionElements(this, internalIndex, elements);
    }
    return true;
  };
  protoOf(ArrayDeque).r = function (index) {
    Companion_instance_6.b4(index, this.jf_1);
    // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
    // Inline function 'kotlin.collections.ArrayDeque.internalGet' call
    var internalIndex = positiveMod(this, this.hf_1 + index | 0);
    var tmp = this.if_1[internalIndex];
    return (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
  };
  protoOf(ArrayDeque).l2 = function (index, element) {
    Companion_instance_6.b4(index, this.jf_1);
    // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
    var internalIndex = positiveMod(this, this.hf_1 + index | 0);
    // Inline function 'kotlin.collections.ArrayDeque.internalGet' call
    var tmp = this.if_1[internalIndex];
    var oldElement = (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
    this.if_1[internalIndex] = element;
    return oldElement;
  };
  protoOf(ArrayDeque).t = function (element) {
    return !(this.w(element) === -1);
  };
  protoOf(ArrayDeque).w = function (element) {
    // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
    var index = this.jf_1;
    var tail = positiveMod(this, this.hf_1 + index | 0);
    if (this.hf_1 < tail) {
      var inductionVariable = this.hf_1;
      if (inductionVariable < tail)
        do {
          var index_0 = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          if (equals(element, this.if_1[index_0]))
            return index_0 - this.hf_1 | 0;
        }
         while (inductionVariable < tail);
    } else if (this.hf_1 >= tail) {
      var inductionVariable_0 = this.hf_1;
      var last = this.if_1.length;
      if (inductionVariable_0 < last)
        do {
          var index_1 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          if (equals(element, this.if_1[index_1]))
            return index_1 - this.hf_1 | 0;
        }
         while (inductionVariable_0 < last);
      var inductionVariable_1 = 0;
      if (inductionVariable_1 < tail)
        do {
          var index_2 = inductionVariable_1;
          inductionVariable_1 = inductionVariable_1 + 1 | 0;
          if (equals(element, this.if_1[index_2]))
            return (index_2 + this.if_1.length | 0) - this.hf_1 | 0;
        }
         while (inductionVariable_1 < tail);
    }
    return -1;
  };
  protoOf(ArrayDeque).v = function (element) {
    // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
    var index = this.jf_1;
    var tail = positiveMod(this, this.hf_1 + index | 0);
    if (this.hf_1 < tail) {
      var inductionVariable = tail - 1 | 0;
      var last = this.hf_1;
      if (last <= inductionVariable)
        do {
          var index_0 = inductionVariable;
          inductionVariable = inductionVariable + -1 | 0;
          if (equals(element, this.if_1[index_0]))
            return index_0 - this.hf_1 | 0;
        }
         while (!(index_0 === last));
    } else if (this.hf_1 > tail) {
      var inductionVariable_0 = tail - 1 | 0;
      if (0 <= inductionVariable_0)
        do {
          var index_1 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + -1 | 0;
          if (equals(element, this.if_1[index_1]))
            return (index_1 + this.if_1.length | 0) - this.hf_1 | 0;
        }
         while (0 <= inductionVariable_0);
      var inductionVariable_1 = get_lastIndex_0(this.if_1);
      var last_0 = this.hf_1;
      if (last_0 <= inductionVariable_1)
        do {
          var index_2 = inductionVariable_1;
          inductionVariable_1 = inductionVariable_1 + -1 | 0;
          if (equals(element, this.if_1[index_2]))
            return index_2 - this.hf_1 | 0;
        }
         while (!(index_2 === last_0));
    }
    return -1;
  };
  protoOf(ArrayDeque).h2 = function (element) {
    var index = this.w(element);
    if (index === -1)
      return false;
    this.n2(index);
    return true;
  };
  protoOf(ArrayDeque).n2 = function (index) {
    Companion_instance_6.b4(index, this.jf_1);
    if (index === get_lastIndex_2(this)) {
      return this.sf();
    } else if (index === 0) {
      return this.qf();
    }
    registerModification_0(this);
    // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
    var internalIndex = positiveMod(this, this.hf_1 + index | 0);
    // Inline function 'kotlin.collections.ArrayDeque.internalGet' call
    var tmp = this.if_1[internalIndex];
    var element = (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
    if (index < this.jf_1 >> 1) {
      if (internalIndex >= this.hf_1) {
        var tmp0 = this.if_1;
        var tmp2 = this.if_1;
        var tmp4 = this.hf_1 + 1 | 0;
        // Inline function 'kotlin.collections.copyInto' call
        var startIndex = this.hf_1;
        arrayCopy(tmp0, tmp2, tmp4, startIndex, internalIndex);
      } else {
        var tmp0_0 = this.if_1;
        // Inline function 'kotlin.collections.copyInto' call
        var destination = this.if_1;
        arrayCopy(tmp0_0, destination, 1, 0, internalIndex);
        this.if_1[0] = this.if_1[this.if_1.length - 1 | 0];
        var tmp0_1 = this.if_1;
        var tmp2_0 = this.if_1;
        var tmp4_0 = this.hf_1 + 1 | 0;
        var tmp6 = this.hf_1;
        // Inline function 'kotlin.collections.copyInto' call
        var endIndex = this.if_1.length - 1 | 0;
        arrayCopy(tmp0_1, tmp2_0, tmp4_0, tmp6, endIndex);
      }
      this.if_1[this.hf_1] = null;
      this.hf_1 = incremented(this, this.hf_1);
    } else {
      // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
      var index_0 = get_lastIndex_2(this);
      var internalLastIndex = positiveMod(this, this.hf_1 + index_0 | 0);
      if (internalIndex <= internalLastIndex) {
        var tmp0_2 = this.if_1;
        var tmp2_1 = this.if_1;
        var tmp6_0 = internalIndex + 1 | 0;
        // Inline function 'kotlin.collections.copyInto' call
        var endIndex_0 = internalLastIndex + 1 | 0;
        arrayCopy(tmp0_2, tmp2_1, internalIndex, tmp6_0, endIndex_0);
      } else {
        var tmp0_3 = this.if_1;
        var tmp2_2 = this.if_1;
        var tmp6_1 = internalIndex + 1 | 0;
        // Inline function 'kotlin.collections.copyInto' call
        var endIndex_1 = this.if_1.length;
        arrayCopy(tmp0_3, tmp2_2, internalIndex, tmp6_1, endIndex_1);
        this.if_1[this.if_1.length - 1 | 0] = this.if_1[0];
        var tmp0_4 = this.if_1;
        var tmp2_3 = this.if_1;
        // Inline function 'kotlin.collections.copyInto' call
        var endIndex_2 = internalLastIndex + 1 | 0;
        arrayCopy(tmp0_4, tmp2_3, 0, 1, endIndex_2);
      }
      this.if_1[internalLastIndex] = null;
    }
    this.jf_1 = this.jf_1 - 1 | 0;
    return element;
  };
  protoOf(ArrayDeque).j1 = function (elements) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.ArrayDeque.filterInPlace' call
      var tmp;
      if (this.s()) {
        tmp = true;
      } else {
        // Inline function 'kotlin.collections.isEmpty' call
        tmp = this.if_1.length === 0;
      }
      if (tmp) {
        tmp$ret$1 = false;
        break $l$block;
      }
      // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
      var index = this.jf_1;
      var tail = positiveMod(this, this.hf_1 + index | 0);
      var newTail = this.hf_1;
      var modified = false;
      if (this.hf_1 < tail) {
        var inductionVariable = this.hf_1;
        if (inductionVariable < tail)
          do {
            var index_0 = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var element = this.if_1[index_0];
            var it = (element == null ? true : !(element == null)) ? element : THROW_CCE();
            if (!elements.t(it)) {
              var tmp_0 = this.if_1;
              var _unary__edvuaz = newTail;
              newTail = _unary__edvuaz + 1 | 0;
              tmp_0[_unary__edvuaz] = element;
            } else {
              modified = true;
            }
          }
           while (inductionVariable < tail);
        fill_0(this.if_1, null, newTail, tail);
      } else {
        var inductionVariable_0 = this.hf_1;
        var last = this.if_1.length;
        if (inductionVariable_0 < last)
          do {
            var index_1 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var element_0 = this.if_1[index_1];
            this.if_1[index_1] = null;
            var it_0 = (element_0 == null ? true : !(element_0 == null)) ? element_0 : THROW_CCE();
            if (!elements.t(it_0)) {
              var tmp_1 = this.if_1;
              var _unary__edvuaz_0 = newTail;
              newTail = _unary__edvuaz_0 + 1 | 0;
              tmp_1[_unary__edvuaz_0] = element_0;
            } else {
              modified = true;
            }
          }
           while (inductionVariable_0 < last);
        newTail = positiveMod(this, newTail);
        var inductionVariable_1 = 0;
        if (inductionVariable_1 < tail)
          do {
            var index_2 = inductionVariable_1;
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            var element_1 = this.if_1[index_2];
            this.if_1[index_2] = null;
            var it_1 = (element_1 == null ? true : !(element_1 == null)) ? element_1 : THROW_CCE();
            if (!elements.t(it_1)) {
              this.if_1[newTail] = element_1;
              newTail = incremented(this, newTail);
            } else {
              modified = true;
            }
          }
           while (inductionVariable_1 < tail);
      }
      if (modified) {
        registerModification_0(this);
        this.jf_1 = negativeMod(this, newTail - this.hf_1 | 0);
      }
      tmp$ret$1 = modified;
    }
    return tmp$ret$1;
  };
  protoOf(ArrayDeque).j2 = function (elements) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.ArrayDeque.filterInPlace' call
      var tmp;
      if (this.s()) {
        tmp = true;
      } else {
        // Inline function 'kotlin.collections.isEmpty' call
        tmp = this.if_1.length === 0;
      }
      if (tmp) {
        tmp$ret$1 = false;
        break $l$block;
      }
      // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
      var index = this.jf_1;
      var tail = positiveMod(this, this.hf_1 + index | 0);
      var newTail = this.hf_1;
      var modified = false;
      if (this.hf_1 < tail) {
        var inductionVariable = this.hf_1;
        if (inductionVariable < tail)
          do {
            var index_0 = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var element = this.if_1[index_0];
            var it = (element == null ? true : !(element == null)) ? element : THROW_CCE();
            if (elements.t(it)) {
              var tmp_0 = this.if_1;
              var _unary__edvuaz = newTail;
              newTail = _unary__edvuaz + 1 | 0;
              tmp_0[_unary__edvuaz] = element;
            } else {
              modified = true;
            }
          }
           while (inductionVariable < tail);
        fill_0(this.if_1, null, newTail, tail);
      } else {
        var inductionVariable_0 = this.hf_1;
        var last = this.if_1.length;
        if (inductionVariable_0 < last)
          do {
            var index_1 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var element_0 = this.if_1[index_1];
            this.if_1[index_1] = null;
            var it_0 = (element_0 == null ? true : !(element_0 == null)) ? element_0 : THROW_CCE();
            if (elements.t(it_0)) {
              var tmp_1 = this.if_1;
              var _unary__edvuaz_0 = newTail;
              newTail = _unary__edvuaz_0 + 1 | 0;
              tmp_1[_unary__edvuaz_0] = element_0;
            } else {
              modified = true;
            }
          }
           while (inductionVariable_0 < last);
        newTail = positiveMod(this, newTail);
        var inductionVariable_1 = 0;
        if (inductionVariable_1 < tail)
          do {
            var index_2 = inductionVariable_1;
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            var element_1 = this.if_1[index_2];
            this.if_1[index_2] = null;
            var it_1 = (element_1 == null ? true : !(element_1 == null)) ? element_1 : THROW_CCE();
            if (elements.t(it_1)) {
              this.if_1[newTail] = element_1;
              newTail = incremented(this, newTail);
            } else {
              modified = true;
            }
          }
           while (inductionVariable_1 < tail);
      }
      if (modified) {
        registerModification_0(this);
        this.jf_1 = negativeMod(this, newTail - this.hf_1 | 0);
      }
      tmp$ret$1 = modified;
    }
    return tmp$ret$1;
  };
  protoOf(ArrayDeque).k2 = function () {
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!this.s()) {
      registerModification_0(this);
      // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
      var index = this.jf_1;
      var tail = positiveMod(this, this.hf_1 + index | 0);
      nullifyNonEmpty(this, this.hf_1, tail);
    }
    this.hf_1 = 0;
    this.jf_1 = 0;
  };
  protoOf(ArrayDeque).tf = function (array) {
    var tmp = array.length >= this.jf_1 ? array : arrayOfNulls(array, this.jf_1);
    var dest = isArray(tmp) ? tmp : THROW_CCE();
    // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
    var index = this.jf_1;
    var tail = positiveMod(this, this.hf_1 + index | 0);
    if (this.hf_1 < tail) {
      var tmp0 = this.if_1;
      // Inline function 'kotlin.collections.copyInto' call
      var startIndex = this.hf_1;
      arrayCopy(tmp0, dest, 0, startIndex, tail);
    } else {
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!this.s()) {
        var tmp0_0 = this.if_1;
        var tmp6 = this.hf_1;
        // Inline function 'kotlin.collections.copyInto' call
        var endIndex = this.if_1.length;
        arrayCopy(tmp0_0, dest, 0, tmp6, endIndex);
        var tmp0_1 = this.if_1;
        // Inline function 'kotlin.collections.copyInto' call
        var destinationOffset = this.if_1.length - this.hf_1 | 0;
        arrayCopy(tmp0_1, dest, destinationOffset, 0, tail);
      }
    }
    var tmp_0 = terminateCollectionToArray(this.jf_1, dest);
    return isArray(tmp_0) ? tmp_0 : THROW_CCE();
  };
  protoOf(ArrayDeque).p5 = function () {
    // Inline function 'kotlin.arrayOfNulls' call
    var size = this.jf_1;
    var tmp$ret$0 = Array(size);
    return this.tf(tmp$ret$0);
  };
  protoOf(ArrayDeque).toArray = function () {
    return this.p5();
  };
  protoOf(ArrayDeque).z4 = function (fromIndex, toIndex) {
    Companion_instance_6.r3(fromIndex, toIndex, this.jf_1);
    var length = toIndex - fromIndex | 0;
    if (length === 0)
      return Unit_instance;
    else if (length === this.jf_1) {
      this.k2();
      return Unit_instance;
    } else if (length === 1) {
      this.n2(fromIndex);
      return Unit_instance;
    }
    registerModification_0(this);
    if (fromIndex < (this.jf_1 - toIndex | 0)) {
      removeRangeShiftPreceding(this, fromIndex, toIndex);
      var newHead = positiveMod(this, this.hf_1 + length | 0);
      nullifyNonEmpty(this, this.hf_1, newHead);
      this.hf_1 = newHead;
    } else {
      removeRangeShiftSucceeding(this, fromIndex, toIndex);
      // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
      var index = this.jf_1;
      var tail = positiveMod(this, this.hf_1 + index | 0);
      nullifyNonEmpty(this, negativeMod(this, tail - length | 0), tail);
    }
    this.jf_1 = this.jf_1 - length | 0;
  };
  function ArrayDeque() {
    Companion_getInstance_9();
    this.hf_1 = 0;
    this.jf_1 = 0;
  }
  function collectionToArrayCommonImpl(collection) {
    if (collection.s()) {
      // Inline function 'kotlin.emptyArray' call
      return [];
    }
    // Inline function 'kotlin.arrayOfNulls' call
    var size = collection.p();
    var destination = Array(size);
    var iterator = collection.m();
    var index = 0;
    while (iterator.n()) {
      var _unary__edvuaz = index;
      index = _unary__edvuaz + 1 | 0;
      destination[_unary__edvuaz] = iterator.o();
    }
    return destination;
  }
  function listOf_0(elements) {
    return elements.length > 0 ? asList(elements) : emptyList();
  }
  function emptyList() {
    return EmptyList_instance;
  }
  function get_lastIndex_2(_this__u8e3s4) {
    return _this__u8e3s4.p() - 1 | 0;
  }
  function arrayListOf(elements) {
    var tmp;
    if (elements.length === 0) {
      tmp = ArrayList_init_$Create$();
    } else {
      // Inline function 'kotlin.collections.asArrayList' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = new ArrayList(elements);
    }
    return tmp;
  }
  function mutableListOf(elements) {
    var tmp;
    if (elements.length === 0) {
      tmp = ArrayList_init_$Create$();
    } else {
      // Inline function 'kotlin.collections.asArrayList' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = new ArrayList(elements);
    }
    return tmp;
  }
  function listOfNotNull(element) {
    return !(element == null) ? listOf(element) : emptyList();
  }
  function get_indices_1(_this__u8e3s4) {
    return numberRangeToNumber(0, _this__u8e3s4.p() - 1 | 0);
  }
  function binarySearch(_this__u8e3s4, element, comparator, fromIndex, toIndex) {
    fromIndex = fromIndex === VOID ? 0 : fromIndex;
    toIndex = toIndex === VOID ? _this__u8e3s4.p() : toIndex;
    rangeCheck_0(_this__u8e3s4.p(), fromIndex, toIndex);
    var low = fromIndex;
    var high = toIndex - 1 | 0;
    while (low <= high) {
      var mid = (low + high | 0) >>> 1 | 0;
      var midVal = _this__u8e3s4.r(mid);
      var cmp = comparator.compare(midVal, element);
      if (cmp < 0)
        low = mid + 1 | 0;
      else if (cmp > 0)
        high = mid - 1 | 0;
      else
        return mid;
    }
    return -(low + 1 | 0) | 0;
  }
  function optimizeReadOnlyList(_this__u8e3s4) {
    switch (_this__u8e3s4.p()) {
      case 0:
        return emptyList();
      case 1:
        return listOf(_this__u8e3s4.r(0));
      default:
        return _this__u8e3s4;
    }
  }
  function EmptyList() {
    this.uf_1 = -7390468764508069838n;
  }
  protoOf(EmptyList).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, KtList) : false) {
      tmp = other.s();
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(EmptyList).hashCode = function () {
    return 1;
  };
  protoOf(EmptyList).toString = function () {
    return '[]';
  };
  protoOf(EmptyList).p = function () {
    return 0;
  };
  protoOf(EmptyList).s = function () {
    return true;
  };
  protoOf(EmptyList).vf = function (element) {
    return false;
  };
  protoOf(EmptyList).t = function (element) {
    if (!false)
      return false;
    var tmp;
    if (false) {
      tmp = element;
    } else {
      tmp = THROW_CCE();
    }
    return this.vf(tmp);
  };
  protoOf(EmptyList).wf = function (elements) {
    return elements.s();
  };
  protoOf(EmptyList).e2 = function (elements) {
    return this.wf(elements);
  };
  protoOf(EmptyList).r = function (index) {
    throw IndexOutOfBoundsException_init_$Create$_0("Empty list doesn't contain element at index " + index + '.');
  };
  protoOf(EmptyList).xf = function (element) {
    return -1;
  };
  protoOf(EmptyList).w = function (element) {
    if (!false)
      return -1;
    var tmp;
    if (false) {
      tmp = element;
    } else {
      tmp = THROW_CCE();
    }
    return this.xf(tmp);
  };
  protoOf(EmptyList).yf = function (element) {
    return -1;
  };
  protoOf(EmptyList).v = function (element) {
    if (!false)
      return -1;
    var tmp;
    if (false) {
      tmp = element;
    } else {
      tmp = THROW_CCE();
    }
    return this.yf(tmp);
  };
  protoOf(EmptyList).m = function () {
    return EmptyIterator_instance;
  };
  protoOf(EmptyList).f2 = function () {
    return EmptyIterator_instance;
  };
  protoOf(EmptyList).u = function (index) {
    if (!(index === 0))
      throw IndexOutOfBoundsException_init_$Create$_0('Index: ' + index);
    return EmptyIterator_instance;
  };
  protoOf(EmptyList).g2 = function (fromIndex, toIndex) {
    if (fromIndex === 0 && toIndex === 0)
      return this;
    throw IndexOutOfBoundsException_init_$Create$_0('fromIndex: ' + fromIndex + ', toIndex: ' + toIndex);
  };
  var EmptyList_instance;
  function EmptyList_getInstance() {
    return EmptyList_instance;
  }
  function rangeCheck_0(size, fromIndex, toIndex) {
    if (fromIndex > toIndex)
      throw IllegalArgumentException_init_$Create$_0('fromIndex (' + fromIndex + ') is greater than toIndex (' + toIndex + ').');
    else if (fromIndex < 0)
      throw IndexOutOfBoundsException_init_$Create$_0('fromIndex (' + fromIndex + ') is less than zero.');
    else if (toIndex > size)
      throw IndexOutOfBoundsException_init_$Create$_0('toIndex (' + toIndex + ') is greater than size (' + size + ').');
  }
  function EmptyIterator() {
  }
  protoOf(EmptyIterator).n = function () {
    return false;
  };
  protoOf(EmptyIterator).r4 = function () {
    return false;
  };
  protoOf(EmptyIterator).s4 = function () {
    return 0;
  };
  protoOf(EmptyIterator).u4 = function () {
    return -1;
  };
  protoOf(EmptyIterator).o = function () {
    throw NoSuchElementException_init_$Create$();
  };
  protoOf(EmptyIterator).t4 = function () {
    throw NoSuchElementException_init_$Create$();
  };
  var EmptyIterator_instance;
  function EmptyIterator_getInstance() {
    return EmptyIterator_instance;
  }
  function throwIndexOverflow() {
    throw ArithmeticException_init_$Create$_0('Index overflow has happened.');
  }
  function asCollection(_this__u8e3s4, isVarargs) {
    isVarargs = isVarargs === VOID ? false : isVarargs;
    return new ArrayAsCollection(_this__u8e3s4, isVarargs);
  }
  function ArrayAsCollection(values, isVarargs) {
    this.zf_1 = values;
    this.ag_1 = isVarargs;
  }
  protoOf(ArrayAsCollection).p = function () {
    return this.zf_1.length;
  };
  protoOf(ArrayAsCollection).s = function () {
    // Inline function 'kotlin.collections.isEmpty' call
    return this.zf_1.length === 0;
  };
  protoOf(ArrayAsCollection).bg = function (element) {
    return contains_0(this.zf_1, element);
  };
  protoOf(ArrayAsCollection).t = function (element) {
    if (!(element == null ? true : !(element == null)))
      return false;
    return this.bg((element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  protoOf(ArrayAsCollection).cg = function (elements) {
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var tmp;
      if (isInterface(elements, Collection)) {
        tmp = elements.s();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
      var _iterator__ex2g4s = elements.m();
      while (_iterator__ex2g4s.n()) {
        var element = _iterator__ex2g4s.o();
        if (!this.bg(element)) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
      }
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  };
  protoOf(ArrayAsCollection).e2 = function (elements) {
    return this.cg(elements);
  };
  protoOf(ArrayAsCollection).m = function () {
    return arrayIterator(this.zf_1);
  };
  function IndexedValue(index, value) {
    this.dg_1 = index;
    this.eg_1 = value;
  }
  protoOf(IndexedValue).fg = function () {
    return this.dg_1;
  };
  protoOf(IndexedValue).gg = function () {
    return this.eg_1;
  };
  protoOf(IndexedValue).toString = function () {
    return 'IndexedValue(index=' + this.dg_1 + ', value=' + toString_0(this.eg_1) + ')';
  };
  protoOf(IndexedValue).hashCode = function () {
    var result = this.dg_1;
    result = imul(result, 31) + (this.eg_1 == null ? 0 : hashCode(this.eg_1)) | 0;
    return result;
  };
  protoOf(IndexedValue).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof IndexedValue))
      return false;
    if (!(this.dg_1 === other.dg_1))
      return false;
    if (!equals(this.eg_1, other.eg_1))
      return false;
    return true;
  };
  function flatten(_this__u8e3s4) {
    var result = ArrayList_init_$Create$();
    var _iterator__ex2g4s = _this__u8e3s4.m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      addAll_1(result, element);
    }
    return result;
  }
  function IndexingIterable(iteratorFactory) {
    this.hg_1 = iteratorFactory;
  }
  protoOf(IndexingIterable).m = function () {
    return new IndexingIterator(this.hg_1());
  };
  function collectionSizeOrDefault(_this__u8e3s4, default_0) {
    var tmp;
    if (isInterface(_this__u8e3s4, Collection)) {
      tmp = _this__u8e3s4.p();
    } else {
      tmp = default_0;
    }
    return tmp;
  }
  function collectionSizeOrNull(_this__u8e3s4) {
    var tmp;
    if (isInterface(_this__u8e3s4, Collection)) {
      tmp = _this__u8e3s4.p();
    } else {
      tmp = null;
    }
    return tmp;
  }
  function IndexingIterator(iterator) {
    this.ig_1 = iterator;
    this.jg_1 = 0;
  }
  protoOf(IndexingIterator).n = function () {
    return this.ig_1.n();
  };
  protoOf(IndexingIterator).o = function () {
    var _unary__edvuaz = this.jg_1;
    this.jg_1 = _unary__edvuaz + 1 | 0;
    return new IndexedValue(checkIndexOverflow(_unary__edvuaz), this.ig_1.o());
  };
  function getOrImplicitDefault(_this__u8e3s4, key) {
    if (isInterface(_this__u8e3s4, MapWithDefault))
      return _this__u8e3s4.kg(key);
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlin.collections.getOrElseNullable' call
      var value = _this__u8e3s4.q2(key);
      if (value == null && !_this__u8e3s4.o2(key)) {
        throw NoSuchElementException_init_$Create$_0('Key ' + toString_0(key) + ' is missing in the map.');
      } else {
        tmp$ret$0 = (value == null ? true : !(value == null)) ? value : THROW_CCE();
        break $l$block;
      }
    }
    return tmp$ret$0;
  }
  function MapWithDefault() {
  }
  function mapOf_0(pairs) {
    return pairs.length > 0 ? toMap_1(pairs, LinkedHashMap_init_$Create$_0(mapCapacity(pairs.length))) : emptyMap();
  }
  function getValue_0(_this__u8e3s4, key) {
    return getOrImplicitDefault(_this__u8e3s4, key);
  }
  function emptyMap() {
    var tmp = EmptyMap_instance;
    return isInterface(tmp, KtMap) ? tmp : THROW_CCE();
  }
  function toMutableMap(_this__u8e3s4) {
    return LinkedHashMap_init_$Create$_1(_this__u8e3s4);
  }
  function toMap(_this__u8e3s4) {
    var tmp;
    switch (_this__u8e3s4.p()) {
      case 0:
        tmp = emptyMap();
        break;
      case 1:
        // Inline function 'kotlin.collections.toSingletonMap' call

        tmp = toMutableMap(_this__u8e3s4);
        break;
      default:
        tmp = toMutableMap(_this__u8e3s4);
        break;
    }
    return tmp;
  }
  function toMap_0(_this__u8e3s4) {
    if (isInterface(_this__u8e3s4, Collection)) {
      var tmp;
      switch (_this__u8e3s4.p()) {
        case 0:
          tmp = emptyMap();
          break;
        case 1:
          var tmp_0;
          if (isInterface(_this__u8e3s4, KtList)) {
            tmp_0 = _this__u8e3s4.r(0);
          } else {
            tmp_0 = _this__u8e3s4.m().o();
          }

          tmp = mapOf(tmp_0);
          break;
        default:
          tmp = toMap_2(_this__u8e3s4, LinkedHashMap_init_$Create$_0(mapCapacity(_this__u8e3s4.p())));
          break;
      }
      return tmp;
    }
    return optimizeReadOnlyMap(toMap_2(_this__u8e3s4, LinkedHashMap_init_$Create$()));
  }
  function hashMapOf(pairs) {
    // Inline function 'kotlin.apply' call
    var this_0 = HashMap_init_$Create$_0(mapCapacity(pairs.length));
    putAll(this_0, pairs);
    return this_0;
  }
  function toMap_1(_this__u8e3s4, destination) {
    // Inline function 'kotlin.apply' call
    putAll(destination, _this__u8e3s4);
    return destination;
  }
  function EmptyMap() {
    this.lg_1 = 8246714829545688274n;
  }
  protoOf(EmptyMap).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, KtMap) : false) {
      tmp = other.s();
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(EmptyMap).hashCode = function () {
    return 0;
  };
  protoOf(EmptyMap).toString = function () {
    return '{}';
  };
  protoOf(EmptyMap).p = function () {
    return 0;
  };
  protoOf(EmptyMap).s = function () {
    return true;
  };
  protoOf(EmptyMap).mg = function (key) {
    return false;
  };
  protoOf(EmptyMap).o2 = function (key) {
    if (!(key == null ? true : !(key == null)))
      return false;
    return this.mg((key == null ? true : !(key == null)) ? key : THROW_CCE());
  };
  protoOf(EmptyMap).ng = function (value) {
    return false;
  };
  protoOf(EmptyMap).p2 = function (value) {
    if (!false)
      return false;
    var tmp;
    if (false) {
      tmp = value;
    } else {
      tmp = THROW_CCE();
    }
    return this.ng(tmp);
  };
  protoOf(EmptyMap).og = function (key) {
    return null;
  };
  protoOf(EmptyMap).q2 = function (key) {
    if (!(key == null ? true : !(key == null)))
      return null;
    return this.og((key == null ? true : !(key == null)) ? key : THROW_CCE());
  };
  protoOf(EmptyMap).y = function () {
    return EmptySet_instance;
  };
  protoOf(EmptyMap).r2 = function () {
    return EmptySet_instance;
  };
  protoOf(EmptyMap).s2 = function () {
    return EmptyList_instance;
  };
  var EmptyMap_instance;
  function EmptyMap_getInstance() {
    return EmptyMap_instance;
  }
  function toMap_2(_this__u8e3s4, destination) {
    // Inline function 'kotlin.apply' call
    putAll_0(destination, _this__u8e3s4);
    return destination;
  }
  function optimizeReadOnlyMap(_this__u8e3s4) {
    var tmp;
    switch (_this__u8e3s4.p()) {
      case 0:
        tmp = emptyMap();
        break;
      case 1:
        // Inline function 'kotlin.collections.toSingletonMapOrSelf' call

        tmp = _this__u8e3s4;
        break;
      default:
        tmp = _this__u8e3s4;
        break;
    }
    return tmp;
  }
  function putAll(_this__u8e3s4, pairs) {
    var inductionVariable = 0;
    var last = pairs.length;
    while (inductionVariable < last) {
      var _destruct__k2r9zo = pairs[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      var key = _destruct__k2r9zo.fg();
      var value = _destruct__k2r9zo.gg();
      _this__u8e3s4.t2(key, value);
    }
  }
  function putAll_0(_this__u8e3s4, pairs) {
    var _iterator__ex2g4s = pairs.m();
    while (_iterator__ex2g4s.n()) {
      var _destruct__k2r9zo = _iterator__ex2g4s.o();
      var key = _destruct__k2r9zo.fg();
      var value = _destruct__k2r9zo.gg();
      _this__u8e3s4.t2(key, value);
    }
  }
  function addAll_0(_this__u8e3s4, elements) {
    return _this__u8e3s4.q(asList(elements));
  }
  function removeLast(_this__u8e3s4) {
    var tmp;
    if (_this__u8e3s4.s()) {
      throw NoSuchElementException_init_$Create$_0('List is empty.');
    } else {
      tmp = _this__u8e3s4.n2(get_lastIndex_2(_this__u8e3s4));
    }
    return tmp;
  }
  function removeFirstOrNull(_this__u8e3s4) {
    return _this__u8e3s4.s() ? null : _this__u8e3s4.n2(0);
  }
  function addAll_1(_this__u8e3s4, elements) {
    if (isInterface(elements, Collection))
      return _this__u8e3s4.q(elements);
    else {
      var result = false;
      var _iterator__ex2g4s = elements.m();
      while (_iterator__ex2g4s.n()) {
        var item = _iterator__ex2g4s.o();
        if (_this__u8e3s4.j(item))
          result = true;
      }
      return result;
    }
  }
  function convertToListIfNotCollection(_this__u8e3s4) {
    var tmp;
    if (isInterface(_this__u8e3s4, Collection)) {
      tmp = _this__u8e3s4;
    } else {
      tmp = toList_0(_this__u8e3s4);
    }
    return tmp;
  }
  function removeAll(_this__u8e3s4, elements) {
    return _this__u8e3s4.j1(convertToListIfNotCollection(elements));
  }
  function retainAll(_this__u8e3s4, elements) {
    return _this__u8e3s4.j2(convertToListIfNotCollection(elements));
  }
  function addAll_2(_this__u8e3s4, elements) {
    var result = false;
    var _iterator__ex2g4s = elements.m();
    while (_iterator__ex2g4s.n()) {
      var item = _iterator__ex2g4s.o();
      if (_this__u8e3s4.j(item))
        result = true;
    }
    return result;
  }
  function removeAll_0(_this__u8e3s4, predicate) {
    return filterInPlace(_this__u8e3s4, predicate, true);
  }
  function removeAll_1(_this__u8e3s4, predicate) {
    return filterInPlace_0(_this__u8e3s4, predicate, true);
  }
  function filterInPlace(_this__u8e3s4, predicate, predicateResultToRemove) {
    if (!isInterface(_this__u8e3s4, RandomAccess)) {
      return filterInPlace_0(isInterface(_this__u8e3s4, MutableIterable) ? _this__u8e3s4 : THROW_CCE(), predicate, predicateResultToRemove);
    }
    var writeIndex = 0;
    var inductionVariable = 0;
    var last = get_lastIndex_2(_this__u8e3s4);
    if (inductionVariable <= last)
      $l$loop: do {
        var readIndex = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var element = _this__u8e3s4.r(readIndex);
        if (predicate(element) === predicateResultToRemove)
          continue $l$loop;
        if (!(writeIndex === readIndex)) {
          _this__u8e3s4.l2(writeIndex, element);
        }
        writeIndex = writeIndex + 1 | 0;
      }
       while (!(readIndex === last));
    if (writeIndex < _this__u8e3s4.p()) {
      var inductionVariable_0 = get_lastIndex_2(_this__u8e3s4);
      var last_0 = writeIndex;
      if (last_0 <= inductionVariable_0)
        do {
          var removeIndex = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + -1 | 0;
          _this__u8e3s4.n2(removeIndex);
        }
         while (!(removeIndex === last_0));
      return true;
    } else {
      return false;
    }
  }
  function filterInPlace_0(_this__u8e3s4, predicate, predicateResultToRemove) {
    var result = false;
    // Inline function 'kotlin.with' call
    var $this$with = _this__u8e3s4.m();
    while ($this$with.n())
      if (predicate($this$with.o()) === predicateResultToRemove) {
        $this$with.h4();
        result = true;
      }
    return result;
  }
  function IntIterator() {
  }
  protoOf(IntIterator).o = function () {
    return this.rg();
  };
  function CharIterator() {
  }
  protoOf(CharIterator).sg = function () {
    return this.tg();
  };
  protoOf(CharIterator).o = function () {
    return new Char(this.sg());
  };
  function asReversed(_this__u8e3s4) {
    return new ReversedList(_this__u8e3s4);
  }
  function asReversed_0(_this__u8e3s4) {
    return new ReversedListReadOnly(_this__u8e3s4);
  }
  function ReversedList$listIterator$1(this$0, $index) {
    this.vg_1 = this$0;
    this.ug_1 = this$0.xg_1.u(reversePositionIndex(this$0, $index));
  }
  protoOf(ReversedList$listIterator$1).n = function () {
    return this.ug_1.r4();
  };
  protoOf(ReversedList$listIterator$1).r4 = function () {
    return this.ug_1.n();
  };
  protoOf(ReversedList$listIterator$1).o = function () {
    return this.ug_1.t4();
  };
  protoOf(ReversedList$listIterator$1).s4 = function () {
    return reverseIteratorIndex(this.vg_1, this.ug_1.u4());
  };
  protoOf(ReversedList$listIterator$1).t4 = function () {
    return this.ug_1.o();
  };
  protoOf(ReversedList$listIterator$1).u4 = function () {
    return reverseIteratorIndex(this.vg_1, this.ug_1.s4());
  };
  protoOf(ReversedList$listIterator$1).h4 = function () {
    return this.ug_1.h4();
  };
  function ReversedList(delegate) {
    AbstractMutableList.call(this);
    this.xg_1 = delegate;
  }
  protoOf(ReversedList).p = function () {
    return this.xg_1.p();
  };
  protoOf(ReversedList).r = function (index) {
    return this.xg_1.r(reverseElementIndex(this, index));
  };
  protoOf(ReversedList).k2 = function () {
    return this.xg_1.k2();
  };
  protoOf(ReversedList).n2 = function (index) {
    return this.xg_1.n2(reverseElementIndex(this, index));
  };
  protoOf(ReversedList).yg = function (index, element) {
    return this.xg_1.l2(reverseElementIndex(this, index), element);
  };
  protoOf(ReversedList).l2 = function (index, element) {
    return this.yg(index, (element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  protoOf(ReversedList).zg = function (index, element) {
    this.xg_1.m2(reversePositionIndex(this, index), element);
  };
  protoOf(ReversedList).m2 = function (index, element) {
    return this.zg(index, (element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  protoOf(ReversedList).m = function () {
    return this.u(0);
  };
  protoOf(ReversedList).f2 = function () {
    return this.u(0);
  };
  protoOf(ReversedList).u = function (index) {
    return new ReversedList$listIterator$1(this, index);
  };
  function ReversedListReadOnly$listIterator$1(this$0, $index) {
    this.bh_1 = this$0;
    this.ah_1 = this$0.ch_1.u(reversePositionIndex(this$0, $index));
  }
  protoOf(ReversedListReadOnly$listIterator$1).n = function () {
    return this.ah_1.r4();
  };
  protoOf(ReversedListReadOnly$listIterator$1).r4 = function () {
    return this.ah_1.n();
  };
  protoOf(ReversedListReadOnly$listIterator$1).o = function () {
    return this.ah_1.t4();
  };
  protoOf(ReversedListReadOnly$listIterator$1).s4 = function () {
    return reverseIteratorIndex(this.bh_1, this.ah_1.u4());
  };
  protoOf(ReversedListReadOnly$listIterator$1).t4 = function () {
    return this.ah_1.o();
  };
  protoOf(ReversedListReadOnly$listIterator$1).u4 = function () {
    return reverseIteratorIndex(this.bh_1, this.ah_1.s4());
  };
  function ReversedListReadOnly(delegate) {
    AbstractList.call(this);
    this.ch_1 = delegate;
  }
  protoOf(ReversedListReadOnly).p = function () {
    return this.ch_1.p();
  };
  protoOf(ReversedListReadOnly).r = function (index) {
    return this.ch_1.r(reverseElementIndex(this, index));
  };
  protoOf(ReversedListReadOnly).m = function () {
    return this.u(0);
  };
  protoOf(ReversedListReadOnly).f2 = function () {
    return this.u(0);
  };
  protoOf(ReversedListReadOnly).u = function (index) {
    return new ReversedListReadOnly$listIterator$1(this, index);
  };
  function reverseElementIndex(_this__u8e3s4, index) {
    var tmp;
    if (0 <= index ? index <= get_lastIndex_2(_this__u8e3s4) : false) {
      tmp = get_lastIndex_2(_this__u8e3s4) - index | 0;
    } else {
      throw IndexOutOfBoundsException_init_$Create$_0('Element index ' + index + ' must be in range [' + numberRangeToNumber(0, get_lastIndex_2(_this__u8e3s4)).toString() + '].');
    }
    return tmp;
  }
  function reversePositionIndex(_this__u8e3s4, index) {
    var tmp;
    if (0 <= index ? index <= _this__u8e3s4.p() : false) {
      tmp = _this__u8e3s4.p() - index | 0;
    } else {
      throw IndexOutOfBoundsException_init_$Create$_0('Position index ' + index + ' must be in range [' + numberRangeToNumber(0, _this__u8e3s4.p()).toString() + '].');
    }
    return tmp;
  }
  function reverseIteratorIndex(_this__u8e3s4, index) {
    return get_lastIndex_2(_this__u8e3s4) - index | 0;
  }
  function Sequence() {
  }
  function sequence(block) {
    // Inline function 'kotlin.sequences.Sequence' call
    return new sequence$$inlined$Sequence$1(block);
  }
  function SequenceScope() {
  }
  protoOf(SequenceScope).fh = function (sequence, $completion) {
    return this.eh(sequence.m(), $completion);
  };
  function iterator(block) {
    var iterator = new SequenceBuilderIterator();
    iterator.jh_1 = createCoroutineUnintercepted(block, iterator, iterator);
    return iterator;
  }
  function nextNotReady($this) {
    if (!$this.n())
      throw NoSuchElementException_init_$Create$();
    else
      return $this.o();
  }
  function exceptionalState($this) {
    switch ($this.gh_1) {
      case 4:
        return NoSuchElementException_init_$Create$();
      case 5:
        return IllegalStateException_init_$Create$_0('Iterator has failed.');
      default:
        return IllegalStateException_init_$Create$_0('Unexpected state of the iterator: ' + $this.gh_1);
    }
  }
  function SequenceBuilderIterator() {
    SequenceScope.call(this);
    this.gh_1 = 0;
    this.hh_1 = null;
    this.ih_1 = null;
    this.jh_1 = null;
  }
  protoOf(SequenceBuilderIterator).n = function () {
    while (true) {
      switch (this.gh_1) {
        case 0:
          break;
        case 1:
          if (ensureNotNull(this.ih_1).n()) {
            this.gh_1 = 2;
            return true;
          } else {
            this.ih_1 = null;
          }

          break;
        case 4:
          return false;
        case 3:
        case 2:
          return true;
        default:
          throw exceptionalState(this);
      }
      this.gh_1 = 5;
      var step = ensureNotNull(this.jh_1);
      this.jh_1 = null;
      // Inline function 'kotlin.coroutines.resume' call
      // Inline function 'kotlin.Companion.success' call
      var tmp$ret$0 = _Result___init__impl__xyqfz8(Unit_instance);
      step.q9(tmp$ret$0);
    }
  };
  protoOf(SequenceBuilderIterator).o = function () {
    switch (this.gh_1) {
      case 0:
      case 1:
        return nextNotReady(this);
      case 2:
        this.gh_1 = 1;
        return ensureNotNull(this.ih_1).o();
      case 3:
        this.gh_1 = 0;
        var tmp = this.hh_1;
        var result = (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
        this.hh_1 = null;
        return result;
      default:
        throw exceptionalState(this);
    }
  };
  protoOf(SequenceBuilderIterator).dh = function (value, $completion) {
    this.hh_1 = value;
    this.gh_1 = 3;
    this.jh_1 = $completion;
    return get_COROUTINE_SUSPENDED();
  };
  protoOf(SequenceBuilderIterator).eh = function (iterator, $completion) {
    if (!iterator.n())
      return Unit_instance;
    this.ih_1 = iterator;
    this.gh_1 = 2;
    this.jh_1 = $completion;
    return get_COROUTINE_SUSPENDED();
  };
  protoOf(SequenceBuilderIterator).kh = function (result) {
    // Inline function 'kotlin.getOrThrow' call
    throwOnFailure(result);
    var tmp = _Result___get_value__impl__bjfvqg(result);
    if (!(tmp == null ? true : !(tmp == null)))
      THROW_CCE();
    this.gh_1 = 4;
  };
  protoOf(SequenceBuilderIterator).q9 = function (result) {
    return this.kh(result);
  };
  protoOf(SequenceBuilderIterator).l9 = function () {
    return EmptyCoroutineContext_instance;
  };
  function sequence$$inlined$Sequence$1($block) {
    this.lh_1 = $block;
  }
  protoOf(sequence$$inlined$Sequence$1).m = function () {
    return iterator(this.lh_1);
  };
  function asSequence_2(_this__u8e3s4) {
    // Inline function 'kotlin.sequences.Sequence' call
    var tmp$ret$0 = new asSequence$$inlined$Sequence$1_1(_this__u8e3s4);
    return constrainOnce(tmp$ret$0);
  }
  function generateSequence(seed, nextFunction) {
    var tmp;
    if (seed == null) {
      tmp = EmptySequence_instance;
    } else {
      tmp = new GeneratorSequence(generateSequence$lambda(seed), nextFunction);
    }
    return tmp;
  }
  function emptySequence() {
    return EmptySequence_instance;
  }
  function flatten_0(_this__u8e3s4) {
    return flatten_2(_this__u8e3s4, flatten$lambda);
  }
  function sequenceOf(elements) {
    return asSequence(elements);
  }
  function ensureItemIterator($this) {
    var itemIterator = $this.nh_1;
    if (!(itemIterator == null) && itemIterator.n()) {
      $this.oh_1 = 1;
      return true;
    }
    while ($this.mh_1.n()) {
      var element = $this.mh_1.o();
      var nextItemIterator = $this.ph_1.sh_1($this.ph_1.rh_1(element));
      if (nextItemIterator.n()) {
        $this.nh_1 = nextItemIterator;
        $this.oh_1 = 1;
        return true;
      }
    }
    $this.oh_1 = 2;
    $this.nh_1 = null;
    return false;
  }
  function FlatteningSequence$iterator$1(this$0) {
    this.ph_1 = this$0;
    this.mh_1 = this$0.qh_1.m();
    this.nh_1 = null;
    this.oh_1 = 0;
  }
  protoOf(FlatteningSequence$iterator$1).o = function () {
    if (this.oh_1 === 2)
      throw NoSuchElementException_init_$Create$();
    if (this.oh_1 === 0 && !ensureItemIterator(this)) {
      throw NoSuchElementException_init_$Create$();
    }
    this.oh_1 = 0;
    return ensureNotNull(this.nh_1).o();
  };
  protoOf(FlatteningSequence$iterator$1).n = function () {
    if (this.oh_1 === 1)
      return true;
    if (this.oh_1 === 2)
      return false;
    return ensureItemIterator(this);
  };
  function FlatteningSequence(sequence, transformer, iterator) {
    this.qh_1 = sequence;
    this.rh_1 = transformer;
    this.sh_1 = iterator;
  }
  protoOf(FlatteningSequence).m = function () {
    return new FlatteningSequence$iterator$1(this);
  };
  function TransformingSequence$iterator$1(this$0) {
    this.uh_1 = this$0;
    this.th_1 = this$0.vh_1.m();
  }
  protoOf(TransformingSequence$iterator$1).o = function () {
    return this.uh_1.wh_1(this.th_1.o());
  };
  protoOf(TransformingSequence$iterator$1).n = function () {
    return this.th_1.n();
  };
  function TransformingSequence(sequence, transformer) {
    this.vh_1 = sequence;
    this.wh_1 = transformer;
  }
  protoOf(TransformingSequence).m = function () {
    return new TransformingSequence$iterator$1(this);
  };
  protoOf(TransformingSequence).xh = function (iterator) {
    return new FlatteningSequence(this.vh_1, this.wh_1, iterator);
  };
  function calcNext($this) {
    while ($this.yh_1.n()) {
      var item = $this.yh_1.o();
      if ($this.bi_1.ei_1(item) === $this.bi_1.di_1) {
        $this.ai_1 = item;
        $this.zh_1 = 1;
        return Unit_instance;
      }
    }
    $this.zh_1 = 0;
  }
  function FilteringSequence$iterator$1(this$0) {
    this.bi_1 = this$0;
    this.yh_1 = this$0.ci_1.m();
    this.zh_1 = -1;
    this.ai_1 = null;
  }
  protoOf(FilteringSequence$iterator$1).o = function () {
    if (this.zh_1 === -1) {
      calcNext(this);
    }
    if (this.zh_1 === 0)
      throw NoSuchElementException_init_$Create$();
    var result = this.ai_1;
    this.ai_1 = null;
    this.zh_1 = -1;
    return (result == null ? true : !(result == null)) ? result : THROW_CCE();
  };
  protoOf(FilteringSequence$iterator$1).n = function () {
    if (this.zh_1 === -1) {
      calcNext(this);
    }
    return this.zh_1 === 1;
  };
  function FilteringSequence(sequence, sendWhen, predicate) {
    sendWhen = sendWhen === VOID ? true : sendWhen;
    this.ci_1 = sequence;
    this.di_1 = sendWhen;
    this.ei_1 = predicate;
  }
  protoOf(FilteringSequence).m = function () {
    return new FilteringSequence$iterator$1(this);
  };
  function flatten_1(_this__u8e3s4) {
    return flatten_2(_this__u8e3s4, flatten$lambda_0);
  }
  function DropTakeSequence() {
  }
  function TakeSequence$iterator$1(this$0) {
    this.fi_1 = this$0.ii_1;
    this.gi_1 = this$0.hi_1.m();
  }
  protoOf(TakeSequence$iterator$1).o = function () {
    if (this.fi_1 === 0)
      throw NoSuchElementException_init_$Create$();
    this.fi_1 = this.fi_1 - 1 | 0;
    return this.gi_1.o();
  };
  protoOf(TakeSequence$iterator$1).n = function () {
    return this.fi_1 > 0 && this.gi_1.n();
  };
  function TakeSequence(sequence, count) {
    this.hi_1 = sequence;
    this.ii_1 = count;
    // Inline function 'kotlin.require' call
    if (!(this.ii_1 >= 0)) {
      var message = 'count must be non-negative, but was ' + this.ii_1 + '.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
  }
  protoOf(TakeSequence).h1 = function (n) {
    return n >= this.ii_1 ? this : new TakeSequence(this.hi_1, n);
  };
  protoOf(TakeSequence).m = function () {
    return new TakeSequence$iterator$1(this);
  };
  function generateSequence_0(seedFunction, nextFunction) {
    return new GeneratorSequence(seedFunction, nextFunction);
  }
  function constrainOnce(_this__u8e3s4) {
    var tmp;
    if (_this__u8e3s4 instanceof ConstrainedOnceSequence) {
      tmp = _this__u8e3s4;
    } else {
      tmp = new ConstrainedOnceSequence(_this__u8e3s4);
    }
    return tmp;
  }
  function EmptySequence() {
  }
  protoOf(EmptySequence).m = function () {
    return EmptyIterator_instance;
  };
  protoOf(EmptySequence).h1 = function (n) {
    return EmptySequence_instance;
  };
  var EmptySequence_instance;
  function EmptySequence_getInstance() {
    return EmptySequence_instance;
  }
  function calcNext_0($this) {
    $this.ji_1 = $this.ki_1 === -2 ? $this.li_1.mi_1() : $this.li_1.ni_1(ensureNotNull($this.ji_1));
    $this.ki_1 = $this.ji_1 == null ? 0 : 1;
  }
  function GeneratorSequence$iterator$1(this$0) {
    this.li_1 = this$0;
    this.ji_1 = null;
    this.ki_1 = -2;
  }
  protoOf(GeneratorSequence$iterator$1).o = function () {
    if (this.ki_1 < 0) {
      calcNext_0(this);
    }
    if (this.ki_1 === 0)
      throw NoSuchElementException_init_$Create$();
    var tmp = this.ji_1;
    var result = !(tmp == null) ? tmp : THROW_CCE();
    this.ki_1 = -1;
    return result;
  };
  protoOf(GeneratorSequence$iterator$1).n = function () {
    if (this.ki_1 < 0) {
      calcNext_0(this);
    }
    return this.ki_1 === 1;
  };
  function GeneratorSequence(getInitialValue, getNextValue) {
    this.mi_1 = getInitialValue;
    this.ni_1 = getNextValue;
  }
  protoOf(GeneratorSequence).m = function () {
    return new GeneratorSequence$iterator$1(this);
  };
  function flatten_2(_this__u8e3s4, iterator) {
    if (_this__u8e3s4 instanceof TransformingSequence) {
      return (_this__u8e3s4 instanceof TransformingSequence ? _this__u8e3s4 : THROW_CCE()).xh(iterator);
    }
    return new FlatteningSequence(_this__u8e3s4, flatten$lambda_1, iterator);
  }
  function asSequence$$inlined$Sequence$1_1($this_asSequence) {
    this.oi_1 = $this_asSequence;
  }
  protoOf(asSequence$$inlined$Sequence$1_1).m = function () {
    return this.oi_1;
  };
  function generateSequence$lambda($seed) {
    return function () {
      return $seed;
    };
  }
  function flatten$lambda(it) {
    return it.m();
  }
  function flatten$lambda_0(it) {
    return it.m();
  }
  function flatten$lambda_1(it) {
    return it;
  }
  function setOf_0(elements) {
    return toSet(elements);
  }
  function emptySet() {
    return EmptySet_instance;
  }
  function mutableSetOf(elements) {
    return toCollection(elements, LinkedHashSet_init_$Create$_1(mapCapacity(elements.length)));
  }
  function optimizeReadOnlySet(_this__u8e3s4) {
    switch (_this__u8e3s4.p()) {
      case 0:
        return emptySet();
      case 1:
        return setOf(_this__u8e3s4.m().o());
      default:
        return _this__u8e3s4;
    }
  }
  function hashSetOf(elements) {
    return toCollection(elements, HashSet_init_$Create$_1(mapCapacity(elements.length)));
  }
  function EmptySet() {
    this.pi_1 = 3406603774387020532n;
  }
  protoOf(EmptySet).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, KtSet) : false) {
      tmp = other.s();
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(EmptySet).hashCode = function () {
    return 0;
  };
  protoOf(EmptySet).toString = function () {
    return '[]';
  };
  protoOf(EmptySet).p = function () {
    return 0;
  };
  protoOf(EmptySet).s = function () {
    return true;
  };
  protoOf(EmptySet).vf = function (element) {
    return false;
  };
  protoOf(EmptySet).t = function (element) {
    if (!false)
      return false;
    var tmp;
    if (false) {
      tmp = element;
    } else {
      tmp = THROW_CCE();
    }
    return this.vf(tmp);
  };
  protoOf(EmptySet).wf = function (elements) {
    return elements.s();
  };
  protoOf(EmptySet).e2 = function (elements) {
    return this.wf(elements);
  };
  protoOf(EmptySet).m = function () {
    return EmptyIterator_instance;
  };
  var EmptySet_instance;
  function EmptySet_getInstance() {
    return EmptySet_instance;
  }
  function compareValues(a, b) {
    if (a === b)
      return 0;
    if (a == null)
      return -1;
    if (b == null)
      return 1;
    return compareTo_0((!(a == null) ? isComparable(a) : false) ? a : THROW_CCE(), b);
  }
  function Continuation() {
  }
  function startCoroutine(_this__u8e3s4, receiver, completion) {
    // Inline function 'kotlin.coroutines.resume' call
    var this_0 = intercepted(createCoroutineUnintercepted(_this__u8e3s4, receiver, completion));
    // Inline function 'kotlin.Companion.success' call
    var tmp$ret$0 = _Result___init__impl__xyqfz8(Unit_instance);
    this_0.q9(tmp$ret$0);
  }
  function Key() {
  }
  var Key_instance;
  function Key_getInstance() {
    return Key_instance;
  }
  function ContinuationInterceptor() {
  }
  function Element_0() {
  }
  function CoroutineContext$plus$lambda(acc, element) {
    var removed = acc.ui(element.z());
    var tmp;
    if (removed === EmptyCoroutineContext_instance) {
      tmp = element;
    } else {
      var interceptor = removed.s9(Key_instance);
      var tmp_0;
      if (interceptor == null) {
        tmp_0 = new CombinedContext(removed, element);
      } else {
        var left = removed.ui(Key_instance);
        tmp_0 = left === EmptyCoroutineContext_instance ? new CombinedContext(element, interceptor) : new CombinedContext(new CombinedContext(left, element), interceptor);
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  function CoroutineContext() {
  }
  function EmptyCoroutineContext() {
    this.xi_1 = 0n;
  }
  protoOf(EmptyCoroutineContext).s9 = function (key) {
    return null;
  };
  protoOf(EmptyCoroutineContext).vi = function (initial, operation) {
    return initial;
  };
  protoOf(EmptyCoroutineContext).wi = function (context) {
    return context;
  };
  protoOf(EmptyCoroutineContext).ui = function (key) {
    return this;
  };
  protoOf(EmptyCoroutineContext).hashCode = function () {
    return 0;
  };
  protoOf(EmptyCoroutineContext).toString = function () {
    return 'EmptyCoroutineContext';
  };
  var EmptyCoroutineContext_instance;
  function EmptyCoroutineContext_getInstance() {
    return EmptyCoroutineContext_instance;
  }
  function size_0($this) {
    var cur = $this;
    var size = 2;
    while (true) {
      var tmp = cur.yi_1;
      var tmp0_elvis_lhs = tmp instanceof CombinedContext ? tmp : null;
      var tmp_0;
      if (tmp0_elvis_lhs == null) {
        return size;
      } else {
        tmp_0 = tmp0_elvis_lhs;
      }
      cur = tmp_0;
      size = size + 1 | 0;
    }
  }
  function contains_7($this, element) {
    return equals($this.s9(element.z()), element);
  }
  function containsAll($this, context) {
    var cur = context;
    while (true) {
      if (!contains_7($this, cur.zi_1))
        return false;
      var next = cur.yi_1;
      if (next instanceof CombinedContext) {
        cur = next;
      } else {
        return contains_7($this, isInterface(next, Element_0) ? next : THROW_CCE());
      }
    }
  }
  function CombinedContext$toString$lambda(acc, element) {
    var tmp;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(acc) === 0) {
      tmp = toString_1(element);
    } else {
      tmp = acc + ', ' + toString_1(element);
    }
    return tmp;
  }
  function CombinedContext(left, element) {
    this.yi_1 = left;
    this.zi_1 = element;
  }
  protoOf(CombinedContext).s9 = function (key) {
    var cur = this;
    while (true) {
      var tmp0_safe_receiver = cur.zi_1.s9(key);
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        return tmp0_safe_receiver;
      }
      var next = cur.yi_1;
      if (next instanceof CombinedContext) {
        cur = next;
      } else {
        return next.s9(key);
      }
    }
  };
  protoOf(CombinedContext).vi = function (initial, operation) {
    return operation(this.yi_1.vi(initial, operation), this.zi_1);
  };
  protoOf(CombinedContext).ui = function (key) {
    if (this.zi_1.s9(key) == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      return this.yi_1;
    }
    var newLeft = this.yi_1.ui(key);
    return newLeft === this.yi_1 ? this : newLeft === EmptyCoroutineContext_instance ? this.zi_1 : new CombinedContext(newLeft, this.zi_1);
  };
  protoOf(CombinedContext).equals = function (other) {
    var tmp;
    if (this === other) {
      tmp = true;
    } else {
      var tmp_0;
      var tmp_1;
      if (other instanceof CombinedContext) {
        tmp_1 = size_0(other) === size_0(this);
      } else {
        tmp_1 = false;
      }
      if (tmp_1) {
        tmp_0 = containsAll(other, this);
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  protoOf(CombinedContext).hashCode = function () {
    return hashCode(this.yi_1) + hashCode(this.zi_1) | 0;
  };
  protoOf(CombinedContext).toString = function () {
    return '[' + this.vi('', CombinedContext$toString$lambda) + ']';
  };
  function AbstractCoroutineContextKey(baseKey, safeCast) {
    this.qi_1 = safeCast;
    var tmp = this;
    var tmp_0;
    if (baseKey instanceof AbstractCoroutineContextKey) {
      tmp_0 = baseKey.ri_1;
    } else {
      tmp_0 = baseKey;
    }
    tmp.ri_1 = tmp_0;
  }
  protoOf(AbstractCoroutineContextKey).si = function (element) {
    return this.qi_1(element);
  };
  protoOf(AbstractCoroutineContextKey).ti = function (key) {
    return key === this || this.ri_1 === key;
  };
  function AbstractCoroutineContextElement(key) {
    this.aj_1 = key;
  }
  protoOf(AbstractCoroutineContextElement).z = function () {
    return this.aj_1;
  };
  function get_COROUTINE_SUSPENDED() {
    return CoroutineSingletons_COROUTINE_SUSPENDED_getInstance();
  }
  var CoroutineSingletons_COROUTINE_SUSPENDED_instance;
  var CoroutineSingletons_UNDECIDED_instance;
  var CoroutineSingletons_RESUMED_instance;
  var CoroutineSingletons_entriesInitialized;
  function CoroutineSingletons_initEntries() {
    if (CoroutineSingletons_entriesInitialized)
      return Unit_instance;
    CoroutineSingletons_entriesInitialized = true;
    CoroutineSingletons_COROUTINE_SUSPENDED_instance = new CoroutineSingletons('COROUTINE_SUSPENDED', 0);
    CoroutineSingletons_UNDECIDED_instance = new CoroutineSingletons('UNDECIDED', 1);
    CoroutineSingletons_RESUMED_instance = new CoroutineSingletons('RESUMED', 2);
  }
  function CoroutineSingletons(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function CoroutineSingletons_COROUTINE_SUSPENDED_getInstance() {
    CoroutineSingletons_initEntries();
    return CoroutineSingletons_COROUTINE_SUSPENDED_instance;
  }
  function enumEntries(entries) {
    return new EnumEntriesList(entries);
  }
  function EnumEntriesList(entries) {
    AbstractList.call(this);
    this.bj_1 = entries;
  }
  protoOf(EnumEntriesList).p = function () {
    return this.bj_1.length;
  };
  protoOf(EnumEntriesList).r = function (index) {
    Companion_instance_6.b4(index, this.bj_1.length);
    return this.bj_1[index];
  };
  protoOf(EnumEntriesList).cj = function (element) {
    if (element === null)
      return false;
    var target = getOrNull(this.bj_1, element.x2_1);
    return target === element;
  };
  protoOf(EnumEntriesList).t = function (element) {
    if (!(element instanceof Enum))
      return false;
    return this.cj(element instanceof Enum ? element : THROW_CCE());
  };
  protoOf(EnumEntriesList).dj = function (element) {
    if (element === null)
      return -1;
    var ordinal = element.x2_1;
    var target = getOrNull(this.bj_1, ordinal);
    return target === element ? ordinal : -1;
  };
  protoOf(EnumEntriesList).w = function (element) {
    if (!(element instanceof Enum))
      return -1;
    return this.dj(element instanceof Enum ? element : THROW_CCE());
  };
  protoOf(EnumEntriesList).ej = function (element) {
    return this.dj(element);
  };
  protoOf(EnumEntriesList).v = function (element) {
    if (!(element instanceof Enum))
      return -1;
    return this.ej(element instanceof Enum ? element : THROW_CCE());
  };
  function getProgressionLastElement(start, end, step) {
    var tmp;
    if (step > 0) {
      tmp = start >= end ? end : end - differenceModulo(end, start, step) | 0;
    } else if (step < 0) {
      tmp = start <= end ? end : end + differenceModulo(start, end, -step | 0) | 0;
    } else {
      throw IllegalArgumentException_init_$Create$_0('Step is zero.');
    }
    return tmp;
  }
  function differenceModulo(a, b, c) {
    return mod(mod(a, c) - mod(b, c) | 0, c);
  }
  function mod(a, b) {
    var mod = a % b | 0;
    return mod >= 0 ? mod : mod + b | 0;
  }
  function Default() {
    Default_instance = this;
    Random.call(this);
    this.fj_1 = defaultPlatformRandom();
  }
  protoOf(Default).gj = function (bitCount) {
    return this.fj_1.gj(bitCount);
  };
  protoOf(Default).rg = function () {
    return this.fj_1.rg();
  };
  protoOf(Default).hj = function () {
    return this.fj_1.hj();
  };
  protoOf(Default).ij = function (array) {
    return this.fj_1.ij(array);
  };
  protoOf(Default).jj = function (array, fromIndex, toIndex) {
    return this.fj_1.jj(array, fromIndex, toIndex);
  };
  var Default_instance;
  function Default_getInstance() {
    if (Default_instance == null)
      new Default();
    return Default_instance;
  }
  function Random() {
    Default_getInstance();
  }
  protoOf(Random).rg = function () {
    return this.gj(32);
  };
  protoOf(Random).hj = function () {
    return doubleFromParts(this.gj(26), this.gj(27));
  };
  protoOf(Random).jj = function (array, fromIndex, toIndex) {
    // Inline function 'kotlin.require' call
    if (!((0 <= fromIndex ? fromIndex <= array.length : false) && (0 <= toIndex ? toIndex <= array.length : false))) {
      var message = 'fromIndex (' + fromIndex + ') or toIndex (' + toIndex + ') are out of range: 0..' + array.length + '.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    // Inline function 'kotlin.require' call
    if (!(fromIndex <= toIndex)) {
      var message_0 = 'fromIndex (' + fromIndex + ') must be not greater than toIndex (' + toIndex + ').';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message_0));
    }
    var steps = (toIndex - fromIndex | 0) / 4 | 0;
    var position = fromIndex;
    // Inline function 'kotlin.repeat' call
    var inductionVariable = 0;
    if (inductionVariable < steps)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var v = this.rg();
        array[position] = toByte(v);
        array[position + 1 | 0] = toByte(v >>> 8 | 0);
        array[position + 2 | 0] = toByte(v >>> 16 | 0);
        array[position + 3 | 0] = toByte(v >>> 24 | 0);
        position = position + 4 | 0;
      }
       while (inductionVariable < steps);
    var remainder = toIndex - position | 0;
    var vr = this.gj(imul(remainder, 8));
    var inductionVariable_0 = 0;
    if (inductionVariable_0 < remainder)
      do {
        var i = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        array[position + i | 0] = toByte(vr >>> imul(i, 8) | 0);
      }
       while (inductionVariable_0 < remainder);
    return array;
  };
  protoOf(Random).ij = function (array) {
    return this.jj(array, 0, array.length);
  };
  function Random_0(seed) {
    return XorWowRandom_init_$Create$(seed, seed >> 31);
  }
  function takeUpperBits(_this__u8e3s4, bitCount) {
    return (_this__u8e3s4 >>> (32 - bitCount | 0) | 0) & (-bitCount | 0) >> 31;
  }
  function Random_1(seed) {
    return XorWowRandom_init_$Create$(convertToInt(seed), convertToInt(shiftRight(seed, 32)));
  }
  function XorWowRandom_init_$Init$(seed1, seed2, $this) {
    XorWowRandom.call($this, seed1, seed2, 0, 0, ~seed1, seed1 << 10 ^ (seed2 >>> 4 | 0));
    return $this;
  }
  function XorWowRandom_init_$Create$(seed1, seed2) {
    return XorWowRandom_init_$Init$(seed1, seed2, objectCreate(protoOf(XorWowRandom)));
  }
  function checkInvariants($this) {
    // Inline function 'kotlin.require' call
    if (!!(($this.kj_1 | $this.lj_1 | $this.mj_1 | $this.nj_1 | $this.oj_1) === 0)) {
      var message = 'Initial state must have at least one non-zero element.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
  }
  function Companion_10() {
    this.qj_1 = 0n;
  }
  var Companion_instance_10;
  function Companion_getInstance_10() {
    return Companion_instance_10;
  }
  function XorWowRandom(x, y, z, w, v, addend) {
    Random.call(this);
    this.kj_1 = x;
    this.lj_1 = y;
    this.mj_1 = z;
    this.nj_1 = w;
    this.oj_1 = v;
    this.pj_1 = addend;
    checkInvariants(this);
    // Inline function 'kotlin.repeat' call
    var inductionVariable = 0;
    if (inductionVariable < 64)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.rg();
      }
       while (inductionVariable < 64);
  }
  protoOf(XorWowRandom).rg = function () {
    var t = this.kj_1;
    t = t ^ (t >>> 2 | 0);
    this.kj_1 = this.lj_1;
    this.lj_1 = this.mj_1;
    this.mj_1 = this.nj_1;
    var v0 = this.oj_1;
    this.nj_1 = v0;
    t = t ^ t << 1 ^ v0 ^ v0 << 4;
    this.oj_1 = t;
    this.pj_1 = this.pj_1 + 362437 | 0;
    return t + this.pj_1 | 0;
  };
  protoOf(XorWowRandom).gj = function (bitCount) {
    return takeUpperBits(this.rg(), bitCount);
  };
  function Companion_11() {
    Companion_instance_11 = this;
    this.b1_1 = new IntRange(1, 0);
  }
  var Companion_instance_11;
  function Companion_getInstance_11() {
    if (Companion_instance_11 == null)
      new Companion_11();
    return Companion_instance_11;
  }
  function IntRange(start, endInclusive) {
    Companion_getInstance_11();
    IntProgression.call(this, start, endInclusive, 1);
  }
  protoOf(IntRange).p1 = function () {
    return this.c1_1;
  };
  protoOf(IntRange).q1 = function () {
    return this.d1_1;
  };
  protoOf(IntRange).s = function () {
    return this.c1_1 > this.d1_1;
  };
  protoOf(IntRange).equals = function (other) {
    var tmp;
    if (other instanceof IntRange) {
      tmp = this.s() && other.s() || (this.c1_1 === other.c1_1 && this.d1_1 === other.d1_1);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(IntRange).hashCode = function () {
    return this.s() ? -1 : imul(31, this.c1_1) + this.d1_1 | 0;
  };
  protoOf(IntRange).toString = function () {
    return '' + this.c1_1 + '..' + this.d1_1;
  };
  function Companion_12() {
    Companion_instance_12 = this;
    this.rj_1 = new CharRange(_Char___init__impl__6a9atx(1), _Char___init__impl__6a9atx(0));
  }
  var Companion_instance_12;
  function Companion_getInstance_12() {
    if (Companion_instance_12 == null)
      new Companion_12();
    return Companion_instance_12;
  }
  function CharRange(start, endInclusive) {
    Companion_getInstance_12();
    CharProgression.call(this, start, endInclusive, 1);
  }
  protoOf(CharRange).s = function () {
    return Char__compareTo_impl_ypi4mb(this.vj_1, this.wj_1) > 0;
  };
  protoOf(CharRange).equals = function (other) {
    var tmp;
    if (other instanceof CharRange) {
      tmp = this.s() && other.s() || (this.vj_1 === other.vj_1 && this.wj_1 === other.wj_1);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(CharRange).hashCode = function () {
    var tmp;
    if (this.s()) {
      tmp = -1;
    } else {
      // Inline function 'kotlin.code' call
      var this_0 = this.vj_1;
      var tmp$ret$0 = Char__toInt_impl_vasixd(this_0);
      var tmp_0 = imul(31, tmp$ret$0);
      // Inline function 'kotlin.code' call
      var this_1 = this.wj_1;
      tmp = tmp_0 + Char__toInt_impl_vasixd(this_1) | 0;
    }
    return tmp;
  };
  protoOf(CharRange).toString = function () {
    return toString(this.vj_1) + '..' + toString(this.wj_1);
  };
  function IntProgressionIterator(first, last, step) {
    IntIterator.call(this);
    this.yj_1 = step;
    this.zj_1 = last;
    this.ak_1 = this.yj_1 > 0 ? first <= last : first >= last;
    this.bk_1 = this.ak_1 ? first : this.zj_1;
  }
  protoOf(IntProgressionIterator).n = function () {
    return this.ak_1;
  };
  protoOf(IntProgressionIterator).rg = function () {
    var value = this.bk_1;
    if (value === this.zj_1) {
      if (!this.ak_1)
        throw NoSuchElementException_init_$Create$();
      this.ak_1 = false;
    } else {
      this.bk_1 = this.bk_1 + this.yj_1 | 0;
    }
    return value;
  };
  function CharProgressionIterator(first, last, step) {
    CharIterator.call(this);
    this.ck_1 = step;
    var tmp = this;
    // Inline function 'kotlin.code' call
    tmp.dk_1 = Char__toInt_impl_vasixd(last);
    this.ek_1 = this.ck_1 > 0 ? Char__compareTo_impl_ypi4mb(first, last) <= 0 : Char__compareTo_impl_ypi4mb(first, last) >= 0;
    var tmp_0 = this;
    var tmp_1;
    if (this.ek_1) {
      // Inline function 'kotlin.code' call
      tmp_1 = Char__toInt_impl_vasixd(first);
    } else {
      tmp_1 = this.dk_1;
    }
    tmp_0.fk_1 = tmp_1;
  }
  protoOf(CharProgressionIterator).n = function () {
    return this.ek_1;
  };
  protoOf(CharProgressionIterator).tg = function () {
    var value = this.fk_1;
    if (value === this.dk_1) {
      if (!this.ek_1)
        throw NoSuchElementException_init_$Create$();
      this.ek_1 = false;
    } else {
      this.fk_1 = this.fk_1 + this.ck_1 | 0;
    }
    return numberToChar(value);
  };
  function Companion_13() {
  }
  protoOf(Companion_13).f1 = function (rangeStart, rangeEnd, step) {
    return new IntProgression(rangeStart, rangeEnd, step);
  };
  var Companion_instance_13;
  function Companion_getInstance_13() {
    return Companion_instance_13;
  }
  function IntProgression(start, endInclusive, step) {
    if (step === 0)
      throw IllegalArgumentException_init_$Create$_0('Step must be non-zero.');
    if (step === -2147483648)
      throw IllegalArgumentException_init_$Create$_0('Step must be greater than Int.MIN_VALUE to avoid overflow on negation.');
    this.c1_1 = start;
    this.d1_1 = getProgressionLastElement(start, endInclusive, step);
    this.e1_1 = step;
  }
  protoOf(IntProgression).m = function () {
    return new IntProgressionIterator(this.c1_1, this.d1_1, this.e1_1);
  };
  protoOf(IntProgression).s = function () {
    return this.e1_1 > 0 ? this.c1_1 > this.d1_1 : this.c1_1 < this.d1_1;
  };
  protoOf(IntProgression).equals = function (other) {
    var tmp;
    if (other instanceof IntProgression) {
      tmp = this.s() && other.s() || (this.c1_1 === other.c1_1 && this.d1_1 === other.d1_1 && this.e1_1 === other.e1_1);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(IntProgression).hashCode = function () {
    return this.s() ? -1 : imul(31, imul(31, this.c1_1) + this.d1_1 | 0) + this.e1_1 | 0;
  };
  protoOf(IntProgression).toString = function () {
    return this.e1_1 > 0 ? '' + this.c1_1 + '..' + this.d1_1 + ' step ' + this.e1_1 : '' + this.c1_1 + ' downTo ' + this.d1_1 + ' step ' + (-this.e1_1 | 0);
  };
  function Companion_14() {
  }
  var Companion_instance_14;
  function Companion_getInstance_14() {
    return Companion_instance_14;
  }
  function CharProgression(start, endInclusive, step) {
    if (step === 0)
      throw IllegalArgumentException_init_$Create$_0('Step must be non-zero.');
    if (step === -2147483648)
      throw IllegalArgumentException_init_$Create$_0('Step must be greater than Int.MIN_VALUE to avoid overflow on negation.');
    this.vj_1 = start;
    var tmp = this;
    // Inline function 'kotlin.code' call
    var tmp_0 = Char__toInt_impl_vasixd(start);
    // Inline function 'kotlin.code' call
    var tmp$ret$1 = Char__toInt_impl_vasixd(endInclusive);
    tmp.wj_1 = numberToChar(getProgressionLastElement(tmp_0, tmp$ret$1, step));
    this.xj_1 = step;
  }
  protoOf(CharProgression).m = function () {
    return new CharProgressionIterator(this.vj_1, this.wj_1, this.xj_1);
  };
  protoOf(CharProgression).s = function () {
    return this.xj_1 > 0 ? Char__compareTo_impl_ypi4mb(this.vj_1, this.wj_1) > 0 : Char__compareTo_impl_ypi4mb(this.vj_1, this.wj_1) < 0;
  };
  protoOf(CharProgression).equals = function (other) {
    var tmp;
    if (other instanceof CharProgression) {
      tmp = this.s() && other.s() || (this.vj_1 === other.vj_1 && this.wj_1 === other.wj_1 && this.xj_1 === other.xj_1);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(CharProgression).hashCode = function () {
    var tmp;
    if (this.s()) {
      tmp = -1;
    } else {
      // Inline function 'kotlin.code' call
      var this_0 = this.vj_1;
      var tmp$ret$0 = Char__toInt_impl_vasixd(this_0);
      var tmp_0 = imul(31, tmp$ret$0);
      // Inline function 'kotlin.code' call
      var this_1 = this.wj_1;
      var tmp$ret$1 = Char__toInt_impl_vasixd(this_1);
      tmp = imul(31, tmp_0 + tmp$ret$1 | 0) + this.xj_1 | 0;
    }
    return tmp;
  };
  protoOf(CharProgression).toString = function () {
    return this.xj_1 > 0 ? toString(this.vj_1) + '..' + toString(this.wj_1) + ' step ' + this.xj_1 : toString(this.vj_1) + ' downTo ' + toString(this.wj_1) + ' step ' + (-this.xj_1 | 0);
  };
  function checkStepIsPositive(isPositive, step) {
    if (!isPositive)
      throw IllegalArgumentException_init_$Create$_0('Step must be positive, was: ' + toString_1(step) + '.');
  }
  function cast(_this__u8e3s4, value) {
    if (!_this__u8e3s4.sa(value)) {
      // Inline function 'kotlin.reflect.qualifiedOrSimpleName' call
      var tmp$ret$0 = _this__u8e3s4.ra();
      throw ClassCastException_init_$Create$_0('Value cannot be cast to ' + tmp$ret$0);
    }
    return !(value == null) ? value : THROW_CCE();
  }
  function safeCast(_this__u8e3s4, value) {
    var tmp;
    if (_this__u8e3s4.sa(value)) {
      tmp = !(value == null) ? value : THROW_CCE();
    } else {
      tmp = null;
    }
    return tmp;
  }
  function KTypeParameter() {
  }
  function Companion_15() {
    Companion_instance_15 = this;
    this.ab_1 = new KTypeProjection(null, null);
  }
  protoOf(Companion_15).bb = function (type) {
    return new KTypeProjection(KVariance_INVARIANT_getInstance(), type);
  };
  var Companion_instance_15;
  function Companion_getInstance_15() {
    if (Companion_instance_15 == null)
      new Companion_15();
    return Companion_instance_15;
  }
  function KTypeProjection(variance, type) {
    Companion_getInstance_15();
    this.gk_1 = variance;
    this.hk_1 = type;
    // Inline function 'kotlin.require' call
    if (!(this.gk_1 == null === (this.hk_1 == null))) {
      var message = this.gk_1 == null ? 'Star projection must have no type specified.' : 'The projection variance ' + this.gk_1.toString() + ' requires type to be specified.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
  }
  protoOf(KTypeProjection).toString = function () {
    var tmp0_subject = this.gk_1;
    var tmp;
    switch (tmp0_subject == null ? -1 : tmp0_subject.x2_1) {
      case -1:
        tmp = '*';
        break;
      case 0:
        tmp = toString_0(this.hk_1);
        break;
      case 1:
        tmp = 'in ' + toString_0(this.hk_1);
        break;
      case 2:
        tmp = 'out ' + toString_0(this.hk_1);
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  };
  protoOf(KTypeProjection).hashCode = function () {
    var result = this.gk_1 == null ? 0 : this.gk_1.hashCode();
    result = imul(result, 31) + (this.hk_1 == null ? 0 : hashCode(this.hk_1)) | 0;
    return result;
  };
  protoOf(KTypeProjection).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof KTypeProjection))
      return false;
    if (!equals(this.gk_1, other.gk_1))
      return false;
    if (!equals(this.hk_1, other.hk_1))
      return false;
    return true;
  };
  var KVariance_INVARIANT_instance;
  var KVariance_IN_instance;
  var KVariance_OUT_instance;
  var KVariance_entriesInitialized;
  function KVariance_initEntries() {
    if (KVariance_entriesInitialized)
      return Unit_instance;
    KVariance_entriesInitialized = true;
    KVariance_INVARIANT_instance = new KVariance('INVARIANT', 0);
    KVariance_IN_instance = new KVariance('IN', 1);
    KVariance_OUT_instance = new KVariance('OUT', 2);
  }
  function KVariance(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function KVariance_INVARIANT_getInstance() {
    KVariance_initEntries();
    return KVariance_INVARIANT_instance;
  }
  function appendElement(_this__u8e3s4, element, transform) {
    if (!(transform == null))
      _this__u8e3s4.k(transform(element));
    else {
      if (element == null ? true : isCharSequence(element))
        _this__u8e3s4.k(element);
      else {
        if (element instanceof Char)
          _this__u8e3s4.k8(element.s1_1);
        else {
          _this__u8e3s4.k(toString_1(element));
        }
      }
    }
  }
  function isSurrogate(_this__u8e3s4) {
    return _Char___init__impl__6a9atx(55296) <= _this__u8e3s4 ? _this__u8e3s4 <= _Char___init__impl__6a9atx(57343) : false;
  }
  function titlecase(_this__u8e3s4) {
    return titlecaseImpl(_this__u8e3s4);
  }
  function equals_1(_this__u8e3s4, other, ignoreCase) {
    ignoreCase = ignoreCase === VOID ? false : ignoreCase;
    if (_this__u8e3s4 === other)
      return true;
    if (!ignoreCase)
      return false;
    var thisUpper = uppercaseChar(_this__u8e3s4);
    var otherUpper = uppercaseChar(other);
    var tmp;
    if (thisUpper === otherUpper) {
      tmp = true;
    } else {
      // Inline function 'kotlin.text.lowercaseChar' call
      // Inline function 'kotlin.text.lowercase' call
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.unsafeCast' call
      var tmp$ret$2 = toString(thisUpper).toLowerCase();
      var tmp_0 = charCodeAt(tmp$ret$2, 0);
      // Inline function 'kotlin.text.lowercaseChar' call
      // Inline function 'kotlin.text.lowercase' call
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.unsafeCast' call
      var tmp$ret$6 = toString(otherUpper).toLowerCase();
      tmp = tmp_0 === charCodeAt(tmp$ret$6, 0);
    }
    return tmp;
  }
  function trimIndent(_this__u8e3s4) {
    return replaceIndent(_this__u8e3s4, '');
  }
  function trimMargin(_this__u8e3s4, marginPrefix) {
    marginPrefix = marginPrefix === VOID ? '|' : marginPrefix;
    return replaceIndentByMargin(_this__u8e3s4, '', marginPrefix);
  }
  function replaceIndent(_this__u8e3s4, newIndent) {
    newIndent = newIndent === VOID ? '' : newIndent;
    var lines_0 = lines(_this__u8e3s4);
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList_init_$Create$();
    var _iterator__ex2g4s = lines_0.m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      // Inline function 'kotlin.text.isNotBlank' call
      if (!isBlank(element)) {
        destination.j(element);
      }
    }
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(destination, 10));
    var _iterator__ex2g4s_0 = destination.m();
    while (_iterator__ex2g4s_0.n()) {
      var item = _iterator__ex2g4s_0.o();
      var tmp$ret$4 = indentWidth(item);
      destination_0.j(tmp$ret$4);
    }
    var tmp0_elvis_lhs = minOrNull(destination_0);
    var minCommonIndent = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
    var tmp2 = _this__u8e3s4.length + imul(newIndent.length, lines_0.p()) | 0;
    // Inline function 'kotlin.text.reindent' call
    var indentAddFunction = getIndentFunction(newIndent);
    var lastIndex = get_lastIndex_2(lines_0);
    // Inline function 'kotlin.collections.mapIndexedNotNull' call
    // Inline function 'kotlin.collections.mapIndexedNotNullTo' call
    var destination_1 = ArrayList_init_$Create$();
    // Inline function 'kotlin.collections.forEachIndexed' call
    var index = 0;
    var _iterator__ex2g4s_1 = lines_0.m();
    while (_iterator__ex2g4s_1.n()) {
      var item_0 = _iterator__ex2g4s_1.o();
      var _unary__edvuaz = index;
      index = _unary__edvuaz + 1 | 0;
      var index_0 = checkIndexOverflow(_unary__edvuaz);
      var tmp;
      if ((index_0 === 0 || index_0 === lastIndex) && isBlank(item_0)) {
        tmp = null;
      } else {
        var tmp0_safe_receiver = drop_0(item_0, minCommonIndent);
        var tmp_0;
        if (tmp0_safe_receiver == null) {
          tmp_0 = null;
        } else {
          // Inline function 'kotlin.let' call
          tmp_0 = indentAddFunction(tmp0_safe_receiver);
        }
        var tmp1_elvis_lhs = tmp_0;
        tmp = tmp1_elvis_lhs == null ? item_0 : tmp1_elvis_lhs;
      }
      var tmp0_safe_receiver_0 = tmp;
      if (tmp0_safe_receiver_0 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        destination_1.j(tmp0_safe_receiver_0);
      }
    }
    return joinTo_0(destination_1, StringBuilder_init_$Create$(tmp2), '\n').toString();
  }
  function replaceIndentByMargin(_this__u8e3s4, newIndent, marginPrefix) {
    newIndent = newIndent === VOID ? '' : newIndent;
    marginPrefix = marginPrefix === VOID ? '|' : marginPrefix;
    // Inline function 'kotlin.text.isNotBlank' call
    // Inline function 'kotlin.require' call
    if (!!isBlank(marginPrefix)) {
      var message = 'marginPrefix must be non-blank string.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    var lines_0 = lines(_this__u8e3s4);
    var tmp2 = _this__u8e3s4.length + imul(newIndent.length, lines_0.p()) | 0;
    // Inline function 'kotlin.text.reindent' call
    var indentAddFunction = getIndentFunction(newIndent);
    var lastIndex = get_lastIndex_2(lines_0);
    // Inline function 'kotlin.collections.mapIndexedNotNull' call
    // Inline function 'kotlin.collections.mapIndexedNotNullTo' call
    var destination = ArrayList_init_$Create$();
    // Inline function 'kotlin.collections.forEachIndexed' call
    var index = 0;
    var _iterator__ex2g4s = lines_0.m();
    while (_iterator__ex2g4s.n()) {
      var item = _iterator__ex2g4s.o();
      var _unary__edvuaz = index;
      index = _unary__edvuaz + 1 | 0;
      var index_0 = checkIndexOverflow(_unary__edvuaz);
      var tmp;
      if ((index_0 === 0 || index_0 === lastIndex) && isBlank(item)) {
        tmp = null;
      } else {
        var tmp$ret$4;
        $l$block: {
          // Inline function 'kotlin.text.indexOfFirst' call
          var inductionVariable = 0;
          var last = charSequenceLength(item) - 1 | 0;
          if (inductionVariable <= last)
            do {
              var index_1 = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var it = charSequenceGet(item, index_1);
              if (!isWhitespace(it)) {
                tmp$ret$4 = index_1;
                break $l$block;
              }
            }
             while (inductionVariable <= last);
          tmp$ret$4 = -1;
        }
        var firstNonWhitespaceIndex = tmp$ret$4;
        var tmp0_safe_receiver = firstNonWhitespaceIndex === -1 ? null : startsWith_0(item, marginPrefix, firstNonWhitespaceIndex) ? substring_0(item, firstNonWhitespaceIndex + marginPrefix.length | 0) : null;
        var tmp_0;
        if (tmp0_safe_receiver == null) {
          tmp_0 = null;
        } else {
          // Inline function 'kotlin.let' call
          tmp_0 = indentAddFunction(tmp0_safe_receiver);
        }
        var tmp1_elvis_lhs = tmp_0;
        tmp = tmp1_elvis_lhs == null ? item : tmp1_elvis_lhs;
      }
      var tmp0_safe_receiver_0 = tmp;
      if (tmp0_safe_receiver_0 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        destination.j(tmp0_safe_receiver_0);
      }
    }
    return joinTo_0(destination, StringBuilder_init_$Create$(tmp2), '\n').toString();
  }
  function indentWidth(_this__u8e3s4) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.text.indexOfFirst' call
      var inductionVariable = 0;
      var last = charSequenceLength(_this__u8e3s4) - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var it = charSequenceGet(_this__u8e3s4, index);
          if (!isWhitespace(it)) {
            tmp$ret$1 = index;
            break $l$block;
          }
        }
         while (inductionVariable <= last);
      tmp$ret$1 = -1;
    }
    // Inline function 'kotlin.let' call
    var it_0 = tmp$ret$1;
    return it_0 === -1 ? _this__u8e3s4.length : it_0;
  }
  function getIndentFunction(indent) {
    var tmp;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(indent) === 0) {
      tmp = getIndentFunction$lambda;
    } else {
      tmp = getIndentFunction$lambda_0(indent);
    }
    return tmp;
  }
  function getIndentFunction$lambda(line) {
    return line;
  }
  function getIndentFunction$lambda_0($indent) {
    return function (line) {
      return $indent + line;
    };
  }
  function toIntOrNull(_this__u8e3s4) {
    return toIntOrNull_0(_this__u8e3s4, 10);
  }
  function toLongOrNull(_this__u8e3s4) {
    return toLongOrNull_0(_this__u8e3s4, 10);
  }
  function toIntOrNull_0(_this__u8e3s4, radix) {
    checkRadix(radix);
    var length = _this__u8e3s4.length;
    if (length === 0)
      return null;
    var start;
    var isNegative;
    var limit;
    var firstChar = charCodeAt(_this__u8e3s4, 0);
    if (Char__compareTo_impl_ypi4mb(firstChar, _Char___init__impl__6a9atx(48)) < 0) {
      if (length === 1)
        return null;
      start = 1;
      if (firstChar === _Char___init__impl__6a9atx(45)) {
        isNegative = true;
        limit = -2147483648;
      } else if (firstChar === _Char___init__impl__6a9atx(43)) {
        isNegative = false;
        limit = -2147483647;
      } else
        return null;
    } else {
      start = 0;
      isNegative = false;
      limit = -2147483647;
    }
    var limitForMaxRadix = -59652323;
    var limitBeforeMul = limitForMaxRadix;
    var result = 0;
    var inductionVariable = start;
    if (inductionVariable < length)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var digit = digitOf(charCodeAt(_this__u8e3s4, i), radix);
        if (digit < 0)
          return null;
        if (result < limitBeforeMul) {
          if (limitBeforeMul === limitForMaxRadix) {
            limitBeforeMul = limit / radix | 0;
            if (result < limitBeforeMul) {
              return null;
            }
          } else {
            return null;
          }
        }
        result = imul(result, radix);
        if (result < (limit + digit | 0))
          return null;
        result = result - digit | 0;
      }
       while (inductionVariable < length);
    return isNegative ? result : -result | 0;
  }
  function toLongOrNull_0(_this__u8e3s4, radix) {
    checkRadix(radix);
    var length = _this__u8e3s4.length;
    if (length === 0)
      return null;
    var start;
    var isNegative;
    var limit;
    var firstChar = charCodeAt(_this__u8e3s4, 0);
    if (Char__compareTo_impl_ypi4mb(firstChar, _Char___init__impl__6a9atx(48)) < 0) {
      if (length === 1)
        return null;
      start = 1;
      if (firstChar === _Char___init__impl__6a9atx(45)) {
        isNegative = true;
        limit = -9223372036854775808n;
      } else if (firstChar === _Char___init__impl__6a9atx(43)) {
        isNegative = false;
        limit = -9223372036854775807n;
      } else
        return null;
    } else {
      start = 0;
      isNegative = false;
      limit = -9223372036854775807n;
    }
    // Inline function 'kotlin.Long.div' call
    var this_0 = -9223372036854775807n;
    var limitForMaxRadix = divide(this_0, fromInt_0(36));
    var limitBeforeMul = limitForMaxRadix;
    var result = 0n;
    var inductionVariable = start;
    if (inductionVariable < length)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var digit = digitOf(charCodeAt(_this__u8e3s4, i), radix);
        if (digit < 0)
          return null;
        if (result < limitBeforeMul) {
          if (limitBeforeMul === limitForMaxRadix) {
            // Inline function 'kotlin.Long.div' call
            var this_1 = limit;
            limitBeforeMul = divide(this_1, fromInt_0(radix));
            if (result < limitBeforeMul) {
              return null;
            }
          } else {
            return null;
          }
        }
        // Inline function 'kotlin.Long.times' call
        var this_2 = result;
        result = multiply_0(this_2, fromInt_0(radix));
        var tmp = result;
        // Inline function 'kotlin.Long.plus' call
        var this_3 = limit;
        if (tmp < add_2(this_3, fromInt_0(digit)))
          return null;
        // Inline function 'kotlin.Long.minus' call
        var this_4 = result;
        result = subtract_1(this_4, fromInt_0(digit));
      }
       while (inductionVariable < length);
    return isNegative ? result : negate_0(result);
  }
  function numberFormatError(input) {
    throw NumberFormatException_init_$Create$_0("Invalid number format: '" + input + "'");
  }
  function toByteOrNull(_this__u8e3s4) {
    return toByteOrNull_0(_this__u8e3s4, 10);
  }
  function toShortOrNull(_this__u8e3s4) {
    return toShortOrNull_0(_this__u8e3s4, 10);
  }
  function toByteOrNull_0(_this__u8e3s4, radix) {
    var tmp0_elvis_lhs = toIntOrNull_0(_this__u8e3s4, radix);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var int = tmp;
    if (int < -128 || int > 127)
      return null;
    return toByte(int);
  }
  function toShortOrNull_0(_this__u8e3s4, radix) {
    var tmp0_elvis_lhs = toIntOrNull_0(_this__u8e3s4, radix);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var int = tmp;
    if (int < -32768 || int > 32767)
      return null;
    return toShort(int);
  }
  function contains_8(_this__u8e3s4, other, ignoreCase) {
    ignoreCase = ignoreCase === VOID ? false : ignoreCase;
    var tmp;
    if (typeof other === 'string') {
      tmp = indexOf_9(_this__u8e3s4, other, VOID, ignoreCase) >= 0;
    } else {
      tmp = indexOf_10(_this__u8e3s4, other, 0, charSequenceLength(_this__u8e3s4), ignoreCase) >= 0;
    }
    return tmp;
  }
  function isBlank(_this__u8e3s4) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.text.all' call
      var inductionVariable = 0;
      while (inductionVariable < charSequenceLength(_this__u8e3s4)) {
        var element = charSequenceGet(_this__u8e3s4, inductionVariable);
        inductionVariable = inductionVariable + 1 | 0;
        if (!isWhitespace(element)) {
          tmp$ret$1 = false;
          break $l$block;
        }
      }
      tmp$ret$1 = true;
    }
    return tmp$ret$1;
  }
  function split(_this__u8e3s4, delimiters, ignoreCase, limit) {
    ignoreCase = ignoreCase === VOID ? false : ignoreCase;
    limit = limit === VOID ? 0 : limit;
    if (delimiters.length === 1) {
      return split_1(_this__u8e3s4, toString(delimiters[0]), ignoreCase, limit);
    }
    // Inline function 'kotlin.collections.map' call
    var this_0 = asIterable(rangesDelimitedBy(_this__u8e3s4, delimiters, VOID, ignoreCase, limit));
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.m();
    while (_iterator__ex2g4s.n()) {
      var item = _iterator__ex2g4s.o();
      var tmp$ret$0 = substring_2(_this__u8e3s4, item);
      destination.j(tmp$ret$0);
    }
    return destination;
  }
  function substring_1(_this__u8e3s4, range) {
    return substring(_this__u8e3s4, range.p1(), range.q1() + 1 | 0);
  }
  function indexOf_8(_this__u8e3s4, char, startIndex, ignoreCase) {
    startIndex = startIndex === VOID ? 0 : startIndex;
    ignoreCase = ignoreCase === VOID ? false : ignoreCase;
    var tmp;
    var tmp_0;
    if (ignoreCase) {
      tmp_0 = true;
    } else {
      tmp_0 = !(typeof _this__u8e3s4 === 'string');
    }
    if (tmp_0) {
      // Inline function 'kotlin.charArrayOf' call
      var tmp$ret$0 = charArrayOf([char]);
      tmp = indexOfAny(_this__u8e3s4, tmp$ret$0, startIndex, ignoreCase);
    } else {
      // Inline function 'kotlin.text.nativeIndexOf' call
      // Inline function 'kotlin.text.nativeIndexOf' call
      var str = toString(char);
      // Inline function 'kotlin.js.asDynamic' call
      tmp = _this__u8e3s4.indexOf(str, startIndex);
    }
    return tmp;
  }
  function lastIndexOf_2(_this__u8e3s4, string, startIndex, ignoreCase) {
    startIndex = startIndex === VOID ? get_lastIndex_3(_this__u8e3s4) : startIndex;
    ignoreCase = ignoreCase === VOID ? false : ignoreCase;
    var tmp;
    var tmp_0;
    if (ignoreCase) {
      tmp_0 = true;
    } else {
      tmp_0 = !(typeof _this__u8e3s4 === 'string');
    }
    if (tmp_0) {
      tmp = indexOf_10(_this__u8e3s4, string, startIndex, 0, ignoreCase, true);
    } else {
      // Inline function 'kotlin.text.nativeLastIndexOf' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = _this__u8e3s4.lastIndexOf(string, startIndex);
    }
    return tmp;
  }
  function split_0(_this__u8e3s4, delimiters, ignoreCase, limit) {
    ignoreCase = ignoreCase === VOID ? false : ignoreCase;
    limit = limit === VOID ? 0 : limit;
    if (delimiters.length === 1) {
      var delimiter = delimiters[0];
      // Inline function 'kotlin.text.isEmpty' call
      if (!(charSequenceLength(delimiter) === 0)) {
        return split_1(_this__u8e3s4, delimiter, ignoreCase, limit);
      }
    }
    // Inline function 'kotlin.collections.map' call
    var this_0 = asIterable(rangesDelimitedBy_0(_this__u8e3s4, delimiters, VOID, ignoreCase, limit));
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.m();
    while (_iterator__ex2g4s.n()) {
      var item = _iterator__ex2g4s.o();
      var tmp$ret$1 = substring_2(_this__u8e3s4, item);
      destination.j(tmp$ret$1);
    }
    return destination;
  }
  function lastIndexOf_3(_this__u8e3s4, char, startIndex, ignoreCase) {
    startIndex = startIndex === VOID ? get_lastIndex_3(_this__u8e3s4) : startIndex;
    ignoreCase = ignoreCase === VOID ? false : ignoreCase;
    var tmp;
    var tmp_0;
    if (ignoreCase) {
      tmp_0 = true;
    } else {
      tmp_0 = !(typeof _this__u8e3s4 === 'string');
    }
    if (tmp_0) {
      // Inline function 'kotlin.charArrayOf' call
      var tmp$ret$0 = charArrayOf([char]);
      tmp = lastIndexOfAny(_this__u8e3s4, tmp$ret$0, startIndex, ignoreCase);
    } else {
      // Inline function 'kotlin.text.nativeLastIndexOf' call
      // Inline function 'kotlin.text.nativeLastIndexOf' call
      var str = toString(char);
      // Inline function 'kotlin.js.asDynamic' call
      tmp = _this__u8e3s4.lastIndexOf(str, startIndex);
    }
    return tmp;
  }
  function substringAfter(_this__u8e3s4, delimiter, missingDelimiterValue) {
    missingDelimiterValue = missingDelimiterValue === VOID ? _this__u8e3s4 : missingDelimiterValue;
    var index = indexOf_9(_this__u8e3s4, delimiter);
    return index === -1 ? missingDelimiterValue : substring(_this__u8e3s4, index + delimiter.length | 0, _this__u8e3s4.length);
  }
  function substringBefore(_this__u8e3s4, delimiter, missingDelimiterValue) {
    missingDelimiterValue = missingDelimiterValue === VOID ? _this__u8e3s4 : missingDelimiterValue;
    var index = indexOf_9(_this__u8e3s4, delimiter);
    return index === -1 ? missingDelimiterValue : substring(_this__u8e3s4, 0, index);
  }
  function indexOf_9(_this__u8e3s4, string, startIndex, ignoreCase) {
    startIndex = startIndex === VOID ? 0 : startIndex;
    ignoreCase = ignoreCase === VOID ? false : ignoreCase;
    var tmp;
    var tmp_0;
    if (ignoreCase) {
      tmp_0 = true;
    } else {
      tmp_0 = !(typeof _this__u8e3s4 === 'string');
    }
    if (tmp_0) {
      tmp = indexOf_10(_this__u8e3s4, string, startIndex, charSequenceLength(_this__u8e3s4), ignoreCase);
    } else {
      // Inline function 'kotlin.text.nativeIndexOf' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = _this__u8e3s4.indexOf(string, startIndex);
    }
    return tmp;
  }
  function contains_9(_this__u8e3s4, char, ignoreCase) {
    ignoreCase = ignoreCase === VOID ? false : ignoreCase;
    return indexOf_8(_this__u8e3s4, char, VOID, ignoreCase) >= 0;
  }
  function substringAfterLast(_this__u8e3s4, delimiter, missingDelimiterValue) {
    missingDelimiterValue = missingDelimiterValue === VOID ? _this__u8e3s4 : missingDelimiterValue;
    var index = lastIndexOf_2(_this__u8e3s4, delimiter);
    return index === -1 ? missingDelimiterValue : substring(_this__u8e3s4, index + delimiter.length | 0, _this__u8e3s4.length);
  }
  function get_lastIndex_3(_this__u8e3s4) {
    return charSequenceLength(_this__u8e3s4) - 1 | 0;
  }
  function lineSequence(_this__u8e3s4) {
    // Inline function 'kotlin.sequences.Sequence' call
    return new lineSequence$$inlined$Sequence$1(_this__u8e3s4);
  }
  function startsWith_1(_this__u8e3s4, char, ignoreCase) {
    ignoreCase = ignoreCase === VOID ? false : ignoreCase;
    return charSequenceLength(_this__u8e3s4) > 0 && equals_1(charSequenceGet(_this__u8e3s4, 0), char, ignoreCase);
  }
  function indexOfAny(_this__u8e3s4, chars, startIndex, ignoreCase) {
    startIndex = startIndex === VOID ? 0 : startIndex;
    ignoreCase = ignoreCase === VOID ? false : ignoreCase;
    var tmp;
    if (!ignoreCase && chars.length === 1) {
      tmp = typeof _this__u8e3s4 === 'string';
    } else {
      tmp = false;
    }
    if (tmp) {
      var char = single(chars);
      // Inline function 'kotlin.text.nativeIndexOf' call
      // Inline function 'kotlin.text.nativeIndexOf' call
      var str = toString(char);
      // Inline function 'kotlin.js.asDynamic' call
      return _this__u8e3s4.indexOf(str, startIndex);
    }
    var inductionVariable = coerceAtLeast(startIndex, 0);
    var last = get_lastIndex_3(_this__u8e3s4);
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var charAtIndex = charSequenceGet(_this__u8e3s4, index);
        var tmp$ret$4;
        $l$block: {
          // Inline function 'kotlin.collections.any' call
          var inductionVariable_0 = 0;
          var last_0 = chars.length;
          while (inductionVariable_0 < last_0) {
            var element = chars[inductionVariable_0];
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            if (equals_1(element, charAtIndex, ignoreCase)) {
              tmp$ret$4 = true;
              break $l$block;
            }
          }
          tmp$ret$4 = false;
        }
        if (tmp$ret$4)
          return index;
      }
       while (!(index === last));
    return -1;
  }
  function indexOf_10(_this__u8e3s4, other, startIndex, endIndex, ignoreCase, last) {
    last = last === VOID ? false : last;
    var indices = !last ? numberRangeToNumber(coerceAtLeast(startIndex, 0), coerceAtMost(endIndex, charSequenceLength(_this__u8e3s4))) : downTo(coerceAtMost(startIndex, get_lastIndex_3(_this__u8e3s4)), coerceAtLeast(endIndex, 0));
    var tmp;
    if (typeof _this__u8e3s4 === 'string') {
      tmp = typeof other === 'string';
    } else {
      tmp = false;
    }
    if (tmp) {
      var inductionVariable = indices.c1_1;
      var last_0 = indices.d1_1;
      var step = indices.e1_1;
      if (step > 0 && inductionVariable <= last_0 || (step < 0 && last_0 <= inductionVariable))
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + step | 0;
          if (regionMatches(other, 0, _this__u8e3s4, index, other.length, ignoreCase))
            return index;
        }
         while (!(index === last_0));
    } else {
      var inductionVariable_0 = indices.c1_1;
      var last_1 = indices.d1_1;
      var step_0 = indices.e1_1;
      if (step_0 > 0 && inductionVariable_0 <= last_1 || (step_0 < 0 && last_1 <= inductionVariable_0))
        do {
          var index_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + step_0 | 0;
          if (regionMatchesImpl(other, 0, _this__u8e3s4, index_0, charSequenceLength(other), ignoreCase))
            return index_0;
        }
         while (!(index_0 === last_1));
    }
    return -1;
  }
  function split_1(_this__u8e3s4, delimiter, ignoreCase, limit) {
    requireNonNegativeLimit(limit);
    var currentOffset = 0;
    var nextIndex = indexOf_9(_this__u8e3s4, delimiter, currentOffset, ignoreCase);
    if (nextIndex === -1 || limit === 1) {
      return listOf(toString_1(_this__u8e3s4));
    }
    var isLimited = limit > 0;
    var result = ArrayList_init_$Create$_0(isLimited ? coerceAtMost(limit, 10) : 10);
    $l$loop: do {
      var tmp2 = currentOffset;
      // Inline function 'kotlin.text.substring' call
      var endIndex = nextIndex;
      var tmp$ret$0 = toString_1(charSequenceSubSequence(_this__u8e3s4, tmp2, endIndex));
      result.j(tmp$ret$0);
      currentOffset = nextIndex + delimiter.length | 0;
      if (isLimited && result.p() === (limit - 1 | 0))
        break $l$loop;
      nextIndex = indexOf_9(_this__u8e3s4, delimiter, currentOffset, ignoreCase);
    }
     while (!(nextIndex === -1));
    var tmp2_0 = currentOffset;
    // Inline function 'kotlin.text.substring' call
    var endIndex_0 = charSequenceLength(_this__u8e3s4);
    var tmp$ret$1 = toString_1(charSequenceSubSequence(_this__u8e3s4, tmp2_0, endIndex_0));
    result.j(tmp$ret$1);
    return result;
  }
  function rangesDelimitedBy(_this__u8e3s4, delimiters, startIndex, ignoreCase, limit) {
    startIndex = startIndex === VOID ? 0 : startIndex;
    ignoreCase = ignoreCase === VOID ? false : ignoreCase;
    limit = limit === VOID ? 0 : limit;
    requireNonNegativeLimit(limit);
    return new DelimitedRangesSequence(_this__u8e3s4, startIndex, limit, rangesDelimitedBy$lambda(delimiters, ignoreCase));
  }
  function substring_2(_this__u8e3s4, range) {
    return toString_1(charSequenceSubSequence(_this__u8e3s4, range.p1(), range.q1() + 1 | 0));
  }
  function trimEnd(_this__u8e3s4) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.text.trimEnd' call
      var inductionVariable = charSequenceLength(_this__u8e3s4) - 1 | 0;
      if (0 <= inductionVariable)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + -1 | 0;
          var p0 = charSequenceGet(_this__u8e3s4, index);
          if (!isWhitespace(p0)) {
            tmp$ret$1 = charSequenceSubSequence(_this__u8e3s4, 0, index + 1 | 0);
            break $l$block;
          }
        }
         while (0 <= inductionVariable);
      tmp$ret$1 = '';
    }
    return tmp$ret$1;
  }
  function rangesDelimitedBy_0(_this__u8e3s4, delimiters, startIndex, ignoreCase, limit) {
    startIndex = startIndex === VOID ? 0 : startIndex;
    ignoreCase = ignoreCase === VOID ? false : ignoreCase;
    limit = limit === VOID ? 0 : limit;
    requireNonNegativeLimit(limit);
    var delimitersList = asList(delimiters);
    return new DelimitedRangesSequence(_this__u8e3s4, startIndex, limit, rangesDelimitedBy$lambda_0(delimitersList, ignoreCase));
  }
  function lastIndexOfAny(_this__u8e3s4, chars, startIndex, ignoreCase) {
    startIndex = startIndex === VOID ? get_lastIndex_3(_this__u8e3s4) : startIndex;
    ignoreCase = ignoreCase === VOID ? false : ignoreCase;
    var tmp;
    if (!ignoreCase && chars.length === 1) {
      tmp = typeof _this__u8e3s4 === 'string';
    } else {
      tmp = false;
    }
    if (tmp) {
      var char = single(chars);
      // Inline function 'kotlin.text.nativeLastIndexOf' call
      // Inline function 'kotlin.text.nativeLastIndexOf' call
      var str = toString(char);
      // Inline function 'kotlin.js.asDynamic' call
      return _this__u8e3s4.lastIndexOf(str, startIndex);
    }
    var inductionVariable = coerceAtMost(startIndex, get_lastIndex_3(_this__u8e3s4));
    if (0 <= inductionVariable)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        var charAtIndex = charSequenceGet(_this__u8e3s4, index);
        var tmp$ret$4;
        $l$block: {
          // Inline function 'kotlin.collections.any' call
          var inductionVariable_0 = 0;
          var last = chars.length;
          while (inductionVariable_0 < last) {
            var element = chars[inductionVariable_0];
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            if (equals_1(element, charAtIndex, ignoreCase)) {
              tmp$ret$4 = true;
              break $l$block;
            }
          }
          tmp$ret$4 = false;
        }
        if (tmp$ret$4)
          return index;
      }
       while (0 <= inductionVariable);
    return -1;
  }
  function trim(_this__u8e3s4) {
    // Inline function 'kotlin.text.trim' call
    var startIndex = 0;
    var endIndex = charSequenceLength(_this__u8e3s4) - 1 | 0;
    var startFound = false;
    $l$loop: while (startIndex <= endIndex) {
      var index = !startFound ? startIndex : endIndex;
      var p0 = charSequenceGet(_this__u8e3s4, index);
      var match = isWhitespace(p0);
      if (!startFound) {
        if (!match)
          startFound = true;
        else
          startIndex = startIndex + 1 | 0;
      } else {
        if (!match)
          break $l$loop;
        else
          endIndex = endIndex - 1 | 0;
      }
    }
    return charSequenceSubSequence(_this__u8e3s4, startIndex, endIndex + 1 | 0);
  }
  function State() {
    this.ik_1 = 0;
    this.jk_1 = 1;
    this.kk_1 = 2;
  }
  var State_instance;
  function State_getInstance() {
    return State_instance;
  }
  function LinesIterator(string) {
    this.lk_1 = string;
    this.mk_1 = 0;
    this.nk_1 = 0;
    this.ok_1 = 0;
    this.pk_1 = 0;
  }
  protoOf(LinesIterator).n = function () {
    if (!(this.mk_1 === 0)) {
      return this.mk_1 === 1;
    }
    if (this.pk_1 < 0) {
      this.mk_1 = 2;
      return false;
    }
    var _delimiterLength = -1;
    var _delimiterStartIndex = charSequenceLength(this.lk_1);
    var inductionVariable = this.nk_1;
    var last = charSequenceLength(this.lk_1);
    if (inductionVariable < last)
      $l$loop: do {
        var idx = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var c = charSequenceGet(this.lk_1, idx);
        if (c === _Char___init__impl__6a9atx(10) || c === _Char___init__impl__6a9atx(13)) {
          _delimiterLength = c === _Char___init__impl__6a9atx(13) && (idx + 1 | 0) < charSequenceLength(this.lk_1) && charSequenceGet(this.lk_1, idx + 1 | 0) === _Char___init__impl__6a9atx(10) ? 2 : 1;
          _delimiterStartIndex = idx;
          break $l$loop;
        }
      }
       while (inductionVariable < last);
    this.mk_1 = 1;
    this.pk_1 = _delimiterLength;
    this.ok_1 = _delimiterStartIndex;
    return true;
  };
  protoOf(LinesIterator).o = function () {
    if (!this.n()) {
      throw NoSuchElementException_init_$Create$();
    }
    this.mk_1 = 0;
    var lastIndex = this.ok_1;
    var firstIndex = this.nk_1;
    this.nk_1 = this.ok_1 + this.pk_1 | 0;
    // Inline function 'kotlin.text.substring' call
    var this_0 = this.lk_1;
    return toString_1(charSequenceSubSequence(this_0, firstIndex, lastIndex));
  };
  function regionMatchesImpl(_this__u8e3s4, thisOffset, other, otherOffset, length, ignoreCase) {
    if (otherOffset < 0 || thisOffset < 0 || thisOffset > (charSequenceLength(_this__u8e3s4) - length | 0) || otherOffset > (charSequenceLength(other) - length | 0)) {
      return false;
    }
    var inductionVariable = 0;
    if (inductionVariable < length)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!equals_1(charSequenceGet(_this__u8e3s4, thisOffset + index | 0), charSequenceGet(other, otherOffset + index | 0), ignoreCase))
          return false;
      }
       while (inductionVariable < length);
    return true;
  }
  function requireNonNegativeLimit(limit) {
    // Inline function 'kotlin.require' call
    if (!(limit >= 0)) {
      var message = 'Limit must be non-negative, but was ' + limit;
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    return Unit_instance;
  }
  function calcNext_1($this) {
    if ($this.sk_1 < 0) {
      $this.qk_1 = 0;
      $this.tk_1 = null;
    } else {
      var tmp;
      var tmp_0;
      if ($this.vk_1.yk_1 > 0) {
        $this.uk_1 = $this.uk_1 + 1 | 0;
        tmp_0 = $this.uk_1 >= $this.vk_1.yk_1;
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        tmp = true;
      } else {
        tmp = $this.sk_1 > charSequenceLength($this.vk_1.wk_1);
      }
      if (tmp) {
        $this.tk_1 = numberRangeToNumber($this.rk_1, get_lastIndex_3($this.vk_1.wk_1));
        $this.sk_1 = -1;
      } else {
        var match = $this.vk_1.zk_1($this.vk_1.wk_1, $this.sk_1);
        if (match == null) {
          $this.tk_1 = numberRangeToNumber($this.rk_1, get_lastIndex_3($this.vk_1.wk_1));
          $this.sk_1 = -1;
        } else {
          var index = match.fg();
          var length = match.gg();
          $this.tk_1 = until($this.rk_1, index);
          $this.rk_1 = index + length | 0;
          $this.sk_1 = $this.rk_1 + (length === 0 ? 1 : 0) | 0;
        }
      }
      $this.qk_1 = 1;
    }
  }
  function DelimitedRangesSequence$iterator$1(this$0) {
    this.vk_1 = this$0;
    this.qk_1 = -1;
    this.rk_1 = coerceIn_0(this$0.xk_1, 0, charSequenceLength(this$0.wk_1));
    this.sk_1 = this.rk_1;
    this.tk_1 = null;
    this.uk_1 = 0;
  }
  protoOf(DelimitedRangesSequence$iterator$1).o = function () {
    if (this.qk_1 === -1) {
      calcNext_1(this);
    }
    if (this.qk_1 === 0)
      throw NoSuchElementException_init_$Create$();
    var tmp = this.tk_1;
    var result = tmp instanceof IntRange ? tmp : THROW_CCE();
    this.tk_1 = null;
    this.qk_1 = -1;
    return result;
  };
  protoOf(DelimitedRangesSequence$iterator$1).n = function () {
    if (this.qk_1 === -1) {
      calcNext_1(this);
    }
    return this.qk_1 === 1;
  };
  function DelimitedRangesSequence(input, startIndex, limit, getNextMatch) {
    this.wk_1 = input;
    this.xk_1 = startIndex;
    this.yk_1 = limit;
    this.zk_1 = getNextMatch;
  }
  protoOf(DelimitedRangesSequence).m = function () {
    return new DelimitedRangesSequence$iterator$1(this);
  };
  function findAnyOf(_this__u8e3s4, strings, startIndex, ignoreCase, last) {
    if (!ignoreCase && strings.p() === 1) {
      var string = single_1(strings);
      var index = !last ? indexOf_9(_this__u8e3s4, string, startIndex) : lastIndexOf_2(_this__u8e3s4, string, startIndex);
      return index < 0 ? null : to(index, string);
    }
    var indices = !last ? numberRangeToNumber(coerceAtLeast(startIndex, 0), charSequenceLength(_this__u8e3s4)) : downTo(coerceAtMost(startIndex, get_lastIndex_3(_this__u8e3s4)), 0);
    if (typeof _this__u8e3s4 === 'string') {
      var inductionVariable = indices.c1_1;
      var last_0 = indices.d1_1;
      var step = indices.e1_1;
      if (step > 0 && inductionVariable <= last_0 || (step < 0 && last_0 <= inductionVariable))
        do {
          var index_0 = inductionVariable;
          inductionVariable = inductionVariable + step | 0;
          var tmp$ret$1;
          $l$block: {
            // Inline function 'kotlin.collections.firstOrNull' call
            var _iterator__ex2g4s = strings.m();
            while (_iterator__ex2g4s.n()) {
              var element = _iterator__ex2g4s.o();
              if (regionMatches(element, 0, _this__u8e3s4, index_0, element.length, ignoreCase)) {
                tmp$ret$1 = element;
                break $l$block;
              }
            }
            tmp$ret$1 = null;
          }
          var matchingString = tmp$ret$1;
          if (!(matchingString == null))
            return to(index_0, matchingString);
        }
         while (!(index_0 === last_0));
    } else {
      var inductionVariable_0 = indices.c1_1;
      var last_1 = indices.d1_1;
      var step_0 = indices.e1_1;
      if (step_0 > 0 && inductionVariable_0 <= last_1 || (step_0 < 0 && last_1 <= inductionVariable_0))
        do {
          var index_1 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + step_0 | 0;
          var tmp$ret$3;
          $l$block_0: {
            // Inline function 'kotlin.collections.firstOrNull' call
            var _iterator__ex2g4s_0 = strings.m();
            while (_iterator__ex2g4s_0.n()) {
              var element_0 = _iterator__ex2g4s_0.o();
              if (regionMatchesImpl(element_0, 0, _this__u8e3s4, index_1, element_0.length, ignoreCase)) {
                tmp$ret$3 = element_0;
                break $l$block_0;
              }
            }
            tmp$ret$3 = null;
          }
          var matchingString_0 = tmp$ret$3;
          if (!(matchingString_0 == null))
            return to(index_1, matchingString_0);
        }
         while (!(index_1 === last_1));
    }
    return null;
  }
  function padStart(_this__u8e3s4, length, padChar) {
    padChar = padChar === VOID ? _Char___init__impl__6a9atx(32) : padChar;
    return toString_1(padStart_0(isCharSequence(_this__u8e3s4) ? _this__u8e3s4 : THROW_CCE(), length, padChar));
  }
  function lines(_this__u8e3s4) {
    return toList_2(lineSequence(_this__u8e3s4));
  }
  function padStart_0(_this__u8e3s4, length, padChar) {
    padChar = padChar === VOID ? _Char___init__impl__6a9atx(32) : padChar;
    if (length < 0)
      throw IllegalArgumentException_init_$Create$_0('Desired length ' + length + ' is less than zero.');
    if (length <= charSequenceLength(_this__u8e3s4))
      return charSequenceSubSequence(_this__u8e3s4, 0, charSequenceLength(_this__u8e3s4));
    var sb = StringBuilder_init_$Create$(length);
    var inductionVariable = 1;
    var last = length - charSequenceLength(_this__u8e3s4) | 0;
    if (inductionVariable <= last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        sb.k8(padChar);
      }
       while (!(i === last));
    sb.k(_this__u8e3s4);
    return sb;
  }
  function lineSequence$$inlined$Sequence$1($this_lineSequence) {
    this.al_1 = $this_lineSequence;
  }
  protoOf(lineSequence$$inlined$Sequence$1).m = function () {
    return new LinesIterator(this.al_1);
  };
  function rangesDelimitedBy$lambda($delimiters, $ignoreCase) {
    return function ($this$DelimitedRangesSequence, currentIndex) {
      // Inline function 'kotlin.let' call
      var it = indexOfAny($this$DelimitedRangesSequence, $delimiters, currentIndex, $ignoreCase);
      return it < 0 ? null : to(it, 1);
    };
  }
  function rangesDelimitedBy$lambda_0($delimitersList, $ignoreCase) {
    return function ($this$DelimitedRangesSequence, currentIndex) {
      var tmp0_safe_receiver = findAnyOf($this$DelimitedRangesSequence, $delimitersList, currentIndex, $ignoreCase, false);
      var tmp;
      if (tmp0_safe_receiver == null) {
        tmp = null;
      } else {
        // Inline function 'kotlin.let' call
        tmp = to(tmp0_safe_receiver.pg_1, tmp0_safe_receiver.qg_1.length);
      }
      return tmp;
    };
  }
  function MatchNamedGroupCollection() {
  }
  function _Duration___init__impl__kdtzql(rawValue) {
    // Inline function 'kotlin.time.durationAssertionsEnabled' call
    if (true) {
      if (isInNanos(rawValue)) {
        var containsArg = _get_value__a43j40_0(rawValue);
        if (!(-4611686018426999999n <= containsArg ? containsArg <= 4611686018426999999n : false))
          throw AssertionError_init_$Create$_1(_get_value__a43j40_0(rawValue).toString() + ' ns is out of nanoseconds range');
      } else {
        var containsArg_0 = _get_value__a43j40_0(rawValue);
        if (!(-4611686018427387903n <= containsArg_0 ? containsArg_0 <= 4611686018427387903n : false))
          throw AssertionError_init_$Create$_1(_get_value__a43j40_0(rawValue).toString() + ' ms is out of milliseconds range');
        var containsArg_1 = _get_value__a43j40_0(rawValue);
        if (-4611686018426n <= containsArg_1 ? containsArg_1 <= 4611686018426n : false)
          throw AssertionError_init_$Create$_1(_get_value__a43j40_0(rawValue).toString() + ' ms is denormalized');
      }
    }
    return rawValue;
  }
  function _get_rawValue__5zfu4e($this) {
    return $this;
  }
  function _get_value__a43j40_0($this) {
    return shiftRight(_get_rawValue__5zfu4e($this), 1);
  }
  function isInNanos($this) {
    // Inline function 'kotlin.time.Duration.unitDiscriminator' call
    return (convertToInt(_get_rawValue__5zfu4e($this)) & 1) === 0;
  }
  function isInMillis($this) {
    // Inline function 'kotlin.time.Duration.unitDiscriminator' call
    return (convertToInt(_get_rawValue__5zfu4e($this)) & 1) === 1;
  }
  function _get_storageUnit__szjgha($this) {
    return isInNanos($this) ? DurationUnit_NANOSECONDS_getInstance() : DurationUnit_MILLISECONDS_getInstance();
  }
  function Companion_16() {
    Companion_instance_16 = this;
    this.qe_1 = _Duration___init__impl__kdtzql(0n);
    this.re_1 = durationOfMillis(4611686018427387903n);
    this.se_1 = durationOfMillis(-4611686018427387903n);
  }
  protoOf(Companion_16).bl = function (value) {
    var tmp;
    try {
      tmp = parseDuration(value, true);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof IllegalArgumentException) {
        var e = $p;
        throw IllegalArgumentException_init_$Create$_1("Invalid ISO duration string format: '" + value + "'.", e);
      } else {
        throw $p;
      }
    }
    return tmp;
  };
  var Companion_instance_16;
  function Companion_getInstance_16() {
    if (Companion_instance_16 == null)
      new Companion_16();
    return Companion_instance_16;
  }
  function Duration__unaryMinus_impl_x2k1y0($this) {
    var tmp = negate_0(_get_value__a43j40_0($this));
    // Inline function 'kotlin.time.Duration.unitDiscriminator' call
    var tmp$ret$0 = convertToInt(_get_rawValue__5zfu4e($this)) & 1;
    return durationOf(tmp, tmp$ret$0);
  }
  function Duration__plus_impl_yu9v8f($this, other) {
    if (Duration__isInfinite_impl_tsn9y3($this)) {
      if (Duration__isFinite_impl_rzjsps(other) || (_get_rawValue__5zfu4e($this) ^ _get_rawValue__5zfu4e(other)) >= 0n)
        return $this;
      else
        throw IllegalArgumentException_init_$Create$_0('Summing infinite durations of different signs yields an undefined result.');
    } else if (Duration__isInfinite_impl_tsn9y3(other))
      return other;
    var tmp;
    // Inline function 'kotlin.time.Duration.unitDiscriminator' call
    var tmp_0 = convertToInt(_get_rawValue__5zfu4e($this)) & 1;
    // Inline function 'kotlin.time.Duration.unitDiscriminator' call
    if (tmp_0 === (convertToInt(_get_rawValue__5zfu4e(other)) & 1)) {
      var result = add_2(_get_value__a43j40_0($this), _get_value__a43j40_0(other));
      tmp = isInNanos($this) ? durationOfNanosNormalized(result) : durationOfMillisNormalized(result);
    } else {
      if (isInMillis($this)) {
        tmp = addValuesMixedRanges($this, _get_value__a43j40_0($this), _get_value__a43j40_0(other));
      } else {
        tmp = addValuesMixedRanges($this, _get_value__a43j40_0(other), _get_value__a43j40_0($this));
      }
    }
    return tmp;
  }
  function addValuesMixedRanges($this, thisMillis, otherNanos) {
    var otherMillis = nanosToMillis(otherNanos);
    var resultMillis = add_2(thisMillis, otherMillis);
    var tmp;
    if (-4611686018426n <= resultMillis ? resultMillis <= 4611686018426n : false) {
      var otherNanoRemainder = subtract_1(otherNanos, millisToNanos(otherMillis));
      tmp = durationOfNanos(add_2(millisToNanos(resultMillis), otherNanoRemainder));
    } else {
      tmp = durationOfMillis(coerceIn(resultMillis, -4611686018427387903n, 4611686018427387903n));
    }
    return tmp;
  }
  function Duration__isNegative_impl_pbysfa($this) {
    return _get_rawValue__5zfu4e($this) < 0n;
  }
  function Duration__isInfinite_impl_tsn9y3($this) {
    return _get_rawValue__5zfu4e($this) === _get_rawValue__5zfu4e(Companion_getInstance_16().re_1) || _get_rawValue__5zfu4e($this) === _get_rawValue__5zfu4e(Companion_getInstance_16().se_1);
  }
  function Duration__isFinite_impl_rzjsps($this) {
    return !Duration__isInfinite_impl_tsn9y3($this);
  }
  function _Duration___get_absoluteValue__impl__vr7i6w($this) {
    return Duration__isNegative_impl_pbysfa($this) ? Duration__unaryMinus_impl_x2k1y0($this) : $this;
  }
  function Duration__compareTo_impl_pchp0f($this, other) {
    var compareBits = _get_rawValue__5zfu4e($this) ^ _get_rawValue__5zfu4e(other);
    if (compareBits < 0n || (convertToInt(compareBits) & 1) === 0)
      return compareTo_0(_get_rawValue__5zfu4e($this), _get_rawValue__5zfu4e(other));
    // Inline function 'kotlin.time.Duration.unitDiscriminator' call
    var tmp = convertToInt(_get_rawValue__5zfu4e($this)) & 1;
    // Inline function 'kotlin.time.Duration.unitDiscriminator' call
    var r = tmp - (convertToInt(_get_rawValue__5zfu4e(other)) & 1) | 0;
    return Duration__isNegative_impl_pbysfa($this) ? -r | 0 : r;
  }
  function Duration__compareTo_impl_pchp0f_0($this, other) {
    return Duration__compareTo_impl_pchp0f($this.pe_1, other instanceof Duration ? other.pe_1 : THROW_CCE());
  }
  function _Duration___get_hoursComponent__impl__7hllxa($this) {
    var tmp;
    if (Duration__isInfinite_impl_tsn9y3($this)) {
      tmp = 0;
    } else {
      // Inline function 'kotlin.Long.rem' call
      var this_0 = _Duration___get_inWholeHours__impl__kb9f3j($this);
      var tmp$ret$0 = modulo(this_0, fromInt_0(24));
      tmp = convertToInt(tmp$ret$0);
    }
    return tmp;
  }
  function _Duration___get_minutesComponent__impl__ctvd8u($this) {
    var tmp;
    if (Duration__isInfinite_impl_tsn9y3($this)) {
      tmp = 0;
    } else {
      // Inline function 'kotlin.Long.rem' call
      var this_0 = _Duration___get_inWholeMinutes__impl__dognoh($this);
      var tmp$ret$0 = modulo(this_0, fromInt_0(60));
      tmp = convertToInt(tmp$ret$0);
    }
    return tmp;
  }
  function _Duration___get_secondsComponent__impl__if34a6($this) {
    var tmp;
    if (Duration__isInfinite_impl_tsn9y3($this)) {
      tmp = 0;
    } else {
      // Inline function 'kotlin.Long.rem' call
      var this_0 = _Duration___get_inWholeSeconds__impl__hpy7b3($this);
      var tmp$ret$0 = modulo(this_0, fromInt_0(60));
      tmp = convertToInt(tmp$ret$0);
    }
    return tmp;
  }
  function _Duration___get_nanosecondsComponent__impl__nh19kq($this) {
    var tmp;
    if (Duration__isInfinite_impl_tsn9y3($this)) {
      tmp = 0;
    } else if (isInMillis($this)) {
      // Inline function 'kotlin.Long.rem' call
      var this_0 = _get_value__a43j40_0($this);
      var tmp$ret$0 = modulo(this_0, fromInt_0(1000));
      tmp = convertToInt(millisToNanos(tmp$ret$0));
    } else {
      var tmp0 = _get_value__a43j40_0($this);
      // Inline function 'kotlin.Long.rem' call
      var other = 1000000000;
      var tmp$ret$1 = modulo(tmp0, fromInt_0(other));
      tmp = convertToInt(tmp$ret$1);
    }
    return tmp;
  }
  function Duration__toDouble_impl_a56y2b($this, unit) {
    var tmp0_subject = _get_rawValue__5zfu4e($this);
    var tmp;
    if (tmp0_subject === _get_rawValue__5zfu4e(Companion_getInstance_16().re_1)) {
      tmp = Infinity;
    } else if (tmp0_subject === _get_rawValue__5zfu4e(Companion_getInstance_16().se_1)) {
      tmp = -Infinity;
    } else {
      tmp = convertDurationUnit(toNumber_0(_get_value__a43j40_0($this)), _get_storageUnit__szjgha($this), unit);
    }
    return tmp;
  }
  function Duration__toLong_impl_shr43i($this, unit) {
    var tmp0_subject = _get_rawValue__5zfu4e($this);
    return tmp0_subject === _get_rawValue__5zfu4e(Companion_getInstance_16().re_1) ? 9223372036854775807n : tmp0_subject === _get_rawValue__5zfu4e(Companion_getInstance_16().se_1) ? -9223372036854775808n : convertDurationUnit_0(_get_value__a43j40_0($this), _get_storageUnit__szjgha($this), unit);
  }
  function _Duration___get_inWholeDays__impl__7bvpxz($this) {
    return Duration__toLong_impl_shr43i($this, DurationUnit_DAYS_getInstance());
  }
  function _Duration___get_inWholeHours__impl__kb9f3j($this) {
    return Duration__toLong_impl_shr43i($this, DurationUnit_HOURS_getInstance());
  }
  function _Duration___get_inWholeMinutes__impl__dognoh($this) {
    return Duration__toLong_impl_shr43i($this, DurationUnit_MINUTES_getInstance());
  }
  function _Duration___get_inWholeSeconds__impl__hpy7b3($this) {
    return Duration__toLong_impl_shr43i($this, DurationUnit_SECONDS_getInstance());
  }
  function _Duration___get_inWholeMilliseconds__impl__msfiry($this) {
    return isInMillis($this) && Duration__isFinite_impl_rzjsps($this) ? _get_value__a43j40_0($this) : Duration__toLong_impl_shr43i($this, DurationUnit_MILLISECONDS_getInstance());
  }
  function Duration__toString_impl_8d916b($this) {
    var tmp0_subject = _get_rawValue__5zfu4e($this);
    var tmp;
    if (tmp0_subject === 0n) {
      tmp = '0s';
    } else if (tmp0_subject === _get_rawValue__5zfu4e(Companion_getInstance_16().re_1)) {
      tmp = 'Infinity';
    } else if (tmp0_subject === _get_rawValue__5zfu4e(Companion_getInstance_16().se_1)) {
      tmp = '-Infinity';
    } else {
      var isNegative = Duration__isNegative_impl_pbysfa($this);
      // Inline function 'kotlin.text.buildString' call
      // Inline function 'kotlin.apply' call
      var this_0 = StringBuilder_init_$Create$_1();
      if (isNegative) {
        this_0.k8(_Char___init__impl__6a9atx(45));
      }
      // Inline function 'kotlin.time.Duration.toComponents' call
      var this_1 = _Duration___get_absoluteValue__impl__vr7i6w($this);
      var tmp0 = _Duration___get_inWholeDays__impl__7bvpxz(this_1);
      var tmp2 = _Duration___get_hoursComponent__impl__7hllxa(this_1);
      var tmp4 = _Duration___get_minutesComponent__impl__ctvd8u(this_1);
      var tmp6 = _Duration___get_secondsComponent__impl__if34a6(this_1);
      var nanoseconds = _Duration___get_nanosecondsComponent__impl__nh19kq(this_1);
      var hasDays = !(tmp0 === 0n);
      var hasHours = !(tmp2 === 0);
      var hasMinutes = !(tmp4 === 0);
      var hasSeconds = !(tmp6 === 0) || !(nanoseconds === 0);
      var components = 0;
      if (hasDays) {
        this_0.hc(tmp0).k8(_Char___init__impl__6a9atx(100));
        components = components + 1 | 0;
      }
      if (hasHours || (hasDays && (hasMinutes || hasSeconds))) {
        var _unary__edvuaz = components;
        components = _unary__edvuaz + 1 | 0;
        if (_unary__edvuaz > 0) {
          this_0.k8(_Char___init__impl__6a9atx(32));
        }
        this_0.gc(tmp2).k8(_Char___init__impl__6a9atx(104));
      }
      if (hasMinutes || (hasSeconds && (hasHours || hasDays))) {
        var _unary__edvuaz_0 = components;
        components = _unary__edvuaz_0 + 1 | 0;
        if (_unary__edvuaz_0 > 0) {
          this_0.k8(_Char___init__impl__6a9atx(32));
        }
        this_0.gc(tmp4).k8(_Char___init__impl__6a9atx(109));
      }
      if (hasSeconds) {
        var _unary__edvuaz_1 = components;
        components = _unary__edvuaz_1 + 1 | 0;
        if (_unary__edvuaz_1 > 0) {
          this_0.k8(_Char___init__impl__6a9atx(32));
        }
        if (!(tmp6 === 0) || hasDays || hasHours || hasMinutes) {
          appendFractional($this, this_0, tmp6, nanoseconds, 9, 's', false);
        } else if (nanoseconds >= 1000000) {
          appendFractional($this, this_0, nanoseconds / 1000000 | 0, nanoseconds % 1000000 | 0, 6, 'ms', false);
        } else if (nanoseconds >= 1000) {
          appendFractional($this, this_0, nanoseconds / 1000 | 0, nanoseconds % 1000 | 0, 3, 'us', false);
        } else
          this_0.gc(nanoseconds).j8('ns');
      }
      if (isNegative && components > 1) {
        this_0.ic(1, _Char___init__impl__6a9atx(40)).k8(_Char___init__impl__6a9atx(41));
      }
      tmp = this_0.toString();
    }
    return tmp;
  }
  function appendFractional($this, _this__u8e3s4, whole, fractional, fractionalSize, unit, isoZeroes) {
    _this__u8e3s4.gc(whole);
    if (!(fractional === 0)) {
      _this__u8e3s4.k8(_Char___init__impl__6a9atx(46));
      var fracString = padStart(fractional.toString(), fractionalSize, _Char___init__impl__6a9atx(48));
      var tmp$ret$1;
      $l$block: {
        // Inline function 'kotlin.text.indexOfLast' call
        var inductionVariable = charSequenceLength(fracString) - 1 | 0;
        if (0 <= inductionVariable)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + -1 | 0;
            if (!(charSequenceGet(fracString, index) === _Char___init__impl__6a9atx(48))) {
              tmp$ret$1 = index;
              break $l$block;
            }
          }
           while (0 <= inductionVariable);
        tmp$ret$1 = -1;
      }
      var nonZeroDigits = tmp$ret$1 + 1 | 0;
      if (!isoZeroes && nonZeroDigits < 3) {
        // Inline function 'kotlin.text.appendRange' call
        _this__u8e3s4.fc(fracString, 0, nonZeroDigits);
      } else {
        // Inline function 'kotlin.text.appendRange' call
        var endIndex = imul((nonZeroDigits + 2 | 0) / 3 | 0, 3);
        _this__u8e3s4.fc(fracString, 0, endIndex);
      }
    }
    _this__u8e3s4.j8(unit);
  }
  function Duration__toString_impl_8d916b_0($this, unit, decimals) {
    // Inline function 'kotlin.require' call
    if (!(decimals >= 0)) {
      var message = 'decimals must be not negative, but was ' + decimals;
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    var number = Duration__toDouble_impl_a56y2b($this, unit);
    if (isInfinite(number))
      return number.toString();
    return formatToExactDecimals(number, coerceAtMost(decimals, 12)) + shortName(unit);
  }
  function Duration__toIsoString_impl_9h6wsm($this) {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder_init_$Create$_1();
    if (Duration__isNegative_impl_pbysfa($this)) {
      this_0.k8(_Char___init__impl__6a9atx(45));
    }
    this_0.j8('PT');
    // Inline function 'kotlin.time.Duration.toComponents' call
    var this_1 = _Duration___get_absoluteValue__impl__vr7i6w($this);
    var tmp0 = _Duration___get_inWholeHours__impl__kb9f3j(this_1);
    var tmp2 = _Duration___get_minutesComponent__impl__ctvd8u(this_1);
    var tmp4 = _Duration___get_secondsComponent__impl__if34a6(this_1);
    var nanoseconds = _Duration___get_nanosecondsComponent__impl__nh19kq(this_1);
    var hours = tmp0;
    if (Duration__isInfinite_impl_tsn9y3($this)) {
      hours = 9999999999999n;
    }
    var hasHours = !(hours === 0n);
    var hasSeconds = !(tmp4 === 0) || !(nanoseconds === 0);
    var hasMinutes = !(tmp2 === 0) || (hasSeconds && hasHours);
    if (hasHours) {
      this_0.hc(hours).k8(_Char___init__impl__6a9atx(72));
    }
    if (hasMinutes) {
      this_0.gc(tmp2).k8(_Char___init__impl__6a9atx(77));
    }
    if (hasSeconds || (!hasHours && !hasMinutes)) {
      appendFractional($this, this_0, tmp4, nanoseconds, 9, 'S', true);
    }
    return this_0.toString();
  }
  function Duration__hashCode_impl_u4exz6($this) {
    return getBigIntHashCode($this);
  }
  function Duration__equals_impl_ygj6w6($this, other) {
    if (!(other instanceof Duration))
      return false;
    if (!($this === other.pe_1))
      return false;
    return true;
  }
  function Duration(rawValue) {
    Companion_getInstance_16();
    this.pe_1 = rawValue;
  }
  protoOf(Duration).cl = function (other) {
    return Duration__compareTo_impl_pchp0f(this.pe_1, other);
  };
  protoOf(Duration).d = function (other) {
    return Duration__compareTo_impl_pchp0f_0(this, other);
  };
  protoOf(Duration).toString = function () {
    return Duration__toString_impl_8d916b(this.pe_1);
  };
  protoOf(Duration).hashCode = function () {
    return Duration__hashCode_impl_u4exz6(this.pe_1);
  };
  protoOf(Duration).equals = function (other) {
    return Duration__equals_impl_ygj6w6(this.pe_1, other);
  };
  function toDuration(_this__u8e3s4, unit) {
    var maxNsInUnit = convertDurationUnitOverflow(4611686018426999999n, DurationUnit_NANOSECONDS_getInstance(), unit);
    if (negate_0(maxNsInUnit) <= _this__u8e3s4 ? _this__u8e3s4 <= maxNsInUnit : false) {
      return durationOfNanos(convertDurationUnitOverflow(_this__u8e3s4, unit, DurationUnit_NANOSECONDS_getInstance()));
    } else {
      var millis = convertDurationUnit_0(_this__u8e3s4, unit, DurationUnit_MILLISECONDS_getInstance());
      return durationOfMillis(coerceIn(millis, -4611686018427387903n, 4611686018427387903n));
    }
  }
  function durationOfMillis(normalMillis) {
    // Inline function 'kotlin.Long.plus' call
    var this_0 = shiftLeft(normalMillis, 1);
    var tmp$ret$0 = add_2(this_0, fromInt_0(1));
    return _Duration___init__impl__kdtzql(tmp$ret$0);
  }
  function toDuration_0(_this__u8e3s4, unit) {
    var tmp;
    if (unit.a3(DurationUnit_SECONDS_getInstance()) <= 0) {
      tmp = durationOfNanos(convertDurationUnitOverflow(fromInt_0(_this__u8e3s4), unit, DurationUnit_NANOSECONDS_getInstance()));
    } else {
      tmp = toDuration(fromInt_0(_this__u8e3s4), unit);
    }
    return tmp;
  }
  function toDuration_1(_this__u8e3s4, unit) {
    var valueInNs = convertDurationUnit(_this__u8e3s4, unit, DurationUnit_NANOSECONDS_getInstance());
    // Inline function 'kotlin.require' call
    if (!!isNaN_0(valueInNs)) {
      var message = 'Duration value cannot be NaN.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    var nanos = roundToLong(valueInNs);
    var tmp;
    if (-4611686018426999999n <= nanos ? nanos <= 4611686018426999999n : false) {
      tmp = durationOfNanos(nanos);
    } else {
      var millis = roundToLong(convertDurationUnit(_this__u8e3s4, unit, DurationUnit_MILLISECONDS_getInstance()));
      tmp = durationOfMillisNormalized(millis);
    }
    return tmp;
  }
  function parseDuration(value, strictIso) {
    var length = value.length;
    if (length === 0)
      throw IllegalArgumentException_init_$Create$_0('The string is empty');
    var index = 0;
    var result = Companion_getInstance_16().qe_1;
    var infinityString = 'Infinity';
    var tmp0_subject = charCodeAt(value, index);
    if (tmp0_subject === _Char___init__impl__6a9atx(43) || tmp0_subject === _Char___init__impl__6a9atx(45)) {
      index = index + 1 | 0;
    }
    var hasSign = index > 0;
    var isNegative = hasSign && startsWith_1(value, _Char___init__impl__6a9atx(45));
    if (length <= index)
      throw IllegalArgumentException_init_$Create$_0('No components');
    else {
      if (charCodeAt(value, index) === _Char___init__impl__6a9atx(80)) {
        index = index + 1 | 0;
        if (index === length)
          throw IllegalArgumentException_init_$Create$();
        var nonDigitSymbols = '+-.';
        var isTimeComponent = false;
        var prevUnit = null;
        $l$loop: while (index < length) {
          if (charCodeAt(value, index) === _Char___init__impl__6a9atx(84)) {
            var tmp;
            if (isTimeComponent) {
              tmp = true;
            } else {
              index = index + 1 | 0;
              tmp = index === length;
            }
            if (tmp)
              throw IllegalArgumentException_init_$Create$();
            isTimeComponent = true;
            continue $l$loop;
          }
          // Inline function 'kotlin.time.substringWhile' call
          var startIndex = index;
          // Inline function 'kotlin.time.skipWhile' call
          var i = startIndex;
          $l$loop_0: while (true) {
            var tmp_0;
            if (i < value.length) {
              var it = charCodeAt(value, i);
              tmp_0 = (_Char___init__impl__6a9atx(48) <= it ? it <= _Char___init__impl__6a9atx(57) : false) || contains_9(nonDigitSymbols, it);
            } else {
              tmp_0 = false;
            }
            if (!tmp_0) {
              break $l$loop_0;
            }
            i = i + 1 | 0;
          }
          var tmp$ret$1 = i;
          var component = substring(value, startIndex, tmp$ret$1);
          // Inline function 'kotlin.text.isEmpty' call
          if (charSequenceLength(component) === 0)
            throw IllegalArgumentException_init_$Create$();
          index = index + component.length | 0;
          // Inline function 'kotlin.text.getOrElse' call
          var index_0 = index;
          var tmp_1;
          if (0 <= index_0 ? index_0 <= (charSequenceLength(value) - 1 | 0) : false) {
            tmp_1 = charSequenceGet(value, index_0);
          } else {
            throw IllegalArgumentException_init_$Create$_0('Missing unit for value ' + component);
          }
          var unitChar = tmp_1;
          index = index + 1 | 0;
          var unit = durationUnitByIsoChar(unitChar, isTimeComponent);
          if (!(prevUnit == null) && prevUnit.a3(unit) <= 0)
            throw IllegalArgumentException_init_$Create$_0('Unexpected order of duration components');
          prevUnit = unit;
          var dotIndex = indexOf_8(component, _Char___init__impl__6a9atx(46));
          if (unit.equals(DurationUnit_SECONDS_getInstance()) && dotIndex > 0) {
            var whole = substring(component, 0, dotIndex);
            result = Duration__plus_impl_yu9v8f(result, toDuration(parseOverLongIsoComponent(whole), unit));
            result = Duration__plus_impl_yu9v8f(result, toDuration_1(toDouble(substring_0(component, dotIndex)), unit));
          } else {
            result = Duration__plus_impl_yu9v8f(result, toDuration(parseOverLongIsoComponent(component), unit));
          }
        }
      } else {
        if (strictIso)
          throw IllegalArgumentException_init_$Create$();
        else {
          var tmp_2 = index;
          var tmp0 = length - index | 0;
          // Inline function 'kotlin.comparisons.maxOf' call
          var b = infinityString.length;
          var tmp$ret$5 = Math.max(tmp0, b);
          if (regionMatches(value, tmp_2, infinityString, 0, tmp$ret$5, true)) {
            result = Companion_getInstance_16().re_1;
          } else {
            var prevUnit_0 = null;
            var afterFirst = false;
            var allowSpaces = !hasSign;
            if (hasSign && charCodeAt(value, index) === _Char___init__impl__6a9atx(40) && last_2(value) === _Char___init__impl__6a9atx(41)) {
              allowSpaces = true;
              index = index + 1 | 0;
              var tmp_3 = index;
              length = length - 1 | 0;
              if (tmp_3 === length)
                throw IllegalArgumentException_init_$Create$_0('No components');
            }
            while (index < length) {
              if (afterFirst && allowSpaces) {
                // Inline function 'kotlin.time.skipWhile' call
                var i_0 = index;
                $l$loop_1: while (true) {
                  var tmp_4;
                  if (i_0 < value.length) {
                    tmp_4 = charCodeAt(value, i_0) === _Char___init__impl__6a9atx(32);
                  } else {
                    tmp_4 = false;
                  }
                  if (!tmp_4) {
                    break $l$loop_1;
                  }
                  i_0 = i_0 + 1 | 0;
                }
                index = i_0;
              }
              afterFirst = true;
              // Inline function 'kotlin.time.substringWhile' call
              var startIndex_0 = index;
              // Inline function 'kotlin.time.skipWhile' call
              var i_1 = startIndex_0;
              $l$loop_2: while (true) {
                var tmp_5;
                if (i_1 < value.length) {
                  var it_0 = charCodeAt(value, i_1);
                  tmp_5 = (_Char___init__impl__6a9atx(48) <= it_0 ? it_0 <= _Char___init__impl__6a9atx(57) : false) || it_0 === _Char___init__impl__6a9atx(46);
                } else {
                  tmp_5 = false;
                }
                if (!tmp_5) {
                  break $l$loop_2;
                }
                i_1 = i_1 + 1 | 0;
              }
              var tmp$ret$9 = i_1;
              var component_0 = substring(value, startIndex_0, tmp$ret$9);
              // Inline function 'kotlin.text.isEmpty' call
              if (charSequenceLength(component_0) === 0)
                throw IllegalArgumentException_init_$Create$();
              index = index + component_0.length | 0;
              // Inline function 'kotlin.time.substringWhile' call
              var startIndex_1 = index;
              // Inline function 'kotlin.time.skipWhile' call
              var i_2 = startIndex_1;
              $l$loop_3: while (true) {
                var tmp_6;
                if (i_2 < value.length) {
                  var it_1 = charCodeAt(value, i_2);
                  tmp_6 = _Char___init__impl__6a9atx(97) <= it_1 ? it_1 <= _Char___init__impl__6a9atx(122) : false;
                } else {
                  tmp_6 = false;
                }
                if (!tmp_6) {
                  break $l$loop_3;
                }
                i_2 = i_2 + 1 | 0;
              }
              var tmp$ret$13 = i_2;
              var unitName = substring(value, startIndex_1, tmp$ret$13);
              index = index + unitName.length | 0;
              var unit_0 = durationUnitByShortName(unitName);
              if (!(prevUnit_0 == null) && prevUnit_0.a3(unit_0) <= 0)
                throw IllegalArgumentException_init_$Create$_0('Unexpected order of duration components');
              prevUnit_0 = unit_0;
              var dotIndex_0 = indexOf_8(component_0, _Char___init__impl__6a9atx(46));
              if (dotIndex_0 > 0) {
                var whole_0 = substring(component_0, 0, dotIndex_0);
                result = Duration__plus_impl_yu9v8f(result, toDuration(toLong(whole_0), unit_0));
                result = Duration__plus_impl_yu9v8f(result, toDuration_1(toDouble(substring_0(component_0, dotIndex_0)), unit_0));
                if (index < length)
                  throw IllegalArgumentException_init_$Create$_0('Fractional component must be last');
              } else {
                result = Duration__plus_impl_yu9v8f(result, toDuration(toLong(component_0), unit_0));
              }
            }
          }
        }
      }
    }
    return isNegative ? Duration__unaryMinus_impl_x2k1y0(result) : result;
  }
  function durationOf(normalValue, unitDiscriminator) {
    // Inline function 'kotlin.Long.plus' call
    var this_0 = shiftLeft(normalValue, 1);
    var tmp$ret$0 = add_2(this_0, fromInt_0(unitDiscriminator));
    return _Duration___init__impl__kdtzql(tmp$ret$0);
  }
  function durationOfNanosNormalized(nanos) {
    var tmp;
    if (-4611686018426999999n <= nanos ? nanos <= 4611686018426999999n : false) {
      tmp = durationOfNanos(nanos);
    } else {
      tmp = durationOfMillis(nanosToMillis(nanos));
    }
    return tmp;
  }
  function durationOfMillisNormalized(millis) {
    var tmp;
    if (-4611686018426n <= millis ? millis <= 4611686018426n : false) {
      tmp = durationOfNanos(millisToNanos(millis));
    } else {
      tmp = durationOfMillis(coerceIn(millis, -4611686018427387903n, 4611686018427387903n));
    }
    return tmp;
  }
  function nanosToMillis(nanos) {
    // Inline function 'kotlin.Long.div' call
    return divide(nanos, fromInt_0(1000000));
  }
  function millisToNanos(millis) {
    // Inline function 'kotlin.Long.times' call
    return multiply_0(millis, fromInt_0(1000000));
  }
  function durationOfNanos(normalNanos) {
    return _Duration___init__impl__kdtzql(shiftLeft(normalNanos, 1));
  }
  function parseOverLongIsoComponent(value) {
    var length = value.length;
    var startIndex = 0;
    if (length > 0 && contains_9('+-', charCodeAt(value, 0))) {
      startIndex = startIndex + 1 | 0;
    }
    if ((length - startIndex | 0) > 16) {
      // Inline function 'kotlin.run' call
      $l$block: {
        var firstNonZero = startIndex;
        var inductionVariable = startIndex;
        if (inductionVariable < length)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var tmp0_subject = charCodeAt(value, index);
            if (tmp0_subject === _Char___init__impl__6a9atx(48)) {
              if (firstNonZero === index) {
                firstNonZero = firstNonZero + 1 | 0;
              }
            } else if (!(_Char___init__impl__6a9atx(49) <= tmp0_subject ? tmp0_subject <= _Char___init__impl__6a9atx(57) : false)) {
              break $l$block;
            }
          }
           while (inductionVariable < length);
        if ((length - firstNonZero | 0) > 16) {
          return charCodeAt(value, 0) === _Char___init__impl__6a9atx(45) ? -9223372036854775808n : 9223372036854775807n;
        }
      }
    }
    var tmp;
    var tmp_0;
    if (startsWith(value, '+') && length > 1) {
      var containsArg = charCodeAt(value, 1);
      tmp_0 = _Char___init__impl__6a9atx(48) <= containsArg ? containsArg <= _Char___init__impl__6a9atx(57) : false;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = toLong(drop_0(value, 1));
    } else {
      tmp = toLong(value);
    }
    return tmp;
  }
  function shortName(_this__u8e3s4) {
    var tmp;
    switch (_this__u8e3s4.x2_1) {
      case 0:
        tmp = 'ns';
        break;
      case 1:
        tmp = 'us';
        break;
      case 2:
        tmp = 'ms';
        break;
      case 3:
        tmp = 's';
        break;
      case 4:
        tmp = 'm';
        break;
      case 5:
        tmp = 'h';
        break;
      case 6:
        tmp = 'd';
        break;
      default:
        var message = 'Unknown unit: ' + _this__u8e3s4.toString();
        throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    return tmp;
  }
  function durationUnitByIsoChar(isoChar, isTimeComponent) {
    var tmp;
    if (!isTimeComponent) {
      var tmp_0;
      if (isoChar === _Char___init__impl__6a9atx(68)) {
        tmp_0 = DurationUnit_DAYS_getInstance();
      } else {
        throw IllegalArgumentException_init_$Create$_0('Invalid or unsupported duration ISO non-time unit: ' + toString(isoChar));
      }
      tmp = tmp_0;
    } else {
      var tmp_1;
      if (isoChar === _Char___init__impl__6a9atx(72)) {
        tmp_1 = DurationUnit_HOURS_getInstance();
      } else if (isoChar === _Char___init__impl__6a9atx(77)) {
        tmp_1 = DurationUnit_MINUTES_getInstance();
      } else if (isoChar === _Char___init__impl__6a9atx(83)) {
        tmp_1 = DurationUnit_SECONDS_getInstance();
      } else {
        throw IllegalArgumentException_init_$Create$_0('Invalid duration ISO time unit: ' + toString(isoChar));
      }
      tmp = tmp_1;
    }
    return tmp;
  }
  function durationUnitByShortName(shortName) {
    var tmp;
    switch (shortName) {
      case 'ns':
        tmp = DurationUnit_NANOSECONDS_getInstance();
        break;
      case 'us':
        tmp = DurationUnit_MICROSECONDS_getInstance();
        break;
      case 'ms':
        tmp = DurationUnit_MILLISECONDS_getInstance();
        break;
      case 's':
        tmp = DurationUnit_SECONDS_getInstance();
        break;
      case 'm':
        tmp = DurationUnit_MINUTES_getInstance();
        break;
      case 'h':
        tmp = DurationUnit_HOURS_getInstance();
        break;
      case 'd':
        tmp = DurationUnit_DAYS_getInstance();
        break;
      default:
        throw IllegalArgumentException_init_$Create$_0('Unknown duration unit short name: ' + shortName);
    }
    return tmp;
  }
  function _ValueTimeMark___init__impl__uyfl2m(reading) {
    return reading;
  }
  function _ValueTimeMark___get_reading__impl__5qz8rd($this) {
    return $this;
  }
  function ValueTimeMark__elapsedNow_impl_eonqvs($this) {
    return MonotonicTimeSource_getInstance().le($this);
  }
  function ValueTimeMark__minus_impl_f87sko($this, other) {
    if (!(other instanceof ValueTimeMark))
      throw IllegalArgumentException_init_$Create$_0('Subtracting or comparing time marks from different time sources is not possible: ' + ValueTimeMark__toString_impl_ow3ax6($this) + ' and ' + toString_1(other));
    return ValueTimeMark__minus_impl_f87sko_0($this, other.dl_1);
  }
  function ValueTimeMark__minus_impl_f87sko_0($this, other) {
    return MonotonicTimeSource_getInstance().me($this, other);
  }
  function ValueTimeMark__toString_impl_ow3ax6($this) {
    return 'ValueTimeMark(reading=' + toString_1($this) + ')';
  }
  function ValueTimeMark__hashCode_impl_oduu93($this) {
    return hashCode($this);
  }
  function ValueTimeMark__equals_impl_uc54jh($this, other) {
    if (!(other instanceof ValueTimeMark))
      return false;
    var tmp0_other_with_cast = other.dl_1;
    if (!equals($this, tmp0_other_with_cast))
      return false;
    return true;
  }
  function ValueTimeMark__compareTo_impl_uoccns($this, other) {
    return $this.el((!(other == null) ? isInterface(other, ComparableTimeMark) : false) ? other : THROW_CCE());
  }
  function ValueTimeMark(reading) {
    this.dl_1 = reading;
  }
  protoOf(ValueTimeMark).fl = function (other) {
    return ValueTimeMark__minus_impl_f87sko(this.dl_1, other);
  };
  protoOf(ValueTimeMark).toString = function () {
    return ValueTimeMark__toString_impl_ow3ax6(this.dl_1);
  };
  protoOf(ValueTimeMark).hashCode = function () {
    return ValueTimeMark__hashCode_impl_oduu93(this.dl_1);
  };
  protoOf(ValueTimeMark).equals = function (other) {
    return ValueTimeMark__equals_impl_uc54jh(this.dl_1, other);
  };
  protoOf(ValueTimeMark).d = function (other) {
    return ValueTimeMark__compareTo_impl_uoccns(this, other);
  };
  function Monotonic() {
  }
  protoOf(Monotonic).je = function () {
    return MonotonicTimeSource_getInstance().je();
  };
  protoOf(Monotonic).toString = function () {
    return toString_1(MonotonicTimeSource_getInstance());
  };
  var Monotonic_instance;
  function Monotonic_getInstance() {
    return Monotonic_instance;
  }
  function ComparableTimeMark() {
  }
  function TimedValue(value, duration) {
    this.gl_1 = value;
    this.hl_1 = duration;
  }
  protoOf(TimedValue).fg = function () {
    return this.gl_1;
  };
  protoOf(TimedValue).il = function () {
    return this.hl_1;
  };
  protoOf(TimedValue).toString = function () {
    return 'TimedValue(value=' + toString_0(this.gl_1) + ', duration=' + Duration__toString_impl_8d916b(this.hl_1) + ')';
  };
  protoOf(TimedValue).hashCode = function () {
    var result = this.gl_1 == null ? 0 : hashCode(this.gl_1);
    result = imul(result, 31) + Duration__hashCode_impl_u4exz6(this.hl_1) | 0;
    return result;
  };
  protoOf(TimedValue).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TimedValue))
      return false;
    if (!equals(this.gl_1, other.gl_1))
      return false;
    if (!(this.hl_1 === other.hl_1))
      return false;
    return true;
  };
  function get_UNDEFINED_RESULT() {
    _init_properties_DeepRecursive_kt__zbwcac();
    return UNDEFINED_RESULT;
  }
  var UNDEFINED_RESULT;
  function DeepRecursiveScope() {
  }
  function invoke_4(_this__u8e3s4, value) {
    _init_properties_DeepRecursive_kt__zbwcac();
    return (new DeepRecursiveScopeImpl(_this__u8e3s4.kl_1, value)).pl();
  }
  function DeepRecursiveFunction(block) {
    this.kl_1 = block;
  }
  function DeepRecursiveScopeImpl(block, value) {
    DeepRecursiveScope.call(this);
    var tmp = this;
    tmp.ll_1 = isSuspendFunction(block, 2) ? block : THROW_CCE();
    this.ml_1 = value;
    var tmp_0 = this;
    tmp_0.nl_1 = isInterface(this, Continuation) ? this : THROW_CCE();
    this.ol_1 = get_UNDEFINED_RESULT();
  }
  protoOf(DeepRecursiveScopeImpl).l9 = function () {
    return EmptyCoroutineContext_instance;
  };
  protoOf(DeepRecursiveScopeImpl).ql = function (result) {
    this.nl_1 = null;
    this.ol_1 = result;
  };
  protoOf(DeepRecursiveScopeImpl).q9 = function (result) {
    return this.ql(result);
  };
  protoOf(DeepRecursiveScopeImpl).jl = function (value, $completion) {
    var tmp = this;
    tmp.nl_1 = isInterface($completion, Continuation) ? $completion : THROW_CCE();
    this.ml_1 = value;
    return get_COROUTINE_SUSPENDED();
  };
  protoOf(DeepRecursiveScopeImpl).pl = function () {
    $l$loop: while (true) {
      var result = this.ol_1;
      var tmp0_elvis_lhs = this.nl_1;
      var tmp;
      if (tmp0_elvis_lhs == null) {
        // Inline function 'kotlin.getOrThrow' call
        var this_0 = new Result(result) instanceof Result ? result : THROW_CCE();
        throwOnFailure(this_0);
        var tmp_0 = _Result___get_value__impl__bjfvqg(this_0);
        return (tmp_0 == null ? true : !(tmp_0 == null)) ? tmp_0 : THROW_CCE();
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var cont = tmp;
      if (equals(get_UNDEFINED_RESULT(), result)) {
        var tmp_1;
        try {
          var tmp0 = this.ll_1;
          // Inline function 'kotlin.coroutines.intrinsics.startCoroutineUninterceptedOrReturn' call
          var param = this.ml_1;
          tmp_1 = startCoroutineUninterceptedOrReturnNonGeneratorVersion_0(tmp0, this, param, cont);
        } catch ($p) {
          var tmp_2;
          if ($p instanceof Error) {
            var e = $p;
            // Inline function 'kotlin.coroutines.resumeWithException' call
            // Inline function 'kotlin.Companion.failure' call
            var tmp$ret$2 = _Result___init__impl__xyqfz8(createFailure(e));
            cont.q9(tmp$ret$2);
            continue $l$loop;
          } else {
            throw $p;
          }
        }
        var r = tmp_1;
        if (!(r === get_COROUTINE_SUSPENDED())) {
          // Inline function 'kotlin.coroutines.resume' call
          // Inline function 'kotlin.Companion.success' call
          var value = (r == null ? true : !(r == null)) ? r : THROW_CCE();
          var tmp$ret$4 = _Result___init__impl__xyqfz8(value);
          cont.q9(tmp$ret$4);
        }
      } else {
        this.ol_1 = get_UNDEFINED_RESULT();
        cont.q9(result);
      }
    }
  };
  var properties_initialized_DeepRecursive_kt_5z0al2;
  function _init_properties_DeepRecursive_kt__zbwcac() {
    if (!properties_initialized_DeepRecursive_kt_5z0al2) {
      properties_initialized_DeepRecursive_kt_5z0al2 = true;
      // Inline function 'kotlin.Companion.success' call
      var value = get_COROUTINE_SUSPENDED();
      UNDEFINED_RESULT = _Result___init__impl__xyqfz8(value);
    }
  }
  var LazyThreadSafetyMode_SYNCHRONIZED_instance;
  var LazyThreadSafetyMode_PUBLICATION_instance;
  var LazyThreadSafetyMode_NONE_instance;
  var LazyThreadSafetyMode_entriesInitialized;
  function LazyThreadSafetyMode_initEntries() {
    if (LazyThreadSafetyMode_entriesInitialized)
      return Unit_instance;
    LazyThreadSafetyMode_entriesInitialized = true;
    LazyThreadSafetyMode_SYNCHRONIZED_instance = new LazyThreadSafetyMode('SYNCHRONIZED', 0);
    LazyThreadSafetyMode_PUBLICATION_instance = new LazyThreadSafetyMode('PUBLICATION', 1);
    LazyThreadSafetyMode_NONE_instance = new LazyThreadSafetyMode('NONE', 2);
  }
  function LazyThreadSafetyMode(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function UnsafeLazyImpl(initializer) {
    this.rl_1 = initializer;
    this.sl_1 = UNINITIALIZED_VALUE_instance;
  }
  protoOf(UnsafeLazyImpl).a1 = function () {
    if (this.sl_1 === UNINITIALIZED_VALUE_instance) {
      this.sl_1 = ensureNotNull(this.rl_1)();
      this.rl_1 = null;
    }
    var tmp = this.sl_1;
    return (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
  };
  protoOf(UnsafeLazyImpl).tl = function () {
    return !(this.sl_1 === UNINITIALIZED_VALUE_instance);
  };
  protoOf(UnsafeLazyImpl).toString = function () {
    return this.tl() ? toString_0(this.a1()) : 'Lazy value not initialized yet.';
  };
  function UNINITIALIZED_VALUE() {
  }
  var UNINITIALIZED_VALUE_instance;
  function UNINITIALIZED_VALUE_getInstance() {
    return UNINITIALIZED_VALUE_instance;
  }
  function LazyThreadSafetyMode_PUBLICATION_getInstance() {
    LazyThreadSafetyMode_initEntries();
    return LazyThreadSafetyMode_PUBLICATION_instance;
  }
  function LazyThreadSafetyMode_NONE_getInstance() {
    LazyThreadSafetyMode_initEntries();
    return LazyThreadSafetyMode_NONE_instance;
  }
  function _Result___init__impl__xyqfz8(value) {
    return value;
  }
  function _Result___get_value__impl__bjfvqg($this) {
    return $this;
  }
  function _Result___get_isSuccess__impl__sndoy8($this) {
    var tmp = _Result___get_value__impl__bjfvqg($this);
    return !(tmp instanceof Failure);
  }
  function _Result___get_isFailure__impl__jpiriv($this) {
    var tmp = _Result___get_value__impl__bjfvqg($this);
    return tmp instanceof Failure;
  }
  function Result__exceptionOrNull_impl_p6xea9($this) {
    var tmp;
    if (_Result___get_value__impl__bjfvqg($this) instanceof Failure) {
      tmp = _Result___get_value__impl__bjfvqg($this).ul_1;
    } else {
      tmp = null;
    }
    return tmp;
  }
  function Result__toString_impl_yu5r8k($this) {
    var tmp;
    if (_Result___get_value__impl__bjfvqg($this) instanceof Failure) {
      tmp = _Result___get_value__impl__bjfvqg($this).toString();
    } else {
      tmp = 'Success(' + toString_0(_Result___get_value__impl__bjfvqg($this)) + ')';
    }
    return tmp;
  }
  function Companion_17() {
  }
  var Companion_instance_17;
  function Companion_getInstance_17() {
    return Companion_instance_17;
  }
  function Failure(exception) {
    this.ul_1 = exception;
  }
  protoOf(Failure).equals = function (other) {
    var tmp;
    if (other instanceof Failure) {
      tmp = equals(this.ul_1, other.ul_1);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(Failure).hashCode = function () {
    return hashCode(this.ul_1);
  };
  protoOf(Failure).toString = function () {
    return 'Failure(' + this.ul_1.toString() + ')';
  };
  function Result__hashCode_impl_d2zufp($this) {
    return $this == null ? 0 : hashCode($this);
  }
  function Result__equals_impl_bxgmep($this, other) {
    if (!(other instanceof Result))
      return false;
    var tmp0_other_with_cast = other.vl_1;
    if (!equals($this, tmp0_other_with_cast))
      return false;
    return true;
  }
  function Result(value) {
    this.vl_1 = value;
  }
  protoOf(Result).toString = function () {
    return Result__toString_impl_yu5r8k(this.vl_1);
  };
  protoOf(Result).hashCode = function () {
    return Result__hashCode_impl_d2zufp(this.vl_1);
  };
  protoOf(Result).equals = function (other) {
    return Result__equals_impl_bxgmep(this.vl_1, other);
  };
  function createFailure(exception) {
    return new Failure(exception);
  }
  function throwOnFailure(_this__u8e3s4) {
    var tmp = _Result___get_value__impl__bjfvqg(_this__u8e3s4);
    if (tmp instanceof Failure)
      throw _Result___get_value__impl__bjfvqg(_this__u8e3s4).ul_1;
  }
  function NotImplementedError(message) {
    message = message === VOID ? 'An operation is not implemented.' : message;
    Error_init_$Init$_0(message, this);
    captureStack(this, NotImplementedError);
  }
  function Pair(first, second) {
    this.pg_1 = first;
    this.qg_1 = second;
  }
  protoOf(Pair).toString = function () {
    return '(' + toString_0(this.pg_1) + ', ' + toString_0(this.qg_1) + ')';
  };
  protoOf(Pair).fg = function () {
    return this.pg_1;
  };
  protoOf(Pair).gg = function () {
    return this.qg_1;
  };
  protoOf(Pair).hashCode = function () {
    var result = this.pg_1 == null ? 0 : hashCode(this.pg_1);
    result = imul(result, 31) + (this.qg_1 == null ? 0 : hashCode(this.qg_1)) | 0;
    return result;
  };
  protoOf(Pair).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Pair))
      return false;
    if (!equals(this.pg_1, other.pg_1))
      return false;
    if (!equals(this.qg_1, other.qg_1))
      return false;
    return true;
  };
  function to(_this__u8e3s4, that) {
    return new Pair(_this__u8e3s4, that);
  }
  function Triple(first, second, third) {
    this.wl_1 = first;
    this.xl_1 = second;
    this.yl_1 = third;
  }
  protoOf(Triple).toString = function () {
    return '(' + toString_0(this.wl_1) + ', ' + toString_0(this.xl_1) + ', ' + toString_0(this.yl_1) + ')';
  };
  protoOf(Triple).fg = function () {
    return this.wl_1;
  };
  protoOf(Triple).gg = function () {
    return this.xl_1;
  };
  protoOf(Triple).zl = function () {
    return this.yl_1;
  };
  protoOf(Triple).hashCode = function () {
    var result = this.wl_1 == null ? 0 : hashCode(this.wl_1);
    result = imul(result, 31) + (this.xl_1 == null ? 0 : hashCode(this.xl_1)) | 0;
    result = imul(result, 31) + (this.yl_1 == null ? 0 : hashCode(this.yl_1)) | 0;
    return result;
  };
  protoOf(Triple).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Triple))
      return false;
    if (!equals(this.wl_1, other.wl_1))
      return false;
    if (!equals(this.xl_1, other.xl_1))
      return false;
    if (!equals(this.yl_1, other.yl_1))
      return false;
    return true;
  };
  function _UByte___init__impl__g9hnc4(data) {
    return data;
  }
  function _UByte___get_data__impl__jof9qr($this) {
    return $this;
  }
  function Companion_18() {
    Companion_instance_18 = this;
    this.am_1 = _UByte___init__impl__g9hnc4(0);
    this.bm_1 = _UByte___init__impl__g9hnc4(-1);
    this.cm_1 = 1;
    this.dm_1 = 8;
  }
  var Companion_instance_18;
  function Companion_getInstance_18() {
    if (Companion_instance_18 == null)
      new Companion_18();
    return Companion_instance_18;
  }
  function UByte__compareTo_impl_5w5192($this, other) {
    // Inline function 'kotlin.UByte.toInt' call
    var tmp = _UByte___get_data__impl__jof9qr($this) & 255;
    // Inline function 'kotlin.UByte.toInt' call
    var tmp$ret$1 = _UByte___get_data__impl__jof9qr(other) & 255;
    return compareTo_0(tmp, tmp$ret$1);
  }
  function UByte__compareTo_impl_5w5192_0($this, other) {
    return UByte__compareTo_impl_5w5192($this.em_1, other instanceof UByte ? other.em_1 : THROW_CCE());
  }
  function UByte__toString_impl_v72jg($this) {
    // Inline function 'kotlin.UByte.toInt' call
    return (_UByte___get_data__impl__jof9qr($this) & 255).toString();
  }
  function UByte__hashCode_impl_mmczcb($this) {
    return $this;
  }
  function UByte__equals_impl_nvqtsf($this, other) {
    if (!(other instanceof UByte))
      return false;
    if (!($this === other.em_1))
      return false;
    return true;
  }
  function UByte(data) {
    Companion_getInstance_18();
    this.em_1 = data;
  }
  protoOf(UByte).fm = function (other) {
    return UByte__compareTo_impl_5w5192(this.em_1, other);
  };
  protoOf(UByte).d = function (other) {
    return UByte__compareTo_impl_5w5192_0(this, other);
  };
  protoOf(UByte).toString = function () {
    return UByte__toString_impl_v72jg(this.em_1);
  };
  protoOf(UByte).hashCode = function () {
    return UByte__hashCode_impl_mmczcb(this.em_1);
  };
  protoOf(UByte).equals = function (other) {
    return UByte__equals_impl_nvqtsf(this.em_1, other);
  };
  function _UByteArray___init__impl__ip4y9n(storage) {
    return storage;
  }
  function _UByteArray___get_storage__impl__d4kctt($this) {
    return $this;
  }
  function _UByteArray___init__impl__ip4y9n_0(size) {
    return _UByteArray___init__impl__ip4y9n(new Int8Array(size));
  }
  function UByteArray__get_impl_t5f3hv($this, index) {
    // Inline function 'kotlin.toUByte' call
    var this_0 = _UByteArray___get_storage__impl__d4kctt($this)[index];
    return _UByte___init__impl__g9hnc4(this_0);
  }
  function UByteArray__set_impl_jvcicn($this, index, value) {
    var tmp = _UByteArray___get_storage__impl__d4kctt($this);
    // Inline function 'kotlin.UByte.toByte' call
    tmp[index] = _UByte___get_data__impl__jof9qr(value);
  }
  function _UByteArray___get_size__impl__h6pkdv($this) {
    return _UByteArray___get_storage__impl__d4kctt($this).length;
  }
  function UByteArray__iterator_impl_509y1p($this) {
    return new Iterator(_UByteArray___get_storage__impl__d4kctt($this));
  }
  function Iterator(array) {
    this.gm_1 = array;
    this.hm_1 = 0;
  }
  protoOf(Iterator).n = function () {
    return this.hm_1 < this.gm_1.length;
  };
  protoOf(Iterator).im = function () {
    var tmp;
    if (this.hm_1 < this.gm_1.length) {
      var _unary__edvuaz = this.hm_1;
      this.hm_1 = _unary__edvuaz + 1 | 0;
      // Inline function 'kotlin.toUByte' call
      var this_0 = this.gm_1[_unary__edvuaz];
      tmp = _UByte___init__impl__g9hnc4(this_0);
    } else {
      throw NoSuchElementException_init_$Create$_0(this.hm_1.toString());
    }
    return tmp;
  };
  protoOf(Iterator).o = function () {
    return new UByte(this.im());
  };
  function UByteArray__contains_impl_njh19q($this, element) {
    var tmp = _UByteArray___get_storage__impl__d4kctt($this);
    // Inline function 'kotlin.UByte.toByte' call
    var tmp$ret$0 = _UByte___get_data__impl__jof9qr(element);
    return contains_2(tmp, tmp$ret$0);
  }
  function UByteArray__contains_impl_njh19q_0($this, element) {
    if (!(element instanceof UByte))
      return false;
    return UByteArray__contains_impl_njh19q($this.jm_1, element instanceof UByte ? element.em_1 : THROW_CCE());
  }
  function UByteArray__containsAll_impl_v9s6dj($this, elements) {
    var tmp0 = isInterface(elements, Collection) ? elements : THROW_CCE();
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var tmp;
      if (isInterface(tmp0, Collection)) {
        tmp = tmp0.s();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
      var _iterator__ex2g4s = tmp0.m();
      while (_iterator__ex2g4s.n()) {
        var element = _iterator__ex2g4s.o();
        var tmp_0;
        if (element instanceof UByte) {
          var tmp_1 = _UByteArray___get_storage__impl__d4kctt($this);
          // Inline function 'kotlin.UByte.toByte' call
          var this_0 = element.em_1;
          var tmp$ret$1 = _UByte___get_data__impl__jof9qr(this_0);
          tmp_0 = contains_2(tmp_1, tmp$ret$1);
        } else {
          tmp_0 = false;
        }
        if (!tmp_0) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
      }
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  }
  function UByteArray__containsAll_impl_v9s6dj_0($this, elements) {
    return UByteArray__containsAll_impl_v9s6dj($this.jm_1, elements);
  }
  function UByteArray__isEmpty_impl_nbfqsa($this) {
    return _UByteArray___get_storage__impl__d4kctt($this).length === 0;
  }
  function UByteArray__toString_impl_ukpl97($this) {
    return 'UByteArray(storage=' + toString_1($this) + ')';
  }
  function UByteArray__hashCode_impl_ip8jx2($this) {
    return hashCode($this);
  }
  function UByteArray__equals_impl_roka4u($this, other) {
    if (!(other instanceof UByteArray))
      return false;
    var tmp0_other_with_cast = other.jm_1;
    if (!equals($this, tmp0_other_with_cast))
      return false;
    return true;
  }
  function UByteArray(storage) {
    this.jm_1 = storage;
  }
  protoOf(UByteArray).p = function () {
    return _UByteArray___get_size__impl__h6pkdv(this.jm_1);
  };
  protoOf(UByteArray).m = function () {
    return UByteArray__iterator_impl_509y1p(this.jm_1);
  };
  protoOf(UByteArray).km = function (element) {
    return UByteArray__contains_impl_njh19q(this.jm_1, element);
  };
  protoOf(UByteArray).t = function (element) {
    return UByteArray__contains_impl_njh19q_0(this, element);
  };
  protoOf(UByteArray).lm = function (elements) {
    return UByteArray__containsAll_impl_v9s6dj(this.jm_1, elements);
  };
  protoOf(UByteArray).e2 = function (elements) {
    return UByteArray__containsAll_impl_v9s6dj_0(this, elements);
  };
  protoOf(UByteArray).s = function () {
    return UByteArray__isEmpty_impl_nbfqsa(this.jm_1);
  };
  protoOf(UByteArray).toString = function () {
    return UByteArray__toString_impl_ukpl97(this.jm_1);
  };
  protoOf(UByteArray).hashCode = function () {
    return UByteArray__hashCode_impl_ip8jx2(this.jm_1);
  };
  protoOf(UByteArray).equals = function (other) {
    return UByteArray__equals_impl_roka4u(this.jm_1, other);
  };
  function _UInt___init__impl__l7qpdl(data) {
    return data;
  }
  function _UInt___get_data__impl__f0vqqw($this) {
    return $this;
  }
  function Companion_19() {
    Companion_instance_19 = this;
    this.mm_1 = _UInt___init__impl__l7qpdl(0);
    this.nm_1 = _UInt___init__impl__l7qpdl(-1);
    this.om_1 = 4;
    this.pm_1 = 32;
  }
  var Companion_instance_19;
  function Companion_getInstance_19() {
    if (Companion_instance_19 == null)
      new Companion_19();
    return Companion_instance_19;
  }
  function UInt__compareTo_impl_yacclj($this, other) {
    return uintCompare(_UInt___get_data__impl__f0vqqw($this), _UInt___get_data__impl__f0vqqw(other));
  }
  function UInt__compareTo_impl_yacclj_0($this, other) {
    return UInt__compareTo_impl_yacclj($this.qm_1, other instanceof UInt ? other.qm_1 : THROW_CCE());
  }
  function UInt__toString_impl_dbgl21($this) {
    // Inline function 'kotlin.uintToString' call
    // Inline function 'kotlin.uintToLong' call
    var value = _UInt___get_data__impl__f0vqqw($this);
    return (fromInt_0(value) & 4294967295n).toString();
  }
  function UInt__hashCode_impl_z2mhuw($this) {
    return $this;
  }
  function UInt__equals_impl_ffdoxg($this, other) {
    if (!(other instanceof UInt))
      return false;
    if (!($this === other.qm_1))
      return false;
    return true;
  }
  function UInt(data) {
    Companion_getInstance_19();
    this.qm_1 = data;
  }
  protoOf(UInt).rm = function (other) {
    return UInt__compareTo_impl_yacclj(this.qm_1, other);
  };
  protoOf(UInt).d = function (other) {
    return UInt__compareTo_impl_yacclj_0(this, other);
  };
  protoOf(UInt).toString = function () {
    return UInt__toString_impl_dbgl21(this.qm_1);
  };
  protoOf(UInt).hashCode = function () {
    return UInt__hashCode_impl_z2mhuw(this.qm_1);
  };
  protoOf(UInt).equals = function (other) {
    return UInt__equals_impl_ffdoxg(this.qm_1, other);
  };
  function _UIntArray___init__impl__ghjpc6(storage) {
    return storage;
  }
  function _UIntArray___get_storage__impl__92a0v0($this) {
    return $this;
  }
  function _UIntArray___init__impl__ghjpc6_0(size) {
    return _UIntArray___init__impl__ghjpc6(new Int32Array(size));
  }
  function UIntArray__get_impl_gp5kza($this, index) {
    // Inline function 'kotlin.toUInt' call
    var this_0 = _UIntArray___get_storage__impl__92a0v0($this)[index];
    return _UInt___init__impl__l7qpdl(this_0);
  }
  function UIntArray__set_impl_7f2zu2($this, index, value) {
    var tmp = _UIntArray___get_storage__impl__92a0v0($this);
    // Inline function 'kotlin.UInt.toInt' call
    tmp[index] = _UInt___get_data__impl__f0vqqw(value);
  }
  function _UIntArray___get_size__impl__r6l8ci($this) {
    return _UIntArray___get_storage__impl__92a0v0($this).length;
  }
  function UIntArray__iterator_impl_tkdv7k($this) {
    return new Iterator_0(_UIntArray___get_storage__impl__92a0v0($this));
  }
  function Iterator_0(array) {
    this.sm_1 = array;
    this.tm_1 = 0;
  }
  protoOf(Iterator_0).n = function () {
    return this.tm_1 < this.sm_1.length;
  };
  protoOf(Iterator_0).um = function () {
    var tmp;
    if (this.tm_1 < this.sm_1.length) {
      var _unary__edvuaz = this.tm_1;
      this.tm_1 = _unary__edvuaz + 1 | 0;
      // Inline function 'kotlin.toUInt' call
      var this_0 = this.sm_1[_unary__edvuaz];
      tmp = _UInt___init__impl__l7qpdl(this_0);
    } else {
      throw NoSuchElementException_init_$Create$_0(this.tm_1.toString());
    }
    return tmp;
  };
  protoOf(Iterator_0).o = function () {
    return new UInt(this.um());
  };
  function UIntArray__contains_impl_b16rzj($this, element) {
    var tmp = _UIntArray___get_storage__impl__92a0v0($this);
    // Inline function 'kotlin.UInt.toInt' call
    var tmp$ret$0 = _UInt___get_data__impl__f0vqqw(element);
    return contains_3(tmp, tmp$ret$0);
  }
  function UIntArray__contains_impl_b16rzj_0($this, element) {
    if (!(element instanceof UInt))
      return false;
    return UIntArray__contains_impl_b16rzj($this.vm_1, element instanceof UInt ? element.qm_1 : THROW_CCE());
  }
  function UIntArray__containsAll_impl_414g22($this, elements) {
    var tmp0 = isInterface(elements, Collection) ? elements : THROW_CCE();
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var tmp;
      if (isInterface(tmp0, Collection)) {
        tmp = tmp0.s();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
      var _iterator__ex2g4s = tmp0.m();
      while (_iterator__ex2g4s.n()) {
        var element = _iterator__ex2g4s.o();
        var tmp_0;
        if (element instanceof UInt) {
          var tmp_1 = _UIntArray___get_storage__impl__92a0v0($this);
          // Inline function 'kotlin.UInt.toInt' call
          var this_0 = element.qm_1;
          var tmp$ret$1 = _UInt___get_data__impl__f0vqqw(this_0);
          tmp_0 = contains_3(tmp_1, tmp$ret$1);
        } else {
          tmp_0 = false;
        }
        if (!tmp_0) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
      }
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  }
  function UIntArray__containsAll_impl_414g22_0($this, elements) {
    return UIntArray__containsAll_impl_414g22($this.vm_1, elements);
  }
  function UIntArray__isEmpty_impl_vd8j4n($this) {
    return _UIntArray___get_storage__impl__92a0v0($this).length === 0;
  }
  function UIntArray__toString_impl_3zy802($this) {
    return 'UIntArray(storage=' + toString_1($this) + ')';
  }
  function UIntArray__hashCode_impl_hr7ost($this) {
    return hashCode($this);
  }
  function UIntArray__equals_impl_flcmof($this, other) {
    if (!(other instanceof UIntArray))
      return false;
    var tmp0_other_with_cast = other.vm_1;
    if (!equals($this, tmp0_other_with_cast))
      return false;
    return true;
  }
  function UIntArray(storage) {
    this.vm_1 = storage;
  }
  protoOf(UIntArray).p = function () {
    return _UIntArray___get_size__impl__r6l8ci(this.vm_1);
  };
  protoOf(UIntArray).m = function () {
    return UIntArray__iterator_impl_tkdv7k(this.vm_1);
  };
  protoOf(UIntArray).wm = function (element) {
    return UIntArray__contains_impl_b16rzj(this.vm_1, element);
  };
  protoOf(UIntArray).t = function (element) {
    return UIntArray__contains_impl_b16rzj_0(this, element);
  };
  protoOf(UIntArray).xm = function (elements) {
    return UIntArray__containsAll_impl_414g22(this.vm_1, elements);
  };
  protoOf(UIntArray).e2 = function (elements) {
    return UIntArray__containsAll_impl_414g22_0(this, elements);
  };
  protoOf(UIntArray).s = function () {
    return UIntArray__isEmpty_impl_vd8j4n(this.vm_1);
  };
  protoOf(UIntArray).toString = function () {
    return UIntArray__toString_impl_3zy802(this.vm_1);
  };
  protoOf(UIntArray).hashCode = function () {
    return UIntArray__hashCode_impl_hr7ost(this.vm_1);
  };
  protoOf(UIntArray).equals = function (other) {
    return UIntArray__equals_impl_flcmof(this.vm_1, other);
  };
  function _ULong___init__impl__c78o9k(data) {
    return data;
  }
  function _ULong___get_data__impl__fggpzb($this) {
    return $this;
  }
  function Companion_20() {
    Companion_instance_20 = this;
    this.ym_1 = _ULong___init__impl__c78o9k(0n);
    this.zm_1 = _ULong___init__impl__c78o9k(-1n);
    this.an_1 = 8;
    this.bn_1 = 64;
  }
  var Companion_instance_20;
  function Companion_getInstance_20() {
    if (Companion_instance_20 == null)
      new Companion_20();
    return Companion_instance_20;
  }
  function ULong__compareTo_impl_38i7tu($this, other) {
    return ulongCompare(_ULong___get_data__impl__fggpzb($this), _ULong___get_data__impl__fggpzb(other));
  }
  function ULong__compareTo_impl_38i7tu_0($this, other) {
    return ULong__compareTo_impl_38i7tu($this.r1_1, other instanceof ULong ? other.r1_1 : THROW_CCE());
  }
  function ULong__toString_impl_f9au7k($this) {
    // Inline function 'kotlin.ulongToString' call
    var value = _ULong___get_data__impl__fggpzb($this);
    return ulongToString(value, 10);
  }
  function ULong__hashCode_impl_6hv2lb($this) {
    return getBigIntHashCode($this);
  }
  function ULong__equals_impl_o0gnyb($this, other) {
    if (!(other instanceof ULong))
      return false;
    if (!($this === other.r1_1))
      return false;
    return true;
  }
  function ULong(data) {
    Companion_getInstance_20();
    this.r1_1 = data;
  }
  protoOf(ULong).cn = function (other) {
    return ULong__compareTo_impl_38i7tu(this.r1_1, other);
  };
  protoOf(ULong).d = function (other) {
    return ULong__compareTo_impl_38i7tu_0(this, other);
  };
  protoOf(ULong).toString = function () {
    return ULong__toString_impl_f9au7k(this.r1_1);
  };
  protoOf(ULong).hashCode = function () {
    return ULong__hashCode_impl_6hv2lb(this.r1_1);
  };
  protoOf(ULong).equals = function (other) {
    return ULong__equals_impl_o0gnyb(this.r1_1, other);
  };
  function _ULongArray___init__impl__twm1l3(storage) {
    return storage;
  }
  function _ULongArray___get_storage__impl__28e64j($this) {
    return $this;
  }
  function _ULongArray___init__impl__twm1l3_0(size) {
    return _ULongArray___init__impl__twm1l3(longArray(size));
  }
  function ULongArray__get_impl_pr71q9($this, index) {
    // Inline function 'kotlin.toULong' call
    var this_0 = _ULongArray___get_storage__impl__28e64j($this)[index];
    return _ULong___init__impl__c78o9k(this_0);
  }
  function ULongArray__set_impl_z19mvh($this, index, value) {
    var tmp = _ULongArray___get_storage__impl__28e64j($this);
    // Inline function 'kotlin.ULong.toLong' call
    tmp[index] = _ULong___get_data__impl__fggpzb(value);
  }
  function _ULongArray___get_size__impl__ju6dtr($this) {
    return _ULongArray___get_storage__impl__28e64j($this).length;
  }
  function ULongArray__iterator_impl_cq4d2h($this) {
    return new Iterator_1(_ULongArray___get_storage__impl__28e64j($this));
  }
  function Iterator_1(array) {
    this.dn_1 = array;
    this.en_1 = 0;
  }
  protoOf(Iterator_1).n = function () {
    return this.en_1 < this.dn_1.length;
  };
  protoOf(Iterator_1).fn = function () {
    var tmp;
    if (this.en_1 < this.dn_1.length) {
      var _unary__edvuaz = this.en_1;
      this.en_1 = _unary__edvuaz + 1 | 0;
      // Inline function 'kotlin.toULong' call
      var this_0 = this.dn_1[_unary__edvuaz];
      tmp = _ULong___init__impl__c78o9k(this_0);
    } else {
      throw NoSuchElementException_init_$Create$_0(this.en_1.toString());
    }
    return tmp;
  };
  protoOf(Iterator_1).o = function () {
    return new ULong(this.fn());
  };
  function ULongArray__contains_impl_v9bgai($this, element) {
    var tmp = _ULongArray___get_storage__impl__28e64j($this);
    // Inline function 'kotlin.ULong.toLong' call
    var tmp$ret$0 = _ULong___get_data__impl__fggpzb(element);
    return contains_1(tmp, tmp$ret$0);
  }
  function ULongArray__contains_impl_v9bgai_0($this, element) {
    if (!(element instanceof ULong))
      return false;
    return ULongArray__contains_impl_v9bgai($this.gn_1, element instanceof ULong ? element.r1_1 : THROW_CCE());
  }
  function ULongArray__containsAll_impl_xx8ztf($this, elements) {
    var tmp0 = isInterface(elements, Collection) ? elements : THROW_CCE();
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var tmp;
      if (isInterface(tmp0, Collection)) {
        tmp = tmp0.s();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
      var _iterator__ex2g4s = tmp0.m();
      while (_iterator__ex2g4s.n()) {
        var element = _iterator__ex2g4s.o();
        var tmp_0;
        if (element instanceof ULong) {
          var tmp_1 = _ULongArray___get_storage__impl__28e64j($this);
          // Inline function 'kotlin.ULong.toLong' call
          var this_0 = element.r1_1;
          var tmp$ret$1 = _ULong___get_data__impl__fggpzb(this_0);
          tmp_0 = contains_1(tmp_1, tmp$ret$1);
        } else {
          tmp_0 = false;
        }
        if (!tmp_0) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
      }
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  }
  function ULongArray__containsAll_impl_xx8ztf_0($this, elements) {
    return ULongArray__containsAll_impl_xx8ztf($this.gn_1, elements);
  }
  function ULongArray__isEmpty_impl_c3yngu($this) {
    return _ULongArray___get_storage__impl__28e64j($this).length === 0;
  }
  function ULongArray__toString_impl_wqk1p5($this) {
    return 'ULongArray(storage=' + toString_1($this) + ')';
  }
  function ULongArray__hashCode_impl_aze4wa($this) {
    return hashCode($this);
  }
  function ULongArray__equals_impl_vwitwa($this, other) {
    if (!(other instanceof ULongArray))
      return false;
    var tmp0_other_with_cast = other.gn_1;
    if (!equals($this, tmp0_other_with_cast))
      return false;
    return true;
  }
  function ULongArray(storage) {
    this.gn_1 = storage;
  }
  protoOf(ULongArray).p = function () {
    return _ULongArray___get_size__impl__ju6dtr(this.gn_1);
  };
  protoOf(ULongArray).m = function () {
    return ULongArray__iterator_impl_cq4d2h(this.gn_1);
  };
  protoOf(ULongArray).z3 = function (element) {
    return ULongArray__contains_impl_v9bgai(this.gn_1, element);
  };
  protoOf(ULongArray).t = function (element) {
    return ULongArray__contains_impl_v9bgai_0(this, element);
  };
  protoOf(ULongArray).hn = function (elements) {
    return ULongArray__containsAll_impl_xx8ztf(this.gn_1, elements);
  };
  protoOf(ULongArray).e2 = function (elements) {
    return ULongArray__containsAll_impl_xx8ztf_0(this, elements);
  };
  protoOf(ULongArray).s = function () {
    return ULongArray__isEmpty_impl_c3yngu(this.gn_1);
  };
  protoOf(ULongArray).toString = function () {
    return ULongArray__toString_impl_wqk1p5(this.gn_1);
  };
  protoOf(ULongArray).hashCode = function () {
    return ULongArray__hashCode_impl_aze4wa(this.gn_1);
  };
  protoOf(ULongArray).equals = function (other) {
    return ULongArray__equals_impl_vwitwa(this.gn_1, other);
  };
  function _UShort___init__impl__jigrne(data) {
    return data;
  }
  function _UShort___get_data__impl__g0245($this) {
    return $this;
  }
  function Companion_21() {
    Companion_instance_21 = this;
    this.in_1 = _UShort___init__impl__jigrne(0);
    this.jn_1 = _UShort___init__impl__jigrne(-1);
    this.kn_1 = 2;
    this.ln_1 = 16;
  }
  var Companion_instance_21;
  function Companion_getInstance_21() {
    if (Companion_instance_21 == null)
      new Companion_21();
    return Companion_instance_21;
  }
  function UShort__compareTo_impl_1pfgyc($this, other) {
    // Inline function 'kotlin.UShort.toInt' call
    var tmp = _UShort___get_data__impl__g0245($this) & 65535;
    // Inline function 'kotlin.UShort.toInt' call
    var tmp$ret$1 = _UShort___get_data__impl__g0245(other) & 65535;
    return compareTo_0(tmp, tmp$ret$1);
  }
  function UShort__compareTo_impl_1pfgyc_0($this, other) {
    return UShort__compareTo_impl_1pfgyc($this.mn_1, other instanceof UShort ? other.mn_1 : THROW_CCE());
  }
  function UShort__toString_impl_edaoee($this) {
    // Inline function 'kotlin.UShort.toInt' call
    return (_UShort___get_data__impl__g0245($this) & 65535).toString();
  }
  function UShort__hashCode_impl_ywngrv($this) {
    return $this;
  }
  function UShort__equals_impl_7t9pdz($this, other) {
    if (!(other instanceof UShort))
      return false;
    if (!($this === other.mn_1))
      return false;
    return true;
  }
  function UShort(data) {
    Companion_getInstance_21();
    this.mn_1 = data;
  }
  protoOf(UShort).nn = function (other) {
    return UShort__compareTo_impl_1pfgyc(this.mn_1, other);
  };
  protoOf(UShort).d = function (other) {
    return UShort__compareTo_impl_1pfgyc_0(this, other);
  };
  protoOf(UShort).toString = function () {
    return UShort__toString_impl_edaoee(this.mn_1);
  };
  protoOf(UShort).hashCode = function () {
    return UShort__hashCode_impl_ywngrv(this.mn_1);
  };
  protoOf(UShort).equals = function (other) {
    return UShort__equals_impl_7t9pdz(this.mn_1, other);
  };
  function _UShortArray___init__impl__9b26ef(storage) {
    return storage;
  }
  function _UShortArray___get_storage__impl__t2jpv5($this) {
    return $this;
  }
  function _UShortArray___init__impl__9b26ef_0(size) {
    return _UShortArray___init__impl__9b26ef(new Int16Array(size));
  }
  function UShortArray__get_impl_fnbhmx($this, index) {
    // Inline function 'kotlin.toUShort' call
    var this_0 = _UShortArray___get_storage__impl__t2jpv5($this)[index];
    return _UShort___init__impl__jigrne(this_0);
  }
  function UShortArray__set_impl_6d8whp($this, index, value) {
    var tmp = _UShortArray___get_storage__impl__t2jpv5($this);
    // Inline function 'kotlin.UShort.toShort' call
    tmp[index] = _UShort___get_data__impl__g0245(value);
  }
  function _UShortArray___get_size__impl__jqto1b($this) {
    return _UShortArray___get_storage__impl__t2jpv5($this).length;
  }
  function UShortArray__iterator_impl_ktpenn($this) {
    return new Iterator_2(_UShortArray___get_storage__impl__t2jpv5($this));
  }
  function Iterator_2(array) {
    this.on_1 = array;
    this.pn_1 = 0;
  }
  protoOf(Iterator_2).n = function () {
    return this.pn_1 < this.on_1.length;
  };
  protoOf(Iterator_2).qn = function () {
    var tmp;
    if (this.pn_1 < this.on_1.length) {
      var _unary__edvuaz = this.pn_1;
      this.pn_1 = _unary__edvuaz + 1 | 0;
      // Inline function 'kotlin.toUShort' call
      var this_0 = this.on_1[_unary__edvuaz];
      tmp = _UShort___init__impl__jigrne(this_0);
    } else {
      throw NoSuchElementException_init_$Create$_0(this.pn_1.toString());
    }
    return tmp;
  };
  protoOf(Iterator_2).o = function () {
    return new UShort(this.qn());
  };
  function UShortArray__contains_impl_vo7k3g($this, element) {
    var tmp = _UShortArray___get_storage__impl__t2jpv5($this);
    // Inline function 'kotlin.UShort.toShort' call
    var tmp$ret$0 = _UShort___get_data__impl__g0245(element);
    return contains_4(tmp, tmp$ret$0);
  }
  function UShortArray__contains_impl_vo7k3g_0($this, element) {
    if (!(element instanceof UShort))
      return false;
    return UShortArray__contains_impl_vo7k3g($this.rn_1, element instanceof UShort ? element.mn_1 : THROW_CCE());
  }
  function UShortArray__containsAll_impl_vlaaxp($this, elements) {
    var tmp0 = isInterface(elements, Collection) ? elements : THROW_CCE();
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var tmp;
      if (isInterface(tmp0, Collection)) {
        tmp = tmp0.s();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
      var _iterator__ex2g4s = tmp0.m();
      while (_iterator__ex2g4s.n()) {
        var element = _iterator__ex2g4s.o();
        var tmp_0;
        if (element instanceof UShort) {
          var tmp_1 = _UShortArray___get_storage__impl__t2jpv5($this);
          // Inline function 'kotlin.UShort.toShort' call
          var this_0 = element.mn_1;
          var tmp$ret$1 = _UShort___get_data__impl__g0245(this_0);
          tmp_0 = contains_4(tmp_1, tmp$ret$1);
        } else {
          tmp_0 = false;
        }
        if (!tmp_0) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
      }
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  }
  function UShortArray__containsAll_impl_vlaaxp_0($this, elements) {
    return UShortArray__containsAll_impl_vlaaxp($this.rn_1, elements);
  }
  function UShortArray__isEmpty_impl_cdd9l0($this) {
    return _UShortArray___get_storage__impl__t2jpv5($this).length === 0;
  }
  function UShortArray__toString_impl_omz03z($this) {
    return 'UShortArray(storage=' + toString_1($this) + ')';
  }
  function UShortArray__hashCode_impl_2vt3b4($this) {
    return hashCode($this);
  }
  function UShortArray__equals_impl_tyc3mk($this, other) {
    if (!(other instanceof UShortArray))
      return false;
    var tmp0_other_with_cast = other.rn_1;
    if (!equals($this, tmp0_other_with_cast))
      return false;
    return true;
  }
  function UShortArray(storage) {
    this.rn_1 = storage;
  }
  protoOf(UShortArray).p = function () {
    return _UShortArray___get_size__impl__jqto1b(this.rn_1);
  };
  protoOf(UShortArray).m = function () {
    return UShortArray__iterator_impl_ktpenn(this.rn_1);
  };
  protoOf(UShortArray).sn = function (element) {
    return UShortArray__contains_impl_vo7k3g(this.rn_1, element);
  };
  protoOf(UShortArray).t = function (element) {
    return UShortArray__contains_impl_vo7k3g_0(this, element);
  };
  protoOf(UShortArray).tn = function (elements) {
    return UShortArray__containsAll_impl_vlaaxp(this.rn_1, elements);
  };
  protoOf(UShortArray).e2 = function (elements) {
    return UShortArray__containsAll_impl_vlaaxp_0(this, elements);
  };
  protoOf(UShortArray).s = function () {
    return UShortArray__isEmpty_impl_cdd9l0(this.rn_1);
  };
  protoOf(UShortArray).toString = function () {
    return UShortArray__toString_impl_omz03z(this.rn_1);
  };
  protoOf(UShortArray).hashCode = function () {
    return UShortArray__hashCode_impl_2vt3b4(this.rn_1);
  };
  protoOf(UShortArray).equals = function (other) {
    return UShortArray__equals_impl_tyc3mk(this.rn_1, other);
  };
  function toString_6(_this__u8e3s4, radix) {
    // Inline function 'kotlin.ULong.toLong' call
    var tmp$ret$0 = _ULong___get_data__impl__fggpzb(_this__u8e3s4);
    return ulongToString(tmp$ret$0, checkRadix(radix));
  }
  function toULongOrNull(_this__u8e3s4) {
    return toULongOrNull_0(_this__u8e3s4, 10);
  }
  function toUInt(_this__u8e3s4) {
    var tmp0_elvis_lhs = toUIntOrNull(_this__u8e3s4);
    var tmp;
    var tmp_0 = tmp0_elvis_lhs;
    if ((tmp_0 == null ? null : new UInt(tmp_0)) == null) {
      numberFormatError(_this__u8e3s4);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function toULong(_this__u8e3s4) {
    var tmp0_elvis_lhs = toULongOrNull(_this__u8e3s4);
    var tmp;
    var tmp_0 = tmp0_elvis_lhs;
    if ((tmp_0 == null ? null : new ULong(tmp_0)) == null) {
      numberFormatError(_this__u8e3s4);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function toUByte(_this__u8e3s4) {
    var tmp0_elvis_lhs = toUByteOrNull(_this__u8e3s4);
    var tmp;
    var tmp_0 = tmp0_elvis_lhs;
    if ((tmp_0 == null ? null : new UByte(tmp_0)) == null) {
      numberFormatError(_this__u8e3s4);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function toUShort(_this__u8e3s4) {
    var tmp0_elvis_lhs = toUShortOrNull(_this__u8e3s4);
    var tmp;
    var tmp_0 = tmp0_elvis_lhs;
    if ((tmp_0 == null ? null : new UShort(tmp_0)) == null) {
      numberFormatError(_this__u8e3s4);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function toULongOrNull_0(_this__u8e3s4, radix) {
    checkRadix(radix);
    var length = _this__u8e3s4.length;
    if (length === 0)
      return null;
    var limit = _ULong___init__impl__c78o9k(-1n);
    var start;
    var firstChar = charCodeAt(_this__u8e3s4, 0);
    if (Char__compareTo_impl_ypi4mb(firstChar, _Char___init__impl__6a9atx(48)) < 0) {
      if (length === 1 || !(firstChar === _Char___init__impl__6a9atx(43)))
        return null;
      start = 1;
    } else {
      start = 0;
    }
    var limitForMaxRadix = _ULong___init__impl__c78o9k(512409557603043100n);
    var limitBeforeMul = limitForMaxRadix;
    // Inline function 'kotlin.toULong' call
    var uradix = _ULong___init__impl__c78o9k(fromInt_0(radix));
    var result = _ULong___init__impl__c78o9k(0n);
    var inductionVariable = start;
    if (inductionVariable < length)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var digit = digitOf(charCodeAt(_this__u8e3s4, i), radix);
        if (digit < 0)
          return null;
        var tmp0 = result;
        // Inline function 'kotlin.ULong.compareTo' call
        var other = limitBeforeMul;
        if (ulongCompare(_ULong___get_data__impl__fggpzb(tmp0), _ULong___get_data__impl__fggpzb(other)) > 0) {
          if (limitBeforeMul === limitForMaxRadix) {
            // Inline function 'kotlin.ULong.div' call
            limitBeforeMul = ulongDivide(limit, uradix);
            var tmp0_0 = result;
            // Inline function 'kotlin.ULong.compareTo' call
            var other_0 = limitBeforeMul;
            if (ulongCompare(_ULong___get_data__impl__fggpzb(tmp0_0), _ULong___get_data__impl__fggpzb(other_0)) > 0) {
              return null;
            }
          } else {
            return null;
          }
        }
        // Inline function 'kotlin.ULong.times' call
        var this_0 = result;
        result = _ULong___init__impl__c78o9k(multiply_0(_ULong___get_data__impl__fggpzb(this_0), _ULong___get_data__impl__fggpzb(uradix)));
        var beforeAdding = result;
        var tmp0_1 = result;
        // Inline function 'kotlin.toUInt' call
        // Inline function 'kotlin.ULong.plus' call
        // Inline function 'kotlin.UInt.toULong' call
        var this_1 = _UInt___init__impl__l7qpdl(digit);
        // Inline function 'kotlin.uintToULong' call
        // Inline function 'kotlin.uintToLong' call
        var value = _UInt___get_data__impl__f0vqqw(this_1);
        var tmp$ret$6 = fromInt_0(value) & 4294967295n;
        // Inline function 'kotlin.ULong.plus' call
        var other_1 = _ULong___init__impl__c78o9k(tmp$ret$6);
        result = _ULong___init__impl__c78o9k(add_2(_ULong___get_data__impl__fggpzb(tmp0_1), _ULong___get_data__impl__fggpzb(other_1)));
        // Inline function 'kotlin.ULong.compareTo' call
        var this_2 = result;
        if (ulongCompare(_ULong___get_data__impl__fggpzb(this_2), _ULong___get_data__impl__fggpzb(beforeAdding)) < 0)
          return null;
      }
       while (inductionVariable < length);
    return result;
  }
  function toUIntOrNull(_this__u8e3s4) {
    return toUIntOrNull_0(_this__u8e3s4, 10);
  }
  function toUByteOrNull(_this__u8e3s4) {
    return toUByteOrNull_0(_this__u8e3s4, 10);
  }
  function toUShortOrNull(_this__u8e3s4) {
    return toUShortOrNull_0(_this__u8e3s4, 10);
  }
  function toUIntOrNull_0(_this__u8e3s4, radix) {
    checkRadix(radix);
    var length = _this__u8e3s4.length;
    if (length === 0)
      return null;
    var limit = _UInt___init__impl__l7qpdl(-1);
    var start;
    var firstChar = charCodeAt(_this__u8e3s4, 0);
    if (Char__compareTo_impl_ypi4mb(firstChar, _Char___init__impl__6a9atx(48)) < 0) {
      if (length === 1 || !(firstChar === _Char___init__impl__6a9atx(43)))
        return null;
      start = 1;
    } else {
      start = 0;
    }
    var limitForMaxRadix = _UInt___init__impl__l7qpdl(119304647);
    var limitBeforeMul = limitForMaxRadix;
    // Inline function 'kotlin.toUInt' call
    var uradix = _UInt___init__impl__l7qpdl(radix);
    var result = _UInt___init__impl__l7qpdl(0);
    var inductionVariable = start;
    if (inductionVariable < length)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var digit = digitOf(charCodeAt(_this__u8e3s4, i), radix);
        if (digit < 0)
          return null;
        var tmp0 = result;
        // Inline function 'kotlin.UInt.compareTo' call
        var other = limitBeforeMul;
        if (uintCompare(_UInt___get_data__impl__f0vqqw(tmp0), _UInt___get_data__impl__f0vqqw(other)) > 0) {
          if (limitBeforeMul === limitForMaxRadix) {
            // Inline function 'kotlin.UInt.div' call
            limitBeforeMul = uintDivide(limit, uradix);
            var tmp0_0 = result;
            // Inline function 'kotlin.UInt.compareTo' call
            var other_0 = limitBeforeMul;
            if (uintCompare(_UInt___get_data__impl__f0vqqw(tmp0_0), _UInt___get_data__impl__f0vqqw(other_0)) > 0) {
              return null;
            }
          } else {
            return null;
          }
        }
        // Inline function 'kotlin.UInt.times' call
        var this_0 = result;
        result = _UInt___init__impl__l7qpdl(imul(_UInt___get_data__impl__f0vqqw(this_0), _UInt___get_data__impl__f0vqqw(uradix)));
        var beforeAdding = result;
        var tmp0_1 = result;
        // Inline function 'kotlin.toUInt' call
        // Inline function 'kotlin.UInt.plus' call
        var other_1 = _UInt___init__impl__l7qpdl(digit);
        result = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(tmp0_1) + _UInt___get_data__impl__f0vqqw(other_1) | 0);
        // Inline function 'kotlin.UInt.compareTo' call
        var this_1 = result;
        if (uintCompare(_UInt___get_data__impl__f0vqqw(this_1), _UInt___get_data__impl__f0vqqw(beforeAdding)) < 0)
          return null;
      }
       while (inductionVariable < length);
    return result;
  }
  function toUByteOrNull_0(_this__u8e3s4, radix) {
    var tmp0_elvis_lhs = toUIntOrNull_0(_this__u8e3s4, radix);
    var tmp;
    var tmp_0 = tmp0_elvis_lhs;
    if ((tmp_0 == null ? null : new UInt(tmp_0)) == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var int = tmp;
    // Inline function 'kotlin.UInt.compareTo' call
    // Inline function 'kotlin.UByte.toUInt' call
    var this_0 = _UByte___init__impl__g9hnc4(-1);
    // Inline function 'kotlin.UInt.compareTo' call
    var other = _UInt___init__impl__l7qpdl(_UByte___get_data__impl__jof9qr(this_0) & 255);
    if (uintCompare(_UInt___get_data__impl__f0vqqw(int), _UInt___get_data__impl__f0vqqw(other)) > 0)
      return null;
    // Inline function 'kotlin.UInt.toUByte' call
    // Inline function 'kotlin.toUByte' call
    var this_1 = _UInt___get_data__impl__f0vqqw(int);
    return _UByte___init__impl__g9hnc4(toByte(this_1));
  }
  function toUShortOrNull_0(_this__u8e3s4, radix) {
    var tmp0_elvis_lhs = toUIntOrNull_0(_this__u8e3s4, radix);
    var tmp;
    var tmp_0 = tmp0_elvis_lhs;
    if ((tmp_0 == null ? null : new UInt(tmp_0)) == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var int = tmp;
    // Inline function 'kotlin.UInt.compareTo' call
    // Inline function 'kotlin.UShort.toUInt' call
    var this_0 = _UShort___init__impl__jigrne(-1);
    // Inline function 'kotlin.UInt.compareTo' call
    var other = _UInt___init__impl__l7qpdl(_UShort___get_data__impl__g0245(this_0) & 65535);
    if (uintCompare(_UInt___get_data__impl__f0vqqw(int), _UInt___get_data__impl__f0vqqw(other)) > 0)
      return null;
    // Inline function 'kotlin.UInt.toUShort' call
    // Inline function 'kotlin.toUShort' call
    var this_1 = _UInt___get_data__impl__f0vqqw(int);
    return _UShort___init__impl__jigrne(toShort(this_1));
  }
  function atomicfu$AtomicRefArray$ref(size) {
    var tmp = this;
    var tmp_0 = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_1 = Array(size);
    while (tmp_0 < size) {
      tmp_1[tmp_0] = atomic$ref$1(null);
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp.un_1 = tmp_1;
  }
  protoOf(atomicfu$AtomicRefArray$ref).vn = function () {
    return this.un_1.length;
  };
  protoOf(atomicfu$AtomicRefArray$ref).atomicfu$get = function (index) {
    return this.un_1[index];
  };
  function atomicfu$AtomicRefArray$ofNulls(size) {
    return new atomicfu$AtomicRefArray$ref(size);
  }
  function None() {
    None_instance = this;
    atomicfu$TraceBase.call(this);
  }
  var None_instance;
  function None_getInstance() {
    if (None_instance == null)
      new None();
    return None_instance;
  }
  function atomicfu$TraceBase() {
  }
  protoOf(atomicfu$TraceBase).atomicfu$Trace$append$1 = function (event) {
  };
  protoOf(atomicfu$TraceBase).atomicfu$Trace$append$2 = function (event1, event2) {
  };
  protoOf(atomicfu$TraceBase).atomicfu$Trace$append$3 = function (event1, event2, event3) {
  };
  protoOf(atomicfu$TraceBase).atomicfu$Trace$append$4 = function (event1, event2, event3, event4) {
  };
  function AtomicBoolean(value) {
    this.kotlinx$atomicfu$value = value;
  }
  protoOf(AtomicBoolean).wn = function (_set____db54di) {
    this.kotlinx$atomicfu$value = _set____db54di;
  };
  protoOf(AtomicBoolean).xn = function () {
    return this.kotlinx$atomicfu$value;
  };
  protoOf(AtomicBoolean).atomicfu$compareAndSet = function (expect, update) {
    if (!(this.kotlinx$atomicfu$value === expect))
      return false;
    this.kotlinx$atomicfu$value = update;
    return true;
  };
  protoOf(AtomicBoolean).atomicfu$getAndSet = function (value) {
    var oldValue = this.kotlinx$atomicfu$value;
    this.kotlinx$atomicfu$value = value;
    return oldValue;
  };
  protoOf(AtomicBoolean).toString = function () {
    return this.kotlinx$atomicfu$value.toString();
  };
  function atomic$boolean$1(initial) {
    return atomic$boolean$(initial, None_getInstance());
  }
  function AtomicRef(value) {
    this.kotlinx$atomicfu$value = value;
  }
  protoOf(AtomicRef).yn = function (_set____db54di) {
    this.kotlinx$atomicfu$value = _set____db54di;
  };
  protoOf(AtomicRef).xn = function () {
    return this.kotlinx$atomicfu$value;
  };
  protoOf(AtomicRef).atomicfu$compareAndSet = function (expect, update) {
    if (!(this.kotlinx$atomicfu$value === expect))
      return false;
    this.kotlinx$atomicfu$value = update;
    return true;
  };
  protoOf(AtomicRef).atomicfu$getAndSet = function (value) {
    var oldValue = this.kotlinx$atomicfu$value;
    this.kotlinx$atomicfu$value = value;
    return oldValue;
  };
  protoOf(AtomicRef).toString = function () {
    return toString_0(this.kotlinx$atomicfu$value);
  };
  function atomic$ref$1(initial) {
    return atomic$ref$(initial, None_getInstance());
  }
  function AtomicInt(value) {
    this.kotlinx$atomicfu$value = value;
  }
  protoOf(AtomicInt).zn = function (_set____db54di) {
    this.kotlinx$atomicfu$value = _set____db54di;
  };
  protoOf(AtomicInt).xn = function () {
    return this.kotlinx$atomicfu$value;
  };
  protoOf(AtomicInt).atomicfu$compareAndSet = function (expect, update) {
    if (!(this.kotlinx$atomicfu$value === expect))
      return false;
    this.kotlinx$atomicfu$value = update;
    return true;
  };
  protoOf(AtomicInt).atomicfu$getAndSet = function (value) {
    var oldValue = this.kotlinx$atomicfu$value;
    this.kotlinx$atomicfu$value = value;
    return oldValue;
  };
  protoOf(AtomicInt).atomicfu$getAndIncrement = function () {
    var tmp1 = this.kotlinx$atomicfu$value;
    this.kotlinx$atomicfu$value = tmp1 + 1 | 0;
    return tmp1;
  };
  protoOf(AtomicInt).atomicfu$getAndDecrement = function () {
    var tmp1 = this.kotlinx$atomicfu$value;
    this.kotlinx$atomicfu$value = tmp1 - 1 | 0;
    return tmp1;
  };
  protoOf(AtomicInt).atomicfu$getAndAdd = function (delta) {
    var oldValue = this.kotlinx$atomicfu$value;
    this.kotlinx$atomicfu$value = this.kotlinx$atomicfu$value + delta | 0;
    return oldValue;
  };
  protoOf(AtomicInt).atomicfu$addAndGet = function (delta) {
    this.kotlinx$atomicfu$value = this.kotlinx$atomicfu$value + delta | 0;
    return this.kotlinx$atomicfu$value;
  };
  protoOf(AtomicInt).atomicfu$incrementAndGet = function () {
    this.kotlinx$atomicfu$value = this.kotlinx$atomicfu$value + 1 | 0;
    return this.kotlinx$atomicfu$value;
  };
  protoOf(AtomicInt).atomicfu$decrementAndGet = function () {
    this.kotlinx$atomicfu$value = this.kotlinx$atomicfu$value - 1 | 0;
    return this.kotlinx$atomicfu$value;
  };
  protoOf(AtomicInt).toString = function () {
    return this.kotlinx$atomicfu$value.toString();
  };
  function atomic$int$1(initial) {
    return atomic$int$(initial, None_getInstance());
  }
  function AtomicLong(value) {
    this.kotlinx$atomicfu$value = value;
  }
  protoOf(AtomicLong).ao = function (_set____db54di) {
    this.kotlinx$atomicfu$value = _set____db54di;
  };
  protoOf(AtomicLong).xn = function () {
    return this.kotlinx$atomicfu$value;
  };
  protoOf(AtomicLong).atomicfu$compareAndSet = function (expect, update) {
    if (!(this.kotlinx$atomicfu$value === expect))
      return false;
    this.kotlinx$atomicfu$value = update;
    return true;
  };
  protoOf(AtomicLong).atomicfu$getAndSet = function (value) {
    var oldValue = this.kotlinx$atomicfu$value;
    this.kotlinx$atomicfu$value = value;
    return oldValue;
  };
  protoOf(AtomicLong).atomicfu$getAndIncrement$long = function () {
    var tmp1 = this.kotlinx$atomicfu$value;
    this.kotlinx$atomicfu$value = add_2(tmp1, get_ONE());
    return tmp1;
  };
  protoOf(AtomicLong).atomicfu$getAndDecrement$long = function () {
    var tmp1 = this.kotlinx$atomicfu$value;
    this.kotlinx$atomicfu$value = subtract_1(tmp1, get_ONE());
    return tmp1;
  };
  protoOf(AtomicLong).atomicfu$getAndAdd$long = function (delta) {
    var oldValue = this.kotlinx$atomicfu$value;
    this.kotlinx$atomicfu$value = add_2(this.kotlinx$atomicfu$value, delta);
    return oldValue;
  };
  protoOf(AtomicLong).atomicfu$addAndGet$long = function (delta) {
    this.kotlinx$atomicfu$value = add_2(this.kotlinx$atomicfu$value, delta);
    return this.kotlinx$atomicfu$value;
  };
  protoOf(AtomicLong).atomicfu$incrementAndGet$long = function () {
    this.kotlinx$atomicfu$value = add_2(this.kotlinx$atomicfu$value, get_ONE());
    return this.kotlinx$atomicfu$value;
  };
  protoOf(AtomicLong).atomicfu$decrementAndGet$long = function () {
    this.kotlinx$atomicfu$value = subtract_1(this.kotlinx$atomicfu$value, get_ONE());
    return this.kotlinx$atomicfu$value;
  };
  protoOf(AtomicLong).toString = function () {
    return this.kotlinx$atomicfu$value.toString();
  };
  function atomic$long$1(initial) {
    return atomic$long$(initial, None_getInstance());
  }
  function atomic$boolean$(initial, trace) {
    trace = trace === VOID ? None_getInstance() : trace;
    return new AtomicBoolean(initial);
  }
  function atomic$ref$(initial, trace) {
    trace = trace === VOID ? None_getInstance() : trace;
    return new AtomicRef(initial);
  }
  function atomic$int$(initial, trace) {
    trace = trace === VOID ? None_getInstance() : trace;
    return new AtomicInt(initial);
  }
  function atomic$long$(initial, trace) {
    trace = trace === VOID ? None_getInstance() : trace;
    return new AtomicLong(initial);
  }
  function appendText(_this__u8e3s4, text) {
    _this__u8e3s4.appendChild(ensureNotNull(_this__u8e3s4.ownerDocument).createTextNode(text));
    return _this__u8e3s4;
  }
  function AbstractCoroutine(parentContext, initParentJob, active) {
    JobSupport.call(this, active);
    if (initParentJob) {
      this.do(parentContext.s9(Key_instance_3));
    }
    this.go_1 = parentContext.wi(this);
  }
  protoOf(AbstractCoroutine).l9 = function () {
    return this.go_1;
  };
  protoOf(AbstractCoroutine).ho = function () {
    return this.go_1;
  };
  protoOf(AbstractCoroutine).io = function () {
    return protoOf(JobSupport).io.call(this);
  };
  protoOf(AbstractCoroutine).jo = function (value) {
  };
  protoOf(AbstractCoroutine).ko = function (cause, handled) {
  };
  protoOf(AbstractCoroutine).lo = function () {
    return get_classSimpleName(this) + ' was cancelled';
  };
  protoOf(AbstractCoroutine).mo = function (state) {
    if (state instanceof CompletedExceptionally) {
      this.ko(state.no_1, state.po());
    } else {
      this.jo((state == null ? true : !(state == null)) ? state : THROW_CCE());
    }
  };
  protoOf(AbstractCoroutine).q9 = function (result) {
    var state = this.qo(toState_0(result));
    if (state === get_COMPLETING_WAITING_CHILDREN())
      return Unit_instance;
    this.ro(state);
  };
  protoOf(AbstractCoroutine).ro = function (state) {
    return this.so(state);
  };
  protoOf(AbstractCoroutine).to = function (exception) {
    handleCoroutineException(this.go_1, exception);
  };
  protoOf(AbstractCoroutine).uo = function () {
    var tmp0_elvis_lhs = get_coroutineName(this.go_1);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return protoOf(JobSupport).uo.call(this);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var coroutineName = tmp;
    return '"' + coroutineName + '":' + protoOf(JobSupport).uo.call(this);
  };
  protoOf(AbstractCoroutine).vo = function (start, receiver, block) {
    start.yo(block, receiver, this);
  };
  function launch(_this__u8e3s4, context, start, block) {
    context = context === VOID ? EmptyCoroutineContext_instance : context;
    start = start === VOID ? CoroutineStart_DEFAULT_getInstance() : start;
    var newContext = newCoroutineContext(_this__u8e3s4, context);
    var coroutine = start.iq() ? new LazyStandaloneCoroutine(newContext, block) : new StandaloneCoroutine(newContext, true);
    coroutine.vo(start, coroutine, block);
    return coroutine;
  }
  function withContext(context, block, $completion) {
    // Inline function 'kotlin.contracts.contract' call
    var tmp$ret$1;
    $l$block_0: {
      var oldContext = $completion.l9();
      var newContext = newCoroutineContext_0(oldContext, context);
      ensureActive(newContext);
      if (newContext === oldContext) {
        var coroutine = new ScopeCoroutine(newContext, $completion);
        tmp$ret$1 = startUndispatchedOrReturn(coroutine, coroutine, block);
        break $l$block_0;
      }
      if (equals(newContext.s9(Key_instance), oldContext.s9(Key_instance))) {
        var coroutine_0 = new UndispatchedCoroutine(newContext, $completion);
        // Inline function 'kotlinx.coroutines.withCoroutineContext' call
        coroutine_0.go_1;
        tmp$ret$1 = startUndispatchedOrReturn(coroutine_0, coroutine_0, block);
        break $l$block_0;
      }
      var coroutine_1 = new DispatchedCoroutine(newContext, $completion);
      startCoroutineCancellable(block, coroutine_1, coroutine_1);
      tmp$ret$1 = coroutine_1.oq();
    }
    return tmp$ret$1;
  }
  function async(_this__u8e3s4, context, start, block) {
    context = context === VOID ? EmptyCoroutineContext_instance : context;
    start = start === VOID ? CoroutineStart_DEFAULT_getInstance() : start;
    var newContext = newCoroutineContext(_this__u8e3s4, context);
    var coroutine = start.iq() ? new LazyDeferredCoroutine(newContext, block) : new DeferredCoroutine(newContext, true);
    coroutine.vo(start, coroutine, block);
    return coroutine;
  }
  function StandaloneCoroutine(parentContext, active) {
    AbstractCoroutine.call(this, parentContext, true, active);
  }
  protoOf(StandaloneCoroutine).dq = function (exception) {
    handleCoroutineException(this.go_1, exception);
    return true;
  };
  function LazyStandaloneCoroutine(parentContext, block) {
    StandaloneCoroutine.call(this, parentContext, false);
    this.vq_1 = createCoroutineUnintercepted(block, this, this);
  }
  protoOf(LazyStandaloneCoroutine).gp = function () {
    startCoroutineCancellable_0(this.vq_1, this);
  };
  function trySuspend($this) {
    // Inline function 'kotlinx.atomicfu.loop' call
    var this_0 = $this.nq_1;
    while (true) {
      switch (this_0.kotlinx$atomicfu$value) {
        case 0:
          if ($this.nq_1.atomicfu$compareAndSet(0, 1))
            return true;
          break;
        case 2:
          return false;
        default:
          // Inline function 'kotlin.error' call

          var message = 'Already suspended';
          throw IllegalStateException_init_$Create$_0(toString_1(message));
      }
    }
  }
  function tryResume($this) {
    // Inline function 'kotlinx.atomicfu.loop' call
    var this_0 = $this.nq_1;
    while (true) {
      switch (this_0.kotlinx$atomicfu$value) {
        case 0:
          if ($this.nq_1.atomicfu$compareAndSet(0, 2))
            return true;
          break;
        case 1:
          return false;
        default:
          // Inline function 'kotlin.error' call

          var message = 'Already resumed';
          throw IllegalStateException_init_$Create$_0(toString_1(message));
      }
    }
  }
  function DispatchedCoroutine(context, uCont) {
    ScopeCoroutine.call(this, context, uCont);
    this.nq_1 = atomic$int$1(0);
  }
  protoOf(DispatchedCoroutine).so = function (state) {
    this.ro(state);
  };
  protoOf(DispatchedCoroutine).ro = function (state) {
    if (tryResume(this))
      return Unit_instance;
    resumeCancellableWith(intercepted(this.zq_1), recoverResult(state, this.zq_1));
  };
  protoOf(DispatchedCoroutine).oq = function () {
    if (trySuspend(this))
      return get_COROUTINE_SUSPENDED();
    var state = unboxState(this.cp());
    if (state instanceof CompletedExceptionally)
      throw state.no_1;
    return (state == null ? true : !(state == null)) ? state : THROW_CCE();
  };
  function $awaitCOROUTINE$(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.ir_1 = _this__u8e3s4;
  }
  protoOf($awaitCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.ir_1.hq(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return (suspendResult == null ? true : !(suspendResult == null)) ? suspendResult : THROW_CCE();
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function DeferredCoroutine(parentContext, active) {
    AbstractCoroutine.call(this, parentContext, true, active);
  }
  protoOf(DeferredCoroutine).mr = function () {
    var tmp = this.gq();
    return (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
  };
  protoOf(DeferredCoroutine).nr = function ($completion) {
    var tmp = new $awaitCOROUTINE$(this, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  function LazyDeferredCoroutine(parentContext, block) {
    DeferredCoroutine.call(this, parentContext, false);
    this.rr_1 = createCoroutineUnintercepted(block, this, this);
  }
  protoOf(LazyDeferredCoroutine).gp = function () {
    startCoroutineCancellable_0(this.rr_1, this);
  };
  function CancellableContinuation() {
  }
  function disposeOnCancellation(_this__u8e3s4, handle) {
    // Inline function 'kotlinx.coroutines.asHandler' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = new DisposeOnCancel(handle);
    return _this__u8e3s4.ur(tmp$ret$1);
  }
  function DisposeOnCancel(handle) {
    CancelHandler.call(this);
    this.xr_1 = handle;
  }
  protoOf(DisposeOnCancel).yr = function (cause) {
    return this.xr_1.zr();
  };
  protoOf(DisposeOnCancel).invoke = function (cause) {
    return this.yr(cause);
  };
  protoOf(DisposeOnCancel).toString = function () {
    return 'DisposeOnCancel[' + toString_1(this.xr_1) + ']';
  };
  function getOrCreateCancellableContinuation(delegate) {
    if (!(delegate instanceof DispatchedContinuation)) {
      return new CancellableContinuationImpl(delegate, 1);
    }
    var tmp0_safe_receiver = delegate.gs();
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.takeIf' call
      var tmp_0;
      if (tmp0_safe_receiver.ns()) {
        tmp_0 = tmp0_safe_receiver;
      } else {
        tmp_0 = null;
      }
      tmp = tmp_0;
    }
    var tmp1_elvis_lhs = tmp;
    var tmp_1;
    if (tmp1_elvis_lhs == null) {
      return new CancellableContinuationImpl(delegate, 2);
    } else {
      tmp_1 = tmp1_elvis_lhs;
    }
    return tmp_1;
  }
  function get_RESUME_TOKEN() {
    _init_properties_CancellableContinuationImpl_kt__6rrtdd();
    return RESUME_TOKEN;
  }
  var RESUME_TOKEN;
  function _get_parentHandle__f8dcex($this) {
    return $this.ms_1.kotlinx$atomicfu$value;
  }
  function _get_stateDebugRepresentation__bf18u4($this) {
    var tmp0_subject = $this.cp();
    var tmp;
    if (!(tmp0_subject == null) ? isInterface(tmp0_subject, NotCompleted) : false) {
      tmp = 'Active';
    } else {
      if (tmp0_subject instanceof CancelledContinuation) {
        tmp = 'Cancelled';
      } else {
        tmp = 'Completed';
      }
    }
    return tmp;
  }
  function isReusable($this) {
    var tmp;
    if (get_isReusableMode($this.ps_1)) {
      var tmp_0 = $this.is_1;
      tmp = (tmp_0 instanceof DispatchedContinuation ? tmp_0 : THROW_CCE()).os();
    } else {
      tmp = false;
    }
    return tmp;
  }
  function cancelLater($this, cause) {
    if (!isReusable($this))
      return false;
    var tmp = $this.is_1;
    var dispatched = tmp instanceof DispatchedContinuation ? tmp : THROW_CCE();
    return dispatched.qs(cause);
  }
  function callSegmentOnCancellation($this, segment, cause) {
    // Inline function 'kotlinx.coroutines.index' call
    var index = $this.ks_1.kotlinx$atomicfu$value & 536870911;
    // Inline function 'kotlin.check' call
    if (!!(index === 536870911)) {
      var message = 'The index for Segment.onCancellation(..) is broken';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    // Inline function 'kotlinx.coroutines.CancellableContinuationImpl.callCancelHandlerSafely' call
    try {
      segment.vs(index, cause, $this.l9());
    } catch ($p) {
      if ($p instanceof Error) {
        var ex = $p;
        handleCoroutineException($this.l9(), new CompletionHandlerException('Exception in invokeOnCancellation handler for ' + $this.toString(), ex));
      } else {
        throw $p;
      }
    }
  }
  function trySuspend_0($this) {
    // Inline function 'kotlinx.atomicfu.loop' call
    var this_0 = $this.ks_1;
    while (true) {
      var cur = this_0.kotlinx$atomicfu$value;
      // Inline function 'kotlinx.coroutines.decision' call
      switch (cur >> 29) {
        case 0:
          // Inline function 'kotlinx.coroutines.index' call

          // Inline function 'kotlinx.coroutines.decisionAndIndex' call

          var tmp$ret$2 = (1 << 29) + (cur & 536870911) | 0;
          if ($this.ks_1.atomicfu$compareAndSet(cur, tmp$ret$2))
            return true;
          break;
        case 2:
          return false;
        default:
          // Inline function 'kotlin.error' call

          var message = 'Already suspended';
          throw IllegalStateException_init_$Create$_0(toString_1(message));
      }
    }
  }
  function tryResume_0($this) {
    // Inline function 'kotlinx.atomicfu.loop' call
    var this_0 = $this.ks_1;
    while (true) {
      var cur = this_0.kotlinx$atomicfu$value;
      // Inline function 'kotlinx.coroutines.decision' call
      switch (cur >> 29) {
        case 0:
          // Inline function 'kotlinx.coroutines.index' call

          // Inline function 'kotlinx.coroutines.decisionAndIndex' call

          var tmp$ret$2 = (2 << 29) + (cur & 536870911) | 0;
          if ($this.ks_1.atomicfu$compareAndSet(cur, tmp$ret$2))
            return true;
          break;
        case 1:
          return false;
        default:
          // Inline function 'kotlin.error' call

          var message = 'Already resumed';
          throw IllegalStateException_init_$Create$_0(toString_1(message));
      }
    }
  }
  function installParentHandle($this) {
    var tmp0_elvis_lhs = $this.l9().s9(Key_instance_3);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var parent = tmp;
    // Inline function 'kotlinx.coroutines.asHandler' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = new ChildContinuation($this);
    var handle = parent.mp(true, VOID, tmp$ret$1);
    $this.ms_1.atomicfu$compareAndSet(null, handle);
    return handle;
  }
  function invokeOnCancellationImpl($this, handler) {
    // Inline function 'kotlinx.coroutines.assert' call
    // Inline function 'kotlinx.atomicfu.loop' call
    var this_0 = $this.ls_1;
    while (true) {
      var state = this_0.kotlinx$atomicfu$value;
      if (state instanceof Active) {
        if ($this.ls_1.atomicfu$compareAndSet(state, handler))
          return Unit_instance;
      } else {
        var tmp;
        if (state instanceof CancelHandler) {
          tmp = true;
        } else {
          tmp = state instanceof Segment;
        }
        if (tmp) {
          multipleHandlersError($this, handler, state);
        } else {
          if (state instanceof CompletedExceptionally) {
            if (!state.et()) {
              multipleHandlersError($this, handler, state);
            }
            if (state instanceof CancelledContinuation) {
              var tmp1_safe_receiver = state instanceof CompletedExceptionally ? state : null;
              var cause = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.no_1;
              if (handler instanceof CancelHandler) {
                $this.bt(handler, cause);
              } else {
                var segment = handler instanceof Segment ? handler : THROW_CCE();
                callSegmentOnCancellation($this, segment, cause);
              }
            }
            return Unit_instance;
          } else {
            if (state instanceof CompletedContinuation_0) {
              if (!(state.xs_1 == null)) {
                multipleHandlersError($this, handler, state);
              }
              if (handler instanceof Segment)
                return Unit_instance;
              if (!(handler instanceof CancelHandler))
                THROW_CCE();
              if (state.ct()) {
                $this.bt(handler, state.at_1);
                return Unit_instance;
              }
              var update = state.dt(VOID, handler);
              if ($this.ls_1.atomicfu$compareAndSet(state, update))
                return Unit_instance;
            } else {
              if (handler instanceof Segment)
                return Unit_instance;
              if (!(handler instanceof CancelHandler))
                THROW_CCE();
              var update_0 = new CompletedContinuation_0(state, handler);
              if ($this.ls_1.atomicfu$compareAndSet(state, update_0))
                return Unit_instance;
            }
          }
        }
      }
    }
  }
  function multipleHandlersError($this, handler, state) {
    // Inline function 'kotlin.error' call
    var message = "It's prohibited to register multiple handlers, tried to register " + toString_1(handler) + ', already has ' + toString_0(state);
    throw IllegalStateException_init_$Create$_0(toString_1(message));
  }
  function makeCancelHandler($this, handler) {
    var tmp;
    if (handler instanceof CancelHandler) {
      tmp = handler;
    } else {
      tmp = new InvokeOnCancel(handler);
    }
    return tmp;
  }
  function dispatchResume($this, mode) {
    if (tryResume_0($this))
      return Unit_instance;
    dispatch($this, mode);
  }
  function resumedState($this, state, proposedUpdate, resumeMode, onCancellation, idempotent) {
    var tmp;
    if (proposedUpdate instanceof CompletedExceptionally) {
      // Inline function 'kotlinx.coroutines.assert' call
      // Inline function 'kotlinx.coroutines.assert' call
      tmp = proposedUpdate;
    } else {
      if (!get_isCancellableMode(resumeMode) && idempotent == null) {
        tmp = proposedUpdate;
      } else {
        var tmp_0;
        var tmp_1;
        if (!(onCancellation == null)) {
          tmp_1 = true;
        } else {
          tmp_1 = state instanceof CancelHandler;
        }
        if (tmp_1) {
          tmp_0 = true;
        } else {
          tmp_0 = !(idempotent == null);
        }
        if (tmp_0) {
          tmp = new CompletedContinuation_0(proposedUpdate, state instanceof CancelHandler ? state : null, onCancellation, idempotent);
        } else {
          tmp = proposedUpdate;
        }
      }
    }
    return tmp;
  }
  function resumeImpl($this, proposedUpdate, resumeMode, onCancellation) {
    // Inline function 'kotlinx.atomicfu.loop' call
    var this_0 = $this.ls_1;
    while (true) {
      var tmp0 = this_0.kotlinx$atomicfu$value;
      $l$block: {
        if (!(tmp0 == null) ? isInterface(tmp0, NotCompleted) : false) {
          var update = resumedState($this, tmp0, proposedUpdate, resumeMode, onCancellation, null);
          if (!$this.ls_1.atomicfu$compareAndSet(tmp0, update)) {
            break $l$block;
          }
          detachChildIfNonResuable($this);
          dispatchResume($this, resumeMode);
          return Unit_instance;
        } else {
          if (tmp0 instanceof CancelledContinuation) {
            if (tmp0.jt()) {
              if (onCancellation == null)
                null;
              else {
                // Inline function 'kotlin.let' call
                $this.ft(onCancellation, tmp0.no_1);
              }
              return Unit_instance;
            }
          }
        }
        alreadyResumedError($this, proposedUpdate);
      }
    }
  }
  function resumeImpl$default($this, proposedUpdate, resumeMode, onCancellation, $super) {
    onCancellation = onCancellation === VOID ? null : onCancellation;
    return resumeImpl($this, proposedUpdate, resumeMode, onCancellation);
  }
  function tryResumeImpl($this, proposedUpdate, idempotent, onCancellation) {
    // Inline function 'kotlinx.atomicfu.loop' call
    var this_0 = $this.ls_1;
    while (true) {
      var tmp0 = this_0.kotlinx$atomicfu$value;
      $l$block: {
        if (!(tmp0 == null) ? isInterface(tmp0, NotCompleted) : false) {
          var update = resumedState($this, tmp0, proposedUpdate, $this.ps_1, onCancellation, idempotent);
          if (!$this.ls_1.atomicfu$compareAndSet(tmp0, update)) {
            break $l$block;
          }
          detachChildIfNonResuable($this);
          return get_RESUME_TOKEN();
        } else {
          if (tmp0 instanceof CompletedContinuation_0) {
            var tmp;
            if (!(idempotent == null) && tmp0.zs_1 === idempotent) {
              // Inline function 'kotlinx.coroutines.assert' call
              tmp = get_RESUME_TOKEN();
            } else {
              tmp = null;
            }
            return tmp;
          } else {
            return null;
          }
        }
      }
    }
  }
  function alreadyResumedError($this, proposedUpdate) {
    // Inline function 'kotlin.error' call
    var message = 'Already resumed, but proposed with update ' + toString_0(proposedUpdate);
    throw IllegalStateException_init_$Create$_0(toString_1(message));
  }
  function detachChildIfNonResuable($this) {
    if (!isReusable($this)) {
      $this.kt();
    }
  }
  function CancellableContinuationImpl(delegate, resumeMode) {
    DispatchedTask.call(this, resumeMode);
    this.is_1 = delegate;
    // Inline function 'kotlinx.coroutines.assert' call
    this.js_1 = this.is_1.l9();
    var tmp = this;
    // Inline function 'kotlinx.coroutines.decisionAndIndex' call
    var tmp$ret$1 = (0 << 29) + 536870911 | 0;
    tmp.ks_1 = atomic$int$1(tmp$ret$1);
    this.ls_1 = atomic$ref$1(Active_instance);
    this.ms_1 = atomic$ref$1(null);
  }
  protoOf(CancellableContinuationImpl).lt = function () {
    return this.is_1;
  };
  protoOf(CancellableContinuationImpl).l9 = function () {
    return this.js_1;
  };
  protoOf(CancellableContinuationImpl).cp = function () {
    return this.ls_1.kotlinx$atomicfu$value;
  };
  protoOf(CancellableContinuationImpl).dp = function () {
    var tmp = this.cp();
    return !(!(tmp == null) ? isInterface(tmp, NotCompleted) : false);
  };
  protoOf(CancellableContinuationImpl).ep = function () {
    var tmp = this.cp();
    return tmp instanceof CancelledContinuation;
  };
  protoOf(CancellableContinuationImpl).mt = function () {
    var tmp0_elvis_lhs = installParentHandle(this);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var handle = tmp;
    if (this.dp()) {
      handle.zr();
      this.ms_1.kotlinx$atomicfu$value = NonDisposableHandle_instance;
    }
  };
  protoOf(CancellableContinuationImpl).ns = function () {
    // Inline function 'kotlinx.coroutines.assert' call
    // Inline function 'kotlinx.coroutines.assert' call
    var state = this.ls_1.kotlinx$atomicfu$value;
    // Inline function 'kotlinx.coroutines.assert' call
    var tmp;
    if (state instanceof CompletedContinuation_0) {
      tmp = !(state.zs_1 == null);
    } else {
      tmp = false;
    }
    if (tmp) {
      this.kt();
      return false;
    }
    var tmp_0 = this.ks_1;
    // Inline function 'kotlinx.coroutines.decisionAndIndex' call
    tmp_0.kotlinx$atomicfu$value = (0 << 29) + 536870911 | 0;
    this.ls_1.kotlinx$atomicfu$value = Active_instance;
    return true;
  };
  protoOf(CancellableContinuationImpl).nt = function () {
    return this.cp();
  };
  protoOf(CancellableContinuationImpl).ot = function (takenState, cause) {
    var this_0 = this.ls_1;
    while (true) {
      var state = this_0.kotlinx$atomicfu$value;
      if (!(state == null) ? isInterface(state, NotCompleted) : false) {
        // Inline function 'kotlin.error' call
        var message = 'Not completed';
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      } else {
        if (state instanceof CompletedExceptionally)
          return Unit_instance;
        else {
          if (state instanceof CompletedContinuation_0) {
            // Inline function 'kotlin.check' call
            if (!!state.ct()) {
              var message_0 = 'Must be called at most once';
              throw IllegalStateException_init_$Create$_0(toString_1(message_0));
            }
            var update = state.dt(VOID, VOID, VOID, VOID, cause);
            if (this.ls_1.atomicfu$compareAndSet(state, update)) {
              state.pt(this, cause);
              return Unit_instance;
            }
          } else {
            if (this.ls_1.atomicfu$compareAndSet(state, new CompletedContinuation_0(state, VOID, VOID, VOID, cause))) {
              return Unit_instance;
            }
          }
        }
      }
    }
    return Unit_instance;
  };
  protoOf(CancellableContinuationImpl).qt = function (cause) {
    // Inline function 'kotlinx.atomicfu.loop' call
    var this_0 = this.ls_1;
    while (true) {
      var tmp0 = this_0.kotlinx$atomicfu$value;
      $l$block: {
        if (!(!(tmp0 == null) ? isInterface(tmp0, NotCompleted) : false))
          return false;
        var tmp;
        if (tmp0 instanceof CancelHandler) {
          tmp = true;
        } else {
          tmp = tmp0 instanceof Segment;
        }
        var update = new CancelledContinuation(this, cause, tmp);
        if (!this.ls_1.atomicfu$compareAndSet(tmp0, update)) {
          break $l$block;
        }
        if (tmp0 instanceof CancelHandler) {
          this.bt(tmp0, cause);
        } else {
          if (tmp0 instanceof Segment) {
            callSegmentOnCancellation(this, tmp0, cause);
          }
        }
        detachChildIfNonResuable(this);
        dispatchResume(this, this.ps_1);
        return true;
      }
    }
  };
  protoOf(CancellableContinuationImpl).rt = function (cause) {
    if (cancelLater(this, cause))
      return Unit_instance;
    this.qt(cause);
    detachChildIfNonResuable(this);
  };
  protoOf(CancellableContinuationImpl).bt = function (handler, cause) {
    // Inline function 'kotlinx.coroutines.CancellableContinuationImpl.callCancelHandlerSafely' call
    try {
      handler.invoke(cause);
    } catch ($p) {
      if ($p instanceof Error) {
        var ex = $p;
        handleCoroutineException(this.l9(), new CompletionHandlerException('Exception in invokeOnCancellation handler for ' + this.toString(), ex));
      } else {
        throw $p;
      }
    }
    return Unit_instance;
  };
  protoOf(CancellableContinuationImpl).ft = function (onCancellation, cause) {
    try {
      onCancellation(cause);
    } catch ($p) {
      if ($p instanceof Error) {
        var ex = $p;
        handleCoroutineException(this.l9(), new CompletionHandlerException('Exception in resume onCancellation handler for ' + this.toString(), ex));
      } else {
        throw $p;
      }
    }
  };
  protoOf(CancellableContinuationImpl).st = function (parent) {
    return parent.hp();
  };
  protoOf(CancellableContinuationImpl).tt = function () {
    var isReusable_0 = isReusable(this);
    if (trySuspend_0(this)) {
      if (_get_parentHandle__f8dcex(this) == null) {
        installParentHandle(this);
      }
      if (isReusable_0) {
        this.ut();
      }
      return get_COROUTINE_SUSPENDED();
    }
    if (isReusable_0) {
      this.ut();
    }
    var state = this.cp();
    if (state instanceof CompletedExceptionally)
      throw recoverStackTrace(state.no_1, this);
    if (get_isCancellableMode(this.ps_1)) {
      var job = this.l9().s9(Key_instance_3);
      if (!(job == null) && !job.io()) {
        var cause = job.hp();
        this.ot(state, cause);
        throw recoverStackTrace(cause, this);
      }
    }
    return this.vt(state);
  };
  protoOf(CancellableContinuationImpl).ut = function () {
    var tmp = this.is_1;
    var tmp0_safe_receiver = tmp instanceof DispatchedContinuation ? tmp : null;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.wt(this);
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    var cancellationCause = tmp_0;
    this.kt();
    this.qt(cancellationCause);
  };
  protoOf(CancellableContinuationImpl).q9 = function (result) {
    return resumeImpl$default(this, toState(result, this), this.ps_1);
  };
  protoOf(CancellableContinuationImpl).wr = function (value, onCancellation) {
    return resumeImpl(this, value, this.ps_1, onCancellation);
  };
  protoOf(CancellableContinuationImpl).xt = function (segment, index) {
    var tmp0 = this.ks_1;
    $l$block: {
      // Inline function 'kotlinx.atomicfu.update' call
      while (true) {
        var cur = tmp0.kotlinx$atomicfu$value;
        // Inline function 'kotlinx.coroutines.index' call
        // Inline function 'kotlin.check' call
        if (!((cur & 536870911) === 536870911)) {
          var message = 'invokeOnCancellation should be called at most once';
          throw IllegalStateException_init_$Create$_0(toString_1(message));
        }
        // Inline function 'kotlinx.coroutines.decision' call
        // Inline function 'kotlinx.coroutines.decisionAndIndex' call
        var upd = (cur >> 29 << 29) + index | 0;
        if (tmp0.atomicfu$compareAndSet(cur, upd)) {
          break $l$block;
        }
      }
    }
    invokeOnCancellationImpl(this, segment);
  };
  protoOf(CancellableContinuationImpl).ur = function (handler) {
    var cancelHandler = makeCancelHandler(this, handler);
    invokeOnCancellationImpl(this, cancelHandler);
  };
  protoOf(CancellableContinuationImpl).kt = function () {
    var tmp0_elvis_lhs = _get_parentHandle__f8dcex(this);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var handle = tmp;
    handle.zr();
    this.ms_1.kotlinx$atomicfu$value = NonDisposableHandle_instance;
  };
  protoOf(CancellableContinuationImpl).sr = function (value, idempotent, onCancellation) {
    return tryResumeImpl(this, value, idempotent, onCancellation);
  };
  protoOf(CancellableContinuationImpl).tr = function (token) {
    // Inline function 'kotlinx.coroutines.assert' call
    dispatchResume(this, this.ps_1);
  };
  protoOf(CancellableContinuationImpl).vr = function (_this__u8e3s4, value) {
    var tmp = this.is_1;
    var dc = tmp instanceof DispatchedContinuation ? tmp : null;
    var tmp_0;
    if ((dc == null ? null : dc.bs_1) === _this__u8e3s4) {
      tmp_0 = 4;
    } else {
      tmp_0 = this.ps_1;
    }
    resumeImpl$default(this, value, tmp_0);
  };
  protoOf(CancellableContinuationImpl).vt = function (state) {
    var tmp;
    if (state instanceof CompletedContinuation_0) {
      var tmp_0 = state.ws_1;
      tmp = (tmp_0 == null ? true : !(tmp_0 == null)) ? tmp_0 : THROW_CCE();
    } else {
      tmp = (state == null ? true : !(state == null)) ? state : THROW_CCE();
    }
    return tmp;
  };
  protoOf(CancellableContinuationImpl).yt = function (state) {
    var tmp0_safe_receiver = protoOf(DispatchedTask).yt.call(this, state);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp = recoverStackTrace(tmp0_safe_receiver, this.is_1);
    }
    return tmp;
  };
  protoOf(CancellableContinuationImpl).toString = function () {
    return this.zt() + '(' + toDebugString(this.is_1) + '){' + _get_stateDebugRepresentation__bf18u4(this) + '}@' + get_hexAddress(this);
  };
  protoOf(CancellableContinuationImpl).zt = function () {
    return 'CancellableContinuation';
  };
  function Active() {
  }
  protoOf(Active).toString = function () {
    return 'Active';
  };
  var Active_instance;
  function Active_getInstance() {
    return Active_instance;
  }
  function NotCompleted() {
  }
  function CompletedContinuation_0(result, cancelHandler, onCancellation, idempotentResume, cancelCause) {
    cancelHandler = cancelHandler === VOID ? null : cancelHandler;
    onCancellation = onCancellation === VOID ? null : onCancellation;
    idempotentResume = idempotentResume === VOID ? null : idempotentResume;
    cancelCause = cancelCause === VOID ? null : cancelCause;
    this.ws_1 = result;
    this.xs_1 = cancelHandler;
    this.ys_1 = onCancellation;
    this.zs_1 = idempotentResume;
    this.at_1 = cancelCause;
  }
  protoOf(CompletedContinuation_0).ct = function () {
    return !(this.at_1 == null);
  };
  protoOf(CompletedContinuation_0).pt = function (cont, cause) {
    var tmp0_safe_receiver = this.xs_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      cont.bt(tmp0_safe_receiver, cause);
    }
    var tmp1_safe_receiver = this.ys_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      cont.ft(tmp1_safe_receiver, cause);
    }
  };
  protoOf(CompletedContinuation_0).cu = function (result, cancelHandler, onCancellation, idempotentResume, cancelCause) {
    return new CompletedContinuation_0(result, cancelHandler, onCancellation, idempotentResume, cancelCause);
  };
  protoOf(CompletedContinuation_0).dt = function (result, cancelHandler, onCancellation, idempotentResume, cancelCause, $super) {
    result = result === VOID ? this.ws_1 : result;
    cancelHandler = cancelHandler === VOID ? this.xs_1 : cancelHandler;
    onCancellation = onCancellation === VOID ? this.ys_1 : onCancellation;
    idempotentResume = idempotentResume === VOID ? this.zs_1 : idempotentResume;
    cancelCause = cancelCause === VOID ? this.at_1 : cancelCause;
    return $super === VOID ? this.cu(result, cancelHandler, onCancellation, idempotentResume, cancelCause) : $super.cu.call(this, result, cancelHandler, onCancellation, idempotentResume, cancelCause);
  };
  protoOf(CompletedContinuation_0).toString = function () {
    return 'CompletedContinuation(result=' + toString_0(this.ws_1) + ', cancelHandler=' + toString_0(this.xs_1) + ', onCancellation=' + toString_0(this.ys_1) + ', idempotentResume=' + toString_0(this.zs_1) + ', cancelCause=' + toString_0(this.at_1) + ')';
  };
  protoOf(CompletedContinuation_0).hashCode = function () {
    var result = this.ws_1 == null ? 0 : hashCode(this.ws_1);
    result = imul(result, 31) + (this.xs_1 == null ? 0 : hashCode(this.xs_1)) | 0;
    result = imul(result, 31) + (this.ys_1 == null ? 0 : hashCode(this.ys_1)) | 0;
    result = imul(result, 31) + (this.zs_1 == null ? 0 : hashCode(this.zs_1)) | 0;
    result = imul(result, 31) + (this.at_1 == null ? 0 : hashCode(this.at_1)) | 0;
    return result;
  };
  protoOf(CompletedContinuation_0).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CompletedContinuation_0))
      return false;
    var tmp0_other_with_cast = other instanceof CompletedContinuation_0 ? other : THROW_CCE();
    if (!equals(this.ws_1, tmp0_other_with_cast.ws_1))
      return false;
    if (!equals(this.xs_1, tmp0_other_with_cast.xs_1))
      return false;
    if (!equals(this.ys_1, tmp0_other_with_cast.ys_1))
      return false;
    if (!equals(this.zs_1, tmp0_other_with_cast.zs_1))
      return false;
    if (!equals(this.at_1, tmp0_other_with_cast.at_1))
      return false;
    return true;
  };
  function CancelHandler() {
    CancelHandlerBase.call(this);
  }
  function InvokeOnCancel(handler) {
    CancelHandler.call(this);
    this.du_1 = handler;
  }
  protoOf(InvokeOnCancel).yr = function (cause) {
    this.du_1(cause);
  };
  protoOf(InvokeOnCancel).invoke = function (cause) {
    return this.yr(cause);
  };
  protoOf(InvokeOnCancel).toString = function () {
    return 'InvokeOnCancel[' + get_classSimpleName(this.du_1) + '@' + get_hexAddress(this) + ']';
  };
  var properties_initialized_CancellableContinuationImpl_kt_xtzb03;
  function _init_properties_CancellableContinuationImpl_kt__6rrtdd() {
    if (!properties_initialized_CancellableContinuationImpl_kt_xtzb03) {
      properties_initialized_CancellableContinuationImpl_kt_xtzb03 = true;
      RESUME_TOKEN = new Symbol_0('RESUME_TOKEN');
    }
  }
  function CompletableDeferred(parent) {
    parent = parent === VOID ? null : parent;
    return new CompletableDeferredImpl(parent);
  }
  function $awaitCOROUTINE$_0(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.mu_1 = _this__u8e3s4;
  }
  protoOf($awaitCOROUTINE$_0).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.mu_1.hq(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return (suspendResult == null ? true : !(suspendResult == null)) ? suspendResult : THROW_CCE();
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function CompletableDeferredImpl(parent) {
    JobSupport.call(this, true);
    this.do(parent);
  }
  protoOf(CompletableDeferredImpl).qp = function () {
    return true;
  };
  protoOf(CompletableDeferredImpl).mr = function () {
    var tmp = this.gq();
    return (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
  };
  protoOf(CompletableDeferredImpl).nr = function ($completion) {
    var tmp = new $awaitCOROUTINE$_0(this, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(CompletableDeferredImpl).pu = function (value) {
    return this.qu(value);
  };
  protoOf(CompletableDeferredImpl).ru = function (exception) {
    return this.qu(new CompletedExceptionally(exception));
  };
  function CompletableJob() {
  }
  function recoverResult(state, uCont) {
    var tmp;
    if (state instanceof CompletedExceptionally) {
      // Inline function 'kotlin.Companion.failure' call
      var exception = recoverStackTrace(state.no_1, uCont);
      tmp = _Result___init__impl__xyqfz8(createFailure(exception));
    } else {
      // Inline function 'kotlin.Companion.success' call
      var value = (state == null ? true : !(state == null)) ? state : THROW_CCE();
      tmp = _Result___init__impl__xyqfz8(value);
    }
    return tmp;
  }
  function CompletedExceptionally(cause, handled) {
    handled = handled === VOID ? false : handled;
    this.no_1 = cause;
    this.oo_1 = atomic$boolean$1(handled);
  }
  protoOf(CompletedExceptionally).po = function () {
    return this.oo_1.kotlinx$atomicfu$value;
  };
  protoOf(CompletedExceptionally).et = function () {
    return this.oo_1.atomicfu$compareAndSet(false, true);
  };
  protoOf(CompletedExceptionally).toString = function () {
    return get_classSimpleName(this) + '[' + this.no_1.toString() + ']';
  };
  function CancelledContinuation(continuation, cause, handled) {
    CompletedExceptionally.call(this, cause == null ? CancellationException_init_$Create$_0('Continuation ' + toString_1(continuation) + ' was cancelled normally') : cause, handled);
    this.it_1 = atomic$boolean$1(false);
  }
  protoOf(CancelledContinuation).jt = function () {
    return this.it_1.atomicfu$compareAndSet(false, true);
  };
  function toState(_this__u8e3s4, caller) {
    // Inline function 'kotlin.fold' call
    var exception = Result__exceptionOrNull_impl_p6xea9(_this__u8e3s4);
    var tmp;
    if (exception == null) {
      var tmp_0 = _Result___get_value__impl__bjfvqg(_this__u8e3s4);
      tmp = (tmp_0 == null ? true : !(tmp_0 == null)) ? tmp_0 : THROW_CCE();
    } else {
      tmp = new CompletedExceptionally(recoverStackTrace(exception, caller));
    }
    return tmp;
  }
  function toState_0(_this__u8e3s4, onCancellation) {
    onCancellation = onCancellation === VOID ? null : onCancellation;
    // Inline function 'kotlin.fold' call
    var exception = Result__exceptionOrNull_impl_p6xea9(_this__u8e3s4);
    var tmp;
    if (exception == null) {
      var tmp_0 = _Result___get_value__impl__bjfvqg(_this__u8e3s4);
      var it = (tmp_0 == null ? true : !(tmp_0 == null)) ? tmp_0 : THROW_CCE();
      tmp = !(onCancellation == null) ? new CompletedWithCancellation(it, onCancellation) : it;
    } else {
      tmp = new CompletedExceptionally(exception);
    }
    return tmp;
  }
  function CompletedWithCancellation(result, onCancellation) {
    this.tu_1 = result;
    this.uu_1 = onCancellation;
  }
  protoOf(CompletedWithCancellation).toString = function () {
    return 'CompletedWithCancellation(result=' + toString_0(this.tu_1) + ', onCancellation=' + toString_1(this.uu_1) + ')';
  };
  protoOf(CompletedWithCancellation).hashCode = function () {
    var result = this.tu_1 == null ? 0 : hashCode(this.tu_1);
    result = imul(result, 31) + hashCode(this.uu_1) | 0;
    return result;
  };
  protoOf(CompletedWithCancellation).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CompletedWithCancellation))
      return false;
    var tmp0_other_with_cast = other instanceof CompletedWithCancellation ? other : THROW_CCE();
    if (!equals(this.tu_1, tmp0_other_with_cast.tu_1))
      return false;
    if (!equals(this.uu_1, tmp0_other_with_cast.uu_1))
      return false;
    return true;
  };
  function CoroutineDispatcher$Key$_init_$lambda_akl8b5(it) {
    return it instanceof CoroutineDispatcher ? it : null;
  }
  function Key_0() {
    Key_instance_0 = this;
    var tmp = Key_instance;
    AbstractCoroutineContextKey.call(this, tmp, CoroutineDispatcher$Key$_init_$lambda_akl8b5);
  }
  var Key_instance_0;
  function Key_getInstance_0() {
    if (Key_instance_0 == null)
      new Key_0();
    return Key_instance_0;
  }
  function CoroutineDispatcher() {
    Key_getInstance_0();
    AbstractCoroutineContextElement.call(this, Key_instance);
  }
  protoOf(CoroutineDispatcher).wu = function (context) {
    return true;
  };
  protoOf(CoroutineDispatcher).yu = function (context, block) {
    return this.xu(context, block);
  };
  protoOf(CoroutineDispatcher).t9 = function (continuation) {
    return new DispatchedContinuation(this, continuation);
  };
  protoOf(CoroutineDispatcher).u9 = function (continuation) {
    var dispatched = continuation instanceof DispatchedContinuation ? continuation : THROW_CCE();
    dispatched.zu();
  };
  protoOf(CoroutineDispatcher).toString = function () {
    return get_classSimpleName(this) + '@' + get_hexAddress(this);
  };
  function handleCoroutineException(context, exception) {
    try {
      var tmp0_safe_receiver = context.s9(Key_instance_1);
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        tmp0_safe_receiver.av(context, exception);
        return Unit_instance;
      }
    } catch ($p) {
      if ($p instanceof Error) {
        var t = $p;
        handleUncaughtCoroutineException(context, handlerException(exception, t));
        return Unit_instance;
      } else {
        throw $p;
      }
    }
    handleUncaughtCoroutineException(context, exception);
  }
  function Key_1() {
  }
  var Key_instance_1;
  function Key_getInstance_1() {
    return Key_instance_1;
  }
  function handlerException(originalException, thrownException) {
    if (originalException === thrownException)
      return originalException;
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlinx.coroutines.addSuppressedThrowable' call
    return RuntimeException_init_$Create$_1('Exception while trying to handle coroutine exception', thrownException);
  }
  function Key_2() {
  }
  var Key_instance_2;
  function Key_getInstance_2() {
    return Key_instance_2;
  }
  function CoroutineName(name) {
    AbstractCoroutineContextElement.call(this, Key_instance_2);
    this.cv_1 = name;
  }
  protoOf(CoroutineName).toString = function () {
    return 'CoroutineName(' + this.cv_1 + ')';
  };
  protoOf(CoroutineName).hashCode = function () {
    return getStringHashCode(this.cv_1);
  };
  protoOf(CoroutineName).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CoroutineName))
      return false;
    var tmp0_other_with_cast = other instanceof CoroutineName ? other : THROW_CCE();
    if (!(this.cv_1 === tmp0_other_with_cast.cv_1))
      return false;
    return true;
  };
  function CoroutineScope() {
  }
  function CoroutineScope_0(context) {
    return new ContextScope(!(context.s9(Key_instance_3) == null) ? context : context.wi(Job_0()));
  }
  function coroutineScope(block, $completion) {
    // Inline function 'kotlin.contracts.contract' call
    var coroutine = new ScopeCoroutine($completion.l9(), $completion);
    return startUndispatchedOrReturn(coroutine, coroutine, block);
  }
  function cancel(_this__u8e3s4, cause) {
    cause = cause === VOID ? null : cause;
    var tmp0_elvis_lhs = _this__u8e3s4.ho().s9(Key_instance_3);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var message = 'Scope cannot be cancelled because it does not have a job: ' + toString_1(_this__u8e3s4);
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var job = tmp;
    job.rp(cause);
  }
  function get_isActive(_this__u8e3s4) {
    var tmp0_safe_receiver = _this__u8e3s4.ho().s9(Key_instance_3);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.io();
    return tmp1_elvis_lhs == null ? true : tmp1_elvis_lhs;
  }
  function cancel_0(_this__u8e3s4, message, cause) {
    cause = cause === VOID ? null : cause;
    return cancel(_this__u8e3s4, CancellationException_init_$Create$_1(message, cause));
  }
  function GlobalScope() {
  }
  protoOf(GlobalScope).ho = function () {
    return EmptyCoroutineContext_instance;
  };
  var GlobalScope_instance;
  function GlobalScope_getInstance() {
    return GlobalScope_instance;
  }
  var CoroutineStart_DEFAULT_instance;
  var CoroutineStart_LAZY_instance;
  var CoroutineStart_ATOMIC_instance;
  var CoroutineStart_UNDISPATCHED_instance;
  var CoroutineStart_entriesInitialized;
  function CoroutineStart_initEntries() {
    if (CoroutineStart_entriesInitialized)
      return Unit_instance;
    CoroutineStart_entriesInitialized = true;
    CoroutineStart_DEFAULT_instance = new CoroutineStart('DEFAULT', 0);
    CoroutineStart_LAZY_instance = new CoroutineStart('LAZY', 1);
    CoroutineStart_ATOMIC_instance = new CoroutineStart('ATOMIC', 2);
    CoroutineStart_UNDISPATCHED_instance = new CoroutineStart('UNDISPATCHED', 3);
  }
  function CoroutineStart(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  protoOf(CoroutineStart).yo = function (block, receiver, completion) {
    var tmp;
    switch (this.x2_1) {
      case 0:
        startCoroutineCancellable(block, receiver, completion);
        tmp = Unit_instance;
        break;
      case 2:
        startCoroutine(block, receiver, completion);
        tmp = Unit_instance;
        break;
      case 3:
        startCoroutineUndispatched(block, receiver, completion);
        tmp = Unit_instance;
        break;
      case 1:
        tmp = Unit_instance;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  };
  protoOf(CoroutineStart).iq = function () {
    return this === CoroutineStart_LAZY_getInstance();
  };
  function CoroutineStart_DEFAULT_getInstance() {
    CoroutineStart_initEntries();
    return CoroutineStart_DEFAULT_instance;
  }
  function CoroutineStart_LAZY_getInstance() {
    CoroutineStart_initEntries();
    return CoroutineStart_LAZY_instance;
  }
  function CoroutineStart_ATOMIC_getInstance() {
    CoroutineStart_initEntries();
    return CoroutineStart_ATOMIC_instance;
  }
  function CoroutineStart_UNDISPATCHED_getInstance() {
    CoroutineStart_initEntries();
    return CoroutineStart_UNDISPATCHED_instance;
  }
  function delay(duration, $completion) {
    return delay_0(toDelayMillis(duration), $completion);
  }
  function delay_0(timeMillis, $completion) {
    if (timeMillis <= 0n)
      return Unit_instance;
    var cancellable = new CancellableContinuationImpl(intercepted($completion), 1);
    cancellable.mt();
    if (timeMillis < 9223372036854775807n) {
      get_delay(cancellable.l9()).dv(timeMillis, cancellable);
    }
    return cancellable.tt();
  }
  function Delay() {
  }
  function toDelayMillis(_this__u8e3s4) {
    return Duration__compareTo_impl_pchp0f(_this__u8e3s4, Companion_getInstance_16().qe_1) > 0 ? coerceAtLeast_0(_Duration___get_inWholeMilliseconds__impl__msfiry(_this__u8e3s4), 1n) : 0n;
  }
  function get_delay(_this__u8e3s4) {
    var tmp = _this__u8e3s4.s9(Key_instance);
    var tmp0_elvis_lhs = (!(tmp == null) ? isInterface(tmp, Delay) : false) ? tmp : null;
    return tmp0_elvis_lhs == null ? get_DefaultDelay() : tmp0_elvis_lhs;
  }
  function DelayWithTimeoutDiagnostics() {
  }
  function delta($this, unconfined) {
    return unconfined ? 4294967296n : 1n;
  }
  function EventLoop() {
    CoroutineDispatcher.call(this);
    this.hv_1 = 0n;
    this.iv_1 = false;
    this.jv_1 = null;
  }
  protoOf(EventLoop).kv = function () {
    var tmp0_elvis_lhs = this.jv_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var queue = tmp;
    var tmp1_elvis_lhs = queue.rf();
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      return false;
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    var task = tmp_0;
    task.au();
    return true;
  };
  protoOf(EventLoop).lv = function (task) {
    var tmp0_elvis_lhs = this.jv_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.also' call
      var this_0 = ArrayDeque_init_$Create$();
      this.jv_1 = this_0;
      tmp = this_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var queue = tmp;
    queue.pf(task);
  };
  protoOf(EventLoop).mv = function () {
    return this.hv_1 >= delta(this, true);
  };
  protoOf(EventLoop).nv = function () {
    var tmp0_safe_receiver = this.jv_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.s();
    return tmp1_elvis_lhs == null ? true : tmp1_elvis_lhs;
  };
  protoOf(EventLoop).ov = function (unconfined) {
    this.hv_1 = add_2(this.hv_1, delta(this, unconfined));
    if (!unconfined)
      this.iv_1 = true;
  };
  protoOf(EventLoop).pv = function (unconfined) {
    this.hv_1 = subtract_1(this.hv_1, delta(this, unconfined));
    if (this.hv_1 > 0n)
      return Unit_instance;
    // Inline function 'kotlinx.coroutines.assert' call
    if (this.iv_1) {
      this.qv();
    }
  };
  protoOf(EventLoop).qv = function () {
  };
  function ThreadLocalEventLoop() {
    ThreadLocalEventLoop_instance = this;
    this.rv_1 = commonThreadLocal(new Symbol_0('ThreadLocalEventLoop'));
  }
  protoOf(ThreadLocalEventLoop).sv = function () {
    var tmp0_elvis_lhs = this.rv_1.uv();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.also' call
      var this_0 = createEventLoop();
      ThreadLocalEventLoop_getInstance().rv_1.vv(this_0);
      tmp = this_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  var ThreadLocalEventLoop_instance;
  function ThreadLocalEventLoop_getInstance() {
    if (ThreadLocalEventLoop_instance == null)
      new ThreadLocalEventLoop();
    return ThreadLocalEventLoop_instance;
  }
  function CompletionHandlerException(message, cause) {
    RuntimeException_init_$Init$_1(message, cause, this);
    captureStack(this, CompletionHandlerException);
  }
  function CoroutinesInternalError(message, cause) {
    Error_init_$Init$_1(message, cause, this);
    captureStack(this, CoroutinesInternalError);
  }
  function Key_3() {
  }
  var Key_instance_3;
  function Key_getInstance_3() {
    return Key_instance_3;
  }
  function Job() {
  }
  function Job_0(parent) {
    parent = parent === VOID ? null : parent;
    return new JobImpl(parent);
  }
  function cancel_1(_this__u8e3s4, cause) {
    cause = cause === VOID ? null : cause;
    var tmp0_safe_receiver = _this__u8e3s4.s9(Key_instance_3);
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.rp(cause);
    }
  }
  function cancel_2(_this__u8e3s4, message, cause) {
    cause = cause === VOID ? null : cause;
    return _this__u8e3s4.rp(CancellationException_init_$Create$_1(message, cause));
  }
  function get_job(_this__u8e3s4) {
    var tmp0_elvis_lhs = _this__u8e3s4.s9(Key_instance_3);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var message = "Current context doesn't contain Job in it: " + toString_1(_this__u8e3s4);
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function DisposableHandle() {
  }
  function ChildHandle() {
  }
  function get_isActive_0(_this__u8e3s4) {
    var tmp0_safe_receiver = _this__u8e3s4.s9(Key_instance_3);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.io();
    return tmp1_elvis_lhs == null ? true : tmp1_elvis_lhs;
  }
  function ensureActive(_this__u8e3s4) {
    var tmp0_safe_receiver = _this__u8e3s4.s9(Key_instance_3);
    if (tmp0_safe_receiver == null)
      null;
    else {
      ensureActive_0(tmp0_safe_receiver);
    }
  }
  function NonDisposableHandle() {
  }
  protoOf(NonDisposableHandle).bp = function () {
    return null;
  };
  protoOf(NonDisposableHandle).zr = function () {
  };
  protoOf(NonDisposableHandle).vp = function (cause) {
    return false;
  };
  protoOf(NonDisposableHandle).toString = function () {
    return 'NonDisposableHandle';
  };
  var NonDisposableHandle_instance;
  function NonDisposableHandle_getInstance() {
    return NonDisposableHandle_instance;
  }
  function ParentJob() {
  }
  function ensureActive_0(_this__u8e3s4) {
    if (!_this__u8e3s4.io())
      throw _this__u8e3s4.hp();
  }
  function disposeOnCompletion(_this__u8e3s4, handle) {
    // Inline function 'kotlinx.coroutines.asHandler' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = new DisposeOnCompletion(handle);
    return _this__u8e3s4.kp(tmp$ret$1);
  }
  function get_COMPLETING_ALREADY() {
    _init_properties_JobSupport_kt__68f172();
    return COMPLETING_ALREADY;
  }
  var COMPLETING_ALREADY;
  function get_COMPLETING_WAITING_CHILDREN() {
    _init_properties_JobSupport_kt__68f172();
    return COMPLETING_WAITING_CHILDREN;
  }
  var COMPLETING_WAITING_CHILDREN;
  function get_COMPLETING_RETRY() {
    _init_properties_JobSupport_kt__68f172();
    return COMPLETING_RETRY;
  }
  var COMPLETING_RETRY;
  function get_TOO_LATE_TO_CANCEL() {
    _init_properties_JobSupport_kt__68f172();
    return TOO_LATE_TO_CANCEL;
  }
  var TOO_LATE_TO_CANCEL;
  function get_SEALED() {
    _init_properties_JobSupport_kt__68f172();
    return SEALED;
  }
  var SEALED;
  function get_EMPTY_NEW() {
    _init_properties_JobSupport_kt__68f172();
    return EMPTY_NEW;
  }
  var EMPTY_NEW;
  function get_EMPTY_ACTIVE() {
    _init_properties_JobSupport_kt__68f172();
    return EMPTY_ACTIVE;
  }
  var EMPTY_ACTIVE;
  function unboxState(_this__u8e3s4) {
    _init_properties_JobSupport_kt__68f172();
    var tmp0_safe_receiver = _this__u8e3s4 instanceof IncompleteStateBox ? _this__u8e3s4 : null;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.wv_1;
    return tmp1_elvis_lhs == null ? _this__u8e3s4 : tmp1_elvis_lhs;
  }
  function ChildContinuation(child) {
    JobCancellingNode.call(this);
    this.bw_1 = child;
  }
  protoOf(ChildContinuation).yr = function (cause) {
    this.bw_1.rt(this.bw_1.st(this.gw()));
  };
  protoOf(ChildContinuation).invoke = function (cause) {
    return this.yr(cause);
  };
  function _set_exceptionsHolder__tqm22h($this, value) {
    $this.sw_1.kotlinx$atomicfu$value = value;
  }
  function _get_exceptionsHolder__nhszp($this) {
    return $this.sw_1.kotlinx$atomicfu$value;
  }
  function allocateList($this) {
    return ArrayList_init_$Create$_0(4);
  }
  function finalizeFinishingState($this, state, proposedUpdate) {
    // Inline function 'kotlinx.coroutines.assert' call
    // Inline function 'kotlinx.coroutines.assert' call
    // Inline function 'kotlinx.coroutines.assert' call
    var tmp0_safe_receiver = proposedUpdate instanceof CompletedExceptionally ? proposedUpdate : null;
    var proposedException = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.no_1;
    var wasCancelling;
    // Inline function 'kotlinx.coroutines.internal.synchronized' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlinx.coroutines.internal.synchronizedImpl' call
    wasCancelling = state.tw();
    var exceptions = state.uw(proposedException);
    var finalCause = getFinalRootCause($this, state, exceptions);
    if (!(finalCause == null)) {
      addSuppressedExceptions($this, finalCause, exceptions);
    }
    var finalException = finalCause;
    var finalState = finalException == null ? proposedUpdate : finalException === proposedException ? proposedUpdate : new CompletedExceptionally(finalException);
    if (!(finalException == null)) {
      var handled = cancelParent($this, finalException) || $this.dq(finalException);
      if (handled) {
        (finalState instanceof CompletedExceptionally ? finalState : THROW_CCE()).et();
      }
    }
    if (!wasCancelling) {
      $this.aq(finalException);
    }
    $this.mo(finalState);
    var casSuccess = $this.bo_1.atomicfu$compareAndSet(state, boxIncomplete(finalState));
    // Inline function 'kotlinx.coroutines.assert' call
    completeStateFinalization($this, state, finalState);
    return finalState;
  }
  function getFinalRootCause($this, state, exceptions) {
    if (exceptions.s()) {
      if (state.tw()) {
        // Inline function 'kotlinx.coroutines.JobSupport.defaultCancellationException' call
        return new JobCancellationException(null == null ? $this.lo() : null, null, $this);
      }
      return null;
    }
    var tmp$ret$2;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var _iterator__ex2g4s = exceptions.m();
      while (_iterator__ex2g4s.n()) {
        var element = _iterator__ex2g4s.o();
        if (!(element instanceof CancellationException)) {
          tmp$ret$2 = element;
          break $l$block;
        }
      }
      tmp$ret$2 = null;
    }
    var firstNonCancellation = tmp$ret$2;
    if (!(firstNonCancellation == null))
      return firstNonCancellation;
    var first = exceptions.r(0);
    if (first instanceof TimeoutCancellationException) {
      var tmp$ret$4;
      $l$block_0: {
        // Inline function 'kotlin.collections.firstOrNull' call
        var _iterator__ex2g4s_0 = exceptions.m();
        while (_iterator__ex2g4s_0.n()) {
          var element_0 = _iterator__ex2g4s_0.o();
          var tmp;
          if (!(element_0 === first)) {
            tmp = element_0 instanceof TimeoutCancellationException;
          } else {
            tmp = false;
          }
          if (tmp) {
            tmp$ret$4 = element_0;
            break $l$block_0;
          }
        }
        tmp$ret$4 = null;
      }
      var detailedTimeoutException = tmp$ret$4;
      if (!(detailedTimeoutException == null))
        return detailedTimeoutException;
    }
    return first;
  }
  function addSuppressedExceptions($this, rootCause, exceptions) {
    if (exceptions.p() <= 1)
      return Unit_instance;
    var seenExceptions = identitySet(exceptions.p());
    var unwrappedCause = unwrap(rootCause);
    var tmp0_iterator = exceptions.m();
    while (tmp0_iterator.n()) {
      var exception = tmp0_iterator.o();
      var unwrapped = unwrap(exception);
      var tmp;
      var tmp_0;
      if (!(unwrapped === rootCause) && !(unwrapped === unwrappedCause)) {
        tmp_0 = !(unwrapped instanceof CancellationException);
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        tmp = seenExceptions.j(unwrapped);
      } else {
        tmp = false;
      }
      if (tmp) {
        // Inline function 'kotlinx.coroutines.addSuppressedThrowable' call
      }
    }
  }
  function tryFinalizeSimpleState($this, state, update) {
    // Inline function 'kotlinx.coroutines.assert' call
    // Inline function 'kotlinx.coroutines.assert' call
    if (!$this.bo_1.atomicfu$compareAndSet(state, boxIncomplete(update)))
      return false;
    $this.aq(null);
    $this.mo(update);
    completeStateFinalization($this, state, update);
    return true;
  }
  function completeStateFinalization($this, state, update) {
    var tmp0_safe_receiver = $this.ap();
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      tmp0_safe_receiver.zr();
      $this.zo(NonDisposableHandle_instance);
    }
    var tmp1_safe_receiver = update instanceof CompletedExceptionally ? update : null;
    var cause = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.no_1;
    if (state instanceof JobNode) {
      try {
        state.invoke(cause);
      } catch ($p) {
        if ($p instanceof Error) {
          var ex = $p;
          $this.to(new CompletionHandlerException('Exception in completion handler ' + toString_1(state) + ' for ' + $this.toString(), ex));
        } else {
          throw $p;
        }
      }
    } else {
      var tmp2_safe_receiver = state.hw();
      if (tmp2_safe_receiver == null)
        null;
      else {
        notifyCompletion($this, tmp2_safe_receiver, cause);
      }
    }
  }
  function notifyCancelling($this, list, cause) {
    $this.aq(cause);
    // Inline function 'kotlinx.coroutines.JobSupport.notifyHandlers' call
    var exception = null;
    // Inline function 'kotlinx.coroutines.internal.LinkedListHead.forEach' call
    var cur = list.iw_1;
    while (!equals(cur, list)) {
      if (cur instanceof JobCancellingNode) {
        var node = cur;
        try {
          node.invoke(cause);
        } catch ($p) {
          if ($p instanceof Error) {
            var ex = $p;
            var tmp0_safe_receiver = exception;
            var tmp;
            if (tmp0_safe_receiver == null) {
              tmp = null;
            } else {
              // Inline function 'kotlin.apply' call
              // Inline function 'kotlinx.coroutines.addSuppressedThrowable' call
              tmp = tmp0_safe_receiver;
            }
            if (tmp == null) {
              // Inline function 'kotlin.run' call
              exception = new CompletionHandlerException('Exception in completion handler ' + node.toString() + ' for ' + $this.toString(), ex);
            }
          } else {
            throw $p;
          }
        }
      }
      cur = cur.iw_1;
    }
    var tmp0_safe_receiver_0 = exception;
    if (tmp0_safe_receiver_0 == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      $this.to(tmp0_safe_receiver_0);
    }
    cancelParent($this, cause);
  }
  function cancelParent($this, cause) {
    if ($this.bq())
      return true;
    var isCancellation = cause instanceof CancellationException;
    var parent = $this.ap();
    if (parent === null || parent === NonDisposableHandle_instance) {
      return isCancellation;
    }
    return parent.vp(cause) || isCancellation;
  }
  function notifyCompletion($this, _this__u8e3s4, cause) {
    // Inline function 'kotlinx.coroutines.JobSupport.notifyHandlers' call
    var exception = null;
    // Inline function 'kotlinx.coroutines.internal.LinkedListHead.forEach' call
    var cur = _this__u8e3s4.iw_1;
    while (!equals(cur, _this__u8e3s4)) {
      if (cur instanceof JobNode) {
        var node = cur;
        try {
          node.invoke(cause);
        } catch ($p) {
          if ($p instanceof Error) {
            var ex = $p;
            var tmp0_safe_receiver = exception;
            var tmp;
            if (tmp0_safe_receiver == null) {
              tmp = null;
            } else {
              // Inline function 'kotlin.apply' call
              // Inline function 'kotlinx.coroutines.addSuppressedThrowable' call
              tmp = tmp0_safe_receiver;
            }
            if (tmp == null) {
              // Inline function 'kotlin.run' call
              exception = new CompletionHandlerException('Exception in completion handler ' + node.toString() + ' for ' + $this.toString(), ex);
            }
          } else {
            throw $p;
          }
        }
      }
      cur = cur.iw_1;
    }
    var tmp0_safe_receiver_0 = exception;
    if (tmp0_safe_receiver_0 == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      $this.to(tmp0_safe_receiver_0);
    }
    return Unit_instance;
  }
  function startInternal($this, state) {
    if (state instanceof Empty) {
      if (state.ww_1)
        return 0;
      if (!$this.bo_1.atomicfu$compareAndSet(state, get_EMPTY_ACTIVE()))
        return -1;
      $this.gp();
      return 1;
    } else {
      if (state instanceof InactiveNodeList) {
        if (!$this.bo_1.atomicfu$compareAndSet(state, state.vw_1))
          return -1;
        $this.gp();
        return 1;
      } else {
        return 0;
      }
    }
  }
  function makeNode($this, handler, onCancelling) {
    var tmp;
    if (onCancelling) {
      var tmp0_elvis_lhs = handler instanceof JobCancellingNode ? handler : null;
      tmp = tmp0_elvis_lhs == null ? new InvokeOnCancelling(handler) : tmp0_elvis_lhs;
    } else {
      var tmp1_safe_receiver = handler instanceof JobNode ? handler : null;
      var tmp_0;
      if (tmp1_safe_receiver == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlin.also' call
        // Inline function 'kotlinx.coroutines.assert' call
        tmp_0 = tmp1_safe_receiver;
      }
      var tmp2_elvis_lhs = tmp_0;
      tmp = tmp2_elvis_lhs == null ? new InvokeOnCompletion(handler) : tmp2_elvis_lhs;
    }
    var node = tmp;
    node.fw_1 = $this;
    return node;
  }
  function addLastAtomic($this, expect, list, node) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlinx.coroutines.internal.LinkedListNode.addLastIf' call
      if (!($this.cp() === expect)) {
        tmp$ret$1 = false;
        break $l$block;
      }
      list.lw(node);
      tmp$ret$1 = true;
    }
    return tmp$ret$1;
  }
  function promoteEmptyToNodeList($this, state) {
    var list = new NodeList();
    var update = state.ww_1 ? list : new InactiveNodeList(list);
    $this.bo_1.atomicfu$compareAndSet(state, update);
  }
  function promoteSingleToNodeList($this, state) {
    state.ow(new NodeList());
    // Inline function 'kotlinx.coroutines.internal.LinkedListNode.nextNode' call
    var list = state.iw_1;
    $this.bo_1.atomicfu$compareAndSet(state, list);
  }
  function joinInternal($this) {
    // Inline function 'kotlinx.coroutines.JobSupport.loopOnState' call
    while (true) {
      var state = $this.cp();
      if (!(!(state == null) ? isInterface(state, Incomplete) : false))
        return false;
      if (startInternal($this, state) >= 0)
        return true;
    }
  }
  function joinSuspend($this, $completion) {
    var cancellable = new CancellableContinuationImpl(intercepted($completion), 1);
    cancellable.mt();
    // Inline function 'kotlinx.coroutines.asHandler' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = new ResumeOnCompletion(cancellable);
    disposeOnCancellation(cancellable, $this.kp(tmp$ret$1));
    return cancellable.tt();
  }
  function registerSelectForOnJoin($this, select, ignoredParam) {
    if (!joinInternal($this)) {
      select.xw(Unit_instance);
      return Unit_instance;
    }
    // Inline function 'kotlinx.coroutines.asHandler' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = new SelectOnJoinCompletionHandler($this, select);
    var disposableHandle = $this.kp(tmp$ret$1);
    select.yw(disposableHandle);
  }
  function SelectOnJoinCompletionHandler($outer, select) {
    this.ex_1 = $outer;
    JobNode.call(this);
    this.dx_1 = select;
  }
  protoOf(SelectOnJoinCompletionHandler).yr = function (cause) {
    this.dx_1.fx(this.ex_1, Unit_instance);
  };
  protoOf(SelectOnJoinCompletionHandler).invoke = function (cause) {
    return this.yr(cause);
  };
  function cancelMakeCompleting($this, cause) {
    // Inline function 'kotlinx.coroutines.JobSupport.loopOnState' call
    while (true) {
      var state = $this.cp();
      var tmp;
      if (!(!(state == null) ? isInterface(state, Incomplete) : false)) {
        tmp = true;
      } else {
        var tmp_0;
        if (state instanceof Finishing) {
          tmp_0 = state.gx();
        } else {
          tmp_0 = false;
        }
        tmp = tmp_0;
      }
      if (tmp) {
        return get_COMPLETING_ALREADY();
      }
      var proposedUpdate = new CompletedExceptionally(createCauseException($this, cause));
      var finalState = tryMakeCompleting($this, state, proposedUpdate);
      if (!(finalState === get_COMPLETING_RETRY()))
        return finalState;
    }
  }
  function createCauseException($this, cause) {
    var tmp;
    if (cause == null ? true : cause instanceof Error) {
      var tmp_0;
      if (cause == null) {
        // Inline function 'kotlinx.coroutines.JobSupport.defaultCancellationException' call
        tmp_0 = new JobCancellationException(null == null ? $this.lo() : null, null, $this);
      } else {
        tmp_0 = cause;
      }
      tmp = tmp_0;
    } else {
      tmp = ((!(cause == null) ? isInterface(cause, ParentJob) : false) ? cause : THROW_CCE()).yp();
    }
    return tmp;
  }
  function makeCancelling($this, cause) {
    var causeExceptionCache = null;
    // Inline function 'kotlinx.coroutines.JobSupport.loopOnState' call
    while (true) {
      var tmp0 = $this.cp();
      $l$block: {
        if (tmp0 instanceof Finishing) {
          // Inline function 'kotlinx.coroutines.internal.synchronized' call
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'kotlinx.coroutines.internal.synchronizedImpl' call
          if (tmp0.hx())
            return get_TOO_LATE_TO_CANCEL();
          var wasCancelling = tmp0.tw();
          if (!(cause == null) || !wasCancelling) {
            var tmp0_elvis_lhs = causeExceptionCache;
            var tmp;
            if (tmp0_elvis_lhs == null) {
              // Inline function 'kotlin.also' call
              var this_0 = createCauseException($this, cause);
              causeExceptionCache = this_0;
              tmp = this_0;
            } else {
              tmp = tmp0_elvis_lhs;
            }
            var causeException = tmp;
            tmp0.ix(causeException);
          }
          // Inline function 'kotlin.takeIf' call
          var this_1 = tmp0.jx();
          var tmp_0;
          if (!wasCancelling) {
            tmp_0 = this_1;
          } else {
            tmp_0 = null;
          }
          var notifyRootCause = tmp_0;
          if (notifyRootCause == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            notifyCancelling($this, tmp0.pw_1, notifyRootCause);
          }
          return get_COMPLETING_ALREADY();
        } else {
          if (!(tmp0 == null) ? isInterface(tmp0, Incomplete) : false) {
            var tmp2_elvis_lhs = causeExceptionCache;
            var tmp_1;
            if (tmp2_elvis_lhs == null) {
              // Inline function 'kotlin.also' call
              var this_2 = createCauseException($this, cause);
              causeExceptionCache = this_2;
              tmp_1 = this_2;
            } else {
              tmp_1 = tmp2_elvis_lhs;
            }
            var causeException_0 = tmp_1;
            if (tmp0.io()) {
              if (tryMakeCancelling($this, tmp0, causeException_0))
                return get_COMPLETING_ALREADY();
            } else {
              var finalState = tryMakeCompleting($this, tmp0, new CompletedExceptionally(causeException_0));
              if (finalState === get_COMPLETING_ALREADY()) {
                // Inline function 'kotlin.error' call
                var message = 'Cannot happen in ' + toString_0(tmp0);
                throw IllegalStateException_init_$Create$_0(toString_1(message));
              } else if (finalState === get_COMPLETING_RETRY()) {
                break $l$block;
              } else
                return finalState;
            }
          } else {
            return get_TOO_LATE_TO_CANCEL();
          }
        }
      }
    }
  }
  function getOrPromoteCancellingList($this, state) {
    var tmp1_elvis_lhs = state.hw();
    var tmp;
    if (tmp1_elvis_lhs == null) {
      var tmp_0;
      if (state instanceof Empty) {
        tmp_0 = new NodeList();
      } else {
        if (state instanceof JobNode) {
          promoteSingleToNodeList($this, state);
          tmp_0 = null;
        } else {
          var message = 'State should have list: ' + toString_1(state);
          throw IllegalStateException_init_$Create$_0(toString_1(message));
        }
      }
      tmp = tmp_0;
    } else {
      tmp = tmp1_elvis_lhs;
    }
    return tmp;
  }
  function tryMakeCancelling($this, state, rootCause) {
    // Inline function 'kotlinx.coroutines.assert' call
    // Inline function 'kotlinx.coroutines.assert' call
    var tmp0_elvis_lhs = getOrPromoteCancellingList($this, state);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var list = tmp;
    var cancelling = new Finishing(list, false, rootCause);
    if (!$this.bo_1.atomicfu$compareAndSet(state, cancelling))
      return false;
    notifyCancelling($this, list, rootCause);
    return true;
  }
  function tryMakeCompleting($this, state, proposedUpdate) {
    if (!(!(state == null) ? isInterface(state, Incomplete) : false))
      return get_COMPLETING_ALREADY();
    var tmp;
    var tmp_0;
    var tmp_1;
    if (state instanceof Empty) {
      tmp_1 = true;
    } else {
      tmp_1 = state instanceof JobNode;
    }
    if (tmp_1) {
      tmp_0 = !(state instanceof ChildHandleNode);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = !(proposedUpdate instanceof CompletedExceptionally);
    } else {
      tmp = false;
    }
    if (tmp) {
      if (tryFinalizeSimpleState($this, state, proposedUpdate)) {
        return proposedUpdate;
      }
      return get_COMPLETING_RETRY();
    }
    return tryMakeCompletingSlowPath($this, state, proposedUpdate);
  }
  function tryMakeCompletingSlowPath($this, state, proposedUpdate) {
    var tmp0_elvis_lhs = getOrPromoteCancellingList($this, state);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return get_COMPLETING_RETRY();
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var list = tmp;
    var tmp1_elvis_lhs = state instanceof Finishing ? state : null;
    var finishing = tmp1_elvis_lhs == null ? new Finishing(list, false, null) : tmp1_elvis_lhs;
    var notifyRootCause = null;
    // Inline function 'kotlinx.coroutines.internal.synchronized' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlinx.coroutines.internal.synchronizedImpl' call
    if (finishing.gx())
      return get_COMPLETING_ALREADY();
    finishing.kx(true);
    if (!(finishing === state)) {
      if (!$this.bo_1.atomicfu$compareAndSet(state, finishing))
        return get_COMPLETING_RETRY();
    }
    // Inline function 'kotlinx.coroutines.assert' call
    var wasCancelling = finishing.tw();
    var tmp0_safe_receiver = proposedUpdate instanceof CompletedExceptionally ? proposedUpdate : null;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      finishing.ix(tmp0_safe_receiver.no_1);
    }
    // Inline function 'kotlin.takeIf' call
    var this_0 = finishing.jx();
    var tmp_0;
    if (!wasCancelling) {
      tmp_0 = this_0;
    } else {
      tmp_0 = null;
    }
    notifyRootCause = tmp_0;
    var tmp2_safe_receiver = notifyRootCause;
    if (tmp2_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      notifyCancelling($this, list, tmp2_safe_receiver);
    }
    var child = firstChild($this, state);
    if (!(child == null) && tryWaitForChild($this, finishing, child, proposedUpdate))
      return get_COMPLETING_WAITING_CHILDREN();
    return finalizeFinishingState($this, finishing, proposedUpdate);
  }
  function _get_exceptionOrNull__b3j7js($this, _this__u8e3s4) {
    var tmp0_safe_receiver = _this__u8e3s4 instanceof CompletedExceptionally ? _this__u8e3s4 : null;
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.no_1;
  }
  function firstChild($this, state) {
    var tmp1_elvis_lhs = state instanceof ChildHandleNode ? state : null;
    var tmp;
    if (tmp1_elvis_lhs == null) {
      var tmp0_safe_receiver = state.hw();
      tmp = tmp0_safe_receiver == null ? null : nextChild($this, tmp0_safe_receiver);
    } else {
      tmp = tmp1_elvis_lhs;
    }
    return tmp;
  }
  function tryWaitForChild($this, state, child, proposedUpdate) {
    var $this_0 = $this;
    var state_0 = state;
    var child_0 = child;
    var proposedUpdate_0 = proposedUpdate;
    $l$1: do {
      $l$0: do {
        var tmp = child_0.px_1;
        // Inline function 'kotlinx.coroutines.asHandler' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$1 = new ChildCompletion($this_0, state_0, child_0, proposedUpdate_0);
        var handle = tmp.mp(VOID, false, tmp$ret$1);
        if (!(handle === NonDisposableHandle_instance))
          return true;
        var tmp0_elvis_lhs = nextChild($this_0, child_0);
        var tmp_0;
        if (tmp0_elvis_lhs == null) {
          return false;
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        var nextChild_0 = tmp_0;
        var tmp0 = $this_0;
        var tmp1 = state_0;
        var tmp3 = proposedUpdate_0;
        $this_0 = tmp0;
        state_0 = tmp1;
        child_0 = nextChild_0;
        proposedUpdate_0 = tmp3;
        continue $l$0;
      }
       while (false);
    }
     while (true);
  }
  function continueCompleting($this, state, lastChild, proposedUpdate) {
    // Inline function 'kotlinx.coroutines.assert' call
    var waitChild = nextChild($this, lastChild);
    if (!(waitChild == null) && tryWaitForChild($this, state, waitChild, proposedUpdate))
      return Unit_instance;
    var finalState = finalizeFinishingState($this, state, proposedUpdate);
    $this.so(finalState);
  }
  function nextChild($this, _this__u8e3s4) {
    var cur = _this__u8e3s4;
    $l$loop: while (true) {
      // Inline function 'kotlinx.coroutines.internal.LinkedListNode.isRemoved' call
      if (!cur.kw_1) {
        break $l$loop;
      }
      // Inline function 'kotlinx.coroutines.internal.LinkedListNode.prevNode' call
      cur = cur.jw_1;
    }
    $l$loop_0: while (true) {
      // Inline function 'kotlinx.coroutines.internal.LinkedListNode.nextNode' call
      cur = cur.iw_1;
      // Inline function 'kotlinx.coroutines.internal.LinkedListNode.isRemoved' call
      if (cur.kw_1)
        continue $l$loop_0;
      if (cur instanceof ChildHandleNode)
        return cur;
      if (cur instanceof NodeList)
        return null;
    }
  }
  function stateString($this, state) {
    var tmp;
    if (state instanceof Finishing) {
      tmp = state.tw() ? 'Cancelling' : state.gx() ? 'Completing' : 'Active';
    } else {
      if (!(state == null) ? isInterface(state, Incomplete) : false) {
        tmp = state.io() ? 'Active' : 'New';
      } else {
        if (state instanceof CompletedExceptionally) {
          tmp = 'Cancelled';
        } else {
          tmp = 'Completed';
        }
      }
    }
    return tmp;
  }
  function Finishing(list, isCompleting, rootCause) {
    this.pw_1 = list;
    this.qw_1 = atomic$boolean$1(isCompleting);
    this.rw_1 = atomic$ref$1(rootCause);
    this.sw_1 = atomic$ref$1(null);
  }
  protoOf(Finishing).hw = function () {
    return this.pw_1;
  };
  protoOf(Finishing).kx = function (value) {
    this.qw_1.kotlinx$atomicfu$value = value;
  };
  protoOf(Finishing).gx = function () {
    return this.qw_1.kotlinx$atomicfu$value;
  };
  protoOf(Finishing).qx = function (value) {
    this.rw_1.kotlinx$atomicfu$value = value;
  };
  protoOf(Finishing).jx = function () {
    return this.rw_1.kotlinx$atomicfu$value;
  };
  protoOf(Finishing).hx = function () {
    return _get_exceptionsHolder__nhszp(this) === get_SEALED();
  };
  protoOf(Finishing).tw = function () {
    return !(this.jx() == null);
  };
  protoOf(Finishing).io = function () {
    return this.jx() == null;
  };
  protoOf(Finishing).uw = function (proposedException) {
    var eh = _get_exceptionsHolder__nhszp(this);
    var tmp;
    if (eh == null) {
      tmp = allocateList(this);
    } else {
      if (eh instanceof Error) {
        // Inline function 'kotlin.also' call
        var this_0 = allocateList(this);
        this_0.j(eh);
        tmp = this_0;
      } else {
        if (eh instanceof ArrayList) {
          tmp = eh instanceof ArrayList ? eh : THROW_CCE();
        } else {
          var message = 'State is ' + toString_0(eh);
          throw IllegalStateException_init_$Create$_0(toString_1(message));
        }
      }
    }
    var list = tmp;
    var rootCause = this.jx();
    if (rootCause == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      list.m2(0, rootCause);
    }
    if (!(proposedException == null) && !equals(proposedException, rootCause)) {
      list.j(proposedException);
    }
    _set_exceptionsHolder__tqm22h(this, get_SEALED());
    return list;
  };
  protoOf(Finishing).ix = function (exception) {
    var rootCause = this.jx();
    if (rootCause == null) {
      this.qx(exception);
      return Unit_instance;
    }
    if (exception === rootCause)
      return Unit_instance;
    var eh = _get_exceptionsHolder__nhszp(this);
    if (eh == null) {
      _set_exceptionsHolder__tqm22h(this, exception);
    } else {
      if (eh instanceof Error) {
        if (exception === eh)
          return Unit_instance;
        // Inline function 'kotlin.apply' call
        var this_0 = allocateList(this);
        this_0.j(eh);
        this_0.j(exception);
        _set_exceptionsHolder__tqm22h(this, this_0);
      } else {
        if (eh instanceof ArrayList) {
          (eh instanceof ArrayList ? eh : THROW_CCE()).j(exception);
        } else {
          // Inline function 'kotlin.error' call
          var message = 'State is ' + toString_0(eh);
          throw IllegalStateException_init_$Create$_0(toString_1(message));
        }
      }
    }
  };
  protoOf(Finishing).toString = function () {
    return 'Finishing[cancelling=' + this.tw() + ', completing=' + this.gx() + ', rootCause=' + toString_0(this.jx()) + ', exceptions=' + toString_0(_get_exceptionsHolder__nhszp(this)) + ', list=' + this.pw_1.toString() + ']';
  };
  function ChildCompletion(parent, state, child, proposedUpdate) {
    JobNode.call(this);
    this.vx_1 = parent;
    this.wx_1 = state;
    this.xx_1 = child;
    this.yx_1 = proposedUpdate;
  }
  protoOf(ChildCompletion).yr = function (cause) {
    continueCompleting(this.vx_1, this.wx_1, this.xx_1, this.yx_1);
  };
  protoOf(ChildCompletion).invoke = function (cause) {
    return this.yr(cause);
  };
  function AwaitContinuation(delegate, job) {
    CancellableContinuationImpl.call(this, delegate, 1);
    this.fy_1 = job;
  }
  protoOf(AwaitContinuation).st = function (parent) {
    var state = this.fy_1.cp();
    if (state instanceof Finishing) {
      var tmp0_safe_receiver = state.jx();
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        return tmp0_safe_receiver;
      }
    }
    if (state instanceof CompletedExceptionally)
      return state.no_1;
    return parent.hp();
  };
  protoOf(AwaitContinuation).zt = function () {
    return 'AwaitContinuation';
  };
  function awaitSuspend($this, $completion) {
    var cont = new AwaitContinuation(intercepted($completion), $this);
    cont.mt();
    // Inline function 'kotlinx.coroutines.asHandler' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = new ResumeAwaitOnCompletion(cont);
    disposeOnCancellation(cont, $this.kp(tmp$ret$1));
    return cont.tt();
  }
  function JobSupport$registerSelectForOnJoin$ref() {
    var l = function (p0, p1, p2) {
      registerSelectForOnJoin(p0, p1, p2);
      return Unit_instance;
    };
    l.callableName = 'registerSelectForOnJoin';
    return l;
  }
  function JobSupport(active) {
    this.bo_1 = atomic$ref$1(active ? get_EMPTY_ACTIVE() : get_EMPTY_NEW());
    this.co_1 = atomic$ref$1(null);
  }
  protoOf(JobSupport).z = function () {
    return Key_instance_3;
  };
  protoOf(JobSupport).zo = function (value) {
    this.co_1.kotlinx$atomicfu$value = value;
  };
  protoOf(JobSupport).ap = function () {
    return this.co_1.kotlinx$atomicfu$value;
  };
  protoOf(JobSupport).bp = function () {
    var tmp0_safe_receiver = this.ap();
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.bp();
  };
  protoOf(JobSupport).do = function (parent) {
    // Inline function 'kotlinx.coroutines.assert' call
    if (parent == null) {
      this.zo(NonDisposableHandle_instance);
      return Unit_instance;
    }
    parent.fp();
    var handle = parent.zp(this);
    this.zo(handle);
    if (this.dp()) {
      handle.zr();
      this.zo(NonDisposableHandle_instance);
    }
  };
  protoOf(JobSupport).cp = function () {
    // Inline function 'kotlinx.atomicfu.loop' call
    var this_0 = this.bo_1;
    while (true) {
      var state = this_0.kotlinx$atomicfu$value;
      if (!(state instanceof OpDescriptor))
        return state;
      state.gy(this);
    }
  };
  protoOf(JobSupport).io = function () {
    var state = this.cp();
    var tmp;
    if (!(state == null) ? isInterface(state, Incomplete) : false) {
      tmp = state.io();
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(JobSupport).dp = function () {
    var tmp = this.cp();
    return !(!(tmp == null) ? isInterface(tmp, Incomplete) : false);
  };
  protoOf(JobSupport).ep = function () {
    var state = this.cp();
    var tmp;
    if (state instanceof CompletedExceptionally) {
      tmp = true;
    } else {
      var tmp_0;
      if (state instanceof Finishing) {
        tmp_0 = state.tw();
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  protoOf(JobSupport).fp = function () {
    // Inline function 'kotlinx.coroutines.JobSupport.loopOnState' call
    while (true) {
      var state = this.cp();
      var tmp0_subject = startInternal(this, state);
      if (tmp0_subject === 0)
        return false;
      else if (tmp0_subject === 1)
        return true;
    }
  };
  protoOf(JobSupport).gp = function () {
  };
  protoOf(JobSupport).hp = function () {
    var state = this.cp();
    var tmp;
    if (state instanceof Finishing) {
      var tmp0_safe_receiver = state.jx();
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : this.ip(tmp0_safe_receiver, get_classSimpleName(this) + ' is cancelling');
      var tmp_0;
      if (tmp1_elvis_lhs == null) {
        var message = 'Job is still new or active: ' + this.toString();
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      } else {
        tmp_0 = tmp1_elvis_lhs;
      }
      tmp = tmp_0;
    } else {
      if (!(state == null) ? isInterface(state, Incomplete) : false) {
        var message_0 = 'Job is still new or active: ' + this.toString();
        throw IllegalStateException_init_$Create$_0(toString_1(message_0));
      } else {
        if (state instanceof CompletedExceptionally) {
          tmp = this.jp(state.no_1);
        } else {
          tmp = new JobCancellationException(get_classSimpleName(this) + ' has completed normally', null, this);
        }
      }
    }
    return tmp;
  };
  protoOf(JobSupport).ip = function (_this__u8e3s4, message) {
    var tmp0_elvis_lhs = _this__u8e3s4 instanceof CancellationException ? _this__u8e3s4 : null;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlinx.coroutines.JobSupport.defaultCancellationException' call
      tmp = new JobCancellationException(message == null ? this.lo() : message, _this__u8e3s4, this);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  protoOf(JobSupport).jp = function (_this__u8e3s4, message, $super) {
    message = message === VOID ? null : message;
    return $super === VOID ? this.ip(_this__u8e3s4, message) : $super.ip.call(this, _this__u8e3s4, message);
  };
  protoOf(JobSupport).kp = function (handler) {
    return this.lp(false, true, handler);
  };
  protoOf(JobSupport).lp = function (onCancelling, invokeImmediately, handler) {
    var node = makeNode(this, handler, onCancelling);
    // Inline function 'kotlinx.coroutines.JobSupport.loopOnState' call
    while (true) {
      var tmp0 = this.cp();
      $l$block: {
        if (tmp0 instanceof Empty) {
          if (tmp0.ww_1) {
            if (this.bo_1.atomicfu$compareAndSet(tmp0, node))
              return node;
          } else {
            promoteEmptyToNodeList(this, tmp0);
          }
        } else {
          if (!(tmp0 == null) ? isInterface(tmp0, Incomplete) : false) {
            var list = tmp0.hw();
            if (list == null) {
              promoteSingleToNodeList(this, tmp0 instanceof JobNode ? tmp0 : THROW_CCE());
            } else {
              var rootCause = null;
              var handle = NonDisposableHandle_instance;
              var tmp;
              if (onCancelling) {
                tmp = tmp0 instanceof Finishing;
              } else {
                tmp = false;
              }
              if (tmp) {
                // Inline function 'kotlinx.coroutines.internal.synchronized' call
                // Inline function 'kotlin.contracts.contract' call
                // Inline function 'kotlinx.coroutines.internal.synchronizedImpl' call
                rootCause = tmp0.jx();
                var tmp_0;
                if (rootCause == null) {
                  tmp_0 = true;
                } else {
                  var tmp_1;
                  // Inline function 'kotlinx.coroutines.isHandlerOf' call
                  if (handler instanceof ChildHandleNode) {
                    tmp_1 = !tmp0.gx();
                  } else {
                    tmp_1 = false;
                  }
                  tmp_0 = tmp_1;
                }
                if (tmp_0) {
                  if (!addLastAtomic(this, tmp0, list, node)) {
                    break $l$block;
                  }
                  if (rootCause == null)
                    return node;
                  handle = node;
                }
              }
              if (!(rootCause == null)) {
                if (invokeImmediately) {
                  invokeIt(handler, rootCause);
                }
                return handle;
              } else {
                if (addLastAtomic(this, tmp0, list, node))
                  return node;
              }
            }
          } else {
            if (invokeImmediately) {
              var tmp1_safe_receiver = tmp0 instanceof CompletedExceptionally ? tmp0 : null;
              invokeIt(handler, tmp1_safe_receiver == null ? null : tmp1_safe_receiver.no_1);
            }
            return NonDisposableHandle_instance;
          }
        }
      }
    }
  };
  protoOf(JobSupport).np = function ($completion) {
    if (!joinInternal(this)) {
      // Inline function 'kotlin.js.getCoroutineContext' call
      var tmp$ret$0 = $completion.l9();
      ensureActive(tmp$ret$0);
      return Unit_instance;
    }
    return joinSuspend(this, $completion);
  };
  protoOf(JobSupport).op = function () {
    var tmp = JobSupport$registerSelectForOnJoin$ref();
    return new SelectClause0Impl(this, typeof tmp === 'function' ? tmp : THROW_CCE());
  };
  protoOf(JobSupport).pp = function (node) {
    // Inline function 'kotlinx.coroutines.JobSupport.loopOnState' call
    while (true) {
      var state = this.cp();
      if (state instanceof JobNode) {
        if (!(state === node))
          return Unit_instance;
        if (this.bo_1.atomicfu$compareAndSet(state, get_EMPTY_ACTIVE()))
          return Unit_instance;
      } else {
        if (!(state == null) ? isInterface(state, Incomplete) : false) {
          if (!(state.hw() == null)) {
            node.mw();
          }
          return Unit_instance;
        } else {
          return Unit_instance;
        }
      }
    }
  };
  protoOf(JobSupport).qp = function () {
    return false;
  };
  protoOf(JobSupport).rp = function (cause) {
    var tmp;
    if (cause == null) {
      // Inline function 'kotlinx.coroutines.JobSupport.defaultCancellationException' call
      tmp = new JobCancellationException(null == null ? this.lo() : null, null, this);
    } else {
      tmp = cause;
    }
    this.tp(tmp);
  };
  protoOf(JobSupport).lo = function () {
    return 'Job was cancelled';
  };
  protoOf(JobSupport).tp = function (cause) {
    this.xp(cause);
  };
  protoOf(JobSupport).up = function (parentJob) {
    this.xp(parentJob);
  };
  protoOf(JobSupport).vp = function (cause) {
    if (cause instanceof CancellationException)
      return true;
    return this.xp(cause) && this.cq();
  };
  protoOf(JobSupport).wp = function (cause) {
    return this.xp(cause);
  };
  protoOf(JobSupport).xp = function (cause) {
    var finalState = get_COMPLETING_ALREADY();
    if (this.qp()) {
      finalState = cancelMakeCompleting(this, cause);
      if (finalState === get_COMPLETING_WAITING_CHILDREN())
        return true;
    }
    if (finalState === get_COMPLETING_ALREADY()) {
      finalState = makeCancelling(this, cause);
    }
    var tmp;
    if (finalState === get_COMPLETING_ALREADY()) {
      tmp = true;
    } else if (finalState === get_COMPLETING_WAITING_CHILDREN()) {
      tmp = true;
    } else if (finalState === get_TOO_LATE_TO_CANCEL()) {
      tmp = false;
    } else {
      this.so(finalState);
      tmp = true;
    }
    return tmp;
  };
  protoOf(JobSupport).yp = function () {
    var state = this.cp();
    var tmp;
    if (state instanceof Finishing) {
      tmp = state.jx();
    } else {
      if (state instanceof CompletedExceptionally) {
        tmp = state.no_1;
      } else {
        if (!(state == null) ? isInterface(state, Incomplete) : false) {
          var message = 'Cannot be cancelling child in this state: ' + toString_0(state);
          throw IllegalStateException_init_$Create$_0(toString_1(message));
        } else {
          tmp = null;
        }
      }
    }
    var rootCause = tmp;
    var tmp1_elvis_lhs = rootCause instanceof CancellationException ? rootCause : null;
    return tmp1_elvis_lhs == null ? new JobCancellationException('Parent job is ' + stateString(this, state), rootCause, this) : tmp1_elvis_lhs;
  };
  protoOf(JobSupport).qu = function (proposedUpdate) {
    // Inline function 'kotlinx.coroutines.JobSupport.loopOnState' call
    while (true) {
      var tmp0 = this.cp();
      $l$block: {
        var finalState = tryMakeCompleting(this, tmp0, proposedUpdate);
        if (finalState === get_COMPLETING_ALREADY())
          return false;
        else if (finalState === get_COMPLETING_WAITING_CHILDREN())
          return true;
        else if (finalState === get_COMPLETING_RETRY()) {
          break $l$block;
        } else {
          this.so(finalState);
          return true;
        }
      }
    }
  };
  protoOf(JobSupport).qo = function (proposedUpdate) {
    // Inline function 'kotlinx.coroutines.JobSupport.loopOnState' call
    while (true) {
      var tmp0 = this.cp();
      $l$block: {
        var finalState = tryMakeCompleting(this, tmp0, proposedUpdate);
        if (finalState === get_COMPLETING_ALREADY())
          throw IllegalStateException_init_$Create$_1('Job ' + this.toString() + ' is already complete or completing, ' + ('but is being completed with ' + toString_0(proposedUpdate)), _get_exceptionOrNull__b3j7js(this, proposedUpdate));
        else if (finalState === get_COMPLETING_RETRY()) {
          break $l$block;
        } else
          return finalState;
      }
    }
  };
  protoOf(JobSupport).zp = function (child) {
    // Inline function 'kotlinx.coroutines.asHandler' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = new ChildHandleNode(child);
    var tmp = this.mp(true, VOID, tmp$ret$1);
    return isInterface(tmp, ChildHandle) ? tmp : THROW_CCE();
  };
  protoOf(JobSupport).to = function (exception) {
    throw exception;
  };
  protoOf(JobSupport).aq = function (cause) {
  };
  protoOf(JobSupport).bq = function () {
    return false;
  };
  protoOf(JobSupport).cq = function () {
    return true;
  };
  protoOf(JobSupport).dq = function (exception) {
    return false;
  };
  protoOf(JobSupport).mo = function (state) {
  };
  protoOf(JobSupport).so = function (state) {
  };
  protoOf(JobSupport).toString = function () {
    return this.eq() + '@' + get_hexAddress(this);
  };
  protoOf(JobSupport).eq = function () {
    return this.uo() + '{' + stateString(this, this.cp()) + '}';
  };
  protoOf(JobSupport).uo = function () {
    return get_classSimpleName(this);
  };
  protoOf(JobSupport).fq = function () {
    var state = this.cp();
    // Inline function 'kotlin.check' call
    if (!!(!(state == null) ? isInterface(state, Incomplete) : false)) {
      var message = 'This job has not completed yet';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    return _get_exceptionOrNull__b3j7js(this, state);
  };
  protoOf(JobSupport).gq = function () {
    var state = this.cp();
    // Inline function 'kotlin.check' call
    if (!!(!(state == null) ? isInterface(state, Incomplete) : false)) {
      var message = 'This job has not completed yet';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    if (state instanceof CompletedExceptionally)
      throw state.no_1;
    return unboxState(state);
  };
  protoOf(JobSupport).hq = function ($completion) {
    $l$loop: while (true) {
      var state = this.cp();
      if (!(!(state == null) ? isInterface(state, Incomplete) : false)) {
        if (state instanceof CompletedExceptionally) {
          // Inline function 'kotlinx.coroutines.internal.recoverAndThrow' call
          throw state.no_1;
        }
        return unboxState(state);
      }
      if (startInternal(this, state) >= 0)
        break $l$loop;
    }
    return awaitSuspend(this, $completion);
  };
  function handlesExceptionF($this) {
    var tmp = $this.ap();
    var tmp0_safe_receiver = tmp instanceof ChildHandleNode ? tmp : null;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.gw();
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      return false;
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    var parentJob = tmp_0;
    while (true) {
      if (parentJob.cq())
        return true;
      var tmp_1 = parentJob.ap();
      var tmp2_safe_receiver = tmp_1 instanceof ChildHandleNode ? tmp_1 : null;
      var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.gw();
      var tmp_2;
      if (tmp3_elvis_lhs == null) {
        return false;
      } else {
        tmp_2 = tmp3_elvis_lhs;
      }
      parentJob = tmp_2;
    }
  }
  function JobImpl(parent) {
    JobSupport.call(this, true);
    this.do(parent);
    this.jy_1 = handlesExceptionF(this);
  }
  protoOf(JobImpl).qp = function () {
    return true;
  };
  protoOf(JobImpl).cq = function () {
    return this.jy_1;
  };
  protoOf(JobImpl).su = function () {
    return this.qu(Unit_instance);
  };
  protoOf(JobImpl).ru = function (exception) {
    return this.qu(new CompletedExceptionally(exception));
  };
  function Empty(isActive) {
    this.ww_1 = isActive;
  }
  protoOf(Empty).io = function () {
    return this.ww_1;
  };
  protoOf(Empty).hw = function () {
    return null;
  };
  protoOf(Empty).toString = function () {
    return 'Empty{' + (this.ww_1 ? 'Active' : 'New') + '}';
  };
  function Incomplete() {
  }
  function IncompleteStateBox(state) {
    this.wv_1 = state;
  }
  function JobCancellingNode() {
    JobNode.call(this);
  }
  function boxIncomplete(_this__u8e3s4) {
    _init_properties_JobSupport_kt__68f172();
    var tmp;
    if (!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Incomplete) : false) {
      tmp = new IncompleteStateBox(_this__u8e3s4);
    } else {
      tmp = _this__u8e3s4;
    }
    return tmp;
  }
  function JobNode() {
    CompletionHandlerBase.call(this);
  }
  protoOf(JobNode).gw = function () {
    var tmp = this.fw_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('job');
    }
  };
  protoOf(JobNode).io = function () {
    return true;
  };
  protoOf(JobNode).hw = function () {
    return null;
  };
  protoOf(JobNode).zr = function () {
    return this.gw().pp(this);
  };
  protoOf(JobNode).toString = function () {
    return get_classSimpleName(this) + '@' + get_hexAddress(this) + '[job@' + get_hexAddress(this.gw()) + ']';
  };
  function NodeList() {
    LinkedListHead.call(this);
  }
  protoOf(NodeList).io = function () {
    return true;
  };
  protoOf(NodeList).hw = function () {
    return this;
  };
  protoOf(NodeList).ny = function (state) {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder_init_$Create$_1();
    this_0.j8('List{');
    this_0.j8(state);
    this_0.j8('}[');
    var first = true;
    // Inline function 'kotlinx.coroutines.internal.LinkedListHead.forEach' call
    var cur = this.iw_1;
    while (!equals(cur, this)) {
      if (cur instanceof JobNode) {
        var node = cur;
        if (first)
          first = false;
        else {
          this_0.j8(', ');
        }
        this_0.i8(node);
      }
      cur = cur.iw_1;
    }
    this_0.j8(']');
    return this_0.toString();
  };
  protoOf(NodeList).toString = function () {
    return get_DEBUG() ? this.ny('Active') : protoOf(LinkedListHead).toString.call(this);
  };
  function InactiveNodeList(list) {
    this.vw_1 = list;
  }
  protoOf(InactiveNodeList).hw = function () {
    return this.vw_1;
  };
  protoOf(InactiveNodeList).io = function () {
    return false;
  };
  protoOf(InactiveNodeList).toString = function () {
    return get_DEBUG() ? this.vw_1.ny('New') : anyToString(this);
  };
  function ChildHandleNode(childJob) {
    JobCancellingNode.call(this);
    this.px_1 = childJob;
  }
  protoOf(ChildHandleNode).bp = function () {
    return this.gw();
  };
  protoOf(ChildHandleNode).yr = function (cause) {
    return this.px_1.up(this.gw());
  };
  protoOf(ChildHandleNode).invoke = function (cause) {
    return this.yr(cause);
  };
  protoOf(ChildHandleNode).vp = function (cause) {
    return this.gw().vp(cause);
  };
  function InvokeOnCancelling(handler) {
    JobCancellingNode.call(this);
    this.vy_1 = handler;
    this.wy_1 = atomic$int$1(0);
  }
  protoOf(InvokeOnCancelling).yr = function (cause) {
    if (this.wy_1.atomicfu$compareAndSet(0, 1))
      this.vy_1(cause);
  };
  protoOf(InvokeOnCancelling).invoke = function (cause) {
    return this.yr(cause);
  };
  function InvokeOnCompletion(handler) {
    JobNode.call(this);
    this.bz_1 = handler;
  }
  protoOf(InvokeOnCompletion).yr = function (cause) {
    return this.bz_1(cause);
  };
  protoOf(InvokeOnCompletion).invoke = function (cause) {
    return this.yr(cause);
  };
  function ResumeOnCompletion(continuation) {
    JobNode.call(this);
    this.gz_1 = continuation;
  }
  protoOf(ResumeOnCompletion).yr = function (cause) {
    // Inline function 'kotlin.coroutines.resume' call
    var this_0 = this.gz_1;
    // Inline function 'kotlin.Companion.success' call
    var tmp$ret$0 = _Result___init__impl__xyqfz8(Unit_instance);
    this_0.q9(tmp$ret$0);
    return Unit_instance;
  };
  protoOf(ResumeOnCompletion).invoke = function (cause) {
    return this.yr(cause);
  };
  function ResumeAwaitOnCompletion(continuation) {
    JobNode.call(this);
    this.lz_1 = continuation;
  }
  protoOf(ResumeAwaitOnCompletion).yr = function (cause) {
    var state = this.gw().cp();
    // Inline function 'kotlinx.coroutines.assert' call
    if (state instanceof CompletedExceptionally) {
      var tmp0 = this.lz_1;
      // Inline function 'kotlin.coroutines.resumeWithException' call
      // Inline function 'kotlin.Companion.failure' call
      var exception = state.no_1;
      var tmp$ret$1 = _Result___init__impl__xyqfz8(createFailure(exception));
      tmp0.q9(tmp$ret$1);
    } else {
      var tmp0_0 = this.lz_1;
      var tmp = unboxState(state);
      // Inline function 'kotlin.coroutines.resume' call
      // Inline function 'kotlin.Companion.success' call
      var value = (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
      var tmp$ret$3 = _Result___init__impl__xyqfz8(value);
      tmp0_0.q9(tmp$ret$3);
    }
  };
  protoOf(ResumeAwaitOnCompletion).invoke = function (cause) {
    return this.yr(cause);
  };
  function DisposeOnCompletion(handle) {
    JobNode.call(this);
    this.qz_1 = handle;
  }
  protoOf(DisposeOnCompletion).yr = function (cause) {
    return this.qz_1.zr();
  };
  protoOf(DisposeOnCompletion).invoke = function (cause) {
    return this.yr(cause);
  };
  var properties_initialized_JobSupport_kt_5iq8a4;
  function _init_properties_JobSupport_kt__68f172() {
    if (!properties_initialized_JobSupport_kt_5iq8a4) {
      properties_initialized_JobSupport_kt_5iq8a4 = true;
      COMPLETING_ALREADY = new Symbol_0('COMPLETING_ALREADY');
      COMPLETING_WAITING_CHILDREN = new Symbol_0('COMPLETING_WAITING_CHILDREN');
      COMPLETING_RETRY = new Symbol_0('COMPLETING_RETRY');
      TOO_LATE_TO_CANCEL = new Symbol_0('TOO_LATE_TO_CANCEL');
      SEALED = new Symbol_0('SEALED');
      EMPTY_NEW = new Empty(false);
      EMPTY_ACTIVE = new Empty(true);
    }
  }
  function MainCoroutineDispatcher() {
    CoroutineDispatcher.call(this);
  }
  protoOf(MainCoroutineDispatcher).toString = function () {
    var tmp0_elvis_lhs = this.tz();
    return tmp0_elvis_lhs == null ? get_classSimpleName(this) + '@' + get_hexAddress(this) : tmp0_elvis_lhs;
  };
  protoOf(MainCoroutineDispatcher).tz = function () {
    var main = Dispatchers_getInstance().yz();
    if (this === main)
      return 'Dispatchers.Main';
    var tmp;
    try {
      tmp = main.sz();
    } catch ($p) {
      var tmp_0;
      if ($p instanceof UnsupportedOperationException) {
        var e = $p;
        tmp_0 = null;
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    var immediate = tmp;
    if (this === immediate)
      return 'Dispatchers.Main.immediate';
    return null;
  };
  function SupervisorJob(parent) {
    parent = parent === VOID ? null : parent;
    return new SupervisorJobImpl(parent);
  }
  function SupervisorJobImpl(parent) {
    JobImpl.call(this, parent);
  }
  protoOf(SupervisorJobImpl).vp = function (cause) {
    return false;
  };
  function withTimeoutOrNull(timeMillis, block, $completion) {
    var tmp = new $withTimeoutOrNullCOROUTINE$(timeMillis, block, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  }
  function TimeoutCancellationException(message, coroutine) {
    CancellationException_init_$Init$_0(message, this);
    captureStack(this, TimeoutCancellationException);
    this.n10_1 = coroutine;
  }
  function TimeoutCoroutine(time, uCont) {
    ScopeCoroutine.call(this, uCont.l9(), uCont);
    this.s10_1 = time;
  }
  protoOf(TimeoutCoroutine).au = function () {
    this.wp(TimeoutCancellationException_0(this.s10_1, get_delay(this.go_1), this));
  };
  protoOf(TimeoutCoroutine).uo = function () {
    return protoOf(ScopeCoroutine).uo.call(this) + '(timeMillis=' + this.s10_1.toString() + ')';
  };
  function setupTimeout(coroutine, block) {
    var cont = coroutine.zq_1;
    var context = cont.l9();
    disposeOnCompletion(coroutine, get_delay(context).ev(coroutine.s10_1, coroutine, coroutine.go_1));
    return startUndispatchedOrReturnIgnoreTimeout(coroutine, coroutine, block);
  }
  function TimeoutCancellationException_0(time, delay, coroutine) {
    var tmp0_safe_receiver = isInterface(delay, DelayWithTimeoutDiagnostics) ? delay : null;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.time.Companion.milliseconds' call
      Companion_getInstance_16();
      var tmp$ret$0 = toDuration(time, DurationUnit_MILLISECONDS_getInstance());
      tmp = tmp0_safe_receiver.fv(tmp$ret$0);
    }
    var tmp1_elvis_lhs = tmp;
    var message = tmp1_elvis_lhs == null ? 'Timed out waiting for ' + time.toString() + ' ms' : tmp1_elvis_lhs;
    return new TimeoutCancellationException(message, coroutine);
  }
  function $withTimeoutOrNullCOROUTINE$(timeMillis, block, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.k10_1 = timeMillis;
    this.l10_1 = block;
  }
  protoOf($withTimeoutOrNullCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 3;
            if (this.k10_1 <= 0n)
              return null;
            this.m10_1 = {_v: null};
            this.g9_1 = 2;
            this.f9_1 = 1;
            var timeoutCoroutine = new TimeoutCoroutine(this.k10_1, this);
            this.m10_1._v = timeoutCoroutine;
            suspendResult = returnIfSuspended(setupTimeout(timeoutCoroutine, this.l10_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            this.g9_1 = 3;
            var tmp_0 = this.i9_1;
            if (tmp_0 instanceof TimeoutCancellationException) {
              var e = this.i9_1;
              if (e.n10_1 === this.m10_1._v) {
                return null;
              }
              throw e;
            } else {
              throw this.i9_1;
            }

          case 3:
            throw this.i9_1;
          case 4:
            this.g9_1 = 3;
            return Unit_instance;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.g9_1 === 3) {
          throw e_0;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e_0;
        }
      }
     while (true);
  };
  function Key_4() {
  }
  var Key_instance_4;
  function Key_getInstance_4() {
    return Key_instance_4;
  }
  function YieldContext() {
    AbstractCoroutineContextElement.call(this, Key_instance_4);
    this.u10_1 = false;
  }
  function Unconfined() {
    Unconfined_instance = this;
    CoroutineDispatcher.call(this);
  }
  protoOf(Unconfined).wu = function (context) {
    return false;
  };
  protoOf(Unconfined).xu = function (context, block) {
    var yieldContext = context.s9(Key_instance_4);
    if (!(yieldContext == null)) {
      yieldContext.u10_1 = true;
      return Unit_instance;
    }
    throw UnsupportedOperationException_init_$Create$_0('Dispatchers.Unconfined.dispatch function can only be used by the yield function. If you wrap Unconfined dispatcher in your code, make sure you properly delegate isDispatchNeeded and dispatch calls.');
  };
  protoOf(Unconfined).toString = function () {
    return 'Dispatchers.Unconfined';
  };
  var Unconfined_instance;
  function Unconfined_getInstance() {
    if (Unconfined_instance == null)
      new Unconfined();
    return Unconfined_instance;
  }
  function Waiter() {
  }
  function yield_0($completion) {
    var tmp$ret$0;
    $l$block_0: {
      var context = $completion.l9();
      ensureActive(context);
      var tmp = intercepted($completion);
      var tmp0_elvis_lhs = tmp instanceof DispatchedContinuation ? tmp : null;
      var tmp_0;
      if (tmp0_elvis_lhs == null) {
        tmp$ret$0 = Unit_instance;
        break $l$block_0;
      } else {
        tmp_0 = tmp0_elvis_lhs;
      }
      var cont = tmp_0;
      if (cont.bs_1.wu(context)) {
        cont.w10(context, Unit_instance);
      } else {
        var yieldContext = new YieldContext();
        cont.w10(context.wi(yieldContext), Unit_instance);
        if (yieldContext.u10_1) {
          tmp$ret$0 = yieldUndispatched(cont) ? get_COROUTINE_SUSPENDED() : Unit_instance;
          break $l$block_0;
        }
      }
      tmp$ret$0 = get_COROUTINE_SUSPENDED();
    }
    return tmp$ret$0;
  }
  var BufferOverflow_SUSPEND_instance;
  var BufferOverflow_DROP_OLDEST_instance;
  var BufferOverflow_DROP_LATEST_instance;
  var BufferOverflow_entriesInitialized;
  function BufferOverflow_initEntries() {
    if (BufferOverflow_entriesInitialized)
      return Unit_instance;
    BufferOverflow_entriesInitialized = true;
    BufferOverflow_SUSPEND_instance = new BufferOverflow('SUSPEND', 0);
    BufferOverflow_DROP_OLDEST_instance = new BufferOverflow('DROP_OLDEST', 1);
    BufferOverflow_DROP_LATEST_instance = new BufferOverflow('DROP_LATEST', 2);
  }
  function BufferOverflow(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function BufferOverflow_SUSPEND_getInstance() {
    BufferOverflow_initEntries();
    return BufferOverflow_SUSPEND_instance;
  }
  function BufferOverflow_DROP_OLDEST_getInstance() {
    BufferOverflow_initEntries();
    return BufferOverflow_DROP_OLDEST_instance;
  }
  function BufferOverflow_DROP_LATEST_getInstance() {
    BufferOverflow_initEntries();
    return BufferOverflow_DROP_LATEST_instance;
  }
  function get_NULL_SEGMENT() {
    _init_properties_BufferedChannel_kt__d6uc4y();
    return NULL_SEGMENT;
  }
  var NULL_SEGMENT;
  function get_SEGMENT_SIZE() {
    _init_properties_BufferedChannel_kt__d6uc4y();
    return SEGMENT_SIZE;
  }
  var SEGMENT_SIZE;
  function get_EXPAND_BUFFER_COMPLETION_WAIT_ITERATIONS() {
    _init_properties_BufferedChannel_kt__d6uc4y();
    return EXPAND_BUFFER_COMPLETION_WAIT_ITERATIONS;
  }
  var EXPAND_BUFFER_COMPLETION_WAIT_ITERATIONS;
  function get_BUFFERED() {
    _init_properties_BufferedChannel_kt__d6uc4y();
    return BUFFERED;
  }
  var BUFFERED;
  function get_IN_BUFFER() {
    _init_properties_BufferedChannel_kt__d6uc4y();
    return IN_BUFFER;
  }
  var IN_BUFFER;
  function get_RESUMING_BY_RCV() {
    _init_properties_BufferedChannel_kt__d6uc4y();
    return RESUMING_BY_RCV;
  }
  var RESUMING_BY_RCV;
  function get_RESUMING_BY_EB() {
    _init_properties_BufferedChannel_kt__d6uc4y();
    return RESUMING_BY_EB;
  }
  var RESUMING_BY_EB;
  function get_POISONED() {
    _init_properties_BufferedChannel_kt__d6uc4y();
    return POISONED;
  }
  var POISONED;
  function get_DONE_RCV() {
    _init_properties_BufferedChannel_kt__d6uc4y();
    return DONE_RCV;
  }
  var DONE_RCV;
  function get_INTERRUPTED_SEND() {
    _init_properties_BufferedChannel_kt__d6uc4y();
    return INTERRUPTED_SEND;
  }
  var INTERRUPTED_SEND;
  function get_INTERRUPTED_RCV() {
    _init_properties_BufferedChannel_kt__d6uc4y();
    return INTERRUPTED_RCV;
  }
  var INTERRUPTED_RCV;
  function get_CHANNEL_CLOSED() {
    _init_properties_BufferedChannel_kt__d6uc4y();
    return CHANNEL_CLOSED;
  }
  var CHANNEL_CLOSED;
  function get_SUSPEND() {
    _init_properties_BufferedChannel_kt__d6uc4y();
    return SUSPEND;
  }
  var SUSPEND;
  function get_SUSPEND_NO_WAITER() {
    _init_properties_BufferedChannel_kt__d6uc4y();
    return SUSPEND_NO_WAITER;
  }
  var SUSPEND_NO_WAITER;
  function get_FAILED() {
    _init_properties_BufferedChannel_kt__d6uc4y();
    return FAILED;
  }
  var FAILED;
  function get_NO_RECEIVE_RESULT() {
    _init_properties_BufferedChannel_kt__d6uc4y();
    return NO_RECEIVE_RESULT;
  }
  var NO_RECEIVE_RESULT;
  function get_CLOSE_HANDLER_CLOSED() {
    _init_properties_BufferedChannel_kt__d6uc4y();
    return CLOSE_HANDLER_CLOSED;
  }
  var CLOSE_HANDLER_CLOSED;
  function get_CLOSE_HANDLER_INVOKED() {
    _init_properties_BufferedChannel_kt__d6uc4y();
    return CLOSE_HANDLER_INVOKED;
  }
  var CLOSE_HANDLER_INVOKED;
  function get_NO_CLOSE_CAUSE() {
    _init_properties_BufferedChannel_kt__d6uc4y();
    return NO_CLOSE_CAUSE;
  }
  var NO_CLOSE_CAUSE;
  function setElementLazy($this, index, value) {
    // Inline function 'kotlinx.atomicfu.AtomicRef.lazySet' call
    $this.c11_1.atomicfu$get(imul(index, 2)).kotlinx$atomicfu$value = value;
  }
  function ChannelSegment(id, prev, channel, pointers) {
    Segment.call(this, id, prev, pointers);
    this.b11_1 = channel;
    this.c11_1 = atomicfu$AtomicRefArray$ofNulls(imul(get_SEGMENT_SIZE(), 2));
  }
  protoOf(ChannelSegment).d11 = function () {
    return ensureNotNull(this.b11_1);
  };
  protoOf(ChannelSegment).e11 = function () {
    return get_SEGMENT_SIZE();
  };
  protoOf(ChannelSegment).f11 = function (index, element) {
    setElementLazy(this, index, element);
  };
  protoOf(ChannelSegment).g11 = function (index) {
    var tmp = this.c11_1.atomicfu$get(imul(index, 2)).kotlinx$atomicfu$value;
    return (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
  };
  protoOf(ChannelSegment).h11 = function (index) {
    // Inline function 'kotlin.also' call
    var this_0 = this.g11(index);
    this.i11(index);
    return this_0;
  };
  protoOf(ChannelSegment).i11 = function (index) {
    setElementLazy(this, index, null);
  };
  protoOf(ChannelSegment).j11 = function (index) {
    return this.c11_1.atomicfu$get(imul(index, 2) + 1 | 0).kotlinx$atomicfu$value;
  };
  protoOf(ChannelSegment).k11 = function (index, value) {
    this.c11_1.atomicfu$get(imul(index, 2) + 1 | 0).kotlinx$atomicfu$value = value;
  };
  protoOf(ChannelSegment).l11 = function (index, from, to) {
    return this.c11_1.atomicfu$get(imul(index, 2) + 1 | 0).atomicfu$compareAndSet(from, to);
  };
  protoOf(ChannelSegment).m11 = function (index, update) {
    return this.c11_1.atomicfu$get(imul(index, 2) + 1 | 0).atomicfu$getAndSet(update);
  };
  protoOf(ChannelSegment).vs = function (index, cause, context) {
    var isSender = index >= get_SEGMENT_SIZE();
    var index_0 = isSender ? index - get_SEGMENT_SIZE() | 0 : index;
    var element = this.g11(index_0);
    $l$loop: while (true) {
      var cur = this.j11(index_0);
      var tmp;
      if (!(cur == null) ? isInterface(cur, Waiter) : false) {
        tmp = true;
      } else {
        tmp = cur instanceof WaiterEB;
      }
      if (tmp) {
        var update = isSender ? get_INTERRUPTED_SEND() : get_INTERRUPTED_RCV();
        if (this.l11(index_0, cur, update)) {
          this.i11(index_0);
          this.z11(index_0, !isSender);
          if (isSender) {
            var tmp0_safe_receiver = this.d11().o11_1;
            if (tmp0_safe_receiver == null)
              null;
            else {
              callUndeliveredElement(tmp0_safe_receiver, element, context);
            }
          }
          return Unit_instance;
        }
      } else {
        if (cur === get_INTERRUPTED_SEND() || cur === get_INTERRUPTED_RCV()) {
          this.i11(index_0);
          if (isSender) {
            var tmp1_safe_receiver = this.d11().o11_1;
            if (tmp1_safe_receiver == null)
              null;
            else {
              callUndeliveredElement(tmp1_safe_receiver, element, context);
            }
          }
          return Unit_instance;
        } else {
          if (cur === get_RESUMING_BY_EB() || cur === get_RESUMING_BY_RCV())
            continue $l$loop;
          else {
            if (cur === get_DONE_RCV() || cur === get_BUFFERED())
              return Unit_instance;
            else {
              if (cur === get_CHANNEL_CLOSED())
                return Unit_instance;
              else {
                // Inline function 'kotlin.error' call
                var message = 'unexpected state: ' + toString_0(cur);
                throw IllegalStateException_init_$Create$_0(toString_1(message));
              }
            }
          }
        }
      }
    }
  };
  protoOf(ChannelSegment).z11 = function (index, receiver) {
    if (receiver) {
      var tmp = this.d11();
      var tmp0 = this.ts_1;
      // Inline function 'kotlin.Long.times' call
      var other = get_SEGMENT_SIZE();
      // Inline function 'kotlin.Long.plus' call
      var this_0 = multiply_0(tmp0, fromInt_0(other));
      var tmp$ret$1 = add_2(this_0, fromInt_0(index));
      tmp.a12(tmp$ret$1);
    }
    this.b12();
  };
  function onClosedHasNext($this) {
    $this.n12_1 = get_CHANNEL_CLOSED();
    var tmp0_elvis_lhs = $this.p12_1.q12();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var cause = tmp;
    throw recoverStackTrace_0(cause);
  }
  function hasNextOnNoWaiterSuspend($this, segment, index, r, $completion) {
    var cancellable = getOrCreateCancellableContinuation(intercepted($completion));
    try {
      $this.o12_1 = cancellable;
      // Inline function 'kotlinx.coroutines.channels.BufferedChannel.receiveImplOnNoWaiter' call
      var this_0 = $this.p12_1;
      var updCellResult = updateCellReceive(this_0, segment, index, r, $this);
      if (updCellResult === get_SUSPEND()) {
        prepareReceiverForSuspension(this_0, $this, segment, index);
      } else if (updCellResult === get_FAILED()) {
        if (r < this_0.r12()) {
          segment.l12();
        }
        $l$block_0: {
          // Inline function 'kotlinx.coroutines.channels.BufferedChannel.receiveImpl' call
          var segment_0 = this_0.u11_1.kotlinx$atomicfu$value;
          $l$loop_0: while (true) {
            if (this_0.s12()) {
              onClosedHasNextNoWaiterSuspend($this);
              break $l$block_0;
            }
            var r_0 = this_0.q11_1.atomicfu$getAndIncrement$long();
            // Inline function 'kotlin.Long.div' call
            var other = get_SEGMENT_SIZE();
            var id = divide(r_0, fromInt_0(other));
            // Inline function 'kotlin.Long.rem' call
            var other_0 = get_SEGMENT_SIZE();
            var tmp$ret$3 = modulo(r_0, fromInt_0(other_0));
            var i = convertToInt(tmp$ret$3);
            if (!(segment_0.ts_1 === id)) {
              var tmp0_elvis_lhs = findSegmentReceive(this_0, id, segment_0);
              var tmp;
              if (tmp0_elvis_lhs == null) {
                continue $l$loop_0;
              } else {
                tmp = tmp0_elvis_lhs;
              }
              segment_0 = tmp;
            }
            var updCellResult_0 = updateCellReceive(this_0, segment_0, i, r_0, $this);
            if (updCellResult_0 === get_SUSPEND()) {
              var tmp1_safe_receiver = (!($this == null) ? isInterface($this, Waiter) : false) ? $this : null;
              if (tmp1_safe_receiver == null)
                null;
              else {
                prepareReceiverForSuspension(this_0, tmp1_safe_receiver, segment_0, i);
              }
            } else if (updCellResult_0 === get_FAILED()) {
              if (r_0 < this_0.r12()) {
                segment_0.l12();
              }
              continue $l$loop_0;
            } else if (updCellResult_0 === get_SUSPEND_NO_WAITER()) {
              var message = 'unexpected';
              throw IllegalStateException_init_$Create$_0(toString_1(message));
            } else {
              segment_0.l12();
              var element = (updCellResult_0 == null ? true : !(updCellResult_0 == null)) ? updCellResult_0 : THROW_CCE();
              $this.n12_1 = element;
              $this.o12_1 = null;
              var tmp0_safe_receiver = $this.p12_1.o11_1;
              cancellable.wr(true, tmp0_safe_receiver == null ? null : bindCancellationFun(tmp0_safe_receiver, element, cancellable.l9()));
            }
            break $l$block_0;
          }
        }
      } else {
        segment.l12();
        var element_0 = (updCellResult == null ? true : !(updCellResult == null)) ? updCellResult : THROW_CCE();
        $this.n12_1 = element_0;
        $this.o12_1 = null;
        var tmp0_safe_receiver_0 = $this.p12_1.o11_1;
        cancellable.wr(true, tmp0_safe_receiver_0 == null ? null : bindCancellationFun(tmp0_safe_receiver_0, element_0, cancellable.l9()));
      }
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        cancellable.ut();
        throw e;
      } else {
        throw $p;
      }
    }
    return cancellable.tt();
  }
  function onClosedHasNextNoWaiterSuspend($this) {
    var cont = ensureNotNull($this.o12_1);
    $this.o12_1 = null;
    $this.n12_1 = get_CHANNEL_CLOSED();
    var cause = $this.p12_1.q12();
    if (cause == null) {
      // Inline function 'kotlin.coroutines.resume' call
      // Inline function 'kotlin.Companion.success' call
      var tmp$ret$0 = _Result___init__impl__xyqfz8(false);
      cont.q9(tmp$ret$0);
    } else {
      // Inline function 'kotlin.coroutines.resumeWithException' call
      // Inline function 'kotlin.Companion.failure' call
      var exception = recoverStackTrace(cause, cont);
      var tmp$ret$2 = _Result___init__impl__xyqfz8(createFailure(exception));
      cont.q9(tmp$ret$2);
    }
  }
  function $hasNextCOROUTINE$(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.b13_1 = _this__u8e3s4;
  }
  protoOf($hasNextCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 8;
            var tmp_0 = this;
            tmp_0.l13_1 = this.b13_1.p12_1;
            var tmp_1 = this;
            tmp_1.k13_1 = null;
            this.f9_1 = 1;
            continue $sm;
          case 1:
            this.h13_1 = this.l13_1;
            this.i13_1 = this.k13_1;
            this.e13_1 = this.h13_1.u11_1.kotlinx$atomicfu$value;
            this.f9_1 = 2;
            continue $sm;
          case 2:
            if (!true) {
              this.f9_1 = 9;
              continue $sm;
            }

            if (this.h13_1.s12()) {
              var tmp_2 = this;
              tmp_2.c13_1 = onClosedHasNext(this.b13_1);
              this.f9_1 = 10;
              continue $sm;
            } else {
              this.f9_1 = 3;
              continue $sm;
            }

          case 3:
            this.f13_1 = this.h13_1.q11_1.atomicfu$getAndIncrement$long();
            var tmp0 = this.f13_1;
            var other = get_SEGMENT_SIZE();
            var id = divide(tmp0, fromInt_0(other));
            var tmp_3 = this;
            var tmp0_0 = this.f13_1;
            var other_0 = get_SEGMENT_SIZE();
            tmp_3.g13_1 = convertToInt(modulo(tmp0_0, fromInt_0(other_0)));
            if (!(this.e13_1.ts_1 === id)) {
              var tmp0_elvis_lhs = findSegmentReceive(this.h13_1, id, this.e13_1);
              if (tmp0_elvis_lhs == null) {
                this.f9_1 = 2;
                var tmp_4 = this;
                continue $sm;
              } else {
                this.j13_1 = tmp0_elvis_lhs;
                this.f9_1 = 4;
                continue $sm;
              }
            } else {
              this.f9_1 = 5;
              continue $sm;
            }

          case 4:
            this.e13_1 = this.j13_1;
            this.f9_1 = 5;
            continue $sm;
          case 5:
            var updCellResult = updateCellReceive(this.h13_1, this.e13_1, this.g13_1, this.f13_1, this.i13_1);
            if (updCellResult === get_SUSPEND()) {
              var tmp_5 = this;
              var tmp_6 = this.i13_1;
              var tmp1_safe_receiver = (!(tmp_6 == null) ? isInterface(tmp_6, Waiter) : false) ? tmp_6 : null;
              if (tmp1_safe_receiver == null)
                null;
              else {
                prepareReceiverForSuspension(this.h13_1, tmp1_safe_receiver, this.e13_1, this.g13_1);
              }
              this.e13_1;
              this.g13_1;
              this.f13_1;
              var message = 'unreachable';
              throw IllegalStateException_init_$Create$_0(toString_1(message));
            } else {
              if (updCellResult === get_FAILED()) {
                if (this.f13_1 < this.h13_1.r12()) {
                  this.e13_1.l12();
                }
                this.f9_1 = 2;
                var tmp_7 = this;
                continue $sm;
              } else {
                if (updCellResult === get_SUSPEND_NO_WAITER()) {
                  var tmp0_1 = this.e13_1;
                  var tmp2 = this.g13_1;
                  var r = this.f13_1;
                  this.f9_1 = 6;
                  suspendResult = hasNextOnNoWaiterSuspend(this.b13_1, tmp0_1, tmp2, r, this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  continue $sm;
                } else {
                  var tmp_8 = this;
                  this.e13_1.l12();
                  var element = (updCellResult == null ? true : !(updCellResult == null)) ? updCellResult : THROW_CCE();
                  this.b13_1.n12_1 = element;
                  tmp_8.d13_1 = true;
                  this.f9_1 = 7;
                  continue $sm;
                }
              }
            }

          case 6:
            var tmp_9 = this;
            return suspendResult;
          case 7:
            this.c13_1 = this.d13_1;
            this.f9_1 = 10;
            continue $sm;
          case 8:
            throw this.i9_1;
          case 9:
            if (false) {
              this.f9_1 = 1;
              continue $sm;
            }

            this.f9_1 = 10;
            continue $sm;
          case 10:
            return this.c13_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 8) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function _get_bufferEndCounter__2d4hee($this) {
    return $this.r11_1.kotlinx$atomicfu$value;
  }
  function _get_isRendezvousOrUnlimited__3mdufi($this) {
    // Inline function 'kotlin.let' call
    var it = _get_bufferEndCounter__2d4hee($this);
    return it === 0n || it === 9223372036854775807n;
  }
  function onClosedSend($this, element, $completion) {
    var cancellable = new CancellableContinuationImpl(intercepted($completion), 1);
    cancellable.mt();
    $l$block: {
      var tmp0_safe_receiver = $this.o11_1;
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : callUndeliveredElementCatchingException(tmp0_safe_receiver, element);
      if (tmp1_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        addSuppressed(tmp1_safe_receiver, $this.m13());
        // Inline function 'kotlinx.coroutines.resumeWithStackTrace' call
        // Inline function 'kotlin.Companion.failure' call
        var exception = recoverStackTrace(tmp1_safe_receiver, cancellable);
        var tmp$ret$0 = _Result___init__impl__xyqfz8(createFailure(exception));
        cancellable.q9(tmp$ret$0);
        break $l$block;
      }
      // Inline function 'kotlinx.coroutines.resumeWithStackTrace' call
      var exception_0 = $this.m13();
      // Inline function 'kotlin.Companion.failure' call
      var exception_1 = recoverStackTrace(exception_0, cancellable);
      var tmp$ret$4 = _Result___init__impl__xyqfz8(createFailure(exception_1));
      cancellable.q9(tmp$ret$4);
    }
    return cancellable.tt();
  }
  function sendOnNoWaiterSuspend($this, segment, index, element, s, $completion) {
    var cancellable = getOrCreateCancellableContinuation(intercepted($completion));
    try {
      // Inline function 'kotlinx.coroutines.channels.BufferedChannel.sendImplOnNoWaiter' call
      switch (updateCellSend($this, segment, index, element, s, cancellable, false)) {
        case 0:
          segment.l12();
          // Inline function 'kotlin.coroutines.resume' call

          // Inline function 'kotlin.Companion.success' call

          var tmp$ret$0 = _Result___init__impl__xyqfz8(Unit_instance);
          cancellable.q9(tmp$ret$0);
          break;
        case 1:
          // Inline function 'kotlin.coroutines.resume' call

          // Inline function 'kotlin.Companion.success' call

          var tmp$ret$3 = _Result___init__impl__xyqfz8(Unit_instance);
          cancellable.q9(tmp$ret$3);
          break;
        case 2:
          prepareSenderForSuspension($this, cancellable, segment, index);
          break;
        case 4:
          if (s < $this.n13()) {
            segment.l12();
          }

          onClosedSendOnNoWaiterSuspend($this, element, cancellable);
          break;
        case 5:
          segment.l12();
          $l$block_5: {
            // Inline function 'kotlinx.coroutines.channels.BufferedChannel.sendImpl' call
            var segment_0 = access$_get_sendSegment__111kgq($this).kotlinx$atomicfu$value;
            $l$loop_0: while (true) {
              var sendersAndCloseStatusCur = access$_get_sendersAndCloseStatus__tvw29s($this).atomicfu$getAndIncrement$long();
              // Inline function 'kotlinx.coroutines.channels.sendersCounter' call
              var s_0 = sendersAndCloseStatusCur & access$_get_SENDERS_COUNTER_MASK_$tBufferedChannelKt_6ll4te();
              var closed = access$_get_isClosedForSend0__sm8f7a($this, sendersAndCloseStatusCur);
              // Inline function 'kotlin.Long.div' call
              var other = get_SEGMENT_SIZE();
              var id = divide(s_0, fromInt_0(other));
              // Inline function 'kotlin.Long.rem' call
              var other_0 = get_SEGMENT_SIZE();
              var tmp$ret$9 = modulo(s_0, fromInt_0(other_0));
              var i = convertToInt(tmp$ret$9);
              if (!(segment_0.ts_1 === id)) {
                var tmp0_elvis_lhs = access$findSegmentSend($this, id, segment_0);
                var tmp;
                if (tmp0_elvis_lhs == null) {
                  var tmp_0;
                  if (closed) {
                    onClosedSendOnNoWaiterSuspend($this, element, cancellable);
                    break $l$block_5;
                  } else {
                    continue $l$loop_0;
                  }
                } else {
                  tmp = tmp0_elvis_lhs;
                }
                segment_0 = tmp;
              }
              var tmp1_subject = access$updateCellSend($this, segment_0, i, element, s_0, cancellable, closed);
              if (tmp1_subject === access$_get_RESULT_RENDEZVOUS_$tBufferedChannelKt_ykevfn()) {
                segment_0.l12();
                // Inline function 'kotlin.coroutines.resume' call
                // Inline function 'kotlin.Companion.success' call
                var tmp$ret$12 = _Result___init__impl__xyqfz8(Unit_instance);
                cancellable.q9(tmp$ret$12);
                break $l$block_5;
              } else if (tmp1_subject === access$_get_RESULT_BUFFERED_$tBufferedChannelKt_tnykj7()) {
                // Inline function 'kotlin.coroutines.resume' call
                // Inline function 'kotlin.Companion.success' call
                var tmp$ret$15 = _Result___init__impl__xyqfz8(Unit_instance);
                cancellable.q9(tmp$ret$15);
                break $l$block_5;
              } else if (tmp1_subject === access$_get_RESULT_SUSPEND_$tBufferedChannelKt_vus6es()) {
                if (closed) {
                  segment_0.b12();
                  onClosedSendOnNoWaiterSuspend($this, element, cancellable);
                  break $l$block_5;
                }
                var tmp2_safe_receiver = (!(cancellable == null) ? isInterface(cancellable, Waiter) : false) ? cancellable : null;
                if (tmp2_safe_receiver == null)
                  null;
                else {
                  access$prepareSenderForSuspension($this, tmp2_safe_receiver, segment_0, i);
                }
                break $l$block_5;
              } else if (tmp1_subject === access$_get_RESULT_CLOSED_$tBufferedChannelKt_3eqb16()) {
                if (s_0 < $this.n13()) {
                  segment_0.l12();
                }
                onClosedSendOnNoWaiterSuspend($this, element, cancellable);
                break $l$block_5;
              } else if (tmp1_subject === access$_get_RESULT_FAILED_$tBufferedChannelKt_wacckr()) {
                segment_0.l12();
                continue $l$loop_0;
              } else if (tmp1_subject === access$_get_RESULT_SUSPEND_NO_WAITER_$tBufferedChannelKt_61h09f()) {
                var message = 'unexpected';
                throw IllegalStateException_init_$Create$_0(toString_1(message));
              }
            }
          }

          break;
        default:
          // Inline function 'kotlin.error' call

          var message_0 = 'unexpected';
          throw IllegalStateException_init_$Create$_0(toString_1(message_0));
      }
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        cancellable.ut();
        throw e;
      } else {
        throw $p;
      }
    }
    return cancellable.tt();
  }
  function prepareSenderForSuspension($this, _this__u8e3s4, segment, index) {
    _this__u8e3s4.xt(segment, index + get_SEGMENT_SIZE() | 0);
  }
  function onClosedSendOnNoWaiterSuspend($this, element, cont) {
    var tmp0_safe_receiver = $this.o11_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      callUndeliveredElement(tmp0_safe_receiver, element, cont.l9());
    }
    // Inline function 'kotlin.coroutines.resumeWithException' call
    // Inline function 'kotlin.Companion.failure' call
    var exception = recoverStackTrace($this.m13(), cont);
    var tmp$ret$0 = _Result___init__impl__xyqfz8(createFailure(exception));
    cont.q9(tmp$ret$0);
  }
  function SendBroadcast() {
  }
  function updateCellSend($this, segment, index, element, s, waiter, closed) {
    segment.f11(index, element);
    if (closed)
      return updateCellSendSlow($this, segment, index, element, s, waiter, closed);
    var state = segment.j11(index);
    if (state === null) {
      if (bufferOrRendezvousSend($this, s)) {
        if (segment.l11(index, null, get_BUFFERED())) {
          return 1;
        }
      } else {
        if (waiter == null) {
          return 3;
        } else {
          if (segment.l11(index, null, waiter))
            return 2;
        }
      }
    } else {
      if (!(state == null) ? isInterface(state, Waiter) : false) {
        segment.i11(index);
        var tmp;
        if (tryResumeReceiver($this, state, element)) {
          segment.k11(index, get_DONE_RCV());
          $this.o13();
          tmp = 0;
        } else {
          if (!(segment.m11(index, get_INTERRUPTED_RCV()) === get_INTERRUPTED_RCV())) {
            segment.z11(index, true);
          }
          tmp = 5;
        }
        return tmp;
      }
    }
    return updateCellSendSlow($this, segment, index, element, s, waiter, closed);
  }
  function updateCellSendSlow($this, segment, index, element, s, waiter, closed) {
    while (true) {
      var state = segment.j11(index);
      if (state === null) {
        if (bufferOrRendezvousSend($this, s) && !closed) {
          if (segment.l11(index, null, get_BUFFERED())) {
            return 1;
          }
        } else {
          if (closed) {
            if (segment.l11(index, null, get_INTERRUPTED_SEND())) {
              segment.z11(index, false);
              return 4;
            }
          } else if (waiter == null)
            return 3;
          else if (segment.l11(index, null, waiter))
            return 2;
        }
      } else if (state === get_IN_BUFFER()) {
        if (segment.l11(index, state, get_BUFFERED())) {
          return 1;
        }
      } else if (state === get_INTERRUPTED_RCV()) {
        segment.i11(index);
        return 5;
      } else if (state === get_POISONED()) {
        segment.i11(index);
        return 5;
      } else if (state === get_CHANNEL_CLOSED()) {
        segment.i11(index);
        completeCloseOrCancel($this);
        return 4;
      } else {
        // Inline function 'kotlinx.coroutines.assert' call
        segment.i11(index);
        var tmp;
        if (state instanceof WaiterEB) {
          tmp = state.p13_1;
        } else {
          tmp = state;
        }
        var receiver = tmp;
        var tmp_0;
        if (tryResumeReceiver($this, receiver, element)) {
          segment.k11(index, get_DONE_RCV());
          $this.o13();
          tmp_0 = 0;
        } else {
          if (!(segment.m11(index, get_INTERRUPTED_RCV()) === get_INTERRUPTED_RCV())) {
            segment.z11(index, true);
          }
          tmp_0 = 5;
        }
        return tmp_0;
      }
    }
  }
  function shouldSendSuspend0($this, curSendersAndCloseStatus) {
    if (_get_isClosedForSend0__kxgf9m($this, curSendersAndCloseStatus))
      return false;
    // Inline function 'kotlinx.coroutines.channels.sendersCounter' call
    var tmp$ret$0 = curSendersAndCloseStatus & 1152921504606846975n;
    return !bufferOrRendezvousSend($this, tmp$ret$0);
  }
  function bufferOrRendezvousSend($this, curSenders) {
    var tmp;
    if (curSenders < _get_bufferEndCounter__2d4hee($this)) {
      tmp = true;
    } else {
      var tmp0 = $this.n13();
      // Inline function 'kotlin.Long.plus' call
      var other = $this.n11_1;
      tmp = curSenders < add_2(tmp0, fromInt_0(other));
    }
    return tmp;
  }
  function tryResumeReceiver($this, _this__u8e3s4, element) {
    var tmp;
    if (isInterface(_this__u8e3s4, SelectInstance)) {
      tmp = _this__u8e3s4.fx($this, element);
    } else {
      if (_this__u8e3s4 instanceof ReceiveCatching) {
        if (!(_this__u8e3s4 instanceof ReceiveCatching))
          THROW_CCE();
        var tmp_0 = Companion_getInstance_22().s13(element);
        var tmp1_safe_receiver = $this.o11_1;
        tmp = tryResume0(_this__u8e3s4.t13_1, new ChannelResult(tmp_0), tmp1_safe_receiver == null ? null : bindCancellationFun(tmp1_safe_receiver, element, _this__u8e3s4.t13_1.l9()));
      } else {
        if (_this__u8e3s4 instanceof BufferedChannelIterator) {
          if (!(_this__u8e3s4 instanceof BufferedChannelIterator))
            THROW_CCE();
          tmp = _this__u8e3s4.q13(element);
        } else {
          if (isInterface(_this__u8e3s4, CancellableContinuation)) {
            if (!isInterface(_this__u8e3s4, CancellableContinuation))
              THROW_CCE();
            var tmp2_safe_receiver = $this.o11_1;
            tmp = tryResume0(_this__u8e3s4, element, tmp2_safe_receiver == null ? null : bindCancellationFun(tmp2_safe_receiver, element, _this__u8e3s4.l9()));
          } else {
            var message = 'Unexpected receiver type: ' + toString_1(_this__u8e3s4);
            throw IllegalStateException_init_$Create$_0(toString_1(message));
          }
        }
      }
    }
    return tmp;
  }
  function receiveOnNoWaiterSuspend($this, segment, index, r, $completion) {
    var cancellable = getOrCreateCancellableContinuation(intercepted($completion));
    try {
      // Inline function 'kotlinx.coroutines.channels.BufferedChannel.receiveImplOnNoWaiter' call
      var updCellResult = updateCellReceive($this, segment, index, r, cancellable);
      if (updCellResult === get_SUSPEND()) {
        prepareReceiverForSuspension($this, cancellable, segment, index);
      } else if (updCellResult === get_FAILED()) {
        if (r < $this.r12()) {
          segment.l12();
        }
        $l$block_0: {
          // Inline function 'kotlinx.coroutines.channels.BufferedChannel.receiveImpl' call
          var segment_0 = $this.u11_1.kotlinx$atomicfu$value;
          $l$loop_0: while (true) {
            if ($this.s12()) {
              onClosedReceiveOnNoWaiterSuspend($this, cancellable);
              break $l$block_0;
            }
            var r_0 = $this.q11_1.atomicfu$getAndIncrement$long();
            // Inline function 'kotlin.Long.div' call
            var other = get_SEGMENT_SIZE();
            var id = divide(r_0, fromInt_0(other));
            // Inline function 'kotlin.Long.rem' call
            var other_0 = get_SEGMENT_SIZE();
            var tmp$ret$3 = modulo(r_0, fromInt_0(other_0));
            var i = convertToInt(tmp$ret$3);
            if (!(segment_0.ts_1 === id)) {
              var tmp0_elvis_lhs = findSegmentReceive($this, id, segment_0);
              var tmp;
              if (tmp0_elvis_lhs == null) {
                continue $l$loop_0;
              } else {
                tmp = tmp0_elvis_lhs;
              }
              segment_0 = tmp;
            }
            var updCellResult_0 = updateCellReceive($this, segment_0, i, r_0, cancellable);
            if (updCellResult_0 === get_SUSPEND()) {
              var tmp1_safe_receiver = (!(cancellable == null) ? isInterface(cancellable, Waiter) : false) ? cancellable : null;
              if (tmp1_safe_receiver == null)
                null;
              else {
                prepareReceiverForSuspension($this, tmp1_safe_receiver, segment_0, i);
              }
            } else if (updCellResult_0 === get_FAILED()) {
              if (r_0 < $this.r12()) {
                segment_0.l12();
              }
              continue $l$loop_0;
            } else if (updCellResult_0 === get_SUSPEND_NO_WAITER()) {
              var message = 'unexpected';
              throw IllegalStateException_init_$Create$_0(toString_1(message));
            } else {
              segment_0.l12();
              var element = (updCellResult_0 == null ? true : !(updCellResult_0 == null)) ? updCellResult_0 : THROW_CCE();
              var tmp0_safe_receiver = $this.o11_1;
              var onCancellation = tmp0_safe_receiver == null ? null : bindCancellationFun(tmp0_safe_receiver, element, cancellable.l9());
              cancellable.wr(element, onCancellation);
            }
            break $l$block_0;
          }
        }
      } else {
        segment.l12();
        var element_0 = (updCellResult == null ? true : !(updCellResult == null)) ? updCellResult : THROW_CCE();
        var tmp0_safe_receiver_0 = $this.o11_1;
        var onCancellation_0 = tmp0_safe_receiver_0 == null ? null : bindCancellationFun(tmp0_safe_receiver_0, element_0, cancellable.l9());
        cancellable.wr(element_0, onCancellation_0);
      }
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        cancellable.ut();
        throw e;
      } else {
        throw $p;
      }
    }
    return cancellable.tt();
  }
  function prepareReceiverForSuspension($this, _this__u8e3s4, segment, index) {
    $this.u13();
    _this__u8e3s4.xt(segment, index);
  }
  function onClosedReceiveOnNoWaiterSuspend($this, cont) {
    // Inline function 'kotlin.coroutines.resumeWithException' call
    // Inline function 'kotlin.Companion.failure' call
    var exception = _get_receiveException__foorc1($this);
    var tmp$ret$0 = _Result___init__impl__xyqfz8(createFailure(exception));
    cont.q9(tmp$ret$0);
  }
  function updateCellReceive($this, segment, index, r, waiter) {
    var state = segment.j11(index);
    if (state === null) {
      // Inline function 'kotlinx.coroutines.channels.sendersCounter' call
      var senders = $this.p11_1.kotlinx$atomicfu$value & 1152921504606846975n;
      if (r >= senders) {
        if (waiter === null) {
          return get_SUSPEND_NO_WAITER();
        }
        if (segment.l11(index, state, waiter)) {
          expandBuffer($this);
          return get_SUSPEND();
        }
      }
    } else if (state === get_BUFFERED())
      if (segment.l11(index, state, get_DONE_RCV())) {
        expandBuffer($this);
        return segment.h11(index);
      }
    return updateCellReceiveSlow($this, segment, index, r, waiter);
  }
  function updateCellReceiveSlow($this, segment, index, r, waiter) {
    $l$loop: while (true) {
      var state = segment.j11(index);
      if (state === null || state === get_IN_BUFFER()) {
        // Inline function 'kotlinx.coroutines.channels.sendersCounter' call
        var senders = $this.p11_1.kotlinx$atomicfu$value & 1152921504606846975n;
        if (r < senders) {
          if (segment.l11(index, state, get_POISONED())) {
            expandBuffer($this);
            return get_FAILED();
          }
        } else {
          if (waiter === null) {
            return get_SUSPEND_NO_WAITER();
          }
          if (segment.l11(index, state, waiter)) {
            expandBuffer($this);
            return get_SUSPEND();
          }
        }
      } else if (state === get_BUFFERED()) {
        if (segment.l11(index, state, get_DONE_RCV())) {
          expandBuffer($this);
          return segment.h11(index);
        }
      } else if (state === get_INTERRUPTED_SEND())
        return get_FAILED();
      else if (state === get_POISONED())
        return get_FAILED();
      else if (state === get_CHANNEL_CLOSED()) {
        expandBuffer($this);
        return get_FAILED();
      } else if (state === get_RESUMING_BY_EB())
        continue $l$loop;
      else {
        if (segment.l11(index, state, get_RESUMING_BY_RCV())) {
          var helpExpandBuffer = state instanceof WaiterEB;
          var tmp;
          if (state instanceof WaiterEB) {
            tmp = state.p13_1;
          } else {
            tmp = state;
          }
          var sender = tmp;
          var tmp_0;
          if (tryResumeSender($this, sender, segment, index)) {
            segment.k11(index, get_DONE_RCV());
            expandBuffer($this);
            tmp_0 = segment.h11(index);
          } else {
            segment.k11(index, get_INTERRUPTED_SEND());
            segment.z11(index, false);
            if (helpExpandBuffer) {
              expandBuffer($this);
            }
            tmp_0 = get_FAILED();
          }
          return tmp_0;
        }
      }
    }
  }
  function tryResumeSender($this, _this__u8e3s4, segment, index) {
    var tmp;
    if (isInterface(_this__u8e3s4, CancellableContinuation)) {
      if (!isInterface(_this__u8e3s4, CancellableContinuation))
        THROW_CCE();
      tmp = tryResume0(_this__u8e3s4, Unit_instance);
    } else {
      if (isInterface(_this__u8e3s4, SelectInstance)) {
        if (!(_this__u8e3s4 instanceof SelectImplementation))
          THROW_CCE();
        var trySelectResult = _this__u8e3s4.c14($this, Unit_instance);
        if (trySelectResult === TrySelectDetailedResult_REREGISTER_getInstance()) {
          segment.i11(index);
        }
        tmp = trySelectResult === TrySelectDetailedResult_SUCCESSFUL_getInstance();
      } else {
        if (_this__u8e3s4 instanceof SendBroadcast) {
          tmp = tryResume0(_this__u8e3s4.v13_1, true);
        } else {
          var message = 'Unexpected waiter: ' + toString_1(_this__u8e3s4);
          throw IllegalStateException_init_$Create$_0(toString_1(message));
        }
      }
    }
    return tmp;
  }
  function expandBuffer($this) {
    if (_get_isRendezvousOrUnlimited__3mdufi($this))
      return Unit_instance;
    var segment = $this.v11_1.kotlinx$atomicfu$value;
    try_again: while (true) {
      var b = $this.r11_1.atomicfu$getAndIncrement$long();
      // Inline function 'kotlin.Long.div' call
      var other = get_SEGMENT_SIZE();
      var id = divide(b, fromInt_0(other));
      var s = $this.r12();
      if (s <= b) {
        if (segment.ts_1 < id && !(segment.h12() == null)) {
          moveSegmentBufferEndToSpecifiedOrLast($this, id, segment);
        }
        incCompletedExpandBufferAttempts$default($this);
        return Unit_instance;
      }
      if (!(segment.ts_1 === id)) {
        var tmp0_elvis_lhs = findSegmentBufferEnd($this, id, segment, b);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          continue try_again;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        segment = tmp;
      }
      // Inline function 'kotlin.Long.rem' call
      var other_0 = get_SEGMENT_SIZE();
      var tmp$ret$1 = modulo(b, fromInt_0(other_0));
      var i = convertToInt(tmp$ret$1);
      if (updateCellExpandBuffer($this, segment, i, b)) {
        incCompletedExpandBufferAttempts$default($this);
        return Unit_instance;
      } else {
        incCompletedExpandBufferAttempts$default($this);
        continue try_again;
      }
    }
  }
  function updateCellExpandBuffer($this, segment, index, b) {
    var state = segment.j11(index);
    if (!(state == null) ? isInterface(state, Waiter) : false) {
      if (b >= $this.q11_1.kotlinx$atomicfu$value) {
        if (segment.l11(index, state, get_RESUMING_BY_EB())) {
          var tmp;
          if (tryResumeSender($this, state, segment, index)) {
            segment.k11(index, get_BUFFERED());
            tmp = true;
          } else {
            segment.k11(index, get_INTERRUPTED_SEND());
            segment.z11(index, false);
            tmp = false;
          }
          return tmp;
        }
      }
    }
    return updateCellExpandBufferSlow($this, segment, index, b);
  }
  function updateCellExpandBufferSlow($this, segment, index, b) {
    $l$loop: while (true) {
      var state = segment.j11(index);
      if (!(state == null) ? isInterface(state, Waiter) : false) {
        if (b < $this.q11_1.kotlinx$atomicfu$value) {
          if (segment.l11(index, state, new WaiterEB(state)))
            return true;
        } else {
          if (segment.l11(index, state, get_RESUMING_BY_EB())) {
            var tmp;
            if (tryResumeSender($this, state, segment, index)) {
              segment.k11(index, get_BUFFERED());
              tmp = true;
            } else {
              segment.k11(index, get_INTERRUPTED_SEND());
              segment.z11(index, false);
              tmp = false;
            }
            return tmp;
          }
        }
      } else {
        if (state === get_INTERRUPTED_SEND())
          return false;
        else {
          if (state === null) {
            if (segment.l11(index, state, get_IN_BUFFER()))
              return true;
          } else {
            if (state === get_BUFFERED())
              return true;
            else {
              if (state === get_POISONED() || state === get_DONE_RCV() || state === get_INTERRUPTED_RCV())
                return true;
              else {
                if (state === get_CHANNEL_CLOSED())
                  return true;
                else {
                  if (state === get_RESUMING_BY_RCV())
                    continue $l$loop;
                  else {
                    // Inline function 'kotlin.error' call
                    var message = 'Unexpected cell state: ' + toString_0(state);
                    throw IllegalStateException_init_$Create$_0(toString_1(message));
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  function incCompletedExpandBufferAttempts($this, nAttempts) {
    // Inline function 'kotlin.also' call
    // Inline function 'kotlinx.coroutines.channels.ebPauseExpandBuffers' call
    if (!(($this.s11_1.atomicfu$addAndGet$long(nAttempts) & 4611686018427387904n) === 0n)) {
      $l$loop: while (true) {
        // Inline function 'kotlinx.coroutines.channels.ebPauseExpandBuffers' call
        if (!!(($this.s11_1.kotlinx$atomicfu$value & 4611686018427387904n) === 0n)) {
          break $l$loop;
        }
      }
    }
  }
  function incCompletedExpandBufferAttempts$default($this, nAttempts, $super) {
    nAttempts = nAttempts === VOID ? 1n : nAttempts;
    return incCompletedExpandBufferAttempts($this, nAttempts);
  }
  function BufferedChannelIterator($outer) {
    this.p12_1 = $outer;
    this.n12_1 = get_NO_RECEIVE_RESULT();
    this.o12_1 = null;
  }
  protoOf(BufferedChannelIterator).d14 = function ($completion) {
    var tmp = new $hasNextCOROUTINE$(this, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(BufferedChannelIterator).xt = function (segment, index) {
    var tmp0_safe_receiver = this.o12_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.xt(segment, index);
    }
  };
  protoOf(BufferedChannelIterator).o = function () {
    var result = this.n12_1;
    // Inline function 'kotlin.check' call
    if (!!(result === get_NO_RECEIVE_RESULT())) {
      var message = '`hasNext()` has not been invoked';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    this.n12_1 = get_NO_RECEIVE_RESULT();
    if (result === get_CHANNEL_CLOSED())
      throw recoverStackTrace_0(_get_receiveException__foorc1(this.p12_1));
    return (result == null ? true : !(result == null)) ? result : THROW_CCE();
  };
  protoOf(BufferedChannelIterator).q13 = function (element) {
    var cont = ensureNotNull(this.o12_1);
    this.o12_1 = null;
    this.n12_1 = element;
    var tmp0_safe_receiver = this.p12_1.o11_1;
    return tryResume0(cont, true, tmp0_safe_receiver == null ? null : bindCancellationFun(tmp0_safe_receiver, element, cont.l9()));
  };
  protoOf(BufferedChannelIterator).e14 = function () {
    var cont = ensureNotNull(this.o12_1);
    this.o12_1 = null;
    this.n12_1 = get_CHANNEL_CLOSED();
    var cause = this.p12_1.q12();
    if (cause == null) {
      // Inline function 'kotlin.coroutines.resume' call
      // Inline function 'kotlin.Companion.success' call
      var tmp$ret$0 = _Result___init__impl__xyqfz8(false);
      cont.q9(tmp$ret$0);
    } else {
      // Inline function 'kotlin.coroutines.resumeWithException' call
      // Inline function 'kotlin.Companion.failure' call
      var exception = recoverStackTrace(cause, cont);
      var tmp$ret$2 = _Result___init__impl__xyqfz8(createFailure(exception));
      cont.q9(tmp$ret$2);
    }
  };
  function _get_receiveException__foorc1($this) {
    var tmp0_elvis_lhs = $this.q12();
    return tmp0_elvis_lhs == null ? new ClosedReceiveChannelException('Channel was closed') : tmp0_elvis_lhs;
  }
  function invokeCloseHandler($this) {
    var tmp0 = $this.y11_1;
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlinx.atomicfu.getAndUpdate' call
      while (true) {
        var cur = tmp0.kotlinx$atomicfu$value;
        var tmp;
        if (cur === null) {
          tmp = get_CLOSE_HANDLER_CLOSED();
        } else {
          tmp = get_CLOSE_HANDLER_INVOKED();
        }
        var upd = tmp;
        if (tmp0.atomicfu$compareAndSet(cur, upd)) {
          tmp$ret$1 = cur;
          break $l$block;
        }
      }
    }
    var tmp0_elvis_lhs = tmp$ret$1;
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var closeHandler = tmp_0;
    if (typeof closeHandler !== 'function')
      THROW_CCE();
    closeHandler($this.q12());
  }
  function markClosed($this) {
    var tmp0 = $this.p11_1;
    var tmp$ret$4;
    $l$block: {
      // Inline function 'kotlinx.atomicfu.update' call
      while (true) {
        var cur = tmp0.kotlinx$atomicfu$value;
        // Inline function 'kotlinx.coroutines.channels.sendersCloseStatus' call
        var tmp;
        switch (convertToInt(shiftRight(cur, 60))) {
          case 0:
            // Inline function 'kotlinx.coroutines.channels.sendersCounter' call

            var tmp$ret$1 = cur & 1152921504606846975n;
            tmp = constructSendersAndCloseStatus(tmp$ret$1, 2);
            break;
          case 1:
            // Inline function 'kotlinx.coroutines.channels.sendersCounter' call

            var tmp$ret$2 = cur & 1152921504606846975n;
            tmp = constructSendersAndCloseStatus(tmp$ret$2, 3);
            break;
          default:
            return Unit_instance;
        }
        var upd = tmp;
        if (tmp0.atomicfu$compareAndSet(cur, upd)) {
          tmp$ret$4 = Unit_instance;
          break $l$block;
        }
      }
      tmp$ret$4 = Unit_instance;
    }
    return tmp$ret$4;
  }
  function markCancelled($this) {
    var tmp0 = $this.p11_1;
    var tmp$ret$2;
    $l$block: {
      // Inline function 'kotlinx.atomicfu.update' call
      while (true) {
        var cur = tmp0.kotlinx$atomicfu$value;
        // Inline function 'kotlinx.coroutines.channels.sendersCounter' call
        var tmp$ret$0 = cur & 1152921504606846975n;
        var upd = constructSendersAndCloseStatus(tmp$ret$0, 3);
        if (tmp0.atomicfu$compareAndSet(cur, upd)) {
          tmp$ret$2 = Unit_instance;
          break $l$block;
        }
      }
      tmp$ret$2 = Unit_instance;
    }
    return tmp$ret$2;
  }
  function markCancellationStarted($this) {
    var tmp0 = $this.p11_1;
    var tmp$ret$3;
    $l$block: {
      // Inline function 'kotlinx.atomicfu.update' call
      while (true) {
        var cur = tmp0.kotlinx$atomicfu$value;
        var tmp;
        // Inline function 'kotlinx.coroutines.channels.sendersCloseStatus' call
        if (convertToInt(shiftRight(cur, 60)) === 0) {
          // Inline function 'kotlinx.coroutines.channels.sendersCounter' call
          var tmp$ret$1 = cur & 1152921504606846975n;
          tmp = constructSendersAndCloseStatus(tmp$ret$1, 1);
        } else {
          return Unit_instance;
        }
        var upd = tmp;
        if (tmp0.atomicfu$compareAndSet(cur, upd)) {
          tmp$ret$3 = Unit_instance;
          break $l$block;
        }
      }
      tmp$ret$3 = Unit_instance;
    }
    return tmp$ret$3;
  }
  function completeCloseOrCancel($this) {
    $this.f14();
  }
  function completeClose($this, sendersCur) {
    var lastSegment = closeLinkedList($this);
    if ($this.h14()) {
      var lastBufferedCellGlobalIndex = markAllEmptyCellsAsClosed($this, lastSegment);
      if (!(lastBufferedCellGlobalIndex === -1n)) {
        $this.g14(lastBufferedCellGlobalIndex);
      }
    }
    cancelSuspendedReceiveRequests($this, lastSegment, sendersCur);
    return lastSegment;
  }
  function completeCancel($this, sendersCur) {
    var lastSegment = completeClose($this, sendersCur);
    removeUnprocessedElements($this, lastSegment);
  }
  function closeLinkedList($this) {
    var lastSegment = $this.v11_1.kotlinx$atomicfu$value;
    // Inline function 'kotlin.let' call
    var it = $this.t11_1.kotlinx$atomicfu$value;
    if (it.ts_1 > lastSegment.ts_1)
      lastSegment = it;
    // Inline function 'kotlin.let' call
    var it_0 = $this.u11_1.kotlinx$atomicfu$value;
    if (it_0.ts_1 > lastSegment.ts_1)
      lastSegment = it_0;
    return close_0(lastSegment);
  }
  function markAllEmptyCellsAsClosed($this, lastSegment) {
    var segment = lastSegment;
    while (true) {
      var inductionVariable = get_SEGMENT_SIZE() - 1 | 0;
      if (0 <= inductionVariable)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + -1 | 0;
          var tmp0 = segment.ts_1;
          // Inline function 'kotlin.Long.times' call
          var other = get_SEGMENT_SIZE();
          // Inline function 'kotlin.Long.plus' call
          var this_0 = multiply_0(tmp0, fromInt_0(other));
          var globalIndex = add_2(this_0, fromInt_0(index));
          if (globalIndex < $this.n13())
            return -1n;
          cell_update: while (true) {
            var state = segment.j11(index);
            if (state === null || state === get_IN_BUFFER()) {
              if (segment.l11(index, state, get_CHANNEL_CLOSED())) {
                segment.b12();
                break cell_update;
              }
            } else if (state === get_BUFFERED())
              return globalIndex;
            else
              break cell_update;
          }
        }
         while (0 <= inductionVariable);
      var tmp1_elvis_lhs = segment.k12();
      var tmp;
      if (tmp1_elvis_lhs == null) {
        return -1n;
      } else {
        tmp = tmp1_elvis_lhs;
      }
      segment = tmp;
    }
  }
  function removeUnprocessedElements($this, lastSegment) {
    var onUndeliveredElement = $this.o11_1;
    var undeliveredElementException = null;
    var suspendedSenders = _InlineList___init__impl__z8n56();
    var segment = lastSegment;
    process_segments: while (true) {
      var inductionVariable = get_SEGMENT_SIZE() - 1 | 0;
      if (0 <= inductionVariable)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + -1 | 0;
          var tmp0 = segment.ts_1;
          // Inline function 'kotlin.Long.times' call
          var other = get_SEGMENT_SIZE();
          // Inline function 'kotlin.Long.plus' call
          var this_0 = multiply_0(tmp0, fromInt_0(other));
          var globalIndex = add_2(this_0, fromInt_0(index));
          update_cell: while (true) {
            var state = segment.j11(index);
            if (state === get_DONE_RCV())
              break process_segments;
            else {
              if (state === get_BUFFERED()) {
                if (globalIndex < $this.n13())
                  break process_segments;
                if (segment.l11(index, state, get_CHANNEL_CLOSED())) {
                  if (!(onUndeliveredElement == null)) {
                    var element = segment.g11(index);
                    undeliveredElementException = callUndeliveredElementCatchingException(onUndeliveredElement, element, undeliveredElementException);
                  }
                  segment.i11(index);
                  segment.b12();
                  break update_cell;
                }
              } else {
                if (state === get_IN_BUFFER() || state === null) {
                  if (segment.l11(index, state, get_CHANNEL_CLOSED())) {
                    segment.b12();
                    break update_cell;
                  }
                } else {
                  var tmp;
                  if (!(state == null) ? isInterface(state, Waiter) : false) {
                    tmp = true;
                  } else {
                    tmp = state instanceof WaiterEB;
                  }
                  if (tmp) {
                    if (globalIndex < $this.n13())
                      break process_segments;
                    var tmp_0;
                    if (state instanceof WaiterEB) {
                      tmp_0 = state.p13_1;
                    } else {
                      tmp_0 = (!(state == null) ? isInterface(state, Waiter) : false) ? state : THROW_CCE();
                    }
                    var sender = tmp_0;
                    if (segment.l11(index, state, get_CHANNEL_CLOSED())) {
                      if (!(onUndeliveredElement == null)) {
                        var element_0 = segment.g11(index);
                        undeliveredElementException = callUndeliveredElementCatchingException(onUndeliveredElement, element_0, undeliveredElementException);
                      }
                      suspendedSenders = InlineList__plus_impl_nuetvo(suspendedSenders, sender);
                      segment.i11(index);
                      segment.b12();
                      break update_cell;
                    }
                  } else {
                    if (state === get_RESUMING_BY_EB() || state === get_RESUMING_BY_RCV())
                      break process_segments;
                    else {
                      if (state === get_RESUMING_BY_EB())
                        continue update_cell;
                      else {
                        break update_cell;
                      }
                    }
                  }
                }
              }
            }
          }
        }
         while (0 <= inductionVariable);
      var tmp1_elvis_lhs = segment.k12();
      var tmp_1;
      if (tmp1_elvis_lhs == null) {
        break process_segments;
      } else {
        tmp_1 = tmp1_elvis_lhs;
      }
      segment = tmp_1;
    }
    var tmp0_0 = suspendedSenders;
    $l$block: {
      // Inline function 'kotlinx.coroutines.internal.InlineList.forEachReversed' call
      var tmp0_subject = access$_get_holder__kkflen(tmp0_0);
      if (tmp0_subject == null) {
        break $l$block;
      } else {
        if (!(tmp0_subject instanceof ArrayList)) {
          var tmp_2 = access$_get_holder__kkflen(tmp0_0);
          var it = (tmp_2 == null ? true : !(tmp_2 == null)) ? tmp_2 : THROW_CCE();
          resumeSenderOnCancelledChannel($this, it);
        } else {
          var tmp_3 = access$_get_holder__kkflen(tmp0_0);
          var list = tmp_3 instanceof ArrayList ? tmp_3 : THROW_CCE();
          var inductionVariable_0 = list.p() - 1 | 0;
          if (0 <= inductionVariable_0)
            do {
              var i = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + -1 | 0;
              var it_0 = list.r(i);
              resumeSenderOnCancelledChannel($this, it_0);
            }
             while (0 <= inductionVariable_0);
        }
      }
    }
    var tmp2_safe_receiver = undeliveredElementException;
    if (tmp2_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      throw tmp2_safe_receiver;
    }
  }
  function cancelSuspendedReceiveRequests($this, lastSegment, sendersCounter) {
    var suspendedReceivers = _InlineList___init__impl__z8n56();
    var segment = lastSegment;
    process_segments: while (!(segment == null)) {
      var inductionVariable = get_SEGMENT_SIZE() - 1 | 0;
      if (0 <= inductionVariable)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + -1 | 0;
          var tmp0 = segment.ts_1;
          // Inline function 'kotlin.Long.times' call
          var other = get_SEGMENT_SIZE();
          // Inline function 'kotlin.Long.plus' call
          var this_0 = multiply_0(tmp0, fromInt_0(other));
          if (add_2(this_0, fromInt_0(index)) < sendersCounter)
            break process_segments;
          cell_update: while (true) {
            var state = segment.j11(index);
            if (state === null || state === get_IN_BUFFER()) {
              if (segment.l11(index, state, get_CHANNEL_CLOSED())) {
                segment.b12();
                break cell_update;
              }
            } else {
              if (state instanceof WaiterEB) {
                if (segment.l11(index, state, get_CHANNEL_CLOSED())) {
                  suspendedReceivers = InlineList__plus_impl_nuetvo(suspendedReceivers, state.p13_1);
                  segment.z11(index, true);
                  break cell_update;
                }
              } else {
                if (!(state == null) ? isInterface(state, Waiter) : false) {
                  if (segment.l11(index, state, get_CHANNEL_CLOSED())) {
                    suspendedReceivers = InlineList__plus_impl_nuetvo(suspendedReceivers, state);
                    segment.z11(index, true);
                    break cell_update;
                  }
                } else {
                  break cell_update;
                }
              }
            }
          }
        }
         while (0 <= inductionVariable);
      segment = segment.k12();
    }
    var tmp0_0 = suspendedReceivers;
    $l$block: {
      // Inline function 'kotlinx.coroutines.internal.InlineList.forEachReversed' call
      var tmp0_subject = access$_get_holder__kkflen(tmp0_0);
      if (tmp0_subject == null) {
        break $l$block;
      } else {
        if (!(tmp0_subject instanceof ArrayList)) {
          var tmp = access$_get_holder__kkflen(tmp0_0);
          var it = (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
          resumeReceiverOnClosedChannel($this, it);
        } else {
          var tmp_0 = access$_get_holder__kkflen(tmp0_0);
          var list = tmp_0 instanceof ArrayList ? tmp_0 : THROW_CCE();
          var inductionVariable_0 = list.p() - 1 | 0;
          if (0 <= inductionVariable_0)
            do {
              var i = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + -1 | 0;
              var it_0 = list.r(i);
              resumeReceiverOnClosedChannel($this, it_0);
            }
             while (0 <= inductionVariable_0);
        }
      }
    }
  }
  function resumeReceiverOnClosedChannel($this, _this__u8e3s4) {
    return resumeWaiterOnClosedChannel($this, _this__u8e3s4, true);
  }
  function resumeSenderOnCancelledChannel($this, _this__u8e3s4) {
    return resumeWaiterOnClosedChannel($this, _this__u8e3s4, false);
  }
  function resumeWaiterOnClosedChannel($this, _this__u8e3s4, receiver) {
    if (_this__u8e3s4 instanceof SendBroadcast) {
      // Inline function 'kotlin.coroutines.resume' call
      var this_0 = _this__u8e3s4.v13_1;
      // Inline function 'kotlin.Companion.success' call
      var tmp$ret$0 = _Result___init__impl__xyqfz8(false);
      this_0.q9(tmp$ret$0);
    } else {
      if (isInterface(_this__u8e3s4, CancellableContinuation)) {
        // Inline function 'kotlin.coroutines.resumeWithException' call
        // Inline function 'kotlin.Companion.failure' call
        var exception = receiver ? _get_receiveException__foorc1($this) : $this.m13();
        var tmp$ret$2 = _Result___init__impl__xyqfz8(createFailure(exception));
        _this__u8e3s4.q9(tmp$ret$2);
      } else {
        if (_this__u8e3s4 instanceof ReceiveCatching) {
          var tmp0 = _this__u8e3s4.t13_1;
          // Inline function 'kotlin.coroutines.resume' call
          // Inline function 'kotlin.Companion.success' call
          var value = new ChannelResult(Companion_getInstance_22().i14($this.q12()));
          var tmp$ret$4 = _Result___init__impl__xyqfz8(value);
          tmp0.q9(tmp$ret$4);
        } else {
          if (_this__u8e3s4 instanceof BufferedChannelIterator) {
            _this__u8e3s4.e14();
          } else {
            if (isInterface(_this__u8e3s4, SelectInstance)) {
              _this__u8e3s4.fx($this, get_CHANNEL_CLOSED());
            } else {
              // Inline function 'kotlin.error' call
              var message = 'Unexpected waiter: ' + toString_1(_this__u8e3s4);
              throw IllegalStateException_init_$Create$_0(toString_1(message));
            }
          }
        }
      }
    }
  }
  function _get_isClosedForSend0__kxgf9m($this, _this__u8e3s4) {
    return isClosed($this, _this__u8e3s4, false);
  }
  function _get_isClosedForReceive0__f7qknl($this, _this__u8e3s4) {
    return isClosed($this, _this__u8e3s4, true);
  }
  function isClosed($this, sendersAndCloseStatusCur, isClosedForReceive) {
    // Inline function 'kotlinx.coroutines.channels.sendersCloseStatus' call
    var tmp;
    switch (convertToInt(shiftRight(sendersAndCloseStatusCur, 60))) {
      case 0:
        tmp = false;
        break;
      case 1:
        tmp = false;
        break;
      case 2:
        // Inline function 'kotlinx.coroutines.channels.sendersCounter' call

        var tmp$ret$1 = sendersAndCloseStatusCur & 1152921504606846975n;
        completeClose($this, tmp$ret$1);
        tmp = isClosedForReceive ? !$this.j14() : true;
        break;
      case 3:
        // Inline function 'kotlinx.coroutines.channels.sendersCounter' call

        var tmp$ret$2 = sendersAndCloseStatusCur & 1152921504606846975n;
        completeCancel($this, tmp$ret$2);
        tmp = true;
        break;
      default:
        // Inline function 'kotlinx.coroutines.channels.sendersCloseStatus' call

        var message = 'unexpected close status: ' + convertToInt(shiftRight(sendersAndCloseStatusCur, 60));
        throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    return tmp;
  }
  function isCellNonEmpty($this, segment, index, globalIndex) {
    while (true) {
      var state = segment.j11(index);
      if (state === null || state === get_IN_BUFFER()) {
        if (segment.l11(index, state, get_POISONED())) {
          expandBuffer($this);
          return false;
        }
      } else if (state === get_BUFFERED())
        return true;
      else if (state === get_INTERRUPTED_SEND())
        return false;
      else if (state === get_CHANNEL_CLOSED())
        return false;
      else if (state === get_DONE_RCV())
        return false;
      else if (state === get_POISONED())
        return false;
      else if (state === get_RESUMING_BY_EB())
        return true;
      else if (state === get_RESUMING_BY_RCV())
        return false;
      else
        return globalIndex === $this.n13();
    }
  }
  function findSegmentSend($this, id, startFrom) {
    var tmp0 = $this.t11_1;
    var tmp6 = createSegmentFunction();
    var tmp$ret$2;
    $l$block_2: {
      // Inline function 'kotlinx.coroutines.internal.findSegmentAndMoveForward' call
      while (true) {
        var s = findSegmentInternal(startFrom, id, tmp6);
        var tmp;
        if (_SegmentOrClosed___get_isClosed__impl__qmxmlo(s)) {
          tmp = true;
        } else {
          var tmp2 = _SegmentOrClosed___get_segment__impl__jvcr9l(s);
          var tmp$ret$0;
          $l$block_1: {
            // Inline function 'kotlinx.coroutines.internal.moveForward' call
            while (true) {
              var cur = tmp0.kotlinx$atomicfu$value;
              if (cur.ts_1 >= tmp2.ts_1) {
                tmp$ret$0 = true;
                break $l$block_1;
              }
              if (!tmp2.d12()) {
                tmp$ret$0 = false;
                break $l$block_1;
              }
              if (tmp0.atomicfu$compareAndSet(cur, tmp2)) {
                if (cur.e12()) {
                  cur.h4();
                }
                tmp$ret$0 = true;
                break $l$block_1;
              }
              if (tmp2.e12()) {
                tmp2.h4();
              }
            }
            tmp$ret$0 = Unit_instance;
          }
          tmp = tmp$ret$0;
        }
        if (tmp) {
          tmp$ret$2 = s;
          break $l$block_2;
        }
      }
    }
    // Inline function 'kotlin.let' call
    var it = tmp$ret$2;
    var tmp_0;
    if (_SegmentOrClosed___get_isClosed__impl__qmxmlo(it)) {
      completeCloseOrCancel($this);
      var tmp0_0 = startFrom.ts_1;
      // Inline function 'kotlin.Long.times' call
      var other = get_SEGMENT_SIZE();
      if (multiply_0(tmp0_0, fromInt_0(other)) < $this.n13()) {
        startFrom.l12();
      }
      tmp_0 = null;
    } else {
      var segment = _SegmentOrClosed___get_segment__impl__jvcr9l(it);
      var tmp_1;
      if (segment.ts_1 > id) {
        var tmp0_1 = segment.ts_1;
        // Inline function 'kotlin.Long.times' call
        var other_0 = get_SEGMENT_SIZE();
        var tmp$ret$4 = multiply_0(tmp0_1, fromInt_0(other_0));
        updateSendersCounterIfLower($this, tmp$ret$4);
        var tmp0_2 = segment.ts_1;
        // Inline function 'kotlin.Long.times' call
        var other_1 = get_SEGMENT_SIZE();
        if (multiply_0(tmp0_2, fromInt_0(other_1)) < $this.n13()) {
          segment.l12();
        }
        tmp_1 = null;
      } else {
        // Inline function 'kotlinx.coroutines.assert' call
        tmp_1 = segment;
      }
      tmp_0 = tmp_1;
    }
    return tmp_0;
  }
  function findSegmentReceive($this, id, startFrom) {
    var tmp0 = $this.u11_1;
    var tmp6 = createSegmentFunction();
    var tmp$ret$2;
    $l$block_2: {
      // Inline function 'kotlinx.coroutines.internal.findSegmentAndMoveForward' call
      while (true) {
        var s = findSegmentInternal(startFrom, id, tmp6);
        var tmp;
        if (_SegmentOrClosed___get_isClosed__impl__qmxmlo(s)) {
          tmp = true;
        } else {
          var tmp2 = _SegmentOrClosed___get_segment__impl__jvcr9l(s);
          var tmp$ret$0;
          $l$block_1: {
            // Inline function 'kotlinx.coroutines.internal.moveForward' call
            while (true) {
              var cur = tmp0.kotlinx$atomicfu$value;
              if (cur.ts_1 >= tmp2.ts_1) {
                tmp$ret$0 = true;
                break $l$block_1;
              }
              if (!tmp2.d12()) {
                tmp$ret$0 = false;
                break $l$block_1;
              }
              if (tmp0.atomicfu$compareAndSet(cur, tmp2)) {
                if (cur.e12()) {
                  cur.h4();
                }
                tmp$ret$0 = true;
                break $l$block_1;
              }
              if (tmp2.e12()) {
                tmp2.h4();
              }
            }
            tmp$ret$0 = Unit_instance;
          }
          tmp = tmp$ret$0;
        }
        if (tmp) {
          tmp$ret$2 = s;
          break $l$block_2;
        }
      }
    }
    // Inline function 'kotlin.let' call
    var it = tmp$ret$2;
    var tmp_0;
    if (_SegmentOrClosed___get_isClosed__impl__qmxmlo(it)) {
      completeCloseOrCancel($this);
      var tmp0_0 = startFrom.ts_1;
      // Inline function 'kotlin.Long.times' call
      var other = get_SEGMENT_SIZE();
      if (multiply_0(tmp0_0, fromInt_0(other)) < $this.r12()) {
        startFrom.l12();
      }
      tmp_0 = null;
    } else {
      var segment = _SegmentOrClosed___get_segment__impl__jvcr9l(it);
      var tmp_1;
      if (!_get_isRendezvousOrUnlimited__3mdufi($this)) {
        var tmp0_1 = _get_bufferEndCounter__2d4hee($this);
        // Inline function 'kotlin.Long.div' call
        var other_0 = get_SEGMENT_SIZE();
        tmp_1 = id <= divide(tmp0_1, fromInt_0(other_0));
      } else {
        tmp_1 = false;
      }
      if (tmp_1) {
        var tmp0_2 = $this.v11_1;
        $l$block_5: {
          // Inline function 'kotlinx.coroutines.internal.moveForward' call
          while (true) {
            var cur_0 = tmp0_2.kotlinx$atomicfu$value;
            if (cur_0.ts_1 >= segment.ts_1) {
              break $l$block_5;
            }
            if (!segment.d12()) {
              break $l$block_5;
            }
            if (tmp0_2.atomicfu$compareAndSet(cur_0, segment)) {
              if (cur_0.e12()) {
                cur_0.h4();
              }
              break $l$block_5;
            }
            if (segment.e12()) {
              segment.h4();
            }
          }
        }
      }
      var tmp_2;
      if (segment.ts_1 > id) {
        var tmp0_3 = segment.ts_1;
        // Inline function 'kotlin.Long.times' call
        var other_1 = get_SEGMENT_SIZE();
        var tmp$ret$7 = multiply_0(tmp0_3, fromInt_0(other_1));
        updateReceiversCounterIfLower($this, tmp$ret$7);
        var tmp0_4 = segment.ts_1;
        // Inline function 'kotlin.Long.times' call
        var other_2 = get_SEGMENT_SIZE();
        if (multiply_0(tmp0_4, fromInt_0(other_2)) < $this.r12()) {
          segment.l12();
        }
        tmp_2 = null;
      } else {
        // Inline function 'kotlinx.coroutines.assert' call
        tmp_2 = segment;
      }
      tmp_0 = tmp_2;
    }
    return tmp_0;
  }
  function findSegmentBufferEnd($this, id, startFrom, currentBufferEndCounter) {
    var tmp0 = $this.v11_1;
    var tmp6 = createSegmentFunction();
    var tmp$ret$2;
    $l$block_2: {
      // Inline function 'kotlinx.coroutines.internal.findSegmentAndMoveForward' call
      while (true) {
        var s = findSegmentInternal(startFrom, id, tmp6);
        var tmp;
        if (_SegmentOrClosed___get_isClosed__impl__qmxmlo(s)) {
          tmp = true;
        } else {
          var tmp2 = _SegmentOrClosed___get_segment__impl__jvcr9l(s);
          var tmp$ret$0;
          $l$block_1: {
            // Inline function 'kotlinx.coroutines.internal.moveForward' call
            while (true) {
              var cur = tmp0.kotlinx$atomicfu$value;
              if (cur.ts_1 >= tmp2.ts_1) {
                tmp$ret$0 = true;
                break $l$block_1;
              }
              if (!tmp2.d12()) {
                tmp$ret$0 = false;
                break $l$block_1;
              }
              if (tmp0.atomicfu$compareAndSet(cur, tmp2)) {
                if (cur.e12()) {
                  cur.h4();
                }
                tmp$ret$0 = true;
                break $l$block_1;
              }
              if (tmp2.e12()) {
                tmp2.h4();
              }
            }
            tmp$ret$0 = Unit_instance;
          }
          tmp = tmp$ret$0;
        }
        if (tmp) {
          tmp$ret$2 = s;
          break $l$block_2;
        }
      }
    }
    // Inline function 'kotlin.let' call
    var it = tmp$ret$2;
    var tmp_0;
    if (_SegmentOrClosed___get_isClosed__impl__qmxmlo(it)) {
      completeCloseOrCancel($this);
      moveSegmentBufferEndToSpecifiedOrLast($this, id, startFrom);
      incCompletedExpandBufferAttempts$default($this);
      tmp_0 = null;
    } else {
      var segment = _SegmentOrClosed___get_segment__impl__jvcr9l(it);
      var tmp_1;
      if (segment.ts_1 > id) {
        // Inline function 'kotlin.Long.plus' call
        var tmp_2 = add_2(currentBufferEndCounter, fromInt_0(1));
        var tmp0_0 = segment.ts_1;
        // Inline function 'kotlin.Long.times' call
        var other = get_SEGMENT_SIZE();
        var tmp$ret$4 = multiply_0(tmp0_0, fromInt_0(other));
        if ($this.r11_1.atomicfu$compareAndSet(tmp_2, tmp$ret$4)) {
          var tmp0_1 = segment.ts_1;
          // Inline function 'kotlin.Long.times' call
          var other_0 = get_SEGMENT_SIZE();
          var tmp$ret$5 = multiply_0(tmp0_1, fromInt_0(other_0));
          incCompletedExpandBufferAttempts($this, subtract_1(tmp$ret$5, currentBufferEndCounter));
        } else {
          incCompletedExpandBufferAttempts$default($this);
        }
        tmp_1 = null;
      } else {
        // Inline function 'kotlinx.coroutines.assert' call
        tmp_1 = segment;
      }
      tmp_0 = tmp_1;
    }
    return tmp_0;
  }
  function moveSegmentBufferEndToSpecifiedOrLast($this, id, startFrom) {
    var segment = startFrom;
    $l$loop: while (segment.ts_1 < id) {
      var tmp0_elvis_lhs = segment.h12();
      var tmp;
      if (tmp0_elvis_lhs == null) {
        break $l$loop;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      segment = tmp;
    }
    while (true) {
      $l$loop_0: while (segment.c12()) {
        var tmp1_elvis_lhs = segment.h12();
        var tmp_0;
        if (tmp1_elvis_lhs == null) {
          break $l$loop_0;
        } else {
          tmp_0 = tmp1_elvis_lhs;
        }
        segment = tmp_0;
      }
      var tmp0 = $this.v11_1;
      var tmp2 = segment;
      var tmp$ret$0;
      $l$block_1: {
        // Inline function 'kotlinx.coroutines.internal.moveForward' call
        while (true) {
          var cur = tmp0.kotlinx$atomicfu$value;
          if (cur.ts_1 >= tmp2.ts_1) {
            tmp$ret$0 = true;
            break $l$block_1;
          }
          if (!tmp2.d12()) {
            tmp$ret$0 = false;
            break $l$block_1;
          }
          if (tmp0.atomicfu$compareAndSet(cur, tmp2)) {
            if (cur.e12()) {
              cur.h4();
            }
            tmp$ret$0 = true;
            break $l$block_1;
          }
          if (tmp2.e12()) {
            tmp2.h4();
          }
        }
        tmp$ret$0 = Unit_instance;
      }
      if (tmp$ret$0)
        return Unit_instance;
    }
  }
  function updateSendersCounterIfLower($this, value) {
    var this_0 = $this.p11_1;
    while (true) {
      var cur = this_0.kotlinx$atomicfu$value;
      // Inline function 'kotlinx.coroutines.channels.sendersCounter' call
      var curCounter = cur & 1152921504606846975n;
      if (curCounter >= value)
        return Unit_instance;
      // Inline function 'kotlinx.coroutines.channels.sendersCloseStatus' call
      var tmp$ret$1 = convertToInt(shiftRight(cur, 60));
      var update = constructSendersAndCloseStatus(curCounter, tmp$ret$1);
      if ($this.p11_1.atomicfu$compareAndSet(cur, update))
        return Unit_instance;
    }
    return Unit_instance;
  }
  function updateReceiversCounterIfLower($this, value) {
    var this_0 = $this.q11_1;
    while (true) {
      var cur = this_0.kotlinx$atomicfu$value;
      if (cur >= value)
        return Unit_instance;
      if ($this.q11_1.atomicfu$compareAndSet(cur, value))
        return Unit_instance;
    }
    return Unit_instance;
  }
  function access$_get_sendersAndCloseStatus__tvw29s($this) {
    return $this.p11_1;
  }
  function access$_get_sendSegment__111kgq($this) {
    return $this.t11_1;
  }
  function access$prepareSenderForSuspension($this, $receiver, segment, index) {
    return prepareSenderForSuspension($this, $receiver, segment, index);
  }
  function access$updateCellSend($this, segment, index, element, s, waiter, closed) {
    return updateCellSend($this, segment, index, element, s, waiter, closed);
  }
  function access$_get_isClosedForSend0__sm8f7a($this, $receiver) {
    return _get_isClosedForSend0__kxgf9m($this, $receiver);
  }
  function access$findSegmentSend($this, id, startFrom) {
    return findSegmentSend($this, id, startFrom);
  }
  function BufferedChannel$onUndeliveredElementReceiveCancellationConstructor$lambda$lambda($element, this$0, $select) {
    return function (it) {
      var tmp;
      if (!($element === get_CHANNEL_CLOSED())) {
        callUndeliveredElement(this$0.o11_1, ($element == null ? true : !($element == null)) ? $element : THROW_CCE(), $select.l9());
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function BufferedChannel$onUndeliveredElementReceiveCancellationConstructor$lambda(this$0) {
    return function (select, _anonymous_parameter_1__qggqgd, element) {
      return BufferedChannel$onUndeliveredElementReceiveCancellationConstructor$lambda$lambda(element, this$0, select);
    };
  }
  function $sendCOROUTINE$(_this__u8e3s4, element, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.t14_1 = _this__u8e3s4;
    this.u14_1 = element;
  }
  protoOf($sendCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 11;
            var tmp_0 = this;
            tmp_0.f15_1 = this.t14_1;
            var tmp_1 = this;
            tmp_1.e15_1 = this.u14_1;
            var tmp_2 = this;
            tmp_2.d15_1 = null;
            this.f9_1 = 1;
            continue $sm;
          case 1:
            this.x14_1 = this.f15_1;
            this.a15_1 = this.e15_1;
            this.y14_1 = this.d15_1;
            this.w14_1 = access$_get_sendSegment__111kgq(this.x14_1).kotlinx$atomicfu$value;
            this.f9_1 = 2;
            continue $sm;
          case 2:
            if (!true) {
              this.f9_1 = 12;
              continue $sm;
            }

            var sendersAndCloseStatusCur = access$_get_sendersAndCloseStatus__tvw29s(this.x14_1).atomicfu$getAndIncrement$long();
            var tmp_3 = this;
            tmp_3.z14_1 = sendersAndCloseStatusCur & access$_get_SENDERS_COUNTER_MASK_$tBufferedChannelKt_6ll4te();
            this.b15_1 = access$_get_isClosedForSend0__sm8f7a(this.x14_1, sendersAndCloseStatusCur);
            var tmp0 = this.z14_1;
            var other = get_SEGMENT_SIZE();
            var id = divide(tmp0, fromInt_0(other));
            var tmp_4 = this;
            var tmp0_0 = this.z14_1;
            var other_0 = get_SEGMENT_SIZE();
            tmp_4.v14_1 = convertToInt(modulo(tmp0_0, fromInt_0(other_0)));
            if (!(this.w14_1.ts_1 === id)) {
              var tmp0_elvis_lhs = access$findSegmentSend(this.x14_1, id, this.w14_1);
              if (tmp0_elvis_lhs == null) {
                if (this.b15_1) {
                  this.f9_1 = 10;
                  suspendResult = onClosedSend(this.t14_1, this.u14_1, this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  continue $sm;
                } else {
                  this.f9_1 = 2;
                  var tmp_5 = this;
                  continue $sm;
                }
              } else {
                this.c15_1 = tmp0_elvis_lhs;
                this.f9_1 = 3;
                continue $sm;
              }
            } else {
              this.f9_1 = 4;
              continue $sm;
            }

          case 3:
            this.w14_1 = this.c15_1;
            this.f9_1 = 4;
            continue $sm;
          case 4:
            var tmp1_subject = access$updateCellSend(this.x14_1, this.w14_1, this.v14_1, this.a15_1, this.z14_1, this.y14_1, this.b15_1);
            if (tmp1_subject === access$_get_RESULT_RENDEZVOUS_$tBufferedChannelKt_ykevfn()) {
              this.w14_1.l12();
              this.f9_1 = 13;
              continue $sm;
            } else {
              if (tmp1_subject === access$_get_RESULT_BUFFERED_$tBufferedChannelKt_tnykj7()) {
                this.f9_1 = 13;
                continue $sm;
              } else {
                if (tmp1_subject === access$_get_RESULT_SUSPEND_$tBufferedChannelKt_vus6es()) {
                  if (this.b15_1) {
                    this.w14_1.b12();
                    this.f9_1 = 9;
                    suspendResult = onClosedSend(this.t14_1, this.u14_1, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) {
                      return suspendResult;
                    }
                    continue $sm;
                  } else {
                    this.f9_1 = 8;
                    continue $sm;
                  }
                } else {
                  if (tmp1_subject === access$_get_RESULT_CLOSED_$tBufferedChannelKt_3eqb16()) {
                    if (this.z14_1 < this.x14_1.n13()) {
                      this.w14_1.l12();
                    }
                    this.f9_1 = 7;
                    suspendResult = onClosedSend(this.t14_1, this.u14_1, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) {
                      return suspendResult;
                    }
                    continue $sm;
                  } else {
                    if (tmp1_subject === access$_get_RESULT_FAILED_$tBufferedChannelKt_wacckr()) {
                      this.w14_1.l12();
                      this.f9_1 = 2;
                      continue $sm;
                    } else {
                      if (tmp1_subject === access$_get_RESULT_SUSPEND_NO_WAITER_$tBufferedChannelKt_61h09f()) {
                        var tmp0_1 = this.w14_1;
                        var tmp2 = this.v14_1;
                        var tmp4 = this.a15_1;
                        var s = this.z14_1;
                        this.f9_1 = 6;
                        suspendResult = sendOnNoWaiterSuspend(this.t14_1, tmp0_1, tmp2, tmp4, s, this);
                        if (suspendResult === get_COROUTINE_SUSPENDED()) {
                          return suspendResult;
                        }
                        continue $sm;
                      } else {
                        this.f9_1 = 5;
                        continue $sm;
                      }
                    }
                  }
                }
              }
            }

          case 5:
            this.f9_1 = 2;
            continue $sm;
          case 6:
            this.f9_1 = 13;
            continue $sm;
          case 7:
            this.f9_1 = 13;
            continue $sm;
          case 8:
            var tmp_6 = this.y14_1;
            var tmp2_safe_receiver = (!(tmp_6 == null) ? isInterface(tmp_6, Waiter) : false) ? tmp_6 : null;
            if (tmp2_safe_receiver == null)
              null;
            else {
              access$prepareSenderForSuspension(this.x14_1, tmp2_safe_receiver, this.w14_1, this.v14_1);
            }

            this.w14_1;
            this.v14_1;
            this.f9_1 = 13;
            continue $sm;
          case 9:
            this.f9_1 = 13;
            continue $sm;
          case 10:
            this.f9_1 = 13;
            continue $sm;
          case 11:
            throw this.i9_1;
          case 12:
            if (false) {
              this.f9_1 = 1;
              continue $sm;
            }

            this.f9_1 = 13;
            continue $sm;
          case 13:
            return Unit_instance;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 11) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function $receiveCOROUTINE$(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.o15_1 = _this__u8e3s4;
  }
  protoOf($receiveCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 8;
            var tmp_0 = this;
            tmp_0.y15_1 = this.o15_1;
            var tmp_1 = this;
            tmp_1.x15_1 = null;
            this.f9_1 = 1;
            continue $sm;
          case 1:
            this.u15_1 = this.y15_1;
            this.v15_1 = this.x15_1;
            this.r15_1 = this.u15_1.u11_1.kotlinx$atomicfu$value;
            this.f9_1 = 2;
            continue $sm;
          case 2:
            if (!true) {
              this.f9_1 = 9;
              continue $sm;
            }

            if (this.u15_1.s12()) {
              var tmp_2 = this;
              throw recoverStackTrace_0(_get_receiveException__foorc1(this.o15_1));
            } else {
              this.f9_1 = 3;
              continue $sm;
            }

          case 3:
            this.s15_1 = this.u15_1.q11_1.atomicfu$getAndIncrement$long();
            var tmp0 = this.s15_1;
            var other = get_SEGMENT_SIZE();
            var id = divide(tmp0, fromInt_0(other));
            var tmp_3 = this;
            var tmp0_0 = this.s15_1;
            var other_0 = get_SEGMENT_SIZE();
            tmp_3.t15_1 = convertToInt(modulo(tmp0_0, fromInt_0(other_0)));
            if (!(this.r15_1.ts_1 === id)) {
              var tmp0_elvis_lhs = findSegmentReceive(this.u15_1, id, this.r15_1);
              if (tmp0_elvis_lhs == null) {
                this.f9_1 = 2;
                var tmp_4 = this;
                continue $sm;
              } else {
                this.w15_1 = tmp0_elvis_lhs;
                this.f9_1 = 4;
                continue $sm;
              }
            } else {
              this.f9_1 = 5;
              continue $sm;
            }

          case 4:
            this.r15_1 = this.w15_1;
            this.f9_1 = 5;
            continue $sm;
          case 5:
            var updCellResult = updateCellReceive(this.u15_1, this.r15_1, this.t15_1, this.s15_1, this.v15_1);
            if (updCellResult === get_SUSPEND()) {
              var tmp_5 = this;
              var tmp_6 = this.v15_1;
              var tmp1_safe_receiver = (!(tmp_6 == null) ? isInterface(tmp_6, Waiter) : false) ? tmp_6 : null;
              if (tmp1_safe_receiver == null)
                null;
              else {
                prepareReceiverForSuspension(this.u15_1, tmp1_safe_receiver, this.r15_1, this.t15_1);
              }
              this.r15_1;
              this.t15_1;
              this.s15_1;
              var message = 'unexpected';
              throw IllegalStateException_init_$Create$_0(toString_1(message));
            } else {
              if (updCellResult === get_FAILED()) {
                if (this.s15_1 < this.u15_1.r12()) {
                  this.r15_1.l12();
                }
                this.f9_1 = 2;
                var tmp_7 = this;
                continue $sm;
              } else {
                if (updCellResult === get_SUSPEND_NO_WAITER()) {
                  var tmp0_1 = this.r15_1;
                  var tmp2 = this.t15_1;
                  var r = this.s15_1;
                  this.f9_1 = 6;
                  suspendResult = receiveOnNoWaiterSuspend(this.o15_1, tmp0_1, tmp2, r, this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  continue $sm;
                } else {
                  var tmp_8 = this;
                  this.r15_1.l12();
                  return (updCellResult == null ? true : !(updCellResult == null)) ? updCellResult : THROW_CCE();
                }
              }
            }

          case 6:
            this.q15_1 = suspendResult;
            this.f9_1 = 7;
            continue $sm;
          case 7:
            this.p15_1 = this.q15_1;
            this.f9_1 = 10;
            continue $sm;
          case 8:
            throw this.i9_1;
          case 9:
            if (false) {
              this.f9_1 = 1;
              continue $sm;
            }

            this.f9_1 = 10;
            continue $sm;
          case 10:
            return this.p15_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 8) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function BufferedChannel(capacity, onUndeliveredElement) {
    onUndeliveredElement = onUndeliveredElement === VOID ? null : onUndeliveredElement;
    this.n11_1 = capacity;
    this.o11_1 = onUndeliveredElement;
    // Inline function 'kotlin.require' call
    if (!(this.n11_1 >= 0)) {
      var message = 'Invalid channel capacity: ' + this.n11_1 + ', should be >=0';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    this.p11_1 = atomic$long$1(0n);
    this.q11_1 = atomic$long$1(0n);
    this.r11_1 = atomic$long$1(initialBufferEnd(this.n11_1));
    this.s11_1 = atomic$long$1(_get_bufferEndCounter__2d4hee(this));
    var firstSegment = new ChannelSegment(0n, null, this, 3);
    this.t11_1 = atomic$ref$1(firstSegment);
    this.u11_1 = atomic$ref$1(firstSegment);
    var tmp = this;
    var tmp_0;
    if (_get_isRendezvousOrUnlimited__3mdufi(this)) {
      var tmp_1 = get_NULL_SEGMENT();
      tmp_0 = tmp_1 instanceof ChannelSegment ? tmp_1 : THROW_CCE();
    } else {
      tmp_0 = firstSegment;
    }
    tmp.v11_1 = atomic$ref$1(tmp_0);
    var tmp_2 = this;
    var tmp_3;
    if (this.o11_1 == null) {
      tmp_3 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_3 = BufferedChannel$onUndeliveredElementReceiveCancellationConstructor$lambda(this);
    }
    tmp_2.w11_1 = tmp_3;
    this.x11_1 = atomic$ref$1(get_NO_CLOSE_CAUSE());
    this.y11_1 = atomic$ref$1(null);
  }
  protoOf(BufferedChannel).r12 = function () {
    // Inline function 'kotlinx.coroutines.channels.sendersCounter' call
    return this.p11_1.kotlinx$atomicfu$value & 1152921504606846975n;
  };
  protoOf(BufferedChannel).n13 = function () {
    return this.q11_1.kotlinx$atomicfu$value;
  };
  protoOf(BufferedChannel).z15 = function (element, $completion) {
    var tmp = new $sendCOROUTINE$(this, element, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(BufferedChannel).a16 = function (element) {
    if (shouldSendSuspend0(this, this.p11_1.kotlinx$atomicfu$value))
      return Companion_getInstance_22().b16();
    var tmp4 = get_INTERRUPTED_SEND();
    var tmp$ret$4;
    $l$block_5: {
      // Inline function 'kotlinx.coroutines.channels.BufferedChannel.sendImpl' call
      var segment = access$_get_sendSegment__111kgq(this).kotlinx$atomicfu$value;
      $l$loop_0: while (true) {
        var sendersAndCloseStatusCur = access$_get_sendersAndCloseStatus__tvw29s(this).atomicfu$getAndIncrement$long();
        // Inline function 'kotlinx.coroutines.channels.sendersCounter' call
        var s = sendersAndCloseStatusCur & access$_get_SENDERS_COUNTER_MASK_$tBufferedChannelKt_6ll4te();
        var closed = access$_get_isClosedForSend0__sm8f7a(this, sendersAndCloseStatusCur);
        // Inline function 'kotlin.Long.div' call
        var other = get_SEGMENT_SIZE();
        var id = divide(s, fromInt_0(other));
        // Inline function 'kotlin.Long.rem' call
        var other_0 = get_SEGMENT_SIZE();
        var tmp$ret$2 = modulo(s, fromInt_0(other_0));
        var i = convertToInt(tmp$ret$2);
        if (!(segment.ts_1 === id)) {
          var tmp0_elvis_lhs = access$findSegmentSend(this, id, segment);
          var tmp;
          if (tmp0_elvis_lhs == null) {
            var tmp_0;
            if (closed) {
              tmp$ret$4 = Companion_getInstance_22().i14(this.m13());
              break $l$block_5;
            } else {
              continue $l$loop_0;
            }
          } else {
            tmp = tmp0_elvis_lhs;
          }
          segment = tmp;
        }
        var tmp1_subject = access$updateCellSend(this, segment, i, element, s, tmp4, closed);
        if (tmp1_subject === access$_get_RESULT_RENDEZVOUS_$tBufferedChannelKt_ykevfn()) {
          segment.l12();
          tmp$ret$4 = Companion_getInstance_22().s13(Unit_instance);
          break $l$block_5;
        } else if (tmp1_subject === access$_get_RESULT_BUFFERED_$tBufferedChannelKt_tnykj7()) {
          tmp$ret$4 = Companion_getInstance_22().s13(Unit_instance);
          break $l$block_5;
        } else if (tmp1_subject === access$_get_RESULT_SUSPEND_$tBufferedChannelKt_vus6es()) {
          if (closed) {
            segment.b12();
            tmp$ret$4 = Companion_getInstance_22().i14(this.m13());
            break $l$block_5;
          }
          var tmp2_safe_receiver = (!(tmp4 == null) ? isInterface(tmp4, Waiter) : false) ? tmp4 : null;
          if (tmp2_safe_receiver == null)
            null;
          else {
            access$prepareSenderForSuspension(this, tmp2_safe_receiver, segment, i);
          }
          segment.b12();
          tmp$ret$4 = Companion_getInstance_22().b16();
          break $l$block_5;
        } else if (tmp1_subject === access$_get_RESULT_CLOSED_$tBufferedChannelKt_3eqb16()) {
          if (s < this.n13()) {
            segment.l12();
          }
          tmp$ret$4 = Companion_getInstance_22().i14(this.m13());
          break $l$block_5;
        } else if (tmp1_subject === access$_get_RESULT_FAILED_$tBufferedChannelKt_wacckr()) {
          segment.l12();
          continue $l$loop_0;
        } else if (tmp1_subject === access$_get_RESULT_SUSPEND_NO_WAITER_$tBufferedChannelKt_61h09f()) {
          var message = 'unexpected';
          throw IllegalStateException_init_$Create$_0(toString_1(message));
        }
      }
    }
    return tmp$ret$4;
  };
  protoOf(BufferedChannel).u13 = function () {
  };
  protoOf(BufferedChannel).o13 = function () {
  };
  protoOf(BufferedChannel).d16 = function ($completion) {
    var tmp = new $receiveCOROUTINE$(this, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(BufferedChannel).e16 = function () {
    var r = this.q11_1.kotlinx$atomicfu$value;
    var sendersAndCloseStatusCur = this.p11_1.kotlinx$atomicfu$value;
    if (_get_isClosedForReceive0__f7qknl(this, sendersAndCloseStatusCur)) {
      return Companion_getInstance_22().i14(this.q12());
    }
    // Inline function 'kotlinx.coroutines.channels.sendersCounter' call
    var s = sendersAndCloseStatusCur & 1152921504606846975n;
    if (r >= s)
      return Companion_getInstance_22().b16();
    var tmp2 = get_INTERRUPTED_RCV();
    var tmp$ret$2;
    $l$block_0: {
      // Inline function 'kotlinx.coroutines.channels.BufferedChannel.receiveImpl' call
      var segment = this.u11_1.kotlinx$atomicfu$value;
      $l$loop_0: while (true) {
        if (this.s12()) {
          tmp$ret$2 = Companion_getInstance_22().i14(this.q12());
          break $l$block_0;
        }
        var r_0 = this.q11_1.atomicfu$getAndIncrement$long();
        // Inline function 'kotlin.Long.div' call
        var other = get_SEGMENT_SIZE();
        var id = divide(r_0, fromInt_0(other));
        // Inline function 'kotlin.Long.rem' call
        var other_0 = get_SEGMENT_SIZE();
        var tmp$ret$4 = modulo(r_0, fromInt_0(other_0));
        var i = convertToInt(tmp$ret$4);
        if (!(segment.ts_1 === id)) {
          var tmp0_elvis_lhs = findSegmentReceive(this, id, segment);
          var tmp;
          if (tmp0_elvis_lhs == null) {
            continue $l$loop_0;
          } else {
            tmp = tmp0_elvis_lhs;
          }
          segment = tmp;
        }
        var updCellResult = updateCellReceive(this, segment, i, r_0, tmp2);
        var tmp_0;
        if (updCellResult === get_SUSPEND()) {
          var tmp1_safe_receiver = (!(tmp2 == null) ? isInterface(tmp2, Waiter) : false) ? tmp2 : null;
          if (tmp1_safe_receiver == null)
            null;
          else {
            prepareReceiverForSuspension(this, tmp1_safe_receiver, segment, i);
          }
          var segm = segment;
          this.a12(r_0);
          segm.b12();
          tmp_0 = new ChannelResult(Companion_getInstance_22().b16());
        } else if (updCellResult === get_FAILED()) {
          if (r_0 < this.r12()) {
            segment.l12();
          }
          continue $l$loop_0;
        } else if (updCellResult === get_SUSPEND_NO_WAITER()) {
          var message = 'unexpected';
          throw IllegalStateException_init_$Create$_0(toString_1(message));
        } else {
          segment.l12();
          var element = (updCellResult == null ? true : !(updCellResult == null)) ? updCellResult : THROW_CCE();
          tmp_0 = new ChannelResult(Companion_getInstance_22().s13(element));
        }
        tmp$ret$2 = tmp_0.c16_1;
        break $l$block_0;
      }
    }
    return tmp$ret$2;
  };
  protoOf(BufferedChannel).g14 = function (globalCellIndex) {
    // Inline function 'kotlinx.coroutines.assert' call
    var segment = this.u11_1.kotlinx$atomicfu$value;
    $l$loop_0: while (true) {
      var r = this.q11_1.kotlinx$atomicfu$value;
      // Inline function 'kotlin.Long.plus' call
      var other = this.n11_1;
      var tmp0 = add_2(r, fromInt_0(other));
      // Inline function 'kotlin.math.max' call
      var b = _get_bufferEndCounter__2d4hee(this);
      if (globalCellIndex < (tmp0 >= b ? tmp0 : b))
        return Unit_instance;
      // Inline function 'kotlin.Long.plus' call
      var tmp$ret$3 = add_2(r, fromInt_0(1));
      if (!this.q11_1.atomicfu$compareAndSet(r, tmp$ret$3))
        continue $l$loop_0;
      // Inline function 'kotlin.Long.div' call
      var other_0 = get_SEGMENT_SIZE();
      var id = divide(r, fromInt_0(other_0));
      // Inline function 'kotlin.Long.rem' call
      var other_1 = get_SEGMENT_SIZE();
      var tmp$ret$5 = modulo(r, fromInt_0(other_1));
      var i = convertToInt(tmp$ret$5);
      if (!(segment.ts_1 === id)) {
        var tmp0_elvis_lhs = findSegmentReceive(this, id, segment);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          continue $l$loop_0;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        segment = tmp;
      }
      var updCellResult = updateCellReceive(this, segment, i, r, null);
      if (updCellResult === get_FAILED()) {
        if (r < this.r12()) {
          segment.l12();
        }
      } else {
        segment.l12();
        var tmp1_safe_receiver = this.o11_1;
        var tmp_0;
        if (tmp1_safe_receiver == null) {
          tmp_0 = null;
        } else {
          tmp_0 = callUndeliveredElementCatchingException(tmp1_safe_receiver, (updCellResult == null ? true : !(updCellResult == null)) ? updCellResult : THROW_CCE());
        }
        var tmp2_safe_receiver = tmp_0;
        if (tmp2_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          throw tmp2_safe_receiver;
        }
      }
    }
  };
  protoOf(BufferedChannel).a12 = function (globalIndex) {
    if (_get_isRendezvousOrUnlimited__3mdufi(this))
      return Unit_instance;
    while (_get_bufferEndCounter__2d4hee(this) <= globalIndex) {
    }
    // Inline function 'kotlin.repeat' call
    var times = get_EXPAND_BUFFER_COMPLETION_WAIT_ITERATIONS();
    var inductionVariable = 0;
    if (inductionVariable < times)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var b = _get_bufferEndCounter__2d4hee(this);
        // Inline function 'kotlinx.coroutines.channels.ebCompletedCounter' call
        var ebCompleted = this.s11_1.kotlinx$atomicfu$value & 4611686018427387903n;
        if (b === ebCompleted && b === _get_bufferEndCounter__2d4hee(this))
          return Unit_instance;
      }
       while (inductionVariable < times);
    var tmp0 = this.s11_1;
    $l$block: {
      // Inline function 'kotlinx.atomicfu.update' call
      while (true) {
        var cur = tmp0.kotlinx$atomicfu$value;
        // Inline function 'kotlinx.coroutines.channels.ebCompletedCounter' call
        var tmp$ret$3 = cur & 4611686018427387903n;
        var upd = constructEBCompletedAndPauseFlag(tmp$ret$3, true);
        if (tmp0.atomicfu$compareAndSet(cur, upd)) {
          break $l$block;
        }
      }
    }
    while (true) {
      var b_0 = _get_bufferEndCounter__2d4hee(this);
      var ebCompletedAndBit = this.s11_1.kotlinx$atomicfu$value;
      // Inline function 'kotlinx.coroutines.channels.ebCompletedCounter' call
      var ebCompleted_0 = ebCompletedAndBit & 4611686018427387903n;
      // Inline function 'kotlinx.coroutines.channels.ebPauseExpandBuffers' call
      var pauseExpandBuffers = !((ebCompletedAndBit & 4611686018427387904n) === 0n);
      if (b_0 === ebCompleted_0 && b_0 === _get_bufferEndCounter__2d4hee(this)) {
        var tmp0_0 = this.s11_1;
        $l$block_0: {
          // Inline function 'kotlinx.atomicfu.update' call
          while (true) {
            var cur_0 = tmp0_0.kotlinx$atomicfu$value;
            // Inline function 'kotlinx.coroutines.channels.ebCompletedCounter' call
            var tmp$ret$8 = cur_0 & 4611686018427387903n;
            var upd_0 = constructEBCompletedAndPauseFlag(tmp$ret$8, false);
            if (tmp0_0.atomicfu$compareAndSet(cur_0, upd_0)) {
              break $l$block_0;
            }
          }
        }
        return Unit_instance;
      }
      if (!pauseExpandBuffers) {
        this.s11_1.atomicfu$compareAndSet(ebCompletedAndBit, constructEBCompletedAndPauseFlag(ebCompleted_0, true));
      }
    }
  };
  protoOf(BufferedChannel).m = function () {
    return new BufferedChannelIterator(this);
  };
  protoOf(BufferedChannel).q12 = function () {
    var tmp = this.x11_1.kotlinx$atomicfu$value;
    return (tmp == null ? true : tmp instanceof Error) ? tmp : THROW_CCE();
  };
  protoOf(BufferedChannel).m13 = function () {
    var tmp0_elvis_lhs = this.q12();
    return tmp0_elvis_lhs == null ? new ClosedSendChannelException('Channel was closed') : tmp0_elvis_lhs;
  };
  protoOf(BufferedChannel).f16 = function () {
  };
  protoOf(BufferedChannel).g16 = function (cause) {
    return this.h16(cause, false);
  };
  protoOf(BufferedChannel).rp = function (cause) {
    this.j16(cause);
  };
  protoOf(BufferedChannel).j16 = function (cause) {
    return this.h16(cause == null ? CancellationException_init_$Create$_0('Channel was cancelled') : cause, true);
  };
  protoOf(BufferedChannel).h16 = function (cause, cancel) {
    if (cancel) {
      markCancellationStarted(this);
    }
    var closedByThisOperation = this.x11_1.atomicfu$compareAndSet(get_NO_CLOSE_CAUSE(), cause);
    if (cancel) {
      markCancelled(this);
    } else {
      markClosed(this);
    }
    completeCloseOrCancel(this);
    // Inline function 'kotlin.also' call
    this.f16();
    if (closedByThisOperation) {
      invokeCloseHandler(this);
    }
    return closedByThisOperation;
  };
  protoOf(BufferedChannel).h14 = function () {
    return false;
  };
  protoOf(BufferedChannel).f14 = function () {
    return _get_isClosedForSend0__kxgf9m(this, this.p11_1.kotlinx$atomicfu$value);
  };
  protoOf(BufferedChannel).s12 = function () {
    return _get_isClosedForReceive0__f7qknl(this, this.p11_1.kotlinx$atomicfu$value);
  };
  protoOf(BufferedChannel).j14 = function () {
    $l$loop: while (true) {
      var segment = this.u11_1.kotlinx$atomicfu$value;
      var r = this.n13();
      var s = this.r12();
      if (s <= r)
        return false;
      // Inline function 'kotlin.Long.div' call
      var other = get_SEGMENT_SIZE();
      var id = divide(r, fromInt_0(other));
      if (!(segment.ts_1 === id)) {
        var tmp0_elvis_lhs = findSegmentReceive(this, id, segment);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          var tmp_0;
          if (this.u11_1.kotlinx$atomicfu$value.ts_1 < id) {
            return false;
          } else {
            continue $l$loop;
          }
        } else {
          tmp = tmp0_elvis_lhs;
        }
        segment = tmp;
      }
      segment.l12();
      // Inline function 'kotlin.Long.rem' call
      var other_0 = get_SEGMENT_SIZE();
      var tmp$ret$1 = modulo(r, fromInt_0(other_0));
      var i = convertToInt(tmp$ret$1);
      if (isCellNonEmpty(this, segment, i, r))
        return true;
      // Inline function 'kotlin.Long.plus' call
      var tmp$ret$2 = add_2(r, fromInt_0(1));
      this.q11_1.atomicfu$compareAndSet(r, tmp$ret$2);
    }
  };
  protoOf(BufferedChannel).toString = function () {
    var sb = StringBuilder_init_$Create$_1();
    // Inline function 'kotlinx.coroutines.channels.sendersCloseStatus' call
    var this_0 = this.p11_1.kotlinx$atomicfu$value;
    var tmp0_subject = convertToInt(shiftRight(this_0, 60));
    if (tmp0_subject === 2) {
      sb.j8('closed,');
    } else if (tmp0_subject === 3) {
      sb.j8('cancelled,');
    }
    sb.j8('capacity=' + this.n11_1 + ',');
    sb.j8('data=[');
    // Inline function 'kotlin.collections.filter' call
    var tmp0 = listOf_0([this.u11_1.kotlinx$atomicfu$value, this.t11_1.kotlinx$atomicfu$value, this.v11_1.kotlinx$atomicfu$value]);
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList_init_$Create$();
    var _iterator__ex2g4s = tmp0.m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      if (!(element === get_NULL_SEGMENT())) {
        destination.j(element);
      }
    }
    var tmp$ret$4;
    $l$block: {
      // Inline function 'kotlin.collections.minBy' call
      var iterator = destination.m();
      if (!iterator.n())
        throw NoSuchElementException_init_$Create$();
      var minElem = iterator.o();
      if (!iterator.n()) {
        tmp$ret$4 = minElem;
        break $l$block;
      }
      var minValue = minElem.ts_1;
      do {
        var e = iterator.o();
        var v = e.ts_1;
        if (compareTo_0(minValue, v) > 0) {
          minElem = e;
          minValue = v;
        }
      }
       while (iterator.n());
      tmp$ret$4 = minElem;
    }
    var firstSegment = tmp$ret$4;
    var r = this.n13();
    var s = this.r12();
    var segment = firstSegment;
    append_elements: while (true) {
      var inductionVariable = 0;
      var last = get_SEGMENT_SIZE();
      if (inductionVariable < last)
        process_cell: do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var tmp0_0 = segment.ts_1;
          // Inline function 'kotlin.Long.times' call
          var other = get_SEGMENT_SIZE();
          // Inline function 'kotlin.Long.plus' call
          var this_1 = multiply_0(tmp0_0, fromInt_0(other));
          var globalCellIndex = add_2(this_1, fromInt_0(i));
          if (globalCellIndex >= s && globalCellIndex >= r)
            break append_elements;
          var cellState = segment.j11(i);
          var element_0 = segment.g11(i);
          var tmp;
          if (!(cellState == null) ? isInterface(cellState, CancellableContinuation) : false) {
            tmp = globalCellIndex < r && globalCellIndex >= s ? 'receive' : globalCellIndex < s && globalCellIndex >= r ? 'send' : 'cont';
          } else {
            if (!(cellState == null) ? isInterface(cellState, SelectInstance) : false) {
              tmp = globalCellIndex < r && globalCellIndex >= s ? 'onReceive' : globalCellIndex < s && globalCellIndex >= r ? 'onSend' : 'select';
            } else {
              if (cellState instanceof ReceiveCatching) {
                tmp = 'receiveCatching';
              } else {
                if (cellState instanceof SendBroadcast) {
                  tmp = 'sendBroadcast';
                } else {
                  if (cellState instanceof WaiterEB) {
                    tmp = 'EB(' + toString_0(cellState) + ')';
                  } else {
                    if (equals(cellState, get_RESUMING_BY_RCV()) ? true : equals(cellState, get_RESUMING_BY_EB())) {
                      tmp = 'resuming_sender';
                    } else {
                      if ((((((cellState == null ? true : equals(cellState, get_IN_BUFFER())) ? true : equals(cellState, get_DONE_RCV())) ? true : equals(cellState, get_POISONED())) ? true : equals(cellState, get_INTERRUPTED_RCV())) ? true : equals(cellState, get_INTERRUPTED_SEND())) ? true : equals(cellState, get_CHANNEL_CLOSED())) {
                        continue process_cell;
                      } else {
                        tmp = toString_1(cellState);
                      }
                    }
                  }
                }
              }
            }
          }
          var cellStateString = tmp;
          if (!(element_0 == null)) {
            sb.j8('(' + cellStateString + ',' + toString_0(element_0) + '),');
          } else {
            sb.j8(cellStateString + ',');
          }
        }
         while (inductionVariable < last);
      var tmp3_elvis_lhs = segment.h12();
      var tmp_0;
      if (tmp3_elvis_lhs == null) {
        break append_elements;
      } else {
        tmp_0 = tmp3_elvis_lhs;
      }
      segment = tmp_0;
    }
    if (last_2(sb) === _Char___init__impl__6a9atx(44)) {
      sb.nc(sb.a() - 1 | 0);
    }
    sb.j8(']');
    return sb.toString();
  };
  function WaiterEB(waiter) {
    this.p13_1 = waiter;
  }
  protoOf(WaiterEB).toString = function () {
    return 'WaiterEB(' + toString_1(this.p13_1) + ')';
  };
  function initialBufferEnd(capacity) {
    _init_properties_BufferedChannel_kt__d6uc4y();
    switch (capacity) {
      case 0:
        return 0n;
      case 2147483647:
        return 9223372036854775807n;
      default:
        return fromInt_0(capacity);
    }
  }
  function ReceiveCatching() {
  }
  function tryResume0(_this__u8e3s4, value, onCancellation) {
    onCancellation = onCancellation === VOID ? null : onCancellation;
    _init_properties_BufferedChannel_kt__d6uc4y();
    // Inline function 'kotlin.let' call
    var token = _this__u8e3s4.sr(value, null, onCancellation);
    var tmp;
    if (!(token == null)) {
      _this__u8e3s4.tr(token);
      tmp = true;
    } else {
      tmp = false;
    }
    return tmp;
  }
  function constructEBCompletedAndPauseFlag(counter, pauseEB) {
    _init_properties_BufferedChannel_kt__d6uc4y();
    return add_2(pauseEB ? 4611686018427387904n : 0n, counter);
  }
  function constructSendersAndCloseStatus(counter, closeStatus) {
    _init_properties_BufferedChannel_kt__d6uc4y();
    return add_2(shiftLeft(fromInt_0(closeStatus), 60), counter);
  }
  function createSegmentFunction() {
    _init_properties_BufferedChannel_kt__d6uc4y();
    return createSegment$ref();
  }
  function createSegment(id, prev) {
    _init_properties_BufferedChannel_kt__d6uc4y();
    return new ChannelSegment(id, prev, prev.d11(), 0);
  }
  function access$_get_RESULT_RENDEZVOUS_$tBufferedChannelKt_ykevfn() {
    return 0;
  }
  function access$_get_RESULT_BUFFERED_$tBufferedChannelKt_tnykj7() {
    return 1;
  }
  function access$_get_RESULT_SUSPEND_$tBufferedChannelKt_vus6es() {
    return 2;
  }
  function access$_get_RESULT_CLOSED_$tBufferedChannelKt_3eqb16() {
    return 4;
  }
  function access$_get_RESULT_FAILED_$tBufferedChannelKt_wacckr() {
    return 5;
  }
  function access$_get_RESULT_SUSPEND_NO_WAITER_$tBufferedChannelKt_61h09f() {
    return 3;
  }
  function access$_get_SENDERS_COUNTER_MASK_$tBufferedChannelKt_6ll4te() {
    return 1152921504606846975n;
  }
  function createSegment$ref() {
    var l = function (p0, p1) {
      return createSegment(p0, p1);
    };
    l.callableName = 'createSegment';
    return l;
  }
  var properties_initialized_BufferedChannel_kt_58tjvw;
  function _init_properties_BufferedChannel_kt__d6uc4y() {
    if (!properties_initialized_BufferedChannel_kt_58tjvw) {
      properties_initialized_BufferedChannel_kt_58tjvw = true;
      NULL_SEGMENT = new ChannelSegment(-1n, null, null, 0);
      SEGMENT_SIZE = systemProp('kotlinx.coroutines.bufferedChannel.segmentSize', 32);
      EXPAND_BUFFER_COMPLETION_WAIT_ITERATIONS = systemProp('kotlinx.coroutines.bufferedChannel.expandBufferCompletionWaitIterations', 10000);
      BUFFERED = new Symbol_0('BUFFERED');
      IN_BUFFER = new Symbol_0('SHOULD_BUFFER');
      RESUMING_BY_RCV = new Symbol_0('S_RESUMING_BY_RCV');
      RESUMING_BY_EB = new Symbol_0('RESUMING_BY_EB');
      POISONED = new Symbol_0('POISONED');
      DONE_RCV = new Symbol_0('DONE_RCV');
      INTERRUPTED_SEND = new Symbol_0('INTERRUPTED_SEND');
      INTERRUPTED_RCV = new Symbol_0('INTERRUPTED_RCV');
      CHANNEL_CLOSED = new Symbol_0('CHANNEL_CLOSED');
      SUSPEND = new Symbol_0('SUSPEND');
      SUSPEND_NO_WAITER = new Symbol_0('SUSPEND_NO_WAITER');
      FAILED = new Symbol_0('FAILED');
      NO_RECEIVE_RESULT = new Symbol_0('NO_RECEIVE_RESULT');
      CLOSE_HANDLER_CLOSED = new Symbol_0('CLOSE_HANDLER_CLOSED');
      CLOSE_HANDLER_INVOKED = new Symbol_0('CLOSE_HANDLER_INVOKED');
      NO_CLOSE_CAUSE = new Symbol_0('NO_CLOSE_CAUSE');
    }
  }
  function Factory() {
    Factory_instance = this;
    this.l16_1 = 2147483647;
    this.m16_1 = 0;
    this.n16_1 = -1;
    this.o16_1 = -2;
    this.p16_1 = -3;
    this.q16_1 = 'kotlinx.coroutines.channels.defaultBuffer';
    this.r16_1 = systemProp('kotlinx.coroutines.channels.defaultBuffer', 64, 1, 2147483646);
  }
  var Factory_instance;
  function Factory_getInstance() {
    if (Factory_instance == null)
      new Factory();
    return Factory_instance;
  }
  function Channel(capacity, onBufferOverflow, onUndeliveredElement) {
    capacity = capacity === VOID ? 0 : capacity;
    onBufferOverflow = onBufferOverflow === VOID ? BufferOverflow_SUSPEND_getInstance() : onBufferOverflow;
    onUndeliveredElement = onUndeliveredElement === VOID ? null : onUndeliveredElement;
    var tmp;
    switch (capacity) {
      case 0:
        tmp = onBufferOverflow.equals(BufferOverflow_SUSPEND_getInstance()) ? new BufferedChannel(0, onUndeliveredElement) : new ConflatedBufferedChannel(1, onBufferOverflow, onUndeliveredElement);
        break;
      case -1:
        // Inline function 'kotlin.require' call

        if (!onBufferOverflow.equals(BufferOverflow_SUSPEND_getInstance())) {
          var message = 'CONFLATED capacity cannot be used with non-default onBufferOverflow';
          throw IllegalArgumentException_init_$Create$_0(toString_1(message));
        }

        tmp = new ConflatedBufferedChannel(1, BufferOverflow_DROP_OLDEST_getInstance(), onUndeliveredElement);
        break;
      case 2147483647:
        tmp = new BufferedChannel(2147483647, onUndeliveredElement);
        break;
      case -2:
        tmp = onBufferOverflow.equals(BufferOverflow_SUSPEND_getInstance()) ? new BufferedChannel(Factory_getInstance().r16_1, onUndeliveredElement) : new ConflatedBufferedChannel(1, onBufferOverflow, onUndeliveredElement);
        break;
      default:
        tmp = onBufferOverflow === BufferOverflow_SUSPEND_getInstance() ? new BufferedChannel(capacity, onUndeliveredElement) : new ConflatedBufferedChannel(capacity, onBufferOverflow, onUndeliveredElement);
        break;
    }
    return tmp;
  }
  function _ChannelResult___init__impl__siwsuf(holder) {
    return holder;
  }
  function _ChannelResult___get_holder__impl__pm9gzw($this) {
    return $this;
  }
  function _ChannelResult___get_isSuccess__impl__odq1z9($this) {
    var tmp = _ChannelResult___get_holder__impl__pm9gzw($this);
    return !(tmp instanceof Failed);
  }
  function _ChannelResult___get_isClosed__impl__mg7kuu($this) {
    var tmp = _ChannelResult___get_holder__impl__pm9gzw($this);
    return tmp instanceof Closed;
  }
  function ChannelResult__getOrNull_impl_f5e07h($this) {
    var tmp;
    var tmp_0 = _ChannelResult___get_holder__impl__pm9gzw($this);
    if (!(tmp_0 instanceof Failed)) {
      var tmp_1 = _ChannelResult___get_holder__impl__pm9gzw($this);
      tmp = (tmp_1 == null ? true : !(tmp_1 == null)) ? tmp_1 : THROW_CCE();
    } else {
      tmp = null;
    }
    return tmp;
  }
  function ChannelResult__getOrThrow_impl_od1axs($this) {
    var tmp = _ChannelResult___get_holder__impl__pm9gzw($this);
    if (!(tmp instanceof Failed)) {
      var tmp_0 = _ChannelResult___get_holder__impl__pm9gzw($this);
      return (tmp_0 == null ? true : !(tmp_0 == null)) ? tmp_0 : THROW_CCE();
    }
    var tmp_1;
    var tmp_2 = _ChannelResult___get_holder__impl__pm9gzw($this);
    if (tmp_2 instanceof Closed) {
      tmp_1 = !(_ChannelResult___get_holder__impl__pm9gzw($this).s16_1 == null);
    } else {
      tmp_1 = false;
    }
    if (tmp_1)
      throw _ChannelResult___get_holder__impl__pm9gzw($this).s16_1;
    // Inline function 'kotlin.error' call
    var message = "Trying to call 'getOrThrow' on a failed channel result: " + toString_0(_ChannelResult___get_holder__impl__pm9gzw($this));
    throw IllegalStateException_init_$Create$_0(toString_1(message));
  }
  function ChannelResult__exceptionOrNull_impl_16ei30($this) {
    var tmp = _ChannelResult___get_holder__impl__pm9gzw($this);
    var tmp0_safe_receiver = tmp instanceof Closed ? tmp : null;
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.s16_1;
  }
  function Failed() {
  }
  protoOf(Failed).toString = function () {
    return 'Failed';
  };
  function Closed(cause) {
    Failed.call(this);
    this.s16_1 = cause;
  }
  protoOf(Closed).equals = function (other) {
    var tmp;
    if (other instanceof Closed) {
      tmp = equals(this.s16_1, other.s16_1);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(Closed).hashCode = function () {
    // Inline function 'kotlin.hashCode' call
    var tmp0_safe_receiver = this.s16_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    return tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
  };
  protoOf(Closed).toString = function () {
    return 'Closed(' + toString_0(this.s16_1) + ')';
  };
  function Companion_22() {
    Companion_instance_22 = this;
    this.r13_1 = new Failed();
  }
  protoOf(Companion_22).s13 = function (value) {
    return _ChannelResult___init__impl__siwsuf(value);
  };
  protoOf(Companion_22).b16 = function () {
    return _ChannelResult___init__impl__siwsuf(this.r13_1);
  };
  protoOf(Companion_22).i14 = function (cause) {
    return _ChannelResult___init__impl__siwsuf(new Closed(cause));
  };
  var Companion_instance_22;
  function Companion_getInstance_22() {
    if (Companion_instance_22 == null)
      new Companion_22();
    return Companion_instance_22;
  }
  function ChannelResult__toString_impl_rrcqu7($this) {
    var tmp;
    if (_ChannelResult___get_holder__impl__pm9gzw($this) instanceof Closed) {
      tmp = toString_1(_ChannelResult___get_holder__impl__pm9gzw($this));
    } else {
      tmp = 'Value(' + toString_0(_ChannelResult___get_holder__impl__pm9gzw($this)) + ')';
    }
    return tmp;
  }
  function ChannelResult__hashCode_impl_lilec2($this) {
    return $this == null ? 0 : hashCode($this);
  }
  function ChannelResult__equals_impl_f471ri($this, other) {
    if (!(other instanceof ChannelResult))
      return false;
    var tmp0_other_with_cast = other instanceof ChannelResult ? other.c16_1 : THROW_CCE();
    if (!equals($this, tmp0_other_with_cast))
      return false;
    return true;
  }
  function ChannelResult(holder) {
    Companion_getInstance_22();
    this.c16_1 = holder;
  }
  protoOf(ChannelResult).toString = function () {
    return ChannelResult__toString_impl_rrcqu7(this.c16_1);
  };
  protoOf(ChannelResult).hashCode = function () {
    return ChannelResult__hashCode_impl_lilec2(this.c16_1);
  };
  protoOf(ChannelResult).equals = function (other) {
    return ChannelResult__equals_impl_f471ri(this.c16_1, other);
  };
  function SendChannel() {
  }
  function ReceiveChannel() {
  }
  function ClosedSendChannelException(message) {
    IllegalStateException_init_$Init$_0(message, this);
    captureStack(this, ClosedSendChannelException);
  }
  function ClosedReceiveChannelException(message) {
    NoSuchElementException_init_$Init$_0(message, this);
    captureStack(this, ClosedReceiveChannelException);
  }
  function ChannelCoroutine(parentContext, _channel, initParentJob, active) {
    AbstractCoroutine.call(this, parentContext, initParentJob, active);
    this.w16_1 = _channel;
  }
  protoOf(ChannelCoroutine).f14 = function () {
    return this.w16_1.f14();
  };
  protoOf(ChannelCoroutine).g16 = function (cause) {
    return this.w16_1.g16(cause);
  };
  protoOf(ChannelCoroutine).m = function () {
    return this.w16_1.m();
  };
  protoOf(ChannelCoroutine).d16 = function ($completion) {
    return this.w16_1.d16($completion);
  };
  protoOf(ChannelCoroutine).z15 = function (element, $completion) {
    return this.w16_1.z15(element, $completion);
  };
  protoOf(ChannelCoroutine).e16 = function () {
    return this.w16_1.e16();
  };
  protoOf(ChannelCoroutine).a16 = function (element) {
    return this.w16_1.a16(element);
  };
  protoOf(ChannelCoroutine).d11 = function () {
    return this;
  };
  protoOf(ChannelCoroutine).rp = function (cause) {
    if (this.ep())
      return Unit_instance;
    var tmp;
    if (cause == null) {
      // Inline function 'kotlinx.coroutines.JobSupport.defaultCancellationException' call
      tmp = new JobCancellationException(null == null ? this.lo() : null, null, this);
    } else {
      tmp = cause;
    }
    this.tp(tmp);
  };
  protoOf(ChannelCoroutine).k16 = function (cause, $super) {
    return this.sp(cause, ($super == null ? true : $super instanceof ChannelCoroutine) ? $super : THROW_CCE());
  };
  protoOf(ChannelCoroutine).tp = function (cause) {
    var exception = this.jp(cause);
    this.w16_1.rp(exception);
    this.wp(exception);
  };
  function cancelConsumed(_this__u8e3s4, cause) {
    var tmp;
    if (cause == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      var tmp0_elvis_lhs = cause instanceof CancellationException ? cause : null;
      tmp = tmp0_elvis_lhs == null ? CancellationException_init_$Create$_1('Channel was consumed, consumer had failed', cause) : tmp0_elvis_lhs;
    }
    _this__u8e3s4.rp(tmp);
  }
  function trySendImpl($this, element, isSendOp) {
    return $this.k17_1 === BufferOverflow_DROP_LATEST_getInstance() ? trySendDropLatest($this, element, isSendOp) : trySendDropOldest($this, element);
  }
  function trySendDropLatest($this, element, isSendOp) {
    var result = protoOf(BufferedChannel).a16.call($this, element);
    if (_ChannelResult___get_isSuccess__impl__odq1z9(result) || _ChannelResult___get_isClosed__impl__mg7kuu(result))
      return result;
    if (isSendOp) {
      var tmp0_safe_receiver = $this.o11_1;
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : callUndeliveredElementCatchingException(tmp0_safe_receiver, element);
      if (tmp1_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        throw tmp1_safe_receiver;
      }
    }
    return Companion_getInstance_22().s13(Unit_instance);
  }
  function trySendDropOldest($this, element) {
    var tmp4 = get_BUFFERED();
    var tmp$ret$3;
    $l$block: {
      // Inline function 'kotlinx.coroutines.channels.BufferedChannel.sendImpl' call
      var segment = access$_get_sendSegment__111kgq($this).kotlinx$atomicfu$value;
      $l$loop_0: while (true) {
        var sendersAndCloseStatusCur = access$_get_sendersAndCloseStatus__tvw29s($this).atomicfu$getAndIncrement$long();
        var s = sendersAndCloseStatusCur & access$_get_SENDERS_COUNTER_MASK_$tBufferedChannelKt_6ll4te();
        var closed = access$_get_isClosedForSend0__sm8f7a($this, sendersAndCloseStatusCur);
        // Inline function 'kotlin.Long.div' call
        var other = get_SEGMENT_SIZE();
        var id = divide(s, fromInt_0(other));
        // Inline function 'kotlin.Long.rem' call
        var other_0 = get_SEGMENT_SIZE();
        var tmp$ret$2 = modulo(s, fromInt_0(other_0));
        var i = convertToInt(tmp$ret$2);
        if (!(segment.ts_1 === id)) {
          var tmp0_elvis_lhs = access$findSegmentSend($this, id, segment);
          var tmp;
          if (tmp0_elvis_lhs == null) {
            var tmp_0;
            if (closed) {
              return Companion_getInstance_22().i14($this.m13());
            } else {
              continue $l$loop_0;
            }
          } else {
            tmp = tmp0_elvis_lhs;
          }
          segment = tmp;
        }
        var tmp1_subject = access$updateCellSend($this, segment, i, element, s, tmp4, closed);
        if (tmp1_subject === access$_get_RESULT_RENDEZVOUS_$tBufferedChannelKt_ykevfn()) {
          segment.l12();
          return Companion_getInstance_22().s13(Unit_instance);
        } else if (tmp1_subject === access$_get_RESULT_BUFFERED_$tBufferedChannelKt_tnykj7()) {
          return Companion_getInstance_22().s13(Unit_instance);
        } else if (tmp1_subject === access$_get_RESULT_SUSPEND_$tBufferedChannelKt_vus6es()) {
          if (closed) {
            segment.b12();
            return Companion_getInstance_22().i14($this.m13());
          }
          var tmp2_safe_receiver = (!(tmp4 == null) ? isInterface(tmp4, Waiter) : false) ? tmp4 : null;
          if (tmp2_safe_receiver == null)
            null;
          else {
            access$prepareSenderForSuspension($this, tmp2_safe_receiver, segment, i);
          }
          var tmp0 = segment.ts_1;
          // Inline function 'kotlin.Long.times' call
          var other_1 = get_SEGMENT_SIZE();
          // Inline function 'kotlin.Long.plus' call
          var this_0 = multiply_0(tmp0, fromInt_0(other_1));
          var tmp$ret$5 = add_2(this_0, fromInt_0(i));
          $this.g14(tmp$ret$5);
          return Companion_getInstance_22().s13(Unit_instance);
        } else if (tmp1_subject === access$_get_RESULT_CLOSED_$tBufferedChannelKt_3eqb16()) {
          if (s < $this.n13()) {
            segment.l12();
          }
          return Companion_getInstance_22().i14($this.m13());
        } else if (tmp1_subject === access$_get_RESULT_FAILED_$tBufferedChannelKt_wacckr()) {
          segment.l12();
          continue $l$loop_0;
        } else if (tmp1_subject === access$_get_RESULT_SUSPEND_NO_WAITER_$tBufferedChannelKt_61h09f()) {
          var message = 'unexpected';
          throw IllegalStateException_init_$Create$_0(toString_1(message));
        }
      }
    }
    return tmp$ret$3;
  }
  function ConflatedBufferedChannel(capacity, onBufferOverflow, onUndeliveredElement) {
    onUndeliveredElement = onUndeliveredElement === VOID ? null : onUndeliveredElement;
    BufferedChannel.call(this, capacity, onUndeliveredElement);
    this.j17_1 = capacity;
    this.k17_1 = onBufferOverflow;
    // Inline function 'kotlin.require' call
    if (!!(this.k17_1 === BufferOverflow_SUSPEND_getInstance())) {
      var message = 'This implementation does not support suspension for senders, use ' + getKClass(BufferedChannel).ra() + ' instead';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    // Inline function 'kotlin.require' call
    if (!(this.j17_1 >= 1)) {
      var message_0 = 'Buffered channel capacity must be at least 1, but ' + this.j17_1 + ' was specified';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message_0));
    }
  }
  protoOf(ConflatedBufferedChannel).h14 = function () {
    return this.k17_1.equals(BufferOverflow_DROP_OLDEST_getInstance());
  };
  protoOf(ConflatedBufferedChannel).z15 = function (element, $completion) {
    // Inline function 'kotlinx.coroutines.channels.onClosed' call
    var this_0 = trySendImpl(this, element, true);
    // Inline function 'kotlin.contracts.contract' call
    var tmp = _ChannelResult___get_holder__impl__pm9gzw(this_0);
    if (tmp instanceof Closed) {
      ChannelResult__exceptionOrNull_impl_16ei30(this_0);
      var tmp0_safe_receiver = this.o11_1;
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : callUndeliveredElementCatchingException(tmp0_safe_receiver, element);
      if (tmp1_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        addSuppressed(tmp1_safe_receiver, this.m13());
        throw tmp1_safe_receiver;
      }
      throw this.m13();
    }
    return Unit_instance;
  };
  protoOf(ConflatedBufferedChannel).a16 = function (element) {
    return trySendImpl(this, element, false);
  };
  function ProducerScope() {
  }
  function produce(_this__u8e3s4, context, capacity, onBufferOverflow, start, onCompletion, block) {
    context = context === VOID ? EmptyCoroutineContext_instance : context;
    capacity = capacity === VOID ? 0 : capacity;
    onBufferOverflow = onBufferOverflow === VOID ? BufferOverflow_SUSPEND_getInstance() : onBufferOverflow;
    start = start === VOID ? CoroutineStart_DEFAULT_getInstance() : start;
    onCompletion = onCompletion === VOID ? null : onCompletion;
    var channel = Channel(capacity, onBufferOverflow);
    var newContext = newCoroutineContext(_this__u8e3s4, context);
    var coroutine = new ProducerCoroutine(newContext, channel);
    if (!(onCompletion == null)) {
      coroutine.kp(onCompletion);
    }
    coroutine.vo(start, coroutine, block);
    return coroutine;
  }
  function ProducerCoroutine(parentContext, channel) {
    ChannelCoroutine.call(this, parentContext, channel, true, true);
  }
  protoOf(ProducerCoroutine).io = function () {
    return protoOf(ChannelCoroutine).io.call(this);
  };
  protoOf(ProducerCoroutine).p17 = function (value) {
    this.w16_1.i16();
  };
  protoOf(ProducerCoroutine).jo = function (value) {
    return this.p17(value instanceof Unit ? value : THROW_CCE());
  };
  protoOf(ProducerCoroutine).ko = function (cause, handled) {
    var processed = this.w16_1.g16(cause);
    if (!processed && !handled) {
      handleCoroutineException(this.go_1, cause);
    }
  };
  protoOf(ProducerCoroutine).k16 = function (cause, $super) {
    return this.sp(cause, ($super == null ? true : $super instanceof ProducerCoroutine) ? $super : THROW_CCE());
  };
  function produce_0(_this__u8e3s4, context, capacity, block) {
    context = context === VOID ? EmptyCoroutineContext_instance : context;
    capacity = capacity === VOID ? 0 : capacity;
    return produce(_this__u8e3s4, context, capacity, BufferOverflow_SUSPEND_getInstance(), CoroutineStart_DEFAULT_getInstance(), null, block);
  }
  function asFlow(_this__u8e3s4) {
    // Inline function 'kotlinx.coroutines.flow.internal.unsafeFlow' call
    return new asFlow$$inlined$unsafeFlow$1(_this__u8e3s4);
  }
  function channelFlow(block) {
    return new ChannelFlowBuilder(block);
  }
  function asFlow_0(_this__u8e3s4) {
    // Inline function 'kotlinx.coroutines.flow.internal.unsafeFlow' call
    return new asFlow$$inlined$unsafeFlow$2(_this__u8e3s4);
  }
  function flow(block) {
    return new SafeFlow(block);
  }
  function emptyFlow() {
    return EmptyFlow_instance;
  }
  function ChannelFlowBuilder(block, context, capacity, onBufferOverflow) {
    context = context === VOID ? EmptyCoroutineContext_instance : context;
    capacity = capacity === VOID ? -2 : capacity;
    onBufferOverflow = onBufferOverflow === VOID ? BufferOverflow_SUSPEND_getInstance() : onBufferOverflow;
    ChannelFlow.call(this, context, capacity, onBufferOverflow);
    this.t17_1 = block;
  }
  protoOf(ChannelFlowBuilder).u17 = function (context, capacity, onBufferOverflow) {
    return new ChannelFlowBuilder(this.t17_1, context, capacity, onBufferOverflow);
  };
  protoOf(ChannelFlowBuilder).v17 = function (scope, $completion) {
    return this.t17_1(scope, $completion);
  };
  protoOf(ChannelFlowBuilder).toString = function () {
    return 'block[' + toString_1(this.t17_1) + '] -> ' + protoOf(ChannelFlow).toString.call(this);
  };
  function SafeFlow(block) {
    AbstractFlow.call(this);
    this.h18_1 = block;
  }
  protoOf(SafeFlow).i18 = function (collector, $completion) {
    return this.h18_1(collector, $completion);
  };
  function EmptyFlow() {
  }
  protoOf(EmptyFlow).j18 = function (collector, $completion) {
    return Unit_instance;
  };
  protoOf(EmptyFlow).f18 = function (collector, $completion) {
    return this.j18(collector, $completion);
  };
  var EmptyFlow_instance;
  function EmptyFlow_getInstance() {
    return EmptyFlow_instance;
  }
  function flowOf(value) {
    // Inline function 'kotlinx.coroutines.flow.internal.unsafeFlow' call
    return new flowOf$$inlined$unsafeFlow$1(value);
  }
  function $collectCOROUTINE$(_this__u8e3s4, collector, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.s18_1 = _this__u8e3s4;
    this.t18_1 = collector;
  }
  protoOf($collectCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 4;
            this.u18_1 = this.t18_1;
            this.v18_1 = this.s18_1.w18_1.m();
            this.f9_1 = 1;
            continue $sm;
          case 1:
            if (!this.v18_1.n()) {
              this.f9_1 = 3;
              continue $sm;
            }

            var element = this.v18_1.o();
            this.f9_1 = 2;
            suspendResult = this.u18_1.x18(element, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.f9_1 = 1;
            continue $sm;
          case 3:
            return Unit_instance;
          case 4:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 4) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function asFlow$$inlined$unsafeFlow$1($this_asFlow) {
    this.w18_1 = $this_asFlow;
  }
  protoOf(asFlow$$inlined$unsafeFlow$1).y18 = function (collector, $completion) {
    var tmp = new $collectCOROUTINE$(this, collector, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(asFlow$$inlined$unsafeFlow$1).f18 = function (collector, $completion) {
    return this.y18(collector, $completion);
  };
  function $collectCOROUTINE$_0(_this__u8e3s4, collector, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.h19_1 = _this__u8e3s4;
    this.i19_1 = collector;
  }
  protoOf($collectCOROUTINE$_0).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 4;
            this.j19_1 = this.i19_1;
            this.k19_1 = this.h19_1.l19_1.m();
            this.f9_1 = 1;
            continue $sm;
          case 1:
            if (!this.k19_1.n()) {
              this.f9_1 = 3;
              continue $sm;
            }

            var element = this.k19_1.o();
            this.f9_1 = 2;
            suspendResult = this.j19_1.x18(element, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.f9_1 = 1;
            continue $sm;
          case 3:
            return Unit_instance;
          case 4:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 4) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function asFlow$$inlined$unsafeFlow$2($this_asFlow) {
    this.l19_1 = $this_asFlow;
  }
  protoOf(asFlow$$inlined$unsafeFlow$2).y18 = function (collector, $completion) {
    var tmp = new $collectCOROUTINE$_0(this, collector, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(asFlow$$inlined$unsafeFlow$2).f18 = function (collector, $completion) {
    return this.y18(collector, $completion);
  };
  function $collectCOROUTINE$_1(_this__u8e3s4, collector, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.u19_1 = _this__u8e3s4;
    this.v19_1 = collector;
  }
  protoOf($collectCOROUTINE$_1).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            var $this$unsafeFlow = this.v19_1;
            this.f9_1 = 1;
            suspendResult = $this$unsafeFlow.x18(this.u19_1.w19_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function flowOf$$inlined$unsafeFlow$1($value) {
    this.w19_1 = $value;
  }
  protoOf(flowOf$$inlined$unsafeFlow$1).y18 = function (collector, $completion) {
    var tmp = new $collectCOROUTINE$_1(this, collector, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(flowOf$$inlined$unsafeFlow$1).f18 = function (collector, $completion) {
    return this.y18(collector, $completion);
  };
  function consumeAsFlow(_this__u8e3s4) {
    return new ChannelAsFlow(_this__u8e3s4, true);
  }
  function markConsumed($this) {
    if ($this.b1a_1) {
      // Inline function 'kotlin.check' call
      if (!!$this.c1a_1.atomicfu$getAndSet(true)) {
        var message = 'ReceiveChannel.consumeAsFlow can be collected just once';
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      }
    }
  }
  function $collectCOROUTINE$_2(_this__u8e3s4, collector, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.l1a_1 = _this__u8e3s4;
    this.m1a_1 = collector;
  }
  protoOf($collectCOROUTINE$_2).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 4;
            if (this.l1a_1.x17_1 === -3) {
              markConsumed(this.l1a_1);
              this.f9_1 = 2;
              suspendResult = emitAllImpl(this.m1a_1, this.l1a_1.a1a_1, this.l1a_1.b1a_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.f9_1 = 1;
              suspendResult = protoOf(ChannelFlow).f18.call(this.l1a_1, this.m1a_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            this.f9_1 = 3;
            continue $sm;
          case 2:
            this.f9_1 = 3;
            continue $sm;
          case 3:
            return Unit_instance;
          case 4:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 4) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function ChannelAsFlow(channel, consume, context, capacity, onBufferOverflow) {
    context = context === VOID ? EmptyCoroutineContext_instance : context;
    capacity = capacity === VOID ? -3 : capacity;
    onBufferOverflow = onBufferOverflow === VOID ? BufferOverflow_SUSPEND_getInstance() : onBufferOverflow;
    ChannelFlow.call(this, context, capacity, onBufferOverflow);
    this.a1a_1 = channel;
    this.b1a_1 = consume;
    this.c1a_1 = atomic$boolean$1(false);
  }
  protoOf(ChannelAsFlow).u17 = function (context, capacity, onBufferOverflow) {
    return new ChannelAsFlow(this.a1a_1, this.b1a_1, context, capacity, onBufferOverflow);
  };
  protoOf(ChannelAsFlow).b18 = function () {
    return new ChannelAsFlow(this.a1a_1, this.b1a_1);
  };
  protoOf(ChannelAsFlow).v17 = function (scope, $completion) {
    return emitAllImpl(new SendingCollector(scope), this.a1a_1, this.b1a_1, $completion);
  };
  protoOf(ChannelAsFlow).e18 = function (scope) {
    markConsumed(this);
    var tmp;
    if (this.x17_1 === -3) {
      tmp = this.a1a_1;
    } else {
      tmp = protoOf(ChannelFlow).e18.call(this, scope);
    }
    return tmp;
  };
  protoOf(ChannelAsFlow).f18 = function (collector, $completion) {
    var tmp = new $collectCOROUTINE$_2(this, collector, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(ChannelAsFlow).g18 = function () {
    return 'channel=' + toString_1(this.a1a_1);
  };
  function emitAllImpl(_this__u8e3s4, channel, consume, $completion) {
    var tmp = new $emitAllImplCOROUTINE$(_this__u8e3s4, channel, consume, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  }
  function emitAll(_this__u8e3s4, channel, $completion) {
    return emitAllImpl(_this__u8e3s4, channel, true, $completion);
  }
  function $emitAllImplCOROUTINE$(_this__u8e3s4, channel, consume, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.v1a_1 = _this__u8e3s4;
    this.w1a_1 = channel;
    this.x1a_1 = consume;
  }
  protoOf($emitAllImplCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 9;
            ensureActive_1(this.v1a_1);
            this.y1a_1 = null;
            this.f9_1 = 1;
            continue $sm;
          case 1:
            this.g9_1 = 7;
            this.g9_1 = 6;
            this.z1a_1 = this.w1a_1.m();
            this.f9_1 = 2;
            continue $sm;
          case 2:
            this.f9_1 = 3;
            suspendResult = this.z1a_1.d14(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            if (!suspendResult) {
              this.f9_1 = 5;
              continue $sm;
            }

            var element = this.z1a_1.o();
            this.f9_1 = 4;
            suspendResult = this.v1a_1.x18(element, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            this.f9_1 = 2;
            continue $sm;
          case 5:
            this.g9_1 = 9;
            this.f9_1 = 8;
            continue $sm;
          case 6:
            this.g9_1 = 7;
            var tmp_0 = this.i9_1;
            if (tmp_0 instanceof Error) {
              var e = this.i9_1;
              this.y1a_1 = e;
              throw e;
            } else {
              throw this.i9_1;
            }

          case 7:
            this.g9_1 = 9;
            var t = this.i9_1;
            if (this.x1a_1) {
              cancelConsumed(this.w1a_1, this.y1a_1);
            }

            throw t;
          case 8:
            this.g9_1 = 9;
            if (this.x1a_1) {
              cancelConsumed(this.w1a_1, this.y1a_1);
            }

            return Unit_instance;
          case 9:
            throw this.i9_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.g9_1 === 9) {
          throw e_0;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e_0;
        }
      }
     while (true);
  };
  function Flow() {
  }
  function $collectCOROUTINE$_3(_this__u8e3s4, collector, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.i1b_1 = _this__u8e3s4;
    this.j1b_1 = collector;
  }
  protoOf($collectCOROUTINE$_3).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 5;
            var tmp_0 = this;
            tmp_0.k1b_1 = new SafeCollector(this.j1b_1, this.l9());
            this.f9_1 = 1;
            continue $sm;
          case 1:
            this.g9_1 = 4;
            this.f9_1 = 2;
            suspendResult = this.i1b_1.i18(this.k1b_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.g9_1 = 5;
            this.f9_1 = 3;
            continue $sm;
          case 3:
            this.g9_1 = 5;
            this.k1b_1.p9();
            return Unit_instance;
          case 4:
            this.g9_1 = 5;
            var t = this.i9_1;
            this.k1b_1.p9();
            throw t;
          case 5:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 5) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function AbstractFlow() {
  }
  protoOf(AbstractFlow).f18 = function (collector, $completion) {
    var tmp = new $collectCOROUTINE$_3(this, collector, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  function FlowCollector() {
  }
  function get_NO_VALUE() {
    _init_properties_SharedFlow_kt__umasnn();
    return NO_VALUE;
  }
  var NO_VALUE;
  function MutableSharedFlow(replay, extraBufferCapacity, onBufferOverflow) {
    replay = replay === VOID ? 0 : replay;
    extraBufferCapacity = extraBufferCapacity === VOID ? 0 : extraBufferCapacity;
    onBufferOverflow = onBufferOverflow === VOID ? BufferOverflow_SUSPEND_getInstance() : onBufferOverflow;
    _init_properties_SharedFlow_kt__umasnn();
    // Inline function 'kotlin.require' call
    if (!(replay >= 0)) {
      var message = 'replay cannot be negative, but was ' + replay;
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    // Inline function 'kotlin.require' call
    if (!(extraBufferCapacity >= 0)) {
      var message_0 = 'extraBufferCapacity cannot be negative, but was ' + extraBufferCapacity;
      throw IllegalArgumentException_init_$Create$_0(toString_1(message_0));
    }
    // Inline function 'kotlin.require' call
    if (!(replay > 0 || extraBufferCapacity > 0 || onBufferOverflow.equals(BufferOverflow_SUSPEND_getInstance()))) {
      var message_1 = 'replay or extraBufferCapacity must be positive with non-default onBufferOverflow strategy ' + onBufferOverflow.toString();
      throw IllegalArgumentException_init_$Create$_0(toString_1(message_1));
    }
    var bufferCapacity0 = replay + extraBufferCapacity | 0;
    var bufferCapacity = bufferCapacity0 < 0 ? 2147483647 : bufferCapacity0;
    return new SharedFlowImpl(replay, bufferCapacity, onBufferOverflow);
  }
  function _get_head__d7jo8b($this) {
    var tmp0 = $this.y1b_1;
    // Inline function 'kotlin.comparisons.minOf' call
    var b = $this.x1b_1;
    return tmp0 <= b ? tmp0 : b;
  }
  function _get_replaySize__dxgnb1($this) {
    var tmp0 = _get_head__d7jo8b($this);
    // Inline function 'kotlin.Long.plus' call
    var other = $this.z1b_1;
    var tmp$ret$0 = add_2(tmp0, fromInt_0(other));
    return convertToInt(subtract_1(tmp$ret$0, $this.x1b_1));
  }
  function _get_totalSize__xhdb3o($this) {
    return $this.z1b_1 + $this.a1c_1 | 0;
  }
  function _get_bufferEndIndex__d2rk18($this) {
    var tmp0 = _get_head__d7jo8b($this);
    // Inline function 'kotlin.Long.plus' call
    var other = $this.z1b_1;
    return add_2(tmp0, fromInt_0(other));
  }
  function _get_queueEndIndex__4m025l($this) {
    var tmp0 = _get_head__d7jo8b($this);
    // Inline function 'kotlin.Long.plus' call
    var other = $this.z1b_1;
    var tmp0_0 = add_2(tmp0, fromInt_0(other));
    // Inline function 'kotlin.Long.plus' call
    var other_0 = $this.a1c_1;
    return add_2(tmp0_0, fromInt_0(other_0));
  }
  function tryEmitLocked($this, value) {
    if ($this.c1c_1 === 0)
      return tryEmitNoCollectorsLocked($this, value);
    if ($this.z1b_1 >= $this.u1b_1 && $this.y1b_1 <= $this.x1b_1) {
      switch ($this.v1b_1.x2_1) {
        case 0:
          return false;
        case 2:
          return true;
        case 1:
          break;
      }
    }
    enqueueLocked($this, value);
    $this.z1b_1 = $this.z1b_1 + 1 | 0;
    if ($this.z1b_1 > $this.u1b_1) {
      dropOldestLocked($this);
    }
    if (_get_replaySize__dxgnb1($this) > $this.t1b_1) {
      // Inline function 'kotlin.Long.plus' call
      var this_0 = $this.x1b_1;
      var tmp$ret$0 = add_2(this_0, fromInt_0(1));
      updateBufferLocked($this, tmp$ret$0, $this.y1b_1, _get_bufferEndIndex__d2rk18($this), _get_queueEndIndex__4m025l($this));
    }
    return true;
  }
  function tryEmitNoCollectorsLocked($this, value) {
    // Inline function 'kotlinx.coroutines.assert' call
    if ($this.t1b_1 === 0)
      return true;
    enqueueLocked($this, value);
    $this.z1b_1 = $this.z1b_1 + 1 | 0;
    if ($this.z1b_1 > $this.t1b_1) {
      dropOldestLocked($this);
    }
    var tmp = $this;
    var tmp0 = _get_head__d7jo8b($this);
    // Inline function 'kotlin.Long.plus' call
    var other = $this.z1b_1;
    tmp.y1b_1 = add_2(tmp0, fromInt_0(other));
    return true;
  }
  function dropOldestLocked($this) {
    setBufferAt(ensureNotNull($this.w1b_1), _get_head__d7jo8b($this), null);
    $this.z1b_1 = $this.z1b_1 - 1 | 0;
    // Inline function 'kotlin.Long.plus' call
    var this_0 = _get_head__d7jo8b($this);
    var newHead = add_2(this_0, fromInt_0(1));
    if ($this.x1b_1 < newHead)
      $this.x1b_1 = newHead;
    if ($this.y1b_1 < newHead) {
      correctCollectorIndexesOnDropOldest($this, newHead);
    }
    // Inline function 'kotlinx.coroutines.assert' call
  }
  function correctCollectorIndexesOnDropOldest($this, newHead) {
    $l$block: {
      // Inline function 'kotlinx.coroutines.flow.internal.AbstractSharedFlow.forEachSlotLocked' call
      if ($this.c1c_1 === 0) {
        break $l$block;
      }
      var tmp0_safe_receiver = $this.b1c_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.collections.forEach' call
        var inductionVariable = 0;
        var last = tmp0_safe_receiver.length;
        while (inductionVariable < last) {
          var element = tmp0_safe_receiver[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          if (!(element == null)) {
            if (element.f1c_1 >= 0n && element.f1c_1 < newHead) {
              element.f1c_1 = newHead;
            }
          }
        }
      }
    }
    $this.y1b_1 = newHead;
  }
  function enqueueLocked($this, item) {
    var curSize = _get_totalSize__xhdb3o($this);
    var curBuffer = $this.w1b_1;
    var buffer = curBuffer == null ? growBuffer($this, null, 0, 2) : curSize >= curBuffer.length ? growBuffer($this, curBuffer, curSize, imul(curBuffer.length, 2)) : curBuffer;
    // Inline function 'kotlin.Long.plus' call
    var this_0 = _get_head__d7jo8b($this);
    var tmp$ret$0 = add_2(this_0, fromInt_0(curSize));
    setBufferAt(buffer, tmp$ret$0, item);
  }
  function growBuffer($this, curBuffer, curSize, newSize) {
    // Inline function 'kotlin.check' call
    if (!(newSize > 0)) {
      var message = 'Buffer size overflow';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    // Inline function 'kotlin.arrayOfNulls' call
    // Inline function 'kotlin.also' call
    var this_0 = Array(newSize);
    $this.w1b_1 = this_0;
    var newBuffer = this_0;
    if (curBuffer == null)
      return newBuffer;
    var head = _get_head__d7jo8b($this);
    var inductionVariable = 0;
    if (inductionVariable < curSize)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlin.Long.plus' call
        var tmp = add_2(head, fromInt_0(i));
        // Inline function 'kotlin.Long.plus' call
        var tmp$ret$6 = add_2(head, fromInt_0(i));
        setBufferAt(newBuffer, tmp, getBufferAt(curBuffer, tmp$ret$6));
      }
       while (inductionVariable < curSize);
    return newBuffer;
  }
  function emitSuspend($this, value, $completion) {
    var cancellable = new CancellableContinuationImpl(intercepted($completion), 1);
    cancellable.mt();
    var resumes = get_EMPTY_RESUMES();
    // Inline function 'kotlinx.coroutines.internal.synchronized' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlinx.coroutines.internal.synchronizedImpl' call
    var tmp$ret$3;
    $l$block: {
      if (tryEmitLocked($this, value)) {
        // Inline function 'kotlin.coroutines.resume' call
        // Inline function 'kotlin.Companion.success' call
        var tmp$ret$1 = _Result___init__impl__xyqfz8(Unit_instance);
        cancellable.q9(tmp$ret$1);
        resumes = findSlotsToResumeLocked($this, resumes);
        tmp$ret$3 = null;
        break $l$block;
      }
      var tmp0 = _get_head__d7jo8b($this);
      // Inline function 'kotlin.Long.plus' call
      var other = _get_totalSize__xhdb3o($this);
      var tmp$ret$4 = add_2(tmp0, fromInt_0(other));
      // Inline function 'kotlin.also' call
      var this_0 = new Emitter($this, tmp$ret$4, value, cancellable);
      enqueueLocked($this, this_0);
      $this.a1c_1 = $this.a1c_1 + 1 | 0;
      if ($this.u1b_1 === 0)
        resumes = findSlotsToResumeLocked($this, resumes);
      tmp$ret$3 = this_0;
    }
    var emitter = tmp$ret$3;
    if (emitter == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      disposeOnCancellation(cancellable, emitter);
    }
    var indexedObject = resumes;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var r = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (r == null)
        null;
      else {
        // Inline function 'kotlin.coroutines.resume' call
        // Inline function 'kotlin.Companion.success' call
        var tmp$ret$11 = _Result___init__impl__xyqfz8(Unit_instance);
        r.q9(tmp$ret$11);
      }
    }
    return cancellable.tt();
  }
  function cancelEmitter($this, emitter) {
    // Inline function 'kotlinx.coroutines.internal.synchronized' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlinx.coroutines.internal.synchronizedImpl' call
    if (emitter.i1c_1 < _get_head__d7jo8b($this))
      return Unit_instance;
    var buffer = ensureNotNull($this.w1b_1);
    if (!(getBufferAt(buffer, emitter.i1c_1) === emitter))
      return Unit_instance;
    setBufferAt(buffer, emitter.i1c_1, get_NO_VALUE());
    cleanupTailLocked($this);
    return Unit_instance;
  }
  function updateBufferLocked($this, newReplayIndex, newMinCollectorIndex, newBufferEndIndex, newQueueEndIndex) {
    // Inline function 'kotlin.comparisons.minOf' call
    var newHead = newMinCollectorIndex <= newReplayIndex ? newMinCollectorIndex : newReplayIndex;
    // Inline function 'kotlinx.coroutines.assert' call
    var inductionVariable = _get_head__d7jo8b($this);
    if (inductionVariable < newHead)
      do {
        var index = inductionVariable;
        inductionVariable = add_2(inductionVariable, 1n);
        setBufferAt(ensureNotNull($this.w1b_1), index, null);
      }
       while (inductionVariable < newHead);
    $this.x1b_1 = newReplayIndex;
    $this.y1b_1 = newMinCollectorIndex;
    $this.z1b_1 = convertToInt(subtract_1(newBufferEndIndex, newHead));
    $this.a1c_1 = convertToInt(subtract_1(newQueueEndIndex, newBufferEndIndex));
    // Inline function 'kotlinx.coroutines.assert' call
    // Inline function 'kotlinx.coroutines.assert' call
    // Inline function 'kotlinx.coroutines.assert' call
  }
  function cleanupTailLocked($this) {
    if ($this.u1b_1 === 0 && $this.a1c_1 <= 1)
      return Unit_instance;
    var buffer = ensureNotNull($this.w1b_1);
    $l$loop: while (true) {
      var tmp;
      if ($this.a1c_1 > 0) {
        var tmp0 = _get_head__d7jo8b($this);
        // Inline function 'kotlin.Long.plus' call
        var other = _get_totalSize__xhdb3o($this);
        // Inline function 'kotlin.Long.minus' call
        var this_0 = add_2(tmp0, fromInt_0(other));
        var tmp$ret$1 = subtract_1(this_0, fromInt_0(1));
        tmp = getBufferAt(buffer, tmp$ret$1) === get_NO_VALUE();
      } else {
        tmp = false;
      }
      if (!tmp) {
        break $l$loop;
      }
      $this.a1c_1 = $this.a1c_1 - 1 | 0;
      var tmp0_0 = _get_head__d7jo8b($this);
      // Inline function 'kotlin.Long.plus' call
      var other_0 = _get_totalSize__xhdb3o($this);
      var tmp$ret$2 = add_2(tmp0_0, fromInt_0(other_0));
      setBufferAt(buffer, tmp$ret$2, null);
    }
  }
  function tryTakeValue($this, slot) {
    var resumes = get_EMPTY_RESUMES();
    // Inline function 'kotlinx.coroutines.internal.synchronized' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlinx.coroutines.internal.synchronizedImpl' call
    var index = tryPeekLocked($this, slot);
    var tmp;
    if (index < 0n) {
      tmp = get_NO_VALUE();
    } else {
      var oldIndex = slot.f1c_1;
      var newValue = getPeekedValueLockedAt($this, index);
      var tmp_0 = slot;
      // Inline function 'kotlin.Long.plus' call
      tmp_0.f1c_1 = add_2(index, fromInt_0(1));
      resumes = $this.l1c(oldIndex);
      tmp = newValue;
    }
    var value = tmp;
    var indexedObject = resumes;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var resume = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (resume == null)
        null;
      else {
        // Inline function 'kotlin.coroutines.resume' call
        // Inline function 'kotlin.Companion.success' call
        var tmp$ret$5 = _Result___init__impl__xyqfz8(Unit_instance);
        resume.q9(tmp$ret$5);
      }
    }
    return value;
  }
  function tryPeekLocked($this, slot) {
    var index = slot.f1c_1;
    if (index < _get_bufferEndIndex__d2rk18($this))
      return index;
    if ($this.u1b_1 > 0)
      return -1n;
    if (index > _get_head__d7jo8b($this))
      return -1n;
    if ($this.a1c_1 === 0)
      return -1n;
    return index;
  }
  function getPeekedValueLockedAt($this, index) {
    var item = getBufferAt(ensureNotNull($this.w1b_1), index);
    var tmp;
    if (item instanceof Emitter) {
      tmp = item.j1c_1;
    } else {
      tmp = item;
    }
    return tmp;
  }
  function awaitValue($this, slot, $completion) {
    var cancellable = new CancellableContinuationImpl(intercepted($completion), 1);
    cancellable.mt();
    // Inline function 'kotlinx.coroutines.internal.synchronized' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlinx.coroutines.internal.synchronizedImpl' call
    $l$block: {
      var index = tryPeekLocked($this, slot);
      if (index < 0n) {
        slot.g1c_1 = cancellable;
      } else {
        // Inline function 'kotlin.coroutines.resume' call
        // Inline function 'kotlin.Companion.success' call
        var tmp$ret$1 = _Result___init__impl__xyqfz8(Unit_instance);
        cancellable.q9(tmp$ret$1);
        break $l$block;
      }
      slot.g1c_1 = cancellable;
    }
    return cancellable.tt();
  }
  function findSlotsToResumeLocked($this, resumesIn) {
    var resumes = resumesIn;
    var resumeCount = resumesIn.length;
    $l$block: {
      // Inline function 'kotlinx.coroutines.flow.internal.AbstractSharedFlow.forEachSlotLocked' call
      if ($this.c1c_1 === 0) {
        break $l$block;
      }
      var tmp0_safe_receiver = $this.b1c_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.collections.forEach' call
        var inductionVariable = 0;
        var last = tmp0_safe_receiver.length;
        while (inductionVariable < last) {
          var element = tmp0_safe_receiver[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          if (!(element == null)) {
            $l$block_1: {
              var tmp0_elvis_lhs = element.g1c_1;
              var tmp;
              if (tmp0_elvis_lhs == null) {
                break $l$block_1;
              } else {
                tmp = tmp0_elvis_lhs;
              }
              var cont = tmp;
              if (tryPeekLocked($this, element) < 0n) {
                break $l$block_1;
              }
              if (resumeCount >= resumes.length) {
                var tmp_0 = resumes;
                // Inline function 'kotlin.comparisons.maxOf' call
                var b = imul(2, resumes.length);
                var tmp$ret$2 = Math.max(2, b);
                resumes = copyOf_1(tmp_0, tmp$ret$2);
              }
              var tmp_1 = resumes;
              var tmp1 = resumeCount;
              resumeCount = tmp1 + 1 | 0;
              tmp_1[tmp1] = cont;
              element.g1c_1 = null;
            }
          }
        }
      }
    }
    return resumes;
  }
  function Emitter(flow, index, value, cont) {
    this.h1c_1 = flow;
    this.i1c_1 = index;
    this.j1c_1 = value;
    this.k1c_1 = cont;
  }
  protoOf(Emitter).zr = function () {
    return cancelEmitter(this.h1c_1, this);
  };
  function $collectCOROUTINE$_4(_this__u8e3s4, collector, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.u1c_1 = _this__u8e3s4;
    this.v1c_1 = collector;
  }
  protoOf($collectCOROUTINE$_4).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 13;
            this.w1c_1 = this.u1c_1.z1c();
            this.f9_1 = 1;
            continue $sm;
          case 1:
            this.g9_1 = 12;
            var tmp_0 = this.v1c_1;
            if (tmp_0 instanceof SubscribedFlowCollector) {
              this.f9_1 = 2;
              suspendResult = this.v1c_1.c1d(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.f9_1 = 3;
              continue $sm;
            }

          case 2:
            this.f9_1 = 3;
            continue $sm;
          case 3:
            var tmp_1 = this;
            tmp_1.y1c_1 = this.l9().s9(Key_instance_3);
            this.f9_1 = 4;
            continue $sm;
          case 4:
            if (!true) {
              this.f9_1 = 10;
              continue $sm;
            }

            this.f9_1 = 5;
            continue $sm;
          case 5:
            if (!true) {
              this.f9_1 = 8;
              continue $sm;
            }

            this.x1c_1 = tryTakeValue(this.u1c_1, this.w1c_1);
            if (!(this.x1c_1 === get_NO_VALUE())) {
              this.f9_1 = 8;
              continue $sm;
            } else {
              this.f9_1 = 6;
              continue $sm;
            }

          case 6:
            this.f9_1 = 7;
            suspendResult = awaitValue(this.u1c_1, this.w1c_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 7:
            this.f9_1 = 5;
            continue $sm;
          case 8:
            var tmp0_safe_receiver = this.y1c_1;
            if (tmp0_safe_receiver == null)
              null;
            else {
              ensureActive_0(tmp0_safe_receiver);
            }

            this.f9_1 = 9;
            var tmp_2 = this.x1c_1;
            suspendResult = this.v1c_1.x18((tmp_2 == null ? true : !(tmp_2 == null)) ? tmp_2 : THROW_CCE(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 9:
            this.f9_1 = 4;
            continue $sm;
          case 10:
            this.g9_1 = 13;
            this.f9_1 = 11;
            continue $sm;
          case 11:
            this.g9_1 = 13;
            this.u1c_1.d1d(this.w1c_1);
            return Unit_instance;
          case 12:
            this.g9_1 = 13;
            var t = this.i9_1;
            this.u1c_1.d1d(this.w1c_1);
            throw t;
          case 13:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 13) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function SharedFlowImpl(replay, bufferCapacity, onBufferOverflow) {
    AbstractSharedFlow.call(this);
    this.t1b_1 = replay;
    this.u1b_1 = bufferCapacity;
    this.v1b_1 = onBufferOverflow;
    this.w1b_1 = null;
    this.x1b_1 = 0n;
    this.y1b_1 = 0n;
    this.z1b_1 = 0;
    this.a1c_1 = 0;
  }
  protoOf(SharedFlowImpl).e1d = function () {
    var tmp = ensureNotNull(this.w1b_1);
    var tmp0 = this.x1b_1;
    // Inline function 'kotlin.Long.plus' call
    var other = _get_replaySize__dxgnb1(this);
    // Inline function 'kotlin.Long.minus' call
    var this_0 = add_2(tmp0, fromInt_0(other));
    var tmp$ret$1 = subtract_1(this_0, fromInt_0(1));
    var tmp_0 = getBufferAt(tmp, tmp$ret$1);
    return (tmp_0 == null ? true : !(tmp_0 == null)) ? tmp_0 : THROW_CCE();
  };
  protoOf(SharedFlowImpl).f1d = function (collector, $completion) {
    var tmp = new $collectCOROUTINE$_4(this, collector, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(SharedFlowImpl).f18 = function (collector, $completion) {
    return this.f1d(collector, $completion);
  };
  protoOf(SharedFlowImpl).g1d = function (value) {
    var resumes = get_EMPTY_RESUMES();
    // Inline function 'kotlinx.coroutines.internal.synchronized' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlinx.coroutines.internal.synchronizedImpl' call
    var tmp;
    if (tryEmitLocked(this, value)) {
      resumes = findSlotsToResumeLocked(this, resumes);
      tmp = true;
    } else {
      tmp = false;
    }
    var emitted = tmp;
    var indexedObject = resumes;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var cont = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (cont == null)
        null;
      else {
        // Inline function 'kotlin.coroutines.resume' call
        // Inline function 'kotlin.Companion.success' call
        var tmp$ret$4 = _Result___init__impl__xyqfz8(Unit_instance);
        cont.q9(tmp$ret$4);
      }
    }
    return emitted;
  };
  protoOf(SharedFlowImpl).x18 = function (value, $completion) {
    if (this.g1d(value))
      return Unit_instance;
    return emitSuspend(this, value, $completion);
  };
  protoOf(SharedFlowImpl).h1d = function () {
    var index = this.x1b_1;
    if (index < this.y1b_1)
      this.y1b_1 = index;
    return index;
  };
  protoOf(SharedFlowImpl).l1c = function (oldIndex) {
    // Inline function 'kotlinx.coroutines.assert' call
    if (oldIndex > this.y1b_1)
      return get_EMPTY_RESUMES();
    var head = _get_head__d7jo8b(this);
    // Inline function 'kotlin.Long.plus' call
    var other = this.z1b_1;
    var newMinCollectorIndex = add_2(head, fromInt_0(other));
    if (this.u1b_1 === 0 && this.a1c_1 > 0) {
      var tmp0 = newMinCollectorIndex;
      newMinCollectorIndex = add_2(tmp0, get_ONE());
    }
    $l$block: {
      // Inline function 'kotlinx.coroutines.flow.internal.AbstractSharedFlow.forEachSlotLocked' call
      if (this.c1c_1 === 0) {
        break $l$block;
      }
      var tmp0_safe_receiver = this.b1c_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.collections.forEach' call
        var inductionVariable = 0;
        var last = tmp0_safe_receiver.length;
        while (inductionVariable < last) {
          var element = tmp0_safe_receiver[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          if (!(element == null)) {
            if (element.f1c_1 >= 0n && element.f1c_1 < newMinCollectorIndex)
              newMinCollectorIndex = element.f1c_1;
          }
        }
      }
    }
    // Inline function 'kotlinx.coroutines.assert' call
    if (newMinCollectorIndex <= this.y1b_1)
      return get_EMPTY_RESUMES();
    var newBufferEndIndex = _get_bufferEndIndex__d2rk18(this);
    var tmp;
    if (this.c1c_1 > 0) {
      var newBufferSize0 = convertToInt(subtract_1(newBufferEndIndex, newMinCollectorIndex));
      var tmp0_0 = this.a1c_1;
      // Inline function 'kotlin.comparisons.minOf' call
      var b = this.u1b_1 - newBufferSize0 | 0;
      tmp = Math.min(tmp0_0, b);
    } else {
      tmp = this.a1c_1;
    }
    var maxResumeCount = tmp;
    var resumes = get_EMPTY_RESUMES();
    var tmp0_1 = newBufferEndIndex;
    // Inline function 'kotlin.Long.plus' call
    var other_0 = this.a1c_1;
    var newQueueEndIndex = add_2(tmp0_1, fromInt_0(other_0));
    if (maxResumeCount > 0) {
      // Inline function 'kotlin.arrayOfNulls' call
      resumes = Array(maxResumeCount);
      var resumeCount = 0;
      var buffer = ensureNotNull(this.w1b_1);
      var inductionVariable_0 = newBufferEndIndex;
      if (inductionVariable_0 < newQueueEndIndex)
        $l$loop: do {
          var curEmitterIndex = inductionVariable_0;
          inductionVariable_0 = add_2(inductionVariable_0, 1n);
          var emitter = getBufferAt(buffer, curEmitterIndex);
          if (!(emitter === get_NO_VALUE())) {
            if (!(emitter instanceof Emitter))
              THROW_CCE();
            var tmp_0 = resumes;
            var tmp2 = resumeCount;
            resumeCount = tmp2 + 1 | 0;
            tmp_0[tmp2] = emitter.k1c_1;
            setBufferAt(buffer, curEmitterIndex, get_NO_VALUE());
            setBufferAt(buffer, newBufferEndIndex, emitter.j1c_1);
            var tmp3 = newBufferEndIndex;
            newBufferEndIndex = add_2(tmp3, get_ONE());
            if (resumeCount >= maxResumeCount)
              break $l$loop;
          }
        }
         while (inductionVariable_0 < newQueueEndIndex);
    }
    var newBufferSize1 = convertToInt(subtract_1(newBufferEndIndex, head));
    if (this.c1c_1 === 0)
      newMinCollectorIndex = newBufferEndIndex;
    var tmp0_2 = this.x1b_1;
    var tmp0_3 = newBufferEndIndex;
    // Inline function 'kotlin.comparisons.minOf' call
    var a = this.t1b_1;
    // Inline function 'kotlin.Long.minus' call
    var other_1 = Math.min(a, newBufferSize1);
    // Inline function 'kotlin.comparisons.maxOf' call
    var b_0 = subtract_1(tmp0_3, fromInt_0(other_1));
    var newReplayIndex = tmp0_2 >= b_0 ? tmp0_2 : b_0;
    if (this.u1b_1 === 0 && newReplayIndex < newQueueEndIndex && equals(getBufferAt(ensureNotNull(this.w1b_1), newReplayIndex), get_NO_VALUE())) {
      var tmp4 = newBufferEndIndex;
      newBufferEndIndex = add_2(tmp4, get_ONE());
      var tmp5 = newReplayIndex;
      newReplayIndex = add_2(tmp5, get_ONE());
    }
    updateBufferLocked(this, newReplayIndex, newMinCollectorIndex, newBufferEndIndex, newQueueEndIndex);
    cleanupTailLocked(this);
    // Inline function 'kotlin.collections.isNotEmpty' call
    // Inline function 'kotlin.collections.isEmpty' call
    if (!(resumes.length === 0))
      resumes = findSlotsToResumeLocked(this, resumes);
    return resumes;
  };
  protoOf(SharedFlowImpl).i1d = function () {
    return new SharedFlowSlot();
  };
  protoOf(SharedFlowImpl).j1d = function (size) {
    // Inline function 'kotlin.arrayOfNulls' call
    return Array(size);
  };
  protoOf(SharedFlowImpl).k1d = function () {
    // Inline function 'kotlinx.coroutines.internal.synchronized' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlinx.coroutines.internal.synchronizedImpl' call
    updateBufferLocked(this, _get_bufferEndIndex__d2rk18(this), this.y1b_1, _get_bufferEndIndex__d2rk18(this), _get_queueEndIndex__4m025l(this));
    return Unit_instance;
  };
  protoOf(SharedFlowImpl).c18 = function (context, capacity, onBufferOverflow) {
    return fuseSharedFlow(this, context, capacity, onBufferOverflow);
  };
  function SharedFlowSlot() {
    AbstractSharedFlowSlot.call(this);
    this.f1c_1 = -1n;
    this.g1c_1 = null;
  }
  protoOf(SharedFlowSlot).m1d = function (flow) {
    if (this.f1c_1 >= 0n)
      return false;
    this.f1c_1 = flow.h1d();
    return true;
  };
  protoOf(SharedFlowSlot).n1d = function (flow) {
    return this.m1d(flow instanceof SharedFlowImpl ? flow : THROW_CCE());
  };
  protoOf(SharedFlowSlot).o1d = function (flow) {
    // Inline function 'kotlinx.coroutines.assert' call
    var oldIndex = this.f1c_1;
    this.f1c_1 = -1n;
    this.g1c_1 = null;
    return flow.l1c(oldIndex);
  };
  protoOf(SharedFlowSlot).p1d = function (flow) {
    return this.o1d(flow instanceof SharedFlowImpl ? flow : THROW_CCE());
  };
  function getBufferAt(_this__u8e3s4, index) {
    _init_properties_SharedFlow_kt__umasnn();
    return _this__u8e3s4[convertToInt(index) & (_this__u8e3s4.length - 1 | 0)];
  }
  function setBufferAt(_this__u8e3s4, index, item) {
    _init_properties_SharedFlow_kt__umasnn();
    return _this__u8e3s4[convertToInt(index) & (_this__u8e3s4.length - 1 | 0)] = item;
  }
  function fuseSharedFlow(_this__u8e3s4, context, capacity, onBufferOverflow) {
    _init_properties_SharedFlow_kt__umasnn();
    if ((capacity === 0 || capacity === -3) && onBufferOverflow.equals(BufferOverflow_SUSPEND_getInstance())) {
      return _this__u8e3s4;
    }
    return new ChannelFlowOperatorImpl(_this__u8e3s4, context, capacity, onBufferOverflow);
  }
  var properties_initialized_SharedFlow_kt_tmefor;
  function _init_properties_SharedFlow_kt__umasnn() {
    if (!properties_initialized_SharedFlow_kt_tmefor) {
      properties_initialized_SharedFlow_kt_tmefor = true;
      NO_VALUE = new Symbol_0('NO_VALUE');
    }
  }
  function Companion_23() {
    Companion_instance_23 = this;
    this.q1d_1 = new StartedEagerly();
    this.r1d_1 = new StartedLazily();
  }
  var Companion_instance_23;
  function Companion_getInstance_23() {
    if (Companion_instance_23 == null)
      new Companion_23();
    return Companion_instance_23;
  }
  function StartedEagerly() {
  }
  protoOf(StartedEagerly).s1d = function (subscriptionCount) {
    return flowOf(SharingCommand_START_getInstance());
  };
  protoOf(StartedEagerly).toString = function () {
    return 'SharingStarted.Eagerly';
  };
  function StartedLazily$command$slambda$slambda($started, $this_flow, resultContinuation) {
    this.b1e_1 = $started;
    this.c1e_1 = $this_flow;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(StartedLazily$command$slambda$slambda).e1e = function (count, $completion) {
    var tmp = this.f1e(count, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(StartedLazily$command$slambda$slambda).v9 = function (p1, $completion) {
    return this.e1e((!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(StartedLazily$command$slambda$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 3;
            if (this.d1e_1 > 0 && !this.b1e_1._v) {
              this.b1e_1._v = true;
              this.f9_1 = 1;
              suspendResult = this.c1e_1.x18(SharingCommand_START_getInstance(), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.f9_1 = 2;
              continue $sm;
            }

          case 1:
            this.f9_1 = 2;
            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 3) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(StartedLazily$command$slambda$slambda).f1e = function (count, completion) {
    var i = new StartedLazily$command$slambda$slambda(this.b1e_1, this.c1e_1, completion);
    i.d1e_1 = count;
    return i;
  };
  function StartedLazily$command$slambda$slambda_0($started, $this_flow, resultContinuation) {
    var i = new StartedLazily$command$slambda$slambda($started, $this_flow, resultContinuation);
    var l = function (count, $completion) {
      return i.e1e(count, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function sam$kotlinx_coroutines_flow_FlowCollector$0(function_0) {
    this.g1e_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0).x18 = function (value, $completion) {
    return this.g1e_1(value, $completion);
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0).f3 = function () {
    return this.g1e_1;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, FlowCollector) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0).hashCode = function () {
    return hashCode(this.f3());
  };
  function StartedLazily$command$slambda($subscriptionCount, resultContinuation) {
    this.p1e_1 = $subscriptionCount;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(StartedLazily$command$slambda).r1e = function ($this$flow, $completion) {
    var tmp = this.s1e($this$flow, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(StartedLazily$command$slambda).v9 = function (p1, $completion) {
    return this.r1e((!(p1 == null) ? isInterface(p1, FlowCollector) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(StartedLazily$command$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            var started = {_v: false};
            this.f9_1 = 1;
            var tmp_0 = StartedLazily$command$slambda$slambda_0(started, this.q1e_1, null);
            suspendResult = this.p1e_1.f1d(new sam$kotlinx_coroutines_flow_FlowCollector$0(tmp_0), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            throwKotlinNothingValueException();
            break;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(StartedLazily$command$slambda).s1e = function ($this$flow, completion) {
    var i = new StartedLazily$command$slambda(this.p1e_1, completion);
    i.q1e_1 = $this$flow;
    return i;
  };
  function StartedLazily$command$slambda_0($subscriptionCount, resultContinuation) {
    var i = new StartedLazily$command$slambda($subscriptionCount, resultContinuation);
    var l = function ($this$flow, $completion) {
      return i.r1e($this$flow, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function StartedLazily() {
  }
  protoOf(StartedLazily).s1d = function (subscriptionCount) {
    return flow(StartedLazily$command$slambda_0(subscriptionCount, null));
  };
  protoOf(StartedLazily).toString = function () {
    return 'SharingStarted.Lazily';
  };
  var SharingCommand_START_instance;
  var SharingCommand_STOP_instance;
  var SharingCommand_STOP_AND_RESET_REPLAY_CACHE_instance;
  var SharingCommand_entriesInitialized;
  function SharingCommand_initEntries() {
    if (SharingCommand_entriesInitialized)
      return Unit_instance;
    SharingCommand_entriesInitialized = true;
    SharingCommand_START_instance = new SharingCommand('START', 0);
    SharingCommand_STOP_instance = new SharingCommand('STOP', 1);
    SharingCommand_STOP_AND_RESET_REPLAY_CACHE_instance = new SharingCommand('STOP_AND_RESET_REPLAY_CACHE', 2);
  }
  function SharingCommand(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function SharingCommand_START_getInstance() {
    SharingCommand_initEntries();
    return SharingCommand_START_instance;
  }
  function get_NONE() {
    _init_properties_StateFlow_kt__eu9yi5();
    return NONE;
  }
  var NONE;
  function get_PENDING() {
    _init_properties_StateFlow_kt__eu9yi5();
    return PENDING;
  }
  var PENDING;
  function StateFlow() {
  }
  function MutableStateFlow(value) {
    _init_properties_StateFlow_kt__eu9yi5();
    return new StateFlowImpl(value == null ? get_NULL() : value);
  }
  function updateState($this, expectedState, newState) {
    var curSequence;
    var curSlots;
    // Inline function 'kotlinx.coroutines.internal.synchronized' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlinx.coroutines.internal.synchronizedImpl' call
    var oldState = $this.x1e_1.kotlinx$atomicfu$value;
    if (!(expectedState == null) && !equals(oldState, expectedState))
      return false;
    if (equals(oldState, newState))
      return true;
    $this.x1e_1.kotlinx$atomicfu$value = newState;
    curSequence = $this.y1e_1;
    if ((curSequence & 1) === 0) {
      curSequence = curSequence + 1 | 0;
      $this.y1e_1 = curSequence;
    } else {
      $this.y1e_1 = curSequence + 2 | 0;
      return true;
    }
    curSlots = $this.b1c_1;
    while (true) {
      var tmp0_safe_receiver = curSlots;
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.collections.forEach' call
        var inductionVariable = 0;
        var last = tmp0_safe_receiver.length;
        while (inductionVariable < last) {
          var element = tmp0_safe_receiver[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          if (element == null)
            null;
          else {
            element.a1f();
          }
        }
      }
      // Inline function 'kotlinx.coroutines.internal.synchronized' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlinx.coroutines.internal.synchronizedImpl' call
      if ($this.y1e_1 === curSequence) {
        $this.y1e_1 = curSequence + 1 | 0;
        return true;
      }
      curSequence = $this.y1e_1;
      curSlots = $this.b1c_1;
    }
  }
  function $collectCOROUTINE$_5(_this__u8e3s4, collector, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.j1f_1 = _this__u8e3s4;
    this.k1f_1 = collector;
  }
  protoOf($collectCOROUTINE$_5).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 12;
            this.l1f_1 = this.j1f_1.z1c();
            this.f9_1 = 1;
            continue $sm;
          case 1:
            this.g9_1 = 11;
            var tmp_0 = this.k1f_1;
            if (tmp_0 instanceof SubscribedFlowCollector) {
              this.f9_1 = 2;
              suspendResult = this.k1f_1.c1d(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.f9_1 = 3;
              continue $sm;
            }

          case 2:
            this.f9_1 = 3;
            continue $sm;
          case 3:
            var tmp_1 = this;
            tmp_1.o1f_1 = this.l9().s9(Key_instance_3);
            this.m1f_1 = null;
            this.f9_1 = 4;
            continue $sm;
          case 4:
            if (!true) {
              this.f9_1 = 9;
              continue $sm;
            }

            this.n1f_1 = this.j1f_1.x1e_1.kotlinx$atomicfu$value;
            var tmp0_safe_receiver = this.o1f_1;
            if (tmp0_safe_receiver == null)
              null;
            else {
              ensureActive_0(tmp0_safe_receiver);
            }

            if (this.m1f_1 == null || !equals(this.m1f_1, this.n1f_1)) {
              this.f9_1 = 5;
              var tmp0 = get_NULL();
              var value = this.n1f_1;
              var tmp_2;
              if (value === tmp0) {
                tmp_2 = (null == null ? true : !(null == null)) ? null : THROW_CCE();
              } else {
                tmp_2 = (value == null ? true : !(value == null)) ? value : THROW_CCE();
              }
              suspendResult = this.k1f_1.x18(tmp_2, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.f9_1 = 6;
              continue $sm;
            }

          case 5:
            this.m1f_1 = this.n1f_1;
            this.f9_1 = 6;
            continue $sm;
          case 6:
            if (!this.l1f_1.q1f()) {
              this.f9_1 = 7;
              suspendResult = this.l1f_1.p1f(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.f9_1 = 8;
              continue $sm;
            }

          case 7:
            this.f9_1 = 8;
            continue $sm;
          case 8:
            this.f9_1 = 4;
            continue $sm;
          case 9:
            this.g9_1 = 12;
            this.f9_1 = 10;
            continue $sm;
          case 10:
            this.g9_1 = 12;
            this.j1f_1.d1d(this.l1f_1);
            return Unit_instance;
          case 11:
            this.g9_1 = 12;
            var t = this.i9_1;
            this.j1f_1.d1d(this.l1f_1);
            throw t;
          case 12:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 12) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function StateFlowImpl(initialState) {
    AbstractSharedFlow.call(this);
    this.x1e_1 = atomic$ref$1(initialState);
    this.y1e_1 = 0;
  }
  protoOf(StateFlowImpl).r1f = function (value) {
    updateState(this, null, value == null ? get_NULL() : value);
  };
  protoOf(StateFlowImpl).a1 = function () {
    var tmp0 = get_NULL();
    // Inline function 'kotlinx.coroutines.internal.Symbol.unbox' call
    var value = this.x1e_1.kotlinx$atomicfu$value;
    var tmp;
    if (value === tmp0) {
      tmp = (null == null ? true : !(null == null)) ? null : THROW_CCE();
    } else {
      tmp = (value == null ? true : !(value == null)) ? value : THROW_CCE();
    }
    return tmp;
  };
  protoOf(StateFlowImpl).g1d = function (value) {
    this.r1f(value);
    return true;
  };
  protoOf(StateFlowImpl).x18 = function (value, $completion) {
    this.r1f(value);
    return Unit_instance;
  };
  protoOf(StateFlowImpl).k1d = function () {
    throw UnsupportedOperationException_init_$Create$_0('MutableStateFlow.resetReplayCache is not supported');
  };
  protoOf(StateFlowImpl).f1d = function (collector, $completion) {
    var tmp = new $collectCOROUTINE$_5(this, collector, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(StateFlowImpl).f18 = function (collector, $completion) {
    return this.f1d(collector, $completion);
  };
  protoOf(StateFlowImpl).i1d = function () {
    return new StateFlowSlot();
  };
  protoOf(StateFlowImpl).j1d = function (size) {
    // Inline function 'kotlin.arrayOfNulls' call
    return Array(size);
  };
  protoOf(StateFlowImpl).c18 = function (context, capacity, onBufferOverflow) {
    return fuseStateFlow(this, context, capacity, onBufferOverflow);
  };
  function StateFlowSlot() {
    AbstractSharedFlowSlot.call(this);
    this.z1e_1 = atomic$ref$1(null);
  }
  protoOf(StateFlowSlot).s1f = function (flow) {
    if (!(this.z1e_1.kotlinx$atomicfu$value == null))
      return false;
    this.z1e_1.kotlinx$atomicfu$value = get_NONE();
    return true;
  };
  protoOf(StateFlowSlot).n1d = function (flow) {
    return this.s1f(flow instanceof StateFlowImpl ? flow : THROW_CCE());
  };
  protoOf(StateFlowSlot).t1f = function (flow) {
    this.z1e_1.kotlinx$atomicfu$value = null;
    return get_EMPTY_RESUMES();
  };
  protoOf(StateFlowSlot).p1d = function (flow) {
    return this.t1f(flow instanceof StateFlowImpl ? flow : THROW_CCE());
  };
  protoOf(StateFlowSlot).a1f = function () {
    // Inline function 'kotlinx.atomicfu.loop' call
    var this_0 = this.z1e_1;
    while (true) {
      var state = this_0.kotlinx$atomicfu$value;
      if (state == null)
        return Unit_instance;
      else if (state === get_PENDING())
        return Unit_instance;
      else if (state === get_NONE()) {
        if (this.z1e_1.atomicfu$compareAndSet(state, get_PENDING()))
          return Unit_instance;
      } else {
        if (this.z1e_1.atomicfu$compareAndSet(state, get_NONE())) {
          // Inline function 'kotlin.coroutines.resume' call
          var this_1 = state instanceof CancellableContinuationImpl ? state : THROW_CCE();
          // Inline function 'kotlin.Companion.success' call
          var tmp$ret$0 = _Result___init__impl__xyqfz8(Unit_instance);
          this_1.q9(tmp$ret$0);
          return Unit_instance;
        }
      }
    }
  };
  protoOf(StateFlowSlot).q1f = function () {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlinx.coroutines.assert' call
    return ensureNotNull(this.z1e_1.atomicfu$getAndSet(get_NONE())) === get_PENDING();
  };
  protoOf(StateFlowSlot).p1f = function ($completion) {
    var cancellable = new CancellableContinuationImpl(intercepted($completion), 1);
    cancellable.mt();
    $l$block: {
      // Inline function 'kotlinx.coroutines.assert' call
      if (this.z1e_1.atomicfu$compareAndSet(get_NONE(), cancellable)) {
        break $l$block;
      }
      // Inline function 'kotlinx.coroutines.assert' call
      // Inline function 'kotlin.coroutines.resume' call
      // Inline function 'kotlin.Companion.success' call
      var tmp$ret$3 = _Result___init__impl__xyqfz8(Unit_instance);
      cancellable.q9(tmp$ret$3);
    }
    return cancellable.tt();
  };
  function fuseStateFlow(_this__u8e3s4, context, capacity, onBufferOverflow) {
    _init_properties_StateFlow_kt__eu9yi5();
    // Inline function 'kotlinx.coroutines.assert' call
    if (((0 <= capacity ? capacity <= 1 : false) || capacity === -2) && onBufferOverflow.equals(BufferOverflow_DROP_OLDEST_getInstance())) {
      return _this__u8e3s4;
    }
    return fuseSharedFlow(_this__u8e3s4, context, capacity, onBufferOverflow);
  }
  var properties_initialized_StateFlow_kt_nsqikx;
  function _init_properties_StateFlow_kt__eu9yi5() {
    if (!properties_initialized_StateFlow_kt_nsqikx) {
      properties_initialized_StateFlow_kt_nsqikx = true;
      NONE = new Symbol_0('NONE');
      PENDING = new Symbol_0('PENDING');
    }
  }
  function get_EMPTY_RESUMES() {
    _init_properties_AbstractSharedFlow_kt__h2xygb();
    return EMPTY_RESUMES;
  }
  var EMPTY_RESUMES;
  function AbstractSharedFlow() {
    this.b1c_1 = null;
    this.c1c_1 = 0;
    this.d1c_1 = 0;
    this.e1c_1 = null;
  }
  protoOf(AbstractSharedFlow).l1d = function () {
    // Inline function 'kotlinx.coroutines.internal.synchronized' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlinx.coroutines.internal.synchronizedImpl' call
    var tmp0_elvis_lhs = this.e1c_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.also' call
      var this_0 = new SubscriptionCountStateFlow(this.c1c_1);
      this.e1c_1 = this_0;
      tmp = this_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  protoOf(AbstractSharedFlow).z1c = function () {
    var subscriptionCount;
    // Inline function 'kotlinx.coroutines.internal.synchronized' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlinx.coroutines.internal.synchronizedImpl' call
    var curSlots = this.b1c_1;
    var tmp;
    if (curSlots == null) {
      // Inline function 'kotlin.also' call
      var this_0 = this.j1d(2);
      this.b1c_1 = this_0;
      tmp = this_0;
    } else {
      var tmp_0;
      if (this.c1c_1 >= curSlots.length) {
        // Inline function 'kotlin.also' call
        var this_1 = copyOf_1(curSlots, imul(2, curSlots.length));
        this.b1c_1 = this_1;
        tmp_0 = this_1;
      } else {
        tmp_0 = curSlots;
      }
      tmp = tmp_0;
    }
    var slots = tmp;
    var index = this.d1c_1;
    var slot;
    $l$loop: while (true) {
      var tmp0_elvis_lhs = slots[index];
      var tmp_1;
      if (tmp0_elvis_lhs == null) {
        // Inline function 'kotlin.also' call
        var this_2 = this.i1d();
        slots[index] = this_2;
        tmp_1 = this_2;
      } else {
        tmp_1 = tmp0_elvis_lhs;
      }
      slot = tmp_1;
      index = index + 1 | 0;
      if (index >= slots.length)
        index = 0;
      if ((slot instanceof AbstractSharedFlowSlot ? slot : THROW_CCE()).n1d(this))
        break $l$loop;
    }
    this.d1c_1 = index;
    this.c1c_1 = this.c1c_1 + 1 | 0;
    subscriptionCount = this.e1c_1;
    var slot_0 = slot;
    if (subscriptionCount == null)
      null;
    else
      subscriptionCount.g1g(1);
    return slot_0;
  };
  protoOf(AbstractSharedFlow).d1d = function (slot) {
    var subscriptionCount;
    // Inline function 'kotlinx.coroutines.internal.synchronized' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlinx.coroutines.internal.synchronizedImpl' call
    this.c1c_1 = this.c1c_1 - 1 | 0;
    subscriptionCount = this.e1c_1;
    if (this.c1c_1 === 0)
      this.d1c_1 = 0;
    var resumes = (slot instanceof AbstractSharedFlowSlot ? slot : THROW_CCE()).p1d(this);
    var inductionVariable = 0;
    var last = resumes.length;
    while (inductionVariable < last) {
      var cont = resumes[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (cont == null)
        null;
      else {
        // Inline function 'kotlin.coroutines.resume' call
        // Inline function 'kotlin.Companion.success' call
        var tmp$ret$4 = _Result___init__impl__xyqfz8(Unit_instance);
        cont.q9(tmp$ret$4);
      }
    }
    if (subscriptionCount == null)
      null;
    else
      subscriptionCount.g1g(-1);
  };
  function AbstractSharedFlowSlot() {
  }
  function SubscriptionCountStateFlow(initialValue) {
    SharedFlowImpl.call(this, 1, 2147483647, BufferOverflow_DROP_OLDEST_getInstance());
    this.g1d(initialValue);
  }
  protoOf(SubscriptionCountStateFlow).a1 = function () {
    // Inline function 'kotlinx.coroutines.internal.synchronized' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlinx.coroutines.internal.synchronizedImpl' call
    return this.e1d();
  };
  protoOf(SubscriptionCountStateFlow).g1g = function (delta) {
    // Inline function 'kotlinx.coroutines.internal.synchronized' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlinx.coroutines.internal.synchronizedImpl' call
    return this.g1d(this.e1d() + delta | 0);
  };
  var properties_initialized_AbstractSharedFlow_kt_2mpafr;
  function _init_properties_AbstractSharedFlow_kt__h2xygb() {
    if (!properties_initialized_AbstractSharedFlow_kt_2mpafr) {
      properties_initialized_AbstractSharedFlow_kt_2mpafr = true;
      // Inline function 'kotlin.arrayOfNulls' call
      EMPTY_RESUMES = Array(0);
    }
  }
  function ChannelFlow$_get_collectToFun_$slambda_j53z2e(this$0, resultContinuation) {
    this.p1g_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ChannelFlow$_get_collectToFun_$slambda_j53z2e).r1g = function (it, $completion) {
    var tmp = this.s1g(it, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(ChannelFlow$_get_collectToFun_$slambda_j53z2e).v9 = function (p1, $completion) {
    return this.r1g((!(p1 == null) ? isInterface(p1, ProducerScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ChannelFlow$_get_collectToFun_$slambda_j53z2e).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.p1g_1.v17(this.q1g_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(ChannelFlow$_get_collectToFun_$slambda_j53z2e).s1g = function (it, completion) {
    var i = new ChannelFlow$_get_collectToFun_$slambda_j53z2e(this.p1g_1, completion);
    i.q1g_1 = it;
    return i;
  };
  function ChannelFlow$_get_collectToFun_$slambda_j53z2e_0(this$0, resultContinuation) {
    var i = new ChannelFlow$_get_collectToFun_$slambda_j53z2e(this$0, resultContinuation);
    var l = function (it, $completion) {
      return i.r1g(it, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function ChannelFlow$collect$slambda($collector, this$0, resultContinuation) {
    this.b1h_1 = $collector;
    this.c1h_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ChannelFlow$collect$slambda).e1h = function ($this$coroutineScope, $completion) {
    var tmp = this.f1h($this$coroutineScope, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(ChannelFlow$collect$slambda).v9 = function (p1, $completion) {
    return this.e1h((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ChannelFlow$collect$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = emitAll(this.b1h_1, this.c1h_1.e18(this.d1h_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(ChannelFlow$collect$slambda).f1h = function ($this$coroutineScope, completion) {
    var i = new ChannelFlow$collect$slambda(this.b1h_1, this.c1h_1, completion);
    i.d1h_1 = $this$coroutineScope;
    return i;
  };
  function ChannelFlow$collect$slambda_0($collector, this$0, resultContinuation) {
    var i = new ChannelFlow$collect$slambda($collector, this$0, resultContinuation);
    var l = function ($this$coroutineScope, $completion) {
      return i.e1h($this$coroutineScope, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function ChannelFlow(context, capacity, onBufferOverflow) {
    this.w17_1 = context;
    this.x17_1 = capacity;
    this.y17_1 = onBufferOverflow;
    // Inline function 'kotlinx.coroutines.assert' call
  }
  protoOf(ChannelFlow).z17 = function () {
    return ChannelFlow$_get_collectToFun_$slambda_j53z2e_0(this, null);
  };
  protoOf(ChannelFlow).a18 = function () {
    return this.x17_1 === -3 ? -2 : this.x17_1;
  };
  protoOf(ChannelFlow).b18 = function () {
    return null;
  };
  protoOf(ChannelFlow).c18 = function (context, capacity, onBufferOverflow) {
    // Inline function 'kotlinx.coroutines.assert' call
    var newContext = context.wi(this.w17_1);
    var newCapacity;
    var newOverflow;
    if (!onBufferOverflow.equals(BufferOverflow_SUSPEND_getInstance())) {
      newCapacity = capacity;
      newOverflow = onBufferOverflow;
    } else {
      var tmp;
      if (this.x17_1 === -3) {
        tmp = capacity;
      } else if (capacity === -3) {
        tmp = this.x17_1;
      } else if (this.x17_1 === -2) {
        tmp = capacity;
      } else if (capacity === -2) {
        tmp = this.x17_1;
      } else {
        // Inline function 'kotlinx.coroutines.assert' call
        // Inline function 'kotlinx.coroutines.assert' call
        var sum = this.x17_1 + capacity | 0;
        tmp = sum >= 0 ? sum : 2147483647;
      }
      newCapacity = tmp;
      newOverflow = this.y17_1;
    }
    if (equals(newContext, this.w17_1) && newCapacity === this.x17_1 && newOverflow.equals(this.y17_1))
      return this;
    return this.u17(newContext, newCapacity, newOverflow);
  };
  protoOf(ChannelFlow).e18 = function (scope) {
    return produce(scope, this.w17_1, this.a18(), this.y17_1, CoroutineStart_ATOMIC_getInstance(), VOID, this.z17());
  };
  protoOf(ChannelFlow).f18 = function (collector, $completion) {
    return coroutineScope(ChannelFlow$collect$slambda_0(collector, this, null), $completion);
  };
  protoOf(ChannelFlow).g18 = function () {
    return null;
  };
  protoOf(ChannelFlow).toString = function () {
    var props = ArrayList_init_$Create$_0(4);
    var tmp0_safe_receiver = this.g18();
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      props.j(tmp0_safe_receiver);
    }
    if (!(this.w17_1 === EmptyCoroutineContext_instance)) {
      props.j('context=' + toString_1(this.w17_1));
    }
    if (!(this.x17_1 === -3)) {
      props.j('capacity=' + this.x17_1);
    }
    if (!this.y17_1.equals(BufferOverflow_SUSPEND_getInstance())) {
      props.j('onBufferOverflow=' + this.y17_1.toString());
    }
    return get_classSimpleName(this) + '[' + joinToString_0(props, ', ') + ']';
  };
  function FusibleFlow() {
  }
  function ChannelFlowOperatorImpl(flow, context, capacity, onBufferOverflow) {
    context = context === VOID ? EmptyCoroutineContext_instance : context;
    capacity = capacity === VOID ? -3 : capacity;
    onBufferOverflow = onBufferOverflow === VOID ? BufferOverflow_SUSPEND_getInstance() : onBufferOverflow;
    ChannelFlowOperator.call(this, flow, context, capacity, onBufferOverflow);
  }
  protoOf(ChannelFlowOperatorImpl).u17 = function (context, capacity, onBufferOverflow) {
    return new ChannelFlowOperatorImpl(this.n1h_1, context, capacity, onBufferOverflow);
  };
  protoOf(ChannelFlowOperatorImpl).b18 = function () {
    return this.n1h_1;
  };
  protoOf(ChannelFlowOperatorImpl).o1h = function (collector, $completion) {
    return this.n1h_1.f18(collector, $completion);
  };
  function collectWithContextUndispatched($this, collector, newContext, $completion) {
    // Inline function 'kotlin.js.getCoroutineContext' call
    var tmp$ret$0 = $completion.l9();
    var originalContextCollector = withUndispatchedContextCollector(collector, tmp$ret$0);
    return withContextUndispatched(newContext, originalContextCollector, VOID, ChannelFlowOperator$collectWithContextUndispatched$slambda_0($this, null), $completion);
  }
  function ChannelFlowOperator$collectWithContextUndispatched$slambda(this$0, resultContinuation) {
    this.x1h_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ChannelFlowOperator$collectWithContextUndispatched$slambda).z1h = function (it, $completion) {
    var tmp = this.a1i(it, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(ChannelFlowOperator$collectWithContextUndispatched$slambda).v9 = function (p1, $completion) {
    return this.z1h((!(p1 == null) ? isInterface(p1, FlowCollector) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ChannelFlowOperator$collectWithContextUndispatched$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.x1h_1.o1h(this.y1h_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(ChannelFlowOperator$collectWithContextUndispatched$slambda).a1i = function (it, completion) {
    var i = new ChannelFlowOperator$collectWithContextUndispatched$slambda(this.x1h_1, completion);
    i.y1h_1 = it;
    return i;
  };
  function ChannelFlowOperator$collectWithContextUndispatched$slambda_0(this$0, resultContinuation) {
    var i = new ChannelFlowOperator$collectWithContextUndispatched$slambda(this$0, resultContinuation);
    var l = function (it, $completion) {
      return i.z1h(it, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function $collectCOROUTINE$_6(_this__u8e3s4, collector, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.j1i_1 = _this__u8e3s4;
    this.k1i_1 = collector;
  }
  protoOf($collectCOROUTINE$_6).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 7;
            if (this.j1i_1.x17_1 === -3) {
              var tmp_0 = this;
              tmp_0.m1i_1 = this.l9();
              this.l1i_1 = this.m1i_1.wi(this.j1i_1.w17_1);
              if (equals(this.l1i_1, this.m1i_1)) {
                this.f9_1 = 6;
                suspendResult = this.j1i_1.o1h(this.k1i_1, this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                this.f9_1 = 1;
                continue $sm;
              }
            } else {
              this.f9_1 = 3;
              continue $sm;
            }

          case 1:
            if (equals(this.l1i_1.s9(Key_instance), this.m1i_1.s9(Key_instance))) {
              this.f9_1 = 5;
              suspendResult = collectWithContextUndispatched(this.j1i_1, this.k1i_1, this.l1i_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.f9_1 = 2;
              continue $sm;
            }

          case 2:
            this.f9_1 = 3;
            continue $sm;
          case 3:
            this.f9_1 = 4;
            suspendResult = protoOf(ChannelFlow).f18.call(this.j1i_1, this.k1i_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            return Unit_instance;
          case 5:
            return Unit_instance;
          case 6:
            return Unit_instance;
          case 7:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 7) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function ChannelFlowOperator(flow, context, capacity, onBufferOverflow) {
    ChannelFlow.call(this, context, capacity, onBufferOverflow);
    this.n1h_1 = flow;
  }
  protoOf(ChannelFlowOperator).v17 = function (scope, $completion) {
    return this.o1h(new SendingCollector(scope), $completion);
  };
  protoOf(ChannelFlowOperator).f18 = function (collector, $completion) {
    var tmp = new $collectCOROUTINE$_6(this, collector, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(ChannelFlowOperator).toString = function () {
    return toString_1(this.n1h_1) + ' -> ' + protoOf(ChannelFlow).toString.call(this);
  };
  function withUndispatchedContextCollector(_this__u8e3s4, emitContext) {
    var tmp;
    var tmp_0;
    if (_this__u8e3s4 instanceof SendingCollector) {
      tmp_0 = true;
    } else {
      tmp_0 = _this__u8e3s4 instanceof NopCollector;
    }
    if (tmp_0) {
      tmp = _this__u8e3s4;
    } else {
      tmp = new UndispatchedContextCollector(_this__u8e3s4, emitContext);
    }
    return tmp;
  }
  function withContextUndispatched(newContext, value, countOrElement, block, $completion) {
    countOrElement = countOrElement === VOID ? threadContextElements(newContext) : countOrElement;
    // Inline function 'kotlinx.coroutines.withCoroutineContext' call
    // Inline function 'kotlin.coroutines.intrinsics.startCoroutineUninterceptedOrReturn' call
    var completion = new StackFrameContinuation($completion, newContext);
    return startCoroutineUninterceptedOrReturnNonGeneratorVersion(block, value, completion);
  }
  function UndispatchedContextCollector$emitRef$slambda($downstream, resultContinuation) {
    this.v1i_1 = $downstream;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(UndispatchedContextCollector$emitRef$slambda).x1i = function (it, $completion) {
    var tmp = this.y1i(it, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(UndispatchedContextCollector$emitRef$slambda).v9 = function (p1, $completion) {
    return this.x1i((p1 == null ? true : !(p1 == null)) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(UndispatchedContextCollector$emitRef$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.v1i_1.x18(this.w1i_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(UndispatchedContextCollector$emitRef$slambda).y1i = function (it, completion) {
    var i = new UndispatchedContextCollector$emitRef$slambda(this.v1i_1, completion);
    i.w1i_1 = it;
    return i;
  };
  function UndispatchedContextCollector$emitRef$slambda_0($downstream, resultContinuation) {
    var i = new UndispatchedContextCollector$emitRef$slambda($downstream, resultContinuation);
    var l = function (it, $completion) {
      return i.x1i(it, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function UndispatchedContextCollector(downstream, emitContext) {
    this.z1i_1 = emitContext;
    this.a1j_1 = threadContextElements(this.z1i_1);
    var tmp = this;
    tmp.b1j_1 = UndispatchedContextCollector$emitRef$slambda_0(downstream, null);
  }
  protoOf(UndispatchedContextCollector).x18 = function (value, $completion) {
    return withContextUndispatched(this.z1i_1, value, this.a1j_1, this.b1j_1, $completion);
  };
  function StackFrameContinuation(uCont, context) {
    this.c1j_1 = uCont;
    this.d1j_1 = context;
  }
  protoOf(StackFrameContinuation).l9 = function () {
    return this.d1j_1;
  };
  protoOf(StackFrameContinuation).q9 = function (result) {
    this.c1j_1.q9(result);
  };
  function checkOwnership(_this__u8e3s4, owner) {
    if (!(_this__u8e3s4.e1j_1 === owner))
      throw _this__u8e3s4;
  }
  function ChannelFlowTransformLatest$flowCollect$slambda$slambda$slambda(this$0, $collector, $value, resultContinuation) {
    this.n1j_1 = this$0;
    this.o1j_1 = $collector;
    this.p1j_1 = $value;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ChannelFlowTransformLatest$flowCollect$slambda$slambda$slambda).e1h = function ($this$launch, $completion) {
    var tmp = this.f1h($this$launch, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(ChannelFlowTransformLatest$flowCollect$slambda$slambda$slambda).v9 = function (p1, $completion) {
    return this.e1h((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ChannelFlowTransformLatest$flowCollect$slambda$slambda$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.n1j_1.v1j_1(this.o1j_1, this.p1j_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(ChannelFlowTransformLatest$flowCollect$slambda$slambda$slambda).f1h = function ($this$launch, completion) {
    var i = new ChannelFlowTransformLatest$flowCollect$slambda$slambda$slambda(this.n1j_1, this.o1j_1, this.p1j_1, completion);
    i.q1j_1 = $this$launch;
    return i;
  };
  function ChannelFlowTransformLatest$flowCollect$slambda$slambda$slambda_0(this$0, $collector, $value, resultContinuation) {
    var i = new ChannelFlowTransformLatest$flowCollect$slambda$slambda$slambda(this$0, $collector, $value, resultContinuation);
    var l = function ($this$launch, $completion) {
      return i.e1h($this$launch, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function ChannelFlowTransformLatest$flowCollect$slambda$slambda($previousFlow, $this_coroutineScope, this$0, $collector, resultContinuation) {
    this.e1k_1 = $previousFlow;
    this.f1k_1 = $this_coroutineScope;
    this.g1k_1 = this$0;
    this.h1k_1 = $collector;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ChannelFlowTransformLatest$flowCollect$slambda$slambda).x1i = function (value, $completion) {
    var tmp = this.y1i(value, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(ChannelFlowTransformLatest$flowCollect$slambda$slambda).v9 = function (p1, $completion) {
    return this.x1i((p1 == null ? true : !(p1 == null)) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ChannelFlowTransformLatest$flowCollect$slambda$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 3;
            var tmp0_safe_receiver = this.e1k_1._v;
            if (tmp0_safe_receiver == null) {
              this.j1k_1 = null;
              this.f9_1 = 2;
              continue $sm;
            } else {
              this.k1k_1 = tmp0_safe_receiver;
              var $this$apply = this.k1k_1;
              $this$apply.rp(new ChildCancelledException());
              this.f9_1 = 1;
              suspendResult = $this$apply.np(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            this.j1k_1 = this.k1k_1;
            this.f9_1 = 2;
            continue $sm;
          case 2:
            var tmp_0 = CoroutineStart_UNDISPATCHED_getInstance();
            this.e1k_1._v = launch(this.f1k_1, VOID, tmp_0, ChannelFlowTransformLatest$flowCollect$slambda$slambda$slambda_0(this.g1k_1, this.h1k_1, this.i1k_1, null));
            return Unit_instance;
          case 3:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 3) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(ChannelFlowTransformLatest$flowCollect$slambda$slambda).y1i = function (value, completion) {
    var i = new ChannelFlowTransformLatest$flowCollect$slambda$slambda(this.e1k_1, this.f1k_1, this.g1k_1, this.h1k_1, completion);
    i.i1k_1 = value;
    return i;
  };
  function ChannelFlowTransformLatest$flowCollect$slambda$slambda_0($previousFlow, $this_coroutineScope, this$0, $collector, resultContinuation) {
    var i = new ChannelFlowTransformLatest$flowCollect$slambda$slambda($previousFlow, $this_coroutineScope, this$0, $collector, resultContinuation);
    var l = function (value, $completion) {
      return i.x1i(value, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function sam$kotlinx_coroutines_flow_FlowCollector$0_0(function_0) {
    this.l1k_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_0).x18 = function (value, $completion) {
    return this.l1k_1(value, $completion);
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_0).f3 = function () {
    return this.l1k_1;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, FlowCollector) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_0).hashCode = function () {
    return hashCode(this.f3());
  };
  function ChannelFlowTransformLatest$flowCollect$slambda(this$0, $collector, resultContinuation) {
    this.u1k_1 = this$0;
    this.v1k_1 = $collector;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ChannelFlowTransformLatest$flowCollect$slambda).e1h = function ($this$coroutineScope, $completion) {
    var tmp = this.f1h($this$coroutineScope, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(ChannelFlowTransformLatest$flowCollect$slambda).v9 = function (p1, $completion) {
    return this.e1h((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ChannelFlowTransformLatest$flowCollect$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            var previousFlow = {_v: null};
            this.f9_1 = 1;
            var tmp_0 = ChannelFlowTransformLatest$flowCollect$slambda$slambda_0(previousFlow, this.w1k_1, this.u1k_1, this.v1k_1, null);
            suspendResult = this.u1k_1.n1h_1.f18(new sam$kotlinx_coroutines_flow_FlowCollector$0_0(tmp_0), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(ChannelFlowTransformLatest$flowCollect$slambda).f1h = function ($this$coroutineScope, completion) {
    var i = new ChannelFlowTransformLatest$flowCollect$slambda(this.u1k_1, this.v1k_1, completion);
    i.w1k_1 = $this$coroutineScope;
    return i;
  };
  function ChannelFlowTransformLatest$flowCollect$slambda_0(this$0, $collector, resultContinuation) {
    var i = new ChannelFlowTransformLatest$flowCollect$slambda(this$0, $collector, resultContinuation);
    var l = function ($this$coroutineScope, $completion) {
      return i.e1h($this$coroutineScope, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function ChannelFlowTransformLatest(transform, flow, context, capacity, onBufferOverflow) {
    context = context === VOID ? EmptyCoroutineContext_instance : context;
    capacity = capacity === VOID ? -2 : capacity;
    onBufferOverflow = onBufferOverflow === VOID ? BufferOverflow_SUSPEND_getInstance() : onBufferOverflow;
    ChannelFlowOperator.call(this, flow, context, capacity, onBufferOverflow);
    this.v1j_1 = transform;
  }
  protoOf(ChannelFlowTransformLatest).u17 = function (context, capacity, onBufferOverflow) {
    return new ChannelFlowTransformLatest(this.v1j_1, this.n1h_1, context, capacity, onBufferOverflow);
  };
  protoOf(ChannelFlowTransformLatest).x1k = function (collector, $completion) {
    // Inline function 'kotlinx.coroutines.assert' call
    return coroutineScope(ChannelFlowTransformLatest$flowCollect$slambda_0(this, collector, null), $completion);
  };
  protoOf(ChannelFlowTransformLatest).o1h = function (collector, $completion) {
    return this.x1k(collector, $completion);
  };
  function NopCollector() {
  }
  protoOf(NopCollector).y1k = function (value, $completion) {
    return Unit_instance;
  };
  protoOf(NopCollector).x18 = function (value, $completion) {
    return this.y1k((value == null ? true : !(value == null)) ? value : THROW_CCE(), $completion);
  };
  var NopCollector_instance;
  function NopCollector_getInstance() {
    return NopCollector_instance;
  }
  function get_NULL() {
    _init_properties_NullSurrogate_kt__n2yti9();
    return NULL;
  }
  var NULL;
  var UNINITIALIZED;
  var DONE;
  var properties_initialized_NullSurrogate_kt_39v8bl;
  function _init_properties_NullSurrogate_kt__n2yti9() {
    if (!properties_initialized_NullSurrogate_kt_39v8bl) {
      properties_initialized_NullSurrogate_kt_39v8bl = true;
      NULL = new Symbol_0('NULL');
      UNINITIALIZED = new Symbol_0('UNINITIALIZED');
      DONE = new Symbol_0('DONE');
    }
  }
  function checkContext(_this__u8e3s4, currentContext) {
    var result = currentContext.vi(0, checkContext$lambda(_this__u8e3s4));
    if (!(result === _this__u8e3s4.n1b_1)) {
      // Inline function 'kotlin.error' call
      var message = 'Flow invariant is violated:\n' + ('\t\tFlow was collected in ' + toString_1(_this__u8e3s4.m1b_1) + ',\n') + ('\t\tbut emission happened in ' + toString_1(currentContext) + '.\n') + "\t\tPlease refer to 'flow' documentation or use 'flowOn' instead";
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
  }
  function transitiveCoroutineParent(_this__u8e3s4, collectJob) {
    var $this = _this__u8e3s4;
    var collectJob_0 = collectJob;
    $l$1: do {
      $l$0: do {
        if ($this === null)
          return null;
        if ($this === collectJob_0)
          return $this;
        if (!($this instanceof ScopeCoroutine))
          return $this;
        var tmp0 = $this.bp();
        var tmp1 = collectJob_0;
        $this = tmp0;
        collectJob_0 = tmp1;
        continue $l$0;
      }
       while (false);
    }
     while (true);
  }
  function checkContext$lambda($this_checkContext) {
    return function (count, element) {
      var key = element.z();
      var collectElement = $this_checkContext.m1b_1.s9(key);
      var tmp;
      if (!(key === Key_instance_3)) {
        return !(element === collectElement) ? -2147483648 : count + 1 | 0;
      }
      var collectJob = (collectElement == null ? true : isInterface(collectElement, Job)) ? collectElement : THROW_CCE();
      var emissionParentJob = transitiveCoroutineParent(isInterface(element, Job) ? element : THROW_CCE(), collectJob);
      var tmp_0;
      if (!(emissionParentJob === collectJob)) {
        var message = 'Flow invariant is violated:\n\t\tEmission from another coroutine is detected.\n' + ('\t\tChild of ' + toString_0(emissionParentJob) + ', expected child of ' + toString_0(collectJob) + '.\n') + '\t\tFlowCollector is not thread-safe and concurrent emissions are prohibited.\n' + "\t\tTo mitigate this restriction please use 'channelFlow' builder instead of 'flow'";
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      }
      return collectJob == null ? count : count + 1 | 0;
    };
  }
  function SendingCollector(channel) {
    this.z1k_1 = channel;
  }
  protoOf(SendingCollector).x18 = function (value, $completion) {
    return this.z1k_1.z15(value, $completion);
  };
  function cancellable(_this__u8e3s4) {
    var tmp;
    if (isInterface(_this__u8e3s4, CancellableFlow)) {
      tmp = _this__u8e3s4;
    } else {
      tmp = new CancellableFlowImpl(_this__u8e3s4);
    }
    return tmp;
  }
  function CancellableFlow() {
  }
  function sam$kotlinx_coroutines_flow_FlowCollector$0_1(function_0) {
    this.a1l_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_1).x18 = function (value, $completion) {
    return this.a1l_1(value, $completion);
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_1).f3 = function () {
    return this.a1l_1;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_1).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, FlowCollector) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_1).hashCode = function () {
    return hashCode(this.f3());
  };
  function CancellableFlowImpl$collect$slambda($collector, resultContinuation) {
    this.j1l_1 = $collector;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CancellableFlowImpl$collect$slambda).x1i = function (it, $completion) {
    var tmp = this.y1i(it, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(CancellableFlowImpl$collect$slambda).v9 = function (p1, $completion) {
    return this.x1i((p1 == null ? true : !(p1 == null)) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CancellableFlowImpl$collect$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            ensureActive(this.l9());
            this.f9_1 = 1;
            suspendResult = this.j1l_1.x18(this.k1l_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(CancellableFlowImpl$collect$slambda).y1i = function (it, completion) {
    var i = new CancellableFlowImpl$collect$slambda(this.j1l_1, completion);
    i.k1l_1 = it;
    return i;
  };
  function CancellableFlowImpl$collect$slambda_0($collector, resultContinuation) {
    var i = new CancellableFlowImpl$collect$slambda($collector, resultContinuation);
    var l = function (it, $completion) {
      return i.x1i(it, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function CancellableFlowImpl(flow) {
    this.l1l_1 = flow;
  }
  protoOf(CancellableFlowImpl).f18 = function (collector, $completion) {
    var tmp = CancellableFlowImpl$collect$slambda_0(collector, null);
    return this.l1l_1.f18(new sam$kotlinx_coroutines_flow_FlowCollector$0_1(tmp), $completion);
  };
  function buffer(_this__u8e3s4, capacity, onBufferOverflow) {
    capacity = capacity === VOID ? -2 : capacity;
    onBufferOverflow = onBufferOverflow === VOID ? BufferOverflow_SUSPEND_getInstance() : onBufferOverflow;
    // Inline function 'kotlin.require' call
    if (!(capacity >= 0 || capacity === -2 || capacity === -1)) {
      var message = 'Buffer size should be non-negative, BUFFERED, or CONFLATED, but was ' + capacity;
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    // Inline function 'kotlin.require' call
    if (!(!(capacity === -1) || onBufferOverflow.equals(BufferOverflow_SUSPEND_getInstance()))) {
      var message_0 = 'CONFLATED capacity cannot be used with non-default onBufferOverflow';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message_0));
    }
    var capacity_0 = capacity;
    var onBufferOverflow_0 = onBufferOverflow;
    if (capacity_0 === -1) {
      capacity_0 = 0;
      onBufferOverflow_0 = BufferOverflow_DROP_OLDEST_getInstance();
    }
    var tmp;
    if (isInterface(_this__u8e3s4, FusibleFlow)) {
      tmp = _this__u8e3s4.d18(VOID, capacity_0, onBufferOverflow_0);
    } else {
      tmp = new ChannelFlowOperatorImpl(_this__u8e3s4, VOID, capacity_0, onBufferOverflow_0);
    }
    return tmp;
  }
  function get_defaultKeySelector() {
    _init_properties_Distinct_kt__4eindw();
    return defaultKeySelector;
  }
  var defaultKeySelector;
  function get_defaultAreEquivalent() {
    _init_properties_Distinct_kt__4eindw();
    return defaultAreEquivalent;
  }
  var defaultAreEquivalent;
  function distinctUntilChanged(_this__u8e3s4) {
    _init_properties_Distinct_kt__4eindw();
    var tmp;
    if (isInterface(_this__u8e3s4, StateFlow)) {
      tmp = _this__u8e3s4;
    } else {
      tmp = distinctUntilChangedBy(_this__u8e3s4, get_defaultKeySelector(), get_defaultAreEquivalent());
    }
    return tmp;
  }
  function distinctUntilChangedBy(_this__u8e3s4, keySelector, areEquivalent) {
    _init_properties_Distinct_kt__4eindw();
    var tmp;
    var tmp_0;
    var tmp_1;
    if (_this__u8e3s4 instanceof DistinctFlowImpl) {
      tmp_1 = _this__u8e3s4.n1l_1 === keySelector;
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = _this__u8e3s4.o1l_1 === areEquivalent;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = _this__u8e3s4;
    } else {
      tmp = new DistinctFlowImpl(_this__u8e3s4, keySelector, areEquivalent);
    }
    return tmp;
  }
  function sam$kotlinx_coroutines_flow_FlowCollector$0_2(function_0) {
    this.p1l_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_2).x18 = function (value, $completion) {
    return this.p1l_1(value, $completion);
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_2).f3 = function () {
    return this.p1l_1;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_2).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, FlowCollector) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_2).hashCode = function () {
    return hashCode(this.f3());
  };
  function DistinctFlowImpl$collect$slambda(this$0, $previousKey, $collector, resultContinuation) {
    this.y1l_1 = this$0;
    this.z1l_1 = $previousKey;
    this.a1m_1 = $collector;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(DistinctFlowImpl$collect$slambda).x1i = function (value, $completion) {
    var tmp = this.y1i(value, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(DistinctFlowImpl$collect$slambda).v9 = function (p1, $completion) {
    return this.x1i((p1 == null ? true : !(p1 == null)) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(DistinctFlowImpl$collect$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 3;
            var key = this.y1l_1.n1l_1(this.b1m_1);
            if (this.z1l_1._v === get_NULL() || !this.y1l_1.o1l_1(this.z1l_1._v, key)) {
              this.z1l_1._v = key;
              this.f9_1 = 1;
              suspendResult = this.a1m_1.x18(this.b1m_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.f9_1 = 2;
              continue $sm;
            }

          case 1:
            this.f9_1 = 2;
            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 3) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(DistinctFlowImpl$collect$slambda).y1i = function (value, completion) {
    var i = new DistinctFlowImpl$collect$slambda(this.y1l_1, this.z1l_1, this.a1m_1, completion);
    i.b1m_1 = value;
    return i;
  };
  function DistinctFlowImpl$collect$slambda_0(this$0, $previousKey, $collector, resultContinuation) {
    var i = new DistinctFlowImpl$collect$slambda(this$0, $previousKey, $collector, resultContinuation);
    var l = function (value, $completion) {
      return i.x1i(value, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function DistinctFlowImpl(upstream, keySelector, areEquivalent) {
    this.m1l_1 = upstream;
    this.n1l_1 = keySelector;
    this.o1l_1 = areEquivalent;
  }
  protoOf(DistinctFlowImpl).f18 = function (collector, $completion) {
    var previousKey = {_v: get_NULL()};
    var tmp = DistinctFlowImpl$collect$slambda_0(this, previousKey, collector, null);
    return this.m1l_1.f18(new sam$kotlinx_coroutines_flow_FlowCollector$0_2(tmp), $completion);
  };
  function defaultKeySelector$lambda(it) {
    _init_properties_Distinct_kt__4eindw();
    return it;
  }
  function defaultAreEquivalent$lambda(old, new_0) {
    _init_properties_Distinct_kt__4eindw();
    return equals(old, new_0);
  }
  var properties_initialized_Distinct_kt_uy8c72;
  function _init_properties_Distinct_kt__4eindw() {
    if (!properties_initialized_Distinct_kt_uy8c72) {
      properties_initialized_Distinct_kt_uy8c72 = true;
      defaultKeySelector = defaultKeySelector$lambda;
      defaultAreEquivalent = defaultAreEquivalent$lambda;
    }
  }
  function onStart(_this__u8e3s4, action) {
    // Inline function 'kotlinx.coroutines.flow.internal.unsafeFlow' call
    return new onStart$$inlined$unsafeFlow$1(action, _this__u8e3s4);
  }
  function onCompletion(_this__u8e3s4, action) {
    // Inline function 'kotlinx.coroutines.flow.internal.unsafeFlow' call
    return new onCompletion$$inlined$unsafeFlow$1(_this__u8e3s4, action);
  }
  function ensureActive_1(_this__u8e3s4) {
    if (_this__u8e3s4 instanceof ThrowingCollector)
      throw _this__u8e3s4.c1m_1;
  }
  function invokeSafely(_this__u8e3s4, action, cause, $completion) {
    var tmp = new $invokeSafelyCOROUTINE$(_this__u8e3s4, action, cause, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  }
  function ThrowingCollector(e) {
    this.c1m_1 = e;
  }
  protoOf(ThrowingCollector).y1k = function (value, $completion) {
    throw this.c1m_1;
  };
  protoOf(ThrowingCollector).x18 = function (value, $completion) {
    return this.y1k((value == null ? true : !(value == null)) ? value : THROW_CCE(), $completion);
  };
  function $collectCOROUTINE$_7(_this__u8e3s4, collector, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.w1m_1 = _this__u8e3s4;
    this.x1m_1 = collector;
  }
  protoOf($collectCOROUTINE$_7).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 6;
            this.z1m_1 = this.x1m_1;
            var tmp_0 = this;
            tmp_0.y1m_1 = new SafeCollector(this.z1m_1, this.l9());
            this.f9_1 = 1;
            continue $sm;
          case 1:
            this.g9_1 = 5;
            this.f9_1 = 2;
            suspendResult = this.w1m_1.a1n_1(this.y1m_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.g9_1 = 6;
            this.f9_1 = 3;
            continue $sm;
          case 3:
            this.g9_1 = 6;
            this.y1m_1.p9();
            this.f9_1 = 4;
            suspendResult = this.w1m_1.b1n_1.f18(this.z1m_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            return Unit_instance;
          case 5:
            this.g9_1 = 6;
            var t = this.i9_1;
            this.y1m_1.p9();
            throw t;
          case 6:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 6) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function onStart$$inlined$unsafeFlow$1($action, $this_onStart) {
    this.a1n_1 = $action;
    this.b1n_1 = $this_onStart;
  }
  protoOf(onStart$$inlined$unsafeFlow$1).y18 = function (collector, $completion) {
    var tmp = new $collectCOROUTINE$_7(this, collector, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(onStart$$inlined$unsafeFlow$1).f18 = function (collector, $completion) {
    return this.y18(collector, $completion);
  };
  function $collectCOROUTINE$_8(_this__u8e3s4, collector, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.k1n_1 = _this__u8e3s4;
    this.l1n_1 = collector;
  }
  protoOf($collectCOROUTINE$_8).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 9;
            this.o1n_1 = this.l1n_1;
            this.g9_1 = 7;
            this.f9_1 = 1;
            suspendResult = this.k1n_1.p1n_1.f18(this.o1n_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.g9_1 = 9;
            this.f9_1 = 2;
            continue $sm;
          case 2:
            this.g9_1 = 9;
            var tmp_0 = this;
            tmp_0.n1n_1 = new SafeCollector(this.o1n_1, this.l9());
            this.f9_1 = 3;
            continue $sm;
          case 3:
            this.g9_1 = 6;
            this.f9_1 = 4;
            suspendResult = this.k1n_1.q1n_1(this.n1n_1, null, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            this.g9_1 = 9;
            this.f9_1 = 5;
            continue $sm;
          case 5:
            this.g9_1 = 9;
            this.n1n_1.p9();
            return Unit_instance;
          case 6:
            this.g9_1 = 9;
            var t = this.i9_1;
            this.n1n_1.p9();
            throw t;
          case 7:
            this.g9_1 = 9;
            var tmp_1 = this.i9_1;
            if (tmp_1 instanceof Error) {
              this.m1n_1 = this.i9_1;
              this.f9_1 = 8;
              suspendResult = invokeSafely(new ThrowingCollector(this.m1n_1), this.k1n_1.q1n_1, this.m1n_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              throw this.i9_1;
            }

          case 8:
            throw this.m1n_1;
          case 9:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 9) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function onCompletion$$inlined$unsafeFlow$1($this_onCompletion, $action) {
    this.p1n_1 = $this_onCompletion;
    this.q1n_1 = $action;
  }
  protoOf(onCompletion$$inlined$unsafeFlow$1).y18 = function (collector, $completion) {
    var tmp = new $collectCOROUTINE$_8(this, collector, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(onCompletion$$inlined$unsafeFlow$1).f18 = function (collector, $completion) {
    return this.y18(collector, $completion);
  };
  function $invokeSafelyCOROUTINE$(_this__u8e3s4, action, cause, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.l1m_1 = _this__u8e3s4;
    this.m1m_1 = action;
    this.n1m_1 = cause;
  }
  protoOf($invokeSafelyCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 3;
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.m1m_1(this.l1m_1, this.n1m_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.g9_1 = 3;
            this.f9_1 = 4;
            continue $sm;
          case 2:
            this.g9_1 = 3;
            var tmp_0 = this.i9_1;
            if (tmp_0 instanceof Error) {
              var e = this.i9_1;
              if (!(this.n1m_1 === null) && !(this.n1m_1 === e)) {
                this.n1m_1;
              }
              throw e;
            } else {
              throw this.i9_1;
            }

          case 3:
            throw this.i9_1;
          case 4:
            this.g9_1 = 3;
            return Unit_instance;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.g9_1 === 3) {
          throw e_0;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e_0;
        }
      }
     while (true);
  };
  function transformWhile(_this__u8e3s4, transform) {
    return flow(transformWhile$slambda_0(_this__u8e3s4, transform, null));
  }
  function takeWhile(_this__u8e3s4, predicate) {
    // Inline function 'kotlinx.coroutines.flow.internal.unsafeFlow' call
    return new takeWhile$$inlined$unsafeFlow$1(_this__u8e3s4, predicate);
  }
  function $emitCOROUTINE$(_this__u8e3s4, value, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.z1n_1 = _this__u8e3s4;
    this.a1o_1 = value;
  }
  protoOf($emitCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 3;
            var value = this.a1o_1;
            this.f9_1 = 1;
            suspendResult = this.z1n_1.b1o_1(this.z1n_1.c1o_1, value, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            if (!suspendResult) {
              throw new AbortFlowException(this.z1n_1);
            } else {
              this.f9_1 = 2;
              continue $sm;
            }

          case 2:
            return Unit_instance;
          case 3:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 3) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function transformWhile$2$$inlined$collectWhile$1($transform, $this_flow) {
    this.b1o_1 = $transform;
    this.c1o_1 = $this_flow;
  }
  protoOf(transformWhile$2$$inlined$collectWhile$1).y1k = function (value, $completion) {
    var tmp = new $emitCOROUTINE$(this, value, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(transformWhile$2$$inlined$collectWhile$1).x18 = function (value, $completion) {
    return this.y1k((value == null ? true : !(value == null)) ? value : THROW_CCE(), $completion);
  };
  function transformWhile$slambda($this_transformWhile, $transform, resultContinuation) {
    this.l1o_1 = $this_transformWhile;
    this.m1o_1 = $transform;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(transformWhile$slambda).p1o = function ($this$flow, $completion) {
    var tmp = this.q1o($this$flow, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(transformWhile$slambda).v9 = function (p1, $completion) {
    return this.p1o((!(p1 == null) ? isInterface(p1, FlowCollector) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(transformWhile$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 3;
            var this_0 = this.l1o_1;
            var tmp_0 = this;
            tmp_0.o1o_1 = new transformWhile$2$$inlined$collectWhile$1(this.m1o_1, this.n1o_1);
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this_0.f18(this.o1o_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.g9_1 = 3;
            this.f9_1 = 4;
            continue $sm;
          case 2:
            this.g9_1 = 3;
            var tmp_1 = this.i9_1;
            if (tmp_1 instanceof AbortFlowException) {
              var e = this.i9_1;
              checkOwnership(e, this.o1o_1);
              this.f9_1 = 4;
              continue $sm;
            } else {
              throw this.i9_1;
            }

          case 3:
            throw this.i9_1;
          case 4:
            this.g9_1 = 3;
            return Unit_instance;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.g9_1 === 3) {
          throw e_0;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(transformWhile$slambda).q1o = function ($this$flow, completion) {
    var i = new transformWhile$slambda(this.l1o_1, this.m1o_1, completion);
    i.n1o_1 = $this$flow;
    return i;
  };
  function transformWhile$slambda_0($this_transformWhile, $transform, resultContinuation) {
    var i = new transformWhile$slambda($this_transformWhile, $transform, resultContinuation);
    var l = function ($this$flow, $completion) {
      return i.p1o($this$flow, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function $emitCOROUTINE$_0(_this__u8e3s4, value, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.z1o_1 = _this__u8e3s4;
    this.a1p_1 = value;
  }
  protoOf($emitCOROUTINE$_0).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 5;
            this.c1p_1 = this.a1p_1;
            this.f9_1 = 1;
            suspendResult = this.z1o_1.d1p_1(this.c1p_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            if (suspendResult) {
              this.f9_1 = 2;
              suspendResult = this.z1o_1.e1p_1.x18(this.c1p_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              var tmp_0 = this;
              tmp_0.b1p_1 = false;
              this.f9_1 = 3;
              continue $sm;
            }

          case 2:
            this.b1p_1 = true;
            this.f9_1 = 3;
            continue $sm;
          case 3:
            if (!this.b1p_1) {
              throw new AbortFlowException(this.z1o_1);
            } else {
              this.f9_1 = 4;
              continue $sm;
            }

          case 4:
            return Unit_instance;
          case 5:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 5) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function takeWhile$$inlined$unsafeFlow$1$collect$2($predicate, $$this$unsafeFlow) {
    this.d1p_1 = $predicate;
    this.e1p_1 = $$this$unsafeFlow;
  }
  protoOf(takeWhile$$inlined$unsafeFlow$1$collect$2).y1k = function (value, $completion) {
    var tmp = new $emitCOROUTINE$_0(this, value, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(takeWhile$$inlined$unsafeFlow$1$collect$2).x18 = function (value, $completion) {
    return this.y1k((value == null ? true : !(value == null)) ? value : THROW_CCE(), $completion);
  };
  function $collectCOROUTINE$_9(_this__u8e3s4, collector, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.n1p_1 = _this__u8e3s4;
    this.o1p_1 = collector;
  }
  protoOf($collectCOROUTINE$_9).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 3;
            var $this$unsafeFlow = this.o1p_1;
            var this_0 = this.n1p_1.q1p_1;
            var tmp_0 = this;
            tmp_0.p1p_1 = new takeWhile$$inlined$unsafeFlow$1$collect$2(this.n1p_1.r1p_1, $this$unsafeFlow);
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this_0.f18(this.p1p_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.g9_1 = 3;
            this.f9_1 = 4;
            continue $sm;
          case 2:
            this.g9_1 = 3;
            var tmp_1 = this.i9_1;
            if (tmp_1 instanceof AbortFlowException) {
              var e = this.i9_1;
              checkOwnership(e, this.p1p_1);
              this.f9_1 = 4;
              continue $sm;
            } else {
              throw this.i9_1;
            }

          case 3:
            throw this.i9_1;
          case 4:
            this.g9_1 = 3;
            return Unit_instance;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.g9_1 === 3) {
          throw e_0;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e_0;
        }
      }
     while (true);
  };
  function takeWhile$$inlined$unsafeFlow$1($this_takeWhile, $predicate) {
    this.q1p_1 = $this_takeWhile;
    this.r1p_1 = $predicate;
  }
  protoOf(takeWhile$$inlined$unsafeFlow$1).y18 = function (collector, $completion) {
    var tmp = new $collectCOROUTINE$_9(this, collector, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(takeWhile$$inlined$unsafeFlow$1).f18 = function (collector, $completion) {
    return this.y18(collector, $completion);
  };
  var DEFAULT_CONCURRENCY;
  function flatMapConcat(_this__u8e3s4, transform) {
    _init_properties_Merge_kt__cbpr96();
    // Inline function 'kotlinx.coroutines.flow.map' call
    // Inline function 'kotlinx.coroutines.flow.unsafeTransform' call
    // Inline function 'kotlinx.coroutines.flow.internal.unsafeFlow' call
    var tmp$ret$2 = new flatMapConcat$$inlined$map$1(_this__u8e3s4, transform);
    return flattenConcat(tmp$ret$2);
  }
  function transformLatest(_this__u8e3s4, transform) {
    _init_properties_Merge_kt__cbpr96();
    return new ChannelFlowTransformLatest(transform, _this__u8e3s4);
  }
  function flattenConcat(_this__u8e3s4) {
    _init_properties_Merge_kt__cbpr96();
    // Inline function 'kotlinx.coroutines.flow.internal.unsafeFlow' call
    return new flattenConcat$$inlined$unsafeFlow$1(_this__u8e3s4);
  }
  function mapLatest(_this__u8e3s4, transform) {
    _init_properties_Merge_kt__cbpr96();
    return transformLatest(_this__u8e3s4, mapLatest$slambda_0(transform, null));
  }
  function sam$kotlinx_coroutines_flow_FlowCollector$0_3(function_0) {
    this.s1p_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_3).x18 = function (value, $completion) {
    return this.s1p_1(value, $completion);
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_3).f3 = function () {
    return this.s1p_1;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_3).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, FlowCollector) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_3).hashCode = function () {
    return hashCode(this.f3());
  };
  function flatMapConcat$o$collect$slambda($$this$unsafeFlow, $transform, resultContinuation) {
    this.b1q_1 = $$this$unsafeFlow;
    this.c1q_1 = $transform;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(flatMapConcat$o$collect$slambda).f1q = function (value, $completion) {
    var tmp = this.g1q(value, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(flatMapConcat$o$collect$slambda).v9 = function (p1, $completion) {
    return this.f1q((p1 == null ? true : !(p1 == null)) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(flatMapConcat$o$collect$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 3;
            var tmp0 = this.b1q_1;
            var tmp2 = this.d1q_1;
            this.e1q_1 = tmp0;
            this.f9_1 = 1;
            suspendResult = this.c1q_1(tmp2, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            this.f9_1 = 2;
            suspendResult = this.e1q_1.x18(ARGUMENT, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 3) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(flatMapConcat$o$collect$slambda).g1q = function (value, completion) {
    var i = new flatMapConcat$o$collect$slambda(this.b1q_1, this.c1q_1, completion);
    i.d1q_1 = value;
    return i;
  };
  function flatMapConcat$o$collect$slambda_0($$this$unsafeFlow, $transform, resultContinuation) {
    var i = new flatMapConcat$o$collect$slambda($$this$unsafeFlow, $transform, resultContinuation);
    var l = function (value, $completion) {
      return i.f1q(value, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function $collectCOROUTINE$_10(_this__u8e3s4, collector, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.p1q_1 = _this__u8e3s4;
    this.q1q_1 = collector;
  }
  protoOf($collectCOROUTINE$_10).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            var $this$unsafeFlow = this.q1q_1;
            this.f9_1 = 1;
            var tmp_0 = flatMapConcat$o$collect$slambda_0($this$unsafeFlow, this.p1q_1.s1q_1, null);
            suspendResult = this.p1q_1.r1q_1.f18(new sam$kotlinx_coroutines_flow_FlowCollector$0_3(tmp_0), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function flatMapConcat$$inlined$map$1($this, $transform) {
    this.r1q_1 = $this;
    this.s1q_1 = $transform;
  }
  protoOf(flatMapConcat$$inlined$map$1).y18 = function (collector, $completion) {
    var tmp = new $collectCOROUTINE$_10(this, collector, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(flatMapConcat$$inlined$map$1).f18 = function (collector, $completion) {
    return this.y18(collector, $completion);
  };
  function sam$kotlinx_coroutines_flow_FlowCollector$0_4(function_0) {
    this.t1q_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_4).x18 = function (value, $completion) {
    return this.t1q_1(value, $completion);
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_4).f3 = function () {
    return this.t1q_1;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_4).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, FlowCollector) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_4).hashCode = function () {
    return hashCode(this.f3());
  };
  function flattenConcat$o$collect$slambda($$this$unsafeFlow, resultContinuation) {
    this.c1r_1 = $$this$unsafeFlow;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(flattenConcat$o$collect$slambda).e1r = function (value, $completion) {
    var tmp = this.f1r(value, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(flattenConcat$o$collect$slambda).v9 = function (p1, $completion) {
    return this.e1r((!(p1 == null) ? isInterface(p1, Flow) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(flattenConcat$o$collect$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = emitAll_0(this.c1r_1, this.d1r_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(flattenConcat$o$collect$slambda).f1r = function (value, completion) {
    var i = new flattenConcat$o$collect$slambda(this.c1r_1, completion);
    i.d1r_1 = value;
    return i;
  };
  function flattenConcat$o$collect$slambda_0($$this$unsafeFlow, resultContinuation) {
    var i = new flattenConcat$o$collect$slambda($$this$unsafeFlow, resultContinuation);
    var l = function (value, $completion) {
      return i.e1r(value, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function $collectCOROUTINE$_11(_this__u8e3s4, collector, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.o1r_1 = _this__u8e3s4;
    this.p1r_1 = collector;
  }
  protoOf($collectCOROUTINE$_11).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            var $this$unsafeFlow = this.p1r_1;
            this.f9_1 = 1;
            var tmp_0 = flattenConcat$o$collect$slambda_0($this$unsafeFlow, null);
            suspendResult = this.o1r_1.q1r_1.f18(new sam$kotlinx_coroutines_flow_FlowCollector$0_4(tmp_0), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function flattenConcat$$inlined$unsafeFlow$1($this_flattenConcat) {
    this.q1r_1 = $this_flattenConcat;
  }
  protoOf(flattenConcat$$inlined$unsafeFlow$1).y18 = function (collector, $completion) {
    var tmp = new $collectCOROUTINE$_11(this, collector, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(flattenConcat$$inlined$unsafeFlow$1).f18 = function (collector, $completion) {
    return this.y18(collector, $completion);
  };
  function mapLatest$slambda($transform, resultContinuation) {
    this.z1r_1 = $transform;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(mapLatest$slambda).c1s = function ($this$transformLatest, it, $completion) {
    var tmp = this.d1s($this$transformLatest, it, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(mapLatest$slambda).w9 = function (p1, p2, $completion) {
    var tmp = (!(p1 == null) ? isInterface(p1, FlowCollector) : false) ? p1 : THROW_CCE();
    return this.c1s(tmp, (p2 == null ? true : !(p2 == null)) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(mapLatest$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 3;
            this.f9_1 = 1;
            suspendResult = this.z1r_1(this.b1s_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            this.f9_1 = 2;
            suspendResult = this.a1s_1.x18(ARGUMENT, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 3) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(mapLatest$slambda).d1s = function ($this$transformLatest, it, completion) {
    var i = new mapLatest$slambda(this.z1r_1, completion);
    i.a1s_1 = $this$transformLatest;
    i.b1s_1 = it;
    return i;
  };
  function mapLatest$slambda_0($transform, resultContinuation) {
    var i = new mapLatest$slambda($transform, resultContinuation);
    var l = function ($this$transformLatest, it, $completion) {
      return i.c1s($this$transformLatest, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  var properties_initialized_Merge_kt_dhn6vs;
  function _init_properties_Merge_kt__cbpr96() {
    if (!properties_initialized_Merge_kt_dhn6vs) {
      properties_initialized_Merge_kt_dhn6vs = true;
      DEFAULT_CONCURRENCY = systemProp('kotlinx.coroutines.flow.defaultConcurrency', 16, 1, 2147483647);
    }
  }
  function shareIn(_this__u8e3s4, scope, started, replay) {
    replay = replay === VOID ? 0 : replay;
    var config = configureSharing(_this__u8e3s4, replay);
    var shared = MutableSharedFlow(replay, config.f1s_1, config.g1s_1);
    var tmp = get_NO_VALUE();
    var job = launchSharing(scope, config.h1s_1, config.e1s_1, shared, started, !(tmp == null) ? tmp : THROW_CCE());
    return new ReadonlySharedFlow(shared, job);
  }
  function $onSubscriptionCOROUTINE$(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.q1s_1 = _this__u8e3s4;
  }
  protoOf($onSubscriptionCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 7;
            var tmp_0 = this;
            tmp_0.r1s_1 = new SafeCollector(this.q1s_1.a1d_1, this.l9());
            this.f9_1 = 1;
            continue $sm;
          case 1:
            this.g9_1 = 6;
            this.f9_1 = 2;
            suspendResult = this.q1s_1.b1d_1(this.r1s_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.g9_1 = 7;
            this.f9_1 = 3;
            continue $sm;
          case 3:
            this.g9_1 = 7;
            this.r1s_1.p9();
            var tmp_1 = this.q1s_1.a1d_1;
            if (tmp_1 instanceof SubscribedFlowCollector) {
              this.f9_1 = 4;
              suspendResult = this.q1s_1.a1d_1.c1d(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.f9_1 = 5;
              continue $sm;
            }

          case 4:
            this.f9_1 = 5;
            continue $sm;
          case 5:
            return Unit_instance;
          case 6:
            this.g9_1 = 7;
            var t = this.i9_1;
            this.r1s_1.p9();
            throw t;
          case 7:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 7) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function SubscribedFlowCollector() {
  }
  protoOf(SubscribedFlowCollector).c1d = function ($completion) {
    var tmp = new $onSubscriptionCOROUTINE$(this, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  function SharingConfig(upstream, extraBufferCapacity, onBufferOverflow, context) {
    this.e1s_1 = upstream;
    this.f1s_1 = extraBufferCapacity;
    this.g1s_1 = onBufferOverflow;
    this.h1s_1 = context;
  }
  function configureSharing(_this__u8e3s4, replay) {
    // Inline function 'kotlinx.coroutines.assert' call
    var defaultExtraCapacity = coerceAtLeast(replay, Factory_getInstance().r16_1) - replay | 0;
    if (_this__u8e3s4 instanceof ChannelFlow) {
      var upstream = _this__u8e3s4.b18();
      if (!(upstream == null)) {
        var tmp0_subject = _this__u8e3s4.x17_1;
        return new SharingConfig(upstream, ((tmp0_subject === -3 ? true : tmp0_subject === -2) ? true : tmp0_subject === 0) ? _this__u8e3s4.y17_1.equals(BufferOverflow_SUSPEND_getInstance()) ? _this__u8e3s4.x17_1 === 0 ? 0 : defaultExtraCapacity : replay === 0 ? 1 : 0 : _this__u8e3s4.x17_1, _this__u8e3s4.y17_1, _this__u8e3s4.w17_1);
      }
    }
    return new SharingConfig(_this__u8e3s4, defaultExtraCapacity, BufferOverflow_SUSPEND_getInstance(), EmptyCoroutineContext_instance);
  }
  function launchSharing(_this__u8e3s4, context, upstream, shared, started, initialValue) {
    var start = equals(started, Companion_getInstance_23().q1d_1) ? CoroutineStart_DEFAULT_getInstance() : CoroutineStart_UNDISPATCHED_getInstance();
    return launch(_this__u8e3s4, context, start, launchSharing$slambda_0(started, upstream, shared, initialValue, null));
  }
  function $collectCOROUTINE$_12(_this__u8e3s4, collector, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.a1t_1 = _this__u8e3s4;
    this.b1t_1 = collector;
  }
  protoOf($collectCOROUTINE$_12).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.a1t_1.d1t_1.f1d(this.b1t_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            throwKotlinNothingValueException();
            break;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function ReadonlySharedFlow(flow, job) {
    this.c1t_1 = job;
    this.d1t_1 = flow;
  }
  protoOf(ReadonlySharedFlow).f1d = function (collector, $completion) {
    var tmp = new $collectCOROUTINE$_12(this, collector, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(ReadonlySharedFlow).f18 = function (collector, $completion) {
    return this.f1d(collector, $completion);
  };
  protoOf(ReadonlySharedFlow).c18 = function (context, capacity, onBufferOverflow) {
    return fuseSharedFlow(this, context, capacity, onBufferOverflow);
  };
  function stateIn(_this__u8e3s4, scope, $completion) {
    var config = configureSharing(_this__u8e3s4, 1);
    var result = CompletableDeferred();
    launchSharingDeferred(scope, config.h1s_1, config.e1s_1, result);
    return result.nr($completion);
  }
  function launchSharingDeferred(_this__u8e3s4, context, upstream, result) {
    launch(_this__u8e3s4, context, VOID, launchSharingDeferred$slambda_0(upstream, result, null));
  }
  function $collectCOROUTINE$_13(_this__u8e3s4, collector, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.m1t_1 = _this__u8e3s4;
    this.n1t_1 = collector;
  }
  protoOf($collectCOROUTINE$_13).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.m1t_1.p1t_1.f1d(this.n1t_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            throwKotlinNothingValueException();
            break;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function ReadonlyStateFlow(flow, job) {
    this.o1t_1 = job;
    this.p1t_1 = flow;
  }
  protoOf(ReadonlyStateFlow).a1 = function () {
    return this.p1t_1.a1();
  };
  protoOf(ReadonlyStateFlow).f1d = function (collector, $completion) {
    var tmp = new $collectCOROUTINE$_13(this, collector, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(ReadonlyStateFlow).f18 = function (collector, $completion) {
    return this.f1d(collector, $completion);
  };
  protoOf(ReadonlyStateFlow).c18 = function (context, capacity, onBufferOverflow) {
    return fuseStateFlow(this, context, capacity, onBufferOverflow);
  };
  function launchSharing$slambda$slambda(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(launchSharing$slambda$slambda).z1t = function (it, $completion) {
    var tmp = this.f1e(it, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(launchSharing$slambda$slambda).v9 = function (p1, $completion) {
    return this.z1t((!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(launchSharing$slambda$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        if (tmp === 0) {
          this.g9_1 = 1;
          return this.y1t_1 > 0;
        } else if (tmp === 1) {
          throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(launchSharing$slambda$slambda).f1e = function (it, completion) {
    var i = new launchSharing$slambda$slambda(completion);
    i.y1t_1 = it;
    return i;
  };
  function launchSharing$slambda$slambda_0(resultContinuation) {
    var i = new launchSharing$slambda$slambda(resultContinuation);
    var l = function (it, $completion) {
      return i.z1t(it, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function launchSharing$slambda$slambda_1($upstream, $shared, $initialValue, resultContinuation) {
    this.i1u_1 = $upstream;
    this.j1u_1 = $shared;
    this.k1u_1 = $initialValue;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(launchSharing$slambda$slambda_1).m1u = function (it, $completion) {
    var tmp = this.n1u(it, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(launchSharing$slambda$slambda_1).v9 = function (p1, $completion) {
    return this.m1u(p1 instanceof SharingCommand ? p1 : THROW_CCE(), $completion);
  };
  protoOf(launchSharing$slambda$slambda_1).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 3;
            var tmp0 = this.l1u_1.x2_1;
            if (tmp0 === 0) {
              this.f9_1 = 1;
              suspendResult = this.i1u_1.f18(this.j1u_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              if (tmp0 === 1) {
                this.f9_1 = 2;
                continue $sm;
              } else {
                if (tmp0 === 2) {
                  if (this.k1u_1 === get_NO_VALUE()) {
                    this.j1u_1.k1d();
                  } else {
                    this.j1u_1.g1d(this.k1u_1);
                  }
                  this.f9_1 = 2;
                  continue $sm;
                } else {
                  this.f9_1 = 2;
                  continue $sm;
                }
              }
            }

          case 1:
            this.f9_1 = 2;
            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 3) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(launchSharing$slambda$slambda_1).n1u = function (it, completion) {
    var i = new launchSharing$slambda$slambda_1(this.i1u_1, this.j1u_1, this.k1u_1, completion);
    i.l1u_1 = it;
    return i;
  };
  function launchSharing$slambda$slambda_2($upstream, $shared, $initialValue, resultContinuation) {
    var i = new launchSharing$slambda$slambda_1($upstream, $shared, $initialValue, resultContinuation);
    var l = function (it, $completion) {
      return i.m1u(it, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function launchSharing$slambda($started, $upstream, $shared, $initialValue, resultContinuation) {
    this.w1u_1 = $started;
    this.x1u_1 = $upstream;
    this.y1u_1 = $shared;
    this.z1u_1 = $initialValue;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(launchSharing$slambda).e1h = function ($this$launch, $completion) {
    var tmp = this.f1h($this$launch, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(launchSharing$slambda).v9 = function (p1, $completion) {
    return this.e1h((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(launchSharing$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 6;
            if (this.w1u_1 === Companion_getInstance_23().q1d_1) {
              this.f9_1 = 4;
              suspendResult = this.x1u_1.f18(this.y1u_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              if (this.w1u_1 === Companion_getInstance_23().r1d_1) {
                this.f9_1 = 2;
                var tmp_0 = this.y1u_1.l1d();
                suspendResult = first_3(tmp_0, launchSharing$slambda$slambda_0(null), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                this.f9_1 = 1;
                var tmp_1 = distinctUntilChanged(this.w1u_1.s1d(this.y1u_1.l1d()));
                suspendResult = collectLatest(tmp_1, launchSharing$slambda$slambda_2(this.x1u_1, this.y1u_1, this.z1u_1, null), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              }
            }

          case 1:
            this.f9_1 = 5;
            continue $sm;
          case 2:
            this.f9_1 = 3;
            suspendResult = this.x1u_1.f18(this.y1u_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            this.f9_1 = 5;
            continue $sm;
          case 4:
            this.f9_1 = 5;
            continue $sm;
          case 5:
            return Unit_instance;
          case 6:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 6) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(launchSharing$slambda).f1h = function ($this$launch, completion) {
    var i = new launchSharing$slambda(this.w1u_1, this.x1u_1, this.y1u_1, this.z1u_1, completion);
    i.a1v_1 = $this$launch;
    return i;
  };
  function launchSharing$slambda_0($started, $upstream, $shared, $initialValue, resultContinuation) {
    var i = new launchSharing$slambda($started, $upstream, $shared, $initialValue, resultContinuation);
    var l = function ($this$launch, $completion) {
      return i.e1h($this$launch, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function sam$kotlinx_coroutines_flow_FlowCollector$0_5(function_0) {
    this.b1v_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_5).x18 = function (value, $completion) {
    return this.b1v_1(value, $completion);
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_5).f3 = function () {
    return this.b1v_1;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_5).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, FlowCollector) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_5).hashCode = function () {
    return hashCode(this.f3());
  };
  function launchSharingDeferred$slambda$slambda($state, $this_launch, $result, resultContinuation) {
    this.k1v_1 = $state;
    this.l1v_1 = $this_launch;
    this.m1v_1 = $result;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(launchSharingDeferred$slambda$slambda).x1i = function (value, $completion) {
    var tmp = this.y1i(value, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(launchSharingDeferred$slambda$slambda).v9 = function (p1, $completion) {
    return this.x1i((p1 == null ? true : !(p1 == null)) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(launchSharingDeferred$slambda$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        if (tmp === 0) {
          this.g9_1 = 1;
          var tmp0_safe_receiver = this.k1v_1._v;
          var tmp_0;
          if (tmp0_safe_receiver == null) {
            tmp_0 = null;
          } else {
            tmp0_safe_receiver.r1f(this.n1v_1);
            tmp_0 = Unit_instance;
          }
          if (tmp_0 == null) {
            var $this$run = this.l1v_1;
            var this_0 = MutableStateFlow(this.n1v_1);
            this.m1v_1.pu(new ReadonlyStateFlow(this_0, get_job($this$run.ho())));
            this.k1v_1._v = this_0;
          }
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(launchSharingDeferred$slambda$slambda).y1i = function (value, completion) {
    var i = new launchSharingDeferred$slambda$slambda(this.k1v_1, this.l1v_1, this.m1v_1, completion);
    i.n1v_1 = value;
    return i;
  };
  function launchSharingDeferred$slambda$slambda_0($state, $this_launch, $result, resultContinuation) {
    var i = new launchSharingDeferred$slambda$slambda($state, $this_launch, $result, resultContinuation);
    var l = function (value, $completion) {
      return i.x1i(value, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function launchSharingDeferred$slambda($upstream, $result, resultContinuation) {
    this.w1v_1 = $upstream;
    this.x1v_1 = $result;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(launchSharingDeferred$slambda).e1h = function ($this$launch, $completion) {
    var tmp = this.f1h($this$launch, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(launchSharingDeferred$slambda).v9 = function (p1, $completion) {
    return this.e1h((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(launchSharingDeferred$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 3;
            this.g9_1 = 2;
            var state = {_v: null};
            this.f9_1 = 1;
            var tmp_0 = launchSharingDeferred$slambda$slambda_0(state, this.y1v_1, this.x1v_1, null);
            suspendResult = this.w1v_1.f18(new sam$kotlinx_coroutines_flow_FlowCollector$0_5(tmp_0), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.g9_1 = 3;
            this.f9_1 = 4;
            continue $sm;
          case 2:
            this.g9_1 = 3;
            var tmp_1 = this.i9_1;
            if (tmp_1 instanceof Error) {
              var e = this.i9_1;
              this.x1v_1.ru(e);
              throw e;
            } else {
              throw this.i9_1;
            }

          case 3:
            throw this.i9_1;
          case 4:
            this.g9_1 = 3;
            return Unit_instance;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.g9_1 === 3) {
          throw e_0;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(launchSharingDeferred$slambda).f1h = function ($this$launch, completion) {
    var i = new launchSharingDeferred$slambda(this.w1v_1, this.x1v_1, completion);
    i.y1v_1 = $this$launch;
    return i;
  };
  function launchSharingDeferred$slambda_0($upstream, $result, resultContinuation) {
    var i = new launchSharingDeferred$slambda($upstream, $result, resultContinuation);
    var l = function ($this$launch, $completion) {
      return i.e1h($this$launch, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function collectLatest(_this__u8e3s4, action, $completion) {
    return collect(buffer(mapLatest(_this__u8e3s4, action), 0), $completion);
  }
  function emitAll_0(_this__u8e3s4, flow, $completion) {
    ensureActive_1(_this__u8e3s4);
    return flow.f18(_this__u8e3s4, $completion);
  }
  function collect(_this__u8e3s4, $completion) {
    return _this__u8e3s4.f18(NopCollector_instance, $completion);
  }
  function toList_3(_this__u8e3s4, destination, $completion) {
    destination = destination === VOID ? ArrayList_init_$Create$() : destination;
    return toCollection_1(_this__u8e3s4, destination, $completion);
  }
  function toCollection_1(_this__u8e3s4, destination, $completion) {
    var tmp = new $toCollectionCOROUTINE$(_this__u8e3s4, destination, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  }
  function sam$kotlinx_coroutines_flow_FlowCollector$0_6(function_0) {
    this.j1w_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_6).x18 = function (value, $completion) {
    return this.j1w_1(value, $completion);
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_6).f3 = function () {
    return this.j1w_1;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_6).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, FlowCollector) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_6).hashCode = function () {
    return hashCode(this.f3());
  };
  function toCollection$slambda($destination, resultContinuation) {
    this.s1w_1 = $destination;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(toCollection$slambda).x1i = function (value, $completion) {
    var tmp = this.y1i(value, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(toCollection$slambda).v9 = function (p1, $completion) {
    return this.x1i((p1 == null ? true : !(p1 == null)) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(toCollection$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        if (tmp === 0) {
          this.g9_1 = 1;
          this.s1w_1.j(this.t1w_1);
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(toCollection$slambda).y1i = function (value, completion) {
    var i = new toCollection$slambda(this.s1w_1, completion);
    i.t1w_1 = value;
    return i;
  };
  function toCollection$slambda_0($destination, resultContinuation) {
    var i = new toCollection$slambda($destination, resultContinuation);
    var l = function (value, $completion) {
      return i.x1i(value, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function $toCollectionCOROUTINE$(_this__u8e3s4, destination, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.h1w_1 = _this__u8e3s4;
    this.i1w_1 = destination;
  }
  protoOf($toCollectionCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            var tmp_0 = toCollection$slambda_0(this.i1w_1, null);
            suspendResult = this.h1w_1.f18(new sam$kotlinx_coroutines_flow_FlowCollector$0_6(tmp_0), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return this.i1w_1;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function first_3(_this__u8e3s4, predicate, $completion) {
    var tmp = new $firstCOROUTINE$(_this__u8e3s4, predicate, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  }
  function firstOrNull_3(_this__u8e3s4, $completion) {
    var tmp = new $firstOrNullCOROUTINE$(_this__u8e3s4, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  }
  function firstOrNull_4(_this__u8e3s4, predicate, $completion) {
    var tmp = new $firstOrNullCOROUTINE$_0(_this__u8e3s4, predicate, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  }
  function $emitCOROUTINE$_1(_this__u8e3s4, value, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.l1y_1 = _this__u8e3s4;
    this.m1y_1 = value;
  }
  protoOf($emitCOROUTINE$_1).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 4;
            this.o1y_1 = this.m1y_1;
            this.f9_1 = 1;
            suspendResult = this.l1y_1.p1y_1(this.o1y_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            if (suspendResult) {
              var tmp_0 = this;
              this.l1y_1.q1y_1._v = this.o1y_1;
              tmp_0.n1y_1 = false;
              this.f9_1 = 2;
              continue $sm;
            } else {
              var tmp_1 = this;
              tmp_1.n1y_1 = true;
              this.f9_1 = 2;
              continue $sm;
            }

          case 2:
            if (!this.n1y_1) {
              throw new AbortFlowException(this.l1y_1);
            } else {
              this.f9_1 = 3;
              continue $sm;
            }

          case 3:
            return Unit_instance;
          case 4:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 4) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function first$$inlined$collectWhile$1($predicate, $result) {
    this.p1y_1 = $predicate;
    this.q1y_1 = $result;
  }
  protoOf(first$$inlined$collectWhile$1).y1k = function (value, $completion) {
    var tmp = new $emitCOROUTINE$_1(this, value, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(first$$inlined$collectWhile$1).x18 = function (value, $completion) {
    return this.y1k((value == null ? true : !(value == null)) ? value : THROW_CCE(), $completion);
  };
  function firstOrNull$$inlined$collectWhile$1($result) {
    this.r1y_1 = $result;
  }
  protoOf(firstOrNull$$inlined$collectWhile$1).y1k = function (value, $completion) {
    this.r1y_1._v = value;
    if (!false) {
      throw new AbortFlowException(this);
    }
    return Unit_instance;
  };
  protoOf(firstOrNull$$inlined$collectWhile$1).x18 = function (value, $completion) {
    return this.y1k((value == null ? true : !(value == null)) ? value : THROW_CCE(), $completion);
  };
  function $emitCOROUTINE$_2(_this__u8e3s4, value, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.a1z_1 = _this__u8e3s4;
    this.b1z_1 = value;
  }
  protoOf($emitCOROUTINE$_2).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 4;
            this.d1z_1 = this.b1z_1;
            this.f9_1 = 1;
            suspendResult = this.a1z_1.e1z_1(this.d1z_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            if (suspendResult) {
              var tmp_0 = this;
              this.a1z_1.f1z_1._v = this.d1z_1;
              tmp_0.c1z_1 = false;
              this.f9_1 = 2;
              continue $sm;
            } else {
              var tmp_1 = this;
              tmp_1.c1z_1 = true;
              this.f9_1 = 2;
              continue $sm;
            }

          case 2:
            if (!this.c1z_1) {
              throw new AbortFlowException(this.a1z_1);
            } else {
              this.f9_1 = 3;
              continue $sm;
            }

          case 3:
            return Unit_instance;
          case 4:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 4) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function firstOrNull$$inlined$collectWhile$2($predicate, $result) {
    this.e1z_1 = $predicate;
    this.f1z_1 = $result;
  }
  protoOf(firstOrNull$$inlined$collectWhile$2).y1k = function (value, $completion) {
    var tmp = new $emitCOROUTINE$_2(this, value, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(firstOrNull$$inlined$collectWhile$2).x18 = function (value, $completion) {
    return this.y1k((value == null ? true : !(value == null)) ? value : THROW_CCE(), $completion);
  };
  function $firstCOROUTINE$(_this__u8e3s4, predicate, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.c1x_1 = _this__u8e3s4;
    this.d1x_1 = predicate;
  }
  protoOf($firstCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 3;
            this.e1x_1 = {_v: get_NULL()};
            var this_0 = this.c1x_1;
            var tmp_0 = this;
            tmp_0.f1x_1 = new first$$inlined$collectWhile$1(this.d1x_1, this.e1x_1);
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this_0.f18(this.f1x_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.g9_1 = 3;
            this.f9_1 = 4;
            continue $sm;
          case 2:
            this.g9_1 = 3;
            var tmp_1 = this.i9_1;
            if (tmp_1 instanceof AbortFlowException) {
              var e = this.i9_1;
              checkOwnership(e, this.f1x_1);
              this.f9_1 = 4;
              continue $sm;
            } else {
              throw this.i9_1;
            }

          case 3:
            throw this.i9_1;
          case 4:
            this.g9_1 = 3;
            if (this.e1x_1._v === get_NULL())
              throw NoSuchElementException_init_$Create$_0('Expected at least one element matching the predicate ' + toString_1(this.d1x_1));
            var tmp_2 = this.e1x_1._v;
            return (tmp_2 == null ? true : !(tmp_2 == null)) ? tmp_2 : THROW_CCE();
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.g9_1 === 3) {
          throw e_0;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e_0;
        }
      }
     while (true);
  };
  function $firstOrNullCOROUTINE$(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.o1x_1 = _this__u8e3s4;
  }
  protoOf($firstOrNullCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 4;
            this.p1x_1 = {_v: null};
            var this_0 = this.o1x_1;
            var tmp_0 = this;
            tmp_0.q1x_1 = new firstOrNull$$inlined$collectWhile$1(this.p1x_1);
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this_0.f18(this.q1x_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.g9_1 = 4;
            this.f9_1 = 3;
            continue $sm;
          case 2:
            this.g9_1 = 4;
            var tmp_1 = this.i9_1;
            if (tmp_1 instanceof AbortFlowException) {
              var e = this.i9_1;
              checkOwnership(e, this.q1x_1);
              this.f9_1 = 3;
              continue $sm;
            } else {
              throw this.i9_1;
            }

          case 3:
            this.g9_1 = 4;
            return this.p1x_1._v;
          case 4:
            throw this.i9_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.g9_1 === 4) {
          throw e_0;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e_0;
        }
      }
     while (true);
  };
  function $firstOrNullCOROUTINE$_0(_this__u8e3s4, predicate, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.z1x_1 = _this__u8e3s4;
    this.a1y_1 = predicate;
  }
  protoOf($firstOrNullCOROUTINE$_0).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 4;
            this.b1y_1 = {_v: null};
            var this_0 = this.z1x_1;
            var tmp_0 = this;
            tmp_0.c1y_1 = new firstOrNull$$inlined$collectWhile$2(this.a1y_1, this.b1y_1);
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this_0.f18(this.c1y_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.g9_1 = 4;
            this.f9_1 = 3;
            continue $sm;
          case 2:
            this.g9_1 = 4;
            var tmp_1 = this.i9_1;
            if (tmp_1 instanceof AbortFlowException) {
              var e = this.i9_1;
              checkOwnership(e, this.c1y_1);
              this.f9_1 = 3;
              continue $sm;
            } else {
              throw this.i9_1;
            }

          case 3:
            this.g9_1 = 4;
            return this.b1y_1._v;
          case 4:
            throw this.i9_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.g9_1 === 4) {
          throw e_0;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e_0;
        }
      }
     while (true);
  };
  function OpDescriptor() {
  }
  function get_CLOSED() {
    _init_properties_ConcurrentLinkedList_kt__5gcgzy();
    return CLOSED;
  }
  var CLOSED;
  function Segment(id, prev, pointers) {
    ConcurrentLinkedListNode.call(this, prev);
    this.ts_1 = id;
    this.us_1 = atomic$int$1(pointers << 16);
  }
  protoOf(Segment).c12 = function () {
    return this.us_1.kotlinx$atomicfu$value === this.e11() && !this.j12();
  };
  protoOf(Segment).d12 = function () {
    var tmp0 = this.us_1;
    var tmp$ret$1;
    $l$block_0: {
      // Inline function 'kotlinx.coroutines.internal.addConditionally' call
      while (true) {
        var cur = tmp0.kotlinx$atomicfu$value;
        if (!(!(cur === this.e11()) || this.j12())) {
          tmp$ret$1 = false;
          break $l$block_0;
        }
        if (tmp0.atomicfu$compareAndSet(cur, cur + 65536 | 0)) {
          tmp$ret$1 = true;
          break $l$block_0;
        }
      }
    }
    return tmp$ret$1;
  };
  protoOf(Segment).e12 = function () {
    return this.us_1.atomicfu$addAndGet(-65536) === this.e11() && !this.j12();
  };
  protoOf(Segment).b12 = function () {
    if (this.us_1.atomicfu$incrementAndGet() === this.e11()) {
      this.h4();
    }
  };
  function close_0(_this__u8e3s4) {
    _init_properties_ConcurrentLinkedList_kt__5gcgzy();
    var cur = _this__u8e3s4;
    while (true) {
      // Inline function 'kotlinx.coroutines.internal.ConcurrentLinkedListNode.nextOrIfClosed' call
      var this_0 = cur;
      // Inline function 'kotlin.let' call
      var it = access$_get_nextOrClosed__ywzond(this_0);
      var tmp;
      if (it === access$_get_CLOSED_$tConcurrentLinkedListKt_wmtpdy()) {
        return cur;
      } else {
        tmp = (it == null ? true : it instanceof ConcurrentLinkedListNode) ? it : THROW_CCE();
      }
      var next = tmp;
      if (next === null) {
        if (cur.m12())
          return cur;
      } else {
        cur = next;
      }
    }
  }
  function _SegmentOrClosed___init__impl__jnexvb(value) {
    return value;
  }
  function _get_value__a43j40_1($this) {
    return $this;
  }
  function _SegmentOrClosed___get_isClosed__impl__qmxmlo($this) {
    return _get_value__a43j40_1($this) === get_CLOSED();
  }
  function _SegmentOrClosed___get_segment__impl__jvcr9l($this) {
    var tmp;
    if (_get_value__a43j40_1($this) === get_CLOSED()) {
      var message = 'Does not contain segment';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    } else {
      var tmp_0 = _get_value__a43j40_1($this);
      tmp = tmp_0 instanceof Segment ? tmp_0 : THROW_CCE();
    }
    return tmp;
  }
  function SegmentOrClosed__toString_impl_pzb2an($this) {
    return 'SegmentOrClosed(value=' + toString_0($this) + ')';
  }
  function SegmentOrClosed__hashCode_impl_4855hs($this) {
    return $this == null ? 0 : hashCode($this);
  }
  function SegmentOrClosed__equals_impl_6erq1g($this, other) {
    if (!(other instanceof SegmentOrClosed))
      return false;
    var tmp0_other_with_cast = other instanceof SegmentOrClosed ? other.k14_1 : THROW_CCE();
    if (!equals($this, tmp0_other_with_cast))
      return false;
    return true;
  }
  function SegmentOrClosed(value) {
    this.k14_1 = value;
  }
  protoOf(SegmentOrClosed).toString = function () {
    return SegmentOrClosed__toString_impl_pzb2an(this.k14_1);
  };
  protoOf(SegmentOrClosed).hashCode = function () {
    return SegmentOrClosed__hashCode_impl_4855hs(this.k14_1);
  };
  protoOf(SegmentOrClosed).equals = function (other) {
    return SegmentOrClosed__equals_impl_6erq1g(this.k14_1, other);
  };
  function _get_nextOrClosed__w0gmuv($this) {
    return $this.f12_1.kotlinx$atomicfu$value;
  }
  function _get_aliveSegmentLeft__mr4ndu($this) {
    var cur = $this.k12();
    while (!(cur === null) && cur.c12())
      cur = cur.g12_1.kotlinx$atomicfu$value;
    return cur;
  }
  function _get_aliveSegmentRight__7ulr0b($this) {
    // Inline function 'kotlinx.coroutines.assert' call
    var cur = ensureNotNull($this.h12());
    while (cur.c12()) {
      var tmp0_elvis_lhs = cur.h12();
      var tmp;
      if (tmp0_elvis_lhs == null) {
        return cur;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      cur = tmp;
    }
    return cur;
  }
  function access$_get_nextOrClosed__ywzond($this) {
    return _get_nextOrClosed__w0gmuv($this);
  }
  function ConcurrentLinkedListNode(prev) {
    this.f12_1 = atomic$ref$1(null);
    this.g12_1 = atomic$ref$1(prev);
  }
  protoOf(ConcurrentLinkedListNode).h12 = function () {
    // Inline function 'kotlinx.coroutines.internal.ConcurrentLinkedListNode.nextOrIfClosed' call
    // Inline function 'kotlin.let' call
    var it = access$_get_nextOrClosed__ywzond(this);
    var tmp;
    if (it === access$_get_CLOSED_$tConcurrentLinkedListKt_wmtpdy()) {
      return null;
    } else {
      tmp = (it == null ? true : it instanceof ConcurrentLinkedListNode) ? it : THROW_CCE();
    }
    return tmp;
  };
  protoOf(ConcurrentLinkedListNode).i12 = function (value) {
    return this.f12_1.atomicfu$compareAndSet(null, value);
  };
  protoOf(ConcurrentLinkedListNode).j12 = function () {
    return this.h12() == null;
  };
  protoOf(ConcurrentLinkedListNode).k12 = function () {
    return this.g12_1.kotlinx$atomicfu$value;
  };
  protoOf(ConcurrentLinkedListNode).l12 = function () {
    // Inline function 'kotlinx.atomicfu.AtomicRef.lazySet' call
    this.g12_1.kotlinx$atomicfu$value = null;
  };
  protoOf(ConcurrentLinkedListNode).m12 = function () {
    return this.f12_1.atomicfu$compareAndSet(null, get_CLOSED());
  };
  protoOf(ConcurrentLinkedListNode).h4 = function () {
    // Inline function 'kotlinx.coroutines.assert' call
    if (this.j12())
      return Unit_instance;
    $l$loop_0: while (true) {
      var prev = _get_aliveSegmentLeft__mr4ndu(this);
      var next = _get_aliveSegmentRight__7ulr0b(this);
      var tmp0 = next.g12_1;
      $l$block: {
        // Inline function 'kotlinx.atomicfu.update' call
        while (true) {
          var cur = tmp0.kotlinx$atomicfu$value;
          var upd = cur === null ? null : prev;
          if (tmp0.atomicfu$compareAndSet(cur, upd)) {
            break $l$block;
          }
        }
      }
      if (!(prev === null))
        prev.f12_1.kotlinx$atomicfu$value = next;
      if (next.c12() && !next.j12())
        continue $l$loop_0;
      if (!(prev === null) && prev.c12())
        continue $l$loop_0;
      return Unit_instance;
    }
  };
  function findSegmentInternal(_this__u8e3s4, id, createNewSegment) {
    _init_properties_ConcurrentLinkedList_kt__5gcgzy();
    var cur = _this__u8e3s4;
    $l$loop: while (cur.ts_1 < id || cur.c12()) {
      // Inline function 'kotlinx.coroutines.internal.ConcurrentLinkedListNode.nextOrIfClosed' call
      var this_0 = cur;
      // Inline function 'kotlin.let' call
      var it = access$_get_nextOrClosed__ywzond(this_0);
      var tmp;
      if (it === access$_get_CLOSED_$tConcurrentLinkedListKt_wmtpdy()) {
        return _SegmentOrClosed___init__impl__jnexvb(get_CLOSED());
      } else {
        tmp = (it == null ? true : it instanceof ConcurrentLinkedListNode) ? it : THROW_CCE();
      }
      var next = tmp;
      if (!(next == null)) {
        cur = next;
        continue $l$loop;
      }
      // Inline function 'kotlin.Long.plus' call
      var this_1 = cur.ts_1;
      var newTail = createNewSegment(add_2(this_1, fromInt_0(1)), cur);
      if (cur.i12(newTail)) {
        if (cur.c12()) {
          cur.h4();
        }
        cur = newTail;
      }
    }
    return _SegmentOrClosed___init__impl__jnexvb(cur);
  }
  function access$_get_CLOSED_$tConcurrentLinkedListKt_wmtpdy() {
    return get_CLOSED();
  }
  var properties_initialized_ConcurrentLinkedList_kt_kwt434;
  function _init_properties_ConcurrentLinkedList_kt__5gcgzy() {
    if (!properties_initialized_ConcurrentLinkedList_kt_kwt434) {
      properties_initialized_ConcurrentLinkedList_kt_kwt434 = true;
      CLOSED = new Symbol_0('CLOSED');
    }
  }
  function handleUncaughtCoroutineException(context, exception) {
    var tmp0_iterator = get_platformExceptionHandlers().m();
    while (tmp0_iterator.n()) {
      var handler = tmp0_iterator.o();
      try {
        handler.av(context, exception);
      } catch ($p) {
        if ($p instanceof ExceptionSuccessfullyProcessed) {
          var _ = $p;
          return Unit_instance;
        } else {
          if ($p instanceof Error) {
            var t = $p;
            propagateExceptionFinalResort(handlerException(exception, t));
          } else {
            throw $p;
          }
        }
      }
    }
    try {
      addSuppressed(exception, new DiagnosticCoroutineContextException(context));
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
      } else {
        throw $p;
      }
    }
    propagateExceptionFinalResort(exception);
  }
  function ExceptionSuccessfullyProcessed() {
  }
  function get_UNDEFINED() {
    _init_properties_DispatchedContinuation_kt__tnmqc0();
    return UNDEFINED;
  }
  var UNDEFINED;
  function get_REUSABLE_CLAIMED() {
    _init_properties_DispatchedContinuation_kt__tnmqc0();
    return REUSABLE_CLAIMED;
  }
  var REUSABLE_CLAIMED;
  function resumeCancellableWith(_this__u8e3s4, result, onCancellation) {
    onCancellation = onCancellation === VOID ? null : onCancellation;
    _init_properties_DispatchedContinuation_kt__tnmqc0();
    var tmp;
    if (_this__u8e3s4 instanceof DispatchedContinuation) {
      // Inline function 'kotlinx.coroutines.internal.DispatchedContinuation.resumeCancellableWith' call
      var state = toState_0(result, onCancellation);
      if (_this__u8e3s4.bs_1.wu(_this__u8e3s4.l9())) {
        _this__u8e3s4.ds_1 = state;
        _this__u8e3s4.ps_1 = 1;
        _this__u8e3s4.bs_1.xu(_this__u8e3s4.l9(), _this__u8e3s4);
      } else {
        $l$block: {
          // Inline function 'kotlinx.coroutines.internal.executeUnconfined' call
          // Inline function 'kotlinx.coroutines.assert' call
          var eventLoop = ThreadLocalEventLoop_getInstance().sv();
          if (false && eventLoop.nv()) {
            break $l$block;
          }
          var tmp_0;
          if (eventLoop.mv()) {
            _this__u8e3s4.ds_1 = state;
            _this__u8e3s4.ps_1 = 1;
            eventLoop.lv(_this__u8e3s4);
            tmp_0 = true;
          } else {
            // Inline function 'kotlinx.coroutines.runUnconfinedEventLoop' call
            eventLoop.ov(true);
            try {
              var tmp$ret$4;
              $l$block_0: {
                // Inline function 'kotlinx.coroutines.internal.DispatchedContinuation.resumeCancelled' call
                var job = _this__u8e3s4.l9().s9(Key_instance_3);
                if (!(job == null) && !job.io()) {
                  var cause = job.hp();
                  _this__u8e3s4.ot(state, cause);
                  // Inline function 'kotlin.coroutines.resumeWithException' call
                  // Inline function 'kotlin.Companion.failure' call
                  var tmp$ret$2 = _Result___init__impl__xyqfz8(createFailure(cause));
                  _this__u8e3s4.q9(tmp$ret$2);
                  tmp$ret$4 = true;
                  break $l$block_0;
                }
                tmp$ret$4 = false;
              }
              if (!tmp$ret$4) {
                // Inline function 'kotlinx.coroutines.internal.DispatchedContinuation.resumeUndispatchedWith' call
                _this__u8e3s4.cs_1;
                // Inline function 'kotlinx.coroutines.withContinuationContext' call
                _this__u8e3s4.es_1;
                _this__u8e3s4.cs_1.q9(result);
              }
              $l$loop: while (eventLoop.kv()) {
              }
            } catch ($p) {
              if ($p instanceof Error) {
                var e = $p;
                _this__u8e3s4.bu(e, null);
              } else {
                throw $p;
              }
            }
            finally {
              eventLoop.pv(true);
            }
            tmp_0 = false;
          }
        }
      }
      tmp = Unit_instance;
    } else {
      _this__u8e3s4.q9(result);
      tmp = Unit_instance;
    }
    return tmp;
  }
  function _get_reusableCancellableContinuation__9qex09($this) {
    var tmp = $this.fs_1.kotlinx$atomicfu$value;
    return tmp instanceof CancellableContinuationImpl ? tmp : null;
  }
  function DispatchedContinuation(dispatcher, continuation) {
    DispatchedTask.call(this, -1);
    this.bs_1 = dispatcher;
    this.cs_1 = continuation;
    this.ds_1 = get_UNDEFINED();
    this.es_1 = threadContextElements(this.l9());
    this.fs_1 = atomic$ref$1(null);
  }
  protoOf(DispatchedContinuation).l9 = function () {
    return this.cs_1.l9();
  };
  protoOf(DispatchedContinuation).os = function () {
    return !(this.fs_1.kotlinx$atomicfu$value == null);
  };
  protoOf(DispatchedContinuation).g1z = function () {
    // Inline function 'kotlinx.atomicfu.loop' call
    var this_0 = this.fs_1;
    while (true) {
      if (!(this_0.kotlinx$atomicfu$value === get_REUSABLE_CLAIMED()))
        return Unit_instance;
    }
  };
  protoOf(DispatchedContinuation).zu = function () {
    this.g1z();
    var tmp0_safe_receiver = _get_reusableCancellableContinuation__9qex09(this);
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.kt();
    }
  };
  protoOf(DispatchedContinuation).gs = function () {
    // Inline function 'kotlinx.atomicfu.loop' call
    var this_0 = this.fs_1;
    while (true) {
      var state = this_0.kotlinx$atomicfu$value;
      if (state === null) {
        this.fs_1.kotlinx$atomicfu$value = get_REUSABLE_CLAIMED();
        return null;
      } else {
        if (state instanceof CancellableContinuationImpl) {
          if (this.fs_1.atomicfu$compareAndSet(state, get_REUSABLE_CLAIMED())) {
            return state instanceof CancellableContinuationImpl ? state : THROW_CCE();
          }
        } else {
          if (state !== get_REUSABLE_CLAIMED()) {
            if (!(state instanceof Error)) {
              // Inline function 'kotlin.error' call
              var message = 'Inconsistent state ' + toString_0(state);
              throw IllegalStateException_init_$Create$_0(toString_1(message));
            }
          }
        }
      }
    }
  };
  protoOf(DispatchedContinuation).wt = function (continuation) {
    // Inline function 'kotlinx.atomicfu.loop' call
    var this_0 = this.fs_1;
    while (true) {
      var state = this_0.kotlinx$atomicfu$value;
      if (state === get_REUSABLE_CLAIMED()) {
        if (this.fs_1.atomicfu$compareAndSet(get_REUSABLE_CLAIMED(), continuation))
          return null;
      } else {
        if (state instanceof Error) {
          // Inline function 'kotlin.require' call
          // Inline function 'kotlin.require' call
          if (!this.fs_1.atomicfu$compareAndSet(state, null)) {
            var message = 'Failed requirement.';
            throw IllegalArgumentException_init_$Create$_0(toString_1(message));
          }
          return state;
        } else {
          // Inline function 'kotlin.error' call
          var message_0 = 'Inconsistent state ' + toString_0(state);
          throw IllegalStateException_init_$Create$_0(toString_1(message_0));
        }
      }
    }
  };
  protoOf(DispatchedContinuation).qs = function (cause) {
    // Inline function 'kotlinx.atomicfu.loop' call
    var this_0 = this.fs_1;
    while (true) {
      var state = this_0.kotlinx$atomicfu$value;
      if (equals(state, get_REUSABLE_CLAIMED())) {
        if (this.fs_1.atomicfu$compareAndSet(get_REUSABLE_CLAIMED(), cause))
          return true;
      } else {
        if (state instanceof Error)
          return true;
        else {
          if (this.fs_1.atomicfu$compareAndSet(state, null))
            return false;
        }
      }
    }
  };
  protoOf(DispatchedContinuation).nt = function () {
    var state = this.ds_1;
    // Inline function 'kotlinx.coroutines.assert' call
    this.ds_1 = get_UNDEFINED();
    return state;
  };
  protoOf(DispatchedContinuation).lt = function () {
    return this;
  };
  protoOf(DispatchedContinuation).q9 = function (result) {
    var context = this.cs_1.l9();
    var state = toState_0(result);
    if (this.bs_1.wu(context)) {
      this.ds_1 = state;
      this.ps_1 = 0;
      this.bs_1.xu(context, this);
    } else {
      $l$block: {
        // Inline function 'kotlinx.coroutines.internal.executeUnconfined' call
        // Inline function 'kotlinx.coroutines.assert' call
        var eventLoop = ThreadLocalEventLoop_getInstance().sv();
        if (false && eventLoop.nv()) {
          break $l$block;
        }
        var tmp;
        if (eventLoop.mv()) {
          this.ds_1 = state;
          this.ps_1 = 0;
          eventLoop.lv(this);
          tmp = true;
        } else {
          // Inline function 'kotlinx.coroutines.runUnconfinedEventLoop' call
          eventLoop.ov(true);
          try {
            this.l9();
            // Inline function 'kotlinx.coroutines.withCoroutineContext' call
            this.es_1;
            this.cs_1.q9(result);
            $l$loop: while (eventLoop.kv()) {
            }
          } catch ($p) {
            if ($p instanceof Error) {
              var e = $p;
              this.bu(e, null);
            } else {
              throw $p;
            }
          }
          finally {
            eventLoop.pv(true);
          }
          tmp = false;
        }
      }
    }
  };
  protoOf(DispatchedContinuation).ot = function (takenState, cause) {
    if (takenState instanceof CompletedWithCancellation) {
      takenState.uu_1(cause);
    }
  };
  protoOf(DispatchedContinuation).w10 = function (context, value) {
    this.ds_1 = value;
    this.ps_1 = 1;
    this.bs_1.yu(context, this);
  };
  protoOf(DispatchedContinuation).toString = function () {
    return 'DispatchedContinuation[' + this.bs_1.toString() + ', ' + toDebugString(this.cs_1) + ']';
  };
  function yieldUndispatched(_this__u8e3s4) {
    _init_properties_DispatchedContinuation_kt__tnmqc0();
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlinx.coroutines.internal.executeUnconfined' call
      // Inline function 'kotlinx.coroutines.assert' call
      var eventLoop = ThreadLocalEventLoop_getInstance().sv();
      if (true && eventLoop.nv()) {
        tmp$ret$1 = false;
        break $l$block;
      }
      var tmp;
      if (eventLoop.mv()) {
        _this__u8e3s4.ds_1 = Unit_instance;
        _this__u8e3s4.ps_1 = 1;
        eventLoop.lv(_this__u8e3s4);
        tmp = true;
      } else {
        // Inline function 'kotlinx.coroutines.runUnconfinedEventLoop' call
        eventLoop.ov(true);
        try {
          _this__u8e3s4.au();
          $l$loop: while (eventLoop.kv()) {
          }
        } catch ($p) {
          if ($p instanceof Error) {
            var e = $p;
            _this__u8e3s4.bu(e, null);
          } else {
            throw $p;
          }
        }
        finally {
          eventLoop.pv(true);
        }
        tmp = false;
      }
      tmp$ret$1 = tmp;
    }
    return tmp$ret$1;
  }
  var properties_initialized_DispatchedContinuation_kt_2siadq;
  function _init_properties_DispatchedContinuation_kt__tnmqc0() {
    if (!properties_initialized_DispatchedContinuation_kt_2siadq) {
      properties_initialized_DispatchedContinuation_kt_2siadq = true;
      UNDEFINED = new Symbol_0('UNDEFINED');
      REUSABLE_CLAIMED = new Symbol_0('REUSABLE_CLAIMED');
    }
  }
  function DispatchedTask(resumeMode) {
    SchedulerTask.call(this);
    this.ps_1 = resumeMode;
  }
  protoOf(DispatchedTask).ot = function (takenState, cause) {
  };
  protoOf(DispatchedTask).vt = function (state) {
    return (state == null ? true : !(state == null)) ? state : THROW_CCE();
  };
  protoOf(DispatchedTask).yt = function (state) {
    var tmp0_safe_receiver = state instanceof CompletedExceptionally ? state : null;
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.no_1;
  };
  protoOf(DispatchedTask).au = function () {
    // Inline function 'kotlinx.coroutines.assert' call
    get_taskContext(this);
    var taskContext = Unit_instance;
    var fatalException = null;
    try {
      var tmp = this.lt();
      var delegate = tmp instanceof DispatchedContinuation ? tmp : THROW_CCE();
      var continuation = delegate.cs_1;
      // Inline function 'kotlinx.coroutines.withContinuationContext' call
      delegate.es_1;
      var context = continuation.l9();
      var state = this.nt();
      var exception = this.yt(state);
      var job = exception == null && get_isCancellableMode(this.ps_1) ? context.s9(Key_instance_3) : null;
      if (!(job == null) && !job.io()) {
        var cause = job.hp();
        this.ot(state, cause);
        // Inline function 'kotlinx.coroutines.resumeWithStackTrace' call
        // Inline function 'kotlin.Companion.failure' call
        var exception_0 = recoverStackTrace(cause, continuation);
        var tmp$ret$1 = _Result___init__impl__xyqfz8(createFailure(exception_0));
        continuation.q9(tmp$ret$1);
      } else {
        if (!(exception == null)) {
          // Inline function 'kotlin.coroutines.resumeWithException' call
          // Inline function 'kotlin.Companion.failure' call
          var tmp$ret$3 = _Result___init__impl__xyqfz8(createFailure(exception));
          continuation.q9(tmp$ret$3);
        } else {
          // Inline function 'kotlin.coroutines.resume' call
          // Inline function 'kotlin.Companion.success' call
          var value = this.vt(state);
          var tmp$ret$5 = _Result___init__impl__xyqfz8(value);
          continuation.q9(tmp$ret$5);
        }
      }
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        fatalException = e;
      } else {
        throw $p;
      }
    }
    finally {
      // Inline function 'kotlin.runCatching' call
      var tmp_0;
      try {
        // Inline function 'kotlinx.coroutines.afterTask' call
        // Inline function 'kotlin.Companion.success' call
        tmp_0 = _Result___init__impl__xyqfz8(Unit_instance);
      } catch ($p) {
        var tmp_1;
        if ($p instanceof Error) {
          var e_0 = $p;
          // Inline function 'kotlin.Companion.failure' call
          tmp_1 = _Result___init__impl__xyqfz8(createFailure(e_0));
        } else {
          throw $p;
        }
        tmp_0 = tmp_1;
      }
      var result = tmp_0;
      this.bu(fatalException, Result__exceptionOrNull_impl_p6xea9(result));
    }
  };
  protoOf(DispatchedTask).bu = function (exception, finallyException) {
    if (exception === null && finallyException === null)
      return Unit_instance;
    if (!(exception === null) && !(finallyException === null)) {
      // Inline function 'kotlinx.coroutines.addSuppressedThrowable' call
    }
    var cause = exception == null ? finallyException : exception;
    var reason = new CoroutinesInternalError('Fatal exception in coroutines machinery for ' + toString_1(this) + '. ' + "Please read KDoc to 'handleFatalException' method and report this incident to maintainers", ensureNotNull(cause));
    handleCoroutineException(this.lt().l9(), reason);
  };
  function get_isReusableMode(_this__u8e3s4) {
    return _this__u8e3s4 === 2;
  }
  function get_isCancellableMode(_this__u8e3s4) {
    return _this__u8e3s4 === 1 || _this__u8e3s4 === 2;
  }
  function dispatch(_this__u8e3s4, mode) {
    // Inline function 'kotlinx.coroutines.assert' call
    var delegate = _this__u8e3s4.lt();
    var undispatched = mode === 4;
    var tmp;
    var tmp_0;
    if (!undispatched) {
      tmp_0 = delegate instanceof DispatchedContinuation;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = get_isCancellableMode(mode) === get_isCancellableMode(_this__u8e3s4.ps_1);
    } else {
      tmp = false;
    }
    if (tmp) {
      var dispatcher = delegate.bs_1;
      var context = delegate.l9();
      if (dispatcher.wu(context)) {
        dispatcher.xu(context, _this__u8e3s4);
      } else {
        resumeUnconfined(_this__u8e3s4);
      }
    } else {
      resume(_this__u8e3s4, delegate, undispatched);
    }
  }
  function resumeUnconfined(_this__u8e3s4) {
    var eventLoop = ThreadLocalEventLoop_getInstance().sv();
    if (eventLoop.mv()) {
      eventLoop.lv(_this__u8e3s4);
    } else {
      // Inline function 'kotlinx.coroutines.runUnconfinedEventLoop' call
      eventLoop.ov(true);
      try {
        resume(_this__u8e3s4, _this__u8e3s4.lt(), true);
        $l$loop: while (eventLoop.kv()) {
        }
      } catch ($p) {
        if ($p instanceof Error) {
          var e = $p;
          _this__u8e3s4.bu(e, null);
        } else {
          throw $p;
        }
      }
      finally {
        eventLoop.pv(true);
      }
    }
  }
  function resume(_this__u8e3s4, delegate, undispatched) {
    var state = _this__u8e3s4.nt();
    var exception = _this__u8e3s4.yt(state);
    var tmp;
    if (!(exception == null)) {
      // Inline function 'kotlin.Companion.failure' call
      tmp = _Result___init__impl__xyqfz8(createFailure(exception));
    } else {
      // Inline function 'kotlin.Companion.success' call
      var value = _this__u8e3s4.vt(state);
      tmp = _Result___init__impl__xyqfz8(value);
    }
    var result = tmp;
    if (undispatched) {
      // Inline function 'kotlinx.coroutines.internal.DispatchedContinuation.resumeUndispatchedWith' call
      var this_0 = delegate instanceof DispatchedContinuation ? delegate : THROW_CCE();
      this_0.cs_1;
      // Inline function 'kotlinx.coroutines.withContinuationContext' call
      this_0.es_1;
      this_0.cs_1.q9(result);
    } else {
      delegate.q9(result);
    }
  }
  function _InlineList___init__impl__z8n56(holder) {
    holder = holder === VOID ? null : holder;
    return holder;
  }
  function _get_holder__f6h5pd($this) {
    return $this;
  }
  function InlineList__plus_impl_nuetvo($this, element) {
    // Inline function 'kotlinx.coroutines.assert' call
    var tmp0_subject = _get_holder__f6h5pd($this);
    var tmp;
    if (tmp0_subject == null) {
      tmp = _InlineList___init__impl__z8n56(element);
    } else {
      if (tmp0_subject instanceof ArrayList) {
        var tmp_0 = _get_holder__f6h5pd($this);
        (tmp_0 instanceof ArrayList ? tmp_0 : THROW_CCE()).j(element);
        tmp = _InlineList___init__impl__z8n56(_get_holder__f6h5pd($this));
      } else {
        var list = ArrayList_init_$Create$_0(4);
        var tmp_1 = _get_holder__f6h5pd($this);
        list.j((tmp_1 == null ? true : !(tmp_1 == null)) ? tmp_1 : THROW_CCE());
        list.j(element);
        tmp = _InlineList___init__impl__z8n56(list);
      }
    }
    return tmp;
  }
  function access$_get_holder__kkflen($this) {
    return _get_holder__f6h5pd($this);
  }
  function callUndeliveredElement(_this__u8e3s4, element, context) {
    var tmp0_safe_receiver = callUndeliveredElementCatchingException(_this__u8e3s4, element, null);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      handleCoroutineException(context, tmp0_safe_receiver);
    }
  }
  function UndeliveredElementException(message, cause) {
    RuntimeException_init_$Init$_1(message, cause, this);
    captureStack(this, UndeliveredElementException);
  }
  function callUndeliveredElementCatchingException(_this__u8e3s4, element, undeliveredElementException) {
    undeliveredElementException = undeliveredElementException === VOID ? null : undeliveredElementException;
    try {
      _this__u8e3s4(element);
    } catch ($p) {
      if ($p instanceof Error) {
        var ex = $p;
        if (!(undeliveredElementException == null) && !(undeliveredElementException.cause === ex)) {
          // Inline function 'kotlinx.coroutines.addSuppressedThrowable' call
        } else {
          return new UndeliveredElementException('Exception in undelivered element handler for ' + toString_0(element), ex);
        }
      } else {
        throw $p;
      }
    }
    return undeliveredElementException;
  }
  function bindCancellationFun(_this__u8e3s4, element, context) {
    return bindCancellationFun$lambda(_this__u8e3s4, element, context);
  }
  function bindCancellationFun$lambda($this_bindCancellationFun, $element, $context) {
    return function (_anonymous_parameter_0__qggqh8) {
      callUndeliveredElement($this_bindCancellationFun, $element, $context);
      return Unit_instance;
    };
  }
  function ScopeCoroutine(context, uCont) {
    AbstractCoroutine.call(this, context, true, true);
    this.zq_1 = uCont;
  }
  protoOf(ScopeCoroutine).bq = function () {
    return true;
  };
  protoOf(ScopeCoroutine).so = function (state) {
    resumeCancellableWith(intercepted(this.zq_1), recoverResult(state, this.zq_1));
  };
  protoOf(ScopeCoroutine).ro = function (state) {
    this.zq_1.q9(recoverResult(state, this.zq_1));
  };
  function ContextScope(context) {
    this.h1z_1 = context;
  }
  protoOf(ContextScope).ho = function () {
    return this.h1z_1;
  };
  protoOf(ContextScope).toString = function () {
    return 'CoroutineScope(coroutineContext=' + toString_1(this.h1z_1) + ')';
  };
  function Symbol_0(symbol) {
    this.i1z_1 = symbol;
  }
  protoOf(Symbol_0).toString = function () {
    return '<' + this.i1z_1 + '>';
  };
  function systemProp(propertyName, defaultValue, minValue, maxValue) {
    minValue = minValue === VOID ? 1 : minValue;
    maxValue = maxValue === VOID ? 2147483647 : maxValue;
    return convertToInt(systemProp_0(propertyName, fromInt_0(defaultValue), fromInt_0(minValue), fromInt_0(maxValue)));
  }
  function systemProp_0(propertyName, defaultValue, minValue, maxValue) {
    minValue = minValue === VOID ? 1n : minValue;
    maxValue = maxValue === VOID ? 9223372036854775807n : maxValue;
    var tmp0_elvis_lhs = systemProp_1(propertyName);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return defaultValue;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var value = tmp;
    var tmp1_elvis_lhs = toLongOrNull(value);
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      var message = "System property '" + propertyName + "' has unrecognized value '" + value + "'";
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    var parsed = tmp_0;
    if (!(minValue <= parsed ? parsed <= maxValue : false)) {
      // Inline function 'kotlin.error' call
      var message_0 = "System property '" + propertyName + "' should be in range " + minValue.toString() + '..' + maxValue.toString() + ", but is '" + parsed.toString() + "'";
      throw IllegalStateException_init_$Create$_0(toString_1(message_0));
    }
    return parsed;
  }
  function startCoroutineCancellable(_this__u8e3s4, receiver, completion, onCancellation) {
    onCancellation = onCancellation === VOID ? null : onCancellation;
    // Inline function 'kotlinx.coroutines.intrinsics.runSafely' call
    try {
      var tmp = intercepted(createCoroutineUnintercepted(_this__u8e3s4, receiver, completion));
      // Inline function 'kotlin.Companion.success' call
      var tmp$ret$0 = _Result___init__impl__xyqfz8(Unit_instance);
      resumeCancellableWith(tmp, tmp$ret$0, onCancellation);
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        dispatcherFailure(completion, e);
      } else {
        throw $p;
      }
    }
    return Unit_instance;
  }
  function startCoroutineCancellable_0(_this__u8e3s4, fatalCompletion) {
    // Inline function 'kotlinx.coroutines.intrinsics.runSafely' call
    try {
      var tmp = intercepted(_this__u8e3s4);
      // Inline function 'kotlin.Companion.success' call
      var tmp$ret$0 = _Result___init__impl__xyqfz8(Unit_instance);
      resumeCancellableWith(tmp, tmp$ret$0);
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        dispatcherFailure(fatalCompletion, e);
      } else {
        throw $p;
      }
    }
    return Unit_instance;
  }
  function dispatcherFailure(completion, e) {
    // Inline function 'kotlin.Companion.failure' call
    var tmp$ret$0 = _Result___init__impl__xyqfz8(createFailure(e));
    completion.q9(tmp$ret$0);
    throw e;
  }
  function startUndispatchedOrReturn(_this__u8e3s4, receiver, block) {
    var tmp$ret$2;
    $l$block_0: {
      // Inline function 'kotlinx.coroutines.intrinsics.undispatchedResult' call
      var tmp;
      try {
        // Inline function 'kotlin.coroutines.intrinsics.startCoroutineUninterceptedOrReturn' call
        tmp = startCoroutineUninterceptedOrReturnNonGeneratorVersion(block, receiver, _this__u8e3s4);
      } catch ($p) {
        var tmp_0;
        if ($p instanceof Error) {
          var e = $p;
          tmp_0 = new CompletedExceptionally(e);
        } else {
          throw $p;
        }
        tmp = tmp_0;
      }
      var result = tmp;
      if (result === get_COROUTINE_SUSPENDED()) {
        tmp$ret$2 = get_COROUTINE_SUSPENDED();
        break $l$block_0;
      }
      var state = _this__u8e3s4.qo(result);
      if (state === get_COMPLETING_WAITING_CHILDREN()) {
        tmp$ret$2 = get_COROUTINE_SUSPENDED();
        break $l$block_0;
      }
      var tmp_1;
      if (state instanceof CompletedExceptionally) {
        var tmp_2;
        state.no_1;
        if (true) {
          throw recoverStackTrace(state.no_1, _this__u8e3s4.zq_1);
        } else {
          if (result instanceof CompletedExceptionally) {
            throw recoverStackTrace(result.no_1, _this__u8e3s4.zq_1);
          } else {
            tmp_2 = result;
          }
        }
        tmp_1 = tmp_2;
      } else {
        tmp_1 = unboxState(state);
      }
      tmp$ret$2 = tmp_1;
    }
    return tmp$ret$2;
  }
  function startCoroutineUndispatched(_this__u8e3s4, receiver, completion) {
    $l$block: {
      // Inline function 'kotlinx.coroutines.intrinsics.startDirect' call
      // Inline function 'kotlinx.coroutines.internal.probeCoroutineCreated' call
      var actualCompletion = completion;
      var tmp;
      try {
        // Inline function 'kotlinx.coroutines.withCoroutineContext' call
        completion.l9();
        // Inline function 'kotlin.coroutines.intrinsics.startCoroutineUninterceptedOrReturn' call
        tmp = startCoroutineUninterceptedOrReturnNonGeneratorVersion(_this__u8e3s4, receiver, actualCompletion);
      } catch ($p) {
        var tmp_0;
        if ($p instanceof Error) {
          var e = $p;
          // Inline function 'kotlin.coroutines.resumeWithException' call
          // Inline function 'kotlin.Companion.failure' call
          var tmp$ret$5 = _Result___init__impl__xyqfz8(createFailure(e));
          actualCompletion.q9(tmp$ret$5);
          break $l$block;
        } else {
          throw $p;
        }
      }
      var value = tmp;
      if (!(value === get_COROUTINE_SUSPENDED())) {
        // Inline function 'kotlin.coroutines.resume' call
        // Inline function 'kotlin.Companion.success' call
        var value_0 = (value == null ? true : !(value == null)) ? value : THROW_CCE();
        var tmp$ret$8 = _Result___init__impl__xyqfz8(value_0);
        actualCompletion.q9(tmp$ret$8);
      }
    }
  }
  function startUndispatchedOrReturnIgnoreTimeout(_this__u8e3s4, receiver, block) {
    var tmp$ret$2;
    $l$block_0: {
      // Inline function 'kotlinx.coroutines.intrinsics.undispatchedResult' call
      var tmp;
      try {
        // Inline function 'kotlin.coroutines.intrinsics.startCoroutineUninterceptedOrReturn' call
        tmp = startCoroutineUninterceptedOrReturnNonGeneratorVersion(block, receiver, _this__u8e3s4);
      } catch ($p) {
        var tmp_0;
        if ($p instanceof Error) {
          var e = $p;
          tmp_0 = new CompletedExceptionally(e);
        } else {
          throw $p;
        }
        tmp = tmp_0;
      }
      var result = tmp;
      if (result === get_COROUTINE_SUSPENDED()) {
        tmp$ret$2 = get_COROUTINE_SUSPENDED();
        break $l$block_0;
      }
      var state = _this__u8e3s4.qo(result);
      if (state === get_COMPLETING_WAITING_CHILDREN()) {
        tmp$ret$2 = get_COROUTINE_SUSPENDED();
        break $l$block_0;
      }
      var tmp_1;
      if (state instanceof CompletedExceptionally) {
        var tmp_2;
        var e_0 = state.no_1;
        var tmp_3;
        if (e_0 instanceof TimeoutCancellationException) {
          tmp_3 = e_0.n10_1 === _this__u8e3s4;
        } else {
          tmp_3 = false;
        }
        if (!tmp_3) {
          throw recoverStackTrace(state.no_1, _this__u8e3s4.zq_1);
        } else {
          if (result instanceof CompletedExceptionally) {
            throw recoverStackTrace(result.no_1, _this__u8e3s4.zq_1);
          } else {
            tmp_2 = result;
          }
        }
        tmp_1 = tmp_2;
      } else {
        tmp_1 = unboxState(state);
      }
      tmp$ret$2 = tmp_1;
    }
    return tmp$ret$2;
  }
  function get_DUMMY_PROCESS_RESULT_FUNCTION() {
    _init_properties_Select_kt__zhm2jg();
    return DUMMY_PROCESS_RESULT_FUNCTION;
  }
  var DUMMY_PROCESS_RESULT_FUNCTION;
  function get_STATE_REG() {
    _init_properties_Select_kt__zhm2jg();
    return STATE_REG;
  }
  var STATE_REG;
  function get_STATE_COMPLETED() {
    _init_properties_Select_kt__zhm2jg();
    return STATE_COMPLETED;
  }
  var STATE_COMPLETED;
  function get_STATE_CANCELLED() {
    _init_properties_Select_kt__zhm2jg();
    return STATE_CANCELLED;
  }
  var STATE_CANCELLED;
  function get_NO_RESULT() {
    _init_properties_Select_kt__zhm2jg();
    return NO_RESULT;
  }
  var NO_RESULT;
  function get_PARAM_CLAUSE_0() {
    _init_properties_Select_kt__zhm2jg();
    return PARAM_CLAUSE_0;
  }
  var PARAM_CLAUSE_0;
  function SelectClause0Impl(clauseObject, regFunc, onCancellationConstructor) {
    onCancellationConstructor = onCancellationConstructor === VOID ? null : onCancellationConstructor;
    this.j1z_1 = clauseObject;
    this.k1z_1 = regFunc;
    this.l1z_1 = onCancellationConstructor;
    this.m1z_1 = get_DUMMY_PROCESS_RESULT_FUNCTION();
  }
  protoOf(SelectClause0Impl).n1z = function () {
    return this.j1z_1;
  };
  protoOf(SelectClause0Impl).o1z = function () {
    return this.k1z_1;
  };
  protoOf(SelectClause0Impl).p1z = function () {
    return this.l1z_1;
  };
  protoOf(SelectClause0Impl).q1z = function () {
    return this.m1z_1;
  };
  function SelectInstance() {
  }
  function $invokeBlockCOROUTINE$(_this__u8e3s4, argument, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.z1z_1 = _this__u8e3s4;
    this.a20_1 = argument;
  }
  protoOf($invokeBlockCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 4;
            var block = this.z1z_1.g20_1;
            if (this.z1z_1.f20_1 === get_PARAM_CLAUSE_0()) {
              if (!isSuspendFunction(block, 0))
                THROW_CCE();
              this.f9_1 = 2;
              suspendResult = block(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              if (!isSuspendFunction(block, 1))
                THROW_CCE();
              this.f9_1 = 1;
              suspendResult = block(this.a20_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            this.b20_1 = suspendResult;
            this.f9_1 = 3;
            continue $sm;
          case 2:
            this.b20_1 = suspendResult;
            this.f9_1 = 3;
            continue $sm;
          case 3:
            return this.b20_1;
          case 4:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 4) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function _get_isSelected__uy0hmu($this) {
    var tmp = $this.x13_1.kotlinx$atomicfu$value;
    return tmp instanceof ClauseData;
  }
  function doSelectSuspend($this, $completion) {
    var tmp = new $doSelectSuspendCOROUTINE$($this, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  }
  function checkClauseObject($this, clauseObject) {
    var clauses = ensureNotNull($this.y13_1);
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.none' call
      var tmp;
      if (isInterface(clauses, Collection)) {
        tmp = clauses.s();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
      var _iterator__ex2g4s = clauses.m();
      while (_iterator__ex2g4s.n()) {
        var element = _iterator__ex2g4s.o();
        if (element.c20_1 === clauseObject) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
      }
      tmp$ret$0 = true;
    }
    // Inline function 'kotlin.check' call
    if (!tmp$ret$0) {
      var message = 'Cannot use select clauses on the same object: ' + toString_1(clauseObject);
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
  }
  function waitUntilSelected($this, $completion) {
    var cancellable = new CancellableContinuationImpl(intercepted($completion), 1);
    cancellable.mt();
    $l$block_0: {
      // Inline function 'kotlinx.atomicfu.loop' call
      var this_0 = $this.x13_1;
      while (true) {
        var curState = this_0.kotlinx$atomicfu$value;
        if (curState === get_STATE_REG()) {
          if ($this.x13_1.atomicfu$compareAndSet(curState, cancellable)) {
            // Inline function 'kotlinx.coroutines.asHandler' call
            // Inline function 'kotlin.js.asDynamic' call
            cancellable.ur($this);
            break $l$block_0;
          }
        } else {
          if (isInterface(curState, KtList)) {
            if ($this.x13_1.atomicfu$compareAndSet(curState, get_STATE_REG())) {
              if (!isInterface(curState, KtList))
                THROW_CCE();
              // Inline function 'kotlin.collections.forEach' call
              var _iterator__ex2g4s = curState.m();
              while (_iterator__ex2g4s.n()) {
                var element = _iterator__ex2g4s.o();
                reregisterClause($this, element);
              }
            }
          } else {
            if (curState instanceof ClauseData) {
              cancellable.wr(Unit_instance, curState.u20($this, $this.b14_1));
              break $l$block_0;
            } else {
              // Inline function 'kotlin.error' call
              var message = 'unexpected state: ' + toString_1(curState);
              throw IllegalStateException_init_$Create$_0(toString_1(message));
            }
          }
        }
      }
    }
    return cancellable.tt();
  }
  function reregisterClause($this, clauseObject) {
    var clause = ensureNotNull(findClause($this, clauseObject));
    clause.i20_1 = null;
    clause.j20_1 = -1;
    $this.v20(clause, true);
  }
  function trySelectInternal($this, clauseObject, internalResult) {
    $l$loop: while (true) {
      var curState = $this.x13_1.kotlinx$atomicfu$value;
      if (isInterface(curState, CancellableContinuation)) {
        var tmp0_elvis_lhs = findClause($this, clauseObject);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          continue $l$loop;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var clause = tmp;
        var onCancellation = clause.u20($this, internalResult);
        if ($this.x13_1.atomicfu$compareAndSet(curState, clause)) {
          var cont = isInterface(curState, CancellableContinuation) ? curState : THROW_CCE();
          $this.b14_1 = internalResult;
          if (tryResume_1(cont, onCancellation))
            return 0;
          $this.b14_1 = null;
          return 2;
        }
      } else {
        var tmp_0;
        if (equals(curState, get_STATE_COMPLETED())) {
          tmp_0 = true;
        } else {
          tmp_0 = curState instanceof ClauseData;
        }
        if (tmp_0)
          return 3;
        else {
          if (equals(curState, get_STATE_CANCELLED()))
            return 2;
          else {
            if (equals(curState, get_STATE_REG())) {
              if ($this.x13_1.atomicfu$compareAndSet(curState, listOf(clauseObject)))
                return 1;
            } else {
              if (isInterface(curState, KtList)) {
                if ($this.x13_1.atomicfu$compareAndSet(curState, plus_6(curState, clauseObject)))
                  return 1;
              } else {
                // Inline function 'kotlin.error' call
                var message = 'Unexpected state: ' + toString_1(curState);
                throw IllegalStateException_init_$Create$_0(toString_1(message));
              }
            }
          }
        }
      }
    }
  }
  function findClause($this, clauseObject) {
    var tmp0_elvis_lhs = $this.y13_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var clauses = tmp;
    // Inline function 'kotlin.collections.find' call
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var _iterator__ex2g4s = clauses.m();
      while (_iterator__ex2g4s.n()) {
        var element = _iterator__ex2g4s.o();
        if (element.c20_1 === clauseObject) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    var tmp1_elvis_lhs = tmp$ret$1;
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      var message = 'Clause with object ' + toString_1(clauseObject) + ' is not found';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    return tmp_0;
  }
  function complete($this, $completion) {
    var tmp = new $completeCOROUTINE$($this, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  }
  function processResultAndInvokeBlockRecoveringException($this, clause, internalResult, $completion) {
    var tmp = new $processResultAndInvokeBlockRecoveringExceptionCOROUTINE$($this, clause, internalResult, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  }
  function cleanup($this, selectedClause) {
    // Inline function 'kotlinx.coroutines.assert' call
    var tmp0_elvis_lhs = $this.y13_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var clauses = tmp;
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = clauses.m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      if (!(element === selectedClause)) {
        element.zr();
      }
    }
    $this.x13_1.kotlinx$atomicfu$value = get_STATE_COMPLETED();
    $this.b14_1 = get_NO_RESULT();
    $this.y13_1 = null;
  }
  function ClauseData($outer, clauseObject, regFunc, processResFunc, param, block, onCancellationConstructor) {
    this.k20_1 = $outer;
    this.c20_1 = clauseObject;
    this.d20_1 = regFunc;
    this.e20_1 = processResFunc;
    this.f20_1 = param;
    this.g20_1 = block;
    this.h20_1 = onCancellationConstructor;
    this.i20_1 = null;
    this.j20_1 = -1;
  }
  protoOf(ClauseData).s21 = function (select) {
    // Inline function 'kotlinx.coroutines.assert' call
    // Inline function 'kotlinx.coroutines.assert' call
    this.d20_1(this.c20_1, select, this.f20_1);
    return select.b14_1 === get_NO_RESULT();
  };
  protoOf(ClauseData).t21 = function (result) {
    return this.e20_1(this.c20_1, this.f20_1, result);
  };
  protoOf(ClauseData).u21 = function (argument, $completion) {
    var tmp = new $invokeBlockCOROUTINE$(this, argument, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(ClauseData).zr = function () {
    // Inline function 'kotlin.with' call
    var $this$with = this.i20_1;
    var tmp;
    if ($this$with instanceof Segment) {
      $this$with.vs(this.j20_1, null, this.k20_1.l9());
      tmp = Unit_instance;
    } else {
      var tmp0_safe_receiver = (!($this$with == null) ? isInterface($this$with, DisposableHandle) : false) ? $this$with : null;
      var tmp_0;
      if (tmp0_safe_receiver == null) {
        tmp_0 = null;
      } else {
        tmp0_safe_receiver.zr();
        tmp_0 = Unit_instance;
      }
      tmp = tmp_0;
    }
  };
  protoOf(ClauseData).u20 = function (select, internalResult) {
    var tmp0_safe_receiver = this.h20_1;
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver(select, this.f20_1, internalResult);
  };
  function $doSelectCOROUTINE$(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.d22_1 = _this__u8e3s4;
  }
  protoOf($doSelectCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 4;
            if (_get_isSelected__uy0hmu(this.d22_1)) {
              this.f9_1 = 2;
              suspendResult = complete(this.d22_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.f9_1 = 1;
              suspendResult = doSelectSuspend(this.d22_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            this.e22_1 = suspendResult;
            this.f9_1 = 3;
            continue $sm;
          case 2:
            this.e22_1 = suspendResult;
            this.f9_1 = 3;
            continue $sm;
          case 3:
            return this.e22_1;
          case 4:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 4) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function $doSelectSuspendCOROUTINE$(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.t20_1 = _this__u8e3s4;
  }
  protoOf($doSelectSuspendCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 3;
            this.f9_1 = 1;
            suspendResult = waitUntilSelected(this.t20_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.f9_1 = 2;
            suspendResult = complete(this.t20_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return suspendResult;
          case 3:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 3) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function $completeCOROUTINE$(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.e21_1 = _this__u8e3s4;
  }
  protoOf($completeCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 4;
            var tmp_0 = this.e21_1.x13_1.kotlinx$atomicfu$value;
            var selectedClause = tmp_0 instanceof ClauseData ? tmp_0 : THROW_CCE();
            var internalResult = this.e21_1.b14_1;
            cleanup(this.e21_1, selectedClause);
            if (!get_RECOVER_STACK_TRACES()) {
              var blockArgument = selectedClause.t21(internalResult);
              this.f9_1 = 2;
              suspendResult = selectedClause.u21(blockArgument, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.f9_1 = 1;
              suspendResult = processResultAndInvokeBlockRecoveringException(this.e21_1, selectedClause, internalResult, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            this.f21_1 = suspendResult;
            this.f9_1 = 3;
            continue $sm;
          case 2:
            this.f21_1 = suspendResult;
            this.f9_1 = 3;
            continue $sm;
          case 3:
            return this.f21_1;
          case 4:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 4) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function $processResultAndInvokeBlockRecoveringExceptionCOROUTINE$(_this__u8e3s4, clause, internalResult, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.o21_1 = _this__u8e3s4;
    this.p21_1 = clause;
    this.q21_1 = internalResult;
  }
  protoOf($processResultAndInvokeBlockRecoveringExceptionCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 3;
            this.g9_1 = 2;
            var blockArgument = this.p21_1.t21(this.q21_1);
            this.f9_1 = 1;
            suspendResult = this.p21_1.u21(blockArgument, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.r21_1 = suspendResult;
            this.g9_1 = 3;
            this.f9_1 = 4;
            continue $sm;
          case 2:
            this.g9_1 = 3;
            var tmp_0 = this.i9_1;
            if (tmp_0 instanceof Error) {
              var e = this.i9_1;
              var tmp_1 = this;
              throw e;
            } else {
              throw this.i9_1;
            }

          case 3:
            throw this.i9_1;
          case 4:
            this.g9_1 = 3;
            return this.r21_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.g9_1 === 3) {
          throw e_0;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e_0;
        }
      }
     while (true);
  };
  function SelectImplementation(context) {
    CancelHandler.call(this);
    this.w13_1 = context;
    this.x13_1 = atomic$ref$1(get_STATE_REG());
    this.y13_1 = ArrayList_init_$Create$_0(2);
    this.z13_1 = null;
    this.a14_1 = -1;
    this.b14_1 = get_NO_RESULT();
  }
  protoOf(SelectImplementation).l9 = function () {
    return this.w13_1;
  };
  protoOf(SelectImplementation).f22 = function ($completion) {
    var tmp = new $doSelectCOROUTINE$(this, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(SelectImplementation).g22 = function (_this__u8e3s4, block) {
    return this.h22(new ClauseData(this, _this__u8e3s4.n1z(), _this__u8e3s4.o1z(), _this__u8e3s4.q1z(), get_PARAM_CLAUSE_0(), block, _this__u8e3s4.p1z()));
  };
  protoOf(SelectImplementation).v20 = function (_this__u8e3s4, reregister) {
    // Inline function 'kotlinx.coroutines.assert' call
    // Inline function 'kotlin.let' call
    if (this.x13_1.kotlinx$atomicfu$value instanceof ClauseData)
      return Unit_instance;
    if (!reregister) {
      checkClauseObject(this, _this__u8e3s4.c20_1);
    }
    if (_this__u8e3s4.s21(this)) {
      if (!reregister) {
        // Inline function 'kotlin.collections.plusAssign' call
        ensureNotNull(this.y13_1).j(_this__u8e3s4);
      }
      _this__u8e3s4.i20_1 = this.z13_1;
      _this__u8e3s4.j20_1 = this.a14_1;
      this.z13_1 = null;
      this.a14_1 = -1;
    } else {
      this.x13_1.kotlinx$atomicfu$value = _this__u8e3s4;
    }
  };
  protoOf(SelectImplementation).h22 = function (_this__u8e3s4, reregister, $super) {
    reregister = reregister === VOID ? false : reregister;
    var tmp;
    if ($super === VOID) {
      this.v20(_this__u8e3s4, reregister);
      tmp = Unit_instance;
    } else {
      tmp = $super.v20.call(this, _this__u8e3s4, reregister);
    }
    return tmp;
  };
  protoOf(SelectImplementation).yw = function (disposableHandle) {
    this.z13_1 = disposableHandle;
  };
  protoOf(SelectImplementation).xt = function (segment, index) {
    this.z13_1 = segment;
    this.a14_1 = index;
  };
  protoOf(SelectImplementation).xw = function (internalResult) {
    this.b14_1 = internalResult;
  };
  protoOf(SelectImplementation).fx = function (clauseObject, result) {
    return trySelectInternal(this, clauseObject, result) === 0;
  };
  protoOf(SelectImplementation).c14 = function (clauseObject, result) {
    return TrySelectDetailedResult_0(trySelectInternal(this, clauseObject, result));
  };
  protoOf(SelectImplementation).yr = function (cause) {
    var tmp0 = this.x13_1;
    $l$block: {
      // Inline function 'kotlinx.atomicfu.update' call
      while (true) {
        var cur = tmp0.kotlinx$atomicfu$value;
        if (cur === get_STATE_COMPLETED())
          return Unit_instance;
        var upd = get_STATE_CANCELLED();
        if (tmp0.atomicfu$compareAndSet(cur, upd)) {
          break $l$block;
        }
      }
    }
    var tmp0_elvis_lhs = this.y13_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var clauses = tmp;
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = clauses.m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      element.zr();
    }
    this.b14_1 = get_NO_RESULT();
    this.y13_1 = null;
  };
  protoOf(SelectImplementation).invoke = function (cause) {
    return this.yr(cause);
  };
  var TrySelectDetailedResult_SUCCESSFUL_instance;
  var TrySelectDetailedResult_REREGISTER_instance;
  var TrySelectDetailedResult_CANCELLED_instance;
  var TrySelectDetailedResult_ALREADY_SELECTED_instance;
  var TrySelectDetailedResult_entriesInitialized;
  function TrySelectDetailedResult_initEntries() {
    if (TrySelectDetailedResult_entriesInitialized)
      return Unit_instance;
    TrySelectDetailedResult_entriesInitialized = true;
    TrySelectDetailedResult_SUCCESSFUL_instance = new TrySelectDetailedResult('SUCCESSFUL', 0);
    TrySelectDetailedResult_REREGISTER_instance = new TrySelectDetailedResult('REREGISTER', 1);
    TrySelectDetailedResult_CANCELLED_instance = new TrySelectDetailedResult('CANCELLED', 2);
    TrySelectDetailedResult_ALREADY_SELECTED_instance = new TrySelectDetailedResult('ALREADY_SELECTED', 3);
  }
  function TrySelectDetailedResult(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function TrySelectDetailedResult_0(trySelectInternalResult) {
    _init_properties_Select_kt__zhm2jg();
    var tmp;
    switch (trySelectInternalResult) {
      case 0:
        tmp = TrySelectDetailedResult_SUCCESSFUL_getInstance();
        break;
      case 1:
        tmp = TrySelectDetailedResult_REREGISTER_getInstance();
        break;
      case 2:
        tmp = TrySelectDetailedResult_CANCELLED_getInstance();
        break;
      case 3:
        tmp = TrySelectDetailedResult_ALREADY_SELECTED_getInstance();
        break;
      default:
        var message = 'Unexpected internal result: ' + trySelectInternalResult;
        throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    return tmp;
  }
  function tryResume_1(_this__u8e3s4, onCancellation) {
    _init_properties_Select_kt__zhm2jg();
    var tmp0_elvis_lhs = _this__u8e3s4.sr(Unit_instance, null, onCancellation);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var token = tmp;
    _this__u8e3s4.tr(token);
    return true;
  }
  function DUMMY_PROCESS_RESULT_FUNCTION$lambda(_anonymous_parameter_0__qggqh8, _anonymous_parameter_1__qggqgd, _anonymous_parameter_2__qggqfi) {
    _init_properties_Select_kt__zhm2jg();
    return null;
  }
  function TrySelectDetailedResult_SUCCESSFUL_getInstance() {
    TrySelectDetailedResult_initEntries();
    return TrySelectDetailedResult_SUCCESSFUL_instance;
  }
  function TrySelectDetailedResult_REREGISTER_getInstance() {
    TrySelectDetailedResult_initEntries();
    return TrySelectDetailedResult_REREGISTER_instance;
  }
  function TrySelectDetailedResult_CANCELLED_getInstance() {
    TrySelectDetailedResult_initEntries();
    return TrySelectDetailedResult_CANCELLED_instance;
  }
  function TrySelectDetailedResult_ALREADY_SELECTED_getInstance() {
    TrySelectDetailedResult_initEntries();
    return TrySelectDetailedResult_ALREADY_SELECTED_instance;
  }
  var properties_initialized_Select_kt_7rpl36;
  function _init_properties_Select_kt__zhm2jg() {
    if (!properties_initialized_Select_kt_7rpl36) {
      properties_initialized_Select_kt_7rpl36 = true;
      DUMMY_PROCESS_RESULT_FUNCTION = DUMMY_PROCESS_RESULT_FUNCTION$lambda;
      STATE_REG = new Symbol_0('STATE_REG');
      STATE_COMPLETED = new Symbol_0('STATE_COMPLETED');
      STATE_CANCELLED = new Symbol_0('STATE_CANCELLED');
      NO_RESULT = new Symbol_0('NO_RESULT');
      PARAM_CLAUSE_0 = new Symbol_0('PARAM_CLAUSE_0');
    }
  }
  function invokeIt(_this__u8e3s4, cause) {
    if (typeof _this__u8e3s4 === 'function')
      _this__u8e3s4(cause);
    else {
      // Inline function 'kotlin.js.asDynamic' call
      _this__u8e3s4.invoke(cause);
    }
  }
  function CancelHandlerBase() {
  }
  function CompletionHandlerBase() {
    LinkedListNode.call(this);
  }
  function newCoroutineContext(_this__u8e3s4, context) {
    var combined = _this__u8e3s4.ho().wi(context);
    return !(combined === Dispatchers_getInstance().uz_1) && combined.s9(Key_instance) == null ? combined.wi(Dispatchers_getInstance().uz_1) : combined;
  }
  function newCoroutineContext_0(_this__u8e3s4, addedContext) {
    return _this__u8e3s4.wi(addedContext);
  }
  function UndispatchedCoroutine(context, uCont) {
    ScopeCoroutine.call(this, context, uCont);
  }
  protoOf(UndispatchedCoroutine).ro = function (state) {
    return this.zq_1.q9(recoverResult(state, this.zq_1));
  };
  function toDebugString(_this__u8e3s4) {
    return toString_1(_this__u8e3s4);
  }
  function get_DefaultDelay() {
    var tmp = Dispatchers_getInstance().uz_1;
    return isInterface(tmp, Delay) ? tmp : THROW_CCE();
  }
  function createDefaultDispatcher() {
    var tmp;
    if (isJsdom()) {
      tmp = NodeDispatcher_getInstance();
    } else {
      var tmp_0;
      var tmp_1;
      if (!(typeof window === 'undefined')) {
        // Inline function 'kotlin.js.asDynamic' call
        tmp_1 = window != null;
      } else {
        tmp_1 = false;
      }
      if (tmp_1) {
        // Inline function 'kotlin.js.asDynamic' call
        tmp_0 = !(typeof window.addEventListener === 'undefined');
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        tmp = asCoroutineDispatcher(window);
      } else {
        if (typeof process === 'undefined' || typeof process.nextTick === 'undefined') {
          tmp = SetTimeoutDispatcher_getInstance();
        } else {
          tmp = NodeDispatcher_getInstance();
        }
      }
    }
    return tmp;
  }
  function get_coroutineName(_this__u8e3s4) {
    return null;
  }
  function isJsdom() {
    return !(typeof navigator === 'undefined') && navigator != null && navigator.userAgent != null && !(typeof navigator.userAgent === 'undefined') && !(typeof navigator.userAgent.match === 'undefined') && navigator.userAgent.match('\\bjsdom\\b');
  }
  var counter;
  function get_DEBUG() {
    return DEBUG;
  }
  var DEBUG;
  function get_hexAddress(_this__u8e3s4) {
    // Inline function 'kotlin.js.asDynamic' call
    var result = _this__u8e3s4.__debug_counter;
    if (!(typeof result === 'number')) {
      counter = counter + 1 | 0;
      result = counter;
      // Inline function 'kotlin.js.asDynamic' call
      _this__u8e3s4.__debug_counter = result;
    }
    return ((!(result == null) ? typeof result === 'number' : false) ? result : THROW_CCE()).toString();
  }
  function get_classSimpleName(_this__u8e3s4) {
    var tmp0_elvis_lhs = getKClassFromExpression(_this__u8e3s4).ra();
    return tmp0_elvis_lhs == null ? 'Unknown' : tmp0_elvis_lhs;
  }
  function Dispatchers() {
    Dispatchers_instance = this;
    this.uz_1 = createDefaultDispatcher();
    this.vz_1 = Unconfined_getInstance();
    this.wz_1 = new JsMainDispatcher(this.uz_1, false);
    this.xz_1 = null;
  }
  protoOf(Dispatchers).yz = function () {
    var tmp0_elvis_lhs = this.xz_1;
    return tmp0_elvis_lhs == null ? this.wz_1 : tmp0_elvis_lhs;
  };
  var Dispatchers_instance;
  function Dispatchers_getInstance() {
    if (Dispatchers_instance == null)
      new Dispatchers();
    return Dispatchers_instance;
  }
  function JsMainDispatcher(delegate, invokeImmediately) {
    MainCoroutineDispatcher.call(this);
    this.n22_1 = delegate;
    this.o22_1 = invokeImmediately;
    this.p22_1 = this.o22_1 ? this : new JsMainDispatcher(this.n22_1, true);
  }
  protoOf(JsMainDispatcher).sz = function () {
    return this.p22_1;
  };
  protoOf(JsMainDispatcher).wu = function (context) {
    return !this.o22_1;
  };
  protoOf(JsMainDispatcher).xu = function (context, block) {
    return this.n22_1.xu(context, block);
  };
  protoOf(JsMainDispatcher).yu = function (context, block) {
    return this.n22_1.yu(context, block);
  };
  protoOf(JsMainDispatcher).toString = function () {
    var tmp0_elvis_lhs = this.tz();
    return tmp0_elvis_lhs == null ? this.n22_1.toString() : tmp0_elvis_lhs;
  };
  function createEventLoop() {
    return new UnconfinedEventLoop();
  }
  function UnconfinedEventLoop() {
    EventLoop.call(this);
  }
  protoOf(UnconfinedEventLoop).xu = function (context, block) {
    unsupported();
  };
  function unsupported() {
    throw UnsupportedOperationException_init_$Create$_0('runBlocking event loop is not supported');
  }
  function get_RECOVER_STACK_TRACES() {
    return RECOVER_STACK_TRACES;
  }
  var RECOVER_STACK_TRACES;
  function JobCancellationException(message, cause, job) {
    CancellationException_init_$Init$_1(message, cause, this);
    captureStack(this, JobCancellationException);
    this.u22_1 = job;
  }
  protoOf(JobCancellationException).toString = function () {
    return protoOf(CancellationException).toString.call(this) + '; job=' + toString_1(this.u22_1);
  };
  protoOf(JobCancellationException).equals = function (other) {
    var tmp;
    if (other === this) {
      tmp = true;
    } else {
      var tmp_0;
      var tmp_1;
      var tmp_2;
      if (other instanceof JobCancellationException) {
        tmp_2 = other.message == this.message;
      } else {
        tmp_2 = false;
      }
      if (tmp_2) {
        tmp_1 = equals(other.u22_1, this.u22_1);
      } else {
        tmp_1 = false;
      }
      if (tmp_1) {
        tmp_0 = equals(other.cause, this.cause);
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  protoOf(JobCancellationException).hashCode = function () {
    var tmp = imul(imul(getStringHashCode(ensureNotNull(this.message)), 31) + hashCode(this.u22_1) | 0, 31);
    var tmp0_safe_receiver = this.cause;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    return tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
  };
  function NodeDispatcher() {
    NodeDispatcher_instance = this;
    SetTimeoutBasedDispatcher.call(this);
  }
  protoOf(NodeDispatcher).x22 = function () {
    process.nextTick(this.e23_1.b23_1);
  };
  var NodeDispatcher_instance;
  function NodeDispatcher_getInstance() {
    if (NodeDispatcher_instance == null)
      new NodeDispatcher();
    return NodeDispatcher_instance;
  }
  function SetTimeoutDispatcher() {
    SetTimeoutDispatcher_instance = this;
    SetTimeoutBasedDispatcher.call(this);
  }
  protoOf(SetTimeoutDispatcher).x22 = function () {
    setTimeout(this.e23_1.b23_1, 0);
  };
  var SetTimeoutDispatcher_instance;
  function SetTimeoutDispatcher_getInstance() {
    if (SetTimeoutDispatcher_instance == null)
      new SetTimeoutDispatcher();
    return SetTimeoutDispatcher_instance;
  }
  function SetTimeoutBasedDispatcher$ScheduledMessageQueue$processQueue$lambda(this$0) {
    return function () {
      this$0.k23();
      return Unit_instance;
    };
  }
  function ScheduledMessageQueue($outer) {
    this.c23_1 = $outer;
    MessageQueue.call(this);
    var tmp = this;
    tmp.b23_1 = SetTimeoutBasedDispatcher$ScheduledMessageQueue$processQueue$lambda(this);
  }
  protoOf(ScheduledMessageQueue).l23 = function () {
    this.c23_1.x22();
  };
  protoOf(ScheduledMessageQueue).m23 = function () {
    setTimeout(this.b23_1, 0);
  };
  function SetTimeoutBasedDispatcher$invokeOnTimeout$lambda($block) {
    return function () {
      $block.au();
      return Unit_instance;
    };
  }
  function SetTimeoutBasedDispatcher$scheduleResumeAfterDelay$lambda($continuation, this$0) {
    return function () {
      // Inline function 'kotlin.with' call
      $continuation.vr(this$0, Unit_instance);
      return Unit_instance;
    };
  }
  function SetTimeoutBasedDispatcher() {
    CoroutineDispatcher.call(this);
    this.e23_1 = new ScheduledMessageQueue(this);
  }
  protoOf(SetTimeoutBasedDispatcher).xu = function (context, block) {
    this.e23_1.z23(block);
  };
  protoOf(SetTimeoutBasedDispatcher).ev = function (timeMillis, block, context) {
    var handle = setTimeout(SetTimeoutBasedDispatcher$invokeOnTimeout$lambda(block), delayToInt(timeMillis));
    return new ClearTimeout(handle);
  };
  protoOf(SetTimeoutBasedDispatcher).dv = function (timeMillis, continuation) {
    var handle = setTimeout(SetTimeoutBasedDispatcher$scheduleResumeAfterDelay$lambda(continuation, this), delayToInt(timeMillis));
    // Inline function 'kotlinx.coroutines.asHandler' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = new ClearTimeout(handle);
    continuation.ur(tmp$ret$1);
  };
  function MessageQueue() {
    this.h23_1 = ArrayDeque_init_$Create$();
    this.i23_1 = 16;
    this.j23_1 = false;
  }
  protoOf(MessageQueue).p = function () {
    return this.h23_1.jf_1;
  };
  protoOf(MessageQueue).n23 = function (index, element) {
    this.h23_1.m2(index, element);
  };
  protoOf(MessageQueue).m2 = function (index, element) {
    return this.n23(index, (!(element == null) ? isInterface(element, Runnable) : false) ? element : THROW_CCE());
  };
  protoOf(MessageQueue).o23 = function (element) {
    return this.h23_1.j(element);
  };
  protoOf(MessageQueue).j = function (element) {
    return this.o23((!(element == null) ? isInterface(element, Runnable) : false) ? element : THROW_CCE());
  };
  protoOf(MessageQueue).p23 = function (index, elements) {
    return this.h23_1.i2(index, elements);
  };
  protoOf(MessageQueue).i2 = function (index, elements) {
    return this.p23(index, elements);
  };
  protoOf(MessageQueue).q23 = function (elements) {
    return this.h23_1.q(elements);
  };
  protoOf(MessageQueue).q = function (elements) {
    return this.q23(elements);
  };
  protoOf(MessageQueue).k2 = function () {
    this.h23_1.k2();
  };
  protoOf(MessageQueue).r23 = function (element) {
    return this.h23_1.t(element);
  };
  protoOf(MessageQueue).t = function (element) {
    if (!(!(element == null) ? isInterface(element, Runnable) : false))
      return false;
    return this.r23((!(element == null) ? isInterface(element, Runnable) : false) ? element : THROW_CCE());
  };
  protoOf(MessageQueue).s23 = function (elements) {
    return this.h23_1.e2(elements);
  };
  protoOf(MessageQueue).e2 = function (elements) {
    return this.s23(elements);
  };
  protoOf(MessageQueue).r = function (index) {
    return this.h23_1.r(index);
  };
  protoOf(MessageQueue).t23 = function (element) {
    return this.h23_1.w(element);
  };
  protoOf(MessageQueue).w = function (element) {
    if (!(!(element == null) ? isInterface(element, Runnable) : false))
      return -1;
    return this.t23((!(element == null) ? isInterface(element, Runnable) : false) ? element : THROW_CCE());
  };
  protoOf(MessageQueue).s = function () {
    return this.h23_1.s();
  };
  protoOf(MessageQueue).m = function () {
    return this.h23_1.m();
  };
  protoOf(MessageQueue).u23 = function (element) {
    return this.h23_1.v(element);
  };
  protoOf(MessageQueue).v = function (element) {
    if (!(!(element == null) ? isInterface(element, Runnable) : false))
      return -1;
    return this.u23((!(element == null) ? isInterface(element, Runnable) : false) ? element : THROW_CCE());
  };
  protoOf(MessageQueue).f2 = function () {
    return this.h23_1.f2();
  };
  protoOf(MessageQueue).u = function (index) {
    return this.h23_1.u(index);
  };
  protoOf(MessageQueue).v23 = function (element) {
    return this.h23_1.h2(element);
  };
  protoOf(MessageQueue).h2 = function (element) {
    if (!(!(element == null) ? isInterface(element, Runnable) : false))
      return false;
    return this.v23((!(element == null) ? isInterface(element, Runnable) : false) ? element : THROW_CCE());
  };
  protoOf(MessageQueue).w23 = function (elements) {
    return this.h23_1.j1(elements);
  };
  protoOf(MessageQueue).j1 = function (elements) {
    return this.w23(elements);
  };
  protoOf(MessageQueue).n2 = function (index) {
    return this.h23_1.n2(index);
  };
  protoOf(MessageQueue).x23 = function (elements) {
    return this.h23_1.j2(elements);
  };
  protoOf(MessageQueue).j2 = function (elements) {
    return this.x23(elements);
  };
  protoOf(MessageQueue).y23 = function (index, element) {
    return this.h23_1.l2(index, element);
  };
  protoOf(MessageQueue).l2 = function (index, element) {
    return this.y23(index, (!(element == null) ? isInterface(element, Runnable) : false) ? element : THROW_CCE());
  };
  protoOf(MessageQueue).g2 = function (fromIndex, toIndex) {
    return this.h23_1.g2(fromIndex, toIndex);
  };
  protoOf(MessageQueue).z23 = function (element) {
    this.o23(element);
    if (!this.j23_1) {
      this.j23_1 = true;
      this.l23();
    }
  };
  protoOf(MessageQueue).k23 = function () {
    try {
      // Inline function 'kotlin.repeat' call
      var times = this.i23_1;
      var inductionVariable = 0;
      if (inductionVariable < times)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var tmp0_elvis_lhs = removeFirstOrNull(this);
          var tmp;
          if (tmp0_elvis_lhs == null) {
            return Unit_instance;
          } else {
            tmp = tmp0_elvis_lhs;
          }
          var element = tmp;
          element.au();
        }
         while (inductionVariable < times);
    }finally {
      if (this.s()) {
        this.j23_1 = false;
      } else {
        this.m23();
      }
    }
  };
  function delayToInt(timeMillis) {
    return convertToInt(coerceIn(timeMillis, 0n, 2147483647n));
  }
  function ClearTimeout(handle) {
    CancelHandler.call(this);
    this.a24_1 = handle;
  }
  protoOf(ClearTimeout).zr = function () {
    clearTimeout(this.a24_1);
  };
  protoOf(ClearTimeout).yr = function (cause) {
    this.zr();
  };
  protoOf(ClearTimeout).invoke = function (cause) {
    return this.yr(cause);
  };
  protoOf(ClearTimeout).toString = function () {
    return 'ClearTimeout[' + this.a24_1 + ']';
  };
  function WindowClearTimeout($outer, handle) {
    this.c24_1 = $outer;
    ClearTimeout.call(this, handle);
  }
  protoOf(WindowClearTimeout).zr = function () {
    this.c24_1.e24_1.clearTimeout(this.a24_1);
  };
  function WindowDispatcher$scheduleResumeAfterDelay$lambda($continuation, this$0) {
    return function () {
      // Inline function 'kotlin.with' call
      $continuation.vr(this$0, Unit_instance);
      return Unit_instance;
    };
  }
  function WindowDispatcher$invokeOnTimeout$lambda($block) {
    return function () {
      $block.au();
      return Unit_instance;
    };
  }
  function WindowDispatcher(window_0) {
    CoroutineDispatcher.call(this);
    this.e24_1 = window_0;
    this.f24_1 = new WindowMessageQueue(this.e24_1);
  }
  protoOf(WindowDispatcher).xu = function (context, block) {
    return this.f24_1.z23(block);
  };
  protoOf(WindowDispatcher).dv = function (timeMillis, continuation) {
    var handle = this.e24_1.setTimeout(WindowDispatcher$scheduleResumeAfterDelay$lambda(continuation, this), delayToInt(timeMillis));
    // Inline function 'kotlinx.coroutines.asHandler' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = new WindowClearTimeout(this, handle);
    continuation.ur(tmp$ret$1);
  };
  protoOf(WindowDispatcher).ev = function (timeMillis, block, context) {
    var handle = this.e24_1.setTimeout(WindowDispatcher$invokeOnTimeout$lambda(block), delayToInt(timeMillis));
    return new WindowClearTimeout(this, handle);
  };
  function WindowMessageQueue$lambda(this$0) {
    return function (event) {
      var tmp;
      if (event.source == this$0.j24_1 && event.data == this$0.k24_1) {
        event.stopPropagation();
        this$0.k23();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function WindowMessageQueue$schedule$lambda(this$0) {
    return function (it) {
      this$0.k23();
      return Unit_instance;
    };
  }
  function WindowMessageQueue(window_0) {
    MessageQueue.call(this);
    this.j24_1 = window_0;
    this.k24_1 = 'dispatchCoroutine';
    this.j24_1.addEventListener('message', WindowMessageQueue$lambda(this), true);
  }
  protoOf(WindowMessageQueue).l23 = function () {
    var tmp = Promise.resolve(Unit_instance);
    tmp.then(WindowMessageQueue$schedule$lambda(this));
  };
  protoOf(WindowMessageQueue).m23 = function () {
    this.j24_1.postMessage(this.k24_1, '*');
  };
  function promise(_this__u8e3s4, context, start, block) {
    context = context === VOID ? EmptyCoroutineContext_instance : context;
    start = start === VOID ? CoroutineStart_DEFAULT_getInstance() : start;
    return asPromise(async(_this__u8e3s4, context, start, block));
  }
  function asPromise(_this__u8e3s4) {
    var promise = new Promise(asPromise$lambda(_this__u8e3s4));
    // Inline function 'kotlin.js.asDynamic' call
    promise.deferred = _this__u8e3s4;
    return promise;
  }
  function await_0(_this__u8e3s4, $completion) {
    var cancellable = new CancellableContinuationImpl(intercepted($completion), 1);
    cancellable.mt();
    var tmp = await$lambda(cancellable);
    _this__u8e3s4.then(tmp, await$lambda_0(cancellable));
    return cancellable.tt();
  }
  function asPromise$lambda$lambda($this_asPromise, $reject, $resolve) {
    return function (it) {
      var e = $this_asPromise.fq();
      var tmp;
      if (!(e == null)) {
        tmp = $reject(e);
      } else {
        tmp = $resolve($this_asPromise.mr());
      }
      return Unit_instance;
    };
  }
  function asPromise$lambda($this_asPromise) {
    return function (resolve, reject) {
      $this_asPromise.kp(asPromise$lambda$lambda($this_asPromise, reject, resolve));
      return Unit_instance;
    };
  }
  function await$lambda($cont) {
    return function (it) {
      // Inline function 'kotlin.coroutines.resume' call
      var this_0 = $cont;
      // Inline function 'kotlin.Companion.success' call
      var tmp$ret$0 = _Result___init__impl__xyqfz8(it);
      this_0.q9(tmp$ret$0);
      return Unit_instance;
    };
  }
  function await$lambda_0($cont) {
    return function (it) {
      // Inline function 'kotlin.coroutines.resumeWithException' call
      var this_0 = $cont;
      // Inline function 'kotlin.Companion.failure' call
      var tmp$ret$0 = _Result___init__impl__xyqfz8(createFailure(it));
      this_0.q9(tmp$ret$0);
      return Unit_instance;
    };
  }
  function Runnable() {
  }
  function SchedulerTask() {
  }
  function get_taskContext(_this__u8e3s4) {
    return Unit_instance;
  }
  function asCoroutineDispatcher(_this__u8e3s4) {
    // Inline function 'kotlin.js.asDynamic' call
    var tmp0_elvis_lhs = _this__u8e3s4.coroutineDispatcher;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.also' call
      var this_0 = new WindowDispatcher(_this__u8e3s4);
      // Inline function 'kotlin.js.asDynamic' call
      _this__u8e3s4.coroutineDispatcher = this_0;
      tmp = this_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function AbortFlowException(owner) {
    CancellationException_init_$Init$_0('Flow was aborted, no more elements needed', this);
    captureStack(this, AbortFlowException);
    this.e1j_1 = owner;
  }
  function ChildCancelledException() {
    CancellationException_init_$Init$_0('Child of the scoped flow was cancelled', this);
    captureStack(this, ChildCancelledException);
  }
  function SafeCollector$collectContextSize$lambda(count, _anonymous_parameter_1__qggqgd) {
    return count + 1 | 0;
  }
  function SafeCollector(collector, collectContext) {
    this.l1b_1 = collector;
    this.m1b_1 = collectContext;
    var tmp = this;
    tmp.n1b_1 = this.m1b_1.vi(0, SafeCollector$collectContextSize$lambda);
    this.o1b_1 = null;
  }
  protoOf(SafeCollector).x18 = function (value, $completion) {
    // Inline function 'kotlinx.coroutines.currentCoroutineContext' call
    // Inline function 'kotlin.js.getCoroutineContext' call
    var currentContext = $completion.l9();
    ensureActive(currentContext);
    if (!(this.o1b_1 === currentContext)) {
      checkContext(this, currentContext);
      this.o1b_1 = currentContext;
    }
    return this.l1b_1.x18(value, $completion);
  };
  protoOf(SafeCollector).p9 = function () {
  };
  function identitySet(expectedSize) {
    return HashSet_init_$Create$_1(expectedSize);
  }
  function get_platformExceptionHandlers_() {
    _init_properties_CoroutineExceptionHandlerImpl_kt__37d7wf();
    return platformExceptionHandlers_;
  }
  var platformExceptionHandlers_;
  function get_platformExceptionHandlers() {
    _init_properties_CoroutineExceptionHandlerImpl_kt__37d7wf();
    return get_platformExceptionHandlers_();
  }
  function propagateExceptionFinalResort(exception) {
    _init_properties_CoroutineExceptionHandlerImpl_kt__37d7wf();
    console.error(exception);
  }
  function DiagnosticCoroutineContextException(context) {
    RuntimeException_init_$Init$_0(toString_1(context), this);
    captureStack(this, DiagnosticCoroutineContextException);
  }
  var properties_initialized_CoroutineExceptionHandlerImpl_kt_qhrgvx;
  function _init_properties_CoroutineExceptionHandlerImpl_kt__37d7wf() {
    if (!properties_initialized_CoroutineExceptionHandlerImpl_kt_qhrgvx) {
      properties_initialized_CoroutineExceptionHandlerImpl_kt_qhrgvx = true;
      // Inline function 'kotlin.collections.mutableSetOf' call
      platformExceptionHandlers_ = LinkedHashSet_init_$Create$();
    }
  }
  function LinkedListNode() {
    this.iw_1 = this;
    this.jw_1 = this;
    this.kw_1 = false;
  }
  protoOf(LinkedListNode).lw = function (node) {
    var prev = this.jw_1;
    node.iw_1 = this;
    node.jw_1 = prev;
    prev.iw_1 = node;
    this.jw_1 = node;
  };
  protoOf(LinkedListNode).mw = function () {
    return this.nw();
  };
  protoOf(LinkedListNode).zr = function () {
    this.mw();
  };
  protoOf(LinkedListNode).nw = function () {
    if (this.kw_1)
      return false;
    var prev = this.jw_1;
    var next = this.iw_1;
    prev.iw_1 = next;
    next.jw_1 = prev;
    this.kw_1 = true;
    return true;
  };
  protoOf(LinkedListNode).ow = function (node) {
    if (!(this.iw_1 === this))
      return false;
    this.lw(node);
    return true;
  };
  function LinkedListHead() {
    LinkedListNode.call(this);
  }
  protoOf(LinkedListHead).mw = function () {
    throw UnsupportedOperationException_init_$Create$();
  };
  function recoverStackTrace(exception, continuation) {
    return exception;
  }
  function unwrap(exception) {
    return exception;
  }
  function recoverStackTrace_0(exception) {
    return exception;
  }
  function systemProp_1(propertyName) {
    return null;
  }
  function threadContextElements(context) {
    return 0;
  }
  function CommonThreadLocal() {
    this.tv_1 = null;
  }
  protoOf(CommonThreadLocal).uv = function () {
    var tmp = this.tv_1;
    return (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
  };
  protoOf(CommonThreadLocal).vv = function (value) {
    this.tv_1 = value;
  };
  function commonThreadLocal(name) {
    return new CommonThreadLocal();
  }
  function EnumInfoFactory() {
  }
  var EnumInfoFactory_instance;
  function EnumInfoFactory_getInstance() {
    return EnumInfoFactory_instance;
  }
  function toNormalizedName($this, name) {
    // Inline function 'kotlin.text.uppercase' call
    // Inline function 'kotlin.js.asDynamic' call
    return name.toUpperCase();
  }
  function EnumInfoImpl(enumConstants) {
    var numConstants = enumConstants.length;
    var valueMap = HashMap_init_$Create$_0(numConstants);
    var originalNames = ArrayList_init_$Create$_0(numConstants);
    var inductionVariable = 0;
    var last = enumConstants.length;
    while (inductionVariable < last) {
      var value = enumConstants[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      var originalName = value.toString();
      originalNames.j(originalName);
      var normalizedName = toNormalizedName(this, originalName);
      var oldValue = valueMap.t2(normalizedName, value);
      // Inline function 'kotlin.require' call
      if (!(oldValue == null)) {
        var message = "duplicate values: '" + toString_1(value) + "', '" + toString_0(oldValue) + "'";
        throw IllegalArgumentException_init_$Create$_0(toString_1(message));
      }
    }
    this.m24_1 = originalNames;
    this.l24_1 = valueMap;
  }
  protoOf(EnumInfoImpl).n24 = function () {
    return this.m24_1;
  };
  protoOf(EnumInfoImpl).o24 = function (name) {
    var tmp;
    if (this.p24(name)) {
      tmp = this.l24_1.q2(toNormalizedName(this, name));
    } else {
      tmp = null;
    }
    return tmp;
  };
  protoOf(EnumInfoImpl).p24 = function (name) {
    return this.l24_1.o2(toNormalizedName(this, name));
  };
  function Enums() {
  }
  var Enums_instance;
  function Enums_getInstance() {
    return Enums_instance;
  }
  function subListTail(_this__u8e3s4, fromIndex) {
    return _this__u8e3s4.g2(fromIndex, _this__u8e3s4.p());
  }
  function subListTail_0(_this__u8e3s4, fromIndex) {
    return _this__u8e3s4.g2(fromIndex, _this__u8e3s4.p());
  }
  function isDigit(_this__u8e3s4) {
    return _Char___init__impl__6a9atx(48) <= _this__u8e3s4 ? _this__u8e3s4 <= _Char___init__impl__6a9atx(57) : false;
  }
  function isLetterOrDigit(_this__u8e3s4) {
    return isLetter(_this__u8e3s4) || isDigit(_this__u8e3s4);
  }
  function isInt(_this__u8e3s4) {
    return !(toIntOrNull(_this__u8e3s4) == null);
  }
  function isLetter(_this__u8e3s4) {
    return (_Char___init__impl__6a9atx(97) <= _this__u8e3s4 ? _this__u8e3s4 <= _Char___init__impl__6a9atx(122) : false) || (_Char___init__impl__6a9atx(65) <= _this__u8e3s4 ? _this__u8e3s4 <= _Char___init__impl__6a9atx(90) : false);
  }
  function DefaultValueNullPersister(defaultValue) {
    this.q24_1 = defaultValue;
  }
  protoOf(DefaultValueNullPersister).r24 = function (value) {
    return value == null || equals(value, this.q24_1);
  };
  protoOf(DefaultValueNullPersister).s24 = function () {
    return null;
  };
  protoOf(DefaultValueNullPersister).t24 = function () {
    return this.q24_1;
  };
  function EmptyStringNullPersister() {
  }
  protoOf(EmptyStringNullPersister).s24 = function () {
    return '';
  };
  protoOf(EmptyStringNullPersister).u24 = function (value) {
    // Inline function 'kotlin.text.isNullOrEmpty' call
    return value == null || charSequenceLength(value) === 0;
  };
  protoOf(EmptyStringNullPersister).t24 = function () {
    return null;
  };
  function ExceptionNullPersister() {
  }
  protoOf(ExceptionNullPersister).s24 = function () {
    throw NullPointerException_init_$Create$();
  };
  protoOf(ExceptionNullPersister).t24 = function () {
    throw NullPointerException_init_$Create$();
  };
  function toNonNullPersister(_this__u8e3s4, nullPersister) {
    nullPersister = nullPersister === VOID ? new ExceptionNullPersister() : nullPersister;
    return new SimplePersister(_this__u8e3s4, nullPersister);
  }
  function NonNullPersister() {
  }
  function toNullablePersister(_this__u8e3s4, nullPersister) {
    nullPersister = nullPersister === VOID ? new NullPersisterForNullable() : nullPersister;
    var nonNullPersister = isInterface(_this__u8e3s4, NonNullPersister) ? _this__u8e3s4 : THROW_CCE();
    return new SimplePersister(nonNullPersister, nullPersister);
  }
  function NonNullPersisters$STRING_PERSISTER$1() {
  }
  protoOf(NonNullPersisters$STRING_PERSISTER$1).v24 = function (value) {
    return value;
  };
  protoOf(NonNullPersisters$STRING_PERSISTER$1).x24 = function (value) {
    return value;
  };
  protoOf(NonNullPersisters$STRING_PERSISTER$1).w24 = function (value) {
    return this.x24((!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
  };
  protoOf(NonNullPersisters$STRING_PERSISTER$1).toString = function () {
    return 'stringPersister';
  };
  function NonNullPersisters$INT_PERSISTER$1() {
  }
  protoOf(NonNullPersisters$INT_PERSISTER$1).v24 = function (value) {
    return toInt(value);
  };
  protoOf(NonNullPersisters$INT_PERSISTER$1).y24 = function (value) {
    return value.toString();
  };
  protoOf(NonNullPersisters$INT_PERSISTER$1).w24 = function (value) {
    return this.y24((!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
  };
  protoOf(NonNullPersisters$INT_PERSISTER$1).toString = function () {
    return 'intPersister';
  };
  function NonNullPersisters$LONG_PERSISTER$1() {
  }
  protoOf(NonNullPersisters$LONG_PERSISTER$1).v24 = function (value) {
    return toLong(value);
  };
  protoOf(NonNullPersisters$LONG_PERSISTER$1).z24 = function (value) {
    return value.toString();
  };
  protoOf(NonNullPersisters$LONG_PERSISTER$1).w24 = function (value) {
    return this.z24((!(value == null) ? typeof value === 'bigint' : false) ? value : THROW_CCE());
  };
  protoOf(NonNullPersisters$LONG_PERSISTER$1).toString = function () {
    return 'longPersister';
  };
  function NonNullPersisters$BOOLEAN_PERSISTER$1() {
  }
  protoOf(NonNullPersisters$BOOLEAN_PERSISTER$1).v24 = function (value) {
    return toBoolean(value);
  };
  protoOf(NonNullPersisters$BOOLEAN_PERSISTER$1).a25 = function (value) {
    return value.toString();
  };
  protoOf(NonNullPersisters$BOOLEAN_PERSISTER$1).w24 = function (value) {
    return this.a25((!(value == null) ? typeof value === 'boolean' : false) ? value : THROW_CCE());
  };
  protoOf(NonNullPersisters$BOOLEAN_PERSISTER$1).toString = function () {
    return 'booleanPersister';
  };
  function NonNullPersisters$DOUBLE_PERSISTER$1() {
  }
  protoOf(NonNullPersisters$DOUBLE_PERSISTER$1).v24 = function (value) {
    return toDouble(value);
  };
  protoOf(NonNullPersisters$DOUBLE_PERSISTER$1).b25 = function (value) {
    return value.toString();
  };
  protoOf(NonNullPersisters$DOUBLE_PERSISTER$1).w24 = function (value) {
    return this.b25((!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
  };
  protoOf(NonNullPersisters$DOUBLE_PERSISTER$1).toString = function () {
    return 'doublePersister';
  };
  function NonNullPersisters() {
    NonNullPersisters_instance = this;
    var tmp = this;
    tmp.c25_1 = new NonNullPersisters$STRING_PERSISTER$1();
    var tmp_0 = this;
    tmp_0.d25_1 = new NonNullPersisters$INT_PERSISTER$1();
    var tmp_1 = this;
    tmp_1.e25_1 = new NonNullPersisters$LONG_PERSISTER$1();
    var tmp_2 = this;
    tmp_2.f25_1 = new NonNullPersisters$BOOLEAN_PERSISTER$1();
    var tmp_3 = this;
    tmp_3.g25_1 = new NonNullPersisters$DOUBLE_PERSISTER$1();
  }
  protoOf(NonNullPersisters).h25 = function () {
    return this.c25_1;
  };
  protoOf(NonNullPersisters).i25 = function () {
    return this.d25_1;
  };
  protoOf(NonNullPersisters).j25 = function () {
    return this.e25_1;
  };
  protoOf(NonNullPersisters).k25 = function () {
    return this.f25_1;
  };
  protoOf(NonNullPersisters).l25 = function () {
    return this.g25_1;
  };
  var NonNullPersisters_instance;
  function NonNullPersisters_getInstance() {
    if (NonNullPersisters_instance == null)
      new NonNullPersisters();
    return NonNullPersisters_instance;
  }
  function NullPersister() {
  }
  function NullPersisterForNullable() {
  }
  protoOf(NullPersisterForNullable).s24 = function () {
    return null;
  };
  protoOf(NullPersisterForNullable).t24 = function () {
    return null;
  };
  function Persister() {
  }
  function Persisters() {
    Persisters_instance = this;
    this.q25_1 = NonNullPersisters_getInstance().h25();
    this.r25_1 = toNullablePersister(this.q25_1);
    this.s25_1 = toNonNullPersister(NonNullPersisters_getInstance().i25());
    this.t25_1 = toNonNullPersister(NonNullPersisters_getInstance().j25());
    this.u25_1 = toNonNullPersister(NonNullPersisters_getInstance().l25());
    this.v25_1 = NonNullPersisters_getInstance().k25();
    this.w25_1 = toNonNullPersister(this.v25_1);
  }
  protoOf(Persisters).x25 = function (defaultValue) {
    var nullPersister = this.y25(defaultValue);
    return toNonNullPersister(this.q25_1, nullPersister);
  };
  protoOf(Persisters).z25 = function (defaultValue, $super) {
    defaultValue = defaultValue === VOID ? null : defaultValue;
    return $super === VOID ? this.x25(defaultValue) : $super.x25.call(this, defaultValue);
  };
  protoOf(Persisters).a26 = function () {
    return this.r25_1;
  };
  protoOf(Persisters).i25 = function () {
    return this.s25_1;
  };
  protoOf(Persisters).j25 = function () {
    return this.t25_1;
  };
  protoOf(Persisters).k25 = function () {
    return this.w25_1;
  };
  protoOf(Persisters).b26 = function (defaultValue) {
    var nullPersister = this.y25(defaultValue);
    return toNonNullPersister(this.v25_1, nullPersister);
  };
  protoOf(Persisters).c26 = function (defaultValue, $super) {
    defaultValue = defaultValue === VOID ? false : defaultValue;
    return $super === VOID ? this.b26(defaultValue) : $super.b26.call(this, defaultValue);
  };
  protoOf(Persisters).y25 = function (defaultValue) {
    var tmp;
    if (defaultValue == null) {
      tmp = new ExceptionNullPersister();
    } else {
      tmp = new DefaultValueNullPersister(defaultValue);
    }
    return tmp;
  };
  var Persisters_instance;
  function Persisters_getInstance() {
    if (Persisters_instance == null)
      new Persisters();
    return Persisters_instance;
  }
  function SimplePersister(nonNullPersister, nullPersister) {
    this.d26_1 = nonNullPersister;
    this.e26_1 = nullPersister;
  }
  protoOf(SimplePersister).m25 = function () {
    return this.e26_1;
  };
  protoOf(SimplePersister).n25 = function (value) {
    return this.d26_1.w24(value);
  };
  protoOf(SimplePersister).o25 = function (value) {
    return this.d26_1.v24(value);
  };
  function Creator() {
  }
  function CommonBigNumberOperations() {
  }
  var SignificantDecider_FIVE_instance;
  var SignificantDecider_LESS_THAN_FIVE_instance;
  var SignificantDecider_MORE_THAN_FIVE_instance;
  var SignificantDecider_entriesInitialized;
  function SignificantDecider_initEntries() {
    if (SignificantDecider_entriesInitialized)
      return Unit_instance;
    SignificantDecider_entriesInitialized = true;
    SignificantDecider_FIVE_instance = new SignificantDecider('FIVE', 0);
    SignificantDecider_LESS_THAN_FIVE_instance = new SignificantDecider('LESS_THAN_FIVE', 1);
    SignificantDecider_MORE_THAN_FIVE_instance = new SignificantDecider('MORE_THAN_FIVE', 2);
  }
  function roundOrDont($this, significand, exponent, decimalMode) {
    var tmp;
    if (decimalMode.f27_1) {
      tmp = new BigDecimal(significand, exponent);
    } else {
      tmp = roundSignificand($this, significand, exponent, decimalMode);
    }
    return tmp;
  }
  function SignificantDecider(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function determineDecider($this, discarded) {
    var tmp = Companion_getInstance_26().l27_1;
    // Inline function 'kotlin.Long.minus' call
    var this_0 = discarded.r27();
    var tmp$ret$0 = subtract_1(this_0, fromInt_0(1));
    var scale = tmp.s27(tmp$ret$0);
    var divrem = discarded.t27(scale);
    var significant = divrem.u27_1.w27().x27(true);
    var rest = divrem.v27_1.w27();
    var tmp_0;
    if (significant === 5) {
      var tmp_1;
      if (rest.equals(Companion_getInstance_26().i27_1)) {
        tmp_1 = SignificantDecider_FIVE_getInstance();
      } else {
        tmp_1 = SignificantDecider_MORE_THAN_FIVE_getInstance();
      }
      tmp_0 = tmp_1;
    } else if (significant > 5) {
      tmp_0 = SignificantDecider_MORE_THAN_FIVE_getInstance();
    } else if (significant < 5) {
      tmp_0 = SignificantDecider_LESS_THAN_FIVE_getInstance();
    } else {
      throw RuntimeException_init_$Create$_0("Couldn't determine decider");
    }
    return tmp_0;
  }
  function roundDiscarded($this, significand, discarded, decimalMode) {
    var toDiscard = subtract_1(significand.r27(), decimalMode.c27_1);
    var tmp;
    if (toDiscard > 0n) {
      var additionallyDiscarded = significand.t27(Companion_getInstance_26().l27_1.s27(toDiscard));
      tmp = new Pair(additionallyDiscarded.u27_1, additionallyDiscarded.v27_1);
    } else {
      tmp = new Pair(significand, discarded);
    }
    var _destruct__k2r9zo = tmp;
    var result = _destruct__k2r9zo.fg();
    var remainder = _destruct__k2r9zo.gg();
    var tmp_0;
    if (significand.equals(Companion_getInstance_26().i27_1)) {
      tmp_0 = discarded.o27_1;
    } else {
      tmp_0 = significand.o27_1;
    }
    var sign = tmp_0;
    if (!decimalMode.d27_1.equals(RoundingMode_AWAY_FROM_ZERO_getInstance()) && !decimalMode.d27_1.equals(RoundingMode_TOWARDS_ZERO_getInstance())) {
      if (remainder.y27()) {
        return result;
      }
    } else {
      if (remainder.y27() && discarded.y27()) {
        return result;
      }
    }
    var decider = determineDecider($this, remainder);
    switch (decimalMode.d27_1.x2_1) {
      case 2:
        if (sign.equals(Sign_POSITIVE_getInstance())) {
          result = result.a28();
        } else {
          result = result.z27();
        }

        break;
      case 3:
        break;
      case 1:
        if (sign.equals(Sign_POSITIVE_getInstance())) {
          result = result.a28();
        }

        break;
      case 0:
        if (!sign.equals(Sign_POSITIVE_getInstance())) {
          result = result.z27();
        }

        break;
      case 5:
        switch (sign.x2_1) {
          case 0:
            if (!decider.equals(SignificantDecider_LESS_THAN_FIVE_getInstance())) {
              result = result.a28();
            }

            break;
          case 1:
            if (!decider.equals(SignificantDecider_LESS_THAN_FIVE_getInstance())) {
              result = result.z27();
            }

            break;
          case 2:
            break;
          default:
            noWhenBranchMatchedException();
            break;
        }

        break;
      case 6:
        switch (sign.x2_1) {
          case 0:
            if (decider.equals(SignificantDecider_MORE_THAN_FIVE_getInstance())) {
              result = result.a28();
            }

            break;
          case 1:
            if (decider.equals(SignificantDecider_MORE_THAN_FIVE_getInstance())) {
              result = result.z27();
            }

            break;
          case 2:
            break;
          default:
            noWhenBranchMatchedException();
            break;
        }

        break;
      case 7:
        switch (sign.x2_1) {
          case 0:
            if (!decider.equals(SignificantDecider_LESS_THAN_FIVE_getInstance())) {
              result = result.a28();
            }

            break;
          case 1:
            if (decider.equals(SignificantDecider_MORE_THAN_FIVE_getInstance())) {
              result = result.z27();
            }

            break;
          case 2:
            break;
          default:
            noWhenBranchMatchedException();
            break;
        }

        break;
      case 8:
        switch (sign.x2_1) {
          case 0:
            if (decider.equals(SignificantDecider_MORE_THAN_FIVE_getInstance())) {
              result = result.a28();
            }

            break;
          case 1:
            if (!decider.equals(SignificantDecider_LESS_THAN_FIVE_getInstance())) {
              result = result.z27();
            }

            break;
          case 2:
            break;
          default:
            noWhenBranchMatchedException();
            break;
        }

        break;
      case 9:
        if (decider.equals(SignificantDecider_FIVE_getInstance())) {
          if (significand.a27(2).w27().equals(Companion_getInstance_26().j27_1)) {
            switch (sign.x2_1) {
              case 0:
                result = result.a28();
                break;
              case 1:
                result = result.z27();
                break;
              case 2:
                break;
              default:
                noWhenBranchMatchedException();
                break;
            }
          }
        } else if (decider.equals(SignificantDecider_MORE_THAN_FIVE_getInstance())) {
          if (sign.equals(Sign_POSITIVE_getInstance())) {
            result = result.a28();
          }
          if (sign.equals(Sign_NEGATIVE_getInstance())) {
            result = result.z27();
          }
        }

        break;
      case 10:
        if (decider.equals(SignificantDecider_FIVE_getInstance())) {
          if (significand.a27(2).equals(Companion_getInstance_26().i27_1)) {
            switch (sign.x2_1) {
              case 0:
                result = result.a28();
                break;
              case 1:
                result = result.z27();
                break;
              case 2:
                break;
              default:
                noWhenBranchMatchedException();
                break;
            }
          }
        } else if (decider.equals(SignificantDecider_MORE_THAN_FIVE_getInstance())) {
          if (sign.equals(Sign_POSITIVE_getInstance())) {
            result = result.a28();
          }
          if (sign.equals(Sign_NEGATIVE_getInstance())) {
            result = result.z27();
          }
        }

        break;
      case 4:
        throw ArithmeticException_init_$Create$_0('Non-terminating result of division operation. Specify decimalPrecision');
      default:
        noWhenBranchMatchedException();
        break;
    }
    return result;
  }
  function roundSignificand($this, significand, exponent, decimalMode) {
    if (significand.y27()) {
      return new BigDecimal(Companion_getInstance_26().i27_1, exponent, decimalMode);
    }
    var significandDigits = significand.r27();
    var tmp;
    if (decimalMode.g27_1) {
      tmp = add_2(decimalMode.c27_1, decimalMode.e27_1);
    } else {
      tmp = decimalMode.c27_1;
    }
    var desiredPrecision = tmp;
    var tmp_0;
    if (desiredPrecision > significandDigits && !decimalMode.g27_1) {
      var extendedSignificand = significand.s26(Companion_getInstance_26().l27_1.s27(subtract_1(desiredPrecision, significandDigits)));
      tmp_0 = new BigDecimal(extendedSignificand, exponent, decimalMode);
    } else if (desiredPrecision < significandDigits) {
      var divRem = significand.t27(Companion_getInstance_26().l27_1.s27(subtract_1(significandDigits, desiredPrecision)));
      var resolvedRemainder = divRem.v27_1;
      if (divRem.v27_1.equals(Companion_getInstance_26().i27_1)) {
        return new BigDecimal(divRem.u27_1, exponent, decimalMode);
      }
      var tmp_1;
      if (significand.r27() === add_2(divRem.u27_1.r27(), divRem.v27_1.r27())) {
        var newSignificand = roundDiscarded($this, divRem.u27_1, resolvedRemainder, decimalMode);
        var exponentModifier = subtract_1(newSignificand.r27(), divRem.u27_1.r27());
        tmp_1 = new BigDecimal(newSignificand, add_2(exponent, exponentModifier), decimalMode);
      } else {
        tmp_1 = $this.m28(divRem.u27_1, exponent, decimalMode);
      }
      tmp_0 = tmp_1;
    } else {
      tmp_0 = new BigDecimal(significand, exponent, decimalMode);
    }
    return tmp_0;
  }
  function applyScale($this, significand, exponent, decimalMode) {
    if (!decimalMode.g27_1) {
      return new BigDecimal(significand, exponent, decimalMode);
    }
    var tmp;
    if (exponent >= 0n) {
      // Inline function 'kotlin.Long.plus' call
      var this_0 = add_2(exponent, decimalMode.e27_1);
      var tmp$ret$0 = add_2(this_0, fromInt_0(1));
      tmp = new DecimalMode(tmp$ret$0, decimalMode.d27_1);
    } else if (exponent < 0n) {
      // Inline function 'kotlin.Long.plus' call
      var this_1 = decimalMode.e27_1;
      var tmp$ret$1 = add_2(this_1, fromInt_0(1));
      tmp = new DecimalMode(tmp$ret$1, decimalMode.d27_1);
    } else {
      throw RuntimeException_init_$Create$_0('Unexpected state');
    }
    var workMode = tmp;
    var tmp_0;
    if (exponent >= 0n) {
      tmp_0 = roundSignificand($this, significand, exponent, workMode);
    } else {
      var tmp_1;
      if (decimalMode.d27_1.equals(RoundingMode_ROUND_HALF_TO_EVEN_getInstance())) {
        var temp = (new BigDecimal(significand, exponent)).w26(imul(significand.n28(), 2));
        tmp_1 = roundSignificand($this, temp.p28_1, temp.q28_1, workMode).y26(imul(significand.n28(), 2));
      } else {
        var temp_0 = (new BigDecimal(significand, exponent)).w26(significand.n28());
        tmp_1 = roundSignificand($this, temp_0.p28_1, temp_0.q28_1, workMode).y26(significand.n28());
      }
      tmp_0 = tmp_1;
    }
    return tmp_0;
  }
  function resolveDecimalMode($this, firstDecimalMode, secondDecimalMode, suppliedDecimalMode) {
    var tmp;
    if (!(suppliedDecimalMode == null)) {
      tmp = suppliedDecimalMode;
    } else {
      if (firstDecimalMode == null && secondDecimalMode == null) {
        return new DecimalMode();
      }
      if (firstDecimalMode == null && !(secondDecimalMode == null)) {
        return secondDecimalMode;
      }
      if (secondDecimalMode == null && !(firstDecimalMode == null)) {
        return firstDecimalMode;
      }
      if (!ensureNotNull(firstDecimalMode).d27_1.equals(ensureNotNull(secondDecimalMode).d27_1)) {
        throw ArithmeticException_init_$Create$_0('Different rounding modes! This: ' + firstDecimalMode.d27_1.toString() + ' Other: ' + secondDecimalMode.d27_1.toString());
      }
      var tmp_0;
      if (firstDecimalMode.c27_1 >= secondDecimalMode.c27_1) {
        tmp_0 = firstDecimalMode;
      } else {
        tmp_0 = secondDecimalMode;
      }
      var unifiedDecimalMode = tmp_0;
      tmp = unifiedDecimalMode;
    }
    return tmp;
  }
  function SignificantDecider_FIVE_getInstance() {
    SignificantDecider_initEntries();
    return SignificantDecider_FIVE_instance;
  }
  function SignificantDecider_LESS_THAN_FIVE_getInstance() {
    SignificantDecider_initEntries();
    return SignificantDecider_LESS_THAN_FIVE_instance;
  }
  function SignificantDecider_MORE_THAN_FIVE_getInstance() {
    SignificantDecider_initEntries();
    return SignificantDecider_MORE_THAN_FIVE_instance;
  }
  var ScaleOps_Max_instance;
  var ScaleOps_Min_instance;
  var ScaleOps_Add_instance;
  var ScaleOps_entriesInitialized;
  function ScaleOps_initEntries() {
    if (ScaleOps_entriesInitialized)
      return Unit_instance;
    ScaleOps_entriesInitialized = true;
    ScaleOps_Max_instance = new ScaleOps('Max', 0);
    ScaleOps_Min_instance = new ScaleOps('Min', 1);
    ScaleOps_Add_instance = new ScaleOps('Add', 2);
  }
  function Companion_24() {
    Companion_instance_24 = this;
    this.b28_1 = new BigDecimal(Companion_getInstance_26().i27_1);
    this.c28_1 = new BigDecimal(Companion_getInstance_26().j27_1);
    this.d28_1 = new BigDecimal(Companion_getInstance_26().k27_1);
    this.e28_1 = new BigDecimal(Companion_getInstance_26().l27_1, 1n);
    this.f28_1 = false;
    var tmp = this;
    // Inline function 'kotlin.doubleArrayOf' call
    tmp.g28_1 = new Float64Array([1.0, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, 1.0E7, 1.0E8, 1.0E9, 1.0E10, 1.0E11, 1.0E12, 1.0E13, 1.0E14, 1.0E15, 1.0E16, 1.0E17, 1.0E18, 1.0E19, 1.0E20, 1.0E21, 1.0E22]);
    this.h28_1 = this.w28(1.7976931348623157E308);
    this.i28_1 = this.w28(4.9E-324);
    var tmp_0 = this;
    // Inline function 'kotlin.floatArrayOf' call
    tmp_0.j28_1 = new Float32Array([1.0, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, 1.0E7, 1.0E8, 1.0E9, 1.0E10]);
    this.k28_1 = this.x28(3.4028235E38);
    this.l28_1 = this.x28(1.4E-45);
  }
  protoOf(Companion_24).m28 = function (significand, exponent, decimalMode) {
    var tmp;
    if (significand.o27_1.equals(Sign_POSITIVE_getInstance())) {
      var tmp_0;
      switch (decimalMode.d27_1.x2_1) {
        case 1:
        case 2:
          var increasedSignificand = significand.a28();
          var exponentModifier = subtract_1(increasedSignificand.r27(), significand.r27());
          tmp_0 = new BigDecimal(increasedSignificand, add_2(exponent, exponentModifier), decimalMode);
          break;
        default:
          tmp_0 = new BigDecimal(significand, exponent, decimalMode);
          break;
      }
      tmp = tmp_0;
    } else if (significand.o27_1.equals(Sign_NEGATIVE_getInstance())) {
      var tmp_1;
      switch (decimalMode.d27_1.x2_1) {
        case 0:
        case 2:
          var increasedSignificand_0 = significand.z27();
          var exponentModifier_0 = subtract_1(increasedSignificand_0.r27(), significand.r27());
          tmp_1 = new BigDecimal(increasedSignificand_0, add_2(exponent, exponentModifier_0), decimalMode);
          break;
        default:
          tmp_1 = new BigDecimal(significand, exponent, decimalMode);
          break;
      }
      tmp = tmp_1;
    } else {
      tmp = new BigDecimal(significand, exponent, decimalMode);
    }
    return tmp;
  };
  protoOf(Companion_24).y28 = function (long, decimalMode) {
    var bigint = Companion_getInstance_26().z28(long);
    // Inline function 'kotlin.Long.minus' call
    var this_0 = bigint.r27();
    var tmp$ret$0 = subtract_1(this_0, fromInt_0(1));
    return (new BigDecimal(bigint, tmp$ret$0, decimalMode)).a29(decimalMode);
  };
  protoOf(Companion_24).b29 = function (int, decimalMode) {
    var bigint = Companion_getInstance_26().h26(int);
    // Inline function 'kotlin.Long.minus' call
    var this_0 = bigint.r27();
    var tmp$ret$0 = subtract_1(this_0, fromInt_0(1));
    return (new BigDecimal(bigint, tmp$ret$0, decimalMode)).a29(decimalMode);
  };
  protoOf(Companion_24).c29 = function (short, decimalMode) {
    var bigint = Companion_getInstance_26().d29(short);
    // Inline function 'kotlin.Long.minus' call
    var this_0 = bigint.r27();
    var tmp$ret$0 = subtract_1(this_0, fromInt_0(1));
    return (new BigDecimal(bigint, tmp$ret$0, decimalMode)).a29(decimalMode);
  };
  protoOf(Companion_24).e29 = function (byte, decimalMode) {
    var bigint = Companion_getInstance_26().f29(byte);
    // Inline function 'kotlin.Long.minus' call
    var this_0 = bigint.r27();
    var tmp$ret$0 = subtract_1(this_0, fromInt_0(1));
    return (new BigDecimal(bigint, tmp$ret$0, decimalMode)).a29(decimalMode);
  };
  protoOf(Companion_24).g29 = function (float, decimalMode) {
    var floatString = float.toString();
    var tmp;
    if (contains_9(floatString, _Char___init__impl__6a9atx(46)) && !contains_9(floatString, _Char___init__impl__6a9atx(69), true)) {
      var tmp$ret$1;
      $l$block: {
        // Inline function 'kotlin.text.dropLastWhile' call
        var inductionVariable = get_lastIndex_3(floatString);
        if (0 <= inductionVariable)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + -1 | 0;
            if (!(charCodeAt(floatString, index) === _Char___init__impl__6a9atx(48))) {
              tmp$ret$1 = substring(floatString, 0, index + 1 | 0);
              break $l$block;
            }
          }
           while (0 <= inductionVariable);
        tmp$ret$1 = '';
      }
      tmp = this.h29(tmp$ret$1, decimalMode).a29(decimalMode);
    } else {
      tmp = this.h29(floatString, decimalMode).a29(decimalMode);
    }
    return tmp;
  };
  protoOf(Companion_24).x28 = function (float, decimalMode, $super) {
    decimalMode = decimalMode === VOID ? null : decimalMode;
    return $super === VOID ? this.g29(float, decimalMode) : $super.g29.call(this, float, decimalMode);
  };
  protoOf(Companion_24).i29 = function (double, decimalMode) {
    var doubleString = double.toString();
    var tmp;
    if (contains_9(doubleString, _Char___init__impl__6a9atx(46)) && !contains_9(doubleString, _Char___init__impl__6a9atx(69), true)) {
      var tmp$ret$1;
      $l$block: {
        // Inline function 'kotlin.text.dropLastWhile' call
        var inductionVariable = get_lastIndex_3(doubleString);
        if (0 <= inductionVariable)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + -1 | 0;
            if (!(charCodeAt(doubleString, index) === _Char___init__impl__6a9atx(48))) {
              tmp$ret$1 = substring(doubleString, 0, index + 1 | 0);
              break $l$block;
            }
          }
           while (0 <= inductionVariable);
        tmp$ret$1 = '';
      }
      tmp = this.h29(tmp$ret$1, decimalMode).a29(decimalMode);
    } else {
      tmp = this.h29(doubleString, decimalMode).a29(decimalMode).a29(decimalMode);
    }
    return tmp;
  };
  protoOf(Companion_24).w28 = function (double, decimalMode, $super) {
    decimalMode = decimalMode === VOID ? null : decimalMode;
    return $super === VOID ? this.i29(double, decimalMode) : $super.i29.call(this, double, decimalMode);
  };
  protoOf(Companion_24).z28 = function (long) {
    return this.y28(long, null);
  };
  protoOf(Companion_24).h26 = function (int) {
    return this.b29(int, null);
  };
  protoOf(Companion_24).d29 = function (short) {
    return this.c29(short, null);
  };
  protoOf(Companion_24).f29 = function (byte) {
    return this.e29(byte, null);
  };
  protoOf(Companion_24).i26 = function (float, exactRequired) {
    return this.g29(float, null);
  };
  protoOf(Companion_24).k26 = function (double, exactRequired) {
    return this.i29(double, null);
  };
  protoOf(Companion_24).f26 = function (string, base) {
    return this.h29(string, null);
  };
  protoOf(Companion_24).j29 = function (string) {
    return this.k29(string);
  };
  protoOf(Companion_24).h29 = function (floatingPointString, decimalMode) {
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(floatingPointString) === 0) {
      throw ArithmeticException_init_$Create$_0('Empty string is not a valid decimal number');
    }
    if (contains_9(floatingPointString, _Char___init__impl__6a9atx(69), true)) {
      var tmp;
      if (!contains_9(floatingPointString, _Char___init__impl__6a9atx(46))) {
        var splitAroundE = split(floatingPointString, charArrayOf([_Char___init__impl__6a9atx(69), _Char___init__impl__6a9atx(101)]));
        tmp = listOf_0([splitAroundE.r(0), '0E' + splitAroundE.r(1)]);
      } else {
        tmp = split(floatingPointString, charArrayOf([_Char___init__impl__6a9atx(46)]));
      }
      var split_0 = tmp;
      if (split_0.p() === 2) {
        var signPresent = charCodeAt(floatingPointString, 0) === _Char___init__impl__6a9atx(45) || charCodeAt(floatingPointString, 0) === _Char___init__impl__6a9atx(43);
        var tmp_0;
        if (signPresent) {
          tmp_0 = 1;
        } else {
          tmp_0 = 0;
        }
        var leftStart = tmp_0;
        var tmp_1;
        if (signPresent) {
          var tmp_2;
          if (charCodeAt(floatingPointString, 0) === _Char___init__impl__6a9atx(45)) {
            tmp_2 = Sign_NEGATIVE_getInstance();
          } else {
            tmp_2 = Sign_POSITIVE_getInstance();
          }
          tmp_1 = tmp_2;
        } else {
          tmp_1 = Sign_POSITIVE_getInstance();
        }
        var sign = tmp_1;
        var left = substring_0(split_0.r(0), leftStart);
        var rightSplit = split(split_0.r(1), charArrayOf([_Char___init__impl__6a9atx(69), _Char___init__impl__6a9atx(101)]));
        var right = rightSplit.r(0);
        var exponentSplit = rightSplit.r(1);
        var exponentSignPresent = charCodeAt(exponentSplit, 0) === _Char___init__impl__6a9atx(45) || charCodeAt(exponentSplit, 0) === _Char___init__impl__6a9atx(43);
        var tmp_3;
        if (charCodeAt(exponentSplit, 0) === _Char___init__impl__6a9atx(45)) {
          tmp_3 = Sign_NEGATIVE_getInstance();
        } else {
          tmp_3 = Sign_POSITIVE_getInstance();
        }
        var exponentSign = tmp_3;
        var tmp_4;
        if (exponentSignPresent) {
          tmp_4 = 1;
        } else {
          tmp_4 = 0;
        }
        var skipSignIfPresent = tmp_4;
        var exponentString = substring_0(exponentSplit, skipSignIfPresent);
        var tmp_5;
        if (exponentSign.equals(Sign_POSITIVE_getInstance())) {
          tmp_5 = toLong_0(exponentString, 10);
        } else {
          // Inline function 'kotlin.Long.times' call
          var this_0 = toLong_0(exponentString, 10);
          tmp_5 = multiply_0(this_0, fromInt_0(-1));
        }
        var exponent = tmp_5;
        var tmp$ret$3;
        $l$block: {
          // Inline function 'kotlin.text.indexOfFirst' call
          var inductionVariable = 0;
          var last = charSequenceLength(left) - 1 | 0;
          if (inductionVariable <= last)
            do {
              var index = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              if (!(charSequenceGet(left, index) === _Char___init__impl__6a9atx(48))) {
                tmp$ret$3 = index;
                break $l$block;
              }
            }
             while (inductionVariable <= last);
          tmp$ret$3 = -1;
        }
        var leftFirstNonZero = tmp$ret$3;
        if (leftFirstNonZero === -1) {
          leftFirstNonZero = 0;
        }
        var tmp$ret$5;
        $l$block_0: {
          // Inline function 'kotlin.text.indexOfLast' call
          var inductionVariable_0 = charSequenceLength(right) - 1 | 0;
          if (0 <= inductionVariable_0)
            do {
              var index_0 = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + -1 | 0;
              if (!(charSequenceGet(right, index_0) === _Char___init__impl__6a9atx(48))) {
                tmp$ret$5 = index_0;
                break $l$block_0;
              }
            }
             while (0 <= inductionVariable_0);
          tmp$ret$5 = -1;
        }
        var rightLastNonZero = tmp$ret$5;
        if (rightLastNonZero === -1) {
          rightLastNonZero = right.length - 1 | 0;
        }
        var leftTruncated = substring(left, leftFirstNonZero, left.length);
        var rightTruncated = substring(right, 0, rightLastNonZero + 1 | 0);
        var significand = Companion_getInstance_26().f26(leftTruncated + rightTruncated, 10);
        if (significand.equals(Companion_getInstance_26().i27_1)) {
          sign = Sign_ZERO_getInstance();
        }
        if (sign.equals(Sign_NEGATIVE_getInstance())) {
          significand = significand.l29();
        }
        var tmp_6;
        if (!(leftTruncated === '0')) {
          // Inline function 'kotlin.Long.plus' call
          var other = leftTruncated.length;
          // Inline function 'kotlin.Long.minus' call
          var this_1 = add_2(exponent, fromInt_0(other));
          tmp_6 = subtract_1(this_1, fromInt_0(1));
        } else {
          // Inline function 'kotlin.Long.minus' call
          var this_2 = subtract_1(exponent, subtract_1(numberToLong(rightTruncated.length), significand.r27()));
          tmp_6 = subtract_1(this_2, fromInt_0(1));
        }
        var exponentModifiedByFloatingPointPosition = tmp_6;
        return new BigDecimal(significand, exponentModifiedByFloatingPointPosition, decimalMode);
      } else
        throw ArithmeticException_init_$Create$_0('Invalid (or unsupported) floating point number format: ' + floatingPointString);
    } else {
      if (contains_9(floatingPointString, _Char___init__impl__6a9atx(46))) {
        var split_1 = split(floatingPointString, charArrayOf([_Char___init__impl__6a9atx(46)]));
        if (split_1.p() === 2) {
          var signPresent_0 = charCodeAt(floatingPointString, 0) === _Char___init__impl__6a9atx(45) || charCodeAt(floatingPointString, 0) === _Char___init__impl__6a9atx(43);
          var tmp_7;
          if (signPresent_0) {
            tmp_7 = 1;
          } else {
            tmp_7 = 0;
          }
          var leftStart_0 = tmp_7;
          var tmp_8;
          if (signPresent_0) {
            var tmp_9;
            if (charCodeAt(floatingPointString, 0) === _Char___init__impl__6a9atx(45)) {
              tmp_9 = Sign_NEGATIVE_getInstance();
            } else {
              tmp_9 = Sign_POSITIVE_getInstance();
            }
            tmp_8 = tmp_9;
          } else {
            tmp_8 = Sign_POSITIVE_getInstance();
          }
          var sign_0 = tmp_8;
          var left_0 = substring_0(split_1.r(0), leftStart_0);
          var right_0 = split_1.r(1);
          var tmp$ret$10;
          $l$block_1: {
            // Inline function 'kotlin.text.indexOfFirst' call
            var inductionVariable_1 = 0;
            var last_0 = charSequenceLength(left_0) - 1 | 0;
            if (inductionVariable_1 <= last_0)
              do {
                var index_1 = inductionVariable_1;
                inductionVariable_1 = inductionVariable_1 + 1 | 0;
                if (!(charSequenceGet(left_0, index_1) === _Char___init__impl__6a9atx(48))) {
                  tmp$ret$10 = index_1;
                  break $l$block_1;
                }
              }
               while (inductionVariable_1 <= last_0);
            tmp$ret$10 = -1;
          }
          var leftFirstNonZero_0 = tmp$ret$10;
          if (leftFirstNonZero_0 === -1) {
            leftFirstNonZero_0 = 0;
          }
          var tmp$ret$12;
          $l$block_2: {
            // Inline function 'kotlin.text.indexOfLast' call
            var inductionVariable_2 = charSequenceLength(right_0) - 1 | 0;
            if (0 <= inductionVariable_2)
              do {
                var index_2 = inductionVariable_2;
                inductionVariable_2 = inductionVariable_2 + -1 | 0;
                if (!(charSequenceGet(right_0, index_2) === _Char___init__impl__6a9atx(48))) {
                  tmp$ret$12 = index_2;
                  break $l$block_2;
                }
              }
               while (0 <= inductionVariable_2);
            tmp$ret$12 = -1;
          }
          var rightLastNonZero_0 = tmp$ret$12;
          if (rightLastNonZero_0 === -1) {
            rightLastNonZero_0 = right_0.length - 1 | 0;
          }
          var leftTruncated_0 = substring(left_0, leftFirstNonZero_0, left_0.length);
          var rightTruncated_0 = substring(right_0, 0, rightLastNonZero_0 + 1 | 0);
          var significand_0 = Companion_getInstance_26().f26(leftTruncated_0 + rightTruncated_0, 10);
          var tmp_10;
          var tmp_11;
          // Inline function 'kotlin.text.isNotEmpty' call
          if (charSequenceLength(leftTruncated_0) > 0) {
            tmp_11 = !(charCodeAt(leftTruncated_0, 0) === _Char___init__impl__6a9atx(48));
          } else {
            tmp_11 = false;
          }
          if (tmp_11) {
            tmp_10 = leftTruncated_0.length - 1 | 0;
          } else {
            var tmp$ret$15;
            $l$block_3: {
              // Inline function 'kotlin.text.indexOfFirst' call
              var inductionVariable_3 = 0;
              var last_1 = charSequenceLength(rightTruncated_0) - 1 | 0;
              if (inductionVariable_3 <= last_1)
                do {
                  var index_3 = inductionVariable_3;
                  inductionVariable_3 = inductionVariable_3 + 1 | 0;
                  if (!(charSequenceGet(rightTruncated_0, index_3) === _Char___init__impl__6a9atx(48))) {
                    tmp$ret$15 = index_3;
                    break $l$block_3;
                  }
                }
                 while (inductionVariable_3 <= last_1);
              tmp$ret$15 = -1;
            }
            tmp_10 = imul(tmp$ret$15 + 1 | 0, -1);
          }
          var exponent_0 = tmp_10;
          if (significand_0.equals(Companion_getInstance_26().i27_1)) {
            sign_0 = Sign_ZERO_getInstance();
          }
          if (sign_0.equals(Sign_NEGATIVE_getInstance())) {
            significand_0 = significand_0.l29();
          }
          return new BigDecimal(significand_0, fromInt_0(exponent_0), decimalMode);
        } else
          throw ArithmeticException_init_$Create$_0('Invalid (or unsupported) floating point number format: ' + floatingPointString);
      } else {
        var significand_1 = Companion_getInstance_26().f26(floatingPointString, 10);
        // Inline function 'kotlin.Long.minus' call
        var this_3 = significand_1.r27();
        var tmp$ret$16 = subtract_1(this_3, fromInt_0(1));
        return new BigDecimal(significand_1, tmp$ret$16, decimalMode);
      }
    }
  };
  protoOf(Companion_24).k29 = function (floatingPointString, decimalMode, $super) {
    decimalMode = decimalMode === VOID ? null : decimalMode;
    return $super === VOID ? this.h29(floatingPointString, decimalMode) : $super.h29.call(this, floatingPointString, decimalMode);
  };
  var Companion_instance_24;
  function Companion_getInstance_24() {
    if (Companion_instance_24 == null)
      new Companion_24();
    return Companion_instance_24;
  }
  function removeTrailingZeroes($this, bigDecimal) {
    if (bigDecimal.y27())
      return $this;
    var significand = bigDecimal.p28_1;
    var divisionResult = new QuotientAndRemainder(bigDecimal.p28_1, Companion_getInstance_26().i27_1);
    do {
      divisionResult = divisionResult.u27_1.t27(Companion_getInstance_26().l27_1);
      if (divisionResult.v27_1.equals(Companion_getInstance_26().i27_1)) {
        significand = divisionResult.u27_1;
      }
    }
     while (divisionResult.v27_1.equals(Companion_getInstance_26().i27_1));
    return new BigDecimal(significand, bigDecimal.q28_1);
  }
  function ScaleOps(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function computeMode($this, other, op) {
    var tmp;
    if ($this.r28_1 == null || $this.r28_1.f27_1 || other.r28_1 == null || other.r28_1.f27_1) {
      tmp = Companion_getInstance_25().m29_1;
    } else {
      var tmp0 = $this.r28_1.c27_1;
      // Inline function 'kotlin.math.max' call
      var b = other.r28_1.c27_1;
      var tmp_0 = tmp0 >= b ? tmp0 : b;
      var tmp_1;
      if ($this.r28_1.g27_1 && other.r28_1.g27_1) {
        var tmp_2;
        switch (op.x2_1) {
          case 0:
            var tmp0_0 = $this.r28_1.e27_1;
            // Inline function 'kotlin.math.max' call

            var b_0 = other.r28_1.e27_1;
            tmp_2 = tmp0_0 >= b_0 ? tmp0_0 : b_0;
            break;
          case 1:
            var tmp0_1 = $this.r28_1.e27_1;
            // Inline function 'kotlin.math.min' call

            var b_1 = other.r28_1.e27_1;
            tmp_2 = tmp0_1 <= b_1 ? tmp0_1 : b_1;
            break;
          case 2:
            tmp_2 = add_2($this.r28_1.e27_1, other.r28_1.e27_1);
            break;
          default:
            noWhenBranchMatchedException();
            break;
        }
        tmp_1 = tmp_2;
      } else {
        tmp_1 = -1n;
      }
      tmp = new DecimalMode(tmp_0, $this.r28_1.d27_1, tmp_1);
    }
    return tmp;
  }
  function checkWholeness($this, exactRequired) {
    if (exactRequired && !$this.o29())
      throw ArithmeticException_init_$Create$_0('Cannot convert to int and provide exact value');
  }
  function getRidOfRadix($this, bigDecimal) {
    var precision = bigDecimal.p28_1.r27();
    // Inline function 'kotlin.Long.plus' call
    var this_0 = subtract_1(bigDecimal.q28_1, precision);
    var newExponent = add_2(this_0, fromInt_0(1));
    return new BigDecimal(bigDecimal.p28_1, newExponent);
  }
  function bringSignificandToSameExponent($this, first, second) {
    var firstPrepared = getRidOfRadix($this, first);
    var secondPrepared = getRidOfRadix($this, second);
    var firstPreparedExponent = firstPrepared.q28_1;
    var secondPreparedExponent = secondPrepared.q28_1;
    var tmp;
    if (first.q28_1 > second.q28_1) {
      var moveFirstBy = subtract_1(firstPreparedExponent, secondPreparedExponent);
      var tmp_0;
      if (moveFirstBy >= 0n) {
        var movedFirst = firstPrepared.p28_1.s26(toBigInteger(10).s27(moveFirstBy));
        return new Triple(movedFirst, second.p28_1, secondPreparedExponent);
      } else {
        var tmp_1 = toBigInteger(10);
        // Inline function 'kotlin.Long.times' call
        var tmp$ret$0 = multiply_0(moveFirstBy, fromInt_0(-1));
        var movedSecond = secondPrepared.p28_1.s26(tmp_1.s27(tmp$ret$0));
        tmp_0 = new Triple(first.p28_1, movedSecond, firstPreparedExponent);
      }
      tmp = tmp_0;
    } else if (first.q28_1 < second.q28_1) {
      var moveSecondBy = subtract_1(secondPreparedExponent, firstPreparedExponent);
      var tmp_2;
      if (moveSecondBy >= 0n) {
        var movedSecond_0 = secondPrepared.p28_1.s26(toBigInteger(10).s27(moveSecondBy));
        tmp_2 = new Triple(first.p28_1, movedSecond_0, firstPreparedExponent);
      } else {
        var tmp_3 = toBigInteger(10);
        // Inline function 'kotlin.Long.times' call
        var tmp$ret$1 = multiply_0(moveSecondBy, fromInt_0(-1));
        var movedFirst_0 = firstPrepared.p28_1.s26(tmp_3.s27(tmp$ret$1));
        tmp_2 = new Triple(movedFirst_0, second.p28_1, firstPreparedExponent);
      }
      return tmp_2;
    } else if (first.q28_1 === second.q28_1) {
      var delta = subtract_1(firstPreparedExponent, secondPreparedExponent);
      var tmp_4;
      if (delta > 0n) {
        var movedFirst_1 = first.p28_1.s26(toBigInteger(10).s27(delta));
        tmp_4 = new Triple(movedFirst_1, second.p28_1, firstPreparedExponent);
      } else {
        if (delta < 0n) {
          var tmp_5 = toBigInteger(10);
          // Inline function 'kotlin.Long.times' call
          var tmp$ret$2 = multiply_0(delta, fromInt_0(-1));
          var movedSecond_1 = second.p28_1.s26(tmp_5.s27(tmp$ret$2));
          tmp_4 = new Triple(first.p28_1, movedSecond_1, firstPreparedExponent);
        } else {
          // Inline function 'kotlin.Long.compareTo' call
          if (compareTo_0(delta, fromInt_0(0)) === 0) {
            tmp_4 = new Triple(first.p28_1, second.p28_1, firstPreparedExponent);
          } else {
            throw RuntimeException_init_$Create$_0('Invalid delta: ' + delta.toString());
          }
        }
      }
      return tmp_4;
    } else {
      throw RuntimeException_init_$Create$_0('Invalid comparison state BigInteger: ' + first.q28_1.toString() + ', ' + second.q28_1.toString());
    }
    return tmp;
  }
  function javascriptNumberComparison($this, number) {
    var double = numberToDouble(number);
    var tmp;
    if (double > toNumber_0(9223372036854775807n)) {
      tmp = $this.p29(Companion_getInstance_24().j29(double.toString()));
    } else if (double % 1 === 0.0) {
      tmp = $this.p29(Companion_getInstance_24().z28(numberToLong(number)));
    } else {
      tmp = $this.p29(toBigDecimal(numberToDouble(number)));
    }
    return tmp;
  }
  function placeADotInStringExpanded($this, input, position) {
    var prefix = substring_1(input, until(0, input.length - position | 0));
    var tmp0 = substring_1(input, until(input.length - position | 0, input.length));
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.text.dropLastWhile' call
      var inductionVariable = get_lastIndex_3(tmp0);
      if (0 <= inductionVariable)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + -1 | 0;
          if (!(charCodeAt(tmp0, index) === _Char___init__impl__6a9atx(48))) {
            tmp$ret$1 = substring(tmp0, 0, index + 1 | 0);
            break $l$block;
          }
        }
         while (0 <= inductionVariable);
      tmp$ret$1 = '';
    }
    var suffix = tmp$ret$1;
    var tmp;
    // Inline function 'kotlin.text.isNotEmpty' call
    if (charSequenceLength(suffix) > 0) {
      tmp = prefix + '.' + suffix;
    } else {
      tmp = prefix;
    }
    return tmp;
  }
  function placeADotInString($this, input, position) {
    var prefix = substring_1(input, until(0, input.length - position | 0));
    var suffix = substring_1(input, until(input.length - position | 0, input.length));
    var prepared = prefix + '.' + suffix;
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.text.dropLastWhile' call
      var inductionVariable = get_lastIndex_3(prepared);
      if (0 <= inductionVariable)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + -1 | 0;
          if (!(charCodeAt(prepared, index) === _Char___init__impl__6a9atx(48))) {
            tmp$ret$1 = substring(prepared, 0, index + 1 | 0);
            break $l$block;
          }
        }
         while (0 <= inductionVariable);
      tmp$ret$1 = '';
    }
    return tmp$ret$1;
  }
  function ScaleOps_Max_getInstance() {
    ScaleOps_initEntries();
    return ScaleOps_Max_instance;
  }
  function BigDecimal(_significand, _exponent, _decimalMode) {
    Companion_getInstance_24();
    _exponent = _exponent === VOID ? 0n : _exponent;
    _decimalMode = _decimalMode === VOID ? null : _decimalMode;
    if (!(_decimalMode == null) && _decimalMode.g27_1) {
      var wrk = applyScale(Companion_getInstance_24(), _significand, _exponent, _decimalMode);
      if (!wrk.y27()) {
        this.p28_1 = wrk.p28_1;
        this.q28_1 = wrk.q28_1;
        var newPrecision = this.p28_1.r27();
        this.o28_1 = newPrecision;
        this.r28_1 = _decimalMode.q29(newPrecision);
      } else {
        this.p28_1 = wrk.p28_1;
        this.q28_1 = multiply_0(wrk.q28_1, add_2(_decimalMode.c27_1, _decimalMode.e27_1));
        this.o28_1 = add_2(_decimalMode.c27_1, _decimalMode.e27_1);
        this.r28_1 = _decimalMode.q29(this.o28_1);
      }
    } else {
      this.p28_1 = _significand;
      this.o28_1 = _significand.r27();
      this.q28_1 = _exponent;
      this.r28_1 = _decimalMode;
    }
    var tmp = this;
    var tmp0_safe_receiver = this.r28_1;
    var tmp0_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.c27_1;
    tmp.s28_1 = tmp0_elvis_lhs == null ? 0n : tmp0_elvis_lhs;
    var tmp_0 = this;
    var tmp1_safe_receiver = this.r28_1;
    var tmp0_elvis_lhs_0 = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.d27_1;
    tmp_0.t28_1 = tmp0_elvis_lhs_0 == null ? RoundingMode_NONE_getInstance() : tmp0_elvis_lhs_0;
    var tmp_1 = this;
    var tmp13_safe_receiver = this.r28_1;
    var tmp0_elvis_lhs_1 = tmp13_safe_receiver == null ? null : tmp13_safe_receiver.e27_1;
    tmp_1.u28_1 = tmp0_elvis_lhs_1 == null ? -1n : tmp0_elvis_lhs_1;
    this.v28_1 = this.u28_1 >= 0n;
  }
  protoOf(BigDecimal).m26 = function () {
    return Companion_getInstance_24();
  };
  protoOf(BigDecimal).n26 = function () {
    return this;
  };
  protoOf(BigDecimal).r29 = function (other) {
    return this.s29(other, computeMode(this, other, ScaleOps_Max_getInstance()));
  };
  protoOf(BigDecimal).p26 = function (other) {
    return this.r29(other instanceof BigDecimal ? other : THROW_CCE());
  };
  protoOf(BigDecimal).s29 = function (other, decimalMode) {
    var resolvedDecimalMode = resolveDecimalMode(Companion_getInstance_24(), this.r28_1, other.r28_1, decimalMode);
    if (this.y27()) {
      return roundOrDont(Companion_getInstance_24(), other.p28_1, other.q28_1, resolvedDecimalMode);
    }
    if (other.y27()) {
      return roundOrDont(Companion_getInstance_24(), this.p28_1, this.q28_1, resolvedDecimalMode);
    }
    var _destruct__k2r9zo = bringSignificandToSameExponent(this, this, other);
    var first = _destruct__k2r9zo.fg();
    var second = _destruct__k2r9zo.gg();
    var firstNumOfDigits = first.r27();
    var secondNumOfDigits = second.r27();
    var newSignificand = first.o26(second);
    var newSignificandNumOfDigit = newSignificand.r27();
    var tmp;
    if (firstNumOfDigits > secondNumOfDigits) {
      tmp = firstNumOfDigits;
    } else {
      tmp = secondNumOfDigits;
    }
    var largerOperand = tmp;
    var carryDetected = subtract_1(newSignificandNumOfDigit, largerOperand);
    var tmp0 = this.q28_1;
    // Inline function 'kotlin.math.max' call
    var b = other.q28_1;
    var tmp$ret$0 = tmp0 >= b ? tmp0 : b;
    var newExponent = add_2(tmp$ret$0, carryDetected);
    var tmp_0;
    if (resolvedDecimalMode.g27_1) {
      tmp_0 = roundOrDont(Companion_getInstance_24(), newSignificand, newExponent, resolvedDecimalMode.q29(newSignificandNumOfDigit));
    } else {
      tmp_0 = roundOrDont(Companion_getInstance_24(), newSignificand, newExponent, resolvedDecimalMode);
    }
    return tmp_0;
  };
  protoOf(BigDecimal).t29 = function (other) {
    return this.u29(other, computeMode(this, other, ScaleOps_Max_getInstance()));
  };
  protoOf(BigDecimal).r26 = function (other) {
    return this.t29(other instanceof BigDecimal ? other : THROW_CCE());
  };
  protoOf(BigDecimal).u29 = function (other, decimalMode) {
    var resolvedDecimalMode = resolveDecimalMode(Companion_getInstance_24(), this.r28_1, other.r28_1, decimalMode);
    if (this.y27()) {
      return roundOrDont(Companion_getInstance_24(), other.p28_1.l29(), other.q28_1, resolvedDecimalMode);
    }
    if (other.y27()) {
      return roundOrDont(Companion_getInstance_24(), this.p28_1, this.q28_1, resolvedDecimalMode);
    }
    var _destruct__k2r9zo = bringSignificandToSameExponent(this, this, other);
    var first = _destruct__k2r9zo.fg();
    var second = _destruct__k2r9zo.gg();
    var firstNumOfDigits = first.r27();
    var secondNumOfDigits = second.r27();
    var newSignificand = first.q26(second);
    var newSignificandNumOfDigit = newSignificand.r27();
    var tmp;
    if (firstNumOfDigits > secondNumOfDigits) {
      tmp = firstNumOfDigits;
    } else {
      tmp = secondNumOfDigits;
    }
    var largerOperand = tmp;
    var borrowDetected = subtract_1(newSignificandNumOfDigit, largerOperand);
    var tmp0 = this.q28_1;
    // Inline function 'kotlin.math.max' call
    var b = other.q28_1;
    var tmp$ret$0 = tmp0 >= b ? tmp0 : b;
    var newExponent = add_2(tmp$ret$0, borrowDetected);
    if (this.v28_1) {
      return roundOrDont(Companion_getInstance_24(), newSignificand, newExponent, resolvedDecimalMode.q29(newSignificandNumOfDigit));
    } else {
      return roundOrDont(Companion_getInstance_24(), newSignificand, newExponent, resolvedDecimalMode);
    }
  };
  protoOf(BigDecimal).v29 = function (other) {
    return this.w29(other, computeMode(this, other, ScaleOps_Max_getInstance()));
  };
  protoOf(BigDecimal).t26 = function (other) {
    return this.v29(other instanceof BigDecimal ? other : THROW_CCE());
  };
  protoOf(BigDecimal).w29 = function (other, decimalMode) {
    var resolvedDecimalMode = resolveDecimalMode(Companion_getInstance_24(), this.r28_1, other.r28_1, decimalMode);
    var firstNumOfDigits = this.p28_1.r27();
    var secondNumOfDigits = other.p28_1.r27();
    var newSignificand = this.p28_1.s26(other.p28_1);
    var newSignificandNumOfDigit = newSignificand.r27();
    var moveExponent = subtract_1(newSignificandNumOfDigit, add_2(firstNumOfDigits, secondNumOfDigits));
    // Inline function 'kotlin.Long.plus' call
    var this_0 = add_2(add_2(this.q28_1, other.q28_1), moveExponent);
    var newExponent = add_2(this_0, fromInt_0(1));
    var tmp;
    if (resolvedDecimalMode.g27_1) {
      tmp = roundOrDont(Companion_getInstance_24(), newSignificand, newExponent, resolvedDecimalMode.q29(newSignificandNumOfDigit));
    } else {
      tmp = roundOrDont(Companion_getInstance_24(), newSignificand, newExponent, resolvedDecimalMode);
    }
    return tmp;
  };
  protoOf(BigDecimal).x29 = function (other) {
    return this.y29(other, computeMode(this, other, ScaleOps_Max_getInstance()));
  };
  protoOf(BigDecimal).v26 = function (other) {
    return this.x29(other instanceof BigDecimal ? other : THROW_CCE());
  };
  protoOf(BigDecimal).y29 = function (other, decimalMode) {
    var resolvedDecimalMode = resolveDecimalMode(Companion_getInstance_24(), this.r28_1, other.r28_1, decimalMode);
    if (resolvedDecimalMode.f27_1 && !resolvedDecimalMode.g27_1) {
      var newExponent = subtract_1(this.q28_1, other.q28_1);
      // Inline function 'kotlin.Long.times' call
      var this_0 = other.o28_1;
      // Inline function 'kotlin.Long.plus' call
      var this_1 = multiply_0(this_0, fromInt_0(2));
      var power = add_2(this_1, fromInt_0(6));
      var thisPrepared = this.p28_1.s26(Companion_getInstance_26().l27_1.s27(power));
      var divRem = thisPrepared.t27(other.p28_1);
      var result = divRem.u27_1;
      // Inline function 'kotlin.Long.minus' call
      var this_2 = other.o28_1;
      var expectedDiff = subtract_1(this_2, fromInt_0(1));
      var exponentModifier = add_2(expectedDiff, subtract_1(result.r27(), thisPrepared.r27()));
      if (!divRem.v27_1.equals(Companion_getInstance_26().i27_1)) {
        throw ArithmeticException_init_$Create$_0('Non-terminating result of division operation (i.e. 1/3 = 0.3333... library needs to know when to stop and how to round up at that point). Specify decimalPrecision inside your decimal mode.');
      }
      return new BigDecimal(result, add_2(newExponent, exponentModifier), resolvedDecimalMode);
    } else {
      // Inline function 'kotlin.Long.minus' call
      var this_3 = subtract_1(this.q28_1, other.q28_1);
      var newExponent_0 = subtract_1(this_3, fromInt_0(1));
      var desiredPrecision = resolvedDecimalMode.c27_1;
      var power_0 = add_2(subtract_1(desiredPrecision, this.o28_1), other.o28_1);
      var tmp;
      if (power_0 > 0n) {
        tmp = this.p28_1.s26(toBigInteger(10).s27(power_0));
      } else if (power_0 < 0n) {
        var tmp_0 = toBigInteger(10);
        // Inline function 'kotlin.math.absoluteValue' call
        var tmp$ret$4 = abs_1(power_0);
        tmp = this.p28_1.u26(tmp_0.s27(tmp$ret$4));
      } else {
        tmp = this.p28_1;
      }
      var thisPrepared_0 = tmp;
      var divRem_0 = thisPrepared_0.t27(other.p28_1);
      var result_0 = divRem_0.u27_1;
      if (result_0.equals(Companion_getInstance_26().i27_1)) {
        var _unary__edvuaz = newExponent_0;
        newExponent_0 = subtract_1(_unary__edvuaz, get_ONE());
      }
      var exponentModifier_0 = subtract_1(result_0.r27(), resolvedDecimalMode.c27_1);
      var tmp_1;
      if (this.v28_1) {
        tmp_1 = new BigDecimal(roundDiscarded(Companion_getInstance_24(), result_0, divRem_0.v27_1, resolvedDecimalMode), add_2(newExponent_0, exponentModifier_0), resolvedDecimalMode.q29(result_0.r27()));
      } else {
        tmp_1 = new BigDecimal(roundDiscarded(Companion_getInstance_24(), result_0, divRem_0.v27_1, resolvedDecimalMode), add_2(newExponent_0, exponentModifier_0), resolvedDecimalMode);
      }
      return tmp_1;
    }
  };
  protoOf(BigDecimal).z29 = function (other) {
    return this.a2a(other).qg_1;
  };
  protoOf(BigDecimal).b27 = function (other) {
    return this.z29(other instanceof BigDecimal ? other : THROW_CCE());
  };
  protoOf(BigDecimal).a2a = function (other) {
    if (this.q28_1 < 0n) {
      return new Pair(Companion_getInstance_24().b28_1, this);
    }
    if (other.w27().b2a(this.w27()) > 0) {
      return new Pair(Companion_getInstance_24().b28_1, this);
    }
    var tmp16_safe_receiver = this.r28_1;
    var tmp;
    if (tmp16_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.Long.plus' call
      var this_0 = subtract_1(this.q28_1, other.q28_1);
      var tmp$ret$0 = add_2(this_0, fromInt_0(1));
      tmp = tmp16_safe_receiver.q29(tmp$ret$0);
    }
    var tmp0_elvis_lhs = tmp;
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.Long.plus' call
      var this_1 = subtract_1(this.q28_1, other.q28_1);
      var tmp$ret$1 = add_2(this_1, fromInt_0(1));
      tmp_0 = new DecimalMode(tmp$ret$1, RoundingMode_FLOOR_getInstance());
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var resolvedRoundingMode = tmp_0;
    var quotient = this.y29(other, resolvedRoundingMode);
    var quotientInfinitePrecision = quotient.c2a(VOID, VOID, Companion_getInstance_25().m29_1);
    var remainder = this.e2a(quotientInfinitePrecision.d2a(other));
    return new Pair(quotient, remainder);
  };
  protoOf(BigDecimal).y27 = function () {
    return this.p28_1.y27();
  };
  protoOf(BigDecimal).f2a = function (significand, exponent, decimalMode) {
    return new BigDecimal(significand, exponent, decimalMode);
  };
  protoOf(BigDecimal).c2a = function (significand, exponent, decimalMode, $super) {
    significand = significand === VOID ? this.p28_1 : significand;
    exponent = exponent === VOID ? this.q28_1 : exponent;
    decimalMode = decimalMode === VOID ? this.r28_1 : decimalMode;
    return $super === VOID ? this.f2a(significand, exponent, decimalMode) : $super.f2a.call(this, significand, exponent, decimalMode);
  };
  protoOf(BigDecimal).g2a = function (places) {
    if (places === 0n) {
      return this;
    }
    return this.c2a(VOID, add_2(this.q28_1, places));
  };
  protoOf(BigDecimal).h2a = function () {
    if (this.q28_1 < 0n) {
      var tmp;
      switch (this.p28_1.o27_1.x2_1) {
        case 0:
          tmp = Companion_getInstance_24().b28_1;
          break;
        case 1:
          tmp = Companion_getInstance_24().c28_1.l29();
          break;
        case 2:
          tmp = Companion_getInstance_24().b28_1;
          break;
        default:
          noWhenBranchMatchedException();
          break;
      }
      return tmp;
    }
    // Inline function 'kotlin.Long.plus' call
    var this_0 = this.q28_1;
    var tmp$ret$0 = add_2(this_0, fromInt_0(1));
    return this.a29(new DecimalMode(tmp$ret$0, RoundingMode_FLOOR_getInstance()));
  };
  protoOf(BigDecimal).i2a = function () {
    if (this.q28_1 < 0n) {
      return Companion_getInstance_26().i27_1;
    }
    var precisionExponentDiff = subtract_1(this.q28_1, this.o28_1);
    var tmp;
    if (precisionExponentDiff > 0n) {
      var tmp_0 = toBigInteger(10);
      // Inline function 'kotlin.Long.plus' call
      var tmp$ret$0 = add_2(precisionExponentDiff, fromInt_0(1));
      tmp = this.p28_1.s26(tmp_0.s27(tmp$ret$0));
    } else if (precisionExponentDiff < 0n) {
      var tmp_1 = toBigInteger(10);
      // Inline function 'kotlin.math.absoluteValue' call
      // Inline function 'kotlin.Long.minus' call
      var this_0 = abs_1(precisionExponentDiff);
      var tmp$ret$2 = subtract_1(this_0, fromInt_0(1));
      tmp = this.p28_1.u26(tmp_1.s27(tmp$ret$2));
    } else {
      tmp = this.p28_1.x26(10);
    }
    return tmp;
  };
  protoOf(BigDecimal).j2a = function (other) {
    return this.a2a(other);
  };
  protoOf(BigDecimal).e2a = function (other) {
    return this.u29(other, computeMode(this, other, ScaleOps_Max_getInstance()));
  };
  protoOf(BigDecimal).d2a = function (other) {
    return this.w29(other, computeMode(this, other, ScaleOps_Max_getInstance()));
  };
  protoOf(BigDecimal).w27 = function () {
    return new BigDecimal(this.p28_1.w27(), this.q28_1, this.r28_1);
  };
  protoOf(BigDecimal).l29 = function () {
    return new BigDecimal(this.p28_1.l29(), this.q28_1, this.r28_1);
  };
  protoOf(BigDecimal).x27 = function (exactRequired) {
    checkWholeness(this, exactRequired);
    return this.i2a().x27(exactRequired);
  };
  protoOf(BigDecimal).o29 = function () {
    var res = this.w27().j2a(Companion_getInstance_24().c28_1);
    var isWholeNumber = res.qg_1.y27();
    return isWholeNumber;
  };
  protoOf(BigDecimal).a29 = function (decimalMode) {
    if (decimalMode == null) {
      return this;
    }
    return roundSignificand(Companion_getInstance_24(), this.p28_1, this.q28_1, decimalMode);
  };
  protoOf(BigDecimal).p29 = function (other) {
    var tmp;
    if (this.q28_1 === other.q28_1 && this.o28_1 === other.o28_1) {
      tmp = this.p28_1.k2a(other.p28_1);
    } else {
      var _destruct__k2r9zo = bringSignificandToSameExponent(this, this, other);
      var preparedFirst = _destruct__k2r9zo.fg();
      var preparedSecond = _destruct__k2r9zo.gg();
      tmp = preparedFirst.k2a(preparedSecond);
    }
    return tmp;
  };
  protoOf(BigDecimal).b2a = function (other) {
    if (isNumber(other)) {
      if (RuntimePlatform_instance.l2a().equals(Platform_JS_getInstance()) || RuntimePlatform_instance.l2a().equals(Platform_WASMJS_getInstance())) {
        return javascriptNumberComparison(this, other);
      }
    }
    var tmp;
    if (other instanceof BigDecimal) {
      tmp = this.p29(other);
    } else {
      if (typeof other === 'bigint') {
        tmp = this.p29(Companion_getInstance_24().z28(other));
      } else {
        if (typeof other === 'number') {
          tmp = this.p29(Companion_getInstance_24().h26(other));
        } else {
          if (typeof other === 'number') {
            tmp = this.p29(Companion_getInstance_24().d29(other));
          } else {
            if (typeof other === 'number') {
              tmp = this.p29(Companion_getInstance_24().f29(other));
            } else {
              if (typeof other === 'number') {
                tmp = this.p29(Companion_getInstance_24().w28(other));
              } else {
                if (typeof other === 'number') {
                  tmp = this.p29(Companion_getInstance_24().x28(other));
                } else {
                  throw RuntimeException_init_$Create$_0('Invalid comparison type for BigDecimal: ' + getKClassFromExpression(other).ra());
                }
              }
            }
          }
        }
      }
    }
    return tmp;
  };
  protoOf(BigDecimal).d = function (other) {
    return this.b2a(!(other == null) ? other : THROW_CCE());
  };
  protoOf(BigDecimal).equals = function (other) {
    var tmp;
    if (other instanceof BigDecimal) {
      tmp = this.p29(other);
    } else {
      if (!(other == null) ? typeof other === 'bigint' : false) {
        tmp = this.p29(Companion_getInstance_24().z28(other));
      } else {
        if (!(other == null) ? typeof other === 'number' : false) {
          tmp = this.p29(Companion_getInstance_24().h26(other));
        } else {
          if (!(other == null) ? typeof other === 'number' : false) {
            tmp = this.p29(Companion_getInstance_24().d29(other));
          } else {
            if (!(other == null) ? typeof other === 'number' : false) {
              tmp = this.p29(Companion_getInstance_24().f29(other));
            } else {
              if (!(other == null) ? typeof other === 'number' : false) {
                tmp = this.p29(Companion_getInstance_24().w28(other));
              } else {
                if (!(other == null) ? typeof other === 'number' : false) {
                  tmp = this.p29(Companion_getInstance_24().x28(other));
                } else {
                  tmp = -1;
                }
              }
            }
          }
        }
      }
    }
    var comparison = tmp;
    return comparison === 0;
  };
  protoOf(BigDecimal).hashCode = function () {
    if (this.y27()) {
      return 0;
    }
    return removeTrailingZeroes(this, this).p28_1.hashCode() + getBigIntHashCode(this.q28_1) | 0;
  };
  protoOf(BigDecimal).toString = function () {
    if (Companion_getInstance_24().f28_1) {
      return this.m2a();
    }
    var significandString = this.p28_1.n2a(10);
    var tmp;
    if (this.p28_1.b2a(0) < 0) {
      tmp = 2;
    } else {
      tmp = 1;
    }
    var modifier = tmp;
    var tmp_0;
    var tmp0 = this.p28_1.toString();
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.text.dropLastWhile' call
      var inductionVariable = get_lastIndex_3(tmp0);
      if (0 <= inductionVariable)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + -1 | 0;
          if (!(charCodeAt(tmp0, index) === _Char___init__impl__6a9atx(48))) {
            tmp$ret$1 = substring(tmp0, 0, index + 1 | 0);
            break $l$block;
          }
        }
         while (0 <= inductionVariable);
      tmp$ret$1 = '';
    }
    if (tmp$ret$1.length <= 1) {
      tmp_0 = '0';
    } else {
      tmp_0 = '';
    }
    var expand = tmp_0;
    var tmp_1;
    if (this.q28_1 > 0n) {
      tmp_1 = placeADotInString(this, significandString, significandString.length - modifier | 0) + expand + 'E+' + this.q28_1.toString();
    } else if (this.q28_1 < 0n) {
      tmp_1 = placeADotInString(this, significandString, significandString.length - modifier | 0) + expand + 'E' + this.q28_1.toString();
    } else if (this.q28_1 === 0n) {
      tmp_1 = placeADotInString(this, significandString, significandString.length - modifier | 0) + expand;
    } else {
      throw RuntimeException_init_$Create$_0('Invalid state, please report a bug (Integer compareTo invalid)');
    }
    return tmp_1;
  };
  protoOf(BigDecimal).m2a = function () {
    if (this.y27()) {
      return '0';
    }
    var digits = this.p28_1.r27();
    if (this.q28_1 > 2147483647n) {
      throw RuntimeException_init_$Create$_0('Invalid toStringExpanded request (exponent > Int.MAX_VALUE)');
    }
    var significandString = this.p28_1.o2a(10);
    var tmp;
    if (this.p28_1.o27_1.equals(Sign_NEGATIVE_getInstance())) {
      tmp = '-';
    } else {
      tmp = '';
    }
    var sign = tmp;
    var tmp_0;
    if (this.q28_1 > 0n) {
      // Inline function 'kotlin.Long.plus' call
      var this_0 = subtract_1(this.q28_1, digits);
      var diffBigInt = add_2(this_0, fromInt_0(1));
      var tmp_1;
      if (diffBigInt > 0n) {
        var expandZeros = this.p2a(diffBigInt, _Char___init__impl__6a9atx(48));
        tmp_1 = significandString + expandZeros;
      } else {
        tmp_1 = placeADotInStringExpanded(this, significandString, (significandString.length - convertToInt(this.q28_1) | 0) - 1 | 0);
      }
      tmp_0 = tmp_1;
    } else if (this.q28_1 < 0n) {
      // Inline function 'kotlin.math.absoluteValue' call
      var this_1 = convertToInt(this.q28_1);
      var diffInt = abs_0(this_1);
      var tmp_2;
      if (diffInt > 0) {
        // Inline function 'kotlin.math.absoluteValue' call
        var this_2 = this.q28_1;
        var tmp$ret$2 = abs_1(this_2);
        var expandZeros_0 = this.p2a(tmp$ret$2, _Char___init__impl__6a9atx(48));
        tmp_2 = placeADotInStringExpanded(this, expandZeros_0 + significandString, (diffInt + significandString.length | 0) - 1 | 0);
      } else {
        tmp_2 = placeADotInStringExpanded(this, significandString, significandString.length - 1 | 0);
      }
      tmp_0 = tmp_2;
    } else if (this.q28_1 === 0n) {
      if (digits === 1n) {
        return sign + significandString;
      }
      tmp_0 = placeADotInStringExpanded(this, significandString, significandString.length - 1 | 0);
    } else {
      throw RuntimeException_init_$Create$_0('Invalid state, please report a bug (Integer compareTo invalid)');
    }
    var adjusted = tmp_0;
    return sign + adjusted;
  };
  protoOf(BigDecimal).p2a = function (_this__u8e3s4, char) {
    if (_this__u8e3s4 < 0n) {
      throw RuntimeException_init_$Create$_0('Char cannot be multiplied with negative number');
    }
    var counter = _this__u8e3s4;
    var stringBuilder = StringBuilder_init_$Create$_1();
    while (counter > 0n) {
      stringBuilder.k8(char);
      var _unary__edvuaz = counter;
      counter = subtract_1(_unary__edvuaz, get_ONE());
    }
    return stringBuilder.toString();
  };
  function toBigDecimal(_this__u8e3s4, exponentModifier, decimalMode) {
    exponentModifier = exponentModifier === VOID ? null : exponentModifier;
    decimalMode = decimalMode === VOID ? null : decimalMode;
    var tmp = Companion_getInstance_24().i29(_this__u8e3s4, decimalMode);
    return tmp.g2a(exponentModifier == null ? 0n : exponentModifier);
  }
  function Companion_25() {
    Companion_instance_25 = this;
    this.m29_1 = new DecimalMode();
    this.n29_1 = new DecimalMode(30n, RoundingMode_ROUND_HALF_AWAY_FROM_ZERO_getInstance(), 2n);
  }
  var Companion_instance_25;
  function Companion_getInstance_25() {
    if (Companion_instance_25 == null)
      new Companion_25();
    return Companion_instance_25;
  }
  function DecimalMode(decimalPrecision, roundingMode, scale) {
    Companion_getInstance_25();
    decimalPrecision = decimalPrecision === VOID ? 0n : decimalPrecision;
    roundingMode = roundingMode === VOID ? RoundingMode_NONE_getInstance() : roundingMode;
    scale = scale === VOID ? -1n : scale;
    this.c27_1 = decimalPrecision;
    this.d27_1 = roundingMode;
    this.e27_1 = scale;
    if (this.c27_1 < 0n) {
      throw ArithmeticException_init_$Create$_0('Negative decimal precision is not allowed.');
    }
    this.f27_1 = this.c27_1 === 0n;
    this.g27_1 = this.e27_1 >= 0n;
    if (!this.g27_1 && this.c27_1 === 0n && !this.d27_1.equals(RoundingMode_NONE_getInstance())) {
      throw ArithmeticException_init_$Create$_0('Rounding mode with 0 digits precision.');
    }
    if (this.e27_1 < -1n) {
      throw ArithmeticException_init_$Create$_0('Negative Scale is unsupported.');
    }
    if (this.g27_1 && this.d27_1.equals(RoundingMode_NONE_getInstance())) {
      throw ArithmeticException_init_$Create$_0('Scale of ' + this.e27_1.toString() + ' digits to the right of the decimal requires a RoundingMode that is not NONE.');
    }
  }
  protoOf(DecimalMode).q2a = function (decimalPrecision, roundingMode, scale) {
    return new DecimalMode(decimalPrecision, roundingMode, scale);
  };
  protoOf(DecimalMode).q29 = function (decimalPrecision, roundingMode, scale, $super) {
    decimalPrecision = decimalPrecision === VOID ? this.c27_1 : decimalPrecision;
    roundingMode = roundingMode === VOID ? this.d27_1 : roundingMode;
    scale = scale === VOID ? this.e27_1 : scale;
    return $super === VOID ? this.q2a(decimalPrecision, roundingMode, scale) : $super.q2a.call(this, decimalPrecision, roundingMode, scale);
  };
  protoOf(DecimalMode).toString = function () {
    return 'DecimalMode(decimalPrecision=' + this.c27_1.toString() + ', roundingMode=' + this.d27_1.toString() + ', scale=' + this.e27_1.toString() + ')';
  };
  protoOf(DecimalMode).hashCode = function () {
    var result = getBigIntHashCode(this.c27_1);
    result = imul(result, 31) + this.d27_1.hashCode() | 0;
    result = imul(result, 31) + getBigIntHashCode(this.e27_1) | 0;
    return result;
  };
  protoOf(DecimalMode).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof DecimalMode))
      return false;
    var tmp0_other_with_cast = other instanceof DecimalMode ? other : THROW_CCE();
    if (!(this.c27_1 === tmp0_other_with_cast.c27_1))
      return false;
    if (!this.d27_1.equals(tmp0_other_with_cast.d27_1))
      return false;
    if (!(this.e27_1 === tmp0_other_with_cast.e27_1))
      return false;
    return true;
  };
  var RoundingMode_FLOOR_instance;
  var RoundingMode_CEILING_instance;
  var RoundingMode_AWAY_FROM_ZERO_instance;
  var RoundingMode_TOWARDS_ZERO_instance;
  var RoundingMode_NONE_instance;
  var RoundingMode_ROUND_HALF_AWAY_FROM_ZERO_instance;
  var RoundingMode_ROUND_HALF_TOWARDS_ZERO_instance;
  var RoundingMode_ROUND_HALF_CEILING_instance;
  var RoundingMode_ROUND_HALF_FLOOR_instance;
  var RoundingMode_ROUND_HALF_TO_EVEN_instance;
  var RoundingMode_ROUND_HALF_TO_ODD_instance;
  var RoundingMode_entriesInitialized;
  function RoundingMode_initEntries() {
    if (RoundingMode_entriesInitialized)
      return Unit_instance;
    RoundingMode_entriesInitialized = true;
    RoundingMode_FLOOR_instance = new RoundingMode('FLOOR', 0);
    RoundingMode_CEILING_instance = new RoundingMode('CEILING', 1);
    RoundingMode_AWAY_FROM_ZERO_instance = new RoundingMode('AWAY_FROM_ZERO', 2);
    RoundingMode_TOWARDS_ZERO_instance = new RoundingMode('TOWARDS_ZERO', 3);
    RoundingMode_NONE_instance = new RoundingMode('NONE', 4);
    RoundingMode_ROUND_HALF_AWAY_FROM_ZERO_instance = new RoundingMode('ROUND_HALF_AWAY_FROM_ZERO', 5);
    RoundingMode_ROUND_HALF_TOWARDS_ZERO_instance = new RoundingMode('ROUND_HALF_TOWARDS_ZERO', 6);
    RoundingMode_ROUND_HALF_CEILING_instance = new RoundingMode('ROUND_HALF_CEILING', 7);
    RoundingMode_ROUND_HALF_FLOOR_instance = new RoundingMode('ROUND_HALF_FLOOR', 8);
    RoundingMode_ROUND_HALF_TO_EVEN_instance = new RoundingMode('ROUND_HALF_TO_EVEN', 9);
    RoundingMode_ROUND_HALF_TO_ODD_instance = new RoundingMode('ROUND_HALF_TO_ODD', 10);
  }
  function RoundingMode(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function RoundingMode_FLOOR_getInstance() {
    RoundingMode_initEntries();
    return RoundingMode_FLOOR_instance;
  }
  function RoundingMode_AWAY_FROM_ZERO_getInstance() {
    RoundingMode_initEntries();
    return RoundingMode_AWAY_FROM_ZERO_instance;
  }
  function RoundingMode_TOWARDS_ZERO_getInstance() {
    RoundingMode_initEntries();
    return RoundingMode_TOWARDS_ZERO_instance;
  }
  function RoundingMode_NONE_getInstance() {
    RoundingMode_initEntries();
    return RoundingMode_NONE_instance;
  }
  function RoundingMode_ROUND_HALF_AWAY_FROM_ZERO_getInstance() {
    RoundingMode_initEntries();
    return RoundingMode_ROUND_HALF_AWAY_FROM_ZERO_instance;
  }
  function RoundingMode_ROUND_HALF_TO_EVEN_getInstance() {
    RoundingMode_initEntries();
    return RoundingMode_ROUND_HALF_TO_EVEN_instance;
  }
  function BigInteger_init_$Init$(long, $this) {
    var tmp = Companion_getInstance_26().h27_1.r2a(long);
    // Inline function 'com.ionspin.kotlin.bignum.integer.Companion.determinSignFromNumber' call
    Companion_getInstance_26();
    var tmp22_subject = PrimitiveClasses_getInstance().pb();
    var tmp_0;
    if (tmp22_subject.equals(PrimitiveClasses_getInstance().pb())) {
      if (typeof long !== 'bigint')
        THROW_CCE();
      var tmp_1;
      // Inline function 'kotlin.Long.compareTo' call
      if (compareTo_0(long, fromInt_0(0)) < 0) {
        tmp_1 = Sign_NEGATIVE_getInstance();
      } else {
        // Inline function 'kotlin.Long.compareTo' call
        if (compareTo_0(long, fromInt_0(0)) > 0) {
          tmp_1 = Sign_POSITIVE_getInstance();
        } else {
          tmp_1 = Sign_ZERO_getInstance();
        }
      }
      tmp_0 = tmp_1;
    } else if (tmp22_subject.equals(PrimitiveClasses_getInstance().ob())) {
      if (typeof long !== 'number')
        THROW_CCE();
      tmp_0 = compareTo_0(long, 0) < 0 ? Sign_NEGATIVE_getInstance() : compareTo_0(long, 0) > 0 ? Sign_POSITIVE_getInstance() : Sign_ZERO_getInstance();
    } else if (tmp22_subject.equals(PrimitiveClasses_getInstance().nb())) {
      if (typeof long !== 'number')
        THROW_CCE();
      tmp_0 = compareTo_0(long, 0) < 0 ? Sign_NEGATIVE_getInstance() : compareTo_0(long, 0) > 0 ? Sign_POSITIVE_getInstance() : Sign_ZERO_getInstance();
    } else if (tmp22_subject.equals(PrimitiveClasses_getInstance().mb())) {
      if (typeof long !== 'number')
        THROW_CCE();
      tmp_0 = compareTo_0(long, 0) < 0 ? Sign_NEGATIVE_getInstance() : compareTo_0(long, 0) > 0 ? Sign_POSITIVE_getInstance() : Sign_ZERO_getInstance();
    } else {
      throw RuntimeException_init_$Create$_0('Unsupported type ' + toString_1(PrimitiveClasses_getInstance().pb()));
    }
    var tmp$ret$2 = tmp_0;
    BigInteger.call($this, tmp, tmp$ret$2);
    return $this;
  }
  function BigInteger_init_$Create$(long) {
    return BigInteger_init_$Init$(long, objectCreate(protoOf(BigInteger)));
  }
  function BigInteger_init_$Init$_0(int, $this) {
    var tmp = Companion_getInstance_26().h27_1.s2a(int);
    // Inline function 'com.ionspin.kotlin.bignum.integer.Companion.determinSignFromNumber' call
    Companion_getInstance_26();
    var tmp22_subject = PrimitiveClasses_getInstance().ob();
    var tmp_0;
    if (tmp22_subject.equals(PrimitiveClasses_getInstance().pb())) {
      if (typeof int !== 'bigint')
        THROW_CCE();
      var tmp_1;
      // Inline function 'kotlin.Long.compareTo' call
      if (compareTo_0(int, fromInt_0(0)) < 0) {
        tmp_1 = Sign_NEGATIVE_getInstance();
      } else {
        // Inline function 'kotlin.Long.compareTo' call
        if (compareTo_0(int, fromInt_0(0)) > 0) {
          tmp_1 = Sign_POSITIVE_getInstance();
        } else {
          tmp_1 = Sign_ZERO_getInstance();
        }
      }
      tmp_0 = tmp_1;
    } else if (tmp22_subject.equals(PrimitiveClasses_getInstance().ob())) {
      if (typeof int !== 'number')
        THROW_CCE();
      tmp_0 = compareTo_0(int, 0) < 0 ? Sign_NEGATIVE_getInstance() : compareTo_0(int, 0) > 0 ? Sign_POSITIVE_getInstance() : Sign_ZERO_getInstance();
    } else if (tmp22_subject.equals(PrimitiveClasses_getInstance().nb())) {
      if (typeof int !== 'number')
        THROW_CCE();
      tmp_0 = compareTo_0(int, 0) < 0 ? Sign_NEGATIVE_getInstance() : compareTo_0(int, 0) > 0 ? Sign_POSITIVE_getInstance() : Sign_ZERO_getInstance();
    } else if (tmp22_subject.equals(PrimitiveClasses_getInstance().mb())) {
      if (typeof int !== 'number')
        THROW_CCE();
      tmp_0 = compareTo_0(int, 0) < 0 ? Sign_NEGATIVE_getInstance() : compareTo_0(int, 0) > 0 ? Sign_POSITIVE_getInstance() : Sign_ZERO_getInstance();
    } else {
      throw RuntimeException_init_$Create$_0('Unsupported type ' + toString_1(PrimitiveClasses_getInstance().ob()));
    }
    var tmp$ret$2 = tmp_0;
    BigInteger.call($this, tmp, tmp$ret$2);
    return $this;
  }
  function BigInteger_init_$Create$_0(int) {
    return BigInteger_init_$Init$_0(int, objectCreate(protoOf(BigInteger)));
  }
  function BigInteger_init_$Init$_1(short, $this) {
    var tmp = Companion_getInstance_26().h27_1.t2a(short);
    // Inline function 'com.ionspin.kotlin.bignum.integer.Companion.determinSignFromNumber' call
    Companion_getInstance_26();
    var tmp22_subject = PrimitiveClasses_getInstance().nb();
    var tmp_0;
    if (tmp22_subject.equals(PrimitiveClasses_getInstance().pb())) {
      if (typeof short !== 'bigint')
        THROW_CCE();
      var tmp_1;
      // Inline function 'kotlin.Long.compareTo' call
      if (compareTo_0(short, fromInt_0(0)) < 0) {
        tmp_1 = Sign_NEGATIVE_getInstance();
      } else {
        // Inline function 'kotlin.Long.compareTo' call
        if (compareTo_0(short, fromInt_0(0)) > 0) {
          tmp_1 = Sign_POSITIVE_getInstance();
        } else {
          tmp_1 = Sign_ZERO_getInstance();
        }
      }
      tmp_0 = tmp_1;
    } else if (tmp22_subject.equals(PrimitiveClasses_getInstance().ob())) {
      if (typeof short !== 'number')
        THROW_CCE();
      tmp_0 = compareTo_0(short, 0) < 0 ? Sign_NEGATIVE_getInstance() : compareTo_0(short, 0) > 0 ? Sign_POSITIVE_getInstance() : Sign_ZERO_getInstance();
    } else if (tmp22_subject.equals(PrimitiveClasses_getInstance().nb())) {
      if (typeof short !== 'number')
        THROW_CCE();
      tmp_0 = compareTo_0(short, 0) < 0 ? Sign_NEGATIVE_getInstance() : compareTo_0(short, 0) > 0 ? Sign_POSITIVE_getInstance() : Sign_ZERO_getInstance();
    } else if (tmp22_subject.equals(PrimitiveClasses_getInstance().mb())) {
      if (typeof short !== 'number')
        THROW_CCE();
      tmp_0 = compareTo_0(short, 0) < 0 ? Sign_NEGATIVE_getInstance() : compareTo_0(short, 0) > 0 ? Sign_POSITIVE_getInstance() : Sign_ZERO_getInstance();
    } else {
      throw RuntimeException_init_$Create$_0('Unsupported type ' + toString_1(PrimitiveClasses_getInstance().nb()));
    }
    var tmp$ret$2 = tmp_0;
    BigInteger.call($this, tmp, tmp$ret$2);
    return $this;
  }
  function BigInteger_init_$Create$_1(short) {
    return BigInteger_init_$Init$_1(short, objectCreate(protoOf(BigInteger)));
  }
  function BigInteger_init_$Init$_2(byte, $this) {
    var tmp = Companion_getInstance_26().h27_1.u2a(byte);
    // Inline function 'com.ionspin.kotlin.bignum.integer.Companion.determinSignFromNumber' call
    Companion_getInstance_26();
    var tmp22_subject = PrimitiveClasses_getInstance().mb();
    var tmp_0;
    if (tmp22_subject.equals(PrimitiveClasses_getInstance().pb())) {
      if (typeof byte !== 'bigint')
        THROW_CCE();
      var tmp_1;
      // Inline function 'kotlin.Long.compareTo' call
      if (compareTo_0(byte, fromInt_0(0)) < 0) {
        tmp_1 = Sign_NEGATIVE_getInstance();
      } else {
        // Inline function 'kotlin.Long.compareTo' call
        if (compareTo_0(byte, fromInt_0(0)) > 0) {
          tmp_1 = Sign_POSITIVE_getInstance();
        } else {
          tmp_1 = Sign_ZERO_getInstance();
        }
      }
      tmp_0 = tmp_1;
    } else if (tmp22_subject.equals(PrimitiveClasses_getInstance().ob())) {
      if (typeof byte !== 'number')
        THROW_CCE();
      tmp_0 = compareTo_0(byte, 0) < 0 ? Sign_NEGATIVE_getInstance() : compareTo_0(byte, 0) > 0 ? Sign_POSITIVE_getInstance() : Sign_ZERO_getInstance();
    } else if (tmp22_subject.equals(PrimitiveClasses_getInstance().nb())) {
      if (typeof byte !== 'number')
        THROW_CCE();
      tmp_0 = compareTo_0(byte, 0) < 0 ? Sign_NEGATIVE_getInstance() : compareTo_0(byte, 0) > 0 ? Sign_POSITIVE_getInstance() : Sign_ZERO_getInstance();
    } else if (tmp22_subject.equals(PrimitiveClasses_getInstance().mb())) {
      if (typeof byte !== 'number')
        THROW_CCE();
      tmp_0 = compareTo_0(byte, 0) < 0 ? Sign_NEGATIVE_getInstance() : compareTo_0(byte, 0) > 0 ? Sign_POSITIVE_getInstance() : Sign_ZERO_getInstance();
    } else {
      throw RuntimeException_init_$Create$_0('Unsupported type ' + toString_1(PrimitiveClasses_getInstance().mb()));
    }
    var tmp$ret$2 = tmp_0;
    BigInteger.call($this, tmp, tmp$ret$2);
    return $this;
  }
  function BigInteger_init_$Create$_2(byte) {
    return BigInteger_init_$Init$_2(byte, objectCreate(protoOf(BigInteger)));
  }
  function Companion_26() {
    Companion_instance_26 = this;
    this.h27_1 = get_chosenArithmetic();
    this.i27_1 = new BigInteger(this.h27_1.v2a(), Sign_ZERO_getInstance());
    this.j27_1 = new BigInteger(this.h27_1.w2a(), Sign_POSITIVE_getInstance());
    this.k27_1 = new BigInteger(this.h27_1.x2a(), Sign_POSITIVE_getInstance());
    this.l27_1 = new BigInteger(this.h27_1.y2a(), Sign_POSITIVE_getInstance());
    var tmp = this;
    // Inline function 'kotlin.math.log10' call
    tmp.m27_1 = log10(2.0);
  }
  protoOf(Companion_26).f26 = function (string, base) {
    if (base < 2 || base > 36) {
      throw NumberFormatException_init_$Create$_0('Unsupported base: ' + base + '. Supported base range is from 2 to 36');
    }
    var decimal = contains_9(string, _Char___init__impl__6a9atx(46));
    if (decimal) {
      var bigDecimal = Companion_getInstance_24().j29(string);
      var isActuallyDecimal = bigDecimal.e2a(bigDecimal.h2a()).b2a(0) > 0;
      if (isActuallyDecimal) {
        throw NumberFormatException_init_$Create$_0('Supplied string is decimal, which cannot be converted to BigInteger without precision loss.');
      }
      return bigDecimal.i2a();
    }
    var signed = charCodeAt(string, 0) === _Char___init__impl__6a9atx(45) || charCodeAt(string, 0) === _Char___init__impl__6a9atx(43);
    var tmp;
    if (signed) {
      if (string.length === 1) {
        throw NumberFormatException_init_$Create$_0('Invalid big integer: ' + string);
      }
      var tmp_0;
      if (charCodeAt(string, 0) === _Char___init__impl__6a9atx(45)) {
        tmp_0 = Sign_NEGATIVE_getInstance();
      } else {
        tmp_0 = Sign_POSITIVE_getInstance();
      }
      var isNegative = tmp_0;
      if (string.length === 2 && charCodeAt(string, 1) === _Char___init__impl__6a9atx(48)) {
        return this.i27_1;
      }
      tmp = new BigInteger(this.h27_1.z2a(substring(string, 1, string.length), base), isNegative);
    } else {
      if (string.length === 1 && charCodeAt(string, 0) === _Char___init__impl__6a9atx(48)) {
        return this.i27_1;
      }
      tmp = new BigInteger(this.h27_1.z2a(string, base), Sign_POSITIVE_getInstance());
    }
    return tmp;
  };
  protoOf(Companion_26).a2b = function (uLong) {
    return new BigInteger(this.h27_1.b2b(uLong), Sign_POSITIVE_getInstance());
  };
  protoOf(Companion_26).c2b = function (uInt) {
    return new BigInteger(this.h27_1.d2b(uInt), Sign_POSITIVE_getInstance());
  };
  protoOf(Companion_26).e2b = function (uShort) {
    return new BigInteger(this.h27_1.f2b(uShort), Sign_POSITIVE_getInstance());
  };
  protoOf(Companion_26).g2b = function (uByte) {
    return new BigInteger(this.h27_1.h2b(uByte), Sign_POSITIVE_getInstance());
  };
  protoOf(Companion_26).z28 = function (long) {
    return BigInteger_init_$Create$(long);
  };
  protoOf(Companion_26).h26 = function (int) {
    return BigInteger_init_$Create$_0(int);
  };
  protoOf(Companion_26).d29 = function (short) {
    return BigInteger_init_$Create$_1(short);
  };
  protoOf(Companion_26).f29 = function (byte) {
    return BigInteger_init_$Create$_2(byte);
  };
  protoOf(Companion_26).i26 = function (float, exactRequired) {
    // Inline function 'kotlin.math.floor' call
    var floatDecimalPart = float - Math.floor(float);
    var tmp = Companion_getInstance_24();
    // Inline function 'kotlin.math.floor' call
    var tmp$ret$1 = Math.floor(float);
    var bigDecimal = tmp.g29(tmp$ret$1, null);
    if (exactRequired) {
      if (floatDecimalPart > 0) {
        throw ArithmeticException_init_$Create$_0('Cant create BigInteger without precision loss, and exact  value was required');
      }
    }
    return bigDecimal.i2a();
  };
  protoOf(Companion_26).k26 = function (double, exactRequired) {
    // Inline function 'kotlin.math.floor' call
    var doubleDecimalPart = double - Math.floor(double);
    var tmp = Companion_getInstance_24();
    // Inline function 'kotlin.math.floor' call
    var tmp$ret$1 = Math.floor(double);
    var bigDecimal = tmp.i29(tmp$ret$1, null);
    if (exactRequired) {
      if (doubleDecimalPart > 0) {
        throw ArithmeticException_init_$Create$_0('Cant create BigInteger without precision loss, and exact  value was required');
      }
    }
    return bigDecimal.i2a();
  };
  var Companion_instance_26;
  function Companion_getInstance_26() {
    if (Companion_instance_26 == null)
      new Companion_26();
    return Companion_instance_26;
  }
  function isResultZero($this, resultMagnitude) {
    return Companion_getInstance_26().h27_1.i2b(resultMagnitude, Companion_getInstance_26().h27_1.v2a()) === 0;
  }
  function javascriptNumberComparison_0($this, number) {
    var double = numberToDouble(number);
    var tmp;
    if (double > toNumber_0(9223372036854775807n)) {
      tmp = $this.k2a(Companion_getInstance_26().g26(double.toString()));
    } else if (double % 1 === 0.0) {
      tmp = $this.k2a(Companion_getInstance_26().z28(numberToLong(number)));
    } else {
      var tmp_0 = numberToDouble(number);
      tmp = $this.j2b(tmp_0, BigInteger$javascriptNumberComparison$lambda($this));
    }
    return tmp;
  }
  function QuotientAndRemainder(quotient, remainder) {
    this.u27_1 = quotient;
    this.v27_1 = remainder;
  }
  protoOf(QuotientAndRemainder).toString = function () {
    return 'QuotientAndRemainder(quotient=' + this.u27_1.toString() + ', remainder=' + this.v27_1.toString() + ')';
  };
  protoOf(QuotientAndRemainder).hashCode = function () {
    var result = this.u27_1.hashCode();
    result = imul(result, 31) + this.v27_1.hashCode() | 0;
    return result;
  };
  protoOf(QuotientAndRemainder).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof QuotientAndRemainder))
      return false;
    var tmp0_other_with_cast = other instanceof QuotientAndRemainder ? other : THROW_CCE();
    if (!this.u27_1.equals(tmp0_other_with_cast.u27_1))
      return false;
    if (!this.v27_1.equals(tmp0_other_with_cast.v27_1))
      return false;
    return true;
  };
  function BigInteger$compareTo$lambda(this$0) {
    return function (it) {
      return this$0.k2a(it);
    };
  }
  function BigInteger$compareTo$lambda_0(this$0) {
    return function (it) {
      return this$0.k2a(it);
    };
  }
  function BigInteger$javascriptNumberComparison$lambda(this$0) {
    return function (it) {
      return this$0.k2a(it);
    };
  }
  function BigInteger(wordArray, requestedSign) {
    Companion_getInstance_26();
    if (requestedSign.equals(Sign_ZERO_getInstance())) {
      // Inline function 'kotlin.require' call
      if (!isResultZero(this, wordArray)) {
        var message = 'sign should be Sign.ZERO iff magnitude has a value of 0';
        throw IllegalArgumentException_init_$Create$_0(toString_1(message));
      }
    }
    this.n27_1 = BigInteger63Arithmetic_getInstance().c2c(wordArray);
    var tmp = this;
    var tmp_0;
    if (isResultZero(this, this.n27_1)) {
      tmp_0 = Sign_ZERO_getInstance();
    } else {
      tmp_0 = requestedSign;
    }
    tmp.o27_1 = tmp_0;
    this.p27_1 = _ULongArray___get_size__impl__ju6dtr(this.n27_1);
    this.q27_1 = null;
  }
  protoOf(BigInteger).m26 = function () {
    return Companion_getInstance_26();
  };
  protoOf(BigInteger).n26 = function () {
    return this;
  };
  protoOf(BigInteger).d2c = function (other) {
    var comparison = Companion_getInstance_26().h27_1.i2b(this.n27_1, other.n27_1);
    var tmp;
    if (other.o27_1.equals(this.o27_1)) {
      return new BigInteger(Companion_getInstance_26().h27_1.f2c(this.n27_1, other.n27_1), this.o27_1);
    } else {
      var tmp_0;
      if (comparison > 0) {
        tmp_0 = new BigInteger(Companion_getInstance_26().h27_1.e2c(this.n27_1, other.n27_1), this.o27_1);
      } else if (comparison < 0) {
        tmp_0 = new BigInteger(Companion_getInstance_26().h27_1.e2c(other.n27_1, this.n27_1), other.o27_1);
      } else {
        tmp_0 = Companion_getInstance_26().i27_1;
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  protoOf(BigInteger).p26 = function (other) {
    return this.d2c(other instanceof BigInteger ? other : THROW_CCE());
  };
  protoOf(BigInteger).g2c = function (other) {
    if (this.y27()) {
      return other.l29();
    }
    if (other.y27()) {
      return this;
    }
    var tmp;
    if (other.o27_1.equals(this.o27_1)) {
      var comparison = Companion_getInstance_26().h27_1.i2b(this.n27_1, other.n27_1);
      var tmp_0;
      if (comparison > 0) {
        tmp_0 = new BigInteger(Companion_getInstance_26().h27_1.e2c(this.n27_1, other.n27_1), this.o27_1);
      } else if (comparison < 0) {
        tmp_0 = new BigInteger(Companion_getInstance_26().h27_1.e2c(other.n27_1, this.n27_1), this.o27_1.j2c());
      } else {
        tmp_0 = Companion_getInstance_26().i27_1;
      }
      tmp = tmp_0;
    } else {
      return new BigInteger(Companion_getInstance_26().h27_1.f2c(this.n27_1, other.n27_1), this.o27_1);
    }
    return tmp;
  };
  protoOf(BigInteger).r26 = function (other) {
    return this.g2c(other instanceof BigInteger ? other : THROW_CCE());
  };
  protoOf(BigInteger).k2c = function (other) {
    if (this.y27() || other.y27()) {
      return Companion_getInstance_26().i27_1;
    }
    if (other.equals(Companion_getInstance_26().j27_1)) {
      return this;
    }
    var tmp;
    if (!this.o27_1.equals(other.o27_1)) {
      tmp = Sign_NEGATIVE_getInstance();
    } else {
      tmp = Sign_POSITIVE_getInstance();
    }
    var sign = tmp;
    var tmp_0;
    if (sign.equals(Sign_POSITIVE_getInstance())) {
      tmp_0 = new BigInteger(Companion_getInstance_26().h27_1.l2c(this.n27_1, other.n27_1), sign);
    } else {
      tmp_0 = new BigInteger(Companion_getInstance_26().h27_1.l2c(this.n27_1, other.n27_1), sign);
    }
    return tmp_0;
  };
  protoOf(BigInteger).t26 = function (other) {
    return this.k2c(other instanceof BigInteger ? other : THROW_CCE());
  };
  protoOf(BigInteger).m2c = function (other) {
    if (other.y27()) {
      throw ArithmeticException_init_$Create$_0('Division by zero! ' + this.toString() + ' / ' + other.toString());
    }
    var result = Companion_getInstance_26().h27_1.n2c(this.n27_1, other.n27_1).pg_1.gn_1;
    var tmp;
    if (equals(result, Companion_getInstance_26().h27_1.v2a())) {
      tmp = Companion_getInstance_26().i27_1;
    } else {
      var tmp_0;
      if (!this.o27_1.equals(other.o27_1)) {
        tmp_0 = Sign_NEGATIVE_getInstance();
      } else {
        tmp_0 = Sign_POSITIVE_getInstance();
      }
      var sign = tmp_0;
      tmp = new BigInteger(result, sign);
    }
    return tmp;
  };
  protoOf(BigInteger).v26 = function (other) {
    return this.m2c(other instanceof BigInteger ? other : THROW_CCE());
  };
  protoOf(BigInteger).o2c = function (other) {
    if (other.y27()) {
      throw ArithmeticException_init_$Create$_0('Division by zero! ' + this.toString() + ' / ' + other.toString());
    }
    var tmp;
    if (!this.o27_1.equals(other.o27_1)) {
      tmp = Sign_NEGATIVE_getInstance();
    } else {
      tmp = Sign_POSITIVE_getInstance();
    }
    var sign = tmp;
    var result = Companion_getInstance_26().h27_1.n2c(this.n27_1, other.n27_1).qg_1.gn_1;
    if (equals(result, Companion_getInstance_26().h27_1.v2a())) {
      sign = Sign_ZERO_getInstance();
    }
    return new BigInteger(result, sign);
  };
  protoOf(BigInteger).b27 = function (other) {
    return this.o2c(other instanceof BigInteger ? other : THROW_CCE());
  };
  protoOf(BigInteger).p2c = function (other) {
    if (other.y27()) {
      throw ArithmeticException_init_$Create$_0('Division by zero! ' + this.toString() + ' / ' + other.toString());
    }
    var tmp;
    if (!this.o27_1.equals(other.o27_1)) {
      tmp = Sign_NEGATIVE_getInstance();
    } else {
      tmp = Sign_POSITIVE_getInstance();
    }
    var sign = tmp;
    var result = Companion_getInstance_26().h27_1.n2c(this.n27_1, other.n27_1);
    var tmp_0;
    if (equals(result.pg_1, new ULongArray(Companion_getInstance_26().h27_1.v2a()))) {
      tmp_0 = Companion_getInstance_26().i27_1;
    } else {
      tmp_0 = new BigInteger(result.pg_1.gn_1, sign);
    }
    var quotient = tmp_0;
    var tmp_1;
    if (equals(result.qg_1, new ULongArray(Companion_getInstance_26().h27_1.v2a()))) {
      tmp_1 = Companion_getInstance_26().i27_1;
    } else {
      tmp_1 = new BigInteger(result.qg_1.gn_1, this.o27_1);
    }
    var remainder = tmp_1;
    return new Pair(quotient, remainder);
  };
  protoOf(BigInteger).k2a = function (other) {
    if (this.y27() && other.y27())
      return 0;
    if (other.y27() && this.o27_1.equals(Sign_POSITIVE_getInstance()))
      return 1;
    if (other.y27() && this.o27_1.equals(Sign_NEGATIVE_getInstance()))
      return -1;
    if (this.y27() && other.o27_1.equals(Sign_POSITIVE_getInstance()))
      return -1;
    if (this.y27() && other.o27_1.equals(Sign_NEGATIVE_getInstance()))
      return 1;
    if (!this.o27_1.equals(other.o27_1))
      return this.o27_1.equals(Sign_POSITIVE_getInstance()) ? 1 : -1;
    var result = Companion_getInstance_26().h27_1.i2b(this.n27_1, other.n27_1);
    var tmp;
    if (this.o27_1.equals(Sign_NEGATIVE_getInstance()) && other.o27_1.equals(Sign_NEGATIVE_getInstance())) {
      tmp = imul(result, -1);
    } else {
      tmp = result;
    }
    return tmp;
  };
  protoOf(BigInteger).y27 = function () {
    return this.o27_1.equals(Sign_ZERO_getInstance()) || get_chosenArithmetic().i2b(this.n27_1, get_chosenArithmetic().v2a()) === 0;
  };
  protoOf(BigInteger).l29 = function () {
    return new BigInteger(this.n27_1, this.o27_1.j2c());
  };
  protoOf(BigInteger).w27 = function () {
    return new BigInteger(this.n27_1, Sign_POSITIVE_getInstance());
  };
  protoOf(BigInteger).s27 = function (exponent) {
    if (exponent < 0n) {
      throw ArithmeticException_init_$Create$_0('Negative exponent not supported with BigInteger');
    }
    var tmp;
    if (this.y27()) {
      tmp = Companion_getInstance_26().i27_1;
    } else if (this.equals(Companion_getInstance_26().j27_1)) {
      tmp = Companion_getInstance_26().j27_1;
    } else {
      var tmp_0;
      if (this.o27_1.equals(Sign_NEGATIVE_getInstance())) {
        var tmp_1;
        // Inline function 'kotlin.Long.rem' call
        if (modulo(exponent, fromInt_0(2)) === 0n) {
          tmp_1 = Sign_POSITIVE_getInstance();
        } else {
          tmp_1 = Sign_NEGATIVE_getInstance();
        }
        tmp_0 = tmp_1;
      } else {
        tmp_0 = Sign_POSITIVE_getInstance();
      }
      var sign = tmp_0;
      tmp = new BigInteger(Companion_getInstance_26().h27_1.q2c(this.n27_1, exponent), sign);
    }
    return tmp;
  };
  protoOf(BigInteger).r2c = function (exponent) {
    return this.s27(fromInt_0(exponent));
  };
  protoOf(BigInteger).n28 = function () {
    var tmp;
    switch (this.o27_1.x2_1) {
      case 0:
        tmp = 1;
        break;
      case 1:
        tmp = -1;
        break;
      case 2:
        tmp = 0;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  };
  protoOf(BigInteger).r27 = function () {
    if (this.y27()) {
      return 1n;
    }
    var powersOf10 = BigInteger63Arithmetic_getInstance().b2c_1;
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.indexOfFirst' call
      var inductionVariable = 0;
      var last = powersOf10.length - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var it = powersOf10[index].gn_1;
          if (BigInteger63Arithmetic_getInstance().s2c(it, this.n27_1) > 0) {
            tmp$ret$1 = index;
            break $l$block;
          }
        }
         while (inductionVariable <= last);
      tmp$ret$1 = -1;
    }
    var quickSearch = tmp$ret$1;
    if (!(quickSearch === -1)) {
      return fromInt_0(quickSearch);
    }
    var tmp = this.u26(Companion_getInstance_26().l27_1.r2c(powersOf10.length));
    var counter = 0n;
    while (!tmp.y27()) {
      tmp = tmp.z26(10);
      var _unary__edvuaz = counter;
      counter = add_2(_unary__edvuaz, get_ONE());
    }
    var tmp0 = counter;
    // Inline function 'kotlin.Long.plus' call
    var other = powersOf10.length;
    return add_2(tmp0, fromInt_0(other));
  };
  protoOf(BigInteger).z27 = function () {
    return this.q26(Companion_getInstance_26().j27_1);
  };
  protoOf(BigInteger).a28 = function () {
    return this.o26(Companion_getInstance_26().j27_1);
  };
  protoOf(BigInteger).t27 = function (other) {
    var result = this.p2c(other);
    return new QuotientAndRemainder(result.pg_1, result.qg_1);
  };
  protoOf(BigInteger).b2a = function (other) {
    if (isNumber(other)) {
      if (RuntimePlatform_instance.l2a().equals(Platform_JS_getInstance())) {
        return javascriptNumberComparison_0(this, other);
      }
    }
    var tmp;
    if (other instanceof BigInteger) {
      tmp = this.k2a(other);
    } else {
      if (typeof other === 'bigint') {
        tmp = this.k2a(Companion_getInstance_26().z28(other));
      } else {
        if (typeof other === 'number') {
          tmp = this.k2a(Companion_getInstance_26().h26(other));
        } else {
          if (typeof other === 'number') {
            tmp = this.k2a(Companion_getInstance_26().d29(other));
          } else {
            if (typeof other === 'number') {
              tmp = this.k2a(Companion_getInstance_26().f29(other));
            } else {
              if (other instanceof ULong) {
                tmp = this.k2a(Companion_getInstance_26().a2b(other.r1_1));
              } else {
                if (other instanceof UInt) {
                  tmp = this.k2a(Companion_getInstance_26().c2b(other.qm_1));
                } else {
                  if (other instanceof UShort) {
                    tmp = this.k2a(Companion_getInstance_26().e2b(other.mn_1));
                  } else {
                    if (other instanceof UByte) {
                      tmp = this.k2a(Companion_getInstance_26().g2b(other.em_1));
                    } else {
                      if (typeof other === 'number') {
                        tmp = this.j2b(other, BigInteger$compareTo$lambda(this));
                      } else {
                        if (typeof other === 'number') {
                          tmp = this.t2c(other, BigInteger$compareTo$lambda_0(this));
                        } else {
                          throw RuntimeException_init_$Create$_0('Invalid comparison type for BigInteger: ' + toString_1(getKClassFromExpression(other)));
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    return tmp;
  };
  protoOf(BigInteger).d = function (other) {
    return this.b2a(!(other == null) ? other : THROW_CCE());
  };
  protoOf(BigInteger).j2b = function (float, comparisonBlock) {
    // Inline function 'kotlin.math.floor' call
    var withoutDecimalPart = Math.floor(float);
    var hasDecimalPart = !(float % 1 === 0.0);
    var tmp;
    if (hasDecimalPart) {
      var comparisonResult = comparisonBlock(Companion_getInstance_26().j26(withoutDecimalPart + 1));
      var tmp_0;
      if (comparisonResult === 0) {
        tmp_0 = 1;
      } else {
        tmp_0 = comparisonResult;
      }
      tmp = tmp_0;
    } else {
      tmp = comparisonBlock(Companion_getInstance_26().j26(withoutDecimalPart));
    }
    return tmp;
  };
  protoOf(BigInteger).t2c = function (double, comparisonBlock) {
    // Inline function 'kotlin.math.floor' call
    var withoutDecimalPart = Math.floor(double);
    var hasDecimalPart = !(double % 1 === 0.0);
    var tmp;
    if (hasDecimalPart) {
      var comparisonResult = comparisonBlock(Companion_getInstance_26().l26(withoutDecimalPart + 1));
      var tmp_0;
      if (comparisonResult === 0) {
        tmp_0 = 1;
      } else {
        tmp_0 = comparisonResult;
      }
      tmp = tmp_0;
    } else {
      tmp = comparisonBlock(Companion_getInstance_26().l26(withoutDecimalPart));
    }
    return tmp;
  };
  protoOf(BigInteger).equals = function (other) {
    var tmp;
    if (other instanceof BigInteger) {
      tmp = this.k2a(other);
    } else {
      if (!(other == null) ? typeof other === 'bigint' : false) {
        tmp = this.k2a(Companion_getInstance_26().z28(other));
      } else {
        if (!(other == null) ? typeof other === 'number' : false) {
          tmp = this.k2a(Companion_getInstance_26().h26(other));
        } else {
          if (!(other == null) ? typeof other === 'number' : false) {
            tmp = this.k2a(Companion_getInstance_26().d29(other));
          } else {
            if (!(other == null) ? typeof other === 'number' : false) {
              tmp = this.k2a(Companion_getInstance_26().f29(other));
            } else {
              if (other instanceof ULong) {
                tmp = this.k2a(Companion_getInstance_26().a2b(other.r1_1));
              } else {
                if (other instanceof UInt) {
                  tmp = this.k2a(Companion_getInstance_26().c2b(other.qm_1));
                } else {
                  if (other instanceof UShort) {
                    tmp = this.k2a(Companion_getInstance_26().e2b(other.mn_1));
                  } else {
                    if (other instanceof UByte) {
                      tmp = this.k2a(Companion_getInstance_26().g2b(other.em_1));
                    } else {
                      tmp = -1;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    var comparison = tmp;
    return comparison === 0;
  };
  protoOf(BigInteger).hashCode = function () {
    // Inline function 'kotlin.collections.fold' call
    var this_0 = this.n27_1;
    var accumulator = 0;
    var _iterator__ex2g4s = ULongArray__iterator_impl_cq4d2h(this_0);
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o().r1_1;
      accumulator = accumulator + ULong__hashCode_impl_6hv2lb(element) | 0;
    }
    return accumulator + this.o27_1.hashCode() | 0;
  };
  protoOf(BigInteger).toString = function () {
    return this.n2a(10);
  };
  protoOf(BigInteger).n2a = function (base) {
    var tmp;
    if (this.o27_1.equals(Sign_NEGATIVE_getInstance())) {
      tmp = '-';
    } else {
      tmp = '';
    }
    var sign = tmp;
    return sign + this.o2a(base);
  };
  protoOf(BigInteger).o2a = function (base) {
    return Companion_getInstance_26().h27_1.u2c(this.n27_1, base);
  };
  protoOf(BigInteger).x27 = function (exactRequired) {
    if (exactRequired && (this.b2a(2147483647) > 0 || this.b2a(-2147483648) < 0)) {
      throw ArithmeticException_init_$Create$_0('Cannot convert to int and provide exact value');
    }
    // Inline function 'kotlin.ULong.toInt' call
    var this_0 = ULongArray__get_impl_pr71q9(this.n27_1, 0);
    var tmp$ret$0 = convertToInt(_ULong___get_data__impl__fggpzb(this_0));
    return imul(tmp$ret$0, this.n28());
  };
  var Sign_POSITIVE_instance;
  var Sign_NEGATIVE_instance;
  var Sign_ZERO_instance;
  var Sign_entriesInitialized;
  function Sign_initEntries() {
    if (Sign_entriesInitialized)
      return Unit_instance;
    Sign_entriesInitialized = true;
    Sign_POSITIVE_instance = new Sign('POSITIVE', 0);
    Sign_NEGATIVE_instance = new Sign('NEGATIVE', 1);
    Sign_ZERO_instance = new Sign('ZERO', 2);
  }
  function Sign(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  protoOf(Sign).j2c = function () {
    var tmp;
    switch (this.x2_1) {
      case 0:
        tmp = Sign_NEGATIVE_getInstance();
        break;
      case 1:
        tmp = Sign_POSITIVE_getInstance();
        break;
      case 2:
        tmp = Sign_ZERO_getInstance();
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  };
  function Sign_POSITIVE_getInstance() {
    Sign_initEntries();
    return Sign_POSITIVE_instance;
  }
  function Sign_NEGATIVE_getInstance() {
    Sign_initEntries();
    return Sign_NEGATIVE_instance;
  }
  function Sign_ZERO_getInstance() {
    Sign_initEntries();
    return Sign_ZERO_instance;
  }
  function toBigInteger(_this__u8e3s4) {
    return Companion_getInstance_26().h26(_this__u8e3s4);
  }
  function get_chosenArithmetic() {
    _init_properties_Configuration_kt__48zwcc();
    return chosenArithmetic;
  }
  var chosenArithmetic;
  var properties_initialized_Configuration_kt_gex7mu;
  function _init_properties_Configuration_kt__48zwcc() {
    if (!properties_initialized_Configuration_kt_gex7mu) {
      properties_initialized_Configuration_kt_gex7mu = true;
      chosenArithmetic = BigInteger63Arithmetic_getInstance();
    }
  }
  var Platform_JVM_instance;
  var Platform_NATIVE_instance;
  var Platform_JS_instance;
  var Platform_WASMJS_instance;
  var Platform_entriesInitialized;
  function Platform_initEntries() {
    if (Platform_entriesInitialized)
      return Unit_instance;
    Platform_entriesInitialized = true;
    Platform_JVM_instance = new Platform('JVM', 0);
    Platform_NATIVE_instance = new Platform('NATIVE', 1);
    Platform_JS_instance = new Platform('JS', 2);
    Platform_WASMJS_instance = new Platform('WASMJS', 3);
  }
  function Platform(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function Platform_JS_getInstance() {
    Platform_initEntries();
    return Platform_JS_instance;
  }
  function Platform_WASMJS_getInstance() {
    Platform_initEntries();
    return Platform_WASMJS_instance;
  }
  function Sextuple(a, b, c, d, e, f) {
    this.v2c_1 = a;
    this.w2c_1 = b;
    this.x2c_1 = c;
    this.y2c_1 = d;
    this.z2c_1 = e;
    this.a2d_1 = f;
  }
  protoOf(Sextuple).fg = function () {
    return this.v2c_1;
  };
  protoOf(Sextuple).gg = function () {
    return this.w2c_1;
  };
  protoOf(Sextuple).zl = function () {
    return this.x2c_1;
  };
  protoOf(Sextuple).b2d = function () {
    return this.y2c_1;
  };
  protoOf(Sextuple).c2d = function () {
    return this.z2c_1;
  };
  protoOf(Sextuple).d2d = function () {
    return this.a2d_1;
  };
  protoOf(Sextuple).toString = function () {
    return 'Sextuple(a=' + toString_0(this.v2c_1) + ', b=' + toString_0(this.w2c_1) + ', c=' + toString_0(this.x2c_1) + ', d=' + toString_0(this.y2c_1) + ', e=' + toString_0(this.z2c_1) + ', f=' + toString_0(this.a2d_1) + ')';
  };
  protoOf(Sextuple).hashCode = function () {
    var result = this.v2c_1 == null ? 0 : hashCode(this.v2c_1);
    result = imul(result, 31) + (this.w2c_1 == null ? 0 : hashCode(this.w2c_1)) | 0;
    result = imul(result, 31) + (this.x2c_1 == null ? 0 : hashCode(this.x2c_1)) | 0;
    result = imul(result, 31) + (this.y2c_1 == null ? 0 : hashCode(this.y2c_1)) | 0;
    result = imul(result, 31) + (this.z2c_1 == null ? 0 : hashCode(this.z2c_1)) | 0;
    result = imul(result, 31) + (this.a2d_1 == null ? 0 : hashCode(this.a2d_1)) | 0;
    return result;
  };
  protoOf(Sextuple).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Sextuple))
      return false;
    var tmp0_other_with_cast = other instanceof Sextuple ? other : THROW_CCE();
    if (!equals(this.v2c_1, tmp0_other_with_cast.v2c_1))
      return false;
    if (!equals(this.w2c_1, tmp0_other_with_cast.w2c_1))
      return false;
    if (!equals(this.x2c_1, tmp0_other_with_cast.x2c_1))
      return false;
    if (!equals(this.y2c_1, tmp0_other_with_cast.y2c_1))
      return false;
    if (!equals(this.z2c_1, tmp0_other_with_cast.z2c_1))
      return false;
    if (!equals(this.a2d_1, tmp0_other_with_cast.a2d_1))
      return false;
    return true;
  };
  function Quadruple(a, b, c, d) {
    this.e2d_1 = a;
    this.f2d_1 = b;
    this.g2d_1 = c;
    this.h2d_1 = d;
  }
  protoOf(Quadruple).fg = function () {
    return this.e2d_1;
  };
  protoOf(Quadruple).gg = function () {
    return this.f2d_1;
  };
  protoOf(Quadruple).zl = function () {
    return this.g2d_1;
  };
  protoOf(Quadruple).b2d = function () {
    return this.h2d_1;
  };
  protoOf(Quadruple).toString = function () {
    return 'Quadruple(a=' + toString_0(this.e2d_1) + ', b=' + toString_0(this.f2d_1) + ', c=' + toString_0(this.g2d_1) + ', d=' + toString_0(this.h2d_1) + ')';
  };
  protoOf(Quadruple).hashCode = function () {
    var result = this.e2d_1 == null ? 0 : hashCode(this.e2d_1);
    result = imul(result, 31) + (this.f2d_1 == null ? 0 : hashCode(this.f2d_1)) | 0;
    result = imul(result, 31) + (this.g2d_1 == null ? 0 : hashCode(this.g2d_1)) | 0;
    result = imul(result, 31) + (this.h2d_1 == null ? 0 : hashCode(this.h2d_1)) | 0;
    return result;
  };
  protoOf(Quadruple).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Quadruple))
      return false;
    var tmp0_other_with_cast = other instanceof Quadruple ? other : THROW_CCE();
    if (!equals(this.e2d_1, tmp0_other_with_cast.e2d_1))
      return false;
    if (!equals(this.f2d_1, tmp0_other_with_cast.f2d_1))
      return false;
    if (!equals(this.g2d_1, tmp0_other_with_cast.g2d_1))
      return false;
    if (!equals(this.h2d_1, tmp0_other_with_cast.h2d_1))
      return false;
    return true;
  };
  function SignedUIntArray(unsignedValue, sign) {
    this.i2d_1 = unsignedValue;
    this.j2d_1 = sign;
  }
  protoOf(SignedUIntArray).toString = function () {
    return 'SignedUIntArray(unsignedValue=' + UIntArray__toString_impl_3zy802(this.i2d_1) + ', sign=' + this.j2d_1 + ')';
  };
  protoOf(SignedUIntArray).hashCode = function () {
    var result = UIntArray__hashCode_impl_hr7ost(this.i2d_1);
    result = imul(result, 31) + getBooleanHashCode(this.j2d_1) | 0;
    return result;
  };
  protoOf(SignedUIntArray).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SignedUIntArray))
      return false;
    var tmp0_other_with_cast = other instanceof SignedUIntArray ? other : THROW_CCE();
    if (!equals(this.i2d_1, tmp0_other_with_cast.i2d_1))
      return false;
    if (!(this.j2d_1 === tmp0_other_with_cast.j2d_1))
      return false;
    return true;
  };
  function BigInteger32Arithmetic() {
    BigInteger32Arithmetic_instance = this;
    var tmp = this;
    // Inline function 'kotlin.intArrayOf' call
    tmp.k2d_1 = new Int32Array([]);
    this.l2d_1 = _ULong___init__impl__c78o9k(4294967295n);
    this.m2d_1 = _UInt___init__impl__l7qpdl(-1);
    this.n2d_1 = _ULong___init__impl__c78o9k(4294967296n);
    this.o2d_1 = _ULong___init__impl__c78o9k(65535n);
    this.p2d_1 = _UInt___init__impl__l7qpdl(-1);
    this.q2d_1 = 32;
    this.r2d_1 = 32;
    this.s2d_1 = _UIntArray___init__impl__ghjpc6_0(0);
    var tmp_0 = this;
    // Inline function 'kotlin.UIntArray' call
    var tmp_1 = 0;
    var tmp_2 = new Int32Array(1);
    while (tmp_1 < 1) {
      var tmp_3 = tmp_1;
      // Inline function 'kotlin.UInt.toInt' call
      var this_0 = _UInt___init__impl__l7qpdl(1);
      tmp_2[tmp_3] = _UInt___get_data__impl__f0vqqw(this_0);
      tmp_1 = tmp_1 + 1 | 0;
    }
    tmp_0.t2d_1 = _UIntArray___init__impl__ghjpc6(tmp_2);
    var tmp_4 = this;
    // Inline function 'kotlin.UIntArray' call
    var tmp_5 = 0;
    var tmp_6 = new Int32Array(1);
    while (tmp_5 < 1) {
      var tmp_7 = tmp_5;
      // Inline function 'kotlin.UInt.toInt' call
      var this_1 = _UInt___init__impl__l7qpdl(2);
      tmp_6[tmp_7] = _UInt___get_data__impl__f0vqqw(this_1);
      tmp_5 = tmp_5 + 1 | 0;
    }
    tmp_4.u2d_1 = _UIntArray___init__impl__ghjpc6(tmp_6);
    var tmp_8 = this;
    // Inline function 'kotlin.UIntArray' call
    var tmp_9 = 0;
    var tmp_10 = new Int32Array(1);
    while (tmp_9 < 1) {
      var tmp_11 = tmp_9;
      // Inline function 'kotlin.UInt.toInt' call
      var this_2 = _UInt___init__impl__l7qpdl(10);
      tmp_10[tmp_11] = _UInt___get_data__impl__f0vqqw(this_2);
      tmp_9 = tmp_9 + 1 | 0;
    }
    tmp_8.v2d_1 = _UIntArray___init__impl__ghjpc6(tmp_10);
    this.w2d_1 = 60;
    this.x2d_1 = 15000;
    this.y2d_1 = new SignedUIntArray(this.u2d_1, true);
  }
  protoOf(BigInteger32Arithmetic).z2d = function (value) {
    var x = value;
    var y;
    var n = this.q2d_1;
    // Inline function 'kotlin.UInt.shr' call
    var this_0 = x;
    y = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_0) >>> 16 | 0);
    if (!(y === _UInt___init__impl__l7qpdl(0))) {
      n = n - 16 | 0;
      x = y;
    }
    // Inline function 'kotlin.UInt.shr' call
    var this_1 = x;
    y = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_1) >>> 8 | 0);
    if (!(y === _UInt___init__impl__l7qpdl(0))) {
      n = n - 8 | 0;
      x = y;
    }
    // Inline function 'kotlin.UInt.shr' call
    var this_2 = x;
    y = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_2) >>> 4 | 0);
    if (!(y === _UInt___init__impl__l7qpdl(0))) {
      n = n - 4 | 0;
      x = y;
    }
    // Inline function 'kotlin.UInt.shr' call
    var this_3 = x;
    y = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_3) >>> 2 | 0);
    if (!(y === _UInt___init__impl__l7qpdl(0))) {
      n = n - 2 | 0;
      x = y;
    }
    // Inline function 'kotlin.UInt.shr' call
    var this_4 = x;
    y = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_4) >>> 1 | 0);
    if (!(y === _UInt___init__impl__l7qpdl(0))) {
      return n - 2 | 0;
    }
    var tmp = n;
    // Inline function 'kotlin.UInt.toInt' call
    var this_5 = x;
    return tmp - _UInt___get_data__impl__f0vqqw(this_5) | 0;
  };
  protoOf(BigInteger32Arithmetic).a2e = function (value) {
    if (UIntArray__isEmpty_impl_vd8j4n(value)) {
      return 0;
    }
    var mostSignificant = UIntArray__get_impl_gp5kza(value, _UIntArray___get_size__impl__r6l8ci(value) - 1 | 0);
    return this.b2e(mostSignificant) + imul(_UIntArray___get_size__impl__r6l8ci(value) - 1 | 0, this.q2d_1) | 0;
  };
  protoOf(BigInteger32Arithmetic).b2e = function (value) {
    return this.q2d_1 - this.z2d(value) | 0;
  };
  protoOf(BigInteger32Arithmetic).c2e = function (bigInteger) {
    // Inline function 'kotlin.collections.indexOfLast' call
    var tmp0 = _UIntArray___get_storage__impl__92a0v0(bigInteger);
    var tmp$ret$3;
    $l$block: {
      // Inline function 'kotlin.collections.indexOfLast' call
      var inductionVariable = tmp0.length - 1 | 0;
      if (0 <= inductionVariable)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + -1 | 0;
          // Inline function 'kotlin.toUInt' call
          var this_0 = tmp0[index];
          if (!(_UInt___init__impl__l7qpdl(this_0) === _UInt___init__impl__l7qpdl(0))) {
            tmp$ret$3 = index;
            break $l$block;
          }
        }
         while (0 <= inductionVariable);
      tmp$ret$3 = -1;
    }
    var firstEmpty = tmp$ret$3 + 1 | 0;
    if (firstEmpty === -1 || firstEmpty === 0) {
      return this.s2d_1;
    }
    // Inline function 'kotlin.collections.copyOfRange' call
    return _UIntArray___init__impl__ghjpc6(copyOfRange_0(_UIntArray___get_storage__impl__92a0v0(bigInteger), 0, firstEmpty));
  };
  protoOf(BigInteger32Arithmetic).d2e = function (bigInteger) {
    var lastNonEmptyIndex = _UIntArray___get_size__impl__r6l8ci(bigInteger) - 1 | 0;
    if (lastNonEmptyIndex <= 0) {
      return 0;
    }
    var element = UIntArray__get_impl_gp5kza(bigInteger, lastNonEmptyIndex);
    while (element === _UInt___init__impl__l7qpdl(0) && lastNonEmptyIndex > 0) {
      lastNonEmptyIndex = lastNonEmptyIndex - 1 | 0;
      element = UIntArray__get_impl_gp5kza(bigInteger, lastNonEmptyIndex);
    }
    if (UIntArray__get_impl_gp5kza(bigInteger, lastNonEmptyIndex) === _UInt___init__impl__l7qpdl(0)) {
      lastNonEmptyIndex = lastNonEmptyIndex - 1 | 0;
    }
    return (_UIntArray___get_size__impl__r6l8ci(bigInteger) - lastNonEmptyIndex | 0) - 1 | 0;
  };
  protoOf(BigInteger32Arithmetic).e2e = function (operand, places) {
    if (UIntArray__isEmpty_impl_vd8j4n(operand) || places === 0) {
      return operand;
    }
    var originalSize = _UIntArray___get_size__impl__r6l8ci(operand);
    var leadingZeros = this.z2d(UIntArray__get_impl_gp5kza(operand, _UIntArray___get_size__impl__r6l8ci(operand) - 1 | 0));
    var shiftWords = places / this.q2d_1 | 0;
    var shiftBits = places % this.q2d_1 | 0;
    var tmp;
    if (shiftBits > leadingZeros) {
      tmp = shiftWords + 1 | 0;
    } else {
      tmp = shiftWords;
    }
    var wordsNeeded = tmp;
    if (shiftBits === 0) {
      // Inline function 'kotlin.UIntArray' call
      var tmp_0 = 0;
      var tmp_1 = _UIntArray___get_size__impl__r6l8ci(operand) + wordsNeeded | 0;
      var tmp_2 = new Int32Array(tmp_1);
      while (tmp_0 < tmp_1) {
        var tmp_3 = tmp_0;
        // Inline function 'kotlin.UInt.toInt' call
        var this_0 = (0 <= tmp_3 ? tmp_3 < shiftWords : false) ? _UInt___init__impl__l7qpdl(0) : UIntArray__get_impl_gp5kza(operand, tmp_3 - shiftWords | 0);
        tmp_2[tmp_3] = _UInt___get_data__impl__f0vqqw(this_0);
        tmp_0 = tmp_0 + 1 | 0;
      }
      return _UIntArray___init__impl__ghjpc6(tmp_2);
    }
    // Inline function 'kotlin.UIntArray' call
    var tmp_4 = 0;
    var tmp_5 = _UIntArray___get_size__impl__r6l8ci(operand) + wordsNeeded | 0;
    var tmp_6 = new Int32Array(tmp_5);
    while (tmp_4 < tmp_5) {
      var tmp_7 = tmp_4;
      var tmp_8;
      if (0 <= tmp_7 ? tmp_7 < shiftWords : false) {
        tmp_8 = _UInt___init__impl__l7qpdl(0);
      } else {
        if (tmp_7 === shiftWords) {
          // Inline function 'kotlin.UInt.shl' call
          var this_1 = UIntArray__get_impl_gp5kza(operand, tmp_7 - shiftWords | 0);
          tmp_8 = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_1) << shiftBits);
        } else {
          var containsLower = shiftWords + 1 | 0;
          if (tmp_7 < (originalSize + shiftWords | 0) ? containsLower <= tmp_7 : false) {
            // Inline function 'kotlin.UInt.shl' call
            var this_2 = UIntArray__get_impl_gp5kza(operand, tmp_7 - shiftWords | 0);
            var tmp0 = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_2) << shiftBits);
            var tmp0_0 = UIntArray__get_impl_gp5kza(operand, (tmp_7 - shiftWords | 0) - 1 | 0);
            // Inline function 'kotlin.UInt.shr' call
            var bitCount = BigInteger32Arithmetic_getInstance().q2d_1 - shiftBits | 0;
            // Inline function 'kotlin.UInt.or' call
            var other = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(tmp0_0) >>> bitCount | 0);
            tmp_8 = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(tmp0) | _UInt___get_data__impl__f0vqqw(other));
          } else {
            if (tmp_7 === ((originalSize + wordsNeeded | 0) - 1 | 0)) {
              var tmp0_1 = UIntArray__get_impl_gp5kza(operand, tmp_7 - wordsNeeded | 0);
              // Inline function 'kotlin.UInt.shr' call
              var bitCount_0 = BigInteger32Arithmetic_getInstance().q2d_1 - shiftBits | 0;
              tmp_8 = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(tmp0_1) >>> bitCount_0 | 0);
            } else {
              throw RuntimeException_init_$Create$_0('Invalid case ' + tmp_7);
            }
          }
        }
      }
      // Inline function 'kotlin.UInt.toInt' call
      var this_3 = tmp_8;
      tmp_6[tmp_7] = _UInt___get_data__impl__f0vqqw(this_3);
      tmp_4 = tmp_4 + 1 | 0;
    }
    return _UIntArray___init__impl__ghjpc6(tmp_6);
  };
  protoOf(BigInteger32Arithmetic).f2e = function (operand, places) {
    if (UIntArray__isEmpty_impl_vd8j4n(operand) || places === 0) {
      return operand;
    }
    var shiftBits = places % this.q2d_1 | 0;
    var wordsToDiscard = places / this.q2d_1 | 0;
    if (wordsToDiscard >= _UIntArray___get_size__impl__r6l8ci(operand)) {
      return this.s2d_1;
    }
    if (shiftBits === 0) {
      // Inline function 'kotlin.collections.copyOfRange' call
      var toIndex = _UIntArray___get_size__impl__r6l8ci(operand);
      return _UIntArray___init__impl__ghjpc6(copyOfRange_0(_UIntArray___get_storage__impl__92a0v0(operand), wordsToDiscard, toIndex));
    }
    if (_UIntArray___get_size__impl__r6l8ci(operand) > 1 && (_UIntArray___get_size__impl__r6l8ci(operand) - wordsToDiscard | 0) === 1) {
      // Inline function 'kotlin.UInt.shr' call
      var this_0 = UIntArray__get_impl_gp5kza(operand, _UIntArray___get_size__impl__r6l8ci(operand) - 1 | 0);
      var tmp$ret$1 = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_0) >>> shiftBits | 0);
      // Inline function 'kotlin.uintArrayOf' call
      return _UIntArray___init__impl__ghjpc6(new Int32Array([tmp$ret$1]));
    }
    // Inline function 'kotlin.UIntArray' call
    var tmp = 0;
    var tmp_0 = _UIntArray___get_size__impl__r6l8ci(operand) - wordsToDiscard | 0;
    var tmp_1 = new Int32Array(tmp_0);
    while (tmp < tmp_0) {
      var tmp_2 = tmp;
      var tmp_3;
      if (0 <= tmp_2 ? tmp_2 < ((_UIntArray___get_size__impl__r6l8ci(operand) - 1 | 0) - wordsToDiscard | 0) : false) {
        // Inline function 'kotlin.UInt.shr' call
        var this_1 = UIntArray__get_impl_gp5kza(operand, tmp_2 + wordsToDiscard | 0);
        var tmp0 = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_1) >>> shiftBits | 0);
        var tmp0_0 = UIntArray__get_impl_gp5kza(operand, (tmp_2 + wordsToDiscard | 0) + 1 | 0);
        // Inline function 'kotlin.UInt.shl' call
        var bitCount = BigInteger32Arithmetic_getInstance().q2d_1 - shiftBits | 0;
        // Inline function 'kotlin.UInt.or' call
        var other = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(tmp0_0) << bitCount);
        tmp_3 = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(tmp0) | _UInt___get_data__impl__f0vqqw(other));
      } else if (tmp_2 === ((_UIntArray___get_size__impl__r6l8ci(operand) - 1 | 0) - wordsToDiscard | 0)) {
        // Inline function 'kotlin.UInt.shr' call
        var this_2 = UIntArray__get_impl_gp5kza(operand, tmp_2 + wordsToDiscard | 0);
        tmp_3 = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_2) >>> shiftBits | 0);
      } else {
        throw RuntimeException_init_$Create$_0('Invalid case ' + tmp_2);
      }
      // Inline function 'kotlin.UInt.toInt' call
      var this_3 = tmp_3;
      tmp_1[tmp_2] = _UInt___get_data__impl__f0vqqw(this_3);
      tmp = tmp + 1 | 0;
    }
    var result = _UIntArray___init__impl__ghjpc6(tmp_1);
    return this.c2e(result);
  };
  protoOf(BigInteger32Arithmetic).g2e = function (dividend, divisor) {
    var divisorSize = _UIntArray___get_size__impl__r6l8ci(divisor);
    var normalizationShift = this.z2d(UIntArray__get_impl_gp5kza(divisor, divisorSize - 1 | 0));
    var divisorNormalized = this.h2e(divisor, normalizationShift);
    var dividendNormalized = this.h2e(dividend, normalizationShift);
    return new Triple(new UIntArray(dividendNormalized), new UIntArray(divisorNormalized), normalizationShift);
  };
  protoOf(BigInteger32Arithmetic).i2e = function (remainderNormalized, normalizationShift) {
    var remainder = this.j2e(remainderNormalized, normalizationShift);
    return remainder;
  };
  protoOf(BigInteger32Arithmetic).k2e = function (first, second) {
    var firstStart = _UIntArray___get_size__impl__r6l8ci(first) - this.d2e(first) | 0;
    var secondStart = _UIntArray___get_size__impl__r6l8ci(second) - this.d2e(second) | 0;
    if (firstStart > secondStart) {
      return 1;
    }
    if (secondStart > firstStart) {
      return -1;
    }
    var counter = firstStart - 1 | 0;
    var firstIsLarger = false;
    var bothAreEqual = true;
    $l$loop_0: while (counter >= 0) {
      var tmp0 = UIntArray__get_impl_gp5kza(first, counter);
      // Inline function 'kotlin.UInt.compareTo' call
      var other = UIntArray__get_impl_gp5kza(second, counter);
      if (uintCompare(_UInt___get_data__impl__f0vqqw(tmp0), _UInt___get_data__impl__f0vqqw(other)) > 0) {
        firstIsLarger = true;
        bothAreEqual = false;
        break $l$loop_0;
      }
      var tmp0_0 = UIntArray__get_impl_gp5kza(first, counter);
      // Inline function 'kotlin.UInt.compareTo' call
      var other_0 = UIntArray__get_impl_gp5kza(second, counter);
      if (uintCompare(_UInt___get_data__impl__f0vqqw(tmp0_0), _UInt___get_data__impl__f0vqqw(other_0)) < 0) {
        firstIsLarger = false;
        bothAreEqual = false;
        break $l$loop_0;
      }
      counter = counter - 1 | 0;
    }
    if (bothAreEqual) {
      return 0;
    }
    if (firstIsLarger) {
      return 1;
    } else {
      return -1;
    }
  };
  protoOf(BigInteger32Arithmetic).l2e = function (first, second) {
    if (_UIntArray___get_size__impl__r6l8ci(first) === 1 && UIntArray__get_impl_gp5kza(first, 0) === _UInt___init__impl__l7qpdl(0))
      return second;
    if (_UIntArray___get_size__impl__r6l8ci(second) === 1 && UIntArray__get_impl_gp5kza(second, 0) === _UInt___init__impl__l7qpdl(0))
      return first;
    var tmp;
    if (_UIntArray___get_size__impl__r6l8ci(first) > _UIntArray___get_size__impl__r6l8ci(second)) {
      tmp = new Quadruple(_UIntArray___get_size__impl__r6l8ci(first), _UIntArray___get_size__impl__r6l8ci(second), new UIntArray(first), new UIntArray(second));
    } else {
      tmp = new Quadruple(_UIntArray___get_size__impl__r6l8ci(second), _UIntArray___get_size__impl__r6l8ci(first), new UIntArray(second), new UIntArray(first));
    }
    var _destruct__k2r9zo = tmp;
    var maxLength = _destruct__k2r9zo.fg();
    var minLength = _destruct__k2r9zo.gg();
    var largerData = _destruct__k2r9zo.zl().vm_1;
    var smallerData = _destruct__k2r9zo.b2d().vm_1;
    // Inline function 'kotlin.UIntArray' call
    var tmp_0 = 0;
    var tmp_1 = maxLength + 1 | 0;
    var tmp_2 = new Int32Array(tmp_1);
    while (tmp_0 < tmp_1) {
      var tmp_3 = tmp_0;
      // Inline function 'kotlin.UInt.toInt' call
      var this_0 = _UInt___init__impl__l7qpdl(0);
      tmp_2[tmp_3] = _UInt___get_data__impl__f0vqqw(this_0);
      tmp_0 = tmp_0 + 1 | 0;
    }
    var result = _UIntArray___init__impl__ghjpc6(tmp_2);
    var i = 0;
    var sum = _ULong___init__impl__c78o9k(0n);
    while (i < minLength) {
      var tmp0 = sum;
      // Inline function 'kotlin.ULong.plus' call
      // Inline function 'kotlin.UInt.toULong' call
      var this_1 = UIntArray__get_impl_gp5kza(largerData, i);
      // Inline function 'kotlin.uintToULong' call
      // Inline function 'kotlin.uintToLong' call
      var value = _UInt___get_data__impl__f0vqqw(this_1);
      var tmp$ret$4 = fromInt_0(value) & 4294967295n;
      // Inline function 'kotlin.ULong.plus' call
      var other = _ULong___init__impl__c78o9k(tmp$ret$4);
      var tmp0_0 = _ULong___init__impl__c78o9k(add_2(_ULong___get_data__impl__fggpzb(tmp0), _ULong___get_data__impl__fggpzb(other)));
      // Inline function 'kotlin.ULong.plus' call
      // Inline function 'kotlin.UInt.toULong' call
      var this_2 = UIntArray__get_impl_gp5kza(smallerData, i);
      // Inline function 'kotlin.uintToULong' call
      // Inline function 'kotlin.uintToLong' call
      var value_0 = _UInt___get_data__impl__f0vqqw(this_2);
      var tmp$ret$9 = fromInt_0(value_0) & 4294967295n;
      // Inline function 'kotlin.ULong.plus' call
      var other_0 = _ULong___init__impl__c78o9k(tmp$ret$9);
      sum = _ULong___init__impl__c78o9k(add_2(_ULong___get_data__impl__fggpzb(tmp0_0), _ULong___get_data__impl__fggpzb(other_0)));
      var tmp_4 = i;
      var tmp0_1 = sum;
      // Inline function 'kotlin.ULong.and' call
      var other_1 = this.l2d_1;
      // Inline function 'kotlin.ULong.toUInt' call
      var this_3 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(tmp0_1) & _ULong___get_data__impl__fggpzb(other_1));
      // Inline function 'kotlin.toUInt' call
      var this_4 = _ULong___get_data__impl__fggpzb(this_3);
      var tmp$ret$16 = _UInt___init__impl__l7qpdl(convertToInt(this_4));
      UIntArray__set_impl_7f2zu2(result, tmp_4, tmp$ret$16);
      var tmp0_2 = sum;
      // Inline function 'kotlin.ULong.shr' call
      var bitCount = this.q2d_1;
      sum = _ULong___init__impl__c78o9k(shiftRightUnsigned(_ULong___get_data__impl__fggpzb(tmp0_2), bitCount));
      i = i + 1 | 0;
    }
    while (true) {
      if (sum === _ULong___init__impl__c78o9k(0n)) {
        while (i < maxLength) {
          UIntArray__set_impl_7f2zu2(result, i, UIntArray__get_impl_gp5kza(largerData, i));
          i = i + 1 | 0;
        }
        var tmp_5;
        if (UIntArray__get_impl_gp5kza(result, _UIntArray___get_size__impl__r6l8ci(result) - 1 | 0) === _UInt___init__impl__l7qpdl(0)) {
          // Inline function 'kotlin.collections.copyOfRange' call
          var toIndex = _UIntArray___get_size__impl__r6l8ci(result) - 1 | 0;
          tmp_5 = _UIntArray___init__impl__ghjpc6(copyOfRange_0(_UIntArray___get_storage__impl__92a0v0(result), 0, toIndex));
        } else {
          tmp_5 = result;
        }
        return tmp_5;
      }
      if (i === maxLength) {
        // Inline function 'kotlin.ULong.toUInt' call
        var this_5 = sum;
        // Inline function 'kotlin.toUInt' call
        var this_6 = _ULong___get_data__impl__fggpzb(this_5);
        var tmp$ret$20 = _UInt___init__impl__l7qpdl(convertToInt(this_6));
        UIntArray__set_impl_7f2zu2(result, maxLength, tmp$ret$20);
        return result;
      }
      var tmp0_3 = sum;
      // Inline function 'kotlin.ULong.plus' call
      // Inline function 'kotlin.UInt.toULong' call
      var this_7 = UIntArray__get_impl_gp5kza(largerData, i);
      // Inline function 'kotlin.uintToULong' call
      // Inline function 'kotlin.uintToLong' call
      var value_1 = _UInt___get_data__impl__f0vqqw(this_7);
      var tmp$ret$21 = fromInt_0(value_1) & 4294967295n;
      // Inline function 'kotlin.ULong.plus' call
      var other_2 = _ULong___init__impl__c78o9k(tmp$ret$21);
      sum = _ULong___init__impl__c78o9k(add_2(_ULong___get_data__impl__fggpzb(tmp0_3), _ULong___get_data__impl__fggpzb(other_2)));
      var tmp_6 = i;
      var tmp0_4 = sum;
      // Inline function 'kotlin.ULong.and' call
      var other_3 = this.l2d_1;
      // Inline function 'kotlin.ULong.toUInt' call
      var this_8 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(tmp0_4) & _ULong___get_data__impl__fggpzb(other_3));
      // Inline function 'kotlin.toUInt' call
      var this_9 = _ULong___get_data__impl__fggpzb(this_8);
      var tmp$ret$28 = _UInt___init__impl__l7qpdl(convertToInt(this_9));
      UIntArray__set_impl_7f2zu2(result, tmp_6, tmp$ret$28);
      var tmp0_5 = sum;
      // Inline function 'kotlin.ULong.shr' call
      var bitCount_0 = this.q2d_1;
      sum = _ULong___init__impl__c78o9k(shiftRightUnsigned(_ULong___get_data__impl__fggpzb(tmp0_5), bitCount_0));
      i = i + 1 | 0;
    }
  };
  protoOf(BigInteger32Arithmetic).m2e = function (first, second) {
    var firstWithoutLeadingZeroes = this.c2e(first);
    var secondWithoutLeadingZeroes = this.c2e(second);
    var firstIsLarger = this.k2e(firstWithoutLeadingZeroes, secondWithoutLeadingZeroes) === 1;
    var tmp;
    if (firstIsLarger) {
      tmp = new Quadruple(_UIntArray___get_size__impl__r6l8ci(firstWithoutLeadingZeroes), _UIntArray___get_size__impl__r6l8ci(secondWithoutLeadingZeroes), new UIntArray(firstWithoutLeadingZeroes), new UIntArray(secondWithoutLeadingZeroes));
    } else {
      tmp = new Quadruple(_UIntArray___get_size__impl__r6l8ci(secondWithoutLeadingZeroes), _UIntArray___get_size__impl__r6l8ci(firstWithoutLeadingZeroes), new UIntArray(secondWithoutLeadingZeroes), new UIntArray(firstWithoutLeadingZeroes));
    }
    var _destruct__k2r9zo = tmp;
    var largerLength = _destruct__k2r9zo.fg();
    var smallerLength = _destruct__k2r9zo.gg();
    var largerData = _destruct__k2r9zo.zl().vm_1;
    var smallerData = _destruct__k2r9zo.b2d().vm_1;
    // Inline function 'kotlin.UIntArray' call
    var tmp_0 = 0;
    var tmp_1 = largerLength + 1 | 0;
    var tmp_2 = new Int32Array(tmp_1);
    while (tmp_0 < tmp_1) {
      var tmp_3 = tmp_0;
      // Inline function 'kotlin.UInt.toInt' call
      var this_0 = _UInt___init__impl__l7qpdl(0);
      tmp_2[tmp_3] = _UInt___get_data__impl__f0vqqw(this_0);
      tmp_0 = tmp_0 + 1 | 0;
    }
    var result = _UIntArray___init__impl__ghjpc6(tmp_2);
    var i = 0;
    var diff = _ULong___init__impl__c78o9k(0n);
    while (i < smallerLength) {
      if (i >= _UIntArray___get_size__impl__r6l8ci(largerData)) {
        println('Breakpoint');
      }
      if (i >= _UIntArray___get_size__impl__r6l8ci(smallerData)) {
        println('Breakpoint');
      }
      // Inline function 'kotlin.UInt.toULong' call
      var this_1 = UIntArray__get_impl_gp5kza(largerData, i);
      // Inline function 'kotlin.uintToULong' call
      // Inline function 'kotlin.uintToLong' call
      var value = _UInt___get_data__impl__f0vqqw(this_1);
      var tmp$ret$4 = fromInt_0(value) & 4294967295n;
      var tmp0 = _ULong___init__impl__c78o9k(tmp$ret$4);
      // Inline function 'kotlin.ULong.minus' call
      // Inline function 'kotlin.UInt.toULong' call
      var this_2 = UIntArray__get_impl_gp5kza(smallerData, i);
      // Inline function 'kotlin.uintToULong' call
      // Inline function 'kotlin.uintToLong' call
      var value_0 = _UInt___get_data__impl__f0vqqw(this_2);
      var tmp$ret$7 = fromInt_0(value_0) & 4294967295n;
      // Inline function 'kotlin.ULong.minus' call
      var other = _ULong___init__impl__c78o9k(tmp$ret$7);
      var tmp0_0 = _ULong___init__impl__c78o9k(subtract_1(_ULong___get_data__impl__fggpzb(tmp0), _ULong___get_data__impl__fggpzb(other)));
      // Inline function 'kotlin.ULong.minus' call
      var other_0 = diff;
      diff = _ULong___init__impl__c78o9k(subtract_1(_ULong___get_data__impl__fggpzb(tmp0_0), _ULong___get_data__impl__fggpzb(other_0)));
      var tmp_4 = i;
      // Inline function 'kotlin.ULong.toUInt' call
      var this_3 = diff;
      // Inline function 'kotlin.toUInt' call
      var this_4 = _ULong___get_data__impl__fggpzb(this_3);
      var tmp$ret$14 = _UInt___init__impl__l7qpdl(convertToInt(this_4));
      UIntArray__set_impl_7f2zu2(result, tmp_4, tmp$ret$14);
      var tmp0_1 = diff;
      // Inline function 'kotlin.ULong.and' call
      var other_1 = this.n2d_1;
      var tmp0_2 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(tmp0_1) & _ULong___get_data__impl__fggpzb(other_1));
      // Inline function 'kotlin.ULong.shr' call
      var bitCount = this.r2d_1;
      diff = _ULong___init__impl__c78o9k(shiftRightUnsigned(_ULong___get_data__impl__fggpzb(tmp0_2), bitCount));
      i = i + 1 | 0;
    }
    while (!(diff === _ULong___init__impl__c78o9k(0n))) {
      var tmp0_3 = UIntArray__get_impl_gp5kza(largerData, i);
      // Inline function 'kotlin.UInt.minus' call
      var other_2 = diff;
      // Inline function 'kotlin.UInt.toULong' call
      // Inline function 'kotlin.uintToULong' call
      // Inline function 'kotlin.uintToLong' call
      var value_1 = _UInt___get_data__impl__f0vqqw(tmp0_3);
      var tmp$ret$17 = fromInt_0(value_1) & 4294967295n;
      // Inline function 'kotlin.ULong.minus' call
      var this_5 = _ULong___init__impl__c78o9k(tmp$ret$17);
      diff = _ULong___init__impl__c78o9k(subtract_1(_ULong___get_data__impl__fggpzb(this_5), _ULong___get_data__impl__fggpzb(other_2)));
      var tmp_5 = i;
      // Inline function 'kotlin.ULong.toUInt' call
      var this_6 = diff;
      // Inline function 'kotlin.toUInt' call
      var this_7 = _ULong___get_data__impl__fggpzb(this_6);
      var tmp0_4 = _UInt___init__impl__l7qpdl(convertToInt(this_7));
      // Inline function 'kotlin.UInt.and' call
      var other_3 = this.m2d_1;
      var tmp$ret$24 = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(tmp0_4) & _UInt___get_data__impl__f0vqqw(other_3));
      UIntArray__set_impl_7f2zu2(result, tmp_5, tmp$ret$24);
      var tmp0_5 = diff;
      // Inline function 'kotlin.ULong.and' call
      var other_4 = this.n2d_1;
      var tmp0_6 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(tmp0_5) & _ULong___get_data__impl__fggpzb(other_4));
      // Inline function 'kotlin.ULong.shr' call
      var bitCount_0 = this.r2d_1;
      diff = _ULong___init__impl__c78o9k(shiftRightUnsigned(_ULong___get_data__impl__fggpzb(tmp0_6), bitCount_0));
      i = i + 1 | 0;
    }
    while (i < largerLength) {
      UIntArray__set_impl_7f2zu2(result, i, UIntArray__get_impl_gp5kza(largerData, i));
      i = i + 1 | 0;
    }
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList_init_$Create$();
    var _iterator__ex2g4s = UIntArray__iterator_impl_tkdv7k(result);
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o().qm_1;
      if (element === _UInt___init__impl__l7qpdl(0)) {
        destination.j(new UInt(element));
      }
    }
    if (destination.s()) {
      return this.s2d_1;
    }
    // Inline function 'kotlin.collections.indexOfLast' call
    var tmp0_7 = _UIntArray___get_storage__impl__92a0v0(result);
    var tmp$ret$33;
    $l$block: {
      // Inline function 'kotlin.collections.indexOfLast' call
      var inductionVariable = tmp0_7.length - 1 | 0;
      if (0 <= inductionVariable)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + -1 | 0;
          // Inline function 'kotlin.toUInt' call
          var this_8 = tmp0_7[index];
          if (!(_UInt___init__impl__l7qpdl(this_8) === _UInt___init__impl__l7qpdl(0))) {
            tmp$ret$33 = index;
            break $l$block;
          }
        }
         while (0 <= inductionVariable);
      tmp$ret$33 = -1;
    }
    var firstEmpty = tmp$ret$33 + 1 | 0;
    // Inline function 'kotlin.collections.copyOfRange' call
    return _UIntArray___init__impl__ghjpc6(copyOfRange_0(_UIntArray___get_storage__impl__92a0v0(result), 0, firstEmpty));
  };
  protoOf(BigInteger32Arithmetic).n2e = function (first, second) {
    var result = _UIntArray___init__impl__ghjpc6_0(_UIntArray___get_size__impl__r6l8ci(first) + 1 | 0);
    var product;
    var sum;
    var inductionVariable = 0;
    var last = _UIntArray___get_size__impl__r6l8ci(first);
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlin.UInt.toULong' call
        var this_0 = UIntArray__get_impl_gp5kza(first, i);
        // Inline function 'kotlin.uintToULong' call
        // Inline function 'kotlin.uintToLong' call
        var value = _UInt___get_data__impl__f0vqqw(this_0);
        var tmp$ret$0 = fromInt_0(value) & 4294967295n;
        // Inline function 'kotlin.ULong.times' call
        var tmp0 = _ULong___init__impl__c78o9k(tmp$ret$0);
        // Inline function 'kotlin.UInt.toULong' call
        // Inline function 'kotlin.uintToULong' call
        // Inline function 'kotlin.uintToLong' call
        var value_0 = _UInt___get_data__impl__f0vqqw(second);
        var tmp$ret$3 = fromInt_0(value_0) & 4294967295n;
        // Inline function 'kotlin.ULong.times' call
        var other = _ULong___init__impl__c78o9k(tmp$ret$3);
        product = _ULong___init__impl__c78o9k(multiply_0(_ULong___get_data__impl__fggpzb(tmp0), _ULong___get_data__impl__fggpzb(other)));
        // Inline function 'kotlin.UInt.toULong' call
        var this_1 = UIntArray__get_impl_gp5kza(result, i);
        // Inline function 'kotlin.uintToULong' call
        // Inline function 'kotlin.uintToLong' call
        var value_1 = _UInt___get_data__impl__f0vqqw(this_1);
        var tmp$ret$8 = fromInt_0(value_1) & 4294967295n;
        var tmp0_0 = _ULong___init__impl__c78o9k(tmp$ret$8);
        // Inline function 'kotlin.ULong.and' call
        var other_0 = this.l2d_1;
        // Inline function 'kotlin.ULong.toUInt' call
        var this_2 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(product) & _ULong___get_data__impl__fggpzb(other_0));
        // Inline function 'kotlin.toUInt' call
        var this_3 = _ULong___get_data__impl__fggpzb(this_2);
        // Inline function 'kotlin.ULong.plus' call
        // Inline function 'kotlin.UInt.toULong' call
        var this_4 = _UInt___init__impl__l7qpdl(convertToInt(this_3));
        // Inline function 'kotlin.uintToULong' call
        // Inline function 'kotlin.uintToLong' call
        var value_2 = _UInt___get_data__impl__f0vqqw(this_4);
        var tmp$ret$14 = fromInt_0(value_2) & 4294967295n;
        // Inline function 'kotlin.ULong.plus' call
        var other_1 = _ULong___init__impl__c78o9k(tmp$ret$14);
        sum = _ULong___init__impl__c78o9k(add_2(_ULong___get_data__impl__fggpzb(tmp0_0), _ULong___get_data__impl__fggpzb(other_1)));
        var tmp0_1 = sum;
        // Inline function 'kotlin.ULong.and' call
        var other_2 = this.l2d_1;
        // Inline function 'kotlin.ULong.toUInt' call
        var this_5 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(tmp0_1) & _ULong___get_data__impl__fggpzb(other_2));
        // Inline function 'kotlin.toUInt' call
        var this_6 = _ULong___get_data__impl__fggpzb(this_5);
        var tmp$ret$21 = _UInt___init__impl__l7qpdl(convertToInt(this_6));
        UIntArray__set_impl_7f2zu2(result, i, tmp$ret$21);
        var tmp0_2 = sum;
        // Inline function 'kotlin.ULong.shr' call
        var bitCount = this.q2d_1;
        sum = _ULong___init__impl__c78o9k(shiftRightUnsigned(_ULong___get_data__impl__fggpzb(tmp0_2), bitCount));
        var tmp = i + 1 | 0;
        // Inline function 'kotlin.ULong.shr' call
        var bitCount_0 = this.q2d_1;
        // Inline function 'kotlin.ULong.toUInt' call
        var this_7 = _ULong___init__impl__c78o9k(shiftRightUnsigned(_ULong___get_data__impl__fggpzb(product), bitCount_0));
        // Inline function 'kotlin.toUInt' call
        var this_8 = _ULong___get_data__impl__fggpzb(this_7);
        var tmp0_3 = _UInt___init__impl__l7qpdl(convertToInt(this_8));
        // Inline function 'kotlin.ULong.toUInt' call
        var this_9 = sum;
        // Inline function 'kotlin.toUInt' call
        var this_10 = _ULong___get_data__impl__fggpzb(this_9);
        // Inline function 'kotlin.UInt.plus' call
        var other_3 = _UInt___init__impl__l7qpdl(convertToInt(this_10));
        var tmp$ret$28 = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(tmp0_3) + _UInt___get_data__impl__f0vqqw(other_3) | 0);
        UIntArray__set_impl_7f2zu2(result, tmp, tmp$ret$28);
      }
       while (inductionVariable < last);
    return this.c2e(result);
  };
  protoOf(BigInteger32Arithmetic).o2e = function (first, second) {
    return this.p2e(first, second);
  };
  protoOf(BigInteger32Arithmetic).p2e = function (unnormalizedDividend, unnormalizedDivisor) {
    if (this.q2e(unnormalizedDivisor, unnormalizedDividend) > 0) {
      return new Pair(new UIntArray(this.s2d_1), new UIntArray(unnormalizedDividend));
    }
    if (_UIntArray___get_size__impl__r6l8ci(unnormalizedDivisor) === 1 && _UIntArray___get_size__impl__r6l8ci(unnormalizedDividend) === 1) {
      var tmp0 = UIntArray__get_impl_gp5kza(unnormalizedDividend, 0);
      // Inline function 'kotlin.UInt.div' call
      var other = UIntArray__get_impl_gp5kza(unnormalizedDivisor, 0);
      var tmp$ret$0 = uintDivide(tmp0, other);
      // Inline function 'kotlin.uintArrayOf' call
      var tmp$ret$1 = _UIntArray___init__impl__ghjpc6(new Int32Array([tmp$ret$0]));
      var tmp = this.c2e(tmp$ret$1);
      var tmp0_0 = UIntArray__get_impl_gp5kza(unnormalizedDividend, 0);
      // Inline function 'kotlin.UInt.rem' call
      var other_0 = UIntArray__get_impl_gp5kza(unnormalizedDivisor, 0);
      var tmp$ret$2 = uintRemainder(tmp0_0, other_0);
      // Inline function 'kotlin.uintArrayOf' call
      var tmp$ret$3 = _UIntArray___init__impl__ghjpc6(new Int32Array([tmp$ret$2]));
      return new Pair(new UIntArray(tmp), new UIntArray(this.c2e(tmp$ret$3)));
    }
    var bitPrecision = this.a2e(unnormalizedDividend) - this.a2e(unnormalizedDivisor) | 0;
    if (bitPrecision === 0) {
      // Inline function 'kotlin.uintArrayOf' call
      var tmp$ret$4 = _UIntArray___init__impl__ghjpc6(new Int32Array([_UInt___init__impl__l7qpdl(1)]));
      return new Pair(new UIntArray(tmp$ret$4), new UIntArray(this.r2e(unnormalizedDividend, unnormalizedDivisor)));
    }
    var _destruct__k2r9zo = this.g2e(unnormalizedDividend, unnormalizedDivisor);
    var dividend = _destruct__k2r9zo.fg().vm_1;
    var divisor = _destruct__k2r9zo.gg().vm_1;
    var normalizationShift = _destruct__k2r9zo.zl();
    var dividendSize = _UIntArray___get_size__impl__r6l8ci(dividend);
    var divisorSize = _UIntArray___get_size__impl__r6l8ci(divisor);
    var wordPrecision = dividendSize - divisorSize | 0;
    var qjhat;
    var reconstructedQuotient;
    var quotient = _UIntArray___init__impl__ghjpc6_0(wordPrecision);
    var divisorTimesBaseToPowerOfM = this.h2e(divisor, imul(wordPrecision, this.q2d_1));
    if (this.q2e(dividend, divisorTimesBaseToPowerOfM) >= 0) {
      quotient = _UIntArray___init__impl__ghjpc6_0(wordPrecision + 1 | 0);
      UIntArray__set_impl_7f2zu2(quotient, wordPrecision, _UInt___init__impl__l7qpdl(1));
      dividend = this.r2e(dividend, divisorTimesBaseToPowerOfM);
    }
    var inductionVariable = wordPrecision - 1 | 0;
    if (0 <= inductionVariable)
      do {
        var j = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        var tmp_0;
        if ((divisorSize + j | 0) < _UIntArray___get_size__impl__r6l8ci(dividend)) {
          // Inline function 'kotlin.UInt.toULong' call
          var this_0 = UIntArray__get_impl_gp5kza(dividend, divisorSize + j | 0);
          // Inline function 'kotlin.uintToULong' call
          // Inline function 'kotlin.uintToLong' call
          var value = _UInt___get_data__impl__f0vqqw(this_0);
          var tmp$ret$5 = fromInt_0(value) & 4294967295n;
          var tmp0_1 = _ULong___init__impl__c78o9k(tmp$ret$5);
          // Inline function 'kotlin.ULong.shl' call
          var bitCount = this.q2d_1;
          var tmp0_2 = _ULong___init__impl__c78o9k(shiftLeft(_ULong___get_data__impl__fggpzb(tmp0_1), bitCount));
          // Inline function 'kotlin.ULong.plus' call
          // Inline function 'kotlin.UInt.toULong' call
          var this_1 = UIntArray__get_impl_gp5kza(dividend, (divisorSize + j | 0) - 1 | 0);
          // Inline function 'kotlin.uintToULong' call
          // Inline function 'kotlin.uintToLong' call
          var value_0 = _UInt___get_data__impl__f0vqqw(this_1);
          var tmp$ret$9 = fromInt_0(value_0) & 4294967295n;
          // Inline function 'kotlin.ULong.plus' call
          var other_1 = _ULong___init__impl__c78o9k(tmp$ret$9);
          var tmp0_3 = _ULong___init__impl__c78o9k(add_2(_ULong___get_data__impl__fggpzb(tmp0_2), _ULong___get_data__impl__fggpzb(other_1)));
          // Inline function 'kotlin.ULong.div' call
          // Inline function 'kotlin.UInt.toULong' call
          var this_2 = UIntArray__get_impl_gp5kza(divisor, divisorSize - 1 | 0);
          // Inline function 'kotlin.uintToULong' call
          // Inline function 'kotlin.uintToLong' call
          var value_1 = _UInt___get_data__impl__f0vqqw(this_2);
          var tmp$ret$14 = fromInt_0(value_1) & 4294967295n;
          // Inline function 'kotlin.ULong.div' call
          var other_2 = _ULong___init__impl__c78o9k(tmp$ret$14);
          tmp_0 = ulongDivide(tmp0_3, other_2);
        } else {
          var tmp_1;
          if ((divisorSize + j | 0) === _UIntArray___get_size__impl__r6l8ci(dividend)) {
            var tmp0_4 = UIntArray__get_impl_gp5kza(dividend, (divisorSize + j | 0) - 1 | 0);
            // Inline function 'kotlin.UInt.div' call
            var other_3 = UIntArray__get_impl_gp5kza(divisor, divisorSize - 1 | 0);
            // Inline function 'kotlin.UInt.toULong' call
            var this_3 = uintDivide(tmp0_4, other_3);
            // Inline function 'kotlin.uintToULong' call
            // Inline function 'kotlin.uintToLong' call
            var value_2 = _UInt___get_data__impl__f0vqqw(this_3);
            var tmp$ret$20 = fromInt_0(value_2) & 4294967295n;
            tmp_1 = _ULong___init__impl__c78o9k(tmp$ret$20);
          } else {
            tmp_1 = _ULong___init__impl__c78o9k(0n);
          }
          tmp_0 = tmp_1;
        }
        qjhat = tmp_0;
        var tmp_2 = quotient;
        var tmp_3;
        var tmp0_5 = this.p2d_1;
        // Inline function 'kotlin.UInt.minus' call
        var other_4 = _ULong___init__impl__c78o9k(1n);
        // Inline function 'kotlin.UInt.toULong' call
        // Inline function 'kotlin.uintToULong' call
        // Inline function 'kotlin.uintToLong' call
        var value_3 = _UInt___get_data__impl__f0vqqw(tmp0_5);
        var tmp$ret$23 = fromInt_0(value_3) & 4294967295n;
        // Inline function 'kotlin.ULong.minus' call
        var this_4 = _ULong___init__impl__c78o9k(tmp$ret$23);
        // Inline function 'kotlin.ULong.compareTo' call
        var other_5 = _ULong___init__impl__c78o9k(subtract_1(_ULong___get_data__impl__fggpzb(this_4), _ULong___get_data__impl__fggpzb(other_4)));
        if (ulongCompare(_ULong___get_data__impl__fggpzb(qjhat), _ULong___get_data__impl__fggpzb(other_5)) < 0) {
          // Inline function 'kotlin.ULong.toUInt' call
          // Inline function 'kotlin.toUInt' call
          var this_5 = _ULong___get_data__impl__fggpzb(qjhat);
          tmp_3 = _UInt___init__impl__l7qpdl(convertToInt(this_5));
        } else {
          var tmp0_6 = this.p2d_1;
          // Inline function 'kotlin.UInt.minus' call
          var other_6 = _UInt___init__impl__l7qpdl(1);
          tmp_3 = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(tmp0_6) - _UInt___get_data__impl__f0vqqw(other_6) | 0);
        }
        UIntArray__set_impl_7f2zu2(tmp_2, j, tmp_3);
        reconstructedQuotient = this.h2e(this.s2e(divisor, UIntArray__get_impl_gp5kza(quotient, j)), imul(j, this.q2d_1));
        while (this.q2e(reconstructedQuotient, dividend) > 0) {
          var tmp_4 = quotient;
          var tmp0_7 = UIntArray__get_impl_gp5kza(quotient, j);
          // Inline function 'kotlin.UInt.minus' call
          var other_7 = _UInt___init__impl__l7qpdl(1);
          var tmp$ret$32 = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(tmp0_7) - _UInt___get_data__impl__f0vqqw(other_7) | 0);
          UIntArray__set_impl_7f2zu2(tmp_4, j, tmp$ret$32);
          reconstructedQuotient = this.h2e(this.s2e(divisor, UIntArray__get_impl_gp5kza(quotient, j)), imul(j, this.q2d_1));
        }
        dividend = this.r2e(dividend, reconstructedQuotient);
      }
       while (0 <= inductionVariable);
    while (this.q2e(dividend, divisor) >= 0) {
      quotient = this.t2e(quotient, _UInt___init__impl__l7qpdl(1));
      dividend = this.r2e(dividend, divisor);
    }
    var denormRemainder = this.i2e(dividend, normalizationShift);
    return new Pair(new UIntArray(this.c2e(quotient)), new UIntArray(denormRemainder));
  };
  protoOf(BigInteger32Arithmetic).h2e = function (_this__u8e3s4, places) {
    return this.e2e(_this__u8e3s4, places);
  };
  protoOf(BigInteger32Arithmetic).j2e = function (_this__u8e3s4, places) {
    return this.f2e(_this__u8e3s4, places);
  };
  protoOf(BigInteger32Arithmetic).r2e = function (_this__u8e3s4, other) {
    return this.m2e(_this__u8e3s4, other);
  };
  protoOf(BigInteger32Arithmetic).t2e = function (_this__u8e3s4, other) {
    // Inline function 'kotlin.uintArrayOf' call
    var tmp$ret$0 = _UIntArray___init__impl__ghjpc6(new Int32Array([other]));
    return this.l2e(_this__u8e3s4, tmp$ret$0);
  };
  protoOf(BigInteger32Arithmetic).s2e = function (_this__u8e3s4, other) {
    return this.n2e(_this__u8e3s4, other);
  };
  protoOf(BigInteger32Arithmetic).q2e = function (_this__u8e3s4, other) {
    return this.k2e(_this__u8e3s4, other);
  };
  var BigInteger32Arithmetic_instance;
  function BigInteger32Arithmetic_getInstance() {
    if (BigInteger32Arithmetic_instance == null)
      new BigInteger32Arithmetic();
    return BigInteger32Arithmetic_instance;
  }
  function multiplyWithCorrectedSize($this, first, second, firstCorrectedSize, secondCorrectedSize) {
    if (isZero_0($this, first) || isZero_0($this, second)) {
      return $this.l2b_1;
    }
    if ((firstCorrectedSize >= 120 || secondCorrectedSize >= 120) && (firstCorrectedSize <= 15000 || secondCorrectedSize < 15000)) {
      return karatsubaMultiplyWithCorrectedSizes($this, first, second, firstCorrectedSize, secondCorrectedSize);
    }
    if (firstCorrectedSize >= 15000 && secondCorrectedSize >= 15000) {
      return $this.u2e(first, second);
    }
    return basecaseMultiplyWithCorrectedSize($this, first, second, firstCorrectedSize, secondCorrectedSize);
  }
  function basecaseMultiplyWithCorrectedSize($this, first, second, firstCorrectedSizeStart, secondCorrectedSizeStart) {
    var resultArray = $this.l2b_1;
    // Inline function 'kotlin.collections.forEachIndexed' call
    var index = 0;
    var _iterator__ex2g4s = ULongArray__iterator_impl_cq4d2h(second);
    while (_iterator__ex2g4s.n()) {
      var item = _iterator__ex2g4s.o().r1_1;
      var _unary__edvuaz = index;
      index = _unary__edvuaz + 1 | 0;
      if (_unary__edvuaz > secondCorrectedSizeStart) {
        new ULongArray(resultArray);
      } else {
        resultArray = BigInteger63Arithmetic_getInstance().x2e(resultArray, BigInteger63Arithmetic_getInstance().w2e(BigInteger63Arithmetic_getInstance().v2e(first, item), imul(_unary__edvuaz, BigInteger63Arithmetic_getInstance().q2b_1)));
      }
    }
    return resultArray;
  }
  function karatsubaMultiplyWithCorrectedSizes($this, firstUnsigned, secondUnsigned, firstCorrectedSize, secondCorrectedSize) {
    var first = new SignedULongArray(firstUnsigned, true);
    var second = new SignedULongArray(secondUnsigned, true);
    // Inline function 'kotlin.math.max' call
    var halfLength = (Math.max(firstCorrectedSize, secondCorrectedSize) + 1 | 0) / 2 | 0;
    var mask = $this.y2e($this.w2e($this.m2b_1, imul(halfLength, $this.r2b_1)), _ULong___init__impl__c78o9k(1n));
    var firstLower = $this.z2e(first, mask);
    var firstHigher = $this.a2f(first, imul(halfLength, $this.r2b_1));
    var secondLower = $this.z2e(second, mask);
    var secondHigher = $this.a2f(second, imul(halfLength, $this.r2b_1));
    var higherProduct = $this.b2f(firstHigher, secondHigher);
    var lowerProduct = $this.b2f(firstLower, secondLower);
    var middleProduct = $this.b2f($this.c2f(firstHigher, firstLower), $this.c2f(secondHigher, secondLower));
    var result = $this.c2f($this.c2f($this.d2f(higherProduct, imul(imul(2, $this.r2b_1), halfLength)), $this.d2f($this.e2f($this.e2f(middleProduct, higherProduct), lowerProduct), imul($this.r2b_1, halfLength))), lowerProduct);
    return result.f2f_1;
  }
  function isZero_0($this, _this__u8e3s4) {
    if (equals(_this__u8e3s4, $this.l2b_1))
      return true;
    if (_ULongArray___get_size__impl__ju6dtr(_this__u8e3s4) === 1 && ULongArray__get_impl_pr71q9(_this__u8e3s4, 0) === _ULong___init__impl__c78o9k(0n))
      return true;
    if ((_ULongArray___get_size__impl__ju6dtr(_this__u8e3s4) - $this.h2f(_this__u8e3s4) | 0) === 0)
      return true;
    return false;
  }
  function SignedULongArray(unsignedValue, sign) {
    this.f2f_1 = unsignedValue;
    this.g2f_1 = sign;
  }
  protoOf(SignedULongArray).i2f = function (unsignedValue, sign) {
    return new SignedULongArray(unsignedValue, sign);
  };
  protoOf(SignedULongArray).j2f = function (unsignedValue, sign, $super) {
    unsignedValue = unsignedValue === VOID ? this.f2f_1 : unsignedValue;
    sign = sign === VOID ? this.g2f_1 : sign;
    return $super === VOID ? this.i2f(unsignedValue, sign) : $super.i2f.call(this, new ULongArray(unsignedValue), sign);
  };
  protoOf(SignedULongArray).toString = function () {
    return 'SignedULongArray(unsignedValue=' + ULongArray__toString_impl_wqk1p5(this.f2f_1) + ', sign=' + this.g2f_1 + ')';
  };
  protoOf(SignedULongArray).hashCode = function () {
    var result = ULongArray__hashCode_impl_aze4wa(this.f2f_1);
    result = imul(result, 31) + getBooleanHashCode(this.g2f_1) | 0;
    return result;
  };
  protoOf(SignedULongArray).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SignedULongArray))
      return false;
    var tmp0_other_with_cast = other instanceof SignedULongArray ? other : THROW_CCE();
    if (!equals(this.f2f_1, tmp0_other_with_cast.f2f_1))
      return false;
    if (!(this.g2f_1 === tmp0_other_with_cast.g2f_1))
      return false;
    return true;
  };
  function signedAdd($this, first, second) {
    var tmp;
    if (!!(first.g2f_1 ^ second.g2f_1)) {
      var tmp_0;
      if ($this.s2c(first.f2f_1, second.f2f_1) > 0) {
        tmp_0 = new SignedULongArray($this.k2f(first.f2f_1, second.f2f_1), first.g2f_1);
      } else {
        tmp_0 = new SignedULongArray($this.k2f(second.f2f_1, first.f2f_1), second.g2f_1);
      }
      tmp = tmp_0;
    } else {
      tmp = new SignedULongArray($this.x2e(first.f2f_1, second.f2f_1), first.g2f_1);
    }
    return tmp;
  }
  function signedSubtract($this, first, second) {
    return signedAdd($this, first, second.j2f(VOID, !second.g2f_1));
  }
  function signedMultiply($this, first, second) {
    return new SignedULongArray($this.l2f(first.f2f_1, second.f2f_1), !!!(first.g2f_1 ^ second.g2f_1));
  }
  function signedDivide($this, first, second) {
    return new SignedULongArray($this.m2f(first.f2f_1, second.f2f_1), !!!(first.g2f_1 ^ second.g2f_1));
  }
  function BigInteger63Arithmetic() {
    BigInteger63Arithmetic_instance = this;
    var tmp = this;
    // Inline function 'kotlin.longArrayOf' call
    tmp.k2b_1 = longArrayOf([]);
    var tmp_0 = this;
    // Inline function 'kotlin.ulongArrayOf' call
    tmp_0.l2b_1 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(0n)]));
    var tmp_1 = this;
    // Inline function 'kotlin.ulongArrayOf' call
    tmp_1.m2b_1 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(1n)]));
    var tmp_2 = this;
    // Inline function 'kotlin.ulongArrayOf' call
    tmp_2.n2b_1 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(2n)]));
    var tmp_3 = this;
    // Inline function 'kotlin.ulongArrayOf' call
    tmp_3.o2b_1 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(10n)]));
    var tmp_4 = this;
    // Inline function 'kotlin.ulongArrayOf' call
    tmp_4.p2b_1 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(3074457345618258603n)]));
    this.q2b_1 = 63;
    this.r2b_1 = 63;
    this.s2b_1 = _ULong___init__impl__c78o9k(9223372036854775807n);
    var tmp_5 = this;
    // Inline function 'kotlin.ulongArrayOf' call
    tmp_5.t2b_1 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(9223372036854775807n)]));
    this.u2b_1 = _ULong___init__impl__c78o9k(4294967295n);
    this.v2b_1 = _ULong___init__impl__c78o9k(9223372032559808512n);
    this.w2b_1 = _ULong___init__impl__c78o9k(-9223372036854775808n);
    this.x2b_1 = 120;
    this.y2b_1 = 15000;
    this.z2b_1 = false;
    this.a2c_1 = new SignedULongArray(BigInteger63Arithmetic_getInstance().n2b_1, true);
    var tmp_6 = this;
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_7 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(1n)]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_8 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(10n)]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_9 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(100n)]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_10 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(1000n)]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_11 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(10000n)]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_12 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(100000n)]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_13 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(1000000n)]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_14 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(10000000n)]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_15 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(100000000n)]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_16 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(1000000000n)]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_17 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(10000000000n)]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_18 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(100000000000n)]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_19 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(1000000000000n)]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_20 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(10000000000000n)]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_21 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(100000000000000n)]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_22 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(1000000000000000n)]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_23 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(10000000000000000n)]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_24 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(100000000000000000n)]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_25 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(1000000000000000000n)]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_26 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(776627963145224192n), _ULong___init__impl__c78o9k(1n)]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_27 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(7766279631452241920n), _ULong___init__impl__c78o9k(10n)]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_28 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(3875820019684212736n), _ULong___init__impl__c78o9k(108n)]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_29 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(1864712049423024128n), _ULong___init__impl__c78o9k(1084n)]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_30 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(200376420520689664n), _ULong___init__impl__c78o9k(10842n)]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_31 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(2003764205206896640n), _ULong___init__impl__c78o9k(108420n)]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_32 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(1590897978359414784n), _ULong___init__impl__c78o9k(1084202n)]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_33 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(6685607746739372032n), _ULong___init__impl__c78o9k(10842021n)]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_34 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(2292473209410289664n), _ULong___init__impl__c78o9k(108420217n)]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_35 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(4477988020393345024n), _ULong___init__impl__c78o9k(1084202172n)]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_36 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(7886392056514347008n), _ULong___init__impl__c78o9k(10842021724n)]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_37 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(5076944270305263616n), _ULong___init__impl__c78o9k(108420217248n)]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_38 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(4652582518778757120n), _ULong___init__impl__c78o9k(1084202172485n)]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_39 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(408965003513692160n), _ULong___init__impl__c78o9k(10842021724855n)]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_40 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(4089650035136921600n), _ULong___init__impl__c78o9k(108420217248550n)]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_41 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(4003012203950112768n), _ULong___init__impl__c78o9k(1084202172485504n)]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_42 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(3136633892082024448n), _ULong___init__impl__c78o9k(10842021724855044n)]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_43 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(3696222810255917056n), _ULong___init__impl__c78o9k(108420217248550443n)]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_44 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(68739955140067328n), _ULong___init__impl__c78o9k(1084202172485504434n)]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_45 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(687399551400673280n), _ULong___init__impl__c78o9k(1618649688000268532n), _ULong___init__impl__c78o9k(1n)]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_46 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(6873995514006732800n), _ULong___init__impl__c78o9k(6963124843147909512n), _ULong___init__impl__c78o9k(11n)]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_47 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(4176350882083897344n), _ULong___init__impl__c78o9k(5067644173495664471n), _ULong___init__impl__c78o9k(117n)]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_48 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(4870020673419870208n), _ULong___init__impl__c78o9k(4559581550682765674n), _ULong___init__impl__c78o9k(1175n)]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_49 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(2583346549924823040n), _ULong___init__impl__c78o9k(8702327359408553513n), _ULong___init__impl__c78o9k(11754n)]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_50 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(7386721425538678784n), _ULong___init__impl__c78o9k(4012925262392552860n), _ULong___init__impl__c78o9k(117549n)]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_51 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(80237960548581376n), _ULong___init__impl__c78o9k(3235764476506425376n), _ULong___init__impl__c78o9k(1175494n)]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_52 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(802379605485813760n), _ULong___init__impl__c78o9k(4687528654499926336n), _ULong___init__impl__c78o9k(11754943n)]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_53 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(8023796054858137600n), _ULong___init__impl__c78o9k(758426360725384320n), _ULong___init__impl__c78o9k(117549435n)]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_54 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(6450984253743169536n), _ULong___init__impl__c78o9k(7584263607253843208n), _ULong___init__impl__c78o9k(1175494350n)]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_55 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(9169610316303040512n), _ULong___init__impl__c78o9k(2055659777700225622n), _ULong___init__impl__c78o9k(11754943508n)]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_56 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(8685754831337422848n), _ULong___init__impl__c78o9k(2109853703292704613n), _ULong___init__impl__c78o9k(117549435082n)]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_57 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(3847199981681246208n), _ULong___init__impl__c78o9k(2651792959217494523n), _ULong___init__impl__c78o9k(1175494350822n)]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_58 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(1578511669393358848n), _ULong___init__impl__c78o9k(8071185518465393618n), _ULong___init__impl__c78o9k(11754943508222n)]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_59 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(6561744657078812672n), _ULong___init__impl__c78o9k(6924878889815729717n), _ULong___init__impl__c78o9k(117549435082228n)]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_60 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(1053842312804696064n), _ULong___init__impl__c78o9k(4685184640173866521n), _ULong___init__impl__c78o9k(1175494350822287n)]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_61 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(1315051091192184832n), _ULong___init__impl__c78o9k(734986217464786171n), _ULong___init__impl__c78o9k(11754943508222875n)]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_62 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(3927138875067072512n), _ULong___init__impl__c78o9k(7349862174647861711n), _ULong___init__impl__c78o9k(117549435082228750n)]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_63 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(2377900603251621888n), _ULong___init__impl__c78o9k(8935017488495186458n), _ULong___init__impl__c78o9k(1175494350822287507n)]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_64 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(5332261958806667264n), _ULong___init__impl__c78o9k(6339826553258882310n), _ULong___init__impl__c78o9k(2531571471368099271n), _ULong___init__impl__c78o9k(1n)]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_65 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(7205759403792793600n), _ULong___init__impl__c78o9k(8058033311460168257n), _ULong___init__impl__c78o9k(6868970639971441100n), _ULong___init__impl__c78o9k(12n)]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_66 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(7493989779944505344n), _ULong___init__impl__c78o9k(6793356819763476113n), _ULong___init__impl__c78o9k(4126102141730980352n), _ULong___init__impl__c78o9k(127n)]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_67 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(1152921504606846976n), _ULong___init__impl__c78o9k(3369963939651330482n), _ULong___init__impl__c78o9k(4367533269890700295n), _ULong___init__impl__c78o9k(1274n)]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_68 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(2305843009213693952n), _ULong___init__impl__c78o9k(6029523285948977397n), _ULong___init__impl__c78o9k(6781844551487899721n), _ULong___init__impl__c78o9k(12744n)]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_69 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(4611686018427387904n), _ULong___init__impl__c78o9k(4955000638361119124n), _ULong___init__impl__c78o9k(3254841256895566560n), _ULong___init__impl__c78o9k(127447n)]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_70 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(0n), _ULong___init__impl__c78o9k(3433146199337312205n), _ULong___init__impl__c78o9k(4878296458391338181n), _ULong___init__impl__c78o9k(1274473n)]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_71 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(0n), _ULong___init__impl__c78o9k(6661345882808794626n), _ULong___init__impl__c78o9k(2666104399639502773n), _ULong___init__impl__c78o9k(12744735n)]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_72 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(0n), _ULong___init__impl__c78o9k(2049854570104515604n), _ULong___init__impl__c78o9k(8214299922685476121n), _ULong___init__impl__c78o9k(127447352n)]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_73 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(0n), _ULong___init__impl__c78o9k(2051801627335604424n), _ULong___init__impl__c78o9k(8356022932016554748n), _ULong___init__impl__c78o9k(1274473528n)]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_74 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(0n), _ULong___init__impl__c78o9k(2071272199646492624n), _ULong___init__impl__c78o9k(549880988472565210n), _ULong___init__impl__c78o9k(12744735289n)]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_75 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(0n), _ULong___init__impl__c78o9k(2265977922755374624n), _ULong___init__impl__c78o9k(5498809884725652102n), _ULong___init__impl__c78o9k(127447352890n)]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_76 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(0n), _ULong___init__impl__c78o9k(4213035153844194624n), _ULong___init__impl__c78o9k(8871238662982641982n), _ULong___init__impl__c78o9k(1274473528905n)]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_77 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(0n), _ULong___init__impl__c78o9k(5236863391022843008n), _ULong___init__impl__c78o9k(5702038298133437552n), _ULong___init__impl__c78o9k(12744735289059n)]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_78 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(0n), _ULong___init__impl__c78o9k(6251773725954551040n), _ULong___init__impl__c78o9k(1680150760205720677n), _ULong___init__impl__c78o9k(127447352890596n)]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_79 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(0n), _ULong___init__impl__c78o9k(7177505038416855552n), _ULong___init__impl__c78o9k(7578135565202430968n), _ULong___init__impl__c78o9k(1274473528905961n)]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_80 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(0n), _ULong___init__impl__c78o9k(7211446126185124864n), _ULong___init__impl__c78o9k(1994379357186103223n), _ULong___init__impl__c78o9k(12744735289059618n)]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_81 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(0n), _ULong___init__impl__c78o9k(7550857003867817984n), _ULong___init__impl__c78o9k(1497049498151480621n), _ULong___init__impl__c78o9k(127447352890596182n)]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_82 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(0n), _ULong___init__impl__c78o9k(1721593743839973376n), _ULong___init__impl__c78o9k(5747122944660030410n), _ULong___init__impl__c78o9k(1274473528905961821n)]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_83 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(0n), _ULong___init__impl__c78o9k(7992565401544957952n), _ULong___init__impl__c78o9k(2130997225471649253n), _ULong___init__impl__c78o9k(3521363252204842408n), _ULong___init__impl__c78o9k(1n)]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_84 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(0n), _ULong___init__impl__c78o9k(6138677720611373056n), _ULong___init__impl__c78o9k(2863228181006940922n), _ULong___init__impl__c78o9k(7543516411484096658n), _ULong___init__impl__c78o9k(13n)]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_85 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(0n), _ULong___init__impl__c78o9k(6046544984985075712n), _ULong___init__impl__c78o9k(962165699505081802n), _ULong___init__impl__c78o9k(1648187820002760119n), _ULong___init__impl__c78o9k(138n)]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_86 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(0n), _ULong___init__impl__c78o9k(5125217628722102272n), _ULong___init__impl__c78o9k(398284958196042218n), _ULong___init__impl__c78o9k(7258506163172825383n), _ULong___init__impl__c78o9k(1381n)]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_87 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(0n), _ULong___init__impl__c78o9k(5135316102947143680n), _ULong___init__impl__c78o9k(3982849581960422185n), _ULong___init__impl__c78o9k(8021457373744823174n), _ULong___init__impl__c78o9k(13817n)]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_88 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(0n), _ULong___init__impl__c78o9k(5236300845197557760n), _ULong___init__impl__c78o9k(2935007672185118623n), _ULong___init__impl__c78o9k(6427597442610025280n), _ULong___init__impl__c78o9k(138178n)]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_89 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(0n), _ULong___init__impl__c78o9k(6246148267701698560n), _ULong___init__impl__c78o9k(1679960611286858811n), _ULong___init__impl__c78o9k(8935742204971597955n), _ULong___init__impl__c78o9k(1381786n)]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_90 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(0n), _ULong___init__impl__c78o9k(7121250455888330752n), _ULong___init__impl__c78o9k(7576234076013812308n), _ULong___init__impl__c78o9k(6347073718022997279n), _ULong___init__impl__c78o9k(13817869n)]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_91 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(0n), _ULong___init__impl__c78o9k(6648900300899876864n), _ULong___init__impl__c78o9k(1975364465299916623n), _ULong___init__impl__c78o9k(8130504959101317950n), _ULong___init__impl__c78o9k(138178696n)]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_92 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(0n), _ULong___init__impl__c78o9k(1925398751015337984n), _ULong___init__impl__c78o9k(1306900579289614621n), _ULong___init__impl__c78o9k(7518073296174973038n), _ULong___init__impl__c78o9k(1381786968n)]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_93 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(0n), _ULong___init__impl__c78o9k(807243436443828224n), _ULong___init__impl__c78o9k(3845633756041370404n), _ULong___init__impl__c78o9k(1393756666911523917n), _ULong___init__impl__c78o9k(13817869688n)]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_94 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(0n), _ULong___init__impl__c78o9k(8072434364438282240n), _ULong___init__impl__c78o9k(1562849412994600808n), _ULong___init__impl__c78o9k(4714194632260463366n), _ULong___init__impl__c78o9k(138178696881n)]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_95 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(0n), _ULong___init__impl__c78o9k(6937367349544615936n), _ULong___init__impl__c78o9k(6405122093091232280n), _ULong___init__impl__c78o9k(1025086138330754621n), _ULong___init__impl__c78o9k(1381786968815n)]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_96 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(0n), _ULong___init__impl__c78o9k(4810069237462728704n), _ULong___init__impl__c78o9k(8710988709783667959n), _ULong___init__impl__c78o9k(1027489346452770408n), _ULong___init__impl__c78o9k(13817869688151n)]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_97 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(0n), _ULong___init__impl__c78o9k(1983832190353408000n), _ULong___init__impl__c78o9k(4099538766143697323n), _ULong___init__impl__c78o9k(1051521427672928281n), _ULong___init__impl__c78o9k(138178696881511n)]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_98 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(0n), _ULong___init__impl__c78o9k(1391577829824528384n), _ULong___init__impl__c78o9k(4101899514017870000n), _ULong___init__impl__c78o9k(1291842239874507006n), _ULong___init__impl__c78o9k(1381786968815111n)]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_99 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(0n), _ULong___init__impl__c78o9k(4692406261390508032n), _ULong___init__impl__c78o9k(4125506992759596769n), _ULong___init__impl__c78o9k(3695050361890294256n), _ULong___init__impl__c78o9k(13817869688151111n)]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_100 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(0n), _ULong___init__impl__c78o9k(807202429631201280n), _ULong___init__impl__c78o9k(4361581780176864463n), _ULong___init__impl__c78o9k(57015471483839332n), _ULong___init__impl__c78o9k(138178696881511114n)]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_101 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(0n), _ULong___init__impl__c78o9k(8072024296312012800n), _ULong___init__impl__c78o9k(6722329654349541398n), _ULong___init__impl__c78o9k(570154714838393324n), _ULong___init__impl__c78o9k(1381786968815111140n)]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_102 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(0n), _ULong___init__impl__c78o9k(6933266668281921536n), _ULong___init__impl__c78o9k(2659692285511983332n), _ULong___init__impl__c78o9k(5701547148383933247n), _ULong___init__impl__c78o9k(4594497651296335592n), _ULong___init__impl__c78o9k(1n)]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_103 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(0n), _ULong___init__impl__c78o9k(4769062424835784704n), _ULong___init__impl__c78o9k(8150178781410281711n), _ULong___init__impl__c78o9k(1675239262710677624n), _ULong___init__impl__c78o9k(9051488365544252694n), _ULong___init__impl__c78o9k(14n)]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_104 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(0n), _ULong___init__impl__c78o9k(1573764064083968000n), _ULong___init__impl__c78o9k(7714811519264610651n), _ULong___init__impl__c78o9k(7529020590252000440n), _ULong___init__impl__c78o9k(7504535323749544669n), _ULong___init__impl__c78o9k(149n)]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_105 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(0n), _ULong___init__impl__c78o9k(6514268603984904192n), _ULong___init__impl__c78o9k(3361138897807900047n), _ULong___init__impl__c78o9k(1503229607681797944n), _ULong___init__impl__c78o9k(1258376942657240234n), _ULong___init__impl__c78o9k(1498n)]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_106 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(0n), _ULong___init__impl__c78o9k(579081781865611264n), _ULong___init__impl__c78o9k(5941272867514673053n), _ULong___init__impl__c78o9k(5808924039963203635n), _ULong___init__impl__c78o9k(3360397389717626533n), _ULong___init__impl__c78o9k(14981n)]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp$ret$107 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(0n), _ULong___init__impl__c78o9k(5790817818656112640n), _ULong___init__impl__c78o9k(4072496454018075682n), _ULong___init__impl__c78o9k(2749008178503381508n), _ULong___init__impl__c78o9k(5933857786611937912n), _ULong___init__impl__c78o9k(149813n)]));
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_6.b2c_1 = [new ULongArray(tmp_7), new ULongArray(tmp_8), new ULongArray(tmp_9), new ULongArray(tmp_10), new ULongArray(tmp_11), new ULongArray(tmp_12), new ULongArray(tmp_13), new ULongArray(tmp_14), new ULongArray(tmp_15), new ULongArray(tmp_16), new ULongArray(tmp_17), new ULongArray(tmp_18), new ULongArray(tmp_19), new ULongArray(tmp_20), new ULongArray(tmp_21), new ULongArray(tmp_22), new ULongArray(tmp_23), new ULongArray(tmp_24), new ULongArray(tmp_25), new ULongArray(tmp_26), new ULongArray(tmp_27), new ULongArray(tmp_28), new ULongArray(tmp_29), new ULongArray(tmp_30), new ULongArray(tmp_31), new ULongArray(tmp_32), new ULongArray(tmp_33), new ULongArray(tmp_34), new ULongArray(tmp_35), new ULongArray(tmp_36), new ULongArray(tmp_37), new ULongArray(tmp_38), new ULongArray(tmp_39), new ULongArray(tmp_40), new ULongArray(tmp_41), new ULongArray(tmp_42), new ULongArray(tmp_43), new ULongArray(tmp_44), new ULongArray(tmp_45), new ULongArray(tmp_46), new ULongArray(tmp_47), new ULongArray(tmp_48), new ULongArray(tmp_49), new ULongArray(tmp_50), new ULongArray(tmp_51), new ULongArray(tmp_52), new ULongArray(tmp_53), new ULongArray(tmp_54), new ULongArray(tmp_55), new ULongArray(tmp_56), new ULongArray(tmp_57), new ULongArray(tmp_58), new ULongArray(tmp_59), new ULongArray(tmp_60), new ULongArray(tmp_61), new ULongArray(tmp_62), new ULongArray(tmp_63), new ULongArray(tmp_64), new ULongArray(tmp_65), new ULongArray(tmp_66), new ULongArray(tmp_67), new ULongArray(tmp_68), new ULongArray(tmp_69), new ULongArray(tmp_70), new ULongArray(tmp_71), new ULongArray(tmp_72), new ULongArray(tmp_73), new ULongArray(tmp_74), new ULongArray(tmp_75), new ULongArray(tmp_76), new ULongArray(tmp_77), new ULongArray(tmp_78), new ULongArray(tmp_79), new ULongArray(tmp_80), new ULongArray(tmp_81), new ULongArray(tmp_82), new ULongArray(tmp_83), new ULongArray(tmp_84), new ULongArray(tmp_85), new ULongArray(tmp_86), new ULongArray(tmp_87), new ULongArray(tmp_88), new ULongArray(tmp_89), new ULongArray(tmp_90), new ULongArray(tmp_91), new ULongArray(tmp_92), new ULongArray(tmp_93), new ULongArray(tmp_94), new ULongArray(tmp_95), new ULongArray(tmp_96), new ULongArray(tmp_97), new ULongArray(tmp_98), new ULongArray(tmp_99), new ULongArray(tmp_100), new ULongArray(tmp_101), new ULongArray(tmp_102), new ULongArray(tmp_103), new ULongArray(tmp_104), new ULongArray(tmp_105), new ULongArray(tmp_106), new ULongArray(tmp$ret$107)];
  }
  protoOf(BigInteger63Arithmetic).v2a = function () {
    return this.l2b_1;
  };
  protoOf(BigInteger63Arithmetic).w2a = function () {
    return this.m2b_1;
  };
  protoOf(BigInteger63Arithmetic).x2a = function () {
    return this.n2b_1;
  };
  protoOf(BigInteger63Arithmetic).y2a = function () {
    return this.o2b_1;
  };
  protoOf(BigInteger63Arithmetic).n2f = function (value) {
    var x = value;
    var y;
    var n = 63;
    // Inline function 'kotlin.ULong.shr' call
    var this_0 = x;
    y = _ULong___init__impl__c78o9k(shiftRightUnsigned(_ULong___get_data__impl__fggpzb(this_0), 32));
    if (!(y === _ULong___init__impl__c78o9k(0n))) {
      n = n - 32 | 0;
      x = y;
    }
    // Inline function 'kotlin.ULong.shr' call
    var this_1 = x;
    y = _ULong___init__impl__c78o9k(shiftRightUnsigned(_ULong___get_data__impl__fggpzb(this_1), 16));
    if (!(y === _ULong___init__impl__c78o9k(0n))) {
      n = n - 16 | 0;
      x = y;
    }
    // Inline function 'kotlin.ULong.shr' call
    var this_2 = x;
    y = _ULong___init__impl__c78o9k(shiftRightUnsigned(_ULong___get_data__impl__fggpzb(this_2), 8));
    if (!(y === _ULong___init__impl__c78o9k(0n))) {
      n = n - 8 | 0;
      x = y;
    }
    // Inline function 'kotlin.ULong.shr' call
    var this_3 = x;
    y = _ULong___init__impl__c78o9k(shiftRightUnsigned(_ULong___get_data__impl__fggpzb(this_3), 4));
    if (!(y === _ULong___init__impl__c78o9k(0n))) {
      n = n - 4 | 0;
      x = y;
    }
    // Inline function 'kotlin.ULong.shr' call
    var this_4 = x;
    y = _ULong___init__impl__c78o9k(shiftRightUnsigned(_ULong___get_data__impl__fggpzb(this_4), 2));
    if (!(y === _ULong___init__impl__c78o9k(0n))) {
      n = n - 2 | 0;
      x = y;
    }
    // Inline function 'kotlin.ULong.shr' call
    var this_5 = x;
    y = _ULong___init__impl__c78o9k(shiftRightUnsigned(_ULong___get_data__impl__fggpzb(this_5), 1));
    if (!(y === _ULong___init__impl__c78o9k(0n))) {
      return n - 2 | 0;
    }
    var tmp = n;
    // Inline function 'kotlin.ULong.toInt' call
    var this_6 = x;
    return tmp - convertToInt(_ULong___get_data__impl__fggpzb(this_6)) | 0;
  };
  protoOf(BigInteger63Arithmetic).o2f = function (value) {
    if (isZero_0(this, value)) {
      return 0;
    }
    var start = (_ULongArray___get_size__impl__ju6dtr(value) - this.h2f(value) | 0) - 1 | 0;
    var mostSignificant = ULongArray__get_impl_pr71q9(value, start);
    return this.p2f(mostSignificant) + imul(start, 63) | 0;
  };
  protoOf(BigInteger63Arithmetic).p2f = function (value) {
    return 63 - this.n2f(value) | 0;
  };
  protoOf(BigInteger63Arithmetic).c2c = function (bigInteger) {
    var correctedSize = _ULongArray___get_size__impl__ju6dtr(bigInteger) - this.h2f(bigInteger) | 0;
    if (correctedSize === 0) {
      return this.l2b_1;
    }
    if (_ULongArray___get_size__impl__ju6dtr(bigInteger) === correctedSize) {
      return bigInteger;
    }
    if (false && (_ULongArray___get_size__impl__ju6dtr(bigInteger) - correctedSize | 0) > 1000) {
      println('RLZ original array : ' + _ULongArray___get_size__impl__ju6dtr(bigInteger) + ' contains: ' + ((_ULongArray___get_size__impl__ju6dtr(bigInteger) - correctedSize | 0) - 1 | 0) + ' zeros');
    }
    // Inline function 'kotlin.collections.copyOfRange' call
    return _ULongArray___init__impl__twm1l3(copyOfRange(_ULongArray___get_storage__impl__28e64j(bigInteger), 0, correctedSize));
  };
  protoOf(BigInteger63Arithmetic).h2f = function (bigInteger) {
    var lastNonEmptyIndex = _ULongArray___get_size__impl__ju6dtr(bigInteger) - 1 | 0;
    if (lastNonEmptyIndex <= 0) {
      return 0;
    }
    var element = ULongArray__get_impl_pr71q9(bigInteger, lastNonEmptyIndex);
    while (element === _ULong___init__impl__c78o9k(0n) && lastNonEmptyIndex > 0) {
      lastNonEmptyIndex = lastNonEmptyIndex - 1 | 0;
      element = ULongArray__get_impl_pr71q9(bigInteger, lastNonEmptyIndex);
    }
    if (ULongArray__get_impl_pr71q9(bigInteger, lastNonEmptyIndex) === _ULong___init__impl__c78o9k(0n)) {
      lastNonEmptyIndex = lastNonEmptyIndex - 1 | 0;
    }
    return (_ULongArray___get_size__impl__ju6dtr(bigInteger) - lastNonEmptyIndex | 0) - 1 | 0;
  };
  protoOf(BigInteger63Arithmetic).q2f = function (operand, places) {
    if (isZero_0(this, operand)) {
      return operand;
    }
    if (places === 0) {
      return operand;
    }
    if (ULongArray__isEmpty_impl_c3yngu(operand)) {
      return this.l2b_1;
    }
    var leadingZeroWords = this.h2f(operand);
    if (_ULongArray___get_size__impl__ju6dtr(operand) === leadingZeroWords) {
      return this.l2b_1;
    }
    var originalSize = _ULongArray___get_size__impl__ju6dtr(operand) - leadingZeroWords | 0;
    var leadingZeros = this.n2f(ULongArray__get_impl_pr71q9(operand, originalSize - 1 | 0));
    var shiftWords = places / this.q2b_1 | 0;
    var shiftBits = places % this.q2b_1 | 0;
    var tmp;
    if (shiftBits > leadingZeros) {
      tmp = shiftWords + 1 | 0;
    } else {
      tmp = shiftWords;
    }
    var wordsNeeded = tmp;
    if (shiftBits === 0) {
      // Inline function 'kotlin.ULongArray' call
      var tmp_0 = 0;
      var tmp_1 = originalSize + wordsNeeded | 0;
      var tmp_2 = longArray(tmp_1);
      while (tmp_0 < tmp_1) {
        var tmp_3 = tmp_0;
        // Inline function 'kotlin.ULong.toLong' call
        var this_0 = (0 <= tmp_3 ? tmp_3 < shiftWords : false) ? _ULong___init__impl__c78o9k(0n) : ULongArray__get_impl_pr71q9(operand, tmp_3 - shiftWords | 0);
        tmp_2[tmp_3] = _ULong___get_data__impl__fggpzb(this_0);
        tmp_0 = tmp_0 + 1 | 0;
      }
      return _ULongArray___init__impl__twm1l3(tmp_2);
    }
    // Inline function 'kotlin.ULongArray' call
    var tmp_4 = 0;
    var tmp_5 = originalSize + wordsNeeded | 0;
    var tmp_6 = longArray(tmp_5);
    while (tmp_4 < tmp_5) {
      var tmp_7 = tmp_4;
      var tmp_8;
      if (0 <= tmp_7 ? tmp_7 < shiftWords : false) {
        tmp_8 = _ULong___init__impl__c78o9k(0n);
      } else {
        if (tmp_7 === shiftWords) {
          // Inline function 'kotlin.ULong.shl' call
          var this_1 = ULongArray__get_impl_pr71q9(operand, tmp_7 - shiftWords | 0);
          var tmp0 = _ULong___init__impl__c78o9k(shiftLeft(_ULong___get_data__impl__fggpzb(this_1), shiftBits));
          // Inline function 'kotlin.ULong.and' call
          var other = BigInteger63Arithmetic_getInstance().s2b_1;
          tmp_8 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(tmp0) & _ULong___get_data__impl__fggpzb(other));
        } else {
          var containsLower = shiftWords + 1 | 0;
          if (tmp_7 < (originalSize + shiftWords | 0) ? containsLower <= tmp_7 : false) {
            // Inline function 'kotlin.ULong.shl' call
            var this_2 = ULongArray__get_impl_pr71q9(operand, tmp_7 - shiftWords | 0);
            var tmp0_0 = _ULong___init__impl__c78o9k(shiftLeft(_ULong___get_data__impl__fggpzb(this_2), shiftBits));
            // Inline function 'kotlin.ULong.and' call
            var other_0 = BigInteger63Arithmetic_getInstance().s2b_1;
            var tmp0_1 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(tmp0_0) & _ULong___get_data__impl__fggpzb(other_0));
            var tmp0_2 = ULongArray__get_impl_pr71q9(operand, (tmp_7 - shiftWords | 0) - 1 | 0);
            // Inline function 'kotlin.ULong.shr' call
            var bitCount = BigInteger63Arithmetic_getInstance().q2b_1 - shiftBits | 0;
            // Inline function 'kotlin.ULong.or' call
            var other_1 = _ULong___init__impl__c78o9k(shiftRightUnsigned(_ULong___get_data__impl__fggpzb(tmp0_2), bitCount));
            tmp_8 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(tmp0_1) | _ULong___get_data__impl__fggpzb(other_1));
          } else {
            if (tmp_7 === ((originalSize + wordsNeeded | 0) - 1 | 0)) {
              var tmp0_3 = ULongArray__get_impl_pr71q9(operand, tmp_7 - wordsNeeded | 0);
              // Inline function 'kotlin.ULong.shr' call
              var bitCount_0 = BigInteger63Arithmetic_getInstance().q2b_1 - shiftBits | 0;
              tmp_8 = _ULong___init__impl__c78o9k(shiftRightUnsigned(_ULong___get_data__impl__fggpzb(tmp0_3), bitCount_0));
            } else {
              throw RuntimeException_init_$Create$_0('Invalid case ' + tmp_7);
            }
          }
        }
      }
      // Inline function 'kotlin.ULong.toLong' call
      var this_3 = tmp_8;
      tmp_6[tmp_7] = _ULong___get_data__impl__fggpzb(this_3);
      tmp_4 = tmp_4 + 1 | 0;
    }
    return _ULongArray___init__impl__twm1l3(tmp_6);
  };
  protoOf(BigInteger63Arithmetic).r2f = function (operand, places) {
    if (ULongArray__isEmpty_impl_c3yngu(operand) || places === 0) {
      return operand;
    }
    var leadingZeroWords = this.h2f(operand);
    var realOperandSize = _ULongArray___get_size__impl__ju6dtr(operand) - leadingZeroWords | 0;
    var shiftBits = places % this.q2b_1 | 0;
    var wordsToDiscard = places / this.q2b_1 | 0;
    if (wordsToDiscard >= realOperandSize) {
      return this.l2b_1;
    }
    if (shiftBits === 0) {
      // Inline function 'kotlin.collections.copyOfRange' call
      var fromIndex = realOperandSize - wordsToDiscard | 0;
      _ULongArray___init__impl__twm1l3(copyOfRange(_ULongArray___get_storage__impl__28e64j(operand), fromIndex, realOperandSize));
    }
    if (realOperandSize > 1 && (realOperandSize - wordsToDiscard | 0) === 1) {
      // Inline function 'kotlin.ULong.shr' call
      var this_0 = ULongArray__get_impl_pr71q9(operand, realOperandSize - 1 | 0);
      var tmp$ret$1 = _ULong___init__impl__c78o9k(shiftRightUnsigned(_ULong___get_data__impl__fggpzb(this_0), shiftBits));
      // Inline function 'kotlin.ulongArrayOf' call
      return _ULongArray___init__impl__twm1l3(longArrayOf([tmp$ret$1]));
    }
    var newLength = realOperandSize - wordsToDiscard | 0;
    if (newLength === 0) {
      return this.l2b_1;
    }
    // Inline function 'kotlin.ULongArray' call
    var tmp = 0;
    var tmp_0 = realOperandSize - wordsToDiscard | 0;
    var tmp_1 = longArray(tmp_0);
    while (tmp < tmp_0) {
      var tmp_2 = tmp;
      var tmp_3;
      if (0 <= tmp_2 ? tmp_2 < ((realOperandSize - 1 | 0) - wordsToDiscard | 0) : false) {
        // Inline function 'kotlin.ULong.shr' call
        var this_1 = ULongArray__get_impl_pr71q9(operand, tmp_2 + wordsToDiscard | 0);
        var tmp0 = _ULong___init__impl__c78o9k(shiftRightUnsigned(_ULong___get_data__impl__fggpzb(this_1), shiftBits));
        var tmp0_0 = ULongArray__get_impl_pr71q9(operand, (tmp_2 + wordsToDiscard | 0) + 1 | 0);
        // Inline function 'kotlin.ULong.shl' call
        var bitCount = BigInteger63Arithmetic_getInstance().q2b_1 - shiftBits | 0;
        var tmp0_1 = _ULong___init__impl__c78o9k(shiftLeft(_ULong___get_data__impl__fggpzb(tmp0_0), bitCount));
        // Inline function 'kotlin.ULong.and' call
        var other = BigInteger63Arithmetic_getInstance().s2b_1;
        // Inline function 'kotlin.ULong.or' call
        var other_0 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(tmp0_1) & _ULong___get_data__impl__fggpzb(other));
        tmp_3 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(tmp0) | _ULong___get_data__impl__fggpzb(other_0));
      } else if (tmp_2 === ((realOperandSize - 1 | 0) - wordsToDiscard | 0)) {
        // Inline function 'kotlin.ULong.shr' call
        var this_2 = ULongArray__get_impl_pr71q9(operand, tmp_2 + wordsToDiscard | 0);
        tmp_3 = _ULong___init__impl__c78o9k(shiftRightUnsigned(_ULong___get_data__impl__fggpzb(this_2), shiftBits));
      } else {
        throw RuntimeException_init_$Create$_0('Invalid case ' + tmp_2);
      }
      // Inline function 'kotlin.ULong.toLong' call
      var this_3 = tmp_3;
      tmp_1[tmp_2] = _ULong___get_data__impl__fggpzb(this_3);
      tmp = tmp + 1 | 0;
    }
    var result = _ULongArray___init__impl__twm1l3(tmp_1);
    return result;
  };
  protoOf(BigInteger63Arithmetic).s2f = function (first, second, firstStart, secondStart) {
    if (firstStart > secondStart) {
      return 1;
    }
    if (secondStart > firstStart) {
      return -1;
    }
    var counter = firstStart - 1 | 0;
    var firstIsLarger = false;
    var bothAreEqual = true;
    $l$loop_0: while (counter >= 0) {
      var tmp0 = ULongArray__get_impl_pr71q9(first, counter);
      // Inline function 'kotlin.ULong.compareTo' call
      var other = ULongArray__get_impl_pr71q9(second, counter);
      if (ulongCompare(_ULong___get_data__impl__fggpzb(tmp0), _ULong___get_data__impl__fggpzb(other)) > 0) {
        firstIsLarger = true;
        bothAreEqual = false;
        break $l$loop_0;
      }
      var tmp0_0 = ULongArray__get_impl_pr71q9(first, counter);
      // Inline function 'kotlin.ULong.compareTo' call
      var other_0 = ULongArray__get_impl_pr71q9(second, counter);
      if (ulongCompare(_ULong___get_data__impl__fggpzb(tmp0_0), _ULong___get_data__impl__fggpzb(other_0)) < 0) {
        firstIsLarger = false;
        bothAreEqual = false;
        break $l$loop_0;
      }
      counter = counter - 1 | 0;
    }
    if (bothAreEqual) {
      return 0;
    }
    if (firstIsLarger) {
      return 1;
    } else {
      return -1;
    }
  };
  protoOf(BigInteger63Arithmetic).i2b = function (first, second) {
    var firstStart = _ULongArray___get_size__impl__ju6dtr(first) - this.h2f(first) | 0;
    var secondStart = _ULongArray___get_size__impl__ju6dtr(second) - this.h2f(second) | 0;
    return this.s2f(first, second, firstStart, secondStart);
  };
  protoOf(BigInteger63Arithmetic).t2f = function (resultArray, resultArrayStart, first, second) {
    if (isZero_0(this, first)) {
      // Inline function 'kotlin.collections.copyInto' call
      var endIndex = _ULongArray___get_size__impl__ju6dtr(first);
      var tmp0 = _ULongArray___get_storage__impl__28e64j(first);
      // Inline function 'kotlin.collections.copyInto' call
      var destination = _ULongArray___get_storage__impl__28e64j(resultArray);
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp = tmp0;
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      arrayCopy(tmp, destination, resultArrayStart, 0, endIndex);
      return Unit_instance;
    }
    if (isZero_0(this, second)) {
      // Inline function 'kotlin.collections.copyInto' call
      var endIndex_0 = _ULongArray___get_size__impl__ju6dtr(second);
      var tmp0_0 = _ULongArray___get_storage__impl__28e64j(second);
      // Inline function 'kotlin.collections.copyInto' call
      var destination_0 = _ULongArray___get_storage__impl__28e64j(resultArray);
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp_0 = tmp0_0;
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      arrayCopy(tmp_0, destination_0, resultArrayStart, 0, endIndex_0);
      return Unit_instance;
    }
    var firstStart = _ULongArray___get_size__impl__ju6dtr(first) - this.h2f(first) | 0;
    var secondStart = _ULongArray___get_size__impl__ju6dtr(second) - this.h2f(second) | 0;
    var tmp_1;
    if (firstStart > secondStart) {
      tmp_1 = new Sextuple(_ULongArray___get_size__impl__ju6dtr(first), _ULongArray___get_size__impl__ju6dtr(second), new ULongArray(first), new ULongArray(second), firstStart, secondStart);
    } else {
      tmp_1 = new Sextuple(_ULongArray___get_size__impl__ju6dtr(second), _ULongArray___get_size__impl__ju6dtr(first), new ULongArray(second), new ULongArray(first), secondStart, firstStart);
    }
    var _destruct__k2r9zo = tmp_1;
    var largerLength = _destruct__k2r9zo.fg();
    var smallerLength = _destruct__k2r9zo.gg();
    var largerData = _destruct__k2r9zo.zl().gn_1;
    var smallerData = _destruct__k2r9zo.b2d().gn_1;
    var largerStart = _destruct__k2r9zo.c2d();
    var smallerStart = _destruct__k2r9zo.d2d();
    var i = 0;
    var sum = _ULong___init__impl__c78o9k(0n);
    while (i < smallerStart) {
      var tmp0_1 = sum;
      // Inline function 'kotlin.ULong.plus' call
      var other = ULongArray__get_impl_pr71q9(largerData, i);
      var tmp0_2 = _ULong___init__impl__c78o9k(add_2(_ULong___get_data__impl__fggpzb(tmp0_1), _ULong___get_data__impl__fggpzb(other)));
      // Inline function 'kotlin.ULong.plus' call
      var other_0 = ULongArray__get_impl_pr71q9(smallerData, i);
      sum = _ULong___init__impl__c78o9k(add_2(_ULong___get_data__impl__fggpzb(tmp0_2), _ULong___get_data__impl__fggpzb(other_0)));
      var tmp_2 = i + resultArrayStart | 0;
      var tmp0_3 = sum;
      // Inline function 'kotlin.ULong.and' call
      var other_1 = this.s2b_1;
      var tmp$ret$14 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(tmp0_3) & _ULong___get_data__impl__fggpzb(other_1));
      ULongArray__set_impl_z19mvh(resultArray, tmp_2, tmp$ret$14);
      // Inline function 'kotlin.ULong.shr' call
      var this_0 = sum;
      sum = _ULong___init__impl__c78o9k(shiftRightUnsigned(_ULong___get_data__impl__fggpzb(this_0), 63));
      i = i + 1 | 0;
    }
    while (true) {
      if (sum === _ULong___init__impl__c78o9k(0n)) {
        while (i < largerStart) {
          ULongArray__set_impl_z19mvh(resultArray, i + resultArrayStart | 0, ULongArray__get_impl_pr71q9(largerData, i));
          i = i + 1 | 0;
        }
        return Unit_instance;
      }
      if (i === largerLength) {
        ULongArray__set_impl_z19mvh(resultArray, largerLength + resultArrayStart | 0, sum);
        return Unit_instance;
      }
      var tmp0_4 = sum;
      // Inline function 'kotlin.ULong.plus' call
      var other_2 = ULongArray__get_impl_pr71q9(largerData, i);
      sum = _ULong___init__impl__c78o9k(add_2(_ULong___get_data__impl__fggpzb(tmp0_4), _ULong___get_data__impl__fggpzb(other_2)));
      var tmp_3 = i;
      var tmp0_5 = sum;
      // Inline function 'kotlin.ULong.and' call
      var other_3 = this.s2b_1;
      var tmp$ret$17 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(tmp0_5) & _ULong___get_data__impl__fggpzb(other_3));
      ULongArray__set_impl_z19mvh(resultArray, tmp_3, tmp$ret$17);
      // Inline function 'kotlin.ULong.shr' call
      var this_1 = sum;
      sum = _ULong___init__impl__c78o9k(shiftRightUnsigned(_ULong___get_data__impl__fggpzb(this_1), 63));
      i = i + 1 | 0;
    }
  };
  protoOf(BigInteger63Arithmetic).f2c = function (first, second) {
    if (isZero_0(this, first))
      return second;
    if (isZero_0(this, second))
      return first;
    var firstStart = _ULongArray___get_size__impl__ju6dtr(first) - this.h2f(first) | 0;
    var secondStart = _ULongArray___get_size__impl__ju6dtr(second) - this.h2f(second) | 0;
    var tmp;
    if (firstStart > secondStart) {
      tmp = new Sextuple(_ULongArray___get_size__impl__ju6dtr(first), _ULongArray___get_size__impl__ju6dtr(second), new ULongArray(first), new ULongArray(second), firstStart, secondStart);
    } else {
      tmp = new Sextuple(_ULongArray___get_size__impl__ju6dtr(second), _ULongArray___get_size__impl__ju6dtr(first), new ULongArray(second), new ULongArray(first), secondStart, firstStart);
    }
    var _destruct__k2r9zo = tmp;
    var largerLength = _destruct__k2r9zo.fg();
    var smallerLength = _destruct__k2r9zo.gg();
    var largerData = _destruct__k2r9zo.zl().gn_1;
    var smallerData = _destruct__k2r9zo.b2d().gn_1;
    var largerStart = _destruct__k2r9zo.c2d();
    var smallerStart = _destruct__k2r9zo.d2d();
    // Inline function 'com.ionspin.kotlin.bignum.integer.base63.array.BigInteger63Arithmetic.possibleAdditionOverflow' call
    var firstMostSignificant = ULongArray__get_impl_pr71q9(largerData, largerStart - 1 | 0);
    var secondMostSignificant = ULongArray__get_impl_pr71q9(smallerData, smallerStart - 1 | 0);
    var tmp_0;
    // Inline function 'kotlin.ULong.and' call
    var other = _ULong___init__impl__c78o9k(6917529027641081856n);
    if (!(_ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(firstMostSignificant) & _ULong___get_data__impl__fggpzb(other)) === _ULong___init__impl__c78o9k(0n))) {
      tmp_0 = true;
    } else {
      // Inline function 'kotlin.ULong.and' call
      var other_0 = _ULong___init__impl__c78o9k(6917529027641081856n);
      tmp_0 = !(_ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(secondMostSignificant) & _ULong___get_data__impl__fggpzb(other_0)) === _ULong___init__impl__c78o9k(0n));
    }
    var possibleOverflow = tmp_0;
    var possibleOverflow_0 = possibleOverflow;
    var tmp_1;
    if (possibleOverflow_0) {
      // Inline function 'kotlin.ULongArray' call
      var tmp_2 = 0;
      var tmp_3 = largerLength + 1 | 0;
      var tmp_4 = longArray(tmp_3);
      while (tmp_2 < tmp_3) {
        var tmp_5 = tmp_2;
        // Inline function 'kotlin.ULong.toLong' call
        var this_0 = _ULong___init__impl__c78o9k(0n);
        tmp_4[tmp_5] = _ULong___get_data__impl__fggpzb(this_0);
        tmp_2 = tmp_2 + 1 | 0;
      }
      tmp_1 = _ULongArray___init__impl__twm1l3(tmp_4);
    } else {
      // Inline function 'kotlin.ULongArray' call
      var tmp_6 = 0;
      var tmp_7 = longArray(largerLength);
      while (tmp_6 < largerLength) {
        var tmp_8 = tmp_6;
        // Inline function 'kotlin.ULong.toLong' call
        var this_1 = _ULong___init__impl__c78o9k(0n);
        tmp_7[tmp_8] = _ULong___get_data__impl__fggpzb(this_1);
        tmp_6 = tmp_6 + 1 | 0;
      }
      tmp_1 = _ULongArray___init__impl__twm1l3(tmp_7);
    }
    var result = tmp_1;
    this.t2f(result, 0, first, second);
    var tmp_9;
    if (possibleOverflow_0) {
      tmp_9 = this.c2c(result);
    } else {
      tmp_9 = result;
    }
    return tmp_9;
  };
  protoOf(BigInteger63Arithmetic).u2f = function (first, second, firstStart, secondStart) {
    var comparison = this.s2f(first, second, firstStart, secondStart);
    var firstSize = firstStart + 1 | 0;
    var secondSize = secondStart + 1 | 0;
    var firstIsLarger = comparison === 1;
    if (comparison === 0)
      return this.l2b_1;
    if (secondSize === 1 && ULongArray__get_impl_pr71q9(second, 0) === _ULong___init__impl__c78o9k(0n)) {
      return first;
    }
    if (!firstIsLarger) {
      throw RuntimeException_init_$Create$_0('subtract result less than zero');
    }
    var tmp;
    if (firstIsLarger) {
      tmp = new Quadruple(new ULongArray(first), new ULongArray(second), firstStart, secondStart);
    } else {
      tmp = new Quadruple(new ULongArray(second), new ULongArray(first), secondStart, firstStart);
    }
    var _destruct__k2r9zo = tmp;
    var largerData = _destruct__k2r9zo.fg().gn_1;
    var smallerData = _destruct__k2r9zo.gg().gn_1;
    var largerStart = _destruct__k2r9zo.zl();
    var smallerStart = _destruct__k2r9zo.b2d();
    // Inline function 'kotlin.ULongArray' call
    var tmp_0 = 0;
    var tmp_1 = longArray(largerStart);
    while (tmp_0 < largerStart) {
      var tmp_2 = tmp_0;
      // Inline function 'kotlin.ULong.toLong' call
      var this_0 = _ULong___init__impl__c78o9k(0n);
      tmp_1[tmp_2] = _ULong___get_data__impl__fggpzb(this_0);
      tmp_0 = tmp_0 + 1 | 0;
    }
    var result = _ULongArray___init__impl__twm1l3(tmp_1);
    var i = 0;
    var diff = _ULong___init__impl__c78o9k(0n);
    while (i < smallerStart) {
      var tmp0 = ULongArray__get_impl_pr71q9(largerData, i);
      // Inline function 'kotlin.ULong.minus' call
      var other = ULongArray__get_impl_pr71q9(smallerData, i);
      var tmp0_0 = _ULong___init__impl__c78o9k(subtract_1(_ULong___get_data__impl__fggpzb(tmp0), _ULong___get_data__impl__fggpzb(other)));
      // Inline function 'kotlin.ULong.minus' call
      var other_0 = diff;
      diff = _ULong___init__impl__c78o9k(subtract_1(_ULong___get_data__impl__fggpzb(tmp0_0), _ULong___get_data__impl__fggpzb(other_0)));
      var tmp_3 = i;
      var tmp0_1 = diff;
      // Inline function 'kotlin.ULong.and' call
      var other_1 = this.s2b_1;
      var tmp$ret$6 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(tmp0_1) & _ULong___get_data__impl__fggpzb(other_1));
      ULongArray__set_impl_z19mvh(result, tmp_3, tmp$ret$6);
      // Inline function 'kotlin.ULong.shr' call
      var this_1 = diff;
      diff = _ULong___init__impl__c78o9k(shiftRightUnsigned(_ULong___get_data__impl__fggpzb(this_1), 63));
      i = i + 1 | 0;
    }
    while (!(diff === _ULong___init__impl__c78o9k(0n))) {
      var tmp0_2 = ULongArray__get_impl_pr71q9(largerData, i);
      // Inline function 'kotlin.ULong.minus' call
      var other_2 = diff;
      diff = _ULong___init__impl__c78o9k(subtract_1(_ULong___get_data__impl__fggpzb(tmp0_2), _ULong___get_data__impl__fggpzb(other_2)));
      var tmp_4 = i;
      var tmp0_3 = diff;
      // Inline function 'kotlin.ULong.and' call
      var other_3 = this.s2b_1;
      var tmp$ret$9 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(tmp0_3) & _ULong___get_data__impl__fggpzb(other_3));
      ULongArray__set_impl_z19mvh(result, tmp_4, tmp$ret$9);
      // Inline function 'kotlin.ULong.shr' call
      var this_2 = diff;
      diff = _ULong___init__impl__c78o9k(shiftRightUnsigned(_ULong___get_data__impl__fggpzb(this_2), 63));
      i = i + 1 | 0;
    }
    while (i < largerStart) {
      ULongArray__set_impl_z19mvh(result, i, ULongArray__get_impl_pr71q9(largerData, i));
      i = i + 1 | 0;
    }
    if (this.h2f(result) === (_ULongArray___get_size__impl__ju6dtr(result) - 1 | 0) && ULongArray__get_impl_pr71q9(result, 0) === _ULong___init__impl__c78o9k(0n)) {
      return this.l2b_1;
    }
    return this.c2c(result);
  };
  protoOf(BigInteger63Arithmetic).e2c = function (first, second) {
    var firstStart = _ULongArray___get_size__impl__ju6dtr(first) - this.h2f(first) | 0;
    var secondStart = _ULongArray___get_size__impl__ju6dtr(second) - this.h2f(second) | 0;
    return this.u2f(first, second, firstStart, secondStart);
  };
  protoOf(BigInteger63Arithmetic).l2c = function (first, second) {
    var firstCorrectedSize = _ULongArray___get_size__impl__ju6dtr(first) - this.h2f(first) | 0;
    var secondCorrectedSize = _ULongArray___get_size__impl__ju6dtr(second) - this.h2f(second) | 0;
    return multiplyWithCorrectedSize(this, first, second, firstCorrectedSize, secondCorrectedSize);
  };
  protoOf(BigInteger63Arithmetic).v2f = function (original, numberOfWords, value) {
    // Inline function 'kotlin.ULongArray' call
    var tmp = 0;
    var tmp_0 = _ULongArray___get_size__impl__ju6dtr(original) + numberOfWords | 0;
    var tmp_1 = longArray(tmp_0);
    while (tmp < tmp_0) {
      var tmp_2 = tmp;
      // Inline function 'kotlin.ULong.toLong' call
      var this_0 = tmp_2 < _ULongArray___get_size__impl__ju6dtr(original) ? ULongArray__get_impl_pr71q9(original, tmp_2) : value;
      tmp_1[tmp_2] = _ULong___get_data__impl__fggpzb(this_0);
      tmp = tmp + 1 | 0;
    }
    return _ULongArray___init__impl__twm1l3(tmp_1);
  };
  protoOf(BigInteger63Arithmetic).u2e = function (firstUnchecked, secondUnchecked) {
    var tmp;
    if (!((_ULongArray___get_size__impl__ju6dtr(firstUnchecked) % 3 | 0) === 0)) {
      // Inline function 'kotlin.ULongArray' call
      var tmp_0 = 0;
      var tmp_1 = imul((_ULongArray___get_size__impl__ju6dtr(firstUnchecked) + 2 | 0) / 3 | 0, 3) - _ULongArray___get_size__impl__ju6dtr(firstUnchecked) | 0;
      var tmp_2 = longArray(tmp_1);
      while (tmp_0 < tmp_1) {
        var tmp_3 = tmp_0;
        // Inline function 'kotlin.ULong.toLong' call
        var this_0 = _ULong___init__impl__c78o9k(0n);
        tmp_2[tmp_3] = _ULong___get_data__impl__fggpzb(this_0);
        tmp_0 = tmp_0 + 1 | 0;
      }
      var tmp$ret$3 = _ULongArray___init__impl__twm1l3(tmp_2);
      // Inline function 'kotlin.collections.asIterable' call
      var tmp$ret$4 = new ULongArray(tmp$ret$3);
      tmp = plus_5(new ULongArray(firstUnchecked), tmp$ret$4);
    } else {
      tmp = new ULongArray(firstUnchecked);
    }
    var first = toULongArray(tmp);
    var tmp_4;
    if (!((_ULongArray___get_size__impl__ju6dtr(secondUnchecked) % 3 | 0) === 0)) {
      // Inline function 'kotlin.ULongArray' call
      var tmp_5 = 0;
      var tmp_6 = imul((_ULongArray___get_size__impl__ju6dtr(secondUnchecked) + 2 | 0) / 3 | 0, 3) - _ULongArray___get_size__impl__ju6dtr(secondUnchecked) | 0;
      var tmp_7 = longArray(tmp_6);
      while (tmp_5 < tmp_6) {
        var tmp_8 = tmp_5;
        // Inline function 'kotlin.ULong.toLong' call
        var this_1 = _ULong___init__impl__c78o9k(0n);
        tmp_7[tmp_8] = _ULong___get_data__impl__fggpzb(this_1);
        tmp_5 = tmp_5 + 1 | 0;
      }
      var tmp$ret$8 = _ULongArray___init__impl__twm1l3(tmp_7);
      // Inline function 'kotlin.collections.asIterable' call
      var tmp$ret$9 = new ULongArray(tmp$ret$8);
      tmp_4 = plus_5(new ULongArray(secondUnchecked), tmp$ret$9);
    } else {
      tmp_4 = new ULongArray(secondUnchecked);
    }
    var second = toULongArray(tmp_4);
    var firstLength = _ULongArray___get_size__impl__ju6dtr(first);
    var secondLength = _ULongArray___get_size__impl__ju6dtr(second);
    var tmp_9;
    if (firstLength > secondLength) {
      var prepared = this.v2f(second, firstLength - secondLength | 0, _ULong___init__impl__c78o9k(0n));
      tmp_9 = new Pair(new ULongArray(first), new ULongArray(prepared));
    } else if (firstLength < secondLength) {
      var prepared_0 = this.v2f(first, secondLength - firstLength | 0, _ULong___init__impl__c78o9k(0n));
      tmp_9 = new Pair(new ULongArray(prepared_0), new ULongArray(second));
    } else {
      tmp_9 = new Pair(new ULongArray(first), new ULongArray(second));
    }
    var _destruct__k2r9zo = tmp_9;
    var firstPrepared = _destruct__k2r9zo.fg().gn_1;
    var secondPrepared = _destruct__k2r9zo.gg().gn_1;
    var tmp0 = _ULongArray___get_size__impl__ju6dtr(first);
    // Inline function 'kotlin.math.max' call
    var b = _ULongArray___get_size__impl__ju6dtr(second);
    var longestLength = Math.max(tmp0, b);
    var extendedDigit = (longestLength + 2 | 0) / 3 | 0;
    var m0 = new SignedULongArray(toULongArray(slice(firstPrepared, until(0, extendedDigit))), true);
    var m1 = new SignedULongArray(toULongArray(slice(firstPrepared, until(extendedDigit, imul(extendedDigit, 2)))), true);
    var m2 = new SignedULongArray(toULongArray(slice(firstPrepared, until(imul(extendedDigit, 2), imul(extendedDigit, 3)))), true);
    var n0 = new SignedULongArray(toULongArray(slice(secondPrepared, until(0, extendedDigit))), true);
    var n1 = new SignedULongArray(toULongArray(slice(secondPrepared, until(extendedDigit, imul(extendedDigit, 2)))), true);
    var n2 = new SignedULongArray(toULongArray(slice(secondPrepared, until(imul(extendedDigit, 2), imul(extendedDigit, 3)))), true);
    var p0 = this.c2f(m0, m2);
    var pe0 = m0;
    var pe1 = this.c2f(p0, m1);
    var pem1 = this.e2f(p0, m1);
    var doublePemM2 = this.b2f(this.c2f(pem1, m2), this.a2c_1);
    var pem2 = this.e2f(doublePemM2, m0);
    var pinf = m2;
    var q0 = this.c2f(n0, n2);
    var qe0 = n0;
    var qe1 = this.c2f(q0, n1);
    var qem1 = this.e2f(q0, n1);
    var doubleQemN2 = this.b2f(this.c2f(qem1, n2), this.a2c_1);
    var qem2 = this.e2f(doubleQemN2, n0);
    var qinf = n2;
    var re0 = this.b2f(pe0, qe0);
    var re1 = this.b2f(pe1, qe1);
    var rem1 = this.b2f(pem1, qem1);
    var rem2 = this.b2f(pem2, qem2);
    var rinf = this.b2f(pinf, qinf);
    var r0 = re0;
    var r4 = rinf;
    var rem2re1diff = this.e2f(rem2, re1);
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp$ret$11 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(3n)]));
    var r3 = this.w2f(rem2re1diff, new SignedULongArray(tmp$ret$11, true));
    var r1 = this.a2f(this.e2f(re1, rem1), 1);
    var r2 = this.e2f(rem1, r0);
    r3 = this.c2f(this.a2f(this.e2f(r2, r3), 1), this.b2f(this.a2c_1, rinf));
    r2 = this.e2f(this.c2f(r2, r1), r4);
    r1 = this.e2f(r1, r3);
    var bShiftAmount = imul(extendedDigit, 63);
    var rb0 = r0;
    var rb1 = this.d2f(r1, bShiftAmount);
    var rb2 = this.d2f(r2, imul(bShiftAmount, 2));
    var rb3 = this.d2f(r3, imul(bShiftAmount, 3));
    var rb4 = this.d2f(r4, imul(bShiftAmount, 4));
    var rb = this.c2f(this.c2f(this.c2f(this.c2f(rb0, rb1), rb2), rb3), rb4);
    return rb.f2f_1;
  };
  protoOf(BigInteger63Arithmetic).v2e = function (first, second) {
    var firstCorrectedSize = _ULongArray___get_size__impl__ju6dtr(first) - this.h2f(first) | 0;
    return this.x2f(first, second, firstCorrectedSize);
  };
  protoOf(BigInteger63Arithmetic).x2f = function (first, second, firstCorrectedSize) {
    // Inline function 'kotlin.ULong.and' call
    var other = this.u2b_1;
    var secondLow = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(second) & _ULong___get_data__impl__fggpzb(other));
    // Inline function 'kotlin.ULong.shr' call
    var secondHigh = _ULong___init__impl__c78o9k(shiftRightUnsigned(_ULong___get_data__impl__fggpzb(second), 32));
    var requiredBits = this.o2f(first) + this.p2f(second) | 0;
    var tmp;
    if (!((requiredBits % 63 | 0) === 0)) {
      tmp = (requiredBits / 63 | 0) + 1 | 0;
    } else {
      tmp = requiredBits / 63 | 0;
    }
    var requiredWords = tmp;
    var result = _ULongArray___init__impl__twm1l3_0(requiredWords);
    var carryIntoNextRound = _ULong___init__impl__c78o9k(0n);
    var i = 0;
    var j = 0;
    while (i < firstCorrectedSize) {
      var tmp0 = ULongArray__get_impl_pr71q9(first, i);
      // Inline function 'kotlin.ULong.and' call
      var other_0 = this.u2b_1;
      var firstLow = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(tmp0) & _ULong___get_data__impl__fggpzb(other_0));
      // Inline function 'kotlin.ULong.shr' call
      var this_0 = ULongArray__get_impl_pr71q9(first, i);
      var firstHigh = _ULong___init__impl__c78o9k(shiftRightUnsigned(_ULong___get_data__impl__fggpzb(this_0), 32));
      i = i + 1 | 0;
      // Inline function 'kotlin.ULong.times' call
      var lowerProduct = _ULong___init__impl__c78o9k(multiply_0(_ULong___get_data__impl__fggpzb(firstLow), _ULong___get_data__impl__fggpzb(secondLow)));
      // Inline function 'kotlin.ULong.shr' call
      var lowerCarry = _ULong___init__impl__c78o9k(shiftRightUnsigned(_ULong___get_data__impl__fggpzb(lowerProduct), 63));
      var tmp0_0 = carryIntoNextRound;
      // Inline function 'kotlin.ULong.and' call
      var other_1 = this.s2b_1;
      // Inline function 'kotlin.ULong.plus' call
      var other_2 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(lowerProduct) & _ULong___get_data__impl__fggpzb(other_1));
      var lowResult = _ULong___init__impl__c78o9k(add_2(_ULong___get_data__impl__fggpzb(tmp0_0), _ULong___get_data__impl__fggpzb(other_2)));
      var tmp0_1 = lowerCarry;
      // Inline function 'kotlin.ULong.shr' call
      var this_1 = lowResult;
      // Inline function 'kotlin.ULong.plus' call
      var other_3 = _ULong___init__impl__c78o9k(shiftRightUnsigned(_ULong___get_data__impl__fggpzb(this_1), 63));
      lowerCarry = _ULong___init__impl__c78o9k(add_2(_ULong___get_data__impl__fggpzb(tmp0_1), _ULong___get_data__impl__fggpzb(other_3)));
      var tmp0_2 = lowResult;
      // Inline function 'kotlin.ULong.and' call
      var other_4 = this.s2b_1;
      lowResult = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(tmp0_2) & _ULong___get_data__impl__fggpzb(other_4));
      // Inline function 'kotlin.ULong.times' call
      var tmp0_3 = _ULong___init__impl__c78o9k(multiply_0(_ULong___get_data__impl__fggpzb(firstLow), _ULong___get_data__impl__fggpzb(secondHigh)));
      // Inline function 'kotlin.ULong.times' call
      // Inline function 'kotlin.ULong.plus' call
      var other_5 = _ULong___init__impl__c78o9k(multiply_0(_ULong___get_data__impl__fggpzb(secondLow), _ULong___get_data__impl__fggpzb(firstHigh)));
      var middleProduct = _ULong___init__impl__c78o9k(add_2(_ULong___get_data__impl__fggpzb(tmp0_3), _ULong___get_data__impl__fggpzb(other_5)));
      var middleCarry = lowerCarry;
      var tmp0_4 = middleCarry;
      // Inline function 'kotlin.ULong.shr' call
      // Inline function 'kotlin.ULong.plus' call
      var other_6 = _ULong___init__impl__c78o9k(shiftRightUnsigned(_ULong___get_data__impl__fggpzb(middleProduct), 31));
      middleCarry = _ULong___init__impl__c78o9k(add_2(_ULong___get_data__impl__fggpzb(tmp0_4), _ULong___get_data__impl__fggpzb(other_6)));
      var tmp0_5 = lowResult;
      // Inline function 'kotlin.ULong.shl' call
      var tmp0_6 = _ULong___init__impl__c78o9k(shiftLeft(_ULong___get_data__impl__fggpzb(middleProduct), 32));
      // Inline function 'kotlin.ULong.and' call
      var other_7 = this.s2b_1;
      // Inline function 'kotlin.ULong.plus' call
      var other_8 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(tmp0_6) & _ULong___get_data__impl__fggpzb(other_7));
      lowResult = _ULong___init__impl__c78o9k(add_2(_ULong___get_data__impl__fggpzb(tmp0_5), _ULong___get_data__impl__fggpzb(other_8)));
      var tmp0_7 = middleCarry;
      // Inline function 'kotlin.ULong.shr' call
      var this_2 = lowResult;
      // Inline function 'kotlin.ULong.plus' call
      var other_9 = _ULong___init__impl__c78o9k(shiftRightUnsigned(_ULong___get_data__impl__fggpzb(this_2), 63));
      middleCarry = _ULong___init__impl__c78o9k(add_2(_ULong___get_data__impl__fggpzb(tmp0_7), _ULong___get_data__impl__fggpzb(other_9)));
      var tmp_0 = j;
      var tmp0_8 = lowResult;
      // Inline function 'kotlin.ULong.and' call
      var other_10 = this.s2b_1;
      var tmp$ret$21 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(tmp0_8) & _ULong___get_data__impl__fggpzb(other_10));
      ULongArray__set_impl_z19mvh(result, tmp_0, tmp$ret$21);
      var highResult = middleCarry;
      // Inline function 'kotlin.ULong.times' call
      // Inline function 'kotlin.ULong.shl' call
      var this_3 = _ULong___init__impl__c78o9k(multiply_0(_ULong___get_data__impl__fggpzb(firstHigh), _ULong___get_data__impl__fggpzb(secondHigh)));
      var higherProduct = _ULong___init__impl__c78o9k(shiftLeft(_ULong___get_data__impl__fggpzb(this_3), 1));
      // Inline function 'kotlin.ULong.plus' call
      var this_4 = highResult;
      highResult = _ULong___init__impl__c78o9k(add_2(_ULong___get_data__impl__fggpzb(this_4), _ULong___get_data__impl__fggpzb(higherProduct)));
      carryIntoNextRound = highResult;
      j = j + 1 | 0;
    }
    if (!(carryIntoNextRound === _ULong___init__impl__c78o9k(0n))) {
      ULongArray__set_impl_z19mvh(result, j, carryIntoNextRound);
    }
    return result;
  };
  protoOf(BigInteger63Arithmetic).q2c = function (base, exponent) {
    if (exponent === 0n) {
      return this.m2b_1;
    }
    if (exponent === 1n) {
      return base;
    }
    if (_ULongArray___get_size__impl__ju6dtr(base) === 1 && ULongArray__get_impl_pr71q9(base, 0) === _ULong___init__impl__c78o9k(10n) && exponent < fromInt_0(this.b2c_1.length)) {
      return this.b2c_1[convertToInt(exponent)].gn_1;
    }
    var firstCorrectedSize = _ULongArray___get_size__impl__ju6dtr(base) - this.h2f(base) | 0;
    var helperVar = this.m2b_1;
    var exponentVar = exponent;
    var baseVar = base;
    while (exponentVar > 1n) {
      // Inline function 'kotlin.Long.rem' call
      var this_0 = exponentVar;
      if (modulo(this_0, fromInt_0(2)) === 0n) {
        baseVar = this.l2f(baseVar, baseVar);
        // Inline function 'kotlin.Long.div' call
        var this_1 = exponentVar;
        exponentVar = divide(this_1, fromInt_0(2));
      } else {
        helperVar = this.l2f(baseVar, helperVar);
        baseVar = this.l2f(baseVar, baseVar);
        // Inline function 'kotlin.Long.minus' call
        var this_2 = exponentVar;
        // Inline function 'kotlin.Long.div' call
        var this_3 = subtract_1(this_2, fromInt_0(1));
        exponentVar = divide(this_3, fromInt_0(2));
      }
    }
    return this.l2f(helperVar, baseVar);
  };
  protoOf(BigInteger63Arithmetic).y2f = function (dividend, divisor) {
    var divisorSize = _ULongArray___get_size__impl__ju6dtr(divisor);
    var normalizationShift = this.n2f(ULongArray__get_impl_pr71q9(divisor, divisorSize - 1 | 0));
    var divisorNormalized = this.w2e(divisor, normalizationShift);
    var dividendNormalized = this.w2e(dividend, normalizationShift);
    return new Triple(new ULongArray(dividendNormalized), new ULongArray(divisorNormalized), normalizationShift);
  };
  protoOf(BigInteger63Arithmetic).z2f = function (remainderNormalized, normalizationShift) {
    var remainder = this.a2g(remainderNormalized, normalizationShift);
    return remainder;
  };
  protoOf(BigInteger63Arithmetic).b2g = function (unnormalizedDividend, unnormalizedDivisor) {
    if (this.s2c(unnormalizedDivisor, unnormalizedDividend) > 0) {
      return new Pair(new ULongArray(this.l2b_1), new ULongArray(unnormalizedDividend));
    }
    if (_ULongArray___get_size__impl__ju6dtr(unnormalizedDivisor) === 1 && _ULongArray___get_size__impl__ju6dtr(unnormalizedDividend) === 1) {
      var tmp0 = ULongArray__get_impl_pr71q9(unnormalizedDividend, 0);
      // Inline function 'kotlin.ULong.div' call
      var other = ULongArray__get_impl_pr71q9(unnormalizedDivisor, 0);
      var tmp$ret$0 = ulongDivide(tmp0, other);
      // Inline function 'kotlin.ulongArrayOf' call
      var tmp$ret$1 = _ULongArray___init__impl__twm1l3(longArrayOf([tmp$ret$0]));
      var tmp = this.c2c(tmp$ret$1);
      var tmp0_0 = ULongArray__get_impl_pr71q9(unnormalizedDividend, 0);
      // Inline function 'kotlin.ULong.rem' call
      var other_0 = ULongArray__get_impl_pr71q9(unnormalizedDivisor, 0);
      var tmp$ret$2 = ulongRemainder(tmp0_0, other_0);
      // Inline function 'kotlin.ulongArrayOf' call
      var tmp$ret$3 = _ULongArray___init__impl__twm1l3(longArrayOf([tmp$ret$2]));
      return new Pair(new ULongArray(tmp), new ULongArray(this.c2c(tmp$ret$3)));
    }
    var bitPrecision = this.o2f(unnormalizedDividend) - this.o2f(unnormalizedDivisor) | 0;
    if (bitPrecision === 0) {
      return new Pair(new ULongArray(this.m2b_1), new ULongArray(this.k2f(unnormalizedDividend, unnormalizedDivisor)));
    }
    var _destruct__k2r9zo = this.y2f(unnormalizedDividend, unnormalizedDivisor);
    var dividend = _destruct__k2r9zo.fg().gn_1;
    var divisor = _destruct__k2r9zo.gg().gn_1;
    var normalizationShift = _destruct__k2r9zo.zl();
    var dividendSize = _ULongArray___get_size__impl__ju6dtr(dividend);
    var divisorSize = _ULongArray___get_size__impl__ju6dtr(divisor);
    var divisorCorrectedSize = _ULongArray___get_size__impl__ju6dtr(divisor) - this.h2f(divisor) | 0;
    var wordPrecision = dividendSize - divisorSize | 0;
    var qjhat;
    var reconstructedQuotient;
    var quotient = _ULongArray___init__impl__twm1l3_0(wordPrecision);
    var divisorTimesBaseToPowerOfM = this.w2e(divisor, imul(wordPrecision, this.q2b_1));
    if (this.s2c(dividend, divisorTimesBaseToPowerOfM) >= 0) {
      quotient = _ULongArray___init__impl__twm1l3_0(wordPrecision + 1 | 0);
      ULongArray__set_impl_z19mvh(quotient, wordPrecision, _ULong___init__impl__c78o9k(1n));
      dividend = this.k2f(dividend, divisorTimesBaseToPowerOfM);
    }
    var inductionVariable = wordPrecision - 1 | 0;
    if (0 <= inductionVariable)
      do {
        var j = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        var tmp_0;
        if ((divisorSize + j | 0) < _ULongArray___get_size__impl__ju6dtr(dividend)) {
          // Inline function 'kotlin.ulongArrayOf' call
          var tmp$ret$4 = _ULongArray___init__impl__twm1l3(longArrayOf([ULongArray__get_impl_pr71q9(dividend, divisorSize + j | 0)]));
          tmp_0 = this.c2g(this.w2e(tmp$ret$4, this.q2b_1), ULongArray__get_impl_pr71q9(dividend, (divisorSize + j | 0) - 1 | 0));
        } else {
          var tmp_1;
          if ((divisorSize + j | 0) === _ULongArray___get_size__impl__ju6dtr(dividend)) {
            // Inline function 'kotlin.ulongArrayOf' call
            tmp_1 = _ULongArray___init__impl__twm1l3(longArrayOf([ULongArray__get_impl_pr71q9(dividend, (divisorSize + j | 0) - 1 | 0)]));
          } else {
            tmp_1 = this.l2b_1;
          }
          tmp_0 = tmp_1;
        }
        var twoDigit = tmp_0;
        var tmp_2 = BigInteger32Arithmetic_getInstance();
        var tmp_3 = this.d2g(twoDigit);
        // Inline function 'kotlin.ulongArrayOf' call
        var tmp$ret$6 = _ULongArray___init__impl__twm1l3(longArrayOf([ULongArray__get_impl_pr71q9(divisor, divisorSize - 1 | 0)]));
        var convertedResult = tmp_2.o2e(tmp_3, this.d2g(tmp$ret$6));
        qjhat = this.e2g(convertedResult.pg_1.vm_1);
        var tmp_4 = quotient;
        var tmp_5;
        var tmp_6 = qjhat;
        var tmp0_1 = this.s2b_1;
        // Inline function 'kotlin.ULong.minus' call
        var other_1 = _ULong___init__impl__c78o9k(1n);
        var tmp$ret$7 = _ULong___init__impl__c78o9k(subtract_1(_ULong___get_data__impl__fggpzb(tmp0_1), _ULong___get_data__impl__fggpzb(other_1)));
        if (this.f2g(tmp_6, tmp$ret$7) < 0) {
          tmp_5 = ULongArray__get_impl_pr71q9(qjhat, 0);
        } else {
          tmp_5 = this.s2b_1;
        }
        ULongArray__set_impl_z19mvh(tmp_4, j, tmp_5);
        reconstructedQuotient = this.w2e(this.x2f(divisor, ULongArray__get_impl_pr71q9(quotient, j), divisorCorrectedSize), imul(j, this.q2b_1));
        while (this.s2c(reconstructedQuotient, dividend) > 0) {
          var tmp_7 = quotient;
          var tmp0_2 = ULongArray__get_impl_pr71q9(quotient, j);
          // Inline function 'kotlin.ULong.minus' call
          // Inline function 'kotlin.UInt.toULong' call
          var this_0 = _UInt___init__impl__l7qpdl(1);
          // Inline function 'kotlin.uintToULong' call
          // Inline function 'kotlin.uintToLong' call
          var value = _UInt___get_data__impl__f0vqqw(this_0);
          var tmp$ret$8 = fromInt_0(value) & 4294967295n;
          // Inline function 'kotlin.ULong.minus' call
          var other_2 = _ULong___init__impl__c78o9k(tmp$ret$8);
          var tmp$ret$12 = _ULong___init__impl__c78o9k(subtract_1(_ULong___get_data__impl__fggpzb(tmp0_2), _ULong___get_data__impl__fggpzb(other_2)));
          ULongArray__set_impl_z19mvh(tmp_7, j, tmp$ret$12);
          reconstructedQuotient = this.w2e(this.x2f(divisor, ULongArray__get_impl_pr71q9(quotient, j), divisorCorrectedSize), imul(j, this.q2b_1));
        }
        dividend = this.k2f(dividend, reconstructedQuotient);
      }
       while (0 <= inductionVariable);
    while (this.s2c(dividend, divisor) >= 0) {
      quotient = this.c2g(quotient, _ULong___init__impl__c78o9k(1n));
      dividend = this.k2f(dividend, divisor);
    }
    var denormRemainder = this.z2f(dividend, normalizationShift);
    return new Pair(new ULongArray(this.c2c(quotient)), new ULongArray(denormRemainder));
  };
  protoOf(BigInteger63Arithmetic).g2g = function (operand) {
    if (isZero_0(this, operand))
      return this.l2b_1;
    var length = this.o2f(operand);
    var tmp;
    if ((length % 64 | 0) === 0) {
      tmp = length / 64 | 0;
    } else {
      tmp = (length / 64 | 0) + 1 | 0;
    }
    var requiredLength = tmp;
    var wordStep;
    var shiftAmount;
    var result = _ULongArray___init__impl__twm1l3_0(requiredLength);
    var inductionVariable = 0;
    if (inductionVariable < requiredLength)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        wordStep = i / 63 | 0;
        shiftAmount = i % 63 | 0;
        if (((i + wordStep | 0) + 1 | 0) < _ULongArray___get_size__impl__ju6dtr(operand)) {
          // Inline function 'kotlin.ULong.shr' call
          var this_0 = ULongArray__get_impl_pr71q9(operand, i + wordStep | 0);
          var tmp0 = _ULong___init__impl__c78o9k(shiftRightUnsigned(_ULong___get_data__impl__fggpzb(this_0), shiftAmount));
          var tmp0_0 = ULongArray__get_impl_pr71q9(operand, (i + wordStep | 0) + 1 | 0);
          // Inline function 'kotlin.ULong.shl' call
          var bitCount = 63 - shiftAmount | 0;
          // Inline function 'kotlin.ULong.or' call
          var other = _ULong___init__impl__c78o9k(shiftLeft(_ULong___get_data__impl__fggpzb(tmp0_0), bitCount));
          var tmp$ret$2 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(tmp0) | _ULong___get_data__impl__fggpzb(other));
          ULongArray__set_impl_z19mvh(result, i, tmp$ret$2);
        } else {
          // Inline function 'kotlin.ULong.shr' call
          var this_1 = ULongArray__get_impl_pr71q9(operand, i + wordStep | 0);
          var tmp$ret$3 = _ULong___init__impl__c78o9k(shiftRightUnsigned(_ULong___get_data__impl__fggpzb(this_1), shiftAmount));
          ULongArray__set_impl_z19mvh(result, i, tmp$ret$3);
        }
      }
       while (inductionVariable < requiredLength);
    return this.c2c(result);
  };
  protoOf(BigInteger63Arithmetic).h2g = function (operand) {
    var power64Representation = this.g2g(operand);
    var result = _UIntArray___init__impl__ghjpc6_0(imul(_ULongArray___get_size__impl__ju6dtr(power64Representation), 2));
    var inductionVariable = 0;
    var last = _ULongArray___get_size__impl__ju6dtr(power64Representation);
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = imul(2, i);
        var tmp0 = ULongArray__get_impl_pr71q9(power64Representation, i);
        // Inline function 'kotlin.UInt.toULong' call
        var this_0 = BigInteger32Arithmetic_getInstance().p2d_1;
        // Inline function 'kotlin.uintToULong' call
        // Inline function 'kotlin.uintToLong' call
        var value = _UInt___get_data__impl__f0vqqw(this_0);
        var tmp$ret$0 = fromInt_0(value) & 4294967295n;
        // Inline function 'kotlin.ULong.and' call
        var other = _ULong___init__impl__c78o9k(tmp$ret$0);
        // Inline function 'kotlin.ULong.toUInt' call
        var this_1 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(tmp0) & _ULong___get_data__impl__fggpzb(other));
        // Inline function 'kotlin.toUInt' call
        var this_2 = _ULong___get_data__impl__fggpzb(this_1);
        var tmp$ret$5 = _UInt___init__impl__l7qpdl(convertToInt(this_2));
        UIntArray__set_impl_7f2zu2(result, tmp, tmp$ret$5);
        var tmp_0 = imul(2, i) + 1 | 0;
        // Inline function 'kotlin.ULong.shr' call
        var this_3 = ULongArray__get_impl_pr71q9(power64Representation, i);
        // Inline function 'kotlin.ULong.toUInt' call
        var this_4 = _ULong___init__impl__c78o9k(shiftRightUnsigned(_ULong___get_data__impl__fggpzb(this_3), 32));
        // Inline function 'kotlin.toUInt' call
        var this_5 = _ULong___get_data__impl__fggpzb(this_4);
        var tmp$ret$8 = _UInt___init__impl__l7qpdl(convertToInt(this_5));
        UIntArray__set_impl_7f2zu2(result, tmp_0, tmp$ret$8);
      }
       while (inductionVariable < last);
    return BigInteger32Arithmetic_getInstance().c2e(result);
  };
  protoOf(BigInteger63Arithmetic).i2g = function (operand) {
    if (_UIntArray___get_size__impl__r6l8ci(operand) === 0) {
      return this.l2b_1;
    }
    if (_UIntArray___get_size__impl__r6l8ci(operand) === 1) {
      // Inline function 'kotlin.UInt.toULong' call
      var this_0 = UIntArray__get_impl_gp5kza(operand, 0);
      // Inline function 'kotlin.uintToULong' call
      // Inline function 'kotlin.uintToLong' call
      var value = _UInt___get_data__impl__f0vqqw(this_0);
      var tmp$ret$0 = fromInt_0(value) & 4294967295n;
      var tmp$ret$2 = _ULong___init__impl__c78o9k(tmp$ret$0);
      // Inline function 'kotlin.ulongArrayOf' call
      return _ULongArray___init__impl__twm1l3(longArrayOf([tmp$ret$2]));
    }
    var length = BigInteger32Arithmetic_getInstance().a2e(operand);
    var tmp;
    if ((length % 63 | 0) === 0) {
      tmp = length / 63 | 0;
    } else {
      tmp = (length / 63 | 0) + 1 | 0;
    }
    var requiredLength = tmp;
    var result = _ULongArray___init__impl__twm1l3_0(requiredLength);
    var skipWordCount;
    var inductionVariable = 0;
    if (inductionVariable < requiredLength)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        skipWordCount = i / 32 | 0;
        var shiftAmount = i % 32 | 0;
        var position = imul(i, 2) - skipWordCount | 0;
        if (requiredLength === 2) {
          // Inline function 'kotlin.UInt.toULong' call
          var this_1 = UIntArray__get_impl_gp5kza(operand, 0);
          // Inline function 'kotlin.uintToULong' call
          // Inline function 'kotlin.uintToLong' call
          var value_0 = _UInt___get_data__impl__f0vqqw(this_1);
          var tmp$ret$4 = fromInt_0(value_0) & 4294967295n;
          var tmp0 = _ULong___init__impl__c78o9k(tmp$ret$4);
          // Inline function 'kotlin.UInt.toULong' call
          var this_2 = UIntArray__get_impl_gp5kza(operand, 1);
          // Inline function 'kotlin.uintToULong' call
          // Inline function 'kotlin.uintToLong' call
          var value_1 = _UInt___get_data__impl__f0vqqw(this_2);
          var tmp$ret$7 = fromInt_0(value_1) & 4294967295n;
          // Inline function 'kotlin.ULong.shl' call
          var this_3 = _ULong___init__impl__c78o9k(tmp$ret$7);
          var tmp0_0 = _ULong___init__impl__c78o9k(shiftLeft(_ULong___get_data__impl__fggpzb(this_3), 32));
          // Inline function 'kotlin.ULong.and' call
          var other = this.v2b_1;
          // Inline function 'kotlin.ULong.or' call
          var other_0 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(tmp0_0) & _ULong___get_data__impl__fggpzb(other));
          var tmp$ret$12 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(tmp0) | _ULong___get_data__impl__fggpzb(other_0));
          ULongArray__set_impl_z19mvh(result, 0, tmp$ret$12);
          if (_UIntArray___get_size__impl__r6l8ci(operand) === 4) {
            // Inline function 'kotlin.UInt.toULong' call
            var this_4 = UIntArray__get_impl_gp5kza(operand, 1);
            // Inline function 'kotlin.uintToULong' call
            // Inline function 'kotlin.uintToLong' call
            var value_2 = _UInt___get_data__impl__f0vqqw(this_4);
            var tmp$ret$13 = fromInt_0(value_2) & 4294967295n;
            // Inline function 'kotlin.ULong.shr' call
            var this_5 = _ULong___init__impl__c78o9k(tmp$ret$13);
            var tmp0_1 = _ULong___init__impl__c78o9k(shiftRightUnsigned(_ULong___get_data__impl__fggpzb(this_5), 31));
            // Inline function 'kotlin.UInt.toULong' call
            var this_6 = UIntArray__get_impl_gp5kza(operand, 2);
            // Inline function 'kotlin.uintToULong' call
            // Inline function 'kotlin.uintToLong' call
            var value_3 = _UInt___get_data__impl__f0vqqw(this_6);
            var tmp$ret$17 = fromInt_0(value_3) & 4294967295n;
            // Inline function 'kotlin.ULong.shl' call
            var this_7 = _ULong___init__impl__c78o9k(tmp$ret$17);
            // Inline function 'kotlin.ULong.or' call
            var other_1 = _ULong___init__impl__c78o9k(shiftLeft(_ULong___get_data__impl__fggpzb(this_7), 1));
            var tmp0_2 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(tmp0_1) | _ULong___get_data__impl__fggpzb(other_1));
            // Inline function 'kotlin.UInt.toULong' call
            var this_8 = UIntArray__get_impl_gp5kza(operand, 3);
            // Inline function 'kotlin.uintToULong' call
            // Inline function 'kotlin.uintToLong' call
            var value_4 = _UInt___get_data__impl__f0vqqw(this_8);
            var tmp$ret$22 = fromInt_0(value_4) & 4294967295n;
            // Inline function 'kotlin.ULong.shl' call
            var this_9 = _ULong___init__impl__c78o9k(tmp$ret$22);
            // Inline function 'kotlin.ULong.or' call
            var other_2 = _ULong___init__impl__c78o9k(shiftLeft(_ULong___get_data__impl__fggpzb(this_9), 33));
            var tmp$ret$26 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(tmp0_2) | _ULong___get_data__impl__fggpzb(other_2));
            ULongArray__set_impl_z19mvh(result, 1, tmp$ret$26);
          } else {
            if (_UIntArray___get_size__impl__r6l8ci(operand) > 2) {
              // Inline function 'kotlin.UInt.toULong' call
              var this_10 = UIntArray__get_impl_gp5kza(operand, 1);
              // Inline function 'kotlin.uintToULong' call
              // Inline function 'kotlin.uintToLong' call
              var value_5 = _UInt___get_data__impl__f0vqqw(this_10);
              var tmp$ret$27 = fromInt_0(value_5) & 4294967295n;
              // Inline function 'kotlin.ULong.shr' call
              var this_11 = _ULong___init__impl__c78o9k(tmp$ret$27);
              var tmp0_3 = _ULong___init__impl__c78o9k(shiftRightUnsigned(_ULong___get_data__impl__fggpzb(this_11), 31));
              // Inline function 'kotlin.UInt.toULong' call
              var this_12 = UIntArray__get_impl_gp5kza(operand, 2);
              // Inline function 'kotlin.uintToULong' call
              // Inline function 'kotlin.uintToLong' call
              var value_6 = _UInt___get_data__impl__f0vqqw(this_12);
              var tmp$ret$31 = fromInt_0(value_6) & 4294967295n;
              // Inline function 'kotlin.ULong.shl' call
              var this_13 = _ULong___init__impl__c78o9k(tmp$ret$31);
              // Inline function 'kotlin.ULong.or' call
              var other_3 = _ULong___init__impl__c78o9k(shiftLeft(_ULong___get_data__impl__fggpzb(this_13), 1));
              var tmp$ret$35 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(tmp0_3) | _ULong___get_data__impl__fggpzb(other_3));
              ULongArray__set_impl_z19mvh(result, 1, tmp$ret$35);
            } else {
              // Inline function 'kotlin.UInt.toULong' call
              var this_14 = UIntArray__get_impl_gp5kza(operand, 1);
              // Inline function 'kotlin.uintToULong' call
              // Inline function 'kotlin.uintToLong' call
              var value_7 = _UInt___get_data__impl__f0vqqw(this_14);
              var tmp$ret$36 = fromInt_0(value_7) & 4294967295n;
              // Inline function 'kotlin.ULong.shr' call
              var this_15 = _ULong___init__impl__c78o9k(tmp$ret$36);
              var tmp$ret$39 = _ULong___init__impl__c78o9k(shiftRightUnsigned(_ULong___get_data__impl__fggpzb(this_15), 31));
              ULongArray__set_impl_z19mvh(result, 1, tmp$ret$39);
            }
          }
        } else {
          if (i === 0) {
            // Inline function 'kotlin.UInt.toULong' call
            var this_16 = UIntArray__get_impl_gp5kza(operand, 0);
            // Inline function 'kotlin.uintToULong' call
            // Inline function 'kotlin.uintToLong' call
            var value_8 = _UInt___get_data__impl__f0vqqw(this_16);
            var tmp$ret$40 = fromInt_0(value_8) & 4294967295n;
            var tmp0_4 = _ULong___init__impl__c78o9k(tmp$ret$40);
            // Inline function 'kotlin.UInt.toULong' call
            var this_17 = UIntArray__get_impl_gp5kza(operand, 1);
            // Inline function 'kotlin.uintToULong' call
            // Inline function 'kotlin.uintToLong' call
            var value_9 = _UInt___get_data__impl__f0vqqw(this_17);
            var tmp$ret$43 = fromInt_0(value_9) & 4294967295n;
            // Inline function 'kotlin.ULong.shl' call
            var this_18 = _ULong___init__impl__c78o9k(tmp$ret$43);
            var tmp0_5 = _ULong___init__impl__c78o9k(shiftLeft(_ULong___get_data__impl__fggpzb(this_18), 32));
            // Inline function 'kotlin.ULong.and' call
            var other_4 = this.v2b_1;
            // Inline function 'kotlin.ULong.or' call
            var other_5 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(tmp0_5) & _ULong___get_data__impl__fggpzb(other_4));
            var tmp$ret$48 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(tmp0_4) | _ULong___get_data__impl__fggpzb(other_5));
            ULongArray__set_impl_z19mvh(result, i, tmp$ret$48);
          } else if (1 <= i ? i < (requiredLength - 1 | 0) : false) {
            // Inline function 'kotlin.UInt.toULong' call
            var this_19 = UIntArray__get_impl_gp5kza(operand, position - 1 | 0);
            // Inline function 'kotlin.uintToULong' call
            // Inline function 'kotlin.uintToLong' call
            var value_10 = _UInt___get_data__impl__f0vqqw(this_19);
            var tmp$ret$49 = fromInt_0(value_10) & 4294967295n;
            var tmp0_6 = _ULong___init__impl__c78o9k(tmp$ret$49);
            // Inline function 'kotlin.ULong.shr' call
            var bitCount = 32 - shiftAmount | 0;
            var tmp0_7 = _ULong___init__impl__c78o9k(shiftRightUnsigned(_ULong___get_data__impl__fggpzb(tmp0_6), bitCount));
            // Inline function 'kotlin.UInt.toULong' call
            var this_20 = UIntArray__get_impl_gp5kza(operand, position);
            // Inline function 'kotlin.uintToULong' call
            // Inline function 'kotlin.uintToLong' call
            var value_11 = _UInt___get_data__impl__f0vqqw(this_20);
            var tmp$ret$53 = fromInt_0(value_11) & 4294967295n;
            // Inline function 'kotlin.ULong.shl' call
            var this_21 = _ULong___init__impl__c78o9k(tmp$ret$53);
            // Inline function 'kotlin.ULong.or' call
            var other_6 = _ULong___init__impl__c78o9k(shiftLeft(_ULong___get_data__impl__fggpzb(this_21), shiftAmount));
            var tmp0_8 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(tmp0_7) | _ULong___get_data__impl__fggpzb(other_6));
            // Inline function 'kotlin.UInt.toULong' call
            var this_22 = UIntArray__get_impl_gp5kza(operand, position + 1 | 0);
            // Inline function 'kotlin.uintToULong' call
            // Inline function 'kotlin.uintToLong' call
            var value_12 = _UInt___get_data__impl__f0vqqw(this_22);
            var tmp$ret$58 = fromInt_0(value_12) & 4294967295n;
            var tmp0_9 = _ULong___init__impl__c78o9k(tmp$ret$58);
            // Inline function 'kotlin.ULong.shl' call
            var bitCount_0 = 32 + shiftAmount | 0;
            var tmp0_10 = _ULong___init__impl__c78o9k(shiftLeft(_ULong___get_data__impl__fggpzb(tmp0_9), bitCount_0));
            // Inline function 'kotlin.ULong.and' call
            var other_7 = this.v2b_1;
            // Inline function 'kotlin.ULong.or' call
            var other_8 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(tmp0_10) & _ULong___get_data__impl__fggpzb(other_7));
            var tmp$ret$63 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(tmp0_8) | _ULong___get_data__impl__fggpzb(other_8));
            ULongArray__set_impl_z19mvh(result, i, tmp$ret$63);
          } else if (i === (requiredLength - 1 | 0)) {
            if (position < _UIntArray___get_size__impl__r6l8ci(operand)) {
              // Inline function 'kotlin.UInt.toULong' call
              var this_23 = UIntArray__get_impl_gp5kza(operand, position - 1 | 0);
              // Inline function 'kotlin.uintToULong' call
              // Inline function 'kotlin.uintToLong' call
              var value_13 = _UInt___get_data__impl__f0vqqw(this_23);
              var tmp$ret$64 = fromInt_0(value_13) & 4294967295n;
              var tmp0_11 = _ULong___init__impl__c78o9k(tmp$ret$64);
              // Inline function 'kotlin.ULong.shr' call
              var bitCount_1 = 32 - shiftAmount | 0;
              var tmp0_12 = _ULong___init__impl__c78o9k(shiftRightUnsigned(_ULong___get_data__impl__fggpzb(tmp0_11), bitCount_1));
              // Inline function 'kotlin.UInt.toULong' call
              var this_24 = UIntArray__get_impl_gp5kza(operand, position);
              // Inline function 'kotlin.uintToULong' call
              // Inline function 'kotlin.uintToLong' call
              var value_14 = _UInt___get_data__impl__f0vqqw(this_24);
              var tmp$ret$68 = fromInt_0(value_14) & 4294967295n;
              // Inline function 'kotlin.ULong.shl' call
              var this_25 = _ULong___init__impl__c78o9k(tmp$ret$68);
              // Inline function 'kotlin.ULong.or' call
              var other_9 = _ULong___init__impl__c78o9k(shiftLeft(_ULong___get_data__impl__fggpzb(this_25), shiftAmount));
              var tmp$ret$72 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(tmp0_12) | _ULong___get_data__impl__fggpzb(other_9));
              ULongArray__set_impl_z19mvh(result, i, tmp$ret$72);
            } else {
              // Inline function 'kotlin.UInt.toULong' call
              var this_26 = UIntArray__get_impl_gp5kza(operand, position - 1 | 0);
              // Inline function 'kotlin.uintToULong' call
              // Inline function 'kotlin.uintToLong' call
              var value_15 = _UInt___get_data__impl__f0vqqw(this_26);
              var tmp$ret$73 = fromInt_0(value_15) & 4294967295n;
              var tmp0_13 = _ULong___init__impl__c78o9k(tmp$ret$73);
              // Inline function 'kotlin.ULong.shr' call
              var bitCount_2 = 32 - shiftAmount | 0;
              var tmp$ret$76 = _ULong___init__impl__c78o9k(shiftRightUnsigned(_ULong___get_data__impl__fggpzb(tmp0_13), bitCount_2));
              ULongArray__set_impl_z19mvh(result, i, tmp$ret$76);
            }
          }
        }
      }
       while (inductionVariable < requiredLength);
    return result;
  };
  protoOf(BigInteger63Arithmetic).n2c = function (first, second) {
    return this.b2g(first, second);
  };
  protoOf(BigInteger63Arithmetic).c2f = function (_this__u8e3s4, other) {
    return signedAdd(this, _this__u8e3s4, other);
  };
  protoOf(BigInteger63Arithmetic).e2f = function (_this__u8e3s4, other) {
    return signedSubtract(this, _this__u8e3s4, other);
  };
  protoOf(BigInteger63Arithmetic).b2f = function (_this__u8e3s4, other) {
    return signedMultiply(this, _this__u8e3s4, other);
  };
  protoOf(BigInteger63Arithmetic).w2f = function (_this__u8e3s4, other) {
    return signedDivide(this, _this__u8e3s4, other);
  };
  protoOf(BigInteger63Arithmetic).a2f = function (_this__u8e3s4, places) {
    return new SignedULongArray(this.a2g(_this__u8e3s4.f2f_1, places), _this__u8e3s4.g2f_1);
  };
  protoOf(BigInteger63Arithmetic).d2f = function (_this__u8e3s4, places) {
    return new SignedULongArray(this.w2e(_this__u8e3s4.f2f_1, places), _this__u8e3s4.g2f_1);
  };
  protoOf(BigInteger63Arithmetic).z2e = function (_this__u8e3s4, operand) {
    return new SignedULongArray(this.j2g(_this__u8e3s4.f2f_1, operand), _this__u8e3s4.g2f_1);
  };
  protoOf(BigInteger63Arithmetic).z2a = function (number, base) {
    var parsed = this.l2b_1;
    // Inline function 'kotlin.text.toLowerCase' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.text.forEach' call
    var indexedObject = number.toLowerCase();
    var inductionVariable = 0;
    while (inductionVariable < charSequenceLength(indexedObject)) {
      var element = charSequenceGet(indexedObject, inductionVariable);
      inductionVariable = inductionVariable + 1 | 0;
      var tmp = BigInteger63Arithmetic_getInstance();
      var tmp_0 = BigInteger63Arithmetic_getInstance();
      var tmp_1 = parsed;
      // Inline function 'kotlin.toULong' call
      var tmp$ret$2 = _ULong___init__impl__c78o9k(fromInt_0(base));
      var tmp_2 = tmp_0.k2g(tmp_1, tmp$ret$2);
      // Inline function 'kotlin.toULong' call
      var this_0 = toDigit(element, base);
      var tmp$ret$3 = _ULong___init__impl__c78o9k(fromInt_0(this_0));
      parsed = tmp.c2g(tmp_2, tmp$ret$3);
    }
    return this.c2c(parsed);
  };
  protoOf(BigInteger63Arithmetic).u2c = function (operand, base) {
    // Inline function 'kotlin.collections.copyOf' call
    var copy = _ULongArray___init__impl__twm1l3(copyOf_8(_ULongArray___get_storage__impl__28e64j(operand)));
    // Inline function 'kotlin.toULong' call
    var tmp$ret$1 = _ULong___init__impl__c78o9k(fromInt_0(base));
    // Inline function 'kotlin.ulongArrayOf' call
    var baseArray = _ULongArray___init__impl__twm1l3(longArrayOf([tmp$ret$1]));
    var stringBuilder = StringBuilder_init_$Create$_1();
    while (!equals(copy, this.l2b_1)) {
      var divremResult = this.l2g(copy, baseArray);
      if (ULongArray__isEmpty_impl_c3yngu(divremResult.qg_1.gn_1)) {
        stringBuilder.gc(0);
      } else {
        stringBuilder.j8(toString_6(ULongArray__get_impl_pr71q9(divremResult.qg_1.gn_1, 0), base));
      }
      copy = divremResult.pg_1.gn_1;
    }
    // Inline function 'kotlin.text.reversed' call
    var this_0 = stringBuilder.toString();
    return toString_1(reversed_1(isCharSequence(this_0) ? this_0 : THROW_CCE()));
  };
  protoOf(BigInteger63Arithmetic).j2g = function (operand, mask) {
    var tmp;
    if (_ULongArray___get_size__impl__ju6dtr(operand) > _ULongArray___get_size__impl__ju6dtr(mask)) {
      tmp = new Pair(new ULongArray(operand), new ULongArray(mask));
    } else {
      tmp = new Pair(new ULongArray(mask), new ULongArray(operand));
    }
    var _destruct__k2r9zo = tmp;
    var bigger = _destruct__k2r9zo.fg().gn_1;
    var smaller = _destruct__k2r9zo.gg().gn_1;
    // Inline function 'kotlin.ULongArray' call
    var tmp_0 = 0;
    var tmp_1 = _ULongArray___get_size__impl__ju6dtr(smaller);
    var tmp_2 = longArray(tmp_1);
    while (tmp_0 < tmp_1) {
      var tmp_3 = tmp_0;
      var tmp0 = ULongArray__get_impl_pr71q9(operand, tmp_3);
      // Inline function 'kotlin.ULong.and' call
      var other = ULongArray__get_impl_pr71q9(mask, tmp_3);
      // Inline function 'kotlin.ULong.toLong' call
      var this_0 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(tmp0) & _ULong___get_data__impl__fggpzb(other));
      tmp_2[tmp_3] = _ULong___get_data__impl__fggpzb(this_0);
      tmp_0 = tmp_0 + 1 | 0;
    }
    return _ULongArray___init__impl__twm1l3(tmp_2);
  };
  protoOf(BigInteger63Arithmetic).w2e = function (_this__u8e3s4, places) {
    return this.q2f(_this__u8e3s4, places);
  };
  protoOf(BigInteger63Arithmetic).a2g = function (_this__u8e3s4, places) {
    return this.r2f(_this__u8e3s4, places);
  };
  protoOf(BigInteger63Arithmetic).x2e = function (_this__u8e3s4, other) {
    return this.f2c(_this__u8e3s4, other);
  };
  protoOf(BigInteger63Arithmetic).k2f = function (_this__u8e3s4, other) {
    return this.e2c(_this__u8e3s4, other);
  };
  protoOf(BigInteger63Arithmetic).l2f = function (_this__u8e3s4, other) {
    return this.l2c(_this__u8e3s4, other);
  };
  protoOf(BigInteger63Arithmetic).c2g = function (_this__u8e3s4, other) {
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp$ret$0 = _ULongArray___init__impl__twm1l3(longArrayOf([other]));
    return this.f2c(_this__u8e3s4, tmp$ret$0);
  };
  protoOf(BigInteger63Arithmetic).y2e = function (_this__u8e3s4, other) {
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp$ret$0 = _ULongArray___init__impl__twm1l3(longArrayOf([other]));
    return this.e2c(_this__u8e3s4, tmp$ret$0);
  };
  protoOf(BigInteger63Arithmetic).k2g = function (_this__u8e3s4, other) {
    return this.v2e(_this__u8e3s4, other);
  };
  protoOf(BigInteger63Arithmetic).m2f = function (_this__u8e3s4, other) {
    return this.n2c(_this__u8e3s4, other).pg_1.gn_1;
  };
  protoOf(BigInteger63Arithmetic).l2g = function (_this__u8e3s4, other) {
    return this.n2c(_this__u8e3s4, other);
  };
  protoOf(BigInteger63Arithmetic).s2c = function (_this__u8e3s4, other) {
    return this.i2b(_this__u8e3s4, other);
  };
  protoOf(BigInteger63Arithmetic).f2g = function (_this__u8e3s4, other) {
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp$ret$0 = _ULongArray___init__impl__twm1l3(longArrayOf([other]));
    return this.i2b(_this__u8e3s4, tmp$ret$0);
  };
  protoOf(BigInteger63Arithmetic).d2g = function (_this__u8e3s4) {
    return this.h2g(_this__u8e3s4);
  };
  protoOf(BigInteger63Arithmetic).e2g = function (_this__u8e3s4) {
    return this.i2g(_this__u8e3s4);
  };
  protoOf(BigInteger63Arithmetic).b2b = function (uLong) {
    var tmp;
    // Inline function 'kotlin.ULong.and' call
    var other = this.w2b_1;
    if (!(_ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(uLong) & _ULong___get_data__impl__fggpzb(other)) === _ULong___init__impl__c78o9k(0n))) {
      // Inline function 'kotlin.ULong.and' call
      var other_0 = this.s2b_1;
      var tmp$ret$1 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(uLong) & _ULong___get_data__impl__fggpzb(other_0));
      // Inline function 'kotlin.ulongArrayOf' call
      tmp = _ULongArray___init__impl__twm1l3(longArrayOf([tmp$ret$1, _ULong___init__impl__c78o9k(1n)]));
    } else {
      // Inline function 'kotlin.ulongArrayOf' call
      tmp = _ULongArray___init__impl__twm1l3(longArrayOf([uLong]));
    }
    return tmp;
  };
  protoOf(BigInteger63Arithmetic).d2b = function (uInt) {
    // Inline function 'kotlin.UInt.toULong' call
    // Inline function 'kotlin.uintToULong' call
    // Inline function 'kotlin.uintToLong' call
    var value = _UInt___get_data__impl__f0vqqw(uInt);
    var tmp$ret$0 = fromInt_0(value) & 4294967295n;
    var tmp$ret$2 = _ULong___init__impl__c78o9k(tmp$ret$0);
    // Inline function 'kotlin.ulongArrayOf' call
    return _ULongArray___init__impl__twm1l3(longArrayOf([tmp$ret$2]));
  };
  protoOf(BigInteger63Arithmetic).f2b = function (uShort) {
    // Inline function 'kotlin.UShort.toULong' call
    var tmp$ret$0 = _ULong___init__impl__c78o9k(fromInt_0(_UShort___get_data__impl__g0245(uShort)) & 65535n);
    // Inline function 'kotlin.ulongArrayOf' call
    return _ULongArray___init__impl__twm1l3(longArrayOf([tmp$ret$0]));
  };
  protoOf(BigInteger63Arithmetic).h2b = function (uByte) {
    // Inline function 'kotlin.UByte.toULong' call
    var tmp$ret$0 = _ULong___init__impl__c78o9k(fromInt_0(_UByte___get_data__impl__jof9qr(uByte)) & 255n);
    // Inline function 'kotlin.ulongArrayOf' call
    return _ULongArray___init__impl__twm1l3(longArrayOf([tmp$ret$0]));
  };
  protoOf(BigInteger63Arithmetic).r2a = function (long) {
    if (long === -9223372036854775808n) {
      // Inline function 'kotlin.ulongArrayOf' call
      return _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(0n), _ULong___init__impl__c78o9k(1n)]));
    }
    // Inline function 'kotlin.math.absoluteValue' call
    // Inline function 'kotlin.toULong' call
    var this_0 = abs_1(long);
    var tmp0 = _ULong___init__impl__c78o9k(this_0);
    // Inline function 'kotlin.ULong.and' call
    var other = this.s2b_1;
    var tmp$ret$3 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(tmp0) & _ULong___get_data__impl__fggpzb(other));
    // Inline function 'kotlin.ulongArrayOf' call
    return _ULongArray___init__impl__twm1l3(longArrayOf([tmp$ret$3]));
  };
  protoOf(BigInteger63Arithmetic).s2a = function (int) {
    // Inline function 'kotlin.math.absoluteValue' call
    var this_0 = fromInt_0(int);
    // Inline function 'kotlin.toULong' call
    var this_1 = abs_1(this_0);
    var tmp$ret$1 = _ULong___init__impl__c78o9k(this_1);
    // Inline function 'kotlin.ulongArrayOf' call
    return _ULongArray___init__impl__twm1l3(longArrayOf([tmp$ret$1]));
  };
  protoOf(BigInteger63Arithmetic).t2a = function (short) {
    // Inline function 'kotlin.math.absoluteValue' call
    // Inline function 'kotlin.toULong' call
    var this_0 = abs_0(short);
    var tmp$ret$1 = _ULong___init__impl__c78o9k(fromInt_0(this_0));
    // Inline function 'kotlin.ulongArrayOf' call
    return _ULongArray___init__impl__twm1l3(longArrayOf([tmp$ret$1]));
  };
  protoOf(BigInteger63Arithmetic).u2a = function (byte) {
    // Inline function 'kotlin.math.absoluteValue' call
    // Inline function 'kotlin.toULong' call
    var this_0 = abs_0(byte);
    var tmp$ret$1 = _ULong___init__impl__c78o9k(fromInt_0(this_0));
    // Inline function 'kotlin.ulongArrayOf' call
    return _ULongArray___init__impl__twm1l3(longArrayOf([tmp$ret$1]));
  };
  var BigInteger63Arithmetic_instance;
  function BigInteger63Arithmetic_getInstance() {
    if (BigInteger63Arithmetic_instance == null)
      new BigInteger63Arithmetic();
    return BigInteger63Arithmetic_instance;
  }
  function toDigit(_this__u8e3s4, base) {
    base = base === VOID ? 10 : base;
    var tmp;
    if (_Char___init__impl__6a9atx(48) <= _this__u8e3s4 ? _this__u8e3s4 <= _Char___init__impl__6a9atx(57) : false) {
      tmp = Char__toInt_impl_vasixd(Char__minus_impl_a2frrh_0(_this__u8e3s4, 48));
    } else if (_Char___init__impl__6a9atx(97) <= _this__u8e3s4 ? _this__u8e3s4 <= _Char___init__impl__6a9atx(122) : false) {
      tmp = Char__minus_impl_a2frrh(_this__u8e3s4, _Char___init__impl__6a9atx(97)) + 10 | 0;
    } else if (_Char___init__impl__6a9atx(65) <= _this__u8e3s4 ? _this__u8e3s4 <= _Char___init__impl__6a9atx(90) : false) {
      tmp = Char__minus_impl_a2frrh(_this__u8e3s4, _Char___init__impl__6a9atx(65)) + 10 | 0;
    } else if (_Char___init__impl__6a9atx(65313) <= _this__u8e3s4 ? _this__u8e3s4 <= _Char___init__impl__6a9atx(65338) : false) {
      tmp = Char__minus_impl_a2frrh(_this__u8e3s4, _Char___init__impl__6a9atx(65313)) - 10 | 0;
    } else if (_Char___init__impl__6a9atx(65345) <= _this__u8e3s4 ? _this__u8e3s4 <= _Char___init__impl__6a9atx(65370) : false) {
      tmp = Char__minus_impl_a2frrh(_this__u8e3s4, _Char___init__impl__6a9atx(65345)) - 10 | 0;
    } else if (_this__u8e3s4 === _Char___init__impl__6a9atx(46)) {
      throw NumberFormatException_init_$Create$_0('Invalid digit for radix ' + toString(_this__u8e3s4) + ' (Possibly a decimal value, which is not supported by BigInteger parser');
    } else {
      throw NumberFormatException_init_$Create$_0('Invalid digit for radix ' + toString(_this__u8e3s4));
    }
    var digit = tmp;
    if (digit < 0 || digit >= base) {
      throw NumberFormatException_init_$Create$_0(toString(_this__u8e3s4) + ' is not a valid digit for number system with base ' + base);
    }
    return digit;
  }
  function RuntimePlatform() {
  }
  protoOf(RuntimePlatform).l2a = function () {
    return Platform_JS_getInstance();
  };
  var RuntimePlatform_instance;
  function RuntimePlatform_getInstance() {
    return RuntimePlatform_instance;
  }
  function parseValue($this, lexer) {
    var tmp0_subject = lexer.p2g();
    switch (tmp0_subject == null ? -1 : tmp0_subject.x2_1) {
      case 9:
        var sv = lexer.q2g();
        lexer.r2g();
        return new JsonString(sv);
      case 2:
        return parseArray($this, lexer);
      case 8:
        var dv = Companion_getInstance_24().j29(lexer.s2g());
        lexer.r2g();
        return new JsonNumber(dv);
      case 0:
        return parseObject($this, lexer);
      case 4:
        lexer.r2g();
        return new JsonNull();
      case 5:
        lexer.r2g();
        return new JsonBoolean(true);
      case 6:
        lexer.r2g();
        return new JsonBoolean(false);
      default:
        throw JsonParsingException_init_$Create$();
    }
  }
  function parseObject($this, lexer) {
    var result = new JsonObject();
    lexer.t2g(JsonTokenKind_LEFT_BRACE_getInstance());
    while (!equals(lexer.p2g(), JsonTokenKind_RIGHT_BRACE_getInstance())) {
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!result.r2().s()) {
        lexer.t2g(JsonTokenKind_COMMA_getInstance());
      }
      if (!equals(lexer.p2g(), JsonTokenKind_STRING_getInstance())) {
        throw JsonParsingException_init_$Create$();
      }
      var key = lexer.q2g();
      lexer.r2g();
      lexer.t2g(JsonTokenKind_COLON_getInstance());
      result.v2g(key, parseValue($this, lexer));
    }
    lexer.t2g(JsonTokenKind_RIGHT_BRACE_getInstance());
    return result;
  }
  function parseArray($this, lexer) {
    var result = new JsonArray();
    lexer.t2g(JsonTokenKind_LEFT_BRACKET_getInstance());
    while (!equals(lexer.p2g(), JsonTokenKind_RIGHT_BRACKET_getInstance())) {
      if (result.x2g() > 0) {
        lexer.t2g(JsonTokenKind_COMMA_getInstance());
      }
      result.y2g(parseValue($this, lexer));
    }
    lexer.t2g(JsonTokenKind_RIGHT_BRACKET_getInstance());
    return result;
  }
  function DefaultJsonSupport() {
  }
  protoOf(DefaultJsonSupport).z2g = function (input) {
    try {
      var lexer = new StringJsonLexer(input);
      var result = parseValue(this, lexer);
      var tokenKind = lexer.p2g();
      if (!(tokenKind == null)) {
        throw JsonParsingException_init_$Create$_0('tokenKind: ' + tokenKind.toString());
      }
      return result;
    } catch ($p) {
      if ($p instanceof RuntimeException) {
        var e = $p;
        throw JsonParsingException_init_$Create$_1("Failed to parse json='" + input + "'", e);
      } else {
        throw $p;
      }
    }
  };
  protoOf(DefaultJsonSupport).a2h = function (value) {
    return value.n2a(0);
  };
  function nSpaces($this, n) {
    var inductionVariable = 0;
    if (inductionVariable < n)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        $this.c2h_1.k8(_Char___init__impl__6a9atx(32));
      }
       while (inductionVariable < n);
  }
  function IndentBuilder(myIndentSize) {
    this.b2h_1 = myIndentSize;
    this.c2h_1 = StringBuilder_init_$Create$_1();
    this.d2h_1 = 0;
  }
  protoOf(IndentBuilder).e2h = function (o) {
    this.c2h_1.i8(o);
    return this;
  };
  protoOf(IndentBuilder).f2h = function () {
    if (this.b2h_1 > 0) {
      this.c2h_1.j8('\n');
      nSpaces(this, imul(this.d2h_1, this.b2h_1));
    }
  };
  protoOf(IndentBuilder).g2h = function () {
    this.d2h_1 = this.d2h_1 + 1 | 0;
  };
  protoOf(IndentBuilder).h2h = function () {
    this.d2h_1 = this.d2h_1 - 1 | 0;
  };
  protoOf(IndentBuilder).toString = function () {
    return this.c2h_1.toString();
  };
  function Json() {
    Json_instance = this;
    this.i2h_1 = new DefaultJsonSupport();
  }
  protoOf(Json).z2g = function (input) {
    return this.i2h_1.z2g(input);
  };
  protoOf(Json).a2h = function (value) {
    return this.i2h_1.a2h(value);
  };
  var Json_instance;
  function Json_getInstance() {
    if (Json_instance == null)
      new Json();
    return Json_instance;
  }
  function Companion_27() {
    Companion_instance_27 = this;
    this.j2h_1 = emptyList();
  }
  var Companion_instance_27;
  function Companion_getInstance_27() {
    if (Companion_instance_27 == null)
      new Companion_27();
    return Companion_instance_27;
  }
  function JsonArray() {
    Companion_getInstance_27();
    JsonValue.call(this);
    this.w2g_1 = null;
  }
  protoOf(JsonArray).m = function () {
    var tmp;
    if (this.w2g_1 == null) {
      tmp = Companion_getInstance_27().j2h_1.m();
    } else {
      tmp = ensureNotNull(this.w2g_1).m();
    }
    return tmp;
  };
  protoOf(JsonArray).x2g = function () {
    var tmp;
    if (this.w2g_1 == null) {
      tmp = 0;
    } else {
      tmp = ensureNotNull(this.w2g_1).p();
    }
    return tmp;
  };
  protoOf(JsonArray).k2h = function (pos, value) {
    if (this.w2g_1 == null) {
      this.w2g_1 = ArrayList_init_$Create$_0(1);
    }
    ensureNotNull(this.w2g_1).m2(pos, value);
  };
  protoOf(JsonArray).l2h = function (pos) {
    ensureNotNull(this.w2g_1).n2(pos);
  };
  protoOf(JsonArray).y2g = function (value) {
    this.k2h(this.x2g(), value);
  };
  protoOf(JsonArray).r = function (index) {
    return ensureNotNull(this.w2g_1).r(index);
  };
  protoOf(JsonArray).m2h = function (s) {
    this.y2g(new JsonString(s));
  };
  protoOf(JsonArray).n2h = function (d) {
    this.y2g(new JsonNumber(d));
  };
  protoOf(JsonArray).o2h = function (d) {
    this.n2h(Companion_getInstance_24().w28(d));
  };
  protoOf(JsonArray).p2h = function (i) {
    this.n2h(Companion_getInstance_24().h26(i));
  };
  protoOf(JsonArray).q2h = function (index) {
    var tmp = this.r(index);
    return tmp instanceof JsonObject ? tmp : THROW_CCE();
  };
  protoOf(JsonArray).r2h = function (index) {
    var tmp = this.r(index);
    return tmp instanceof JsonArray ? tmp : THROW_CCE();
  };
  protoOf(JsonArray).s2h = function (index) {
    var tmp = this.r(index);
    return (tmp instanceof JsonString ? tmp : THROW_CCE()).t2h_1;
  };
  protoOf(JsonArray).u2h = function (index) {
    var tmp = this.r(index);
    return (tmp instanceof JsonNumber ? tmp : THROW_CCE()).w2h();
  };
  protoOf(JsonArray).x2h = function (builder) {
    // Inline function 'kotlin.with' call
    builder.e2h('[');
    builder.g2h();
    builder.f2h();
    var size = this.x2g();
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.r(i).x2h(builder);
        if (!(i === (size - 1 | 0))) {
          builder.e2h(',');
          builder.f2h();
        }
      }
       while (inductionVariable < size);
    builder.h2h();
    builder.f2h();
    builder.e2h(']');
  };
  function JsonBoolean(booleanValue) {
    JsonValue.call(this);
    this.y2h_1 = booleanValue;
  }
  protoOf(JsonBoolean).x2h = function (builder) {
    builder.e2h(this.y2h_1);
  };
  function readNumber($this) {
    var tmp = $this.z2h();
    // Inline function 'kotlin.code' call
    var this_0 = _Char___init__impl__6a9atx(45);
    if (tmp === Char__toInt_impl_vasixd(this_0)) {
      $this.a2i();
    }
    while (isDigit_0($this, $this.z2h())) {
      $this.a2i();
    }
    var tmp_0 = $this.z2h();
    // Inline function 'kotlin.code' call
    var this_1 = _Char___init__impl__6a9atx(46);
    if (tmp_0 === Char__toInt_impl_vasixd(this_1)) {
      $this.a2i();
      if (!isDigit_0($this, $this.z2h())) {
        throw JsonParsingException_init_$Create$();
      }
      while (isDigit_0($this, $this.z2h())) {
        $this.a2i();
      }
    }
    if (readExponent($this)) {
      if (!isDigit_0($this, $this.z2h())) {
        throw JsonParsingException_init_$Create$();
      }
      $this.a2i();
      while (isDigit_0($this, $this.z2h())) {
        $this.a2i();
      }
    }
  }
  function readExponent($this) {
    var tmp;
    var tmp_0 = $this.z2h();
    // Inline function 'kotlin.code' call
    var this_0 = _Char___init__impl__6a9atx(69);
    if (tmp_0 === Char__toInt_impl_vasixd(this_0)) {
      tmp = true;
    } else {
      var tmp_1 = $this.z2h();
      // Inline function 'kotlin.code' call
      var this_1 = _Char___init__impl__6a9atx(101);
      tmp = tmp_1 === Char__toInt_impl_vasixd(this_1);
    }
    if (tmp) {
      $this.a2i();
      var tmp_2;
      var tmp_3 = $this.z2h();
      // Inline function 'kotlin.code' call
      var this_2 = _Char___init__impl__6a9atx(43);
      if (tmp_3 === Char__toInt_impl_vasixd(this_2)) {
        tmp_2 = true;
      } else {
        var tmp_4 = $this.z2h();
        // Inline function 'kotlin.code' call
        var this_3 = _Char___init__impl__6a9atx(45);
        tmp_2 = tmp_4 === Char__toInt_impl_vasixd(this_3);
      }
      if (tmp_2) {
        $this.a2i();
      }
      return true;
    }
    return false;
  }
  function readString($this) {
    if (!$this.b2i('"')) {
      throw JsonParsingException_init_$Create$();
    }
    $l$loop: while (true) {
      var tmp;
      var tmp_0 = $this.z2h();
      // Inline function 'kotlin.code' call
      var this_0 = _Char___init__impl__6a9atx(34);
      if (!(tmp_0 === Char__toInt_impl_vasixd(this_0))) {
        tmp = !($this.z2h() === -1);
      } else {
        tmp = false;
      }
      if (!tmp) {
        break $l$loop;
      }
      var tmp_1 = $this.z2h();
      // Inline function 'kotlin.code' call
      var this_1 = _Char___init__impl__6a9atx(92);
      if (tmp_1 === Char__toInt_impl_vasixd(this_1)) {
        $this.a2i();
        if (JsonUtil_getInstance().h2i(numberToChar($this.z2h()))) {
          $this.a2i();
        } else {
          var tmp_2 = $this.z2h();
          // Inline function 'kotlin.code' call
          var this_2 = _Char___init__impl__6a9atx(117);
          if (tmp_2 === Char__toInt_impl_vasixd(this_2)) {
            $this.a2i();
            var inductionVariable = 0;
            if (inductionVariable <= 3)
              do {
                var i = inductionVariable;
                inductionVariable = inductionVariable + 1 | 0;
                if (!isHexDigit($this, $this.z2h())) {
                  throw JsonParsingException_init_$Create$();
                }
                $this.a2i();
              }
               while (inductionVariable <= 3);
          } else {
            throw RuntimeException_init_$Create$();
          }
        }
      } else {
        if (JsonUtil_getInstance().g2i(numberToChar($this.z2h()))) {
          throw JsonParsingException_init_$Create$();
        } else {
          $this.a2i();
        }
      }
    }
    if (!$this.b2i('"')) {
      throw JsonParsingException_init_$Create$();
    }
  }
  function skipSpaces($this) {
    while (!($this.z2h() === -1) && isWhiteSpace($this, $this.z2h())) {
      $this.a2i();
    }
  }
  function isWhiteSpace($this, ch) {
    var char = numberToChar(ch);
    return char === _Char___init__impl__6a9atx(32) || char === _Char___init__impl__6a9atx(9) || char === _Char___init__impl__6a9atx(10) || char === _Char___init__impl__6a9atx(13);
  }
  function isDigit_0($this, ch) {
    return isDigit(numberToChar(ch));
  }
  function isHexDigit($this, ch) {
    var char = numberToChar(ch);
    return isDigit(char) || (_Char___init__impl__6a9atx(97) <= char ? char <= _Char___init__impl__6a9atx(102) : false) || (_Char___init__impl__6a9atx(65) <= char ? char <= _Char___init__impl__6a9atx(70) : false);
  }
  function JsonLexer(isExhaustive) {
    this.m2g_1 = isExhaustive;
    this.n2g_1 = null;
    this.o2g_1 = !this.m2g_1;
  }
  protoOf(JsonLexer).p2g = function () {
    if (this.o2g_1) {
      this.o2g_1 = false;
      this.r2g();
    }
    return this.n2g_1;
  };
  protoOf(JsonLexer).r2g = function () {
    skipSpaces(this);
    if (this.z2h() === -1) {
      this.n2g_1 = null;
      return Unit_instance;
    }
    this.i2i();
    var tmp = this.z2h();
    // Inline function 'kotlin.code' call
    var this_0 = _Char___init__impl__6a9atx(34);
    if (tmp === Char__toInt_impl_vasixd(this_0)) {
      readString(this);
      this.n2g_1 = JsonTokenKind_STRING_getInstance();
      return Unit_instance;
    }
    var tmp_0 = this.z2h();
    // Inline function 'kotlin.code' call
    var this_1 = _Char___init__impl__6a9atx(44);
    if (tmp_0 === Char__toInt_impl_vasixd(this_1)) {
      this.n2g_1 = JsonTokenKind_COMMA_getInstance();
      this.a2i();
      return Unit_instance;
    }
    var tmp_1 = this.z2h();
    // Inline function 'kotlin.code' call
    var this_2 = _Char___init__impl__6a9atx(91);
    if (tmp_1 === Char__toInt_impl_vasixd(this_2)) {
      this.n2g_1 = JsonTokenKind_LEFT_BRACKET_getInstance();
      this.a2i();
      return Unit_instance;
    }
    var tmp_2 = this.z2h();
    // Inline function 'kotlin.code' call
    var this_3 = _Char___init__impl__6a9atx(93);
    if (tmp_2 === Char__toInt_impl_vasixd(this_3)) {
      this.n2g_1 = JsonTokenKind_RIGHT_BRACKET_getInstance();
      this.a2i();
      return Unit_instance;
    }
    var tmp_3;
    if (isDigit_0(this, this.z2h())) {
      tmp_3 = true;
    } else {
      var tmp_4 = this.z2h();
      // Inline function 'kotlin.code' call
      var this_4 = _Char___init__impl__6a9atx(45);
      tmp_3 = tmp_4 === Char__toInt_impl_vasixd(this_4);
    }
    if (tmp_3) {
      readNumber(this);
      this.n2g_1 = JsonTokenKind_NUMBER_getInstance();
      return Unit_instance;
    }
    var tmp_5 = this.z2h();
    // Inline function 'kotlin.code' call
    var this_5 = _Char___init__impl__6a9atx(123);
    if (tmp_5 === Char__toInt_impl_vasixd(this_5)) {
      this.n2g_1 = JsonTokenKind_LEFT_BRACE_getInstance();
      this.a2i();
      return Unit_instance;
    }
    var tmp_6 = this.z2h();
    // Inline function 'kotlin.code' call
    var this_6 = _Char___init__impl__6a9atx(125);
    if (tmp_6 === Char__toInt_impl_vasixd(this_6)) {
      this.n2g_1 = JsonTokenKind_RIGHT_BRACE_getInstance();
      this.a2i();
      return Unit_instance;
    }
    var tmp_7 = this.z2h();
    // Inline function 'kotlin.code' call
    var this_7 = _Char___init__impl__6a9atx(58);
    if (tmp_7 === Char__toInt_impl_vasixd(this_7)) {
      this.n2g_1 = JsonTokenKind_COLON_getInstance();
      this.a2i();
      return Unit_instance;
    }
    if (this.b2i('null')) {
      this.n2g_1 = JsonTokenKind_NULL_getInstance();
      return Unit_instance;
    }
    if (this.b2i('true')) {
      this.n2g_1 = JsonTokenKind_TRUE_getInstance();
      return Unit_instance;
    }
    if (this.b2i('false')) {
      this.n2g_1 = JsonTokenKind_FALSE_getInstance();
      return Unit_instance;
    }
    throw JsonParsingException_init_$Create$();
  };
  protoOf(JsonLexer).t2g = function (kind) {
    if (this.o2g_1) {
      this.o2g_1 = false;
      this.r2g();
    }
    if (!equals(this.n2g_1, kind)) {
      throw JsonParsingException_init_$Create$();
    }
    if (this.m2g_1) {
      this.r2g();
    } else {
      this.o2g_1 = true;
    }
  };
  function JsonNull() {
    JsonValue.call(this);
  }
  protoOf(JsonNull).x2h = function (builder) {
    builder.e2h('null');
  };
  function JsonNumber(decimalValue) {
    JsonValue.call(this);
    this.v2h_1 = decimalValue;
  }
  protoOf(JsonNumber).w2h = function () {
    return this.v2h_1.x27(false);
  };
  protoOf(JsonNumber).x2h = function (builder) {
    builder.e2h(this.v2h_1.m2a());
  };
  function JsonObject() {
    JsonValue.call(this);
    this.u2g_1 = LinkedHashMap_init_$Create$();
  }
  protoOf(JsonObject).r2 = function () {
    return this.u2g_1.r2();
  };
  protoOf(JsonObject).v2g = function (key, value) {
    // Inline function 'kotlin.collections.set' call
    this.u2g_1.t2(key, value);
  };
  protoOf(JsonObject).j2i = function (key, value) {
    if (!(value == null)) {
      this.v2g(key, new JsonString(value));
    }
  };
  protoOf(JsonObject).ld = function (key) {
    return this.u2g_1.q2(key);
  };
  protoOf(JsonObject).ny = function (key) {
    var tmp = this.ld(key);
    var tmp0_elvis_lhs = (tmp == null ? true : tmp instanceof JsonString) ? tmp : THROW_CCE();
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var value = tmp_0;
    return value.t2h_1;
  };
  protoOf(JsonObject).k2i = function (key) {
    var tmp = this.ld(key);
    return (tmp == null ? true : tmp instanceof JsonArray) ? tmp : THROW_CCE();
  };
  protoOf(JsonObject).x2h = function (builder) {
    builder.e2h('{');
    builder.g2h();
    builder.f2h();
    var keys = ArrayList_init_$Create$_1(this.u2g_1.r2());
    var inductionVariable = 0;
    var last = keys.p();
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        builder.e2h('"').e2h(JsonUtil_getInstance().sc(keys.r(i))).e2h('":');
        ensureNotNull(this.u2g_1.q2(keys.r(i))).x2h(builder);
        if (!(i === (keys.p() - 1 | 0))) {
          builder.e2h(',');
          builder.f2h();
        }
      }
       while (inductionVariable < last);
    builder.h2h();
    builder.f2h();
    builder.e2h('}');
  };
  function JsonParsingException_init_$Init$($this) {
    RuntimeException_init_$Init$($this);
    JsonParsingException.call($this);
    return $this;
  }
  function JsonParsingException_init_$Create$() {
    var tmp = JsonParsingException_init_$Init$(objectCreate(protoOf(JsonParsingException)));
    captureStack(tmp, JsonParsingException_init_$Create$);
    return tmp;
  }
  function JsonParsingException_init_$Init$_0(message, $this) {
    RuntimeException_init_$Init$_0(message, $this);
    JsonParsingException.call($this);
    return $this;
  }
  function JsonParsingException_init_$Create$_0(message) {
    var tmp = JsonParsingException_init_$Init$_0(message, objectCreate(protoOf(JsonParsingException)));
    captureStack(tmp, JsonParsingException_init_$Create$_0);
    return tmp;
  }
  function JsonParsingException_init_$Init$_1(message, cause, $this) {
    RuntimeException_init_$Init$_1(message, cause, $this);
    JsonParsingException.call($this);
    return $this;
  }
  function JsonParsingException_init_$Create$_1(message, cause) {
    var tmp = JsonParsingException_init_$Init$_1(message, cause, objectCreate(protoOf(JsonParsingException)));
    captureStack(tmp, JsonParsingException_init_$Create$_1);
    return tmp;
  }
  function JsonParsingException() {
    captureStack(this, JsonParsingException);
  }
  function JsonString(stringValue) {
    JsonValue.call(this);
    this.t2h_1 = stringValue;
  }
  protoOf(JsonString).x2h = function (builder) {
    builder.e2h('"');
    builder.e2h(JsonUtil_getInstance().sc(this.t2h_1));
    builder.e2h('"');
  };
  var JsonTokenKind_LEFT_BRACE_instance;
  var JsonTokenKind_RIGHT_BRACE_instance;
  var JsonTokenKind_LEFT_BRACKET_instance;
  var JsonTokenKind_RIGHT_BRACKET_instance;
  var JsonTokenKind_NULL_instance;
  var JsonTokenKind_TRUE_instance;
  var JsonTokenKind_FALSE_instance;
  var JsonTokenKind_COMMA_instance;
  var JsonTokenKind_NUMBER_instance;
  var JsonTokenKind_STRING_instance;
  var JsonTokenKind_COLON_instance;
  var JsonTokenKind_entriesInitialized;
  function JsonTokenKind_initEntries() {
    if (JsonTokenKind_entriesInitialized)
      return Unit_instance;
    JsonTokenKind_entriesInitialized = true;
    JsonTokenKind_LEFT_BRACE_instance = new JsonTokenKind('LEFT_BRACE', 0);
    JsonTokenKind_RIGHT_BRACE_instance = new JsonTokenKind('RIGHT_BRACE', 1);
    JsonTokenKind_LEFT_BRACKET_instance = new JsonTokenKind('LEFT_BRACKET', 2);
    JsonTokenKind_RIGHT_BRACKET_instance = new JsonTokenKind('RIGHT_BRACKET', 3);
    JsonTokenKind_NULL_instance = new JsonTokenKind('NULL', 4);
    JsonTokenKind_TRUE_instance = new JsonTokenKind('TRUE', 5);
    JsonTokenKind_FALSE_instance = new JsonTokenKind('FALSE', 6);
    JsonTokenKind_COMMA_instance = new JsonTokenKind('COMMA', 7);
    JsonTokenKind_NUMBER_instance = new JsonTokenKind('NUMBER', 8);
    JsonTokenKind_STRING_instance = new JsonTokenKind('STRING', 9);
    JsonTokenKind_COLON_instance = new JsonTokenKind('COLON', 10);
  }
  function JsonTokenKind(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function JsonTokenKind_LEFT_BRACE_getInstance() {
    JsonTokenKind_initEntries();
    return JsonTokenKind_LEFT_BRACE_instance;
  }
  function JsonTokenKind_RIGHT_BRACE_getInstance() {
    JsonTokenKind_initEntries();
    return JsonTokenKind_RIGHT_BRACE_instance;
  }
  function JsonTokenKind_LEFT_BRACKET_getInstance() {
    JsonTokenKind_initEntries();
    return JsonTokenKind_LEFT_BRACKET_instance;
  }
  function JsonTokenKind_RIGHT_BRACKET_getInstance() {
    JsonTokenKind_initEntries();
    return JsonTokenKind_RIGHT_BRACKET_instance;
  }
  function JsonTokenKind_NULL_getInstance() {
    JsonTokenKind_initEntries();
    return JsonTokenKind_NULL_instance;
  }
  function JsonTokenKind_TRUE_getInstance() {
    JsonTokenKind_initEntries();
    return JsonTokenKind_TRUE_instance;
  }
  function JsonTokenKind_FALSE_getInstance() {
    JsonTokenKind_initEntries();
    return JsonTokenKind_FALSE_instance;
  }
  function JsonTokenKind_COMMA_getInstance() {
    JsonTokenKind_initEntries();
    return JsonTokenKind_COMMA_instance;
  }
  function JsonTokenKind_NUMBER_getInstance() {
    JsonTokenKind_initEntries();
    return JsonTokenKind_NUMBER_instance;
  }
  function JsonTokenKind_STRING_getInstance() {
    JsonTokenKind_initEntries();
    return JsonTokenKind_STRING_instance;
  }
  function JsonTokenKind_COLON_getInstance() {
    JsonTokenKind_initEntries();
    return JsonTokenKind_COLON_instance;
  }
  function JsonUtil() {
    JsonUtil_instance = this;
    var tmp = this;
    // Inline function 'kotlin.charArrayOf' call
    tmp.c2i_1 = charArrayOf([_Char___init__impl__6a9atx(34), _Char___init__impl__6a9atx(92), _Char___init__impl__6a9atx(47), _Char___init__impl__6a9atx(8), _Char___init__impl__6a9atx(12), _Char___init__impl__6a9atx(10), _Char___init__impl__6a9atx(13), _Char___init__impl__6a9atx(9)]);
    var tmp_0 = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_0.d2i_1 = ['\\"', '\\\\', '\\/', '\\b', '\\f', '\\n', '\\r', '\\t'];
    var tmp_1 = this;
    // Inline function 'kotlin.charArrayOf' call
    tmp_1.e2i_1 = charArrayOf([_Char___init__impl__6a9atx(34), _Char___init__impl__6a9atx(92), _Char___init__impl__6a9atx(47), _Char___init__impl__6a9atx(98), _Char___init__impl__6a9atx(102), _Char___init__impl__6a9atx(110), _Char___init__impl__6a9atx(114), _Char___init__impl__6a9atx(116)]);
    var table = new Int32Array(255);
    var inductionVariable = 0;
    var last = table.length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        table[i] = -1;
      }
       while (inductionVariable <= last);
    var inductionVariable_0 = 0;
    var last_0 = this.e2i_1.length - 1 | 0;
    if (inductionVariable_0 <= last_0)
      do {
        var i_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        // Inline function 'kotlin.code' call
        var this_0 = this.e2i_1[i_0];
        var tmp_2 = Char__toInt_impl_vasixd(this_0);
        // Inline function 'kotlin.code' call
        var this_1 = this.c2i_1[i_0];
        table[tmp_2] = Char__toInt_impl_vasixd(this_1);
      }
       while (inductionVariable_0 <= last_0);
    this.f2i_1 = table;
  }
  protoOf(JsonUtil).g2i = function (ch) {
    // Inline function 'kotlin.code' call
    var chValue = Char__toInt_impl_vasixd(ch);
    return chValue < 32 || chValue === 34 || chValue === 92;
  };
  protoOf(JsonUtil).h2i = function (ch) {
    return !(indexOf_0(this.e2i_1, ch) === -1);
  };
  protoOf(JsonUtil).sc = function (s) {
    var builder = StringBuilder_init_$Create$_1();
    var len = s.length;
    var inductionVariable = 0;
    if (inductionVariable < len)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var c = charCodeAt(s, i);
        var index = indexOf_0(this.c2i_1, c);
        if (!(index === -1)) {
          builder.j8(this.d2i_1[index]);
        } else if (this.g2i(c)) {
          // Inline function 'kotlin.code' call
          var tmp$ret$0 = Char__toInt_impl_vasixd(c);
          var hex = toString_3(tmp$ret$0, 16);
          builder.j8('\\u');
          var inductionVariable_0 = 4;
          var last = hex.length + 1 | 0;
          if (last <= inductionVariable_0)
            do {
              var j = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + -1 | 0;
              builder.k8(_Char___init__impl__6a9atx(48));
            }
             while (!(j === last));
          builder.j8(hex);
        } else {
          builder.k8(c);
        }
      }
       while (inductionVariable < len);
    return builder.toString();
  };
  protoOf(JsonUtil).l2i = function (s, start, end) {
    var result = null;
    var i = start;
    while (i < end) {
      var ch = charCodeAt(s, i);
      if (ch === _Char___init__impl__6a9atx(92) && i < (end - 1 | 0)) {
        if (result == null) {
          result = StringBuilder_init_$Create$_1();
          result.ec(s, start, i);
        }
        i = i + 1 | 0;
        ch = charCodeAt(s, i);
        var specialChar = -1;
        // Inline function 'kotlin.code' call
        var this_0 = ch;
        if (Char__toInt_impl_vasixd(this_0) < this.f2i_1.length) {
          // Inline function 'kotlin.code' call
          var this_1 = ch;
          var tmp$ret$1 = Char__toInt_impl_vasixd(this_1);
          specialChar = this.f2i_1[tmp$ret$1];
        }
        if (!(specialChar === -1)) {
          result.k8(numberToChar(specialChar));
        } else if (ch === _Char___init__impl__6a9atx(117)) {
          if (i >= (end - 4 | 0)) {
            throw RuntimeException_init_$Create$();
          }
          var hexNumber = substring(s, i + 1 | 0, i + 5 | 0);
          result.k8(numberToChar(toInt_0(hexNumber, 16)));
          i = i + 4 | 0;
        } else {
          throw RuntimeException_init_$Create$();
        }
      } else {
        var tmp0_safe_receiver = result;
        if (tmp0_safe_receiver == null)
          null;
        else
          tmp0_safe_receiver.k8(ch);
      }
      i = i + 1 | 0;
    }
    var tmp1_safe_receiver = result;
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.toString();
    return tmp2_elvis_lhs == null ? substring(s, start, end) : tmp2_elvis_lhs;
  };
  var JsonUtil_instance;
  function JsonUtil_getInstance() {
    if (JsonUtil_instance == null)
      new JsonUtil();
    return JsonUtil_instance;
  }
  function JsonValue() {
  }
  protoOf(JsonValue).n2a = function (indent) {
    var builder = new IndentBuilder(indent);
    this.x2h(builder);
    return builder.toString();
  };
  protoOf(JsonValue).toString = function () {
    return Json_getInstance().a2h(this);
  };
  function readCurrent($this) {
    var tmp;
    if ($this.q2i_1 < $this.p2i_1.length) {
      // Inline function 'kotlin.code' call
      var this_0 = charCodeAt($this.p2i_1, $this.q2i_1);
      tmp = Char__toInt_impl_vasixd(this_0);
    } else {
      tmp = -1;
    }
    return tmp;
  }
  function StringJsonLexer(input) {
    JsonLexer.call(this, true);
    this.p2i_1 = input;
    this.q2i_1 = 0;
    this.r2i_1 = 0;
    this.s2i_1 = 0;
    this.t2i_1 = false;
    this.q2i_1 = 0;
    this.t2i_1 = false;
    this.r2g();
  }
  protoOf(StringJsonLexer).z2h = function () {
    if (!this.t2i_1) {
      this.t2i_1 = true;
      this.s2i_1 = readCurrent(this);
    }
    return this.s2i_1;
  };
  protoOf(StringJsonLexer).s2g = function () {
    return substring(this.p2i_1, this.r2i_1, this.q2i_1);
  };
  protoOf(StringJsonLexer).q2g = function () {
    return JsonUtil_getInstance().l2i(this.p2i_1, this.r2i_1 + 1 | 0, this.q2i_1 - 1 | 0);
  };
  protoOf(StringJsonLexer).i2i = function () {
    this.r2i_1 = this.q2i_1;
  };
  protoOf(StringJsonLexer).a2i = function () {
    this.q2i_1 = this.q2i_1 + 1 | 0;
    this.t2i_1 = false;
  };
  protoOf(StringJsonLexer).b2i = function (s) {
    if (this.z2h() === -1) {
      return false;
    }
    if (startsWith_0(this.p2i_1, s, this.q2i_1)) {
      this.q2i_1 = this.q2i_1 + s.length | 0;
      this.t2i_1 = false;
      return true;
    }
    return false;
  };
  function BaseJsonReaderSupport() {
  }
  protoOf(BaseJsonReaderSupport).u2i = function (jsonValue) {
    var tmp;
    if (jsonValue instanceof JsonArray) {
      tmp = new JsonArrayReaderImpl(jsonValue);
    } else {
      if (jsonValue instanceof JsonObject) {
        tmp = new JsonObjectReaderImpl(jsonValue);
      } else {
        throw UnsupportedOperationException_init_$Create$_0('unknown json value: ' + toString_1(getKClassFromExpression(jsonValue)));
      }
    }
    return tmp;
  };
  var BaseJsonReaderSupport_instance;
  function BaseJsonReaderSupport_getInstance() {
    return BaseJsonReaderSupport_instance;
  }
  function JsonArrayReaderImpl(jsonArray) {
    this.v2i_1 = jsonArray;
    this.w2i_1 = 0;
  }
  protoOf(JsonArrayReaderImpl).x2i = function (block) {
    return block(this);
  };
  protoOf(JsonArrayReaderImpl).y2i = function () {
    var tmp;
    if (this.w2i_1 < this.v2i_1.x2g()) {
      var _unary__edvuaz = this.w2i_1;
      this.w2i_1 = _unary__edvuaz + 1 | 0;
      tmp = this.v2i_1.s2h(_unary__edvuaz);
    } else {
      tmp = null;
    }
    return tmp;
  };
  protoOf(JsonArrayReaderImpl).z2i = function () {
    var tmp;
    if (this.w2i_1 < this.v2i_1.x2g()) {
      var _unary__edvuaz = this.w2i_1;
      this.w2i_1 = _unary__edvuaz + 1 | 0;
      var nextJsonArray = this.v2i_1.r2h(_unary__edvuaz);
      tmp = new JsonArrayReaderImpl(nextJsonArray);
    } else {
      tmp = null;
    }
    return tmp;
  };
  protoOf(JsonArrayReaderImpl).a2j = function () {
    var _unary__edvuaz = this.w2i_1;
    this.w2i_1 = _unary__edvuaz + 1 | 0;
    var jsonObject = this.v2i_1.q2h(_unary__edvuaz);
    return new JsonObjectReaderImpl(jsonObject);
  };
  function JsonObjectReaderImpl(jsonObject) {
    this.b2j_1 = jsonObject;
    this.c2j_1 = this.b2j_1.r2().m();
    this.d2j_1 = null;
  }
  protoOf(JsonObjectReaderImpl).e2j = function (block) {
    return block(this);
  };
  protoOf(JsonObjectReaderImpl).f2j = function () {
    var tmp = this;
    var tmp_0;
    if (this.c2j_1.n()) {
      tmp_0 = this.c2j_1.o();
    } else {
      tmp_0 = null;
    }
    tmp.d2j_1 = tmp_0;
    return this.d2j_1;
  };
  protoOf(JsonObjectReaderImpl).g2j = function () {
    return ensureNotNull(this.b2j_1.ny(ensureNotNull(this.d2j_1)));
  };
  protoOf(JsonObjectReaderImpl).z2i = function () {
    var jsonArray = ensureNotNull(this.b2j_1.k2i(ensureNotNull(this.d2j_1)));
    return new JsonArrayReaderImpl(jsonArray);
  };
  function JsonArrayReader() {
  }
  function CommonApiJsonIterator(jsonIterator) {
    this.h2j_1 = jsonIterator;
  }
  protoOf(CommonApiJsonIterator).i2j = function () {
    return this.h2j_1.i2j();
  };
  protoOf(CommonApiJsonIterator).o2j = function () {
    return this.h2j_1.o2j();
  };
  protoOf(CommonApiJsonIterator).p2j = function () {
    return this.h2j_1.p2j();
  };
  function CommonJsonIterSupport() {
  }
  protoOf(CommonJsonIterSupport).q2j = function () {
    return new CommonJsonIteratorFactory();
  };
  var CommonJsonIterSupport_instance;
  function CommonJsonIterSupport_getInstance() {
    return CommonJsonIterSupport_instance;
  }
  function CommonJsonIteratorFactory() {
  }
  protoOf(CommonJsonIteratorFactory).r2j = function (buf) {
    var jsonIterator = Companion_instance_28.r2j(buf);
    return new CommonApiJsonIterator(jsonIterator);
  };
  protoOf(CommonJsonIteratorFactory).toString = function () {
    return 'CommonJsonIteratorFactory';
  };
  function Hex() {
    Hex_instance = this;
    var tmp = this;
    var tmp_0 = 0;
    // Inline function 'kotlin.code' call
    var this_0 = _Char___init__impl__6a9atx(102);
    var tmp_1 = Char__toInt_impl_vasixd(this_0) + 1 | 0;
    var tmp_2 = new Int32Array(tmp_1);
    while (tmp_0 < tmp_1) {
      tmp_2[tmp_0] = -1;
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp.t2k_1 = tmp_2;
    var inductionVariable = _Char___init__impl__6a9atx(48);
    if (inductionVariable <= _Char___init__impl__6a9atx(57))
      do {
        var ch = inductionVariable;
        inductionVariable = Char__plus_impl_qi7pgj(inductionVariable, 1);
        // Inline function 'kotlin.code' call
        var i = Char__toInt_impl_vasixd(ch);
        // Inline function 'kotlin.code' call
        var this_1 = _Char___init__impl__6a9atx(48);
        var tmp$ret$3 = Char__toInt_impl_vasixd(this_1);
        this.t2k_1[i] = i - tmp$ret$3 | 0;
      }
       while (inductionVariable <= _Char___init__impl__6a9atx(57));
    var inductionVariable_0 = _Char___init__impl__6a9atx(97);
    if (inductionVariable_0 <= _Char___init__impl__6a9atx(102))
      do {
        var ch_0 = inductionVariable_0;
        inductionVariable_0 = Char__plus_impl_qi7pgj(inductionVariable_0, 1);
        // Inline function 'kotlin.code' call
        var i_0 = Char__toInt_impl_vasixd(ch_0);
        // Inline function 'kotlin.code' call
        var this_2 = _Char___init__impl__6a9atx(97);
        var tmp$ret$5 = Char__toInt_impl_vasixd(this_2);
        this.t2k_1[i_0] = (i_0 - tmp$ret$5 | 0) + 10 | 0;
      }
       while (inductionVariable_0 <= _Char___init__impl__6a9atx(102));
    var inductionVariable_1 = _Char___init__impl__6a9atx(65);
    if (inductionVariable_1 <= _Char___init__impl__6a9atx(70))
      do {
        var ch_1 = inductionVariable_1;
        inductionVariable_1 = Char__plus_impl_qi7pgj(inductionVariable_1, 1);
        // Inline function 'kotlin.code' call
        var i_1 = Char__toInt_impl_vasixd(ch_1);
        // Inline function 'kotlin.code' call
        var this_3 = _Char___init__impl__6a9atx(65);
        var tmp$ret$7 = Char__toInt_impl_vasixd(this_3);
        this.t2k_1[i_1] = (i_1 - tmp$ret$7 | 0) + 10 | 0;
      }
       while (inductionVariable_1 <= _Char___init__impl__6a9atx(70));
  }
  protoOf(Hex).u2k = function (b) {
    var value = this.t2k_1[b];
    // Inline function 'kotlin.require' call
    if (!!(value === -1)) {
      var message = '' + b + ' is not valid hex digit';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    return value;
  };
  var Hex_instance;
  function Hex_getInstance() {
    if (Hex_instance == null)
      new Hex();
    return Hex_instance;
  }
  function JsonException(message) {
    RuntimeException_init_$Init$_0(message, this);
    captureStack(this, JsonException);
  }
  function nextToken($this) {
    var i = $this.k2j_1;
    loop: while (true) {
      var tmp = $this.j2j_1;
      var _unary__edvuaz = i;
      i = _unary__edvuaz + 1 | 0;
      var c = tmp[_unary__edvuaz];
      var tmp_0;
      if (c === 32 || c === 10 || (c === 13 || c === 9)) {
        continue loop;
      } else {
        $this.k2j_1 = i;
        tmp_0 = c;
      }
      return tmp_0;
    }
  }
  function unreadByte($this) {
    if ($this.k2j_1 === 0) {
      throw reportError($this, 'unreadByte', 'unread too many bytes');
    }
    $this.k2j_1 = $this.k2j_1 - 1 | 0;
  }
  function skipFixedBytes($this, n) {
    $this.k2j_1 = $this.k2j_1 + n | 0;
  }
  function reportError($this, op, msg) {
    // Inline function 'kotlin.math.max' call
    var a = $this.k2j_1 - 10 | 0;
    var peekStart = Math.max(a, 0);
    var tmp0 = $this.k2j_1;
    // Inline function 'kotlin.math.min' call
    var b = $this.l2j_1;
    var peekSize = Math.min(tmp0, b) - peekStart | 0;
    var peek = decodeToString_0($this.j2j_1, peekStart, peekSize);
    var bufString = decodeToString($this.j2j_1);
    throw new JsonException(op + ': ' + msg + ', head: ' + $this.k2j_1 + ', peek: ' + peek + ', buf: ' + bufString);
  }
  function parse($this) {
    var c;
    var i = $this.k2j_1;
    var bound = $this.n2j_1.length;
    var inductionVariable = 0;
    if (inductionVariable < bound)
      $l$loop: do {
        var j = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = $this.j2j_1;
        var _unary__edvuaz = i;
        i = _unary__edvuaz + 1 | 0;
        c = tmp[_unary__edvuaz];
        if (c === 34) {
          $this.k2j_1 = i;
          return j;
        }
        // Inline function 'kotlin.experimental.xor' call
        if (toByte(c ^ 92) < 1) {
          break $l$loop;
        }
        $this.n2j_1[j] = numberToChar(c);
      }
       while (inductionVariable < bound);
    var alreadyCopied = 0;
    if (i > $this.k2j_1) {
      alreadyCopied = (i - $this.k2j_1 | 0) - 1 | 0;
      $this.k2j_1 = i - 1 | 0;
    }
    return readStringSlowPath($this, alreadyCopied);
  }
  function readStringSlowPath($this, j) {
    var currentJ = j;
    try {
      var isExpectingLowSurrogate = false;
      var i = $this.k2j_1;
      $l$loop: while (i < $this.l2j_1) {
        var tmp = $this.j2j_1;
        var _unary__edvuaz = i;
        i = _unary__edvuaz + 1 | 0;
        var bc = tmp[_unary__edvuaz];
        if (bc === 34) {
          $this.k2j_1 = i;
          return currentJ;
        }
        if (bc === 92) {
          var tmp_0 = $this.j2j_1;
          var _unary__edvuaz_0 = i;
          i = _unary__edvuaz_0 + 1 | 0;
          bc = tmp_0[_unary__edvuaz_0];
          switch (bc) {
            case 98:
              bc = 8;
              break;
            case 116:
              bc = 9;
              break;
            case 110:
              bc = 10;
              break;
            case 102:
              bc = 12;
              break;
            case 114:
              bc = 13;
              break;
            case 34:
            case 47:
            case 92:
              break;
            case 117:
              var tmp_1 = Hex_getInstance();
              var tmp_2 = $this.j2j_1;
              var _unary__edvuaz_1 = i;
              i = _unary__edvuaz_1 + 1 | 0;
              var tmp_3 = tmp_1.u2k(tmp_2[_unary__edvuaz_1]) << 12;
              var tmp_4 = Hex_getInstance();
              var tmp_5 = $this.j2j_1;
              var _unary__edvuaz_2 = i;
              i = _unary__edvuaz_2 + 1 | 0;
              var tmp_6 = tmp_3 + (tmp_4.u2k(tmp_5[_unary__edvuaz_2]) << 8) | 0;
              var tmp_7 = Hex_getInstance();
              var tmp_8 = $this.j2j_1;
              var _unary__edvuaz_3 = i;
              i = _unary__edvuaz_3 + 1 | 0;
              var tmp_9 = tmp_6 + (tmp_7.u2k(tmp_8[_unary__edvuaz_3]) << 4) | 0;
              var tmp_10 = Hex_getInstance();
              var tmp_11 = $this.j2j_1;
              var _unary__edvuaz_4 = i;
              i = _unary__edvuaz_4 + 1 | 0;
              bc = tmp_9 + tmp_10.u2k(tmp_11[_unary__edvuaz_4]) | 0;
              var bcChar = numberToChar(bc);
              if (isHighSurrogate(bcChar)) {
                var tmp_12;
                if (isExpectingLowSurrogate) {
                  throw new JsonException('invalid surrogate');
                } else {
                  tmp_12 = true;
                }
                isExpectingLowSurrogate = tmp_12;
              } else if (isLowSurrogate(bcChar)) {
                var tmp_13;
                if (isExpectingLowSurrogate) {
                  tmp_13 = false;
                } else {
                  throw new JsonException('invalid surrogate');
                }
                isExpectingLowSurrogate = tmp_13;
              } else if (isExpectingLowSurrogate) {
                throw new JsonException('invalid surrogate');
              }

              break;
            default:
              throw reportError($this, 'readStringSlowPath', 'invalid escape character: ' + bc);
          }
        } else if (!((bc & 128) === 0)) {
          var tmp_14 = $this.j2j_1;
          var _unary__edvuaz_5 = i;
          i = _unary__edvuaz_5 + 1 | 0;
          var u2 = tmp_14[_unary__edvuaz_5];
          if ((bc & 224) === 192) {
            bc = ((bc & 31) << 6) + (u2 & 63) | 0;
          } else {
            var tmp_15 = $this.j2j_1;
            var _unary__edvuaz_6 = i;
            i = _unary__edvuaz_6 + 1 | 0;
            var u3 = tmp_15[_unary__edvuaz_6];
            if ((bc & 240) === 224) {
              bc = (((bc & 15) << 12) + ((u2 & 63) << 6) | 0) + (u3 & 63) | 0;
            } else {
              var tmp_16 = $this.j2j_1;
              var _unary__edvuaz_7 = i;
              i = _unary__edvuaz_7 + 1 | 0;
              var u4 = tmp_16[_unary__edvuaz_7];
              var tmp_17;
              if ((bc & 248) === 240) {
                tmp_17 = ((((bc & 7) << 18) + ((u2 & 63) << 12) | 0) + ((u3 & 63) << 6) | 0) + (u4 & 63) | 0;
              } else {
                throw reportError($this, 'readStringSlowPath', 'invalid unicode character');
              }
              bc = tmp_17;
              if (bc >= 65536) {
                if (bc >= 1114112) {
                  throw reportError($this, 'readStringSlowPath', 'invalid unicode character');
                }
                var sup = bc - 65536 | 0;
                if ($this.n2j_1.length === currentJ) {
                  var newBuf = charArray(imul($this.n2j_1.length, 2));
                  // Inline function 'kotlin.collections.copyInto' call
                  var this_0 = $this.n2j_1;
                  var endIndex = this_0.length;
                  // Inline function 'kotlin.js.unsafeCast' call
                  // Inline function 'kotlin.js.asDynamic' call
                  var tmp_18 = this_0;
                  // Inline function 'kotlin.js.unsafeCast' call
                  // Inline function 'kotlin.js.asDynamic' call
                  arrayCopy(tmp_18, newBuf, 0, 0, endIndex);
                  $this.n2j_1 = newBuf;
                }
                var tmp_19 = $this.n2j_1;
                var _unary__edvuaz_8 = currentJ;
                currentJ = _unary__edvuaz_8 + 1 | 0;
                tmp_19[_unary__edvuaz_8] = numberToChar((sup >>> 10 | 0) + 55296 | 0);
                if ($this.n2j_1.length === currentJ) {
                  var newBuf_0 = charArray(imul($this.n2j_1.length, 2));
                  // Inline function 'kotlin.collections.copyInto' call
                  var this_1 = $this.n2j_1;
                  var endIndex_0 = this_1.length;
                  // Inline function 'kotlin.js.unsafeCast' call
                  // Inline function 'kotlin.js.asDynamic' call
                  var tmp_20 = this_1;
                  // Inline function 'kotlin.js.unsafeCast' call
                  // Inline function 'kotlin.js.asDynamic' call
                  arrayCopy(tmp_20, newBuf_0, 0, 0, endIndex_0);
                  $this.n2j_1 = newBuf_0;
                }
                var tmp_21 = $this.n2j_1;
                var _unary__edvuaz_9 = currentJ;
                currentJ = _unary__edvuaz_9 + 1 | 0;
                tmp_21[_unary__edvuaz_9] = numberToChar((sup & 1023) + 56320 | 0);
                continue $l$loop;
              }
            }
          }
        }
        if ($this.n2j_1.length === currentJ) {
          var newBuf_1 = charArray(imul($this.n2j_1.length, 2));
          // Inline function 'kotlin.collections.copyInto' call
          var this_2 = $this.n2j_1;
          var endIndex_1 = this_2.length;
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          var tmp_22 = this_2;
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          arrayCopy(tmp_22, newBuf_1, 0, 0, endIndex_1);
          $this.n2j_1 = newBuf_1;
        }
        var tmp_23 = $this.n2j_1;
        var _unary__edvuaz_10 = currentJ;
        currentJ = _unary__edvuaz_10 + 1 | 0;
        tmp_23[_unary__edvuaz_10] = numberToChar(bc);
      }
      throw reportError($this, 'readStringSlowPath', 'incomplete string');
    } catch ($p) {
      if ($p instanceof IndexOutOfBoundsException) {
        var e = $p;
        throw reportError($this, 'readString', 'incomplete string');
      } else {
        throw $p;
      }
    }
  }
  function Companion_28() {
    this.s2j_1 = 9;
    this.t2j_1 = 10;
    this.u2j_1 = 13;
    this.v2j_1 = 32;
    this.w2j_1 = 34;
    this.x2j_1 = 44;
    this.y2j_1 = 58;
    this.z2j_1 = 92;
    this.a2k_1 = 91;
    this.b2k_1 = 93;
    this.c2k_1 = 123;
    this.d2k_1 = 125;
    this.e2k_1 = 110;
    this.f2k_1 = 34;
    this.g2k_1 = 92;
    this.h2k_1 = 47;
    this.i2k_1 = 98;
    this.j2k_1 = 116;
    this.k2k_1 = 110;
    this.l2k_1 = 102;
    this.m2k_1 = 114;
    this.n2k_1 = 117;
    this.o2k_1 = 8;
    this.p2k_1 = 9;
    this.q2k_1 = 10;
    this.r2k_1 = 12;
    this.s2k_1 = 13;
  }
  protoOf(Companion_28).r2j = function (buf) {
    return new JsonIterator(buf, 0, buf.length);
  };
  var Companion_instance_28;
  function Companion_getInstance_28() {
    return Companion_instance_28;
  }
  function JsonIterator(buf, head, tail) {
    this.j2j_1 = buf;
    this.k2j_1 = head;
    this.l2j_1 = tail;
    this.m2j_1 = HashMap_init_$Create$();
    this.n2j_1 = charArray(32);
  }
  protoOf(JsonIterator).i2j = function () {
    var c = nextToken(this);
    var tmp0_subject = c;
    var tmp;
    if (tmp0_subject === 91) {
      c = nextToken(this);
      var tmp_0;
      if (c === 93) {
        tmp_0 = false;
      } else {
        unreadByte(this);
        tmp_0 = true;
      }
      tmp = tmp_0;
    } else if (tmp0_subject === 93) {
      tmp = false;
    } else if (tmp0_subject === 44) {
      tmp = true;
    } else if (tmp0_subject === 110) {
      tmp = false;
    } else {
      throw reportError(this, 'readArray', 'expect [ or , or n or ], but found: ' + c);
    }
    return tmp;
  };
  protoOf(JsonIterator).p2j = function () {
    var c = nextToken(this);
    var tmp0_subject = c;
    var tmp;
    if (tmp0_subject === 110) {
      skipFixedBytes(this, 3);
      tmp = null;
    } else if (tmp0_subject === 123) {
      c = nextToken(this);
      var tmp1_subject = c;
      var tmp_0;
      if (tmp1_subject === 34) {
        unreadByte(this);
        var field = this.o2j();
        if (!(nextToken(this) === 58)) {
          throw reportError(this, 'readObject', 'expect :');
        }
        tmp_0 = field;
      } else if (tmp1_subject === 125) {
        tmp_0 = null;
      } else {
        throw reportError(this, 'readObject', 'expect " after {');
      }
      tmp = tmp_0;
    } else if (tmp0_subject === 44) {
      var field_0 = this.o2j();
      if (!(nextToken(this) === 58)) {
        throw reportError(this, 'readObject', 'expect :');
      }
      tmp = field_0;
    } else if (tmp0_subject === 125) {
      tmp = null;
    } else {
      throw reportError(this, 'readObject', 'expect { or , or } or n, but found: ' + c);
    }
    return tmp;
  };
  protoOf(JsonIterator).o2j = function () {
    var c = nextToken(this);
    if (!(c === 34)) {
      if (c === 110) {
        skipFixedBytes(this, 3);
        return null;
      }
      throw reportError(this, 'readString', 'expect string or null, but ' + c);
    }
    var j = parse(this);
    var string = concatToString_0(this.n2j_1, 0, 0 + j | 0);
    // Inline function 'kotlin.collections.getOrPut' call
    var this_0 = this.m2j_1;
    var value = this_0.q2(string);
    var tmp;
    if (value == null) {
      var answer = string;
      this_0.t2(string, answer);
      tmp = answer;
    } else {
      tmp = value;
    }
    return tmp;
  };
  function readArrayToken($this) {
    var hasMore = $this.v2k_1.i2j();
    if (!hasMore) {
      $this.y2k_1 = true;
    }
    return hasMore;
  }
  function createJsonIterReaderInArray($this) {
    var readFun = JsonIterArrayReader$createJsonIterReaderInArray$lambda($this);
    return readNext($this, readFun);
  }
  function readNext($this, readFun) {
    var tmp;
    if ($this.w2k_1) {
      var tmp_0;
      if ($this.x2k_1) {
        $this.x2k_1 = false;
        tmp_0 = readFun();
      } else {
        var hasMore = readArrayToken($this);
        var tmp_1;
        if (hasMore) {
          tmp_1 = readFun();
        } else {
          tmp_1 = null;
        }
        tmp_0 = tmp_1;
      }
      tmp = tmp_0;
    } else {
      tmp = null;
    }
    return tmp;
  }
  function ApiJsonIterator$readString$ref(p0) {
    var l = function () {
      return p0.o2j();
    };
    l.callableName = 'readString';
    return l;
  }
  function JsonIterArrayReader$createJsonIterReaderInArray$lambda(this$0) {
    return function () {
      return new JsonIterReader(this$0.v2k_1);
    };
  }
  function JsonIterArrayReader(jsonIterator, hasMore) {
    this.v2k_1 = jsonIterator;
    this.w2k_1 = hasMore;
    this.x2k_1 = true;
    this.y2k_1 = !this.w2k_1;
  }
  protoOf(JsonIterArrayReader).x2i = function (block) {
    throw IllegalStateException_init_$Create$();
  };
  protoOf(JsonIterArrayReader).y2i = function () {
    return readNext(this, ApiJsonIterator$readString$ref(this.v2k_1));
  };
  protoOf(JsonIterArrayReader).z2i = function () {
    return createJsonIterReaderInArray(this);
  };
  protoOf(JsonIterArrayReader).a2j = function () {
    return createJsonIterReaderInArray(this);
  };
  protoOf(JsonIterArrayReader).z2k = function () {
    if (!this.y2k_1) {
      var hasMore = readArrayToken(this);
      // Inline function 'kotlin.check' call
      if (!!hasMore) {
        throw IllegalStateException_init_$Create$_0('Check failed.');
      }
    }
  };
  function JsonIterObjectReader(jsonIterator) {
    this.a2l_1 = jsonIterator;
  }
  protoOf(JsonIterObjectReader).e2j = function (block) {
    throw IllegalStateException_init_$Create$();
  };
  protoOf(JsonIterObjectReader).f2j = function () {
    return this.a2l_1.p2j();
  };
  protoOf(JsonIterObjectReader).g2j = function () {
    return this.a2l_1.o2j();
  };
  protoOf(JsonIterObjectReader).z2i = function () {
    return new JsonIterReader(this.a2l_1);
  };
  function readArrayToken_0($this) {
    return $this.b2l_1.i2j();
  }
  function JsonIterReader(jsonIterator) {
    this.b2l_1 = jsonIterator;
  }
  protoOf(JsonIterReader).x2i = function (block) {
    var hasMoreAtStart = readArrayToken_0(this);
    var arrayReader = new JsonIterArrayReader(this.b2l_1, hasMoreAtStart);
    var result = block(arrayReader);
    arrayReader.z2k();
    return result;
  };
  protoOf(JsonIterReader).e2j = function (block) {
    var objectReader = new JsonIterObjectReader(this.b2l_1);
    return block(objectReader);
  };
  protoOf(JsonIterReader).y2i = function () {
    throw IllegalStateException_init_$Create$();
  };
  protoOf(JsonIterReader).z2i = function () {
    throw IllegalStateException_init_$Create$();
  };
  protoOf(JsonIterReader).a2j = function () {
    throw IllegalStateException_init_$Create$();
  };
  protoOf(JsonIterReader).f2j = function () {
    throw IllegalStateException_init_$Create$();
  };
  protoOf(JsonIterReader).g2j = function () {
    throw IllegalStateException_init_$Create$();
  };
  function JsonIterReaderFactory(jsonIteratorFactory) {
    this.c2l_1 = jsonIteratorFactory;
  }
  protoOf(JsonIterReaderFactory).d2l = function (jsonBytes) {
    var jsonIterator = this.c2l_1.r2j(jsonBytes);
    return new JsonIterReader(jsonIterator);
  };
  protoOf(JsonIterReaderFactory).toString = function () {
    return toString_1(this.c2l_1);
  };
  function JsonStreamIterSupport() {
  }
  protoOf(JsonStreamIterSupport).e2l = function (jsonIteratorFactory) {
    return new JsonIterReaderFactory(jsonIteratorFactory);
  };
  var JsonStreamIterSupport_instance;
  function JsonStreamIterSupport_getInstance() {
    return JsonStreamIterSupport_instance;
  }
  function CommonJsonStreamIterSupport() {
  }
  protoOf(CommonJsonStreamIterSupport).f2l = function () {
    var jsonIteratorFactory = CommonJsonIterSupport_instance.q2j();
    return JsonStreamIterSupport_instance.e2l(jsonIteratorFactory);
  };
  protoOf(CommonJsonStreamIterSupport).g2l = function (jsonString) {
    var jsonBytes = encodeToByteArray(jsonString);
    return this.h2l(jsonBytes);
  };
  protoOf(CommonJsonStreamIterSupport).h2l = function (jsonBytes) {
    var jsonReaderFactory = this.f2l();
    return jsonReaderFactory.d2l(jsonBytes);
  };
  var CommonJsonStreamIterSupport_instance;
  function CommonJsonStreamIterSupport_getInstance() {
    return CommonJsonStreamIterSupport_instance;
  }
  function CompositeDisposable(disposables) {
    this.i2l_1 = toMutableList(disposables);
  }
  protoOf(CompositeDisposable).j2l = function (disposable) {
    this.i2l_1.j(disposable);
    return this;
  };
  protoOf(CompositeDisposable).k2l = function (disposable) {
    this.j2l(disposable);
  };
  protoOf(CompositeDisposable).l2l = function (disposables) {
    var inductionVariable = 0;
    var last = disposables.length;
    while (inductionVariable < last) {
      var disposable = disposables[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      this.i2l_1.j(disposable);
    }
    return this;
  };
  protoOf(CompositeDisposable).zr = function () {
    var _iterator__ex2g4s = reversed(this.i2l_1).m();
    while (_iterator__ex2g4s.n()) {
      var disposable = _iterator__ex2g4s.o();
      disposable.zr();
    }
    this.i2l_1.k2();
  };
  function Companion_29() {
    Companion_instance_29 = this;
    this.m2l_1 = toDisposable_0([]);
  }
  var Companion_instance_29;
  function Companion_getInstance_29() {
    if (Companion_instance_29 == null)
      new Companion_29();
    return Companion_instance_29;
  }
  function Disposable() {
  }
  function toDisposable(disposableIterable) {
    // Inline function 'jetbrains.ocelot.base.disposable.toDisposable' call
    return new toDisposable$$inlined$toDisposable$1(disposableIterable);
  }
  function toDisposable_0(disposables) {
    return toDisposable(toList(disposables));
  }
  function toDisposable$$inlined$toDisposable$1($disposableIterable) {
    this.n2l_1 = $disposableIterable;
  }
  protoOf(toDisposable$$inlined$toDisposable$1).zr = function () {
    var _iterator__ex2g4s = reversed(this.n2l_1).m();
    while (_iterator__ex2g4s.n()) {
      var disposable = _iterator__ex2g4s.o();
      disposable.zr();
    }
    return Unit_instance;
  };
  function DisposableMap() {
    this.o2l_1 = HashMap_init_$Create$();
  }
  protoOf(DisposableMap).p2l = function (key, disposable) {
    var prev = this.o2l_1.t2(key, disposable);
    if (!(prev == null)) {
      prev.zr();
      ensureNotNull(this.o2l_1.u2(key)).zr();
      throw IllegalStateException_init_$Create$_0("Registration for the key '" + toString_0(key) + "' already exists.");
    }
  };
  protoOf(DisposableMap).q2l = function (key) {
    var prev = this.o2l_1.u2(key);
    var tmp;
    if (prev == null) {
      tmp = false;
    } else {
      prev.zr();
      tmp = true;
    }
    return tmp;
  };
  protoOf(DisposableMap).r2l = function () {
    return this.o2l_1.r2();
  };
  protoOf(DisposableMap).k2 = function () {
    try {
      var _iterator__ex2g4s = this.o2l_1.s2().m();
      while (_iterator__ex2g4s.n()) {
        var disposable = _iterator__ex2g4s.o();
        disposable.zr();
      }
    }finally {
      this.o2l_1.k2();
    }
  };
  function AddAtEndSafeIterationList() {
    SafeIterationList.call(this);
  }
  protoOf(AddAtEndSafeIterationList).v2l = function (item) {
    // Inline function 'kotlin.collections.plusAssign' call
    this.w2l_1.j(item);
  };
  function ListMap$keySet$1$iterator$spec$1(this$0) {
    this.g2m_1 = this$0;
  }
  protoOf(ListMap$keySet$1$iterator$spec$1).r = function (index) {
    return this.g2m_1.h2m_1[index];
  };
  function ListMap$values$1$iterator$spec$1(this$0) {
    this.i2m_1 = this$0;
  }
  protoOf(ListMap$values$1$iterator$spec$1).r = function (index) {
    return this.i2m_1.h2m_1[index + 1 | 0];
  };
  function ListMap$entrySet$1$iterator$spec$1(this$0) {
    this.j2m_1 = this$0;
  }
  protoOf(ListMap$entrySet$1$iterator$spec$1).r = function (index) {
    return new Entry_0(this.j2m_1, index);
  };
  function mapIterator($this, spec) {
    return new ListMap$mapIterator$1($this, spec);
  }
  function findByKey($this, key) {
    var i = 0;
    while (i < $this.h2m_1.length) {
      var k = $this.h2m_1[i];
      if (equals(key, k)) {
        return i;
      }
      i = i + 2 | 0;
    }
    return -1;
  }
  function removeAt($this, index) {
    if ($this.h2m_1.length === 2) {
      $this.h2m_1 = Companion_getInstance_30().k2m_1;
      return Unit_instance;
    }
    var tmp = 0;
    var tmp_0 = $this.h2m_1.length - 2 | 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_1 = Array(tmp_0);
    while (tmp < tmp_0) {
      var tmp_2 = tmp;
      var tmp_3;
      if (tmp_2 < index) {
        tmp_3 = $this.h2m_1[tmp_2];
      } else {
        tmp_3 = $this.h2m_1[tmp_2 + 2 | 0];
      }
      tmp_1[tmp_2] = tmp_3;
      tmp = tmp + 1 | 0;
    }
    var newArray = tmp_1;
    $this.h2m_1 = newArray;
  }
  function Entry_0($outer, index) {
    this.m2m_1 = $outer;
    this.l2m_1 = index;
  }
  protoOf(Entry_0).n2m = function () {
    var tmp = this.m2m_1.h2m_1[this.l2m_1];
    return (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
  };
  protoOf(Entry_0).o2m = function () {
    var tmp = this.m2m_1.h2m_1[this.l2m_1 + 1 | 0];
    return (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
  };
  function Companion_30() {
    Companion_instance_30 = this;
    var tmp = this;
    // Inline function 'kotlin.emptyArray' call
    tmp.k2m_1 = [];
  }
  var Companion_instance_30;
  function Companion_getInstance_30() {
    if (Companion_instance_30 == null)
      new Companion_30();
    return Companion_instance_30;
  }
  function ListMap$keySet$1(this$0) {
    this.p2m_1 = this$0;
    AbstractMutableSet.call(this);
  }
  protoOf(ListMap$keySet$1).p = function () {
    return this.p2m_1.x2g();
  };
  protoOf(ListMap$keySet$1).t6 = function (element) {
    throw IllegalStateException_init_$Create$_0('Not available in keySet');
  };
  protoOf(ListMap$keySet$1).j = function (element) {
    return this.t6((element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  protoOf(ListMap$keySet$1).m = function () {
    var spec = new ListMap$keySet$1$iterator$spec$1(this.p2m_1);
    return mapIterator(this.p2m_1, spec);
  };
  function ListMap$values$1(this$0) {
    this.q2m_1 = this$0;
    AbstractCollection.call(this);
  }
  protoOf(ListMap$values$1).p = function () {
    return this.q2m_1.x2g();
  };
  protoOf(ListMap$values$1).m = function () {
    var spec = new ListMap$values$1$iterator$spec$1(this.q2m_1);
    return mapIterator(this.q2m_1, spec);
  };
  function ListMap$entrySet$1(this$0) {
    this.r2m_1 = this$0;
    AbstractSet.call(this);
  }
  protoOf(ListMap$entrySet$1).p = function () {
    return this.r2m_1.x2g();
  };
  protoOf(ListMap$entrySet$1).m = function () {
    var spec = new ListMap$entrySet$1$iterator$spec$1(this.r2m_1);
    return mapIterator(this.r2m_1, spec);
  };
  function ListMap$mapIterator$1(this$0, $spec) {
    this.u2m_1 = this$0;
    this.v2m_1 = $spec;
    this.s2m_1 = 0;
    this.t2m_1 = false;
  }
  protoOf(ListMap$mapIterator$1).n = function () {
    return this.s2m_1 < this.u2m_1.h2m_1.length;
  };
  protoOf(ListMap$mapIterator$1).o = function () {
    if (!this.n()) {
      throw NoSuchElementException_init_$Create$();
    }
    this.t2m_1 = true;
    var tmp = this.v2m_1.r(this.s2m_1);
    var value = (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
    this.s2m_1 = this.s2m_1 + 2 | 0;
    return value;
  };
  protoOf(ListMap$mapIterator$1).h4 = function () {
    // Inline function 'kotlin.check' call
    if (!this.t2m_1) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    this.s2m_1 = this.s2m_1 - 2 | 0;
    removeAt(this.u2m_1, this.s2m_1);
    this.t2m_1 = false;
  };
  function ListMap() {
    Companion_getInstance_30();
    this.h2m_1 = Companion_getInstance_30().k2m_1;
  }
  protoOf(ListMap).w2m = function () {
    return this.x2g() === 0;
  };
  protoOf(ListMap).o2 = function (key) {
    return findByKey(this, key) >= 0;
  };
  protoOf(ListMap).u2 = function (key) {
    var index = findByKey(this, key);
    var tmp;
    if (index >= 0) {
      var value = this.h2m_1[index + 1 | 0];
      removeAt(this, index);
      tmp = (value == null ? true : !(value == null)) ? value : THROW_CCE();
    } else {
      tmp = null;
    }
    return tmp;
  };
  protoOf(ListMap).x2m = function () {
    return new ListMap$keySet$1(this);
  };
  protoOf(ListMap).y2m = function () {
    return new ListMap$values$1(this);
  };
  protoOf(ListMap).z2m = function () {
    return new ListMap$entrySet$1(this);
  };
  protoOf(ListMap).x2g = function () {
    return this.h2m_1.length / 2 | 0;
  };
  protoOf(ListMap).t2 = function (key, value) {
    var index = findByKey(this, key);
    if (index >= 0) {
      var oldValue = this.h2m_1[index + 1 | 0];
      this.h2m_1[index + 1 | 0] = value;
      return (oldValue == null ? true : !(oldValue == null)) ? oldValue : THROW_CCE();
    }
    var size = this.h2m_1.length;
    var tmp = 0;
    var tmp_0 = size + 2 | 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_1 = Array(tmp_0);
    while (tmp < tmp_0) {
      var tmp_2 = tmp;
      tmp_1[tmp_2] = tmp_2 < size ? this.h2m_1[tmp_2] : null;
      tmp = tmp + 1 | 0;
    }
    var newArray = tmp_1;
    newArray[size] = key;
    newArray[size + 1 | 0] = value;
    this.h2m_1 = newArray;
    return null;
  };
  protoOf(ListMap).q2 = function (key) {
    var index = findByKey(this, key);
    var tmp;
    if (index === -1) {
      tmp = null;
    } else {
      var tmp_0 = this.h2m_1[index + 1 | 0];
      tmp = (tmp_0 == null ? true : !(tmp_0 == null)) ? tmp_0 : THROW_CCE();
    }
    return tmp;
  };
  protoOf(ListMap).toString = function () {
    var builder = StringBuilder_init_$Create$_1();
    builder.j8('{');
    var i = 0;
    while (i < this.h2m_1.length) {
      var k = this.h2m_1[i];
      var v = this.h2m_1[i + 1 | 0];
      if (!(i === 0)) {
        builder.j8(',');
      }
      builder.i8(k).j8('=').i8(v);
      i = i + 2 | 0;
    }
    builder.j8('}');
    return builder.toString();
  };
  protoOf(ListMap).k2 = function () {
    this.h2m_1 = Companion_getInstance_30().k2m_1;
  };
  function _get_closeableIterable__v2oelp($this) {
    return new SafeIterationListIterable($this);
  }
  function addOp($this, op) {
    if ($this.x2l_1 == null) {
      $this.x2l_1 = ArrayList_init_$Create$_0(1);
    }
    ensureNotNull($this.x2l_1).j(op);
  }
  function itemsRemove($this, item) {
    return $this.w2l_1.h2(item);
  }
  function Op(item, isAdd) {
    this.a2n_1 = item;
    this.b2n_1 = isAdd;
  }
  function Companion_31() {
  }
  protoOf(Companion_31).c2n = function () {
    return new AddAtEndSafeIterationList();
  };
  var Companion_instance_31;
  function Companion_getInstance_31() {
    return Companion_instance_31;
  }
  function SafeIterationList() {
    this.w2l_1 = ArrayList_init_$Create$_0(1);
    this.x2l_1 = null;
    this.y2l_1 = 0;
  }
  protoOf(SafeIterationList).z2l = function () {
    return this.y2l_1 > 0;
  };
  protoOf(SafeIterationList).a2m = function (f) {
    var iterable = _get_closeableIterable__v2oelp(this);
    try {
      return f(iterable);
    }finally {
      iterable.d2n();
    }
  };
  protoOf(SafeIterationList).b2m = function (item) {
    if (this.z2l()) {
      var op = new Op(item, true);
      addOp(this, op);
    } else {
      this.v2l(item);
    }
  };
  protoOf(SafeIterationList).c2m = function (item) {
    if (this.z2l()) {
      var op = new Op(item, false);
      addOp(this, op);
    } else {
      itemsRemove(this, item);
    }
  };
  protoOf(SafeIterationList).d2m = function (item) {
    if (!(this.x2l_1 == null)) {
      var _iterator__ex2g4s = ensureNotNull(this.x2l_1).m();
      while (_iterator__ex2g4s.n()) {
        var op = _iterator__ex2g4s.o();
        if (!op.b2n_1 && op.a2n_1 === item) {
          return true;
        }
      }
    }
    return false;
  };
  protoOf(SafeIterationList).e2m = function () {
    this.y2l_1 = this.y2l_1 + 1 | 0;
  };
  protoOf(SafeIterationList).f2m = function () {
    this.y2l_1 = this.y2l_1 - 1 | 0;
    if (!this.z2l()) {
      if (!(this.x2l_1 == null)) {
        var _iterator__ex2g4s = ensureNotNull(this.x2l_1).m();
        while (_iterator__ex2g4s.n()) {
          var op = _iterator__ex2g4s.o();
          var item = op.a2n_1;
          if (op.b2n_1) {
            this.v2l(item);
          } else {
            itemsRemove(this, item);
          }
        }
        ensureNotNull(this.x2l_1).k2();
      }
    }
  };
  protoOf(SafeIterationList).x2g = function () {
    var tmp = this.w2l_1.p();
    var tmp0_safe_receiver = this.x2l_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.p();
    return tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
  };
  protoOf(SafeIterationList).k2 = function () {
    this.w2l_1.k2();
    var tmp0_safe_receiver = this.x2l_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.k2();
    }
    this.y2l_1 = 0;
  };
  function ItemIterator(iterationList) {
    this.e2n_1 = iterationList;
    this.g2n_1 = null;
    this.f2n_1 = this.e2n_1.w2l_1.m();
  }
  protoOf(ItemIterator).n = function () {
    var hasNext = false;
    $l$loop_0: while (this.f2n_1.n()) {
      var item = this.f2n_1.o();
      if (!this.e2n_1.d2m(item)) {
        hasNext = true;
        this.g2n_1 = item;
        break $l$loop_0;
      }
    }
    return hasNext;
  };
  protoOf(ItemIterator).o = function () {
    var tmp = this.g2n_1;
    return (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
  };
  function SafeIterationListIterable(iterationList) {
    this.h2n_1 = iterationList;
    this.h2n_1.e2m();
  }
  protoOf(SafeIterationListIterable).m = function () {
    return new ItemIterator(this.h2n_1);
  };
  protoOf(SafeIterationListIterable).d2n = function () {
    return this.h2n_1.f2m();
  };
  function SimpleCopyOnWriteAddAtStartList() {
    SimpleCopyOnWriteList.call(this);
  }
  protoOf(SimpleCopyOnWriteAddAtStartList).j2n = function (item) {
    // Inline function 'kotlin.apply' call
    var this_0 = ArrayList_init_$Create$_0(this.l2n().p() + 1 | 0);
    this_0.j(item);
    this_0.q(this.l2n());
    return this_0;
  };
  function checkItem($this, item) {
    // Inline function 'kotlin.check' call
    if (!!(item == null)) {
      var message = 'item is null';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    return Unit_instance;
  }
  function Companion_32() {
  }
  protoOf(Companion_32).m2n = function () {
    return new SimpleCopyOnWriteAddAtStartList();
  };
  var Companion_instance_32;
  function Companion_getInstance_32() {
    return Companion_instance_32;
  }
  function SimpleCopyOnWriteList() {
    this.k2n_1 = null;
    this.k2();
  }
  protoOf(SimpleCopyOnWriteList).l2n = function () {
    return ensureNotNull(this.k2n_1);
  };
  protoOf(SimpleCopyOnWriteList).b2m = function (item) {
    checkItem(this, item);
    this.k2n_1 = this.j2n(item);
  };
  protoOf(SimpleCopyOnWriteList).c2m = function (item) {
    checkItem(this, item);
    var items = ensureNotNull(this.k2n_1);
    var index = items.w(item);
    if (index >= 0) {
      // Inline function 'kotlin.apply' call
      var this_0 = ArrayList_init_$Create$_0(items.p() - 1 | 0);
      this_0.q(items.g2(0, index));
      this_0.q(subListTail(items, index + 1 | 0));
      var newItems = this_0;
      this.k2n_1 = newItems;
    }
  };
  protoOf(SimpleCopyOnWriteList).m = function () {
    return ensureNotNull(this.k2n_1).m();
  };
  protoOf(SimpleCopyOnWriteList).k2 = function () {
    this.k2n_1 = ArrayList_init_$Create$_0(0);
  };
  function newTreeMap(comparator) {
    return new NaiveTreeMap(comparator);
  }
  function newTreeSet(comparator) {
    return new NaiveTreeSet(comparator);
  }
  function NaiveTreeMap$TailMapView$iterator$1($delegate, this$0) {
    this.n2n_1 = $delegate;
    this.o2n_1 = this$0;
  }
  protoOf(NaiveTreeMap$TailMapView$iterator$1).n = function () {
    return this.n2n_1.n();
  };
  protoOf(NaiveTreeMap$TailMapView$iterator$1).o = function () {
    var key = this.n2n_1.o();
    return new Entry_1(this.o2n_1, key, getValue_0(this.o2n_1.v2n_1, key));
  };
  protoOf(NaiveTreeMap$TailMapView$iterator$1).h4 = function () {
    this.n2n_1.h4();
  };
  function Entry_1($outer, key, value) {
    this.z2n_1 = $outer;
    this.x2n_1 = key;
    this.y2n_1 = value;
  }
  protoOf(Entry_1).z = function () {
    return this.x2n_1;
  };
  protoOf(Entry_1).a1 = function () {
    return this.y2n_1;
  };
  function ceilingIndex($this, key) {
    var index = binarySearch($this.u2n_1, key, $this.t2n_1);
    if (index < 0) {
      return ~index;
    }
    return index;
  }
  function TailMapView($outer) {
    this.a2o_1 = $outer;
    AbstractMutableSet.call(this);
  }
  protoOf(TailMapView).c2o = function () {
    var tmp0_safe_receiver = this.b2o();
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp = ceilingIndex(this.a2o_1, tmp0_safe_receiver);
    }
    var tmp1_elvis_lhs = tmp;
    return tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
  };
  protoOf(TailMapView).p = function () {
    return this.a2o_1.u2n_1.p() - this.c2o() | 0;
  };
  protoOf(TailMapView).d2o = function (element) {
    return !(this.a2o_1.t2(element.z(), element.a1()) == null);
  };
  protoOf(TailMapView).j = function (element) {
    return this.d2o((!(element == null) ? isInterface(element, MutableEntry) : false) ? element : THROW_CCE());
  };
  protoOf(TailMapView).e2o = function (element) {
    var tmp;
    var tmp_0;
    var tmp0 = this.a2o_1.v2n_1;
    // Inline function 'kotlin.collections.contains' call
    // Inline function 'kotlin.collections.containsKey' call
    var key = element.z();
    if ((isInterface(tmp0, KtMap) ? tmp0 : THROW_CCE()).o2(key)) {
      var tmp0_safe_receiver = this.b2o();
      var tmp_1;
      if (tmp0_safe_receiver == null) {
        tmp_1 = null;
      } else {
        // Inline function 'kotlin.let' call
        tmp_1 = this.a2o_1.t2n_1.compare(element.z(), tmp0_safe_receiver) >= 0;
      }
      tmp_0 = tmp_1 === true;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = equals(this.a2o_1.v2n_1.q2(element.z()), element.a1());
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(TailMapView).t = function (element) {
    if (!(!(element == null) ? isInterface(element, MutableEntry) : false))
      return false;
    return this.e2o((!(element == null) ? isInterface(element, MutableEntry) : false) ? element : THROW_CCE());
  };
  protoOf(TailMapView).m = function () {
    var delegate = this.a2o_1.u2n_1.u(this.c2o());
    return new NaiveTreeMap$TailMapView$iterator$1(delegate, this.a2o_1);
  };
  function NaiveTreeMap$entries$1(this$0) {
    TailMapView.call(this, this$0);
  }
  protoOf(NaiveTreeMap$entries$1).b2o = function () {
    return null;
  };
  function NaiveTreeMap$tailMap0$entrySet$1($ceilingKey, this$0) {
    TailMapView.call(this, this$0);
    this.h2o_1 = $ceilingKey;
  }
  protoOf(NaiveTreeMap$tailMap0$entrySet$1).b2o = function () {
    return this.h2o_1;
  };
  function NaiveTreeMap$tailMap0$1($entrySet, this$0, $ceilingKey) {
    this.m2o_1 = $entrySet;
    this.n2o_1 = this$0;
    this.o2o_1 = $ceilingKey;
    AbstractMutableMap.call(this);
  }
  protoOf(NaiveTreeMap$tailMap0$1).y = function () {
    return this.m2o_1;
  };
  protoOf(NaiveTreeMap$tailMap0$1).t2 = function (key, value) {
    if (this.n2o_1.t2n_1.compare(key, this.o2o_1) < 0) {
      return null;
    }
    return this.n2o_1.t2(key, value);
  };
  protoOf(NaiveTreeMap$tailMap0$1).o2 = function (key) {
    return this.n2o_1.o2(key) && this.n2o_1.t2n_1.compare(this.o2o_1, key) <= 0;
  };
  protoOf(NaiveTreeMap$tailMap0$1).q2 = function (key) {
    var tmp;
    if (this.n2o_1.t2n_1.compare(this.o2o_1, key) <= 0) {
      tmp = this.n2o_1.q2(key);
    } else {
      tmp = null;
    }
    return tmp;
  };
  function NaiveTreeMap(comparator) {
    AbstractMutableMap.call(this);
    this.t2n_1 = comparator;
    this.u2n_1 = ArrayList_init_$Create$();
    this.v2n_1 = HashMap_init_$Create$();
    var tmp = this;
    tmp.w2n_1 = new NaiveTreeMap$entries$1(this);
  }
  protoOf(NaiveTreeMap).y = function () {
    return this.w2n_1;
  };
  protoOf(NaiveTreeMap).q2 = function (key) {
    return this.v2n_1.q2(key);
  };
  protoOf(NaiveTreeMap).t2 = function (key, value) {
    var index = binarySearch(this.u2n_1, key, this.t2n_1);
    if (index < 0) {
      this.u2n_1.m2(~index, key);
    } else {
      this.u2n_1.l2(index, key);
    }
    return this.v2n_1.t2(key, value);
  };
  protoOf(NaiveTreeMap).u2 = function (key) {
    var index = binarySearch(this.u2n_1, key, this.t2n_1);
    if (index >= 0) {
      this.u2n_1.n2(index);
    }
    return this.v2n_1.u2(key);
  };
  protoOf(NaiveTreeMap).o2 = function (key) {
    return this.v2n_1.o2(key);
  };
  protoOf(NaiveTreeMap).p2 = function (value) {
    return this.v2n_1.p2(value);
  };
  protoOf(NaiveTreeMap).p2o = function (key) {
    var ceilingKey = key;
    var entrySet = new NaiveTreeMap$tailMap0$entrySet$1(ceilingKey, this);
    return new NaiveTreeMap$tailMap0$1(entrySet, this, ceilingKey);
  };
  function Present() {
  }
  var Present_instance;
  function Present_getInstance() {
    return Present_instance;
  }
  function NaiveTreeSet(comparator) {
    AbstractMutableSet.call(this);
    this.q2o_1 = new NaiveTreeMap(comparator);
  }
  protoOf(NaiveTreeSet).p = function () {
    return this.q2o_1.p();
  };
  protoOf(NaiveTreeSet).j = function (element) {
    return this.q2o_1.t2(element, Present_instance) == null;
  };
  protoOf(NaiveTreeSet).h2 = function (element) {
    return equals(this.q2o_1.u2(element), Present_instance);
  };
  protoOf(NaiveTreeSet).m = function () {
    return this.q2o_1.r2().m();
  };
  function Lock() {
  }
  function emptyThreadSafeChecker() {
    return new emptyThreadSafeChecker$1();
  }
  function emptyThreadSafeChecker$1() {
  }
  protoOf(emptyThreadSafeChecker$1).u2o = function () {
  };
  function newAtomicLong(initialValue) {
    return new AtomicLongJs(initialValue);
  }
  function newAtomicBoolean(value) {
    return new AtomicBooleanJs(value);
  }
  function AtomicLongJs(value) {
    this.v2o_1 = value;
  }
  protoOf(AtomicLongJs).w2o = function () {
    var _unary__edvuaz = this.v2o_1;
    this.v2o_1 = add_2(_unary__edvuaz, get_ONE());
    return this.v2o_1;
  };
  function AtomicBooleanJs(value) {
    this.x2o_1 = value;
  }
  protoOf(AtomicBooleanJs).y2o = function (expect, update) {
    var tmp;
    if (this.x2o_1 === expect) {
      this.x2o_1 = update;
      tmp = true;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(AtomicBooleanJs).z2o = function (newValue) {
    this.x2o_1 = newValue;
  };
  function newConcurrentHashMap() {
    return HashMap_init_$Create$();
  }
  function newConcurrentHashSet() {
    return HashSet_init_$Create$();
  }
  function newLock() {
    return new newLock$1();
  }
  function newLock$1() {
  }
  protoOf(newLock$1).r2o = function () {
  };
  protoOf(newLock$1).s2o = function () {
  };
  function newSimpleThreadLocal(initialValueSupplier) {
    return new SimpleThreadLocalJs(initialValueSupplier);
  }
  function SimpleThreadLocalJs(initialValueSupplier) {
    this.a2p_1 = initialValueSupplier();
  }
  protoOf(SimpleThreadLocalJs).uv = function () {
    return this.a2p_1;
  };
  function newThreadSafeChecker() {
    return emptyThreadSafeChecker();
  }
  function FormattingAppender() {
  }
  protoOf(FormattingAppender).c2p = function (loggingEvent) {
    // Inline function 'kotlin.let' call
    var it = KotlinLoggingConfiguration_getInstance().e2p_1.g2p().h2p(loggingEvent);
    this.b2p(loggingEvent, it);
  };
  function DirectLoggerFactory() {
  }
  protoOf(DirectLoggerFactory).i2p = function (name) {
    return new KLoggerDirect(name);
  };
  var DirectLoggerFactory_instance;
  function DirectLoggerFactory_getInstance() {
    return DirectLoggerFactory_instance;
  }
  function prefix($this, level, loggerName) {
    var tmp;
    if ($this.j2p_1) {
      tmp = level.w2_1 + ': [' + loggerName + '] ';
    } else {
      tmp = '';
    }
    return tmp;
  }
  function throwableToString($this, _this__u8e3s4) {
    return createThrowableMsg($this, '', _this__u8e3s4);
  }
  function createThrowableMsg($this, msg, throwable) {
    var $this_0 = $this;
    var msg_0 = msg;
    var throwable_0 = throwable;
    $l$1: do {
      $l$0: do {
        var tmp;
        if (throwable_0 == null || equals(throwable_0.cause, throwable_0)) {
          tmp = msg_0;
        } else {
          var tmp0 = $this_0;
          var tmp1 = msg_0 + ", Caused by: '" + throwable_0.message + "'";
          var tmp2 = throwable_0.cause;
          $this_0 = tmp0;
          msg_0 = tmp1;
          throwable_0 = tmp2;
          continue $l$0;
        }
        return tmp;
      }
       while (false);
    }
     while (true);
  }
  function DefaultMessageFormatter(includePrefix) {
    includePrefix = includePrefix === VOID ? true : includePrefix;
    this.j2p_1 = includePrefix;
  }
  protoOf(DefaultMessageFormatter).h2p = function (loggingEvent) {
    // Inline function 'kotlin.with' call
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder_init_$Create$_1();
    this_0.j8(prefix(this, loggingEvent.k2p_1, loggingEvent.m2p_1));
    var tmp0_safe_receiver = loggingEvent.l2p_1;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.r2p();
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      this_0.j8(tmp1_safe_receiver);
      this_0.j8(' ');
    }
    this_0.j8(loggingEvent.n2p_1);
    this_0.j8(throwableToString(this, loggingEvent.o2p_1));
    return this_0.toString();
  };
  function KLogger$debug$lambda($message, $throwable) {
    return function ($this$at) {
      $this$at.s2p_1 = toStringSafe($message);
      $this$at.t2p_1 = $throwable;
      return Unit_instance;
    };
  }
  function KLogger$info$lambda($message, $throwable) {
    return function ($this$at) {
      $this$at.s2p_1 = toStringSafe($message);
      $this$at.t2p_1 = $throwable;
      return Unit_instance;
    };
  }
  function KLogger$warn$lambda($message, $throwable) {
    return function ($this$at) {
      $this$at.s2p_1 = toStringSafe($message);
      $this$at.t2p_1 = $throwable;
      return Unit_instance;
    };
  }
  function KLogger$error$lambda($message, $throwable) {
    return function ($this$at) {
      $this$at.s2p_1 = toStringSafe($message);
      $this$at.t2p_1 = $throwable;
      return Unit_instance;
    };
  }
  function KLogger() {
  }
  function KLoggingEvent_init_$Init$(level, marker, loggerName, eventBuilder, $this) {
    KLoggingEvent.call($this, level, marker, loggerName, eventBuilder.s2p_1, eventBuilder.t2p_1, eventBuilder.u2p_1);
    return $this;
  }
  function KLoggingEvent_init_$Create$(level, marker, loggerName, eventBuilder) {
    return KLoggingEvent_init_$Init$(level, marker, loggerName, eventBuilder, objectCreate(protoOf(KLoggingEvent)));
  }
  function KLoggingEvent(level, marker, loggerName, message, cause, payload, timestamp) {
    message = message === VOID ? null : message;
    cause = cause === VOID ? null : cause;
    payload = payload === VOID ? null : payload;
    timestamp = timestamp === VOID ? getCurrentTime() : timestamp;
    this.k2p_1 = level;
    this.l2p_1 = marker;
    this.m2p_1 = loggerName;
    this.n2p_1 = message;
    this.o2p_1 = cause;
    this.p2p_1 = payload;
    this.q2p_1 = timestamp;
  }
  protoOf(KLoggingEvent).toString = function () {
    return 'KLoggingEvent(level=' + this.k2p_1.toString() + ', marker=' + toString_0(this.l2p_1) + ', loggerName=' + this.m2p_1 + ', message=' + this.n2p_1 + ', cause=' + toString_0(this.o2p_1) + ', payload=' + toString_0(this.p2p_1) + ', timestamp=' + this.q2p_1.toString() + ')';
  };
  protoOf(KLoggingEvent).hashCode = function () {
    var result = this.k2p_1.hashCode();
    result = imul(result, 31) + (this.l2p_1 == null ? 0 : hashCode(this.l2p_1)) | 0;
    result = imul(result, 31) + getStringHashCode(this.m2p_1) | 0;
    result = imul(result, 31) + (this.n2p_1 == null ? 0 : getStringHashCode(this.n2p_1)) | 0;
    result = imul(result, 31) + (this.o2p_1 == null ? 0 : hashCode(this.o2p_1)) | 0;
    result = imul(result, 31) + (this.p2p_1 == null ? 0 : hashCode(this.p2p_1)) | 0;
    result = imul(result, 31) + getBigIntHashCode(this.q2p_1) | 0;
    return result;
  };
  protoOf(KLoggingEvent).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof KLoggingEvent))
      return false;
    var tmp0_other_with_cast = other instanceof KLoggingEvent ? other : THROW_CCE();
    if (!this.k2p_1.equals(tmp0_other_with_cast.k2p_1))
      return false;
    if (!equals(this.l2p_1, tmp0_other_with_cast.l2p_1))
      return false;
    if (!(this.m2p_1 === tmp0_other_with_cast.m2p_1))
      return false;
    if (!(this.n2p_1 == tmp0_other_with_cast.n2p_1))
      return false;
    if (!equals(this.o2p_1, tmp0_other_with_cast.o2p_1))
      return false;
    if (!equals(this.p2p_1, tmp0_other_with_cast.p2p_1))
      return false;
    if (!(this.q2p_1 === tmp0_other_with_cast.q2p_1))
      return false;
    return true;
  };
  function KLoggingEventBuilder() {
    this.s2p_1 = null;
    this.t2p_1 = null;
    this.u2p_1 = null;
    this.v2p_1 = null;
    this.w2p_1 = null;
  }
  function KotlinLogging() {
    KotlinLogging_instance = this;
    var factory = KotlinLoggingConfiguration_getInstance().f2p_1;
    if (KotlinLoggingConfiguration_getInstance().d2p_1) {
      println('kotlin-logging: initializing... active logger factory: ' + getKClassFromExpression(factory).ra());
    }
  }
  protoOf(KotlinLogging).i2q = function (func) {
    return this.i2p(KLoggerNameResolver_instance.j2q(func));
  };
  protoOf(KotlinLogging).i2p = function (name) {
    return KotlinLoggingConfiguration_getInstance().f2p_1.i2p(name);
  };
  var KotlinLogging_instance;
  function KotlinLogging_getInstance() {
    if (KotlinLogging_instance == null)
      new KotlinLogging();
    return KotlinLogging_instance;
  }
  var Level_TRACE_instance;
  var Level_DEBUG_instance;
  var Level_INFO_instance;
  var Level_WARN_instance;
  var Level_ERROR_instance;
  var Level_OFF_instance;
  var Level_entriesInitialized;
  function Level_initEntries() {
    if (Level_entriesInitialized)
      return Unit_instance;
    Level_entriesInitialized = true;
    Level_TRACE_instance = new Level('TRACE', 0, 0, 'TRACE');
    Level_DEBUG_instance = new Level('DEBUG', 1, 10, 'DEBUG');
    Level_INFO_instance = new Level('INFO', 2, 20, 'INFO');
    Level_WARN_instance = new Level('WARN', 3, 30, 'WARN');
    Level_ERROR_instance = new Level('ERROR', 4, 40, 'ERROR');
    Level_OFF_instance = new Level('OFF', 5, 50, 'OFF');
  }
  function Level(name, ordinal, levelInt, levelStr) {
    Enum.call(this, name, ordinal);
    this.m2q_1 = levelInt;
    this.n2q_1 = levelStr;
  }
  protoOf(Level).o2q = function () {
    return this.a3(KotlinLoggingConfiguration_getInstance().e2p_1.p2q()) >= 0;
  };
  protoOf(Level).toString = function () {
    return this.n2q_1;
  };
  function Level_DEBUG_getInstance() {
    Level_initEntries();
    return Level_DEBUG_instance;
  }
  function Level_INFO_getInstance() {
    Level_initEntries();
    return Level_INFO_instance;
  }
  function Level_WARN_getInstance() {
    Level_initEntries();
    return Level_WARN_instance;
  }
  function Level_ERROR_getInstance() {
    Level_initEntries();
    return Level_ERROR_instance;
  }
  function KLoggerDirect(name) {
    this.q2q_1 = name;
  }
  protoOf(KLoggerDirect).z2p = function (level, marker, block) {
    if (this.s2q(level, marker)) {
      // Inline function 'kotlin.apply' call
      var this_0 = new KLoggingEventBuilder();
      block(this_0);
      // Inline function 'kotlin.run' call
      if (level.x2_1 !== 5) {
        KotlinLoggingConfiguration_getInstance().e2p_1.r2q().c2p(KLoggingEvent_init_$Create$(level, marker, this.q2q_1, this_0));
      }
    }
  };
  protoOf(KLoggerDirect).s2q = function (level, marker) {
    return level.o2q();
  };
  function toStringSafe(_this__u8e3s4) {
    var tmp;
    try {
      tmp = toString_0(_this__u8e3s4());
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Exception) {
        var e = $p;
        tmp_0 = DefaultErrorMessageProducer_instance.t2q(e);
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  function DefaultErrorMessageProducer() {
  }
  protoOf(DefaultErrorMessageProducer).t2q = function (e) {
    return 'Log message invocation failed: ' + e.toString();
  };
  var DefaultErrorMessageProducer_instance;
  function DefaultErrorMessageProducer_getInstance() {
    return DefaultErrorMessageProducer_instance;
  }
  function ConsoleOutputAppender() {
    FormattingAppender.call(this);
  }
  protoOf(ConsoleOutputAppender).b2p = function (loggingEvent, formattedMessage) {
    switch (loggingEvent.k2p_1.x2_1) {
      case 0:
        console.log(formattedMessage);
        break;
      case 1:
        console.log(formattedMessage);
        break;
      case 2:
        console.info(formattedMessage);
        break;
      case 3:
        console.warn(formattedMessage);
        break;
      case 4:
        console.error(formattedMessage);
        break;
      case 5:
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
  };
  function KotlinLoggingConfiguration$direct$1() {
    this.u2q_1 = Level_INFO_getInstance();
    this.v2q_1 = new DefaultMessageFormatter(true);
    this.w2q_1 = new ConsoleOutputAppender();
  }
  protoOf(KotlinLoggingConfiguration$direct$1).p2q = function () {
    return this.u2q_1;
  };
  protoOf(KotlinLoggingConfiguration$direct$1).g2p = function () {
    return this.v2q_1;
  };
  protoOf(KotlinLoggingConfiguration$direct$1).r2q = function () {
    return this.w2q_1;
  };
  function KotlinLoggingConfiguration() {
    KotlinLoggingConfiguration_instance = this;
    this.d2p_1 = true;
    var tmp = this;
    tmp.e2p_1 = new KotlinLoggingConfiguration$direct$1();
    this.f2p_1 = DirectLoggerFactory_instance;
  }
  var KotlinLoggingConfiguration_instance;
  function KotlinLoggingConfiguration_getInstance() {
    if (KotlinLoggingConfiguration_instance == null)
      new KotlinLoggingConfiguration();
    return KotlinLoggingConfiguration_instance;
  }
  function KLoggerNameResolver() {
  }
  protoOf(KLoggerNameResolver).j2q = function (func) {
    var found = false;
    var exception = Exception_init_$Create$();
    var _iterator__ex2g4s = split_0(stackTraceToString(exception), ['\n']).m();
    while (_iterator__ex2g4s.n()) {
      var line = _iterator__ex2g4s.o();
      if (found) {
        return substringAfterLast(substringAfterLast(substringBefore(line, '.kt'), '.'), '/');
      }
      if (contains_8(line, 'at KotlinLogging')) {
        found = true;
      }
    }
    return '';
  };
  var KLoggerNameResolver_instance;
  function KLoggerNameResolver_getInstance() {
    return KLoggerNameResolver_instance;
  }
  function getCurrentTime() {
    return numberToLong(Date.now());
  }
  function isInUnitTests(_this__u8e3s4) {
    return false;
  }
  function currentTimeMillis() {
    return numberToLong((new Date()).getTime());
  }
  function sam$jetbrains_ocelot_base_disposable_Disposable$0(function_0) {
    this.x2q_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0).zr = function () {
    return this.x2q_1();
  };
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0).f3 = function () {
    return this.x2q_1;
  };
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Disposable) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0).hashCode = function () {
    return hashCode(this.f3());
  };
  function ThrowableHandler$MyEventSource$addHandler$lambda(this$0, $handler) {
    return function () {
      this$0.y2q_1.h2($handler);
      return Unit_instance;
    };
  }
  function getError($this, throwable) {
    var tmp;
    if (throwable instanceof Error_0) {
      tmp = throwable;
    } else {
      tmp = null;
    }
    var error = tmp;
    if (error == null) {
      var cause = throwable.cause;
      if (!(cause == null)) {
        error = getError($this, cause);
      }
    }
    return error;
  }
  function ThrowableHandler$Companion$LOG$lambda() {
    return Unit_instance;
  }
  function isInUnitTests_0($this, throwable) {
    return $this.z2q_1.uv() ? false : isInUnitTests(throwable);
  }
  function MyEventSource() {
    this.y2q_1 = ArrayList_init_$Create$();
  }
  protoOf(MyEventSource).d2r = function (throwable) {
    var _iterator__ex2g4s = ArrayList_init_$Create$_1(this.y2q_1).m();
    while (_iterator__ex2g4s.n()) {
      var handler = _iterator__ex2g4s.o();
      handler(throwable);
    }
  };
  protoOf(MyEventSource).e2r = function (handler) {
    this.y2q_1.j(handler);
    var tmp = ThrowableHandler$MyEventSource$addHandler$lambda(this, handler);
    return new sam$jetbrains_ocelot_base_disposable_Disposable$0(tmp);
  };
  function Companion_33() {
    Companion_instance_33 = this;
    var tmp = this;
    var tmp_0 = KotlinLogging_getInstance();
    tmp.f2r_1 = tmp_0.i2q(ThrowableHandler$Companion$LOG$lambda);
    this.g2r_1 = true;
  }
  protoOf(Companion_33).h2r = function (t) {
    var error = getError(this, t);
    if (!(error == null)) {
      throw error;
    }
  };
  var Companion_instance_33;
  function Companion_getInstance_33() {
    if (Companion_instance_33 == null)
      new Companion_33();
    return Companion_instance_33;
  }
  function sam$jetbrains_ocelot_base_disposable_Disposable$0_0(function_0) {
    this.i2r_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0_0).zr = function () {
    return this.i2r_1();
  };
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0_0).f3 = function () {
    return this.i2r_1;
  };
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0_0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Disposable) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0_0).hashCode = function () {
    return hashCode(this.f3());
  };
  function ThrowableHandler$forceProduction$lambda() {
    return false;
  }
  function ThrowableHandler$MyEventSource$_init_$ref_j6mxqu() {
    var l = function () {
      return new MyEventSource();
    };
    l.callableName = '<init>';
    return l;
  }
  function ThrowableHandler$handle$lambda() {
    return 'Exception handled at ThrowableHandler';
  }
  function ThrowableHandler$addHandler$lambda(this$0, $leakStacktrace) {
    return function () {
      return this$0.b2r_1.j($leakStacktrace);
    };
  }
  function ThrowableHandler$addHandler$lambda$lambda(this$0, $leakStacktrace) {
    return function () {
      this$0.b2r_1.h2($leakStacktrace);
      return Unit_instance;
    };
  }
  function ThrowableHandler$addHandler$lambda_0(this$0, $leakStacktrace) {
    return function () {
      this$0.c2r_1.t2o(ThrowableHandler$addHandler$lambda$lambda(this$0, $leakStacktrace));
      return Unit_instance;
    };
  }
  function ThrowableHandler$addHandler$lambda_1($handlerReg, $leakDisposable) {
    return function () {
      $handlerReg.zr();
      var tmp0_safe_receiver = $leakDisposable._v;
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.zr();
      }
      return Unit_instance;
    };
  }
  function ThrowableHandler() {
    Companion_getInstance_33();
    var tmp = this;
    tmp.z2q_1 = newSimpleThreadLocal(ThrowableHandler$forceProduction$lambda);
    var tmp_0 = this;
    tmp_0.a2r_1 = newSimpleThreadLocal(ThrowableHandler$MyEventSource$_init_$ref_j6mxqu());
    this.b2r_1 = LinkedHashSet_init_$Create$();
    this.c2r_1 = newLock();
  }
  protoOf(ThrowableHandler).j2r = function (throwable) {
    if (isInUnitTests_0(this, throwable)) {
      if (throwable instanceof RuntimeException)
        throw throwable;
      throw RuntimeException_init_$Create$_2(throwable);
    }
    if (!this.z2q_1.uv()) {
      var tmp = Companion_getInstance_33().f2r_1;
      tmp.h2q(throwable, ThrowableHandler$handle$lambda);
    }
    Companion_getInstance_33().h2r(throwable);
    this.a2r_1.uv().d2r(throwable);
  };
  protoOf(ThrowableHandler).e2r = function (handler) {
    var handlerReg = this.a2r_1.uv().e2r(handler);
    var leakDisposable = {_v: null};
    var leakStacktrace = RuntimeException_init_$Create$_0('Potential leak');
    this.c2r_1.t2o(ThrowableHandler$addHandler$lambda(this, leakStacktrace));
    var tmp = ThrowableHandler$addHandler$lambda_0(this, leakStacktrace);
    leakDisposable._v = new sam$jetbrains_ocelot_base_disposable_Disposable$0_0(tmp);
    var tmp_0 = ThrowableHandler$addHandler$lambda_1(handlerReg, leakDisposable);
    return new sam$jetbrains_ocelot_base_disposable_Disposable$0_0(tmp_0);
  };
  function ThrowableHandlers() {
    ThrowableHandlers_instance = this;
    this.k2r_1 = new ThrowableHandler();
    this.l2r_1 = this.k2r_1;
  }
  var ThrowableHandlers_instance;
  function ThrowableHandlers_getInstance() {
    if (ThrowableHandlers_instance == null)
      new ThrowableHandlers();
    return ThrowableHandlers_instance;
  }
  function CollectionAdapter() {
  }
  protoOf(CollectionAdapter).m2r = function (event) {
  };
  protoOf(CollectionAdapter).n2r = function (event) {
    var index = event.q2r_1;
    var removeEvent = new CollectionItemEvent(event.s2r(), null, index, EventType_REMOVE_getInstance());
    this.t2r(removeEvent);
    var addEvent = new CollectionItemEvent(null, event.u2r(), index, EventType_ADD_getInstance());
    this.m2r(addEvent);
  };
  protoOf(CollectionAdapter).t2r = function (event) {
  };
  function CollectionIndexOutOfBoundsException_init_$Init$($this) {
    RuntimeException_init_$Init$($this);
    CollectionIndexOutOfBoundsException.call($this);
    return $this;
  }
  function CollectionIndexOutOfBoundsException_init_$Create$() {
    var tmp = CollectionIndexOutOfBoundsException_init_$Init$(objectCreate(protoOf(CollectionIndexOutOfBoundsException)));
    captureStack(tmp, CollectionIndexOutOfBoundsException_init_$Create$);
    return tmp;
  }
  function CollectionIndexOutOfBoundsException_init_$Init$_0(index, $this) {
    RuntimeException_init_$Init$_0(index.toString(), $this);
    CollectionIndexOutOfBoundsException.call($this);
    return $this;
  }
  function CollectionIndexOutOfBoundsException_init_$Create$_0(index) {
    var tmp = CollectionIndexOutOfBoundsException_init_$Init$_0(index, objectCreate(protoOf(CollectionIndexOutOfBoundsException)));
    captureStack(tmp, CollectionIndexOutOfBoundsException_init_$Create$_0);
    return tmp;
  }
  function CollectionIndexOutOfBoundsException_init_$Init$_1(message, $this) {
    RuntimeException_init_$Init$_0(message, $this);
    CollectionIndexOutOfBoundsException.call($this);
    return $this;
  }
  function CollectionIndexOutOfBoundsException_init_$Create$_1(message) {
    var tmp = CollectionIndexOutOfBoundsException_init_$Init$_1(message, objectCreate(protoOf(CollectionIndexOutOfBoundsException)));
    captureStack(tmp, CollectionIndexOutOfBoundsException_init_$Create$_1);
    return tmp;
  }
  function CollectionIndexOutOfBoundsException() {
    captureStack(this, CollectionIndexOutOfBoundsException);
  }
  var EventType_ADD_instance;
  var EventType_SET_instance;
  var EventType_REMOVE_instance;
  var EventType_entriesInitialized;
  function EventType_initEntries() {
    if (EventType_entriesInitialized)
      return Unit_instance;
    EventType_entriesInitialized = true;
    EventType_ADD_instance = new EventType('ADD', 0);
    EventType_SET_instance = new EventType('SET', 1);
    EventType_REMOVE_instance = new EventType('REMOVE', 2);
  }
  function EventType(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function EventType_ADD_getInstance() {
    EventType_initEntries();
    return EventType_ADD_instance;
  }
  function EventType_SET_getInstance() {
    EventType_initEntries();
    return EventType_SET_instance;
  }
  function EventType_REMOVE_getInstance() {
    EventType_initEntries();
    return EventType_REMOVE_instance;
  }
  function CollectionItemEvent(_oldItem, _newItem, index, type) {
    this.o2r_1 = _oldItem;
    this.p2r_1 = _newItem;
    this.q2r_1 = index;
    this.r2r_1 = type;
    // Inline function 'kotlin.check' call
    if (!((!this.r2r_1.equals(EventType_ADD_getInstance()) || this.o2r_1 == null) && (!this.r2r_1.equals(EventType_REMOVE_getInstance()) || this.p2r_1 == null))) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
  }
  protoOf(CollectionItemEvent).s2r = function () {
    if (this.r2r_1.equals(EventType_ADD_getInstance())) {
      throw UnsupportedOperationException_init_$Create$_0("There's no oldItem on add event");
    }
    return ensureNotNull(this.o2r_1);
  };
  protoOf(CollectionItemEvent).u2r = function () {
    if (this.r2r_1.equals(EventType_REMOVE_getInstance())) {
      throw UnsupportedOperationException_init_$Create$_0("There's no newItem on remove event");
    }
    return ensureNotNull(this.p2r_1);
  };
  protoOf(CollectionItemEvent).v2r = function (listener) {
    var tmp;
    switch (this.r2r_1.x2_1) {
      case 0:
        listener.m2r(this);
        tmp = Unit_instance;
        break;
      case 1:
        listener.n2r(this);
        tmp = Unit_instance;
        break;
      default:
        listener.t2r(this);
        tmp = Unit_instance;
        break;
    }
    return tmp;
  };
  protoOf(CollectionItemEvent).w2r = function (listener) {
    return this.v2r((!(listener == null) ? isInterface(listener, CollectionListener) : false) ? listener : THROW_CCE());
  };
  protoOf(CollectionItemEvent).toString = function () {
    switch (this.r2r_1.x2_1) {
      case 0:
        return toString_0(this.p2r_1) + ' added at ' + this.q2r_1;
      case 1:
        return toString_0(this.o2r_1) + ' replaced with ' + toString_0(this.p2r_1) + ' at ' + this.q2r_1;
      default:
        return toString_0(this.o2r_1) + ' removed at ' + this.q2r_1;
    }
  };
  protoOf(CollectionItemEvent).hashCode = function () {
    var result = this.o2r_1 == null ? 0 : hashCode(this.o2r_1);
    result = imul(result, 31) + (this.p2r_1 == null ? 0 : hashCode(this.p2r_1)) | 0;
    result = imul(result, 31) + this.q2r_1 | 0;
    result = imul(result, 31) + this.r2r_1.hashCode() | 0;
    return result;
  };
  protoOf(CollectionItemEvent).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CollectionItemEvent))
      return false;
    if (!equals(this.o2r_1, other.o2r_1))
      return false;
    if (!equals(this.p2r_1, other.p2r_1))
      return false;
    if (!(this.q2r_1 === other.q2r_1))
      return false;
    if (!this.r2r_1.equals(other.r2r_1))
      return false;
    return true;
  };
  function CollectionListener() {
  }
  function MutableObservableCollection() {
  }
  function CollectionListeners($outer) {
    this.b2s_1 = $outer;
    Listeners.call(this);
  }
  protoOf(CollectionListeners).c2s = function () {
    return this.b2s_1.f2s();
  };
  protoOf(CollectionListeners).g2s = function () {
    this.b2s_1.e2s_1 = null;
    this.b2s_1.h2s();
  };
  function AbstractObservableList$add$lambda($event) {
    return function (listener) {
      listener.m2r($event);
      return Unit_instance;
    };
  }
  function AbstractObservableList$set$lambda($event) {
    return function (listener) {
      listener.n2r($event);
      return Unit_instance;
    };
  }
  function AbstractObservableList$removeAt$lambda($event) {
    return function (listener) {
      listener.t2r($event);
      return Unit_instance;
    };
  }
  function AbstractObservableList$addHandler$listener$1($handler) {
    this.m2s_1 = $handler;
  }
  protoOf(AbstractObservableList$addHandler$listener$1).m2r = function (event) {
    return this.m2s_1.n2s(event);
  };
  protoOf(AbstractObservableList$addHandler$listener$1).n2r = function (event) {
    return this.m2s_1.n2s(event);
  };
  protoOf(AbstractObservableList$addHandler$listener$1).t2r = function (event) {
    return this.m2s_1.n2s(event);
  };
  function AbstractObservableList() {
    AbstractMutableList.call(this);
    this.e2s_1 = null;
  }
  protoOf(AbstractObservableList).o2s = function (index, item) {
    if (index < 0 || index > this.p()) {
      throw CollectionIndexOutOfBoundsException_init_$Create$_1('Add: index=' + index + ', size=' + this.p());
    }
  };
  protoOf(AbstractObservableList).p2s = function (index, oldItem, newItem) {
    if (index < 0 || index >= this.p()) {
      throw CollectionIndexOutOfBoundsException_init_$Create$_1('Set: index=' + index + ', size=' + this.p());
    }
  };
  protoOf(AbstractObservableList).q2s = function (index, item) {
    if (index < 0 || index >= this.p()) {
      throw CollectionIndexOutOfBoundsException_init_$Create$_1('Remove: index=' + index + ', size=' + this.p());
    }
  };
  protoOf(AbstractObservableList).r2s = function (index, element) {
    this.o2s(index, element);
    this.s2s(index, element);
    var success = false;
    try {
      this.t2s(index, element);
      success = true;
      this.u2s(index, element);
      var listeners = this.e2s_1;
      if (!(listeners == null)) {
        var event = new CollectionItemEvent(null, element, index, EventType_ADD_getInstance());
        listeners.k2s(AbstractObservableList$add$lambda(event));
      }
    }finally {
      this.v2s(index, element, success);
    }
  };
  protoOf(AbstractObservableList).m2 = function (index, element) {
    return this.r2s(index, (element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  protoOf(AbstractObservableList).s2s = function (index, item) {
  };
  protoOf(AbstractObservableList).u2s = function (index, item) {
  };
  protoOf(AbstractObservableList).v2s = function (index, item, success) {
  };
  protoOf(AbstractObservableList).w2s = function (index, element) {
    var old = this.r(index);
    this.p2s(index, old, element);
    this.x2s(index, old, element);
    var success = false;
    try {
      this.y2s(index, element);
      success = true;
      this.z2s(index, old, element);
      var listeners = this.e2s_1;
      if (!(listeners == null)) {
        var event = new CollectionItemEvent(old, element, index, EventType_SET_getInstance());
        listeners.k2s(AbstractObservableList$set$lambda(event));
      }
    }finally {
      this.a2t(index, old, element, success);
    }
    return old;
  };
  protoOf(AbstractObservableList).l2 = function (index, element) {
    return this.w2s(index, (element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  protoOf(AbstractObservableList).y2s = function (index, item) {
    this.b2t(index);
    this.t2s(index, item);
  };
  protoOf(AbstractObservableList).x2s = function (index, oldItem, newItem) {
  };
  protoOf(AbstractObservableList).z2s = function (index, oldItem, newItem) {
  };
  protoOf(AbstractObservableList).a2t = function (index, oldItem, newItem, success) {
  };
  protoOf(AbstractObservableList).n2 = function (index) {
    var item = this.r(index);
    this.q2s(index, item);
    this.c2t(index, item);
    var success = false;
    try {
      this.b2t(index);
      success = true;
      this.d2t(index, item);
      var listeners = this.e2s_1;
      if (!(listeners == null)) {
        var event = new CollectionItemEvent(item, null, index, EventType_REMOVE_getInstance());
        listeners.k2s(AbstractObservableList$removeAt$lambda(event));
      }
    }finally {
      this.e2t(index, item, success);
    }
    return item;
  };
  protoOf(AbstractObservableList).c2t = function (index, item) {
  };
  protoOf(AbstractObservableList).d2t = function (index, item) {
  };
  protoOf(AbstractObservableList).e2t = function (index, item, success) {
  };
  protoOf(AbstractObservableList).x2r = function (listener) {
    var listeners = this.e2s_1;
    if (listeners == null) {
      listeners = new CollectionListeners(this);
      this.e2s_1 = listeners;
    }
    return listeners.j2s(listener);
  };
  protoOf(AbstractObservableList).f2t = function (handler) {
    var listener = new AbstractObservableList$addHandler$listener$1(handler);
    return this.x2r(listener);
  };
  protoOf(AbstractObservableList).y2r = function (handler) {
    return this.f2t(handler);
  };
  protoOf(AbstractObservableList).f2s = function () {
  };
  protoOf(AbstractObservableList).h2s = function () {
  };
  function Companion_34() {
  }
  protoOf(Companion_34).g2t = function (list) {
    return new ConstantObservableListAdapter(toList_0(list));
  };
  var Companion_instance_34;
  function Companion_getInstance_34() {
    return Companion_instance_34;
  }
  function ConstantObservableListAdapter(delegate) {
    this.h2t_1 = delegate;
  }
  protoOf(ConstantObservableListAdapter).x2r = function (listener) {
    return Companion_getInstance_29().m2l_1;
  };
  protoOf(ConstantObservableListAdapter).f2t = function (handler) {
    return Companion_getInstance_29().m2l_1;
  };
  protoOf(ConstantObservableListAdapter).y2r = function (handler) {
    return this.f2t(handler);
  };
  protoOf(ConstantObservableListAdapter).s = function () {
    return this.h2t_1.s();
  };
  protoOf(ConstantObservableListAdapter).i2t = function (element) {
    return this.h2t_1.t(element);
  };
  protoOf(ConstantObservableListAdapter).t = function (element) {
    if (!(element == null ? true : !(element == null)))
      return false;
    return this.i2t((element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  protoOf(ConstantObservableListAdapter).m = function () {
    return this.h2t_1.m();
  };
  protoOf(ConstantObservableListAdapter).j2t = function (elements) {
    return this.h2t_1.e2(elements);
  };
  protoOf(ConstantObservableListAdapter).e2 = function (elements) {
    return this.j2t(elements);
  };
  protoOf(ConstantObservableListAdapter).r = function (index) {
    return this.h2t_1.r(index);
  };
  protoOf(ConstantObservableListAdapter).k2t = function (element) {
    return this.h2t_1.w(element);
  };
  protoOf(ConstantObservableListAdapter).w = function (element) {
    if (!(element == null ? true : !(element == null)))
      return -1;
    return this.k2t((element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  protoOf(ConstantObservableListAdapter).l2t = function (element) {
    return this.h2t_1.v(element);
  };
  protoOf(ConstantObservableListAdapter).v = function (element) {
    if (!(element == null ? true : !(element == null)))
      return -1;
    return this.l2t((element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  protoOf(ConstantObservableListAdapter).f2 = function () {
    return this.h2t_1.f2();
  };
  protoOf(ConstantObservableListAdapter).u = function (index) {
    return this.h2t_1.u(index);
  };
  protoOf(ConstantObservableListAdapter).g2 = function (fromIndex, toIndex) {
    return this.h2t_1.g2(fromIndex, toIndex);
  };
  protoOf(ConstantObservableListAdapter).asJsReadonlyArrayView = function () {
    return this.h2t_1.asJsReadonlyArrayView();
  };
  protoOf(ConstantObservableListAdapter).p = function () {
    return this.h2t_1.p();
  };
  function MutableObservableList() {
  }
  function ensureContainerInitialized($this) {
    if ($this.o2t_1 == null) {
      $this.o2t_1 = ArrayList_init_$Create$_0(1);
    }
  }
  function ObservableArrayList() {
    AbstractObservableList.call(this);
    this.o2t_1 = null;
  }
  protoOf(ObservableArrayList).p = function () {
    var tmp0_safe_receiver = this.o2t_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.p();
    return tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
  };
  protoOf(ObservableArrayList).r = function (index) {
    var tmp0_elvis_lhs = this.o2t_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw CollectionIndexOutOfBoundsException_init_$Create$_0(index);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var container = tmp;
    return container.r(index);
  };
  protoOf(ObservableArrayList).t2s = function (index, item) {
    ensureContainerInitialized(this);
    ensureNotNull(this.o2t_1).m2(index, item);
  };
  protoOf(ObservableArrayList).y2s = function (index, item) {
    ensureNotNull(this.o2t_1).l2(index, item);
  };
  protoOf(ObservableArrayList).b2t = function (index) {
    var container = ensureNotNull(this.o2t_1);
    container.n2(index);
    if (container.s()) {
      this.o2t_1 = null;
    }
  };
  function ObservableList() {
  }
  function doBeforeAdd($this, item) {
    $this.q2t(item);
    $this.r2t(item);
  }
  function doAfterAdd($this, item, success) {
    try {
      if (success && !($this.p2t_1 == null)) {
        var tmp = ensureNotNull($this.p2t_1);
        tmp.k2s(AbstractObservableSet$doAfterAdd$lambda(item));
      }
    }finally {
      $this.s2t(item, success);
    }
  }
  function doBeforeRemove($this, item) {
    $this.t2t(item);
    $this.u2t(item);
  }
  function doAfterRemove($this, item, success) {
    try {
      if (success && !($this.p2t_1 == null)) {
        var tmp = ensureNotNull($this.p2t_1);
        tmp.k2s(AbstractObservableSet$doAfterRemove$lambda(item));
      }
    }finally {
      $this.v2t(item, success);
    }
  }
  function AbstractObservableSet$doAfterAdd$lambda($item) {
    return function (collectionListener) {
      var event = new CollectionItemEvent(null, $item, -1, EventType_ADD_getInstance());
      collectionListener.m2r(event);
      return Unit_instance;
    };
  }
  function AbstractObservableSet$iterator$1($iterator, this$0) {
    this.y2t_1 = $iterator;
    this.z2t_1 = this$0;
    this.w2t_1 = false;
    this.x2t_1 = null;
  }
  protoOf(AbstractObservableSet$iterator$1).n = function () {
    return this.y2t_1.n();
  };
  protoOf(AbstractObservableSet$iterator$1).o = function () {
    this.x2t_1 = this.y2t_1.o();
    this.w2t_1 = true;
    return ensureNotNull(this.x2t_1);
  };
  protoOf(AbstractObservableSet$iterator$1).h4 = function () {
    // Inline function 'kotlin.check' call
    if (!this.w2t_1) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    this.w2t_1 = false;
    doBeforeRemove(this.z2t_1, ensureNotNull(this.x2t_1));
    var success = false;
    try {
      this.y2t_1.h4();
      success = true;
    }finally {
      doAfterRemove(this.z2t_1, ensureNotNull(this.x2t_1), success);
    }
  };
  function AbstractObservableSet$doAfterRemove$lambda($item) {
    return function (collectionListener) {
      collectionListener.t2r(new CollectionItemEvent($item, null, -1, EventType_REMOVE_getInstance()));
      return Unit_instance;
    };
  }
  function AbstractObservableSet$addHandler$listener$1($handler) {
    this.a2u_1 = $handler;
    CollectionAdapter.call(this);
  }
  protoOf(AbstractObservableSet$addHandler$listener$1).m2r = function (event) {
    return this.a2u_1.n2s(event);
  };
  protoOf(AbstractObservableSet$addHandler$listener$1).t2r = function (event) {
    return this.a2u_1.n2s(event);
  };
  function AbstractObservableSet() {
    AbstractMutableSet.call(this);
    this.p2t_1 = null;
  }
  protoOf(AbstractObservableSet).x2r = function (listener) {
    if (this.p2t_1 == null) {
      this.p2t_1 = new Listeners();
    }
    return ensureNotNull(this.p2t_1).j2s(listener);
  };
  protoOf(AbstractObservableSet).c2u = function (element) {
    if (this.t(element))
      return false;
    doBeforeAdd(this, element);
    var success = false;
    try {
      this.d2u(element);
      success = this.e2u(element);
    }finally {
      doAfterAdd(this, element, success);
    }
    return success;
  };
  protoOf(AbstractObservableSet).j = function (element) {
    return this.c2u((element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  protoOf(AbstractObservableSet).f2u = function (element) {
    if (!this.t(element)) {
      return false;
    }
    doBeforeRemove(this, element);
    var success = false;
    try {
      this.g2u(element);
      success = this.h2u(element);
    }finally {
      doAfterRemove(this, element, success);
    }
    return success;
  };
  protoOf(AbstractObservableSet).h2 = function (element) {
    if (!(element == null ? true : !(element == null)))
      return false;
    return this.f2u((element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  protoOf(AbstractObservableSet).m = function () {
    if (this.p() === 0) {
      // Inline function 'kotlin.collections.mutableSetOf' call
      return LinkedHashSet_init_$Create$().m();
    }
    var iterator = this.b2u();
    return new AbstractObservableSet$iterator$1(iterator, this);
  };
  protoOf(AbstractObservableSet).q2t = function (item) {
  };
  protoOf(AbstractObservableSet).t2t = function (item) {
  };
  protoOf(AbstractObservableSet).r2t = function (item) {
  };
  protoOf(AbstractObservableSet).d2u = function (item) {
  };
  protoOf(AbstractObservableSet).s2t = function (item, success) {
  };
  protoOf(AbstractObservableSet).u2t = function (item) {
  };
  protoOf(AbstractObservableSet).g2u = function (item) {
  };
  protoOf(AbstractObservableSet).v2t = function (item, success) {
  };
  protoOf(AbstractObservableSet).f2t = function (handler) {
    var listener = new AbstractObservableSet$addHandler$listener$1(handler);
    return this.x2r(listener);
  };
  protoOf(AbstractObservableSet).y2r = function (handler) {
    return this.f2t(handler);
  };
  function Companion_35() {
  }
  protoOf(Companion_35).i2u = function (set) {
    return new ConstantObservableSetAdapter(toSet_0(set));
  };
  var Companion_instance_35;
  function Companion_getInstance_35() {
    return Companion_instance_35;
  }
  function ConstantObservableSetAdapter(delegate) {
    this.j2u_1 = delegate;
  }
  protoOf(ConstantObservableSetAdapter).x2r = function (listener) {
    return Companion_getInstance_29().m2l_1;
  };
  protoOf(ConstantObservableSetAdapter).f2t = function (handler) {
    return Companion_getInstance_29().m2l_1;
  };
  protoOf(ConstantObservableSetAdapter).y2r = function (handler) {
    return this.f2t(handler);
  };
  protoOf(ConstantObservableSetAdapter).s = function () {
    return this.j2u_1.s();
  };
  protoOf(ConstantObservableSetAdapter).i2t = function (element) {
    return this.j2u_1.t(element);
  };
  protoOf(ConstantObservableSetAdapter).t = function (element) {
    if (!(element == null ? true : !(element == null)))
      return false;
    return this.i2t((element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  protoOf(ConstantObservableSetAdapter).m = function () {
    return this.j2u_1.m();
  };
  protoOf(ConstantObservableSetAdapter).j2t = function (elements) {
    return this.j2u_1.e2(elements);
  };
  protoOf(ConstantObservableSetAdapter).e2 = function (elements) {
    return this.j2t(elements);
  };
  protoOf(ConstantObservableSetAdapter).p = function () {
    return this.j2u_1.p();
  };
  function ObservableHashSet_init_$Init$($this) {
    AbstractObservableSet.call($this);
    ObservableHashSet.call($this);
    return $this;
  }
  function ObservableHashSet_init_$Create$() {
    return ObservableHashSet_init_$Init$(objectCreate(protoOf(ObservableHashSet)));
  }
  function ensureSetInitialized($this) {
    if ($this.l2u_1 == null) {
      $this.l2u_1 = HashSet_init_$Create$_1(1);
    }
  }
  protoOf(ObservableHashSet).p = function () {
    var tmp0_safe_receiver = this.l2u_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.p();
    return tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
  };
  protoOf(ObservableHashSet).b2u = function () {
    return ensureNotNull(this.l2u_1).m();
  };
  protoOf(ObservableHashSet).i2t = function (element) {
    var tmp0_safe_receiver = this.l2u_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.t(element);
    return tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
  };
  protoOf(ObservableHashSet).t = function (element) {
    if (!(element == null ? true : !(element == null)))
      return false;
    return this.i2t((element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  protoOf(ObservableHashSet).e2u = function (item) {
    ensureSetInitialized(this);
    return ensureNotNull(this.l2u_1).j(item);
  };
  protoOf(ObservableHashSet).h2u = function (item) {
    return ensureNotNull(this.l2u_1).h2(item);
  };
  function ObservableHashSet() {
    this.l2u_1 = null;
  }
  function wrapEvent(event, f) {
    var eventType = event.r2r_1;
    var tmp;
    if (!eventType.equals(EventType_ADD_getInstance()) && !(event.s2r() == null)) {
      tmp = f(event.s2r());
    } else {
      tmp = null;
    }
    var oldItem = tmp;
    var tmp_0;
    if (!eventType.equals(EventType_REMOVE_getInstance()) && !(event.u2r() == null)) {
      tmp_0 = f(event.u2r());
    } else {
      tmp_0 = null;
    }
    var newItem = tmp_0;
    return new CollectionItemEvent(oldItem, newItem, event.q2r_1, eventType);
  }
  function ObservableListWrapper$addListener$lambda(this$0) {
    return function (it) {
      return wrapEvent(it, this$0.o2u_1);
    };
  }
  function ObservableListWrapper$addHandler$lambda($handler, this$0) {
    return function (event) {
      $handler.n2s(wrapEvent(event, this$0.o2u_1));
      return Unit_instance;
    };
  }
  function ObservableListWrapper(source, sToT, tToS) {
    AbstractMutableList.call(this);
    this.n2u_1 = source;
    this.o2u_1 = sToT;
    this.p2u_1 = tToS;
  }
  protoOf(ObservableListWrapper).p = function () {
    return this.n2u_1.p();
  };
  protoOf(ObservableListWrapper).q2u = function (listener) {
    return this.n2u_1.x2r(new RelayCollectionListener(listener, ObservableListWrapper$addListener$lambda(this)));
  };
  protoOf(ObservableListWrapper).x2r = function (listener) {
    return this.q2u(listener);
  };
  protoOf(ObservableListWrapper).r2u = function (handler) {
    return this.n2u_1.z2r(ObservableListWrapper$addHandler$lambda(handler, this));
  };
  protoOf(ObservableListWrapper).y2r = function (handler) {
    return this.r2u(handler);
  };
  protoOf(ObservableListWrapper).s2u = function (index, element) {
    this.n2u_1.m2(index, this.p2u_1(element));
  };
  protoOf(ObservableListWrapper).m2 = function (index, element) {
    return this.s2u(index, (element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  protoOf(ObservableListWrapper).t2u = function (index, element) {
    var old = this.n2u_1.l2(index, this.p2u_1(element));
    return this.o2u_1(old);
  };
  protoOf(ObservableListWrapper).l2 = function (index, element) {
    return this.t2u(index, (element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  protoOf(ObservableListWrapper).r = function (index) {
    return this.o2u_1(this.n2u_1.r(index));
  };
  protoOf(ObservableListWrapper).n2 = function (index) {
    var old = this.n2u_1.n2(index);
    return this.o2u_1(old);
  };
  function ObservableSetWrapper$addListener$lambda(this$0) {
    return function (it) {
      return wrapEvent(it, this$0.v2u_1);
    };
  }
  function ObservableSetWrapper$addHandler$lambda($handler, this$0) {
    return function (event) {
      $handler.n2s(wrapEvent(event, this$0.v2u_1));
      return Unit_instance;
    };
  }
  function ObservableSetWrapper$iterator$1(this$0) {
    this.y2u_1 = this$0;
    this.x2u_1 = this$0.u2u_1.m();
  }
  protoOf(ObservableSetWrapper$iterator$1).n = function () {
    return this.x2u_1.n();
  };
  protoOf(ObservableSetWrapper$iterator$1).o = function () {
    return this.y2u_1.v2u_1(this.x2u_1.o());
  };
  protoOf(ObservableSetWrapper$iterator$1).h4 = function () {
    return this.x2u_1.h4();
  };
  function ObservableSetWrapper(source, sToT, tToS) {
    this.u2u_1 = source;
    this.v2u_1 = sToT;
    this.w2u_1 = tToS;
  }
  protoOf(ObservableSetWrapper).p = function () {
    return this.u2u_1.p();
  };
  protoOf(ObservableSetWrapper).q2u = function (listener) {
    return this.u2u_1.x2r(new RelayCollectionListener(listener, ObservableSetWrapper$addListener$lambda(this)));
  };
  protoOf(ObservableSetWrapper).x2r = function (listener) {
    return this.q2u(listener);
  };
  protoOf(ObservableSetWrapper).r2u = function (handler) {
    return this.u2u_1.z2r(ObservableSetWrapper$addHandler$lambda(handler, this));
  };
  protoOf(ObservableSetWrapper).y2r = function (handler) {
    return this.r2u(handler);
  };
  protoOf(ObservableSetWrapper).s = function () {
    return this.u2u_1.s();
  };
  protoOf(ObservableSetWrapper).z2u = function (element) {
    if (element == null)
      return false;
    return this.u2u_1.t(this.w2u_1(element));
  };
  protoOf(ObservableSetWrapper).t = function (element) {
    if (!(element == null ? true : !(element == null)))
      return false;
    return this.z2u((element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  protoOf(ObservableSetWrapper).m = function () {
    return new ObservableSetWrapper$iterator$1(this);
  };
  protoOf(ObservableSetWrapper).a2v = function (element) {
    return this.u2u_1.j(this.w2u_1(element));
  };
  protoOf(ObservableSetWrapper).j = function (element) {
    return this.a2v((element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  protoOf(ObservableSetWrapper).b2v = function (element) {
    return this.u2u_1.h2(this.w2u_1(element));
  };
  protoOf(ObservableSetWrapper).h2 = function (element) {
    if (!(element == null ? true : !(element == null)))
      return false;
    return this.b2v((element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  protoOf(ObservableSetWrapper).c2v = function (elements) {
    var _iterator__ex2g4s = elements.m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      if (!this.u2u_1.t(this.w2u_1(element))) {
        return false;
      }
    }
    return true;
  };
  protoOf(ObservableSetWrapper).e2 = function (elements) {
    return this.c2v(elements);
  };
  protoOf(ObservableSetWrapper).d2v = function (elements) {
    var changed = false;
    var _iterator__ex2g4s = elements.m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      if (this.a2v(element)) {
        changed = true;
      }
    }
    return changed;
  };
  protoOf(ObservableSetWrapper).q = function (elements) {
    return this.d2v(elements);
  };
  protoOf(ObservableSetWrapper).e2v = function (elements) {
    var iter = this.m();
    while (iter.n()) {
      var current = iter.o();
      if (!elements.t(current)) {
        iter.h4();
      }
    }
    return false;
  };
  protoOf(ObservableSetWrapper).j2 = function (elements) {
    return this.e2v(elements);
  };
  protoOf(ObservableSetWrapper).f2v = function (elements) {
    var changed = false;
    var _iterator__ex2g4s = elements.m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      if (this.u2u_1.h2(this.w2u_1(element))) {
        changed = true;
      }
    }
    return changed;
  };
  protoOf(ObservableSetWrapper).j1 = function (elements) {
    return this.f2v(elements);
  };
  protoOf(ObservableSetWrapper).k2 = function () {
    return this.u2u_1.k2();
  };
  function RelayCollectionListener(relayTo, transform) {
    this.g2v_1 = relayTo;
    this.h2v_1 = transform;
  }
  protoOf(RelayCollectionListener).i2v = function (event) {
    this.g2v_1.m2r(this.h2v_1(event));
  };
  protoOf(RelayCollectionListener).m2r = function (event) {
    return this.i2v(event);
  };
  protoOf(RelayCollectionListener).j2v = function (event) {
    this.g2v_1.n2r(this.h2v_1(event));
  };
  protoOf(RelayCollectionListener).n2r = function (event) {
    return this.j2v(event);
  };
  protoOf(RelayCollectionListener).k2v = function (event) {
    this.g2v_1.t2r(this.h2v_1(event));
  };
  protoOf(RelayCollectionListener).t2r = function (event) {
    return this.k2v(event);
  };
  function get_asObservable(_this__u8e3s4) {
    return Companion_instance_34.g2t(_this__u8e3s4);
  }
  function get_asObservable_0(_this__u8e3s4) {
    var tmp;
    if (isInterface(_this__u8e3s4, KtList)) {
      tmp = get_asObservable(_this__u8e3s4);
    } else {
      if (isInterface(_this__u8e3s4, KtSet)) {
        tmp = get_asObservable_1(_this__u8e3s4);
      } else {
        throw IllegalStateException_init_$Create$_0('Unknown collection ' + toString_1(_this__u8e3s4));
      }
    }
    return tmp;
  }
  function get_asObservable_1(_this__u8e3s4) {
    return Companion_instance_35.i2u(_this__u8e3s4);
  }
  function EventHandlerListeners$fire$lambda($event) {
    return function (handler) {
      handler.n2s($event);
      return Unit_instance;
    };
  }
  function EventHandlerListeners() {
    Listeners.call(this);
  }
  protoOf(EventHandlerListeners).m2v = function (event) {
    return this.k2s(EventHandlerListeners$fire$lambda(event));
  };
  function EventSource$addHandler$$inlined$eventHandler$1($f) {
    this.n2v_1 = $f;
  }
  protoOf(EventSource$addHandler$$inlined$eventHandler$1).o2v = function (event) {
    return this.n2v_1(event);
  };
  protoOf(EventSource$addHandler$$inlined$eventHandler$1).n2s = function (event) {
    return this.o2v((event == null ? true : !(event == null)) ? event : THROW_CCE());
  };
  function EventSource() {
  }
  function ListenerEvent$dispatch$ref(p0) {
    var l = function (_this__u8e3s4) {
      p0.w2r(_this__u8e3s4);
      return Unit_instance;
    };
    l.callableName = 'dispatch';
    return l;
  }
  function EventListeners() {
    Listeners.call(this);
  }
  protoOf(EventListeners).q2v = function (event) {
    return this.k2s(ListenerEvent$dispatch$ref(event));
  };
  function addHandlerTo($this, src) {
    var handler = src.z2r(CompositeEventSource$addHandlerTo$lambda($this));
    $this.t2v_1.j(handler);
  }
  function CompositeEventSource$addHandler$1(this$0) {
    this.v2v_1 = this$0;
    EventHandlerListeners.call(this);
  }
  protoOf(CompositeEventSource$addHandler$1).c2s = function () {
    var _iterator__ex2g4s = this.v2v_1.s2v_1.m();
    while (_iterator__ex2g4s.n()) {
      var eventSource = _iterator__ex2g4s.o();
      addHandlerTo(this.v2v_1, eventSource);
    }
  };
  protoOf(CompositeEventSource$addHandler$1).g2s = function () {
    var _iterator__ex2g4s = this.v2v_1.t2v_1.m();
    while (_iterator__ex2g4s.n()) {
      var disposable = _iterator__ex2g4s.o();
      disposable.zr();
    }
    this.v2v_1.t2v_1.k2();
    this.v2v_1.r2v_1 = null;
  };
  function CompositeEventSource$addHandlerTo$lambda(this$0) {
    return function (event) {
      ensureNotNull(this$0.r2v_1).m2v(event);
      return Unit_instance;
    };
  }
  function CompositeEventSource(sources) {
    this.r2v_1 = null;
    this.s2v_1 = ArrayList_init_$Create$();
    this.t2v_1 = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last = sources.length;
    while (inductionVariable < last) {
      var source = sources[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      this.w2v(source);
    }
  }
  protoOf(CompositeEventSource).w2v = function (source) {
    // Inline function 'kotlin.collections.plusAssign' call
    this.s2v_1.j(source);
  };
  protoOf(CompositeEventSource).y2r = function (handler) {
    if (this.r2v_1 == null) {
      var tmp = this;
      tmp.r2v_1 = new CompositeEventSource$addHandler$1(this);
    }
    return ensureNotNull(this.r2v_1).j2s(handler);
  };
  function EventSources() {
  }
  protoOf(EventSources).x2v = function (sources) {
    return new CompositeEventSource(sources.slice());
  };
  var EventSources_instance;
  function EventSources_getInstance() {
    return EventSources_instance;
  }
  function Listeners$add$$inlined$toDisposable$1(this$0, $listener) {
    this.y2v_1 = this$0;
    this.z2v_1 = $listener;
  }
  protoOf(Listeners$add$$inlined$toDisposable$1).zr = function () {
    this.y2v_1.i2s_1.c2m(this.z2v_1);
    if (this.y2v_1.w2m()) {
      this.y2v_1.g2s();
    }
    return Unit_instance;
  };
  function Listeners$fire$lambda($h) {
    return function (iterable) {
      var _iterator__ex2g4s = iterable.m();
      while (_iterator__ex2g4s.n()) {
        var listener = _iterator__ex2g4s.o();
        try {
          $h(listener);
        } catch ($p) {
          if ($p instanceof Error) {
            var t = $p;
            ThrowableHandlers_getInstance().k2r_1.j2r(t);
          } else {
            throw $p;
          }
        }
      }
      return Unit_instance;
    };
  }
  function Listeners() {
    this.i2s_1 = Companion_instance_31.c2n();
  }
  protoOf(Listeners).w2m = function () {
    return this.l2s() === 0;
  };
  protoOf(Listeners).j2s = function (listener) {
    if (this.w2m()) {
      this.c2s();
    }
    this.i2s_1.b2m(listener);
    // Inline function 'jetbrains.ocelot.base.disposable.toDisposable' call
    return new Listeners$add$$inlined$toDisposable$1(this, listener);
  };
  protoOf(Listeners).k2s = function (h) {
    if (this.w2m()) {
      return Unit_instance;
    }
    try {
      this.i2s_1.a2m(Listeners$fire$lambda(h));
    }finally {
      if (!this.i2s_1.z2l() && this.w2m()) {
        this.g2s();
      }
    }
  };
  protoOf(Listeners).k2 = function () {
    return this.i2s_1.k2();
  };
  protoOf(Listeners).c2s = function () {
  };
  protoOf(Listeners).g2s = function () {
  };
  protoOf(Listeners).l2s = function () {
    return this.i2s_1.x2g();
  };
  function ListenersDelegate($outer, element) {
    this.c2w_1 = $outer;
    Listeners.call(this);
    this.b2w_1 = element;
  }
  protoOf(ListenersDelegate).c2s = function () {
    this.c2w_1.e2w(this.b2w_1);
  };
  protoOf(ListenersDelegate).g2s = function () {
    this.c2w_1.f2w(this.b2w_1);
  };
  function ListenersMap$add$$inlined$toDisposable$1($disposable, $listeners, this$0, $element) {
    this.g2w_1 = $disposable;
    this.h2w_1 = $listeners;
    this.i2w_1 = this$0;
    this.j2w_1 = $element;
  }
  protoOf(ListenersMap$add$$inlined$toDisposable$1).zr = function () {
    this.g2w_1.zr();
    if (this.h2w_1.w2m()) {
      this.i2w_1.d2w_1.u2(this.j2w_1);
    }
    return Unit_instance;
  };
  function ListenersMap() {
    var tmp = this;
    // Inline function 'kotlin.collections.hashMapOf' call
    tmp.d2w_1 = HashMap_init_$Create$();
  }
  protoOf(ListenersMap).k2w = function (element, listener) {
    // Inline function 'kotlin.collections.getOrPut' call
    var this_0 = this.d2w_1;
    var value = this_0.q2(element);
    var tmp;
    if (value == null) {
      var answer = new ListenersDelegate(this, element);
      this_0.t2(element, answer);
      tmp = answer;
    } else {
      tmp = value;
    }
    var listeners = tmp;
    var disposable = listeners.j2s(listener);
    // Inline function 'jetbrains.ocelot.base.disposable.toDisposable' call
    return new ListenersMap$add$$inlined$toDisposable$1(disposable, listeners, this, element);
  };
  protoOf(ListenersMap).l2w = function (element, action) {
    var tmp0_safe_receiver = this.d2w_1.q2(element);
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.k2s(action);
    }
  };
  protoOf(ListenersMap).k2 = function () {
    var _iterator__ex2g4s = this.d2w_1.s2().m();
    while (_iterator__ex2g4s.n()) {
      var listeners = _iterator__ex2g4s.o();
      listeners.k2();
    }
    this.d2w_1.k2();
  };
  protoOf(ListenersMap).e2w = function (element) {
  };
  protoOf(ListenersMap).f2w = function (element) {
  };
  function BaseDerivedProperty$addHandler$1(this$0) {
    this.n2w_1 = this$0;
    EventHandlerListeners.call(this);
  }
  protoOf(BaseDerivedProperty$addHandler$1).c2s = function () {
    this.n2w_1.o2w_1 = this.n2w_1.q2w();
    this.n2w_1.r2w();
  };
  protoOf(BaseDerivedProperty$addHandler$1).g2s = function () {
    this.n2w_1.s2w();
    this.n2w_1.p2w_1 = null;
  };
  function BaseDerivedProperty() {
    BaseReadableProperty.call(this);
    this.o2w_1 = null;
    this.p2w_1 = null;
  }
  protoOf(BaseDerivedProperty).uv = function () {
    var tmp;
    if (this.p2w_1 == null) {
      tmp = this.q2w();
    } else {
      var tmp_0 = this.o2w_1;
      tmp = (tmp_0 == null ? true : !(tmp_0 == null)) ? tmp_0 : THROW_CCE();
    }
    return tmp;
  };
  protoOf(BaseDerivedProperty).t2w = function () {
    var newValue = this.q2w();
    var oldValue = this.o2w_1;
    if (equals(oldValue, newValue)) {
      return Unit_instance;
    }
    this.o2w_1 = newValue;
    if (!(this.p2w_1 == null)) {
      var castOldValue = (oldValue == null ? true : !(oldValue == null)) ? oldValue : THROW_CCE();
      var event = new PropertyChangeEvent(castOldValue, newValue);
      ensureNotNull(this.p2w_1).m2v(event);
    }
  };
  protoOf(BaseDerivedProperty).u2w = function (handler) {
    if (this.p2w_1 == null) {
      var tmp = this;
      tmp.p2w_1 = new BaseDerivedProperty$addHandler$1(this);
    }
    return ensureNotNull(this.p2w_1).j2s(handler);
  };
  protoOf(BaseDerivedProperty).y2r = function (handler) {
    return this.u2w(handler);
  };
  function BaseReadableProperty() {
  }
  protoOf(BaseReadableProperty).v2w = function () {
    var tmp0_elvis_lhs = getKClassFromExpression(this).ra();
    return tmp0_elvis_lhs == null ? '<Name not available, inherits BaseReadableProperty>' : tmp0_elvis_lhs;
  };
  protoOf(BaseReadableProperty).toString = function () {
    return this.v2w();
  };
  function DelayedValueProperty$addHandler$1(this$0) {
    this.y2w_1 = this$0;
    EventHandlerListeners.call(this);
  }
  protoOf(DelayedValueProperty$addHandler$1).g2s = function () {
    this.y2w_1.a2x_1 = null;
  };
  function DelayedValueProperty() {
    BaseReadableProperty.call(this);
    this.z2w_1 = null;
    this.a2x_1 = null;
    this.b2x_1 = null;
  }
  protoOf(DelayedValueProperty).v2w = function () {
    return 'delayedProperty()';
  };
  protoOf(DelayedValueProperty).uv = function () {
    return this.z2w_1;
  };
  protoOf(DelayedValueProperty).c2x = function (newValue) {
    if (equals(newValue, this.z2w_1)) {
      return Unit_instance;
    }
    var oldValue = this.z2w_1;
    this.z2w_1 = newValue;
    // Inline function 'kotlin.check' call
    if (!(this.b2x_1 == null)) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    this.b2x_1 = new PropertyChangeEvent(oldValue, this.z2w_1);
  };
  protoOf(DelayedValueProperty).d2x = function (newValue) {
    return this.c2x((newValue == null ? true : !(newValue == null)) ? newValue : THROW_CCE());
  };
  protoOf(DelayedValueProperty).c9 = function () {
    var tmp0_safe_receiver = this.a2x_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.m2v(ensureNotNull(this.b2x_1));
    }
    this.b2x_1 = null;
  };
  protoOf(DelayedValueProperty).e2x = function (handler) {
    if (this.a2x_1 == null) {
      var tmp = this;
      tmp.a2x_1 = new DelayedValueProperty$addHandler$1(this);
    }
    return ensureNotNull(this.a2x_1).j2s(handler);
  };
  protoOf(DelayedValueProperty).y2r = function (handler) {
    return this.e2x(handler);
  };
  function DerivedProperty$doAddListeners$lambda(this$0) {
    return function (it) {
      this$0.t2w();
      return Unit_instance;
    };
  }
  function DerivedProperty(deps) {
    BaseDerivedProperty.call(this);
    this.i2x_1 = toList(deps);
    var tmp = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp.j2x_1 = ArrayList_init_$Create$();
  }
  protoOf(DerivedProperty).r2w = function () {
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.i2x_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.m();
    while (_iterator__ex2g4s.n()) {
      var item = _iterator__ex2g4s.o();
      var tmp$ret$0 = item.z2r(DerivedProperty$doAddListeners$lambda(this));
      destination.j(tmp$ret$0);
    }
    var list = destination;
    this.j2x_1.q(list);
  };
  protoOf(DerivedProperty).s2w = function () {
    var _iterator__ex2g4s = this.j2x_1.m();
    while (_iterator__ex2g4s.n()) {
      var r = _iterator__ex2g4s.o();
      r.zr();
    }
    this.j2x_1.k2();
  };
  function toDerivedProperty(_this__u8e3s4, deps) {
    var r = _this__u8e3s4;
    return new toDerivedProperty$1(deps, r);
  }
  function toDerivedProperty$1($deps, $r) {
    this.o2x_1 = $r;
    DerivedProperty.call(this, $deps.slice());
  }
  protoOf(toDerivedProperty$1).q2w = function () {
    return this.o2x_1();
  };
  function notNull(_this__u8e3s4) {
    return map_0(_this__u8e3s4, notNull$lambda);
  }
  function not(_this__u8e3s4) {
    return map_0(_this__u8e3s4, not$lambda);
  }
  function isNull(_this__u8e3s4) {
    return map_0(_this__u8e3s4, isNull$lambda);
  }
  function ifProp(_this__u8e3s4, ifTrue, ifFalse) {
    return ifProp_0(_this__u8e3s4, constantProp(ifTrue), constantProp(ifFalse));
  }
  function map_0(_this__u8e3s4, f) {
    var prop = _this__u8e3s4;
    return new map$1(_this__u8e3s4, prop, f);
  }
  function map_1(_this__u8e3s4, sourceToTarget, targetToSource) {
    var property = _this__u8e3s4;
    return new map$2(property, sourceToTarget, targetToSource);
  }
  function Properties$and$1($props) {
    this.t2x_1 = $props;
    DerivedProperty.call(this, $props.slice());
  }
  protoOf(Properties$and$1).v2w = function () {
    var propExpr = new StringBuilder('(');
    propExpr.j8(this.t2x_1[0].v2w());
    var inductionVariable = 1;
    var last = this.t2x_1.length;
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        propExpr.j8(' && ').j8(this.t2x_1[i].v2w());
      }
       while (inductionVariable < last);
    return propExpr.j8(')').toString();
  };
  protoOf(Properties$and$1).q2w = function () {
    var res = true;
    var indexedObject = this.t2x_1;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var prop = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      res = (res && prop.w2w());
    }
    return res;
  };
  function Properties$or$1($props) {
    this.y2x_1 = $props;
    DerivedProperty.call(this, $props.slice());
  }
  protoOf(Properties$or$1).v2w = function () {
    var propExpr = new StringBuilder('(');
    propExpr.j8(this.y2x_1[0].v2w());
    var inductionVariable = 1;
    var last = this.y2x_1.length;
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        propExpr.j8(' || ').j8(this.y2x_1[i].v2w());
      }
       while (inductionVariable < last);
    return propExpr.j8(')').toString();
  };
  protoOf(Properties$or$1).q2w = function () {
    var res = false;
    var indexedObject = this.y2x_1;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var prop = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      res = res || prop.w2w();
    }
    return res;
  };
  function Properties() {
    Properties_instance = this;
    this.z2x_1 = constantProp(true);
    this.a2y_1 = constantProp(false);
  }
  protoOf(Properties).b2y = function (props) {
    // Inline function 'kotlin.collections.isNotEmpty' call
    // Inline function 'kotlin.collections.isEmpty' call
    // Inline function 'kotlin.require' call
    if (!!(props.length === 0)) {
      var message = 'No arguments';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    return new Properties$and$1(props);
  };
  protoOf(Properties).c2y = function (props) {
    // Inline function 'kotlin.collections.isNotEmpty' call
    // Inline function 'kotlin.collections.isEmpty' call
    // Inline function 'kotlin.require' call
    if (!!(props.length === 0)) {
      var message = 'No arguments';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    return new Properties$or$1(props);
  };
  var Properties_instance;
  function Properties_getInstance() {
    if (Properties_instance == null)
      new Properties();
    return Properties_instance;
  }
  function notEqual(_this__u8e3s4, p2) {
    return not(isEqual(_this__u8e3s4, p2));
  }
  function and(_this__u8e3s4, op2) {
    var op1 = _this__u8e3s4;
    return new and$1(op1, op2);
  }
  function asValidatedProp(_this__u8e3s4, initialValue, validator) {
    var source = _this__u8e3s4;
    return new asValidatedProp$ValidatedProperty(initialValue, source, validator);
  }
  function isSame(_this__u8e3s4, v) {
    return map_0(_this__u8e3s4, isSame$lambda(v));
  }
  function select(_this__u8e3s4, nullValue, selector) {
    var source = _this__u8e3s4;
    return new select$1(selector, source, nullValue);
  }
  function constantProp(_this__u8e3s4) {
    var value = _this__u8e3s4;
    return new constantProp$1(value);
  }
  function ifProp_0(_this__u8e3s4, ifTrue, ifFalse) {
    var conditionProp = _this__u8e3s4;
    return new ifProp$1(conditionProp, ifTrue, ifFalse);
  }
  function isEqual(_this__u8e3s4, p2) {
    var p1 = _this__u8e3s4;
    return new isEqual$1(p1, p2);
  }
  function AbstractSelectProperty(selector) {
    BaseDerivedProperty.call(this);
    this.f2y_1 = selector;
    this.g2y_1 = Companion_getInstance_29().m2l_1;
    this.h2y_1 = Companion_getInstance_29().m2l_1;
  }
  protoOf(AbstractSelectProperty).r2w = function () {
    this.g2y_1 = this.i2y();
    this.h2y_1 = this.j2y();
  };
  protoOf(AbstractSelectProperty).s2w = function () {
    this.k2y();
    this.l2y();
  };
  protoOf(AbstractSelectProperty).k2y = function () {
    this.g2y_1.zr();
    this.g2y_1 = Companion_getInstance_29().m2l_1;
  };
  protoOf(AbstractSelectProperty).l2y = function () {
    this.h2y_1.zr();
    this.h2y_1 = Companion_getInstance_29().m2l_1;
  };
  function notNull$lambda(value) {
    return !(value == null);
  }
  function not$lambda(value) {
    return !value;
  }
  function isNull$lambda(value) {
    return value == null;
  }
  function map$1($this_map, $prop, $f) {
    this.q2y_1 = $prop;
    this.r2y_1 = $f;
    DerivedProperty.call(this, [$this_map]);
  }
  protoOf(map$1).v2w = function () {
    return 'transform(' + this.q2y_1.v2w() + ', ' + toString_1(this.r2y_1) + ')';
  };
  protoOf(map$1).q2w = function () {
    return this.r2y_1(this.q2y_1.w2w());
  };
  function map$o$addHandler$lambda($sourceToTarget, $handler) {
    return function (event) {
      var oldValue = $sourceToTarget(event.s2y_1);
      var newValue = $sourceToTarget(event.t2y_1);
      var tmp;
      if (!equals(oldValue, newValue)) {
        $handler.n2s(new PropertyChangeEvent(oldValue, newValue));
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function map$2($property, $sourceToTarget, $targetToSource) {
    this.u2y_1 = $property;
    this.v2y_1 = $sourceToTarget;
    this.w2y_1 = $targetToSource;
  }
  protoOf(map$2).v2w = function () {
    return 'transform(' + this.u2y_1.v2w() + ', ' + toString_1(this.v2y_1) + ', ' + toString_1(this.w2y_1) + ')';
  };
  protoOf(map$2).uv = function () {
    var source = this.u2y_1.uv();
    return this.v2y_1(source);
  };
  protoOf(map$2).x2y = function (handler) {
    return this.u2y_1.z2r(map$o$addHandler$lambda(this.v2y_1, handler));
  };
  protoOf(map$2).y2r = function (handler) {
    return this.x2y(handler);
  };
  protoOf(map$2).y2y = function (newValue) {
    var source = this.w2y_1(newValue);
    this.u2y_1.d2x(source);
  };
  protoOf(map$2).d2x = function (newValue) {
    return this.y2y((newValue == null ? true : !(newValue == null)) ? newValue : THROW_CCE());
  };
  function and$1($op1, $op2) {
    this.d2z_1 = $op1;
    this.e2z_1 = $op2;
    DerivedProperty.call(this, [$op1, $op2]);
  }
  protoOf(and$1).v2w = function () {
    return '(' + this.d2z_1.v2w() + ' && ' + this.e2z_1.v2w() + ')';
  };
  protoOf(and$1).q2w = function () {
    return this.d2z_1.w2w() && this.e2z_1.w2w();
  };
  function asValidatedProp$ValidatedProperty($initialValue, $source, $validator) {
    this.k2z_1 = $source;
    this.l2z_1 = $validator;
    DerivedProperty.call(this, [$source]);
    this.j2z_1 = $initialValue;
  }
  protoOf(asValidatedProp$ValidatedProperty).v2w = function () {
    return 'validated(' + this.k2z_1.v2w() + ', ' + toString_1(this.l2z_1) + ')';
  };
  protoOf(asValidatedProp$ValidatedProperty).q2w = function () {
    var sourceValue = this.k2z_1.w2w();
    if (this.l2z_1(sourceValue)) {
      this.j2z_1 = sourceValue;
    }
    return this.j2z_1;
  };
  protoOf(asValidatedProp$ValidatedProperty).d2x = function (newValue) {
    if (!this.l2z_1(newValue)) {
      return Unit_instance;
    }
    this.k2z_1.f2x(newValue);
  };
  function isSame$lambda($v) {
    return function (value) {
      return value === $v;
    };
  }
  function select$o$addSourceListener$lambda(this$0) {
    return function (it) {
      this$0.l2y();
      this$0.j2y();
      this$0.t2w();
      return Unit_instance;
    };
  }
  function select$o$addTargetListener$lambda(this$0) {
    return function (it) {
      this$0.t2w();
      return Unit_instance;
    };
  }
  function select$1($selector, $source, $nullValue) {
    this.r2z_1 = $selector;
    this.s2z_1 = $source;
    this.t2z_1 = $nullValue;
    AbstractSelectProperty.call(this, $selector);
  }
  protoOf(select$1).v2w = function () {
    return this.s2z_1.v2w() + '.select(' + toString_0(this.t2z_1) + ', ' + toString_1(this.r2z_1) + ')';
  };
  protoOf(select$1).i2y = function () {
    return this.s2z_1.z2r(select$o$addSourceListener$lambda(this));
  };
  protoOf(select$1).j2y = function () {
    var tmp0_safe_receiver = this.s2z_1.w2w();
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp = this.r2z_1(tmp0_safe_receiver);
    }
    var tmp1_safe_receiver = tmp;
    var tmp_0;
    if (tmp1_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.run' call
      tmp_0 = tmp1_safe_receiver.z2r(select$o$addTargetListener$lambda(this));
    }
    var tmp2_elvis_lhs = tmp_0;
    return tmp2_elvis_lhs == null ? Companion_getInstance_29().m2l_1 : tmp2_elvis_lhs;
  };
  protoOf(select$1).q2w = function () {
    var value = this.s2z_1.w2w();
    return value == null ? this.t2z_1 : this.r2z_1(value).uv();
  };
  function constantProp$1($value) {
    this.u2z_1 = $value;
    BaseReadableProperty.call(this);
  }
  protoOf(constantProp$1).v2w = function () {
    return 'constantProp(' + toString_0(this.u2z_1) + ')';
  };
  protoOf(constantProp$1).uv = function () {
    return this.u2z_1;
  };
  protoOf(constantProp$1).u2w = function (handler) {
    return Companion_getInstance_29().m2l_1;
  };
  protoOf(constantProp$1).y2r = function (handler) {
    return this.u2w(handler);
  };
  function ifProp$1($conditionProp, $ifTrue, $ifFalse) {
    this.z2z_1 = $conditionProp;
    this.a30_1 = $ifTrue;
    this.b30_1 = $ifFalse;
    DerivedProperty.call(this, [$conditionProp, $ifTrue, $ifFalse]);
  }
  protoOf(ifProp$1).v2w = function () {
    var conditionExpr = this.z2z_1.v2w();
    var ifTrueExpr = this.a30_1.v2w();
    var ifFalseExpr = this.b30_1.v2w();
    return 'if(' + conditionExpr + ', ' + ifTrueExpr + ', ' + ifFalseExpr + ')';
  };
  protoOf(ifProp$1).q2w = function () {
    return this.z2z_1.w2w() ? this.a30_1.w2w() : this.b30_1.w2w();
  };
  function isEqual$1($p1, $p2) {
    this.g30_1 = $p1;
    this.h30_1 = $p2;
    DerivedProperty.call(this, [$p1, $p2]);
  }
  protoOf(isEqual$1).v2w = function () {
    return 'equals(' + this.g30_1.v2w() + ', ' + this.h30_1.v2w() + ')';
  };
  protoOf(isEqual$1).q2w = function () {
    return equals(this.g30_1.w2w(), this.h30_1.w2w());
  };
  function Property() {
  }
  function PropertyBinding$bindOneWay$lambda($target) {
    return function (it) {
      $target.f2x(it.t2y_1);
      return Unit_instance;
    };
  }
  function PropertyBinding$bindTwoWay$UpdatingEventHandler($syncing, $target, $source, forward) {
    this.j30_1 = $syncing;
    this.k30_1 = $target;
    this.l30_1 = $source;
    this.i30_1 = forward;
  }
  protoOf(PropertyBinding$bindTwoWay$UpdatingEventHandler).m30 = function (event) {
    if (this.j30_1.w2w())
      return Unit_instance;
    this.j30_1.f2x(true);
    try {
      if (this.i30_1) {
        this.k30_1.f2x(this.l30_1.w2w());
      } else {
        this.l30_1.f2x(this.k30_1.w2w());
      }
    }finally {
      this.j30_1.f2x(false);
    }
  };
  protoOf(PropertyBinding$bindTwoWay$UpdatingEventHandler).n2s = function (event) {
    return this.m30(event instanceof PropertyChangeEvent ? event : THROW_CCE());
  };
  function PropertyBinding() {
  }
  protoOf(PropertyBinding).n30 = function (source, target) {
    target.f2x(source.w2w());
    return source.z2r(PropertyBinding$bindOneWay$lambda(target));
  };
  protoOf(PropertyBinding).o30 = function (source, target) {
    var syncing = new ValueProperty(false);
    target.f2x(source.w2w());
    return source.y2r(new PropertyBinding$bindTwoWay$UpdatingEventHandler(syncing, target, source, true)).j2l(target.y2r(new PropertyBinding$bindTwoWay$UpdatingEventHandler(syncing, target, source, false)));
  };
  var PropertyBinding_instance;
  function PropertyBinding_getInstance() {
    return PropertyBinding_instance;
  }
  function PropertyChangeEvent(oldValue, newValue) {
    this.s2y_1 = oldValue;
    this.t2y_1 = newValue;
  }
  protoOf(PropertyChangeEvent).toString = function () {
    return toString_0(this.s2y_1) + ' -> ' + toString_0(this.t2y_1);
  };
  protoOf(PropertyChangeEvent).hashCode = function () {
    var result = this.s2y_1 == null ? 0 : hashCode(this.s2y_1);
    result = imul(result, 31) + (this.t2y_1 == null ? 0 : hashCode(this.t2y_1)) | 0;
    return result;
  };
  protoOf(PropertyChangeEvent).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PropertyChangeEvent))
      return false;
    if (!equals(this.s2y_1, other.s2y_1))
      return false;
    if (!equals(this.t2y_1, other.t2y_1))
      return false;
    return true;
  };
  function ReadableProperty() {
  }
  function UpdatableProperty() {
    BaseDerivedProperty.call(this);
  }
  protoOf(UpdatableProperty).v2w = function () {
    return 'updatable property';
  };
  protoOf(UpdatableProperty).r30 = function () {
    return this.t2w();
  };
  function _get_initializedHandlers__py2qj8($this) {
    var tmp0_elvis_lhs = $this.t30_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.run' call
      var initHandlers = new ValueProperty$initializedHandlers$1($this);
      $this.t30_1 = initHandlers;
      tmp = initHandlers;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function fireEvents($this, oldValue, newValue) {
    var tmp0_safe_receiver = $this.t30_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.apply' call
      var event = new PropertyChangeEvent(oldValue, newValue);
      tmp0_safe_receiver.m2v(event);
    }
  }
  function ValueProperty$initializedHandlers$1($this_run) {
    this.v30_1 = $this_run;
    EventHandlerListeners.call(this);
  }
  protoOf(ValueProperty$initializedHandlers$1).g2s = function () {
    this.v30_1.t30_1 = null;
  };
  function ValueProperty(value) {
    BaseReadableProperty.call(this);
    this.s30_1 = value;
    this.t30_1 = null;
  }
  protoOf(ValueProperty).v2w = function () {
    return 'valueProperty()';
  };
  protoOf(ValueProperty).uv = function () {
    return this.s30_1;
  };
  protoOf(ValueProperty).d2x = function (newValue) {
    if (equals(newValue, this.s30_1)) {
      return Unit_instance;
    }
    var oldValue = this.s30_1;
    this.s30_1 = newValue;
    fireEvents(this, oldValue, this.s30_1);
  };
  protoOf(ValueProperty).u2w = function (handler) {
    return _get_initializedHandlers__py2qj8(this).j2s(handler);
  };
  protoOf(ValueProperty).y2r = function (handler) {
    return this.u2w(handler);
  };
  function WritableProperty() {
  }
  function toWritableProperty(_this__u8e3s4) {
    return new toWritableProperty$1(_this__u8e3s4);
  }
  function toWritableProperty$1($this_toWritableProperty) {
    this.w30_1 = $this_toWritableProperty;
  }
  protoOf(toWritableProperty$1).x30 = function (newValue) {
    this.w30_1.k2();
    if (!(newValue == null)) {
      this.w30_1.j(newValue);
    }
  };
  protoOf(toWritableProperty$1).d2x = function (newValue) {
    return this.x30((newValue == null ? true : !(newValue == null)) ? newValue : THROW_CCE());
  };
  function notEmptyProp(_this__u8e3s4) {
    return not(isEmptyProp(_this__u8e3s4));
  }
  function asSingleItemCollectionProp(_this__u8e3s4) {
    var collection = _this__u8e3s4;
    // Inline function 'kotlin.check' call
    if (!(collection.p() <= 1)) {
      var message = 'Collection ' + toString_1(collection) + ' has more than one item';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    return new SingleItemCollectionProperty(collection);
  }
  function isEmptyProp(_this__u8e3s4) {
    return new isEmptyProp$1(_this__u8e3s4);
  }
  function isEmptyProp$1($this_isEmptyProp) {
    this.c31_1 = $this_isEmptyProp;
    SimpleCollectionProperty.call(this, $this_isEmptyProp);
  }
  protoOf(isEmptyProp$1).v2w = function () {
    return 'isEmpty(' + toString_1(this.c31_1) + ')';
  };
  protoOf(isEmptyProp$1).q2w = function () {
    return this.c31_1.s();
  };
  function _get_disposable__lofx05($this) {
    var tmp = $this.g31_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('disposable');
    }
  }
  function SimpleCollectionProperty$doAddListeners$listener$1(this$0) {
    this.h31_1 = this$0;
  }
  protoOf(SimpleCollectionProperty$doAddListeners$listener$1).m2r = function (event) {
    return this.h31_1.t2w();
  };
  protoOf(SimpleCollectionProperty$doAddListeners$listener$1).n2r = function (event) {
    return this.h31_1.t2w();
  };
  protoOf(SimpleCollectionProperty$doAddListeners$listener$1).t2r = function (event) {
    return this.h31_1.t2w();
  };
  function SimpleCollectionProperty(collection) {
    BaseDerivedProperty.call(this);
    this.f31_1 = collection;
  }
  protoOf(SimpleCollectionProperty).r2w = function () {
    var listener = new SimpleCollectionProperty$doAddListeners$listener$1(this);
    this.g31_1 = this.f31_1.x2r(listener);
  };
  protoOf(SimpleCollectionProperty).s2w = function () {
    return _get_disposable__lofx05(this).zr();
  };
  function SingleItemCollectionProperty$addHandler$listener$1(this$0, $handler) {
    this.i31_1 = this$0;
    this.j31_1 = $handler;
    CollectionAdapter.call(this);
  }
  protoOf(SingleItemCollectionProperty$addHandler$listener$1).m2r = function (event) {
    // Inline function 'kotlin.check' call
    if (!(this.i31_1.k31_1.p() === 1)) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    this.j31_1.n2s(new PropertyChangeEvent(null, event.u2r()));
  };
  protoOf(SingleItemCollectionProperty$addHandler$listener$1).n2r = function (event) {
    // Inline function 'kotlin.check' call
    if (!(event.q2r_1 === 0)) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    this.j31_1.n2s(new PropertyChangeEvent(event.s2r(), event.u2r()));
  };
  protoOf(SingleItemCollectionProperty$addHandler$listener$1).t2r = function (event) {
    // Inline function 'kotlin.check' call
    if (!this.i31_1.k31_1.s()) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    this.j31_1.n2s(new PropertyChangeEvent(event.s2r(), null));
  };
  function SingleItemCollectionProperty(collection) {
    this.k31_1 = collection;
  }
  protoOf(SingleItemCollectionProperty).v2w = function () {
    return 'SingleItemCollectionProperty(' + toString_1(this.k31_1) + ')';
  };
  protoOf(SingleItemCollectionProperty).uv = function () {
    return firstOrNull_0(this.k31_1);
  };
  protoOf(SingleItemCollectionProperty).l31 = function (newValue) {
    var current = this.uv();
    if (equals(current, newValue))
      return Unit_instance;
    this.k31_1.k2();
    if (!(newValue == null)) {
      this.k31_1.j(newValue);
    }
  };
  protoOf(SingleItemCollectionProperty).d2x = function (newValue) {
    return this.l31((newValue == null ? true : !(newValue == null)) ? newValue : THROW_CCE());
  };
  protoOf(SingleItemCollectionProperty).m31 = function (handler) {
    var listener = new SingleItemCollectionProperty$addHandler$listener$1(this, handler);
    return this.k31_1.x2r(listener);
  };
  protoOf(SingleItemCollectionProperty).y2r = function (handler) {
    return this.m31(handler);
  };
  function awaitNotNull(_this__u8e3s4, $completion) {
    var tmp = new $awaitNotNullCOROUTINE$(_this__u8e3s4, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  }
  function awaitValue_0(_this__u8e3s4, value, $completion) {
    var tmp = new $awaitValueCOROUTINE$(_this__u8e3s4, value, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  }
  function awaitMatching(_this__u8e3s4, predicate, $completion) {
    var tmp = new $awaitMatchingCOROUTINE$(_this__u8e3s4, predicate, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  }
  function awaitNotNull$lambda(it) {
    return !(it == null);
  }
  function awaitValue$lambda($value) {
    return function (it) {
      return equals(it, $value);
    };
  }
  function awaitMatching$lambda($predicate, $deferred) {
    return function (it) {
      var tmp;
      if ($predicate(it.t2y_1)) {
        $deferred.pu(it.t2y_1);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function $awaitNotNullCOROUTINE$(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.v31_1 = _this__u8e3s4;
  }
  protoOf($awaitNotNullCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = awaitMatching(this.v31_1, awaitNotNull$lambda, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            return ensureNotNull(ARGUMENT);
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function $awaitValueCOROUTINE$(_this__u8e3s4, value, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.e32_1 = _this__u8e3s4;
    this.f32_1 = value;
  }
  protoOf($awaitValueCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = awaitMatching(this.e32_1, awaitValue$lambda(this.f32_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function $awaitMatchingCOROUTINE$(_this__u8e3s4, predicate, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.o32_1 = _this__u8e3s4;
    this.p32_1 = predicate;
  }
  protoOf($awaitMatchingCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 8;
            var current = this.o32_1.uv();
            if (this.p32_1(current)) {
              return current;
            }

            this.s32_1 = CompletableDeferred();
            var tmp_0 = this;
            tmp_0.q32_1 = this.o32_1.z2r(awaitMatching$lambda(this.p32_1, this.s32_1));
            this.f9_1 = 1;
            continue $sm;
          case 1:
            this.f9_1 = 2;
            continue $sm;
          case 2:
            this.g9_1 = 7;
            var newCurrent = this.o32_1.uv();
            if (this.p32_1(newCurrent)) {
              this.r32_1 = newCurrent;
              this.g9_1 = 8;
              this.f9_1 = 5;
              continue $sm;
            } else {
              this.f9_1 = 3;
              continue $sm;
            }

          case 3:
            this.f9_1 = 4;
            suspendResult = this.s32_1.nr(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            this.r32_1 = suspendResult;
            this.g9_1 = 8;
            this.f9_1 = 5;
            var tmp_1 = this;
            continue $sm;
          case 5:
            var tmp_2 = this.r32_1;
            this.g9_1 = 8;
            this.q32_1.zr();
            return tmp_2;
          case 6:
            this.g9_1 = 8;
            this.q32_1.zr();
            return Unit_instance;
          case 7:
            this.g9_1 = 8;
            var t = this.i9_1;
            this.q32_1.zr();
            throw t;
          case 8:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 8) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function BaseTransformer() {
  }
  function IdentityHashMap$entries$1$iterator$1$next$1($entry) {
    this.v32_1 = $entry;
  }
  protoOf(IdentityHashMap$entries$1$iterator$1$next$1).z = function () {
    return this.v32_1.z().w32_1;
  };
  protoOf(IdentityHashMap$entries$1$iterator$1$next$1).a1 = function () {
    return this.v32_1.a1();
  };
  function IdentityHashMap$entries$1$iterator$1(this$0) {
    this.x32_1 = this$0.y32_1.y().m();
  }
  protoOf(IdentityHashMap$entries$1$iterator$1).n = function () {
    return this.x32_1.n();
  };
  protoOf(IdentityHashMap$entries$1$iterator$1).o = function () {
    var entry = this.x32_1.o();
    return new IdentityHashMap$entries$1$iterator$1$next$1(entry);
  };
  protoOf(IdentityHashMap$entries$1$iterator$1).h4 = function () {
    return this.x32_1.h4();
  };
  function IdentityHashMap$keys$1$iterator$1(this$0) {
    this.z32_1 = this$0.y32_1.r2().m();
  }
  protoOf(IdentityHashMap$keys$1$iterator$1).n = function () {
    return this.z32_1.n();
  };
  protoOf(IdentityHashMap$keys$1$iterator$1).o = function () {
    return this.z32_1.o().w32_1;
  };
  protoOf(IdentityHashMap$keys$1$iterator$1).h4 = function () {
    return this.z32_1.h4();
  };
  function mapEntry($this, element) {
    return new IdentityHashMap$mapEntry$1(element);
  }
  function IdentityHashMap$entries$1(this$0) {
    this.a33_1 = this$0;
  }
  protoOf(IdentityHashMap$entries$1).p = function () {
    return this.a33_1.y32_1.y().p();
  };
  protoOf(IdentityHashMap$entries$1).d2o = function (element) {
    return this.a33_1.y32_1.t2(new Wrapper(element.z()), element.a1()) == null;
  };
  protoOf(IdentityHashMap$entries$1).j = function (element) {
    return this.d2o((!(element == null) ? isInterface(element, MutableEntry) : false) ? element : THROW_CCE());
  };
  protoOf(IdentityHashMap$entries$1).b33 = function (elements) {
    var result = false;
    var _iterator__ex2g4s = elements.m();
    while (_iterator__ex2g4s.n()) {
      var e = _iterator__ex2g4s.o();
      result = result || this.d2o(e);
    }
    return result;
  };
  protoOf(IdentityHashMap$entries$1).q = function (elements) {
    return this.b33(elements);
  };
  protoOf(IdentityHashMap$entries$1).k2 = function () {
    return this.a33_1.y32_1.k2();
  };
  protoOf(IdentityHashMap$entries$1).e2o = function (element) {
    return this.a33_1.y32_1.y().t(mapEntry(this.a33_1, element));
  };
  protoOf(IdentityHashMap$entries$1).t = function (element) {
    if (!(!(element == null) ? isInterface(element, MutableEntry) : false))
      return false;
    return this.e2o((!(element == null) ? isInterface(element, MutableEntry) : false) ? element : THROW_CCE());
  };
  protoOf(IdentityHashMap$entries$1).c33 = function (elements) {
    var _iterator__ex2g4s = elements.m();
    while (_iterator__ex2g4s.n()) {
      var e = _iterator__ex2g4s.o();
      if (!this.e2o(e)) {
        return false;
      }
    }
    return true;
  };
  protoOf(IdentityHashMap$entries$1).e2 = function (elements) {
    return this.c33(elements);
  };
  protoOf(IdentityHashMap$entries$1).s = function () {
    return this.a33_1.y32_1.s();
  };
  protoOf(IdentityHashMap$entries$1).m = function () {
    return new IdentityHashMap$entries$1$iterator$1(this.a33_1);
  };
  protoOf(IdentityHashMap$entries$1).d33 = function (element) {
    return this.a33_1.y32_1.y().h2(mapEntry(this.a33_1, element));
  };
  protoOf(IdentityHashMap$entries$1).h2 = function (element) {
    if (!(!(element == null) ? isInterface(element, MutableEntry) : false))
      return false;
    return this.d33((!(element == null) ? isInterface(element, MutableEntry) : false) ? element : THROW_CCE());
  };
  protoOf(IdentityHashMap$entries$1).e33 = function (elements) {
    var tmp = this.a33_1.y32_1.y();
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(elements, 10));
    var _iterator__ex2g4s = elements.m();
    while (_iterator__ex2g4s.n()) {
      var item = _iterator__ex2g4s.o();
      var tmp$ret$0 = mapEntry(this.a33_1, item);
      destination.j(tmp$ret$0);
    }
    return tmp.j1(destination);
  };
  protoOf(IdentityHashMap$entries$1).j1 = function (elements) {
    return this.e33(elements);
  };
  protoOf(IdentityHashMap$entries$1).f33 = function (elements) {
    var tmp = this.a33_1.y32_1.y();
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(elements, 10));
    var _iterator__ex2g4s = elements.m();
    while (_iterator__ex2g4s.n()) {
      var item = _iterator__ex2g4s.o();
      var tmp$ret$0 = mapEntry(this.a33_1, item);
      destination.j(tmp$ret$0);
    }
    return tmp.j2(destination);
  };
  protoOf(IdentityHashMap$entries$1).j2 = function (elements) {
    return this.f33(elements);
  };
  function IdentityHashMap$mapEntry$1($element) {
    this.g33_1 = $element;
  }
  protoOf(IdentityHashMap$mapEntry$1).z = function () {
    return new Wrapper(this.g33_1.z());
  };
  protoOf(IdentityHashMap$mapEntry$1).a1 = function () {
    return this.g33_1.a1();
  };
  function IdentityHashMap$keys$1(this$0) {
    this.h33_1 = this$0;
  }
  protoOf(IdentityHashMap$keys$1).p = function () {
    return this.h33_1.y32_1.r2().p();
  };
  protoOf(IdentityHashMap$keys$1).t6 = function (element) {
    return this.h33_1.y32_1.r2().j(new Wrapper(element));
  };
  protoOf(IdentityHashMap$keys$1).j = function (element) {
    return this.t6((element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  protoOf(IdentityHashMap$keys$1).i33 = function (elements) {
    var tmp = this.h33_1.y32_1.r2();
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(elements, 10));
    var _iterator__ex2g4s = elements.m();
    while (_iterator__ex2g4s.n()) {
      var item = _iterator__ex2g4s.o();
      var tmp$ret$0 = new Wrapper(item);
      destination.j(tmp$ret$0);
    }
    return tmp.q(destination);
  };
  protoOf(IdentityHashMap$keys$1).q = function (elements) {
    return this.i33(elements);
  };
  protoOf(IdentityHashMap$keys$1).k2 = function () {
    return this.h33_1.y32_1.r2().k2();
  };
  protoOf(IdentityHashMap$keys$1).w5 = function (element) {
    return this.h33_1.y32_1.r2().t(new Wrapper(element));
  };
  protoOf(IdentityHashMap$keys$1).t = function (element) {
    if (!(element == null ? true : !(element == null)))
      return false;
    return this.w5((element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  protoOf(IdentityHashMap$keys$1).j33 = function (elements) {
    var tmp = this.h33_1.y32_1.r2();
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(elements, 10));
    var _iterator__ex2g4s = elements.m();
    while (_iterator__ex2g4s.n()) {
      var item = _iterator__ex2g4s.o();
      var tmp$ret$0 = new Wrapper(item);
      destination.j(tmp$ret$0);
    }
    return tmp.e2(destination);
  };
  protoOf(IdentityHashMap$keys$1).e2 = function (elements) {
    return this.j33(elements);
  };
  protoOf(IdentityHashMap$keys$1).s = function () {
    return this.h33_1.y32_1.r2().s();
  };
  protoOf(IdentityHashMap$keys$1).m = function () {
    return new IdentityHashMap$keys$1$iterator$1(this.h33_1);
  };
  protoOf(IdentityHashMap$keys$1).u2 = function (element) {
    return this.h33_1.y32_1.r2().h2(new Wrapper(element));
  };
  protoOf(IdentityHashMap$keys$1).h2 = function (element) {
    if (!(element == null ? true : !(element == null)))
      return false;
    return this.u2((element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  protoOf(IdentityHashMap$keys$1).k33 = function (elements) {
    var tmp = this.h33_1.y32_1.r2();
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(elements, 10));
    var _iterator__ex2g4s = elements.m();
    while (_iterator__ex2g4s.n()) {
      var item = _iterator__ex2g4s.o();
      var tmp$ret$0 = new Wrapper(item);
      destination.j(tmp$ret$0);
    }
    return tmp.j1(destination);
  };
  protoOf(IdentityHashMap$keys$1).j1 = function (elements) {
    return this.k33(elements);
  };
  protoOf(IdentityHashMap$keys$1).l33 = function (elements) {
    var tmp = this.h33_1.y32_1.r2();
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(elements, 10));
    var _iterator__ex2g4s = elements.m();
    while (_iterator__ex2g4s.n()) {
      var item = _iterator__ex2g4s.o();
      var tmp$ret$0 = new Wrapper(item);
      destination.j(tmp$ret$0);
    }
    return tmp.j2(destination);
  };
  protoOf(IdentityHashMap$keys$1).j2 = function (elements) {
    return this.l33(elements);
  };
  function IdentityHashMap() {
    this.y32_1 = HashMap_init_$Create$();
  }
  protoOf(IdentityHashMap).p = function () {
    return this.y32_1.p();
  };
  protoOf(IdentityHashMap).o2 = function (key) {
    return this.y32_1.o2(new Wrapper(key));
  };
  protoOf(IdentityHashMap).p2 = function (value) {
    return this.y32_1.p2(value);
  };
  protoOf(IdentityHashMap).q2 = function (key) {
    return this.y32_1.q2(new Wrapper(key));
  };
  protoOf(IdentityHashMap).s = function () {
    return this.y32_1.s();
  };
  protoOf(IdentityHashMap).y = function () {
    return new IdentityHashMap$entries$1(this);
  };
  protoOf(IdentityHashMap).r2 = function () {
    return new IdentityHashMap$keys$1(this);
  };
  protoOf(IdentityHashMap).s2 = function () {
    return this.y32_1.s2();
  };
  protoOf(IdentityHashMap).k2 = function () {
    this.y32_1.k2();
  };
  protoOf(IdentityHashMap).t2 = function (key, value) {
    return this.y32_1.t2(new Wrapper(key), value);
  };
  protoOf(IdentityHashMap).v2 = function (from) {
    throw UnsupportedOperationException_init_$Create$();
  };
  protoOf(IdentityHashMap).u2 = function (key) {
    return this.y32_1.u2(new Wrapper(key));
  };
  function Wrapper(value) {
    this.w32_1 = value;
  }
  protoOf(Wrapper).equals = function (other) {
    if (other instanceof Wrapper) {
      return other.w32_1 === this.w32_1;
    }
    return false;
  };
  protoOf(Wrapper).hashCode = function () {
    return 0;
  };
  function SimpleTransformation(source, target, disposable) {
    Transformation.call(this);
    this.n33_1 = source;
    this.o33_1 = target;
    this.p33_1 = disposable;
  }
  protoOf(SimpleTransformation).q33 = function () {
    return this.o33_1;
  };
  protoOf(SimpleTransformation).r33 = function () {
    return this.p33_1.zr();
  };
  function TerminalTransformation() {
    this.s33_1 = false;
  }
  protoOf(TerminalTransformation).zr = function () {
    // Inline function 'kotlin.check' call
    if (!!this.s33_1) {
      var message = 'Already disposed';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    this.s33_1 = true;
    this.r33();
  };
  protoOf(TerminalTransformation).r33 = function () {
  };
  function Transformation() {
    TerminalTransformation.call(this);
  }
  function Transformers$fromFun$1$transform$1($from, $target) {
    this.u33_1 = $from;
    this.v33_1 = $target;
    Transformation.call(this);
  }
  protoOf(Transformers$fromFun$1$transform$1).q33 = function () {
    return this.v33_1;
  };
  function Transformers$listMap$1$transform$listener$1($transformer, $to, $itemRegistrations) {
    this.w33_1 = $transformer;
    this.x33_1 = $to;
    this.y33_1 = $itemRegistrations;
  }
  protoOf(Transformers$listMap$1$transform$listener$1).z33 = function (event) {
    var transformation = this.w33_1.t32(event.u2r());
    this.x33_1.m2(event.q2r_1, transformation.q33());
    this.y33_1.m2(event.q2r_1, transformation);
  };
  protoOf(Transformers$listMap$1$transform$listener$1).m2r = function (event) {
    return this.z33(event);
  };
  protoOf(Transformers$listMap$1$transform$listener$1).a34 = function (event) {
    var transformation = this.w33_1.t32(event.u2r());
    this.x33_1.l2(event.q2r_1, transformation.q33());
    this.y33_1.l2(event.q2r_1, transformation).zr();
  };
  protoOf(Transformers$listMap$1$transform$listener$1).n2r = function (event) {
    return this.a34(event);
  };
  protoOf(Transformers$listMap$1$transform$listener$1).b34 = function (event) {
    this.x33_1.n2(event.q2r_1);
    this.y33_1.n2(event.q2r_1).zr();
  };
  protoOf(Transformers$listMap$1$transform$listener$1).t2r = function (event) {
    return this.b34(event);
  };
  function Transformers$listMap$1$transform$$inlined$toDisposable$1($itemRegistrations, $reg) {
    this.c34_1 = $itemRegistrations;
    this.d34_1 = $reg;
  }
  protoOf(Transformers$listMap$1$transform$$inlined$toDisposable$1).zr = function () {
    var _iterator__ex2g4s = this.c34_1.m();
    while (_iterator__ex2g4s.n()) {
      var r = _iterator__ex2g4s.o();
      r.zr();
    }
    this.d34_1.zr();
    return Unit_instance;
  };
  function watch($this, container, list) {
    return list.x2r(new Transformers$flattenList$5$transform$sourceListener$1$watch$1($this.g34_1, container, $this.h34_1, $this.i34_1, $this.k34_1));
  }
  function Transformers$flattenList$5$transform$sourceListener$1$watch$1(this$0, $container, $from, $sizes, $to) {
    this.l34_1 = this$0;
    this.m34_1 = $container;
    this.n34_1 = $from;
    this.o34_1 = $sizes;
    this.p34_1 = $to;
  }
  protoOf(Transformers$flattenList$5$transform$sourceListener$1$watch$1).m2r = function (event) {
    var startIndex = getStartResultIndex(this.l34_1, this.m34_1, this.n34_1, this.o34_1);
    var tmp0 = this.o34_1;
    var tmp2 = this.m34_1;
    // Inline function 'kotlin.collections.set' call
    var value = ensureNotNull(this.o34_1.q2(this.m34_1)) + 1 | 0;
    tmp0.t2(tmp2, value);
    this.p34_1.m2(startIndex + event.q2r_1 | 0, event.u2r());
  };
  protoOf(Transformers$flattenList$5$transform$sourceListener$1$watch$1).n2r = function (event) {
    var startIndex = getStartResultIndex(this.l34_1, this.m34_1, this.n34_1, this.o34_1);
    this.p34_1.l2(startIndex + event.q2r_1 | 0, event.u2r());
  };
  protoOf(Transformers$flattenList$5$transform$sourceListener$1$watch$1).t2r = function (event) {
    var tmp0 = this.o34_1;
    var tmp2 = this.m34_1;
    // Inline function 'kotlin.collections.set' call
    var value = ensureNotNull(this.o34_1.q2(this.m34_1)) - 1 | 0;
    tmp0.t2(tmp2, value);
    this.p34_1.h2(event.s2r());
  };
  function getStartResultIndex($this, event, sourceList, sizes) {
    var resultIndex = 0;
    var iterator = sourceList.m();
    var current = iterator.o();
    while (!(current === event)) {
      resultIndex = resultIndex + getValue_0(sizes, current) | 0;
      current = iterator.o();
    }
    return resultIndex;
  }
  function Transformers$flattenList$5$transform$sourceListener$1($f, $t, this$0, $from, $sizes, $registrations, $to) {
    this.e34_1 = $f;
    this.f34_1 = $t;
    this.g34_1 = this$0;
    this.h34_1 = $from;
    this.i34_1 = $sizes;
    this.j34_1 = $registrations;
    this.k34_1 = $to;
    CollectionAdapter.call(this);
  }
  protoOf(Transformers$flattenList$5$transform$sourceListener$1).z33 = function (event) {
    var selected = this.e34_1(event.u2r());
    var transform = this.f34_1.t32(selected);
    var target = transform.q33();
    var startIndex = getStartResultIndex(this.g34_1, event.u2r(), this.h34_1, this.i34_1);
    var tmp0 = this.i34_1;
    var tmp2 = event.u2r();
    // Inline function 'kotlin.collections.set' call
    var value = target.p();
    tmp0.t2(tmp2, value);
    var reg = watch(this, event.u2r(), target);
    var tmp0_0 = this.j34_1;
    var tmp2_0 = event.u2r();
    // Inline function 'kotlin.collections.set' call
    var value_0 = reg.j2l(transform);
    tmp0_0.t2(tmp2_0, value_0);
    var _iterator__ex2g4s = target.m();
    while (_iterator__ex2g4s.n()) {
      var r = _iterator__ex2g4s.o();
      var _unary__edvuaz = startIndex;
      startIndex = _unary__edvuaz + 1 | 0;
      this.k34_1.m2(_unary__edvuaz, r);
    }
  };
  protoOf(Transformers$flattenList$5$transform$sourceListener$1).m2r = function (event) {
    return this.z33(event);
  };
  protoOf(Transformers$flattenList$5$transform$sourceListener$1).b34 = function (event) {
    var selected = this.e34_1(event.s2r());
    var transformation = this.f34_1.t32(selected);
    this.i34_1.u2(event.s2r());
    ensureNotNull(this.j34_1.u2(event.s2r())).zr();
    this.k34_1.j1(transformation.q33());
    transformation.zr();
  };
  protoOf(Transformers$flattenList$5$transform$sourceListener$1).t2r = function (event) {
    return this.b34(event);
  };
  function Transformers$flattenList$5$transform$$inlined$toDisposable$1($from, $registrations, $sourceRegistration) {
    this.q34_1 = $from;
    this.r34_1 = $registrations;
    this.s34_1 = $sourceRegistration;
  }
  protoOf(Transformers$flattenList$5$transform$$inlined$toDisposable$1).zr = function () {
    var _iterator__ex2g4s = this.q34_1.m();
    while (_iterator__ex2g4s.n()) {
      var s = _iterator__ex2g4s.o();
      ensureNotNull(this.r34_1.u2(s)).zr();
    }
    this.s34_1.zr();
    return Unit_instance;
  };
  function Transformers$withPlaceHoldersIfEmpty$1$transform$fromRegistration$1($from, $placeholder, $to) {
    this.u34_1 = $placeholder;
    this.v34_1 = $to;
    CollectionAdapter.call(this);
    this.t34_1 = null;
    if ($from.s()) {
      this.t34_1 = $placeholder();
      $to.j(ensureNotNull(this.t34_1));
    }
  }
  protoOf(Transformers$withPlaceHoldersIfEmpty$1$transform$fromRegistration$1).m2r = function (event) {
    if (!(this.t34_1 == null)) {
      this.v34_1.h2(ensureNotNull(this.t34_1));
      this.t34_1 = null;
    }
    this.v34_1.m2(event.q2r_1, event.u2r());
  };
  protoOf(Transformers$withPlaceHoldersIfEmpty$1$transform$fromRegistration$1).n2r = function (event) {
    // Inline function 'kotlin.check' call
    if (!(this.t34_1 == null)) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    this.v34_1.l2(event.q2r_1, event.u2r());
  };
  protoOf(Transformers$withPlaceHoldersIfEmpty$1$transform$fromRegistration$1).t2r = function (event) {
    this.v34_1.n2(event.q2r_1);
    if (this.v34_1.s()) {
      // Inline function 'kotlin.check' call
      if (!(this.t34_1 == null)) {
        throw IllegalStateException_init_$Create$_0('Check failed.');
      }
      this.t34_1 = this.u34_1();
      this.v34_1.j(ensureNotNull(this.t34_1));
    }
  };
  function Transformers$propertyToList$o$transform$o($to, $from) {
    return function () {
      var tmp;
      if (!$to.s() && $from.uv() === $to.r(0)) {
        return Unit_instance;
      }
      $to.k2();
      var tmp_0;
      if (!($from.uv() == null)) {
        $to.j(ensureNotNull($from.uv()));
        tmp_0 = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function Transformers$propertyToList$o$transform$lambda($sync) {
    return function (it) {
      $sync();
      return Unit_instance;
    };
  }
  function flattenList($this, f, t) {
    return new Transformers$flattenList$5(f, t);
  }
  function Transformers$fromFun$1($f) {
    this.w34_1 = $f;
    BaseTransformer.call(this);
  }
  protoOf(Transformers$fromFun$1).t32 = function (from) {
    var target = this.w34_1(from);
    return new Transformers$fromFun$1$transform$1(from, target);
  };
  protoOf(Transformers$fromFun$1).u32 = function (from, to) {
    throw UnsupportedOperationException_init_$Create$();
  };
  function Transformers$listMap$1($transformer) {
    this.x34_1 = $transformer;
    BaseTransformer.call(this);
  }
  protoOf(Transformers$listMap$1).y34 = function (from) {
    return this.z34(from, new ObservableArrayList());
  };
  protoOf(Transformers$listMap$1).t32 = function (from) {
    return this.y34((!(from == null) ? isInterface(from, ObservableList) : false) ? from : THROW_CCE());
  };
  protoOf(Transformers$listMap$1).z34 = function (from, to) {
    var itemRegistrations = ArrayList_init_$Create$();
    var listener = new Transformers$listMap$1$transform$listener$1(this.x34_1, to, itemRegistrations);
    var inductionVariable = 0;
    var last = from.p() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        listener.z33(new CollectionItemEvent(null, from.r(i), i, EventType_ADD_getInstance()));
      }
       while (inductionVariable <= last);
    var reg = from.x2r(listener);
    // Inline function 'jetbrains.ocelot.base.disposable.toDisposable' call
    var tmp$ret$0 = new Transformers$listMap$1$transform$$inlined$toDisposable$1(itemRegistrations, reg);
    return new SimpleTransformation(from, to, tmp$ret$0);
  };
  protoOf(Transformers$listMap$1).u32 = function (from, to) {
    var tmp = (!(from == null) ? isInterface(from, ObservableList) : false) ? from : THROW_CCE();
    return this.z34(tmp, (!(to == null) ? isInterface(to, MutableObservableList) : false) ? to : THROW_CCE());
  };
  function Transformers$flattenList$lambda(it) {
    return it;
  }
  function Transformers$flattenList$5($f, $t) {
    this.a35_1 = $f;
    this.b35_1 = $t;
    BaseTransformer.call(this);
  }
  protoOf(Transformers$flattenList$5).y34 = function (from) {
    return this.c35(from, new ObservableArrayList());
  };
  protoOf(Transformers$flattenList$5).t32 = function (from) {
    return this.y34((!(from == null) ? isInterface(from, ObservableList) : false) ? from : THROW_CCE());
  };
  protoOf(Transformers$flattenList$5).c35 = function (from, to) {
    var registrations = new IdentityHashMap();
    var sizes = new IdentityHashMap();
    var sourceListener = new Transformers$flattenList$5$transform$sourceListener$1(this.a35_1, this.b35_1, this, from, sizes, registrations, to);
    var sourceRegistration = from.x2r(sourceListener);
    var iterator = from.m();
    var index = 0;
    while (iterator.n()) {
      var index_0 = index;
      index = index + 1 | 0;
      var s = iterator.o();
      var event = new CollectionItemEvent(null, s, index_0, EventType_ADD_getInstance());
      sourceListener.z33(event);
    }
    // Inline function 'jetbrains.ocelot.base.disposable.toDisposable' call
    var tmp$ret$0 = new Transformers$flattenList$5$transform$$inlined$toDisposable$1(from, registrations, sourceRegistration);
    return new SimpleTransformation(from, to, tmp$ret$0);
  };
  protoOf(Transformers$flattenList$5).u32 = function (from, to) {
    var tmp = (!(from == null) ? isInterface(from, ObservableList) : false) ? from : THROW_CCE();
    return this.c35(tmp, (!(to == null) ? isInterface(to, MutableObservableList) : false) ? to : THROW_CCE());
  };
  function Transformers$withPlaceHoldersIfEmpty$1($placeholder) {
    this.d35_1 = $placeholder;
    BaseTransformer.call(this);
  }
  protoOf(Transformers$withPlaceHoldersIfEmpty$1).e35 = function (from) {
    return this.f35(from, ArrayList_init_$Create$());
  };
  protoOf(Transformers$withPlaceHoldersIfEmpty$1).t32 = function (from) {
    return this.e35((!(from == null) ? isInterface(from, ObservableList) : false) ? from : THROW_CCE());
  };
  protoOf(Transformers$withPlaceHoldersIfEmpty$1).f35 = function (from, to) {
    var fromRegistration = from.x2r(new Transformers$withPlaceHoldersIfEmpty$1$transform$fromRegistration$1(from, this.d35_1, to));
    return new SimpleTransformation(from, to, fromRegistration);
  };
  protoOf(Transformers$withPlaceHoldersIfEmpty$1).u32 = function (from, to) {
    var tmp = (!(from == null) ? isInterface(from, ObservableList) : false) ? from : THROW_CCE();
    return this.f35(tmp, (!(to == null) ? isInterface(to, KtMutableList) : false) ? to : THROW_CCE());
  };
  function Transformers$propertyToList$1() {
    BaseTransformer.call(this);
  }
  protoOf(Transformers$propertyToList$1).g35 = function (from) {
    return this.h35(from, new ObservableArrayList());
  };
  protoOf(Transformers$propertyToList$1).t32 = function (from) {
    return this.g35((!(from == null) ? isInterface(from, ReadableProperty) : false) ? from : THROW_CCE());
  };
  protoOf(Transformers$propertyToList$1).h35 = function (from, to) {
    // Inline function 'kotlin.check' call
    if (!to.s()) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    var sync = Transformers$propertyToList$o$transform$o(to, from);
    sync();
    return new SimpleTransformation(from, to, from.z2r(Transformers$propertyToList$o$transform$lambda(sync)));
  };
  protoOf(Transformers$propertyToList$1).u32 = function (from, to) {
    var tmp = (!(from == null) ? isInterface(from, ReadableProperty) : false) ? from : THROW_CCE();
    return this.h35(tmp, (!(to == null) ? isInterface(to, MutableObservableList) : false) ? to : THROW_CCE());
  };
  function Transformers() {
  }
  protoOf(Transformers).i35 = function (f) {
    return new Transformers$fromFun$1(f);
  };
  protoOf(Transformers).j35 = function (transformer) {
    return new Transformers$listMap$1(transformer);
  };
  protoOf(Transformers).k35 = function (f) {
    return this.j35(this.i35(f));
  };
  protoOf(Transformers).l35 = function (t) {
    return flattenList(this, Transformers$flattenList$lambda, t);
  };
  protoOf(Transformers).m35 = function (placeholder) {
    return new Transformers$withPlaceHoldersIfEmpty$1(placeholder);
  };
  protoOf(Transformers).n35 = function () {
    return new Transformers$propertyToList$1();
  };
  var Transformers_instance;
  function Transformers_getInstance() {
    return Transformers_instance;
  }
  function ancestors(_this__u8e3s4) {
    return generateSequenceFromNext(_this__u8e3s4, VOID, ancestors$lambda);
  }
  function isDescendant(_this__u8e3s4, current) {
    var tmp0 = ancestorsFrom(current);
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.sequences.any' call
      var _iterator__ex2g4s = tmp0.m();
      while (_iterator__ex2g4s.n()) {
        var element = _iterator__ex2g4s.o();
        if (equals(element, _this__u8e3s4)) {
          tmp$ret$1 = true;
          break $l$block;
        }
      }
      tmp$ret$1 = false;
    }
    return tmp$ret$1;
  }
  function ancestorsFrom(_this__u8e3s4) {
    return generateSequence(_this__u8e3s4, ancestorsFrom$lambda);
  }
  function root(_this__u8e3s4) {
    return last_1(ancestorsFrom(_this__u8e3s4));
  }
  function reverseAncestors(_this__u8e3s4) {
    return asReversed_0(toList_2(ancestorsFrom(_this__u8e3s4)));
  }
  function ancestors$lambda(node) {
    return node.bp();
  }
  function ancestorsFrom$lambda(node) {
    return node.bp();
  }
  function Composite() {
  }
  function get_descendants(_this__u8e3s4) {
    var tmp = _this__u8e3s4.o35();
    // Inline function 'kotlin.collections.flatMap' call
    var tmp0 = _this__u8e3s4.o35();
    // Inline function 'kotlin.collections.flatMapTo' call
    var destination = ArrayList_init_$Create$();
    var _iterator__ex2g4s = tmp0.m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      var list = get_descendants(element);
      addAll_1(destination, list);
    }
    return plus_5(tmp, destination);
  }
  function get_descendantsFrom(_this__u8e3s4) {
    return plus_9(sequenceOf([_this__u8e3s4]), asSequence_0(get_descendants(_this__u8e3s4)));
  }
  function nextNavOrder($this, start, current) {
    var $this_0 = $this;
    var start_0 = start;
    var current_0 = current;
    $l$1: do {
      $l$0: do {
        var nextSibling = current_0.p35();
        if (!(nextSibling == null)) {
          return $this_0.q35(nextSibling);
        }
        if ($this_0.r35(current_0))
          return null;
        var parent = current_0.bp();
        var tmp;
        if (isDescendant(parent, start_0)) {
          var tmp0 = $this_0;
          var tmp1 = start_0;
          var tmp2 = ensureNotNull(parent);
          $this_0 = tmp0;
          start_0 = tmp1;
          current_0 = tmp2;
          continue $l$0;
        } else {
          tmp = parent;
        }
        return tmp;
      }
       while (false);
    }
     while (true);
  }
  function prevNavOrder($this, start, current) {
    var $this_0 = $this;
    var start_0 = start;
    var current_0 = current;
    $l$1: do {
      $l$0: do {
        var prevSibling = current_0.s35();
        if (!(prevSibling == null)) {
          return $this_0.t35(prevSibling);
        }
        if ($this_0.r35(current_0))
          return null;
        var parent = current_0.bp();
        var tmp;
        if (isDescendant(parent, start_0)) {
          var tmp0 = $this_0;
          var tmp1 = start_0;
          var tmp2 = ensureNotNull(parent);
          $this_0 = tmp0;
          start_0 = tmp1;
          current_0 = tmp2;
          continue $l$0;
        } else {
          tmp = parent;
        }
        return tmp;
      }
       while (false);
    }
     while (true);
  }
  function Composites$nextLeaves$lambda(composite) {
    return Composites_instance.u35(composite);
  }
  function Composites$prevLeaves$lambda(composite) {
    return Composites_instance.v35(composite);
  }
  function Composites$nextNavOrder$lambda($current) {
    return function (composite) {
      return nextNavOrder(Composites_instance, $current, composite);
    };
  }
  function Composites$prevNavOrder$lambda($current) {
    return function (composite) {
      return prevNavOrder(Composites_instance, $current, composite);
    };
  }
  function Composites() {
  }
  protoOf(Composites).r35 = function (composite) {
    var parent = composite.bp();
    var tmp;
    if (parent == null || !(composite.p35() == null) || !(composite.s35() == null)) {
      tmp = false;
    } else {
      var children = parent.o35();
      tmp = !(children.p() === 1) || !equals(children.r(0), composite);
    }
    return tmp;
  };
  protoOf(Composites).w35 = function (composite) {
    var parent = composite.bp();
    var tmp;
    if (parent == null) {
      tmp = null;
    } else {
      var children = parent.o35();
      var index = children.w(composite);
      tmp = getOrNull_0(children, index + 1 | 0);
    }
    return tmp;
  };
  protoOf(Composites).x35 = function (composite) {
    var parent = composite.bp();
    var tmp;
    if (parent == null) {
      tmp = null;
    } else {
      var children = parent.o35();
      var index = children.w(composite);
      tmp = getOrNull_0(children, index - 1 | 0);
    }
    return tmp;
  };
  protoOf(Composites).q35 = function (composite) {
    var $this = this;
    var composite_0 = composite;
    $l$1: do {
      $l$0: do {
        var first = composite_0.y35();
        var tmp;
        if (first == null) {
          tmp = composite_0;
        } else {
          $this = $this;
          composite_0 = first;
          continue $l$0;
        }
        return tmp;
      }
       while (false);
    }
     while (true);
  };
  protoOf(Composites).t35 = function (composite) {
    var $this = this;
    var composite_0 = composite;
    $l$1: do {
      $l$0: do {
        var last = composite_0.z35();
        var tmp;
        if (last == null) {
          tmp = composite_0;
        } else {
          $this = $this;
          composite_0 = last;
          continue $l$0;
        }
        return tmp;
      }
       while (false);
    }
     while (true);
  };
  protoOf(Composites).u35 = function (composite) {
    return this.a36(composite, null);
  };
  protoOf(Composites).a36 = function (composite, within) {
    var current = composite;
    while (true) {
      var nextSibling = current.p35();
      if (!(nextSibling == null)) {
        return this.q35(nextSibling);
      }
      if (this.r35(current))
        return null;
      var parent = current.bp();
      if (equals(parent, within))
        return null;
      current = ensureNotNull(parent);
    }
  };
  protoOf(Composites).v35 = function (composite) {
    return this.b36(composite, null);
  };
  protoOf(Composites).b36 = function (composite, within) {
    var current = composite;
    while (true) {
      var prevSibling = current.s35();
      if (!(prevSibling == null)) {
        return this.t35(prevSibling);
      }
      if (this.r35(current))
        return null;
      var parent = current.bp();
      if (equals(parent, within))
        return null;
      current = ensureNotNull(parent);
    }
  };
  protoOf(Composites).c36 = function (current) {
    return generateSequenceFromNext(current, VOID, Composites$nextLeaves$lambda);
  };
  protoOf(Composites).d36 = function (current) {
    return generateSequenceFromNext(current, VOID, Composites$prevLeaves$lambda);
  };
  protoOf(Composites).e36 = function (current, fromNext) {
    return generateSequenceFromNext(current, fromNext, Composites$nextNavOrder$lambda(current));
  };
  protoOf(Composites).f36 = function (current, fromNext, $super) {
    fromNext = fromNext === VOID ? true : fromNext;
    return $super === VOID ? this.e36(current, fromNext) : $super.e36.call(this, current, fromNext);
  };
  protoOf(Composites).g36 = function (current) {
    return generateSequenceFromNext(current, VOID, Composites$prevNavOrder$lambda(current));
  };
  protoOf(Composites).h36 = function (c1, c2) {
    if (equals(c1, c2))
      return false;
    var c1a = reverseAncestors(c1);
    var c2a = reverseAncestors(c2);
    // Inline function 'kotlin.require' call
    if (!equals(c1a.r(0), c2a.r(0))) {
      var message = 'Items are in different trees';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    var tmp0 = c1a.p();
    // Inline function 'kotlin.math.min' call
    var b = c2a.p();
    var commonLength = Math.min(tmp0, b);
    var inductionVariable = 1;
    if (inductionVariable < commonLength)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var first = c1a.r(i);
        var second = c2a.r(i);
        if (!equals(first, second)) {
          return this.i36(first, second) > 0;
        }
      }
       while (inductionVariable < commonLength);
    throw IllegalArgumentException_init_$Create$_0('One parameter is an ancestor of the other');
  };
  protoOf(Composites).i36 = function (c1, c2) {
    var left = c1;
    var right = c1;
    var delta = 0;
    while (true) {
      if (equals(left, c2)) {
        return -delta | 0;
      }
      if (equals(right, c2)) {
        return delta;
      }
      delta = delta + 1 | 0;
      // Inline function 'kotlin.check' call
      if (!(!(left == null) || !(right == null))) {
        var message = 'Both left and right are null';
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      }
      if (!(left == null)) {
        left = left.s35();
      }
      if (!(right == null)) {
        right = right.p35();
      }
    }
  };
  var Composites_instance;
  function Composites_getInstance() {
    return Composites_instance;
  }
  function generateSequenceFromNext(initial, fromNext, nextFunction) {
    fromNext = fromNext === VOID ? true : fromNext;
    var seed = fromNext ? nextFunction(initial) : initial;
    return generateSequence(seed, nextFunction);
  }
  function Companion_36() {
    Companion_instance_36 = this;
    this.j36_1 = new IdNames();
  }
  protoOf(Companion_36).k36 = function () {
    return IdGenerator_getInstance().p36();
  };
  var Companion_instance_36;
  function Companion_getInstance_36() {
    if (Companion_instance_36 == null)
      new Companion_36();
    return Companion_instance_36;
  }
  function BaseId(id, name) {
    Companion_getInstance_36();
    id = id === VOID ? Companion_getInstance_36().k36() : id;
    name = name === VOID ? null : name;
    this.q36_1 = id;
    // Inline function 'kotlin.text.isNotEmpty' call
    var this_0 = this.q36_1;
    // Inline function 'kotlin.require' call
    if (!(charSequenceLength(this_0) > 0)) {
      var message = "id='" + this.q36_1 + "'";
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    if (!(name == null)) {
      Companion_getInstance_36().j36_1.s36(this.q36_1, name);
    }
  }
  protoOf(BaseId).y2 = function () {
    return Companion_getInstance_36().j36_1.ld(this.q36_1);
  };
  protoOf(BaseId).equals = function (other) {
    if (other == null)
      return false;
    if (!getKClassFromExpression(other).equals(getKClassFromExpression(this)))
      return false;
    var otherId = other instanceof BaseId ? other : THROW_CCE();
    return this.q36_1 === ensureNotNull(otherId).q36_1;
  };
  protoOf(BaseId).hashCode = function () {
    return getStringHashCode(this.q36_1);
  };
  protoOf(BaseId).toString = function () {
    return this.y2() == null ? this.q36_1 : '' + this.y2() + ' [' + this.q36_1 + ']';
  };
  function nextBase62RandomId($this, length) {
    var chars = charArray(length);
    var nBits = 0;
    var bits = 0;
    var i = 0;
    while (i < chars.length) {
      if (nBits < 6) {
        nBits = 32;
        bits = $this.o36_1.rg();
      }
      var idx = bits & 63;
      bits = bits >> 6;
      nBits = nBits - 6 | 0;
      if (idx < 62) {
        var _unary__edvuaz = i;
        i = _unary__edvuaz + 1 | 0;
        chars[_unary__edvuaz] = toChar($this, idx);
      }
    }
    return concatToString(chars);
  }
  function toChar($this, x) {
    var k = x + getShift($this, x) | 0;
    return numberToChar(k);
  }
  function getShift($this, x) {
    return x < 10 ? 48 : x < 36 ? 87 : 29;
  }
  function IdGenerator() {
    IdGenerator_instance = this;
    this.l36_1 = 48;
    this.m36_1 = 87;
    this.n36_1 = 29;
    this.o36_1 = Default_getInstance();
  }
  protoOf(IdGenerator).p36 = function () {
    return nextBase62RandomId(this, 22);
  };
  var IdGenerator_instance;
  function IdGenerator_getInstance() {
    if (IdGenerator_instance == null)
      new IdGenerator();
    return IdGenerator_instance;
  }
  function IdNames() {
    this.r36_1 = newConcurrentHashMap();
  }
  protoOf(IdNames).s36 = function (id, name) {
    // Inline function 'kotlin.collections.getOrPut' call
    var this_0 = this.r36_1;
    var value = this_0.q2(id);
    var tmp;
    if (value == null) {
      var answer = name;
      this_0.t2(id, answer);
      tmp = answer;
    } else {
      tmp = value;
    }
    var oldName = tmp;
    // Inline function 'kotlin.check' call
    if (!(oldName === name)) {
      var message = 'Different name for known id ' + id + ', first name = ' + oldName + ', name = ' + name + ']';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
  };
  protoOf(IdNames).ld = function (id) {
    return this.r36_1.q2(id);
  };
  function areBoundsGood($this, lowerBound, upperBound) {
    return (lowerBound - 1 | 0) <= upperBound;
  }
  function Interval$reverseIterable$1$iterator$1(this$0) {
    this.u36_1 = this$0;
    this.t36_1 = this$0.w36_1;
  }
  protoOf(Interval$reverseIterable$1$iterator$1).n = function () {
    return this.u36_1.v36_1 <= this.t36_1;
  };
  protoOf(Interval$reverseIterable$1$iterator$1).o = function () {
    var _unary__edvuaz = this.t36_1;
    this.t36_1 = _unary__edvuaz - 1 | 0;
    return _unary__edvuaz;
  };
  function createIntervalForIntersection($this, lowerBound, upperBound, other) {
    // Inline function 'kotlin.require' call
    if (!areBoundsGood(Companion_instance_37, lowerBound, upperBound)) {
      var message = 'Ranges are not connected: this=' + $this.toString() + ' other=' + other.toString();
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    return new Interval(lowerBound, upperBound);
  }
  function Companion_37() {
  }
  protoOf(Companion_37).x36 = function (lowerBound, length) {
    return new Interval(lowerBound, lowerBound + length | 0);
  };
  protoOf(Companion_37).y36 = function (lowerBound, upperExclusive) {
    return new Interval(lowerBound, upperExclusive - 1 | 0);
  };
  protoOf(Companion_37).z36 = function (lowerBound, length) {
    return this.y36(lowerBound, lowerBound + length | 0);
  };
  protoOf(Companion_37).a37 = function (bound) {
    return new Interval(bound, bound);
  };
  var Companion_instance_37;
  function Companion_getInstance_37() {
    return Companion_instance_37;
  }
  function Interval$iterable$1(this$0) {
    this.b37_1 = this$0;
  }
  protoOf(Interval$iterable$1).m = function () {
    return this.b37_1.m();
  };
  function Interval$reverseIterable$1(this$0) {
    this.c37_1 = this$0;
  }
  protoOf(Interval$reverseIterable$1).m = function () {
    return new Interval$reverseIterable$1$iterator$1(this.c37_1);
  };
  function Interval$iterator$1(this$0) {
    this.e37_1 = this$0;
    this.d37_1 = this$0.v36_1;
  }
  protoOf(Interval$iterator$1).n = function () {
    return this.d37_1 < this.e37_1.f37();
  };
  protoOf(Interval$iterator$1).o = function () {
    var _unary__edvuaz = this.d37_1;
    this.d37_1 = _unary__edvuaz + 1 | 0;
    return _unary__edvuaz;
  };
  function Interval(lowerBound, upperBound) {
    this.v36_1 = lowerBound;
    this.w36_1 = upperBound;
    // Inline function 'kotlin.require' call
    if (!areBoundsGood(Companion_instance_37, this.v36_1, this.w36_1)) {
      var message = 'Lower bound is greater than the upperExclusive: ' + this.toString();
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
  }
  protoOf(Interval).f37 = function () {
    return this.w36_1 + 1 | 0;
  };
  protoOf(Interval).a = function () {
    return this.w36_1 - this.v36_1 | 0;
  };
  protoOf(Interval).g37 = function () {
    return new Interval$iterable$1(this);
  };
  protoOf(Interval).h37 = function () {
    return new Interval$reverseIterable$1(this);
  };
  protoOf(Interval).m = function () {
    return new Interval$iterator$1(this);
  };
  protoOf(Interval).s = function () {
    return this.v36_1 > this.w36_1;
  };
  protoOf(Interval).i37 = function (point) {
    return this.v36_1 <= point && point <= this.w36_1;
  };
  protoOf(Interval).j37 = function (other) {
    return this.i37(other.v36_1) && this.i37(other.w36_1);
  };
  protoOf(Interval).k37 = function (other) {
    return this.i37(other.v36_1) || other.i37(this.v36_1);
  };
  protoOf(Interval).l37 = function (other) {
    return this.v36_1 <= other.w36_1 && other.v36_1 <= this.w36_1;
  };
  protoOf(Interval).m37 = function (other) {
    var tmp;
    if (this.v36_1 <= other.v36_1) {
      var tmp_0;
      if (this.w36_1 >= other.w36_1) {
        tmp_0 = other;
      } else {
        tmp_0 = createIntervalForIntersection(this, other.v36_1, this.w36_1, other);
      }
      tmp = tmp_0;
    } else if (this.w36_1 <= other.w36_1) {
      tmp = this;
    } else {
      tmp = createIntervalForIntersection(this, this.v36_1, other.w36_1, other);
    }
    return tmp;
  };
  protoOf(Interval).n37 = function (other) {
    var tmp;
    if (this.j37(other)) {
      tmp = this;
    } else if (other.j37(this)) {
      tmp = other;
    } else {
      var tmp0 = this.v36_1;
      // Inline function 'kotlin.math.min' call
      var b = other.v36_1;
      var lower = Math.min(tmp0, b);
      var tmp0_0 = this.w36_1;
      // Inline function 'kotlin.math.max' call
      var b_0 = other.w36_1;
      var upper = Math.max(tmp0_0, b_0);
      tmp = new Interval(lower, upper);
    }
    return tmp;
  };
  protoOf(Interval).o37 = function (list) {
    return list.g2(this.v36_1, this.f37());
  };
  protoOf(Interval).toString = function () {
    return '[' + this.v36_1 + ', ' + this.w36_1 + ']';
  };
  protoOf(Interval).hashCode = function () {
    var result = this.v36_1;
    result = imul(result, 31) + this.w36_1 | 0;
    return result;
  };
  protoOf(Interval).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Interval))
      return false;
    if (!(this.v36_1 === other.v36_1))
      return false;
    if (!(this.w36_1 === other.w36_1))
      return false;
    return true;
  };
  function Asyncs$constant$1($value) {
    this.p37_1 = $value;
  }
  protoOf(Asyncs$constant$1).q37 = function (successHandler) {
    successHandler(this.p37_1);
    return Companion_getInstance_29().m2l_1;
  };
  protoOf(Asyncs$constant$1).r37 = function (successHandler) {
    return this.q37(successHandler);
  };
  protoOf(Asyncs$constant$1).s37 = function (successHandler, failureHandler) {
    return this.q37(successHandler);
  };
  protoOf(Asyncs$constant$1).t37 = function (successHandler, failureHandler) {
    return this.s37(successHandler, failureHandler);
  };
  function Asyncs$failure$1($t) {
    this.u37_1 = $t;
  }
  protoOf(Asyncs$failure$1).q37 = function (successHandler) {
    return Companion_getInstance_29().m2l_1;
  };
  protoOf(Asyncs$failure$1).r37 = function (successHandler) {
    return this.q37(successHandler);
  };
  protoOf(Asyncs$failure$1).s37 = function (successHandler, failureHandler) {
    return this.v37(failureHandler);
  };
  protoOf(Asyncs$failure$1).t37 = function (successHandler, failureHandler) {
    return this.s37(successHandler, failureHandler);
  };
  protoOf(Asyncs$failure$1).v37 = function (failureHandler) {
    failureHandler(this.u37_1);
    return Companion_getInstance_29().m2l_1;
  };
  function AsyncResolver$success$ref(p0) {
    var l = function (_this__u8e3s4) {
      p0.w37(_this__u8e3s4);
      return Unit_instance;
    };
    l.callableName = 'success';
    return l;
  }
  function AsyncResolver$failure$ref(p0) {
    var l = function (_this__u8e3s4) {
      p0.x37(_this__u8e3s4);
      return Unit_instance;
    };
    l.callableName = 'failure';
    return l;
  }
  function Asyncs() {
  }
  protoOf(Asyncs).y37 = function (value) {
    return new Asyncs$constant$1(value);
  };
  protoOf(Asyncs).z37 = function (t) {
    return new Asyncs$failure$1(t);
  };
  protoOf(Asyncs).a38 = function () {
    return this.y37(Unit_instance);
  };
  protoOf(Asyncs).b38 = function (from, to) {
    var tmp = AsyncResolver$success$ref(to);
    return from.t37(tmp, AsyncResolver$failure$ref(to));
  };
  var Asyncs_instance;
  function Asyncs_getInstance() {
    return Asyncs_instance;
  }
  function clearHandlers($this) {
    $this.g38_1.k2();
    $this.h38_1.k2();
  }
  function alreadyHandled($this) {
    return $this.d38_1 || $this.f38_1;
  }
  function SuccessItem(value) {
    this.i38_1 = value;
  }
  protoOf(SuccessItem).uv = function () {
    return this.i38_1;
  };
  function SimpleAsync$onResult$$inlined$toDisposable$1($successRegistration, $failureRegistration) {
    this.j38_1 = $successRegistration;
    this.k38_1 = $failureRegistration;
  }
  protoOf(SimpleAsync$onResult$$inlined$toDisposable$1).zr = function () {
    this.j38_1.zr();
    this.k38_1.zr();
    return Unit_instance;
  };
  function SimpleAsync$success$lambda(this$0) {
    return function (handler) {
      handler(ensureNotNull(this$0.c38_1).uv());
      return Unit_instance;
    };
  }
  function SimpleAsync$failure$lambda(this$0) {
    return function (handler) {
      handler(ensureNotNull(this$0.e38_1));
      return Unit_instance;
    };
  }
  function SimpleAsync() {
    this.c38_1 = null;
    this.d38_1 = false;
    this.e38_1 = null;
    this.f38_1 = false;
    this.g38_1 = new Listeners();
    this.h38_1 = new Listeners();
  }
  protoOf(SimpleAsync).r37 = function (successHandler) {
    var tmp;
    if (alreadyHandled(this)) {
      if (this.d38_1) {
        successHandler(ensureNotNull(this.c38_1).uv());
      }
      tmp = Companion_getInstance_29().m2l_1;
    } else {
      tmp = this.g38_1.j2s(successHandler);
    }
    return tmp;
  };
  protoOf(SimpleAsync).t37 = function (successHandler, failureHandler) {
    var successRegistration = this.r37(successHandler);
    var failureRegistration = this.v37(failureHandler);
    // Inline function 'jetbrains.ocelot.base.disposable.toDisposable' call
    return new SimpleAsync$onResult$$inlined$toDisposable$1(successRegistration, failureRegistration);
  };
  protoOf(SimpleAsync).v37 = function (failureHandler) {
    var tmp;
    if (alreadyHandled(this)) {
      if (this.f38_1) {
        failureHandler(ensureNotNull(this.e38_1));
      }
      tmp = Companion_getInstance_29().m2l_1;
    } else {
      tmp = this.h38_1.j2s(failureHandler);
    }
    return tmp;
  };
  protoOf(SimpleAsync).w37 = function (result) {
    // Inline function 'kotlin.check' call
    if (!!alreadyHandled(this)) {
      var message = 'Async already completed';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    this.c38_1 = new SuccessItem(result);
    this.d38_1 = true;
    var tmp = this.g38_1;
    tmp.k2s(SimpleAsync$success$lambda(this));
    clearHandlers(this);
  };
  protoOf(SimpleAsync).x37 = function (throwable) {
    // Inline function 'kotlin.check' call
    if (!!alreadyHandled(this)) {
      var message = 'Async already completed';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    this.e38_1 = throwable;
    this.f38_1 = true;
    var tmp = this.h38_1;
    tmp.k2s(SimpleAsync$failure$lambda(this));
    clearHandlers(this);
  };
  function ThrowableCollectionException_init_$Init$(throwables, $this) {
    RuntimeException_init_$Init$_1('size=' + throwables.p(), throwables.r(0), $this);
    ThrowableCollectionException.call($this);
    $this.l38_1.q(throwables);
    return $this;
  }
  function ThrowableCollectionException_init_$Create$(throwables) {
    var tmp = ThrowableCollectionException_init_$Init$(throwables, objectCreate(protoOf(ThrowableCollectionException)));
    captureStack(tmp, ThrowableCollectionException_init_$Create$);
    return tmp;
  }
  protoOf(ThrowableCollectionException).m38 = function () {
    return this.l38_1;
  };
  function ThrowableCollectionException() {
    captureStack(this, ThrowableCollectionException);
    this.l38_1 = ArrayList_init_$Create$();
  }
  function AsyncGuardedExecution() {
  }
  function compound(first, other) {
    return new compound$1(first, other);
  }
  function EmptyRunnable() {
  }
  protoOf(EmptyRunnable).p38 = function () {
    return false;
  };
  protoOf(EmptyRunnable).q38 = function () {
  };
  var EmptyRunnable_instance;
  function EmptyRunnable_getInstance() {
    return EmptyRunnable_instance;
  }
  function compound$1$prepare$2(this$0) {
    this.r38_1 = this$0;
  }
  protoOf(compound$1$prepare$2).p38 = function () {
    return this.r38_1.s38_1.p38() || this.r38_1.t38_1.p38();
  };
  protoOf(compound$1$prepare$2).q38 = function () {
    // Inline function 'kotlin.check' call
    if (!this.p38()) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    if (this.r38_1.s38_1.p38()) {
      this.r38_1.s38_1.q38();
    }
    if (this.r38_1.t38_1.p38()) {
      this.r38_1.t38_1.q38();
    }
  };
  function $prepareCOROUTINE$(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.e39_1 = _this__u8e3s4;
  }
  protoOf($prepareCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 3;
            this.f9_1 = 1;
            suspendResult = this.e39_1.u38_1.n38(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            this.e39_1.s38_1 = ARGUMENT;
            this.f9_1 = 2;
            suspendResult = this.e39_1.v38_1.n38(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var ARGUMENT_0 = suspendResult;
            this.e39_1.t38_1 = ARGUMENT_0;
            return new compound$1$prepare$2(this.e39_1);
          case 3:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 3) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function compound$1($first, $other) {
    this.u38_1 = $first;
    this.v38_1 = $other;
    this.s38_1 = EmptyRunnable_instance;
    this.t38_1 = EmptyRunnable_instance;
  }
  protoOf(compound$1).n38 = function ($completion) {
    var tmp = new $prepareCOROUTINE$(this, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(compound$1).zr = function () {
    if (this.s38_1.p38()) {
      this.u38_1.zr();
    }
    if (this.t38_1.p38()) {
      this.v38_1.zr();
    }
  };
  function await_1(_this__u8e3s4, $completion) {
    var cancellable = new CancellableContinuationImpl(intercepted($completion), 1);
    cancellable.mt();
    var successHandler = await$lambda_1(cancellable);
    var failureHandler = await$lambda_2(cancellable);
    _this__u8e3s4.t37(successHandler, failureHandler);
    return cancellable.tt();
  }
  function await$lambda_1($continuation) {
    return function (result) {
      // Inline function 'kotlin.coroutines.resume' call
      var this_0 = $continuation;
      // Inline function 'kotlin.Companion.success' call
      var tmp$ret$0 = _Result___init__impl__xyqfz8(result);
      this_0.q9(tmp$ret$0);
      return Unit_instance;
    };
  }
  function await$lambda_2($continuation) {
    return function (exception) {
      // Inline function 'kotlin.coroutines.resumeWithException' call
      var this_0 = $continuation;
      // Inline function 'kotlin.Companion.failure' call
      var tmp$ret$0 = _Result___init__impl__xyqfz8(createFailure(exception));
      this_0.q9(tmp$ret$0);
      return Unit_instance;
    };
  }
  function launchWith(_this__u8e3s4, asyncTracker, block) {
    asyncTracker.f39();
    return launch(_this__u8e3s4, VOID, VOID, launchWith$slambda_0(block, asyncTracker, null));
  }
  function AsyncTracker$Companion$EMPTY$1() {
  }
  function Companion_38() {
    Companion_instance_38 = this;
    var tmp = this;
    tmp.h39_1 = new AsyncTracker$Companion$EMPTY$1();
  }
  var Companion_instance_38;
  function Companion_getInstance_38() {
    if (Companion_instance_38 == null)
      new Companion_38();
    return Companion_instance_38;
  }
  function AsyncTracker() {
  }
  function launchWith$slambda($block, $asyncTracker, resultContinuation) {
    this.q39_1 = $block;
    this.r39_1 = $asyncTracker;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(launchWith$slambda).e1h = function ($this$launch, $completion) {
    var tmp = this.f1h($this$launch, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(launchWith$slambda).v9 = function (p1, $completion) {
    return this.e1h((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(launchWith$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 5;
            this.f9_1 = 1;
            continue $sm;
          case 1:
            this.g9_1 = 4;
            this.f9_1 = 2;
            suspendResult = this.q39_1(this.s39_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.g9_1 = 5;
            this.f9_1 = 3;
            continue $sm;
          case 3:
            this.g9_1 = 5;
            this.r39_1.g39();
            return Unit_instance;
          case 4:
            this.g9_1 = 5;
            var t = this.i9_1;
            this.r39_1.g39();
            throw t;
          case 5:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 5) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(launchWith$slambda).f1h = function ($this$launch, completion) {
    var i = new launchWith$slambda(this.q39_1, this.r39_1, completion);
    i.s39_1 = $this$launch;
    return i;
  };
  function launchWith$slambda_0($block, $asyncTracker, resultContinuation) {
    var i = new launchWith$slambda($block, $asyncTracker, resultContinuation);
    var l = function ($this$launch, $completion) {
      return i.e1h($this$launch, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function DefaultAsyncEdt() {
  }
  function EdtException() {
  }
  function EdtTask() {
  }
  function NullEventDispatchThread() {
    DefaultAsyncEdt.call(this);
  }
  protoOf(NullEventDispatchThread).t39 = function () {
    return 0n;
  };
  protoOf(NullEventDispatchThread).u39 = function (task) {
  };
  protoOf(NullEventDispatchThread).v39 = function (delay, task) {
    return Companion_getInstance_29().m2l_1;
  };
  protoOf(NullEventDispatchThread).w39 = function (period, task) {
    return Companion_getInstance_29().m2l_1;
  };
  function get_asCoroutineDispatcher(_this__u8e3s4) {
    return new EdtCoroutineDispatcher(_this__u8e3s4);
  }
  function sam$jetbrains_ocelot_base_edt_EdtTask$0(function_0) {
    this.x39_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0).au = function () {
    return this.x39_1();
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0).f3 = function () {
    return this.x39_1;
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, EdtTask) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0).hashCode = function () {
    return hashCode(this.f3());
  };
  function sam$jetbrains_ocelot_base_edt_EdtTask$0_0(function_0) {
    this.y39_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_0).au = function () {
    return this.y39_1();
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_0).f3 = function () {
    return this.y39_1;
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, EdtTask) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_0).hashCode = function () {
    return hashCode(this.f3());
  };
  function sam$jetbrains_ocelot_base_edt_EdtTask$0_1(function_0) {
    this.z39_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_1).au = function () {
    return this.z39_1();
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_1).f3 = function () {
    return this.z39_1;
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_1).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, EdtTask) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_1).hashCode = function () {
    return hashCode(this.f3());
  };
  function sam$kotlinx_coroutines_DisposableHandle$0(function_0) {
    this.a3a_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_DisposableHandle$0).zr = function () {
    return this.a3a_1();
  };
  protoOf(sam$kotlinx_coroutines_DisposableHandle$0).f3 = function () {
    return this.a3a_1;
  };
  protoOf(sam$kotlinx_coroutines_DisposableHandle$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, DisposableHandle) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlinx_coroutines_DisposableHandle$0).hashCode = function () {
    return hashCode(this.f3());
  };
  function Runnable$run$ref(p0) {
    var l = function () {
      p0.au();
      return Unit_instance;
    };
    l.callableName = 'run';
    return l;
  }
  function EdtCoroutineDispatcher$scheduleResumeAfterDelay$lambda($continuation, this$0) {
    return function () {
      // Inline function 'kotlin.with' call
      $continuation.vr(this$0, Unit_instance);
      return Unit_instance;
    };
  }
  function EdtCoroutineDispatcher$scheduleResumeAfterDelay$lambda_0($disposable) {
    return function (it) {
      $disposable.zr();
      return Unit_instance;
    };
  }
  function EdtCoroutineDispatcher$invokeOnTimeout$lambda($block) {
    return function () {
      $block.au();
      return Unit_instance;
    };
  }
  function EdtCoroutineDispatcher$invokeOnTimeout$lambda_0($disposable) {
    return function () {
      $disposable.zr();
      return Unit_instance;
    };
  }
  function EdtCoroutineDispatcher(edt) {
    CoroutineDispatcher.call(this);
    this.c3a_1 = edt;
  }
  protoOf(EdtCoroutineDispatcher).xu = function (context, block) {
    var tmp = Runnable$run$ref(block);
    return this.c3a_1.u39(new sam$jetbrains_ocelot_base_edt_EdtTask$0(tmp));
  };
  protoOf(EdtCoroutineDispatcher).dv = function (timeMillis, continuation) {
    var tmp = EdtCoroutineDispatcher$scheduleResumeAfterDelay$lambda(continuation, this);
    var task = new sam$jetbrains_ocelot_base_edt_EdtTask$0_0(tmp);
    var disposable = this.c3a_1.v39(convertToInt(timeMillis), task);
    continuation.ur(EdtCoroutineDispatcher$scheduleResumeAfterDelay$lambda_0(disposable));
  };
  protoOf(EdtCoroutineDispatcher).ev = function (timeMillis, block, context) {
    var tmp = EdtCoroutineDispatcher$invokeOnTimeout$lambda(block);
    var task = new sam$jetbrains_ocelot_base_edt_EdtTask$0_1(tmp);
    var disposable = this.c3a_1.v39(convertToInt(timeMillis), task);
    var tmp_0 = EdtCoroutineDispatcher$invokeOnTimeout$lambda_0(disposable);
    return new sam$kotlinx_coroutines_DisposableHandle$0(tmp_0);
  };
  function doExecute($this, task) {
    var tmp;
    try {
      task.au();
      tmp = Unit_instance;
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var t = $p;
        ThrowableHandlers_getInstance().k2r_1.j2r(t);
        tmp_0 = Unit_instance;
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  function timerDisposable($this, timer) {
    // Inline function 'jetbrains.ocelot.base.disposable.toDisposable' call
    return new JsEventDispatchThread$timerDisposable$$inlined$toDisposable$1(timer);
  }
  function EdtTask$run$ref(p0) {
    var l = function () {
      p0.au();
      return Unit_instance;
    };
    l.callableName = 'run';
    return l;
  }
  function JsEventDispatchThread$schedule$lambda($task) {
    return function () {
      doExecute(JsEventDispatchThread_getInstance(), $task);
      return Unit_instance;
    };
  }
  function JsEventDispatchThread$scheduleRepeating$lambda($lastInvocation, $period, $task) {
    return function () {
      var current = JsEventDispatchThread_getInstance().t39();
      var tmp;
      if (subtract_1(current, $lastInvocation._v) >= fromInt_0($period)) {
        $lastInvocation._v = current;
        doExecute(JsEventDispatchThread_getInstance(), $task);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function JsEventDispatchThread$timerDisposable$$inlined$toDisposable$1($timer) {
    this.d3a_1 = $timer;
  }
  protoOf(JsEventDispatchThread$timerDisposable$$inlined$toDisposable$1).zr = function () {
    if (this.d3a_1.j3a()) {
      this.d3a_1.i3a();
    }
    return Unit_instance;
  };
  function JsEventDispatchThread() {
    JsEventDispatchThread_instance = this;
    DefaultAsyncEdt.call(this);
  }
  protoOf(JsEventDispatchThread).t39 = function () {
    return currentTimeMillis();
  };
  protoOf(JsEventDispatchThread).u39 = function (task) {
    var tmp = Companion_getInstance_39().k3a_1;
    return tmp.l3a(EdtTask$run$ref(task));
  };
  protoOf(JsEventDispatchThread).v39 = function (delay, task) {
    var timer = new Timer(JsEventDispatchThread$schedule$lambda(task));
    timer.m3a(delay);
    return timerDisposable(this, timer);
  };
  protoOf(JsEventDispatchThread).w39 = function (period, task) {
    var lastInvocation = {_v: 0n};
    var timer = new Timer(JsEventDispatchThread$scheduleRepeating$lambda(lastInvocation, period, task));
    timer.n3a(period);
    return timerDisposable(this, timer);
  };
  var JsEventDispatchThread_instance;
  function JsEventDispatchThread_getInstance() {
    if (JsEventDispatchThread_instance == null)
      new JsEventDispatchThread();
    return JsEventDispatchThread_instance;
  }
  function Companion_39() {
    Companion_instance_39 = this;
    this.k3a_1 = new SchedulerImpl();
  }
  var Companion_instance_39;
  function Companion_getInstance_39() {
    if (Companion_instance_39 == null)
      new Companion_39();
    return Companion_instance_39;
  }
  function SchedulerImpl$Rescuer$execute$lambda(this$0) {
    return function () {
      return ensureNotNull(this$0.o3a_1).u3a();
    };
  }
  function push($this, queue, task) {
    var result = queue;
    if (result == null) {
      result = ArrayList_init_$Create$();
    }
    result.j(task);
    return result;
  }
  function scheduleFixedDelayImpl($this, delayMs, cmd) {
    var handler = SchedulerImpl$Companion$scheduleFixedDelayImpl$lambda(cmd, delayMs);
    window.setTimeout(handler, delayMs);
  }
  function scheduleFixedPeriodImpl($this, delayMs, cmd) {
    var intervalId = {_v: null};
    var handler = SchedulerImpl$Companion$scheduleFixedPeriodImpl$lambda(cmd, intervalId);
    intervalId._v = window.setInterval(handler, delayMs);
  }
  function SchedulerImpl$Companion$scheduleFixedDelayImpl$lambda($cmd, $delayMs) {
    return function () {
      var result = false;
      var tmp;
      try {
        result = $cmd();
        tmp = Unit_instance;
      } catch ($p) {
        var tmp_0;
        if ($p instanceof Error) {
          var t = $p;
          ThrowableHandlers_getInstance().k2r_1.j2r(t);
          tmp_0 = Unit_instance;
        } else {
          throw $p;
        }
        tmp = tmp_0;
      }
      var tmp_1;
      if (result) {
        scheduleFixedDelayImpl(Companion_instance_40, $delayMs, $cmd);
        tmp_1 = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function SchedulerImpl$Companion$scheduleFixedPeriodImpl$lambda($cmd, $intervalId) {
    return function () {
      var result = false;
      var tmp;
      try {
        result = $cmd();
        tmp = Unit_instance;
      } catch ($p) {
        var tmp_0;
        if ($p instanceof Error) {
          var t = $p;
          ThrowableHandlers_getInstance().k2r_1.j2r(t);
          tmp_0 = Unit_instance;
        } else {
          throw $p;
        }
        tmp = tmp_0;
      }
      var tmp_1;
      if (!result) {
        window.clearInterval(ensureNotNull($intervalId._v));
        tmp_1 = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function Task(scheduled) {
    this.v3a_1 = scheduled;
  }
  protoOf(Task).w3a = function () {
    this.v3a_1();
  };
  function Flusher($outer) {
    this.t3a_1 = $outer;
  }
  protoOf(Flusher).u3a = function () {
    this.t3a_1.r3a_1 = true;
    this.t3a_1.x3a();
    this.t3a_1.r3a_1 = false;
    this.t3a_1.s3a_1 = this.t3a_1.y3a();
    return this.t3a_1.s3a_1;
  };
  function Rescuer($outer) {
    this.z3a_1 = $outer;
  }
  protoOf(Rescuer).u3a = function () {
    if (this.z3a_1.r3a_1) {
      this.z3a_1.a3b(1, SchedulerImpl$Rescuer$execute$lambda(this.z3a_1));
    }
    return this.z3a_1.s3a_1;
  };
  function maybeSchedulePostEventPumpCommands($this) {
    if (!$this.s3a_1) {
      $this.s3a_1 = true;
      if ($this.o3a_1 == null) {
        $this.o3a_1 = new Flusher($this);
      }
      var tmp = Companion_instance_40;
      scheduleFixedDelayImpl(tmp, 1, SchedulerImpl$maybeSchedulePostEventPumpCommands$lambda($this));
      if ($this.p3a_1 == null) {
        $this.p3a_1 = new Rescuer($this);
      }
      var tmp_0 = Companion_instance_40;
      scheduleFixedDelayImpl(tmp_0, 50, SchedulerImpl$maybeSchedulePostEventPumpCommands$lambda_0($this));
    }
  }
  function Companion_40() {
    this.b3b_1 = 1;
    this.c3b_1 = 50;
  }
  var Companion_instance_40;
  function Companion_getInstance_40() {
    return Companion_instance_40;
  }
  function SchedulerImpl$maybeSchedulePostEventPumpCommands$lambda(this$0) {
    return function () {
      return ensureNotNull(this$0.o3a_1).u3a();
    };
  }
  function SchedulerImpl$maybeSchedulePostEventPumpCommands$lambda_0(this$0) {
    return function () {
      return ensureNotNull(this$0.p3a_1).u3a();
    };
  }
  function SchedulerImpl() {
    this.o3a_1 = null;
    this.p3a_1 = null;
    this.q3a_1 = null;
    this.r3a_1 = false;
    this.s3a_1 = false;
  }
  protoOf(SchedulerImpl).y3a = function () {
    return !(this.q3a_1 == null);
  };
  protoOf(SchedulerImpl).l3a = function (command) {
    this.q3a_1 = push(Companion_instance_40, this.q3a_1, new Task(command));
    maybeSchedulePostEventPumpCommands(this);
  };
  protoOf(SchedulerImpl).a3b = function (delayMs, command) {
    scheduleFixedDelayImpl(Companion_instance_40, delayMs, command);
  };
  protoOf(SchedulerImpl).d3b = function (delayMs, command) {
    scheduleFixedPeriodImpl(Companion_instance_40, delayMs, command);
  };
  protoOf(SchedulerImpl).x3a = function () {
    if (!(this.q3a_1 == null)) {
      var oldDeferred = this.q3a_1;
      this.q3a_1 = null;
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s = ensureNotNull(oldDeferred).m();
      while (_iterator__ex2g4s.n()) {
        var element = _iterator__ex2g4s.o();
        element.w3a();
      }
    }
  };
  function fire($this, scheduleCancelCounter) {
    if (!(scheduleCancelCounter === $this.h3a_1)) {
      return Unit_instance;
    }
    if (!$this.f3a_1) {
      $this.g3a_1 = null;
    }
    $this.e3a_1();
  }
  function createCallback($this, cancelCounter) {
    return Timer$createCallback$lambda($this, cancelCounter);
  }
  function Timer$createCallback$lambda(this$0, $cancelCounter) {
    return function () {
      var tmp;
      try {
        fire(this$0, $cancelCounter);
        tmp = Unit_instance;
      } catch ($p) {
        var tmp_0;
        if ($p instanceof Error) {
          var t = $p;
          ThrowableHandlers_getInstance().k2r_1.j2r(t);
          tmp_0 = Unit_instance;
        } else {
          throw $p;
        }
        tmp = tmp_0;
      }
      return Unit_instance;
    };
  }
  function Timer(task) {
    this.e3a_1 = task;
    this.f3a_1 = false;
    this.g3a_1 = null;
    this.h3a_1 = 0;
  }
  protoOf(Timer).j3a = function () {
    return !(this.g3a_1 == null);
  };
  protoOf(Timer).i3a = function () {
    if (!this.j3a()) {
      return Unit_instance;
    }
    this.h3a_1 = this.h3a_1 + 1 | 0;
    if (this.f3a_1) {
      window.clearInterval(ensureNotNull(this.g3a_1));
    } else {
      window.clearTimeout(ensureNotNull(this.g3a_1));
    }
    this.g3a_1 = null;
  };
  protoOf(Timer).m3a = function (delayMillis) {
    // Inline function 'kotlin.require' call
    if (!(delayMillis >= 0)) {
      var message = 'must be non-negative';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    if (this.j3a()) {
      this.i3a();
    }
    this.f3a_1 = false;
    this.g3a_1 = window.setTimeout(createCallback(this, this.h3a_1), delayMillis);
  };
  protoOf(Timer).n3a = function (periodMillis) {
    // Inline function 'kotlin.require' call
    if (!(periodMillis > 0)) {
      var message = 'must be positive';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    if (this.j3a()) {
      this.i3a();
    }
    this.f3a_1 = true;
    this.g3a_1 = window.setInterval(createCallback(this, this.h3a_1), periodMillis);
  };
  function get_platformEdt() {
    _init_properties_JsEdt_kt__w9ydkq();
    return platformEdt;
  }
  var platformEdt;
  var properties_initialized_JsEdt_kt_uwb5uk;
  function _init_properties_JsEdt_kt__w9ydkq() {
    if (!properties_initialized_JsEdt_kt_uwb5uk) {
      properties_initialized_JsEdt_kt_uwb5uk = true;
      platformEdt = JsEventDispatchThread_getInstance();
    }
  }
  function Service$Key$invoke$lambda(this$0) {
    return function (it) {
      return this$0.e3b(it);
    };
  }
  function Service$Companion$instance$lambda($instance, $disposable) {
    return function (service, _unused_var__etf5q3) {
      return new ServiceInstance(service, $instance, $disposable);
    };
  }
  function Service$Companion$byFactory$lambda(it) {
    return Companion_getInstance_29().m2l_1;
  }
  function Service$Companion$byFactory$lambda_0($factory, $disposable) {
    return function (service, container) {
      // Inline function 'kotlin.let' call
      var it = $factory(container);
      return new ServiceInstance(service, it, $disposable(it));
    };
  }
  function Service$Companion$disposableInstance$lambda($instance) {
    return function (service, _unused_var__etf5q3) {
      return Companion_instance_42.f3b(service, $instance);
    };
  }
  function Key_5() {
  }
  function Companion_41() {
  }
  protoOf(Companion_41).j3b = function (instance, keys, disposable) {
    var tmp = toSet(keys);
    return new Service(tmp, Service$Companion$instance$lambda(instance, disposable));
  };
  protoOf(Companion_41).k3b = function (instance, keys, disposable, $super) {
    disposable = disposable === VOID ? Companion_getInstance_29().m2l_1 : disposable;
    return $super === VOID ? this.j3b(instance, keys, disposable) : $super.j3b.call(this, instance, keys, disposable);
  };
  protoOf(Companion_41).l3b = function (keys, disposable, factory) {
    var tmp = toSet(keys);
    return new Service(tmp, Service$Companion$byFactory$lambda_0(factory, disposable));
  };
  protoOf(Companion_41).m3b = function (keys, disposable, factory, $super) {
    var tmp;
    if (disposable === VOID) {
      tmp = Service$Companion$byFactory$lambda;
    } else {
      tmp = disposable;
    }
    disposable = tmp;
    return $super === VOID ? this.l3b(keys, disposable, factory) : $super.l3b.call(this, keys, disposable, factory);
  };
  protoOf(Companion_41).n3b = function (instance, keys) {
    var tmp = toSet(keys);
    return new Service(tmp, Service$Companion$disposableInstance$lambda(instance));
  };
  protoOf(Companion_41).o3b = function (disposable) {
    return this.j3b(Unit_instance, [new AnonymousResourceServiceKey()], disposable);
  };
  var Companion_instance_41;
  function Companion_getInstance_41() {
    return Companion_instance_41;
  }
  function AnonymousResourceServiceKey() {
  }
  function Service(keys, factory) {
    this.p3b_1 = factory;
    // Inline function 'kotlin.collections.isNotEmpty' call
    // Inline function 'kotlin.check' call
    if (!!keys.s()) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    this.q3b_1 = keys;
  }
  protoOf(Service).r3b = function (container) {
    return this.p3b_1(this, container);
  };
  function ServiceAdapter(adapterFunction) {
    this.s3b_1 = adapterFunction;
    this.t3b_1 = null;
  }
  protoOf(ServiceAdapter).u3b = function (scope) {
    var tmp0_elvis_lhs = this.t3b_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.run' call
      var res = this.s3b_1(scope);
      this.t3b_1 = res;
      tmp = res;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  function serviceContainer(services, parent) {
    parent = parent === VOID ? null : parent;
    return new ServiceManager(toSet(services), parent);
  }
  function Companion_42() {
  }
  protoOf(Companion_42).f3b = function (service, value) {
    return new ServiceInstance(service, value, value);
  };
  var Companion_instance_42;
  function Companion_getInstance_42() {
    return Companion_instance_42;
  }
  function ServiceInstance$$inlined$toDisposable$1() {
  }
  protoOf(ServiceInstance$$inlined$toDisposable$1).zr = function () {
    return Unit_instance;
  };
  function ServiceInstance(service, value, disposable) {
    var tmp;
    if (disposable === VOID) {
      // Inline function 'jetbrains.ocelot.base.disposable.toDisposable' call
      tmp = new ServiceInstance$$inlined$toDisposable$1();
    } else {
      tmp = disposable;
    }
    disposable = tmp;
    this.v3b_1 = disposable;
    this.w3b_1 = service;
    this.x3b_1 = value;
  }
  protoOf(ServiceInstance).zr = function () {
    this.v3b_1.zr();
  };
  protoOf(ServiceInstance).j2l = function (disposable) {
    return this.v3b_1.j2l(disposable);
  };
  function ServiceManager$ServiceEntry$instance$delegate$lambda(this$0, this$1) {
    return function () {
      return this$0.y3b_1.r3b(this$1);
    };
  }
  function ServiceManager$ServiceEntry$_get_instance_$ref_823nog() {
    return function (p0) {
      return p0.b3c();
    };
  }
  function ServiceEntry($outer, service) {
    this.a3c_1 = $outer;
    this.y3b_1 = service;
    var tmp = this;
    tmp.z3b_1 = lazy(ServiceManager$ServiceEntry$instance$delegate$lambda(this, this.a3c_1));
  }
  protoOf(ServiceEntry).b3c = function () {
    var tmp0 = this.z3b_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('instance', 1, tmp, ServiceManager$ServiceEntry$_get_instance_$ref_823nog(), null);
    return tmp0.a1();
  };
  function ServiceManager(serviceSet, parentContainer) {
    this.c3c_1 = parentContainer;
    var tmp = this;
    // Inline function 'kotlin.collections.hashMapOf' call
    tmp.d3c_1 = HashMap_init_$Create$();
    var _iterator__ex2g4s = serviceSet.m();
    while (_iterator__ex2g4s.n()) {
      var service = _iterator__ex2g4s.o();
      var tmp0 = service.q3b_1;
      var tmp$ret$1;
      $l$block_0: {
        // Inline function 'kotlin.collections.any' call
        var tmp_0;
        if (isInterface(tmp0, Collection)) {
          tmp_0 = tmp0.s();
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          tmp$ret$1 = false;
          break $l$block_0;
        }
        var _iterator__ex2g4s_0 = tmp0.m();
        while (_iterator__ex2g4s_0.n()) {
          var element = _iterator__ex2g4s_0.o();
          // Inline function 'kotlin.collections.contains' call
          // Inline function 'kotlin.collections.containsKey' call
          var this_0 = this.d3c_1;
          if ((isInterface(this_0, KtMap) ? this_0 : THROW_CCE()).o2(element)) {
            tmp$ret$1 = true;
            break $l$block_0;
          }
        }
        tmp$ret$1 = false;
      }
      if (tmp$ret$1) {
        throw IllegalArgumentException_init_$Create$_0('Duplicate services');
      }
      var entry = new ServiceEntry(this, service);
      var _iterator__ex2g4s_1 = service.q3b_1.m();
      while (_iterator__ex2g4s_1.n()) {
        var key = _iterator__ex2g4s_1.o();
        // Inline function 'kotlin.collections.set' call
        this.d3c_1.t2(key, entry);
      }
    }
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s_2 = this.d3c_1.y().m();
    while (_iterator__ex2g4s_2.n()) {
      var service_0 = _iterator__ex2g4s_2.o();
      service_0.a1().b3c();
    }
  }
  protoOf(ServiceManager).zr = function () {
    var _iterator__ex2g4s = this.d3c_1.s2().m();
    while (_iterator__ex2g4s.n()) {
      var service = _iterator__ex2g4s.o();
      service.b3c().zr();
    }
  };
  protoOf(ServiceManager).h3b = function (key) {
    var tmp0_elvis_lhs = this.d3c_1.q2(key);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp1_safe_receiver = this.c3c_1;
      return tmp1_safe_receiver == null ? null : tmp1_safe_receiver.h3b(key);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var service = tmp;
    var tmp_0 = service.b3c().x3b_1;
    return !(tmp_0 == null) ? tmp_0 : THROW_CCE();
  };
  function ServicesScope() {
  }
  function CoroutineContextService() {
    CoroutineContextService_instance = this;
    this.f3c_1 = EmptyCoroutineContext_instance;
  }
  protoOf(CoroutineContextService).g3b = function () {
    return this.f3c_1;
  };
  var CoroutineContextService_instance;
  function CoroutineContextService_getInstance() {
    if (CoroutineContextService_instance == null)
      new CoroutineContextService();
    return CoroutineContextService_instance;
  }
  function Configuration_init_$Init$($this) {
    Configuration.call($this);
    return $this;
  }
  function Configuration_init_$Create$() {
    return Configuration_init_$Init$(objectCreate(protoOf(Configuration)));
  }
  protoOf(Configuration).h3c = function () {
    return this.g3c_1.r2();
  };
  protoOf(Configuration).i3c = function (key, value) {
    var tmp0 = this.g3c_1;
    // Inline function 'kotlin.collections.set' call
    var value_0 = !(value == null) ? value : THROW_CCE();
    tmp0.t2(key, value_0);
    return this;
  };
  protoOf(Configuration).j3c = function (key) {
    var tmp;
    if (!this.l3c(key) && key.m3c()) {
      tmp = key.k3c();
    } else {
      var tmp_0 = this.g3c_1.q2(key);
      tmp = (tmp_0 == null ? true : !(tmp_0 == null)) ? tmp_0 : THROW_CCE();
    }
    return tmp;
  };
  protoOf(Configuration).l3c = function (key) {
    return this.g3c_1.o2(key);
  };
  protoOf(Configuration).n3c = function (other) {
    var parameters = HashSet_init_$Create$();
    parameters.q(this.h3c());
    parameters.q(other.h3c());
    var _iterator__ex2g4s = parameters.m();
    while (_iterator__ex2g4s.n()) {
      var parameter = _iterator__ex2g4s.o();
      if (!equals(this.j3c(parameter), other.j3c(parameter))) {
        return parameter;
      }
    }
    return null;
  };
  function Configuration() {
    this.g3c_1 = HashMap_init_$Create$();
  }
  function getPersister($this, tag) {
    return $this.p3c(tag).q3c();
  }
  function ConfigurationPersistentContext() {
    this.o3c_1 = HashMap_init_$Create$();
  }
  protoOf(ConfigurationPersistentContext).r3c = function () {
    return this.o3c_1.r2();
  };
  protoOf(ConfigurationPersistentContext).s3c = function (parameter) {
    // Inline function 'kotlin.check' call
    if (!!this.o3c_1.o2(parameter.t3c())) {
      var message = "Parameter with tag '" + parameter.t3c() + "' is already registered";
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    var tmp0 = this.o3c_1;
    // Inline function 'kotlin.collections.set' call
    var key = parameter.t3c();
    tmp0.t2(key, parameter);
  };
  protoOf(ConfigurationPersistentContext).p3c = function (tag) {
    // Inline function 'kotlin.check' call
    if (!this.o3c_1.o2(tag)) {
      var message = 'Unknown tag: ' + tag;
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    var tmp = ensureNotNull(this.o3c_1.q2(tag));
    return isInterface(tmp, PersistentParameter) ? tmp : THROW_CCE();
  };
  protoOf(ConfigurationPersistentContext).u3c = function (tag, value) {
    return getPersister(this, tag).p25(value);
  };
  function addToConfiguration($this, configuration, tag, jsonValue) {
    var parameter = $this.v3c_1.p3c(tag);
    configuration.i3c(parameter, ensureNotNull($this.v3c_1.u3c(tag, jsonValue)));
  }
  function ConfigurationPersister(persistentContext) {
    this.v3c_1 = persistentContext;
  }
  protoOf(ConfigurationPersister).w3c = function (jsonObject) {
    var configuration = Configuration_init_$Create$();
    var _iterator__ex2g4s = this.v3c_1.r3c().m();
    while (_iterator__ex2g4s.n()) {
      var tag = _iterator__ex2g4s.o();
      var value = jsonObject.ny(tag);
      if (!(value == null)) {
        addToConfiguration(this, configuration, tag, value);
      }
    }
    return configuration;
  };
  function PersistentParameter() {
  }
  function LoggingUtils() {
    this.x3c_1 = 500;
  }
  protoOf(LoggingUtils).y3c = function (o) {
    var tmp;
    if (o == null) {
      tmp = 'null';
    } else {
      tmp = this.z3c(toString_1(o));
    }
    return tmp;
  };
  protoOf(LoggingUtils).z3c = function (string) {
    if (string == null) {
      return 'null';
    }
    var tmp;
    if (string.length > 500) {
      tmp = take_1(string, 500) + '...';
    } else {
      tmp = string;
    }
    return tmp;
  };
  var LoggingUtils_instance;
  function LoggingUtils_getInstance() {
    return LoggingUtils_instance;
  }
  function OtRejectionException(reason) {
    reason = reason === VOID ? RejectionReason_INTERNAL_ERROR_getInstance() : reason;
    RuntimeException_init_$Init$_0(reason.c3d_1, this);
    captureStack(this, OtRejectionException);
    this.d3d_1 = reason;
  }
  var RejectionReason_NOT_FOUND_instance;
  var RejectionReason_ACCESS_DENIED_instance;
  var RejectionReason_INVALID_OPERATION_instance;
  var RejectionReason_INTERNAL_ERROR_instance;
  var RejectionReason_TIMEOUT_instance;
  var RejectionReason_DISCONNECTED_instance;
  function values() {
    return [RejectionReason_NOT_FOUND_getInstance(), RejectionReason_ACCESS_DENIED_getInstance(), RejectionReason_INVALID_OPERATION_getInstance(), RejectionReason_INTERNAL_ERROR_getInstance(), RejectionReason_TIMEOUT_getInstance(), RejectionReason_DISCONNECTED_getInstance()];
  }
  var RejectionReason_entriesInitialized;
  function RejectionReason_initEntries() {
    if (RejectionReason_entriesInitialized)
      return Unit_instance;
    RejectionReason_entriesInitialized = true;
    RejectionReason_NOT_FOUND_instance = new RejectionReason('NOT_FOUND', 0, 'entity was not found');
    RejectionReason_ACCESS_DENIED_instance = new RejectionReason('ACCESS_DENIED', 1, 'access denied');
    RejectionReason_INVALID_OPERATION_instance = new RejectionReason('INVALID_OPERATION', 2, 'invalid operation');
    RejectionReason_INTERNAL_ERROR_instance = new RejectionReason('INTERNAL_ERROR', 3, 'internal error');
    RejectionReason_TIMEOUT_instance = new RejectionReason('TIMEOUT', 4, 'timeout');
    RejectionReason_DISCONNECTED_instance = new RejectionReason('DISCONNECTED', 5, 'disconnected');
  }
  function RejectionReason(name, ordinal, reason) {
    Enum.call(this, name, ordinal);
    this.c3d_1 = reason;
  }
  function RejectionReason_NOT_FOUND_getInstance() {
    RejectionReason_initEntries();
    return RejectionReason_NOT_FOUND_instance;
  }
  function RejectionReason_ACCESS_DENIED_getInstance() {
    RejectionReason_initEntries();
    return RejectionReason_ACCESS_DENIED_instance;
  }
  function RejectionReason_INVALID_OPERATION_getInstance() {
    RejectionReason_initEntries();
    return RejectionReason_INVALID_OPERATION_instance;
  }
  function RejectionReason_INTERNAL_ERROR_getInstance() {
    RejectionReason_initEntries();
    return RejectionReason_INTERNAL_ERROR_instance;
  }
  function RejectionReason_TIMEOUT_getInstance() {
    RejectionReason_initEntries();
    return RejectionReason_TIMEOUT_instance;
  }
  function RejectionReason_DISCONNECTED_getInstance() {
    RejectionReason_initEntries();
    return RejectionReason_DISCONNECTED_instance;
  }
  function ThreadSafeProperty$get$lambda(this$0) {
    return function () {
      return protoOf(ValueProperty).uv.call(this$0);
    };
  }
  function ThreadSafeProperty$set$lambda(this$0, $newValue) {
    return function () {
      protoOf(ValueProperty).d2x.call(this$0, $newValue);
      return Unit_instance;
    };
  }
  function ThreadSafeProperty$addHandler$lambda(this$0, $handler) {
    return function () {
      return protoOf(ValueProperty).u2w.call(this$0, $handler);
    };
  }
  function ThreadSafeProperty(initialValue) {
    ValueProperty.call(this, initialValue);
    this.g3d_1 = newLock();
  }
  protoOf(ThreadSafeProperty).uv = function () {
    return this.g3d_1.t2o(ThreadSafeProperty$get$lambda(this));
  };
  protoOf(ThreadSafeProperty).d2x = function (newValue) {
    this.g3d_1.t2o(ThreadSafeProperty$set$lambda(this, newValue));
  };
  protoOf(ThreadSafeProperty).u2w = function (handler) {
    return this.g3d_1.t2o(ThreadSafeProperty$addHandler$lambda(this, handler));
  };
  protoOf(ThreadSafeProperty).y2r = function (handler) {
    return this.u2w(handler);
  };
  function entityWithTheSameId($this) {
    return Entities$entityWithTheSameId$lambda;
  }
  function copyContent($this, entity, copy, entityFactory, childFilter) {
    $this.j3d(entity, copy);
    $this.k3d(entity, copy);
    $this.l3d(entity, copy);
    var _iterator__ex2g4s = entity.z3d().m();
    while (_iterator__ex2g4s.n()) {
      var childId = _iterator__ex2g4s.o();
      var children = entity.a3e(childId);
      var _iterator__ex2g4s_0 = children.m();
      while (_iterator__ex2g4s_0.n()) {
        var child = _iterator__ex2g4s_0.o();
        if (childFilter(child)) {
          var childCopy = entityFactory(child);
          copyContent($this, child, childCopy, entityFactory, childFilter);
          copy.a3e(childId).j(childCopy);
        }
      }
    }
  }
  function copyContent_0($this, entity, copy) {
    var tmp = entityWithTheSameId($this);
    copyContent($this, entity, copy, tmp, Entities$copyContent$lambda);
  }
  function Entities$entityWithTheSameId$lambda(entity) {
    return new Entity(entity.m3d_1, entity.n3d_1);
  }
  function Entities$ENTITY_WITH_NEW_ID$lambda(value) {
    return new Entity(value.m3d_1);
  }
  function Entities$copyContent$lambda(it) {
    return true;
  }
  function Entities() {
    Entities_instance = this;
    this.h3d_1 = '  ';
    var tmp = this;
    tmp.i3d_1 = Entities$ENTITY_WITH_NEW_ID$lambda;
  }
  protoOf(Entities).b3e = function (entity) {
    var copy = entityWithTheSameId(this)(entity);
    copyContent_0(this, entity, copy);
    return copy;
  };
  protoOf(Entities).j3d = function (from, to) {
    var _iterator__ex2g4s = from.c3e().m();
    while (_iterator__ex2g4s.n()) {
      var propId = _iterator__ex2g4s.o();
      to.e3e(propId, from.d3e(propId));
    }
  };
  protoOf(Entities).k3d = function (from, to) {
    var _iterator__ex2g4s = from.f3e().m();
    while (_iterator__ex2g4s.n()) {
      var refId = _iterator__ex2g4s.o();
      var targets = from.g3e(refId);
      to.g3e(refId).q(targets);
    }
  };
  protoOf(Entities).l3d = function (from, to) {
    var _iterator__ex2g4s = from.h3e().m();
    while (_iterator__ex2g4s.n()) {
      var blobId = _iterator__ex2g4s.o();
      var model = from.i3e(blobId);
      if (model == null) {
        to.j3e(blobId, null);
      }
      to.j3e(blobId, ensureNotNull(model).s3e());
    }
  };
  protoOf(Entities).t3e = function (entity) {
    return entity.q3d_1 == null ? null : root(entity);
  };
  protoOf(Entities).u3e = function (ancestorId, entity) {
    var tmp0 = ancestorsFrom(entity);
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.sequences.any' call
      var _iterator__ex2g4s = tmp0.m();
      while (_iterator__ex2g4s.n()) {
        var element = _iterator__ex2g4s.o();
        if (element.n3d_1.equals(ancestorId)) {
          tmp$ret$1 = true;
          break $l$block;
        }
      }
      tmp$ret$1 = false;
    }
    return tmp$ret$1;
  };
  var Entities_instance;
  function Entities_getInstance() {
    if (Entities_instance == null)
      new Entities();
    return Entities_instance;
  }
  function Entity$SafeObservableHashSet$1(this$0) {
    this.v3e_1 = this$0;
    CollectionAdapter.call(this);
  }
  protoOf(Entity$SafeObservableHashSet$1).m2r = function (event) {
    setEventInProgress(this.v3e_1, true);
  };
  protoOf(Entity$SafeObservableHashSet$1).t2r = function (event) {
    setEventInProgress(this.v3e_1, true);
  };
  function getCantAddMessage($this, entity) {
    return 'Cannot add entity with id=' + entity.n3d_1 + ' to role=' + $this.z3e_1 + ' in context=' + toString_0($this.y3e_1.q3d_1);
  }
  function getCantRemoveMessage($this, entity) {
    return 'Cannot remove entity with id=' + entity.n3d_1 + ' from role=' + $this.z3e_1 + ' in context=' + toString_0($this.y3e_1.q3d_1);
  }
  function decNonEmptyFeatures($this) {
    $this.x3d_1 = $this.x3d_1 - 1 | 0;
  }
  function incNonEmptyFeatures($this) {
    $this.x3d_1 = $this.x3d_1 + 1 | 0;
  }
  function contextEvent($this, changedChild) {
    return !($this.q3d_1 == null) && !changedChild.y3d_1;
  }
  function setEventInProgress($this, inProgress) {
    var entityContext = $this.q3d_1;
    if (!(entityContext == null)) {
      entityContext.h3f(inProgress);
    }
  }
  function checkCanModify($this) {
    var tmp0_safe_receiver = $this.q3d_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.i3f();
    }
  }
  function ModelListenerData(propertyId, handler) {
    this.j3f_1 = propertyId;
    this.k3f_1 = handler;
  }
  function SafeObservableHashSet($outer) {
    this.n3f_1 = $outer;
    ObservableHashSet_init_$Init$(this);
    this.x2r(new Entity$SafeObservableHashSet$1(this.n3f_1));
  }
  protoOf(SafeObservableHashSet).q2t = function (item) {
    return checkCanModify(this.n3f_1);
  };
  protoOf(SafeObservableHashSet).t2t = function (item) {
    return checkCanModify(this.n3f_1);
  };
  protoOf(SafeObservableHashSet).s2t = function (item, success) {
    if (!success)
      return Unit_instance;
    try {
      if (this.p() === 1) {
        incNonEmptyFeatures(this.n3f_1);
      }
      if (!(this.n3f_1.q3d_1 == null)) {
        this.o3f(item);
      }
    }finally {
      setEventInProgress(this.n3f_1, false);
    }
  };
  protoOf(SafeObservableHashSet).v2t = function (item, success) {
    if (!success)
      return Unit_instance;
    try {
      if (this.s()) {
        decNonEmptyFeatures(this.n3f_1);
      }
      if (!(this.n3f_1.q3d_1 == null)) {
        this.p3f(item);
      }
    }finally {
      setEventInProgress(this.n3f_1, false);
    }
  };
  function Entity$set$lambda($propId, $event) {
    return function (data) {
      var tmp;
      if (data.q3f_1.equals($propId)) {
        data.r3f_1.n2s($event);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function Entity$set$lambda_0($modelId, $event) {
    return function (listenerData) {
      var tmp;
      if (listenerData.j3f_1.equals($modelId)) {
        listenerData.k3f_1.n2s($event);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function Entity$modelProperty$1($blobId, this$0) {
    this.s3f_1 = $blobId;
    this.t3f_1 = this$0;
  }
  protoOf(Entity$modelProperty$1).v2w = function () {
    return toString_1(this) + '.' + this.s3f_1.toString();
  };
  protoOf(Entity$modelProperty$1).uv = function () {
    return this.t3f_1.i3e(this.s3f_1);
  };
  protoOf(Entity$modelProperty$1).u3f = function (newValue) {
    this.t3f_1.j3e(this.s3f_1, newValue);
  };
  protoOf(Entity$modelProperty$1).d2x = function (newValue) {
    return this.u3f((newValue == null ? true : newValue instanceof Model) ? newValue : THROW_CCE());
  };
  protoOf(Entity$modelProperty$1).v3f = function (handler) {
    return this.t3f_1.w3f(this.s3f_1, handler);
  };
  protoOf(Entity$modelProperty$1).y2r = function (handler) {
    return this.v3f(handler);
  };
  function Entity$get$1(this$0, $refId) {
    this.a3g_1 = this$0;
    this.b3g_1 = $refId;
    SafeObservableHashSet.call(this, this$0);
  }
  protoOf(Entity$get$1).c3g = function (item) {
    protoOf(SafeObservableHashSet).q2t.call(this, item);
    // Inline function 'kotlin.check' call
    if (!(!this.b3g_1.f3g() || this.s())) {
      var message = 'Adding second item to single reference role ' + this.b3g_1.toString();
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
  };
  protoOf(Entity$get$1).q2t = function (item) {
    return this.c3g((item == null ? true : item instanceof EntityReference) ? item : THROW_CCE());
  };
  protoOf(Entity$get$1).g3g = function (item) {
    ensureNotNull(this.a3g_1.q3d_1).h3g(this.a3g_1, this.b3g_1, new CollectionItemEvent(null, item, -1, EventType_ADD_getInstance()));
  };
  protoOf(Entity$get$1).o3f = function (item) {
    return this.g3g((item == null ? true : item instanceof EntityReference) ? item : THROW_CCE());
  };
  protoOf(Entity$get$1).i3g = function (item) {
    ensureNotNull(this.a3g_1.q3d_1).h3g(this.a3g_1, this.b3g_1, new CollectionItemEvent(item, null, -1, EventType_REMOVE_getInstance()));
  };
  protoOf(Entity$get$1).p3f = function (item) {
    return this.i3g((item == null ? true : item instanceof EntityReference) ? item : THROW_CCE());
  };
  function Entity$get$2(this$0, $childId) {
    this.y3e_1 = this$0;
    this.z3e_1 = $childId;
    SafeEntityHashSet.call(this);
  }
  protoOf(Entity$get$2).j3g = function (item) {
    checkCanModify(this.y3e_1);
    // Inline function 'kotlin.require' call
    if (!(ensureNotNull(item).bp() == null)) {
      var message = getCantAddMessage(this, item) + ': entity has parent ' + ensureNotNull(item.bp()).n3d_1.toString();
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    // Inline function 'kotlin.check' call
    if (!(!this.z3e_1.f3g() || this.s())) {
      var message_0 = getCantAddMessage(this, item) + ': adding second item to single child role ' + this.z3e_1.toString();
      throw IllegalStateException_init_$Create$_0(toString_1(message_0));
    }
    var addNewEntity = item.q3d_1 == null && (this.y3e_1.q3d_1 == null || ensureNotNull(this.y3e_1.q3d_1).k3g(item));
    var moving = item.y3d_1 && equals(item.q3d_1, this.y3e_1.q3d_1);
    // Inline function 'kotlin.require' call
    if (!(addNewEntity || moving)) {
      var message_1 = getCantAddMessage(this, item) + ": entity's context=" + toString_0(item.q3d_1) + ', entity is moving=' + item.y3d_1;
      throw IllegalArgumentException_init_$Create$_0(toString_1(message_1));
    }
  };
  protoOf(Entity$get$2).q2t = function (item) {
    return this.j3g((item == null ? true : item instanceof Entity) ? item : THROW_CCE());
  };
  protoOf(Entity$get$2).l3g = function (item) {
    checkCanModify(this.y3e_1);
    // Inline function 'kotlin.require' call
    if (!equals(ensureNotNull(item).bp(), this.y3e_1)) {
      var message = getCantRemoveMessage(this, item) + ": entity's parent=" + item.bp() + ', try to remove from ' + this.y3e_1.n3d_1.toString();
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    // Inline function 'kotlin.require' call
    if (!(this.y3e_1.q3d_1 == null || ensureNotNull(this.y3e_1.q3d_1).m3g(item))) {
      var message_0 = getCantRemoveMessage(this, item) + ": entity's context=" + toString_0(item.q3d_1);
      throw IllegalArgumentException_init_$Create$_0(toString_1(message_0));
    }
  };
  protoOf(Entity$get$2).t2t = function (item) {
    return this.l3g((item == null ? true : item instanceof Entity) ? item : THROW_CCE());
  };
  protoOf(Entity$get$2).n3g = function (item) {
    ensureNotNull(item).o3d_1.c2x(this.y3e_1);
    item.p3d_1 = this.z3e_1;
  };
  protoOf(Entity$get$2).r2t = function (item) {
    return this.n3g((item == null ? true : item instanceof Entity) ? item : THROW_CCE());
  };
  protoOf(Entity$get$2).o3g = function (item) {
    item.o3d_1.c9();
    if (this.p() === 1) {
      incNonEmptyFeatures(this.y3e_1);
    }
    if (contextEvent(this.y3e_1, item)) {
      ensureNotNull(this.y3e_1.q3d_1).r3g(this.y3e_1, this.z3e_1, new CollectionItemEvent(null, item, -1, EventType_ADD_getInstance()));
    }
  };
  protoOf(Entity$get$2).s3g = function (item) {
    ensureNotNull(item).o3d_1.c2x(null);
    item.p3d_1 = null;
  };
  protoOf(Entity$get$2).u2t = function (item) {
    return this.s3g((item == null ? true : item instanceof Entity) ? item : THROW_CCE());
  };
  protoOf(Entity$get$2).t3g = function (item) {
    item.o3d_1.c9();
    if (this.s()) {
      decNonEmptyFeatures(this.y3e_1);
    }
    if (contextEvent(this.y3e_1, item)) {
      ensureNotNull(this.y3e_1.q3d_1).r3g(this.y3e_1, this.z3e_1, new CollectionItemEvent(item, null, -1, EventType_REMOVE_getInstance()));
    }
  };
  protoOf(Entity$get$2).u3g = function () {
    setEventInProgress(this.y3e_1, true);
  };
  protoOf(Entity$get$2).v3g = function () {
    setEventInProgress(this.y3e_1, false);
  };
  function Entity$get$3(this$0) {
    this.e3h_1 = this$0;
    CollectionAdapter.call(this);
  }
  protoOf(Entity$get$3).f3h = function (event) {
    if (contextEvent(this.e3h_1, event.u2r())) {
      ensureNotNull(this.e3h_1.q3d_1).g3h(event.u2r());
    }
  };
  protoOf(Entity$get$3).m2r = function (event) {
    return this.f3h(event);
  };
  protoOf(Entity$get$3).h3h = function (event) {
    if (contextEvent(this.e3h_1, event.s2r())) {
      ensureNotNull(this.e3h_1.q3d_1).i3h(event.s2r());
    }
  };
  protoOf(Entity$get$3).t2r = function (event) {
    return this.h3h(event);
  };
  function Entity(conceptId, id) {
    id = id === VOID ? EntityId_init_$Create$() : id;
    this.m3d_1 = conceptId;
    this.n3d_1 = id;
    this.o3d_1 = new DelayedValueProperty();
    this.p3d_1 = null;
    this.q3d_1 = null;
    this.r3d_1 = null;
    this.s3d_1 = new Listeners();
    this.t3d_1 = null;
    this.u3d_1 = new Listeners();
    this.v3d_1 = null;
    this.w3d_1 = null;
    this.x3d_1 = 0;
    this.y3d_1 = false;
  }
  protoOf(Entity).bp = function () {
    return this.o3d_1.uv();
  };
  protoOf(Entity).c3e = function () {
    return this.r3d_1 == null ? emptySet() : ensureNotNull(this.r3d_1).x2m();
  };
  protoOf(Entity).h3e = function () {
    return this.t3d_1 == null ? emptySet() : ensureNotNull(this.t3d_1).x2m();
  };
  protoOf(Entity).f3e = function () {
    return this.v3d_1 == null ? emptySet() : ensureNotNull(this.v3d_1).x2m();
  };
  protoOf(Entity).z3d = function () {
    return this.w3d_1 == null ? emptySet() : ensureNotNull(this.w3d_1).x2m();
  };
  protoOf(Entity).w2m = function () {
    return this.x3d_1 === 0;
  };
  protoOf(Entity).j3h = function () {
    return this.o3d_1;
  };
  protoOf(Entity).k3h = function (ctx) {
    if (!(this.q3d_1 == null)) {
      throw OtException_init_$Create$();
    }
    this.q3d_1 = ctx;
  };
  protoOf(Entity).l3h = function () {
    if (this.q3d_1 == null) {
      throw OtException_init_$Create$();
    }
    this.q3d_1 = null;
  };
  protoOf(Entity).m3h = function () {
    checkCanModify(this);
    var tmp0 = this.bp();
    $l$block: {
      // Inline function 'kotlin.checkNotNull' call
      if (tmp0 == null) {
        var message = 'Delete root is inapplicable';
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      } else {
        break $l$block;
      }
    }
    ensureNotNull(this.bp()).a3e(ensureNotNull(this.p3d_1)).h2(this);
  };
  protoOf(Entity).n3h = function (newParent) {
    if (this.bp() == null)
      return false;
    if (equals(newParent, this.bp()))
      return false;
    var p = newParent;
    while (!(p == null)) {
      if (equals(p, this))
        return false;
      p = p.bp();
    }
    return Entities_getInstance().t3e(this) === Entities_getInstance().t3e(newParent);
  };
  protoOf(Entity).o3h = function (newParent) {
    checkCanModify(this);
    // Inline function 'kotlin.check' call
    if (!this.n3h(newParent)) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    var role = ensureNotNull(this.p3d_1);
    var oldParent = this.bp();
    this.y3d_1 = true;
    try {
      ensureNotNull(oldParent).a3e(role).h2(this);
      newParent.a3e(role).j(this);
    }finally {
      this.y3d_1 = false;
    }
    if (!(this.q3d_1 == null)) {
      ensureNotNull(this.q3d_1).h3f(true);
      try {
        ensureNotNull(this.q3d_1).p3h(this, oldParent);
      }finally {
        ensureNotNull(this.q3d_1).h3f(false);
      }
    }
  };
  protoOf(Entity).d3e = function (propId) {
    return this.r3d_1 == null ? null : ensureNotNull(this.r3d_1).q2(propId);
  };
  protoOf(Entity).e3e = function (propId, newValue) {
    checkCanModify(this);
    var oldValue = this.d3e(propId);
    if (oldValue == newValue)
      return Unit_instance;
    if (newValue == null) {
      ensureNotNull(this.r3d_1).u2(propId);
      if (ensureNotNull(this.r3d_1).w2m()) {
        this.r3d_1 = null;
        decNonEmptyFeatures(this);
      }
    } else {
      if (this.r3d_1 == null) {
        this.r3d_1 = new ListMap();
        incNonEmptyFeatures(this);
      }
      ensureNotNull(this.r3d_1).t2(propId, newValue);
    }
    setEventInProgress(this, true);
    try {
      var event = new PropertyChangeEvent(oldValue, newValue);
      var tmp0_safe_receiver = this.q3d_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.q3h(this, propId, event);
      }
      this.s3d_1.k2s(Entity$set$lambda(propId, event));
    }finally {
      setEventInProgress(this, false);
    }
  };
  protoOf(Entity).i3e = function (modelId) {
    return this.t3d_1 == null ? null : ensureNotNull(this.t3d_1).q2(modelId);
  };
  protoOf(Entity).j3e = function (modelId, model) {
    checkCanModify(this);
    var oldValue = this.i3e(modelId);
    if (equals(oldValue, model))
      return Unit_instance;
    if (oldValue == null)
      null;
    else {
      oldValue.r3h(new NullEventStateHolder());
    }
    if (model == null) {
      ensureNotNull(this.t3d_1).u2(modelId);
      if (ensureNotNull(this.t3d_1).w2m()) {
        this.t3d_1 = null;
        decNonEmptyFeatures(this);
      }
    } else {
      if (this.t3d_1 == null) {
        this.t3d_1 = new ListMap();
        incNonEmptyFeatures(this);
      }
      ensureNotNull(this.t3d_1).t2(modelId, model);
    }
    setEventInProgress(this, true);
    try {
      var event = new PropertyChangeEvent(oldValue, model);
      var tmp1_safe_receiver = this.q3d_1;
      if (tmp1_safe_receiver == null)
        null;
      else {
        tmp1_safe_receiver.s3h(this, modelId, event);
      }
      this.u3d_1.k2s(Entity$set$lambda_0(modelId, event));
    }finally {
      setEventInProgress(this, false);
    }
  };
  protoOf(Entity).w3f = function (modelId, handler) {
    return this.u3d_1.j2s(new ModelListenerData(modelId, handler));
  };
  protoOf(Entity).t3h = function (blobId) {
    return new Entity$modelProperty$1(blobId, this);
  };
  protoOf(Entity).g3e = function (refId) {
    var entityReferences = this.v3d_1;
    if (entityReferences == null) {
      entityReferences = new ListMap();
      this.v3d_1 = entityReferences;
    }
    var result = entityReferences.q2(refId);
    if (result == null) {
      result = new Entity$get$1(this, refId);
      entityReferences.t2(refId, result);
    }
    return result;
  };
  protoOf(Entity).a3e = function (childId) {
    var children = this.w3d_1;
    if (children == null) {
      children = new ListMap();
      this.w3d_1 = children;
    }
    var result = children.q2(childId);
    if (result == null) {
      result = new Entity$get$2(this, childId);
      var tmp = result;
      tmp.x2r(new Entity$get$3(this));
      children.t2(childId, result);
    }
    return result;
  };
  protoOf(Entity).toString = function () {
    return this.n3d_1.toString() + '(' + this.m3d_1.toString() + ')';
  };
  function EntityChildId_init_$Init$(flags, $this) {
    RoleId_init_$Init$(flags, $this);
    EntityChildId.call($this);
    return $this;
  }
  function EntityChildId_init_$Create$(flags) {
    return EntityChildId_init_$Init$(flags, objectCreate(protoOf(EntityChildId)));
  }
  function EntityChildId_init_$Init$_0(id, flags, $this) {
    RoleId_init_$Init$_0(id, flags, $this);
    EntityChildId.call($this);
    return $this;
  }
  function EntityChildId_init_$Create$_0(id, flags) {
    return EntityChildId_init_$Init$_0(id, flags, objectCreate(protoOf(EntityChildId)));
  }
  function EntityChildId() {
  }
  function EntityConceptId_init_$Init$($this) {
    MetaId_init_$Init$(Companion_getInstance_43().x3h_1, $this);
    EntityConceptId.call($this);
    return $this;
  }
  function EntityConceptId_init_$Create$() {
    return EntityConceptId_init_$Init$(objectCreate(protoOf(EntityConceptId)));
  }
  function EntityConceptId_init_$Init$_0(id, $this) {
    MetaId_init_$Init$_0(id, Companion_getInstance_43().x3h_1, $this);
    EntityConceptId.call($this);
    return $this;
  }
  function EntityConceptId_init_$Create$_0(id) {
    return EntityConceptId_init_$Init$_0(id, objectCreate(protoOf(EntityConceptId)));
  }
  function Companion_43() {
    Companion_instance_43 = this;
    this.x3h_1 = emptySet();
  }
  var Companion_instance_43;
  function Companion_getInstance_43() {
    if (Companion_instance_43 == null)
      new Companion_43();
    return Companion_instance_43;
  }
  function EntityConceptId() {
    Companion_getInstance_43();
  }
  var EntityConceptIdFlag_TRANSIENT_instance;
  var EntityConceptIdFlag_NOTIFY_instance;
  function values_0() {
    return [EntityConceptIdFlag_TRANSIENT_getInstance(), EntityConceptIdFlag_NOTIFY_getInstance()];
  }
  var EntityConceptIdFlag_entriesInitialized;
  function EntityConceptIdFlag_initEntries() {
    if (EntityConceptIdFlag_entriesInitialized)
      return Unit_instance;
    EntityConceptIdFlag_entriesInitialized = true;
    EntityConceptIdFlag_TRANSIENT_instance = new EntityConceptIdFlag('TRANSIENT', 0);
    EntityConceptIdFlag_NOTIFY_instance = new EntityConceptIdFlag('NOTIFY', 1);
  }
  function EntityConceptIdFlag(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function EntityConceptIdFlag_TRANSIENT_getInstance() {
    EntityConceptIdFlag_initEntries();
    return EntityConceptIdFlag_TRANSIENT_instance;
  }
  function EntityConceptIdFlag_NOTIFY_getInstance() {
    EntityConceptIdFlag_initEntries();
    return EntityConceptIdFlag_NOTIFY_instance;
  }
  function EntityContext$SafeEntityHashSet$1(this$0) {
    this.y3h_1 = this$0;
    CollectionAdapter.call(this);
  }
  protoOf(EntityContext$SafeEntityHashSet$1).f3h = function (event) {
    return this.y3h_1.u3g();
  };
  protoOf(EntityContext$SafeEntityHashSet$1).m2r = function (event) {
    return this.f3h(event);
  };
  protoOf(EntityContext$SafeEntityHashSet$1).h3h = function (event) {
    return this.y3h_1.u3g();
  };
  protoOf(EntityContext$SafeEntityHashSet$1).t2r = function (event) {
    return this.h3h(event);
  };
  function watchModelBlob($this, entity, modelBlobId) {
    var tmp0_elvis_lhs = entity.i3e(modelBlobId);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw OtException_init_$Create$();
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var model = tmp;
    model.r3h($this.f3f_1);
    var nodeFeatureChangedRegistration = model.z3h(new EntityContext$watchModelBlob$nodeFeatureChangedRegistration$1($this, entity, modelBlobId));
    // Inline function 'kotlin.collections.getOrPut' call
    var this_0 = $this.e3f_1;
    var value = this_0.q2(entity);
    var tmp_0;
    if (value == null) {
      var answer = new ListMap();
      this_0.t2(entity, answer);
      tmp_0 = answer;
    } else {
      tmp_0 = value;
    }
    var registrations = tmp_0;
    registrations.t2(modelBlobId, nodeFeatureChangedRegistration);
    $this.d3f_1.k2s(EntityContext$watchModelBlob$lambda(model));
  }
  function unwatchModelBlob($this, entity, modelBlobId, model) {
    var registrations = $this.e3f_1.q2(entity);
    ensureNotNull(ensureNotNull(registrations).u2(modelBlobId)).zr();
    if (registrations.w2m()) {
      $this.e3f_1.u2(entity);
    }
    $this.d3f_1.k2s(EntityContext$unwatchModelBlob$lambda(model));
  }
  function fire_0($this, event) {
    var tmp = $this.f3f_1;
    tmp.b3i(EntityContext$fire$lambda($this, event));
  }
  function SafeEntityHashSet() {
    EntityHashSet.call(this);
    this.x2r(new EntityContext$SafeEntityHashSet$1(this));
  }
  protoOf(SafeEntityHashSet).y3g = function (item, success) {
    if (!success)
      return Unit_instance;
    try {
      this.o3g(ensureNotNull(item));
    }finally {
      this.v3g();
    }
  };
  protoOf(SafeEntityHashSet).s2t = function (item, success) {
    return this.y3g((item == null ? true : item instanceof Entity) ? item : THROW_CCE(), success);
  };
  protoOf(SafeEntityHashSet).z3g = function (item, success) {
    if (!success)
      return Unit_instance;
    try {
      this.t3g(ensureNotNull(item));
    }finally {
      this.v3g();
    }
  };
  protoOf(SafeEntityHashSet).v2t = function (item, success) {
    return this.z3g((item == null ? true : item instanceof Entity) ? item : THROW_CCE(), success);
  };
  function EntityContext$rootEntities$1(this$0) {
    this.e3i_1 = this$0;
    SafeEntityHashSet.call(this);
  }
  protoOf(EntityContext$rootEntities$1).j3g = function (item) {
    this.e3i_1.i3f();
    // Inline function 'kotlin.check' call
    if (!(ensureNotNull(item).bp() == null && this.e3i_1.k3g(item))) {
      var message = "Can't add root " + item.toString() + ', parent=' + toString_0(item.bp()) + ', context=' + toString_0(item.q3d_1);
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
  };
  protoOf(EntityContext$rootEntities$1).q2t = function (item) {
    return this.j3g((item == null ? true : item instanceof Entity) ? item : THROW_CCE());
  };
  protoOf(EntityContext$rootEntities$1).o3g = function (item) {
    var event = new RootAddedEvent(item);
    fire_0(this.e3i_1, event);
  };
  protoOf(EntityContext$rootEntities$1).l3g = function (item) {
    this.e3i_1.i3f();
    // Inline function 'kotlin.check' call
    if (!this.e3i_1.m3g(ensureNotNull(item))) {
      var message = "Can't remove root " + item + ', context=' + toString_0(item.q3d_1);
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
  };
  protoOf(EntityContext$rootEntities$1).t2t = function (item) {
    return this.l3g((item == null ? true : item instanceof Entity) ? item : THROW_CCE());
  };
  protoOf(EntityContext$rootEntities$1).t3g = function (item) {
    fire_0(this.e3i_1, new RootRemovedEvent(item));
  };
  protoOf(EntityContext$rootEntities$1).u3g = function () {
    this.e3i_1.h3f(true);
  };
  protoOf(EntityContext$rootEntities$1).v3g = function () {
    this.e3i_1.h3f(false);
  };
  function EntityContext$1(this$0) {
    this.f3i_1 = this$0;
    CollectionAdapter.call(this);
  }
  protoOf(EntityContext$1).f3h = function (event) {
    return this.f3i_1.g3h(event.u2r());
  };
  protoOf(EntityContext$1).m2r = function (event) {
    return this.f3h(event);
  };
  protoOf(EntityContext$1).h3h = function (event) {
    return this.f3i_1.i3h(event.s2r());
  };
  protoOf(EntityContext$1).t2r = function (event) {
    return this.h3h(event);
  };
  function EntityContext$attach$lambda($entity) {
    return function (listener) {
      listener.g3i($entity);
      return Unit_instance;
    };
  }
  function EntityContext$detach$lambda($entity) {
    return function (listener) {
      listener.h3i($entity);
      return Unit_instance;
    };
  }
  function EntityContext$watchModelBlob$nodeFeatureChangedRegistration$1(this$0, $entity, $modelBlobId) {
    this.i3i_1 = this$0;
    this.j3i_1 = $entity;
    this.k3i_1 = $modelBlobId;
    ModelAdapter.call(this);
  }
  protoOf(EntityContext$watchModelBlob$nodeFeatureChangedRegistration$1).l3i = function (event) {
    fire_0(this.i3i_1, new EntityNodeEvent(this.j3i_1, this.k3i_1, event));
  };
  function EntityContext$watchModelBlob$lambda($model) {
    return function (listener) {
      listener.w3i($model);
      return Unit_instance;
    };
  }
  function EntityContext$unwatchModelBlob$lambda($model) {
    return function (listener) {
      listener.x3i($model);
      return Unit_instance;
    };
  }
  function EntityEvent$dispatch$ref(p0) {
    var l = function (_this__u8e3s4) {
      p0.z3i(_this__u8e3s4);
      return Unit_instance;
    };
    l.callableName = 'dispatch';
    return l;
  }
  function EntityContext$fire$lambda(this$0, $event) {
    return function () {
      this$0.b3f_1.k2s(EntityEvent$dispatch$ref($event));
      return Unit_instance;
    };
  }
  function EntityContext() {
    this.a3f_1 = new EntityHashSet();
    this.b3f_1 = new Listeners();
    this.c3f_1 = new Listeners();
    this.d3f_1 = new Listeners();
    this.e3f_1 = HashMap_init_$Create$();
    this.f3f_1 = new EventStateHolder();
    var tmp = this;
    tmp.g3f_1 = new EntityContext$rootEntities$1(this);
    this.g3f_1.x2r(new EntityContext$1(this));
  }
  protoOf(EntityContext).a3j = function () {
    return this.a3f_1;
  };
  protoOf(EntityContext).h3f = function (inProgress) {
    this.f3f_1.b3j(inProgress);
  };
  protoOf(EntityContext).r3h = function (eventStateHolder) {
    this.f3f_1.c3j(eventStateHolder);
    this.f3f_1 = eventStateHolder;
    var _iterator__ex2g4s = this.e3f_1.r2().m();
    while (_iterator__ex2g4s.n()) {
      var modelHolder = _iterator__ex2g4s.o();
      var _iterator__ex2g4s_0 = ensureNotNull(this.e3f_1.q2(modelHolder)).x2m().m();
      while (_iterator__ex2g4s_0.n()) {
        var id = _iterator__ex2g4s_0.o();
        ensureNotNull(modelHolder.i3e(id)).r3h(eventStateHolder);
      }
    }
  };
  protoOf(EntityContext).d3j = function (rootId) {
    return this.g3f_1.a3h(rootId);
  };
  protoOf(EntityContext).k3g = function (entity) {
    return !this.a3f_1.b3h(entity) && entity.q3d_1 == null;
  };
  protoOf(EntityContext).g3h = function (entity) {
    if (!this.k3g(entity)) {
      throw OtException_init_$Create$();
    }
    entity.k3h(this);
    var _iterator__ex2g4s = entity.z3d().m();
    while (_iterator__ex2g4s.n()) {
      var childId = _iterator__ex2g4s.o();
      var _iterator__ex2g4s_0 = entity.a3e(childId).m();
      while (_iterator__ex2g4s_0.n()) {
        var child = _iterator__ex2g4s_0.o();
        this.g3h(child);
      }
    }
    this.a3f_1.c2u(entity);
    var _iterator__ex2g4s_1 = entity.h3e().m();
    while (_iterator__ex2g4s_1.n()) {
      var modelBlobId = _iterator__ex2g4s_1.o();
      watchModelBlob(this, entity, modelBlobId);
    }
    this.c3f_1.k2s(EntityContext$attach$lambda(entity));
  };
  protoOf(EntityContext).q3h = function (entity, propertyId, event) {
    fire_0(this, new EntityPropertyChangedEvent(entity, propertyId, event.s2y_1, event.t2y_1));
  };
  protoOf(EntityContext).h3g = function (entity, referenceId, itemEvent) {
    var tmp;
    switch (itemEvent.r2r_1.x2_1) {
      case 0:
        tmp = new EntityReferenceAddedEvent(entity, referenceId, itemEvent.u2r());
        break;
      case 2:
        tmp = new EntityReferenceRemovedEvent(entity, referenceId, itemEvent.s2r());
        break;
      default:
        throw IllegalArgumentException_init_$Create$_0('Unsupported event type');
    }
    var event = tmp;
    fire_0(this, event);
  };
  protoOf(EntityContext).p3h = function (entity, oldParent) {
    var event = new EntityMovedEvent(entity, oldParent);
    fire_0(this, event);
  };
  protoOf(EntityContext).r3g = function (entity, childId, itemEvent) {
    var tmp;
    switch (itemEvent.r2r_1.x2_1) {
      case 0:
        tmp = new EntityChildAddedEvent(entity, childId, itemEvent.u2r());
        break;
      case 2:
        tmp = new EntityChildRemovedEvent(entity, childId, itemEvent.s2r());
        break;
      default:
        throw IllegalArgumentException_init_$Create$_0('Unsupported event type');
    }
    var event = tmp;
    fire_0(this, event);
  };
  protoOf(EntityContext).s3h = function (entity, blobId, event) {
    var oldValue = event.s2y_1;
    if (!(oldValue == null)) {
      unwatchModelBlob(this, entity, blobId, oldValue);
    }
    var newValue = event.t2y_1;
    if (!(newValue == null)) {
      watchModelBlob(this, entity, blobId);
    }
    fire_0(this, new EntityModelBlobChangedEvent(entity, blobId, oldValue, newValue));
  };
  protoOf(EntityContext).m3g = function (entity) {
    return this.a3f_1.b3h(entity) && equals(entity.q3d_1, this);
  };
  protoOf(EntityContext).i3h = function (entity) {
    if (!this.m3g(entity)) {
      throw OtException_init_$Create$();
    }
    this.a3f_1.f2u(entity);
    var _iterator__ex2g4s = entity.h3e().m();
    while (_iterator__ex2g4s.n()) {
      var modelBlobId = _iterator__ex2g4s.o();
      unwatchModelBlob(this, entity, modelBlobId, ensureNotNull(entity.i3e(modelBlobId)));
    }
    var _iterator__ex2g4s_0 = entity.z3d().m();
    while (_iterator__ex2g4s_0.n()) {
      var childId = _iterator__ex2g4s_0.o();
      var _iterator__ex2g4s_1 = entity.a3e(childId).m();
      while (_iterator__ex2g4s_1.n()) {
        var child = _iterator__ex2g4s_1.o();
        this.i3h(child);
      }
    }
    var registrations = this.e3f_1.u2(entity);
    if (!(registrations == null)) {
      var _iterator__ex2g4s_2 = registrations.y2m().m();
      while (_iterator__ex2g4s_2.n()) {
        var r = _iterator__ex2g4s_2.o();
        r.zr();
      }
    }
    entity.l3h();
    this.c3f_1.k2s(EntityContext$detach$lambda(entity));
  };
  protoOf(EntityContext).i3f = function () {
    return this.f3f_1.e3j();
  };
  protoOf(EntityContext).f3j = function (listener) {
    return this.b3f_1.j2s(listener);
  };
  protoOf(EntityContext).g3j = function (listener) {
    return this.c3f_1.j2s(listener);
  };
  protoOf(EntityContext).h3j = function (listener) {
    return this.d3f_1.j2s(listener);
  };
  protoOf(EntityContext).i3j = function (id) {
    return !(this.a3f_1.a3h(id) == null);
  };
  function ensureEntitiesInitialized($this) {
    if ($this.q3g_1 == null) {
      $this.q3g_1 = HashMap_init_$Create$_0(1);
    }
  }
  function EntityHashSet() {
    AbstractObservableSet.call(this);
    this.q3g_1 = null;
  }
  protoOf(EntityHashSet).a3h = function (id) {
    var map = this.q3g_1;
    return map == null ? null : map.q2(id);
  };
  protoOf(EntityHashSet).p = function () {
    return this.q3g_1 == null ? 0 : ensureNotNull(this.q3g_1).p();
  };
  protoOf(EntityHashSet).b3h = function (element) {
    if (this.q3g_1 == null)
      return false;
    return ensureNotNull(this.q3g_1).r2().t(element.n3d_1);
  };
  protoOf(EntityHashSet).t = function (element) {
    if (!(element instanceof Entity))
      return false;
    return this.b3h(element instanceof Entity ? element : THROW_CCE());
  };
  protoOf(EntityHashSet).c3h = function (item) {
    ensureEntitiesInitialized(this);
    var tmp0 = ensureNotNull(this.q3g_1);
    // Inline function 'kotlin.collections.set' call
    var key = item.n3d_1;
    tmp0.t2(key, item);
    return true;
  };
  protoOf(EntityHashSet).e2u = function (item) {
    return this.c3h(item instanceof Entity ? item : THROW_CCE());
  };
  protoOf(EntityHashSet).d3h = function (item) {
    return !(ensureNotNull(this.q3g_1).u2(item.n3d_1) == null);
  };
  protoOf(EntityHashSet).h2u = function (item) {
    return this.d3h(item instanceof Entity ? item : THROW_CCE());
  };
  protoOf(EntityHashSet).b2u = function () {
    return ensureNotNull(this.q3g_1).s2().m();
  };
  function EntityId_init_$Init$($this) {
    BaseId.call($this);
    EntityId.call($this);
    return $this;
  }
  function EntityId_init_$Create$() {
    return EntityId_init_$Init$(objectCreate(protoOf(EntityId)));
  }
  function EntityId_init_$Init$_0(id, $this) {
    BaseId.call($this, id);
    EntityId.call($this);
    return $this;
  }
  function EntityId_init_$Create$_0(id) {
    return EntityId_init_$Init$_0(id, objectCreate(protoOf(EntityId)));
  }
  function EntityId() {
  }
  function EntityModelBlobId_init_$Init$($this) {
    BaseId.call($this);
    EntityModelBlobId.call($this);
    return $this;
  }
  function EntityModelBlobId_init_$Create$() {
    return EntityModelBlobId_init_$Init$(objectCreate(protoOf(EntityModelBlobId)));
  }
  function EntityModelBlobId_init_$Init$_0(id, $this) {
    BaseId.call($this, id);
    EntityModelBlobId.call($this);
    return $this;
  }
  function EntityModelBlobId_init_$Create$_0(id) {
    return EntityModelBlobId_init_$Init$_0(id, objectCreate(protoOf(EntityModelBlobId)));
  }
  function EntityModelBlobId() {
  }
  function EntityPropertyId_init_$Init$($this) {
    BaseId.call($this);
    EntityPropertyId.call($this);
    return $this;
  }
  function EntityPropertyId_init_$Create$() {
    return EntityPropertyId_init_$Init$(objectCreate(protoOf(EntityPropertyId)));
  }
  function EntityPropertyId_init_$Init$_0(id, $this) {
    BaseId.call($this, id);
    EntityPropertyId.call($this);
    return $this;
  }
  function EntityPropertyId_init_$Create$_0(id) {
    return EntityPropertyId_init_$Init$_0(id, objectCreate(protoOf(EntityPropertyId)));
  }
  function EntityPropertyId() {
  }
  function Companion_44() {
  }
  var Companion_instance_44;
  function Companion_getInstance_44() {
    return Companion_instance_44;
  }
  function EntityReference(rootId, entityId) {
    entityId = entityId === VOID ? rootId : entityId;
    this.j3j_1 = rootId;
    this.k3j_1 = entityId;
  }
  protoOf(EntityReference).l3j = function () {
    return this.j3j_1.equals(this.k3j_1);
  };
  protoOf(EntityReference).equals = function (other) {
    if (this === other)
      return true;
    if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    var reference = other instanceof EntityReference ? other : THROW_CCE();
    if (!this.k3j_1.equals(reference.k3j_1))
      return false;
    return this.j3j_1.equals(reference.j3j_1);
  };
  protoOf(EntityReference).hashCode = function () {
    var result = this.j3j_1.hashCode();
    result = imul(31, result) + this.k3j_1.hashCode() | 0;
    return result;
  };
  protoOf(EntityReference).toString = function () {
    return '(' + this.j3j_1.toString() + ', ' + this.k3j_1.toString() + ')';
  };
  function EntityReferenceId_init_$Init$(id, flags, $this) {
    RoleId_init_$Init$_0(id, flags, $this);
    EntityReferenceId.call($this);
    return $this;
  }
  function EntityReferenceId_init_$Create$(id, flags) {
    return EntityReferenceId_init_$Init$(id, flags, objectCreate(protoOf(EntityReferenceId)));
  }
  function EntityReferenceId() {
  }
  function EntitySet() {
  }
  var ReferenceStatus_NOT_LOADED_instance;
  var ReferenceStatus_LOADED_instance;
  var ReferenceStatus_ERROR_instance;
  var ReferenceStatus_entriesInitialized;
  function ReferenceStatus_initEntries() {
    if (ReferenceStatus_entriesInitialized)
      return Unit_instance;
    ReferenceStatus_entriesInitialized = true;
    ReferenceStatus_NOT_LOADED_instance = new ReferenceStatus('NOT_LOADED', 0);
    ReferenceStatus_LOADED_instance = new ReferenceStatus('LOADED', 1);
    ReferenceStatus_ERROR_instance = new ReferenceStatus('ERROR', 2);
  }
  function ReferenceStatus(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function ReferenceStatus_NOT_LOADED_getInstance() {
    ReferenceStatus_initEntries();
    return ReferenceStatus_NOT_LOADED_instance;
  }
  function ReferenceStatus_LOADED_getInstance() {
    ReferenceStatus_initEntries();
    return ReferenceStatus_LOADED_instance;
  }
  function ReferenceStatus_ERROR_getInstance() {
    ReferenceStatus_initEntries();
    return ReferenceStatus_ERROR_instance;
  }
  function EntityChildAddedEvent(parent, childRole, child) {
    EntityChildEvent.call(this, parent, childRole, child);
  }
  protoOf(EntityChildAddedEvent).z3i = function (listener) {
    listener.p3j(this);
  };
  protoOf(EntityChildAddedEvent).toString = function () {
    return 'child added to ' + protoOf(EntityChildEvent).toString.call(this);
  };
  function EntityChildEvent(parent, childRole, child) {
    EntityEvent.call(this, parent);
    this.r3j_1 = childRole;
    this.s3j_1 = child;
  }
  protoOf(EntityChildEvent).toString = function () {
    return 'parent=' + this.y3i_1.toString() + ', role=' + this.r3j_1.toString() + ', child=' + this.s3j_1.toString();
  };
  function EntityChildRemovedEvent(parent, childRole, child) {
    EntityChildEvent.call(this, parent, childRole, child);
  }
  protoOf(EntityChildRemovedEvent).z3i = function (listener) {
    listener.w3j(this);
  };
  protoOf(EntityChildRemovedEvent).toString = function () {
    return 'child removed from ' + protoOf(EntityChildEvent).toString.call(this);
  };
  function EntityContextListener() {
  }
  function EntityEvent(entity) {
    this.y3i_1 = entity;
  }
  function EntityModelBlobChangedEvent(entity, modelBlobId, oldModel, newModel) {
    EntityEvent.call(this, entity);
    this.h3k_1 = modelBlobId;
    this.i3k_1 = oldModel;
    this.j3k_1 = newModel;
  }
  protoOf(EntityModelBlobChangedEvent).z3i = function (listener) {
    listener.e3k(this);
  };
  protoOf(EntityModelBlobChangedEvent).toString = function () {
    return 'model blob changed: entity=' + this.y3i_1.toString() + ', blobId=' + this.h3k_1.toString() + ', ' + toString_0(this.i3k_1) + ' -> ' + toString_0(this.j3k_1);
  };
  function EntityMovedEvent(entity, oldParent) {
    EntityEvent.call(this, entity);
    this.l3k_1 = oldParent;
  }
  protoOf(EntityMovedEvent).z3i = function (listener) {
    listener.a3k(this);
  };
  protoOf(EntityMovedEvent).toString = function () {
    return 'moved entity=' + this.y3i_1 + ' from ' + this.l3k_1 + ' to ' + toString_0(this.y3i_1.bp());
  };
  function EntityNodeEvent(entity, modelBlobId, nodeEvent) {
    EntityEvent.call(this, entity);
    this.n3k_1 = modelBlobId;
    this.o3k_1 = nodeEvent;
  }
  protoOf(EntityNodeEvent).z3i = function (listener) {
    listener.f3k(this);
  };
  protoOf(EntityNodeEvent).toString = function () {
    return 'node changed at entity=' + this.y3i_1.toString() + ', blobId=' + this.n3k_1.toString() + ' : ' + this.o3k_1.toString();
  };
  function EntityPropertyChangedEvent(entity, propertyId, oldValue, newValue) {
    EntityEvent.call(this, entity);
    this.q3k_1 = propertyId;
    this.r3k_1 = oldValue;
    this.s3k_1 = newValue;
  }
  protoOf(EntityPropertyChangedEvent).z3i = function (listener) {
    listener.b3k(this);
  };
  protoOf(EntityPropertyChangedEvent).toString = function () {
    return 'property changed: entity=' + this.y3i_1.toString() + ', propId=' + this.q3k_1.toString() + ', ' + this.r3k_1 + ' -> ' + this.s3k_1;
  };
  function EntityReferenceAddedEvent(entity, reference, value) {
    EntityReferenceEvent.call(this, entity, reference, value);
  }
  protoOf(EntityReferenceAddedEvent).z3i = function (listener) {
    listener.c3k(this);
  };
  protoOf(EntityReferenceAddedEvent).toString = function () {
    return 'reference added to ' + protoOf(EntityReferenceEvent).toString.call(this);
  };
  function EntityReferenceEvent(entity, referenceId, value) {
    EntityEvent.call(this, entity);
    this.x3k_1 = referenceId;
    this.y3k_1 = value;
  }
  protoOf(EntityReferenceEvent).toString = function () {
    return 'entity=' + this.y3i_1.toString() + ', refId=' + this.x3k_1.toString() + ', ref=' + this.y3k_1.toString();
  };
  function EntityReferenceRemovedEvent(entity, reference, value) {
    EntityReferenceEvent.call(this, entity, reference, value);
  }
  protoOf(EntityReferenceRemovedEvent).z3i = function (listener) {
    listener.d3k(this);
  };
  protoOf(EntityReferenceRemovedEvent).toString = function () {
    return 'reference removed from ' + protoOf(EntityReferenceEvent).toString.call(this);
  };
  function RootAddedEvent(entity) {
    EntityEvent.call(this, entity);
  }
  protoOf(RootAddedEvent).z3i = function (listener) {
    listener.x3j(this);
  };
  protoOf(RootAddedEvent).toString = function () {
    return 'root added : ' + this.y3i_1.toString();
  };
  function RootRemovedEvent(entity) {
    EntityEvent.call(this, entity);
  }
  protoOf(RootRemovedEvent).z3i = function (listener) {
    listener.z3j(this);
  };
  protoOf(RootRemovedEvent).toString = function () {
    return 'root removed : ' + this.y3i_1.toString();
  };
  function EventStateHolder() {
    this.a3i_1 = false;
  }
  protoOf(EventStateHolder).b3j = function (inProgress) {
    if (this.e3l() === inProgress) {
      throw OtException_init_$Create$_0("The 'event-in-progress' flag is already " + this.e3l());
    }
    this.a3i_1 = inProgress;
  };
  protoOf(EventStateHolder).e3l = function () {
    return this.a3i_1;
  };
  protoOf(EventStateHolder).e3j = function () {
    if (this.e3l()) {
      throw OtException_init_$Create$_0('Changing model inside event');
    }
  };
  protoOf(EventStateHolder).c3j = function (substitute) {
    if (this.e3l()) {
      throw OtException_init_$Create$_0(plus_12(getKClassFromExpression(this).ra(), ' cannot be reset while event is in progress'));
    }
  };
  protoOf(EventStateHolder).f3l = function (f) {
    this.b3j(true);
    try {
      f();
    }finally {
      this.b3j(false);
    }
  };
  protoOf(EventStateHolder).b3i = function (f) {
    if (!this.e3l()) {
      throw OtException_init_$Create$_0('Fire when event is not in progress');
    }
    f();
  };
  function NullEventStateHolder() {
    EventStateHolder.call(this);
  }
  protoOf(NullEventStateHolder).b3j = function (inProgress) {
  };
  protoOf(NullEventStateHolder).e3l = function () {
    return false;
  };
  protoOf(NullEventStateHolder).e3j = function () {
  };
  protoOf(NullEventStateHolder).c3j = function (substitute) {
  };
  protoOf(NullEventStateHolder).f3l = function (f) {
    return f();
  };
  protoOf(NullEventStateHolder).b3i = function (f) {
    return f();
  };
  function OtException_init_$Init$($this) {
    RuntimeException_init_$Init$($this);
    OtException.call($this);
    return $this;
  }
  function OtException_init_$Create$() {
    var tmp = OtException_init_$Init$(objectCreate(protoOf(OtException)));
    captureStack(tmp, OtException_init_$Create$);
    return tmp;
  }
  function OtException_init_$Init$_0(message, $this) {
    RuntimeException_init_$Init$_0(message, $this);
    OtException.call($this);
    return $this;
  }
  function OtException_init_$Create$_0(message) {
    var tmp = OtException_init_$Init$_0(message, objectCreate(protoOf(OtException)));
    captureStack(tmp, OtException_init_$Create$_0);
    return tmp;
  }
  function OtException_init_$Init$_1(message, cause, $this) {
    RuntimeException_init_$Init$_1(message, cause, $this);
    OtException.call($this);
    return $this;
  }
  function OtException_init_$Create$_1(message, cause) {
    var tmp = OtException_init_$Init$_1(message, cause, objectCreate(protoOf(OtException)));
    captureStack(tmp, OtException_init_$Create$_1);
    return tmp;
  }
  function OtException() {
    captureStack(this, OtException);
  }
  function readEntityReferenceIdList($this, arrayReader) {
    return arrayReader.x2i(Json2EntityConverter$readEntityReferenceIdList$lambda);
  }
  function readChildArray($this, arrayReader, entity) {
    return arrayReader.x2i(Json2EntityConverter$readChildArray$lambda($this, entity));
  }
  function Companion_45() {
  }
  var Companion_instance_45;
  function Companion_getInstance_45() {
    return Companion_instance_45;
  }
  function Json2EntityConverter$entityFromJson$lambda(this$0) {
    return function ($this$readArray) {
      var serializedEntityId = $this$readArray.y2i();
      // Inline function 'kotlin.checkNotNull' call
      $l$block: {
        // Inline function 'kotlin.checkNotNull' call
        if (serializedEntityId == null) {
          var message = 'Required value was null.';
          throw IllegalStateException_init_$Create$_0(toString_1(message));
        } else {
          break $l$block;
        }
      }
      var serializedConceptId = $this$readArray.y2i();
      // Inline function 'kotlin.checkNotNull' call
      $l$block_0: {
        // Inline function 'kotlin.checkNotNull' call
        if (serializedConceptId == null) {
          var message_0 = 'Required value was null.';
          throw IllegalStateException_init_$Create$_0(toString_1(message_0));
        } else {
          break $l$block_0;
        }
      }
      var conceptIdPersister = this$0.h3l_1.q3l(EntityIdModelKinds_getInstance().k3l_1);
      var conceptId = conceptIdPersister.p25(serializedConceptId);
      var entityIdPersister = this$0.h3l_1.q3l(EntityIdModelKinds_getInstance().j3l_1);
      var entityId = entityIdPersister.p25(serializedEntityId);
      var entity = new Entity(conceptId, entityId);
      var propertiesArrayReader = $this$readArray.z2i();
      // Inline function 'kotlin.checkNotNull' call
      $l$block_1: {
        // Inline function 'kotlin.checkNotNull' call
        if (propertiesArrayReader == null) {
          var message_1 = 'Required value was null.';
          throw IllegalStateException_init_$Create$_0(toString_1(message_1));
        } else {
          break $l$block_1;
        }
      }
      this$0.r3l(propertiesArrayReader, entity);
      var referencesArrayReader = $this$readArray.z2i();
      // Inline function 'kotlin.checkNotNull' call
      $l$block_2: {
        // Inline function 'kotlin.checkNotNull' call
        if (referencesArrayReader == null) {
          var message_2 = 'Required value was null.';
          throw IllegalStateException_init_$Create$_0(toString_1(message_2));
        } else {
          break $l$block_2;
        }
      }
      this$0.s3l(referencesArrayReader, entity);
      var modelObjectReader = $this$readArray.a2j();
      // Inline function 'kotlin.checkNotNull' call
      $l$block_3: {
        // Inline function 'kotlin.checkNotNull' call
        if (modelObjectReader == null) {
          var message_3 = 'Required value was null.';
          throw IllegalStateException_init_$Create$_0(toString_1(message_3));
        } else {
          break $l$block_3;
        }
      }
      this$0.t3l(modelObjectReader, entity);
      $l$loop: while (true) {
        var tmp0_elvis_lhs = $this$readArray.z2i();
        var tmp;
        if (tmp0_elvis_lhs == null) {
          break $l$loop;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var childArrayReader = tmp;
        readChildArray(this$0, childArrayReader, entity);
      }
      return entity;
    };
  }
  function Json2EntityConverter$jsonToProperties$lambda(this$0, $entity) {
    return function ($this$readArray) {
      var propertyIdPersister = this$0.h3l_1.q3l(EntityIdModelKinds_getInstance().l3l_1);
      $l$loop: while (true) {
        var tmp0_elvis_lhs = $this$readArray.y2i();
        var tmp;
        if (tmp0_elvis_lhs == null) {
          break $l$loop;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var serializedId = tmp;
        var value = $this$readArray.y2i();
        // Inline function 'kotlin.checkNotNull' call
        $l$block: {
          // Inline function 'kotlin.checkNotNull' call
          if (value == null) {
            var message = 'Required value was null.';
            throw IllegalStateException_init_$Create$_0(toString_1(message));
          } else {
            break $l$block;
          }
        }
        var propertyId = propertyIdPersister.p25(serializedId);
        $entity.e3e(propertyId, value);
      }
      return Unit_instance;
    };
  }
  function Json2EntityConverter$jsonToReferences$lambda(this$0, $entity) {
    return function ($this$readArray) {
      var referenceIdPersister = this$0.h3l_1.q3l(EntityIdModelKinds_getInstance().m3l_1);
      var entityReferencePersister = this$0.h3l_1.q3l(EntityIdModelKinds_getInstance().p3l_1);
      $l$loop: while (true) {
        var tmp0_elvis_lhs = $this$readArray.y2i();
        var tmp;
        if (tmp0_elvis_lhs == null) {
          break $l$loop;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var serializedId = tmp;
        var entityReferenceId = referenceIdPersister.p25(serializedId);
        var refs = $entity.g3e(entityReferenceId);
        var idListArrayReader = $this$readArray.z2i();
        // Inline function 'kotlin.checkNotNull' call
        $l$block: {
          // Inline function 'kotlin.checkNotNull' call
          if (idListArrayReader == null) {
            var message = 'Required value was null.';
            throw IllegalStateException_init_$Create$_0(toString_1(message));
          } else {
            break $l$block;
          }
        }
        var valueList = readEntityReferenceIdList(this$0, idListArrayReader);
        var _iterator__ex2g4s = valueList.m();
        while (_iterator__ex2g4s.n()) {
          var value = _iterator__ex2g4s.o();
          refs.j(entityReferencePersister.p25(value));
        }
      }
      return Unit_instance;
    };
  }
  function Json2EntityConverter$readEntityReferenceIdList$lambda($this$readArray) {
    var valueList = ArrayList_init_$Create$();
    $l$loop: while (true) {
      var tmp0_elvis_lhs = $this$readArray.y2i();
      var tmp;
      if (tmp0_elvis_lhs == null) {
        break $l$loop;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var value = tmp;
      valueList.j(value);
    }
    return valueList;
  }
  function Json2EntityConverter$jsonToModel$lambda(this$0, $entity) {
    return function ($this$readObject) {
      $l$loop: while (true) {
        var tmp0_elvis_lhs = $this$readObject.f2j();
        var tmp;
        if (tmp0_elvis_lhs == null) {
          break $l$loop;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var blobId = tmp;
        var arrayReader = $this$readObject.z2i();
        var rootNode = this$0.i3l_1.w3l(arrayReader);
        var model = new Model(rootNode);
        $entity.j3e(this$0.h3l_1.q3l(EntityIdModelKinds_getInstance().n3l_1).p25(blobId), model);
      }
      return Unit_instance;
    };
  }
  function Json2EntityConverter$readChildArray$lambda(this$0, $entity) {
    return function ($this$readArray) {
      var serializedChildId = $this$readArray.y2i();
      var childIdPersister = this$0.h3l_1.q3l(EntityIdModelKinds_getInstance().o3l_1);
      var entityChildId = childIdPersister.p25(serializedChildId);
      var childSet = $entity.a3e(entityChildId);
      $l$loop: while (true) {
        var tmp0_elvis_lhs = $this$readArray.z2i();
        var tmp;
        if (tmp0_elvis_lhs == null) {
          break $l$loop;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var childArrayReader = tmp;
        var childEntity = this$0.x3l(childArrayReader);
        childSet.j(childEntity);
      }
      return Unit_instance;
    };
  }
  function Json2EntityConverter(idContext, nodeFactory) {
    idContext = idContext === VOID ? new EntityIdPersistenceContext() : idContext;
    nodeFactory = nodeFactory === VOID ? RawNodeFactory_instance : nodeFactory;
    this.h3l_1 = idContext;
    this.i3l_1 = new Json2NodeConverter(this.h3l_1, nodeFactory);
  }
  protoOf(Json2EntityConverter).x3l = function (arrayReader) {
    return arrayReader.x2i(Json2EntityConverter$entityFromJson$lambda(this));
  };
  protoOf(Json2EntityConverter).r3l = function (arrayReader, entity) {
    return arrayReader.x2i(Json2EntityConverter$jsonToProperties$lambda(this, entity));
  };
  protoOf(Json2EntityConverter).s3l = function (arrayReader, entity) {
    return arrayReader.x2i(Json2EntityConverter$jsonToReferences$lambda(this, entity));
  };
  protoOf(Json2EntityConverter).t3l = function (objectReader, entity) {
    return objectReader.e2j(Json2EntityConverter$jsonToModel$lambda(this, entity));
  };
  function readProperties($this, objectReader, node) {
    return objectReader.e2j(Json2NodeConverter$readProperties$lambda($this, node));
  }
  function readChildren($this, objectReader, node) {
    return objectReader.e2j(Json2NodeConverter$readChildren$lambda($this, node));
  }
  function Json2NodeConverter$fromJson$lambda(this$0) {
    return function ($this$readArray) {
      var serializedId = $this$readArray.y2i();
      // Inline function 'kotlin.checkNotNull' call
      $l$block: {
        // Inline function 'kotlin.checkNotNull' call
        if (serializedId == null) {
          var message = 'Required value was null.';
          throw IllegalStateException_init_$Create$_0(toString_1(message));
        } else {
          break $l$block;
        }
      }
      var id = this$0.u3l_1.q3l(NodeIdModelKinds_getInstance().z3l_1).p25(serializedId);
      var serializedConceptId = $this$readArray.y2i();
      // Inline function 'kotlin.checkNotNull' call
      $l$block_0: {
        // Inline function 'kotlin.checkNotNull' call
        if (serializedConceptId == null) {
          var message_0 = 'Required value was null.';
          throw IllegalStateException_init_$Create$_0(toString_1(message_0));
        } else {
          break $l$block_0;
        }
      }
      var conceptId = this$0.u3l_1.q3l(NodeIdModelKinds_getInstance().a3m_1).p25(serializedConceptId);
      var node = this$0.v3l_1.d3m(conceptId, id);
      var propertiesObjectReader = $this$readArray.a2j();
      // Inline function 'kotlin.checkNotNull' call
      $l$block_1: {
        // Inline function 'kotlin.checkNotNull' call
        if (propertiesObjectReader == null) {
          var message_1 = 'Required value was null.';
          throw IllegalStateException_init_$Create$_0(toString_1(message_1));
        } else {
          break $l$block_1;
        }
      }
      readProperties(this$0, propertiesObjectReader, node);
      var childrenObjectReader = $this$readArray.a2j();
      // Inline function 'kotlin.checkNotNull' call
      $l$block_2: {
        // Inline function 'kotlin.checkNotNull' call
        if (childrenObjectReader == null) {
          var message_2 = 'Required value was null.';
          throw IllegalStateException_init_$Create$_0(toString_1(message_2));
        } else {
          break $l$block_2;
        }
      }
      readChildren(this$0, childrenObjectReader, node);
      return node;
    };
  }
  function Json2NodeConverter$readProperties$lambda(this$0, $node) {
    return function ($this$readObject) {
      var propertyIdPersister = this$0.u3l_1.q3l(NodeIdModelKinds_getInstance().b3m_1);
      $l$loop: while (true) {
        var tmp0_elvis_lhs = $this$readObject.f2j();
        var tmp;
        if (tmp0_elvis_lhs == null) {
          break $l$loop;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var propertyId = tmp;
        var nodePropertyId = propertyIdPersister.p25(propertyId);
        var value = $this$readObject.g2j();
        // Inline function 'kotlin.checkNotNull' call
        $l$block: {
          // Inline function 'kotlin.checkNotNull' call
          if (value == null) {
            var message = 'Required value was null.';
            throw IllegalStateException_init_$Create$_0(toString_1(message));
          } else {
            break $l$block;
          }
        }
        $node.o3m(nodePropertyId, value);
      }
      return Unit_instance;
    };
  }
  function Json2NodeConverter$readChildren$lambda$lambda($children, this$0) {
    return function ($this$readArray) {
      $l$loop: while (true) {
        var tmp0_elvis_lhs = $this$readArray.z2i();
        var tmp;
        if (tmp0_elvis_lhs == null) {
          break $l$loop;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var childArrayReader = tmp;
        $children.j(this$0.w3l(childArrayReader));
      }
      return Unit_instance;
    };
  }
  function Json2NodeConverter$readChildren$lambda(this$0, $node) {
    return function ($this$readObject) {
      var childIdPersister = this$0.u3l_1.q3l(NodeIdModelKinds_getInstance().c3m_1);
      $l$loop: while (true) {
        var tmp0_elvis_lhs = $this$readObject.f2j();
        var tmp;
        if (tmp0_elvis_lhs == null) {
          break $l$loop;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var childId = tmp;
        var nodeChildId = childIdPersister.p25(childId);
        var children = $node.p3m(nodeChildId);
        var arrayReader = $this$readObject.z2i();
        arrayReader.x2i(Json2NodeConverter$readChildren$lambda$lambda(children, this$0));
      }
      return Unit_instance;
    };
  }
  function Json2NodeConverter(idContext, nodeFactory) {
    nodeFactory = nodeFactory === VOID ? RawNodeFactory_instance : nodeFactory;
    this.u3l_1 = idContext;
    this.v3l_1 = nodeFactory;
  }
  protoOf(Json2NodeConverter).w3l = function (arrayReader) {
    return arrayReader.x2i(Json2NodeConverter$fromJson$lambda(this));
  };
  function Companion_46() {
  }
  var Companion_instance_46;
  function Companion_getInstance_46() {
    return Companion_instance_46;
  }
  function Entity2JsonConverter(idContext, filter) {
    idContext = idContext === VOID ? new EntityIdPersistenceContext() : idContext;
    filter = filter === VOID ? null : filter;
    this.q3m_1 = idContext;
    this.r3m_1 = filter;
    this.s3m_1 = new Node2JsonConverter(this.q3m_1);
  }
  protoOf(Entity2JsonConverter).t3m = function (entity) {
    var result = new JsonArray();
    result.m2h(ensureNotNull(this.q3m_1.q3l(EntityIdModelKinds_getInstance().j3l_1).w24(entity.n3d_1)));
    result.m2h(ensureNotNull(this.q3m_1.q3l(EntityIdModelKinds_getInstance().k3l_1).w24(entity.m3d_1)));
    result.y2g(this.x3m(entity, entity.c3e()));
    result.y2g(this.y3m(entity, entity.f3e()));
    result.y2g(this.z3m(entity, entity.h3e()));
    var _iterator__ex2g4s = entity.z3d().m();
    while (_iterator__ex2g4s.n()) {
      var cid = _iterator__ex2g4s.o();
      var child = new JsonArray();
      child.m2h(ensureNotNull(this.q3m_1.q3l(EntityIdModelKinds_getInstance().o3l_1).w24(cid)));
      var notEmpty = false;
      var _iterator__ex2g4s_0 = entity.a3e(cid).m();
      $l$loop: while (_iterator__ex2g4s_0.n()) {
        var cEntity = _iterator__ex2g4s_0.o();
        if (!(this.r3m_1 == null) && !this.r3m_1(cEntity)) {
          continue $l$loop;
        }
        notEmpty = true;
        child.y2g(this.t3m(cEntity));
      }
      if (notEmpty) {
        result.y2g(child);
      }
    }
    return result;
  };
  protoOf(Entity2JsonConverter).x3m = function (entity, ids) {
    var result = new JsonArray();
    var _iterator__ex2g4s = ids.m();
    $l$loop: while (_iterator__ex2g4s.n()) {
      var id = _iterator__ex2g4s.o();
      var tmp0_elvis_lhs = entity.d3e(id);
      var tmp;
      if (tmp0_elvis_lhs == null) {
        continue $l$loop;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var value = tmp;
      result.m2h(ensureNotNull(this.q3m_1.q3l(EntityIdModelKinds_getInstance().l3l_1).w24(id)));
      result.m2h(value);
    }
    return result;
  };
  protoOf(Entity2JsonConverter).y3m = function (entity, ids) {
    var result = new JsonArray();
    var _iterator__ex2g4s = ids.m();
    $l$loop: while (_iterator__ex2g4s.n()) {
      var refId = _iterator__ex2g4s.o();
      var refSet = entity.g3e(refId);
      if (refSet.s())
        continue $l$loop;
      result.m2h(ensureNotNull(this.q3m_1.q3l(EntityIdModelKinds_getInstance().m3l_1).w24(refId)));
      var refs = new JsonArray();
      var _iterator__ex2g4s_0 = refSet.m();
      while (_iterator__ex2g4s_0.n()) {
        var ref = _iterator__ex2g4s_0.o();
        refs.m2h(ensureNotNull(this.q3m_1.q3l(EntityIdModelKinds_getInstance().p3l_1).w24(ref)));
      }
      result.y2g(refs);
    }
    return result;
  };
  protoOf(Entity2JsonConverter).z3m = function (entity, ids) {
    var result = new JsonObject();
    var _iterator__ex2g4s = ids.m();
    $l$loop: while (_iterator__ex2g4s.n()) {
      var blobId = _iterator__ex2g4s.o();
      var tmp0_elvis_lhs = entity.i3e(blobId);
      var tmp;
      if (tmp0_elvis_lhs == null) {
        continue $l$loop;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var model = tmp;
      result.v2g(ensureNotNull(this.q3m_1.q3l(EntityIdModelKinds_getInstance().n3l_1).w24(blobId)), this.s3m_1.b3n(model.k3e_1));
    }
    return result;
  };
  function Node2JsonConverter(idContext) {
    this.a3n_1 = idContext;
  }
  protoOf(Node2JsonConverter).b3n = function (node) {
    var result = new JsonArray();
    result.m2h(ensureNotNull(this.a3n_1.q3l(NodeIdModelKinds_getInstance().z3l_1).w24(NodeUtil_instance.c3n(node))));
    result.m2h(ensureNotNull(this.a3n_1.q3l(NodeIdModelKinds_getInstance().a3m_1).w24(node.e3m_1)));
    var properties = new JsonObject();
    var _iterator__ex2g4s = node.c3e().m();
    while (_iterator__ex2g4s.n()) {
      var propertyId = _iterator__ex2g4s.o();
      properties.j2i(ensureNotNull(this.a3n_1.q3l(NodeIdModelKinds_getInstance().b3m_1).w24(propertyId)), node.d3n(propertyId).uv());
    }
    result.y2g(properties);
    var allChildren = new JsonObject();
    var _iterator__ex2g4s_0 = node.z3d().m();
    $l$loop: while (_iterator__ex2g4s_0.n()) {
      var childId = _iterator__ex2g4s_0.o();
      var childNodes = node.p3m(childId);
      if (childNodes.s()) {
        continue $l$loop;
      }
      var children = new JsonArray();
      var _iterator__ex2g4s_1 = childNodes.m();
      while (_iterator__ex2g4s_1.n()) {
        var child = _iterator__ex2g4s_1.o();
        children.y2g(this.b3n(child));
      }
      allChildren.v2g(ensureNotNull(this.a3n_1.q3l(NodeIdModelKinds_getInstance().c3m_1).w24(childId)), children);
    }
    result.y2g(allChildren);
    return result;
  };
  function getUnequalConceptsMessage($this, expected, actual) {
    return "Unequal concept ids: expected='" + expected + "', actual='" + actual + "'";
  }
  function MessageBundle() {
  }
  protoOf(MessageBundle).e3n = function (expected, actual) {
    return getUnequalConceptsMessage(this, expected.q36_1, actual.q36_1);
  };
  protoOf(MessageBundle).f3n = function (id1, id2) {
    return "Unequal role ids: id1='" + id1.q36_1 + "', id2='" + id2.q36_1 + "'";
  };
  protoOf(MessageBundle).g3n = function (id) {
    return "Cannot remove when not empty, id='" + (id == null ? null : id.q36_1) + "'";
  };
  protoOf(MessageBundle).h3n = function (id1, id2) {
    var tmp = id1 == null ? null : id1.q36_1;
    return "Unequal ids: id1='" + tmp + "', id2='" + (id2 == null ? null : id2.q36_1) + "'";
  };
  var MessageBundle_instance;
  function MessageBundle_getInstance() {
    return MessageBundle_instance;
  }
  function trySerializeCatching($this, value) {
    var tmp;
    try {
      tmp = $this.q3c().w24(value);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var e = $p;
        throw IllegalArgumentException_init_$Create$_1('Property ' + $this.i3n().toString() + '.' + $this.j3n().y2() + ' has assigned to non-serializable value: ' + toString_0(value), e);
      } else {
        throw $p;
      }
    }
    return tmp;
  }
  function tryDeserializeCatching($this, value) {
    var tmp;
    try {
      tmp = $this.q3c().p25(value);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var e = $p;
        throw IllegalStateException_init_$Create$_1('Property ' + $this.i3n().toString() + '.' + $this.j3n().y2() + ' contains non-deserializable value: ' + value, e);
      } else {
        throw $p;
      }
    }
    return tmp;
  }
  function BaseOtNodeProperty() {
    BaseReadableProperty.call(this);
  }
  protoOf(BaseOtNodeProperty).v2w = function () {
    return '' + getKClassFromExpression(this).ra() + '(' + this.i3n().toString() + '.' + this.j3n().y2() + ', ' + toString_1(this.q3c()) + ')';
  };
  protoOf(BaseOtNodeProperty).uv = function () {
    return tryDeserializeCatching(this, this.i3n().k3n(this.j3n()));
  };
  protoOf(BaseOtNodeProperty).d2x = function (newValue) {
    var value = trySerializeCatching(this, newValue);
    this.i3n().l3n(this.j3n(), value);
  };
  protoOf(BaseOtNodeProperty).u2w = function (handler) {
    return this.i3n().m3n(this.j3n(), new PropertyEventHandlerWrapper(handler, this.q3c()));
  };
  protoOf(BaseOtNodeProperty).y2r = function (handler) {
    return this.u2w(handler);
  };
  function BaseOtNodeTextProperty$addHandler$$inlined$eventHandler$1($handler) {
    this.n3n_1 = $handler;
  }
  protoOf(BaseOtNodeTextProperty$addHandler$$inlined$eventHandler$1).o2v = function (event) {
    var oldValue = event.s2y_1;
    if (oldValue == null) {
      var newValue = ensureNotNull(event.t2y_1);
      // Inline function 'kotlin.text.isNotEmpty' call
      if (charSequenceLength(newValue) > 0) {
        this.n3n_1.n2s(new PropertyChangeEvent('', newValue));
      }
    } else if (event.t2y_1 == null) {
      // Inline function 'kotlin.text.isNotEmpty' call
      if (charSequenceLength(oldValue) > 0) {
        this.n3n_1.n2s(new PropertyChangeEvent(oldValue, ''));
      }
    } else {
      var changeEvent = event instanceof PropertyChangeEvent ? event : THROW_CCE();
      this.n3n_1.n2s(changeEvent);
    }
    return Unit_instance;
  };
  protoOf(BaseOtNodeTextProperty$addHandler$$inlined$eventHandler$1).n2s = function (event) {
    return this.o2v((event == null ? true : !(event == null)) ? event : THROW_CCE());
  };
  function BaseOtNodeTextProperty() {
  }
  protoOf(BaseOtNodeTextProperty).v2w = function () {
    return 'text property [' + this.i3n().toString() + '.' + this.j3n().y2() + ']';
  };
  protoOf(BaseOtNodeTextProperty).o3n = function (index, text) {
    var s = this.i3n().k3n(this.j3n());
    var indexParam = s == null ? -1 : index;
    this.i3n().p3n(this.j3n(), indexParam, text);
  };
  protoOf(BaseOtNodeTextProperty).q3n = function (index, length) {
    var s = this.i3n().k3n(this.j3n());
    if (s == null) {
      // Inline function 'kotlin.require' call
      if (!(index === 0 && length === 0)) {
        var message = 'Incorrect deletion';
        throw IllegalArgumentException_init_$Create$_0(toString_1(message));
      }
      return Unit_instance;
    }
    var indexParam = s.length === length ? -1 : index;
    this.i3n().r3n(this.j3n(), indexParam, length);
  };
  protoOf(BaseOtNodeTextProperty).uv = function () {
    var tmp0_elvis_lhs = this.i3n().k3n(this.j3n());
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
  protoOf(BaseOtNodeTextProperty).s3n = function (handler) {
    // Inline function 'jetbrains.ocelot.base.observable.event.eventHandler' call
    var wrapper = new BaseOtNodeTextProperty$addHandler$$inlined$eventHandler$1(handler);
    return this.i3n().m3n(this.j3n(), wrapper);
  };
  protoOf(BaseOtNodeTextProperty).y2r = function (handler) {
    return this.s3n(handler);
  };
  function checkField($this, metaId, fieldName, value1, value2) {
    // Inline function 'kotlin.check' call
    if (!equals(value1, value2)) {
      var message = "for '" + $this.t3n_1 + "' instance: '" + toString_1(metaId) + "', field: '" + fieldName + "' values do not match: '" + toString_0(value1) + "', '" + toString_0(value2) + "'";
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
  }
  function MetaIdFactory(idClassName, defaultValue) {
    this.t3n_1 = idClassName;
    this.u3n_1 = defaultValue;
    this.v3n_1 = HashMap_init_$Create$();
  }
  protoOf(MetaIdFactory).w3n = function (id, name, flags) {
    var conceptId = this.v3n_1.q2(id);
    var tmp;
    if (conceptId == null) {
      // Inline function 'kotlin.collections.getOrPut' call
      var this_0 = this.v3n_1;
      var value = this_0.q2(id);
      var tmp_0;
      if (value == null) {
        var answer = this.u3n_1(id, name, flags);
        this_0.t2(id, answer);
        tmp_0 = answer;
      } else {
        tmp_0 = value;
      }
      tmp = tmp_0;
    } else {
      checkField(this, conceptId, 'flags', flags, conceptId.w3h());
      tmp = conceptId;
    }
    return tmp;
  };
  function startChanges($this) {
    // Inline function 'kotlin.check' call
    if (!!$this.p3e_1) {
      var message = 'Start new command while other command is in progress';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    $this.p3e_1 = true;
  }
  function endChanges($this) {
    // Inline function 'kotlin.check' call
    if (!$this.p3e_1) {
      var message = 'No command in progress';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    $this.p3e_1 = false;
  }
  function UnionNodeCollectionView($outer) {
    this.x3n_1 = $outer;
    AbstractCollection.call(this);
  }
  protoOf(UnionNodeCollectionView).p = function () {
    return this.x3n_1.l3e_1.p() + this.x3n_1.m3e_1.p() | 0;
  };
  protoOf(UnionNodeCollectionView).m = function () {
    var sequence = plus_9(asSequence_0(this.x3n_1.l3e_1.s2()), asSequence_0(this.x3n_1.m3e_1));
    return sequence.m();
  };
  protoOf(UnionNodeCollectionView).y3n = function (element) {
    var tmp;
    if (element.a3o()) {
      tmp = this.x3n_1.l3e_1.o2(element.z3n());
    } else {
      tmp = this.x3n_1.m3e_1.t(element);
    }
    return tmp;
  };
  protoOf(UnionNodeCollectionView).t = function (element) {
    if (!(element instanceof OtNode))
      return false;
    return this.y3n(element instanceof OtNode ? element : THROW_CCE());
  };
  function Model$register$lambda($node) {
    return function (listener) {
      listener.b3o($node);
      return Unit_instance;
    };
  }
  function Model$unregister$lambda($node) {
    return function (listener) {
      listener.c3o($node);
      return Unit_instance;
    };
  }
  function Model$onNodeChanged$lambda(this$0, $event) {
    return function () {
      this$0.n3e_1.q2v($event);
      return Unit_instance;
    };
  }
  function Model$fire$lambda(this$0, $event) {
    return function () {
      this$0.n3e_1.q2v($event);
      return Unit_instance;
    };
  }
  function Model(rootNode) {
    this.k3e_1 = rootNode;
    this.l3e_1 = HashMap_init_$Create$();
    this.m3e_1 = HashSet_init_$Create$();
    this.n3e_1 = new EventListeners();
    this.o3e_1 = new Listeners();
    this.p3e_1 = false;
    this.q3e_1 = new NullEventStateHolder();
    this.r3e_1 = false;
    if (!(this.k3e_1.d3o() == null)) {
      throw OtException_init_$Create$_0('Root node has parent');
    }
    this.e3o(this.k3e_1);
  }
  protoOf(Model).f3o = function () {
    return new UnionNodeCollectionView(this);
  };
  protoOf(Model).b3j = function (inProgress) {
    this.q3e_1.b3j(inProgress);
  };
  protoOf(Model).r3h = function (eventStateHolder) {
    this.q3e_1 = eventStateHolder;
  };
  protoOf(Model).g3o = function (id) {
    return this.l3e_1.q2(id);
  };
  protoOf(Model).s3e = function () {
    var rootNode = this.k3e_1.h3o();
    return new Model(rootNode);
  };
  protoOf(Model).z3h = function (listener) {
    return this.n3e_1.j2s(listener);
  };
  protoOf(Model).i3o = function (listener) {
    return this.o3e_1.j2s(listener);
  };
  protoOf(Model).j3o = function (node) {
    return !(this.f3o().t(node) || (node.a3o() && this.l3e_1.o2(node.z3n())));
  };
  protoOf(Model).k3o = function (node) {
    return this.f3o().t(node) && (!node.a3o() || this.l3e_1.o2(node.z3n()));
  };
  protoOf(Model).e3o = function (node) {
    if (!this.j3o(node)) {
      if (this.f3o().t(node))
        throw OtException_init_$Create$_0('Node is already registered');
      else if (node.a3o())
        throw OtException_init_$Create$_0("Duplicate node id='" + node.l3o() + "'");
      else
        throw OtException_init_$Create$_0("Can't register node=" + node.toString());
    }
    node.m3o(this);
    var _iterator__ex2g4s = node.z3d().m();
    while (_iterator__ex2g4s.n()) {
      var childId = _iterator__ex2g4s.o();
      var _iterator__ex2g4s_0 = node.p3m(childId).m();
      while (_iterator__ex2g4s_0.n()) {
        var child = _iterator__ex2g4s_0.o();
        try {
          this.e3o(child);
        } catch ($p) {
          if ($p instanceof OtException) {
            var e = $p;
            var nodeId = node.a3o() ? node.z3n() : null;
            var message = "Failed to register child. NodeId='" + toString_0(nodeId) + "', childId='" + childId.toString() + "'";
            throw OtException_init_$Create$_1(message, e);
          } else {
            throw $p;
          }
        }
      }
    }
    if (node.a3o()) {
      var tmp0 = this.l3e_1;
      // Inline function 'kotlin.collections.set' call
      var key = node.z3n();
      tmp0.t2(key, node);
    } else {
      this.m3e_1.j(node);
    }
    this.o3e_1.k2s(Model$register$lambda(node));
  };
  protoOf(Model).n3o = function (node) {
    if (!this.k3o(node)) {
      throw OtException_init_$Create$_0('Unregistered node id=' + node.z3n().toString());
    }
    if (node.a3o()) {
      this.l3e_1.u2(node.z3n());
    } else {
      this.m3e_1.h2(node);
    }
    var _iterator__ex2g4s = node.z3d().m();
    while (_iterator__ex2g4s.n()) {
      var childId = _iterator__ex2g4s.o();
      var _iterator__ex2g4s_0 = node.p3m(childId).m();
      while (_iterator__ex2g4s_0.n()) {
        var child = _iterator__ex2g4s_0.o();
        this.n3o(child);
      }
    }
    node.m3o(null);
    this.o3e_1.k2s(Model$unregister$lambda(node));
  };
  protoOf(Model).o3o = function (f) {
    startChanges(this);
    try {
      f();
    }finally {
      endChanges(this);
    }
  };
  protoOf(Model).p3o = function (event) {
    if (!this.p3e_1) {
      var tmp = this.q3e_1;
      tmp.b3i(Model$onNodeChanged$lambda(this, event));
    }
  };
  protoOf(Model).q3o = function (event) {
    var tmp = this.q3e_1;
    tmp.f3l(Model$fire$lambda(this, event));
  };
  protoOf(Model).i3f = function () {
    this.q3e_1.e3j();
  };
  function Node$getTextProperty$1(this$0, $propertyId) {
    BaseOtNodeTextProperty.call(this);
    this.r3o_1 = this$0;
    this.s3o_1 = $propertyId;
  }
  protoOf(Node$getTextProperty$1).i3n = function () {
    return this.r3o_1;
  };
  protoOf(Node$getTextProperty$1).j3n = function () {
    return this.s3o_1;
  };
  function Node_0(conceptId, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(conceptId) : nodeId;
    OtNode.call(this, conceptId, nodeId);
    this.e3p_1 = null;
    this.f3p_1 = null;
  }
  protoOf(Node_0).c3e = function () {
    var tmp0_safe_receiver = this.e3p_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.x2m();
    return tmp1_elvis_lhs == null ? emptySet() : tmp1_elvis_lhs;
  };
  protoOf(Node_0).z3d = function () {
    var tmp0_safe_receiver = this.f3p_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.x2m();
    return tmp1_elvis_lhs == null ? emptySet() : tmp1_elvis_lhs;
  };
  protoOf(Node_0).w2m = function () {
    var tmp;
    var tmp_0;
    if (this.f3p_1 == null) {
      tmp_0 = true;
    } else {
      var tmp0 = ensureNotNull(this.f3p_1).y2m();
      var tmp$ret$0;
      $l$block_0: {
        // Inline function 'kotlin.collections.all' call
        var tmp_1;
        if (isInterface(tmp0, Collection)) {
          tmp_1 = tmp0.s();
        } else {
          tmp_1 = false;
        }
        if (tmp_1) {
          tmp$ret$0 = true;
          break $l$block_0;
        }
        var _iterator__ex2g4s = tmp0.m();
        while (_iterator__ex2g4s.n()) {
          var element = _iterator__ex2g4s.o();
          if (!element.s()) {
            tmp$ret$0 = false;
            break $l$block_0;
          }
        }
        tmp$ret$0 = true;
      }
      tmp_0 = tmp$ret$0;
    }
    if (tmp_0) {
      tmp = this.e3p_1 == null || ensureNotNull(this.e3p_1).w2m();
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(Node_0).g3p = function (nodeId) {
    return new Node_0(this.e3m_1, nodeId);
  };
  protoOf(Node_0).k3n = function (propertyId) {
    var tmp0_safe_receiver = this.e3p_1;
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.q2(propertyId);
  };
  protoOf(Node_0).i3p = function (propertyId, value, oldValue) {
    if (oldValue == value)
      return true;
    if (value == null) {
      ensureNotNull(this.e3p_1).u2(propertyId);
      if (ensureNotNull(this.e3p_1).w2m()) {
        this.e3p_1 = null;
      }
    } else {
      if (this.e3p_1 == null) {
        this.e3p_1 = new ListMap();
      }
      ensureNotNull(this.e3p_1).t2(propertyId, value);
    }
    return false;
  };
  protoOf(Node_0).p3m = function (childId) {
    if (this.f3p_1 == null) {
      this.f3p_1 = new ListMap();
    }
    var list = ensureNotNull(this.f3p_1).q2(childId);
    if (list == null) {
      list = new ChildrenObservableList(this, childId);
      list.x2r(this);
      ensureNotNull(this.f3p_1).t2(childId, list);
    }
    return list;
  };
  protoOf(Node_0).j3p = function (propertyId) {
    return new Node$getTextProperty$1(this, propertyId);
  };
  function NodeChildId(id, name, flags) {
    RoleId_init_$Init$_1(id, name, flags, this);
  }
  function createDefaultId($this) {
    return Companion_getInstance_36().k36();
  }
  function NodeChildId$_init_$ref_694iog() {
    var l = function (p0, p1, p2) {
      return new NodeChildId(p0, p1, p2);
    };
    l.callableName = '<init>';
    return l;
  }
  function NodeChildIdFactory() {
    NodeChildIdFactory_instance = this;
    var tmp = this;
    tmp.d3q_1 = new MetaIdFactory('NodeChildId', NodeChildId$_init_$ref_694iog());
  }
  protoOf(NodeChildIdFactory).e3q = function (id, name) {
    return this.h3q(id, name, Companion_getInstance_76().g3q_1);
  };
  protoOf(NodeChildIdFactory).i3q = function (id, name, $super) {
    id = id === VOID ? createDefaultId(this) : id;
    name = name === VOID ? null : name;
    return $super === VOID ? this.e3q(id, name) : $super.e3q.call(this, id, name);
  };
  protoOf(NodeChildIdFactory).j3q = function (id, name) {
    return this.h3q(id, name, Companion_getInstance_76().f3q_1);
  };
  protoOf(NodeChildIdFactory).h3q = function (id, name, flags) {
    return this.d3q_1.w3n(id, name, flags);
  };
  var NodeChildIdFactory_instance;
  function NodeChildIdFactory_getInstance() {
    if (NodeChildIdFactory_instance == null)
      new NodeChildIdFactory();
    return NodeChildIdFactory_instance;
  }
  function NodeConceptId(id, name, flags) {
    MetaId_init_$Init$_1(id, name, flags, this);
  }
  protoOf(NodeConceptId).m3q = function () {
    return !this.w3h().t(NodeConceptIdFlag_NO_ID_getInstance());
  };
  protoOf(NodeConceptId).toString = function () {
    var string = protoOf(MetaId).toString.call(this);
    var tmp;
    if (this.m3q()) {
      tmp = string;
    } else {
      tmp = string + '(without id)';
    }
    return tmp;
  };
  function createDefaultId_0($this) {
    return Companion_getInstance_36().k36();
  }
  function NodeConceptId$_init_$ref_joxnlo() {
    var l = function (p0, p1, p2) {
      return new NodeConceptId(p0, p1, p2);
    };
    l.callableName = '<init>';
    return l;
  }
  function NodeConceptIdFactory() {
    NodeConceptIdFactory_instance = this;
    this.n3q_1 = emptySet();
    this.o3q_1 = setOf(NodeConceptIdFlag_NO_ID_getInstance());
    var tmp = this;
    tmp.p3q_1 = new MetaIdFactory('NodeConceptId', NodeConceptId$_init_$ref_joxnlo());
  }
  protoOf(NodeConceptIdFactory).q3q = function (id, name) {
    return this.r3q(id, name, this.n3q_1);
  };
  protoOf(NodeConceptIdFactory).s3q = function (id, name, $super) {
    id = id === VOID ? createDefaultId_0(this) : id;
    name = name === VOID ? null : name;
    return $super === VOID ? this.q3q(id, name) : $super.q3q.call(this, id, name);
  };
  protoOf(NodeConceptIdFactory).t3q = function (id, name) {
    return this.r3q(id, name, this.o3q_1);
  };
  protoOf(NodeConceptIdFactory).u3q = function (id, name, $super) {
    id = id === VOID ? createDefaultId_0(this) : id;
    name = name === VOID ? null : name;
    return $super === VOID ? this.t3q(id, name) : $super.t3q.call(this, id, name);
  };
  protoOf(NodeConceptIdFactory).r3q = function (id, name, flags) {
    return this.p3q_1.w3n(id, name, flags);
  };
  var NodeConceptIdFactory_instance;
  function NodeConceptIdFactory_getInstance() {
    if (NodeConceptIdFactory_instance == null)
      new NodeConceptIdFactory();
    return NodeConceptIdFactory_instance;
  }
  var NodeConceptIdFlag_NO_ID_instance;
  function values_1() {
    return [NodeConceptIdFlag_NO_ID_getInstance()];
  }
  var NodeConceptIdFlag_entriesInitialized;
  function NodeConceptIdFlag_initEntries() {
    if (NodeConceptIdFlag_entriesInitialized)
      return Unit_instance;
    NodeConceptIdFlag_entriesInitialized = true;
    NodeConceptIdFlag_NO_ID_instance = new NodeConceptIdFlag('NO_ID', 0);
  }
  function NodeConceptIdFlag(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function NodeConceptIdFlag_NO_ID_getInstance() {
    NodeConceptIdFlag_initEntries();
    return NodeConceptIdFlag_NO_ID_instance;
  }
  function NodeCopier() {
  }
  protoOf(NodeCopier).w3q = function (node) {
    var result = this.v3q(node);
    var _iterator__ex2g4s = node.c3e().m();
    while (_iterator__ex2g4s.n()) {
      var propertyId = _iterator__ex2g4s.o();
      result.d3n(propertyId).d2x(node.d3n(propertyId).uv());
    }
    var _iterator__ex2g4s_0 = node.z3d().m();
    $l$loop: while (_iterator__ex2g4s_0.n()) {
      var childId = _iterator__ex2g4s_0.o();
      var childNodes = node.p3m(childId);
      if (childNodes.s()) {
        continue $l$loop;
      }
      var resultChildren = result.p3m(childId);
      var _iterator__ex2g4s_1 = childNodes.m();
      while (_iterator__ex2g4s_1.n()) {
        var childNode = _iterator__ex2g4s_1.o();
        resultChildren.j(this.w3q(childNode));
      }
    }
    return result;
  };
  function NodeId(id) {
    id = id === VOID ? Companion_getInstance_36().k36() : id;
    BaseId.call(this, id);
  }
  function NodePropertyChangeEvent(propertyId, changeEvent) {
    this.x3q_1 = propertyId;
    this.y3q_1 = changeEvent;
  }
  function NodePropertyId(id, name) {
    BaseId.call(this, id, name);
  }
  function NodePropertyIdFactory() {
    NodePropertyIdFactory_instance = this;
    this.z3q_1 = HashMap_init_$Create$();
  }
  protoOf(NodePropertyIdFactory).a3r = function (id, name) {
    // Inline function 'kotlin.collections.getOrPut' call
    var this_0 = this.z3q_1;
    var value = this_0.q2(id);
    var tmp;
    if (value == null) {
      var answer = new NodePropertyId(id, name);
      this_0.t2(id, answer);
      tmp = answer;
    } else {
      tmp = value;
    }
    return tmp;
  };
  protoOf(NodePropertyIdFactory).b3r = function (id, name, $super) {
    id = id === VOID ? Companion_getInstance_36().k36() : id;
    name = name === VOID ? null : name;
    return $super === VOID ? this.a3r(id, name) : $super.a3r.call(this, id, name);
  };
  var NodePropertyIdFactory_instance;
  function NodePropertyIdFactory_getInstance() {
    if (NodePropertyIdFactory_instance == null)
      new NodePropertyIdFactory();
    return NodePropertyIdFactory_instance;
  }
  function checkStructureOnAdd($this, item) {
    $l$block: {
      // Inline function 'kotlin.requireNotNull' call
      if (item == null) {
        var message = 'Null children not allowed';
        throw IllegalArgumentException_init_$Create$_0(toString_1(message));
      } else {
        break $l$block;
      }
    }
    // Inline function 'kotlin.require' call
    if (!(item.d3o() == null)) {
      var message_0 = "Can't add node attached to another parent";
      throw IllegalArgumentException_init_$Create$_0(toString_1(message_0));
    }
    // Inline function 'kotlin.check' call
    if (!($this.g3r_1.g3m_1 == null || ensureNotNull($this.g3r_1.g3m_1).j3o(item) || $this.g3r_1.n3m_1)) {
      var message_1 = "Can't register node " + item.toString() + ' in model ' + toString_0($this.g3r_1.g3m_1);
      throw IllegalStateException_init_$Create$_0(toString_1(message_1));
    }
  }
  function checkStructureOnRemove($this, item) {
    // Inline function 'kotlin.require' call
    if (!equals(item.d3o(), $this.g3r_1)) {
      var message = 'Removing from the wrong parent';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    // Inline function 'kotlin.check' call
    if (!($this.g3r_1.g3m_1 == null || ensureNotNull($this.g3r_1.g3m_1).k3o(item))) {
      var message_0 = "Can't unregister node " + item.toString() + ' in model ' + toString_0($this.g3r_1.g3m_1);
      throw IllegalStateException_init_$Create$_0(toString_1(message_0));
    }
  }
  function attachItemStart($this, item, prevIndex, nextIndex) {
    item.h3m_1.c2x($this.g3r_1);
    item.i3m_1 = $this.f3r_1;
    if (0 <= prevIndex ? prevIndex < $this.p() : false) {
      var prev = $this.r(prevIndex);
      prev.k3m_1 = item;
      item.j3m_1 = prev;
    }
    if (0 <= nextIndex ? nextIndex < $this.p() : false) {
      var next = $this.r(nextIndex);
      next.j3m_1 = item;
      item.k3m_1 = next;
    }
  }
  function attachItemFinish($this, item, index) {
    item.h3m_1.c9();
    if ($this.g3r_1.k3p()) {
      var nodeEvent = new NodeChildAddedEvent($this.g3r_1, $this.f3r_1, index, item);
      onNodeChanged($this.g3r_1, nodeEvent);
    }
  }
  function detachItemStart($this, item) {
    item.h3m_1.c2x(null);
    item.i3m_1 = null;
    var prev = item.n3p();
    var next = item.o3p();
    if (!(prev == null)) {
      prev.k3m_1 = next;
    }
    if (!(next == null)) {
      next.j3m_1 = prev;
    }
    item.j3m_1 = null;
    item.k3m_1 = null;
  }
  function detachItemFinish($this, item, index) {
    item.h3m_1.c9();
    if ($this.g3r_1.k3p()) {
      var nodeEvent = new NodeChildRemovedEvent($this.g3r_1, $this.f3r_1, index, item);
      onNodeChanged($this.g3r_1, nodeEvent);
    }
  }
  function detachAndAttachItemsFinish($this, oldItem, newItem, index) {
    newItem.h3m_1.c9();
    if ($this.g3r_1.k3p()) {
      var nodeEvent = new NodeChildSetEvent($this.g3r_1, $this.f3r_1, index, oldItem, newItem);
      onNodeChanged($this.g3r_1, nodeEvent);
    }
  }
  function validateNodeId($this, nodeId, conceptId) {
    if (!(nodeId == null)) {
      // Inline function 'kotlin.require' call
      if (!conceptId.m3q()) {
        var message = expectedNoIdMessage(Companion_instance_47, conceptId, nodeId);
        throw IllegalArgumentException_init_$Create$_0(toString_1(message));
      }
    } else {
      // Inline function 'kotlin.require' call
      if (!!conceptId.m3q()) {
        var message_0 = expectedNodeIdMessage(Companion_instance_47, conceptId);
        throw IllegalArgumentException_init_$Create$_0(toString_1(message_0));
      }
    }
  }
  function expectedNoIdMessage($this, conceptId, nodeId) {
    return "Expected node with conceptId='" + conceptId.toString() + "' and nodeId='" + toString_0(nodeId) + "' to have no id";
  }
  function expectedNodeIdMessage($this, conceptId) {
    return "Expected node with conceptId='" + conceptId.toString() + "' to have an id";
  }
  function nodeCannotHaveIdMessage($this, conceptId) {
    return "OtNode with conceptId='" + conceptId.toString() + "' cannot have an id";
  }
  function indexOutOfBoundsMessage($this, indexDescription, index, interval) {
    return indexDescription + ' index is out of bounds: index=' + index + ', bounds=' + interval.toString();
  }
  function _get_propertyListeners__yg2t9j($this) {
    if (!_get_arePropertyListenersInitialized__tb7xlf($this)) {
      $this.l3m_1 = new EventHandlerListeners();
    }
    return ensureNotNull($this.l3m_1);
  }
  function _get_arePropertyListenersInitialized__tb7xlf($this) {
    return !($this.l3m_1 == null);
  }
  function _get_deepChangeListeners__s6vj7y($this) {
    if (!_get_deepChangeListenersInitialized__6113uu($this)) {
      var tmp = $this;
      tmp.m3m_1 = new OtNode$deepChangeListeners$1($this);
    }
    return ensureNotNull($this.m3m_1);
  }
  function _get_deepChangeListenersInitialized__6113uu($this) {
    return !($this.m3m_1 == null);
  }
  function _get_hasListeners__lk7hnq($this) {
    return $this.k3p() || _get_arePropertyListenersInitialized__tb7xlf($this);
  }
  function checkCanModify_0($this) {
    if ($this.k3p()) {
      ensureNotNull($this.g3m_1).i3f();
    }
  }
  function getChildNodeToSplit($this, toAdd, index, list) {
    checkCanModify_0($this);
    checkIndex($this, index, list);
    var source = list.r(index - 1 | 0);
    // Inline function 'kotlin.require' call
    if (!source.e3m_1.equals(toAdd.e3m_1)) {
      var message = MessageBundle_instance.e3n(source.e3m_1, toAdd.e3m_1);
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    return source;
  }
  function checkIndex($this, index, list) {
    // Inline function 'kotlin.require' call
    if (!(0 < index && index <= list.p())) {
      var interval = new Interval(1, list.p());
      var message = indexOutOfBoundsMessage(Companion_instance_47, 'Add', index, interval);
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
  }
  function setEventInProgress_0($this, inProgress) {
    var tmp0_safe_receiver = $this.g3m_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.b3j(inProgress);
    }
  }
  function executeAtomicChanges($this, f) {
    if ($this.k3p()) {
      ensureNotNull($this.g3m_1).o3o(f);
    } else {
      f();
    }
  }
  function onNodeChanged($this, event) {
    ensureNotNull($this.g3m_1).p3o(event);
    if (ensureNotNull($this.g3m_1).r3e_1) {
      fireDescendantEvent($this, event);
    }
  }
  function fire_1($this, event) {
    if ($this.k3p()) {
      ensureNotNull($this.g3m_1).q3o(event);
    }
  }
  function fireDescendantEvent($this, event) {
    if (_get_deepChangeListenersInitialized__6113uu($this)) {
      _get_deepChangeListeners__s6vj7y($this).m2v(event);
    }
    var tmp0_safe_receiver = $this.d3o();
    if (tmp0_safe_receiver == null)
      null;
    else {
      fireDescendantEvent(tmp0_safe_receiver, event);
    }
  }
  function RemoveChildOperationData($outer, child) {
    this.l3r_1 = $outer;
    this.h3r_1 = ensureNotNull(child.l3p());
    this.i3r_1 = this.l3r_1.p3m(this.h3r_1);
    this.j3r_1 = this.i3r_1.v(child);
    // Inline function 'kotlin.check' call
    if (!(this.j3r_1 > 0)) {
      var message = 'Child index=' + this.j3r_1;
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    this.k3r_1 = this.i3r_1.r(this.j3r_1 - 1 | 0);
    // Inline function 'kotlin.check' call
    if (!this.k3r_1.e3m_1.equals(child.e3m_1)) {
      var message_0 = MessageBundle_instance.e3n(this.k3r_1.e3m_1, child.e3m_1);
      throw IllegalStateException_init_$Create$_0(toString_1(message_0));
    }
  }
  function MyProperty($outer, propertyId) {
    this.n3r_1 = $outer;
    BaseReadableProperty.call(this);
    this.m3r_1 = propertyId;
  }
  protoOf(MyProperty).v2w = function () {
    return this.n3r_1.toString() + '.' + this.m3r_1.y2();
  };
  protoOf(MyProperty).uv = function () {
    return this.n3r_1.k3n(this.m3r_1);
  };
  protoOf(MyProperty).o3r = function (newValue) {
    return this.n3r_1.l3n(this.m3r_1, newValue);
  };
  protoOf(MyProperty).d2x = function (newValue) {
    return this.o3r((newValue == null ? true : typeof newValue === 'string') ? newValue : THROW_CCE());
  };
  protoOf(MyProperty).p3r = function (handler) {
    return this.n3r_1.m3n(this.m3r_1, handler);
  };
  protoOf(MyProperty).y2r = function (handler) {
    return this.p3r(handler);
  };
  function ChildrenObservableList($outer, childId) {
    this.g3r_1 = $outer;
    ObservableArrayList.call(this);
    this.f3r_1 = childId;
  }
  protoOf(ChildrenObservableList).bp = function () {
    return this.g3r_1;
  };
  protoOf(ChildrenObservableList).q3r = function (index, item) {
    checkCanModify_0(this.g3r_1);
    protoOf(ObservableArrayList).o2s.call(this, index, item);
    // Inline function 'kotlin.check' call
    if (!(!this.f3r_1.f3g() || this.s())) {
      var message = "Can't add second item to a single role " + this.f3r_1.toString();
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    checkStructureOnAdd(this, item);
  };
  protoOf(ChildrenObservableList).o2s = function (index, item) {
    return this.q3r(index, item instanceof OtNode ? item : THROW_CCE());
  };
  protoOf(ChildrenObservableList).r3r = function (index, oldItem, newItem) {
    checkCanModify_0(this.g3r_1);
    protoOf(ObservableArrayList).p2s.call(this, index, oldItem, newItem);
    checkStructureOnRemove(this, oldItem);
    checkStructureOnAdd(this, newItem);
  };
  protoOf(ChildrenObservableList).p2s = function (index, oldItem, newItem) {
    var tmp = oldItem instanceof OtNode ? oldItem : THROW_CCE();
    return this.r3r(index, tmp, newItem instanceof OtNode ? newItem : THROW_CCE());
  };
  protoOf(ChildrenObservableList).s3r = function (index, item) {
    checkCanModify_0(this.g3r_1);
    protoOf(ObservableArrayList).q2s.call(this, index, item);
    checkStructureOnRemove(this, item);
  };
  protoOf(ChildrenObservableList).q2s = function (index, item) {
    return this.s3r(index, item instanceof OtNode ? item : THROW_CCE());
  };
  protoOf(ChildrenObservableList).t3r = function (index, item) {
    attachItemStart(this, item, index - 1 | 0, index);
  };
  protoOf(ChildrenObservableList).s2s = function (index, item) {
    return this.t3r(index, item instanceof OtNode ? item : THROW_CCE());
  };
  protoOf(ChildrenObservableList).u3r = function (index, item, success) {
    if (!success)
      return Unit_instance;
    try {
      attachItemFinish(this, item, index);
    }finally {
      setEventInProgress_0(this.g3r_1, false);
    }
  };
  protoOf(ChildrenObservableList).v2s = function (index, item, success) {
    return this.u3r(index, item instanceof OtNode ? item : THROW_CCE(), success);
  };
  protoOf(ChildrenObservableList).v3r = function (index, oldItem, newItem) {
    detachItemStart(this, oldItem);
    attachItemStart(this, newItem, index - 1 | 0, index + 1 | 0);
  };
  protoOf(ChildrenObservableList).x2s = function (index, oldItem, newItem) {
    var tmp = oldItem instanceof OtNode ? oldItem : THROW_CCE();
    return this.v3r(index, tmp, newItem instanceof OtNode ? newItem : THROW_CCE());
  };
  protoOf(ChildrenObservableList).w3r = function (index, oldItem, newItem, success) {
    if (!success)
      return Unit_instance;
    try {
      detachAndAttachItemsFinish(this, oldItem, newItem, index);
    }finally {
      setEventInProgress_0(this.g3r_1, false);
    }
  };
  protoOf(ChildrenObservableList).a2t = function (index, oldItem, newItem, success) {
    var tmp = oldItem instanceof OtNode ? oldItem : THROW_CCE();
    return this.w3r(index, tmp, newItem instanceof OtNode ? newItem : THROW_CCE(), success);
  };
  protoOf(ChildrenObservableList).x3r = function (index, item) {
    return detachItemStart(this, item);
  };
  protoOf(ChildrenObservableList).c2t = function (index, item) {
    return this.x3r(index, item instanceof OtNode ? item : THROW_CCE());
  };
  protoOf(ChildrenObservableList).y3r = function (index, item, success) {
    if (!success)
      return Unit_instance;
    try {
      detachItemFinish(this, item, index);
    }finally {
      setEventInProgress_0(this.g3r_1, false);
    }
  };
  protoOf(ChildrenObservableList).e2t = function (index, item, success) {
    return this.y3r(index, item instanceof OtNode ? item : THROW_CCE(), success);
  };
  function Companion_47() {
  }
  protoOf(Companion_47).t3o = function (conceptId) {
    return conceptId.m3q() ? new NodeId() : null;
  };
  var Companion_instance_47;
  function Companion_getInstance_47() {
    return Companion_instance_47;
  }
  function OtNode$deepChangeListeners$1(this$0) {
    this.a3s_1 = this$0;
    EventHandlerListeners.call(this);
  }
  protoOf(OtNode$deepChangeListeners$1).g2s = function () {
    this.a3s_1.m3m_1 = null;
  };
  function OtNode$copy$nodeCopier$1($preserveIds) {
    this.b3s_1 = $preserveIds;
    NodeCopier.call(this);
  }
  protoOf(OtNode$copy$nodeCopier$1).v3q = function (node) {
    var newNode = this.b3s_1 && node.a3o() ? node.g3p(node.z3n()) : this.b3s_1 && !node.a3o() ? node.g3p(null) : node.h3p();
    return newNode;
  };
  function OtNode$descendants$slambda($includeSelf, this$0, resultContinuation) {
    this.k3s_1 = $includeSelf;
    this.l3s_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(OtNode$descendants$slambda).p3s = function ($this$sequence, $completion) {
    var tmp = this.q3s($this$sequence, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(OtNode$descendants$slambda).v9 = function (p1, $completion) {
    return this.p3s(p1 instanceof SequenceScope ? p1 : THROW_CCE(), $completion);
  };
  protoOf(OtNode$descendants$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 8;
            if (this.k3s_1) {
              this.f9_1 = 1;
              suspendResult = this.m3s_1.dh(this.l3s_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.f9_1 = 2;
              continue $sm;
            }

          case 1:
            this.f9_1 = 2;
            continue $sm;
          case 2:
            this.o3s_1 = this.l3s_1.z3d().m();
            this.f9_1 = 3;
            continue $sm;
          case 3:
            if (!this.o3s_1.n()) {
              this.f9_1 = 7;
              continue $sm;
            }

            var childId = this.o3s_1.o();
            var children = this.l3s_1.p3m(childId);
            this.n3s_1 = children.m();
            this.f9_1 = 4;
            continue $sm;
          case 4:
            if (!this.n3s_1.n()) {
              this.f9_1 = 6;
              continue $sm;
            }

            var child = this.n3s_1.o();
            this.f9_1 = 5;
            suspendResult = this.m3s_1.fh(child.s3p(true), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 5:
            this.f9_1 = 4;
            continue $sm;
          case 6:
            this.f9_1 = 3;
            continue $sm;
          case 7:
            return Unit_instance;
          case 8:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 8) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(OtNode$descendants$slambda).q3s = function ($this$sequence, completion) {
    var i = new OtNode$descendants$slambda(this.k3s_1, this.l3s_1, completion);
    i.m3s_1 = $this$sequence;
    return i;
  };
  function OtNode$descendants$slambda_0($includeSelf, this$0, resultContinuation) {
    var i = new OtNode$descendants$slambda($includeSelf, this$0, resultContinuation);
    var l = function ($this$sequence, $completion) {
      return i.p3s($this$sequence, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function OtNode$allChildren$slambda(this$0, resultContinuation) {
    this.z3s_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(OtNode$allChildren$slambda).p3s = function ($this$sequence, $completion) {
    var tmp = this.q3s($this$sequence, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(OtNode$allChildren$slambda).v9 = function (p1, $completion) {
    return this.p3s(p1 instanceof SequenceScope ? p1 : THROW_CCE(), $completion);
  };
  protoOf(OtNode$allChildren$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 6;
            this.c3t_1 = this.z3s_1.z3d().m();
            this.f9_1 = 1;
            continue $sm;
          case 1:
            if (!this.c3t_1.n()) {
              this.f9_1 = 5;
              continue $sm;
            }

            var childId = this.c3t_1.o();
            var children = this.z3s_1.p3m(childId);
            this.b3t_1 = children.m();
            this.f9_1 = 2;
            continue $sm;
          case 2:
            if (!this.b3t_1.n()) {
              this.f9_1 = 4;
              continue $sm;
            }

            var child = this.b3t_1.o();
            this.f9_1 = 3;
            suspendResult = this.a3t_1.dh(child, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            this.f9_1 = 2;
            continue $sm;
          case 4:
            this.f9_1 = 1;
            continue $sm;
          case 5:
            return Unit_instance;
          case 6:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 6) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(OtNode$allChildren$slambda).q3s = function ($this$sequence, completion) {
    var i = new OtNode$allChildren$slambda(this.z3s_1, completion);
    i.a3t_1 = $this$sequence;
    return i;
  };
  function OtNode$allChildren$slambda_0(this$0, resultContinuation) {
    var i = new OtNode$allChildren$slambda(this$0, resultContinuation);
    var l = function ($this$sequence, $completion) {
      return i.p3s($this$sequence, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function OtNode$insertInProperty$lambda(this$0, $propertyId, $newProperty) {
    return function () {
      this$0.l3n($propertyId, $newProperty);
      return Unit_instance;
    };
  }
  function OtNode$deleteInProperty$lambda(this$0, $propertyId, $newProperty) {
    return function () {
      this$0.l3n($propertyId, $newProperty);
      return Unit_instance;
    };
  }
  function OtNode$addChildAndSplitProperty$lambda($source, $propertyId, $newValue, $child, $movedText, $list, $index) {
    return function () {
      $source.l3n($propertyId, $newValue);
      $child.l3n($propertyId, $movedText);
      $list.m2($index, $child);
      return Unit_instance;
    };
  }
  function OtNode$addChildAndSplitChildCollection$lambda($list, $index, $child, $collectionId, $sourceChildren, $splitIndex) {
    return function () {
      $list.m2($index, $child);
      var newChildren = $child.p3m($collectionId);
      var iterator = $sourceChildren.f2();
      var inductionVariable = 0;
      var tmp;
      if (inductionVariable < $splitIndex) {
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          iterator.o();
        }
         while (inductionVariable < $splitIndex);
        tmp = Unit_instance;
      }
      $child.n3m_1 = true;
      var tmp_0;
      try {
        while (iterator.n()) {
          var node = iterator.o();
          iterator.h4();
          newChildren.j(node);
        }
        tmp_0 = Unit_instance;
      }finally {
        $child.n3m_1 = false;
      }
      return Unit_instance;
    };
  }
  function OtNode$mergePropertyAndRemoveChild$lambda($data, $propertyId, $resultProperty) {
    return function () {
      $data.i3r_1.n2($data.j3r_1);
      $data.k3r_1.l3n($propertyId, $resultProperty);
      return Unit_instance;
    };
  }
  function OtNode$mergeChildCollectionAndRemoveChild$lambda($childCollection, $data, $targetCollection) {
    return function () {
      var copy = ArrayList_init_$Create$_1($childCollection);
      $childCollection.k2();
      $data.k3r_1.n3m_1 = true;
      var tmp;
      try {
        var _iterator__ex2g4s = copy.m();
        while (_iterator__ex2g4s.n()) {
          var node = _iterator__ex2g4s.o();
          $targetCollection.j(node);
        }
        tmp = Unit_instance;
      }finally {
        $data.k3r_1.n3m_1 = false;
      }
      $data.i3r_1.n2($data.j3r_1);
      return Unit_instance;
    };
  }
  function OtNode$addPropertyHandler$$inlined$eventHandler$1($propertyId, $handler) {
    this.d3t_1 = $propertyId;
    this.e3t_1 = $handler;
  }
  protoOf(OtNode$addPropertyHandler$$inlined$eventHandler$1).o2v = function (event) {
    if (event.x3q_1.equals(this.d3t_1)) {
      this.e3t_1.n2s(event.y3q_1);
    }
    return Unit_instance;
  };
  protoOf(OtNode$addPropertyHandler$$inlined$eventHandler$1).n2s = function (event) {
    return this.o2v((event == null ? true : !(event == null)) ? event : THROW_CCE());
  };
  function OtNode(conceptId, nodeId) {
    this.e3m_1 = conceptId;
    this.g3m_1 = null;
    this.h3m_1 = new DelayedValueProperty();
    this.i3m_1 = null;
    this.j3m_1 = null;
    this.k3m_1 = null;
    this.l3m_1 = null;
    this.m3m_1 = null;
    this.n3m_1 = false;
    validateNodeId(Companion_instance_47, nodeId, this.e3m_1);
    this.f3m_1 = nodeId;
  }
  protoOf(OtNode).f3t = function () {
    return this.e3m_1;
  };
  protoOf(OtNode).a3o = function () {
    return this.e3m_1.m3q();
  };
  protoOf(OtNode).z3n = function () {
    if (!this.a3o()) {
      throw UnsupportedOperationException_init_$Create$_0(nodeCannotHaveIdMessage(Companion_instance_47, this.e3m_1));
    }
    var tmp0 = this.f3m_1;
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.checkNotNull' call
      if (tmp0 == null) {
        var message = expectedNodeIdMessage(Companion_instance_47, this.e3m_1);
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      } else {
        tmp$ret$1 = tmp0;
        break $l$block;
      }
    }
    return tmp$ret$1;
  };
  protoOf(OtNode).l3o = function () {
    return this.z3n().q36_1;
  };
  protoOf(OtNode).m3o = function (model) {
    // Inline function 'kotlin.check' call
    if (!(!this.k3p() || model == null)) {
      var message = 'Attempt to register node though it already has a model';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    this.g3m_1 = model;
  };
  protoOf(OtNode).g3t = function () {
    return this.g3m_1;
  };
  protoOf(OtNode).k3p = function () {
    return !(this.g3m_1 == null);
  };
  protoOf(OtNode).j3h = function () {
    return this.h3m_1;
  };
  protoOf(OtNode).d3o = function () {
    return this.h3m_1.uv();
  };
  protoOf(OtNode).l3p = function () {
    return this.i3m_1;
  };
  protoOf(OtNode).m3p = function () {
    var tmp0_safe_receiver = this.d3o();
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.p3m(ensureNotNull(this.l3p()));
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.w(this);
    return tmp2_elvis_lhs == null ? -1 : tmp2_elvis_lhs;
  };
  protoOf(OtNode).n3p = function () {
    return this.j3m_1;
  };
  protoOf(OtNode).o3p = function () {
    return this.k3m_1;
  };
  protoOf(OtNode).h3p = function (nodeId, $super) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(this.e3m_1) : nodeId;
    return $super === VOID ? this.g3p(nodeId) : $super.g3p.call(this, nodeId);
  };
  protoOf(OtNode).p3p = function (preserveIds) {
    var nodeCopier = new OtNode$copy$nodeCopier$1(preserveIds);
    return nodeCopier.w3q(this);
  };
  protoOf(OtNode).q3p = function (preserveIds, $super) {
    preserveIds = preserveIds === VOID ? false : preserveIds;
    return $super === VOID ? this.p3p(preserveIds) : $super.p3p.call(this, preserveIds);
  };
  protoOf(OtNode).h3o = function () {
    return this.p3p(true);
  };
  protoOf(OtNode).r3p = function () {
    checkCanModify_0(this);
    var tmp0_elvis_lhs = this.d3o();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var message = 'OtNode has no parent';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var parent = tmp;
    var siblings = parent.p3m(ensureNotNull(this.l3p()));
    siblings.h2(this);
  };
  protoOf(OtNode).s3p = function (includeSelf) {
    return sequence(OtNode$descendants$slambda_0(includeSelf, this, null));
  };
  protoOf(OtNode).t3p = function () {
    return sequence(OtNode$allChildren$slambda_0(this, null));
  };
  protoOf(OtNode).d3n = function (propertyId) {
    return new MyProperty(this, propertyId);
  };
  protoOf(OtNode).o3m = function (propertyId, value) {
    // Inline function 'kotlin.check' call
    if (!!_get_hasListeners__lk7hnq(this)) {
      var message = "calling setValue is allowed only when there are no listeners since it doesn't produce events";
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    this.i3p(propertyId, value, this.k3n(propertyId));
  };
  protoOf(OtNode).p3n = function (propertyId, index, text) {
    checkCanModify_0(this);
    $l$block: {
      // Inline function 'kotlin.requireNotNull' call
      if (text == null) {
        var message = "text shouldn't be null";
        throw IllegalArgumentException_init_$Create$_0(toString_1(message));
      } else {
        break $l$block;
      }
    }
    var tmp;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(text) === 0) {
      tmp = !(index === -1);
    } else {
      tmp = false;
    }
    if (tmp) {
      return Unit_instance;
    }
    var property = this.k3n(propertyId);
    var stringIndex = index;
    if (property == null) {
      // Inline function 'kotlin.require' call
      if (!(index === -1)) {
        var message_0 = 'Use index=-1 to insert into null property';
        throw IllegalArgumentException_init_$Create$_0(toString_1(message_0));
      }
      property = '';
      stringIndex = 0;
    }
    // Inline function 'kotlin.require' call
    if (!(stringIndex >= 0)) {
      var message_1 = 'Negative index, value=' + stringIndex;
      throw IllegalArgumentException_init_$Create$_0(toString_1(message_1));
    }
    // Inline function 'kotlin.require' call
    if (!(property.length >= stringIndex)) {
      var message_2 = 'Insert index=' + stringIndex + ", property value='" + property + "', length=" + property.length;
      throw IllegalArgumentException_init_$Create$_0(toString_1(message_2));
    }
    var newProperty = take_1(property, stringIndex) + text + substring_0(property, stringIndex);
    executeAtomicChanges(this, OtNode$insertInProperty$lambda(this, propertyId, newProperty));
    fire_1(this, new NodeInsertedInPropertyEvent(this, propertyId, index, text));
  };
  protoOf(OtNode).r3n = function (propertyId, index, length) {
    checkCanModify_0(this);
    if (length === 0 && !(index === -1)) {
      return Unit_instance;
    }
    var property = this.k3n(propertyId);
    $l$block: {
      // Inline function 'kotlin.requireNotNull' call
      if (property == null) {
        var message = "Null property value: id='" + propertyId.toString() + "'";
        throw IllegalArgumentException_init_$Create$_0(toString_1(message));
      } else {
        break $l$block;
      }
    }
    var stringIndex = index;
    if (index === -1) {
      // Inline function 'kotlin.require' call
      if (!(property.length === length)) {
        var message_0 = 'Incorrect delete to null';
        throw IllegalArgumentException_init_$Create$_0(toString_1(message_0));
      }
      stringIndex = 0;
    } else {
      // Inline function 'kotlin.require' call
      if (!(stringIndex >= 0)) {
        var message_1 = 'Negative index, value=' + stringIndex;
        throw IllegalArgumentException_init_$Create$_0(toString_1(message_1));
      }
      // Inline function 'kotlin.require' call
      if (!(length >= 0)) {
        var message_2 = 'Negative length, value=' + length;
        throw IllegalArgumentException_init_$Create$_0(toString_1(message_2));
      }
    }
    // Inline function 'kotlin.require' call
    if (!(property.length >= (stringIndex + length | 0))) {
      var message_3 = "Delete range is out of bounds: property value='" + property + "', delete at " + stringIndex + ', length=' + length;
      throw IllegalArgumentException_init_$Create$_0(toString_1(message_3));
    }
    var tmp;
    if (index === -1) {
      tmp = null;
    } else {
      tmp = take_1(property, stringIndex) + substring_0(property, stringIndex + length | 0);
    }
    var newProperty = tmp;
    executeAtomicChanges(this, OtNode$deleteInProperty$lambda(this, propertyId, newProperty));
    var event = new NodeDeletedInPropertyEvent(this, propertyId, index, substring(property, stringIndex, stringIndex + length | 0));
    fire_1(this, event);
  };
  protoOf(OtNode).u3p = function (with_0) {
    checkCanModify_0(this);
    var parent = this.d3o();
    $l$block: {
      // Inline function 'kotlin.checkNotNull' call
      if (parent == null) {
        var message = 'Replace root node is inapplicable';
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      } else {
        break $l$block;
      }
    }
    var siblings = parent.p3m(ensureNotNull(this.l3p()));
    var index = siblings.w(this);
    siblings.l2(index, with_0);
  };
  protoOf(OtNode).v3p = function (role, index, propertyId, splitIndex) {
    var list = this.p3m(role);
    checkIndex(this, index, list);
    var sourceNode = list.r(index - 1 | 0);
    var node = sourceNode.h3p();
    var splitIndexParam = sourceNode.d3n(propertyId).uv() == null && splitIndex === 0 ? -1 : splitIndex;
    this.w3p(node, role, index, propertyId, splitIndexParam);
    return node;
  };
  protoOf(OtNode).w3p = function (child, role, index, propertyId, splitIndex) {
    var list = this.p3m(role);
    var source = getChildNodeToSplit(this, child, index, list);
    var property = source.k3n(propertyId);
    var nullProperty = property == null;
    var stringSplitIndex = splitIndex;
    if (nullProperty) {
      // Inline function 'kotlin.require' call
      if (!(splitIndex === -1)) {
        var message = 'Use splitIndex=-1 to split null property';
        throw IllegalArgumentException_init_$Create$_0(toString_1(message));
      }
      property = '';
    }
    if (splitIndex === -1) {
      stringSplitIndex = 0;
    }
    if (stringSplitIndex < 0 || ensureNotNull(property).length < stringSplitIndex) {
      throw IllegalArgumentException_init_$Create$_0('Split index=' + stringSplitIndex + ", property value='" + property + "', length=" + ensureNotNull(property).length);
    }
    var newValue = splitIndex === -1 ? null : take_1(property, stringSplitIndex);
    var movedText = substring_0(property, stringSplitIndex);
    executeAtomicChanges(this, OtNode$addChildAndSplitProperty$lambda(source, propertyId, newValue, child, movedText, list, index));
    var tmp;
    if (nullProperty) {
      tmp = new NodeChildAddedEvent(this, role, index, child);
    } else {
      tmp = new NodeChildAddedPropertySplitEvent(this, role, index, child, source, splitIndex, propertyId, movedText);
    }
    var nodeEvent = tmp;
    fire_1(this, nodeEvent);
  };
  protoOf(OtNode).x3p = function (child, role, index, collectionId, splitIndex) {
    var list = this.p3m(role);
    var source = getChildNodeToSplit(this, child, index, list);
    var sourceChildren = source.p3m(collectionId);
    // Inline function 'kotlin.require' call
    if (!(0 <= splitIndex && splitIndex <= sourceChildren.p())) {
      var interval = new Interval(0, sourceChildren.p());
      var message = indexOutOfBoundsMessage(Companion_instance_47, 'Split', splitIndex, interval);
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    var splitSize = sourceChildren.p() - splitIndex | 0;
    executeAtomicChanges(this, OtNode$addChildAndSplitChildCollection$lambda(list, index, child, collectionId, sourceChildren, splitIndex));
    var event = new NodeChildAddedChildCollectionSplitEvent(this, role, index, child, source, splitIndex, collectionId, splitSize);
    fire_1(this, event);
  };
  protoOf(OtNode).y3p = function (child, propertyId) {
    var mergeNull = false;
    checkCanModify_0(this);
    var data = new RemoveChildOperationData(this, child);
    var mergedProperty = child.d3n(propertyId).uv();
    if (mergedProperty == null) {
      mergeNull = true;
      mergedProperty = '';
    }
    var targetProperty = data.k3r_1.d3n(propertyId).uv();
    var nullTarget = targetProperty == null;
    if (nullTarget) {
      targetProperty = '';
    }
    var resultProperty = mergeNull && nullTarget ? null : ensureNotNull(targetProperty) + mergedProperty;
    executeAtomicChanges(this, OtNode$mergePropertyAndRemoveChild$lambda(data, propertyId, resultProperty));
    var tmp;
    if (mergeNull) {
      tmp = new NodeChildRemovedEvent(this, data.h3r_1, data.j3r_1, child);
    } else {
      var targetLength = nullTarget ? -1 : ensureNotNull(targetProperty).length;
      tmp = new NodePropertyMergedChildRemovedEvent(this, data.h3r_1, data.j3r_1, child, data.k3r_1, targetLength, propertyId, mergedProperty);
    }
    var event = tmp;
    fire_1(this, event);
  };
  protoOf(OtNode).z3p = function (child, collectionId) {
    checkCanModify_0(this);
    var data = new RemoveChildOperationData(this, child);
    var childCollection = child.p3m(collectionId);
    var targetCollection = data.k3r_1.p3m(collectionId);
    var childLength = childCollection.p();
    var targetLength = targetCollection.p();
    executeAtomicChanges(this, OtNode$mergeChildCollectionAndRemoveChild$lambda(childCollection, data, targetCollection));
    var event = new NodeChildCollectionMergedChildRemovedEvent(this, data.h3r_1, data.j3r_1, child, data.k3r_1, targetLength, collectionId, childLength);
    fire_1(this, event);
  };
  protoOf(OtNode).a3q = function (event) {
    setEventInProgress_0(this, true);
    if (this.k3p()) {
      ensureNotNull(this.g3m_1).e3o(event.u2r());
    }
  };
  protoOf(OtNode).m2r = function (event) {
    return this.a3q(event);
  };
  protoOf(OtNode).b3q = function (event) {
    setEventInProgress_0(this, true);
    if (this.k3p()) {
      ensureNotNull(this.g3m_1).n3o(event.s2r());
      ensureNotNull(this.g3m_1).e3o(event.u2r());
    }
  };
  protoOf(OtNode).n2r = function (event) {
    return this.b3q(event);
  };
  protoOf(OtNode).c3q = function (event) {
    setEventInProgress_0(this, true);
    if (this.k3p()) {
      ensureNotNull(this.g3m_1).n3o(event.s2r());
    }
  };
  protoOf(OtNode).t2r = function (event) {
    return this.c3q(event);
  };
  protoOf(OtNode).toString = function () {
    var className = getKClassFromExpression(this).ra();
    var tmp;
    if (className == null) {
      tmp = '<anonymous concept>';
    } else {
      var dotIndex = lastIndexOf_3(className, _Char___init__impl__6a9atx(46));
      tmp = dotIndex === -1 ? className : substring_0(className, dotIndex + 1 | 0);
    }
    var prettyClassName = tmp;
    var hashCode_0 = toString_3(hashCode(this), 16);
    return prettyClassName + '@' + hashCode_0 + '[conceptId=' + this.e3m_1.toString() + ', id=' + toString_0(this.f3m_1) + ']';
  };
  protoOf(OtNode).l3n = function (propertyId, value) {
    checkCanModify_0(this);
    var oldValue = this.k3n(propertyId);
    if (this.i3p(propertyId, value, oldValue)) {
      return Unit_instance;
    }
    setEventInProgress_0(this, true);
    try {
      if (this.k3p()) {
        var nodeEvent = new NodePropertySetEvent(this, propertyId, oldValue, value);
        onNodeChanged(this, nodeEvent);
      }
      if (_get_arePropertyListenersInitialized__tb7xlf(this)) {
        var propertyChangeEvent = new PropertyChangeEvent(oldValue, value);
        var event = new NodePropertyChangeEvent(propertyId, propertyChangeEvent);
        _get_propertyListeners__yg2t9j(this).m2v(event);
      }
    }finally {
      setEventInProgress_0(this, false);
    }
  };
  protoOf(OtNode).m3n = function (propertyId, handler) {
    // Inline function 'jetbrains.ocelot.base.observable.event.eventHandler' call
    var listener = new OtNode$addPropertyHandler$$inlined$eventHandler$1(propertyId, handler);
    return _get_propertyListeners__yg2t9j(this).j2s(listener);
  };
  function OtNodeFactory() {
  }
  function PropertyEventHandlerWrapper(handler, persister) {
    this.i3t_1 = handler;
    this.j3t_1 = persister;
  }
  protoOf(PropertyEventHandlerWrapper).k3t = function (event) {
    var oldValue = this.j3t_1.p25(event.s2y_1);
    var newValue = this.j3t_1.p25(event.t2y_1);
    if (!equals(oldValue, newValue)) {
      this.i3t_1.n2s(new PropertyChangeEvent(oldValue, newValue));
    }
  };
  protoOf(PropertyEventHandlerWrapper).n2s = function (event) {
    return this.k3t(event instanceof PropertyChangeEvent ? event : THROW_CCE());
  };
  function RawNodeFactory() {
  }
  protoOf(RawNodeFactory).d3m = function (conceptId, nodeId) {
    return new Node_0(conceptId, nodeId);
  };
  var RawNodeFactory_instance;
  function RawNodeFactory_getInstance() {
    return RawNodeFactory_instance;
  }
  function ModelAdapter() {
  }
  protoOf(ModelAdapter).l3i = function (event) {
  };
  protoOf(ModelAdapter).m3i = function (event) {
    return this.l3i(event);
  };
  protoOf(ModelAdapter).n3i = function (event) {
    return this.l3i(event);
  };
  protoOf(ModelAdapter).o3i = function (event) {
    return this.l3i(event);
  };
  protoOf(ModelAdapter).p3i = function (event) {
    return this.l3i(event);
  };
  protoOf(ModelAdapter).q3i = function (event) {
    return this.l3i(event);
  };
  protoOf(ModelAdapter).r3i = function (event) {
    return this.l3i(event);
  };
  protoOf(ModelAdapter).s3i = function (event) {
    return this.l3i(event);
  };
  protoOf(ModelAdapter).t3i = function (event) {
    return this.l3i(event);
  };
  protoOf(ModelAdapter).u3i = function (event) {
    return this.l3i(event);
  };
  protoOf(ModelAdapter).v3i = function (event) {
    return this.l3i(event);
  };
  function ModelListener() {
  }
  function NodeChildAddedChildCollectionSplitEvent(node, role, index, child, sourceNode, splitIndex, childId, splitSize) {
    NodeChildEvent.call(this, node, role, index, child);
    this.p3t_1 = sourceNode;
    this.q3t_1 = splitIndex;
    this.r3t_1 = childId;
    this.s3t_1 = splitSize;
  }
  protoOf(NodeChildAddedChildCollectionSplitEvent).t3t = function (listener) {
    listener.s3i(this);
  };
  protoOf(NodeChildAddedChildCollectionSplitEvent).w2r = function (listener) {
    return this.t3t((!(listener == null) ? isInterface(listener, ModelListener) : false) ? listener : THROW_CCE());
  };
  function NodeChildAddedEvent(node, role, index, child) {
    NodeChildEvent.call(this, node, role, index, child);
  }
  protoOf(NodeChildAddedEvent).t3t = function (listener) {
    return listener.n3i(this);
  };
  protoOf(NodeChildAddedEvent).w2r = function (listener) {
    return this.t3t((!(listener == null) ? isInterface(listener, ModelListener) : false) ? listener : THROW_CCE());
  };
  function NodeChildAddedPropertySplitEvent(node, role, index, child, sourceNode, splitIndex, propertyId, movedText) {
    NodeChildEvent.call(this, node, role, index, child);
    this.c3u_1 = sourceNode;
    this.d3u_1 = splitIndex;
    this.e3u_1 = propertyId;
    this.f3u_1 = movedText;
  }
  protoOf(NodeChildAddedPropertySplitEvent).t3t = function (listener) {
    listener.q3i(this);
  };
  protoOf(NodeChildAddedPropertySplitEvent).w2r = function (listener) {
    return this.t3t((!(listener == null) ? isInterface(listener, ModelListener) : false) ? listener : THROW_CCE());
  };
  function NodeChildCollectionMergedChildRemovedEvent(node, role, index, child, targetNode, targetLength, childId, removedLength) {
    NodeChildEvent.call(this, node, role, index, child);
    this.k3u_1 = targetNode;
    this.l3u_1 = targetLength;
    this.m3u_1 = childId;
    this.n3u_1 = removedLength;
  }
  protoOf(NodeChildCollectionMergedChildRemovedEvent).t3t = function (listener) {
    listener.t3i(this);
  };
  protoOf(NodeChildCollectionMergedChildRemovedEvent).w2r = function (listener) {
    return this.t3t((!(listener == null) ? isInterface(listener, ModelListener) : false) ? listener : THROW_CCE());
  };
  function NodeChildEvent(node, role, index, child) {
    NodeEvent.call(this, node);
    this.p3u_1 = role;
    this.q3u_1 = index;
    this.r3u_1 = child;
  }
  function NodeChildRemovedEvent(node, role, index, child) {
    NodeChildEvent.call(this, node, role, index, child);
  }
  protoOf(NodeChildRemovedEvent).t3t = function (listener) {
    listener.o3i(this);
  };
  protoOf(NodeChildRemovedEvent).w2r = function (listener) {
    return this.t3t((!(listener == null) ? isInterface(listener, ModelListener) : false) ? listener : THROW_CCE());
  };
  function NodeChildSetEvent(node, role, index, oldChild, newChild) {
    NodeChildEvent.call(this, node, role, index, newChild);
    this.a3v_1 = oldChild;
  }
  protoOf(NodeChildSetEvent).b3v = function () {
    return this.r3u_1;
  };
  protoOf(NodeChildSetEvent).t3t = function (listener) {
    listener.p3i(this);
  };
  protoOf(NodeChildSetEvent).w2r = function (listener) {
    return this.t3t((!(listener == null) ? isInterface(listener, ModelListener) : false) ? listener : THROW_CCE());
  };
  function NodeDeletedInPropertyEvent(node, propertyId, index, text) {
    NodePropertyChangedEvent.call(this, node, propertyId, index, text);
  }
  protoOf(NodeDeletedInPropertyEvent).t3t = function (listener) {
    listener.v3i(this);
  };
  protoOf(NodeDeletedInPropertyEvent).w2r = function (listener) {
    return this.t3t((!(listener == null) ? isInterface(listener, ModelListener) : false) ? listener : THROW_CCE());
  };
  function NodeEvent(node) {
    this.g3v_1 = node;
  }
  protoOf(NodeEvent).toString = function () {
    return 'node=' + this.g3v_1.toString();
  };
  function NodeInsertedInPropertyEvent(node, propertyId, index, text) {
    NodePropertyChangedEvent.call(this, node, propertyId, index, text);
  }
  protoOf(NodeInsertedInPropertyEvent).t3t = function (listener) {
    listener.u3i(this);
  };
  protoOf(NodeInsertedInPropertyEvent).w2r = function (listener) {
    return this.t3t((!(listener == null) ? isInterface(listener, ModelListener) : false) ? listener : THROW_CCE());
  };
  function NodePropertyChangedEvent(node, propertyId, index, text) {
    NodeEvent.call(this, node);
    this.m3v_1 = propertyId;
    this.n3v_1 = index;
    this.o3v_1 = text;
  }
  function NodePropertyMergedChildRemovedEvent(node, role, index, child, targetNode, targetLength, propertyId, mergedText) {
    NodeChildEvent.call(this, node, role, index, child);
    this.t3v_1 = targetNode;
    this.u3v_1 = targetLength;
    this.v3v_1 = propertyId;
    this.w3v_1 = mergedText;
  }
  protoOf(NodePropertyMergedChildRemovedEvent).t3t = function (listener) {
    listener.r3i(this);
  };
  protoOf(NodePropertyMergedChildRemovedEvent).w2r = function (listener) {
    return this.t3t((!(listener == null) ? isInterface(listener, ModelListener) : false) ? listener : THROW_CCE());
  };
  function NodePropertySetEvent(node, propertyId, oldValue, newValue) {
    NodeEvent.call(this, node);
    this.y3v_1 = propertyId;
    this.z3v_1 = oldValue;
    this.a3w_1 = newValue;
  }
  protoOf(NodePropertySetEvent).t3t = function (listener) {
    return listener.m3i(this);
  };
  protoOf(NodePropertySetEvent).w2r = function (listener) {
    return this.t3t((!(listener == null) ? isInterface(listener, ModelListener) : false) ? listener : THROW_CCE());
  };
  function NodeUtil() {
  }
  protoOf(NodeUtil).b3w = function (conceptId, id) {
    var hasId = !(id == null);
    return conceptId.m3q() === hasId;
  };
  protoOf(NodeUtil).c3w = function (node, id) {
    var tmp;
    if (node.a3o()) {
      tmp = node.z3n();
    } else {
      tmp = null;
    }
    var nodeId = tmp;
    return equals(id, nodeId);
  };
  protoOf(NodeUtil).d3w = function (node1, node2) {
    var tmp;
    if (!(node1.a3o() === node2.a3o())) {
      tmp = false;
    } else if (node1.a3o()) {
      tmp = node1.z3n().equals(node2.z3n());
    } else {
      tmp = true;
    }
    return tmp;
  };
  protoOf(NodeUtil).e3w = function (lhs, rhs) {
    return lhs === rhs || this.f3w(lhs, rhs);
  };
  protoOf(NodeUtil).f3w = function (lhs, rhs) {
    return !(lhs == null) && equals(lhs, rhs);
  };
  protoOf(NodeUtil).c3n = function (node) {
    return node.a3o() ? node.z3n() : null;
  };
  var NodeUtil_instance;
  function NodeUtil_getInstance() {
    return NodeUtil_instance;
  }
  function index_0($this, node, registry) {
    if (node.a3o()) {
      // Inline function 'kotlin.collections.set' call
      var key = node.z3n();
      registry.t2(key, node);
      var _iterator__ex2g4s = node.z3d().m();
      while (_iterator__ex2g4s.n()) {
        var role = _iterator__ex2g4s.o();
        var _iterator__ex2g4s_0 = node.p3m(role).m();
        while (_iterator__ex2g4s_0.n()) {
          var child = _iterator__ex2g4s_0.o();
          index_0($this, child, registry);
        }
      }
    }
  }
  function Nodes() {
    this.g3w_1 = '  ';
  }
  protoOf(Nodes).h3w = function (subtreeRoot) {
    var tmp;
    if (subtreeRoot.a3o()) {
      tmp = this.i3w(subtreeRoot).r2();
    } else {
      tmp = emptySet();
    }
    return tmp;
  };
  protoOf(Nodes).i3w = function (subtreeRoot) {
    var registry = HashMap_init_$Create$();
    index_0(this, subtreeRoot, registry);
    return registry;
  };
  var Nodes_instance;
  function Nodes_getInstance() {
    return Nodes_instance;
  }
  function findAddRemoveOperations($this, op) {
    if (isInterface(op, OperationContainer)) {
      var _iterator__ex2g4s = (isInterface(op, OperationContainer) ? op : THROW_CCE()).j3w().m();
      while (_iterator__ex2g4s.n()) {
        var childOp = _iterator__ex2g4s.o();
        findAddRemoveOperations($this, childOp);
      }
      return Unit_instance;
    }
    checkRemoveOperation($this, op);
    checkAddOperation($this, op);
  }
  function checkRemoveOperation($this, op) {
    var id = null;
    if (op instanceof RemoveRootOperation) {
      id = op.m3w();
    }
    if (op instanceof RemoveChildOperation) {
      id = op.p3w();
    }
    if (op instanceof RemoveChildOperation_0) {
      id = op.v3w();
    }
    if (!(id == null)) {
      $this.w3w_1.j(id);
    }
  }
  function checkAddOperation($this, op) {
    var id = null;
    var conceptId = null;
    if (op instanceof AddRootOperation) {
      id = op.m3w();
      conceptId = op.f3t();
    }
    if (op instanceof AddChildOperation) {
      id = op.p3w();
      conceptId = op.f3t();
    }
    if (op instanceof AddChildOperation_0) {
      id = op.v3w();
      conceptId = op.f3t();
    }
    if (!(id == null) && $this.w3w_1.t(id)) {
      throw IllegalStateException_init_$Create$_0('Multiple add/remove inside command: id=' + id.toString() + ', conceptId=' + toString_0(conceptId));
    }
  }
  function AddRemoveConsistencyValidator() {
    this.w3w_1 = HashSet_init_$Create$();
  }
  protoOf(AddRemoveConsistencyValidator).x3w = function (operationRootId, op) {
    findAddRemoveOperations(this, op);
  };
  protoOf(AddRemoveConsistencyValidator).y3w = function () {
    this.w3w_1.k2();
  };
  function Companion_48() {
    Companion_instance_48 = this;
    this.z3w_1 = Companion_getInstance_51().a3x_1;
  }
  var Companion_instance_48;
  function Companion_getInstance_48() {
    if (Companion_instance_48 == null)
      new Companion_48();
    return Companion_instance_48;
  }
  function EntityContextCommandProcessor$Companion$LOG$lambda() {
    return Unit_instance;
  }
  function EntityContextCommandProcessor$o$_init_$lambda_6ce6sz(this$0) {
    return function () {
      return !this$0.m3x_1;
    };
  }
  function _get_resultOp__5l2s0j($this) {
    if ($this.o3x_1 == null || ensureNotNull($this.p3x_1).s()) {
      return null;
    }
    var meaningfulOps = ArrayList_init_$Create$();
    var _iterator__ex2g4s = ensureNotNull($this.p3x_1).m();
    while (_iterator__ex2g4s.n()) {
      var op = _iterator__ex2g4s.o();
      if (!op.r3x()) {
        meaningfulOps.j(op);
      }
    }
    var size = meaningfulOps.p();
    if (size === 0)
      return null;
    if (size === 1)
      return meaningfulOps.r(0);
    var operation = $this.c3x_1.s3x(meaningfulOps);
    return operation.r3x() ? null : operation;
  }
  function isFatal($this, t) {
    if (t instanceof OtException) {
      return true;
    }
    if (t instanceof ThrowableCollectionException) {
      var _iterator__ex2g4s = t.m38().m();
      while (_iterator__ex2g4s.n()) {
        var childT = _iterator__ex2g4s.o();
        if (isFatal($this, childT)) {
          return true;
        }
      }
    }
    return !(t.cause == null) && isFatal($this, ensureNotNull(t.cause));
  }
  function addThrowableHandler($this) {
    if ($this.k3x_1 == null) {
      var tmp = $this;
      var tmp_0 = ThrowableHandlers_getInstance().k2r_1;
      tmp.k3x_1 = tmp_0.e2r(EntityContextCommandProcessor$addThrowableHandler$lambda($this));
    }
  }
  function operationHappened($this, op) {
    if (!$this.l3x_1) {
      throw OtException_init_$Create$_0('Each operation must be performed inside command, op=' + toString_1(op));
    }
    var operationRootId;
    try {
      operationRootId = validate_0($this, op);
    } catch ($p) {
      if ($p instanceof Exception) {
        var e = $p;
        ensureNotNull($this.p3x_1).j(op);
        throw OtException_init_$Create$_1('Validation failed, op=' + EntityPrintOperationUtil_instance.t3x(op), e);
      } else {
        throw $p;
      }
    }
    if ($this.o3x_1 == null) {
      $this.o3x_1 = operationRootId;
    }
    if (!($this.o3x_1 == null)) {
      ensureNotNull($this.p3x_1).j(op);
    }
    $this.i3x_1.k2s(EntityContextCommandProcessor$operationHappened$lambda(op));
  }
  function validate_0($this, op) {
    var info = OperationRootIdInfo_init_$Create$_0(op);
    if (!info.x3x()) {
      throw IllegalStateException_init_$Create$_0(info.w3x_1);
    }
    var operationRootId = info.v3x_1;
    if (!($this.o3x_1 == null) && !equals($this.o3x_1, operationRootId)) {
      var rootEntities = $this.b3x_1.g3f_1;
      var r1 = rootEntities.a3h(ensureNotNull($this.o3x_1));
      var r2 = rootEntities.a3h(ensureNotNull(operationRootId));
      throw IllegalStateException_init_$Create$_0('[transaction must change only one root: root1=' + toString_0(r1) + ', root2=' + toString_0(r2) + ']');
    }
    fire_2($this, EntityContextCommandProcessor$validate$lambda(operationRootId, op));
    return ensureNotNull(operationRootId);
  }
  function fire_2($this, caller) {
    if ($this.q3x_1 == null)
      return Unit_instance;
    var _iterator__ex2g4s = ensureNotNull($this.q3x_1).m();
    while (_iterator__ex2g4s.n()) {
      var validator = _iterator__ex2g4s.o();
      caller(validator);
    }
  }
  function checkCanFinishCommand($this) {
    if (!$this.l3x_1) {
      throw OtException_init_$Create$_0('No command in progress');
    }
  }
  function finishCommand($this) {
    $this.l3x_1 = false;
    $this.o3x_1 = null;
    $this.p3x_1 = null;
    resetOperationValidators($this);
  }
  function resetOperationValidators($this) {
    try {
      fire_2($this, OperationValidator$reset$ref());
    } catch ($p) {
      if ($p instanceof Error) {
        var t = $p;
        ThrowableHandlers_getInstance().k2r_1.j2r(t);
      } else {
        throw $p;
      }
    }
  }
  function executeOperation($this, op) {
    $this.n3x_1 = op;
    op.y3x($this.b3x_1, $this.e3x_1);
    $this.n3x_1 = null;
  }
  function transformThroughCurrentOperations($this, operation) {
    if ($this.p3x_1 == null)
      return operation;
    var newOp = operation;
    var rootId = OperationRootIdInfo_init_$Create$_0(operation).v3x_1;
    if (!(rootId == null) && equals(rootId, $this.o3x_1)) {
      newOp = transformOp($this, operation);
      $this.p3x_1 = transformCurrentOps($this, operation);
    }
    return newOp;
  }
  function transformOp($this, operation) {
    var currentOperation = operation;
    var _iterator__ex2g4s = ensureNotNull($this.p3x_1).m();
    while (_iterator__ex2g4s.n()) {
      var op = _iterator__ex2g4s.o();
      currentOperation = op.z3x(currentOperation, false);
    }
    return currentOperation;
  }
  function transformCurrentOps($this, operation) {
    var currentOperation = operation;
    var newOps = ArrayDeque_init_$Create$();
    var _iterator__ex2g4s = ensureNotNull($this.p3x_1).m();
    while (_iterator__ex2g4s.n()) {
      var op = _iterator__ex2g4s.o();
      var newOp = op.z3x(currentOperation, false);
      newOps.j(currentOperation.z3x(op, true));
      currentOperation = newOp;
    }
    return newOps;
  }
  function safeExecute($this, command) {
    $this.n3x_1 = null;
    try {
      command();
    } catch ($p) {
      if ($p instanceof Error) {
        var t = $p;
        var tmp;
        if ($this.n3x_1 == null) {
          tmp = t;
        } else {
          var tmp_0 = LoggingUtils_instance;
          var tmp_1 = $this.n3x_1;
          var opString = tmp_0.y3c((tmp_1 == null ? true : !(tmp_1 == null)) ? tmp_1 : THROW_CCE());
          tmp = RuntimeException_init_$Create$_1('Exception while executing operation\nop=' + opString, t);
        }
        var throwable = tmp;
        appendToCurrentError($this, throwable);
        ThrowableHandlers_getInstance().k2r_1.j2r(throwable);
      } else {
        throw $p;
      }
    }
    finally {
      $this.n3x_1 = null;
    }
  }
  function handleCurrentThrowable($this, recoverable) {
    if ($this.a3y()) {
      if (!recoverable) {
        appendToGlobalError($this, ensureNotNull($this.h3x_1));
        $this.h3x_1 = null;
      }
      return false;
    }
    return true;
  }
  function checkNotInError($this) {
    if (!($this.h3x_1 == null)) {
      throw IllegalStateException_init_$Create$_1('Working with command in error, stored is cause', $this.h3x_1);
    }
  }
  function appendToCurrentError($this, t) {
    (new EntityContextCommandProcessor$appendToCurrentError$1($this)).b3y(t);
  }
  function appendToGlobalError($this, t) {
    if (!$this.d3x_1)
      return Unit_instance;
    (new EntityContextCommandProcessor$appendToGlobalError$1($this)).b3y(t);
  }
  function ErrorAppender() {
  }
  protoOf(ErrorAppender).b3y = function (t) {
    var v = this.a1();
    if (v === t)
      return Unit_instance;
    if (v == null) {
      this.c3y(t);
    } else {
      if (v instanceof ThrowableCollectionException) {
        var throwables = v.m38();
        if (!throwables.t(t)) {
          this.c3y(ThrowableCollectionException_init_$Create$(throwables));
        }
      } else {
        this.c3y(ThrowableCollectionException_init_$Create$(listOf_0([v, t])));
      }
    }
  };
  function MyEventStateHolder($outer) {
    this.f3y_1 = $outer;
    EventStateHolder.call(this);
    this.e3y_1 = false;
  }
  protoOf(MyEventStateHolder).e3j = function () {
    protoOf(EventStateHolder).e3j.call(this);
    if (!this.f3y_1.l3x_1 && !this.f3y_1.m3x_1) {
      throw OtException_init_$Create$_0('Each operation must be performed inside command');
    }
  };
  protoOf(MyEventStateHolder).c3j = function (substitute) {
    // Inline function 'kotlin.check' call
    if (!this.e3y_1) {
      var message = 'Current context is already managed by some command processor. If you are serious, dispose the previous one first';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
  };
  function Companion_49() {
    Companion_instance_49 = this;
    var tmp = this;
    var tmp_0 = KotlinLogging_getInstance();
    tmp.g3y_1 = tmp_0.i2q(EntityContextCommandProcessor$Companion$LOG$lambda);
  }
  var Companion_instance_49;
  function Companion_getInstance_49() {
    if (Companion_instance_49 == null)
      new Companion_49();
    return Companion_instance_49;
  }
  function EntityContextCommandProcessor$1(this$0) {
    this.l3y_1 = this$0;
    EntityContextOperationsTracker.call(this, this$0.b3x_1, EntityContextCommandProcessor$o$_init_$lambda_6ce6sz(this$0));
  }
  protoOf(EntityContextCommandProcessor$1).m3y = function (op) {
    operationHappened(this.l3y_1, op);
  };
  function EntityContextCommandProcessor$addThrowableHandler$lambda(this$0) {
    return function (throwable) {
      var tmp;
      if ((this$0.l3x_1 || this$0.m3x_1) && isFatal(this$0, throwable)) {
        appendToCurrentError(this$0, throwable);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function EntityContextCommandProcessor$operationHappened$lambda($op) {
    return function (listener) {
      listener.r3y($op);
      return Unit_instance;
    };
  }
  function EntityContextCommandProcessor$validate$lambda($operationRootId, $op) {
    return function (validator) {
      validator.x3w(ensureNotNull($operationRootId), $op);
      return Unit_instance;
    };
  }
  function EntityContextCommandProcessor$addOperationValidator$$inlined$toDisposable$1(this$0, $validator) {
    this.s3y_1 = this$0;
    this.t3y_1 = $validator;
  }
  protoOf(EntityContextCommandProcessor$addOperationValidator$$inlined$toDisposable$1).zr = function () {
    ensureNotNull(this.s3y_1.q3x_1).h2(this.t3y_1);
    if (ensureNotNull(this.s3y_1.q3x_1).s()) {
      this.s3y_1.q3x_1 = null;
    }
    return Unit_instance;
  };
  function EntityContextCommandProcessor$dispose$lambda(this$0) {
    return function () {
      return 'Dispose ' + toString_1(this$0) + ' in invalid state: commandInProgress=' + this$0.l3x_1 + ', ' + ('inExternalCommand=' + this$0.m3x_1);
    };
  }
  function EntityContextCommandProcessor$startCommand$lambda($event) {
    return function (listener) {
      listener.u3y($event);
      return Unit_instance;
    };
  }
  function EntityContextCommandProcessor$commitCommand$lambda($resultOp) {
    return function (listener) {
      listener.v3y($resultOp);
      return Unit_instance;
    };
  }
  function OperationValidator$reset$ref() {
    var l = function (p0) {
      p0.y3w();
      return Unit_instance;
    };
    l.callableName = 'reset';
    return l;
  }
  function OtCommandListener$onExternalOperationStarted$ref() {
    var l = function (p0) {
      p0.w3y();
      return Unit_instance;
    };
    l.callableName = 'onExternalOperationStarted';
    return l;
  }
  function EntityContextCommandProcessor$executeExternal$lambda(this$0, $op) {
    return function () {
      var transformedOp = transformThroughCurrentOperations(this$0, $op);
      executeOperation(this$0, transformedOp);
      return Unit_instance;
    };
  }
  function EntityContextCommandProcessor$executeExternal$lambda_0($op) {
    return function (listener) {
      listener.x3y($op);
      return Unit_instance;
    };
  }
  function OtCommandListener$onExternalOperationFailed$ref() {
    var l = function (p0) {
      p0.y3y();
      return Unit_instance;
    };
    l.callableName = 'onExternalOperationFailed';
    return l;
  }
  function EntityContextCommandProcessor$appendToCurrentError$1(this$0) {
    this.z3y_1 = this$0;
    ErrorAppender.call(this);
  }
  protoOf(EntityContextCommandProcessor$appendToCurrentError$1).c3y = function (t) {
    this.z3y_1.h3x_1 = t;
  };
  protoOf(EntityContextCommandProcessor$appendToCurrentError$1).a1 = function () {
    return this.z3y_1.h3x_1;
  };
  function EntityContextCommandProcessor$appendToGlobalError$1(this$0) {
    this.a3z_1 = this$0;
    ErrorAppender.call(this);
  }
  protoOf(EntityContextCommandProcessor$appendToGlobalError$1).c3y = function (t) {
    return this.a3z_1.f3x_1.d2x(t);
  };
  protoOf(EntityContextCommandProcessor$appendToGlobalError$1).a1 = function () {
    return this.a3z_1.f3x_1.uv();
  };
  function EntityContextCommandProcessor(model, merger, isErrorCollectingEnabled, enableAddRemoveValidator, nodeFactory) {
    Companion_getInstance_49();
    nodeFactory = nodeFactory === VOID ? RawNodeFactory_instance : nodeFactory;
    this.b3x_1 = model;
    this.c3x_1 = merger;
    this.d3x_1 = isErrorCollectingEnabled;
    this.e3x_1 = nodeFactory;
    this.f3x_1 = new ValueProperty(null);
    this.h3x_1 = null;
    this.i3x_1 = new Listeners();
    this.k3x_1 = null;
    this.l3x_1 = false;
    this.m3x_1 = false;
    this.n3x_1 = null;
    this.o3x_1 = null;
    this.p3x_1 = null;
    this.q3x_1 = null;
    this.g3x_1 = new MyEventStateHolder(this);
    var tmp = this;
    tmp.j3x_1 = new EntityContextCommandProcessor$1(this);
    if (enableAddRemoveValidator) {
      this.b3z(new AddRemoveConsistencyValidator());
    }
  }
  protoOf(EntityContextCommandProcessor).c3z = function () {
    this.b3x_1.r3h(this.g3x_1);
  };
  protoOf(EntityContextCommandProcessor).a3y = function () {
    return !(this.h3x_1 == null);
  };
  protoOf(EntityContextCommandProcessor).d3z = function (listener) {
    return this.i3x_1.j2s(listener);
  };
  protoOf(EntityContextCommandProcessor).e3z = function (listener) {
    return this.d3z(listener);
  };
  protoOf(EntityContextCommandProcessor).b3z = function (validator) {
    if (this.q3x_1 == null) {
      this.q3x_1 = ArrayList_init_$Create$_0(1);
    }
    ensureNotNull(this.q3x_1).j(validator);
    // Inline function 'jetbrains.ocelot.base.disposable.toDisposable' call
    return new EntityContextCommandProcessor$addOperationValidator$$inlined$toDisposable$1(this, validator);
  };
  protoOf(EntityContextCommandProcessor).zr = function () {
    if (!(this.k3x_1 == null)) {
      ensureNotNull(this.k3x_1).zr();
    }
    this.g3x_1.e3y_1 = true;
    this.b3x_1.r3h(new EventStateHolder());
    this.j3x_1.zr();
    if (this.m3x_1 || this.l3x_1) {
      var tmp = Companion_getInstance_49().g3y_1;
      tmp.c2q(EntityContextCommandProcessor$dispose$lambda(this));
    }
  };
  protoOf(EntityContextCommandProcessor).f3z = function (undoGroupId) {
    addThrowableHandler(this);
    if (this.m3x_1) {
      throw OtException_init_$Create$_0('Execute changes while external command is in progress');
    }
    if (this.l3x_1) {
      throw OtException_init_$Create$_0('Start new command during command execution');
    }
    checkNotInError(this);
    this.l3x_1 = true;
    this.p3x_1 = ArrayDeque_init_$Create$();
    var event = new OtCommandEvent(undoGroupId);
    this.i3x_1.k2s(EntityContextCommandProcessor$startCommand$lambda(event));
  };
  protoOf(EntityContextCommandProcessor).g3z = function () {
    checkCanFinishCommand(this);
    if (this.a3y()) {
      finishCommand(this);
      handleCurrentThrowable(this, false);
      throw IllegalStateException_init_$Create$_1('Cannot commit failed command, throwable is cause and it is stored at processor.error', this.f3x_1.uv());
    }
    var resultOp = _get_resultOp__5l2s0j(this);
    finishCommand(this);
    this.i3x_1.k2s(EntityContextCommandProcessor$commitCommand$lambda(resultOp));
  };
  protoOf(EntityContextCommandProcessor).h3z = function (op) {
    addThrowableHandler(this);
    if (this.m3x_1) {
      throw OtException_init_$Create$_0('Execute external changes while external command is already in progress');
    }
    checkNotInError(this);
    this.i3x_1.k2s(OtCommandListener$onExternalOperationStarted$ref());
    this.m3x_1 = true;
    safeExecute(this, EntityContextCommandProcessor$executeExternal$lambda(this, op));
    var success = handleCurrentThrowable(this, false);
    this.m3x_1 = false;
    if (success) {
      this.i3x_1.k2s(EntityContextCommandProcessor$executeExternal$lambda_0(op));
    } else {
      this.i3x_1.k2s(OtCommandListener$onExternalOperationFailed$ref());
    }
  };
  protoOf(EntityContextCommandProcessor).i3z = function (reloadedRootId) {
    if (reloadedRootId.equals(this.o3x_1) && !(this.p3x_1 == null)) {
      ensureNotNull(this.p3x_1).k2();
    }
  };
  function EntityContextOperationsTracker$Companion$TRUE$lambda() {
    return true;
  }
  function EntityContextOperationsTracker$o$onItemAdded$lambda($event) {
    return function () {
      return OperationBuilder_instance.j3z($event.u2r());
    };
  }
  function EntityContextOperationsTracker$o$onItemRemoved$lambda($event) {
    return function () {
      return OperationBuilder_instance.k3z($event.s2r());
    };
  }
  function EntityContextOperationsTracker$o$onChildAdded$lambda($event) {
    return function () {
      return OperationConverter_instance.m3z($event.y3i_1, OperationBuilder_instance.l3z($event.s3j_1, $event.r3j_1));
    };
  }
  function EntityContextOperationsTracker$o$onChildRemoved$lambda($event) {
    return function () {
      return OperationConverter_instance.m3z($event.y3i_1, OperationBuilder_instance.n3z($event.s3j_1, $event.r3j_1));
    };
  }
  function EntityContextOperationsTracker$o$onChildMoved$lambda($event) {
    return function () {
      return Companion_instance_54.o3z($event.y3i_1, $event.l3k_1);
    };
  }
  function EntityContextOperationsTracker$o$onPropertyChanged$lambda($event) {
    return function () {
      return OperationConverter_instance.m3z($event.y3i_1, new SetPropertyOperation($event.q3k_1, new SetValueOperation($event.r3k_1, $event.s3k_1)));
    };
  }
  function EntityContextOperationsTracker$o$onReferenceAdded$lambda($event) {
    return function () {
      var addOperation = new AddToSetOperation($event.y3k_1, $event.x3k_1.f3g());
      var setReferenceOperation = new SetReferenceOperation($event.x3k_1, addOperation);
      return OperationConverter_instance.m3z($event.y3i_1, setReferenceOperation);
    };
  }
  function EntityContextOperationsTracker$o$onReferenceRemoved$lambda($event) {
    return function () {
      var removeOperation = new RemoveFromSetOperation($event.y3k_1, $event.x3k_1.f3g());
      var setReferenceOperation = new SetReferenceOperation($event.x3k_1, removeOperation);
      return OperationConverter_instance.m3z($event.y3i_1, setReferenceOperation);
    };
  }
  function EntityContextOperationsTracker$o$onModelBlobChanged$lambda($event, $oldModel) {
    return function () {
      return OperationConverter_instance.m3z($event.y3i_1, Companion_instance_52.p3z($event.h3k_1, $oldModel).q3z());
    };
  }
  function EntityContextOperationsTracker$o$onModelBlobChanged$lambda_0($event, $newModel) {
    return function () {
      return OperationConverter_instance.m3z($event.y3i_1, Companion_instance_52.p3z($event.h3k_1, $newModel));
    };
  }
  function EntityContextOperationsTracker$o$onNodeEvent$lambda($event, this$0) {
    return function () {
      $event.o3k_1.w2r(this$0.o3y_1);
      var operation = this$0.o3y_1.s3z();
      var changeModelBlobOperation = new ChangeModelBlobOperation($event.n3k_1, ensureNotNull(operation));
      return OperationConverter_instance.m3z($event.y3i_1, changeModelBlobOperation);
    };
  }
  function notifyAboutOperation($this, operationSupplier) {
    if ($this.n3y_1()) {
      $this.m3y(operationSupplier());
    }
  }
  function MyModelOperationTracker() {
    ModelOperationsTracker.call(this);
    this.r3z_1 = null;
  }
  protoOf(MyModelOperationTracker).s3z = function () {
    var op = this.r3z_1;
    this.r3z_1 = null;
    return op;
  };
  protoOf(MyModelOperationTracker).t3z = function (operation) {
    // Inline function 'kotlin.check' call
    if (!(this.r3z_1 == null)) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    this.r3z_1 = operation;
  };
  function Companion_50() {
    Companion_instance_50 = this;
    var tmp = this;
    tmp.u3z_1 = EntityContextOperationsTracker$Companion$TRUE$lambda;
  }
  var Companion_instance_50;
  function Companion_getInstance_50() {
    if (Companion_instance_50 == null)
      new Companion_50();
    return Companion_instance_50;
  }
  function EntityContextOperationsTracker$1(this$0) {
    this.v3z_1 = this$0;
    CollectionAdapter.call(this);
  }
  protoOf(EntityContextOperationsTracker$1).f3h = function (event) {
    notifyAboutOperation(this.v3z_1, EntityContextOperationsTracker$o$onItemAdded$lambda(event));
  };
  protoOf(EntityContextOperationsTracker$1).m2r = function (event) {
    return this.f3h(event);
  };
  protoOf(EntityContextOperationsTracker$1).h3h = function (event) {
    notifyAboutOperation(this.v3z_1, EntityContextOperationsTracker$o$onItemRemoved$lambda(event));
  };
  protoOf(EntityContextOperationsTracker$1).t2r = function (event) {
    return this.h3h(event);
  };
  function EntityContextOperationsTracker$2(this$0) {
    this.w3z_1 = this$0;
  }
  protoOf(EntityContextOperationsTracker$2).p3j = function (event) {
    notifyAboutOperation(this.w3z_1, EntityContextOperationsTracker$o$onChildAdded$lambda(event));
  };
  protoOf(EntityContextOperationsTracker$2).w3j = function (event) {
    notifyAboutOperation(this.w3z_1, EntityContextOperationsTracker$o$onChildRemoved$lambda(event));
  };
  protoOf(EntityContextOperationsTracker$2).a3k = function (event) {
    notifyAboutOperation(this.w3z_1, EntityContextOperationsTracker$o$onChildMoved$lambda(event));
  };
  protoOf(EntityContextOperationsTracker$2).b3k = function (event) {
    notifyAboutOperation(this.w3z_1, EntityContextOperationsTracker$o$onPropertyChanged$lambda(event));
  };
  protoOf(EntityContextOperationsTracker$2).c3k = function (event) {
    notifyAboutOperation(this.w3z_1, EntityContextOperationsTracker$o$onReferenceAdded$lambda(event));
  };
  protoOf(EntityContextOperationsTracker$2).d3k = function (event) {
    notifyAboutOperation(this.w3z_1, EntityContextOperationsTracker$o$onReferenceRemoved$lambda(event));
  };
  protoOf(EntityContextOperationsTracker$2).e3k = function (event) {
    var oldModel = event.i3k_1;
    if (!(oldModel == null)) {
      notifyAboutOperation(this.w3z_1, EntityContextOperationsTracker$o$onModelBlobChanged$lambda(event, oldModel));
    }
    var newModel = event.j3k_1;
    if (!(newModel == null)) {
      notifyAboutOperation(this.w3z_1, EntityContextOperationsTracker$o$onModelBlobChanged$lambda_0(event, newModel));
    }
  };
  protoOf(EntityContextOperationsTracker$2).f3k = function (event) {
    notifyAboutOperation(this.w3z_1, EntityContextOperationsTracker$o$onNodeEvent$lambda(event, this.w3z_1));
  };
  function EntityContextOperationsTracker(entityContext, notificationSupplier) {
    Companion_getInstance_50();
    this.n3y_1 = notificationSupplier;
    this.o3y_1 = new MyModelOperationTracker();
    var tmp = this;
    tmp.p3y_1 = entityContext.g3f_1.x2r(new EntityContextOperationsTracker$1(this));
    var tmp_0 = this;
    tmp_0.q3y_1 = entityContext.f3j(new EntityContextOperationsTracker$2(this));
  }
  protoOf(EntityContextOperationsTracker).zr = function () {
    this.p3y_1.zr();
    this.q3y_1.zr();
  };
  function Companion_51() {
    Companion_instance_51 = this;
    this.a3x_1 = new MergeNavAndEmptyUndoGroupId();
  }
  var Companion_instance_51;
  function Companion_getInstance_51() {
    if (Companion_instance_51 == null)
      new Companion_51();
    return Companion_instance_51;
  }
  function MergeNavAndEmptyUndoGroupId() {
    Companion_getInstance_51();
  }
  protoOf(MergeNavAndEmptyUndoGroupId).x3z = function (nextGroupId, nextType, currentType) {
    return nextGroupId === Companion_getInstance_51().a3x_1 && (currentType === UndoCommandType_EMPTY_getInstance() || (currentType === UndoCommandType_NAVIGATION_getInstance() && !(nextType === UndoCommandType_EDITING_getInstance())));
  };
  protoOf(MergeNavAndEmptyUndoGroupId).toString = function () {
    return 'default';
  };
  function newCommandProcessor(entityContext, merger, errorCollectingEnabled, enableAddRemoveValidator, nodeFactory) {
    errorCollectingEnabled = errorCollectingEnabled === VOID ? true : errorCollectingEnabled;
    enableAddRemoveValidator = enableAddRemoveValidator === VOID ? true : enableAddRemoveValidator;
    nodeFactory = nodeFactory === VOID ? RawNodeFactory_instance : nodeFactory;
    var processor = new EntityContextCommandProcessor(entityContext, merger, errorCollectingEnabled, enableAddRemoveValidator, nodeFactory);
    processor.c3z();
    return processor;
  }
  function OperationValidator() {
  }
  function OtCommandEvent(undoGroupId) {
    this.y3z_1 = undoGroupId;
  }
  protoOf(OtCommandEvent).toString = function () {
    return 'OtCommandEvent(undoGroupId=' + toString_1(this.y3z_1) + ')';
  };
  protoOf(OtCommandEvent).hashCode = function () {
    return hashCode(this.y3z_1);
  };
  protoOf(OtCommandEvent).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof OtCommandEvent))
      return false;
    if (!equals(this.y3z_1, other.y3z_1))
      return false;
    return true;
  };
  function OtCommandListener() {
  }
  function get_COMMAND_PROCESSOR_KEY() {
    _init_properties_InstallCommandProcessor_kt__w3apc();
    return COMMAND_PROCESSOR_KEY;
  }
  var COMMAND_PROCESSOR_KEY;
  var properties_initialized_InstallCommandProcessor_kt_ir07oy;
  function _init_properties_InstallCommandProcessor_kt__w3apc() {
    if (!properties_initialized_InstallCommandProcessor_kt_ir07oy) {
      properties_initialized_InstallCommandProcessor_kt_ir07oy = true;
      COMMAND_PROCESSOR_KEY = new WrapperContextKey('entityContextCommandProcessor');
    }
  }
  function buildAssemblyOperations($this) {
    var seq = ArrayList_init_$Create$();
    createEntityContentOperations($this, $this.z3z_1, seq);
    var _iterator__ex2g4s = $this.z3z_1.z3d().m();
    while (_iterator__ex2g4s.n()) {
      var childId = _iterator__ex2g4s.o();
      var children = $this.z3z_1.a3e(childId);
      var _iterator__ex2g4s_0 = children.m();
      while (_iterator__ex2g4s_0.n()) {
        var e = _iterator__ex2g4s_0.o();
        $this.a40(e, seq);
      }
    }
    return Companion_instance_68.b40(seq);
  }
  function createEntityContentOperations($this, entity, ops) {
    var _iterator__ex2g4s = entity.c3e().m();
    while (_iterator__ex2g4s.n()) {
      var propId = _iterator__ex2g4s.o();
      var property = entity.d3e(propId);
      if (!(property == null)) {
        ops.j(new SetPropertyOperation(propId, new SetValueOperation(null, property)));
      }
    }
    var _iterator__ex2g4s_0 = entity.f3e().m();
    while (_iterator__ex2g4s_0.n()) {
      var refId = _iterator__ex2g4s_0.o();
      var targets = entity.g3e(refId);
      var _iterator__ex2g4s_1 = targets.m();
      while (_iterator__ex2g4s_1.n()) {
        var ref = _iterator__ex2g4s_1.o();
        ops.j(new SetReferenceOperation(refId, new AddToSetOperation(ref, refId.f3g())));
      }
    }
    var _iterator__ex2g4s_2 = entity.h3e().m();
    while (_iterator__ex2g4s_2.n()) {
      var modelBlobId = _iterator__ex2g4s_2.o();
      var model = entity.i3e(modelBlobId);
      if (!(model == null)) {
        var operation = Companion_instance_52.p3z(modelBlobId, model);
        ops.j(operation);
      }
    }
  }
  function Companion_52() {
  }
  protoOf(Companion_52).p3z = function (modelBlobId, model) {
    var root = model.k3e_1;
    var modelOp = AddModelBlobOperation_init_$Create$(modelBlobId, root.e3m_1, NodeUtil_instance.c3n(root));
    var nodeAssemblyOperationBuilder = new NodeAssemblyOperationBuilder(root);
    var assemblyOp = new ChangeModelBlobOperation(modelBlobId, new SetModelOperation(nodeAssemblyOperationBuilder.f40()));
    return CompositeOperation_init_$Create$([modelOp, assemblyOp]);
  };
  var Companion_instance_52;
  function Companion_getInstance_52() {
    return Companion_instance_52;
  }
  function EntityAssemblyOperationBuilder(entity) {
    this.z3z_1 = entity;
  }
  protoOf(EntityAssemblyOperationBuilder).f40 = function () {
    return buildAssemblyOperations(this);
  };
  protoOf(EntityAssemblyOperationBuilder).a40 = function (child, ops) {
    var addAssembleOps = ArrayList_init_$Create$();
    var addOp = AddChildOperation_init_$Create$(child.m3d_1, child.n3d_1, ensureNotNull(child.p3d_1).f3g());
    addAssembleOps.j(addOp);
    var op = buildAssemblyOperations(new EntityAssemblyOperationBuilder(child));
    if (!op.r3x()) {
      addAssembleOps.j(new ChangeChildOperation(child.n3d_1, op));
    }
    ops.j(new ChildSetOperation(ensureNotNull(child.p3d_1), Companion_instance_68.b40(addAssembleOps)));
  };
  function EntityPrintOperationUtil() {
  }
  protoOf(EntityPrintOperationUtil).t3x = function (operation) {
    var res = PrintOperationUtil_instance.g40(operation);
    if (!(operation == null)) {
      res = res + ('\n' + Companion_instance_53.h40(operation).toString());
    }
    return res;
  };
  var EntityPrintOperationUtil_instance;
  function EntityPrintOperationUtil_getInstance() {
    return EntityPrintOperationUtil_instance;
  }
  function Descriptor() {
    this.i40_1 = HashSet_init_$Create$();
    this.j40_1 = HashSet_init_$Create$();
    this.k40_1 = HashSet_init_$Create$();
    this.l40_1 = HashSet_init_$Create$();
    this.m40_1 = HashSet_init_$Create$();
    this.n40_1 = HashSet_init_$Create$();
  }
  protoOf(Descriptor).toString = function () {
    return 'Descriptor{addedEntityConcepts=' + this.i40_1 + ', removedEntityConcepts=' + this.j40_1 + ', modifiedEntityProperties=' + this.k40_1 + ', addedNodeConcepts=' + this.l40_1 + ', removeNodeConcepts=' + this.m40_1 + ', modifiedNodeProperties=' + toString_1(this.n40_1) + '}';
  };
  function Companion_53() {
  }
  protoOf(Companion_53).h40 = function (operation) {
    var collector = new LeafOperationsCollector();
    collector.p40(operation);
    return collector.o40_1;
  };
  var Companion_instance_53;
  function Companion_getInstance_53() {
    return Companion_instance_53;
  }
  function LeafOperationsCollector() {
    OperationCondition.call(this);
    this.o40_1 = new Descriptor();
  }
  protoOf(LeafOperationsCollector).q40 = function (op) {
    if (op instanceof BuildRootOperation) {
      this.o40_1.i40_1.j(op.t42().m3d_1);
    } else {
      if (op instanceof AddRootOperation) {
        this.o40_1.i40_1.j(op.f3t());
      } else {
        if (op instanceof AddChildOperation) {
          this.o40_1.i40_1.j(op.f3t());
        } else {
          if (op instanceof RemoveRootOperation) {
            this.o40_1.j40_1.j(op.f3t());
          } else {
            if (op instanceof RemoveChildOperation) {
              this.o40_1.j40_1.j(op.f3t());
            } else {
              if (op instanceof AddModelBlobOperation) {
                this.o40_1.l40_1.j(op.q42());
              } else {
                if (op instanceof AddChildOperation_0) {
                  this.o40_1.l40_1.j(op.f3t());
                } else {
                  if (op instanceof RemoveModelBlobOperation) {
                    this.o40_1.m40_1.j(op.q42());
                  } else {
                    if (op instanceof RemoveChildOperation_0) {
                      this.o40_1.l40_1.j(op.f3t());
                    } else {
                      if (op instanceof ReplaceChildOperation) {
                        this.o40_1.m40_1.j(op.m42());
                        this.o40_1.l40_1.j(op.n42());
                      } else {
                        if (op instanceof AddChildSplitPropertyOperation) {
                          this.o40_1.l40_1.j(op.l41_1);
                          this.o40_1.n40_1.j(op.c42_1);
                        } else {
                          if (op instanceof AddChildSplitChildCollectionOperation) {
                            this.o40_1.l40_1.j(op.l41_1);
                          } else {
                            if (op instanceof MergePropertyRemoveChildOperation) {
                              this.o40_1.m40_1.j(op.s40_1);
                              this.o40_1.n40_1.j(op.h41_1);
                            } else {
                              if (op instanceof MergeChildCollectionRemoveChildOperation) {
                                this.o40_1.m40_1.j(op.s40_1);
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    return false;
  };
  protoOf(LeafOperationsCollector).p40 = function (op) {
    if (op instanceof SetPropertyOperation) {
      this.o40_1.k40_1.j(op.l3p());
      return Unit_instance;
    }
    if (op instanceof ChangePropertyOperation) {
      this.o40_1.n40_1.j(op.l3p());
      return Unit_instance;
    }
    protoOf(OperationCondition).p40.call(this, op);
  };
  function checkRoot($this, root) {
    // Inline function 'kotlin.require' call
    if (!(root.bp() == null)) {
      var message = 'Entity ' + root.toString() + ' is not root';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
  }
  function OperationBuilder() {
  }
  protoOf(OperationBuilder).z42 = function (entity) {
    return (new EntityAssemblyOperationBuilder(entity)).f40();
  };
  protoOf(OperationBuilder).a43 = function (entity) {
    return this.z42(entity).q3z();
  };
  protoOf(OperationBuilder).n3z = function (entity, role) {
    var entityId = entity.n3d_1;
    var disassembleOp = this.a43(entity);
    return new ChildSetOperation(role, CompositeOperation_init_$Create$([new ChangeChildOperation(entityId, disassembleOp), RemoveChildOperation_init_$Create$(entity.m3d_1, entityId, role.f3g())]));
  };
  protoOf(OperationBuilder).l3z = function (entity, role) {
    var entityId = entity.n3d_1;
    var assembleOp = this.z42(entity);
    return new ChildSetOperation(role, CompositeOperation_init_$Create$([AddChildOperation_init_$Create$(entity.m3d_1, entityId, role.f3g()), new ChangeChildOperation(entityId, assembleOp)]));
  };
  protoOf(OperationBuilder).j3z = function (root) {
    checkRoot(this, root);
    var rootId = root.n3d_1;
    var addRootOperation = AddRootOperation_init_$Create$(rootId, root.m3d_1);
    var assembleOp = this.z42(root);
    return CompositeOperation_init_$Create$([addRootOperation, new ChangeRootEntityOperation(rootId, assembleOp)]);
  };
  protoOf(OperationBuilder).k3z = function (root) {
    checkRoot(this, root);
    var rootId = root.n3d_1;
    var disassembleOp = this.a43(root);
    return CompositeOperation_init_$Create$([new ChangeRootEntityOperation(rootId, disassembleOp), RemoveRootOperation_init_$Create$(rootId, root.m3d_1)]);
  };
  var OperationBuilder_instance;
  function OperationBuilder_getInstance() {
    return OperationBuilder_instance;
  }
  function OperationConverter() {
  }
  protoOf(OperationConverter).m3z = function (entity, op) {
    var parent = entity.bp();
    var tmp;
    if (parent == null) {
      tmp = new ChangeRootEntityOperation(entity.n3d_1, op);
    } else {
      tmp = this.m3z(parent, new ChildSetOperation(ensureNotNull(entity.p3d_1), new ChangeChildOperation(entity.n3d_1, op)));
    }
    return tmp;
  };
  var OperationConverter_instance;
  function OperationConverter_getInstance() {
    return OperationConverter_instance;
  }
  function OperationRootIdInfo_init_$Init$($this) {
    OperationRootIdInfo.call($this);
    return $this;
  }
  function OperationRootIdInfo_init_$Create$() {
    return OperationRootIdInfo_init_$Init$(objectCreate(protoOf(OperationRootIdInfo)));
  }
  function OperationRootIdInfo_init_$Init$_0(op, $this) {
    OperationRootIdInfo.call($this);
    init_1($this, op);
    return $this;
  }
  function OperationRootIdInfo_init_$Create$_0(op) {
    return OperationRootIdInfo_init_$Init$_0(op, objectCreate(protoOf(OperationRootIdInfo)));
  }
  function init($this, operations) {
    var result = OperationRootIdInfo_init_$Create$();
    var _iterator__ex2g4s = operations.m();
    while (_iterator__ex2g4s.n()) {
      var childOp = _iterator__ex2g4s.o();
      var found = OperationRootIdInfo_init_$Create$();
      init_1(found, childOp);
      if (!(result.v3x_1 == null) && !(found.v3x_1 == null) && !equals(result.v3x_1, found.v3x_1)) {
        appendErrorMessage(result, '[transaction must change only one root]');
        init_0($this, result);
        return Unit_instance;
      }
      if (result.v3x_1 == null) {
        result.v3x_1 = found.v3x_1;
        result.u3x_1 = found.u3x_1;
      } else {
        if (found.u3x_1 === OperationKind_REMOVE_getInstance()) {
          result.u3x_1 = OperationKind_REMOVE_getInstance();
        }
      }
    }
    init_0($this, result);
  }
  function init_0($this, other) {
    $this.w3x_1 = other.w3x_1;
    $this.v3x_1 = other.v3x_1;
    $this.u3x_1 = other.u3x_1;
  }
  function init_1($this, op) {
    if (isInterface(op, RootOperation)) {
      var tmp = $this;
      tmp.v3x_1 = (isInterface(op, RootOperation) ? op : THROW_CCE()).m3w();
      var tmp_0 = $this;
      var tmp_1;
      var tmp_2;
      if (op instanceof ChangeRootEntityOperation) {
        tmp_2 = true;
      } else {
        tmp_2 = op instanceof MoveOperation;
      }
      if (tmp_2) {
        tmp_1 = OperationKind_CHANGE_getInstance();
      } else {
        var tmp_3;
        if (op instanceof AddRootOperation) {
          tmp_3 = true;
        } else {
          tmp_3 = op instanceof BuildRootOperation;
        }
        if (tmp_3) {
          tmp_1 = OperationKind_ADD_getInstance();
        } else {
          if (op instanceof RemoveRootOperation) {
            tmp_1 = OperationKind_REMOVE_getInstance();
          } else {
            throw IllegalStateException_init_$Create$_0('Unexpected root operation type: ' + toString_1(getKClassFromExpression(op)));
          }
        }
      }
      tmp_0.u3x_1 = tmp_1;
    } else {
      if (isInterface(op, OperationContainer)) {
        init($this, (isInterface(op, OperationContainer) ? op : THROW_CCE()).j3w());
      } else {
        if (op instanceof NoSubjectOperation) {
          $this.v3x_1 = null;
          $this.u3x_1 = null;
        } else {
          $this.w3x_1 = getImproperOpErrorMsg($this, op);
        }
      }
    }
  }
  function getImproperOpErrorMsg($this, op) {
    var s = op == null ? 'NULL' : getKClassFromExpression(op).ra();
    return '[unknown operation ' + s + ']';
  }
  function appendErrorMessage($this, extra) {
    if ($this.w3x_1 == null) {
      $this.w3x_1 = extra;
    } else {
      $this.w3x_1 = plus_12($this.w3x_1, extra);
    }
  }
  protoOf(OperationRootIdInfo).x3x = function () {
    return this.w3x_1 == null;
  };
  function OperationRootIdInfo() {
    this.u3x_1 = null;
    this.v3x_1 = null;
    this.w3x_1 = null;
  }
  function RootOperation() {
  }
  function AddChildOperation_init_$Init$(conceptId, entityId, singleRole, $this) {
    ChildOperation_init_$Init$(conceptId, entityId, singleRole, $this);
    AddChildOperation.call($this);
    return $this;
  }
  function AddChildOperation_init_$Create$(conceptId, entityId, singleRole) {
    return AddChildOperation_init_$Init$(conceptId, entityId, singleRole, objectCreate(protoOf(AddChildOperation)));
  }
  function AddChildOperation_init_$Init$_0(data, $this) {
    ChildOperation.call($this, data);
    AddChildOperation.call($this);
    return $this;
  }
  function AddChildOperation_init_$Create$_0(data) {
    return AddChildOperation_init_$Init$_0(data, objectCreate(protoOf(AddChildOperation)));
  }
  protoOf(AddChildOperation).y2 = function () {
    return 'addChild';
  };
  protoOf(AddChildOperation).d43 = function (otherOp, server) {
    var tmp;
    if (otherOp instanceof AddChildOperation) {
      this.g43(otherOp);
      var tmp_0;
      if (this.p3w().equals(otherOp.p3w())) {
        tmp_0 = new NopOperation();
      } else if (this.f3g()) {
        tmp_0 = server ? new NopOperation() : CompositeOperation_init_$Create$([this.q3z(), otherOp]);
      } else {
        tmp_0 = otherOp;
      }
      tmp = tmp_0;
    } else {
      tmp = protoOf(ChildOperation).f43.call(this, otherOp, server);
    }
    return tmp;
  };
  protoOf(AddChildOperation).f43 = function (otherOp, server) {
    return this.d43(otherOp, server);
  };
  protoOf(AddChildOperation).h43 = function (model, nodeFactory) {
    // Inline function 'kotlin.check' call
    if (!(!this.f3g() || model.s())) {
      var message = 'Add into not empty single-item child set';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    // Inline function 'kotlin.check' call
    if (!(model.a3h(this.p3w()) == null)) {
      var message_0 = 'Entity with id=' + this.p3w().toString() + ' already exists';
      throw IllegalStateException_init_$Create$_0(toString_1(message_0));
    }
    model.j(new Entity(this.f3t(), this.p3w()));
    return model;
  };
  protoOf(AddChildOperation).y3x = function (model, nodeFactory) {
    return this.h43((!(model == null) ? isInterface(model, EntitySet) : false) ? model : THROW_CCE(), nodeFactory);
  };
  protoOf(AddChildOperation).q3z = function () {
    return RemoveChildOperation_init_$Create$_0(this.o3w_1);
  };
  protoOf(AddChildOperation).j43 = function (model, ops, nodeFactory) {
    return (new AddChildOperationExecutor(nodeFactory)).o43(model, ops);
  };
  protoOf(AddChildOperation).p43 = function (model, ops, nodeFactory) {
    return this.j43((!(model == null) ? isInterface(model, EntitySet) : false) ? model : THROW_CCE(), ops, nodeFactory);
  };
  function AddChildOperation() {
  }
  function ChangeChildOperation(role, op) {
    TargetedOperation.call(this, role, op);
  }
  protoOf(ChangeChildOperation).y2 = function () {
    return 'changeChild';
  };
  protoOf(ChangeChildOperation).w43 = function (op) {
    return new ChangeChildOperation(this.l3p(), op);
  };
  protoOf(ChangeChildOperation).x43 = function (op) {
    return this.w43(op);
  };
  protoOf(ChangeChildOperation).d43 = function (otherOp, server) {
    if (otherOp instanceof RemoveChildOperation) {
      if (otherOp.p3w().equals(this.l3p())) {
        var fake = new Entity(otherOp.f3t(), otherOp.p3w());
        fake = this.s3z().y3x(fake, RawNodeFactory_instance);
        var disassemble = OperationBuilder_instance.a43(fake);
        var changeChildOperation = new ChangeChildOperation(this.l3p(), disassemble);
        return CompositeOperation_init_$Create$([changeChildOperation, otherOp]);
      }
    }
    return protoOf(TargetedOperation).y43.call(this, otherOp, server);
  };
  protoOf(ChangeChildOperation).f43 = function (otherOp, server) {
    return this.d43(otherOp, server);
  };
  protoOf(ChangeChildOperation).y43 = function (otherOp, server) {
    return this.d43(otherOp, server);
  };
  protoOf(ChangeChildOperation).z43 = function (otherOp, server) {
    if (otherOp instanceof RemoveChildOperation) {
      if (otherOp.p3w().equals(this.l3p())) {
        return new NopOperation();
      }
    }
    return protoOf(TargetedOperation).q43.call(this, otherOp, server);
  };
  protoOf(ChangeChildOperation).q43 = function (otherOp, server) {
    return this.z43(otherOp, server);
  };
  protoOf(ChangeChildOperation).a44 = function (source) {
    return source.a3h(this.l3p());
  };
  protoOf(ChangeChildOperation).b44 = function (source) {
    return this.a44((!(source == null) ? isInterface(source, EntitySet) : false) ? source : THROW_CCE());
  };
  protoOf(ChangeChildOperation).j43 = function (model, ops, nodeFactory) {
    return (new ChangeChildOperationExecutor(nodeFactory)).o43(model, ops);
  };
  protoOf(ChangeChildOperation).p43 = function (model, ops, nodeFactory) {
    return this.j43((!(model == null) ? isInterface(model, EntitySet) : false) ? model : THROW_CCE(), ops, nodeFactory);
  };
  function ChildOperation_init_$Init$(conceptId, entityId, singleRole, $this) {
    ChildOperation.call($this, new EntityChildOperationData(conceptId, entityId, singleRole));
    return $this;
  }
  function ChildOperation(operationData) {
    BaseOperation.call(this);
    this.o3w_1 = operationData;
  }
  protoOf(ChildOperation).f3t = function () {
    return this.o3w_1.f44_1;
  };
  protoOf(ChildOperation).p3w = function () {
    return this.o3w_1.g44_1;
  };
  protoOf(ChildOperation).f3g = function () {
    return this.o3w_1.h44_1;
  };
  protoOf(ChildOperation).g43 = function (otherOp) {
    // Inline function 'kotlin.check' call
    if (!(this.f3g() === otherOp.f3g())) {
      var message = "Mismatching 'single role' flag";
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
  };
  protoOf(ChildOperation).toString = function () {
    return this.y2() + '[id = ' + this.p3w().toString() + ';c = ' + this.f3t().toString() + ']';
  };
  function ChildOperationUtil() {
  }
  protoOf(ChildOperationUtil).i44 = function (op) {
    return op instanceof AddChildOperation;
  };
  protoOf(ChildOperationUtil).j44 = function (op) {
    return op instanceof RemoveChildOperation;
  };
  protoOf(ChildOperationUtil).k44 = function (op) {
    return op instanceof ChangeChildOperation;
  };
  protoOf(ChildOperationUtil).l44 = function (op) {
    var tmp;
    if (op instanceof ChildOperation) {
      tmp = op.p3w();
    } else {
      if (op instanceof ChangeChildOperation) {
        tmp = op.l3p();
      } else {
        throw IllegalArgumentException_init_$Create$_0('Unknown operation to get role from: ' + PrintOperationUtil_instance.g40(op));
      }
    }
    return tmp;
  };
  protoOf(ChildOperationUtil).m44 = function (op) {
    return this.l44(op);
  };
  protoOf(ChildOperationUtil).n44 = function (op) {
    return (op instanceof ChildOperation ? op : THROW_CCE()).o3w_1;
  };
  protoOf(ChildOperationUtil).o44 = function (op) {
    return this.n44(op);
  };
  protoOf(ChildOperationUtil).p44 = function (role, data) {
    return AddChildOperation_init_$Create$_0(data);
  };
  protoOf(ChildOperationUtil).q44 = function (role, data) {
    var tmp = role instanceof EntityId ? role : THROW_CCE();
    return this.p44(tmp, data instanceof EntityChildOperationData ? data : THROW_CCE());
  };
  protoOf(ChildOperationUtil).r44 = function (role, data) {
    return RemoveChildOperation_init_$Create$_0(data);
  };
  protoOf(ChildOperationUtil).s44 = function (role, data) {
    var tmp = role instanceof EntityId ? role : THROW_CCE();
    return this.r44(tmp, data instanceof EntityChildOperationData ? data : THROW_CCE());
  };
  protoOf(ChildOperationUtil).t44 = function (role, innerOp) {
    return new ChangeChildOperation(role, innerOp);
  };
  protoOf(ChildOperationUtil).u44 = function (role, innerOp) {
    return this.t44(role instanceof EntityId ? role : THROW_CCE(), innerOp);
  };
  function EntityChildOperationData(conceptId, entityId, isSingleRole) {
    this.f44_1 = conceptId;
    this.g44_1 = entityId;
    this.h44_1 = isSingleRole;
  }
  protoOf(EntityChildOperationData).toString = function () {
    return 'EntityChildOperationData(conceptId=' + this.f44_1.toString() + ', entityId=' + this.g44_1.toString() + ', isSingleRole=' + this.h44_1 + ')';
  };
  protoOf(EntityChildOperationData).hashCode = function () {
    var result = this.f44_1.hashCode();
    result = imul(result, 31) + this.g44_1.hashCode() | 0;
    result = imul(result, 31) + getBooleanHashCode(this.h44_1) | 0;
    return result;
  };
  protoOf(EntityChildOperationData).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof EntityChildOperationData))
      return false;
    if (!this.f44_1.equals(other.f44_1))
      return false;
    if (!this.g44_1.equals(other.g44_1))
      return false;
    if (!(this.h44_1 === other.h44_1))
      return false;
    return true;
  };
  function RemoveChildOperation_init_$Init$(conceptId, entityId, singleRole, $this) {
    ChildOperation_init_$Init$(conceptId, entityId, singleRole, $this);
    RemoveChildOperation.call($this);
    return $this;
  }
  function RemoveChildOperation_init_$Create$(conceptId, entityId, singleRole) {
    return RemoveChildOperation_init_$Init$(conceptId, entityId, singleRole, objectCreate(protoOf(RemoveChildOperation)));
  }
  function RemoveChildOperation_init_$Init$_0(data, $this) {
    ChildOperation.call($this, data);
    RemoveChildOperation.call($this);
    return $this;
  }
  function RemoveChildOperation_init_$Create$_0(data) {
    return RemoveChildOperation_init_$Init$_0(data, objectCreate(protoOf(RemoveChildOperation)));
  }
  protoOf(RemoveChildOperation).y2 = function () {
    return 'removeChild';
  };
  protoOf(RemoveChildOperation).d43 = function (otherOp, server) {
    if (otherOp instanceof RemoveChildOperation) {
      this.g43(otherOp instanceof ChildOperation ? otherOp : THROW_CCE());
    }
    var tmp;
    if (otherOp instanceof RemoveChildOperation) {
      tmp = this.p3w().equals(otherOp.p3w()) ? new NopOperation() : otherOp;
    } else {
      if (otherOp instanceof AddChildOperation) {
        tmp = this.p3w().equals(otherOp.p3w()) ? new NopOperation() : otherOp;
      } else {
        tmp = protoOf(ChildOperation).f43.call(this, otherOp, server);
      }
    }
    return tmp;
  };
  protoOf(RemoveChildOperation).f43 = function (otherOp, server) {
    return this.d43(otherOp, server);
  };
  protoOf(RemoveChildOperation).h43 = function (model, nodeFactory) {
    // Inline function 'kotlin.check' call
    if (!(!this.f3g() || model.p() === 1)) {
      var message = "'Single role' set size=" + model.p();
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    var tmp0_elvis_lhs = model.a3h(this.p3w());
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalStateException_init_$Create$_0(EntityMessages_instance.x44(this.p3w()));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var entity = tmp;
    // Inline function 'kotlin.check' call
    if (!this.f3t().equals(entity.m3d_1)) {
      var message_0 = MessageBundle_instance.e3n(this.f3t(), entity.m3d_1);
      throw IllegalStateException_init_$Create$_0(toString_1(message_0));
    }
    // Inline function 'kotlin.check' call
    if (!entity.w2m()) {
      var message_1 = MessageBundle_instance.g3n(this.p3w());
      throw IllegalStateException_init_$Create$_0(toString_1(message_1));
    }
    model.h2(entity);
    return model;
  };
  protoOf(RemoveChildOperation).y3x = function (model, nodeFactory) {
    return this.h43((!(model == null) ? isInterface(model, EntitySet) : false) ? model : THROW_CCE(), nodeFactory);
  };
  protoOf(RemoveChildOperation).q3z = function () {
    return AddChildOperation_init_$Create$_0(this.o3w_1);
  };
  function RemoveChildOperation() {
  }
  function AddRootOperation_init_$Init$(entityId, conceptId, $this) {
    RootEntityOperation_init_$Init$(entityId, conceptId, $this);
    AddRootOperation.call($this);
    return $this;
  }
  function AddRootOperation_init_$Create$(entityId, conceptId) {
    return AddRootOperation_init_$Init$(entityId, conceptId, objectCreate(protoOf(AddRootOperation)));
  }
  function AddRootOperation_init_$Init$_0(operationData, $this) {
    RootEntityOperation.call($this, operationData);
    AddRootOperation.call($this);
    return $this;
  }
  function AddRootOperation_init_$Create$_0(operationData) {
    return AddRootOperation_init_$Init$_0(operationData, objectCreate(protoOf(AddRootOperation)));
  }
  function assertRootIsNotExist($this, model) {
    // Inline function 'kotlin.check' call
    if (!(model.g3f_1.a3h($this.m3w()) == null)) {
      var message = "Duplicate root id='" + $this.m3w().toString() + "'";
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
  }
  protoOf(AddRootOperation).a45 = function (otherOp, server) {
    if (otherOp instanceof AddRootOperation) {
      if (otherOp.m3w().equals(this.m3w())) {
        return new NopOperation();
      }
    }
    return protoOf(RootEntityOperation).f43.call(this, otherOp, server);
  };
  protoOf(AddRootOperation).f43 = function (otherOp, server) {
    return this.a45(otherOp, server);
  };
  protoOf(AddRootOperation).b45 = function (model, nodeFactory) {
    assertRootIsNotExist(this, model);
    var entity = new Entity(this.f3t(), this.m3w());
    model.g3f_1.j(entity);
    return model;
  };
  protoOf(AddRootOperation).y3x = function (model, nodeFactory) {
    return this.b45(model instanceof EntityContext ? model : THROW_CCE(), nodeFactory);
  };
  protoOf(AddRootOperation).q3z = function () {
    return RemoveRootOperation_init_$Create$_0(this.l3w_1);
  };
  protoOf(AddRootOperation).toString = function () {
    return 'addRoot[c = ' + this.m3w().toString() + ';id = ' + this.f3t().toString() + ']';
  };
  protoOf(AddRootOperation).c45 = function (model, ops, nodeFactory) {
    assertRootIsNotExist(this, model);
    return (new AddRootOperationExecutor(nodeFactory)).o43(model, ops);
  };
  protoOf(AddRootOperation).p43 = function (model, ops, nodeFactory) {
    return this.c45(model instanceof EntityContext ? model : THROW_CCE(), ops, nodeFactory);
  };
  function AddRootOperation() {
  }
  function AddRootOperationExecutor$installChecker$1(this$0) {
    this.f45_1 = this$0;
    RootOperationsExecutorChecker.call(this, ensureNotNull(this$0.l43_1).m3w(), this$0.g45());
  }
  protoOf(AddRootOperationExecutor$installChecker$1).x3j = function (event) {
    return this.j45(event);
  };
  protoOf(AddRootOperationExecutor$installChecker$1).z3j = function (event) {
    return this.f45_1.i3a();
  };
  function AddRootOperationExecutor(nodeFactory) {
    nodeFactory = nodeFactory === VOID ? RawNodeFactory_instance : nodeFactory;
    BaseAddOperationExecutor.call(this, nodeFactory);
  }
  protoOf(AddRootOperationExecutor).o45 = function (op) {
    return op instanceof AddRootOperation;
  };
  protoOf(AddRootOperationExecutor).p45 = function (op) {
    return this.o45(op);
  };
  protoOf(AddRootOperationExecutor).q45 = function (op) {
    return RootOperationsExecutorUtil_instance.r45(ensureNotNull(this.l43_1).m3w(), op);
  };
  protoOf(AddRootOperationExecutor).s45 = function (op) {
    return this.q45(op);
  };
  protoOf(AddRootOperationExecutor).t45 = function (source) {
    return new EntityContext();
  };
  protoOf(AddRootOperationExecutor).u45 = function (source) {
    return this.t45(source instanceof EntityContext ? source : THROW_CCE());
  };
  protoOf(AddRootOperationExecutor).v45 = function (tempContainer) {
    return tempContainer;
  };
  protoOf(AddRootOperationExecutor).w45 = function (tempContainer) {
    return this.v45(tempContainer instanceof EntityContext ? tempContainer : THROW_CCE());
  };
  protoOf(AddRootOperationExecutor).x45 = function (source, temp) {
    var root = temp.g3f_1.a3h(ensureNotNull(this.l43_1).m3w());
    // Inline function 'kotlin.collections.remove' call
    var this_0 = temp.g3f_1;
    (isInterface(this_0, MutableCollection) ? this_0 : THROW_CCE()).h2(root);
    source.g3f_1.j(ensureNotNull(root));
  };
  protoOf(AddRootOperationExecutor).y45 = function (source, temp) {
    var tmp = source instanceof EntityContext ? source : THROW_CCE();
    return this.x45(tmp, temp instanceof EntityContext ? temp : THROW_CCE());
  };
  protoOf(AddRootOperationExecutor).z45 = function (tempContainer) {
    return tempContainer.f3j(new AddRootOperationExecutor$installChecker$1(this));
  };
  protoOf(AddRootOperationExecutor).a46 = function (tempContainer) {
    return this.z45(tempContainer instanceof EntityContext ? tempContainer : THROW_CCE());
  };
  function BuildRootOperation(filter) {
    filter = filter === VOID ? null : filter;
    BaseOperation.call(this);
    this.s42_1 = filter;
  }
  protoOf(BuildRootOperation).m3w = function () {
    return this.j46().n3d_1;
  };
  protoOf(BuildRootOperation).a45 = function (otherOp, server) {
    var tmp;
    if (!isInterface(otherOp, RootOperation)) {
      tmp = true;
    } else {
      var tmp_0 = this.j46().n3d_1;
      tmp = !tmp_0.equals((isInterface(otherOp, RootOperation) ? otherOp : THROW_CCE()).m3w());
    }
    // Inline function 'kotlin.check' call
    if (!tmp) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    return protoOf(BaseOperation).f43.call(this, otherOp, server);
  };
  protoOf(BuildRootOperation).f43 = function (otherOp, server) {
    return this.a45(otherOp, server);
  };
  protoOf(BuildRootOperation).k46 = function (otherOp, server) {
    var tmp;
    if (!isInterface(otherOp, RootOperation)) {
      tmp = true;
    } else {
      var tmp_0 = this.j46().n3d_1;
      tmp = !tmp_0.equals((isInterface(otherOp, RootOperation) ? otherOp : THROW_CCE()).m3w());
    }
    // Inline function 'kotlin.check' call
    if (!tmp) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    return protoOf(BaseOperation).q43.call(this, otherOp, server);
  };
  protoOf(BuildRootOperation).q43 = function (otherOp, server) {
    return this.k46(otherOp, server);
  };
  protoOf(BuildRootOperation).b45 = function (model, nodeFactory) {
    model.g3f_1.j(this.t42());
    return model;
  };
  protoOf(BuildRootOperation).y3x = function (model, nodeFactory) {
    return this.b45(model instanceof EntityContext ? model : THROW_CCE(), nodeFactory);
  };
  protoOf(BuildRootOperation).q3z = function () {
    throw IllegalStateException_init_$Create$();
  };
  protoOf(BuildRootOperation).toString = function () {
    return 'buildRoot[' + this.j46().toString() + ']';
  };
  function ChangeRootEntityOperation(role, op) {
    TargetedOperation.call(this, role, op);
  }
  protoOf(ChangeRootEntityOperation).y2 = function () {
    return 'changeRoot';
  };
  protoOf(ChangeRootEntityOperation).m3w = function () {
    return this.l3p();
  };
  protoOf(ChangeRootEntityOperation).a45 = function (otherOp, server) {
    if (otherOp instanceof RemoveRootOperation) {
      if (this.l3p().equals(otherOp.m3w())) {
        return CompositeOperation_init_$Create$([this.q3z(), otherOp]);
      }
    }
    return protoOf(TargetedOperation).y43.call(this, otherOp, server);
  };
  protoOf(ChangeRootEntityOperation).f43 = function (otherOp, server) {
    return this.a45(otherOp, server);
  };
  protoOf(ChangeRootEntityOperation).y43 = function (otherOp, server) {
    return this.a45(otherOp, server);
  };
  protoOf(ChangeRootEntityOperation).k46 = function (otherOp, server) {
    if (otherOp instanceof RemoveRootOperation) {
      if (this.l3p().equals(otherOp.m3w())) {
        return new NopOperation();
      }
    }
    return protoOf(TargetedOperation).q43.call(this, otherOp, server);
  };
  protoOf(ChangeRootEntityOperation).q43 = function (otherOp, server) {
    return this.k46(otherOp, server);
  };
  protoOf(ChangeRootEntityOperation).w43 = function (op) {
    return new ChangeRootEntityOperation(this.l3p(), op);
  };
  protoOf(ChangeRootEntityOperation).x43 = function (op) {
    return this.w43(op);
  };
  protoOf(ChangeRootEntityOperation).o46 = function (source) {
    return source.g3f_1.a3h(this.l3p());
  };
  protoOf(ChangeRootEntityOperation).b44 = function (source) {
    return this.o46(source instanceof EntityContext ? source : THROW_CCE());
  };
  protoOf(ChangeRootEntityOperation).c45 = function (model, ops, nodeFactory) {
    return (new ChangeRootOperationExecutor(nodeFactory)).o43(model, ops);
  };
  protoOf(ChangeRootEntityOperation).p43 = function (model, ops, nodeFactory) {
    return this.c45(model instanceof EntityContext ? model : THROW_CCE(), ops, nodeFactory);
  };
  function ChangeRootOperationExecutor$installChecker$1(this$0) {
    this.r46_1 = this$0;
    RootOperationsExecutorChecker.call(this, ensureNotNull(this$0.l43_1).m3w(), this$0.g45());
  }
  protoOf(ChangeRootOperationExecutor$installChecker$1).x3j = function (event) {
    this.r46_1.i3a();
  };
  protoOf(ChangeRootOperationExecutor$installChecker$1).z3j = function (event) {
    this.j45(event);
  };
  function ChangeRootOperationExecutor(nodeFactory) {
    nodeFactory = nodeFactory === VOID ? RawNodeFactory_instance : nodeFactory;
    BaseRemoveOperationExecutor.call(this, nodeFactory);
  }
  protoOf(ChangeRootOperationExecutor).o45 = function (op) {
    return op instanceof RemoveRootOperation;
  };
  protoOf(ChangeRootOperationExecutor).p45 = function (op) {
    return this.o45(op);
  };
  protoOf(ChangeRootOperationExecutor).w46 = function (source) {
    return !(source.d3j(ensureNotNull(this.l43_1).m3w()) == null);
  };
  protoOf(ChangeRootOperationExecutor).h46 = function (source) {
    return this.w46(source instanceof EntityContext ? source : THROW_CCE());
  };
  protoOf(ChangeRootOperationExecutor).x46 = function (op) {
    return RootOperationsExecutorUtil_instance.r45(ensureNotNull(this.l43_1).m3w(), op);
  };
  protoOf(ChangeRootOperationExecutor).i46 = function (op) {
    return this.x46(op);
  };
  protoOf(ChangeRootOperationExecutor).t45 = function (source) {
    var context = new EntityContext();
    var root = source.g3f_1.a3h(ensureNotNull(this.l43_1).m3w());
    context.g3f_1.j(Entities_getInstance().b3e(ensureNotNull(root)));
    return context;
  };
  protoOf(ChangeRootOperationExecutor).u45 = function (source) {
    return this.t45(source instanceof EntityContext ? source : THROW_CCE());
  };
  protoOf(ChangeRootOperationExecutor).v45 = function (tempContainer) {
    return tempContainer;
  };
  protoOf(ChangeRootOperationExecutor).w45 = function (tempContainer) {
    return this.v45(tempContainer instanceof EntityContext ? tempContainer : THROW_CCE());
  };
  protoOf(ChangeRootOperationExecutor).x45 = function (source, temp) {
    var rootEntities = source.g3f_1;
    var root = rootEntities.a3h(ensureNotNull(this.l43_1).m3w());
    // Inline function 'kotlin.collections.remove' call
    (isInterface(rootEntities, MutableCollection) ? rootEntities : THROW_CCE()).h2(root);
  };
  protoOf(ChangeRootOperationExecutor).y45 = function (source, temp) {
    var tmp = source instanceof EntityContext ? source : THROW_CCE();
    return this.x45(tmp, temp instanceof EntityContext ? temp : THROW_CCE());
  };
  protoOf(ChangeRootOperationExecutor).z45 = function (tempContainer) {
    return tempContainer.f3j(new ChangeRootOperationExecutor$installChecker$1(this));
  };
  protoOf(ChangeRootOperationExecutor).a46 = function (tempContainer) {
    return this.z45(tempContainer instanceof EntityContext ? tempContainer : THROW_CCE());
  };
  function RemoveRootOperation_init_$Init$(entityId, conceptId, $this) {
    RootEntityOperation_init_$Init$(entityId, conceptId, $this);
    RemoveRootOperation.call($this);
    return $this;
  }
  function RemoveRootOperation_init_$Create$(entityId, conceptId) {
    return RemoveRootOperation_init_$Init$(entityId, conceptId, objectCreate(protoOf(RemoveRootOperation)));
  }
  function RemoveRootOperation_init_$Init$_0(operationData, $this) {
    RootEntityOperation.call($this, operationData);
    RemoveRootOperation.call($this);
    return $this;
  }
  function RemoveRootOperation_init_$Create$_0(operationData) {
    return RemoveRootOperation_init_$Init$_0(operationData, objectCreate(protoOf(RemoveRootOperation)));
  }
  protoOf(RemoveRootOperation).b45 = function (model, nodeFactory) {
    var rootEntities = model.g3f_1;
    var root = rootEntities.a3h(this.m3w());
    $l$block: {
      // Inline function 'kotlin.checkNotNull' call
      if (root == null) {
        var message = "No root with id='" + this.m3w().toString() + "'";
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      } else {
        break $l$block;
      }
    }
    // Inline function 'kotlin.check' call
    if (!root.w2m()) {
      var message_0 = MessageBundle_instance.g3n(this.m3w());
      throw IllegalStateException_init_$Create$_0(toString_1(message_0));
    }
    rootEntities.h2(root);
    return model;
  };
  protoOf(RemoveRootOperation).y3x = function (model, nodeFactory) {
    return this.b45(model instanceof EntityContext ? model : THROW_CCE(), nodeFactory);
  };
  protoOf(RemoveRootOperation).q3z = function () {
    return AddRootOperation_init_$Create$_0(this.l3w_1);
  };
  protoOf(RemoveRootOperation).a45 = function (otherOp, server) {
    if (otherOp instanceof RemoveRootOperation) {
      if (otherOp.m3w().equals(this.m3w())) {
        return new NopOperation();
      }
    }
    return protoOf(RootEntityOperation).f43.call(this, otherOp, server);
  };
  protoOf(RemoveRootOperation).f43 = function (otherOp, server) {
    return this.a45(otherOp, server);
  };
  protoOf(RemoveRootOperation).toString = function () {
    return 'removeRoot[c = ' + this.f3t().toString() + ';id = ' + this.m3w().toString() + ']';
  };
  function RemoveRootOperation() {
  }
  function RootEntityOperation_init_$Init$(entityId, conceptId, $this) {
    RootEntityOperation.call($this, new RootOperationData(entityId, conceptId));
    return $this;
  }
  function RootEntityOperation(operationData) {
    BaseOperation.call(this);
    this.l3w_1 = operationData;
  }
  protoOf(RootEntityOperation).m3w = function () {
    return this.l3w_1.e47_1;
  };
  protoOf(RootEntityOperation).f3t = function () {
    return this.l3w_1.f47_1;
  };
  function RootOperationData(entityId, conceptId) {
    this.e47_1 = entityId;
    this.f47_1 = conceptId;
  }
  protoOf(RootOperationData).toString = function () {
    return 'RootOperationData(entityId=' + this.e47_1.toString() + ', conceptId=' + this.f47_1.toString() + ')';
  };
  protoOf(RootOperationData).hashCode = function () {
    var result = this.e47_1.hashCode();
    result = imul(result, 31) + this.f47_1.hashCode() | 0;
    return result;
  };
  protoOf(RootOperationData).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RootOperationData))
      return false;
    if (!this.e47_1.equals(other.e47_1))
      return false;
    if (!this.f47_1.equals(other.f47_1))
      return false;
    return true;
  };
  function RootOperationUtil() {
  }
  protoOf(RootOperationUtil).i44 = function (op) {
    return op instanceof AddRootOperation;
  };
  protoOf(RootOperationUtil).j44 = function (op) {
    return op instanceof RemoveRootOperation;
  };
  protoOf(RootOperationUtil).k44 = function (op) {
    return op instanceof ChangeRootEntityOperation;
  };
  protoOf(RootOperationUtil).g47 = function (op) {
    var tmp;
    if (op instanceof RootEntityOperation) {
      tmp = op.m3w();
    } else {
      if (op instanceof ChangeRootEntityOperation) {
        tmp = op.l3p();
      } else {
        throw IllegalArgumentException_init_$Create$_0('Unknown operation to get role from: ' + PrintOperationUtil_instance.g40(op));
      }
    }
    return tmp;
  };
  protoOf(RootOperationUtil).m44 = function (op) {
    return this.g47(op);
  };
  protoOf(RootOperationUtil).h47 = function (op) {
    return (op instanceof RootEntityOperation ? op : THROW_CCE()).l3w_1;
  };
  protoOf(RootOperationUtil).o44 = function (op) {
    return this.h47(op);
  };
  protoOf(RootOperationUtil).i47 = function (role, data) {
    return AddRootOperation_init_$Create$_0(data);
  };
  protoOf(RootOperationUtil).q44 = function (role, data) {
    var tmp = role instanceof EntityId ? role : THROW_CCE();
    return this.i47(tmp, data instanceof RootOperationData ? data : THROW_CCE());
  };
  protoOf(RootOperationUtil).j47 = function (role, data) {
    return RemoveRootOperation_init_$Create$_0(data);
  };
  protoOf(RootOperationUtil).s44 = function (role, data) {
    var tmp = role instanceof EntityId ? role : THROW_CCE();
    return this.j47(tmp, data instanceof RootOperationData ? data : THROW_CCE());
  };
  protoOf(RootOperationUtil).t44 = function (role, innerOp) {
    return new ChangeRootEntityOperation(role, innerOp);
  };
  protoOf(RootOperationUtil).u44 = function (role, innerOp) {
    return this.t44(role instanceof EntityId ? role : THROW_CCE(), innerOp);
  };
  function RootOperationsExecutorChecker(allowedRootId, canceller) {
    this.h45_1 = allowedRootId;
    this.i45_1 = canceller;
  }
  protoOf(RootOperationsExecutorChecker).y3j = function (event) {
    if (!Entities_getInstance().u3e(this.h45_1, event.y3i_1)) {
      this.i45_1();
    }
  };
  protoOf(RootOperationsExecutorChecker).j45 = function (e) {
    if (!this.h45_1.equals(e.y3i_1.n3d_1)) {
      this.i45_1();
    }
  };
  function RootOperationsExecutorUtil() {
  }
  protoOf(RootOperationsExecutorUtil).r45 = function (expectedRootId, op) {
    var tmp;
    if (op instanceof ChangeRootEntityOperation) {
      tmp = expectedRootId.equals(op.m3w());
    } else {
      tmp = false;
    }
    return tmp;
  };
  var RootOperationsExecutorUtil_instance;
  function RootOperationsExecutorUtil_getInstance() {
    return RootOperationsExecutorUtil_instance;
  }
  function SafeBuildRootOperation(root, filter) {
    filter = filter === VOID ? null : filter;
    BuildRootOperation.call(this, filter);
    this.m47_1 = Entities_getInstance().b3e(root);
  }
  protoOf(SafeBuildRootOperation).t42 = function () {
    return Entities_getInstance().b3e(this.m47_1);
  };
  protoOf(SafeBuildRootOperation).j46 = function () {
    return this.m47_1;
  };
  function UnsafeBuildRootOperation(root) {
    BuildRootOperation.call(this);
    this.p47_1 = root;
  }
  protoOf(UnsafeBuildRootOperation).t42 = function () {
    return this.p47_1;
  };
  protoOf(UnsafeBuildRootOperation).j46 = function () {
    return this.p47_1;
  };
  function entityDiff($this) {
    var contentDiff = ArrayList_init_$Create$();
    contentDiff.q(propertiesDiff($this));
    contentDiff.q(blobsDiff($this));
    contentDiff.q(childrenDiff($this));
    contentDiff.q(referencesDiff($this));
    return Companion_instance_68.b40(contentDiff);
  }
  function propertiesDiff($this) {
    var diff = ArrayList_init_$Create$();
    var _iterator__ex2g4s = $this.q47_1.c3e().m();
    while (_iterator__ex2g4s.n()) {
      var propertyId = _iterator__ex2g4s.o();
      diff.j(propertyDiff($this, propertyId));
    }
    var _iterator__ex2g4s_0 = $this.r47_1.c3e().m();
    while (_iterator__ex2g4s_0.n()) {
      var propertyId_0 = _iterator__ex2g4s_0.o();
      if (!$this.q47_1.c3e().t(propertyId_0)) {
        diff.j(new SetPropertyOperation(propertyId_0, new SetValueOperation(null, $this.r47_1.d3e(propertyId_0))));
      }
    }
    return diff;
  }
  function propertyDiff($this, propertyId) {
    var srcValue = $this.q47_1.d3e(propertyId);
    var trgValue = $this.r47_1.d3e(propertyId);
    var tmp;
    if (srcValue == trgValue) {
      tmp = new NopOperation();
    } else {
      tmp = new SetPropertyOperation(propertyId, new SetValueOperation(srcValue, trgValue));
    }
    return tmp;
  }
  function blobsDiff($this) {
    var diff = ArrayList_init_$Create$();
    var _iterator__ex2g4s = $this.q47_1.h3e().m();
    while (_iterator__ex2g4s.n()) {
      var blobId = _iterator__ex2g4s.o();
      diff.j(blobDiff($this, blobId));
    }
    var _iterator__ex2g4s_0 = $this.r47_1.h3e().m();
    while (_iterator__ex2g4s_0.n()) {
      var blobId_0 = _iterator__ex2g4s_0.o();
      if (!$this.q47_1.h3e().t(blobId_0)) {
        var modelAssemblyOperation = createModelAssemblyOperation($this, blobId_0, ensureNotNull($this.r47_1.i3e(blobId_0)));
        diff.j(modelAssemblyOperation);
      }
    }
    return diff;
  }
  function blobDiff($this, blobId) {
    var trgModel = $this.r47_1.i3e(blobId);
    var srcModel = $this.q47_1.i3e(blobId);
    if (trgModel == null) {
      return createModelAssemblyOperation($this, blobId, ensureNotNull(srcModel)).q3z();
    }
    var tmp;
    if (NodeUtil_instance.d3w(ensureNotNull(srcModel).k3e_1, trgModel.k3e_1)) {
      var op = NodeDiff_instance.t47(srcModel, trgModel);
      tmp = new ChangeModelBlobOperation(blobId, op);
    } else {
      tmp = Companion_instance_68.s47([createModelAssemblyOperation($this, blobId, srcModel).q3z(), createModelAssemblyOperation($this, blobId, trgModel)]);
    }
    return tmp;
  }
  function createModelAssemblyOperation($this, blobId, model) {
    return Companion_instance_52.p3z(blobId, model);
  }
  function referencesDiff($this) {
    var diff = ArrayList_init_$Create$();
    var _iterator__ex2g4s = $this.q47_1.f3e().m();
    while (_iterator__ex2g4s.n()) {
      var referenceId = _iterator__ex2g4s.o();
      if ($this.r47_1.f3e().t(referenceId)) {
        diff.q(referenceDiff($this, referenceId));
      } else {
        var _iterator__ex2g4s_0 = $this.q47_1.g3e(referenceId).m();
        while (_iterator__ex2g4s_0.n()) {
          var s = _iterator__ex2g4s_0.o();
          diff.j(new SetReferenceOperation(referenceId, new RemoveFromSetOperation(s, referenceId.f3g())));
        }
      }
    }
    var _iterator__ex2g4s_1 = $this.r47_1.f3e().m();
    while (_iterator__ex2g4s_1.n()) {
      var referenceId_0 = _iterator__ex2g4s_1.o();
      if (!$this.q47_1.f3e().t(referenceId_0)) {
        var _iterator__ex2g4s_2 = $this.r47_1.g3e(referenceId_0).m();
        while (_iterator__ex2g4s_2.n()) {
          var t = _iterator__ex2g4s_2.o();
          diff.j(new SetReferenceOperation(referenceId_0, new AddToSetOperation(t, referenceId_0.f3g())));
        }
      }
    }
    return diff;
  }
  function referenceDiff($this, referenceId) {
    var srcRefs = $this.q47_1.g3e(referenceId);
    var trgRefs = $this.r47_1.g3e(referenceId);
    var diff = ArrayList_init_$Create$();
    if (srcRefs.s() && trgRefs.s()) {
      return diff;
    }
    var _iterator__ex2g4s = srcRefs.m();
    while (_iterator__ex2g4s.n()) {
      var s = _iterator__ex2g4s.o();
      if (!trgRefs.t(s)) {
        diff.j(new SetReferenceOperation(referenceId, new RemoveFromSetOperation(s, referenceId.f3g())));
      }
    }
    var _iterator__ex2g4s_0 = trgRefs.m();
    while (_iterator__ex2g4s_0.n()) {
      var t = _iterator__ex2g4s_0.o();
      if (!srcRefs.t(t)) {
        diff.j(new SetReferenceOperation(referenceId, new AddToSetOperation(t, referenceId.f3g())));
      }
    }
    return diff;
  }
  function childrenDiff($this) {
    var diff = ArrayList_init_$Create$();
    var _iterator__ex2g4s = $this.q47_1.z3d().m();
    while (_iterator__ex2g4s.n()) {
      var childId = _iterator__ex2g4s.o();
      if ($this.r47_1.z3d().t(childId)) {
        diff.q(childDiff($this, childId));
      } else {
        var _iterator__ex2g4s_0 = $this.q47_1.a3e(childId).m();
        while (_iterator__ex2g4s_0.n()) {
          var s = _iterator__ex2g4s_0.o();
          diff.j(OperationBuilder_instance.n3z(s, childId));
        }
      }
    }
    var _iterator__ex2g4s_1 = $this.r47_1.z3d().m();
    while (_iterator__ex2g4s_1.n()) {
      var childId_0 = _iterator__ex2g4s_1.o();
      if (!$this.q47_1.z3d().t(childId_0)) {
        var _iterator__ex2g4s_2 = $this.r47_1.a3e(childId_0).m();
        while (_iterator__ex2g4s_2.n()) {
          var t = _iterator__ex2g4s_2.o();
          diff.j(OperationBuilder_instance.l3z(t, childId_0));
        }
      }
    }
    return diff;
  }
  function childDiff($this, childId) {
    var srcChildren = $this.q47_1.a3e(childId);
    var trgChildren = $this.r47_1.a3e(childId);
    var diff = ArrayList_init_$Create$();
    if (srcChildren.s() && trgChildren.s()) {
      return diff;
    }
    var _iterator__ex2g4s = srcChildren.m();
    while (_iterator__ex2g4s.n()) {
      var s = _iterator__ex2g4s.o();
      var t = trgChildren.a3h(s.n3d_1);
      if (!(t == null)) {
        if (t.m3d_1.equals(s.m3d_1)) {
          var entityDiffBuilder = new EntityDiffBuilder(s, t);
          var d = entityDiff(entityDiffBuilder);
          if (!d.r3x()) {
            var changeChildOperation = new ChangeChildOperation(s.n3d_1, d);
            diff.j(new ChildSetOperation(childId, changeChildOperation));
          }
        } else {
          diff.j(OperationBuilder_instance.n3z(s, childId));
          diff.j(OperationBuilder_instance.l3z(t, childId));
        }
      } else {
        diff.j(OperationBuilder_instance.n3z(s, childId));
      }
    }
    var _iterator__ex2g4s_0 = trgChildren.m();
    while (_iterator__ex2g4s_0.n()) {
      var t_0 = _iterator__ex2g4s_0.o();
      if (srcChildren.a3h(t_0.n3d_1) == null) {
        diff.j(OperationBuilder_instance.l3z(t_0, childId));
      }
    }
    return diff;
  }
  function EntityDiffBuilder(source, target) {
    this.q47_1 = source;
    this.r47_1 = target;
    // Inline function 'kotlin.check' call
    if (!this.q47_1.m3d_1.equals(this.r47_1.m3d_1)) {
      var message = MessageBundle_instance.e3n(this.q47_1.m3d_1, this.r47_1.m3d_1);
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    // Inline function 'kotlin.check' call
    if (!this.q47_1.n3d_1.equals(this.r47_1.n3d_1)) {
      var message_0 = MessageBundle_instance.h3n(this.q47_1.n3d_1, this.r47_1.n3d_1);
      throw IllegalStateException_init_$Create$_0(toString_1(message_0));
    }
  }
  protoOf(EntityDiffBuilder).u47 = function () {
    return new ChangeRootEntityOperation(this.q47_1.n3d_1, entityDiff(this));
  };
  function EntityMessages() {
  }
  protoOf(EntityMessages).x44 = function (entityId) {
    return "No entity with id='" + entityId.toString() + "'";
  };
  var EntityMessages_instance;
  function EntityMessages_getInstance() {
    return EntityMessages_instance;
  }
  function AddModelBlobOperation_init_$Init$(modelBlobId, conceptId, nodeId, $this) {
    ModelBlobOperation_init_$Init$(modelBlobId, conceptId, nodeId, $this);
    AddModelBlobOperation.call($this);
    return $this;
  }
  function AddModelBlobOperation_init_$Create$(modelBlobId, conceptId, nodeId) {
    return AddModelBlobOperation_init_$Init$(modelBlobId, conceptId, nodeId, objectCreate(protoOf(AddModelBlobOperation)));
  }
  function AddModelBlobOperation_init_$Init$_0(data, $this) {
    ModelBlobOperation.call($this, data);
    AddModelBlobOperation.call($this);
    return $this;
  }
  function AddModelBlobOperation_init_$Create$_0(data) {
    return AddModelBlobOperation_init_$Init$_0(data, objectCreate(protoOf(AddModelBlobOperation)));
  }
  protoOf(AddModelBlobOperation).y2 = function () {
    return 'addModel';
  };
  protoOf(AddModelBlobOperation).x47 = function (otherOp, server) {
    if (otherOp instanceof AddModelBlobOperation) {
      if (otherOp.y47().equals(this.y47())) {
        var rootId = otherOp.m3w();
        var tmp;
        if (otherOp.q42().equals(this.q42()) && !(rootId == null) && equals(rootId, this.m3w())) {
          tmp = new NopOperation();
        } else {
          var tmp_0;
          if (server) {
            tmp_0 = new NopOperation();
          } else {
            tmp_0 = CompositeOperation_init_$Create$([this.q3z(), otherOp]);
          }
          tmp = tmp_0;
        }
        return tmp;
      }
    }
    return protoOf(ModelBlobOperation).f43.call(this, otherOp, server);
  };
  protoOf(AddModelBlobOperation).f43 = function (otherOp, server) {
    return this.x47(otherOp, server);
  };
  protoOf(AddModelBlobOperation).z47 = function (model, nodeFactory) {
    // Inline function 'kotlin.check' call
    if (!(model.i3e(this.y47()) == null)) {
      var message = "Model blob with id='" + this.y47().toString() + "' is already registered";
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    var root = nodeFactory.d3m(this.q42(), this.m3w());
    var rootModel = new Model(root);
    model.j3e(this.y47(), rootModel);
    return model;
  };
  protoOf(AddModelBlobOperation).y3x = function (model, nodeFactory) {
    return this.z47(model instanceof Entity ? model : THROW_CCE(), nodeFactory);
  };
  protoOf(AddModelBlobOperation).q3z = function () {
    return RemoveModelBlobOperation_init_$Create$_0(this.p42_1);
  };
  protoOf(AddModelBlobOperation).a48 = function (model, ops, nodeFactory) {
    return (new AddModelOperationExecutor(nodeFactory)).o43(model, ops);
  };
  protoOf(AddModelBlobOperation).p43 = function (model, ops, nodeFactory) {
    return this.a48(model instanceof Entity ? model : THROW_CCE(), ops, nodeFactory);
  };
  function AddModelBlobOperation() {
  }
  function AddModelOperationExecutor$installChecker$1(this$0) {
    this.e48_1 = this$0;
    ModelOperationsExecutorChecker.call(this, ensureNotNull(this$0.l43_1).y47(), ensureNotNull(this$0.l43_1).m3w(), this$0.g45());
  }
  protoOf(AddModelOperationExecutor$installChecker$1).e3k = function (event) {
    if (event.i3k_1 == null && !(event.j3k_1 == null)) {
      this.i48(event);
    } else {
      this.e48_1.i3a();
    }
  };
  function AddModelOperationExecutor(nodeFactory) {
    nodeFactory = nodeFactory === VOID ? RawNodeFactory_instance : nodeFactory;
    BaseAddOperationExecutor.call(this, nodeFactory);
    this.n48_1 = EntityId_init_$Create$();
  }
  protoOf(AddModelOperationExecutor).o48 = function (op) {
    return op instanceof AddModelBlobOperation;
  };
  protoOf(AddModelOperationExecutor).p45 = function (op) {
    return this.o48(op);
  };
  protoOf(AddModelOperationExecutor).p48 = function (op) {
    return ModelOperationsExecutorUtil_instance.q48(ensureNotNull(this.l43_1).y47(), op);
  };
  protoOf(AddModelOperationExecutor).s45 = function (op) {
    return this.p48(op);
  };
  protoOf(AddModelOperationExecutor).r48 = function (source) {
    var context = new EntityContext();
    var entity = new Entity(source.m3d_1, this.n48_1);
    context.g3f_1.j(entity);
    return context;
  };
  protoOf(AddModelOperationExecutor).u45 = function (source) {
    return this.r48(source instanceof Entity ? source : THROW_CCE());
  };
  protoOf(AddModelOperationExecutor).v45 = function (tempContainer) {
    return ensureNotNull(ModelOperationsExecutorUtil_instance.s48(tempContainer, this.n48_1));
  };
  protoOf(AddModelOperationExecutor).w45 = function (tempContainer) {
    return this.v45(tempContainer instanceof EntityContext ? tempContainer : THROW_CCE());
  };
  protoOf(AddModelOperationExecutor).t48 = function (source, temp) {
    var blobId = ensureNotNull(this.l43_1).y47();
    var model = temp.i3e(blobId);
    temp.j3e(blobId, null);
    source.j3e(blobId, model);
  };
  protoOf(AddModelOperationExecutor).y45 = function (source, temp) {
    var tmp = source instanceof Entity ? source : THROW_CCE();
    return this.t48(tmp, temp instanceof Entity ? temp : THROW_CCE());
  };
  protoOf(AddModelOperationExecutor).z45 = function (tempContainer) {
    return tempContainer.f3j(new AddModelOperationExecutor$installChecker$1(this));
  };
  protoOf(AddModelOperationExecutor).a46 = function (tempContainer) {
    return this.z45(tempContainer instanceof EntityContext ? tempContainer : THROW_CCE());
  };
  function ChangeModelBlobOperation(role, op) {
    TargetedOperation.call(this, role, op);
  }
  protoOf(ChangeModelBlobOperation).y2 = function () {
    return 'changeBlob';
  };
  protoOf(ChangeModelBlobOperation).x47 = function (otherOp, server) {
    if (otherOp instanceof RemoveModelBlobOperation) {
      if (otherOp.y47().equals(this.l3p())) {
        return CompositeOperation_init_$Create$([this.q3z(), otherOp]);
      }
    }
    return protoOf(TargetedOperation).y43.call(this, otherOp, server);
  };
  protoOf(ChangeModelBlobOperation).f43 = function (otherOp, server) {
    return this.x47(otherOp, server);
  };
  protoOf(ChangeModelBlobOperation).y43 = function (otherOp, server) {
    return this.x47(otherOp, server);
  };
  protoOf(ChangeModelBlobOperation).x48 = function (otherOp, server) {
    if (otherOp instanceof RemoveModelBlobOperation) {
      if (otherOp.y47().equals(this.l3p())) {
        return new NopOperation();
      }
    }
    return protoOf(TargetedOperation).q43.call(this, otherOp, server);
  };
  protoOf(ChangeModelBlobOperation).q43 = function (otherOp, server) {
    return this.x48(otherOp, server);
  };
  protoOf(ChangeModelBlobOperation).y48 = function (op) {
    return new ChangeModelBlobOperation(this.l3p(), op);
  };
  protoOf(ChangeModelBlobOperation).x43 = function (op) {
    return this.y48(op);
  };
  protoOf(ChangeModelBlobOperation).z48 = function (source) {
    return source.i3e(this.l3p());
  };
  protoOf(ChangeModelBlobOperation).b44 = function (source) {
    return this.z48(source instanceof Entity ? source : THROW_CCE());
  };
  protoOf(ChangeModelBlobOperation).a49 = function (model, customExecute, nodeFactory) {
    var tmp0 = model.i3e(this.l3p());
    $l$block: {
      // Inline function 'kotlin.checkNotNull' call
      if (tmp0 == null) {
        var message = ModelBlobMessages_instance.b49(this.l3p());
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      } else {
        break $l$block;
      }
    }
    this.e44(ensureNotNull(this.z48(model)), customExecute, nodeFactory);
    return model;
  };
  protoOf(ChangeModelBlobOperation).c49 = function (model, customExecute, nodeFactory) {
    return this.a49(model instanceof Entity ? model : THROW_CCE(), customExecute, nodeFactory);
  };
  protoOf(ChangeModelBlobOperation).c44 = function (model, customExecute, nodeFactory) {
    return this.a49(model instanceof Entity ? model : THROW_CCE(), customExecute, nodeFactory);
  };
  protoOf(ChangeModelBlobOperation).a48 = function (model, ops, nodeFactory) {
    return (new ChangeModelOperationExecutor(nodeFactory)).o43(model, ops);
  };
  protoOf(ChangeModelBlobOperation).p43 = function (model, ops, nodeFactory) {
    return this.a48(model instanceof Entity ? model : THROW_CCE(), ops, nodeFactory);
  };
  function ChangeModelOperationExecutor$installChecker$1(this$0) {
    this.g49_1 = this$0;
    ModelOperationsExecutorChecker.call(this, ensureNotNull(this$0.l43_1).y47(), ensureNotNull(this$0.l43_1).m3w(), this$0.g45());
  }
  protoOf(ChangeModelOperationExecutor$installChecker$1).e3k = function (event) {
    if (!(event.i3k_1 == null) && event.j3k_1 == null) {
      this.i48(event);
    } else {
      this.g49_1.i3a();
    }
  };
  function ChangeModelOperationExecutor(nodeFactory) {
    nodeFactory = nodeFactory === VOID ? RawNodeFactory_instance : nodeFactory;
    BaseRemoveOperationExecutor.call(this, nodeFactory);
    this.l49_1 = EntityId_init_$Create$();
  }
  protoOf(ChangeModelOperationExecutor).o48 = function (op) {
    return op instanceof RemoveModelBlobOperation;
  };
  protoOf(ChangeModelOperationExecutor).p45 = function (op) {
    return this.o48(op);
  };
  protoOf(ChangeModelOperationExecutor).m49 = function (source) {
    return !(source.i3e(ensureNotNull(this.l43_1).y47()) == null);
  };
  protoOf(ChangeModelOperationExecutor).h46 = function (source) {
    return this.m49(source instanceof Entity ? source : THROW_CCE());
  };
  protoOf(ChangeModelOperationExecutor).n49 = function (op) {
    return ModelOperationsExecutorUtil_instance.q48(ensureNotNull(this.l43_1).y47(), op);
  };
  protoOf(ChangeModelOperationExecutor).i46 = function (op) {
    return this.n49(op);
  };
  protoOf(ChangeModelOperationExecutor).r48 = function (source) {
    var entity = new Entity(source.m3d_1, this.l49_1);
    var model = source.i3e(ensureNotNull(this.l43_1).y47());
    entity.j3e(ensureNotNull(this.l43_1).y47(), ensureNotNull(model).s3e());
    var context = new EntityContext();
    context.g3f_1.j(entity);
    return context;
  };
  protoOf(ChangeModelOperationExecutor).u45 = function (source) {
    return this.r48(source instanceof Entity ? source : THROW_CCE());
  };
  protoOf(ChangeModelOperationExecutor).v45 = function (tempContainer) {
    return ensureNotNull(ModelOperationsExecutorUtil_instance.s48(tempContainer, this.l49_1));
  };
  protoOf(ChangeModelOperationExecutor).w45 = function (tempContainer) {
    return this.v45(tempContainer instanceof EntityContext ? tempContainer : THROW_CCE());
  };
  protoOf(ChangeModelOperationExecutor).t48 = function (source, temp) {
    source.j3e(ensureNotNull(this.l43_1).y47(), null);
  };
  protoOf(ChangeModelOperationExecutor).y45 = function (source, temp) {
    var tmp = source instanceof Entity ? source : THROW_CCE();
    return this.t48(tmp, temp instanceof Entity ? temp : THROW_CCE());
  };
  protoOf(ChangeModelOperationExecutor).z45 = function (tempContainer) {
    return tempContainer.f3j(new ChangeModelOperationExecutor$installChecker$1(this));
  };
  protoOf(ChangeModelOperationExecutor).a46 = function (tempContainer) {
    return this.z45(tempContainer instanceof EntityContext ? tempContainer : THROW_CCE());
  };
  function ModelBlobMessages() {
  }
  protoOf(ModelBlobMessages).b49 = function (blobId) {
    return "No model blob with id='" + blobId.toString() + "'";
  };
  var ModelBlobMessages_instance;
  function ModelBlobMessages_getInstance() {
    return ModelBlobMessages_instance;
  }
  function ModelBlobOperation_init_$Init$(modelBlobId, conceptId, nodeId, $this) {
    ModelBlobOperation.call($this, new ModelBlobOperationData(modelBlobId, conceptId, nodeId));
    return $this;
  }
  function ModelBlobOperation(operationData) {
    BaseOperation.call(this);
    this.p42_1 = operationData;
  }
  protoOf(ModelBlobOperation).y47 = function () {
    return this.p42_1.o49_1;
  };
  protoOf(ModelBlobOperation).q42 = function () {
    return this.p42_1.p49_1;
  };
  protoOf(ModelBlobOperation).m3w = function () {
    return this.p42_1.q49_1;
  };
  protoOf(ModelBlobOperation).y2 = function () {
    return 'modelBlob';
  };
  protoOf(ModelBlobOperation).toString = function () {
    return this.y2() + '[modelId = ' + this.y47() + ';c = ' + this.q42() + ';nodeId = ' + toString_0(this.m3w()) + ']';
  };
  function ModelBlobOperationData(modelBlobId, rootConceptId, rootId) {
    this.o49_1 = modelBlobId;
    this.p49_1 = rootConceptId;
    this.q49_1 = rootId;
  }
  protoOf(ModelBlobOperationData).toString = function () {
    return 'ModelBlobOperationData(modelBlobId=' + this.o49_1.toString() + ', rootConceptId=' + this.p49_1.toString() + ', rootId=' + toString_0(this.q49_1) + ')';
  };
  protoOf(ModelBlobOperationData).hashCode = function () {
    var result = this.o49_1.hashCode();
    result = imul(result, 31) + this.p49_1.hashCode() | 0;
    result = imul(result, 31) + (this.q49_1 == null ? 0 : this.q49_1.hashCode()) | 0;
    return result;
  };
  protoOf(ModelBlobOperationData).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ModelBlobOperationData))
      return false;
    if (!this.o49_1.equals(other.o49_1))
      return false;
    if (!this.p49_1.equals(other.p49_1))
      return false;
    if (!equals(this.q49_1, other.q49_1))
      return false;
    return true;
  };
  function ModelBlobOperationUtil() {
  }
  protoOf(ModelBlobOperationUtil).i44 = function (op) {
    return op instanceof AddModelBlobOperation;
  };
  protoOf(ModelBlobOperationUtil).j44 = function (op) {
    return op instanceof RemoveModelBlobOperation;
  };
  protoOf(ModelBlobOperationUtil).k44 = function (op) {
    return op instanceof ChangeModelBlobOperation;
  };
  protoOf(ModelBlobOperationUtil).r49 = function (op) {
    var tmp;
    if (op instanceof ModelBlobOperation) {
      tmp = op.y47();
    } else {
      if (op instanceof ChangeModelBlobOperation) {
        tmp = op.l3p();
      } else {
        throw IllegalArgumentException_init_$Create$_0('Unknown operation to get role from: ' + PrintOperationUtil_instance.g40(op));
      }
    }
    return tmp;
  };
  protoOf(ModelBlobOperationUtil).m44 = function (op) {
    return this.r49(op);
  };
  protoOf(ModelBlobOperationUtil).s49 = function (op) {
    return (op instanceof ModelBlobOperation ? op : THROW_CCE()).p42_1;
  };
  protoOf(ModelBlobOperationUtil).o44 = function (op) {
    return this.s49(op);
  };
  protoOf(ModelBlobOperationUtil).t49 = function (role, data) {
    return AddModelBlobOperation_init_$Create$_0(data);
  };
  protoOf(ModelBlobOperationUtil).q44 = function (role, data) {
    var tmp = role instanceof EntityModelBlobId ? role : THROW_CCE();
    return this.t49(tmp, data instanceof ModelBlobOperationData ? data : THROW_CCE());
  };
  protoOf(ModelBlobOperationUtil).u49 = function (role, data) {
    return RemoveModelBlobOperation_init_$Create$_0(data);
  };
  protoOf(ModelBlobOperationUtil).s44 = function (role, data) {
    var tmp = role instanceof EntityModelBlobId ? role : THROW_CCE();
    return this.u49(tmp, data instanceof ModelBlobOperationData ? data : THROW_CCE());
  };
  protoOf(ModelBlobOperationUtil).v49 = function (role, innerOp) {
    return new ChangeModelBlobOperation(role, innerOp);
  };
  protoOf(ModelBlobOperationUtil).u44 = function (role, innerOp) {
    return this.v49(role instanceof EntityModelBlobId ? role : THROW_CCE(), innerOp);
  };
  function ModelOperationsExecutorChecker(myAllowedModelId, myAllowedRootId, myCanceller) {
    this.f48_1 = myAllowedModelId;
    this.g48_1 = myAllowedRootId;
    this.h48_1 = myCanceller;
  }
  protoOf(ModelOperationsExecutorChecker).y3j = function (event) {
    this.h48_1();
  };
  protoOf(ModelOperationsExecutorChecker).f3k = function (event) {
    if (!this.f48_1.equals(event.n3k_1)) {
      this.h48_1();
      return Unit_instance;
    }
    var rootNode = ensureNotNull(event.o3k_1.g3v_1.g3m_1).k3e_1;
    if (!NodeUtil_instance.c3w(rootNode, this.g48_1)) {
      this.h48_1();
    }
  };
  protoOf(ModelOperationsExecutorChecker).i48 = function (e) {
    if (!this.f48_1.equals(e.h3k_1)) {
      this.h48_1();
    }
  };
  function ModelOperationsExecutorUtil() {
  }
  protoOf(ModelOperationsExecutorUtil).q48 = function (expectedId, op) {
    var tmp;
    if (op instanceof ChangeModelBlobOperation) {
      tmp = expectedId.equals(op.l3p());
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(ModelOperationsExecutorUtil).s48 = function (container, entityId) {
    return container.g3f_1.a3h(entityId);
  };
  var ModelOperationsExecutorUtil_instance;
  function ModelOperationsExecutorUtil_getInstance() {
    return ModelOperationsExecutorUtil_instance;
  }
  function RemoveModelBlobOperation_init_$Init$(modelBlobId, conceptId, nodeId, $this) {
    ModelBlobOperation_init_$Init$(modelBlobId, conceptId, nodeId, $this);
    RemoveModelBlobOperation.call($this);
    return $this;
  }
  function RemoveModelBlobOperation_init_$Create$(modelBlobId, conceptId, nodeId) {
    return RemoveModelBlobOperation_init_$Init$(modelBlobId, conceptId, nodeId, objectCreate(protoOf(RemoveModelBlobOperation)));
  }
  function RemoveModelBlobOperation_init_$Init$_0(data, $this) {
    ModelBlobOperation.call($this, data);
    RemoveModelBlobOperation.call($this);
    return $this;
  }
  function RemoveModelBlobOperation_init_$Create$_0(data) {
    return RemoveModelBlobOperation_init_$Init$_0(data, objectCreate(protoOf(RemoveModelBlobOperation)));
  }
  protoOf(RemoveModelBlobOperation).y2 = function () {
    return 'removeModel';
  };
  protoOf(RemoveModelBlobOperation).x47 = function (otherOp, server) {
    if (otherOp instanceof RemoveModelBlobOperation) {
      if (otherOp.y47().equals(this.y47())) {
        return new NopOperation();
      }
    }
    return protoOf(ModelBlobOperation).f43.call(this, otherOp, server);
  };
  protoOf(RemoveModelBlobOperation).f43 = function (otherOp, server) {
    return this.x47(otherOp, server);
  };
  protoOf(RemoveModelBlobOperation).z47 = function (model, nodeFactory) {
    var tmp0 = model.i3e(this.y47());
    $l$block: {
      // Inline function 'kotlin.checkNotNull' call
      if (tmp0 == null) {
        var message = ModelBlobMessages_instance.b49(this.y47());
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      } else {
        break $l$block;
      }
    }
    var root = ensureNotNull(model.i3e(this.y47())).k3e_1;
    // Inline function 'kotlin.check' call
    if (!this.q42().equals(root.e3m_1)) {
      var message_0 = MessageBundle_instance.e3n(this.q42(), root.e3m_1);
      throw IllegalStateException_init_$Create$_0(toString_1(message_0));
    }
    // Inline function 'kotlin.check' call
    if (!NodeUtil_instance.c3w(root, this.m3w())) {
      var message_1 = MessageBundle_instance.h3n(root.z3n(), ensureNotNull(this.m3w()));
      throw IllegalStateException_init_$Create$_0(toString_1(message_1));
    }
    // Inline function 'kotlin.check' call
    if (!root.w2m()) {
      var message_2 = MessageBundle_instance.g3n(this.y47());
      throw IllegalStateException_init_$Create$_0(toString_1(message_2));
    }
    model.j3e(this.y47(), null);
    return model;
  };
  protoOf(RemoveModelBlobOperation).y3x = function (model, nodeFactory) {
    return this.z47(model instanceof Entity ? model : THROW_CCE(), nodeFactory);
  };
  protoOf(RemoveModelBlobOperation).q3z = function () {
    return AddModelBlobOperation_init_$Create$_0(this.p42_1);
  };
  function RemoveModelBlobOperation() {
  }
  function removeFromTargeted($this, targeted, item) {
    var role = targeted.l3p();
    if (equals(role, item.y49_1)) {
      if (!item.n()) {
        return null;
      }
      var result = $this.z49(targeted.s3z(), ensureNotNull(item.h12()));
      return result == null ? null : targeted.x43(result);
    }
    return targeted;
  }
  function DestroyOperationTransformer() {
  }
  protoOf(DestroyOperationTransformer).a4a = function (to, what, diff) {
    return CompositeOperation_init_$Create$([diff.d4a(what), to]);
  };
  protoOf(DestroyOperationTransformer).z49 = function (from, item) {
    if (from instanceof CompositeOperation) {
      var ops = ArrayList_init_$Create$();
      var _iterator__ex2g4s = (from instanceof CompositeOperation ? from : THROW_CCE()).j3w().m();
      while (_iterator__ex2g4s.n()) {
        var op = _iterator__ex2g4s.o();
        var disassemblyOp = this.z49(op, item);
        if (!(disassemblyOp == null)) {
          ops.j(disassemblyOp);
        }
      }
      return ops.s() ? null : Companion_instance_68.b40(ops);
    }
    if (from instanceof TargetedOperation) {
      return removeFromTargeted(this, from instanceof TargetedOperation ? from : THROW_CCE(), item);
    }
    var tmp;
    var tmp_0;
    if (from instanceof RemoveChildOperation) {
      tmp_0 = (from instanceof RemoveChildOperation ? from : THROW_CCE()).p3w().equals(item.h4a(0));
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = null;
    } else {
      tmp = from;
    }
    return tmp;
  };
  var DestroyOperationTransformer_instance;
  function DestroyOperationTransformer_getInstance() {
    return DestroyOperationTransformer_instance;
  }
  function EntityPathItem(item, next) {
    PathItem.call(this, item);
    this.j4a_1 = next;
  }
  protoOf(EntityPathItem).k4a = function (newValue) {
    var tmp = this;
    tmp.j4a_1 = (newValue == null ? true : newValue instanceof RolePathItem) ? newValue : THROW_CCE();
  };
  protoOf(EntityPathItem).l4a = function (_set____db54di) {
    return this.k4a(_set____db54di);
  };
  protoOf(EntityPathItem).h12 = function () {
    return this.j4a_1;
  };
  protoOf(EntityPathItem).m4a = function () {
    return new EntityPathItem(this.y49_1, this.n() ? ensureNotNull(this.j4a_1).m4a() : null);
  };
  protoOf(EntityPathItem).d4a = function (op) {
    var tmp;
    if (op.r3x()) {
      tmp = new NopOperation();
    } else {
      var tmp_0;
      if (this.n()) {
        tmp_0 = ensureNotNull(this.h12()).d4a(op);
      } else {
        tmp_0 = isInterface(op, Operation) ? op : THROW_CCE();
      }
      var operation = tmp_0;
      tmp = new ChangeChildOperation(this.y49_1, operation);
    }
    return tmp;
  };
  function _get_pathToOldParent__me5jxc($this) {
    return $this.r4a_1.m4a().z4a();
  }
  function checkRole($this, op) {
    if (!(op instanceof NopOperation)) {
      if (op instanceof ChildSetOperation) {
        var role = op.l3p();
        if (!role.equals($this.v4a_1)) {
          throw OtException_init_$Create$_0("Transformed destroy operation doesn't change the desired subtree: " + ("role='" + $this.v4a_1.toString() + "', SetChild role='" + role.toString() + "'"));
        }
      } else {
        if (op instanceof CompositeOperation) {
          var _iterator__ex2g4s = op.j3w().m();
          while (_iterator__ex2g4s.n()) {
            var o = _iterator__ex2g4s.o();
            checkRole($this, o);
          }
        } else {
          throw OtException_init_$Create$_0("Transformed destroy operation doesn't change the desired subtree");
        }
      }
    }
  }
  function checkContainsAddRmMoving($this, op) {
    if (containsRemoveMovingOperation($this, op) && containsAddMovingOperation($this, op)) {
      throw OtException_init_$Create$_0('Multiple add/remove of moving entity may be transformed in wrong way');
    }
  }
  function to2From($this) {
    var from = $this.s4a_1.m4a();
    from.o4a(new RolePathItem($this.v4a_1, new EntityPathItem($this.u4a_1, null)));
    return from;
  }
  function containsRemoveMovingOperation($this, operation) {
    return (new MoveOperation$containsRemoveMovingOperation$1($this)).y42(operation);
  }
  function containsRemoveNewParentOperation($this, operation) {
    return (new MoveOperation$containsRemoveNewParentOperation$1($this)).y42(operation);
  }
  function containsAddMovingOperation($this, operation) {
    return (new MoveOperation$containsAddMovingOperation$1($this)).y42(operation);
  }
  function Companion_54() {
  }
  protoOf(Companion_54).o3z = function (moved, oldParent) {
    var to = Companion_instance_56.a4b(moved);
    to.z4a();
    var from = Companion_instance_56.a4b(ensureNotNull(oldParent));
    from.b4b(ensureNotNull(moved.p3d_1), moved.n3d_1);
    return new MoveOperation(from, to, OperationBuilder_instance.n3z(moved, ensureNotNull(moved.p3d_1)));
  };
  var Companion_instance_54;
  function Companion_getInstance_54() {
    return Companion_instance_54;
  }
  function MoveOperation$containsRemoveMovingOperation$1(this$0) {
    this.c4b_1 = this$0;
    OperationCondition.call(this);
  }
  protoOf(MoveOperation$containsRemoveMovingOperation$1).q40 = function (op) {
    var tmp;
    if (op instanceof RemoveChildOperation) {
      tmp = op.p3w().equals(this.c4b_1.u4a_1);
    } else {
      tmp = false;
    }
    return tmp;
  };
  function MoveOperation$containsRemoveNewParentOperation$1(this$0) {
    this.d4b_1 = this$0;
    OperationCondition.call(this);
  }
  protoOf(MoveOperation$containsRemoveNewParentOperation$1).q40 = function (op) {
    var tmp;
    if (op instanceof RemoveChildOperation) {
      tmp = op.p3w().equals(this.d4b_1.w4a_1);
    } else {
      tmp = false;
    }
    return tmp;
  };
  function MoveOperation$containsAddMovingOperation$1(this$0) {
    this.e4b_1 = this$0;
    OperationCondition.call(this);
  }
  protoOf(MoveOperation$containsAddMovingOperation$1).q40 = function (op) {
    var tmp;
    if (op instanceof AddChildOperation) {
      tmp = op.p3w().equals(this.e4b_1.u4a_1);
    } else {
      tmp = false;
    }
    return tmp;
  };
  function MoveOperation(_from, _to, destroyOperation) {
    BaseOperation.call(this);
    this.r4a_1 = _from;
    this.s4a_1 = _to;
    this.t4a_1 = destroyOperation;
    // Inline function 'kotlin.check' call
    if (!this.r4a_1.y49_1.equals(this.s4a_1.y49_1)) {
      var message = 'Move between different roots: ' + this.r4a_1.y49_1.toString() + ', ' + this.s4a_1.y49_1.toString();
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    var tmp = this;
    var tmp_0 = this.s4a_1.h4a(0);
    tmp.w4a_1 = tmp_0 instanceof EntityId ? tmp_0 : THROW_CCE();
    var tmp_1 = this;
    var tmp_2 = this.r4a_1.h4a(1);
    tmp_1.v4a_1 = tmp_2 instanceof EntityChildId ? tmp_2 : THROW_CCE();
    var tmp_3 = this;
    var tmp_4 = this.r4a_1.h4a(0);
    tmp_3.u4a_1 = tmp_4 instanceof EntityId ? tmp_4 : THROW_CCE();
  }
  protoOf(MoveOperation).f4b = function () {
    return this.r4a_1.m4a();
  };
  protoOf(MoveOperation).g4b = function () {
    return this.s4a_1.m4a();
  };
  protoOf(MoveOperation).m3w = function () {
    return this.r4a_1.y49_1;
  };
  protoOf(MoveOperation).a45 = function (otherOp, server) {
    if (otherOp instanceof MoveOperation) {
      if (otherOp.r4a_1.equals(this.r4a_1)) {
        var tmp;
        if (otherOp.s4a_1.equals(this.s4a_1)) {
          tmp = new NopOperation();
        } else {
          tmp = server ? new NopOperation() : new MoveOperation(to2From(this), otherOp.s4a_1.m4a(), this.t4a_1);
        }
        return tmp;
      }
      if (otherOp.r4a_1.i4b(this.r4a_1)) {
        var from = PathItemUtil_instance.h4b(otherOp.r4a_1, this.r4a_1, this.s4a_1);
        var tmp_0;
        if (otherOp.s4a_1.i4b(this.r4a_1)) {
          tmp_0 = PathItemUtil_instance.h4b(otherOp.s4a_1, this.r4a_1, this.s4a_1);
        } else {
          tmp_0 = otherOp.s4a_1.m4a();
        }
        var to = tmp_0;
        return new MoveOperation(from, to, otherOp.t4a_1);
      }
      if (this.r4a_1.i4b(otherOp.r4a_1)) {
        var destroy = DestroyOperationTransformer_instance.z49(otherOp.t4a_1, PathItemUtil_instance.j4b(this.r4a_1, otherOp.r4a_1));
        if (this.s4a_1.i4b(otherOp.r4a_1)) {
          destroy = DestroyOperationTransformer_instance.a4a(ensureNotNull(destroy), this.t4a_1, PathItemUtil_instance.j4b(this.s4a_1, otherOp.r4a_1));
        }
        return new MoveOperation(otherOp.r4a_1.m4a(), otherOp.s4a_1.m4a(), ensureNotNull(destroy));
      }
      if (this.s4a_1.i4b(otherOp.r4a_1)) {
        var tmp_1;
        if (otherOp.s4a_1.i4b(this.r4a_1)) {
          tmp_1 = server ? new NopOperation() : CompositeOperation_init_$Create$([this.q3z(), otherOp]);
        } else {
          tmp_1 = new MoveOperation(otherOp.r4a_1.m4a(), otherOp.s4a_1.m4a(), DestroyOperationTransformer_instance.a4a(otherOp.t4a_1, this.t4a_1, PathItemUtil_instance.j4b(this.s4a_1, otherOp.r4a_1)));
        }
        return tmp_1;
      }
      var tmp_2;
      if (otherOp.s4a_1.i4b(this.r4a_1)) {
        tmp_2 = new MoveOperation(otherOp.r4a_1.m4a(), PathItemUtil_instance.h4b(otherOp.s4a_1, this.r4a_1, this.s4a_1), otherOp.t4a_1);
      } else {
        tmp_2 = otherOp;
      }
      return tmp_2;
    }
    if (otherOp instanceof ChangeRootEntityOperation) {
      checkContainsAddRmMoving(this, otherOp);
      if (containsRemoveNewParentOperation(this, otherOp)) {
        var otherWithoutOpsInMovingSubtree = DestroyOperationTransformer_instance.z49(otherOp, this.r4a_1);
        return CompositeOperation_init_$Create$([this.s4a_1.d4a(this.t4a_1), ensureNotNull(otherWithoutOpsInMovingSubtree)]);
      }
      return (new RootOperationTransformer(this.r4a_1, this.s4a_1)).o4b(otherOp);
    }
    return protoOf(BaseOperation).f43.call(this, otherOp, server);
  };
  protoOf(MoveOperation).f43 = function (otherOp, server) {
    return this.a45(otherOp, server);
  };
  protoOf(MoveOperation).k46 = function (otherOp, server) {
    if (otherOp instanceof ChangeRootEntityOperation) {
      checkContainsAddRmMoving(this, otherOp);
      if (containsRemoveMovingOperation(this, otherOp)) {
        return new NopOperation();
      }
      var tmp = otherOp.z3x(_get_pathToOldParent__me5jxc(this).d4a(this.t4a_1), !server);
      var op = tmp instanceof ChangeRootEntityOperation ? tmp : THROW_CCE();
      var destroy = _get_pathToOldParent__me5jxc(this).p4b(op);
      checkRole(this, destroy);
      var tmp_0;
      if (containsRemoveNewParentOperation(this, otherOp)) {
        tmp_0 = op;
      } else {
        tmp_0 = new MoveOperation(this.r4a_1.m4a(), this.s4a_1.m4a(), destroy);
      }
      return tmp_0;
    }
    return protoOf(BaseOperation).q43.call(this, otherOp, server);
  };
  protoOf(MoveOperation).q43 = function (otherOp, server) {
    return this.k46(otherOp, server);
  };
  protoOf(MoveOperation).b45 = function (model, nodeFactory) {
    var tmp0_elvis_lhs = model.a3j().a3h(this.u4a_1);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalStateException_init_$Create$_0('Moving: ' + EntityMessages_instance.x44(this.u4a_1));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var moving = tmp;
    // Inline function 'kotlin.check' call
    if (!this.v4a_1.equals(moving.p3d_1)) {
      var message = MessageBundle_instance.f3n(this.v4a_1, ensureNotNull(moving.p3d_1));
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    // Inline function 'kotlin.check' call
    if (!this.r4a_1.h4a(2).equals(ensureNotNull(moving.bp()).n3d_1)) {
      var message_0 = 'Unequal parents: stored=' + this.r4a_1.h4a(2).q36_1 + ', actual=' + ensureNotNull(moving.bp()).n3d_1.toString();
      throw IllegalStateException_init_$Create$_0(toString_1(message_0));
    }
    var tmp1_elvis_lhs = model.a3j().a3h(this.w4a_1);
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      throw IllegalStateException_init_$Create$_0('New parent: ' + EntityMessages_instance.x44(this.w4a_1));
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    var newParent = tmp_0;
    // Inline function 'kotlin.check' call
    if (!this.r4a_1.equals(Companion_instance_56.a4b(moving))) {
      var message_1 = 'Source paths are unequal';
      throw IllegalStateException_init_$Create$_0(toString_1(message_1));
    }
    // Inline function 'kotlin.check' call
    if (!this.s4a_1.equals(Companion_instance_56.a4b(newParent))) {
      var message_2 = 'Target paths are unequal';
      throw IllegalStateException_init_$Create$_0(toString_1(message_2));
    }
    moving.o3h(newParent);
    return model;
  };
  protoOf(MoveOperation).y3x = function (model, nodeFactory) {
    return this.b45(model instanceof EntityContext ? model : THROW_CCE(), nodeFactory);
  };
  protoOf(MoveOperation).q3z = function () {
    return new MoveOperation(to2From(this), _get_pathToOldParent__me5jxc(this), this.t4a_1);
  };
  protoOf(MoveOperation).toString = function () {
    return 'move[' + this.r4a_1.toString() + ' -> ' + this.s4a_1.toString() + ';destroy=' + toString_1(this.t4a_1) + ']';
  };
  function get_4($this, i) {
    if (i === 0) {
      return $this.y49_1;
    }
    // Inline function 'kotlin.check' call
    if (!$this.n()) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    return get_4(ensureNotNull($this.h12()), i - 1 | 0);
  }
  function delegateUnwrap($this, op) {
    var tmp = $this.h12();
    var next = (tmp == null ? true : tmp instanceof PathItem) ? tmp : THROW_CCE();
    return ensureNotNull(next).p4a(op);
  }
  function PathItem(value) {
    this.y49_1 = value;
  }
  protoOf(PathItem).n = function () {
    return !(this.h12() == null);
  };
  protoOf(PathItem).i4b = function (path) {
    var i2 = path;
    var i1 = this;
    while (!(i1 == null) && !(i2 == null)) {
      if (!i1.y49_1.equals(i2.y49_1)) {
        return false;
      }
      i1 = i1.h12();
      i2 = i2.h12();
    }
    return i2 == null;
  };
  protoOf(PathItem).h4a = function (index) {
    return get_4(this, (this.x2g() - index | 0) - 1 | 0);
  };
  protoOf(PathItem).o4a = function (tail) {
    if (!this.n()) {
      this.l4a(tail instanceof PathItem ? tail : THROW_CCE());
      return Unit_instance;
    }
    ensureNotNull(this.h12()).o4a(tail);
  };
  protoOf(PathItem).x2g = function () {
    return 1 + (this.n() ? ensureNotNull(this.h12()).x2g() : 0) | 0;
  };
  protoOf(PathItem).n4a = function (fromIndex) {
    if (fromIndex === 0) {
      return this.m4a();
    }
    if (!this.n()) {
      // Inline function 'kotlin.check' call
      if (!(fromIndex <= 1)) {
        throw IllegalStateException_init_$Create$_0('Check failed.');
      }
      return null;
    }
    return ensureNotNull(this.h12()).n4a(fromIndex - 1 | 0);
  };
  protoOf(PathItem).equals = function (other) {
    if (this === other)
      return true;
    if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    var that = other instanceof PathItem ? other : THROW_CCE();
    if (!equals(this.y49_1, ensureNotNull(that).y49_1))
      return false;
    return !(!(this.h12() == null) ? !equals(this.h12(), that.h12()) : !(that.h12() == null));
  };
  protoOf(PathItem).hashCode = function () {
    var result = this.y49_1.hashCode();
    result = imul(31, result) + (!(this.h12() == null) ? ensureNotNull(this.h12()).hashCode() : 0) | 0;
    return result;
  };
  protoOf(PathItem).p4a = function (op) {
    // Inline function 'kotlin.check' call
    if (!equals(op.l3p(), this.y49_1)) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    var operation = op.s3z();
    var tmp;
    if (operation instanceof NopOperation) {
      tmp = operation;
    } else {
      if (!this.n()) {
        tmp = operation;
      } else {
        tmp = delegateUnwrap(this, operation instanceof TargetedOperation ? operation : THROW_CCE());
      }
    }
    return tmp;
  };
  protoOf(PathItem).toString = function () {
    return this.y49_1.q36_1 + (this.n() ? ensureNotNull(this.h12()).toString() : '');
  };
  function PathItemUtil() {
  }
  protoOf(PathItemUtil).j4b = function (longer, shorter) {
    // Inline function 'kotlin.check' call
    if (!longer.i4b(shorter)) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    var tmp = longer.n4a(shorter.x2g() - 2 | 0);
    return tmp instanceof RolePathItem ? tmp : THROW_CCE();
  };
  protoOf(PathItemUtil).h4b = function (path, oldPrefix, newPrefix) {
    var changed = newPrefix.m4a();
    var copy = path.n4a(oldPrefix.x2g() - 2 | 0);
    if (!(copy == null)) {
      changed.o4a(copy);
    }
    return changed;
  };
  var PathItemUtil_instance;
  function PathItemUtil_getInstance() {
    return PathItemUtil_instance;
  }
  function Companion_55() {
  }
  protoOf(Companion_55).q4b = function () {
    return '-(';
  };
  protoOf(Companion_55).r4b = function () {
    return ')-';
  };
  var Companion_instance_55;
  function Companion_getInstance_55() {
    return Companion_instance_55;
  }
  function RolePathItem(item, next) {
    PathItem.call(this, item);
    this.c4a_1 = null;
    this.c4a_1 = next;
  }
  protoOf(RolePathItem).s4b = function (newValue) {
    var tmp = this;
    tmp.c4a_1 = (newValue == null ? true : newValue instanceof EntityPathItem) ? newValue : THROW_CCE();
  };
  protoOf(RolePathItem).l4a = function (_set____db54di) {
    return this.s4b(_set____db54di);
  };
  protoOf(RolePathItem).h12 = function () {
    return this.c4a_1;
  };
  protoOf(RolePathItem).toString = function () {
    return Companion_instance_55.q4b() + this.y49_1.q36_1 + Companion_instance_55.r4b() + (this.n() ? ensureNotNull(this.h12()).toString() : '');
  };
  protoOf(RolePathItem).d4a = function (op) {
    if (op.r3x()) {
      return new NopOperation();
    }
    // Inline function 'kotlin.check' call
    if (!this.n()) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    return new ChildSetOperation(this.y49_1, ensureNotNull(this.c4a_1).d4a(op));
  };
  protoOf(RolePathItem).m4a = function () {
    return new RolePathItem(this.y49_1, this.n() ? ensureNotNull(this.c4a_1).m4a() : null);
  };
  function doTransform($this, item, otherOp, result) {
    if (isDirectOperationOnSubtree($this, otherOp)) {
      result.j(newOrderedOp($this, otherOp, true));
    } else {
      if (otherOp instanceof TargetedOperation) {
        onTargetedOperation($this, item, otherOp instanceof TargetedOperation ? otherOp : THROW_CCE(), result);
      } else {
        if (otherOp instanceof CompositeOperation) {
          onCompositeOperation($this, item, otherOp instanceof CompositeOperation ? otherOp : THROW_CCE(), result);
        } else {
          result.j(newOrderedOp($this, otherOp, false));
        }
      }
    }
  }
  function newOrderedOp($this, op, changePath) {
    var _unary__edvuaz = $this.n4b_1;
    $this.n4b_1 = _unary__edvuaz + 1 | 0;
    return new OrderedOperation(op, changePath, _unary__edvuaz);
  }
  function onTargetedOperation($this, item, otherOp, result) {
    if (isOnPath($this, item, otherOp)) {
      if (item.n()) {
        diveInto($this, item, otherOp, result);
      } else {
        result.j(newOrderedOp($this, otherOp, true));
      }
    } else {
      result.j(newOrderedOp($this, otherOp, false));
    }
  }
  function isOnPath($this, item, op) {
    return equals(op.l3p(), item.y49_1);
  }
  function diveInto($this, item, op, result) {
    var tmp = op.s3z();
    var targetOperation = isInterface(tmp, Operation) ? tmp : THROW_CCE();
    doTransform($this, ensureNotNull(item.h12()), targetOperation, result);
    restore($this, op, result);
  }
  function restore($this, wrapperOp, ops) {
    var _iterator__ex2g4s = ops.m();
    while (_iterator__ex2g4s.n()) {
      var op = _iterator__ex2g4s.o();
      if (!op.u4b_1) {
        var tmp = op.t4b_1;
        var operation = isInterface(tmp, Operation) ? tmp : THROW_CCE();
        op.t4b_1 = wrapperOp.x43(operation);
      }
    }
  }
  function onCompositeOperation($this, item, otherOp, result) {
    var _iterator__ex2g4s = otherOp.j3w().m();
    while (_iterator__ex2g4s.n()) {
      var op = _iterator__ex2g4s.o();
      var childOps = ArrayList_init_$Create$();
      doTransform($this, item, op, childOps);
      append($this, result, childOps);
    }
  }
  function append($this, ops, other) {
    var _iterator__ex2g4s = other.m();
    while (_iterator__ex2g4s.n()) {
      var op = _iterator__ex2g4s.o();
      checkOrder($this, ops, op);
      ops.j(op);
    }
  }
  function checkOrder($this, ops, next) {
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!ops.s()) {
      var last_0 = last(ops);
      // Inline function 'kotlin.check' call
      if (!(last_0.w4b_1 === next.v4b_1)) {
        throw IllegalStateException_init_$Create$_0('Check failed.');
      }
    }
  }
  function isDirectOperationOnSubtree($this, op) {
    var tmp;
    if (op instanceof ChildOperation) {
      tmp = op.p3w().equals($this.m4b_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
  function OrderedOperation(operation, toChangePath, start) {
    this.t4b_1 = operation;
    this.u4b_1 = toChangePath;
    this.v4b_1 = start;
    this.w4b_1 = this.v4b_1 + 1 | 0;
  }
  function RootOperationTransformer(from, to) {
    this.k4b_1 = from;
    this.l4b_1 = to;
    var tmp = this;
    var tmp_0 = this.k4b_1.h4a(0);
    tmp.m4b_1 = tmp_0 instanceof EntityId ? tmp_0 : THROW_CCE();
    this.n4b_1 = 0;
  }
  protoOf(RootOperationTransformer).o4b = function (otherOp) {
    var result = ArrayList_init_$Create$();
    doTransform(this, this.k4b_1, otherOp, result);
    var tmp;
    if (result.s()) {
      tmp = new NopOperation();
    } else {
      var tmp_0 = this.k4b_1.h4a(1);
      var role = tmp_0 instanceof EntityChildId ? tmp_0 : THROW_CCE();
      var ops = ArrayList_init_$Create$();
      var _iterator__ex2g4s = result.m();
      while (_iterator__ex2g4s.n()) {
        var op = _iterator__ex2g4s.o();
        var operation = op.t4b_1;
        var tmp_1;
        if (op.u4b_1) {
          var entitySetOperation = isInterface(operation, Operation) ? operation : THROW_CCE();
          tmp_1 = this.l4b_1.d4a(new ChildSetOperation(role, entitySetOperation));
        } else {
          tmp_1 = isInterface(operation, Operation) ? operation : THROW_CCE();
        }
        var opToAdd = tmp_1;
        ops.j(opToAdd);
      }
      tmp = Companion_instance_68.b40(ops);
    }
    return tmp;
  };
  function create($this, entity, lower) {
    var $this_0 = $this;
    var entity_0 = entity;
    var lower_0 = lower;
    $l$1: do {
      $l$0: do {
        var parent = entity_0.bp();
        var tmp;
        if (parent == null) {
          tmp = new RootPathItem(entity_0.n3d_1, lower_0);
        } else {
          var tmp0 = $this_0;
          var tmp2 = new RolePathItem(ensureNotNull(entity_0.p3d_1), new EntityPathItem(entity_0.n3d_1, lower_0));
          $this_0 = tmp0;
          entity_0 = parent;
          lower_0 = tmp2;
          continue $l$0;
        }
        return tmp;
      }
       while (false);
    }
     while (true);
  }
  function removeLastEntityNode($this, pathItem) {
    if (ensureNotNull(ensureNotNull(pathItem.h12()).h12()).n()) {
      removeLastEntityNode($this, ensureNotNull(ensureNotNull(pathItem.j4a_1).c4a_1));
    } else {
      pathItem.k4a(null);
    }
  }
  function appendEntityNode($this, pathItem, toAppend) {
    if (pathItem.n() && ensureNotNull(pathItem.h12()).n()) {
      appendEntityNode($this, ensureNotNull(ensureNotNull(pathItem.j4a_1).c4a_1), toAppend);
    } else {
      pathItem.k4a(toAppend);
    }
  }
  function Companion_56() {
  }
  protoOf(Companion_56).a4b = function (entity) {
    return create(this, entity, null);
  };
  var Companion_instance_56;
  function Companion_getInstance_56() {
    return Companion_instance_56;
  }
  function RootPathItem(item, next) {
    PathItem.call(this, item);
    this.y4a_1 = next;
  }
  protoOf(RootPathItem).k4a = function (newValue) {
    var tmp = this;
    tmp.y4a_1 = (newValue == null ? true : newValue instanceof RolePathItem) ? newValue : THROW_CCE();
  };
  protoOf(RootPathItem).l4a = function (_set____db54di) {
    return this.k4a(_set____db54di);
  };
  protoOf(RootPathItem).h12 = function () {
    return this.y4a_1;
  };
  protoOf(RootPathItem).m4a = function () {
    return new RootPathItem(this.y49_1, this.n() ? ensureNotNull(this.y4a_1).m4a() : null);
  };
  protoOf(RootPathItem).z4a = function () {
    if (ensureNotNull(ensureNotNull(this.y4a_1).h12()).n()) {
      removeLastEntityNode(this, ensureNotNull(ensureNotNull(this.y4a_1).c4a_1));
    } else {
      this.y4a_1 = null;
    }
    return this;
  };
  protoOf(RootPathItem).b4b = function (role, entityId) {
    var toAppend = new RolePathItem(role, new EntityPathItem(entityId, null));
    if (this.n() && ensureNotNull(this.y4a_1).n()) {
      appendEntityNode(this, ensureNotNull(ensureNotNull(this.y4a_1).c4a_1), toAppend);
    } else {
      this.y4a_1 = toAppend;
    }
    return this;
  };
  protoOf(RootPathItem).d4a = function (op) {
    var tmp;
    if (op.r3x()) {
      tmp = new NopOperation();
    } else {
      var tmp_0;
      if (this.n()) {
        tmp_0 = ensureNotNull(this.y4a_1).d4a(op);
      } else {
        tmp_0 = isInterface(op, Operation) ? op : THROW_CCE();
      }
      var operation = tmp_0;
      tmp = new ChangeRootEntityOperation(this.y49_1, operation);
    }
    return tmp;
  };
  protoOf(RootPathItem).p4b = function (op) {
    var tmp = protoOf(PathItem).p4a.call(this, op);
    return isInterface(tmp, Operation) ? tmp : THROW_CCE();
  };
  protoOf(RootPathItem).p4a = function (op) {
    return this.p4b(op);
  };
  function AddChildOperationExecutor$installChecker$1(this$0) {
    EntityOperationsExecutorChecker.call(this, this$0.b4c_1, ensureNotNull(this$0.l43_1).p3w(), this$0.g45());
  }
  protoOf(AddChildOperationExecutor$installChecker$1).p3j = function (event) {
    this.j4c(event);
  };
  function AddChildOperationExecutor(nodeFactory) {
    nodeFactory = nodeFactory === VOID ? RawNodeFactory_instance : nodeFactory;
    BaseAddOperationExecutor.call(this, nodeFactory);
    this.b4c_1 = EntityId_init_$Create$();
    this.c4c_1 = EntityChildId_init_$Create$(Companion_getInstance_76().g3q_1);
  }
  protoOf(AddChildOperationExecutor).k4c = function (op) {
    return op instanceof AddChildOperation;
  };
  protoOf(AddChildOperationExecutor).p45 = function (op) {
    return this.k4c(op);
  };
  protoOf(AddChildOperationExecutor).l4c = function (op) {
    return EntityOperationsExecutorUtil_instance.m4c(ensureNotNull(this.l43_1).p3w(), op);
  };
  protoOf(AddChildOperationExecutor).s45 = function (op) {
    return this.l4c(op);
  };
  protoOf(AddChildOperationExecutor).n4c = function (source) {
    var context = new EntityContext();
    var root = new Entity(EntityConceptId_init_$Create$(), this.b4c_1);
    context.g3f_1.j(root);
    return context;
  };
  protoOf(AddChildOperationExecutor).u45 = function (source) {
    return this.n4c((!(source == null) ? isInterface(source, EntitySet) : false) ? source : THROW_CCE());
  };
  protoOf(AddChildOperationExecutor).v45 = function (tempContainer) {
    return EntityOperationsExecutorUtil_instance.o4c(tempContainer, this.b4c_1, this.c4c_1);
  };
  protoOf(AddChildOperationExecutor).w45 = function (tempContainer) {
    return this.v45(tempContainer instanceof EntityContext ? tempContainer : THROW_CCE());
  };
  protoOf(AddChildOperationExecutor).p4c = function (source, temp) {
    var entity = temp.a3h(ensureNotNull(this.l43_1).p3w());
    ensureNotNull(entity).m3h();
    source.j(entity);
  };
  protoOf(AddChildOperationExecutor).y45 = function (source, temp) {
    var tmp = (!(source == null) ? isInterface(source, EntitySet) : false) ? source : THROW_CCE();
    return this.p4c(tmp, (!(temp == null) ? isInterface(temp, EntitySet) : false) ? temp : THROW_CCE());
  };
  protoOf(AddChildOperationExecutor).z45 = function (tempContainer) {
    return tempContainer.f3j(new AddChildOperationExecutor$installChecker$1(this));
  };
  protoOf(AddChildOperationExecutor).a46 = function (tempContainer) {
    return this.z45(tempContainer instanceof EntityContext ? tempContainer : THROW_CCE());
  };
  function ChangeChildOperationExecutor$installChecker$1(this$0) {
    EntityOperationsExecutorChecker.call(this, this$0.u4c_1, ensureNotNull(this$0.l43_1).p3w(), this$0.g45());
  }
  protoOf(ChangeChildOperationExecutor$installChecker$1).w3j = function (event) {
    this.j4c(event);
  };
  function ChangeChildOperationExecutor(nodeFactory) {
    nodeFactory = nodeFactory === VOID ? RawNodeFactory_instance : nodeFactory;
    BaseRemoveOperationExecutor.call(this, nodeFactory);
    this.u4c_1 = EntityId_init_$Create$();
    this.v4c_1 = EntityChildId_init_$Create$(Companion_getInstance_76().g3q_1);
  }
  protoOf(ChangeChildOperationExecutor).k4c = function (op) {
    return op instanceof RemoveChildOperation;
  };
  protoOf(ChangeChildOperationExecutor).p45 = function (op) {
    return this.k4c(op);
  };
  protoOf(ChangeChildOperationExecutor).z4c = function (source) {
    return !(source.a3h(ensureNotNull(this.l43_1).p3w()) == null);
  };
  protoOf(ChangeChildOperationExecutor).h46 = function (source) {
    return this.z4c((!(source == null) ? isInterface(source, EntitySet) : false) ? source : THROW_CCE());
  };
  protoOf(ChangeChildOperationExecutor).a4d = function (op) {
    return EntityOperationsExecutorUtil_instance.m4c(ensureNotNull(this.l43_1).p3w(), op);
  };
  protoOf(ChangeChildOperationExecutor).i46 = function (op) {
    return this.a4d(op);
  };
  protoOf(ChangeChildOperationExecutor).n4c = function (source) {
    var context = new EntityContext();
    var root = new Entity(EntityConceptId_init_$Create$(), this.u4c_1);
    context.g3f_1.j(root);
    var entity = source.a3h(ensureNotNull(this.l43_1).p3w());
    root.a3e(this.v4c_1).j(Entities_getInstance().b3e(ensureNotNull(entity)));
    return context;
  };
  protoOf(ChangeChildOperationExecutor).u45 = function (source) {
    return this.n4c((!(source == null) ? isInterface(source, EntitySet) : false) ? source : THROW_CCE());
  };
  protoOf(ChangeChildOperationExecutor).v45 = function (tempContainer) {
    return EntityOperationsExecutorUtil_instance.o4c(tempContainer, this.u4c_1, this.v4c_1);
  };
  protoOf(ChangeChildOperationExecutor).w45 = function (tempContainer) {
    return this.v45(tempContainer instanceof EntityContext ? tempContainer : THROW_CCE());
  };
  protoOf(ChangeChildOperationExecutor).p4c = function (source, temp) {
    var entity = source.a3h(ensureNotNull(this.l43_1).p3w());
    // Inline function 'kotlin.collections.remove' call
    (isInterface(source, MutableCollection) ? source : THROW_CCE()).h2(entity);
  };
  protoOf(ChangeChildOperationExecutor).y45 = function (source, temp) {
    var tmp = (!(source == null) ? isInterface(source, EntitySet) : false) ? source : THROW_CCE();
    return this.p4c(tmp, (!(temp == null) ? isInterface(temp, EntitySet) : false) ? temp : THROW_CCE());
  };
  protoOf(ChangeChildOperationExecutor).z45 = function (tempContainer) {
    return tempContainer.f3j(new ChangeChildOperationExecutor$installChecker$1(this));
  };
  protoOf(ChangeChildOperationExecutor).a46 = function (tempContainer) {
    return this.z45(tempContainer instanceof EntityContext ? tempContainer : THROW_CCE());
  };
  function Companion_57() {
  }
  var Companion_instance_57;
  function Companion_getInstance_57() {
    return Companion_instance_57;
  }
  function ChildSetOperation(role, op) {
    TargetedOperation.call(this, role, op);
  }
  protoOf(ChildSetOperation).e4d = function (op) {
    return new ChildSetOperation(this.l3p(), op);
  };
  protoOf(ChildSetOperation).x43 = function (op) {
    return this.e4d(op);
  };
  protoOf(ChildSetOperation).z48 = function (source) {
    return source.a3e(this.l3p());
  };
  protoOf(ChildSetOperation).b44 = function (source) {
    return this.z48(source instanceof Entity ? source : THROW_CCE());
  };
  protoOf(ChildSetOperation).y2 = function () {
    return 'setChild';
  };
  function handleMainEvent($this, e) {
    if (!$this.h4c_1.equals(e.s3j_1.n3d_1)) {
      $this.i4c_1();
    }
  }
  function EntityOperationsExecutorChecker(myAllowedRootId, myAllowedChildId, myCanceller) {
    this.g4c_1 = myAllowedRootId;
    this.h4c_1 = myAllowedChildId;
    this.i4c_1 = myCanceller;
  }
  protoOf(EntityOperationsExecutorChecker).y3j = function (event) {
    if (!Entities_getInstance().u3e(this.h4c_1, event.y3i_1)) {
      this.i4c_1();
    }
  };
  protoOf(EntityOperationsExecutorChecker).j4c = function (e) {
    if (this.g4c_1.equals(e.y3i_1.n3d_1)) {
      handleMainEvent(this, e);
    } else {
      this.y3j(e);
    }
  };
  function EntityOperationsExecutorUtil() {
  }
  protoOf(EntityOperationsExecutorUtil).m4c = function (expectedId, op) {
    var tmp;
    if (op instanceof ChangeChildOperation) {
      tmp = expectedId.equals(op.l3p());
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(EntityOperationsExecutorUtil).o4c = function (container, roodId, role) {
    return ensureNotNull(container.g3f_1.a3h(roodId)).a3e(role);
  };
  var EntityOperationsExecutorUtil_instance;
  function EntityOperationsExecutorUtil_getInstance() {
    return EntityOperationsExecutorUtil_instance;
  }
  function SetPropertyOperation(role, op) {
    TargetedOperation.call(this, role, op);
  }
  protoOf(SetPropertyOperation).y2 = function () {
    return 'setProperty';
  };
  protoOf(SetPropertyOperation).i4d = function (op) {
    return new SetPropertyOperation(this.l3p(), op);
  };
  protoOf(SetPropertyOperation).x43 = function (op) {
    return this.i4d(op);
  };
  protoOf(SetPropertyOperation).z48 = function (source) {
    return source.d3e(this.l3p());
  };
  protoOf(SetPropertyOperation).b44 = function (source) {
    return this.z48(source instanceof Entity ? source : THROW_CCE());
  };
  protoOf(SetPropertyOperation).a49 = function (model, customExecute, nodeFactory) {
    var oldValue = this.z48(model);
    var newValue = this.s3z().y3x(oldValue, nodeFactory);
    model.e3e(this.l3p(), newValue);
    return model;
  };
  protoOf(SetPropertyOperation).c49 = function (model, customExecute, nodeFactory) {
    return this.a49(model instanceof Entity ? model : THROW_CCE(), customExecute, nodeFactory);
  };
  protoOf(SetPropertyOperation).c44 = function (model, customExecute, nodeFactory) {
    return this.a49(model instanceof Entity ? model : THROW_CCE(), customExecute, nodeFactory);
  };
  function Companion_58() {
  }
  var Companion_instance_58;
  function Companion_getInstance_58() {
    return Companion_instance_58;
  }
  function SetReferenceOperation(role, op) {
    TargetedOperation.call(this, role, op);
  }
  protoOf(SetReferenceOperation).y2 = function () {
    return 'setEntityReference';
  };
  protoOf(SetReferenceOperation).m4d = function (op) {
    return new SetReferenceOperation(this.l3p(), op);
  };
  protoOf(SetReferenceOperation).x43 = function (op) {
    return this.m4d(op);
  };
  protoOf(SetReferenceOperation).z48 = function (source) {
    return source.g3e(this.l3p());
  };
  protoOf(SetReferenceOperation).b44 = function (source) {
    return this.z48(source instanceof Entity ? source : THROW_CCE());
  };
  function BaseAddOperationExecutor(nodeFactory) {
    BaseOperationExecutor.call(this, nodeFactory);
  }
  protoOf(BaseAddOperationExecutor).f46 = function () {
    return 2;
  };
  protoOf(BaseAddOperationExecutor).g46 = function () {
    return MainOpPos_FIRST_getInstance();
  };
  protoOf(BaseAddOperationExecutor).h46 = function (source) {
    return true;
  };
  protoOf(BaseAddOperationExecutor).i46 = function (op) {
    throw IllegalStateException_init_$Create$();
  };
  var MainOpPos_FIRST_instance;
  var MainOpPos_LAST_instance;
  var MainOpPos_ANY_instance;
  var MainOpPos_entriesInitialized;
  function MainOpPos_initEntries() {
    if (MainOpPos_entriesInitialized)
      return Unit_instance;
    MainOpPos_entriesInitialized = true;
    MainOpPos_FIRST_instance = new MainOpPos('FIRST', 0);
    MainOpPos_LAST_instance = new MainOpPos('LAST', 1);
    MainOpPos_ANY_instance = new MainOpPos('ANY', 2);
  }
  function canExecute($this, model, ops) {
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    var tmp_3;
    if (!(model == null)) {
      // Inline function 'kotlin.collections.isNotEmpty' call
      tmp_3 = !ops.s();
    } else {
      tmp_3 = false;
    }
    if (tmp_3) {
      tmp_2 = findAndSetMainOp($this, ops);
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = $this.h46(model);
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = areNonMainOpsValid($this, ops);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      executeOnTemp($this, model, ops);
      tmp = !$this.n43_1;
    } else {
      tmp = false;
    }
    return tmp;
  }
  function findAndSetMainOp($this, ops) {
    $this.l43_1 = findMainOp($this, ops);
    return !($this.l43_1 == null);
  }
  function operationsToApplyCount($this, ops) {
    var tmp0 = $this.f46();
    // Inline function 'kotlin.math.min' call
    var b = ops.p();
    return Math.min(tmp0, b);
  }
  function findMainOp($this, ops) {
    var mainOp = null;
    if (MainOpPos_FIRST_getInstance().equals($this.g46()) && $this.p45(first(ops))) {
      mainOp = first(ops);
    } else if (MainOpPos_LAST_getInstance().equals($this.g46()) && $this.p45(last(ops))) {
      mainOp = last(ops);
    } else if (MainOpPos_ANY_getInstance().equals($this.g46())) {
      var _iterator__ex2g4s = ops.m();
      $l$loop: while (_iterator__ex2g4s.n()) {
        var op = _iterator__ex2g4s.o();
        if ($this.p45(op)) {
          mainOp = op;
          break $l$loop;
        }
      }
    }
    return (mainOp == null ? true : isInterface(mainOp, Operation)) ? mainOp : THROW_CCE();
  }
  function areNonMainOpsValid($this, ops) {
    var mainOpPassed = false;
    var _iterator__ex2g4s = ops.m();
    while (_iterator__ex2g4s.n()) {
      var op = _iterator__ex2g4s.o();
      if (op === $this.l43_1) {
        mainOpPassed = true;
      } else if (!mainOpPassed && !$this.i46(op)) {
        return false;
      } else if (mainOpPassed && !$this.s45(op)) {
        return false;
      }
    }
    return true;
  }
  function executeOnTemp($this, model, ops) {
    $this.m43_1 = $this.u45(model);
    var checkerReg = $this.a46(ensureNotNull($this.m43_1));
    var tempItem = $this.w45(ensureNotNull($this.m43_1));
    var i = ops.m();
    while (i.n() && !$this.n43_1) {
      var operation = i.o();
      if (operation instanceof CustomExecuteOperation) {
        (operation instanceof CustomExecuteOperation ? operation : THROW_CCE()).c49(tempItem, false, $this.k43_1);
      } else {
        operation.y3x(tempItem, $this.k43_1);
      }
    }
    checkerReg.zr();
  }
  function execute($this, model) {
    // Inline function 'kotlin.check' call
    if (!!$this.n43_1) {
      var message = 'Execution was cancelled';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    $this.y45(model, $this.w45(ensureNotNull($this.m43_1)));
  }
  function MainOpPos(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function BaseOperationExecutor$cancel$ref(p0) {
    var l = function () {
      p0.i3a();
      return Unit_instance;
    };
    l.callableName = 'cancel';
    return l;
  }
  function MainOpPos_FIRST_getInstance() {
    MainOpPos_initEntries();
    return MainOpPos_FIRST_instance;
  }
  function MainOpPos_LAST_getInstance() {
    MainOpPos_initEntries();
    return MainOpPos_LAST_instance;
  }
  function MainOpPos_ANY_getInstance() {
    MainOpPos_initEntries();
    return MainOpPos_ANY_instance;
  }
  function BaseOperationExecutor(nodeFactory) {
    nodeFactory = nodeFactory === VOID ? RawNodeFactory_instance : nodeFactory;
    this.k43_1 = nodeFactory;
    this.l43_1 = null;
    this.m43_1 = null;
    this.n43_1 = false;
  }
  protoOf(BaseOperationExecutor).o43 = function (model, ops) {
    var trimmedOps = ops.g2(0, operationsToApplyCount(this, ops));
    if (canExecute(this, model, trimmedOps)) {
      execute(this, model);
      return ExecutionResult_init_$Create$(trimmedOps.p());
    }
    return Companion_getInstance_69().n4d_1;
  };
  protoOf(BaseOperationExecutor).i3a = function () {
    this.n43_1 = true;
  };
  protoOf(BaseOperationExecutor).g45 = function () {
    return BaseOperationExecutor$cancel$ref(this);
  };
  function BaseRemoveOperationExecutor(nodeFactory) {
    BaseOperationExecutor.call(this, nodeFactory);
  }
  protoOf(BaseRemoveOperationExecutor).f46 = function () {
    return 2;
  };
  protoOf(BaseRemoveOperationExecutor).g46 = function () {
    return MainOpPos_LAST_getInstance();
  };
  protoOf(BaseRemoveOperationExecutor).s45 = function (op) {
    throw IllegalStateException_init_$Create$();
  };
  function OperationCondition() {
  }
  protoOf(OperationCondition).x42 = function (op) {
    return this.q40(op);
  };
  protoOf(OperationCondition).y42 = function (op) {
    if (this.q40(op))
      return true;
    if (isInterface(op, OperationContainer)) {
      var _iterator__ex2g4s = (isInterface(op, OperationContainer) ? op : THROW_CCE()).j3w().m();
      while (_iterator__ex2g4s.n()) {
        var operation = _iterator__ex2g4s.o();
        if (this.y42(operation)) {
          return true;
        }
      }
    }
    return false;
  };
  protoOf(OperationCondition).p40 = function (op) {
    if (this.q40(op))
      return Unit_instance;
    if (isInterface(op, OperationContainer)) {
      var _iterator__ex2g4s = (isInterface(op, OperationContainer) ? op : THROW_CCE()).j3w().m();
      while (_iterator__ex2g4s.n()) {
        var operation = _iterator__ex2g4s.o();
        this.p40(operation);
      }
    }
  };
  function IndexedAddOperation() {
  }
  function IndexedOperation() {
  }
  function open($this, s, e) {
    return Companion_instance_37.y36(s, e);
  }
  function checkOperationsHaveLength($this, expectedLength, ops) {
    var inductionVariable = 0;
    var last = ops.length;
    while (inductionVariable < last) {
      var op = ops[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (!(op.a() === expectedLength)) {
        return false;
      }
    }
    return true;
  }
  function IndexedOperationTransformer() {
  }
  protoOf(IndexedOperationTransformer).r4d = function (op1, op2, server) {
    var r1 = open(this, op1.m3p(), op1.m3p() + op1.a() | 0);
    var r2 = open(this, op2.m3p(), op2.m3p() + op2.a() | 0);
    var tmp;
    if (isInterface(op1, IndexedAddOperation)) {
      tmp = isInterface(op2, IndexedAddOperation);
    } else {
      tmp = false;
    }
    if (tmp) {
      var iao1 = isInterface(op1, IndexedAddOperation) ? op1 : THROW_CCE();
      var iao2 = isInterface(op2, IndexedAddOperation) ? op2 : THROW_CCE();
      var tmp_0;
      if (iao1.m3p() > iao2.m3p()) {
        tmp_0 = 0;
      } else if (iao1.m3p() < iao2.m3p()) {
        tmp_0 = iao1.a();
      } else if (iao1.o4d().a3(iao2.o4d()) > 0 || (iao1.o4d().equals(iao2.o4d()) && server)) {
        tmp_0 = iao1.a();
      } else {
        tmp_0 = 0;
      }
      var delta = tmp_0;
      return iao2.p4d(iao2.m3p() + delta | 0);
    }
    var tmp_1;
    if (isInterface(op1, IndexedRemoveOperation)) {
      tmp_1 = isInterface(op2, IndexedRemoveOperation);
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      var iro1 = isInterface(op1, IndexedRemoveOperation) ? op1 : THROW_CCE();
      var iro2 = isInterface(op2, IndexedRemoveOperation) ? op2 : THROW_CCE();
      var intersection = r1.l37(r2) ? r1.m37(r2) : null;
      var tmp_2;
      if (intersection == null || intersection.s()) {
        var tmp_3;
        if (iro1.m3p() > iro2.m3p()) {
          tmp_3 = iro2;
        } else {
          tmp_3 = iro2.p4d(iro2.m3p() - iro1.a() | 0);
        }
        tmp_2 = tmp_3;
      } else {
        var message = 'Intersection of remove operations should be resolved outside of transformer';
        throw IllegalStateException_init_$Create$_0(message);
      }
      return tmp_2;
    }
    var tmp_4;
    if (isInterface(op1, IndexedRemoveOperation)) {
      tmp_4 = isInterface(op2, IndexedAddOperation);
    } else {
      tmp_4 = false;
    }
    if (tmp_4) {
      var iro = isInterface(op1, IndexedRemoveOperation) ? op1 : THROW_CCE();
      var iao = isInterface(op2, IndexedAddOperation) ? op2 : THROW_CCE();
      var tmp_5;
      if (iro.m3p() >= iao.m3p()) {
        tmp_5 = iao;
      } else if (r1.i37(iao.m3p())) {
        tmp_5 = new NopOperation();
      } else {
        tmp_5 = iao.p4d(iao.m3p() - iro.a() | 0);
      }
      return tmp_5;
    }
    var tmp_6;
    if (isInterface(op1, IndexedAddOperation)) {
      tmp_6 = isInterface(op2, IndexedRemoveOperation);
    } else {
      tmp_6 = false;
    }
    if (tmp_6) {
      var iao_0 = isInterface(op1, IndexedAddOperation) ? op1 : THROW_CCE();
      var iro_0 = isInterface(op2, IndexedRemoveOperation) ? op2 : THROW_CCE();
      var tmp_7;
      if (iro_0.m3p() >= iao_0.m3p()) {
        tmp_7 = iro_0.p4d(iro_0.m3p() + iao_0.a() | 0);
      } else if (r2.i37(iao_0.m3p())) {
        tmp_7 = iro_0.s4d(iao_0);
      } else {
        tmp_7 = iro_0;
      }
      return tmp_7;
    }
    var tmp_8;
    var tmp_9;
    if (isInterface(op1, IndexedReplaceOperation)) {
      tmp_9 = isInterface(op2, IndexedRemoveOperation);
    } else {
      tmp_9 = false;
    }
    if (tmp_9) {
      tmp_8 = checkOperationsHaveLength(this, 1, [op1, op2]);
    } else {
      tmp_8 = false;
    }
    if (tmp_8) {
      var iRepO = isInterface(op1, IndexedReplaceOperation) ? op1 : THROW_CCE();
      var iRemO = isInterface(op2, IndexedRemoveOperation) ? op2 : THROW_CCE();
      var tmp_10;
      if (iRepO.m3p() === iRemO.m3p()) {
        tmp_10 = iRemO.t4d(iRepO);
      } else {
        tmp_10 = iRemO;
      }
      return tmp_10;
    }
    var tmp_11;
    var tmp_12;
    if (isInterface(op1, IndexedRemoveOperation)) {
      tmp_12 = isInterface(op2, IndexedReplaceOperation);
    } else {
      tmp_12 = false;
    }
    if (tmp_12) {
      tmp_11 = checkOperationsHaveLength(this, 1, [op1, op2]);
    } else {
      tmp_11 = false;
    }
    if (tmp_11) {
      var iRemO_0 = isInterface(op1, IndexedRemoveOperation) ? op1 : THROW_CCE();
      var iRepO_0 = isInterface(op2, IndexedReplaceOperation) ? op2 : THROW_CCE();
      var tmp_13;
      if (iRepO_0.m3p() > iRemO_0.m3p()) {
        tmp_13 = iRepO_0.p4d(iRepO_0.m3p() - iRemO_0.a() | 0);
      } else if (iRepO_0.m3p() === iRemO_0.m3p()) {
        tmp_13 = new NopOperation();
      } else {
        tmp_13 = iRepO_0;
      }
      return tmp_13;
    }
    var tmp_14;
    var tmp_15;
    if (isInterface(op1, IndexedAddOperation)) {
      tmp_15 = isInterface(op2, IndexedReplaceOperation);
    } else {
      tmp_15 = false;
    }
    if (tmp_15) {
      tmp_14 = checkOperationsHaveLength(this, 1, [op1, op2]);
    } else {
      tmp_14 = false;
    }
    if (tmp_14) {
      var iao_1 = isInterface(op1, IndexedAddOperation) ? op1 : THROW_CCE();
      var iRepO_1 = isInterface(op2, IndexedReplaceOperation) ? op2 : THROW_CCE();
      var tmp_16;
      if (iRepO_1.m3p() >= iao_1.m3p()) {
        tmp_16 = iRepO_1.p4d(iRepO_1.m3p() + iao_1.a() | 0);
      } else {
        tmp_16 = iRepO_1;
      }
      return tmp_16;
    }
    var tmp_17;
    var tmp_18;
    if (isInterface(op1, IndexedReplaceOperation)) {
      tmp_18 = isInterface(op2, IndexedAddOperation);
    } else {
      tmp_18 = false;
    }
    if (tmp_18) {
      tmp_17 = checkOperationsHaveLength(this, 1, [op1, op2]);
    } else {
      tmp_17 = false;
    }
    if (tmp_17) {
      return op2;
    }
    var tmp_19;
    var tmp_20;
    if (isInterface(op1, IndexedReplaceOperation)) {
      tmp_20 = isInterface(op2, IndexedReplaceOperation);
    } else {
      tmp_20 = false;
    }
    if (tmp_20) {
      tmp_19 = checkOperationsHaveLength(this, 1, [op1, op2]);
    } else {
      tmp_19 = false;
    }
    if (tmp_19) {
      var iRepO1 = isInterface(op1, IndexedReplaceOperation) ? op1 : THROW_CCE();
      var iRepO2 = isInterface(op2, IndexedReplaceOperation) ? op2 : THROW_CCE();
      var tmp_21;
      if (iRepO1.m3p() === iRepO2.m3p()) {
        var tmp_22;
        if (server) {
          tmp_22 = new NopOperation();
        } else {
          tmp_22 = iRepO2.t4d(iRepO1);
        }
        tmp_21 = tmp_22;
      } else {
        tmp_21 = iRepO2;
      }
      return tmp_21;
    }
    throw IllegalArgumentException_init_$Create$_0(toString_1(op1) + '; ' + toString_1(op2));
  };
  function IndexedRemoveOperation() {
  }
  function IndexedReplaceOperation() {
  }
  var Priority_NORMAL_instance;
  var Priority_HIGH_instance;
  var Priority_entriesInitialized;
  function Priority_initEntries() {
    if (Priority_entriesInitialized)
      return Unit_instance;
    Priority_entriesInitialized = true;
    Priority_NORMAL_instance = new Priority('NORMAL', 0);
    Priority_HIGH_instance = new Priority('HIGH', 1);
  }
  function Priority(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function Priority_NORMAL_getInstance() {
    Priority_initEntries();
    return Priority_NORMAL_instance;
  }
  function Priority_HIGH_getInstance() {
    Priority_initEntries();
    return Priority_HIGH_instance;
  }
  function Accumulator() {
  }
  function _get_accumulators__7t2b7i($this) {
    var accumulators = ArrayList_init_$Create$();
    accumulators.j(new SetValueAccumulator());
    accumulators.j(new EntityReferenceAccumulator());
    accumulators.j(new ModelAccumulator($this));
    accumulators.j(new RootOperationsAccumulator($this));
    accumulators.j(new SetPropertyAccumulator($this));
    accumulators.j(new EntityChildAccumulator($this));
    accumulators.j(new EntityChildSetAccumulator($this));
    accumulators.j(new SetReferenceAccumulator($this));
    accumulators.j(new ChangeModelAccumulator());
    return accumulators;
  }
  function collectFromAccumulators($this, accumulators, result) {
    var _iterator__ex2g4s = accumulators.m();
    while (_iterator__ex2g4s.n()) {
      var accumulator = _iterator__ex2g4s.o();
      var ops = accumulator.w4d();
      result.q(isInterface(ops, Collection) ? ops : THROW_CCE());
    }
  }
  function accumulate($this, accumulators, operation) {
    var _iterator__ex2g4s = accumulators.m();
    while (_iterator__ex2g4s.n()) {
      var accumulator = _iterator__ex2g4s.o();
      if (accumulator.u4d(operation)) {
        var opAccumulator = isInterface(accumulator, Accumulator) ? accumulator : THROW_CCE();
        opAccumulator.v4d(operation);
        return true;
      }
    }
    return false;
  }
  function unwrapAndRemoveNops($this, op, annotationData) {
    var tmp;
    if (op instanceof AnnotatedOperation) {
      annotationData.a4e(op);
      tmp = unwrapAndRemoveNops($this, op.e4e_1, annotationData);
    } else {
      if (op instanceof CompositeOperation) {
        var result = ArrayList_init_$Create$();
        var _iterator__ex2g4s = op.j3w().m();
        while (_iterator__ex2g4s.n()) {
          var innerOp = _iterator__ex2g4s.o();
          result.q(unwrapAndRemoveNops($this, innerOp, annotationData));
        }
        tmp = result;
      } else {
        if (op.r3x()) {
          tmp = emptyList();
        } else {
          tmp = listOf(op);
        }
      }
    }
    return tmp;
  }
  function AnnotationData() {
    this.x4d_1 = null;
    this.y4d_1 = 0n;
    this.z4d_1 = false;
  }
  protoOf(AnnotationData).a4e = function (op) {
    var opAuthor = op.c4e_1;
    if (this.z4d_1) {
      if (!(this.x4d_1 == opAuthor)) {
        this.x4d_1 = 'Various authors';
      }
    } else {
      this.z4d_1 = true;
      this.x4d_1 = opAuthor;
      this.y4d_1 = op.d4e_1;
    }
  };
  protoOf(AnnotationData).f4e = function (op) {
    var tmp;
    if (this.z4d_1) {
      tmp = new AnnotatedOperation(this.x4d_1, this.y4d_1, op);
    } else {
      tmp = op;
    }
    return tmp;
  };
  function RootOperationsAccumulator(merger) {
    AddChangeRemoveAccumulator.call(this, merger, new RootOperationUtil());
  }
  function EntityChildAccumulator(merger) {
    AddChangeRemoveAccumulator.call(this, merger, new ChildOperationUtil());
  }
  function ModelAccumulator(merger) {
    AddChangeRemoveAccumulator.call(this, merger, new ModelBlobOperationUtil());
  }
  function Companion_59() {
    this.m4e_1 = 'Various authors';
  }
  var Companion_instance_59;
  function Companion_getInstance_59() {
    return Companion_instance_59;
  }
  function AccumulatorBasedMerger() {
  }
  protoOf(AccumulatorBasedMerger).s3x = function (operations) {
    var annotationData = new AnnotationData();
    var accumulatorList = _get_accumulators__7t2b7i(this);
    var result = ArrayList_init_$Create$();
    var _iterator__ex2g4s = operations.m();
    while (_iterator__ex2g4s.n()) {
      var operation = _iterator__ex2g4s.o();
      var unwrapped = unwrapAndRemoveNops(this, operation, annotationData);
      var _iterator__ex2g4s_0 = unwrapped.m();
      while (_iterator__ex2g4s_0.n()) {
        var innerOp = _iterator__ex2g4s_0.o();
        var accumulatorFound = accumulate(this, accumulatorList, innerOp);
        if (!accumulatorFound) {
          ThrowableHandlers_getInstance().k2r_1.j2r(RuntimeException_init_$Create$_0('Operation unsupported by merger found: ' + getKClassFromExpression(innerOp).ra()));
          collectFromAccumulators(this, accumulatorList, result);
          result.q(unwrapped);
          accumulatorList = _get_accumulators__7t2b7i(this);
        }
      }
    }
    collectFromAccumulators(this, accumulatorList, result);
    var composed = Companion_instance_68.b40(result);
    return annotationData.f4e(composed);
  };
  function AddChangeRemoveAccumulator$addOp$1(this$0) {
    this.n4e_1 = this$0;
  }
  protoOf(AddChangeRemoveAccumulator$addOp$1).s3x = function (operations) {
    return this.n4e_1.l4e(operations);
  };
  function AddChangeRemoveAccumulator(merger, util) {
    MergerBasedAccumulator.call(this, merger);
    this.h4e_1 = util;
    this.i4e_1 = new ListMap();
  }
  protoOf(AddChangeRemoveAccumulator).u4d = function (op) {
    return this.h4e_1.i44(op) || this.h4e_1.j44(op) || this.h4e_1.k44(op);
  };
  protoOf(AddChangeRemoveAccumulator).j4e = function (op) {
    var role = this.h4e_1.m44(op);
    if (!this.i4e_1.o2(role)) {
      this.i4e_1.t2(role, new OperationsInfo(this.h4e_1, new AddChangeRemoveAccumulator$addOp$1(this)));
    }
    var info = this.i4e_1.q2(role);
    if (this.h4e_1.i44(op)) {
      ensureNotNull(info).y4e(op);
    } else if (this.h4e_1.j44(op)) {
      ensureNotNull(info).x4e(op);
    } else if (this.h4e_1.k44(op)) {
      ensureNotNull(info).w4e(op);
    }
  };
  protoOf(AddChangeRemoveAccumulator).v4d = function (op) {
    return this.j4e(isInterface(op, Operation) ? op : THROW_CCE());
  };
  protoOf(AddChangeRemoveAccumulator).w4d = function () {
    var result = ArrayList_init_$Create$();
    var _iterator__ex2g4s = this.i4e_1.z2m().m();
    while (_iterator__ex2g4s.n()) {
      var roleInfoEntry = _iterator__ex2g4s.o();
      var info = roleInfoEntry.o2m();
      var role = roleInfoEntry.n2m();
      result.q(info.z4e(role));
    }
    return result;
  };
  function ChangeModelAccumulator() {
    MergerBasedAccumulator.call(this, Companion_instance_60.b3c());
    this.b4f_1 = ArrayList_init_$Create$();
  }
  protoOf(ChangeModelAccumulator).u4d = function (op) {
    return op instanceof SetModelOperation;
  };
  protoOf(ChangeModelAccumulator).c4f = function (op) {
    this.b4f_1.j(op);
  };
  protoOf(ChangeModelAccumulator).v4d = function (op) {
    return this.c4f(isInterface(op, Operation) ? op : THROW_CCE());
  };
  protoOf(ChangeModelAccumulator).w4d = function () {
    var mergeResult = this.l4e(this.b4f_1);
    return mergeResult.r3x() ? emptyList() : listOf(mergeResult);
  };
  function EntityChildSetAccumulator(merger) {
    TargetedOperationAccumulator.call(this, merger);
  }
  protoOf(EntityChildSetAccumulator).u4d = function (op) {
    return op instanceof ChildSetOperation;
  };
  function ReferenceOperationUtil() {
  }
  protoOf(ReferenceOperationUtil).i44 = function (op) {
    return op instanceof AddToSetOperation;
  };
  protoOf(ReferenceOperationUtil).j44 = function (op) {
    return op instanceof RemoveFromSetOperation;
  };
  protoOf(ReferenceOperationUtil).k44 = function (op) {
    return false;
  };
  protoOf(ReferenceOperationUtil).k4f = function (op) {
    return (op instanceof ChangeSetOperation ? op : THROW_CCE()).m4f_1;
  };
  protoOf(ReferenceOperationUtil).m44 = function (op) {
    return this.k4f(op);
  };
  protoOf(ReferenceOperationUtil).o4f = function (op) {
    var changeSetOp = op instanceof ChangeSetOperation ? op : THROW_CCE();
    return new EntityReferenceData(changeSetOp.m4f_1, changeSetOp.n4f_1);
  };
  protoOf(ReferenceOperationUtil).o44 = function (op) {
    return this.o4f(op);
  };
  protoOf(ReferenceOperationUtil).p4f = function (role, data) {
    return new AddToSetOperation(data.q4f_1, data.r4f_1);
  };
  protoOf(ReferenceOperationUtil).q44 = function (role, data) {
    var tmp = role instanceof EntityReference ? role : THROW_CCE();
    return this.p4f(tmp, data instanceof EntityReferenceData ? data : THROW_CCE());
  };
  protoOf(ReferenceOperationUtil).s4f = function (role, data) {
    return new RemoveFromSetOperation(data.q4f_1, data.r4f_1);
  };
  protoOf(ReferenceOperationUtil).s44 = function (role, data) {
    var tmp = role instanceof EntityReference ? role : THROW_CCE();
    return this.s4f(tmp, data instanceof EntityReferenceData ? data : THROW_CCE());
  };
  protoOf(ReferenceOperationUtil).t4f = function (role, innerOp) {
    throw UnsupportedOperationException_init_$Create$();
  };
  protoOf(ReferenceOperationUtil).u44 = function (role, innerOp) {
    return this.t4f(role instanceof EntityReference ? role : THROW_CCE(), innerOp);
  };
  function EntityReferenceData(ref, singleRole) {
    this.q4f_1 = ref;
    this.r4f_1 = singleRole;
  }
  protoOf(EntityReferenceData).toString = function () {
    return 'EntityReferenceData(ref=' + this.q4f_1.toString() + ', singleRole=' + this.r4f_1 + ')';
  };
  protoOf(EntityReferenceData).hashCode = function () {
    var result = this.q4f_1.hashCode();
    result = imul(result, 31) + getBooleanHashCode(this.r4f_1) | 0;
    return result;
  };
  protoOf(EntityReferenceData).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof EntityReferenceData))
      return false;
    if (!this.q4f_1.equals(other.q4f_1))
      return false;
    if (!(this.r4f_1 === other.r4f_1))
      return false;
    return true;
  };
  function EntityReferenceAccumulator() {
    AddChangeRemoveAccumulator.call(this, null, new ReferenceOperationUtil());
  }
  function MergerBasedAccumulator(merger) {
    this.k4e_1 = merger;
  }
  protoOf(MergerBasedAccumulator).l4e = function (ops) {
    return ensureNotNull(this.k4e_1).s3x(ops);
  };
  function assertNoChangesBeforeAdd($this) {
    if (!$this.r4e_1.s()) {
      var builder = new StringBuilder('Got operations changing item before adding item itself:\n');
      builder.j8('Changing ops:\n');
      var _iterator__ex2g4s = $this.r4e_1.m();
      while (_iterator__ex2g4s.n()) {
        var existingOp = _iterator__ex2g4s.o();
        builder.j8(existingOp.r43()).j8('\n');
      }
      throw IllegalStateException_init_$Create$_0(builder.toString());
    }
  }
  function mergeAndAddToResult($this, ops, result, role) {
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!ops.s()) {
      var mergedOp = $this.p4e_1.s3x(ops);
      if (!mergedOp.r3x()) {
        result.j($this.o4e_1.u44(role, mergedOp));
      }
    }
  }
  function collectAddChangeOps($this, ops, role) {
    var result = ArrayList_init_$Create$();
    if ($this.s4e_1) {
      result.j($this.o4e_1.q44(role, ensureNotNull($this.t4e_1)));
    }
    mergeAndAddToResult($this, ops, result, role);
    return result;
  }
  function OperationsInfo(util, merger) {
    this.o4e_1 = util;
    this.p4e_1 = merger;
    this.q4e_1 = false;
    this.r4e_1 = ArrayList_init_$Create$();
    this.s4e_1 = false;
    this.t4e_1 = null;
    this.u4e_1 = null;
    this.v4e_1 = null;
  }
  protoOf(OperationsInfo).y4e = function (op) {
    this.q4e_1 = true;
    // Inline function 'kotlin.check' call
    if (!!this.s4e_1) {
      var message = 'Unexpected add operation: object with this role was added already';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    assertNoChangesBeforeAdd(this);
    this.t4e_1 = this.o4e_1.o44(op);
    this.s4e_1 = true;
  };
  protoOf(OperationsInfo).x4e = function (op) {
    if (this.q4e_1) {
      if (this.s4e_1) {
        var curData = this.o4e_1.o44(op);
        // Inline function 'kotlin.check' call
        if (!equals(this.t4e_1, curData)) {
          var message = 'Unequal data for add and remove operations';
          throw IllegalStateException_init_$Create$_0(toString_1(message));
        }
        this.r4e_1.k2();
        this.s4e_1 = false;
      } else {
        throw IllegalStateException_init_$Create$_0('Unexpected remove operation: remove without corresponding add');
      }
    } else {
      this.q4e_1 = true;
      this.u4e_1 = this.o4e_1.o44(op);
      this.v4e_1 = ArrayList_init_$Create$_1(this.r4e_1);
      this.r4e_1.k2();
    }
  };
  protoOf(OperationsInfo).w4e = function (op) {
    var targetedOperation = op instanceof TargetedOperation ? op : THROW_CCE();
    this.r4e_1.j(targetedOperation.s3z());
  };
  protoOf(OperationsInfo).z4e = function (role) {
    if (!(this.u4e_1 == null)) {
      var result = ArrayList_init_$Create$();
      if (equals(this.u4e_1, this.t4e_1)) {
        if (!this.s4e_1) {
          // Inline function 'kotlin.check' call
          if (!this.r4e_1.s()) {
            var message = 'Non-empty inner operations though no add happened after remove';
            throw IllegalStateException_init_$Create$_0(toString_1(message));
          }
          mergeAndAddToResult(this, ensureNotNull(this.v4e_1), result, role);
          result.j(this.o4e_1.s44(role, ensureNotNull(this.u4e_1)));
        } else {
          var allOps = ArrayList_init_$Create$_1(ensureNotNull(this.v4e_1));
          allOps.q(this.r4e_1);
          mergeAndAddToResult(this, allOps, result, role);
        }
      } else {
        mergeAndAddToResult(this, ensureNotNull(this.v4e_1), result, role);
        result.j(this.o4e_1.s44(role, ensureNotNull(this.u4e_1)));
        result.q(collectAddChangeOps(this, this.r4e_1, role));
      }
      return result;
    }
    return collectAddChangeOps(this, this.r4e_1, role);
  };
  function SetPropertyAccumulator(merger) {
    TargetedOperationAccumulator.call(this, merger);
  }
  protoOf(SetPropertyAccumulator).u4d = function (op) {
    return op instanceof SetPropertyOperation;
  };
  function SetReferenceAccumulator(merger) {
    TargetedOperationAccumulator.call(this, merger);
  }
  protoOf(SetReferenceAccumulator).u4d = function (op) {
    return op instanceof SetReferenceOperation;
  };
  function nullOrString($this, o) {
    var tmp;
    if (o == null) {
      tmp = true;
    } else {
      tmp = typeof o === 'string';
    }
    return tmp;
  }
  function SetValueAccumulator() {
    this.a4g_1 = false;
    this.b4g_1 = null;
    this.c4g_1 = null;
  }
  protoOf(SetValueAccumulator).u4d = function (op) {
    var tmp;
    if (!(op instanceof SetValueOperation)) {
      tmp = false;
    } else {
      tmp = (nullOrString(this, op.e4g_1) && nullOrString(this, op.f4g_1));
    }
    return tmp;
  };
  protoOf(SetValueAccumulator).g4g = function (op) {
    var setValueOp = op instanceof SetValueOperation ? op : THROW_CCE();
    if (!this.a4g_1) {
      this.b4g_1 = setValueOp.e4g_1;
      this.a4g_1 = true;
    }
    this.c4g_1 = setValueOp.f4g_1;
  };
  protoOf(SetValueAccumulator).v4d = function (op) {
    return this.g4g(isInterface(op, Operation) ? op : THROW_CCE());
  };
  protoOf(SetValueAccumulator).w4d = function () {
    var tmp;
    if (this.a4g_1 && !(this.b4g_1 == this.c4g_1)) {
      tmp = listOf(new SetValueOperation(this.b4g_1, this.c4g_1));
    } else {
      tmp = emptyList();
    }
    return tmp;
  };
  function TargetedOperationAccumulator$addOp$lambda($op) {
    return function (value) {
      var tmp = $op.x43(value);
      return tmp instanceof TargetedOperation ? tmp : THROW_CCE();
    };
  }
  function TargetedOperationAccumulator(merger) {
    MergerBasedAccumulator.call(this, merger);
    this.h4f_1 = HashMap_init_$Create$();
    this.i4f_1 = HashMap_init_$Create$();
  }
  protoOf(TargetedOperationAccumulator).j4f = function (op) {
    var role = op.l3p();
    if (!this.h4f_1.o2(role)) {
      var tmp0 = this.h4f_1;
      // Inline function 'kotlin.collections.set' call
      var value = ArrayList_init_$Create$();
      tmp0.t2(role, value);
      var tmp0_0 = this.i4f_1;
      // Inline function 'kotlin.collections.set' call
      var value_0 = TargetedOperationAccumulator$addOp$lambda(op);
      tmp0_0.t2(role, value_0);
    }
    getValue_0(this.h4f_1, role).j(op.s3z());
  };
  protoOf(TargetedOperationAccumulator).v4d = function (op) {
    return this.j4f(op instanceof TargetedOperation ? op : THROW_CCE());
  };
  protoOf(TargetedOperationAccumulator).w4d = function () {
    var result = ArrayList_init_$Create$();
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s = this.h4f_1.y().m();
    while (_iterator__ex2g4s.n()) {
      var _destruct__k2r9zo = _iterator__ex2g4s.o();
      // Inline function 'kotlin.collections.component1' call
      var key = _destruct__k2r9zo.z();
      // Inline function 'kotlin.collections.component2' call
      var value = _destruct__k2r9zo.a1();
      var merge = this.l4e(value);
      if (!merge.r3x()) {
        result.j(getValue_0(this.i4f_1, key)(merge));
      }
    }
    return result;
  };
  function BaseDataOperationRule() {
    BaseMergeOperationsRule.call(this);
  }
  protoOf(BaseDataOperationRule).j4g = function (op1, op2) {
    var tmp;
    if (!this.h4g(op1) || !this.i4g(op2)) {
      tmp = false;
    } else {
      tmp = equals(this.k4g(op1), this.l4g(op2));
    }
    return tmp;
  };
  function BaseMergeOperationsRule() {
  }
  protoOf(BaseMergeOperationsRule).m4g = function (op1, op2) {
    if (this.j4g(op1, op2)) {
      return this.n4g(op1, op2);
    }
    throw IllegalArgumentException_init_$Create$_0('Operations are not same: ' + toString_1(op1) + ' ' + toString_1(op2));
  };
  function BaseMutuallyInverseOperationRule() {
    BaseDataOperationRule.call(this);
  }
  protoOf(BaseMutuallyInverseOperationRule).n4g = function (op1, op2) {
    return new NopOperation();
  };
  protoOf(BaseMutuallyInverseOperationRule).k4g = function (op) {
    return this.o4g(op);
  };
  protoOf(BaseMutuallyInverseOperationRule).l4g = function (op) {
    return this.o4g(op);
  };
  function EntityChildAddRemoveRule() {
    BaseMutuallyInverseOperationRule.call(this);
  }
  protoOf(EntityChildAddRemoveRule).h4g = function (op) {
    return op instanceof AddChildOperation;
  };
  protoOf(EntityChildAddRemoveRule).i4g = function (op) {
    return op instanceof RemoveChildOperation;
  };
  protoOf(EntityChildAddRemoveRule).o4g = function (op) {
    return (op instanceof ChildOperation ? op : THROW_CCE()).o3w_1;
  };
  function getOperationsList($this, op) {
    var tmp;
    if (op instanceof CompositeOperation) {
      tmp = (op instanceof CompositeOperation ? op : THROW_CCE()).j3w();
    } else {
      tmp = listOf(op);
    }
    return tmp;
  }
  function tryMergeInner($this, op1, op2) {
    var merged = $this.q4g(op1, op2);
    var tmp;
    if (merged instanceof CompositeOperation) {
      tmp = null;
    } else {
      tmp = merged;
    }
    return tmp;
  }
  function MergeCompositeOperationsRule(innerOperationsMerger) {
    MergeContainerOperationsRule.call(this, innerOperationsMerger);
  }
  protoOf(MergeCompositeOperationsRule).n4g = function (op1, op2) {
    var ops1 = getOperationsList(this, op1);
    var ops2 = getOperationsList(this, op2);
    if (ops1.s()) {
      return Companion_instance_68.b40(ops2);
    }
    if (ops2.s()) {
      return Companion_instance_68.b40(ops1);
    }
    var index1 = ops1.p() - 1 | 0;
    var index2 = 0;
    var merged = tryMergeInner(this, ops1.r(index1), ops2.r(index2));
    if (merged == null) {
      var operations = ArrayList_init_$Create$();
      operations.q(ops1);
      operations.q(ops2);
      return Companion_instance_68.b40(operations);
    }
    index1 = index1 - 1 | 0;
    index2 = index2 + 1 | 0;
    while (index1 >= 0 || index2 < ops2.p()) {
      var mergedAny = false;
      if (index1 >= 0) {
        var result = tryMergeInner(this, ops1.r(index1), ensureNotNull(merged));
        if (!(result == null)) {
          merged = result;
          index1 = index1 - 1 | 0;
          mergedAny = true;
        }
      }
      if (index2 < ops2.p()) {
        var result_0 = tryMergeInner(this, ensureNotNull(merged), ops2.r(index2));
        if (!(result_0 == null)) {
          merged = result_0;
          index2 = index2 + 1 | 0;
          mergedAny = true;
        }
      }
      if (!mergedAny) {
        var operations_0 = ArrayList_init_$Create$_1(ops1.g2(0, index1 + 1 | 0));
        operations_0.j(ensureNotNull(merged));
        operations_0.q(subListTail(ops2, index2));
        return Companion_instance_68.b40(operations_0);
      }
    }
    return ensureNotNull(merged);
  };
  protoOf(MergeCompositeOperationsRule).j4g = function (op1, op2) {
    var tmp;
    if (op1 instanceof CompositeOperation) {
      tmp = true;
    } else {
      tmp = op2 instanceof CompositeOperation;
    }
    return tmp;
  };
  function MergeContainerOperationsRule(innerOperationsMerger) {
    BaseMergeOperationsRule.call(this);
    this.p4g_1 = innerOperationsMerger;
  }
  protoOf(MergeContainerOperationsRule).q4g = function (op1, op2) {
    return this.p4g_1.s3x(listOf_0([op1, op2]));
  };
  function MergeSetValueOperationsRule() {
    BaseMergeOperationsRule.call(this);
  }
  protoOf(MergeSetValueOperationsRule).n4g = function (op1, op2) {
    var setValue1 = op1 instanceof SetValueOperation ? op1 : THROW_CCE();
    var setValue2 = op2 instanceof SetValueOperation ? op2 : THROW_CCE();
    var oldValue = setValue1.e4g_1;
    var newValue = setValue2.f4g_1;
    return equals(oldValue, newValue) ? new NopOperation() : new SetValueOperation(oldValue, newValue);
  };
  protoOf(MergeSetValueOperationsRule).j4g = function (op1, op2) {
    var tmp;
    var tmp_0;
    if (op1 instanceof SetValueOperation) {
      tmp_0 = op2 instanceof SetValueOperation;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      var tmp_1 = (op1 instanceof SetValueOperation ? op1 : THROW_CCE()).f4g_1;
      tmp = equals(tmp_1, (op2 instanceof SetValueOperation ? op2 : THROW_CCE()).e4g_1);
    } else {
      tmp = false;
    }
    return tmp;
  };
  function MergeTargetedOperationsRule(innerOperationsMerger) {
    MergeContainerOperationsRule.call(this, innerOperationsMerger);
  }
  protoOf(MergeTargetedOperationsRule).n4g = function (op1, op2) {
    var targeted1 = op1 instanceof TargetedOperation ? op1 : THROW_CCE();
    var targeted2 = op2 instanceof TargetedOperation ? op2 : THROW_CCE();
    var innerMergeResult = this.q4g(targeted1.s3z(), targeted2.s3z());
    return innerMergeResult.r3x() ? new NopOperation() : targeted1.x43(innerMergeResult);
  };
  protoOf(MergeTargetedOperationsRule).j4g = function (op1, op2) {
    var tmp;
    var tmp_0;
    if (op1 instanceof TargetedOperation) {
      tmp_0 = op2 instanceof TargetedOperation;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      var tmp_1 = (op1 instanceof TargetedOperation ? op1 : THROW_CCE()).l3p();
      tmp = equals(tmp_1, (op2 instanceof TargetedOperation ? op2 : THROW_CCE()).l3p());
    } else {
      tmp = false;
    }
    return tmp;
  };
  function ModelAddRemoveRule() {
    BaseMutuallyInverseOperationRule.call(this);
  }
  protoOf(ModelAddRemoveRule).h4g = function (op) {
    return op instanceof AddModelBlobOperation;
  };
  protoOf(ModelAddRemoveRule).i4g = function (op) {
    return op instanceof RemoveModelBlobOperation;
  };
  protoOf(ModelAddRemoveRule).o4g = function (op) {
    return (op instanceof ModelBlobOperation ? op : THROW_CCE()).p42_1;
  };
  function NodeChildAddRemoveRule() {
    BaseMutuallyInverseOperationRule.call(this);
  }
  protoOf(NodeChildAddRemoveRule).h4g = function (op) {
    return op instanceof AddChildOperation_0;
  };
  protoOf(NodeChildAddRemoveRule).i4g = function (op) {
    return op instanceof RemoveChildOperation_0;
  };
  protoOf(NodeChildAddRemoveRule).o4g = function (op) {
    return (op instanceof ChildOperation_0 ? op : THROW_CCE()).t3w_1;
  };
  function NodeChildAddReplaceRule() {
    BaseDataOperationRule.call(this);
  }
  protoOf(NodeChildAddReplaceRule).h4g = function (op) {
    return op instanceof AddChildOperation_0;
  };
  protoOf(NodeChildAddReplaceRule).i4g = function (op) {
    return op instanceof ReplaceChildOperation;
  };
  protoOf(NodeChildAddReplaceRule).k4g = function (op) {
    var childOperation = op instanceof ChildOperation_0 ? op : THROW_CCE();
    return childOperation.t3w_1;
  };
  protoOf(NodeChildAddReplaceRule).l4g = function (op) {
    var replaceChildOperation = op instanceof ReplaceChildOperation ? op : THROW_CCE();
    return replaceChildOperation.i42_1;
  };
  protoOf(NodeChildAddReplaceRule).n4g = function (op1, op2) {
    var replaceChildOperation = op2 instanceof ReplaceChildOperation ? op2 : THROW_CCE();
    var addChildOperation = AddChildOperation_init_$Create$_2(replaceChildOperation.j42_1);
    return isInterface(addChildOperation, Operation) ? addChildOperation : THROW_CCE();
  };
  function NodeChildReplaceRemoveRule() {
    BaseDataOperationRule.call(this);
  }
  protoOf(NodeChildReplaceRemoveRule).h4g = function (op) {
    return op instanceof ReplaceChildOperation;
  };
  protoOf(NodeChildReplaceRemoveRule).i4g = function (op) {
    return op instanceof RemoveChildOperation_0;
  };
  protoOf(NodeChildReplaceRemoveRule).k4g = function (op) {
    var replaceChildOperation = op instanceof ReplaceChildOperation ? op : THROW_CCE();
    return replaceChildOperation.j42_1;
  };
  protoOf(NodeChildReplaceRemoveRule).l4g = function (op) {
    var childOperation = op instanceof ChildOperation_0 ? op : THROW_CCE();
    return childOperation.t3w_1;
  };
  protoOf(NodeChildReplaceRemoveRule).n4g = function (op1, op2) {
    var replaceChildOperation = op1 instanceof ReplaceChildOperation ? op1 : THROW_CCE();
    var removeChildOperation = RemoveChildOperation_init_$Create$_2(replaceChildOperation.i42_1);
    return isInterface(removeChildOperation, Operation) ? removeChildOperation : THROW_CCE();
  };
  function NodeChildReplaceReplaceRule() {
    BaseDataOperationRule.call(this);
  }
  protoOf(NodeChildReplaceReplaceRule).h4g = function (op) {
    return op instanceof ReplaceChildOperation;
  };
  protoOf(NodeChildReplaceReplaceRule).i4g = function (op) {
    return op instanceof ReplaceChildOperation;
  };
  protoOf(NodeChildReplaceReplaceRule).k4g = function (op) {
    var replaceChildOperation = op instanceof ReplaceChildOperation ? op : THROW_CCE();
    return replaceChildOperation.j42_1;
  };
  protoOf(NodeChildReplaceReplaceRule).l4g = function (op) {
    var replaceChildOperation = op instanceof ReplaceChildOperation ? op : THROW_CCE();
    return replaceChildOperation.i42_1;
  };
  protoOf(NodeChildReplaceReplaceRule).n4g = function (op1, op2) {
    var replace1 = op1 instanceof ReplaceChildOperation ? op1 : THROW_CCE();
    var replace2 = op2 instanceof ReplaceChildOperation ? op2 : THROW_CCE();
    var oldData = replace1.i42_1;
    var newData = replace2.j42_1;
    var tmp;
    if (oldData.equals(newData)) {
      tmp = new NopOperation();
    } else {
      var replaceChildOperation = new ReplaceChildOperation(oldData, newData);
      tmp = isInterface(replaceChildOperation, Operation) ? replaceChildOperation : THROW_CCE();
    }
    return tmp;
  };
  function NopOperationRule() {
    BaseMergeOperationsRule.call(this);
  }
  protoOf(NopOperationRule).n4g = function (op1, op2) {
    var tmp;
    if (op1 instanceof NopOperation) {
      tmp = op2;
    } else {
      tmp = op1;
    }
    return tmp;
  };
  protoOf(NopOperationRule).j4g = function (op1, op2) {
    var tmp;
    if (op1 instanceof NopOperation) {
      tmp = true;
    } else {
      tmp = op2 instanceof NopOperation;
    }
    return tmp;
  };
  function RootAddRemoveRule() {
    BaseMutuallyInverseOperationRule.call(this);
  }
  protoOf(RootAddRemoveRule).h4g = function (op) {
    return op instanceof AddRootOperation;
  };
  protoOf(RootAddRemoveRule).i4g = function (op) {
    return op instanceof RemoveRootOperation;
  };
  protoOf(RootAddRemoveRule).o4g = function (op) {
    return (op instanceof RootEntityOperation ? op : THROW_CCE()).l3w_1;
  };
  function init_2($this, rules) {
    $this.t4g_1.q(rules);
  }
  function merge($this, op1, op2) {
    if (bothAnnotated($this, op1, op2)) {
      var annotatedOp1 = op1 instanceof AnnotatedOperation ? op1 : THROW_CCE();
      var annotatedOp2 = op2 instanceof AnnotatedOperation ? op2 : THROW_CCE();
      if (sameAnnotator($this, annotatedOp1, annotatedOp2)) {
        return annotatedOp1.u4g(merge($this, annotatedOp1.e4e_1, annotatedOp2.e4e_1));
      }
    }
    return tryMergeSame($this, op1, op2);
  }
  function tryMergeSame($this, op1, op2) {
    var _iterator__ex2g4s = $this.t4g_1.m();
    while (_iterator__ex2g4s.n()) {
      var mergeRule = _iterator__ex2g4s.o();
      if (mergeRule.j4g(op1, op2)) {
        return mergeRule.m4g(op1, op2);
      }
    }
    return CompositeOperation_init_$Create$([op1, op2]);
  }
  function bothAnnotated($this, op1, op2) {
    var tmp;
    if (op1 instanceof AnnotatedOperation) {
      tmp = op2 instanceof AnnotatedOperation;
    } else {
      tmp = false;
    }
    return tmp;
  }
  function sameAnnotator($this, op1, op2) {
    return op1.c4e_1 == op2.c4e_1;
  }
  function Companion_60() {
  }
  protoOf(Companion_60).b3c = function () {
    var merger = new SimpleAnnotatorPreservingOperationsMerger();
    var mergeRules = ArrayList_init_$Create$();
    mergeRules.j(new MergeTargetedOperationsRule(merger));
    mergeRules.j(new MergeSetValueOperationsRule());
    mergeRules.j(new NopOperationRule());
    mergeRules.j(new NodeChildAddRemoveRule());
    mergeRules.j(new NodeChildAddReplaceRule());
    mergeRules.j(new NodeChildReplaceRemoveRule());
    mergeRules.j(new NodeChildReplaceReplaceRule());
    mergeRules.j(new EntityChildAddRemoveRule());
    mergeRules.j(new RootAddRemoveRule());
    mergeRules.j(new ModelAddRemoveRule());
    mergeRules.j(new MergeCompositeOperationsRule(merger));
    init_2(merger, mergeRules);
    return merger;
  };
  var Companion_instance_60;
  function Companion_getInstance_60() {
    return Companion_instance_60;
  }
  function SimpleAnnotatorPreservingOperationsMerger() {
    this.t4g_1 = ArrayList_init_$Create$();
  }
  protoOf(SimpleAnnotatorPreservingOperationsMerger).v4g = function (operations) {
    if (operations.s()) {
      return new NopOperation();
    }
    var resultingOp = null;
    var _iterator__ex2g4s = operations.m();
    while (_iterator__ex2g4s.n()) {
      var op = _iterator__ex2g4s.o();
      var tmp;
      if (resultingOp == null) {
        tmp = op;
      } else {
        tmp = merge(this, resultingOp, op);
      }
      resultingOp = tmp;
    }
    return ensureNotNull(resultingOp);
  };
  protoOf(SimpleAnnotatorPreservingOperationsMerger).s3x = function (operations) {
    return this.v4g(operations);
  };
  function NodeAssemblyOperationBuilder(node) {
    this.c40_1 = node;
    this.d40_1 = null;
    this.e40_1 = null;
  }
  protoOf(NodeAssemblyOperationBuilder).f40 = function () {
    var operations = ArrayList_init_$Create$();
    var _iterator__ex2g4s = this.c40_1.c3e().m();
    $l$loop: while (_iterator__ex2g4s.n()) {
      var propId = _iterator__ex2g4s.o();
      if (!(this.d40_1 == null) && equals(this.d40_1, propId)) {
        continue $l$loop;
      }
      var property = this.c40_1.d3n(propId).uv();
      if (!(property == null)) {
        operations.j(new ChangePropertyOperation(propId, new SetValueOperation(null, property)));
      }
    }
    var _iterator__ex2g4s_0 = this.c40_1.z3d().m();
    while (_iterator__ex2g4s_0.n()) {
      var childId = _iterator__ex2g4s_0.o();
      var curIndex = 0;
      var _iterator__ex2g4s_1 = this.c40_1.p3m(childId).m();
      $l$loop_0: while (_iterator__ex2g4s_1.n()) {
        var child = _iterator__ex2g4s_1.o();
        if (!(this.e40_1 == null) && equals(this.e40_1, childId)) {
          continue $l$loop_0;
        }
        var id = NodeUtil_instance.c3n(child);
        var addOperation = AddChildOperation_init_$Create$_1(child.e3m_1, id, curIndex, childId.f3g());
        var childAssemblyOperation = (new NodeAssemblyOperationBuilder(child)).f40();
        var _unary__edvuaz = curIndex;
        curIndex = _unary__edvuaz + 1 | 0;
        operations.j(new ChildListOperation(childId, CompositeOperation_init_$Create$([addOperation, new ChangeChildOperation_0(id, _unary__edvuaz, childAssemblyOperation)])));
      }
    }
    return Companion_instance_68.b40(operations);
  };
  protoOf(NodeAssemblyOperationBuilder).w4g = function (propertyId) {
    this.d40_1 = propertyId;
  };
  protoOf(NodeAssemblyOperationBuilder).x4g = function (outerModifiedChildId) {
    this.e40_1 = outerModifiedChildId;
  };
  function OperationBuilder_0() {
  }
  protoOf(OperationBuilder_0).y4g = function (childId, node, index) {
    var id = NodeUtil_instance.c3n(node);
    var addOp = AddChildOperation_init_$Create$_1(node.e3m_1, id, index, childId.f3g());
    var assembleOp = new ChangeChildOperation_0(id, index, (new NodeAssemblyOperationBuilder(node)).f40());
    var tmp;
    if (assembleOp.r3x()) {
      tmp = addOp;
    } else {
      tmp = CompositeOperation_init_$Create$([addOp, assembleOp]);
    }
    return tmp;
  };
  protoOf(OperationBuilder_0).z4g = function (childId, node, index) {
    var id = NodeUtil_instance.c3n(node);
    var disassembleOp = new ChangeChildOperation_0(id, index, (new NodeAssemblyOperationBuilder(node)).f40().q3z());
    var removeOp = RemoveChildOperation_init_$Create$_1(node.e3m_1, id, index, childId.f3g());
    var tmp;
    if (disassembleOp.r3x()) {
      tmp = removeOp;
    } else {
      tmp = CompositeOperation_init_$Create$([disassembleOp, removeOp]);
    }
    return tmp;
  };
  protoOf(OperationBuilder_0).a4h = function (childId, node, index) {
    var op = this.y4g(childId, node, index);
    return new ChildListOperation(childId, op);
  };
  protoOf(OperationBuilder_0).b4h = function (childId, node, index) {
    var op = this.z4g(childId, node, index);
    return new ChildListOperation(childId, op);
  };
  protoOf(OperationBuilder_0).c4h = function (oldNode, newNode, id, index) {
    var oldNodeId = NodeUtil_instance.c3n(oldNode);
    var newNodeId = NodeUtil_instance.c3n(newNode);
    return CompositeOperation_init_$Create$([new ChangeChildOperation_0(oldNodeId, index, (new NodeAssemblyOperationBuilder(oldNode)).f40().q3z()), ReplaceChildOperation_init_$Create$(oldNode.e3m_1, oldNodeId, newNode.e3m_1, newNodeId, index, id.f3g()), new ChangeChildOperation_0(newNodeId, index, (new NodeAssemblyOperationBuilder(newNode)).f40())]);
  };
  protoOf(OperationBuilder_0).d4h = function (id, oldNode, newNode, index) {
    return new ChildListOperation(id, this.c4h(oldNode, newNode, id, index));
  };
  protoOf(OperationBuilder_0).e4h = function (event) {
    var child = event.r3u_1;
    return new AddChildSplitChildCollectionOperation(child.e3m_1, event.p3t_1.z3n(), child.z3n(), event.q3u_1, event.r3t_1, event.q3t_1, event.s3t_1);
  };
  protoOf(OperationBuilder_0).f4h = function (event) {
    var child = event.r3u_1;
    return new MergeChildCollectionRemoveChildOperation(child.e3m_1, child.z3n(), event.k3u_1.z3n(), event.q3u_1, event.m3u_1, event.n3u_1, event.l3u_1);
  };
  var OperationBuilder_instance_0;
  function OperationBuilder_getInstance_0() {
    return OperationBuilder_instance_0;
  }
  function AddChildOperation_init_$Init$_1(conceptId, nodeId, index, isSingleRole, $this) {
    ChildOperation_init_$Init$_0(conceptId, nodeId, index, isSingleRole, $this);
    AddChildOperation_0.call($this);
    return $this;
  }
  function AddChildOperation_init_$Create$_1(conceptId, nodeId, index, isSingleRole) {
    return AddChildOperation_init_$Init$_1(conceptId, nodeId, index, isSingleRole, objectCreate(protoOf(AddChildOperation_0)));
  }
  function AddChildOperation_init_$Init$_2(data, $this) {
    ChildOperation_0.call($this, data);
    AddChildOperation_0.call($this);
    return $this;
  }
  function AddChildOperation_init_$Create$_2(data) {
    return AddChildOperation_init_$Init$_2(data, objectCreate(protoOf(AddChildOperation_0)));
  }
  protoOf(AddChildOperation_0).o4d = function () {
    return this.l4h_1;
  };
  protoOf(AddChildOperation_0).q4d = function () {
    return this.m4h_1;
  };
  protoOf(AddChildOperation_0).y2 = function () {
    return 'addChild';
  };
  protoOf(AddChildOperation_0).n4h = function (otherOp, server) {
    if (otherOp instanceof AddChildOperation_0) {
      if (NodeUtil_instance.f3w(this.v3w(), otherOp.v3w())) {
        this.p4h(otherOp);
        return new NopOperation();
      } else if (this.s4h_1) {
        this.c4i(otherOp);
        return server ? new NopOperation() : CompositeOperation_init_$Create$([this.q3z(), otherOp]);
      }
    } else {
      if (otherOp instanceof ReplaceChildOperation) {
        if (NodeUtil_instance.f3w(this.v3w(), otherOp.b4i())) {
          this.p4h(otherOp.o4h());
          // Inline function 'kotlin.check' call
          if (!!this.s4h_1) {
            var message = ChildOperationMessages_instance.t4h(this, otherOp);
            throw IllegalStateException_init_$Create$_0(toString_1(message));
          }
          return otherOp.u4h().p4d(this.m3p() + 1 | 0);
        }
      }
    }
    return protoOf(ChildOperation_0).n4h.call(this, otherOp, server);
  };
  protoOf(AddChildOperation_0).f43 = function (otherOp, server) {
    return this.n4h(otherOp, server);
  };
  protoOf(AddChildOperation_0).d4i = function (model, nodeFactory) {
    // Inline function 'kotlin.check' call
    if (!(!this.s4h_1 || model.s())) {
      var message = 'Add into not empty single-item child list';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    var node = nodeFactory.d3m(this.f3t(), this.v3w());
    model.m2(this.m3p(), node);
    return model;
  };
  protoOf(AddChildOperation_0).y3x = function (model, nodeFactory) {
    return this.d4i((!(model == null) ? isInterface(model, KtMutableList) : false) ? model : THROW_CCE(), nodeFactory);
  };
  protoOf(AddChildOperation_0).q3z = function () {
    return RemoveChildOperation_init_$Create$_2(this.t3w_1);
  };
  protoOf(AddChildOperation_0).p4d = function (newIndex) {
    return AddChildOperation_init_$Create$_1(this.f3t(), this.v3w(), newIndex, this.s4h_1);
  };
  protoOf(AddChildOperation_0).e4i = function (model, ops, nodeFactory) {
    return (new AddChildOperationExecutor_0(nodeFactory)).o43(model, ops);
  };
  protoOf(AddChildOperation_0).p43 = function (model, ops, nodeFactory) {
    return this.e4i((!(model == null) ? isInterface(model, KtMutableList) : false) ? model : THROW_CCE(), ops, nodeFactory);
  };
  function AddChildOperation_0() {
    this.l4h_1 = Priority_NORMAL_getInstance();
    this.m4h_1 = 1;
  }
  function BaseListItemOperation(index, isSingleRole) {
    BaseOperation.call(this);
    this.r4h_1 = index;
    this.s4h_1 = isSingleRole;
  }
  protoOf(BaseListItemOperation).m3p = function () {
    return this.r4h_1;
  };
  protoOf(BaseListItemOperation).n4h = function (otherOp, server) {
    if (otherOp instanceof BaseListItemOperation) {
      if (!(this.s4h_1 === otherOp.s4h_1)) {
        throw IllegalStateException_init_$Create$_0("Mismatching 'single role' flag");
      }
      var tmp = new IndexedOperationTransformer();
      return tmp.r4d(this, isInterface(otherOp, IndexedOperation) ? otherOp : THROW_CCE(), server);
    }
    return protoOf(BaseOperation).f43.call(this, otherOp, server);
  };
  protoOf(BaseListItemOperation).f43 = function (otherOp, server) {
    return this.n4h(otherOp, server);
  };
  protoOf(BaseListItemOperation).h4i = function (op) {
    if (!(this.m3p() === op.m3p())) {
      throw IllegalStateException_init_$Create$_0('Unequal indices: current index=' + this.m3p() + ', other index=' + op.m3p());
    }
  };
  protoOf(BaseListItemOperation).c4i = function (op) {
    if (!(this.s4h_1 === op.s4h_1)) {
      throw IllegalStateException_init_$Create$_0("Mismatching 'single role' flags");
    }
  };
  function rollbackCurrentThenOtherOp($this, conceptId, otherOp) {
    var temp = RawNodeFactory_instance.d3m(conceptId, $this.l4i_1);
    temp = $this.s3z().y3x(temp, RawNodeFactory_instance);
    var disassemble = (new NodeAssemblyOperationBuilder(temp)).f40().q3z();
    var changeChildOperation = new ChangeChildOperation_0($this.l4i_1, $this.l3p(), disassemble);
    return CompositeOperation_init_$Create$([changeChildOperation, otherOp]);
  }
  function assertEqualsCurrentId($this, otherId) {
    // Inline function 'kotlin.check' call
    if (!NodeUtil_instance.e3w($this.l4i_1, otherId)) {
      var message = 'Unequal ids: ' + toString_0($this.l4i_1) + ', ' + toString_0(otherId);
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
  }
  function ChangeChildOperation_0(nodeId, childIndex, op) {
    TargetedOperation.call(this, childIndex, op);
    this.l4i_1 = nodeId;
  }
  protoOf(ChangeChildOperation_0).y2 = function () {
    return 'changeChild';
  };
  protoOf(ChangeChildOperation_0).m4i = function (source) {
    return source.r(this.l3p());
  };
  protoOf(ChangeChildOperation_0).b44 = function (source) {
    return this.m4i((!(source == null) ? isInterface(source, KtMutableList) : false) ? source : THROW_CCE());
  };
  protoOf(ChangeChildOperation_0).n4i = function (newIndex) {
    return new ChangeChildOperation_0(this.l4i_1, newIndex, this.s3z());
  };
  protoOf(ChangeChildOperation_0).n4h = function (otherOp, server) {
    if (otherOp instanceof RemoveChildOperation_0) {
      if (otherOp.m3p() === this.l3p()) {
        assertEqualsCurrentId(this, otherOp.v3w());
        return rollbackCurrentThenOtherOp(this, otherOp.f3t(), otherOp);
      }
    }
    if (otherOp instanceof ReplaceChildOperation) {
      if (otherOp.m3p() === this.l3p()) {
        assertEqualsCurrentId(this, otherOp.o4i());
        return rollbackCurrentThenOtherOp(this, otherOp.m42(), otherOp);
      }
    }
    return protoOf(TargetedOperation).y43.call(this, otherOp, server);
  };
  protoOf(ChangeChildOperation_0).f43 = function (otherOp, server) {
    return this.n4h(otherOp, server);
  };
  protoOf(ChangeChildOperation_0).y43 = function (otherOp, server) {
    return this.n4h(otherOp, server);
  };
  protoOf(ChangeChildOperation_0).p4i = function (otherOp, server) {
    if (otherOp instanceof RemoveChildOperation_0) {
      if (otherOp.m3p() === this.l3p()) {
        assertEqualsCurrentId(this, otherOp.v3w());
        return new NopOperation();
      }
      if (otherOp.m3p() < this.l3p()) {
        return new ChangeChildOperation_0(this.l4i_1, this.l3p() - 1 | 0, this.s3z());
      }
    }
    if (otherOp instanceof AddChildOperation_0) {
      if (otherOp.m3p() <= this.l3p()) {
        return new ChangeChildOperation_0(this.l4i_1, this.l3p() + 1 | 0, this.s3z());
      }
    }
    if (otherOp instanceof ReplaceChildOperation) {
      if (otherOp.m3p() === this.l3p()) {
        assertEqualsCurrentId(this, otherOp.o4i());
        return new NopOperation();
      }
    }
    return protoOf(TargetedOperation).q43.call(this, otherOp, server);
  };
  protoOf(ChangeChildOperation_0).q43 = function (otherOp, server) {
    return this.p4i(otherOp, server);
  };
  protoOf(ChangeChildOperation_0).q4i = function (op) {
    return new ChangeChildOperation_0(this.l4i_1, this.l3p(), op);
  };
  protoOf(ChangeChildOperation_0).x43 = function (op) {
    return this.q4i(op);
  };
  protoOf(ChangeChildOperation_0).r4i = function (model, customExecute, nodeFactory) {
    var node = this.m4i(model);
    // Inline function 'kotlin.check' call
    if (!NodeUtil_instance.c3w(ensureNotNull(node), this.l4i_1)) {
      var message = MessageBundle_instance.h3n(this.l4i_1, NodeUtil_instance.c3n(node));
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    this.e44(node, customExecute, nodeFactory);
    return model;
  };
  protoOf(ChangeChildOperation_0).c49 = function (model, customExecute, nodeFactory) {
    return this.r4i((!(model == null) ? isInterface(model, KtMutableList) : false) ? model : THROW_CCE(), customExecute, nodeFactory);
  };
  protoOf(ChangeChildOperation_0).c44 = function (model, customExecute, nodeFactory) {
    return this.r4i((!(model == null) ? isInterface(model, KtMutableList) : false) ? model : THROW_CCE(), customExecute, nodeFactory);
  };
  protoOf(ChangeChildOperation_0).e4i = function (model, ops, nodeFactory) {
    return (new ChangeChildOperationExecutor_0(nodeFactory)).t4i(model, ops);
  };
  protoOf(ChangeChildOperation_0).p43 = function (model, ops, nodeFactory) {
    return this.e4i((!(model == null) ? isInterface(model, KtMutableList) : false) ? model : THROW_CCE(), ops, nodeFactory);
  };
  protoOf(ChangeChildOperation_0).toString = function () {
    return protoOf(TargetedOperation).toString.call(this) + '; id = ' + toString_0(this.l4i_1);
  };
  protoOf(ChangeChildOperation_0).s43 = function (indent) {
    return indent + this.y2() + '[id = ' + toString_0(this.l4i_1) + ';r = ' + this.l3p() + ';o =\n' + this.s3z().s43(indent + '  ') + indent + ']\n';
  };
  function ChildOperation_init_$Init$_0(conceptId, nodeId, index, isSingleRole, $this) {
    ChildOperation_0.call($this, new NodeChildOperationData(isSingleRole, index, conceptId, nodeId));
    return $this;
  }
  function ChildOperation_0(operationData) {
    BaseListItemOperation.call(this, operationData.v4i_1, operationData.u4i_1);
    this.t3w_1 = operationData;
    this.u3w_1 = 1;
    // Inline function 'kotlin.require' call
    if (!NodeUtil_instance.b3w(this.t3w_1.w4i_1, this.t3w_1.x4i_1)) {
      var message = 'concept id ' + this.t3w_1.w4i_1.toString() + " doesn't permit " + toString_0(this.t3w_1.x4i_1) + ' node id';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
  }
  protoOf(ChildOperation_0).v3w = function () {
    return this.t3w_1.x4i_1;
  };
  protoOf(ChildOperation_0).f3t = function () {
    return this.t3w_1.w4i_1;
  };
  protoOf(ChildOperation_0).a = function () {
    return this.u3w_1;
  };
  protoOf(ChildOperation_0).n4h = function (otherOp, server) {
    if (otherOp instanceof ChildOperation_0) {
      // Inline function 'kotlin.check' call
      if (!!NodeUtil_instance.f3w(this.v3w(), otherOp.v3w())) {
        var tmp0_safe_receiver = this.v3w();
        var message = "Equal ids: '" + (tmp0_safe_receiver == null ? null : tmp0_safe_receiver.q36_1) + "', expected: different";
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      }
    }
    return protoOf(BaseListItemOperation).n4h.call(this, otherOp, server);
  };
  protoOf(ChildOperation_0).f43 = function (otherOp, server) {
    return this.n4h(otherOp, server);
  };
  protoOf(ChildOperation_0).toString = function () {
    return this.y2() + '[n = ' + toString_0(this.v3w()) + ';i = ' + this.m3p() + ']';
  };
  protoOf(ChildOperation_0).f4i = function (op) {
    // Inline function 'kotlin.check' call
    if (!this.f3t().equals(op.f3t())) {
      var message = MessageBundle_instance.e3n(this.f3t(), op.f3t());
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
  };
  protoOf(ChildOperation_0).g4i = function (op) {
    // Inline function 'kotlin.check' call
    if (!(this.v3w() == null || equals(this.v3w(), op.v3w()))) {
      var message = 'Unequal nodeIds: current nodeId=' + toString_0(this.v3w()) + ', other nodeId=' + toString_0(op.v3w());
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
  };
  protoOf(ChildOperation_0).p4h = function (op) {
    this.h4i(op);
    this.c4i(op);
    this.f4i(op);
  };
  protoOf(ChildOperation_0).y4i = function (op) {
    this.g4i(op);
    this.c4i(op);
    this.f4i(op);
  };
  protoOf(ChildOperation_0).z4i = function (op) {
    this.g4i(op);
    this.h4i(op);
    this.c4i(op);
    this.f4i(op);
  };
  function ChildOperationMessages() {
  }
  protoOf(ChildOperationMessages).t4h = function (addOp, replaceOp) {
    return 'Simultaneous addition and replacement of singleRole=true list item: ' + addOp.toString() + ', ' + replaceOp.toString();
  };
  var ChildOperationMessages_instance;
  function ChildOperationMessages_getInstance() {
    return ChildOperationMessages_instance;
  }
  function NodeChildOperationData(isSingle, index, conceptId, nodeId) {
    this.u4i_1 = isSingle;
    this.v4i_1 = index;
    this.w4i_1 = conceptId;
    this.x4i_1 = nodeId;
  }
  protoOf(NodeChildOperationData).toString = function () {
    return 'NodeChildOperationData(isSingle=' + this.u4i_1 + ', index=' + this.v4i_1 + ', conceptId=' + this.w4i_1.toString() + ', nodeId=' + toString_0(this.x4i_1) + ')';
  };
  protoOf(NodeChildOperationData).hashCode = function () {
    var result = getBooleanHashCode(this.u4i_1);
    result = imul(result, 31) + this.v4i_1 | 0;
    result = imul(result, 31) + this.w4i_1.hashCode() | 0;
    result = imul(result, 31) + (this.x4i_1 == null ? 0 : this.x4i_1.hashCode()) | 0;
    return result;
  };
  protoOf(NodeChildOperationData).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof NodeChildOperationData))
      return false;
    if (!(this.u4i_1 === other.u4i_1))
      return false;
    if (!(this.v4i_1 === other.v4i_1))
      return false;
    if (!this.w4i_1.equals(other.w4i_1))
      return false;
    if (!equals(this.x4i_1, other.x4i_1))
      return false;
    return true;
  };
  function RemoveChildOperation_init_$Init$_1(conceptId, nodeId, removeIndex, isSingleRole, $this) {
    ChildOperation_init_$Init$_0(conceptId, nodeId, removeIndex, isSingleRole, $this);
    RemoveChildOperation_0.call($this);
    return $this;
  }
  function RemoveChildOperation_init_$Create$_1(conceptId, nodeId, removeIndex, isSingleRole) {
    return RemoveChildOperation_init_$Init$_1(conceptId, nodeId, removeIndex, isSingleRole, objectCreate(protoOf(RemoveChildOperation_0)));
  }
  function RemoveChildOperation_init_$Init$_2(data, $this) {
    ChildOperation_0.call($this, data);
    RemoveChildOperation_0.call($this);
    return $this;
  }
  function RemoveChildOperation_init_$Create$_2(data) {
    return RemoveChildOperation_init_$Init$_2(data, objectCreate(protoOf(RemoveChildOperation_0)));
  }
  protoOf(RemoveChildOperation_0).q4d = function () {
    return this.a4i_1;
  };
  protoOf(RemoveChildOperation_0).y2 = function () {
    return 'removeChild';
  };
  protoOf(RemoveChildOperation_0).n4h = function (otherOp, server) {
    if (otherOp instanceof RemoveChildOperation_0) {
      if (this.m3p() === otherOp.m3p()) {
        this.y4i(otherOp);
        return new NopOperation();
      }
      // Inline function 'kotlin.check' call
      if (!!NodeUtil_instance.f3w(this.v3w(), otherOp.v3w())) {
        var message = 'Unequal indexes: ' + this.m3p() + ' and ' + otherOp.m3p();
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      }
    }
    return protoOf(ChildOperation_0).n4h.call(this, otherOp, server);
  };
  protoOf(RemoveChildOperation_0).f43 = function (otherOp, server) {
    return this.n4h(otherOp, server);
  };
  protoOf(RemoveChildOperation_0).q3z = function () {
    return AddChildOperation_init_$Create$_2(this.t3w_1);
  };
  protoOf(RemoveChildOperation_0).d4i = function (model, nodeFactory) {
    // Inline function 'kotlin.check' call
    if (!(!this.s4h_1 || model.p() === 1)) {
      var message = "'Single role' list size=" + model.p();
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    var node = model.r(this.m3p());
    // Inline function 'kotlin.check' call
    if (!this.f3t().equals(node.e3m_1)) {
      var message_0 = MessageBundle_instance.e3n(this.f3t(), node.e3m_1);
      throw IllegalStateException_init_$Create$_0(toString_1(message_0));
    }
    // Inline function 'kotlin.check' call
    if (!NodeUtil_instance.c3w(node, this.v3w())) {
      var message_1 = MessageBundle_instance.h3n(this.v3w(), node.z3n());
      throw IllegalStateException_init_$Create$_0(toString_1(message_1));
    }
    // Inline function 'kotlin.check' call
    if (!node.w2m()) {
      var message_2 = MessageBundle_instance.g3n(this.v3w());
      throw IllegalStateException_init_$Create$_0(toString_1(message_2));
    }
    model.n2(this.m3p());
    return model;
  };
  protoOf(RemoveChildOperation_0).y3x = function (model, nodeFactory) {
    return this.d4i((!(model == null) ? isInterface(model, KtMutableList) : false) ? model : THROW_CCE(), nodeFactory);
  };
  protoOf(RemoveChildOperation_0).p4d = function (newIndex) {
    return RemoveChildOperation_init_$Create$_1(this.f3t(), this.v3w(), newIndex, this.s4h_1);
  };
  protoOf(RemoveChildOperation_0).a4j = function (op) {
    throw IllegalStateException_init_$Create$();
  };
  protoOf(RemoveChildOperation_0).s4d = function (op) {
    return this.a4j(op);
  };
  protoOf(RemoveChildOperation_0).b4j = function (replaceRemovedItem) {
    if (replaceRemovedItem instanceof ReplaceChildOperation) {
      this.z4i(replaceRemovedItem.u4h());
      return RemoveChildOperation_init_$Create$_1(replaceRemovedItem.n42(), replaceRemovedItem.b4i(), this.m3p(), this.s4h_1);
    }
    throw IllegalArgumentException_init_$Create$();
  };
  protoOf(RemoveChildOperation_0).t4d = function (replaceRemovedItem) {
    return this.b4j(replaceRemovedItem);
  };
  function RemoveChildOperation_0() {
    this.a4i_1 = -1;
  }
  function ensureSameIndex($this, oldData, newData) {
    // Inline function 'kotlin.check' call
    if (!(oldData.v4i_1 === newData.v4i_1)) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    return oldData.v4i_1;
  }
  function ensureSameSingleRole($this, oldData, newData) {
    // Inline function 'kotlin.check' call
    if (!(oldData.u4i_1 === newData.u4i_1)) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    return oldData.u4i_1;
  }
  function ReplaceChildOperation_init_$Init$(oldConceptId, oldNodeId, newConceptId, newNodeId, index, isSingleRole, $this) {
    ReplaceChildOperation.call($this, new NodeChildOperationData(isSingleRole, index, oldConceptId, oldNodeId), new NodeChildOperationData(isSingleRole, index, newConceptId, newNodeId));
    return $this;
  }
  function ReplaceChildOperation_init_$Create$(oldConceptId, oldNodeId, newConceptId, newNodeId, index, isSingleRole) {
    return ReplaceChildOperation_init_$Init$(oldConceptId, oldNodeId, newConceptId, newNodeId, index, isSingleRole, objectCreate(protoOf(ReplaceChildOperation)));
  }
  function Companion_61() {
  }
  var Companion_instance_61;
  function Companion_getInstance_61() {
    return Companion_instance_61;
  }
  function ReplaceChildOperation(oldOperationData, newOperationData) {
    BaseListItemOperation.call(this, ensureSameIndex(Companion_instance_61, oldOperationData, newOperationData), ensureSameSingleRole(Companion_instance_61, oldOperationData, newOperationData));
    this.i42_1 = oldOperationData;
    this.j42_1 = newOperationData;
    this.k42_1 = 1;
    this.l42_1 = 0;
  }
  protoOf(ReplaceChildOperation).m42 = function () {
    return this.i42_1.w4i_1;
  };
  protoOf(ReplaceChildOperation).o4i = function () {
    return this.i42_1.x4i_1;
  };
  protoOf(ReplaceChildOperation).n42 = function () {
    return this.j42_1.w4i_1;
  };
  protoOf(ReplaceChildOperation).b4i = function () {
    return this.j42_1.x4i_1;
  };
  protoOf(ReplaceChildOperation).a = function () {
    return this.k42_1;
  };
  protoOf(ReplaceChildOperation).q4d = function () {
    return this.l42_1;
  };
  protoOf(ReplaceChildOperation).u4h = function () {
    return RemoveChildOperation_init_$Create$_2(this.i42_1);
  };
  protoOf(ReplaceChildOperation).o4h = function () {
    return AddChildOperation_init_$Create$_2(this.j42_1);
  };
  protoOf(ReplaceChildOperation).n4h = function (otherOp, server) {
    if (otherOp instanceof ReplaceChildOperation) {
      if (this.m3p() === otherOp.m3p() && NodeUtil_instance.f3w(this.b4i(), otherOp.b4i())) {
        this.u4h().y4i(otherOp.u4h());
        this.o4h().f4i(otherOp.o4h());
        return new NopOperation();
      }
    } else {
      if (otherOp instanceof AddChildOperation_0) {
        if (NodeUtil_instance.f3w(this.b4i(), otherOp.v3w())) {
          this.o4h().p4h(otherOp);
          // Inline function 'kotlin.check' call
          if (!!this.s4h_1) {
            var message = ChildOperationMessages_instance.t4h(otherOp, this);
            throw IllegalStateException_init_$Create$_0(toString_1(message));
          }
          return new NopOperation();
        }
      }
    }
    return protoOf(BaseListItemOperation).n4h.call(this, otherOp, server);
  };
  protoOf(ReplaceChildOperation).f43 = function (otherOp, server) {
    return this.n4h(otherOp, server);
  };
  protoOf(ReplaceChildOperation).p4d = function (newIndex) {
    return ReplaceChildOperation_init_$Create$(this.i42_1.w4i_1, this.i42_1.x4i_1, this.j42_1.w4i_1, this.j42_1.x4i_1, newIndex, this.s4h_1);
  };
  protoOf(ReplaceChildOperation).b4j = function (replaceOldItem) {
    if (replaceOldItem instanceof ReplaceChildOperation) {
      this.u4h().z4i(replaceOldItem.u4h());
      return new ReplaceChildOperation(replaceOldItem.j42_1, this.j42_1);
    }
    throw IllegalArgumentException_init_$Create$_0(toString_1(replaceOldItem));
  };
  protoOf(ReplaceChildOperation).t4d = function (replaceOldItem) {
    return this.b4j(replaceOldItem);
  };
  protoOf(ReplaceChildOperation).d4i = function (model, nodeFactory) {
    // Inline function 'kotlin.check' call
    if (!(!this.s4h_1 || model.p() === 1)) {
      var message = "'Single role' list size=" + model.p();
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    // Inline function 'kotlin.check' call
    if (!(model.p() > this.m3p())) {
      var message_0 = 'Child list does not contain element ' + this.m3p();
      throw IllegalStateException_init_$Create$_0(toString_1(message_0));
    }
    var oldNode = model.r(this.m3p());
    var oldConceptId = this.i42_1.w4i_1;
    // Inline function 'kotlin.check' call
    if (!oldConceptId.equals(oldNode.e3m_1)) {
      var message_1 = MessageBundle_instance.e3n(oldConceptId, oldNode.e3m_1);
      throw IllegalStateException_init_$Create$_0(toString_1(message_1));
    }
    var oldNodeId = this.i42_1.x4i_1;
    // Inline function 'kotlin.check' call
    if (!NodeUtil_instance.c3w(oldNode, oldNodeId)) {
      var message_2 = MessageBundle_instance.h3n(oldNodeId, oldNode.z3n());
      throw IllegalStateException_init_$Create$_0(toString_1(message_2));
    }
    // Inline function 'kotlin.check' call
    if (!oldNode.w2m()) {
      var message_3 = "Cannot replace when not empty, id='" + ensureNotNull(oldNodeId).q36_1 + "'";
      throw IllegalStateException_init_$Create$_0(toString_1(message_3));
    }
    model.l2(this.m3p(), nodeFactory.d3m(this.j42_1.w4i_1, this.j42_1.x4i_1));
    return model;
  };
  protoOf(ReplaceChildOperation).y3x = function (model, nodeFactory) {
    return this.d4i((!(model == null) ? isInterface(model, KtMutableList) : false) ? model : THROW_CCE(), nodeFactory);
  };
  protoOf(ReplaceChildOperation).q3z = function () {
    return new ReplaceChildOperation(this.j42_1, this.i42_1);
  };
  protoOf(ReplaceChildOperation).toString = function () {
    return 'replaceChild[oldN = ' + toString_0(this.i42_1.x4i_1) + ';newN = ' + toString_0(this.j42_1.x4i_1) + ';i = ' + this.m3p() + ']';
  };
  function InPlaceNodeDiffBuilder(source, target) {
    NodeDiffBuilder.call(this, source, target);
  }
  protoOf(InPlaceNodeDiffBuilder).f4j = function (source) {
    return source.z3d();
  };
  protoOf(InPlaceNodeDiffBuilder).g4j = function (source) {
    return source.c3e();
  };
  function exists($this, nodeId) {
    return !($this.p4j_1.g3o(nodeId) == null);
  }
  function neverExisted($this, nodeId) {
    return !$this.q4j_1.t(nodeId) && $this.p4j_1.g3o(nodeId) == null;
  }
  function getInsertionPoint($this, toInsert) {
    var parent = toInsert.d3o();
    return getModified($this, ensureNotNull(parent));
  }
  function getModified($this, node) {
    if (node.a3o()) {
      return safeGet($this, node.z3n());
    }
    var root = $this.p4j_1.k3e_1;
    return Companion_instance_62.r4j(node, root);
  }
  function safeGet($this, nodeId) {
    var tmp0_elvis_lhs = $this.p4j_1.g3o(nodeId);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalStateException_init_$Create$_0('No node for id=' + nodeId.toString());
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function ModifiedSource$addChildAndSplitChildCollection$disposable$1($outerEvent) {
    this.s4j_1 = $outerEvent;
    ModelAdapter.call(this);
  }
  protoOf(ModifiedSource$addChildAndSplitChildCollection$disposable$1).s3i = function (event) {
    this.s4j_1._v = event;
  };
  function ModifiedSource$mergeChildCollectionAndRemoveChild$disposable$1($outerEvent) {
    this.t4j_1 = $outerEvent;
    ModelAdapter.call(this);
  }
  protoOf(ModifiedSource$mergeChildCollectionAndRemoveChild$disposable$1).t3i = function (event) {
    this.t4j_1._v = event;
  };
  function ModifiedSource(origin) {
    this.q4j_1 = HashSet_init_$Create$();
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.require' call
    if (!origin.a3o()) {
      var message = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    this.p4j_1 = new Model(origin.h3o());
  }
  protoOf(ModifiedSource).u4j = function (node) {
    return node.a3o() && exists(this, node.z3n());
  };
  protoOf(ModifiedSource).v4j = function (node) {
    return node.a3o() && neverExisted(this, node.z3n());
  };
  protoOf(ModifiedSource).w4j = function (node, index) {
    var tmp0_elvis_lhs = getInsertionPoint(this, node);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalStateException_init_$Create$_0('Parent for ' + node.toString() + ' not found in modified source');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var parent = tmp;
    parent.p3m(ensureNotNull(node.l3p())).m2(index, node.h3o());
  };
  protoOf(ModifiedSource).x4j = function (node) {
    var modifiedNode = getModified(this, node);
    if (node.a3o()) {
      var subtreeIds = Nodes_instance.h3w(modifiedNode);
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!intersect(subtreeIds, this.q4j_1).s()) {
        var intersection = HashSet_init_$Create$_0(this.q4j_1);
        intersection.j2(subtreeIds);
        throw IllegalStateException_init_$Create$_0('Duplicate removal of nodes with ids: ' + intersection.toString());
      }
    }
    modifiedNode.r3p();
  };
  protoOf(ModifiedSource).y4j = function (parentId, childRole, childIndex, newChildId, conceptId, splitRole, splitIndex) {
    var parent = safeGet(this, parentId);
    var outerEvent = {_v: null};
    var disposable = this.p4j_1.z3h(new ModifiedSource$addChildAndSplitChildCollection$disposable$1(outerEvent));
    parent.x3p(RawNodeFactory_instance.d3m(conceptId, newChildId), childRole, childIndex, splitRole, splitIndex);
    disposable.zr();
    return OperationBuilder_instance_0.e4h(ensureNotNull(outerEvent._v));
  };
  protoOf(ModifiedSource).z4j = function (toRemove, mergeRole) {
    var parent = toRemove.d3o();
    var outerEvent = {_v: null};
    var disposable = this.p4j_1.z3h(new ModifiedSource$mergeChildCollectionAndRemoveChild$disposable$1(outerEvent));
    ensureNotNull(parent).z3p(toRemove, mergeRole);
    disposable.zr();
    return OperationBuilder_instance_0.f4h(ensureNotNull(outerEvent._v));
  };
  protoOf(ModifiedSource).a4k = function (source, role) {
    var modifiedSrc = getModified(this, source);
    return modifiedSrc.p3m(role);
  };
  protoOf(ModifiedSource).f4j = function (source) {
    return getModified(this, source).z3d();
  };
  protoOf(ModifiedSource).g4j = function (source) {
    return getModified(this, source).c3e();
  };
  function NodeDiff() {
  }
  protoOf(NodeDiff).t47 = function (source, target) {
    var op = this.b4k(source.k3e_1, target.k3e_1);
    return new SetModelOperation(op);
  };
  protoOf(NodeDiff).b4k = function (source, target) {
    if (!(NodeUtil_instance.c3n(source) == null)) {
      try {
        return (new SplitMergeAwareNodeDiffBuilder(source, target)).f40();
      } catch ($p) {
        if ($p instanceof Exception) {
          var e = $p;
          ThrowableHandlers_getInstance().k2r_1.j2r(e);
        } else {
          throw $p;
        }
      }
    }
    return (new InPlaceNodeDiffBuilder(source, target)).f40();
  };
  var NodeDiff_instance;
  function NodeDiff_getInstance() {
    return NodeDiff_instance;
  }
  function _get_queue__c6g84g($this) {
    var tmp = $this.j4j_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('queue');
    }
  }
  function enqueue($this, source, target) {
    var task = new MyTask(source, target);
    _get_queue__c6g84g($this).j(task);
    return task;
  }
  function buildNodeDiff($this, source, target) {
    var diff = ArrayList_init_$Create$();
    diff.q(propertiesDiff_0($this, source, target));
    diff.q(childrenDiff_0($this, source, target));
    return compose($this, diff);
  }
  function propertiesDiff_0($this, source, target) {
    var diff = ArrayList_init_$Create$();
    var srcPropertyIds = $this.g4j(source);
    var trgPropertyIds = target.c3e();
    var _iterator__ex2g4s = srcPropertyIds.m();
    while (_iterator__ex2g4s.n()) {
      var propertyId = _iterator__ex2g4s.o();
      var srcValue = source.d3n(propertyId).uv();
      if (trgPropertyIds.t(propertyId)) {
        var trgValue = target.d3n(propertyId).uv();
        if (!(srcValue == trgValue)) {
          diff.j(toSupplier($this, changePropertyOp($this, propertyId, srcValue, trgValue)));
        }
      } else {
        diff.j(toSupplier($this, changePropertyOp($this, propertyId, srcValue, null)));
      }
    }
    var _iterator__ex2g4s_0 = trgPropertyIds.m();
    while (_iterator__ex2g4s_0.n()) {
      var propertyId_0 = _iterator__ex2g4s_0.o();
      if (!srcPropertyIds.t(propertyId_0)) {
        diff.j(toSupplier($this, changePropertyOp($this, propertyId_0, null, target.d3n(propertyId_0).uv())));
      }
    }
    return diff;
  }
  function changePropertyOp($this, propertyId, srcValue, trgValue) {
    return new ChangePropertyOperation(propertyId, new SetValueOperation(srcValue, trgValue));
  }
  function childrenDiff_0($this, source, target) {
    var diff = ArrayList_init_$Create$();
    var srcChildIds = $this.f4j(source);
    var trgChildIds = target.z3d();
    var _iterator__ex2g4s = srcChildIds.m();
    while (_iterator__ex2g4s.n()) {
      var childId = _iterator__ex2g4s.o();
      var targetChildren = trgChildIds.t(childId) ? target.p3m(childId) : emptyList();
      diff.j(roleDiff($this, source, childId, targetChildren));
    }
    var _iterator__ex2g4s_0 = trgChildIds.m();
    while (_iterator__ex2g4s_0.n()) {
      var childId_0 = _iterator__ex2g4s_0.o();
      if (!srcChildIds.t(childId_0)) {
        var iterator = target.p3m(childId_0).m();
        var index = 0;
        while (iterator.n()) {
          var index_0 = index;
          index = index + 1 | 0;
          var n = iterator.o();
          diff.j(buildOperationSupplier($this, n, index_0));
        }
      }
    }
    return diff;
  }
  function destroyOperationSupplier($this, node, index) {
    return toSupplier($this, $this.l4j(ensureNotNull(node.l3p()), node, index));
  }
  function buildOperationSupplier($this, node, index) {
    return toSupplier($this, $this.m4j(node, index));
  }
  function roleDiff($this, sourceParent, role, target) {
    var p = $this.o4j(sourceParent, role, target);
    var modifiedSource = p.pg_1;
    // Inline function 'kotlin.check' call
    if (!(modifiedSource.p() === target.p())) {
      var message = 'Different length in role=' + role.toString() + ': source ' + modifiedSource.p() + ', target ' + target.p();
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    var diff = ArrayList_init_$Create$();
    diff.j(toSupplier($this, Companion_instance_68.b40(p.qg_1)));
    diff.q(childrenContentDiff($this, modifiedSource, target));
    return compose($this, diff);
  }
  function childrenContentDiff($this, modifiedSource, target) {
    var diff_0 = ArrayList_init_$Create$();
    var targetIndex = 0;
    var sourceIndex = 0;
    var _iterator__ex2g4s = modifiedSource.m();
    while (_iterator__ex2g4s.n()) {
      var s = _iterator__ex2g4s.o();
      var t = target.r(targetIndex);
      if (NodeUtil_instance.d3w(s, t)) {
        diff_0.j(diff($this, s, t, targetIndex));
        targetIndex = targetIndex + 1 | 0;
        sourceIndex = sourceIndex + 1 | 0;
      } else {
        diff_0.j(destroyOperationSupplier($this, s, sourceIndex));
      }
    }
    while (targetIndex < target.p()) {
      diff_0.j(buildOperationSupplier($this, target.r(targetIndex), targetIndex));
      targetIndex = targetIndex + 1 | 0;
    }
    return diff_0;
  }
  function diff($this, s, t, index) {
    var tmp;
    if (t.e3m_1.equals(s.e3m_1)) {
      var task = enqueue($this, s, t);
      return NodeDiffBuilder$diff$lambda(s, index, task);
    } else {
      tmp = toSupplier($this, CompositeOperation_init_$Create$([$this.k4j(s, index), $this.m4j(t, index)]));
    }
    return tmp;
  }
  function compose($this, suppliers) {
    return NodeDiffBuilder$compose$lambda(suppliers);
  }
  function toSupplier($this, op) {
    return NodeDiffBuilder$toSupplier$lambda(op);
  }
  function MyTask(source, target) {
    this.c4k_1 = source;
    this.d4k_1 = target;
    this.e4k_1 = null;
  }
  protoOf(MyTask).f4k = function () {
    var tmp0 = this.e4k_1;
    $l$block: {
      // Inline function 'kotlin.checkNotNull' call
      if (tmp0 == null) {
        var message = 'Task was not executed yet';
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      } else {
        break $l$block;
      }
    }
    return ensureNotNull(this.e4k_1)();
  };
  protoOf(MyTask).g4k = function (supplier) {
    // Inline function 'kotlin.check' call
    if (!(this.e4k_1 == null)) {
      var message = 'Supplier has been set already';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    this.e4k_1 = supplier;
  };
  function NodeDiffBuilder$diff$lambda($s, $index, $task) {
    return function () {
      return new ChildListOperation(ensureNotNull($s.l3p()), new ChangeChildOperation_0(NodeUtil_instance.c3n($s), $index, $task.f4k()));
    };
  }
  function NodeDiffBuilder$compose$lambda($suppliers) {
    return function () {
      var ops = ArrayList_init_$Create$();
      var _iterator__ex2g4s = $suppliers.m();
      while (_iterator__ex2g4s.n()) {
        var supplier = _iterator__ex2g4s.o();
        ops.j(supplier());
      }
      return Companion_instance_68.b40(ops);
    };
  }
  function NodeDiffBuilder$toSupplier$lambda($op) {
    return function () {
      return $op;
    };
  }
  function NodeDiffBuilder(source, target) {
    this.h4j_1 = source;
    this.i4j_1 = target;
    // Inline function 'kotlin.check' call
    if (!this.h4j_1.e3m_1.equals(this.i4j_1.e3m_1)) {
      var message = MessageBundle_instance.e3n(this.h4j_1.e3m_1, this.i4j_1.e3m_1);
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    // Inline function 'kotlin.check' call
    if (!NodeUtil_instance.d3w(this.h4j_1, this.i4j_1)) {
      var message_0 = MessageBundle_instance.h3n(this.h4j_1.z3n(), this.i4j_1.z3n());
      throw IllegalStateException_init_$Create$_0(toString_1(message_0));
    }
  }
  protoOf(NodeDiffBuilder).f40 = function () {
    this.j4j_1 = ArrayDeque_init_$Create$();
    var firstTask = enqueue(this, this.h4j_1, this.i4j_1);
    while (!_get_queue__c6g84g(this).s()) {
      var task = _get_queue__c6g84g(this).qf();
      task.g4k(buildNodeDiff(this, task.c4k_1, task.d4k_1));
    }
    return firstTask.f4k();
  };
  protoOf(NodeDiffBuilder).k4j = function (node, index) {
    return this.l4j(ensureNotNull(node.l3p()), node, index);
  };
  protoOf(NodeDiffBuilder).l4j = function (role, node, index) {
    return OperationBuilder_instance_0.b4h(role, node, index);
  };
  protoOf(NodeDiffBuilder).m4j = function (node, index) {
    return this.n4j(ensureNotNull(node.l3p()), node, index);
  };
  protoOf(NodeDiffBuilder).n4j = function (role, node, index) {
    return OperationBuilder_instance_0.a4h(role, node, index);
  };
  protoOf(NodeDiffBuilder).o4j = function (sourceParent, role, target) {
    var source = sourceParent.p3m(role);
    var srcIndex = 0;
    var modifiedSource = ArrayList_init_$Create$_0(target.p());
    var operations = ArrayList_init_$Create$();
    var _iterator__ex2g4s = source.m();
    while (_iterator__ex2g4s.n()) {
      var s = _iterator__ex2g4s.o();
      if (!NodeInspectionUtil_getInstance().i4k(target, s)) {
        operations.j(this.k4j(s, srcIndex));
      } else {
        modifiedSource.j(s);
        srcIndex = srcIndex + 1 | 0;
      }
    }
    var iterator = target.m();
    var index = 0;
    while (iterator.n()) {
      var trgIndex = index;
      index = index + 1 | 0;
      var t = iterator.o();
      if (!NodeInspectionUtil_getInstance().i4k(source, t)) {
        var i = trgIndex < modifiedSource.p() ? trgIndex : modifiedSource.p();
        operations.j(this.m4j(t, i));
        modifiedSource.m2(i, t);
      }
    }
    return new Pair(modifiedSource, operations);
  };
  function isOfNodesWithIds($this, nodes) {
    var tmp;
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!nodes.s()) {
      tmp = nodes.r(0).a3o();
    } else {
      tmp = false;
    }
    return tmp;
  }
  function contains_10($this, container, nodeId, idGetter) {
    return !(indexOf_11($this, container, nodeId, idGetter) === -1);
  }
  function indexOf_11($this, withNodeId, nodeId, idGetter) {
    var iterator = withNodeId.m();
    var index = 0;
    while (iterator.n()) {
      var index_0 = index;
      index = index + 1 | 0;
      var n = iterator.o();
      if (nodeId.equals(idGetter(n))) {
        return index_0;
      }
    }
    return -1;
  }
  function NodeInspectionUtil$NODE_ID_GETTER$lambda(node) {
    return NodeUtil_instance.c3n(node);
  }
  function NodeInspectionUtil() {
    NodeInspectionUtil_instance = this;
    var tmp = this;
    tmp.h4k_1 = NodeInspectionUtil$NODE_ID_GETTER$lambda;
  }
  protoOf(NodeInspectionUtil).j4k = function (source, target) {
    return isOfNodesWithIds(this, source) || isOfNodesWithIds(this, target);
  };
  protoOf(NodeInspectionUtil).i4k = function (container, node) {
    return this.k4k(container, node, this.h4k_1);
  };
  protoOf(NodeInspectionUtil).k4k = function (container, node, idGetter) {
    return node.a3o() && contains_10(this, container, node.z3n(), idGetter);
  };
  protoOf(NodeInspectionUtil).l4k = function (nodes, nodeId) {
    return indexOf_11(this, nodes, nodeId, this.h4k_1);
  };
  var NodeInspectionUtil_instance;
  function NodeInspectionUtil_getInstance() {
    if (NodeInspectionUtil_instance == null)
      new NodeInspectionUtil();
    return NodeInspectionUtil_instance;
  }
  function fromNode($this, node, root) {
    var current = node;
    var path = ArrayList_init_$Create$();
    while (!(current == null) && !isRoot($this, current, root)) {
      path.j(new Element_1(current.l3p(), current.m3p()));
      current = current.d3o();
      var tmp0 = current;
      $l$block: {
        // Inline function 'kotlin.checkNotNull' call
        if (tmp0 == null) {
          var message = 'Root was not reached, node=' + node.toString();
          throw IllegalStateException_init_$Create$_0(toString_1(message));
        } else {
          break $l$block;
        }
      }
    }
    reverse(path);
    return new NodePath(path);
  }
  function isRoot($this, node, root) {
    return node.a3o() && node.z3n().equals(root.z3n());
  }
  function getNode($this, root) {
    if ($this.m4k_1.s()) {
      return root;
    }
    var current = root;
    var _iterator__ex2g4s = $this.m4k_1.m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      // Inline function 'kotlin.check' call
      if (!contains_5(current.z3d(), element.n4k_1)) {
        var message = 'Failed to locate descendant by path=' + toString_1($this.m4k_1);
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      }
      var children = current.p3m(ensureNotNull(element.n4k_1));
      // Inline function 'kotlin.check' call
      if (!(children.p() > element.o4k_1)) {
        var message_0 = 'Failed to locate descendant by path=' + toString_1($this.m4k_1);
        throw IllegalStateException_init_$Create$_0(toString_1(message_0));
      }
      current = children.r(element.o4k_1);
    }
    return current;
  }
  function Element_1(role, index) {
    this.n4k_1 = role;
    this.o4k_1 = index;
  }
  protoOf(Element_1).toString = function () {
    return '(role=' + toString_0(this.n4k_1) + ', index=' + this.o4k_1 + ')';
  };
  protoOf(Element_1).hashCode = function () {
    var result = this.n4k_1 == null ? 0 : this.n4k_1.hashCode();
    result = imul(result, 31) + this.o4k_1 | 0;
    return result;
  };
  protoOf(Element_1).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Element_1))
      return false;
    if (!equals(this.n4k_1, other.n4k_1))
      return false;
    if (!(this.o4k_1 === other.o4k_1))
      return false;
    return true;
  };
  function Companion_62() {
  }
  protoOf(Companion_62).r4j = function (node, root) {
    $l$block: {
      // Inline function 'kotlin.requireNotNull' call
      if (node == null) {
        var message = 'Null target node';
        throw IllegalArgumentException_init_$Create$_0(toString_1(message));
      } else {
        break $l$block;
      }
    }
    $l$block_0: {
      // Inline function 'kotlin.requireNotNull' call
      if (root == null) {
        var message_0 = 'No root to build path to';
        throw IllegalArgumentException_init_$Create$_0(toString_1(message_0));
      } else {
        break $l$block_0;
      }
    }
    // Inline function 'kotlin.require' call
    if (!root.a3o()) {
      var message_1 = 'Root without id';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message_1));
    }
    return getNode(fromNode(this, node, root), root);
  };
  var Companion_instance_62;
  function Companion_getInstance_62() {
    return Companion_instance_62;
  }
  function NodePath(path) {
    this.m4k_1 = path;
  }
  function NodeWithRegistry(node) {
    this.p4k_1 = node;
  }
  function SplitMergeAwareNodeDiffBuilder$MoveToData$Companion$REVERSE_PARENT_ORDER_COMPARATOR$1() {
  }
  protoOf(SplitMergeAwareNodeDiffBuilder$MoveToData$Companion$REVERSE_PARENT_ORDER_COMPARATOR$1).r4k = function (a, b) {
    return b.s4k_1.m3p() - a.s4k_1.m3p() | 0;
  };
  protoOf(SplitMergeAwareNodeDiffBuilder$MoveToData$Companion$REVERSE_PARENT_ORDER_COMPARATOR$1).compare = function (a, b) {
    var tmp = a instanceof MoveToData ? a : THROW_CCE();
    return this.r4k(tmp, b instanceof MoveToData ? b : THROW_CCE());
  };
  function Companion_63() {
    Companion_instance_63 = this;
    var tmp = this;
    tmp.v4k_1 = new SplitMergeAwareNodeDiffBuilder$MoveToData$Companion$REVERSE_PARENT_ORDER_COMPARATOR$1();
  }
  var Companion_instance_63;
  function Companion_getInstance_63() {
    if (Companion_instance_63 == null)
      new Companion_63();
    return Companion_instance_63;
  }
  function wrap($this, node) {
    return node.g3m_1 == null ? new MyNotAttachedNode(node) : new MyAttachedNode(node);
  }
  function getMovedChildren($this, parent, target) {
    if (!parent.a3o()) {
      return emptyList();
    }
    var result = null;
    var _iterator__ex2g4s = parent.z3d().m();
    while (_iterator__ex2g4s.n()) {
      var role = _iterator__ex2g4s.o();
      var _iterator__ex2g4s_0 = parent.p3m(role).m();
      while (_iterator__ex2g4s_0.n()) {
        var child = _iterator__ex2g4s_0.o();
        if (child.a3o()) {
          var existent = target.q4k(child.z3n());
          if (!(existent == null)) {
            // Inline function 'kotlin.check' call
            if (!role.equals(existent.l3p())) {
              var message = MessageBundle_instance.f3n(role, ensureNotNull(existent.l3p())) + ', node=' + existent.toString();
              throw IllegalStateException_init_$Create$_0(toString_1(message));
            }
            var existentParent = existent.d3o();
            $l$block: {
              // Inline function 'kotlin.checkNotNull' call
              if (existentParent == null) {
                var message_0 = 'Root or detached node: ' + existent.toString();
                throw IllegalStateException_init_$Create$_0(toString_1(message_0));
              } else {
                break $l$block;
              }
            }
            if (!parent.z3n().equals(existentParent.z3n())) {
              if (result == null) {
                result = ArrayList_init_$Create$();
              }
              result.j(existent);
            }
          }
        }
      }
    }
    // Inline function 'kotlin.collections.orEmpty' call
    var tmp0_elvis_lhs = result;
    return tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
  }
  function getMoveIterable($this, movedChildren) {
    var byTargetParent = HashMap_init_$Create$();
    var _iterator__ex2g4s = movedChildren.m();
    while (_iterator__ex2g4s.n()) {
      var child = _iterator__ex2g4s.o();
      var parent = child.d3o();
      $l$block: {
        // Inline function 'kotlin.checkNotNull' call
        if (parent == null) {
          var message = 'No parent for ' + child.toString();
          throw IllegalStateException_init_$Create$_0(toString_1(message));
        } else {
          break $l$block;
        }
      }
      var location = new Pair(parent, ensureNotNull(child.l3p()));
      // Inline function 'kotlin.collections.getOrPut' call
      var value = byTargetParent.q2(location);
      var tmp;
      if (value == null) {
        var answer = ArrayList_init_$Create$();
        byTargetParent.t2(location, answer);
        tmp = answer;
      } else {
        tmp = value;
      }
      var list = tmp;
      list.j(child);
    }
    var data = ArrayList_init_$Create$_0(byTargetParent.p());
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s_0 = byTargetParent.y().m();
    while (_iterator__ex2g4s_0.n()) {
      var _destruct__k2r9zo = _iterator__ex2g4s_0.o();
      // Inline function 'kotlin.collections.component1' call
      var key = _destruct__k2r9zo.z();
      // Inline function 'kotlin.collections.component2' call
      var value_0 = _destruct__k2r9zo.a1();
      data.j(new MoveToData(key.pg_1, key.qg_1, value_0));
    }
    var result = toList_0(data);
    return sortedWith(result, Companion_getInstance_63().v4k_1);
  }
  function checkReordering($this, source, target) {
    if (NodeInspectionUtil_getInstance().j4k(source, target)) {
      var inductionVariable = source.p() - 1 | 0;
      if (0 <= inductionVariable)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + -1 | 0;
          // Inline function 'kotlin.check' call
          if (!source.r(i).z3n().equals(target.r(i).z3n())) {
            var message = 'Expected ' + target.r(i).z3n().toString() + ', got ' + source.r(i).z3n().toString() + ' at position ' + i;
            throw IllegalStateException_init_$Create$_0(toString_1(message));
          }
        }
         while (0 <= inductionVariable);
    }
  }
  function getFromSource($this, parent, role) {
    return $this.a4l_1.a4k(parent, role);
  }
  function doArrange($this, sourceParent, role, target) {
    var result = ArrayList_init_$Create$();
    var moveData = null;
    var sourceIndex = 0;
    while (sourceIndex < getFromSource($this, sourceParent, role).p()) {
      var s = getFromSource($this, sourceParent, role).r(sourceIndex);
      var movedChildren = s.a3o() ? getMovedChildren($this, s, $this.z4k_1) : emptyList();
      if (movedChildren.s()) {
        if (!NodeInspectionUtil_getInstance().i4k(target, s)) {
          result.j($this.k4j(s, sourceIndex));
        } else {
          sourceIndex = sourceIndex + 1 | 0;
        }
      } else {
        if (moveData == null) {
          moveData = ArrayList_init_$Create$();
        }
        var tmp = moveData;
        var tmp_0 = new MoveFromData(s, movedChildren);
        var _unary__edvuaz = sourceIndex;
        sourceIndex = _unary__edvuaz + 1 | 0;
        tmp.j(new Pair(tmp_0, _unary__edvuaz));
      }
    }
    if (!(moveData == null)) {
      processMoves($this, moveData, sourceParent, role, result);
    }
    var source = getFromSource($this, sourceParent, role);
    var iterator = target.m();
    var index = 0;
    while (iterator.n()) {
      var targetIndex = index;
      index = index + 1 | 0;
      var t = iterator.o();
      if (!NodeInspectionUtil_getInstance().i4k(source, t)) {
        result.j($this.m4j(t, targetIndex));
      }
    }
    return result;
  }
  function processMoves($this, moveData, sourceParent, role, result) {
    var initSize = getFromSource($this, sourceParent, role).p();
    var _iterator__ex2g4s = moveData.m();
    while (_iterator__ex2g4s.n()) {
      var p = _iterator__ex2g4s.o();
      var curSize = getFromSource($this, sourceParent, role).p();
      var index = (p.qg_1 + curSize | 0) - initSize | 0;
      result.q(arrangeWithSplitsAndMerges($this, p.pg_1, index));
    }
    var sourceCollection = getFromSource($this, sourceParent, role);
    var removedNum = 0;
    var _iterator__ex2g4s_0 = moveData.m();
    while (_iterator__ex2g4s_0.n()) {
      var p_0 = _iterator__ex2g4s_0.o();
      var source = p_0.pg_1.b4l_1;
      if ($this.a4l_1.u4j(source) && getFrom($this, $this.z4k_1, source) == null) {
        result.j($this.l4j(ensureNotNull(source.l3p()), source, NodeInspectionUtil_getInstance().l4k(sourceCollection, source.z3n()) - removedNum | 0));
        removedNum = removedNum + 1 | 0;
      }
    }
  }
  function arrangeWithSplitsAndMerges($this, from, sourceIndex) {
    var to = getMoveIterable($this, from.c4l_1);
    var result = ArrayList_init_$Create$();
    var iterator = to.m();
    while (iterator.n()) {
      var md = iterator.o();
      if ($this.a4l_1.u4j(md.s4k_1)) {
        // Inline function 'kotlin.check' call
        if (!!iterator.n()) {
          var message = 'Cannot merge and remove, because there are more pending moves: ' + md.toString();
          throw IllegalStateException_init_$Create$_0(toString_1(message));
        }
        result.j(doMerge($this, from.b4l_1, md));
        return result;
      }
      if ($this.a4l_1.v4j(md.s4k_1)) {
        result.j(doSplit($this, from.b4l_1, sourceIndex, md));
      } else {
        throw IllegalStateException_init_$Create$_0('No split or merge can be performed: ' + md.toString());
      }
    }
    return result;
  }
  function doMerge($this, toRemove, md) {
    // Inline function 'kotlin.check' call
    if (!(toRemove.c3e().s() && !hasChildWithoutIdInMajorRole($this, toRemove))) {
      var message = 'Cannot merge and remove because of non-null properties and/or other children: source=' + toRemove.toString() + ', ' + md.toString();
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    var majorRole = toRemove.l3p();
    var op = $this.a4l_1.z4j(toRemove, md.t4k_1);
    return new ChildListOperation(ensureNotNull(majorRole), op);
  }
  function doSplit($this, source, sourceIndex, md) {
    var firstMoved = md.u4k_1.r(0);
    var splitCollection = getFromSource($this, source, md.t4k_1);
    var splitIndex = NodeInspectionUtil_getInstance().l4k(splitCollection, firstMoved.z3n());
    var addChildId = md.s4k_1.z3n();
    var addChildConceptId = md.s4k_1.e3m_1;
    var addIndex = sourceIndex + 1 | 0;
    var majorRole = source.l3p();
    var op = $this.a4l_1.y4j(ensureNotNull(source.d3o()).z3n(), ensureNotNull(majorRole), addIndex, addChildId, addChildConceptId, md.t4k_1, splitIndex);
    return new ChildListOperation(majorRole, op);
  }
  function hasChildWithoutIdInMajorRole($this, node) {
    var _iterator__ex2g4s = node.z3d().m();
    while (_iterator__ex2g4s.n()) {
      var id = _iterator__ex2g4s.o();
      var _iterator__ex2g4s_0 = node.p3m(id).m();
      while (_iterator__ex2g4s_0.n()) {
        var child = _iterator__ex2g4s_0.o();
        if (!child.a3o()) {
          return true;
        }
      }
    }
    return false;
  }
  function getFrom($this, target, item) {
    return item.a3o() ? target.q4k(item.z3n()) : null;
  }
  function MoveFromData(source, movedChildren) {
    this.b4l_1 = source;
    this.c4l_1 = movedChildren;
  }
  function MoveToData(newParent, role, children) {
    Companion_getInstance_63();
    this.s4k_1 = newParent;
    this.t4k_1 = role;
    this.u4k_1 = children;
  }
  protoOf(MoveToData).toString = function () {
    return 'newParent=' + this.s4k_1.toString() + ', role=' + this.t4k_1.toString() + ', children=' + toString_1(this.u4k_1);
  };
  function MyAttachedNode(node) {
    NodeWithRegistry.call(this, node);
  }
  protoOf(MyAttachedNode).q4k = function (id) {
    return ensureNotNull(this.p4k_1.g3m_1).g3o(id);
  };
  function MyNotAttachedNode(node) {
    NodeWithRegistry.call(this, node);
    this.f4l_1 = Nodes_instance.i3w(node);
  }
  protoOf(MyNotAttachedNode).q4k = function (id) {
    return this.f4l_1.q2(id);
  };
  function SplitMergeAwareNodeDiffBuilder(source, target) {
    NodeDiffBuilder.call(this, source, target);
    this.z4k_1 = wrap(this, target);
    this.a4l_1 = new ModifiedSource(source);
  }
  protoOf(SplitMergeAwareNodeDiffBuilder).g4j = function (source) {
    return this.a4l_1.g4j(source);
  };
  protoOf(SplitMergeAwareNodeDiffBuilder).f4j = function (source) {
    return this.a4l_1.f4j(source);
  };
  protoOf(SplitMergeAwareNodeDiffBuilder).l4j = function (role, node, index) {
    this.a4l_1.x4j(node);
    return protoOf(NodeDiffBuilder).l4j.call(this, role, node, index);
  };
  protoOf(SplitMergeAwareNodeDiffBuilder).n4j = function (role, node, index) {
    this.a4l_1.w4j(node, index);
    return protoOf(NodeDiffBuilder).n4j.call(this, role, node, index);
  };
  protoOf(SplitMergeAwareNodeDiffBuilder).o4j = function (sourceParent, role, target) {
    var result = doArrange(this, sourceParent, role, target);
    var modifiedSource = getFromSource(this, sourceParent, role);
    checkReordering(this, modifiedSource, target);
    return new Pair(modifiedSource, result);
  };
  function ModelOperationConverter$toModelOperation$lambda(currNode, operation) {
    return currNode.d3o() == null ? new SetModelOperation(operation) : null;
  }
  function ModelOperationConverter() {
  }
  protoOf(ModelOperationConverter).g4l = function (node, op) {
    return this.h4l(node, op, ModelOperationConverter$toModelOperation$lambda);
  };
  protoOf(ModelOperationConverter).h4l = function (node, op, finalOp) {
    var tmp0_elvis_lhs = finalOp(node, op);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.run' call
      // Inline function 'kotlin.checkNotNull' call
      var tmp0 = node.d3o();
      var tmp$ret$1;
      $l$block: {
        // Inline function 'kotlin.checkNotNull' call
        if (tmp0 == null) {
          var message = 'Required value was null.';
          throw IllegalStateException_init_$Create$_0(toString_1(message));
        } else {
          tmp$ret$1 = tmp0;
          break $l$block;
        }
      }
      var nodeParent = tmp$ret$1;
      var role = ensureNotNull(node.l3p());
      var index = nodeParent.p3m(role).w(node);
      var changeChildOperation = new ChangeChildOperation_0(NodeUtil_instance.c3n(node), index, op);
      tmp = this.h4l(nodeParent, new ChildListOperation(role, changeChildOperation), finalOp);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  var ModelOperationConverter_instance;
  function ModelOperationConverter_getInstance() {
    return ModelOperationConverter_instance;
  }
  function ModelOperationsTracker() {
  }
  protoOf(ModelOperationsTracker).n3i = function (event) {
    this.t3z(ModelOperationConverter_instance.g4l(event.g3v_1, OperationBuilder_instance_0.a4h(event.p3u_1, event.r3u_1, event.q3u_1)));
  };
  protoOf(ModelOperationsTracker).o3i = function (event) {
    this.t3z(ModelOperationConverter_instance.g4l(event.g3v_1, OperationBuilder_instance_0.b4h(event.p3u_1, event.r3u_1, event.q3u_1)));
  };
  protoOf(ModelOperationsTracker).p3i = function (event) {
    this.t3z(ModelOperationConverter_instance.g4l(event.g3v_1, OperationBuilder_instance_0.d4h(event.p3u_1, event.a3v_1, event.b3v(), event.q3u_1)));
  };
  protoOf(ModelOperationsTracker).q3i = function (event) {
    var addOperation = new AddChildSplitPropertyOperation(event.r3u_1.e3m_1, event.c3u_1.z3n(), event.r3u_1.z3n(), event.q3u_1, event.e3u_1, event.d3u_1, event.f3u_1);
    var builder = new NodeAssemblyOperationBuilder(event.r3u_1);
    builder.w4g(event.e3u_1);
    var buildOperation = new ChangeChildOperation_0(event.r3u_1.z3n(), event.q3u_1, builder.f40());
    this.t3z(ModelOperationConverter_instance.g4l(event.g3v_1, new ChildListOperation(event.p3u_1, CompositeOperation_init_$Create$([addOperation, buildOperation]))));
  };
  protoOf(ModelOperationsTracker).r3i = function (event) {
    var removeOperation = new MergePropertyRemoveChildOperation(event.r3u_1.e3m_1, event.r3u_1.z3n(), event.t3v_1.z3n(), event.q3u_1, event.v3v_1, event.w3v_1, event.u3v_1);
    var builder = new NodeAssemblyOperationBuilder(event.r3u_1);
    builder.w4g(event.v3v_1);
    var buildOperation = new ChangeChildOperation_0(event.r3u_1.z3n(), event.q3u_1, builder.f40().q3z());
    this.t3z(ModelOperationConverter_instance.g4l(event.g3v_1, new ChildListOperation(event.p3u_1, CompositeOperation_init_$Create$([buildOperation, removeOperation]))));
  };
  protoOf(ModelOperationsTracker).s3i = function (event) {
    var addOperation = OperationBuilder_instance_0.e4h(event);
    var builder = new NodeAssemblyOperationBuilder(event.r3u_1);
    builder.x4g(event.r3t_1);
    var buildOperation = new ChangeChildOperation_0(event.r3u_1.z3n(), event.q3u_1, builder.f40());
    this.t3z(ModelOperationConverter_instance.g4l(event.g3v_1, new ChildListOperation(event.p3u_1, CompositeOperation_init_$Create$([addOperation, buildOperation]))));
  };
  protoOf(ModelOperationsTracker).t3i = function (event) {
    var removeOperation = OperationBuilder_instance_0.f4h(event);
    var builder = new NodeAssemblyOperationBuilder(event.r3u_1);
    builder.x4g(event.m3u_1);
    var buildOperation = new ChangeChildOperation_0(event.r3u_1.z3n(), event.q3u_1, builder.f40().q3z());
    this.t3z(ModelOperationConverter_instance.g4l(event.g3v_1, new ChildListOperation(event.p3u_1, CompositeOperation_init_$Create$([buildOperation, removeOperation]))));
  };
  protoOf(ModelOperationsTracker).m3i = function (event) {
    var propertyOperation = new ChangePropertyOperation(event.y3v_1, new SetValueOperation(event.z3v_1, event.a3w_1));
    this.t3z(ModelOperationConverter_instance.g4l(event.g3v_1, propertyOperation));
  };
  protoOf(ModelOperationsTracker).u3i = function (event) {
    var propertyOperation = new ChangePropertyOperation(event.m3v_1, new InsertTextOperation(event.n3v_1, event.o3v_1));
    this.t3z(ModelOperationConverter_instance.g4l(event.g3v_1, propertyOperation));
  };
  protoOf(ModelOperationsTracker).v3i = function (event) {
    var propertyOperation = new ChangePropertyOperation(event.m3v_1, new DeleteTextOperation(event.n3v_1, event.o3v_1));
    this.t3z(ModelOperationConverter_instance.g4l(event.g3v_1, propertyOperation));
  };
  function AddChildOperationExecutor$installChecker$1_0($tempContainer, this$0) {
    NodeChildOperationsExecutorChecker.call(this, $tempContainer.k3e_1, ensureNotNull(this$0.l43_1).m3p(), ensureNotNull(this$0.l43_1).v3w(), this$0.g45());
  }
  protoOf(AddChildOperationExecutor$installChecker$1_0).n3i = function (event) {
    this.q4l(event);
  };
  function AddChildOperationExecutor_0(nodeFactory) {
    nodeFactory = nodeFactory === VOID ? RawNodeFactory_instance : nodeFactory;
    BaseAddOperationExecutor.call(this, nodeFactory);
    this.z4l_1 = NodeChildIdFactory_getInstance().i3q();
  }
  protoOf(AddChildOperationExecutor_0).a4m = function (op) {
    return op instanceof AddChildOperation_0;
  };
  protoOf(AddChildOperationExecutor_0).p45 = function (op) {
    return this.a4m(op);
  };
  protoOf(AddChildOperationExecutor_0).b4m = function (op) {
    return NodeOperationsExecutorUtil_instance.c4m(ensureNotNull(this.l43_1).v3w(), ensureNotNull(this.l43_1).m3p(), op);
  };
  protoOf(AddChildOperationExecutor_0).s45 = function (op) {
    return this.b4m(op);
  };
  protoOf(AddChildOperationExecutor_0).d4m = function (source) {
    var conceptId = NodeConceptIdFactory_getInstance().s3q();
    var parentCopy = RawNodeFactory_instance.h3t(conceptId);
    var _iterator__ex2g4s = source.m();
    while (_iterator__ex2g4s.n()) {
      var child = _iterator__ex2g4s.o();
      var childCopy = this.k43_1.d3m(child.e3m_1, NodeUtil_instance.c3n(child));
      parentCopy.p3m(this.z4l_1).j(childCopy);
    }
    return new Model(parentCopy);
  };
  protoOf(AddChildOperationExecutor_0).u45 = function (source) {
    return this.d4m((!(source == null) ? isInterface(source, KtMutableList) : false) ? source : THROW_CCE());
  };
  protoOf(AddChildOperationExecutor_0).e4m = function (tempContainer) {
    return NodeOperationsExecutorUtil_instance.f4m(tempContainer, this.z4l_1);
  };
  protoOf(AddChildOperationExecutor_0).w45 = function (tempContainer) {
    return this.e4m(tempContainer instanceof Model ? tempContainer : THROW_CCE());
  };
  protoOf(AddChildOperationExecutor_0).g4m = function (source, temp) {
    var added = temp.r(ensureNotNull(this.l43_1).m3p());
    added.r3p();
    source.m2(ensureNotNull(this.l43_1).m3p(), added);
  };
  protoOf(AddChildOperationExecutor_0).y45 = function (source, temp) {
    var tmp = (!(source == null) ? isInterface(source, KtMutableList) : false) ? source : THROW_CCE();
    return this.g4m(tmp, (!(temp == null) ? isInterface(temp, KtMutableList) : false) ? temp : THROW_CCE());
  };
  protoOf(AddChildOperationExecutor_0).h4m = function (tempContainer) {
    return tempContainer.z3h(new AddChildOperationExecutor$installChecker$1_0(tempContainer, this));
  };
  protoOf(AddChildOperationExecutor_0).a46 = function (tempContainer) {
    return this.h4m(tempContainer instanceof Model ? tempContainer : THROW_CCE());
  };
  function ChangeChildOperationExecutor_0(nodeFactory) {
    nodeFactory = nodeFactory === VOID ? RawNodeFactory_instance : nodeFactory;
    this.s4i_1 = nodeFactory;
  }
  protoOf(ChangeChildOperationExecutor_0).t4i = function (model, ops) {
    var executionResult = (new RemoveChildOperationExecutor(this.s4i_1)).o43(model, ops);
    if (!executionResult.i4m_1) {
      executionResult = (new ReplaceChildOperationExecutor(this.s4i_1)).o43(model, ops);
    }
    return executionResult;
  };
  function applyOperation($this, node, operation, nodeFactory) {
    if (isInterface(operation, OperationContainer)) {
      var operationContainer = isInterface(operation, OperationContainer) ? operation : THROW_CCE();
      applyContainer($this, node, operationContainer, nodeFactory);
    } else {
      if (operation instanceof InsertTextOperation) {
        node.p3n($this.l3p(), TextOperationUtil_instance.p4m(operation), operation.s4m_1);
      } else {
        if (operation instanceof DeleteTextOperation) {
          node.r3n($this.l3p(), TextOperationUtil_instance.p4m(operation), operation.a());
        } else {
          var oldValue = $this.o4m(node);
          node.d3n($this.l3p()).d2x(operation.y3x(oldValue, nodeFactory));
        }
      }
    }
    return node;
  }
  function applyContainer($this, node, operation, nodeFactory) {
    var _iterator__ex2g4s = operation.j3w().m();
    while (_iterator__ex2g4s.n()) {
      var op = _iterator__ex2g4s.o();
      applyOperation($this, node, op, nodeFactory);
    }
  }
  function ChangePropertyOperation(role, op) {
    TargetedOperation.call(this, role, op);
    this.n4m_1 = 'changeProperty';
  }
  protoOf(ChangePropertyOperation).y2 = function () {
    return this.n4m_1;
  };
  protoOf(ChangePropertyOperation).i4d = function (op) {
    return new ChangePropertyOperation(this.l3p(), op);
  };
  protoOf(ChangePropertyOperation).x43 = function (op) {
    return this.i4d(op);
  };
  protoOf(ChangePropertyOperation).o4m = function (source) {
    return source.d3n(this.l3p()).uv();
  };
  protoOf(ChangePropertyOperation).b44 = function (source) {
    return this.o4m(source instanceof OtNode ? source : THROW_CCE());
  };
  protoOf(ChangePropertyOperation).t4m = function (model, customExecute, nodeFactory) {
    return applyOperation(this, model, this.s3z(), nodeFactory);
  };
  protoOf(ChangePropertyOperation).c49 = function (model, customExecute, nodeFactory) {
    return this.t4m(model instanceof OtNode ? model : THROW_CCE(), customExecute, nodeFactory);
  };
  protoOf(ChangePropertyOperation).c44 = function (model, customExecute, nodeFactory) {
    return this.t4m(model instanceof OtNode ? model : THROW_CCE(), customExecute, nodeFactory);
  };
  function ChildListOperation(role, op) {
    TargetedOperation.call(this, role, op);
  }
  protoOf(ChildListOperation).y2 = function () {
    return 'setChild';
  };
  protoOf(ChildListOperation).x4m = function (op) {
    return new ChildListOperation(this.l3p(), op);
  };
  protoOf(ChildListOperation).x43 = function (op) {
    return this.x4m(op);
  };
  protoOf(ChildListOperation).o4m = function (source) {
    return source.p3m(this.l3p());
  };
  protoOf(ChildListOperation).b44 = function (source) {
    return this.o4m(source instanceof OtNode ? source : THROW_CCE());
  };
  function handleMainEvent_0($this, event) {
    if (!($this.s4l_1 === event.q3u_1) || !NodeUtil_instance.c3w(event.r3u_1, $this.t4l_1)) {
      $this.u4l_1();
    }
  }
  function NodeChildOperationsExecutorChecker(allowedParent, allowedChildIndex, allowedChildId, canceller) {
    NodeOperationsExecutorChecker.call(this, allowedParent, allowedChildIndex, allowedChildId, canceller);
  }
  protoOf(NodeChildOperationsExecutorChecker).q4l = function (event) {
    if (equals(event.g3v_1, this.r4l_1)) {
      handleMainEvent_0(this, event);
    } else {
      this.l3i(event);
    }
  };
  function NodeOperationsExecutorChecker(allowedParent, allowedChildIndex, allowedChildId, canceller) {
    ModelAdapter.call(this);
    this.r4l_1 = allowedParent;
    this.s4l_1 = allowedChildIndex;
    this.t4l_1 = allowedChildId;
    this.u4l_1 = canceller;
  }
  protoOf(NodeOperationsExecutorChecker).l3i = function (event) {
    var node = event.g3v_1;
    while (!(node == null) && !equals(node.d3o(), this.r4l_1)) {
      node = node.d3o();
    }
    if (node == null || !(this.s4l_1 === node.m3p()) || !NodeUtil_instance.c3w(node, this.t4l_1)) {
      this.u4l_1();
    }
  };
  function NodeOperationsExecutorUtil() {
  }
  protoOf(NodeOperationsExecutorUtil).c4m = function (expectedId, expectedIndex, op) {
    var tmp;
    var tmp_0;
    if (op instanceof ChangeChildOperation_0) {
      tmp_0 = NodeUtil_instance.e3w(expectedId, op.l4i_1);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = expectedIndex === op.l3p();
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(NodeOperationsExecutorUtil).y4m = function (source, role, fullCopiedItemIndex, nodeFactory) {
    var conceptId = NodeConceptIdFactory_getInstance().s3q();
    var root = RawNodeFactory_instance.h3t(conceptId);
    var listCopy = root.p3m(role);
    var iterator = source.f2();
    while (iterator.n()) {
      var srcChild = iterator.o();
      if (iterator.u4() === fullCopiedItemIndex) {
        listCopy.j(srcChild.h3o());
      } else {
        var node = nodeFactory.d3m(srcChild.e3m_1, NodeUtil_instance.c3n(srcChild));
        listCopy.j(node);
      }
    }
    return new Model(root);
  };
  protoOf(NodeOperationsExecutorUtil).f4m = function (container, role) {
    return container.k3e_1.p3m(role);
  };
  var NodeOperationsExecutorUtil_instance;
  function NodeOperationsExecutorUtil_getInstance() {
    return NodeOperationsExecutorUtil_instance;
  }
  function RemoveChildOperationExecutor$installChecker$1($tempContainer, this$0) {
    NodeChildOperationsExecutorChecker.call(this, $tempContainer.k3e_1, ensureNotNull(this$0.l43_1).m3p(), ensureNotNull(this$0.l43_1).v3w(), this$0.g45());
  }
  protoOf(RemoveChildOperationExecutor$installChecker$1).o3i = function (event) {
    this.q4l(event);
  };
  function RemoveChildOperationExecutor(nodeFactory) {
    nodeFactory = nodeFactory === VOID ? RawNodeFactory_instance : nodeFactory;
    BaseRemoveOperationExecutor.call(this, nodeFactory);
    this.h4n_1 = NodeChildIdFactory_getInstance().i3q();
  }
  protoOf(RemoveChildOperationExecutor).a4m = function (op) {
    return op instanceof RemoveChildOperation_0;
  };
  protoOf(RemoveChildOperationExecutor).p45 = function (op) {
    return this.a4m(op);
  };
  protoOf(RemoveChildOperationExecutor).i4n = function (source) {
    var index = ensureNotNull(this.l43_1).m3p();
    var expectedId = ensureNotNull(this.l43_1).v3w();
    return index < source.p() && NodeUtil_instance.c3w(source.r(index), expectedId);
  };
  protoOf(RemoveChildOperationExecutor).h46 = function (source) {
    return this.i4n((!(source == null) ? isInterface(source, KtMutableList) : false) ? source : THROW_CCE());
  };
  protoOf(RemoveChildOperationExecutor).j4n = function (op) {
    return NodeOperationsExecutorUtil_instance.c4m(ensureNotNull(this.l43_1).v3w(), ensureNotNull(this.l43_1).m3p(), op);
  };
  protoOf(RemoveChildOperationExecutor).i46 = function (op) {
    return this.j4n(op);
  };
  protoOf(RemoveChildOperationExecutor).d4m = function (source) {
    return NodeOperationsExecutorUtil_instance.y4m(source, this.h4n_1, ensureNotNull(this.l43_1).m3p(), this.k43_1);
  };
  protoOf(RemoveChildOperationExecutor).u45 = function (source) {
    return this.d4m((!(source == null) ? isInterface(source, KtMutableList) : false) ? source : THROW_CCE());
  };
  protoOf(RemoveChildOperationExecutor).e4m = function (tempContainer) {
    return NodeOperationsExecutorUtil_instance.f4m(tempContainer, this.h4n_1);
  };
  protoOf(RemoveChildOperationExecutor).w45 = function (tempContainer) {
    return this.e4m(tempContainer instanceof Model ? tempContainer : THROW_CCE());
  };
  protoOf(RemoveChildOperationExecutor).g4m = function (source, temp) {
    source.n2(ensureNotNull(this.l43_1).m3p());
  };
  protoOf(RemoveChildOperationExecutor).y45 = function (source, temp) {
    var tmp = (!(source == null) ? isInterface(source, KtMutableList) : false) ? source : THROW_CCE();
    return this.g4m(tmp, (!(temp == null) ? isInterface(temp, KtMutableList) : false) ? temp : THROW_CCE());
  };
  protoOf(RemoveChildOperationExecutor).h4m = function (tempContainer) {
    return tempContainer.z3h(new RemoveChildOperationExecutor$installChecker$1(tempContainer, this));
  };
  protoOf(RemoveChildOperationExecutor).a46 = function (tempContainer) {
    return this.h4m(tempContainer instanceof Model ? tempContainer : THROW_CCE());
  };
  function ReplaceChildOperationExecutor$installChecker$1($tempContainer, this$0) {
    this.o4n_1 = this$0;
    NodeOperationsExecutorChecker.call(this, $tempContainer.k3e_1, ensureNotNull(this$0.l43_1).m3p(), ensureNotNull(this$0.l43_1).o4i(), this$0.g45());
  }
  protoOf(ReplaceChildOperationExecutor$installChecker$1).p3i = function (event) {
    if (!(ensureNotNull(this.o4n_1.l43_1).m3p() === event.q3u_1) || !NodeUtil_instance.c3w(event.a3v_1, ensureNotNull(this.o4n_1.l43_1).o4i()) || !NodeUtil_instance.c3w(event.b3v(), ensureNotNull(this.o4n_1.l43_1).b4i())) {
      this.o4n_1.i3a();
    } else {
      this.t4l_1 = NodeUtil_instance.c3n(event.b3v());
    }
  };
  function ReplaceChildOperationExecutor(nodeFactory) {
    nodeFactory = nodeFactory === VOID ? RawNodeFactory_instance : nodeFactory;
    BaseOperationExecutor.call(this, nodeFactory);
    this.t4n_1 = NodeChildIdFactory_getInstance().i3q();
    this.u4n_1 = 3;
    this.v4n_1 = MainOpPos_ANY_getInstance();
  }
  protoOf(ReplaceChildOperationExecutor).f46 = function () {
    return this.u4n_1;
  };
  protoOf(ReplaceChildOperationExecutor).g46 = function () {
    return this.v4n_1;
  };
  protoOf(ReplaceChildOperationExecutor).a4m = function (op) {
    return op instanceof ReplaceChildOperation;
  };
  protoOf(ReplaceChildOperationExecutor).p45 = function (op) {
    return this.a4m(op);
  };
  protoOf(ReplaceChildOperationExecutor).i4n = function (source) {
    var index = ensureNotNull(this.l43_1).m3p();
    var expectedId = ensureNotNull(this.l43_1).o4i();
    return index < source.p() && NodeUtil_instance.c3w(source.r(index), expectedId);
  };
  protoOf(ReplaceChildOperationExecutor).h46 = function (source) {
    return this.i4n((!(source == null) ? isInterface(source, KtMutableList) : false) ? source : THROW_CCE());
  };
  protoOf(ReplaceChildOperationExecutor).j4n = function (op) {
    return NodeOperationsExecutorUtil_instance.c4m(ensureNotNull(this.l43_1).o4i(), ensureNotNull(this.l43_1).m3p(), op);
  };
  protoOf(ReplaceChildOperationExecutor).i46 = function (op) {
    return this.j4n(op);
  };
  protoOf(ReplaceChildOperationExecutor).b4m = function (op) {
    return NodeOperationsExecutorUtil_instance.c4m(ensureNotNull(this.l43_1).b4i(), ensureNotNull(this.l43_1).m3p(), op);
  };
  protoOf(ReplaceChildOperationExecutor).s45 = function (op) {
    return this.b4m(op);
  };
  protoOf(ReplaceChildOperationExecutor).d4m = function (source) {
    return NodeOperationsExecutorUtil_instance.y4m(source, this.t4n_1, ensureNotNull(this.l43_1).m3p(), this.k43_1);
  };
  protoOf(ReplaceChildOperationExecutor).u45 = function (source) {
    return this.d4m((!(source == null) ? isInterface(source, KtMutableList) : false) ? source : THROW_CCE());
  };
  protoOf(ReplaceChildOperationExecutor).e4m = function (tempContainer) {
    return NodeOperationsExecutorUtil_instance.f4m(tempContainer, this.t4n_1);
  };
  protoOf(ReplaceChildOperationExecutor).w45 = function (tempContainer) {
    return this.e4m(tempContainer instanceof Model ? tempContainer : THROW_CCE());
  };
  protoOf(ReplaceChildOperationExecutor).g4m = function (source, temp) {
    var replacement = temp.r(ensureNotNull(this.l43_1).m3p());
    replacement.r3p();
    source.l2(ensureNotNull(this.l43_1).m3p(), replacement);
  };
  protoOf(ReplaceChildOperationExecutor).y45 = function (source, temp) {
    var tmp = (!(source == null) ? isInterface(source, KtMutableList) : false) ? source : THROW_CCE();
    return this.g4m(tmp, (!(temp == null) ? isInterface(temp, KtMutableList) : false) ? temp : THROW_CCE());
  };
  protoOf(ReplaceChildOperationExecutor).h4m = function (tempContainer) {
    return tempContainer.z3h(new ReplaceChildOperationExecutor$installChecker$1(tempContainer, this));
  };
  protoOf(ReplaceChildOperationExecutor).a46 = function (tempContainer) {
    return this.h4m(tempContainer instanceof Model ? tempContainer : THROW_CCE());
  };
  function Companion_64() {
    this.w4n_1 = 'root';
  }
  var Companion_instance_64;
  function Companion_getInstance_64() {
    return Companion_instance_64;
  }
  function SetModelOperation(op) {
    TargetedOperation.call(this, 'root', op);
  }
  protoOf(SetModelOperation).y2 = function () {
    return 'setModel';
  };
  protoOf(SetModelOperation).q4i = function (op) {
    return new SetModelOperation(op);
  };
  protoOf(SetModelOperation).x43 = function (op) {
    return this.q4i(op);
  };
  protoOf(SetModelOperation).a4o = function (source) {
    return source.k3e_1;
  };
  protoOf(SetModelOperation).b44 = function (source) {
    return this.a4o(source instanceof Model ? source : THROW_CCE());
  };
  function findListOperation($this, op) {
    var tmp0_safe_receiver = SplitMergeOperationsUtil_instance.n4o(op, $this.k4o_1, new Int32Array([$this.m4o()]));
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.o4o_1;
  }
  function AddChildSplitChildCollectionOperation(conceptId, sourceId, addedId, addIndex, childId, splitIndex, splitSize) {
    BaseAddChildSplitOperation.call(this, conceptId, sourceId, addedId, addIndex, splitIndex);
    this.k4o_1 = childId;
    this.l4o_1 = splitSize;
  }
  protoOf(AddChildSplitChildCollectionOperation).q4o = function () {
    return this.k4o_1;
  };
  protoOf(AddChildSplitChildCollectionOperation).n4h = function (otherOp, server) {
    var compositeOp = SplitMergeOperationsUtil_instance.r4o(otherOp, new Int32Array([this.m4o()]));
    if (!(compositeOp == null))
      return this.z3x(compositeOp, server);
    var listOp = findListOperation(this, otherOp);
    if (!(listOp == null)) {
      if (listOp instanceof ChangeChildOperation_0) {
        var changeOp = listOp instanceof ChangeChildOperation_0 ? listOp : THROW_CCE();
        if (ensureNotNull(changeOp).l3p() >= this.p41_1) {
          var newOp = changeOp.n4i(changeOp.l3p() - this.p41_1 | 0);
          return new ChangeChildOperation_0(this.n41_1, this.o41_1, new ChildListOperation(this.k4o_1, newOp));
        }
      }
      if (listOp instanceof BaseAddChildSplitOperation) {
        var splitOp = listOp instanceof BaseAddChildSplitOperation ? listOp : THROW_CCE();
        if (ensureNotNull(splitOp).m3p() === this.p41_1) {
          return otherOp;
        }
      }
      if (listOp instanceof BaseMergeRemoveChildOperation) {
        var mergeOp = listOp instanceof BaseMergeRemoveChildOperation ? listOp : THROW_CCE();
        if (ensureNotNull(mergeOp).m3p() === this.p41_1) {
          return CompositeOperation_init_$Create$([this.q3z(), otherOp]);
        }
      }
      if (isInterface(listOp, IndexedOperation)) {
        var indexOp = (listOp == null ? true : isInterface(listOp, IndexedOperation)) ? listOp : THROW_CCE();
        if (ensureNotNull(indexOp).m3p() >= this.p41_1) {
          var newOp_0 = indexOp.p4d(indexOp.m3p() - this.p41_1 | 0);
          return new ChangeChildOperation_0(this.n41_1, this.o41_1, new ChildListOperation(this.k4o_1, newOp_0));
        }
      }
    }
    return protoOf(BaseAddChildSplitOperation).n4h.call(this, otherOp, server);
  };
  protoOf(AddChildSplitChildCollectionOperation).f43 = function (otherOp, server) {
    return this.n4h(otherOp, server);
  };
  protoOf(AddChildSplitChildCollectionOperation).p4i = function (otherOp, server) {
    var compositeOp = SplitMergeOperationsUtil_instance.r4o(otherOp, new Int32Array([this.m4o()]));
    if (!(compositeOp == null))
      return compositeOp.z3x(this, !server);
    var listOp = findListOperation(this, otherOp);
    if (!(listOp == null)) {
      if (listOp instanceof BaseAddChildSplitOperation) {
        var splitOp = listOp instanceof BaseAddChildSplitOperation ? listOp : THROW_CCE();
        if (ensureNotNull(splitOp).o41_1 === this.p41_1) {
          return this.s4o(this.p41_1 + splitOp.q4d() | 0);
        }
      }
      if (listOp instanceof BaseMergeRemoveChildOperation) {
        var mergeOp = listOp instanceof BaseMergeRemoveChildOperation ? listOp : THROW_CCE();
        if (ensureNotNull(mergeOp).m3p() === this.p41_1) {
          return new NopOperation();
        }
      }
      if (isInterface(listOp, IndexedOperation)) {
        var indexOp = (listOp == null ? true : isInterface(listOp, IndexedOperation)) ? listOp : THROW_CCE();
        var tmp;
        if (ensureNotNull(indexOp).m3p() < this.p41_1) {
          tmp = this.s4o(this.p41_1 + indexOp.q4d() | 0);
        } else {
          tmp = this.t4o(this.l4o_1 + indexOp.q4d() | 0);
        }
        return tmp;
      }
    }
    return protoOf(BaseAddChildSplitOperation).p4i.call(this, otherOp, server);
  };
  protoOf(AddChildSplitChildCollectionOperation).q43 = function (otherOp, server) {
    return this.p4i(otherOp, server);
  };
  protoOf(AddChildSplitChildCollectionOperation).d4i = function (model, nodeFactory) {
    var source = model.r(this.o41_1 - 1 | 0);
    this.u4o(source);
    // Inline function 'kotlin.check' call
    if (!(source.p3m(this.k4o_1).p() === (this.p41_1 + this.l4o_1 | 0))) {
      var message = 'Source children size=' + source.p3m(this.k4o_1).p() + ', split index=' + this.p41_1 + ', split size=' + this.l4o_1;
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    var parent = source.d3o();
    $l$block: {
      // Inline function 'kotlin.checkNotNull' call
      if (parent == null) {
        var message_0 = 'Null parent';
        throw IllegalStateException_init_$Create$_0(toString_1(message_0));
      } else {
        break $l$block;
      }
    }
    var newNode = nodeFactory.d3m(this.l41_1, this.n41_1);
    parent.x3p(newNode, ensureNotNull(source.l3p()), this.o41_1, this.k4o_1, this.p41_1);
    return model;
  };
  protoOf(AddChildSplitChildCollectionOperation).y3x = function (model, nodeFactory) {
    return this.d4i((!(model == null) ? isInterface(model, KtMutableList) : false) ? model : THROW_CCE(), nodeFactory);
  };
  protoOf(AddChildSplitChildCollectionOperation).q3z = function () {
    return new MergeChildCollectionRemoveChildOperation(this.l41_1, this.n41_1, this.m41_1, this.o41_1, this.k4o_1, this.l4o_1, this.p41_1);
  };
  protoOf(AddChildSplitChildCollectionOperation).p4d = function (newIndex) {
    return new AddChildSplitChildCollectionOperation(this.l41_1, this.m41_1, this.n41_1, newIndex, this.k4o_1, this.p41_1, this.l4o_1);
  };
  protoOf(AddChildSplitChildCollectionOperation).s4o = function (newSplitIndex) {
    return new AddChildSplitChildCollectionOperation(this.l41_1, this.m41_1, this.n41_1, this.o41_1, this.k4o_1, newSplitIndex, this.l4o_1);
  };
  protoOf(AddChildSplitChildCollectionOperation).t4o = function (newSplitSize) {
    return new AddChildSplitChildCollectionOperation(this.l41_1, this.m41_1, this.n41_1, this.o41_1, this.k4o_1, this.p41_1, newSplitSize);
  };
  protoOf(AddChildSplitChildCollectionOperation).v4o = function (newSourceNodeId) {
    return new AddChildSplitChildCollectionOperation(this.l41_1, newSourceNodeId, this.n41_1, this.o41_1, this.k4o_1, this.p41_1, this.l4o_1);
  };
  protoOf(AddChildSplitChildCollectionOperation).w4o = function (newMoveSize) {
    return this.t4o(newMoveSize);
  };
  protoOf(AddChildSplitChildCollectionOperation).toString = function () {
    return 'AddChildSplitChildren[' + this.x4o() + '; role = ' + this.k4o_1.toString() + '; size = ' + this.l4o_1 + ']';
  };
  function constructorIndex($this, splitIndex) {
    return splitIndex === -1 ? 0 : splitIndex;
  }
  function splitThroughThis($this, splitOp, server) {
    if (splitOp.m3p() === $this.m3p()) {
      var otherSplitToNull = splitOp.y4o();
      if ($this.y4o()) {
        var tmp;
        if (otherSplitToNull) {
          var tmp_0;
          if (server) {
            tmp_0 = splitOp.p4d(splitOp.m3p() + 1 | 0).v4o($this.n41_1);
          } else {
            tmp_0 = AddChildOperation_init_$Create$_1($this.l41_1, splitOp.n41_1, $this.o41_1, false);
          }
          tmp = tmp_0;
        } else {
          tmp = splitOp.v4o($this.n41_1).p4d($this.o41_1 + 1 | 0);
        }
        return tmp;
      }
      if (otherSplitToNull) {
        return splitOp.z4o(take_1(splitOp.e42_1, $this.p41_1));
      }
    }
    return null;
  }
  function setValueThroughThis($this, setOp) {
    // Inline function 'kotlin.check' call
    if (!(setOp.f4g_1 == null)) {
      var message = 'Transform ' + setOp.toString() + ' through ' + $this.toString();
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    var tmp;
    if ($this.y4o()) {
      tmp = new NopOperation();
    } else {
      var opOldValue = ensureNotNull(setOp.e4g_1);
      var oldValue = dropLast_0(opOldValue, $this.e42_1.length);
      var setValueOperation = new SetValueOperation(oldValue, null);
      var changePropertyOperation = new ChangePropertyOperation($this.c42_1, setValueOperation);
      tmp = new ChangeChildOperation_0($this.m41_1, $this.o41_1 - 1 | 0, changePropertyOperation);
    }
    return tmp;
  }
  function insertThroughThis($this, insertOp) {
    if ($this.y4o()) {
      // Inline function 'kotlin.check' call
      if (!!insertOp.a4p()) {
        var message = 'Insert into null while splitting this node';
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      }
      var changePropertyOperation = new ChangePropertyOperation($this.c42_1, insertOp);
      return new ChangeChildOperation_0($this.n41_1, $this.o41_1, changePropertyOperation);
    }
    // Inline function 'kotlin.check' call
    if (!!insertOp.a4p()) {
      var message_0 = 'Insert into null while splitting this node';
      throw IllegalStateException_init_$Create$_0(toString_1(message_0));
    }
    return null;
  }
  function deleteThroughThis($this, deleteOp) {
    if ($this.y4o()) {
      var changePropertyOperation = new ChangePropertyOperation($this.c42_1, deleteOp);
      return new ChangeChildOperation_0($this.n41_1, $this.o41_1, changePropertyOperation);
    }
    if (deleteOp.a4p()) {
      var deleteOpText = deleteOp.s4m_1;
      var d1 = new DeleteTextOperation(-1, take_1(deleteOpText, $this.p41_1));
      var d2 = new DeleteTextOperation(-1, substring_0(deleteOpText, $this.p41_1));
      var op1 = new ChangeChildOperation_0($this.m41_1, $this.o41_1 - 1 | 0, new ChangePropertyOperation($this.c42_1, d1));
      var op2 = new ChangeChildOperation_0($this.n41_1, $this.o41_1, new ChangePropertyOperation($this.c42_1, d2));
      return CompositeOperation_init_$Create$([op1, op2]);
    }
    var deleteIndex = deleteOp.m3p();
    if (deleteIndex < $this.p41_1 && (deleteIndex + deleteOp.a() | 0) > $this.p41_1) {
      var deleteOpText_0 = deleteOp.s4m_1;
      var delete1 = new DeleteTextOperation(deleteIndex, take_1(deleteOpText_0, $this.p41_1 - deleteIndex | 0));
      var delete2 = new DeleteTextOperation(0, substring_0(deleteOpText_0, $this.p41_1 - deleteIndex | 0));
      var op1_0 = new ChangeChildOperation_0($this.m41_1, $this.o41_1 - 1 | 0, new ChangePropertyOperation($this.c42_1, delete1));
      var op2_0 = new ChangeChildOperation_0($this.n41_1, $this.o41_1, new ChangePropertyOperation($this.c42_1, delete2));
      return CompositeOperation_init_$Create$([op1_0, op2_0]);
    }
    return null;
  }
  function thisThroughDelete($this, deleteOp) {
    var tmp;
    if (deleteOp.a4p()) {
      tmp = AddChildOperation_init_$Create$_1($this.l41_1, $this.n41_1, $this.o41_1, false);
    } else if ($this.y4o()) {
      var deleteIndex = deleteOp.m3p();
      tmp = $this.z4o(take_1($this.e42_1, deleteIndex) + substring_0($this.e42_1, deleteIndex + deleteOp.a() | 0));
    } else if (deleteOp.m3p() >= $this.p41_1) {
      var index = deleteOp.m3p() - $this.p41_1 | 0;
      tmp = $this.z4o(take_1($this.e42_1, index) + substring_0($this.e42_1, index + deleteOp.a() | 0));
    } else {
      var tmp_0;
      if ((deleteOp.m3p() + deleteOp.a() | 0) > $this.p41_1) {
        tmp_0 = $this.s4o(deleteOp.m3p()).z4o(substring_0($this.e42_1, (deleteOp.m3p() + deleteOp.a() | 0) - $this.p41_1 | 0));
      } else {
        tmp_0 = $this.s4o($this.p41_1 - deleteOp.a() | 0);
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  function thisThroughInsert($this, insertOp) {
    // Inline function 'kotlin.check' call
    if (!!insertOp.a4p()) {
      var message = 'Insert into null while splitting this node';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    var tmp;
    if ($this.y4o()) {
      var index = insertOp.m3p();
      tmp = changeInsertOpMovedText($this, insertOp, index);
    } else if (insertOp.m3p() >= $this.p41_1) {
      var index_0 = insertOp.m3p() - $this.p41_1 | 0;
      tmp = changeInsertOpMovedText($this, insertOp, index_0);
    } else {
      tmp = $this.s4o($this.p41_1 + insertOp.a() | 0);
    }
    return tmp;
  }
  function changeInsertOpMovedText($this, insertOp, index) {
    return $this.z4o(take_1($this.e42_1, index) + insertOp.s4m_1 + substring_0($this.e42_1, index));
  }
  function thisThroughSetValue($this, setOp) {
    if (setOp.f4g_1 == null) {
      var addOp = AddChildOperation_init_$Create$_1($this.l41_1, $this.n41_1, $this.o41_1, false);
      var setValueOperation = new SetValueOperation(null, $this.e42_1);
      var changePropertyOperation = new ChangePropertyOperation($this.c42_1, setValueOperation);
      var childOp = new ChangeChildOperation_0($this.n41_1, $this.o41_1, changePropertyOperation);
      return CompositeOperation_init_$Create$([addOp, childOp]);
    }
    throw RuntimeException_init_$Create$_0('Transform ' + $this.toString() + ' through ' + setOp.toString());
  }
  function findStringOperation($this, op) {
    var tmp0_safe_receiver = SplitMergeOperationsUtil_instance.b4p(op, $this.c42_1, new Int32Array([$this.m4o()]));
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.o4o_1;
  }
  function Companion_65() {
  }
  var Companion_instance_65;
  function Companion_getInstance_65() {
    return Companion_instance_65;
  }
  function AddChildSplitPropertyOperation(conceptId, sourceId, addedId, addIndex, propertyId, _splitIndex, movedText) {
    BaseAddChildSplitOperation.call(this, conceptId, sourceId, addedId, addIndex, constructorIndex(Companion_instance_65, _splitIndex));
    this.c42_1 = propertyId;
    this.d42_1 = _splitIndex;
    this.e42_1 = movedText;
  }
  protoOf(AddChildSplitPropertyOperation).y4o = function () {
    return this.d42_1 === -1;
  };
  protoOf(AddChildSplitPropertyOperation).q4o = function () {
    return this.c42_1;
  };
  protoOf(AddChildSplitPropertyOperation).n4h = function (otherOp, server) {
    var compositeOp = SplitMergeOperationsUtil_instance.c4p(otherOp, new Int32Array([this.m4o()]));
    if (!(compositeOp == null))
      return this.z3x(compositeOp, server);
    var stringOp = findStringOperation(this, otherOp);
    if (!(stringOp == null)) {
      if (stringOp instanceof SetValueOperation) {
        return setValueThroughThis(this, stringOp instanceof SetValueOperation ? stringOp : THROW_CCE());
      }
      if (stringOp instanceof InsertTextOperation) {
        var result = insertThroughThis(this, stringOp);
        if (!(result == null)) {
          return result;
        }
      }
      if (stringOp instanceof DeleteTextOperation) {
        var result_0 = deleteThroughThis(this, stringOp);
        if (!(result_0 == null)) {
          return result_0;
        }
      }
      if (stringOp instanceof TextOperation) {
        var tmp;
        if (stringOp.m3p() >= this.p41_1) {
          var newOp = stringOp.p4d(stringOp.m3p() - this.p41_1 | 0);
          var changePropertyOperation = new ChangePropertyOperation(this.c42_1, newOp);
          tmp = new ChangeChildOperation_0(this.n41_1, this.o41_1, changePropertyOperation);
        } else {
          tmp = otherOp;
        }
        return tmp;
      }
    }
    if (otherOp instanceof AddChildSplitPropertyOperation) {
      var result_1 = splitThroughThis(this, otherOp, server);
      if (!(result_1 == null)) {
        return result_1;
      }
    }
    return protoOf(BaseAddChildSplitOperation).n4h.call(this, otherOp, server);
  };
  protoOf(AddChildSplitPropertyOperation).f43 = function (otherOp, server) {
    return this.n4h(otherOp, server);
  };
  protoOf(AddChildSplitPropertyOperation).p4i = function (otherOp, server) {
    var compositeOp = SplitMergeOperationsUtil_instance.c4p(otherOp, new Int32Array([this.m4o()]));
    if (!(compositeOp == null))
      return compositeOp.z3x(this, !server);
    var stringOp = findStringOperation(this, otherOp);
    if (!(stringOp == null)) {
      if (stringOp instanceof SetValueOperation) {
        var setValueOperation = (stringOp == null ? true : stringOp instanceof SetValueOperation) ? stringOp : THROW_CCE();
        return thisThroughSetValue(this, ensureNotNull(setValueOperation));
      }
      if (stringOp instanceof InsertTextOperation) {
        return thisThroughInsert(this, stringOp);
      }
      if (stringOp instanceof DeleteTextOperation) {
        return thisThroughDelete(this, stringOp);
      }
    }
    return protoOf(BaseAddChildSplitOperation).p4i.call(this, otherOp, server);
  };
  protoOf(AddChildSplitPropertyOperation).q43 = function (otherOp, server) {
    return this.p4i(otherOp, server);
  };
  protoOf(AddChildSplitPropertyOperation).p4d = function (newIndex) {
    return new AddChildSplitPropertyOperation(this.l41_1, this.m41_1, this.n41_1, newIndex, this.c42_1, this.d42_1, this.e42_1);
  };
  protoOf(AddChildSplitPropertyOperation).v4o = function (newSourceNodeId) {
    return new AddChildSplitPropertyOperation(this.l41_1, newSourceNodeId, this.n41_1, this.o41_1, this.c42_1, this.d42_1, this.e42_1);
  };
  protoOf(AddChildSplitPropertyOperation).s4o = function (newSplitIndex) {
    return new AddChildSplitPropertyOperation(this.l41_1, this.m41_1, this.n41_1, this.o41_1, this.c42_1, newSplitIndex, this.e42_1);
  };
  protoOf(AddChildSplitPropertyOperation).z4o = function (newMovedText) {
    return new AddChildSplitPropertyOperation(this.l41_1, this.m41_1, this.n41_1, this.o41_1, this.c42_1, this.d42_1, newMovedText);
  };
  protoOf(AddChildSplitPropertyOperation).w4o = function (newMoveSize) {
    return this.z4o(take_1(this.e42_1, newMoveSize));
  };
  protoOf(AddChildSplitPropertyOperation).d4i = function (model, nodeFactory) {
    var source = model.r(this.o41_1 - 1 | 0);
    this.u4o(source);
    var property = source.d3n(this.c42_1).uv();
    if (property == null) {
      // Inline function 'kotlin.check' call
      if (!this.y4o()) {
        var message = 'Use splitIndex=-1 to split null property';
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      }
      property = '';
    }
    var movedText = this.e42_1;
    // Inline function 'kotlin.check' call
    if (!(property.length === (this.p41_1 + movedText.length | 0))) {
      var message_0 = "Property value='" + property + "', split index=" + this.p41_1 + ", moved text='" + movedText + "'";
      throw IllegalStateException_init_$Create$_0(toString_1(message_0));
    }
    var textToMove = substring_0(property, this.p41_1);
    // Inline function 'kotlin.check' call
    if (!(textToMove === movedText)) {
      var message_1 = "Stored text to move='" + movedText + "', actual='" + textToMove + "'";
      throw IllegalStateException_init_$Create$_0(toString_1(message_1));
    }
    var parent = source.d3o();
    $l$block: {
      // Inline function 'kotlin.checkNotNull' call
      if (parent == null) {
        var message_2 = 'Null parent';
        throw IllegalStateException_init_$Create$_0(toString_1(message_2));
      } else {
        break $l$block;
      }
    }
    var newNode = nodeFactory.d3m(this.l41_1, this.n41_1);
    parent.w3p(newNode, ensureNotNull(source.l3p()), this.o41_1, this.c42_1, this.d42_1);
    return model;
  };
  protoOf(AddChildSplitPropertyOperation).y3x = function (model, nodeFactory) {
    return this.d4i((!(model == null) ? isInterface(model, KtMutableList) : false) ? model : THROW_CCE(), nodeFactory);
  };
  protoOf(AddChildSplitPropertyOperation).q3z = function () {
    return new MergePropertyRemoveChildOperation(this.l41_1, this.n41_1, this.m41_1, this.o41_1, this.c42_1, this.e42_1, this.d42_1);
  };
  protoOf(AddChildSplitPropertyOperation).toString = function () {
    return 'AddChildSplitProperty[' + this.x4o() + '; prop=' + this.c42_1.toString() + '; text=' + this.e42_1 + ']';
  };
  function AssertionUtil() {
  }
  protoOf(AssertionUtil).d4p = function (lhs, rhs) {
    // Inline function 'kotlin.check' call
    if (!!NodeUtil_instance.f3w(lhs, rhs)) {
      var message = 'IDs equal: ' + toString_0(lhs);
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
  };
  protoOf(AssertionUtil).e4p = function (lhs, rhs) {
    // Inline function 'kotlin.check' call
    if (!NodeUtil_instance.e3w(lhs, rhs)) {
      var message = 'IDs not equal: ' + toString_0(lhs) + ', ' + toString_0(rhs);
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
  };
  var AssertionUtil_instance;
  function AssertionUtil_getInstance() {
    return AssertionUtil_instance;
  }
  function getReplacingSourceMessage($this, addChildSplitOp, replaceOp) {
    return 'Detected replacing source item of ' + toString_1(addChildSplitOp) + ' with ' + replaceOp.toString();
  }
  function Companion_66() {
  }
  var Companion_instance_66;
  function Companion_getInstance_66() {
    return Companion_instance_66;
  }
  function BaseAddChildSplitOperation(conceptId, sourceNodeId, addedNodeId, addIndex, splitIndex) {
    BaseOperation.call(this);
    this.l41_1 = conceptId;
    this.m41_1 = sourceNodeId;
    this.n41_1 = addedNodeId;
    this.o41_1 = addIndex;
    this.p41_1 = splitIndex;
    this.q41_1 = Priority_HIGH_getInstance();
    this.r41_1 = 1;
    this.s41_1 = 1;
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.require' call
    if (!this.l41_1.m3q()) {
      var message = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
  }
  protoOf(BaseAddChildSplitOperation).o4d = function () {
    return this.q41_1;
  };
  protoOf(BaseAddChildSplitOperation).m3p = function () {
    return this.o41_1;
  };
  protoOf(BaseAddChildSplitOperation).a = function () {
    return this.r41_1;
  };
  protoOf(BaseAddChildSplitOperation).q4d = function () {
    return this.s41_1;
  };
  protoOf(BaseAddChildSplitOperation).m4o = function () {
    return this.o41_1 - 1 | 0;
  };
  protoOf(BaseAddChildSplitOperation).x4o = function () {
    return 'cid = ' + this.l41_1.toString() + '; srcId = ' + this.m41_1.toString() + '; addId = ' + this.n41_1.toString() + '; addIndex = ' + this.o41_1 + ('; splitIndex = ' + this.p41_1);
  };
  protoOf(BaseAddChildSplitOperation).n4h = function (otherOp, server) {
    if (otherOp instanceof BaseAddChildSplitOperation) {
      if (otherOp.n41_1.equals(this.n41_1) || otherOp.n41_1.equals(this.m41_1) || otherOp.m41_1.equals(this.n41_1)) {
        throw RuntimeException_init_$Create$();
      }
      if (otherOp.m41_1.equals(this.m41_1)) {
        if (!equals(this.q4o(), otherOp.q4o())) {
          throw RuntimeException_init_$Create$();
        }
        var tmp;
        if (this.p41_1 < otherOp.p41_1 || (this.p41_1 === otherOp.p41_1 && server)) {
          tmp = otherOp.v4o(this.n41_1).s4o(otherOp.p41_1 - this.p41_1 | 0).p4d(this.o41_1 + 1 | 0);
        } else {
          tmp = otherOp.w4o(this.p41_1 - otherOp.p41_1 | 0);
        }
        return tmp;
      }
      return (new IndexedOperationTransformer()).r4d(this, otherOp, server);
    }
    if (otherOp instanceof ChangeChildOperation_0) {
      if (otherOp.l3p() >= this.o41_1) {
        return otherOp.n4i(otherOp.l3p() + 1 | 0);
      }
    }
    if (otherOp instanceof RemoveChildOperation_0) {
      AssertionUtil_instance.d4p(this.n41_1, otherOp.v3w());
      if ((this.o41_1 - 1 | 0) === otherOp.m3p()) {
        AssertionUtil_instance.e4p(this.m41_1, otherOp.v3w());
        return RemoveChildOperation_init_$Create$_1(this.l41_1, this.m41_1, this.o41_1 - 1 | 0, false);
      }
    }
    if (otherOp instanceof ReplaceChildOperation) {
      // Inline function 'kotlin.check' call
      if (!!((this.o41_1 - 1 | 0) === otherOp.m3p())) {
        var message = getReplacingSourceMessage(Companion_instance_66, this, otherOp);
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      }
    }
    var tmp_0;
    if (otherOp instanceof BaseListItemOperation) {
      tmp_0 = (new IndexedOperationTransformer()).r4d(this, otherOp, server);
    } else {
      tmp_0 = protoOf(BaseOperation).f43.call(this, otherOp, server);
    }
    return tmp_0;
  };
  protoOf(BaseAddChildSplitOperation).f43 = function (otherOp, server) {
    return this.n4h(otherOp, server);
  };
  protoOf(BaseAddChildSplitOperation).p4i = function (otherOp, server) {
    if (otherOp instanceof RemoveChildOperation_0) {
      AssertionUtil_instance.d4p(this.n41_1, otherOp.v3w());
      if ((this.o41_1 - 1 | 0) === otherOp.m3p()) {
        AssertionUtil_instance.e4p(this.m41_1, otherOp.v3w());
        return AddChildOperation_init_$Create$_1(this.l41_1, this.n41_1, this.o41_1 - 1 | 0, false);
      }
    }
    if (otherOp instanceof ReplaceChildOperation) {
      // Inline function 'kotlin.check' call
      if (!!((this.o41_1 - 1 | 0) === otherOp.m3p())) {
        var message = getReplacingSourceMessage(Companion_instance_66, this, otherOp);
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      }
    }
    var tmp;
    if (otherOp instanceof BaseListItemOperation) {
      tmp = (new IndexedOperationTransformer()).r4d(otherOp, this, !server);
    } else {
      tmp = protoOf(BaseOperation).q43.call(this, otherOp, server);
    }
    return tmp;
  };
  protoOf(BaseAddChildSplitOperation).q43 = function (otherOp, server) {
    return this.p4i(otherOp, server);
  };
  protoOf(BaseAddChildSplitOperation).u4o = function (source) {
    // Inline function 'kotlin.check' call
    if (!this.l41_1.equals(source.e3m_1)) {
      var message = MessageBundle_instance.e3n(this.l41_1, source.e3m_1);
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    // Inline function 'kotlin.check' call
    if (!this.m41_1.equals(source.z3n())) {
      var message_0 = MessageBundle_instance.h3n(this.m41_1, source.z3n());
      throw IllegalStateException_init_$Create$_0(toString_1(message_0));
    }
  };
  function notNull_0($this, id) {
    var tmp;
    if (id == null) {
      throw IllegalArgumentException_init_$Create$_0('nodeId cannot be null');
    } else {
      tmp = id;
    }
    return tmp;
  }
  function getReplacingRemovedMessage($this, mergeRmChildOp, replaceOp) {
    return 'Detected replacing removed item of ' + toString_1(mergeRmChildOp) + ' with ' + replaceOp.toString();
  }
  function getReplacingTargetMessage($this, mergeRmChildOp, replaceOp) {
    return 'Detected replacing target item of ' + toString_1(mergeRmChildOp) + ' with ' + replaceOp.toString();
  }
  function Companion_67() {
  }
  var Companion_instance_67;
  function Companion_getInstance_67() {
    return Companion_instance_67;
  }
  function BaseMergeRemoveChildOperation(conceptId, removedNodeId, targetNodeId, removeIndex, targetLength) {
    BaseOperation.call(this);
    this.s40_1 = conceptId;
    this.t40_1 = removedNodeId;
    this.u40_1 = targetNodeId;
    this.v40_1 = removeIndex;
    this.w40_1 = targetLength;
    this.x40_1 = 1;
    this.y40_1 = -1;
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.require' call
    if (!this.s40_1.m3q()) {
      var message = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
  }
  protoOf(BaseMergeRemoveChildOperation).m3p = function () {
    return this.v40_1;
  };
  protoOf(BaseMergeRemoveChildOperation).a = function () {
    return this.x40_1;
  };
  protoOf(BaseMergeRemoveChildOperation).q4d = function () {
    return this.y40_1;
  };
  protoOf(BaseMergeRemoveChildOperation).x4o = function () {
    return 'cid = ' + this.s40_1.toString() + '; rmId = ' + this.t40_1.toString() + '; trgId = ' + this.u40_1.toString() + '; rmIndex = ' + this.v40_1 + ('; trgLen = ' + this.w40_1);
  };
  protoOf(BaseMergeRemoveChildOperation).n4h = function (otherOp, server) {
    if (otherOp instanceof ChangeChildOperation_0) {
      if (otherOp.l3p() === this.v40_1) {
        return new NopOperation();
      }
      if (otherOp.l3p() > this.v40_1) {
        return otherOp.n4i(otherOp.l3p() - 1 | 0);
      }
    }
    if (otherOp instanceof RemoveChildOperation_0) {
      var tmp;
      if (this.v40_1 === otherOp.m3p()) {
        AssertionUtil_instance.e4p(this.t40_1, otherOp.v3w());
        tmp = new NopOperation();
      } else if ((this.v40_1 - 1 | 0) === otherOp.m3p()) {
        AssertionUtil_instance.e4p(this.u40_1, otherOp.v3w());
        tmp = CompositeOperation_init_$Create$([this.q3z(), otherOp]);
      } else {
        tmp = (new IndexedOperationTransformer()).r4d(this, otherOp, server);
      }
      return tmp;
    }
    if (otherOp instanceof ReplaceChildOperation) {
      var tmp_0;
      if (this.v40_1 === otherOp.m3p()) {
        throw IllegalStateException_init_$Create$_0(getReplacingRemovedMessage(Companion_instance_67, this, otherOp));
      } else if ((this.v40_1 - 1 | 0) === otherOp.m3p()) {
        throw IllegalStateException_init_$Create$_0(getReplacingTargetMessage(Companion_instance_67, this, otherOp));
      } else {
        tmp_0 = (new IndexedOperationTransformer()).r4d(this, otherOp, server);
      }
      return tmp_0;
    }
    if (otherOp instanceof AddChildOperation_0) {
      var tmp_1;
      if (otherOp.m3p() === this.v40_1) {
        var tmp_2;
        if (otherOp.f3t().equals(this.s40_1)) {
          tmp_2 = this.g4p(notNull_0(Companion_instance_67, otherOp.v3w()));
        } else {
          tmp_2 = new NopOperation();
        }
        tmp_1 = tmp_2;
      } else {
        tmp_1 = (new IndexedOperationTransformer()).r4d(this, otherOp, server);
      }
      return tmp_1;
    }
    if (otherOp instanceof BaseMergeRemoveChildOperation) {
      // Inline function 'kotlin.check' call
      if (!equals(this.q4o(), otherOp.q4o())) {
        throw IllegalStateException_init_$Create$_0('Check failed.');
      }
      if (otherOp.t40_1.equals(this.t40_1)) {
        if (!otherOp.u40_1.equals(this.u40_1)) {
          throw RuntimeException_init_$Create$();
        }
        return new NopOperation();
      }
      if (otherOp.u40_1.equals(this.u40_1)) {
        throw RuntimeException_init_$Create$();
      }
      if (otherOp.u40_1.equals(this.t40_1)) {
        return otherOp.h4p(this.u40_1).i4p(this.w40_1 + otherOp.w40_1 | 0).p4d(this.v40_1);
      }
      var tmp_3;
      if (otherOp.t40_1.equals(this.u40_1)) {
        tmp_3 = otherOp.j4p(this);
      } else {
        tmp_3 = (new IndexedOperationTransformer()).r4d(this, otherOp, server);
      }
      return tmp_3;
    }
    return protoOf(BaseOperation).f43.call(this, otherOp, server);
  };
  protoOf(BaseMergeRemoveChildOperation).f43 = function (otherOp, server) {
    return this.n4h(otherOp, server);
  };
  protoOf(BaseMergeRemoveChildOperation).p4i = function (otherOp, server) {
    if (otherOp instanceof ChangeChildOperation_0) {
      if (otherOp.l3p() === this.v40_1) {
        return CompositeOperation_init_$Create$([otherOp.q3z(), this]);
      }
    }
    if (otherOp instanceof RemoveChildOperation_0) {
      var tmp;
      if (this.v40_1 === otherOp.m3p()) {
        AssertionUtil_instance.e4p(this.t40_1, otherOp.v3w());
        tmp = new NopOperation();
      } else if ((this.v40_1 - 1 | 0) === otherOp.m3p()) {
        AssertionUtil_instance.e4p(this.u40_1, otherOp.v3w());
        tmp = new NopOperation();
      } else {
        tmp = (new IndexedOperationTransformer()).r4d(otherOp, this, !server);
      }
      return tmp;
    }
    if (otherOp instanceof ReplaceChildOperation) {
      var tmp_0;
      if (this.v40_1 === otherOp.m3p()) {
        throw IllegalStateException_init_$Create$_0(getReplacingRemovedMessage(Companion_instance_67, this, otherOp));
      } else if ((this.v40_1 - 1 | 0) === otherOp.m3p()) {
        throw IllegalStateException_init_$Create$_0(getReplacingTargetMessage(Companion_instance_67, this, otherOp));
      } else {
        tmp_0 = (new IndexedOperationTransformer()).r4d(otherOp, this, !server);
      }
      return tmp_0;
    }
    if (otherOp instanceof AddChildOperation_0) {
      var tmp_1;
      if (otherOp.m3p() === this.v40_1) {
        var tmp_2;
        if (otherOp.f3t().equals(this.s40_1)) {
          tmp_2 = this.h4p(notNull_0(Companion_instance_67, otherOp.v3w())).i4p(this.f4p()).p4d(this.v40_1 + 1 | 0);
        } else {
          tmp_2 = CompositeOperation_init_$Create$([otherOp.q3z(), this]);
        }
        tmp_1 = tmp_2;
      } else {
        tmp_1 = (new IndexedOperationTransformer()).r4d(otherOp, this, !server);
      }
      return tmp_1;
    }
    return protoOf(BaseOperation).q43.call(this, otherOp, server);
  };
  protoOf(BaseMergeRemoveChildOperation).q43 = function (otherOp, server) {
    return this.p4i(otherOp, server);
  };
  protoOf(BaseMergeRemoveChildOperation).b4j = function (replaceRemovedItem) {
    throw IllegalStateException_init_$Create$();
  };
  protoOf(BaseMergeRemoveChildOperation).t4d = function (replaceRemovedItem) {
    return this.b4j(replaceRemovedItem);
  };
  protoOf(BaseMergeRemoveChildOperation).a4j = function (op) {
    throw UnsupportedOperationException_init_$Create$();
  };
  protoOf(BaseMergeRemoveChildOperation).s4d = function (op) {
    return this.a4j(op);
  };
  protoOf(BaseMergeRemoveChildOperation).k4p = function (toRemove, target) {
    // Inline function 'kotlin.check' call
    if (!toRemove.z3n().equals(this.t40_1)) {
      var message = 'To remove node: ' + MessageBundle_instance.h3n(this.t40_1, toRemove.z3n());
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    // Inline function 'kotlin.check' call
    if (!target.z3n().equals(this.u40_1)) {
      var message_0 = 'Target node: ' + MessageBundle_instance.h3n(this.u40_1, target.z3n());
      throw IllegalStateException_init_$Create$_0(toString_1(message_0));
    }
    // Inline function 'kotlin.check' call
    if (!this.s40_1.equals(toRemove.e3m_1)) {
      var message_1 = 'To remove node: ' + MessageBundle_instance.e3n(this.s40_1, toRemove.e3m_1);
      throw IllegalStateException_init_$Create$_0(toString_1(message_1));
    }
    // Inline function 'kotlin.check' call
    if (!this.s40_1.equals(target.e3m_1)) {
      var message_2 = 'Target node: ' + MessageBundle_instance.e3n(this.s40_1, target.e3m_1);
      throw IllegalStateException_init_$Create$_0(toString_1(message_2));
    }
  };
  function assertAddChildSplitChildCollectionIsValid($this, splitOp) {
    if (!splitOp.k4o_1.equals($this.t4p_1)) {
      throw RuntimeException_init_$Create$();
    }
    if (splitOp.n41_1.equals($this.u40_1) || splitOp.n41_1.equals($this.t40_1)) {
      throw RuntimeException_init_$Create$();
    }
  }
  function changeRemovedLength($this, newRemovedLength) {
    return new MergeChildCollectionRemoveChildOperation($this.s40_1, $this.t40_1, $this.u40_1, $this.v40_1, $this.t4p_1, newRemovedLength, $this.w40_1);
  }
  function findListOperation_0($this, op) {
    return SplitMergeOperationsUtil_instance.n4o(op, $this.t4p_1, new Int32Array([$this.m3p(), $this.m3p() - 1 | 0]));
  }
  function MergeChildCollectionRemoveChildOperation(conceptId, removedNodeId, targetNodeId, removeIndex, childId, removedLength, targetLength) {
    BaseMergeRemoveChildOperation.call(this, conceptId, removedNodeId, targetNodeId, removeIndex, targetLength);
    this.t4p_1 = childId;
    this.u4p_1 = removedLength;
  }
  protoOf(MergeChildCollectionRemoveChildOperation).f4p = function () {
    return 0;
  };
  protoOf(MergeChildCollectionRemoveChildOperation).q4o = function () {
    return this.t4p_1;
  };
  protoOf(MergeChildCollectionRemoveChildOperation).n4h = function (otherOp, server) {
    var compositeOp = SplitMergeOperationsUtil_instance.r4o(otherOp, new Int32Array([this.m3p(), this.m3p() - 1 | 0]));
    if (!(compositeOp == null))
      return this.z3x(compositeOp, server);
    var listOp = findListOperation_0(this, otherOp);
    if (!(listOp == null)) {
      var newOp = null;
      var tmp;
      var tmp_0 = listOp.o4o_1;
      if (tmp_0 instanceof ChangeChildOperation_0) {
        tmp = listOp.p4o_1 === this.m3p();
      } else {
        tmp = false;
      }
      if (tmp) {
        var changeOp = listOp.o4o_1;
        newOp = changeOp.n4i(changeOp.l3p() + this.w40_1 | 0);
      }
      var tmp_1;
      var tmp_2 = listOp.o4o_1;
      if (isInterface(tmp_2, IndexedOperation)) {
        tmp_1 = listOp.p4o_1 === this.m3p();
      } else {
        tmp_1 = false;
      }
      if (tmp_1) {
        var tmp_3 = listOp.o4o_1;
        var indexOp = isInterface(tmp_3, IndexedOperation) ? tmp_3 : THROW_CCE();
        newOp = indexOp.p4d(indexOp.m3p() + this.w40_1 | 0);
      }
      if (!(newOp == null)) {
        return new ChangeChildOperation_0(this.u40_1, this.v40_1 - 1 | 0, new ChildListOperation(this.t4p_1, newOp));
      }
    }
    if (otherOp instanceof AddChildSplitChildCollectionOperation) {
      assertAddChildSplitChildCollectionIsValid(this, otherOp);
      if (otherOp.m41_1.equals(this.t40_1)) {
        return otherOp.v4o(this.u40_1).p4d(this.v40_1).s4o(this.w40_1 + otherOp.p41_1 | 0);
      }
      var tmp_4;
      if (otherOp.m41_1.equals(this.u40_1)) {
        tmp_4 = otherOp.t4o(otherOp.l4o_1 + this.u4p_1 | 0);
      } else {
        tmp_4 = (new IndexedOperationTransformer()).r4d(this, otherOp, server);
      }
      return tmp_4;
    }
    return protoOf(BaseMergeRemoveChildOperation).n4h.call(this, otherOp, server);
  };
  protoOf(MergeChildCollectionRemoveChildOperation).f43 = function (otherOp, server) {
    return this.n4h(otherOp, server);
  };
  protoOf(MergeChildCollectionRemoveChildOperation).p4i = function (otherOp, server) {
    var compositeOp = SplitMergeOperationsUtil_instance.r4o(otherOp, new Int32Array([this.m3p(), this.m3p() - 1 | 0]));
    if (!(compositeOp == null))
      return compositeOp.z3x(this, !server);
    var listOp = findListOperation_0(this, otherOp);
    if (!(listOp == null)) {
      var tmp = listOp.o4o_1;
      if (tmp instanceof ChangeChildOperation_0) {
        return this;
      }
      var tmp_0 = listOp.o4o_1;
      if (isInterface(tmp_0, IndexedOperation)) {
        var tmp_1;
        if (listOp.p4o_1 === this.m3p()) {
          var tmp_2 = listOp.o4o_1;
          tmp_1 = changeRemovedLength(this, this.u4p_1 + (isInterface(tmp_2, IndexedOperation) ? tmp_2 : THROW_CCE()).q4d() | 0);
        } else {
          var tmp_3 = listOp.o4o_1;
          tmp_1 = this.i4p(this.w40_1 + (isInterface(tmp_3, IndexedOperation) ? tmp_3 : THROW_CCE()).q4d() | 0);
        }
        return tmp_1;
      }
    }
    if (otherOp instanceof AddChildSplitChildCollectionOperation) {
      assertAddChildSplitChildCollectionIsValid(this, otherOp);
      if (otherOp.m41_1.equals(this.t40_1)) {
        return changeRemovedLength(this, otherOp.p41_1);
      }
      var tmp_4;
      if (otherOp.m41_1.equals(this.u40_1)) {
        tmp_4 = this.h4p(otherOp.n41_1).i4p(otherOp.l4o_1).p4d(this.v40_1 + 1 | 0);
      } else {
        tmp_4 = (new IndexedOperationTransformer()).r4d(otherOp, this, !server);
      }
      return tmp_4;
    }
    return protoOf(BaseMergeRemoveChildOperation).p4i.call(this, otherOp, server);
  };
  protoOf(MergeChildCollectionRemoveChildOperation).q43 = function (otherOp, server) {
    return this.p4i(otherOp, server);
  };
  protoOf(MergeChildCollectionRemoveChildOperation).d4i = function (model, nodeFactory) {
    var toRemove = model.r(this.v40_1);
    var target = model.r(this.v40_1 - 1 | 0);
    this.k4p(toRemove, target);
    var removedChildren = toRemove.p3m(this.t4p_1);
    // Inline function 'kotlin.check' call
    if (!(removedChildren.p() === this.u4p_1)) {
      var message = "To remove node's children length: stored=" + this.u4p_1 + ', actual=' + removedChildren.p();
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    var targetChildren = target.p3m(this.t4p_1);
    // Inline function 'kotlin.check' call
    if (!(targetChildren.p() === this.w40_1)) {
      var message_0 = "Target node's children length: stored=" + this.w40_1 + ', actual=' + targetChildren.p();
      throw IllegalStateException_init_$Create$_0(toString_1(message_0));
    }
    var parent = toRemove.d3o();
    $l$block: {
      // Inline function 'kotlin.checkNotNull' call
      if (parent == null) {
        var message_1 = 'Null parent';
        throw IllegalStateException_init_$Create$_0(toString_1(message_1));
      } else {
        break $l$block;
      }
    }
    parent.z3p(toRemove, this.t4p_1);
    return model;
  };
  protoOf(MergeChildCollectionRemoveChildOperation).y3x = function (model, nodeFactory) {
    return this.d4i((!(model == null) ? isInterface(model, KtMutableList) : false) ? model : THROW_CCE(), nodeFactory);
  };
  protoOf(MergeChildCollectionRemoveChildOperation).q3z = function () {
    return new AddChildSplitChildCollectionOperation(this.s40_1, this.u40_1, this.t40_1, this.v40_1, this.t4p_1, this.w40_1, this.u4p_1);
  };
  protoOf(MergeChildCollectionRemoveChildOperation).g4p = function (addedNodeId) {
    return new AddChildSplitChildCollectionOperation(this.s40_1, this.u40_1, addedNodeId, this.v40_1, this.t4p_1, this.w40_1, this.u4p_1);
  };
  protoOf(MergeChildCollectionRemoveChildOperation).p4d = function (newIndex) {
    return new MergeChildCollectionRemoveChildOperation(this.s40_1, this.t40_1, this.u40_1, newIndex, this.t4p_1, this.u4p_1, this.w40_1);
  };
  protoOf(MergeChildCollectionRemoveChildOperation).h4p = function (newTargetNodeId) {
    return new MergeChildCollectionRemoveChildOperation(this.s40_1, this.t40_1, newTargetNodeId, this.v40_1, this.t4p_1, this.u4p_1, this.w40_1);
  };
  protoOf(MergeChildCollectionRemoveChildOperation).i4p = function (newTargetLength) {
    return new MergeChildCollectionRemoveChildOperation(this.s40_1, this.t40_1, this.u40_1, this.v40_1, this.t4p_1, this.u4p_1, newTargetLength);
  };
  protoOf(MergeChildCollectionRemoveChildOperation).j4p = function (mergeOp) {
    var operation = mergeOp instanceof MergeChildCollectionRemoveChildOperation ? mergeOp : THROW_CCE();
    return changeRemovedLength(this, this.u4p_1 + operation.u4p_1 | 0);
  };
  protoOf(MergeChildCollectionRemoveChildOperation).toString = function () {
    return 'MergeChildCollectionRemoveChild[' + this.x4o() + '; role=' + this.t4p_1.toString() + '; rmLen=' + this.u4p_1 + ']';
  };
  function _get_isMergeToNull__zf4w4f($this) {
    return $this.w40_1 === -1;
  }
  function setValueThroughThis_0($this, setOp) {
    var tmp;
    if (setOp.f4g_1 == null) {
      tmp = createChangeSourceProperty($this, new DeleteTextOperation($this.w40_1, $this.i41_1));
    } else {
      throw RuntimeException_init_$Create$_0('Transform ' + setOp.toString() + ' through ' + $this.toString());
    }
    return tmp;
  }
  function mergeThroughThis($this, otherOp) {
    var myMergeToNull = _get_isMergeToNull__zf4w4f($this);
    var theirMergeToNull = _get_isMergeToNull__zf4w4f(otherOp);
    if (($this.m3p() + 1 | 0) === otherOp.m3p()) {
      // Inline function 'kotlin.check' call
      if (!!theirMergeToNull) {
        var message = 'Merging empty node is prohibited';
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      }
      if (myMergeToNull) {
        return otherOp.p4d(otherOp.v40_1 - 1 | 0).h4p($this.u40_1);
      }
    }
    if ($this.m3p() === (otherOp.m3p() + 1 | 0)) {
      // Inline function 'kotlin.check' call
      if (!!myMergeToNull) {
        var message_0 = 'Merging empty node is prohibited';
        throw IllegalStateException_init_$Create$_0(toString_1(message_0));
      }
      if (theirMergeToNull) {
        return otherOp.j4p($this);
      }
    }
    return null;
  }
  function splitThroughThis_0($this, otherOp, server) {
    if (otherOp.n41_1.equals($this.u40_1) || otherOp.n41_1.equals($this.t40_1)) {
      throw RuntimeException_init_$Create$();
    }
    if (otherOp.m41_1.equals($this.t40_1)) {
      if (_get_isMergeToNull__zf4w4f($this)) {
        return otherOp.v4o($this.u40_1).p4d(otherOp.m3p() - 1 | 0);
      }
      var tmp;
      if (otherOp.y4o()) {
        tmp = otherOp.v4o($this.u40_1).p4d(otherOp.m3p() - 1 | 0).s4o($this.w40_1);
      } else {
        tmp = otherOp.v4o($this.u40_1).p4d($this.v40_1).s4o($this.w40_1 + otherOp.p41_1 | 0);
      }
      return tmp;
    }
    if (otherOp.m41_1.equals($this.u40_1)) {
      // Inline function 'kotlin.check' call
      if (!!_get_isMergeToNull__zf4w4f($this)) {
        var message = 'Split node that should have null property according to merge to null op';
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      }
      return otherOp.z4o(otherOp.e42_1 + $this.i41_1);
    }
    return (new IndexedOperationTransformer()).r4d($this, otherOp, server);
  }
  function insertThroughThis_0($this, insertOp, index) {
    if (_get_isMergeToNull__zf4w4f($this)) {
      if (isOperationOnMergeTarget($this, index)) {
        if (insertOp.a4p()) {
          return createChangeSourceProperty($this, insertOp.p4d(0));
        }
        throw IllegalStateException_init_$Create$_0('Merge into null but insert into not null target');
      }
      if (isOperationOnMergeSource_0($this, index)) {
        // Inline function 'kotlin.check' call
        if (!!insertOp.a4p()) {
          var message = 'Merge node and insert into null source';
          throw IllegalStateException_init_$Create$_0(toString_1(message));
        }
        return createChangeSourceProperty($this, insertOp);
      }
    }
    // Inline function 'kotlin.check' call
    if (!!insertOp.a4p()) {
      var message_0 = 'Impossible merge + insert transform';
      throw IllegalStateException_init_$Create$_0(toString_1(message_0));
    }
    return null;
  }
  function deleteThroughThis_0($this, deleteOp, index) {
    if (_get_isMergeToNull__zf4w4f($this)) {
      // Inline function 'kotlin.check' call
      if (!!isOperationOnMergeTarget($this, index)) {
        var message = 'Merge to null but delete from target';
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      }
      if (isOperationOnMergeSource_0($this, index)) {
        return createChangeSourceProperty($this, deleteOp);
      }
    }
    if (deleteOp.a4p()) {
      if (isOperationOnMergeTarget($this, index)) {
        return createChangeSourceProperty($this, deleteOp.p4d(0));
      }
      if (isOperationOnMergeSource_0($this, index)) {
        return createChangeSourceProperty($this, deleteOp.p4d($this.w40_1));
      }
    }
    return null;
  }
  function createChangeSourceProperty($this, innerOp) {
    var changePropertyOperation = new ChangePropertyOperation($this.h41_1, innerOp);
    return new ChangeChildOperation_0($this.u40_1, $this.v40_1 - 1 | 0, changePropertyOperation);
  }
  function thisThroughSetValue_0($this, setOp) {
    var tmp;
    if (setOp.f4g_1 == null) {
      tmp = RemoveChildOperation_init_$Create$_1($this.s40_1, $this.t40_1, $this.v40_1, false);
    } else {
      throw RuntimeException_init_$Create$_0('Transform ' + setOp.toString() + ' through ' + $this.toString());
    }
    return tmp;
  }
  function thisThroughSplit($this, splitOp, server) {
    if (splitOp.n41_1.equals($this.u40_1) || splitOp.n41_1.equals($this.t40_1)) {
      throw RuntimeException_init_$Create$();
    }
    var mergeToNull = _get_isMergeToNull__zf4w4f($this);
    var splitLeavingNull = splitOp.y4o();
    if (splitOp.m41_1.equals($this.t40_1)) {
      if (mergeToNull) {
        var tmp;
        if (splitLeavingNull) {
          tmp = RemoveChildOperation_init_$Create$_1($this.s40_1, $this.t40_1, $this.v40_1, false);
        } else {
          tmp = changeMergedProperty($this, take_1($this.i41_1, splitOp.p41_1));
        }
        return tmp;
      }
      var tmp_0;
      if (splitLeavingNull) {
        tmp_0 = RemoveChildOperation_init_$Create$_1($this.s40_1, $this.t40_1, $this.v40_1, false);
      } else {
        tmp_0 = changeMergedProperty($this, take_1($this.i41_1, splitOp.p41_1));
      }
      return tmp_0;
    }
    if (splitOp.m41_1.equals($this.u40_1)) {
      // Inline function 'kotlin.check' call
      if (!!mergeToNull) {
        var message = 'Split node that should have null property according to merge to null op';
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      }
      var tmp_1;
      if (splitLeavingNull) {
        tmp_1 = $this.p4d($this.v40_1 + 1 | 0).h4p(splitOp.n41_1);
      } else {
        tmp_1 = $this.h4p(splitOp.n41_1).i4p(splitOp.e42_1.length).p4d($this.v40_1 + 1 | 0);
      }
      return tmp_1;
    }
    return (new IndexedOperationTransformer()).r4d(splitOp, $this, !server);
  }
  function thisThroughInsert_0($this, insertOp, index, nodeFactory) {
    if (_get_isMergeToNull__zf4w4f($this)) {
      if (isOperationOnMergeTarget($this, index)) {
        if (insertOp.a4p()) {
          return $this.i4p(insertOp.a());
        }
        throw IllegalStateException_init_$Create$_0('Merging into null but inserting into non-null target');
      }
      if (isOperationOnMergeSource_0($this, index)) {
        // Inline function 'kotlin.check' call
        if (!!insertOp.a4p()) {
          var message = 'Merging and inserting into null source';
          throw IllegalStateException_init_$Create$_0(toString_1(message));
        }
        return changeMergedProperty($this, ensureNotNull(insertOp.c4q($this.i41_1, nodeFactory)));
      }
    }
    // Inline function 'kotlin.check' call
    if (!!insertOp.a4p()) {
      var message_0 = 'Impossible merge + insert transform';
      throw IllegalStateException_init_$Create$_0(toString_1(message_0));
    }
    var tmp;
    if (isOperationOnMergeTarget($this, index)) {
      tmp = $this.i4p($this.w40_1 + insertOp.a() | 0);
    } else {
      tmp = null;
    }
    return tmp;
  }
  function thisThroughDelete_0($this, deleteOp, index, nodeFactory) {
    if (_get_isMergeToNull__zf4w4f($this)) {
      // Inline function 'kotlin.check' call
      if (!!isOperationOnMergeTarget($this, index)) {
        var message = 'Merge to null but delete in target';
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      }
      if (isOperationOnMergeSource_0($this, index)) {
        var tmp;
        if (deleteOp.a4p()) {
          tmp = RemoveChildOperation_init_$Create$_1($this.s40_1, $this.t40_1, $this.v40_1, false);
        } else {
          tmp = changeMergedProperty($this, ensureNotNull(deleteOp.c4q($this.i41_1, nodeFactory)));
        }
        return tmp;
      }
    }
    if (deleteOp.a4p()) {
      if (isOperationOnMergeTarget($this, index)) {
        return $this.i4p(-1);
      }
      if (isOperationOnMergeSource_0($this, index)) {
        return RemoveChildOperation_init_$Create$_1($this.s40_1, $this.t40_1, $this.v40_1, false);
      }
    }
    var tmp_0;
    if (isOperationOnMergeTarget($this, index)) {
      tmp_0 = $this.i4p($this.w40_1 - deleteOp.a() | 0);
    } else {
      tmp_0 = null;
    }
    return tmp_0;
  }
  function isOperationOnMergeTarget($this, index) {
    return index === ($this.m3p() - 1 | 0);
  }
  function isOperationOnMergeSource($this, op) {
    return isOperationOnMergeSource_0($this, op.p4o_1);
  }
  function isOperationOnMergeSource_0($this, index) {
    return index === $this.m3p();
  }
  function changeMergedProperty($this, newMergedProperty) {
    return new MergePropertyRemoveChildOperation($this.s40_1, $this.t40_1, $this.u40_1, $this.v40_1, $this.h41_1, newMergedProperty, $this.w40_1);
  }
  function findStringOperation_0($this, op) {
    return SplitMergeOperationsUtil_instance.b4p(op, $this.h41_1, new Int32Array([$this.m3p(), $this.m3p() - 1 | 0]));
  }
  function MergePropertyRemoveChildOperation(conceptId, removedId, targetId, removeIndex, propertyId, mergedProperty, targetPropertyLength) {
    BaseMergeRemoveChildOperation.call(this, conceptId, removedId, targetId, removeIndex, targetPropertyLength);
    this.h41_1 = propertyId;
    this.i41_1 = mergedProperty;
    this.j41_1 = -1;
  }
  protoOf(MergePropertyRemoveChildOperation).f4p = function () {
    return this.j41_1;
  };
  protoOf(MergePropertyRemoveChildOperation).q4o = function () {
    return this.h41_1;
  };
  protoOf(MergePropertyRemoveChildOperation).n4h = function (otherOp, server) {
    var compositeOp = SplitMergeOperationsUtil_instance.c4p(otherOp, new Int32Array([this.m3p(), this.m3p() - 1 | 0]));
    if (!(compositeOp == null))
      return this.z3x(compositeOp, server);
    var op = findStringOperation_0(this, otherOp);
    if (!(op == null)) {
      var stringOp = op.o4o_1;
      if (stringOp instanceof SetValueOperation) {
        var setOp = stringOp instanceof SetValueOperation ? stringOp : THROW_CCE();
        return setValueThroughThis_0(this, setOp);
      }
      if (stringOp instanceof InsertTextOperation) {
        var result = insertThroughThis_0(this, stringOp, op.p4o_1);
        if (!(result == null)) {
          return result;
        }
      }
      if (stringOp instanceof DeleteTextOperation) {
        var result_0 = deleteThroughThis_0(this, stringOp, op.p4o_1);
        if (!(result_0 == null)) {
          return result_0;
        }
      }
      var tmp;
      if (isOperationOnMergeSource(this, op)) {
        tmp = stringOp instanceof TextOperation;
      } else {
        tmp = false;
      }
      if (tmp) {
        var newOp = stringOp.p4d(stringOp.m3p() + this.w40_1 | 0);
        return createChangeSourceProperty(this, newOp);
      }
    }
    if (otherOp instanceof AddChildSplitPropertyOperation) {
      return splitThroughThis_0(this, otherOp, server);
    }
    if (otherOp instanceof MergePropertyRemoveChildOperation) {
      var mergeOp = mergeThroughThis(this, otherOp);
      if (!(mergeOp == null))
        return mergeOp;
    }
    return protoOf(BaseMergeRemoveChildOperation).n4h.call(this, otherOp, server);
  };
  protoOf(MergePropertyRemoveChildOperation).f43 = function (otherOp, server) {
    return this.n4h(otherOp, server);
  };
  protoOf(MergePropertyRemoveChildOperation).p4i = function (otherOp, server) {
    var compositeOp = SplitMergeOperationsUtil_instance.c4p(otherOp, new Int32Array([this.m3p(), this.m3p() - 1 | 0]));
    if (!(compositeOp == null))
      return compositeOp.z3x(this, !server);
    var op = findStringOperation_0(this, otherOp);
    if (!(op == null)) {
      var stringOp = op.o4o_1;
      if (stringOp instanceof SetValueOperation) {
        var setOp = stringOp instanceof SetValueOperation ? stringOp : THROW_CCE();
        return thisThroughSetValue_0(this, setOp);
      }
      if (stringOp instanceof InsertTextOperation) {
        var result = thisThroughInsert_0(this, stringOp, op.p4o_1, RawNodeFactory_instance);
        if (!(result == null)) {
          return result;
        }
      }
      if (stringOp instanceof DeleteTextOperation) {
        var result_0 = thisThroughDelete_0(this, stringOp, op.p4o_1, RawNodeFactory_instance);
        if (!(result_0 == null)) {
          return result_0;
        }
      }
      if (isOperationOnMergeSource(this, op)) {
        if (stringOp instanceof TextOperation) {
          return changeMergedProperty(this, ensureNotNull(stringOp.c4q(this.i41_1, RawNodeFactory_instance)));
        }
      }
    }
    var tmp;
    if (otherOp instanceof AddChildSplitPropertyOperation) {
      tmp = thisThroughSplit(this, otherOp, server);
    } else {
      tmp = protoOf(BaseMergeRemoveChildOperation).p4i.call(this, otherOp, server);
    }
    return tmp;
  };
  protoOf(MergePropertyRemoveChildOperation).q43 = function (otherOp, server) {
    return this.p4i(otherOp, server);
  };
  protoOf(MergePropertyRemoveChildOperation).g4p = function (addedNodeId) {
    return new AddChildSplitPropertyOperation(this.s40_1, this.u40_1, addedNodeId, this.v40_1, this.h41_1, this.w40_1, this.i41_1);
  };
  protoOf(MergePropertyRemoveChildOperation).i4p = function (newTargetLength) {
    return new MergePropertyRemoveChildOperation(this.s40_1, this.t40_1, this.u40_1, this.v40_1, this.h41_1, this.i41_1, newTargetLength);
  };
  protoOf(MergePropertyRemoveChildOperation).h4p = function (newTargetNodeId) {
    return new MergePropertyRemoveChildOperation(this.s40_1, this.t40_1, newTargetNodeId, this.v40_1, this.h41_1, this.i41_1, this.w40_1);
  };
  protoOf(MergePropertyRemoveChildOperation).p4d = function (newIndex) {
    return new MergePropertyRemoveChildOperation(this.s40_1, this.t40_1, this.u40_1, newIndex, this.h41_1, this.i41_1, this.w40_1);
  };
  protoOf(MergePropertyRemoveChildOperation).j4p = function (mergeOp) {
    var mergePropertyRemoveChildOperation = mergeOp instanceof MergePropertyRemoveChildOperation ? mergeOp : THROW_CCE();
    return changeMergedProperty(this, this.i41_1 + mergePropertyRemoveChildOperation.i41_1);
  };
  protoOf(MergePropertyRemoveChildOperation).d4i = function (model, nodeFactory) {
    var toRemove = model.r(this.v40_1);
    var target = model.r(this.v40_1 - 1 | 0);
    this.k4p(toRemove, target);
    var targetProperty = target.d3n(this.h41_1).uv();
    var targetLength = this.w40_1;
    if (targetProperty == null) {
      // Inline function 'kotlin.check' call
      if (!(targetLength === -1)) {
        var message = 'Use targetLength=-1 to merge into null';
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      }
      targetProperty = '';
      targetLength = 0;
    }
    // Inline function 'kotlin.check' call
    if (!(targetProperty.length === targetLength)) {
      var message_0 = 'Target property length: stored=' + targetLength + ', actual=' + targetProperty.length;
      throw IllegalStateException_init_$Create$_0(toString_1(message_0));
    }
    var mergedProperty = toRemove.d3n(this.h41_1).uv();
    // Inline function 'kotlin.check' call
    if (!(mergedProperty === this.i41_1)) {
      var message_1 = "Stored merged property value='" + this.i41_1 + "', actual='" + mergedProperty + "'";
      throw IllegalStateException_init_$Create$_0(toString_1(message_1));
    }
    var parent = target.d3o();
    $l$block: {
      // Inline function 'kotlin.checkNotNull' call
      if (parent == null) {
        var message_2 = 'Null parent';
        throw IllegalStateException_init_$Create$_0(toString_1(message_2));
      } else {
        break $l$block;
      }
    }
    parent.y3p(toRemove, this.h41_1);
    return model;
  };
  protoOf(MergePropertyRemoveChildOperation).y3x = function (model, nodeFactory) {
    return this.d4i((!(model == null) ? isInterface(model, KtMutableList) : false) ? model : THROW_CCE(), nodeFactory);
  };
  protoOf(MergePropertyRemoveChildOperation).q3z = function () {
    return new AddChildSplitPropertyOperation(this.s40_1, this.u40_1, this.t40_1, this.v40_1, this.h41_1, this.w40_1, this.i41_1);
  };
  protoOf(MergePropertyRemoveChildOperation).toString = function () {
    return 'MergePropertyRemoveChild[' + this.x4o() + '; prop=' + this.h41_1.toString() + '; text=' + this.i41_1 + ']';
  };
  function getCompositeOperation($this, op, provider, indexes) {
    var tmp0_elvis_lhs = getChangeChildOperation($this, op, indexes.slice());
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var changeOp = tmp;
    var changeOpOperation = changeOp.s3z();
    if (changeOpOperation instanceof CompositeOperation) {
      var compositeOp = changeOpOperation instanceof CompositeOperation ? changeOpOperation : THROW_CCE();
      var operations = ArrayList_init_$Create$_0(compositeOp.j3w().p());
      var _iterator__ex2g4s = compositeOp.j3w().m();
      while (_iterator__ex2g4s.n()) {
        var nodeOp = _iterator__ex2g4s.o();
        operations.j(new ChangeChildOperation_0(changeOp.l4i_1, changeOp.l3p(), nodeOp));
      }
      return Companion_instance_68.b40(operations);
    }
    if (provider.e4q(changeOpOperation)) {
      var nodeOp_0 = changeOpOperation instanceof TargetedOperation ? changeOpOperation : THROW_CCE();
      var tmp_0 = nodeOp_0.s3z();
      if (tmp_0 instanceof CompositeOperation) {
        var tmp_1 = nodeOp_0.s3z();
        var compositeOp_0 = tmp_1 instanceof CompositeOperation ? tmp_1 : THROW_CCE();
        var operations_0 = ArrayList_init_$Create$_0(compositeOp_0.j3w().p());
        var _iterator__ex2g4s_0 = compositeOp_0.j3w().m();
        while (_iterator__ex2g4s_0.n()) {
          var listOp = _iterator__ex2g4s_0.o();
          operations_0.j(new ChangeChildOperation_0(changeOp.l4i_1, changeOp.l3p(), provider.d4q(nodeOp_0.l3p(), listOp)));
        }
        return Companion_instance_68.b40(operations_0);
      }
    }
    if (changeOpOperation instanceof ChildListOperation) {
      var operation = changeOpOperation.s3z();
      if (operation instanceof CompositeOperation) {
        var compositeOp_1 = operation instanceof CompositeOperation ? operation : THROW_CCE();
        var compositeOpOperations = compositeOp_1.j3w();
        var operations_1 = ArrayList_init_$Create$_0(compositeOpOperations.p());
        var _iterator__ex2g4s_1 = compositeOpOperations.m();
        while (_iterator__ex2g4s_1.n()) {
          var listOp_0 = _iterator__ex2g4s_1.o();
          operations_1.j(new ChangeChildOperation_0(changeOp.l4i_1, changeOp.l3p(), new ChildListOperation(changeOpOperation.l3p(), listOp_0)));
        }
        return Companion_instance_68.b40(operations_1);
      }
    }
    return null;
  }
  function getNodeOperation($this, op, nodeOperationCondition, role, indexes) {
    var tmp0_elvis_lhs = getChangeChildOperation($this, op, indexes.slice());
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var changeOp = tmp;
    var changeOpOperation = changeOp.s3z();
    if (!nodeOperationCondition.x42(changeOpOperation))
      return null;
    var targetedOp = changeOpOperation instanceof TargetedOperation ? changeOpOperation : THROW_CCE();
    return !equals(targetedOp.l3p(), role) ? null : new NodeOperation(targetedOp.s3z(), changeOp.l3p());
  }
  function getChangeChildOperation($this, op, indexes) {
    if (!(op instanceof ChangeChildOperation_0))
      return null;
    var found = false;
    var inductionVariable = 0;
    var last = indexes.length;
    while (inductionVariable < last) {
      var index = indexes[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (index === op.l3p())
        found = true;
    }
    return !found ? null : op;
  }
  function NodeOperation(op, index) {
    this.o4o_1 = op;
    this.p4o_1 = index;
  }
  protoOf(NodeOperation).toString = function () {
    return 'NodeOperation(op=' + toString_1(this.o4o_1) + ', index=' + this.p4o_1 + ')';
  };
  protoOf(NodeOperation).hashCode = function () {
    var result = hashCode(this.o4o_1);
    result = imul(result, 31) + this.p4o_1 | 0;
    return result;
  };
  protoOf(NodeOperation).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof NodeOperation))
      return false;
    if (!equals(this.o4o_1, other.o4o_1))
      return false;
    if (!(this.p4o_1 === other.p4o_1))
      return false;
    return true;
  };
  function SplitMergeOperationsUtil$getChildCollectionCompositeOperation$provider$1() {
  }
  protoOf(SplitMergeOperationsUtil$getChildCollectionCompositeOperation$provider$1).e4q = function (nodeOp) {
    return nodeOp instanceof ChildListOperation;
  };
  protoOf(SplitMergeOperationsUtil$getChildCollectionCompositeOperation$provider$1).f4q = function (role, op) {
    return new ChildListOperation(role, op);
  };
  protoOf(SplitMergeOperationsUtil$getChildCollectionCompositeOperation$provider$1).d4q = function (role, op) {
    return this.f4q(role instanceof NodeChildId ? role : THROW_CCE(), op);
  };
  function SplitMergeOperationsUtil$getPropertyCompositeOperation$provider$1() {
  }
  protoOf(SplitMergeOperationsUtil$getPropertyCompositeOperation$provider$1).e4q = function (nodeOp) {
    return nodeOp instanceof ChangePropertyOperation;
  };
  protoOf(SplitMergeOperationsUtil$getPropertyCompositeOperation$provider$1).g4q = function (role, op) {
    return new ChangePropertyOperation(role, op);
  };
  protoOf(SplitMergeOperationsUtil$getPropertyCompositeOperation$provider$1).d4q = function (role, op) {
    return this.g4q(role instanceof NodePropertyId ? role : THROW_CCE(), op);
  };
  function SplitMergeOperationsUtil$findListOperation$nodeOperationCondition$1() {
    OperationCondition.call(this);
  }
  protoOf(SplitMergeOperationsUtil$findListOperation$nodeOperationCondition$1).q40 = function (op) {
    return op instanceof ChildListOperation;
  };
  function SplitMergeOperationsUtil$findStringOperation$nodeOperationCondition$1() {
    OperationCondition.call(this);
  }
  protoOf(SplitMergeOperationsUtil$findStringOperation$nodeOperationCondition$1).q40 = function (op) {
    return op instanceof ChangePropertyOperation;
  };
  function SplitMergeOperationsUtil() {
  }
  protoOf(SplitMergeOperationsUtil).r4o = function (op, indexes) {
    var provider = new SplitMergeOperationsUtil$getChildCollectionCompositeOperation$provider$1();
    return getCompositeOperation(this, op, provider, indexes.slice());
  };
  protoOf(SplitMergeOperationsUtil).c4p = function (op, indexes) {
    var provider = new SplitMergeOperationsUtil$getPropertyCompositeOperation$provider$1();
    return getCompositeOperation(this, op, provider, indexes.slice());
  };
  protoOf(SplitMergeOperationsUtil).n4o = function (op, childId, nodeIds) {
    var nodeOperationCondition = new SplitMergeOperationsUtil$findListOperation$nodeOperationCondition$1();
    return getNodeOperation(this, op, nodeOperationCondition, childId, nodeIds.slice());
  };
  protoOf(SplitMergeOperationsUtil).b4p = function (op, propertyId, nodeIds) {
    var nodeOperationCondition = new SplitMergeOperationsUtil$findStringOperation$nodeOperationCondition$1();
    return getNodeOperation(this, op, nodeOperationCondition, propertyId, nodeIds.slice());
  };
  var SplitMergeOperationsUtil_instance;
  function SplitMergeOperationsUtil_getInstance() {
    return SplitMergeOperationsUtil_instance;
  }
  function AnnotatedOperation(author, changeTime, operation) {
    BaseOperation.call(this);
    this.c4e_1 = author;
    this.d4e_1 = changeTime;
    this.e4e_1 = operation;
  }
  protoOf(AnnotatedOperation).r3x = function () {
    return this.e4e_1.r3x();
  };
  protoOf(AnnotatedOperation).j3w = function () {
    return listOf(this.e4e_1);
  };
  protoOf(AnnotatedOperation).y3x = function (model, nodeFactory) {
    return this.e4e_1.y3x(model, nodeFactory);
  };
  protoOf(AnnotatedOperation).q3z = function () {
    return this.u4g(this.e4e_1.q3z());
  };
  protoOf(AnnotatedOperation).f43 = function (otherOp, server) {
    return this.e4e_1.z3x(otherOp, server);
  };
  protoOf(AnnotatedOperation).q43 = function (otherOp, server) {
    return this.u4g(otherOp.z3x(this.e4e_1, server));
  };
  protoOf(AnnotatedOperation).toString = function () {
    return 'Annotated[a = ' + this.c4e_1 + ';t = ' + this.d4e_1.toString() + ';o = ' + toString_1(this.e4e_1) + ']';
  };
  protoOf(AnnotatedOperation).s43 = function (indent) {
    return indent + 'Annotated[a = ' + this.c4e_1 + ';t = ' + this.d4e_1.toString() + ';o = \n' + this.e4e_1.s43(indent + '  ') + indent + ']\n';
  };
  protoOf(AnnotatedOperation).u4g = function (operation) {
    return new AnnotatedOperation(this.c4e_1, this.d4e_1, operation);
  };
  function BaseOperation() {
    this.e43_1 = false;
  }
  protoOf(BaseOperation).r3x = function () {
    return this.e43_1;
  };
  protoOf(BaseOperation).z3x = function (otherOp, server) {
    var tmp;
    if (this.r3x()) {
      tmp = otherOp;
    } else {
      tmp = this.f43(otherOp, server);
    }
    return tmp;
  };
  protoOf(BaseOperation).f43 = function (otherOp, server) {
    var tmp;
    if (otherOp instanceof BaseOperation) {
      var baseOperation = otherOp instanceof BaseOperation ? otherOp : THROW_CCE();
      tmp = baseOperation.q43(this, server);
    } else {
      tmp = otherOp;
    }
    return tmp;
  };
  protoOf(BaseOperation).q43 = function (otherOp, server) {
    return this;
  };
  protoOf(BaseOperation).r43 = function () {
    return this.s43('');
  };
  protoOf(BaseOperation).s43 = function (indent) {
    return indent + toString_1(this) + '\n';
  };
  function expandCompositesAndRemoveNops($this, ops) {
    var result = ArrayList_init_$Create$();
    var _iterator__ex2g4s = ops.m();
    while (_iterator__ex2g4s.n()) {
      var op = _iterator__ex2g4s.o();
      if (op instanceof CompositeOperation) {
        var composite = op instanceof CompositeOperation ? op : THROW_CCE();
        var expanded = expandCompositesAndRemoveNops($this, composite.j3w());
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!expanded.s()) {
          result.q(expanded);
        }
      } else {
        if (!(op instanceof NopOperation)) {
          result.j(op);
        }
      }
    }
    return result;
  }
  function CompositeOperation_init_$Init$(ops, $this) {
    CompositeOperation.call($this, toList(ops));
    return $this;
  }
  function CompositeOperation_init_$Create$(ops) {
    return CompositeOperation_init_$Init$(ops, objectCreate(protoOf(CompositeOperation)));
  }
  function executeWithConsecutive($this, model, nodeFactory) {
    var result = model;
    var i = 0;
    while (i < $this.f4a_1.p()) {
      var operation = $this.f4a_1.r(i);
      var executionResult = Companion_getInstance_69().n4d_1;
      if (isInterface(operation, WithConsecutiveOperation)) {
        var restOps = subListTail_0($this.f4a_1, i);
        var withConsecutiveOperation = isInterface(operation, WithConsecutiveOperation) ? operation : THROW_CCE();
        executionResult = withConsecutiveOperation.p43(model, restOps, nodeFactory);
      }
      if (!executionResult.i4m_1) {
        result = operation.y3x(result, nodeFactory);
        i = i + 1 | 0;
      } else {
        i = i + executionResult.j4m_1 | 0;
      }
    }
    return result;
  }
  function Companion_68() {
  }
  protoOf(Companion_68).b40 = function (ops) {
    var opsList = ops;
    opsList = expandCompositesAndRemoveNops(this, opsList);
    var size = opsList.p();
    if (size === 0) {
      return new NopOperation();
    } else if (size === 1) {
      return opsList.r(0);
    }
    return new CompositeOperation(opsList, false);
  };
  protoOf(Companion_68).s47 = function (ops) {
    return this.b40(toList(ops));
  };
  var Companion_instance_68;
  function Companion_getInstance_68() {
    return Companion_instance_68;
  }
  function CompositeOperation(ops, expand) {
    expand = expand === VOID ? true : expand;
    CustomExecuteOperation.call(this);
    this.f4a_1 = ArrayList_init_$Create$();
    this.g4a_1 = false;
    this.f4a_1.q(expand ? expandCompositesAndRemoveNops(Companion_instance_68, ops) : ops);
    this.g4a_1 = true;
    var _iterator__ex2g4s = this.f4a_1.m();
    while (_iterator__ex2g4s.n()) {
      var op = _iterator__ex2g4s.o();
      if (!op.r3x()) {
        this.g4a_1 = false;
      }
    }
  }
  protoOf(CompositeOperation).r3x = function () {
    return this.g4a_1;
  };
  protoOf(CompositeOperation).j3w = function () {
    return this.f4a_1;
  };
  protoOf(CompositeOperation).q3z = function () {
    var inverseOps = ArrayList_init_$Create$();
    var _iterator__ex2g4s = this.f4a_1.m();
    while (_iterator__ex2g4s.n()) {
      var op = _iterator__ex2g4s.o();
      inverseOps.j(op.q3z());
    }
    reverse(inverseOps);
    return Companion_instance_68.b40(inverseOps);
  };
  protoOf(CompositeOperation).c49 = function (model, customExecute, nodeFactory) {
    var tmp;
    if (customExecute) {
      tmp = executeWithConsecutive(this, model, nodeFactory);
    } else {
      var result = model;
      var _iterator__ex2g4s = this.f4a_1.m();
      while (_iterator__ex2g4s.n()) {
        var operation = _iterator__ex2g4s.o();
        var tmp_0;
        if (operation instanceof CustomExecuteOperation) {
          tmp_0 = operation.c49(result, false, nodeFactory);
        } else {
          tmp_0 = operation.y3x(result, nodeFactory);
        }
        result = tmp_0;
      }
      tmp = result;
    }
    return tmp;
  };
  protoOf(CompositeOperation).f43 = function (otherOp, server) {
    var result = otherOp;
    var _iterator__ex2g4s = this.f4a_1.m();
    while (_iterator__ex2g4s.n()) {
      var operation = _iterator__ex2g4s.o();
      result = operation.z3x(result, server);
    }
    return result;
  };
  protoOf(CompositeOperation).q43 = function (otherOp, server) {
    var currentOp = otherOp;
    var newOps = ArrayList_init_$Create$();
    var _iterator__ex2g4s = this.f4a_1.m();
    while (_iterator__ex2g4s.n()) {
      var operation = _iterator__ex2g4s.o();
      newOps.j(currentOp.z3x(operation, server));
      currentOp = operation.z3x(currentOp, !server);
    }
    return Companion_instance_68.b40(newOps);
  };
  protoOf(CompositeOperation).toString = function () {
    return 'Composite' + this.f4a_1.toString();
  };
  protoOf(CompositeOperation).s43 = function (indent) {
    var builder = (new StringBuilder(indent)).j8('Composite[\n');
    var _iterator__ex2g4s = this.f4a_1.m();
    while (_iterator__ex2g4s.n()) {
      var operation = _iterator__ex2g4s.o();
      builder.j8(operation.s43(indent + '  '));
    }
    builder.j8(indent).j8(']\n');
    return builder.toString();
  };
  function CustomExecuteOperation() {
    BaseOperation.call(this);
  }
  protoOf(CustomExecuteOperation).y3x = function (model, nodeFactory) {
    return this.c49(model, true, nodeFactory);
  };
  function ExecutionResult_init_$Init$(appliedCommandsCount, $this) {
    ExecutionResult.call($this, true, appliedCommandsCount);
    return $this;
  }
  function ExecutionResult_init_$Create$(appliedCommandsCount) {
    return ExecutionResult_init_$Init$(appliedCommandsCount, objectCreate(protoOf(ExecutionResult)));
  }
  function Companion_69() {
    Companion_instance_69 = this;
    this.n4d_1 = new ExecutionResult(false, 0);
  }
  var Companion_instance_69;
  function Companion_getInstance_69() {
    if (Companion_instance_69 == null)
      new Companion_69();
    return Companion_instance_69;
  }
  function ExecutionResult(applied, appliedOperationsCount) {
    Companion_getInstance_69();
    this.i4m_1 = applied;
    this.j4m_1 = appliedOperationsCount;
  }
  function HasOperationTargetData() {
  }
  function NoSubjectOperation() {
    BaseOperation.call(this);
  }
  function NopOperation() {
    NoSubjectOperation.call(this);
    this.i4q_1 = true;
  }
  protoOf(NopOperation).r3x = function () {
    return this.i4q_1;
  };
  protoOf(NopOperation).y3x = function (model, nodeFactory) {
    return model;
  };
  protoOf(NopOperation).q3z = function () {
    return new NopOperation();
  };
  protoOf(NopOperation).toString = function () {
    return 'Nop';
  };
  function Operation() {
  }
  function OperationContainer() {
  }
  var OperationKind_ADD_instance;
  var OperationKind_REMOVE_instance;
  var OperationKind_CHANGE_instance;
  var OperationKind_entriesInitialized;
  function OperationKind_initEntries() {
    if (OperationKind_entriesInitialized)
      return Unit_instance;
    OperationKind_entriesInitialized = true;
    OperationKind_ADD_instance = new OperationKind('ADD', 0);
    OperationKind_REMOVE_instance = new OperationKind('REMOVE', 1);
    OperationKind_CHANGE_instance = new OperationKind('CHANGE', 2);
  }
  function OperationKind(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function OperationKind_ADD_getInstance() {
    OperationKind_initEntries();
    return OperationKind_ADD_instance;
  }
  function OperationKind_REMOVE_getInstance() {
    OperationKind_initEntries();
    return OperationKind_REMOVE_instance;
  }
  function OperationKind_CHANGE_getInstance() {
    OperationKind_initEntries();
    return OperationKind_CHANGE_instance;
  }
  function TargetedOperation(role, operation) {
    CustomExecuteOperation.call(this);
    this.v42_1 = role;
    this.w42_1 = operation;
  }
  protoOf(TargetedOperation).l3p = function () {
    return this.v42_1;
  };
  protoOf(TargetedOperation).s3z = function () {
    return this.w42_1;
  };
  protoOf(TargetedOperation).r3x = function () {
    return this.s3z().r3x();
  };
  protoOf(TargetedOperation).y2 = function () {
    return 'targeted';
  };
  protoOf(TargetedOperation).j3w = function () {
    return listOf(this.s3z());
  };
  protoOf(TargetedOperation).y43 = function (otherOp, server) {
    if (otherOp instanceof TargetedOperation) {
      var otherTargeted = otherOp instanceof TargetedOperation ? otherOp : THROW_CCE();
      if (equals(this.l3p(), otherTargeted.l3p())) {
        var tmp = otherTargeted.s3z();
        var otherOperation = isInterface(tmp, Operation) ? tmp : THROW_CCE();
        return this.x43(this.s3z().z3x(otherOperation, server));
      }
    }
    return protoOf(CustomExecuteOperation).f43.call(this, otherOp, server);
  };
  protoOf(TargetedOperation).f43 = function (otherOp, server) {
    return this.y43(otherOp, server);
  };
  protoOf(TargetedOperation).q3z = function () {
    return this.x43(this.s3z().q3z());
  };
  protoOf(TargetedOperation).c44 = function (model, customExecute, nodeFactory) {
    var tmp0_elvis_lhs = this.b44(model);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalStateException_init_$Create$_0('src=' + toString_0(model) + '; role=' + toString_0(this.l3p()));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var target = tmp;
    this.e44(target, customExecute, nodeFactory);
    return model;
  };
  protoOf(TargetedOperation).c49 = function (model, customExecute, nodeFactory) {
    return this.c44((model == null ? true : !(model == null)) ? model : THROW_CCE(), customExecute, nodeFactory);
  };
  protoOf(TargetedOperation).e44 = function (target, customExecute, nodeFactory) {
    var operation = this.s3z();
    if (operation instanceof CustomExecuteOperation) {
      operation.c49(target, customExecute, nodeFactory);
    } else {
      operation.y3x(target, nodeFactory);
    }
  };
  protoOf(TargetedOperation).toString = function () {
    return this.y2() + '[r = ' + toString_0(this.l3p()) + ';o = ' + toString_1(this.s3z()) + ']';
  };
  protoOf(TargetedOperation).s43 = function (indent) {
    return indent + this.y2() + '[r = ' + toString_0(this.l3p()) + ';o =\n' + this.s3z().s43(indent + '  ') + indent + ']\n';
  };
  function WithConsecutiveOperation() {
  }
  function prettyPrint($this, op) {
    var tmp1_elvis_lhs = op == null ? null : op.r43();
    return tmp1_elvis_lhs == null ? 'null' : tmp1_elvis_lhs;
  }
  function PrintOperationUtil() {
  }
  protoOf(PrintOperationUtil).g40 = function (operation) {
    return LoggingUtils_instance.z3c(prettyPrint(this, operation));
  };
  var PrintOperationUtil_instance;
  function PrintOperationUtil_getInstance() {
    return PrintOperationUtil_instance;
  }
  function AnnotatedOperationPersister() {
  }
  protoOf(AnnotatedOperationPersister).t3c = function () {
    return 'ao';
  };
  protoOf(AnnotatedOperationPersister).j4q = function () {
    return getKClass(AnnotatedOperation);
  };
  protoOf(AnnotatedOperationPersister).k4q = function (modelCtx, ctx, op) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.require' call
    if (!(op instanceof AnnotatedOperation)) {
      var message = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    var ao = op instanceof AnnotatedOperation ? op : THROW_CCE();
    var result = new JsonArray();
    var author = ao.c4e_1;
    if (author == null) {
      result.y2g(new JsonNull());
    } else {
      result.m2h(author);
    }
    result.m2h(ao.d4e_1.toString());
    result.y2g(ctx.r4q(modelCtx, ao.e4e_1));
    return result;
  };
  protoOf(AnnotatedOperationPersister).s4q = function (modelCtx, ctx, json) {
    var tmp;
    var tmp_0 = json.r(0);
    if (tmp_0 instanceof JsonNull) {
      tmp = null;
    } else {
      tmp = json.s2h(0);
    }
    var author = tmp;
    var time = toLong(json.s2h(1));
    var op = ctx.t4q(modelCtx, json.r2h(2));
    return new AnnotatedOperation(author, time, op);
  };
  function CompositeOperationPersister() {
  }
  protoOf(CompositeOperationPersister).t3c = function () {
    return 'c';
  };
  protoOf(CompositeOperationPersister).j4q = function () {
    return getKClass(CompositeOperation);
  };
  protoOf(CompositeOperationPersister).k4q = function (modelCtx, ctx, op) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.require' call
    if (!(op instanceof CompositeOperation)) {
      var message = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    var composite = op instanceof CompositeOperation ? op : THROW_CCE();
    var container = new JsonArray();
    var _iterator__ex2g4s = composite.j3w().m();
    while (_iterator__ex2g4s.n()) {
      var childOp = _iterator__ex2g4s.o();
      container.y2g(ctx.r4q(modelCtx, childOp));
    }
    var result = new JsonArray();
    result.y2g(container);
    return result;
  };
  protoOf(CompositeOperationPersister).s4q = function (modelCtx, ctx, json) {
    var ops = ArrayList_init_$Create$();
    var itemsArrays = json.r2h(0);
    var _iterator__ex2g4s = itemsArrays.m();
    while (_iterator__ex2g4s.n()) {
      var v = _iterator__ex2g4s.o();
      ops.j(ctx.t4q(modelCtx, v instanceof JsonArray ? v : THROW_CCE()));
    }
    return Companion_instance_68.b40(ops);
  };
  function NopOperationPersister() {
  }
  protoOf(NopOperationPersister).t3c = function () {
    return 'n';
  };
  protoOf(NopOperationPersister).j4q = function () {
    return getKClass(NopOperation);
  };
  protoOf(NopOperationPersister).k4q = function (modelCtx, ctx, op) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.require' call
    if (!(op instanceof NopOperation)) {
      var message = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    return new JsonArray();
  };
  protoOf(NopOperationPersister).s4q = function (modelCtx, ctx, json) {
    return new NopOperation();
  };
  function PersisterNotFoundException_init_$Init$($outer, kind, json, $this) {
    $this.u4q_1 = $outer;
    RuntimeException_init_$Init$_0(toString_1($outer) + ', delegates=' + $outer.q4q_1 + ', kind=' + kind + '; unknown tag ' + json.s2h(0) + ', json=' + json.toString(), $this);
    PersisterNotFoundException.call($this);
    return $this;
  }
  function PersisterNotFoundException_init_$Create$($outer, kind, json) {
    var tmp = PersisterNotFoundException_init_$Init$($outer, kind, json, objectCreate(protoOf(PersisterNotFoundException)));
    captureStack(tmp, PersisterNotFoundException_init_$Create$);
    return tmp;
  }
  function PersisterNotFoundException_init_$Init$_0($outer, kind, op, $this) {
    $this.u4q_1 = $outer;
    RuntimeException_init_$Init$_0(toString_1($outer) + ', delegates=' + $outer.q4q_1 + ', kind=' + kind + "; can't serialize op=" + toString_1(op), $this);
    PersisterNotFoundException.call($this);
    return $this;
  }
  function PersisterNotFoundException_init_$Create$_0($outer, kind, op) {
    var tmp = PersisterNotFoundException_init_$Init$_0($outer, kind, op, objectCreate(protoOf(PersisterNotFoundException)));
    captureStack(tmp, PersisterNotFoundException_init_$Create$_0);
    return tmp;
  }
  function getTagPersistersMap($this, ctx) {
    // Inline function 'kotlin.collections.getOrPut' call
    var this_0 = $this.o4q_1;
    var value = this_0.q2(ctx);
    var tmp;
    if (value == null) {
      var answer = HashMap_init_$Create$();
      this_0.t2(ctx, answer);
      tmp = answer;
    } else {
      tmp = value;
    }
    var map = tmp;
    return isInterface(map, KtMutableMap) ? map : THROW_CCE();
  }
  function getClassPersistersMap($this, ctx) {
    // Inline function 'kotlin.collections.getOrPut' call
    var this_0 = $this.p4q_1;
    var value = this_0.q2(ctx);
    var tmp;
    if (value == null) {
      var answer = HashMap_init_$Create$();
      this_0.t2(ctx, answer);
      tmp = answer;
    } else {
      tmp = value;
    }
    var map = tmp;
    return isInterface(map, KtMutableMap) ? map : THROW_CCE();
  }
  function checkGlobalTag($this, tag) {
    if ($this.m4q_1.o2(tag)) {
      throw RuntimeException_init_$Create$_0(tag + ' in global');
    }
    var _iterator__ex2g4s = $this.o4q_1.r2().m();
    while (_iterator__ex2g4s.n()) {
      var ctx = _iterator__ex2g4s.o();
      if (getTagPersistersMap($this, ctx).o2(tag)) {
        throw RuntimeException_init_$Create$_0(tag);
      }
    }
  }
  function checkLocalTag($this, ctx, tag) {
    if ($this.m4q_1.o2(tag)) {
      throw RuntimeException_init_$Create$_0(tag + ' in global');
    }
    if (getTagPersistersMap($this, ctx).o2(tag)) {
      throw RuntimeException_init_$Create$_0(tag);
    }
  }
  function silentSerialize($this, ctx, op) {
    var result = doSerialize($this, ctx, op);
    var _iterator__ex2g4s = $this.q4q_1.m();
    $l$loop: while (_iterator__ex2g4s.n()) {
      var context = _iterator__ex2g4s.o();
      if (!(result == null)) {
        break $l$loop;
      }
      result = silentSerialize(context, ctx, op);
    }
    return result;
  }
  function doSerialize($this, ctx, op) {
    var tagMap = getClassPersistersMap($this, ctx);
    var persister = tagMap.q2(getKClassFromExpression(op));
    if (!(persister == null)) {
      var result = persister.v4q($this, op);
      result.k2h(0, new JsonString(persister.t3c()));
      return result;
    }
    var globPersister = $this.n4q_1.q2(getKClassFromExpression(op));
    if (!(globPersister == null)) {
      var result_0 = globPersister.k4q(ctx, $this, op);
      result_0.k2h(0, new JsonString(globPersister.t3c()));
      return result_0;
    }
    return null;
  }
  function silentDeserialize($this, ctx, json) {
    var operation = doDeserialize($this, ctx, json);
    var _iterator__ex2g4s = $this.q4q_1.m();
    $l$loop: while (_iterator__ex2g4s.n()) {
      var context = _iterator__ex2g4s.o();
      if (!(operation == null)) {
        break $l$loop;
      }
      operation = silentDeserialize(context, ctx, json);
    }
    return operation;
  }
  function doDeserialize($this, ctx, json) {
    var tag = json.s2h(0);
    var persisters = getTagPersistersMap($this, ctx);
    var persister = persisters.q2(tag);
    if (!(persister == null)) {
      json.l2h(0);
      return persister.w4q($this, json);
    }
    var globalPersister = $this.m4q_1.q2(tag);
    if (!(globalPersister == null)) {
      json.l2h(0);
      return globalPersister.s4q(ctx, $this, json);
    }
    return null;
  }
  function PersisterNotFoundException() {
    captureStack(this, PersisterNotFoundException);
  }
  function OperationPersistenceContext(idPersistenceContext) {
    this.l4q_1 = idPersistenceContext;
    this.m4q_1 = HashMap_init_$Create$();
    this.n4q_1 = HashMap_init_$Create$();
    this.o4q_1 = HashMap_init_$Create$();
    this.p4q_1 = HashMap_init_$Create$();
    this.q4q_1 = ArrayList_init_$Create$();
    this.x4q(new NopOperationPersister());
    this.x4q(new CompositeOperationPersister());
    this.x4q(new AnnotatedOperationPersister());
  }
  protoOf(OperationPersistenceContext).x4q = function (persister) {
    checkGlobalTag(this, persister.t3c());
    var tmp0 = this.m4q_1;
    // Inline function 'kotlin.collections.set' call
    var key = persister.t3c();
    tmp0.t2(key, persister);
    var tmp0_0 = this.n4q_1;
    // Inline function 'kotlin.collections.set' call
    var key_0 = persister.j4q();
    tmp0_0.t2(key_0, persister);
  };
  protoOf(OperationPersistenceContext).y4q = function (ctx, persisters) {
    var inductionVariable = 0;
    var last = persisters.length;
    while (inductionVariable < last) {
      var persister = persisters[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      checkLocalTag(this, ctx, persister.t3c());
      var tmp0 = getTagPersistersMap(this, ctx);
      // Inline function 'kotlin.collections.set' call
      var key = persister.t3c();
      tmp0.t2(key, persister);
      var tmp0_0 = getClassPersistersMap(this, ctx);
      // Inline function 'kotlin.collections.set' call
      var key_0 = persister.j4q();
      tmp0_0.t2(key_0, persister);
    }
  };
  protoOf(OperationPersistenceContext).r4q = function (ctx, op) {
    var tmp0_elvis_lhs = silentSerialize(this, ctx, op);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw PersisterNotFoundException_init_$Create$_0(this, ctx, op);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  protoOf(OperationPersistenceContext).t4q = function (ctx, json) {
    var tmp0_elvis_lhs = silentDeserialize(this, ctx, json);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw PersisterNotFoundException_init_$Create$(this, ctx, json);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  protoOf(OperationPersistenceContext).z4q = function (context) {
    // Inline function 'kotlin.collections.plusAssign' call
    this.q4q_1.j(context);
  };
  protoOf(OperationPersistenceContext).a4r = function (kind, id) {
    return this.l4q_1.q3l(kind).w24(id);
  };
  protoOf(OperationPersistenceContext).b4r = function (kind, value) {
    return this.l4q_1.q3l(kind).p25(value);
  };
  function TargetedOperationPersister(rolePersister) {
    this.c4r_1 = rolePersister;
  }
  protoOf(TargetedOperationPersister).g4r = function (ctx, op) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.require' call
    if (!this.e4r(op)) {
      var message = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    var targetedOp = op instanceof TargetedOperation ? op : THROW_CCE();
    var result = new JsonArray();
    result.m2h(ensureNotNull(this.c4r_1.w24(targetedOp.l3p())));
    result.y2g(ctx.r4q(this.d4r(), targetedOp.s3z()));
    return result;
  };
  protoOf(TargetedOperationPersister).v4q = function (ctx, op) {
    return this.g4r(ctx, op);
  };
  protoOf(TargetedOperationPersister).w4q = function (ctx, json) {
    var role = this.c4r_1.p25(json.s2h(0));
    var op = ctx.t4q(this.d4r(), json.r2h(1));
    return this.f4r(role, op);
  };
  function doUpdateIdCompressor($this, idCompressor, update) {
    var patch = HashMap_init_$Create$();
    var i = 0;
    while (i < update.x2g()) {
      var tmp2 = update.s2h(i);
      // Inline function 'kotlin.collections.set' call
      var value = update.s2h(i + 1 | 0);
      patch.t2(tmp2, value);
      i = i + 2 | 0;
    }
    idCompressor.j4r(patch);
  }
  function DictionaryAwareDeserializer(idCompressor) {
    DictionaryAwarePersister.call(this, idCompressor);
  }
  protoOf(DictionaryAwareDeserializer).n4r = function (json) {
    var valueIndex = 0;
    if (json.x2g() === 2) {
      doUpdateIdCompressor(this, ensureNotNull(this.o4r_1), json.r2h(0));
      valueIndex = 1;
    }
    return this.m4r(json.r(valueIndex));
  };
  function DictionaryAwarePersister(idCompressor) {
    this.o4r_1 = idCompressor;
    var tmp = this;
    var tmp_0;
    var tmp_1;
    if (this.o4r_1 == null) {
      tmp_1 = true;
    } else {
      var tmp_2 = this.o4r_1;
      tmp_1 = tmp_2 instanceof UpdatableIdCompressor;
    }
    if (tmp_1) {
      tmp_0 = false;
    } else {
      var tmp_3 = this.o4r_1;
      if (tmp_3 instanceof DefaultSelfUpdatingIdCompressor) {
        tmp_0 = true;
      } else {
        throw IllegalArgumentException_init_$Create$_0('Unknown id compressor: ' + toString_1(this.o4r_1));
      }
    }
    tmp.p4r_1 = tmp_0;
  }
  function compressorUpdateToJson($this, data) {
    var array = new JsonArray();
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s = data.y().m();
    while (_iterator__ex2g4s.n()) {
      var _destruct__k2r9zo = _iterator__ex2g4s.o();
      // Inline function 'kotlin.collections.component1' call
      var key = _destruct__k2r9zo.z();
      // Inline function 'kotlin.collections.component2' call
      var value = _destruct__k2r9zo.a1();
      array.m2h(key);
      array.m2h(value);
    }
    return array;
  }
  function DictionaryAwareSerializer(idCompressor) {
    DictionaryAwarePersister.call(this, idCompressor);
  }
  protoOf(DictionaryAwareSerializer).t4r = function (value) {
    var result = new JsonArray();
    if (this.p4r_1) {
      var tmp = this.o4r_1;
      (tmp instanceof DefaultSelfUpdatingIdCompressor ? tmp : THROW_CCE()).b4s();
      var jsonValue = this.s4r(value);
      var updateResult = this.o4r_1.k4s();
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!updateResult.s()) {
        result.y2g(compressorUpdateToJson(this, updateResult));
      }
      result.y2g(jsonValue);
    } else {
      result.y2g(this.s4r(value));
    }
    return result;
  };
  function AddChildOperationPersister() {
    ChildOperationPersister.call(this);
  }
  protoOf(AddChildOperationPersister).t3c = function () {
    return 'a';
  };
  protoOf(AddChildOperationPersister).j4q = function () {
    return getKClass(AddChildOperation);
  };
  protoOf(AddChildOperationPersister).l4s = function (op) {
    return op instanceof AddChildOperation;
  };
  protoOf(AddChildOperationPersister).m4s = function (conceptId, entityId, singleRole) {
    return AddChildOperation_init_$Create$(conceptId, entityId, singleRole);
  };
  function ChangeChildOperationPersister() {
    this.o4s_1 = 'cc';
    this.p4s_1 = getKClass(ChangeChildOperation);
  }
  protoOf(ChangeChildOperationPersister).t3c = function () {
    return this.o4s_1;
  };
  protoOf(ChangeChildOperationPersister).j4q = function () {
    return this.p4s_1;
  };
  protoOf(ChangeChildOperationPersister).n4s = function (ctx, op) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.require' call
    if (!(op instanceof ChangeChildOperation)) {
      var message = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    var result = new JsonArray();
    result.m2h(ensureNotNull(ctx.a4r(EntityIdModelKinds_getInstance().j3l_1, op.l3p())));
    result.y2g(ctx.r4q(EntityModelKinds_getInstance().q4s_1, op.s3z()));
    return result;
  };
  protoOf(ChangeChildOperationPersister).v4q = function (ctx, op) {
    return this.n4s(ctx, op);
  };
  protoOf(ChangeChildOperationPersister).w4q = function (ctx, json) {
    var id = ctx.b4r(EntityIdModelKinds_getInstance().j3l_1, json.s2h(0));
    var op = ctx.t4q(EntityModelKinds_getInstance().q4s_1, json.r2h(1));
    return new ChangeChildOperation(id, op);
  };
  function ChildOperationPersister() {
  }
  protoOf(ChildOperationPersister).n4s = function (ctx, op) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.require' call
    if (!this.l4s(op)) {
      var message = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    var childOp = op instanceof ChildOperation ? op : THROW_CCE();
    var result = new JsonArray();
    result.m2h(ensureNotNull(ctx.a4r(EntityIdModelKinds_getInstance().k3l_1, childOp.f3t())));
    result.m2h(ensureNotNull(ctx.a4r(EntityIdModelKinds_getInstance().j3l_1, childOp.p3w())));
    if (childOp.f3g()) {
      result.o2h(0.0);
    }
    return result;
  };
  protoOf(ChildOperationPersister).v4q = function (ctx, op) {
    return this.n4s(ctx, op);
  };
  protoOf(ChildOperationPersister).w4q = function (ctx, json) {
    var conceptId = ctx.b4r(EntityIdModelKinds_getInstance().k3l_1, json.s2h(0));
    var entityId = ctx.b4r(EntityIdModelKinds_getInstance().j3l_1, json.s2h(1));
    var isSingleRole = json.x2g() === 3;
    return this.m4s(conceptId, entityId, isSingleRole);
  };
  function RemoveChildOperationPersister() {
    ChildOperationPersister.call(this);
    this.u4s_1 = 'r';
    this.v4s_1 = getKClass(RemoveChildOperation);
  }
  protoOf(RemoveChildOperationPersister).t3c = function () {
    return this.u4s_1;
  };
  protoOf(RemoveChildOperationPersister).j4q = function () {
    return this.v4s_1;
  };
  protoOf(RemoveChildOperationPersister).l4s = function (op) {
    return op instanceof RemoveChildOperation;
  };
  protoOf(RemoveChildOperationPersister).m4s = function (conceptId, entityId, singleRole) {
    return RemoveChildOperation_init_$Create$(conceptId, entityId, singleRole);
  };
  function AddRootOperationPersister() {
    this.w4s_1 = 'a';
    this.x4s_1 = getKClass(AddRootOperation);
  }
  protoOf(AddRootOperationPersister).t3c = function () {
    return this.w4s_1;
  };
  protoOf(AddRootOperationPersister).j4q = function () {
    return this.x4s_1;
  };
  protoOf(AddRootOperationPersister).y4s = function (ctx, op) {
    // Inline function 'kotlin.check' call
    if (!(op instanceof AddRootOperation)) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    var result = new JsonArray();
    result.m2h(ensureNotNull(ctx.a4r(EntityIdModelKinds_getInstance().j3l_1, op.m3w())));
    result.m2h(ensureNotNull(ctx.a4r(EntityIdModelKinds_getInstance().k3l_1, op.f3t())));
    return result;
  };
  protoOf(AddRootOperationPersister).v4q = function (ctx, op) {
    return this.y4s(ctx, op);
  };
  protoOf(AddRootOperationPersister).w4q = function (ctx, json) {
    var entityId = ctx.b4r(EntityIdModelKinds_getInstance().j3l_1, json.s2h(0));
    var conceptId = ctx.b4r(EntityIdModelKinds_getInstance().k3l_1, json.s2h(1));
    return AddRootOperation_init_$Create$(entityId, conceptId);
  };
  function Deserializer(idCompressor, nodeFactory) {
    nodeFactory = nodeFactory === VOID ? RawNodeFactory_instance : nodeFactory;
    DictionaryAwareDeserializer.call(this, idCompressor);
    this.b4t_1 = nodeFactory;
    this.c4t_1 = new EntityIdPersistenceContext(idCompressor);
  }
  protoOf(Deserializer).m4r = function (json) {
    var converter = new Json2EntityConverter(this.c4t_1, this.b4t_1);
    var tmp = BaseJsonReaderSupport_instance.u2i(json);
    var jsonArrayReader = isInterface(tmp, JsonArrayReader) ? tmp : THROW_CCE();
    var root = converter.x3l(jsonArrayReader);
    return new UnsafeBuildRootOperation(root);
  };
  function Serializer(idCompressor) {
    DictionaryAwareSerializer.call(this, idCompressor);
    this.f4t_1 = new EntityIdPersistenceContext(idCompressor);
  }
  protoOf(Serializer).g4t = function (value) {
    return (new Entity2JsonConverter(this.f4t_1, value.s42_1)).t3m(value.t42());
  };
  protoOf(Serializer).s4r = function (value) {
    return this.g4t(value instanceof BuildRootOperation ? value : THROW_CCE());
  };
  function BuildRootOperationPersister(nodeFactory) {
    nodeFactory = nodeFactory === VOID ? RawNodeFactory_instance : nodeFactory;
    this.h4t_1 = nodeFactory;
    this.i4t_1 = 'b';
    this.j4t_1 = getKClass(SafeBuildRootOperation);
  }
  protoOf(BuildRootOperationPersister).t3c = function () {
    return this.i4t_1;
  };
  protoOf(BuildRootOperationPersister).j4q = function () {
    return this.j4t_1;
  };
  protoOf(BuildRootOperationPersister).y4s = function (ctx, op) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.require' call
    if (!(op instanceof BuildRootOperation)) {
      var message = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    var idCompressor = DefaultSelfUpdatingIdCompressor_init_$Create$();
    var serializer = new Serializer(idCompressor);
    return serializer.t4r(op);
  };
  protoOf(BuildRootOperationPersister).v4q = function (ctx, op) {
    return this.y4s(ctx, op);
  };
  protoOf(BuildRootOperationPersister).w4q = function (ctx, json) {
    var deserializer = new Deserializer(new UpdatableIdCompressor(), this.h4t_1);
    return deserializer.n4r(json);
  };
  function ChangeRootEntityOperationPersister() {
    this.k4t_1 = 'e';
    this.l4t_1 = getKClass(ChangeRootEntityOperation);
  }
  protoOf(ChangeRootEntityOperationPersister).t3c = function () {
    return this.k4t_1;
  };
  protoOf(ChangeRootEntityOperationPersister).j4q = function () {
    return this.l4t_1;
  };
  protoOf(ChangeRootEntityOperationPersister).y4s = function (ctx, op) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.require' call
    if (!(op instanceof ChangeRootEntityOperation)) {
      var message = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    var result = new JsonArray();
    result.m2h(ensureNotNull(ctx.a4r(EntityIdModelKinds_getInstance().j3l_1, op.l3p())));
    result.y2g(ctx.r4q(EntityModelKinds_getInstance().q4s_1, op.s3z()));
    return result;
  };
  protoOf(ChangeRootEntityOperationPersister).v4q = function (ctx, op) {
    return this.y4s(ctx, op);
  };
  protoOf(ChangeRootEntityOperationPersister).w4q = function (ctx, json) {
    var entityId = ctx.b4r(EntityIdModelKinds_getInstance().j3l_1, json.s2h(0));
    var op = ctx.t4q(EntityModelKinds_getInstance().q4s_1, json.r2h(1));
    return new ChangeRootEntityOperation(entityId, op);
  };
  function RemoveRootOperationPersister() {
    this.m4t_1 = 'r';
    this.n4t_1 = getKClass(RemoveRootOperation);
  }
  protoOf(RemoveRootOperationPersister).t3c = function () {
    return this.m4t_1;
  };
  protoOf(RemoveRootOperationPersister).j4q = function () {
    return this.n4t_1;
  };
  protoOf(RemoveRootOperationPersister).y4s = function (ctx, op) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.require' call
    if (!(op instanceof RemoveRootOperation)) {
      var message = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    var result = new JsonArray();
    result.m2h(ensureNotNull(ctx.a4r(EntityIdModelKinds_getInstance().j3l_1, op.m3w())));
    result.m2h(ensureNotNull(ctx.a4r(EntityIdModelKinds_getInstance().k3l_1, op.f3t())));
    return result;
  };
  protoOf(RemoveRootOperationPersister).v4q = function (ctx, op) {
    return this.y4s(ctx, op);
  };
  protoOf(RemoveRootOperationPersister).w4q = function (ctx, json) {
    var entityId = ctx.b4r(EntityIdModelKinds_getInstance().j3l_1, json.s2h(0));
    var conceptId = ctx.b4r(EntityIdModelKinds_getInstance().k3l_1, json.s2h(1));
    return RemoveRootOperation_init_$Create$(entityId, conceptId);
  };
  function EntityConceptIdPersister() {
    MetaIdPersister.call(this);
    this.p4t_1 = values_0();
  }
  protoOf(EntityConceptIdPersister).q4t = function (id, flags) {
    return EntityConceptId_init_$Create$_0(id);
  };
  protoOf(EntityConceptIdPersister).r4t = function (id, flags) {
    return this.q4t(id, flags);
  };
  protoOf(EntityConceptIdPersister).s4t = function () {
    return this.p4t_1;
  };
  function EntityIdPersistenceContext(idCompressor) {
    idCompressor = idCompressor === VOID ? null : idCompressor;
    BaseIdPersistenceContext.call(this, idCompressor);
    var idPersister = PrivateEntityIdPersisters_instance.v4t();
    this.w4t(EntityIdModelKinds_getInstance().j3l_1, idPersister);
    this.w4t(EntityIdModelKinds_getInstance().k3l_1, PrivateEntityIdPersisters_instance.x4t());
    this.w4t(EntityIdModelKinds_getInstance().l3l_1, PrivateEntityIdPersisters_instance.y4t());
    this.w4t(EntityIdModelKinds_getInstance().m3l_1, PrivateEntityIdPersisters_instance.z4t());
    this.w4t(EntityIdModelKinds_getInstance().n3l_1, PrivateEntityIdPersisters_instance.a4u());
    this.w4t(EntityIdModelKinds_getInstance().o3l_1, PrivateEntityIdPersisters_instance.b4u());
    this.w4t(EntityIdModelKinds_getInstance().p3l_1, EntityIdPersisters_instance.c4u());
    this.d4u(new NodeIdPersistenceContext(idCompressor));
  }
  protoOf(EntityIdPersistenceContext).h4u = function () {
    var tmp = this.i4u().r(0);
    return tmp instanceof NodeIdPersistenceContext ? tmp : THROW_CCE();
  };
  function EntityIdPersisters$childIdPersister$1() {
    RoleIdPersister.call(this);
  }
  protoOf(EntityIdPersisters$childIdPersister$1).m4u = function (id, flags) {
    return EntityChildId_init_$Create$_0(id, flags);
  };
  protoOf(EntityIdPersisters$childIdPersister$1).r4t = function (id, flags) {
    return this.m4u(id, flags);
  };
  function EntityIdPersisters$referenceIdPersister$1() {
    RoleIdPersister.call(this);
  }
  protoOf(EntityIdPersisters$referenceIdPersister$1).m4u = function (id, flags) {
    return EntityReferenceId_init_$Create$(id, flags);
  };
  protoOf(EntityIdPersisters$referenceIdPersister$1).r4t = function (id, flags) {
    return this.m4u(id, flags);
  };
  function EntityIdPersisters$entityReferencePersister$1() {
    this.r4u_1 = _Char___init__impl__6a9atx(44);
    this.s4u_1 = PrivateEntityIdPersisters_instance.v4t();
    this.t4u_1 = new ExceptionNullPersister();
  }
  protoOf(EntityIdPersisters$entityReferencePersister$1).o25 = function (value) {
    var separatorIndex = -1;
    var inductionVariable = 0;
    var last = charSequenceLength(value) - 1 | 0;
    if (inductionVariable <= last)
      $l$loop: do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (charCodeAt(value, index) === this.r4u_1) {
          separatorIndex = index;
          break $l$loop;
        }
      }
       while (inductionVariable <= last);
    var tmp;
    if (separatorIndex < 0) {
      tmp = new EntityReference(this.s4u_1.p25(value));
    } else {
      var serializedRootId = take_1(value, separatorIndex);
      var serializedEntityId = substring_0(value, separatorIndex + 1 | 0);
      tmp = new EntityReference(this.s4u_1.p25(serializedRootId), this.s4u_1.p25(serializedEntityId));
    }
    return tmp;
  };
  protoOf(EntityIdPersisters$entityReferencePersister$1).u4u = function (value) {
    var tmp;
    if (value.j3j_1.equals(value.k3j_1)) {
      tmp = this.s4u_1.n25(value.j3j_1);
    } else {
      var rootString = this.s4u_1.w24(value.j3j_1);
      var entityString = this.s4u_1.w24(value.k3j_1);
      // Inline function 'kotlin.check' call
      if (!(!contains_8(ensureNotNull(rootString), '' + toString(this.r4u_1)) && !contains_8(ensureNotNull(entityString), '' + toString(this.r4u_1)))) {
        throw IllegalStateException_init_$Create$_0('Check failed.');
      }
      tmp = rootString + toString(this.r4u_1) + entityString;
    }
    return tmp;
  };
  protoOf(EntityIdPersisters$entityReferencePersister$1).n25 = function (value) {
    return this.u4u(value instanceof EntityReference ? value : THROW_CCE());
  };
  protoOf(EntityIdPersisters$entityReferencePersister$1).m25 = function () {
    return this.t4u_1;
  };
  function EntityIdPersisters() {
  }
  protoOf(EntityIdPersisters).v4u = function () {
    return new EntityIdPersisters$childIdPersister$1();
  };
  protoOf(EntityIdPersisters).w4u = function () {
    return new EntityIdPersisters$referenceIdPersister$1();
  };
  protoOf(EntityIdPersisters).x4t = function () {
    return new EntityConceptIdPersister();
  };
  protoOf(EntityIdPersisters).c4u = function () {
    return new EntityIdPersisters$entityReferencePersister$1();
  };
  var EntityIdPersisters_instance;
  function EntityIdPersisters_getInstance() {
    return EntityIdPersisters_instance;
  }
  function PrivateEntityIdPersisters$idPersister$1() {
    DefaultIdPersister.call(this);
  }
  protoOf(PrivateEntityIdPersisters$idPersister$1).y4u = function (id) {
    return EntityId_init_$Create$_0(id);
  };
  function PrivateEntityIdPersisters$propertyIdPersister$1() {
    DefaultIdPersister.call(this);
  }
  protoOf(PrivateEntityIdPersisters$propertyIdPersister$1).y4u = function (id) {
    return EntityPropertyId_init_$Create$_0(id);
  };
  function PrivateEntityIdPersisters$modelBlobIdPersister$1() {
    DefaultIdPersister.call(this);
  }
  protoOf(PrivateEntityIdPersisters$modelBlobIdPersister$1).y4u = function (id) {
    return EntityModelBlobId_init_$Create$_0(id);
  };
  function PrivateEntityIdPersisters() {
  }
  protoOf(PrivateEntityIdPersisters).v4t = function () {
    return new PrivateEntityIdPersisters$idPersister$1();
  };
  protoOf(PrivateEntityIdPersisters).b4u = function () {
    return new CompressingIdPersister(EntityIdPersisters_instance.v4u());
  };
  protoOf(PrivateEntityIdPersisters).y4t = function () {
    return new CompressingIdPersister(new PrivateEntityIdPersisters$propertyIdPersister$1());
  };
  protoOf(PrivateEntityIdPersisters).z4t = function () {
    return new CompressingIdPersister(EntityIdPersisters_instance.w4u());
  };
  protoOf(PrivateEntityIdPersisters).a4u = function () {
    return new CompressingIdPersister(new PrivateEntityIdPersisters$modelBlobIdPersister$1());
  };
  protoOf(PrivateEntityIdPersisters).x4t = function () {
    return new CompressingIdPersister(EntityIdPersisters_instance.x4t());
  };
  var PrivateEntityIdPersisters_instance;
  function PrivateEntityIdPersisters_getInstance() {
    return PrivateEntityIdPersisters_instance;
  }
  function AddModelBlobOperationPersister() {
    ModelBlobOperationPersister.call(this);
    this.d4v_1 = 'am';
    this.e4v_1 = getKClass(AddModelBlobOperation);
  }
  protoOf(AddModelBlobOperationPersister).t3c = function () {
    return this.d4v_1;
  };
  protoOf(AddModelBlobOperationPersister).j4q = function () {
    return this.e4v_1;
  };
  protoOf(AddModelBlobOperationPersister).f4v = function (op) {
    return op instanceof AddModelBlobOperation;
  };
  protoOf(AddModelBlobOperationPersister).g4v = function (modelBlobId, conceptId, nodeId) {
    return AddModelBlobOperation_init_$Create$(modelBlobId, conceptId, nodeId);
  };
  function ChangeModelBlobOperationPersister(rolePersister) {
    TargetedOperationPersister.call(this, rolePersister);
    this.j4v_1 = NodeModelKinds_getInstance().m4v_1;
    this.k4v_1 = 'cm';
    this.l4v_1 = getKClass(ChangeModelBlobOperation);
  }
  protoOf(ChangeModelBlobOperationPersister).d4r = function () {
    return this.j4v_1;
  };
  protoOf(ChangeModelBlobOperationPersister).t3c = function () {
    return this.k4v_1;
  };
  protoOf(ChangeModelBlobOperationPersister).j4q = function () {
    return this.l4v_1;
  };
  protoOf(ChangeModelBlobOperationPersister).f4v = function (op) {
    return op instanceof ChangeModelBlobOperation;
  };
  protoOf(ChangeModelBlobOperationPersister).e4r = function (op) {
    return this.f4v(op);
  };
  protoOf(ChangeModelBlobOperationPersister).q4v = function (role, op) {
    return new ChangeModelBlobOperation(ensureNotNull(role), op);
  };
  protoOf(ChangeModelBlobOperationPersister).f4r = function (role, op) {
    return this.q4v((role == null ? true : role instanceof EntityModelBlobId) ? role : THROW_CCE(), op);
  };
  function ModelBlobOperationPersister() {
  }
  protoOf(ModelBlobOperationPersister).h4v = function (ctx, op) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.require' call
    if (!this.f4v(op)) {
      var message = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    var modelOp = op instanceof ModelBlobOperation ? op : THROW_CCE();
    var result = new JsonArray();
    result.m2h(ensureNotNull(ctx.a4r(EntityIdModelKinds_getInstance().n3l_1, modelOp.y47())));
    result.m2h(serializeConceptId(ctx, modelOp.q42()));
    result.m2h(serializeNodeId(ctx, ensureNotNull(modelOp.m3w())));
    return result;
  };
  protoOf(ModelBlobOperationPersister).v4q = function (ctx, op) {
    return this.h4v(ctx, op);
  };
  protoOf(ModelBlobOperationPersister).w4q = function (ctx, json) {
    var modelBlobId = ctx.b4r(EntityIdModelKinds_getInstance().n3l_1, json.s2h(0));
    var conceptId = deserializeConceptId(ctx, json.s2h(1));
    var nodeId = deserializeNodeId(ctx, json.s2h(2));
    return this.g4v(modelBlobId, conceptId, nodeId);
  };
  function RemoveModelBlobOperationPersister() {
    ModelBlobOperationPersister.call(this);
    this.r4v_1 = 'rm';
    this.s4v_1 = getKClass(RemoveModelBlobOperation);
  }
  protoOf(RemoveModelBlobOperationPersister).t3c = function () {
    return this.r4v_1;
  };
  protoOf(RemoveModelBlobOperationPersister).j4q = function () {
    return this.s4v_1;
  };
  protoOf(RemoveModelBlobOperationPersister).f4v = function (op) {
    return op instanceof RemoveModelBlobOperation;
  };
  protoOf(RemoveModelBlobOperationPersister).g4v = function (modelBlobId, conceptId, nodeId) {
    return RemoveModelBlobOperation_init_$Create$(modelBlobId, conceptId, nodeId);
  };
  function EntityIdModelKinds() {
    EntityIdModelKinds_instance = this;
    this.j3l_1 = new ModelKind('entityId');
    this.k3l_1 = new ModelKind('entityConcept');
    this.l3l_1 = new ModelKind('entityProperty');
    this.m3l_1 = new ModelKind('entityReferenceId');
    this.n3l_1 = new ModelKind('modelBlob');
    this.o3l_1 = new ModelKind('entityChild');
    this.p3l_1 = new ModelKind('entityReference');
  }
  var EntityIdModelKinds_instance;
  function EntityIdModelKinds_getInstance() {
    if (EntityIdModelKinds_instance == null)
      new EntityIdModelKinds();
    return EntityIdModelKinds_instance;
  }
  function EntityModelKinds() {
    EntityModelKinds_instance = this;
    this.q4s_1 = new ModelKind('entity');
    this.r4s_1 = new ModelKind('property');
    this.s4s_1 = new ModelKind('entityReference');
    this.t4s_1 = new ModelKind('children');
  }
  var EntityModelKinds_instance;
  function EntityModelKinds_getInstance() {
    if (EntityModelKinds_instance == null)
      new EntityModelKinds();
    return EntityModelKinds_instance;
  }
  function serializePath($this, rootPathItem, ctx) {
    var result = new JsonArray();
    var item = rootPathItem;
    while (!(item == null)) {
      var value = item.y49_1;
      if (value instanceof EntityId) {
        result.m2h(ensureNotNull(ctx.q3l(EntityIdModelKinds_getInstance().j3l_1).w24(value)));
      } else {
        if (value instanceof EntityChildId) {
          result.m2h(ensureNotNull(ctx.q3l(EntityIdModelKinds_getInstance().o3l_1).w24(value)));
        } else {
          throw IllegalStateException_init_$Create$();
        }
      }
      item = item.h12();
    }
    return result;
  }
  function deserializePath($this, array, ctx) {
    // Inline function 'kotlin.check' call
    if (!!(array.x2g() === 0)) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    var entityId = ctx.q3l(EntityIdModelKinds_getInstance().j3l_1).p25(array.s2h(0));
    var rolePathItem = deserializeRole($this, array, 1, ctx);
    return new RootPathItem(entityId, rolePathItem);
  }
  function deserializeRole($this, array, index, ctx) {
    var tmp;
    if (index === array.x2g()) {
      tmp = null;
    } else {
      var entityChildId = ctx.q3l(EntityIdModelKinds_getInstance().o3l_1).p25(array.s2h(index));
      var entityPathItem = deserializeEntity($this, array, index + 1 | 0, ctx);
      tmp = new RolePathItem(entityChildId, entityPathItem);
    }
    return tmp;
  }
  function deserializeEntity($this, array, index, ctx) {
    var tmp;
    if (index === array.x2g()) {
      tmp = null;
    } else {
      var entityId = ctx.q3l(EntityIdModelKinds_getInstance().j3l_1).p25(array.s2h(index));
      var rolePathItem = deserializeRole($this, array, index + 1 | 0, ctx);
      tmp = new EntityPathItem(entityId, rolePathItem);
    }
    return tmp;
  }
  function MoveOperationPersister() {
    this.t4v_1 = 'm';
    this.u4v_1 = getKClass(MoveOperation);
  }
  protoOf(MoveOperationPersister).t3c = function () {
    return this.t4v_1;
  };
  protoOf(MoveOperationPersister).j4q = function () {
    return this.u4v_1;
  };
  protoOf(MoveOperationPersister).y4s = function (ctx, op) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.require' call
    if (!(op instanceof MoveOperation)) {
      var message = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    var result = new JsonArray();
    var idPersistenceContext = ctx.l4q_1;
    result.y2g(serializePath(this, op.f4b(), idPersistenceContext));
    result.y2g(serializePath(this, op.g4b(), idPersistenceContext));
    result.y2g(ctx.r4q(EntityModelKinds_getInstance().q4s_1, op.t4a_1));
    return result;
  };
  protoOf(MoveOperationPersister).v4q = function (ctx, op) {
    return this.y4s(ctx, op);
  };
  protoOf(MoveOperationPersister).w4q = function (ctx, json) {
    var destroy = ctx.t4q(EntityModelKinds_getInstance().q4s_1, json.r2h(2));
    var idPersistenceContext = ctx.l4q_1;
    return new MoveOperation(deserializePath(this, json.r2h(0), idPersistenceContext), deserializePath(this, json.r2h(1), idPersistenceContext), destroy);
  };
  function EntityOperationPersistenceContext_init_$Init$(compressor, nodeFactory, $this) {
    nodeFactory = nodeFactory === VOID ? RawNodeFactory_instance : nodeFactory;
    EntityOperationPersistenceContext.call($this, new EntityIdPersistenceContext(compressor), nodeFactory);
    return $this;
  }
  function EntityOperationPersistenceContext_init_$Create$(compressor, nodeFactory) {
    return EntityOperationPersistenceContext_init_$Init$(compressor, nodeFactory, objectCreate(protoOf(EntityOperationPersistenceContext)));
  }
  function Companion_70() {
    Companion_instance_70 = this;
    this.v4v_1 = new ModelKind('entityContext');
  }
  var Companion_instance_70;
  function Companion_getInstance_70() {
    if (Companion_instance_70 == null)
      new Companion_70();
    return Companion_instance_70;
  }
  function EntityOperationPersistenceContext(idPersistenceContext, nodeFactory) {
    Companion_getInstance_70();
    idPersistenceContext = idPersistenceContext === VOID ? new EntityIdPersistenceContext() : idPersistenceContext;
    nodeFactory = nodeFactory === VOID ? RawNodeFactory_instance : nodeFactory;
    OperationPersistenceContext.call(this, idPersistenceContext);
    this.y4q(Companion_getInstance_70().v4v_1, [new AddRootOperationPersister(), new RemoveRootOperationPersister(), new ChangeRootEntityOperationPersister(), new MoveOperationPersister(), new BuildRootOperationPersister(nodeFactory)]);
    this.y4q(EntityModelKinds_getInstance().q4s_1, [new ChildSetOperationPersister(), new SetReferenceOperationPersister(), new SetPropertyOperationPersister(), new AddModelBlobOperationPersister(), new RemoveModelBlobOperationPersister(), new ChangeModelBlobOperationPersister(idPersistenceContext.q3l(EntityIdModelKinds_getInstance().n3l_1))]);
    this.y4q(EntityModelKinds_getInstance().r4s_1, [new SetValueOperationPersister(Persisters_getInstance().a26())]);
    this.y4q(EntityModelKinds_getInstance().s4s_1, [new AddToSetOperationPersister(idPersistenceContext.q3l(EntityIdModelKinds_getInstance().p3l_1)), new RemoveFromSetOperationPersister(idPersistenceContext.q3l(EntityIdModelKinds_getInstance().p3l_1))]);
    this.y4q(EntityModelKinds_getInstance().t4s_1, [new AddChildOperationPersister(), new RemoveChildOperationPersister(), new ChangeChildOperationPersister()]);
    this.z4q(new NodeOperationsPersistenceContext(idPersistenceContext.h4u()));
  }
  protoOf(EntityOperationPersistenceContext).c4w = function (operation) {
    return this.r4q(Companion_getInstance_70().v4v_1, operation);
  };
  protoOf(EntityOperationPersistenceContext).d4w = function (array) {
    return this.t4q(Companion_getInstance_70().v4v_1, array);
  };
  function ChildSetOperationPersister() {
    this.e4w_1 = 's';
    this.f4w_1 = getKClass(ChildSetOperation);
  }
  protoOf(ChildSetOperationPersister).t3c = function () {
    return this.e4w_1;
  };
  protoOf(ChildSetOperationPersister).j4q = function () {
    return this.f4w_1;
  };
  protoOf(ChildSetOperationPersister).h4v = function (ctx, op) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.require' call
    if (!(op instanceof ChildSetOperation)) {
      var message = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    var result = new JsonArray();
    result.m2h(ensureNotNull(ctx.a4r(EntityIdModelKinds_getInstance().o3l_1, op.l3p())));
    result.y2g(ctx.r4q(EntityModelKinds_getInstance().t4s_1, op.s3z()));
    return result;
  };
  protoOf(ChildSetOperationPersister).v4q = function (ctx, op) {
    return this.h4v(ctx, op);
  };
  protoOf(ChildSetOperationPersister).w4q = function (ctx, json) {
    var childId = ctx.b4r(EntityIdModelKinds_getInstance().o3l_1, json.s2h(0));
    var entitySetOp = ctx.t4q(EntityModelKinds_getInstance().t4s_1, json.r2h(1));
    return new ChildSetOperation(childId, entitySetOp);
  };
  function SetPropertyOperationPersister() {
    this.g4w_1 = 'p';
    this.h4w_1 = getKClass(SetPropertyOperation);
  }
  protoOf(SetPropertyOperationPersister).t3c = function () {
    return this.g4w_1;
  };
  protoOf(SetPropertyOperationPersister).j4q = function () {
    return this.h4w_1;
  };
  protoOf(SetPropertyOperationPersister).h4v = function (ctx, op) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.require' call
    if (!(op instanceof SetPropertyOperation)) {
      var message = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    var result = new JsonArray();
    result.m2h(ensureNotNull(ctx.a4r(EntityIdModelKinds_getInstance().l3l_1, op.l3p())));
    result.y2g(ctx.r4q(EntityModelKinds_getInstance().r4s_1, op.s3z()));
    return result;
  };
  protoOf(SetPropertyOperationPersister).v4q = function (ctx, op) {
    return this.h4v(ctx, op);
  };
  protoOf(SetPropertyOperationPersister).w4q = function (ctx, json) {
    var propertyId = ctx.b4r(EntityIdModelKinds_getInstance().l3l_1, json.s2h(0));
    var propOp = ctx.t4q(EntityModelKinds_getInstance().r4s_1, json.r2h(1));
    return new SetPropertyOperation(propertyId, propOp);
  };
  function SetReferenceOperationPersister() {
    this.i4w_1 = 'er';
    this.j4w_1 = getKClass(SetReferenceOperation);
  }
  protoOf(SetReferenceOperationPersister).t3c = function () {
    return this.i4w_1;
  };
  protoOf(SetReferenceOperationPersister).j4q = function () {
    return this.j4w_1;
  };
  protoOf(SetReferenceOperationPersister).h4v = function (ctx, op) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.require' call
    if (!(op instanceof SetReferenceOperation)) {
      var message = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    var result = new JsonArray();
    result.m2h(ensureNotNull(ctx.a4r(EntityIdModelKinds_getInstance().m3l_1, op.l3p())));
    result.y2g(ctx.r4q(EntityModelKinds_getInstance().s4s_1, op.s3z()));
    return result;
  };
  protoOf(SetReferenceOperationPersister).v4q = function (ctx, op) {
    return this.h4v(ctx, op);
  };
  protoOf(SetReferenceOperationPersister).w4q = function (ctx, json) {
    var referenceId = ctx.b4r(EntityIdModelKinds_getInstance().m3l_1, json.s2h(0));
    var refSetOp = ctx.t4q(EntityModelKinds_getInstance().s4s_1, json.r2h(1));
    return new SetReferenceOperation(referenceId, refSetOp);
  };
  function BaseIdPersistenceContext(idCompressor) {
    this.u3m_1 = idCompressor;
    this.v3m_1 = HashMap_init_$Create$();
    this.w3m_1 = ArrayList_init_$Create$();
  }
  protoOf(BaseIdPersistenceContext).j4u = function () {
    return this.u3m_1;
  };
  protoOf(BaseIdPersistenceContext).i4u = function () {
    return this.w3m_1;
  };
  protoOf(BaseIdPersistenceContext).w4t = function (kind, persister) {
    // Inline function 'kotlin.check' call
    if (!!this.v3m_1.o2(kind)) {
      var message = kind.toString();
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    if (persister instanceof CompressingIdPersister) {
      (persister instanceof CompressingIdPersister ? persister : THROW_CCE()).n4w(this.j4u());
    }
    // Inline function 'kotlin.collections.set' call
    this.v3m_1.t2(kind, persister);
  };
  protoOf(BaseIdPersistenceContext).d4u = function (delegate) {
    this.w3m_1.j(delegate);
  };
  protoOf(BaseIdPersistenceContext).q3l = function (kind) {
    var persister = this.v3m_1.q2(kind);
    var _iterator__ex2g4s = this.w3m_1.m();
    $l$loop: while (_iterator__ex2g4s.n()) {
      var delegate = _iterator__ex2g4s.o();
      if (!(persister == null)) {
        break $l$loop;
      }
      persister = delegate.q3l(kind);
    }
    var tmp0 = persister;
    $l$block: {
      // Inline function 'kotlin.checkNotNull' call
      if (tmp0 == null) {
        var message = 'Unknown id persister kind ' + kind.toString();
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      } else {
        break $l$block;
      }
    }
    return isInterface(persister, Persister) ? persister : THROW_CCE();
  };
  function BulkUpdateIdCompressor_init_$Init$(initialIdToShortcutMap, shortcutsPersister, $this) {
    BulkUpdateIdCompressor_init_$Init$_0(initialIdToShortcutMap, shortcutsPersister, HashMap_init_$Create$(), $this);
    return $this;
  }
  function BulkUpdateIdCompressor_init_$Init$_0(initialIdToShortcutMap, shortcutsPersister, updateMap, $this) {
    SelfUpdatingIdCompressor_init_$Init$(initialIdToShortcutMap, new MyPersister(updateMap), $this);
    BulkUpdateIdCompressor.call($this);
    $this.y4r_1 = updateMap;
    $this.z4r_1 = shortcutsPersister;
    return $this;
  }
  function rollbackUpdate($this, updateData) {
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s = updateData.y().m();
    while (_iterator__ex2g4s.n()) {
      var _destruct__k2r9zo = _iterator__ex2g4s.o();
      // Inline function 'kotlin.collections.component1' call
      var key = _destruct__k2r9zo.z();
      // Inline function 'kotlin.collections.component2' call
      var value = _destruct__k2r9zo.a1();
      $this.o4w(key, value);
    }
  }
  function MyPersister(map) {
    this.p4w_1 = map;
  }
  protoOf(MyPersister).q4w = function (id, shortcut) {
    // Inline function 'kotlin.collections.set' call
    this.p4w_1.t2(id, shortcut);
    return true;
  };
  protoOf(BulkUpdateIdCompressor).r4w = function () {
    return this.a4s_1;
  };
  protoOf(BulkUpdateIdCompressor).b4s = function () {
    // Inline function 'kotlin.check' call
    if (!!this.r4w()) {
      var message = 'Multiple updates are not allowed';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    this.a4s_1 = true;
    this.y4r_1.k2();
  };
  protoOf(BulkUpdateIdCompressor).s4w = function (commit) {
    // Inline function 'kotlin.check' call
    if (!this.r4w()) {
      var message = 'IdCompressor is not updating';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    this.a4s_1 = false;
    try {
      if (commit) {
        this.z4r_1(HashMap_init_$Create$_1(this.y4r_1));
      } else {
        rollbackUpdate(this, this.y4r_1);
      }
    } catch ($p) {
      if ($p instanceof Error) {
        var t = $p;
        rollbackUpdate(this, this.y4r_1);
        throw t;
      } else {
        throw $p;
      }
    }
    finally {
      this.y4r_1.k2();
    }
  };
  function BulkUpdateIdCompressor() {
    this.a4s_1 = false;
  }
  function baseSerialize($this, value) {
    return $this.k4w_1.n25(value);
  }
  function pack($this, value) {
    return ensureNotNull($this.l4w_1).a4x(ensureNotNull(value));
  }
  function canBePacked($this, id) {
    return !($this.l4w_1 == null) && ensureNotNull($this.l4w_1).z4w(baseSerialize($this, id));
  }
  function CompressingIdPersister(basePersister) {
    this.k4w_1 = basePersister;
    this.l4w_1 = null;
    this.m4w_1 = new ExceptionNullPersister();
  }
  protoOf(CompressingIdPersister).m25 = function () {
    return this.m4w_1;
  };
  protoOf(CompressingIdPersister).n4w = function (context) {
    this.l4w_1 = context;
  };
  protoOf(CompressingIdPersister).o25 = function (value) {
    var valueStr = value;
    if (!(this.l4w_1 == null)) {
      valueStr = ensureNotNull(this.l4w_1).c4x(ensureNotNull(valueStr));
    }
    return this.k4w_1.p25(valueStr);
  };
  protoOf(CompressingIdPersister).a4v = function (value) {
    var serialized = baseSerialize(this, value);
    return canBePacked(this, value) ? pack(this, serialized) : serialized;
  };
  protoOf(CompressingIdPersister).n25 = function (value) {
    return this.a4v(value instanceof BaseId ? value : THROW_CCE());
  };
  function DefaultIdPersister() {
    this.z4u_1 = new NullPersisterForNullable();
  }
  protoOf(DefaultIdPersister).o25 = function (value) {
    return this.y4u(value);
  };
  protoOf(DefaultIdPersister).a4v = function (value) {
    return value.q36_1;
  };
  protoOf(DefaultIdPersister).n25 = function (value) {
    return this.a4v(value instanceof BaseId ? value : THROW_CCE());
  };
  protoOf(DefaultIdPersister).m25 = function () {
    return this.z4u_1;
  };
  function DefaultSelfUpdatingIdCompressor$Companion$consumer$o($map) {
    return function (value) {
      $map.v2(value);
      return Unit_instance;
    };
  }
  function DefaultSelfUpdatingIdCompressor_init_$Init$(initialIdToShortcutMap, $this) {
    initialIdToShortcutMap = initialIdToShortcutMap === VOID ? emptyMap() : initialIdToShortcutMap;
    DefaultSelfUpdatingIdCompressor.call($this, HashMap_init_$Create$(), initialIdToShortcutMap);
    return $this;
  }
  function DefaultSelfUpdatingIdCompressor_init_$Create$(initialIdToShortcutMap) {
    return DefaultSelfUpdatingIdCompressor_init_$Init$(initialIdToShortcutMap, objectCreate(protoOf(DefaultSelfUpdatingIdCompressor)));
  }
  function Companion_71() {
  }
  protoOf(Companion_71).e4x = function (map) {
    return DefaultSelfUpdatingIdCompressor$Companion$consumer$o(map);
  };
  var Companion_instance_71;
  function Companion_getInstance_71() {
    return Companion_instance_71;
  }
  function DefaultSelfUpdatingIdCompressor(idToShortcutUpdate, initialIdToShortcutMap) {
    BulkUpdateIdCompressor_init_$Init$(initialIdToShortcutMap, Companion_instance_71.e4x(idToShortcutUpdate), this);
    this.j4s_1 = idToShortcutUpdate;
  }
  protoOf(DefaultSelfUpdatingIdCompressor).k4s = function () {
    // Inline function 'kotlin.check' call
    if (!this.r4w()) {
      var message = 'Attempt to get update from non-updating compressor';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    this.s4w(true);
    var changes = HashMap_init_$Create$_1(this.j4s_1);
    this.j4s_1.k2();
    return changes;
  };
  function IdCompressor_init_$Init$($this) {
    IdCompressor.call($this);
    return $this;
  }
  function IdCompressor_init_$Init$_0(initialIdToShortcutMap, $this) {
    IdCompressor.call($this);
    var _iterator__ex2g4s = initialIdToShortcutMap.r2().m();
    while (_iterator__ex2g4s.n()) {
      var id = _iterator__ex2g4s.o();
      $this.d4x(id, getValue_0(initialIdToShortcutMap, id));
    }
    return $this;
  }
  protoOf(IdCompressor).a4x = function (id) {
    // Inline function 'kotlin.collections.getOrElse' call
    var tmp0_elvis_lhs = this.h4r_1.q2(id);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      tmp = this.x4w(id);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  protoOf(IdCompressor).b4x = function (id) {
    return this.h4r_1.q2(id);
  };
  protoOf(IdCompressor).c4x = function (shortcut) {
    // Inline function 'kotlin.collections.getOrElse' call
    var tmp0_elvis_lhs = this.i4r_1.q2(shortcut);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      tmp = this.y4w(shortcut);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  protoOf(IdCompressor).d4x = function (id, shortcut) {
    // Inline function 'kotlin.check' call
    if (!!this.h4r_1.o2(id)) {
      var message = 'Id is already registered: ' + id;
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    // Inline function 'kotlin.check' call
    if (!!this.i4r_1.o2(shortcut)) {
      var message_0 = 'Shortcut already used: ' + shortcut;
      throw IllegalStateException_init_$Create$_0(toString_1(message_0));
    }
    // Inline function 'kotlin.collections.set' call
    this.h4r_1.t2(id, shortcut);
    // Inline function 'kotlin.collections.set' call
    this.i4r_1.t2(shortcut, id);
  };
  protoOf(IdCompressor).o4w = function (id, shortcut) {
    // Inline function 'kotlin.check' call
    if (!this.h4r_1.o2(id)) {
      var message = 'Id is not registered: ' + id;
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    // Inline function 'kotlin.check' call
    if (!this.i4r_1.o2(shortcut)) {
      var message_0 = 'Shortcut was not assigned: ' + shortcut;
      throw IllegalStateException_init_$Create$_0(toString_1(message_0));
    }
    this.h4r_1.u2(id);
    this.i4r_1.u2(shortcut);
  };
  protoOf(IdCompressor).x2g = function () {
    return this.h4r_1.p();
  };
  protoOf(IdCompressor).k2 = function () {
    this.h4r_1.k2();
    this.i4r_1.k2();
  };
  protoOf(IdCompressor).z4w = function (id) {
    return this.h4r_1.o2(id);
  };
  function IdCompressor() {
    this.h4r_1 = HashMap_init_$Create$();
    this.i4r_1 = HashMap_init_$Create$();
  }
  function NullableIdPersister() {
  }
  protoOf(NullableIdPersister).v24 = function (value) {
    return this.f4x(value);
  };
  protoOf(NullableIdPersister).g4x = function (value) {
    return value.q36_1;
  };
  protoOf(NullableIdPersister).w24 = function (value) {
    return this.g4x(value instanceof BaseId ? value : THROW_CCE());
  };
  function IdPersisters$ENTITY_ID_PERSISTER$1() {
    NullableIdPersister.call(this);
  }
  protoOf(IdPersisters$ENTITY_ID_PERSISTER$1).f4x = function (id) {
    return EntityId_init_$Create$_0(id);
  };
  function IdPersisters$NODE_ID_PERSISTER$1() {
    NullableIdPersister.call(this);
  }
  protoOf(IdPersisters$NODE_ID_PERSISTER$1).f4x = function (id) {
    return new NodeId(id);
  };
  function IdPersisters() {
    IdPersisters_instance = this;
    var tmp = this;
    tmp.h4x_1 = new IdPersisters$ENTITY_ID_PERSISTER$1();
    var tmp_0 = this;
    tmp_0.i4x_1 = new IdPersisters$NODE_ID_PERSISTER$1();
  }
  protoOf(IdPersisters).j4x = function () {
    return toNonNullPersister(this.i4x_1);
  };
  protoOf(IdPersisters).k4x = function () {
    return toNullablePersister(this.i4x_1, new EmptyStringNullPersister());
  };
  var IdPersisters_instance;
  function IdPersisters_getInstance() {
    if (IdPersisters_instance == null)
      new IdPersisters();
    return IdPersisters_instance;
  }
  function flagsToPrefix($this, flags) {
    if (flags.s())
      return '';
    var allFlags = $this.s4t();
    var r = StringBuilder_init_$Create$(allFlags.length);
    var inductionVariable = 0;
    var last = allFlags.length;
    while (inductionVariable < last) {
      var f = allFlags[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (flags.t(f)) {
        r.k8(_Char___init__impl__6a9atx(42));
      } else {
        r.k8(_Char___init__impl__6a9atx(126));
      }
    }
    r.l1();
    var i = 0;
    $l$loop: while (i < r.a() && r.b(i) !== _Char___init__impl__6a9atx(42)) {
      i = i + 1 | 0;
    }
    return r.lc(i);
  }
  function prefixToFlags($this, prefix) {
    var flags = HashSet_init_$Create$();
    var allFlags = $this.s4t();
    // Inline function 'kotlin.require' call
    if (!(prefix.length <= allFlags.length)) {
      var message = 'Prefix has more positions than flag values: ' + prefix;
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    var inductionVariable = 0;
    var last = charSequenceLength(prefix) - 1 | 0;
    if (inductionVariable <= last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (charCodeAt(prefix, (prefix.length - i | 0) - 1 | 0) === _Char___init__impl__6a9atx(42)) {
          flags.j(allFlags[i]);
        }
      }
       while (inductionVariable <= last);
    return flags;
  }
  function Companion_72() {
    Companion_instance_72 = this;
    this.l4x_1 = _Char___init__impl__6a9atx(42);
    this.m4x_1 = _Char___init__impl__6a9atx(126);
  }
  var Companion_instance_72;
  function Companion_getInstance_72() {
    if (Companion_instance_72 == null)
      new Companion_72();
    return Companion_instance_72;
  }
  function MetaIdPersister() {
    Companion_getInstance_72();
    this.t4t_1 = new ExceptionNullPersister();
  }
  protoOf(MetaIdPersister).o25 = function (value) {
    var tmp0 = lastIndexOf_3(value, _Char___init__impl__6a9atx(42));
    // Inline function 'kotlin.math.max' call
    var b = lastIndexOf_3(value, _Char___init__impl__6a9atx(126));
    var i = Math.max(tmp0, b);
    var id;
    var flags;
    if (i < 0) {
      id = value;
      flags = emptySet();
    } else {
      id = substring_0(value, i + 1 | 0);
      flags = prefixToFlags(this, take_1(value, i + 1 | 0));
    }
    return this.r4t(id, flags);
  };
  protoOf(MetaIdPersister).u4t = function (value) {
    var id = value.q36_1;
    // Inline function 'kotlin.require' call
    if (!(indexOf_8(id, _Char___init__impl__6a9atx(42)) < 0 && indexOf_8(id, _Char___init__impl__6a9atx(126)) < 0)) {
      var message = "Meta id cannot contain '*' or '~': " + toString_1(value);
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    return flagsToPrefix(this, value.w3h()) + id;
  };
  protoOf(MetaIdPersister).n25 = function (value) {
    return this.u4t(value instanceof MetaId ? value : THROW_CCE());
  };
  protoOf(MetaIdPersister).m25 = function () {
    return this.t4t_1;
  };
  function nullIdCompressorSupplier() {
    return nullIdCompressorSupplier$lambda;
  }
  function nullIdCompressorSupplier$lambda() {
    return null;
  }
  function RoleIdPersister() {
    MetaIdPersister.call(this);
    this.o4u_1 = values_2();
  }
  protoOf(RoleIdPersister).s4t = function () {
    return this.o4u_1;
  };
  function SelfUpdatingIdCompressor_init_$Init$(initialIdToShortcutMap, callback, $this) {
    IdCompressor_init_$Init$_0(initialIdToShortcutMap, $this);
    SelfUpdatingIdCompressor.call($this);
    $this.w4w_1 = callback;
    return $this;
  }
  protoOf(SelfUpdatingIdCompressor).x4w = function (id) {
    var shortcut = this.b4x(id);
    if (!(shortcut == null)) {
      return shortcut;
    }
    // Inline function 'kotlin.check' call
    if (!this.r4w()) {
      var message = 'Attempt to modify id dictionary without collecting changes';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    shortcut = this.v4w_1.p4x(this.x2g());
    var result = this.w4w_1.q4w(id, shortcut);
    if (!result) {
      return id;
    }
    this.d4x(id, shortcut);
    return shortcut;
  };
  protoOf(SelfUpdatingIdCompressor).y4w = function (shortcut) {
    return shortcut;
  };
  protoOf(SelfUpdatingIdCompressor).j4r = function (patch) {
    throw IllegalStateException_init_$Create$_0('Attempt to update non-updatable id compressor');
  };
  protoOf(SelfUpdatingIdCompressor).z4w = function (id) {
    return this.r4w() || protoOf(IdCompressor).z4w.call(this, id);
  };
  function SelfUpdatingIdCompressor() {
    this.v4w_1 = new ShortcutConverter();
  }
  function addChars($this, from, to) {
    var inductionVariable = from;
    if (inductionVariable < to)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        $this.o4x_1.j(new Char(numberToChar(i)));
      }
       while (inductionVariable < to);
  }
  function ShortcutConverter() {
    this.o4x_1 = ArrayList_init_$Create$();
    addChars(this, 48, 58);
    addChars(this, 65, 91);
    addChars(this, 97, 123);
    this.n4x_1 = this.o4x_1.p();
  }
  protoOf(ShortcutConverter).p4x = function (i) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.require' call
    if (!(i >= 0)) {
      var message = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    var sb = StringBuilder_init_$Create$_1();
    var current = i;
    do {
      sb.k8(this.o4x_1.r(current % this.n4x_1 | 0).s1_1);
      current = current / this.n4x_1 | 0;
    }
     while (!(current === 0));
    // Inline function 'kotlin.text.reversed' call
    var this_0 = sb.toString();
    return toString_1(reversed_1(isCharSequence(this_0) ? this_0 : THROW_CCE()));
  };
  function UpdatableIdCompressor() {
    IdCompressor_init_$Init$(this);
  }
  protoOf(UpdatableIdCompressor).x4w = function (id) {
    return id;
  };
  protoOf(UpdatableIdCompressor).y4w = function (shortcut) {
    throw IllegalStateException_init_$Create$_0('Unregistered shortcut ' + shortcut);
  };
  protoOf(UpdatableIdCompressor).j4r = function (patch) {
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s = patch.y().m();
    while (_iterator__ex2g4s.n()) {
      var _destruct__k2r9zo = _iterator__ex2g4s.o();
      // Inline function 'kotlin.collections.component1' call
      var key = _destruct__k2r9zo.z();
      // Inline function 'kotlin.collections.component2' call
      var value = _destruct__k2r9zo.a1();
      this.d4x(key, value);
    }
  };
  protoOf(UpdatableIdCompressor).z4w = function (id) {
    return true;
  };
  function ModelKind(name) {
    this.s4x_1 = name;
  }
  protoOf(ModelKind).toString = function () {
    return this.s4x_1;
  };
  function AddChildOperationPersister_0() {
    ChildOperationPersister_0.call(this);
    this.t4x_1 = 'a';
    this.u4x_1 = getKClass(AddChildOperation_0);
  }
  protoOf(AddChildOperationPersister_0).t3c = function () {
    return this.t4x_1;
  };
  protoOf(AddChildOperationPersister_0).j4q = function () {
    return this.u4x_1;
  };
  protoOf(AddChildOperationPersister_0).v4x = function (op) {
    return op instanceof AddChildOperation_0;
  };
  protoOf(AddChildOperationPersister_0).w4x = function (conceptId, nodeId, index, isSingleRole) {
    return AddChildOperation_init_$Create$_1(conceptId, nodeId, index, isSingleRole);
  };
  function ChangeChildOperationPersister_0() {
    this.y4x_1 = 'cc';
    this.z4x_1 = getKClass(ChangeChildOperation_0);
  }
  protoOf(ChangeChildOperationPersister_0).t3c = function () {
    return this.y4x_1;
  };
  protoOf(ChangeChildOperationPersister_0).j4q = function () {
    return this.z4x_1;
  };
  protoOf(ChangeChildOperationPersister_0).x4x = function (ctx, op) {
    if (op instanceof ChangeChildOperation_0) {
      var result = new JsonArray();
      result.m2h(serializeNodeId(ctx, ensureNotNull(op.l4i_1)));
      result.m2h(ensureNotNull(Persisters_getInstance().i25().w24(op.l3p())));
      result.y2g(ctx.r4q(NodeModelKinds_getInstance().n4v_1, op.s3z()));
      return result;
    }
    throw UnsupportedOperationException_init_$Create$_0(toString_1(getKClassFromExpression(op)));
  };
  protoOf(ChangeChildOperationPersister_0).v4q = function (ctx, op) {
    return this.x4x(ctx, op);
  };
  protoOf(ChangeChildOperationPersister_0).w4q = function (ctx, json) {
    var nodeId = deserializeNodeId(ctx, json.s2h(0));
    var childIndex = Persisters_getInstance().i25().p25(json.s2h(1));
    var nodeOp = ctx.t4q(NodeModelKinds_getInstance().n4v_1, json.r2h(2));
    return new ChangeChildOperation_0(nodeId, childIndex, nodeOp);
  };
  function ChildOperationPersister_0() {
  }
  protoOf(ChildOperationPersister_0).x4x = function (ctx, op) {
    if (this.v4x(op)) {
      var chOp = op instanceof ChildOperation_0 ? op : THROW_CCE();
      var result = new JsonArray();
      // Inline function 'kotlin.with' call
      result.m2h(serializeConceptId(ctx, chOp.f3t()));
      result.m2h(serializeNodeId(ctx, ensureNotNull(chOp.v3w())));
      result.m2h(ensureNotNull(Persisters_getInstance().i25().w24(chOp.m3p())));
      if (chOp.s4h_1) {
        result.o2h(0.0);
      }
      return result;
    }
    throw UnsupportedOperationException_init_$Create$_0(toString_1(getKClassFromExpression(op)));
  };
  protoOf(ChildOperationPersister_0).v4q = function (ctx, op) {
    return this.x4x(ctx, op);
  };
  protoOf(ChildOperationPersister_0).w4q = function (ctx, json) {
    var conceptId = deserializeConceptId(ctx, json.s2h(0));
    var nodeId = deserializeNodeId(ctx, json.s2h(1));
    var index = Persisters_getInstance().i25().p25(json.s2h(2));
    var isSingleRole = json.x2g() === 4;
    return this.w4x(conceptId, nodeId, index, isSingleRole);
  };
  function RemoveChildOperationPersister_0() {
    ChildOperationPersister_0.call(this);
    this.a4y_1 = 'r';
    this.b4y_1 = getKClass(RemoveChildOperation_0);
  }
  protoOf(RemoveChildOperationPersister_0).t3c = function () {
    return this.a4y_1;
  };
  protoOf(RemoveChildOperationPersister_0).j4q = function () {
    return this.b4y_1;
  };
  protoOf(RemoveChildOperationPersister_0).v4x = function (op) {
    return op instanceof RemoveChildOperation_0;
  };
  protoOf(RemoveChildOperationPersister_0).w4x = function (conceptId, nodeId, index, isSingleRole) {
    return RemoveChildOperation_init_$Create$_1(conceptId, nodeId, index, isSingleRole);
  };
  function getConceptIdPersister($this, ctx) {
    return ctx.l4q_1.q3l(NodeIdModelKinds_getInstance().a3m_1);
  }
  function getNodeIdPersister($this, ctx) {
    return ctx.l4q_1.q3l(NodeIdModelKinds_getInstance().y3l_1);
  }
  function ReplaceChildOperationPersister() {
    this.c4y_1 = 'rep';
    this.d4y_1 = getKClass(ReplaceChildOperation);
  }
  protoOf(ReplaceChildOperationPersister).t3c = function () {
    return this.c4y_1;
  };
  protoOf(ReplaceChildOperationPersister).j4q = function () {
    return this.d4y_1;
  };
  protoOf(ReplaceChildOperationPersister).x4x = function (ctx, op) {
    if (op instanceof ReplaceChildOperation) {
      var conceptIdPersister = getConceptIdPersister(this, ctx);
      var nodeIdPersister = getNodeIdPersister(this, ctx);
      var result = new JsonArray();
      result.m2h(ensureNotNull(conceptIdPersister.w24(op.m42())));
      result.m2h(ensureNotNull(nodeIdPersister.w24(ensureNotNull(op.o4i()))));
      result.m2h(ensureNotNull(conceptIdPersister.w24(op.n42())));
      result.m2h(ensureNotNull(nodeIdPersister.w24(ensureNotNull(op.b4i()))));
      result.m2h(ensureNotNull(Persisters_getInstance().i25().w24(op.m3p())));
      if (op.s4h_1) {
        result.o2h(0.0);
      }
      return result;
    }
    throw UnsupportedOperationException_init_$Create$_0(toString_1(getKClassFromExpression(op)));
  };
  protoOf(ReplaceChildOperationPersister).v4q = function (ctx, op) {
    return this.x4x(ctx, op);
  };
  protoOf(ReplaceChildOperationPersister).w4q = function (ctx, json) {
    var conceptIdPersister = getConceptIdPersister(this, ctx);
    var nodeIdPersister = getNodeIdPersister(this, ctx);
    var oldConceptId = conceptIdPersister.p25(json.s2h(0));
    var oldId = nodeIdPersister.p25(json.s2h(1));
    var newConceptId = conceptIdPersister.p25(json.s2h(2));
    var newId = nodeIdPersister.p25(json.s2h(3));
    var index = Persisters_getInstance().i25().p25(json.s2h(4));
    var isSingleRole = json.x2g() === 6;
    return ReplaceChildOperation_init_$Create$(oldConceptId, oldId, newConceptId, newId, index, isSingleRole);
  };
  function serializeConceptId(_this__u8e3s4, nodeConceptId) {
    return ensureNotNull(_this__u8e3s4.a4r(NodeIdModelKinds_getInstance().a3m_1, nodeConceptId));
  }
  function serializeNodeId(_this__u8e3s4, nodeId) {
    return ensureNotNull(_this__u8e3s4.a4r(NodeIdModelKinds_getInstance().y3l_1, nodeId));
  }
  function deserializeConceptId(_this__u8e3s4, value) {
    return _this__u8e3s4.b4r(NodeIdModelKinds_getInstance().a3m_1, value);
  }
  function deserializeNodeId(_this__u8e3s4, value) {
    return _this__u8e3s4.b4r(NodeIdModelKinds_getInstance().y3l_1, value);
  }
  function NodeConceptIdPersister() {
    MetaIdPersister.call(this);
    this.f4y_1 = values_1();
  }
  protoOf(NodeConceptIdPersister).s4t = function () {
    return this.f4y_1;
  };
  protoOf(NodeConceptIdPersister).g4y = function (id, flags) {
    return NodeConceptIdFactory_getInstance().r3q(id, null, flags);
  };
  protoOf(NodeConceptIdPersister).r4t = function (id, flags) {
    return this.g4y(id, flags);
  };
  function NodeIdPersistenceContext(idCompressor) {
    idCompressor = idCompressor === VOID ? null : idCompressor;
    BaseIdPersistenceContext.call(this, idCompressor);
    this.w4t(NodeIdModelKinds_getInstance().y3l_1, IdPersisters_getInstance().j4x());
    this.w4t(NodeIdModelKinds_getInstance().z3l_1, IdPersisters_getInstance().k4x());
    this.w4t(NodeIdModelKinds_getInstance().a3m_1, PrivateNodeIdPersisters_instance.x4t());
    this.w4t(NodeIdModelKinds_getInstance().b3m_1, PrivateNodeIdPersisters_instance.y4t());
    this.w4t(NodeIdModelKinds_getInstance().c3m_1, PrivateNodeIdPersisters_instance.b4u());
  }
  function NodeIdPersisters$childIdPersister$1() {
    RoleIdPersister.call(this);
  }
  protoOf(NodeIdPersisters$childIdPersister$1).m4u = function (id, flags) {
    return NodeChildIdFactory_getInstance().h3q(id, null, flags);
  };
  protoOf(NodeIdPersisters$childIdPersister$1).r4t = function (id, flags) {
    return this.m4u(id, flags);
  };
  function NodeIdPersisters() {
  }
  protoOf(NodeIdPersisters).x4t = function () {
    return new NodeConceptIdPersister();
  };
  protoOf(NodeIdPersisters).b4u = function () {
    return new NodeIdPersisters$childIdPersister$1();
  };
  var NodeIdPersisters_instance;
  function NodeIdPersisters_getInstance() {
    return NodeIdPersisters_instance;
  }
  function PrivateNodeIdPersisters$propertyIdPersister$basePersister$1() {
    DefaultIdPersister.call(this);
  }
  protoOf(PrivateNodeIdPersisters$propertyIdPersister$basePersister$1).y4u = function (id) {
    return NodePropertyIdFactory_getInstance().b3r(id);
  };
  function PrivateNodeIdPersisters() {
  }
  protoOf(PrivateNodeIdPersisters).x4t = function () {
    return new CompressingIdPersister(NodeIdPersisters_instance.x4t());
  };
  protoOf(PrivateNodeIdPersisters).y4t = function () {
    var basePersister = new PrivateNodeIdPersisters$propertyIdPersister$basePersister$1();
    return new CompressingIdPersister(basePersister);
  };
  protoOf(PrivateNodeIdPersisters).b4u = function () {
    return new CompressingIdPersister(NodeIdPersisters_instance.b4u());
  };
  var PrivateNodeIdPersisters_instance;
  function PrivateNodeIdPersisters_getInstance() {
    return PrivateNodeIdPersisters_instance;
  }
  function NodeIdModelKinds() {
    NodeIdModelKinds_instance = this;
    this.y3l_1 = new ModelKind('nodeId');
    this.z3l_1 = new ModelKind('nullableNodeId');
    this.a3m_1 = new ModelKind('nodeConceptId');
    this.b3m_1 = new ModelKind('nodePropertyId');
    this.c3m_1 = new ModelKind('nodeChildId');
  }
  var NodeIdModelKinds_instance;
  function NodeIdModelKinds_getInstance() {
    if (NodeIdModelKinds_instance == null)
      new NodeIdModelKinds();
    return NodeIdModelKinds_instance;
  }
  function NodeModelKinds() {
    NodeModelKinds_instance = this;
    this.m4v_1 = new ModelKind('model');
    this.n4v_1 = new ModelKind('node');
    this.o4v_1 = new ModelKind('nodeChildren');
    this.p4v_1 = new ModelKind('nodeProperty');
  }
  var NodeModelKinds_instance;
  function NodeModelKinds_getInstance() {
    if (NodeModelKinds_instance == null)
      new NodeModelKinds();
    return NodeModelKinds_instance;
  }
  function ChangePropertyOperationPersister() {
    this.k4y_1 = 'cp';
    this.l4y_1 = getKClass(ChangePropertyOperation);
  }
  protoOf(ChangePropertyOperationPersister).t3c = function () {
    return this.k4y_1;
  };
  protoOf(ChangePropertyOperationPersister).j4q = function () {
    return this.l4y_1;
  };
  protoOf(ChangePropertyOperationPersister).m4y = function (ctx, op) {
    if (op instanceof ChangePropertyOperation) {
      var result = new JsonArray();
      result.m2h(ensureNotNull(ctx.a4r(NodeIdModelKinds_getInstance().b3m_1, op.l3p())));
      result.y2g(ctx.r4q(NodeModelKinds_getInstance().p4v_1, op.s3z()));
      return result;
    }
    throw UnsupportedOperationException_init_$Create$_0(toString_1(getKClassFromExpression(op)));
  };
  protoOf(ChangePropertyOperationPersister).v4q = function (ctx, op) {
    return this.m4y(ctx, op);
  };
  protoOf(ChangePropertyOperationPersister).w4q = function (ctx, json) {
    var propertyId = ctx.b4r(NodeIdModelKinds_getInstance().b3m_1, json.s2h(0));
    var op = ctx.t4q(NodeModelKinds_getInstance().p4v_1, json.r2h(1));
    return new ChangePropertyOperation(propertyId, op);
  };
  function ChildListOperationPersister(rolePersister) {
    TargetedOperationPersister.call(this, rolePersister);
    this.o4y_1 = 'sc';
    this.p4y_1 = getKClass(ChildListOperation);
    this.q4y_1 = NodeModelKinds_getInstance().o4v_1;
  }
  protoOf(ChildListOperationPersister).t3c = function () {
    return this.o4y_1;
  };
  protoOf(ChildListOperationPersister).j4q = function () {
    return this.p4y_1;
  };
  protoOf(ChildListOperationPersister).r4y = function (op) {
    return op instanceof ChildListOperation;
  };
  protoOf(ChildListOperationPersister).e4r = function (op) {
    return this.r4y(op);
  };
  protoOf(ChildListOperationPersister).d4r = function () {
    return this.q4y_1;
  };
  protoOf(ChildListOperationPersister).s4y = function (role, op) {
    return new ChildListOperation(ensureNotNull(role), op);
  };
  protoOf(ChildListOperationPersister).f4r = function (role, op) {
    return this.s4y((role == null ? true : role instanceof NodeChildId) ? role : THROW_CCE(), op);
  };
  function NodeOperationsPersistenceContext(idPersistenceContext) {
    OperationPersistenceContext.call(this, idPersistenceContext);
    this.y4q(NodeModelKinds_getInstance().m4v_1, [new SetModelOperationPersister()]);
    this.y4q(NodeModelKinds_getInstance().n4v_1, [new ChildListOperationPersister(idPersistenceContext.q3l(NodeIdModelKinds_getInstance().c3m_1)), new ChangePropertyOperationPersister()]);
    this.y4q(NodeModelKinds_getInstance().o4v_1, [new AddChildOperationPersister_0(), new RemoveChildOperationPersister_0(), new ChangeChildOperationPersister_0(), new ReplaceChildOperationPersister(), new AddChildSplitPropertyOperationPersister(), new AddChildSplitChildCollectionOperationPersister(), new MergePropertyRemoveChildOperationPersister(), new MergeChildCollectionRemoveChildOperationPersister()]);
    this.y4q(NodeModelKinds_getInstance().p4v_1, [new SetValueOperationPersister(Persisters_getInstance().a26()), new InsertTextOperationsPersister(), new DeleteTextOperationPersister()]);
  }
  function SetModelOperationPersister() {
    TargetedOperationPersister.call(this, Persisters_getInstance().z25());
    this.u4y_1 = NodeModelKinds_getInstance().n4v_1;
    this.v4y_1 = 'sm';
    this.w4y_1 = getKClass(SetModelOperation);
  }
  protoOf(SetModelOperationPersister).d4r = function () {
    return this.u4y_1;
  };
  protoOf(SetModelOperationPersister).t3c = function () {
    return this.v4y_1;
  };
  protoOf(SetModelOperationPersister).j4q = function () {
    return this.w4y_1;
  };
  protoOf(SetModelOperationPersister).x4y = function (op) {
    return op instanceof SetModelOperation;
  };
  protoOf(SetModelOperationPersister).e4r = function (op) {
    return this.x4y(op);
  };
  protoOf(SetModelOperationPersister).y4y = function (role, op) {
    return new SetModelOperation(op);
  };
  protoOf(SetModelOperationPersister).f4r = function (role, op) {
    return this.y4y((role == null ? true : typeof role === 'string') ? role : THROW_CCE(), op);
  };
  function AddChildSplitChildCollectionOperationPersister() {
    BaseAddChildSplitOperationPersister.call(this);
    this.z4y_1 = 'acscc';
    this.a4z_1 = getKClass(AddChildSplitChildCollectionOperation);
  }
  protoOf(AddChildSplitChildCollectionOperationPersister).b4z = function (op) {
    return (op instanceof AddChildSplitChildCollectionOperation ? op : THROW_CCE()).p41_1;
  };
  protoOf(AddChildSplitChildCollectionOperationPersister).c4z = function (op) {
    return op instanceof AddChildSplitChildCollectionOperation;
  };
  protoOf(AddChildSplitChildCollectionOperationPersister).d4z = function (ctx, op) {
    var splitOp = op instanceof AddChildSplitChildCollectionOperation ? op : THROW_CCE();
    var res = new JsonArray();
    res.m2h(ensureNotNull(Persisters_getInstance().i25().w24(splitOp.l4o_1)));
    res.m2h(ensureNotNull(ctx.a4r(NodeIdModelKinds_getInstance().c3m_1, splitOp.k4o_1)));
    return res;
  };
  protoOf(AddChildSplitChildCollectionOperationPersister).e4z = function (data, ctx) {
    var additionalData = data.k4z_1;
    var splitSize = Persisters_getInstance().i25().p25(additionalData.s2h(0));
    var childId = ctx.q3l(NodeIdModelKinds_getInstance().c3m_1).p25(additionalData.s2h(1));
    return new AddChildSplitChildCollectionOperation(data.f4z_1, data.g4z_1, data.h4z_1, data.i4z_1, childId, data.j4z_1, splitSize);
  };
  protoOf(AddChildSplitChildCollectionOperationPersister).t3c = function () {
    return this.z4y_1;
  };
  protoOf(AddChildSplitChildCollectionOperationPersister).j4q = function () {
    return this.a4z_1;
  };
  function AddChildSplitPropertyOperationPersister() {
    BaseAddChildSplitOperationPersister.call(this);
    this.l4z_1 = 'acsp';
    this.m4z_1 = getKClass(AddChildSplitPropertyOperation);
  }
  protoOf(AddChildSplitPropertyOperationPersister).b4z = function (op) {
    var splitOp = op instanceof AddChildSplitPropertyOperation ? op : THROW_CCE();
    return splitOp.y4o() ? -1 : splitOp.p41_1;
  };
  protoOf(AddChildSplitPropertyOperationPersister).c4z = function (op) {
    return op instanceof AddChildSplitPropertyOperation;
  };
  protoOf(AddChildSplitPropertyOperationPersister).d4z = function (ctx, op) {
    var splitOp = op instanceof AddChildSplitPropertyOperation ? op : THROW_CCE();
    var res = new JsonArray();
    res.m2h(ensureNotNull(ctx.a4r(NodeIdModelKinds_getInstance().b3m_1, splitOp.c42_1)));
    res.m2h(ensureNotNull(Persisters_getInstance().z25().w24(splitOp.e42_1)));
    return res;
  };
  protoOf(AddChildSplitPropertyOperationPersister).e4z = function (data, ctx) {
    var additionalData = data.k4z_1;
    var propertyId = ctx.q3l(NodeIdModelKinds_getInstance().b3m_1).p25(additionalData.s2h(0));
    var movedText = Persisters_getInstance().z25().p25(additionalData.s2h(1));
    return new AddChildSplitPropertyOperation(data.f4z_1, data.g4z_1, data.h4z_1, data.i4z_1, propertyId, data.j4z_1, movedText);
  };
  protoOf(AddChildSplitPropertyOperationPersister).t3c = function () {
    return this.l4z_1;
  };
  protoOf(AddChildSplitPropertyOperationPersister).j4q = function () {
    return this.m4z_1;
  };
  function BaseAddChildSplitOperationPersister() {
  }
  protoOf(BaseAddChildSplitOperationPersister).x4x = function (ctx, op) {
    if (this.c4z(op)) {
      var splitOp = op instanceof BaseAddChildSplitOperation ? op : THROW_CCE();
      var result = new JsonArray();
      // Inline function 'kotlin.with' call
      result.m2h(serializeConceptId(ctx, splitOp.l41_1));
      result.m2h(serializeNodeId(ctx, splitOp.m41_1));
      result.m2h(serializeNodeId(ctx, splitOp.n41_1));
      result.m2h(ensureNotNull(Persisters_getInstance().i25().w24(splitOp.o41_1)));
      result.m2h(ensureNotNull(Persisters_getInstance().i25().w24(this.b4z(op))));
      result.y2g(this.d4z(ctx, op));
      return result;
    }
    throw UnsupportedOperationException_init_$Create$_0(toString_1(getKClassFromExpression(op)));
  };
  protoOf(BaseAddChildSplitOperationPersister).v4q = function (ctx, op) {
    return this.x4x(ctx, op);
  };
  protoOf(BaseAddChildSplitOperationPersister).w4q = function (ctx, json) {
    return this.e4z(new DeserializationData(ctx, json), ctx.l4q_1);
  };
  function BaseMergeRemoveChildOperationPersister() {
  }
  protoOf(BaseMergeRemoveChildOperationPersister).x4x = function (ctx, op) {
    if (this.c4z(op)) {
      var mergeOp = op instanceof BaseMergeRemoveChildOperation ? op : THROW_CCE();
      var result = new JsonArray();
      // Inline function 'kotlin.with' call
      result.m2h(serializeConceptId(ctx, mergeOp.s40_1));
      result.m2h(serializeNodeId(ctx, mergeOp.t40_1));
      result.m2h(serializeNodeId(ctx, mergeOp.u40_1));
      result.m2h(ensureNotNull(Persisters_getInstance().i25().w24(mergeOp.v40_1)));
      result.m2h(ensureNotNull(Persisters_getInstance().i25().w24(mergeOp.w40_1)));
      result.y2g(this.d4z(ctx, op));
      return result;
    }
    throw UnsupportedOperationException_init_$Create$_0(toString_1(getKClassFromExpression(op)));
  };
  protoOf(BaseMergeRemoveChildOperationPersister).v4q = function (ctx, op) {
    return this.x4x(ctx, op);
  };
  protoOf(BaseMergeRemoveChildOperationPersister).w4q = function (ctx, json) {
    return this.e4z(new DeserializationData(ctx, json), ctx.l4q_1);
  };
  function DeserializationData(ctx, json) {
    this.f4z_1 = deserializeConceptId(ctx, json.s2h(0));
    this.g4z_1 = deserializeNodeId(ctx, json.s2h(1));
    this.h4z_1 = deserializeNodeId(ctx, json.s2h(2));
    this.i4z_1 = Persisters_getInstance().i25().p25(json.s2h(3));
    this.j4z_1 = Persisters_getInstance().i25().p25(json.s2h(4));
    this.k4z_1 = json.r2h(5);
  }
  function MergeChildCollectionRemoveChildOperationPersister() {
    BaseMergeRemoveChildOperationPersister.call(this);
    this.n4z_1 = 'mccrc';
    this.o4z_1 = getKClass(MergeChildCollectionRemoveChildOperation);
  }
  protoOf(MergeChildCollectionRemoveChildOperationPersister).c4z = function (op) {
    return op instanceof MergeChildCollectionRemoveChildOperation;
  };
  protoOf(MergeChildCollectionRemoveChildOperationPersister).d4z = function (ctx, op) {
    var mergeOp = op instanceof MergeChildCollectionRemoveChildOperation ? op : THROW_CCE();
    var res = new JsonArray();
    res.m2h(ensureNotNull(Persisters_getInstance().i25().w24(mergeOp.u4p_1)));
    res.m2h(ensureNotNull(ctx.a4r(NodeIdModelKinds_getInstance().c3m_1, mergeOp.t4p_1)));
    return res;
  };
  protoOf(MergeChildCollectionRemoveChildOperationPersister).e4z = function (data, ctx) {
    var additionalData = data.k4z_1;
    var removedLength = Persisters_getInstance().i25().p25(additionalData.s2h(0));
    var childId = ctx.q3l(NodeIdModelKinds_getInstance().c3m_1).p25(additionalData.s2h(1));
    return new MergeChildCollectionRemoveChildOperation(data.f4z_1, data.g4z_1, data.h4z_1, data.i4z_1, childId, removedLength, data.j4z_1);
  };
  protoOf(MergeChildCollectionRemoveChildOperationPersister).t3c = function () {
    return this.n4z_1;
  };
  protoOf(MergeChildCollectionRemoveChildOperationPersister).j4q = function () {
    return this.o4z_1;
  };
  function MergePropertyRemoveChildOperationPersister() {
    BaseMergeRemoveChildOperationPersister.call(this);
    this.p4z_1 = 'mprc';
    this.q4z_1 = getKClass(MergePropertyRemoveChildOperation);
  }
  protoOf(MergePropertyRemoveChildOperationPersister).c4z = function (op) {
    return op instanceof MergePropertyRemoveChildOperation;
  };
  protoOf(MergePropertyRemoveChildOperationPersister).d4z = function (ctx, op) {
    var mergeOp = op instanceof MergePropertyRemoveChildOperation ? op : THROW_CCE();
    var res = new JsonArray();
    res.m2h(ensureNotNull(ctx.a4r(NodeIdModelKinds_getInstance().b3m_1, mergeOp.h41_1)));
    res.m2h(ensureNotNull(Persisters_getInstance().z25().w24(mergeOp.i41_1)));
    return res;
  };
  protoOf(MergePropertyRemoveChildOperationPersister).e4z = function (data, ctx) {
    var additionalData = data.k4z_1;
    var propertyId = ctx.q3l(NodeIdModelKinds_getInstance().b3m_1).p25(additionalData.s2h(0));
    var mergedProperty = Persisters_getInstance().z25().p25(additionalData.s2h(1));
    return new MergePropertyRemoveChildOperation(data.f4z_1, data.g4z_1, data.h4z_1, data.i4z_1, propertyId, mergedProperty, data.j4z_1);
  };
  protoOf(MergePropertyRemoveChildOperationPersister).t3c = function () {
    return this.p4z_1;
  };
  protoOf(MergePropertyRemoveChildOperationPersister).j4q = function () {
    return this.q4z_1;
  };
  function AddToSetOperationPersister(itemPersister) {
    ChangeSetOperationPersister.call(this, itemPersister);
    this.s4z_1 = 'a';
    this.t4z_1 = getKClass(AddToSetOperation);
  }
  protoOf(AddToSetOperationPersister).t3c = function () {
    return this.s4z_1;
  };
  protoOf(AddToSetOperationPersister).j4q = function () {
    return this.t4z_1;
  };
  protoOf(AddToSetOperationPersister).u4z = function (op) {
    return op instanceof AddToSetOperation;
  };
  protoOf(AddToSetOperationPersister).v4z = function (item, singleRole) {
    return new AddToSetOperation(item, singleRole);
  };
  function ChangeSetOperationPersister(itemPersister) {
    this.w4z_1 = itemPersister;
  }
  protoOf(ChangeSetOperationPersister).x4z = function (ctx, op) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.require' call
    if (!this.u4z(op)) {
      var message = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    var changeOp = op instanceof ChangeSetOperation ? op : THROW_CCE();
    var result = new JsonArray();
    result.m2h(ensureNotNull(this.w4z_1.w24(changeOp.m4f_1)));
    if (changeOp.n4f_1) {
      result.o2h(0.0);
    }
    return result;
  };
  protoOf(ChangeSetOperationPersister).v4q = function (ctx, op) {
    return this.x4z(ctx, op);
  };
  protoOf(ChangeSetOperationPersister).w4q = function (ctx, json) {
    var item = ensureNotNull(this.w4z_1.p25(json.s2h(0)));
    var isSingleRole = json.x2g() === 2;
    return this.v4z(item, isSingleRole);
  };
  function RemoveFromSetOperationPersister(itemPersister) {
    ChangeSetOperationPersister.call(this, itemPersister);
    this.z4z_1 = 'r';
    this.a50_1 = getKClass(RemoveFromSetOperation);
  }
  protoOf(RemoveFromSetOperationPersister).t3c = function () {
    return this.z4z_1;
  };
  protoOf(RemoveFromSetOperationPersister).j4q = function () {
    return this.a50_1;
  };
  protoOf(RemoveFromSetOperationPersister).u4z = function (op) {
    return op instanceof RemoveFromSetOperation;
  };
  protoOf(RemoveFromSetOperationPersister).v4z = function (item, singleRole) {
    return new RemoveFromSetOperation(item, singleRole);
  };
  function Companion_73() {
    this.b50_1 = -2;
  }
  var Companion_instance_73;
  function Companion_getInstance_73() {
    return Companion_instance_73;
  }
  function DeleteTextOperationPersister() {
    this.c50_1 = 'd';
    this.d50_1 = getKClass(DeleteTextOperation);
  }
  protoOf(DeleteTextOperationPersister).t3c = function () {
    return this.c50_1;
  };
  protoOf(DeleteTextOperationPersister).j4q = function () {
    return this.d50_1;
  };
  protoOf(DeleteTextOperationPersister).e50 = function (ctx, op) {
    if (op instanceof DeleteTextOperation) {
      var result = new JsonArray();
      result.m2h(ensureNotNull(Persisters_getInstance().i25().w24(TextOperationUtil_instance.p4m(op))));
      result.m2h(ensureNotNull(Persisters_getInstance().z25().w24(op.s4m_1)));
      return result;
    }
    throw UnsupportedOperationException_init_$Create$_0(toString_1(getKClassFromExpression(op)));
  };
  protoOf(DeleteTextOperationPersister).v4q = function (ctx, op) {
    return this.e50(ctx, op);
  };
  protoOf(DeleteTextOperationPersister).w4q = function (ctx, json) {
    var deleteIndex = Persisters_getInstance().i25().p25(json.s2h(0));
    var text = Persisters_getInstance().z25().p25(json.s2h(1));
    return new DeleteTextOperation(deleteIndex, text);
  };
  function InsertTextOperationsPersister() {
    this.f50_1 = 'i';
    this.g50_1 = getKClass(InsertTextOperation);
  }
  protoOf(InsertTextOperationsPersister).t3c = function () {
    return this.f50_1;
  };
  protoOf(InsertTextOperationsPersister).j4q = function () {
    return this.g50_1;
  };
  protoOf(InsertTextOperationsPersister).e50 = function (ctx, op) {
    if (op instanceof InsertTextOperation) {
      var result = new JsonArray();
      result.m2h(ensureNotNull(Persisters_getInstance().i25().w24(TextOperationUtil_instance.p4m(op))));
      result.m2h(ensureNotNull(Persisters_getInstance().z25().w24(op.s4m_1)));
      return result;
    }
    throw UnsupportedOperationException_init_$Create$_0(toString_1(getKClassFromExpression(op)));
  };
  protoOf(InsertTextOperationsPersister).v4q = function (ctx, op) {
    return this.e50(ctx, op);
  };
  protoOf(InsertTextOperationsPersister).w4q = function (ctx, json) {
    var insertIndex = Persisters_getInstance().i25().p25(json.s2h(0));
    var text = Persisters_getInstance().z25().p25(json.s2h(1));
    return new InsertTextOperation(insertIndex, text);
  };
  function toJsonValue($this, value) {
    var tmp;
    if (value == null) {
      tmp = new JsonNull();
    } else {
      tmp = new JsonString(value);
    }
    return tmp;
  }
  function fromJsonValue($this, value) {
    var tmp;
    if (value instanceof JsonNull) {
      tmp = null;
    } else {
      var string = value instanceof JsonString ? value : THROW_CCE();
      tmp = string.t2h_1;
    }
    return tmp;
  }
  function SetValueOperationPersister(persister) {
    this.h50_1 = persister;
    this.i50_1 = 'sv';
    this.j50_1 = getKClass(SetValueOperation);
  }
  protoOf(SetValueOperationPersister).t3c = function () {
    return this.i50_1;
  };
  protoOf(SetValueOperationPersister).j4q = function () {
    return this.j50_1;
  };
  protoOf(SetValueOperationPersister).k50 = function (ctx, op) {
    var tmp;
    if (op instanceof SetValueOperation) {
      var setValueOp = op instanceof SetValueOperation ? op : THROW_CCE();
      var result = new JsonArray();
      result.y2g(toJsonValue(this, this.h50_1.w24(setValueOp.e4g_1)));
      result.y2g(toJsonValue(this, this.h50_1.w24(setValueOp.f4g_1)));
      tmp = result;
    } else {
      throw UnsupportedOperationException_init_$Create$_0(toString_1(getKClassFromExpression(op)));
    }
    return tmp;
  };
  protoOf(SetValueOperationPersister).v4q = function (ctx, op) {
    return this.k50(ctx, op);
  };
  protoOf(SetValueOperationPersister).w4q = function (ctx, json) {
    var oldValue = this.h50_1.p25(fromJsonValue(this, json.r(0)));
    var newValue = this.h50_1.p25(fromJsonValue(this, json.r(1)));
    return new SetValueOperation(oldValue, newValue);
  };
  function AddToSetOperation(item, singleRole) {
    ChangeSetOperation.call(this, item, singleRole);
  }
  protoOf(AddToSetOperation).o50 = function (otherOp, server) {
    if (otherOp instanceof AddToSetOperation) {
      var otherAdd = otherOp instanceof AddToSetOperation ? otherOp : THROW_CCE();
      this.p50(otherAdd);
      if (equals(otherAdd.m4f_1, this.m4f_1)) {
        return new NopOperation();
      }
      if (this.n4f_1) {
        var tmp;
        if (server) {
          tmp = new NopOperation();
        } else {
          tmp = CompositeOperation_init_$Create$([this.q3z(), otherOp]);
        }
        return tmp;
      }
    }
    return protoOf(ChangeSetOperation).f43.call(this, otherOp, server);
  };
  protoOf(AddToSetOperation).f43 = function (otherOp, server) {
    return this.o50(otherOp, server);
  };
  protoOf(AddToSetOperation).q50 = function (model, nodeFactory) {
    // Inline function 'kotlin.check' call
    if (!!model.t(this.m4f_1)) {
      var message = 'Model already contains ' + toString_0(this.m4f_1);
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    // Inline function 'kotlin.check' call
    if (!(!this.n4f_1 || model.s())) {
      var message_0 = 'Add to not empty single-item collection';
      throw IllegalStateException_init_$Create$_0(toString_1(message_0));
    }
    model.j(this.m4f_1);
    return model;
  };
  protoOf(AddToSetOperation).y3x = function (model, nodeFactory) {
    return this.q50((!(model == null) ? isInterface(model, KtMutableSet) : false) ? model : THROW_CCE(), nodeFactory);
  };
  protoOf(AddToSetOperation).q3z = function () {
    return new RemoveFromSetOperation(this.m4f_1, this.n4f_1);
  };
  protoOf(AddToSetOperation).toString = function () {
    return 'addToSet[' + toString_0(this.m4f_1) + ']';
  };
  function ChangeSetOperation(item, isSingleRole) {
    BaseOperation.call(this);
    this.m4f_1 = item;
    this.n4f_1 = isSingleRole;
  }
  protoOf(ChangeSetOperation).p50 = function (otherOp) {
    // Inline function 'kotlin.check' call
    if (!(this.n4f_1 === otherOp.n4f_1)) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
  };
  function RemoveFromSetOperation(item, singleRole) {
    ChangeSetOperation.call(this, item, singleRole);
  }
  protoOf(RemoveFromSetOperation).o50 = function (otherOp, server) {
    if (otherOp instanceof RemoveFromSetOperation) {
      var otherRemove = otherOp instanceof RemoveFromSetOperation ? otherOp : THROW_CCE();
      this.p50(otherRemove);
      if (equals(otherRemove.m4f_1, this.m4f_1)) {
        return new NopOperation();
      }
    }
    return protoOf(ChangeSetOperation).f43.call(this, otherOp, server);
  };
  protoOf(RemoveFromSetOperation).f43 = function (otherOp, server) {
    return this.o50(otherOp, server);
  };
  protoOf(RemoveFromSetOperation).q50 = function (model, nodeFactory) {
    // Inline function 'kotlin.check' call
    if (!model.t(this.m4f_1)) {
      var message = "Model doesn't contain " + toString_0(this.m4f_1);
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    // Inline function 'kotlin.check' call
    if (!(!this.n4f_1 || model.p() === 1)) {
      var message_0 = 'Remove from single-item set which size is > 1';
      throw IllegalStateException_init_$Create$_0(toString_1(message_0));
    }
    model.h2(this.m4f_1);
    return model;
  };
  protoOf(RemoveFromSetOperation).y3x = function (model, nodeFactory) {
    return this.q50((!(model == null) ? isInterface(model, KtMutableSet) : false) ? model : THROW_CCE(), nodeFactory);
  };
  protoOf(RemoveFromSetOperation).q3z = function () {
    return new AddToSetOperation(this.m4f_1, this.n4f_1);
  };
  protoOf(RemoveFromSetOperation).toString = function () {
    return 'removeFromSet[' + toString_0(this.m4f_1) + ']';
  };
  function deleteOperation($this, index, text) {
    var tmp;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(text) === 0) {
      tmp = new NopOperation();
    } else {
      tmp = new DeleteTextOperation(index, text);
    }
    return tmp;
  }
  function deleteThroughDelete($this, deleteOp, server) {
    if ($this.a4p()) {
      return new NopOperation();
    }
    if (deleteOp.a4p()) {
      var text = deleteOp.s4m_1;
      return new DeleteTextOperation(-1, take_1(text, $this.m3p()) + substring_0(text, $this.m3p() + $this.a() | 0));
    }
    var index = $this.m3p();
    var endIndex = index + $this.a() | 0;
    var theirIndex = deleteOp.m3p();
    var theirEndIndex = theirIndex + deleteOp.a() | 0;
    if (index <= theirIndex && endIndex >= theirEndIndex) {
      return new NopOperation();
    }
    var theirText = deleteOp.s4m_1;
    if (index >= theirIndex && endIndex <= theirEndIndex) {
      return deleteOperation($this, theirIndex, take_1(theirText, index - theirIndex | 0) + substring_0(theirText, endIndex - theirIndex | 0));
    }
    if (theirIndex <= index ? index <= theirEndIndex : false) {
      return deleteOperation($this, theirIndex, take_1(theirText, index - theirIndex | 0));
    }
    var tmp;
    if (index <= theirIndex ? theirIndex <= endIndex : false) {
      tmp = deleteOperation($this, index, substring_0(theirText, endIndex - theirIndex | 0));
    } else {
      tmp = protoOf(TextOperation).u50.call($this, deleteOp, server);
    }
    return tmp;
  }
  function insertThroughDelete($this, op, server) {
    // Inline function 'kotlin.check' call
    if (!!op.a4p()) {
      var message = 'Insert to null op transformed through delete';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    return $this.a4p() ? new NopOperation() : protoOf(TextOperation).u50.call($this, op, server);
  }
  function DeleteTextOperation(deleteIndex, text) {
    TextOperation.call(this, deleteIndex, text);
  }
  protoOf(DeleteTextOperation).q4d = function () {
    return -this.a() | 0;
  };
  protoOf(DeleteTextOperation).p4d = function (newIndex) {
    var tmp;
    if (this.a() === 0 && !(newIndex === -1)) {
      tmp = new NopOperation();
    } else {
      tmp = new DeleteTextOperation(newIndex, this.s4m_1);
    }
    return tmp;
  };
  protoOf(DeleteTextOperation).v50 = function (op) {
    var insertOp = op instanceof InsertTextOperation ? op : THROW_CCE();
    var offset = insertOp.m3p() - this.m3p() | 0;
    return new DeleteTextOperation(this.r4m_1, take_1(this.s4m_1, offset) + insertOp.s4m_1 + substring_0(this.s4m_1, offset));
  };
  protoOf(DeleteTextOperation).s4d = function (op) {
    return this.v50(op);
  };
  protoOf(DeleteTextOperation).w50 = function (replaceRemovedItem) {
    throw UnsupportedOperationException_init_$Create$();
  };
  protoOf(DeleteTextOperation).t4d = function (replaceRemovedItem) {
    return this.w50(replaceRemovedItem);
  };
  protoOf(DeleteTextOperation).x50 = function (model) {
    if (this.a4p()) {
      // Inline function 'kotlin.check' call
      if (!(this.s4m_1 === model)) {
        throw IllegalStateException_init_$Create$_0('Check failed.');
      }
      return null;
    }
    var modelText = substring(ensureNotNull(model), this.m3p(), this.m3p() + this.a() | 0);
    // Inline function 'kotlin.check' call
    if (!(this.s4m_1 === modelText)) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    return take_1(model, this.m3p()) + substring_0(model, this.m3p() + this.a() | 0);
  };
  protoOf(DeleteTextOperation).u50 = function (otherOp, server) {
    var tmp;
    if (!(otherOp instanceof TextOperation)) {
      tmp = protoOf(TextOperation).u50.call(this, otherOp, server);
    } else {
      if (otherOp instanceof InsertTextOperation) {
        tmp = insertThroughDelete(this, otherOp, server);
      } else {
        if (otherOp instanceof DeleteTextOperation) {
          tmp = deleteThroughDelete(this, otherOp, server);
        } else {
          throw IllegalStateException_init_$Create$_0('Unknown text op');
        }
      }
    }
    return tmp;
  };
  protoOf(DeleteTextOperation).f43 = function (otherOp, server) {
    return this.u50(otherOp, server);
  };
  protoOf(DeleteTextOperation).q3z = function () {
    return new InsertTextOperation(this.r4m_1, this.s4m_1);
  };
  protoOf(DeleteTextOperation).toString = function () {
    return "Delete '" + this.s4m_1 + "' at " + this.r4m_1;
  };
  function insertThroughInsert($this, insertOp, server) {
    var insertToNull = $this.a4p();
    var opInsertToNul = insertOp.a4p();
    if (!insertToNull && !opInsertToNul) {
      return protoOf(TextOperation).u50.call($this, insertOp, server);
    }
    if (insertToNull && opInsertToNul) {
      var newIndex = server ? $this.s4m_1.length : 0;
      return insertOp.p4d(newIndex);
    }
    throw IllegalStateException_init_$Create$_0('Transforming insert into null and insert into not null');
  }
  function deleteThroughInsert($this, op, server) {
    // Inline function 'kotlin.check' call
    if (!!$this.a4p()) {
      var message = 'Delete op is transformed through insert to null';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    var tmp;
    if (op.a4p()) {
      tmp = op.v50($this);
    } else {
      tmp = protoOf(TextOperation).u50.call($this, op, server);
    }
    return tmp;
  }
  function InsertTextOperation(insertIndex, text) {
    TextOperation.call(this, insertIndex, text);
    this.y4p_1 = Priority_NORMAL_getInstance();
  }
  protoOf(InsertTextOperation).q4d = function () {
    return this.a();
  };
  protoOf(InsertTextOperation).o4d = function () {
    return this.y4p_1;
  };
  protoOf(InsertTextOperation).u50 = function (otherOp, server) {
    if (otherOp instanceof TextOperation) {
      var tmp;
      if (otherOp instanceof InsertTextOperation) {
        tmp = insertThroughInsert(this, otherOp, server);
      } else {
        if (otherOp instanceof DeleteTextOperation) {
          tmp = deleteThroughInsert(this, otherOp, server);
        } else {
          throw IllegalStateException_init_$Create$_0('Unknown text operation');
        }
      }
      return tmp;
    }
    return protoOf(TextOperation).u50.call(this, otherOp, server);
  };
  protoOf(InsertTextOperation).f43 = function (otherOp, server) {
    return this.u50(otherOp, server);
  };
  protoOf(InsertTextOperation).p4d = function (newIndex) {
    return new InsertTextOperation(newIndex, this.s4m_1);
  };
  protoOf(InsertTextOperation).q3z = function () {
    return new DeleteTextOperation(this.r4m_1, this.s4m_1);
  };
  protoOf(InsertTextOperation).x50 = function (model) {
    if (model == null) {
      // Inline function 'kotlin.require' call
      if (!this.a4p()) {
        var message = 'Cannot insert into null string';
        throw IllegalArgumentException_init_$Create$_0(toString_1(message));
      }
      return this.s4m_1;
    }
    return take_1(model, this.m3p()) + this.s4m_1 + substring_0(model, this.m3p());
  };
  protoOf(InsertTextOperation).toString = function () {
    return 'Insert ' + this.s4m_1 + ' at ' + this.r4m_1;
  };
  function TextOperation(transformationIndex, text) {
    BaseOperation.call(this);
    this.r4m_1 = transformationIndex;
    this.s4m_1 = text;
  }
  protoOf(TextOperation).m3p = function () {
    return this.r4m_1 === -1 ? 0 : this.r4m_1;
  };
  protoOf(TextOperation).a = function () {
    return this.s4m_1.length;
  };
  protoOf(TextOperation).a4p = function () {
    return this.r4m_1 === -1;
  };
  protoOf(TextOperation).u50 = function (otherOp, server) {
    var tmp;
    if (otherOp instanceof TextOperation) {
      tmp = (new IndexedOperationTransformer()).r4d(this, otherOp, server);
    } else {
      if (otherOp instanceof SetValueOperation) {
        var setValue = otherOp instanceof SetValueOperation ? otherOp : THROW_CCE();
        var result = this.c4q(setValue.e4g_1, RawNodeFactory_instance);
        var newValue = setValue.f4g_1;
        var tmp_0;
        if (result === newValue) {
          tmp_0 = new NopOperation();
        } else {
          tmp_0 = new SetValueOperation(result, newValue);
        }
        tmp = tmp_0;
      } else {
        tmp = protoOf(BaseOperation).f43.call(this, otherOp, server);
      }
    }
    return tmp;
  };
  protoOf(TextOperation).f43 = function (otherOp, server) {
    return this.u50(otherOp, server);
  };
  protoOf(TextOperation).y50 = function (otherOp, server) {
    var tmp;
    if (otherOp instanceof SetValueOperation) {
      tmp = new NopOperation();
    } else {
      tmp = protoOf(BaseOperation).q43.call(this, otherOp, server);
    }
    return tmp;
  };
  protoOf(TextOperation).q43 = function (otherOp, server) {
    return this.y50(otherOp, server);
  };
  protoOf(TextOperation).c4q = function (model, nodeFactory) {
    return this.x50(model);
  };
  protoOf(TextOperation).y3x = function (model, nodeFactory) {
    return this.c4q((model == null ? true : typeof model === 'string') ? model : THROW_CCE(), nodeFactory);
  };
  function TextOperationUtil() {
  }
  protoOf(TextOperationUtil).p4m = function (op) {
    return op.a4p() ? -1 : op.m3p();
  };
  var TextOperationUtil_instance;
  function TextOperationUtil_getInstance() {
    return TextOperationUtil_instance;
  }
  function SetValueOperation(oldValue, newValue) {
    BaseOperation.call(this);
    this.e4g_1 = oldValue;
    this.f4g_1 = newValue;
    // Inline function 'kotlin.check' call
    if (!!equals(this.e4g_1, this.f4g_1)) {
      var message = 'equal old and new values: ' + toString_0(this.e4g_1);
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
  }
  protoOf(SetValueOperation).q3z = function () {
    return new SetValueOperation(this.f4g_1, this.e4g_1);
  };
  protoOf(SetValueOperation).z50 = function (otherOp, server) {
    if (otherOp instanceof SetValueOperation) {
      var otherSet = otherOp instanceof SetValueOperation ? otherOp : THROW_CCE();
      var tmp;
      if (equals(this.f4g_1, otherSet.f4g_1) || server) {
        tmp = new NopOperation();
      } else {
        tmp = new SetValueOperation(this.f4g_1, otherSet.f4g_1);
      }
      return tmp;
    }
    return protoOf(BaseOperation).f43.call(this, otherOp, server);
  };
  protoOf(SetValueOperation).f43 = function (otherOp, server) {
    return this.z50(otherOp, server);
  };
  protoOf(SetValueOperation).a51 = function (model, nodeFactory) {
    // Inline function 'kotlin.check' call
    if (!equals(model, this.e4g_1)) {
      var message = "different current values: in operation = '" + toString_0(this.e4g_1) + "', in model = '" + toString_0(model) + "'";
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    return this.f4g_1;
  };
  protoOf(SetValueOperation).y3x = function (model, nodeFactory) {
    return this.a51((model == null ? true : !(model == null)) ? model : THROW_CCE(), nodeFactory);
  };
  protoOf(SetValueOperation).toString = function () {
    return 'SetValue[' + toString_0(this.e4g_1) + '->' + toString_0(this.f4g_1) + ']';
  };
  protoOf(SetValueOperation).hashCode = function () {
    var result = this.e4g_1 == null ? 0 : hashCode(this.e4g_1);
    result = imul(result, 31) + (this.f4g_1 == null ? 0 : hashCode(this.f4g_1)) | 0;
    return result;
  };
  protoOf(SetValueOperation).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SetValueOperation))
      return false;
    if (!equals(this.e4g_1, other.e4g_1))
      return false;
    if (!equals(this.f4g_1, other.f4g_1))
      return false;
    return true;
  };
  var OtTransactionState_STARTED_instance;
  var OtTransactionState_FINISHED_instance;
  var OtTransactionState_entriesInitialized;
  function OtTransactionState_initEntries() {
    if (OtTransactionState_entriesInitialized)
      return Unit_instance;
    OtTransactionState_entriesInitialized = true;
    OtTransactionState_STARTED_instance = new OtTransactionState('STARTED', 0);
    OtTransactionState_FINISHED_instance = new OtTransactionState('FINISHED', 1);
  }
  function updateProperty($this) {
    $this.d51_1.d2x($this.c51_1.jf_1);
  }
  function onOtCommandFinished($this) {
    $this.n51_1.k51_1 = OtTransactionState_FINISHED_getInstance();
    if (!($this.n51_1.m51_1 == null)) {
      var transaction = $this.n51_1.m51_1;
      $this.n51_1.m51_1 = null;
      try {
        ensureNotNull(transaction).r51();
      } catch ($p) {
        if ($p instanceof Exception) {
          var e = $p;
          clear_0($this.n51_1);
          throw e;
        } else {
          throw $p;
        }
      }
    }
  }
  function restore_0($this, provider, savedState) {
    try {
      var state = savedState.q2(provider);
      if (!(state == null)) {
        provider.s51(isInterface(state, OtAware) ? state : THROW_CCE());
      }
    } catch ($p) {
      if ($p instanceof Exception) {
        var e = $p;
        ThrowableHandlers_getInstance().k2r_1.j2r(e);
      } else {
        throw $p;
      }
    }
  }
  function removeStateProvider($this, provider) {
    $this.i51_1.h2(provider);
    var _iterator__ex2g4s = $this.t51().m();
    while (_iterator__ex2g4s.n()) {
      var undoStack = _iterator__ex2g4s.o();
      var _iterator__ex2g4s_0 = undoStack.u51().m();
      while (_iterator__ex2g4s_0.n()) {
        var command = _iterator__ex2g4s_0.o();
        command.b52(provider);
      }
    }
    var _iterator__ex2g4s_1 = $this.c52().m();
    while (_iterator__ex2g4s_1.n()) {
      var redoStack = _iterator__ex2g4s_1.o();
      var _iterator__ex2g4s_2 = redoStack.u51().m();
      while (_iterator__ex2g4s_2.n()) {
        var command_0 = _iterator__ex2g4s_2.o();
        command_0.b52(provider);
      }
    }
  }
  function verifyCanUndo($this) {
    var transaction = $this.m51_1;
    // Inline function 'kotlin.check' call
    if (!!(transaction == null || !transaction.p51_1.equals(Kind_COMMON_getInstance()) || !transaction.r3x())) {
      var message = "Undo/redo is forbidden during transparent commands, other undo/redo commands and user's operations";
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    verifyOtTransactionState($this, OtTransactionState_STARTED_getInstance());
  }
  function verifyOtTransactionState($this, state) {
    // Inline function 'kotlin.check' call
    if (!$this.k51_1.equals(state)) {
      var message = 'OT transaction state is ' + $this.k51_1.toString() + ', expected ' + state.toString();
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
  }
  function ensureNotStateRestoring($this) {
    // Inline function 'kotlin.check' call
    if (!!$this.j51_1) {
      var message = 'Changing model during view state recovering';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
  }
  function clear_0($this) {
    var _iterator__ex2g4s = $this.t51().m();
    while (_iterator__ex2g4s.n()) {
      var stack = _iterator__ex2g4s.o();
      stack.k2();
    }
    var _iterator__ex2g4s_0 = $this.c52().m();
    while (_iterator__ex2g4s_0.n()) {
      var stack_0 = _iterator__ex2g4s_0.o();
      stack_0.k2();
    }
  }
  function OtTransactionState(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function UndoStackImpl(maxSize) {
    this.b51_1 = maxSize;
    this.c51_1 = ArrayDeque_init_$Create$();
    this.d51_1 = new ValueProperty(0);
  }
  protoOf(UndoStackImpl).u51 = function () {
    return this.c51_1;
  };
  protoOf(UndoStackImpl).w2m = function () {
    return this.x2g().uv() === 0;
  };
  protoOf(UndoStackImpl).mf = function () {
    return this.c51_1.mf();
  };
  protoOf(UndoStackImpl).d52 = function () {
    return this.c51_1.jf_1 >= 2 ? this.c51_1.r(1) : null;
  };
  protoOf(UndoStackImpl).e52 = function () {
    var command = this.c51_1.qf();
    updateProperty(this);
    return command;
  };
  protoOf(UndoStackImpl).x2g = function () {
    return this.d51_1;
  };
  protoOf(UndoStackImpl).k2 = function () {
    this.c51_1.k2();
    updateProperty(this);
  };
  protoOf(UndoStackImpl).f52 = function (command) {
    while ((this.c51_1.jf_1 + 1 | 0) > this.b51_1 && !(this.b51_1 === 0)) {
      this.c51_1.sf();
    }
    this.c51_1.of(command);
    updateProperty(this);
  };
  protoOf(UndoStackImpl).toString = function () {
    return this.c51_1.toString();
  };
  function UndoCommandListener($outer) {
    this.n51_1 = $outer;
  }
  protoOf(UndoCommandListener).r3y = function (op) {
    ensureNotStateRestoring(this.n51_1);
    ensureNotNull(this.n51_1.m51_1).g52(op);
  };
  protoOf(UndoCommandListener).x3y = function (op) {
    var transaction = this.n51_1.m51_1;
    if (transaction == null) {
      UndoUtils_instance.i52(this.n51_1, op);
    } else {
      ensureNotStateRestoring(this.n51_1);
      transaction.h52(op);
    }
  };
  protoOf(UndoCommandListener).u3y = function (event) {
    this.n51_1.k51_1 = OtTransactionState_STARTED_getInstance();
    var transaction = this.n51_1.m51_1;
    if (transaction == null) {
      transaction = new UndoableTransaction(this.n51_1, Kind_COMMON_getInstance());
      this.n51_1.m51_1 = transaction;
    }
    transaction.j52(event.y3z_1);
  };
  protoOf(UndoCommandListener).v3y = function (op) {
    return onOtCommandFinished(this);
  };
  function BaseUndoManager$addStateProvider$$inlined$toDisposable$1(this$0, $provider) {
    this.k52_1 = this$0;
    this.l52_1 = $provider;
  }
  protoOf(BaseUndoManager$addStateProvider$$inlined$toDisposable$1).zr = function () {
    removeStateProvider(this.k52_1, this.l52_1);
    return Unit_instance;
  };
  function OtTransactionState_STARTED_getInstance() {
    OtTransactionState_initEntries();
    return OtTransactionState_STARTED_instance;
  }
  function OtTransactionState_FINISHED_getInstance() {
    OtTransactionState_initEntries();
    return OtTransactionState_FINISHED_instance;
  }
  function BaseUndoManager(model, commandNotifier, allowUndo, nodeFactory) {
    allowUndo = allowUndo === VOID ? true : allowUndo;
    this.e51_1 = model;
    this.f51_1 = commandNotifier;
    this.g51_1 = nodeFactory;
    this.h51_1 = allowUndo ? this.f51_1.e3z(new UndoCommandListener(this)) : null;
    this.i51_1 = ArrayList_init_$Create$();
    this.j51_1 = false;
    this.k51_1 = OtTransactionState_FINISHED_getInstance();
    this.l51_1 = null;
    this.m51_1 = null;
  }
  protoOf(BaseUndoManager).m52 = function () {
    var states = HashMap_init_$Create$();
    var _iterator__ex2g4s = this.i51_1.m();
    while (_iterator__ex2g4s.n()) {
      var provider = _iterator__ex2g4s.o();
      try {
        var state = provider.n52();
        if (!(state == null)) {
          // Inline function 'kotlin.collections.set' call
          states.t2(provider, state);
        }
      } catch ($p) {
        if ($p instanceof Error) {
          var t = $p;
          ThrowableHandlers_getInstance().k2r_1.j2r(t);
        } else {
          throw $p;
        }
      }
    }
    return states;
  };
  protoOf(BaseUndoManager).o52 = function () {
    return this.l51_1;
  };
  protoOf(BaseUndoManager).p52 = function (stackId) {
    if (equals(this.l51_1, stackId))
      return Unit_instance;
    var transaction = this.m51_1;
    if (!(transaction == null) && !transaction.r3x()) {
      throw OtException_init_$Create$_0('Cannot change current undo/redo stack inside undoable transaction');
    }
    this.l51_1 = stackId;
  };
  protoOf(BaseUndoManager).zr = function () {
    var tmp0_safe_receiver = this.h51_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.zr();
    }
  };
  protoOf(BaseUndoManager).s52 = function (groupId) {
    var transaction = this.m51_1;
    $l$block: {
      // Inline function 'kotlin.checkNotNull' call
      if (transaction == null) {
        var message = 'No transaction is running at the moment';
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      } else {
        break $l$block;
      }
    }
    transaction.t52(groupId);
  };
  protoOf(BaseUndoManager).u52 = function (savedState) {
    this.j51_1 = true;
    try {
      var reversedProviders = ArrayList_init_$Create$_1(this.i51_1);
      reverse(reversedProviders);
      var _iterator__ex2g4s = reversedProviders.m();
      while (_iterator__ex2g4s.n()) {
        var p = _iterator__ex2g4s.o();
        restore_0(this, p, savedState);
      }
    }finally {
      this.j51_1 = false;
    }
  };
  protoOf(BaseUndoManager).v52 = function (provider) {
    this.i51_1.j(provider);
    // Inline function 'jetbrains.ocelot.base.disposable.toDisposable' call
    return new BaseUndoManager$addStateProvider$$inlined$toDisposable$1(this, provider);
  };
  protoOf(BaseUndoManager).w52 = function (op) {
    op.y3x(this.e51_1, this.g51_1);
  };
  protoOf(BaseUndoManager).z52 = function () {
    if (this.a53().uv().e53()) {
      verifyCanUndo(this);
      var transaction = ensureNotNull(this.m51_1);
      transaction.z52();
      try {
        var groupId = this.x52();
        transaction.t52(groupId);
      } catch ($p) {
        if ($p instanceof Exception) {
          var e = $p;
          clear_0(this);
          throw e;
        } else {
          throw $p;
        }
      }
    }
  };
  protoOf(BaseUndoManager).f53 = function () {
    if (this.g53().uv().e53()) {
      verifyCanUndo(this);
      var transaction = ensureNotNull(this.m51_1);
      transaction.f53();
      try {
        var groupId = this.y52();
        transaction.t52(groupId);
      } catch ($p) {
        if ($p instanceof Exception) {
          var e = $p;
          clear_0(this);
          throw e;
        } else {
          throw $p;
        }
      }
    }
  };
  function OtAware() {
  }
  function SimpleUndoStackId(id) {
    this.i53_1 = id;
  }
  protoOf(SimpleUndoStackId).toString = function () {
    return 'SimpleUndoStackId(id=' + toString_1(this.i53_1) + ')';
  };
  protoOf(SimpleUndoStackId).hashCode = function () {
    return hashCode(this.i53_1);
  };
  protoOf(SimpleUndoStackId).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SimpleUndoStackId))
      return false;
    if (!equals(this.i53_1, other.i53_1))
      return false;
    return true;
  };
  var Kind_NO_STACK_SELECTED_instance;
  var Kind_EMPTY_STACK_instance;
  var Kind_DEPENDENT_STACK_CHANGED_instance;
  var Kind_entriesInitialized;
  function Kind_initEntries() {
    if (Kind_entriesInitialized)
      return Unit_instance;
    Kind_entriesInitialized = true;
    Kind_NO_STACK_SELECTED_instance = new Kind('NO_STACK_SELECTED', 0);
    Kind_EMPTY_STACK_instance = new Kind('EMPTY_STACK', 1);
    Kind_DEPENDENT_STACK_CHANGED_instance = new Kind('DEPENDENT_STACK_CHANGED', 2);
  }
  function Kind(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function Kind_EMPTY_STACK_getInstance() {
    Kind_initEntries();
    return Kind_EMPTY_STACK_instance;
  }
  function UndoRejectionInfo(kind, problemStackIds) {
    this.j53_1 = kind;
    this.k53_1 = problemStackIds;
  }
  protoOf(UndoRejectionInfo).toString = function () {
    return 'UndoRejectionInfo[' + this.j53_1.toString() + ', problemStackIds=' + toString_1(this.k53_1) + ']';
  };
  function Companion_74() {
  }
  protoOf(Companion_74).l53 = function (groupId) {
    return new UndoState(true, groupId, null);
  };
  protoOf(Companion_74).m53 = function (groupId, info) {
    return new UndoState(false, groupId, info);
  };
  var Companion_instance_74;
  function Companion_getInstance_74() {
    return Companion_instance_74;
  }
  function UndoState(canUndo, groupId, _rejectionInfo) {
    this.b53_1 = canUndo;
    this.c53_1 = groupId;
    this.d53_1 = _rejectionInfo;
  }
  protoOf(UndoState).n53 = function () {
    // Inline function 'kotlin.check' call
    if (!!this.b53_1) {
      var message = "No rejection info available for 'can undo' state";
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    return this.d53_1;
  };
  protoOf(UndoState).e53 = function () {
    return this.b53_1;
  };
  protoOf(UndoState).toString = function () {
    return 'groupId=' + toString_0(this.c53_1) + ', canUndo=' + this.b53_1 + ', rejectionInfo=' + toString_0(this.d53_1);
  };
  protoOf(UndoState).hashCode = function () {
    var result = getBooleanHashCode(this.b53_1);
    result = imul(result, 31) + (this.c53_1 == null ? 0 : hashCode(this.c53_1)) | 0;
    result = imul(result, 31) + (this.d53_1 == null ? 0 : hashCode(this.d53_1)) | 0;
    return result;
  };
  protoOf(UndoState).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof UndoState))
      return false;
    if (!(this.b53_1 === other.b53_1))
      return false;
    if (!equals(this.c53_1, other.c53_1))
      return false;
    if (!equals(this.d53_1, other.d53_1))
      return false;
    return true;
  };
  function addExternalOperation($this, op, stack, currentState) {
    if (!stack.w2m()) {
      stack.mf().o53(op);
      $this.p53(stack, currentState);
    }
  }
  function tryMergeTwoLastCommands($this, stack, currentState) {
    if (stack.x2g().uv() > 1 && ensureNotNull(stack.d52()).q53(stack.mf(), currentState)) {
      stack.e52();
      removeEmptyCommands($this, stack, currentState);
    }
  }
  function removeEmptyCommands($this, stack, currentState) {
    while (!stack.w2m() && stack.mf().r53(currentState) === UndoCommandType_EMPTY_getInstance()) {
      var nopCommand = stack.e52();
      if (!stack.w2m()) {
        stack.mf().t53(nopCommand.s53());
      }
    }
  }
  function UndoUtils() {
  }
  protoOf(UndoUtils).u53 = function (operations) {
    var _iterator__ex2g4s = operations.m();
    while (_iterator__ex2g4s.n()) {
      var op = _iterator__ex2g4s.o();
      if (!op.r3x())
        return false;
    }
    return true;
  };
  protoOf(UndoUtils).i52 = function (manager, op) {
    var currentState = manager.m52();
    var _iterator__ex2g4s = manager.t51().m();
    while (_iterator__ex2g4s.n()) {
      var stack = _iterator__ex2g4s.o();
      addExternalOperation(this, op, stack, currentState);
    }
    var _iterator__ex2g4s_0 = manager.c52().m();
    while (_iterator__ex2g4s_0.n()) {
      var stack_0 = _iterator__ex2g4s_0.o();
      addExternalOperation(this, op, stack_0, currentState);
    }
  };
  protoOf(UndoUtils).p53 = function (stack, currentState) {
    removeEmptyCommands(this, stack, currentState);
    tryMergeTwoLastCommands(this, stack, currentState);
  };
  var UndoUtils_instance;
  function UndoUtils_getInstance() {
    return UndoUtils_instance;
  }
  function _get_classAndHash__24311e($this) {
    var tmp0_elvis_lhs = getKClassFromExpression($this).ra();
    var className = tmp0_elvis_lhs == null ? '<anonymous command>' : tmp0_elvis_lhs;
    return className + '@' + toString_3(hashCode($this), 16);
  }
  function computeUndoType($this, currentStates) {
    var providers = HashSet_init_$Create$();
    providers.q($this.y51_1.r2());
    providers.q(currentStates.r2());
    var type = UndoCommandType_EMPTY_getInstance();
    var _iterator__ex2g4s = providers.m();
    while (_iterator__ex2g4s.n()) {
      var provider = _iterator__ex2g4s.o();
      var viewStateProvider = isInterface(provider, ViewStateProvider) ? provider : THROW_CCE();
      var providerType = computeUndoType_0($this, viewStateProvider, $this.y51_1.q2(provider), currentStates.q2(provider));
      if (providerType === UndoCommandType_EDITING_getInstance()) {
        return UndoCommandType_EDITING_getInstance();
      }
      if (providerType === UndoCommandType_NAVIGATION_getInstance()) {
        type = UndoCommandType_NAVIGATION_getInstance();
      }
    }
    return type;
  }
  function computeUndoType_0($this, provider, savedState, currentState) {
    if (savedState === currentState) {
      return UndoCommandType_EMPTY_getInstance();
    }
    var tmp;
    if (savedState == null || currentState == null) {
      tmp = UndoCommandType_NAVIGATION_getInstance();
    } else {
      tmp = provider.v53(savedState, currentState);
    }
    return tmp;
  }
  function UndoableCommand(data, affectedStackIds) {
    this.v51_1 = data.w53_1;
    this.a52_1 = false;
    this.y51_1 = HashMap_init_$Create$_1(data.x53_1);
    this.z51_1 = HashSet_init_$Create$_0(affectedStackIds);
    this.w51_1 = ArrayList_init_$Create$_0(data.y53_1.p());
    var _iterator__ex2g4s = data.y53_1.m();
    while (_iterator__ex2g4s.n()) {
      var op = _iterator__ex2g4s.o();
      this.w51_1.j(op.q3z());
    }
    this.x51_1 = ArrayList_init_$Create$_0(data.z53_1.p());
    this.t53(data.z53_1);
  }
  protoOf(UndoableCommand).s53 = function () {
    return this.x51_1;
  };
  protoOf(UndoableCommand).o53 = function (externalOp) {
    var operation = externalOp;
    var inductionVariable = this.w51_1.p() - 1 | 0;
    if (0 <= inductionVariable)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        var undoOp = this.w51_1.r(i);
        var newOp = operation.z3x(undoOp, true);
        operation = undoOp.z3x(operation, false);
        this.w51_1.l2(i, newOp);
      }
       while (0 <= inductionVariable);
    this.x51_1.j(operation);
    var _iterator__ex2g4s = this.y51_1.r2().m();
    while (_iterator__ex2g4s.n()) {
      var provider = _iterator__ex2g4s.o();
      var tmp0 = this.y51_1;
      // Inline function 'kotlin.collections.set' call
      var value = ensureNotNull(this.y51_1.q2(provider)).h53(operation);
      tmp0.t2(provider, value);
    }
  };
  protoOf(UndoableCommand).t53 = function (externalOperations) {
    var _iterator__ex2g4s = externalOperations.m();
    while (_iterator__ex2g4s.n()) {
      var externalOp = _iterator__ex2g4s.o();
      this.o53(externalOp);
    }
  };
  protoOf(UndoableCommand).a54 = function (manager) {
    // Inline function 'kotlin.check' call
    if (!!this.a52_1) {
      var message = 'The command has already been reverted';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    this.a52_1 = true;
    var inductionVariable = this.w51_1.p() - 1 | 0;
    if (0 <= inductionVariable)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        manager.w52(this.w51_1.r(i));
      }
       while (0 <= inductionVariable);
    var i_0 = this.x51_1.f2();
    while (i_0.n()) {
      var op = i_0.o();
      if (op.r3x()) {
        i_0.h4();
      }
    }
    manager.u52(this.y51_1);
  };
  protoOf(UndoableCommand).b52 = function (provider) {
    this.y51_1.u2(provider);
  };
  protoOf(UndoableCommand).r53 = function (currentState) {
    var tmp;
    if (!UndoUtils_instance.u53(this.w51_1)) {
      tmp = UndoCommandType_EDITING_getInstance();
    } else {
      tmp = computeUndoType(this, currentState);
    }
    return tmp;
  };
  protoOf(UndoableCommand).q53 = function (next, currentState) {
    var thisCmdType = this.r53(next.y51_1);
    var nextCmdType = next.r53(currentState);
    if (this.v51_1.x3z(next.v51_1, nextCmdType, thisCmdType)) {
      this.t53(next.x51_1);
      this.w51_1.q(next.w51_1);
      return true;
    }
    return false;
  };
  protoOf(UndoableCommand).toString = function () {
    return _get_classAndHash__24311e(this) + '[groupId=' + toString_1(this.v51_1) + ', undoOps=' + this.w51_1.p() + ', extOps=' + this.x51_1.p() + ', states=' + this.y51_1.p() + ']';
  };
  function UndoableCommandData(groupId, undoOperations, externalOperations, savedState) {
    this.w53_1 = groupId;
    this.x53_1 = savedState;
    var tmp = this;
    // Inline function 'kotlin.collections.orEmpty' call
    tmp.y53_1 = undoOperations == null ? emptyList() : undoOperations;
    var tmp_0 = this;
    tmp_0.z53_1 = externalOperations == null ? ArrayList_init_$Create$() : externalOperations;
  }
  protoOf(UndoableCommandData).r3x = function () {
    return UndoUtils_instance.u53(this.y53_1);
  };
  protoOf(UndoableCommandData).toString = function () {
    return 'groupId=' + toString_1(this.w53_1) + ', undoOps=' + this.y53_1.p() + ', externalOps=' + this.z53_1.p() + ', states=' + this.x53_1.p();
  };
  function noExternalOps($this) {
    return $this.e54_1 == null || ensureNotNull($this.e54_1).s();
  }
  function checkNonNullGroupId($this, groupId) {
    $l$block: {
      // Inline function 'kotlin.requireNotNull' call
      if (groupId == null) {
        var message = 'Unexpected null CommandsUndoGroupId';
        throw IllegalArgumentException_init_$Create$_0(toString_1(message));
      } else {
        break $l$block;
      }
    }
  }
  var Kind_UNDO_instance;
  var Kind_REDO_instance;
  var Kind_COMMON_instance;
  var Kind_entriesInitialized_0;
  function Kind_initEntries_0() {
    if (Kind_entriesInitialized_0)
      return Unit_instance;
    Kind_entriesInitialized_0 = true;
    Kind_UNDO_instance = new Kind_0('UNDO', 0);
    Kind_REDO_instance = new Kind_0('REDO', 1);
    Kind_COMMON_instance = new Kind_0('COMMON', 2);
  }
  function UndoableCommandDataBuilder(groupId, savedState) {
    this.b54_1 = groupId;
    this.c54_1 = savedState;
    this.d54_1 = null;
    this.e54_1 = null;
    this.f54_1 = false;
    checkNonNullGroupId(this, this.b54_1);
  }
  protoOf(UndoableCommandDataBuilder).w2m = function () {
    return this.c54_1.s() && noExternalOps(this) && this.r3x();
  };
  protoOf(UndoableCommandDataBuilder).r3x = function () {
    return this.d54_1 == null || UndoUtils_instance.u53(ensureNotNull(this.d54_1));
  };
  protoOf(UndoableCommandDataBuilder).f40 = function () {
    return new UndoableCommandData(this.b54_1, this.d54_1, this.e54_1, this.c54_1);
  };
  protoOf(UndoableCommandDataBuilder).t52 = function (groupId) {
    checkNonNullGroupId(this, groupId);
    if (!equals(groupId, this.b54_1)) {
      // Inline function 'kotlin.check' call
      if (!!this.f54_1) {
        var message = 'Multiple undo group updates in one command';
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      }
      this.f54_1 = true;
      this.b54_1 = groupId;
    }
  };
  protoOf(UndoableCommandDataBuilder).g54 = function (op) {
    // Inline function 'kotlin.check' call
    if (!(this.e54_1 == null)) {
      var message = 'Undo operations cannot interchange with external operations because of possible revert ambiguity';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    if (this.d54_1 == null) {
      this.d54_1 = ArrayList_init_$Create$();
    }
    ensureNotNull(this.d54_1).j(op);
  };
  protoOf(UndoableCommandDataBuilder).h54 = function (op) {
    if (this.e54_1 == null) {
      this.e54_1 = ArrayList_init_$Create$();
    }
    ensureNotNull(this.e54_1).j(op);
  };
  function Kind_0(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function Kind_UNDO_getInstance() {
    Kind_initEntries_0();
    return Kind_UNDO_instance;
  }
  function Kind_REDO_getInstance() {
    Kind_initEntries_0();
    return Kind_REDO_instance;
  }
  function Kind_COMMON_getInstance() {
    Kind_initEntries_0();
    return Kind_COMMON_instance;
  }
  function UndoableTransaction(manager, kind) {
    this.o51_1 = manager;
    this.q51_1 = null;
    this.p51_1 = kind;
  }
  protoOf(UndoableTransaction).r3x = function () {
    return this.q51_1 == null || ensureNotNull(this.q51_1).r3x();
  };
  protoOf(UndoableTransaction).z52 = function () {
    this.p51_1 = Kind_UNDO_getInstance();
  };
  protoOf(UndoableTransaction).f53 = function () {
    this.p51_1 = Kind_REDO_getInstance();
  };
  protoOf(UndoableTransaction).t52 = function (groupId) {
    ensureNotNull(this.q51_1).t52(groupId);
  };
  protoOf(UndoableTransaction).r51 = function () {
    if (ensureNotNull(this.q51_1).w2m())
      return Unit_instance;
    var data = ensureNotNull(this.q51_1).f40();
    switch (this.p51_1.x2_1) {
      case 2:
        this.o51_1.q52(data, true);
        break;
      case 0:
        this.o51_1.r52(data);
        break;
      case 1:
        this.o51_1.q52(data, false);
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
  };
  protoOf(UndoableTransaction).j52 = function (groupId) {
    // Inline function 'kotlin.check' call
    if (!(this.q51_1 == null)) {
      var message = 'Transaction has already started';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    this.q51_1 = new UndoableCommandDataBuilder(groupId, this.o51_1.m52());
  };
  protoOf(UndoableTransaction).h52 = function (op) {
    // Inline function 'kotlin.check' call
    if (!(!this.p51_1.equals(Kind_UNDO_getInstance()) && !this.p51_1.equals(Kind_REDO_getInstance()))) {
      var message = 'External operation while ' + this.p51_1.toString() + ' is in progress';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    if (!op.r3x()) {
      ensureNotNull(this.q51_1).h54(op);
    }
  };
  protoOf(UndoableTransaction).g52 = function (op) {
    if (!op.r3x()) {
      ensureNotNull(this.q51_1).g54(op);
    }
  };
  function ViewStateProvider() {
  }
  var UndoCommandType_EMPTY_instance;
  var UndoCommandType_NAVIGATION_instance;
  var UndoCommandType_EDITING_instance;
  var UndoCommandType_entriesInitialized;
  function UndoCommandType_initEntries() {
    if (UndoCommandType_entriesInitialized)
      return Unit_instance;
    UndoCommandType_entriesInitialized = true;
    UndoCommandType_EMPTY_instance = new UndoCommandType('EMPTY', 0);
    UndoCommandType_NAVIGATION_instance = new UndoCommandType('NAVIGATION', 1);
    UndoCommandType_EDITING_instance = new UndoCommandType('EDITING', 2);
  }
  function UndoCommandType(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function UndoCommandType_EMPTY_getInstance() {
    UndoCommandType_initEntries();
    return UndoCommandType_EMPTY_instance;
  }
  function UndoCommandType_NAVIGATION_getInstance() {
    UndoCommandType_initEntries();
    return UndoCommandType_NAVIGATION_instance;
  }
  function UndoCommandType_EDITING_getInstance() {
    UndoCommandType_initEntries();
    return UndoCommandType_EDITING_instance;
  }
  function simpleStateProperty($this, stackId, stack) {
    return new SingleStackUndoManager$simpleStateProperty$1(stackId, stack);
  }
  function revert($this, stack) {
    var command = stack.e52();
    command.a54($this);
    var extOps = command.s53();
    if (!stack.w2m()) {
      stack.mf().t53(extOps);
    }
    UndoUtils_instance.p53(stack, $this.m52());
    return command.v51_1;
  }
  function push_0($this, stack, data) {
    stack.f52(new UndoableCommand(data, setOf(ensureNotNull($this.o52()))));
    UndoUtils_instance.p53(stack, $this.m52());
  }
  function SingleStackUndoManager$simpleStateProperty$1($stackId, $stack) {
    this.n54_1 = $stack;
    DerivedProperty.call(this, [$stack.x2g()]);
    this.m54_1 = Companion_instance_74.m53(null, new UndoRejectionInfo(Kind_EMPTY_STACK_getInstance(), setOf($stackId)));
  }
  protoOf(SingleStackUndoManager$simpleStateProperty$1).q2w = function () {
    var tmp;
    if (this.n54_1.w2m()) {
      tmp = this.m54_1;
    } else {
      tmp = Companion_instance_74.l53(this.n54_1.mf().v51_1);
    }
    return tmp;
  };
  function SingleStackUndoManager(model, commandNotifier, maxStackSize, allowUndo, nodeFactory) {
    allowUndo = allowUndo === VOID ? true : allowUndo;
    BaseUndoManager.call(this, model, commandNotifier, allowUndo, nodeFactory);
    var stackId = new SimpleUndoStackId(new Object());
    this.x54_1 = new UndoStackImpl(maxStackSize);
    this.z54_1 = simpleStateProperty(this, stackId, this.x54_1);
    this.y54_1 = new UndoStackImpl(maxStackSize);
    this.a55_1 = simpleStateProperty(this, stackId, this.y54_1);
    protoOf(BaseUndoManager).p52.call(this, stackId);
  }
  protoOf(SingleStackUndoManager).a53 = function () {
    return this.z54_1;
  };
  protoOf(SingleStackUndoManager).g53 = function () {
    return this.a55_1;
  };
  protoOf(SingleStackUndoManager).t51 = function () {
    return listOf(this.x54_1);
  };
  protoOf(SingleStackUndoManager).c52 = function () {
    return listOf(this.y54_1);
  };
  protoOf(SingleStackUndoManager).p52 = function (stackId) {
    throw UnsupportedOperationException_init_$Create$_0('Cannot change stack for single-stack manager');
  };
  protoOf(SingleStackUndoManager).x52 = function () {
    return revert(this, this.x54_1);
  };
  protoOf(SingleStackUndoManager).y52 = function () {
    return revert(this, this.y54_1);
  };
  protoOf(SingleStackUndoManager).q52 = function (data, isCommonOp) {
    if (!data.r3x() && isCommonOp) {
      this.y54_1.k2();
    }
    push_0(this, this.x54_1, data);
  };
  protoOf(SingleStackUndoManager).r52 = function (data) {
    return push_0(this, this.y54_1, data);
  };
  function singleStackUndoManager(processor, maxStackSize, allowUndo) {
    maxStackSize = maxStackSize === VOID ? 0 : maxStackSize;
    allowUndo = allowUndo === VOID ? true : allowUndo;
    return new SingleStackUndoManager(processor.b3x_1, processor, maxStackSize, allowUndo, processor.e3x_1);
  }
  function Command_init_$Init$(commandId, baseVersion, operation, $this) {
    Command.call($this, commandId, baseVersion, baseVersion + 1 | 0, operation);
    return $this;
  }
  function Command_init_$Create$(commandId, baseVersion, operation) {
    return Command_init_$Init$(commandId, baseVersion, operation, objectCreate(protoOf(Command)));
  }
  function toString_7($this, short) {
    var operationString = short ? LoggingUtils_instance.y3c($this.e55_1) : toString_1($this.e55_1);
    return 'Command(' + $this.b55_1.f55_1.toString() + ', root id = ' + $this.b55_1.g55_1.toString() + ', ' + $this.c55_1 + '->' + $this.d55_1 + ', ' + operationString + ')';
  }
  function Command(commandId, baseVersion, resultVersion, operation) {
    this.b55_1 = commandId;
    this.c55_1 = baseVersion;
    this.d55_1 = resultVersion;
    this.e55_1 = operation;
    // Inline function 'kotlin.require' call
    if (!(this.c55_1 <= this.d55_1)) {
      var message = 'Invalid versions range: ' + this.c55_1 + ' -> ' + this.d55_1 + ', op=\n' + EntityPrintOperationUtil_instance.t3x(this.e55_1);
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
  }
  protoOf(Command).h55 = function (cmd, server) {
    var delta = server ? this.d55_1 - this.c55_1 | 0 : 0;
    var op = this.e55_1.z3x(cmd.e55_1, server);
    return new Command(cmd.b55_1, cmd.c55_1 + delta | 0, cmd.d55_1 + delta | 0, op);
  };
  protoOf(Command).toString = function () {
    return toString_7(this, false);
  };
  protoOf(Command).hashCode = function () {
    var result = this.b55_1.hashCode();
    result = imul(result, 31) + this.c55_1 | 0;
    result = imul(result, 31) + this.d55_1 | 0;
    result = imul(result, 31) + hashCode(this.e55_1) | 0;
    return result;
  };
  protoOf(Command).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Command))
      return false;
    if (!this.b55_1.equals(other.b55_1))
      return false;
    if (!(this.c55_1 === other.c55_1))
      return false;
    if (!(this.d55_1 === other.d55_1))
      return false;
    if (!equals(this.e55_1, other.e55_1))
      return false;
    return true;
  };
  function CommandId_init_$Init$($this) {
    BaseId.call($this);
    CommandId.call($this);
    return $this;
  }
  function CommandId_init_$Create$() {
    return CommandId_init_$Init$(objectCreate(protoOf(CommandId)));
  }
  function CommandId_init_$Init$_0(id, $this) {
    BaseId.call($this, id);
    CommandId.call($this);
    return $this;
  }
  function CommandId_init_$Create$_0(id) {
    return CommandId_init_$Init$_0(id, objectCreate(protoOf(CommandId)));
  }
  function CommandId() {
  }
  function LoadCommandId_init_$Init$(rootId, entityId, $this) {
    entityId = entityId === VOID ? rootId : entityId;
    LoadCommandId_init_$Init$_0(CommandId_init_$Create$(), rootId, entityId, $this);
    return $this;
  }
  function LoadCommandId_init_$Create$(rootId, entityId) {
    return LoadCommandId_init_$Init$(rootId, entityId, objectCreate(protoOf(LoadCommandId)));
  }
  function LoadCommandId_init_$Init$_0(commandId, rootId, entityId, $this) {
    entityId = entityId === VOID ? rootId : entityId;
    LoadCommandId.call($this, commandId, new EntityReference(rootId, entityId == null ? rootId : entityId));
    return $this;
  }
  function LoadCommandId_init_$Create$_0(commandId, rootId, entityId) {
    return LoadCommandId_init_$Init$_0(commandId, rootId, entityId, objectCreate(protoOf(LoadCommandId)));
  }
  function LoadCommandId(commandId, reference) {
    this.i55_1 = commandId;
    this.j55_1 = reference;
  }
  protoOf(LoadCommandId).k55 = function () {
    return this.j55_1.l3j();
  };
  protoOf(LoadCommandId).m3w = function () {
    return this.j55_1.j3j_1;
  };
  protoOf(LoadCommandId).p3w = function () {
    return this.j55_1.k3j_1;
  };
  protoOf(LoadCommandId).toString = function () {
    return '[c = ' + this.i55_1.toString() + ', r = ' + this.j55_1.toString() + ']';
  };
  protoOf(LoadCommandId).hashCode = function () {
    var result = this.i55_1.hashCode();
    result = imul(result, 31) + this.j55_1.hashCode() | 0;
    return result;
  };
  protoOf(LoadCommandId).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof LoadCommandId))
      return false;
    if (!this.i55_1.equals(other.i55_1))
      return false;
    if (!this.j55_1.equals(other.j55_1))
      return false;
    return true;
  };
  function getTimestampFromOperation($this, op) {
    var tmp;
    if (op instanceof AnnotatedOperation) {
      tmp = (op instanceof AnnotatedOperation ? op : THROW_CCE()).d4e_1;
    } else {
      tmp = currentTimeMillis();
    }
    return tmp;
  }
  function OtOperationRecord_init_$Init$(commandId, operation, baseVersion, resultVersion, timestamp, $this) {
    resultVersion = resultVersion === VOID ? Companion_instance_75.l55(baseVersion) : resultVersion;
    timestamp = timestamp === VOID ? getTimestampFromOperation(Companion_instance_75, operation) : timestamp;
    OtOperationRecord.call($this);
    $this.m55_1 = commandId;
    $this.n55_1 = operation;
    $this.o55_1 = baseVersion;
    $this.p55_1 = resultVersion;
    $this.q55_1 = timestamp;
    return $this;
  }
  function OtOperationRecord_init_$Init$_0(command, $this) {
    OtOperationRecord_init_$Init$(command.b55_1, command.e55_1, command.c55_1, command.d55_1, getTimestampFromOperation(Companion_instance_75, command.e55_1), $this);
    return $this;
  }
  function OtOperationRecord_init_$Create$(command) {
    return OtOperationRecord_init_$Init$_0(command, objectCreate(protoOf(OtOperationRecord)));
  }
  function Companion_75() {
  }
  protoOf(Companion_75).l55 = function (baseVersion) {
    return baseVersion + 1 | 0;
  };
  var Companion_instance_75;
  function Companion_getInstance_75() {
    return Companion_instance_75;
  }
  protoOf(OtOperationRecord).m3w = function () {
    return this.m55_1.g55_1;
  };
  protoOf(OtOperationRecord).equals = function (other) {
    if (!(other instanceof OtOperationRecord))
      return false;
    return this.m55_1.equals(other.m55_1) && this.o55_1 === other.o55_1 && toString_1(this.n55_1) === toString_1(other.n55_1);
  };
  protoOf(OtOperationRecord).hashCode = function () {
    var result = this.m55_1.hashCode();
    result = imul(31, result) + hashCode(this.n55_1) | 0;
    result = imul(31, result) + this.o55_1 | 0;
    result = imul(31, result) + this.p55_1 | 0;
    result = imul(31, result) + convertToInt(this.q55_1 ^ shiftRightUnsigned(this.q55_1, 32)) | 0;
    return result;
  };
  protoOf(OtOperationRecord).toString = function () {
    return 'OtOperationRecord: rootId=' + this.m3w().q36_1 + '; commandId=' + this.m55_1.f55_1.q36_1 + '; baseVersion=' + this.o55_1 + '; resultVersion=' + this.p55_1 + '; ts=' + this.q55_1.toString() + '; operation=' + toString_1(this.n55_1);
  };
  function OtOperationRecord() {
    this.o55_1 = 0;
    this.p55_1 = 0;
    this.q55_1 = 0n;
  }
  function RootCommandId_init_$Init$(rootId, $this) {
    RootCommandId.call($this, CommandId_init_$Create$(), rootId);
    return $this;
  }
  function RootCommandId_init_$Create$(rootId) {
    return RootCommandId_init_$Init$(rootId, objectCreate(protoOf(RootCommandId)));
  }
  function RootCommandId(commandId, rootId) {
    this.f55_1 = commandId;
    this.g55_1 = rootId;
  }
  protoOf(RootCommandId).toString = function () {
    return 'RootCommandId(commandId=' + this.f55_1.toString() + ', rootId=' + this.g55_1.toString() + ')';
  };
  protoOf(RootCommandId).hashCode = function () {
    var result = this.f55_1.hashCode();
    result = imul(result, 31) + this.g55_1.hashCode() | 0;
    return result;
  };
  protoOf(RootCommandId).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RootCommandId))
      return false;
    if (!this.f55_1.equals(other.f55_1))
      return false;
    if (!this.g55_1.equals(other.g55_1))
      return false;
    return true;
  };
  function MetaId_init_$Init$(flags, $this) {
    BaseId.call($this);
    MetaId.call($this);
    $this.v3h_1 = flags;
    return $this;
  }
  function MetaId_init_$Init$_0(id, flags, $this) {
    BaseId.call($this, id);
    MetaId.call($this);
    $this.v3h_1 = flags;
    return $this;
  }
  function MetaId_init_$Init$_1(id, name, flags, $this) {
    BaseId.call($this, id, name);
    MetaId.call($this);
    $this.v3h_1 = flags;
    return $this;
  }
  protoOf(MetaId).w3h = function () {
    return this.v3h_1;
  };
  protoOf(MetaId).toString = function () {
    return protoOf(BaseId).toString.call(this) + '(' + toString_1(this.v3h_1) + ')';
  };
  function MetaId() {
  }
  function RoleId_init_$Init$(flags, $this) {
    MetaId_init_$Init$(flags, $this);
    RoleId.call($this);
    return $this;
  }
  function RoleId_init_$Init$_0(id, flags, $this) {
    MetaId_init_$Init$_0(id, flags, $this);
    RoleId.call($this);
    return $this;
  }
  function RoleId_init_$Init$_1(id, name, flags, $this) {
    MetaId_init_$Init$_1(id, name, flags, $this);
    RoleId.call($this);
    return $this;
  }
  function Companion_76() {
    Companion_instance_76 = this;
    this.f3q_1 = setOf(RoleIdFlag_SINGLE_getInstance());
    this.g3q_1 = emptySet();
  }
  var Companion_instance_76;
  function Companion_getInstance_76() {
    if (Companion_instance_76 == null)
      new Companion_76();
    return Companion_instance_76;
  }
  protoOf(RoleId).f3g = function () {
    return this.w3h().t(RoleIdFlag_SINGLE_getInstance());
  };
  protoOf(RoleId).toString = function () {
    return protoOf(MetaId).toString.call(this) + (this.f3g() ? ' (single)' : '');
  };
  function RoleId() {
    Companion_getInstance_76();
  }
  var RoleIdFlag_SINGLE_instance;
  function values_2() {
    return [RoleIdFlag_SINGLE_getInstance()];
  }
  var RoleIdFlag_entriesInitialized;
  function RoleIdFlag_initEntries() {
    if (RoleIdFlag_entriesInitialized)
      return Unit_instance;
    RoleIdFlag_entriesInitialized = true;
    RoleIdFlag_SINGLE_instance = new RoleIdFlag('SINGLE', 0);
  }
  function RoleIdFlag(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function RoleIdFlag_SINGLE_getInstance() {
    RoleIdFlag_initEntries();
    return RoleIdFlag_SINGLE_instance;
  }
  function AdditionalModelContext() {
    this.r55_1 = HashSet_init_$Create$();
    this.s55_1 = new Listeners();
  }
  protoOf(AdditionalModelContext).t55 = function () {
    return this.r55_1;
  };
  protoOf(AdditionalModelContext).h3j = function (listener) {
    return this.s55_1.j2s(listener);
  };
  function EntityWrapper$1(this$0) {
    this.y55_1 = this$0;
    DerivedProperty.call(this, [this$0.a56_1.j3h()]);
  }
  protoOf(EntityWrapper$1).v2w = function () {
    return 'parent(' + this.y55_1.a56_1.toString() + ')';
  };
  protoOf(EntityWrapper$1).q2w = function () {
    return this.y55_1.bp();
  };
  function EntityWrapper$getModelRootNodeProperty$lambda(it) {
    return it == null ? null : it.k3e_1;
  }
  function EntityWrapper$getModelRootNodeProperty$lambda_0(it) {
    var tmp;
    if (it == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      var tmp0_safe_receiver = it.g3m_1;
      var tmp_0;
      if (tmp0_safe_receiver == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlin.apply' call
        // Inline function 'kotlin.check' call
        if (!equals(tmp0_safe_receiver.k3e_1, it)) {
          var message = 'Node is not root';
          throw IllegalStateException_init_$Create$_0(toString_1(message));
        }
        tmp_0 = tmp0_safe_receiver;
      }
      var tmp1_elvis_lhs = tmp_0;
      tmp = tmp1_elvis_lhs == null ? new Model(it) : tmp1_elvis_lhs;
    }
    return tmp;
  }
  function EntityWrapper(context, entity) {
    this.z55_1 = context;
    this.a56_1 = entity;
    var tmp = this;
    tmp.b56_1 = new EntityWrapper$1(this);
    this.z55_1.v56(this);
  }
  protoOf(EntityWrapper).bp = function () {
    var parent = this.a56_1.bp();
    var tmp;
    if (parent == null) {
      tmp = null;
    } else {
      tmp = this.z55_1.w56(parent);
    }
    return tmp;
  };
  protoOf(EntityWrapper).x56 = function (blobId) {
    var modelProp = this.a56_1.t3h(blobId);
    return this.z55_1.y56(modelProp);
  };
  protoOf(EntityWrapper).z56 = function (blobId) {
    var modelProperty = this.a56_1.t3h(blobId);
    var tmp = EntityWrapper$getModelRootNodeProperty$lambda;
    return map_1(modelProperty, tmp, EntityWrapper$getModelRootNodeProperty$lambda_0);
  };
  protoOf(EntityWrapper).toString = function () {
    var tmp0_elvis_lhs = getKClassFromExpression(this).ra();
    var className = tmp0_elvis_lhs == null ? '<anonymous entity concept>' : tmp0_elvis_lhs;
    return className + '@' + toString_3(hashCode(this), 16) + '[' + this.a56_1.toString() + ']';
  };
  function getWrapperFor($this, node) {
    return $this.a57_1.c57(node);
  }
  function doGetChildren($this, childId, requestedClass) {
    var tmp = $this.b57_1.p3m(childId);
    var source = isInterface(tmp, MutableObservableList) ? tmp : THROW_CCE();
    var toTarget = NodeWrapper$doGetChildren$lambda($this, requestedClass);
    var toSource = NodeWrapper$doGetChildren$lambda_0;
    return new ObservableListWrapper(source, toTarget, toSource);
  }
  function propertyByStringProperty($this, prop, persister) {
    return new NodeWrapper$propertyByStringProperty$1(prop, persister);
  }
  function NodeWrapper$parentProperty$1(this$0) {
    this.h57_1 = this$0;
    DerivedProperty.call(this, [this$0.b57_1.j3h()]);
  }
  protoOf(NodeWrapper$parentProperty$1).v2w = function () {
    return 'parent(' + this.h57_1.b57_1.toString() + ')';
  };
  protoOf(NodeWrapper$parentProperty$1).q2w = function () {
    return this.h57_1.d3o();
  };
  function NodeWrapper$doGetChildren$lambda(this$0, $requestedClass) {
    return function (sourceNode) {
      return this$0.a57_1.i57(sourceNode, $requestedClass);
    };
  }
  function NodeWrapper$doGetChildren$lambda_0(target) {
    return target.b57_1;
  }
  function NodeWrapper$descendants$lambda(this$0) {
    return function (it) {
      return this$0.a57_1.i57(it instanceof Node_0 ? it : THROW_CCE(), getKClass(NodeWrapper));
    };
  }
  function NodeWrapper$allChildren$lambda(this$0) {
    return function (it) {
      return this$0.a57_1.i57(it instanceof Node_0 ? it : THROW_CCE(), getKClass(NodeWrapper));
    };
  }
  function NodeWrapper$propertyByStringProperty$1($prop, $persister) {
    this.j57_1 = $prop;
    this.k57_1 = $persister;
    BaseReadableProperty.call(this);
  }
  protoOf(NodeWrapper$propertyByStringProperty$1).v2w = function () {
    return 'fromStringProp(' + this.j57_1.v2w() + ', ' + toString_1(this.k57_1) + ')';
  };
  protoOf(NodeWrapper$propertyByStringProperty$1).uv = function () {
    var value = this.j57_1.uv();
    try {
      return this.k57_1.p25(value);
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        throw IllegalStateException_init_$Create$_1('Property ' + toString_1(this.j57_1) + ' contains non-deserializable value: ' + value, e);
      } else {
        throw $p;
      }
    }
  };
  protoOf(NodeWrapper$propertyByStringProperty$1).d2x = function (newValue) {
    var value;
    try {
      value = this.k57_1.w24(newValue);
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        throw IllegalArgumentException_init_$Create$_1('Property ' + toString_1(this.j57_1) + ' has assigned to non-serializable value: ' + toString_0(newValue), e);
      } else {
        throw $p;
      }
    }
    this.j57_1.d2x(value);
  };
  protoOf(NodeWrapper$propertyByStringProperty$1).u2w = function (handler) {
    return this.j57_1.y2r(new PropertyEventHandlerWrapper(handler, this.k57_1));
  };
  protoOf(NodeWrapper$propertyByStringProperty$1).y2r = function (handler) {
    return this.u2w(handler);
  };
  function NodeWrapper(context, node) {
    this.a57_1 = context;
    this.b57_1 = node;
    this.a57_1.l57(this);
  }
  protoOf(NodeWrapper).z3n = function () {
    return this.b57_1.z3n();
  };
  protoOf(NodeWrapper).d3o = function () {
    var tmp0_safe_receiver = this.b57_1.d3o();
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp = getWrapperFor(this, tmp0_safe_receiver instanceof Node_0 ? tmp0_safe_receiver : THROW_CCE());
    }
    return tmp;
  };
  protoOf(NodeWrapper).g3t = function () {
    return this.b57_1.g3m_1;
  };
  protoOf(NodeWrapper).j3h = function () {
    return new NodeWrapper$parentProperty$1(this);
  };
  protoOf(NodeWrapper).j3p = function (propertyId) {
    return this.b57_1.j3p(propertyId);
  };
  protoOf(NodeWrapper).m57 = function (propertyId) {
    return this.n57(propertyId, Persisters_getInstance().i25());
  };
  protoOf(NodeWrapper).o57 = function (propertyId) {
    return this.n57(propertyId, Persisters_getInstance().c26());
  };
  protoOf(NodeWrapper).n57 = function (propertyId, persister) {
    return propertyByStringProperty(this, this.b57_1.d3n(propertyId), persister);
  };
  protoOf(NodeWrapper).p57 = function (childId) {
    // Inline function 'kotlin.require' call
    if (!childId.f3g()) {
      var message = 'child property is supported only for single role node child id ' + childId.q36_1;
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    return asSingleItemCollectionProp(doGetChildren(this, childId, null));
  };
  protoOf(NodeWrapper).q57 = function (childId) {
    return this.r57(childId, null);
  };
  protoOf(NodeWrapper).r57 = function (childId, requestedClass) {
    // Inline function 'kotlin.require' call
    if (!!childId.f3g()) {
      var message = 'observable list of children is supported only for multi role node child id ' + childId.q36_1;
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    return doGetChildren(this, childId, requestedClass);
  };
  protoOf(NodeWrapper).s57 = function (with_0) {
    return this.b57_1.u3p(with_0.b57_1);
  };
  protoOf(NodeWrapper).r3p = function () {
    return this.b57_1.r3p();
  };
  protoOf(NodeWrapper).t57 = function () {
    var copy = this.b57_1.q3p();
    return getWrapperFor(this, copy instanceof Node_0 ? copy : THROW_CCE());
  };
  protoOf(NodeWrapper).s3p = function (includeSelf) {
    var tmp = this.b57_1.s3p(includeSelf);
    return map(tmp, NodeWrapper$descendants$lambda(this));
  };
  protoOf(NodeWrapper).t3p = function () {
    var tmp = this.b57_1.t3p();
    return map(tmp, NodeWrapper$allChildren$lambda(this));
  };
  protoOf(NodeWrapper).toString = function () {
    var tmp0_elvis_lhs = getKClassFromExpression(this).ra();
    var className = tmp0_elvis_lhs == null ? '<anonymous concept>' : tmp0_elvis_lhs;
    var hashCode_0 = toString_3(hashCode(this), 16);
    return className + '@' + hashCode_0 + '[' + this.b57_1.toString() + ']';
  };
  function NodeWrapperFactory() {
  }
  protoOf(NodeWrapperFactory).v57 = function (context, node, requestedClass, errorMessage) {
    return null;
  };
  function WrapperContext$Companion$LOG$lambda() {
    return Unit_instance;
  }
  function ReferenceListener$onReferencedEntityAdded$ref() {
    var l = function (p0) {
      p0.w57();
      return Unit_instance;
    };
    l.callableName = 'onReferencedEntityAdded';
    return l;
  }
  function ReferenceListener$onReferencedEntityRemoved$ref() {
    var l = function (p0) {
      p0.x57();
      return Unit_instance;
    };
    l.callableName = 'onReferencedEntityRemoved';
    return l;
  }
  function WrapperContext_init_$Init$(entityContext, $this) {
    entityContext = entityContext === VOID ? new EntityContext() : entityContext;
    WrapperContext.call($this, entityContext, new AdditionalModelContext());
    return $this;
  }
  function WrapperContext_init_$Create$(entityContext) {
    return WrapperContext_init_$Init$(entityContext, objectCreate(protoOf(WrapperContext)));
  }
  function watchModel($this, model) {
    $this.t56_1.j1(model.f3o());
    var disposable = model.i3o(new WrapperContext$watchModel$disposable$1($this));
    // Inline function 'kotlin.collections.set' call
    $this.m56_1.t2(model, disposable);
  }
  function createWrapperFor($this, entity) {
    $this.i56_1.uv().j(entity);
    try {
      var wrapper;
      var _iterator__ex2g4s = $this.h56_1.m();
      while (_iterator__ex2g4s.n()) {
        var factory = _iterator__ex2g4s.o();
        wrapper = factory.y57($this, entity);
        if (!(wrapper == null)) {
          checkDetached($this, entity);
          return wrapper instanceof EntityWrapper ? wrapper : THROW_CCE();
        }
      }
      throw IllegalArgumentException_init_$Create$_0('Cannot create wrapper for entity ' + entity.toString());
    }finally {
      $this.i56_1.uv().h2(entity);
    }
  }
  function checkDetached($this, entity) {
    if (!(entity.q3d_1 === $this.c56_1)) {
      $this.s56_1.j(entity);
    }
  }
  function createWrapperFor_0($this, node, requestedClass) {
    var result = null;
    $this.i56_1.uv().j(node);
    try {
      var _iterator__ex2g4s = $this.o56_1.m();
      $l$loop: while (_iterator__ex2g4s.n()) {
        var factory = _iterator__ex2g4s.o();
        var wrapper = factory.u57($this, node);
        if (!(wrapper == null)) {
          // Inline function 'kotlin.check' call
          if (!(wrapper.b57_1 === node)) {
            var message = 'Factory ' + toString_1(factory) + ' provided a wrapper for a node different to ' + node.toString();
            throw IllegalStateException_init_$Create$_0(toString_1(message));
          }
          var wrapperResult = wrapper instanceof NodeWrapper ? wrapper : THROW_CCE();
          result = wrapperResult;
          break $l$loop;
        }
      }
      var errorMessage = 'Cannot create wrapper for node: ' + node.toString() + ', requestedClass: ' + toString_0(requestedClass);
      if (result == null) {
        var _iterator__ex2g4s_0 = $this.o56_1.m();
        $l$loop_0: while (_iterator__ex2g4s_0.n()) {
          var factory_0 = _iterator__ex2g4s_0.o();
          var errorWrapper = factory_0.v57($this, node, requestedClass, errorMessage);
          if (!(errorWrapper == null)) {
            // Inline function 'kotlin.check' call
            if (!(errorWrapper.b57_1 === node)) {
              var message_0 = 'Factory ' + toString_1(factory_0) + ' provided error a wrapper for a node different to ' + node.toString();
              throw IllegalStateException_init_$Create$_0(toString_1(message_0));
            }
            result = errorWrapper;
            var tmp = Companion_getInstance_77().z57_1;
            tmp.f2q(WrapperContext$createWrapperFor$lambda(errorMessage));
            break $l$loop_0;
          }
        }
      }
      var tmp0 = result;
      $l$block: {
        // Inline function 'kotlin.requireNotNull' call
        if (tmp0 == null) {
          var message_1 = errorMessage;
          throw IllegalArgumentException_init_$Create$_0(toString_1(message_1));
        } else {
          break $l$block;
        }
      }
      checkDetached_0($this, node);
      return result;
    }finally {
      $this.i56_1.uv().h2(node);
    }
  }
  function checkDetached_0($this, node) {
    var model = node.g3m_1;
    if (model == null || !$this.m56_1.o2(model)) {
      $this.t56_1.j(node);
    }
  }
  function DefaultLoadingPeer($outer) {
    this.b58_1 = $outer;
  }
  function Companion_77() {
    Companion_instance_77 = this;
    var tmp = this;
    var tmp_0 = KotlinLogging_getInstance();
    tmp.z57_1 = tmp_0.i2q(WrapperContext$Companion$LOG$lambda);
    this.a58_1 = 60000;
  }
  var Companion_instance_77;
  function Companion_getInstance_77() {
    if (Companion_instance_77 == null)
      new Companion_77();
    return Companion_instance_77;
  }
  function WrapperContext$creatingWrapperFor$lambda() {
    return HashSet_init_$Create$();
  }
  function WrapperContext$1(this$0) {
    this.c58_1 = this$0;
  }
  protoOf(WrapperContext$1).g3i = function (entity) {
    var id = entity.n3d_1;
    var tmp0_safe_receiver = this.c58_1.r56_1.q2(id);
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.k2s(ReferenceListener$onReferencedEntityAdded$ref());
    }
    this.c58_1.s56_1.h2(entity);
  };
  protoOf(WrapperContext$1).h3i = function (entity) {
    var id = entity.n3d_1;
    var tmp0_safe_receiver = this.c58_1.r56_1.q2(id);
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.k2s(ReferenceListener$onReferencedEntityRemoved$ref());
    }
    this.c58_1.s56_1.j(entity);
  };
  function WrapperContext$modelAttachListener$1(this$0) {
    this.d58_1 = this$0;
  }
  protoOf(WrapperContext$modelAttachListener$1).w3i = function (model) {
    return watchModel(this.d58_1, model);
  };
  protoOf(WrapperContext$modelAttachListener$1).x3i = function (model) {
    this.d58_1.t56_1.q(model.f3o());
    ensureNotNull(this.d58_1.m56_1.u2(model)).zr();
  };
  function WrapperContext$watchModel$disposable$1(this$0) {
    this.e58_1 = this$0;
  }
  protoOf(WrapperContext$watchModel$disposable$1).b3o = function (node) {
    this.e58_1.t56_1.h2(node);
  };
  protoOf(WrapperContext$watchModel$disposable$1).c3o = function (node) {
    this.e58_1.t56_1.j(node);
  };
  function WrapperContext$wrap$lambda(this$0) {
    return function (input) {
      var tmp;
      if (input == null) {
        tmp = null;
      } else {
        tmp = this$0.f58(input.k3e_1);
      }
      return tmp;
    };
  }
  function WrapperContext$wrap$lambda_0(input) {
    var tmp;
    if (input == null) {
      tmp = null;
    } else {
      var model = input.g3t();
      var tmp_0;
      if (model == null) {
        tmp_0 = new Model(input.b57_1);
      } else {
        // Inline function 'kotlin.check' call
        if (!equals(model.k3e_1, input.b57_1)) {
          var message = 'Wrapped node is not root';
          throw IllegalStateException_init_$Create$_0(toString_1(message));
        }
        tmp_0 = model;
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  function WrapperContext$wrapEntitySet$lambda(this$0) {
    return function (item) {
      return this$0.w56(item);
    };
  }
  function WrapperContext$wrapEntitySet$lambda_0(wrapper) {
    return wrapper.a56_1;
  }
  function WrapperContext$createWrapperFor$lambda($errorMessage) {
    return function () {
      return $errorMessage;
    };
  }
  function WrapperContext$put$$inlined$toDisposable$1(this$0, $key) {
    this.g58_1 = this$0;
    this.h58_1 = $key;
  }
  protoOf(WrapperContext$put$$inlined$toDisposable$1).zr = function () {
    this.g58_1.j56_1.u2(this.h58_1);
    return Unit_instance;
  };
  function WrapperContext(entityContext, additionalModelContext) {
    Companion_getInstance_77();
    entityContext = entityContext === VOID ? new EntityContext() : entityContext;
    additionalModelContext = additionalModelContext === VOID ? new AdditionalModelContext() : additionalModelContext;
    this.c56_1 = entityContext;
    this.d56_1 = additionalModelContext;
    this.g56_1 = HashMap_init_$Create$();
    this.h56_1 = ArrayList_init_$Create$();
    var tmp = this;
    tmp.i56_1 = newSimpleThreadLocal(WrapperContext$creatingWrapperFor$lambda);
    this.j56_1 = HashMap_init_$Create$();
    this.m56_1 = HashMap_init_$Create$();
    this.n56_1 = HashMap_init_$Create$();
    this.o56_1 = ArrayList_init_$Create$();
    this.p56_1 = true;
    this.r56_1 = HashMap_init_$Create$();
    this.s56_1 = HashSet_init_$Create$();
    this.t56_1 = HashSet_init_$Create$();
    this.u56_1 = new DefaultLoadingPeer(this);
    this.e56_1 = this.i58(this.c56_1.g3f_1);
    this.f56_1 = this.i58(this.c56_1.a3j());
    var _iterator__ex2g4s = this.c56_1.a3j().m();
    while (_iterator__ex2g4s.n()) {
      var entity = _iterator__ex2g4s.o();
      var _iterator__ex2g4s_0 = entity.h3e().m();
      while (_iterator__ex2g4s_0.n()) {
        var blobId = _iterator__ex2g4s_0.o();
        watchModel(this, ensureNotNull(entity.i3e(blobId)));
      }
    }
    var tmp_0 = this;
    tmp_0.q56_1 = this.c56_1.g3j(new WrapperContext$1(this));
    var modelAttachListener = new WrapperContext$modelAttachListener$1(this);
    this.k56_1 = this.c56_1.h3j(modelAttachListener);
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s_1 = this.d56_1.t55().m();
    while (_iterator__ex2g4s_1.n()) {
      var element = _iterator__ex2g4s_1.o();
      watchModel(this, element);
    }
    this.l56_1 = this.d56_1.h3j(modelAttachListener);
  }
  protoOf(WrapperContext).zr = function () {
    var _iterator__ex2g4s = this.m56_1.s2().m();
    while (_iterator__ex2g4s.n()) {
      var disposable = _iterator__ex2g4s.o();
      disposable.zr();
    }
    this.l56_1.zr();
    this.k56_1.zr();
    this.q56_1.zr();
  };
  protoOf(WrapperContext).j58 = function (factory) {
    this.o56_1.j(factory);
  };
  protoOf(WrapperContext).k58 = function (factory) {
    this.h56_1.j(factory);
  };
  protoOf(WrapperContext).y56 = function (modelProp) {
    var sourceToTarget = WrapperContext$wrap$lambda(this);
    var targetToSource = WrapperContext$wrap$lambda_0;
    return map_1(modelProp, sourceToTarget, targetToSource);
  };
  protoOf(WrapperContext).i58 = function (set) {
    var tmp = WrapperContext$wrapEntitySet$lambda(this);
    return new ObservableSetWrapper(set, tmp, WrapperContext$wrapEntitySet$lambda_0);
  };
  protoOf(WrapperContext).v56 = function (entityWrapper) {
    var entity = entityWrapper.a56_1;
    // Inline function 'kotlin.collections.set' call
    this.g56_1.t2(entity, entityWrapper);
    checkDetached(this, entity);
  };
  protoOf(WrapperContext).l57 = function (nodeWrapper) {
    var node = nodeWrapper.b57_1;
    // Inline function 'kotlin.collections.set' call
    this.n56_1.t2(node, nodeWrapper);
    checkDetached_0(this, node);
  };
  protoOf(WrapperContext).l58 = function (node, requestedClass) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.require' call
    if (!(node instanceof Node_0)) {
      var message = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    return this.i57(node, requestedClass);
  };
  protoOf(WrapperContext).f58 = function (node, requestedClass, $super) {
    requestedClass = requestedClass === VOID ? null : requestedClass;
    return $super === VOID ? this.l58(node, requestedClass) : $super.l58.call(this, node, requestedClass);
  };
  protoOf(WrapperContext).i57 = function (node, requestedClass) {
    // Inline function 'kotlin.check' call
    if (!!this.i56_1.uv().t(node)) {
      var message = 'Create wrapper for node ' + node.toString() + ' is still in progress';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    var tmp;
    if (this.n56_1.o2(node)) {
      var tmp_0 = this.n56_1.q2(node);
      tmp = tmp_0 instanceof NodeWrapper ? tmp_0 : THROW_CCE();
    } else {
      tmp = createWrapperFor_0(this, node, requestedClass);
    }
    return tmp;
  };
  protoOf(WrapperContext).c57 = function (node, requestedClass, $super) {
    requestedClass = requestedClass === VOID ? null : requestedClass;
    return $super === VOID ? this.i57(node, requestedClass) : $super.i57.call(this, node, requestedClass);
  };
  protoOf(WrapperContext).w56 = function (entity) {
    // Inline function 'kotlin.check' call
    if (!!this.i56_1.uv().t(entity)) {
      var message = 'Create wrapper for entity ' + entity.toString() + ' is still in progress';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    var tmp;
    if (this.g56_1.o2(entity)) {
      var tmp_0 = this.g56_1.q2(entity);
      tmp = tmp_0 instanceof EntityWrapper ? tmp_0 : THROW_CCE();
    } else {
      tmp = createWrapperFor(this, entity);
    }
    return tmp;
  };
  protoOf(WrapperContext).m58 = function (key) {
    var tmp0_elvis_lhs = this.j56_1.q2(key);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalStateException_init_$Create$_0('Missing wrapper context element: ' + key.toString());
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var result = tmp;
    return !(result == null) ? result : THROW_CCE();
  };
  protoOf(WrapperContext).n58 = function (key) {
    var result = this.j56_1.q2(key);
    return (result == null ? true : !(result == null)) ? result : THROW_CCE();
  };
  protoOf(WrapperContext).o58 = function (key, value) {
    // Inline function 'kotlin.check' call
    if (!!this.j56_1.o2(key)) {
      var message = 'Wrapper context already contains value for the key: ' + key.toString();
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    var tmp0 = this.j56_1;
    // Inline function 'kotlin.collections.set' call
    var value_0 = !(value == null) ? value : THROW_CCE();
    tmp0.t2(key, value_0);
    // Inline function 'jetbrains.ocelot.base.disposable.toDisposable' call
    return new WrapperContext$put$$inlined$toDisposable$1(this, key);
  };
  function WrapperContextKey(name) {
    this.p58_1 = name;
  }
  protoOf(WrapperContextKey).toString = function () {
    return this.p58_1;
  };
  function WrapperContextService() {
  }
  var WrapperContextService_instance;
  function WrapperContextService_getInstance() {
    return WrapperContextService_instance;
  }
  function ReferenceListener() {
  }
  function serializer($this, serializersModule) {
    var tmp0_elvis_lhs = serializersModule.u58($this.q58_1, $this.s58_1);
    var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? $this.r58_1 : tmp0_elvis_lhs;
    var tmp;
    if (tmp1_elvis_lhs == null) {
      serializerNotRegistered($this.q58_1);
    } else {
      tmp = tmp1_elvis_lhs;
    }
    return tmp;
  }
  function ContextualSerializer$descriptor$lambda(this$0) {
    return function ($this$buildSerialDescriptor) {
      var tmp = $this$buildSerialDescriptor;
      var tmp0_safe_receiver = this$0.r58_1;
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.v58();
      // Inline function 'kotlin.collections.orEmpty' call
      var tmp0_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.w58();
      tmp.z58_1 = tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
      return Unit_instance;
    };
  }
  function ContextualSerializer(serializableClass, fallbackSerializer, typeArgumentsSerializers) {
    this.q58_1 = serializableClass;
    this.r58_1 = fallbackSerializer;
    this.s58_1 = asList(typeArgumentsSerializers);
    var tmp = this;
    var tmp_0 = CONTEXTUAL_getInstance();
    tmp.t58_1 = withContext_0(buildSerialDescriptor('kotlinx.serialization.ContextualSerializer', tmp_0, [], ContextualSerializer$descriptor$lambda(this)), this.q58_1);
  }
  protoOf(ContextualSerializer).v58 = function () {
    return this.t58_1;
  };
  protoOf(ContextualSerializer).f59 = function (encoder, value) {
    encoder.h59(serializer(this, encoder.g59()), value);
  };
  protoOf(ContextualSerializer).i59 = function (encoder, value) {
    return this.f59(encoder, !(value == null) ? value : THROW_CCE());
  };
  protoOf(ContextualSerializer).j59 = function (decoder) {
    return decoder.k59(serializer(this, decoder.g59()));
  };
  function KSerializer() {
  }
  function SerializationStrategy() {
  }
  function DeserializationStrategy() {
  }
  function PolymorphicSerializer_init_$Init$(baseClass, classAnnotations, $this) {
    PolymorphicSerializer.call($this, baseClass);
    $this.m59_1 = asList(classAnnotations);
    return $this;
  }
  function PolymorphicSerializer_init_$Create$(baseClass, classAnnotations) {
    return PolymorphicSerializer_init_$Init$(baseClass, classAnnotations, objectCreate(protoOf(PolymorphicSerializer)));
  }
  function PolymorphicSerializer$descriptor$delegate$lambda$lambda(this$0) {
    return function ($this$buildSerialDescriptor) {
      $this$buildSerialDescriptor.o59('type', serializer_5(StringCompanionObject_instance).v58());
      $this$buildSerialDescriptor.o59('value', buildSerialDescriptor('kotlinx.serialization.Polymorphic<' + this$0.l59_1.ra() + '>', CONTEXTUAL_getInstance(), []));
      $this$buildSerialDescriptor.z58_1 = this$0.m59_1;
      return Unit_instance;
    };
  }
  function PolymorphicSerializer$descriptor$delegate$lambda(this$0) {
    return function () {
      var tmp = OPEN_getInstance();
      return withContext_0(buildSerialDescriptor('kotlinx.serialization.Polymorphic', tmp, [], PolymorphicSerializer$descriptor$delegate$lambda$lambda(this$0)), this$0.l59_1);
    };
  }
  function PolymorphicSerializer$_get_descriptor_$ref_8tw9if() {
    return function (p0) {
      return p0.v58();
    };
  }
  function PolymorphicSerializer(baseClass) {
    AbstractPolymorphicSerializer.call(this);
    this.l59_1 = baseClass;
    this.m59_1 = emptyList();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.n59_1 = lazy_0(tmp_0, PolymorphicSerializer$descriptor$delegate$lambda(this));
  }
  protoOf(PolymorphicSerializer).p59 = function () {
    return this.l59_1;
  };
  protoOf(PolymorphicSerializer).v58 = function () {
    var tmp0 = this.n59_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('descriptor', 1, tmp, PolymorphicSerializer$_get_descriptor_$ref_8tw9if(), null);
    return tmp0.a1();
  };
  protoOf(PolymorphicSerializer).toString = function () {
    return 'kotlinx.serialization.PolymorphicSerializer(baseClass: ' + toString_1(this.l59_1) + ')';
  };
  function findPolymorphicSerializer(_this__u8e3s4, encoder, value) {
    var tmp0_elvis_lhs = _this__u8e3s4.r59(encoder, value);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throwSubtypeNotRegistered(getKClassFromExpression(value), _this__u8e3s4.p59());
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function findPolymorphicSerializer_0(_this__u8e3s4, decoder, klassName) {
    var tmp0_elvis_lhs = _this__u8e3s4.q59(decoder, klassName);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throwSubtypeNotRegistered_0(klassName, _this__u8e3s4.p59());
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function SealedClassSerializer_init_$Init$(serialName, baseClass, subclasses, subclassSerializers, classAnnotations, $this) {
    SealedClassSerializer.call($this, serialName, baseClass, subclasses, subclassSerializers);
    $this.t59_1 = asList(classAnnotations);
    return $this;
  }
  function SealedClassSerializer_init_$Create$(serialName, baseClass, subclasses, subclassSerializers, classAnnotations) {
    return SealedClassSerializer_init_$Init$(serialName, baseClass, subclasses, subclassSerializers, classAnnotations, objectCreate(protoOf(SealedClassSerializer)));
  }
  function SealedClassSerializer$descriptor$delegate$lambda$lambda$lambda(this$0) {
    return function ($this$buildSerialDescriptor) {
      // Inline function 'kotlin.collections.forEach' call
      // Inline function 'kotlin.collections.iterator' call
      var _iterator__ex2g4s = this$0.w59_1.y().m();
      while (_iterator__ex2g4s.n()) {
        var element = _iterator__ex2g4s.o();
        // Inline function 'kotlin.collections.component1' call
        var name = element.z();
        // Inline function 'kotlin.collections.component2' call
        var serializer = element.a1();
        $this$buildSerialDescriptor.o59(name, serializer.v58());
      }
      return Unit_instance;
    };
  }
  function SealedClassSerializer$descriptor$delegate$lambda$lambda(this$0) {
    return function ($this$buildSerialDescriptor) {
      $this$buildSerialDescriptor.o59('type', serializer_5(StringCompanionObject_instance).v58());
      var tmp = 'kotlinx.serialization.Sealed<' + this$0.s59_1.ra() + '>';
      var tmp_0 = CONTEXTUAL_getInstance();
      var elementDescriptor = buildSerialDescriptor(tmp, tmp_0, [], SealedClassSerializer$descriptor$delegate$lambda$lambda$lambda(this$0));
      $this$buildSerialDescriptor.o59('value', elementDescriptor);
      $this$buildSerialDescriptor.z58_1 = this$0.t59_1;
      return Unit_instance;
    };
  }
  function SealedClassSerializer$descriptor$delegate$lambda($serialName, this$0) {
    return function () {
      var tmp = SEALED_getInstance();
      return buildSerialDescriptor($serialName, tmp, [], SealedClassSerializer$descriptor$delegate$lambda$lambda(this$0));
    };
  }
  function SealedClassSerializer$_get_descriptor_$ref_m511rz() {
    return function (p0) {
      return p0.v58();
    };
  }
  function SealedClassSerializer$$inlined$groupingBy$1($this) {
    this.x59_1 = $this;
  }
  protoOf(SealedClassSerializer$$inlined$groupingBy$1).e4 = function () {
    return this.x59_1.m();
  };
  protoOf(SealedClassSerializer$$inlined$groupingBy$1).y59 = function (element) {
    return element.a1().v58().z59();
  };
  protoOf(SealedClassSerializer$$inlined$groupingBy$1).f4 = function (element) {
    return this.y59((element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  function SealedClassSerializer(serialName, baseClass, subclasses, subclassSerializers) {
    AbstractPolymorphicSerializer.call(this);
    this.s59_1 = baseClass;
    this.t59_1 = emptyList();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.u59_1 = lazy_0(tmp_0, SealedClassSerializer$descriptor$delegate$lambda(serialName, this));
    if (!(subclasses.length === subclassSerializers.length)) {
      throw IllegalArgumentException_init_$Create$_0('All subclasses of sealed class ' + this.s59_1.ra() + ' should be marked @Serializable');
    }
    this.v59_1 = toMap_0(zip(subclasses, subclassSerializers));
    var tmp_1 = this;
    // Inline function 'kotlin.collections.groupingBy' call
    var this_0 = this.v59_1.y();
    // Inline function 'kotlin.collections.aggregate' call
    var tmp0 = new SealedClassSerializer$$inlined$groupingBy$1(this_0);
    // Inline function 'kotlin.collections.mutableMapOf' call
    // Inline function 'kotlin.collections.aggregateTo' call
    var destination = LinkedHashMap_init_$Create$();
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s = tmp0.e4();
    while (_iterator__ex2g4s.n()) {
      var e = _iterator__ex2g4s.o();
      var key = tmp0.f4(e);
      var accumulator = destination.q2(key);
      accumulator == null && !destination.o2(key);
      if (!(accumulator == null)) {
        // Inline function 'kotlin.error' call
        var message = "Multiple sealed subclasses of '" + toString_1(this.s59_1) + "' have the same serial name '" + key + "':" + (" '" + toString_1(accumulator.z()) + "', '" + toString_1(e.z()) + "'");
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      }
      // Inline function 'kotlin.collections.set' call
      destination.t2(key, e);
    }
    // Inline function 'kotlin.collections.mapValues' call
    // Inline function 'kotlin.collections.mapValuesTo' call
    var destination_0 = LinkedHashMap_init_$Create$_0(mapCapacity(destination.p()));
    // Inline function 'kotlin.collections.associateByTo' call
    var _iterator__ex2g4s_0 = destination.y().m();
    while (_iterator__ex2g4s_0.n()) {
      var element = _iterator__ex2g4s_0.o();
      var tmp_2 = element.z();
      var tmp$ret$8 = element.a1().a1();
      destination_0.t2(tmp_2, tmp$ret$8);
    }
    tmp_1.w59_1 = destination_0;
  }
  protoOf(SealedClassSerializer).p59 = function () {
    return this.s59_1;
  };
  protoOf(SealedClassSerializer).v58 = function () {
    var tmp0 = this.u59_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('descriptor', 1, tmp, SealedClassSerializer$_get_descriptor_$ref_m511rz(), null);
    return tmp0.a1();
  };
  protoOf(SealedClassSerializer).q59 = function (decoder, klassName) {
    // Inline function 'kotlin.collections.get' call
    var this_0 = this.w59_1;
    var tmp0_elvis_lhs = (isInterface(this_0, KtMap) ? this_0 : THROW_CCE()).q2(klassName);
    return tmp0_elvis_lhs == null ? protoOf(AbstractPolymorphicSerializer).q59.call(this, decoder, klassName) : tmp0_elvis_lhs;
  };
  protoOf(SealedClassSerializer).r59 = function (encoder, value) {
    var tmp0_elvis_lhs = this.v59_1.q2(getKClassFromExpression(value));
    var tmp1_safe_receiver = tmp0_elvis_lhs == null ? protoOf(AbstractPolymorphicSerializer).r59.call(this, encoder, value) : tmp0_elvis_lhs;
    var tmp;
    if (tmp1_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlinx.serialization.internal.cast' call
      tmp = isInterface(tmp1_safe_receiver, SerializationStrategy) ? tmp1_safe_receiver : THROW_CCE();
    }
    return tmp;
  };
  function BinaryFormat() {
  }
  function StringFormat() {
  }
  function UnknownFieldException_init_$Init$(index, $this) {
    UnknownFieldException.call($this, 'An unknown field for index ' + index);
    return $this;
  }
  function UnknownFieldException_init_$Create$(index) {
    var tmp = UnknownFieldException_init_$Init$(index, objectCreate(protoOf(UnknownFieldException)));
    captureStack(tmp, UnknownFieldException_init_$Create$);
    return tmp;
  }
  function UnknownFieldException(message) {
    SerializationException_init_$Init$_0(message, this);
    captureStack(this, UnknownFieldException);
  }
  function SerializationException_init_$Init$($this) {
    IllegalArgumentException_init_$Init$($this);
    SerializationException.call($this);
    return $this;
  }
  function SerializationException_init_$Create$() {
    var tmp = SerializationException_init_$Init$(objectCreate(protoOf(SerializationException)));
    captureStack(tmp, SerializationException_init_$Create$);
    return tmp;
  }
  function SerializationException_init_$Init$_0(message, $this) {
    IllegalArgumentException_init_$Init$_0(message, $this);
    SerializationException.call($this);
    return $this;
  }
  function SerializationException_init_$Create$_0(message) {
    var tmp = SerializationException_init_$Init$_0(message, objectCreate(protoOf(SerializationException)));
    captureStack(tmp, SerializationException_init_$Create$_0);
    return tmp;
  }
  function SerializationException_init_$Init$_1(message, cause, $this) {
    IllegalArgumentException_init_$Init$_1(message, cause, $this);
    SerializationException.call($this);
    return $this;
  }
  function SerializationException() {
    captureStack(this, SerializationException);
  }
  function MissingFieldException_init_$Init$(missingFields, serialName, $this) {
    MissingFieldException.call($this, missingFields, missingFields.p() === 1 ? "Field '" + missingFields.r(0) + "' is required for type with serial name '" + serialName + "', but it was missing" : 'Fields ' + toString_1(missingFields) + " are required for type with serial name '" + serialName + "', but they were missing", null);
    return $this;
  }
  function MissingFieldException_init_$Create$(missingFields, serialName) {
    var tmp = MissingFieldException_init_$Init$(missingFields, serialName, objectCreate(protoOf(MissingFieldException)));
    captureStack(tmp, MissingFieldException_init_$Create$);
    return tmp;
  }
  function MissingFieldException(missingFields, message, cause) {
    SerializationException_init_$Init$_1(message, cause, this);
    captureStack(this, MissingFieldException);
    this.e5a_1 = missingFields;
  }
  function serializer_0(type) {
    return serializer_2(EmptySerializersModule_0(), type);
  }
  function serializer_1(_this__u8e3s4) {
    var tmp0_elvis_lhs = serializerOrNull(_this__u8e3s4);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      serializerNotRegistered(_this__u8e3s4);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function serializer_2(_this__u8e3s4, type) {
    var tmp0_elvis_lhs = serializerByKTypeImpl(_this__u8e3s4, type, true);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      platformSpecificSerializerNotRegistered(kclass(type));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function serializerOrNull(_this__u8e3s4) {
    var tmp0_elvis_lhs = compiledSerializerImpl(_this__u8e3s4);
    return tmp0_elvis_lhs == null ? builtinSerializerOrNull(_this__u8e3s4) : tmp0_elvis_lhs;
  }
  function serializerByKTypeImpl(_this__u8e3s4, type, failOnMissingTypeArgSerializer) {
    var rootClass = kclass(type);
    var isNullable = type.hb();
    // Inline function 'kotlin.collections.map' call
    var this_0 = type.gb();
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.m();
    while (_iterator__ex2g4s.n()) {
      var item = _iterator__ex2g4s.o();
      var tmp0 = item.hk_1;
      var tmp$ret$1;
      $l$block: {
        // Inline function 'kotlin.requireNotNull' call
        if (tmp0 == null) {
          var message = 'Star projections in type arguments are not allowed, but had ' + toString_1(type);
          throw IllegalArgumentException_init_$Create$_0(toString_1(message));
        } else {
          tmp$ret$1 = tmp0;
          break $l$block;
        }
      }
      var tmp$ret$2 = tmp$ret$1;
      destination.j(tmp$ret$2);
    }
    var typeArguments = destination;
    var tmp;
    if (typeArguments.s()) {
      tmp = findCachedSerializer(rootClass, isNullable);
    } else {
      var cachedResult = findParametrizedCachedSerializer(rootClass, typeArguments, isNullable);
      var tmp_0;
      if (failOnMissingTypeArgSerializer) {
        // Inline function 'kotlin.Result.getOrNull' call
        var tmp_1;
        if (_Result___get_isFailure__impl__jpiriv(cachedResult)) {
          tmp_1 = null;
        } else {
          var tmp_2 = _Result___get_value__impl__bjfvqg(cachedResult);
          tmp_1 = (tmp_2 == null ? true : !(tmp_2 == null)) ? tmp_2 : THROW_CCE();
        }
        tmp_0 = tmp_1;
      } else {
        // Inline function 'kotlin.getOrElse' call
        var exception = Result__exceptionOrNull_impl_p6xea9(cachedResult);
        var tmp_3;
        if (exception == null) {
          var tmp_4 = _Result___get_value__impl__bjfvqg(cachedResult);
          tmp_3 = (tmp_4 == null ? true : !(tmp_4 == null)) ? tmp_4 : THROW_CCE();
        } else {
          return null;
        }
        tmp_0 = tmp_3;
      }
      tmp = tmp_0;
    }
    var cachedSerializer = tmp;
    if (cachedSerializer == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      return cachedSerializer;
    }
    var tmp_5;
    if (typeArguments.s()) {
      tmp_5 = _this__u8e3s4.f5a(rootClass);
    } else {
      var tmp1_elvis_lhs = serializersForParameters(_this__u8e3s4, typeArguments, failOnMissingTypeArgSerializer);
      var tmp_6;
      if (tmp1_elvis_lhs == null) {
        return null;
      } else {
        tmp_6 = tmp1_elvis_lhs;
      }
      var serializers = tmp_6;
      var tmp2_elvis_lhs = parametrizedSerializerOrNull(rootClass, serializers, serializerByKTypeImpl$lambda(typeArguments));
      tmp_5 = tmp2_elvis_lhs == null ? _this__u8e3s4.u58(rootClass, serializers) : tmp2_elvis_lhs;
    }
    var contextualSerializer = tmp_5;
    var tmp_7;
    if (contextualSerializer == null) {
      tmp_7 = null;
    } else {
      // Inline function 'kotlinx.serialization.internal.cast' call
      tmp_7 = isInterface(contextualSerializer, KSerializer) ? contextualSerializer : THROW_CCE();
    }
    var tmp4_safe_receiver = tmp_7;
    return tmp4_safe_receiver == null ? null : nullable(tmp4_safe_receiver, isNullable);
  }
  function serializersForParameters(_this__u8e3s4, typeArguments, failOnMissingTypeArgSerializer) {
    var tmp;
    if (failOnMissingTypeArgSerializer) {
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(typeArguments, 10));
      var _iterator__ex2g4s = typeArguments.m();
      while (_iterator__ex2g4s.n()) {
        var item = _iterator__ex2g4s.o();
        var tmp$ret$0 = serializer_2(_this__u8e3s4, item);
        destination.j(tmp$ret$0);
      }
      tmp = destination;
    } else {
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(typeArguments, 10));
      var _iterator__ex2g4s_0 = typeArguments.m();
      while (_iterator__ex2g4s_0.n()) {
        var item_0 = _iterator__ex2g4s_0.o();
        var tmp0_elvis_lhs = serializerOrNull_0(_this__u8e3s4, item_0);
        var tmp_0;
        if (tmp0_elvis_lhs == null) {
          return null;
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        var tmp$ret$3 = tmp_0;
        destination_0.j(tmp$ret$3);
      }
      tmp = destination_0;
    }
    var serializers = tmp;
    return serializers;
  }
  function parametrizedSerializerOrNull(_this__u8e3s4, serializers, elementClassifierIfArray) {
    var tmp0_elvis_lhs = builtinParametrizedSerializer(_this__u8e3s4, serializers, elementClassifierIfArray);
    return tmp0_elvis_lhs == null ? compiledParametrizedSerializer(_this__u8e3s4, serializers) : tmp0_elvis_lhs;
  }
  function nullable(_this__u8e3s4, shouldBeNullable) {
    if (shouldBeNullable)
      return get_nullable(_this__u8e3s4);
    return isInterface(_this__u8e3s4, KSerializer) ? _this__u8e3s4 : THROW_CCE();
  }
  function serializerOrNull_0(_this__u8e3s4, type) {
    return serializerByKTypeImpl(_this__u8e3s4, type, false);
  }
  function builtinParametrizedSerializer(_this__u8e3s4, serializers, elementClassifierIfArray) {
    var tmp;
    if (((_this__u8e3s4.equals(getKClass(Collection)) ? true : _this__u8e3s4.equals(getKClass(KtList))) ? true : _this__u8e3s4.equals(getKClass(KtMutableList))) ? true : _this__u8e3s4.equals(getKClass(ArrayList))) {
      tmp = new ArrayListSerializer(serializers.r(0));
    } else if (_this__u8e3s4.equals(getKClass(HashSet))) {
      tmp = new HashSetSerializer(serializers.r(0));
    } else if ((_this__u8e3s4.equals(getKClass(KtSet)) ? true : _this__u8e3s4.equals(getKClass(KtMutableSet))) ? true : _this__u8e3s4.equals(getKClass(LinkedHashSet))) {
      tmp = new LinkedHashSetSerializer(serializers.r(0));
    } else if (_this__u8e3s4.equals(getKClass(HashMap))) {
      tmp = new HashMapSerializer(serializers.r(0), serializers.r(1));
    } else if ((_this__u8e3s4.equals(getKClass(KtMap)) ? true : _this__u8e3s4.equals(getKClass(KtMutableMap))) ? true : _this__u8e3s4.equals(getKClass(LinkedHashMap))) {
      tmp = new LinkedHashMapSerializer(serializers.r(0), serializers.r(1));
    } else if (_this__u8e3s4.equals(getKClass(Entry))) {
      tmp = MapEntrySerializer(serializers.r(0), serializers.r(1));
    } else if (_this__u8e3s4.equals(getKClass(Pair))) {
      tmp = PairSerializer(serializers.r(0), serializers.r(1));
    } else if (_this__u8e3s4.equals(getKClass(Triple))) {
      tmp = TripleSerializer(serializers.r(0), serializers.r(1), serializers.r(2));
    } else {
      var tmp_0;
      if (isReferenceArray(_this__u8e3s4)) {
        var tmp_1 = elementClassifierIfArray();
        tmp_0 = ArraySerializer((!(tmp_1 == null) ? isInterface(tmp_1, KClass) : false) ? tmp_1 : THROW_CCE(), serializers.r(0));
      } else {
        tmp_0 = null;
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  function compiledParametrizedSerializer(_this__u8e3s4, serializers) {
    // Inline function 'kotlin.collections.toTypedArray' call
    var tmp$ret$0 = copyToArray(serializers);
    return constructSerializerForGivenTypeArgs(_this__u8e3s4, tmp$ret$0.slice());
  }
  function serializerByKTypeImpl$lambda($typeArguments) {
    return function () {
      return $typeArguments.r(0).fb();
    };
  }
  function get_SERIALIZERS_CACHE() {
    _init_properties_SerializersCache_kt__hgwi2p();
    return SERIALIZERS_CACHE;
  }
  var SERIALIZERS_CACHE;
  function get_SERIALIZERS_CACHE_NULLABLE() {
    _init_properties_SerializersCache_kt__hgwi2p();
    return SERIALIZERS_CACHE_NULLABLE;
  }
  var SERIALIZERS_CACHE_NULLABLE;
  function get_PARAMETRIZED_SERIALIZERS_CACHE() {
    _init_properties_SerializersCache_kt__hgwi2p();
    return PARAMETRIZED_SERIALIZERS_CACHE;
  }
  var PARAMETRIZED_SERIALIZERS_CACHE;
  function get_PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE() {
    _init_properties_SerializersCache_kt__hgwi2p();
    return PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE;
  }
  var PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE;
  function findCachedSerializer(clazz, isNullable) {
    _init_properties_SerializersCache_kt__hgwi2p();
    var tmp;
    if (!isNullable) {
      var tmp0_safe_receiver = get_SERIALIZERS_CACHE().g5a(clazz);
      var tmp_0;
      if (tmp0_safe_receiver == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlinx.serialization.internal.cast' call
        tmp_0 = isInterface(tmp0_safe_receiver, KSerializer) ? tmp0_safe_receiver : THROW_CCE();
      }
      tmp = tmp_0;
    } else {
      tmp = get_SERIALIZERS_CACHE_NULLABLE().g5a(clazz);
    }
    return tmp;
  }
  function findParametrizedCachedSerializer(clazz, types, isNullable) {
    _init_properties_SerializersCache_kt__hgwi2p();
    var tmp;
    if (!isNullable) {
      var tmp_0 = get_PARAMETRIZED_SERIALIZERS_CACHE().h5a(clazz, types);
      tmp = new Result(tmp_0) instanceof Result ? tmp_0 : THROW_CCE();
    } else {
      tmp = get_PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE().h5a(clazz, types);
    }
    return tmp;
  }
  function SERIALIZERS_CACHE$lambda(it) {
    _init_properties_SerializersCache_kt__hgwi2p();
    return serializerOrNull(it);
  }
  function SERIALIZERS_CACHE_NULLABLE$lambda(it) {
    _init_properties_SerializersCache_kt__hgwi2p();
    var tmp0_safe_receiver = serializerOrNull(it);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : get_nullable(tmp0_safe_receiver);
    var tmp;
    if (tmp1_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlinx.serialization.internal.cast' call
      tmp = isInterface(tmp1_safe_receiver, KSerializer) ? tmp1_safe_receiver : THROW_CCE();
    }
    return tmp;
  }
  function PARAMETRIZED_SERIALIZERS_CACHE$lambda(clazz, types) {
    _init_properties_SerializersCache_kt__hgwi2p();
    var serializers = ensureNotNull(serializersForParameters(EmptySerializersModule_0(), types, true));
    return parametrizedSerializerOrNull(clazz, serializers, PARAMETRIZED_SERIALIZERS_CACHE$lambda$lambda(types));
  }
  function PARAMETRIZED_SERIALIZERS_CACHE$lambda$lambda($types) {
    return function () {
      return $types.r(0).fb();
    };
  }
  function PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE$lambda(clazz, types) {
    _init_properties_SerializersCache_kt__hgwi2p();
    var serializers = ensureNotNull(serializersForParameters(EmptySerializersModule_0(), types, true));
    var tmp0_safe_receiver = parametrizedSerializerOrNull(clazz, serializers, PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE$lambda$lambda(types));
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : get_nullable(tmp0_safe_receiver);
    var tmp;
    if (tmp1_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlinx.serialization.internal.cast' call
      tmp = isInterface(tmp1_safe_receiver, KSerializer) ? tmp1_safe_receiver : THROW_CCE();
    }
    return tmp;
  }
  function PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE$lambda$lambda($types) {
    return function () {
      return $types.r(0).fb();
    };
  }
  var properties_initialized_SerializersCache_kt_q8kf25;
  function _init_properties_SerializersCache_kt__hgwi2p() {
    if (!properties_initialized_SerializersCache_kt_q8kf25) {
      properties_initialized_SerializersCache_kt_q8kf25 = true;
      SERIALIZERS_CACHE = createCache(SERIALIZERS_CACHE$lambda);
      SERIALIZERS_CACHE_NULLABLE = createCache(SERIALIZERS_CACHE_NULLABLE$lambda);
      PARAMETRIZED_SERIALIZERS_CACHE = createParametrizedCache(PARAMETRIZED_SERIALIZERS_CACHE$lambda);
      PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE = createParametrizedCache(PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE$lambda);
    }
  }
  function serializer_3(_this__u8e3s4) {
    return UnitSerializer_getInstance();
  }
  function get_nullable(_this__u8e3s4) {
    var tmp;
    if (_this__u8e3s4.v58().i5a()) {
      tmp = isInterface(_this__u8e3s4, KSerializer) ? _this__u8e3s4 : THROW_CCE();
    } else {
      tmp = new NullableSerializer(_this__u8e3s4);
    }
    return tmp;
  }
  function PairSerializer(keySerializer, valueSerializer) {
    return new PairSerializer_0(keySerializer, valueSerializer);
  }
  function serializer_4(_this__u8e3s4) {
    return BooleanSerializer_getInstance();
  }
  function TripleSerializer(aSerializer, bSerializer, cSerializer) {
    return new TripleSerializer_0(aSerializer, bSerializer, cSerializer);
  }
  function ListSerializer(elementSerializer) {
    return new ArrayListSerializer(elementSerializer);
  }
  function serializer_5(_this__u8e3s4) {
    return StringSerializer_getInstance();
  }
  function SetSerializer(elementSerializer) {
    return new LinkedHashSetSerializer(elementSerializer);
  }
  function MapSerializer(keySerializer, valueSerializer) {
    return new LinkedHashMapSerializer(keySerializer, valueSerializer);
  }
  function ByteArraySerializer() {
    return ByteArraySerializer_getInstance();
  }
  function MapEntrySerializer(keySerializer, valueSerializer) {
    return new MapEntrySerializer_0(keySerializer, valueSerializer);
  }
  function serializer_6(_this__u8e3s4) {
    return ULongSerializer_getInstance();
  }
  function serializer_7(_this__u8e3s4) {
    return UIntSerializer_getInstance();
  }
  function serializer_8(_this__u8e3s4) {
    return UByteSerializer_getInstance();
  }
  function serializer_9(_this__u8e3s4) {
    return UShortSerializer_getInstance();
  }
  function ArraySerializer(kClass, elementSerializer) {
    return new ReferenceArraySerializer(kClass, elementSerializer);
  }
  function serializer_10(_this__u8e3s4) {
    return ByteSerializer_getInstance();
  }
  function serializer_11(_this__u8e3s4) {
    return CharSerializer_getInstance();
  }
  function CharArraySerializer() {
    return CharArraySerializer_getInstance();
  }
  function serializer_12(_this__u8e3s4) {
    return DoubleSerializer_getInstance();
  }
  function DoubleArraySerializer() {
    return DoubleArraySerializer_getInstance();
  }
  function serializer_13(_this__u8e3s4) {
    return FloatSerializer_getInstance();
  }
  function FloatArraySerializer() {
    return FloatArraySerializer_getInstance();
  }
  function serializer_14(_this__u8e3s4) {
    return LongSerializer_getInstance();
  }
  function LongArraySerializer() {
    return LongArraySerializer_getInstance();
  }
  function ULongArraySerializer() {
    return ULongArraySerializer_getInstance();
  }
  function serializer_15(_this__u8e3s4) {
    return IntSerializer_getInstance();
  }
  function IntArraySerializer() {
    return IntArraySerializer_getInstance();
  }
  function UIntArraySerializer() {
    return UIntArraySerializer_getInstance();
  }
  function serializer_16(_this__u8e3s4) {
    return ShortSerializer_getInstance();
  }
  function ShortArraySerializer() {
    return ShortArraySerializer_getInstance();
  }
  function UShortArraySerializer() {
    return UShortArraySerializer_getInstance();
  }
  function UByteArraySerializer() {
    return UByteArraySerializer_getInstance();
  }
  function BooleanArraySerializer() {
    return BooleanArraySerializer_getInstance();
  }
  function NothingSerializer() {
    return NothingSerializer_getInstance();
  }
  function serializer_17(_this__u8e3s4) {
    return DurationSerializer_getInstance();
  }
  function getContextualDescriptor(_this__u8e3s4, descriptor) {
    var tmp0_safe_receiver = get_capturedKClass(descriptor);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      var tmp0_safe_receiver_0 = _this__u8e3s4.f5a(tmp0_safe_receiver);
      tmp = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.v58();
    }
    return tmp;
  }
  function withContext_0(_this__u8e3s4, context) {
    return new ContextDescriptor(_this__u8e3s4, context);
  }
  function get_capturedKClass(_this__u8e3s4) {
    var tmp;
    if (_this__u8e3s4 instanceof ContextDescriptor) {
      tmp = _this__u8e3s4.n5a_1;
    } else {
      if (_this__u8e3s4 instanceof SerialDescriptorForNullable) {
        tmp = get_capturedKClass(_this__u8e3s4.j5a_1);
      } else {
        tmp = null;
      }
    }
    return tmp;
  }
  function ContextDescriptor(original, kClass) {
    this.m5a_1 = original;
    this.n5a_1 = kClass;
    this.o5a_1 = this.m5a_1.z59() + '<' + this.n5a_1.ra() + '>';
  }
  protoOf(ContextDescriptor).w58 = function () {
    return this.m5a_1.w58();
  };
  protoOf(ContextDescriptor).p5a = function () {
    return this.m5a_1.p5a();
  };
  protoOf(ContextDescriptor).q5a = function () {
    return this.m5a_1.q5a();
  };
  protoOf(ContextDescriptor).i5a = function () {
    return this.m5a_1.i5a();
  };
  protoOf(ContextDescriptor).r5a = function () {
    return this.m5a_1.r5a();
  };
  protoOf(ContextDescriptor).s5a = function (index) {
    return this.m5a_1.s5a(index);
  };
  protoOf(ContextDescriptor).t5a = function (index) {
    return this.m5a_1.t5a(index);
  };
  protoOf(ContextDescriptor).u5a = function (name) {
    return this.m5a_1.u5a(name);
  };
  protoOf(ContextDescriptor).v5a = function (index) {
    return this.m5a_1.v5a(index);
  };
  protoOf(ContextDescriptor).w5a = function (index) {
    return this.m5a_1.w5a(index);
  };
  protoOf(ContextDescriptor).z59 = function () {
    return this.o5a_1;
  };
  protoOf(ContextDescriptor).equals = function (other) {
    var tmp0_elvis_lhs = other instanceof ContextDescriptor ? other : null;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var another = tmp;
    return equals(this.m5a_1, another.m5a_1) && another.n5a_1.equals(this.n5a_1);
  };
  protoOf(ContextDescriptor).hashCode = function () {
    var result = this.n5a_1.hashCode();
    result = imul(31, result) + getStringHashCode(this.o5a_1) | 0;
    return result;
  };
  protoOf(ContextDescriptor).toString = function () {
    return 'ContextDescriptor(kClass: ' + toString_1(this.n5a_1) + ', original: ' + toString_1(this.m5a_1) + ')';
  };
  function SerialDescriptor() {
  }
  function get_elementNames(_this__u8e3s4) {
    // Inline function 'kotlin.collections.Iterable' call
    return new elementNames$$inlined$Iterable$1(_this__u8e3s4);
  }
  function get_elementDescriptors(_this__u8e3s4) {
    // Inline function 'kotlin.collections.Iterable' call
    return new elementDescriptors$$inlined$Iterable$1(_this__u8e3s4);
  }
  function elementNames$1($this_elementNames) {
    this.y5a_1 = $this_elementNames;
    this.x5a_1 = $this_elementNames.p5a();
  }
  protoOf(elementNames$1).n = function () {
    return this.x5a_1 > 0;
  };
  protoOf(elementNames$1).o = function () {
    var tmp = this.y5a_1.p5a();
    var tmp1 = this.x5a_1;
    this.x5a_1 = tmp1 - 1 | 0;
    return this.y5a_1.v5a(tmp - tmp1 | 0);
  };
  function elementNames$$inlined$Iterable$1($this_elementNames) {
    this.z5a_1 = $this_elementNames;
  }
  protoOf(elementNames$$inlined$Iterable$1).m = function () {
    return new elementNames$1(this.z5a_1);
  };
  function elementDescriptors$1($this_elementDescriptors) {
    this.b5b_1 = $this_elementDescriptors;
    this.a5b_1 = $this_elementDescriptors.p5a();
  }
  protoOf(elementDescriptors$1).n = function () {
    return this.a5b_1 > 0;
  };
  protoOf(elementDescriptors$1).o = function () {
    var tmp = this.b5b_1.p5a();
    var tmp1 = this.a5b_1;
    this.a5b_1 = tmp1 - 1 | 0;
    return this.b5b_1.t5a(tmp - tmp1 | 0);
  };
  function elementDescriptors$$inlined$Iterable$1($this_elementDescriptors) {
    this.c5b_1 = $this_elementDescriptors;
  }
  protoOf(elementDescriptors$$inlined$Iterable$1).m = function () {
    return new elementDescriptors$1(this.c5b_1);
  };
  function PrimitiveSerialDescriptor(serialName, kind) {
    // Inline function 'kotlin.text.isNotBlank' call
    // Inline function 'kotlin.require' call
    if (!!isBlank(serialName)) {
      var message = 'Blank serial names are prohibited';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    return PrimitiveDescriptorSafe(serialName, kind);
  }
  function buildSerialDescriptor(serialName, kind, typeParameters, builder) {
    var tmp;
    if (builder === VOID) {
      tmp = buildSerialDescriptor$lambda;
    } else {
      tmp = builder;
    }
    builder = tmp;
    // Inline function 'kotlin.text.isNotBlank' call
    // Inline function 'kotlin.require' call
    if (!!isBlank(serialName)) {
      var message = 'Blank serial names are prohibited';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    // Inline function 'kotlin.require' call
    if (!!equals(kind, CLASS_getInstance())) {
      var message_0 = "For StructureKind.CLASS please use 'buildClassSerialDescriptor' instead";
      throw IllegalArgumentException_init_$Create$_0(toString_1(message_0));
    }
    var sdBuilder = new ClassSerialDescriptorBuilder(serialName);
    builder(sdBuilder);
    return new SerialDescriptorImpl(serialName, kind, sdBuilder.a59_1.p(), toList(typeParameters), sdBuilder);
  }
  function ClassSerialDescriptorBuilder(serialName) {
    this.x58_1 = serialName;
    this.y58_1 = false;
    this.z58_1 = emptyList();
    this.a59_1 = ArrayList_init_$Create$();
    this.b59_1 = HashSet_init_$Create$();
    this.c59_1 = ArrayList_init_$Create$();
    this.d59_1 = ArrayList_init_$Create$();
    this.e59_1 = ArrayList_init_$Create$();
  }
  protoOf(ClassSerialDescriptorBuilder).d5b = function (elementName, descriptor, annotations, isOptional) {
    // Inline function 'kotlin.require' call
    if (!this.b59_1.j(elementName)) {
      var message = "Element with name '" + elementName + "' is already registered in " + this.x58_1;
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    // Inline function 'kotlin.collections.plusAssign' call
    this.a59_1.j(elementName);
    // Inline function 'kotlin.collections.plusAssign' call
    this.c59_1.j(descriptor);
    // Inline function 'kotlin.collections.plusAssign' call
    this.d59_1.j(annotations);
    // Inline function 'kotlin.collections.plusAssign' call
    this.e59_1.j(isOptional);
  };
  protoOf(ClassSerialDescriptorBuilder).o59 = function (elementName, descriptor, annotations, isOptional, $super) {
    annotations = annotations === VOID ? emptyList() : annotations;
    isOptional = isOptional === VOID ? false : isOptional;
    var tmp;
    if ($super === VOID) {
      this.d5b(elementName, descriptor, annotations, isOptional);
      tmp = Unit_instance;
    } else {
      tmp = $super.d5b.call(this, elementName, descriptor, annotations, isOptional);
    }
    return tmp;
  };
  function _get__hashCode__tgwhef($this) {
    var tmp0 = $this.p5b_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('_hashCode', 1, tmp, SerialDescriptorImpl$_get__hashCode_$ref_2v7wzp(), null);
    return tmp0.a1();
  }
  function SerialDescriptorImpl$_hashCode$delegate$lambda(this$0) {
    return function () {
      return hashCodeImpl(this$0, this$0.o5b_1);
    };
  }
  function SerialDescriptorImpl$_get__hashCode_$ref_2v7wzp() {
    return function (p0) {
      return _get__hashCode__tgwhef(p0);
    };
  }
  function SerialDescriptorImpl$toString$lambda(this$0) {
    return function (it) {
      return this$0.v5a(it) + ': ' + this$0.t5a(it).z59();
    };
  }
  function SerialDescriptorImpl(serialName, kind, elementsCount, typeParameters, builder) {
    this.e5b_1 = serialName;
    this.f5b_1 = kind;
    this.g5b_1 = elementsCount;
    this.h5b_1 = builder.z58_1;
    this.i5b_1 = toHashSet(builder.a59_1);
    var tmp = this;
    // Inline function 'kotlin.collections.toTypedArray' call
    var this_0 = builder.a59_1;
    tmp.j5b_1 = copyToArray(this_0);
    this.k5b_1 = compactArray(builder.c59_1);
    var tmp_0 = this;
    // Inline function 'kotlin.collections.toTypedArray' call
    var this_1 = builder.d59_1;
    tmp_0.l5b_1 = copyToArray(this_1);
    this.m5b_1 = toBooleanArray(builder.e59_1);
    var tmp_1 = this;
    // Inline function 'kotlin.collections.map' call
    var this_2 = withIndex(this.j5b_1);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_2, 10));
    var _iterator__ex2g4s = this_2.m();
    while (_iterator__ex2g4s.n()) {
      var item = _iterator__ex2g4s.o();
      var tmp$ret$2 = to(item.eg_1, item.dg_1);
      destination.j(tmp$ret$2);
    }
    tmp_1.n5b_1 = toMap_0(destination);
    this.o5b_1 = compactArray(typeParameters);
    var tmp_2 = this;
    tmp_2.p5b_1 = lazy(SerialDescriptorImpl$_hashCode$delegate$lambda(this));
  }
  protoOf(SerialDescriptorImpl).z59 = function () {
    return this.e5b_1;
  };
  protoOf(SerialDescriptorImpl).r5a = function () {
    return this.f5b_1;
  };
  protoOf(SerialDescriptorImpl).p5a = function () {
    return this.g5b_1;
  };
  protoOf(SerialDescriptorImpl).w58 = function () {
    return this.h5b_1;
  };
  protoOf(SerialDescriptorImpl).q5b = function () {
    return this.i5b_1;
  };
  protoOf(SerialDescriptorImpl).v5a = function (index) {
    return getChecked(this.j5b_1, index);
  };
  protoOf(SerialDescriptorImpl).u5a = function (name) {
    var tmp0_elvis_lhs = this.n5b_1.q2(name);
    return tmp0_elvis_lhs == null ? -3 : tmp0_elvis_lhs;
  };
  protoOf(SerialDescriptorImpl).s5a = function (index) {
    return getChecked(this.l5b_1, index);
  };
  protoOf(SerialDescriptorImpl).t5a = function (index) {
    return getChecked(this.k5b_1, index);
  };
  protoOf(SerialDescriptorImpl).w5a = function (index) {
    return getChecked_0(this.m5b_1, index);
  };
  protoOf(SerialDescriptorImpl).equals = function (other) {
    var tmp$ret$0;
    $l$block_5: {
      // Inline function 'kotlinx.serialization.internal.equalsImpl' call
      if (this === other) {
        tmp$ret$0 = true;
        break $l$block_5;
      }
      if (!(other instanceof SerialDescriptorImpl)) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      if (!(this.z59() === other.z59())) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      if (!contentEquals_0(this.o5b_1, other.o5b_1)) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      if (!(this.p5a() === other.p5a())) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      var inductionVariable = 0;
      var last = this.p5a();
      if (inductionVariable < last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          if (!(this.t5a(index).z59() === other.t5a(index).z59())) {
            tmp$ret$0 = false;
            break $l$block_5;
          }
          if (!equals(this.t5a(index).r5a(), other.t5a(index).r5a())) {
            tmp$ret$0 = false;
            break $l$block_5;
          }
        }
         while (inductionVariable < last);
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  };
  protoOf(SerialDescriptorImpl).hashCode = function () {
    return _get__hashCode__tgwhef(this);
  };
  protoOf(SerialDescriptorImpl).toString = function () {
    var tmp = until(0, this.g5b_1);
    var tmp_0 = this.e5b_1 + '(';
    return joinToString_0(tmp, ', ', tmp_0, ')', VOID, VOID, SerialDescriptorImpl$toString$lambda(this));
  };
  function buildClassSerialDescriptor(serialName, typeParameters, builderAction) {
    var tmp;
    if (builderAction === VOID) {
      tmp = buildClassSerialDescriptor$lambda;
    } else {
      tmp = builderAction;
    }
    builderAction = tmp;
    // Inline function 'kotlin.text.isNotBlank' call
    // Inline function 'kotlin.require' call
    if (!!isBlank(serialName)) {
      var message = 'Blank serial names are prohibited';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    var sdBuilder = new ClassSerialDescriptorBuilder(serialName);
    builderAction(sdBuilder);
    return new SerialDescriptorImpl(serialName, CLASS_getInstance(), sdBuilder.a59_1.p(), toList(typeParameters), sdBuilder);
  }
  function buildSerialDescriptor$lambda($this$null) {
    return Unit_instance;
  }
  function buildClassSerialDescriptor$lambda($this$null) {
    return Unit_instance;
  }
  function BOOLEAN() {
    BOOLEAN_instance = this;
    PrimitiveKind.call(this);
  }
  var BOOLEAN_instance;
  function BOOLEAN_getInstance() {
    if (BOOLEAN_instance == null)
      new BOOLEAN();
    return BOOLEAN_instance;
  }
  function BYTE() {
    BYTE_instance = this;
    PrimitiveKind.call(this);
  }
  var BYTE_instance;
  function BYTE_getInstance() {
    if (BYTE_instance == null)
      new BYTE();
    return BYTE_instance;
  }
  function CHAR() {
    CHAR_instance = this;
    PrimitiveKind.call(this);
  }
  var CHAR_instance;
  function CHAR_getInstance() {
    if (CHAR_instance == null)
      new CHAR();
    return CHAR_instance;
  }
  function SHORT() {
    SHORT_instance = this;
    PrimitiveKind.call(this);
  }
  var SHORT_instance;
  function SHORT_getInstance() {
    if (SHORT_instance == null)
      new SHORT();
    return SHORT_instance;
  }
  function INT() {
    INT_instance = this;
    PrimitiveKind.call(this);
  }
  var INT_instance;
  function INT_getInstance() {
    if (INT_instance == null)
      new INT();
    return INT_instance;
  }
  function LONG() {
    LONG_instance = this;
    PrimitiveKind.call(this);
  }
  var LONG_instance;
  function LONG_getInstance() {
    if (LONG_instance == null)
      new LONG();
    return LONG_instance;
  }
  function FLOAT() {
    FLOAT_instance = this;
    PrimitiveKind.call(this);
  }
  var FLOAT_instance;
  function FLOAT_getInstance() {
    if (FLOAT_instance == null)
      new FLOAT();
    return FLOAT_instance;
  }
  function DOUBLE() {
    DOUBLE_instance = this;
    PrimitiveKind.call(this);
  }
  var DOUBLE_instance;
  function DOUBLE_getInstance() {
    if (DOUBLE_instance == null)
      new DOUBLE();
    return DOUBLE_instance;
  }
  function STRING() {
    STRING_instance = this;
    PrimitiveKind.call(this);
  }
  var STRING_instance;
  function STRING_getInstance() {
    if (STRING_instance == null)
      new STRING();
    return STRING_instance;
  }
  function PrimitiveKind() {
    SerialKind.call(this);
  }
  function ENUM() {
    ENUM_instance = this;
    SerialKind.call(this);
  }
  var ENUM_instance;
  function ENUM_getInstance() {
    if (ENUM_instance == null)
      new ENUM();
    return ENUM_instance;
  }
  function CONTEXTUAL() {
    CONTEXTUAL_instance = this;
    SerialKind.call(this);
  }
  var CONTEXTUAL_instance;
  function CONTEXTUAL_getInstance() {
    if (CONTEXTUAL_instance == null)
      new CONTEXTUAL();
    return CONTEXTUAL_instance;
  }
  function SerialKind() {
  }
  protoOf(SerialKind).toString = function () {
    return ensureNotNull(getKClassFromExpression(this).ra());
  };
  protoOf(SerialKind).hashCode = function () {
    return getStringHashCode(this.toString());
  };
  function CLASS() {
    CLASS_instance = this;
    StructureKind.call(this);
  }
  var CLASS_instance;
  function CLASS_getInstance() {
    if (CLASS_instance == null)
      new CLASS();
    return CLASS_instance;
  }
  function LIST() {
    LIST_instance = this;
    StructureKind.call(this);
  }
  var LIST_instance;
  function LIST_getInstance() {
    if (LIST_instance == null)
      new LIST();
    return LIST_instance;
  }
  function MAP() {
    MAP_instance = this;
    StructureKind.call(this);
  }
  var MAP_instance;
  function MAP_getInstance() {
    if (MAP_instance == null)
      new MAP();
    return MAP_instance;
  }
  function OBJECT() {
    OBJECT_instance = this;
    StructureKind.call(this);
  }
  var OBJECT_instance;
  function OBJECT_getInstance() {
    if (OBJECT_instance == null)
      new OBJECT();
    return OBJECT_instance;
  }
  function StructureKind() {
    SerialKind.call(this);
  }
  function SEALED_0() {
    SEALED_instance = this;
    PolymorphicKind.call(this);
  }
  var SEALED_instance;
  function SEALED_getInstance() {
    if (SEALED_instance == null)
      new SEALED_0();
    return SEALED_instance;
  }
  function OPEN() {
    OPEN_instance = this;
    PolymorphicKind.call(this);
  }
  var OPEN_instance;
  function OPEN_getInstance() {
    if (OPEN_instance == null)
      new OPEN();
    return OPEN_instance;
  }
  function PolymorphicKind() {
    SerialKind.call(this);
  }
  function AbstractDecoder() {
  }
  protoOf(AbstractDecoder).r5b = function () {
    throw SerializationException_init_$Create$_0(toString_1(getKClassFromExpression(this)) + " can't retrieve untyped values");
  };
  protoOf(AbstractDecoder).s5b = function () {
    return true;
  };
  protoOf(AbstractDecoder).t5b = function () {
    return null;
  };
  protoOf(AbstractDecoder).u5b = function () {
    var tmp = this.r5b();
    return typeof tmp === 'boolean' ? tmp : THROW_CCE();
  };
  protoOf(AbstractDecoder).v5b = function () {
    var tmp = this.r5b();
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  protoOf(AbstractDecoder).w5b = function () {
    var tmp = this.r5b();
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  protoOf(AbstractDecoder).x5b = function () {
    var tmp = this.r5b();
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  protoOf(AbstractDecoder).y5b = function () {
    var tmp = this.r5b();
    return typeof tmp === 'bigint' ? tmp : THROW_CCE();
  };
  protoOf(AbstractDecoder).z5b = function () {
    var tmp = this.r5b();
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  protoOf(AbstractDecoder).a5c = function () {
    var tmp = this.r5b();
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  protoOf(AbstractDecoder).b5c = function () {
    var tmp = this.r5b();
    return tmp instanceof Char ? tmp.s1_1 : THROW_CCE();
  };
  protoOf(AbstractDecoder).c5c = function () {
    var tmp = this.r5b();
    return typeof tmp === 'string' ? tmp : THROW_CCE();
  };
  protoOf(AbstractDecoder).d5c = function (enumDescriptor) {
    var tmp = this.r5b();
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  protoOf(AbstractDecoder).e5c = function (descriptor) {
    return this;
  };
  protoOf(AbstractDecoder).f5c = function (deserializer, previousValue) {
    return this.k59(deserializer);
  };
  protoOf(AbstractDecoder).g5c = function (descriptor) {
    return this;
  };
  protoOf(AbstractDecoder).h5c = function (descriptor) {
  };
  protoOf(AbstractDecoder).i5c = function (descriptor, index) {
    return this.u5b();
  };
  protoOf(AbstractDecoder).j5c = function (descriptor, index) {
    return this.v5b();
  };
  protoOf(AbstractDecoder).k5c = function (descriptor, index) {
    return this.w5b();
  };
  protoOf(AbstractDecoder).l5c = function (descriptor, index) {
    return this.x5b();
  };
  protoOf(AbstractDecoder).m5c = function (descriptor, index) {
    return this.y5b();
  };
  protoOf(AbstractDecoder).n5c = function (descriptor, index) {
    return this.z5b();
  };
  protoOf(AbstractDecoder).o5c = function (descriptor, index) {
    return this.a5c();
  };
  protoOf(AbstractDecoder).p5c = function (descriptor, index) {
    return this.b5c();
  };
  protoOf(AbstractDecoder).q5c = function (descriptor, index) {
    return this.c5c();
  };
  protoOf(AbstractDecoder).r5c = function (descriptor, index) {
    return this.e5c(descriptor.t5a(index));
  };
  protoOf(AbstractDecoder).s5c = function (descriptor, index, deserializer, previousValue) {
    return this.f5c(deserializer, previousValue);
  };
  protoOf(AbstractDecoder).u5c = function (descriptor, index, deserializer, previousValue) {
    var isNullabilitySupported = deserializer.v58().i5a();
    return isNullabilitySupported || this.s5b() ? this.f5c(deserializer, previousValue) : this.t5b();
  };
  function AbstractEncoder() {
  }
  protoOf(AbstractEncoder).g5c = function (descriptor) {
    return this;
  };
  protoOf(AbstractEncoder).h5c = function (descriptor) {
  };
  protoOf(AbstractEncoder).y5c = function (descriptor, index) {
    return true;
  };
  protoOf(AbstractEncoder).z5c = function (value) {
    throw SerializationException_init_$Create$_0('Non-serializable ' + toString_1(getKClassFromExpression(value)) + ' is not supported by ' + toString_1(getKClassFromExpression(this)) + ' encoder');
  };
  protoOf(AbstractEncoder).a5d = function () {
    throw SerializationException_init_$Create$_0("'null' is not supported by default");
  };
  protoOf(AbstractEncoder).b5d = function (value) {
    return this.z5c(value);
  };
  protoOf(AbstractEncoder).c5d = function (value) {
    return this.z5c(value);
  };
  protoOf(AbstractEncoder).d5d = function (value) {
    return this.z5c(value);
  };
  protoOf(AbstractEncoder).e5d = function (value) {
    return this.z5c(value);
  };
  protoOf(AbstractEncoder).f5d = function (value) {
    return this.z5c(value);
  };
  protoOf(AbstractEncoder).g5d = function (value) {
    return this.z5c(value);
  };
  protoOf(AbstractEncoder).h5d = function (value) {
    return this.z5c(value);
  };
  protoOf(AbstractEncoder).i5d = function (value) {
    return this.z5c(new Char(value));
  };
  protoOf(AbstractEncoder).j5d = function (value) {
    return this.z5c(value);
  };
  protoOf(AbstractEncoder).k5d = function (enumDescriptor, index) {
    return this.z5c(index);
  };
  protoOf(AbstractEncoder).l5d = function (descriptor) {
    return this;
  };
  protoOf(AbstractEncoder).m5d = function (descriptor, index, value) {
    if (this.y5c(descriptor, index)) {
      this.b5d(value);
    }
  };
  protoOf(AbstractEncoder).n5d = function (descriptor, index, value) {
    if (this.y5c(descriptor, index)) {
      this.c5d(value);
    }
  };
  protoOf(AbstractEncoder).o5d = function (descriptor, index, value) {
    if (this.y5c(descriptor, index)) {
      this.d5d(value);
    }
  };
  protoOf(AbstractEncoder).p5d = function (descriptor, index, value) {
    if (this.y5c(descriptor, index)) {
      this.e5d(value);
    }
  };
  protoOf(AbstractEncoder).q5d = function (descriptor, index, value) {
    if (this.y5c(descriptor, index)) {
      this.f5d(value);
    }
  };
  protoOf(AbstractEncoder).r5d = function (descriptor, index, value) {
    if (this.y5c(descriptor, index)) {
      this.g5d(value);
    }
  };
  protoOf(AbstractEncoder).s5d = function (descriptor, index, value) {
    if (this.y5c(descriptor, index)) {
      this.h5d(value);
    }
  };
  protoOf(AbstractEncoder).t5d = function (descriptor, index, value) {
    if (this.y5c(descriptor, index)) {
      this.i5d(value);
    }
  };
  protoOf(AbstractEncoder).u5d = function (descriptor, index, value) {
    if (this.y5c(descriptor, index)) {
      this.j5d(value);
    }
  };
  protoOf(AbstractEncoder).v5d = function (descriptor, index) {
    return this.y5c(descriptor, index) ? this.l5d(descriptor.t5a(index)) : NoOpEncoder_getInstance();
  };
  protoOf(AbstractEncoder).w5d = function (descriptor, index, serializer, value) {
    if (this.y5c(descriptor, index)) {
      this.h59(serializer, value);
    }
  };
  protoOf(AbstractEncoder).x5d = function (descriptor, index, serializer, value) {
    if (this.y5c(descriptor, index)) {
      this.y5d(serializer, value);
    }
  };
  function Decoder() {
  }
  function CompositeDecoder() {
  }
  function Encoder() {
  }
  function CompositeEncoder() {
  }
  function decodeSequentially_0($this, compositeDecoder) {
    var klassName = compositeDecoder.q5c($this.v58(), 0);
    var serializer = findPolymorphicSerializer_0($this, compositeDecoder, klassName);
    return compositeDecoder.t5c($this.v58(), 1, serializer);
  }
  function AbstractPolymorphicSerializer() {
  }
  protoOf(AbstractPolymorphicSerializer).f59 = function (encoder, value) {
    var actualSerializer = findPolymorphicSerializer(this, encoder, value);
    // Inline function 'kotlinx.serialization.encoding.encodeStructure' call
    var descriptor = this.v58();
    var composite = encoder.g5c(descriptor);
    composite.u5d(this.v58(), 0, actualSerializer.v58().z59());
    var tmp = this.v58();
    // Inline function 'kotlinx.serialization.internal.cast' call
    var tmp$ret$0 = isInterface(actualSerializer, SerializationStrategy) ? actualSerializer : THROW_CCE();
    composite.w5d(tmp, 1, tmp$ret$0, value);
    composite.h5c(descriptor);
  };
  protoOf(AbstractPolymorphicSerializer).i59 = function (encoder, value) {
    return this.f59(encoder, !(value == null) ? value : THROW_CCE());
  };
  protoOf(AbstractPolymorphicSerializer).j59 = function (decoder) {
    // Inline function 'kotlinx.serialization.encoding.decodeStructure' call
    var descriptor = this.v58();
    var composite = decoder.g5c(descriptor);
    var tmp$ret$0;
    $l$block: {
      var klassName = null;
      var value = null;
      if (composite.v5c()) {
        tmp$ret$0 = decodeSequentially_0(this, composite);
        break $l$block;
      }
      mainLoop: while (true) {
        var index = composite.w5c(this.v58());
        switch (index) {
          case -1:
            break mainLoop;
          case 0:
            klassName = composite.q5c(this.v58(), index);
            break;
          case 1:
            var tmp0 = klassName;
            var tmp$ret$2;
            $l$block_0: {
              // Inline function 'kotlin.requireNotNull' call
              if (tmp0 == null) {
                var message = 'Cannot read polymorphic value before its type token';
                throw IllegalArgumentException_init_$Create$_0(toString_1(message));
              } else {
                tmp$ret$2 = tmp0;
                break $l$block_0;
              }
            }

            klassName = tmp$ret$2;
            var serializer = findPolymorphicSerializer_0(this, composite, klassName);
            value = composite.t5c(this.v58(), index, serializer);
            break;
          default:
            var tmp0_elvis_lhs = klassName;
            throw SerializationException_init_$Create$_0('Invalid index in polymorphic deserialization of ' + (tmp0_elvis_lhs == null ? 'unknown class' : tmp0_elvis_lhs) + ('\n Expected 0, 1 or DECODE_DONE(-1), but found ' + index));
        }
      }
      var tmp0_0 = value;
      var tmp$ret$4;
      $l$block_1: {
        // Inline function 'kotlin.requireNotNull' call
        if (tmp0_0 == null) {
          var message_0 = 'Polymorphic value has not been read for class ' + klassName;
          throw IllegalArgumentException_init_$Create$_0(toString_1(message_0));
        } else {
          tmp$ret$4 = tmp0_0;
          break $l$block_1;
        }
      }
      var tmp = tmp$ret$4;
      tmp$ret$0 = !(tmp == null) ? tmp : THROW_CCE();
    }
    var result = tmp$ret$0;
    composite.h5c(descriptor);
    return result;
  };
  protoOf(AbstractPolymorphicSerializer).q59 = function (decoder, klassName) {
    return decoder.g59().c5e(this.p59(), klassName);
  };
  protoOf(AbstractPolymorphicSerializer).r59 = function (encoder, value) {
    return encoder.g59().d5e(this.p59(), value);
  };
  function throwSubtypeNotRegistered(subClass, baseClass) {
    var tmp0_elvis_lhs = subClass.ra();
    throwSubtypeNotRegistered_0(tmp0_elvis_lhs == null ? toString_1(subClass) : tmp0_elvis_lhs, baseClass);
  }
  function throwSubtypeNotRegistered_0(subClassName, baseClass) {
    var scope = "in the scope of '" + baseClass.ra() + "'";
    throw SerializationException_init_$Create$_0(subClassName == null ? 'Class discriminator was missing and no default polymorphic serializers were registered ' + scope : "Class '" + subClassName + "' is not registered for polymorphic serialization " + scope + '.\n' + ("To be registered automatically, class '" + subClassName + "' has to be '@Serializable', and the base class '" + baseClass.ra() + "' has to be sealed and '@Serializable'.\n") + ("Alternatively, register the serializer for '" + subClassName + "' explicitly in a corresponding SerializersModule."));
  }
  function NothingSerializer_0() {
    NothingSerializer_instance = this;
    this.e5e_1 = NothingSerialDescriptor_getInstance();
  }
  protoOf(NothingSerializer_0).v58 = function () {
    return this.e5e_1;
  };
  protoOf(NothingSerializer_0).f5e = function (encoder, value) {
    throw SerializationException_init_$Create$_0("'kotlin.Nothing' cannot be serialized");
  };
  protoOf(NothingSerializer_0).i59 = function (encoder, value) {
    var tmp;
    if (false) {
      tmp = value;
    } else {
      tmp = THROW_CCE();
    }
    return this.f5e(encoder, tmp);
  };
  protoOf(NothingSerializer_0).j59 = function (decoder) {
    throw SerializationException_init_$Create$_0("'kotlin.Nothing' does not have instances");
  };
  var NothingSerializer_instance;
  function NothingSerializer_getInstance() {
    if (NothingSerializer_instance == null)
      new NothingSerializer_0();
    return NothingSerializer_instance;
  }
  function DurationSerializer() {
    DurationSerializer_instance = this;
    this.g5e_1 = new PrimitiveSerialDescriptor_0('kotlin.time.Duration', STRING_getInstance());
  }
  protoOf(DurationSerializer).v58 = function () {
    return this.g5e_1;
  };
  protoOf(DurationSerializer).h5e = function (encoder, value) {
    encoder.j5d(Duration__toIsoString_impl_9h6wsm(value));
  };
  protoOf(DurationSerializer).i59 = function (encoder, value) {
    return this.h5e(encoder, value instanceof Duration ? value.pe_1 : THROW_CCE());
  };
  protoOf(DurationSerializer).i5e = function (decoder) {
    return Companion_getInstance_16().bl(decoder.c5c());
  };
  protoOf(DurationSerializer).j59 = function (decoder) {
    return new Duration(this.i5e(decoder));
  };
  var DurationSerializer_instance;
  function DurationSerializer_getInstance() {
    if (DurationSerializer_instance == null)
      new DurationSerializer();
    return DurationSerializer_instance;
  }
  function CachedNames() {
  }
  function ArrayListClassDesc(elementDesc) {
    ListLikeDescriptor.call(this, elementDesc);
  }
  protoOf(ArrayListClassDesc).z59 = function () {
    return 'kotlin.collections.ArrayList';
  };
  function LinkedHashSetClassDesc(elementDesc) {
    ListLikeDescriptor.call(this, elementDesc);
  }
  protoOf(LinkedHashSetClassDesc).z59 = function () {
    return 'kotlin.collections.LinkedHashSet';
  };
  function HashSetClassDesc(elementDesc) {
    ListLikeDescriptor.call(this, elementDesc);
  }
  protoOf(HashSetClassDesc).z59 = function () {
    return 'kotlin.collections.HashSet';
  };
  function HashMapClassDesc(keyDesc, valueDesc) {
    MapLikeDescriptor.call(this, 'kotlin.collections.HashMap', keyDesc, valueDesc);
  }
  function LinkedHashMapClassDesc(keyDesc, valueDesc) {
    MapLikeDescriptor.call(this, 'kotlin.collections.LinkedHashMap', keyDesc, valueDesc);
  }
  function ArrayClassDesc(elementDesc) {
    ListLikeDescriptor.call(this, elementDesc);
  }
  protoOf(ArrayClassDesc).z59 = function () {
    return 'kotlin.Array';
  };
  function ListLikeDescriptor(elementDescriptor) {
    this.l5e_1 = elementDescriptor;
    this.m5e_1 = 1;
  }
  protoOf(ListLikeDescriptor).r5a = function () {
    return LIST_getInstance();
  };
  protoOf(ListLikeDescriptor).p5a = function () {
    return this.m5e_1;
  };
  protoOf(ListLikeDescriptor).v5a = function (index) {
    return index.toString();
  };
  protoOf(ListLikeDescriptor).u5a = function (name) {
    var tmp0_elvis_lhs = toIntOrNull(name);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalArgumentException_init_$Create$_0(name + ' is not a valid list index');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  protoOf(ListLikeDescriptor).w5a = function (index) {
    // Inline function 'kotlin.require' call
    if (!(index >= 0)) {
      var message = 'Illegal index ' + index + ', ' + this.z59() + ' expects only non-negative indices';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    return false;
  };
  protoOf(ListLikeDescriptor).s5a = function (index) {
    // Inline function 'kotlin.require' call
    if (!(index >= 0)) {
      var message = 'Illegal index ' + index + ', ' + this.z59() + ' expects only non-negative indices';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    return emptyList();
  };
  protoOf(ListLikeDescriptor).t5a = function (index) {
    // Inline function 'kotlin.require' call
    if (!(index >= 0)) {
      var message = 'Illegal index ' + index + ', ' + this.z59() + ' expects only non-negative indices';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    return this.l5e_1;
  };
  protoOf(ListLikeDescriptor).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ListLikeDescriptor))
      return false;
    if (equals(this.l5e_1, other.l5e_1) && this.z59() === other.z59())
      return true;
    return false;
  };
  protoOf(ListLikeDescriptor).hashCode = function () {
    return imul(hashCode(this.l5e_1), 31) + getStringHashCode(this.z59()) | 0;
  };
  protoOf(ListLikeDescriptor).toString = function () {
    return this.z59() + '(' + toString_1(this.l5e_1) + ')';
  };
  function MapLikeDescriptor(serialName, keyDescriptor, valueDescriptor) {
    this.r5e_1 = serialName;
    this.s5e_1 = keyDescriptor;
    this.t5e_1 = valueDescriptor;
    this.u5e_1 = 2;
  }
  protoOf(MapLikeDescriptor).z59 = function () {
    return this.r5e_1;
  };
  protoOf(MapLikeDescriptor).r5a = function () {
    return MAP_getInstance();
  };
  protoOf(MapLikeDescriptor).p5a = function () {
    return this.u5e_1;
  };
  protoOf(MapLikeDescriptor).v5a = function (index) {
    return index.toString();
  };
  protoOf(MapLikeDescriptor).u5a = function (name) {
    var tmp0_elvis_lhs = toIntOrNull(name);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalArgumentException_init_$Create$_0(name + ' is not a valid map index');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  protoOf(MapLikeDescriptor).w5a = function (index) {
    // Inline function 'kotlin.require' call
    if (!(index >= 0)) {
      var message = 'Illegal index ' + index + ', ' + this.z59() + ' expects only non-negative indices';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    return false;
  };
  protoOf(MapLikeDescriptor).s5a = function (index) {
    // Inline function 'kotlin.require' call
    if (!(index >= 0)) {
      var message = 'Illegal index ' + index + ', ' + this.z59() + ' expects only non-negative indices';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    return emptyList();
  };
  protoOf(MapLikeDescriptor).t5a = function (index) {
    // Inline function 'kotlin.require' call
    if (!(index >= 0)) {
      var message = 'Illegal index ' + index + ', ' + this.z59() + ' expects only non-negative indices';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    var tmp;
    switch (index % 2 | 0) {
      case 0:
        tmp = this.s5e_1;
        break;
      case 1:
        tmp = this.t5e_1;
        break;
      default:
        var message_0 = 'Unreached';
        throw IllegalStateException_init_$Create$_0(toString_1(message_0));
    }
    return tmp;
  };
  protoOf(MapLikeDescriptor).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof MapLikeDescriptor))
      return false;
    if (!(this.z59() === other.z59()))
      return false;
    if (!equals(this.s5e_1, other.s5e_1))
      return false;
    if (!equals(this.t5e_1, other.t5e_1))
      return false;
    return true;
  };
  protoOf(MapLikeDescriptor).hashCode = function () {
    var result = getStringHashCode(this.z59());
    result = imul(31, result) + hashCode(this.s5e_1) | 0;
    result = imul(31, result) + hashCode(this.t5e_1) | 0;
    return result;
  };
  protoOf(MapLikeDescriptor).toString = function () {
    return this.z59() + '(' + toString_1(this.s5e_1) + ', ' + toString_1(this.t5e_1) + ')';
  };
  function PrimitiveArrayDescriptor(primitive) {
    ListLikeDescriptor.call(this, primitive);
    this.z5e_1 = primitive.z59() + 'Array';
  }
  protoOf(PrimitiveArrayDescriptor).z59 = function () {
    return this.z5e_1;
  };
  function ArrayListSerializer(element) {
    CollectionSerializer.call(this, element);
    this.b5f_1 = new ArrayListClassDesc(element.v58());
  }
  protoOf(ArrayListSerializer).v58 = function () {
    return this.b5f_1;
  };
  protoOf(ArrayListSerializer).c5f = function () {
    // Inline function 'kotlin.collections.arrayListOf' call
    return ArrayList_init_$Create$();
  };
  protoOf(ArrayListSerializer).d5f = function (_this__u8e3s4) {
    return _this__u8e3s4.p();
  };
  protoOf(ArrayListSerializer).e5f = function (_this__u8e3s4) {
    return this.d5f(_this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(ArrayListSerializer).f5f = function (_this__u8e3s4) {
    return _this__u8e3s4;
  };
  protoOf(ArrayListSerializer).g5f = function (_this__u8e3s4) {
    return this.f5f(_this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(ArrayListSerializer).h5f = function (_this__u8e3s4) {
    var tmp0_elvis_lhs = _this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : null;
    return tmp0_elvis_lhs == null ? ArrayList_init_$Create$_1(_this__u8e3s4) : tmp0_elvis_lhs;
  };
  protoOf(ArrayListSerializer).i5f = function (_this__u8e3s4) {
    return this.h5f((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtList) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(ArrayListSerializer).j5f = function (_this__u8e3s4, size) {
    return _this__u8e3s4.o5(size);
  };
  protoOf(ArrayListSerializer).k5f = function (_this__u8e3s4, size) {
    return this.j5f(_this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE(), size);
  };
  protoOf(ArrayListSerializer).l5f = function (_this__u8e3s4, index, element) {
    _this__u8e3s4.m2(index, element);
  };
  protoOf(ArrayListSerializer).m5f = function (_this__u8e3s4, index, element) {
    var tmp = _this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE();
    return this.l5f(tmp, index, (element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  function MapLikeSerializer(keySerializer, valueSerializer) {
    AbstractCollectionSerializer.call(this);
    this.w5f_1 = keySerializer;
    this.x5f_1 = valueSerializer;
  }
  protoOf(MapLikeSerializer).y5f = function (decoder, builder, startIndex, size) {
    // Inline function 'kotlin.require' call
    if (!(size >= 0)) {
      var message = 'Size must be known in advance when using READ_ALL';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    var progression = step(until(0, imul(size, 2)), 2);
    var inductionVariable = progression.c1_1;
    var last = progression.d1_1;
    var step_0 = progression.e1_1;
    if (step_0 > 0 && inductionVariable <= last || (step_0 < 0 && last <= inductionVariable))
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + step_0 | 0;
        this.z5f(decoder, startIndex + index | 0, builder, false);
      }
       while (!(index === last));
  };
  protoOf(MapLikeSerializer).s5f = function (decoder, builder, startIndex, size) {
    return this.y5f(decoder, (!(builder == null) ? isInterface(builder, KtMutableMap) : false) ? builder : THROW_CCE(), startIndex, size);
  };
  protoOf(MapLikeSerializer).z5f = function (decoder, index, builder, checkIndex) {
    var key = decoder.t5c(this.v58(), index, this.w5f_1);
    var tmp;
    if (checkIndex) {
      // Inline function 'kotlin.also' call
      var this_0 = decoder.w5c(this.v58());
      // Inline function 'kotlin.require' call
      if (!(this_0 === (index + 1 | 0))) {
        var message = 'Value must follow key in a map, index for key: ' + index + ', returned index for value: ' + this_0;
        throw IllegalArgumentException_init_$Create$_0(toString_1(message));
      }
      tmp = this_0;
    } else {
      tmp = index + 1 | 0;
    }
    var vIndex = tmp;
    var tmp_0;
    var tmp_1;
    if (builder.o2(key)) {
      var tmp_2 = this.x5f_1.v58().r5a();
      tmp_1 = !(tmp_2 instanceof PrimitiveKind);
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = decoder.s5c(this.v58(), vIndex, this.x5f_1, getValue_0(builder, key));
    } else {
      tmp_0 = decoder.t5c(this.v58(), vIndex, this.x5f_1);
    }
    var value = tmp_0;
    // Inline function 'kotlin.collections.set' call
    builder.t2(key, value);
  };
  protoOf(MapLikeSerializer).t5f = function (decoder, index, builder, checkIndex) {
    return this.z5f(decoder, index, (!(builder == null) ? isInterface(builder, KtMutableMap) : false) ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(MapLikeSerializer).r5f = function (encoder, value) {
    var size = this.a5g(value);
    // Inline function 'kotlinx.serialization.encoding.encodeCollection' call
    var descriptor = this.v58();
    var composite = encoder.a5e(descriptor, size);
    var iterator = this.b5g(value);
    var index = 0;
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s = iterator;
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      // Inline function 'kotlin.collections.component1' call
      var k = element.z();
      // Inline function 'kotlin.collections.component2' call
      var v = element.a1();
      var tmp = this.v58();
      var tmp0 = index;
      index = tmp0 + 1 | 0;
      composite.w5d(tmp, tmp0, this.w5f_1, k);
      var tmp_0 = this.v58();
      var tmp1 = index;
      index = tmp1 + 1 | 0;
      composite.w5d(tmp_0, tmp1, this.x5f_1, v);
    }
    composite.h5c(descriptor);
  };
  protoOf(MapLikeSerializer).i59 = function (encoder, value) {
    return this.r5f(encoder, (value == null ? true : !(value == null)) ? value : THROW_CCE());
  };
  function readSize($this, decoder, builder) {
    var size = decoder.x5c($this.v58());
    $this.k5f(builder, size);
    return size;
  }
  function AbstractCollectionSerializer() {
  }
  protoOf(AbstractCollectionSerializer).v5f = function (decoder, previous) {
    var tmp1_elvis_lhs = previous == null ? null : this.i5f(previous);
    var builder = tmp1_elvis_lhs == null ? this.c5f() : tmp1_elvis_lhs;
    var startIndex = this.e5f(builder);
    var compositeDecoder = decoder.g5c(this.v58());
    if (compositeDecoder.v5c()) {
      this.s5f(compositeDecoder, builder, startIndex, readSize(this, compositeDecoder, builder));
    } else {
      $l$loop: while (true) {
        var index = compositeDecoder.w5c(this.v58());
        if (index === -1)
          break $l$loop;
        this.u5f(compositeDecoder, startIndex + index | 0, builder);
      }
    }
    compositeDecoder.h5c(this.v58());
    return this.g5f(builder);
  };
  protoOf(AbstractCollectionSerializer).j59 = function (decoder) {
    return this.v5f(decoder, null);
  };
  protoOf(AbstractCollectionSerializer).u5f = function (decoder, index, builder, checkIndex, $super) {
    checkIndex = checkIndex === VOID ? true : checkIndex;
    var tmp;
    if ($super === VOID) {
      this.t5f(decoder, index, builder, checkIndex);
      tmp = Unit_instance;
    } else {
      tmp = $super.t5f.call(this, decoder, index, builder, checkIndex);
    }
    return tmp;
  };
  function LinkedHashSetSerializer(eSerializer) {
    CollectionSerializer.call(this, eSerializer);
    this.d5g_1 = new LinkedHashSetClassDesc(eSerializer.v58());
  }
  protoOf(LinkedHashSetSerializer).v58 = function () {
    return this.d5g_1;
  };
  protoOf(LinkedHashSetSerializer).c5f = function () {
    // Inline function 'kotlin.collections.linkedSetOf' call
    return LinkedHashSet_init_$Create$();
  };
  protoOf(LinkedHashSetSerializer).e5g = function (_this__u8e3s4) {
    return _this__u8e3s4.p();
  };
  protoOf(LinkedHashSetSerializer).e5f = function (_this__u8e3s4) {
    return this.e5g(_this__u8e3s4 instanceof LinkedHashSet ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(LinkedHashSetSerializer).f5g = function (_this__u8e3s4) {
    return _this__u8e3s4;
  };
  protoOf(LinkedHashSetSerializer).g5f = function (_this__u8e3s4) {
    return this.f5g(_this__u8e3s4 instanceof LinkedHashSet ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(LinkedHashSetSerializer).g5g = function (_this__u8e3s4) {
    var tmp0_elvis_lhs = _this__u8e3s4 instanceof LinkedHashSet ? _this__u8e3s4 : null;
    return tmp0_elvis_lhs == null ? LinkedHashSet_init_$Create$_0(_this__u8e3s4) : tmp0_elvis_lhs;
  };
  protoOf(LinkedHashSetSerializer).i5f = function (_this__u8e3s4) {
    return this.g5g((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtSet) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(LinkedHashSetSerializer).h5g = function (_this__u8e3s4, size) {
  };
  protoOf(LinkedHashSetSerializer).k5f = function (_this__u8e3s4, size) {
    return this.h5g(_this__u8e3s4 instanceof LinkedHashSet ? _this__u8e3s4 : THROW_CCE(), size);
  };
  protoOf(LinkedHashSetSerializer).i5g = function (_this__u8e3s4, index, element) {
    _this__u8e3s4.j(element);
  };
  protoOf(LinkedHashSetSerializer).m5f = function (_this__u8e3s4, index, element) {
    var tmp = _this__u8e3s4 instanceof LinkedHashSet ? _this__u8e3s4 : THROW_CCE();
    return this.i5g(tmp, index, (element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  function HashSetSerializer(eSerializer) {
    CollectionSerializer.call(this, eSerializer);
    this.k5g_1 = new HashSetClassDesc(eSerializer.v58());
  }
  protoOf(HashSetSerializer).v58 = function () {
    return this.k5g_1;
  };
  protoOf(HashSetSerializer).c5f = function () {
    return HashSet_init_$Create$();
  };
  protoOf(HashSetSerializer).l5g = function (_this__u8e3s4) {
    return _this__u8e3s4.p();
  };
  protoOf(HashSetSerializer).e5f = function (_this__u8e3s4) {
    return this.l5g(_this__u8e3s4 instanceof HashSet ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(HashSetSerializer).m5g = function (_this__u8e3s4) {
    return _this__u8e3s4;
  };
  protoOf(HashSetSerializer).g5f = function (_this__u8e3s4) {
    return this.m5g(_this__u8e3s4 instanceof HashSet ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(HashSetSerializer).g5g = function (_this__u8e3s4) {
    var tmp0_elvis_lhs = _this__u8e3s4 instanceof HashSet ? _this__u8e3s4 : null;
    return tmp0_elvis_lhs == null ? HashSet_init_$Create$_0(_this__u8e3s4) : tmp0_elvis_lhs;
  };
  protoOf(HashSetSerializer).i5f = function (_this__u8e3s4) {
    return this.g5g((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtSet) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(HashSetSerializer).n5g = function (_this__u8e3s4, size) {
  };
  protoOf(HashSetSerializer).k5f = function (_this__u8e3s4, size) {
    return this.n5g(_this__u8e3s4 instanceof HashSet ? _this__u8e3s4 : THROW_CCE(), size);
  };
  protoOf(HashSetSerializer).o5g = function (_this__u8e3s4, index, element) {
    _this__u8e3s4.j(element);
  };
  protoOf(HashSetSerializer).m5f = function (_this__u8e3s4, index, element) {
    var tmp = _this__u8e3s4 instanceof HashSet ? _this__u8e3s4 : THROW_CCE();
    return this.o5g(tmp, index, (element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  function HashMapSerializer(kSerializer, vSerializer) {
    MapLikeSerializer.call(this, kSerializer, vSerializer);
    this.r5g_1 = new HashMapClassDesc(kSerializer.v58(), vSerializer.v58());
  }
  protoOf(HashMapSerializer).v58 = function () {
    return this.r5g_1;
  };
  protoOf(HashMapSerializer).s5g = function (_this__u8e3s4) {
    return _this__u8e3s4.p();
  };
  protoOf(HashMapSerializer).a5g = function (_this__u8e3s4) {
    return this.s5g((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(HashMapSerializer).t5g = function (_this__u8e3s4) {
    // Inline function 'kotlin.collections.iterator' call
    return _this__u8e3s4.y().m();
  };
  protoOf(HashMapSerializer).b5g = function (_this__u8e3s4) {
    return this.t5g((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(HashMapSerializer).c5f = function () {
    return HashMap_init_$Create$();
  };
  protoOf(HashMapSerializer).u5g = function (_this__u8e3s4) {
    return imul(_this__u8e3s4.p(), 2);
  };
  protoOf(HashMapSerializer).e5f = function (_this__u8e3s4) {
    return this.u5g(_this__u8e3s4 instanceof HashMap ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(HashMapSerializer).v5g = function (_this__u8e3s4) {
    return _this__u8e3s4;
  };
  protoOf(HashMapSerializer).g5f = function (_this__u8e3s4) {
    return this.v5g(_this__u8e3s4 instanceof HashMap ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(HashMapSerializer).w5g = function (_this__u8e3s4) {
    var tmp0_elvis_lhs = _this__u8e3s4 instanceof HashMap ? _this__u8e3s4 : null;
    return tmp0_elvis_lhs == null ? HashMap_init_$Create$_1(_this__u8e3s4) : tmp0_elvis_lhs;
  };
  protoOf(HashMapSerializer).i5f = function (_this__u8e3s4) {
    return this.w5g((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(HashMapSerializer).x5g = function (_this__u8e3s4, size) {
  };
  protoOf(HashMapSerializer).k5f = function (_this__u8e3s4, size) {
    return this.x5g(_this__u8e3s4 instanceof HashMap ? _this__u8e3s4 : THROW_CCE(), size);
  };
  function LinkedHashMapSerializer(kSerializer, vSerializer) {
    MapLikeSerializer.call(this, kSerializer, vSerializer);
    this.a5h_1 = new LinkedHashMapClassDesc(kSerializer.v58(), vSerializer.v58());
  }
  protoOf(LinkedHashMapSerializer).v58 = function () {
    return this.a5h_1;
  };
  protoOf(LinkedHashMapSerializer).s5g = function (_this__u8e3s4) {
    return _this__u8e3s4.p();
  };
  protoOf(LinkedHashMapSerializer).a5g = function (_this__u8e3s4) {
    return this.s5g((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(LinkedHashMapSerializer).t5g = function (_this__u8e3s4) {
    // Inline function 'kotlin.collections.iterator' call
    return _this__u8e3s4.y().m();
  };
  protoOf(LinkedHashMapSerializer).b5g = function (_this__u8e3s4) {
    return this.t5g((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(LinkedHashMapSerializer).c5f = function () {
    return LinkedHashMap_init_$Create$();
  };
  protoOf(LinkedHashMapSerializer).b5h = function (_this__u8e3s4) {
    return imul(_this__u8e3s4.p(), 2);
  };
  protoOf(LinkedHashMapSerializer).e5f = function (_this__u8e3s4) {
    return this.b5h(_this__u8e3s4 instanceof LinkedHashMap ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(LinkedHashMapSerializer).c5h = function (_this__u8e3s4) {
    return _this__u8e3s4;
  };
  protoOf(LinkedHashMapSerializer).g5f = function (_this__u8e3s4) {
    return this.c5h(_this__u8e3s4 instanceof LinkedHashMap ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(LinkedHashMapSerializer).w5g = function (_this__u8e3s4) {
    var tmp0_elvis_lhs = _this__u8e3s4 instanceof LinkedHashMap ? _this__u8e3s4 : null;
    return tmp0_elvis_lhs == null ? LinkedHashMap_init_$Create$_1(_this__u8e3s4) : tmp0_elvis_lhs;
  };
  protoOf(LinkedHashMapSerializer).i5f = function (_this__u8e3s4) {
    return this.w5g((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(LinkedHashMapSerializer).d5h = function (_this__u8e3s4, size) {
  };
  protoOf(LinkedHashMapSerializer).k5f = function (_this__u8e3s4, size) {
    return this.d5h(_this__u8e3s4 instanceof LinkedHashMap ? _this__u8e3s4 : THROW_CCE(), size);
  };
  function ReferenceArraySerializer(kClass, eSerializer) {
    CollectionLikeSerializer.call(this, eSerializer);
    this.f5h_1 = kClass;
    this.g5h_1 = new ArrayClassDesc(eSerializer.v58());
  }
  protoOf(ReferenceArraySerializer).v58 = function () {
    return this.g5h_1;
  };
  protoOf(ReferenceArraySerializer).h5h = function (_this__u8e3s4) {
    return _this__u8e3s4.length;
  };
  protoOf(ReferenceArraySerializer).a5g = function (_this__u8e3s4) {
    return this.h5h((!(_this__u8e3s4 == null) ? isArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(ReferenceArraySerializer).i5h = function (_this__u8e3s4) {
    return arrayIterator(_this__u8e3s4);
  };
  protoOf(ReferenceArraySerializer).b5g = function (_this__u8e3s4) {
    return this.i5h((!(_this__u8e3s4 == null) ? isArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(ReferenceArraySerializer).c5f = function () {
    // Inline function 'kotlin.collections.arrayListOf' call
    return ArrayList_init_$Create$();
  };
  protoOf(ReferenceArraySerializer).j5h = function (_this__u8e3s4) {
    return _this__u8e3s4.p();
  };
  protoOf(ReferenceArraySerializer).e5f = function (_this__u8e3s4) {
    return this.j5h(_this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(ReferenceArraySerializer).k5h = function (_this__u8e3s4) {
    return toNativeArrayImpl(_this__u8e3s4, this.f5h_1);
  };
  protoOf(ReferenceArraySerializer).g5f = function (_this__u8e3s4) {
    return this.k5h(_this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(ReferenceArraySerializer).l5h = function (_this__u8e3s4) {
    return ArrayList_init_$Create$_1(asList(_this__u8e3s4));
  };
  protoOf(ReferenceArraySerializer).i5f = function (_this__u8e3s4) {
    return this.l5h((!(_this__u8e3s4 == null) ? isArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(ReferenceArraySerializer).m5h = function (_this__u8e3s4, size) {
    return _this__u8e3s4.o5(size);
  };
  protoOf(ReferenceArraySerializer).k5f = function (_this__u8e3s4, size) {
    return this.m5h(_this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE(), size);
  };
  protoOf(ReferenceArraySerializer).n5h = function (_this__u8e3s4, index, element) {
    _this__u8e3s4.m2(index, element);
  };
  protoOf(ReferenceArraySerializer).m5f = function (_this__u8e3s4, index, element) {
    var tmp = _this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE();
    return this.n5h(tmp, index, (element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  function CollectionSerializer(element) {
    CollectionLikeSerializer.call(this, element);
  }
  protoOf(CollectionSerializer).o5f = function (_this__u8e3s4) {
    return _this__u8e3s4.p();
  };
  protoOf(CollectionSerializer).a5g = function (_this__u8e3s4) {
    return this.o5f((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Collection) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(CollectionSerializer).p5f = function (_this__u8e3s4) {
    return _this__u8e3s4.m();
  };
  protoOf(CollectionSerializer).b5g = function (_this__u8e3s4) {
    return this.p5f((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Collection) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  function CollectionLikeSerializer(elementSerializer) {
    AbstractCollectionSerializer.call(this);
    this.q5f_1 = elementSerializer;
  }
  protoOf(CollectionLikeSerializer).r5f = function (encoder, value) {
    var size = this.a5g(value);
    // Inline function 'kotlinx.serialization.encoding.encodeCollection' call
    var descriptor = this.v58();
    var composite = encoder.a5e(descriptor, size);
    var iterator = this.b5g(value);
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        composite.w5d(this.v58(), index, this.q5f_1, iterator.o());
      }
       while (inductionVariable < size);
    composite.h5c(descriptor);
  };
  protoOf(CollectionLikeSerializer).i59 = function (encoder, value) {
    return this.r5f(encoder, (value == null ? true : !(value == null)) ? value : THROW_CCE());
  };
  protoOf(CollectionLikeSerializer).s5f = function (decoder, builder, startIndex, size) {
    // Inline function 'kotlin.require' call
    if (!(size >= 0)) {
      var message = 'Size must be known in advance when using READ_ALL';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.t5f(decoder, startIndex + index | 0, builder, false);
      }
       while (inductionVariable < size);
  };
  protoOf(CollectionLikeSerializer).t5f = function (decoder, index, builder, checkIndex) {
    this.m5f(builder, index, decoder.t5c(this.v58(), index, this.q5f_1));
  };
  function PrimitiveArraySerializer(primitiveSerializer) {
    CollectionLikeSerializer.call(this, primitiveSerializer);
    this.p5h_1 = new PrimitiveArrayDescriptor(primitiveSerializer.v58());
  }
  protoOf(PrimitiveArraySerializer).v58 = function () {
    return this.p5h_1;
  };
  protoOf(PrimitiveArraySerializer).q5h = function (_this__u8e3s4) {
    return _this__u8e3s4.r5h();
  };
  protoOf(PrimitiveArraySerializer).e5f = function (_this__u8e3s4) {
    return this.q5h(_this__u8e3s4 instanceof PrimitiveArrayBuilder ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(PrimitiveArraySerializer).s5h = function (_this__u8e3s4) {
    return _this__u8e3s4.t5h();
  };
  protoOf(PrimitiveArraySerializer).g5f = function (_this__u8e3s4) {
    return this.s5h(_this__u8e3s4 instanceof PrimitiveArrayBuilder ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(PrimitiveArraySerializer).u5h = function (_this__u8e3s4, size) {
    return _this__u8e3s4.v5h(size);
  };
  protoOf(PrimitiveArraySerializer).k5f = function (_this__u8e3s4, size) {
    return this.u5h(_this__u8e3s4 instanceof PrimitiveArrayBuilder ? _this__u8e3s4 : THROW_CCE(), size);
  };
  protoOf(PrimitiveArraySerializer).w5h = function (_this__u8e3s4) {
    var message = 'This method lead to boxing and must not be used, use writeContents instead';
    throw IllegalStateException_init_$Create$_0(toString_1(message));
  };
  protoOf(PrimitiveArraySerializer).b5g = function (_this__u8e3s4) {
    return this.w5h((_this__u8e3s4 == null ? true : !(_this__u8e3s4 == null)) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(PrimitiveArraySerializer).x5h = function (_this__u8e3s4, index, element) {
    var message = 'This method lead to boxing and must not be used, use Builder.append instead';
    throw IllegalStateException_init_$Create$_0(toString_1(message));
  };
  protoOf(PrimitiveArraySerializer).m5f = function (_this__u8e3s4, index, element) {
    var tmp = _this__u8e3s4 instanceof PrimitiveArrayBuilder ? _this__u8e3s4 : THROW_CCE();
    return this.x5h(tmp, index, (element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  protoOf(PrimitiveArraySerializer).c5f = function () {
    return this.i5f(this.y5h());
  };
  protoOf(PrimitiveArraySerializer).b5i = function (encoder, value) {
    var size = this.a5g(value);
    // Inline function 'kotlinx.serialization.encoding.encodeCollection' call
    var descriptor = this.p5h_1;
    var composite = encoder.a5e(descriptor, size);
    this.a5i(composite, value, size);
    composite.h5c(descriptor);
  };
  protoOf(PrimitiveArraySerializer).i59 = function (encoder, value) {
    return this.b5i(encoder, (value == null ? true : !(value == null)) ? value : THROW_CCE());
  };
  protoOf(PrimitiveArraySerializer).r5f = function (encoder, value) {
    return this.b5i(encoder, (value == null ? true : !(value == null)) ? value : THROW_CCE());
  };
  protoOf(PrimitiveArraySerializer).j59 = function (decoder) {
    return this.v5f(decoder, null);
  };
  function PrimitiveArrayBuilder() {
  }
  protoOf(PrimitiveArrayBuilder).c5i = function (requiredCapacity, $super) {
    requiredCapacity = requiredCapacity === VOID ? this.r5h() + 1 | 0 : requiredCapacity;
    var tmp;
    if ($super === VOID) {
      this.v5h(requiredCapacity);
      tmp = Unit_instance;
    } else {
      tmp = $super.v5h.call(this, requiredCapacity);
    }
    return tmp;
  };
  function Companion_78() {
    Companion_instance_78 = this;
    this.d5i_1 = longArray(0);
  }
  var Companion_instance_78;
  function Companion_getInstance_78() {
    if (Companion_instance_78 == null)
      new Companion_78();
    return Companion_instance_78;
  }
  function prepareHighMarksArray($this, elementsCount) {
    var slotsCount = (elementsCount - 1 | 0) >>> 6 | 0;
    var elementsInLastSlot = elementsCount & 63;
    var highMarks = longArray(slotsCount);
    if (!(elementsInLastSlot === 0)) {
      highMarks[get_lastIndex(highMarks)] = shiftLeft(-1n, elementsCount);
    }
    return highMarks;
  }
  function markHigh($this, index) {
    var slot = (index >>> 6 | 0) - 1 | 0;
    var offsetInSlot = index & 63;
    $this.h5i_1[slot] = $this.h5i_1[slot] | shiftLeft(1n, offsetInSlot);
  }
  function nextUnmarkedHighIndex($this) {
    var inductionVariable = 0;
    var last = $this.h5i_1.length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var slot = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var slotOffset = imul(slot + 1 | 0, 64);
        var slotMarks = $this.h5i_1[slot];
        while (!(slotMarks === -1n)) {
          var indexInSlot = countTrailingZeroBits(~slotMarks);
          slotMarks = slotMarks | shiftLeft(1n, indexInSlot);
          var index = slotOffset + indexInSlot | 0;
          if ($this.f5i_1($this.e5i_1, index)) {
            $this.h5i_1[slot] = slotMarks;
            return index;
          }
        }
        $this.h5i_1[slot] = slotMarks;
      }
       while (inductionVariable <= last);
    return -1;
  }
  function ElementMarker(descriptor, readIfAbsent) {
    Companion_getInstance_78();
    this.e5i_1 = descriptor;
    this.f5i_1 = readIfAbsent;
    var elementsCount = this.e5i_1.p5a();
    if (elementsCount <= 64) {
      var tmp = this;
      var tmp_0;
      if (elementsCount === 64) {
        tmp_0 = 0n;
      } else {
        tmp_0 = shiftLeft(-1n, elementsCount);
      }
      tmp.g5i_1 = tmp_0;
      this.h5i_1 = Companion_getInstance_78().d5i_1;
    } else {
      this.g5i_1 = 0n;
      this.h5i_1 = prepareHighMarksArray(this, elementsCount);
    }
  }
  protoOf(ElementMarker).i5i = function (index) {
    if (index < 64) {
      this.g5i_1 = this.g5i_1 | shiftLeft(1n, index);
    } else {
      markHigh(this, index);
    }
  };
  protoOf(ElementMarker).j5i = function () {
    var elementsCount = this.e5i_1.p5a();
    while (!(this.g5i_1 === -1n)) {
      var index = countTrailingZeroBits(~this.g5i_1);
      this.g5i_1 = this.g5i_1 | shiftLeft(1n, index);
      if (this.f5i_1(this.e5i_1, index)) {
        return index;
      }
    }
    if (elementsCount > 64) {
      return nextUnmarkedHighIndex(this);
    }
    return -1;
  };
  function createUnmarkedDescriptor($this, serialName) {
    var d = new EnumDescriptor(serialName, $this.k5i_1.length);
    // Inline function 'kotlin.collections.forEach' call
    var indexedObject = $this.k5i_1;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      d.z5i(element.w2_1);
    }
    return d;
  }
  function EnumSerializer$descriptor$delegate$lambda(this$0, $serialName) {
    return function () {
      var tmp0_elvis_lhs = this$0.l5i_1;
      return tmp0_elvis_lhs == null ? createUnmarkedDescriptor(this$0, $serialName) : tmp0_elvis_lhs;
    };
  }
  function EnumSerializer$_get_descriptor_$ref_j67dlw() {
    return function (p0) {
      return p0.v58();
    };
  }
  function EnumSerializer(serialName, values) {
    this.k5i_1 = values;
    this.l5i_1 = null;
    var tmp = this;
    tmp.m5i_1 = lazy(EnumSerializer$descriptor$delegate$lambda(this, serialName));
  }
  protoOf(EnumSerializer).v58 = function () {
    var tmp0 = this.m5i_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('descriptor', 1, tmp, EnumSerializer$_get_descriptor_$ref_j67dlw(), null);
    return tmp0.a1();
  };
  protoOf(EnumSerializer).a5j = function (encoder, value) {
    var index = indexOf(this.k5i_1, value);
    if (index === -1) {
      throw SerializationException_init_$Create$_0(toString_1(value) + ' is not a valid enum ' + this.v58().z59() + ', ' + ('must be one of ' + contentToString(this.k5i_1)));
    }
    encoder.k5d(this.v58(), index);
  };
  protoOf(EnumSerializer).i59 = function (encoder, value) {
    return this.a5j(encoder, value instanceof Enum ? value : THROW_CCE());
  };
  protoOf(EnumSerializer).j59 = function (decoder) {
    var index = decoder.d5c(this.v58());
    if (!(0 <= index ? index <= (this.k5i_1.length - 1 | 0) : false)) {
      throw SerializationException_init_$Create$_0('' + index + ' is not among valid ' + this.v58().z59() + ' enum values, ' + ('values size is ' + this.k5i_1.length));
    }
    return this.k5i_1[index];
  };
  protoOf(EnumSerializer).toString = function () {
    return 'kotlinx.serialization.internal.EnumSerializer<' + this.v58().z59() + '>';
  };
  function _get_elementDescriptors__y23q9p($this) {
    var tmp0 = $this.o5j_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('elementDescriptors', 1, tmp, EnumDescriptor$_get_elementDescriptors_$ref_5lvk4a(), null);
    return tmp0.a1();
  }
  function EnumDescriptor$elementDescriptors$delegate$lambda($elementsCount, $name, this$0) {
    return function () {
      var tmp = 0;
      var tmp_0 = $elementsCount;
      // Inline function 'kotlin.arrayOfNulls' call
      var tmp_1 = Array(tmp_0);
      while (tmp < tmp_0) {
        var tmp_2 = tmp;
        tmp_1[tmp_2] = buildSerialDescriptor($name + '.' + this$0.v5a(tmp_2), OBJECT_getInstance(), []);
        tmp = tmp + 1 | 0;
      }
      return tmp_1;
    };
  }
  function EnumDescriptor$_get_elementDescriptors_$ref_5lvk4a() {
    return function (p0) {
      return _get_elementDescriptors__y23q9p(p0);
    };
  }
  function EnumDescriptor(name, elementsCount) {
    PluginGeneratedSerialDescriptor.call(this, name, VOID, elementsCount);
    this.n5j_1 = ENUM_getInstance();
    var tmp = this;
    tmp.o5j_1 = lazy(EnumDescriptor$elementDescriptors$delegate$lambda(elementsCount, name, this));
  }
  protoOf(EnumDescriptor).r5a = function () {
    return this.n5j_1;
  };
  protoOf(EnumDescriptor).t5a = function (index) {
    return getChecked(_get_elementDescriptors__y23q9p(this), index);
  };
  protoOf(EnumDescriptor).equals = function (other) {
    if (this === other)
      return true;
    if (other == null)
      return false;
    if (!(!(other == null) ? isInterface(other, SerialDescriptor) : false))
      return false;
    if (!(other.r5a() === ENUM_getInstance()))
      return false;
    if (!(this.z59() === other.z59()))
      return false;
    if (!equals(cachedSerialNames(this), cachedSerialNames(other)))
      return false;
    return true;
  };
  protoOf(EnumDescriptor).toString = function () {
    return joinToString_0(get_elementNames(this), ', ', this.z59() + '(', ')');
  };
  protoOf(EnumDescriptor).hashCode = function () {
    var result = getStringHashCode(this.z59());
    // Inline function 'kotlinx.serialization.internal.elementsHashCodeBy' call
    // Inline function 'kotlin.collections.fold' call
    var accumulator = 1;
    var _iterator__ex2g4s = get_elementNames(this).m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      var hash = accumulator;
      var tmp = imul(31, hash);
      // Inline function 'kotlin.hashCode' call
      var tmp1_elvis_lhs = element == null ? null : hashCode(element);
      accumulator = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
    }
    var elementsHashCode = accumulator;
    result = imul(31, result) + elementsHashCode | 0;
    return result;
  };
  function InlineClassDescriptor(name, generatedSerializer) {
    PluginGeneratedSerialDescriptor.call(this, name, generatedSerializer, 1);
    this.d5k_1 = true;
  }
  protoOf(InlineClassDescriptor).q5a = function () {
    return this.d5k_1;
  };
  protoOf(InlineClassDescriptor).hashCode = function () {
    return imul(protoOf(PluginGeneratedSerialDescriptor).hashCode.call(this), 31);
  };
  protoOf(InlineClassDescriptor).equals = function (other) {
    var tmp$ret$0;
    $l$block_5: {
      // Inline function 'kotlinx.serialization.internal.equalsImpl' call
      if (this === other) {
        tmp$ret$0 = true;
        break $l$block_5;
      }
      if (!(other instanceof InlineClassDescriptor)) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      if (!(this.z59() === other.z59())) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      if (!(other.d5k_1 && contentEquals_0(this.p5j(), other.p5j()))) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      if (!(this.p5a() === other.p5a())) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      var inductionVariable = 0;
      var last = this.p5a();
      if (inductionVariable < last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          if (!(this.t5a(index).z59() === other.t5a(index).z59())) {
            tmp$ret$0 = false;
            break $l$block_5;
          }
          if (!equals(this.t5a(index).r5a(), other.t5a(index).r5a())) {
            tmp$ret$0 = false;
            break $l$block_5;
          }
        }
         while (inductionVariable < last);
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  };
  function InlinePrimitiveDescriptor(name, primitiveSerializer) {
    return new InlineClassDescriptor(name, new InlinePrimitiveDescriptor$1(primitiveSerializer));
  }
  function InlinePrimitiveDescriptor$1($primitiveSerializer) {
    this.e5k_1 = $primitiveSerializer;
  }
  protoOf(InlinePrimitiveDescriptor$1).f5k = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [this.e5k_1];
  };
  protoOf(InlinePrimitiveDescriptor$1).v58 = function () {
    var message = 'unsupported';
    throw IllegalStateException_init_$Create$_0(toString_1(message));
  };
  protoOf(InlinePrimitiveDescriptor$1).i59 = function (encoder, value) {
    // Inline function 'kotlin.error' call
    var message = 'unsupported';
    throw IllegalStateException_init_$Create$_0(toString_1(message));
  };
  protoOf(InlinePrimitiveDescriptor$1).j59 = function (decoder) {
    // Inline function 'kotlin.error' call
    var message = 'unsupported';
    throw IllegalStateException_init_$Create$_0(toString_1(message));
  };
  function jsonCachedSerialNames(_this__u8e3s4) {
    return cachedSerialNames(_this__u8e3s4);
  }
  function NoOpEncoder() {
    NoOpEncoder_instance = this;
    AbstractEncoder.call(this);
    this.h5k_1 = EmptySerializersModule_0();
  }
  protoOf(NoOpEncoder).g59 = function () {
    return this.h5k_1;
  };
  protoOf(NoOpEncoder).z5c = function (value) {
    return Unit_instance;
  };
  protoOf(NoOpEncoder).a5d = function () {
    return Unit_instance;
  };
  protoOf(NoOpEncoder).b5d = function (value) {
    return Unit_instance;
  };
  protoOf(NoOpEncoder).c5d = function (value) {
    return Unit_instance;
  };
  protoOf(NoOpEncoder).d5d = function (value) {
    return Unit_instance;
  };
  protoOf(NoOpEncoder).e5d = function (value) {
    return Unit_instance;
  };
  protoOf(NoOpEncoder).f5d = function (value) {
    return Unit_instance;
  };
  protoOf(NoOpEncoder).g5d = function (value) {
    return Unit_instance;
  };
  protoOf(NoOpEncoder).h5d = function (value) {
    return Unit_instance;
  };
  protoOf(NoOpEncoder).i5d = function (value) {
    return Unit_instance;
  };
  protoOf(NoOpEncoder).j5d = function (value) {
    return Unit_instance;
  };
  protoOf(NoOpEncoder).k5d = function (enumDescriptor, index) {
    return Unit_instance;
  };
  var NoOpEncoder_instance;
  function NoOpEncoder_getInstance() {
    if (NoOpEncoder_instance == null)
      new NoOpEncoder();
    return NoOpEncoder_instance;
  }
  function error_2($this) {
    throw IllegalStateException_init_$Create$_0('Descriptor for type `kotlin.Nothing` does not have elements');
  }
  function NothingSerialDescriptor() {
    NothingSerialDescriptor_instance = this;
    this.i5k_1 = OBJECT_getInstance();
    this.j5k_1 = 'kotlin.Nothing';
  }
  protoOf(NothingSerialDescriptor).r5a = function () {
    return this.i5k_1;
  };
  protoOf(NothingSerialDescriptor).z59 = function () {
    return this.j5k_1;
  };
  protoOf(NothingSerialDescriptor).p5a = function () {
    return 0;
  };
  protoOf(NothingSerialDescriptor).v5a = function (index) {
    error_2(this);
  };
  protoOf(NothingSerialDescriptor).u5a = function (name) {
    error_2(this);
  };
  protoOf(NothingSerialDescriptor).w5a = function (index) {
    error_2(this);
  };
  protoOf(NothingSerialDescriptor).t5a = function (index) {
    error_2(this);
  };
  protoOf(NothingSerialDescriptor).s5a = function (index) {
    error_2(this);
  };
  protoOf(NothingSerialDescriptor).toString = function () {
    return 'NothingSerialDescriptor';
  };
  protoOf(NothingSerialDescriptor).equals = function (other) {
    return this === other;
  };
  protoOf(NothingSerialDescriptor).hashCode = function () {
    return getStringHashCode(this.j5k_1) + imul(31, this.i5k_1.hashCode()) | 0;
  };
  var NothingSerialDescriptor_instance;
  function NothingSerialDescriptor_getInstance() {
    if (NothingSerialDescriptor_instance == null)
      new NothingSerialDescriptor();
    return NothingSerialDescriptor_instance;
  }
  function NullableSerializer(serializer) {
    this.k5k_1 = serializer;
    this.l5k_1 = new SerialDescriptorForNullable(this.k5k_1.v58());
  }
  protoOf(NullableSerializer).v58 = function () {
    return this.l5k_1;
  };
  protoOf(NullableSerializer).m5k = function (encoder, value) {
    if (!(value == null)) {
      encoder.z5d();
      encoder.h59(this.k5k_1, value);
    } else {
      encoder.a5d();
    }
  };
  protoOf(NullableSerializer).i59 = function (encoder, value) {
    return this.m5k(encoder, (value == null ? true : !(value == null)) ? value : THROW_CCE());
  };
  protoOf(NullableSerializer).j59 = function (decoder) {
    return decoder.s5b() ? decoder.k59(this.k5k_1) : decoder.t5b();
  };
  protoOf(NullableSerializer).equals = function (other) {
    if (this === other)
      return true;
    if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    if (!(other instanceof NullableSerializer))
      THROW_CCE();
    if (!equals(this.k5k_1, other.k5k_1))
      return false;
    return true;
  };
  protoOf(NullableSerializer).hashCode = function () {
    return hashCode(this.k5k_1);
  };
  function SerialDescriptorForNullable(original) {
    this.j5a_1 = original;
    this.k5a_1 = this.j5a_1.z59() + '?';
    this.l5a_1 = cachedSerialNames(this.j5a_1);
  }
  protoOf(SerialDescriptorForNullable).w58 = function () {
    return this.j5a_1.w58();
  };
  protoOf(SerialDescriptorForNullable).p5a = function () {
    return this.j5a_1.p5a();
  };
  protoOf(SerialDescriptorForNullable).q5a = function () {
    return this.j5a_1.q5a();
  };
  protoOf(SerialDescriptorForNullable).r5a = function () {
    return this.j5a_1.r5a();
  };
  protoOf(SerialDescriptorForNullable).s5a = function (index) {
    return this.j5a_1.s5a(index);
  };
  protoOf(SerialDescriptorForNullable).t5a = function (index) {
    return this.j5a_1.t5a(index);
  };
  protoOf(SerialDescriptorForNullable).u5a = function (name) {
    return this.j5a_1.u5a(name);
  };
  protoOf(SerialDescriptorForNullable).v5a = function (index) {
    return this.j5a_1.v5a(index);
  };
  protoOf(SerialDescriptorForNullable).w5a = function (index) {
    return this.j5a_1.w5a(index);
  };
  protoOf(SerialDescriptorForNullable).z59 = function () {
    return this.k5a_1;
  };
  protoOf(SerialDescriptorForNullable).q5b = function () {
    return this.l5a_1;
  };
  protoOf(SerialDescriptorForNullable).i5a = function () {
    return true;
  };
  protoOf(SerialDescriptorForNullable).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SerialDescriptorForNullable))
      return false;
    if (!equals(this.j5a_1, other.j5a_1))
      return false;
    return true;
  };
  protoOf(SerialDescriptorForNullable).toString = function () {
    return toString_1(this.j5a_1) + '?';
  };
  protoOf(SerialDescriptorForNullable).hashCode = function () {
    return imul(hashCode(this.j5a_1), 31);
  };
  function ObjectSerializer_init_$Init$(serialName, objectInstance, classAnnotations, $this) {
    ObjectSerializer.call($this, serialName, objectInstance);
    $this.o5k_1 = asList(classAnnotations);
    return $this;
  }
  function ObjectSerializer_init_$Create$(serialName, objectInstance, classAnnotations) {
    return ObjectSerializer_init_$Init$(serialName, objectInstance, classAnnotations, objectCreate(protoOf(ObjectSerializer)));
  }
  function ObjectSerializer$descriptor$delegate$lambda$lambda(this$0) {
    return function ($this$buildSerialDescriptor) {
      $this$buildSerialDescriptor.z58_1 = this$0.o5k_1;
      return Unit_instance;
    };
  }
  function ObjectSerializer$descriptor$delegate$lambda($serialName, this$0) {
    return function () {
      var tmp = OBJECT_getInstance();
      return buildSerialDescriptor($serialName, tmp, [], ObjectSerializer$descriptor$delegate$lambda$lambda(this$0));
    };
  }
  function ObjectSerializer$_get_descriptor_$ref_7z4xb6() {
    return function (p0) {
      return p0.v58();
    };
  }
  function ObjectSerializer(serialName, objectInstance) {
    this.n5k_1 = objectInstance;
    this.o5k_1 = emptyList();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.p5k_1 = lazy_0(tmp_0, ObjectSerializer$descriptor$delegate$lambda(serialName, this));
  }
  protoOf(ObjectSerializer).v58 = function () {
    var tmp0 = this.p5k_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('descriptor', 1, tmp, ObjectSerializer$_get_descriptor_$ref_7z4xb6(), null);
    return tmp0.a1();
  };
  protoOf(ObjectSerializer).f59 = function (encoder, value) {
    encoder.g5c(this.v58()).h5c(this.v58());
  };
  protoOf(ObjectSerializer).i59 = function (encoder, value) {
    return this.f59(encoder, !(value == null) ? value : THROW_CCE());
  };
  protoOf(ObjectSerializer).j59 = function (decoder) {
    // Inline function 'kotlinx.serialization.encoding.decodeStructure' call
    var descriptor = this.v58();
    var composite = decoder.g5c(descriptor);
    var tmp$ret$0;
    $l$block_0: {
      if (composite.v5c()) {
        tmp$ret$0 = Unit_instance;
        break $l$block_0;
      }
      var index = composite.w5c(this.v58());
      if (index === -1) {
        tmp$ret$0 = Unit_instance;
        break $l$block_0;
      } else
        throw SerializationException_init_$Create$_0('Unexpected index ' + index);
    }
    var result = tmp$ret$0;
    composite.h5c(descriptor);
    return this.n5k_1;
  };
  function get_EMPTY_DESCRIPTOR_ARRAY() {
    _init_properties_Platform_common_kt__3qzecs();
    return EMPTY_DESCRIPTOR_ARRAY;
  }
  var EMPTY_DESCRIPTOR_ARRAY;
  function serializerNotRegistered(_this__u8e3s4) {
    _init_properties_Platform_common_kt__3qzecs();
    throw SerializationException_init_$Create$_0(notRegisteredMessage(_this__u8e3s4));
  }
  function kclass(_this__u8e3s4) {
    _init_properties_Platform_common_kt__3qzecs();
    var t = _this__u8e3s4.fb();
    var tmp;
    if (!(t == null) ? isInterface(t, KClass) : false) {
      tmp = t;
    } else {
      if (!(t == null) ? isInterface(t, KTypeParameter) : false) {
        var message = 'Captured type parameter ' + toString_0(t) + ' from generic non-reified function. ' + ('Such functionality cannot be supported as ' + toString_0(t) + ' is erased, either specify serializer explicitly or make ') + ('calling function inline with reified ' + toString_0(t));
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      } else {
        var message_0 = 'Only KClass supported as classifier, got ' + toString_0(t);
        throw IllegalStateException_init_$Create$_0(toString_1(message_0));
      }
    }
    var tmp_0 = tmp;
    return isInterface(tmp_0, KClass) ? tmp_0 : THROW_CCE();
  }
  function compactArray(_this__u8e3s4) {
    _init_properties_Platform_common_kt__3qzecs();
    // Inline function 'kotlin.takeUnless' call
    var tmp;
    // Inline function 'kotlin.collections.isNullOrEmpty' call
    if (!(_this__u8e3s4 == null || _this__u8e3s4.s())) {
      tmp = _this__u8e3s4;
    } else {
      tmp = null;
    }
    var tmp0_safe_receiver = tmp;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.collections.toTypedArray' call
      tmp_0 = copyToArray(tmp0_safe_receiver);
    }
    var tmp1_elvis_lhs = tmp_0;
    return tmp1_elvis_lhs == null ? get_EMPTY_DESCRIPTOR_ARRAY() : tmp1_elvis_lhs;
  }
  function cachedSerialNames(_this__u8e3s4) {
    _init_properties_Platform_common_kt__3qzecs();
    if (isInterface(_this__u8e3s4, CachedNames))
      return _this__u8e3s4.q5b();
    var result = HashSet_init_$Create$_1(_this__u8e3s4.p5a());
    var inductionVariable = 0;
    var last = _this__u8e3s4.p5a();
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlin.collections.plusAssign' call
        var element = _this__u8e3s4.v5a(i);
        result.j(element);
      }
       while (inductionVariable < last);
    return result;
  }
  function notRegisteredMessage(_this__u8e3s4) {
    _init_properties_Platform_common_kt__3qzecs();
    var tmp0_elvis_lhs = _this__u8e3s4.ra();
    return notRegisteredMessage_0(tmp0_elvis_lhs == null ? '<local class name not available>' : tmp0_elvis_lhs);
  }
  function notRegisteredMessage_0(className) {
    _init_properties_Platform_common_kt__3qzecs();
    return "Serializer for class '" + className + "' is not found.\n" + "Please ensure that class is marked as '@Serializable' and that the serialization compiler plugin is applied.\n";
  }
  var properties_initialized_Platform_common_kt_i7q4ty;
  function _init_properties_Platform_common_kt__3qzecs() {
    if (!properties_initialized_Platform_common_kt_i7q4ty) {
      properties_initialized_Platform_common_kt_i7q4ty = true;
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      EMPTY_DESCRIPTOR_ARRAY = [];
    }
  }
  function throwMissingFieldException(seen, goldenMask, descriptor) {
    // Inline function 'kotlin.collections.mutableListOf' call
    var missingFields = ArrayList_init_$Create$();
    var missingFieldsBits = goldenMask & ~seen;
    var inductionVariable = 0;
    if (inductionVariable < 32)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!((missingFieldsBits & 1) === 0)) {
          // Inline function 'kotlin.collections.plusAssign' call
          var element = descriptor.v5a(i);
          missingFields.j(element);
        }
        missingFieldsBits = missingFieldsBits >>> 1 | 0;
      }
       while (inductionVariable < 32);
    throw MissingFieldException_init_$Create$(missingFields, descriptor.z59());
  }
  function _get_childSerializers__7vnyfa($this) {
    var tmp0 = $this.w5i_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('childSerializers', 1, tmp, PluginGeneratedSerialDescriptor$_get_childSerializers_$ref_e7suca(), null);
    return tmp0.a1();
  }
  function _get__hashCode__tgwhef_0($this) {
    var tmp0 = $this.y5i_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('_hashCode', 1, tmp, PluginGeneratedSerialDescriptor$_get__hashCode_$ref_cmj4vz(), null);
    return tmp0.a1();
  }
  function buildIndices($this) {
    var indices = HashMap_init_$Create$();
    var inductionVariable = 0;
    var last = $this.r5i_1.length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlin.collections.set' call
        var key = $this.r5i_1[i];
        indices.t2(key, i);
      }
       while (inductionVariable <= last);
    return indices;
  }
  function PluginGeneratedSerialDescriptor$childSerializers$delegate$lambda(this$0) {
    return function () {
      var tmp0_safe_receiver = this$0.o5i_1;
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.f5k();
      return tmp1_elvis_lhs == null ? get_EMPTY_SERIALIZER_ARRAY() : tmp1_elvis_lhs;
    };
  }
  function PluginGeneratedSerialDescriptor$_get_childSerializers_$ref_e7suca() {
    return function (p0) {
      return _get_childSerializers__7vnyfa(p0);
    };
  }
  function PluginGeneratedSerialDescriptor$typeParameterDescriptors$delegate$lambda(this$0) {
    return function () {
      var tmp0_safe_receiver = this$0.o5i_1;
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.g5k();
      var tmp;
      if (tmp1_safe_receiver == null) {
        tmp = null;
      } else {
        // Inline function 'kotlin.collections.map' call
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList_init_$Create$_0(tmp1_safe_receiver.length);
        var inductionVariable = 0;
        var last = tmp1_safe_receiver.length;
        while (inductionVariable < last) {
          var item = tmp1_safe_receiver[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          var tmp$ret$0 = item.v58();
          destination.j(tmp$ret$0);
        }
        tmp = destination;
      }
      return compactArray(tmp);
    };
  }
  function PluginGeneratedSerialDescriptor$_get_typeParameterDescriptors_$ref_jk3pka() {
    return function (p0) {
      return p0.p5j();
    };
  }
  function PluginGeneratedSerialDescriptor$_hashCode$delegate$lambda(this$0) {
    return function () {
      return hashCodeImpl(this$0, this$0.p5j());
    };
  }
  function PluginGeneratedSerialDescriptor$_get__hashCode_$ref_cmj4vz() {
    return function (p0) {
      return _get__hashCode__tgwhef_0(p0);
    };
  }
  function PluginGeneratedSerialDescriptor$toString$lambda(this$0) {
    return function (i) {
      return this$0.v5a(i) + ': ' + this$0.t5a(i).z59();
    };
  }
  function PluginGeneratedSerialDescriptor(serialName, generatedSerializer, elementsCount) {
    generatedSerializer = generatedSerializer === VOID ? null : generatedSerializer;
    this.n5i_1 = serialName;
    this.o5i_1 = generatedSerializer;
    this.p5i_1 = elementsCount;
    this.q5i_1 = -1;
    var tmp = this;
    var tmp_0 = 0;
    var tmp_1 = this.p5i_1;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_2 = Array(tmp_1);
    while (tmp_0 < tmp_1) {
      tmp_2[tmp_0] = '[UNINITIALIZED]';
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp.r5i_1 = tmp_2;
    var tmp_3 = this;
    // Inline function 'kotlin.arrayOfNulls' call
    var size = this.p5i_1;
    tmp_3.s5i_1 = Array(size);
    this.t5i_1 = null;
    this.u5i_1 = booleanArray(this.p5i_1);
    this.v5i_1 = emptyMap();
    var tmp_4 = this;
    var tmp_5 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp_4.w5i_1 = lazy_0(tmp_5, PluginGeneratedSerialDescriptor$childSerializers$delegate$lambda(this));
    var tmp_6 = this;
    var tmp_7 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp_6.x5i_1 = lazy_0(tmp_7, PluginGeneratedSerialDescriptor$typeParameterDescriptors$delegate$lambda(this));
    var tmp_8 = this;
    var tmp_9 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp_8.y5i_1 = lazy_0(tmp_9, PluginGeneratedSerialDescriptor$_hashCode$delegate$lambda(this));
  }
  protoOf(PluginGeneratedSerialDescriptor).z59 = function () {
    return this.n5i_1;
  };
  protoOf(PluginGeneratedSerialDescriptor).p5a = function () {
    return this.p5i_1;
  };
  protoOf(PluginGeneratedSerialDescriptor).r5a = function () {
    return CLASS_getInstance();
  };
  protoOf(PluginGeneratedSerialDescriptor).w58 = function () {
    var tmp0_elvis_lhs = this.t5i_1;
    return tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
  };
  protoOf(PluginGeneratedSerialDescriptor).q5b = function () {
    return this.v5i_1.r2();
  };
  protoOf(PluginGeneratedSerialDescriptor).p5j = function () {
    var tmp0 = this.x5i_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('typeParameterDescriptors', 1, tmp, PluginGeneratedSerialDescriptor$_get_typeParameterDescriptors_$ref_jk3pka(), null);
    return tmp0.a1();
  };
  protoOf(PluginGeneratedSerialDescriptor).q5j = function (name, isOptional) {
    this.q5i_1 = this.q5i_1 + 1 | 0;
    this.r5i_1[this.q5i_1] = name;
    this.u5i_1[this.q5i_1] = isOptional;
    this.s5i_1[this.q5i_1] = null;
    if (this.q5i_1 === (this.p5i_1 - 1 | 0)) {
      this.v5i_1 = buildIndices(this);
    }
  };
  protoOf(PluginGeneratedSerialDescriptor).z5i = function (name, isOptional, $super) {
    isOptional = isOptional === VOID ? false : isOptional;
    var tmp;
    if ($super === VOID) {
      this.q5j(name, isOptional);
      tmp = Unit_instance;
    } else {
      tmp = $super.q5j.call(this, name, isOptional);
    }
    return tmp;
  };
  protoOf(PluginGeneratedSerialDescriptor).t5a = function (index) {
    return getChecked(_get_childSerializers__7vnyfa(this), index).v58();
  };
  protoOf(PluginGeneratedSerialDescriptor).w5a = function (index) {
    return getChecked_0(this.u5i_1, index);
  };
  protoOf(PluginGeneratedSerialDescriptor).s5a = function (index) {
    var tmp0_elvis_lhs = getChecked(this.s5i_1, index);
    return tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
  };
  protoOf(PluginGeneratedSerialDescriptor).v5a = function (index) {
    return getChecked(this.r5i_1, index);
  };
  protoOf(PluginGeneratedSerialDescriptor).u5a = function (name) {
    var tmp0_elvis_lhs = this.v5i_1.q2(name);
    return tmp0_elvis_lhs == null ? -3 : tmp0_elvis_lhs;
  };
  protoOf(PluginGeneratedSerialDescriptor).equals = function (other) {
    var tmp$ret$0;
    $l$block_5: {
      // Inline function 'kotlinx.serialization.internal.equalsImpl' call
      if (this === other) {
        tmp$ret$0 = true;
        break $l$block_5;
      }
      if (!(other instanceof PluginGeneratedSerialDescriptor)) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      if (!(this.z59() === other.z59())) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      if (!contentEquals_0(this.p5j(), other.p5j())) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      if (!(this.p5a() === other.p5a())) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      var inductionVariable = 0;
      var last = this.p5a();
      if (inductionVariable < last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          if (!(this.t5a(index).z59() === other.t5a(index).z59())) {
            tmp$ret$0 = false;
            break $l$block_5;
          }
          if (!equals(this.t5a(index).r5a(), other.t5a(index).r5a())) {
            tmp$ret$0 = false;
            break $l$block_5;
          }
        }
         while (inductionVariable < last);
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  };
  protoOf(PluginGeneratedSerialDescriptor).hashCode = function () {
    return _get__hashCode__tgwhef_0(this);
  };
  protoOf(PluginGeneratedSerialDescriptor).toString = function () {
    var tmp = until(0, this.p5i_1);
    var tmp_0 = this.z59() + '(';
    return joinToString_0(tmp, ', ', tmp_0, ')', VOID, VOID, PluginGeneratedSerialDescriptor$toString$lambda(this));
  };
  function hashCodeImpl(_this__u8e3s4, typeParams) {
    var result = getStringHashCode(_this__u8e3s4.z59());
    result = imul(31, result) + contentHashCode(typeParams) | 0;
    var elementDescriptors = get_elementDescriptors(_this__u8e3s4);
    // Inline function 'kotlinx.serialization.internal.elementsHashCodeBy' call
    // Inline function 'kotlin.collections.fold' call
    var accumulator = 1;
    var _iterator__ex2g4s = elementDescriptors.m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      var hash = accumulator;
      var tmp = imul(31, hash);
      // Inline function 'kotlin.hashCode' call
      var tmp0_safe_receiver = element.z59();
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
      accumulator = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
    }
    var namesHash = accumulator;
    // Inline function 'kotlinx.serialization.internal.elementsHashCodeBy' call
    // Inline function 'kotlin.collections.fold' call
    var accumulator_0 = 1;
    var _iterator__ex2g4s_0 = elementDescriptors.m();
    while (_iterator__ex2g4s_0.n()) {
      var element_0 = _iterator__ex2g4s_0.o();
      var hash_0 = accumulator_0;
      var tmp_0 = imul(31, hash_0);
      // Inline function 'kotlin.hashCode' call
      var tmp0_safe_receiver_0 = element_0.r5a();
      var tmp1_elvis_lhs_0 = tmp0_safe_receiver_0 == null ? null : hashCode(tmp0_safe_receiver_0);
      accumulator_0 = tmp_0 + (tmp1_elvis_lhs_0 == null ? 0 : tmp1_elvis_lhs_0) | 0;
    }
    var kindHash = accumulator_0;
    result = imul(31, result) + namesHash | 0;
    result = imul(31, result) + kindHash | 0;
    return result;
  }
  function get_EMPTY_SERIALIZER_ARRAY() {
    _init_properties_PluginHelperInterfaces_kt__xgvzfp();
    return EMPTY_SERIALIZER_ARRAY;
  }
  var EMPTY_SERIALIZER_ARRAY;
  function GeneratedSerializer() {
  }
  function SerializerFactory() {
  }
  var properties_initialized_PluginHelperInterfaces_kt_ap8in1;
  function _init_properties_PluginHelperInterfaces_kt__xgvzfp() {
    if (!properties_initialized_PluginHelperInterfaces_kt_ap8in1) {
      properties_initialized_PluginHelperInterfaces_kt_ap8in1 = true;
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      EMPTY_SERIALIZER_ARRAY = [];
    }
  }
  function ByteArraySerializer_0() {
    ByteArraySerializer_instance = this;
    PrimitiveArraySerializer.call(this, serializer_10(ByteCompanionObject_instance));
  }
  protoOf(ByteArraySerializer_0).t5k = function (_this__u8e3s4) {
    return _this__u8e3s4.length;
  };
  protoOf(ByteArraySerializer_0).a5g = function (_this__u8e3s4) {
    return this.t5k((!(_this__u8e3s4 == null) ? isByteArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(ByteArraySerializer_0).u5k = function (_this__u8e3s4) {
    return new ByteArrayBuilder(_this__u8e3s4);
  };
  protoOf(ByteArraySerializer_0).i5f = function (_this__u8e3s4) {
    return this.u5k((!(_this__u8e3s4 == null) ? isByteArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(ByteArraySerializer_0).y5h = function () {
    return new Int8Array(0);
  };
  protoOf(ByteArraySerializer_0).v5k = function (decoder, index, builder, checkIndex) {
    builder.y5k(decoder.j5c(this.p5h_1, index));
  };
  protoOf(ByteArraySerializer_0).t5f = function (decoder, index, builder, checkIndex) {
    return this.v5k(decoder, index, builder instanceof ByteArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(ByteArraySerializer_0).z5h = function (decoder, index, builder, checkIndex) {
    return this.v5k(decoder, index, builder instanceof ByteArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(ByteArraySerializer_0).z5k = function (encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        encoder.n5d(this.p5h_1, i, content[i]);
      }
       while (inductionVariable < size);
  };
  protoOf(ByteArraySerializer_0).a5i = function (encoder, content, size) {
    return this.z5k(encoder, (!(content == null) ? isByteArray(content) : false) ? content : THROW_CCE(), size);
  };
  var ByteArraySerializer_instance;
  function ByteArraySerializer_getInstance() {
    if (ByteArraySerializer_instance == null)
      new ByteArraySerializer_0();
    return ByteArraySerializer_instance;
  }
  function ByteArrayBuilder(bufferWithData) {
    PrimitiveArrayBuilder.call(this);
    this.w5k_1 = bufferWithData;
    this.x5k_1 = bufferWithData.length;
    this.v5h(10);
  }
  protoOf(ByteArrayBuilder).r5h = function () {
    return this.x5k_1;
  };
  protoOf(ByteArrayBuilder).v5h = function (requiredCapacity) {
    if (this.w5k_1.length < requiredCapacity)
      this.w5k_1 = copyOf_0(this.w5k_1, coerceAtLeast(requiredCapacity, imul(this.w5k_1.length, 2)));
  };
  protoOf(ByteArrayBuilder).y5k = function (c) {
    this.c5i();
    var tmp = this.w5k_1;
    var tmp1 = this.x5k_1;
    this.x5k_1 = tmp1 + 1 | 0;
    tmp[tmp1] = c;
  };
  protoOf(ByteArrayBuilder).t5h = function () {
    return copyOf_0(this.w5k_1, this.x5k_1);
  };
  function CharArraySerializer_0() {
    CharArraySerializer_instance = this;
    PrimitiveArraySerializer.call(this, serializer_11(Companion_getInstance()));
  }
  protoOf(CharArraySerializer_0).c5l = function (_this__u8e3s4) {
    return _this__u8e3s4.length;
  };
  protoOf(CharArraySerializer_0).a5g = function (_this__u8e3s4) {
    return this.c5l((!(_this__u8e3s4 == null) ? isCharArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(CharArraySerializer_0).d5l = function (_this__u8e3s4) {
    return new CharArrayBuilder(_this__u8e3s4);
  };
  protoOf(CharArraySerializer_0).i5f = function (_this__u8e3s4) {
    return this.d5l((!(_this__u8e3s4 == null) ? isCharArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(CharArraySerializer_0).y5h = function () {
    return charArray(0);
  };
  protoOf(CharArraySerializer_0).e5l = function (decoder, index, builder, checkIndex) {
    builder.h5l(decoder.p5c(this.p5h_1, index));
  };
  protoOf(CharArraySerializer_0).t5f = function (decoder, index, builder, checkIndex) {
    return this.e5l(decoder, index, builder instanceof CharArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(CharArraySerializer_0).z5h = function (decoder, index, builder, checkIndex) {
    return this.e5l(decoder, index, builder instanceof CharArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(CharArraySerializer_0).i5l = function (encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        encoder.t5d(this.p5h_1, i, content[i]);
      }
       while (inductionVariable < size);
  };
  protoOf(CharArraySerializer_0).a5i = function (encoder, content, size) {
    return this.i5l(encoder, (!(content == null) ? isCharArray(content) : false) ? content : THROW_CCE(), size);
  };
  var CharArraySerializer_instance;
  function CharArraySerializer_getInstance() {
    if (CharArraySerializer_instance == null)
      new CharArraySerializer_0();
    return CharArraySerializer_instance;
  }
  function DoubleArraySerializer_0() {
    DoubleArraySerializer_instance = this;
    PrimitiveArraySerializer.call(this, serializer_12(DoubleCompanionObject_instance));
  }
  protoOf(DoubleArraySerializer_0).l5l = function (_this__u8e3s4) {
    return _this__u8e3s4.length;
  };
  protoOf(DoubleArraySerializer_0).a5g = function (_this__u8e3s4) {
    return this.l5l((!(_this__u8e3s4 == null) ? isDoubleArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(DoubleArraySerializer_0).m5l = function (_this__u8e3s4) {
    return new DoubleArrayBuilder(_this__u8e3s4);
  };
  protoOf(DoubleArraySerializer_0).i5f = function (_this__u8e3s4) {
    return this.m5l((!(_this__u8e3s4 == null) ? isDoubleArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(DoubleArraySerializer_0).y5h = function () {
    return new Float64Array(0);
  };
  protoOf(DoubleArraySerializer_0).n5l = function (decoder, index, builder, checkIndex) {
    builder.q5l(decoder.o5c(this.p5h_1, index));
  };
  protoOf(DoubleArraySerializer_0).t5f = function (decoder, index, builder, checkIndex) {
    return this.n5l(decoder, index, builder instanceof DoubleArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(DoubleArraySerializer_0).z5h = function (decoder, index, builder, checkIndex) {
    return this.n5l(decoder, index, builder instanceof DoubleArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(DoubleArraySerializer_0).r5l = function (encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        encoder.s5d(this.p5h_1, i, content[i]);
      }
       while (inductionVariable < size);
  };
  protoOf(DoubleArraySerializer_0).a5i = function (encoder, content, size) {
    return this.r5l(encoder, (!(content == null) ? isDoubleArray(content) : false) ? content : THROW_CCE(), size);
  };
  var DoubleArraySerializer_instance;
  function DoubleArraySerializer_getInstance() {
    if (DoubleArraySerializer_instance == null)
      new DoubleArraySerializer_0();
    return DoubleArraySerializer_instance;
  }
  function FloatArraySerializer_0() {
    FloatArraySerializer_instance = this;
    PrimitiveArraySerializer.call(this, serializer_13(FloatCompanionObject_instance));
  }
  protoOf(FloatArraySerializer_0).u5l = function (_this__u8e3s4) {
    return _this__u8e3s4.length;
  };
  protoOf(FloatArraySerializer_0).a5g = function (_this__u8e3s4) {
    return this.u5l((!(_this__u8e3s4 == null) ? isFloatArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(FloatArraySerializer_0).v5l = function (_this__u8e3s4) {
    return new FloatArrayBuilder(_this__u8e3s4);
  };
  protoOf(FloatArraySerializer_0).i5f = function (_this__u8e3s4) {
    return this.v5l((!(_this__u8e3s4 == null) ? isFloatArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(FloatArraySerializer_0).y5h = function () {
    return new Float32Array(0);
  };
  protoOf(FloatArraySerializer_0).w5l = function (decoder, index, builder, checkIndex) {
    builder.z5l(decoder.n5c(this.p5h_1, index));
  };
  protoOf(FloatArraySerializer_0).t5f = function (decoder, index, builder, checkIndex) {
    return this.w5l(decoder, index, builder instanceof FloatArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(FloatArraySerializer_0).z5h = function (decoder, index, builder, checkIndex) {
    return this.w5l(decoder, index, builder instanceof FloatArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(FloatArraySerializer_0).a5m = function (encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        encoder.r5d(this.p5h_1, i, content[i]);
      }
       while (inductionVariable < size);
  };
  protoOf(FloatArraySerializer_0).a5i = function (encoder, content, size) {
    return this.a5m(encoder, (!(content == null) ? isFloatArray(content) : false) ? content : THROW_CCE(), size);
  };
  var FloatArraySerializer_instance;
  function FloatArraySerializer_getInstance() {
    if (FloatArraySerializer_instance == null)
      new FloatArraySerializer_0();
    return FloatArraySerializer_instance;
  }
  function LongArraySerializer_0() {
    LongArraySerializer_instance = this;
    PrimitiveArraySerializer.call(this, serializer_14(Companion_instance_2));
  }
  protoOf(LongArraySerializer_0).d5m = function (_this__u8e3s4) {
    return _this__u8e3s4.length;
  };
  protoOf(LongArraySerializer_0).a5g = function (_this__u8e3s4) {
    return this.d5m((!(_this__u8e3s4 == null) ? isLongArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(LongArraySerializer_0).e5m = function (_this__u8e3s4) {
    return new LongArrayBuilder(_this__u8e3s4);
  };
  protoOf(LongArraySerializer_0).i5f = function (_this__u8e3s4) {
    return this.e5m((!(_this__u8e3s4 == null) ? isLongArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(LongArraySerializer_0).y5h = function () {
    return longArray(0);
  };
  protoOf(LongArraySerializer_0).f5m = function (decoder, index, builder, checkIndex) {
    builder.i5m(decoder.m5c(this.p5h_1, index));
  };
  protoOf(LongArraySerializer_0).t5f = function (decoder, index, builder, checkIndex) {
    return this.f5m(decoder, index, builder instanceof LongArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(LongArraySerializer_0).z5h = function (decoder, index, builder, checkIndex) {
    return this.f5m(decoder, index, builder instanceof LongArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(LongArraySerializer_0).j5m = function (encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        encoder.q5d(this.p5h_1, i, content[i]);
      }
       while (inductionVariable < size);
  };
  protoOf(LongArraySerializer_0).a5i = function (encoder, content, size) {
    return this.j5m(encoder, (!(content == null) ? isLongArray(content) : false) ? content : THROW_CCE(), size);
  };
  var LongArraySerializer_instance;
  function LongArraySerializer_getInstance() {
    if (LongArraySerializer_instance == null)
      new LongArraySerializer_0();
    return LongArraySerializer_instance;
  }
  function ULongArraySerializer_0() {
    ULongArraySerializer_instance = this;
    PrimitiveArraySerializer.call(this, serializer_6(Companion_getInstance_20()));
  }
  protoOf(ULongArraySerializer_0).m5m = function (_this__u8e3s4) {
    return _ULongArray___get_size__impl__ju6dtr(_this__u8e3s4);
  };
  protoOf(ULongArraySerializer_0).a5g = function (_this__u8e3s4) {
    return this.m5m(_this__u8e3s4 instanceof ULongArray ? _this__u8e3s4.gn_1 : THROW_CCE());
  };
  protoOf(ULongArraySerializer_0).n5m = function (_this__u8e3s4) {
    return new ULongArrayBuilder(_this__u8e3s4);
  };
  protoOf(ULongArraySerializer_0).i5f = function (_this__u8e3s4) {
    return this.n5m(_this__u8e3s4 instanceof ULongArray ? _this__u8e3s4.gn_1 : THROW_CCE());
  };
  protoOf(ULongArraySerializer_0).o5m = function () {
    return _ULongArray___init__impl__twm1l3_0(0);
  };
  protoOf(ULongArraySerializer_0).y5h = function () {
    return new ULongArray(this.o5m());
  };
  protoOf(ULongArraySerializer_0).p5m = function (decoder, index, builder, checkIndex) {
    // Inline function 'kotlin.toULong' call
    var this_0 = decoder.r5c(this.p5h_1, index).y5b();
    var tmp$ret$0 = _ULong___init__impl__c78o9k(this_0);
    builder.s5m(tmp$ret$0);
  };
  protoOf(ULongArraySerializer_0).t5f = function (decoder, index, builder, checkIndex) {
    return this.p5m(decoder, index, builder instanceof ULongArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(ULongArraySerializer_0).z5h = function (decoder, index, builder, checkIndex) {
    return this.p5m(decoder, index, builder instanceof ULongArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(ULongArraySerializer_0).t5m = function (encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = encoder.v5d(this.p5h_1, i);
        // Inline function 'kotlin.ULong.toLong' call
        var this_0 = ULongArray__get_impl_pr71q9(content, i);
        var tmp$ret$0 = _ULong___get_data__impl__fggpzb(this_0);
        tmp.f5d(tmp$ret$0);
      }
       while (inductionVariable < size);
  };
  protoOf(ULongArraySerializer_0).a5i = function (encoder, content, size) {
    return this.t5m(encoder, content instanceof ULongArray ? content.gn_1 : THROW_CCE(), size);
  };
  var ULongArraySerializer_instance;
  function ULongArraySerializer_getInstance() {
    if (ULongArraySerializer_instance == null)
      new ULongArraySerializer_0();
    return ULongArraySerializer_instance;
  }
  function IntArraySerializer_0() {
    IntArraySerializer_instance = this;
    PrimitiveArraySerializer.call(this, serializer_15(IntCompanionObject_instance));
  }
  protoOf(IntArraySerializer_0).w5m = function (_this__u8e3s4) {
    return _this__u8e3s4.length;
  };
  protoOf(IntArraySerializer_0).a5g = function (_this__u8e3s4) {
    return this.w5m((!(_this__u8e3s4 == null) ? isIntArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(IntArraySerializer_0).x5m = function (_this__u8e3s4) {
    return new IntArrayBuilder(_this__u8e3s4);
  };
  protoOf(IntArraySerializer_0).i5f = function (_this__u8e3s4) {
    return this.x5m((!(_this__u8e3s4 == null) ? isIntArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(IntArraySerializer_0).y5h = function () {
    return new Int32Array(0);
  };
  protoOf(IntArraySerializer_0).y5m = function (decoder, index, builder, checkIndex) {
    builder.b5n(decoder.l5c(this.p5h_1, index));
  };
  protoOf(IntArraySerializer_0).t5f = function (decoder, index, builder, checkIndex) {
    return this.y5m(decoder, index, builder instanceof IntArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(IntArraySerializer_0).z5h = function (decoder, index, builder, checkIndex) {
    return this.y5m(decoder, index, builder instanceof IntArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(IntArraySerializer_0).c5n = function (encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        encoder.p5d(this.p5h_1, i, content[i]);
      }
       while (inductionVariable < size);
  };
  protoOf(IntArraySerializer_0).a5i = function (encoder, content, size) {
    return this.c5n(encoder, (!(content == null) ? isIntArray(content) : false) ? content : THROW_CCE(), size);
  };
  var IntArraySerializer_instance;
  function IntArraySerializer_getInstance() {
    if (IntArraySerializer_instance == null)
      new IntArraySerializer_0();
    return IntArraySerializer_instance;
  }
  function UIntArraySerializer_0() {
    UIntArraySerializer_instance = this;
    PrimitiveArraySerializer.call(this, serializer_7(Companion_getInstance_19()));
  }
  protoOf(UIntArraySerializer_0).f5n = function (_this__u8e3s4) {
    return _UIntArray___get_size__impl__r6l8ci(_this__u8e3s4);
  };
  protoOf(UIntArraySerializer_0).a5g = function (_this__u8e3s4) {
    return this.f5n(_this__u8e3s4 instanceof UIntArray ? _this__u8e3s4.vm_1 : THROW_CCE());
  };
  protoOf(UIntArraySerializer_0).g5n = function (_this__u8e3s4) {
    return new UIntArrayBuilder(_this__u8e3s4);
  };
  protoOf(UIntArraySerializer_0).i5f = function (_this__u8e3s4) {
    return this.g5n(_this__u8e3s4 instanceof UIntArray ? _this__u8e3s4.vm_1 : THROW_CCE());
  };
  protoOf(UIntArraySerializer_0).h5n = function () {
    return _UIntArray___init__impl__ghjpc6_0(0);
  };
  protoOf(UIntArraySerializer_0).y5h = function () {
    return new UIntArray(this.h5n());
  };
  protoOf(UIntArraySerializer_0).i5n = function (decoder, index, builder, checkIndex) {
    // Inline function 'kotlin.toUInt' call
    var this_0 = decoder.r5c(this.p5h_1, index).x5b();
    var tmp$ret$0 = _UInt___init__impl__l7qpdl(this_0);
    builder.l5n(tmp$ret$0);
  };
  protoOf(UIntArraySerializer_0).t5f = function (decoder, index, builder, checkIndex) {
    return this.i5n(decoder, index, builder instanceof UIntArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(UIntArraySerializer_0).z5h = function (decoder, index, builder, checkIndex) {
    return this.i5n(decoder, index, builder instanceof UIntArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(UIntArraySerializer_0).m5n = function (encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = encoder.v5d(this.p5h_1, i);
        // Inline function 'kotlin.UInt.toInt' call
        var this_0 = UIntArray__get_impl_gp5kza(content, i);
        var tmp$ret$0 = _UInt___get_data__impl__f0vqqw(this_0);
        tmp.e5d(tmp$ret$0);
      }
       while (inductionVariable < size);
  };
  protoOf(UIntArraySerializer_0).a5i = function (encoder, content, size) {
    return this.m5n(encoder, content instanceof UIntArray ? content.vm_1 : THROW_CCE(), size);
  };
  var UIntArraySerializer_instance;
  function UIntArraySerializer_getInstance() {
    if (UIntArraySerializer_instance == null)
      new UIntArraySerializer_0();
    return UIntArraySerializer_instance;
  }
  function ShortArraySerializer_0() {
    ShortArraySerializer_instance = this;
    PrimitiveArraySerializer.call(this, serializer_16(ShortCompanionObject_instance));
  }
  protoOf(ShortArraySerializer_0).p5n = function (_this__u8e3s4) {
    return _this__u8e3s4.length;
  };
  protoOf(ShortArraySerializer_0).a5g = function (_this__u8e3s4) {
    return this.p5n((!(_this__u8e3s4 == null) ? isShortArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(ShortArraySerializer_0).q5n = function (_this__u8e3s4) {
    return new ShortArrayBuilder(_this__u8e3s4);
  };
  protoOf(ShortArraySerializer_0).i5f = function (_this__u8e3s4) {
    return this.q5n((!(_this__u8e3s4 == null) ? isShortArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(ShortArraySerializer_0).y5h = function () {
    return new Int16Array(0);
  };
  protoOf(ShortArraySerializer_0).r5n = function (decoder, index, builder, checkIndex) {
    builder.u5n(decoder.k5c(this.p5h_1, index));
  };
  protoOf(ShortArraySerializer_0).t5f = function (decoder, index, builder, checkIndex) {
    return this.r5n(decoder, index, builder instanceof ShortArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(ShortArraySerializer_0).z5h = function (decoder, index, builder, checkIndex) {
    return this.r5n(decoder, index, builder instanceof ShortArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(ShortArraySerializer_0).v5n = function (encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        encoder.o5d(this.p5h_1, i, content[i]);
      }
       while (inductionVariable < size);
  };
  protoOf(ShortArraySerializer_0).a5i = function (encoder, content, size) {
    return this.v5n(encoder, (!(content == null) ? isShortArray(content) : false) ? content : THROW_CCE(), size);
  };
  var ShortArraySerializer_instance;
  function ShortArraySerializer_getInstance() {
    if (ShortArraySerializer_instance == null)
      new ShortArraySerializer_0();
    return ShortArraySerializer_instance;
  }
  function UShortArraySerializer_0() {
    UShortArraySerializer_instance = this;
    PrimitiveArraySerializer.call(this, serializer_9(Companion_getInstance_21()));
  }
  protoOf(UShortArraySerializer_0).y5n = function (_this__u8e3s4) {
    return _UShortArray___get_size__impl__jqto1b(_this__u8e3s4);
  };
  protoOf(UShortArraySerializer_0).a5g = function (_this__u8e3s4) {
    return this.y5n(_this__u8e3s4 instanceof UShortArray ? _this__u8e3s4.rn_1 : THROW_CCE());
  };
  protoOf(UShortArraySerializer_0).z5n = function (_this__u8e3s4) {
    return new UShortArrayBuilder(_this__u8e3s4);
  };
  protoOf(UShortArraySerializer_0).i5f = function (_this__u8e3s4) {
    return this.z5n(_this__u8e3s4 instanceof UShortArray ? _this__u8e3s4.rn_1 : THROW_CCE());
  };
  protoOf(UShortArraySerializer_0).a5o = function () {
    return _UShortArray___init__impl__9b26ef_0(0);
  };
  protoOf(UShortArraySerializer_0).y5h = function () {
    return new UShortArray(this.a5o());
  };
  protoOf(UShortArraySerializer_0).b5o = function (decoder, index, builder, checkIndex) {
    // Inline function 'kotlin.toUShort' call
    var this_0 = decoder.r5c(this.p5h_1, index).w5b();
    var tmp$ret$0 = _UShort___init__impl__jigrne(this_0);
    builder.e5o(tmp$ret$0);
  };
  protoOf(UShortArraySerializer_0).t5f = function (decoder, index, builder, checkIndex) {
    return this.b5o(decoder, index, builder instanceof UShortArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(UShortArraySerializer_0).z5h = function (decoder, index, builder, checkIndex) {
    return this.b5o(decoder, index, builder instanceof UShortArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(UShortArraySerializer_0).f5o = function (encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = encoder.v5d(this.p5h_1, i);
        // Inline function 'kotlin.UShort.toShort' call
        var this_0 = UShortArray__get_impl_fnbhmx(content, i);
        var tmp$ret$0 = _UShort___get_data__impl__g0245(this_0);
        tmp.d5d(tmp$ret$0);
      }
       while (inductionVariable < size);
  };
  protoOf(UShortArraySerializer_0).a5i = function (encoder, content, size) {
    return this.f5o(encoder, content instanceof UShortArray ? content.rn_1 : THROW_CCE(), size);
  };
  var UShortArraySerializer_instance;
  function UShortArraySerializer_getInstance() {
    if (UShortArraySerializer_instance == null)
      new UShortArraySerializer_0();
    return UShortArraySerializer_instance;
  }
  function UByteArraySerializer_0() {
    UByteArraySerializer_instance = this;
    PrimitiveArraySerializer.call(this, serializer_8(Companion_getInstance_18()));
  }
  protoOf(UByteArraySerializer_0).i5o = function (_this__u8e3s4) {
    return _UByteArray___get_size__impl__h6pkdv(_this__u8e3s4);
  };
  protoOf(UByteArraySerializer_0).a5g = function (_this__u8e3s4) {
    return this.i5o(_this__u8e3s4 instanceof UByteArray ? _this__u8e3s4.jm_1 : THROW_CCE());
  };
  protoOf(UByteArraySerializer_0).j5o = function (_this__u8e3s4) {
    return new UByteArrayBuilder(_this__u8e3s4);
  };
  protoOf(UByteArraySerializer_0).i5f = function (_this__u8e3s4) {
    return this.j5o(_this__u8e3s4 instanceof UByteArray ? _this__u8e3s4.jm_1 : THROW_CCE());
  };
  protoOf(UByteArraySerializer_0).k5o = function () {
    return _UByteArray___init__impl__ip4y9n_0(0);
  };
  protoOf(UByteArraySerializer_0).y5h = function () {
    return new UByteArray(this.k5o());
  };
  protoOf(UByteArraySerializer_0).l5o = function (decoder, index, builder, checkIndex) {
    // Inline function 'kotlin.toUByte' call
    var this_0 = decoder.r5c(this.p5h_1, index).v5b();
    var tmp$ret$0 = _UByte___init__impl__g9hnc4(this_0);
    builder.o5o(tmp$ret$0);
  };
  protoOf(UByteArraySerializer_0).t5f = function (decoder, index, builder, checkIndex) {
    return this.l5o(decoder, index, builder instanceof UByteArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(UByteArraySerializer_0).z5h = function (decoder, index, builder, checkIndex) {
    return this.l5o(decoder, index, builder instanceof UByteArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(UByteArraySerializer_0).p5o = function (encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = encoder.v5d(this.p5h_1, i);
        // Inline function 'kotlin.UByte.toByte' call
        var this_0 = UByteArray__get_impl_t5f3hv(content, i);
        var tmp$ret$0 = _UByte___get_data__impl__jof9qr(this_0);
        tmp.c5d(tmp$ret$0);
      }
       while (inductionVariable < size);
  };
  protoOf(UByteArraySerializer_0).a5i = function (encoder, content, size) {
    return this.p5o(encoder, content instanceof UByteArray ? content.jm_1 : THROW_CCE(), size);
  };
  var UByteArraySerializer_instance;
  function UByteArraySerializer_getInstance() {
    if (UByteArraySerializer_instance == null)
      new UByteArraySerializer_0();
    return UByteArraySerializer_instance;
  }
  function BooleanArraySerializer_0() {
    BooleanArraySerializer_instance = this;
    PrimitiveArraySerializer.call(this, serializer_4(BooleanCompanionObject_instance));
  }
  protoOf(BooleanArraySerializer_0).s5o = function (_this__u8e3s4) {
    return _this__u8e3s4.length;
  };
  protoOf(BooleanArraySerializer_0).a5g = function (_this__u8e3s4) {
    return this.s5o((!(_this__u8e3s4 == null) ? isBooleanArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(BooleanArraySerializer_0).t5o = function (_this__u8e3s4) {
    return new BooleanArrayBuilder(_this__u8e3s4);
  };
  protoOf(BooleanArraySerializer_0).i5f = function (_this__u8e3s4) {
    return this.t5o((!(_this__u8e3s4 == null) ? isBooleanArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(BooleanArraySerializer_0).y5h = function () {
    return booleanArray(0);
  };
  protoOf(BooleanArraySerializer_0).u5o = function (decoder, index, builder, checkIndex) {
    builder.x5o(decoder.i5c(this.p5h_1, index));
  };
  protoOf(BooleanArraySerializer_0).t5f = function (decoder, index, builder, checkIndex) {
    return this.u5o(decoder, index, builder instanceof BooleanArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(BooleanArraySerializer_0).z5h = function (decoder, index, builder, checkIndex) {
    return this.u5o(decoder, index, builder instanceof BooleanArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(BooleanArraySerializer_0).y5o = function (encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        encoder.m5d(this.p5h_1, i, content[i]);
      }
       while (inductionVariable < size);
  };
  protoOf(BooleanArraySerializer_0).a5i = function (encoder, content, size) {
    return this.y5o(encoder, (!(content == null) ? isBooleanArray(content) : false) ? content : THROW_CCE(), size);
  };
  var BooleanArraySerializer_instance;
  function BooleanArraySerializer_getInstance() {
    if (BooleanArraySerializer_instance == null)
      new BooleanArraySerializer_0();
    return BooleanArraySerializer_instance;
  }
  function CharArrayBuilder(bufferWithData) {
    PrimitiveArrayBuilder.call(this);
    this.f5l_1 = bufferWithData;
    this.g5l_1 = bufferWithData.length;
    this.v5h(10);
  }
  protoOf(CharArrayBuilder).r5h = function () {
    return this.g5l_1;
  };
  protoOf(CharArrayBuilder).v5h = function (requiredCapacity) {
    if (this.f5l_1.length < requiredCapacity)
      this.f5l_1 = copyOf_3(this.f5l_1, coerceAtLeast(requiredCapacity, imul(this.f5l_1.length, 2)));
  };
  protoOf(CharArrayBuilder).h5l = function (c) {
    this.c5i();
    var tmp = this.f5l_1;
    var tmp1 = this.g5l_1;
    this.g5l_1 = tmp1 + 1 | 0;
    tmp[tmp1] = c;
  };
  protoOf(CharArrayBuilder).t5h = function () {
    return copyOf_3(this.f5l_1, this.g5l_1);
  };
  function DoubleArrayBuilder(bufferWithData) {
    PrimitiveArrayBuilder.call(this);
    this.o5l_1 = bufferWithData;
    this.p5l_1 = bufferWithData.length;
    this.v5h(10);
  }
  protoOf(DoubleArrayBuilder).r5h = function () {
    return this.p5l_1;
  };
  protoOf(DoubleArrayBuilder).v5h = function (requiredCapacity) {
    if (this.o5l_1.length < requiredCapacity)
      this.o5l_1 = copyOf_4(this.o5l_1, coerceAtLeast(requiredCapacity, imul(this.o5l_1.length, 2)));
  };
  protoOf(DoubleArrayBuilder).q5l = function (c) {
    this.c5i();
    var tmp = this.o5l_1;
    var tmp1 = this.p5l_1;
    this.p5l_1 = tmp1 + 1 | 0;
    tmp[tmp1] = c;
  };
  protoOf(DoubleArrayBuilder).t5h = function () {
    return copyOf_4(this.o5l_1, this.p5l_1);
  };
  function FloatArrayBuilder(bufferWithData) {
    PrimitiveArrayBuilder.call(this);
    this.x5l_1 = bufferWithData;
    this.y5l_1 = bufferWithData.length;
    this.v5h(10);
  }
  protoOf(FloatArrayBuilder).r5h = function () {
    return this.y5l_1;
  };
  protoOf(FloatArrayBuilder).v5h = function (requiredCapacity) {
    if (this.x5l_1.length < requiredCapacity)
      this.x5l_1 = copyOf_5(this.x5l_1, coerceAtLeast(requiredCapacity, imul(this.x5l_1.length, 2)));
  };
  protoOf(FloatArrayBuilder).z5l = function (c) {
    this.c5i();
    var tmp = this.x5l_1;
    var tmp1 = this.y5l_1;
    this.y5l_1 = tmp1 + 1 | 0;
    tmp[tmp1] = c;
  };
  protoOf(FloatArrayBuilder).t5h = function () {
    return copyOf_5(this.x5l_1, this.y5l_1);
  };
  function LongArrayBuilder(bufferWithData) {
    PrimitiveArrayBuilder.call(this);
    this.g5m_1 = bufferWithData;
    this.h5m_1 = bufferWithData.length;
    this.v5h(10);
  }
  protoOf(LongArrayBuilder).r5h = function () {
    return this.h5m_1;
  };
  protoOf(LongArrayBuilder).v5h = function (requiredCapacity) {
    if (this.g5m_1.length < requiredCapacity)
      this.g5m_1 = copyOf_2(this.g5m_1, coerceAtLeast(requiredCapacity, imul(this.g5m_1.length, 2)));
  };
  protoOf(LongArrayBuilder).i5m = function (c) {
    this.c5i();
    var tmp = this.g5m_1;
    var tmp1 = this.h5m_1;
    this.h5m_1 = tmp1 + 1 | 0;
    tmp[tmp1] = c;
  };
  protoOf(LongArrayBuilder).t5h = function () {
    return copyOf_2(this.g5m_1, this.h5m_1);
  };
  function ULongArrayBuilder(bufferWithData) {
    PrimitiveArrayBuilder.call(this);
    this.q5m_1 = bufferWithData;
    this.r5m_1 = _ULongArray___get_size__impl__ju6dtr(bufferWithData);
    this.v5h(10);
  }
  protoOf(ULongArrayBuilder).r5h = function () {
    return this.r5m_1;
  };
  protoOf(ULongArrayBuilder).v5h = function (requiredCapacity) {
    if (_ULongArray___get_size__impl__ju6dtr(this.q5m_1) < requiredCapacity) {
      var tmp = this;
      var tmp0 = this.q5m_1;
      // Inline function 'kotlin.collections.copyOf' call
      var newSize = coerceAtLeast(requiredCapacity, imul(_ULongArray___get_size__impl__ju6dtr(this.q5m_1), 2));
      tmp.q5m_1 = _ULongArray___init__impl__twm1l3(copyOf_2(_ULongArray___get_storage__impl__28e64j(tmp0), newSize));
    }
  };
  protoOf(ULongArrayBuilder).s5m = function (c) {
    this.c5i();
    var tmp = this.q5m_1;
    var tmp1 = this.r5m_1;
    this.r5m_1 = tmp1 + 1 | 0;
    ULongArray__set_impl_z19mvh(tmp, tmp1, c);
  };
  protoOf(ULongArrayBuilder).z5o = function () {
    var tmp0 = this.q5m_1;
    // Inline function 'kotlin.collections.copyOf' call
    var newSize = this.r5m_1;
    return _ULongArray___init__impl__twm1l3(copyOf_2(_ULongArray___get_storage__impl__28e64j(tmp0), newSize));
  };
  protoOf(ULongArrayBuilder).t5h = function () {
    return new ULongArray(this.z5o());
  };
  function IntArrayBuilder(bufferWithData) {
    PrimitiveArrayBuilder.call(this);
    this.z5m_1 = bufferWithData;
    this.a5n_1 = bufferWithData.length;
    this.v5h(10);
  }
  protoOf(IntArrayBuilder).r5h = function () {
    return this.a5n_1;
  };
  protoOf(IntArrayBuilder).v5h = function (requiredCapacity) {
    if (this.z5m_1.length < requiredCapacity)
      this.z5m_1 = copyOf(this.z5m_1, coerceAtLeast(requiredCapacity, imul(this.z5m_1.length, 2)));
  };
  protoOf(IntArrayBuilder).b5n = function (c) {
    this.c5i();
    var tmp = this.z5m_1;
    var tmp1 = this.a5n_1;
    this.a5n_1 = tmp1 + 1 | 0;
    tmp[tmp1] = c;
  };
  protoOf(IntArrayBuilder).t5h = function () {
    return copyOf(this.z5m_1, this.a5n_1);
  };
  function UIntArrayBuilder(bufferWithData) {
    PrimitiveArrayBuilder.call(this);
    this.j5n_1 = bufferWithData;
    this.k5n_1 = _UIntArray___get_size__impl__r6l8ci(bufferWithData);
    this.v5h(10);
  }
  protoOf(UIntArrayBuilder).r5h = function () {
    return this.k5n_1;
  };
  protoOf(UIntArrayBuilder).v5h = function (requiredCapacity) {
    if (_UIntArray___get_size__impl__r6l8ci(this.j5n_1) < requiredCapacity) {
      var tmp = this;
      var tmp0 = this.j5n_1;
      // Inline function 'kotlin.collections.copyOf' call
      var newSize = coerceAtLeast(requiredCapacity, imul(_UIntArray___get_size__impl__r6l8ci(this.j5n_1), 2));
      tmp.j5n_1 = _UIntArray___init__impl__ghjpc6(copyOf(_UIntArray___get_storage__impl__92a0v0(tmp0), newSize));
    }
  };
  protoOf(UIntArrayBuilder).l5n = function (c) {
    this.c5i();
    var tmp = this.j5n_1;
    var tmp1 = this.k5n_1;
    this.k5n_1 = tmp1 + 1 | 0;
    UIntArray__set_impl_7f2zu2(tmp, tmp1, c);
  };
  protoOf(UIntArrayBuilder).a5p = function () {
    var tmp0 = this.j5n_1;
    // Inline function 'kotlin.collections.copyOf' call
    var newSize = this.k5n_1;
    return _UIntArray___init__impl__ghjpc6(copyOf(_UIntArray___get_storage__impl__92a0v0(tmp0), newSize));
  };
  protoOf(UIntArrayBuilder).t5h = function () {
    return new UIntArray(this.a5p());
  };
  function ShortArrayBuilder(bufferWithData) {
    PrimitiveArrayBuilder.call(this);
    this.s5n_1 = bufferWithData;
    this.t5n_1 = bufferWithData.length;
    this.v5h(10);
  }
  protoOf(ShortArrayBuilder).r5h = function () {
    return this.t5n_1;
  };
  protoOf(ShortArrayBuilder).v5h = function (requiredCapacity) {
    if (this.s5n_1.length < requiredCapacity)
      this.s5n_1 = copyOf_6(this.s5n_1, coerceAtLeast(requiredCapacity, imul(this.s5n_1.length, 2)));
  };
  protoOf(ShortArrayBuilder).u5n = function (c) {
    this.c5i();
    var tmp = this.s5n_1;
    var tmp1 = this.t5n_1;
    this.t5n_1 = tmp1 + 1 | 0;
    tmp[tmp1] = c;
  };
  protoOf(ShortArrayBuilder).t5h = function () {
    return copyOf_6(this.s5n_1, this.t5n_1);
  };
  function UShortArrayBuilder(bufferWithData) {
    PrimitiveArrayBuilder.call(this);
    this.c5o_1 = bufferWithData;
    this.d5o_1 = _UShortArray___get_size__impl__jqto1b(bufferWithData);
    this.v5h(10);
  }
  protoOf(UShortArrayBuilder).r5h = function () {
    return this.d5o_1;
  };
  protoOf(UShortArrayBuilder).v5h = function (requiredCapacity) {
    if (_UShortArray___get_size__impl__jqto1b(this.c5o_1) < requiredCapacity) {
      var tmp = this;
      var tmp0 = this.c5o_1;
      // Inline function 'kotlin.collections.copyOf' call
      var newSize = coerceAtLeast(requiredCapacity, imul(_UShortArray___get_size__impl__jqto1b(this.c5o_1), 2));
      tmp.c5o_1 = _UShortArray___init__impl__9b26ef(copyOf_6(_UShortArray___get_storage__impl__t2jpv5(tmp0), newSize));
    }
  };
  protoOf(UShortArrayBuilder).e5o = function (c) {
    this.c5i();
    var tmp = this.c5o_1;
    var tmp1 = this.d5o_1;
    this.d5o_1 = tmp1 + 1 | 0;
    UShortArray__set_impl_6d8whp(tmp, tmp1, c);
  };
  protoOf(UShortArrayBuilder).b5p = function () {
    var tmp0 = this.c5o_1;
    // Inline function 'kotlin.collections.copyOf' call
    var newSize = this.d5o_1;
    return _UShortArray___init__impl__9b26ef(copyOf_6(_UShortArray___get_storage__impl__t2jpv5(tmp0), newSize));
  };
  protoOf(UShortArrayBuilder).t5h = function () {
    return new UShortArray(this.b5p());
  };
  function UByteArrayBuilder(bufferWithData) {
    PrimitiveArrayBuilder.call(this);
    this.m5o_1 = bufferWithData;
    this.n5o_1 = _UByteArray___get_size__impl__h6pkdv(bufferWithData);
    this.v5h(10);
  }
  protoOf(UByteArrayBuilder).r5h = function () {
    return this.n5o_1;
  };
  protoOf(UByteArrayBuilder).v5h = function (requiredCapacity) {
    if (_UByteArray___get_size__impl__h6pkdv(this.m5o_1) < requiredCapacity) {
      var tmp = this;
      var tmp0 = this.m5o_1;
      // Inline function 'kotlin.collections.copyOf' call
      var newSize = coerceAtLeast(requiredCapacity, imul(_UByteArray___get_size__impl__h6pkdv(this.m5o_1), 2));
      tmp.m5o_1 = _UByteArray___init__impl__ip4y9n(copyOf_0(_UByteArray___get_storage__impl__d4kctt(tmp0), newSize));
    }
  };
  protoOf(UByteArrayBuilder).o5o = function (c) {
    this.c5i();
    var tmp = this.m5o_1;
    var tmp1 = this.n5o_1;
    this.n5o_1 = tmp1 + 1 | 0;
    UByteArray__set_impl_jvcicn(tmp, tmp1, c);
  };
  protoOf(UByteArrayBuilder).c5p = function () {
    var tmp0 = this.m5o_1;
    // Inline function 'kotlin.collections.copyOf' call
    var newSize = this.n5o_1;
    return _UByteArray___init__impl__ip4y9n(copyOf_0(_UByteArray___get_storage__impl__d4kctt(tmp0), newSize));
  };
  protoOf(UByteArrayBuilder).t5h = function () {
    return new UByteArray(this.c5p());
  };
  function BooleanArrayBuilder(bufferWithData) {
    PrimitiveArrayBuilder.call(this);
    this.v5o_1 = bufferWithData;
    this.w5o_1 = bufferWithData.length;
    this.v5h(10);
  }
  protoOf(BooleanArrayBuilder).r5h = function () {
    return this.w5o_1;
  };
  protoOf(BooleanArrayBuilder).v5h = function (requiredCapacity) {
    if (this.v5o_1.length < requiredCapacity)
      this.v5o_1 = copyOf_7(this.v5o_1, coerceAtLeast(requiredCapacity, imul(this.v5o_1.length, 2)));
  };
  protoOf(BooleanArrayBuilder).x5o = function (c) {
    this.c5i();
    var tmp = this.v5o_1;
    var tmp1 = this.w5o_1;
    this.w5o_1 = tmp1 + 1 | 0;
    tmp[tmp1] = c;
  };
  protoOf(BooleanArrayBuilder).t5h = function () {
    return copyOf_7(this.v5o_1, this.w5o_1);
  };
  function get_BUILTIN_SERIALIZERS() {
    _init_properties_Primitives_kt__k0eto4();
    return BUILTIN_SERIALIZERS;
  }
  var BUILTIN_SERIALIZERS;
  function StringSerializer() {
    StringSerializer_instance = this;
    this.d5p_1 = new PrimitiveSerialDescriptor_0('kotlin.String', STRING_getInstance());
  }
  protoOf(StringSerializer).v58 = function () {
    return this.d5p_1;
  };
  protoOf(StringSerializer).e5p = function (encoder, value) {
    return encoder.j5d(value);
  };
  protoOf(StringSerializer).i59 = function (encoder, value) {
    return this.e5p(encoder, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
  };
  protoOf(StringSerializer).j59 = function (decoder) {
    return decoder.c5c();
  };
  var StringSerializer_instance;
  function StringSerializer_getInstance() {
    if (StringSerializer_instance == null)
      new StringSerializer();
    return StringSerializer_instance;
  }
  function BooleanSerializer() {
    BooleanSerializer_instance = this;
    this.f5p_1 = new PrimitiveSerialDescriptor_0('kotlin.Boolean', BOOLEAN_getInstance());
  }
  protoOf(BooleanSerializer).v58 = function () {
    return this.f5p_1;
  };
  protoOf(BooleanSerializer).g5p = function (encoder, value) {
    return encoder.b5d(value);
  };
  protoOf(BooleanSerializer).i59 = function (encoder, value) {
    return this.g5p(encoder, (!(value == null) ? typeof value === 'boolean' : false) ? value : THROW_CCE());
  };
  protoOf(BooleanSerializer).j59 = function (decoder) {
    return decoder.u5b();
  };
  var BooleanSerializer_instance;
  function BooleanSerializer_getInstance() {
    if (BooleanSerializer_instance == null)
      new BooleanSerializer();
    return BooleanSerializer_instance;
  }
  function IntSerializer() {
    IntSerializer_instance = this;
    this.h5p_1 = new PrimitiveSerialDescriptor_0('kotlin.Int', INT_getInstance());
  }
  protoOf(IntSerializer).v58 = function () {
    return this.h5p_1;
  };
  protoOf(IntSerializer).i5p = function (encoder, value) {
    return encoder.e5d(value);
  };
  protoOf(IntSerializer).i59 = function (encoder, value) {
    return this.i5p(encoder, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
  };
  protoOf(IntSerializer).j59 = function (decoder) {
    return decoder.x5b();
  };
  var IntSerializer_instance;
  function IntSerializer_getInstance() {
    if (IntSerializer_instance == null)
      new IntSerializer();
    return IntSerializer_instance;
  }
  function LongSerializer() {
    LongSerializer_instance = this;
    this.j5p_1 = new PrimitiveSerialDescriptor_0('kotlin.Long', LONG_getInstance());
  }
  protoOf(LongSerializer).v58 = function () {
    return this.j5p_1;
  };
  protoOf(LongSerializer).k5p = function (encoder, value) {
    return encoder.f5d(value);
  };
  protoOf(LongSerializer).i59 = function (encoder, value) {
    return this.k5p(encoder, (!(value == null) ? typeof value === 'bigint' : false) ? value : THROW_CCE());
  };
  protoOf(LongSerializer).j59 = function (decoder) {
    return decoder.y5b();
  };
  var LongSerializer_instance;
  function LongSerializer_getInstance() {
    if (LongSerializer_instance == null)
      new LongSerializer();
    return LongSerializer_instance;
  }
  function builtinSerializerOrNull(_this__u8e3s4) {
    _init_properties_Primitives_kt__k0eto4();
    var tmp = get_BUILTIN_SERIALIZERS().q2(_this__u8e3s4);
    return (tmp == null ? true : isInterface(tmp, KSerializer)) ? tmp : THROW_CCE();
  }
  function UnitSerializer() {
    UnitSerializer_instance = this;
    this.l5p_1 = new ObjectSerializer('kotlin.Unit', Unit_instance);
  }
  protoOf(UnitSerializer).v58 = function () {
    return this.l5p_1.v58();
  };
  protoOf(UnitSerializer).m5p = function (decoder) {
    this.l5p_1.j59(decoder);
  };
  protoOf(UnitSerializer).j59 = function (decoder) {
    this.m5p(decoder);
    return Unit_instance;
  };
  protoOf(UnitSerializer).n5p = function (encoder, value) {
    this.l5p_1.f59(encoder, Unit_instance);
  };
  protoOf(UnitSerializer).i59 = function (encoder, value) {
    return this.n5p(encoder, value instanceof Unit ? value : THROW_CCE());
  };
  var UnitSerializer_instance;
  function UnitSerializer_getInstance() {
    if (UnitSerializer_instance == null)
      new UnitSerializer();
    return UnitSerializer_instance;
  }
  function PrimitiveDescriptorSafe(serialName, kind) {
    _init_properties_Primitives_kt__k0eto4();
    checkName(serialName);
    return new PrimitiveSerialDescriptor_0(serialName, kind);
  }
  function error_3($this) {
    throw IllegalStateException_init_$Create$_0('Primitive descriptor does not have elements');
  }
  function PrimitiveSerialDescriptor_0(serialName, kind) {
    this.o5p_1 = serialName;
    this.p5p_1 = kind;
  }
  protoOf(PrimitiveSerialDescriptor_0).z59 = function () {
    return this.o5p_1;
  };
  protoOf(PrimitiveSerialDescriptor_0).r5a = function () {
    return this.p5p_1;
  };
  protoOf(PrimitiveSerialDescriptor_0).p5a = function () {
    return 0;
  };
  protoOf(PrimitiveSerialDescriptor_0).v5a = function (index) {
    error_3(this);
  };
  protoOf(PrimitiveSerialDescriptor_0).u5a = function (name) {
    error_3(this);
  };
  protoOf(PrimitiveSerialDescriptor_0).w5a = function (index) {
    error_3(this);
  };
  protoOf(PrimitiveSerialDescriptor_0).t5a = function (index) {
    error_3(this);
  };
  protoOf(PrimitiveSerialDescriptor_0).s5a = function (index) {
    error_3(this);
  };
  protoOf(PrimitiveSerialDescriptor_0).toString = function () {
    return 'PrimitiveDescriptor(' + this.o5p_1 + ')';
  };
  protoOf(PrimitiveSerialDescriptor_0).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PrimitiveSerialDescriptor_0))
      return false;
    if (this.o5p_1 === other.o5p_1 && equals(this.p5p_1, other.p5p_1))
      return true;
    return false;
  };
  protoOf(PrimitiveSerialDescriptor_0).hashCode = function () {
    return getStringHashCode(this.o5p_1) + imul(31, this.p5p_1.hashCode()) | 0;
  };
  function checkName(serialName) {
    _init_properties_Primitives_kt__k0eto4();
    var keys = get_BUILTIN_SERIALIZERS().r2();
    var tmp0_iterator = keys.m();
    while (tmp0_iterator.n()) {
      var primitive = tmp0_iterator.o();
      var simpleName = capitalize(ensureNotNull(primitive.ra()));
      var qualifiedName = 'kotlin.' + simpleName;
      if (equals_0(serialName, qualifiedName, true) || equals_0(serialName, simpleName, true)) {
        throw IllegalArgumentException_init_$Create$_0(trimIndent('\n                The name of serial descriptor should uniquely identify associated serializer.\n                For serial name ' + serialName + ' there already exist ' + capitalize(simpleName) + 'Serializer.\n                Please refer to SerialDescriptor documentation for additional information.\n            '));
      }
    }
  }
  function capitalize(_this__u8e3s4) {
    _init_properties_Primitives_kt__k0eto4();
    // Inline function 'kotlin.text.replaceFirstChar' call
    var tmp;
    // Inline function 'kotlin.text.isNotEmpty' call
    if (charSequenceLength(_this__u8e3s4) > 0) {
      var it = charCodeAt(_this__u8e3s4, 0);
      var tmp$ret$1 = isLowerCase(it) ? titlecase(it) : toString(it);
      tmp = toString_1(tmp$ret$1) + substring_0(_this__u8e3s4, 1);
    } else {
      tmp = _this__u8e3s4;
    }
    return tmp;
  }
  function ByteSerializer() {
    ByteSerializer_instance = this;
    this.q5p_1 = new PrimitiveSerialDescriptor_0('kotlin.Byte', BYTE_getInstance());
  }
  protoOf(ByteSerializer).v58 = function () {
    return this.q5p_1;
  };
  protoOf(ByteSerializer).r5p = function (encoder, value) {
    return encoder.c5d(value);
  };
  protoOf(ByteSerializer).i59 = function (encoder, value) {
    return this.r5p(encoder, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
  };
  protoOf(ByteSerializer).j59 = function (decoder) {
    return decoder.v5b();
  };
  var ByteSerializer_instance;
  function ByteSerializer_getInstance() {
    if (ByteSerializer_instance == null)
      new ByteSerializer();
    return ByteSerializer_instance;
  }
  function CharSerializer() {
    CharSerializer_instance = this;
    this.s5p_1 = new PrimitiveSerialDescriptor_0('kotlin.Char', CHAR_getInstance());
  }
  protoOf(CharSerializer).v58 = function () {
    return this.s5p_1;
  };
  protoOf(CharSerializer).t5p = function (encoder, value) {
    return encoder.i5d(value);
  };
  protoOf(CharSerializer).i59 = function (encoder, value) {
    return this.t5p(encoder, value instanceof Char ? value.s1_1 : THROW_CCE());
  };
  protoOf(CharSerializer).u5p = function (decoder) {
    return decoder.b5c();
  };
  protoOf(CharSerializer).j59 = function (decoder) {
    return new Char(this.u5p(decoder));
  };
  var CharSerializer_instance;
  function CharSerializer_getInstance() {
    if (CharSerializer_instance == null)
      new CharSerializer();
    return CharSerializer_instance;
  }
  function DoubleSerializer() {
    DoubleSerializer_instance = this;
    this.v5p_1 = new PrimitiveSerialDescriptor_0('kotlin.Double', DOUBLE_getInstance());
  }
  protoOf(DoubleSerializer).v58 = function () {
    return this.v5p_1;
  };
  protoOf(DoubleSerializer).w5p = function (encoder, value) {
    return encoder.h5d(value);
  };
  protoOf(DoubleSerializer).i59 = function (encoder, value) {
    return this.w5p(encoder, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
  };
  protoOf(DoubleSerializer).j59 = function (decoder) {
    return decoder.a5c();
  };
  var DoubleSerializer_instance;
  function DoubleSerializer_getInstance() {
    if (DoubleSerializer_instance == null)
      new DoubleSerializer();
    return DoubleSerializer_instance;
  }
  function FloatSerializer() {
    FloatSerializer_instance = this;
    this.x5p_1 = new PrimitiveSerialDescriptor_0('kotlin.Float', FLOAT_getInstance());
  }
  protoOf(FloatSerializer).v58 = function () {
    return this.x5p_1;
  };
  protoOf(FloatSerializer).y5p = function (encoder, value) {
    return encoder.g5d(value);
  };
  protoOf(FloatSerializer).i59 = function (encoder, value) {
    return this.y5p(encoder, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
  };
  protoOf(FloatSerializer).j59 = function (decoder) {
    return decoder.z5b();
  };
  var FloatSerializer_instance;
  function FloatSerializer_getInstance() {
    if (FloatSerializer_instance == null)
      new FloatSerializer();
    return FloatSerializer_instance;
  }
  function ShortSerializer() {
    ShortSerializer_instance = this;
    this.z5p_1 = new PrimitiveSerialDescriptor_0('kotlin.Short', SHORT_getInstance());
  }
  protoOf(ShortSerializer).v58 = function () {
    return this.z5p_1;
  };
  protoOf(ShortSerializer).a5q = function (encoder, value) {
    return encoder.d5d(value);
  };
  protoOf(ShortSerializer).i59 = function (encoder, value) {
    return this.a5q(encoder, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
  };
  protoOf(ShortSerializer).j59 = function (decoder) {
    return decoder.w5b();
  };
  var ShortSerializer_instance;
  function ShortSerializer_getInstance() {
    if (ShortSerializer_instance == null)
      new ShortSerializer();
    return ShortSerializer_instance;
  }
  var properties_initialized_Primitives_kt_6dpii6;
  function _init_properties_Primitives_kt__k0eto4() {
    if (!properties_initialized_Primitives_kt_6dpii6) {
      properties_initialized_Primitives_kt_6dpii6 = true;
      BUILTIN_SERIALIZERS = mapOf_0([to(PrimitiveClasses_getInstance().tb(), serializer_5(StringCompanionObject_instance)), to(getKClass(Char), serializer_11(Companion_getInstance())), to(PrimitiveClasses_getInstance().wb(), CharArraySerializer()), to(PrimitiveClasses_getInstance().rb(), serializer_12(DoubleCompanionObject_instance)), to(PrimitiveClasses_getInstance().cc(), DoubleArraySerializer()), to(PrimitiveClasses_getInstance().qb(), serializer_13(FloatCompanionObject_instance)), to(PrimitiveClasses_getInstance().bc(), FloatArraySerializer()), to(PrimitiveClasses_getInstance().pb(), serializer_14(Companion_instance_2)), to(PrimitiveClasses_getInstance().ac(), LongArraySerializer()), to(getKClass(ULong), serializer_6(Companion_getInstance_20())), to(getKClass(ULongArray), ULongArraySerializer()), to(PrimitiveClasses_getInstance().ob(), serializer_15(IntCompanionObject_instance)), to(PrimitiveClasses_getInstance().zb(), IntArraySerializer()), to(getKClass(UInt), serializer_7(Companion_getInstance_19())), to(getKClass(UIntArray), UIntArraySerializer()), to(PrimitiveClasses_getInstance().nb(), serializer_16(ShortCompanionObject_instance)), to(PrimitiveClasses_getInstance().yb(), ShortArraySerializer()), to(getKClass(UShort), serializer_9(Companion_getInstance_21())), to(getKClass(UShortArray), UShortArraySerializer()), to(PrimitiveClasses_getInstance().mb(), serializer_10(ByteCompanionObject_instance)), to(PrimitiveClasses_getInstance().xb(), ByteArraySerializer()), to(getKClass(UByte), serializer_8(Companion_getInstance_18())), to(getKClass(UByteArray), UByteArraySerializer()), to(PrimitiveClasses_getInstance().lb(), serializer_4(BooleanCompanionObject_instance)), to(PrimitiveClasses_getInstance().vb(), BooleanArraySerializer()), to(getKClass(Unit), serializer_3(Unit_instance)), to(PrimitiveClasses_getInstance().kb(), NothingSerializer()), to(getKClass(Duration), serializer_17(Companion_getInstance_16()))]);
    }
  }
  function NamedValueDecoder() {
    TaggedDecoder.call(this);
  }
  protoOf(NamedValueDecoder).d5q = function (_this__u8e3s4, index) {
    return this.f5q(this.e5q(_this__u8e3s4, index));
  };
  protoOf(NamedValueDecoder).f5q = function (nestedName) {
    var tmp0_elvis_lhs = this.i5q();
    return this.j5q(tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs, nestedName);
  };
  protoOf(NamedValueDecoder).e5q = function (descriptor, index) {
    return descriptor.v5a(index);
  };
  protoOf(NamedValueDecoder).j5q = function (parentName, childName) {
    var tmp;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(parentName) === 0) {
      tmp = childName;
    } else {
      tmp = parentName + '.' + childName;
    }
    return tmp;
  };
  function NamedValueEncoder() {
    TaggedEncoder.call(this);
  }
  protoOf(NamedValueEncoder).d5q = function (_this__u8e3s4, index) {
    return this.f5q(this.e5q(_this__u8e3s4, index));
  };
  protoOf(NamedValueEncoder).f5q = function (nestedName) {
    var tmp0_elvis_lhs = this.i5q();
    return this.j5q(tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs, nestedName);
  };
  protoOf(NamedValueEncoder).e5q = function (descriptor, index) {
    return descriptor.v5a(index);
  };
  protoOf(NamedValueEncoder).j5q = function (parentName, childName) {
    var tmp;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(parentName) === 0) {
      tmp = childName;
    } else {
      tmp = parentName + '.' + childName;
    }
    return tmp;
  };
  function tagBlock($this, tag, block) {
    $this.x5q(tag);
    var r = block();
    if (!$this.h5q_1) {
      $this.y5q();
    }
    $this.h5q_1 = false;
    return r;
  }
  function TaggedDecoder$decodeSerializableElement$lambda(this$0, $deserializer, $previousValue) {
    return function () {
      return this$0.f5c($deserializer, $previousValue);
    };
  }
  function TaggedDecoder$decodeNullableSerializableElement$lambda(this$0, $deserializer, $previousValue) {
    return function () {
      return this$0.s5b() ? this$0.f5c($deserializer, $previousValue) : this$0.t5b();
    };
  }
  function TaggedDecoder() {
    var tmp = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.g5q_1 = ArrayList_init_$Create$();
    this.h5q_1 = false;
  }
  protoOf(TaggedDecoder).g59 = function () {
    return EmptySerializersModule_0();
  };
  protoOf(TaggedDecoder).k5q = function (tag) {
    throw SerializationException_init_$Create$_0(toString_1(getKClassFromExpression(this)) + " can't retrieve untyped values");
  };
  protoOf(TaggedDecoder).l5q = function (tag) {
    return true;
  };
  protoOf(TaggedDecoder).m5q = function (tag) {
    var tmp = this.k5q(tag);
    return typeof tmp === 'boolean' ? tmp : THROW_CCE();
  };
  protoOf(TaggedDecoder).n5q = function (tag) {
    var tmp = this.k5q(tag);
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  protoOf(TaggedDecoder).o5q = function (tag) {
    var tmp = this.k5q(tag);
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  protoOf(TaggedDecoder).p5q = function (tag) {
    var tmp = this.k5q(tag);
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  protoOf(TaggedDecoder).q5q = function (tag) {
    var tmp = this.k5q(tag);
    return typeof tmp === 'bigint' ? tmp : THROW_CCE();
  };
  protoOf(TaggedDecoder).r5q = function (tag) {
    var tmp = this.k5q(tag);
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  protoOf(TaggedDecoder).s5q = function (tag) {
    var tmp = this.k5q(tag);
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  protoOf(TaggedDecoder).t5q = function (tag) {
    var tmp = this.k5q(tag);
    return tmp instanceof Char ? tmp.s1_1 : THROW_CCE();
  };
  protoOf(TaggedDecoder).u5q = function (tag) {
    var tmp = this.k5q(tag);
    return typeof tmp === 'string' ? tmp : THROW_CCE();
  };
  protoOf(TaggedDecoder).v5q = function (tag, enumDescriptor) {
    var tmp = this.k5q(tag);
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  protoOf(TaggedDecoder).w5q = function (tag, inlineDescriptor) {
    // Inline function 'kotlin.apply' call
    this.x5q(tag);
    return this;
  };
  protoOf(TaggedDecoder).f5c = function (deserializer, previousValue) {
    return this.k59(deserializer);
  };
  protoOf(TaggedDecoder).e5c = function (descriptor) {
    return this.w5q(this.y5q(), descriptor);
  };
  protoOf(TaggedDecoder).s5b = function () {
    var tmp0_elvis_lhs = this.i5q();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var currentTag = tmp;
    return this.l5q(currentTag);
  };
  protoOf(TaggedDecoder).t5b = function () {
    return null;
  };
  protoOf(TaggedDecoder).u5b = function () {
    return this.m5q(this.y5q());
  };
  protoOf(TaggedDecoder).v5b = function () {
    return this.n5q(this.y5q());
  };
  protoOf(TaggedDecoder).w5b = function () {
    return this.o5q(this.y5q());
  };
  protoOf(TaggedDecoder).x5b = function () {
    return this.p5q(this.y5q());
  };
  protoOf(TaggedDecoder).y5b = function () {
    return this.q5q(this.y5q());
  };
  protoOf(TaggedDecoder).z5b = function () {
    return this.r5q(this.y5q());
  };
  protoOf(TaggedDecoder).a5c = function () {
    return this.s5q(this.y5q());
  };
  protoOf(TaggedDecoder).b5c = function () {
    return this.t5q(this.y5q());
  };
  protoOf(TaggedDecoder).c5c = function () {
    return this.u5q(this.y5q());
  };
  protoOf(TaggedDecoder).d5c = function (enumDescriptor) {
    return this.v5q(this.y5q(), enumDescriptor);
  };
  protoOf(TaggedDecoder).g5c = function (descriptor) {
    return this;
  };
  protoOf(TaggedDecoder).h5c = function (descriptor) {
  };
  protoOf(TaggedDecoder).i5c = function (descriptor, index) {
    return this.m5q(this.d5q(descriptor, index));
  };
  protoOf(TaggedDecoder).j5c = function (descriptor, index) {
    return this.n5q(this.d5q(descriptor, index));
  };
  protoOf(TaggedDecoder).k5c = function (descriptor, index) {
    return this.o5q(this.d5q(descriptor, index));
  };
  protoOf(TaggedDecoder).l5c = function (descriptor, index) {
    return this.p5q(this.d5q(descriptor, index));
  };
  protoOf(TaggedDecoder).m5c = function (descriptor, index) {
    return this.q5q(this.d5q(descriptor, index));
  };
  protoOf(TaggedDecoder).n5c = function (descriptor, index) {
    return this.r5q(this.d5q(descriptor, index));
  };
  protoOf(TaggedDecoder).o5c = function (descriptor, index) {
    return this.s5q(this.d5q(descriptor, index));
  };
  protoOf(TaggedDecoder).p5c = function (descriptor, index) {
    return this.t5q(this.d5q(descriptor, index));
  };
  protoOf(TaggedDecoder).q5c = function (descriptor, index) {
    return this.u5q(this.d5q(descriptor, index));
  };
  protoOf(TaggedDecoder).r5c = function (descriptor, index) {
    return this.w5q(this.d5q(descriptor, index), descriptor.t5a(index));
  };
  protoOf(TaggedDecoder).s5c = function (descriptor, index, deserializer, previousValue) {
    var tmp = this.d5q(descriptor, index);
    return tagBlock(this, tmp, TaggedDecoder$decodeSerializableElement$lambda(this, deserializer, previousValue));
  };
  protoOf(TaggedDecoder).u5c = function (descriptor, index, deserializer, previousValue) {
    var tmp = this.d5q(descriptor, index);
    return tagBlock(this, tmp, TaggedDecoder$decodeNullableSerializableElement$lambda(this, deserializer, previousValue));
  };
  protoOf(TaggedDecoder).i5q = function () {
    return lastOrNull(this.g5q_1);
  };
  protoOf(TaggedDecoder).x5q = function (name) {
    this.g5q_1.j(name);
  };
  protoOf(TaggedDecoder).y5q = function () {
    var r = this.g5q_1.n2(get_lastIndex_2(this.g5q_1));
    this.h5q_1 = true;
    return r;
  };
  function encodeElement($this, desc, index) {
    var tag = $this.d5q(desc, index);
    $this.x5q(tag);
    return true;
  }
  function TaggedEncoder() {
    var tmp = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.a5r_1 = ArrayList_init_$Create$();
  }
  protoOf(TaggedEncoder).g59 = function () {
    return EmptySerializersModule_0();
  };
  protoOf(TaggedEncoder).b5r = function (tag, value) {
    throw SerializationException_init_$Create$_0('Non-serializable ' + toString_1(getKClassFromExpression(value)) + ' is not supported by ' + toString_1(getKClassFromExpression(this)) + ' encoder');
  };
  protoOf(TaggedEncoder).c5r = function (tag) {
  };
  protoOf(TaggedEncoder).d5r = function (tag) {
    throw SerializationException_init_$Create$_0('null is not supported');
  };
  protoOf(TaggedEncoder).e5r = function (tag, value) {
    return this.b5r(tag, value);
  };
  protoOf(TaggedEncoder).f5r = function (tag, value) {
    return this.b5r(tag, value);
  };
  protoOf(TaggedEncoder).g5r = function (tag, value) {
    return this.b5r(tag, value);
  };
  protoOf(TaggedEncoder).h5r = function (tag, value) {
    return this.b5r(tag, value);
  };
  protoOf(TaggedEncoder).i5r = function (tag, value) {
    return this.b5r(tag, value);
  };
  protoOf(TaggedEncoder).j5r = function (tag, value) {
    return this.b5r(tag, value);
  };
  protoOf(TaggedEncoder).k5r = function (tag, value) {
    return this.b5r(tag, value);
  };
  protoOf(TaggedEncoder).l5r = function (tag, value) {
    return this.b5r(tag, new Char(value));
  };
  protoOf(TaggedEncoder).m5r = function (tag, value) {
    return this.b5r(tag, value);
  };
  protoOf(TaggedEncoder).n5r = function (tag, enumDescriptor, ordinal) {
    return this.b5r(tag, ordinal);
  };
  protoOf(TaggedEncoder).o5r = function (tag, inlineDescriptor) {
    // Inline function 'kotlin.apply' call
    this.x5q(tag);
    return this;
  };
  protoOf(TaggedEncoder).l5d = function (descriptor) {
    return this.o5r(this.y5q(), descriptor);
  };
  protoOf(TaggedEncoder).z5d = function () {
    return this.c5r(this.q5r());
  };
  protoOf(TaggedEncoder).a5d = function () {
    return this.d5r(this.y5q());
  };
  protoOf(TaggedEncoder).b5d = function (value) {
    return this.k5r(this.y5q(), value);
  };
  protoOf(TaggedEncoder).c5d = function (value) {
    return this.f5r(this.y5q(), value);
  };
  protoOf(TaggedEncoder).d5d = function (value) {
    return this.g5r(this.y5q(), value);
  };
  protoOf(TaggedEncoder).e5d = function (value) {
    return this.e5r(this.y5q(), value);
  };
  protoOf(TaggedEncoder).f5d = function (value) {
    return this.h5r(this.y5q(), value);
  };
  protoOf(TaggedEncoder).g5d = function (value) {
    return this.i5r(this.y5q(), value);
  };
  protoOf(TaggedEncoder).h5d = function (value) {
    return this.j5r(this.y5q(), value);
  };
  protoOf(TaggedEncoder).i5d = function (value) {
    return this.l5r(this.y5q(), value);
  };
  protoOf(TaggedEncoder).j5d = function (value) {
    return this.m5r(this.y5q(), value);
  };
  protoOf(TaggedEncoder).k5d = function (enumDescriptor, index) {
    return this.n5r(this.y5q(), enumDescriptor, index);
  };
  protoOf(TaggedEncoder).g5c = function (descriptor) {
    return this;
  };
  protoOf(TaggedEncoder).h5c = function (descriptor) {
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!this.a5r_1.s()) {
      this.y5q();
    }
    this.p5r(descriptor);
  };
  protoOf(TaggedEncoder).p5r = function (descriptor) {
  };
  protoOf(TaggedEncoder).m5d = function (descriptor, index, value) {
    return this.k5r(this.d5q(descriptor, index), value);
  };
  protoOf(TaggedEncoder).n5d = function (descriptor, index, value) {
    return this.f5r(this.d5q(descriptor, index), value);
  };
  protoOf(TaggedEncoder).o5d = function (descriptor, index, value) {
    return this.g5r(this.d5q(descriptor, index), value);
  };
  protoOf(TaggedEncoder).p5d = function (descriptor, index, value) {
    return this.e5r(this.d5q(descriptor, index), value);
  };
  protoOf(TaggedEncoder).q5d = function (descriptor, index, value) {
    return this.h5r(this.d5q(descriptor, index), value);
  };
  protoOf(TaggedEncoder).r5d = function (descriptor, index, value) {
    return this.i5r(this.d5q(descriptor, index), value);
  };
  protoOf(TaggedEncoder).s5d = function (descriptor, index, value) {
    return this.j5r(this.d5q(descriptor, index), value);
  };
  protoOf(TaggedEncoder).t5d = function (descriptor, index, value) {
    return this.l5r(this.d5q(descriptor, index), value);
  };
  protoOf(TaggedEncoder).u5d = function (descriptor, index, value) {
    return this.m5r(this.d5q(descriptor, index), value);
  };
  protoOf(TaggedEncoder).v5d = function (descriptor, index) {
    return this.o5r(this.d5q(descriptor, index), descriptor.t5a(index));
  };
  protoOf(TaggedEncoder).w5d = function (descriptor, index, serializer, value) {
    if (encodeElement(this, descriptor, index)) {
      this.h59(serializer, value);
    }
  };
  protoOf(TaggedEncoder).x5d = function (descriptor, index, serializer, value) {
    if (encodeElement(this, descriptor, index)) {
      this.y5d(serializer, value);
    }
  };
  protoOf(TaggedEncoder).q5r = function () {
    return last(this.a5r_1);
  };
  protoOf(TaggedEncoder).i5q = function () {
    return lastOrNull(this.a5r_1);
  };
  protoOf(TaggedEncoder).x5q = function (name) {
    this.a5r_1.j(name);
  };
  protoOf(TaggedEncoder).y5q = function () {
    var tmp;
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!this.a5r_1.s()) {
      tmp = this.a5r_1.n2(get_lastIndex_2(this.a5r_1));
    } else {
      throw SerializationException_init_$Create$_0('No tag in stack for requested element');
    }
    return tmp;
  };
  function get_NULL_0() {
    _init_properties_Tuples_kt__dz0qyd();
    return NULL_0;
  }
  var NULL_0;
  function PairSerializer$descriptor$lambda($keySerializer, $valueSerializer) {
    return function ($this$buildClassSerialDescriptor) {
      $this$buildClassSerialDescriptor.o59('first', $keySerializer.v58());
      $this$buildClassSerialDescriptor.o59('second', $valueSerializer.v58());
      return Unit_instance;
    };
  }
  function PairSerializer_0(keySerializer, valueSerializer) {
    KeyValueSerializer.call(this, keySerializer, valueSerializer);
    var tmp = this;
    tmp.t5r_1 = buildClassSerialDescriptor('kotlin.Pair', [], PairSerializer$descriptor$lambda(keySerializer, valueSerializer));
  }
  protoOf(PairSerializer_0).v58 = function () {
    return this.t5r_1;
  };
  protoOf(PairSerializer_0).u5r = function (_this__u8e3s4) {
    return _this__u8e3s4.pg_1;
  };
  protoOf(PairSerializer_0).v5r = function (_this__u8e3s4) {
    return this.u5r(_this__u8e3s4 instanceof Pair ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(PairSerializer_0).w5r = function (_this__u8e3s4) {
    return _this__u8e3s4.qg_1;
  };
  protoOf(PairSerializer_0).x5r = function (_this__u8e3s4) {
    return this.w5r(_this__u8e3s4 instanceof Pair ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(PairSerializer_0).y5r = function (key, value) {
    return to(key, value);
  };
  function decodeSequentially_1($this, composite) {
    var a = composite.t5c($this.f5s_1, 0, $this.c5s_1);
    var b = composite.t5c($this.f5s_1, 1, $this.d5s_1);
    var c = composite.t5c($this.f5s_1, 2, $this.e5s_1);
    composite.h5c($this.f5s_1);
    return new Triple(a, b, c);
  }
  function decodeStructure($this, composite) {
    var a = get_NULL_0();
    var b = get_NULL_0();
    var c = get_NULL_0();
    mainLoop: while (true) {
      var index = composite.w5c($this.f5s_1);
      switch (index) {
        case -1:
          break mainLoop;
        case 0:
          a = composite.t5c($this.f5s_1, 0, $this.c5s_1);
          break;
        case 1:
          b = composite.t5c($this.f5s_1, 1, $this.d5s_1);
          break;
        case 2:
          c = composite.t5c($this.f5s_1, 2, $this.e5s_1);
          break;
        default:
          throw SerializationException_init_$Create$_0('Unexpected index ' + index);
      }
    }
    composite.h5c($this.f5s_1);
    if (a === get_NULL_0())
      throw SerializationException_init_$Create$_0("Element 'first' is missing");
    if (b === get_NULL_0())
      throw SerializationException_init_$Create$_0("Element 'second' is missing");
    if (c === get_NULL_0())
      throw SerializationException_init_$Create$_0("Element 'third' is missing");
    var tmp = (a == null ? true : !(a == null)) ? a : THROW_CCE();
    var tmp_0 = (b == null ? true : !(b == null)) ? b : THROW_CCE();
    return new Triple(tmp, tmp_0, (c == null ? true : !(c == null)) ? c : THROW_CCE());
  }
  function TripleSerializer$descriptor$lambda(this$0) {
    return function ($this$buildClassSerialDescriptor) {
      $this$buildClassSerialDescriptor.o59('first', this$0.c5s_1.v58());
      $this$buildClassSerialDescriptor.o59('second', this$0.d5s_1.v58());
      $this$buildClassSerialDescriptor.o59('third', this$0.e5s_1.v58());
      return Unit_instance;
    };
  }
  function TripleSerializer_0(aSerializer, bSerializer, cSerializer) {
    this.c5s_1 = aSerializer;
    this.d5s_1 = bSerializer;
    this.e5s_1 = cSerializer;
    var tmp = this;
    tmp.f5s_1 = buildClassSerialDescriptor('kotlin.Triple', [], TripleSerializer$descriptor$lambda(this));
  }
  protoOf(TripleSerializer_0).v58 = function () {
    return this.f5s_1;
  };
  protoOf(TripleSerializer_0).g5s = function (encoder, value) {
    var structuredEncoder = encoder.g5c(this.f5s_1);
    structuredEncoder.w5d(this.f5s_1, 0, this.c5s_1, value.wl_1);
    structuredEncoder.w5d(this.f5s_1, 1, this.d5s_1, value.xl_1);
    structuredEncoder.w5d(this.f5s_1, 2, this.e5s_1, value.yl_1);
    structuredEncoder.h5c(this.f5s_1);
  };
  protoOf(TripleSerializer_0).i59 = function (encoder, value) {
    return this.g5s(encoder, value instanceof Triple ? value : THROW_CCE());
  };
  protoOf(TripleSerializer_0).j59 = function (decoder) {
    var composite = decoder.g5c(this.f5s_1);
    if (composite.v5c()) {
      return decodeSequentially_1(this, composite);
    }
    return decodeStructure(this, composite);
  };
  function MapEntry(key, value) {
    this.h5s_1 = key;
    this.i5s_1 = value;
  }
  protoOf(MapEntry).z = function () {
    return this.h5s_1;
  };
  protoOf(MapEntry).a1 = function () {
    return this.i5s_1;
  };
  protoOf(MapEntry).toString = function () {
    return 'MapEntry(key=' + toString_0(this.h5s_1) + ', value=' + toString_0(this.i5s_1) + ')';
  };
  protoOf(MapEntry).hashCode = function () {
    var result = this.h5s_1 == null ? 0 : hashCode(this.h5s_1);
    result = imul(result, 31) + (this.i5s_1 == null ? 0 : hashCode(this.i5s_1)) | 0;
    return result;
  };
  protoOf(MapEntry).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof MapEntry))
      return false;
    var tmp0_other_with_cast = other instanceof MapEntry ? other : THROW_CCE();
    if (!equals(this.h5s_1, tmp0_other_with_cast.h5s_1))
      return false;
    if (!equals(this.i5s_1, tmp0_other_with_cast.i5s_1))
      return false;
    return true;
  };
  function MapEntrySerializer$descriptor$lambda($keySerializer, $valueSerializer) {
    return function ($this$buildSerialDescriptor) {
      $this$buildSerialDescriptor.o59('key', $keySerializer.v58());
      $this$buildSerialDescriptor.o59('value', $valueSerializer.v58());
      return Unit_instance;
    };
  }
  function MapEntrySerializer_0(keySerializer, valueSerializer) {
    KeyValueSerializer.call(this, keySerializer, valueSerializer);
    var tmp = this;
    var tmp_0 = MAP_getInstance();
    tmp.l5s_1 = buildSerialDescriptor('kotlin.collections.Map.Entry', tmp_0, [], MapEntrySerializer$descriptor$lambda(keySerializer, valueSerializer));
  }
  protoOf(MapEntrySerializer_0).v58 = function () {
    return this.l5s_1;
  };
  protoOf(MapEntrySerializer_0).m5s = function (_this__u8e3s4) {
    return _this__u8e3s4.z();
  };
  protoOf(MapEntrySerializer_0).v5r = function (_this__u8e3s4) {
    return this.m5s((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Entry) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(MapEntrySerializer_0).n5s = function (_this__u8e3s4) {
    return _this__u8e3s4.a1();
  };
  protoOf(MapEntrySerializer_0).x5r = function (_this__u8e3s4) {
    return this.n5s((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Entry) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(MapEntrySerializer_0).y5r = function (key, value) {
    return new MapEntry(key, value);
  };
  function KeyValueSerializer(keySerializer, valueSerializer) {
    this.z5r_1 = keySerializer;
    this.a5s_1 = valueSerializer;
  }
  protoOf(KeyValueSerializer).b5s = function (encoder, value) {
    var structuredEncoder = encoder.g5c(this.v58());
    structuredEncoder.w5d(this.v58(), 0, this.z5r_1, this.v5r(value));
    structuredEncoder.w5d(this.v58(), 1, this.a5s_1, this.x5r(value));
    structuredEncoder.h5c(this.v58());
  };
  protoOf(KeyValueSerializer).i59 = function (encoder, value) {
    return this.b5s(encoder, (value == null ? true : !(value == null)) ? value : THROW_CCE());
  };
  protoOf(KeyValueSerializer).j59 = function (decoder) {
    // Inline function 'kotlinx.serialization.encoding.decodeStructure' call
    var descriptor = this.v58();
    var composite = decoder.g5c(descriptor);
    var tmp$ret$0;
    $l$block: {
      if (composite.v5c()) {
        var key = composite.t5c(this.v58(), 0, this.z5r_1);
        var value = composite.t5c(this.v58(), 1, this.a5s_1);
        tmp$ret$0 = this.y5r(key, value);
        break $l$block;
      }
      var key_0 = get_NULL_0();
      var value_0 = get_NULL_0();
      mainLoop: while (true) {
        var idx = composite.w5c(this.v58());
        switch (idx) {
          case -1:
            break mainLoop;
          case 0:
            key_0 = composite.t5c(this.v58(), 0, this.z5r_1);
            break;
          case 1:
            value_0 = composite.t5c(this.v58(), 1, this.a5s_1);
            break;
          default:
            throw SerializationException_init_$Create$_0('Invalid index: ' + idx);
        }
      }
      if (key_0 === get_NULL_0())
        throw SerializationException_init_$Create$_0("Element 'key' is missing");
      if (value_0 === get_NULL_0())
        throw SerializationException_init_$Create$_0("Element 'value' is missing");
      var tmp = (key_0 == null ? true : !(key_0 == null)) ? key_0 : THROW_CCE();
      tmp$ret$0 = this.y5r(tmp, (value_0 == null ? true : !(value_0 == null)) ? value_0 : THROW_CCE());
    }
    var result = tmp$ret$0;
    composite.h5c(descriptor);
    return result;
  };
  var properties_initialized_Tuples_kt_3vs7ar;
  function _init_properties_Tuples_kt__dz0qyd() {
    if (!properties_initialized_Tuples_kt_3vs7ar) {
      properties_initialized_Tuples_kt_3vs7ar = true;
      NULL_0 = new Object();
    }
  }
  function ULongSerializer() {
    ULongSerializer_instance = this;
    this.o5s_1 = InlinePrimitiveDescriptor('kotlin.ULong', serializer_14(Companion_instance_2));
  }
  protoOf(ULongSerializer).v58 = function () {
    return this.o5s_1;
  };
  protoOf(ULongSerializer).p5s = function (encoder, value) {
    var tmp = encoder.l5d(this.o5s_1);
    // Inline function 'kotlin.ULong.toLong' call
    var tmp$ret$0 = _ULong___get_data__impl__fggpzb(value);
    tmp.f5d(tmp$ret$0);
  };
  protoOf(ULongSerializer).i59 = function (encoder, value) {
    return this.p5s(encoder, value instanceof ULong ? value.r1_1 : THROW_CCE());
  };
  protoOf(ULongSerializer).q5s = function (decoder) {
    // Inline function 'kotlin.toULong' call
    var this_0 = decoder.e5c(this.o5s_1).y5b();
    return _ULong___init__impl__c78o9k(this_0);
  };
  protoOf(ULongSerializer).j59 = function (decoder) {
    return new ULong(this.q5s(decoder));
  };
  var ULongSerializer_instance;
  function ULongSerializer_getInstance() {
    if (ULongSerializer_instance == null)
      new ULongSerializer();
    return ULongSerializer_instance;
  }
  function UIntSerializer() {
    UIntSerializer_instance = this;
    this.r5s_1 = InlinePrimitiveDescriptor('kotlin.UInt', serializer_15(IntCompanionObject_instance));
  }
  protoOf(UIntSerializer).v58 = function () {
    return this.r5s_1;
  };
  protoOf(UIntSerializer).s5s = function (encoder, value) {
    var tmp = encoder.l5d(this.r5s_1);
    // Inline function 'kotlin.UInt.toInt' call
    var tmp$ret$0 = _UInt___get_data__impl__f0vqqw(value);
    tmp.e5d(tmp$ret$0);
  };
  protoOf(UIntSerializer).i59 = function (encoder, value) {
    return this.s5s(encoder, value instanceof UInt ? value.qm_1 : THROW_CCE());
  };
  protoOf(UIntSerializer).t5s = function (decoder) {
    // Inline function 'kotlin.toUInt' call
    var this_0 = decoder.e5c(this.r5s_1).x5b();
    return _UInt___init__impl__l7qpdl(this_0);
  };
  protoOf(UIntSerializer).j59 = function (decoder) {
    return new UInt(this.t5s(decoder));
  };
  var UIntSerializer_instance;
  function UIntSerializer_getInstance() {
    if (UIntSerializer_instance == null)
      new UIntSerializer();
    return UIntSerializer_instance;
  }
  function UByteSerializer() {
    UByteSerializer_instance = this;
    this.u5s_1 = InlinePrimitiveDescriptor('kotlin.UByte', serializer_10(ByteCompanionObject_instance));
  }
  protoOf(UByteSerializer).v58 = function () {
    return this.u5s_1;
  };
  protoOf(UByteSerializer).v5s = function (encoder, value) {
    var tmp = encoder.l5d(this.u5s_1);
    // Inline function 'kotlin.UByte.toByte' call
    var tmp$ret$0 = _UByte___get_data__impl__jof9qr(value);
    tmp.c5d(tmp$ret$0);
  };
  protoOf(UByteSerializer).i59 = function (encoder, value) {
    return this.v5s(encoder, value instanceof UByte ? value.em_1 : THROW_CCE());
  };
  protoOf(UByteSerializer).w5s = function (decoder) {
    // Inline function 'kotlin.toUByte' call
    var this_0 = decoder.e5c(this.u5s_1).v5b();
    return _UByte___init__impl__g9hnc4(this_0);
  };
  protoOf(UByteSerializer).j59 = function (decoder) {
    return new UByte(this.w5s(decoder));
  };
  var UByteSerializer_instance;
  function UByteSerializer_getInstance() {
    if (UByteSerializer_instance == null)
      new UByteSerializer();
    return UByteSerializer_instance;
  }
  function UShortSerializer() {
    UShortSerializer_instance = this;
    this.x5s_1 = InlinePrimitiveDescriptor('kotlin.UShort', serializer_16(ShortCompanionObject_instance));
  }
  protoOf(UShortSerializer).v58 = function () {
    return this.x5s_1;
  };
  protoOf(UShortSerializer).y5s = function (encoder, value) {
    var tmp = encoder.l5d(this.x5s_1);
    // Inline function 'kotlin.UShort.toShort' call
    var tmp$ret$0 = _UShort___get_data__impl__g0245(value);
    tmp.d5d(tmp$ret$0);
  };
  protoOf(UShortSerializer).i59 = function (encoder, value) {
    return this.y5s(encoder, value instanceof UShort ? value.mn_1 : THROW_CCE());
  };
  protoOf(UShortSerializer).z5s = function (decoder) {
    // Inline function 'kotlin.toUShort' call
    var this_0 = decoder.e5c(this.x5s_1).w5b();
    return _UShort___init__impl__jigrne(this_0);
  };
  protoOf(UShortSerializer).j59 = function (decoder) {
    return new UShort(this.z5s(decoder));
  };
  var UShortSerializer_instance;
  function UShortSerializer_getInstance() {
    if (UShortSerializer_instance == null)
      new UShortSerializer();
    return UShortSerializer_instance;
  }
  function get_EmptySerializersModuleLegacyJs() {
    _init_properties_SerializersModule_kt__u78ha3();
    return EmptySerializersModule;
  }
  var EmptySerializersModule;
  function SerializersModule() {
  }
  protoOf(SerializersModule).f5a = function (kClass, typeArgumentsSerializers, $super) {
    typeArgumentsSerializers = typeArgumentsSerializers === VOID ? emptyList() : typeArgumentsSerializers;
    return $super === VOID ? this.u58(kClass, typeArgumentsSerializers) : $super.u58.call(this, kClass, typeArgumentsSerializers);
  };
  function SerialModuleImpl(class2ContextualFactory, polyBase2Serializers, polyBase2DefaultSerializerProvider, polyBase2NamedSerializers, polyBase2DefaultDeserializerProvider) {
    SerializersModule.call(this);
    this.b5t_1 = class2ContextualFactory;
    this.c5t_1 = polyBase2Serializers;
    this.d5t_1 = polyBase2DefaultSerializerProvider;
    this.e5t_1 = polyBase2NamedSerializers;
    this.f5t_1 = polyBase2DefaultDeserializerProvider;
  }
  protoOf(SerialModuleImpl).d5e = function (baseClass, value) {
    if (!baseClass.sa(value))
      return null;
    var tmp0_safe_receiver = this.c5t_1.q2(baseClass);
    var tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.q2(getKClassFromExpression(value));
    var registered = (!(tmp == null) ? isInterface(tmp, SerializationStrategy) : false) ? tmp : null;
    if (!(registered == null))
      return registered;
    var tmp_0 = this.d5t_1.q2(baseClass);
    var tmp1_safe_receiver = (!(tmp_0 == null) ? typeof tmp_0 === 'function' : false) ? tmp_0 : null;
    return tmp1_safe_receiver == null ? null : tmp1_safe_receiver(value);
  };
  protoOf(SerialModuleImpl).c5e = function (baseClass, serializedClassName) {
    var tmp0_safe_receiver = this.e5t_1.q2(baseClass);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.collections.get' call
      tmp = (isInterface(tmp0_safe_receiver, KtMap) ? tmp0_safe_receiver : THROW_CCE()).q2(serializedClassName);
    }
    var tmp_0 = tmp;
    var registered = (!(tmp_0 == null) ? isInterface(tmp_0, KSerializer) : false) ? tmp_0 : null;
    if (!(registered == null))
      return registered;
    var tmp_1 = this.f5t_1.q2(baseClass);
    var tmp1_safe_receiver = (!(tmp_1 == null) ? typeof tmp_1 === 'function' : false) ? tmp_1 : null;
    return tmp1_safe_receiver == null ? null : tmp1_safe_receiver(serializedClassName);
  };
  protoOf(SerialModuleImpl).u58 = function (kClass, typeArgumentsSerializers) {
    var tmp0_safe_receiver = this.b5t_1.q2(kClass);
    var tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.g5t(typeArgumentsSerializers);
    return (tmp == null ? true : isInterface(tmp, KSerializer)) ? tmp : null;
  };
  protoOf(SerialModuleImpl).a5t = function (collector) {
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s = this.b5t_1.y().m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      // Inline function 'kotlin.collections.component1' call
      var kclass = element.z();
      // Inline function 'kotlin.collections.component2' call
      var serial = element.a1();
      if (serial instanceof Argless) {
        var tmp = isInterface(kclass, KClass) ? kclass : THROW_CCE();
        var tmp_0 = serial.j5t_1;
        collector.k5t(tmp, isInterface(tmp_0, KSerializer) ? tmp_0 : THROW_CCE());
      } else {
        if (serial instanceof WithTypeArguments) {
          collector.i5t(kclass, serial.h5t_1);
        }
      }
    }
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s_0 = this.c5t_1.y().m();
    while (_iterator__ex2g4s_0.n()) {
      var element_0 = _iterator__ex2g4s_0.o();
      // Inline function 'kotlin.collections.component1' call
      var baseClass = element_0.z();
      // Inline function 'kotlin.collections.component2' call
      var classMap = element_0.a1();
      // Inline function 'kotlin.collections.forEach' call
      // Inline function 'kotlin.collections.iterator' call
      var _iterator__ex2g4s_1 = classMap.y().m();
      while (_iterator__ex2g4s_1.n()) {
        var element_1 = _iterator__ex2g4s_1.o();
        // Inline function 'kotlin.collections.component1' call
        var actualClass = element_1.z();
        // Inline function 'kotlin.collections.component2' call
        var serializer = element_1.a1();
        var tmp_1 = isInterface(baseClass, KClass) ? baseClass : THROW_CCE();
        var tmp_2 = isInterface(actualClass, KClass) ? actualClass : THROW_CCE();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var tmp$ret$11 = isInterface(serializer, KSerializer) ? serializer : THROW_CCE();
        collector.l5t(tmp_1, tmp_2, tmp$ret$11);
      }
    }
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s_2 = this.d5t_1.y().m();
    while (_iterator__ex2g4s_2.n()) {
      var element_2 = _iterator__ex2g4s_2.o();
      // Inline function 'kotlin.collections.component1' call
      var baseClass_0 = element_2.z();
      // Inline function 'kotlin.collections.component2' call
      var provider = element_2.a1();
      var tmp_3 = isInterface(baseClass_0, KClass) ? baseClass_0 : THROW_CCE();
      collector.m5t(tmp_3, typeof provider === 'function' ? provider : THROW_CCE());
    }
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s_3 = this.f5t_1.y().m();
    while (_iterator__ex2g4s_3.n()) {
      var element_3 = _iterator__ex2g4s_3.o();
      // Inline function 'kotlin.collections.component1' call
      var baseClass_1 = element_3.z();
      // Inline function 'kotlin.collections.component2' call
      var provider_0 = element_3.a1();
      var tmp_4 = isInterface(baseClass_1, KClass) ? baseClass_1 : THROW_CCE();
      collector.n5t(tmp_4, typeof provider_0 === 'function' ? provider_0 : THROW_CCE());
    }
  };
  function Argless(serializer) {
    ContextualProvider.call(this);
    this.j5t_1 = serializer;
  }
  protoOf(Argless).g5t = function (typeArgumentsSerializers) {
    return this.j5t_1;
  };
  protoOf(Argless).equals = function (other) {
    var tmp;
    if (other instanceof Argless) {
      tmp = equals(other.j5t_1, this.j5t_1);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(Argless).hashCode = function () {
    return hashCode(this.j5t_1);
  };
  function WithTypeArguments(provider) {
    ContextualProvider.call(this);
    this.h5t_1 = provider;
  }
  protoOf(WithTypeArguments).g5t = function (typeArgumentsSerializers) {
    return this.h5t_1(typeArgumentsSerializers);
  };
  function ContextualProvider() {
  }
  var properties_initialized_SerializersModule_kt_fjigjn;
  function _init_properties_SerializersModule_kt__u78ha3() {
    if (!properties_initialized_SerializersModule_kt_fjigjn) {
      properties_initialized_SerializersModule_kt_fjigjn = true;
      EmptySerializersModule = new SerialModuleImpl(emptyMap(), emptyMap(), emptyMap(), emptyMap(), emptyMap());
    }
  }
  function SerializersModuleBuilder() {
    var tmp = this;
    // Inline function 'kotlin.collections.hashMapOf' call
    tmp.o5t_1 = HashMap_init_$Create$();
    var tmp_0 = this;
    // Inline function 'kotlin.collections.hashMapOf' call
    tmp_0.p5t_1 = HashMap_init_$Create$();
    var tmp_1 = this;
    // Inline function 'kotlin.collections.hashMapOf' call
    tmp_1.q5t_1 = HashMap_init_$Create$();
    var tmp_2 = this;
    // Inline function 'kotlin.collections.hashMapOf' call
    tmp_2.r5t_1 = HashMap_init_$Create$();
    var tmp_3 = this;
    // Inline function 'kotlin.collections.hashMapOf' call
    tmp_3.s5t_1 = HashMap_init_$Create$();
  }
  protoOf(SerializersModuleBuilder).k5t = function (kClass, serializer) {
    return this.t5t(kClass, new Argless(serializer));
  };
  protoOf(SerializersModuleBuilder).i5t = function (kClass, provider) {
    return this.t5t(kClass, new WithTypeArguments(provider));
  };
  protoOf(SerializersModuleBuilder).l5t = function (baseClass, actualClass, actualSerializer) {
    this.u5t(baseClass, actualClass, actualSerializer);
  };
  protoOf(SerializersModuleBuilder).m5t = function (baseClass, defaultSerializerProvider) {
    this.v5t(baseClass, defaultSerializerProvider, false);
  };
  protoOf(SerializersModuleBuilder).n5t = function (baseClass, defaultDeserializerProvider) {
    this.w5t(baseClass, defaultDeserializerProvider, false);
  };
  protoOf(SerializersModuleBuilder).x5t = function (forClass, provider, allowOverwrite) {
    if (!allowOverwrite) {
      var previous = this.o5t_1.q2(forClass);
      if (!(previous == null) && !equals(previous, provider)) {
        throw new SerializerAlreadyRegisteredException('Contextual serializer or serializer provider for ' + toString_1(forClass) + ' already registered in this module');
      }
    }
    // Inline function 'kotlin.collections.set' call
    this.o5t_1.t2(forClass, provider);
  };
  protoOf(SerializersModuleBuilder).t5t = function (forClass, provider, allowOverwrite, $super) {
    allowOverwrite = allowOverwrite === VOID ? false : allowOverwrite;
    var tmp;
    if ($super === VOID) {
      this.x5t(forClass, provider, allowOverwrite);
      tmp = Unit_instance;
    } else {
      tmp = $super.x5t.call(this, forClass, provider, allowOverwrite);
    }
    return tmp;
  };
  protoOf(SerializersModuleBuilder).v5t = function (baseClass, defaultSerializerProvider, allowOverwrite) {
    var previous = this.q5t_1.q2(baseClass);
    if (!(previous == null) && !equals(previous, defaultSerializerProvider) && !allowOverwrite) {
      throw IllegalArgumentException_init_$Create$_0('Default serializers provider for ' + toString_1(baseClass) + ' is already registered: ' + toString_0(previous));
    }
    // Inline function 'kotlin.collections.set' call
    this.q5t_1.t2(baseClass, defaultSerializerProvider);
  };
  protoOf(SerializersModuleBuilder).w5t = function (baseClass, defaultDeserializerProvider, allowOverwrite) {
    var previous = this.s5t_1.q2(baseClass);
    if (!(previous == null) && !equals(previous, defaultDeserializerProvider) && !allowOverwrite) {
      throw IllegalArgumentException_init_$Create$_0('Default deserializers provider for ' + toString_1(baseClass) + ' is already registered: ' + toString_0(previous));
    }
    // Inline function 'kotlin.collections.set' call
    this.s5t_1.t2(baseClass, defaultDeserializerProvider);
  };
  protoOf(SerializersModuleBuilder).y5t = function (baseClass, concreteClass, concreteSerializer, allowOverwrite) {
    var name = concreteSerializer.v58().z59();
    // Inline function 'kotlin.collections.getOrPut' call
    var this_0 = this.p5t_1;
    var value = this_0.q2(baseClass);
    var tmp;
    if (value == null) {
      // Inline function 'kotlin.collections.hashMapOf' call
      var answer = HashMap_init_$Create$();
      this_0.t2(baseClass, answer);
      tmp = answer;
    } else {
      tmp = value;
    }
    var baseClassSerializers = tmp;
    var previousSerializer = baseClassSerializers.q2(concreteClass);
    // Inline function 'kotlin.collections.getOrPut' call
    var this_1 = this.r5t_1;
    var value_0 = this_1.q2(baseClass);
    var tmp_0;
    if (value_0 == null) {
      // Inline function 'kotlin.collections.hashMapOf' call
      var answer_0 = HashMap_init_$Create$();
      this_1.t2(baseClass, answer_0);
      tmp_0 = answer_0;
    } else {
      tmp_0 = value_0;
    }
    var names = tmp_0;
    if (allowOverwrite) {
      if (!(previousSerializer == null)) {
        names.u2(previousSerializer.v58().z59());
      }
      // Inline function 'kotlin.collections.set' call
      baseClassSerializers.t2(concreteClass, concreteSerializer);
      // Inline function 'kotlin.collections.set' call
      names.t2(name, concreteSerializer);
      return Unit_instance;
    }
    if (!(previousSerializer == null)) {
      if (!equals(previousSerializer, concreteSerializer)) {
        throw SerializerAlreadyRegisteredException_init_$Create$(baseClass, concreteClass);
      } else {
        names.u2(previousSerializer.v58().z59());
      }
    }
    var previousByName = names.q2(name);
    if (!(previousByName == null)) {
      // Inline function 'kotlin.sequences.find' call
      var tmp0 = asSequence_1(ensureNotNull(this.p5t_1.q2(baseClass)));
      var tmp$ret$9;
      $l$block: {
        // Inline function 'kotlin.sequences.firstOrNull' call
        var _iterator__ex2g4s = tmp0.m();
        while (_iterator__ex2g4s.n()) {
          var element = _iterator__ex2g4s.o();
          if (element.a1() === previousByName) {
            tmp$ret$9 = element;
            break $l$block;
          }
        }
        tmp$ret$9 = null;
      }
      var conflictingClass = tmp$ret$9;
      throw IllegalArgumentException_init_$Create$_0("Multiple polymorphic serializers for base class '" + toString_1(baseClass) + "' " + ("have the same serial name '" + name + "': '" + toString_1(concreteClass) + "' and '" + toString_0(conflictingClass) + "'"));
    }
    // Inline function 'kotlin.collections.set' call
    baseClassSerializers.t2(concreteClass, concreteSerializer);
    // Inline function 'kotlin.collections.set' call
    names.t2(name, concreteSerializer);
  };
  protoOf(SerializersModuleBuilder).u5t = function (baseClass, concreteClass, concreteSerializer, allowOverwrite, $super) {
    allowOverwrite = allowOverwrite === VOID ? false : allowOverwrite;
    var tmp;
    if ($super === VOID) {
      this.y5t(baseClass, concreteClass, concreteSerializer, allowOverwrite);
      tmp = Unit_instance;
    } else {
      tmp = $super.y5t.call(this, baseClass, concreteClass, concreteSerializer, allowOverwrite);
    }
    return tmp;
  };
  protoOf(SerializersModuleBuilder).t5h = function () {
    return new SerialModuleImpl(this.o5t_1, this.p5t_1, this.q5t_1, this.r5t_1, this.s5t_1);
  };
  function EmptySerializersModule_0() {
    return get_EmptySerializersModuleLegacyJs();
  }
  function SerializerAlreadyRegisteredException_init_$Init$(baseClass, concreteClass, $this) {
    SerializerAlreadyRegisteredException.call($this, 'Serializer for ' + toString_1(concreteClass) + ' already registered in the scope of ' + toString_1(baseClass));
    return $this;
  }
  function SerializerAlreadyRegisteredException_init_$Create$(baseClass, concreteClass) {
    var tmp = SerializerAlreadyRegisteredException_init_$Init$(baseClass, concreteClass, objectCreate(protoOf(SerializerAlreadyRegisteredException)));
    captureStack(tmp, SerializerAlreadyRegisteredException_init_$Create$);
    return tmp;
  }
  function SerializerAlreadyRegisteredException(msg) {
    IllegalArgumentException_init_$Init$_0(msg, this);
    captureStack(this, SerializerAlreadyRegisteredException);
  }
  function SerializersModuleCollector$contextual$lambda($serializer) {
    return function (it) {
      return $serializer;
    };
  }
  function SerializersModuleCollector() {
  }
  function SerializableWith(serializer) {
    this.z5t_1 = serializer;
  }
  protoOf(SerializableWith).equals = function (other) {
    if (!(other instanceof SerializableWith))
      return false;
    var tmp0_other_with_cast = other instanceof SerializableWith ? other : THROW_CCE();
    if (!this.z5t_1.equals(tmp0_other_with_cast.z5t_1))
      return false;
    return true;
  };
  protoOf(SerializableWith).hashCode = function () {
    return imul(getStringHashCode('serializer'), 127) ^ this.z5t_1.hashCode();
  };
  protoOf(SerializableWith).toString = function () {
    return '@kotlinx.serialization.SerializableWith(' + 'serializer=' + toString_1(this.z5t_1) + ')';
  };
  function platformSpecificSerializerNotRegistered(_this__u8e3s4) {
    throw SerializationException_init_$Create$_0(notRegisteredMessage(_this__u8e3s4) + '\n' + 'On Kotlin/JS explicitly declared serializer should be used for interfaces and enums without @Serializable annotation');
  }
  function compiledSerializerImpl(_this__u8e3s4) {
    var tmp1_elvis_lhs = constructSerializerForGivenTypeArgs(_this__u8e3s4, []);
    var tmp;
    if (tmp1_elvis_lhs == null) {
      // Inline function 'kotlin.js.asDynamic' call
      var tmp0_safe_receiver = get_js(_this__u8e3s4).Companion;
      var tmp_0 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.serializer();
      tmp = (!(tmp_0 == null) ? isInterface(tmp_0, KSerializer) : false) ? tmp_0 : null;
    } else {
      tmp = tmp1_elvis_lhs;
    }
    return tmp;
  }
  function isReferenceArray(rootClass) {
    return rootClass.equals(PrimitiveClasses_getInstance().sb());
  }
  function constructSerializerForGivenTypeArgs(_this__u8e3s4, args) {
    var tmp;
    try {
      // Inline function 'kotlin.reflect.findAssociatedObject' call
      var assocObject = findAssociatedObject(_this__u8e3s4, getKClass(SerializableWith));
      var tmp_0;
      if (!(assocObject == null) ? isInterface(assocObject, KSerializer) : false) {
        tmp_0 = (!(assocObject == null) ? isInterface(assocObject, KSerializer) : false) ? assocObject : THROW_CCE();
      } else {
        if (!(assocObject == null) ? isInterface(assocObject, SerializerFactory) : false) {
          var tmp_1 = assocObject.q5k(args.slice());
          tmp_0 = isInterface(tmp_1, KSerializer) ? tmp_1 : THROW_CCE();
        } else {
          if (get_isInterface(_this__u8e3s4)) {
            tmp_0 = new PolymorphicSerializer(_this__u8e3s4);
          } else {
            tmp_0 = null;
          }
        }
      }
      tmp = tmp_0;
    } catch ($p) {
      var tmp_2;
      var e = $p;
      tmp_2 = null;
      tmp = tmp_2;
    }
    return tmp;
  }
  function createCache(factory) {
    return new createCache$1(factory);
  }
  function createParametrizedCache(factory) {
    return new createParametrizedCache$1(factory);
  }
  function getChecked(_this__u8e3s4, index) {
    if (!(0 <= index ? index <= (_this__u8e3s4.length - 1 | 0) : false))
      throw IndexOutOfBoundsException_init_$Create$_0('Index ' + index + ' out of bounds ' + get_indices(_this__u8e3s4).toString());
    return _this__u8e3s4[index];
  }
  function getChecked_0(_this__u8e3s4, index) {
    if (!(0 <= index ? index <= (_this__u8e3s4.length - 1 | 0) : false))
      throw IndexOutOfBoundsException_init_$Create$_0('Index ' + index + ' out of bounds ' + get_indices_0(_this__u8e3s4).toString());
    return _this__u8e3s4[index];
  }
  function toNativeArrayImpl(_this__u8e3s4, eClass) {
    // Inline function 'kotlin.collections.toTypedArray' call
    return copyToArray(_this__u8e3s4);
  }
  function get_isInterface(_this__u8e3s4) {
    // Inline function 'kotlin.js.asDynamic' call
    var tmp0_safe_receiver = get_js(_this__u8e3s4).$metadata$;
    return (tmp0_safe_receiver == null ? null : tmp0_safe_receiver.kind) == 'interface';
  }
  function createCache$1($factory) {
    this.a5u_1 = $factory;
  }
  protoOf(createCache$1).g5a = function (key) {
    return this.a5u_1(key);
  };
  function createParametrizedCache$1($factory) {
    this.b5u_1 = $factory;
  }
  protoOf(createParametrizedCache$1).h5a = function (key, types) {
    // Inline function 'kotlin.runCatching' call
    var tmp;
    try {
      // Inline function 'kotlin.Companion.success' call
      var value = this.b5u_1(key, types);
      tmp = _Result___init__impl__xyqfz8(value);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var e = $p;
        // Inline function 'kotlin.Companion.failure' call
        tmp_0 = _Result___init__impl__xyqfz8(createFailure(e));
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  function AlreadyInvalidException(invalidationContext, message) {
    Exception_init_$Init$_0('Invalidation context is already invalid: ' + message + '; inv.context: ' + toString_1(invalidationContext == null ? 'not defined' : invalidationContext), this);
    captureStack(this, AlreadyInvalidException);
  }
  function Invalidation$ALWAYS_INVALIDATE$1() {
  }
  protoOf(Invalidation$ALWAYS_INVALIDATE$1).c5u = function (event, actions) {
    actions.d5u();
  };
  protoOf(Invalidation$ALWAYS_INVALIDATE$1).e5u = function (event, actions) {
    return this.c5u(!(event == null) ? event : THROW_CCE(), actions);
  };
  function Invalidation() {
    Invalidation_instance = this;
    this.f5u_1 = Invalidation_getInstance();
    var tmp = this;
    tmp.g5u_1 = new Invalidation$ALWAYS_INVALIDATE$1();
  }
  var Invalidation_instance;
  function Invalidation_getInstance() {
    if (Invalidation_instance == null)
      new Invalidation();
    return Invalidation_instance;
  }
  function assertValid(_this__u8e3s4, message) {
    if (!_this__u8e3s4.p38()) {
      throw new AlreadyInvalidException(_this__u8e3s4, message());
    }
  }
  function _get_isActive__4an5s5($this) {
    return !($this.j5u_1 == null);
  }
  function recompute($this) {
    var inv = $this.h5u_1.l5u(fresh($this));
    var currentValue = inv.m5u();
    var tmp = inv.n5u();
    tmp.y2r(new EagerInvalidatable$recompute$1($this, currentValue));
    return inv.m5u();
  }
  function fresh($this) {
    $this.i5u_1 = new Invalidator();
    return ensureNotNull($this.i5u_1);
  }
  function ValueHolder(value) {
    this.o5u_1 = value;
  }
  protoOf(ValueHolder).uv = function () {
    return this.o5u_1;
  };
  protoOf(ValueHolder).d2x = function (newValue) {
    this.o5u_1 = newValue;
  };
  function EagerInvalidatable$myListeners$1(this$0) {
    this.q5u_1 = this$0;
    EventHandlerListeners.call(this);
  }
  protoOf(EagerInvalidatable$myListeners$1).c2s = function () {
    this.q5u_1.j5u_1 = new ValueHolder(recompute(this.q5u_1));
  };
  protoOf(EagerInvalidatable$myListeners$1).g2s = function () {
    ensureNotNull(this.q5u_1.i5u_1).zr();
    this.q5u_1.i5u_1 = null;
    this.q5u_1.j5u_1 = null;
  };
  function EagerInvalidatable$recompute$1(this$0, $currentValue) {
    this.r5u_1 = this$0;
    this.s5u_1 = $currentValue;
  }
  protoOf(EagerInvalidatable$recompute$1).t5u = function (event) {
    if (!_get_isActive__4an5s5(this.r5u_1)) {
      return Unit_instance;
    }
    var newValue = recompute(this.r5u_1);
    if (equals(this.s5u_1, newValue)) {
      return Unit_instance;
    }
    ensureNotNull(this.r5u_1.j5u_1).d2x(newValue);
    var propertyChangeEvent = new PropertyChangeEvent(this.s5u_1, newValue);
    this.r5u_1.k5u_1.m2v(propertyChangeEvent);
  };
  protoOf(EagerInvalidatable$recompute$1).n2s = function (event) {
    return this.t5u(event instanceof Invalidation ? event : THROW_CCE());
  };
  function EagerInvalidatable(myComputation) {
    this.h5u_1 = myComputation;
    this.i5u_1 = null;
    this.j5u_1 = null;
    var tmp = this;
    tmp.k5u_1 = new EagerInvalidatable$myListeners$1(this);
  }
  protoOf(EagerInvalidatable).v2w = function () {
    return 'Eagerly recomputed invalidatable value';
  };
  protoOf(EagerInvalidatable).uv = function () {
    var tmp;
    if (!_get_isActive__4an5s5(this)) {
      tmp = this.h5u_1.l5u(Companion_getInstance_79().u5u_1).m5u();
    } else {
      tmp = ensureNotNull(this.j5u_1).uv();
    }
    return tmp;
  };
  protoOf(EagerInvalidatable).w5u = function (handler) {
    return this.k5u_1.j2s(handler);
  };
  protoOf(EagerInvalidatable).y2r = function (handler) {
    return this.w5u(handler);
  };
  function depend(_this__u8e3s4, property) {
    _this__u8e3s4.x5u(property, Invalidation_getInstance().g5u_1);
    return property.uv();
  }
  function affects(_this__u8e3s4, ctx) {
    ctx.x5u(_this__u8e3s4.n5u(), Invalidation_getInstance().g5u_1);
    return _this__u8e3s4.m5u();
  }
  function depend_0(_this__u8e3s4, collection) {
    _this__u8e3s4.x5u(collection, Invalidation_getInstance().g5u_1);
    return collection;
  }
  function depend_1(_this__u8e3s4, inv) {
    return _this__u8e3s4.x5u(inv.n5u(), Invalidation_getInstance().g5u_1);
  }
  function InvalidatableBase() {
  }
  protoOf(InvalidatableBase).m5u = function () {
    if (!this.n5u().p38()) {
      throw IllegalStateException_init_$Create$_0('Value is already invalid, must not be retrieved');
    }
    return this.y5u();
  };
  function release($this) {
    // Inline function 'kotlin.check' call
    if (!$this.p38()) {
      var message = "can't release: already invalid";
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    $this.a5v_1 = false;
    $this.b5v();
  }
  function InvalidationPointBase$addHandler$$inlined$toDisposable$1(this$0, $handler) {
    this.c5v_1 = this$0;
    this.d5v_1 = $handler;
  }
  protoOf(InvalidationPointBase$addHandler$$inlined$toDisposable$1).zr = function () {
    this.c5v_1.z5u_1.h2(this.d5v_1);
    return Unit_instance;
  };
  function InvalidationPointBase() {
    this.z5u_1 = ArrayDeque_init_$Create$();
    this.a5v_1 = true;
  }
  protoOf(InvalidationPointBase).p38 = function () {
    return this.a5v_1;
  };
  protoOf(InvalidationPointBase).e5v = function (handler) {
    if (!this.a5v_1) {
      handler.n2s(Invalidation_getInstance());
      return Companion_getInstance_29().m2l_1;
    }
    this.z5u_1.j(handler);
    // Inline function 'jetbrains.ocelot.base.disposable.toDisposable' call
    return new InvalidationPointBase$addHandler$$inlined$toDisposable$1(this, handler);
  };
  protoOf(InvalidationPointBase).y2r = function (handler) {
    return this.e5v(handler);
  };
  protoOf(InvalidationPointBase).d5u = function () {
    release(this);
    var _iterator__ex2g4s = ArrayList_init_$Create$_1(this.z5u_1).m();
    while (_iterator__ex2g4s.n()) {
      var handler = _iterator__ex2g4s.o();
      handler.n2s(Invalidation_getInstance().f5u_1);
    }
    this.z5u_1.k2();
  };
  protoOf(InvalidationPointBase).zr = function () {
    if (!this.a5v_1)
      return Unit_instance;
    release(this);
    this.z5u_1.k2();
  };
  function Dependencies() {
    this.f5v_1 = HashMap_init_$Create$();
    this.g5v_1 = ArrayList_init_$Create$();
  }
  protoOf(Dependencies).h5v = function (disposable) {
    this.g5v_1.j(disposable);
  };
  protoOf(Dependencies).i5v = function (key) {
    return this.f5v_1.o2(key);
  };
  protoOf(Dependencies).j5v = function (key, value) {
    // Inline function 'kotlin.collections.set' call
    this.f5v_1.t2(key, value);
  };
  protoOf(Dependencies).zr = function () {
    var _iterator__ex2g4s = plus_5(this.f5v_1.s2(), this.g5v_1).m();
    while (_iterator__ex2g4s.n()) {
      var disposable = _iterator__ex2g4s.o();
      disposable.zr();
    }
    this.f5v_1.k2();
    this.g5v_1.k2();
  };
  function addEventHandler($this, eventSource, reaction) {
    var key = new SourceKey(eventSource, reaction);
    if ($this.l5v_1.i5v(key))
      return Unit_instance;
    $this.l5v_1.j5v(key, createEventHandler($this, eventSource, reaction));
  }
  function createEventHandler($this, eventSource, reaction) {
    // Inline function 'jetbrains.ocelot.base.observable.event.eventHandler' call
    var tmp$ret$0 = new Invalidator$createEventHandler$$inlined$eventHandler$1(reaction, $this);
    return eventSource.y2r(tmp$ret$0);
  }
  function SourceKey(eventSource, reaction) {
    this.m5v_1 = eventSource;
    this.n5v_1 = reaction;
  }
  protoOf(SourceKey).equals = function (other) {
    var tmp;
    if (other instanceof SourceKey) {
      tmp = (this.m5v_1 === other.m5v_1 && this.n5v_1 === other.n5v_1);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(SourceKey).hashCode = function () {
    return hashCode(this.m5v_1) + imul(31, hashCode(this.n5v_1)) | 0;
  };
  function Invalidator$1(this$0) {
    this.q5v_1 = this$0;
    InvalidationPointBase.call(this);
  }
  protoOf(Invalidator$1).b5v = function () {
    return this.q5v_1.l5v_1.zr();
  };
  function Invalidator$addEventSource$lambda() {
    return "Can't add EventSource";
  }
  function Invalidator$addDisposable$lambda() {
    return "Can't add Disposable";
  }
  function Invalidator$createEventHandler$1(this$0) {
    this.r5v_1 = this$0;
  }
  protoOf(Invalidator$createEventHandler$1).d5u = function () {
    this.r5v_1.k5v_1.d5u();
  };
  function Invalidator$createEventHandler$$inlined$eventHandler$1($reaction, this$0) {
    this.s5v_1 = $reaction;
    this.t5v_1 = this$0;
  }
  protoOf(Invalidator$createEventHandler$$inlined$eventHandler$1).o2v = function (event) {
    this.s5v_1.e5u(event, new Invalidator$createEventHandler$1(this.t5v_1));
    return Unit_instance;
  };
  protoOf(Invalidator$createEventHandler$$inlined$eventHandler$1).n2s = function (event) {
    return this.o2v((event == null ? true : !(event == null)) ? event : THROW_CCE());
  };
  function Invalidator$value$lambda() {
    return 'No reason to make value';
  }
  function Invalidator$value$3(this$0, $value) {
    this.u5v_1 = this$0;
    this.v5v_1 = $value;
    InvalidatableBase.call(this);
  }
  protoOf(Invalidator$value$3).n5u = function () {
    return this.u5v_1.k5v_1;
  };
  protoOf(Invalidator$value$3).y5u = function () {
    return this.v5v_1;
  };
  function Invalidator$failure$lambda() {
    return 'No reason to make failure';
  }
  function Invalidator$failure$3(this$0, $throwable) {
    this.w5v_1 = this$0;
    this.x5v_1 = $throwable;
    InvalidatableBase.call(this);
  }
  protoOf(Invalidator$failure$3).n5u = function () {
    return this.w5v_1.k5v_1;
  };
  protoOf(Invalidator$failure$3).y5u = function () {
    throw this.x5v_1;
  };
  function Invalidator() {
    this.l5v_1 = new Dependencies();
    var tmp = this;
    tmp.k5v_1 = new Invalidator$1(this);
  }
  protoOf(Invalidator).x5u = function (eventSource, reaction) {
    assertValid(this, Invalidator$addEventSource$lambda);
    addEventHandler(this, eventSource, reaction);
  };
  protoOf(Invalidator).y5v = function (disposable) {
    assertValid(this, Invalidator$addDisposable$lambda);
    this.l5v_1.h5v(disposable);
  };
  protoOf(Invalidator).p38 = function () {
    return this.k5v_1.p38();
  };
  protoOf(Invalidator).zr = function () {
    this.k5v_1.zr();
  };
  protoOf(Invalidator).z5v = function (value) {
    assertValid(this, Invalidator$value$lambda);
    return new Invalidator$value$3(this, value);
  };
  protoOf(Invalidator).a5w = function (throwable) {
    assertValid(this, Invalidator$failure$lambda);
    return new Invalidator$failure$3(this, throwable);
  };
  function NonTrackingInvalidationContext$Companion$INVALIDATION_POINT$1() {
    InvalidationPointBase.call(this);
  }
  protoOf(NonTrackingInvalidationContext$Companion$INVALIDATION_POINT$1).b5v = function () {
  };
  function Companion_79() {
    Companion_instance_79 = this;
    this.u5u_1 = new NonTrackingInvalidationContext();
    var tmp = this;
    tmp.v5u_1 = new NonTrackingInvalidationContext$Companion$INVALIDATION_POINT$1();
  }
  var Companion_instance_79;
  function Companion_getInstance_79() {
    if (Companion_instance_79 == null)
      new Companion_79();
    return Companion_instance_79;
  }
  function NonTrackingInvalidationContext$value$1($value) {
    this.d5w_1 = $value;
    InvalidatableBase.call(this);
  }
  protoOf(NonTrackingInvalidationContext$value$1).n5u = function () {
    return Companion_getInstance_79().v5u_1;
  };
  protoOf(NonTrackingInvalidationContext$value$1).y5u = function () {
    return this.d5w_1;
  };
  function NonTrackingInvalidationContext$failure$1($throwable) {
    this.e5w_1 = $throwable;
    InvalidatableBase.call(this);
  }
  protoOf(NonTrackingInvalidationContext$failure$1).n5u = function () {
    return Companion_getInstance_79().v5u_1;
  };
  protoOf(NonTrackingInvalidationContext$failure$1).y5u = function () {
    throw this.e5w_1;
  };
  function NonTrackingInvalidationContext() {
    Companion_getInstance_79();
  }
  protoOf(NonTrackingInvalidationContext).p38 = function () {
    return true;
  };
  protoOf(NonTrackingInvalidationContext).x5u = function (eventSource, reaction) {
  };
  protoOf(NonTrackingInvalidationContext).y5v = function (disposable) {
    disposable.zr();
  };
  protoOf(NonTrackingInvalidationContext).zr = function () {
  };
  protoOf(NonTrackingInvalidationContext).z5v = function (value) {
    return new NonTrackingInvalidationContext$value$1(value);
  };
  protoOf(NonTrackingInvalidationContext).a5w = function (throwable) {
    return new NonTrackingInvalidationContext$failure$1(throwable);
  };
  function attributeQuery(value, attributeFunction) {
    // Inline function 'jetbrains.ocelot.langDef.query.query' call
    return new attributeQuery$$inlined$query$1(value, attributeFunction);
  }
  function InvalidateOnAttributeChanged$Companion$compareByIdentity$lambda(a, b) {
    return a === b;
  }
  function InvalidateOnAttributeChanged$Companion$compareByEquality$lambda(a, b) {
    return equals(a, b);
  }
  function Companion_80() {
    Companion_instance_80 = this;
    var tmp = this;
    tmp.f5w_1 = InvalidateOnAttributeChanged$Companion$compareByIdentity$lambda;
    var tmp_0 = this;
    tmp_0.g5w_1 = InvalidateOnAttributeChanged$Companion$compareByEquality$lambda;
  }
  var Companion_instance_80;
  function Companion_getInstance_80() {
    if (Companion_instance_80 == null)
      new Companion_80();
    return Companion_instance_80;
  }
  function InvalidateOnAttributeChanged(value, attributeFunction, compare) {
    Companion_getInstance_80();
    this.h5w_1 = value;
    this.i5w_1 = attributeFunction;
    this.j5w_1 = compare;
    this.k5w_1 = this.i5w_1(this.h5w_1);
  }
  protoOf(InvalidateOnAttributeChanged).c5u = function (event, actions) {
    var newValue = this.i5w_1(this.h5w_1);
    if (!this.j5w_1(newValue, this.k5w_1)) {
      this.k5w_1 = newValue;
      actions.d5u();
    }
  };
  protoOf(InvalidateOnAttributeChanged).e5u = function (event, actions) {
    return this.c5u(!(event == null) ? event : THROW_CCE(), actions);
  };
  function attributeQuery$$inlined$query$1($value, $attributeFunction) {
    this.l5w_1 = $value;
    this.m5w_1 = $attributeFunction;
  }
  protoOf(attributeQuery$$inlined$query$1).n5w = function (builder) {
    var reaction = new InvalidateOnAttributeChanged(this.l5w_1, this.m5w_1, Companion_getInstance_80().g5w_1);
    builder.q5w_1.o5w_1.x5u(this.l5w_1, reaction);
    return reaction.k5w_1;
  };
  function Execution(dependencies, observationContext) {
    this.o5w_1 = dependencies;
    this.p5w_1 = CoroutineScope_0(observationContext);
  }
  protoOf(Execution).s5w = function () {
    return get_isActive(this.p5w_1);
  };
  function asNullableProperty(_this__u8e3s4) {
    return withDefault(_this__u8e3s4, null);
  }
  function Ready(outcome) {
    Result_0.call(this);
    this.t5w_1 = outcome;
  }
  protoOf(Ready).toString = function () {
    return 'Ready(outcome=' + toString_1(this.t5w_1) + ')';
  };
  protoOf(Ready).hashCode = function () {
    return hashCode(this.t5w_1);
  };
  protoOf(Ready).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Ready))
      return false;
    if (!equals(this.t5w_1, other.t5w_1))
      return false;
    return true;
  };
  function NotReady() {
    NotReady_instance = this;
    Result_0.call(this);
  }
  var NotReady_instance;
  function NotReady_getInstance() {
    if (NotReady_instance == null)
      new NotReady();
    return NotReady_instance;
  }
  function Success(value) {
    Outcome.call(this);
    this.u5w_1 = value;
  }
  protoOf(Success).toString = function () {
    return 'Success(value=' + toString_0(this.u5w_1) + ')';
  };
  protoOf(Success).hashCode = function () {
    return this.u5w_1 == null ? 0 : hashCode(this.u5w_1);
  };
  protoOf(Success).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Success))
      return false;
    if (!equals(this.u5w_1, other.u5w_1))
      return false;
    return true;
  };
  function Failure_0(throwable) {
    Outcome.call(this);
    this.v5w_1 = throwable;
  }
  protoOf(Failure_0).toString = function () {
    return 'Failure(throwable=' + this.v5w_1.toString() + ')';
  };
  protoOf(Failure_0).hashCode = function () {
    return hashCode(this.v5w_1);
  };
  protoOf(Failure_0).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Failure_0))
      return false;
    if (!equals(this.v5w_1, other.v5w_1))
      return false;
    return true;
  };
  function LoopingQuery$listeners$o$beforeFirstAdded$lambda(this$0) {
    return function (it) {
      var tmp;
      if (it instanceof CancellationException) {
        this$0.b5x_1 = NotReady_getInstance();
        tmp = Unit_instance;
      } else {
        if (it instanceof Error) {
          ThrowableHandlers_getInstance().k2r_1.j2r(it);
          this$0.b5x_1 = NotReady_getInstance();
          tmp = Unit_instance;
        }
      }
      return Unit_instance;
    };
  }
  function LoopingQuery$launchComputingJob$slambda$lambda($event) {
    return function (it) {
      it.n2s($event);
      return Unit_instance;
    };
  }
  function LoopingQuery$launchComputingJob$slambda$lambda_0($awaitInvalidation) {
    return function (it) {
      $awaitInvalidation.su();
      return Unit_instance;
    };
  }
  function launchComputingJob($this) {
    var tmp = CoroutineStart_UNDISPATCHED_getInstance();
    return launch($this.z5w_1, VOID, tmp, LoopingQuery$launchComputingJob$slambda_0($this, null));
  }
  function Result_0() {
  }
  function Outcome() {
  }
  function LoopingQuery$_init_$slambda_vmyece(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(LoopingQuery$_init_$slambda_vmyece).m5x = function (it, $completion) {
    var tmp = this.n5x(it, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(LoopingQuery$_init_$slambda_vmyece).v9 = function (p1, $completion) {
    return this.m5x(p1 instanceof Outcome ? p1 : THROW_CCE(), $completion);
  };
  protoOf(LoopingQuery$_init_$slambda_vmyece).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        if (tmp === 0) {
          this.g9_1 = 1;
          return true;
        } else if (tmp === 1) {
          throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(LoopingQuery$_init_$slambda_vmyece).n5x = function (it, completion) {
    var i = new LoopingQuery$_init_$slambda_vmyece(completion);
    i.l5x_1 = it;
    return i;
  };
  function LoopingQuery$_init_$slambda_vmyece_0(resultContinuation) {
    var i = new LoopingQuery$_init_$slambda_vmyece(resultContinuation);
    var l = function (it, $completion) {
      return i.m5x(it, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function LoopingQuery$listeners$1(this$0) {
    this.p5x_1 = this$0;
    Listeners.call(this);
  }
  protoOf(LoopingQuery$listeners$1).c2s = function () {
    var tmp0_safe_receiver = this.p5x_1.a5x_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.sp();
    }
    var newComputingJob = launchComputingJob(this.p5x_1);
    newComputingJob.kp(LoopingQuery$listeners$o$beforeFirstAdded$lambda(this.p5x_1));
    this.p5x_1.a5x_1 = newComputingJob;
  };
  protoOf(LoopingQuery$listeners$1).g2s = function () {
    var tmp0_safe_receiver = this.p5x_1.a5x_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.sp();
    }
  };
  function LoopingQuery$launchComputingJob$slambda(this$0, resultContinuation) {
    this.y5x_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(LoopingQuery$launchComputingJob$slambda).e1h = function ($this$launch, $completion) {
    var tmp = this.f1h($this$launch, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(LoopingQuery$launchComputingJob$slambda).v9 = function (p1, $completion) {
    return this.e1h((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(LoopingQuery$launchComputingJob$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 31;
            this.f9_1 = 1;
            continue $sm;
          case 1:
            if (!get_isActive_0(this.z5x_1.ho())) {
              this.f9_1 = 30;
              continue $sm;
            }

            this.y5x_1.y5w_1.f39();
            this.f9_1 = 2;
            continue $sm;
          case 2:
            if (!true) {
              this.f9_1 = 6;
              continue $sm;
            }

            this.j5y_1 = new Invalidator();
            this.g9_1 = 4;
            this.f9_1 = 3;
            suspendResult = supervise(this.y5x_1.w5w_1, this.j5y_1, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            this.k5y_1 = suspendResult;
            this.g9_1 = 31;
            this.f9_1 = 5;
            continue $sm;
          case 4:
            this.g9_1 = 31;
            var tmp_0 = this.i9_1;
            if (tmp_0 instanceof AlreadyInvalidException) {
              var e = this.i9_1;
              this.f9_1 = 2;
              var tmp_1 = this;
              continue $sm;
            } else {
              var tmp_2 = this.i9_1;
              if (tmp_2 instanceof Error) {
                var e_0 = this.i9_1;
                var tmp_3 = this;
                this.y5x_1.y5w_1.g39();
                if (this.j5y_1.p38()) {
                  this.j5y_1.zr();
                }
                throw e_0;
              } else {
                throw this.i9_1;
              }
            }

          case 5:
            this.g9_1 = 31;
            this.h5y_1 = this.k5y_1;
            this.a5y_1 = this.j5y_1;
            this.f9_1 = 6;
            continue $sm;
          case 6:
            this.f9_1 = 7;
            continue $sm;
          case 7:
            this.f9_1 = 8;
            continue $sm;
          case 8:
            this.g9_1 = 29;
            this.f9_1 = 9;
            continue $sm;
          case 9:
            this.g9_1 = 28;
            this.i5y_1 = this.y5x_1.b5x_1;
            var tmp_4 = this;
            this.z5x_1;
            var tmp_5;
            try {
              var value = this.h5y_1.m5u();
              tmp_5 = _Result___init__impl__xyqfz8(value);
            } catch ($p) {
              var tmp_6;
              if ($p instanceof Error) {
                var e_1 = $p;
                tmp_6 = _Result___init__impl__xyqfz8(createFailure(e_1));
              } else {
                throw $p;
              }
              tmp_5 = tmp_6;
            }

            var this_0 = tmp_5;
            var exception = Result__exceptionOrNull_impl_p6xea9(this_0);
            var tmp_7;
            if (exception == null) {
              var tmp_8 = _Result___get_value__impl__bjfvqg(this_0);
              var it = (tmp_8 == null ? true : !(tmp_8 == null)) ? tmp_8 : THROW_CCE();
              tmp_7 = new Success(it);
            } else {
              tmp_7 = new Failure_0(exception);
            }

            tmp_4.d5y_1 = tmp_7;
            this.y5x_1.b5x_1 = new Ready(this.d5y_1);
            this.e5y_1 = !equals(this.i5y_1, this.y5x_1.b5x_1);
            if (this.e5y_1) {
              this.f9_1 = 10;
              suspendResult = yield_0(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.f9_1 = 12;
              continue $sm;
            }

          case 10:
            var event = new PropertyChangeEvent(this.i5y_1, this.y5x_1.b5x_1);
            this.y5x_1.c5x_1.k2s(LoopingQuery$launchComputingJob$slambda$lambda(event));
            this.f9_1 = 11;
            suspendResult = yield_0(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 11:
            this.f9_1 = 12;
            continue $sm;
          case 12:
            this.f9_1 = 13;
            continue $sm;
          case 13:
            this.g9_1 = 29;
            this.y5x_1.y5w_1.g39();
            if (this.h5y_1.n5u().p38()) {
              this.f5y_1 = Job_0();
              var tmp_9 = this.h5y_1.n5u();
              var handler = tmp_9.z2r(LoopingQuery$launchComputingJob$slambda$lambda_0(this.f5y_1));
              var tmp_10 = this;
              tmp_10.g5y_1 = handler;
              this.f9_1 = 14;
              continue $sm;
            } else {
              this.f9_1 = 21;
              continue $sm;
            }

          case 14:
            this.b5y_1 = this.g5y_1;
            this.f9_1 = 15;
            continue $sm;
          case 15:
            this.f9_1 = 16;
            continue $sm;
          case 16:
            this.g9_1 = 27;
            this.b5y_1;
            this.f9_1 = 17;
            suspendResult = this.f5y_1.np(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 17:
            this.f9_1 = 18;
            var tmp_11 = this;
            continue $sm;
          case 18:
            this.g9_1 = 29;
            this.b5y_1.zr();
            this.f9_1 = 20;
            continue $sm;
          case 19:
            this.g9_1 = 29;
            this.b5y_1.zr();
            if (false) {
              this.f9_1 = 14;
              continue $sm;
            }

            this.f9_1 = 20;
            continue $sm;
          case 20:
            this.f9_1 = 21;
            continue $sm;
          case 21:
            if (this.e5y_1) {
              this.f9_1 = 22;
              suspendResult = this.y5x_1.x5w_1(this.d5y_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.c5y_1 = false;
              this.f9_1 = 23;
              continue $sm;
            }

          case 22:
            this.c5y_1 = !suspendResult;
            this.f9_1 = 23;
            continue $sm;
          case 23:
            if (this.c5y_1) {
              this.g9_1 = 31;
              this.f9_1 = 25;
              continue $sm;
            } else {
              this.f9_1 = 24;
              continue $sm;
            }

          case 24:
            this.g9_1 = 31;
            this.f9_1 = 26;
            continue $sm;
          case 25:
            this.g9_1 = 31;
            if (this.a5y_1.p38()) {
              this.a5y_1.zr();
            }

            this.f9_1 = 30;
            continue $sm;
          case 26:
            this.g9_1 = 31;
            if (this.a5y_1.p38()) {
              this.a5y_1.zr();
            }

            this.f9_1 = 1;
            continue $sm;
          case 27:
            this.g9_1 = 29;
            var t = this.i9_1;
            this.b5y_1.zr();
            throw t;
          case 28:
            this.g9_1 = 29;
            var t_0 = this.i9_1;
            this.y5x_1.y5w_1.g39();
            throw t_0;
          case 29:
            this.g9_1 = 31;
            var t_1 = this.i9_1;
            if (this.a5y_1.p38()) {
              this.a5y_1.zr();
            }

            throw t_1;
          case 30:
            return Unit_instance;
          case 31:
            throw this.i9_1;
        }
      } catch ($p) {
        var e_2 = $p;
        if (this.g9_1 === 31) {
          throw e_2;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e_2;
        }
      }
     while (true);
  };
  protoOf(LoopingQuery$launchComputingJob$slambda).f1h = function ($this$launch, completion) {
    var i = new LoopingQuery$launchComputingJob$slambda(this.y5x_1, completion);
    i.z5x_1 = $this$launch;
    return i;
  };
  function LoopingQuery$launchComputingJob$slambda_0(this$0, resultContinuation) {
    var i = new LoopingQuery$launchComputingJob$slambda(this$0, resultContinuation);
    var l = function ($this$launch, $completion) {
      return i.e1h($this$launch, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function LoopingQuery(parentCoroutineContext, query, recomputeCallback, asyncTracker) {
    var tmp;
    if (recomputeCallback === VOID) {
      tmp = LoopingQuery$_init_$slambda_vmyece_0(null);
    } else {
      tmp = recomputeCallback;
    }
    recomputeCallback = tmp;
    asyncTracker = asyncTracker === VOID ? Companion_getInstance_38().h39_1 : asyncTracker;
    this.w5w_1 = query;
    this.x5w_1 = recomputeCallback;
    this.y5w_1 = asyncTracker;
    this.z5w_1 = CoroutineScope_0(parentCoroutineContext);
    this.a5x_1 = null;
    this.b5x_1 = NotReady_getInstance();
    var tmp_0 = this;
    tmp_0.c5x_1 = new LoopingQuery$listeners$1(this);
  }
  protoOf(LoopingQuery).v2w = function () {
    return 'LoopingQuery@' + toString_3(hashCode(this), 16) + '[' + toString_1(this.w5w_1) + ']';
  };
  protoOf(LoopingQuery).uv = function () {
    return this.b5x_1;
  };
  protoOf(LoopingQuery).l5y = function (handler) {
    return this.c5x_1.j2s(handler);
  };
  protoOf(LoopingQuery).y2r = function (handler) {
    return this.l5y(handler);
  };
  function withDefault(_this__u8e3s4, default_0) {
    return map_0(_this__u8e3s4, withDefault$lambda(default_0));
  }
  function withDefault$lambda($default) {
    return function (value) {
      var tmp;
      if (equals(value, NotReady_getInstance())) {
        tmp = $default;
      } else {
        if (value instanceof Ready) {
          var outcome = value.t5w_1;
          var tmp_0;
          if (outcome instanceof Failure_0) {
            ThrowableHandlers_getInstance().k2r_1.j2r(outcome.v5w_1);
            tmp_0 = $default;
          } else {
            if (outcome instanceof Success) {
              tmp_0 = outcome.u5w_1;
            } else {
              noWhenBranchMatchedException();
            }
          }
          tmp = tmp_0;
        } else {
          noWhenBranchMatchedException();
        }
      }
      return tmp;
    };
  }
  function QCollectionBase$_get_size_$lambda_5cjhst(it) {
    return it.p();
  }
  function QCollectionBase$contains$lambda($element) {
    return function (it) {
      return it.t($element);
    };
  }
  function QCollectionBase() {
  }
  function QMutableCollectionBase() {
  }
  function QMutableListBase() {
  }
  function toReified(_this__u8e3s4, valueKClass) {
    return new toReified$1(_this__u8e3s4, valueKClass);
  }
  function toReified$1($this_toReified, $valueKClass) {
    this.n5y_1 = $this_toReified;
    this.o5y_1 = $valueKClass;
  }
  protoOf(toReified$1).p5y = function () {
    return this.o5y_1;
  };
  protoOf(toReified$1).m5y = function () {
    return this.n5y_1.m5y();
  };
  protoOf(toReified$1).n5w = function (builder) {
    return this.n5y_1.n5w(builder);
  };
  protoOf(toReified$1).q5y = function (builder, $completion) {
    return this.n5y_1.r5w(builder, $completion);
  };
  protoOf(toReified$1).r5w = function (builder, $completion) {
    return this.q5y(builder, $completion);
  };
  protoOf(toReified$1).x30 = function (newValue) {
    this.n5y_1.d2x(newValue);
  };
  protoOf(toReified$1).d2x = function (newValue) {
    return this.x30((newValue == null ? true : !(newValue == null)) ? newValue : THROW_CCE());
  };
  protoOf(toReified$1).r5y = function (value) {
    this.n5y_1.f2x(value);
  };
  protoOf(toReified$1).f2x = function (value) {
    return this.r5y((value == null ? true : !(value == null)) ? value : THROW_CCE());
  };
  function execute_0(_this__u8e3s4) {
    return supervise_0(_this__u8e3s4, Companion_getInstance_79().u5u_1).m5u();
  }
  function execute_1(_this__u8e3s4, $completion) {
    var tmp = new $executeCOROUTINE$(_this__u8e3s4, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  }
  function constant(value) {
    // Inline function 'jetbrains.ocelot.langDef.query.query' call
    return new constant$$inlined$query$1(value);
  }
  function supervise(_this__u8e3s4, invalidationContext, observationContext, $completion) {
    observationContext = observationContext === VOID ? EmptyCoroutineContext_instance : observationContext;
    var tmp = new $superviseCOROUTINE$(_this__u8e3s4, invalidationContext, observationContext, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  }
  function supervise_0(_this__u8e3s4, invalidationContext, observationContext) {
    observationContext = observationContext === VOID ? EmptyCoroutineContext_instance : observationContext;
    var tmp;
    try {
      tmp = _this__u8e3s4.n5w(QueryInit_getInstance().p5z(invalidationContext, observationContext));
    } catch ($p) {
      var tmp_0;
      if ($p instanceof AlreadyInvalidException) {
        var t = $p;
        throw t;
      } else {
        if ($p instanceof Error) {
          var t_0 = $p;
          return invalidationContext.a5w(t_0);
        } else {
          throw $p;
        }
      }
    }
    var result = tmp;
    return invalidationContext.z5v(result);
  }
  function sam$jetbrains_ocelot_base_disposable_Disposable$0_1(function_0) {
    this.q5z_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0_1).zr = function () {
    return this.q5z_1();
  };
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0_1).f3 = function () {
    return this.q5z_1;
  };
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0_1).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Disposable) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0_1).hashCode = function () {
    return hashCode(this.f3());
  };
  function QueryInit$initBuilder$lambda($job) {
    return function () {
      $job.sp();
      return Unit_instance;
    };
  }
  function QueryInit() {
    QueryInit_instance = this;
    var tmp = this;
    var tmp_0 = Companion_getInstance_79().u5u_1;
    // Inline function 'kotlin.also' call
    var this_0 = Job_0();
    this_0.sp();
    tmp.o5z_1 = new QueryBuilder(new Execution(tmp_0, this_0));
  }
  protoOf(QueryInit).p5z = function (invalidationContext, observationContext) {
    if (invalidationContext instanceof NonTrackingInvalidationContext)
      return this.o5z_1;
    var job = Job_0();
    var newObservationContext = observationContext.wi(job);
    var tmp = QueryInit$initBuilder$lambda(job);
    invalidationContext.y5v(new sam$jetbrains_ocelot_base_disposable_Disposable$0_1(tmp));
    var execution = new Execution(invalidationContext, newObservationContext);
    return new QueryBuilder(execution);
  };
  var QueryInit_instance;
  function QueryInit_getInstance() {
    if (QueryInit_instance == null)
      new QueryInit();
    return QueryInit_instance;
  }
  function constant$$inlined$query$1($value) {
    this.r5z_1 = $value;
  }
  protoOf(constant$$inlined$query$1).n5w = function (builder) {
    return this.r5z_1;
  };
  function sam$jetbrains_ocelot_base_disposable_Disposable$0_2(function_0) {
    this.s5z_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0_2).zr = function () {
    return this.s5z_1();
  };
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0_2).f3 = function () {
    return this.s5z_1;
  };
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0_2).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Disposable) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0_2).hashCode = function () {
    return hashCode(this.f3());
  };
  function supervise$slambda$lambda($invalidationContext, $this_coroutineScope) {
    return function () {
      var alreadyInvalidException = new AlreadyInvalidException($invalidationContext, 'Query execution no longer required');
      get_job($this_coroutineScope.ho()).rp(CancellationException_init_$Create$_1('Already invalid', alreadyInvalidException));
      return Unit_instance;
    };
  }
  function supervise$slambda($invalidationContext, $this_supervise, $currentObservationContext, resultContinuation) {
    this.b60_1 = $invalidationContext;
    this.c60_1 = $this_supervise;
    this.d60_1 = $currentObservationContext;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(supervise$slambda).f60 = function ($this$coroutineScope, $completion) {
    var tmp = this.f1h($this$coroutineScope, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(supervise$slambda).v9 = function (p1, $completion) {
    return this.f60((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(supervise$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            var tmp_0 = supervise$slambda$lambda(this.b60_1, this.e60_1);
            this.b60_1.y5v(new sam$jetbrains_ocelot_base_disposable_Disposable$0_2(tmp_0));
            this.f9_1 = 1;
            suspendResult = this.c60_1.r5w(QueryInit_getInstance().p5z(this.b60_1, this.d60_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(supervise$slambda).f1h = function ($this$coroutineScope, completion) {
    var i = new supervise$slambda(this.b60_1, this.c60_1, this.d60_1, completion);
    i.e60_1 = $this$coroutineScope;
    return i;
  };
  function supervise$slambda_0($invalidationContext, $this_supervise, $currentObservationContext, resultContinuation) {
    var i = new supervise$slambda($invalidationContext, $this_supervise, $currentObservationContext, resultContinuation);
    var l = function ($this$coroutineScope, $completion) {
      return i.f60($this$coroutineScope, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function $executeCOROUTINE$(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.a5z_1 = _this__u8e3s4;
  }
  protoOf($executeCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = supervise(this.a5z_1, Companion_getInstance_79().u5u_1, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult.m5u();
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function $superviseCOROUTINE$(_this__u8e3s4, invalidationContext, observationContext, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.j5z_1 = _this__u8e3s4;
    this.k5z_1 = invalidationContext;
    this.l5z_1 = observationContext;
  }
  protoOf($superviseCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 5;
            var currentObservationContext = this.l9().wi(this.l5z_1);
            var tmp_0 = this.j5z_1;
            if (isInterface(tmp_0, Query)) {
              return supervise_0(this.j5z_1, this.k5z_1, currentObservationContext);
            }

            this.g9_1 = 4;
            var tmp_1 = this.k5z_1;
            if (tmp_1 instanceof NonTrackingInvalidationContext) {
              this.f9_1 = 2;
              suspendResult = this.j5z_1.r5w(QueryInit_getInstance().p5z(this.k5z_1, currentObservationContext), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.f9_1 = 1;
              suspendResult = coroutineScope(supervise$slambda_0(this.k5z_1, this.j5z_1, currentObservationContext, null), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            this.n5z_1 = suspendResult;
            this.f9_1 = 3;
            continue $sm;
          case 2:
            this.n5z_1 = suspendResult;
            this.f9_1 = 3;
            continue $sm;
          case 3:
            var value = this.n5z_1;
            var tmp_2 = this;
            tmp_2.m5z_1 = _Result___init__impl__xyqfz8(value);
            this.g9_1 = 5;
            this.f9_1 = 6;
            continue $sm;
          case 4:
            this.g9_1 = 5;
            var tmp_3 = this.i9_1;
            if (tmp_3 instanceof CancellationException) {
              var exception = this.i9_1;
              var tmp_4 = this;
              var cause = exception.cause;
              var tmp0_safe_receiver = cause instanceof CancellationException ? cause : null;
              var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.cause;
              var actualCause = tmp1_elvis_lhs == null ? cause : tmp1_elvis_lhs;
              if (actualCause instanceof AlreadyInvalidException) {
                throw actualCause;
              }
              throw exception;
            } else {
              var tmp_5 = this.i9_1;
              if (tmp_5 instanceof AlreadyInvalidException) {
                var exception_0 = this.i9_1;
                var tmp_6 = this;
                throw exception_0;
              } else {
                var tmp_7 = this.i9_1;
                if (tmp_7 instanceof Error) {
                  var t = this.i9_1;
                  var tmp_8 = this;
                  tmp_8.m5z_1 = _Result___init__impl__xyqfz8(createFailure(t));
                  this.f9_1 = 6;
                  continue $sm;
                } else {
                  throw this.i9_1;
                }
              }
            }

          case 5:
            throw this.i9_1;
          case 6:
            this.g9_1 = 5;
            var result = this.m5z_1;
            if (!this.k5z_1.p38()) {
              throw new AlreadyInvalidException(this.k5z_1, 'invalidated after being computed but before returning');
            }

            var exception_1 = Result__exceptionOrNull_impl_p6xea9(result);
            var tmp_9;
            if (exception_1 == null) {
              var tmp_10 = _Result___get_value__impl__bjfvqg(result);
              var it = (tmp_10 == null ? true : !(tmp_10 == null)) ? tmp_10 : THROW_CCE();
              tmp_9 = this.k5z_1.z5v(it);
            } else {
              tmp_9 = this.k5z_1.a5w(exception_1);
            }

            return tmp_9;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 5) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function Companion_81() {
    Companion_instance_81 = this;
    this.g60_1 = constant(null);
    this.h60_1 = constant(false);
    this.i60_1 = constant(true);
    this.j60_1 = constant('');
  }
  var Companion_instance_81;
  function Companion_getInstance_81() {
    if (Companion_instance_81 == null)
      new Companion_81();
    return Companion_instance_81;
  }
  function Query() {
  }
  function QueryBuilder(execution) {
    this.q5w_1 = execution;
  }
  protoOf(QueryBuilder).k60 = function (_this__u8e3s4, $completion) {
    return _this__u8e3s4.r5w(this, $completion);
  };
  protoOf(QueryBuilder).l60 = function (_this__u8e3s4) {
    return _this__u8e3s4.n5w(this);
  };
  function waitUntilNot(_this__u8e3s4, emptyValue) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new waitUntilNot$$inlined$suspendingQuery$1(_this__u8e3s4, emptyValue);
  }
  function waitUntilNot$o$runSuspend$lambda($d) {
    return function (it) {
      $d.pu(Unit_instance);
      return Unit_instance;
    };
  }
  function $runSuspendCOROUTINE$(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.u60_1 = _this__u8e3s4;
    this.v60_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 6;
            var tmp_0 = this;
            tmp_0.y60_1 = this.v60_1;
            this.w60_1 = Unit_instance;
            this.f9_1 = 1;
            continue $sm;
          case 1:
            this.x60_1 = this.y60_1;
            var value = this.u60_1.z60_1.uv();
            if (!equals(value, this.u60_1.a61_1)) {
              this.w60_1 = this.x60_1.l60(get_forQueries_0(this.u60_1.z60_1));
              this.f9_1 = 5;
              continue $sm;
            } else {
              this.f9_1 = 2;
              continue $sm;
            }

          case 2:
            var d = CompletableDeferred();
            var handler = this.u60_1.z60_1.z2r(waitUntilNot$o$runSuspend$lambda(d));
            this.x60_1.q5w_1.o5w_1.y5v(handler);
            this.f9_1 = 3;
            suspendResult = d.nr(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            this.f9_1 = 4;
            suspendResult = this.x60_1.k60(waitUntilNot(this.u60_1.z60_1, this.u60_1.a61_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            this.w60_1 = suspendResult;
            if (false) {
              this.f9_1 = 1;
              continue $sm;
            }

            this.f9_1 = 5;
            continue $sm;
          case 5:
            return this.w60_1;
          case 6:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 6) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function waitUntilNot$$inlined$suspendingQuery$1($this_waitUntilNot, $emptyValue) {
    this.z60_1 = $this_waitUntilNot;
    this.a61_1 = $emptyValue;
  }
  protoOf(waitUntilNot$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(waitUntilNot$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function get_forQueries(_this__u8e3s4) {
    return new QPropertyAdapter(_this__u8e3s4);
  }
  function get_asProperty(_this__u8e3s4) {
    return new EagerInvalidatable(new asProperty$1(_this__u8e3s4));
  }
  function get_forQueries_0(_this__u8e3s4) {
    return new QReadablePropertyAdapter(_this__u8e3s4);
  }
  function get_forQueries_1(_this__u8e3s4) {
    return new QListAdapter(_this__u8e3s4);
  }
  function get_forQueries_2(_this__u8e3s4) {
    return new QCollectionAdapter(_this__u8e3s4);
  }
  function get_forQueries_3(_this__u8e3s4) {
    return new QTextPropertyAdapter(_this__u8e3s4);
  }
  function QPropertyAdapter(observable) {
    this.c61_1 = observable;
  }
  protoOf(QPropertyAdapter).m5y = function () {
    return this.c61_1;
  };
  protoOf(QPropertyAdapter).n5w = function (builder) {
    depend(builder.q5w_1.o5w_1, this.m5y());
    return this.m5y().w2w();
  };
  protoOf(QPropertyAdapter).vv = function (newValue) {
    this.m5y().d2x(newValue);
  };
  protoOf(QPropertyAdapter).d2x = function (newValue) {
    return this.vv((newValue == null ? true : !(newValue == null)) ? newValue : THROW_CCE());
  };
  protoOf(QPropertyAdapter).equals = function (other) {
    if (!(other instanceof QPropertyAdapter))
      return false;
    return equals(this.m5y(), other.m5y());
  };
  protoOf(QPropertyAdapter).hashCode = function () {
    return hashCode(this.m5y());
  };
  function QMutableListAdapter(observable) {
    this.d61_1 = observable;
  }
  protoOf(QMutableListAdapter).m5y = function () {
    return this.d61_1;
  };
  protoOf(QMutableListAdapter).n5w = function (builder) {
    depend_0(builder.q5w_1.o5w_1, this.m5y());
    return this.m5y();
  };
  protoOf(QMutableListAdapter).equals = function (other) {
    if (!(other instanceof QMutableListAdapter))
      return false;
    return equals(this.m5y(), other.m5y());
  };
  protoOf(QMutableListAdapter).hashCode = function () {
    return hashCode(this.m5y());
  };
  function get_forQueries_4(_this__u8e3s4) {
    return new QMutableCollectionAdapter(_this__u8e3s4);
  }
  function QReadablePropertyAdapter(observable) {
    this.e61_1 = observable;
  }
  protoOf(QReadablePropertyAdapter).n5w = function (builder) {
    depend(builder.q5w_1.o5w_1, this.e61_1);
    return this.e61_1.w2w();
  };
  protoOf(QReadablePropertyAdapter).equals = function (other) {
    if (!(other instanceof QReadablePropertyAdapter))
      return false;
    return equals(this.e61_1, other.e61_1);
  };
  protoOf(QReadablePropertyAdapter).hashCode = function () {
    return hashCode(this.e61_1);
  };
  function QListAdapter(observable) {
    this.f61_1 = observable;
  }
  protoOf(QListAdapter).m5y = function () {
    return this.f61_1;
  };
  protoOf(QListAdapter).n5w = function (builder) {
    depend_0(builder.q5w_1.o5w_1, this.f61_1);
    return this.f61_1;
  };
  protoOf(QListAdapter).equals = function (other) {
    if (!(other instanceof QListAdapter))
      return false;
    return equals(this.f61_1, other.f61_1);
  };
  protoOf(QListAdapter).hashCode = function () {
    return hashCode(this.f61_1);
  };
  function QCollectionAdapter(observable) {
    this.g61_1 = observable;
  }
  protoOf(QCollectionAdapter).m5y = function () {
    return this.g61_1;
  };
  protoOf(QCollectionAdapter).n5w = function (builder) {
    depend_0(builder.q5w_1.o5w_1, this.g61_1);
    return this.g61_1;
  };
  protoOf(QCollectionAdapter).equals = function (other) {
    if (!(other instanceof QCollectionAdapter))
      return false;
    return equals(this.g61_1, other.g61_1);
  };
  protoOf(QCollectionAdapter).hashCode = function () {
    return hashCode(this.g61_1);
  };
  function QTextPropertyAdapter(observable) {
    this.h61_1 = observable;
  }
  protoOf(QTextPropertyAdapter).m5y = function () {
    return this.h61_1;
  };
  protoOf(QTextPropertyAdapter).n5w = function (builder) {
    depend(builder.q5w_1.o5w_1, this.h61_1);
    return this.h61_1.w2w();
  };
  protoOf(QTextPropertyAdapter).equals = function (other) {
    if (!(other instanceof QTextPropertyAdapter))
      return false;
    return equals(this.h61_1, other.h61_1);
  };
  protoOf(QTextPropertyAdapter).hashCode = function () {
    return hashCode(this.h61_1);
  };
  function QMutableCollectionAdapter(observable) {
    this.i61_1 = observable;
  }
  protoOf(QMutableCollectionAdapter).m5y = function () {
    return this.i61_1;
  };
  protoOf(QMutableCollectionAdapter).n5w = function (builder) {
    depend_0(builder.q5w_1.o5w_1, this.i61_1);
    return this.i61_1;
  };
  protoOf(QMutableCollectionAdapter).equals = function (other) {
    if (!(other instanceof QMutableCollectionAdapter))
      return false;
    return equals(this.i61_1, other.i61_1);
  };
  protoOf(QMutableCollectionAdapter).hashCode = function () {
    return hashCode(this.i61_1);
  };
  function asProperty$1($this_asProperty) {
    this.j61_1 = $this_asProperty;
  }
  protoOf(asProperty$1).l5u = function (context) {
    var execution = new Execution(context, EmptyCoroutineContext_instance);
    var builder = new QueryBuilder(execution);
    var result = this.j61_1.n5w(builder);
    return context.z5v(result);
  };
  function Default_0() {
    Default_instance_0 = this;
    Json_0.call(this, new JsonConfiguration(), EmptySerializersModule_0());
  }
  var Default_instance_0;
  function Default_getInstance_0() {
    if (Default_instance_0 == null)
      new Default_0();
    return Default_instance_0;
  }
  function Json_0(configuration, serializersModule) {
    Default_getInstance_0();
    this.k61_1 = configuration;
    this.l61_1 = serializersModule;
    this.m61_1 = new DescriptorSchemaCache();
  }
  protoOf(Json_0).g59 = function () {
    return this.l61_1;
  };
  protoOf(Json_0).c5a = function (serializer, value) {
    var result = new JsonToStringWriter();
    try {
      encodeByWriter(this, result, serializer, value);
      return result.toString();
    }finally {
      result.zu();
    }
  };
  protoOf(Json_0).d5a = function (deserializer, string) {
    var lexer = new StringJsonLexer_0(string);
    var input = new StreamingJsonDecoder(this, WriteMode_OBJ_getInstance(), lexer, deserializer.v58(), null);
    var result = input.k59(deserializer);
    lexer.c62();
    return result;
  };
  protoOf(Json_0).n61 = function (serializer, value) {
    return writeJson(this, value, serializer);
  };
  protoOf(Json_0).o61 = function (deserializer, element) {
    return readJson(this, element, deserializer);
  };
  function Json_1(from, builderAction) {
    from = from === VOID ? Default_getInstance_0() : from;
    var builder = new JsonBuilder(from);
    builderAction(builder);
    var conf = builder.r62();
    return new JsonImpl(conf, builder.q62_1);
  }
  function JsonBuilder(json) {
    this.d62_1 = json.k61_1.s62_1;
    this.e62_1 = json.k61_1.x62_1;
    this.f62_1 = json.k61_1.t62_1;
    this.g62_1 = json.k61_1.u62_1;
    this.h62_1 = json.k61_1.v62_1;
    this.i62_1 = json.k61_1.w62_1;
    this.j62_1 = json.k61_1.y62_1;
    this.k62_1 = json.k61_1.z62_1;
    this.l62_1 = json.k61_1.a63_1;
    this.m62_1 = json.k61_1.b63_1;
    this.n62_1 = json.k61_1.c63_1;
    this.o62_1 = json.k61_1.d63_1;
    this.p62_1 = json.k61_1.e63_1;
    this.q62_1 = json.g59();
  }
  protoOf(JsonBuilder).r62 = function () {
    if (this.l62_1) {
      // Inline function 'kotlin.require' call
      if (!(this.m62_1 === 'type')) {
        var message = 'Class discriminator should not be specified when array polymorphism is specified';
        throw IllegalArgumentException_init_$Create$_0(toString_1(message));
      }
    }
    if (!this.i62_1) {
      // Inline function 'kotlin.require' call
      if (!(this.j62_1 === '    ')) {
        var message_0 = 'Indent should not be specified when default printing mode is used';
        throw IllegalArgumentException_init_$Create$_0(toString_1(message_0));
      }
    } else if (!(this.j62_1 === '    ')) {
      var tmp0 = this.j62_1;
      var tmp$ret$5;
      $l$block: {
        // Inline function 'kotlin.text.all' call
        var inductionVariable = 0;
        while (inductionVariable < charSequenceLength(tmp0)) {
          var element = charSequenceGet(tmp0, inductionVariable);
          inductionVariable = inductionVariable + 1 | 0;
          if (!(element === _Char___init__impl__6a9atx(32) || element === _Char___init__impl__6a9atx(9) || element === _Char___init__impl__6a9atx(13) || element === _Char___init__impl__6a9atx(10))) {
            tmp$ret$5 = false;
            break $l$block;
          }
        }
        tmp$ret$5 = true;
      }
      var allWhitespaces = tmp$ret$5;
      // Inline function 'kotlin.require' call
      if (!allWhitespaces) {
        var message_1 = 'Only whitespace, tab, newline and carriage return are allowed as pretty print symbols. Had ' + this.j62_1;
        throw IllegalArgumentException_init_$Create$_0(toString_1(message_1));
      }
    }
    return new JsonConfiguration(this.d62_1, this.f62_1, this.g62_1, this.h62_1, this.i62_1, this.e62_1, this.j62_1, this.k62_1, this.l62_1, this.m62_1, this.n62_1, this.o62_1, this.p62_1);
  };
  function validateConfiguration($this) {
    if (equals($this.g59(), EmptySerializersModule_0()))
      return Unit_instance;
    var collector = new PolymorphismValidator($this.k61_1.a63_1, $this.k61_1.b63_1);
    $this.g59().a5t(collector);
  }
  function JsonImpl(configuration, module_0) {
    Json_0.call(this, configuration, module_0);
    validateConfiguration(this);
  }
  function JsonClassDiscriminator() {
  }
  function JsonNames() {
  }
  function JsonConfiguration(encodeDefaults, ignoreUnknownKeys, isLenient, allowStructuredMapKeys, prettyPrint, explicitNulls, prettyPrintIndent, coerceInputValues, useArrayPolymorphism, classDiscriminator, allowSpecialFloatingPointValues, useAlternativeNames, namingStrategy) {
    encodeDefaults = encodeDefaults === VOID ? false : encodeDefaults;
    ignoreUnknownKeys = ignoreUnknownKeys === VOID ? false : ignoreUnknownKeys;
    isLenient = isLenient === VOID ? false : isLenient;
    allowStructuredMapKeys = allowStructuredMapKeys === VOID ? false : allowStructuredMapKeys;
    prettyPrint = prettyPrint === VOID ? false : prettyPrint;
    explicitNulls = explicitNulls === VOID ? true : explicitNulls;
    prettyPrintIndent = prettyPrintIndent === VOID ? '    ' : prettyPrintIndent;
    coerceInputValues = coerceInputValues === VOID ? false : coerceInputValues;
    useArrayPolymorphism = useArrayPolymorphism === VOID ? false : useArrayPolymorphism;
    classDiscriminator = classDiscriminator === VOID ? 'type' : classDiscriminator;
    allowSpecialFloatingPointValues = allowSpecialFloatingPointValues === VOID ? false : allowSpecialFloatingPointValues;
    useAlternativeNames = useAlternativeNames === VOID ? true : useAlternativeNames;
    namingStrategy = namingStrategy === VOID ? null : namingStrategy;
    this.s62_1 = encodeDefaults;
    this.t62_1 = ignoreUnknownKeys;
    this.u62_1 = isLenient;
    this.v62_1 = allowStructuredMapKeys;
    this.w62_1 = prettyPrint;
    this.x62_1 = explicitNulls;
    this.y62_1 = prettyPrintIndent;
    this.z62_1 = coerceInputValues;
    this.a63_1 = useArrayPolymorphism;
    this.b63_1 = classDiscriminator;
    this.c63_1 = allowSpecialFloatingPointValues;
    this.d63_1 = useAlternativeNames;
    this.e63_1 = namingStrategy;
  }
  protoOf(JsonConfiguration).toString = function () {
    return 'JsonConfiguration(encodeDefaults=' + this.s62_1 + ', ignoreUnknownKeys=' + this.t62_1 + ', isLenient=' + this.u62_1 + ', ' + ('allowStructuredMapKeys=' + this.v62_1 + ', prettyPrint=' + this.w62_1 + ', explicitNulls=' + this.x62_1 + ', ') + ("prettyPrintIndent='" + this.y62_1 + "', coerceInputValues=" + this.z62_1 + ', useArrayPolymorphism=' + this.a63_1 + ', ') + ("classDiscriminator='" + this.b63_1 + "', allowSpecialFloatingPointValues=" + this.c63_1 + ', useAlternativeNames=' + this.d63_1 + ', ') + ('namingStrategy=' + toString_0(this.e63_1) + ')');
  };
  function JsonDecoder() {
  }
  function get_jsonUnquotedLiteralDescriptor() {
    _init_properties_JsonElement_kt__7cbdc2();
    return jsonUnquotedLiteralDescriptor;
  }
  var jsonUnquotedLiteralDescriptor;
  function Companion_82() {
  }
  var Companion_instance_82;
  function Companion_getInstance_82() {
    return Companion_instance_82;
  }
  function JsonPrimitive() {
    JsonElement.call(this);
  }
  protoOf(JsonPrimitive).toString = function () {
    return this.h63();
  };
  function get_jsonPrimitive(_this__u8e3s4) {
    _init_properties_JsonElement_kt__7cbdc2();
    var tmp0_elvis_lhs = _this__u8e3s4 instanceof JsonPrimitive ? _this__u8e3s4 : null;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      error_4(_this__u8e3s4, 'JsonPrimitive');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function Companion_83() {
  }
  protoOf(Companion_83).i63 = function () {
    return JsonElementSerializer_getInstance();
  };
  var Companion_instance_83;
  function Companion_getInstance_83() {
    return Companion_instance_83;
  }
  function JsonElement() {
  }
  function JsonPrimitive_0(value) {
    _init_properties_JsonElement_kt__7cbdc2();
    if (value == null)
      return JsonNull_getInstance();
    return new JsonLiteral(value, true);
  }
  function Companion_84() {
  }
  var Companion_instance_84;
  function Companion_getInstance_84() {
    return Companion_instance_84;
  }
  function JsonObject$toString$lambda(_name_for_destructuring_parameter_0__wldtmu) {
    // Inline function 'kotlin.collections.component1' call
    var k = _name_for_destructuring_parameter_0__wldtmu.z();
    // Inline function 'kotlin.collections.component2' call
    var v = _name_for_destructuring_parameter_0__wldtmu.a1();
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder_init_$Create$_1();
    printQuoted(this_0, k);
    this_0.k8(_Char___init__impl__6a9atx(58));
    this_0.i8(v);
    return this_0.toString();
  }
  function JsonObject_0(content) {
    JsonElement.call(this);
    this.j63_1 = content;
  }
  protoOf(JsonObject_0).y = function () {
    return this.j63_1.y();
  };
  protoOf(JsonObject_0).r2 = function () {
    return this.j63_1.r2();
  };
  protoOf(JsonObject_0).p = function () {
    return this.j63_1.p();
  };
  protoOf(JsonObject_0).s2 = function () {
    return this.j63_1.s2();
  };
  protoOf(JsonObject_0).k63 = function (key) {
    return this.j63_1.o2(key);
  };
  protoOf(JsonObject_0).o2 = function (key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return false;
    return this.k63((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  };
  protoOf(JsonObject_0).l63 = function (value) {
    return this.j63_1.p2(value);
  };
  protoOf(JsonObject_0).p2 = function (value) {
    if (!(value instanceof JsonElement))
      return false;
    return this.l63(value instanceof JsonElement ? value : THROW_CCE());
  };
  protoOf(JsonObject_0).ld = function (key) {
    return this.j63_1.q2(key);
  };
  protoOf(JsonObject_0).q2 = function (key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return null;
    return this.ld((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  };
  protoOf(JsonObject_0).s = function () {
    return this.j63_1.s();
  };
  protoOf(JsonObject_0).equals = function (other) {
    return equals(this.j63_1, other);
  };
  protoOf(JsonObject_0).hashCode = function () {
    return hashCode(this.j63_1);
  };
  protoOf(JsonObject_0).toString = function () {
    var tmp = this.j63_1.y();
    return joinToString_0(tmp, ',', '{', '}', VOID, VOID, JsonObject$toString$lambda);
  };
  function get_jsonObject(_this__u8e3s4) {
    _init_properties_JsonElement_kt__7cbdc2();
    var tmp0_elvis_lhs = _this__u8e3s4 instanceof JsonObject_0 ? _this__u8e3s4 : null;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      error_4(_this__u8e3s4, 'JsonObject');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function error_4(_this__u8e3s4, element) {
    _init_properties_JsonElement_kt__7cbdc2();
    throw IllegalArgumentException_init_$Create$_0('Element ' + toString_1(getKClassFromExpression(_this__u8e3s4)) + ' is not a ' + element);
  }
  function _get_$cachedSerializer__te6jhj($this) {
    return $this.n63_1.a1();
  }
  function JsonNull$_anonymous__enib48() {
    return JsonNullSerializer_getInstance();
  }
  function JsonNull_0() {
    JsonNull_instance = this;
    JsonPrimitive.call(this);
    this.m63_1 = 'null';
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.n63_1 = lazy_0(tmp_0, JsonNull$_anonymous__enib48);
  }
  protoOf(JsonNull_0).h63 = function () {
    return this.m63_1;
  };
  protoOf(JsonNull_0).i63 = function () {
    return _get_$cachedSerializer__te6jhj(this);
  };
  protoOf(JsonNull_0).q5k = function (typeParamsSerializers) {
    return this.i63();
  };
  var JsonNull_instance;
  function JsonNull_getInstance() {
    if (JsonNull_instance == null)
      new JsonNull_0();
    return JsonNull_instance;
  }
  function JsonLiteral(body, isString, coerceToInlineType) {
    coerceToInlineType = coerceToInlineType === VOID ? null : coerceToInlineType;
    JsonPrimitive.call(this);
    this.o63_1 = isString;
    this.p63_1 = coerceToInlineType;
    this.q63_1 = toString_1(body);
    if (!(this.p63_1 == null)) {
      // Inline function 'kotlin.require' call
      // Inline function 'kotlin.require' call
      if (!this.p63_1.q5a()) {
        var message = 'Failed requirement.';
        throw IllegalArgumentException_init_$Create$_0(toString_1(message));
      }
    }
  }
  protoOf(JsonLiteral).h63 = function () {
    return this.q63_1;
  };
  protoOf(JsonLiteral).toString = function () {
    var tmp;
    if (this.o63_1) {
      // Inline function 'kotlin.text.buildString' call
      // Inline function 'kotlin.apply' call
      var this_0 = StringBuilder_init_$Create$_1();
      printQuoted(this_0, this.q63_1);
      tmp = this_0.toString();
    } else {
      tmp = this.q63_1;
    }
    return tmp;
  };
  protoOf(JsonLiteral).equals = function (other) {
    if (this === other)
      return true;
    if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    if (!(other instanceof JsonLiteral))
      THROW_CCE();
    if (!(this.o63_1 === other.o63_1))
      return false;
    if (!(this.q63_1 === other.q63_1))
      return false;
    return true;
  };
  protoOf(JsonLiteral).hashCode = function () {
    var result = getBooleanHashCode(this.o63_1);
    result = imul(31, result) + getStringHashCode(this.q63_1) | 0;
    return result;
  };
  function Companion_85() {
  }
  var Companion_instance_85;
  function Companion_getInstance_85() {
    return Companion_instance_85;
  }
  function JsonArray_0(content) {
    JsonElement.call(this);
    this.r63_1 = content;
  }
  protoOf(JsonArray_0).p = function () {
    return this.r63_1.p();
  };
  protoOf(JsonArray_0).s63 = function (element) {
    return this.r63_1.t(element);
  };
  protoOf(JsonArray_0).t = function (element) {
    if (!(element instanceof JsonElement))
      return false;
    return this.s63(element instanceof JsonElement ? element : THROW_CCE());
  };
  protoOf(JsonArray_0).t63 = function (elements) {
    return this.r63_1.e2(elements);
  };
  protoOf(JsonArray_0).e2 = function (elements) {
    return this.t63(elements);
  };
  protoOf(JsonArray_0).r = function (index) {
    return this.r63_1.r(index);
  };
  protoOf(JsonArray_0).u63 = function (element) {
    return this.r63_1.w(element);
  };
  protoOf(JsonArray_0).w = function (element) {
    if (!(element instanceof JsonElement))
      return -1;
    return this.u63(element instanceof JsonElement ? element : THROW_CCE());
  };
  protoOf(JsonArray_0).s = function () {
    return this.r63_1.s();
  };
  protoOf(JsonArray_0).m = function () {
    return this.r63_1.m();
  };
  protoOf(JsonArray_0).v63 = function (element) {
    return this.r63_1.v(element);
  };
  protoOf(JsonArray_0).v = function (element) {
    if (!(element instanceof JsonElement))
      return -1;
    return this.v63(element instanceof JsonElement ? element : THROW_CCE());
  };
  protoOf(JsonArray_0).f2 = function () {
    return this.r63_1.f2();
  };
  protoOf(JsonArray_0).u = function (index) {
    return this.r63_1.u(index);
  };
  protoOf(JsonArray_0).g2 = function (fromIndex, toIndex) {
    return this.r63_1.g2(fromIndex, toIndex);
  };
  protoOf(JsonArray_0).equals = function (other) {
    return equals(this.r63_1, other);
  };
  protoOf(JsonArray_0).hashCode = function () {
    return hashCode(this.r63_1);
  };
  protoOf(JsonArray_0).toString = function () {
    return joinToString_0(this.r63_1, ',', '[', ']');
  };
  function get_longOrNull(_this__u8e3s4) {
    _init_properties_JsonElement_kt__7cbdc2();
    return toLongOrNull(_this__u8e3s4.h63());
  }
  function get_doubleOrNull(_this__u8e3s4) {
    _init_properties_JsonElement_kt__7cbdc2();
    return toDoubleOrNull(_this__u8e3s4.h63());
  }
  function get_booleanOrNull(_this__u8e3s4) {
    _init_properties_JsonElement_kt__7cbdc2();
    return toBooleanStrictOrNull(_this__u8e3s4.h63());
  }
  function get_int(_this__u8e3s4) {
    _init_properties_JsonElement_kt__7cbdc2();
    return toInt(_this__u8e3s4.h63());
  }
  function get_long(_this__u8e3s4) {
    _init_properties_JsonElement_kt__7cbdc2();
    return toLong(_this__u8e3s4.h63());
  }
  function get_float(_this__u8e3s4) {
    _init_properties_JsonElement_kt__7cbdc2();
    // Inline function 'kotlin.text.toFloat' call
    var this_0 = _this__u8e3s4.h63();
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return toDouble(this_0);
  }
  function get_double(_this__u8e3s4) {
    _init_properties_JsonElement_kt__7cbdc2();
    return toDouble(_this__u8e3s4.h63());
  }
  function get_contentOrNull(_this__u8e3s4) {
    _init_properties_JsonElement_kt__7cbdc2();
    var tmp;
    if (_this__u8e3s4 instanceof JsonNull_0) {
      tmp = null;
    } else {
      tmp = _this__u8e3s4.h63();
    }
    return tmp;
  }
  function JsonPrimitive_1(value) {
    _init_properties_JsonElement_kt__7cbdc2();
    if (value == null)
      return JsonNull_getInstance();
    return new JsonLiteral(value, false);
  }
  function JsonPrimitive_2(value) {
    _init_properties_JsonElement_kt__7cbdc2();
    if (value == null)
      return JsonNull_getInstance();
    return new JsonLiteral(value, false);
  }
  var properties_initialized_JsonElement_kt_abxy8s;
  function _init_properties_JsonElement_kt__7cbdc2() {
    if (!properties_initialized_JsonElement_kt_abxy8s) {
      properties_initialized_JsonElement_kt_abxy8s = true;
      jsonUnquotedLiteralDescriptor = InlinePrimitiveDescriptor('kotlinx.serialization.json.JsonUnquotedLiteral', serializer_5(StringCompanionObject_instance));
    }
  }
  function JsonObjectBuilder() {
    var tmp = this;
    // Inline function 'kotlin.collections.linkedMapOf' call
    tmp.w63_1 = LinkedHashMap_init_$Create$();
  }
  protoOf(JsonObjectBuilder).x63 = function (key, element) {
    return this.w63_1.t2(key, element);
  };
  protoOf(JsonObjectBuilder).r62 = function () {
    return new JsonObject_0(this.w63_1);
  };
  function put(_this__u8e3s4, key, value) {
    return _this__u8e3s4.x63(key, JsonPrimitive_0(value));
  }
  function JsonArrayBuilder() {
    var tmp = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp.y63_1 = ArrayList_init_$Create$();
  }
  protoOf(JsonArrayBuilder).z63 = function (element) {
    // Inline function 'kotlin.collections.plusAssign' call
    this.y63_1.j(element);
    return true;
  };
  protoOf(JsonArrayBuilder).r62 = function () {
    return new JsonArray_0(this.y63_1);
  };
  function JsonElementSerializer$descriptor$lambda($this$buildSerialDescriptor) {
    $this$buildSerialDescriptor.o59('JsonPrimitive', defer(JsonElementSerializer$descriptor$lambda$lambda));
    $this$buildSerialDescriptor.o59('JsonNull', defer(JsonElementSerializer$descriptor$lambda$lambda_0));
    $this$buildSerialDescriptor.o59('JsonLiteral', defer(JsonElementSerializer$descriptor$lambda$lambda_1));
    $this$buildSerialDescriptor.o59('JsonObject', defer(JsonElementSerializer$descriptor$lambda$lambda_2));
    $this$buildSerialDescriptor.o59('JsonArray', defer(JsonElementSerializer$descriptor$lambda$lambda_3));
    return Unit_instance;
  }
  function JsonElementSerializer$descriptor$lambda$lambda() {
    return JsonPrimitiveSerializer_getInstance().a64_1;
  }
  function JsonElementSerializer$descriptor$lambda$lambda_0() {
    return JsonNullSerializer_getInstance().b64_1;
  }
  function JsonElementSerializer$descriptor$lambda$lambda_1() {
    return JsonLiteralSerializer_getInstance().c64_1;
  }
  function JsonElementSerializer$descriptor$lambda$lambda_2() {
    return JsonObjectSerializer_getInstance().d64_1;
  }
  function JsonElementSerializer$descriptor$lambda$lambda_3() {
    return JsonArraySerializer_getInstance().e64_1;
  }
  function JsonElementSerializer() {
    JsonElementSerializer_instance = this;
    var tmp = this;
    var tmp_0 = SEALED_getInstance();
    tmp.f64_1 = buildSerialDescriptor('kotlinx.serialization.json.JsonElement', tmp_0, [], JsonElementSerializer$descriptor$lambda);
  }
  protoOf(JsonElementSerializer).v58 = function () {
    return this.f64_1;
  };
  protoOf(JsonElementSerializer).g64 = function (encoder, value) {
    verify(encoder);
    if (value instanceof JsonPrimitive) {
      encoder.h59(JsonPrimitiveSerializer_getInstance(), value);
    } else {
      if (value instanceof JsonObject_0) {
        encoder.h59(JsonObjectSerializer_getInstance(), value);
      } else {
        if (value instanceof JsonArray_0) {
          encoder.h59(JsonArraySerializer_getInstance(), value);
        }
      }
    }
  };
  protoOf(JsonElementSerializer).i59 = function (encoder, value) {
    return this.g64(encoder, value instanceof JsonElement ? value : THROW_CCE());
  };
  protoOf(JsonElementSerializer).j59 = function (decoder) {
    var input = asJsonDecoder(decoder);
    return input.g63();
  };
  var JsonElementSerializer_instance;
  function JsonElementSerializer_getInstance() {
    if (JsonElementSerializer_instance == null)
      new JsonElementSerializer();
    return JsonElementSerializer_instance;
  }
  function JsonPrimitiveSerializer() {
    JsonPrimitiveSerializer_instance = this;
    this.a64_1 = buildSerialDescriptor('kotlinx.serialization.json.JsonPrimitive', STRING_getInstance(), []);
  }
  protoOf(JsonPrimitiveSerializer).v58 = function () {
    return this.a64_1;
  };
  protoOf(JsonPrimitiveSerializer).h64 = function (encoder, value) {
    verify(encoder);
    var tmp;
    if (value instanceof JsonNull_0) {
      encoder.h59(JsonNullSerializer_getInstance(), JsonNull_getInstance());
      tmp = Unit_instance;
    } else {
      var tmp_0 = JsonLiteralSerializer_getInstance();
      encoder.h59(tmp_0, value instanceof JsonLiteral ? value : THROW_CCE());
      tmp = Unit_instance;
    }
    return tmp;
  };
  protoOf(JsonPrimitiveSerializer).i59 = function (encoder, value) {
    return this.h64(encoder, value instanceof JsonPrimitive ? value : THROW_CCE());
  };
  protoOf(JsonPrimitiveSerializer).j59 = function (decoder) {
    var result = asJsonDecoder(decoder).g63();
    if (!(result instanceof JsonPrimitive))
      throw JsonDecodingException_0(-1, 'Unexpected JSON element, expected JsonPrimitive, had ' + toString_1(getKClassFromExpression(result)), toString_1(result));
    return result;
  };
  var JsonPrimitiveSerializer_instance;
  function JsonPrimitiveSerializer_getInstance() {
    if (JsonPrimitiveSerializer_instance == null)
      new JsonPrimitiveSerializer();
    return JsonPrimitiveSerializer_instance;
  }
  function JsonObjectDescriptor() {
    JsonObjectDescriptor_instance = this;
    this.i64_1 = MapSerializer(serializer_5(StringCompanionObject_instance), JsonElementSerializer_getInstance()).v58();
    this.j64_1 = 'kotlinx.serialization.json.JsonObject';
  }
  protoOf(JsonObjectDescriptor).w58 = function () {
    return this.i64_1.w58();
  };
  protoOf(JsonObjectDescriptor).p5a = function () {
    return this.i64_1.p5a();
  };
  protoOf(JsonObjectDescriptor).q5a = function () {
    return this.i64_1.q5a();
  };
  protoOf(JsonObjectDescriptor).i5a = function () {
    return this.i64_1.i5a();
  };
  protoOf(JsonObjectDescriptor).r5a = function () {
    return this.i64_1.r5a();
  };
  protoOf(JsonObjectDescriptor).s5a = function (index) {
    return this.i64_1.s5a(index);
  };
  protoOf(JsonObjectDescriptor).t5a = function (index) {
    return this.i64_1.t5a(index);
  };
  protoOf(JsonObjectDescriptor).u5a = function (name) {
    return this.i64_1.u5a(name);
  };
  protoOf(JsonObjectDescriptor).v5a = function (index) {
    return this.i64_1.v5a(index);
  };
  protoOf(JsonObjectDescriptor).w5a = function (index) {
    return this.i64_1.w5a(index);
  };
  protoOf(JsonObjectDescriptor).z59 = function () {
    return this.j64_1;
  };
  var JsonObjectDescriptor_instance;
  function JsonObjectDescriptor_getInstance() {
    if (JsonObjectDescriptor_instance == null)
      new JsonObjectDescriptor();
    return JsonObjectDescriptor_instance;
  }
  function JsonObjectSerializer() {
    JsonObjectSerializer_instance = this;
    this.d64_1 = JsonObjectDescriptor_getInstance();
  }
  protoOf(JsonObjectSerializer).v58 = function () {
    return this.d64_1;
  };
  protoOf(JsonObjectSerializer).k64 = function (encoder, value) {
    verify(encoder);
    MapSerializer(serializer_5(StringCompanionObject_instance), JsonElementSerializer_getInstance()).i59(encoder, value);
  };
  protoOf(JsonObjectSerializer).i59 = function (encoder, value) {
    return this.k64(encoder, value instanceof JsonObject_0 ? value : THROW_CCE());
  };
  protoOf(JsonObjectSerializer).j59 = function (decoder) {
    verify_0(decoder);
    return new JsonObject_0(MapSerializer(serializer_5(StringCompanionObject_instance), JsonElementSerializer_getInstance()).j59(decoder));
  };
  var JsonObjectSerializer_instance;
  function JsonObjectSerializer_getInstance() {
    if (JsonObjectSerializer_instance == null)
      new JsonObjectSerializer();
    return JsonObjectSerializer_instance;
  }
  function JsonNullSerializer() {
    JsonNullSerializer_instance = this;
    this.b64_1 = buildSerialDescriptor('kotlinx.serialization.json.JsonNull', ENUM_getInstance(), []);
  }
  protoOf(JsonNullSerializer).v58 = function () {
    return this.b64_1;
  };
  protoOf(JsonNullSerializer).l64 = function (encoder, value) {
    verify(encoder);
    encoder.a5d();
  };
  protoOf(JsonNullSerializer).i59 = function (encoder, value) {
    return this.l64(encoder, value instanceof JsonNull_0 ? value : THROW_CCE());
  };
  protoOf(JsonNullSerializer).j59 = function (decoder) {
    verify_0(decoder);
    if (decoder.s5b()) {
      throw new JsonDecodingException("Expected 'null' literal");
    }
    decoder.t5b();
    return JsonNull_getInstance();
  };
  var JsonNullSerializer_instance;
  function JsonNullSerializer_getInstance() {
    if (JsonNullSerializer_instance == null)
      new JsonNullSerializer();
    return JsonNullSerializer_instance;
  }
  function defer(deferred) {
    return new defer$1(deferred);
  }
  function JsonLiteralSerializer() {
    JsonLiteralSerializer_instance = this;
    this.c64_1 = PrimitiveSerialDescriptor('kotlinx.serialization.json.JsonLiteral', STRING_getInstance());
  }
  protoOf(JsonLiteralSerializer).v58 = function () {
    return this.c64_1;
  };
  protoOf(JsonLiteralSerializer).m64 = function (encoder, value) {
    verify(encoder);
    if (value.o63_1) {
      return encoder.j5d(value.q63_1);
    }
    if (!(value.p63_1 == null)) {
      return encoder.l5d(value.p63_1).j5d(value.q63_1);
    }
    var tmp0_safe_receiver = get_longOrNull(value);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      return encoder.f5d(tmp0_safe_receiver);
    }
    var tmp1_safe_receiver = toULongOrNull(value.q63_1);
    var tmp = tmp1_safe_receiver;
    if ((tmp == null ? null : new ULong(tmp)) == null)
      null;
    else {
      var tmp_0 = tmp1_safe_receiver;
      // Inline function 'kotlin.let' call
      var it = (tmp_0 == null ? null : new ULong(tmp_0)).r1_1;
      var tmp_1 = encoder.l5d(serializer_6(Companion_getInstance_20()).v58());
      // Inline function 'kotlin.ULong.toLong' call
      var tmp$ret$1 = _ULong___get_data__impl__fggpzb(it);
      tmp_1.f5d(tmp$ret$1);
      return Unit_instance;
    }
    var tmp2_safe_receiver = get_doubleOrNull(value);
    if (tmp2_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      return encoder.h5d(tmp2_safe_receiver);
    }
    var tmp3_safe_receiver = get_booleanOrNull(value);
    if (tmp3_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      return encoder.b5d(tmp3_safe_receiver);
    }
    encoder.j5d(value.q63_1);
  };
  protoOf(JsonLiteralSerializer).i59 = function (encoder, value) {
    return this.m64(encoder, value instanceof JsonLiteral ? value : THROW_CCE());
  };
  protoOf(JsonLiteralSerializer).j59 = function (decoder) {
    var result = asJsonDecoder(decoder).g63();
    if (!(result instanceof JsonLiteral))
      throw JsonDecodingException_0(-1, 'Unexpected JSON element, expected JsonLiteral, had ' + toString_1(getKClassFromExpression(result)), toString_1(result));
    return result;
  };
  var JsonLiteralSerializer_instance;
  function JsonLiteralSerializer_getInstance() {
    if (JsonLiteralSerializer_instance == null)
      new JsonLiteralSerializer();
    return JsonLiteralSerializer_instance;
  }
  function JsonArrayDescriptor() {
    JsonArrayDescriptor_instance = this;
    this.n64_1 = ListSerializer(JsonElementSerializer_getInstance()).v58();
    this.o64_1 = 'kotlinx.serialization.json.JsonArray';
  }
  protoOf(JsonArrayDescriptor).w58 = function () {
    return this.n64_1.w58();
  };
  protoOf(JsonArrayDescriptor).p5a = function () {
    return this.n64_1.p5a();
  };
  protoOf(JsonArrayDescriptor).q5a = function () {
    return this.n64_1.q5a();
  };
  protoOf(JsonArrayDescriptor).i5a = function () {
    return this.n64_1.i5a();
  };
  protoOf(JsonArrayDescriptor).r5a = function () {
    return this.n64_1.r5a();
  };
  protoOf(JsonArrayDescriptor).s5a = function (index) {
    return this.n64_1.s5a(index);
  };
  protoOf(JsonArrayDescriptor).t5a = function (index) {
    return this.n64_1.t5a(index);
  };
  protoOf(JsonArrayDescriptor).u5a = function (name) {
    return this.n64_1.u5a(name);
  };
  protoOf(JsonArrayDescriptor).v5a = function (index) {
    return this.n64_1.v5a(index);
  };
  protoOf(JsonArrayDescriptor).w5a = function (index) {
    return this.n64_1.w5a(index);
  };
  protoOf(JsonArrayDescriptor).z59 = function () {
    return this.o64_1;
  };
  var JsonArrayDescriptor_instance;
  function JsonArrayDescriptor_getInstance() {
    if (JsonArrayDescriptor_instance == null)
      new JsonArrayDescriptor();
    return JsonArrayDescriptor_instance;
  }
  function JsonArraySerializer() {
    JsonArraySerializer_instance = this;
    this.e64_1 = JsonArrayDescriptor_getInstance();
  }
  protoOf(JsonArraySerializer).v58 = function () {
    return this.e64_1;
  };
  protoOf(JsonArraySerializer).p64 = function (encoder, value) {
    verify(encoder);
    ListSerializer(JsonElementSerializer_getInstance()).i59(encoder, value);
  };
  protoOf(JsonArraySerializer).i59 = function (encoder, value) {
    return this.p64(encoder, value instanceof JsonArray_0 ? value : THROW_CCE());
  };
  protoOf(JsonArraySerializer).j59 = function (decoder) {
    verify_0(decoder);
    return new JsonArray_0(ListSerializer(JsonElementSerializer_getInstance()).j59(decoder));
  };
  var JsonArraySerializer_instance;
  function JsonArraySerializer_getInstance() {
    if (JsonArraySerializer_instance == null)
      new JsonArraySerializer();
    return JsonArraySerializer_instance;
  }
  function verify(encoder) {
    asJsonEncoder(encoder);
  }
  function asJsonDecoder(_this__u8e3s4) {
    var tmp0_elvis_lhs = isInterface(_this__u8e3s4, JsonDecoder) ? _this__u8e3s4 : null;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalStateException_init_$Create$_0('This serializer can be used only with Json format.' + ('Expected Decoder to be JsonDecoder, got ' + toString_1(getKClassFromExpression(_this__u8e3s4))));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function verify_0(decoder) {
    asJsonDecoder(decoder);
  }
  function asJsonEncoder(_this__u8e3s4) {
    var tmp0_elvis_lhs = isInterface(_this__u8e3s4, JsonEncoder) ? _this__u8e3s4 : null;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalStateException_init_$Create$_0('This serializer can be used only with Json format.' + ('Expected Encoder to be JsonEncoder, got ' + toString_1(getKClassFromExpression(_this__u8e3s4))));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function _get_original__l7ku1m($this) {
    var tmp0 = $this.q64_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('original', 1, tmp, defer$o$_get_original_$ref_3cje7k(), null);
    return tmp0.a1();
  }
  function defer$o$_get_original_$ref_3cje7k() {
    return function (p0) {
      return _get_original__l7ku1m(p0);
    };
  }
  function defer$1($deferred) {
    this.q64_1 = lazy($deferred);
  }
  protoOf(defer$1).z59 = function () {
    return _get_original__l7ku1m(this).z59();
  };
  protoOf(defer$1).r5a = function () {
    return _get_original__l7ku1m(this).r5a();
  };
  protoOf(defer$1).p5a = function () {
    return _get_original__l7ku1m(this).p5a();
  };
  protoOf(defer$1).v5a = function (index) {
    return _get_original__l7ku1m(this).v5a(index);
  };
  protoOf(defer$1).u5a = function (name) {
    return _get_original__l7ku1m(this).u5a(name);
  };
  protoOf(defer$1).s5a = function (index) {
    return _get_original__l7ku1m(this).s5a(index);
  };
  protoOf(defer$1).t5a = function (index) {
    return _get_original__l7ku1m(this).t5a(index);
  };
  protoOf(defer$1).w5a = function (index) {
    return _get_original__l7ku1m(this).w5a(index);
  };
  function JsonEncoder() {
  }
  function Composer(writer) {
    this.r64_1 = writer;
    this.s64_1 = true;
  }
  protoOf(Composer).g2h = function () {
    this.s64_1 = true;
  };
  protoOf(Composer).t64 = function () {
    return Unit_instance;
  };
  protoOf(Composer).u64 = function () {
    this.s64_1 = false;
  };
  protoOf(Composer).v64 = function () {
    return Unit_instance;
  };
  protoOf(Composer).w64 = function (v) {
    return this.r64_1.x64(v);
  };
  protoOf(Composer).y64 = function (v) {
    return this.r64_1.z64(v);
  };
  protoOf(Composer).a65 = function (v) {
    return this.r64_1.z64(v.toString());
  };
  protoOf(Composer).b65 = function (v) {
    return this.r64_1.z64(v.toString());
  };
  protoOf(Composer).c65 = function (v) {
    return this.r64_1.d65(fromInt_0(v));
  };
  protoOf(Composer).e65 = function (v) {
    return this.r64_1.d65(fromInt_0(v));
  };
  protoOf(Composer).f65 = function (v) {
    return this.r64_1.d65(fromInt_0(v));
  };
  protoOf(Composer).g65 = function (v) {
    return this.r64_1.d65(v);
  };
  protoOf(Composer).h65 = function (v) {
    return this.r64_1.z64(v.toString());
  };
  protoOf(Composer).i65 = function (value) {
    return this.r64_1.j65(value);
  };
  function Composer_0(sb, json) {
    return json.k61_1.w62_1 ? new ComposerWithPrettyPrint(sb, json) : new Composer(sb);
  }
  function ComposerForUnsignedNumbers(writer, forceQuoting) {
    Composer.call(this, writer);
    this.m65_1 = forceQuoting;
  }
  protoOf(ComposerForUnsignedNumbers).f65 = function (v) {
    if (this.m65_1) {
      // Inline function 'kotlin.toUInt' call
      var tmp$ret$0 = _UInt___init__impl__l7qpdl(v);
      this.i65(UInt__toString_impl_dbgl21(tmp$ret$0));
    } else {
      // Inline function 'kotlin.toUInt' call
      var tmp$ret$1 = _UInt___init__impl__l7qpdl(v);
      this.y64(UInt__toString_impl_dbgl21(tmp$ret$1));
    }
  };
  protoOf(ComposerForUnsignedNumbers).g65 = function (v) {
    if (this.m65_1) {
      // Inline function 'kotlin.toULong' call
      var tmp$ret$0 = _ULong___init__impl__c78o9k(v);
      this.i65(ULong__toString_impl_f9au7k(tmp$ret$0));
    } else {
      // Inline function 'kotlin.toULong' call
      var tmp$ret$1 = _ULong___init__impl__c78o9k(v);
      this.y64(ULong__toString_impl_f9au7k(tmp$ret$1));
    }
  };
  protoOf(ComposerForUnsignedNumbers).c65 = function (v) {
    if (this.m65_1) {
      // Inline function 'kotlin.toUByte' call
      var tmp$ret$0 = _UByte___init__impl__g9hnc4(v);
      this.i65(UByte__toString_impl_v72jg(tmp$ret$0));
    } else {
      // Inline function 'kotlin.toUByte' call
      var tmp$ret$1 = _UByte___init__impl__g9hnc4(v);
      this.y64(UByte__toString_impl_v72jg(tmp$ret$1));
    }
  };
  protoOf(ComposerForUnsignedNumbers).e65 = function (v) {
    if (this.m65_1) {
      // Inline function 'kotlin.toUShort' call
      var tmp$ret$0 = _UShort___init__impl__jigrne(v);
      this.i65(UShort__toString_impl_edaoee(tmp$ret$0));
    } else {
      // Inline function 'kotlin.toUShort' call
      var tmp$ret$1 = _UShort___init__impl__jigrne(v);
      this.y64(UShort__toString_impl_edaoee(tmp$ret$1));
    }
  };
  function ComposerForUnquotedLiterals(writer, forceQuoting) {
    Composer.call(this, writer);
    this.p65_1 = forceQuoting;
  }
  protoOf(ComposerForUnquotedLiterals).i65 = function (value) {
    if (this.p65_1) {
      protoOf(Composer).i65.call(this, value);
    } else {
      protoOf(Composer).y64.call(this, value);
    }
  };
  function ComposerWithPrettyPrint(writer, json) {
    Composer.call(this, writer);
    this.s65_1 = json;
    this.t65_1 = 0;
  }
  protoOf(ComposerWithPrettyPrint).g2h = function () {
    this.s64_1 = true;
    this.t65_1 = this.t65_1 + 1 | 0;
  };
  protoOf(ComposerWithPrettyPrint).t64 = function () {
    this.t65_1 = this.t65_1 - 1 | 0;
  };
  protoOf(ComposerWithPrettyPrint).u64 = function () {
    this.s64_1 = false;
    this.y64('\n');
    // Inline function 'kotlin.repeat' call
    var times = this.t65_1;
    var inductionVariable = 0;
    if (inductionVariable < times)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.y64(this.s65_1.k61_1.y62_1);
      }
       while (inductionVariable < times);
  };
  protoOf(ComposerWithPrettyPrint).v64 = function () {
    this.w64(_Char___init__impl__6a9atx(32));
  };
  function readIfAbsent($this, descriptor, index) {
    $this.v65_1 = (!descriptor.w5a(index) && descriptor.t5a(index).i5a());
    return $this.v65_1;
  }
  function JsonElementMarker$readIfAbsent$ref(p0) {
    var l = function (_this__u8e3s4, p0_0) {
      var tmp0 = p0;
      return readIfAbsent(tmp0, _this__u8e3s4, p0_0);
    };
    l.callableName = 'readIfAbsent';
    return l;
  }
  function JsonElementMarker(descriptor) {
    var tmp = this;
    tmp.u65_1 = new ElementMarker(descriptor, JsonElementMarker$readIfAbsent$ref(this));
    this.v65_1 = false;
  }
  protoOf(JsonElementMarker).w65 = function (index) {
    this.u65_1.i5i(index);
  };
  protoOf(JsonElementMarker).x65 = function () {
    return this.u65_1.j5i();
  };
  function JsonDecodingException(message) {
    JsonException_0.call(this, message);
    captureStack(this, JsonDecodingException);
  }
  function JsonDecodingException_0(offset, message, input) {
    return JsonDecodingException_1(offset, message + '\nJSON input: ' + toString_1(minify(input, offset)));
  }
  function JsonException_0(message) {
    SerializationException_init_$Init$_0(message, this);
    captureStack(this, JsonException_0);
  }
  function JsonDecodingException_1(offset, message) {
    return new JsonDecodingException(offset >= 0 ? 'Unexpected JSON token at offset ' + offset + ': ' + message : message);
  }
  function minify(_this__u8e3s4, offset) {
    offset = offset === VOID ? -1 : offset;
    if (charSequenceLength(_this__u8e3s4) < 200)
      return _this__u8e3s4;
    if (offset === -1) {
      var start = charSequenceLength(_this__u8e3s4) - 60 | 0;
      if (start <= 0)
        return _this__u8e3s4;
      // Inline function 'kotlin.text.substring' call
      var endIndex = charSequenceLength(_this__u8e3s4);
      return '.....' + toString_1(charSequenceSubSequence(_this__u8e3s4, start, endIndex));
    }
    var start_0 = offset - 30 | 0;
    var end = offset + 30 | 0;
    var prefix = start_0 <= 0 ? '' : '.....';
    var suffix = end >= charSequenceLength(_this__u8e3s4) ? '' : '.....';
    var tmp2 = coerceAtLeast(start_0, 0);
    // Inline function 'kotlin.text.substring' call
    var endIndex_0 = coerceAtMost(end, charSequenceLength(_this__u8e3s4));
    return prefix + toString_1(charSequenceSubSequence(_this__u8e3s4, tmp2, endIndex_0)) + suffix;
  }
  function throwInvalidFloatingPointDecoded(_this__u8e3s4, result) {
    _this__u8e3s4.y65('Unexpected special floating-point value ' + toString_1(result) + '. By default, ' + 'non-finite floating point values are prohibited because they do not conform JSON specification', VOID, "It is possible to deserialize them using 'JsonBuilder.allowSpecialFloatingPointValues = true'");
  }
  function JsonEncodingException(message) {
    JsonException_0.call(this, message);
    captureStack(this, JsonEncodingException);
  }
  function InvalidFloatingPointEncoded(value, output) {
    return new JsonEncodingException('Unexpected special floating-point value ' + toString_1(value) + '. By default, ' + 'non-finite floating point values are prohibited because they do not conform JSON specification. ' + "It is possible to deserialize them using 'JsonBuilder.allowSpecialFloatingPointValues = true'\n" + ('Current output: ' + toString_1(minify(output))));
  }
  function InvalidFloatingPointDecoded(value, key, output) {
    return JsonDecodingException_1(-1, unexpectedFpErrorMessage(value, key, output));
  }
  function UnknownKeyException(key, input) {
    return JsonDecodingException_1(-1, "Encountered an unknown key '" + key + "'.\n" + "Use 'ignoreUnknownKeys = true' in 'Json {}' builder to ignore unknown keys.\n" + ('Current input: ' + toString_1(minify(input))));
  }
  function InvalidFloatingPointEncoded_0(value, key, output) {
    return new JsonEncodingException(unexpectedFpErrorMessage(value, key, output));
  }
  function InvalidKeyKindException(keyDescriptor) {
    return new JsonEncodingException("Value of type '" + keyDescriptor.z59() + "' can't be used in JSON as a key in the map. " + ("It should have either primitive or enum kind, but its kind is '" + keyDescriptor.r5a().toString() + "'.\n") + "Use 'allowStructuredMapKeys = true' in 'Json {}' builder to convert such maps to [key1, value1, key2, value2,...] arrays.");
  }
  function unexpectedFpErrorMessage(value, key, output) {
    return 'Unexpected special floating-point value ' + toString_1(value) + ' with key ' + key + '. By default, ' + 'non-finite floating point values are prohibited because they do not conform JSON specification. ' + "It is possible to deserialize them using 'JsonBuilder.allowSpecialFloatingPointValues = true'\n" + ('Current output: ' + toString_1(minify(output)));
  }
  function get_JsonDeserializationNamesKey() {
    _init_properties_JsonNamesMap_kt__cbbp0k();
    return JsonDeserializationNamesKey;
  }
  var JsonDeserializationNamesKey;
  function get_JsonSerializationNamesKey() {
    _init_properties_JsonNamesMap_kt__cbbp0k();
    return JsonSerializationNamesKey;
  }
  var JsonSerializationNamesKey;
  function getJsonNameIndex(_this__u8e3s4, json, name) {
    _init_properties_JsonNamesMap_kt__cbbp0k();
    var strategy = namingStrategy(_this__u8e3s4, json);
    if (!(strategy == null))
      return getJsonNameIndex$getJsonNameIndexSlowPath(json, _this__u8e3s4, name);
    var index = _this__u8e3s4.u5a(name);
    if (!(index === -3))
      return index;
    if (!json.k61_1.d63_1)
      return index;
    return getJsonNameIndex$getJsonNameIndexSlowPath(json, _this__u8e3s4, name);
  }
  function getJsonNameIndexOrThrow(_this__u8e3s4, json, name, suffix) {
    suffix = suffix === VOID ? '' : suffix;
    _init_properties_JsonNamesMap_kt__cbbp0k();
    var index = getJsonNameIndex(_this__u8e3s4, json, name);
    if (index === -3)
      throw SerializationException_init_$Create$_0(_this__u8e3s4.z59() + " does not contain element with name '" + name + "'" + suffix);
    return index;
  }
  function getJsonElementName(_this__u8e3s4, json, index) {
    _init_properties_JsonNamesMap_kt__cbbp0k();
    var strategy = namingStrategy(_this__u8e3s4, json);
    return strategy == null ? _this__u8e3s4.v5a(index) : serializationNamesIndices(_this__u8e3s4, json, strategy)[index];
  }
  function namingStrategy(_this__u8e3s4, json) {
    _init_properties_JsonNamesMap_kt__cbbp0k();
    return equals(_this__u8e3s4.r5a(), CLASS_getInstance()) ? json.k61_1.e63_1 : null;
  }
  function deserializationNamesMap(_this__u8e3s4, descriptor) {
    _init_properties_JsonNamesMap_kt__cbbp0k();
    var tmp = get_schemaCache(_this__u8e3s4);
    var tmp_0 = get_JsonDeserializationNamesKey();
    return tmp.a66(descriptor, tmp_0, deserializationNamesMap$lambda(descriptor, _this__u8e3s4));
  }
  function serializationNamesIndices(_this__u8e3s4, json, strategy) {
    _init_properties_JsonNamesMap_kt__cbbp0k();
    var tmp = get_schemaCache(json);
    var tmp_0 = get_JsonSerializationNamesKey();
    return tmp.a66(_this__u8e3s4, tmp_0, serializationNamesIndices$lambda(_this__u8e3s4, strategy));
  }
  function buildDeserializationNamesMap(_this__u8e3s4, json) {
    _init_properties_JsonNamesMap_kt__cbbp0k();
    // Inline function 'kotlin.collections.mutableMapOf' call
    var builder = LinkedHashMap_init_$Create$();
    var strategy = namingStrategy(_this__u8e3s4, json);
    var inductionVariable = 0;
    var last = _this__u8e3s4.p5a();
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlin.collections.filterIsInstance' call
        var tmp0 = _this__u8e3s4.s5a(i);
        // Inline function 'kotlin.collections.filterIsInstanceTo' call
        var destination = ArrayList_init_$Create$();
        var _iterator__ex2g4s = tmp0.m();
        while (_iterator__ex2g4s.n()) {
          var element = _iterator__ex2g4s.o();
          if (element instanceof JsonNames) {
            destination.j(element);
          }
        }
        var tmp1_safe_receiver = singleOrNull(destination);
        var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.b66_1;
        if (tmp2_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.collections.forEach' call
          var inductionVariable_0 = 0;
          var last_0 = tmp2_safe_receiver.length;
          while (inductionVariable_0 < last_0) {
            var element_0 = tmp2_safe_receiver[inductionVariable_0];
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            buildDeserializationNamesMap$putOrThrow(builder, _this__u8e3s4, element_0, i);
          }
        }
        if (strategy == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          buildDeserializationNamesMap$putOrThrow(builder, _this__u8e3s4, strategy.c66(_this__u8e3s4, i, _this__u8e3s4.v5a(i)), i);
        }
      }
       while (inductionVariable < last);
    // Inline function 'kotlin.collections.ifEmpty' call
    var tmp;
    if (builder.s()) {
      tmp = emptyMap();
    } else {
      tmp = builder;
    }
    return tmp;
  }
  function getJsonNameIndex$getJsonNameIndexSlowPath($json, $this_getJsonNameIndex, $name) {
    var tmp0_elvis_lhs = deserializationNamesMap($json, $this_getJsonNameIndex).q2($name);
    return tmp0_elvis_lhs == null ? -3 : tmp0_elvis_lhs;
  }
  function buildDeserializationNamesMap$putOrThrow(_this__u8e3s4, $this_buildDeserializationNamesMap, name, index) {
    // Inline function 'kotlin.collections.contains' call
    // Inline function 'kotlin.collections.containsKey' call
    if ((isInterface(_this__u8e3s4, KtMap) ? _this__u8e3s4 : THROW_CCE()).o2(name)) {
      throw new JsonException_0("The suggested name '" + name + "' for property " + $this_buildDeserializationNamesMap.v5a(index) + ' is already one of the names for property ' + ($this_buildDeserializationNamesMap.v5a(getValue_0(_this__u8e3s4, name)) + ' in ' + toString_1($this_buildDeserializationNamesMap)));
    }
    // Inline function 'kotlin.collections.set' call
    _this__u8e3s4.t2(name, index);
  }
  function deserializationNamesMap$lambda($descriptor, $this_deserializationNamesMap) {
    return function () {
      return buildDeserializationNamesMap($descriptor, $this_deserializationNamesMap);
    };
  }
  function serializationNamesIndices$lambda($this_serializationNamesIndices, $strategy) {
    return function () {
      var tmp = 0;
      var tmp_0 = $this_serializationNamesIndices.p5a();
      // Inline function 'kotlin.arrayOfNulls' call
      var tmp_1 = Array(tmp_0);
      while (tmp < tmp_0) {
        var tmp_2 = tmp;
        var baseName = $this_serializationNamesIndices.v5a(tmp_2);
        tmp_1[tmp_2] = $strategy.c66($this_serializationNamesIndices, tmp_2, baseName);
        tmp = tmp + 1 | 0;
      }
      return tmp_1;
    };
  }
  var properties_initialized_JsonNamesMap_kt_ljpf42;
  function _init_properties_JsonNamesMap_kt__cbbp0k() {
    if (!properties_initialized_JsonNamesMap_kt_ljpf42) {
      properties_initialized_JsonNamesMap_kt_ljpf42 = true;
      JsonDeserializationNamesKey = new Key_6();
      JsonSerializationNamesKey = new Key_6();
    }
  }
  function Tombstone() {
  }
  var Tombstone_instance;
  function Tombstone_getInstance() {
    return Tombstone_instance;
  }
  function resize($this) {
    var newSize = imul($this.f66_1, 2);
    $this.d66_1 = copyOf_1($this.d66_1, newSize);
    $this.e66_1 = copyOf($this.e66_1, newSize);
  }
  function JsonPath() {
    var tmp = this;
    // Inline function 'kotlin.arrayOfNulls' call
    tmp.d66_1 = Array(8);
    var tmp_0 = this;
    var tmp_1 = 0;
    var tmp_2 = new Int32Array(8);
    while (tmp_1 < 8) {
      tmp_2[tmp_1] = -1;
      tmp_1 = tmp_1 + 1 | 0;
    }
    tmp_0.e66_1 = tmp_2;
    this.f66_1 = -1;
  }
  protoOf(JsonPath).g66 = function (sd) {
    this.f66_1 = this.f66_1 + 1 | 0;
    var depth = this.f66_1;
    if (depth === this.d66_1.length) {
      resize(this);
    }
    this.d66_1[depth] = sd;
  };
  protoOf(JsonPath).h66 = function (index) {
    this.e66_1[this.f66_1] = index;
  };
  protoOf(JsonPath).i66 = function (key) {
    var tmp;
    if (!(this.e66_1[this.f66_1] === -2)) {
      this.f66_1 = this.f66_1 + 1 | 0;
      tmp = this.f66_1 === this.d66_1.length;
    } else {
      tmp = false;
    }
    if (tmp) {
      resize(this);
    }
    this.d66_1[this.f66_1] = key;
    this.e66_1[this.f66_1] = -2;
  };
  protoOf(JsonPath).j66 = function () {
    if (this.e66_1[this.f66_1] === -2) {
      this.d66_1[this.f66_1] = Tombstone_instance;
    }
  };
  protoOf(JsonPath).k66 = function () {
    var depth = this.f66_1;
    if (this.e66_1[depth] === -2) {
      this.e66_1[depth] = -1;
      this.f66_1 = this.f66_1 - 1 | 0;
    }
    if (!(this.f66_1 === -1)) {
      this.f66_1 = this.f66_1 - 1 | 0;
    }
  };
  protoOf(JsonPath).l66 = function () {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder_init_$Create$_1();
    this_0.j8('$');
    // Inline function 'kotlin.repeat' call
    var times = this.f66_1 + 1 | 0;
    var inductionVariable = 0;
    if (inductionVariable < times)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var element = this.d66_1[index];
        if (!(element == null) ? isInterface(element, SerialDescriptor) : false) {
          if (equals(element.r5a(), LIST_getInstance())) {
            if (!(this.e66_1[index] === -1)) {
              this_0.j8('[');
              this_0.i8(this.e66_1[index]);
              this_0.j8(']');
            }
          } else {
            var idx = this.e66_1[index];
            if (idx >= 0) {
              this_0.j8('.');
              this_0.j8(element.v5a(idx));
            }
          }
        } else {
          if (!(element === Tombstone_instance)) {
            this_0.j8('[');
            this_0.j8("'");
            this_0.i8(element);
            this_0.j8("'");
            this_0.j8(']');
          }
        }
      }
       while (inductionVariable < times);
    return this_0.toString();
  };
  protoOf(JsonPath).toString = function () {
    return this.l66();
  };
  function encodeByWriter(_this__u8e3s4, writer, serializer, value) {
    var tmp = WriteMode_OBJ_getInstance();
    // Inline function 'kotlin.arrayOfNulls' call
    var size = values_3().length;
    var tmp$ret$0 = Array(size);
    var encoder = StreamingJsonEncoder_init_$Create$(writer, _this__u8e3s4, tmp, tmp$ret$0);
    encoder.h59(serializer, value);
  }
  function readObject($this) {
    // Inline function 'kotlinx.serialization.json.internal.JsonTreeReader.readObjectImpl' call
    var lastToken = $this.u66_1.x66(6);
    if ($this.u66_1.y66() === 4) {
      $this.u66_1.y65('Unexpected leading comma');
    }
    // Inline function 'kotlin.collections.linkedMapOf' call
    var result = LinkedHashMap_init_$Create$();
    $l$loop: while ($this.u66_1.z66()) {
      var key = $this.v66_1 ? $this.u66_1.b67() : $this.u66_1.a67();
      $this.u66_1.x66(5);
      var element = $this.c67();
      // Inline function 'kotlin.collections.set' call
      result.t2(key, element);
      lastToken = $this.u66_1.d67();
      var tmp0_subject = lastToken;
      if (tmp0_subject !== 4)
        if (tmp0_subject === 7)
          break $l$loop;
        else {
          $this.u66_1.y65('Expected end of the object or comma');
        }
    }
    if (lastToken === 6) {
      $this.u66_1.x66(7);
    } else if (lastToken === 4) {
      $this.u66_1.y65('Unexpected trailing comma');
    }
    return new JsonObject_0(result);
  }
  function readObject_0($this, _this__u8e3s4, $completion) {
    var tmp = new $readObjectCOROUTINE$($this, _this__u8e3s4, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  }
  function readArray($this) {
    var lastToken = $this.u66_1.d67();
    if ($this.u66_1.y66() === 4) {
      $this.u66_1.y65('Unexpected leading comma');
    }
    // Inline function 'kotlin.collections.arrayListOf' call
    var result = ArrayList_init_$Create$();
    while ($this.u66_1.z66()) {
      var element = $this.c67();
      result.j(element);
      lastToken = $this.u66_1.d67();
      if (!(lastToken === 4)) {
        var tmp0 = $this.u66_1;
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.require' call
        var condition = lastToken === 9;
        var position = tmp0.y61_1;
        if (!condition) {
          var tmp$ret$1 = 'Expected end of the array or comma';
          tmp0.y65(tmp$ret$1, position);
        }
      }
    }
    if (lastToken === 8) {
      $this.u66_1.x66(9);
    } else if (lastToken === 4) {
      $this.u66_1.y65('Unexpected trailing comma');
    }
    return new JsonArray_0(result);
  }
  function readValue($this, isString) {
    var tmp;
    if ($this.v66_1 || !isString) {
      tmp = $this.u66_1.b67();
    } else {
      tmp = $this.u66_1.a67();
    }
    var string = tmp;
    if (!isString && string === 'null')
      return JsonNull_getInstance();
    return new JsonLiteral(string, isString);
  }
  function readDeepRecursive($this) {
    return invoke_4(new DeepRecursiveFunction(JsonTreeReader$readDeepRecursive$slambda_0($this, null)), Unit_instance);
  }
  function JsonTreeReader$readDeepRecursive$slambda(this$0, resultContinuation) {
    this.a68_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(JsonTreeReader$readDeepRecursive$slambda).e68 = function ($this$$receiver, it, $completion) {
    var tmp = this.f68($this$$receiver, it, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(JsonTreeReader$readDeepRecursive$slambda).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof DeepRecursiveScope ? p1 : THROW_CCE();
    return this.e68(tmp, p2 instanceof Unit ? p2 : THROW_CCE(), $completion);
  };
  protoOf(JsonTreeReader$readDeepRecursive$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 3;
            var tmp0_subject = this.a68_1.u66_1.y66();
            if (tmp0_subject === 1) {
              this.d68_1 = readValue(this.a68_1, true);
              this.f9_1 = 2;
              continue $sm;
            } else {
              if (tmp0_subject === 0) {
                this.d68_1 = readValue(this.a68_1, false);
                this.f9_1 = 2;
                continue $sm;
              } else {
                if (tmp0_subject === 6) {
                  this.f9_1 = 1;
                  suspendResult = readObject_0(this.a68_1, this.b68_1, this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  continue $sm;
                } else {
                  if (tmp0_subject === 8) {
                    this.d68_1 = readArray(this.a68_1);
                    this.f9_1 = 2;
                    continue $sm;
                  } else {
                    var tmp_0 = this;
                    this.a68_1.u66_1.y65("Can't begin reading element, unexpected token");
                  }
                }
              }
            }

            break;
          case 1:
            this.d68_1 = suspendResult;
            this.f9_1 = 2;
            continue $sm;
          case 2:
            return this.d68_1;
          case 3:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 3) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(JsonTreeReader$readDeepRecursive$slambda).f68 = function ($this$$receiver, it, completion) {
    var i = new JsonTreeReader$readDeepRecursive$slambda(this.a68_1, completion);
    i.b68_1 = $this$$receiver;
    i.c68_1 = it;
    return i;
  };
  function JsonTreeReader$readDeepRecursive$slambda_0(this$0, resultContinuation) {
    var i = new JsonTreeReader$readDeepRecursive$slambda(this$0, resultContinuation);
    var l = function ($this$$receiver, it, $completion) {
      return i.e68($this$$receiver, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function $readObjectCOROUTINE$(_this__u8e3s4, _this__u8e3s4_0, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.m67_1 = _this__u8e3s4;
    this.n67_1 = _this__u8e3s4_0;
  }
  protoOf($readObjectCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 5;
            this.p67_1 = this.m67_1;
            this.q67_1 = this.p67_1.u66_1.x66(6);
            if (this.p67_1.u66_1.y66() === 4) {
              this.p67_1.u66_1.y65('Unexpected leading comma');
            }

            var tmp_0 = this;
            tmp_0.o67_1 = LinkedHashMap_init_$Create$();
            this.f9_1 = 1;
            continue $sm;
          case 1:
            if (!this.p67_1.u66_1.z66()) {
              this.f9_1 = 4;
              continue $sm;
            }

            this.r67_1 = this.p67_1.v66_1 ? this.p67_1.u66_1.b67() : this.p67_1.u66_1.a67();
            this.p67_1.u66_1.x66(5);
            this.f9_1 = 2;
            suspendResult = this.n67_1.jl(Unit_instance, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var element = suspendResult;
            var tmp0 = this.o67_1;
            var key = this.r67_1;
            tmp0.t2(key, element);
            this.q67_1 = this.p67_1.u66_1.d67();
            var tmp0_subject = this.q67_1;
            if (tmp0_subject === 4) {
              this.f9_1 = 3;
              continue $sm;
            } else {
              if (tmp0_subject === 7) {
                this.f9_1 = 4;
                continue $sm;
              } else {
                this.p67_1.u66_1.y65('Expected end of the object or comma');
              }
            }

            break;
          case 3:
            this.f9_1 = 1;
            continue $sm;
          case 4:
            if (this.q67_1 === 6) {
              this.p67_1.u66_1.x66(7);
            } else if (this.q67_1 === 4) {
              this.p67_1.u66_1.y65('Unexpected trailing comma');
            }

            return new JsonObject_0(this.o67_1);
          case 5:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 5) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function JsonTreeReader(configuration, lexer) {
    this.u66_1 = lexer;
    this.v66_1 = configuration.u62_1;
    this.w66_1 = 0;
  }
  protoOf(JsonTreeReader).c67 = function () {
    var token = this.u66_1.y66();
    var tmp;
    if (token === 1) {
      tmp = readValue(this, true);
    } else if (token === 0) {
      tmp = readValue(this, false);
    } else if (token === 6) {
      var tmp_0;
      this.w66_1 = this.w66_1 + 1 | 0;
      if (this.w66_1 === 200) {
        tmp_0 = readDeepRecursive(this);
      } else {
        tmp_0 = readObject(this);
      }
      var result = tmp_0;
      this.w66_1 = this.w66_1 - 1 | 0;
      tmp = result;
    } else if (token === 8) {
      tmp = readArray(this);
    } else {
      this.u66_1.y65('Cannot begin reading element, unexpected token: ' + token);
    }
    return tmp;
  };
  function classDiscriminator(_this__u8e3s4, json) {
    var tmp0_iterator = _this__u8e3s4.w58().m();
    while (tmp0_iterator.n()) {
      var annotation = tmp0_iterator.o();
      if (annotation instanceof JsonClassDiscriminator)
        return annotation.g68_1;
    }
    return json.k61_1.b63_1;
  }
  function decodeSerializableValuePolymorphic(_this__u8e3s4, deserializer) {
    var tmp;
    if (!(deserializer instanceof AbstractPolymorphicSerializer)) {
      tmp = true;
    } else {
      tmp = _this__u8e3s4.f63().k61_1.a63_1;
    }
    if (tmp) {
      return deserializer.j59(_this__u8e3s4);
    }
    var discriminator = classDiscriminator(deserializer.v58(), _this__u8e3s4.f63());
    var tmp0 = _this__u8e3s4.g63();
    // Inline function 'kotlinx.serialization.json.internal.cast' call
    var descriptor = deserializer.v58();
    if (!(tmp0 instanceof JsonObject_0)) {
      throw JsonDecodingException_1(-1, 'Expected ' + toString_1(getKClass(JsonObject_0)) + ' as the serialized body of ' + descriptor.z59() + ', but had ' + toString_1(getKClassFromExpression(tmp0)));
    }
    var jsonTree = tmp0;
    var tmp0_safe_receiver = jsonTree.ld(discriminator);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : get_jsonPrimitive(tmp0_safe_receiver);
    var type = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.h63();
    var tmp2_elvis_lhs = deserializer.q59(_this__u8e3s4, type);
    var tmp_0;
    if (tmp2_elvis_lhs == null) {
      throwSerializerNotFound(type, jsonTree);
    } else {
      tmp_0 = tmp2_elvis_lhs;
    }
    var actualSerializer = tmp_0;
    var tmp_1 = _this__u8e3s4.f63();
    return readPolymorphicJson(tmp_1, discriminator, jsonTree, isInterface(actualSerializer, DeserializationStrategy) ? actualSerializer : THROW_CCE());
  }
  function throwSerializerNotFound(type, jsonTree) {
    var suffix = type == null ? "missing class discriminator ('null')" : "class discriminator '" + type + "'";
    throw JsonDecodingException_0(-1, 'Polymorphic serializer was not found for ' + suffix, jsonTree.toString());
  }
  function validateIfSealed(serializer, actualSerializer, classDiscriminator) {
    if (!(serializer instanceof SealedClassSerializer))
      return Unit_instance;
    if (jsonCachedSerialNames(actualSerializer.v58()).t(classDiscriminator)) {
      var baseName = serializer.v58().z59();
      var actualName = actualSerializer.v58().z59();
      // Inline function 'kotlin.error' call
      var message = "Sealed class '" + actualName + "' cannot be serialized as base class '" + baseName + "' because" + (" it has property name that conflicts with JSON class discriminator '" + classDiscriminator + "'. ") + 'You can either change class discriminator in JsonConfiguration, ' + 'rename property with @SerialName annotation or fall back to array polymorphism';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
  }
  function checkKind(kind) {
    if (kind instanceof ENUM) {
      // Inline function 'kotlin.error' call
      var message = "Enums cannot be serialized polymorphically with 'type' parameter. You can use 'JsonBuilder.useArrayPolymorphism' instead";
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    if (kind instanceof PrimitiveKind) {
      // Inline function 'kotlin.error' call
      var message_0 = "Primitives cannot be serialized polymorphically with 'type' parameter. You can use 'JsonBuilder.useArrayPolymorphism' instead";
      throw IllegalStateException_init_$Create$_0(toString_1(message_0));
    }
    if (kind instanceof PolymorphicKind) {
      // Inline function 'kotlin.error' call
      var message_1 = 'Actual serializer for polymorphic cannot be polymorphic itself';
      throw IllegalStateException_init_$Create$_0(toString_1(message_1));
    }
  }
  function access$validateIfSealed$tPolymorphicKt(serializer, actualSerializer, classDiscriminator) {
    return validateIfSealed(serializer, actualSerializer, classDiscriminator);
  }
  function checkKind_0($this, descriptor, actualClass) {
    var kind = descriptor.r5a();
    var tmp;
    if (kind instanceof PolymorphicKind) {
      tmp = true;
    } else {
      tmp = equals(kind, CONTEXTUAL_getInstance());
    }
    if (tmp) {
      throw IllegalArgumentException_init_$Create$_0('Serializer for ' + actualClass.ra() + " can't be registered as a subclass for polymorphic serialization " + ('because its kind ' + kind.toString() + ' is not concrete. To work with multiple hierarchies, register it as a base class.'));
    }
    if ($this.h68_1)
      return Unit_instance;
    var tmp_0;
    var tmp_1;
    if (equals(kind, LIST_getInstance()) || equals(kind, MAP_getInstance())) {
      tmp_1 = true;
    } else {
      tmp_1 = kind instanceof PrimitiveKind;
    }
    if (tmp_1) {
      tmp_0 = true;
    } else {
      tmp_0 = kind instanceof ENUM;
    }
    if (tmp_0) {
      throw IllegalArgumentException_init_$Create$_0('Serializer for ' + actualClass.ra() + ' of kind ' + kind.toString() + ' cannot be serialized polymorphically with class discriminator.');
    }
  }
  function checkDiscriminatorCollisions($this, descriptor, actualClass) {
    var inductionVariable = 0;
    var last = descriptor.p5a();
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var name = descriptor.v5a(i);
        if (name === $this.i68_1) {
          throw IllegalArgumentException_init_$Create$_0('Polymorphic serializer for ' + toString_1(actualClass) + " has property '" + name + "' that conflicts " + 'with JSON class discriminator. You can either change class discriminator in JsonConfiguration, ' + 'rename property with @SerialName annotation ' + 'or fall back to array polymorphism');
        }
      }
       while (inductionVariable < last);
  }
  function PolymorphismValidator(useArrayPolymorphism, discriminator) {
    this.h68_1 = useArrayPolymorphism;
    this.i68_1 = discriminator;
  }
  protoOf(PolymorphismValidator).i5t = function (kClass, provider) {
  };
  protoOf(PolymorphismValidator).l5t = function (baseClass, actualClass, actualSerializer) {
    var descriptor = actualSerializer.v58();
    checkKind_0(this, descriptor, actualClass);
    if (!this.h68_1) {
      checkDiscriminatorCollisions(this, descriptor, actualClass);
    }
  };
  protoOf(PolymorphismValidator).m5t = function (baseClass, defaultSerializerProvider) {
  };
  protoOf(PolymorphismValidator).n5t = function (baseClass, defaultDeserializerProvider) {
  };
  function Key_6() {
  }
  function DescriptorSchemaCache() {
    this.z65_1 = createMapForCache(16);
  }
  protoOf(DescriptorSchemaCache).j68 = function (descriptor, key, value) {
    // Inline function 'kotlin.collections.getOrPut' call
    var this_0 = this.z65_1;
    var value_0 = this_0.q2(descriptor);
    var tmp;
    if (value_0 == null) {
      var answer = createMapForCache(2);
      this_0.t2(descriptor, answer);
      tmp = answer;
    } else {
      tmp = value_0;
    }
    var tmp0 = tmp;
    var tmp2 = key instanceof Key_6 ? key : THROW_CCE();
    // Inline function 'kotlin.collections.set' call
    var value_1 = !(value == null) ? value : THROW_CCE();
    tmp0.t2(tmp2, value_1);
  };
  protoOf(DescriptorSchemaCache).a66 = function (descriptor, key, defaultValue) {
    var tmp0_safe_receiver = this.k68(descriptor, key);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      return tmp0_safe_receiver;
    }
    var value = defaultValue();
    this.j68(descriptor, key, value);
    return value;
  };
  protoOf(DescriptorSchemaCache).k68 = function (descriptor, key) {
    var tmp0_safe_receiver = this.z65_1.q2(descriptor);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      tmp = tmp0_safe_receiver.q2(key instanceof Key_6 ? key : THROW_CCE());
    }
    var tmp_0 = tmp;
    return !(tmp_0 == null) ? tmp_0 : null;
  };
  function DiscriminatorHolder(discriminatorToSkip) {
    this.l68_1 = discriminatorToSkip;
  }
  function trySkip($this, _this__u8e3s4, unknownKey) {
    if (_this__u8e3s4 == null)
      return false;
    if (_this__u8e3s4.l68_1 === unknownKey) {
      _this__u8e3s4.l68_1 = null;
      return true;
    }
    return false;
  }
  function skipLeftoverElements($this, descriptor) {
    while (!($this.w5c(descriptor) === -1)) {
    }
  }
  function checkLeadingComma($this) {
    if ($this.s61_1.y66() === 4) {
      $this.s61_1.y65('Unexpected leading comma');
    }
  }
  function decodeMapIndex($this) {
    var hasComma = false;
    var decodingKey = !(($this.u61_1 % 2 | 0) === 0);
    if (decodingKey) {
      if (!($this.u61_1 === -1)) {
        hasComma = $this.s61_1.n68();
      }
    } else {
      $this.s61_1.m68(_Char___init__impl__6a9atx(58));
    }
    var tmp;
    if ($this.s61_1.z66()) {
      if (decodingKey) {
        if ($this.u61_1 === -1) {
          var tmp0 = $this.s61_1;
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.require' call
          var condition = !hasComma;
          var position = tmp0.y61_1;
          if (!condition) {
            var tmp$ret$0 = 'Unexpected trailing comma';
            tmp0.y65(tmp$ret$0, position);
          }
        } else {
          var tmp0_0 = $this.s61_1;
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.require' call
          var condition_0 = hasComma;
          var position_0 = tmp0_0.y61_1;
          if (!condition_0) {
            var tmp$ret$2 = 'Expected comma after the key-value pair';
            tmp0_0.y65(tmp$ret$2, position_0);
          }
        }
      }
      $this.u61_1 = $this.u61_1 + 1 | 0;
      tmp = $this.u61_1;
    } else {
      if (hasComma) {
        $this.s61_1.y65("Expected '}', but had ',' instead");
      }
      tmp = -1;
    }
    return tmp;
  }
  function coerceInputValue($this, descriptor, index) {
    var tmp0 = $this.q61_1;
    var tmp2 = descriptor.t5a(index);
    var tmp$ret$1;
    $l$block_2: {
      // Inline function 'kotlinx.serialization.json.internal.tryCoerceValue' call
      var tmp;
      if (!tmp2.i5a()) {
        tmp = $this.s61_1.o68(true);
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$1 = true;
        break $l$block_2;
      }
      if (equals(tmp2.r5a(), ENUM_getInstance())) {
        var tmp_0;
        if (tmp2.i5a()) {
          tmp_0 = $this.s61_1.o68(false);
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          tmp$ret$1 = false;
          break $l$block_2;
        }
        var tmp0_elvis_lhs = $this.s61_1.p68($this.w61_1.u62_1);
        var tmp_1;
        if (tmp0_elvis_lhs == null) {
          tmp$ret$1 = false;
          break $l$block_2;
        } else {
          tmp_1 = tmp0_elvis_lhs;
        }
        var enumValue = tmp_1;
        var enumIndex = getJsonNameIndex(tmp2, tmp0, enumValue);
        if (enumIndex === -3) {
          $this.s61_1.a67();
          tmp$ret$1 = true;
          break $l$block_2;
        }
      }
      tmp$ret$1 = false;
    }
    return tmp$ret$1;
  }
  function decodeObjectIndex($this, descriptor) {
    var hasComma = $this.s61_1.n68();
    while ($this.s61_1.z66()) {
      hasComma = false;
      var key = decodeStringKey($this);
      $this.s61_1.m68(_Char___init__impl__6a9atx(58));
      var index = getJsonNameIndex(descriptor, $this.q61_1, key);
      var tmp;
      if (!(index === -3)) {
        var tmp_0;
        if ($this.w61_1.z62_1 && coerceInputValue($this, descriptor, index)) {
          hasComma = $this.s61_1.n68();
          tmp_0 = false;
        } else {
          var tmp0_safe_receiver = $this.x61_1;
          if (tmp0_safe_receiver == null)
            null;
          else {
            tmp0_safe_receiver.w65(index);
          }
          return index;
        }
        tmp = tmp_0;
      } else {
        tmp = true;
      }
      var isUnknown = tmp;
      if (isUnknown) {
        hasComma = handleUnknown($this, key);
      }
    }
    if (hasComma) {
      $this.s61_1.y65('Unexpected trailing comma');
    }
    var tmp1_safe_receiver = $this.x61_1;
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.x65();
    return tmp2_elvis_lhs == null ? -1 : tmp2_elvis_lhs;
  }
  function handleUnknown($this, key) {
    if ($this.w61_1.t62_1 || trySkip($this, $this.v61_1, key)) {
      $this.s61_1.r68($this.w61_1.u62_1);
    } else {
      $this.s61_1.q68(key);
    }
    return $this.s61_1.n68();
  }
  function decodeListIndex($this) {
    var hasComma = $this.s61_1.n68();
    var tmp;
    if ($this.s61_1.z66()) {
      if (!($this.u61_1 === -1) && !hasComma) {
        $this.s61_1.y65('Expected end of the array or comma');
      }
      $this.u61_1 = $this.u61_1 + 1 | 0;
      tmp = $this.u61_1;
    } else {
      if (hasComma) {
        $this.s61_1.y65('Unexpected trailing comma');
      }
      tmp = -1;
    }
    return tmp;
  }
  function decodeStringKey($this) {
    var tmp;
    if ($this.w61_1.u62_1) {
      tmp = $this.s61_1.t68();
    } else {
      tmp = $this.s61_1.s68();
    }
    return tmp;
  }
  function StreamingJsonDecoder(json, mode, lexer, descriptor, discriminatorHolder) {
    AbstractDecoder.call(this);
    this.q61_1 = json;
    this.r61_1 = mode;
    this.s61_1 = lexer;
    this.t61_1 = this.q61_1.g59();
    this.u61_1 = -1;
    this.v61_1 = discriminatorHolder;
    this.w61_1 = this.q61_1.k61_1;
    this.x61_1 = this.w61_1.x62_1 ? null : new JsonElementMarker(descriptor);
  }
  protoOf(StreamingJsonDecoder).f63 = function () {
    return this.q61_1;
  };
  protoOf(StreamingJsonDecoder).g59 = function () {
    return this.t61_1;
  };
  protoOf(StreamingJsonDecoder).g63 = function () {
    return (new JsonTreeReader(this.q61_1.k61_1, this.s61_1)).c67();
  };
  protoOf(StreamingJsonDecoder).k59 = function (deserializer) {
    try {
      var tmp;
      if (!(deserializer instanceof AbstractPolymorphicSerializer)) {
        tmp = true;
      } else {
        tmp = this.q61_1.k61_1.a63_1;
      }
      if (tmp) {
        return deserializer.j59(this);
      }
      var discriminator = classDiscriminator(deserializer.v58(), this.q61_1);
      var type = this.s61_1.u68(discriminator, this.w61_1.u62_1);
      var actualSerializer = null;
      if (!(type == null)) {
        actualSerializer = deserializer.q59(this, type);
      }
      if (actualSerializer == null) {
        return decodeSerializableValuePolymorphic(this, isInterface(deserializer, DeserializationStrategy) ? deserializer : THROW_CCE());
      }
      this.v61_1 = new DiscriminatorHolder(discriminator);
      var tmp_0 = actualSerializer.j59(this);
      var result = !(tmp_0 == null) ? tmp_0 : THROW_CCE();
      return result;
    } catch ($p) {
      if ($p instanceof MissingFieldException) {
        var e = $p;
        if (contains_8(ensureNotNull(e.message), 'at path'))
          throw e;
        throw new MissingFieldException(e.e5a_1, plus_12(e.message, ' at path: ') + this.s61_1.z61_1.l66(), e);
      } else {
        throw $p;
      }
    }
  };
  protoOf(StreamingJsonDecoder).g5c = function (descriptor) {
    var newMode = switchMode(this.q61_1, descriptor);
    this.s61_1.z61_1.g66(descriptor);
    this.s61_1.m68(newMode.x68_1);
    checkLeadingComma(this);
    var tmp;
    switch (newMode.x2_1) {
      case 1:
      case 2:
      case 3:
        tmp = new StreamingJsonDecoder(this.q61_1, newMode, this.s61_1, descriptor, this.v61_1);
        break;
      default:
        var tmp_0;
        if (this.r61_1.equals(newMode) && this.q61_1.k61_1.x62_1) {
          tmp_0 = this;
        } else {
          tmp_0 = new StreamingJsonDecoder(this.q61_1, newMode, this.s61_1, descriptor, this.v61_1);
        }

        tmp = tmp_0;
        break;
    }
    return tmp;
  };
  protoOf(StreamingJsonDecoder).h5c = function (descriptor) {
    if (this.q61_1.k61_1.t62_1 && descriptor.p5a() === 0) {
      skipLeftoverElements(this, descriptor);
    }
    this.s61_1.m68(this.r61_1.y68_1);
    this.s61_1.z61_1.k66();
  };
  protoOf(StreamingJsonDecoder).s5b = function () {
    var tmp;
    var tmp0_safe_receiver = this.x61_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.v65_1;
    if (!(tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs)) {
      tmp = !this.s61_1.z68();
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(StreamingJsonDecoder).t5b = function () {
    return null;
  };
  protoOf(StreamingJsonDecoder).s5c = function (descriptor, index, deserializer, previousValue) {
    var isMapKey = this.r61_1.equals(WriteMode_MAP_getInstance()) && (index & 1) === 0;
    if (isMapKey) {
      this.s61_1.z61_1.j66();
    }
    var value = protoOf(AbstractDecoder).s5c.call(this, descriptor, index, deserializer, previousValue);
    if (isMapKey) {
      this.s61_1.z61_1.i66(value);
    }
    return value;
  };
  protoOf(StreamingJsonDecoder).w5c = function (descriptor) {
    var index;
    switch (this.r61_1.x2_1) {
      case 0:
        index = decodeObjectIndex(this, descriptor);
        break;
      case 2:
        index = decodeMapIndex(this);
        break;
      default:
        index = decodeListIndex(this);
        break;
    }
    if (!this.r61_1.equals(WriteMode_MAP_getInstance())) {
      this.s61_1.z61_1.h66(index);
    }
    return index;
  };
  protoOf(StreamingJsonDecoder).u5b = function () {
    var tmp;
    if (this.w61_1.u62_1) {
      tmp = this.s61_1.b69();
    } else {
      tmp = this.s61_1.a69();
    }
    return tmp;
  };
  protoOf(StreamingJsonDecoder).v5b = function () {
    var value = this.s61_1.c69();
    if (!(value === fromInt_0(convertToByte(value)))) {
      this.s61_1.y65("Failed to parse byte for input '" + value.toString() + "'");
    }
    return convertToByte(value);
  };
  protoOf(StreamingJsonDecoder).w5b = function () {
    var value = this.s61_1.c69();
    if (!(value === fromInt_0(convertToShort(value)))) {
      this.s61_1.y65("Failed to parse short for input '" + value.toString() + "'");
    }
    return convertToShort(value);
  };
  protoOf(StreamingJsonDecoder).x5b = function () {
    var value = this.s61_1.c69();
    if (!(value === fromInt_0(convertToInt(value)))) {
      this.s61_1.y65("Failed to parse int for input '" + value.toString() + "'");
    }
    return convertToInt(value);
  };
  protoOf(StreamingJsonDecoder).y5b = function () {
    return this.s61_1.c69();
  };
  protoOf(StreamingJsonDecoder).z5b = function () {
    var tmp0 = this.s61_1;
    var tmp$ret$4;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.parseString' call
      var input = tmp0.b67();
      try {
        // Inline function 'kotlin.text.toFloat' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp$ret$4 = toDouble(input);
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          tmp0.y65("Failed to parse type '" + 'float' + "' for input '" + input + "'");
        } else {
          throw $p;
        }
      }
    }
    var result = tmp$ret$4;
    var specialFp = this.q61_1.k61_1.c63_1;
    if (specialFp || isFinite(result))
      return result;
    throwInvalidFloatingPointDecoded(this.s61_1, result);
  };
  protoOf(StreamingJsonDecoder).a5c = function () {
    var tmp0 = this.s61_1;
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.parseString' call
      var input = tmp0.b67();
      try {
        tmp$ret$1 = toDouble(input);
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          tmp0.y65("Failed to parse type '" + 'double' + "' for input '" + input + "'");
        } else {
          throw $p;
        }
      }
    }
    var result = tmp$ret$1;
    var specialFp = this.q61_1.k61_1.c63_1;
    if (specialFp || isFinite_0(result))
      return result;
    throwInvalidFloatingPointDecoded(this.s61_1, result);
  };
  protoOf(StreamingJsonDecoder).b5c = function () {
    var string = this.s61_1.b67();
    if (!(string.length === 1)) {
      this.s61_1.y65("Expected single char, but got '" + string + "'");
    }
    return charCodeAt(string, 0);
  };
  protoOf(StreamingJsonDecoder).c5c = function () {
    var tmp;
    if (this.w61_1.u62_1) {
      tmp = this.s61_1.t68();
    } else {
      tmp = this.s61_1.a67();
    }
    return tmp;
  };
  protoOf(StreamingJsonDecoder).e5c = function (descriptor) {
    return get_isUnsignedNumber(descriptor) ? new JsonDecoderForUnsignedTypes(this.s61_1, this.q61_1) : protoOf(AbstractDecoder).e5c.call(this, descriptor);
  };
  protoOf(StreamingJsonDecoder).d5c = function (enumDescriptor) {
    return getJsonNameIndexOrThrow(enumDescriptor, this.q61_1, this.c5c(), ' at path ' + this.s61_1.z61_1.l66());
  };
  function JsonDecoderForUnsignedTypes(lexer, json) {
    AbstractDecoder.call(this);
    this.d69_1 = lexer;
    this.e69_1 = json.g59();
  }
  protoOf(JsonDecoderForUnsignedTypes).g59 = function () {
    return this.e69_1;
  };
  protoOf(JsonDecoderForUnsignedTypes).w5c = function (descriptor) {
    var message = 'unsupported';
    throw IllegalStateException_init_$Create$_0(toString_1(message));
  };
  protoOf(JsonDecoderForUnsignedTypes).x5b = function () {
    var tmp0 = this.d69_1;
    var tmp$ret$2;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.parseString' call
      var input = tmp0.b67();
      try {
        // Inline function 'kotlin.UInt.toInt' call
        var this_0 = toUInt(input);
        tmp$ret$2 = _UInt___get_data__impl__f0vqqw(this_0);
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          tmp0.y65("Failed to parse type '" + 'UInt' + "' for input '" + input + "'");
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$2;
  };
  protoOf(JsonDecoderForUnsignedTypes).y5b = function () {
    var tmp0 = this.d69_1;
    var tmp$ret$2;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.parseString' call
      var input = tmp0.b67();
      try {
        // Inline function 'kotlin.ULong.toLong' call
        var this_0 = toULong(input);
        tmp$ret$2 = _ULong___get_data__impl__fggpzb(this_0);
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          tmp0.y65("Failed to parse type '" + 'ULong' + "' for input '" + input + "'");
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$2;
  };
  protoOf(JsonDecoderForUnsignedTypes).v5b = function () {
    var tmp0 = this.d69_1;
    var tmp$ret$2;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.parseString' call
      var input = tmp0.b67();
      try {
        // Inline function 'kotlin.UByte.toByte' call
        var this_0 = toUByte(input);
        tmp$ret$2 = _UByte___get_data__impl__jof9qr(this_0);
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          tmp0.y65("Failed to parse type '" + 'UByte' + "' for input '" + input + "'");
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$2;
  };
  protoOf(JsonDecoderForUnsignedTypes).w5b = function () {
    var tmp0 = this.d69_1;
    var tmp$ret$2;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.parseString' call
      var input = tmp0.b67();
      try {
        // Inline function 'kotlin.UShort.toShort' call
        var this_0 = toUShort(input);
        tmp$ret$2 = _UShort___get_data__impl__g0245(this_0);
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          tmp0.y65("Failed to parse type '" + 'UShort' + "' for input '" + input + "'");
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$2;
  };
  function get_unsignedNumberDescriptors() {
    _init_properties_StreamingJsonEncoder_kt__pn1bsi();
    return unsignedNumberDescriptors;
  }
  var unsignedNumberDescriptors;
  function StreamingJsonEncoder_init_$Init$(output, json, mode, modeReuseCache, $this) {
    StreamingJsonEncoder.call($this, Composer_0(output, json), json, mode, modeReuseCache);
    return $this;
  }
  function StreamingJsonEncoder_init_$Create$(output, json, mode, modeReuseCache) {
    return StreamingJsonEncoder_init_$Init$(output, json, mode, modeReuseCache, objectCreate(protoOf(StreamingJsonEncoder)));
  }
  function encodeTypeInfo($this, descriptor) {
    $this.m66_1.u64();
    $this.j5d(ensureNotNull($this.t66_1));
    $this.m66_1.w64(_Char___init__impl__6a9atx(58));
    $this.m66_1.v64();
    $this.j5d(descriptor.z59());
  }
  function StreamingJsonEncoder(composer, json, mode, modeReuseCache) {
    AbstractEncoder.call(this);
    this.m66_1 = composer;
    this.n66_1 = json;
    this.o66_1 = mode;
    this.p66_1 = modeReuseCache;
    this.q66_1 = this.n66_1.g59();
    this.r66_1 = this.n66_1.k61_1;
    this.s66_1 = false;
    this.t66_1 = null;
    var i = this.o66_1.x2_1;
    if (!(this.p66_1 == null)) {
      if (!(this.p66_1[i] === null) || !(this.p66_1[i] === this)) {
        this.p66_1[i] = this;
      }
    }
  }
  protoOf(StreamingJsonEncoder).f63 = function () {
    return this.n66_1;
  };
  protoOf(StreamingJsonEncoder).g59 = function () {
    return this.q66_1;
  };
  protoOf(StreamingJsonEncoder).b5e = function (descriptor, index) {
    return this.r66_1.s62_1;
  };
  protoOf(StreamingJsonEncoder).h59 = function (serializer, value) {
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.encodePolymorphically' call
      var tmp;
      if (!(serializer instanceof AbstractPolymorphicSerializer)) {
        tmp = true;
      } else {
        tmp = this.f63().k61_1.a63_1;
      }
      if (tmp) {
        serializer.i59(this, value);
        break $l$block;
      }
      var casted = serializer instanceof AbstractPolymorphicSerializer ? serializer : THROW_CCE();
      var baseClassDiscriminator = classDiscriminator(serializer.v58(), this.f63());
      var actualSerializer = findPolymorphicSerializer(casted, this, !(value == null) ? value : THROW_CCE());
      access$validateIfSealed$tPolymorphicKt(casted, actualSerializer, baseClassDiscriminator);
      checkKind(actualSerializer.v58().r5a());
      this.t66_1 = baseClassDiscriminator;
      actualSerializer.i59(this, value);
    }
  };
  protoOf(StreamingJsonEncoder).g5c = function (descriptor) {
    var newMode = switchMode(this.n66_1, descriptor);
    if (!(newMode.x68_1 === _Char___init__impl__6a9atx(0))) {
      this.m66_1.w64(newMode.x68_1);
      this.m66_1.g2h();
    }
    if (!(this.t66_1 == null)) {
      encodeTypeInfo(this, descriptor);
      this.t66_1 = null;
    }
    if (this.o66_1.equals(newMode)) {
      return this;
    }
    var tmp0_safe_receiver = this.p66_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver[newMode.x2_1];
    return tmp1_elvis_lhs == null ? new StreamingJsonEncoder(this.m66_1, this.n66_1, newMode, this.p66_1) : tmp1_elvis_lhs;
  };
  protoOf(StreamingJsonEncoder).h5c = function (descriptor) {
    if (!(this.o66_1.y68_1 === _Char___init__impl__6a9atx(0))) {
      this.m66_1.t64();
      this.m66_1.u64();
      this.m66_1.w64(this.o66_1.y68_1);
    }
  };
  protoOf(StreamingJsonEncoder).y5c = function (descriptor, index) {
    switch (this.o66_1.x2_1) {
      case 1:
        if (!this.m66_1.s64_1) {
          this.m66_1.w64(_Char___init__impl__6a9atx(44));
        }

        this.m66_1.u64();
        break;
      case 2:
        if (!this.m66_1.s64_1) {
          var tmp = this;
          var tmp_0;
          if ((index % 2 | 0) === 0) {
            this.m66_1.w64(_Char___init__impl__6a9atx(44));
            this.m66_1.u64();
            tmp_0 = true;
          } else {
            this.m66_1.w64(_Char___init__impl__6a9atx(58));
            this.m66_1.v64();
            tmp_0 = false;
          }
          tmp.s66_1 = tmp_0;
        } else {
          this.s66_1 = true;
          this.m66_1.u64();
        }

        break;
      case 3:
        if (index === 0)
          this.s66_1 = true;
        if (index === 1) {
          this.m66_1.w64(_Char___init__impl__6a9atx(44));
          this.m66_1.v64();
          this.s66_1 = false;
        }

        break;
      default:
        if (!this.m66_1.s64_1) {
          this.m66_1.w64(_Char___init__impl__6a9atx(44));
        }

        this.m66_1.u64();
        this.j5d(getJsonElementName(descriptor, this.n66_1, index));
        this.m66_1.w64(_Char___init__impl__6a9atx(58));
        this.m66_1.v64();
        break;
    }
    return true;
  };
  protoOf(StreamingJsonEncoder).x5d = function (descriptor, index, serializer, value) {
    if (!(value == null) || this.r66_1.x62_1) {
      protoOf(AbstractEncoder).x5d.call(this, descriptor, index, serializer, value);
    }
  };
  protoOf(StreamingJsonEncoder).l5d = function (descriptor) {
    var tmp;
    if (get_isUnsignedNumber(descriptor)) {
      // Inline function 'kotlinx.serialization.json.internal.StreamingJsonEncoder.composerAs' call
      var tmp_0;
      var tmp_1 = this.m66_1;
      if (tmp_1 instanceof ComposerForUnsignedNumbers) {
        tmp_0 = this.m66_1;
      } else {
        var tmp0 = this.m66_1.r64_1;
        var p1 = this.s66_1;
        tmp_0 = new ComposerForUnsignedNumbers(tmp0, p1);
      }
      var tmp$ret$1 = tmp_0;
      tmp = new StreamingJsonEncoder(tmp$ret$1, this.n66_1, this.o66_1, null);
    } else if (get_isUnquotedLiteral(descriptor)) {
      // Inline function 'kotlinx.serialization.json.internal.StreamingJsonEncoder.composerAs' call
      var tmp_2;
      var tmp_3 = this.m66_1;
      if (tmp_3 instanceof ComposerForUnquotedLiterals) {
        tmp_2 = this.m66_1;
      } else {
        var tmp0_0 = this.m66_1.r64_1;
        var p1_0 = this.s66_1;
        tmp_2 = new ComposerForUnquotedLiterals(tmp0_0, p1_0);
      }
      var tmp$ret$3 = tmp_2;
      tmp = new StreamingJsonEncoder(tmp$ret$3, this.n66_1, this.o66_1, null);
    } else {
      tmp = protoOf(AbstractEncoder).l5d.call(this, descriptor);
    }
    return tmp;
  };
  protoOf(StreamingJsonEncoder).a5d = function () {
    this.m66_1.y64('null');
  };
  protoOf(StreamingJsonEncoder).b5d = function (value) {
    if (this.s66_1) {
      this.j5d(value.toString());
    } else {
      this.m66_1.h65(value);
    }
  };
  protoOf(StreamingJsonEncoder).c5d = function (value) {
    if (this.s66_1) {
      this.j5d(value.toString());
    } else {
      this.m66_1.c65(value);
    }
  };
  protoOf(StreamingJsonEncoder).d5d = function (value) {
    if (this.s66_1) {
      this.j5d(value.toString());
    } else {
      this.m66_1.e65(value);
    }
  };
  protoOf(StreamingJsonEncoder).e5d = function (value) {
    if (this.s66_1) {
      this.j5d(value.toString());
    } else {
      this.m66_1.f65(value);
    }
  };
  protoOf(StreamingJsonEncoder).f5d = function (value) {
    if (this.s66_1) {
      this.j5d(value.toString());
    } else {
      this.m66_1.g65(value);
    }
  };
  protoOf(StreamingJsonEncoder).g5d = function (value) {
    if (this.s66_1) {
      this.j5d(value.toString());
    } else {
      this.m66_1.a65(value);
    }
    if (!this.r66_1.c63_1 && !isFinite(value)) {
      throw InvalidFloatingPointEncoded(value, toString_1(this.m66_1.r64_1));
    }
  };
  protoOf(StreamingJsonEncoder).h5d = function (value) {
    if (this.s66_1) {
      this.j5d(value.toString());
    } else {
      this.m66_1.b65(value);
    }
    if (!this.r66_1.c63_1 && !isFinite_0(value)) {
      throw InvalidFloatingPointEncoded(value, toString_1(this.m66_1.r64_1));
    }
  };
  protoOf(StreamingJsonEncoder).i5d = function (value) {
    this.j5d(toString(value));
  };
  protoOf(StreamingJsonEncoder).j5d = function (value) {
    return this.m66_1.i65(value);
  };
  protoOf(StreamingJsonEncoder).k5d = function (enumDescriptor, index) {
    this.j5d(enumDescriptor.v5a(index));
  };
  function get_isUnsignedNumber(_this__u8e3s4) {
    _init_properties_StreamingJsonEncoder_kt__pn1bsi();
    return _this__u8e3s4.q5a() && get_unsignedNumberDescriptors().t(_this__u8e3s4);
  }
  function get_isUnquotedLiteral(_this__u8e3s4) {
    _init_properties_StreamingJsonEncoder_kt__pn1bsi();
    return _this__u8e3s4.q5a() && equals(_this__u8e3s4, get_jsonUnquotedLiteralDescriptor());
  }
  var properties_initialized_StreamingJsonEncoder_kt_6ifwwk;
  function _init_properties_StreamingJsonEncoder_kt__pn1bsi() {
    if (!properties_initialized_StreamingJsonEncoder_kt_6ifwwk) {
      properties_initialized_StreamingJsonEncoder_kt_6ifwwk = true;
      unsignedNumberDescriptors = setOf_0([serializer_7(Companion_getInstance_19()).v58(), serializer_6(Companion_getInstance_20()).v58(), serializer_8(Companion_getInstance_18()).v58(), serializer_9(Companion_getInstance_21()).v58()]);
    }
  }
  function get_ESCAPE_STRINGS() {
    _init_properties_StringOps_kt__fcy1db();
    return ESCAPE_STRINGS;
  }
  var ESCAPE_STRINGS;
  var ESCAPE_MARKERS;
  function printQuoted(_this__u8e3s4, value) {
    _init_properties_StringOps_kt__fcy1db();
    _this__u8e3s4.k8(_Char___init__impl__6a9atx(34));
    var lastPos = 0;
    var inductionVariable = 0;
    var last = charSequenceLength(value) - 1 | 0;
    if (inductionVariable <= last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlin.code' call
        var this_0 = charCodeAt(value, i);
        var c = Char__toInt_impl_vasixd(this_0);
        if (c < get_ESCAPE_STRINGS().length && !(get_ESCAPE_STRINGS()[c] == null)) {
          _this__u8e3s4.ec(value, lastPos, i);
          _this__u8e3s4.j8(get_ESCAPE_STRINGS()[c]);
          lastPos = i + 1 | 0;
        }
      }
       while (inductionVariable <= last);
    if (!(lastPos === 0)) {
      _this__u8e3s4.ec(value, lastPos, value.length);
    } else {
      _this__u8e3s4.j8(value);
    }
    _this__u8e3s4.k8(_Char___init__impl__6a9atx(34));
  }
  function toHexChar(i) {
    _init_properties_StringOps_kt__fcy1db();
    var d = i & 15;
    var tmp;
    if (d < 10) {
      // Inline function 'kotlin.code' call
      var this_0 = _Char___init__impl__6a9atx(48);
      var tmp$ret$0 = Char__toInt_impl_vasixd(this_0);
      tmp = numberToChar(d + tmp$ret$0 | 0);
    } else {
      var tmp_0 = d - 10 | 0;
      // Inline function 'kotlin.code' call
      var this_1 = _Char___init__impl__6a9atx(97);
      var tmp$ret$1 = Char__toInt_impl_vasixd(this_1);
      tmp = numberToChar(tmp_0 + tmp$ret$1 | 0);
    }
    return tmp;
  }
  function toBooleanStrictOrNull(_this__u8e3s4) {
    _init_properties_StringOps_kt__fcy1db();
    return equals_0(_this__u8e3s4, 'true', true) ? true : equals_0(_this__u8e3s4, 'false', true) ? false : null;
  }
  var properties_initialized_StringOps_kt_wzaea7;
  function _init_properties_StringOps_kt__fcy1db() {
    if (!properties_initialized_StringOps_kt_wzaea7) {
      properties_initialized_StringOps_kt_wzaea7 = true;
      // Inline function 'kotlin.arrayOfNulls' call
      // Inline function 'kotlin.apply' call
      var this_0 = Array(93);
      var inductionVariable = 0;
      if (inductionVariable <= 31)
        do {
          var c = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var c1 = toHexChar(c >> 12);
          var c2 = toHexChar(c >> 8);
          var c3 = toHexChar(c >> 4);
          var c4 = toHexChar(c);
          this_0[c] = '\\u' + toString(c1) + toString(c2) + toString(c3) + toString(c4);
        }
         while (inductionVariable <= 31);
      // Inline function 'kotlin.code' call
      var this_1 = _Char___init__impl__6a9atx(34);
      this_0[Char__toInt_impl_vasixd(this_1)] = '\\"';
      // Inline function 'kotlin.code' call
      var this_2 = _Char___init__impl__6a9atx(92);
      this_0[Char__toInt_impl_vasixd(this_2)] = '\\\\';
      // Inline function 'kotlin.code' call
      var this_3 = _Char___init__impl__6a9atx(9);
      this_0[Char__toInt_impl_vasixd(this_3)] = '\\t';
      // Inline function 'kotlin.code' call
      var this_4 = _Char___init__impl__6a9atx(8);
      this_0[Char__toInt_impl_vasixd(this_4)] = '\\b';
      // Inline function 'kotlin.code' call
      var this_5 = _Char___init__impl__6a9atx(10);
      this_0[Char__toInt_impl_vasixd(this_5)] = '\\n';
      // Inline function 'kotlin.code' call
      var this_6 = _Char___init__impl__6a9atx(13);
      this_0[Char__toInt_impl_vasixd(this_6)] = '\\r';
      this_0[12] = '\\f';
      ESCAPE_STRINGS = this_0;
      // Inline function 'kotlin.apply' call
      var this_7 = new Int8Array(93);
      var inductionVariable_0 = 0;
      if (inductionVariable_0 <= 31)
        do {
          var c_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          this_7[c_0] = 1;
        }
         while (inductionVariable_0 <= 31);
      // Inline function 'kotlin.code' call
      var this_8 = _Char___init__impl__6a9atx(34);
      var tmp = Char__toInt_impl_vasixd(this_8);
      // Inline function 'kotlin.code' call
      var this_9 = _Char___init__impl__6a9atx(34);
      var tmp$ret$1 = Char__toInt_impl_vasixd(this_9);
      this_7[tmp] = toByte(tmp$ret$1);
      // Inline function 'kotlin.code' call
      var this_10 = _Char___init__impl__6a9atx(92);
      var tmp_0 = Char__toInt_impl_vasixd(this_10);
      // Inline function 'kotlin.code' call
      var this_11 = _Char___init__impl__6a9atx(92);
      var tmp$ret$3 = Char__toInt_impl_vasixd(this_11);
      this_7[tmp_0] = toByte(tmp$ret$3);
      // Inline function 'kotlin.code' call
      var this_12 = _Char___init__impl__6a9atx(9);
      var tmp_1 = Char__toInt_impl_vasixd(this_12);
      // Inline function 'kotlin.code' call
      var this_13 = _Char___init__impl__6a9atx(116);
      var tmp$ret$5 = Char__toInt_impl_vasixd(this_13);
      this_7[tmp_1] = toByte(tmp$ret$5);
      // Inline function 'kotlin.code' call
      var this_14 = _Char___init__impl__6a9atx(8);
      var tmp_2 = Char__toInt_impl_vasixd(this_14);
      // Inline function 'kotlin.code' call
      var this_15 = _Char___init__impl__6a9atx(98);
      var tmp$ret$7 = Char__toInt_impl_vasixd(this_15);
      this_7[tmp_2] = toByte(tmp$ret$7);
      // Inline function 'kotlin.code' call
      var this_16 = _Char___init__impl__6a9atx(10);
      var tmp_3 = Char__toInt_impl_vasixd(this_16);
      // Inline function 'kotlin.code' call
      var this_17 = _Char___init__impl__6a9atx(110);
      var tmp$ret$9 = Char__toInt_impl_vasixd(this_17);
      this_7[tmp_3] = toByte(tmp$ret$9);
      // Inline function 'kotlin.code' call
      var this_18 = _Char___init__impl__6a9atx(13);
      var tmp_4 = Char__toInt_impl_vasixd(this_18);
      // Inline function 'kotlin.code' call
      var this_19 = _Char___init__impl__6a9atx(114);
      var tmp$ret$11 = Char__toInt_impl_vasixd(this_19);
      this_7[tmp_4] = toByte(tmp$ret$11);
      // Inline function 'kotlin.code' call
      var this_20 = _Char___init__impl__6a9atx(102);
      var tmp$ret$12 = Char__toInt_impl_vasixd(this_20);
      this_7[12] = toByte(tmp$ret$12);
      ESCAPE_MARKERS = this_7;
    }
  }
  function readJson(_this__u8e3s4, element, deserializer) {
    var tmp;
    if (element instanceof JsonObject_0) {
      tmp = new JsonTreeDecoder(_this__u8e3s4, element);
    } else {
      if (element instanceof JsonArray_0) {
        tmp = new JsonTreeListDecoder(_this__u8e3s4, element);
      } else {
        var tmp_0;
        if (element instanceof JsonLiteral) {
          tmp_0 = true;
        } else {
          tmp_0 = equals(element, JsonNull_getInstance());
        }
        if (tmp_0) {
          tmp = new JsonPrimitiveDecoder(_this__u8e3s4, element instanceof JsonPrimitive ? element : THROW_CCE());
        } else {
          noWhenBranchMatchedException();
        }
      }
    }
    var input = tmp;
    return input.k59(deserializer);
  }
  function currentObject($this) {
    var tmp0_safe_receiver = $this.i5q();
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp = $this.k69(tmp0_safe_receiver);
    }
    var tmp1_elvis_lhs = tmp;
    return tmp1_elvis_lhs == null ? $this.a1() : tmp1_elvis_lhs;
  }
  function unparsedPrimitive($this, primitive) {
    throw JsonDecodingException_0(-1, "Failed to parse '" + primitive + "'", toString_1(currentObject($this)));
  }
  function asLiteral($this, _this__u8e3s4, type) {
    var tmp0_elvis_lhs = _this__u8e3s4 instanceof JsonLiteral ? _this__u8e3s4 : null;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw JsonDecodingException_1(-1, "Unexpected 'null' when " + type + ' was expected');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function AbstractJsonTreeDecoder(json, value) {
    NamedValueDecoder.call(this);
    this.h69_1 = json;
    this.i69_1 = value;
    this.j69_1 = this.f63().k61_1;
  }
  protoOf(AbstractJsonTreeDecoder).f63 = function () {
    return this.h69_1;
  };
  protoOf(AbstractJsonTreeDecoder).a1 = function () {
    return this.i69_1;
  };
  protoOf(AbstractJsonTreeDecoder).g59 = function () {
    return this.f63().g59();
  };
  protoOf(AbstractJsonTreeDecoder).g63 = function () {
    return currentObject(this);
  };
  protoOf(AbstractJsonTreeDecoder).k59 = function (deserializer) {
    return decodeSerializableValuePolymorphic(this, deserializer);
  };
  protoOf(AbstractJsonTreeDecoder).j5q = function (parentName, childName) {
    return childName;
  };
  protoOf(AbstractJsonTreeDecoder).g5c = function (descriptor) {
    var currentObject_0 = currentObject(this);
    var tmp0_subject = descriptor.r5a();
    var tmp;
    var tmp_0;
    if (equals(tmp0_subject, LIST_getInstance())) {
      tmp_0 = true;
    } else {
      tmp_0 = tmp0_subject instanceof PolymorphicKind;
    }
    if (tmp_0) {
      var tmp_1 = this.f63();
      // Inline function 'kotlinx.serialization.json.internal.cast' call
      if (!(currentObject_0 instanceof JsonArray_0)) {
        throw JsonDecodingException_1(-1, 'Expected ' + toString_1(getKClass(JsonArray_0)) + ' as the serialized body of ' + descriptor.z59() + ', but had ' + toString_1(getKClassFromExpression(currentObject_0)));
      }
      tmp = new JsonTreeListDecoder(tmp_1, currentObject_0);
    } else {
      if (equals(tmp0_subject, MAP_getInstance())) {
        // Inline function 'kotlinx.serialization.json.internal.selectMapMode' call
        var this_0 = this.f63();
        var keyDescriptor = carrierDescriptor(descriptor.t5a(0), this_0.g59());
        var keyKind = keyDescriptor.r5a();
        var tmp_2;
        var tmp_3;
        if (keyKind instanceof PrimitiveKind) {
          tmp_3 = true;
        } else {
          tmp_3 = equals(keyKind, ENUM_getInstance());
        }
        if (tmp_3) {
          var tmp_4 = this.f63();
          // Inline function 'kotlinx.serialization.json.internal.cast' call
          if (!(currentObject_0 instanceof JsonObject_0)) {
            throw JsonDecodingException_1(-1, 'Expected ' + toString_1(getKClass(JsonObject_0)) + ' as the serialized body of ' + descriptor.z59() + ', but had ' + toString_1(getKClassFromExpression(currentObject_0)));
          }
          tmp_2 = new JsonTreeMapDecoder(tmp_4, currentObject_0);
        } else {
          if (this_0.k61_1.v62_1) {
            var tmp_5 = this.f63();
            // Inline function 'kotlinx.serialization.json.internal.cast' call
            if (!(currentObject_0 instanceof JsonArray_0)) {
              throw JsonDecodingException_1(-1, 'Expected ' + toString_1(getKClass(JsonArray_0)) + ' as the serialized body of ' + descriptor.z59() + ', but had ' + toString_1(getKClassFromExpression(currentObject_0)));
            }
            tmp_2 = new JsonTreeListDecoder(tmp_5, currentObject_0);
          } else {
            throw InvalidKeyKindException(keyDescriptor);
          }
        }
        tmp = tmp_2;
      } else {
        var tmp_6 = this.f63();
        // Inline function 'kotlinx.serialization.json.internal.cast' call
        if (!(currentObject_0 instanceof JsonObject_0)) {
          throw JsonDecodingException_1(-1, 'Expected ' + toString_1(getKClass(JsonObject_0)) + ' as the serialized body of ' + descriptor.z59() + ', but had ' + toString_1(getKClassFromExpression(currentObject_0)));
        }
        tmp = new JsonTreeDecoder(tmp_6, currentObject_0);
      }
    }
    return tmp;
  };
  protoOf(AbstractJsonTreeDecoder).h5c = function (descriptor) {
  };
  protoOf(AbstractJsonTreeDecoder).s5b = function () {
    var tmp = currentObject(this);
    return !(tmp instanceof JsonNull_0);
  };
  protoOf(AbstractJsonTreeDecoder).l69 = function (tag) {
    var currentElement = this.k69(tag);
    var tmp0_elvis_lhs = currentElement instanceof JsonPrimitive ? currentElement : null;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw JsonDecodingException_0(-1, 'Expected JsonPrimitive at ' + tag + ', found ' + toString_1(currentElement), toString_1(currentObject(this)));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  protoOf(AbstractJsonTreeDecoder).m69 = function (tag, enumDescriptor) {
    return getJsonNameIndexOrThrow(enumDescriptor, this.f63(), this.l69(tag).h63());
  };
  protoOf(AbstractJsonTreeDecoder).v5q = function (tag, enumDescriptor) {
    return this.m69((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE(), enumDescriptor);
  };
  protoOf(AbstractJsonTreeDecoder).n69 = function (tag) {
    return !(this.k69(tag) === JsonNull_getInstance());
  };
  protoOf(AbstractJsonTreeDecoder).l5q = function (tag) {
    return this.n69((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  protoOf(AbstractJsonTreeDecoder).o69 = function (tag) {
    var value = this.l69(tag);
    if (!this.f63().k61_1.u62_1) {
      var literal = asLiteral(this, value, 'boolean');
      if (literal.o63_1)
        throw JsonDecodingException_0(-1, "Boolean literal for key '" + tag + "' should be unquoted.\nUse 'isLenient = true' in 'Json {}` builder to accept non-compliant JSON.", toString_1(currentObject(this)));
    }
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.primitive' call
      try {
        var tmp0_elvis_lhs = get_booleanOrNull(value);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          throw IllegalArgumentException_init_$Create$();
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var tmp0_elvis_lhs_0 = tmp;
        var tmp_0;
        if (tmp0_elvis_lhs_0 == null) {
          unparsedPrimitive(this, 'boolean');
        } else {
          tmp_0 = tmp0_elvis_lhs_0;
        }
        tmp$ret$1 = tmp_0;
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          unparsedPrimitive(this, 'boolean');
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$1;
  };
  protoOf(AbstractJsonTreeDecoder).m5q = function (tag) {
    return this.o69((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  protoOf(AbstractJsonTreeDecoder).p69 = function (tag) {
    var tmp2 = this.l69(tag);
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.primitive' call
      try {
        var result = get_int(tmp2);
        var tmp0_elvis_lhs = (-128 <= result ? result <= 127 : false) ? toByte(result) : null;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          unparsedPrimitive(this, 'byte');
        } else {
          tmp = tmp0_elvis_lhs;
        }
        tmp$ret$1 = tmp;
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          unparsedPrimitive(this, 'byte');
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$1;
  };
  protoOf(AbstractJsonTreeDecoder).n5q = function (tag) {
    return this.p69((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  protoOf(AbstractJsonTreeDecoder).q69 = function (tag) {
    var tmp2 = this.l69(tag);
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.primitive' call
      try {
        var result = get_int(tmp2);
        var tmp0_elvis_lhs = (-32768 <= result ? result <= 32767 : false) ? toShort(result) : null;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          unparsedPrimitive(this, 'short');
        } else {
          tmp = tmp0_elvis_lhs;
        }
        tmp$ret$1 = tmp;
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          unparsedPrimitive(this, 'short');
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$1;
  };
  protoOf(AbstractJsonTreeDecoder).o5q = function (tag) {
    return this.q69((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  protoOf(AbstractJsonTreeDecoder).r69 = function (tag) {
    var tmp2 = this.l69(tag);
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.primitive' call
      try {
        var tmp0_elvis_lhs = get_int(tmp2);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          unparsedPrimitive(this, 'int');
        } else {
          tmp = tmp0_elvis_lhs;
        }
        tmp$ret$1 = tmp;
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          unparsedPrimitive(this, 'int');
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$1;
  };
  protoOf(AbstractJsonTreeDecoder).p5q = function (tag) {
    return this.r69((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  protoOf(AbstractJsonTreeDecoder).s69 = function (tag) {
    var tmp2 = this.l69(tag);
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.primitive' call
      try {
        var tmp0_elvis_lhs = get_long(tmp2);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          unparsedPrimitive(this, 'long');
        } else {
          tmp = tmp0_elvis_lhs;
        }
        tmp$ret$1 = tmp;
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          unparsedPrimitive(this, 'long');
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$1;
  };
  protoOf(AbstractJsonTreeDecoder).q5q = function (tag) {
    return this.s69((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  protoOf(AbstractJsonTreeDecoder).t69 = function (tag) {
    var tmp2 = this.l69(tag);
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.primitive' call
      try {
        var tmp0_elvis_lhs = get_float(tmp2);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          unparsedPrimitive(this, 'float');
        } else {
          tmp = tmp0_elvis_lhs;
        }
        tmp$ret$1 = tmp;
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          unparsedPrimitive(this, 'float');
        } else {
          throw $p;
        }
      }
    }
    var result = tmp$ret$1;
    var specialFp = this.f63().k61_1.c63_1;
    if (specialFp || isFinite(result))
      return result;
    throw InvalidFloatingPointDecoded(result, tag, toString_1(currentObject(this)));
  };
  protoOf(AbstractJsonTreeDecoder).r5q = function (tag) {
    return this.t69((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  protoOf(AbstractJsonTreeDecoder).u69 = function (tag) {
    var tmp2 = this.l69(tag);
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.primitive' call
      try {
        var tmp0_elvis_lhs = get_double(tmp2);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          unparsedPrimitive(this, 'double');
        } else {
          tmp = tmp0_elvis_lhs;
        }
        tmp$ret$1 = tmp;
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          unparsedPrimitive(this, 'double');
        } else {
          throw $p;
        }
      }
    }
    var result = tmp$ret$1;
    var specialFp = this.f63().k61_1.c63_1;
    if (specialFp || isFinite_0(result))
      return result;
    throw InvalidFloatingPointDecoded(result, tag, toString_1(currentObject(this)));
  };
  protoOf(AbstractJsonTreeDecoder).s5q = function (tag) {
    return this.u69((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  protoOf(AbstractJsonTreeDecoder).v69 = function (tag) {
    var tmp2 = this.l69(tag);
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.primitive' call
      try {
        var tmp0_elvis_lhs = new Char(single_2(tmp2.h63()));
        var tmp;
        if (tmp0_elvis_lhs == null) {
          unparsedPrimitive(this, 'char');
        } else {
          tmp = tmp0_elvis_lhs;
        }
        tmp$ret$1 = tmp.s1_1;
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          unparsedPrimitive(this, 'char');
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$1;
  };
  protoOf(AbstractJsonTreeDecoder).t5q = function (tag) {
    return this.v69((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  protoOf(AbstractJsonTreeDecoder).w69 = function (tag) {
    var value = this.l69(tag);
    if (!this.f63().k61_1.u62_1) {
      var literal = asLiteral(this, value, 'string');
      if (!literal.o63_1)
        throw JsonDecodingException_0(-1, "String literal for key '" + tag + "' should be quoted.\nUse 'isLenient = true' in 'Json {}` builder to accept non-compliant JSON.", toString_1(currentObject(this)));
    }
    if (value instanceof JsonNull_0)
      throw JsonDecodingException_0(-1, "Unexpected 'null' value instead of string literal", toString_1(currentObject(this)));
    return value.h63();
  };
  protoOf(AbstractJsonTreeDecoder).u5q = function (tag) {
    return this.w69((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  protoOf(AbstractJsonTreeDecoder).x69 = function (tag, inlineDescriptor) {
    return get_isUnsignedNumber(inlineDescriptor) ? new JsonDecoderForUnsignedTypes(new StringJsonLexer_0(this.l69(tag).h63()), this.f63()) : protoOf(NamedValueDecoder).w5q.call(this, tag, inlineDescriptor);
  };
  protoOf(AbstractJsonTreeDecoder).w5q = function (tag, inlineDescriptor) {
    return this.x69((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE(), inlineDescriptor);
  };
  protoOf(AbstractJsonTreeDecoder).e5c = function (descriptor) {
    return !(this.i5q() == null) ? protoOf(NamedValueDecoder).e5c.call(this, descriptor) : (new JsonPrimitiveDecoder(this.f63(), this.a1())).e5c(descriptor);
  };
  function coerceInputValue_0($this, descriptor, index, tag) {
    var tmp0 = $this.f63();
    var tmp2 = descriptor.t5a(index);
    var tmp$ret$1;
    $l$block_2: {
      // Inline function 'kotlinx.serialization.json.internal.tryCoerceValue' call
      var tmp;
      if (!tmp2.i5a()) {
        var tmp_0 = $this.k69(tag);
        tmp = tmp_0 instanceof JsonNull_0;
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$1 = true;
        break $l$block_2;
      }
      if (equals(tmp2.r5a(), ENUM_getInstance())) {
        var tmp_1;
        if (tmp2.i5a()) {
          var tmp_2 = $this.k69(tag);
          tmp_1 = tmp_2 instanceof JsonNull_0;
        } else {
          tmp_1 = false;
        }
        if (tmp_1) {
          tmp$ret$1 = false;
          break $l$block_2;
        }
        var tmp_3 = $this.k69(tag);
        var tmp0_safe_receiver = tmp_3 instanceof JsonPrimitive ? tmp_3 : null;
        var tmp0_elvis_lhs = tmp0_safe_receiver == null ? null : get_contentOrNull(tmp0_safe_receiver);
        var tmp_4;
        if (tmp0_elvis_lhs == null) {
          tmp$ret$1 = false;
          break $l$block_2;
        } else {
          tmp_4 = tmp0_elvis_lhs;
        }
        var enumValue = tmp_4;
        var enumIndex = getJsonNameIndex(tmp2, tmp0, enumValue);
        if (enumIndex === -3) {
          tmp$ret$1 = true;
          break $l$block_2;
        }
      }
      tmp$ret$1 = false;
    }
    return tmp$ret$1;
  }
  function absenceIsNull($this, descriptor, index) {
    $this.h6a_1 = (!$this.f63().k61_1.x62_1 && !descriptor.w5a(index) && descriptor.t5a(index).i5a());
    return $this.h6a_1;
  }
  function JsonTreeDecoder(json, value, polyDiscriminator, polyDescriptor) {
    polyDiscriminator = polyDiscriminator === VOID ? null : polyDiscriminator;
    polyDescriptor = polyDescriptor === VOID ? null : polyDescriptor;
    AbstractJsonTreeDecoder.call(this, json, value);
    this.d6a_1 = value;
    this.e6a_1 = polyDiscriminator;
    this.f6a_1 = polyDescriptor;
    this.g6a_1 = 0;
    this.h6a_1 = false;
  }
  protoOf(JsonTreeDecoder).a1 = function () {
    return this.d6a_1;
  };
  protoOf(JsonTreeDecoder).w5c = function (descriptor) {
    while (this.g6a_1 < descriptor.p5a()) {
      var tmp1 = this.g6a_1;
      this.g6a_1 = tmp1 + 1 | 0;
      var name = this.d5q(descriptor, tmp1);
      var index = this.g6a_1 - 1 | 0;
      this.h6a_1 = false;
      var tmp;
      var tmp_0;
      // Inline function 'kotlin.collections.contains' call
      // Inline function 'kotlin.collections.containsKey' call
      var this_0 = this.a1();
      if ((isInterface(this_0, KtMap) ? this_0 : THROW_CCE()).o2(name)) {
        tmp_0 = true;
      } else {
        tmp_0 = absenceIsNull(this, descriptor, index);
      }
      if (tmp_0) {
        tmp = !this.j69_1.z62_1 || !coerceInputValue_0(this, descriptor, index, name);
      } else {
        tmp = false;
      }
      if (tmp) {
        return index;
      }
    }
    return -1;
  };
  protoOf(JsonTreeDecoder).s5b = function () {
    return !this.h6a_1 && protoOf(AbstractJsonTreeDecoder).s5b.call(this);
  };
  protoOf(JsonTreeDecoder).e5q = function (descriptor, index) {
    var strategy = namingStrategy(descriptor, this.f63());
    var baseName = descriptor.v5a(index);
    if (strategy == null) {
      if (!this.j69_1.d63_1)
        return baseName;
      if (this.a1().r2().t(baseName))
        return baseName;
    }
    var deserializationNamesMap_0 = deserializationNamesMap(this.f63(), descriptor);
    // Inline function 'kotlin.collections.find' call
    var tmp0 = this.a1().r2();
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var _iterator__ex2g4s = tmp0.m();
      while (_iterator__ex2g4s.n()) {
        var element = _iterator__ex2g4s.o();
        if (deserializationNamesMap_0.q2(element) === index) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    var tmp0_safe_receiver = tmp$ret$1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      return tmp0_safe_receiver;
    }
    var fallbackName = strategy == null ? null : strategy.c66(descriptor, index, baseName);
    return fallbackName == null ? baseName : fallbackName;
  };
  protoOf(JsonTreeDecoder).k69 = function (tag) {
    return getValue_0(this.a1(), tag);
  };
  protoOf(JsonTreeDecoder).g5c = function (descriptor) {
    if (descriptor === this.f6a_1)
      return this;
    return protoOf(AbstractJsonTreeDecoder).g5c.call(this, descriptor);
  };
  protoOf(JsonTreeDecoder).h5c = function (descriptor) {
    var tmp;
    if (this.j69_1.t62_1) {
      tmp = true;
    } else {
      var tmp_0 = descriptor.r5a();
      tmp = tmp_0 instanceof PolymorphicKind;
    }
    if (tmp)
      return Unit_instance;
    var strategy = namingStrategy(descriptor, this.f63());
    var tmp_1;
    if (strategy == null && !this.j69_1.d63_1) {
      tmp_1 = jsonCachedSerialNames(descriptor);
    } else if (!(strategy == null)) {
      tmp_1 = deserializationNamesMap(this.f63(), descriptor).r2();
    } else {
      var tmp_2 = jsonCachedSerialNames(descriptor);
      var tmp0_safe_receiver = get_schemaCache(this.f63()).k68(descriptor, get_JsonDeserializationNamesKey());
      // Inline function 'kotlin.collections.orEmpty' call
      var tmp0_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.r2();
      var tmp$ret$0 = tmp0_elvis_lhs == null ? emptySet() : tmp0_elvis_lhs;
      tmp_1 = plus_10(tmp_2, tmp$ret$0);
    }
    var names = tmp_1;
    var tmp1_iterator = this.a1().r2().m();
    while (tmp1_iterator.n()) {
      var key = tmp1_iterator.o();
      if (!names.t(key) && !(key === this.e6a_1)) {
        throw UnknownKeyException(key, this.a1().toString());
      }
    }
  };
  function JsonTreeListDecoder(json, value) {
    AbstractJsonTreeDecoder.call(this, json, value);
    this.n6a_1 = value;
    this.o6a_1 = this.n6a_1.p();
    this.p6a_1 = -1;
  }
  protoOf(JsonTreeListDecoder).a1 = function () {
    return this.n6a_1;
  };
  protoOf(JsonTreeListDecoder).e5q = function (descriptor, index) {
    return index.toString();
  };
  protoOf(JsonTreeListDecoder).k69 = function (tag) {
    return this.n6a_1.r(toInt(tag));
  };
  protoOf(JsonTreeListDecoder).w5c = function (descriptor) {
    while (this.p6a_1 < (this.o6a_1 - 1 | 0)) {
      this.p6a_1 = this.p6a_1 + 1 | 0;
      return this.p6a_1;
    }
    return -1;
  };
  function JsonPrimitiveDecoder(json, value) {
    AbstractJsonTreeDecoder.call(this, json, value);
    this.v6a_1 = value;
    this.x5q('primitive');
  }
  protoOf(JsonPrimitiveDecoder).a1 = function () {
    return this.v6a_1;
  };
  protoOf(JsonPrimitiveDecoder).w5c = function (descriptor) {
    return 0;
  };
  protoOf(JsonPrimitiveDecoder).k69 = function (tag) {
    // Inline function 'kotlin.require' call
    if (!(tag === 'primitive')) {
      var message = "This input can only handle primitives with 'primitive' tag";
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    return this.v6a_1;
  };
  function JsonTreeMapDecoder(json, value) {
    JsonTreeDecoder.call(this, json, value);
    this.g6b_1 = value;
    this.h6b_1 = toList_0(this.g6b_1.r2());
    this.i6b_1 = imul(this.h6b_1.p(), 2);
    this.j6b_1 = -1;
  }
  protoOf(JsonTreeMapDecoder).a1 = function () {
    return this.g6b_1;
  };
  protoOf(JsonTreeMapDecoder).e5q = function (descriptor, index) {
    var i = index / 2 | 0;
    return this.h6b_1.r(i);
  };
  protoOf(JsonTreeMapDecoder).w5c = function (descriptor) {
    while (this.j6b_1 < (this.i6b_1 - 1 | 0)) {
      this.j6b_1 = this.j6b_1 + 1 | 0;
      return this.j6b_1;
    }
    return -1;
  };
  protoOf(JsonTreeMapDecoder).k69 = function (tag) {
    return (this.j6b_1 % 2 | 0) === 0 ? JsonPrimitive_0(tag) : getValue_0(this.g6b_1, tag);
  };
  protoOf(JsonTreeMapDecoder).h5c = function (descriptor) {
  };
  function readPolymorphicJson(_this__u8e3s4, discriminator, element, deserializer) {
    return (new JsonTreeDecoder(_this__u8e3s4, element, discriminator, deserializer.v58())).k59(deserializer);
  }
  function writeJson(_this__u8e3s4, value, serializer) {
    var result = {_v: null};
    var encoder = new JsonTreeEncoder(_this__u8e3s4, writeJson$lambda(result));
    encoder.h59(serializer, value);
    var tmp;
    if (result._v == null) {
      throwUninitializedPropertyAccessException('result');
    } else {
      tmp = result._v;
    }
    return tmp;
  }
  function JsonTreeEncoder(json, nodeConsumer) {
    AbstractJsonTreeEncoder.call(this, json, nodeConsumer);
    var tmp = this;
    // Inline function 'kotlin.collections.linkedMapOf' call
    tmp.u6b_1 = LinkedHashMap_init_$Create$();
  }
  protoOf(JsonTreeEncoder).v6b = function (key, element) {
    // Inline function 'kotlin.collections.set' call
    this.u6b_1.t2(key, element);
  };
  protoOf(JsonTreeEncoder).x5d = function (descriptor, index, serializer, value) {
    if (!(value == null) || this.n6b_1.x62_1) {
      protoOf(AbstractJsonTreeEncoder).x5d.call(this, descriptor, index, serializer, value);
    }
  };
  protoOf(JsonTreeEncoder).w6b = function () {
    return new JsonObject_0(this.u6b_1);
  };
  function inlineUnsignedNumberEncoder($this, tag) {
    return new AbstractJsonTreeEncoder$inlineUnsignedNumberEncoder$1($this, tag);
  }
  function inlineUnquotedLiteralEncoder($this, tag, inlineDescriptor) {
    return new AbstractJsonTreeEncoder$inlineUnquotedLiteralEncoder$1($this, tag, inlineDescriptor);
  }
  function AbstractJsonTreeEncoder$inlineUnsignedNumberEncoder$1(this$0, $tag) {
    this.l6c_1 = this$0;
    this.m6c_1 = $tag;
    AbstractEncoder.call(this);
    this.k6c_1 = this$0.l6b_1.g59();
  }
  protoOf(AbstractJsonTreeEncoder$inlineUnsignedNumberEncoder$1).g59 = function () {
    return this.k6c_1;
  };
  protoOf(AbstractJsonTreeEncoder$inlineUnsignedNumberEncoder$1).n6c = function (s) {
    return this.l6c_1.v6b(this.m6c_1, new JsonLiteral(s, false));
  };
  protoOf(AbstractJsonTreeEncoder$inlineUnsignedNumberEncoder$1).e5d = function (value) {
    // Inline function 'kotlin.toUInt' call
    var tmp$ret$0 = _UInt___init__impl__l7qpdl(value);
    return this.n6c(UInt__toString_impl_dbgl21(tmp$ret$0));
  };
  protoOf(AbstractJsonTreeEncoder$inlineUnsignedNumberEncoder$1).f5d = function (value) {
    // Inline function 'kotlin.toULong' call
    var tmp$ret$0 = _ULong___init__impl__c78o9k(value);
    return this.n6c(ULong__toString_impl_f9au7k(tmp$ret$0));
  };
  protoOf(AbstractJsonTreeEncoder$inlineUnsignedNumberEncoder$1).c5d = function (value) {
    // Inline function 'kotlin.toUByte' call
    var tmp$ret$0 = _UByte___init__impl__g9hnc4(value);
    return this.n6c(UByte__toString_impl_v72jg(tmp$ret$0));
  };
  protoOf(AbstractJsonTreeEncoder$inlineUnsignedNumberEncoder$1).d5d = function (value) {
    // Inline function 'kotlin.toUShort' call
    var tmp$ret$0 = _UShort___init__impl__jigrne(value);
    return this.n6c(UShort__toString_impl_edaoee(tmp$ret$0));
  };
  function AbstractJsonTreeEncoder$inlineUnquotedLiteralEncoder$1(this$0, $tag, $inlineDescriptor) {
    this.o6c_1 = this$0;
    this.p6c_1 = $tag;
    this.q6c_1 = $inlineDescriptor;
    AbstractEncoder.call(this);
  }
  protoOf(AbstractJsonTreeEncoder$inlineUnquotedLiteralEncoder$1).g59 = function () {
    return this.o6c_1.l6b_1.g59();
  };
  protoOf(AbstractJsonTreeEncoder$inlineUnquotedLiteralEncoder$1).j5d = function (value) {
    return this.o6c_1.v6b(this.p6c_1, new JsonLiteral(value, false, this.q6c_1));
  };
  function AbstractJsonTreeEncoder$beginStructure$lambda(this$0) {
    return function (node) {
      this$0.v6b(this$0.q5r(), node);
      return Unit_instance;
    };
  }
  function AbstractJsonTreeEncoder(json, nodeConsumer) {
    NamedValueEncoder.call(this);
    this.l6b_1 = json;
    this.m6b_1 = nodeConsumer;
    this.n6b_1 = this.l6b_1.k61_1;
    this.o6b_1 = null;
  }
  protoOf(AbstractJsonTreeEncoder).f63 = function () {
    return this.l6b_1;
  };
  protoOf(AbstractJsonTreeEncoder).g59 = function () {
    return this.l6b_1.g59();
  };
  protoOf(AbstractJsonTreeEncoder).e5q = function (descriptor, index) {
    return getJsonElementName(descriptor, this.l6b_1, index);
  };
  protoOf(AbstractJsonTreeEncoder).b5e = function (descriptor, index) {
    return this.n6b_1.s62_1;
  };
  protoOf(AbstractJsonTreeEncoder).j5q = function (parentName, childName) {
    return childName;
  };
  protoOf(AbstractJsonTreeEncoder).z5d = function () {
  };
  protoOf(AbstractJsonTreeEncoder).a5d = function () {
    var tmp0_elvis_lhs = this.i5q();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return this.m6b_1(JsonNull_getInstance());
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var tag = tmp;
    this.x6b(tag);
  };
  protoOf(AbstractJsonTreeEncoder).x6b = function (tag) {
    return this.v6b(tag, JsonNull_getInstance());
  };
  protoOf(AbstractJsonTreeEncoder).d5r = function (tag) {
    return this.x6b((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  protoOf(AbstractJsonTreeEncoder).y6b = function (tag, value) {
    return this.v6b(tag, JsonPrimitive_1(value));
  };
  protoOf(AbstractJsonTreeEncoder).e5r = function (tag, value) {
    return this.y6b((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE(), value);
  };
  protoOf(AbstractJsonTreeEncoder).z6b = function (tag, value) {
    return this.v6b(tag, JsonPrimitive_1(value));
  };
  protoOf(AbstractJsonTreeEncoder).f5r = function (tag, value) {
    return this.z6b((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE(), value);
  };
  protoOf(AbstractJsonTreeEncoder).a6c = function (tag, value) {
    return this.v6b(tag, JsonPrimitive_1(value));
  };
  protoOf(AbstractJsonTreeEncoder).g5r = function (tag, value) {
    return this.a6c((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE(), value);
  };
  protoOf(AbstractJsonTreeEncoder).b6c = function (tag, value) {
    return this.v6b(tag, JsonPrimitive_1(value));
  };
  protoOf(AbstractJsonTreeEncoder).h5r = function (tag, value) {
    return this.b6c((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE(), value);
  };
  protoOf(AbstractJsonTreeEncoder).c6c = function (tag, value) {
    this.v6b(tag, JsonPrimitive_1(value));
    if (!this.n6b_1.c63_1 && !isFinite(value)) {
      throw InvalidFloatingPointEncoded_0(value, tag, toString_1(this.w6b()));
    }
  };
  protoOf(AbstractJsonTreeEncoder).i5r = function (tag, value) {
    return this.c6c((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE(), value);
  };
  protoOf(AbstractJsonTreeEncoder).h59 = function (serializer, value) {
    if (!(this.i5q() == null) || !get_requiresTopLevelTag(carrierDescriptor(serializer.v58(), this.g59()))) {
      $l$block: {
        // Inline function 'kotlinx.serialization.json.internal.encodePolymorphically' call
        var tmp;
        if (!(serializer instanceof AbstractPolymorphicSerializer)) {
          tmp = true;
        } else {
          tmp = this.f63().k61_1.a63_1;
        }
        if (tmp) {
          serializer.i59(this, value);
          break $l$block;
        }
        var casted = serializer instanceof AbstractPolymorphicSerializer ? serializer : THROW_CCE();
        var baseClassDiscriminator = classDiscriminator(serializer.v58(), this.f63());
        var actualSerializer = findPolymorphicSerializer(casted, this, !(value == null) ? value : THROW_CCE());
        access$validateIfSealed$tPolymorphicKt(casted, actualSerializer, baseClassDiscriminator);
        checkKind(actualSerializer.v58().r5a());
        this.o6b_1 = baseClassDiscriminator;
        actualSerializer.i59(this, value);
      }
    } else {
      // Inline function 'kotlin.apply' call
      (new JsonPrimitiveEncoder(this.l6b_1, this.m6b_1)).h59(serializer, value);
    }
  };
  protoOf(AbstractJsonTreeEncoder).d6c = function (tag, value) {
    this.v6b(tag, JsonPrimitive_1(value));
    if (!this.n6b_1.c63_1 && !isFinite_0(value)) {
      throw InvalidFloatingPointEncoded_0(value, tag, toString_1(this.w6b()));
    }
  };
  protoOf(AbstractJsonTreeEncoder).j5r = function (tag, value) {
    return this.d6c((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE(), value);
  };
  protoOf(AbstractJsonTreeEncoder).e6c = function (tag, value) {
    return this.v6b(tag, JsonPrimitive_2(value));
  };
  protoOf(AbstractJsonTreeEncoder).k5r = function (tag, value) {
    return this.e6c((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE(), value);
  };
  protoOf(AbstractJsonTreeEncoder).f6c = function (tag, value) {
    return this.v6b(tag, JsonPrimitive_0(toString(value)));
  };
  protoOf(AbstractJsonTreeEncoder).l5r = function (tag, value) {
    return this.f6c((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE(), value);
  };
  protoOf(AbstractJsonTreeEncoder).g6c = function (tag, value) {
    return this.v6b(tag, JsonPrimitive_0(value));
  };
  protoOf(AbstractJsonTreeEncoder).m5r = function (tag, value) {
    return this.g6c((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE(), value);
  };
  protoOf(AbstractJsonTreeEncoder).h6c = function (tag, enumDescriptor, ordinal) {
    return this.v6b(tag, JsonPrimitive_0(enumDescriptor.v5a(ordinal)));
  };
  protoOf(AbstractJsonTreeEncoder).n5r = function (tag, enumDescriptor, ordinal) {
    return this.h6c((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE(), enumDescriptor, ordinal);
  };
  protoOf(AbstractJsonTreeEncoder).i6c = function (tag, value) {
    this.v6b(tag, JsonPrimitive_0(toString_1(value)));
  };
  protoOf(AbstractJsonTreeEncoder).b5r = function (tag, value) {
    return this.i6c((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE(), value);
  };
  protoOf(AbstractJsonTreeEncoder).j6c = function (tag, inlineDescriptor) {
    return get_isUnsignedNumber(inlineDescriptor) ? inlineUnsignedNumberEncoder(this, tag) : get_isUnquotedLiteral(inlineDescriptor) ? inlineUnquotedLiteralEncoder(this, tag, inlineDescriptor) : protoOf(NamedValueEncoder).o5r.call(this, tag, inlineDescriptor);
  };
  protoOf(AbstractJsonTreeEncoder).o5r = function (tag, inlineDescriptor) {
    return this.j6c((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE(), inlineDescriptor);
  };
  protoOf(AbstractJsonTreeEncoder).l5d = function (descriptor) {
    return !(this.i5q() == null) ? protoOf(NamedValueEncoder).l5d.call(this, descriptor) : (new JsonPrimitiveEncoder(this.l6b_1, this.m6b_1)).l5d(descriptor);
  };
  protoOf(AbstractJsonTreeEncoder).g5c = function (descriptor) {
    var tmp;
    if (this.i5q() == null) {
      tmp = this.m6b_1;
    } else {
      tmp = AbstractJsonTreeEncoder$beginStructure$lambda(this);
    }
    var consumer = tmp;
    var tmp0_subject = descriptor.r5a();
    var tmp_0;
    var tmp_1;
    if (equals(tmp0_subject, LIST_getInstance())) {
      tmp_1 = true;
    } else {
      tmp_1 = tmp0_subject instanceof PolymorphicKind;
    }
    if (tmp_1) {
      tmp_0 = new JsonTreeListEncoder(this.l6b_1, consumer);
    } else {
      if (equals(tmp0_subject, MAP_getInstance())) {
        // Inline function 'kotlinx.serialization.json.internal.selectMapMode' call
        var this_0 = this.l6b_1;
        var keyDescriptor = carrierDescriptor(descriptor.t5a(0), this_0.g59());
        var keyKind = keyDescriptor.r5a();
        var tmp_2;
        var tmp_3;
        if (keyKind instanceof PrimitiveKind) {
          tmp_3 = true;
        } else {
          tmp_3 = equals(keyKind, ENUM_getInstance());
        }
        if (tmp_3) {
          tmp_2 = new JsonTreeMapEncoder(this.l6b_1, consumer);
        } else {
          if (this_0.k61_1.v62_1) {
            tmp_2 = new JsonTreeListEncoder(this.l6b_1, consumer);
          } else {
            throw InvalidKeyKindException(keyDescriptor);
          }
        }
        tmp_0 = tmp_2;
      } else {
        tmp_0 = new JsonTreeEncoder(this.l6b_1, consumer);
      }
    }
    var encoder = tmp_0;
    if (!(this.o6b_1 == null)) {
      encoder.v6b(ensureNotNull(this.o6b_1), JsonPrimitive_0(descriptor.z59()));
      this.o6b_1 = null;
    }
    return encoder;
  };
  protoOf(AbstractJsonTreeEncoder).p5r = function (descriptor) {
    this.m6b_1(this.w6b());
  };
  function get_requiresTopLevelTag(_this__u8e3s4) {
    var tmp;
    var tmp_0 = _this__u8e3s4.r5a();
    if (tmp_0 instanceof PrimitiveKind) {
      tmp = true;
    } else {
      tmp = _this__u8e3s4.r5a() === ENUM_getInstance();
    }
    return tmp;
  }
  function JsonPrimitiveEncoder(json, nodeConsumer) {
    AbstractJsonTreeEncoder.call(this, json, nodeConsumer);
    this.w6c_1 = null;
    this.x5q('primitive');
  }
  protoOf(JsonPrimitiveEncoder).v6b = function (key, element) {
    // Inline function 'kotlin.require' call
    if (!(key === 'primitive')) {
      var message = "This output can only consume primitives with 'primitive' tag";
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    // Inline function 'kotlin.require' call
    if (!(this.w6c_1 == null)) {
      var message_0 = 'Primitive element was already recorded. Does call to .encodeXxx happen more than once?';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message_0));
    }
    this.w6c_1 = element;
    this.m6b_1(element);
  };
  protoOf(JsonPrimitiveEncoder).w6b = function () {
    var tmp0 = this.w6c_1;
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.requireNotNull' call
      if (tmp0 == null) {
        var message = 'Primitive element has not been recorded. Is call to .encodeXxx is missing in serializer?';
        throw IllegalArgumentException_init_$Create$_0(toString_1(message));
      } else {
        tmp$ret$1 = tmp0;
        break $l$block;
      }
    }
    return tmp$ret$1;
  };
  function JsonTreeListEncoder(json, nodeConsumer) {
    AbstractJsonTreeEncoder.call(this, json, nodeConsumer);
    var tmp = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.c6d_1 = ArrayList_init_$Create$();
  }
  protoOf(JsonTreeListEncoder).e5q = function (descriptor, index) {
    return index.toString();
  };
  protoOf(JsonTreeListEncoder).v6b = function (key, element) {
    var idx = toInt(key);
    this.c6d_1.m2(idx, element);
  };
  protoOf(JsonTreeListEncoder).w6b = function () {
    return new JsonArray_0(this.c6d_1);
  };
  function _get_tag__e6h4qf($this) {
    var tmp = $this.j6d_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('tag');
    }
  }
  function JsonTreeMapEncoder(json, nodeConsumer) {
    JsonTreeEncoder.call(this, json, nodeConsumer);
    this.k6d_1 = true;
  }
  protoOf(JsonTreeMapEncoder).v6b = function (key, element) {
    if (this.k6d_1) {
      var tmp = this;
      var tmp_0;
      if (element instanceof JsonPrimitive) {
        tmp_0 = element.h63();
      } else {
        if (element instanceof JsonObject_0) {
          throw InvalidKeyKindException(JsonObjectSerializer_getInstance().d64_1);
        } else {
          if (element instanceof JsonArray_0) {
            throw InvalidKeyKindException(JsonArraySerializer_getInstance().e64_1);
          } else {
            noWhenBranchMatchedException();
          }
        }
      }
      tmp.j6d_1 = tmp_0;
      this.k6d_1 = false;
    } else {
      var tmp0 = this.u6b_1;
      // Inline function 'kotlin.collections.set' call
      var key_0 = _get_tag__e6h4qf(this);
      tmp0.t2(key_0, element);
      this.k6d_1 = true;
    }
  };
  protoOf(JsonTreeMapEncoder).w6b = function () {
    return new JsonObject_0(this.u6b_1);
  };
  function writeJson$lambda($result) {
    return function (it) {
      $result._v = it;
      return Unit_instance;
    };
  }
  var WriteMode_OBJ_instance;
  var WriteMode_LIST_instance;
  var WriteMode_MAP_instance;
  var WriteMode_POLY_OBJ_instance;
  function values_3() {
    return [WriteMode_OBJ_getInstance(), WriteMode_LIST_getInstance(), WriteMode_MAP_getInstance(), WriteMode_POLY_OBJ_getInstance()];
  }
  var WriteMode_entriesInitialized;
  function WriteMode_initEntries() {
    if (WriteMode_entriesInitialized)
      return Unit_instance;
    WriteMode_entriesInitialized = true;
    WriteMode_OBJ_instance = new WriteMode('OBJ', 0, _Char___init__impl__6a9atx(123), _Char___init__impl__6a9atx(125));
    WriteMode_LIST_instance = new WriteMode('LIST', 1, _Char___init__impl__6a9atx(91), _Char___init__impl__6a9atx(93));
    WriteMode_MAP_instance = new WriteMode('MAP', 2, _Char___init__impl__6a9atx(123), _Char___init__impl__6a9atx(125));
    WriteMode_POLY_OBJ_instance = new WriteMode('POLY_OBJ', 3, _Char___init__impl__6a9atx(91), _Char___init__impl__6a9atx(93));
  }
  function WriteMode(name, ordinal, begin, end) {
    Enum.call(this, name, ordinal);
    this.x68_1 = begin;
    this.y68_1 = end;
  }
  function switchMode(_this__u8e3s4, desc) {
    var tmp0_subject = desc.r5a();
    var tmp;
    if (tmp0_subject instanceof PolymorphicKind) {
      tmp = WriteMode_POLY_OBJ_getInstance();
    } else {
      if (equals(tmp0_subject, LIST_getInstance())) {
        tmp = WriteMode_LIST_getInstance();
      } else {
        if (equals(tmp0_subject, MAP_getInstance())) {
          // Inline function 'kotlinx.serialization.json.internal.selectMapMode' call
          var keyDescriptor = carrierDescriptor(desc.t5a(0), _this__u8e3s4.g59());
          var keyKind = keyDescriptor.r5a();
          var tmp_0;
          var tmp_1;
          if (keyKind instanceof PrimitiveKind) {
            tmp_1 = true;
          } else {
            tmp_1 = equals(keyKind, ENUM_getInstance());
          }
          if (tmp_1) {
            tmp_0 = WriteMode_MAP_getInstance();
          } else {
            if (_this__u8e3s4.k61_1.v62_1) {
              tmp_0 = WriteMode_LIST_getInstance();
            } else {
              throw InvalidKeyKindException(keyDescriptor);
            }
          }
          tmp = tmp_0;
        } else {
          tmp = WriteMode_OBJ_getInstance();
        }
      }
    }
    return tmp;
  }
  function carrierDescriptor(_this__u8e3s4, module_0) {
    var tmp;
    if (equals(_this__u8e3s4.r5a(), CONTEXTUAL_getInstance())) {
      var tmp0_safe_receiver = getContextualDescriptor(module_0, _this__u8e3s4);
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : carrierDescriptor(tmp0_safe_receiver, module_0);
      tmp = tmp1_elvis_lhs == null ? _this__u8e3s4 : tmp1_elvis_lhs;
    } else if (_this__u8e3s4.q5a()) {
      tmp = carrierDescriptor(_this__u8e3s4.t5a(0), module_0);
    } else {
      tmp = _this__u8e3s4;
    }
    return tmp;
  }
  function WriteMode_OBJ_getInstance() {
    WriteMode_initEntries();
    return WriteMode_OBJ_instance;
  }
  function WriteMode_LIST_getInstance() {
    WriteMode_initEntries();
    return WriteMode_LIST_instance;
  }
  function WriteMode_MAP_getInstance() {
    WriteMode_initEntries();
    return WriteMode_MAP_instance;
  }
  function WriteMode_POLY_OBJ_getInstance() {
    WriteMode_initEntries();
    return WriteMode_POLY_OBJ_instance;
  }
  function appendEscape($this, lastPosition, current) {
    $this.l6d(lastPosition, current);
    return appendEsc($this, current + 1 | 0);
  }
  function decodedString($this, lastPosition, currentPosition) {
    $this.l6d(lastPosition, currentPosition);
    var result = $this.b62_1.toString();
    $this.b62_1.kc(0);
    return result;
  }
  function takePeeked($this) {
    // Inline function 'kotlin.also' call
    var this_0 = ensureNotNull($this.a62_1);
    $this.a62_1 = null;
    return this_0;
  }
  function wasUnquotedString($this) {
    return !(charSequenceGet($this.m6d(), $this.y61_1 - 1 | 0) === _Char___init__impl__6a9atx(34));
  }
  function appendEsc($this, startPosition) {
    var currentPosition = startPosition;
    currentPosition = $this.n6d(currentPosition);
    if (currentPosition === -1) {
      $this.y65('Expected escape sequence to continue, got EOF');
    }
    var tmp = $this.m6d();
    var tmp0 = currentPosition;
    currentPosition = tmp0 + 1 | 0;
    var currentChar = charSequenceGet(tmp, tmp0);
    if (currentChar === _Char___init__impl__6a9atx(117)) {
      return appendHex($this, $this.m6d(), currentPosition);
    }
    // Inline function 'kotlin.code' call
    var tmp$ret$0 = Char__toInt_impl_vasixd(currentChar);
    var c = escapeToChar(tmp$ret$0);
    if (c === _Char___init__impl__6a9atx(0)) {
      $this.y65("Invalid escaped char '" + toString(currentChar) + "'");
    }
    $this.b62_1.k8(c);
    return currentPosition;
  }
  function appendHex($this, source, startPos) {
    if ((startPos + 4 | 0) >= charSequenceLength(source)) {
      $this.y61_1 = startPos;
      $this.o6d();
      if (($this.y61_1 + 4 | 0) >= charSequenceLength(source)) {
        $this.y65('Unexpected EOF during unicode escape');
      }
      return appendHex($this, source, $this.y61_1);
    }
    $this.b62_1.k8(numberToChar((((fromHexChar($this, source, startPos) << 12) + (fromHexChar($this, source, startPos + 1 | 0) << 8) | 0) + (fromHexChar($this, source, startPos + 2 | 0) << 4) | 0) + fromHexChar($this, source, startPos + 3 | 0) | 0));
    return startPos + 4 | 0;
  }
  function fromHexChar($this, source, currentPosition) {
    var character = charSequenceGet(source, currentPosition);
    var tmp;
    if (_Char___init__impl__6a9atx(48) <= character ? character <= _Char___init__impl__6a9atx(57) : false) {
      // Inline function 'kotlin.code' call
      var tmp_0 = Char__toInt_impl_vasixd(character);
      // Inline function 'kotlin.code' call
      var this_0 = _Char___init__impl__6a9atx(48);
      tmp = tmp_0 - Char__toInt_impl_vasixd(this_0) | 0;
    } else if (_Char___init__impl__6a9atx(97) <= character ? character <= _Char___init__impl__6a9atx(102) : false) {
      // Inline function 'kotlin.code' call
      var tmp_1 = Char__toInt_impl_vasixd(character);
      // Inline function 'kotlin.code' call
      var this_1 = _Char___init__impl__6a9atx(97);
      tmp = (tmp_1 - Char__toInt_impl_vasixd(this_1) | 0) + 10 | 0;
    } else if (_Char___init__impl__6a9atx(65) <= character ? character <= _Char___init__impl__6a9atx(70) : false) {
      // Inline function 'kotlin.code' call
      var tmp_2 = Char__toInt_impl_vasixd(character);
      // Inline function 'kotlin.code' call
      var this_2 = _Char___init__impl__6a9atx(65);
      tmp = (tmp_2 - Char__toInt_impl_vasixd(this_2) | 0) + 10 | 0;
    } else {
      $this.y65("Invalid toHexChar char '" + toString(character) + "' in unicode escape");
    }
    return tmp;
  }
  function consumeBoolean2($this, start) {
    var current = $this.n6d(start);
    if (current >= charSequenceLength($this.m6d()) || current === -1) {
      $this.y65('EOF');
    }
    var tmp = $this.m6d();
    var tmp0 = current;
    current = tmp0 + 1 | 0;
    // Inline function 'kotlin.code' call
    var this_0 = charSequenceGet(tmp, tmp0);
    var tmp1_subject = Char__toInt_impl_vasixd(this_0) | 32;
    var tmp_0;
    // Inline function 'kotlin.code' call
    var this_1 = _Char___init__impl__6a9atx(116);
    if (tmp1_subject === Char__toInt_impl_vasixd(this_1)) {
      consumeBooleanLiteral($this, 'rue', current);
      tmp_0 = true;
    } else {
      // Inline function 'kotlin.code' call
      var this_2 = _Char___init__impl__6a9atx(102);
      if (tmp1_subject === Char__toInt_impl_vasixd(this_2)) {
        consumeBooleanLiteral($this, 'alse', current);
        tmp_0 = false;
      } else {
        $this.y65("Expected valid boolean literal prefix, but had '" + $this.b67() + "'");
      }
    }
    return tmp_0;
  }
  function consumeBooleanLiteral($this, literalSuffix, current) {
    if ((charSequenceLength($this.m6d()) - current | 0) < literalSuffix.length) {
      $this.y65('Unexpected end of boolean literal');
    }
    var inductionVariable = 0;
    var last = charSequenceLength(literalSuffix) - 1 | 0;
    if (inductionVariable <= last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var expected = charCodeAt(literalSuffix, i);
        var actual = charSequenceGet($this.m6d(), current + i | 0);
        // Inline function 'kotlin.code' call
        var tmp = Char__toInt_impl_vasixd(expected);
        // Inline function 'kotlin.code' call
        if (!(tmp === (Char__toInt_impl_vasixd(actual) | 32))) {
          $this.y65("Expected valid boolean literal prefix, but had '" + $this.b67() + "'");
        }
      }
       while (inductionVariable <= last);
    $this.y61_1 = current + literalSuffix.length | 0;
  }
  function AbstractJsonLexer() {
    this.y61_1 = 0;
    this.z61_1 = new JsonPath();
    this.a62_1 = null;
    this.b62_1 = StringBuilder_init_$Create$_1();
  }
  protoOf(AbstractJsonLexer).o6d = function () {
  };
  protoOf(AbstractJsonLexer).p6d = function (c) {
    return (((c === _Char___init__impl__6a9atx(125) ? true : c === _Char___init__impl__6a9atx(93)) ? true : c === _Char___init__impl__6a9atx(58)) ? true : c === _Char___init__impl__6a9atx(44)) ? false : true;
  };
  protoOf(AbstractJsonLexer).c62 = function () {
    var nextToken = this.d67();
    if (!(nextToken === 10)) {
      this.y65('Expected EOF after parsing, but had ' + toString(charSequenceGet(this.m6d(), this.y61_1 - 1 | 0)) + ' instead');
    }
  };
  protoOf(AbstractJsonLexer).x66 = function (expected) {
    var token = this.d67();
    if (!(token === expected)) {
      this.q6d(expected);
    }
    return token;
  };
  protoOf(AbstractJsonLexer).m68 = function (expected) {
    this.o6d();
    var source = this.m6d();
    var cpos = this.y61_1;
    $l$loop_0: while (true) {
      cpos = this.n6d(cpos);
      if (cpos === -1)
        break $l$loop_0;
      var tmp0 = cpos;
      cpos = tmp0 + 1 | 0;
      var c = charSequenceGet(source, tmp0);
      if (c === _Char___init__impl__6a9atx(32) || c === _Char___init__impl__6a9atx(10) || c === _Char___init__impl__6a9atx(13) || c === _Char___init__impl__6a9atx(9))
        continue $l$loop_0;
      this.y61_1 = cpos;
      if (c === expected)
        return Unit_instance;
      this.r6d(expected);
    }
    this.y61_1 = cpos;
    this.r6d(expected);
  };
  protoOf(AbstractJsonLexer).r6d = function (expected) {
    this.y61_1 = this.y61_1 - 1 | 0;
    if (this.y61_1 >= 0 && expected === _Char___init__impl__6a9atx(34) && this.b67() === 'null') {
      this.s6d("Expected string literal but 'null' literal was found", this.y61_1 - 4 | 0, "Use 'coerceInputValues = true' in 'Json {}` builder to coerce nulls to default values.");
    }
    this.q6d(charToTokenClass(expected));
  };
  protoOf(AbstractJsonLexer).q6d = function (expectedToken) {
    var expected = expectedToken === 1 ? "quotation mark '\"'" : expectedToken === 4 ? "comma ','" : expectedToken === 5 ? "colon ':'" : expectedToken === 6 ? "start of the object '{'" : expectedToken === 7 ? "end of the object '}'" : expectedToken === 8 ? "start of the array '['" : expectedToken === 9 ? "end of the array ']'" : 'valid token';
    var s = this.y61_1 === charSequenceLength(this.m6d()) || this.y61_1 <= 0 ? 'EOF' : toString(charSequenceGet(this.m6d(), this.y61_1 - 1 | 0));
    this.y65('Expected ' + expected + ", but had '" + s + "' instead", this.y61_1 - 1 | 0);
  };
  protoOf(AbstractJsonLexer).y66 = function () {
    var source = this.m6d();
    var cpos = this.y61_1;
    $l$loop_0: while (true) {
      cpos = this.n6d(cpos);
      if (cpos === -1)
        break $l$loop_0;
      var ch = charSequenceGet(source, cpos);
      if (ch === _Char___init__impl__6a9atx(32) || ch === _Char___init__impl__6a9atx(10) || ch === _Char___init__impl__6a9atx(13) || ch === _Char___init__impl__6a9atx(9)) {
        cpos = cpos + 1 | 0;
        continue $l$loop_0;
      }
      this.y61_1 = cpos;
      return charToTokenClass(ch);
    }
    this.y61_1 = cpos;
    return 10;
  };
  protoOf(AbstractJsonLexer).o68 = function (doConsume) {
    var current = this.t6d();
    current = this.n6d(current);
    var len = charSequenceLength(this.m6d()) - current | 0;
    if (len < 4 || current === -1)
      return false;
    var inductionVariable = 0;
    if (inductionVariable <= 3)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!(charCodeAt('null', i) === charSequenceGet(this.m6d(), current + i | 0)))
          return false;
      }
       while (inductionVariable <= 3);
    if (len > 4 && charToTokenClass(charSequenceGet(this.m6d(), current + 4 | 0)) === 0)
      return false;
    if (doConsume) {
      this.y61_1 = current + 4 | 0;
    }
    return true;
  };
  protoOf(AbstractJsonLexer).z68 = function (doConsume, $super) {
    doConsume = doConsume === VOID ? true : doConsume;
    return $super === VOID ? this.o68(doConsume) : $super.o68.call(this, doConsume);
  };
  protoOf(AbstractJsonLexer).t6d = function () {
    var current = this.y61_1;
    $l$loop_0: while (true) {
      current = this.n6d(current);
      if (current === -1)
        break $l$loop_0;
      var c = charSequenceGet(this.m6d(), current);
      if (c === _Char___init__impl__6a9atx(32) || c === _Char___init__impl__6a9atx(10) || c === _Char___init__impl__6a9atx(13) || c === _Char___init__impl__6a9atx(9)) {
        current = current + 1 | 0;
      } else {
        break $l$loop_0;
      }
    }
    this.y61_1 = current;
    return current;
  };
  protoOf(AbstractJsonLexer).p68 = function (isLenient) {
    var token = this.y66();
    var tmp;
    if (isLenient) {
      if (!(token === 1) && !(token === 0))
        return null;
      tmp = this.b67();
    } else {
      if (!(token === 1))
        return null;
      tmp = this.a67();
    }
    var string = tmp;
    this.a62_1 = string;
    return string;
  };
  protoOf(AbstractJsonLexer).u6d = function (startPos, endPos) {
    // Inline function 'kotlin.text.substring' call
    var this_0 = this.m6d();
    return toString_1(charSequenceSubSequence(this_0, startPos, endPos));
  };
  protoOf(AbstractJsonLexer).a67 = function () {
    if (!(this.a62_1 == null)) {
      return takePeeked(this);
    }
    return this.s68();
  };
  protoOf(AbstractJsonLexer).consumeString2 = function (source, startPosition, current) {
    var currentPosition = current;
    var lastPosition = startPosition;
    var char = charSequenceGet(source, currentPosition);
    var usedAppend = false;
    while (!(char === _Char___init__impl__6a9atx(34))) {
      if (char === _Char___init__impl__6a9atx(92)) {
        usedAppend = true;
        currentPosition = this.n6d(appendEscape(this, lastPosition, currentPosition));
        if (currentPosition === -1) {
          this.y65('EOF', currentPosition);
        }
        lastPosition = currentPosition;
      } else {
        currentPosition = currentPosition + 1 | 0;
        if (currentPosition >= charSequenceLength(source)) {
          usedAppend = true;
          this.l6d(lastPosition, currentPosition);
          currentPosition = this.n6d(currentPosition);
          if (currentPosition === -1) {
            this.y65('EOF', currentPosition);
          }
          lastPosition = currentPosition;
        }
      }
      char = charSequenceGet(source, currentPosition);
    }
    var tmp;
    if (!usedAppend) {
      tmp = this.u6d(lastPosition, currentPosition);
    } else {
      tmp = decodedString(this, lastPosition, currentPosition);
    }
    var string = tmp;
    this.y61_1 = currentPosition + 1 | 0;
    return string;
  };
  protoOf(AbstractJsonLexer).t68 = function () {
    var result = this.b67();
    if (result === 'null' && wasUnquotedString(this)) {
      this.y65("Unexpected 'null' value instead of string literal");
    }
    return result;
  };
  protoOf(AbstractJsonLexer).b67 = function () {
    if (!(this.a62_1 == null)) {
      return takePeeked(this);
    }
    var current = this.t6d();
    if (current >= charSequenceLength(this.m6d()) || current === -1) {
      this.y65('EOF', current);
    }
    var token = charToTokenClass(charSequenceGet(this.m6d(), current));
    if (token === 1) {
      return this.a67();
    }
    if (!(token === 0)) {
      this.y65('Expected beginning of the string, but got ' + toString(charSequenceGet(this.m6d(), current)));
    }
    var usedAppend = false;
    while (charToTokenClass(charSequenceGet(this.m6d(), current)) === 0) {
      current = current + 1 | 0;
      if (current >= charSequenceLength(this.m6d())) {
        usedAppend = true;
        this.l6d(this.y61_1, current);
        var eof = this.n6d(current);
        if (eof === -1) {
          this.y61_1 = current;
          return decodedString(this, 0, 0);
        } else {
          current = eof;
        }
      }
    }
    var tmp;
    if (!usedAppend) {
      tmp = this.u6d(this.y61_1, current);
    } else {
      tmp = decodedString(this, this.y61_1, current);
    }
    var result = tmp;
    this.y61_1 = current;
    return result;
  };
  protoOf(AbstractJsonLexer).l6d = function (fromIndex, toIndex) {
    this.b62_1.ec(this.m6d(), fromIndex, toIndex);
  };
  protoOf(AbstractJsonLexer).r68 = function (allowLenientStrings) {
    // Inline function 'kotlin.collections.mutableListOf' call
    var tokenStack = ArrayList_init_$Create$();
    var lastToken = this.y66();
    if (!(lastToken === 8) && !(lastToken === 6)) {
      this.b67();
      return Unit_instance;
    }
    $l$loop: while (true) {
      lastToken = this.y66();
      if (lastToken === 1) {
        if (allowLenientStrings) {
          this.b67();
        } else {
          this.s68();
        }
        continue $l$loop;
      }
      var tmp0_subject = lastToken;
      if (tmp0_subject === 8 ? true : tmp0_subject === 6) {
        tokenStack.j(lastToken);
      } else if (tmp0_subject === 9) {
        if (!(last(tokenStack) === 8))
          throw JsonDecodingException_0(this.y61_1, 'found ] instead of } at path: ' + this.z61_1.toString(), this.m6d());
        removeLast(tokenStack);
      } else if (tmp0_subject === 7) {
        if (!(last(tokenStack) === 6))
          throw JsonDecodingException_0(this.y61_1, 'found } instead of ] at path: ' + this.z61_1.toString(), this.m6d());
        removeLast(tokenStack);
      } else if (tmp0_subject === 10) {
        this.y65('Unexpected end of input due to malformed JSON during ignoring unknown keys');
      }
      this.d67();
      if (tokenStack.p() === 0)
        return Unit_instance;
    }
  };
  protoOf(AbstractJsonLexer).toString = function () {
    return "JsonReader(source='" + toString_1(this.m6d()) + "', currentPosition=" + this.y61_1 + ')';
  };
  protoOf(AbstractJsonLexer).q68 = function (key) {
    var processed = this.u6d(0, this.y61_1);
    var lastIndexOf = lastIndexOf_2(processed, key);
    this.s6d("Encountered an unknown key '" + key + "'", lastIndexOf, "Use 'ignoreUnknownKeys = true' in 'Json {}' builder to ignore unknown keys.");
  };
  protoOf(AbstractJsonLexer).s6d = function (message, position, hint) {
    var tmp;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(hint) === 0) {
      tmp = '';
    } else {
      tmp = '\n' + hint;
    }
    var hintMessage = tmp;
    throw JsonDecodingException_0(position, message + ' at path: ' + this.z61_1.l66() + hintMessage, this.m6d());
  };
  protoOf(AbstractJsonLexer).y65 = function (message, position, hint, $super) {
    position = position === VOID ? this.y61_1 : position;
    hint = hint === VOID ? '' : hint;
    return $super === VOID ? this.s6d(message, position, hint) : $super.s6d.call(this, message, position, hint);
  };
  protoOf(AbstractJsonLexer).c69 = function () {
    var current = this.t6d();
    current = this.n6d(current);
    if (current >= charSequenceLength(this.m6d()) || current === -1) {
      this.y65('EOF');
    }
    var tmp;
    if (charSequenceGet(this.m6d(), current) === _Char___init__impl__6a9atx(34)) {
      current = current + 1 | 0;
      if (current === charSequenceLength(this.m6d())) {
        this.y65('EOF');
      }
      tmp = true;
    } else {
      tmp = false;
    }
    var hasQuotation = tmp;
    var accumulator = 0n;
    var isNegative = false;
    var start = current;
    var hasChars = true;
    $l$loop_0: while (hasChars) {
      var ch = charSequenceGet(this.m6d(), current);
      if (ch === _Char___init__impl__6a9atx(45)) {
        if (!(current === start)) {
          this.y65("Unexpected symbol '-' in numeric literal");
        }
        isNegative = true;
        current = current + 1 | 0;
        continue $l$loop_0;
      }
      var token = charToTokenClass(ch);
      if (!(token === 0))
        break $l$loop_0;
      current = current + 1 | 0;
      hasChars = !(current === charSequenceLength(this.m6d()));
      var digit = Char__minus_impl_a2frrh(ch, _Char___init__impl__6a9atx(48));
      if (!(0 <= digit ? digit <= 9 : false)) {
        this.y65("Unexpected symbol '" + toString(ch) + "' in numeric literal");
      }
      // Inline function 'kotlin.Long.times' call
      var this_0 = accumulator;
      // Inline function 'kotlin.Long.minus' call
      var this_1 = multiply_0(this_0, fromInt_0(10));
      accumulator = subtract_1(this_1, fromInt_0(digit));
      if (accumulator > 0n) {
        this.y65('Numeric value overflow');
      }
    }
    if (start === current || (isNegative && start === (current - 1 | 0))) {
      this.y65('Expected numeric literal');
    }
    if (hasQuotation) {
      if (!hasChars) {
        this.y65('EOF');
      }
      if (!(charSequenceGet(this.m6d(), current) === _Char___init__impl__6a9atx(34))) {
        this.y65('Expected closing quotation mark');
      }
      current = current + 1 | 0;
    }
    this.y61_1 = current;
    var tmp_0;
    if (isNegative) {
      tmp_0 = accumulator;
    } else if (!(accumulator === -9223372036854775808n)) {
      tmp_0 = negate_0(accumulator);
    } else {
      this.y65('Numeric value overflow');
    }
    return tmp_0;
  };
  protoOf(AbstractJsonLexer).a69 = function () {
    return consumeBoolean2(this, this.t6d());
  };
  protoOf(AbstractJsonLexer).b69 = function () {
    var current = this.t6d();
    if (current === charSequenceLength(this.m6d())) {
      this.y65('EOF');
    }
    var tmp;
    if (charSequenceGet(this.m6d(), current) === _Char___init__impl__6a9atx(34)) {
      current = current + 1 | 0;
      tmp = true;
    } else {
      tmp = false;
    }
    var hasQuotation = tmp;
    var result = consumeBoolean2(this, current);
    if (hasQuotation) {
      if (this.y61_1 === charSequenceLength(this.m6d())) {
        this.y65('EOF');
      }
      if (!(charSequenceGet(this.m6d(), this.y61_1) === _Char___init__impl__6a9atx(34))) {
        this.y65('Expected closing quotation mark');
      }
      this.y61_1 = this.y61_1 + 1 | 0;
    }
    return result;
  };
  function charToTokenClass(c) {
    var tmp;
    // Inline function 'kotlin.code' call
    if (Char__toInt_impl_vasixd(c) < 126) {
      var tmp_0 = CharMappings_getInstance().w6d_1;
      // Inline function 'kotlin.code' call
      tmp = tmp_0[Char__toInt_impl_vasixd(c)];
    } else {
      tmp = 0;
    }
    return tmp;
  }
  function escapeToChar(c) {
    return c < 117 ? CharMappings_getInstance().v6d_1[c] : _Char___init__impl__6a9atx(0);
  }
  function initEscape($this) {
    var inductionVariable = 0;
    if (inductionVariable <= 31)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        initC2ESC($this, i, _Char___init__impl__6a9atx(117));
      }
       while (inductionVariable <= 31);
    initC2ESC($this, 8, _Char___init__impl__6a9atx(98));
    initC2ESC($this, 9, _Char___init__impl__6a9atx(116));
    initC2ESC($this, 10, _Char___init__impl__6a9atx(110));
    initC2ESC($this, 12, _Char___init__impl__6a9atx(102));
    initC2ESC($this, 13, _Char___init__impl__6a9atx(114));
    initC2ESC_0($this, _Char___init__impl__6a9atx(47), _Char___init__impl__6a9atx(47));
    initC2ESC_0($this, _Char___init__impl__6a9atx(34), _Char___init__impl__6a9atx(34));
    initC2ESC_0($this, _Char___init__impl__6a9atx(92), _Char___init__impl__6a9atx(92));
  }
  function initCharToToken($this) {
    var inductionVariable = 0;
    if (inductionVariable <= 32)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        initC2TC($this, i, 127);
      }
       while (inductionVariable <= 32);
    initC2TC($this, 9, 3);
    initC2TC($this, 10, 3);
    initC2TC($this, 13, 3);
    initC2TC($this, 32, 3);
    initC2TC_0($this, _Char___init__impl__6a9atx(44), 4);
    initC2TC_0($this, _Char___init__impl__6a9atx(58), 5);
    initC2TC_0($this, _Char___init__impl__6a9atx(123), 6);
    initC2TC_0($this, _Char___init__impl__6a9atx(125), 7);
    initC2TC_0($this, _Char___init__impl__6a9atx(91), 8);
    initC2TC_0($this, _Char___init__impl__6a9atx(93), 9);
    initC2TC_0($this, _Char___init__impl__6a9atx(34), 1);
    initC2TC_0($this, _Char___init__impl__6a9atx(92), 2);
  }
  function initC2ESC($this, c, esc) {
    if (!(esc === _Char___init__impl__6a9atx(117))) {
      // Inline function 'kotlin.code' call
      var tmp$ret$0 = Char__toInt_impl_vasixd(esc);
      $this.v6d_1[tmp$ret$0] = numberToChar(c);
    }
  }
  function initC2ESC_0($this, c, esc) {
    // Inline function 'kotlin.code' call
    var tmp$ret$0 = Char__toInt_impl_vasixd(c);
    return initC2ESC($this, tmp$ret$0, esc);
  }
  function initC2TC($this, c, cl) {
    $this.w6d_1[c] = cl;
  }
  function initC2TC_0($this, c, cl) {
    // Inline function 'kotlin.code' call
    var tmp$ret$0 = Char__toInt_impl_vasixd(c);
    return initC2TC($this, tmp$ret$0, cl);
  }
  function CharMappings() {
    CharMappings_instance = this;
    this.v6d_1 = charArray(117);
    this.w6d_1 = new Int8Array(126);
    initEscape(this);
    initCharToToken(this);
  }
  var CharMappings_instance;
  function CharMappings_getInstance() {
    if (CharMappings_instance == null)
      new CharMappings();
    return CharMappings_instance;
  }
  function StringJsonLexer_0(source) {
    AbstractJsonLexer.call(this);
    this.b6e_1 = source;
  }
  protoOf(StringJsonLexer_0).m6d = function () {
    return this.b6e_1;
  };
  protoOf(StringJsonLexer_0).n6d = function (position) {
    return position < this.b6e_1.length ? position : -1;
  };
  protoOf(StringJsonLexer_0).d67 = function () {
    var source = this.b6e_1;
    $l$loop: while (!(this.y61_1 === -1) && this.y61_1 < source.length) {
      var tmp1 = this.y61_1;
      this.y61_1 = tmp1 + 1 | 0;
      var ch = charCodeAt(source, tmp1);
      var tc = charToTokenClass(ch);
      var tmp;
      if (tc === 3) {
        continue $l$loop;
      } else {
        tmp = tc;
      }
      return tmp;
    }
    return 10;
  };
  protoOf(StringJsonLexer_0).n68 = function () {
    var current = this.t6d();
    if (current === this.b6e_1.length || current === -1)
      return false;
    if (charCodeAt(this.b6e_1, current) === _Char___init__impl__6a9atx(44)) {
      this.y61_1 = this.y61_1 + 1 | 0;
      return true;
    }
    return false;
  };
  protoOf(StringJsonLexer_0).z66 = function () {
    var current = this.y61_1;
    if (current === -1)
      return false;
    $l$loop: while (current < this.b6e_1.length) {
      var c = charCodeAt(this.b6e_1, current);
      if (c === _Char___init__impl__6a9atx(32) || c === _Char___init__impl__6a9atx(10) || c === _Char___init__impl__6a9atx(13) || c === _Char___init__impl__6a9atx(9)) {
        current = current + 1 | 0;
        continue $l$loop;
      }
      this.y61_1 = current;
      return this.p6d(c);
    }
    this.y61_1 = current;
    return false;
  };
  protoOf(StringJsonLexer_0).t6d = function () {
    var current = this.y61_1;
    if (current === -1)
      return current;
    $l$loop: while (current < this.b6e_1.length) {
      var c = charCodeAt(this.b6e_1, current);
      if (c === _Char___init__impl__6a9atx(32) || c === _Char___init__impl__6a9atx(10) || c === _Char___init__impl__6a9atx(13) || c === _Char___init__impl__6a9atx(9)) {
        current = current + 1 | 0;
      } else {
        break $l$loop;
      }
    }
    this.y61_1 = current;
    return current;
  };
  protoOf(StringJsonLexer_0).m68 = function (expected) {
    if (this.y61_1 === -1) {
      this.r6d(expected);
    }
    var source = this.b6e_1;
    $l$loop: while (this.y61_1 < source.length) {
      var tmp1 = this.y61_1;
      this.y61_1 = tmp1 + 1 | 0;
      var c = charCodeAt(source, tmp1);
      if (c === _Char___init__impl__6a9atx(32) || c === _Char___init__impl__6a9atx(10) || c === _Char___init__impl__6a9atx(13) || c === _Char___init__impl__6a9atx(9))
        continue $l$loop;
      if (c === expected)
        return Unit_instance;
      this.r6d(expected);
    }
    this.r6d(expected);
  };
  protoOf(StringJsonLexer_0).s68 = function () {
    this.m68(_Char___init__impl__6a9atx(34));
    var current = this.y61_1;
    var closingQuote = indexOf_8(this.b6e_1, _Char___init__impl__6a9atx(34), current);
    if (closingQuote === -1) {
      this.q6d(1);
    }
    var inductionVariable = current;
    if (inductionVariable < closingQuote)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (charCodeAt(this.b6e_1, i) === _Char___init__impl__6a9atx(92)) {
          return this.consumeString2(this.b6e_1, this.y61_1, i);
        }
      }
       while (inductionVariable < closingQuote);
    this.y61_1 = closingQuote + 1 | 0;
    return substring(this.b6e_1, current, closingQuote);
  };
  protoOf(StringJsonLexer_0).u68 = function (keyToMatch, isLenient) {
    var positionSnapshot = this.y61_1;
    try {
      if (!(this.d67() === 6))
        return null;
      var firstKey = isLenient ? this.s68() : this.t68();
      if (firstKey === keyToMatch) {
        if (!(this.d67() === 5))
          return null;
        var result = isLenient ? this.a67() : this.t68();
        return result;
      }
      return null;
    }finally {
      this.y61_1 = positionSnapshot;
    }
  };
  function decodeFromDynamic(_this__u8e3s4, deserializer, dynamic) {
    return decodeDynamic(_this__u8e3s4, deserializer, dynamic);
  }
  function get_schemaCache(_this__u8e3s4) {
    return _this__u8e3s4.m61_1;
  }
  function decodeDynamic(_this__u8e3s4, deserializer, dynamic) {
    var tmp;
    switch (typeof dynamic) {
      case 'boolean':
      case 'number':
      case 'string':
        tmp = new PrimitiveDynamicInput(dynamic, _this__u8e3s4);
        break;
      default:
        var tmp_0;
        if (Array.isArray(dynamic)) {
          tmp_0 = new DynamicListInput(dynamic, _this__u8e3s4);
        } else {
          tmp_0 = new DynamicInput(dynamic, _this__u8e3s4);
        }

        tmp = tmp_0;
        break;
    }
    var input = tmp;
    return input.k59(deserializer);
  }
  function coerceInputValue_1($this, descriptor, index, tag) {
    var tmp0 = $this.f63();
    var tmp2 = descriptor.t5a(index);
    var tmp$ret$1;
    $l$block_2: {
      // Inline function 'kotlinx.serialization.json.internal.tryCoerceValue' call
      var tmp;
      if (!tmp2.i5a()) {
        tmp = $this.k6e(tag) == null;
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$1 = true;
        break $l$block_2;
      }
      if (equals(tmp2.r5a(), ENUM_getInstance())) {
        var tmp_0;
        if (tmp2.i5a()) {
          tmp_0 = $this.k6e(tag) == null;
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          tmp$ret$1 = false;
          break $l$block_2;
        }
        var tmp_1 = $this.k6e(tag);
        var tmp0_elvis_lhs = (!(tmp_1 == null) ? typeof tmp_1 === 'string' : false) ? tmp_1 : null;
        var tmp_2;
        if (tmp0_elvis_lhs == null) {
          tmp$ret$1 = false;
          break $l$block_2;
        } else {
          tmp_2 = tmp0_elvis_lhs;
        }
        var enumValue = tmp_2;
        var enumIndex = getJsonNameIndex(tmp2, tmp0, enumValue);
        if (enumIndex === -3) {
          tmp$ret$1 = true;
          break $l$block_2;
        }
      }
      tmp$ret$1 = false;
    }
    return tmp$ret$1;
  }
  function hasName($this, name) {
    return $this.e6e_1[name] !== undefined;
  }
  function absenceIsNull_0($this, descriptor, index) {
    $this.i6e_1 = (!$this.f63().k61_1.x62_1 && !descriptor.w5a(index) && descriptor.t5a(index).i5a());
    return $this.i6e_1;
  }
  function throwMissingTag($this, tag) {
    throw SerializationException_init_$Create$_0('Value for field ' + tag + ' is missing');
  }
  function DynamicInput(value, json) {
    NamedValueDecoder.call(this);
    this.e6e_1 = value;
    this.f6e_1 = json;
    var tmp = this;
    var tmp0_elvis_lhs = this.e6e_1;
    tmp.g6e_1 = Object.keys(tmp0_elvis_lhs == null ? {} : tmp0_elvis_lhs);
    var tmp_0 = this;
    var tmp_1 = this.g6e_1.length;
    tmp_0.h6e_1 = (!(tmp_1 == null) ? typeof tmp_1 === 'number' : false) ? tmp_1 : THROW_CCE();
    this.i6e_1 = false;
    this.j6e_1 = 0;
  }
  protoOf(DynamicInput).f63 = function () {
    return this.f6e_1;
  };
  protoOf(DynamicInput).p = function () {
    return this.h6e_1;
  };
  protoOf(DynamicInput).g59 = function () {
    return this.f63().g59();
  };
  protoOf(DynamicInput).g63 = function () {
    var tag = this.i5q();
    if (!(tag == null)) {
      return decodeFromDynamic(this.f63(), Companion_instance_83.i63(), this.e6e_1[tag]);
    }
    if (this.e6e_1 == null) {
      return JsonNull_getInstance();
    }
    // Inline function 'kotlinx.serialization.json.buildJsonObject' call
    // Inline function 'kotlin.contracts.contract' call
    var builder = new JsonObjectBuilder();
    var inductionVariable = 0;
    var last = this.p();
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var key = this.g6e_1[i];
        var value = decodeDynamic(this.f63(), Companion_instance_83.i63(), this.e6e_1[key]);
        builder.x63(toString_1(key), value);
      }
       while (inductionVariable < last);
    return builder.r62();
  };
  protoOf(DynamicInput).k59 = function (deserializer) {
    return decodeSerializableValuePolymorphic(this, deserializer);
  };
  protoOf(DynamicInput).j5q = function (parentName, childName) {
    return childName;
  };
  protoOf(DynamicInput).w5c = function (descriptor) {
    while (this.j6e_1 < descriptor.p5a()) {
      var tmp1 = this.j6e_1;
      this.j6e_1 = tmp1 + 1 | 0;
      var name = this.d5q(descriptor, tmp1);
      var index = this.j6e_1 - 1 | 0;
      this.i6e_1 = false;
      if ((hasName(this, name) || absenceIsNull_0(this, descriptor, index)) && (!this.f63().k61_1.z62_1 || !coerceInputValue_1(this, descriptor, index, name))) {
        return index;
      }
    }
    return -1;
  };
  protoOf(DynamicInput).e5q = function (descriptor, index) {
    var strategy = namingStrategy(descriptor, this.f63());
    var mainName = descriptor.v5a(index);
    if (strategy == null) {
      if (!this.f63().k61_1.d63_1)
        return mainName;
      if (hasName(this, mainName))
        return mainName;
    }
    var deserializationNamesMap_0 = deserializationNamesMap(this.f63(), descriptor);
    var tmp = this.g6e_1;
    // Inline function 'kotlin.collections.find' call
    var tmp0 = (!(tmp == null) ? isArray(tmp) : false) ? tmp : THROW_CCE();
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var inductionVariable = 0;
      var last = tmp0.length;
      while (inductionVariable < last) {
        var element = tmp0[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        if (deserializationNamesMap_0.q2(element) === index) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    var tmp0_safe_receiver = tmp$ret$1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      return tmp0_safe_receiver;
    }
    var fallbackName = strategy == null ? null : strategy.c66(descriptor, index, mainName);
    return fallbackName == null ? mainName : fallbackName;
  };
  protoOf(DynamicInput).m69 = function (tag, enumDescriptor) {
    var byTag = this.k6e(tag);
    var tmp0_elvis_lhs = (!(byTag == null) ? typeof byTag === 'string' : false) ? byTag : null;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw SerializationException_init_$Create$_0("Enum value must be a string, got '" + byTag + "'");
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var enumValue = tmp;
    return getJsonNameIndexOrThrow(enumDescriptor, this.f63(), enumValue);
  };
  protoOf(DynamicInput).v5q = function (tag, enumDescriptor) {
    return this.m69((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE(), enumDescriptor);
  };
  protoOf(DynamicInput).k6e = function (tag) {
    return this.e6e_1[tag];
  };
  protoOf(DynamicInput).v69 = function (tag) {
    var value = this.k6e(tag);
    var tmp;
    if (!(value == null) ? typeof value === 'string' : false) {
      var tmp_0;
      if (value.length === 1) {
        tmp_0 = charCodeAt(value, 0);
      } else {
        throw SerializationException_init_$Create$_0('' + value + " can't be represented as Char");
      }
      tmp = tmp_0;
    } else {
      if (isNumber(value)) {
        var tmp0_elvis_lhs = (!(value == null) ? typeof value === 'number' : false) ? value : null;
        var tmp_1;
        if (tmp0_elvis_lhs == null) {
          throw SerializationException_init_$Create$_0('' + value + ' is not a Number');
        } else {
          tmp_1 = tmp0_elvis_lhs;
        }
        var num = tmp_1;
        var codePoint = this.l6e(num);
        var tmp_2;
        if (codePoint < 0n) {
          tmp_2 = true;
        } else {
          // Inline function 'kotlin.code' call
          var this_0 = _Char___init__impl__6a9atx(65535);
          var tmp$ret$0 = Char__toInt_impl_vasixd(this_0);
          tmp_2 = codePoint > fromInt_0(tmp$ret$0);
        }
        if (tmp_2)
          throw SerializationException_init_$Create$_0('' + value + " can't be represented as Char because it's not in bounds of Char.MIN_VALUE..Char.MAX_VALUE");
        tmp = numberToChar(convertToInt(codePoint));
      } else {
        throw SerializationException_init_$Create$_0('' + value + " can't be represented as Char");
      }
    }
    return tmp;
  };
  protoOf(DynamicInput).t5q = function (tag) {
    return this.v69((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  protoOf(DynamicInput).s69 = function (tag) {
    var value = this.k6e(tag);
    var tmp0_elvis_lhs = (!(value == null) ? typeof value === 'number' : false) ? value : null;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw SerializationException_init_$Create$_0('' + value + ' is not a Number');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var number = tmp;
    return this.l6e(number);
  };
  protoOf(DynamicInput).q5q = function (tag) {
    return this.s69((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  protoOf(DynamicInput).l6e = function (number) {
    var tmp;
    if (isFinite_0(number)) {
      // Inline function 'kotlin.math.floor' call
      tmp = Math.floor(number) === number;
    } else {
      tmp = false;
    }
    var canBeConverted = tmp;
    if (!canBeConverted)
      throw SerializationException_init_$Create$_0('' + number + " can't be represented as Long because it is not finite or has non-zero fractional part");
    // Inline function 'kotlin.math.abs' call
    var inBound = Math.abs(number) <= 9.007199254740991E15;
    if (!inBound)
      throw SerializationException_init_$Create$_0('' + number + " can't be deserialized to Long due to a potential precision loss");
    return numberToLong(number);
  };
  protoOf(DynamicInput).m6e = function (tag) {
    var tmp0_elvis_lhs = this.k6e(tag);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throwMissingTag(this, tag);
      tmp = Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var o = tmp;
    return !(o == null) ? o : THROW_CCE();
  };
  protoOf(DynamicInput).k5q = function (tag) {
    return this.m6e((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  protoOf(DynamicInput).n69 = function (tag) {
    if (this.i6e_1) {
      return false;
    }
    var o = this.k6e(tag);
    if (o === undefined) {
      throwMissingTag(this, tag);
    }
    return o != null;
  };
  protoOf(DynamicInput).l5q = function (tag) {
    return this.n69((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  protoOf(DynamicInput).g5c = function (descriptor) {
    var tmp0_safe_receiver = this.i5q();
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp = this.e6e_1[tmp0_safe_receiver];
    }
    var tmp1_elvis_lhs = tmp;
    var currentValue = tmp1_elvis_lhs == null ? this.e6e_1 : tmp1_elvis_lhs;
    var tmp_0;
    if (descriptor.r5a() instanceof PolymorphicKind) {
      tmp_0 = this.f63().k61_1.a63_1 ? LIST_getInstance() : MAP_getInstance();
    } else {
      tmp_0 = descriptor.r5a();
    }
    var kind = tmp_0;
    return equals(kind, LIST_getInstance()) ? new DynamicListInput(currentValue, this.f63()) : equals(kind, MAP_getInstance()) ? new DynamicMapInput(currentValue, this.f63()) : new DynamicInput(currentValue, this.f63());
  };
  function PrimitiveDynamicInput(value, json) {
    DynamicInput.call(this, value, json);
    this.x5q('primitive');
  }
  protoOf(PrimitiveDynamicInput).k6e = function (tag) {
    return this.e6e_1;
  };
  protoOf(PrimitiveDynamicInput).g63 = function () {
    var str = toString_1(this.e6e_1);
    var tmp;
    switch (typeof this.e6e_1) {
      case 'boolean':
        tmp = JsonPrimitive_2(toBoolean(str));
        break;
      case 'number':
        var l = toLongOrNull(str);
        if (!(l == null))
          return JsonPrimitive_1(l);
        var d = toDoubleOrNull(str);
        if (!(d == null))
          return JsonPrimitive_1(d);
        return JsonPrimitive_0(str);
      default:
        tmp = JsonPrimitive_0(str);
        break;
    }
    return tmp;
  };
  function DynamicListInput(value, json) {
    DynamicInput.call(this, value, json);
    var tmp = this;
    var tmp_0 = value.length;
    tmp.d6f_1 = (!(tmp_0 == null) ? typeof tmp_0 === 'number' : false) ? tmp_0 : THROW_CCE();
    this.e6f_1 = -1;
  }
  protoOf(DynamicListInput).p = function () {
    return this.d6f_1;
  };
  protoOf(DynamicListInput).e5q = function (descriptor, index) {
    return index.toString();
  };
  protoOf(DynamicListInput).w5c = function (descriptor) {
    while (this.e6f_1 < (this.d6f_1 - 1 | 0)) {
      this.e6f_1 = this.e6f_1 + 1 | 0;
      var o = this.e6e_1[this.e6f_1];
      if (o !== undefined)
        return this.e6f_1;
    }
    return -1;
  };
  protoOf(DynamicListInput).g63 = function () {
    var tag = this.i5q();
    if (!(tag == null)) {
      return decodeFromDynamic(this.f63(), Companion_instance_83.i63(), this.e6e_1[tag]);
    }
    // Inline function 'kotlinx.serialization.json.buildJsonArray' call
    // Inline function 'kotlin.contracts.contract' call
    var builder = new JsonArrayBuilder();
    var inductionVariable = 0;
    var last = this.d6f_1;
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        builder.z63(decodeFromDynamic(this.f63(), Companion_instance_83.i63(), this.e6e_1[i]));
      }
       while (inductionVariable < last);
    return builder.r62();
  };
  function _get_isKey__g0dpic($this) {
    return ($this.o6f_1 % 2 | 0) === 0;
  }
  function throwIllegalKeyType($this, tag, value, type) {
    throw SerializationException_init_$Create$_0('Property ' + tag + ' is not valid type ' + type + ': ' + toString_1(value));
  }
  function DynamicMapInput(value, json) {
    DynamicInput.call(this, value, json);
    var tmp = this;
    var tmp_0 = this.g6e_1.length;
    tmp.n6f_1 = imul((!(tmp_0 == null) ? typeof tmp_0 === 'number' : false) ? tmp_0 : THROW_CCE(), 2);
    this.o6f_1 = -1;
  }
  protoOf(DynamicMapInput).p = function () {
    return this.n6f_1;
  };
  protoOf(DynamicMapInput).e5q = function (descriptor, index) {
    var i = index / 2 | 0;
    var tmp = this.g6e_1[i];
    return (!(tmp == null) ? typeof tmp === 'string' : false) ? tmp : THROW_CCE();
  };
  protoOf(DynamicMapInput).p69 = function (tag) {
    var tmp$ret$1;
    $l$block_0: {
      // Inline function 'kotlinx.serialization.json.internal.DynamicMapInput.decodeMapKey' call
      if (_get_isKey__g0dpic(this)) {
        var value = this.m6e(tag);
        if (!(typeof value === 'string')) {
          tmp$ret$1 = protoOf(DynamicInput).n5q.call(this, tag);
          break $l$block_0;
        }
        var $this$decodeMapKey = toString_1(value);
        var tmp0_elvis_lhs = toByteOrNull($this$decodeMapKey);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          throwIllegalKeyType(this, tag, value, 'byte');
        } else {
          tmp = tmp0_elvis_lhs;
        }
        tmp$ret$1 = tmp;
        break $l$block_0;
      }
      tmp$ret$1 = protoOf(DynamicInput).n5q.call(this, tag);
    }
    return tmp$ret$1;
  };
  protoOf(DynamicMapInput).n5q = function (tag) {
    return this.p69((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  protoOf(DynamicMapInput).q69 = function (tag) {
    var tmp$ret$1;
    $l$block_0: {
      // Inline function 'kotlinx.serialization.json.internal.DynamicMapInput.decodeMapKey' call
      if (_get_isKey__g0dpic(this)) {
        var value = this.m6e(tag);
        if (!(typeof value === 'string')) {
          tmp$ret$1 = protoOf(DynamicInput).o5q.call(this, tag);
          break $l$block_0;
        }
        var $this$decodeMapKey = toString_1(value);
        var tmp0_elvis_lhs = toShortOrNull($this$decodeMapKey);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          throwIllegalKeyType(this, tag, value, 'short');
        } else {
          tmp = tmp0_elvis_lhs;
        }
        tmp$ret$1 = tmp;
        break $l$block_0;
      }
      tmp$ret$1 = protoOf(DynamicInput).o5q.call(this, tag);
    }
    return tmp$ret$1;
  };
  protoOf(DynamicMapInput).o5q = function (tag) {
    return this.q69((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  protoOf(DynamicMapInput).r69 = function (tag) {
    var tmp$ret$1;
    $l$block_0: {
      // Inline function 'kotlinx.serialization.json.internal.DynamicMapInput.decodeMapKey' call
      if (_get_isKey__g0dpic(this)) {
        var value = this.m6e(tag);
        if (!(typeof value === 'string')) {
          tmp$ret$1 = protoOf(DynamicInput).p5q.call(this, tag);
          break $l$block_0;
        }
        var $this$decodeMapKey = toString_1(value);
        var tmp0_elvis_lhs = toIntOrNull($this$decodeMapKey);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          throwIllegalKeyType(this, tag, value, 'int');
        } else {
          tmp = tmp0_elvis_lhs;
        }
        tmp$ret$1 = tmp;
        break $l$block_0;
      }
      tmp$ret$1 = protoOf(DynamicInput).p5q.call(this, tag);
    }
    return tmp$ret$1;
  };
  protoOf(DynamicMapInput).p5q = function (tag) {
    return this.r69((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  protoOf(DynamicMapInput).s69 = function (tag) {
    var tmp$ret$1;
    $l$block_0: {
      // Inline function 'kotlinx.serialization.json.internal.DynamicMapInput.decodeMapKey' call
      if (_get_isKey__g0dpic(this)) {
        var value = this.m6e(tag);
        if (!(typeof value === 'string')) {
          tmp$ret$1 = protoOf(DynamicInput).s69.call(this, tag);
          break $l$block_0;
        }
        var $this$decodeMapKey = toString_1(value);
        var tmp0_elvis_lhs = toDoubleOrNull($this$decodeMapKey);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          throwIllegalKeyType(this, tag, $this$decodeMapKey, 'long');
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var tmp0_elvis_lhs_0 = this.l6e(tmp);
        var tmp_0;
        if (tmp0_elvis_lhs_0 == null) {
          throwIllegalKeyType(this, tag, value, 'long');
        } else {
          tmp_0 = tmp0_elvis_lhs_0;
        }
        tmp$ret$1 = tmp_0;
        break $l$block_0;
      }
      tmp$ret$1 = protoOf(DynamicInput).s69.call(this, tag);
    }
    return tmp$ret$1;
  };
  protoOf(DynamicMapInput).q5q = function (tag) {
    return this.s69((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  protoOf(DynamicMapInput).t69 = function (tag) {
    var tmp$ret$1;
    $l$block_0: {
      // Inline function 'kotlinx.serialization.json.internal.DynamicMapInput.decodeMapKey' call
      if (_get_isKey__g0dpic(this)) {
        var value = this.m6e(tag);
        if (!(typeof value === 'string')) {
          tmp$ret$1 = protoOf(DynamicInput).r5q.call(this, tag);
          break $l$block_0;
        }
        // Inline function 'kotlin.text.toFloatOrNull' call
        var this_0 = toString_1(value);
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp0_elvis_lhs = toDoubleOrNull(this_0);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          throwIllegalKeyType(this, tag, value, 'float');
        } else {
          tmp = tmp0_elvis_lhs;
        }
        tmp$ret$1 = tmp;
        break $l$block_0;
      }
      tmp$ret$1 = protoOf(DynamicInput).r5q.call(this, tag);
    }
    return tmp$ret$1;
  };
  protoOf(DynamicMapInput).r5q = function (tag) {
    return this.t69((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  protoOf(DynamicMapInput).u69 = function (tag) {
    var tmp$ret$1;
    $l$block_0: {
      // Inline function 'kotlinx.serialization.json.internal.DynamicMapInput.decodeMapKey' call
      if (_get_isKey__g0dpic(this)) {
        var value = this.m6e(tag);
        if (!(typeof value === 'string')) {
          tmp$ret$1 = protoOf(DynamicInput).s5q.call(this, tag);
          break $l$block_0;
        }
        var $this$decodeMapKey = toString_1(value);
        var tmp0_elvis_lhs = toDoubleOrNull($this$decodeMapKey);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          throwIllegalKeyType(this, tag, value, 'double');
        } else {
          tmp = tmp0_elvis_lhs;
        }
        tmp$ret$1 = tmp;
        break $l$block_0;
      }
      tmp$ret$1 = protoOf(DynamicInput).s5q.call(this, tag);
    }
    return tmp$ret$1;
  };
  protoOf(DynamicMapInput).s5q = function (tag) {
    return this.u69((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  protoOf(DynamicMapInput).w5c = function (descriptor) {
    while (this.o6f_1 < (this.n6f_1 - 1 | 0)) {
      var tmp1 = this.o6f_1;
      this.o6f_1 = tmp1 + 1 | 0;
      var i = tmp1 / 2 | 0;
      var tmp = this.g6e_1[i];
      var name = (!(tmp == null) ? typeof tmp === 'string' : false) ? tmp : THROW_CCE();
      if (this.e6e_1[name] !== undefined)
        return this.o6f_1;
    }
    return -1;
  };
  protoOf(DynamicMapInput).k6e = function (tag) {
    return (this.o6f_1 % 2 | 0) === 0 ? tag : this.e6e_1[tag];
  };
  function JsonToStringWriter() {
    this.p61_1 = StringBuilder_init_$Create$(128);
  }
  protoOf(JsonToStringWriter).d65 = function (value) {
    this.p61_1.i8(value);
  };
  protoOf(JsonToStringWriter).x64 = function (char) {
    this.p61_1.k8(char);
  };
  protoOf(JsonToStringWriter).z64 = function (text) {
    this.p61_1.j8(text);
  };
  protoOf(JsonToStringWriter).j65 = function (text) {
    printQuoted(this.p61_1, text);
  };
  protoOf(JsonToStringWriter).zu = function () {
    this.p61_1.mc();
  };
  protoOf(JsonToStringWriter).toString = function () {
    return this.p61_1.toString();
  };
  function createMapForCache(initialCapacity) {
    return HashMap_init_$Create$_0(initialCapacity);
  }
  function Language(definitions) {
    this.p6f_1 = definitions;
  }
  protoOf(Language).q6f = function (aspect) {
    if (!isInterface(aspect, LanguageAspect))
      THROW_CCE();
    var tmp0_elvis_lhs = this.p6f_1.q2(aspect);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var aspectDefinitions = tmp;
    return aspect.r6f(aspectDefinitions);
  };
  function LanguageAspect() {
  }
  function language(body) {
    var builder = new LanguageBuilderImpl();
    body(builder);
    return builder.f40();
  }
  function LanguageBuilderImpl() {
    var tmp = this;
    // Inline function 'kotlin.collections.hashMapOf' call
    tmp.s6f_1 = HashMap_init_$Create$();
  }
  protoOf(LanguageBuilderImpl).t6f = function (aspect, definition) {
    // Inline function 'kotlin.collections.getOrPut' call
    var this_0 = this.s6f_1;
    var value = this_0.q2(aspect);
    var tmp;
    if (value == null) {
      // Inline function 'kotlin.collections.arrayListOf' call
      var answer = ArrayList_init_$Create$();
      this_0.t2(aspect, answer);
      tmp = answer;
    } else {
      tmp = value;
    }
    tmp.j(definition);
  };
  protoOf(LanguageBuilderImpl).f40 = function () {
    return new Language(this.s6f_1);
  };
  function LanguageConfigurationException_init_$Init$($this) {
    Exception_init_$Init$($this);
    LanguageConfigurationException.call($this);
    return $this;
  }
  function LanguageConfigurationException_init_$Create$() {
    var tmp = LanguageConfigurationException_init_$Init$(objectCreate(protoOf(LanguageConfigurationException)));
    captureStack(tmp, LanguageConfigurationException_init_$Create$);
    return tmp;
  }
  function LanguageConfigurationException_init_$Init$_0(message, $this) {
    Exception_init_$Init$_0(message, $this);
    LanguageConfigurationException.call($this);
    return $this;
  }
  function LanguageConfigurationException_init_$Create$_0(message) {
    var tmp = LanguageConfigurationException_init_$Init$_0(message, objectCreate(protoOf(LanguageConfigurationException)));
    captureStack(tmp, LanguageConfigurationException_init_$Create$_0);
    return tmp;
  }
  function LanguageConfigurationException() {
    captureStack(this, LanguageConfigurationException);
  }
  function DefaultNodeStorage() {
  }
  protoOf(DefaultNodeStorage).u6f = function (nodePointer, node) {
    return DocumentIdUtil_getInstance().w6f(node, nodePointer.documentId);
  };
  var DefaultNodeStorage_instance;
  function DefaultNodeStorage_getInstance() {
    return DefaultNodeStorage_instance;
  }
  function LocalNodePointerSupport$node$$inlined$query$1(this$0, $nodePointer) {
    this.x6f_1 = this$0;
    this.y6f_1 = $nodePointer;
  }
  protoOf(LocalNodePointerSupport$node$$inlined$query$1).n5w = function (builder) {
    var tmp$ret$0;
    $l$block: {
      var tmp0_elvis_lhs = builder.l60(this.x6f_1.a6g_1.c6g(this.y6f_1.documentId));
      var tmp;
      if (tmp0_elvis_lhs == null) {
        tmp$ret$0 = null;
        break $l$block;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var doc = tmp;
      var tmp1_elvis_lhs = (isInterface(doc, TypedOtNode) ? doc : THROW_CCE()).g3t();
      var tmp_0;
      if (tmp1_elvis_lhs == null) {
        throw IllegalStateException_init_$Create$_0('Document node ' + doc.d6g().m5y().uv() + ' is not attached to a model');
      } else {
        tmp_0 = tmp1_elvis_lhs;
      }
      var model = tmp_0;
      // Inline function 'kotlin.collections.getOrPut' call
      var this_0 = this.x6f_1.b6g_1;
      var value = this_0.q2(model);
      var tmp_1;
      if (value == null) {
        var answer = new FindNodeQueryProvider(model);
        this_0.t2(model, answer);
        tmp_1 = answer;
      } else {
        tmp_1 = value;
      }
      var queryProvider = tmp_1;
      var tmp2_safe_receiver = builder.l60(queryProvider.h6g(this.y6f_1.nodeId));
      tmp$ret$0 = tmp2_safe_receiver == null ? null : toDomainNode(tmp2_safe_receiver, this.x6f_1.z6f_1);
    }
    return tmp$ret$0;
  };
  function LocalNodePointerSupport(wrapperContext, documentRepository) {
    this.z6f_1 = wrapperContext;
    this.a6g_1 = documentRepository;
    var tmp = this;
    // Inline function 'kotlin.collections.hashMapOf' call
    tmp.b6g_1 = HashMap_init_$Create$();
  }
  protoOf(LocalNodePointerSupport).i6g = function (nodePointer) {
    // Inline function 'jetbrains.ocelot.langDef.query.query' call
    return new LocalNodePointerSupport$node$$inlined$query$1(this, nodePointer);
  };
  protoOf(LocalNodePointerSupport).zr = function () {
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = this.b6g_1.s2().m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      element.zr();
    }
    this.b6g_1.k2();
  };
  function NodePointer_init_$Init$(documentId, nodeId, $this) {
    documentId = documentId === VOID ? '' : documentId;
    NodePointer.call($this, documentId, new NodeId(nodeId));
    return $this;
  }
  function NodePointerConstructor(documentId, nodeId) {
    return NodePointer_init_$Init$(documentId, nodeId, objectCreate(protoOf(NodePointer)));
  }
  function Companion_86() {
  }
  protoOf(Companion_86).i63 = function () {
    return NodePointerSerializer_getInstance();
  };
  var Companion_instance_86;
  function Companion_getInstance_86() {
    return Companion_instance_86;
  }
  function NodePointer(documentId, nodeId) {
    documentId = documentId === VOID ? '' : documentId;
    this.documentId = documentId;
    this.nodeId = nodeId;
  }
  protoOf(NodePointer).d6g = function () {
    return this.documentId;
  };
  protoOf(NodePointer).v3w = function () {
    return this.nodeId;
  };
  protoOf(NodePointer).toString = function () {
    return Companion_instance_87.j6g(this);
  };
  protoOf(NodePointer).fg = function () {
    return this.documentId;
  };
  protoOf(NodePointer).gg = function () {
    return this.nodeId;
  };
  protoOf(NodePointer).k6g = function (documentId, nodeId) {
    return new NodePointer(documentId, nodeId);
  };
  protoOf(NodePointer).copy = function (documentId, nodeId, $super) {
    documentId = documentId === VOID ? this.documentId : documentId;
    nodeId = nodeId === VOID ? this.nodeId : nodeId;
    return $super === VOID ? this.k6g(documentId, nodeId) : $super.k6g.call(this, documentId, nodeId);
  };
  protoOf(NodePointer).hashCode = function () {
    var result = getStringHashCode(this.documentId);
    result = imul(result, 31) + this.nodeId.hashCode() | 0;
    return result;
  };
  protoOf(NodePointer).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof NodePointer))
      return false;
    if (!(this.documentId === other.documentId))
      return false;
    if (!this.nodeId.equals(other.nodeId))
      return false;
    return true;
  };
  function NodePointerSerializer() {
    NodePointerSerializer_instance = this;
    this.l6g_1 = PrimitiveSerialDescriptor(ensureNotNull(getKClass(NodePointer).ra()), STRING_getInstance());
    this.m6g_1 = _Char___init__impl__6a9atx(47);
  }
  protoOf(NodePointerSerializer).v58 = function () {
    return this.l6g_1;
  };
  protoOf(NodePointerSerializer).j59 = function (decoder) {
    var value = decoder.c5c();
    var cs = split(value, charArrayOf([_Char___init__impl__6a9atx(47)]), VOID, 2);
    if (!(cs.p() === 2)) {
      throw SerializationException_init_$Create$_0("Expected two components divided by '/' but got '" + value + "'");
    }
    return NodePointerConstructor(cs.r(0), cs.r(1));
  };
  protoOf(NodePointerSerializer).n6g = function (encoder, value) {
    return encoder.j5d(value.documentId + toString(_Char___init__impl__6a9atx(47)) + value.nodeId.q36_1);
  };
  protoOf(NodePointerSerializer).i59 = function (encoder, value) {
    return this.n6g(encoder, value instanceof NodePointer ? value : THROW_CCE());
  };
  var NodePointerSerializer_instance;
  function NodePointerSerializer_getInstance() {
    if (NodePointerSerializer_instance == null)
      new NodePointerSerializer();
    return NodePointerSerializer_instance;
  }
  function Companion_87() {
  }
  protoOf(Companion_87).j6g = function (pointer) {
    // Inline function 'kotlinx.serialization.json.encodeToJsonElement' call
    var this_0 = Default_getInstance_0();
    // Inline function 'kotlinx.serialization.serializer' call
    var this_1 = this_0.g59();
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_2 = serializer_2(this_1, createKType(getKClass(NodePointer), arrayOf([]), false));
    var tmp$ret$1 = isInterface(this_2, KSerializer) ? this_2 : THROW_CCE();
    var tmp$ret$2 = this_0.n61(tmp$ret$1, pointer);
    return get_jsonPrimitive(tmp$ret$2).h63();
  };
  protoOf(Companion_87).v24 = function (pointer) {
    var tmp;
    try {
      var tmp0 = Default_getInstance_0();
      // Inline function 'kotlinx.serialization.json.decodeFromJsonElement' call
      var json = JsonPrimitive_0(pointer);
      // Inline function 'kotlinx.serialization.serializer' call
      var this_0 = tmp0.g59();
      // Inline function 'kotlinx.serialization.internal.cast' call
      var this_1 = serializer_2(this_0, createKType(getKClass(NodePointer), arrayOf([]), false));
      var tmp$ret$1 = isInterface(this_1, KSerializer) ? this_1 : THROW_CCE();
      tmp = tmp0.o61(tmp$ret$1, json);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof SerializationException) {
        var e = $p;
        throw NodePointerFormatException_init_$Create$_0(e);
      } else {
        throw $p;
      }
    }
    return tmp;
  };
  var Companion_instance_87;
  function Companion_getInstance_87() {
    return Companion_instance_87;
  }
  function NodePointerFormatException_init_$Init$($this) {
    IllegalArgumentException_init_$Init$($this);
    NodePointerFormatException.call($this);
    return $this;
  }
  function NodePointerFormatException_init_$Create$() {
    var tmp = NodePointerFormatException_init_$Init$(objectCreate(protoOf(NodePointerFormatException)));
    captureStack(tmp, NodePointerFormatException_init_$Create$);
    return tmp;
  }
  function NodePointerFormatException_init_$Init$_0(cause, $this) {
    IllegalArgumentException_init_$Init$_2(cause, $this);
    NodePointerFormatException.call($this);
    return $this;
  }
  function NodePointerFormatException_init_$Create$_0(cause) {
    var tmp = NodePointerFormatException_init_$Init$_0(cause, objectCreate(protoOf(NodePointerFormatException)));
    captureStack(tmp, NodePointerFormatException_init_$Create$_0);
    return tmp;
  }
  function NodePointerFormatException() {
    captureStack(this, NodePointerFormatException);
  }
  function Companion_88() {
  }
  var Companion_instance_88;
  function Companion_getInstance_88() {
    return Companion_instance_88;
  }
  function NodePointersService(provider) {
    this.o6g_1 = provider;
  }
  protoOf(NodePointersService).p6g = function () {
    return this.o6g_1();
  };
  function EmptyNodeStorage() {
  }
  protoOf(EmptyNodeStorage).u6f = function (nodePointer, node) {
  };
  var EmptyNodeStorage_instance;
  function EmptyNodeStorage_getInstance() {
    return EmptyNodeStorage_instance;
  }
  function Companion_89() {
    Companion_instance_89 = this;
    this.q6g_1 = new NodeStorageService(EmptyNodeStorage_instance);
  }
  protoOf(Companion_89).g3b = function () {
    return this.q6g_1;
  };
  var Companion_instance_89;
  function Companion_getInstance_89() {
    if (Companion_instance_89 == null)
      new Companion_89();
    return Companion_instance_89;
  }
  function NodeStorageService(nodeStorage) {
    Companion_getInstance_89();
    this.r6g_1 = nodeStorage;
  }
  function get_OT_NODE_FACTORY_CONTEXT_KEY() {
    _init_properties_OtNodeFactoryService_kt__g7p7wy();
    return OT_NODE_FACTORY_CONTEXT_KEY;
  }
  var OT_NODE_FACTORY_CONTEXT_KEY;
  function get_nodeFactory(_this__u8e3s4) {
    _init_properties_OtNodeFactoryService_kt__g7p7wy();
    var tmp0_elvis_lhs = _this__u8e3s4.n58(get_OT_NODE_FACTORY_CONTEXT_KEY());
    return tmp0_elvis_lhs == null ? RawNodeFactory_instance : tmp0_elvis_lhs;
  }
  function OtNodeFactoryService() {
  }
  var OtNodeFactoryService_instance;
  function OtNodeFactoryService_getInstance() {
    return OtNodeFactoryService_instance;
  }
  var properties_initialized_OtNodeFactoryService_kt_4iwfjo;
  function _init_properties_OtNodeFactoryService_kt__g7p7wy() {
    if (!properties_initialized_OtNodeFactoryService_kt_4iwfjo) {
      properties_initialized_OtNodeFactoryService_kt_4iwfjo = true;
      OT_NODE_FACTORY_CONTEXT_KEY = new WrapperContextKey('otNodeFactory');
    }
  }
  function Companion_90() {
  }
  protoOf(Companion_90).i63 = function () {
    return $serializer_getInstance();
  };
  var Companion_instance_90;
  function Companion_getInstance_90() {
    return Companion_instance_90;
  }
  function $serializer() {
    $serializer_instance = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('jetbrains.ocelot.langDef.model.SerializedNode', this, 2);
    tmp0_serialDesc.q5j('content', false);
    tmp0_serialDesc.q5j('pointer', false);
    this.s6g_1 = tmp0_serialDesc;
  }
  protoOf($serializer).t6g = function (encoder, value) {
    var tmp0_desc = this.s6g_1;
    var tmp1_output = encoder.g5c(tmp0_desc);
    tmp1_output.u5d(tmp0_desc, 0, value.content);
    tmp1_output.w5d(tmp0_desc, 1, NodePointerSerializer_getInstance(), value.pointer);
    tmp1_output.h5c(tmp0_desc);
  };
  protoOf($serializer).i59 = function (encoder, value) {
    return this.t6g(encoder, value instanceof SerializedNode ? value : THROW_CCE());
  };
  protoOf($serializer).j59 = function (decoder) {
    var tmp0_desc = this.s6g_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.g5c(tmp0_desc);
    if (tmp6_input.v5c()) {
      tmp4_local0 = tmp6_input.q5c(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.s5c(tmp0_desc, 1, NodePointerSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.w5c(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.q5c(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.s5c(tmp0_desc, 1, NodePointerSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.h5c(tmp0_desc);
    return SerializedNode_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer).v58 = function () {
    return this.s6g_1;
  };
  protoOf($serializer).f5k = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), NodePointerSerializer_getInstance()];
  };
  var $serializer_instance;
  function $serializer_getInstance() {
    if ($serializer_instance == null)
      new $serializer();
    return $serializer_instance;
  }
  function SerializedNode_init_$Init$(seen0, content, pointer, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance().s6g_1);
    }
    $this.content = content;
    $this.pointer = pointer;
    return $this;
  }
  function SerializedNode_init_$Create$(seen0, content, pointer, serializationConstructorMarker) {
    return SerializedNode_init_$Init$(seen0, content, pointer, serializationConstructorMarker, objectCreate(protoOf(SerializedNode)));
  }
  function SerializedNode(content, pointer) {
    this.content = content;
    this.pointer = pointer;
  }
  protoOf(SerializedNode).h63 = function () {
    return this.content;
  };
  protoOf(SerializedNode).u6g = function () {
    return this.pointer;
  };
  protoOf(SerializedNode).fg = function () {
    return this.content;
  };
  protoOf(SerializedNode).gg = function () {
    return this.pointer;
  };
  protoOf(SerializedNode).v6g = function (content, pointer) {
    return new SerializedNode(content, pointer);
  };
  protoOf(SerializedNode).copy = function (content, pointer, $super) {
    content = content === VOID ? this.content : content;
    pointer = pointer === VOID ? this.pointer : pointer;
    return $super === VOID ? this.v6g(content, pointer) : $super.v6g.call(this, content, pointer);
  };
  protoOf(SerializedNode).toString = function () {
    return 'SerializedNode(content=' + this.content + ', pointer=' + this.pointer.toString() + ')';
  };
  protoOf(SerializedNode).hashCode = function () {
    var result = getStringHashCode(this.content);
    result = imul(result, 31) + this.pointer.hashCode() | 0;
    return result;
  };
  protoOf(SerializedNode).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SerializedNode))
      return false;
    if (!(this.content === other.content))
      return false;
    if (!this.pointer.equals(other.pointer))
      return false;
    return true;
  };
  function getChildLink($this, roleData) {
    var tmp0_elvis_lhs = getChildLink_0(otConceptRegistry($this.w6g_1), roleData.z6g_1, roleData.a6h_1);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalStateException_init_$Create$_0('Unable to deserialize child link from OT child role ' + roleData.a6h_1.toString() + ' in concept ' + roleData.z6g_1.toString() + ', association is not found');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function otRoleData($this, _this__u8e3s4) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.require' call
    if (!isInterface(_this__u8e3s4, OtChildProperty)) {
      var message = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    return _this__u8e3s4.l3p();
  }
  function otRoleData_0($this, _this__u8e3s4) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.require' call
    if (!isInterface(_this__u8e3s4, OtChildrenList)) {
      var message = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    return _this__u8e3s4.l3p();
  }
  function DomainNodePersister(wrapperContext, nodeFactory) {
    this.w6g_1 = wrapperContext;
    this.x6g_1 = new NullPersisterForNullable();
    this.y6g_1 = new OTNodePersister(nodeFactory);
  }
  protoOf(DomainNodePersister).m25 = function () {
    return this.x6g_1;
  };
  protoOf(DomainNodePersister).b6h = function (value) {
    return this.y6g_1.e6h(toOtNode(value));
  };
  protoOf(DomainNodePersister).n25 = function (value) {
    return this.b6h((!(value == null) ? isInterface(value, DomainNode) : false) ? value : THROW_CCE());
  };
  protoOf(DomainNodePersister).o25 = function (value) {
    var tmp = toDomainNode(this.y6g_1.o25(value), this.w6g_1);
    return isInterface(tmp, DomainNode) ? tmp : THROW_CCE();
  };
  protoOf(DomainNodePersister).f6h = function (node, link) {
    var tmp;
    if (link instanceof SingleChildLink) {
      tmp = otRoleData(this, link.j6h_1(node));
    } else {
      if (link instanceof MultipleChildLink) {
        tmp = otRoleData_0(this, link.h6h_1(node));
      } else {
        noWhenBranchMatchedException();
      }
    }
    var roleData = tmp;
    return OTLinkPersister_instance.k6h(roleData);
  };
  protoOf(DomainNodePersister).l6h = function (value) {
    return getChildLink(this, OTLinkPersister_instance.m6h(value));
  };
  function FindNodeQueryProvider$createNodeRegisterListener$o$onRegister$lambda(it) {
    it.n2s(Unit_instance);
    return Unit_instance;
  }
  function FindNodeQueryProvider$createNodeRegisterListener$o$onUnregister$lambda(it) {
    it.n2s(Unit_instance);
    return Unit_instance;
  }
  function createNodeRegisterListener($this) {
    return $this.e6g_1.i3o(new FindNodeQueryProvider$createNodeRegisterListener$1($this));
  }
  function FindNodeQueryProvider$createNodeRegisterListener$1(this$0) {
    this.n6h_1 = this$0;
  }
  protoOf(FindNodeQueryProvider$createNodeRegisterListener$1).b3o = function (node) {
    if (node.a3o()) {
      var tmp = node.z3n();
      this.n6h_1.g6g_1.l2w(tmp, FindNodeQueryProvider$createNodeRegisterListener$o$onRegister$lambda);
    }
  };
  protoOf(FindNodeQueryProvider$createNodeRegisterListener$1).c3o = function (node) {
    if (node.a3o()) {
      var tmp = node.z3n();
      this.n6h_1.g6g_1.l2w(tmp, FindNodeQueryProvider$createNodeRegisterListener$o$onUnregister$lambda);
    }
  };
  function FindNodeQueryProvider$activeNodeQueries$1(this$0) {
    this.q6h_1 = this$0;
    ListenersMap.call(this);
    this.p6h_1 = 0;
  }
  protoOf(FindNodeQueryProvider$activeNodeQueries$1).r6h = function (element) {
    if (this.p6h_1 === 0) {
      this.q6h_1.f6g_1 = createNodeRegisterListener(this.q6h_1);
    }
    this.p6h_1 = this.p6h_1 + 1 | 0;
  };
  protoOf(FindNodeQueryProvider$activeNodeQueries$1).e2w = function (element) {
    return this.r6h(element instanceof NodeId ? element : THROW_CCE());
  };
  protoOf(FindNodeQueryProvider$activeNodeQueries$1).s6h = function (element) {
    this.p6h_1 = this.p6h_1 - 1 | 0;
    if (this.p6h_1 === 0) {
      ensureNotNull(this.q6h_1.f6g_1).zr();
      this.q6h_1.f6g_1 = null;
    }
  };
  protoOf(FindNodeQueryProvider$activeNodeQueries$1).f2w = function (element) {
    return this.s6h(element instanceof NodeId ? element : THROW_CCE());
  };
  function FindNodeQueryProvider$findNode$1(this$0, $id) {
    this.t6h_1 = this$0;
    this.u6h_1 = $id;
  }
  protoOf(FindNodeQueryProvider$findNode$1).v6h = function (handler) {
    return this.t6h_1.g6g_1.k2w(this.u6h_1, handler);
  };
  protoOf(FindNodeQueryProvider$findNode$1).y2r = function (handler) {
    return this.v6h(handler);
  };
  function FindNodeQueryProvider$findNode$$inlined$query$1(this$0, $id) {
    this.w6h_1 = this$0;
    this.x6h_1 = $id;
  }
  protoOf(FindNodeQueryProvider$findNode$$inlined$query$1).n5w = function (builder) {
    builder.q5w_1.o5w_1.x5u(new FindNodeQueryProvider$findNode$1(this.w6h_1, this.x6h_1), Invalidation_getInstance().g5u_1);
    return this.w6h_1.e6g_1.g3o(this.x6h_1);
  };
  function FindNodeQueryProvider(model) {
    this.e6g_1 = model;
    this.f6g_1 = null;
    var tmp = this;
    tmp.g6g_1 = new FindNodeQueryProvider$activeNodeQueries$1(this);
  }
  protoOf(FindNodeQueryProvider).h6g = function (id) {
    // Inline function 'jetbrains.ocelot.langDef.query.query' call
    return new FindNodeQueryProvider$findNode$$inlined$query$1(this, id);
  };
  protoOf(FindNodeQueryProvider).zr = function () {
    var tmp0_safe_receiver = this.f6g_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.zr();
    }
    this.g6g_1.k2();
  };
  function OTLinkPersister() {
  }
  protoOf(OTLinkPersister).k6h = function (value) {
    var concept = value.fg();
    var role = value.gg();
    return serializeWithChildId(new PersistableLink(concept, role));
  };
  protoOf(OTLinkPersister).m6h = function (value) {
    var _destruct__k2r9zo = deserializeChildLink(value);
    var concept = _destruct__k2r9zo.fg();
    var role = _destruct__k2r9zo.gg();
    return new OTRoleData(concept, role);
  };
  var OTLinkPersister_instance;
  function OTLinkPersister_getInstance() {
    return OTLinkPersister_instance;
  }
  function serializeWithChildId(_this__u8e3s4) {
    return _this__u8e3s4.a6i(NodeIdModelKinds_getInstance().c3m_1);
  }
  function _get_conceptIdPersister__p620bx($this) {
    return (new NodeIdPersistenceContext()).q3l(NodeIdModelKinds_getInstance().a3m_1);
  }
  function Companion_91() {
    this.b6i_1 = '/';
  }
  protoOf(Companion_91).c6i = function (idKind, string) {
    var parts = split_0(string, ['/'], VOID, 2);
    if (!(parts.p() === 2)) {
      throw IllegalStateException_init_$Create$_0('Cannot deserialize link, data in wrong format: ' + string);
    }
    var roleIdPersister = (new NodeIdPersistenceContext()).q3l(idKind);
    var conceptId = _get_conceptIdPersister__p620bx(this).o25(parts.r(0));
    var roleId = roleIdPersister.o25(parts.r(1));
    return new PersistableLink(conceptId, roleId);
  };
  var Companion_instance_91;
  function Companion_getInstance_91() {
    return Companion_instance_91;
  }
  function PersistableLink(concept, role) {
    this.y6h_1 = concept;
    this.z6h_1 = role;
  }
  protoOf(PersistableLink).a6i = function (idKind) {
    var roleIdPersister = (new NodeIdPersistenceContext()).q3l(idKind);
    return plus_12(_get_conceptIdPersister__p620bx(Companion_instance_91).w24(this.y6h_1), '/') + roleIdPersister.w24(this.z6h_1);
  };
  protoOf(PersistableLink).fg = function () {
    return this.y6h_1;
  };
  protoOf(PersistableLink).gg = function () {
    return this.z6h_1;
  };
  protoOf(PersistableLink).toString = function () {
    return 'PersistableLink(concept=' + this.y6h_1.toString() + ', role=' + toString_1(this.z6h_1) + ')';
  };
  protoOf(PersistableLink).hashCode = function () {
    var result = this.y6h_1.hashCode();
    result = imul(result, 31) + this.z6h_1.hashCode() | 0;
    return result;
  };
  protoOf(PersistableLink).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PersistableLink))
      return false;
    if (!this.y6h_1.equals(other.y6h_1))
      return false;
    if (!equals(this.z6h_1, other.z6h_1))
      return false;
    return true;
  };
  function deserializeChildLink(string) {
    return Companion_instance_91.c6i(NodeIdModelKinds_getInstance().c3m_1, string);
  }
  function OTNodePersister(nodeFactory) {
    this.c6h_1 = nodeFactory;
    this.d6h_1 = new NullPersisterForNullable();
  }
  protoOf(OTNodePersister).m25 = function () {
    return this.d6h_1;
  };
  protoOf(OTNodePersister).e6h = function (value) {
    return (new Node2JsonConverter(new NodeIdPersistenceContext())).b3n(value).toString();
  };
  protoOf(OTNodePersister).n25 = function (value) {
    return this.e6h(value instanceof OtNode ? value : THROW_CCE());
  };
  protoOf(OTNodePersister).o25 = function (value) {
    var jsonBytes = encodeToByteArray(value);
    var tmp = CommonJsonStreamIterSupport_instance.h2l(jsonBytes);
    var jsonArrayReader = isInterface(tmp, JsonArrayReader) ? tmp : THROW_CCE();
    return (new Json2NodeConverter(new NodeIdPersistenceContext(), this.c6h_1)).w3l(jsonArrayReader);
  };
  function Companion_92() {
  }
  var Companion_instance_92;
  function Companion_getInstance_92() {
    return Companion_instance_92;
  }
  function SameModelNodeFinder$find$$inlined$map$1($this, this$0) {
    this.d6i_1 = $this;
    this.e6i_1 = this$0;
  }
  protoOf(SameModelNodeFinder$find$$inlined$map$1).n5w = function (builder) {
    var tmp0_safe_receiver = builder.l60(this.d6i_1);
    return tmp0_safe_receiver == null ? null : toDomainNode(tmp0_safe_receiver, this.e6i_1.f6i_1);
  };
  function SameModelNodeFinder(wrapperContext) {
    this.f6i_1 = wrapperContext;
    var tmp = this;
    // Inline function 'kotlin.collections.hashMapOf' call
    tmp.g6i_1 = HashMap_init_$Create$();
  }
  protoOf(SameModelNodeFinder).h6i = function (source, refContents) {
    var tmp0_elvis_lhs = (isInterface(source, TypedOtNode) ? source : THROW_CCE()).g3t();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Companion_getInstance_81().g60_1;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var model = tmp;
    // Inline function 'kotlin.collections.getOrPut' call
    var this_0 = this.g6i_1;
    var value = this_0.q2(model);
    var tmp_0;
    if (value == null) {
      var answer = new FindNodeQueryProvider(model);
      this_0.t2(model, answer);
      tmp_0 = answer;
    } else {
      tmp_0 = value;
    }
    var queryProvider = tmp_0;
    // Inline function 'jetbrains.ocelot.langDef.query.map' call
    var this_1 = queryProvider.h6g(refContents.i6i_1);
    // Inline function 'jetbrains.ocelot.langDef.query.query' call
    return new SameModelNodeFinder$find$$inlined$map$1(this_1, this);
  };
  protoOf(SameModelNodeFinder).j6i = function (source, refContents) {
    return this.h6i(source, refContents instanceof LocalReferenceContent ? refContents : THROW_CCE());
  };
  protoOf(SameModelNodeFinder).zr = function () {
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = this.g6i_1.s2().m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      element.zr();
    }
    this.g6i_1.k2();
  };
  function reset_1($this, newModel, newFindNodeQueryProvider) {
    var oldFindNodeQueryProvider = $this.n6i_1;
    $this.m6i_1 = newModel;
    $this.n6i_1 = newFindNodeQueryProvider;
    if (oldFindNodeQueryProvider == null)
      null;
    else {
      oldFindNodeQueryProvider.zr();
    }
  }
  function SingleRootNodePointerSupport$node$$inlined$query$1(this$0, $nodePointer) {
    this.o6i_1 = this$0;
    this.p6i_1 = $nodePointer;
  }
  protoOf(SingleRootNodePointerSupport$node$$inlined$query$1).n5w = function (builder) {
    var tmp0_safe_receiver = this.o6i_1.n6i_1;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.h6g(this.p6i_1.nodeId);
    var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : builder.l60(tmp1_safe_receiver);
    return tmp2_safe_receiver == null ? null : toDomainNode(tmp2_safe_receiver, this.o6i_1.l6i_1);
  };
  function SingleRootNodePointerSupport(wrapperContext) {
    this.l6i_1 = wrapperContext;
    this.m6i_1 = null;
    this.n6i_1 = null;
  }
  protoOf(SingleRootNodePointerSupport).i6g = function (nodePointer) {
    // Inline function 'jetbrains.ocelot.langDef.query.query' call
    return new SingleRootNodePointerSupport$node$$inlined$query$1(this, nodePointer);
  };
  protoOf(SingleRootNodePointerSupport).q6i = function (newModel) {
    reset_1(this, newModel, new FindNodeQueryProvider(newModel));
  };
  protoOf(SingleRootNodePointerSupport).zr = function () {
    reset_1(this, null, null);
  };
  function OTChildLink(childLink, roleId) {
    this.r6i_1 = childLink;
    this.s6i_1 = roleId;
  }
  function otConceptDataFor($this, conceptId) {
    return otConceptRegistry($this.a57_1).t6i(conceptId);
  }
  function toChildProperty($this, _this__u8e3s4, otRoleId) {
    return new OTChildPropertyAdapter(_this__u8e3s4, $this, new OTRoleData($this.b57_1.e3m_1, otRoleId));
  }
  function toChildrenList($this, _this__u8e3s4, otRoleId) {
    return new OTChildrenListAdapter(_this__u8e3s4, $this, new OTRoleData($this.b57_1.e3m_1, otRoleId));
  }
  function BaseNodeGen$getDescendants$lambda(it) {
    return !(it == null) ? isInterface(it, DomainNode) : false;
  }
  function BaseNodeGen$getAllChildren$lambda(it) {
    return !(it == null) ? isInterface(it, DomainNode) : false;
  }
  function BaseNodeGen(context, node) {
    NodeWrapper.call(this, context, node);
    var tmp = this;
    // Inline function 'kotlin.collections.hashMapOf' call
    tmp.w6i_1 = HashMap_init_$Create$();
  }
  protoOf(BaseNodeGen).x6i = function () {
    var tmp = this.j3h();
    return isInterface(tmp, ReadableProperty) ? tmp : THROW_CCE();
  };
  protoOf(BaseNodeGen).bp = function () {
    return this.x6i().uv();
  };
  protoOf(BaseNodeGen).y6i = function () {
    var tmp0_safe_receiver = this.b57_1.d3o();
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.e3m_1;
    var tmp;
    if (tmp1_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp1_elvis_lhs;
    }
    var parentConcept = tmp;
    var tmp2_elvis_lhs = this.b57_1.l3p();
    var tmp_0;
    if (tmp2_elvis_lhs == null) {
      return null;
    } else {
      tmp_0 = tmp2_elvis_lhs;
    }
    var otRole = tmp_0;
    var tmp_1 = otConceptDataFor(this, parentConcept).z6i(otRole);
    return (tmp_1 == null ? true : tmp_1 instanceof ChildLink) ? tmp_1 : THROW_CCE();
  };
  protoOf(BaseNodeGen).f3t = function () {
    return this.b57_1.e3m_1;
  };
  protoOf(BaseNodeGen).t42 = function () {
    var tmp0_safe_receiver = this.g3t();
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      var tmp_0 = this.a57_1.l58(tmp0_safe_receiver.k3e_1, getKClass(NodeWrapper));
      tmp = isInterface(tmp_0, DocumentNode) ? tmp_0 : null;
    }
    var tmp1_elvis_lhs = tmp;
    var tmp_1;
    if (tmp1_elvis_lhs == null) {
      // Inline function 'jetbrains.ocelot.langDef.structure.ancestorOrSelf' call
      var tmp$ret$2 = ancestorOrSelf(this, getKClass(DocumentNode));
      tmp_1 = execute_0(tmp$ret$2);
    } else {
      tmp_1 = tmp1_elvis_lhs;
    }
    return tmp_1;
  };
  protoOf(BaseNodeGen).a6j = function (tag, reference) {
    // Inline function 'kotlin.collections.contains' call
    // Inline function 'kotlin.collections.containsKey' call
    var this_0 = this.w6i_1;
    // Inline function 'kotlin.check' call
    if (!!(isInterface(this_0, KtMap) ? this_0 : THROW_CCE()).o2(tag)) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    // Inline function 'kotlin.collections.set' call
    this.w6i_1.t2(tag, reference);
  };
  protoOf(BaseNodeGen).b6j = function () {
    return this.w6i_1;
  };
  protoOf(BaseNodeGen).c6j = function (tag) {
    var tmp = this.w6i_1.q2(tag);
    return (!(tmp == null) ? isInterface(tmp, Reference) : false) ? tmp : THROW_CCE();
  };
  protoOf(BaseNodeGen).d6j = function (new_0) {
    return this.s57(new_0 instanceof BaseNodeGen ? new_0 : THROW_CCE());
  };
  protoOf(BaseNodeGen).e6j = function () {
    return this.r3p();
  };
  protoOf(BaseNodeGen).f6j = function () {
    var tmp = this.t57();
    return (!(tmp == null) ? isInterface(tmp, DomainNode) : false) ? tmp : THROW_CCE();
  };
  protoOf(BaseNodeGen).g6j = function (includeSelf) {
    // Inline function 'kotlin.sequences.filterIsInstance' call
    var this_0 = this.s3p(includeSelf);
    var tmp = filter(this_0, BaseNodeGen$getDescendants$lambda);
    return isInterface(tmp, Sequence) ? tmp : THROW_CCE();
  };
  protoOf(BaseNodeGen).h6j = function () {
    // Inline function 'kotlin.sequences.filterIsInstance' call
    var this_0 = this.t3p();
    var tmp = filter(this_0, BaseNodeGen$getAllChildren$lambda);
    return isInterface(tmp, Sequence) ? tmp : THROW_CCE();
  };
  protoOf(BaseNodeGen).i6j = function (propertyId) {
    return get_forQueries(this.n57(propertyId, Persisters_getInstance().x25('')));
  };
  protoOf(BaseNodeGen).j6j = function (propertyId) {
    return get_forQueries(this.m57(propertyId));
  };
  protoOf(BaseNodeGen).k6j = function (propertyId) {
    return this.o6j(propertyId, AttributePersisters_getInstance().m6j_1);
  };
  protoOf(BaseNodeGen).p6j = function (propertyId) {
    return get_forQueries(this.o57(propertyId));
  };
  protoOf(BaseNodeGen).q6j = function (propertyId) {
    return get_forQueries_3(this.j3p(propertyId));
  };
  protoOf(BaseNodeGen).o6j = function (propertyId, persister) {
    return get_forQueries(this.n57(propertyId, persister));
  };
  protoOf(BaseNodeGen).r6j = function (childLink) {
    var tmp = toChildProperty(this, this.p57(childLink.s6i_1), childLink.s6i_1);
    return isInterface(tmp, ChildProperty) ? tmp : THROW_CCE();
  };
  protoOf(BaseNodeGen).s6j = function (childrenLink) {
    var tmp = toChildrenList(this, this.q57(childrenLink.s6i_1), childrenLink.s6i_1);
    return isInterface(tmp, ChildrenList) ? tmp : THROW_CCE();
  };
  function OTRoleData(conceptId, roleId) {
    this.z6g_1 = conceptId;
    this.a6h_1 = roleId;
  }
  protoOf(OTRoleData).fg = function () {
    return this.z6g_1;
  };
  protoOf(OTRoleData).gg = function () {
    return this.a6h_1;
  };
  protoOf(OTRoleData).toString = function () {
    return 'OTRoleData(conceptId=' + this.z6g_1.toString() + ', roleId=' + this.a6h_1.toString() + ')';
  };
  protoOf(OTRoleData).hashCode = function () {
    var result = this.z6g_1.hashCode();
    result = imul(result, 31) + this.a6h_1.hashCode() | 0;
    return result;
  };
  protoOf(OTRoleData).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof OTRoleData))
      return false;
    if (!this.z6g_1.equals(other.z6g_1))
      return false;
    if (!this.a6h_1.equals(other.a6h_1))
      return false;
    return true;
  };
  function OTChildPropertyAdapter(observable, parent, role) {
    QPropertyAdapter.call(this, observable);
    this.u6j_1 = parent;
    this.v6j_1 = role;
  }
  protoOf(OTChildPropertyAdapter).l3p = function () {
    return this.v6j_1;
  };
  function OTChildrenListAdapter(observable, parent, role) {
    QMutableListAdapter.call(this, observable);
    this.x6j_1 = parent;
    this.y6j_1 = role;
  }
  protoOf(OTChildrenListAdapter).bp = function () {
    return this.x6j_1;
  };
  protoOf(OTChildrenListAdapter).l3p = function () {
    return this.y6j_1;
  };
  function get_property(_this__u8e3s4) {
    return NodePropertyIdFactory_getInstance().a3r(_this__u8e3s4, _this__u8e3s4);
  }
  function referenceProperty($this, referencePropertyDescriptor) {
    return new DomainNodeReferenceProperty($this, referencePropertyDescriptor);
  }
  function BaseTypedOtNode$getDescendants$lambda(it) {
    return !(it == null) ? isInterface(it, DomainNode) : false;
  }
  function BaseTypedOtNode$getAllChildren$lambda(it) {
    return !(it == null) ? isInterface(it, DomainNode) : false;
  }
  function BaseTypedOtNode(context, nodeConceptId, nodeId) {
    OtNode.call(this, nodeConceptId, nodeId);
    this.j6k_1 = context;
    this.k6k_1 = null;
  }
  protoOf(BaseTypedOtNode).t42 = function () {
    var tmp0_safe_receiver = this.g3m_1;
    var tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.k3e_1;
    var tmp1_elvis_lhs = (!(tmp == null) ? isInterface(tmp, DocumentNode) : false) ? tmp : null;
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      // Inline function 'jetbrains.ocelot.langDef.structure.ancestorOrSelf' call
      var tmp$ret$0 = ancestorOrSelf(this, getKClass(DocumentNode));
      tmp_0 = execute_0(tmp$ret$0);
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    return tmp_0;
  };
  protoOf(BaseTypedOtNode).x6i = function () {
    var tmp = this.j3h();
    return isInterface(tmp, ReadableProperty) ? tmp : THROW_CCE();
  };
  protoOf(BaseTypedOtNode).y6i = function () {
    var tmp0_safe_receiver = this.d3o();
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.e3m_1;
    var tmp;
    if (tmp1_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp1_elvis_lhs;
    }
    var parentConceptId = tmp;
    var tmp2_elvis_lhs = this.l3p();
    var tmp_0;
    if (tmp2_elvis_lhs == null) {
      return null;
    } else {
      tmp_0 = tmp2_elvis_lhs;
    }
    var childId = tmp_0;
    var tmp_1 = getChildLink_0(this.j6k_1.l6k_1, parentConceptId, childId);
    return tmp_1 instanceof ChildLink ? tmp_1 : null;
  };
  protoOf(BaseTypedOtNode).c3e = function () {
    return !(this.k6k_1 == null) ? setOf(DocumentIdUtil_getInstance().v6f_1) : emptySet();
  };
  protoOf(BaseTypedOtNode).z3d = function () {
    return emptySet();
  };
  protoOf(BaseTypedOtNode).w2m = function () {
    var tmp;
    var tmp0 = this.c3e();
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var tmp_0;
      if (isInterface(tmp0, Collection)) {
        tmp_0 = tmp0.s();
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
      var _iterator__ex2g4s = tmp0.m();
      while (_iterator__ex2g4s.n()) {
        var element = _iterator__ex2g4s.o();
        if (!(this.k3n(element) == null)) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
      }
      tmp$ret$0 = true;
    }
    if (tmp$ret$0) {
      var tmp0_0 = this.z3d();
      var tmp$ret$2;
      $l$block_2: {
        // Inline function 'kotlin.collections.all' call
        var tmp_1;
        if (isInterface(tmp0_0, Collection)) {
          tmp_1 = tmp0_0.s();
        } else {
          tmp_1 = false;
        }
        if (tmp_1) {
          tmp$ret$2 = true;
          break $l$block_2;
        }
        var _iterator__ex2g4s_0 = tmp0_0.m();
        while (_iterator__ex2g4s_0.n()) {
          var element_0 = _iterator__ex2g4s_0.o();
          if (!this.p3m(element_0).s()) {
            tmp$ret$2 = false;
            break $l$block_2;
          }
        }
        tmp$ret$2 = true;
      }
      tmp = tmp$ret$2;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(BaseTypedOtNode).n6k = function () {
    return this.j6k_1.l6k_1.t6i(this.e3m_1);
  };
  protoOf(BaseTypedOtNode).f6j = function () {
    var tmp = this.q3p();
    return isInterface(tmp, DomainNode) ? tmp : THROW_CCE();
  };
  protoOf(BaseTypedOtNode).d6j = function (new_0) {
    this.u3p(new_0 instanceof OtNode ? new_0 : THROW_CCE());
  };
  protoOf(BaseTypedOtNode).e6j = function () {
    this.r3p();
  };
  protoOf(BaseTypedOtNode).g6j = function (includeSelf) {
    // Inline function 'kotlin.sequences.filterIsInstance' call
    var this_0 = this.s3p(includeSelf);
    var tmp = filter(this_0, BaseTypedOtNode$getDescendants$lambda);
    return isInterface(tmp, Sequence) ? tmp : THROW_CCE();
  };
  protoOf(BaseTypedOtNode).h6j = function () {
    // Inline function 'kotlin.sequences.filterIsInstance' call
    var this_0 = this.t3p();
    var tmp = filter(this_0, BaseTypedOtNode$getAllChildren$lambda);
    return isInterface(tmp, Sequence) ? tmp : THROW_CCE();
  };
  protoOf(BaseTypedOtNode).b6j = function () {
    // Inline function 'kotlin.collections.associate' call
    var this_0 = this.n6k().o6k();
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
    // Inline function 'kotlin.collections.associateTo' call
    var destination = LinkedHashMap_init_$Create$_0(capacity);
    var _iterator__ex2g4s = this_0.m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      var tmp = element.t6k_1.q6k_1;
      // Inline function 'kotlin.collections.plusAssign' call
      var pair = to(element.u6k_1, (isInterface(tmp, KProperty1) ? tmp : THROW_CCE())(this));
      destination.t2(pair.pg_1, pair.qg_1);
    }
    return destination;
  };
  protoOf(BaseTypedOtNode).c6j = function (tag) {
    // Inline function 'kotlin.collections.single' call
    var single = null;
    var found = false;
    var _iterator__ex2g4s = this.n6k().o6k().m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      if (element.u6k_1.equals(tag)) {
        if (found)
          throw IllegalArgumentException_init_$Create$_0('Collection contains more than one matching element.');
        single = element;
        found = true;
      }
    }
    if (!found)
      throw NoSuchElementException_init_$Create$_0('Collection contains no element matching the predicate.');
    var referenceLink = ((single == null ? true : !(single == null)) ? single : THROW_CCE()).t6k_1;
    var tmp = referenceLink.q6k_1;
    return (isInterface(tmp, KProperty1) ? tmp : THROW_CCE())(this);
  };
  protoOf(BaseTypedOtNode).k3n = function (propertyId) {
    if (propertyId.equals(DocumentIdUtil_getInstance().v6f_1)) {
      return this.k6k_1;
    }
    return this.v6k(propertyId);
  };
  protoOf(BaseTypedOtNode).v6k = function (propertyId) {
    // Inline function 'kotlin.error' call
    var message = 'Unexpected property ' + propertyId.y2() + ' in node ' + this.toString();
    throw IllegalStateException_init_$Create$_0(toString_1(message));
  };
  protoOf(BaseTypedOtNode).i3p = function (propertyId, value, oldValue) {
    if (oldValue == value)
      return true;
    if (propertyId.equals(DocumentIdUtil_getInstance().v6f_1)) {
      this.k6k_1 = value;
      return false;
    }
    this.w6k(propertyId, value);
    return false;
  };
  protoOf(BaseTypedOtNode).w6k = function (propertyId, value) {
    // Inline function 'kotlin.error' call
    var message = 'Unexpected property ' + propertyId.y2() + ' in node ' + this.toString();
    throw IllegalStateException_init_$Create$_0(toString_1(message));
  };
  protoOf(BaseTypedOtNode).p3m = function (childId) {
    // Inline function 'kotlin.error' call
    var message = 'Unexpected child ' + childId.y2() + ' in node ' + this.toString();
    throw IllegalStateException_init_$Create$_0(toString_1(message));
  };
  protoOf(BaseTypedOtNode).x6k = function (propertyDescriptor) {
    return new DomainNodeProperty(this, propertyDescriptor);
  };
  protoOf(BaseTypedOtNode).y6k = function (textPropertyDescriptor) {
    return new DomainNodeTextProperty(this, textPropertyDescriptor);
  };
  protoOf(BaseTypedOtNode).z6k = function (referencePropertyDescriptor) {
    var referenceProperty_0 = referenceProperty(this, referencePropertyDescriptor);
    var tmp = getReferenceTag(this.n6k(), referencePropertyDescriptor.a6l_1);
    var tmp0_elvis_lhs = tmp instanceof RefTag ? tmp : null;
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      var message = 'Failed to get reference tag ' + referencePropertyDescriptor.a6l_1.toString();
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var refTag = tmp_0;
    var reference = createReference(this.j6k_1.m6k_1, refTag, this, referenceProperty_0);
    return reference;
  };
  protoOf(BaseTypedOtNode).d6l = function (childPropertyDescriptor) {
    var list = new ChildrenObservableList(this, childPropertyDescriptor.e6l_1);
    list.x2r(this);
    return list;
  };
  protoOf(BaseTypedOtNode).f6l = function (childrenObservableList) {
    return new DomainNodeChildProperty(isInterface(childrenObservableList, MutableObservableCollection) ? childrenObservableList : THROW_CCE());
  };
  protoOf(BaseTypedOtNode).g6l = function (childrenPropertyDescriptor) {
    var list = new ChildrenObservableList(this, childrenPropertyDescriptor.h6l_1);
    list.x2r(this);
    return list;
  };
  protoOf(BaseTypedOtNode).i6l = function (childrenObservableList) {
    return new DomainNodeChildrenProperty(isInterface(childrenObservableList, MutableObservableList) ? childrenObservableList : THROW_CCE());
  };
  function get_OT_CONCEPT_REGISTRY_CONTEXT_KEY() {
    _init_properties_ConceptRegistry_kt__idoyjx();
    return OT_CONCEPT_REGISTRY_CONTEXT_KEY;
  }
  var OT_CONCEPT_REGISTRY_CONTEXT_KEY;
  function otConceptRegistry(_this__u8e3s4) {
    _init_properties_ConceptRegistry_kt__idoyjx();
    return _this__u8e3s4.m58(get_OT_CONCEPT_REGISTRY_CONTEXT_KEY());
  }
  function NodeWrapperConceptRegistry() {
  }
  function createInstance(_this__u8e3s4, sourceClass, context) {
    _init_properties_ConceptRegistry_kt__idoyjx();
    return _this__u8e3s4.l6l(sourceClass).q6l(context.m58(Companion_getInstance_93().p6l_1));
  }
  function getChildLink_0(_this__u8e3s4, conceptId, roleId) {
    _init_properties_ConceptRegistry_kt__idoyjx();
    return _this__u8e3s4.t6i(conceptId).z6i(roleId);
  }
  function createInstance_0(_this__u8e3s4, sourceClass, id, context) {
    _init_properties_ConceptRegistry_kt__idoyjx();
    return _this__u8e3s4.l6l(sourceClass).r6l(context.m58(Companion_getInstance_93().p6l_1), id);
  }
  var properties_initialized_ConceptRegistry_kt_hz306j;
  function _init_properties_ConceptRegistry_kt__idoyjx() {
    if (!properties_initialized_ConceptRegistry_kt_hz306j) {
      properties_initialized_ConceptRegistry_kt_hz306j = true;
      OT_CONCEPT_REGISTRY_CONTEXT_KEY = new WrapperContextKey('otConceptRegistry');
    }
  }
  function Companion_93() {
    Companion_instance_93 = this;
    this.p6l_1 = new WrapperContextKey('NODE_SETUP');
  }
  var Companion_instance_93;
  function Companion_getInstance_93() {
    if (Companion_instance_93 == null)
      new Companion_93();
    return Companion_instance_93;
  }
  function NodeSetupContext(wrapperContext, referenceFactoryRegistry) {
    Companion_getInstance_93();
    this.s6l_1 = wrapperContext;
    this.t6l_1 = referenceFactoryRegistry;
  }
  protoOf(NodeSetupContext).u6l = function (referencePropertyId, source) {
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.NodeSetupContext.createReference' call
    var tmp = getReferenceTag(otConceptRegistry(this.s6l_1).t6i(source.f3t()), referencePropertyId);
    var refTag = (tmp == null ? true : tmp instanceof RefTag) ? tmp : THROW_CCE();
    // Inline function 'kotlin.check' call
    if (!!(refTag == null)) {
      var message = "reference property id is not registered: '" + referencePropertyId.toString() + "' for source: '" + source.toString() + "'";
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    var tmp$ret$2 = get_forQueries(source.n57(referencePropertyId, ReferenceContentPersisters_getInstance().d6m(refTag.x6l_1)));
    var reference = createReference_0(this.t6l_1, refTag, source, tmp$ret$2);
    var tmp0_safe_receiver = source instanceof BaseNodeGen ? source : null;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.a6j(refTag, reference);
    }
    return reference;
  };
  function NodeSetupContextService() {
  }
  var NodeSetupContextService_instance;
  function NodeSetupContextService_getInstance() {
    return NodeSetupContextService_instance;
  }
  function registerMember($this, id, property) {
    // Inline function 'kotlin.collections.contains' call
    // Inline function 'kotlin.collections.containsKey' call
    var this_0 = $this.j6m_1;
    // Inline function 'kotlin.check' call
    if (!!(isInterface(this_0, KtMap) ? this_0 : THROW_CCE()).o2(id)) {
      var message = 'Duplicate member id: ' + id.toString();
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    // Inline function 'kotlin.collections.set' call
    $this.j6m_1.t2(id, property);
  }
  function Companion_94() {
  }
  protoOf(Companion_94).k6m = function (descriptors) {
    return listOf_0(descriptors.slice());
  };
  var Companion_instance_94;
  function Companion_getInstance_94() {
    return Companion_instance_94;
  }
  function OTAbstractConceptDescriptor(superConcepts) {
    superConcepts = superConcepts === VOID ? emptyList() : superConcepts;
    this.e6m_1 = superConcepts;
    var tmp = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp.f6m_1 = LinkedHashMap_init_$Create$();
    var tmp_0 = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp_0.g6m_1 = LinkedHashMap_init_$Create$();
    var tmp_1 = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp_1.h6m_1 = LinkedHashMap_init_$Create$();
    var tmp_2 = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp_2.i6m_1 = LinkedHashMap_init_$Create$();
    var tmp_3 = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp_3.j6m_1 = LinkedHashMap_init_$Create$();
  }
  protoOf(OTAbstractConceptDescriptor).l6m = function (link, name) {
    var id = get_property(name);
    // Inline function 'kotlin.check' call
    if (!!this.f6m_1.o2(id)) {
      var message = 'Duplicate property(attribute) id: ' + name;
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    // Inline function 'kotlin.collections.set' call
    this.f6m_1.t2(id, link);
    registerMember(this, id, link.n6m_1);
    return id;
  };
  protoOf(OTAbstractConceptDescriptor).o6m = function (link, name) {
    var id = NodeChildIdFactory_getInstance().j3q(name, name);
    // Inline function 'kotlin.check' call
    if (!!this.g6m_1.o2(id)) {
      var message = 'Duplicate child role id: ' + name;
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    // Inline function 'kotlin.collections.set' call
    this.g6m_1.t2(id, link);
    registerMember(this, id, link.j6h_1);
    return new OTChildLink(link, id);
  };
  protoOf(OTAbstractConceptDescriptor).p6m = function (link, name) {
    var id = NodeChildIdFactory_getInstance().e3q(name, name);
    // Inline function 'kotlin.check' call
    if (!!this.g6m_1.o2(id)) {
      var message = 'Duplicate children role id: ' + name;
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    // Inline function 'kotlin.collections.set' call
    this.g6m_1.t2(id, link);
    registerMember(this, id, link.h6h_1);
    return new OTChildLink(link, id);
  };
  protoOf(OTAbstractConceptDescriptor).q6m = function (link, tag, name) {
    // Inline function 'kotlin.also' call
    var this_0 = NodePropertyIdFactory_getInstance().b3r(name);
    // Inline function 'kotlin.check' call
    if (!!this.i6m_1.o2(this_0)) {
      var message = 'Duplicate reference role id: ' + name;
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    var tmp0 = this.i6m_1;
    // Inline function 'kotlin.collections.set' call
    var value = new ReferenceData(link, tag);
    tmp0.t2(this_0, value);
    registerMember(this, this_0, link.q6k_1);
    return this_0;
  };
  protoOf(OTAbstractConceptDescriptor).r6m = function (property, name) {
    // Inline function 'kotlin.also' call
    var this_0 = get_property(name);
    registerMember(this, this_0, property);
    return this_0;
  };
  function getReferenceTag(_this__u8e3s4, propertyId) {
    var tmp0_safe_receiver = _this__u8e3s4.s6m(propertyId);
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.u6k_1;
  }
  function OTConcept() {
  }
  function DomainNodeFactory() {
  }
  function OTConceptWrapper() {
  }
  function DomainNodeWrapperFactory() {
  }
  function getReferenceLink(_this__u8e3s4, propertyId) {
    var tmp0_safe_receiver = _this__u8e3s4.s6m(propertyId);
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.t6k_1;
  }
  function otConceptByDescriptor(definitionClass, implementationClass, descriptor, useExperimentalNode) {
    useExperimentalNode = useExperimentalNode === VOID ? false : useExperimentalNode;
    var idMapping = otIdMapping(descriptor);
    var tmp;
    if (useExperimentalNode) {
      var tmp_0;
      if (descriptor instanceof OtConceptDescriptor) {
        tmp_0 = new DomainNodeFactoryImpl(descriptor);
      } else {
        tmp_0 = ErrorNodeFactory_instance.x6m();
      }
      var factory = tmp_0;
      tmp = new OTConceptImpl(definitionClass, implementationClass, factory, idMapping);
    } else {
      var tmp_1;
      if (descriptor instanceof OtConceptDescriptor) {
        tmp_1 = new DomainNodeWrapperFactoryImpl(descriptor);
      } else {
        tmp_1 = ErrorNodeFactory_instance.x6m();
      }
      var factory_0 = tmp_1;
      tmp = new OTConceptWrapperImpl(definitionClass, implementationClass, factory_0, idMapping);
    }
    return tmp;
  }
  function otIdMapping(descriptor) {
    var own = new IdMapping(descriptor);
    // Inline function 'kotlin.collections.fold' call
    var accumulator = own;
    var _iterator__ex2g4s = descriptor.e6m_1.m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      var acc = accumulator;
      accumulator = plus_13(acc, otIdMapping(element));
    }
    return accumulator;
  }
  function OTConceptImpl(definitionClass, implementationClass, factory, idMapping) {
    this.y6m_1 = factory;
    this.z6m_1 = idMapping;
    this.a6n_1 = definitionClass;
    this.b6n_1 = implementationClass;
  }
  protoOf(OTConceptImpl).t6m = function () {
    return this.b6n_1;
  };
  protoOf(OTConceptImpl).r6l = function (nodeSetupContext, id) {
    return this.y6m_1.r6l(nodeSetupContext, id);
  };
  protoOf(OTConceptImpl).o6k = function () {
    return this.z6m_1.o6k();
  };
  protoOf(OTConceptImpl).z6i = function (roleId) {
    return this.z6m_1.z6i(roleId);
  };
  protoOf(OTConceptImpl).s6m = function (propertyId) {
    return this.z6m_1.s6m(propertyId);
  };
  protoOf(OTConceptImpl).u6m = function (link) {
    return this.z6m_1.u6m(link);
  };
  protoOf(OTConceptImpl).v6m = function (link) {
    return this.z6m_1.v6m(link);
  };
  function DomainNodeFactoryImpl(descriptor) {
    this.c6n_1 = descriptor;
  }
  protoOf(DomainNodeFactoryImpl).r6l = function (nodeSetupContext, id) {
    return this.c6n_1.l6n_1(get_typedNodeContext(nodeSetupContext.s6l_1), id);
  };
  function ErrorNodeFactory() {
  }
  protoOf(ErrorNodeFactory).r6l = function (nodeSetupContext, id) {
    throw IllegalStateException_init_$Create$_0('Cannot instantiate abstract concept');
  };
  protoOf(ErrorNodeFactory).w6m = function (nodeSetupContext, node) {
    throw IllegalStateException_init_$Create$_0('Trying to instantiate abstract concept for concept id ' + node.e3m_1.toString());
  };
  protoOf(ErrorNodeFactory).x6m = function () {
    var tmp = ErrorNodeFactory_instance;
    return isInterface(tmp, DomainNodeWrapperFactory) ? tmp : THROW_CCE();
  };
  var ErrorNodeFactory_instance;
  function ErrorNodeFactory_getInstance() {
    return ErrorNodeFactory_instance;
  }
  function OTConceptWrapperImpl(definitionClass, implementationClass, factory, idMapping) {
    this.n6n_1 = factory;
    this.o6n_1 = idMapping;
    this.p6n_1 = definitionClass;
    this.q6n_1 = implementationClass;
  }
  protoOf(OTConceptWrapperImpl).t6m = function () {
    return this.q6n_1;
  };
  protoOf(OTConceptWrapperImpl).r6l = function (nodeSetupContext, id) {
    return this.n6n_1.r6l(nodeSetupContext, id);
  };
  protoOf(OTConceptWrapperImpl).o6k = function () {
    return this.o6n_1.o6k();
  };
  protoOf(OTConceptWrapperImpl).z6i = function (roleId) {
    return this.o6n_1.z6i(roleId);
  };
  protoOf(OTConceptWrapperImpl).s6m = function (propertyId) {
    return this.o6n_1.s6m(propertyId);
  };
  protoOf(OTConceptWrapperImpl).u6m = function (link) {
    return this.o6n_1.u6m(link);
  };
  protoOf(OTConceptWrapperImpl).v6m = function (link) {
    return this.o6n_1.v6m(link);
  };
  protoOf(OTConceptWrapperImpl).w6m = function (nodeSetupContext, node) {
    return this.n6n_1.w6m(nodeSetupContext, node);
  };
  function DomainNodeWrapperFactoryImpl(descriptor) {
    this.r6n_1 = descriptor;
  }
  protoOf(DomainNodeWrapperFactoryImpl).r6l = function (nodeSetupContext, id) {
    return this.w6m(nodeSetupContext, new Node_0(this.r6n_1.m6n_1, id));
  };
  protoOf(DomainNodeWrapperFactoryImpl).w6m = function (nodeSetupContext, node) {
    return this.r6n_1.k6n_1(nodeSetupContext, node);
  };
  function IdMapping(descriptor) {
    this.s6n_1 = descriptor;
  }
  protoOf(IdMapping).o6k = function () {
    return this.s6n_1.i6m_1.s2();
  };
  protoOf(IdMapping).z6i = function (roleId) {
    return this.s6n_1.g6m_1.q2(roleId);
  };
  protoOf(IdMapping).s6m = function (propertyId) {
    return this.s6n_1.i6m_1.q2(propertyId);
  };
  protoOf(IdMapping).u6m = function (link) {
    var tmp0 = this.s6n_1.g6m_1.y();
    var tmp$ret$2;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var _iterator__ex2g4s = tmp0.m();
      while (_iterator__ex2g4s.n()) {
        var element = _iterator__ex2g4s.o();
        // Inline function 'kotlin.collections.component2' call
        var l = element.a1();
        if (l.equals(link)) {
          tmp$ret$2 = element;
          break $l$block;
        }
      }
      tmp$ret$2 = null;
    }
    var tmp0_safe_receiver = tmp$ret$2;
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.z();
  };
  protoOf(IdMapping).v6m = function (link) {
    var tmp0 = this.s6n_1.f6m_1.y();
    var tmp$ret$2;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var _iterator__ex2g4s = tmp0.m();
      while (_iterator__ex2g4s.n()) {
        var element = _iterator__ex2g4s.o();
        // Inline function 'kotlin.collections.component2' call
        var l = element.a1();
        if (l.equals(link)) {
          tmp$ret$2 = element;
          break $l$block;
        }
      }
      tmp$ret$2 = null;
    }
    var tmp0_safe_receiver = tmp$ret$2;
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.z();
  };
  function plus_13(_this__u8e3s4, other) {
    var first = _this__u8e3s4;
    return new plus$1(first, other);
  }
  function uncheckedCastGetOtId($this, _this__u8e3s4, link) {
    return _this__u8e3s4.u6m(link instanceof ChildLink ? link : THROW_CCE());
  }
  function uncheckedCastGetOtId_0($this, _this__u8e3s4, link) {
    return _this__u8e3s4.v6m(link instanceof AttributeLink ? link : THROW_CCE());
  }
  function plus$1($first, $other) {
    this.t6n_1 = $first;
    this.u6n_1 = $other;
  }
  protoOf(plus$1).o6k = function () {
    return plus_5(this.t6n_1.o6k(), this.u6n_1.o6k());
  };
  protoOf(plus$1).z6i = function (roleId) {
    var tmp0_elvis_lhs = this.t6n_1.z6i(roleId);
    return tmp0_elvis_lhs == null ? this.u6n_1.z6i(roleId) : tmp0_elvis_lhs;
  };
  protoOf(plus$1).s6m = function (propertyId) {
    var tmp0_elvis_lhs = this.t6n_1.s6m(propertyId);
    return tmp0_elvis_lhs == null ? this.u6n_1.s6m(propertyId) : tmp0_elvis_lhs;
  };
  protoOf(plus$1).u6m = function (link) {
    var tmp0_elvis_lhs = this.t6n_1.u6m(link);
    return tmp0_elvis_lhs == null ? uncheckedCastGetOtId(this, this.u6n_1, link) : tmp0_elvis_lhs;
  };
  protoOf(plus$1).v6m = function (link) {
    var tmp0_elvis_lhs = this.t6n_1.v6m(link);
    return tmp0_elvis_lhs == null ? uncheckedCastGetOtId_0(this, this.u6n_1, link) : tmp0_elvis_lhs;
  };
  function OTSplitMergeSupportFactory(conceptRegistry) {
    this.v6n_1 = conceptRegistry;
  }
  protoOf(OTSplitMergeSupportFactory).w6n = function (role, propertyLink) {
    var childId = this.v6n_1.l6l(role.g6h_1).u6m(role);
    var propertyId = this.v6n_1.l6l(propertyLink.m6m_1).v6m(propertyLink);
    // Inline function 'kotlin.checkNotNull' call
    $l$block: {
      // Inline function 'kotlin.checkNotNull' call
      if (childId == null) {
        var message = 'Required value was null.';
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      } else {
        break $l$block;
      }
    }
    // Inline function 'kotlin.checkNotNull' call
    $l$block_0: {
      // Inline function 'kotlin.checkNotNull' call
      if (propertyId == null) {
        var message_0 = 'Required value was null.';
        throw IllegalStateException_init_$Create$_0(toString_1(message_0));
      } else {
        break $l$block_0;
      }
    }
    return new OTSplitMergeSupport(childId, propertyId);
  };
  function OTSplitMergeSupport(childRoleId, propertyId) {
    this.x6n_1 = childRoleId;
    this.y6n_1 = propertyId;
  }
  protoOf(OTSplitMergeSupport).z6n = function (parent, childIndex, splitIndex) {
    toOtNode(parent).v3p(this.x6n_1, childIndex, this.y6n_1, splitIndex);
  };
  protoOf(OTSplitMergeSupport).a6o = function (parent, childIndex, splitIndex) {
    return this.z6n((!(parent == null) ? isInterface(parent, DomainNode) : false) ? parent : THROW_CCE(), childIndex, splitIndex);
  };
  protoOf(OTSplitMergeSupport).b6o = function (parent, child) {
    toOtNode(parent).y3p(toOtNode(child), this.y6n_1);
  };
  protoOf(OTSplitMergeSupport).c6o = function (parent, child) {
    var tmp = (!(parent == null) ? isInterface(parent, DomainNode) : false) ? parent : THROW_CCE();
    return this.b6o(tmp, isInterface(child, DomainNode) ? child : THROW_CCE());
  };
  function toNodeConceptId($this, _this__u8e3s4, withNodeId) {
    var tmp;
    if (withNodeId) {
      tmp = NodeConceptIdFactory_getInstance().q3q(_this__u8e3s4, _this__u8e3s4);
    } else {
      tmp = NodeConceptIdFactory_getInstance().t3q(_this__u8e3s4, _this__u8e3s4);
    }
    return tmp;
  }
  function OtConceptDescriptor(conceptId, matchingText, factory, experimentalFactory, superConcepts, hasNodeId) {
    matchingText = matchingText === VOID ? conceptId : matchingText;
    superConcepts = superConcepts === VOID ? emptyList() : superConcepts;
    hasNodeId = hasNodeId === VOID ? true : hasNodeId;
    OTAbstractConceptDescriptor.call(this, superConcepts);
    this.j6n_1 = matchingText;
    this.k6n_1 = factory;
    this.l6n_1 = experimentalFactory;
    this.m6n_1 = toNodeConceptId(this, conceptId, hasNodeId);
  }
  protoOf(OtConceptDescriptor).d6o = function (nodeSetupContext, nodeId) {
    var tmp;
    if (get_useExperimentalNode(nodeSetupContext.s6l_1)) {
      tmp = this.l6n_1(get_typedNodeContext(nodeSetupContext.s6l_1), nodeId);
    } else {
      tmp = this.k6n_1(nodeSetupContext, new Node_0(this.m6n_1, nodeId));
    }
    return tmp;
  };
  function get_TYPED_NODE_CONTEXT_KEY() {
    _init_properties_TypedNodeContext_kt__mhj57n();
    return TYPED_NODE_CONTEXT_KEY;
  }
  var TYPED_NODE_CONTEXT_KEY;
  function TypedNodeContext(conceptRegistry, referenceFactoryRegistry) {
    this.l6k_1 = conceptRegistry;
    this.m6k_1 = referenceFactoryRegistry;
  }
  protoOf(TypedNodeContext).toString = function () {
    return 'TypedNodeContext(conceptRegistry=' + toString_1(this.l6k_1) + ', referenceFactoryRegistry=' + toString_1(this.m6k_1) + ')';
  };
  protoOf(TypedNodeContext).hashCode = function () {
    var result = hashCode(this.l6k_1);
    result = imul(result, 31) + hashCode(this.m6k_1) | 0;
    return result;
  };
  protoOf(TypedNodeContext).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TypedNodeContext))
      return false;
    if (!equals(this.l6k_1, other.l6k_1))
      return false;
    if (!equals(this.m6k_1, other.m6k_1))
      return false;
    return true;
  };
  function get_typedNodeContext(_this__u8e3s4) {
    _init_properties_TypedNodeContext_kt__mhj57n();
    return _this__u8e3s4.m58(get_TYPED_NODE_CONTEXT_KEY());
  }
  var properties_initialized_TypedNodeContext_kt_82hs2j;
  function _init_properties_TypedNodeContext_kt__mhj57n() {
    if (!properties_initialized_TypedNodeContext_kt_82hs2j) {
      properties_initialized_TypedNodeContext_kt_82hs2j = true;
      TYPED_NODE_CONTEXT_KEY = new WrapperContextKey('typedNodeContext');
    }
  }
  function TypedOtNode() {
  }
  function get_USE_EXPERIMENTAL_NODE_KEY() {
    _init_properties_UseExperimentalNodeService_kt__v77gkk();
    return USE_EXPERIMENTAL_NODE_KEY;
  }
  var USE_EXPERIMENTAL_NODE_KEY;
  function UseExperimentalNodeService() {
  }
  var UseExperimentalNodeService_instance;
  function UseExperimentalNodeService_getInstance() {
    return UseExperimentalNodeService_instance;
  }
  function get_useExperimentalNode(_this__u8e3s4) {
    _init_properties_UseExperimentalNodeService_kt__v77gkk();
    return _this__u8e3s4.m58(get_USE_EXPERIMENTAL_NODE_KEY());
  }
  var properties_initialized_UseExperimentalNodeService_kt_3wdkmy;
  function _init_properties_UseExperimentalNodeService_kt__v77gkk() {
    if (!properties_initialized_UseExperimentalNodeService_kt_3wdkmy) {
      properties_initialized_UseExperimentalNodeService_kt_3wdkmy = true;
      USE_EXPERIMENTAL_NODE_KEY = new WrapperContextKey('useExperimentalNode');
    }
  }
  function BaseDomainNodeProperty(node) {
    BaseOtNodeProperty.call(this);
    this.e6o_1 = node;
  }
  protoOf(BaseDomainNodeProperty).i3n = function () {
    return toOtNode(this.e6o_1);
  };
  protoOf(BaseDomainNodeProperty).m5y = function () {
    return this;
  };
  protoOf(BaseDomainNodeProperty).n5w = function (builder) {
    depend(builder.q5w_1.o5w_1, this.m5y());
    return this.m5y().w2w();
  };
  function DomainNodeChildProperty(collection) {
    SingleItemCollectionProperty.call(this, collection);
  }
  protoOf(DomainNodeChildProperty).m5y = function () {
    return this;
  };
  protoOf(DomainNodeChildProperty).bp = function () {
    var tmp = this.k31_1;
    var tmp_0 = (tmp instanceof ChildrenObservableList ? tmp : THROW_CCE()).bp();
    return isInterface(tmp_0, DomainNode) ? tmp_0 : THROW_CCE();
  };
  protoOf(DomainNodeChildProperty).l3p = function () {
    return new OTRoleData(this.bp().f3t(), this.g6o());
  };
  protoOf(DomainNodeChildProperty).g6o = function () {
    var tmp = this.k31_1;
    return (tmp instanceof ChildrenObservableList ? tmp : THROW_CCE()).f3r_1;
  };
  protoOf(DomainNodeChildProperty).n5w = function (builder) {
    depend(builder.q5w_1.o5w_1, this.m5y());
    return this.m5y().w2w();
  };
  function DomainNodeChildrenProperty(collection) {
    QMutableListAdapter.call(this, collection);
  }
  protoOf(DomainNodeChildrenProperty).bp = function () {
    var tmp = this.m5y();
    var tmp_0 = (tmp instanceof ChildrenObservableList ? tmp : THROW_CCE()).bp();
    return isInterface(tmp_0, DomainNode) ? tmp_0 : THROW_CCE();
  };
  protoOf(DomainNodeChildrenProperty).l3p = function () {
    return new OTRoleData(this.bp().f3t(), this.g6o());
  };
  protoOf(DomainNodeChildrenProperty).g6o = function () {
    var tmp = this.m5y();
    return (tmp instanceof ChildrenObservableList ? tmp : THROW_CCE()).f3r_1;
  };
  function DomainNodeInMemoryProperty(value) {
    ValueProperty.call(this, value);
  }
  protoOf(DomainNodeInMemoryProperty).m5y = function () {
    return this;
  };
  protoOf(DomainNodeInMemoryProperty).n5w = function (builder) {
    depend(builder.q5w_1.o5w_1, this.m5y());
    return this.m5y().w2w();
  };
  function DomainNodeProperty(node, propertyDescriptor) {
    BaseDomainNodeProperty.call(this, node);
    this.l6o_1 = propertyDescriptor;
  }
  protoOf(DomainNodeProperty).j3n = function () {
    return this.l6o_1.m6o_1;
  };
  protoOf(DomainNodeProperty).q3c = function () {
    return this.l6o_1.n6o_1;
  };
  function DomainNodeReferenceProperty(node, referencePropertyDescriptor) {
    BaseDomainNodeProperty.call(this, node);
    this.p6o_1 = referencePropertyDescriptor;
  }
  protoOf(DomainNodeReferenceProperty).j3n = function () {
    return this.p6o_1.a6l_1;
  };
  protoOf(DomainNodeReferenceProperty).q3c = function () {
    return this.p6o_1.b6l_1;
  };
  protoOf(DomainNodeReferenceProperty).p5y = function () {
    return this.p6o_1.c6l_1;
  };
  function DomainNodeTextProperty(node, textPropertyDescriptor) {
    BaseOtNodeTextProperty.call(this);
    this.q6o_1 = node;
    this.r6o_1 = textPropertyDescriptor;
  }
  protoOf(DomainNodeTextProperty).i3n = function () {
    return toOtNode(this.q6o_1);
  };
  protoOf(DomainNodeTextProperty).j3n = function () {
    return this.r6o_1.s6o_1;
  };
  protoOf(DomainNodeTextProperty).m5y = function () {
    return this;
  };
  protoOf(DomainNodeTextProperty).n5w = function (builder) {
    depend(builder.q5w_1.o5w_1, this.m5y());
    return this.m5y().w2w();
  };
  function OtChildProperty() {
  }
  function OtChildrenList() {
  }
  function DomainNodeChildPropertyDescriptor(childId) {
    this.e6l_1 = childId;
  }
  function DomainNodeChildrenPropertyDescriptor(childrenId) {
    this.h6l_1 = childrenId;
  }
  function DomainNodePropertyDescriptor(propertyId, persister) {
    this.m6o_1 = propertyId;
    this.n6o_1 = persister;
  }
  function DomainNodeReferencePropertyDescriptor(referencePropertyId, referenceContentPersister, referenceContentClass) {
    this.a6l_1 = referencePropertyId;
    this.b6l_1 = referenceContentPersister;
    this.c6l_1 = referenceContentClass;
  }
  function DomainNodeTextPropertyDescriptor(propertyId) {
    this.s6o_1 = propertyId;
  }
  function ConstantReference(property, resolveTarget, findTarget) {
    resolveTarget = resolveTarget === VOID ? null : resolveTarget;
    findTarget = findTarget === VOID ? resolveTarget : findTarget;
    PropertyBasedReference.call(this, property);
    this.u6o_1 = constant(resolveTarget);
    this.v6o_1 = constant(findTarget);
  }
  protoOf(ConstantReference).w6o = function () {
    return this.u6o_1;
  };
  protoOf(ConstantReference).x6o = function () {
    return this.v6o_1;
  };
  protoOf(ConstantReference).d2x = function (newValue) {
    return this.b6p((newValue == null ? true : newValue instanceof ReferenceContent) ? newValue : THROW_CCE());
  };
  protoOf(ConstantReference).r5w = function (builder, $completion) {
    return this.e6p(builder, $completion);
  };
  function ElementsContext() {
  }
  function EnclosingNodeContext(node, link) {
    ElementsContext.call(this);
    this.f6p_1 = node;
    this.g6p_1 = link;
  }
  protoOf(EnclosingNodeContext).h6p = function () {
    return this.f6p_1;
  };
  function SourceNodeContext(source) {
    ElementsContext.call(this);
    this.i6p_1 = source;
  }
  function toEnclosingNodeContext(_this__u8e3s4) {
    return new EnclosingNodeContext(_this__u8e3s4.j6p_1, _this__u8e3s4.k6p_1);
  }
  function Companion_95() {
  }
  var Companion_instance_95;
  function Companion_getInstance_95() {
    return Companion_instance_95;
  }
  function GlobalNodeFinder$find$$inlined$query$1(this$0, $source, $refContents) {
    this.l6p_1 = this$0;
    this.m6p_1 = $source;
    this.n6p_1 = $refContents;
  }
  protoOf(GlobalNodeFinder$find$$inlined$query$1).n5w = function (builder) {
    var nodePointer = this.l6p_1.p6p(this.m6p_1, this.n6p_1);
    return builder.l60(this.l6p_1.o6p_1.i6g(nodePointer));
  };
  function GlobalNodeFinder(nodePointerSupport) {
    this.o6p_1 = nodePointerSupport;
  }
  protoOf(GlobalNodeFinder).q6p = function (source, refContents) {
    // Inline function 'jetbrains.ocelot.langDef.query.query' call
    return new GlobalNodeFinder$find$$inlined$query$1(this, source, refContents);
  };
  protoOf(GlobalNodeFinder).j6i = function (source, refContents) {
    return this.q6p(source, refContents instanceof QualifiedReferenceContent ? refContents : THROW_CCE());
  };
  protoOf(GlobalNodeFinder).p6p = function (source, refContents) {
    return refContents.r6p_1;
  };
  protoOf(GlobalNodeFinder).k6i = function (source, refContents) {
    return this.p6p(source, refContents instanceof QualifiedReferenceContent ? refContents : THROW_CCE());
  };
  function RefTag(source, target, content, name) {
    this.v6l_1 = source;
    this.w6l_1 = target;
    this.x6l_1 = content;
    this.y6l_1 = name;
  }
  protoOf(RefTag).toString = function () {
    return 'RefTag(source=' + toString_1(this.v6l_1) + ', target=' + toString_1(this.w6l_1) + ', content=' + toString_1(this.x6l_1) + ', name=' + this.y6l_1 + ')';
  };
  protoOf(RefTag).hashCode = function () {
    var result = this.v6l_1.hashCode();
    result = imul(result, 31) + this.w6l_1.hashCode() | 0;
    result = imul(result, 31) + this.x6l_1.hashCode() | 0;
    result = imul(result, 31) + getStringHashCode(this.y6l_1) | 0;
    return result;
  };
  protoOf(RefTag).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RefTag))
      return false;
    if (!this.v6l_1.equals(other.v6l_1))
      return false;
    if (!this.w6l_1.equals(other.w6l_1))
      return false;
    if (!this.x6l_1.equals(other.x6l_1))
      return false;
    if (!(this.y6l_1 === other.y6l_1))
      return false;
    return true;
  };
  function NodeFinder() {
  }
  function throwIfMissing($this, _this__u8e3s4) {
    // Inline function 'jetbrains.ocelot.langDef.query.query' call
    return new PrecalculatedResolutionReference$Companion$throwIfMissing$$inlined$query$1(_this__u8e3s4);
  }
  function sam$jetbrains_ocelot_langDef_references_ReferenceFactory$0(function_0) {
    this.s6p_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_langDef_references_ReferenceFactory$0).t6p = function (source, property) {
    return this.s6p_1(source, property);
  };
  protoOf(sam$jetbrains_ocelot_langDef_references_ReferenceFactory$0).f3 = function () {
    return this.s6p_1;
  };
  protoOf(sam$jetbrains_ocelot_langDef_references_ReferenceFactory$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, ReferenceFactory) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_langDef_references_ReferenceFactory$0).hashCode = function () {
    return hashCode(this.f3());
  };
  function PrecalculatedResolutionReference$Companion$factory$lambda(_unused_var__etf5q3, property) {
    return new PrecalculatedResolutionReference(property);
  }
  function PrecalculatedResolutionReference$Companion$throwIfMissing$$inlined$query$1($this_throwIfMissing) {
    this.u6p_1 = $this_throwIfMissing;
  }
  protoOf(PrecalculatedResolutionReference$Companion$throwIfMissing$$inlined$query$1).n5w = function (builder) {
    // Inline function 'kotlin.takeIf' call
    var this_0 = this.u6p_1.uv();
    var tmp;
    if (!equals(this_0, Companion_getInstance_97().v6p_1)) {
      tmp = this_0;
    } else {
      tmp = null;
    }
    var tmp0_elvis_lhs = tmp;
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      var message = 'Value is missing in ' + this.u6p_1.v2w();
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    return tmp_0;
  };
  function Companion_96() {
  }
  protoOf(Companion_96).w6p = function () {
    var tmp = PrecalculatedResolutionReference$Companion$factory$lambda;
    return new sam$jetbrains_ocelot_langDef_references_ReferenceFactory$0(tmp);
  };
  var Companion_instance_96;
  function Companion_getInstance_96() {
    return Companion_instance_96;
  }
  function PrecalculatedResolutionReference$resolve$$inlined$map$1($this) {
    this.x6p_1 = $this;
  }
  protoOf(PrecalculatedResolutionReference$resolve$$inlined$map$1).n5w = function (builder) {
    return builder.l60(this.x6p_1).y6p_1;
  };
  function PrecalculatedResolutionReference$find$$inlined$map$1($this) {
    this.a6q_1 = $this;
  }
  protoOf(PrecalculatedResolutionReference$find$$inlined$map$1).n5w = function (builder) {
    return builder.l60(this.a6q_1).z6p_1;
  };
  function PrecalculatedResolutionReference(property) {
    PropertyBasedReference.call(this, property);
    this.c6q_1 = new ValueProperty(Companion_getInstance_97().v6p_1);
    var tmp = this;
    // Inline function 'jetbrains.ocelot.langDef.query.map' call
    var this_0 = throwIfMissing(Companion_instance_96, this.c6q_1);
    // Inline function 'jetbrains.ocelot.langDef.query.query' call
    tmp.d6q_1 = new PrecalculatedResolutionReference$resolve$$inlined$map$1(this_0);
    var tmp_0 = this;
    // Inline function 'jetbrains.ocelot.langDef.query.map' call
    var this_1 = throwIfMissing(Companion_instance_96, this.c6q_1);
    // Inline function 'jetbrains.ocelot.langDef.query.query' call
    tmp_0.e6q_1 = new PrecalculatedResolutionReference$find$$inlined$map$1(this_1);
  }
  protoOf(PrecalculatedResolutionReference).w6o = function () {
    return this.d6q_1;
  };
  protoOf(PrecalculatedResolutionReference).x6o = function () {
    return this.e6q_1;
  };
  protoOf(PrecalculatedResolutionReference).d2x = function (newValue) {
    return this.b6p((newValue == null ? true : newValue instanceof ReferenceContent) ? newValue : THROW_CCE());
  };
  protoOf(PrecalculatedResolutionReference).r5w = function (builder, $completion) {
    return this.e6p(builder, $completion);
  };
  function Companion_97() {
    Companion_instance_97 = this;
    this.v6p_1 = new PrecalculatedResolutionReferenceValue(null, null);
  }
  var Companion_instance_97;
  function Companion_getInstance_97() {
    if (Companion_instance_97 == null)
      new Companion_97();
    return Companion_instance_97;
  }
  function PrecalculatedResolutionReferenceValue(resolveResult, findResult) {
    Companion_getInstance_97();
    this.y6p_1 = resolveResult;
    this.z6p_1 = findResult;
  }
  function PropertyBasedReference(property) {
    this.y6o_1 = property;
  }
  protoOf(PropertyBasedReference).z6o = function () {
    return this.y6o_1;
  };
  protoOf(PropertyBasedReference).a6p = function (target) {
    var factory = ReferenceContentFactories_getInstance().g6q(this.y6o_1.p5y());
    this.b6p(factory.h6q(target));
  };
  protoOf(PropertyBasedReference).d2x = function (newValue) {
    return this.b6p((newValue == null ? true : newValue instanceof ReferenceContent) ? newValue : THROW_CCE());
  };
  protoOf(PropertyBasedReference).r5w = function (builder, $completion) {
    return this.e6p(builder, $completion);
  };
  function Reference() {
  }
  function ReferenceFactory() {
  }
  function ReferenceResolver() {
  }
  function ReferenceTargetItem(referenceContent, text, additionalText) {
    additionalText = additionalText === VOID ? null : additionalText;
    this.k6q_1 = referenceContent;
    this.l6q_1 = text;
    this.m6q_1 = additionalText;
  }
  function Empty_0() {
  }
  protoOf(Empty_0).n6q = function (context, filter) {
    return emptyFlow();
  };
  protoOf(Empty_0).o6q = function (context, filter) {
    return this.n6q(context, filter);
  };
  var Empty_instance;
  function Empty_getInstance() {
    return Empty_instance;
  }
  function ReferenceTargetsSupplier() {
  }
  function ReferenceLink(sourceConcept, property, targetConcept, contentClass) {
    NodeLink.call(this);
    this.p6k_1 = sourceConcept;
    this.q6k_1 = property;
    this.r6k_1 = targetConcept;
    this.s6k_1 = contentClass;
  }
  protoOf(ReferenceLink).p6q = function () {
    return this.p6k_1;
  };
  protoOf(ReferenceLink).q6q = function () {
    return this.q6k_1;
  };
  function ReferenceData(link, tag) {
    this.t6k_1 = link;
    this.u6k_1 = tag;
  }
  protoOf(ReferenceData).toString = function () {
    return 'ReferenceData(link=' + this.t6k_1.toString() + ', tag=' + this.u6k_1.toString() + ')';
  };
  protoOf(ReferenceData).hashCode = function () {
    var result = this.t6k_1.hashCode();
    result = imul(result, 31) + this.u6k_1.hashCode() | 0;
    return result;
  };
  protoOf(ReferenceData).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ReferenceData))
      return false;
    if (!this.t6k_1.equals(other.t6k_1))
      return false;
    if (!this.u6k_1.equals(other.u6k_1))
      return false;
    return true;
  };
  function TargetInfo(target, referenceContents, text, additionalText) {
    additionalText = additionalText === VOID ? null : additionalText;
    ReferenceTargetItem.call(this, referenceContents, text, additionalText);
    this.u6q_1 = target;
  }
  protoOf(TargetInfo).toString = function () {
    return 'TargetInfo{target=' + toString_1(this.u6q_1) + ', referenceContents=' + toString_1(this.k6q_1) + ', text=' + this.l6q_1 + '}';
  };
  function sam$jetbrains_ocelot_langDef_references_TargetPresentationProvider$0(function_0) {
    this.v6q_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_langDef_references_TargetPresentationProvider$0).w6q = function (target) {
    return this.v6q_1(target);
  };
  protoOf(sam$jetbrains_ocelot_langDef_references_TargetPresentationProvider$0).f3 = function () {
    return this.v6q_1;
  };
  protoOf(sam$jetbrains_ocelot_langDef_references_TargetPresentationProvider$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, TargetPresentationProvider) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_langDef_references_TargetPresentationProvider$0).hashCode = function () {
    return hashCode(this.f3());
  };
  function sam$jetbrains_ocelot_langDef_references_TargetPresentationProvider$0_0(function_0) {
    this.x6q_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_langDef_references_TargetPresentationProvider$0_0).w6q = function (target) {
    return this.x6q_1(target);
  };
  protoOf(sam$jetbrains_ocelot_langDef_references_TargetPresentationProvider$0_0).f3 = function () {
    return this.x6q_1;
  };
  protoOf(sam$jetbrains_ocelot_langDef_references_TargetPresentationProvider$0_0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, TargetPresentationProvider) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_langDef_references_TargetPresentationProvider$0_0).hashCode = function () {
    return hashCode(this.f3());
  };
  function TargetPresentationProvider$Companion$Empty$lambda(it) {
    return Companion_getInstance_81().g60_1;
  }
  function TargetPresentationProvider$Companion$Default$lambda(it) {
    var tmp;
    if (isInterface(it, Named)) {
      tmp = it.y2();
    } else {
      tmp = Companion_getInstance_81().j60_1;
    }
    return tmp;
  }
  function Companion_98() {
    Companion_instance_98 = this;
    var tmp = this;
    var tmp_0 = TargetPresentationProvider$Companion$Empty$lambda;
    tmp.y6q_1 = new sam$jetbrains_ocelot_langDef_references_TargetPresentationProvider$0(tmp_0);
    var tmp_1 = this;
    var tmp_2 = TargetPresentationProvider$Companion$Default$lambda;
    tmp_1.z6q_1 = new sam$jetbrains_ocelot_langDef_references_TargetPresentationProvider$0_0(tmp_2);
  }
  var Companion_instance_98;
  function Companion_getInstance_98() {
    if (Companion_instance_98 == null)
      new Companion_98();
    return Companion_instance_98;
  }
  function TargetPresentationProvider() {
  }
  function TextFilter_init_$Init$(pattern, settings, $this) {
    TextFilter.call($this, pattern, settings.a6r(), settings.b6r());
    return $this;
  }
  function TextFilter_init_$Create$(pattern, settings) {
    return TextFilter_init_$Init$(pattern, settings, objectCreate(protoOf(TextFilter)));
  }
  function TextFilter_init_$Init$_0(pattern, ignoreCase, wordTokenization, $this) {
    TextFilter.call($this, get_tokenized(pattern), ignoreCase, wordTokenization);
    return $this;
  }
  function TextFilter_init_$Create$_0(pattern, ignoreCase, wordTokenization) {
    return TextFilter_init_$Init$_0(pattern, ignoreCase, wordTokenization, objectCreate(protoOf(TextFilter)));
  }
  function TextFilter_init_$Init$_1(pattern, settings, $this) {
    TextFilter.call($this, get_tokenized(pattern), settings.a6r(), settings.b6r());
    return $this;
  }
  function TextFilter_init_$Create$_1(pattern, settings) {
    return TextFilter_init_$Init$_1(pattern, settings, objectCreate(protoOf(TextFilter)));
  }
  function Companion_99() {
    Companion_instance_99 = this;
    this.c6r_1 = new TextFilter(get_tokenized(''), false, false);
  }
  var Companion_instance_99;
  function Companion_getInstance_99() {
    if (Companion_instance_99 == null)
      new Companion_99();
    return Companion_instance_99;
  }
  function $serializer_0() {
    $serializer_instance_0 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('jetbrains.ocelot.langDef.references.TextFilter', this, 3);
    tmp0_serialDesc.q5j('pattern', false);
    tmp0_serialDesc.q5j('ignoreCase', false);
    tmp0_serialDesc.q5j('wordTokenization', false);
    this.d6r_1 = tmp0_serialDesc;
  }
  protoOf($serializer_0).e6r = function (encoder, value) {
    var tmp0_desc = this.d6r_1;
    var tmp1_output = encoder.g5c(tmp0_desc);
    tmp1_output.w5d(tmp0_desc, 0, $serializer_getInstance_1(), value.f6r_1);
    tmp1_output.m5d(tmp0_desc, 1, value.g6r_1);
    tmp1_output.m5d(tmp0_desc, 2, value.h6r_1);
    tmp1_output.h5c(tmp0_desc);
  };
  protoOf($serializer_0).i59 = function (encoder, value) {
    return this.e6r(encoder, value instanceof TextFilter ? value : THROW_CCE());
  };
  protoOf($serializer_0).j59 = function (decoder) {
    var tmp0_desc = this.d6r_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = false;
    var tmp6_local2 = false;
    var tmp7_input = decoder.g5c(tmp0_desc);
    if (tmp7_input.v5c()) {
      tmp4_local0 = tmp7_input.s5c(tmp0_desc, 0, $serializer_getInstance_1(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.i5c(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.i5c(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.w5c(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.s5c(tmp0_desc, 0, $serializer_getInstance_1(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.i5c(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.i5c(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.h5c(tmp0_desc);
    return TextFilter_init_$Create$_2(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_0).v58 = function () {
    return this.d6r_1;
  };
  protoOf($serializer_0).f5k = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_1(), BooleanSerializer_getInstance(), BooleanSerializer_getInstance()];
  };
  var $serializer_instance_0;
  function $serializer_getInstance_0() {
    if ($serializer_instance_0 == null)
      new $serializer_0();
    return $serializer_instance_0;
  }
  function TextFilter_init_$Init$_2(seen0, pattern, ignoreCase, wordTokenization, serializationConstructorMarker, $this) {
    if (!(7 === (7 & seen0))) {
      throwMissingFieldException(seen0, 7, $serializer_getInstance_0().d6r_1);
    }
    $this.f6r_1 = pattern;
    $this.g6r_1 = ignoreCase;
    $this.h6r_1 = wordTokenization;
    return $this;
  }
  function TextFilter_init_$Create$_2(seen0, pattern, ignoreCase, wordTokenization, serializationConstructorMarker) {
    return TextFilter_init_$Init$_2(seen0, pattern, ignoreCase, wordTokenization, serializationConstructorMarker, objectCreate(protoOf(TextFilter)));
  }
  function TextFilter(pattern, ignoreCase, wordTokenization) {
    Companion_getInstance_99();
    this.f6r_1 = pattern;
    this.g6r_1 = ignoreCase;
    this.h6r_1 = wordTokenization;
  }
  protoOf(TextFilter).a6r = function () {
    return this.g6r_1;
  };
  protoOf(TextFilter).b6r = function () {
    return this.h6r_1;
  };
  protoOf(TextFilter).i6r = function (text) {
    if (this.h6r_1) {
      var textTokens = text.l6r();
      var _iterator__ex2g4s = this.f6r_1.l6r().m();
      while (_iterator__ex2g4s.n()) {
        var patternToken = _iterator__ex2g4s.o();
        var tmp$ret$0;
        $l$block_0: {
          // Inline function 'kotlin.collections.any' call
          var tmp;
          if (isInterface(textTokens, Collection)) {
            tmp = textTokens.s();
          } else {
            tmp = false;
          }
          if (tmp) {
            tmp$ret$0 = false;
            break $l$block_0;
          }
          var _iterator__ex2g4s_0 = textTokens.m();
          while (_iterator__ex2g4s_0.n()) {
            var element = _iterator__ex2g4s_0.o();
            if (startsWith(element, patternToken, this.g6r_1)) {
              tmp$ret$0 = true;
              break $l$block_0;
            }
          }
          tmp$ret$0 = false;
        }
        if (!tmp$ret$0) {
          return false;
        }
      }
      return true;
    }
    return startsWith(text.j6r_1, this.f6r_1.j6r_1, this.g6r_1);
  };
  protoOf(TextFilter).m6r = function (text) {
    return this.i6r(get_tokenized(text));
  };
  protoOf(TextFilter).n6r = function (pattern, ignoreCase, wordTokenization) {
    return new TextFilter(pattern, ignoreCase, wordTokenization);
  };
  protoOf(TextFilter).o6r = function (pattern, ignoreCase, wordTokenization, $super) {
    pattern = pattern === VOID ? this.f6r_1 : pattern;
    ignoreCase = ignoreCase === VOID ? this.g6r_1 : ignoreCase;
    wordTokenization = wordTokenization === VOID ? this.h6r_1 : wordTokenization;
    return $super === VOID ? this.n6r(pattern, ignoreCase, wordTokenization) : $super.n6r.call(this, pattern, ignoreCase, wordTokenization);
  };
  protoOf(TextFilter).toString = function () {
    return 'TextFilter(pattern=' + this.f6r_1.toString() + ', ignoreCase=' + this.g6r_1 + ', wordTokenization=' + this.h6r_1 + ')';
  };
  protoOf(TextFilter).hashCode = function () {
    var result = this.f6r_1.hashCode();
    result = imul(result, 31) + getBooleanHashCode(this.g6r_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.h6r_1) | 0;
    return result;
  };
  protoOf(TextFilter).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TextFilter))
      return false;
    if (!this.f6r_1.equals(other.f6r_1))
      return false;
    if (!(this.g6r_1 === other.g6r_1))
      return false;
    if (!(this.h6r_1 === other.h6r_1))
      return false;
    return true;
  };
  function TextFilterSettings$Companion$invoke$1($ignoreCase, $wordTokenization) {
    this.p6r_1 = $ignoreCase;
    this.q6r_1 = $wordTokenization;
  }
  protoOf(TextFilterSettings$Companion$invoke$1).a6r = function () {
    return this.p6r_1;
  };
  protoOf(TextFilterSettings$Companion$invoke$1).b6r = function () {
    return this.q6r_1;
  };
  function TextFilterSettings$Companion$DEFAULT$1() {
    this.r6r_1 = true;
    this.s6r_1 = true;
  }
  protoOf(TextFilterSettings$Companion$DEFAULT$1).a6r = function () {
    return this.r6r_1;
  };
  protoOf(TextFilterSettings$Companion$DEFAULT$1).b6r = function () {
    return this.s6r_1;
  };
  function Companion_100() {
    Companion_instance_100 = this;
    var tmp = this;
    tmp.t6r_1 = new TextFilterSettings$Companion$DEFAULT$1();
  }
  protoOf(Companion_100).u6r = function (ignoreCase, wordTokenization) {
    return new TextFilterSettings$Companion$invoke$1(ignoreCase, wordTokenization);
  };
  var Companion_instance_100;
  function Companion_getInstance_100() {
    if (Companion_instance_100 == null)
      new Companion_100();
    return Companion_instance_100;
  }
  function get_matchPattern() {
    _init_properties_TokenizedText_kt__uj79ng();
    return matchPattern;
  }
  var matchPattern;
  function Companion_101() {
  }
  var Companion_instance_101;
  function Companion_getInstance_101() {
    return Companion_instance_101;
  }
  function $serializer_1() {
    $serializer_instance_1 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('jetbrains.ocelot.langDef.references.TokenizedText', this, 1);
    tmp0_serialDesc.q5j('value', false);
    this.v6r_1 = tmp0_serialDesc;
  }
  protoOf($serializer_1).w6r = function (encoder, value) {
    var tmp0_desc = this.v6r_1;
    var tmp1_output = encoder.g5c(tmp0_desc);
    tmp1_output.u5d(tmp0_desc, 0, value.j6r_1);
    tmp1_output.h5c(tmp0_desc);
  };
  protoOf($serializer_1).i59 = function (encoder, value) {
    return this.w6r(encoder, value instanceof TokenizedText ? value : THROW_CCE());
  };
  protoOf($serializer_1).j59 = function (decoder) {
    var tmp0_desc = this.v6r_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp6_input = decoder.g5c(tmp0_desc);
    if (tmp6_input.v5c()) {
      tmp4_local0 = tmp6_input.q5c(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.w5c(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.q5c(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.h5c(tmp0_desc);
    return TokenizedText_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_1).v58 = function () {
    return this.v6r_1;
  };
  protoOf($serializer_1).f5k = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance()];
  };
  var $serializer_instance_1;
  function $serializer_getInstance_1() {
    if ($serializer_instance_1 == null)
      new $serializer_1();
    return $serializer_instance_1;
  }
  function TokenizedText_init_$Init$(seen0, value, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_1().v6r_1);
    }
    $this.j6r_1 = value;
    $this.k6r_1 = null;
    return $this;
  }
  function TokenizedText_init_$Create$(seen0, value, serializationConstructorMarker) {
    return TokenizedText_init_$Init$(seen0, value, serializationConstructorMarker, objectCreate(protoOf(TokenizedText)));
  }
  function TokenizedText(value) {
    this.j6r_1 = value;
    this.k6r_1 = null;
  }
  protoOf(TokenizedText).l6r = function () {
    var cached = this.k6r_1;
    if (!(cached == null))
      return cached;
    var result = tokens(this.j6r_1);
    this.k6r_1 = result;
    return result;
  };
  protoOf(TokenizedText).toString = function () {
    return 'TokenizedText(value=' + this.j6r_1 + ')';
  };
  protoOf(TokenizedText).hashCode = function () {
    return getStringHashCode(this.j6r_1);
  };
  protoOf(TokenizedText).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TokenizedText))
      return false;
    if (!(this.j6r_1 === other.j6r_1))
      return false;
    return true;
  };
  function get_tokenized(_this__u8e3s4) {
    _init_properties_TokenizedText_kt__uj79ng();
    return new TokenizedText(_this__u8e3s4);
  }
  function tokens(text) {
    _init_properties_TokenizedText_kt__uj79ng();
    var tmp = get_matchPattern().ed(text);
    return toSet_1(map(tmp, tokens$lambda));
  }
  function tokens$lambda(it) {
    _init_properties_TokenizedText_kt__uj79ng();
    return it.a1();
  }
  var properties_initialized_TokenizedText_kt_loublm;
  function _init_properties_TokenizedText_kt__uj79ng() {
    if (!properties_initialized_TokenizedText_kt_loublm) {
      properties_initialized_TokenizedText_kt_loublm = true;
      matchPattern = Regex_init_$Create$('[^a-zA-Z0-9]|[a-zA-Z0-9]+');
    }
  }
  function sam$jetbrains_ocelot_langDef_references_ReferenceFactory$0_0(function_0) {
    this.x6r_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_langDef_references_ReferenceFactory$0_0).t6p = function (source, property) {
    return this.x6r_1(source, property);
  };
  protoOf(sam$jetbrains_ocelot_langDef_references_ReferenceFactory$0_0).f3 = function () {
    return this.x6r_1;
  };
  protoOf(sam$jetbrains_ocelot_langDef_references_ReferenceFactory$0_0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, ReferenceFactory) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_langDef_references_ReferenceFactory$0_0).hashCode = function () {
    return hashCode(this.f3());
  };
  function TrivialReference$Companion$factory$lambda($resolver) {
    return function (source, property) {
      return new TrivialReference(property, $resolver, source);
    };
  }
  function $runSuspendCOROUTINE$_0(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.g6s_1 = _this__u8e3s4;
    this.h6s_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_0).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 3;
            var $this$suspendingQuery = this.h6s_1;
            var tmp0_safe_receiver = $this$suspendingQuery.l60(this.g6s_1.j6s_1);
            if (tmp0_safe_receiver == null) {
              this.i6s_1 = null;
              this.f9_1 = 2;
              continue $sm;
            } else {
              this.f9_1 = 1;
              suspendResult = $this$suspendingQuery.k60(this.g6s_1.k6s_1.i6q(this.g6s_1.l6s_1, tmp0_safe_receiver), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            this.i6s_1 = suspendResult;
            this.f9_1 = 2;
            continue $sm;
          case 2:
            return this.i6s_1;
          case 3:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 3) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function $runSuspendCOROUTINE$_1(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.u6s_1 = _this__u8e3s4;
    this.v6s_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_1).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 3;
            var $this$suspendingQuery = this.v6s_1;
            var tmp0_safe_receiver = $this$suspendingQuery.l60(this.u6s_1.x6s_1);
            if (tmp0_safe_receiver == null) {
              this.w6s_1 = null;
              this.f9_1 = 2;
              continue $sm;
            } else {
              this.f9_1 = 1;
              suspendResult = $this$suspendingQuery.k60(this.u6s_1.y6s_1.j6q(this.u6s_1.z6s_1, tmp0_safe_receiver), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            this.w6s_1 = suspendResult;
            this.f9_1 = 2;
            continue $sm;
          case 2:
            return this.w6s_1;
          case 3:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 3) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function Companion_102() {
  }
  protoOf(Companion_102).a6t = function (resolver) {
    var tmp = TrivialReference$Companion$factory$lambda(resolver);
    return new sam$jetbrains_ocelot_langDef_references_ReferenceFactory$0_0(tmp);
  };
  var Companion_instance_102;
  function Companion_getInstance_102() {
    return Companion_instance_102;
  }
  function TrivialReference$resolve$$inlined$suspendingQuery$1($property, $resolver, $source) {
    this.j6s_1 = $property;
    this.k6s_1 = $resolver;
    this.l6s_1 = $source;
  }
  protoOf(TrivialReference$resolve$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_0(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(TrivialReference$resolve$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function TrivialReference$find$$inlined$suspendingQuery$1($property, $resolver, $source) {
    this.x6s_1 = $property;
    this.y6s_1 = $resolver;
    this.z6s_1 = $source;
  }
  protoOf(TrivialReference$find$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_1(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(TrivialReference$find$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function TrivialReference(property, resolver, source) {
    PropertyBasedReference.call(this, property);
    var tmp = this;
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    tmp.c6t_1 = new TrivialReference$resolve$$inlined$suspendingQuery$1(property, resolver, source);
    var tmp_0 = this;
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    tmp_0.d6t_1 = new TrivialReference$find$$inlined$suspendingQuery$1(property, resolver, source);
  }
  protoOf(TrivialReference).w6o = function () {
    return this.c6t_1;
  };
  protoOf(TrivialReference).x6o = function () {
    return this.d6t_1;
  };
  protoOf(TrivialReference).d2x = function (newValue) {
    return this.b6p((newValue == null ? true : newValue instanceof ReferenceContent) ? newValue : THROW_CCE());
  };
  protoOf(TrivialReference).r5w = function (builder, $completion) {
    return this.e6p(builder, $completion);
  };
  function ReferenceFactoryRegistryService() {
    ReferenceFactoryRegistryService_instance = this;
    this.e6t_1 = new ReferenceFactoryRegistryImpl(emptyMap());
  }
  protoOf(ReferenceFactoryRegistryService).g3b = function () {
    return this.e6t_1;
  };
  var ReferenceFactoryRegistryService_instance;
  function ReferenceFactoryRegistryService_getInstance() {
    if (ReferenceFactoryRegistryService_instance == null)
      new ReferenceFactoryRegistryService();
    return ReferenceFactoryRegistryService_instance;
  }
  function referenceFactories(_this__u8e3s4, body) {
    _this__u8e3s4.t6f(ReferenceFactoryRegistryAspect_instance, new ReferenceFactoryRegistryDefinition(body));
  }
  function ReferenceFactoryRegistryAspect$createConfigurationService$lambda($definitions) {
    return function (it) {
      var builder = new ReferenceFactoryRegistryBuilderImpl(it);
      var _iterator__ex2g4s = $definitions.m();
      while (_iterator__ex2g4s.n()) {
        var definition = _iterator__ex2g4s.o();
        definition.f6t_1(builder);
      }
      return builder.f40();
    };
  }
  function ReferenceFactoryRegistryAspect() {
  }
  protoOf(ReferenceFactoryRegistryAspect).i6t = function (definitions) {
    var tmp = Companion_instance_41;
    var tmp_0 = [ReferenceFactoryRegistryService_getInstance()];
    return tmp.m3b(tmp_0, VOID, ReferenceFactoryRegistryAspect$createConfigurationService$lambda(definitions));
  };
  protoOf(ReferenceFactoryRegistryAspect).r6f = function (definitions) {
    return this.i6t(definitions);
  };
  var ReferenceFactoryRegistryAspect_instance;
  function ReferenceFactoryRegistryAspect_getInstance() {
    return ReferenceFactoryRegistryAspect_instance;
  }
  function ReferenceFactoryRegistryDefinition(body) {
    this.f6t_1 = body;
  }
  function ReferenceFactoryRegistryBuilderImpl(servicesScope) {
    this.g6t_1 = servicesScope;
    var tmp = this;
    // Inline function 'kotlin.collections.hashMapOf' call
    tmp.h6t_1 = HashMap_init_$Create$();
  }
  protoOf(ReferenceFactoryRegistryBuilderImpl).j6t = function (tag, referenceFactory) {
    // Inline function 'kotlin.collections.set' call
    this.h6t_1.t2(tag, referenceFactory);
  };
  protoOf(ReferenceFactoryRegistryBuilderImpl).f40 = function () {
    return new ReferenceFactoryRegistryImpl(this.h6t_1);
  };
  protoOf(ReferenceFactoryRegistryBuilderImpl).h3b = function (key) {
    return this.g6t_1.h3b(key);
  };
  protoOf(ReferenceFactoryRegistryBuilderImpl).e3c = function (_this__u8e3s4, thisRef, property) {
    return this.g6t_1.e3c(_this__u8e3s4, thisRef, property);
  };
  function sam$jetbrains_ocelot_langDef_references_ReferenceFactory$0_1(function_0) {
    this.k6t_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_langDef_references_ReferenceFactory$0_1).t6p = function (source, property) {
    return this.k6t_1(source, property);
  };
  protoOf(sam$jetbrains_ocelot_langDef_references_ReferenceFactory$0_1).f3 = function () {
    return this.k6t_1;
  };
  protoOf(sam$jetbrains_ocelot_langDef_references_ReferenceFactory$0_1).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, ReferenceFactory) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_langDef_references_ReferenceFactory$0_1).hashCode = function () {
    return hashCode(this.f3());
  };
  function ReferenceFactoryRegistryImpl$referenceFactory$lambda(_unused_var__etf5q3, property) {
    return new ConstantReference(property);
  }
  function ReferenceFactoryRegistryImpl(referenceFactories) {
    this.l6t_1 = referenceFactories;
  }
  protoOf(ReferenceFactoryRegistryImpl).m6t = function (tag) {
    var tmp = this.l6t_1.q2(tag);
    var tmp0_elvis_lhs = (!(tmp == null) ? isInterface(tmp, ReferenceFactory) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      var tmp_1 = ReferenceFactoryRegistryImpl$referenceFactory$lambda;
      return new sam$jetbrains_ocelot_langDef_references_ReferenceFactory$0_1(tmp_1);
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var factory = tmp_0;
    return factory;
  };
  function createReference(_this__u8e3s4, tag, source, property) {
    return _this__u8e3s4.m6t(tag).t6p(source, property);
  }
  function createReference_0(_this__u8e3s4, tag, source, property) {
    return createReference(_this__u8e3s4, tag, source, toReified(property, tag.x6l_1));
  }
  function ReferenceTargetPresentationProvidersRegistryService() {
    ReferenceTargetPresentationProvidersRegistryService_instance = this;
    this.n6t_1 = new ReferenceTargetPresentationProvidersRegistryImpl(emptyMap());
  }
  protoOf(ReferenceTargetPresentationProvidersRegistryService).g3b = function () {
    return this.n6t_1;
  };
  var ReferenceTargetPresentationProvidersRegistryService_instance;
  function ReferenceTargetPresentationProvidersRegistryService_getInstance() {
    if (ReferenceTargetPresentationProvidersRegistryService_instance == null)
      new ReferenceTargetPresentationProvidersRegistryService();
    return ReferenceTargetPresentationProvidersRegistryService_instance;
  }
  function referenceTargetPresentationProviders(_this__u8e3s4, body) {
    _this__u8e3s4.t6f(ReferenceTargetPresentationProvidersRegistryAspect_instance, new ReferenceTargetPresentationProvidersRegistryDefinition(body));
  }
  function ReferenceTargetPresentationProvidersRegistryAspect$createConfigurationService$lambda($definitions) {
    return function (it) {
      var builder = new ReferenceTargetPresentationProvidersRegistryBuilderImpl(it);
      var _iterator__ex2g4s = $definitions.m();
      while (_iterator__ex2g4s.n()) {
        var definition = _iterator__ex2g4s.o();
        definition.o6t_1(builder);
      }
      return builder.f40();
    };
  }
  function ReferenceTargetPresentationProvidersRegistryAspect() {
  }
  protoOf(ReferenceTargetPresentationProvidersRegistryAspect).r6t = function (definitions) {
    var tmp = Companion_instance_41;
    var tmp_0 = [ReferenceTargetPresentationProvidersRegistryService_getInstance()];
    return tmp.m3b(tmp_0, VOID, ReferenceTargetPresentationProvidersRegistryAspect$createConfigurationService$lambda(definitions));
  };
  protoOf(ReferenceTargetPresentationProvidersRegistryAspect).r6f = function (definitions) {
    return this.r6t(definitions);
  };
  var ReferenceTargetPresentationProvidersRegistryAspect_instance;
  function ReferenceTargetPresentationProvidersRegistryAspect_getInstance() {
    return ReferenceTargetPresentationProvidersRegistryAspect_instance;
  }
  function ReferenceTargetPresentationProvidersRegistryDefinition(body) {
    this.o6t_1 = body;
  }
  function ReferenceTargetPresentationProvidersRegistryBuilder() {
  }
  function ReferenceTargetPresentationProvidersRegistryBuilderImpl(servicesScope) {
    this.p6t_1 = servicesScope;
    var tmp = this;
    // Inline function 'kotlin.collections.hashMapOf' call
    tmp.q6t_1 = HashMap_init_$Create$();
  }
  protoOf(ReferenceTargetPresentationProvidersRegistryBuilderImpl).s6t = function (tag, presentationProvider) {
    // Inline function 'kotlin.collections.set' call
    this.q6t_1.t2(tag, presentationProvider);
  };
  protoOf(ReferenceTargetPresentationProvidersRegistryBuilderImpl).f40 = function () {
    return new ReferenceTargetPresentationProvidersRegistryImpl(this.q6t_1);
  };
  protoOf(ReferenceTargetPresentationProvidersRegistryBuilderImpl).h3b = function (key) {
    return this.p6t_1.h3b(key);
  };
  protoOf(ReferenceTargetPresentationProvidersRegistryBuilderImpl).e3c = function (_this__u8e3s4, thisRef, property) {
    return this.p6t_1.e3c(_this__u8e3s4, thisRef, property);
  };
  function ReferenceTargetPresentationProvidersRegistryImpl(targetPresentationProviders) {
    this.u6t_1 = targetPresentationProviders;
  }
  protoOf(ReferenceTargetPresentationProvidersRegistryImpl).v6t = function (tag) {
    var tmp0_elvis_lhs = this.u6t_1.q2(tag);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Companion_getInstance_98().y6q_1;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var presentationProvider = tmp;
    return isInterface(presentationProvider, TargetPresentationProvider) ? presentationProvider : THROW_CCE();
  };
  function getPresentation(_this__u8e3s4, tag, target) {
    return _this__u8e3s4.v6t(tag).w6q(target);
  }
  function ReferenceTargetsSuppliersRegistryService() {
    ReferenceTargetsSuppliersRegistryService_instance = this;
    this.w6t_1 = new ReferenceTargetsSuppliersRegistryImpl(emptyMap());
  }
  protoOf(ReferenceTargetsSuppliersRegistryService).g3b = function () {
    return this.w6t_1;
  };
  var ReferenceTargetsSuppliersRegistryService_instance;
  function ReferenceTargetsSuppliersRegistryService_getInstance() {
    if (ReferenceTargetsSuppliersRegistryService_instance == null)
      new ReferenceTargetsSuppliersRegistryService();
    return ReferenceTargetsSuppliersRegistryService_instance;
  }
  function referenceTargetsSuppliers(_this__u8e3s4, body) {
    _this__u8e3s4.t6f(ReferenceTargetsSuppliersRegistryAspect_instance, new ReferenceTargetsSuppliersRegistryDefinition(body));
  }
  function ReferenceTargetsSuppliersRegistryAspect$createConfigurationService$lambda($definitions) {
    return function (it) {
      var builder = new ReferenceTargetsSuppliersRegistryBuilderImpl(it);
      var _iterator__ex2g4s = $definitions.m();
      while (_iterator__ex2g4s.n()) {
        var definition = _iterator__ex2g4s.o();
        definition.x6t_1(builder);
      }
      return builder.f40();
    };
  }
  function ReferenceTargetsSuppliersRegistryAspect() {
  }
  protoOf(ReferenceTargetsSuppliersRegistryAspect).a6u = function (definitions) {
    var tmp = Companion_instance_41;
    var tmp_0 = [ReferenceTargetsSuppliersRegistryService_getInstance()];
    return tmp.m3b(tmp_0, VOID, ReferenceTargetsSuppliersRegistryAspect$createConfigurationService$lambda(definitions));
  };
  protoOf(ReferenceTargetsSuppliersRegistryAspect).r6f = function (definitions) {
    return this.a6u(definitions);
  };
  var ReferenceTargetsSuppliersRegistryAspect_instance;
  function ReferenceTargetsSuppliersRegistryAspect_getInstance() {
    return ReferenceTargetsSuppliersRegistryAspect_instance;
  }
  function ReferenceTargetsSuppliersRegistryDefinition(body) {
    this.x6t_1 = body;
  }
  function ReferenceTargetsSuppliersRegistryBuilderImpl(servicesScope) {
    this.y6t_1 = servicesScope;
    var tmp = this;
    // Inline function 'kotlin.collections.hashMapOf' call
    tmp.z6t_1 = HashMap_init_$Create$();
  }
  protoOf(ReferenceTargetsSuppliersRegistryBuilderImpl).b6u = function (tag, targetsSupplier) {
    // Inline function 'kotlin.collections.set' call
    this.z6t_1.t2(tag, targetsSupplier);
  };
  protoOf(ReferenceTargetsSuppliersRegistryBuilderImpl).f40 = function () {
    return new ReferenceTargetsSuppliersRegistryImpl(this.z6t_1);
  };
  protoOf(ReferenceTargetsSuppliersRegistryBuilderImpl).h3b = function (key) {
    return this.y6t_1.h3b(key);
  };
  protoOf(ReferenceTargetsSuppliersRegistryBuilderImpl).e3c = function (_this__u8e3s4, thisRef, property) {
    return this.y6t_1.e3c(_this__u8e3s4, thisRef, property);
  };
  function ReferenceTargetsSuppliersRegistryImpl(targetSuppliers) {
    this.c6u_1 = targetSuppliers;
  }
  protoOf(ReferenceTargetsSuppliersRegistryImpl).d6u = function (tag) {
    var tmp0_elvis_lhs = this.c6u_1.q2(tag);
    var tmp = tmp0_elvis_lhs == null ? Empty_instance : tmp0_elvis_lhs;
    return isInterface(tmp, ReferenceTargetsSupplier) ? tmp : THROW_CCE();
  };
  function ResolveConfigImpl(referenceFactoryRegistry, referenceTargetsSuppliersRegistry, referenceTargetPresentationProvidersRegistry) {
    this.e6u_1 = referenceFactoryRegistry;
    this.f6u_1 = referenceTargetsSuppliersRegistry;
    this.g6u_1 = referenceTargetPresentationProvidersRegistry;
  }
  protoOf(ResolveConfigImpl).m6t = function (tag) {
    return this.e6u_1.m6t(tag);
  };
  protoOf(ResolveConfigImpl).d6u = function (tag) {
    return this.f6u_1.d6u(tag);
  };
  protoOf(ResolveConfigImpl).v6t = function (tag) {
    return this.g6u_1.v6t(tag);
  };
  function ResolveConfigService() {
  }
  var ResolveConfigService_instance;
  function ResolveConfigService_getInstance() {
    return ResolveConfigService_instance;
  }
  function get_refTags(_this__u8e3s4) {
    return ConceptRegistryService_instance.e3b(_this__u8e3s4).o6l();
  }
  function Companion_103() {
  }
  protoOf(Companion_103).i63 = function () {
    return $serializer_getInstance_2();
  };
  var Companion_instance_103;
  function Companion_getInstance_103() {
    return Companion_instance_103;
  }
  function $serializer_2() {
    $serializer_instance_2 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('jetbrains.ocelot.langDef.references.content.QualifiedReferenceContent', this, 1);
    tmp0_serialDesc.q5j('nodePointer', false);
    this.h6u_1 = tmp0_serialDesc;
  }
  protoOf($serializer_2).i6u = function (encoder, value) {
    var tmp0_desc = this.h6u_1;
    var tmp1_output = encoder.g5c(tmp0_desc);
    tmp1_output.w5d(tmp0_desc, 0, NodePointerSerializer_getInstance(), value.r6p_1);
    tmp1_output.h5c(tmp0_desc);
  };
  protoOf($serializer_2).i59 = function (encoder, value) {
    return this.i6u(encoder, value instanceof QualifiedReferenceContent ? value : THROW_CCE());
  };
  protoOf($serializer_2).j59 = function (decoder) {
    var tmp0_desc = this.h6u_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.g5c(tmp0_desc);
    if (tmp5_input.v5c()) {
      tmp4_local0 = tmp5_input.s5c(tmp0_desc, 0, NodePointerSerializer_getInstance(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.w5c(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.s5c(tmp0_desc, 0, NodePointerSerializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.h5c(tmp0_desc);
    return QualifiedReferenceContent_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_2).v58 = function () {
    return this.h6u_1;
  };
  protoOf($serializer_2).f5k = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [NodePointerSerializer_getInstance()];
  };
  var $serializer_instance_2;
  function $serializer_getInstance_2() {
    if ($serializer_instance_2 == null)
      new $serializer_2();
    return $serializer_instance_2;
  }
  function QualifiedReferenceContent_init_$Init$(seen0, nodePointer, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_2().h6u_1);
    }
    ReferenceContent_init_$Init$(seen0, serializationConstructorMarker, $this);
    $this.r6p_1 = nodePointer;
    return $this;
  }
  function QualifiedReferenceContent_init_$Create$(seen0, nodePointer, serializationConstructorMarker) {
    return QualifiedReferenceContent_init_$Init$(seen0, nodePointer, serializationConstructorMarker, objectCreate(protoOf(QualifiedReferenceContent)));
  }
  function QualifiedReferenceContent(nodePointer) {
    ReferenceContent.call(this);
    this.r6p_1 = nodePointer;
  }
  protoOf(QualifiedReferenceContent).d6g = function () {
    return this.r6p_1.documentId;
  };
  protoOf(QualifiedReferenceContent).toString = function () {
    // Inline function 'jetbrains.ocelot.langDef.references.content.ReferenceContentPersisters.serialize' call
    var this_0 = ReferenceContentPersisters_getInstance();
    return ensureNotNull(this_0.d6m(getKClass(QualifiedReferenceContent)).w24(this));
  };
  protoOf(QualifiedReferenceContent).hashCode = function () {
    return this.r6p_1.hashCode();
  };
  protoOf(QualifiedReferenceContent).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof QualifiedReferenceContent))
      return false;
    if (!this.r6p_1.equals(other.r6p_1))
      return false;
    return true;
  };
  function Companion_104() {
  }
  protoOf(Companion_104).i63 = function () {
    return $serializer_getInstance_3();
  };
  var Companion_instance_104;
  function Companion_getInstance_104() {
    return Companion_instance_104;
  }
  function $serializer_3() {
    $serializer_instance_3 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('jetbrains.ocelot.langDef.references.content.LocalReferenceContent', this, 1);
    tmp0_serialDesc.q5j('nodeId', false);
    this.j6u_1 = tmp0_serialDesc;
  }
  protoOf($serializer_3).k6u = function (encoder, value) {
    var tmp0_desc = this.j6u_1;
    var tmp1_output = encoder.g5c(tmp0_desc);
    tmp1_output.w5d(tmp0_desc, 0, NodeIdSerializer_getInstance(), value.i6i_1);
    tmp1_output.h5c(tmp0_desc);
  };
  protoOf($serializer_3).i59 = function (encoder, value) {
    return this.k6u(encoder, value instanceof LocalReferenceContent ? value : THROW_CCE());
  };
  protoOf($serializer_3).j59 = function (decoder) {
    var tmp0_desc = this.j6u_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.g5c(tmp0_desc);
    if (tmp5_input.v5c()) {
      tmp4_local0 = tmp5_input.s5c(tmp0_desc, 0, NodeIdSerializer_getInstance(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.w5c(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.s5c(tmp0_desc, 0, NodeIdSerializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.h5c(tmp0_desc);
    return LocalReferenceContent_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_3).v58 = function () {
    return this.j6u_1;
  };
  protoOf($serializer_3).f5k = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [NodeIdSerializer_getInstance()];
  };
  var $serializer_instance_3;
  function $serializer_getInstance_3() {
    if ($serializer_instance_3 == null)
      new $serializer_3();
    return $serializer_instance_3;
  }
  function LocalReferenceContent_init_$Init$(seen0, nodeId, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_3().j6u_1);
    }
    ReferenceContent_init_$Init$(seen0, serializationConstructorMarker, $this);
    $this.i6i_1 = nodeId;
    return $this;
  }
  function LocalReferenceContent_init_$Create$(seen0, nodeId, serializationConstructorMarker) {
    return LocalReferenceContent_init_$Init$(seen0, nodeId, serializationConstructorMarker, objectCreate(protoOf(LocalReferenceContent)));
  }
  function LocalReferenceContent(nodeId) {
    ReferenceContent.call(this);
    this.i6i_1 = nodeId;
  }
  protoOf(LocalReferenceContent).toString = function () {
    // Inline function 'jetbrains.ocelot.langDef.references.content.ReferenceContentPersisters.serialize' call
    var this_0 = ReferenceContentPersisters_getInstance();
    return ensureNotNull(this_0.d6m(getKClass(LocalReferenceContent)).w24(this));
  };
  protoOf(LocalReferenceContent).hashCode = function () {
    return this.i6i_1.hashCode();
  };
  protoOf(LocalReferenceContent).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof LocalReferenceContent))
      return false;
    if (!this.i6i_1.equals(other.i6i_1))
      return false;
    return true;
  };
  function _get_$cachedSerializer__te6jhj_0($this) {
    return $this.l6u_1.a1();
  }
  function ReferenceContent$Companion$_anonymous__a4n5i7() {
    var tmp = getKClass(ReferenceContent);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = [getKClass(DynamicReferenceContent), getKClass(LocalReferenceContent), getKClass(QualifiedReferenceContent)];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_1 = [$serializer_getInstance_4(), $serializer_getInstance_3(), $serializer_getInstance_2()];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$8 = [];
    return SealedClassSerializer_init_$Create$('jetbrains.ocelot.langDef.references.content.ReferenceContent', tmp, tmp_0, tmp_1, tmp$ret$8);
  }
  function Companion_105() {
    Companion_instance_105 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.l6u_1 = lazy_0(tmp_0, ReferenceContent$Companion$_anonymous__a4n5i7);
  }
  protoOf(Companion_105).i63 = function () {
    return _get_$cachedSerializer__te6jhj_0(this);
  };
  protoOf(Companion_105).q5k = function (typeParamsSerializers) {
    return this.i63();
  };
  var Companion_instance_105;
  function Companion_getInstance_105() {
    if (Companion_instance_105 == null)
      new Companion_105();
    return Companion_instance_105;
  }
  function ReferenceContent_init_$Init$(seen0, serializationConstructorMarker, $this) {
    return $this;
  }
  function ReferenceContent() {
    Companion_getInstance_105();
  }
  function Companion_106() {
  }
  protoOf(Companion_106).i63 = function () {
    return $serializer_getInstance_4();
  };
  var Companion_instance_106;
  function Companion_getInstance_106() {
    return Companion_instance_106;
  }
  function $serializer_4() {
    $serializer_instance_4 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('jetbrains.ocelot.langDef.references.content.DynamicReferenceContent', this, 1);
    tmp0_serialDesc.q5j('targetName', true);
    this.m6u_1 = tmp0_serialDesc;
  }
  protoOf($serializer_4).n6u = function (encoder, value) {
    var tmp0_desc = this.m6u_1;
    var tmp1_output = encoder.g5c(tmp0_desc);
    if (tmp1_output.b5e(tmp0_desc, 0) ? true : !(value.o6u_1 === '')) {
      tmp1_output.u5d(tmp0_desc, 0, value.o6u_1);
    }
    tmp1_output.h5c(tmp0_desc);
  };
  protoOf($serializer_4).i59 = function (encoder, value) {
    return this.n6u(encoder, value instanceof DynamicReferenceContent ? value : THROW_CCE());
  };
  protoOf($serializer_4).j59 = function (decoder) {
    var tmp0_desc = this.m6u_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.g5c(tmp0_desc);
    if (tmp5_input.v5c()) {
      tmp4_local0 = tmp5_input.q5c(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.w5c(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.q5c(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.h5c(tmp0_desc);
    return DynamicReferenceContent_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_4).v58 = function () {
    return this.m6u_1;
  };
  protoOf($serializer_4).f5k = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance()];
  };
  var $serializer_instance_4;
  function $serializer_getInstance_4() {
    if ($serializer_instance_4 == null)
      new $serializer_4();
    return $serializer_instance_4;
  }
  function DynamicReferenceContent_init_$Init$(seen0, targetName, serializationConstructorMarker, $this) {
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_4().m6u_1);
    }
    ReferenceContent_init_$Init$(seen0, serializationConstructorMarker, $this);
    if (0 === (seen0 & 1))
      $this.o6u_1 = '';
    else
      $this.o6u_1 = targetName;
    return $this;
  }
  function DynamicReferenceContent_init_$Create$(seen0, targetName, serializationConstructorMarker) {
    return DynamicReferenceContent_init_$Init$(seen0, targetName, serializationConstructorMarker, objectCreate(protoOf(DynamicReferenceContent)));
  }
  function DynamicReferenceContent(targetName) {
    targetName = targetName === VOID ? '' : targetName;
    ReferenceContent.call(this);
    this.o6u_1 = targetName;
  }
  protoOf(DynamicReferenceContent).toString = function () {
    // Inline function 'jetbrains.ocelot.langDef.references.content.ReferenceContentPersisters.serialize' call
    var this_0 = ReferenceContentPersisters_getInstance();
    return ensureNotNull(this_0.d6m(getKClass(DynamicReferenceContent)).w24(this));
  };
  protoOf(DynamicReferenceContent).hashCode = function () {
    return getStringHashCode(this.o6u_1);
  };
  protoOf(DynamicReferenceContent).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof DynamicReferenceContent))
      return false;
    if (!(this.o6u_1 === other.o6u_1))
      return false;
    return true;
  };
  function ContentFactory() {
  }
  function sam$jetbrains_ocelot_langDef_references_content_ReferenceContentFactories_ContentFactory$0(function_0) {
    this.p6u_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_langDef_references_content_ReferenceContentFactories_ContentFactory$0).h6q = function (target) {
    return this.p6u_1(target);
  };
  protoOf(sam$jetbrains_ocelot_langDef_references_content_ReferenceContentFactories_ContentFactory$0).f3 = function () {
    return this.p6u_1;
  };
  protoOf(sam$jetbrains_ocelot_langDef_references_content_ReferenceContentFactories_ContentFactory$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, ContentFactory) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_langDef_references_content_ReferenceContentFactories_ContentFactory$0).hashCode = function () {
    return hashCode(this.f3());
  };
  function ReferenceContentFactories$referenceContentFactories$lambda(it) {
    return new LocalReferenceContent(it.z3n());
  }
  function ReferenceContentFactories$referenceContentFactories$lambda_0(it) {
    return new QualifiedReferenceContent(ensureNotNull(get_pointer(it)));
  }
  function ReferenceContentFactories() {
    ReferenceContentFactories_instance = this;
    var tmp = this;
    var tmp_0 = getKClass(LocalReferenceContent);
    var tmp_1 = ReferenceContentFactories$referenceContentFactories$lambda;
    var tmp_2 = to(tmp_0, new sam$jetbrains_ocelot_langDef_references_content_ReferenceContentFactories_ContentFactory$0(tmp_1));
    var tmp_3 = getKClass(QualifiedReferenceContent);
    var tmp_4 = ReferenceContentFactories$referenceContentFactories$lambda_0;
    tmp.f6q_1 = mapOf_0([tmp_2, to(tmp_3, new sam$jetbrains_ocelot_langDef_references_content_ReferenceContentFactories_ContentFactory$0(tmp_4))]);
  }
  protoOf(ReferenceContentFactories).g6q = function (contentKClass) {
    var tmp = this.f6q_1.q2(contentKClass);
    return (!(tmp == null) ? isInterface(tmp, ContentFactory) : false) ? tmp : THROW_CCE();
  };
  var ReferenceContentFactories_instance;
  function ReferenceContentFactories_getInstance() {
    if (ReferenceContentFactories_instance == null)
      new ReferenceContentFactories();
    return ReferenceContentFactories_instance;
  }
  function toDeserializable($this, value) {
    // Inline function 'kotlinx.serialization.json.buildJsonObject' call
    // Inline function 'kotlin.contracts.contract' call
    var builder = new JsonObjectBuilder();
    put(builder, $this.s6u_1, value);
    return builder.r62();
  }
  function contentToStore($this, value) {
    var tmp0_safe_receiver = get_jsonObject(value).ld($this.s6u_1);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : get_jsonPrimitive(tmp0_safe_receiver);
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.h63();
    return tmp2_elvis_lhs == null ? '' : tmp2_elvis_lhs;
  }
  function DelegatePersister(serializer, format) {
    format = format === VOID ? Default_getInstance_0() : format;
    this.q6u_1 = serializer;
    this.r6u_1 = format;
    this.s6u_1 = ensureNotNull(ReferenceContentPersisters_getInstance().z6l_1.q2(this.q6u_1));
  }
  protoOf(DelegatePersister).v24 = function (value) {
    return this.r6u_1.o61(this.q6u_1, toDeserializable(this, value));
  };
  protoOf(DelegatePersister).t6u = function (value) {
    return contentToStore(this, this.r6u_1.n61(this.q6u_1, value));
  };
  protoOf(DelegatePersister).w24 = function (value) {
    return this.t6u(value instanceof ReferenceContent ? value : THROW_CCE());
  };
  function ReferenceContentPersisters() {
    ReferenceContentPersisters_instance = this;
    this.z6l_1 = mapOf_0([to(Companion_instance_104.i63(), 'nodeId'), to(Companion_instance_103.i63(), 'nodePointer'), to(Companion_instance_106.i63(), 'targetName')]);
    var tmp = this;
    // Inline function 'jetbrains.ocelot.langDef.references.content.ReferenceContentPersisters.createPersisterFor' call
    // Inline function 'kotlinx.serialization.serializer' call
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_0 = serializer_0(createKType(getKClass(LocalReferenceContent), arrayOf([]), false));
    var serializer = isInterface(this_0, KSerializer) ? this_0 : THROW_CCE();
    var format = Default_getInstance_0();
    tmp.a6m_1 = toNullablePersister(new DelegatePersister(serializer, format), new EmptyStringNullPersister());
    var tmp_0 = this;
    // Inline function 'jetbrains.ocelot.langDef.references.content.ReferenceContentPersisters.createPersisterFor' call
    // Inline function 'kotlinx.serialization.serializer' call
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_1 = serializer_0(createKType(getKClass(QualifiedReferenceContent), arrayOf([]), false));
    var serializer_1 = isInterface(this_1, KSerializer) ? this_1 : THROW_CCE();
    var format_0 = Default_getInstance_0();
    tmp_0.b6m_1 = toNullablePersister(new DelegatePersister(serializer_1, format_0), new EmptyStringNullPersister());
    var tmp_1 = this;
    // Inline function 'jetbrains.ocelot.langDef.references.content.ReferenceContentPersisters.createPersisterFor' call
    // Inline function 'kotlinx.serialization.serializer' call
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_2 = serializer_0(createKType(getKClass(DynamicReferenceContent), arrayOf([]), false));
    var serializer_2 = isInterface(this_2, KSerializer) ? this_2 : THROW_CCE();
    var format_1 = Default_getInstance_0();
    tmp_1.c6m_1 = toNullablePersister(new DelegatePersister(serializer_2, format_1), new EmptyStringNullPersister());
  }
  protoOf(ReferenceContentPersisters).d6m = function (clazz) {
    var tmp;
    if (clazz.equals(getKClass(LocalReferenceContent))) {
      tmp = this.a6m_1;
    } else if (clazz.equals(getKClass(QualifiedReferenceContent))) {
      tmp = this.b6m_1;
    } else if (clazz.equals(getKClass(DynamicReferenceContent))) {
      tmp = this.c6m_1;
    } else {
      throw IllegalArgumentException_init_$Create$();
    }
    var tmp_0 = tmp;
    return isInterface(tmp_0, Persister) ? tmp_0 : THROW_CCE();
  };
  var ReferenceContentPersisters_instance;
  function ReferenceContentPersisters_getInstance() {
    if (ReferenceContentPersisters_instance == null)
      new ReferenceContentPersisters();
    return ReferenceContentPersisters_instance;
  }
  function BaseDocumentRepository(documentConcepts) {
    this.u6u_1 = new BaseDocumentContainer(documentConcepts);
  }
  protoOf(BaseDocumentRepository).c6g = function (documentId) {
    return this.u6u_1.y6u(documentId);
  };
  protoOf(BaseDocumentRepository).z6u = function () {
    return this.u6u_1;
  };
  protoOf(BaseDocumentRepository).zr = function () {
    this.u6u_1.zr();
  };
  function Companion_107() {
  }
  var Companion_instance_107;
  function Companion_getInstance_107() {
    return Companion_instance_107;
  }
  function LocalDocumentRepository(documentConcepts) {
    BaseDocumentRepository.call(this, documentConcepts);
  }
  function BaseDocumentContainer$Companion$LOG$lambda() {
    return Unit_instance;
  }
  function BaseDocumentContainer$getDocumentQuery$o$run$lambda(this$0, $documentId) {
    return function (handler) {
      return this$0.w6u_1.k2w($documentId, handler);
    };
  }
  function Companion_108() {
    Companion_instance_108 = this;
    var tmp = this;
    var tmp_0 = KotlinLogging_getInstance();
    tmp.b6v_1 = tmp_0.i2q(BaseDocumentContainer$Companion$LOG$lambda);
  }
  var Companion_instance_108;
  function Companion_getInstance_108() {
    if (Companion_instance_108 == null)
      new Companion_108();
    return Companion_instance_108;
  }
  function sam$jetbrains_ocelot_base_observable_event_EventSource$0(function_0) {
    this.c6v_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_base_observable_event_EventSource$0).y2r = function (handler) {
    return this.c6v_1(handler);
  };
  protoOf(sam$jetbrains_ocelot_base_observable_event_EventSource$0).f3 = function () {
    return this.c6v_1;
  };
  protoOf(sam$jetbrains_ocelot_base_observable_event_EventSource$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, EventSource) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_base_observable_event_EventSource$0).hashCode = function () {
    return hashCode(this.f3());
  };
  function BaseDocumentContainer$documents$$inlined$query$1(this$0, $conceptDescriptor) {
    this.d6v_1 = this$0;
    this.e6v_1 = $conceptDescriptor;
  }
  protoOf(BaseDocumentContainer$documents$$inlined$query$1).n5w = function (builder) {
    var tmp = builder.l60(ensureNotNull(this.d6v_1.x6u_1.q2(this.e6v_1.m6n_1)));
    return asSequence_0(isInterface(tmp, Collection) ? tmp : THROW_CCE());
  };
  function BaseDocumentContainer$getDocumentQuery$$inlined$query$1(this$0, $documentId) {
    this.f6v_1 = this$0;
    this.g6v_1 = $documentId;
  }
  protoOf(BaseDocumentContainer$getDocumentQuery$$inlined$query$1).n5w = function (builder) {
    var tmp = BaseDocumentContainer$getDocumentQuery$o$run$lambda(this.f6v_1, this.g6v_1);
    builder.q5w_1.o5w_1.x5u(new sam$jetbrains_ocelot_base_observable_event_EventSource$0(tmp), Invalidation_getInstance().g5u_1);
    return this.f6v_1.c6g(this.g6v_1);
  };
  function BaseDocumentContainer$dispose$lambda(it) {
    it.n2s(Unit_instance);
    return Unit_instance;
  }
  function BaseDocumentContainer(conceptDescriptors) {
    Companion_getInstance_108();
    this.v6u_1 = HashMap_init_$Create$();
    this.w6u_1 = new ListenersMap();
    var tmp = this;
    // Inline function 'kotlin.collections.associate' call
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(conceptDescriptors, 10)), 16);
    // Inline function 'kotlin.collections.associateTo' call
    var destination = LinkedHashMap_init_$Create$_0(capacity);
    var _iterator__ex2g4s = conceptDescriptors.m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      // Inline function 'kotlin.collections.plusAssign' call
      var pair = to(element.m6n_1, get_forQueries_4(ObservableHashSet_init_$Create$()));
      destination.t2(pair.pg_1, pair.qg_1);
    }
    tmp.x6u_1 = destination;
  }
  protoOf(BaseDocumentContainer).h6v = function (conceptDescriptor) {
    // Inline function 'jetbrains.ocelot.langDef.query.query' call
    return new BaseDocumentContainer$documents$$inlined$query$1(this, conceptDescriptor);
  };
  protoOf(BaseDocumentContainer).c6g = function (documentId) {
    return this.v6u_1.q2(documentId);
  };
  protoOf(BaseDocumentContainer).y6u = function (documentId) {
    // Inline function 'jetbrains.ocelot.langDef.query.query' call
    return new BaseDocumentContainer$getDocumentQuery$$inlined$query$1(this, documentId);
  };
  protoOf(BaseDocumentContainer).zr = function () {
    var documentIds = toList_0(this.v6u_1.r2());
    this.v6u_1.k2();
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = this.x6u_1.s2().m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      element.k2();
    }
    var _iterator__ex2g4s_0 = documentIds.m();
    while (_iterator__ex2g4s_0.n()) {
      var documentId = _iterator__ex2g4s_0.o();
      this.w6u_1.l2w(documentId, BaseDocumentContainer$dispose$lambda);
    }
    this.w6u_1.k2();
  };
  function Companion_109() {
  }
  var Companion_instance_109;
  function Companion_getInstance_109() {
    return Companion_instance_109;
  }
  function DocumentContainerProvider$provide$$inlined$query$1(this$0) {
    this.i6v_1 = this$0;
  }
  protoOf(DocumentContainerProvider$provide$$inlined$query$1).n5w = function (builder) {
    return this.i6v_1.z6u();
  };
  function DocumentContainerProvider() {
  }
  function AttributePersisters$baseDecimalPersister$1() {
  }
  protoOf(AttributePersisters$baseDecimalPersister$1).v24 = function (value) {
    return Companion_getInstance_24().j29(value);
  };
  protoOf(AttributePersisters$baseDecimalPersister$1).j6v = function (value) {
    return value.toString();
  };
  protoOf(AttributePersisters$baseDecimalPersister$1).w24 = function (value) {
    return this.j6v(value instanceof BigDecimal ? value : THROW_CCE());
  };
  protoOf(AttributePersisters$baseDecimalPersister$1).toString = function () {
    return 'ionspin.bigDecimal.Persister';
  };
  function AttributePersisters() {
    AttributePersisters_instance = this;
    var tmp = this;
    tmp.l6j_1 = new AttributePersisters$baseDecimalPersister$1();
    this.m6j_1 = toNonNullPersister(this.l6j_1);
    this.n6j_1 = toNullablePersister(this.l6j_1);
  }
  var AttributePersisters_instance;
  function AttributePersisters_getInstance() {
    if (AttributePersisters_instance == null)
      new AttributePersisters();
    return AttributePersisters_instance;
  }
  function NodeIdSerializer() {
    NodeIdSerializer_instance = this;
    this.k6v_1 = PrimitiveSerialDescriptor('NodeId', STRING_getInstance());
  }
  protoOf(NodeIdSerializer).v58 = function () {
    return this.k6v_1;
  };
  protoOf(NodeIdSerializer).j59 = function (decoder) {
    return new NodeId(decoder.c5c());
  };
  protoOf(NodeIdSerializer).l6v = function (encoder, value) {
    return encoder.j5d(value.q36_1);
  };
  protoOf(NodeIdSerializer).i59 = function (encoder, value) {
    return this.l6v(encoder, value instanceof NodeId ? value : THROW_CCE());
  };
  var NodeIdSerializer_instance;
  function NodeIdSerializer_getInstance() {
    if (NodeIdSerializer_instance == null)
      new NodeIdSerializer();
    return NodeIdSerializer_instance;
  }
  function NodePersister() {
  }
  function Companion_110() {
  }
  var Companion_instance_110;
  function Companion_getInstance_110() {
    return Companion_instance_110;
  }
  function serialization(block) {
    var tmp = Companion_instance_41;
    var tmp_0 = [Companion_instance_110];
    return tmp.m3b(tmp_0, VOID, serialization$lambda(block));
  }
  function serialization$2$builder$1($it, $defaultNodePersister) {
    this.n6v_1 = $defaultNodePersister;
    this.m6v_1 = $it;
  }
  protoOf(serialization$2$builder$1).o6v = function (persister) {
    if (!(this.n6v_1._v == null)) {
      throw LanguageConfigurationException_init_$Create$_0('default node persister already set');
    }
    this.n6v_1._v = persister;
  };
  protoOf(serialization$2$builder$1).h3b = function (key) {
    return this.m6v_1.h3b(key);
  };
  protoOf(serialization$2$builder$1).e3c = function (_this__u8e3s4, thisRef, property) {
    return this.m6v_1.e3c(_this__u8e3s4, thisRef, property);
  };
  function serialization$2$1($defaultNodePersister) {
    this.p6v_1 = $defaultNodePersister;
  }
  protoOf(serialization$2$1).q6v = function (type) {
    var tmp0_safe_receiver = this.p6v_1._v;
    var tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver();
    var tmp1_elvis_lhs = (!(tmp == null) ? isInterface(tmp, NodePersister) : false) ? tmp : null;
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      throw LanguageConfigurationException_init_$Create$_0('persister not found for type ' + toString_1(type));
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    return tmp_0;
  };
  function serialization$lambda($block) {
    return function (it) {
      var defaultNodePersister = {_v: null};
      var builder = new serialization$2$builder$1(it, defaultNodePersister);
      $block(builder);
      return new serialization$2$1(defaultNodePersister);
    };
  }
  function documentIdOfMarkedNode($this, node) {
    return toOtNode(node).d3n($this.v6f_1).uv();
  }
  function topmostAncestorOrSelf($this, _this__u8e3s4) {
    return last_1(generateSequence(_this__u8e3s4, DocumentIdUtil$topmostAncestorOrSelf$lambda));
  }
  function DocumentIdUtil$topmostAncestorOrSelf$lambda(it) {
    return it.bp();
  }
  function DocumentIdUtil() {
    DocumentIdUtil_instance = this;
    this.v6f_1 = NodePropertyIdFactory_getInstance().b3r('document_id_mark');
  }
  protoOf(DocumentIdUtil).w6f = function (node, documentId) {
    var tmp;
    if (isInterface(node, DocumentNode)) {
      node.d6g().d2x(documentId);
      tmp = Unit_instance;
    } else {
      // Inline function 'kotlin.require' call
      // Inline function 'kotlin.require' call
      if (!(node.bp() == null)) {
        var message = 'Failed requirement.';
        throw IllegalArgumentException_init_$Create$_0(toString_1(message));
      }
      toOtNode(node).d3n(this.v6f_1).d2x(documentId);
      tmp = Unit_instance;
    }
    return tmp;
  };
  protoOf(DocumentIdUtil).r6v = function (node) {
    var tmp0_safe_receiver = node.t42();
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.d6g();
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : execute_0(tmp1_safe_receiver);
    return tmp2_elvis_lhs == null ? documentIdOfMarkedNode(this, topmostAncestorOrSelf(this, node)) : tmp2_elvis_lhs;
  };
  var DocumentIdUtil_instance;
  function DocumentIdUtil_getInstance() {
    if (DocumentIdUtil_instance == null)
      new DocumentIdUtil();
    return DocumentIdUtil_instance;
  }
  function DocumentNode() {
  }
  function DomainNode() {
  }
  function LightDomainNode() {
  }
  function DirectlyNamed() {
  }
  function Named() {
  }
  function get_pointer(_this__u8e3s4) {
    var docId = DocumentIdUtil_getInstance().r6v(_this__u8e3s4);
    // Inline function 'kotlin.text.isNullOrEmpty' call
    if (docId == null || charSequenceLength(docId) === 0)
      return null;
    return new NodePointer(docId, _this__u8e3s4.z3n());
  }
  function get_stringId(_this__u8e3s4) {
    return _this__u8e3s4.z3n().q36_1;
  }
  function toDomainNode(_this__u8e3s4, wrapperContext) {
    wrapperContext = wrapperContext === VOID ? null : wrapperContext;
    var tmp;
    if (isInterface(_this__u8e3s4, DomainNode)) {
      tmp = _this__u8e3s4;
    } else {
      tmp = ensureNotNull(wrapperContext).f58(_this__u8e3s4);
    }
    return tmp;
  }
  function toOtNode(_this__u8e3s4) {
    var tmp;
    if (_this__u8e3s4 instanceof OtNode) {
      tmp = _this__u8e3s4;
    } else {
      tmp = (_this__u8e3s4 instanceof NodeWrapper ? _this__u8e3s4 : THROW_CCE()).b57_1;
    }
    return tmp;
  }
  function get_wrapperContextOrNull(_this__u8e3s4) {
    var tmp;
    if (_this__u8e3s4 instanceof NodeWrapper) {
      tmp = _this__u8e3s4.a57_1;
    } else {
      tmp = null;
    }
    return tmp;
  }
  function NodeFactory() {
  }
  protoOf(NodeFactory).t6v = function (concept, id, $super) {
    id = id === VOID ? null : id;
    return $super === VOID ? this.s6v(concept, id) : $super.s6v.call(this, concept, id);
  };
  function ChildrenList() {
  }
  function ChildProperty() {
  }
  function MultipleChildLink(sourceConcept, property) {
    ChildLink.call(this);
    this.g6h_1 = sourceConcept;
    this.h6h_1 = property;
  }
  protoOf(MultipleChildLink).p6q = function () {
    return this.g6h_1;
  };
  protoOf(MultipleChildLink).q6q = function () {
    return this.h6h_1;
  };
  function ValueAttributeLink(sourceConcept, property, type) {
    AttributeLink.call(this);
    this.u6v_1 = sourceConcept;
    this.v6v_1 = property;
    this.w6v_1 = type;
  }
  protoOf(ValueAttributeLink).p6q = function () {
    return this.u6v_1;
  };
  protoOf(ValueAttributeLink).q6q = function () {
    return this.v6v_1;
  };
  function SingleChildLink(sourceConcept, property) {
    ChildLink.call(this);
    this.i6h_1 = sourceConcept;
    this.j6h_1 = property;
  }
  protoOf(SingleChildLink).p6q = function () {
    return this.i6h_1;
  };
  protoOf(SingleChildLink).q6q = function () {
    return this.j6h_1;
  };
  function ChildLink() {
    NodeLink.call(this);
  }
  function NodeLink() {
  }
  protoOf(NodeLink).equals = function (other) {
    if (!(other instanceof NodeLink))
      return false;
    return this.p6q().equals(other.p6q()) && this.q6q().callableName === other.q6q().callableName;
  };
  protoOf(NodeLink).hashCode = function () {
    return this.p6q().hashCode() + imul(31, getStringHashCode(this.q6q().callableName)) | 0;
  };
  protoOf(NodeLink).toString = function () {
    return toString_1(this.p6q()) + '#' + this.q6q().callableName;
  };
  function TextAttributeLink(sourceConcept, property) {
    AttributeLink.call(this);
    this.m6m_1 = sourceConcept;
    this.n6m_1 = property;
  }
  protoOf(TextAttributeLink).p6q = function () {
    return this.m6m_1;
  };
  protoOf(TextAttributeLink).q6q = function () {
    return this.n6m_1;
  };
  function Companion_111() {
    Companion_instance_111 = this;
    this.x6v_1 = new SerializedChildLink('');
  }
  var Companion_instance_111;
  function Companion_getInstance_111() {
    if (Companion_instance_111 == null)
      new Companion_111();
    return Companion_instance_111;
  }
  function $serializer_5() {
    $serializer_instance_5 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('jetbrains.ocelot.langDef.structure.SerializedChildLink', this, 1);
    tmp0_serialDesc.q5j('value', false);
    this.y6v_1 = tmp0_serialDesc;
  }
  protoOf($serializer_5).z6v = function (encoder, value) {
    var tmp0_desc = this.y6v_1;
    var tmp1_output = encoder.g5c(tmp0_desc);
    tmp1_output.u5d(tmp0_desc, 0, value.a6w_1);
    tmp1_output.h5c(tmp0_desc);
  };
  protoOf($serializer_5).i59 = function (encoder, value) {
    return this.z6v(encoder, value instanceof SerializedChildLink ? value : THROW_CCE());
  };
  protoOf($serializer_5).j59 = function (decoder) {
    var tmp0_desc = this.y6v_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.g5c(tmp0_desc);
    if (tmp5_input.v5c()) {
      tmp4_local0 = tmp5_input.q5c(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.w5c(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.q5c(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.h5c(tmp0_desc);
    return SerializedChildLink_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_5).v58 = function () {
    return this.y6v_1;
  };
  protoOf($serializer_5).f5k = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance()];
  };
  var $serializer_instance_5;
  function $serializer_getInstance_5() {
    if ($serializer_instance_5 == null)
      new $serializer_5();
    return $serializer_instance_5;
  }
  function SerializedChildLink_init_$Init$(seen0, value, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_5().y6v_1);
    }
    $this.a6w_1 = value;
    return $this;
  }
  function SerializedChildLink_init_$Create$(seen0, value, serializationConstructorMarker) {
    return SerializedChildLink_init_$Init$(seen0, value, serializationConstructorMarker, objectCreate(protoOf(SerializedChildLink)));
  }
  function SerializedChildLink(value) {
    Companion_getInstance_111();
    this.a6w_1 = value;
  }
  protoOf(SerializedChildLink).toString = function () {
    return 'SerializedChildLink(value=' + this.a6w_1 + ')';
  };
  protoOf(SerializedChildLink).hashCode = function () {
    return getStringHashCode(this.a6w_1);
  };
  protoOf(SerializedChildLink).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SerializedChildLink))
      return false;
    if (!(this.a6w_1 === other.a6w_1))
      return false;
    return true;
  };
  function ChildContext(node, link) {
    this.j6p_1 = node;
    this.k6p_1 = link;
  }
  function singleChildContext(node, childLink) {
    return new ChildContext(node, childLink);
  }
  function AttributeLink() {
    NodeLink.call(this);
  }
  function WrapStep$Companion$create$1($target, $wrapper) {
    this.c6w_1 = $wrapper;
    WrapStep.call(this, $target);
  }
  protoOf(WrapStep$Companion$create$1).d6w = function (node) {
    return this.c6w_1(node);
  };
  function Companion_112() {
  }
  protoOf(Companion_112).g6w = function (target, wrapper) {
    return new WrapStep$Companion$create$1(target, wrapper);
  };
  var Companion_instance_112;
  function Companion_getInstance_112() {
    return Companion_instance_112;
  }
  function WrapStep(targetConcept) {
    this.e6w_1 = targetConcept;
  }
  protoOf(WrapStep).f6w = function () {
    return this.e6w_1;
  };
  protoOf(WrapStep).toString = function () {
    return 'Wrap into ' + toString_1(this.f6w());
  };
  function UnwrapStep() {
  }
  function IdentityStep(targetConcept) {
    this.h6w_1 = targetConcept;
  }
  protoOf(IdentityStep).f6w = function () {
    return this.h6w_1;
  };
  protoOf(IdentityStep).d6w = function (node) {
    return node;
  };
  protoOf(IdentityStep).toString = function () {
    return 'Identity ' + toString_1(this.h6w_1);
  };
  function KnowsTargetConcept() {
  }
  function TransformStep$Companion$create$1($target, $transformer) {
    this.j6w_1 = $transformer;
    TransformStep.call(this, $target);
  }
  protoOf(TransformStep$Companion$create$1).d6w = function (node) {
    return this.j6w_1(node);
  };
  function Companion_113() {
  }
  protoOf(Companion_113).g6w = function (target, transformer) {
    return new TransformStep$Companion$create$1(target, transformer);
  };
  var Companion_instance_113;
  function Companion_getInstance_113() {
    return Companion_instance_113;
  }
  function TransformStep(targetConcept) {
    this.k6w_1 = targetConcept;
  }
  protoOf(TransformStep).f6w = function () {
    return this.k6w_1;
  };
  protoOf(TransformStep).toString = function () {
    return 'Turn into ' + toString_1(this.f6w());
  };
  function put_0($this, _this__u8e3s4, key, value) {
    // Inline function 'kotlin.collections.getOrPut' call
    var value_0 = _this__u8e3s4.q2(key);
    var tmp;
    if (value_0 == null) {
      // Inline function 'kotlin.collections.mutableListOf' call
      var answer = ArrayList_init_$Create$();
      _this__u8e3s4.t2(key, answer);
      tmp = answer;
    } else {
      tmp = value_0;
    }
    tmp.j(value);
  }
  function cloneIfNeeded($this, _this__u8e3s4) {
    return !(_this__u8e3s4.bp() == null) ? _this__u8e3s4.f6j() : _this__u8e3s4;
  }
  function transitivelyClose($this, _this__u8e3s4) {
    // Inline function 'kotlin.collections.groupBy' call
    // Inline function 'kotlin.collections.groupByTo' call
    var destination = LinkedHashMap_init_$Create$();
    var _iterator__ex2g4s = _this__u8e3s4.m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      var source = element.fg();
      var key = source;
      // Inline function 'kotlin.collections.getOrPut' call
      var value = destination.q2(key);
      var tmp;
      if (value == null) {
        var answer = ArrayList_init_$Create$();
        destination.t2(key, answer);
        tmp = answer;
      } else {
        tmp = value;
      }
      var list = tmp;
      list.j(element);
    }
    // Inline function 'kotlin.collections.mapValues' call
    // Inline function 'kotlin.collections.mapValuesTo' call
    var destination_0 = LinkedHashMap_init_$Create$_0(mapCapacity(destination.p()));
    // Inline function 'kotlin.collections.associateByTo' call
    var _iterator__ex2g4s_0 = destination.y().m();
    while (_iterator__ex2g4s_0.n()) {
      var element_0 = _iterator__ex2g4s_0.o();
      var tmp_0 = element_0.z();
      // Inline function 'kotlin.collections.component2' call
      var list_0 = element_0.a1();
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(list_0, 10));
      var _iterator__ex2g4s_1 = list_0.m();
      while (_iterator__ex2g4s_1.n()) {
        var item = _iterator__ex2g4s_1.o();
        var target = item.gg();
        destination_1.j(target);
      }
      destination_0.t2(tmp_0, destination_1);
    }
    var groupedBySource = destination_0;
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s_2 = groupedBySource.y().m();
    while (_iterator__ex2g4s_2.n()) {
      var element_1 = _iterator__ex2g4s_2.o();
      // Inline function 'kotlin.collections.component1' call
      var source_0 = element_1.z();
      // Inline function 'kotlin.collections.component2' call
      var targets = element_1.a1();
      var next = targets;
      $l$loop: while (true) {
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!!next.s()) {
          break $l$loop;
        }
        // Inline function 'kotlin.collections.flatMap' call
        var tmp0 = next;
        // Inline function 'kotlin.collections.flatMapTo' call
        var destination_2 = ArrayList_init_$Create$();
        var _iterator__ex2g4s_3 = tmp0.m();
        while (_iterator__ex2g4s_3.n()) {
          var element_2 = _iterator__ex2g4s_3.o();
          var tmp0_elvis_lhs = groupedBySource.q2(element_2);
          var list_1 = tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
          addAll_1(destination_2, list_1);
        }
        var targetsTargets = destination_2;
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s_4 = targetsTargets.m();
        while (_iterator__ex2g4s_4.n()) {
          var element_3 = _iterator__ex2g4s_4.o();
          _this__u8e3s4.j(to(source_0, element_3));
        }
        next = targetsTargets;
      }
    }
  }
  function isAdapterConcept($this, _this__u8e3s4) {
    var tmp;
    if (_this__u8e3s4.o6w_1 && _this__u8e3s4.n6w_1) {
      var tmp_0 = singleOrNull(_this__u8e3s4.r6w_1);
      tmp = tmp_0 instanceof ChildrenMemberData ? tmp_0 : null;
    } else {
      tmp = null;
    }
    return tmp;
  }
  function childContainer($this, node, link) {
    return link.q6q().get(node);
  }
  function singleChild($this, node, link) {
    if (!(link instanceof NodeLink))
      THROW_CCE();
    var tmp = childContainer($this, node, link);
    return (!(tmp == null) ? isInterface(tmp, ChildProperty) : false) ? tmp : THROW_CCE();
  }
  function multipleChild($this, node, link) {
    if (!(link instanceof NodeLink))
      THROW_CCE();
    var tmp = childContainer($this, node, link);
    return (!(tmp == null) ? isInterface(tmp, ChildrenList) : false) ? tmp : THROW_CCE();
  }
  function findPath($this, source, target, startNode) {
    var queue = ArrayDeque_init_$Create$();
    queue.j(new NodeAdaptationSupportImpl$findPath$Context(source, emptyList(), emptySet(), false, false));
    $l$loop_1: while (true) {
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!!queue.s()) {
        break $l$loop_1;
      }
      var context = queue.qf();
      if (context.u6w_1.t(context.s6w_1))
        continue $l$loop_1;
      if (context.s6w_1.equals(target) || $this.a6x_1.t(to(context.s6w_1, target))) {
        var path = context.s6w_1.equals(target) ? context.t6w_1 : plus_6(context.t6w_1, new IdentityStep(target));
        var result = adapter(path, startNode);
        if (result == null || !$this.z6w_1(result)) {
          continue $l$loop_1;
        }
        return path;
      }
      var tmp0_safe_receiver = $this.b6x_1.q2(context.s6w_1);
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s = tmp0_safe_receiver.m();
        while (_iterator__ex2g4s.n()) {
          var element = _iterator__ex2g4s.o();
          $l$block_1: {
            var tmp;
            if (isInterface(element, KnowsTargetConcept)) {
              var tmp_0;
              if (context.v6w_1) {
                tmp_0 = element instanceof IdentityStep;
              } else {
                tmp_0 = false;
              }
              if (tmp_0) {
                break $l$block_1;
              }
              var tmp_1 = element.f6w();
              var tmp_2 = plus_6(context.t6w_1, element);
              var tmp_3 = plus_11(context.u6w_1, context.s6w_1);
              var tmp_4 = element instanceof IdentityStep;
              var tmp_5;
              if (context.w6w_1) {
                tmp_5 = true;
              } else {
                tmp_5 = element instanceof WrapStep;
              }
              tmp = new NodeAdaptationSupportImpl$findPath$Context(tmp_1, tmp_2, tmp_3, tmp_4, tmp_5);
            } else {
              if (isInterface(element, UnwrapStep)) {
                if (context.w6w_1) {
                  break $l$block_1;
                }
                var tmp1_safe_receiver = adapter(context.t6w_1, startNode);
                var tmp_6;
                if (tmp1_safe_receiver == null) {
                  tmp_6 = null;
                } else {
                  // Inline function 'kotlin.let' call
                  tmp_6 = element.d6w(tmp1_safe_receiver);
                }
                var tmp2_safe_receiver = tmp_6;
                var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : _get_concept__pinnop($this, tmp2_safe_receiver);
                var tmp_7;
                if (tmp3_elvis_lhs == null) {
                  break $l$block_1;
                } else {
                  tmp_7 = tmp3_elvis_lhs;
                }
                var unwrappedConcept = tmp_7;
                tmp = new NodeAdaptationSupportImpl$findPath$Context(unwrappedConcept, plus_6(context.t6w_1, element), plus_11(context.u6w_1, context.s6w_1), false, false);
              } else {
                noWhenBranchMatchedException();
              }
            }
            var nextContext = tmp;
            queue.pf(nextContext);
          }
        }
      }
    }
    return null;
  }
  function _get_concept__pinnop($this, _this__u8e3s4) {
    return $this.y6w_1.n6l(getKClassFromExpression(_this__u8e3s4));
  }
  function sam$jetbrains_ocelot_langDef_structure_adaptation_UnwrapStep$0(function_0) {
    this.c6x_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_langDef_structure_adaptation_UnwrapStep$0).d6w = function (node) {
    return this.c6x_1(node);
  };
  protoOf(sam$jetbrains_ocelot_langDef_structure_adaptation_UnwrapStep$0).f3 = function () {
    return this.c6x_1;
  };
  protoOf(sam$jetbrains_ocelot_langDef_structure_adaptation_UnwrapStep$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, UnwrapStep) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_langDef_structure_adaptation_UnwrapStep$0).hashCode = function () {
    return hashCode(this.f3());
  };
  function NodeAdaptationSupportImpl$_init_$lambda_gqngq9(it) {
    return true;
  }
  function NodeAdaptationSupportImpl$lambda(this$0, $concept, $link) {
    return function (node) {
      var newNode = this$0.x6w_1.t6v($concept);
      multipleChild(this$0, newNode, $link).j(cloneIfNeeded(this$0, node));
      return newNode;
    };
  }
  function NodeAdaptationSupportImpl$lambda_0(this$0, $link) {
    return function (it) {
      var tmp0_safe_receiver = singleOrNull(multipleChild(this$0, it, $link).m5y());
      return tmp0_safe_receiver == null ? null : cloneIfNeeded(this$0, tmp0_safe_receiver);
    };
  }
  function NodeAdaptationSupportImpl$lambda_1(this$0, $concept, $link) {
    return function (node) {
      var newNode = this$0.x6w_1.t6v($concept);
      singleChild(this$0, newNode, $link).d2x(cloneIfNeeded(this$0, node));
      return newNode;
    };
  }
  function NodeAdaptationSupportImpl$lambda_2(this$0, $link) {
    return function (node) {
      var tmp0_safe_receiver = singleChild(this$0, node, $link).m5y().uv();
      return tmp0_safe_receiver == null ? null : cloneIfNeeded(this$0, tmp0_safe_receiver);
    };
  }
  function NodeAdaptationSupportImpl$findPath$Context(concept, path, visited, lastIsIdentity, hasBeenWrapped) {
    this.s6w_1 = concept;
    this.t6w_1 = path;
    this.u6w_1 = visited;
    this.v6w_1 = lastIsIdentity;
    this.w6w_1 = hasBeenWrapped;
  }
  function NodeAdaptationSupportImpl(metaModel, nodeFactory, conceptRegistry, validator, customAdapters) {
    var tmp;
    if (validator === VOID) {
      tmp = NodeAdaptationSupportImpl$_init_$lambda_gqngq9;
    } else {
      tmp = validator;
    }
    validator = tmp;
    customAdapters = customAdapters === VOID ? emptyList() : customAdapters;
    this.x6w_1 = nodeFactory;
    this.y6w_1 = conceptRegistry;
    this.z6w_1 = validator;
    // Inline function 'kotlin.collections.mutableSetOf' call
    var identities = LinkedHashSet_init_$Create$();
    // Inline function 'kotlin.collections.mutableMapOf' call
    var adapters = LinkedHashMap_init_$Create$();
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s = metaModel.d6x().y().m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      // Inline function 'kotlin.collections.component1' call
      var concept = element.z();
      // Inline function 'kotlin.collections.component2' call
      var data = element.a1();
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s_0 = data.e6x().m();
      while (_iterator__ex2g4s_0.n()) {
        var element_0 = _iterator__ex2g4s_0.o();
        identities.j(to(concept, element_0));
      }
      var tmp0_safe_receiver = isAdapterConcept(this, data);
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        var childConcept = tmp0_safe_receiver.h6x_1;
        var link = tmp0_safe_receiver.f6x_1;
        if (tmp0_safe_receiver.i6x_1) {
          var tmp_0 = Companion_instance_112;
          var wrapper = tmp_0.g6w(concept, NodeAdaptationSupportImpl$lambda(this, concept, link));
          var tmp_1 = NodeAdaptationSupportImpl$lambda_0(this, link);
          var unwrapper = new sam$jetbrains_ocelot_langDef_structure_adaptation_UnwrapStep$0(tmp_1);
          put_0(this, adapters, childConcept, wrapper);
          put_0(this, adapters, concept, unwrapper);
        } else {
          var tmp_2 = Companion_instance_112;
          var wrapper_0 = tmp_2.g6w(concept, NodeAdaptationSupportImpl$lambda_1(this, concept, link));
          var tmp_3 = NodeAdaptationSupportImpl$lambda_2(this, link);
          var unwrapper_0 = new sam$jetbrains_ocelot_langDef_structure_adaptation_UnwrapStep$0(tmp_3);
          put_0(this, adapters, childConcept, wrapper_0);
          put_0(this, adapters, concept, unwrapper_0);
        }
      }
    }
    transitivelyClose(this, identities);
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s_1 = identities.m();
    while (_iterator__ex2g4s_1.n()) {
      var element_1 = _iterator__ex2g4s_1.o();
      var source = element_1.fg();
      var target = element_1.gg();
      put_0(this, adapters, source, new IdentityStep(target));
    }
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s_2 = customAdapters.m();
    while (_iterator__ex2g4s_2.n()) {
      var element_2 = _iterator__ex2g4s_2.o();
      var concept_0 = element_2.fg();
      var adapter = element_2.gg();
      put_0(this, adapters, concept_0, adapter);
    }
    this.a6x_1 = identities;
    this.b6x_1 = adapters;
  }
  protoOf(NodeAdaptationSupportImpl).l6x = function (node, targetConcept) {
    var tmp0_safe_receiver = safeCast(targetConcept, node);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      return tmp0_safe_receiver;
    }
    var tmp1_elvis_lhs = findPath(this, _get_concept__pinnop(this, node), targetConcept, node);
    var tmp;
    if (tmp1_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp1_elvis_lhs;
    }
    var path = tmp;
    var tmp_0 = adapter(path, node);
    return (!(tmp_0 == null) ? isInterface(tmp_0, DomainNode) : false) ? tmp_0 : THROW_CCE();
  };
  function adapter(_this__u8e3s4, node) {
    var running = node;
    var _iterator__ex2g4s = _this__u8e3s4.m();
    $l$loop: while (_iterator__ex2g4s.n()) {
      var step = _iterator__ex2g4s.o();
      if (running == null)
        break $l$loop;
      running = step.d6w(running);
    }
    return running;
  }
  function Companion_114() {
  }
  var Companion_instance_114;
  function Companion_getInstance_114() {
    return Companion_instance_114;
  }
  function NodeAdapter(source, adapter) {
    this.j6x_1 = source;
    this.k6x_1 = adapter;
  }
  protoOf(NodeAdapter).fg = function () {
    return this.j6x_1;
  };
  protoOf(NodeAdapter).gg = function () {
    return this.k6x_1;
  };
  protoOf(NodeAdapter).toString = function () {
    return 'NodeAdapter(source=' + toString_1(this.j6x_1) + ', adapter=' + toString_1(this.k6x_1) + ')';
  };
  protoOf(NodeAdapter).hashCode = function () {
    var result = this.j6x_1.hashCode();
    result = imul(result, 31) + hashCode(this.k6x_1) | 0;
    return result;
  };
  protoOf(NodeAdapter).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof NodeAdapter))
      return false;
    if (!this.j6x_1.equals(other.j6x_1))
      return false;
    if (!equals(this.k6x_1, other.k6x_1))
      return false;
    return true;
  };
  function wrapsOrTurnsInto(source, target, wrapper, adapt) {
    var adapter = wrapsOrTurnsInto$lambda(adapt);
    var adaptationStep = wrapper ? Companion_instance_112.g6w(target, adapter) : Companion_instance_113.g6w(target, adapter);
    return new NodeAdapter(source, adaptationStep);
  }
  function unwraps(source, adapt) {
    var tmp = unwraps$lambda(adapt);
    var adaptation = new sam$jetbrains_ocelot_langDef_structure_adaptation_UnwrapStep$0_0(tmp);
    return new NodeAdapter(source, adaptation);
  }
  function sam$jetbrains_ocelot_langDef_structure_adaptation_UnwrapStep$0_0(function_0) {
    this.m6x_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_langDef_structure_adaptation_UnwrapStep$0_0).d6w = function (node) {
    return this.m6x_1(node);
  };
  protoOf(sam$jetbrains_ocelot_langDef_structure_adaptation_UnwrapStep$0_0).f3 = function () {
    return this.m6x_1;
  };
  protoOf(sam$jetbrains_ocelot_langDef_structure_adaptation_UnwrapStep$0_0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, UnwrapStep) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_langDef_structure_adaptation_UnwrapStep$0_0).hashCode = function () {
    return hashCode(this.f3());
  };
  function wrapsOrTurnsInto$lambda($adapt) {
    return function (it) {
      if (!isInterface(it, DomainNode))
        THROW_CCE();
      return $adapt(it);
    };
  }
  function unwraps$lambda($adapt) {
    return function (container) {
      if (!isInterface(container, DomainNode))
        THROW_CCE();
      return $adapt(container);
    };
  }
  function concrete($this, _this__u8e3s4) {
    // Inline function 'kotlin.collections.mapNotNull' call
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var destination = ArrayList_init_$Create$();
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s = _this__u8e3s4.y().m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      // Inline function 'kotlin.collections.component1' call
      var concept = element.z();
      // Inline function 'kotlin.collections.component2' call
      var descriptor = element.a1();
      var tmp;
      if (!(descriptor instanceof OtConceptDescriptor)) {
        tmp = null;
      } else {
        tmp = to(concept, descriptor);
      }
      var tmp0_safe_receiver = tmp;
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        destination.j(tmp0_safe_receiver);
      }
    }
    return toMap_0(destination);
  }
  function checkUniqueness($this, records) {
    var conceptIds = HashSet_init_$Create$();
    var sourceClasses = HashSet_init_$Create$();
    var _iterator__ex2g4s = records.m();
    while (_iterator__ex2g4s.n()) {
      var record = _iterator__ex2g4s.o();
      var tmp = record.o6x_1;
      if (tmp instanceof OtConceptDescriptor) {
        var conceptId = record.o6x_1.m6n_1;
        var idWasNotPresent = conceptIds.j(conceptId);
        // Inline function 'kotlin.check' call
        if (!idWasNotPresent) {
          var message = "duplicate concept id: '" + conceptId.toString() + "'";
          throw IllegalStateException_init_$Create$_0(toString_1(message));
        }
      }
      var sourceClass = record.n6x_1;
      var classWasNotPresent = sourceClasses.j(sourceClass);
      // Inline function 'kotlin.check' call
      if (!classWasNotPresent) {
        var message_0 = "duplicate source class: '" + toString_1(sourceClass) + "'";
        throw IllegalStateException_init_$Create$_0(toString_1(message_0));
      }
    }
  }
  function Companion_115() {
  }
  var Companion_instance_115;
  function Companion_getInstance_115() {
    return Companion_instance_115;
  }
  function BaseConceptRegistry(conceptRecords, implementationRecords, useExperimentalNode) {
    checkUniqueness(Companion_instance_115, conceptRecords);
    // Inline function 'kotlin.collections.associate' call
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(conceptRecords, 10)), 16);
    // Inline function 'kotlin.collections.associateTo' call
    var destination = LinkedHashMap_init_$Create$_0(capacity);
    var _iterator__ex2g4s = conceptRecords.m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      // Inline function 'kotlin.collections.plusAssign' call
      var pair = to(element.n6x_1, element.o6x_1);
      destination.t2(pair.pg_1, pair.qg_1);
    }
    var map = destination;
    // Inline function 'kotlin.collections.associate' call
    var capacity_0 = coerceAtLeast(mapCapacity(collectionSizeOrDefault(implementationRecords, 10)), 16);
    // Inline function 'kotlin.collections.associateTo' call
    var destination_0 = LinkedHashMap_init_$Create$_0(capacity_0);
    var _iterator__ex2g4s_0 = implementationRecords.m();
    while (_iterator__ex2g4s_0.n()) {
      var element_0 = _iterator__ex2g4s_0.o();
      // Inline function 'kotlin.collections.plusAssign' call
      var pair_0 = to(element_0.p6x_1, element_0.q6x_1);
      destination_0.t2(pair_0.pg_1, pair_0.qg_1);
    }
    var implementations = destination_0;
    var tmp = this;
    // Inline function 'kotlin.collections.associate' call
    var this_0 = concrete(Companion_instance_115, map).y();
    var capacity_1 = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
    // Inline function 'kotlin.collections.associateTo' call
    var destination_1 = LinkedHashMap_init_$Create$_0(capacity_1);
    var _iterator__ex2g4s_1 = this_0.m();
    while (_iterator__ex2g4s_1.n()) {
      var element_1 = _iterator__ex2g4s_1.o();
      // Inline function 'kotlin.collections.component1' call
      var concept = element_1.z();
      // Inline function 'kotlin.collections.component2' call
      var descriptor = element_1.a1();
      // Inline function 'kotlin.collections.plusAssign' call
      var pair_1 = to(descriptor.m6n_1, concept);
      destination_1.t2(pair_1.pg_1, pair_1.qg_1);
    }
    tmp.r6x_1 = destination_1;
    var tmp_0 = this;
    // Inline function 'kotlin.collections.associate' call
    var this_1 = this.r6x_1.y();
    var capacity_2 = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_1, 10)), 16);
    // Inline function 'kotlin.collections.associateTo' call
    var destination_2 = LinkedHashMap_init_$Create$_0(capacity_2);
    var _iterator__ex2g4s_2 = this_1.m();
    while (_iterator__ex2g4s_2.n()) {
      var element_2 = _iterator__ex2g4s_2.o();
      // Inline function 'kotlin.collections.component1' call
      var id = element_2.z();
      // Inline function 'kotlin.collections.component2' call
      var klass = element_2.a1();
      var tmp0_elvis_lhs = klass.ra();
      var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? id.y2() : tmp0_elvis_lhs;
      // Inline function 'kotlin.collections.plusAssign' call
      var pair_2 = to(tmp1_elvis_lhs == null ? id.q36_1 : tmp1_elvis_lhs, id);
      destination_2.t2(pair_2.pg_1, pair_2.qg_1);
    }
    tmp_0.s6x_1 = destination_2;
    var tmp_1 = this;
    // Inline function 'kotlin.collections.mapValues' call
    // Inline function 'kotlin.collections.mapValuesTo' call
    var destination_3 = LinkedHashMap_init_$Create$_0(mapCapacity(map.p()));
    // Inline function 'kotlin.collections.associateByTo' call
    var _iterator__ex2g4s_3 = map.y().m();
    while (_iterator__ex2g4s_3.n()) {
      var element_3 = _iterator__ex2g4s_3.o();
      var tmp_2 = element_3.z();
      // Inline function 'kotlin.collections.component1' call
      var definitionClass = element_3.z();
      // Inline function 'kotlin.collections.component2' call
      var descriptor_0 = element_3.a1();
      var tmp_3 = isInterface(definitionClass, KClass) ? definitionClass : THROW_CCE();
      var tmp_4 = implementations.q2(definitionClass);
      var tmp$ret$23 = otConceptByDescriptor(tmp_3, tmp_4, descriptor_0 instanceof OTAbstractConceptDescriptor ? descriptor_0 : THROW_CCE(), useExperimentalNode);
      destination_3.t2(tmp_2, tmp$ret$23);
    }
    tmp_1.t6x_1 = destination_3;
    var tmp_5 = this;
    // Inline function 'kotlin.collections.mapValues' call
    var this_2 = concrete(Companion_instance_115, map);
    // Inline function 'kotlin.collections.mapValuesTo' call
    var destination_4 = LinkedHashMap_init_$Create$_0(mapCapacity(this_2.p()));
    // Inline function 'kotlin.collections.associateByTo' call
    var _iterator__ex2g4s_4 = this_2.y().m();
    while (_iterator__ex2g4s_4.n()) {
      var element_4 = _iterator__ex2g4s_4.o();
      var tmp_6 = element_4.z();
      // Inline function 'kotlin.collections.component2' call
      var descriptor_1 = element_4.a1();
      var tmp$ret$29 = descriptor_1.j6n_1;
      destination_4.t2(tmp_6, tmp$ret$29);
    }
    tmp_5.v6x_1 = destination_4;
    var tmp_7 = this;
    // Inline function 'kotlin.collections.associate' call
    var capacity_3 = coerceAtLeast(mapCapacity(collectionSizeOrDefault(implementationRecords, 10)), 16);
    // Inline function 'kotlin.collections.associateTo' call
    var destination_5 = LinkedHashMap_init_$Create$_0(capacity_3);
    var _iterator__ex2g4s_5 = implementationRecords.m();
    while (_iterator__ex2g4s_5.n()) {
      var element_5 = _iterator__ex2g4s_5.o();
      // Inline function 'kotlin.collections.plusAssign' call
      var pair_3 = to(element_5.q6x_1, element_5.p6x_1);
      destination_5.t2(pair_3.pg_1, pair_3.qg_1);
    }
    tmp_7.u6x_1 = destination_5;
  }
  protoOf(BaseConceptRegistry).l6l = function (concept) {
    // Inline function 'kotlin.collections.contains' call
    // Inline function 'kotlin.collections.containsKey' call
    var this_0 = this.t6x_1;
    // Inline function 'kotlin.check' call
    if (!(isInterface(this_0, KtMap) ? this_0 : THROW_CCE()).o2(concept)) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    var tmp = getValue_0(this.t6x_1, concept);
    return isInterface(tmp, OTConcept) ? tmp : THROW_CCE();
  };
  protoOf(BaseConceptRegistry).t6i = function (conceptId) {
    var tmp0 = this.r6x_1.q2(conceptId);
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.checkNotNull' call
      if (tmp0 == null) {
        var message = 'Could not find concept for id ' + conceptId.toString();
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      } else {
        tmp$ret$1 = tmp0;
        break $l$block;
      }
    }
    var concept = tmp$ret$1;
    return this.l6l(concept);
  };
  protoOf(BaseConceptRegistry).m6l = function (sourceClass) {
    var tmp0_elvis_lhs = this.v6x_1.q2(sourceClass);
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
  protoOf(BaseConceptRegistry).n6l = function (impl) {
    var tmp0_elvis_lhs = this.u6x_1.q2(impl);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var message = 'Unknown implementation class: ' + toString_1(impl);
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  protoOf(BaseConceptRegistry).o6l = function () {
    // Inline function 'kotlin.collections.flatMap' call
    var tmp0 = this.t6x_1.s2();
    // Inline function 'kotlin.collections.flatMapTo' call
    var destination = ArrayList_init_$Create$();
    var _iterator__ex2g4s = tmp0.m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      // Inline function 'kotlin.collections.map' call
      var this_0 = element.o6k();
      // Inline function 'kotlin.collections.mapTo' call
      var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
      var _iterator__ex2g4s_0 = this_0.m();
      while (_iterator__ex2g4s_0.n()) {
        var item = _iterator__ex2g4s_0.o();
        var tmp$ret$0 = item.u6k_1;
        destination_0.j(tmp$ret$0);
      }
      var list = destination_0;
      addAll_1(destination, list);
    }
    return destination;
  };
  function ConceptImplementationRegistryRecord(definitionClass, implementationClass) {
    this.p6x_1 = definitionClass;
    this.q6x_1 = implementationClass;
  }
  function ConceptRegistryBasedNodeFactory(conceptRegistry, wrapperContext) {
    NodeFactory.call(this);
    this.w6x_1 = conceptRegistry;
    this.x6x_1 = wrapperContext;
  }
  protoOf(ConceptRegistryBasedNodeFactory).s6v = function (concept, id) {
    var tmp;
    if (id == null) {
      tmp = createInstance(this.w6x_1, concept, this.x6x_1);
    } else {
      tmp = createInstance_0(this.w6x_1, concept, id, this.x6x_1);
    }
    return tmp;
  };
  function ConceptRegistryBuilderImpl(services, useExperimentalNode) {
    this.y6x_1 = services;
    this.z6x_1 = useExperimentalNode;
    var tmp = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp.a6y_1 = ArrayList_init_$Create$();
    var tmp_0 = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp_0.b6y_1 = ArrayList_init_$Create$();
  }
  protoOf(ConceptRegistryBuilderImpl).c6y = function () {
    return this.z6x_1;
  };
  protoOf(ConceptRegistryBuilderImpl).d6y = function (concept, descriptor) {
    this.a6y_1.j(new ConceptRegistryRecord(concept, descriptor));
  };
  protoOf(ConceptRegistryBuilderImpl).e6y = function (concept, descriptor) {
    return this.d6y(concept, descriptor);
  };
  protoOf(ConceptRegistryBuilderImpl).f6y = function (concept, implementation) {
    this.b6y_1.j(new ConceptImplementationRegistryRecord(concept, implementation));
  };
  protoOf(ConceptRegistryBuilderImpl).f40 = function () {
    return createConceptRegistry(this.a6y_1, this.b6y_1, this.z6x_1);
  };
  protoOf(ConceptRegistryBuilderImpl).h3b = function (key) {
    return this.y6x_1.h3b(key);
  };
  protoOf(ConceptRegistryBuilderImpl).e3c = function (_this__u8e3s4, thisRef, property) {
    return this.y6x_1.e3c(_this__u8e3s4, thisRef, property);
  };
  function createConceptRegistry(conceptRecords, implementationRecords, useExperimentalNode) {
    implementationRecords = implementationRecords === VOID ? emptyList() : implementationRecords;
    useExperimentalNode = useExperimentalNode === VOID ? false : useExperimentalNode;
    var tmp;
    if (useExperimentalNode) {
      tmp = new DomainNodeConceptRegistry(conceptRecords, implementationRecords);
    } else {
      tmp = new NodeWrapperConceptRegistryImpl(conceptRecords, implementationRecords);
    }
    return tmp;
  }
  function ConceptRegistryRecord(sourceClass, descriptor) {
    this.n6x_1 = sourceClass;
    this.o6x_1 = descriptor;
  }
  function DomainNodeConceptRegistry$getNodeFactory$1(this$0, $typedNodeContext) {
    this.g6y_1 = this$0;
    this.h6y_1 = $typedNodeContext;
  }
  protoOf(DomainNodeConceptRegistry$getNodeFactory$1).d3m = function (conceptId, nodeId) {
    var descriptor = ensureNotNull(this.g6y_1.n6y_1.q2(conceptId));
    var tmp = descriptor.l6n_1(this.h6y_1, nodeId);
    return tmp instanceof OtNode ? tmp : THROW_CCE();
  };
  function DomainNodeConceptRegistry(conceptRecords, implementationRecords) {
    BaseConceptRegistry.call(this, conceptRecords, implementationRecords, true);
    var tmp = this;
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(conceptRecords, 10));
    var _iterator__ex2g4s = conceptRecords.m();
    while (_iterator__ex2g4s.n()) {
      var item = _iterator__ex2g4s.o();
      var tmp$ret$0 = item.o6x_1;
      destination.j(tmp$ret$0);
    }
    // Inline function 'kotlin.collections.filterIsInstance' call
    // Inline function 'kotlin.collections.filterIsInstanceTo' call
    var destination_0 = ArrayList_init_$Create$();
    var _iterator__ex2g4s_0 = destination.m();
    while (_iterator__ex2g4s_0.n()) {
      var element = _iterator__ex2g4s_0.o();
      if (element instanceof OtConceptDescriptor) {
        destination_0.j(element);
      }
    }
    // Inline function 'kotlin.collections.associateBy' call
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(destination_0, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination_1 = LinkedHashMap_init_$Create$_0(capacity);
    var _iterator__ex2g4s_1 = destination_0.m();
    while (_iterator__ex2g4s_1.n()) {
      var element_0 = _iterator__ex2g4s_1.o();
      var tmp$ret$5 = element_0.m6n_1;
      destination_1.t2(tmp$ret$5, element_0);
    }
    tmp.n6y_1 = destination_1;
  }
  protoOf(DomainNodeConceptRegistry).k6l = function (referenceFactoryRegistry) {
    var typedNodeContext = new TypedNodeContext(this, referenceFactoryRegistry);
    return new DomainNodeConceptRegistry$getNodeFactory$1(this, typedNodeContext);
  };
  function NodeWrapperConceptRegistryImpl$nodeWrapperFactory$1(this$0) {
    this.o6y_1 = this$0;
    NodeWrapperFactory.call(this);
  }
  protoOf(NodeWrapperConceptRegistryImpl$nodeWrapperFactory$1).u57 = function (context, node) {
    var tmp = this.o6y_1.t6i(node.e3m_1);
    var otConcept = isInterface(tmp, OTConceptWrapper) ? tmp : THROW_CCE();
    var tmp_0 = otConcept.w6m(context.m58(Companion_getInstance_93().p6l_1), node);
    return tmp_0 instanceof NodeWrapper ? tmp_0 : THROW_CCE();
  };
  function NodeWrapperConceptRegistryImpl(conceptRecords, implementationRecords) {
    BaseConceptRegistry.call(this, conceptRecords, implementationRecords, false);
  }
  protoOf(NodeWrapperConceptRegistryImpl).j6l = function () {
    return new NodeWrapperConceptRegistryImpl$nodeWrapperFactory$1(this);
  };
  function structure(_this__u8e3s4, body) {
    _this__u8e3s4.t6f(StructureAspect_instance, new ConceptDefinitions(body));
  }
  function StructureAspect$createConfigurationService$lambda($definitions) {
    return function (it) {
      var builder = new ConceptRegistryBuilderImpl(it, ensureNotNull(it.h3b(UseExperimentalNodeService_instance)));
      var _iterator__ex2g4s = $definitions.m();
      while (_iterator__ex2g4s.n()) {
        var definition = _iterator__ex2g4s.o();
        definition.u6y_1(builder);
      }
      return builder.f40();
    };
  }
  function StructureAspect() {
  }
  protoOf(StructureAspect).v6y = function (definitions) {
    var tmp = Companion_instance_41;
    var tmp_0 = [ConceptRegistryService_instance];
    return tmp.m3b(tmp_0, VOID, StructureAspect$createConfigurationService$lambda(definitions));
  };
  protoOf(StructureAspect).r6f = function (definitions) {
    return this.v6y(definitions);
  };
  var StructureAspect_instance;
  function StructureAspect_getInstance() {
    return StructureAspect_instance;
  }
  function ConceptRegistryService() {
  }
  var ConceptRegistryService_instance;
  function ConceptRegistryService_getInstance() {
    return ConceptRegistryService_instance;
  }
  function ConceptDefinitions(body) {
    this.u6y_1 = body;
  }
  function ConceptData(name, fqName, isInstantiable, isAdapter, superConcept, interfaces, members) {
    superConcept = superConcept === VOID ? null : superConcept;
    interfaces = interfaces === VOID ? emptyList() : interfaces;
    members = members === VOID ? emptyList() : members;
    this.l6w_1 = name;
    this.m6w_1 = fqName;
    this.n6w_1 = isInstantiable;
    this.o6w_1 = isAdapter;
    this.p6w_1 = superConcept;
    this.q6w_1 = interfaces;
    this.r6w_1 = members;
  }
  protoOf(ConceptData).e6x = function () {
    return plus_5(listOfNotNull(this.p6w_1), this.q6w_1);
  };
  function ChildrenMemberData(link, name, targetConcept, isMultiple) {
    this.f6x_1 = link;
    this.g6x_1 = name;
    this.h6x_1 = targetConcept;
    this.i6x_1 = isMultiple;
  }
  function AttributeData(link, name, type) {
    this.w6y_1 = link;
    this.x6y_1 = name;
    this.y6y_1 = type;
  }
  function SimpleAttributeType(nullable, klass) {
    AttributeType.call(this);
    this.z6y_1 = nullable;
    this.a6z_1 = klass;
  }
  function ReferenceMemberData(link, name, targetConcept) {
    this.b6z_1 = link;
    this.c6z_1 = name;
    this.d6z_1 = targetConcept;
  }
  function EnumAttributeType(nullable, enumKlass, values) {
    SimpleAttributeType.call(this, nullable, enumKlass);
    this.g6z_1 = enumKlass;
    this.h6z_1 = values;
  }
  function AttributeType() {
  }
  function BaseStructureModel(wrapperContext, nodePointerSupport, useExperimentalNode) {
    this.i6z_1 = wrapperContext;
    this.j6z_1 = nodePointerSupport;
    this.k6z_1 = useExperimentalNode;
  }
  protoOf(BaseStructureModel).l6z = function () {
    return this.i6z_1;
  };
  protoOf(BaseStructureModel).p6g = function () {
    return this.j6z_1;
  };
  protoOf(BaseStructureModel).c6y = function () {
    return this.k6z_1;
  };
  protoOf(BaseStructureModel).zr = function () {
    this.i6z_1.zr();
    this.j6z_1.zr();
  };
  function Companion_116() {
  }
  var Companion_instance_116;
  function Companion_getInstance_116() {
    return Companion_instance_116;
  }
  function EntityNodeLayout(entityConceptId, modelBlobId) {
    this.m6z_1 = entityConceptId;
    this.n6z_1 = modelBlobId;
  }
  protoOf(EntityNodeLayout).o6z = function (entity) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.require' call
    if (!this.m6z_1.equals(entity.m3d_1)) {
      var message = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
  };
  protoOf(EntityNodeLayout).p6z = function (node, entity) {
    this.o6z(entity);
    entity.j3e(this.n6z_1, new Model(node));
    return entity;
  };
  protoOf(EntityNodeLayout).q6z = function (entityId) {
    return new Entity(this.m6z_1, entityId);
  };
  protoOf(EntityNodeLayout).r6z = function (entityId, $super) {
    entityId = entityId === VOID ? EntityId_init_$Create$() : entityId;
    return $super === VOID ? this.q6z(entityId) : $super.q6z.call(this, entityId);
  };
  protoOf(EntityNodeLayout).toString = function () {
    return 'EntityNodeLayout(entityConceptId=' + this.m6z_1.toString() + ', modelBlobId=' + this.n6z_1.toString() + ')';
  };
  protoOf(EntityNodeLayout).hashCode = function () {
    var result = this.m6z_1.hashCode();
    result = imul(result, 31) + this.n6z_1.hashCode() | 0;
    return result;
  };
  protoOf(EntityNodeLayout).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof EntityNodeLayout))
      return false;
    if (!this.m6z_1.equals(other.m6z_1))
      return false;
    if (!this.n6z_1.equals(other.n6z_1))
      return false;
    return true;
  };
  function SingleRootHolder$Companion$wrapperFactory$$inlined$entityWrapperFactory$1() {
  }
  protoOf(SingleRootHolder$Companion$wrapperFactory$$inlined$entityWrapperFactory$1).y57 = function (context, entity) {
    return new SingleRootEntityWrapper(context, entity);
  };
  function Companion_117() {
    Companion_instance_117 = this;
    var tmp = this;
    // Inline function 'jetbrains.ocelot.ot.model.wrapper.entityWrapperFactory' call
    tmp.s6z_1 = new SingleRootHolder$Companion$wrapperFactory$$inlined$entityWrapperFactory$1();
  }
  var Companion_instance_117;
  function Companion_getInstance_117() {
    if (Companion_instance_117 == null)
      new Companion_117();
    return Companion_instance_117;
  }
  function SingleRootEntityWrapper(context, entity) {
    EntityWrapper.call(this, context, entity);
  }
  function SingleRootHolder(layout, wrapperContext, entity, useExperimentalNode) {
    Companion_getInstance_117();
    this.t6z_1 = layout;
    this.t6z_1.o6z(entity);
    wrapperContext.k58(Companion_getInstance_117().s6z_1);
    this.u6z_1 = entity.t3h(this.t6z_1.n6z_1);
    var tmp = this;
    // Inline function 'kotlin.run' call
    var $this$run = wrapperContext.w56(entity);
    var tmp_0;
    if (useExperimentalNode) {
      tmp_0 = $this$run.z56(this.t6z_1.n6z_1);
    } else {
      tmp_0 = $this$run.x56(this.t6z_1.n6z_1);
    }
    var tmp_1 = tmp_0;
    tmp.v6z_1 = isInterface(tmp_1, ReadableProperty) ? tmp_1 : THROW_CCE();
  }
  function SingleRootStructureModel$nodePointerSupportUpdater$lambda($nodePointerSupport) {
    return function (it) {
      var tmp0_elvis_lhs = it.t2y_1;
      var tmp;
      if (tmp0_elvis_lhs == null) {
        return Unit_instance;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var model = tmp;
      $nodePointerSupport.q6i(model);
      return Unit_instance;
    };
  }
  function SingleRootStructureModel(wrapperContext, nodePointerSupport, layout, entity, useExperimentalNode) {
    BaseStructureModel.call(this, wrapperContext, nodePointerSupport, useExperimentalNode);
    this.z6z_1 = entity;
    this.a70_1 = new SingleRootHolder(layout, wrapperContext, this.z6z_1, useExperimentalNode);
    var tmp = this;
    tmp.b70_1 = this.a70_1.u6z_1.z2r(SingleRootStructureModel$nodePointerSupportUpdater$lambda(nodePointerSupport));
    var tmp0_safe_receiver = this.a70_1.u6z_1.uv();
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      nodePointerSupport.q6i(tmp0_safe_receiver);
    }
  }
  protoOf(SingleRootStructureModel).zr = function () {
    protoOf(BaseStructureModel).zr.call(this);
    this.b70_1.zr();
  };
  function ancestorOrSelf(_this__u8e3s4, ancestorKClass) {
    // Inline function 'jetbrains.ocelot.langDef.query.query' call
    return new ancestorOrSelf$$inlined$query$1(_this__u8e3s4, ancestorKClass);
  }
  function ancestorOrSelf$$inlined$query$1($this_ancestorOrSelf, $ancestorKClass) {
    this.c70_1 = $this_ancestorOrSelf;
    this.d70_1 = $ancestorKClass;
  }
  protoOf(ancestorOrSelf$$inlined$query$1).n5w = function (builder) {
    var tmp$ret$0;
    $l$block: {
      var k = this.c70_1;
      while (!(k == null)) {
        if (this.d70_1.sa(k)) {
          tmp$ret$0 = safeCast(this.d70_1, k);
          break $l$block;
        }
        k = builder.l60(get_forQueries_0(k.x6i()));
      }
      tmp$ret$0 = null;
    }
    return tmp$ret$0;
  };
  function ErrorBase(message) {
    this.e70_1 = message;
  }
  protoOf(ErrorBase).e = function () {
    return this.e70_1;
  };
  function ErrorForAllNode(message, node) {
    ErrorBase.call(this, message);
    this.g70_1 = listOf(node);
  }
  protoOf(ErrorForAllNode).f3o = function () {
    return this.g70_1;
  };
  function ErrorForDescendants(message, descendantNodes) {
    ErrorBase.call(this, message);
    this.i70_1 = listOf_0(descendantNodes.slice());
  }
  protoOf(ErrorForDescendants).f3o = function () {
    return this.i70_1;
  };
  var ErrorKind_INFO_instance;
  var ErrorKind_WARNING_instance;
  var ErrorKind_ERROR_instance;
  function values_4() {
    return [ErrorKind_INFO_getInstance(), ErrorKind_WARNING_getInstance(), ErrorKind_ERROR_getInstance()];
  }
  var ErrorKind_entriesInitialized;
  function ErrorKind_initEntries() {
    if (ErrorKind_entriesInitialized)
      return Unit_instance;
    ErrorKind_entriesInitialized = true;
    ErrorKind_INFO_instance = new ErrorKind('INFO', 0);
    ErrorKind_WARNING_instance = new ErrorKind('WARNING', 1);
    ErrorKind_ERROR_instance = new ErrorKind('ERROR', 2);
  }
  function ErrorKind(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function ErrorKind_INFO_getInstance() {
    ErrorKind_initEntries();
    return ErrorKind_INFO_instance;
  }
  function ErrorKind_WARNING_getInstance() {
    ErrorKind_initEntries();
    return ErrorKind_WARNING_instance;
  }
  function ErrorKind_ERROR_getInstance() {
    ErrorKind_initEntries();
    return ErrorKind_ERROR_instance;
  }
  function Companion_118() {
  }
  var Companion_instance_118;
  function Companion_getInstance_118() {
    return Companion_instance_118;
  }
  function Empty_1() {
  }
  protoOf(Empty_1).j70 = function (concept) {
    return emptyList();
  };
  var Empty_instance_0;
  function Empty_getInstance_0() {
    return Empty_instance_0;
  }
  function ErrorCheckConfig() {
  }
  function EmptyErrorCheckConfig() {
  }
  protoOf(EmptyErrorCheckConfig).j70 = function (concept) {
    return emptyList();
  };
  var EmptyErrorCheckConfig_instance;
  function EmptyErrorCheckConfig_getInstance() {
    return EmptyErrorCheckConfig_instance;
  }
  function errorChecking(init) {
    var tmp = Companion_instance_41;
    var tmp_0 = [Companion_instance_118];
    return tmp.m3b(tmp_0, VOID, errorChecking$lambda(init));
  }
  function ErrorCheckConfigBuilder() {
  }
  function implClass($this, conceptClass) {
    var descriptor = $this.m70_1.l6l(conceptClass);
    return ensureNotNull(descriptor.t6m());
  }
  function ErrorCheckConfigBuilderImpl$build$1(this$0) {
    this.o70_1 = this$0;
  }
  protoOf(ErrorCheckConfigBuilderImpl$build$1).j70 = function (concept) {
    var list = this.o70_1.n70_1.q2(concept);
    var checkFunctionList = (!(list == null) ? isInterface(list, KtList) : false) ? list : null;
    var tmp;
    if (checkFunctionList == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(checkFunctionList, 10));
      var _iterator__ex2g4s = checkFunctionList.m();
      while (_iterator__ex2g4s.n()) {
        var item = _iterator__ex2g4s.o();
        var tmp$ret$0 = asChecker(item);
        destination.j(tmp$ret$0);
      }
      tmp = destination;
    }
    // Inline function 'kotlin.collections.orEmpty' call
    var tmp0_elvis_lhs = tmp;
    return tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
  };
  function ErrorCheckConfigBuilderImpl(conceptRegistry, services) {
    ErrorCheckConfigBuilder.call(this);
    this.l70_1 = services;
    this.m70_1 = conceptRegistry;
    this.n70_1 = HashMap_init_$Create$();
  }
  protoOf(ErrorCheckConfigBuilderImpl).k70 = function (_this__u8e3s4, code) {
    var tmp0 = this.n70_1;
    // Inline function 'kotlin.collections.getOrPut' call
    var key = implClass(this, _this__u8e3s4);
    var value = tmp0.q2(key);
    var tmp;
    if (value == null) {
      var answer = ArrayList_init_$Create$();
      tmp0.t2(key, answer);
      tmp = answer;
    } else {
      tmp = value;
    }
    tmp.j(code);
  };
  protoOf(ErrorCheckConfigBuilderImpl).f40 = function () {
    return new ErrorCheckConfigBuilderImpl$build$1(this);
  };
  protoOf(ErrorCheckConfigBuilderImpl).h3b = function (key) {
    return this.l70_1.h3b(key);
  };
  protoOf(ErrorCheckConfigBuilderImpl).e3c = function (_this__u8e3s4, thisRef, property) {
    return this.l70_1.e3c(_this__u8e3s4, thisRef, property);
  };
  function asChecker(_this__u8e3s4) {
    return new asChecker$1(_this__u8e3s4);
  }
  function errorChecking$lambda($init) {
    return function (services) {
      var conceptRegistry = ensureNotNull(services.h3b(ConceptRegistryService_instance));
      var tmp0 = new ErrorCheckConfigBuilderImpl(conceptRegistry, services);
      // Inline function 'kotlin.also' call
      $init(tmp0);
      return tmp0.f40();
    };
  }
  function asChecker$1($this_asChecker) {
    this.p70_1 = $this_asChecker;
  }
  protoOf(asChecker$1).q70 = function (node) {
    return this.p70_1(node);
  };
  function $runSuspendCOROUTINE$_2(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.z70_1 = _this__u8e3s4;
    this.a71_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_2).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 7;
            this.c71_1 = this.a71_1;
            var tmp_0 = this;
            tmp_0.f71_1 = this.z70_1.h71_1.g71_1;
            this.f9_1 = 1;
            continue $sm;
          case 1:
            this.e71_1 = this.f71_1;
            var tmp_1;
            var tmp_2 = this.e71_1;
            if (isInterface(tmp_2, Collection)) {
              tmp_1 = this.e71_1.s();
            } else {
              tmp_1 = false;
            }

            if (tmp_1) {
              this.b71_1 = true;
              this.f9_1 = 8;
              continue $sm;
            } else {
              this.f9_1 = 2;
              continue $sm;
            }

          case 2:
            this.d71_1 = this.e71_1.m();
            this.f9_1 = 3;
            continue $sm;
          case 3:
            if (!this.d71_1.n()) {
              this.f9_1 = 6;
              continue $sm;
            }

            var element = this.d71_1.o();
            this.f9_1 = 4;
            suspendResult = this.c71_1.k60(element.j71(this.z70_1.i71_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            if (!suspendResult) {
              this.b71_1 = false;
              this.f9_1 = 8;
              continue $sm;
            } else {
              this.f9_1 = 5;
              continue $sm;
            }

          case 5:
            this.f9_1 = 3;
            continue $sm;
          case 6:
            this.b71_1 = true;
            if (false) {
              this.f9_1 = 1;
              continue $sm;
            }

            this.f9_1 = 8;
            continue $sm;
          case 7:
            throw this.i9_1;
          case 8:
            return this.b71_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 7) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function CompositeScopeFilter$apply$$inlined$suspendingQuery$1(this$0, $target) {
    this.h71_1 = this$0;
    this.i71_1 = $target;
  }
  protoOf(CompositeScopeFilter$apply$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_2(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(CompositeScopeFilter$apply$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function CompositeScopeFilter(filters) {
    this.g71_1 = filters;
  }
  protoOf(CompositeScopeFilter).j71 = function (target) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new CompositeScopeFilter$apply$$inlined$suspendingQuery$1(this, target);
  };
  function anyOf(filters) {
    var tmp = anyOf$lambda(filters);
    return new sam$jetbrains_ocelot_langDef_scopes_api_ScopeFilter$0(tmp);
  }
  function sam$jetbrains_ocelot_langDef_scopes_api_ScopeFilter$0(function_0) {
    this.k71_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_langDef_scopes_api_ScopeFilter$0).j71 = function (target) {
    return this.k71_1(target);
  };
  protoOf(sam$jetbrains_ocelot_langDef_scopes_api_ScopeFilter$0).f3 = function () {
    return this.k71_1;
  };
  protoOf(sam$jetbrains_ocelot_langDef_scopes_api_ScopeFilter$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, ScopeFilter) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_langDef_scopes_api_ScopeFilter$0).hashCode = function () {
    return hashCode(this.f3());
  };
  function $runSuspendCOROUTINE$_3(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.t71_1 = _this__u8e3s4;
    this.u71_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_3).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 7;
            this.w71_1 = this.u71_1;
            var tmp_0 = this;
            tmp_0.z71_1 = this.t71_1.a72_1;
            this.f9_1 = 1;
            continue $sm;
          case 1:
            this.y71_1 = this.z71_1;
            var tmp_1;
            var tmp_2 = this.y71_1;
            if (isInterface(tmp_2, Collection)) {
              tmp_1 = this.y71_1.s();
            } else {
              tmp_1 = false;
            }

            if (tmp_1) {
              this.v71_1 = false;
              this.f9_1 = 8;
              continue $sm;
            } else {
              this.f9_1 = 2;
              continue $sm;
            }

          case 2:
            this.x71_1 = this.y71_1.m();
            this.f9_1 = 3;
            continue $sm;
          case 3:
            if (!this.x71_1.n()) {
              this.f9_1 = 6;
              continue $sm;
            }

            var element = this.x71_1.o();
            this.f9_1 = 4;
            suspendResult = this.w71_1.k60(element.j71(this.t71_1.b72_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            if (suspendResult) {
              this.v71_1 = true;
              this.f9_1 = 8;
              continue $sm;
            } else {
              this.f9_1 = 5;
              continue $sm;
            }

          case 5:
            this.f9_1 = 3;
            continue $sm;
          case 6:
            this.v71_1 = false;
            if (false) {
              this.f9_1 = 1;
              continue $sm;
            }

            this.f9_1 = 8;
            continue $sm;
          case 7:
            throw this.i9_1;
          case 8:
            return this.v71_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 7) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function anyOf$2$$inlined$suspendingQuery$1($filters, $target) {
    this.a72_1 = $filters;
    this.b72_1 = $target;
  }
  protoOf(anyOf$2$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_3(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(anyOf$2$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function anyOf$lambda($filters) {
    return function (target) {
      // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
      return new anyOf$2$$inlined$suspendingQuery$1($filters, target);
    };
  }
  function Companion_119() {
    Companion_instance_119 = this;
    this.c72_1 = emptySet();
    this.d72_1 = new NamingInfo('');
  }
  var Companion_instance_119;
  function Companion_getInstance_119() {
    if (Companion_instance_119 == null)
      new Companion_119();
    return Companion_instance_119;
  }
  function NamingInfo(mainName, alternativeNames, additionalText) {
    Companion_getInstance_119();
    alternativeNames = alternativeNames === VOID ? Companion_getInstance_119().c72_1 : alternativeNames;
    additionalText = additionalText === VOID ? null : additionalText;
    this.e72_1 = mainName;
    this.f72_1 = alternativeNames;
    this.g72_1 = additionalText;
  }
  protoOf(NamingInfo).h72 = function () {
    return plus_10(setOf(this.e72_1), this.f72_1);
  };
  function NamedNode(name, node) {
    this.i72_1 = name;
    this.j72_1 = node;
  }
  protoOf(NamedNode).fg = function () {
    return this.i72_1;
  };
  protoOf(NamedNode).gg = function () {
    return this.j72_1;
  };
  protoOf(NamedNode).toString = function () {
    return 'NamedNode(name=' + this.i72_1 + ', node=' + toString_1(this.j72_1) + ')';
  };
  protoOf(NamedNode).hashCode = function () {
    var result = getStringHashCode(this.i72_1);
    result = imul(result, 31) + hashCode(this.j72_1) | 0;
    return result;
  };
  protoOf(NamedNode).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof NamedNode))
      return false;
    if (!(this.i72_1 === other.i72_1))
      return false;
    if (!equals(this.j72_1, other.j72_1))
      return false;
    return true;
  };
  function NoopScopeFilter() {
  }
  protoOf(NoopScopeFilter).k72 = function (target) {
    return Companion_getInstance_81().i60_1;
  };
  protoOf(NoopScopeFilter).j71 = function (target) {
    return this.k72(!(target == null) ? target : THROW_CCE());
  };
  var NoopScopeFilter_instance;
  function NoopScopeFilter_getInstance() {
    return NoopScopeFilter_instance;
  }
  function DefaultOrigin(namespace) {
    Origin.call(this, namespace);
  }
  function Origin(namespace) {
    this.l72_1 = namespace;
  }
  function ImportOrigin(namespace) {
    Origin.call(this, namespace);
  }
  function ChildPlaceholderOrigin(namespace, link) {
    LexicalOrigin.call(this, namespace);
    this.n72_1 = link;
  }
  function LexicalOrigin(namespace) {
    Origin.call(this, namespace);
  }
  function Scope() {
  }
  function combine(_this__u8e3s4) {
    if (_this__u8e3s4.s())
      return NoopScopeFilter_instance;
    if (_this__u8e3s4.p() === 1)
      return first(_this__u8e3s4);
    // Inline function 'kotlin.collections.arrayListOf' call
    var filters = ArrayList_init_$Create$();
    var _iterator__ex2g4s = _this__u8e3s4.m();
    $l$loop: while (_iterator__ex2g4s.n()) {
      var filter = _iterator__ex2g4s.o();
      if (filter instanceof NoopScopeFilter)
        continue $l$loop;
      else {
        if (filter instanceof CompositeScopeFilter)
          filters.q(filter.g71_1);
        else {
          filters.j(filter);
        }
      }
    }
    switch (filters.p()) {
      case 0:
        return NoopScopeFilter_instance;
      case 1:
        return first(filters);
      default:
        return new CompositeScopeFilter(filters);
    }
  }
  function $runSuspendCOROUTINE$_4(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.a73_1 = _this__u8e3s4;
    this.b73_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_4).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            var $this$suspendingQuery = this.b73_1;
            this.f9_1 = 1;
            suspendResult = this.a73_1.c73_1($this$suspendingQuery, this.a73_1.d73_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function sam$jetbrains_ocelot_langDef_scopes_api_ScopeFilter$0_0(function_0) {
    this.e73_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_langDef_scopes_api_ScopeFilter$0_0).j71 = function (target) {
    return this.e73_1(target);
  };
  protoOf(sam$jetbrains_ocelot_langDef_scopes_api_ScopeFilter$0_0).f3 = function () {
    return this.e73_1;
  };
  protoOf(sam$jetbrains_ocelot_langDef_scopes_api_ScopeFilter$0_0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, ScopeFilter) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_langDef_scopes_api_ScopeFilter$0_0).hashCode = function () {
    return hashCode(this.f3());
  };
  function ScopeFilter$Companion$query$2$$inlined$suspendingQuery$1($body, $it) {
    this.c73_1 = $body;
    this.d73_1 = $it;
  }
  protoOf(ScopeFilter$Companion$query$2$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_4(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(ScopeFilter$Companion$query$2$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function ScopeFilter$Companion$query$lambda($body) {
    return function (it) {
      // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
      return new ScopeFilter$Companion$query$2$$inlined$suspendingQuery$1($body, it);
    };
  }
  function Companion_120() {
  }
  protoOf(Companion_120).f73 = function (body) {
    var tmp = ScopeFilter$Companion$query$lambda(body);
    return new sam$jetbrains_ocelot_langDef_scopes_api_ScopeFilter$0_0(tmp);
  };
  var Companion_instance_120;
  function Companion_getInstance_120() {
    return Companion_instance_120;
  }
  function ScopeFilter() {
  }
  function namespace($this, targetClass) {
    return new FallbackScopingRulesProvider$namespace$1(targetClass);
  }
  function FallbackScopingRulesProvider$namespace$1($targetClass) {
    this.g73_1 = $targetClass;
  }
  function FallbackScopingRulesProvider(providerScopes, scopeConstraints, defaultScopes, engine) {
    this.h73_1 = providerScopes;
    this.i73_1 = scopeConstraints;
    this.j73_1 = defaultScopes;
    this.k73_1 = engine;
  }
  protoOf(FallbackScopingRulesProvider).l73 = function (provider, originSelector, targetConcept) {
    var spec = new ScopingRuleSpec(provider.o73_1, targetConcept);
    var tmp = this.h73_1.q2(spec);
    var tmp0_elvis_lhs = (tmp == null ? true : typeof tmp === 'function') ? tmp : THROW_CCE();
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      return Companion_getInstance_81().g60_1;
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var scopeSupplier = tmp_0;
    var namespace_0 = namespace(this, targetConcept);
    var tmp_1;
    if (equals(originSelector, Any_getInstance())) {
      tmp_1 = new DefaultOrigin(namespace_0);
    } else {
      if (equals(originSelector, Import_getInstance())) {
        tmp_1 = new ImportOrigin(namespace_0);
      } else {
        if (equals(originSelector, Lexical_getInstance())) {
          tmp_1 = new ChildPlaceholderOrigin(namespace_0, null);
        } else {
          if (originSelector instanceof LexicalWithRole) {
            tmp_1 = new ChildPlaceholderOrigin(namespace_0, originSelector.s73_1);
          } else {
            noWhenBranchMatchedException();
          }
        }
      }
    }
    var origin = tmp_1;
    var scopeContext = this.k73_1.e74(targetConcept, RuleEvaluationStrategy_EAGER_getInstance(), this.k73_1.d74(provider), provider.p73_1());
    return scopeSupplier(scopeContext, provider.p73_1(), origin);
  };
  protoOf(FallbackScopingRulesProvider).f74 = function (targetConcept) {
    var tmp = this.j73_1.q2(targetConcept);
    var tmp0_elvis_lhs = (!(tmp == null) ? typeof tmp === 'function' : false) ? tmp : null;
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      return Companion_getInstance_81().g60_1;
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var scopeSupplier = tmp_0;
    var defaultOrigin = new DefaultOrigin(namespace(this, targetConcept));
    var scopeContext = this.k73_1.e74(targetConcept, RuleEvaluationStrategy_EAGER_getInstance(), this.k73_1.g74(), null);
    return scopeSupplier(scopeContext, defaultOrigin);
  };
  protoOf(FallbackScopingRulesProvider).h74 = function (providerConcept, scopeConstraintId) {
    var spec = new ScopeConstraintRuleSpec(providerConcept, scopeConstraintId);
    var tmp = this.i73_1.q2(spec);
    return (tmp == null ? true : isInterface(tmp, ScopeConstraintProvider)) ? tmp : THROW_CCE();
  };
  function scopes(_this__u8e3s4, body) {
    _this__u8e3s4.t6f(ScopeAspect_instance, new ScopeDefinition(body));
  }
  function ScopeAspect$createConfigurationService$lambda($definitions) {
    return function (it) {
      var builder = ScopeAspect_instance.i74(it);
      var _iterator__ex2g4s = $definitions.m();
      while (_iterator__ex2g4s.n()) {
        var definition = _iterator__ex2g4s.o();
        definition.j74_1(builder);
      }
      return builder.f40();
    };
  }
  function ScopeAspect() {
  }
  protoOf(ScopeAspect).o74 = function (definitions) {
    var tmp = Companion_instance_41;
    var tmp_0 = [ScopeConfigService_instance];
    return tmp.m3b(tmp_0, VOID, ScopeAspect$createConfigurationService$lambda(definitions));
  };
  protoOf(ScopeAspect).r6f = function (definitions) {
    return this.o74(definitions);
  };
  protoOf(ScopeAspect).i74 = function (services) {
    var conceptRegistry = ensureNotNull(services.h3b(ConceptRegistryService_instance));
    return new ScopeConfigBuilder0Fallback(conceptRegistry, new ScopeConfigBuilderImpl(conceptRegistry, services));
  };
  var ScopeAspect_instance;
  function ScopeAspect_getInstance() {
    return ScopeAspect_instance;
  }
  function ScopeDefinition(body) {
    this.j74_1 = body;
  }
  function ScopeConstraintRuleSpec(provider, scopeConstraint) {
    this.p74_1 = provider;
    this.q74_1 = scopeConstraint;
  }
  protoOf(ScopeConstraintRuleSpec).toString = function () {
    return 'ScopeConstraintRuleSpec(provider=' + toString_1(this.p74_1) + ', scopeConstraint=' + toString_1(this.q74_1) + ')';
  };
  protoOf(ScopeConstraintRuleSpec).hashCode = function () {
    var result = this.p74_1.hashCode();
    result = imul(result, 31) + hashCode(this.q74_1) | 0;
    return result;
  };
  protoOf(ScopeConstraintRuleSpec).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ScopeConstraintRuleSpec))
      return false;
    if (!this.p74_1.equals(other.p74_1))
      return false;
    if (!equals(this.q74_1, other.q74_1))
      return false;
    return true;
  };
  function ConstraintProviderSpec(provider, target) {
    this.r74_1 = provider;
    this.s74_1 = target;
  }
  protoOf(ConstraintProviderSpec).toString = function () {
    return 'ConstraintProviderSpec(provider=' + toString_1(this.r74_1) + ', target=' + toString_1(this.s74_1) + ')';
  };
  protoOf(ConstraintProviderSpec).hashCode = function () {
    var result = this.r74_1.hashCode();
    result = imul(result, 31) + this.s74_1.hashCode() | 0;
    return result;
  };
  protoOf(ConstraintProviderSpec).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ConstraintProviderSpec))
      return false;
    if (!this.r74_1.equals(other.r74_1))
      return false;
    if (!this.s74_1.equals(other.s74_1))
      return false;
    return true;
  };
  function ScopeConfigBuilder() {
  }
  function ScopingRuleSpec(provider, target) {
    this.u74_1 = provider;
    this.v74_1 = target;
  }
  protoOf(ScopingRuleSpec).toString = function () {
    return 'ScopingRuleSpec(provider=' + toString_1(this.u74_1) + ', target=' + toString_1(this.v74_1) + ')';
  };
  protoOf(ScopingRuleSpec).hashCode = function () {
    var result = this.u74_1.hashCode();
    result = imul(result, 31) + this.v74_1.hashCode() | 0;
    return result;
  };
  protoOf(ScopingRuleSpec).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ScopingRuleSpec))
      return false;
    if (!this.u74_1.equals(other.u74_1))
      return false;
    if (!this.v74_1.equals(other.v74_1))
      return false;
    return true;
  };
  function ScopeConfigBuilder0$buildFallbackConfig$ref(p0) {
    var l = function (_this__u8e3s4) {
      return p0.w74(_this__u8e3s4);
    };
    l.callableName = 'buildFallbackConfig';
    return l;
  }
  function ScopeConfigBuilder0(conceptRegistry, services) {
    this.k74_1 = services;
    this.l74_1 = conceptRegistry;
    var tmp = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp.m74_1 = ArrayList_init_$Create$();
    this.n74_1 = HashMap_init_$Create$_1(Companion_getInstance_121().z74_1);
  }
  protoOf(ScopeConfigBuilder0).a75 = function (conceptClass) {
    var descriptor = this.l74_1.l6l(conceptClass);
    return ensureNotNull(descriptor.t6m());
  };
  protoOf(ScopeConfigBuilder0).b75 = function (definition) {
    this.m74_1.j(definition);
  };
  protoOf(ScopeConfigBuilder0).w74 = function (engine) {
    return null;
  };
  protoOf(ScopeConfigBuilder0).f40 = function () {
    var tmp = asSequence_0(this.m74_1);
    var tmp_0 = CoroutineContextService_getInstance().e3b(this);
    var tmp_1 = Companion_getInstance_127().e3b(this);
    var tmp_2 = Companion_getInstance_124().e3b(this);
    var tmp_3 = Companion_instance_123.i3b(this);
    return new ScopingRulesEngine(tmp, this.n74_1, tmp_0, tmp_1, tmp_2, tmp_3, ScopeConfigBuilder0$buildFallbackConfig$ref(this));
  };
  protoOf(ScopeConfigBuilder0).h3b = function (key) {
    return this.k74_1.h3b(key);
  };
  protoOf(ScopeConfigBuilder0).e3c = function (_this__u8e3s4, thisRef, property) {
    return this.k74_1.e3c(_this__u8e3s4, thisRef, property);
  };
  function ScopeConfigBuilder0Fallback(conceptRegistry, fallbackBuilder) {
    ScopeConfigBuilder0.call(this, conceptRegistry, fallbackBuilder);
    this.g75_1 = fallbackBuilder;
  }
  protoOf(ScopeConfigBuilder0Fallback).w74 = function (engine) {
    return this.g75_1.m75(engine);
  };
  protoOf(ScopeConfigBuilder0Fallback).h3b = function (key) {
    return this.g75_1.h3b(key);
  };
  protoOf(ScopeConfigBuilder0Fallback).e3c = function (_this__u8e3s4, thisRef, property) {
    return this.g75_1.e3c(_this__u8e3s4, thisRef, property);
  };
  protoOf(ScopeConfigBuilder0Fallback).n75 = function (_this__u8e3s4, filter) {
    this.g75_1.n75(_this__u8e3s4, filter);
  };
  protoOf(ScopeConfigBuilder0Fallback).o75 = function (_this__u8e3s4, target) {
    return this.g75_1.o75(_this__u8e3s4, target);
  };
  protoOf(ScopeConfigBuilder0Fallback).t74 = function (_this__u8e3s4, constraint) {
    return this.g75_1.t74(_this__u8e3s4, constraint);
  };
  function $runSuspendCOROUTINE$_5(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.x75_1 = _this__u8e3s4;
    this.y75_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_5).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            var $this$suspendingQuery = this.y75_1;
            this.f9_1 = 1;
            suspendResult = this.x75_1.z75_1(new ScopeConstraintBuilder($this$suspendingQuery.q5w_1), this.x75_1.a76_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function implClass_0($this, conceptClass) {
    var descriptor = $this.h75_1.l6l(conceptClass);
    return ensureNotNull(descriptor.t6m());
  }
  function sam$jetbrains_ocelot_langDef_scopes_config_api_ScopeConstraintProvider$0(function_0) {
    this.b76_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_langDef_scopes_config_api_ScopeConstraintProvider$0).c76 = function (provider) {
    return this.b76_1(provider);
  };
  protoOf(sam$jetbrains_ocelot_langDef_scopes_config_api_ScopeConstraintProvider$0).f3 = function () {
    return this.b76_1;
  };
  protoOf(sam$jetbrains_ocelot_langDef_scopes_config_api_ScopeConstraintProvider$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, ScopeConstraintProvider) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_langDef_scopes_config_api_ScopeConstraintProvider$0).hashCode = function () {
    return hashCode(this.f3());
  };
  function ScopeConfigBuilderImpl$by$4$$inlined$suspendingQuery$1($filter, $provider) {
    this.z75_1 = $filter;
    this.a76_1 = $provider;
  }
  protoOf(ScopeConfigBuilderImpl$by$4$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_5(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(ScopeConfigBuilderImpl$by$4$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function ScopeConfigBuilderImpl$by$lambda($filter) {
    return function (provider) {
      // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
      return new ScopeConfigBuilderImpl$by$4$$inlined$suspendingQuery$1($filter, provider);
    };
  }
  function ScopeConfigBuilderImpl(conceptRegistry, services) {
    this.h75_1 = conceptRegistry;
    this.i75_1 = services;
    this.j75_1 = HashMap_init_$Create$();
    this.k75_1 = HashMap_init_$Create$();
    this.l75_1 = HashMap_init_$Create$();
  }
  protoOf(ScopeConfigBuilderImpl).n75 = function (_this__u8e3s4, filter) {
    var tmp0 = this.k75_1;
    var tmp = ScopeConfigBuilderImpl$by$lambda(filter);
    // Inline function 'kotlin.collections.set' call
    var value = new sam$jetbrains_ocelot_langDef_scopes_config_api_ScopeConstraintProvider$0(tmp);
    tmp0.t2(_this__u8e3s4, value);
  };
  protoOf(ScopeConfigBuilderImpl).o75 = function (_this__u8e3s4, target) {
    return new ConstraintProviderSpec(implClass_0(this, _this__u8e3s4), target);
  };
  protoOf(ScopeConfigBuilderImpl).m75 = function (engine) {
    return new FallbackScopingRulesProvider(this.j75_1, this.k75_1, this.l75_1, engine);
  };
  protoOf(ScopeConfigBuilderImpl).h3b = function (key) {
    return this.i75_1.h3b(key);
  };
  protoOf(ScopeConfigBuilderImpl).e3c = function (_this__u8e3s4, thisRef, property) {
    return this.i75_1.e3c(_this__u8e3s4, thisRef, property);
  };
  function CollectionScopeFactory$Companion$Default$1() {
  }
  protoOf(CollectionScopeFactory$Companion$Default$1).d76 = function (specification, ruleEvaluationScope, collection, nameFunction) {
    return constant(new CollectionScope(specification, collection, nameFunction));
  };
  function CollectionScopeFactory$Companion$Indexed$1() {
  }
  protoOf(CollectionScopeFactory$Companion$Indexed$1).d76 = function (specification, ruleEvaluationScope, collection, nameFunction) {
    return createIndexingScope(specification, ruleEvaluationScope, collection, nameFunction);
  };
  function Companion_121() {
    Companion_instance_121 = this;
    var tmp = this;
    tmp.x74_1 = new CollectionScopeFactory$Companion$Default$1();
    var tmp_0 = this;
    tmp_0.y74_1 = new CollectionScopeFactory$Companion$Indexed$1();
    this.z74_1 = mapOf_0([to(RuleEvaluationStrategy_PER_REQUEST_getInstance(), this.x74_1), to(RuleEvaluationStrategy_EAGER_getInstance(), this.x74_1), to(RuleEvaluationStrategy_INDEXED_getInstance(), this.y74_1)]);
  }
  var Companion_instance_121;
  function Companion_getInstance_121() {
    if (Companion_instance_121 == null)
      new Companion_121();
    return Companion_instance_121;
  }
  function createIndexingScope(specification, ruleEvaluationScope, rawCollection, nameFunction) {
    var tmp;
    if (!(ruleEvaluationScope.f76_1 == null)) {
      tmp = ruleEvaluationScope.f76_1.h76(specification, rawCollection, nameFunction);
    } else {
      // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
      tmp = new createIndexingScope$$inlined$suspendingQuery$1(specification, rawCollection, nameFunction);
    }
    return tmp;
  }
  function $runSuspendCOROUTINE$_6(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.q76_1 = _this__u8e3s4;
    this.r76_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_6).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            var $this$suspendingQuery = this.r76_1;
            this.f9_1 = 1;
            suspendResult = IndexingCollectionScope($this$suspendingQuery, this.q76_1.s76_1, this.q76_1.t76_1, this.q76_1.u76_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function createIndexingScope$$inlined$suspendingQuery$1($specification, $rawCollection, $nameFunction) {
    this.s76_1 = $specification;
    this.t76_1 = $rawCollection;
    this.u76_1 = $nameFunction;
  }
  protoOf(createIndexingScope$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_6(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(createIndexingScope$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function generalize($this, selector, times) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.require' call
    if (!(times >= 0)) {
      var message = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.require' call
    if (!(times < selector.w76_1)) {
      var message_0 = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message_0));
    }
    var current = selector;
    // Inline function 'kotlin.repeat' call
    var inductionVariable = 0;
    if (inductionVariable < times)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        current = ensureNotNull(current.v76_1);
      }
       while (inductionVariable < times);
    return current;
  }
  function Any() {
    Any_instance = this;
    OriginSelector.call(this, null);
  }
  protoOf(Any).toString = function () {
    return 'Any';
  };
  protoOf(Any).hashCode = function () {
    return 2030821921;
  };
  protoOf(Any).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Any))
      return false;
    return true;
  };
  var Any_instance;
  function Any_getInstance() {
    if (Any_instance == null)
      new Any();
    return Any_instance;
  }
  function Lexical() {
    Lexical_instance = this;
    OriginSelector.call(this, Any_getInstance());
  }
  protoOf(Lexical).toString = function () {
    return 'Lexical';
  };
  protoOf(Lexical).hashCode = function () {
    return -1530397927;
  };
  protoOf(Lexical).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Lexical))
      return false;
    return true;
  };
  var Lexical_instance;
  function Lexical_getInstance() {
    if (Lexical_instance == null)
      new Lexical();
    return Lexical_instance;
  }
  function Import() {
    Import_instance = this;
    OriginSelector.call(this, Any_getInstance());
  }
  protoOf(Import).toString = function () {
    return 'Import';
  };
  protoOf(Import).hashCode = function () {
    return 1534468944;
  };
  protoOf(Import).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Import))
      return false;
    return true;
  };
  var Import_instance;
  function Import_getInstance() {
    if (Import_instance == null)
      new Import();
    return Import_instance;
  }
  function LexicalWithRole(link) {
    OriginSelector.call(this, Lexical_getInstance());
    this.s73_1 = link;
  }
  protoOf(LexicalWithRole).toString = function () {
    return 'LexicalWithRole(link=' + this.s73_1.toString() + ')';
  };
  protoOf(LexicalWithRole).hashCode = function () {
    return this.s73_1.hashCode();
  };
  protoOf(LexicalWithRole).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof LexicalWithRole))
      return false;
    if (!this.s73_1.equals(other.s73_1))
      return false;
    return true;
  };
  function Companion_122() {
  }
  var Companion_instance_122;
  function Companion_getInstance_122() {
    return Companion_instance_122;
  }
  function OriginSelector(parent) {
    this.v76_1 = parent;
    this.w76_1 = this.v76_1 == null ? 1 : 1 + this.v76_1.w76_1 | 0;
  }
  protoOf(OriginSelector).x76 = function (selector) {
    var delta = this.w76_1 - selector.w76_1 | 0;
    if (delta < 0)
      return false;
    return equals(generalize(Companion_instance_122, this, delta), selector);
  };
  function RuleEvaluationScope(strategy, sharedScopes) {
    this.e76_1 = strategy;
    this.f76_1 = sharedScopes;
  }
  var RuleEvaluationStrategy_PER_REQUEST_instance;
  var RuleEvaluationStrategy_EAGER_instance;
  var RuleEvaluationStrategy_INDEXED_instance;
  var RuleEvaluationStrategy_entriesInitialized;
  function RuleEvaluationStrategy_initEntries() {
    if (RuleEvaluationStrategy_entriesInitialized)
      return Unit_instance;
    RuleEvaluationStrategy_entriesInitialized = true;
    RuleEvaluationStrategy_PER_REQUEST_instance = new RuleEvaluationStrategy('PER_REQUEST', 0, false);
    RuleEvaluationStrategy_EAGER_instance = new RuleEvaluationStrategy('EAGER', 1, true);
    RuleEvaluationStrategy_INDEXED_instance = new RuleEvaluationStrategy('INDEXED', 2, true);
  }
  function RuleEvaluationStrategy(name, ordinal, eager) {
    Enum.call(this, name, ordinal);
    this.a77_1 = eager;
  }
  function RuleEvaluationStrategy_PER_REQUEST_getInstance() {
    RuleEvaluationStrategy_initEntries();
    return RuleEvaluationStrategy_PER_REQUEST_instance;
  }
  function RuleEvaluationStrategy_EAGER_getInstance() {
    RuleEvaluationStrategy_initEntries();
    return RuleEvaluationStrategy_EAGER_instance;
  }
  function RuleEvaluationStrategy_INDEXED_getInstance() {
    RuleEvaluationStrategy_initEntries();
    return RuleEvaluationStrategy_INDEXED_instance;
  }
  function $constrainedInAncestorsCOROUTINE$(_this__u8e3s4, _this__u8e3s4_0, constraintId, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.j77_1 = _this__u8e3s4;
    this.k77_1 = _this__u8e3s4_0;
    this.l77_1 = constraintId;
  }
  protoOf($constrainedInAncestorsCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.j77_1.k60(this.j77_1.n77_1.o77(this.l77_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var constraints = suspendResult;
            if (constraints.s())
              return this.k77_1;
            return filter_1(this.k77_1, combine(constraints));
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function ScopeBuilderWithProvider(context, execution) {
    ScopeBuilder.call(this, context, execution);
  }
  protoOf(ScopeBuilderWithProvider).r77 = function ($completion) {
    return this.k60(this.n77_1.s77(), $completion);
  };
  protoOf(ScopeBuilderWithProvider).t77 = function (_this__u8e3s4, constraintId, $completion) {
    var tmp = new $constrainedInAncestorsCOROUTINE$(this, _this__u8e3s4, constraintId, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  function importScopeByLocation($this, reference, $completion) {
    var tmp = $this.l60(reference.z6o());
    var tmp0_elvis_lhs = tmp instanceof QualifiedReferenceContent ? tmp : null;
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      return Scopes_getInstance().z77_1;
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var content = tmp_0;
    var providerLocation = Companion_instance_125.a78(content.r6p_1, getKClass(DomainNode));
    return $this.k60($this.n77_1.b78(providerLocation), $completion);
  }
  function $importScopeCOROUTINE$(_this__u8e3s4, reference, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.k78_1 = _this__u8e3s4;
    this.l78_1 = reference;
  }
  protoOf($importScopeCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 5;
            this.f9_1 = 1;
            suspendResult = this.k78_1.k60(this.l78_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp0_elvis_lhs = suspendResult;
            if (tmp0_elvis_lhs == null) {
              this.f9_1 = 2;
              suspendResult = importScopeByLocation(this.k78_1, this.l78_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.m78_1 = tmp0_elvis_lhs;
              this.f9_1 = 3;
              continue $sm;
            }

          case 2:
            var tmp_0 = this;
            return suspendResult;
          case 3:
            var provider = this.m78_1;
            this.f9_1 = 4;
            suspendResult = this.k78_1.k60(this.k78_1.n77_1.n78(provider), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            return suspendResult;
          case 5:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 5) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function ScopeBuilder(context, execution) {
    QueryBuilder.call(this, execution);
    this.n77_1 = context;
  }
  protoOf(ScopeBuilder).u77 = function (collection, $completion) {
    return this.k60(this.n77_1.o78(collection), $completion);
  };
  protoOf(ScopeBuilder).v77 = function (collection, $completion) {
    return this.u77(get_forQueries_2(get_asObservable_0(collection)), $completion);
  };
  protoOf(ScopeBuilder).w77 = function (reference, $completion) {
    var tmp = new $importScopeCOROUTINE$(this, reference, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(ScopeBuilder).x77 = function (provider, $completion) {
    return this.k60(this.n77_1.n78(provider), $completion);
  };
  protoOf(ScopeBuilder).y77 = function ($completion) {
    return this.k60(this.n77_1.p78(), $completion);
  };
  function ScopeConfigService() {
  }
  var ScopeConfigService_instance;
  function ScopeConfigService_getInstance() {
    return ScopeConfigService_instance;
  }
  function ScopeConstraintBuilder(execution) {
    QueryBuilder.call(this, execution);
    this.r78_1 = NoopScopeFilter_instance;
  }
  function ScopeConstraintId() {
  }
  function ScopeConstraintProvider() {
  }
  function ScopeProvidersRegistry() {
  }
  function ProvideScope(provider, target, evaluationStrategy, origin, builder) {
    ScopingRuleDefinition.call(this);
    this.s78_1 = provider;
    this.t78_1 = target;
    this.u78_1 = evaluationStrategy;
    this.v78_1 = origin;
    this.w78_1 = builder;
  }
  function DefaultScope(target, builder) {
    ScopingRuleDefinition.call(this);
    this.x78_1 = target;
    this.y78_1 = builder;
  }
  function ConstrainScope(source, id, origin, builder) {
    ScopingRuleDefinition.call(this);
    this.z78_1 = source;
    this.a79_1 = id;
    this.b79_1 = origin;
    this.c79_1 = builder;
  }
  function ProvideName(target, name) {
    ScopingRuleDefinition.call(this);
    this.d79_1 = target;
    this.e79_1 = name;
  }
  function ScopingRuleDefinition() {
  }
  function $runSuspendCOROUTINE$_7(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.n79_1 = _this__u8e3s4;
    this.o79_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_7).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 4;
            var tmp_0 = this;
            tmp_0.s79_1 = this.o79_1;
            this.p79_1 = Unit_instance;
            this.f9_1 = 1;
            continue $sm;
          case 1:
            this.r79_1 = this.s79_1;
            this.q79_1 = new ScopeKey(this.n79_1.t79_1, this.n79_1.u79_1, this.n79_1.v79_1);
            var tmp0 = this.n79_1.w79_1.g76_1;
            var key = this.q79_1;
            if ((isInterface(tmp0, KtMap) ? tmp0 : THROW_CCE()).o2(key)) {
              var tmp_1 = this;
              var tmp_2 = getValue_0(this.n79_1.w79_1.g76_1, this.q79_1);
              tmp_1.p79_1 = tmp_2 instanceof IndexingScope ? tmp_2 : THROW_CCE();
              this.f9_1 = 5;
              continue $sm;
            } else {
              this.f9_1 = 2;
              continue $sm;
            }

          case 2:
            this.f9_1 = 3;
            suspendResult = IndexingCollectionScope(this.r79_1, this.n79_1.t79_1, this.n79_1.u79_1, this.n79_1.v79_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            var scope = suspendResult;
            var tmp0_0 = this.n79_1.w79_1.g76_1;
            var key_0 = this.q79_1;
            tmp0_0.t2(key_0, scope);
            this.p79_1 = scope;
            if (false) {
              this.f9_1 = 1;
              continue $sm;
            }

            this.f9_1 = 5;
            continue $sm;
          case 4:
            throw this.i9_1;
          case 5:
            return this.p79_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 4) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function ScopeKey(specification, collection, nameFunction) {
    this.x79_1 = specification;
    this.y79_1 = collection;
    this.z79_1 = nameFunction;
  }
  protoOf(ScopeKey).toString = function () {
    return 'ScopeKey(specification=' + this.x79_1.toString() + ', collection=' + toString_1(this.y79_1) + ', nameFunction=' + toString_1(this.z79_1) + ')';
  };
  protoOf(ScopeKey).hashCode = function () {
    var result = this.x79_1.hashCode();
    result = imul(result, 31) + hashCode(this.y79_1) | 0;
    result = imul(result, 31) + hashCode(this.z79_1) | 0;
    return result;
  };
  protoOf(ScopeKey).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ScopeKey))
      return false;
    if (!this.x79_1.equals(other.x79_1))
      return false;
    if (!equals(this.y79_1, other.y79_1))
      return false;
    if (!equals(this.z79_1, other.z79_1))
      return false;
    return true;
  };
  function Companion_123() {
  }
  var Companion_instance_123;
  function Companion_getInstance_123() {
    return Companion_instance_123;
  }
  function SharedScopesContainer$indexingScopeFor$$inlined$suspendingQuery$1($specification, $collection, $nameFunction, this$0) {
    this.t79_1 = $specification;
    this.u79_1 = $collection;
    this.v79_1 = $nameFunction;
    this.w79_1 = this$0;
  }
  protoOf(SharedScopesContainer$indexingScopeFor$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_7(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(SharedScopesContainer$indexingScopeFor$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function Empty_2() {
  }
  protoOf(Empty_2).a7a = function (scope, targetConcept) {
    return Companion_getInstance_81().g60_1;
  };
  var Empty_instance_1;
  function Empty_getInstance_1() {
    return Empty_instance_1;
  }
  function Companion_124() {
    Companion_instance_124 = this;
    this.b7a_1 = Empty_instance_1;
  }
  protoOf(Companion_124).g3b = function () {
    return this.b7a_1;
  };
  var Companion_instance_124;
  function Companion_getInstance_124() {
    if (Companion_instance_124 == null)
      new Companion_124();
    return Companion_instance_124;
  }
  function $runSuspendCOROUTINE$_8(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.k7a_1 = _this__u8e3s4;
    this.l7a_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_8).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            var $this$suspendingQuery = this.l7a_1;
            var scopeContext = this.k7a_1.o7a_1.m7a_1.e74(this.k7a_1.p7a_1, RuleEvaluationStrategy_PER_REQUEST_getInstance(), this.k7a_1.o7a_1.m7a_1.g74(), null);
            this.f9_1 = 1;
            suspendResult = this.k7a_1.q7a_1(new ScopeBuilder(scopeContext, $this$suspendingQuery.q5w_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function DefaultScopesManager$getScope$$inlined$suspendingQuery$1(this$0, $targetClass, $builder) {
    this.o7a_1 = this$0;
    this.p7a_1 = $targetClass;
    this.q7a_1 = $builder;
  }
  protoOf(DefaultScopesManager$getScope$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_8(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(DefaultScopesManager$getScope$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function DefaultScopesManager(rules, engine) {
    this.m7a_1 = engine;
    var tmp = this;
    // Inline function 'kotlin.collections.hashMapOf' call
    tmp.n7a_1 = HashMap_init_$Create$();
    var _iterator__ex2g4s = rules.m();
    while (_iterator__ex2g4s.n()) {
      var rule = _iterator__ex2g4s.o();
      var tmp0 = this.n7a_1;
      var tmp2 = rule.x78_1;
      // Inline function 'kotlin.collections.set' call
      var value = rule.y78_1;
      tmp0.t2(tmp2, value);
    }
  }
  protoOf(DefaultScopesManager).r7a = function (targetClass) {
    var tmp = this.n7a_1.q2(targetClass);
    var tmp0_elvis_lhs = (!(tmp == null) ? isSuspendFunction(tmp, 1) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      return constant(new EmptyScope());
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var builder = tmp_0;
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new DefaultScopesManager$getScope$$inlined$suspendingQuery$1(this, targetClass, builder);
  };
  protoOf(DefaultScopesManager).s7a = function (targetConcept) {
    // Inline function 'kotlin.collections.contains' call
    // Inline function 'kotlin.collections.containsKey' call
    var this_0 = this.n7a_1;
    return (isInterface(this_0, KtMap) ? this_0 : THROW_CCE()).o2(targetConcept);
  };
  function NameProvidersManager(rules) {
    var tmp = this;
    // Inline function 'kotlin.collections.linkedMapOf' call
    tmp.t7a_1 = LinkedHashMap_init_$Create$();
    var _iterator__ex2g4s = rules.m();
    while (_iterator__ex2g4s.n()) {
      var rule = _iterator__ex2g4s.o();
      var tmp0 = this.t7a_1;
      var tmp2 = rule.d79_1;
      // Inline function 'kotlin.collections.set' call
      var value = rule.e79_1;
      tmp0.t2(tmp2, value);
    }
  }
  protoOf(NameProvidersManager).u7a = function (target) {
    var _iterator__ex2g4s = this.t7a_1.r2().m();
    while (_iterator__ex2g4s.n()) {
      var targetClass = _iterator__ex2g4s.o();
      if (targetClass.sa(target)) {
        return getValue_0(this.t7a_1, targetClass)(target);
      }
    }
    return constant(Companion_getInstance_119().d72_1);
  };
  function NoScopeSpecificationContext() {
    NoScopeSpecificationContext_instance = this;
    this.v7a_1 = AbsentScopeOwner_instance;
  }
  protoOf(NoScopeSpecificationContext).g74 = function () {
    return this.v7a_1;
  };
  protoOf(NoScopeSpecificationContext).d74 = function (location) {
    return AbsentScopeOwner_instance;
  };
  var NoScopeSpecificationContext_instance;
  function NoScopeSpecificationContext_getInstance() {
    if (NoScopeSpecificationContext_instance == null)
      new NoScopeSpecificationContext();
    return NoScopeSpecificationContext_instance;
  }
  function nodeId($this, node) {
    var tmp0_safe_receiver = isInterface(node, DomainNode) ? node : null;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.z3n();
    return tmp1_elvis_lhs == null ? new NodeId() : tmp1_elvis_lhs;
  }
  function NodeLocation$Companion$fromNode$lambda($node) {
    return function () {
      return $node;
    };
  }
  function NodeLocation$Companion$fromPointer$lambda($pointer) {
    return function () {
      var message = 'Location ' + $pointer.toString() + ' can not be resolved';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    };
  }
  function Companion_125() {
  }
  protoOf(Companion_125).w7a = function (node) {
    var tmp0_elvis_lhs = DocumentIdUtil_getInstance().r6v(node);
    var documentId = tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
    var tmp = nodeId(this, node);
    var tmp_0 = getKClassFromExpression(node);
    return new NodeLocation(tmp, documentId, tmp_0, NodeLocation$Companion$fromNode$lambda(node));
  };
  protoOf(Companion_125).a78 = function (pointer, concept) {
    return new NodeLocation(pointer.nodeId, pointer.documentId, concept, NodeLocation$Companion$fromPointer$lambda(pointer));
  };
  var Companion_instance_125;
  function Companion_getInstance_125() {
    return Companion_instance_125;
  }
  function NodeLocation(id, documentId, concept, resolveNode) {
    this.m73_1 = id;
    this.n73_1 = documentId;
    this.o73_1 = concept;
    this.p73_1 = resolveNode;
  }
  protoOf(NodeLocation).toString = function () {
    return '' + this.o73_1.ra() + '/' + this.n73_1 + '/' + this.m73_1.toString();
  };
  function $runSuspendCOROUTINE$_9(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.f7b_1 = _this__u8e3s4;
    this.g7b_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_9).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 9;
            var tmp_0 = this;
            tmp_0.n7b_1 = this.g7b_1;
            this.h7b_1 = Unit_instance;
            this.f9_1 = 1;
            continue $sm;
          case 1:
            this.i7b_1 = this.n7b_1;
            var tmp_1 = this.f7b_1.o7b_1.f6p_1;
            var initial = isInterface(tmp_1, DomainNode) ? tmp_1 : THROW_CCE();
            var curr = initial;
            this.k7b_1 = new ValueProperty(curr);
            var tmp_2 = this;
            var tmp0_safe_receiver = this.f7b_1.o7b_1.g6p_1;
            var tmp_3;
            if (tmp0_safe_receiver == null) {
              tmp_3 = null;
            } else {
              tmp_3 = new LexicalWithRole(tmp0_safe_receiver);
            }

            var tmp1_elvis_lhs = tmp_3;
            tmp_2.j7b_1 = tmp1_elvis_lhs == null ? Lexical_getInstance() : tmp1_elvis_lhs;
            this.f9_1 = 2;
            continue $sm;
          case 2:
            if (!true) {
              this.f9_1 = 6;
              continue $sm;
            }

            var tmp2_elvis_lhs = this.i7b_1.l60(get_forQueries_0(this.k7b_1));
            if (tmp2_elvis_lhs == null) {
              this.f9_1 = 6;
              var tmp_4 = this;
              continue $sm;
            } else {
              this.m7b_1 = tmp2_elvis_lhs;
              this.f9_1 = 3;
              continue $sm;
            }

          case 3:
            this.l7b_1 = this.m7b_1;
            this.f9_1 = 4;
            suspendResult = this.i7b_1.k60(this.f7b_1.p7b_1.s7b(this.l7b_1, this.j7b_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            var scope = suspendResult;
            if (!(scope == null)) {
              this.h7b_1 = scope;
              this.f9_1 = 8;
              continue $sm;
            } else {
              this.f9_1 = 5;
              continue $sm;
            }

          case 5:
            curr = this.l7b_1;
            this.k7b_1 = curr.x6i();
            var roleInParent = curr.y6i();
            this.j7b_1 = !(roleInParent == null) ? new LexicalWithRole(roleInParent) : Lexical_getInstance();
            this.f9_1 = 2;
            continue $sm;
          case 6:
            this.f9_1 = 7;
            suspendResult = this.i7b_1.k60(this.f7b_1.p7b_1.t7b(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 7:
            var tmp3_elvis_lhs = suspendResult;
            this.h7b_1 = tmp3_elvis_lhs == null ? Scopes_getInstance().u7b() : tmp3_elvis_lhs;
            if (false) {
              this.f9_1 = 1;
              continue $sm;
            }

            this.f9_1 = 8;
            continue $sm;
          case 8:
            return this.h7b_1;
          case 9:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 9) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function ParentChildScopes$nearestEnclosingOrDefaultScope$$inlined$suspendingQuery$1($enclosing, this$0) {
    this.o7b_1 = $enclosing;
    this.p7b_1 = this$0;
  }
  protoOf(ParentChildScopes$nearestEnclosingOrDefaultScope$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_9(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(ParentChildScopes$nearestEnclosingOrDefaultScope$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function ParentChildScopes(scopeConfig, targetConcept) {
    this.q7b_1 = scopeConfig;
    this.r7b_1 = targetConcept;
  }
  protoOf(ParentChildScopes).v7b = function (enclosingNode, role) {
    return this.w7b(new EnclosingNodeContext(enclosingNode, role));
  };
  protoOf(ParentChildScopes).x7b = function (enclosingNode, role, $super) {
    role = role === VOID ? null : role;
    return $super === VOID ? this.v7b(enclosingNode, role) : $super.v7b.call(this, enclosingNode, role);
  };
  protoOf(ParentChildScopes).w7b = function (enclosing) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new ParentChildScopes$nearestEnclosingOrDefaultScope$$inlined$suspendingQuery$1(enclosing, this);
  };
  protoOf(ParentChildScopes).s7b = function (node, selector) {
    var tmp = Companion_instance_125;
    return this.q7b_1.l73(tmp.w7a(isInterface(node, DomainNode) ? node : THROW_CCE()), selector, this.r7b_1);
  };
  protoOf(ParentChildScopes).y7b = function (location, selector) {
    return this.q7b_1.l73(location, selector, this.r7b_1);
  };
  protoOf(ParentChildScopes).t7b = function () {
    return this.q7b_1.f74(this.r7b_1);
  };
  function $runSuspendCOROUTINE$_10(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.h7c_1 = _this__u8e3s4;
    this.i7c_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_10).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 5;
            this.m7c_1 = this.i7c_1;
            this.j7c_1 = ArrayList_init_$Create$();
            this.k7c_1 = this.h7c_1.o7c_1;
            this.n7c_1 = null;
            this.f9_1 = 1;
            continue $sm;
          case 1:
            if (!true) {
              this.f9_1 = 6;
              continue $sm;
            }

            this.f9_1 = 2;
            suspendResult = this.m7c_1.k60(tryConstraintRule(this.h7c_1.p7c_1, this.k7c_1, this.n7c_1, this.h7c_1.p7c_1.r7c_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var constraint = suspendResult;
            if (!(constraint == null)) {
              this.j7c_1.j(constraint);
            }

            var tmp_0 = this.k7c_1;
            if (!isInterface(tmp_0, DomainNode)) {
              this.f9_1 = 6;
              continue $sm;
            } else {
              this.f9_1 = 3;
              continue $sm;
            }

          case 3:
            this.n7c_1 = this.k7c_1.y6i();
            var tmp0_elvis_lhs = this.m7c_1.l60(get_forQueries_0(this.k7c_1.x6i()));
            if (tmp0_elvis_lhs == null) {
              this.f9_1 = 6;
              var tmp_1 = this;
              continue $sm;
            } else {
              this.l7c_1 = tmp0_elvis_lhs;
              this.f9_1 = 4;
              continue $sm;
            }

          case 4:
            this.k7c_1 = this.l7c_1;
            this.f9_1 = 1;
            continue $sm;
          case 5:
            throw this.i9_1;
          case 6:
            return this.j7c_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 5) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function $runSuspendCOROUTINE$_11(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.a7d_1 = _this__u8e3s4;
    this.b7d_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_11).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 3;
            var $this$suspendingQuery = this.b7d_1;
            var tmp0_safe_receiver = this.a7d_1.d7d_1;
            var tmp_0;
            if (tmp0_safe_receiver == null) {
              tmp_0 = null;
            } else {
              tmp_0 = new LexicalWithRole(tmp0_safe_receiver);
            }

            var tmp1_elvis_lhs = tmp_0;
            var origin = tmp1_elvis_lhs == null ? Lexical_getInstance() : tmp1_elvis_lhs;
            var tmp_1 = this.a7d_1.e7d_1.q7c_1.h7d(getKClassFromExpression(this.a7d_1.f7d_1), origin, this.a7d_1.g7d_1);
            var constraint = (tmp_1 == null ? true : isInterface(tmp_1, ScopeConstraintProvider)) ? tmp_1 : THROW_CCE();
            if (constraint == null) {
              var tmp_2 = this;
              tmp_2.c7d_1 = null;
              this.f9_1 = 2;
              continue $sm;
            } else {
              this.f9_1 = 1;
              suspendResult = $this$suspendingQuery.k60(constraint.c76(this.a7d_1.f7d_1), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            this.c7d_1 = suspendResult;
            this.f9_1 = 2;
            continue $sm;
          case 2:
            return this.c7d_1;
          case 3:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 3) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function tryConstraintRule($this, node, childLink, constraintId) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new ParentScopeConstraints$tryConstraintRule$$inlined$suspendingQuery$1(childLink, $this, node, constraintId);
  }
  function ParentScopeConstraints$collectConstraints$$inlined$suspendingQuery$1($node, this$0) {
    this.o7c_1 = $node;
    this.p7c_1 = this$0;
  }
  protoOf(ParentScopeConstraints$collectConstraints$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_10(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(ParentScopeConstraints$collectConstraints$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function ParentScopeConstraints$tryConstraintRule$$inlined$suspendingQuery$1($childLink, this$0, $node, $constraintId) {
    this.d7d_1 = $childLink;
    this.e7d_1 = this$0;
    this.f7d_1 = $node;
    this.g7d_1 = $constraintId;
  }
  protoOf(ParentScopeConstraints$tryConstraintRule$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_11(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(ParentScopeConstraints$tryConstraintRule$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function ParentScopeConstraints(scopeConfig, constraintId) {
    this.q7c_1 = scopeConfig;
    this.r7c_1 = constraintId;
  }
  protoOf(ParentScopeConstraints).i7d = function (node) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new ParentScopeConstraints$collectConstraints$$inlined$suspendingQuery$1(node, this);
  };
  function ProviderSpec(providerClass, targetClass, originSelector) {
    this.j7d_1 = providerClass;
    this.k7d_1 = targetClass;
    this.l7d_1 = originSelector;
  }
  protoOf(ProviderSpec).toString = function () {
    return 'ProviderSpec(providerClass=' + toString_1(this.j7d_1) + ', targetClass=' + toString_1(this.k7d_1) + ', originSelector=' + toString_1(this.l7d_1) + ')';
  };
  protoOf(ProviderSpec).hashCode = function () {
    var result = this.j7d_1.hashCode();
    result = imul(result, 31) + this.k7d_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.l7d_1) | 0;
    return result;
  };
  protoOf(ProviderSpec).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ProviderSpec))
      return false;
    if (!this.j7d_1.equals(other.j7d_1))
      return false;
    if (!this.k7d_1.equals(other.k7d_1))
      return false;
    if (!equals(this.l7d_1, other.l7d_1))
      return false;
    return true;
  };
  function ProvideScopeRulesContainer(rules) {
    var tmp = this;
    // Inline function 'kotlin.collections.hashMapOf' call
    tmp.m7d_1 = HashMap_init_$Create$();
    var tmp_0 = this;
    // Inline function 'kotlin.collections.hashMapOf' call
    tmp_0.n7d_1 = HashMap_init_$Create$();
    var _iterator__ex2g4s = rules.m();
    while (_iterator__ex2g4s.n()) {
      var rule = _iterator__ex2g4s.o();
      var tmp0 = this.m7d_1;
      // Inline function 'kotlin.collections.set' call
      var key = new ProviderSpec(rule.s78_1, rule.t78_1, rule.v78_1);
      tmp0.t2(key, rule);
      var tmp0_0 = this.n7d_1;
      // Inline function 'kotlin.collections.getOrPut' call
      var key_0 = rule.s78_1;
      var value = tmp0_0.q2(key_0);
      var tmp_1;
      if (value == null) {
        // Inline function 'kotlin.collections.arrayListOf' call
        var answer = ArrayList_init_$Create$();
        tmp0_0.t2(key_0, answer);
        tmp_1 = answer;
      } else {
        tmp_1 = value;
      }
      tmp_1.j(new ProvidedScopeSpec(rule.t78_1, rule.v78_1));
    }
  }
  protoOf(ProvideScopeRulesContainer).o7d = function (provider, target, origin) {
    var tmp0_elvis_lhs = this.n7d_1.q2(provider);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var specs = tmp;
    var result = null;
    var _iterator__ex2g4s = specs.m();
    while (_iterator__ex2g4s.n()) {
      var spec = _iterator__ex2g4s.o();
      if (spec.p7d_1.equals(target) && origin.x76(spec.q7d_1)) {
        if (result == null || spec.q7d_1.x76(result.q7d_1)) {
          result = spec;
        }
      }
    }
    if (result == null)
      return null;
    var tmp_0 = this.m7d_1.q2(new ProviderSpec(provider, target, result.q7d_1));
    return tmp_0 instanceof ProvideScope ? tmp_0 : null;
  };
  protoOf(ProvideScopeRulesContainer).r7d = function (provider) {
    // Inline function 'kotlin.collections.getOrElse' call
    var tmp0_elvis_lhs = this.n7d_1.q2(provider);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      tmp = emptyList();
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  function ProvidedScopeSpec(targetClass, originSelector) {
    this.p7d_1 = targetClass;
    this.q7d_1 = originSelector;
  }
  protoOf(ProvidedScopeSpec).toString = function () {
    return 'ProvidedScopeSpec(targetClass=' + toString_1(this.p7d_1) + ', originSelector=' + toString_1(this.q7d_1) + ')';
  };
  protoOf(ProvidedScopeSpec).hashCode = function () {
    var result = this.p7d_1.hashCode();
    result = imul(result, 31) + hashCode(this.q7d_1) | 0;
    return result;
  };
  protoOf(ProvidedScopeSpec).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ProvidedScopeSpec))
      return false;
    if (!this.p7d_1.equals(other.p7d_1))
      return false;
    if (!equals(this.q7d_1, other.q7d_1))
      return false;
    return true;
  };
  function $runSuspendCOROUTINE$_12(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.a7e_1 = _this__u8e3s4;
    this.b7e_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_12).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            var $this$suspendingQuery = this.b7e_1;
            this.f9_1 = 1;
            suspendResult = this.a7e_1.c7e_1(new ScopeConstraintBuilder($this$suspendingQuery.q5w_1), this.a7e_1.d7e_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function ConstraintSpec(sourceClass, origin, constraintId) {
    this.e7e_1 = sourceClass;
    this.f7e_1 = origin;
    this.g7e_1 = constraintId;
  }
  protoOf(ConstraintSpec).toString = function () {
    return 'ConstraintSpec(sourceClass=' + toString_1(this.e7e_1) + ', origin=' + toString_1(this.f7e_1) + ', constraintId=' + toString_1(this.g7e_1) + ')';
  };
  protoOf(ConstraintSpec).hashCode = function () {
    var result = this.e7e_1.hashCode();
    result = imul(result, 31) + hashCode(this.f7e_1) | 0;
    result = imul(result, 31) + hashCode(this.g7e_1) | 0;
    return result;
  };
  protoOf(ConstraintSpec).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ConstraintSpec))
      return false;
    if (!this.e7e_1.equals(other.e7e_1))
      return false;
    if (!equals(this.f7e_1, other.f7e_1))
      return false;
    if (!equals(this.g7e_1, other.g7e_1))
      return false;
    return true;
  };
  function ScopeConstraintsManager$getScopeConstraint$$inlined$suspendingQuery$1($queryBuilder, $source) {
    this.c7e_1 = $queryBuilder;
    this.d7e_1 = $source;
  }
  protoOf(ScopeConstraintsManager$getScopeConstraint$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_12(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(ScopeConstraintsManager$getScopeConstraint$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function ScopeConstraintsManager$hasRulesFor$lambda(it) {
    return it.v76_1;
  }
  function ScopeConstraintsManager(rules) {
    var tmp = this;
    // Inline function 'kotlin.collections.hashMapOf' call
    tmp.h7e_1 = HashMap_init_$Create$();
    var _iterator__ex2g4s = rules.m();
    while (_iterator__ex2g4s.n()) {
      var rule = _iterator__ex2g4s.o();
      var tmp0 = this.h7e_1;
      var tmp2 = new ConstraintSpec(rule.z78_1, rule.b79_1, rule.a79_1);
      // Inline function 'kotlin.collections.set' call
      var value = rule.c79_1;
      tmp0.t2(tmp2, value);
    }
  }
  protoOf(ScopeConstraintsManager).i7e = function (source, origin, constraintId) {
    var queryBuilder = this.h7e_1.q2(new ConstraintSpec(getKClassFromExpression(source), origin, constraintId));
    var tmp;
    if (!(queryBuilder == null)) {
      // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
      tmp = new ScopeConstraintsManager$getScopeConstraint$$inlined$suspendingQuery$1(queryBuilder, source);
    } else {
      tmp = Companion_getInstance_81().g60_1;
    }
    return tmp;
  };
  protoOf(ScopeConstraintsManager).j7e = function (sourceClass, origin, constraintId) {
    var tmp0 = generateSequence(origin, ScopeConstraintsManager$hasRulesFor$lambda);
    var tmp$ret$3;
    $l$block: {
      // Inline function 'kotlin.sequences.firstOrNull' call
      var _iterator__ex2g4s = tmp0.m();
      while (_iterator__ex2g4s.n()) {
        var element = _iterator__ex2g4s.o();
        var tmp0_0 = this.h7e_1;
        // Inline function 'kotlin.collections.contains' call
        // Inline function 'kotlin.collections.containsKey' call
        var key = new ConstraintSpec(sourceClass, element, constraintId);
        if ((isInterface(tmp0_0, KtMap) ? tmp0_0 : THROW_CCE()).o2(key)) {
          tmp$ret$3 = element;
          break $l$block;
        }
      }
      tmp$ret$3 = null;
    }
    return tmp$ret$3;
  };
  function $runSuspendCOROUTINE$_13(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.s7e_1 = _this__u8e3s4;
    this.t7e_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_13).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 6;
            var tmp_0 = this;
            tmp_0.x7e_1 = this.t7e_1;
            this.u7e_1 = Unit_instance;
            this.f9_1 = 1;
            continue $sm;
          case 1:
            this.v7e_1 = this.x7e_1;
            var tmp_1 = this.s7e_1.c7f_1.a7f_1;
            if (!(!(tmp_1 == null) ? isInterface(tmp_1, DomainNode) : false)) {
              this.u7e_1 = Scopes_getInstance().z77_1;
              this.f9_1 = 7;
              continue $sm;
            } else {
              this.f9_1 = 2;
              continue $sm;
            }

          case 2:
            var tmp0_elvis_lhs = this.s7e_1.c7f_1.a7f_1.bp();
            if (tmp0_elvis_lhs == null) {
              this.f9_1 = 3;
              suspendResult = this.v7e_1.k60(this.s7e_1.c7f_1.b7f_1.t7b(), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.w7e_1 = tmp0_elvis_lhs;
              this.f9_1 = 4;
              continue $sm;
            }

          case 3:
            var tmp1_elvis_lhs = suspendResult;
            this.u7e_1 = tmp1_elvis_lhs == null ? Scopes_getInstance().z77_1 : tmp1_elvis_lhs;
            this.f9_1 = 7;
            var tmp_2 = this;
            continue $sm;
          case 4:
            var parent = this.w7e_1;
            this.f9_1 = 5;
            suspendResult = this.v7e_1.k60(this.s7e_1.c7f_1.b7f_1.v7b(parent, this.s7e_1.c7f_1.a7f_1.y6i()), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 5:
            this.u7e_1 = suspendResult;
            if (false) {
              this.f9_1 = 1;
              continue $sm;
            }

            this.f9_1 = 7;
            continue $sm;
          case 6:
            throw this.i9_1;
          case 7:
            return this.u7e_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 6) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function $runSuspendCOROUTINE$_14(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.l7f_1 = _this__u8e3s4;
    this.m7f_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_14).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            var $this$suspendingQuery = this.m7f_1;
            this.f9_1 = 1;
            suspendResult = $this$suspendingQuery.k60(this.l7f_1.n7f_1.b7f_1.s7b(this.l7f_1.o7f_1, Import_getInstance()), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp0_elvis_lhs = suspendResult;
            return tmp0_elvis_lhs == null ? Scopes_getInstance().z77_1 : tmp0_elvis_lhs;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function $runSuspendCOROUTINE$_15(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.x7f_1 = _this__u8e3s4;
    this.y7f_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_15).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            var $this$suspendingQuery = this.y7f_1;
            this.f9_1 = 1;
            suspendResult = $this$suspendingQuery.k60(this.x7f_1.z7f_1.b7f_1.y7b(this.x7f_1.a7g_1, Import_getInstance()), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp0_elvis_lhs = suspendResult;
            return tmp0_elvis_lhs == null ? Scopes_getInstance().z77_1 : tmp0_elvis_lhs;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function $runSuspendCOROUTINE$_16(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.j7g_1 = _this__u8e3s4;
    this.k7g_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_16).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            var $this$suspendingQuery = this.k7g_1;
            this.f9_1 = 1;
            suspendResult = $this$suspendingQuery.k60(this.j7g_1.l7g_1.b7f_1.t7b(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp0_elvis_lhs = suspendResult;
            return tmp0_elvis_lhs == null ? Scopes_getInstance().z77_1 : tmp0_elvis_lhs;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function ScopeContextImpl$parentScope$$inlined$suspendingQuery$1(this$0) {
    this.c7f_1 = this$0;
  }
  protoOf(ScopeContextImpl$parentScope$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_13(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(ScopeContextImpl$parentScope$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function ScopeContextImpl$importScope$$inlined$suspendingQuery$1(this$0, $provider) {
    this.n7f_1 = this$0;
    this.o7f_1 = $provider;
  }
  protoOf(ScopeContextImpl$importScope$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_14(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(ScopeContextImpl$importScope$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function ScopeContextImpl$importScope$$inlined$suspendingQuery$2(this$0, $providerLocation) {
    this.z7f_1 = this$0;
    this.a7g_1 = $providerLocation;
  }
  protoOf(ScopeContextImpl$importScope$$inlined$suspendingQuery$2).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_15(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(ScopeContextImpl$importScope$$inlined$suspendingQuery$2).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function ScopeContextImpl$defaultScope$$inlined$suspendingQuery$1(this$0) {
    this.l7g_1 = this$0;
  }
  protoOf(ScopeContextImpl$defaultScope$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_16(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(ScopeContextImpl$defaultScope$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function ScopeConfig$getName$ref(p0) {
    var l = function (_this__u8e3s4) {
      return p0.u7a(_this__u8e3s4);
    };
    l.callableName = 'getName';
    return l;
  }
  function ScopeContextImpl(ruleEvaluation, scopeConfig, targetConcept, node) {
    this.y7e_1 = ruleEvaluation;
    this.z7e_1 = scopeConfig;
    this.a7f_1 = node;
    this.b7f_1 = new ParentChildScopes(this.z7e_1, targetConcept);
  }
  protoOf(ScopeContextImpl).s77 = function () {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new ScopeContextImpl$parentScope$$inlined$suspendingQuery$1(this);
  };
  protoOf(ScopeContextImpl).n78 = function (provider) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new ScopeContextImpl$importScope$$inlined$suspendingQuery$1(this, provider);
  };
  protoOf(ScopeContextImpl).b78 = function (providerLocation) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new ScopeContextImpl$importScope$$inlined$suspendingQuery$2(this, providerLocation);
  };
  protoOf(ScopeContextImpl).p78 = function () {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new ScopeContextImpl$defaultScope$$inlined$suspendingQuery$1(this);
  };
  protoOf(ScopeContextImpl).o77 = function (constraintId) {
    return this.a7f_1 == null ? constant(emptyList()) : (new ParentScopeConstraints(this.z7e_1, constraintId)).i7d(this.a7f_1);
  };
  protoOf(ScopeContextImpl).o78 = function (collection) {
    var scopeFactory = this.z7e_1.m7g(this.y7e_1.e76_1);
    var specification = collectionScopeSpecification(this.z7e_1, collection);
    return scopeFactory.d76(specification, this.y7e_1, collection, ScopeConfig$getName$ref(this.z7e_1));
  };
  function ScopeProvidersManager$ProvidedScopesContainer$readScopeProperty$o$runSuspend$lambda($scopeEvalCompleted) {
    return function (it) {
      $scopeEvalCompleted.su();
      return Unit_instance;
    };
  }
  function $runSuspendCOROUTINE$_17(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.v7g_1 = _this__u8e3s4;
    this.w7g_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_17).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 10;
            this.y7g_1 = this.w7g_1;
            var result = this.v7g_1.b7h_1.uv();
            if (result == null) {
              var tmp_0 = this;
              tmp_0.z7g_1 = Job_0(get_job(this.l9()));
              var updateHandler = this.v7g_1.b7h_1.z2r(ScopeProvidersManager$ProvidedScopesContainer$readScopeProperty$o$runSuspend$lambda(this.z7g_1));
              var tmp_1 = this;
              tmp_1.a7h_1 = updateHandler;
              this.f9_1 = 1;
              continue $sm;
            } else {
              this.f9_1 = 8;
              continue $sm;
            }

          case 1:
            this.x7g_1 = this.a7h_1;
            this.f9_1 = 2;
            continue $sm;
          case 2:
            this.f9_1 = 3;
            continue $sm;
          case 3:
            this.g9_1 = 9;
            this.x7g_1;
            if (!(this.v7g_1.b7h_1.uv() == null)) {
              this.z7g_1.su();
            }

            this.f9_1 = 4;
            suspendResult = this.z7g_1.np(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            this.g9_1 = 10;
            this.f9_1 = 5;
            var tmp_2 = this;
            continue $sm;
          case 5:
            this.g9_1 = 10;
            this.x7g_1.zr();
            this.f9_1 = 7;
            continue $sm;
          case 6:
            this.g9_1 = 10;
            this.x7g_1.zr();
            if (false) {
              this.f9_1 = 1;
              continue $sm;
            }

            this.f9_1 = 7;
            continue $sm;
          case 7:
            this.f9_1 = 8;
            continue $sm;
          case 8:
            return ensureNotNull(this.y7g_1.l60(get_forQueries_0(this.v7g_1.b7h_1)));
          case 9:
            this.g9_1 = 10;
            var t = this.i9_1;
            this.x7g_1.zr();
            throw t;
          case 10:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 10) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function ScopeProvidersManager$ProvidedScopesContainer$readScopeProperty$$inlined$suspendingQuery$1($scopeProperty) {
    this.b7h_1 = $scopeProperty;
  }
  protoOf(ScopeProvidersManager$ProvidedScopesContainer$readScopeProperty$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_17(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(ScopeProvidersManager$ProvidedScopesContainer$readScopeProperty$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function ScopeProvidersManager$Companion$LOG$lambda() {
    return Unit_instance;
  }
  function ScopeProvidersManager$populateScopesFor$slambda$o$runSuspend$lambda($providerClass, $spec, $provider, $id) {
    return function () {
      return 'Scope provider rule is evaluating, provider ' + toString_1($providerClass) + ', specification ' + $spec.toString() + ', instance ' + toString_1($provider) + ', id ' + $id;
    };
  }
  function ScopeProvidersManager$populateScopesFor$slambda$o$runSuspend$lambda_0($providerClass, $spec, $provider, $id) {
    return function () {
      return 'Scope provider rule evaluated, provider ' + toString_1($providerClass) + ', specification ' + $spec.toString() + ', instance ' + toString_1($provider) + ', id ' + $id;
    };
  }
  function $runSuspendCOROUTINE$_18(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.k7h_1 = _this__u8e3s4;
    this.l7h_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_18).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 5;
            this.n7h_1 = this.l7h_1;
            var tmp_0 = Companion_getInstance_126().o7h_1;
            tmp_0.a2q(ScopeProvidersManager$populateScopesFor$slambda$o$runSuspend$lambda(this.k7h_1.s7h_1, this.k7h_1.t7h_1, this.k7h_1.r7h_1, this.k7h_1.u7h_1));
            this.f9_1 = 1;
            continue $sm;
          case 1:
            this.g9_1 = 4;
            this.f9_1 = 2;
            suspendResult = this.k7h_1.p7h_1(new ScopeBuilderWithProvider(this.k7h_1.q7h_1, this.n7h_1.q5w_1), this.k7h_1.r7h_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.m7h_1 = suspendResult;
            this.g9_1 = 5;
            this.f9_1 = 3;
            continue $sm;
          case 3:
            var tmp_1 = this.m7h_1;
            this.g9_1 = 5;
            var tmp_2 = Companion_getInstance_126().o7h_1;
            tmp_2.a2q(ScopeProvidersManager$populateScopesFor$slambda$o$runSuspend$lambda_0(this.k7h_1.s7h_1, this.k7h_1.t7h_1, this.k7h_1.r7h_1, this.k7h_1.u7h_1));
            return tmp_1;
          case 4:
            this.g9_1 = 5;
            var t = this.i9_1;
            var tmp_3 = Companion_getInstance_126().o7h_1;
            tmp_3.a2q(ScopeProvidersManager$populateScopesFor$slambda$o$runSuspend$lambda_0(this.k7h_1.s7h_1, this.k7h_1.t7h_1, this.k7h_1.r7h_1, this.k7h_1.u7h_1));
            throw t;
          case 5:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 5) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function ScopeProvidersManager$populateScopesFor$slambda$lambda($providerClass, $spec, $provider, $id) {
    return function () {
      return 'Evaluation loop for scope provider rule created, provider ' + toString_1($providerClass) + ', specification ' + $spec.toString() + ', instance ' + toString_1($provider) + ', id ' + $id;
    };
  }
  function ScopeProvidersManager$populateScopesFor$2$$inlined$suspendingQuery$1($ruleBuilder, $scopeContext, $provider, $providerClass, $spec, $id) {
    this.p7h_1 = $ruleBuilder;
    this.q7h_1 = $scopeContext;
    this.r7h_1 = $provider;
    this.s7h_1 = $providerClass;
    this.t7h_1 = $spec;
    this.u7h_1 = $id;
  }
  protoOf(ScopeProvidersManager$populateScopesFor$2$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_18(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(ScopeProvidersManager$populateScopesFor$2$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function ScopeProvidersManager$populateScopesFor$slambda$lambda_0($scopeProperty) {
    return function (event) {
      var tmp = event.t2y_1;
      var queryState = tmp instanceof Ready ? tmp : null;
      var tmp_0 = queryState == null ? null : queryState.t5w_1;
      var queryOutcome = tmp_0 instanceof Success ? tmp_0 : null;
      var tmp2_elvis_lhs = queryOutcome == null ? null : queryOutcome.u5w_1;
      var scope = tmp2_elvis_lhs == null ? Scopes_getInstance().z77_1 : tmp2_elvis_lhs;
      $scopeProperty.d2x(scope);
      return Unit_instance;
    };
  }
  function $runSuspendCOROUTINE$_19(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.d7i_1 = _this__u8e3s4;
    this.e7i_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_19).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            var $this$suspendingQuery = this.e7i_1;
            var tmp_0 = Companion_instance_125;
            var tmp_1 = this.d7i_1.g7i_1;
            var scopeOwner = this.d7i_1.f7i_1.j7i_1.d74(tmp_0.w7a(isInterface(tmp_1, DomainNode) ? tmp_1 : THROW_CCE()));
            var scopeContext = this.d7i_1.f7i_1.j7i_1.e74(this.d7i_1.h7i_1, RuleEvaluationStrategy_PER_REQUEST_getInstance(), scopeOwner, this.d7i_1.g7i_1);
            this.f9_1 = 1;
            suspendResult = this.d7i_1.i7i_1(new ScopeBuilderWithProvider(scopeContext, $this$suspendingQuery.q5w_1), this.d7i_1.g7i_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function hasEagerRuleFor($this, providerConcept, targetConcept, selector) {
    return !($this.l7i_1.o7d(providerConcept, targetConcept, selector) == null);
  }
  function hasPerRequestRuleFor($this, providerConcept, targetConcept, selector) {
    return !($this.m7i_1.o7d(providerConcept, targetConcept, selector) == null);
  }
  function ProvidedScopesContainer(job) {
    this.p7i_1 = job;
    var tmp = this;
    // Inline function 'kotlin.collections.hashMapOf' call
    tmp.q7i_1 = HashMap_init_$Create$();
  }
  protoOf(ProvidedScopesContainer).r7i = function (key) {
    // Inline function 'kotlin.collections.getOrPut' call
    var this_0 = this.q7i_1;
    var value = this_0.q2(key);
    var tmp;
    if (value == null) {
      var answer = new ValueProperty(null);
      this_0.t2(key, answer);
      tmp = answer;
    } else {
      tmp = value;
    }
    var tmp_0 = tmp;
    return isInterface(tmp_0, Property) ? tmp_0 : THROW_CCE();
  };
  protoOf(ProvidedScopesContainer).s7i = function (key) {
    var rightKey = key;
    $l$loop: while (true) {
      var tmp;
      var tmp0 = this.q7i_1;
      // Inline function 'kotlin.collections.contains' call
      // Inline function 'kotlin.collections.containsKey' call
      var key_0 = rightKey;
      if (!(isInterface(tmp0, KtMap) ? tmp0 : THROW_CCE()).o2(key_0)) {
        tmp = !(rightKey.q7d_1.v76_1 == null);
      } else {
        tmp = false;
      }
      if (!tmp) {
        break $l$loop;
      }
      rightKey = new ProvidedScopeSpec(key.p7d_1, ensureNotNull(rightKey.q7d_1.v76_1));
    }
    var tmp_0 = this.q7i_1.q2(rightKey);
    var scopeProperty = (!(tmp_0 == null) ? isInterface(tmp_0, Property) : false) ? tmp_0 : THROW_CCE();
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new ScopeProvidersManager$ProvidedScopesContainer$readScopeProperty$$inlined$suspendingQuery$1(scopeProperty);
  };
  protoOf(ProvidedScopesContainer).zr = function () {
    this.p7i_1.sp();
  };
  function Companion_126() {
    Companion_instance_126 = this;
    var tmp = this;
    var tmp_0 = KotlinLogging_getInstance();
    tmp.o7h_1 = tmp_0.i2q(ScopeProvidersManager$Companion$LOG$lambda);
  }
  var Companion_instance_126;
  function Companion_getInstance_126() {
    if (Companion_instance_126 == null)
      new Companion_126();
    return Companion_instance_126;
  }
  function ScopeProvidersManager$eagerRules$lambda(it) {
    return it.u78_1.a77_1;
  }
  function ScopeProvidersManager$perRequestRules$lambda(it) {
    return !it.u78_1.a77_1;
  }
  function ScopeProvidersManager$populateScopesFor$slambda(this$0, $provider, $editable, resultContinuation) {
    this.b7j_1 = this$0;
    this.c7j_1 = $provider;
    this.d7j_1 = $editable;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ScopeProvidersManager$populateScopesFor$slambda).e1h = function ($this$launch, $completion) {
    var tmp = this.f1h($this$launch, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(ScopeProvidersManager$populateScopesFor$slambda).v9 = function (p1, $completion) {
    return this.e1h((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ScopeProvidersManager$populateScopesFor$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 5;
            this.g7j_1 = new ProvidedScopesContainer(get_job(this.e7j_1.ho()));
            var tmp0 = this.b7j_1.o7i_1;
            var tmp2 = this.c7j_1;
            var value = this.g7j_1;
            tmp0.t2(tmp2, value);
            this.h7j_1 = getKClassFromExpression(this.c7j_1);
            this.i7j_1 = this.b7j_1.l7i_1.r7d(this.h7j_1).m();
            this.f9_1 = 1;
            continue $sm;
          case 1:
            if (!this.i7j_1.n()) {
              this.f9_1 = 4;
              continue $sm;
            }

            var spec = this.i7j_1.o();
            var _unary__edvuaz = this.b7j_1.k7i_1;
            this.b7j_1.k7i_1 = _unary__edvuaz + 1 | 0;
            var id = _unary__edvuaz;
            var tmp_0 = Companion_getInstance_126().o7h_1;
            tmp_0.a2q(ScopeProvidersManager$populateScopesFor$slambda$lambda(this.h7j_1, spec, this.c7j_1, id));
            var tmp0_0 = this.b7j_1.l7i_1.o7d(this.h7j_1, spec.p7d_1, spec.q7d_1);
            var tmp$ret$0 = Unit_instance;
            l$ret$1: do {
              if (tmp0_0 == null) {
                var message = 'Required value was null.';
                throw IllegalStateException_init_$Create$_0(toString_1(message));
              } else {
                tmp$ret$0 = tmp0_0;
                break l$ret$1;
              }
            }
             while (false);
            var rule = tmp$ret$0;
            var ruleBuilder = rule.w78_1;
            var coroutineName = new CoroutineName('ScopeProvider-' + id);
            var newCoroutineContext = this.e7j_1.ho().wi(coroutineName);
            var tmp_1 = Companion_instance_125;
            var tmp_2 = this.c7j_1;
            var scopeOwner = this.b7j_1.j7i_1.d74(tmp_1.w7a(isInterface(tmp_2, DomainNode) ? tmp_2 : THROW_CCE()));
            var scopeContext = this.b7j_1.j7i_1.e74(spec.p7d_1, rule.u78_1, scopeOwner, this.c7j_1);
            var query = new ScopeProvidersManager$populateScopesFor$2$$inlined$suspendingQuery$1(ruleBuilder, scopeContext, this.c7j_1, this.h7j_1, spec, id);
            this.f7j_1 = this.g7j_1.r7i(spec);
            if (this.d7j_1) {
              var loopingQuery = new LoopingQuery(newCoroutineContext, query);
              loopingQuery.z2r(ScopeProvidersManager$populateScopesFor$slambda$lambda_0(this.f7j_1));
              var result = loopingQuery.uv();
              if (result instanceof Ready) {
                var outcome = result.t5w_1;
                if (outcome instanceof Success) {
                  this.f7j_1.d2x(outcome.u5w_1);
                }
              }
              this.f9_1 = 3;
              continue $sm;
            } else {
              this.f9_1 = 2;
              suspendResult = execute_1(query, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 2:
            var ARGUMENT = suspendResult;
            this.f7j_1.d2x(ARGUMENT);
            this.f9_1 = 3;
            continue $sm;
          case 3:
            this.f9_1 = 1;
            continue $sm;
          case 4:
            return Unit_instance;
          case 5:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 5) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(ScopeProvidersManager$populateScopesFor$slambda).f1h = function ($this$launch, completion) {
    var i = new ScopeProvidersManager$populateScopesFor$slambda(this.b7j_1, this.c7j_1, this.d7j_1, completion);
    i.e7j_1 = $this$launch;
    return i;
  };
  function ScopeProvidersManager$populateScopesFor$slambda_0(this$0, $provider, $editable, resultContinuation) {
    var i = new ScopeProvidersManager$populateScopesFor$slambda(this$0, $provider, $editable, resultContinuation);
    var l = function ($this$launch, $completion) {
      return i.e1h($this$launch, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function ScopeProvidersManager$getScope$$inlined$suspendingQuery$1(this$0, $provider, $targetClass, $ruleBuilder) {
    this.f7i_1 = this$0;
    this.g7i_1 = $provider;
    this.h7i_1 = $targetClass;
    this.i7i_1 = $ruleBuilder;
  }
  protoOf(ScopeProvidersManager$getScope$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_19(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(ScopeProvidersManager$getScope$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function ScopeProvidersManager(rules, engine, coroutineContext) {
    Companion_getInstance_126();
    this.j7i_1 = engine;
    this.k7i_1 = 0;
    var tmp = this;
    tmp.l7i_1 = new ProvideScopeRulesContainer(filter(rules, ScopeProvidersManager$eagerRules$lambda));
    var tmp_0 = this;
    tmp_0.m7i_1 = new ProvideScopeRulesContainer(filter(rules, ScopeProvidersManager$perRequestRules$lambda));
    this.n7i_1 = CoroutineScope_0(coroutineContext.wi(Job_0(get_job(coroutineContext))));
    var tmp_1 = this;
    // Inline function 'kotlin.collections.hashMapOf' call
    tmp_1.o7i_1 = HashMap_init_$Create$();
  }
  protoOf(ScopeProvidersManager).j7j = function (provider, editable) {
    // Inline function 'kotlin.collections.contains' call
    // Inline function 'kotlin.collections.containsKey' call
    var this_0 = this.o7i_1;
    // Inline function 'kotlin.check' call
    if (!!(isInterface(this_0, KtMap) ? this_0 : THROW_CCE()).o2(provider)) {
      var message = 'Scopes for ' + toString_1(provider) + ' have already populated';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    var tmp = CoroutineStart_UNDISPATCHED_getInstance();
    launch(this.n7i_1, VOID, tmp, ScopeProvidersManager$populateScopesFor$slambda_0(this, provider, editable, null));
  };
  protoOf(ScopeProvidersManager).k7j = function (provider) {
    var container = this.o7i_1.u2(provider);
    $l$block: {
      // Inline function 'kotlin.checkNotNull' call
      if (container == null) {
        var message = 'Scopes for ' + toString_1(provider) + " haven't been populated";
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      } else {
        break $l$block;
      }
    }
    container.zr();
  };
  protoOf(ScopeProvidersManager).l7j = function (provider, targetClass, originSelector) {
    var providerClass = getKClassFromExpression(provider);
    // Inline function 'kotlin.check' call
    if (!this.m7j(providerClass, targetClass, originSelector)) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    var tmp;
    var tmp_0;
    // Inline function 'kotlin.collections.contains' call
    // Inline function 'kotlin.collections.containsKey' call
    var this_0 = this.o7i_1;
    if ((isInterface(this_0, KtMap) ? this_0 : THROW_CCE()).o2(provider)) {
      tmp_0 = hasEagerRuleFor(this, providerClass, targetClass, originSelector);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      var container = getValue_0(this.o7i_1, provider);
      tmp = container.s7i(new ProvidedScopeSpec(targetClass, originSelector));
    } else {
      // Inline function 'kotlin.checkNotNull' call
      var tmp0 = this.m7i_1.o7d(providerClass, targetClass, originSelector);
      var tmp$ret$4;
      $l$block: {
        // Inline function 'kotlin.checkNotNull' call
        if (tmp0 == null) {
          var message = 'Required value was null.';
          throw IllegalStateException_init_$Create$_0(toString_1(message));
        } else {
          tmp$ret$4 = tmp0;
          break $l$block;
        }
      }
      var rule = tmp$ret$4;
      // Inline function 'kotlin.check' call
      if (!rule.u78_1.equals(RuleEvaluationStrategy_PER_REQUEST_getInstance())) {
        throw IllegalStateException_init_$Create$_0('Check failed.');
      }
      var ruleBuilder = rule.w78_1;
      // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
      tmp = new ScopeProvidersManager$getScope$$inlined$suspendingQuery$1(this, provider, targetClass, ruleBuilder);
    }
    return tmp;
  };
  protoOf(ScopeProvidersManager).zr = function () {
    cancel(this.n7i_1);
  };
  protoOf(ScopeProvidersManager).m7j = function (providerConcept, targetConcept, selector) {
    return hasEagerRuleFor(this, providerConcept, targetConcept, selector) || hasPerRequestRuleFor(this, providerConcept, targetConcept, selector);
  };
  function Companion_127() {
    Companion_instance_127 = this;
    this.n7j_1 = NoScopeSpecificationContext_getInstance();
  }
  protoOf(Companion_127).g3b = function () {
    return this.n7j_1;
  };
  var Companion_instance_127;
  function Companion_getInstance_127() {
    if (Companion_instance_127 == null)
      new Companion_127();
    return Companion_instance_127;
  }
  function defaultScopeSpecification(_this__u8e3s4, targetConcept) {
    return new ScopeSpecification(_this__u8e3s4.g74(), new Default_1(ensureNotNull(targetConcept.ra())));
  }
  function providedScopeSpecification(_this__u8e3s4, selector, provider, targetConcept) {
    var tmp;
    var tmp_0;
    if (equals(selector, Lexical_getInstance())) {
      tmp_0 = true;
    } else {
      tmp_0 = selector instanceof LexicalWithRole;
    }
    if (tmp_0) {
      tmp = lexicalScopeSpecification(_this__u8e3s4, provider, targetConcept);
    } else {
      if (equals(selector, Import_getInstance())) {
        tmp = exportedScopeSpecification(_this__u8e3s4, provider, targetConcept);
      } else {
        var message = 'unknown specification: ' + toString_1(selector);
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      }
    }
    return tmp;
  }
  function lexicalScopeSpecification(_this__u8e3s4, provider, targetConcept) {
    return new ScopeSpecification(_this__u8e3s4.d74(provider), new Lexical_0(provider.m73_1, ensureNotNull(targetConcept.ra())));
  }
  function exportedScopeSpecification(_this__u8e3s4, provider, targetConcept) {
    return new ScopeSpecification(_this__u8e3s4.d74(provider), new Exported(provider.m73_1, ensureNotNull(targetConcept.ra())));
  }
  function collectionScopeSpecification(_this__u8e3s4, collection) {
    if (isInterface(collection, OtChildrenList)) {
      var node = collection.bp();
      return new ScopeSpecification(_this__u8e3s4.d74(Companion_instance_125.w7a(node)), new Children(node.z3n(), collection.l3p().a6h_1.q36_1));
    }
    var observableCollection = collection.m5y();
    if (observableCollection instanceof AnnotatedDocumentsList) {
      return new ScopeSpecification(_this__u8e3s4.g74(), new Collection_0(observableCollection.p7j_1));
    }
    return new ScopeSpecification(_this__u8e3s4.g74(), new Collection_0());
  }
  function $runSuspendCOROUTINE$_20(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.y7j_1 = _this__u8e3s4;
    this.z7j_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_20).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            var $this$suspendingQuery = this.z7j_1;
            this.f9_1 = 1;
            suspendResult = $this$suspendingQuery.k60(this.y7j_1.a7k_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp0_safe_receiver = suspendResult;
            var tmp_0;
            if (tmp0_safe_receiver == null) {
              tmp_0 = null;
            } else {
              tmp_0 = new LocatableScope(this.y7j_1.b7k_1, tmp0_safe_receiver);
            }

            return tmp_0;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function $runSuspendCOROUTINE$_21(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.k7k_1 = _this__u8e3s4;
    this.l7k_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_21).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            var $this$suspendingQuery = this.l7k_1;
            this.f9_1 = 1;
            suspendResult = $this$suspendingQuery.k60(this.k7k_1.m7k_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp0_safe_receiver = suspendResult;
            var tmp_0;
            if (tmp0_safe_receiver == null) {
              tmp_0 = null;
            } else {
              tmp_0 = new LocatableScope(this.k7k_1.n7k_1, tmp0_safe_receiver);
            }

            return tmp_0;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function $runSuspendCOROUTINE$_22(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.w7k_1 = _this__u8e3s4;
    this.x7k_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_22).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 4;
            this.z7k_1 = this.x7k_1;
            var tmp0_safe_receiver = this.w7k_1.b7l_1.b74_1;
            var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.h74(this.w7k_1.c7l_1, this.w7k_1.d7l_1);
            var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.c76(this.w7k_1.e7l_1);
            if (tmp2_safe_receiver == null) {
              this.a7l_1 = null;
              this.f9_1 = 2;
              continue $sm;
            } else {
              this.f9_1 = 1;
              suspendResult = this.z7k_1.k60(tmp2_safe_receiver, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            this.a7l_1 = suspendResult;
            this.f9_1 = 2;
            continue $sm;
          case 2:
            this.y7k_1 = this.a7l_1;
            this.f9_1 = 3;
            suspendResult = this.z7k_1.k60(this.w7k_1.b7l_1.z73_1.i7e(this.w7k_1.e7l_1, this.w7k_1.f7l_1, this.w7k_1.d7l_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            var ARGUMENT = suspendResult;
            var constraint = ensureNotNull(ARGUMENT);
            var tmp_0;
            if (!(this.y7k_1 == null)) {
              tmp_0 = combine(listOf_0([this.y7k_1, constraint]));
            } else {
              tmp_0 = constraint;
            }

            return tmp_0;
          case 4:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 4) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function sam$jetbrains_ocelot_langDef_scopes_config_api_ScopeConstraintProvider$0_0(function_0) {
    this.g7l_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_langDef_scopes_config_api_ScopeConstraintProvider$0_0).c76 = function (provider) {
    return this.g7l_1(provider);
  };
  protoOf(sam$jetbrains_ocelot_langDef_scopes_config_api_ScopeConstraintProvider$0_0).f3 = function () {
    return this.g7l_1;
  };
  protoOf(sam$jetbrains_ocelot_langDef_scopes_config_api_ScopeConstraintProvider$0_0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, ScopeConstraintProvider) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_langDef_scopes_config_api_ScopeConstraintProvider$0_0).hashCode = function () {
    return hashCode(this.f3());
  };
  function sam$jetbrains_ocelot_base_disposable_Disposable$0_3(function_0) {
    this.h7l_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0_3).zr = function () {
    return this.h7l_1();
  };
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0_3).f3 = function () {
    return this.h7l_1;
  };
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0_3).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Disposable) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0_3).hashCode = function () {
    return hashCode(this.f3());
  };
  function sam$jetbrains_ocelot_langDef_scopes_config_api_ScopeProvidersRegistry$0(function_0) {
    this.i7l_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_langDef_scopes_config_api_ScopeProvidersRegistry$0).f3 = function () {
    return this.i7l_1;
  };
  protoOf(sam$jetbrains_ocelot_langDef_scopes_config_api_ScopeProvidersRegistry$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, ScopeProvidersRegistry) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_langDef_scopes_config_api_ScopeProvidersRegistry$0).hashCode = function () {
    return hashCode(this.f3());
  };
  function ScopingRulesEngine$_init_$lambda_c1plh9(it) {
    return null;
  }
  function ScopingRulesEngine$scopeProviders$lambda(it) {
    return it instanceof ProvideScope;
  }
  function ScopingRulesEngine$defaultScopes$lambda(it) {
    return it instanceof DefaultScope;
  }
  function ScopingRulesEngine$scopeConstraints$lambda(it) {
    return it instanceof ConstrainScope;
  }
  function ScopingRulesEngine$nameProviders$lambda(it) {
    return it instanceof ProvideName;
  }
  function ScopingRulesEngine$getDefaultScope$$inlined$mapSuspending$1($this, $scope) {
    this.a7k_1 = $this;
    this.b7k_1 = $scope;
  }
  protoOf(ScopingRulesEngine$getDefaultScope$$inlined$mapSuspending$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_20(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(ScopingRulesEngine$getDefaultScope$$inlined$mapSuspending$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function ScopingRulesEngine$getDocumentScope$$inlined$map$1($this, $scope) {
    this.j7l_1 = $this;
    this.k7l_1 = $scope;
  }
  protoOf(ScopingRulesEngine$getDocumentScope$$inlined$map$1).n5w = function (builder) {
    var tmp0_safe_receiver = builder.l60(this.j7l_1);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp = new LocatableScope(this.k7l_1, tmp0_safe_receiver);
    }
    return tmp;
  };
  function ScopingRulesEngine$getDocumentScope$$inlined$map$2($this, $scope) {
    this.m7k_1 = $this;
    this.n7k_1 = $scope;
  }
  protoOf(ScopingRulesEngine$getDocumentScope$$inlined$map$2).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_21(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(ScopingRulesEngine$getDocumentScope$$inlined$map$2).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function ScopingRulesEngine$getScopeConstraint$2$$inlined$suspendingQuery$1(this$0, $providerConcept, $scopeConstraintId, $provider, $o) {
    this.b7l_1 = this$0;
    this.c7l_1 = $providerConcept;
    this.d7l_1 = $scopeConstraintId;
    this.e7l_1 = $provider;
    this.f7l_1 = $o;
  }
  protoOf(ScopingRulesEngine$getScopeConstraint$2$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_22(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(ScopingRulesEngine$getScopeConstraint$2$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function ScopingRulesEngine$getScopeConstraint$lambda(this$0, $providerConcept, $scopeConstraintId, $o) {
    return function (provider) {
      // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
      return new ScopingRulesEngine$getScopeConstraint$2$$inlined$suspendingQuery$1(this$0, $providerConcept, $scopeConstraintId, provider, $o);
    };
  }
  function ScopingRulesEngine$providersRegistry$lambda$lambda(this$0, $provider) {
    return function () {
      this$0.x73_1.k7j($provider);
      return Unit_instance;
    };
  }
  function ScopingRulesEngine$providersRegistry$lambda(this$0) {
    return function (provider, editable) {
      this$0.x73_1.j7j(provider, editable);
      var tmp = ScopingRulesEngine$providersRegistry$lambda$lambda(this$0, provider);
      return new sam$jetbrains_ocelot_base_disposable_Disposable$0_3(tmp);
    };
  }
  function ScopingRulesEngine(rules, scopeFactories, coroutineContext, scopeSpecificationContext, dbScopes, sharedScopes, fallbackRulesBuilder) {
    sharedScopes = sharedScopes === VOID ? null : sharedScopes;
    var tmp;
    if (fallbackRulesBuilder === VOID) {
      tmp = ScopingRulesEngine$_init_$lambda_c1plh9;
    } else {
      tmp = fallbackRulesBuilder;
    }
    fallbackRulesBuilder = tmp;
    this.t73_1 = scopeSpecificationContext;
    this.u73_1 = scopeFactories;
    this.v73_1 = dbScopes;
    this.w73_1 = sharedScopes;
    var tmp_0 = this;
    // Inline function 'kotlin.sequences.filterIsInstance' call
    var tmp_1 = filter(rules, ScopingRulesEngine$scopeProviders$lambda);
    var tmp$ret$0 = isInterface(tmp_1, Sequence) ? tmp_1 : THROW_CCE();
    tmp_0.x73_1 = new ScopeProvidersManager(tmp$ret$0, this, coroutineContext);
    var tmp_2 = this;
    // Inline function 'kotlin.sequences.filterIsInstance' call
    var tmp_3 = filter(rules, ScopingRulesEngine$defaultScopes$lambda);
    var tmp$ret$1 = isInterface(tmp_3, Sequence) ? tmp_3 : THROW_CCE();
    tmp_2.y73_1 = new DefaultScopesManager(tmp$ret$1, this);
    var tmp_4 = this;
    // Inline function 'kotlin.sequences.filterIsInstance' call
    var tmp_5 = filter(rules, ScopingRulesEngine$scopeConstraints$lambda);
    var tmp$ret$2 = isInterface(tmp_5, Sequence) ? tmp_5 : THROW_CCE();
    tmp_4.z73_1 = new ScopeConstraintsManager(tmp$ret$2);
    var tmp_6 = this;
    // Inline function 'kotlin.sequences.filterIsInstance' call
    var tmp_7 = filter(rules, ScopingRulesEngine$nameProviders$lambda);
    var tmp$ret$3 = isInterface(tmp_7, Sequence) ? tmp_7 : THROW_CCE();
    tmp_6.a74_1 = new NameProvidersManager(tmp$ret$3);
    this.b74_1 = fallbackRulesBuilder(this);
    var tmp_8 = this;
    var tmp_9 = ScopingRulesEngine$providersRegistry$lambda(this);
    tmp_8.c74_1 = new sam$jetbrains_ocelot_langDef_scopes_config_api_ScopeProvidersRegistry$0(tmp_9);
  }
  protoOf(ScopingRulesEngine).f74 = function (targetConcept) {
    var scope = defaultScopeSpecification(this, targetConcept);
    var resultQuery = this.y73_1.s7a(targetConcept) ? this.y73_1.r7a(targetConcept) : !(this.b74_1 == null) ? this.b74_1.f74(targetConcept) : Companion_getInstance_81().g60_1;
    // Inline function 'jetbrains.ocelot.langDef.query.mapSuspending' call
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new ScopingRulesEngine$getDefaultScope$$inlined$mapSuspending$1(resultQuery, scope);
  };
  protoOf(ScopingRulesEngine).l73 = function (provider, originSelector, targetConcept) {
    var scope = providedScopeSpecification(this, originSelector, provider, targetConcept);
    var resultQuery = this.x73_1.m7j(provider.o73_1, targetConcept, originSelector) ? this.x73_1.l7j(provider.p73_1(), targetConcept, originSelector) : !(this.b74_1 == null) ? this.b74_1.l73(provider, originSelector, targetConcept) : Companion_getInstance_81().g60_1;
    // Inline function 'jetbrains.ocelot.langDef.query.map' call
    var tmp;
    if (isInterface(resultQuery, Query)) {
      // Inline function 'jetbrains.ocelot.langDef.query.map' call
      // Inline function 'jetbrains.ocelot.langDef.query.query' call
      tmp = new ScopingRulesEngine$getDocumentScope$$inlined$map$1(resultQuery, scope);
    } else {
      // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
      tmp = new ScopingRulesEngine$getDocumentScope$$inlined$map$2(resultQuery, scope);
    }
    return tmp;
  };
  protoOf(ScopingRulesEngine).h7d = function (providerConcept, origin, scopeConstraintId) {
    var o = this.z73_1.j7e(providerConcept, origin, scopeConstraintId);
    var tmp;
    if (!(o == null)) {
      var tmp_0 = ScopingRulesEngine$getScopeConstraint$lambda(this, providerConcept, scopeConstraintId, o);
      tmp = new sam$jetbrains_ocelot_langDef_scopes_config_api_ScopeConstraintProvider$0_0(tmp_0);
    } else {
      var tmp0_safe_receiver = this.b74_1;
      tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.h74(providerConcept, scopeConstraintId);
    }
    return tmp;
  };
  protoOf(ScopingRulesEngine).u7a = function (declaration) {
    return this.a74_1.u7a(declaration);
  };
  protoOf(ScopingRulesEngine).e74 = function (targetClass, strategy, owner, location) {
    var scope = new RuleEvaluationScope(strategy, this.w73_1);
    return new ScopeContextImpl(scope, this.l7l(owner), targetClass, location);
  };
  protoOf(ScopingRulesEngine).m7g = function (strategy) {
    return getValue_0(this.u73_1, strategy);
  };
  protoOf(ScopingRulesEngine).l7l = function (origin) {
    return new ScopingRulesEngineRemoteAdapter(this.v73_1, this, origin);
  };
  protoOf(ScopingRulesEngine).g74 = function () {
    return this.t73_1.g74();
  };
  protoOf(ScopingRulesEngine).d74 = function (location) {
    return this.t73_1.d74(location);
  };
  function ScopingRulesEngineRemoteAdapter(dbScopes, original, owner) {
    this.m7l_1 = dbScopes;
    this.n7l_1 = original;
    this.o7l_1 = owner;
  }
  protoOf(ScopingRulesEngineRemoteAdapter).l73 = function (provider, originSelector, targetConcept) {
    var scope = providedScopeSpecification(this.n7l_1, originSelector, provider, targetConcept);
    if (!equals(this.o7l_1, scope.p7l_1)) {
      return this.m7l_1.a7a(scope, targetConcept);
    }
    return this.n7l_1.l73(provider, originSelector, targetConcept);
  };
  protoOf(ScopingRulesEngineRemoteAdapter).f74 = function (targetConcept) {
    var scope = defaultScopeSpecification(this.n7l_1, targetConcept);
    if (!equals(scope.p7l_1, this.o7l_1)) {
      return this.m7l_1.a7a(scope, targetConcept);
    }
    return this.n7l_1.f74(targetConcept);
  };
  protoOf(ScopingRulesEngineRemoteAdapter).u7a = function (declaration) {
    return this.n7l_1.u7a(declaration);
  };
  protoOf(ScopingRulesEngineRemoteAdapter).m7g = function (strategy) {
    return this.n7l_1.m7g(strategy);
  };
  protoOf(ScopingRulesEngineRemoteAdapter).l7l = function (origin) {
    return this.n7l_1.l7l(origin);
  };
  protoOf(ScopingRulesEngineRemoteAdapter).h7d = function (providerConcept, origin, scopeConstraintId) {
    return this.n7l_1.h7d(providerConcept, origin, scopeConstraintId);
  };
  protoOf(ScopingRulesEngineRemoteAdapter).g74 = function () {
    return this.n7l_1.g74();
  };
  protoOf(ScopingRulesEngineRemoteAdapter).d74 = function (location) {
    return this.n7l_1.d74(location);
  };
  function AnnotatedDocumentsList(role, delegate) {
    this.o7j_1 = delegate;
    this.p7j_1 = role;
  }
  protoOf(AnnotatedDocumentsList).s = function () {
    return this.o7j_1.s();
  };
  protoOf(AnnotatedDocumentsList).bg = function (element) {
    return this.o7j_1.t(element);
  };
  protoOf(AnnotatedDocumentsList).t = function (element) {
    if (!(element == null ? true : !(element == null)))
      return false;
    return this.bg((element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  protoOf(AnnotatedDocumentsList).m = function () {
    return this.o7j_1.m();
  };
  protoOf(AnnotatedDocumentsList).cg = function (elements) {
    return this.o7j_1.e2(elements);
  };
  protoOf(AnnotatedDocumentsList).e2 = function (elements) {
    return this.cg(elements);
  };
  protoOf(AnnotatedDocumentsList).r = function (index) {
    return this.o7j_1.r(index);
  };
  protoOf(AnnotatedDocumentsList).r7l = function (element) {
    return this.o7j_1.w(element);
  };
  protoOf(AnnotatedDocumentsList).w = function (element) {
    if (!(element == null ? true : !(element == null)))
      return -1;
    return this.r7l((element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  protoOf(AnnotatedDocumentsList).s7l = function (element) {
    return this.o7j_1.v(element);
  };
  protoOf(AnnotatedDocumentsList).v = function (element) {
    if (!(element == null ? true : !(element == null)))
      return -1;
    return this.s7l((element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  protoOf(AnnotatedDocumentsList).f2 = function () {
    return this.o7j_1.f2();
  };
  protoOf(AnnotatedDocumentsList).u = function (index) {
    return this.o7j_1.u(index);
  };
  protoOf(AnnotatedDocumentsList).g2 = function (fromIndex, toIndex) {
    return this.o7j_1.g2(fromIndex, toIndex);
  };
  protoOf(AnnotatedDocumentsList).asJsReadonlyArrayView = function () {
    return this.o7j_1.asJsReadonlyArrayView();
  };
  protoOf(AnnotatedDocumentsList).p = function () {
    return this.o7j_1.p();
  };
  protoOf(AnnotatedDocumentsList).t7l = function (listener) {
    return this.o7j_1.x2r(listener);
  };
  protoOf(AnnotatedDocumentsList).x2r = function (listener) {
    return this.t7l(listener);
  };
  protoOf(AnnotatedDocumentsList).u7l = function (handler) {
    return this.o7j_1.y2r(handler);
  };
  protoOf(AnnotatedDocumentsList).y2r = function (handler) {
    return this.u7l(handler);
  };
  protoOf(AnnotatedDocumentsList).v7l = function (handler) {
    return this.o7j_1.z2r(handler);
  };
  protoOf(AnnotatedDocumentsList).z2r = function (handler) {
    return this.v7l(handler);
  };
  function CollectionScope$getElements$slambda(this$0, $filter, resultContinuation) {
    this.e7m_1 = this$0;
    this.f7m_1 = $filter;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CollectionScope$getElements$slambda).k7m = function ($this$flow, $completion) {
    var tmp = this.l7m($this$flow, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(CollectionScope$getElements$slambda).v9 = function (p1, $completion) {
    return this.k7m((!(p1 == null) ? isInterface(p1, FlowCollector) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CollectionScope$getElements$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 7;
            this.j7m_1 = this.e7m_1.m7m_1.m5y().m();
            this.f9_1 = 1;
            continue $sm;
          case 1:
            if (!this.j7m_1.n()) {
              this.f9_1 = 6;
              continue $sm;
            }

            this.h7m_1 = this.j7m_1.o();
            this.f9_1 = 2;
            suspendResult = execute_1(this.e7m_1.n7m_1(this.h7m_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var presentation = suspendResult;
            var tmp0 = presentation.h72();
            var destination = ArrayList_init_$Create$();
            var _iterator__ex2g4s = tmp0.m();
            while (_iterator__ex2g4s.n()) {
              var element = _iterator__ex2g4s.o();
              var tmp_0;
              if (!isBlank(element)) {
                tmp_0 = this.f7m_1.m6r(element);
              } else {
                tmp_0 = false;
              }
              if (tmp_0) {
                destination.j(element);
              }
            }

            this.i7m_1 = destination.m();
            this.f9_1 = 3;
            continue $sm;
          case 3:
            if (!this.i7m_1.n()) {
              this.f9_1 = 5;
              continue $sm;
            }

            var element_0 = this.i7m_1.o();
            this.f9_1 = 4;
            suspendResult = this.g7m_1.x18(new NamedNode(element_0, this.h7m_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            this.f9_1 = 3;
            continue $sm;
          case 5:
            this.f9_1 = 1;
            continue $sm;
          case 6:
            return Unit_instance;
          case 7:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 7) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(CollectionScope$getElements$slambda).l7m = function ($this$flow, completion) {
    var i = new CollectionScope$getElements$slambda(this.e7m_1, this.f7m_1, completion);
    i.g7m_1 = $this$flow;
    return i;
  };
  function CollectionScope$getElements$slambda_0(this$0, $filter, resultContinuation) {
    var i = new CollectionScope$getElements$slambda(this$0, $filter, resultContinuation);
    var l = function ($this$flow, $completion) {
      return i.k7m($this$flow, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function CollectionScope$scopeTree$delegate$lambda($specification, this$0) {
    return function () {
      return new ScopeTree(listOf(new ScopeContent($specification, this$0)));
    };
  }
  function CollectionScope(specification, collection, present) {
    this.m7m_1 = collection;
    this.n7m_1 = present;
    var tmp = this;
    tmp.o7m_1 = lazy(CollectionScope$scopeTree$delegate$lambda(specification, this));
  }
  protoOf(CollectionScope).p7m = function (target) {
    return this.m7m_1.t(target);
  };
  protoOf(CollectionScope).p72 = function (target) {
    return this.p7m(!(target == null) ? target : THROW_CCE());
  };
  protoOf(CollectionScope).q72 = function (filter) {
    return flow(CollectionScope$getElements$slambda_0(this, filter, null));
  };
  function $runSuspendCOROUTINE$_23(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.y7m_1 = _this__u8e3s4;
    this.z7m_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_23).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 7;
            var tmp_0 = this;
            tmp_0.d7n_1 = this.z7m_1;
            this.a7n_1 = Unit_instance;
            this.f9_1 = 1;
            continue $sm;
          case 1:
            this.b7n_1 = this.d7n_1;
            this.c7n_1 = this.y7m_1.f7n_1.e7n_1.m();
            this.f9_1 = 2;
            continue $sm;
          case 2:
            if (!this.c7n_1.n()) {
              this.f9_1 = 5;
              continue $sm;
            }

            var scope = this.c7n_1.o();
            this.f9_1 = 3;
            suspendResult = this.b7n_1.k60(scope.o72(this.y7m_1.g7n_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            var result = suspendResult;
            if (!(result == null)) {
              this.a7n_1 = result;
              this.f9_1 = 6;
              continue $sm;
            } else {
              this.f9_1 = 4;
              continue $sm;
            }

          case 4:
            this.f9_1 = 2;
            continue $sm;
          case 5:
            this.a7n_1 = null;
            if (false) {
              this.f9_1 = 1;
              continue $sm;
            }

            this.f9_1 = 6;
            continue $sm;
          case 6:
            return this.a7n_1;
          case 7:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 7) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function $runSuspendCOROUTINE$_24(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.p7n_1 = _this__u8e3s4;
    this.q7n_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_24).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 7;
            var tmp_0 = this;
            tmp_0.u7n_1 = this.q7n_1;
            this.r7n_1 = Unit_instance;
            this.f9_1 = 1;
            continue $sm;
          case 1:
            this.s7n_1 = this.u7n_1;
            this.t7n_1 = this.p7n_1.v7n_1.e7n_1.m();
            this.f9_1 = 2;
            continue $sm;
          case 2:
            if (!this.t7n_1.n()) {
              this.f9_1 = 5;
              continue $sm;
            }

            var scope = this.t7n_1.o();
            this.f9_1 = 3;
            suspendResult = this.s7n_1.k60(scope.p72(this.p7n_1.w7n_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            if (suspendResult) {
              this.r7n_1 = true;
              this.f9_1 = 6;
              continue $sm;
            } else {
              this.f9_1 = 4;
              continue $sm;
            }

          case 4:
            this.f9_1 = 2;
            continue $sm;
          case 5:
            this.r7n_1 = false;
            if (false) {
              this.f9_1 = 1;
              continue $sm;
            }

            this.f9_1 = 6;
            continue $sm;
          case 6:
            return this.r7n_1;
          case 7:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 7) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function CompositeScope$find$$inlined$suspendingQuery$1(this$0, $pointer) {
    this.f7n_1 = this$0;
    this.g7n_1 = $pointer;
  }
  protoOf(CompositeScope$find$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_23(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(CompositeScope$find$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function CompositeScope$contains$$inlined$suspendingQuery$1(this$0, $target) {
    this.v7n_1 = this$0;
    this.w7n_1 = $target;
  }
  protoOf(CompositeScope$contains$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_24(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(CompositeScope$contains$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function CompositeScope$getElements$slambda($filter, resultContinuation) {
    this.f7o_1 = $filter;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CompositeScope$getElements$slambda).h7o = function (it, $completion) {
    var tmp = this.i7o(it, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(CompositeScope$getElements$slambda).v9 = function (p1, $completion) {
    return this.h7o((!(p1 == null) ? isInterface(p1, Scope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CompositeScope$getElements$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        if (tmp === 0) {
          this.g9_1 = 1;
          return this.g7o_1.q72(this.f7o_1);
        } else if (tmp === 1) {
          throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(CompositeScope$getElements$slambda).i7o = function (it, completion) {
    var i = new CompositeScope$getElements$slambda(this.f7o_1, completion);
    i.g7o_1 = it;
    return i;
  };
  function CompositeScope$getElements$slambda_0($filter, resultContinuation) {
    var i = new CompositeScope$getElements$slambda($filter, resultContinuation);
    var l = function (it, $completion) {
      return i.h7o(it, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function CompositeScope(scopes) {
    this.e7n_1 = scopes;
  }
  protoOf(CompositeScope).o72 = function (pointer) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new CompositeScope$find$$inlined$suspendingQuery$1(this, pointer);
  };
  protoOf(CompositeScope).j7o = function (target) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new CompositeScope$contains$$inlined$suspendingQuery$1(this, target);
  };
  protoOf(CompositeScope).p72 = function (target) {
    return this.j7o(!(target == null) ? target : THROW_CCE());
  };
  protoOf(CompositeScope).q72 = function (filter) {
    var tmp = asFlow_0(this.e7n_1);
    return flatMapConcat(tmp, CompositeScope$getElements$slambda_0(filter, null));
  };
  protoOf(CompositeScope).k7o = function (filter) {
    var tmp;
    if (filter instanceof NoopScopeFilter) {
      tmp = this;
    } else {
      // Inline function 'kotlin.collections.map' call
      var this_0 = this.e7n_1;
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
      var _iterator__ex2g4s = this_0.m();
      while (_iterator__ex2g4s.n()) {
        var item = _iterator__ex2g4s.o();
        var tmp$ret$0 = item.r72(filter);
        destination.j(tmp$ret$0);
      }
      tmp = new CompositeScope(destination);
    }
    return tmp;
  };
  protoOf(CompositeScope).r72 = function (filter) {
    return this.k7o(filter);
  };
  function DelegatingScope(scope) {
    this.l7o_1 = scope;
  }
  protoOf(DelegatingScope).o72 = function (pointer) {
    return this.l7o_1.o72(pointer);
  };
  protoOf(DelegatingScope).p72 = function (target) {
    return this.l7o_1.p72(target);
  };
  protoOf(DelegatingScope).q72 = function (filter) {
    return this.l7o_1.q72(filter);
  };
  function EmptyScope() {
  }
  protoOf(EmptyScope).p72 = function (target) {
    return Companion_getInstance_81().h60_1;
  };
  protoOf(EmptyScope).q72 = function (filter) {
    return emptyFlow();
  };
  protoOf(EmptyScope).r72 = function (filter) {
    return this;
  };
  function filter_0(_this__u8e3s4, condition) {
    var tmp = filter$lambda(condition);
    return _this__u8e3s4.r72(new sam$jetbrains_ocelot_langDef_scopes_api_ScopeFilter$0_1(tmp));
  }
  function filter_1(_this__u8e3s4, condition) {
    return _this__u8e3s4.r72(condition);
  }
  function $runSuspendCOROUTINE$_25(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.u7o_1 = _this__u8e3s4;
    this.v7o_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_25).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 5;
            var $this$suspendingQuery = this.v7o_1;
            var tmp_0 = this;
            tmp_0.z7o_1 = $this$suspendingQuery;
            this.f9_1 = 1;
            suspendResult = $this$suspendingQuery.k60(this.u7o_1.a7p_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp2 = suspendResult;
            var $this$flatMap = this.z7o_1;
            this.x7o_1 = tmp2;
            if (!(this.x7o_1 == null)) {
              this.f9_1 = 2;
              suspendResult = $this$flatMap.k60(this.u7o_1.b7p_1.e7p_1.j71(this.x7o_1), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.y7o_1 = false;
              this.f9_1 = 3;
              continue $sm;
            }

          case 2:
            this.y7o_1 = suspendResult;
            this.f9_1 = 3;
            continue $sm;
          case 3:
            if (this.y7o_1) {
              this.w7o_1 = this.x7o_1;
              this.f9_1 = 4;
              continue $sm;
            } else {
              this.w7o_1 = null;
              this.f9_1 = 4;
              continue $sm;
            }

          case 4:
            return this.w7o_1;
          case 5:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 5) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function $runSuspendCOROUTINE$_26(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.n7p_1 = _this__u8e3s4;
    this.o7p_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_26).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 4;
            this.q7p_1 = this.o7p_1;
            this.f9_1 = 1;
            suspendResult = this.q7p_1.k60(protoOf(DelegatingScope).p72.call(this.n7p_1.r7p_1, this.n7p_1.s7p_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            if (suspendResult) {
              this.f9_1 = 2;
              suspendResult = this.q7p_1.k60(this.n7p_1.r7p_1.e7p_1.j71(this.n7p_1.s7p_1), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.p7p_1 = false;
              this.f9_1 = 3;
              continue $sm;
            }

          case 2:
            this.p7p_1 = suspendResult;
            this.f9_1 = 3;
            continue $sm;
          case 3:
            return this.p7p_1;
          case 4:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 4) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function FilteredScope$getElements$o$collect$slambda($$this$unsafeFlow, this$0, resultContinuation) {
    this.b7q_1 = $$this$unsafeFlow;
    this.c7q_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(FilteredScope$getElements$o$collect$slambda).f1q = function (value, $completion) {
    var tmp = this.g1q(value, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(FilteredScope$getElements$o$collect$slambda).v9 = function (p1, $completion) {
    return this.f1q((p1 == null ? true : !(p1 == null)) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(FilteredScope$getElements$o$collect$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 6;
            var tmp_0 = this;
            tmp_0.h7q_1 = this.b7q_1;
            var tmp_1 = this;
            tmp_1.g7q_1 = this.d7q_1;
            this.f9_1 = 1;
            continue $sm;
          case 1:
            this.f7q_1 = this.h7q_1;
            this.e7q_1 = this.g7q_1;
            var it = this.e7q_1;
            this.f9_1 = 2;
            suspendResult = execute_1(this.c7q_1.e7p_1.j71(it.j72_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            if (suspendResult) {
              this.f9_1 = 4;
              suspendResult = this.f7q_1.x18(this.e7q_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.f9_1 = 3;
              continue $sm;
            }

          case 3:
            if (false) {
              this.f9_1 = 1;
              continue $sm;
            }

            this.f9_1 = 5;
            continue $sm;
          case 4:
            this.f9_1 = 5;
            continue $sm;
          case 5:
            return Unit_instance;
          case 6:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 6) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(FilteredScope$getElements$o$collect$slambda).g1q = function (value, completion) {
    var i = new FilteredScope$getElements$o$collect$slambda(this.b7q_1, this.c7q_1, completion);
    i.d7q_1 = value;
    return i;
  };
  function FilteredScope$getElements$o$collect$slambda_0($$this$unsafeFlow, this$0, resultContinuation) {
    var i = new FilteredScope$getElements$o$collect$slambda($$this$unsafeFlow, this$0, resultContinuation);
    var l = function (value, $completion) {
      return i.f1q(value, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function $collectCOROUTINE$_14(_this__u8e3s4, collector, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.q7q_1 = _this__u8e3s4;
    this.r7q_1 = collector;
  }
  protoOf($collectCOROUTINE$_14).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            var $this$unsafeFlow = this.r7q_1;
            this.f9_1 = 1;
            var tmp_0 = FilteredScope$getElements$o$collect$slambda_0($this$unsafeFlow, this.q7q_1.t7q_1, null);
            suspendResult = this.q7q_1.s7q_1.f18(new sam$kotlinx_coroutines_flow_FlowCollector$0_7(tmp_0), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function sam$kotlinx_coroutines_flow_FlowCollector$0_7(function_0) {
    this.u7q_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_7).x18 = function (value, $completion) {
    return this.u7q_1(value, $completion);
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_7).f3 = function () {
    return this.u7q_1;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_7).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, FlowCollector) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_7).hashCode = function () {
    return hashCode(this.f3());
  };
  function FilteredScope$find$$inlined$flatMap$1($this, this$0) {
    this.a7p_1 = $this;
    this.b7p_1 = this$0;
  }
  protoOf(FilteredScope$find$$inlined$flatMap$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_25(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(FilteredScope$find$$inlined$flatMap$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function FilteredScope$contains$$inlined$suspendingQuery$1(this$0, $target) {
    this.r7p_1 = this$0;
    this.s7p_1 = $target;
  }
  protoOf(FilteredScope$contains$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_26(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(FilteredScope$contains$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function FilteredScope$getElements$$inlined$filter$1($this, this$0) {
    this.s7q_1 = $this;
    this.t7q_1 = this$0;
  }
  protoOf(FilteredScope$getElements$$inlined$filter$1).y18 = function (collector, $completion) {
    var tmp = new $collectCOROUTINE$_14(this, collector, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(FilteredScope$getElements$$inlined$filter$1).f18 = function (collector, $completion) {
    return this.y18(collector, $completion);
  };
  function FilteredScope(base, condition) {
    DelegatingScope.call(this, base);
    this.d7p_1 = base;
    this.e7p_1 = condition;
  }
  protoOf(FilteredScope).o72 = function (pointer) {
    // Inline function 'jetbrains.ocelot.langDef.query.flatMap' call
    var this_0 = protoOf(DelegatingScope).o72.call(this, pointer);
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new FilteredScope$find$$inlined$flatMap$1(this_0, this);
  };
  protoOf(FilteredScope).p72 = function (target) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new FilteredScope$contains$$inlined$suspendingQuery$1(this, target);
  };
  protoOf(FilteredScope).q72 = function (filter) {
    // Inline function 'kotlinx.coroutines.flow.filter' call
    // Inline function 'kotlinx.coroutines.flow.unsafeTransform' call
    var this_0 = protoOf(DelegatingScope).q72.call(this, filter);
    // Inline function 'kotlinx.coroutines.flow.internal.unsafeFlow' call
    return new FilteredScope$getElements$$inlined$filter$1(this_0, this);
  };
  function sam$jetbrains_ocelot_langDef_scopes_api_ScopeFilter$0_1(function_0) {
    this.v7q_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_langDef_scopes_api_ScopeFilter$0_1).j71 = function (target) {
    return this.v7q_1(target);
  };
  protoOf(sam$jetbrains_ocelot_langDef_scopes_api_ScopeFilter$0_1).f3 = function () {
    return this.v7q_1;
  };
  protoOf(sam$jetbrains_ocelot_langDef_scopes_api_ScopeFilter$0_1).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, ScopeFilter) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_langDef_scopes_api_ScopeFilter$0_1).hashCode = function () {
    return hashCode(this.f3());
  };
  function $runSuspendCOROUTINE$_27(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.e7r_1 = _this__u8e3s4;
    this.f7r_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_27).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            var $this$suspendingQuery = this.f7r_1;
            this.f9_1 = 1;
            suspendResult = this.e7r_1.g7r_1($this$suspendingQuery, this.e7r_1.h7r_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function filter$2$$inlined$suspendingQuery$1($condition, $it) {
    this.g7r_1 = $condition;
    this.h7r_1 = $it;
  }
  protoOf(filter$2$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_27(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(filter$2$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function filter$lambda($condition) {
    return function (it) {
      // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
      return new filter$2$$inlined$suspendingQuery$1($condition, it);
    };
  }
  function get_LOG() {
    _init_properties_IndexingScope_kt__inhlv6();
    return LOG;
  }
  var LOG;
  function Companion_128() {
    Companion_instance_128 = this;
    this.i7r_1 = newAtomicLong(0n);
  }
  var Companion_instance_128;
  function Companion_getInstance_128() {
    if (Companion_instance_128 == null)
      new Companion_128();
    return Companion_instance_128;
  }
  function IndexingScope$depend$o$runSuspend$lambda($triggered) {
    return function (_unused_var__etf5q3, _unused_var__etf5q3_0, _unused_var__etf5q3_1) {
      $triggered.d2x(true);
      return Unit_instance;
    };
  }
  function $runSuspendCOROUTINE$_28(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.r7r_1 = _this__u8e3s4;
    this.s7r_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_28).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.t7r_1 = this.s7r_1;
            this.f9_1 = 1;
            suspendResult = awaitValue_0(this.r7r_1.b7s_1.y7r_1, 0, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            if (this.r7r_1.b7s_1.u7r_1) {
              var triggered = new ValueProperty(false);
              depend(this.t7r_1.q5w_1.o5w_1, triggered);
              var tmp_0 = IndexingScope$depend$o$runSuspend$lambda(triggered);
              this.t7r_1.q5w_1.o5w_1.y5v(this.r7r_1.b7s_1.x7r_1.j2s(new sam$jetbrains_ocelot_langDef_scopes_helper_ScopeListenerAdapter$0(tmp_0)));
            }

            return Unit_instance;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function $runSuspendCOROUTINE$_29(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.k7s_1 = _this__u8e3s4;
    this.l7s_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_29).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            var $this$suspendingQuery = this.l7s_1;
            this.f9_1 = 1;
            suspendResult = $this$suspendingQuery.k60(this.k7s_1.m7s_1.z7r_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp0 = this.k7s_1.m7s_1.w7r_1;
            var key = this.k7s_1.n7s_1;
            return (isInterface(tmp0, KtMap) ? tmp0 : THROW_CCE()).o2(key);
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function recordTreeSet($this) {
    var tmp = IndexingScope$recordTreeSet$lambda;
    // Inline function 'kotlin.comparisons.thenBy' call
    var this_0 = new sam$kotlin_Comparator$0_1(tmp);
    var tmp_0 = IndexingScope$recordTreeSet$lambda_0(this_0);
    // Inline function 'kotlin.comparisons.thenBy' call
    var this_1 = new sam$kotlin_Comparator$0_1(tmp_0);
    var tmp_1 = IndexingScope$recordTreeSet$lambda_1(this_1);
    // Inline function 'kotlin.comparisons.thenBy' call
    var this_2 = new sam$kotlin_Comparator$0_1(tmp_1);
    var tmp_2 = IndexingScope$recordTreeSet$lambda_2(this_2, $this);
    var tmp$ret$2 = new sam$kotlin_Comparator$0_1(tmp_2);
    return newTreeSet(tmp$ret$2);
  }
  function removeItem0($this, item) {
    var records = getValue_0($this.w7r_1, item).o7s_1;
    var _iterator__ex2g4s = records.m();
    while (_iterator__ex2g4s.n()) {
      var record = _iterator__ex2g4s.o();
      var _iterator__ex2g4s_0 = record.r7s_1.l6r().m();
      while (_iterator__ex2g4s_0.n()) {
        var token = _iterator__ex2g4s_0.o();
        // Inline function 'kotlin.let' call
        var elements = getValue_0($this.v7r_1, token);
        elements.h2(record);
        if (elements.s()) {
          $this.v7r_1.u2(token);
        }
      }
    }
    $this.w7r_1.u2(item);
  }
  function asNamedNode($this, _this__u8e3s4) {
    return new NamedNode(_this__u8e3s4.r7s_1.j6r_1, _this__u8e3s4.q7s_1);
  }
  function ItemData(records) {
    Companion_getInstance_128();
    this.o7s_1 = records;
    this.p7s_1 = Companion_getInstance_128().i7r_1.w2o();
  }
  function ItemRecord(item, name) {
    this.q7s_1 = item;
    this.r7s_1 = name;
  }
  protoOf(ItemRecord).toString = function () {
    return 'ItemRecord(item=' + toString_0(this.q7s_1) + ', name=' + this.r7s_1.toString() + ')';
  };
  protoOf(ItemRecord).hashCode = function () {
    var result = this.q7s_1 == null ? 0 : hashCode(this.q7s_1);
    result = imul(result, 31) + this.r7s_1.hashCode() | 0;
    return result;
  };
  protoOf(ItemRecord).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ItemRecord))
      return false;
    if (!equals(this.q7s_1, other.q7s_1))
      return false;
    if (!this.r7s_1.equals(other.r7s_1))
      return false;
    return true;
  };
  function sam$kotlin_Comparator$0_0(function_0) {
    this.s7s_1 = function_0;
  }
  protoOf(sam$kotlin_Comparator$0_0).zd = function (a, b) {
    return this.s7s_1(a, b);
  };
  protoOf(sam$kotlin_Comparator$0_0).compare = function (a, b) {
    return this.zd(a, b);
  };
  protoOf(sam$kotlin_Comparator$0_0).f3 = function () {
    return this.s7s_1;
  };
  protoOf(sam$kotlin_Comparator$0_0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Comparator) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlin_Comparator$0_0).hashCode = function () {
    return hashCode(this.f3());
  };
  function sam$kotlin_Comparator$0_1(function_0) {
    this.t7s_1 = function_0;
  }
  protoOf(sam$kotlin_Comparator$0_1).zd = function (a, b) {
    return this.t7s_1(a, b);
  };
  protoOf(sam$kotlin_Comparator$0_1).compare = function (a, b) {
    return this.zd(a, b);
  };
  protoOf(sam$kotlin_Comparator$0_1).f3 = function () {
    return this.t7s_1;
  };
  protoOf(sam$kotlin_Comparator$0_1).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Comparator) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlin_Comparator$0_1).hashCode = function () {
    return hashCode(this.f3());
  };
  function sam$jetbrains_ocelot_langDef_scopes_helper_ScopeListenerAdapter$0(function_0) {
    this.u7s_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_langDef_scopes_helper_ScopeListenerAdapter$0).v7s = function (target, eventType, namingInfo) {
    return this.u7s_1(target, eventType, namingInfo);
  };
  protoOf(sam$jetbrains_ocelot_langDef_scopes_helper_ScopeListenerAdapter$0).f3 = function () {
    return this.u7s_1;
  };
  protoOf(sam$jetbrains_ocelot_langDef_scopes_helper_ScopeListenerAdapter$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, ScopeListenerAdapter) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_langDef_scopes_helper_ScopeListenerAdapter$0).hashCode = function () {
    return hashCode(this.f3());
  };
  function IndexingScope$elementsIndex$lambda(a, b) {
    return compareTo_1(a, b, true);
  }
  function IndexingScope$insertItem$lambda($item, $presentation) {
    return function (it) {
      it.x7s($item, $presentation);
      return Unit_instance;
    };
  }
  function IndexingScope$insertItem$lambda_0($item, $presentation) {
    return function (it) {
      it.w7s($item, $presentation);
      return Unit_instance;
    };
  }
  function IndexingScope$recordTreeSet$lambda(left, right) {
    // Inline function 'kotlin.comparisons.compareValuesBy' call
    var comparator = get_CASE_INSENSITIVE_ORDER(StringCompanionObject_instance);
    var tmp = left.r7s_1.j6r_1;
    var tmp$ret$1 = right.r7s_1.j6r_1;
    return comparator.compare(tmp, tmp$ret$1);
  }
  function IndexingScope$recordTreeSet$lambda_0($this) {
    return function (a, b) {
      var previousCompare = $this.compare(a, b);
      var tmp;
      if (!(previousCompare === 0)) {
        tmp = previousCompare;
      } else {
        // Inline function 'kotlin.comparisons.compareValuesBy' call
        var tmp_0 = a.r7s_1.j6r_1;
        var tmp$ret$1 = b.r7s_1.j6r_1;
        tmp = compareValues(tmp_0, tmp$ret$1);
      }
      return tmp;
    };
  }
  function IndexingScope$recordTreeSet$lambda_1($this) {
    return function (a, b) {
      var previousCompare = $this.compare(a, b);
      var tmp;
      if (!(previousCompare === 0)) {
        tmp = previousCompare;
      } else {
        // Inline function 'kotlin.comparisons.compareValuesBy' call
        var tmp_0 = hashCode(a.q7s_1);
        var tmp$ret$1 = hashCode(b.q7s_1);
        tmp = compareValues(tmp_0, tmp$ret$1);
      }
      return tmp;
    };
  }
  function IndexingScope$recordTreeSet$lambda_2($this, this$0) {
    return function (a, b) {
      var previousCompare = $this.compare(a, b);
      var tmp;
      if (!(previousCompare === 0)) {
        tmp = previousCompare;
      } else {
        // Inline function 'kotlin.comparisons.compareValuesBy' call
        var tmp_0 = getValue_0(this$0.w7r_1, a.q7s_1).p7s_1;
        var tmp$ret$1 = getValue_0(this$0.w7r_1, b.q7s_1).p7s_1;
        tmp = compareValues(tmp_0, tmp$ret$1);
      }
      return tmp;
    };
  }
  function IndexingScope$removeItem$lambda($item) {
    return function (it) {
      it.y7s($item);
      return Unit_instance;
    };
  }
  function IndexingScope$depend$$inlined$suspendingQuery$1(this$0) {
    this.b7s_1 = this$0;
  }
  protoOf(IndexingScope$depend$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_28(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(IndexingScope$depend$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function IndexingScope$contains$$inlined$suspendingQuery$1(this$0, $target) {
    this.m7s_1 = this$0;
    this.n7s_1 = $target;
  }
  protoOf(IndexingScope$contains$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_29(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(IndexingScope$contains$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function IndexingScope$getElements$slambda(this$0, $filter, resultContinuation) {
    this.h7t_1 = this$0;
    this.i7t_1 = $filter;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(IndexingScope$getElements$slambda).k7m = function ($this$flow, $completion) {
    var tmp = this.l7m($this$flow, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(IndexingScope$getElements$slambda).v9 = function (p1, $completion) {
    return this.k7m((!(p1 == null) ? isInterface(p1, FlowCollector) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(IndexingScope$getElements$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 12;
            this.f9_1 = 1;
            suspendResult = execute_1(this.h7t_1.z7r_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp_0 = this;
            tmp_0.n7t_1 = LinkedHashSet_init_$Create$();
            var tmp_1 = this;
            tmp_1.k7t_1 = LinkedHashSet_init_$Create$();
            this.m7t_1 = this.i7t_1.h6r_1 ? this.i7t_1.o6r(VOID, VOID, false) : null;
            var patternTokens = this.i7t_1.f6r_1.l6r();
            var tmp_2 = this;
            var tmp$ret$0;
            l$ret$1: do {
              var iterator = patternTokens.m();
              if (!iterator.n()) {
                tmp$ret$0 = null;
                break l$ret$1;
              }
              var maxElem = iterator.o();
              if (!iterator.n()) {
                tmp$ret$0 = maxElem;
                break l$ret$1;
              }
              var maxValue = maxElem.length;
              do {
                var e = iterator.o();
                var v = e.length;
                if (compareTo_0(maxValue, v) < 0) {
                  maxElem = e;
                  maxValue = v;
                }
              }
               while (iterator.n());
              tmp$ret$0 = maxElem;
            }
             while (false);
            var tmp0_elvis_lhs = tmp$ret$0;
            tmp_2.q7t_1 = tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
            var tmp_3 = this;
            tmp_3.r7t_1 = this.h7t_1.v7r_1.p2o(this.q7t_1).y().m();
            this.f9_1 = 2;
            continue $sm;
          case 2:
            if (!this.r7t_1.n()) {
              this.f9_1 = 10;
              continue $sm;
            }

            var _destruct__k2r9zo = this.r7t_1.o();
            var token = _destruct__k2r9zo.z();
            var tmp_4 = this;
            tmp_4.p7t_1 = _destruct__k2r9zo.a1();
            if (!startsWith(token, this.q7t_1, true)) {
              this.f9_1 = 10;
              continue $sm;
            } else {
              this.f9_1 = 3;
              continue $sm;
            }

          case 3:
            this.o7t_1 = this.p7t_1.m();
            this.f9_1 = 4;
            continue $sm;
          case 4:
            if (!this.o7t_1.n()) {
              this.f9_1 = 9;
              continue $sm;
            }

            this.l7t_1 = this.o7t_1.o();
            if (this.n7t_1.t(this.l7t_1)) {
              this.f9_1 = 4;
              continue $sm;
            } else {
              this.f9_1 = 5;
              continue $sm;
            }

          case 5:
            if (!this.i7t_1.i6r(this.l7t_1.r7s_1)) {
              this.f9_1 = 4;
              continue $sm;
            } else {
              this.f9_1 = 6;
              continue $sm;
            }

          case 6:
            var tmp0 = this.n7t_1;
            var element = this.l7t_1;
            tmp0.j(element);
            if (this.m7t_1 == null || this.m7t_1.i6r(this.l7t_1.r7s_1)) {
              this.f9_1 = 7;
              suspendResult = this.j7t_1.x18(asNamedNode(this.h7t_1, this.l7t_1), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              var tmp0_0 = this.k7t_1;
              var element_0 = this.l7t_1;
              tmp0_0.j(element_0);
              this.f9_1 = 8;
              continue $sm;
            }

          case 7:
            this.f9_1 = 8;
            continue $sm;
          case 8:
            this.f9_1 = 4;
            continue $sm;
          case 9:
            this.f9_1 = 2;
            continue $sm;
          case 10:
            this.f9_1 = 11;
            var this_0 = this.k7t_1;
            var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
            var _iterator__ex2g4s = this_0.m();
            while (_iterator__ex2g4s.n()) {
              var item = _iterator__ex2g4s.o();
              destination.j(asNamedNode(this.h7t_1, item));
            }

            suspendResult = emitAll_0(this.j7t_1, asFlow_0(destination), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 11:
            return Unit_instance;
          case 12:
            throw this.i9_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.g9_1 === 12) {
          throw e_0;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(IndexingScope$getElements$slambda).l7m = function ($this$flow, completion) {
    var i = new IndexingScope$getElements$slambda(this.h7t_1, this.i7t_1, completion);
    i.j7t_1 = $this$flow;
    return i;
  };
  function IndexingScope$getElements$slambda_0(this$0, $filter, resultContinuation) {
    var i = new IndexingScope$getElements$slambda(this$0, $filter, resultContinuation);
    var l = function ($this$flow, $completion) {
      return i.k7m($this$flow, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function IndexingScope$scopeTree$delegate$lambda($specification, this$0) {
    return function () {
      return new ScopeTree(listOf(new ScopeContent($specification, this$0)));
    };
  }
  function IndexingScope(specification, followChanges, initialCapacity) {
    initialCapacity = initialCapacity === VOID ? 12 : initialCapacity;
    this.u7r_1 = followChanges;
    var tmp = this;
    var tmp_0 = IndexingScope$elementsIndex$lambda;
    tmp.v7r_1 = newTreeMap(new sam$kotlin_Comparator$0_0(tmp_0));
    this.w7r_1 = HashMap_init_$Create$_0(capacity(initialCapacity));
    this.x7r_1 = new Listeners();
    this.y7r_1 = new ValueProperty(0);
    var tmp_1 = this;
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    tmp_1.z7r_1 = new IndexingScope$depend$$inlined$suspendingQuery$1(this);
    var tmp_2 = this;
    tmp_2.a7s_1 = lazy(IndexingScope$scopeTree$delegate$lambda(specification, this));
  }
  protoOf(IndexingScope).s7t = function (item, presentation) {
    // Inline function 'kotlin.collections.contains' call
    // Inline function 'kotlin.collections.containsKey' call
    var this_0 = this.w7r_1;
    var itemRenamed = (isInterface(this_0, KtMap) ? this_0 : THROW_CCE()).o2(item);
    // Inline function 'kotlin.collections.map' call
    var this_1 = presentation.h72();
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_1, 10));
    var _iterator__ex2g4s = this_1.m();
    while (_iterator__ex2g4s.n()) {
      var item_0 = _iterator__ex2g4s.o();
      var tmp$ret$2 = new ItemRecord(item, get_tokenized(item_0));
      destination.j(tmp$ret$2);
    }
    var records = destination;
    if (itemRenamed) {
      if (equals(getValue_0(this.w7r_1, item).o7s_1, records)) {
        return Unit_instance;
      }
      removeItem0(this, item);
    }
    var tmp0 = this.w7r_1;
    // Inline function 'kotlin.collections.set' call
    var value = new ItemData(records);
    tmp0.t2(item, value);
    var _iterator__ex2g4s_0 = records.m();
    while (_iterator__ex2g4s_0.n()) {
      var record = _iterator__ex2g4s_0.o();
      var _iterator__ex2g4s_1 = record.r7s_1.l6r().m();
      while (_iterator__ex2g4s_1.n()) {
        var token = _iterator__ex2g4s_1.o();
        // Inline function 'kotlin.collections.getOrPut' call
        var this_2 = this.v7r_1;
        var value_0 = this_2.q2(token);
        var tmp;
        if (value_0 == null) {
          var answer = recordTreeSet(this);
          this_2.t2(token, answer);
          tmp = answer;
        } else {
          tmp = value_0;
        }
        tmp.j(record);
      }
    }
    if (itemRenamed) {
      this.x7r_1.k2s(IndexingScope$insertItem$lambda(item, presentation));
    } else {
      this.x7r_1.k2s(IndexingScope$insertItem$lambda_0(item, presentation));
    }
  };
  protoOf(IndexingScope).t7t = function (item) {
    removeItem0(this, item);
    this.x7r_1.k2s(IndexingScope$removeItem$lambda(item));
  };
  protoOf(IndexingScope).b4s = function () {
    this.y7r_1.d2x(this.y7r_1.uv() + 1 | 0);
  };
  protoOf(IndexingScope).u7t = function () {
    this.y7r_1.d2x(this.y7r_1.uv() - 1 | 0);
  };
  protoOf(IndexingScope).p7m = function (target) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new IndexingScope$contains$$inlined$suspendingQuery$1(this, target);
  };
  protoOf(IndexingScope).p72 = function (target) {
    return this.p7m(!(target == null) ? target : THROW_CCE());
  };
  protoOf(IndexingScope).q72 = function (filter) {
    return flow(IndexingScope$getElements$slambda_0(this, filter, null));
  };
  function IndexingCollectionScope(_this__u8e3s4, specification, collection, present, $completion) {
    var tmp = new $IndexingCollectionScopeCOROUTINE$(_this__u8e3s4, specification, collection, present, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  }
  function capacity(initialCapacity) {
    _init_properties_IndexingScope_kt__inhlv6();
    return numberToInt(initialCapacity / 0.75);
  }
  function IndexingCollectionScope$insertItem(scope, $present, followChanges, $this_IndexingCollectionScope, nameProperties, $specification, item, $completion) {
    var tmp = new $IndexingCollectionScope$insertItemCOROUTINE$(scope, $present, followChanges, $this_IndexingCollectionScope, nameProperties, $specification, item, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  }
  function IndexingCollectionScope$insertItem$handleQueryResult(scope, $item, $specification, result) {
    if (!(result instanceof Ready)) {
      return Unit_instance;
    }
    var outcome = result.t5w_1;
    if (outcome instanceof Success) {
      scope.s7t($item, outcome.u5w_1);
    } else {
      if (outcome instanceof Failure_0) {
        var tmp = get_LOG();
        tmp.e2q(outcome.v5w_1, IndexingCollectionScope$insertItem$handleQueryResult$lambda($specification, $item));
      } else {
        noWhenBranchMatchedException();
      }
    }
  }
  function IndexingCollectionScope$removeItem(followChanges, nameProperties, scope, item) {
    if (followChanges) {
      getValue_0(nameProperties, item).zr();
    }
    scope.t7t(item);
  }
  function IndexingCollectionScope$populateScope(scope, $specification, followChanges, $present, $this_IndexingCollectionScope, nameProperties, initialItems, $completion) {
    var tmp = new $IndexingCollectionScope$populateScopeCOROUTINE$(scope, $specification, followChanges, $present, $this_IndexingCollectionScope, nameProperties, initialItems, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  }
  function LOG$lambda() {
    _init_properties_IndexingScope_kt__inhlv6();
    return Unit_instance;
  }
  function IndexingCollectionScope$lambda($scope) {
    return function (it) {
      $scope.u7t();
      return Unit_instance;
    };
  }
  function IndexingCollectionScope$lambda_0($events) {
    return function (it) {
      $events.i16();
      return Unit_instance;
    };
  }
  function IndexingCollectionScope$lambda_1($scope, $events) {
    return function (it) {
      $scope.b4s();
      // Inline function 'kotlin.check' call
      if (!_ChannelResult___get_isSuccess__impl__odq1z9($events.a16(it))) {
        throw IllegalStateException_init_$Create$_0('Check failed.');
      }
      return Unit_instance;
    };
  }
  function IndexingCollectionScope$slambda($itemsChangeHandler, $events, $scope, $present, $followChanges, $this_IndexingCollectionScope, $nameProperties, $specification, resultContinuation) {
    this.c7w_1 = $itemsChangeHandler;
    this.d7w_1 = $events;
    this.e7w_1 = $scope;
    this.f7w_1 = $present;
    this.g7w_1 = $followChanges;
    this.h7w_1 = $this_IndexingCollectionScope;
    this.i7w_1 = $nameProperties;
    this.j7w_1 = $specification;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(IndexingCollectionScope$slambda).e1h = function ($this$launch, $completion) {
    var tmp = this.f1h($this$launch, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(IndexingCollectionScope$slambda).v9 = function (p1, $completion) {
    return this.e1h((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(IndexingCollectionScope$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 16;
            var tmp_0 = this;
            tmp_0.o7w_1 = this.c7w_1;
            this.f9_1 = 1;
            continue $sm;
          case 1:
            this.l7w_1 = this.o7w_1;
            this.f9_1 = 2;
            continue $sm;
          case 2:
            this.f9_1 = 3;
            continue $sm;
          case 3:
            this.g9_1 = 15;
            this.l7w_1;
            this.n7w_1 = this.d7w_1.m();
            this.f9_1 = 4;
            continue $sm;
          case 4:
            this.f9_1 = 5;
            suspendResult = this.n7w_1.d14(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 5:
            if (!suspendResult) {
              this.f9_1 = 11;
              continue $sm;
            }

            this.m7w_1 = this.n7w_1.o();
            this.f9_1 = 6;
            continue $sm;
          case 6:
            this.g9_1 = 10;
            if (!this.m7w_1.r2r_1.equals(EventType_REMOVE_getInstance())) {
              this.f9_1 = 7;
              suspendResult = IndexingCollectionScope$insertItem(this.e7w_1, this.f7w_1, this.g7w_1, this.h7w_1, this.i7w_1, this.j7w_1, this.m7w_1.u2r(), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.f9_1 = 8;
              continue $sm;
            }

          case 7:
            this.f9_1 = 8;
            continue $sm;
          case 8:
            var tmp_1;
            if (!this.m7w_1.r2r_1.equals(EventType_ADD_getInstance())) {
              IndexingCollectionScope$removeItem(this.g7w_1, this.i7w_1, this.e7w_1, this.m7w_1.s2r());
              tmp_1 = Unit_instance;
            }

            this.f9_1 = 9;
            continue $sm;
          case 9:
            this.g9_1 = 15;
            this.e7w_1.u7t();
            this.f9_1 = 4;
            continue $sm;
          case 10:
            this.g9_1 = 15;
            var t = this.i9_1;
            this.e7w_1.u7t();
            throw t;
          case 11:
            this.g9_1 = 16;
            this.f9_1 = 12;
            var tmp_2 = this;
            continue $sm;
          case 12:
            this.g9_1 = 16;
            this.l7w_1.zr();
            this.f9_1 = 14;
            continue $sm;
          case 13:
            this.g9_1 = 16;
            this.l7w_1.zr();
            if (false) {
              this.f9_1 = 1;
              continue $sm;
            }

            this.f9_1 = 14;
            continue $sm;
          case 14:
            return Unit_instance;
          case 15:
            this.g9_1 = 16;
            var t_0 = this.i9_1;
            this.l7w_1.zr();
            throw t_0;
          case 16:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 16) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(IndexingCollectionScope$slambda).f1h = function ($this$launch, completion) {
    var i = new IndexingCollectionScope$slambda(this.c7w_1, this.d7w_1, this.e7w_1, this.f7w_1, this.g7w_1, this.h7w_1, this.i7w_1, this.j7w_1, completion);
    i.k7w_1 = $this$launch;
    return i;
  };
  function IndexingCollectionScope$slambda_0($itemsChangeHandler, $events, $scope, $present, $followChanges, $this_IndexingCollectionScope, $nameProperties, $specification, resultContinuation) {
    var i = new IndexingCollectionScope$slambda($itemsChangeHandler, $events, $scope, $present, $followChanges, $this_IndexingCollectionScope, $nameProperties, $specification, resultContinuation);
    var l = function ($this$launch, $completion) {
      return i.e1h($this$launch, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function IndexingCollectionScope$insertItem$lambda($scope, $item, $specification) {
    return function (event) {
      IndexingCollectionScope$insertItem$handleQueryResult($scope, $item, $specification, event.t2y_1);
      return Unit_instance;
    };
  }
  function IndexingCollectionScope$insertItem$handleQueryResult$lambda($specification, $item) {
    return function () {
      return "Item's name calculation thrown exception, setting it to null, scope " + $specification.toString() + ', item ' + toString_1($item);
    };
  }
  function IndexingCollectionScope$populateScope$lambda($specification, $initialItems, $followChanges) {
    return function () {
      return 'Scope index population started, scope ' + $specification.toString() + ', size: ' + $initialItems.p() + ', follow changes: ' + $followChanges;
    };
  }
  function IndexingCollectionScope$populateScope$lambda_0($specification, $time) {
    return function () {
      return 'Scope index population finished, scope ' + $specification.toString() + ', time: ' + Duration__toString_impl_8d916b_0($time, DurationUnit_SECONDS_getInstance(), 2) + ' seconds';
    };
  }
  function $IndexingCollectionScopeCOROUTINE$(_this__u8e3s4, specification, collection, present, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.d7u_1 = _this__u8e3s4;
    this.e7u_1 = specification;
    this.f7u_1 = collection;
    this.g7u_1 = present;
  }
  protoOf($IndexingCollectionScopeCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 4;
            this.k7u_1 = this.d7u_1.q5w_1.s5w();
            this.h7u_1 = new IndexingScope(this.e7u_1, this.k7u_1, execute_0(this.f7u_1.p()));
            var items = this.f7u_1.m5y();
            var tmp_0 = this;
            tmp_0.j7u_1 = HashMap_init_$Create$();
            if (this.k7u_1) {
              var tmp_1 = this;
              tmp_1.l7u_1 = Channel(2147483647, VOID, IndexingCollectionScope$lambda(this.h7u_1));
              var tmp_2 = get_job(this.d7u_1.q5w_1.p5w_1.ho());
              tmp_2.kp(IndexingCollectionScope$lambda_0(this.l7u_1));
              var tmp_3 = this;
              tmp_3.m7u_1 = items.z2r(IndexingCollectionScope$lambda_1(this.h7u_1, this.l7u_1));
              this.f9_1 = 2;
              suspendResult = IndexingCollectionScope$populateScope(this.h7u_1, this.e7u_1, this.k7u_1, this.g7u_1, this.d7u_1, this.j7u_1, ArrayList_init_$Create$_1(items), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.f9_1 = 1;
              suspendResult = IndexingCollectionScope$populateScope(this.h7u_1, this.e7u_1, this.k7u_1, this.g7u_1, this.d7u_1, this.j7u_1, ArrayList_init_$Create$_1(items), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            var tmp_4 = this;
            tmp_4.i7u_1 = Unit_instance;
            this.f9_1 = 3;
            continue $sm;
          case 2:
            var tmp_5 = this;
            tmp_5.i7u_1 = launch(this.d7u_1.q5w_1.p5w_1, VOID, VOID, IndexingCollectionScope$slambda_0(this.m7u_1, this.l7u_1, this.h7u_1, this.g7u_1, this.k7u_1, this.d7u_1, this.j7u_1, this.e7u_1, null));
            this.f9_1 = 3;
            continue $sm;
          case 3:
            return this.h7u_1;
          case 4:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 4) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function $IndexingCollectionScope$insertItemCOROUTINE$(scope, $present, followChanges, $this_IndexingCollectionScope, nameProperties, $specification, item, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.v7u_1 = scope;
    this.w7u_1 = $present;
    this.x7u_1 = followChanges;
    this.y7u_1 = $this_IndexingCollectionScope;
    this.z7u_1 = nameProperties;
    this.a7v_1 = $specification;
    this.b7v_1 = item;
  }
  protoOf($IndexingCollectionScope$insertItemCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = execute_1(this.w7u_1(this.b7v_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            this.v7u_1.s7t(this.b7v_1, ARGUMENT);
            if (this.x7u_1) {
              var loopingQuery = new LoopingQuery(this.y7u_1.q5w_1.p5w_1.ho(), this.w7u_1(this.b7v_1));
              var tmp0 = this.z7u_1;
              var tmp2 = this.b7v_1;
              var value = loopingQuery.z2r(IndexingCollectionScope$insertItem$lambda(this.v7u_1, this.b7v_1, this.a7v_1));
              tmp0.t2(tmp2, value);
            }

            return Unit_instance;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function $IndexingCollectionScope$populateScopeCOROUTINE$(scope, $specification, followChanges, $present, $this_IndexingCollectionScope, nameProperties, initialItems, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.k7v_1 = scope;
    this.l7v_1 = $specification;
    this.m7v_1 = followChanges;
    this.n7v_1 = $present;
    this.o7v_1 = $this_IndexingCollectionScope;
    this.p7v_1 = nameProperties;
    this.q7v_1 = initialItems;
  }
  protoOf($IndexingCollectionScope$populateScopeCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 7;
            this.k7v_1.b4s();
            var tmp_0 = get_LOG();
            tmp_0.a2q(IndexingCollectionScope$populateScope$lambda(this.l7v_1, this.q7v_1, this.m7v_1));
            this.f9_1 = 1;
            continue $sm;
          case 1:
            this.g9_1 = 6;
            this.s7v_1 = Monotonic_instance.je();
            this.t7v_1 = this.q7v_1.m();
            this.f9_1 = 2;
            continue $sm;
          case 2:
            if (!this.t7v_1.n()) {
              this.f9_1 = 4;
              continue $sm;
            }

            var item = this.t7v_1.o();
            this.f9_1 = 3;
            suspendResult = IndexingCollectionScope$insertItem(this.k7v_1, this.n7v_1, this.m7v_1, this.o7v_1, this.p7v_1, this.l7v_1, item, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            this.f9_1 = 2;
            continue $sm;
          case 4:
            this.r7v_1 = ValueTimeMark__elapsedNow_impl_eonqvs(this.s7v_1);
            this.g9_1 = 7;
            this.f9_1 = 5;
            continue $sm;
          case 5:
            var tmp_1 = this.r7v_1;
            this.g9_1 = 7;
            this.k7v_1.u7t();
            var time = tmp_1;
            var tmp_2 = get_LOG();
            tmp_2.a2q(IndexingCollectionScope$populateScope$lambda_0(this.l7v_1, time));
            return Unit_instance;
          case 6:
            this.g9_1 = 7;
            var t = this.i9_1;
            this.k7v_1.u7t();
            throw t;
          case 7:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 7) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  var properties_initialized_IndexingScope_kt_pkg5po;
  function _init_properties_IndexingScope_kt__inhlv6() {
    if (!properties_initialized_IndexingScope_kt_pkg5po) {
      properties_initialized_IndexingScope_kt_pkg5po = true;
      var tmp = KotlinLogging_getInstance();
      LOG = tmp.i2q(LOG$lambda);
    }
  }
  function LocatableScope(specification, body) {
    DelegatingScope.call(this, body);
    this.q7w_1 = specification;
    this.r7w_1 = body;
    this.s7w_1 = new ScopeTree(listOf(new ScopeContent(this.q7w_1)));
  }
  function ScopeListenerAdapter() {
  }
  function Scopes() {
    Scopes_instance = this;
    this.z77_1 = new EmptyScope();
  }
  protoOf(Scopes).u7b = function () {
    return this.z77_1;
  };
  var Scopes_instance;
  function Scopes_getInstance() {
    if (Scopes_instance == null)
      new Scopes();
    return Scopes_instance;
  }
  function $runSuspendCOROUTINE$_30(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.b7x_1 = _this__u8e3s4;
    this.c7x_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_30).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 3;
            this.e7x_1 = this.c7x_1;
            this.f9_1 = 1;
            suspendResult = this.e7x_1.k60(this.b7x_1.h7x_1.f7x_1.o72(this.b7x_1.i7x_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.d7x_1 = suspendResult;
            this.f9_1 = 2;
            suspendResult = this.e7x_1.k60(this.b7x_1.h7x_1.g7x_1.o72(this.b7x_1.i7x_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var secondResolveResult = suspendResult;
            var tmp_0;
            if (this.d7x_1 == null) {
              tmp_0 = secondResolveResult;
            } else {
              tmp_0 = secondResolveResult == null ? this.d7x_1 : null;
            }

            return tmp_0;
          case 3:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 3) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function $runSuspendCOROUTINE$_31(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.r7x_1 = _this__u8e3s4;
    this.s7x_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_31).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 3;
            this.u7x_1 = this.s7x_1;
            this.f9_1 = 1;
            suspendResult = this.u7x_1.k60(this.r7x_1.v7x_1.f7x_1.p72(this.r7x_1.w7x_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.t7x_1 = suspendResult;
            this.f9_1 = 2;
            suspendResult = this.u7x_1.k60(this.r7x_1.v7x_1.g7x_1.p72(this.r7x_1.w7x_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var ARGUMENT = suspendResult;
            return !(this.t7x_1 === ARGUMENT);
          case 3:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 3) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function UniqueSumScope$find$$inlined$suspendingQuery$1(this$0, $pointer) {
    this.h7x_1 = this$0;
    this.i7x_1 = $pointer;
  }
  protoOf(UniqueSumScope$find$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_30(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(UniqueSumScope$find$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function UniqueSumScope$contains$$inlined$suspendingQuery$1(this$0, $target) {
    this.v7x_1 = this$0;
    this.w7x_1 = $target;
  }
  protoOf(UniqueSumScope$contains$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_31(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(UniqueSumScope$contains$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function UniqueSumScope$getElements$slambda(this$0, $filter, resultContinuation) {
    this.f7y_1 = this$0;
    this.g7y_1 = $filter;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(UniqueSumScope$getElements$slambda).i7y = function ($this$flow, $completion) {
    var tmp = this.j7y($this$flow, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(UniqueSumScope$getElements$slambda).v9 = function (p1, $completion) {
    return this.i7y((!(p1 == null) ? isInterface(p1, FlowCollector) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(UniqueSumScope$getElements$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 3;
            this.f9_1 = 1;
            suspendResult = emitAll_0(this.h7y_1, this.f7y_1.f7x_1.q72(this.g7y_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.f9_1 = 2;
            suspendResult = emitAll_0(this.h7y_1, this.f7y_1.g7x_1.q72(this.g7y_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 3) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(UniqueSumScope$getElements$slambda).j7y = function ($this$flow, completion) {
    var i = new UniqueSumScope$getElements$slambda(this.f7y_1, this.g7y_1, completion);
    i.h7y_1 = $this$flow;
    return i;
  };
  function UniqueSumScope$getElements$slambda_0(this$0, $filter, resultContinuation) {
    var i = new UniqueSumScope$getElements$slambda(this$0, $filter, resultContinuation);
    var l = function ($this$flow, $completion) {
      return i.i7y($this$flow, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function UniqueSumScope(firstScope, secondScope) {
    this.f7x_1 = firstScope;
    this.g7x_1 = secondScope;
  }
  protoOf(UniqueSumScope).o72 = function (pointer) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new UniqueSumScope$find$$inlined$suspendingQuery$1(this, pointer);
  };
  protoOf(UniqueSumScope).j7o = function (target) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new UniqueSumScope$contains$$inlined$suspendingQuery$1(this, target);
  };
  protoOf(UniqueSumScope).p72 = function (target) {
    return this.j7o(!(target == null) ? target : THROW_CCE());
  };
  protoOf(UniqueSumScope).q72 = function (filter) {
    return flow(UniqueSumScope$getElements$slambda_0(this, filter, null));
  };
  protoOf(UniqueSumScope).k7o = function (filter) {
    var tmp;
    if (filter instanceof NoopScopeFilter) {
      tmp = this;
    } else {
      tmp = new UniqueSumScope(this.f7x_1.r72(filter), this.g7x_1.r72(filter));
    }
    return tmp;
  };
  protoOf(UniqueSumScope).r72 = function (filter) {
    return this.k7o(filter);
  };
  function parentChildScopes($this, source) {
    var tmp = Companion_instance_125;
    return new ParentChildScopes($this.l7y_1.l7l($this.l7y_1.d74(tmp.w7a(isInterface(source, DomainNode) ? source : THROW_CCE()))), $this.k7y_1.w6l_1);
  }
  function AbstractScopedReferenceResolver(refTag, scopeConfig) {
    this.k7y_1 = refTag;
    this.l7y_1 = scopeConfig;
  }
  protoOf(AbstractScopedReferenceResolver).m7y = function (_this__u8e3s4, source, $completion) {
    return _this__u8e3s4.k60(parentChildScopes(this, source).x7b(source), $completion);
  };
  function AbstractScopedReferenceTargetsSupplier$getElements$slambda$o$runSuspend$slambda$slambda($this_flow, this$0, $$this$executeSuspendingQuery, resultContinuation) {
    this.v7y_1 = $this_flow;
    this.w7y_1 = this$0;
    this.x7y_1 = $$this$executeSuspendingQuery;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(AbstractScopedReferenceTargetsSupplier$getElements$slambda$o$runSuspend$slambda$slambda).f1q = function (value, $completion) {
    var tmp = this.g1q(value, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(AbstractScopedReferenceTargetsSupplier$getElements$slambda$o$runSuspend$slambda$slambda).v9 = function (p1, $completion) {
    return this.f1q((p1 == null ? true : !(p1 == null)) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(AbstractScopedReferenceTargetsSupplier$getElements$slambda$o$runSuspend$slambda$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 6;
            var tmp0 = this.v7y_1;
            var tmp2 = this.y7y_1;
            this.c7z_1 = tmp0;
            this.z7y_1 = tmp2.fg();
            this.b7z_1 = tmp2.gg();
            var tmp_0 = this.b7z_1;
            if (isInterface(tmp_0, TargetInfoStub)) {
              this.f9_1 = 4;
              var tmp_1 = this.b7z_1.g7z();
              suspendResult = this.c7z_1.x18(tmp_1 instanceof TargetInfo ? tmp_1 : THROW_CCE(), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.f9_1 = 1;
              suspendResult = execute_1(this.w7y_1.f7z(this.b7z_1), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            this.a7z_1 = suspendResult;
            this.f9_1 = 2;
            suspendResult = this.x7y_1.k60(this.w7y_1.e7z_1.u7a(this.b7z_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var namesData = suspendResult;
            this.f9_1 = 3;
            suspendResult = this.c7z_1.x18(new TargetInfo(this.b7z_1, this.a7z_1, this.z7y_1, namesData.g72_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            this.f9_1 = 5;
            continue $sm;
          case 4:
            this.f9_1 = 5;
            continue $sm;
          case 5:
            return Unit_instance;
          case 6:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 6) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(AbstractScopedReferenceTargetsSupplier$getElements$slambda$o$runSuspend$slambda$slambda).g1q = function (value, completion) {
    var i = new AbstractScopedReferenceTargetsSupplier$getElements$slambda$o$runSuspend$slambda$slambda(this.v7y_1, this.w7y_1, this.x7y_1, completion);
    i.y7y_1 = value;
    return i;
  };
  function AbstractScopedReferenceTargetsSupplier$getElements$slambda$o$runSuspend$slambda$slambda_0($this_flow, this$0, $$this$executeSuspendingQuery, resultContinuation) {
    var i = new AbstractScopedReferenceTargetsSupplier$getElements$slambda$o$runSuspend$slambda$slambda($this_flow, this$0, $$this$executeSuspendingQuery, resultContinuation);
    var l = function (value, $completion) {
      return i.f1q(value, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function AbstractScopedReferenceTargetsSupplier$getElements$slambda$o$runSuspend$slambda($this, this$0, $$this$executeSuspendingQuery, resultContinuation) {
    this.p7z_1 = $this;
    this.q7z_1 = this$0;
    this.r7z_1 = $$this$executeSuspendingQuery;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(AbstractScopedReferenceTargetsSupplier$getElements$slambda$o$runSuspend$slambda).t7z = function ($this$flow, $completion) {
    var tmp = this.u7z($this$flow, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(AbstractScopedReferenceTargetsSupplier$getElements$slambda$o$runSuspend$slambda).v9 = function (p1, $completion) {
    return this.t7z((!(p1 == null) ? isInterface(p1, FlowCollector) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(AbstractScopedReferenceTargetsSupplier$getElements$slambda$o$runSuspend$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            var tmp_0 = AbstractScopedReferenceTargetsSupplier$getElements$slambda$o$runSuspend$slambda$slambda_0(this.s7z_1, this.q7z_1, this.r7z_1, null);
            suspendResult = this.p7z_1.f18(new sam$kotlinx_coroutines_flow_FlowCollector$0_8(tmp_0), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(AbstractScopedReferenceTargetsSupplier$getElements$slambda$o$runSuspend$slambda).u7z = function ($this$flow, completion) {
    var i = new AbstractScopedReferenceTargetsSupplier$getElements$slambda$o$runSuspend$slambda(this.p7z_1, this.q7z_1, this.r7z_1, completion);
    i.s7z_1 = $this$flow;
    return i;
  };
  function AbstractScopedReferenceTargetsSupplier$getElements$slambda$o$runSuspend$slambda_0($this, this$0, $$this$executeSuspendingQuery, resultContinuation) {
    var i = new AbstractScopedReferenceTargetsSupplier$getElements$slambda$o$runSuspend$slambda($this, this$0, $$this$executeSuspendingQuery, resultContinuation);
    var l = function ($this$flow, $completion) {
      return i.t7z($this$flow, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function AbstractScopedReferenceTargetsSupplier$getElements$slambda$o$runSuspend$slambda_1($this_channelFlow, resultContinuation) {
    this.d80_1 = $this_channelFlow;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(AbstractScopedReferenceTargetsSupplier$getElements$slambda$o$runSuspend$slambda_1).f80 = function (it, $completion) {
    var tmp = this.g80(it, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(AbstractScopedReferenceTargetsSupplier$getElements$slambda$o$runSuspend$slambda_1).v9 = function (p1, $completion) {
    return this.f80(p1 instanceof TargetInfo ? p1 : THROW_CCE(), $completion);
  };
  protoOf(AbstractScopedReferenceTargetsSupplier$getElements$slambda$o$runSuspend$slambda_1).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.d80_1.d11().z15(this.e80_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(AbstractScopedReferenceTargetsSupplier$getElements$slambda$o$runSuspend$slambda_1).g80 = function (it, completion) {
    var i = new AbstractScopedReferenceTargetsSupplier$getElements$slambda$o$runSuspend$slambda_1(this.d80_1, completion);
    i.e80_1 = it;
    return i;
  };
  function AbstractScopedReferenceTargetsSupplier$getElements$slambda$o$runSuspend$slambda_2($this_channelFlow, resultContinuation) {
    var i = new AbstractScopedReferenceTargetsSupplier$getElements$slambda$o$runSuspend$slambda_1($this_channelFlow, resultContinuation);
    var l = function (it, $completion) {
      return i.f80(it, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function $runSuspendCOROUTINE$_32(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.p80_1 = _this__u8e3s4;
    this.q80_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_32).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 3;
            this.r80_1 = this.q80_1;
            this.f9_1 = 1;
            suspendResult = this.r80_1.k60(this.p80_1.s80_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var scope = suspendResult;
            var this_0 = scope.q72(this.p80_1.t80_1);
            var elements = flow(AbstractScopedReferenceTargetsSupplier$getElements$slambda$o$runSuspend$slambda_0(this_0, this.p80_1.u80_1, this.r80_1, null));
            this.f9_1 = 2;
            var tmp_0 = AbstractScopedReferenceTargetsSupplier$getElements$slambda$o$runSuspend$slambda_2(this.p80_1.v80_1, null);
            suspendResult = elements.f18(new sam$kotlinx_coroutines_flow_FlowCollector$0_8(tmp_0), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 3) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function AbstractScopedReferenceTargetsSupplier$getElements$2$$inlined$executeSuspendingQuery$1($scopeQuery, $filter, this$0, $this_channelFlow) {
    this.s80_1 = $scopeQuery;
    this.t80_1 = $filter;
    this.u80_1 = this$0;
    this.v80_1 = $this_channelFlow;
  }
  protoOf(AbstractScopedReferenceTargetsSupplier$getElements$2$$inlined$executeSuspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_32(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(AbstractScopedReferenceTargetsSupplier$getElements$2$$inlined$executeSuspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function parentChildScopes_0($this, source) {
    var tmp = Companion_instance_125;
    return new ParentChildScopes($this.e7z_1.l7l($this.e7z_1.d74(tmp.w7a(isInterface(source, DomainNode) ? source : THROW_CCE()))), $this.d7z_1.w6l_1);
  }
  function sam$kotlinx_coroutines_flow_FlowCollector$0_8(function_0) {
    this.w80_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_8).x18 = function (value, $completion) {
    return this.w80_1(value, $completion);
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_8).f3 = function () {
    return this.w80_1;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_8).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, FlowCollector) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_8).hashCode = function () {
    return hashCode(this.f3());
  };
  function AbstractScopedReferenceTargetsSupplier$getElements$slambda($scopeQuery, $filter, this$0, resultContinuation) {
    this.f81_1 = $scopeQuery;
    this.g81_1 = $filter;
    this.h81_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(AbstractScopedReferenceTargetsSupplier$getElements$slambda).j81 = function ($this$channelFlow, $completion) {
    var tmp = this.k81($this$channelFlow, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(AbstractScopedReferenceTargetsSupplier$getElements$slambda).v9 = function (p1, $completion) {
    return this.j81((!(p1 == null) ? isInterface(p1, ProducerScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(AbstractScopedReferenceTargetsSupplier$getElements$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = execute_1(new AbstractScopedReferenceTargetsSupplier$getElements$2$$inlined$executeSuspendingQuery$1(this.f81_1, this.g81_1, this.h81_1, this.i81_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(AbstractScopedReferenceTargetsSupplier$getElements$slambda).k81 = function ($this$channelFlow, completion) {
    var i = new AbstractScopedReferenceTargetsSupplier$getElements$slambda(this.f81_1, this.g81_1, this.h81_1, completion);
    i.i81_1 = $this$channelFlow;
    return i;
  };
  function AbstractScopedReferenceTargetsSupplier$getElements$slambda_0($scopeQuery, $filter, this$0, resultContinuation) {
    var i = new AbstractScopedReferenceTargetsSupplier$getElements$slambda($scopeQuery, $filter, this$0, resultContinuation);
    var l = function ($this$channelFlow, $completion) {
      return i.j81($this$channelFlow, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function AbstractScopedReferenceTargetsSupplier(refTag, scopeConfig) {
    this.d7z_1 = refTag;
    this.e7z_1 = scopeConfig;
  }
  protoOf(AbstractScopedReferenceTargetsSupplier).o6q = function (context, filter) {
    var tmp;
    if (context instanceof EnclosingNodeContext) {
      var tmp_0 = context.f6p_1;
      tmp = !isInterface(tmp_0, DomainNode);
    } else {
      tmp = false;
    }
    // Inline function 'kotlin.require' call
    if (!!tmp) {
      var message = 'Cannot use scopes based reference resolver on objects that are not DomainNode';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    var tmp_1;
    if (context instanceof SourceNodeContext) {
      tmp_1 = parentChildScopes_0(this, context.i6p_1).x7b(context.i6p_1);
    } else {
      if (context instanceof EnclosingNodeContext) {
        tmp_1 = parentChildScopes_0(this, context.h6p()).w7b(context);
      } else {
        noWhenBranchMatchedException();
      }
    }
    var scopeQuery = tmp_1;
    return channelFlow(AbstractScopedReferenceTargetsSupplier$getElements$slambda_0(scopeQuery, filter, this, null));
  };
  function scoped(_this__u8e3s4, tags, skipValidation) {
    skipValidation = skipValidation === VOID ? false : skipValidation;
    return scoped_0(_this__u8e3s4, tags, scoped$lambda(skipValidation));
  }
  function scoped_0(_this__u8e3s4, tags, skipValidationPredicate) {
    var builder = new ScopedReferenceFactoryRegistryBuilder(_this__u8e3s4, ScopeConfigService_instance.e3b(_this__u8e3s4), Companion_instance_92.e3b(_this__u8e3s4), Companion_instance_95.e3b(_this__u8e3s4));
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = tags.m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      builder.p81(element, skipValidationPredicate);
    }
  }
  function getDefaultFinder($this, refContentClass) {
    var tmp;
    if (refContentClass.equals(getKClass(LocalReferenceContent))) {
      tmp = $this.n81_1;
    } else if (refContentClass.equals(getKClass(QualifiedReferenceContent))) {
      tmp = $this.o81_1;
    } else {
      throw IllegalStateException_init_$Create$();
    }
    var tmp_0 = tmp;
    return isInterface(tmp_0, NodeFinder) ? tmp_0 : THROW_CCE();
  }
  function ScopedReferenceFactoryRegistryBuilder(builder, scopeConfig, sameModelNodeFinder, globalNodeFinder) {
    this.l81_1 = builder;
    this.m81_1 = scopeConfig;
    this.n81_1 = sameModelNodeFinder;
    this.o81_1 = globalNodeFinder;
  }
  protoOf(ScopedReferenceFactoryRegistryBuilder).p81 = function (tag, skipValidationPredicate) {
    var referenceResolver = new ScopedReferenceResolver(tag, this.m81_1, getDefaultFinder(this, tag.x6l_1), skipValidationPredicate);
    this.l81_1.j6t(tag, Companion_instance_102.a6t(referenceResolver));
  };
  function scoped$lambda($skipValidation) {
    return function (it) {
      return $skipValidation;
    };
  }
  function $runSuspendCOROUTINE$_33(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.y81_1 = _this__u8e3s4;
    this.z81_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_33).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 9;
            this.b82_1 = this.z81_1;
            this.f9_1 = 1;
            suspendResult = this.b82_1.k60(this.y81_1.h82_1.j6q(this.y81_1.i82_1, this.y81_1.j82_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp0_safe_receiver = suspendResult;
            if (tmp0_safe_receiver == null) {
              this.c82_1 = null;
              this.f9_1 = 6;
              continue $sm;
            } else {
              this.e82_1 = tmp0_safe_receiver;
              this.g82_1 = this.e82_1;
              if (this.y81_1.h82_1.n82_1(this.y81_1.i82_1)) {
                this.f82_1 = true;
                this.f9_1 = 4;
                continue $sm;
              } else {
                this.f9_1 = 2;
                suspendResult = this.y81_1.h82_1.m7y(this.b82_1, this.y81_1.i82_1, this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              }
            }

          case 2:
            var ARGUMENT = suspendResult.p72(this.g82_1);
            this.f9_1 = 3;
            suspendResult = this.b82_1.k60(ARGUMENT, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            this.f82_1 = suspendResult;
            this.f9_1 = 4;
            continue $sm;
          case 4:
            if (this.f82_1) {
              this.d82_1 = this.e82_1;
              this.f9_1 = 5;
              continue $sm;
            } else {
              this.d82_1 = null;
              this.f9_1 = 5;
              continue $sm;
            }

          case 5:
            this.c82_1 = this.d82_1;
            this.f9_1 = 6;
            continue $sm;
          case 6:
            var tmp1_elvis_lhs = this.c82_1;
            if (tmp1_elvis_lhs == null) {
              this.f9_1 = 7;
              suspendResult = findByPointer(this.y81_1.h82_1, this.b82_1, this.y81_1.i82_1, this.y81_1.j82_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.a82_1 = tmp1_elvis_lhs;
              this.f9_1 = 8;
              continue $sm;
            }

          case 7:
            this.a82_1 = suspendResult;
            this.f9_1 = 8;
            continue $sm;
          case 8:
            return this.a82_1;
          case 9:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 9) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function $runSuspendCOROUTINE$_34(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.w82_1 = _this__u8e3s4;
    this.x82_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_34).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 4;
            this.z82_1 = this.x82_1;
            this.f9_1 = 1;
            suspendResult = this.z82_1.k60(this.w82_1.a83_1.m82_1.j6i(this.w82_1.b83_1, this.w82_1.c83_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp0_safe_receiver = suspendResult;
            var tmp_0;
            if (tmp0_safe_receiver == null) {
              tmp_0 = null;
            } else {
              tmp_0 = safeCast(this.w82_1.a83_1.k7y_1.w6l_1, tmp0_safe_receiver);
            }

            var tmp1_elvis_lhs = tmp_0;
            if (tmp1_elvis_lhs == null) {
              this.f9_1 = 2;
              suspendResult = findByPointer(this.w82_1.a83_1, this.z82_1, this.w82_1.b83_1, this.w82_1.c83_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.y82_1 = tmp1_elvis_lhs;
              this.f9_1 = 3;
              continue $sm;
            }

          case 2:
            this.y82_1 = suspendResult;
            this.f9_1 = 3;
            continue $sm;
          case 3:
            return this.y82_1;
          case 4:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 4) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function findByPointer($this, _this__u8e3s4, source, refContent, $completion) {
    var tmp = new $findByPointerCOROUTINE$($this, _this__u8e3s4, source, refContent, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  }
  function ScopedReferenceResolver$_init_$lambda_p6sh3e(it) {
    return false;
  }
  function ScopedReferenceResolver$resolve$$inlined$suspendingQuery$1(this$0, $source, $refContent) {
    this.h82_1 = this$0;
    this.i82_1 = $source;
    this.j82_1 = $refContent;
  }
  protoOf(ScopedReferenceResolver$resolve$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_33(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(ScopedReferenceResolver$resolve$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function ScopedReferenceResolver$find$$inlined$suspendingQuery$1(this$0, $source, $refContent) {
    this.a83_1 = this$0;
    this.b83_1 = $source;
    this.c83_1 = $refContent;
  }
  protoOf(ScopedReferenceResolver$find$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_34(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(ScopedReferenceResolver$find$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function $findByPointerCOROUTINE$(_this__u8e3s4, _this__u8e3s4_0, source, refContent, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.l83_1 = _this__u8e3s4;
    this.m83_1 = _this__u8e3s4_0;
    this.n83_1 = source;
    this.o83_1 = refContent;
  }
  protoOf($findByPointerCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 4;
            var tmp0_safe_receiver = this.l83_1.m82_1.k6i(this.n83_1, this.o83_1);
            if (tmp0_safe_receiver == null) {
              this.p83_1 = null;
              this.f9_1 = 3;
              continue $sm;
            } else {
              this.q83_1 = tmp0_safe_receiver;
              this.f9_1 = 1;
              suspendResult = this.l83_1.m7y(this.m83_1, this.n83_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            var ARGUMENT = suspendResult.o72(this.q83_1);
            this.f9_1 = 2;
            suspendResult = this.m83_1.k60(ARGUMENT, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.p83_1 = suspendResult;
            this.f9_1 = 3;
            continue $sm;
          case 3:
            return this.p83_1;
          case 4:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 4) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function ScopedReferenceResolver(refTag, scopeConfig, finder, skipValidationPredicate) {
    var tmp;
    if (skipValidationPredicate === VOID) {
      tmp = ScopedReferenceResolver$_init_$lambda_p6sh3e;
    } else {
      tmp = skipValidationPredicate;
    }
    skipValidationPredicate = tmp;
    AbstractScopedReferenceResolver.call(this, refTag, scopeConfig);
    this.m82_1 = finder;
    this.n82_1 = skipValidationPredicate;
  }
  protoOf(ScopedReferenceResolver).i6q = function (source, refContent) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new ScopedReferenceResolver$resolve$$inlined$suspendingQuery$1(this, source, refContent);
  };
  protoOf(ScopedReferenceResolver).j6q = function (source, refContent) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new ScopedReferenceResolver$find$$inlined$suspendingQuery$1(this, source, refContent);
  };
  function $runSuspendCOROUTINE$_35(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.z83_1 = _this__u8e3s4;
    this.a84_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_35).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            var $this$suspendingQuery = this.a84_1;
            var tmp_0 = this;
            tmp_0.b84_1 = $this$suspendingQuery;
            this.f9_1 = 1;
            suspendResult = $this$suspendingQuery.k60(this.z83_1.c84_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp2 = suspendResult;
            this.b84_1;
            return tmp2.e72_1;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function ScopedReferenceTargetPresentationProvider$getPresentation$$inlined$flatMap$1($this) {
    this.c84_1 = $this;
  }
  protoOf(ScopedReferenceTargetPresentationProvider$getPresentation$$inlined$flatMap$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_35(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(ScopedReferenceTargetPresentationProvider$getPresentation$$inlined$flatMap$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function ScopedReferenceTargetPresentationProvider(scopeConfig) {
    this.d84_1 = scopeConfig;
  }
  protoOf(ScopedReferenceTargetPresentationProvider).w6q = function (target) {
    // Inline function 'jetbrains.ocelot.langDef.query.flatMap' call
    var this_0 = this.d84_1.u7a(target);
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new ScopedReferenceTargetPresentationProvider$getPresentation$$inlined$flatMap$1(this_0);
  };
  function scoped_1(_this__u8e3s4, tags) {
    var scopeConfig = ScopeConfigService_instance.e3b(_this__u8e3s4);
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = tags.m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      scopeReferenceTargetPresentation(_this__u8e3s4, element, scopeConfig);
    }
  }
  function scopeReferenceTargetPresentation(_this__u8e3s4, tag, scopeConfig) {
    _this__u8e3s4.s6t(tag, new ScopedReferenceTargetPresentationProvider(scopeConfig));
  }
  function ScopedReferenceTargetsSupplier$referenceContents$$inlined$suspendingQuery$1(this$0, $target) {
    this.e84_1 = this$0;
    this.f84_1 = $target;
  }
  protoOf(ScopedReferenceTargetsSupplier$referenceContents$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    return ReferenceContentFactories_getInstance().g6q(this.e84_1.d7z_1.x6l_1).h6q(this.f84_1);
  };
  protoOf(ScopedReferenceTargetsSupplier$referenceContents$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function ScopedReferenceTargetsSupplier(refTag, scopeConfig) {
    AbstractScopedReferenceTargetsSupplier.call(this, refTag, scopeConfig);
  }
  protoOf(ScopedReferenceTargetsSupplier).f7z = function (target) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new ScopedReferenceTargetsSupplier$referenceContents$$inlined$suspendingQuery$1(this, target);
  };
  function scoped_2(_this__u8e3s4, tags) {
    var scopeConfig = ScopeConfigService_instance.e3b(_this__u8e3s4);
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = tags.m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      scopedReferenceTargetSupplier(_this__u8e3s4, element, scopeConfig);
    }
  }
  function scopedReferenceTargetSupplier(_this__u8e3s4, tag, scopeConfig) {
    _this__u8e3s4.b6u(tag, new ScopedReferenceTargetsSupplier(tag, scopeConfig));
  }
  function TargetInfoStub() {
  }
  function AbsentScopeOwner() {
  }
  var AbsentScopeOwner_instance;
  function AbsentScopeOwner_getInstance() {
    return AbsentScopeOwner_instance;
  }
  function ScopeContent(specification, elements) {
    elements = elements === VOID ? null : elements;
    this.i84_1 = specification;
    this.j84_1 = elements;
  }
  protoOf(ScopeContent).toString = function () {
    return 'ScopeContent(specification=' + this.i84_1.toString() + ', elements=' + toString_0(this.j84_1) + ')';
  };
  protoOf(ScopeContent).hashCode = function () {
    var result = this.i84_1.hashCode();
    result = imul(result, 31) + (this.j84_1 == null ? 0 : hashCode(this.j84_1)) | 0;
    return result;
  };
  protoOf(ScopeContent).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ScopeContent))
      return false;
    if (!this.i84_1.equals(other.i84_1))
      return false;
    if (!equals(this.j84_1, other.j84_1))
      return false;
    return true;
  };
  function Default_1(name) {
    ScopeId.call(this);
    this.l84_1 = name;
  }
  protoOf(Default_1).toString = function () {
    return 'Default/' + this.l84_1;
  };
  protoOf(Default_1).hashCode = function () {
    return getStringHashCode(this.l84_1);
  };
  protoOf(Default_1).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Default_1))
      return false;
    if (!(this.l84_1 === other.l84_1))
      return false;
    return true;
  };
  function Exported(provider, name) {
    ScopeId.call(this);
    this.n84_1 = provider;
    this.o84_1 = name;
  }
  protoOf(Exported).toString = function () {
    return 'Exported/' + this.n84_1.toString() + '/' + this.o84_1;
  };
  protoOf(Exported).hashCode = function () {
    var result = this.n84_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.o84_1) | 0;
    return result;
  };
  protoOf(Exported).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Exported))
      return false;
    if (!this.n84_1.equals(other.n84_1))
      return false;
    if (!(this.o84_1 === other.o84_1))
      return false;
    return true;
  };
  function Lexical_0(provider, name) {
    ScopeId.call(this);
    this.q84_1 = provider;
    this.r84_1 = name;
  }
  protoOf(Lexical_0).toString = function () {
    return 'Lexical/' + this.q84_1.toString() + '/' + this.r84_1;
  };
  protoOf(Lexical_0).hashCode = function () {
    var result = this.q84_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.r84_1) | 0;
    return result;
  };
  protoOf(Lexical_0).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Lexical_0))
      return false;
    if (!this.q84_1.equals(other.q84_1))
      return false;
    if (!(this.r84_1 === other.r84_1))
      return false;
    return true;
  };
  function Children(provider, role) {
    ScopeId.call(this);
    this.t84_1 = provider;
    this.u84_1 = role;
  }
  protoOf(Children).toString = function () {
    return 'Children/' + this.t84_1.toString() + '/' + this.u84_1;
  };
  protoOf(Children).hashCode = function () {
    var result = this.t84_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.u84_1) | 0;
    return result;
  };
  protoOf(Children).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Children))
      return false;
    if (!this.t84_1.equals(other.t84_1))
      return false;
    if (!(this.u84_1 === other.u84_1))
      return false;
    return true;
  };
  function Collection_0(id) {
    id = id === VOID ? Companion_getInstance_36().k36() : id;
    ScopeId.call(this);
    this.w84_1 = id;
  }
  protoOf(Collection_0).toString = function () {
    return 'Collection/' + this.w84_1;
  };
  protoOf(Collection_0).hashCode = function () {
    return getStringHashCode(this.w84_1);
  };
  protoOf(Collection_0).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Collection_0))
      return false;
    if (!(this.w84_1 === other.w84_1))
      return false;
    return true;
  };
  function Companion_129() {
  }
  var Companion_instance_129;
  function Companion_getInstance_129() {
    return Companion_instance_129;
  }
  function ScopeId() {
    this.x84_1 = null;
  }
  function ScopeSpecification(owner, id) {
    this.p7l_1 = owner;
    this.q7l_1 = id;
  }
  protoOf(ScopeSpecification).toString = function () {
    return toString_1(this.p7l_1) + '/' + toString_1(this.q7l_1);
  };
  protoOf(ScopeSpecification).hashCode = function () {
    var result = hashCode(this.p7l_1);
    result = imul(result, 31) + hashCode(this.q7l_1) | 0;
    return result;
  };
  protoOf(ScopeSpecification).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ScopeSpecification))
      return false;
    if (!equals(this.p7l_1, other.p7l_1))
      return false;
    if (!equals(this.q7l_1, other.q7l_1))
      return false;
    return true;
  };
  function Companion_130() {
    Companion_instance_130 = this;
    this.y84_1 = new ScopeTree(emptyList());
  }
  var Companion_instance_130;
  function Companion_getInstance_130() {
    if (Companion_instance_130 == null)
      new Companion_130();
    return Companion_instance_130;
  }
  function ScopeTree$toString$lambda(it) {
    return it.i84_1.toString();
  }
  function ScopeTree(contents) {
    Companion_getInstance_130();
    this.z84_1 = contents;
  }
  protoOf(ScopeTree).toString = function () {
    return joinToString_0(this.z84_1, VOID, '[', ']', VOID, VOID, ScopeTree$toString$lambda);
  };
  function findUsages(_this__u8e3s4, body) {
    _this__u8e3s4.t6f(FindUsagesAspect_instance, new FindUsagesDefinition(body));
  }
  function FindUsagesAspect$createConfigurationService$lambda($definitions) {
    return function (services) {
      var conceptRegistry = ensureNotNull(services.h3b(ConceptRegistryService_instance));
      var builder = new FindUsagesConfigBuilderImpl(conceptRegistry);
      var _iterator__ex2g4s = $definitions.m();
      while (_iterator__ex2g4s.n()) {
        var definition = _iterator__ex2g4s.o();
        definition.a85_1(builder);
      }
      return builder.f40();
    };
  }
  function FindUsagesAspect() {
  }
  protoOf(FindUsagesAspect).f85 = function (definitions) {
    var tmp = Companion_instance_41;
    var tmp_0 = [FindUsagesConfigService_instance];
    return tmp.m3b(tmp_0, VOID, FindUsagesAspect$createConfigurationService$lambda(definitions));
  };
  protoOf(FindUsagesAspect).r6f = function (definitions) {
    return this.f85(definitions);
  };
  var FindUsagesAspect_instance;
  function FindUsagesAspect_getInstance() {
    return FindUsagesAspect_instance;
  }
  function FindUsagesDefinition(body) {
    this.a85_1 = body;
  }
  function FindUsagesConfigService() {
  }
  var FindUsagesConfigService_instance;
  function FindUsagesConfigService_getInstance() {
    return FindUsagesConfigService_instance;
  }
  function usageKinds(_this__u8e3s4, kinds) {
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable = 0;
    var last = kinds.length;
    while (inductionVariable < last) {
      var element = kinds[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      _this__u8e3s4.g85(element);
    }
  }
  function FindUsagesData() {
  }
  function get_targetConcept(_this__u8e3s4) {
    return _this__u8e3s4.j85().i85_1.r6k_1;
  }
  function ProperUsage(usage) {
    FindUsagesData.call(this);
    this.k85_1 = usage;
  }
  function DontKnow() {
    DontKnow_instance = this;
    FindUsagesData.call(this);
  }
  var DontKnow_instance;
  function DontKnow_getInstance() {
    if (DontKnow_instance == null)
      new DontKnow();
    return DontKnow_instance;
  }
  function ReferenceContext(sourceNode, link) {
    this.h85_1 = sourceNode;
    this.i85_1 = link;
  }
  function implClass_1($this, conceptClass) {
    var descriptor = $this.b85_1.l6l(conceptClass);
    return ensureNotNull(descriptor.t6m());
  }
  function FindUsagesConfigBuilderImpl$lambda(node, _unused_var__etf5q3) {
    return defaultPresentation(node);
  }
  function FindUsagesConfigBuilderImpl$build$1(this$0) {
    this.l85_1 = this$0;
  }
  protoOf(FindUsagesConfigBuilderImpl$build$1).m85 = function (id) {
    // Inline function 'kotlin.check' call
    if (!this.l85_1.d85_1.r2().t(id)) {
      var message = 'Usage kind ' + id + ' is not registered';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    return ensureNotNull(this.l85_1.d85_1.q2(id));
  };
  protoOf(FindUsagesConfigBuilderImpl$build$1).n85 = function (usage) {
    // Inline function 'kotlin.check' call
    if (!this.l85_1.e85_1.r2().t(usage.o85_1)) {
      var message = 'Presentation is not defined for usage kind ' + toString_1(usage.o85_1);
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    var tmp = ensureNotNull(this.l85_1.e85_1.q2(usage.o85_1));
    var presentation = typeof tmp === 'function' ? tmp : THROW_CCE();
    return presentation(usage.p85_1, usage.q85_1);
  };
  function FindUsagesConfigBuilderImpl(conceptRegistry) {
    this.b85_1 = conceptRegistry;
    this.c85_1 = HashMap_init_$Create$();
    this.d85_1 = HashMap_init_$Create$();
    this.e85_1 = HashMap_init_$Create$();
    var tmp0 = this.d85_1;
    var tmp2 = DefaultUsageKind_getInstance().r85_1;
    // Inline function 'kotlin.collections.set' call
    var value = DefaultUsageKind_getInstance();
    tmp0.t2(tmp2, value);
    var tmp0_0 = this.e85_1;
    var tmp2_0 = DefaultUsageKind_getInstance();
    // Inline function 'kotlin.collections.set' call
    var value_0 = FindUsagesConfigBuilderImpl$lambda;
    tmp0_0.t2(tmp2_0, value_0);
  }
  protoOf(FindUsagesConfigBuilderImpl).g85 = function (kind) {
    // Inline function 'kotlin.text.isNotEmpty' call
    var this_0 = kind.r85_1;
    // Inline function 'kotlin.require' call
    if (!(charSequenceLength(this_0) > 0)) {
      var message = 'Usage kind must not have empty id';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    // Inline function 'kotlin.check' call
    if (!!this.d85_1.o2(kind.r85_1)) {
      var message_0 = 'Usage kind with id ' + kind.r85_1 + ' is already registered';
      throw IllegalStateException_init_$Create$_0(toString_1(message_0));
    }
    var tmp0 = this.d85_1;
    // Inline function 'kotlin.collections.set' call
    var key = kind.r85_1;
    tmp0.t2(key, kind);
  };
  protoOf(FindUsagesConfigBuilderImpl).s85 = function (concept, body) {
    var tmp0 = this.c85_1;
    // Inline function 'kotlin.collections.getOrPut' call
    var key = implClass_1(this, concept);
    var value = tmp0.q2(key);
    var tmp;
    if (value == null) {
      var answer = ArrayList_init_$Create$();
      tmp0.t2(key, answer);
      tmp = answer;
    } else {
      tmp = value;
    }
    var list = tmp;
    list.j(body);
  };
  protoOf(FindUsagesConfigBuilderImpl).t85 = function (concept, body) {
    return this.s85(concept, body);
  };
  protoOf(FindUsagesConfigBuilderImpl).u85 = function (kind, body) {
    // Inline function 'kotlin.check' call
    if (!!this.e85_1.o2(kind)) {
      var message = 'Presentation for usage kind ' + toString_1(kind) + ' is already registered';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    var tmp0 = this.e85_1;
    // Inline function 'kotlin.collections.set' call
    var value = typeof body === 'function' ? body : THROW_CCE();
    tmp0.t2(kind, value);
  };
  protoOf(FindUsagesConfigBuilderImpl).v85 = function (kind, body) {
    return this.u85(kind, body);
  };
  protoOf(FindUsagesConfigBuilderImpl).f40 = function () {
    return new FindUsagesConfigBuilderImpl$build$1(this);
  };
  function defaultPresentation(node) {
    return new DefaultUsagePresentation(node);
  }
  function UsagePresentationData() {
  }
  function UsageKind(id) {
    this.r85_1 = id;
  }
  function DefaultUsageKind() {
    DefaultUsageKind_instance = this;
    UsageKind.call(this, 'default');
  }
  var DefaultUsageKind_instance;
  function DefaultUsageKind_getInstance() {
    if (DefaultUsageKind_instance == null)
      new DefaultUsageKind();
    return DefaultUsageKind_instance;
  }
  function DefaultUsagePresentation(node) {
    UsagePresentationData.call(this);
    this.x85_1 = node;
  }
  function Usage(kind, node, reference) {
    this.o85_1 = kind;
    this.p85_1 = node;
    this.q85_1 = reference;
  }
  function MapperUpdater($outer) {
    this.y85_1 = $outer;
  }
  protoOf(MapperUpdater).z85 = function (sourceList) {
    // Inline function 'kotlin.collections.mutableListOf' call
    var targetContent = ArrayList_init_$Create$();
    var mappers = this.y85_1.d86();
    var _iterator__ex2g4s = mappers.m();
    while (_iterator__ex2g4s.n()) {
      var mapper = _iterator__ex2g4s.o();
      targetContent.j(mapper.e86_1);
    }
    var difference = (new DifferenceBuilder(sourceList, targetContent)).f40();
    var _iterator__ex2g4s_0 = difference.m();
    while (_iterator__ex2g4s_0.n()) {
      var item = _iterator__ex2g4s_0.o();
      var itemIndex = item.n86_1;
      if (item.p86_1) {
        var mapper_0 = this.y85_1.u86(item.o86_1);
        mappers.m2(itemIndex, mapper_0);
        this.v86(itemIndex, mapper_0);
        this.y85_1.w86(mapper_0);
      } else {
        var mapper_1 = mappers.n2(itemIndex);
        this.r86(itemIndex, mapper_1);
      }
    }
  };
  protoOf(MapperUpdater).v86 = function (index, mapper) {
  };
  protoOf(MapperUpdater).r86 = function (index, mapper) {
  };
  function BaseCollectionRoleSynchronizer(factory) {
    BaseRoleSynchronizer.call(this, factory);
  }
  protoOf(BaseCollectionRoleSynchronizer).d86 = function () {
    var tmp = this.c86_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('modifiableMappers');
    }
  };
  protoOf(BaseCollectionRoleSynchronizer).x86 = function () {
    return this.d86();
  };
  protoOf(BaseCollectionRoleSynchronizer).y86 = function (ctx) {
    this.c86_1 = ctx.z86().a87();
    this.b87();
  };
  protoOf(BaseCollectionRoleSynchronizer).e6j = function () {
    return this.c87();
  };
  protoOf(BaseCollectionRoleSynchronizer).b87 = function () {
  };
  protoOf(BaseCollectionRoleSynchronizer).c87 = function () {
  };
  function BaseRoleSynchronizer(mapperFactory) {
    this.s86_1 = mapperFactory;
    this.t86_1 = null;
  }
  protoOf(BaseRoleSynchronizer).u86 = function (source) {
    return this.s86_1(source);
  };
  protoOf(BaseRoleSynchronizer).w86 = function (mapper) {
    var tmp0_safe_receiver = this.t86_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.collections.forEach' call
      var inductionVariable = 0;
      var last = tmp0_safe_receiver.length;
      while (inductionVariable < last) {
        var element = tmp0_safe_receiver[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        element.d87(mapper);
      }
    }
  };
  function removeTarget($this, target) {
    $this.f87_1.u2(target);
  }
  function putMapper($this, mapper) {
    if (mapper.g87()) {
      var target = ensureNotNull(mapper.f86_1);
      var mapperSet = fetchMappers($this, target);
      mapperSet.j(mapper);
    }
  }
  function fetchMappers($this, target) {
    // Inline function 'kotlin.collections.getOrPut' call
    var this_0 = $this.f87_1;
    var value = this_0.q2(target);
    var tmp;
    if (value == null) {
      var answer = HashSet_init_$Create$();
      this_0.t2(target, answer);
      tmp = answer;
    } else {
      tmp = value;
    }
    return tmp;
  }
  function Companion_131() {
    Companion_instance_131 = this;
    this.h87_1 = new MappingContextProperty('ByTargetIndex');
  }
  var Companion_instance_131;
  function Companion_getInstance_131() {
    if (Companion_instance_131 == null)
      new Companion_131();
    return Companion_instance_131;
  }
  function ByTargetIndex$1(this$0) {
    this.i87_1 = this$0;
  }
  protoOf(ByTargetIndex$1).j87 = function (mapper) {
    return putMapper(this.i87_1, mapper);
  };
  protoOf(ByTargetIndex$1).k87 = function (mapper) {
    if (mapper.g87()) {
      var target = ensureNotNull(mapper.f86_1);
      var mappers = fetchMappers(this.i87_1, target);
      // Inline function 'kotlin.check' call
      if (!mappers.t(mapper)) {
        var message = 'unregistered mapper ' + toString_1(mapper) + ' with target ' + toString_1(target);
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      }
      mappers.h2(mapper);
      if (mappers.s()) {
        removeTarget(this.i87_1, target);
      }
    }
  };
  function ByTargetIndex(ctx) {
    Companion_getInstance_131();
    this.f87_1 = HashMap_init_$Create$();
    var _iterator__ex2g4s = ctx.o87().m();
    while (_iterator__ex2g4s.n()) {
      var mapper = _iterator__ex2g4s.o();
      putMapper(this, mapper);
    }
    var tmp = this;
    tmp.e87_1 = ctx.p87(new ByTargetIndex$1(this));
  }
  protoOf(ByTargetIndex).zr = function () {
    return this.e87_1.zr();
  };
  protoOf(ByTargetIndex).q87 = function (target) {
    // Inline function 'kotlin.collections.getOrElse' call
    var tmp0_elvis_lhs = this.f87_1.q2(target);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      tmp = emptySet();
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  function DifferenceItem($outer, index, item, isAdd) {
    this.q86_1 = $outer;
    this.n86_1 = index;
    this.o86_1 = item;
    this.p86_1 = isAdd;
  }
  protoOf(DifferenceItem).toString = function () {
    return (this.p86_1 ? 'add' : 'remove') + ' ' + toString_0(this.o86_1) + '@' + this.n86_1;
  };
  function DifferenceBuilder(sourceList, targetList) {
    this.l86_1 = sourceList;
    this.m86_1 = targetList;
  }
  protoOf(DifferenceBuilder).f40 = function () {
    var result = ArrayList_init_$Create$();
    var sourceContent = this.l86_1;
    var target = ArrayList_init_$Create$_1(this.m86_1);
    var inductionVariable = target.p() - 1 | 0;
    if (0 <= inductionVariable)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        var current = target.r(i);
        if (!sourceContent.t(current)) {
          result.j(new DifferenceItem(this, i, current, false));
          target.n2(i);
        }
      }
       while (0 <= inductionVariable);
    var inductionVariable_0 = 0;
    var last = sourceContent.p() - 1 | 0;
    if (inductionVariable_0 <= last)
      do {
        var i_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var current_0 = sourceContent.r(i_0);
        var next = null;
        if ((i_0 + 1 | 0) < sourceContent.p()) {
          next = sourceContent.r(i_0 + 1 | 0);
        }
        if (target.p() <= i_0) {
          result.j(new DifferenceItem(this, i_0, current_0, true));
          target.m2(i_0, current_0);
        } else {
          var currentTarget = target.r(i_0);
          if (!(currentTarget === current_0)) {
            var currentIndex = target.w(current_0);
            if (!(currentIndex === -1)) {
              result.j(new DifferenceItem(this, currentIndex, current_0, false));
              target.h2(current_0);
            }
            if (next === currentTarget) {
              result.j(new DifferenceItem(this, i_0, current_0, true));
              target.m2(i_0, current_0);
            } else {
              result.j(new DifferenceItem(this, i_0, currentTarget, false));
              result.j(new DifferenceItem(this, i_0, current_0, true));
              target.l2(i_0, current_0);
            }
          }
        }
      }
       while (inductionVariable_0 <= last);
    return result;
  };
  function _get_disposable__lofx05_0($this) {
    var tmp = $this.r87_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('disposable');
    }
  }
  function DisposableSynchronizer() {
  }
  protoOf(DisposableSynchronizer).y86 = function (ctx) {
    this.r87_1 = this.s87(ctx);
  };
  protoOf(DisposableSynchronizer).e6j = function () {
    return _get_disposable__lofx05_0(this).zr();
  };
  function syncOneWay(_this__u8e3s4, target) {
    return new syncOneWay$1(target, _this__u8e3s4);
  }
  function syncTwoWay(_this__u8e3s4, target) {
    return new syncTwoWay$1(_this__u8e3s4, target);
  }
  function syncOneWay$o$doAttach$lambda($target) {
    return function (event) {
      $target.d2x(event.t2y_1);
      return Unit_instance;
    };
  }
  function syncOneWay$1($target, $this_syncOneWay) {
    this.u87_1 = $target;
    this.v87_1 = $this_syncOneWay;
    DisposableSynchronizer.call(this);
  }
  protoOf(syncOneWay$1).s87 = function (ctx) {
    this.u87_1.d2x(this.v87_1.uv());
    return this.v87_1.z2r(syncOneWay$o$doAttach$lambda(this.u87_1));
  };
  function _get_disposable__lofx05_1($this) {
    var tmp = $this.x87_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('disposable');
    }
  }
  function syncTwoWay$1($this_syncTwoWay, $target) {
    this.y87_1 = $this_syncTwoWay;
    this.z87_1 = $target;
    this.w87_1 = null;
  }
  protoOf(syncTwoWay$1).y86 = function (ctx) {
    var property = this.y87_1;
    this.w87_1 = property.uv();
    this.x87_1 = PropertyBinding_instance.o30(property, this.z87_1);
  };
  protoOf(syncTwoWay$1).e6j = function () {
    _get_disposable__lofx05_1(this).zr();
    var tmp = this.w87_1;
    var value = (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
    this.z87_1.d2x(value);
  };
  var State_NOT_ATTACHED_instance;
  var State_ATTACHING_SYNCHRONIZERS_instance;
  var State_ATTACHING_CHILDREN_instance;
  var State_ATTACHED_instance;
  var State_DETACHED_instance;
  var State_entriesInitialized;
  function State_initEntries() {
    if (State_entriesInitialized)
      return Unit_instance;
    State_entriesInitialized = true;
    State_NOT_ATTACHED_instance = new State_0('NOT_ATTACHED', 0);
    State_ATTACHING_SYNCHRONIZERS_instance = new State_0('ATTACHING_SYNCHRONIZERS', 1);
    State_ATTACHING_CHILDREN_instance = new State_0('ATTACHING_CHILDREN', 2);
    State_ATTACHED_instance = new State_0('ATTACHED', 3);
    State_DETACHED_instance = new State_0('DETACHED', 4);
  }
  function instantiateSynchronizers($this) {
    $this.a88(new Mapper$instantiateSynchronizers$1($this));
  }
  function addPart($this, part) {
    var tmp = $this;
    // Inline function 'kotlin.collections.plus' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$0 = $this.i86_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = [part];
    tmp.i86_1 = tmp$ret$0.concat(tmp$ret$3);
  }
  function removePart($this, part) {
    var index = indexOf($this.i86_1, part);
    var tmp = $this;
    var tmp_0 = 0;
    var tmp_1 = $this.i86_1.length - 1 | 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_2 = Array(tmp_1);
    while (tmp_0 < tmp_1) {
      var tmp_3 = tmp_0;
      tmp_2[tmp_3] = tmp_3 < index ? $this.i86_1[tmp_3] : $this.i86_1[tmp_3 + 1 | 0];
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp.i86_1 = tmp_2;
  }
  function addChild($this, child) {
    // Inline function 'kotlin.check' call
    if (!($this.h86_1.equals(State_ATTACHING_SYNCHRONIZERS_getInstance()) || $this.h86_1.equals(State_ATTACHING_CHILDREN_getInstance()) || $this.h86_1.equals(State_ATTACHED_getInstance()))) {
      var message = 'State =  ' + $this.h86_1.toString();
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    child.j86_1 = $this;
    if (!$this.h86_1.equals(State_ATTACHING_SYNCHRONIZERS_getInstance())) {
      child.c88($this.b88());
    }
  }
  function removeChild($this, child) {
    child.e6j();
    child.j86_1 = null;
  }
  function checkCanAdd($this, item) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.require' call
    if (!(item.j86_1 == null)) {
      var message = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
  }
  function checkCanRemove($this, item) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.require' call
    if (!(item.j86_1 === $this)) {
      var message = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
  }
  function ChildProperty_0($outer) {
    this.f88_1 = $outer;
    ValueProperty.call(this, null);
  }
  protoOf(ChildProperty_0).g88 = function (newValue) {
    if (this.uv() == null && !(newValue == null)) {
      addPart(this.f88_1, this);
    }
    if (!(this.uv() == null) && newValue == null) {
      removePart(this.f88_1, this);
    }
    var oldValue = this.uv();
    if (!(oldValue == null)) {
      checkCanRemove(this.f88_1, oldValue);
      removeChild(this.f88_1, oldValue);
    }
    protoOf(ValueProperty).d2x.call(this, newValue);
    if (!(newValue == null)) {
      checkCanAdd(this.f88_1, newValue);
      addChild(this.f88_1, newValue);
    }
  };
  protoOf(ChildProperty_0).d2x = function (newValue) {
    return this.g88((newValue == null ? true : newValue instanceof Mapper) ? newValue : THROW_CCE());
  };
  protoOf(ChildProperty_0).m = function () {
    var tmp0_safe_receiver = this.uv();
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp = listOf(tmp0_safe_receiver);
    }
    // Inline function 'kotlin.collections.orEmpty' call
    var tmp0_elvis_lhs = tmp;
    return (tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs).m();
  };
  function ChildList($outer) {
    this.k88_1 = $outer;
    ObservableArrayList.call(this);
  }
  protoOf(ChildList).l88 = function (index, item) {
    checkCanAdd(this.k88_1, item);
    protoOf(ObservableArrayList).o2s.call(this, index, item);
  };
  protoOf(ChildList).o2s = function (index, item) {
    return this.l88(index, item instanceof Mapper ? item : THROW_CCE());
  };
  protoOf(ChildList).m88 = function (index, oldItem, newItem) {
    checkCanRemove(this.k88_1, oldItem);
    checkCanAdd(this.k88_1, newItem);
    protoOf(ObservableArrayList).p2s.call(this, index, oldItem, newItem);
  };
  protoOf(ChildList).p2s = function (index, oldItem, newItem) {
    var tmp = oldItem instanceof Mapper ? oldItem : THROW_CCE();
    return this.m88(index, tmp, newItem instanceof Mapper ? newItem : THROW_CCE());
  };
  protoOf(ChildList).n88 = function (index, item) {
    checkCanRemove(this.k88_1, item);
    protoOf(ObservableArrayList).q2s.call(this, index, item);
  };
  protoOf(ChildList).q2s = function (index, item) {
    return this.n88(index, item instanceof Mapper ? item : THROW_CCE());
  };
  protoOf(ChildList).o88 = function (index, item) {
    if (this.s()) {
      addPart(this.k88_1, this);
    }
    protoOf(ObservableArrayList).s2s.call(this, index, item);
  };
  protoOf(ChildList).s2s = function (index, item) {
    return this.o88(index, item instanceof Mapper ? item : THROW_CCE());
  };
  protoOf(ChildList).p88 = function (index, item, success) {
    protoOf(ObservableArrayList).v2s.call(this, index, item, success);
    addChild(this.k88_1, item);
  };
  protoOf(ChildList).v2s = function (index, item, success) {
    return this.p88(index, item instanceof Mapper ? item : THROW_CCE(), success);
  };
  protoOf(ChildList).q88 = function (index, oldItem, newItem) {
    removeChild(this.k88_1, oldItem);
    addChild(this.k88_1, newItem);
    protoOf(ObservableArrayList).x2s.call(this, index, oldItem, newItem);
  };
  protoOf(ChildList).x2s = function (index, oldItem, newItem) {
    var tmp = oldItem instanceof Mapper ? oldItem : THROW_CCE();
    return this.q88(index, tmp, newItem instanceof Mapper ? newItem : THROW_CCE());
  };
  protoOf(ChildList).r88 = function (index, item) {
    removeChild(this.k88_1, item);
    protoOf(ObservableArrayList).c2t.call(this, index, item);
  };
  protoOf(ChildList).c2t = function (index, item) {
    return this.r88(index, item instanceof Mapper ? item : THROW_CCE());
  };
  protoOf(ChildList).s88 = function (index, item, success) {
    if (this.s()) {
      removePart(this.k88_1, this);
    }
    protoOf(ObservableArrayList).e2t.call(this, index, item, success);
  };
  protoOf(ChildList).e2t = function (index, item, success) {
    return this.s88(index, item instanceof Mapper ? item : THROW_CCE(), success);
  };
  function ChildSet($outer) {
    this.v88_1 = $outer;
    ObservableHashSet_init_$Init$(this);
  }
  protoOf(ChildSet).w88 = function (item) {
    checkCanAdd(this.v88_1, ensureNotNull(item));
    protoOf(ObservableHashSet).q2t.call(this, item);
  };
  protoOf(ChildSet).q2t = function (item) {
    return this.w88((item == null ? true : item instanceof Mapper) ? item : THROW_CCE());
  };
  protoOf(ChildSet).x88 = function (item) {
    checkCanRemove(this.v88_1, ensureNotNull(item));
    protoOf(ObservableHashSet).t2t.call(this, item);
  };
  protoOf(ChildSet).t2t = function (item) {
    return this.x88((item == null ? true : item instanceof Mapper) ? item : THROW_CCE());
  };
  protoOf(ChildSet).y88 = function (item) {
    if (this.s()) {
      addPart(this.v88_1, this);
    }
    protoOf(ObservableHashSet).r2t.call(this, item);
  };
  protoOf(ChildSet).r2t = function (item) {
    return this.y88((item == null ? true : item instanceof Mapper) ? item : THROW_CCE());
  };
  protoOf(ChildSet).z88 = function (item, success) {
    protoOf(ObservableHashSet).s2t.call(this, item, success);
    addChild(this.v88_1, ensureNotNull(item));
  };
  protoOf(ChildSet).s2t = function (item, success) {
    return this.z88((item == null ? true : item instanceof Mapper) ? item : THROW_CCE(), success);
  };
  protoOf(ChildSet).a89 = function (item) {
    removeChild(this.v88_1, ensureNotNull(item));
    protoOf(ObservableHashSet).u2t.call(this, item);
  };
  protoOf(ChildSet).u2t = function (item) {
    return this.a89((item == null ? true : item instanceof Mapper) ? item : THROW_CCE());
  };
  protoOf(ChildSet).b89 = function (item, success) {
    if (this.s()) {
      removePart(this.v88_1, this);
    }
    protoOf(ObservableHashSet).v2t.call(this, item, success);
  };
  protoOf(ChildSet).v2t = function (item, success) {
    return this.b89((item == null ? true : item instanceof Mapper) ? item : THROW_CCE(), success);
  };
  function ChildContainer() {
  }
  function State_0(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function Companion_132() {
    Companion_instance_132 = this;
    var tmp = this;
    // Inline function 'kotlin.emptyArray' call
    tmp.c89_1 = [];
  }
  var Companion_instance_132;
  function Companion_getInstance_132() {
    if (Companion_instance_132 == null)
      new Companion_132();
    return Companion_instance_132;
  }
  function Mapper$instantiateSynchronizers$1(this$0) {
    this.d89_1 = this$0;
  }
  protoOf(Mapper$instantiateSynchronizers$1).h5v = function (sync) {
    return addPart(this.d89_1, sync);
  };
  function Mapper$attach$synchronizerContext$1(this$0) {
    this.e89_1 = this$0;
  }
  protoOf(Mapper$attach$synchronizerContext$1).b88 = function () {
    return this.e89_1.b88();
  };
  protoOf(Mapper$attach$synchronizerContext$1).z86 = function () {
    return this.e89_1;
  };
  function Mapper$synchronizers$lambda(it) {
    return !(it == null) ? isInterface(it, Synchronizer) : false;
  }
  function Mapper$children$lambda(it) {
    return !(it == null) ? isInterface(it, ChildContainer) : false;
  }
  function State_NOT_ATTACHED_getInstance() {
    State_initEntries();
    return State_NOT_ATTACHED_instance;
  }
  function State_ATTACHING_SYNCHRONIZERS_getInstance() {
    State_initEntries();
    return State_ATTACHING_SYNCHRONIZERS_instance;
  }
  function State_ATTACHING_CHILDREN_getInstance() {
    State_initEntries();
    return State_ATTACHING_CHILDREN_instance;
  }
  function State_ATTACHED_getInstance() {
    State_initEntries();
    return State_ATTACHED_instance;
  }
  function State_DETACHED_getInstance() {
    State_initEntries();
    return State_DETACHED_instance;
  }
  function Mapper(source, target) {
    Companion_getInstance_132();
    this.e86_1 = source;
    this.f86_1 = target;
    this.h86_1 = State_NOT_ATTACHED_getInstance();
    this.i86_1 = Companion_getInstance_132().c89_1;
    this.j86_1 = null;
    this.k86_1 = true;
  }
  protoOf(Mapper).b88 = function () {
    var tmp = this.g86_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('mappingContext');
    }
  };
  protoOf(Mapper).bp = function () {
    return this.j86_1;
  };
  protoOf(Mapper).g87 = function () {
    return this.k86_1;
  };
  protoOf(Mapper).f89 = function () {
    return this.h86_1.equals(State_ATTACHED_getInstance());
  };
  protoOf(Mapper).a88 = function (conf) {
  };
  protoOf(Mapper).g89 = function (source) {
    return this.b88().h89(this, source);
  };
  protoOf(Mapper).i89 = function (ctx) {
    // Inline function 'kotlin.check' call
    if (!(this.j86_1 == null)) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    this.c88(ctx);
  };
  protoOf(Mapper).j89 = function (ctx, $super) {
    ctx = ctx === VOID ? new MappingContext() : ctx;
    var tmp;
    if ($super === VOID) {
      this.i89(ctx);
      tmp = Unit_instance;
    } else {
      tmp = $super.i89.call(this, ctx);
    }
    return tmp;
  };
  protoOf(Mapper).k89 = function () {
    // Inline function 'kotlin.check' call
    if (!(this.j86_1 == null)) {
      var message = 'Dispose can be called only on the root mapper';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    this.e6j();
  };
  protoOf(Mapper).c88 = function (ctx) {
    // Inline function 'kotlin.check' call
    if (!!this.h86_1.equals(State_ATTACHED_getInstance())) {
      var message = 'Mapper is already attached';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    // Inline function 'kotlin.check' call
    if (!this.h86_1.equals(State_NOT_ATTACHED_getInstance())) {
      var message_0 = "Mapper can't be reused because it was already detached";
      throw IllegalStateException_init_$Create$_0(toString_1(message_0));
    }
    try {
      this.l89(ctx);
    } catch ($p) {
      if ($p instanceof Error) {
        var t = $p;
        ThrowableHandlers_getInstance().k2r_1.j2r(t);
      } else {
        throw $p;
      }
    }
    this.h86_1 = State_ATTACHING_SYNCHRONIZERS_getInstance();
    this.g86_1 = ctx;
    instantiateSynchronizers(this);
    this.b88().m89(this);
    var synchronizerContext = new Mapper$attach$synchronizerContext$1(this);
    // Inline function 'kotlin.sequences.forEach' call
    var _iterator__ex2g4s = this.n89().m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      element.y86(synchronizerContext);
    }
    this.h86_1 = State_ATTACHING_CHILDREN_getInstance();
    // Inline function 'kotlin.sequences.forEach' call
    var _iterator__ex2g4s_0 = this.o35().m();
    while (_iterator__ex2g4s_0.n()) {
      var element_0 = _iterator__ex2g4s_0.o();
      element_0.c88(ctx);
    }
    this.h86_1 = State_ATTACHED_getInstance();
    try {
      this.o89(ctx);
    } catch ($p) {
      if ($p instanceof Error) {
        var t_0 = $p;
        ThrowableHandlers_getInstance().k2r_1.j2r(t_0);
      } else {
        throw $p;
      }
    }
  };
  protoOf(Mapper).e6j = function () {
    try {
      this.c87();
    } catch ($p) {
      if ($p instanceof Error) {
        var t = $p;
        ThrowableHandlers_getInstance().k2r_1.j2r(t);
      } else {
        throw $p;
      }
    }
    var indexedObject = this.i86_1;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var part = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (isInterface(part, Disposable)) {
        try {
          part.zr();
        } catch ($p) {
          if ($p instanceof Error) {
            var t_0 = $p;
            ThrowableHandlers_getInstance().k2r_1.j2r(t_0);
          } else {
            throw $p;
          }
        }
      }
      if (isInterface(part, ChildContainer)) {
        var _iterator__ex2g4s = part.m();
        while (_iterator__ex2g4s.n()) {
          var mapper = _iterator__ex2g4s.o();
          mapper.e6j();
        }
      }
    }
    this.b88().p89(this);
    this.h86_1 = State_DETACHED_getInstance();
    this.i86_1 = Companion_getInstance_132().c89_1;
  };
  protoOf(Mapper).l89 = function (ctx) {
  };
  protoOf(Mapper).o89 = function (ctx) {
  };
  protoOf(Mapper).c87 = function () {
  };
  protoOf(Mapper).n89 = function () {
    // Inline function 'kotlin.sequences.filterIsInstance' call
    var this_0 = asSequence(this.i86_1);
    var tmp = filter(this_0, Mapper$synchronizers$lambda);
    return isInterface(tmp, Sequence) ? tmp : THROW_CCE();
  };
  protoOf(Mapper).o35 = function () {
    // Inline function 'kotlin.sequences.filterIsInstance' call
    var this_0 = asSequence(this.i86_1);
    var tmp = filter(this_0, Mapper$children$lambda);
    var tmp$ret$0 = isInterface(tmp, Sequence) ? tmp : THROW_CCE();
    return flatten_0(tmp$ret$0);
  };
  protoOf(Mapper).a87 = function () {
    return new ChildList(this);
  };
  protoOf(Mapper).q89 = function () {
    return new ChildSet(this);
  };
  protoOf(Mapper).r89 = function () {
    return new ChildProperty_0(this);
  };
  function Mappers$attachRoot$$inlined$toDisposable$1($mapper) {
    this.s89_1 = $mapper;
  }
  protoOf(Mappers$attachRoot$$inlined$toDisposable$1).zr = function () {
    this.s89_1.k89();
    return Unit_instance;
  };
  function Mappers$augment$1($mainMapper, $mappers) {
    this.a8a_1 = $mainMapper;
    this.b8a_1 = $mappers;
    Mapper.call(this, $mainMapper.e86_1, $mainMapper.f86_1);
  }
  protoOf(Mappers$augment$1).o89 = function (ctx) {
    protoOf(Mapper).o89.call(this, ctx);
    // Inline function 'kotlin.apply' call
    var this_0 = this.a87();
    this_0.j(this.a8a_1);
    addAll_0(this_0, this.b8a_1);
  };
  function Mappers() {
  }
  protoOf(Mappers).c8a = function (mapper) {
    mapper.j89();
    // Inline function 'jetbrains.ocelot.base.disposable.toDisposable' call
    return new Mappers$attachRoot$$inlined$toDisposable$1(mapper);
  };
  protoOf(Mappers).d8a = function (mainMapper, mappers) {
    return new Mappers$augment$1(mainMapper, mappers);
  };
  var Mappers_instance;
  function Mappers_getInstance() {
    return Mappers_instance;
  }
  function getMappers($this, _this__u8e3s4, source) {
    var value = _this__u8e3s4.q2(source);
    var tmp;
    if (!(value == null) ? isInterface(value, KtSet) : false) {
      tmp = isInterface(value, KtMutableSet) ? value : THROW_CCE();
    } else {
      if (value instanceof Mapper) {
        tmp = mutableSetOf([value instanceof Mapper ? value : THROW_CCE()]);
      } else {
        throw IllegalArgumentException_init_$Create$_0('Source ' + toString_0(source) + ' was not found in the list of registered sources');
      }
    }
    return tmp;
  }
  function MappingContext$register$lambda($mapper) {
    return function (listener) {
      listener.j87($mapper);
      return Unit_instance;
    };
  }
  function MappingContext$unregister$lambda($mapper) {
    return function (listener) {
      listener.k87($mapper);
      return Unit_instance;
    };
  }
  function MappingContext() {
    var tmp = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp.l87_1 = LinkedHashMap_init_$Create$();
    this.m87_1 = new Listeners();
    var tmp_0 = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp_0.n87_1 = LinkedHashMap_init_$Create$();
  }
  protoOf(MappingContext).p87 = function (listener) {
    return this.m87_1.j2s(listener);
  };
  protoOf(MappingContext).m89 = function (mapper) {
    if (mapper.g87()) {
      var source = mapper.e86_1;
      var tmp0 = this.l87_1;
      var tmp;
      if (this.l87_1.o2(source)) {
        // Inline function 'kotlin.apply' call
        var this_0 = getMappers(this, this.l87_1, source);
        this_0.j(mapper);
        tmp = this_0;
      } else {
        tmp = mapper;
      }
      // Inline function 'kotlin.collections.set' call
      var value = tmp;
      tmp0.t2(source, value);
    }
    this.m87_1.k2s(MappingContext$register$lambda(mapper));
  };
  protoOf(MappingContext).p89 = function (mapper) {
    if (mapper.g87()) {
      var source = mapper.e86_1;
      // Inline function 'kotlin.check' call
      if (!this.l87_1.o2(source)) {
        var message = 'Source ' + toString_0(source) + ' of the mapper ' + toString_1(mapper) + ' was not found in the set of registered sources';
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      }
      var allMappers = getMappers(this, this.l87_1, source);
      var wasRemoved = allMappers.h2(mapper);
      // Inline function 'kotlin.check' call
      if (!wasRemoved) {
        var message_0 = 'Trying to unregister not registered mapper: ' + toString_1(mapper);
        throw IllegalStateException_init_$Create$_0(toString_1(message_0));
      }
      switch (allMappers.p()) {
        case 0:
          this.l87_1.u2(source);
          break;
        case 1:
          var tmp0 = this.l87_1;
          // Inline function 'kotlin.collections.set' call

          var value = first_0(allMappers);
          tmp0.t2(source, value);
          break;
        default:
          // Inline function 'kotlin.collections.set' call

          this.l87_1.t2(source, allMappers);
          break;
      }
    }
    this.m87_1.k2s(MappingContext$unregister$lambda(mapper));
  };
  protoOf(MappingContext).h89 = function (ancestor, source) {
    var result = this.e8a(ancestor, source);
    // Inline function 'kotlin.check' call
    if (!(result.p() <= 1)) {
      var message = 'There are more than one mapper for ' + toString_0(source);
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    return singleOrNull_0(result);
  };
  protoOf(MappingContext).e8a = function (ancestor, source) {
    // Inline function 'kotlin.collections.filter' call
    var tmp0 = this.f8a(source);
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList_init_$Create$();
    var _iterator__ex2g4s = tmp0.m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      if (isDescendant(ancestor, element)) {
        destination.j(element);
      }
    }
    return toSet_0(destination);
  };
  protoOf(MappingContext).g8a = function (property, value) {
    // Inline function 'kotlin.check' call
    if (!!this.n87_1.o2(property)) {
      var message = 'Property ' + property.toString() + ' is already defined';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    // Inline function 'kotlin.require' call
    if (!!(value == null)) {
      var message_0 = 'Trying to set null as a value of ' + property.toString();
      throw IllegalArgumentException_init_$Create$_0(toString_1(message_0));
    }
    var tmp0 = this.n87_1;
    // Inline function 'kotlin.collections.set' call
    var value_0 = !(value == null) ? value : THROW_CCE();
    tmp0.t2(property, value_0);
  };
  protoOf(MappingContext).h8a = function (property) {
    var value = this.n87_1.q2(property);
    $l$block: {
      // Inline function 'kotlin.checkNotNull' call
      if (value == null) {
        var message = 'Property ' + property.toString() + " wasn't found";
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      } else {
        break $l$block;
      }
    }
    return !(value == null) ? value : THROW_CCE();
  };
  protoOf(MappingContext).i8a = function (property) {
    return this.n87_1.o2(property);
  };
  protoOf(MappingContext).o87 = function () {
    // Inline function 'kotlin.collections.flatMap' call
    var tmp0 = this.l87_1.r2();
    // Inline function 'kotlin.collections.flatMapTo' call
    var destination = ArrayList_init_$Create$();
    var _iterator__ex2g4s = tmp0.m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      var list = this.f8a(element);
      addAll_1(destination, list);
    }
    return toSet_0(destination);
  };
  protoOf(MappingContext).f8a = function (source) {
    var tmp;
    if (this.l87_1.o2(source)) {
      tmp = getMappers(this, this.l87_1, source);
    } else {
      // Inline function 'kotlin.collections.setOf' call
      tmp = emptySet();
    }
    return tmp;
  };
  function MappingContextProperty(name) {
    this.j8a_1 = name;
  }
  protoOf(MappingContextProperty).toString = function () {
    return 'MappingContextProperty[' + this.j8a_1 + ']';
  };
  function ObservableCollectionRoleSynchronizer$onAttach$1(this$0) {
    this.k8a_1 = this$0;
    CollectionAdapter.call(this);
  }
  protoOf(ObservableCollectionRoleSynchronizer$onAttach$1).z33 = function (event) {
    var mapper = this.k8a_1.u86(event.u2r());
    this.k8a_1.d86().m2(event.q2r_1, mapper);
    this.k8a_1.p8a_1.m2(event.q2r_1, mapper.f86_1);
    this.k8a_1.w86(mapper);
  };
  protoOf(ObservableCollectionRoleSynchronizer$onAttach$1).m2r = function (event) {
    return this.z33(event);
  };
  protoOf(ObservableCollectionRoleSynchronizer$onAttach$1).b34 = function (event) {
    this.k8a_1.d86().n2(event.q2r_1);
    this.k8a_1.p8a_1.n2(event.q2r_1);
  };
  protoOf(ObservableCollectionRoleSynchronizer$onAttach$1).t2r = function (event) {
    return this.b34(event);
  };
  function ObservableCollectionRoleSynchronizer(source, target, factory) {
    BaseCollectionRoleSynchronizer.call(this, factory);
    this.o8a_1 = source;
    this.p8a_1 = target;
    this.q8a_1 = Companion_getInstance_29().m2l_1;
  }
  protoOf(ObservableCollectionRoleSynchronizer).b87 = function () {
    protoOf(BaseCollectionRoleSynchronizer).b87.call(this);
    // Inline function 'kotlin.require' call
    if (!this.p8a_1.s()) {
      var message = 'Target Collection Should Be Empty';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    (new MapperUpdater(this)).z85(this.o8a_1);
    var _iterator__ex2g4s = this.d86().m();
    while (_iterator__ex2g4s.n()) {
      var mapper = _iterator__ex2g4s.o();
      this.p8a_1.j(mapper.f86_1);
    }
    var tmp = this;
    tmp.q8a_1 = this.o8a_1.x2r(new ObservableCollectionRoleSynchronizer$onAttach$1(this));
  };
  protoOf(ObservableCollectionRoleSynchronizer).c87 = function () {
    protoOf(BaseCollectionRoleSynchronizer).c87.call(this);
    this.q8a_1.zr();
    this.p8a_1.k2();
  };
  function indexOf_12(_this__u8e3s4, item) {
    var tmp0 = _this__u8e3s4.x86();
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.indexOfFirst' call
      var index = 0;
      var _iterator__ex2g4s = tmp0.m();
      while (_iterator__ex2g4s.n()) {
        var item_0 = _iterator__ex2g4s.o();
        if (item_0.e86_1 === item) {
          tmp$ret$1 = index;
          break $l$block;
        }
        index = index + 1 | 0;
      }
      tmp$ret$1 = -1;
    }
    return tmp$ret$1;
  }
  function _get_targetMapper__ndmpif($this) {
    var tmp = $this.v8a_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('targetMapper');
    }
  }
  function sync($this) {
    var modelValue = $this.t8a_1.uv();
    var tmp0_safe_receiver = _get_targetMapper__ndmpif($this).uv();
    var viewValue = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.e86_1;
    if (modelValue === viewValue)
      return Unit_instance;
    if (modelValue == null) {
      _get_targetMapper__ndmpif($this).d2x(null);
      $this.u8a_1.d2x(null);
    } else {
      var mapper = $this.u86(modelValue);
      _get_targetMapper__ndmpif($this).d2x(mapper);
      $this.u8a_1.d2x(mapper.f86_1);
      $this.w86(mapper);
    }
  }
  function SingleChildRoleSynchronizer$attach$lambda(this$0) {
    return function (it) {
      sync(this$0);
      return Unit_instance;
    };
  }
  function SingleChildRoleSynchronizer(childProperty, targetProperty, factory) {
    BaseRoleSynchronizer.call(this, factory);
    this.t8a_1 = childProperty;
    this.u8a_1 = targetProperty;
    this.w8a_1 = Companion_getInstance_29().m2l_1;
  }
  protoOf(SingleChildRoleSynchronizer).x86 = function () {
    var tmp0_safe_receiver = _get_targetMapper__ndmpif(this).uv();
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp = listOf(tmp0_safe_receiver);
    }
    // Inline function 'kotlin.collections.orEmpty' call
    var tmp0_elvis_lhs = tmp;
    return tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
  };
  protoOf(SingleChildRoleSynchronizer).y86 = function (ctx) {
    this.v8a_1 = ctx.z86().r89();
    sync(this);
    var tmp = this;
    tmp.w8a_1 = this.t8a_1.z2r(SingleChildRoleSynchronizer$attach$lambda(this));
  };
  protoOf(SingleChildRoleSynchronizer).e6j = function () {
    this.w8a_1.zr();
    _get_targetMapper__ndmpif(this).d2x(null);
  };
  function Synchronizer() {
  }
  function Synchronizers$forProperty$o$doAttach$lambda($runnable) {
    return function (it) {
      $runnable();
      return Unit_instance;
    };
  }
  function Synchronizers$forProperty$$inlined$forEventSource$1($runnable, $src) {
    this.y8a_1 = $runnable;
    this.z8a_1 = $src;
    DisposableSynchronizer.call(this);
  }
  protoOf(Synchronizers$forProperty$$inlined$forEventSource$1).s87 = function (ctx) {
    this.y8a_1();
    return this.z8a_1.z2r(Synchronizers$forProperty$o$doAttach$lambda(this.y8a_1));
  };
  function Synchronizers$forDisposables$1($disposables) {
    this.a8b_1 = $disposables;
  }
  protoOf(Synchronizers$forDisposables$1).y86 = function (ctx) {
  };
  protoOf(Synchronizers$forDisposables$1).e6j = function () {
    var indexedObject = this.a8b_1;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var disposable = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      disposable.zr();
    }
  };
  function Synchronizers$composite$1($syncs) {
    this.b8b_1 = $syncs;
  }
  protoOf(Synchronizers$composite$1).y86 = function (ctx) {
    var indexedObject = this.b8b_1;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var sync = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      sync.y86(ctx);
    }
  };
  protoOf(Synchronizers$composite$1).e6j = function () {
    var inductionVariable = this.b8b_1.length - 1 | 0;
    if (0 <= inductionVariable)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        this.b8b_1[i].e6j();
      }
       while (0 <= inductionVariable);
  };
  function Synchronizers() {
  }
  protoOf(Synchronizers).c8b = function (source, target, factory) {
    return new ObservableCollectionRoleSynchronizer(source, target, factory);
  };
  protoOf(Synchronizers).d8b = function (source, target, factory) {
    return this.e8b(constantProp(source), target, factory);
  };
  protoOf(Synchronizers).e8b = function (source, target, factory) {
    return new SingleChildRoleSynchronizer(source, target, factory);
  };
  protoOf(Synchronizers).f8b = function (property, sync) {
    // Inline function 'jetbrains.ocelot.mapper.core.Synchronizers.forEventSource' call
    return new Synchronizers$forProperty$$inlined$forEventSource$1(sync, property);
  };
  protoOf(Synchronizers).g8b = function (disposables) {
    return new Synchronizers$forDisposables$1(disposables);
  };
  protoOf(Synchronizers).h8b = function (syncs) {
    return new Synchronizers$composite$1(syncs);
  };
  var Synchronizers_instance;
  function Synchronizers_getInstance() {
    return Synchronizers_instance;
  }
  var State_INITIALIZING_instance;
  var State_ATTACHING_instance;
  var State_ATTACHED_instance_0;
  var State_DETACHING_instance;
  var State_DETACHED_instance_0;
  var State_CLEARING_instance;
  var State_entriesInitialized_0;
  function State_initEntries_0() {
    if (State_entriesInitialized_0)
      return Unit_instance;
    State_entriesInitialized_0 = true;
    State_INITIALIZING_instance = new State_1('INITIALIZING', 0);
    State_ATTACHING_instance = new State_1('ATTACHING', 1);
    State_ATTACHED_instance_0 = new State_1('ATTACHED', 2);
    State_DETACHING_instance = new State_1('DETACHING', 3);
    State_DETACHED_instance_0 = new State_1('DETACHED', 4);
    State_CLEARING_instance = new State_1('CLEARING', 5);
  }
  function _get_context__ps0bpe($this) {
    var tmp = $this.j8b_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('context');
    }
  }
  function expectState($this, expectedStates) {
    var hadExpectedState = false;
    var inductionVariable = 0;
    var last = expectedStates.length;
    $l$loop: while (inductionVariable < last) {
      var expectedState = expectedStates[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if ($this.k8b_1.equals(expectedState)) {
        hadExpectedState = true;
        break $l$loop;
      }
    }
    // Inline function 'kotlin.check' call
    if (!hadExpectedState) {
      var message = "current state: '" + $this.k8b_1.toString() + "', expected: '" + toString_1(toList(expectedStates)) + "'";
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
  }
  function transitionToState($this, state, expectedStateBefore) {
    expectState($this, [expectedStateBefore]);
    $this.k8b_1 = state;
  }
  function attachCurrent($this) {
    expectState($this, [State_ATTACHING_getInstance()]);
    var _iterator__ex2g4s = $this.i8b_1.m();
    while (_iterator__ex2g4s.n()) {
      var synchronizer = _iterator__ex2g4s.o();
      synchronizer.y86(_get_context__ps0bpe($this));
      expectState($this, [State_ATTACHING_getInstance()]);
    }
  }
  function detachCurrent($this) {
    expectState($this, [State_DETACHING_getInstance(), State_CLEARING_getInstance()]);
    var _iterator__ex2g4s = $this.i8b_1.m();
    while (_iterator__ex2g4s.n()) {
      var synchronizer = _iterator__ex2g4s.o();
      synchronizer.e6j();
      expectState($this, [State_DETACHING_getInstance(), State_CLEARING_getInstance()]);
    }
    $this.i8b_1.k2();
  }
  function State_1(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function State_INITIALIZING_getInstance() {
    State_initEntries_0();
    return State_INITIALIZING_instance;
  }
  function State_ATTACHING_getInstance() {
    State_initEntries_0();
    return State_ATTACHING_instance;
  }
  function State_ATTACHED_getInstance_0() {
    State_initEntries_0();
    return State_ATTACHED_instance_0;
  }
  function State_DETACHING_getInstance() {
    State_initEntries_0();
    return State_DETACHING_instance;
  }
  function State_DETACHED_getInstance_0() {
    State_initEntries_0();
    return State_DETACHED_instance_0;
  }
  function State_CLEARING_getInstance() {
    State_initEntries_0();
    return State_CLEARING_instance;
  }
  function ReloadableSynchronizer() {
    this.i8b_1 = ArrayList_init_$Create$();
    this.k8b_1 = State_INITIALIZING_getInstance();
  }
  protoOf(ReloadableSynchronizer).l8b = function (synchronizer) {
    expectState(this, [State_INITIALIZING_getInstance(), State_ATTACHED_getInstance_0()]);
    // Inline function 'kotlin.collections.plusAssign' call
    this.i8b_1.j(synchronizer);
    if (this.k8b_1.equals(State_ATTACHED_getInstance_0())) {
      synchronizer.y86(_get_context__ps0bpe(this));
    }
  };
  protoOf(ReloadableSynchronizer).m8b = function () {
    transitionToState(this, State_ATTACHING_getInstance(), State_INITIALIZING_getInstance());
    attachCurrent(this);
    transitionToState(this, State_ATTACHED_getInstance_0(), State_ATTACHING_getInstance());
  };
  protoOf(ReloadableSynchronizer).y86 = function (ctx) {
    transitionToState(this, State_ATTACHING_getInstance(), State_INITIALIZING_getInstance());
    this.j8b_1 = ctx;
    attachCurrent(this);
    transitionToState(this, State_ATTACHED_getInstance_0(), State_ATTACHING_getInstance());
  };
  protoOf(ReloadableSynchronizer).e6j = function () {
    transitionToState(this, State_DETACHING_getInstance(), State_ATTACHED_getInstance_0());
    detachCurrent(this);
    transitionToState(this, State_DETACHED_getInstance_0(), State_DETACHING_getInstance());
  };
  protoOf(ReloadableSynchronizer).k2 = function () {
    transitionToState(this, State_CLEARING_getInstance(), State_ATTACHED_getInstance_0());
    detachCurrent(this);
    transitionToState(this, State_INITIALIZING_getInstance(), State_CLEARING_getInstance());
  };
  function Companion_133() {
  }
  var Companion_instance_133;
  function Companion_getInstance_133() {
    return Companion_instance_133;
  }
  function DoubleRectangle(origin, dimension) {
    this.n8b_1 = origin;
    this.o8b_1 = dimension;
  }
  protoOf(DoubleRectangle).p8b = function () {
    var result = ArrayList_init_$Create$();
    result.j(new DoubleSegment(this.n8b_1, this.n8b_1.s8b(new DoubleVector(this.o8b_1.q8b_1, 0.0))));
    result.j(new DoubleSegment(this.n8b_1, this.n8b_1.s8b(new DoubleVector(0.0, this.o8b_1.r8b_1))));
    result.j(new DoubleSegment(this.n8b_1.s8b(this.o8b_1), this.n8b_1.s8b(new DoubleVector(this.o8b_1.q8b_1, 0.0))));
    result.j(new DoubleSegment(this.n8b_1.s8b(this.o8b_1), this.n8b_1.s8b(new DoubleVector(0.0, this.o8b_1.r8b_1))));
    return result;
  };
  protoOf(DoubleRectangle).t8b = function (to) {
    var result = 0.0;
    var hasResult = false;
    var _iterator__ex2g4s = this.p8b().m();
    while (_iterator__ex2g4s.n()) {
      var s = _iterator__ex2g4s.o();
      if (!hasResult) {
        result = s.t8b(to);
        hasResult = true;
      } else {
        var distance = s.t8b(to);
        if (distance < result) {
          result = distance;
        }
      }
    }
    return result;
  };
  protoOf(DoubleRectangle).toString = function () {
    return '[rect ' + this.n8b_1.toString() + ', ' + this.o8b_1.toString() + ']';
  };
  protoOf(DoubleRectangle).hashCode = function () {
    var result = this.n8b_1.hashCode();
    result = imul(result, 31) + this.o8b_1.hashCode() | 0;
    return result;
  };
  protoOf(DoubleRectangle).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof DoubleRectangle))
      return false;
    if (!this.n8b_1.equals(other.n8b_1))
      return false;
    if (!this.o8b_1.equals(other.o8b_1))
      return false;
    return true;
  };
  function isDistanceToLineBest($this, v) {
    var es = $this.u8b_1.w8b($this.v8b_1);
    var se = es.x8b();
    var ev = v.w8b($this.v8b_1);
    var sv = v.w8b($this.u8b_1);
    return es.y8b(ev) >= 0 && se.y8b(sv) >= 0;
  }
  function DoubleSegment(start, end) {
    this.u8b_1 = start;
    this.v8b_1 = end;
  }
  protoOf(DoubleSegment).t8b = function (v) {
    var vs = this.u8b_1.w8b(v);
    var ve = this.v8b_1.w8b(v);
    var tmp;
    if (isDistanceToLineBest(this, v)) {
      // Inline function 'kotlin.math.abs' call
      var x = vs.q8b_1 * ve.r8b_1 - vs.r8b_1 * ve.q8b_1;
      var pVolume = Math.abs(x);
      tmp = pVolume / this.z8b();
    } else {
      var tmp0 = vs.z8b();
      // Inline function 'kotlin.math.min' call
      var b = ve.z8b();
      tmp = Math.min(tmp0, b);
    }
    return tmp;
  };
  protoOf(DoubleSegment).z8b = function () {
    return this.u8b_1.w8b(this.v8b_1).z8b();
  };
  protoOf(DoubleSegment).toString = function () {
    return '[' + this.u8b_1.toString() + ' -> ' + this.v8b_1.toString() + ']';
  };
  protoOf(DoubleSegment).hashCode = function () {
    var result = this.u8b_1.hashCode();
    result = imul(result, 31) + this.v8b_1.hashCode() | 0;
    return result;
  };
  protoOf(DoubleSegment).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof DoubleSegment))
      return false;
    if (!this.u8b_1.equals(other.u8b_1))
      return false;
    if (!this.v8b_1.equals(other.v8b_1))
      return false;
    return true;
  };
  function Companion_134() {
    Companion_instance_134 = this;
    this.a8c_1 = new DoubleVector(0.0, 0.0);
  }
  var Companion_instance_134;
  function Companion_getInstance_134() {
    if (Companion_instance_134 == null)
      new Companion_134();
    return Companion_instance_134;
  }
  function DoubleVector(x, y) {
    Companion_getInstance_134();
    this.q8b_1 = x;
    this.r8b_1 = y;
  }
  protoOf(DoubleVector).s8b = function (v) {
    return new DoubleVector(this.q8b_1 + v.q8b_1, this.r8b_1 + v.r8b_1);
  };
  protoOf(DoubleVector).w8b = function (v) {
    return new DoubleVector(this.q8b_1 - v.q8b_1, this.r8b_1 - v.r8b_1);
  };
  protoOf(DoubleVector).y8b = function (v) {
    return this.q8b_1 * v.q8b_1 + this.r8b_1 * v.r8b_1;
  };
  protoOf(DoubleVector).x8b = function () {
    return new DoubleVector(-this.q8b_1, -this.r8b_1);
  };
  protoOf(DoubleVector).z8b = function () {
    // Inline function 'kotlin.math.sqrt' call
    var x = this.q8b_1 * this.q8b_1 + this.r8b_1 * this.r8b_1;
    return Math.sqrt(x);
  };
  protoOf(DoubleVector).toString = function () {
    return '(' + this.q8b_1 + ', ' + this.r8b_1 + ')';
  };
  protoOf(DoubleVector).hashCode = function () {
    var result = getNumberHashCode(this.q8b_1);
    result = imul(result, 31) + getNumberHashCode(this.r8b_1) | 0;
    return result;
  };
  protoOf(DoubleVector).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof DoubleVector))
      return false;
    if (!equals(this.q8b_1, other.q8b_1))
      return false;
    if (!equals(this.r8b_1, other.r8b_1))
      return false;
    return true;
  };
  function Rectangle_init_$Init$(x, y, width, height, $this) {
    Rectangle.call($this, new Vector(x, y), new Vector(width, height));
    return $this;
  }
  function Rectangle_init_$Create$(x, y, width, height) {
    return Rectangle_init_$Init$(x, y, width, height, objectCreate(protoOf(Rectangle)));
  }
  function toDoubleRectangle($this) {
    return new DoubleRectangle($this.b8c_1.f8c(), $this.c8c_1.f8c());
  }
  function Companion_135() {
    Companion_instance_135 = this;
    this.g8c_1 = new Rectangle(Companion_getInstance_136().h8c_1, Companion_getInstance_136().h8c_1);
  }
  var Companion_instance_135;
  function Companion_getInstance_135() {
    if (Companion_instance_135 == null)
      new Companion_135();
    return Companion_instance_135;
  }
  function Rectangle(origin, dimension) {
    Companion_getInstance_135();
    this.b8c_1 = origin;
    this.c8c_1 = dimension;
  }
  protoOf(Rectangle).i8c = function (v) {
    return new Rectangle(this.b8c_1.i8c(v), this.c8c_1);
  };
  protoOf(Rectangle).j8c = function (v) {
    return new Rectangle(this.b8c_1.j8c(v), this.c8c_1);
  };
  protoOf(Rectangle).k8c = function (r) {
    return this.l8c(r.b8c_1) && this.l8c(r.b8c_1.i8c(r.c8c_1));
  };
  protoOf(Rectangle).l8c = function (v) {
    return this.b8c_1.d8c_1 <= v.d8c_1 && (this.b8c_1.d8c_1 + this.c8c_1.d8c_1 | 0) >= v.d8c_1 && this.b8c_1.e8c_1 <= v.e8c_1 && (this.b8c_1.e8c_1 + this.c8c_1.e8c_1 | 0) >= v.e8c_1;
  };
  protoOf(Rectangle).m8c = function (rect) {
    var newOrigin = this.b8c_1.n8c(rect.b8c_1);
    var corner = this.b8c_1.i8c(this.c8c_1);
    var rectCorner = rect.b8c_1.i8c(rect.c8c_1);
    var newCorner = corner.o8c(rectCorner);
    var newDimension = newCorner.j8c(newOrigin);
    return new Rectangle(newOrigin, newDimension);
  };
  protoOf(Rectangle).p8c = function (rect) {
    var t1 = this.b8c_1;
    var t2 = this.b8c_1.i8c(this.c8c_1);
    var r1 = rect.b8c_1;
    var r2 = rect.b8c_1.i8c(rect.c8c_1);
    return r2.d8c_1 >= t1.d8c_1 && t2.d8c_1 >= r1.d8c_1 && r2.e8c_1 >= t1.e8c_1 && t2.e8c_1 >= r1.e8c_1;
  };
  protoOf(Rectangle).q8c = function (r) {
    // Inline function 'kotlin.check' call
    if (!this.p8c(r)) {
      var message = 'rectangle [' + this.toString() + "] doesn't intersect [" + r.toString() + ']';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    var too = this.b8c_1.i8c(this.c8c_1);
    var roo = r.b8c_1.i8c(r.c8c_1);
    var ioo = too.n8c(roo);
    var io = this.b8c_1.o8c(r.b8c_1);
    return new Rectangle(io, ioo.j8c(io));
  };
  protoOf(Rectangle).r8c = function (dim) {
    return new Rectangle(this.b8c_1, dim);
  };
  protoOf(Rectangle).s8c = function (to) {
    return toDoubleRectangle(this).t8b(to.f8c());
  };
  protoOf(Rectangle).t8c = function () {
    return Companion_instance_37.x36(this.b8c_1.d8c_1, this.c8c_1.d8c_1);
  };
  protoOf(Rectangle).u8c = function () {
    return Companion_instance_37.x36(this.b8c_1.e8c_1, this.c8c_1.e8c_1);
  };
  protoOf(Rectangle).v8c = function () {
    return this.b8c_1.i8c(new Vector(this.c8c_1.d8c_1 / 2 | 0, this.c8c_1.e8c_1 / 2 | 0));
  };
  protoOf(Rectangle).toString = function () {
    return this.b8c_1.toString() + ' - ' + this.c8c_1.toString();
  };
  protoOf(Rectangle).fg = function () {
    return this.b8c_1;
  };
  protoOf(Rectangle).gg = function () {
    return this.c8c_1;
  };
  protoOf(Rectangle).hashCode = function () {
    var result = this.b8c_1.hashCode();
    result = imul(result, 31) + this.c8c_1.hashCode() | 0;
    return result;
  };
  protoOf(Rectangle).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Rectangle))
      return false;
    if (!this.b8c_1.equals(other.b8c_1))
      return false;
    if (!this.c8c_1.equals(other.c8c_1))
      return false;
    return true;
  };
  function assertOuterInner($this, outer, inner) {
    // Inline function 'kotlin.require' call
    if (!outer.k8c(inner)) {
      var message = 'Outer does not contain inner: outer = ' + outer.toString() + ', inner = ' + inner.toString();
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
  }
  function topLeft($this, r) {
    return r.b8c_1;
  }
  function bottomLeft($this, r) {
    return r.b8c_1.i8c(new Vector(0, r.c8c_1.e8c_1));
  }
  function Rectangles() {
  }
  protoOf(Rectangles).w8c = function (r) {
    return new Rectangle(Companion_getInstance_136().h8c_1, r.c8c_1);
  };
  protoOf(Rectangles).x8c = function (inner, outer) {
    assertOuterInner(this, outer, inner);
    return topLeft(this, inner).e8c_1 - topLeft(this, outer).e8c_1 | 0;
  };
  protoOf(Rectangles).y8c = function (inner, outer) {
    assertOuterInner(this, outer, inner);
    return bottomLeft(this, outer).e8c_1 - bottomLeft(this, inner).e8c_1 | 0;
  };
  protoOf(Rectangles).z8c = function (inner, outer) {
    assertOuterInner(this, outer, inner);
    return topLeft(this, inner).d8c_1 - topLeft(this, outer).d8c_1 | 0;
  };
  protoOf(Rectangles).a8d = function (inner, outer) {
    assertOuterInner(this, outer, inner);
    return this.b8d(outer).d8c_1 - this.b8d(inner).d8c_1 | 0;
  };
  protoOf(Rectangles).c8d = function (r, distance) {
    var change = new Vector(0, distance);
    return new Rectangle(r.b8c_1.j8c(change), r.c8c_1.i8c(change));
  };
  protoOf(Rectangles).d8d = function (r, distance) {
    return r.r8c(r.c8c_1.i8c(new Vector(0, distance)));
  };
  protoOf(Rectangles).e8d = function (r, distance) {
    var change = new Vector(distance, 0);
    return new Rectangle(r.b8c_1.j8c(change), r.c8c_1.i8c(change));
  };
  protoOf(Rectangles).f8d = function (r, distance) {
    return r.r8c(r.c8c_1.i8c(new Vector(distance, 0)));
  };
  protoOf(Rectangles).g8d = function (left, r, right) {
    return this.f8d(this.e8d(r, left), right);
  };
  protoOf(Rectangles).b8d = function (r) {
    return r.b8c_1.i8c(new Vector(r.c8c_1.d8c_1, 0));
  };
  var Rectangles_instance;
  function Rectangles_getInstance() {
    return Rectangles_instance;
  }
  function Companion_136() {
    Companion_instance_136 = this;
    this.h8c_1 = new Vector(0, 0);
  }
  var Companion_instance_136;
  function Companion_getInstance_136() {
    if (Companion_instance_136 == null)
      new Companion_136();
    return Companion_instance_136;
  }
  function Vector(x, y) {
    Companion_getInstance_136();
    this.d8c_1 = x;
    this.e8c_1 = y;
  }
  protoOf(Vector).i8c = function (v) {
    return new Vector(this.d8c_1 + v.d8c_1 | 0, this.e8c_1 + v.e8c_1 | 0);
  };
  protoOf(Vector).j8c = function (v) {
    return this.i8c(v.x8b());
  };
  protoOf(Vector).x8b = function () {
    return new Vector(-this.d8c_1 | 0, -this.e8c_1 | 0);
  };
  protoOf(Vector).o8c = function (v) {
    var tmp0 = this.d8c_1;
    // Inline function 'kotlin.math.max' call
    var b = v.d8c_1;
    var tmp = Math.max(tmp0, b);
    var tmp0_0 = this.e8c_1;
    // Inline function 'kotlin.math.max' call
    var b_0 = v.e8c_1;
    var tmp$ret$1 = Math.max(tmp0_0, b_0);
    return new Vector(tmp, tmp$ret$1);
  };
  protoOf(Vector).n8c = function (v) {
    var tmp0 = this.d8c_1;
    // Inline function 'kotlin.math.min' call
    var b = v.d8c_1;
    var tmp = Math.min(tmp0, b);
    var tmp0_0 = this.e8c_1;
    // Inline function 'kotlin.math.min' call
    var b_0 = v.e8c_1;
    var tmp$ret$1 = Math.min(tmp0_0, b_0);
    return new Vector(tmp, tmp$ret$1);
  };
  protoOf(Vector).x26 = function (i) {
    return new Vector(imul(this.d8c_1, i), imul(this.e8c_1, i));
  };
  protoOf(Vector).f8c = function () {
    return new DoubleVector(this.d8c_1, this.e8c_1);
  };
  protoOf(Vector).toString = function () {
    return '(' + this.d8c_1 + ', ' + this.e8c_1 + ')';
  };
  protoOf(Vector).fg = function () {
    return this.d8c_1;
  };
  protoOf(Vector).gg = function () {
    return this.e8c_1;
  };
  protoOf(Vector).hashCode = function () {
    var result = this.d8c_1;
    result = imul(result, 31) + this.e8c_1 | 0;
    return result;
  };
  protoOf(Vector).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Vector))
      return false;
    if (!(this.d8c_1 === other.d8c_1))
      return false;
    if (!(this.e8c_1 === other.e8c_1))
      return false;
    return true;
  };
  function DomUtil$timerBasedProperty$o$doAddListeners$lambda(this$0) {
    return function () {
      this$0.r30();
      return Unit_instance;
    };
  }
  function timerBasedProperty($this, supplier, period) {
    return new DomUtil$timerBasedProperty$1(period, supplier);
  }
  function DomUtil$nodeChildren$1($node) {
    this.i8d_1 = $node;
    AbstractMutableList.call(this);
  }
  protoOf(DomUtil$nodeChildren$1).p = function () {
    return get_childCount(this.i8d_1);
  };
  protoOf(DomUtil$nodeChildren$1).r = function (index) {
    return getChild(this.i8d_1, index);
  };
  protoOf(DomUtil$nodeChildren$1).j8d = function (index, element) {
    // Inline function 'kotlin.check' call
    if (!(ensureNotNull(element).parentNode == null)) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    var child = ensureNotNull(this.r(index));
    this.i8d_1.replaceChild(child, element);
    return child;
  };
  protoOf(DomUtil$nodeChildren$1).l2 = function (index, element) {
    return this.j8d(index, (element == null ? true : element instanceof Node) ? element : THROW_CCE());
  };
  protoOf(DomUtil$nodeChildren$1).k8d = function (index, element) {
    // Inline function 'kotlin.check' call
    if (!(ensureNotNull(element).parentNode == null)) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    if (index === 0) {
      insertFirst(this.i8d_1, element);
    } else {
      var prev = getChild(this.i8d_1, index - 1 | 0);
      insertAfter(this.i8d_1, element, prev);
    }
  };
  protoOf(DomUtil$nodeChildren$1).m2 = function (index, element) {
    return this.k8d(index, (element == null ? true : element instanceof Node) ? element : THROW_CCE());
  };
  protoOf(DomUtil$nodeChildren$1).n2 = function (index) {
    var child = ensureNotNull(getChild(this.i8d_1, index));
    this.i8d_1.removeChild(child);
    return child;
  };
  function DomUtil$dimension$lambda($element) {
    return function () {
      return new Vector($element.clientWidth, $element.clientHeight);
    };
  }
  function DomUtil$timerBasedProperty$1($period, $supplier) {
    this.o8d_1 = $period;
    this.p8d_1 = $supplier;
    UpdatableProperty.call(this);
    this.n8d_1 = -1;
  }
  protoOf(DomUtil$timerBasedProperty$1).r2w = function () {
    var handler = DomUtil$timerBasedProperty$o$doAddListeners$lambda(this);
    this.n8d_1 = window.setInterval(handler, this.o8d_1);
  };
  protoOf(DomUtil$timerBasedProperty$1).s2w = function () {
    return window.clearInterval(this.n8d_1);
  };
  protoOf(DomUtil$timerBasedProperty$1).q2w = function () {
    return this.p8d_1();
  };
  function DomUtil() {
  }
  protoOf(DomUtil).q8d = function (node) {
    return new DomUtil$nodeChildren$1(node);
  };
  protoOf(DomUtil).r8d = function (element) {
    var supplier = DomUtil$dimension$lambda(element);
    return timerBasedProperty(this, supplier, 200);
  };
  var DomUtil_instance;
  function DomUtil_getInstance() {
    return DomUtil_instance;
  }
  var CssUnit_EM_instance;
  var CssUnit_NUMBER_instance;
  var CssUnit_ENUMERABLE_instance;
  var CssUnit_PX_instance;
  var CssUnit_PERCENT_instance;
  var CssUnit_VW_instance;
  var CssUnit_VH_instance;
  var CssUnit_entriesInitialized;
  function CssUnit_initEntries() {
    if (CssUnit_entriesInitialized)
      return Unit_instance;
    CssUnit_entriesInitialized = true;
    CssUnit_EM_instance = new CssUnit('EM', 0, 'em');
    CssUnit_NUMBER_instance = new CssUnit('NUMBER', 1, '');
    CssUnit_ENUMERABLE_instance = new CssUnit('ENUMERABLE', 2, '');
    CssUnit_PX_instance = new CssUnit('PX', 3, 'px');
    CssUnit_PERCENT_instance = new CssUnit('PERCENT', 4, '%');
    CssUnit_VW_instance = new CssUnit('VW', 5, 'vw');
    CssUnit_VH_instance = new CssUnit('VH', 6, 'vh');
  }
  function CssUnit(name, ordinal, stringRepresentation) {
    Enum.call(this, name, ordinal);
    this.u8d_1 = stringRepresentation;
  }
  function CssUnit_PX_getInstance() {
    CssUnit_initEntries();
    return CssUnit_PX_instance;
  }
  function setDisplay(_this__u8e3s4, display) {
    return doSetProperty(_this__u8e3s4, 'display', display);
  }
  function setVisibility(_this__u8e3s4, visibility) {
    return doSetProperty(_this__u8e3s4, 'visibility', visibility);
  }
  function setFont(_this__u8e3s4, value) {
    return doSetProperty_0(_this__u8e3s4, 'font', value);
  }
  function doSetProperty(_this__u8e3s4, name, value) {
    doSetProperty_0(_this__u8e3s4, name, value.v8d());
    return _this__u8e3s4;
  }
  function doSetProperty_0(_this__u8e3s4, name, value) {
    _this__u8e3s4.setProperty(name, value == null ? '' : value);
    return _this__u8e3s4;
  }
  function setTop(_this__u8e3s4, top, unit) {
    unit = unit === VOID ? CssUnit_PX_getInstance() : unit;
    return doSetProperty_1(_this__u8e3s4, 'top', top, unit);
  }
  function setHeight(_this__u8e3s4, height, unit) {
    unit = unit === VOID ? CssUnit_PX_getInstance() : unit;
    return doSetProperty_1(_this__u8e3s4, 'height', height, unit);
  }
  function setWidth(_this__u8e3s4, width, unit) {
    unit = unit === VOID ? CssUnit_PX_getInstance() : unit;
    return doSetProperty_1(_this__u8e3s4, 'width', width, unit);
  }
  function clearWidth(_this__u8e3s4) {
    return clearProperty(_this__u8e3s4, 'width');
  }
  function clearHeight(_this__u8e3s4) {
    return clearProperty(_this__u8e3s4, 'height');
  }
  function clearBorderTop(_this__u8e3s4) {
    return clearProperty(_this__u8e3s4, 'border-top');
  }
  function clearBorderBottom(_this__u8e3s4) {
    return clearProperty(_this__u8e3s4, 'border-bottom');
  }
  function clearBorderLeft(_this__u8e3s4) {
    return clearProperty(_this__u8e3s4, 'border-left');
  }
  function clearBorderRight(_this__u8e3s4) {
    return clearProperty(_this__u8e3s4, 'border-right');
  }
  function clearOutline(_this__u8e3s4) {
    return clearProperty(_this__u8e3s4, 'outline');
  }
  function setBorderTop(_this__u8e3s4, border) {
    return doSetProperty_0(_this__u8e3s4, 'border-top', border);
  }
  function setBorderBottom(_this__u8e3s4, border) {
    return doSetProperty_0(_this__u8e3s4, 'border-bottom', border);
  }
  function setBorderRight(_this__u8e3s4, border) {
    return doSetProperty_0(_this__u8e3s4, 'border-right', border);
  }
  function setOutline(_this__u8e3s4, outline) {
    return doSetProperty_0(_this__u8e3s4, 'outline', outline);
  }
  function clearBackgroundColor(_this__u8e3s4) {
    return clearProperty(_this__u8e3s4, 'background-color');
  }
  function setBackgroundColor(_this__u8e3s4, color) {
    return doSetProperty_0(_this__u8e3s4, 'background-color', color);
  }
  function getProperty(_this__u8e3s4, name) {
    return _this__u8e3s4.getPropertyValue(name);
  }
  function get_cssOverflow(_this__u8e3s4) {
    return Companion_instance_137.z2g(getProperty(_this__u8e3s4, 'overflow'));
  }
  function get_cssOverflowX(_this__u8e3s4) {
    return Companion_instance_137.z2g(getProperty(_this__u8e3s4, 'overflow-x'));
  }
  function get_cssOverflowY(_this__u8e3s4) {
    return Companion_instance_137.z2g(getProperty(_this__u8e3s4, 'overflow-y'));
  }
  function setLeft(_this__u8e3s4, left, unit) {
    unit = unit === VOID ? CssUnit_PX_getInstance() : unit;
    return doSetProperty_1(_this__u8e3s4, 'left', left, unit);
  }
  function setPosition(_this__u8e3s4, position) {
    return doSetProperty(_this__u8e3s4, 'position', position);
  }
  function setAlignItems(_this__u8e3s4, alignItems) {
    return doSetProperty(_this__u8e3s4, 'align-items', alignItems);
  }
  function clearAlignItems(_this__u8e3s4) {
    return clearProperty(_this__u8e3s4, 'align-items');
  }
  function setSelfAlignment(_this__u8e3s4, alignItems) {
    return doSetProperty(_this__u8e3s4, 'self-alignment', alignItems);
  }
  function clearSelfAlignment(_this__u8e3s4) {
    return clearProperty(_this__u8e3s4, 'self-alignment');
  }
  function setZIndex(_this__u8e3s4, zIndex) {
    return doSetProperty_0(_this__u8e3s4, 'z-index', zIndex.toString());
  }
  function setMarginRight(_this__u8e3s4, margin, unit) {
    unit = unit === VOID ? CssUnit_PX_getInstance() : unit;
    return doSetProperty_1(_this__u8e3s4, 'margin-right', margin, unit);
  }
  function setMarginBottom(_this__u8e3s4, margin, unit) {
    unit = unit === VOID ? CssUnit_PX_getInstance() : unit;
    return doSetProperty_1(_this__u8e3s4, 'margin-bottom', margin, unit);
  }
  function clearDisplay(_this__u8e3s4) {
    return clearProperty(_this__u8e3s4, 'display');
  }
  function setOverflowX(_this__u8e3s4, overflow) {
    return doSetProperty(_this__u8e3s4, 'overflow-x', overflow);
  }
  function setMaxWidth(_this__u8e3s4, width, unit) {
    unit = unit === VOID ? CssUnit_PX_getInstance() : unit;
    return doSetProperty_1(_this__u8e3s4, 'max-width', width, unit);
  }
  function setMaxHeight(_this__u8e3s4, height, unit) {
    unit = unit === VOID ? CssUnit_PX_getInstance() : unit;
    return doSetProperty_1(_this__u8e3s4, 'max-height', height, unit);
  }
  function setOverflowY(_this__u8e3s4, overflow) {
    return doSetProperty(_this__u8e3s4, 'overflow-y', overflow);
  }
  function setVerticalAlign(_this__u8e3s4, align) {
    return doSetProperty(_this__u8e3s4, 'vertical-align', align);
  }
  function setPadding(_this__u8e3s4, padding, unit) {
    unit = unit === VOID ? CssUnit_PX_getInstance() : unit;
    setPaddingLeft(_this__u8e3s4, padding, unit);
    setPaddingRight(_this__u8e3s4, padding, unit);
    setPaddingTop(_this__u8e3s4, padding, unit);
    setPaddingBottom(_this__u8e3s4, padding, unit);
    return _this__u8e3s4;
  }
  function setColor(_this__u8e3s4, color) {
    return doSetProperty_0(_this__u8e3s4, 'color', color);
  }
  function setWhiteSpace(_this__u8e3s4, whiteSpace) {
    return doSetProperty(_this__u8e3s4, 'white-space', whiteSpace);
  }
  function setFontWeight(_this__u8e3s4, value) {
    return doSetProperty(_this__u8e3s4, 'font-weight', value);
  }
  function setFontStyle_0(_this__u8e3s4, value) {
    return doSetProperty(_this__u8e3s4, 'font-style', value);
  }
  function setFontFamily(_this__u8e3s4, value) {
    return doSetProperty_0(_this__u8e3s4, 'font-family', value);
  }
  function setFontSize(_this__u8e3s4, value, unit) {
    unit = unit === VOID ? CssUnit_PX_getInstance() : unit;
    return doSetProperty_1(_this__u8e3s4, 'font-size', value, unit);
  }
  function setOverflow(_this__u8e3s4, overflow) {
    return doSetProperty(_this__u8e3s4, 'overflow', overflow);
  }
  function setBorderStyle(_this__u8e3s4, value) {
    return doSetProperty(_this__u8e3s4, 'border-style', value);
  }
  function setOutlineStyle(_this__u8e3s4, value) {
    return doSetProperty(_this__u8e3s4, 'outline-style', value);
  }
  function clearMarginBottom(_this__u8e3s4) {
    return clearProperty(_this__u8e3s4, 'margin-bottom');
  }
  function setMarginTop(_this__u8e3s4, margin, unit) {
    unit = unit === VOID ? CssUnit_PX_getInstance() : unit;
    return doSetProperty_1(_this__u8e3s4, 'margin-top', margin, unit);
  }
  function clearMarginTop(_this__u8e3s4) {
    return clearProperty(_this__u8e3s4, 'margin-top');
  }
  function setStrokeWidth(_this__u8e3s4, width, unit) {
    unit = unit === VOID ? CssUnit_PX_getInstance() : unit;
    return doSetProperty_1(_this__u8e3s4, 'stroke-width', width, unit);
  }
  function setFill(_this__u8e3s4, fill) {
    return doSetProperty_0(_this__u8e3s4, 'fill', fill);
  }
  function setPaddingLeft(_this__u8e3s4, padding, unit) {
    unit = unit === VOID ? CssUnit_PX_getInstance() : unit;
    return doSetProperty_1(_this__u8e3s4, 'padding-left', padding, unit);
  }
  function setClear(_this__u8e3s4, clear) {
    return doSetProperty(_this__u8e3s4, 'clear', clear);
  }
  function setFloat(_this__u8e3s4, cssFloat) {
    return doSetProperty(_this__u8e3s4, 'float', cssFloat);
  }
  function clearOutlineStyle(_this__u8e3s4) {
    return clearProperty(_this__u8e3s4, 'outline-style');
  }
  function clearOutlineColor(_this__u8e3s4) {
    return clearProperty(_this__u8e3s4, 'outline-color');
  }
  function clearBorderWidth(_this__u8e3s4) {
    return clearProperty(_this__u8e3s4, 'border-width');
  }
  function setOutlineColor(_this__u8e3s4, color) {
    return doSetProperty_0(_this__u8e3s4, 'outline-color', color);
  }
  function setOutlineWidth(_this__u8e3s4, width, unit) {
    unit = unit === VOID ? CssUnit_PX_getInstance() : unit;
    return doSetProperty_1(_this__u8e3s4, 'outline-width', width, unit);
  }
  function setBoxShadow(_this__u8e3s4, value) {
    return doSetProperty_0(_this__u8e3s4, 'box-shadow', value);
  }
  function clearBoxShadow(_this__u8e3s4) {
    return clearProperty(_this__u8e3s4, 'box-shadow');
  }
  function setBottom(_this__u8e3s4, bottom, unit) {
    unit = unit === VOID ? CssUnit_PX_getInstance() : unit;
    return doSetProperty_1(_this__u8e3s4, 'bottom', bottom, unit);
  }
  function doSetProperty_1(_this__u8e3s4, name, value, unit) {
    return doSetProperty_0(_this__u8e3s4, name, toString_0(value) + unit.u8d_1);
  }
  function clearProperty(_this__u8e3s4, name) {
    _this__u8e3s4.removeProperty(name);
    return _this__u8e3s4;
  }
  function setPaddingRight(_this__u8e3s4, padding, unit) {
    unit = unit === VOID ? CssUnit_PX_getInstance() : unit;
    return doSetProperty_1(_this__u8e3s4, 'padding-right', padding, unit);
  }
  function setPaddingTop(_this__u8e3s4, padding, unit) {
    unit = unit === VOID ? CssUnit_PX_getInstance() : unit;
    return doSetProperty_1(_this__u8e3s4, 'padding-top', padding, unit);
  }
  function setPaddingBottom(_this__u8e3s4, padding, unit) {
    unit = unit === VOID ? CssUnit_PX_getInstance() : unit;
    return doSetProperty_1(_this__u8e3s4, 'padding-bottom', padding, unit);
  }
  var CssAlignItem_DEFAULT_instance;
  var CssAlignItem_CENTER_instance;
  var CssAlignItem_STRETCH_instance;
  var CssAlignItem_FLEX_START_instance;
  var CssAlignItem_FLEX_END_instance;
  var CssAlignItem_entriesInitialized;
  function CssAlignItem_initEntries() {
    if (CssAlignItem_entriesInitialized)
      return Unit_instance;
    CssAlignItem_entriesInitialized = true;
    CssAlignItem_DEFAULT_instance = new CssAlignItem('DEFAULT', 0, 'default');
    CssAlignItem_CENTER_instance = new CssAlignItem('CENTER', 1, 'center');
    CssAlignItem_STRETCH_instance = new CssAlignItem('STRETCH', 2, 'stretch');
    CssAlignItem_FLEX_START_instance = new CssAlignItem('FLEX_START', 3, 'flex-start');
    CssAlignItem_FLEX_END_instance = new CssAlignItem('FLEX_END', 4, 'flex-end');
  }
  function CssAlignItem(name, ordinal, stringQualifier) {
    Enum.call(this, name, ordinal);
    this.y8d_1 = stringQualifier;
  }
  protoOf(CssAlignItem).v8d = function () {
    return this.y8d_1;
  };
  function CssAlignItem_STRETCH_getInstance() {
    CssAlignItem_initEntries();
    return CssAlignItem_STRETCH_instance;
  }
  function CssAlignItem_FLEX_START_getInstance() {
    CssAlignItem_initEntries();
    return CssAlignItem_FLEX_START_instance;
  }
  function CssAlignItem_FLEX_END_getInstance() {
    CssAlignItem_initEntries();
    return CssAlignItem_FLEX_END_instance;
  }
  function parse_0(str, values) {
    var inductionVariable = 0;
    var last = values.length;
    while (inductionVariable < last) {
      var value = values[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (equals_0(value.v8d(), str, true)) {
        return value;
      }
    }
    return null;
  }
  var CssBorderStyle_NONE_instance;
  var CssBorderStyle_DOTTED_instance;
  var CssBorderStyle_DASHED_instance;
  var CssBorderStyle_HIDDEN_instance;
  var CssBorderStyle_SOLID_instance;
  var CssBorderStyle_entriesInitialized;
  function CssBorderStyle_initEntries() {
    if (CssBorderStyle_entriesInitialized)
      return Unit_instance;
    CssBorderStyle_entriesInitialized = true;
    CssBorderStyle_NONE_instance = new CssBorderStyle('NONE', 0, 'none');
    CssBorderStyle_DOTTED_instance = new CssBorderStyle('DOTTED', 1, 'dotted');
    CssBorderStyle_DASHED_instance = new CssBorderStyle('DASHED', 2, 'dashed');
    CssBorderStyle_HIDDEN_instance = new CssBorderStyle('HIDDEN', 3, 'hidden');
    CssBorderStyle_SOLID_instance = new CssBorderStyle('SOLID', 4, 'solid');
  }
  function CssBorderStyle(name, ordinal, stringQualifier) {
    Enum.call(this, name, ordinal);
    this.b8e_1 = stringQualifier;
  }
  protoOf(CssBorderStyle).v8d = function () {
    return this.b8e_1;
  };
  function CssBorderStyle_NONE_getInstance() {
    CssBorderStyle_initEntries();
    return CssBorderStyle_NONE_instance;
  }
  var CssClear_NONE_instance;
  var CssClear_BOTH_instance;
  var CssClear_LEFT_instance;
  var CssClear_RIGHT_instance;
  var CssClear_entriesInitialized;
  function CssClear_initEntries() {
    if (CssClear_entriesInitialized)
      return Unit_instance;
    CssClear_entriesInitialized = true;
    CssClear_NONE_instance = new CssClear('NONE', 0, 'none');
    CssClear_BOTH_instance = new CssClear('BOTH', 1, 'both');
    CssClear_LEFT_instance = new CssClear('LEFT', 2, 'left');
    CssClear_RIGHT_instance = new CssClear('RIGHT', 3, 'right');
  }
  function CssClear(name, ordinal, stringQualifier) {
    Enum.call(this, name, ordinal);
    this.e8e_1 = stringQualifier;
  }
  protoOf(CssClear).v8d = function () {
    return this.e8e_1;
  };
  function CssClear_BOTH_getInstance() {
    CssClear_initEntries();
    return CssClear_BOTH_instance;
  }
  var CssDisplay_DEFAULT_instance;
  var CssDisplay_NONE_instance;
  var CssDisplay_BLOCK_instance;
  var CssDisplay_FLEX_instance;
  var CssDisplay_GRID_instance;
  var CssDisplay_INLINE_BLOCK_instance;
  var CssDisplay_entriesInitialized;
  function CssDisplay_initEntries() {
    if (CssDisplay_entriesInitialized)
      return Unit_instance;
    CssDisplay_entriesInitialized = true;
    CssDisplay_DEFAULT_instance = new CssDisplay('DEFAULT', 0, 'default');
    CssDisplay_NONE_instance = new CssDisplay('NONE', 1, 'none');
    CssDisplay_BLOCK_instance = new CssDisplay('BLOCK', 2, 'block');
    CssDisplay_FLEX_instance = new CssDisplay('FLEX', 3, 'flex');
    CssDisplay_GRID_instance = new CssDisplay('GRID', 4, 'grid');
    CssDisplay_INLINE_BLOCK_instance = new CssDisplay('INLINE_BLOCK', 5, 'inline-block');
  }
  function CssDisplay(name, ordinal, stringQualifier) {
    Enum.call(this, name, ordinal);
    this.h8e_1 = stringQualifier;
  }
  protoOf(CssDisplay).v8d = function () {
    return this.h8e_1;
  };
  function CssDisplay_NONE_getInstance() {
    CssDisplay_initEntries();
    return CssDisplay_NONE_instance;
  }
  function CssDisplay_BLOCK_getInstance() {
    CssDisplay_initEntries();
    return CssDisplay_BLOCK_instance;
  }
  function CssDisplay_INLINE_BLOCK_getInstance() {
    CssDisplay_initEntries();
    return CssDisplay_INLINE_BLOCK_instance;
  }
  var CssFloat_NONE_instance;
  var CssFloat_LEFT_instance;
  var CssFloat_RIGHT_instance;
  var CssFloat_entriesInitialized;
  function CssFloat_initEntries() {
    if (CssFloat_entriesInitialized)
      return Unit_instance;
    CssFloat_entriesInitialized = true;
    CssFloat_NONE_instance = new CssFloat('NONE', 0, 'none');
    CssFloat_LEFT_instance = new CssFloat('LEFT', 1, 'left');
    CssFloat_RIGHT_instance = new CssFloat('RIGHT', 2, 'right');
  }
  function CssFloat(name, ordinal, stringQualifier) {
    Enum.call(this, name, ordinal);
    this.k8e_1 = stringQualifier;
  }
  protoOf(CssFloat).v8d = function () {
    return this.k8e_1;
  };
  function CssFloat_LEFT_getInstance() {
    CssFloat_initEntries();
    return CssFloat_LEFT_instance;
  }
  var CssFontStyle_NORMAL_instance;
  var CssFontStyle_ITALIC_instance;
  var CssFontStyle_entriesInitialized;
  function CssFontStyle_initEntries() {
    if (CssFontStyle_entriesInitialized)
      return Unit_instance;
    CssFontStyle_entriesInitialized = true;
    CssFontStyle_NORMAL_instance = new CssFontStyle('NORMAL', 0, 'normal');
    CssFontStyle_ITALIC_instance = new CssFontStyle('ITALIC', 1, 'italic');
  }
  function CssFontStyle(name, ordinal, stringQualifier) {
    Enum.call(this, name, ordinal);
    this.n8e_1 = stringQualifier;
  }
  protoOf(CssFontStyle).v8d = function () {
    return this.n8e_1;
  };
  function CssFontStyle_NORMAL_getInstance() {
    CssFontStyle_initEntries();
    return CssFontStyle_NORMAL_instance;
  }
  function CssFontStyle_ITALIC_getInstance() {
    CssFontStyle_initEntries();
    return CssFontStyle_ITALIC_instance;
  }
  var CssFontWeight_NORMAL_instance;
  var CssFontWeight_BOLD_instance;
  var CssFontWeight_BOLDER_instance;
  var CssFontWeight_LIGHTER_instance;
  var CssFontWeight_entriesInitialized;
  function CssFontWeight_initEntries() {
    if (CssFontWeight_entriesInitialized)
      return Unit_instance;
    CssFontWeight_entriesInitialized = true;
    CssFontWeight_NORMAL_instance = new CssFontWeight('NORMAL', 0, 'normal');
    CssFontWeight_BOLD_instance = new CssFontWeight('BOLD', 1, 'bold');
    CssFontWeight_BOLDER_instance = new CssFontWeight('BOLDER', 2, 'bolder');
    CssFontWeight_LIGHTER_instance = new CssFontWeight('LIGHTER', 3, 'lighter');
  }
  function CssFontWeight(name, ordinal, stringQualifier) {
    Enum.call(this, name, ordinal);
    this.q8e_1 = stringQualifier;
  }
  protoOf(CssFontWeight).v8d = function () {
    return this.q8e_1;
  };
  function CssFontWeight_NORMAL_getInstance() {
    CssFontWeight_initEntries();
    return CssFontWeight_NORMAL_instance;
  }
  function CssFontWeight_BOLD_getInstance() {
    CssFontWeight_initEntries();
    return CssFontWeight_BOLD_instance;
  }
  var CssOutlineStyle_NONE_instance;
  var CssOutlineStyle_DASHED_instance;
  var CssOutlineStyle_DOTTED_instance;
  var CssOutlineStyle_DOUBLE_instance;
  var CssOutlineStyle_GROOVE_instance;
  var CssOutlineStyle_INSET_instance;
  var CssOutlineStyle_OUTSET_instance;
  var CssOutlineStyle_RIDGE_instance;
  var CssOutlineStyle_SOLID_instance;
  var CssOutlineStyle_entriesInitialized;
  function CssOutlineStyle_initEntries() {
    if (CssOutlineStyle_entriesInitialized)
      return Unit_instance;
    CssOutlineStyle_entriesInitialized = true;
    CssOutlineStyle_NONE_instance = new CssOutlineStyle('NONE', 0, 'none');
    CssOutlineStyle_DASHED_instance = new CssOutlineStyle('DASHED', 1, 'dashed');
    CssOutlineStyle_DOTTED_instance = new CssOutlineStyle('DOTTED', 2, 'dotted');
    CssOutlineStyle_DOUBLE_instance = new CssOutlineStyle('DOUBLE', 3, 'double');
    CssOutlineStyle_GROOVE_instance = new CssOutlineStyle('GROOVE', 4, 'groove');
    CssOutlineStyle_INSET_instance = new CssOutlineStyle('INSET', 5, 'inset');
    CssOutlineStyle_OUTSET_instance = new CssOutlineStyle('OUTSET', 6, 'outset');
    CssOutlineStyle_RIDGE_instance = new CssOutlineStyle('RIDGE', 7, 'ridge');
    CssOutlineStyle_SOLID_instance = new CssOutlineStyle('SOLID', 8, 'solid');
  }
  function CssOutlineStyle(name, ordinal, stringQualifier) {
    Enum.call(this, name, ordinal);
    this.t8e_1 = stringQualifier;
  }
  protoOf(CssOutlineStyle).v8d = function () {
    return this.t8e_1;
  };
  function CssOutlineStyle_NONE_getInstance() {
    CssOutlineStyle_initEntries();
    return CssOutlineStyle_NONE_instance;
  }
  function CssOutlineStyle_SOLID_getInstance() {
    CssOutlineStyle_initEntries();
    return CssOutlineStyle_SOLID_instance;
  }
  var CssOverflow_VISIBLE_instance;
  var CssOverflow_HIDDEN_instance;
  var CssOverflow_SCROLL_instance;
  var CssOverflow_AUTO_instance;
  var CssOverflow_INITIAL_instance;
  var CssOverflow_INHERIT_instance;
  function Companion_137() {
  }
  protoOf(Companion_137).z2g = function (value) {
    return parse_0(value, values_5());
  };
  var Companion_instance_137;
  function Companion_getInstance_137() {
    return Companion_instance_137;
  }
  function values_5() {
    return [CssOverflow_VISIBLE_getInstance(), CssOverflow_HIDDEN_getInstance(), CssOverflow_SCROLL_getInstance(), CssOverflow_AUTO_getInstance(), CssOverflow_INITIAL_getInstance(), CssOverflow_INHERIT_getInstance()];
  }
  var CssOverflow_entriesInitialized;
  function CssOverflow_initEntries() {
    if (CssOverflow_entriesInitialized)
      return Unit_instance;
    CssOverflow_entriesInitialized = true;
    CssOverflow_VISIBLE_instance = new CssOverflow('VISIBLE', 0, 'visible');
    CssOverflow_HIDDEN_instance = new CssOverflow('HIDDEN', 1, 'hidden');
    CssOverflow_SCROLL_instance = new CssOverflow('SCROLL', 2, 'scroll');
    CssOverflow_AUTO_instance = new CssOverflow('AUTO', 3, 'auto');
    CssOverflow_INITIAL_instance = new CssOverflow('INITIAL', 4, 'initial');
    CssOverflow_INHERIT_instance = new CssOverflow('INHERIT', 5, 'inherit');
  }
  function CssOverflow(name, ordinal, stringQualifier) {
    Enum.call(this, name, ordinal);
    this.w8e_1 = stringQualifier;
  }
  protoOf(CssOverflow).v8d = function () {
    return this.w8e_1;
  };
  function CssOverflow_VISIBLE_getInstance() {
    CssOverflow_initEntries();
    return CssOverflow_VISIBLE_instance;
  }
  function CssOverflow_HIDDEN_getInstance() {
    CssOverflow_initEntries();
    return CssOverflow_HIDDEN_instance;
  }
  function CssOverflow_SCROLL_getInstance() {
    CssOverflow_initEntries();
    return CssOverflow_SCROLL_instance;
  }
  function CssOverflow_AUTO_getInstance() {
    CssOverflow_initEntries();
    return CssOverflow_AUTO_instance;
  }
  function CssOverflow_INITIAL_getInstance() {
    CssOverflow_initEntries();
    return CssOverflow_INITIAL_instance;
  }
  function CssOverflow_INHERIT_getInstance() {
    CssOverflow_initEntries();
    return CssOverflow_INHERIT_instance;
  }
  var CssPosition_ABSOLUTE_instance;
  var CssPosition_FIXED_instance;
  var CssPosition_RELATIVE_instance;
  var CssPosition_STATIC_instance;
  var CssPosition_STICKY_instance;
  function Companion_138() {
  }
  var Companion_instance_138;
  function Companion_getInstance_138() {
    return Companion_instance_138;
  }
  var CssPosition_entriesInitialized;
  function CssPosition_initEntries() {
    if (CssPosition_entriesInitialized)
      return Unit_instance;
    CssPosition_entriesInitialized = true;
    CssPosition_ABSOLUTE_instance = new CssPosition('ABSOLUTE', 0, 'absolute');
    CssPosition_FIXED_instance = new CssPosition('FIXED', 1, 'fixed');
    CssPosition_RELATIVE_instance = new CssPosition('RELATIVE', 2, 'relative');
    CssPosition_STATIC_instance = new CssPosition('STATIC', 3, 'static');
    CssPosition_STICKY_instance = new CssPosition('STICKY', 4, 'sticky');
  }
  function CssPosition(name, ordinal, stringQualifier) {
    Enum.call(this, name, ordinal);
    this.z8e_1 = stringQualifier;
  }
  protoOf(CssPosition).v8d = function () {
    return this.z8e_1;
  };
  function CssPosition_ABSOLUTE_getInstance() {
    CssPosition_initEntries();
    return CssPosition_ABSOLUTE_instance;
  }
  function CssPosition_FIXED_getInstance() {
    CssPosition_initEntries();
    return CssPosition_FIXED_instance;
  }
  function CssPosition_RELATIVE_getInstance() {
    CssPosition_initEntries();
    return CssPosition_RELATIVE_instance;
  }
  var CssVerticalAlign_BASELINE_instance;
  var CssVerticalAlign_SUB_instance;
  var CssVerticalAlign_SUPER_instance;
  var CssVerticalAlign_TOP_instance;
  var CssVerticalAlign_TEXT_TOP_instance;
  var CssVerticalAlign_MIDDLE_instance;
  var CssVerticalAlign_BOTTOM_instance;
  var CssVerticalAlign_TEXT_BOTTOM_instance;
  var CssVerticalAlign_entriesInitialized;
  function CssVerticalAlign_initEntries() {
    if (CssVerticalAlign_entriesInitialized)
      return Unit_instance;
    CssVerticalAlign_entriesInitialized = true;
    CssVerticalAlign_BASELINE_instance = new CssVerticalAlign('BASELINE', 0, 'baseline');
    CssVerticalAlign_SUB_instance = new CssVerticalAlign('SUB', 1, 'sub');
    CssVerticalAlign_SUPER_instance = new CssVerticalAlign('SUPER', 2, 'super');
    CssVerticalAlign_TOP_instance = new CssVerticalAlign('TOP', 3, 'top');
    CssVerticalAlign_TEXT_TOP_instance = new CssVerticalAlign('TEXT_TOP', 4, 'text_top');
    CssVerticalAlign_MIDDLE_instance = new CssVerticalAlign('MIDDLE', 5, 'middle');
    CssVerticalAlign_BOTTOM_instance = new CssVerticalAlign('BOTTOM', 6, 'bottom');
    CssVerticalAlign_TEXT_BOTTOM_instance = new CssVerticalAlign('TEXT_BOTTOM', 7, 'text_bottom');
  }
  function CssVerticalAlign(name, ordinal, stringQualifier) {
    Enum.call(this, name, ordinal);
    this.c8f_1 = stringQualifier;
  }
  protoOf(CssVerticalAlign).v8d = function () {
    return this.c8f_1;
  };
  function CssVerticalAlign_BOTTOM_getInstance() {
    CssVerticalAlign_initEntries();
    return CssVerticalAlign_BOTTOM_instance;
  }
  var CssVisibility_COLLAPSE_instance;
  var CssVisibility_HIDDEN_instance;
  var CssVisibility_VISIBLE_instance;
  var CssVisibility_entriesInitialized;
  function CssVisibility_initEntries() {
    if (CssVisibility_entriesInitialized)
      return Unit_instance;
    CssVisibility_entriesInitialized = true;
    CssVisibility_COLLAPSE_instance = new CssVisibility('COLLAPSE', 0, 'collapse');
    CssVisibility_HIDDEN_instance = new CssVisibility('HIDDEN', 1, 'hidden');
    CssVisibility_VISIBLE_instance = new CssVisibility('VISIBLE', 2, 'visible');
  }
  function CssVisibility(name, ordinal, stringQualifier) {
    Enum.call(this, name, ordinal);
    this.f8f_1 = stringQualifier;
  }
  protoOf(CssVisibility).v8d = function () {
    return this.f8f_1;
  };
  function CssVisibility_HIDDEN_getInstance() {
    CssVisibility_initEntries();
    return CssVisibility_HIDDEN_instance;
  }
  function CssVisibility_VISIBLE_getInstance() {
    CssVisibility_initEntries();
    return CssVisibility_VISIBLE_instance;
  }
  var CssWhiteSpace_NORMAL_instance;
  var CssWhiteSpace_NOWRAP_instance;
  var CssWhiteSpace_PRE_instance;
  var CssWhiteSpace_PRE_LINE_instance;
  var CssWhiteSpace_PRE_WRAP_instance;
  var CssWhiteSpace_entriesInitialized;
  function CssWhiteSpace_initEntries() {
    if (CssWhiteSpace_entriesInitialized)
      return Unit_instance;
    CssWhiteSpace_entriesInitialized = true;
    CssWhiteSpace_NORMAL_instance = new CssWhiteSpace('NORMAL', 0, 'normal');
    CssWhiteSpace_NOWRAP_instance = new CssWhiteSpace('NOWRAP', 1, 'nowrap');
    CssWhiteSpace_PRE_instance = new CssWhiteSpace('PRE', 2, 'pre');
    CssWhiteSpace_PRE_LINE_instance = new CssWhiteSpace('PRE_LINE', 3, 'pre-line');
    CssWhiteSpace_PRE_WRAP_instance = new CssWhiteSpace('PRE_WRAP', 4, 'pre-wrap');
  }
  function CssWhiteSpace(name, ordinal, stringQualifier) {
    Enum.call(this, name, ordinal);
    this.i8f_1 = stringQualifier;
  }
  protoOf(CssWhiteSpace).v8d = function () {
    return this.i8f_1;
  };
  function CssWhiteSpace_NOWRAP_getInstance() {
    CssWhiteSpace_initEntries();
    return CssWhiteSpace_NOWRAP_instance;
  }
  function DomApi() {
  }
  protoOf(DomApi).j8f = function () {
    return ensureNotNull(this.k8f().body);
  };
  protoOf(DomApi).k8f = function () {
    return document;
  };
  protoOf(DomApi).l8f = function () {
    return window;
  };
  protoOf(DomApi).m8f = function () {
    var tmp = this.n8f('div');
    return tmp instanceof HTMLDivElement ? tmp : THROW_CCE();
  };
  protoOf(DomApi).o8f = function () {
    return this.n8f('span');
  };
  protoOf(DomApi).p8f = function () {
    return cast_0(this.n8f('canvas'));
  };
  protoOf(DomApi).n8f = function (tag) {
    return this.k8f().createElement(tag);
  };
  protoOf(DomApi).q8f = function () {
    return cast_0(this.n8f('textarea'));
  };
  protoOf(DomApi).r8f = function () {
    return cast_0(this.n8f('img'));
  };
  protoOf(DomApi).s8f = function (data) {
    return this.k8f().createTextNode(data);
  };
  var DomApi_instance;
  function DomApi_getInstance() {
    return DomApi_instance;
  }
  function get_eventTarget(_this__u8e3s4) {
    return _this__u8e3s4.target;
  }
  function addClassName(_this__u8e3s4, className) {
    _this__u8e3s4.classList.add(className);
  }
  function setTabIndex(_this__u8e3s4, index) {
    _this__u8e3s4.setAttribute('tabindex', index.toString());
  }
  function removeClassName(_this__u8e3s4, className) {
    _this__u8e3s4.classList.remove(className);
  }
  function getAbsoluteTop(_this__u8e3s4) {
    return _this__u8e3s4.getBoundingClientRect().top;
  }
  function getAbsoluteLeft(_this__u8e3s4) {
    return _this__u8e3s4.getBoundingClientRect().left;
  }
  function clearTabIndex(_this__u8e3s4) {
    _this__u8e3s4.removeAttribute('tabindex');
  }
  function cast_0(_this__u8e3s4) {
    return !(_this__u8e3s4 == null) ? _this__u8e3s4 : THROW_CCE();
  }
  function on(_this__u8e3s4, event, handler) {
    var eventListener = new on$eventListener$1(handler);
    return onEvent(_this__u8e3s4, event, eventListener, false);
  }
  function onEventWithRunner(_this__u8e3s4, event, runner) {
    var consumer = onEventWithRunner$lambda(runner);
    var handler = onEventWithRunner$lambda_0(consumer);
    return on(_this__u8e3s4, event, handler);
  }
  function onEvent(_this__u8e3s4, type, domEventListener, capture) {
    var eventListener = new onEvent$eventListener$1(domEventListener);
    _this__u8e3s4.addEventListener(type.t8f_1, eventListener, capture);
    // Inline function 'jetbrains.ocelot.base.disposable.toDisposable' call
    return new onEvent$$inlined$toDisposable$1(_this__u8e3s4, type, eventListener);
  }
  function on$eventListener$1($handler) {
    this.u8f_1 = $handler;
  }
  protoOf(on$eventListener$1).v8f = function (event) {
    var result = this.u8f_1(event);
    if (!result) {
      event.preventDefault();
      event.stopPropagation();
    }
  };
  function onEventWithRunner$lambda($runner) {
    return function (it) {
      $runner();
      return Unit_instance;
    };
  }
  function onEventWithRunner$lambda_0($consumer) {
    return function (it) {
      $consumer(it);
      return true;
    };
  }
  function onEvent$eventListener$1($domEventListener) {
    this.w8f_1 = $domEventListener;
  }
  protoOf(onEvent$eventListener$1).x8f = function (event) {
    var domEvent = event instanceof Event ? event : THROW_CCE();
    this.w8f_1.v8f(domEvent);
  };
  protoOf(onEvent$eventListener$1).handleEvent = function (event) {
    return this.x8f(event);
  };
  function onEvent$$inlined$toDisposable$1($this_onEvent, $type, $eventListener) {
    this.y8f_1 = $this_onEvent;
    this.z8f_1 = $type;
    this.a8g_1 = $eventListener;
  }
  protoOf(onEvent$$inlined$toDisposable$1).zr = function () {
    this.y8f_1.removeEventListener(this.z8f_1.t8f_1, this.a8g_1);
    return Unit_instance;
  };
  function Companion_139() {
    Companion_instance_139 = this;
    this.b8g_1 = new DomEventType('blur');
    this.c8g_1 = new DomEventType('change');
    this.d8g_1 = new DomEventType('input');
    this.e8g_1 = new DomEventType('paste');
    this.f8g_1 = new DomEventType('resize');
    this.g8g_1 = new DomEventType('click');
    this.h8g_1 = new DomEventType('contextmenu');
    this.i8g_1 = new DomEventType('dblclick');
    this.j8g_1 = new DomEventType('drag');
    this.k8g_1 = new DomEventType('dragend');
    this.l8g_1 = new DomEventType('dragenter');
    this.m8g_1 = new DomEventType('dragleave');
    this.n8g_1 = new DomEventType('dragover');
    this.o8g_1 = new DomEventType('dragstart');
    this.p8g_1 = new DomEventType('drop');
    this.q8g_1 = new DomEventType('focus');
    this.r8g_1 = new DomEventType('focusin');
    this.s8g_1 = new DomEventType('focusout');
    this.t8g_1 = new DomEventType('keydown');
    this.u8g_1 = new DomEventType('keypress');
    this.v8g_1 = new DomEventType('keyup');
    this.w8g_1 = new DomEventType('load');
    this.x8g_1 = new DomEventType('mouseenter');
    this.y8g_1 = new DomEventType('mouseleave');
    this.z8g_1 = new DomEventType('mousedown');
    this.a8h_1 = new DomEventType('mousemove');
    this.b8h_1 = new DomEventType('mouseout');
    this.c8h_1 = new DomEventType('mouseover');
    this.d8h_1 = new DomEventType('mouseup');
    this.e8h_1 = new DomEventType('wheel');
    this.f8h_1 = new DomEventType('scroll');
    this.g8h_1 = new DomEventType('touchcancel');
    this.h8h_1 = new DomEventType('touchend');
    this.i8h_1 = new DomEventType('touchmove');
    this.j8h_1 = new DomEventType('touchstart');
    this.k8h_1 = new DomEventType('compositionstart');
    this.l8h_1 = new DomEventType('compositionend');
    this.m8h_1 = new DomEventType('compositionupdate');
    this.n8h_1 = new DomEventType('message');
    this.o8h_1 = new DomEventType('progress');
    this.p8h_1 = new DomEventType('load');
    this.q8h_1 = new DomEventType('loadstart');
    this.r8h_1 = new DomEventType('loadend');
    this.s8h_1 = new DomEventType('abort');
    this.t8h_1 = new DomEventType('error');
  }
  var Companion_instance_139;
  function Companion_getInstance_139() {
    if (Companion_instance_139 == null)
      new Companion_139();
    return Companion_instance_139;
  }
  function DomEventType(name) {
    Companion_getInstance_139();
    this.t8f_1 = name;
  }
  protoOf(DomEventType).toString = function () {
    return 'DomEventType(name=' + this.t8f_1 + ')';
  };
  protoOf(DomEventType).hashCode = function () {
    return getStringHashCode(this.t8f_1);
  };
  protoOf(DomEventType).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof DomEventType))
      return false;
    if (!(this.t8f_1 === other.t8f_1))
      return false;
    return true;
  };
  function get_context2d(_this__u8e3s4) {
    var tmp = _this__u8e3s4.getContext('2d');
    return tmp instanceof CanvasRenderingContext2D ? tmp : THROW_CCE();
  }
  function onMessage($this, event) {
    var tmp;
    if (equals($this.u8h_1, event.data)) {
      // Inline function 'kotlin.collections.isNotEmpty' call
      tmp = !$this.v8h_1.s();
    } else {
      tmp = false;
    }
    if (tmp) {
      var head = $this.v8h_1.n2(0);
      head();
    }
  }
  function DomImmediatePolyfill$setImmediate$lambda(event) {
    onMessage(DomImmediatePolyfill_getInstance(), event);
    return true;
  }
  function DomImmediatePolyfill() {
    DomImmediatePolyfill_instance = this;
    this.u8h_1 = 'set_immediate_' + Default_getInstance().hj();
    this.v8h_1 = ArrayList_init_$Create$();
    this.w8h_1 = null;
  }
  protoOf(DomImmediatePolyfill).x8h = function (runnable) {
    var window_0 = DomApi_instance.l8f();
    if (this.w8h_1 == null) {
      var consumer = DomImmediatePolyfill$setImmediate$lambda;
      this.w8h_1 = on(window_0, Companion_getInstance_139().n8h_1, consumer);
    }
    this.v8h_1.j(runnable);
    window_0.postMessage(this.u8h_1, '*');
  };
  var DomImmediatePolyfill_instance;
  function DomImmediatePolyfill_getInstance() {
    if (DomImmediatePolyfill_instance == null)
      new DomImmediatePolyfill();
    return DomImmediatePolyfill_instance;
  }
  function removeFromParent(_this__u8e3s4) {
    var tmp0_safe_receiver = _this__u8e3s4.parentElement;
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver.removeChild(_this__u8e3s4);
  }
  function removeAllChildren(_this__u8e3s4) {
    while (!(_this__u8e3s4.lastChild == null)) {
      _this__u8e3s4.removeChild(ensureNotNull(_this__u8e3s4.lastChild));
    }
  }
  function insertFirst(_this__u8e3s4, child) {
    _this__u8e3s4.insertBefore(child, _this__u8e3s4.firstChild);
  }
  function get_childCount(_this__u8e3s4) {
    return _this__u8e3s4.childNodes.length;
  }
  function getChild(_this__u8e3s4, index) {
    return _this__u8e3s4.childNodes.item(index);
  }
  function insertAfter(_this__u8e3s4, newChild, refChild) {
    var next = refChild == null ? null : refChild.nextSibling;
    if (next == null) {
      _this__u8e3s4.appendChild(newChild);
    } else {
      _this__u8e3s4.insertBefore(newChild, next);
    }
  }
  function createElement($this, contents) {
    var style = document.createElement('style');
    style.setAttribute('language', 'text/css');
    appendText(style, contents);
    return style;
  }
  function getHead($this) {
    if ($this.z8h_1 == null) {
      var tmp = $this;
      // Inline function 'org.w3c.dom.get' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp.z8h_1 = document.getElementsByTagName('head')[0];
    }
    return ensureNotNull($this.z8h_1);
  }
  function StyleInjector() {
    StyleInjector_instance = this;
    this.y8h_1 = 'style';
    this.z8h_1 = null;
    this.a8i_1 = ArrayList_init_$Create$();
  }
  protoOf(StyleInjector).b8i = function (css) {
    this.a8i_1.j(css);
    this.c8i();
  };
  protoOf(StyleInjector).d8i = function (contents) {
    var style = createElement(this, contents);
    getHead(this).appendChild(style);
    return style;
  };
  protoOf(StyleInjector).c8i = function () {
    var result = null;
    if (!(this.a8i_1.p() === 0)) {
      var css = joinToString_0(this.a8i_1, '');
      result = this.d8i(css);
      this.a8i_1.k2();
    }
    return result;
  };
  var StyleInjector_instance;
  function StyleInjector_getInstance() {
    if (StyleInjector_instance == null)
      new StyleInjector();
    return StyleInjector_instance;
  }
  function ClipboardContent() {
  }
  function CompositionEvent(composite) {
    Event_0.call(this);
    this.j8i_1 = composite;
  }
  function CopyCutEvent() {
    Event_0.call(this);
    this.s8i_1 = EmptyClipboardContent_instance;
  }
  protoOf(CopyCutEvent).t8i = function (content) {
    this.n8i();
    this.s8i_1 = content;
  };
  protoOf(CopyCutEvent).p8i = function () {
    return this.u8i(EmptyClipboardContent_instance);
  };
  protoOf(CopyCutEvent).u8i = function (content) {
    if (this.l8i_1) {
      // Inline function 'kotlin.check' call
      if (!(this.s8i_1 === content)) {
        var message = 'Different contents: ' + toString_1(this.s8i_1) + ', ' + toString_1(content);
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      }
    } else {
      this.t8i(content);
    }
  };
  function DerivedCopyCutEvent(cause, result) {
    DerivedEvent.call(this, cause);
    this.y8i_1 = result;
  }
  protoOf(DerivedCopyCutEvent).n8i = function () {
    this.b8j_1.t8i(this.y8i_1);
    this.o8i();
  };
  function DerivedEvent(cause) {
    Event_0.call(this);
    this.b8j_1 = cause;
    // Inline function 'kotlin.check' call
    if (!!this.b8j_1.l8i_1) {
      var message = "Can't derive from a consumed event: " + toString_1(this.b8j_1);
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
  }
  protoOf(DerivedEvent).n8i = function () {
    this.b8j_1.n8i();
    this.o8i();
  };
  function EmptyClipboardContent() {
  }
  protoOf(EmptyClipboardContent).e8i = function (kind) {
    return false;
  };
  protoOf(EmptyClipboardContent).f8i = function (kind) {
    throw UnsupportedOperationException_init_$Create$();
  };
  protoOf(EmptyClipboardContent).g8i = function () {
    return '';
  };
  var EmptyClipboardContent_instance;
  function EmptyClipboardContent_getInstance() {
    return EmptyClipboardContent_instance;
  }
  function Event_0() {
    this.k8i_1 = null;
    this.l8i_1 = false;
  }
  protoOf(Event_0).m8i = function (eventContext) {
    // Inline function 'kotlin.check' call
    if (!(this.k8i_1 == null)) {
      var message = 'Already set ' + toString_1(ensureNotNull(this.k8i_1));
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    // Inline function 'kotlin.check' call
    if (!!this.l8i_1) {
      var message_0 = "Can't set a context to the consumed event";
      throw IllegalStateException_init_$Create$_0(toString_1(message_0));
    }
    $l$block: {
      // Inline function 'kotlin.requireNotNull' call
      if (eventContext == null) {
        var message_1 = "Can't set null context";
        throw IllegalArgumentException_init_$Create$_0(toString_1(message_1));
      } else {
        break $l$block;
      }
    }
    this.k8i_1 = eventContext;
  };
  protoOf(Event_0).n8i = function () {
    return this.o8i();
  };
  protoOf(Event_0).o8i = function () {
    // Inline function 'kotlin.check' call
    if (!!this.l8i_1) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    this.l8i_1 = true;
  };
  protoOf(Event_0).p8i = function () {
    if (!this.l8i_1) {
      this.n8i();
    }
  };
  var Key_A_instance;
  var Key_B_instance;
  var Key_C_instance;
  var Key_D_instance;
  var Key_E_instance;
  var Key_F_instance;
  var Key_G_instance;
  var Key_H_instance;
  var Key_I_instance;
  var Key_J_instance;
  var Key_K_instance;
  var Key_L_instance;
  var Key_M_instance;
  var Key_N_instance;
  var Key_O_instance;
  var Key_P_instance;
  var Key_Q_instance;
  var Key_R_instance;
  var Key_S_instance;
  var Key_T_instance;
  var Key_U_instance;
  var Key_V_instance;
  var Key_W_instance;
  var Key_X_instance;
  var Key_Y_instance;
  var Key_Z_instance;
  var Key_DIGIT_0_instance;
  var Key_DIGIT_1_instance;
  var Key_DIGIT_2_instance;
  var Key_DIGIT_3_instance;
  var Key_DIGIT_4_instance;
  var Key_DIGIT_5_instance;
  var Key_DIGIT_6_instance;
  var Key_DIGIT_7_instance;
  var Key_DIGIT_8_instance;
  var Key_DIGIT_9_instance;
  var Key_LEFT_BRACE_instance;
  var Key_RIGHT_BRACE_instance;
  var Key_UP_instance;
  var Key_DOWN_instance;
  var Key_LEFT_instance;
  var Key_RIGHT_instance;
  var Key_PAGE_UP_instance;
  var Key_PAGE_DOWN_instance;
  var Key_ESCAPE_instance;
  var Key_ENTER_instance;
  var Key_HOME_instance;
  var Key_END_instance;
  var Key_TAB_instance;
  var Key_SPACE_instance;
  var Key_INSERT_instance;
  var Key_DELETE_instance;
  var Key_BACKSPACE_instance;
  var Key_EQUALS_instance;
  var Key_BACK_QUOTE_instance;
  var Key_PLUS_instance;
  var Key_MINUS_instance;
  var Key_SLASH_instance;
  var Key_CONTROL_instance;
  var Key_META_instance;
  var Key_ALT_instance;
  var Key_SHIFT_instance;
  var Key_UNKNOWN_instance;
  var Key_F1_instance;
  var Key_F2_instance;
  var Key_F3_instance;
  var Key_F4_instance;
  var Key_F5_instance;
  var Key_F6_instance;
  var Key_F7_instance;
  var Key_F8_instance;
  var Key_F9_instance;
  var Key_F10_instance;
  var Key_F11_instance;
  var Key_F12_instance;
  var Key_COMMA_instance;
  var Key_PERIOD_instance;
  var Key_entriesInitialized;
  function Key_initEntries() {
    if (Key_entriesInitialized)
      return Unit_instance;
    Key_entriesInitialized = true;
    Key_A_instance = new Key_7('A', 0, 'A');
    Key_B_instance = new Key_7('B', 1, 'B');
    Key_C_instance = new Key_7('C', 2, 'C');
    Key_D_instance = new Key_7('D', 3, 'D');
    Key_E_instance = new Key_7('E', 4, 'E');
    Key_F_instance = new Key_7('F', 5, 'F');
    Key_G_instance = new Key_7('G', 6, 'G');
    Key_H_instance = new Key_7('H', 7, 'H');
    Key_I_instance = new Key_7('I', 8, 'I');
    Key_J_instance = new Key_7('J', 9, 'J');
    Key_K_instance = new Key_7('K', 10, 'K');
    Key_L_instance = new Key_7('L', 11, 'L');
    Key_M_instance = new Key_7('M', 12, 'M');
    Key_N_instance = new Key_7('N', 13, 'N');
    Key_O_instance = new Key_7('O', 14, 'O');
    Key_P_instance = new Key_7('P', 15, 'P');
    Key_Q_instance = new Key_7('Q', 16, 'Q');
    Key_R_instance = new Key_7('R', 17, 'R');
    Key_S_instance = new Key_7('S', 18, 'S');
    Key_T_instance = new Key_7('T', 19, 'T');
    Key_U_instance = new Key_7('U', 20, 'U');
    Key_V_instance = new Key_7('V', 21, 'V');
    Key_W_instance = new Key_7('W', 22, 'W');
    Key_X_instance = new Key_7('X', 23, 'X');
    Key_Y_instance = new Key_7('Y', 24, 'Y');
    Key_Z_instance = new Key_7('Z', 25, 'Z');
    Key_DIGIT_0_instance = new Key_7('DIGIT_0', 26, '0');
    Key_DIGIT_1_instance = new Key_7('DIGIT_1', 27, '1');
    Key_DIGIT_2_instance = new Key_7('DIGIT_2', 28, '2');
    Key_DIGIT_3_instance = new Key_7('DIGIT_3', 29, '3');
    Key_DIGIT_4_instance = new Key_7('DIGIT_4', 30, '4');
    Key_DIGIT_5_instance = new Key_7('DIGIT_5', 31, '5');
    Key_DIGIT_6_instance = new Key_7('DIGIT_6', 32, '6');
    Key_DIGIT_7_instance = new Key_7('DIGIT_7', 33, '7');
    Key_DIGIT_8_instance = new Key_7('DIGIT_8', 34, '8');
    Key_DIGIT_9_instance = new Key_7('DIGIT_9', 35, '9');
    Key_LEFT_BRACE_instance = new Key_7('LEFT_BRACE', 36, '[');
    Key_RIGHT_BRACE_instance = new Key_7('RIGHT_BRACE', 37, ']');
    Key_UP_instance = new Key_7('UP', 38, 'Up');
    Key_DOWN_instance = new Key_7('DOWN', 39, 'Down');
    Key_LEFT_instance = new Key_7('LEFT', 40, 'Left');
    Key_RIGHT_instance = new Key_7('RIGHT', 41, 'Right');
    Key_PAGE_UP_instance = new Key_7('PAGE_UP', 42, 'Page Up');
    Key_PAGE_DOWN_instance = new Key_7('PAGE_DOWN', 43, 'Page Down');
    Key_ESCAPE_instance = new Key_7('ESCAPE', 44, 'Escape');
    Key_ENTER_instance = new Key_7('ENTER', 45, 'Enter');
    Key_HOME_instance = new Key_7('HOME', 46, 'Home');
    Key_END_instance = new Key_7('END', 47, 'End');
    Key_TAB_instance = new Key_7('TAB', 48, 'Tab');
    Key_SPACE_instance = new Key_7('SPACE', 49, 'Space');
    Key_INSERT_instance = new Key_7('INSERT', 50, 'Insert');
    Key_DELETE_instance = new Key_7('DELETE', 51, 'Delete');
    Key_BACKSPACE_instance = new Key_7('BACKSPACE', 52, 'Backspace');
    Key_EQUALS_instance = new Key_7('EQUALS', 53, 'Equals');
    Key_BACK_QUOTE_instance = new Key_7('BACK_QUOTE', 54, '`');
    Key_PLUS_instance = new Key_7('PLUS', 55, 'Plus');
    Key_MINUS_instance = new Key_7('MINUS', 56, 'Minus');
    Key_SLASH_instance = new Key_7('SLASH', 57, 'Slash');
    Key_CONTROL_instance = new Key_7('CONTROL', 58, 'Ctrl');
    Key_META_instance = new Key_7('META', 59, 'Meta');
    Key_ALT_instance = new Key_7('ALT', 60, 'Alt');
    Key_SHIFT_instance = new Key_7('SHIFT', 61, 'Shift');
    Key_UNKNOWN_instance = new Key_7('UNKNOWN', 62, '?');
    Key_F1_instance = new Key_7('F1', 63, 'F1');
    Key_F2_instance = new Key_7('F2', 64, 'F2');
    Key_F3_instance = new Key_7('F3', 65, 'F3');
    Key_F4_instance = new Key_7('F4', 66, 'F4');
    Key_F5_instance = new Key_7('F5', 67, 'F5');
    Key_F6_instance = new Key_7('F6', 68, 'F6');
    Key_F7_instance = new Key_7('F7', 69, 'F7');
    Key_F8_instance = new Key_7('F8', 70, 'F8');
    Key_F9_instance = new Key_7('F9', 71, 'F9');
    Key_F10_instance = new Key_7('F10', 72, 'F10');
    Key_F11_instance = new Key_7('F11', 73, 'F11');
    Key_F12_instance = new Key_7('F12', 74, 'F12');
    Key_COMMA_instance = new Key_7('COMMA', 75, ',');
    Key_PERIOD_instance = new Key_7('PERIOD', 76, '.');
  }
  function Key_7(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.e8j_1 = value;
  }
  protoOf(Key_7).toString = function () {
    return this.e8j_1;
  };
  function Key_A_getInstance() {
    Key_initEntries();
    return Key_A_instance;
  }
  function Key_B_getInstance() {
    Key_initEntries();
    return Key_B_instance;
  }
  function Key_C_getInstance() {
    Key_initEntries();
    return Key_C_instance;
  }
  function Key_D_getInstance() {
    Key_initEntries();
    return Key_D_instance;
  }
  function Key_E_getInstance() {
    Key_initEntries();
    return Key_E_instance;
  }
  function Key_F_getInstance() {
    Key_initEntries();
    return Key_F_instance;
  }
  function Key_G_getInstance() {
    Key_initEntries();
    return Key_G_instance;
  }
  function Key_H_getInstance() {
    Key_initEntries();
    return Key_H_instance;
  }
  function Key_I_getInstance() {
    Key_initEntries();
    return Key_I_instance;
  }
  function Key_J_getInstance() {
    Key_initEntries();
    return Key_J_instance;
  }
  function Key_K_getInstance() {
    Key_initEntries();
    return Key_K_instance;
  }
  function Key_L_getInstance() {
    Key_initEntries();
    return Key_L_instance;
  }
  function Key_M_getInstance() {
    Key_initEntries();
    return Key_M_instance;
  }
  function Key_N_getInstance() {
    Key_initEntries();
    return Key_N_instance;
  }
  function Key_O_getInstance() {
    Key_initEntries();
    return Key_O_instance;
  }
  function Key_P_getInstance() {
    Key_initEntries();
    return Key_P_instance;
  }
  function Key_Q_getInstance() {
    Key_initEntries();
    return Key_Q_instance;
  }
  function Key_R_getInstance() {
    Key_initEntries();
    return Key_R_instance;
  }
  function Key_S_getInstance() {
    Key_initEntries();
    return Key_S_instance;
  }
  function Key_T_getInstance() {
    Key_initEntries();
    return Key_T_instance;
  }
  function Key_U_getInstance() {
    Key_initEntries();
    return Key_U_instance;
  }
  function Key_V_getInstance() {
    Key_initEntries();
    return Key_V_instance;
  }
  function Key_W_getInstance() {
    Key_initEntries();
    return Key_W_instance;
  }
  function Key_X_getInstance() {
    Key_initEntries();
    return Key_X_instance;
  }
  function Key_Y_getInstance() {
    Key_initEntries();
    return Key_Y_instance;
  }
  function Key_Z_getInstance() {
    Key_initEntries();
    return Key_Z_instance;
  }
  function Key_DIGIT_0_getInstance() {
    Key_initEntries();
    return Key_DIGIT_0_instance;
  }
  function Key_DIGIT_1_getInstance() {
    Key_initEntries();
    return Key_DIGIT_1_instance;
  }
  function Key_DIGIT_2_getInstance() {
    Key_initEntries();
    return Key_DIGIT_2_instance;
  }
  function Key_DIGIT_3_getInstance() {
    Key_initEntries();
    return Key_DIGIT_3_instance;
  }
  function Key_DIGIT_4_getInstance() {
    Key_initEntries();
    return Key_DIGIT_4_instance;
  }
  function Key_DIGIT_5_getInstance() {
    Key_initEntries();
    return Key_DIGIT_5_instance;
  }
  function Key_DIGIT_6_getInstance() {
    Key_initEntries();
    return Key_DIGIT_6_instance;
  }
  function Key_DIGIT_7_getInstance() {
    Key_initEntries();
    return Key_DIGIT_7_instance;
  }
  function Key_DIGIT_8_getInstance() {
    Key_initEntries();
    return Key_DIGIT_8_instance;
  }
  function Key_DIGIT_9_getInstance() {
    Key_initEntries();
    return Key_DIGIT_9_instance;
  }
  function Key_LEFT_BRACE_getInstance() {
    Key_initEntries();
    return Key_LEFT_BRACE_instance;
  }
  function Key_RIGHT_BRACE_getInstance() {
    Key_initEntries();
    return Key_RIGHT_BRACE_instance;
  }
  function Key_UP_getInstance() {
    Key_initEntries();
    return Key_UP_instance;
  }
  function Key_DOWN_getInstance() {
    Key_initEntries();
    return Key_DOWN_instance;
  }
  function Key_LEFT_getInstance() {
    Key_initEntries();
    return Key_LEFT_instance;
  }
  function Key_RIGHT_getInstance() {
    Key_initEntries();
    return Key_RIGHT_instance;
  }
  function Key_PAGE_UP_getInstance() {
    Key_initEntries();
    return Key_PAGE_UP_instance;
  }
  function Key_PAGE_DOWN_getInstance() {
    Key_initEntries();
    return Key_PAGE_DOWN_instance;
  }
  function Key_ESCAPE_getInstance() {
    Key_initEntries();
    return Key_ESCAPE_instance;
  }
  function Key_ENTER_getInstance() {
    Key_initEntries();
    return Key_ENTER_instance;
  }
  function Key_HOME_getInstance() {
    Key_initEntries();
    return Key_HOME_instance;
  }
  function Key_END_getInstance() {
    Key_initEntries();
    return Key_END_instance;
  }
  function Key_TAB_getInstance() {
    Key_initEntries();
    return Key_TAB_instance;
  }
  function Key_SPACE_getInstance() {
    Key_initEntries();
    return Key_SPACE_instance;
  }
  function Key_INSERT_getInstance() {
    Key_initEntries();
    return Key_INSERT_instance;
  }
  function Key_DELETE_getInstance() {
    Key_initEntries();
    return Key_DELETE_instance;
  }
  function Key_BACKSPACE_getInstance() {
    Key_initEntries();
    return Key_BACKSPACE_instance;
  }
  function Key_BACK_QUOTE_getInstance() {
    Key_initEntries();
    return Key_BACK_QUOTE_instance;
  }
  function Key_SLASH_getInstance() {
    Key_initEntries();
    return Key_SLASH_instance;
  }
  function Key_CONTROL_getInstance() {
    Key_initEntries();
    return Key_CONTROL_instance;
  }
  function Key_ALT_getInstance() {
    Key_initEntries();
    return Key_ALT_instance;
  }
  function Key_SHIFT_getInstance() {
    Key_initEntries();
    return Key_SHIFT_instance;
  }
  function Key_UNKNOWN_getInstance() {
    Key_initEntries();
    return Key_UNKNOWN_instance;
  }
  function Key_F1_getInstance() {
    Key_initEntries();
    return Key_F1_instance;
  }
  function Key_F2_getInstance() {
    Key_initEntries();
    return Key_F2_instance;
  }
  function Key_F3_getInstance() {
    Key_initEntries();
    return Key_F3_instance;
  }
  function Key_F4_getInstance() {
    Key_initEntries();
    return Key_F4_instance;
  }
  function Key_F5_getInstance() {
    Key_initEntries();
    return Key_F5_instance;
  }
  function Key_F6_getInstance() {
    Key_initEntries();
    return Key_F6_instance;
  }
  function Key_F7_getInstance() {
    Key_initEntries();
    return Key_F7_instance;
  }
  function Key_F8_getInstance() {
    Key_initEntries();
    return Key_F8_instance;
  }
  function Key_F9_getInstance() {
    Key_initEntries();
    return Key_F9_instance;
  }
  function Key_F10_getInstance() {
    Key_initEntries();
    return Key_F10_instance;
  }
  function Key_F11_getInstance() {
    Key_initEntries();
    return Key_F11_instance;
  }
  function Key_F12_getInstance() {
    Key_initEntries();
    return Key_F12_instance;
  }
  function Key_COMMA_getInstance() {
    Key_initEntries();
    return Key_COMMA_instance;
  }
  function Key_PERIOD_getInstance() {
    Key_initEntries();
    return Key_PERIOD_instance;
  }
  function KeyEvent_init_$Init$(key, ch, $this) {
    ch = ch === VOID ? _Char___init__impl__6a9atx(0) : ch;
    Event_0.call($this);
    KeyEvent.call($this);
    $this.h8j_1 = new KeyStroke(key, emptyList());
    $this.i8j_1 = ch;
    return $this;
  }
  function KeyEvent_init_$Create$(key, ch) {
    return KeyEvent_init_$Init$(key, ch, objectCreate(protoOf(KeyEvent)));
  }
  function KeyEvent_init_$Init$_0(key, ch, modifiers, $this) {
    Event_0.call($this);
    KeyEvent.call($this);
    $this.h8j_1 = new KeyStroke(key, modifiers);
    $this.i8j_1 = ch;
    return $this;
  }
  function KeyEvent_init_$Create$_0(key, ch, modifiers) {
    return KeyEvent_init_$Init$_0(key, ch, modifiers, objectCreate(protoOf(KeyEvent)));
  }
  protoOf(KeyEvent).z = function () {
    return this.h8j_1.j8j_1;
  };
  protoOf(KeyEvent).l8j = function () {
    return this.h8j_1.l8j();
  };
  protoOf(KeyEvent).m8j = function (key, modifiers) {
    return this.h8j_1.n8j(key, modifiers.slice());
  };
  protoOf(KeyEvent).o8j = function (specs) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.any' call
      var inductionVariable = 0;
      var last = specs.length;
      while (inductionVariable < last) {
        var element = specs[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        if (element.q8j(this.h8j_1)) {
          tmp$ret$1 = true;
          break $l$block;
        }
      }
      tmp$ret$1 = false;
    }
    return tmp$ret$1;
  };
  protoOf(KeyEvent).r8j = function (specs) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.any' call
      var inductionVariable = 0;
      var last = specs.length;
      while (inductionVariable < last) {
        var element = specs[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        if (element.s8j(this.h8j_1)) {
          tmp$ret$1 = true;
          break $l$block;
        }
      }
      tmp$ret$1 = false;
    }
    return tmp$ret$1;
  };
  protoOf(KeyEvent).t8j = function (key) {
    return this.h8j_1.u8j(key);
  };
  protoOf(KeyEvent).s3e = function () {
    return KeyEvent_init_$Create$_0(this.z(), this.i8j_1, this.l8j());
  };
  protoOf(KeyEvent).toString = function () {
    return toString(this.i8j_1) + ', ' + this.h8j_1.toString();
  };
  function KeyEvent() {
  }
  function KeyModifiers_init_$Init$($this) {
    KeyModifiers.call($this, false, false, false, false);
    return $this;
  }
  function KeyModifiers_init_$Create$() {
    return KeyModifiers_init_$Init$(objectCreate(protoOf(KeyModifiers)));
  }
  function Companion_140() {
    Companion_instance_140 = this;
    this.v8j_1 = KeyModifiers_init_$Create$();
  }
  protoOf(Companion_140).w8j = function () {
    return this.v8j_1;
  };
  var Companion_instance_140;
  function Companion_getInstance_140() {
    if (Companion_instance_140 == null)
      new Companion_140();
    return Companion_instance_140;
  }
  function KeyModifiers(isCtrl, isAlt, isShift, isMeta) {
    Companion_getInstance_140();
    this.x8j_1 = isCtrl;
    this.y8j_1 = isAlt;
    this.z8j_1 = isShift;
    this.a8k_1 = isMeta;
  }
  protoOf(KeyModifiers).toString = function () {
    return 'KeyModifiers(isCtrl=' + this.x8j_1 + ', isAlt=' + this.y8j_1 + ', isShift=' + this.z8j_1 + ', isMeta=' + this.a8k_1 + ')';
  };
  protoOf(KeyModifiers).hashCode = function () {
    var result = getBooleanHashCode(this.x8j_1);
    result = imul(result, 31) + getBooleanHashCode(this.y8j_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.z8j_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.a8k_1) | 0;
    return result;
  };
  protoOf(KeyModifiers).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof KeyModifiers))
      return false;
    if (!(this.x8j_1 === other.x8j_1))
      return false;
    if (!(this.y8j_1 === other.y8j_1))
      return false;
    if (!(this.z8j_1 === other.z8j_1))
      return false;
    if (!(this.a8k_1 === other.a8k_1))
      return false;
    return true;
  };
  function KeyStroke_init_$Init$(key, modifiers, $this) {
    KeyStroke.call($this, key, toList(modifiers));
    return $this;
  }
  function KeyStroke_init_$Create$(key, modifiers) {
    return KeyStroke_init_$Init$(key, modifiers, objectCreate(protoOf(KeyStroke)));
  }
  function KeyStroke(key, modifiers) {
    this.j8j_1 = key;
    this.k8j_1 = HashSet_init_$Create$_0(modifiers);
  }
  protoOf(KeyStroke).l8j = function () {
    return this.k8j_1;
  };
  protoOf(KeyStroke).u8j = function (key) {
    return this.k8j_1.t(key);
  };
  protoOf(KeyStroke).n8j = function (key, modifiers) {
    return this.s8j(KeyStroke_init_$Create$(key, modifiers.slice()));
  };
  protoOf(KeyStroke).s8j = function (keyStroke) {
    return this.equals(keyStroke);
  };
  protoOf(KeyStroke).b8k = function (keys) {
    var modifiers = HashSet_init_$Create$_0(this.k8j_1);
    modifiers.q(toList(keys));
    return new KeyStroke(this.j8j_1, modifiers);
  };
  protoOf(KeyStroke).hashCode = function () {
    return imul(this.j8j_1.hashCode(), 31) + hashCode(this.k8j_1) | 0;
  };
  protoOf(KeyStroke).equals = function (other) {
    if (!(other instanceof KeyStroke))
      return false;
    var otherKeyStroke = other instanceof KeyStroke ? other : THROW_CCE();
    return this.j8j_1.equals(ensureNotNull(otherKeyStroke).j8j_1) && equals(this.k8j_1, otherKeyStroke.k8j_1);
  };
  protoOf(KeyStroke).toString = function () {
    return "'" + this.j8j_1.toString() + "' " + toString_1(this.k8j_1);
  };
  function KeyStrokeSpec_init_$Init$(key, modifiers, $this) {
    KeyStrokeSpec.call($this, listOf(KeyStroke_init_$Create$(key, modifiers.slice())));
    return $this;
  }
  function KeyStrokeSpec_init_$Create$(key, modifiers) {
    return KeyStrokeSpec_init_$Init$(key, modifiers, objectCreate(protoOf(KeyStrokeSpec)));
  }
  function KeyStrokeSpec_init_$Init$_0(keyStrokes, $this) {
    KeyStrokeSpec.call($this, ArrayList_init_$Create$_1(keyStrokes));
    return $this;
  }
  function KeyStrokeSpec_init_$Create$_0(keyStrokes) {
    return KeyStrokeSpec_init_$Init$_0(keyStrokes, objectCreate(protoOf(KeyStrokeSpec)));
  }
  function KeyStrokeSpec_init_$Init$_1(keyStrokes, $this) {
    KeyStrokeSpec.call($this, toList(keyStrokes));
    return $this;
  }
  function KeyStrokeSpec_init_$Create$_1(keyStrokes) {
    return KeyStrokeSpec_init_$Init$_1(keyStrokes, objectCreate(protoOf(KeyStrokeSpec)));
  }
  function KeyStrokeSpec(keyStrokes) {
    this.p8j_1 = keyStrokes;
  }
  protoOf(KeyStrokeSpec).q8j = function (keyStroke) {
    var tmp0 = this.p8j_1;
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.any' call
      var tmp;
      if (isInterface(tmp0, Collection)) {
        tmp = tmp0.s();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = false;
        break $l$block_0;
      }
      var _iterator__ex2g4s = tmp0.m();
      while (_iterator__ex2g4s.n()) {
        var element = _iterator__ex2g4s.o();
        if (element.s8j(keyStroke)) {
          tmp$ret$0 = true;
          break $l$block_0;
        }
      }
      tmp$ret$0 = false;
    }
    return tmp$ret$0;
  };
  protoOf(KeyStrokeSpec).c8k = function (key) {
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.p8j_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.m();
    while (_iterator__ex2g4s.n()) {
      var item = _iterator__ex2g4s.o();
      var tmp$ret$0 = item.b8k([key]);
      destination.j(tmp$ret$0);
    }
    var modified = destination;
    return new KeyStrokeSpec(modified);
  };
  protoOf(KeyStrokeSpec).toString = function () {
    return toString_1(this.p8j_1);
  };
  function ctrlOrMeta($this, key) {
    return $this.m8l([KeyStroke_init_$Create$(key, []).b8k([ModifierKey_CONTROL_getInstance()]), KeyStroke_init_$Create$(key, []).b8k([ModifierKey_META_getInstance()])]);
  }
  function ctrlAltOrMetaAlt($this, key) {
    return $this.m8l([KeyStroke_init_$Create$(key, []).b8k([ModifierKey_CONTROL_getInstance(), ModifierKey_ALT_getInstance()]), KeyStroke_init_$Create$(key, []).b8k([ModifierKey_META_getInstance(), ModifierKey_ALT_getInstance()])]);
  }
  function ctrlOrAlt($this, key) {
    return $this.m8l([KeyStroke_init_$Create$(key, []).b8k([ModifierKey_CONTROL_getInstance()]), KeyStroke_init_$Create$(key, []).b8k([ModifierKey_ALT_getInstance()])]);
  }
  function ctrlOrMetaOrAlt($this, key) {
    return $this.m8l([KeyStroke_init_$Create$(key, []).b8k([ModifierKey_CONTROL_getInstance()]), KeyStroke_init_$Create$(key, []).b8k([ModifierKey_META_getInstance()]), KeyStroke_init_$Create$(key, []).b8k([ModifierKey_ALT_getInstance()])]);
  }
  function KeyStrokeSpecs() {
    KeyStrokeSpecs_instance = this;
    this.d8k_1 = this.n8l([ctrlOrMeta(this, Key_C_getInstance()), KeyStrokeSpec_init_$Create$(Key_INSERT_getInstance(), [ModifierKey_CONTROL_getInstance()])]);
    this.e8k_1 = this.n8l([ctrlOrMeta(this, Key_X_getInstance()), KeyStrokeSpec_init_$Create$(Key_DELETE_getInstance(), [ModifierKey_SHIFT_getInstance()])]);
    this.f8k_1 = this.n8l([ctrlOrMeta(this, Key_V_getInstance()), KeyStrokeSpec_init_$Create$(Key_INSERT_getInstance(), [ModifierKey_SHIFT_getInstance()])]);
    this.g8k_1 = ctrlOrMeta(this, Key_Z_getInstance());
    this.h8k_1 = this.g8k_1.c8k(ModifierKey_SHIFT_getInstance());
    this.i8k_1 = ctrlOrMetaOrAlt(this, Key_SPACE_getInstance());
    this.j8k_1 = this.n8l([KeyStrokeSpec_init_$Create$(Key_F1_getInstance(), []), ctrlOrMeta(this, Key_J_getInstance())]);
    this.k8k_1 = this.n8l([ctrlOrMeta(this, Key_I_getInstance()), ctrlOrMeta(this, Key_F1_getInstance())]);
    this.l8k_1 = this.m8l([KeyStroke_init_$Create$(Key_HOME_getInstance(), []), KeyStroke_init_$Create$(Key_LEFT_getInstance(), [ModifierKey_META_getInstance()])]);
    this.m8k_1 = this.m8l([KeyStroke_init_$Create$(Key_END_getInstance(), []), KeyStroke_init_$Create$(Key_RIGHT_getInstance(), [ModifierKey_META_getInstance()])]);
    this.n8k_1 = ctrlOrMeta(this, Key_HOME_getInstance());
    this.o8k_1 = ctrlOrMeta(this, Key_END_getInstance());
    this.p8k_1 = ctrlOrAlt(this, Key_LEFT_getInstance());
    this.q8k_1 = ctrlOrAlt(this, Key_RIGHT_getInstance());
    this.r8k_1 = ctrlAltOrMetaAlt(this, Key_RIGHT_getInstance());
    this.s8k_1 = ctrlAltOrMetaAlt(this, Key_LEFT_getInstance());
    this.t8k_1 = ctrlOrMeta(this, Key_A_getInstance());
    this.u8k_1 = this.n8k_1.c8k(ModifierKey_SHIFT_getInstance());
    this.v8k_1 = this.o8k_1.c8k(ModifierKey_SHIFT_getInstance());
    this.w8k_1 = this.l8k_1.c8k(ModifierKey_SHIFT_getInstance());
    this.x8k_1 = this.m8k_1.c8k(ModifierKey_SHIFT_getInstance());
    this.y8k_1 = this.q8k_1.c8k(ModifierKey_SHIFT_getInstance());
    this.z8k_1 = this.p8k_1.c8k(ModifierKey_SHIFT_getInstance());
    this.a8l_1 = KeyStrokeSpec_init_$Create$(Key_LEFT_getInstance(), [ModifierKey_SHIFT_getInstance()]);
    this.b8l_1 = KeyStrokeSpec_init_$Create$(Key_RIGHT_getInstance(), [ModifierKey_SHIFT_getInstance()]);
    this.c8l_1 = KeyStrokeSpec_init_$Create$(Key_UP_getInstance(), [ModifierKey_SHIFT_getInstance()]);
    this.d8l_1 = KeyStrokeSpec_init_$Create$(Key_DOWN_getInstance(), [ModifierKey_SHIFT_getInstance()]);
    this.e8l_1 = KeyStrokeSpec_init_$Create$(Key_UP_getInstance(), [ModifierKey_ALT_getInstance()]);
    this.f8l_1 = KeyStrokeSpec_init_$Create$(Key_DOWN_getInstance(), [ModifierKey_ALT_getInstance()]);
    this.g8l_1 = ctrlOrMeta(this, Key_D_getInstance());
    this.h8l_1 = this.n8l([KeyStrokeSpec_init_$Create$(Key_BACKSPACE_getInstance(), [ModifierKey_META_getInstance()]), KeyStrokeSpec_init_$Create$(Key_DELETE_getInstance(), [ModifierKey_META_getInstance()])]);
    this.i8l_1 = ctrlOrAlt(this, Key_BACKSPACE_getInstance());
    this.j8l_1 = this.n8l([ctrlAltOrMetaAlt(this, Key_LEFT_BRACE_getInstance()), ctrlAltOrMetaAlt(this, Key_RIGHT_BRACE_getInstance())]);
    this.k8l_1 = ctrlOrMeta(this, Key_LEFT_BRACE_getInstance());
    this.l8l_1 = ctrlOrMeta(this, Key_RIGHT_BRACE_getInstance());
  }
  protoOf(KeyStrokeSpecs).n8l = function (specs) {
    var keyStrokes = HashSet_init_$Create$();
    var inductionVariable = 0;
    var last = specs.length;
    while (inductionVariable < last) {
      var spec = specs[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      var _iterator__ex2g4s = spec.p8j_1.m();
      while (_iterator__ex2g4s.n()) {
        var ks = _iterator__ex2g4s.o();
        keyStrokes.j(ks);
      }
    }
    return KeyStrokeSpec_init_$Create$_0(keyStrokes);
  };
  protoOf(KeyStrokeSpecs).m8l = function (specs) {
    return KeyStrokeSpec_init_$Create$_1(specs.slice());
  };
  var KeyStrokeSpecs_instance;
  function KeyStrokeSpecs_getInstance() {
    if (KeyStrokeSpecs_instance == null)
      new KeyStrokeSpecs();
    return KeyStrokeSpecs_instance;
  }
  var ModifierKey_CONTROL_instance;
  var ModifierKey_ALT_instance;
  var ModifierKey_SHIFT_instance;
  var ModifierKey_META_instance;
  var ModifierKey_entriesInitialized;
  function ModifierKey_initEntries() {
    if (ModifierKey_entriesInitialized)
      return Unit_instance;
    ModifierKey_entriesInitialized = true;
    ModifierKey_CONTROL_instance = new ModifierKey('CONTROL', 0);
    ModifierKey_ALT_instance = new ModifierKey('ALT', 1);
    ModifierKey_SHIFT_instance = new ModifierKey('SHIFT', 2);
    ModifierKey_META_instance = new ModifierKey('META', 3);
  }
  function ModifierKey(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function ModifierKey_CONTROL_getInstance() {
    ModifierKey_initEntries();
    return ModifierKey_CONTROL_instance;
  }
  function ModifierKey_ALT_getInstance() {
    ModifierKey_initEntries();
    return ModifierKey_ALT_instance;
  }
  function ModifierKey_SHIFT_getInstance() {
    ModifierKey_initEntries();
    return ModifierKey_SHIFT_instance;
  }
  function ModifierKey_META_getInstance() {
    ModifierKey_initEntries();
    return ModifierKey_META_instance;
  }
  var MouseButton_NONE_instance;
  var MouseButton_LEFT_instance;
  var MouseButton_MIDDLE_instance;
  var MouseButton_RIGHT_instance;
  var MouseButton_entriesInitialized;
  function MouseButton_initEntries() {
    if (MouseButton_entriesInitialized)
      return Unit_instance;
    MouseButton_entriesInitialized = true;
    MouseButton_NONE_instance = new MouseButton('NONE', 0);
    MouseButton_LEFT_instance = new MouseButton('LEFT', 1);
    MouseButton_MIDDLE_instance = new MouseButton('MIDDLE', 2);
    MouseButton_RIGHT_instance = new MouseButton('RIGHT', 3);
  }
  function MouseButton(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function MouseButton_NONE_getInstance() {
    MouseButton_initEntries();
    return MouseButton_NONE_instance;
  }
  function MouseButton_LEFT_getInstance() {
    MouseButton_initEntries();
    return MouseButton_LEFT_instance;
  }
  function MouseButton_MIDDLE_getInstance() {
    MouseButton_initEntries();
    return MouseButton_MIDDLE_instance;
  }
  function MouseButton_RIGHT_getInstance() {
    MouseButton_initEntries();
    return MouseButton_RIGHT_instance;
  }
  function MouseEvent_init_$Init$(v, button, modifiers, $this) {
    modifiers = modifiers === VOID ? Companion_getInstance_140().w8j() : modifiers;
    MouseEvent.call($this, v.d8c_1, v.e8c_1, button, modifiers);
    return $this;
  }
  function MouseEvent_init_$Create$(v, button, modifiers) {
    return MouseEvent_init_$Init$(v, button, modifiers, objectCreate(protoOf(MouseEvent)));
  }
  function Companion_141() {
  }
  protoOf(Companion_141).o8l = function (v) {
    return MouseEvent_init_$Create$(v, MouseButton_NONE_getInstance());
  };
  var Companion_instance_141;
  function Companion_getInstance_141() {
    return Companion_instance_141;
  }
  function MouseEvent(x, y, button, modifiers) {
    PointEvent.call(this, x, y);
    this.t8l_1 = button;
    this.u8l_1 = modifiers;
  }
  function PasteEvent(content) {
    Event_0.call(this);
    this.c8m_1 = content;
  }
  function PointEvent(x, y) {
    Event_0.call(this);
    this.x8l_1 = x;
    this.y8l_1 = y;
  }
  protoOf(PointEvent).z8l = function () {
    return new Vector(this.x8l_1, this.y8l_1);
  };
  protoOf(PointEvent).toString = function () {
    return '{x=' + this.x8l_1 + ',y=' + this.y8l_1 + '}';
  };
  function TouchEvent() {
  }
  function SimpleContentKind(name) {
    this.d8m_1 = name;
  }
  protoOf(SimpleContentKind).toString = function () {
    return 'SimpleContentKind(name=' + this.d8m_1 + ')';
  };
  protoOf(SimpleContentKind).hashCode = function () {
    return getStringHashCode(this.d8m_1);
  };
  protoOf(SimpleContentKind).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SimpleContentKind))
      return false;
    if (!(this.d8m_1 === other.d8m_1))
      return false;
    return true;
  };
  function ListContentKind(baseKind) {
    this.e8m_1 = baseKind;
  }
  protoOf(ListContentKind).toString = function () {
    return 'ListContentKind(baseKind=' + toString_1(this.e8m_1) + ')';
  };
  protoOf(ListContentKind).hashCode = function () {
    return hashCode(this.e8m_1);
  };
  protoOf(ListContentKind).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ListContentKind))
      return false;
    if (!equals(this.e8m_1, other.e8m_1))
      return false;
    return true;
  };
  function ContentKinds() {
    ContentKinds_instance = this;
    this.f8m_1 = this.h8m('singleLineText');
    this.g8m_1 = this.h8m('multilineText');
  }
  protoOf(ContentKinds).h8m = function (name) {
    return new SimpleContentKind(name);
  };
  protoOf(ContentKinds).i8m = function (kind) {
    return new ListContentKind(kind);
  };
  var ContentKinds_instance;
  function ContentKinds_getInstance() {
    if (ContentKinds_instance == null)
      new ContentKinds();
    return ContentKinds_instance;
  }
  function MultilineTextClipboardContent(lines) {
    this.j8m_1 = lines;
  }
  protoOf(MultilineTextClipboardContent).e8i = function (kind) {
    return equals(kind, ContentKinds_getInstance().g8m_1);
  };
  protoOf(MultilineTextClipboardContent).f8i = function (kind) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.require' call
    if (!(kind === ContentKinds_getInstance().g8m_1)) {
      var message = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    var tmp = this.j8m_1;
    return !(tmp == null) ? tmp : THROW_CCE();
  };
  function SingleLineTextClipboardContent(text) {
    this.k8m_1 = text;
  }
  protoOf(SingleLineTextClipboardContent).e8i = function (kind) {
    return equals(kind, ContentKinds_getInstance().f8m_1);
  };
  protoOf(SingleLineTextClipboardContent).f8i = function (kind) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.require' call
    if (!(kind === ContentKinds_getInstance().f8m_1)) {
      var message = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    var tmp = this.k8m_1;
    return !(tmp == null) ? tmp : THROW_CCE();
  };
  function advancePastStringBody($this) {
    while (lookingAtStringBody($this)) {
      advance($this);
    }
  }
  function advancePastNewline($this) {
    if (!tryAdvancePast($this, _Char___init__impl__6a9atx(13), _Char___init__impl__6a9atx(10))) {
      // Inline function 'kotlin.check' call
      if (!tryAdvancePast($this, _Char___init__impl__6a9atx(10), _Char___init__impl__6a9atx(13))) {
        throw IllegalStateException_init_$Create$_0('Check failed.');
      }
    }
  }
  function tryAdvancePast($this, required, optional) {
    var tmp;
    if (current($this) === required) {
      advance($this);
      if (!lookingAtEOF($this) && current($this) === optional) {
        advance($this);
      }
      tmp = true;
    } else {
      tmp = false;
    }
    return tmp;
  }
  function current($this) {
    return charCodeAt($this.l8m_1, $this.m8m_1);
  }
  function advance($this) {
    $this.m8m_1 = $this.m8m_1 + 1 | 0;
  }
  function lookingAtStringBody($this) {
    return !lookingAtEOF($this) && !(current($this) === _Char___init__impl__6a9atx(13)) && !(current($this) === _Char___init__impl__6a9atx(10));
  }
  function lookingAtEOF($this) {
    return $this.m8m_1 === $this.l8m_1.length;
  }
  function _get_hasLineFeed__kp5f8b($this, _this__u8e3s4) {
    return contains_9(_this__u8e3s4, _Char___init__impl__6a9atx(10)) || contains_9(_this__u8e3s4, _Char___init__impl__6a9atx(13));
  }
  function LinesIterator_0(multiline) {
    this.l8m_1 = multiline;
    this.m8m_1 = 0;
    this.n8m_1 = lookingAtEOF(this);
  }
  protoOf(LinesIterator_0).n = function () {
    return !lookingAtEOF(this) || this.n8m_1;
  };
  protoOf(LinesIterator_0).o = function () {
    if (!this.n()) {
      throw NoSuchElementException_init_$Create$();
    }
    var nextLine;
    if (this.n8m_1) {
      this.n8m_1 = false;
      nextLine = '';
    } else {
      var lineBeginning = this.m8m_1;
      advancePastStringBody(this);
      var lineRightBound = this.m8m_1;
      if (!lookingAtEOF(this)) {
        advancePastNewline(this);
        if (lookingAtEOF(this)) {
          this.n8m_1 = true;
        }
      }
      nextLine = substring(this.l8m_1, lineBeginning, lineRightBound);
    }
    return nextLine;
  };
  function TextContentHelper$splitByNewline$1($multiline) {
    this.o8m_1 = $multiline;
  }
  protoOf(TextContentHelper$splitByNewline$1).m = function () {
    return new LinesIterator_0(this.o8m_1);
  };
  function TextContentHelper() {
    TextContentHelper_instance = this;
    this.p8m_1 = _Char___init__impl__6a9atx(13);
    this.q8m_1 = _Char___init__impl__6a9atx(10);
  }
  protoOf(TextContentHelper).r8m = function (string) {
    var tmp;
    if (_get_hasLineFeed__kp5f8b(this, string)) {
      tmp = new MultilineTextClipboardContent(this.s8m(string));
    } else {
      tmp = new SingleLineTextClipboardContent(string);
    }
    return tmp;
  };
  protoOf(TextContentHelper).t8m = function (string) {
    // Inline function 'kotlin.check' call
    if (!!_get_hasLineFeed__kp5f8b(this, string)) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    return new SingleLineTextClipboardContent(string);
  };
  protoOf(TextContentHelper).u8m = function (strings) {
    return new MultilineTextClipboardContent(strings);
  };
  protoOf(TextContentHelper).s8m = function (multiline) {
    return new TextContentHelper$splitByNewline$1(multiline);
  };
  protoOf(TextContentHelper).v8m = function (lines) {
    var multiline = StringBuilder_init_$Create$_1();
    var lineIter = lines.m();
    while (lineIter.n()) {
      multiline.j8(lineIter.o());
      if (lineIter.n()) {
        multiline.k8(_Char___init__impl__6a9atx(10));
      }
    }
    return multiline.toString();
  };
  var TextContentHelper_instance;
  function TextContentHelper_getInstance() {
    if (TextContentHelper_instance == null)
      new TextContentHelper();
    return TextContentHelper_instance;
  }
  function getText(_this__u8e3s4) {
    var tmp;
    if (_this__u8e3s4.e8i(ContentKinds_getInstance().f8m_1)) {
      tmp = _this__u8e3s4.f8i(ContentKinds_getInstance().f8m_1);
    } else if (_this__u8e3s4.e8i(ContentKinds_getInstance().g8m_1)) {
      tmp = TextContentHelper_getInstance().v8m(_this__u8e3s4.f8i(ContentKinds_getInstance().g8m_1));
    } else {
      tmp = _this__u8e3s4.g8i();
    }
    return tmp;
  }
  function execCopyCommand($this) {
    DomApi_instance.k8f().execCommand('copy');
  }
  function createAndFillClipboardTextArea($this, text) {
    var clipboardArea = createClipboardTextArea($this);
    clipboardArea.value = text;
    clipboardArea.select();
    return clipboardArea;
  }
  function createClipboardTextArea($this) {
    var pasteArea = DomApi_instance.q8f();
    var style = pasteArea.style;
    setPosition(style, CssPosition_ABSOLUTE_getInstance());
    setWidth(style, 1);
    setHeight(style, 1);
    setBottom(style, -100.0);
    setLeft(style, -100.0);
    setZIndex(style, -1);
    DomApi_instance.j8f().appendChild(pasteArea);
    pasteArea.focus();
    return pasteArea;
  }
  function scheduleCutAreaRemoval($this, textArea, retries, delay, delayIncreasePerRetry) {
    (new Timer(DomClipboardSupport$scheduleCutAreaRemoval$lambda(textArea, retries, $this, delay, delayIncreasePerRetry))).m3a(delay);
  }
  function Companion_142() {
  }
  var Companion_instance_142;
  function Companion_getInstance_142() {
    return Companion_instance_142;
  }
  function DomClipboardSupport$pasteContent$lambda($pasteArea, this$0, $handler) {
    return function () {
      DomApi_instance.j8f().removeChild($pasteArea);
      this$0.w8m_1.focus();
      var text = $pasteArea.value;
      $handler(text);
      return Unit_instance;
    };
  }
  function DomClipboardSupport$copyContent$lambda($copyArea, this$0) {
    return function () {
      DomApi_instance.j8f().removeChild($copyArea);
      this$0.w8m_1.focus();
      return Unit_instance;
    };
  }
  function DomClipboardSupport$scheduleCutAreaRemoval$lambda($textArea, $retries, this$0, $delay, $delayIncreasePerRetry) {
    return function () {
      var tmp;
      var tmp_0;
      // Inline function 'kotlin.text.isEmpty' call
      var this_0 = $textArea.innerText;
      if (charSequenceLength(this_0) === 0) {
        tmp_0 = true;
      } else {
        tmp_0 = $retries === 0;
      }
      if (tmp_0) {
        DomApi_instance.j8f().removeChild($textArea);
        this$0.w8m_1.focus();
        tmp = Unit_instance;
      } else {
        scheduleCutAreaRemoval(this$0, $textArea, $retries - 1 | 0, $delay + $delayIncreasePerRetry | 0, $delayIncreasePerRetry);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function DomClipboardSupport(target) {
    this.w8m_1 = target;
  }
  protoOf(DomClipboardSupport).x8m = function (handler) {
    var pasteArea = createClipboardTextArea(Companion_instance_142);
    (new Timer(DomClipboardSupport$pasteContent$lambda(pasteArea, this, handler))).m3a(20);
  };
  protoOf(DomClipboardSupport).y8m = function (text) {
    var copyArea = createAndFillClipboardTextArea(Companion_instance_142, text);
    execCopyCommand(Companion_instance_142);
    (new Timer(DomClipboardSupport$copyContent$lambda(copyArea, this))).m3a(20);
  };
  protoOf(DomClipboardSupport).z8m = function (text) {
    var cutArea = createAndFillClipboardTextArea(Companion_instance_142, text);
    scheduleCutAreaRemoval(this, cutArea, 3, 20, 30);
  };
  function toKeyEvent($this, e) {
    var key = DomKeyCodeMapper_getInstance().b8n(e.keyCode);
    var modifiers = HashSet_init_$Create$();
    if (e.ctrlKey) {
      modifiers.j(ModifierKey_CONTROL_getInstance());
    }
    if (e.altKey) {
      modifiers.j(ModifierKey_ALT_getInstance());
    }
    if (e.shiftKey) {
      modifiers.j(ModifierKey_SHIFT_getInstance());
    }
    if (e.metaKey) {
      modifiers.j(ModifierKey_META_getInstance());
    }
    return KeyEvent_init_$Create$_0(key, numberToChar(e.charCode), modifiers);
  }
  function DomEventUtil() {
  }
  protoOf(DomEventUtil).c8n = function (e, handler) {
    var event = toKeyEvent(this, e);
    handler(event);
    if (event.z().equals(Key_BACKSPACE_getInstance()))
      return false;
    if (event.z().equals(Key_UP_getInstance()) || event.z().equals(Key_DOWN_getInstance()) || event.z().equals(Key_LEFT_getInstance()) || event.z().equals(Key_RIGHT_getInstance()))
      return false;
    if (event.z().equals(Key_SPACE_getInstance()))
      return false;
    if (event.o8j([KeyStrokeSpecs_getInstance().a8l_1]) || event.o8j([KeyStrokeSpecs_getInstance().c8l_1]) || event.o8j([KeyStrokeSpecs_getInstance().b8l_1]) || event.o8j([KeyStrokeSpecs_getInstance().d8l_1])) {
      return false;
    }
    if (event.o8j([KeyStrokeSpecs_getInstance().j8l_1]))
      return false;
    return event.m8j(Key_TAB_getInstance(), []) || event.m8j(Key_TAB_getInstance(), [ModifierKey_SHIFT_getInstance()]) ? false : !event.l8i_1;
  };
  protoOf(DomEventUtil).d8n = function (e, handler) {
    var event = toKeyEvent(this, e);
    handler(event);
    return !event.l8i_1;
  };
  protoOf(DomEventUtil).e8n = function (e, handler) {
    var event = toKeyEvent(this, e);
    if (e.charCode < 32 || e.charCode === 127)
      return true;
    var tmp = e.charCode;
    // Inline function 'kotlin.code' call
    var this_0 = _Char___init__impl__6a9atx(10);
    if (tmp === Char__toInt_impl_vasixd(this_0))
      return true;
    var tmp_0 = e.charCode;
    // Inline function 'kotlin.code' call
    var this_1 = _Char___init__impl__6a9atx(13);
    if (tmp_0 === Char__toInt_impl_vasixd(this_1))
      return true;
    if (event.t8j(ModifierKey_META_getInstance()) || (event.t8j(ModifierKey_CONTROL_getInstance()) && !event.t8j(ModifierKey_ALT_getInstance())))
      return true;
    handler(event);
    return !event.l8i_1;
  };
  protoOf(DomEventUtil).f8n = function (event) {
    var tmp0_subject = event.button;
    return tmp0_subject === 0 ? MouseButton_LEFT_getInstance() : tmp0_subject === 1 ? MouseButton_MIDDLE_getInstance() : tmp0_subject === 2 ? MouseButton_RIGHT_getInstance() : MouseButton_NONE_getInstance();
  };
  protoOf(DomEventUtil).g8n = function (e) {
    var ctrlKey = e.ctrlKey;
    var altKey = e.altKey;
    var shiftKey = e.shiftKey;
    var metaKey = e.metaKey;
    return new KeyModifiers(ctrlKey, altKey, shiftKey, metaKey);
  };
  var DomEventUtil_instance;
  function DomEventUtil_getInstance() {
    return DomEventUtil_instance;
  }
  function DomKeyCodeMapper() {
    DomKeyCodeMapper_instance = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOfNulls' call
    tmp.a8n_1 = Array(222);
    this.a8n_1[18] = Key_ALT_getInstance();
    this.a8n_1[8] = Key_BACKSPACE_getInstance();
    this.a8n_1[17] = Key_CONTROL_getInstance();
    this.a8n_1[46] = Key_DELETE_getInstance();
    this.a8n_1[40] = Key_DOWN_getInstance();
    this.a8n_1[35] = Key_END_getInstance();
    this.a8n_1[13] = Key_ENTER_getInstance();
    this.a8n_1[27] = Key_ESCAPE_getInstance();
    this.a8n_1[36] = Key_HOME_getInstance();
    this.a8n_1[37] = Key_LEFT_getInstance();
    this.a8n_1[34] = Key_PAGE_DOWN_getInstance();
    this.a8n_1[33] = Key_PAGE_UP_getInstance();
    this.a8n_1[39] = Key_RIGHT_getInstance();
    this.a8n_1[16] = Key_SHIFT_getInstance();
    this.a8n_1[9] = Key_TAB_getInstance();
    this.a8n_1[38] = Key_UP_getInstance();
    this.a8n_1[45] = Key_INSERT_getInstance();
    this.a8n_1[32] = Key_SPACE_getInstance();
    set_0(this.a8n_1, _Char___init__impl__6a9atx(65), Key_A_getInstance());
    set_0(this.a8n_1, _Char___init__impl__6a9atx(66), Key_B_getInstance());
    set_0(this.a8n_1, _Char___init__impl__6a9atx(67), Key_C_getInstance());
    set_0(this.a8n_1, _Char___init__impl__6a9atx(68), Key_D_getInstance());
    set_0(this.a8n_1, _Char___init__impl__6a9atx(69), Key_E_getInstance());
    set_0(this.a8n_1, _Char___init__impl__6a9atx(70), Key_F_getInstance());
    set_0(this.a8n_1, _Char___init__impl__6a9atx(71), Key_G_getInstance());
    set_0(this.a8n_1, _Char___init__impl__6a9atx(72), Key_H_getInstance());
    set_0(this.a8n_1, _Char___init__impl__6a9atx(73), Key_I_getInstance());
    set_0(this.a8n_1, _Char___init__impl__6a9atx(74), Key_J_getInstance());
    set_0(this.a8n_1, _Char___init__impl__6a9atx(75), Key_K_getInstance());
    set_0(this.a8n_1, _Char___init__impl__6a9atx(76), Key_L_getInstance());
    set_0(this.a8n_1, _Char___init__impl__6a9atx(77), Key_M_getInstance());
    set_0(this.a8n_1, _Char___init__impl__6a9atx(78), Key_N_getInstance());
    set_0(this.a8n_1, _Char___init__impl__6a9atx(79), Key_O_getInstance());
    set_0(this.a8n_1, _Char___init__impl__6a9atx(80), Key_P_getInstance());
    set_0(this.a8n_1, _Char___init__impl__6a9atx(81), Key_Q_getInstance());
    set_0(this.a8n_1, _Char___init__impl__6a9atx(82), Key_R_getInstance());
    set_0(this.a8n_1, _Char___init__impl__6a9atx(83), Key_S_getInstance());
    set_0(this.a8n_1, _Char___init__impl__6a9atx(84), Key_T_getInstance());
    set_0(this.a8n_1, _Char___init__impl__6a9atx(85), Key_U_getInstance());
    set_0(this.a8n_1, _Char___init__impl__6a9atx(86), Key_V_getInstance());
    set_0(this.a8n_1, _Char___init__impl__6a9atx(87), Key_W_getInstance());
    set_0(this.a8n_1, _Char___init__impl__6a9atx(88), Key_X_getInstance());
    set_0(this.a8n_1, _Char___init__impl__6a9atx(89), Key_Y_getInstance());
    set_0(this.a8n_1, _Char___init__impl__6a9atx(90), Key_Z_getInstance());
    this.a8n_1[219] = Key_LEFT_BRACE_getInstance();
    this.a8n_1[221] = Key_RIGHT_BRACE_getInstance();
    set_0(this.a8n_1, _Char___init__impl__6a9atx(48), Key_DIGIT_0_getInstance());
    set_0(this.a8n_1, _Char___init__impl__6a9atx(49), Key_DIGIT_1_getInstance());
    set_0(this.a8n_1, _Char___init__impl__6a9atx(50), Key_DIGIT_2_getInstance());
    set_0(this.a8n_1, _Char___init__impl__6a9atx(51), Key_DIGIT_3_getInstance());
    set_0(this.a8n_1, _Char___init__impl__6a9atx(52), Key_DIGIT_4_getInstance());
    set_0(this.a8n_1, _Char___init__impl__6a9atx(53), Key_DIGIT_5_getInstance());
    set_0(this.a8n_1, _Char___init__impl__6a9atx(54), Key_DIGIT_6_getInstance());
    set_0(this.a8n_1, _Char___init__impl__6a9atx(55), Key_DIGIT_7_getInstance());
    set_0(this.a8n_1, _Char___init__impl__6a9atx(56), Key_DIGIT_8_getInstance());
    set_0(this.a8n_1, _Char___init__impl__6a9atx(57), Key_DIGIT_9_getInstance());
    this.a8n_1[112] = Key_F1_getInstance();
    this.a8n_1[113] = Key_F2_getInstance();
    this.a8n_1[114] = Key_F3_getInstance();
    this.a8n_1[115] = Key_F4_getInstance();
    this.a8n_1[116] = Key_F5_getInstance();
    this.a8n_1[117] = Key_F6_getInstance();
    this.a8n_1[118] = Key_F7_getInstance();
    this.a8n_1[119] = Key_F8_getInstance();
    this.a8n_1[120] = Key_F9_getInstance();
    this.a8n_1[121] = Key_F10_getInstance();
    this.a8n_1[122] = Key_F11_getInstance();
    this.a8n_1[123] = Key_F12_getInstance();
    this.a8n_1[188] = Key_COMMA_getInstance();
    this.a8n_1[190] = Key_PERIOD_getInstance();
    this.a8n_1[191] = Key_SLASH_getInstance();
    this.a8n_1[192] = Key_BACK_QUOTE_getInstance();
  }
  protoOf(DomKeyCodeMapper).b8n = function (code) {
    if (code < this.a8n_1.length) {
      var result = this.a8n_1[code];
      if (!(result == null)) {
        return result;
      }
    }
    return Key_UNKNOWN_getInstance();
  };
  var DomKeyCodeMapper_instance;
  function DomKeyCodeMapper_getInstance() {
    if (DomKeyCodeMapper_instance == null)
      new DomKeyCodeMapper();
    return DomKeyCodeMapper_instance;
  }
  function set_0(_this__u8e3s4, c, value) {
    // Inline function 'kotlin.code' call
    _this__u8e3s4[Char__toInt_impl_vasixd(c)] = value;
  }
  function KeyEventUtil() {
  }
  protoOf(KeyEventUtil).h8n = function (target, event) {
    var tmp;
    if (event.z().equals(Key_SPACE_getInstance()) && !event.o8j([KeyStrokeSpecs_getInstance().i8k_1])) {
      target.i8n(event);
      target.j8n(KeyEvent_init_$Create$(Key_SPACE_getInstance(), _Char___init__impl__6a9atx(32)));
      tmp = true;
    } else {
      tmp = false;
    }
    return tmp;
  };
  var KeyEventUtil_instance;
  function KeyEventUtil_getInstance() {
    return KeyEventUtil_instance;
  }
  function canDragging($this, pressed, moved) {
    var tmp0 = abs_0(pressed.x8l_1 - moved.x8l_1 | 0);
    // Inline function 'kotlin.math.max' call
    var b = abs_0(pressed.y8l_1 - moved.y8l_1 | 0);
    return Math.max(tmp0, b) > 5;
  }
  function toMouseEvent($this, e) {
    var vec = new Vector(e.clientX, e.clientY);
    return MouseEvent_init_$Create$($this.m8n(vec), DomEventUtil_instance.f8n(e), DomEventUtil_instance.g8n(e));
  }
  function Companion_143() {
    this.n8n_1 = 5;
  }
  var Companion_instance_143;
  function Companion_getInstance_143() {
    return Companion_instance_143;
  }
  function MouseTranslator$translate$lambda(this$0) {
    return function (e) {
      var event = toMouseEvent(this$0, e);
      var tmp;
      if (this$0.p8n(event)) {
        tmp = true;
      } else {
        this$0.l8n_1.o8n(event);
        tmp = !event.l8i_1;
      }
      return tmp;
    };
  }
  function MouseTranslator$translate$lambda_0(this$0) {
    return function (e) {
      var event = toMouseEvent(this$0, e);
      var tmp;
      if (this$0.p8n(event)) {
        tmp = true;
      } else {
        this$0.l8n_1.q8n(event);
        tmp = !event.l8i_1;
      }
      return tmp;
    };
  }
  function MouseTranslator$translate$lambda_1(this$0, $pressed) {
    return function (e) {
      var event = toMouseEvent(this$0, e);
      var tmp0 = $pressed;
      // Inline function 'kotlin.collections.set' call
      var key = event.t8l_1;
      tmp0.t2(key, event);
      var tmp;
      if (this$0.p8n(event)) {
        tmp = true;
      } else {
        this$0.l8n_1.r8n(event);
        this$0.s8n();
        tmp = !event.l8i_1;
      }
      return tmp;
    };
  }
  function MouseTranslator$translate$lambda_2(this$0, $pressed, $pressedOutside) {
    return function (e) {
      var pressedInside = this$0.k8n_1.contains(cast_0(ensureNotNull(get_eventTarget(e))));
      var evt = toMouseEvent(this$0, e);
      var tmp0 = $pressed;
      // Inline function 'kotlin.collections.set' call
      var key = evt.t8l_1;
      tmp0.t2(key, evt);
      var tmp;
      if (!pressedInside || this$0.p8n(evt)) {
        $pressedOutside.j(evt.t8l_1);
        tmp = Unit_instance;
      }
      return true;
    };
  }
  function MouseTranslator$translate$lambda_3($pressed, $pressedOutside) {
    return function (e) {
      $pressed.u2(DomEventUtil_instance.f8n(e));
      $pressedOutside.h2(DomEventUtil_instance.f8n(e));
      return true;
    };
  }
  function MouseTranslator$translate$lambda_4(this$0, $pressed) {
    return function (e) {
      var event = toMouseEvent(this$0, e);
      $pressed.u2(event.t8l_1);
      var tmp;
      if (!this$0.p8n(event)) {
        this$0.l8n_1.t8n(event);
        tmp = Unit_instance;
      }
      return true;
    };
  }
  function MouseTranslator$translate$lambda_5(this$0, $pressed, $pressedOutside) {
    return function (e) {
      var evt = toMouseEvent(this$0, e);
      var pressedEvent = $pressed.q2(evt.t8l_1);
      var tmp;
      if (!(pressedEvent == null) && !$pressedOutside.t(evt.t8l_1) && canDragging(this$0, pressedEvent, evt)) {
        this$0.l8n_1.u8n(evt);
        tmp = Unit_instance;
      }
      return true;
    };
  }
  function MouseTranslator$translate$lambda_6(this$0, $pressed, $pressedOutside) {
    return function (e) {
      var event = toMouseEvent(this$0, e);
      var tmp;
      if (this$0.p8n(event)) {
        tmp = true;
      } else {
        var pressedEvent = $pressed.q2(event.t8l_1);
        if (!(pressedEvent == null) && !$pressedOutside.t(event.t8l_1) && canDragging(this$0, pressedEvent, event)) {
          this$0.l8n_1.u8n(event);
        } else {
          this$0.l8n_1.v8n(event);
        }
        tmp = !event.l8i_1;
      }
      return tmp;
    };
  }
  function MouseTranslator$translate$lambda_7(this$0) {
    return function (e) {
      var event = toMouseEvent(this$0, e);
      var tmp;
      if (this$0.x8n(event)) {
        tmp = true;
      } else {
        this$0.l8n_1.w8n(event);
        tmp = false;
      }
      return tmp;
    };
  }
  function MouseTranslator$translate$lambda_8(this$0) {
    return function (e) {
      var event = toMouseEvent(this$0, e);
      var tmp;
      if (this$0.x8n(event)) {
        tmp = true;
      } else {
        this$0.l8n_1.y8n(event);
        tmp = false;
      }
      return tmp;
    };
  }
  function MouseTranslator$translate$lambda_9(this$0) {
    return function (e) {
      var event = toMouseEvent(this$0, e);
      this$0.l8n_1.w8n(event);
      return true;
    };
  }
  function MouseTranslator(source, target) {
    this.k8n_1 = source;
    this.l8n_1 = target;
  }
  protoOf(MouseTranslator).m8n = function (vec) {
    return vec.i8c(new Vector(numberToInt(DomApi_instance.l8f().scrollX), numberToInt(DomApi_instance.l8f().scrollY)));
  };
  protoOf(MouseTranslator).z8n = function () {
    var disposable = new CompositeDisposable([]);
    var pressed = HashMap_init_$Create$();
    var pressedOutside = HashSet_init_$Create$();
    var tmp = Companion_getInstance_139().g8g_1;
    disposable.l2l([on(this.k8n_1, tmp, MouseTranslator$translate$lambda(this))]);
    var tmp_0 = Companion_getInstance_139().i8g_1;
    disposable.l2l([on(this.k8n_1, tmp_0, MouseTranslator$translate$lambda_0(this))]);
    var tmp_1 = Companion_getInstance_139().z8g_1;
    disposable.l2l([on(this.k8n_1, tmp_1, MouseTranslator$translate$lambda_1(this, pressed))]);
    var document = DomApi_instance.k8f();
    var tmp_2 = Companion_getInstance_139().z8g_1;
    disposable.l2l([on(document, tmp_2, MouseTranslator$translate$lambda_2(this, pressed, pressedOutside))]);
    var tmp_3 = Companion_getInstance_139().d8h_1;
    disposable.l2l([on(document, tmp_3, MouseTranslator$translate$lambda_3(pressed, pressedOutside))]);
    var tmp_4 = Companion_getInstance_139().d8h_1;
    disposable.l2l([on(this.k8n_1, tmp_4, MouseTranslator$translate$lambda_4(this, pressed))]);
    var tmp_5 = Companion_getInstance_139().a8h_1;
    disposable.l2l([on(document, tmp_5, MouseTranslator$translate$lambda_5(this, pressed, pressedOutside))]);
    var tmp_6 = Companion_getInstance_139().a8h_1;
    disposable.l2l([on(this.k8n_1, tmp_6, MouseTranslator$translate$lambda_6(this, pressed, pressedOutside))]);
    var tmp_7 = Companion_getInstance_139().c8h_1;
    disposable.l2l([on(this.k8n_1, tmp_7, MouseTranslator$translate$lambda_7(this))]);
    var tmp_8 = Companion_getInstance_139().b8h_1;
    disposable.l2l([on(this.k8n_1, tmp_8, MouseTranslator$translate$lambda_8(this))]);
    var tmp_9 = Companion_getInstance_139().e8h_1;
    disposable.l2l([on(this.k8n_1, tmp_9, MouseTranslator$translate$lambda_9(this))]);
    return disposable;
  };
  function onKeyDown($this, event) {
    if (!KeyEventUtil_instance.h8n($this.b8o_1, event)) {
      if (event.o8j([KeyStrokeSpecs_getInstance().f8k_1])) {
        $this.c8o_1.x8m(SimpleKeyTranslator$onKeyDown$lambda($this, event));
      } else if (event.o8j([KeyStrokeSpecs_getInstance().d8k_1])) {
        var copyEvent = new CopyCutEvent();
        $this.b8o_1.e8o(copyEvent);
        $this.c8o_1.y8m(getText(copyEvent.s8i_1));
      } else if (event.o8j([KeyStrokeSpecs_getInstance().e8k_1])) {
        var cutEvent = new CopyCutEvent();
        $this.b8o_1.d8o(cutEvent);
        $this.c8o_1.z8m(getText(cutEvent.s8i_1));
      } else {
        $this.b8o_1.i8n(event);
      }
    }
  }
  function SimpleKeyTranslator$translate$lambda$lambda(this$0) {
    return function (te) {
      onKeyDown(this$0, te);
      return Unit_instance;
    };
  }
  function SimpleKeyTranslator$translate$lambda(this$0) {
    return function (e) {
      var tmp = DomEventUtil_instance;
      return tmp.c8n(e, SimpleKeyTranslator$translate$lambda$lambda(this$0));
    };
  }
  function UIEventsTarget$keyReleased$ref(p0) {
    var l = function (_this__u8e3s4) {
      p0.f8o(_this__u8e3s4);
      return Unit_instance;
    };
    l.callableName = 'keyReleased';
    return l;
  }
  function SimpleKeyTranslator$translate$lambda_0(this$0) {
    return function (event) {
      var tmp = DomEventUtil_instance;
      return tmp.d8n(event, UIEventsTarget$keyReleased$ref(this$0.b8o_1));
    };
  }
  function SimpleKeyTranslator$translate$lambda$lambda_0(this$0) {
    return function (te) {
      var tmp;
      if (!(te.i8j_1 === _Char___init__impl__6a9atx(32))) {
        this$0.b8o_1.j8n(te);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function SimpleKeyTranslator$translate$lambda_1(this$0) {
    return function (e) {
      var tmp = DomEventUtil_instance;
      return tmp.e8n(e, SimpleKeyTranslator$translate$lambda$lambda_0(this$0));
    };
  }
  function SimpleKeyTranslator$onKeyDown$lambda(this$0, $event) {
    return function (text) {
      var tmp;
      // Inline function 'kotlin.text.isEmpty' call
      if (charSequenceLength(text) === 0) {
        this$0.b8o_1.i8n($event.s3e());
        tmp = Unit_instance;
      } else {
        this$0.b8o_1.g8o(text);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function SimpleKeyTranslator(focusOwner, target) {
    this.a8o_1 = focusOwner;
    this.b8o_1 = target;
    this.c8o_1 = new DomClipboardSupport(cast_0(this.a8o_1));
  }
  protoOf(SimpleKeyTranslator).z8n = function () {
    var disposable = new CompositeDisposable([]);
    var tmp = Companion_getInstance_139().t8g_1;
    disposable.l2l([on(this.a8o_1, tmp, SimpleKeyTranslator$translate$lambda(this))]);
    var tmp_0 = Companion_getInstance_139().v8g_1;
    disposable.l2l([on(this.a8o_1, tmp_0, SimpleKeyTranslator$translate$lambda_0(this))]);
    var tmp_1 = Companion_getInstance_139().u8g_1;
    disposable.l2l([on(this.a8o_1, tmp_1, SimpleKeyTranslator$translate$lambda_1(this))]);
    return disposable;
  };
  function _get_selectionStart__pp91ud($this) {
    return ensureNotNull($this.h8o_1.selectionStart);
  }
  function _get_selectionEnd__cvpe9o($this) {
    return ensureNotNull($this.h8o_1.selectionEnd);
  }
  function _get_composite__sy6tzq($this) {
    return substring($this.h8o_1.value, $this.l8o_1, _get_selectionEnd__cvpe9o($this));
  }
  function applyIfNotEditor($this, handler) {
    return TextAreaKeyTranslator$applyIfNotEditor$lambda($this, handler);
  }
  function isInputArea($this, target) {
    var e = target instanceof Element ? target : THROW_CCE();
    return 'TEXTAREA' === e.tagName;
  }
  function isEditableContent($this, target) {
    var e = target instanceof Element ? target : THROW_CCE();
    var tmp0_safe_receiver = e.getAttribute('contenteditable');
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : toBoolean(tmp0_safe_receiver);
    return tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
  }
  function onInputChange($this) {
    if ($this.k8o_1) {
      updateComposition($this);
    }
  }
  function onKeyDown_0($this, e) {
    var tmp;
    if ($this.k8o_1) {
      tmp = true;
    } else {
      var tmp_0 = DomEventUtil_instance;
      tmp = tmp_0.c8n(e, TextAreaKeyTranslator$doDispatchKeyPress$ref($this));
    }
    return tmp;
  }
  function onKeyUp($this, e) {
    var tmp;
    if ($this.k8o_1) {
      tmp = true;
    } else {
      var tmp_0 = DomEventUtil_instance;
      tmp = tmp_0.d8n(e, UIEventsTarget$keyReleased$ref_0($this.j8o_1));
    }
    return tmp;
  }
  function onKeyPress($this, e) {
    var tmp;
    if ($this.k8o_1) {
      tmp = true;
    } else {
      var tmp_0 = DomEventUtil_instance;
      tmp = tmp_0.e8n(e, TextAreaKeyTranslator$onKeyPress$lambda($this));
    }
    return tmp;
  }
  function startComposition($this) {
    $this.k8o_1 = true;
    $this.l8o_1 = _get_selectionStart__pp91ud($this);
    $this.j8o_1.m8o(new CompositionEvent(_get_composite__sy6tzq($this)));
  }
  function updateComposition($this) {
    $this.j8o_1.n8o(new CompositionEvent(_get_composite__sy6tzq($this)));
  }
  function endComposition($this) {
    try {
      $this.j8o_1.o8o(new CompositionEvent(''));
      var composite = _get_composite__sy6tzq($this);
      if (composite.length === 1) {
        $this.j8o_1.j8n(KeyEvent_init_$Create$(Key_UNKNOWN_getInstance(), charCodeAt(composite, 0)));
      } else if (composite.length > 1) {
        $this.j8o_1.g8o(composite);
      }
    }finally {
      $this.k8o_1 = false;
      $this.l8o_1 = -1;
      clearTextArea($this);
    }
  }
  function doDispatchKeyPress($this, e) {
    if (KeyEventUtil_instance.h8n($this.j8o_1, e)) {
      return Unit_instance;
    }
    if (e.o8j([KeyStrokeSpecs_getInstance().f8k_1])) {
      $this.j8o_1.p8o();
      return Unit_instance;
    }
    if (e.o8j([KeyStrokeSpecs_getInstance().d8k_1])) {
      var copyEvent = new CopyCutEvent();
      $this.j8o_1.e8o(copyEvent);
      return Unit_instance;
    }
    if (e.o8j([KeyStrokeSpecs_getInstance().e8k_1])) {
      var cutEvent = new CopyCutEvent();
      $this.j8o_1.d8o(cutEvent);
      return Unit_instance;
    }
    $this.j8o_1.i8n(e);
    clearTextArea($this);
  }
  function clearTextArea($this) {
    $this.h8o_1.value = '';
  }
  function TextAreaKeyTranslator$startComposition$ref(p0) {
    var l = function () {
      var tmp0 = p0;
      startComposition(tmp0);
      return Unit_instance;
    };
    l.callableName = 'startComposition';
    return l;
  }
  function TextAreaKeyTranslator$updateComposition$ref(p0) {
    var l = function () {
      var tmp0 = p0;
      updateComposition(tmp0);
      return Unit_instance;
    };
    l.callableName = 'updateComposition';
    return l;
  }
  function TextAreaKeyTranslator$endComposition$ref(p0) {
    var l = function () {
      var tmp0 = p0;
      endComposition(tmp0);
      return Unit_instance;
    };
    l.callableName = 'endComposition';
    return l;
  }
  function TextAreaKeyTranslator$onInputChange$ref(p0) {
    var l = function () {
      var tmp0 = p0;
      onInputChange(tmp0);
      return Unit_instance;
    };
    l.callableName = 'onInputChange';
    return l;
  }
  function TextAreaKeyTranslator$onInputChange$ref_0(p0) {
    var l = function () {
      var tmp0 = p0;
      onInputChange(tmp0);
      return Unit_instance;
    };
    l.callableName = 'onInputChange';
    return l;
  }
  function TextAreaKeyTranslator$onKeyDown$ref(p0) {
    var l = function (_this__u8e3s4) {
      var tmp0 = p0;
      return onKeyDown_0(tmp0, _this__u8e3s4);
    };
    l.callableName = 'onKeyDown';
    return l;
  }
  function TextAreaKeyTranslator$onKeyUp$ref(p0) {
    var l = function (_this__u8e3s4) {
      var tmp0 = p0;
      return onKeyUp(tmp0, _this__u8e3s4);
    };
    l.callableName = 'onKeyUp';
    return l;
  }
  function TextAreaKeyTranslator$onKeyPress$ref(p0) {
    var l = function (_this__u8e3s4) {
      var tmp0 = p0;
      return onKeyPress(tmp0, _this__u8e3s4);
    };
    l.callableName = 'onKeyPress';
    return l;
  }
  function TextAreaKeyTranslator$onKeyDown$ref_0(p0) {
    var l = function (_this__u8e3s4) {
      var tmp0 = p0;
      return onKeyDown_0(tmp0, _this__u8e3s4);
    };
    l.callableName = 'onKeyDown';
    return l;
  }
  function TextAreaKeyTranslator$onKeyUp$ref_0(p0) {
    var l = function (_this__u8e3s4) {
      var tmp0 = p0;
      return onKeyUp(tmp0, _this__u8e3s4);
    };
    l.callableName = 'onKeyUp';
    return l;
  }
  function TextAreaKeyTranslator$onKeyPress$ref_0(p0) {
    var l = function (_this__u8e3s4) {
      var tmp0 = p0;
      return onKeyPress(tmp0, _this__u8e3s4);
    };
    l.callableName = 'onKeyPress';
    return l;
  }
  function TextAreaKeyTranslator$applyIfNotEditor$lambda(this$0, $handler) {
    return function (event) {
      var target = get_eventTarget(event);
      var tmp;
      if (equals(target, this$0.h8o_1) || isEditableContent(this$0, ensureNotNull(target)) || isInputArea(this$0, target)) {
        tmp = true;
      } else {
        tmp = $handler(event);
      }
      return tmp;
    };
  }
  function TextAreaKeyTranslator$doDispatchKeyPress$ref(p0) {
    var l = function (_this__u8e3s4) {
      var tmp0 = p0;
      doDispatchKeyPress(tmp0, _this__u8e3s4);
      return Unit_instance;
    };
    l.callableName = 'doDispatchKeyPress';
    return l;
  }
  function UIEventsTarget$keyReleased$ref_0(p0) {
    var l = function (_this__u8e3s4) {
      p0.f8o(_this__u8e3s4);
      return Unit_instance;
    };
    l.callableName = 'keyReleased';
    return l;
  }
  function TextAreaKeyTranslator$onKeyPress$lambda(this$0) {
    return function (te) {
      var tmp;
      if (!(te.i8j_1 === _Char___init__impl__6a9atx(32))) {
        this$0.j8o_1.j8n(te);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function TextAreaKeyTranslator(textArea, rootElement, target) {
    this.h8o_1 = textArea;
    this.i8o_1 = rootElement;
    this.j8o_1 = target;
    this.k8o_1 = false;
    this.l8o_1 = -1;
  }
  protoOf(TextAreaKeyTranslator).z8n = function () {
    var disposable = new CompositeDisposable([]);
    var tmp = Companion_getInstance_139().k8h_1;
    disposable.l2l([onEventWithRunner(this.h8o_1, tmp, TextAreaKeyTranslator$startComposition$ref(this))]);
    var tmp_0 = Companion_getInstance_139().m8h_1;
    disposable.l2l([onEventWithRunner(this.h8o_1, tmp_0, TextAreaKeyTranslator$updateComposition$ref(this))]);
    var tmp_1 = Companion_getInstance_139().l8h_1;
    disposable.l2l([onEventWithRunner(this.h8o_1, tmp_1, TextAreaKeyTranslator$endComposition$ref(this))]);
    var tmp_2 = Companion_getInstance_139().d8g_1;
    disposable.l2l([onEventWithRunner(this.h8o_1, tmp_2, TextAreaKeyTranslator$onInputChange$ref(this))]);
    var tmp_3 = Companion_getInstance_139().c8g_1;
    disposable.l2l([onEventWithRunner(this.h8o_1, tmp_3, TextAreaKeyTranslator$onInputChange$ref_0(this))]);
    var tmp_4 = Companion_getInstance_139().t8g_1;
    disposable.l2l([on(this.h8o_1, tmp_4, TextAreaKeyTranslator$onKeyDown$ref(this))]);
    var tmp_5 = Companion_getInstance_139().v8g_1;
    disposable.l2l([on(this.h8o_1, tmp_5, TextAreaKeyTranslator$onKeyUp$ref(this))]);
    var tmp_6 = Companion_getInstance_139().u8g_1;
    disposable.l2l([on(this.h8o_1, tmp_6, TextAreaKeyTranslator$onKeyPress$ref(this))]);
    var tmp_7 = Companion_getInstance_139().t8g_1;
    disposable.l2l([on(this.i8o_1, tmp_7, applyIfNotEditor(this, TextAreaKeyTranslator$onKeyDown$ref_0(this)))]);
    var tmp_8 = Companion_getInstance_139().v8g_1;
    disposable.l2l([on(this.i8o_1, tmp_8, applyIfNotEditor(this, TextAreaKeyTranslator$onKeyUp$ref_0(this)))]);
    var tmp_9 = Companion_getInstance_139().u8g_1;
    disposable.l2l([on(this.i8o_1, tmp_9, applyIfNotEditor(this, TextAreaKeyTranslator$onKeyPress$ref_0(this)))]);
    return disposable;
  };
  function Companion_144() {
  }
  protoOf(Companion_144).q8o = function (builder) {
    // Inline function 'kotlin.apply' call
    var this_0 = new ClipboardAdapterBuilder();
    builder(this_0);
    return this_0.t8o();
  };
  var Companion_instance_144;
  function Companion_getInstance_144() {
    return Companion_instance_144;
  }
  function ClipboardAdapter() {
  }
  function sam$jetbrains_ocelot_base_clipboard_ClipboardAdapter$0(function_0) {
    this.v8o_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_base_clipboard_ClipboardAdapter$0).u8o = function (systemClipboard) {
    return this.v8o_1(systemClipboard);
  };
  protoOf(sam$jetbrains_ocelot_base_clipboard_ClipboardAdapter$0).f3 = function () {
    return this.v8o_1;
  };
  protoOf(sam$jetbrains_ocelot_base_clipboard_ClipboardAdapter$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, ClipboardAdapter) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_base_clipboard_ClipboardAdapter$0).hashCode = function () {
    return hashCode(this.f3());
  };
  function ClipboardAdapterBuilder$restoreByText$lambda(it) {
    return new RestoringExternalClipboard(it);
  }
  function ClipboardAdapterBuilder$build$lambda(this$0) {
    return function (systemClipboard) {
      var tmp0 = this$0.s8o_1;
      // Inline function 'kotlin.collections.toTypedArray' call
      var this_0 = this$0.r8o_1;
      var tmp$ret$0 = copyToArray(this_0);
      // Inline function 'kotlin.collections.fold' call
      var accumulator = externalClipboard(systemClipboard, tmp$ret$0.slice());
      var _iterator__ex2g4s = tmp0.m();
      while (_iterator__ex2g4s.n()) {
        var element = _iterator__ex2g4s.o();
        accumulator = element(accumulator);
      }
      return accumulator;
    };
  }
  function ClipboardAdapterBuilder() {
    var tmp = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.r8o_1 = ArrayList_init_$Create$();
    var tmp_0 = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp_0.s8o_1 = ArrayList_init_$Create$();
  }
  protoOf(ClipboardAdapterBuilder).w8o = function (serialization) {
    this.r8o_1.j(serialization);
  };
  protoOf(ClipboardAdapterBuilder).x8o = function () {
    this.s8o_1.j(ClipboardAdapterBuilder$restoreByText$lambda);
  };
  protoOf(ClipboardAdapterBuilder).t8o = function () {
    var tmp = ClipboardAdapterBuilder$build$lambda(this);
    return new sam$jetbrains_ocelot_base_clipboard_ClipboardAdapter$0(tmp);
  };
  function CompositeClipboardContentSerialization$deserialize$lambda($data) {
    return function (it) {
      return it.y8o($data);
    };
  }
  function CompositeClipboardContentSerialization(list) {
    this.z8o_1 = list;
  }
  protoOf(CompositeClipboardContentSerialization).a8p = function (content) {
    var tmp0 = this.z8o_1;
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.any' call
      var inductionVariable = 0;
      var last = tmp0.length;
      while (inductionVariable < last) {
        var element = tmp0[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        if (element.a8p(content)) {
          tmp$ret$1 = true;
          break $l$block;
        }
      }
      tmp$ret$1 = false;
    }
    return tmp$ret$1;
  };
  protoOf(CompositeClipboardContentSerialization).b8p = function (content) {
    var tmp0 = this.z8o_1;
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.first' call
      var inductionVariable = 0;
      var last = tmp0.length;
      while (inductionVariable < last) {
        var element = tmp0[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        if (element.a8p(content)) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      throw NoSuchElementException_init_$Create$_0('Array contains no element matching the predicate.');
    }
    return tmp$ret$1.b8p(content);
  };
  protoOf(CompositeClipboardContentSerialization).y8o = function (data) {
    var tmp = asSequence(this.z8o_1);
    return firstOrNull_2(filterNotNull_0(map(tmp, CompositeClipboardContentSerialization$deserialize$lambda(data))));
  };
  function defaultSystemClipboardInteraction(systemClipboard) {
    return new RestoringExternalClipboard(new OnlyTextExternalClipboard(systemClipboard));
  }
  function $retrieveCOROUTINE$(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.k8p_1 = _this__u8e3s4;
  }
  protoOf($retrieveCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.k8p_1.l8p_1.m8p(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp0_elvis_lhs = suspendResult;
            var tmp_0;
            if (tmp0_elvis_lhs == null) {
              return null;
            } else {
              tmp_0 = tmp0_elvis_lhs;
            }

            var mimeDataSet = tmp_0;
            if (!mimeDataSet.o2('text/plain'))
              return null;
            return TextContentHelper_getInstance().r8m(getValue_0(mimeDataSet, 'text/plain'));
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function OnlyTextExternalClipboard(clipboard) {
    this.l8p_1 = clipboard;
  }
  protoOf(OnlyTextExternalClipboard).n8p = function (content) {
    var textual = getText(content);
    var textData = new MimeTypedData('text/plain', textual);
    this.l8p_1.o8p(mimeDataSet(listOf(textData)));
  };
  protoOf(OnlyTextExternalClipboard).p8p = function ($completion) {
    var tmp = new $retrieveCOROUTINE$(this, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  function $retrieveCOROUTINE$_0(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.y8p_1 = _this__u8e3s4;
  }
  protoOf($retrieveCOROUTINE$_0).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.y8p_1.z8p_1.p8p(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var content = suspendResult;
            var tmp_0;
            var tmp_1 = content == null ? null : getText(content);
            var tmp1_safe_receiver = this.y8p_1.a8q_1;
            if (tmp_1 == (tmp1_safe_receiver == null ? null : getText(tmp1_safe_receiver))) {
              tmp_0 = this.y8p_1.a8q_1;
            } else {
              tmp_0 = content;
            }

            return tmp_0;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function RestoringExternalClipboard(delegate) {
    this.z8p_1 = delegate;
    this.a8q_1 = null;
  }
  protoOf(RestoringExternalClipboard).n8p = function (content) {
    this.z8p_1.n8p(content);
    this.a8q_1 = content;
  };
  protoOf(RestoringExternalClipboard).p8p = function ($completion) {
    var tmp = new $retrieveCOROUTINE$_0(this, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  function externalClipboard(systemClipboard, serializers) {
    return new SerializingExternalClipboard(systemClipboard, new CompositeClipboardContentSerialization(serializers.slice()));
  }
  function $retrieveCOROUTINE$_1(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.j8q_1 = _this__u8e3s4;
  }
  protoOf($retrieveCOROUTINE$_1).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.j8q_1.k8q_1.m8p(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp0_elvis_lhs = suspendResult;
            var tmp_0;
            if (tmp0_elvis_lhs == null) {
              return null;
            } else {
              tmp_0 = tmp0_elvis_lhs;
            }

            var mimeDataSet = tmp_0;
            return this.j8q_1.l8q_1.y8o(mimeDataSet);
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function SerializingExternalClipboard(clipboard, serialization) {
    this.k8q_1 = clipboard;
    this.l8q_1 = serialization;
  }
  protoOf(SerializingExternalClipboard).n8p = function (content) {
    if (!this.l8q_1.a8p(content))
      return Unit_instance;
    var contents = this.l8q_1.b8p(content);
    this.k8q_1.o8p(contents);
  };
  protoOf(SerializingExternalClipboard).p8p = function ($completion) {
    var tmp = new $retrieveCOROUTINE$_1(this, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  function TextClipboardSerialization() {
  }
  protoOf(TextClipboardSerialization).a8p = function (content) {
    var tmp;
    if (content instanceof SingleLineTextClipboardContent) {
      tmp = true;
    } else {
      tmp = content instanceof MultilineTextClipboardContent;
    }
    return tmp;
  };
  protoOf(TextClipboardSerialization).b8p = function (content) {
    return mimeDataSet(listOf(new MimeTypedData('text/plain', getText(content))));
  };
  protoOf(TextClipboardSerialization).y8o = function (data) {
    var tmp0_elvis_lhs = data.q2('text/plain');
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var plainText = tmp;
    return TextContentHelper_getInstance().r8m(plainText);
  };
  var TextClipboardSerialization_instance;
  function TextClipboardSerialization_getInstance() {
    return TextClipboardSerialization_instance;
  }
  function MimeTypedData(type, data) {
    this.m8q_1 = type;
    this.n8q_1 = data;
  }
  protoOf(MimeTypedData).toString = function () {
    return 'MimeTypedData(type=' + this.m8q_1 + ', data=' + this.n8q_1 + ')';
  };
  protoOf(MimeTypedData).hashCode = function () {
    var result = getStringHashCode(this.m8q_1);
    result = imul(result, 31) + getStringHashCode(this.n8q_1) | 0;
    return result;
  };
  protoOf(MimeTypedData).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof MimeTypedData))
      return false;
    if (!(this.m8q_1 === other.m8q_1))
      return false;
    if (!(this.n8q_1 === other.n8q_1))
      return false;
    return true;
  };
  function mimeDataSet(list) {
    // Inline function 'kotlin.collections.associate' call
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(list, 10)), 16);
    // Inline function 'kotlin.collections.associateTo' call
    var destination = LinkedHashMap_init_$Create$_0(capacity);
    var _iterator__ex2g4s = list.m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      // Inline function 'kotlin.collections.plusAssign' call
      var pair = to(element.m8q_1, element.n8q_1);
      destination.t2(pair.pg_1, pair.qg_1);
    }
    return destination;
  }
  function TrivialSystemClipboard() {
    this.o8q_1 = null;
  }
  protoOf(TrivialSystemClipboard).m8p = function ($completion) {
    return this.o8q_1;
  };
  protoOf(TrivialSystemClipboard).o8p = function (contents) {
    this.o8q_1 = contents;
  };
  function clipboard() {
    var tmp = window.navigator.clipboard;
    return tmp instanceof Clipboard ? tmp : THROW_CCE();
  }
  function readTextFromBlob(blob) {
    return new Promise(readTextFromBlob$lambda(blob));
  }
  function clipboardItem(data) {
    var dataObject = {};
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = data.m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      var mime = element.fg();
      var blob = element.gg();
      dataObject[mime] = blob;
    }
    return new ClipboardItem(dataObject, inlinePresentationStyleOption());
  }
  function inlinePresentationStyleOption() {
    var o = {};
    o['presentationStyle'] = 'inline';
    return o;
  }
  function readTextFromBlob$lambda$lambda($resolve, $reader) {
    return function (it) {
      var tmp = $reader.result;
      $resolve((!(tmp == null) ? typeof tmp === 'string' : false) ? tmp : THROW_CCE());
      return Unit_instance;
    };
  }
  function readTextFromBlob$lambda($blob) {
    return function (resolve, _unused_var__etf5q3) {
      var reader = new FileReader();
      reader.onload = readTextFromBlob$lambda$lambda(resolve, reader);
      reader.readAsText($blob);
      return Unit_instance;
    };
  }
  function $retrieveCOROUTINE$_2(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.x8q_1 = _this__u8e3s4;
  }
  protoOf($retrieveCOROUTINE$_2).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 8;
            this.f9_1 = 1;
            suspendResult = await_0(clipboard().read(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var items = suspendResult;
            if (items.length === 0)
              return null;
            this.y8q_1 = HashMap_init_$Create$();
            this.e8r_1 = arrayIterator(items);
            this.f9_1 = 2;
            continue $sm;
          case 2:
            if (!this.e8r_1.n()) {
              this.f9_1 = 7;
              continue $sm;
            }

            this.c8r_1 = this.e8r_1.o();
            this.d8r_1 = arrayIterator(this.c8r_1.types);
            this.f9_1 = 3;
            continue $sm;
          case 3:
            if (!this.d8r_1.n()) {
              this.f9_1 = 6;
              continue $sm;
            }

            this.b8r_1 = this.d8r_1.o();
            this.f9_1 = 4;
            suspendResult = await_0(this.c8r_1.getType(this.b8r_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            var blob = suspendResult;
            var tmp_0 = this;
            tmp_0.a8r_1 = this.y8q_1;
            var tmp_1 = this;
            tmp_1.z8q_1 = this.b8r_1;
            this.f9_1 = 5;
            suspendResult = await_0(readTextFromBlob(blob), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 5:
            var tmp4 = suspendResult;
            var this_0 = this.a8r_1;
            var key = this.z8q_1;
            this_0.t2(key, tmp4);
            this.f9_1 = 3;
            continue $sm;
          case 6:
            this.f9_1 = 2;
            continue $sm;
          case 7:
            return this.y8q_1;
          case 8:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 8) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function JsSystemClipboard() {
  }
  protoOf(JsSystemClipboard).m8p = function ($completion) {
    var tmp = new $retrieveCOROUTINE$_2(this, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(JsSystemClipboard).o8p = function (contents) {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(contents.p());
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s = contents.y().m();
    while (_iterator__ex2g4s.n()) {
      var item = _iterator__ex2g4s.o();
      // Inline function 'kotlin.collections.component1' call
      var mimeType = item.z();
      // Inline function 'kotlin.collections.component2' call
      var data = item.a1();
      // Inline function 'org.w3c.files.BlobPropertyBag' call
      var o = {};
      o['type'] = mimeType;
      var properties = o;
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$6 = [data];
      var blob = new Blob(tmp$ret$6, properties);
      var tmp$ret$7 = to(mimeType, blob);
      destination.j(tmp$ret$7);
    }
    var items = destination;
    var tmp = clipboard();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$12 = [clipboardItem(items)];
    tmp.write(tmp$ret$12);
  };
  var JsSystemClipboard_instance;
  function JsSystemClipboard_getInstance() {
    return JsSystemClipboard_instance;
  }
  function SubList_1(source, fromIndex, toIndex) {
    AbstractList.call(this);
    this.f8r_1 = source;
    this.g8r_1 = fromIndex;
    this.h8r_1 = toIndex;
    this.i8r_1 = 0;
    ListImplementation_instance.j8r(this.g8r_1, this.h8r_1, this.f8r_1.p());
    this.i8r_1 = this.h8r_1 - this.g8r_1 | 0;
  }
  protoOf(SubList_1).r = function (index) {
    ListImplementation_instance.k8r(index, this.i8r_1);
    return this.f8r_1.r(this.g8r_1 + index | 0);
  };
  protoOf(SubList_1).p = function () {
    return this.i8r_1;
  };
  protoOf(SubList_1).g2 = function (fromIndex, toIndex) {
    ListImplementation_instance.j8r(fromIndex, toIndex, this.i8r_1);
    return new SubList_1(this.f8r_1, this.g8r_1 + fromIndex | 0, this.g8r_1 + toIndex | 0);
  };
  function ImmutableList() {
  }
  function persistentListOf() {
    return persistentVectorOf();
  }
  function AbstractListIterator(index, size) {
    this.l8r_1 = index;
    this.m8r_1 = size;
  }
  protoOf(AbstractListIterator).n = function () {
    return this.l8r_1 < this.m8r_1;
  };
  protoOf(AbstractListIterator).r4 = function () {
    return this.l8r_1 > 0;
  };
  protoOf(AbstractListIterator).s4 = function () {
    return this.l8r_1;
  };
  protoOf(AbstractListIterator).u4 = function () {
    return this.l8r_1 - 1 | 0;
  };
  protoOf(AbstractListIterator).n8r = function () {
    if (!this.n())
      throw NoSuchElementException_init_$Create$();
  };
  protoOf(AbstractListIterator).o8r = function () {
    if (!this.r4())
      throw NoSuchElementException_init_$Create$();
  };
  function AbstractPersistentList() {
    AbstractList.call(this);
  }
  protoOf(AbstractPersistentList).g2 = function (fromIndex, toIndex) {
    return subList.call(this, fromIndex, toIndex);
  };
  protoOf(AbstractPersistentList).t = function (element) {
    return !(this.w(element) === -1);
  };
  protoOf(AbstractPersistentList).e2 = function (elements) {
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var tmp;
      if (isInterface(elements, Collection)) {
        tmp = elements.s();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
      var _iterator__ex2g4s = elements.m();
      while (_iterator__ex2g4s.n()) {
        var element = _iterator__ex2g4s.o();
        if (!this.t(element)) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
      }
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  };
  protoOf(AbstractPersistentList).m = function () {
    return this.f2();
  };
  protoOf(AbstractPersistentList).f2 = function () {
    return this.u(0);
  };
  function BufferIterator(buffer, index, size) {
    AbstractListIterator.call(this, index, size);
    this.r8r_1 = buffer;
  }
  protoOf(BufferIterator).o = function () {
    if (!this.n()) {
      throw NoSuchElementException_init_$Create$();
    }
    var tmp1 = this.l8r_1;
    this.l8r_1 = tmp1 + 1 | 0;
    return this.r8r_1[tmp1];
  };
  protoOf(BufferIterator).t4 = function () {
    if (!this.r4()) {
      throw NoSuchElementException_init_$Create$();
    }
    this.l8r_1 = this.l8r_1 - 1 | 0;
    return this.r8r_1[this.l8r_1];
  };
  function rootSize($this) {
    return rootSize_0($this.u8r_1);
  }
  function pushFilledTail($this, root, filledTail, newTail) {
    if ($this.u8r_1 >> 5 > 1 << $this.v8r_1) {
      var newRoot = presizedBufferWith(root);
      var newRootShift = $this.v8r_1 + 5 | 0;
      newRoot = pushTail($this, newRoot, newRootShift, filledTail);
      return new PersistentVector(newRoot, newTail, $this.u8r_1 + 1 | 0, newRootShift);
    }
    var newRoot_0 = pushTail($this, root, $this.v8r_1, filledTail);
    return new PersistentVector(newRoot_0, newTail, $this.u8r_1 + 1 | 0, $this.v8r_1);
  }
  function pushTail($this, root, shift, tail) {
    var bufferIndex = indexSegment($this.u8r_1 - 1 | 0, shift);
    var tmp1_elvis_lhs = root == null ? null : copyOf_1(root, 32);
    var tmp;
    if (tmp1_elvis_lhs == null) {
      // Inline function 'kotlin.arrayOfNulls' call
      tmp = Array(32);
    } else {
      tmp = tmp1_elvis_lhs;
    }
    var newRootNode = tmp;
    if (shift === 5) {
      newRootNode[bufferIndex] = tail;
    } else {
      var tmp_0 = newRootNode[bufferIndex];
      newRootNode[bufferIndex] = pushTail($this, (tmp_0 == null ? true : isArray(tmp_0)) ? tmp_0 : THROW_CCE(), shift - 5 | 0, tail);
    }
    return newRootNode;
  }
  function bufferFor($this, index) {
    if (rootSize($this) <= index) {
      return $this.t8r_1;
    }
    var buffer = $this.s8r_1;
    var shift = $this.v8r_1;
    while (shift > 0) {
      var tmp = buffer[indexSegment(index, shift)];
      buffer = (!(tmp == null) ? isArray(tmp) : false) ? tmp : THROW_CCE();
      shift = shift - 5 | 0;
    }
    return buffer;
  }
  function PersistentVector(root, tail, size, rootShift) {
    AbstractPersistentList.call(this);
    this.s8r_1 = root;
    this.t8r_1 = tail;
    this.u8r_1 = size;
    this.v8r_1 = rootShift;
    // Inline function 'kotlin.require' call
    if (!(this.u8r_1 > 32)) {
      var message = 'Trie-based persistent vector should have at least 33 elements, got ' + this.u8r_1;
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    assert((this.u8r_1 - rootSize_0(this.u8r_1) | 0) <= coerceAtMost(this.t8r_1.length, 32));
  }
  protoOf(PersistentVector).p = function () {
    return this.u8r_1;
  };
  protoOf(PersistentVector).j = function (element) {
    var tailSize = this.u8r_1 - rootSize(this) | 0;
    if (tailSize < 32) {
      var newTail = copyOf_1(this.t8r_1, 32);
      newTail[tailSize] = element;
      return new PersistentVector(this.s8r_1, newTail, this.u8r_1 + 1 | 0, this.v8r_1);
    }
    var newTail_0 = presizedBufferWith(element);
    return pushFilledTail(this, this.s8r_1, this.t8r_1, newTail_0);
  };
  protoOf(PersistentVector).u = function (index) {
    ListImplementation_instance.w8r(index, this.u8r_1);
    var tmp = this.t8r_1;
    return new PersistentVectorIterator(this.s8r_1, isArray(tmp) ? tmp : THROW_CCE(), index, this.u8r_1, (this.v8r_1 / 5 | 0) + 1 | 0);
  };
  protoOf(PersistentVector).r = function (index) {
    ListImplementation_instance.k8r(index, this.u8r_1);
    var buffer = bufferFor(this, index);
    var tmp = buffer[index & 31];
    return (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
  };
  function PersistentVectorIterator(root, tail, index, size, trieHeight) {
    AbstractListIterator.call(this, index, size);
    this.z8r_1 = tail;
    var trieSize = rootSize_0(size);
    var trieIndex = coerceAtMost(index, trieSize);
    this.a8s_1 = new TrieIterator(root, trieIndex, trieSize, trieHeight);
  }
  protoOf(PersistentVectorIterator).o = function () {
    this.n8r();
    if (this.a8s_1.n()) {
      this.l8r_1 = this.l8r_1 + 1 | 0;
      return this.a8s_1.o();
    }
    var tmp3 = this.l8r_1;
    this.l8r_1 = tmp3 + 1 | 0;
    return this.z8r_1[tmp3 - this.a8s_1.m8r_1 | 0];
  };
  protoOf(PersistentVectorIterator).t4 = function () {
    this.o8r();
    if (this.l8r_1 > this.a8s_1.m8r_1) {
      this.l8r_1 = this.l8r_1 - 1 | 0;
      return this.z8r_1[this.l8r_1 - this.a8s_1.m8r_1 | 0];
    }
    this.l8r_1 = this.l8r_1 - 1 | 0;
    return this.a8s_1.t4();
  };
  function Companion_145() {
    Companion_instance_145 = this;
    var tmp = this;
    // Inline function 'kotlin.emptyArray' call
    var tmp$ret$0 = [];
    tmp.g8s_1 = new SmallPersistentVector(tmp$ret$0);
  }
  var Companion_instance_145;
  function Companion_getInstance_145() {
    if (Companion_instance_145 == null)
      new Companion_145();
    return Companion_instance_145;
  }
  function SmallPersistentVector(buffer) {
    Companion_getInstance_145();
    AbstractPersistentList.call(this);
    this.h8s_1 = buffer;
    assert(this.h8s_1.length <= 32);
  }
  protoOf(SmallPersistentVector).p = function () {
    return this.h8s_1.length;
  };
  protoOf(SmallPersistentVector).j = function (element) {
    if (this.p() < 32) {
      var newBuffer = copyOf_1(this.h8s_1, this.p() + 1 | 0);
      newBuffer[this.p()] = element;
      return new SmallPersistentVector(newBuffer);
    }
    var tail = presizedBufferWith(element);
    return new PersistentVector(this.h8s_1, tail, this.p() + 1 | 0, 0);
  };
  protoOf(SmallPersistentVector).w = function (element) {
    return indexOf(this.h8s_1, element);
  };
  protoOf(SmallPersistentVector).v = function (element) {
    return lastIndexOf(this.h8s_1, element);
  };
  protoOf(SmallPersistentVector).u = function (index) {
    ListImplementation_instance.w8r(index, this.p());
    var tmp = this.h8s_1;
    return new BufferIterator(isArray(tmp) ? tmp : THROW_CCE(), index, this.p());
  };
  protoOf(SmallPersistentVector).r = function (index) {
    ListImplementation_instance.k8r(index, this.p());
    var tmp = this.h8s_1[index];
    return (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
  };
  function fillPath($this, index, startLevel) {
    var shift = imul($this.d8s_1 - startLevel | 0, 5);
    var i = startLevel;
    while (i < $this.d8s_1) {
      var tmp = $this.e8s_1;
      var tmp_0 = i;
      var tmp_1 = $this.e8s_1[i - 1 | 0];
      tmp[tmp_0] = ((!(tmp_1 == null) ? isArray(tmp_1) : false) ? tmp_1 : THROW_CCE())[indexSegment(index, shift)];
      shift = shift - 5 | 0;
      i = i + 1 | 0;
    }
  }
  function fillPathIfNeeded($this, indexPredicate) {
    var shift = 0;
    while (indexSegment($this.l8r_1, shift) === indexPredicate) {
      shift = shift + 5 | 0;
    }
    if (shift > 0) {
      var level = ($this.d8s_1 - 1 | 0) - (shift / 5 | 0) | 0;
      fillPath($this, $this.l8r_1, level + 1 | 0);
    }
  }
  function elementAtCurrentIndex($this) {
    var leafBufferIndex = $this.l8r_1 & 31;
    var tmp = $this.e8s_1[$this.d8s_1 - 1 | 0];
    return ((!(tmp == null) ? isArray(tmp) : false) ? tmp : THROW_CCE())[leafBufferIndex];
  }
  function TrieIterator(root, index, size, height) {
    AbstractListIterator.call(this, index, size);
    this.d8s_1 = height;
    var tmp = this;
    // Inline function 'kotlin.arrayOfNulls' call
    var size_0 = this.d8s_1;
    tmp.e8s_1 = Array(size_0);
    this.f8s_1 = index === size;
    this.e8s_1[0] = root;
    fillPath(this, index - (this.f8s_1 ? 1 : 0) | 0, 1);
  }
  protoOf(TrieIterator).o = function () {
    if (!this.n()) {
      throw NoSuchElementException_init_$Create$();
    }
    var result = elementAtCurrentIndex(this);
    this.l8r_1 = this.l8r_1 + 1 | 0;
    if (this.l8r_1 === this.m8r_1) {
      this.f8s_1 = true;
      return result;
    }
    fillPathIfNeeded(this, 0);
    return result;
  };
  protoOf(TrieIterator).t4 = function () {
    if (!this.r4()) {
      throw NoSuchElementException_init_$Create$();
    }
    this.l8r_1 = this.l8r_1 - 1 | 0;
    if (this.f8s_1) {
      this.f8s_1 = false;
      return elementAtCurrentIndex(this);
    }
    fillPathIfNeeded(this, 31);
    return elementAtCurrentIndex(this);
  };
  function persistentVectorOf() {
    return Companion_getInstance_145().g8s_1;
  }
  function presizedBufferWith(element) {
    // Inline function 'kotlin.arrayOfNulls' call
    var buffer = Array(32);
    buffer[0] = element;
    return buffer;
  }
  function rootSize_0(vectorSize) {
    return (vectorSize - 1 | 0) & -32;
  }
  function indexSegment(index, shift) {
    return index >> shift & 31;
  }
  function ListImplementation() {
  }
  protoOf(ListImplementation).k8r = function (index, size) {
    if (index < 0 || index >= size) {
      throw IndexOutOfBoundsException_init_$Create$_0('index: ' + index + ', size: ' + size);
    }
  };
  protoOf(ListImplementation).w8r = function (index, size) {
    if (index < 0 || index > size) {
      throw IndexOutOfBoundsException_init_$Create$_0('index: ' + index + ', size: ' + size);
    }
  };
  protoOf(ListImplementation).j8r = function (fromIndex, toIndex, size) {
    if (fromIndex < 0 || toIndex > size) {
      throw IndexOutOfBoundsException_init_$Create$_0('fromIndex: ' + fromIndex + ', toIndex: ' + toIndex + ', size: ' + size);
    }
    if (fromIndex > toIndex) {
      throw IllegalArgumentException_init_$Create$_0('fromIndex: ' + fromIndex + ' > toIndex: ' + toIndex);
    }
  };
  var ListImplementation_instance;
  function ListImplementation_getInstance() {
    return ListImplementation_instance;
  }
  function assert(condition) {
    if (!condition) {
      throw AssertionError_init_$Create$_0('Assertion failed');
    }
  }
  function BoundsComposites(hasBounds) {
    this.i8s_1 = hasBounds;
  }
  protoOf(BoundsComposites).j8s = function (upper, lower, threshold) {
    var upperBounds = this.i8s_1(upper);
    var lowerBounds = this.i8s_1(lower);
    return ((upperBounds.b8c_1.e8c_1 + upperBounds.c8c_1.e8c_1 | 0) - threshold | 0) <= lowerBounds.b8c_1.e8c_1;
  };
  protoOf(BoundsComposites).k8s = function (upper, lower, threshold, $super) {
    threshold = threshold === VOID ? 0 : threshold;
    return $super === VOID ? this.j8s(upper, lower, threshold) : $super.j8s.call(this, upper, lower, threshold);
  };
  protoOf(BoundsComposites).l8s = function (lower, upper, threshold) {
    return this.j8s(upper, lower, threshold);
  };
  function NavCompositeBounds(boundsComposites, navCompositeFocusables) {
    this.m8s_1 = boundsComposites;
    this.n8s_1 = navCompositeFocusables;
  }
  protoOf(NavCompositeBounds).o8s = function (cell, threshold) {
    var current = cell;
    while (true) {
      var prev = this.n8s_1.r8s(current);
      if (prev == null || this.m8s_1.j8s(prev, cell, threshold)) {
        return current;
      }
      current = prev;
    }
  };
  protoOf(NavCompositeBounds).s8s = function (cell, threshold) {
    var current = cell;
    while (true) {
      var next = this.n8s_1.t8s(current);
      if (next == null || this.m8s_1.l8s(next, cell, threshold)) {
        return current;
      }
      current = next;
    }
  };
  function isFocusable($this, cv) {
    return $this.u8s_1(cv).uv();
  }
  function isVisible($this, cv) {
    return $this.v8s_1(cv).uv();
  }
  function CompositeFocusables(hasFocusability, hasVisibility) {
    this.u8s_1 = hasFocusability;
    this.v8s_1 = hasVisibility;
  }
  protoOf(CompositeFocusables).w8s = function (composite) {
    return this.x8s(composite, true);
  };
  protoOf(CompositeFocusables).x8s = function (composite, deepest) {
    var _iterator__ex2g4s = composite.o35().m();
    $l$loop: while (_iterator__ex2g4s.n()) {
      var cv = _iterator__ex2g4s.o();
      if (!isVisible(this, cv))
        continue $l$loop;
      if (!deepest && isFocusable(this, cv))
        return cv;
      var result = this.w8s(cv);
      if (!(result == null))
        return result;
    }
    return isFocusable(this, composite) ? composite : null;
  };
  protoOf(CompositeFocusables).y8s = function (composite) {
    return this.z8s(composite, true);
  };
  protoOf(CompositeFocusables).z8s = function (composite, deepest) {
    var children = composite.o35();
    var _iterator__ex2g4s = asReversed_0(children).m();
    $l$loop: while (_iterator__ex2g4s.n()) {
      var cv = _iterator__ex2g4s.o();
      if (!isVisible(this, cv))
        continue $l$loop;
      if (!deepest && isFocusable(this, cv))
        return cv;
      var result = this.z8s(cv, deepest);
      if (!(result == null))
        return result;
    }
    return isFocusable(this, composite) ? composite : null;
  };
  function isVisible_0(_this__u8e3s4, hasVisibility) {
    var tmp0 = ancestorsFrom(_this__u8e3s4);
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.sequences.all' call
      var _iterator__ex2g4s = tmp0.m();
      while (_iterator__ex2g4s.n()) {
        var element = _iterator__ex2g4s.o();
        if (!hasVisibility(element).uv()) {
          tmp$ret$1 = false;
          break $l$block;
        }
      }
      tmp$ret$1 = true;
    }
    return tmp$ret$1;
  }
  function isFocusable_0(_this__u8e3s4, hasFocusability, hasVisibility) {
    return hasFocusability(_this__u8e3s4).uv() && isVisible_0(_this__u8e3s4, hasVisibility);
  }
  function prevFocusables($this, composite) {
    var tmp = Composites_instance.g36(composite);
    return filter(tmp, NavCompositeFocusables$prevFocusables$lambda($this));
  }
  function isFocusable_1($this, cv) {
    return isFocusable_0(cv, $this.p8s_1, $this.q8s_1);
  }
  function NavCompositeFocusables$nextFocusables$lambda(this$0) {
    return function (cv) {
      return isFocusable_1(this$0, cv);
    };
  }
  function NavCompositeFocusables$prevFocusables$lambda(this$0) {
    return function (cv) {
      return isFocusable_1(this$0, cv);
    };
  }
  function NavCompositeFocusables(hasFocusability, hasVisibility) {
    this.p8s_1 = hasFocusability;
    this.q8s_1 = hasVisibility;
  }
  protoOf(NavCompositeFocusables).a8t = function (composite, fromNext) {
    var tmp = Composites_instance.e36(composite, fromNext);
    return filter(tmp, NavCompositeFocusables$nextFocusables$lambda(this));
  };
  protoOf(NavCompositeFocusables).b8t = function (composite, fromNext, $super) {
    fromNext = fromNext === VOID ? true : fromNext;
    return $super === VOID ? this.a8t(composite, fromNext) : $super.a8t.call(this, composite, fromNext);
  };
  protoOf(NavCompositeFocusables).t8s = function (composite) {
    return firstOrNull_2(this.b8t(composite));
  };
  protoOf(NavCompositeFocusables).r8s = function (composite) {
    return firstOrNull_2(prevFocusables(this, composite));
  };
  function BackgroundHighlightTextDecoration(color, interval, priority) {
    priority = priority === VOID ? 0 : priority;
    TextDecoration.call(this, interval, priority);
    this.e8t_1 = color;
  }
  protoOf(BackgroundHighlightTextDecoration).toString = function () {
    return 'BackgroundHighlightTextDecoration(color=' + this.e8t_1.toString() + ', range=' + this.f8t_1.toString() + ', priority=' + this.g8t_1 + ')';
  };
  protoOf(BackgroundHighlightTextDecoration).equals = function (other) {
    if (this === other)
      return true;
    if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    if (!(other instanceof BackgroundHighlightTextDecoration))
      THROW_CCE();
    if (!this.e8t_1.equals(other.e8t_1))
      return false;
    if (!this.f8t_1.equals(other.f8t_1))
      return false;
    if (!(this.g8t_1 === other.g8t_1))
      return false;
    return true;
  };
  protoOf(BackgroundHighlightTextDecoration).hashCode = function () {
    var result = this.e8t_1.hashCode();
    result = imul(31, result) + this.f8t_1.hashCode() | 0;
    result = imul(31, result) + this.g8t_1 | 0;
    return result;
  };
  function RedUnderlineTextDecoration() {
  }
  function TextDecoration(interval, priority) {
    priority = priority === VOID ? 0 : priority;
    this.f8t_1 = interval;
    this.g8t_1 = priority;
  }
  function sam$kotlin_Comparator$0_2(function_0) {
    this.h8t_1 = function_0;
  }
  protoOf(sam$kotlin_Comparator$0_2).zd = function (a, b) {
    return this.h8t_1(a, b);
  };
  protoOf(sam$kotlin_Comparator$0_2).compare = function (a, b) {
    return this.zd(a, b);
  };
  protoOf(sam$kotlin_Comparator$0_2).f3 = function () {
    return this.h8t_1;
  };
  protoOf(sam$kotlin_Comparator$0_2).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Comparator) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlin_Comparator$0_2).hashCode = function () {
    return hashCode(this.f3());
  };
  function TextDecorations$PRIORITY$lambda(a, b) {
    // Inline function 'kotlin.comparisons.compareValuesBy' call
    var tmp = a.g8t_1;
    var tmp$ret$1 = b.g8t_1;
    return compareValues(tmp, tmp$ret$1);
  }
  function TextDecorations() {
    TextDecorations_instance = this;
    var tmp = this;
    // Inline function 'kotlin.comparisons.compareBy' call
    var tmp_0 = TextDecorations$PRIORITY$lambda;
    tmp.i8t_1 = new sam$kotlin_Comparator$0_2(tmp_0);
  }
  protoOf(TextDecorations).j8t = function (decorations) {
    var prioritized = ArrayList_init_$Create$_1(decorations);
    sortWith_0(prioritized, this.i8t_1);
    return prioritized;
  };
  protoOf(TextDecorations).k8t = function (decoration, length) {
    var decorationInterval = decoration.f8t_1;
    var lengthInterval = Companion_instance_37.y36(0, length);
    return decorationInterval.m37(lengthInterval);
  };
  var TextDecorations_instance;
  function TextDecorations_getInstance() {
    if (TextDecorations_instance == null)
      new TextDecorations();
    return TextDecorations_instance;
  }
  function TreePath$Companion$sorted$comparator$1($paths) {
    this.l8t_1 = $paths;
  }
  protoOf(TreePath$Companion$sorted$comparator$1).m8t = function (a, b) {
    var valueA = getValue_0(this.l8t_1, a);
    var valueB = getValue_0(this.l8t_1, b);
    return valueA.o8t(valueB);
  };
  protoOf(TreePath$Companion$sorted$comparator$1).compare = function (a, b) {
    var tmp = (!(a == null) ? isInterface(a, Composite) : false) ? a : THROW_CCE();
    return this.m8t(tmp, (!(b == null) ? isInterface(b, Composite) : false) ? b : THROW_CCE());
  };
  function TreePath_init_$Init$(composite, $this) {
    TreePath_init_$Init$_0(composite, null, $this);
    return $this;
  }
  function TreePath_init_$Create$(composite) {
    return TreePath_init_$Init$(composite, objectCreate(protoOf(TreePath)));
  }
  function TreePath_init_$Init$_0(from, to, $this) {
    TreePath.call($this);
    var current = from;
    while (!(current == null) && !(current === to)) {
      var parent = current.bp();
      if (!(parent == null)) {
        var index = parent.o35().w(current);
        // Inline function 'kotlin.check' call
        if (!!(index === -1)) {
          throw IllegalStateException_init_$Create$_0('Check failed.');
        }
        $this.n8t_1.j(index);
      }
      current = parent;
    }
    // Inline function 'kotlin.check' call
    if (!(current === to)) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    reverse($this.n8t_1);
    return $this;
  }
  function TreePath_init_$Create$_0(from, to) {
    return TreePath_init_$Init$_0(from, to, objectCreate(protoOf(TreePath)));
  }
  function TreePath_init_$Init$_1(path, $this) {
    TreePath.call($this);
    $this.n8t_1.q(path);
    return $this;
  }
  function TreePath_init_$Create$_1(path) {
    return TreePath_init_$Init$_1(path, objectCreate(protoOf(TreePath)));
  }
  function Companion_146() {
  }
  protoOf(Companion_146).p8t = function (composites) {
    // Inline function 'kotlin.collections.associateWith' call
    var result = LinkedHashMap_init_$Create$_0(coerceAtLeast(mapCapacity(collectionSizeOrDefault(composites, 10)), 16));
    // Inline function 'kotlin.collections.associateWithTo' call
    var _iterator__ex2g4s = composites.m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      var tmp$ret$0 = TreePath_init_$Create$(element);
      result.t2(element, tmp$ret$0);
    }
    var paths = result;
    var comparator = new TreePath$Companion$sorted$comparator$1(paths);
    return sortedWith(composites, comparator);
  };
  var Companion_instance_146;
  function Companion_getInstance_146() {
    return Companion_instance_146;
  }
  protoOf(TreePath).q8t = function (root) {
    // Inline function 'kotlin.check' call
    if (!this.r8t(root)) {
      var message = 'Invalid context';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    var current = root;
    var _iterator__ex2g4s = this.n8t_1.m();
    while (_iterator__ex2g4s.n()) {
      var i = _iterator__ex2g4s.o();
      current = current.o35().r(i);
    }
    return current;
  };
  protoOf(TreePath).r8t = function (root) {
    var current = root;
    var _iterator__ex2g4s = this.n8t_1.m();
    while (_iterator__ex2g4s.n()) {
      var i = _iterator__ex2g4s.o();
      var children = current.o35();
      if (i >= children.p()) {
        return false;
      }
      current = children.r(i);
    }
    return true;
  };
  protoOf(TreePath).equals = function (other) {
    if (!(other instanceof TreePath))
      return false;
    var treePath = other instanceof TreePath ? other : THROW_CCE();
    return equals(this.n8t_1, ensureNotNull(treePath).n8t_1);
  };
  protoOf(TreePath).hashCode = function () {
    return hashCode(this.n8t_1);
  };
  protoOf(TreePath).o8t = function (other) {
    var tmp0 = this.n8t_1.p();
    // Inline function 'kotlin.math.min' call
    var b = other.n8t_1.p();
    var maxIndex = Math.min(tmp0, b);
    var inductionVariable = 0;
    if (inductionVariable < maxIndex)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var delta = this.n8t_1.r(i) - other.n8t_1.r(i) | 0;
        if (!(delta === 0))
          return delta;
      }
       while (inductionVariable < maxIndex);
    return this.n8t_1.p() - other.n8t_1.p() | 0;
  };
  protoOf(TreePath).d = function (other) {
    return this.o8t(other instanceof TreePath ? other : THROW_CCE());
  };
  protoOf(TreePath).s8t = function (other) {
    var result = TreePath_init_$Create$_1(this.n8t_1);
    result.n8t_1.q(other.n8t_1);
    return result;
  };
  protoOf(TreePath).toString = function () {
    return toString_1(this.n8t_1);
  };
  function TreePath() {
    this.n8t_1 = ArrayList_init_$Create$();
  }
  function get_IdentifierValidator() {
    _init_properties_Validators_kt__iukeyp();
    return IdentifierValidator;
  }
  var IdentifierValidator;
  function Validators$UNSIGNED_INTEGER$lambda(string) {
    var tmp;
    var tmp_0;
    // Inline function 'kotlin.text.isNotEmpty' call
    if (charSequenceLength(string) > 0) {
      var tmp$ret$2;
      $l$block: {
        // Inline function 'kotlin.text.all' call
        var inductionVariable = 0;
        while (inductionVariable < charSequenceLength(string)) {
          var element = charSequenceGet(string, inductionVariable);
          inductionVariable = inductionVariable + 1 | 0;
          if (!isDigit(element)) {
            tmp$ret$2 = false;
            break $l$block;
          }
        }
        tmp$ret$2 = true;
      }
      tmp_0 = tmp$ret$2;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = isInt(string);
    } else {
      tmp = false;
    }
    return tmp;
  }
  function isInt$ref() {
    var l = function (p0) {
      return isInt(p0);
    };
    l.callableName = 'isInt';
    return l;
  }
  function Validators$BOOL$lambda(input) {
    return 'true' === input || 'false' === input;
  }
  function Validators() {
    Validators_instance = this;
    var tmp = this;
    tmp.t8t_1 = Validators$UNSIGNED_INTEGER$lambda;
    var tmp_0 = this;
    tmp_0.u8t_1 = isInt$ref();
    var tmp_1 = this;
    tmp_1.v8t_1 = Validators$BOOL$lambda;
  }
  protoOf(Validators).w8t = function () {
    return this.t8t_1;
  };
  protoOf(Validators).x8t = function () {
    return this.u8t_1;
  };
  protoOf(Validators).y8t = function () {
    return this.v8t_1;
  };
  var Validators_instance;
  function Validators_getInstance() {
    if (Validators_instance == null)
      new Validators();
    return Validators_instance;
  }
  function IdentifierValidator$lambda(input) {
    _init_properties_Validators_kt__iukeyp();
    var tmp;
    var tmp_0;
    if (input == null) {
      tmp_0 = true;
    } else {
      // Inline function 'kotlin.text.isEmpty' call
      tmp_0 = charSequenceLength(input) === 0;
    }
    if (tmp_0) {
      tmp = false;
    } else {
      var isValid = true;
      var inductionVariable = 0;
      var last = input.length;
      $l$loop: while (inductionVariable < last) {
        var index = inductionVariable;
        var ch = charCodeAt(input, inductionVariable);
        inductionVariable = inductionVariable + 1 | 0;
        if (index === 0 && isDigit(ch) || (!isLetterOrDigit(ch) && !(ch === _Char___init__impl__6a9atx(95)))) {
          isValid = false;
          break $l$loop;
        }
      }
      tmp = isValid;
    }
    return tmp;
  }
  var properties_initialized_Validators_kt_wmfhtv;
  function _init_properties_Validators_kt__iukeyp() {
    if (!properties_initialized_Validators_kt_wmfhtv) {
      properties_initialized_Validators_kt_wmfhtv = true;
      IdentifierValidator = IdentifierValidator$lambda;
    }
  }
  var Alignment_STRETCH_instance;
  var Alignment_START_instance;
  var Alignment_END_instance;
  var Alignment_entriesInitialized;
  function Alignment_initEntries() {
    if (Alignment_entriesInitialized)
      return Unit_instance;
    Alignment_entriesInitialized = true;
    Alignment_STRETCH_instance = new Alignment('STRETCH', 0);
    Alignment_START_instance = new Alignment('START', 1);
    Alignment_END_instance = new Alignment('END', 2);
  }
  function Alignment(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function Alignment_STRETCH_getInstance() {
    Alignment_initEntries();
    return Alignment_STRETCH_instance;
  }
  function Alignment_START_getInstance() {
    Alignment_initEntries();
    return Alignment_START_instance;
  }
  function Alignment_END_getInstance() {
    Alignment_initEntries();
    return Alignment_END_instance;
  }
  var Kind_BORDER_instance;
  var Kind_OUTLINE_instance;
  var Kind_entriesInitialized_1;
  function Kind_initEntries_1() {
    if (Kind_entriesInitialized_1)
      return Unit_instance;
    Kind_entriesInitialized_1 = true;
    Kind_BORDER_instance = new Kind_1('BORDER', 0);
    Kind_OUTLINE_instance = new Kind_1('OUTLINE', 1);
  }
  function Kind_1(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function Companion_147() {
  }
  var Companion_instance_147;
  function Companion_getInstance_147() {
    return Companion_instance_147;
  }
  function Kind_BORDER_getInstance() {
    Kind_initEntries_1();
    return Kind_BORDER_instance;
  }
  function Border(color, width, kind) {
    kind = kind === VOID ? Kind_BORDER_getInstance() : kind;
    this.z8t_1 = kind;
    var side = new Side(color, width);
    this.a8u_1 = side;
    this.b8u_1 = side;
    this.c8u_1 = side;
    this.d8u_1 = side;
  }
  function Side(color, width) {
    this.e8u_1 = color;
    this.f8u_1 = width;
    // Inline function 'kotlin.require' call
    if (!(this.f8u_1 >= 0)) {
      var message = 'negative line width';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
  }
  protoOf(Side).toString = function () {
    return 'Side(color=' + this.e8u_1.toString() + ', width=' + this.f8u_1 + ')';
  };
  protoOf(Side).hashCode = function () {
    var result = this.e8u_1.hashCode();
    result = imul(result, 31) + this.f8u_1 | 0;
    return result;
  };
  protoOf(Side).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Side))
      return false;
    if (!this.e8u_1.equals(other.e8u_1))
      return false;
    if (!(this.f8u_1 === other.f8u_1))
      return false;
    return true;
  };
  function Block() {
  }
  function HorizontalBlock(children) {
    CompoundBlock.call(this);
    this.i8u_1 = children;
  }
  protoOf(HorizontalBlock).g8u = function () {
    // Inline function 'kotlin.collections.sumOf' call
    var sum = 0;
    var _iterator__ex2g4s = this.i8u_1.m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      var tmp = sum;
      sum = tmp + element.g8u() | 0;
    }
    return sum;
  };
  protoOf(HorizontalBlock).h8u = function () {
    var tmp0 = this.i8u_1;
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlin.collections.maxOfOrNull' call
      var iterator = tmp0.m();
      if (!iterator.n()) {
        tmp$ret$0 = null;
        break $l$block;
      }
      var maxValue = iterator.o().h8u();
      while (iterator.n()) {
        var v = iterator.o().h8u();
        if (compareTo_0(maxValue, v) < 0) {
          maxValue = v;
        }
      }
      tmp$ret$0 = maxValue;
    }
    var tmp0_elvis_lhs = tmp$ret$0;
    return tmp0_elvis_lhs == null ? 1 : tmp0_elvis_lhs;
  };
  protoOf(HorizontalBlock).toString = function () {
    return 'HorizontalBlock(children=' + toString_1(this.i8u_1) + ')';
  };
  protoOf(HorizontalBlock).hashCode = function () {
    return hashCode(this.i8u_1);
  };
  protoOf(HorizontalBlock).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof HorizontalBlock))
      return false;
    if (!equals(this.i8u_1, other.i8u_1))
      return false;
    return true;
  };
  function TextBlock(text) {
    Block.call(this);
    this.j8u_1 = text;
  }
  protoOf(TextBlock).g8u = function () {
    return this.j8u_1.length;
  };
  protoOf(TextBlock).h8u = function () {
    return 1;
  };
  protoOf(TextBlock).toString = function () {
    return 'TextBlock(text=' + this.j8u_1 + ')';
  };
  protoOf(TextBlock).hashCode = function () {
    return getStringHashCode(this.j8u_1);
  };
  protoOf(TextBlock).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TextBlock))
      return false;
    if (!(this.j8u_1 === other.j8u_1))
      return false;
    return true;
  };
  function IndentationBlock(size) {
    Block.call(this);
    this.k8u_1 = size;
  }
  protoOf(IndentationBlock).g8u = function () {
    return this.k8u_1;
  };
  protoOf(IndentationBlock).h8u = function () {
    return 1;
  };
  protoOf(IndentationBlock).toString = function () {
    return 'IndentationBlock(size=' + this.k8u_1 + ')';
  };
  protoOf(IndentationBlock).hashCode = function () {
    return this.k8u_1;
  };
  protoOf(IndentationBlock).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof IndentationBlock))
      return false;
    if (!(this.k8u_1 === other.k8u_1))
      return false;
    return true;
  };
  function VerticalBlock(children) {
    CompoundBlock.call(this);
    this.l8u_1 = children;
  }
  protoOf(VerticalBlock).g8u = function () {
    var tmp0 = this.l8u_1;
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlin.collections.maxOfOrNull' call
      var iterator = tmp0.m();
      if (!iterator.n()) {
        tmp$ret$0 = null;
        break $l$block;
      }
      var maxValue = iterator.o().g8u();
      while (iterator.n()) {
        var v = iterator.o().g8u();
        if (compareTo_0(maxValue, v) < 0) {
          maxValue = v;
        }
      }
      tmp$ret$0 = maxValue;
    }
    var tmp0_elvis_lhs = tmp$ret$0;
    return tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
  };
  protoOf(VerticalBlock).h8u = function () {
    // Inline function 'kotlin.collections.sumOf' call
    var sum = 0;
    var _iterator__ex2g4s = this.l8u_1.m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      var tmp = sum;
      sum = tmp + element.h8u() | 0;
    }
    return sum;
  };
  protoOf(VerticalBlock).toString = function () {
    return 'VerticalBlock(children=' + toString_1(this.l8u_1) + ')';
  };
  protoOf(VerticalBlock).hashCode = function () {
    return hashCode(this.l8u_1);
  };
  protoOf(VerticalBlock).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof VerticalBlock))
      return false;
    if (!equals(this.l8u_1, other.l8u_1))
      return false;
    return true;
  };
  function CompoundBlock() {
    Block.call(this);
  }
  function BlockBuilder(orientation) {
    BlockData.call(this);
    this.m8u_1 = orientation;
    var tmp = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp.n8u_1 = ArrayList_init_$Create$();
  }
  protoOf(BlockBuilder).o8u = function () {
    var tmp;
    switch (this.m8u_1.x2_1) {
      case 1:
        // Inline function 'kotlin.collections.map' call

        var this_0 = this.n8u_1;
        // Inline function 'kotlin.collections.mapTo' call

        var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
        var _iterator__ex2g4s = this_0.m();
        while (_iterator__ex2g4s.n()) {
          var item = _iterator__ex2g4s.o();
          var tmp$ret$0 = item.o8u();
          destination.j(tmp$ret$0);
        }

        tmp = new VerticalBlock(destination);
        break;
      case 0:
        // Inline function 'kotlin.collections.map' call

        var this_1 = this.n8u_1;
        // Inline function 'kotlin.collections.mapTo' call

        var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_1, 10));
        var _iterator__ex2g4s_0 = this_1.m();
        while (_iterator__ex2g4s_0.n()) {
          var item_0 = _iterator__ex2g4s_0.o();
          var tmp$ret$3 = item_0.o8u();
          destination_0.j(tmp$ret$3);
        }

        tmp = new HorizontalBlock(destination_0);
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  };
  var Orientation_HORIZONTAL_instance;
  var Orientation_VERTICAL_instance;
  var Orientation_entriesInitialized;
  function Orientation_initEntries() {
    if (Orientation_entriesInitialized)
      return Unit_instance;
    Orientation_entriesInitialized = true;
    Orientation_HORIZONTAL_instance = new Orientation('HORIZONTAL', 0);
    Orientation_VERTICAL_instance = new Orientation('VERTICAL', 1);
  }
  function Orientation(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function Orientation_HORIZONTAL_getInstance() {
    Orientation_initEntries();
    return Orientation_HORIZONTAL_instance;
  }
  function Orientation_VERTICAL_getInstance() {
    Orientation_initEntries();
    return Orientation_VERTICAL_instance;
  }
  function BlockData() {
  }
  function ReadyBlock(block) {
    BlockData.call(this);
    this.p8u_1 = block;
  }
  protoOf(ReadyBlock).o8u = function () {
    return this.p8u_1;
  };
  function BlockIndentUpdater(cell, builder) {
    IndentUpdater.call(this, cell, builder, new BlockIndentUpdaterTarget());
  }
  function BlockIndentUpdaterTarget() {
  }
  protoOf(BlockIndentUpdaterTarget).l8v = function () {
    return new BlockBuilder(Orientation_HORIZONTAL_getInstance());
  };
  protoOf(BlockIndentUpdaterTarget).m8v = function (size) {
    return new ReadyBlock(new IndentationBlock(size));
  };
  protoOf(BlockIndentUpdaterTarget).n8v = function (cell) {
    var block = toBlock(cell);
    return new StaticCellWrapper(new ReadyBlock(block));
  };
  protoOf(BlockIndentUpdaterTarget).o8v = function (item) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.require' call
    if (!(item instanceof BlockBuilder)) {
      var message = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    return item.n8u_1;
  };
  protoOf(BlockIndentUpdaterTarget).p8v = function (item) {
    return this.o8v(item instanceof BlockData ? item : THROW_CCE());
  };
  protoOf(BlockIndentUpdaterTarget).q8v = function (item) {
    throw UnsupportedOperationException_init_$Create$();
  };
  protoOf(BlockIndentUpdaterTarget).r8v = function (item) {
    return this.q8v(item instanceof BlockData ? item : THROW_CCE());
  };
  protoOf(BlockIndentUpdaterTarget).s8v = function (item) {
    throw UnsupportedOperationException_init_$Create$();
  };
  protoOf(BlockIndentUpdaterTarget).t8v = function (item) {
    return this.s8v(item instanceof BlockData ? item : THROW_CCE());
  };
  protoOf(BlockIndentUpdaterTarget).u8v = function (cell) {
    throw UnsupportedOperationException_init_$Create$();
  };
  function StaticCellWrapper(item) {
    this.v8v_1 = item;
  }
  protoOf(StaticCellWrapper).w8v = function () {
    return this.v8v_1;
  };
  protoOf(StaticCellWrapper).x8v = function () {
  };
  protoOf(StaticCellWrapper).h4 = function () {
    throw UnsupportedOperationException_init_$Create$();
  };
  function toBlock(_this__u8e3s4) {
    var tmp;
    if (_this__u8e3s4 instanceof TextCell) {
      tmp = new TextBlock(_this__u8e3s4.o8w().w2w());
    } else {
      if (_this__u8e3s4 instanceof VerticalCell) {
        // Inline function 'kotlin.collections.map' call
        var this_0 = _this__u8e3s4.o35();
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
        var _iterator__ex2g4s = this_0.m();
        while (_iterator__ex2g4s.n()) {
          var item = _iterator__ex2g4s.o();
          var tmp$ret$0 = toBlock(item);
          destination.j(tmp$ret$0);
        }
        tmp = new VerticalBlock(destination);
      } else {
        if (_this__u8e3s4 instanceof HorizontalCell) {
          // Inline function 'kotlin.collections.map' call
          var this_1 = _this__u8e3s4.o35();
          // Inline function 'kotlin.collections.mapTo' call
          var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_1, 10));
          var _iterator__ex2g4s_0 = this_1.m();
          while (_iterator__ex2g4s_0.n()) {
            var item_0 = _iterator__ex2g4s_0.o();
            var tmp$ret$3 = toBlock(item_0);
            destination_0.j(tmp$ret$3);
          }
          tmp = new HorizontalBlock(destination_0);
        } else {
          if (_this__u8e3s4 instanceof IndentCell) {
            tmp = indentToBlock(_this__u8e3s4);
          } else {
            if (_this__u8e3s4 instanceof ImageCell) {
              tmp = imageBlock(_this__u8e3s4);
            } else {
              throw IllegalArgumentException_init_$Create$_0('Unexpected kind of cell ' + toString_1(getKClassFromExpression(_this__u8e3s4)));
            }
          }
        }
      }
    }
    return tmp;
  }
  function indentToBlock(_this__u8e3s4) {
    var blockBuilder = new BlockBuilder(Orientation_VERTICAL_getInstance());
    var u = new BlockIndentUpdater(_this__u8e3s4, blockBuilder);
    var _iterator__ex2g4s = _this__u8e3s4.o35().m();
    while (_iterator__ex2g4s.n()) {
      var c = _iterator__ex2g4s.o();
      u.c8v(c);
    }
    return blockBuilder.o8u();
  }
  function imageBlock(_this__u8e3s4) {
    var _destruct__k2r9zo = _this__u8e3s4.z8w().uv().p8w_1;
    var width = _destruct__k2r9zo.fg();
    var height = _destruct__k2r9zo.gg();
    var defaultFont = Companion_getInstance_154().a8x_1;
    var singleCharSize = spaceDimensions(defaultFont);
    var widthInChars = roundToInt(width / singleCharSize.q8b_1);
    // Inline function 'kotlin.let' call
    var it = roundToInt(height / singleCharSize.r8b_1);
    var heightInChars = it === 0 ? 1 : it;
    var tmp = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_0 = Array(heightInChars);
    while (tmp < heightInChars) {
      tmp_0[tmp] = new TextBlock(repeat(' ', widthInChars));
      tmp = tmp + 1 | 0;
    }
    var lines = tmp_0;
    return new VerticalBlock(toList(lines));
  }
  function toText_0(_this__u8e3s4) {
    var tmp = computeLines(_this__u8e3s4);
    return joinToString_0(tmp, '\n', VOID, VOID, VOID, VOID, toText$lambda);
  }
  function computeLines(_this__u8e3s4) {
    var tmp = 0;
    var tmp_0 = _this__u8e3s4.h8u();
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_1 = Array(tmp_0);
    while (tmp < tmp_0) {
      var tmp_2 = tmp;
      tmp_1[tmp_2] = new HorizontalBlock(line(_this__u8e3s4, tmp_2));
      tmp = tmp + 1 | 0;
    }
    return toList(tmp_1);
  }
  function toTextString(_this__u8e3s4) {
    // Inline function 'kotlin.text.trimEnd' call
    var this_0 = joinToString_0(textPieces(_this__u8e3s4), '');
    return toString_1(trimEnd(isCharSequence(this_0) ? this_0 : THROW_CCE()));
  }
  function line(_this__u8e3s4, lineNumber) {
    var tmp;
    if (_this__u8e3s4 instanceof TextBlock) {
      var tmp_0;
      if (lineNumber === 0) {
        tmp_0 = listOf(_this__u8e3s4);
      } else {
        tmp_0 = listOf(new IndentationBlock(_this__u8e3s4.g8u()));
      }
      tmp = tmp_0;
    } else {
      if (_this__u8e3s4 instanceof IndentationBlock) {
        tmp = listOf(_this__u8e3s4);
      } else {
        if (_this__u8e3s4 instanceof HorizontalBlock) {
          // Inline function 'kotlin.collections.flatMap' call
          var tmp0 = _this__u8e3s4.i8u_1;
          // Inline function 'kotlin.collections.flatMapTo' call
          var destination = ArrayList_init_$Create$();
          var _iterator__ex2g4s = tmp0.m();
          while (_iterator__ex2g4s.n()) {
            var element = _iterator__ex2g4s.o();
            var list = line(element, lineNumber);
            addAll_1(destination, list);
          }
          tmp = destination;
        } else {
          if (_this__u8e3s4 instanceof VerticalBlock) {
            tmp = lineOfVerticalBlock(_this__u8e3s4, lineNumber);
          } else {
            noWhenBranchMatchedException();
          }
        }
      }
    }
    return tmp;
  }
  function textPieces(_this__u8e3s4) {
    var tmp;
    if (_this__u8e3s4 instanceof TextBlock) {
      tmp = listOf(_this__u8e3s4.j8u_1);
    } else {
      if (_this__u8e3s4 instanceof IndentationBlock) {
        tmp = listOf(repeat(' ', _this__u8e3s4.k8u_1));
      } else {
        if (_this__u8e3s4 instanceof HorizontalBlock) {
          // Inline function 'kotlin.collections.flatMap' call
          var tmp0 = _this__u8e3s4.i8u_1;
          // Inline function 'kotlin.collections.flatMapTo' call
          var destination = ArrayList_init_$Create$();
          var _iterator__ex2g4s = tmp0.m();
          while (_iterator__ex2g4s.n()) {
            var element = _iterator__ex2g4s.o();
            var list = textPieces(element);
            addAll_1(destination, list);
          }
          tmp = destination;
        } else {
          if (_this__u8e3s4 instanceof VerticalBlock) {
            throw IllegalStateException_init_$Create$_0('Unexpected VerticalBlock. All of them must have been removed before');
          } else {
            noWhenBranchMatchedException();
          }
        }
      }
    }
    return tmp;
  }
  function lineOfVerticalBlock(_this__u8e3s4, lineNumber) {
    var prevAccHeight = 0;
    var accHeight = 0;
    var _iterator__ex2g4s = _this__u8e3s4.l8u_1.m();
    while (_iterator__ex2g4s.n()) {
      var childBlock = _iterator__ex2g4s.o();
      accHeight = accHeight + childBlock.h8u() | 0;
      if (accHeight > lineNumber) {
        var childLine = line(childBlock, lineNumber - prevAccHeight | 0);
        var childWidth = childBlock.g8u();
        var tmp;
        if (childWidth === _this__u8e3s4.g8u()) {
          tmp = childLine;
        } else if (childWidth < _this__u8e3s4.g8u()) {
          tmp = plus_5(childLine, listOf(new IndentationBlock(_this__u8e3s4.g8u() - childWidth | 0)));
        } else {
          throw IllegalStateException_init_$Create$();
        }
        return tmp;
      }
      prevAccHeight = accHeight;
    }
    return listOf(new IndentationBlock(_this__u8e3s4.g8u()));
  }
  function toText$lambda(it) {
    return toTextString(it);
  }
  function attachItem($this, item, prevIndex, nextIndex) {
    changeParent(get_asBaseCell(item), $this.r8x_1);
    if (0 <= prevIndex ? prevIndex < $this.p() : false) {
      var prev = $this.r(prevIndex);
      get_asBaseCell(prev).c8w_1 = item;
      get_asBaseCell(item).d8w_1 = prev;
    }
    if (0 <= nextIndex ? nextIndex < $this.p() : false) {
      var next = $this.r(nextIndex);
      get_asBaseCell(next).d8w_1 = item;
      get_asBaseCell(item).c8w_1 = next;
    }
  }
  function detachItem($this, item, index) {
    if ($this.r8x_1.f89()) {
      get_asCellContainerInternal(ensureNotNull($this.r8x_1.s8x())).t8x(item);
    }
    $this.r8x_1.u8x(new CollectionItemEvent(item, null, index, EventType_REMOVE_getInstance()));
    var itemBaseCell = get_asBaseCell(item);
    if ($this.r8x_1.f89()) {
      detach_0(itemBaseCell, true);
    }
    changeParent(itemBaseCell, null);
    var prev = itemBaseCell.d8w_1;
    var next = itemBaseCell.c8w_1;
    if (!(prev == null)) {
      get_asBaseCell(prev).c8w_1 = next;
    }
    if (!(next == null)) {
      get_asBaseCell(next).d8w_1 = prev;
    }
    itemBaseCell.d8w_1 = null;
    itemBaseCell.c8w_1 = null;
  }
  function BaseCell$ChildList$onItemAdd$lambda($event) {
    return function (listener) {
      listener.v8x($event);
      return Unit_instance;
    };
  }
  function BaseCell$ChildList$onItemRemove$lambda($event) {
    return function (listener) {
      listener.w8x($event);
      return Unit_instance;
    };
  }
  function ensureChildrenInitialized($this) {
    if ($this.y8x_1.z8v_1 == null) {
      $this.y8x_1.z8v_1 = new ChildList_0($this.y8x_1);
    }
  }
  function BaseCell$ExternalChildList$addListener$cellListener$1($listener) {
    this.z8x_1 = $listener;
  }
  protoOf(BaseCell$ExternalChildList$addListener$cellListener$1).v8x = function (event) {
    return this.z8x_1.m2r(event);
  };
  protoOf(BaseCell$ExternalChildList$addListener$cellListener$1).w8x = function (event) {
    return this.z8x_1.t2r(event);
  };
  function BaseCell$ExternalChildList$addHandler$listener$1($handler) {
    this.e8y_1 = $handler;
  }
  protoOf(BaseCell$ExternalChildList$addHandler$listener$1).f8y = function (event) {
    return this.e8y_1.n2s(event);
  };
  protoOf(BaseCell$ExternalChildList$addHandler$listener$1).m2r = function (event) {
    return this.f8y(event);
  };
  protoOf(BaseCell$ExternalChildList$addHandler$listener$1).g8y = function (event) {
    return this.e8y_1.n2s(event);
  };
  protoOf(BaseCell$ExternalChildList$addHandler$listener$1).n2r = function (event) {
    return this.g8y(event);
  };
  protoOf(BaseCell$ExternalChildList$addHandler$listener$1).h8y = function (event) {
    return this.e8y_1.n2s(event);
  };
  protoOf(BaseCell$ExternalChildList$addHandler$listener$1).t2r = function (event) {
    return this.h8y(event);
  };
  function dispatch_0($this, bubblingPath, cursor, event, spec) {
    var $this_0 = $this;
    var bubblingPath_0 = bubblingPath;
    var cursor_0 = cursor;
    var event_0 = event;
    var spec_0 = spec;
    $l$1: do {
      $l$0: do {
        var cell = bubblingPath_0.r(cursor_0);
        dispatchStep(get_asBaseCell(cell), event_0, spec_0);
        if (event_0.l8i_1) {
          return Unit_instance;
        }
        var next = nextAttached($this_0, bubblingPath_0, cursor_0);
        if (!(next === -1)) {
          var tmp0 = $this_0;
          var tmp1 = bubblingPath_0;
          var tmp3 = event_0;
          var tmp4 = spec_0;
          $this_0 = tmp0;
          bubblingPath_0 = tmp1;
          cursor_0 = next;
          event_0 = tmp3;
          spec_0 = tmp4;
          continue $l$0;
        }
        break $l$1;
      }
       while (false);
    }
     while (true);
  }
  function dispatch_1($this, bubblingPath, cursor, event, spec) {
    var $this_0 = $this;
    var bubblingPath_0 = bubblingPath;
    var cursor_0 = cursor;
    var event_0 = event;
    var spec_0 = spec;
    $l$1: do {
      $l$0: do {
        var cell = bubblingPath_0.r(cursor_0);
        var _iterator__ex2g4s = get_asBaseCell(cell).y8v_1.m();
        while (_iterator__ex2g4s.n()) {
          var trait = _iterator__ex2g4s.o();
          trait.i8y(cell, spec_0, event_0);
          if (event_0.l8i_1) {
            return Unit_instance;
          }
        }
        if (!spec_0.k8y_1) {
          return Unit_instance;
        }
        var next = nextAttached($this_0, bubblingPath_0, cursor_0);
        if (!(next === -1)) {
          var tmp0 = $this_0;
          var tmp1 = bubblingPath_0;
          var tmp3 = event_0;
          var tmp4 = spec_0;
          $this_0 = tmp0;
          bubblingPath_0 = tmp1;
          cursor_0 = next;
          event_0 = tmp3;
          spec_0 = tmp4;
          continue $l$0;
        }
        break $l$1;
      }
       while (false);
    }
     while (true);
  }
  function nextAttached($this, bubblingPath, current) {
    var inductionVariable = current + 1 | 0;
    var last = bubblingPath.p();
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (bubblingPath.r(i).f89()) {
          return i;
        }
      }
       while (inductionVariable < last);
    return -1;
  }
  function BaseCell$cellContainer$1$addHandler$cellListener$1($handler) {
    this.l8y_1 = $handler;
  }
  protoOf(BaseCell$cellContainer$1$addHandler$cellListener$1).c8y = function (container) {
    var event = new PropertyChangeEvent(null, container);
    this.l8y_1.n2s(event);
  };
  protoOf(BaseCell$cellContainer$1$addHandler$cellListener$1).d8y = function (container) {
    var event = new PropertyChangeEvent(container, null);
    this.l8y_1.n2s(event);
  };
  function BaseCell$getProp$MyProperty$addHandler$cellListener$1($cellPropSpec, $handler) {
    this.m8y_1 = $cellPropSpec;
    this.n8y_1 = $handler;
  }
  protoOf(BaseCell$getProp$MyProperty$addHandler$cellListener$1).a8y = function (prop, event) {
    if (equals(this.m8y_1, prop)) {
      var changeEvent = event instanceof PropertyChangeEvent ? event : THROW_CCE();
      this.n8y_1.n2s(changeEvent);
    }
  };
  function BaseCell_init_$Init$($this) {
    BaseCell.call($this, null);
    return $this;
  }
  function dispatchStep($this, event, spec) {
    if (equals(spec, Companion_getInstance_170().s8y_1) || (equals(spec, Companion_getInstance_170().t8y_1) || equals(spec, Companion_getInstance_170().u8y_1))) {
      var keyEvent = event instanceof KeyEvent ? event : THROW_CCE();
      var indexedObject = values_6();
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var priority = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        var _iterator__ex2g4s = $this.y8v_1.m();
        while (_iterator__ex2g4s.n()) {
          var trait = _iterator__ex2g4s.o();
          if (priority.equals(EventPriority_LOW_getInstance())) {
            if (equals(spec, Companion_getInstance_170().s8y_1)) {
              trait.v8z($this, keyEvent);
            } else if (equals(spec, Companion_getInstance_170().t8y_1)) {
              trait.u8z($this, keyEvent);
            } else {
              trait.t8z($this, keyEvent);
            }
          } else {
            if (equals(spec, Companion_getInstance_170().s8y_1)) {
              trait.s8z($this, keyEvent);
            } else if (equals(spec, Companion_getInstance_170().t8y_1)) {
              trait.r8y($this, keyEvent);
            } else {
              trait.q8y($this, keyEvent);
            }
          }
          if (event.l8i_1) {
            return Unit_instance;
          }
        }
      }
    } else {
      var _iterator__ex2g4s_0 = $this.y8v_1.m();
      while (_iterator__ex2g4s_0.n()) {
        var trait_0 = _iterator__ex2g4s_0.o();
        spec.p8y($this, event, trait_0);
        if (event.l8i_1) {
          return Unit_instance;
        }
      }
    }
  }
  function firePropertyChange($this, prop, event) {
    propertySet($this, prop, event);
    $this.w8z(prop, event);
    var _iterator__ex2g4s = $this.y8v_1.m();
    while (_iterator__ex2g4s.n()) {
      var trait = _iterator__ex2g4s.o();
      trait.x8z($this, prop, event);
    }
    var tmp0_safe_receiver = $this.f8w_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.k2s(BaseCell$firePropertyChange$lambda(prop, event));
    }
    var tmp1_safe_receiver = $this.s8x();
    var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : get_asCellContainerInternal(tmp1_safe_receiver);
    if (tmp2_safe_receiver == null)
      null;
    else {
      tmp2_safe_receiver.y8z($this, prop, event);
    }
  }
  function getDefaultValue($this, prop) {
    return prop.b90($this);
  }
  function attach($this, container, initial) {
    // Inline function 'kotlin.check' call
    if (!!$this.f89()) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    $this.a8w_1 = container;
    get_asCellContainerInternal(container).c90($this);
    var tmp0_safe_receiver = $this.f8w_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.k2s(BaseCell$attach$lambda(container));
    }
    var children = $this.z8v_1;
    if (!(children == null)) {
      var _iterator__ex2g4s = children.m();
      while (_iterator__ex2g4s.n()) {
        var child = _iterator__ex2g4s.o();
        attach(get_asBaseCell(child), container, false);
      }
    }
    var _iterator__ex2g4s_0 = $this.d90().m();
    while (_iterator__ex2g4s_0.n()) {
      var popup = _iterator__ex2g4s_0.o();
      attach$default(get_asBaseCell(popup), container);
    }
    if (initial) {
      afterAttach($this);
    }
  }
  function attach$default($this, container, initial, $super) {
    initial = initial === VOID ? true : initial;
    return attach($this, container, initial);
  }
  function detach_0($this, initial) {
    var container = $this.s8x();
    // Inline function 'kotlin.checkNotNull' call
    $l$block: {
      // Inline function 'kotlin.checkNotNull' call
      if (container == null) {
        var message = 'Required value was null.';
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      } else {
        break $l$block;
      }
    }
    if (initial) {
      beforeDetach($this, $this);
    }
    get_asCellContainerInternal(container).e90($this);
    $this.a8w_1 = null;
    var tmp0_safe_receiver = $this.f8w_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.k2s(BaseCell$detach$lambda(container));
    }
    var children = $this.z8v_1;
    if (!(children == null)) {
      var _iterator__ex2g4s = children.m();
      while (_iterator__ex2g4s.n()) {
        var child = _iterator__ex2g4s.o();
        detach_0(get_asBaseCell(child), false);
      }
    }
    var _iterator__ex2g4s_0 = $this.d90().m();
    while (_iterator__ex2g4s_0.n()) {
      var popup = _iterator__ex2g4s_0.o();
      detach$default(get_asBaseCell(popup));
    }
  }
  function detach$default($this, initial, $super) {
    initial = initial === VOID ? true : initial;
    return detach_0($this, initial);
  }
  function afterAttach($this) {
    var _iterator__ex2g4s = $this.y8v_1.m();
    while (_iterator__ex2g4s.n()) {
      var trait = _iterator__ex2g4s.o();
      trait.f90($this);
    }
    var children = $this.z8v_1;
    if (!(children == null)) {
      var _iterator__ex2g4s_0 = children.m();
      while (_iterator__ex2g4s_0.n()) {
        var child = _iterator__ex2g4s_0.o();
        afterAttach(get_asBaseCell(child));
      }
    }
  }
  function beforeDetach($this, root) {
    var children = $this.z8v_1;
    if (!(children == null)) {
      var _iterator__ex2g4s = children.m();
      while (_iterator__ex2g4s.n()) {
        var child = _iterator__ex2g4s.o();
        beforeDetach(get_asBaseCell(child), root);
      }
    }
    var _iterator__ex2g4s_0 = $this.y8v_1.m();
    while (_iterator__ex2g4s_0.n()) {
      var trait = _iterator__ex2g4s_0.o();
      trait.g90($this, root);
    }
  }
  function beforePropertySet($this, prop, event) {
    if (isPopupProp(prop)) {
      var cellChangeEvent = event instanceof PropertyChangeEvent ? event : THROW_CCE();
      var oldValue = cellChangeEvent.s2y_1;
      var value = cellChangeEvent.t2y_1;
      if (!(oldValue == null)) {
        if (!($this.s8x() == null)) {
          get_asCellContainerInternal(ensureNotNull($this.s8x())).h90(oldValue);
        }
        oldValue.i90(get_POPUP(), false);
        changeParent(get_asBaseCell(oldValue), null);
      }
      if (!(value == null)) {
        if (!($this.s8x() == null)) {
          get_asCellContainerInternal(ensureNotNull($this.s8x())).j90(value);
        }
        value.i90(get_POPUP(), true);
        changeParent(get_asBaseCell(value), $this);
      }
    }
  }
  function propertySet($this, prop, event) {
    if (isPopupProp(prop) && $this.f89()) {
      var cellChangeEvent = event instanceof PropertyChangeEvent ? event : THROW_CCE();
      var oldValue = cellChangeEvent.s2y_1;
      var value = cellChangeEvent.t2y_1;
      var tmp1_safe_receiver = oldValue == null ? null : get_asBaseCell(oldValue);
      if (tmp1_safe_receiver == null)
        null;
      else {
        detach$default(tmp1_safe_receiver);
      }
      var tmp3_safe_receiver = value == null ? null : get_asBaseCell(value);
      if (tmp3_safe_receiver == null)
        null;
      else {
        attach$default(tmp3_safe_receiver, ensureNotNull($this.s8x()));
      }
    }
  }
  function changeParent($this, newParent) {
    var oldParent = $this.b8w_1;
    $this.b8w_1 = newParent;
    var listeners = $this.f8w_1;
    if (!(listeners == null)) {
      var event = new PropertyChangeEvent(oldParent, newParent);
      listeners.k2s(BaseCell$changeParent$lambda(event));
    }
  }
  function ChildList_0($outer) {
    this.r8x_1 = $outer;
    ObservableArrayList.call(this);
  }
  protoOf(ChildList_0).k90 = function (index, item) {
    var event = new CollectionItemEvent(null, item, index, EventType_ADD_getInstance());
    if (this.r8x_1.f89()) {
      attach$default(get_asBaseCell(item), ensureNotNull(this.r8x_1.s8x()));
    }
    this.r8x_1.v8x(event);
    var tmp0_safe_receiver = this.r8x_1.s8x();
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : get_asCellContainerInternal(tmp0_safe_receiver);
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.l90(this.r8x_1, event);
    }
    var tmp2_safe_receiver = this.r8x_1.f8w_1;
    if (tmp2_safe_receiver == null)
      null;
    else {
      tmp2_safe_receiver.k2s(BaseCell$ChildList$onItemAdd$lambda(event));
    }
  };
  protoOf(ChildList_0).u2s = function (index, item) {
    return this.k90(index, (!(item == null) ? isInterface(item, Cell) : false) ? item : THROW_CCE());
  };
  protoOf(ChildList_0).m90 = function (index, item) {
    var event = new CollectionItemEvent(item, null, index, EventType_REMOVE_getInstance());
    var tmp0_safe_receiver = this.r8x_1.s8x();
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : get_asCellContainerInternal(tmp0_safe_receiver);
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.n90(this.r8x_1, event);
    }
    var tmp2_safe_receiver = this.r8x_1.f8w_1;
    if (tmp2_safe_receiver == null)
      null;
    else {
      tmp2_safe_receiver.k2s(BaseCell$ChildList$onItemRemove$lambda(event));
    }
  };
  protoOf(ChildList_0).d2t = function (index, item) {
    return this.m90(index, (!(item == null) ? isInterface(item, Cell) : false) ? item : THROW_CCE());
  };
  protoOf(ChildList_0).o90 = function (index, oldItem, newItem) {
    this.m90(index, oldItem);
    this.k90(index, newItem);
  };
  protoOf(ChildList_0).z2s = function (index, oldItem, newItem) {
    var tmp = (!(oldItem == null) ? isInterface(oldItem, Cell) : false) ? oldItem : THROW_CCE();
    return this.o90(index, tmp, (!(newItem == null) ? isInterface(newItem, Cell) : false) ? newItem : THROW_CCE());
  };
  protoOf(ChildList_0).p90 = function (index, item) {
    protoOf(ObservableArrayList).o2s.call(this, index, item);
    // Inline function 'kotlin.check' call
    if (!(item.bp() == null)) {
      var message = "item.parent is not null: '" + toString_0(item.bp()) + "', item: '" + toString_1(item) + "', index: " + index;
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    // Inline function 'kotlin.check' call
    if (!!this.r8x_1.q90()) {
      var message_0 = "adding '" + toString_1(item) + "' to a leaf cell ('" + this.r8x_1.toString() + "')";
      throw IllegalStateException_init_$Create$_0(toString_1(message_0));
    }
  };
  protoOf(ChildList_0).o2s = function (index, item) {
    return this.p90(index, (!(item == null) ? isInterface(item, Cell) : false) ? item : THROW_CCE());
  };
  protoOf(ChildList_0).r90 = function (index, item) {
    return attachItem(this, item, index - 1 | 0, index);
  };
  protoOf(ChildList_0).s2s = function (index, item) {
    return this.r90(index, (!(item == null) ? isInterface(item, Cell) : false) ? item : THROW_CCE());
  };
  protoOf(ChildList_0).s90 = function (index, oldItem, newItem) {
    this.p90(index, newItem);
    this.q2s(index, oldItem);
  };
  protoOf(ChildList_0).p2s = function (index, oldItem, newItem) {
    var tmp = (!(oldItem == null) ? isInterface(oldItem, Cell) : false) ? oldItem : THROW_CCE();
    return this.s90(index, tmp, (!(newItem == null) ? isInterface(newItem, Cell) : false) ? newItem : THROW_CCE());
  };
  protoOf(ChildList_0).t90 = function (index, oldItem, newItem) {
    detachItem(this, oldItem, index);
    attachItem(this, newItem, index - 1 | 0, index + 1 | 0);
  };
  protoOf(ChildList_0).x2s = function (index, oldItem, newItem) {
    var tmp = (!(oldItem == null) ? isInterface(oldItem, Cell) : false) ? oldItem : THROW_CCE();
    return this.t90(index, tmp, (!(newItem == null) ? isInterface(newItem, Cell) : false) ? newItem : THROW_CCE());
  };
  protoOf(ChildList_0).u90 = function (index, item) {
    return detachItem(this, item, index);
  };
  protoOf(ChildList_0).c2t = function (index, item) {
    return this.u90(index, (!(item == null) ? isInterface(item, Cell) : false) ? item : THROW_CCE());
  };
  function ExternalChildList($outer) {
    this.y8x_1 = $outer;
    AbstractMutableList.call(this);
  }
  protoOf(ExternalChildList).p = function () {
    var tmp0_safe_receiver = this.y8x_1.z8v_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.p();
    return tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
  };
  protoOf(ExternalChildList).r = function (index) {
    if (this.y8x_1.z8v_1 == null) {
      throw CollectionIndexOutOfBoundsException_init_$Create$();
    }
    return ensureNotNull(this.y8x_1.z8v_1).r(index);
  };
  protoOf(ExternalChildList).v90 = function (index, element) {
    if (this.y8x_1.z8v_1 == null) {
      throw CollectionIndexOutOfBoundsException_init_$Create$();
    }
    return ensureNotNull(this.y8x_1.z8v_1).l2(index, element);
  };
  protoOf(ExternalChildList).l2 = function (index, element) {
    return this.v90(index, (!(element == null) ? isInterface(element, Cell) : false) ? element : THROW_CCE());
  };
  protoOf(ExternalChildList).w90 = function (index, element) {
    ensureChildrenInitialized(this);
    ensureNotNull(this.y8x_1.z8v_1).m2(index, element);
  };
  protoOf(ExternalChildList).m2 = function (index, element) {
    return this.w90(index, (!(element == null) ? isInterface(element, Cell) : false) ? element : THROW_CCE());
  };
  protoOf(ExternalChildList).n2 = function (index) {
    if (this.y8x_1.z8v_1 == null) {
      throw CollectionIndexOutOfBoundsException_init_$Create$();
    }
    var result = ensureNotNull(this.y8x_1.z8v_1).n2(index);
    if (ensureNotNull(this.y8x_1.z8v_1).s()) {
      this.y8x_1.z8v_1 = null;
    }
    return result;
  };
  protoOf(ExternalChildList).x90 = function (listener) {
    var cellListener = new BaseCell$ExternalChildList$addListener$cellListener$1(listener);
    return this.y8x_1.y90(cellListener);
  };
  protoOf(ExternalChildList).x2r = function (listener) {
    return this.x90(listener);
  };
  protoOf(ExternalChildList).z90 = function (handler) {
    var listener = new BaseCell$ExternalChildList$addHandler$listener$1(handler);
    return this.x90(listener);
  };
  protoOf(ExternalChildList).y2r = function (handler) {
    return this.z90(handler);
  };
  function Companion_148() {
  }
  var Companion_instance_148;
  function Companion_getInstance_148() {
    return Companion_instance_148;
  }
  function BaseCell$addTrait$$inlined$toDisposable$1(this$0, $trait) {
    this.a91_1 = this$0;
    this.b91_1 = $trait;
  }
  protoOf(BaseCell$addTrait$$inlined$toDisposable$1).zr = function () {
    this.a91_1.y8v_1.c2m(this.b91_1);
    this.b91_1.c91(this.a91_1);
    return Unit_instance;
  };
  function BaseCell$cellContainer$1(this$0) {
    this.d91_1 = this$0;
  }
  protoOf(BaseCell$cellContainer$1).v2w = function () {
    return 'cell.cellContainer';
  };
  protoOf(BaseCell$cellContainer$1).uv = function () {
    return this.d91_1.s8x();
  };
  protoOf(BaseCell$cellContainer$1).e91 = function (handler) {
    var cellListener = new BaseCell$cellContainer$1$addHandler$cellListener$1(handler);
    return this.d91_1.y90(cellListener);
  };
  protoOf(BaseCell$cellContainer$1).y2r = function (handler) {
    return this.e91(handler);
  };
  function BaseCell$set$$inlined$toDisposable$1(this$0, $prop, $old) {
    this.f91_1 = this$0;
    this.g91_1 = $prop;
    this.h91_1 = $old;
  }
  protoOf(BaseCell$set$$inlined$toDisposable$1).zr = function () {
    this.f91_1.i90(this.g91_1, this.h91_1);
    return Unit_instance;
  };
  function BaseCell$firePropertyChange$lambda($prop, $event) {
    return function (listener) {
      listener.a8y($prop, $event);
      return Unit_instance;
    };
  }
  function BaseCell$getProp$MyProperty(this$0, $cellPropSpec) {
    this.i91_1 = this$0;
    this.j91_1 = $cellPropSpec;
    BaseReadableProperty.call(this);
  }
  protoOf(BaseCell$getProp$MyProperty).v2w = function () {
    return this.i91_1.toString() + '.' + this.j91_1.toString();
  };
  protoOf(BaseCell$getProp$MyProperty).uv = function () {
    return this.i91_1.k91(this.j91_1);
  };
  protoOf(BaseCell$getProp$MyProperty).d2x = function (newValue) {
    this.i91_1.i90(this.j91_1, newValue);
  };
  protoOf(BaseCell$getProp$MyProperty).u2w = function (handler) {
    var cellListener = new BaseCell$getProp$MyProperty$addHandler$cellListener$1(this.j91_1, handler);
    return this.i91_1.y90(cellListener);
  };
  protoOf(BaseCell$getProp$MyProperty).y2r = function (handler) {
    return this.u2w(handler);
  };
  function BaseCell$attach$lambda($container) {
    return function (listener) {
      listener.c8y($container);
      return Unit_instance;
    };
  }
  function BaseCell$detach$lambda($container) {
    return function (listener) {
      listener.d8y($container);
      return Unit_instance;
    };
  }
  function BaseCell$changeParent$lambda($event) {
    return function (listener) {
      listener.b8y($event);
      return Unit_instance;
    };
  }
  function BaseCell$set$trait$1($traitPropSpec, $value) {
    this.l91_1 = $traitPropSpec;
    this.m91_1 = $value;
    CellTrait.call(this);
  }
  protoOf(BaseCell$set$trait$1).n91 = function (cell, spec) {
    var tmp;
    if (this.l91_1 === spec) {
      tmp = this.m91_1;
    } else {
      tmp = protoOf(CellTrait).n91.call(this, cell, this.l91_1);
    }
    return tmp;
  };
  function BaseCell(cellContainer) {
    this.y8v_1 = Companion_instance_32.m2n();
    this.z8v_1 = null;
    this.a8w_1 = null;
    this.b8w_1 = null;
    this.c8w_1 = null;
    this.d8w_1 = null;
    this.e8w_1 = null;
    this.f8w_1 = null;
    if (!(cellContainer == null)) {
      attach$default(this, cellContainer);
    }
  }
  protoOf(BaseCell).s8x = function () {
    return this.a8w_1;
  };
  protoOf(BaseCell).q90 = function () {
    return false;
  };
  protoOf(BaseCell).f89 = function () {
    return !(this.s8x() == null);
  };
  protoOf(BaseCell).m92 = function () {
    return this.n92(get_VISIBLE());
  };
  protoOf(BaseCell).o92 = function () {
    return this.n92(get_FOCUS_HIGHLIGHTED());
  };
  protoOf(BaseCell).p92 = function () {
    return this.n92(get_FOCUSABLE());
  };
  protoOf(BaseCell).bp = function () {
    return this.b8w_1;
  };
  protoOf(BaseCell).o35 = function () {
    return this.q92();
  };
  protoOf(BaseCell).q92 = function () {
    return new ExternalChildList(this);
  };
  protoOf(BaseCell).p35 = function () {
    return this.c8w_1;
  };
  protoOf(BaseCell).s35 = function () {
    return this.d8w_1;
  };
  protoOf(BaseCell).y35 = function () {
    var tmp0_safe_receiver = this.z8v_1;
    return tmp0_safe_receiver == null ? null : first(tmp0_safe_receiver);
  };
  protoOf(BaseCell).z35 = function () {
    var tmp0_safe_receiver = this.z8v_1;
    return tmp0_safe_receiver == null ? null : last(tmp0_safe_receiver);
  };
  protoOf(BaseCell).r92 = function (event, spec) {
    var ctx = Companion_instance_149.s92(this);
    event.m8i(ctx);
    dispatch_0(Companion_instance_148, ctx.t92_1, 0, event, spec);
  };
  protoOf(BaseCell).u92 = function (event, spec) {
    var ctx = Companion_instance_149.s92(this);
    event.m8i(ctx);
    dispatch_1(Companion_instance_148, ctx.t92_1, 0, event, spec);
  };
  protoOf(BaseCell).v92 = function (derivedEvent, spec) {
    var tmp = derivedEvent.b8j_1.k8i_1;
    var context = (tmp == null ? true : tmp instanceof CellEventContext) ? tmp : THROW_CCE();
    $l$block: {
      // Inline function 'kotlin.requireNotNull' call
      if (context == null) {
        var message = 'Event context is not found in ' + toString_1(derivedEvent.b8j_1);
        throw IllegalArgumentException_init_$Create$_0(toString_1(message));
      } else {
        break $l$block;
      }
    }
    derivedEvent.m8i(context);
    var path = context.t92_1;
    var start = path.w(this);
    // Inline function 'kotlin.check' call
    if (!!(start === -1)) {
      var message_0 = this.toString() + ' is not found in the bubbling path ' + toString_1(path);
      throw IllegalStateException_init_$Create$_0(toString_1(message_0));
    }
    dispatch_1(Companion_instance_148, path, start, derivedEvent, spec);
  };
  protoOf(BaseCell).w92 = function (trait) {
    this.y8v_1.b2m(trait);
    trait.o91(this);
    // Inline function 'jetbrains.ocelot.base.disposable.toDisposable' call
    return new BaseCell$addTrait$$inlined$toDisposable$1(this, trait);
  };
  protoOf(BaseCell).x92 = function () {
    return new BaseCell$cellContainer$1(this);
  };
  protoOf(BaseCell).y92 = function () {
    return this.n92(get_FOCUSED());
  };
  protoOf(BaseCell).s8n = function () {
    // Inline function 'kotlin.check' call
    if (!canFocus(this)) {
      var message = "this: '" + this.toString() + "', focusable: '" + this.p92().w2w() + "', container: '" + toString_0(this.s8x()) + "', visible: " + this.m92().w2w();
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    ensureNotNull(this.s8x()).z92().d2x(this);
  };
  protoOf(BaseCell).a93 = function (rectSupplier) {
    return get_peer(this).b93(rectSupplier, this);
  };
  protoOf(BaseCell).y90 = function (cellListener) {
    if (this.f8w_1 == null) {
      this.f8w_1 = new Listeners();
    }
    return ensureNotNull(this.f8w_1).j2s(cellListener);
  };
  protoOf(BaseCell).k91 = function (prop) {
    var properties = this.e8w_1;
    var tmp;
    if (properties == null || !properties.o2(prop)) {
      tmp = getDefaultValue(this, prop);
    } else {
      var tmp_0 = properties.q2(prop);
      tmp = (tmp_0 == null ? true : !(tmp_0 == null)) ? tmp_0 : THROW_CCE();
    }
    return tmp;
  };
  protoOf(BaseCell).i90 = function (prop, value) {
    var old = this.k91(prop);
    if (equals(value, old)) {
      return Companion_getInstance_29().m2l_1;
    }
    var event = new PropertyChangeEvent(old, value);
    beforePropertySet(this, prop, event);
    if (equals(value, getDefaultValue(this, prop))) {
      ensureNotNull(this.e8w_1).u2(prop);
      if (ensureNotNull(this.e8w_1).w2m()) {
        this.e8w_1 = null;
      }
    } else {
      if (this.e8w_1 == null) {
        this.e8w_1 = new ListMap();
      }
      ensureNotNull(this.e8w_1).t2(prop, value);
    }
    firePropertyChange(this, prop, event);
    // Inline function 'jetbrains.ocelot.base.disposable.toDisposable' call
    return new BaseCell$set$$inlined$toDisposable$1(this, prop, old);
  };
  protoOf(BaseCell).c93 = function (prop) {
    var tmp0_elvis_lhs = this.d93(prop);
    return tmp0_elvis_lhs == null ? prop.b90(this) : tmp0_elvis_lhs;
  };
  protoOf(BaseCell).d93 = function (prop) {
    var _iterator__ex2g4s = this.y8v_1.m();
    while (_iterator__ex2g4s.n()) {
      var trait = _iterator__ex2g4s.o();
      var result = trait.n91(this, prop);
      if (!(result == null)) {
        return !(result == null) ? result : THROW_CCE();
      }
    }
    return null;
  };
  protoOf(BaseCell).n92 = function (cellPropSpec) {
    return new BaseCell$getProp$MyProperty(this, cellPropSpec);
  };
  protoOf(BaseCell).d90 = function () {
    var properties = this.e8w_1;
    var tmp;
    if (properties == null) {
      tmp = emptyList();
    } else {
      var result = null;
      var _iterator__ex2g4s = get_POPUP_SPECS().m();
      while (_iterator__ex2g4s.n()) {
        var ps = _iterator__ex2g4s.o();
        var tmp_0 = properties.q2(ps);
        var cell = (tmp_0 == null ? true : isInterface(tmp_0, Cell)) ? tmp_0 : THROW_CCE();
        if (!(cell == null)) {
          if (result == null) {
            result = ArrayList_init_$Create$();
          }
          result.j(cell);
        }
      }
      // Inline function 'kotlin.collections.orEmpty' call
      var tmp0_elvis_lhs = result;
      tmp = tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
    }
    return tmp;
  };
  protoOf(BaseCell).r3p = function () {
    var parent = this.b8w_1;
    // Inline function 'kotlin.checkNotNull' call
    $l$block: {
      // Inline function 'kotlin.checkNotNull' call
      if (parent == null) {
        var message = 'Required value was null.';
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      } else {
        break $l$block;
      }
    }
    var parentCell = get_asBaseCell(parent);
    if (!(parentCell.z8v_1 == null) && ensureNotNull(parentCell.z8v_1).t(this)) {
      parentCell.o35().h2(this);
      return Unit_instance;
    }
    var _iterator__ex2g4s = get_POPUP_SPECS().m();
    while (_iterator__ex2g4s.n()) {
      var popupSpec = _iterator__ex2g4s.o();
      if (parentCell.k91(popupSpec) === this) {
        parentCell.i90(popupSpec, null);
        return Unit_instance;
      }
    }
    throw IllegalStateException_init_$Create$();
  };
  protoOf(BaseCell).w8z = function (prop, event) {
  };
  protoOf(BaseCell).v8x = function (event) {
  };
  protoOf(BaseCell).u8x = function (event) {
  };
  protoOf(BaseCell).g93 = function (traitPropSpec, value) {
    var trait = new BaseCell$set$trait$1(traitPropSpec, value);
    return this.w92(trait);
  };
  protoOf(BaseCell).toString = function () {
    var className = getKClassFromExpression(this).ra();
    return plus_12(className, '@') + toString_3(hashCode(this), 16);
  };
  function get_asBaseCell(_this__u8e3s4) {
    return _this__u8e3s4 instanceof BaseCell ? _this__u8e3s4 : THROW_CCE();
  }
  function get_asBaseCellInternal(_this__u8e3s4) {
    return isInterface(_this__u8e3s4, BaseCellInternal) ? _this__u8e3s4 : THROW_CCE();
  }
  function BaseCellInternal() {
  }
  function canFocus(_this__u8e3s4) {
    return _this__u8e3s4.p92().w2w() && _this__u8e3s4.f89() && _this__u8e3s4.m92().w2w();
  }
  function Cell() {
  }
  function get_EMPTY_CELL_ACTION() {
    _init_properties_CellAction_kt__xjo07s();
    return EMPTY_CELL_ACTION;
  }
  var EMPTY_CELL_ACTION;
  function seqActions(actions) {
    _init_properties_CellAction_kt__xjo07s();
    return seqActions$lambda(actions);
  }
  function EMPTY_CELL_ACTION$lambda() {
    _init_properties_CellAction_kt__xjo07s();
    return Unit_instance;
  }
  function seqActions$lambda($actions) {
    return function () {
      var indexedObject = $actions;
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var action = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        action();
      }
      return Unit_instance;
    };
  }
  var properties_initialized_CellAction_kt_muc5ae;
  function _init_properties_CellAction_kt__xjo07s() {
    if (!properties_initialized_CellAction_kt_muc5ae) {
      properties_initialized_CellAction_kt_muc5ae = true;
      EMPTY_CELL_ACTION = EMPTY_CELL_ACTION$lambda;
    }
  }
  function get_asCellContainerInternal(_this__u8e3s4) {
    return isInterface(_this__u8e3s4, CellContainerInternal) ? _this__u8e3s4 : THROW_CCE();
  }
  function CellContainerInternal() {
  }
  function CellContainerListener() {
  }
  function CellContainerPeer() {
  }
  function comes(_this__u8e3s4, from, to) {
    var tmp = _this__u8e3s4.k8i_1;
    var tmp0_elvis_lhs = (tmp == null ? true : tmp instanceof CellEventContext) ? tmp : THROW_CCE();
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var context = tmp_0;
    var path = context.t92_1;
    var i = path.w(from);
    var j = path.w(to);
    return i >= 0 && j >= 0 && i < j;
  }
  function Companion_149() {
  }
  protoOf(Companion_149).s92 = function (source) {
    var path = toList_2(ancestorsFrom(source));
    return new CellEventContext(path);
  };
  var Companion_instance_149;
  function Companion_getInstance_149() {
    return Companion_instance_149;
  }
  function CellEventContext(bubblingPath) {
    this.t92_1 = bubblingPath;
  }
  function CellListener() {
  }
  function get_origin(_this__u8e3s4) {
    return get_bounds(_this__u8e3s4).b8c_1;
  }
  function get_bounds(_this__u8e3s4) {
    return get_peer(_this__u8e3s4).q93(_this__u8e3s4);
  }
  function get_peer(_this__u8e3s4) {
    var container = _this__u8e3s4.s8x();
    $l$block: {
      // Inline function 'kotlin.checkNotNull' call
      if (container == null) {
        var message = 'Cell ' + toString_1(_this__u8e3s4) + ' is not attached to cell container';
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      } else {
        break $l$block;
      }
    }
    return container.w93();
  }
  function get_dimension(_this__u8e3s4) {
    return get_bounds(_this__u8e3s4).c8c_1;
  }
  function CellPropertySpec_init_$Init$(name, defaultValue, $this) {
    CellPropertySpec.call($this, name, CellPropertySpec$_init_$lambda_vr6ec9(defaultValue));
    return $this;
  }
  function CellPropertySpec_init_$Create$(name, defaultValue) {
    return CellPropertySpec_init_$Init$(name, defaultValue, objectCreate(protoOf(CellPropertySpec)));
  }
  function CellPropertySpec$_init_$lambda_vr6ec9($defaultValue) {
    return function (it) {
      return $defaultValue;
    };
  }
  function CellPropertySpec(name, defaultValueFun) {
    this.z8z_1 = name;
    this.a90_1 = defaultValueFun;
  }
  protoOf(CellPropertySpec).toString = function () {
    return this.z8z_1;
  };
  protoOf(CellPropertySpec).b90 = function (cell) {
    return this.a90_1(cell);
  };
  function get_POPUP_Z_ADJUSTMENT() {
    _init_properties_CellPropertySpecs_kt__dnqpvz();
    return POPUP_Z_ADJUSTMENT;
  }
  var POPUP_Z_ADJUSTMENT;
  function get_POPUP_X_POSITION() {
    _init_properties_CellPropertySpecs_kt__dnqpvz();
    return POPUP_X_POSITION;
  }
  var POPUP_X_POSITION;
  function get_HAS_POPUP_DECORATION() {
    _init_properties_CellPropertySpecs_kt__dnqpvz();
    return HAS_POPUP_DECORATION;
  }
  var HAS_POPUP_DECORATION;
  function get_HOVERED() {
    _init_properties_CellPropertySpecs_kt__dnqpvz();
    return HOVERED;
  }
  var HOVERED;
  function get_FOCUSED() {
    _init_properties_CellPropertySpecs_kt__dnqpvz();
    return FOCUSED;
  }
  var FOCUSED;
  function get_VISIBLE() {
    _init_properties_CellPropertySpecs_kt__dnqpvz();
    return VISIBLE;
  }
  var VISIBLE;
  function get_SELECTED() {
    _init_properties_CellPropertySpecs_kt__dnqpvz();
    return SELECTED;
  }
  var SELECTED;
  function get_FOCUS_HIGHLIGHTED() {
    _init_properties_CellPropertySpecs_kt__dnqpvz();
    return FOCUS_HIGHLIGHTED;
  }
  var FOCUS_HIGHLIGHTED;
  function get_PAIR_HIGHLIGHTED() {
    _init_properties_CellPropertySpecs_kt__dnqpvz();
    return PAIR_HIGHLIGHTED;
  }
  var PAIR_HIGHLIGHTED;
  function get_FOCUSABLE() {
    _init_properties_CellPropertySpecs_kt__dnqpvz();
    return FOCUSABLE;
  }
  var FOCUSABLE;
  function get_BACKGROUND() {
    _init_properties_CellPropertySpecs_kt__dnqpvz();
    return BACKGROUND;
  }
  var BACKGROUND;
  function get_BORDER() {
    _init_properties_CellPropertySpecs_kt__dnqpvz();
    return BORDER;
  }
  var BORDER;
  function get_HAS_SHADOW() {
    _init_properties_CellPropertySpecs_kt__dnqpvz();
    return HAS_SHADOW;
  }
  var HAS_SHADOW;
  function get_RED_UNDERLINE() {
    _init_properties_CellPropertySpecs_kt__dnqpvz();
    return RED_UNDERLINE;
  }
  var RED_UNDERLINE;
  function get_YELLOW_UNDERLINE() {
    _init_properties_CellPropertySpecs_kt__dnqpvz();
    return YELLOW_UNDERLINE;
  }
  var YELLOW_UNDERLINE;
  function get_LINK() {
    _init_properties_CellPropertySpecs_kt__dnqpvz();
    return LINK;
  }
  var LINK;
  function get_background(_this__u8e3s4) {
    _init_properties_CellPropertySpecs_kt__dnqpvz();
    return _this__u8e3s4.n92(get_BACKGROUND());
  }
  function get_selected(_this__u8e3s4) {
    _init_properties_CellPropertySpecs_kt__dnqpvz();
    return _this__u8e3s4.n92(get_SELECTED());
  }
  function get_hasShadow(_this__u8e3s4) {
    _init_properties_CellPropertySpecs_kt__dnqpvz();
    return _this__u8e3s4.n92(get_HAS_SHADOW());
  }
  function get_border(_this__u8e3s4) {
    _init_properties_CellPropertySpecs_kt__dnqpvz();
    return _this__u8e3s4.n92(get_BORDER());
  }
  var properties_initialized_CellPropertySpecs_kt_q8gzf5;
  function _init_properties_CellPropertySpecs_kt__dnqpvz() {
    if (!properties_initialized_CellPropertySpecs_kt_q8gzf5) {
      properties_initialized_CellPropertySpecs_kt_q8gzf5 = true;
      POPUP_Z_ADJUSTMENT = CellPropertySpec_init_$Create$('popupZ', 0);
      POPUP_X_POSITION = CellPropertySpec_init_$Create$('popupXPosition', 0);
      HAS_POPUP_DECORATION = CellPropertySpec_init_$Create$('popupDecoration', false);
      HOVERED = CellPropertySpec_init_$Create$('hovered', false);
      FOCUSED = CellPropertySpec_init_$Create$('focused', false);
      VISIBLE = CellPropertySpec_init_$Create$('visible', true);
      SELECTED = CellPropertySpec_init_$Create$('selected', false);
      FOCUS_HIGHLIGHTED = CellPropertySpec_init_$Create$('focusHighlighted', false);
      PAIR_HIGHLIGHTED = CellPropertySpec_init_$Create$('pairHighlighted', false);
      FOCUSABLE = CellPropertySpec_init_$Create$('focusable', false);
      BACKGROUND = CellPropertySpec_init_$Create$('background', null);
      BORDER = CellPropertySpec_init_$Create$('border', null);
      HAS_SHADOW = CellPropertySpec_init_$Create$('hasShadow', false);
      RED_UNDERLINE = CellPropertySpec_init_$Create$('redUnderline', false);
      YELLOW_UNDERLINE = CellPropertySpec_init_$Create$('yellowUnderline', false);
      LINK = CellPropertySpec_init_$Create$('link', false);
    }
  }
  function isDescendantCellFocused(_this__u8e3s4) {
    var cellContainer = _this__u8e3s4.s8x();
    var tmp;
    if (cellContainer == null) {
      tmp = false;
    } else {
      var focusedCell = cellContainer.z92().uv();
      tmp = (!(focusedCell == null) && isDescendant(_this__u8e3s4, focusedCell));
    }
    return tmp;
  }
  function Hints() {
    Hints_instance = this;
    this.x93_1 = CellTraitPropertySpec_init_$Create$('hideOutOfViewportHint', false);
  }
  var Hints_instance;
  function Hints_getInstance() {
    if (Hints_instance == null)
      new Hints();
    return Hints_instance;
  }
  function HorizontalCell() {
    LayoutCell.call(this);
  }
  function Companion_150() {
    Companion_instance_150 = this;
    this.i94_1 = CellPropertySpec_init_$Create$('crossAlignment', Alignment_STRETCH_getInstance());
    this.j94_1 = CellPropertySpec_init_$Create$('itemAlignment', Alignment_STRETCH_getInstance());
    this.k94_1 = CellPropertySpec_init_$Create$('flexWrap', false);
    this.l94_1 = CellPropertySpec_init_$Create$('justifyContent', false);
  }
  var Companion_instance_150;
  function Companion_getInstance_150() {
    if (Companion_instance_150 == null)
      new Companion_150();
    return Companion_instance_150;
  }
  function LayoutCell() {
    Companion_getInstance_150();
    BaseCell_init_$Init$(this);
  }
  protoOf(LayoutCell).g94 = function () {
    return this.n92(Companion_getInstance_150().i94_1);
  };
  protoOf(LayoutCell).h94 = function () {
    return this.n92(Companion_getInstance_150().l94_1);
  };
  function get_itemAlignment(_this__u8e3s4) {
    return _this__u8e3s4.n92(Companion_getInstance_150().j94_1);
  }
  function Companion_151() {
    Companion_instance_151 = this;
    this.m94_1 = CellTraitPropertySpec_init_$Create$('popupSpec', null);
  }
  var Companion_instance_151;
  function Companion_getInstance_151() {
    if (Companion_instance_151 == null)
      new Companion_151();
    return Companion_instance_151;
  }
  function PopupSpec() {
  }
  function get_isRootCell(_this__u8e3s4) {
    var cell = _this__u8e3s4;
    var container = cell == null ? null : cell.s8x();
    return !(container == null) && equals(container.t42(), cell);
  }
  function scrollDown($this, cell) {
    return scroll($this, cell, 1);
  }
  function scrollUp($this, cell) {
    return scroll($this, cell, -1);
  }
  function scroll($this, cell, direction) {
    if (!cell.k91(Companion_getInstance_153().t94_1)) {
      return false;
    }
    var scroll = get_peer(cell).r93(cell);
    get_peer(cell).s93(cell, new Vector(0, scroll.e8c_1 + imul(direction, get_dimension(cell).e8c_1) | 0));
    return true;
  }
  function doAdjustDimension($this, scrollCell, dimension, viewport) {
    var dimLimit = scrollCell.k91(Companion_getInstance_153().r94_1);
    var widthLimit = dimLimit.d8c_1;
    var heightLimit = dimLimit.e8c_1;
    var width = dimension.d8c_1;
    var height = dimension.e8c_1;
    var changeDimension = false;
    if (height > heightLimit) {
      height = heightLimit;
      changeDimension = true;
    }
    if (width > widthLimit) {
      width = widthLimit;
      changeDimension = true;
    }
    var changeMaxDimension = false;
    if (viewport.e8c_1 < height) {
      heightLimit = viewport.e8c_1;
      height = viewport.e8c_1;
      changeMaxDimension = true;
    }
    if (viewport.d8c_1 < width) {
      widthLimit = viewport.d8c_1;
      width = viewport.d8c_1;
      changeMaxDimension = true;
    }
    var tmp;
    if (changeMaxDimension) {
      setMaxDimension($this, scrollCell, new Vector(widthLimit, heightLimit));
      tmp = new Vector(width, height);
    } else {
      relaxMaxDimension($this, scrollCell, viewport);
      var tmp_0;
      if (changeDimension) {
        tmp_0 = new Vector(width, height);
      } else {
        tmp_0 = dimension;
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  function setMaxDimension($this, cell, newValue) {
    if (cell.k91(Companion_getInstance_152().v94_1) == null) {
      cell.i90(Companion_getInstance_152().v94_1, cell.k91(Companion_getInstance_153().r94_1));
    }
    cell.i90(Companion_getInstance_153().r94_1, newValue);
  }
  function relaxMaxDimension($this, cell, viewport) {
    var tmp0_elvis_lhs = cell.k91(Companion_getInstance_152().v94_1);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var originalMaxDimension = tmp;
    if (originalMaxDimension.d8c_1 <= viewport.d8c_1 && originalMaxDimension.e8c_1 <= viewport.e8c_1) {
      cell.i90(Companion_getInstance_152().v94_1, null);
      cell.i90(Companion_getInstance_153().r94_1, originalMaxDimension);
    } else {
      var tmp0 = originalMaxDimension.d8c_1;
      // Inline function 'kotlin.math.min' call
      var b = viewport.d8c_1;
      var w = Math.min(tmp0, b);
      var tmp0_0 = originalMaxDimension.e8c_1;
      // Inline function 'kotlin.math.min' call
      var b_0 = viewport.e8c_1;
      var h = Math.min(tmp0_0, b_0);
      cell.i90(Companion_getInstance_153().r94_1, new Vector(w, h));
    }
  }
  function Companion_152() {
    Companion_instance_152 = this;
    this.v94_1 = CellPropertySpec_init_$Create$('originalMaxDimension', null);
  }
  var Companion_instance_152;
  function Companion_getInstance_152() {
    if (Companion_instance_152 == null)
      new Companion_152();
    return Companion_instance_152;
  }
  function adjustScroll($this, dimension) {
    var content = $this.y35();
    if (!(content == null)) {
      var contentDim = get_dimension(content);
      var scroll = contentDim.e8c_1 > dimension.e8c_1 || contentDim.d8c_1 > dimension.d8c_1;
      $this.i90(Companion_getInstance_153().t94_1, scroll);
    }
  }
  function ScrollTrait() {
    CellTrait.call(this);
    this.w94_1 = new ScrollPopupSpec();
  }
  protoOf(ScrollTrait).n91 = function (cell, spec) {
    var tmp;
    if (spec === Companion_getInstance_151().m94_1) {
      tmp = this.w94_1;
    } else {
      tmp = protoOf(CellTrait).n91.call(this, cell, spec);
    }
    return tmp;
  };
  protoOf(ScrollTrait).s8z = function (cell, event) {
    if (event.m8j(Key_PAGE_DOWN_getInstance(), [])) {
      if (scrollDown(this, cell)) {
        event.n8i();
        return Unit_instance;
      }
    } else if (event.m8j(Key_PAGE_UP_getInstance(), [])) {
      if (scrollUp(this, cell)) {
        event.n8i();
        return Unit_instance;
      }
    }
    protoOf(CellTrait).s8z.call(this, cell, event);
  };
  function ScrollPopupSpec() {
    Companion_getInstance_152();
  }
  protoOf(ScrollPopupSpec).q94 = function (cell) {
    return false;
  };
  protoOf(ScrollPopupSpec).p94 = function (cell, popup) {
  };
  protoOf(ScrollPopupSpec).o94 = function (cell, dimension, viewport, alignedWidth) {
    var scrollCell = cell instanceof ScrollCell ? cell : THROW_CCE();
    var adjustedDim = doAdjustDimension(this, scrollCell, dimension, viewport);
    adjustScroll(scrollCell, adjustedDim);
    return adjustedDim;
  };
  function Companion_153() {
    Companion_instance_153 = this;
    this.r94_1 = CellPropertySpec_init_$Create$('maxDimension', Companion_getInstance_136().h8c_1);
    this.s94_1 = CellPropertySpec_init_$Create$('scrollRoot', false);
    this.t94_1 = CellPropertySpec_init_$Create$('hasVerticalScroll', false);
    this.u94_1 = new ScrollTrait();
  }
  var Companion_instance_153;
  function Companion_getInstance_153() {
    if (Companion_instance_153 == null)
      new Companion_153();
    return Companion_instance_153;
  }
  function ScrollCell() {
    Companion_getInstance_153();
    BaseCell_init_$Init$(this);
    this.w92(Companion_getInstance_153().u94_1);
  }
  protoOf(ScrollCell).f95 = function () {
    return this.n92(Companion_getInstance_153().r94_1);
  };
  protoOf(ScrollCell).g95 = function () {
    return this.n92(Companion_getInstance_153().t94_1);
  };
  function scrollToAsync(_this__u8e3s4) {
    return _this__u8e3s4.a93(scrollToAsync$lambda(_this__u8e3s4));
  }
  function scrollTo_0(_this__u8e3s4) {
    return scrollTo_1(_this__u8e3s4, scrollTo$lambda(_this__u8e3s4));
  }
  function scrollTo_1(_this__u8e3s4, rectSupplier) {
    return get_peer(_this__u8e3s4).t93(rectSupplier, _this__u8e3s4);
  }
  function scrollTo_2(_this__u8e3s4, rect) {
    return scrollTo_1(_this__u8e3s4, scrollTo$lambda_0(rect));
  }
  function scrollToAsync$lambda($this_scrollToAsync) {
    return function () {
      return new Rectangle(Companion_getInstance_136().h8c_1, get_dimension($this_scrollToAsync));
    };
  }
  function scrollTo$lambda($this_scrollTo) {
    return function () {
      return new Rectangle(Companion_getInstance_136().h8c_1, get_dimension($this_scrollTo));
    };
  }
  function scrollTo$lambda_0($rect) {
    return function () {
      return $rect;
    };
  }
  function TextCell$Companion$SELECTION_END$lambda(cell) {
    return cell.k91(Companion_getInstance_154().e8x_1);
  }
  function TextCell_init_$Init$($this) {
    BaseCell_init_$Init$($this);
    TextCell.call($this);
    return $this;
  }
  function TextCell_init_$Create$() {
    return TextCell_init_$Init$(objectCreate(protoOf(TextCell)));
  }
  function TextCell_init_$Init$_0(text, $this) {
    BaseCell_init_$Init$($this);
    TextCell.call($this);
    $this.o8w().d2x(text);
    return $this;
  }
  function TextCell_init_$Create$_0(text) {
    return TextCell_init_$Init$_0(text, objectCreate(protoOf(TextCell)));
  }
  function Selection(from, to) {
    this.h95_1 = from;
    this.i95_1 = to;
  }
  function Companion_154() {
    Companion_instance_154 = this;
    this.a8x_1 = new Font(Companion_getInstance_211().j95_1, 14);
    this.b8x_1 = CellPropertySpec_init_$Create$('text', '');
    this.c8x_1 = CellPropertySpec_init_$Create$('textColor', Companion_getInstance_210().o95_1);
    this.d8x_1 = CellPropertySpec_init_$Create$('caretVisible', false);
    this.e8x_1 = CellPropertySpec_init_$Create$('caretPosition', 0);
    this.f8x_1 = CellPropertySpec_init_$Create$('fontFamily', this.a8x_1.o96_1);
    this.g8x_1 = CellPropertySpec_init_$Create$('bold', this.a8x_1.q96_1);
    this.h8x_1 = CellPropertySpec_init_$Create$('italic', this.a8x_1.r96_1);
    this.i8x_1 = CellPropertySpec_init_$Create$('fontSize', this.a8x_1.p96_1);
    this.j8x_1 = CellPropertySpec_init_$Create$('selectionVisible', false);
    this.k8x_1 = CellPropertySpec_init_$Create$('selectionStart', 0);
    var tmp = this;
    tmp.l8x_1 = new CellPropertySpec('selectionEnd', TextCell$Companion$SELECTION_END$lambda);
    this.m8x_1 = CellPropertySpec_init_$Create$('textDecorations', emptySet());
    this.n8x_1 = CellPropertySpec_init_$Create$('textStyleRegions', emptyList());
  }
  var Companion_instance_154;
  function Companion_getInstance_154() {
    if (Companion_instance_154 == null)
      new Companion_154();
    return Companion_instance_154;
  }
  protoOf(TextCell).q90 = function () {
    return true;
  };
  protoOf(TextCell).s96 = function () {
    var text = this.o8w().uv();
    return take_1(text, this.t96().uv());
  };
  protoOf(TextCell).u96 = function () {
    var text = this.o8w().uv();
    return substring_0(text, this.t96().uv());
  };
  protoOf(TextCell).v96 = function () {
    return this.t96().uv() === this.w96();
  };
  protoOf(TextCell).x96 = function () {
    return this.t96().uv() === 0;
  };
  protoOf(TextCell).w2m = function () {
    return this.w96() === 0;
  };
  protoOf(TextCell).y96 = function () {
    var offset = this.z96(this.t96().uv());
    return Rectangle_init_$Create$(offset, 0, 0, get_dimension(this).e8c_1).i8c(get_origin(this));
  };
  protoOf(TextCell).a97 = function () {
    var start = this.k91(Companion_getInstance_154().k8x_1);
    var end = this.k91(Companion_getInstance_154().l8x_1);
    // Inline function 'kotlin.math.min' call
    var from = Math.min(start, end);
    // Inline function 'kotlin.math.max' call
    var to = Math.max(start, end);
    return new Selection(from, to);
  };
  protoOf(TextCell).o8w = function () {
    return this.n92(Companion_getInstance_154().b8x_1);
  };
  protoOf(TextCell).b97 = function () {
    return this.n92(Companion_getInstance_154().c8x_1);
  };
  protoOf(TextCell).c97 = function () {
    return this.n92(Companion_getInstance_154().d8x_1);
  };
  protoOf(TextCell).d97 = function () {
    return this.n92(Companion_getInstance_154().g8x_1);
  };
  protoOf(TextCell).e97 = function () {
    return this.n92(Companion_getInstance_154().h8x_1);
  };
  protoOf(TextCell).f97 = function () {
    return this.n92(Companion_getInstance_154().f8x_1);
  };
  protoOf(TextCell).g97 = function () {
    return this.n92(Companion_getInstance_154().i8x_1);
  };
  protoOf(TextCell).t96 = function () {
    return this.n92(Companion_getInstance_154().e8x_1);
  };
  protoOf(TextCell).h97 = function () {
    return this.n92(Companion_getInstance_154().j8x_1);
  };
  protoOf(TextCell).i97 = function () {
    return this.n92(Companion_getInstance_154().k8x_1);
  };
  protoOf(TextCell).j97 = function () {
    return this.n92(Companion_getInstance_154().l8x_1);
  };
  protoOf(TextCell).k97 = function () {
    return this.n92(Companion_getInstance_154().m8x_1);
  };
  protoOf(TextCell).l97 = function () {
    return this.n92(Companion_getInstance_154().n8x_1);
  };
  protoOf(TextCell).w96 = function () {
    return this.o8w().uv().length;
  };
  protoOf(TextCell).m97 = function (x) {
    return get_peer(this).o93(this, x);
  };
  protoOf(TextCell).z96 = function (caret) {
    return get_peer(this).p93(this, caret);
  };
  protoOf(TextCell).toString = function () {
    var value = this.o8w().uv();
    var hashCodeStr = toString_3(hashCode(this), 16);
    return "TextCell('" + value + "')@" + hashCodeStr;
  };
  function TextCell() {
    Companion_getInstance_154();
  }
  function Companion_155() {
    Companion_instance_155 = this;
    this.n97_1 = CellPropertySpec_init_$Create$('widthChars', 0);
    this.o97_1 = CellPropertySpec_init_$Create$('heightLines', 0);
  }
  var Companion_instance_155;
  function Companion_getInstance_155() {
    if (Companion_instance_155 == null)
      new Companion_155();
    return Companion_instance_155;
  }
  function TextPlaceholderCell() {
    Companion_getInstance_155();
    BaseCell_init_$Init$(this);
  }
  protoOf(TextPlaceholderCell).x97 = function () {
    return this.n92(Companion_getInstance_155().n97_1);
  };
  protoOf(TextPlaceholderCell).y97 = function () {
    return this.n92(Companion_getInstance_155().o97_1);
  };
  function Companion_156() {
    Companion_instance_156 = this;
    this.z97_1 = CellPropertySpec_init_$Create$('indented', false);
  }
  var Companion_instance_156;
  function Companion_getInstance_156() {
    if (Companion_instance_156 == null)
      new Companion_156();
    return Companion_instance_156;
  }
  function VerticalCell() {
    Companion_getInstance_156();
    LayoutCell.call(this);
  }
  protoOf(VerticalCell).i98 = function () {
    return this.n92(Companion_getInstance_156().z97_1);
  };
  function workStarted_0($this, _this__u8e3s4) {
    var tmp0_safe_receiver = _this__u8e3s4.s8x();
    if (tmp0_safe_receiver == null)
      null;
    else {
      notifyStart($this, tmp0_safe_receiver);
    }
    listenForAttachDetach($this, _this__u8e3s4);
  }
  function workFinished_0($this, _this__u8e3s4) {
    ensureNotNull(_this__u8e3s4.k91($this.l98_1)).zr();
    _this__u8e3s4.i90($this.l98_1, null);
    var tmp0_safe_receiver = _this__u8e3s4.s8x();
    if (tmp0_safe_receiver == null)
      null;
    else {
      notifyFinish($this, tmp0_safe_receiver);
    }
    var tmp1_safe_receiver = _this__u8e3s4.k91($this.k98_1);
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s = tmp1_safe_receiver.m();
      while (_iterator__ex2g4s.n()) {
        var element = _iterator__ex2g4s.o();
        element();
      }
    }
    _this__u8e3s4.i90($this.k98_1, null);
  }
  function listenForAttachDetach($this, _this__u8e3s4) {
    var tmp = _this__u8e3s4.x92();
    _this__u8e3s4.i90($this.l98_1, tmp.z2r(AmountOfWorkInProgress$listenForAttachDetach$lambda));
  }
  function notifyStart($this, _this__u8e3s4) {
    return AsyncWorkNotifier_getInstance().o98(_this__u8e3s4);
  }
  function notifyFinish($this, _this__u8e3s4) {
    return AsyncWorkNotifier_getInstance().p98(_this__u8e3s4);
  }
  function AmountOfWorkInProgress$listenForAttachDetach$lambda(event) {
    var tmp0_safe_receiver = event.s2y_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      notifyFinish(AmountOfWorkInProgress_getInstance(), tmp0_safe_receiver);
    }
    var tmp1_safe_receiver = event.t2y_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      notifyStart(AmountOfWorkInProgress_getInstance(), tmp1_safe_receiver);
    }
    return Unit_instance;
  }
  function AmountOfWorkInProgress() {
    AmountOfWorkInProgress_instance = this;
    this.j98_1 = CellPropertySpec_init_$Create$('numberOfActivities', 0);
    this.k98_1 = CellPropertySpec_init_$Create$('readyActions', null);
    this.l98_1 = CellPropertySpec_init_$Create$('attachListener', null);
  }
  protoOf(AmountOfWorkInProgress).q98 = function (cell) {
    var num = cell.k91(this.j98_1);
    if (num === 0) {
      workStarted_0(this, cell);
    }
    num = num + 1 | 0;
    cell.i90(this.j98_1, num);
  };
  protoOf(AmountOfWorkInProgress).r98 = function (cell) {
    var num = cell.k91(this.j98_1);
    // Inline function 'kotlin.check' call
    if (!!(num === 0)) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    num = num - 1 | 0;
    cell.i90(this.j98_1, num);
    if (num === 0) {
      workFinished_0(this, cell);
    }
  };
  protoOf(AmountOfWorkInProgress).s98 = function (cell) {
    return cell.k91(this.j98_1) > 0;
  };
  protoOf(AmountOfWorkInProgress).t98 = function (cell, action) {
    // Inline function 'kotlin.check' call
    if (!this.s98(cell)) {
      var message = 'whenReady() must be called only when cell has work in progress';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    var tmp0_elvis_lhs = cell.k91(this.k98_1);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.also' call
      var this_0 = ArrayList_init_$Create$();
      cell.i90(AmountOfWorkInProgress_getInstance().k98_1, this_0);
      tmp = this_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var list = tmp;
    list.j(action);
  };
  var AmountOfWorkInProgress_instance;
  function AmountOfWorkInProgress_getInstance() {
    if (AmountOfWorkInProgress_instance == null)
      new AmountOfWorkInProgress();
    return AmountOfWorkInProgress_instance;
  }
  function waitForAsyncWork(_this__u8e3s4, $completion) {
    var done = CompletableDeferred();
    onAsyncWorkDone(_this__u8e3s4, waitForAsyncWork$lambda(done));
    return done.nr($completion);
  }
  function onAsyncWorkDone(_this__u8e3s4, block) {
    if (!AsyncWorkNotifier_getInstance().u98(_this__u8e3s4)) {
      block();
      return Unit_instance;
    }
    var d = {_v: null};
    var tmp = AsyncWorkNotifier_getInstance();
    d._v = tmp.v98(_this__u8e3s4, new onAsyncWorkDone$1(block, d));
  }
  function workInProgress($this, cell) {
    return cell.k91($this.n98_1) > 0;
  }
  function addListener($this, cell, listener) {
    var tmp0_elvis_lhs = cell.k91($this.m98_1);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.also' call
      var this_0 = new OurListeners(cell);
      cell.i90(AsyncWorkNotifier_getInstance().m98_1, this_0);
      tmp = this_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var listeners = tmp;
    return listeners.j2s(listener);
  }
  function inc($this, cell) {
    var num = cell.k91($this.n98_1);
    if (num === 0) {
      fire_3($this, cell, AsyncWorkNotifier$inc$lambda);
    }
    num = num + 1 | 0;
    cell.i90($this.n98_1, num);
  }
  function dec($this, cell) {
    var num = cell.k91($this.n98_1);
    // Inline function 'kotlin.check' call
    if (!!(num === 0)) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    num = num - 1 | 0;
    cell.i90($this.n98_1, num);
    if (num === 0) {
      fire_3($this, cell, AsyncWorkNotifier$dec$lambda);
    }
  }
  function fire_3($this, _this__u8e3s4, h) {
    var tmp0_safe_receiver = _this__u8e3s4.k91($this.m98_1);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      tmp0_safe_receiver.k2s(AsyncWorkNotifier$fire$lambda(h));
    }
  }
  function OurListeners(cell) {
    Listeners.call(this);
    this.x98_1 = cell;
  }
  protoOf(OurListeners).g2s = function () {
    this.x98_1.i90(AsyncWorkNotifier_getInstance().m98_1, null);
    protoOf(Listeners).g2s.call(this);
  };
  function AsyncWorkNotifier$inc$lambda(it) {
    it.f39();
    return Unit_instance;
  }
  function AsyncWorkNotifier$dec$lambda(it) {
    it.g39();
    return Unit_instance;
  }
  function AsyncWorkNotifier$fire$lambda($h) {
    return function (listener) {
      $h(listener);
      return Unit_instance;
    };
  }
  function AsyncWorkNotifier() {
    AsyncWorkNotifier_instance = this;
    this.m98_1 = CellPropertySpec_init_$Create$('workListeners', null);
    this.n98_1 = CellPropertySpec_init_$Create$('count', 0);
  }
  protoOf(AsyncWorkNotifier).u98 = function (cellContainer) {
    return workInProgress(this, cellContainer.t42());
  };
  protoOf(AsyncWorkNotifier).v98 = function (cellContainer, listener) {
    return addListener(this, cellContainer.t42(), listener);
  };
  protoOf(AsyncWorkNotifier).o98 = function (cellContainer) {
    return inc(this, cellContainer.t42());
  };
  protoOf(AsyncWorkNotifier).p98 = function (cellContainer) {
    return dec(this, cellContainer.t42());
  };
  var AsyncWorkNotifier_instance;
  function AsyncWorkNotifier_getInstance() {
    if (AsyncWorkNotifier_instance == null)
      new AsyncWorkNotifier();
    return AsyncWorkNotifier_instance;
  }
  function waitForAsyncWork$lambda($done) {
    return function () {
      $done.pu(Unit_instance);
      return Unit_instance;
    };
  }
  function onAsyncWorkDone$1($block, $d) {
    this.y98_1 = $block;
    this.z98_1 = $d;
  }
  protoOf(onAsyncWorkDone$1).g39 = function () {
    this.y98_1();
    var tmp;
    if (this.z98_1._v == null) {
      throwUninitializedPropertyAccessException('d');
    } else {
      tmp = this.z98_1._v;
    }
    tmp.zr();
  };
  function CellAsyncTracker(cell) {
    this.a99_1 = cell;
  }
  protoOf(CellAsyncTracker).f39 = function () {
    return AmountOfWorkInProgress_getInstance().q98(this.a99_1);
  };
  protoOf(CellAsyncTracker).g39 = function () {
    return AmountOfWorkInProgress_getInstance().r98(this.a99_1);
  };
  function toEndWhenSettled(_this__u8e3s4, select) {
    whenSettled(_this__u8e3s4, select, toEndWhenSettled$lambda);
  }
  function toFirstPlaceholderWhenSettled(_this__u8e3s4) {
    return toFirstPlaceholderWhenSettled$lambda(_this__u8e3s4);
  }
  function actionWhenSettled(_this__u8e3s4, action) {
    return actionWhenSettled$lambda(_this__u8e3s4, action);
  }
  function whenSettled(_this__u8e3s4, select, action) {
    whenDescendantsReady(_this__u8e3s4, whenSettled$lambda(select, _this__u8e3s4, action));
  }
  function whenDescendantsReady(_this__u8e3s4, block) {
    var tmp = get_descendantsFrom(_this__u8e3s4);
    var d = toList_2(filter(tmp, whenDescendantsReady$lambda));
    if (d.s())
      block();
    var p = new ValueProperty(d.p());
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = d.m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      runWhenReady(element, whenDescendantsReady$lambda_0(p));
    }
    p.z2r(whenDescendantsReady$lambda_1(_this__u8e3s4, block));
  }
  function runWhenSettled(_this__u8e3s4, runnable) {
    var waitingCell = get_enclosingWaitingCell(_this__u8e3s4);
    if (waitingCell == null) {
      runnable();
    } else {
      var tmp = AmountOfWorkInProgress_getInstance();
      tmp.t98(waitingCell, runWhenSettled$lambda(runnable));
    }
  }
  function runWhenReady(_this__u8e3s4, block) {
    if (!AmountOfWorkInProgress_getInstance().s98(_this__u8e3s4)) {
      block();
    } else {
      AmountOfWorkInProgress_getInstance().t98(_this__u8e3s4, block);
    }
  }
  function get_enclosingWaitingCell(_this__u8e3s4) {
    // Inline function 'kotlin.sequences.find' call
    var tmp0 = ancestorsFrom(_this__u8e3s4);
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.sequences.firstOrNull' call
      var _iterator__ex2g4s = tmp0.m();
      while (_iterator__ex2g4s.n()) {
        var element = _iterator__ex2g4s.o();
        if (AmountOfWorkInProgress_getInstance().s98(element)) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    return tmp$ret$1;
  }
  function toEndWhenSettled$lambda(it) {
    return toEnd_0(it);
  }
  function toFirstPlaceholderWhenSettled$lambda$lambda(it) {
    var tmp0_elvis_lhs = getFirstPlaceholder(it);
    return tmp0_elvis_lhs == null ? firstFocusable(it) : tmp0_elvis_lhs;
  }
  function toFirstPlaceholderWhenSettled$lambda($this_toFirstPlaceholderWhenSettled) {
    return function () {
      toEndWhenSettled($this_toFirstPlaceholderWhenSettled, toFirstPlaceholderWhenSettled$lambda$lambda);
      return Unit_instance;
    };
  }
  function actionWhenSettled$lambda$lambda($action, $this_actionWhenSettled) {
    return function () {
      $action($this_actionWhenSettled)();
      return Unit_instance;
    };
  }
  function actionWhenSettled$lambda($this_actionWhenSettled, $action) {
    return function () {
      runWhenSettled($this_actionWhenSettled, actionWhenSettled$lambda$lambda($action, $this_actionWhenSettled));
      return Unit_instance;
    };
  }
  function whenSettled$lambda($select, $this_whenSettled, $action) {
    return function () {
      var tmp0_elvis_lhs = $select($this_whenSettled);
      var tmp;
      if (tmp0_elvis_lhs == null) {
        return Unit_instance;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var innerCell = tmp;
      // Inline function 'kotlin.check' call
      if (!isDescendant($this_whenSettled, innerCell)) {
        var message = 'select function in whenSettled must return a descendant cell';
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      }
      // Inline function 'kotlin.check' call
      if (!!AmountOfWorkInProgress_getInstance().s98(innerCell)) {
        throw IllegalStateException_init_$Create$_0('Check failed.');
      }
      $action(innerCell)();
      return Unit_instance;
    };
  }
  function whenDescendantsReady$lambda(it) {
    return AmountOfWorkInProgress_getInstance().s98(it);
  }
  function whenDescendantsReady$lambda_0($p) {
    return function () {
      var i = $p.w2w();
      $p.f2x(i - 1 | 0);
      return Unit_instance;
    };
  }
  function whenDescendantsReady$lambda_1($this_whenDescendantsReady, $block) {
    return function (event) {
      var tmp;
      if (event.t2y_1 === 0) {
        whenDescendantsReady($this_whenDescendantsReady, $block);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function runWhenSettled$lambda($runnable) {
    return function () {
      $runnable();
      return Unit_instance;
    };
  }
  function Companion_157() {
    this.b99_1 = 200;
  }
  var Companion_instance_157;
  function Companion_getInstance_157() {
    return Companion_instance_157;
  }
  function sam$jetbrains_ocelot_base_edt_EdtTask$0_2(function_0) {
    this.c99_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_2).au = function () {
    return this.c99_1();
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_2).f3 = function () {
    return this.c99_1;
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_2).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, EdtTask) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_2).hashCode = function () {
    return hashCode(this.f3());
  };
  function WaitingMapper$onAttach$lambda($properCell) {
    return function () {
      var tmp0_safe_receiver = firstFocusable($properCell);
      var hacky = tmp0_safe_receiver == null ? null : toEnd_0(tmp0_safe_receiver);
      var tmp;
      if (hacky == null) {
        tmp = null;
      } else {
        // Inline function 'kotlin.let' call
        hacky();
        tmp = Unit_instance;
      }
      if (tmp == null)
        $properCell.c93(ProjectionalSynchronizers_getInstance().d99_1)();
      return Unit_instance;
    };
  }
  function WaitingMapper$onAttach$lambda$lambda($temporaryCell) {
    return function () {
      $temporaryCell.j99();
      return Unit_instance;
    };
  }
  function WaitingMapper$onAttach$lambda$lambda_0($showProgress, $onCreate) {
    return function () {
      $showProgress.zr();
      $onCreate();
      return Unit_instance;
    };
  }
  function WaitingMapper$onAttach$lambda_0($temporaryCell, $properCell, $onCreate) {
    return function () {
      var container = $temporaryCell.i99_1.s8x();
      $temporaryCell.s8n();
      var tmp = ensureNotNull(container).m93();
      var tmp_0 = WaitingMapper$onAttach$lambda$lambda($temporaryCell);
      var showProgress = tmp.v39(200, new sam$jetbrains_ocelot_base_edt_EdtTask$0_2(tmp_0));
      whenDescendantsReady($properCell, WaitingMapper$onAttach$lambda$lambda_0(showProgress, $onCreate));
      return Unit_instance;
    };
  }
  function WaitingMapper$onAttach$lambda_1($temporaryCell, this$0, $onCreate, $properCell, $tracker) {
    return function () {
      $temporaryCell.h4();
      this$0.f86_1.g93(ProjectionalSynchronizers_getInstance().d99_1, $onCreate);
      $properCell.m92().f2x(true);
      $tracker.g39();
      return Unit_instance;
    };
  }
  function WaitingMapper(mapper) {
    Mapper.call(this, mapper.e86_1, new IndentCell());
    this.r99_1 = mapper;
  }
  protoOf(WaitingMapper).o89 = function (ctx) {
    protoOf(Mapper).o89.call(this, ctx);
    this.r89().d2x(this.r99_1);
    var properCell = this.r99_1.f86_1;
    var temporaryCell = new TemporaryCell();
    this.f86_1.o35().j(temporaryCell.i99_1);
    var tmp = this.f86_1.o35();
    // Inline function 'kotlin.apply' call
    properCell.m92().f2x(false);
    tmp.j(properCell);
    var onCreate = WaitingMapper$onAttach$lambda(properCell);
    var tmp_0 = ProjectionalSynchronizers_getInstance().d99_1;
    this.f86_1.g93(tmp_0, WaitingMapper$onAttach$lambda_0(temporaryCell, properCell, onCreate));
    var tracker = new CellAsyncTracker(this.f86_1);
    tracker.f39();
    whenDescendantsReady(properCell, WaitingMapper$onAttach$lambda_1(temporaryCell, this, onCreate, properCell, tracker));
  };
  function TemporaryCell() {
    var tmp = this;
    // Inline function 'kotlin.apply' call
    var this_0 = TextCell_init_$Create$_0('');
    this_0.p92().f2x(true);
    this_0.w92(TextEditing_getInstance().m9a(false, true));
    tmp.g99_1 = this_0;
    var tmp_0 = this;
    // Inline function 'kotlin.apply' call
    var this_1 = TextCell_init_$Create$_0('...');
    this_1.b97().f2x(Companion_getInstance_210().p95_1);
    tmp_0.h99_1 = this_1;
    var tmp_1 = this;
    // Inline function 'kotlin.apply' call
    var this_2 = new IndentCell();
    this_2.o35().j(this.g99_1);
    var tmp_2 = this_2.o35();
    // Inline function 'kotlin.apply' call
    var this_3 = this.h99_1;
    this_3.m92().f2x(false);
    tmp_2.j(this_3);
    tmp_1.i99_1 = this_2;
  }
  protoOf(TemporaryCell).s8n = function () {
    return this.g99_1.s8n();
  };
  protoOf(TemporaryCell).j99 = function () {
    return this.h99_1.m92().f2x(true);
  };
  protoOf(TemporaryCell).h4 = function () {
    this.i99_1.r3p();
  };
  function getCellProperty($this, spec) {
    assertAllowedAncestorProperty($this, spec);
    var tmp;
    if (!($this.u9a_1 == null) && ensureNotNull($this.u9a_1).o2(spec)) {
      var tmp_0 = ensureNotNull($this.u9a_1).q2(spec);
      tmp = (tmp_0 == null ? true : !(tmp_0 == null)) ? tmp_0 : THROW_CCE();
    } else {
      tmp = $this.e86_1.k91(spec);
    }
    return tmp;
  }
  function assertAllowedAncestorProperty($this, spec) {
    // Inline function 'kotlin.require' call
    if (!Companion_getInstance_158().w9a_1.t(spec)) {
      var message = spec.toString();
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
  }
  function Companion_158() {
    Companion_instance_158 = this;
    this.w9a_1 = setOf_0([get_BACKGROUND(), get_RED_UNDERLINE(), get_YELLOW_UNDERLINE()]);
  }
  var Companion_instance_158;
  function Companion_getInstance_158() {
    if (Companion_instance_158 == null)
      new Companion_158();
    return Companion_instance_158;
  }
  function BaseCellMapper(source, target) {
    Companion_getInstance_158();
    Mapper.call(this, source, target);
    this.u9a_1 = null;
    this.v9a_1 = null;
  }
  protoOf(BaseCellMapper).x9a = function () {
    return this.e86_1.k91(get_SELECTED()) || this.a9b(Companion_getInstance_159().z9a_1) > 0;
  };
  protoOf(BaseCellMapper).b9b = function () {
    return this.e86_1.k91(get_FOCUS_HIGHLIGHTED()) || this.a9b(Companion_getInstance_159().y9a_1) > 0;
  };
  protoOf(BaseCellMapper).c9b = function () {
    return getCellProperty(this, get_BACKGROUND());
  };
  protoOf(BaseCellMapper).d9b = function () {
    return getCellProperty(this, get_RED_UNDERLINE());
  };
  protoOf(BaseCellMapper).e9b = function () {
    return getCellProperty(this, get_YELLOW_UNDERLINE());
  };
  protoOf(BaseCellMapper).q90 = function () {
    return false;
  };
  protoOf(BaseCellMapper).f9b = function () {
    return this.b9b() && !this.q90() && !this.x9a();
  };
  protoOf(BaseCellMapper).g9b = function (spec, value) {
    assertAllowedAncestorProperty(this, spec);
    if (this.u9a_1 == null) {
      this.u9a_1 = new ListMap();
    }
    if (equals(value, spec.b90(this.e86_1))) {
      ensureNotNull(this.u9a_1).u2(spec);
    } else {
      ensureNotNull(this.u9a_1).t2(spec, value);
    }
  };
  protoOf(BaseCellMapper).h9b = function () {
    var children = this.e86_1.o35();
    var inductionVariable = 0;
    var last = children.p() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.i9b(i, children.r(i));
      }
       while (inductionVariable <= last);
  };
  protoOf(BaseCellMapper).j9b = function (spec, delta) {
    if (this.v9a_1 == null) {
      this.v9a_1 = new Counters();
    }
    ensureNotNull(this.v9a_1).j9b(spec, delta);
    if (ensureNotNull(this.v9a_1).w2m()) {
      this.v9a_1 = null;
    }
  };
  protoOf(BaseCellMapper).a9b = function (spec) {
    var tmp0_safe_receiver = this.v9a_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.a9b(spec);
    return tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
  };
  function CounterSpec(name) {
    this.l9b_1 = name;
  }
  protoOf(CounterSpec).toString = function () {
    return 'CounterSpec(name=' + this.l9b_1 + ')';
  };
  protoOf(CounterSpec).hashCode = function () {
    return getStringHashCode(this.l9b_1);
  };
  protoOf(CounterSpec).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CounterSpec))
      return false;
    if (!(this.l9b_1 === other.l9b_1))
      return false;
    return true;
  };
  function update($this, add, root, cell, target) {
    var current = cell;
    do {
      current = ensureNotNull(current).bp();
      var _iterator__ex2g4s = $this.m9b_1.m();
      while (_iterator__ex2g4s.n()) {
        var cp = _iterator__ex2g4s.o();
        if (ensureNotNull(current).k91(cp)) {
          $this.n9b(target, cp, new PropertyChangeEvent(!add, add));
        }
      }
    }
     while (!(current === root));
  }
  function CounterUtil() {
    CounterUtil_instance = this;
    this.m9b_1 = listOf_0([get_FOCUS_HIGHLIGHTED(), get_SELECTED()]);
  }
  protoOf(CounterUtil).o9b = function (prop) {
    return contains_5(this.m9b_1, prop);
  };
  protoOf(CounterUtil).p9b = function (root, cell, target) {
    return update(this, true, root, cell, target);
  };
  protoOf(CounterUtil).q9b = function (root, cell, target) {
    return update(this, false, root, cell, target);
  };
  protoOf(CounterUtil).n9b = function (target, prop, event) {
    var tmp;
    var tmp_0 = event.t2y_1;
    if ((!(tmp_0 == null) ? typeof tmp_0 === 'boolean' : false) ? tmp_0 : THROW_CCE()) {
      tmp = 1;
    } else {
      tmp = -1;
    }
    var delta = tmp;
    var spec = null;
    if (prop === get_FOCUS_HIGHLIGHTED()) {
      spec = Companion_getInstance_159().y9a_1;
    } else if (prop === get_SELECTED()) {
      spec = Companion_getInstance_159().z9a_1;
    }
    if (!(spec == null)) {
      target.j9b(spec, delta);
      return true;
    }
    return false;
  };
  var CounterUtil_instance;
  function CounterUtil_getInstance() {
    if (CounterUtil_instance == null)
      new CounterUtil();
    return CounterUtil_instance;
  }
  function Companion_159() {
    Companion_instance_159 = this;
    this.y9a_1 = new CounterSpec('focusHighlight');
    this.z9a_1 = new CounterSpec('selectCount');
  }
  var Companion_instance_159;
  function Companion_getInstance_159() {
    if (Companion_instance_159 == null)
      new Companion_159();
    return Companion_instance_159;
  }
  function Counters() {
    Companion_getInstance_159();
    this.k9b_1 = null;
  }
  protoOf(Counters).w2m = function () {
    return this.k9b_1 == null;
  };
  protoOf(Counters).a9b = function (spec) {
    return this.k9b_1 == null || !ensureNotNull(this.k9b_1).o2(spec) ? 0 : ensureNotNull(ensureNotNull(this.k9b_1).q2(spec));
  };
  protoOf(Counters).j9b = function (spec, delta) {
    if (delta === 0)
      return Unit_instance;
    var oldVal = this.a9b(spec);
    var newVal = oldVal + delta | 0;
    // Inline function 'kotlin.check' call
    if (!(newVal >= 0)) {
      var message = 'Counter ' + spec.toString() + ' decreased to the value less than zero.';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    if (!(newVal === 0)) {
      if (this.k9b_1 == null) {
        this.k9b_1 = new ListMap();
      }
      ensureNotNull(this.k9b_1).t2(spec, newVal);
    } else {
      if (!(this.k9b_1 == null)) {
        ensureNotNull(this.k9b_1).u2(spec);
        if (ensureNotNull(this.k9b_1).w2m()) {
          this.k9b_1 = null;
        }
      }
    }
  };
  function get_cellHasBounds() {
    _init_properties_CellHasBounds_kt__lhxy2j();
    return cellHasBounds;
  }
  var cellHasBounds;
  function get_boundsComposites() {
    _init_properties_CellHasBounds_kt__lhxy2j();
    return boundsComposites;
  }
  var boundsComposites;
  function get_navCompositeBounds() {
    _init_properties_CellHasBounds_kt__lhxy2j();
    var tmp0 = navCompositeBounds$delegate;
    var tmp = KProperty0;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('navCompositeBounds', 0, tmp, _get_navCompositeBounds_$ref_41xbdr(), null);
    return tmp0.a1();
  }
  var navCompositeBounds$delegate;
  function isAbove(upper, lower) {
    _init_properties_CellHasBounds_kt__lhxy2j();
    return get_boundsComposites().k8s(upper, lower);
  }
  function endElement(cell, threshold) {
    _init_properties_CellHasBounds_kt__lhxy2j();
    return get_navCompositeBounds().s8s(cell, threshold);
  }
  function homeElement(cell, threshold) {
    _init_properties_CellHasBounds_kt__lhxy2j();
    return get_navCompositeBounds().o8s(cell, threshold);
  }
  function cellHasBounds$lambda(cell) {
    _init_properties_CellHasBounds_kt__lhxy2j();
    return get_bounds(cell);
  }
  function navCompositeBounds$delegate$lambda() {
    _init_properties_CellHasBounds_kt__lhxy2j();
    return new NavCompositeBounds(get_boundsComposites(), get_cellNavCompositeFocusables());
  }
  function _get_navCompositeBounds_$ref_41xbdr() {
    return function () {
      return get_navCompositeBounds();
    };
  }
  var properties_initialized_CellHasBounds_kt_daj7r1;
  function _init_properties_CellHasBounds_kt__lhxy2j() {
    if (!properties_initialized_CellHasBounds_kt_daj7r1) {
      properties_initialized_CellHasBounds_kt_daj7r1 = true;
      cellHasBounds = cellHasBounds$lambda;
      boundsComposites = new BoundsComposites(get_cellHasBounds());
      navCompositeBounds$delegate = lazy(navCompositeBounds$delegate$lambda);
    }
  }
  function AsyncCompletionSupport$whenCompletionReadyOrNull$slambda$slambda($completionResult, resultContinuation) {
    this.z9b_1 = $completionResult;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(AsyncCompletionSupport$whenCompletionReadyOrNull$slambda$slambda).b9c = function ($this$withTimeoutOrNull, $completion) {
    var tmp = this.f1h($this$withTimeoutOrNull, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(AsyncCompletionSupport$whenCompletionReadyOrNull$slambda$slambda).v9 = function (p1, $completion) {
    return this.b9c((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(AsyncCompletionSupport$whenCompletionReadyOrNull$slambda$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = await_2(this.z9b_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(AsyncCompletionSupport$whenCompletionReadyOrNull$slambda$slambda).f1h = function ($this$withTimeoutOrNull, completion) {
    var i = new AsyncCompletionSupport$whenCompletionReadyOrNull$slambda$slambda(this.z9b_1, completion);
    i.a9c_1 = $this$withTimeoutOrNull;
    return i;
  };
  function AsyncCompletionSupport$whenCompletionReadyOrNull$slambda$slambda_0($completionResult, resultContinuation) {
    var i = new AsyncCompletionSupport$whenCompletionReadyOrNull$slambda$slambda($completionResult, resultContinuation);
    var l = function ($this$withTimeoutOrNull, $completion) {
      return i.b9c($this$withTimeoutOrNull, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function AsyncCompletionSupport$whenCompletionReady$slambda($completionResult, $readyBlock, resultContinuation) {
    this.k9c_1 = $completionResult;
    this.l9c_1 = $readyBlock;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(AsyncCompletionSupport$whenCompletionReady$slambda).e1h = function ($this$launch, $completion) {
    var tmp = this.f1h($this$launch, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(AsyncCompletionSupport$whenCompletionReady$slambda).v9 = function (p1, $completion) {
    return this.e1h((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(AsyncCompletionSupport$whenCompletionReady$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 3;
            this.f9_1 = 1;
            suspendResult = await_2(this.k9c_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var result = suspendResult;
            var items = CompletionItems_init_$Create$(result);
            this.f9_1 = 2;
            suspendResult = this.l9c_1(items, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 3) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(AsyncCompletionSupport$whenCompletionReady$slambda).f1h = function ($this$launch, completion) {
    var i = new AsyncCompletionSupport$whenCompletionReady$slambda(this.k9c_1, this.l9c_1, completion);
    i.m9c_1 = $this$launch;
    return i;
  };
  function AsyncCompletionSupport$whenCompletionReady$slambda_0($completionResult, $readyBlock, resultContinuation) {
    var i = new AsyncCompletionSupport$whenCompletionReady$slambda($completionResult, $readyBlock, resultContinuation);
    var l = function ($this$launch, $completion) {
      return i.e1h($this$launch, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function AsyncCompletionSupport$whenCompletionReady$lambda($completionResult) {
    return function (it) {
      $completionResult.zr();
      return Unit_instance;
    };
  }
  function AsyncCompletionSupport$whenCompletionReadyOrNull$slambda($timeout, $readyBlock, $completionResult, resultContinuation) {
    this.v9c_1 = $timeout;
    this.w9c_1 = $readyBlock;
    this.x9c_1 = $completionResult;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(AsyncCompletionSupport$whenCompletionReadyOrNull$slambda).e1h = function ($this$launch, $completion) {
    var tmp = this.f1h($this$launch, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(AsyncCompletionSupport$whenCompletionReadyOrNull$slambda).v9 = function (p1, $completion) {
    return this.e1h((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(AsyncCompletionSupport$whenCompletionReadyOrNull$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 3;
            this.f9_1 = 1;
            suspendResult = withTimeoutOrNull(this.v9c_1, AsyncCompletionSupport$whenCompletionReadyOrNull$slambda$slambda_0(this.x9c_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var result = suspendResult;
            var tmp_0;
            if (result == null) {
              tmp_0 = null;
            } else {
              tmp_0 = CompletionItems_init_$Create$(result);
            }

            var items = tmp_0;
            this.f9_1 = 2;
            suspendResult = this.w9c_1(items, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 3) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(AsyncCompletionSupport$whenCompletionReadyOrNull$slambda).f1h = function ($this$launch, completion) {
    var i = new AsyncCompletionSupport$whenCompletionReadyOrNull$slambda(this.v9c_1, this.w9c_1, this.x9c_1, completion);
    i.y9c_1 = $this$launch;
    return i;
  };
  function AsyncCompletionSupport$whenCompletionReadyOrNull$slambda_0($timeout, $readyBlock, $completionResult, resultContinuation) {
    var i = new AsyncCompletionSupport$whenCompletionReadyOrNull$slambda($timeout, $readyBlock, $completionResult, resultContinuation);
    var l = function ($this$launch, $completion) {
      return i.e1h($this$launch, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function AsyncCompletionSupport$whenCompletionReadyOrNull$lambda($completionResult) {
    return function (it) {
      $completionResult.zr();
      return Unit_instance;
    };
  }
  function AsyncCompletionSupport$launchWithAsyncCompletion$slambda($block, resultContinuation) {
    this.h9d_1 = $block;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(AsyncCompletionSupport$launchWithAsyncCompletion$slambda).e1h = function ($this$launch, $completion) {
    var tmp = this.f1h($this$launch, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(AsyncCompletionSupport$launchWithAsyncCompletion$slambda).v9 = function (p1, $completion) {
    return this.e1h((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(AsyncCompletionSupport$launchWithAsyncCompletion$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.h9d_1(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(AsyncCompletionSupport$launchWithAsyncCompletion$slambda).f1h = function ($this$launch, completion) {
    var i = new AsyncCompletionSupport$launchWithAsyncCompletion$slambda(this.h9d_1, completion);
    i.i9d_1 = $this$launch;
    return i;
  };
  function AsyncCompletionSupport$launchWithAsyncCompletion$slambda_0($block, resultContinuation) {
    var i = new AsyncCompletionSupport$launchWithAsyncCompletion$slambda($block, resultContinuation);
    var l = function ($this$launch, $completion) {
      return i.e1h($this$launch, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function AsyncCompletionSupport$launchWithAsyncCompletion$lambda($completionResult) {
    return function (it) {
      $completionResult.zr();
      return Unit_instance;
    };
  }
  function AsyncCompletionSupport() {
    AsyncCompletionSupport_instance = this;
    this.j9d_1 = CellTraitPropertySpec_init_$Create$('asyncCompletion', null);
  }
  protoOf(AsyncCompletionSupport).k9d = function (cell, completionResult, cleanup, readyBlock) {
    // Inline function 'jetbrains.ocelot.projectional.cell.completion.AsyncCompletionSupport.launchAndUseCompletion' call
    var tmp = launch_0(cell, this.j9d_1, cleanup, AsyncCompletionSupport$whenCompletionReady$slambda_0(completionResult, readyBlock, null));
    tmp.kp(AsyncCompletionSupport$whenCompletionReady$lambda(completionResult));
  };
  protoOf(AsyncCompletionSupport).l9d = function (cell, completionResult, timeout, cleanup, readyBlock) {
    // Inline function 'jetbrains.ocelot.projectional.cell.completion.AsyncCompletionSupport.launchAndUseCompletion' call
    var tmp = launch_0(cell, this.j9d_1, cleanup, AsyncCompletionSupport$whenCompletionReadyOrNull$slambda_0(timeout, readyBlock, completionResult, null));
    tmp.kp(AsyncCompletionSupport$whenCompletionReadyOrNull$lambda(completionResult));
  };
  protoOf(AsyncCompletionSupport).m9d = function (cell, completionResult, timeout, cleanup, readyBlock, $super) {
    cleanup = cleanup === VOID ? Companion_getInstance_29().m2l_1 : cleanup;
    var tmp;
    if ($super === VOID) {
      this.l9d(cell, completionResult, timeout, cleanup, readyBlock);
      tmp = Unit_instance;
    } else {
      tmp = $super.l9d.call(this, cell, completionResult, timeout, cleanup, readyBlock);
    }
    return tmp;
  };
  protoOf(AsyncCompletionSupport).n9d = function (cell, completionResult, cleanup, block) {
    // Inline function 'jetbrains.ocelot.projectional.cell.completion.AsyncCompletionSupport.launchAndUseCompletion' call
    var tmp = launch_0(cell, this.j9d_1, cleanup, AsyncCompletionSupport$launchWithAsyncCompletion$slambda_0(block, null));
    tmp.kp(AsyncCompletionSupport$launchWithAsyncCompletion$lambda(completionResult));
  };
  protoOf(AsyncCompletionSupport).o9d = function (cell, completionResult, cleanup, block, $super) {
    cleanup = cleanup === VOID ? Companion_getInstance_29().m2l_1 : cleanup;
    var tmp;
    if ($super === VOID) {
      this.n9d(cell, completionResult, cleanup, block);
      tmp = Unit_instance;
    } else {
      tmp = $super.n9d.call(this, cell, completionResult, cleanup, block);
    }
    return tmp;
  };
  var AsyncCompletionSupport_instance;
  function AsyncCompletionSupport_getInstance() {
    if (AsyncCompletionSupport_instance == null)
      new AsyncCompletionSupport();
    return AsyncCompletionSupport_instance;
  }
  function BaseCompletionConfig() {
  }
  protoOf(BaseCompletionConfig).p9d = function (completionItems, prefixText) {
    return false;
  };
  protoOf(BaseCompletionConfig).q9d = function () {
    return 100;
  };
  function _get_completionResult__lvjdbi($this) {
    var tmp = $this.s9d_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('completionResult');
    }
  }
  function _get_completionDisposable__dka3yp($this) {
    var tmp = $this.t9d_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('completionDisposable');
    }
  }
  function _get_supplier__o4mz5r($this) {
    return $this.r9d_1.c93(Completion_getInstance().u9d_1);
  }
  function _get_orCreateTempEditor__t9oxkl($this) {
    var currentEditor = $this.r9d_1.c93(Companion_getInstance_160().e9e_1);
    if (!(currentEditor == null)) {
      return to(currentEditor.g9e(), Companion_getInstance_29().m2l_1);
    }
    var newEditor = $this.r9d_1.k91(Companion_getInstance_162().h9e_1)();
    return to(newEditor.g9e(), newEditor);
  }
  function initCompletionResult($this) {
    if (!!($this.s9d_1 == null)) {
      $this.s9d_1 = _get_supplier__o4mz5r($this).m9e(Companion_getInstance_164().j9e_1);
      var tmp = AsyncCompletionSupport_getInstance();
      var tmp_0 = _get_completionResult__lvjdbi($this);
      tmp.o9d($this.r9d_1, tmp_0, VOID, CellCompletionController$initCompletionResult$slambda_0($this, null));
    }
  }
  function assertNoActiveController($this) {
    var actual = $this.r9d_1.k91(Companion_getInstance_160().f9e_1);
    // Inline function 'kotlin.check' call
    if (!(actual == null)) {
      var message = 'Controller is already active';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
  }
  function disposeCompletion($this) {
    return _get_completionDisposable__dka3yp($this).zr();
  }
  function assertIsDisposed($this) {
    // Inline function 'kotlin.check' call
    if (!($this.r9d_1.k91(Companion_getInstance_160().f9e_1) == null)) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    return Unit_instance;
  }
  function queryEditor($this, query) {
    var editor = _get_orCreateTempEditor__t9oxkl($this);
    try {
      return query(editor.pg_1);
    }finally {
      editor.qg_1.zr();
    }
  }
  function getCompletionItems($this) {
    initCompletionResult($this);
    return CompletionItems_init_$Create$(_get_completionResult__lvjdbi($this));
  }
  function Companion_160() {
    Companion_instance_160 = this;
    this.e9e_1 = CellTraitPropertySpec_init_$Create$('completionEditor', null);
    this.f9e_1 = CellPropertySpec_init_$Create$('completionController', null);
  }
  protoOf(Companion_160).n9e = function (target) {
    var controller = target.k91(this.f9e_1);
    return controller == null ? new CellCompletionController(target) : controller;
  };
  var Companion_instance_160;
  function Companion_getInstance_160() {
    if (Companion_instance_160 == null)
      new Companion_160();
    return Companion_instance_160;
  }
  function CellCompletionController$initCompletionResult$slambda(this$0, resultContinuation) {
    this.w9e_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CellCompletionController$initCompletionResult$slambda).x9e = function ($completion) {
    var tmp = this.y9e($completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(CellCompletionController$initCompletionResult$slambda).z9e = function ($completion) {
    return this.x9e($completion);
  };
  protoOf(CellCompletionController$initCompletionResult$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = awaitValue_0(this.w9e_1.a9f(), false, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(CellCompletionController$initCompletionResult$slambda).y9e = function (completion) {
    return new CellCompletionController$initCompletionResult$slambda(this.w9e_1, completion);
  };
  function CellCompletionController$initCompletionResult$slambda_0(this$0, resultContinuation) {
    var i = new CellCompletionController$initCompletionResult$slambda(this$0, resultContinuation);
    var l = function ($completion) {
      return i.x9e($completion);
    };
    l.$arity = 0;
    return l;
  }
  function CellCompletionController$hasPrefixedItems$lambda(this$0) {
    return function (editor) {
      // Inline function 'kotlin.collections.isNotEmpty' call
      return !getCompletionItems(this$0).c9f(editor.s96()).s();
    };
  }
  function CellCompletionController(cell) {
    Companion_getInstance_160();
    this.r9d_1 = cell;
  }
  protoOf(CellCompletionController).io = function () {
    return !(this.r9d_1.k91(Companion_getInstance_160().f9e_1) == null);
  };
  protoOf(CellCompletionController).a9f = function () {
    return notNull(this.r9d_1.n92(Companion_getInstance_160().f9e_1));
  };
  protoOf(CellCompletionController).d9f = function () {
    return !(_get_supplier__o4mz5r(this) === get_EMPTY_COMPLETION_SUPPLIER());
  };
  protoOf(CellCompletionController).e9f = function (parameters) {
    assertNoActiveController(this);
    var activated = this.r9d_1.i90(Companion_getInstance_160().f9e_1, this);
    // Inline function 'kotlin.runCatching' call
    var tmp;
    try {
      initCompletionResult(this);
      // Inline function 'kotlin.Companion.success' call
      tmp = _Result___init__impl__xyqfz8(Unit_instance);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var e = $p;
        // Inline function 'kotlin.Companion.failure' call
        tmp_0 = _Result___init__impl__xyqfz8(createFailure(e));
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    // Inline function 'kotlin.onFailure' call
    var this_0 = tmp;
    if (Result__exceptionOrNull_impl_p6xea9(this_0) == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      activated.zr();
    }
    // Inline function 'kotlin.getOrThrow' call
    throwOnFailure(this_0);
    var tmp_1 = _Result___get_value__impl__bjfvqg(this_0);
    if (!(tmp_1 == null ? true : !(tmp_1 == null)))
      THROW_CCE();
    var state = ensureNotNull(this.r9d_1.s8x()).f9f();
    var editor = this.r9d_1.k91(Companion_getInstance_162().h9e_1)();
    var nestedCleanup = activated.j2l(this.r9d_1.g93(Companion_getInstance_160().e9e_1, editor)).j2l(editor);
    editor.g9e().s8n();
    this.t9d_1 = CompletionSupport_getInstance().m9f(editor.g9e(), _get_completionResult__lvjdbi(this), parameters, nestedCleanup, state);
  };
  protoOf(CellCompletionController).n9f = function () {
    var actual = this.r9d_1.k91(Companion_getInstance_160().f9e_1);
    $l$block: {
      // Inline function 'kotlin.checkNotNull' call
      if (actual == null) {
        var message = 'Controller is not active';
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      } else {
        break $l$block;
      }
    }
    disposeCompletion(actual);
    assertIsDisposed(actual);
  };
  protoOf(CellCompletionController).o9f = function () {
    return queryEditor(this, CellCompletionController$hasPrefixedItems$lambda(this));
  };
  protoOf(CellCompletionController).p9f = function () {
    var result = _get_supplier__o4mz5r(this).m9e(Companion_getInstance_164().i9e_1);
    if (_get_supplier__o4mz5r(this).q9f()) {
      this.s9d_1 = result;
    }
    return result;
  };
  function Completion$COMPLETION_ITEMS_SHOWN$lambda(it) {
    return Unit_instance;
  }
  function Completion() {
    Completion_instance = this;
    this.u9d_1 = CellTraitPropertySpec_init_$Create$('completion', get_EMPTY_COMPLETION_SUPPLIER());
    this.v9d_1 = CellTraitPropertySpec_init_$Create$('leftTransform', get_EMPTY_COMPLETION_SUPPLIER());
    this.w9d_1 = CellTraitPropertySpec_init_$Create$('rightTransform', get_EMPTY_COMPLETION_SUPPLIER());
    this.x9d_1 = new CellTraitPropertySpec('expandLeft', Side_LEFT_getInstance().t9f());
    this.y9d_1 = new CellTraitPropertySpec('expandRight', Side_RIGHT_getInstance().t9f());
    this.z9d_1 = CellTraitPropertySpec_init_$Create$('completionConfig', new DefaultCompletionConfig());
    this.a9e_1 = CellTraits_instance.u9f('completionItemsShown');
    var tmp = this;
    var tmp_0 = CellTraits_instance;
    tmp.b9e_1 = tmp_0.v9f('completionItemsShown', Completion$COMPLETION_ITEMS_SHOWN$lambda);
    this.c9e_1 = CellPropertySpec_init_$Create$('completionMenuPosition', 0);
    this.d9e_1 = CellTraitPropertySpec_init_$Create$('specialSpaceHandlingInCompletion', true);
  }
  protoOf(Completion).w9f = function (cell) {
    var target = cell.c93(CompletionSupport_getInstance().j9f_1);
    return Companion_getInstance_160().n9e(target);
  };
  protoOf(Completion).x9f = function (cell) {
    return this.w9f(cell).io();
  };
  protoOf(Completion).y9f = function (cell, cp, prop) {
    var completionSupplier = cell.c93(prop);
    return completionSupplier.m9e(cp);
  };
  protoOf(Completion).z9f = function (cell, cp, prop, $super) {
    prop = prop === VOID ? this.u9d_1 : prop;
    return $super === VOID ? this.y9f(cell, cp, prop) : $super.y9f.call(this, cell, cp, prop);
  };
  var Completion_instance;
  function Completion_getInstance() {
    if (Completion_instance == null)
      new Completion();
    return Completion_instance;
  }
  function Companion_161() {
    this.a9g_1 = 'Loading...';
    this.b9g_1 = '<no completion items>';
    this.c9g_1 = '<unexpected error while building completion menu>';
    this.d9g_1 = '<some items may be missing due to unexpected error>';
  }
  var Companion_instance_161;
  function Companion_getInstance_161() {
    return Companion_instance_161;
  }
  function CompletionContentCell() {
    VerticalCell.call(this);
    this.m9g_1 = new TextPlaceholderCell();
    this.n9g_1 = CellFactory_instance.t9g([]);
    this.o9g_1 = TextCell_init_$Create$_0('<no completion items>');
    this.p9g_1 = TextCell_init_$Create$_0('<unexpected error while building completion menu>');
    this.q9g_1 = TextCell_init_$Create$_0('<some items may be missing due to unexpected error>');
    this.r9g_1 = TextCell_init_$Create$_0('Loading...');
    this.s9g_1 = new TextPlaceholderCell();
    CellFactory_instance.u9g(this, [this.m9g_1, this.p9g_1, this.q9g_1, this.n9g_1, this.o9g_1, this.r9g_1, this.s9g_1]);
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = listOf_0([this.o9g_1, this.p9g_1, this.q9g_1]).m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      element.b97().d2x(Companion_getInstance_210().s95_1);
    }
    this.r9g_1.b97().d2x(Companion_getInstance_210().r95_1);
  }
  function CompletionEditor$Companion$FACTORY$lambda(cell) {
    return CompletionEditor$Companion$FACTORY$lambda$lambda(cell);
  }
  function CompletionEditor$Companion$FACTORY$lambda$lambda($cell) {
    return function () {
      var tmp;
      if ($cell.c93(TextEditing_getInstance().t99_1)) {
        tmp = new SimpleCompletionEditor($cell instanceof TextCell ? $cell : THROW_CCE());
      } else {
        tmp = new PopupCompletionEditor($cell);
      }
      return tmp;
    };
  }
  function Companion_162() {
    Companion_instance_162 = this;
    var tmp = this;
    tmp.h9e_1 = new CellPropertySpec('completionEditorProvider', CompletionEditor$Companion$FACTORY$lambda);
  }
  var Companion_instance_162;
  function Companion_getInstance_162() {
    if (Companion_instance_162 == null)
      new Companion_162();
    return Companion_instance_162;
  }
  function init_3($this, cell, background, maxDim) {
    get_hasShadow(cell).d2x(true);
    get_border(cell).d2x(CompletionMenu_getInstance().c9h_1);
    get_background(cell).d2x(background);
    cell.i90(Companion_getInstance_153().r94_1, maxDim);
  }
  function CompletionMenu$CompletionMenuModelMapper$registerSynchronizers$o$doAttach$lambda(this$0, $delayPassed) {
    return function (it) {
      this$0.f86_1.r9h_1.o9g_1.m92().d2x(this$0.e86_1.a9i_1.w2w() && this$0.e86_1.y9h_1.s() && !this$0.e86_1.z9h_1.w2w());
      this$0.f86_1.r9h_1.r9g_1.m92().d2x(!this$0.e86_1.a9i_1.w2w() && $delayPassed.w2w() && this$0.e86_1.y9h_1.s());
      this$0.f86_1.r9h_1.p9g_1.m92().d2x(this$0.e86_1.z9h_1.w2w() && this$0.e86_1.y9h_1.s());
      var tmp = this$0.f86_1.r9h_1.q9g_1.m92();
      var tmp_0;
      if (this$0.e86_1.z9h_1.w2w()) {
        // Inline function 'kotlin.collections.isNotEmpty' call
        tmp_0 = !this$0.e86_1.y9h_1.s();
      } else {
        tmp_0 = false;
      }
      tmp.d2x(tmp_0);
      return Unit_instance;
    };
  }
  function CompletionMenu$CompletionMenuModelMapper$registerSynchronizers$o$onEvent$lambda($it) {
    return function () {
      $it.r9i();
      return Unit_instance;
    };
  }
  function loadUpToVisible($this, cell) {
    while (cell.m92().uv() && get_bounds(cell).p8c(get_bounds($this.s9i_1.f86_1))) {
      $this.s9i_1.e86_1.t9i();
    }
  }
  function _get_longestItemLength__sqzuxe($this) {
    var longest = 0;
    var _iterator__ex2g4s = $this.e86_1.u9i().m();
    while (_iterator__ex2g4s.n()) {
      var item = _iterator__ex2g4s.o();
      var length = Companion_instance_163.v9i(item);
      if (length > longest) {
        longest = length;
      }
    }
    return longest;
  }
  function delayPassedProperty($this, delay, conf) {
    var delayPassed = new ValueProperty(false);
    var delayReg = new CompositeDisposable([]);
    delayReg.l2l([whenAttached($this.f86_1, CompletionMenu$CompletionMenuModelMapper$delayPassedProperty$lambda(delayPassed, delayReg, $this, delay))]);
    conf.h5v(delayReg);
    return delayPassed;
  }
  function initPlaceholders($this) {
    $this.f86_1.w9i(CompletionMenu$CompletionMenuModelMapper$initPlaceholders$lambda($this));
    updatePlaceholders($this);
  }
  function updatePlaceholders($this) {
    if (!$this.e86_1.a9i_1.uv()) {
      hidePlaceholders($this);
      return Unit_instance;
    }
    var placeholderLines = $this.e86_1.x9i().uv() - $this.e86_1.y9h_1.p() | 0;
    if (placeholderLines === 0) {
      hidePlaceholders($this);
      return Unit_instance;
    }
    if ($this.f86_1.r9h_1.m9g_1.x97().uv() === 0) {
      initWidth($this);
    }
    renderedPlaceholder($this).y97().d2x(placeholderLines);
    renderedPlaceholder($this).m92().d2x(true);
    hiddenPlaceholder($this).m92().d2x(false);
  }
  function initWidth($this) {
    var longest = _get_longestItemLength__sqzuxe($this);
    $this.f86_1.w9i(CompletionMenu$CompletionMenuModelMapper$initWidth$lambda(longest));
  }
  function hidePlaceholders($this) {
    $this.f86_1.w9i(CompletionMenu$CompletionMenuModelMapper$hidePlaceholders$lambda);
  }
  function renderedPlaceholder($this) {
    return getPlaceholder($this, $this.e86_1.y9i().uv());
  }
  function hiddenPlaceholder($this) {
    return getPlaceholder($this, !$this.e86_1.y9i().uv());
  }
  function getPlaceholder($this, bottom) {
    return bottom ? $this.f86_1.r9h_1.s9g_1 : $this.f86_1.r9h_1.m9g_1;
  }
  function sam$jetbrains_ocelot_base_edt_EdtTask$0_3(function_0) {
    this.z9i_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_3).au = function () {
    return this.z9i_1();
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_3).f3 = function () {
    return this.z9i_1;
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_3).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, EdtTask) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_3).hashCode = function () {
    return hashCode(this.f3());
  };
  function sam$jetbrains_ocelot_base_edt_EdtTask$0_4(function_0) {
    this.a9j_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_4).au = function () {
    return this.a9j_1();
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_4).f3 = function () {
    return this.a9j_1;
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_4).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, EdtTask) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_4).hashCode = function () {
    return hashCode(this.f3());
  };
  function CompletionMenu$CompletionItemMapper$_init_$ref_j3qln0() {
    var l = function (p0) {
      return new CompletionItemMapper(p0);
    };
    l.callableName = '<init>';
    return l;
  }
  function CompletionMenu$CompletionMenuModelMapper$registerSynchronizers$$inlined$forEventSource$1(this$0, $delayPassed, $src) {
    this.c9j_1 = this$0;
    this.d9j_1 = $delayPassed;
    this.e9j_1 = $src;
    DisposableSynchronizer.call(this);
  }
  protoOf(CompletionMenu$CompletionMenuModelMapper$registerSynchronizers$$inlined$forEventSource$1).s87 = function (ctx) {
    this.c9j_1.f86_1.r9h_1.o9g_1.m92().d2x(this.c9j_1.e86_1.a9i_1.w2w() && this.c9j_1.e86_1.y9h_1.s() && !this.c9j_1.e86_1.z9h_1.w2w());
    this.c9j_1.f86_1.r9h_1.r9g_1.m92().d2x(!this.c9j_1.e86_1.a9i_1.w2w() && this.d9j_1.w2w() && this.c9j_1.e86_1.y9h_1.s());
    this.c9j_1.f86_1.r9h_1.p9g_1.m92().d2x(this.c9j_1.e86_1.z9h_1.w2w() && this.c9j_1.e86_1.y9h_1.s());
    var tmp = this.c9j_1.f86_1.r9h_1.q9g_1.m92();
    var tmp_0;
    if (this.c9j_1.e86_1.z9h_1.w2w()) {
      // Inline function 'kotlin.collections.isNotEmpty' call
      tmp_0 = !this.c9j_1.e86_1.y9h_1.s();
    } else {
      tmp_0 = false;
    }
    tmp.d2x(tmp_0);
    return this.e9j_1.z2r(CompletionMenu$CompletionMenuModelMapper$registerSynchronizers$o$doAttach$lambda(this.c9j_1, this.d9j_1));
  };
  function CompletionMenu$CompletionMenuModelMapper$registerSynchronizers$$inlined$eventHandler$1(this$0) {
    this.f9j_1 = this$0;
  }
  protoOf(CompletionMenu$CompletionMenuModelMapper$registerSynchronizers$$inlined$eventHandler$1).o2v = function (event) {
    var tmp$ret$0;
    $l$block_0: {
      if (event == null) {
        tmp$ret$0 = Unit_instance;
        break $l$block_0;
      }
      var tmp = this.f9j_1.g89(event);
      var tmp1_elvis_lhs = tmp instanceof CompletionItemMapper ? tmp : null;
      var tmp_0;
      if (tmp1_elvis_lhs == null) {
        tmp$ret$0 = Unit_instance;
        break $l$block_0;
      } else {
        tmp_0 = tmp1_elvis_lhs;
      }
      var itemMapper = tmp_0;
      // Inline function 'kotlin.let' call
      var tmp_1 = ensureNotNull(this.f9j_1.f86_1.s8x()).m93();
      var tmp_2 = CompletionMenu$CompletionMenuModelMapper$registerSynchronizers$o$onEvent$lambda(itemMapper);
      tmp_1.u39(new sam$jetbrains_ocelot_base_edt_EdtTask$0_3(tmp_2));
      tmp$ret$0 = Unit_instance;
    }
    return tmp$ret$0;
  };
  protoOf(CompletionMenu$CompletionMenuModelMapper$registerSynchronizers$$inlined$eventHandler$1).n2s = function (event) {
    return this.o2v((event == null ? true : !(event == null)) ? event : THROW_CCE());
  };
  function CompletionMenu$CompletionMenuModelMapper$registerSynchronizers$lambda(this$0) {
    return function (it) {
      updatePlaceholders(this$0);
      return Unit_instance;
    };
  }
  function CompletionMenu$CompletionMenuModelMapper$registerSynchronizers$docCell$1(this$0) {
    this.k9j_1 = this$0;
    DerivedProperty.call(this, [this$0.e86_1.c9i_1, this$0.e86_1.e9i_1]);
  }
  protoOf(CompletionMenu$CompletionMenuModelMapper$registerSynchronizers$docCell$1).q2w = function () {
    if (!this.k9j_1.e86_1.e9i_1.uv() || this.k9j_1.s9j_1 == null)
      return null;
    var item = this.k9j_1.e86_1.c9i_1.uv();
    return item == null ? null : this.k9j_1.s9j_1(item.v9j());
  };
  function CompletionMenu$CompletionMenuModelMapper$registerSynchronizers$$inlined$writableProperty$1(this$0) {
    this.w9j_1 = this$0;
  }
  protoOf(CompletionMenu$CompletionMenuModelMapper$registerSynchronizers$$inlined$writableProperty$1).x9j = function (newValue) {
    var children = this.w9j_1.f86_1.t9h_1.q92();
    children.k2();
    var visible = this.w9j_1.f86_1.s9h_1.m92();
    if (newValue == null) {
      visible.d2x(false);
    } else {
      children.j(newValue);
      visible.d2x(true);
    }
    return Unit_instance;
  };
  protoOf(CompletionMenu$CompletionMenuModelMapper$registerSynchronizers$$inlined$writableProperty$1).d2x = function (newValue) {
    return this.x9j((newValue == null ? true : !(newValue == null)) ? newValue : THROW_CCE());
  };
  function CompletionMenu$CompletionMenuModelMapper$delayPassedProperty$lambda$lambda($delayPassed) {
    return function () {
      $delayPassed.d2x(true);
      return Unit_instance;
    };
  }
  function CompletionMenu$CompletionMenuModelMapper$delayPassedProperty$lambda($delayPassed, $delayReg, this$0, $delay) {
    return function () {
      var tmp;
      if (!$delayPassed.uv()) {
        var tmp_0 = ensureNotNull(this$0.f86_1.s8x()).m93();
        var tmp_1 = CompletionMenu$CompletionMenuModelMapper$delayPassedProperty$lambda$lambda($delayPassed);
        $delayReg.l2l([tmp_0.v39($delay, new sam$jetbrains_ocelot_base_edt_EdtTask$0_4(tmp_1))]);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CompletionMenu$CompletionMenuModelMapper$initPlaceholders$2$1(this$0) {
    this.s9i_1 = this$0;
    CellTrait.call(this);
  }
  protoOf(CompletionMenu$CompletionMenuModelMapper$initPlaceholders$2$1).x91 = function (cell, event) {
    return loadUpToVisible(this, cell);
  };
  protoOf(CompletionMenu$CompletionMenuModelMapper$initPlaceholders$2$1).v91 = function (cell, event) {
    return loadUpToVisible(this, cell);
  };
  protoOf(CompletionMenu$CompletionMenuModelMapper$initPlaceholders$2$1).z91 = function (cell, event) {
    return loadUpToVisible(this, cell);
  };
  protoOf(CompletionMenu$CompletionMenuModelMapper$initPlaceholders$2$1).b92 = function (cell, event) {
    return loadUpToVisible(this, cell);
  };
  function CompletionMenu$CompletionMenuModelMapper$initPlaceholders$lambda(this$0) {
    return function (placeholderCell) {
      placeholderCell.w92(new CompletionMenu$CompletionMenuModelMapper$initPlaceholders$2$1(this$0));
      return Unit_instance;
    };
  }
  function CompletionMenu$CompletionMenuModelMapper$initWidth$lambda($longest) {
    return function (p) {
      p.x97().d2x($longest);
      return Unit_instance;
    };
  }
  function CompletionMenu$CompletionMenuModelMapper$hidePlaceholders$lambda(p) {
    p.m92().d2x(false);
    return Unit_instance;
  }
  function setBackground($this, mode) {
    return $this.f86_1.i90(get_BACKGROUND(), CompletionMenu_getInstance().z9g_1.b9k(mode));
  }
  function Companion_163() {
  }
  protoOf(Companion_163).v9i = function (item) {
    var mainLength = item.c9k().length;
    // Inline function 'kotlin.text.orEmpty' call
    var tmp0_elvis_lhs = item.d9k();
    var additionalLength = (tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs).length;
    var tmp;
    if (additionalLength === 0) {
      tmp = mainLength;
    } else {
      tmp = (mainLength + 1 | 0) + additionalLength | 0;
    }
    return tmp;
  };
  var Companion_instance_163;
  function Companion_getInstance_163() {
    return Companion_instance_163;
  }
  function sam$jetbrains_ocelot_base_edt_EdtTask$0_5(function_0) {
    this.e9k_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_5).au = function () {
    return this.e9k_1();
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_5).f3 = function () {
    return this.e9k_1;
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_5).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, EdtTask) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_5).hashCode = function () {
    return hashCode(this.f3());
  };
  function CompletionMenu$CompletionItemMapper$registerSynchronizers$1($parentMapper, this$0, $hoveredItem) {
    this.f9k_1 = $parentMapper;
    this.g9k_1 = this$0;
    this.h9k_1 = $hoveredItem;
    CellTrait.call(this);
  }
  protoOf(CompletionMenu$CompletionItemMapper$registerSynchronizers$1).t91 = function (cell, event) {
    this.f9k_1.t9j_1.k9k(this.g9k_1.e86_1, event);
  };
  protoOf(CompletionMenu$CompletionItemMapper$registerSynchronizers$1).x91 = function (cell, event) {
    this.h9k_1.d2x(this.g9k_1.e86_1);
    event.n8i();
  };
  protoOf(CompletionMenu$CompletionItemMapper$registerSynchronizers$1).a92 = function (cell, event) {
    this.f9k_1.t9j_1.k9k(this.g9k_1.e86_1, event);
  };
  protoOf(CompletionMenu$CompletionItemMapper$registerSynchronizers$1).z91 = function (cell, event) {
    this.h9k_1.d2x(this.g9k_1.e86_1);
    event.n8i();
  };
  function CompletionMenu$CompletionItemMapper$registerSynchronizers$lambda(this$0, $text) {
    return function () {
      return this$0.e86_1.l9k($text.uv());
    };
  }
  function CompletionMenu$CompletionItemMapper$registerSynchronizers$lambda_0($selected, $completionMenuMode, $matches) {
    return function () {
      return CompletionMenu_getInstance().z9g_1.m9k($selected, $completionMenuMode, $matches);
    };
  }
  function CompletionMenu$CompletionItemMapper$registerSynchronizers$lambda_1($selected, $completionMenuMode) {
    return function () {
      return CompletionMenu_getInstance().z9g_1.n9k($selected, $completionMenuMode);
    };
  }
  function CompletionMenu$CompletionItemMapper$scrollToTarget$ref(p0) {
    var l = function () {
      p0.r9i();
      return Unit_instance;
    };
    l.callableName = 'scrollToTarget';
    return l;
  }
  function CompletionMenu$CompletionItemMapper$registerSynchronizers$lambda$lambda(this$0) {
    return function () {
      var tmp = ensureNotNull(this$0.f86_1.s8x()).m93();
      var tmp_0 = CompletionMenu$CompletionItemMapper$scrollToTarget$ref(this$0);
      tmp.u39(new sam$jetbrains_ocelot_base_edt_EdtTask$0_5(tmp_0));
      return Unit_instance;
    };
  }
  function CompletionMenu$CompletionItemMapper$registerSynchronizers$lambda_2(this$0) {
    return function (event) {
      var tmp;
      if (event.t2y_1) {
        var tmp_0 = this$0;
        tmp_0.p9i_1 = whenAttached(this$0.f86_1, CompletionMenu$CompletionItemMapper$registerSynchronizers$lambda$lambda(this$0));
        tmp = Unit_instance;
      } else {
        this$0.p9i_1.zr();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CompletionMenu$CompletionItemMapper$registerSynchronizers$$inlined$writableProperty$1(this$0, $completionMenuMode) {
    this.o9k_1 = this$0;
    this.p9k_1 = $completionMenuMode;
  }
  protoOf(CompletionMenu$CompletionItemMapper$registerSynchronizers$$inlined$writableProperty$1).x9j = function (newValue) {
    if (newValue) {
      this.o9k_1.q9i_1 = setBackground(this.o9k_1, this.p9k_1.uv());
    } else {
      this.o9k_1.q9i_1.zr();
    }
    return Unit_instance;
  };
  protoOf(CompletionMenu$CompletionItemMapper$registerSynchronizers$$inlined$writableProperty$1).d2x = function (newValue) {
    return this.x9j((newValue == null ? true : !(newValue == null)) ? newValue : THROW_CCE());
  };
  function CompletionMenuCell() {
    HorizontalCell.call(this);
    this.q9h_1 = new ScrollCell();
    this.r9h_1 = new CompletionContentCell();
    this.s9h_1 = new ScrollCell();
    this.t9h_1 = CellFactory_instance.t9g([]);
    this.m92().d2x(false);
    this.g94().d2x(Alignment_START_getInstance());
    init_3(this, this.q9h_1, CompletionMenu_getInstance().a9h_1, CompletionMenu_getInstance().d9h_1);
    init_3(this, this.s9h_1, CompletionMenu_getInstance().b9h_1, CompletionMenu_getInstance().f9h_1);
    this.s9h_1.m92().d2x(false);
    this.q9h_1.o35().j(this.r9h_1);
    this.s9h_1.o35().j(this.t9h_1);
    CellFactory_instance.u9g(this, [this.q9h_1, this.s9h_1]);
    this.w92(CompletionMenu_getInstance().h9h_1);
  }
  protoOf(CompletionMenuCell).w9i = function (consumer) {
    var _iterator__ex2g4s = listOf_0([this.r9h_1.m9g_1, this.r9h_1.s9g_1]).m();
    while (_iterator__ex2g4s.n()) {
      var p = _iterator__ex2g4s.o();
      consumer(p);
    }
  };
  function CompletionMenuSpec() {
  }
  protoOf(CompletionMenuSpec).q94 = function (cell) {
    return false;
  };
  protoOf(CompletionMenuSpec).o94 = function (cell, dimension, viewport, alignedWidth) {
    var menu = cell instanceof CompletionMenuCell ? cell : THROW_CCE();
    var hasDoc = menu.s9h_1.m92().uv();
    var itemsScroll = menu.q9h_1;
    var itemsDim = get_dimension(itemsScroll);
    var tmp0 = itemsDim.d8c_1;
    // Inline function 'kotlin.math.max' call
    var b = CompletionMenu_getInstance().e9h_1.d8c_1;
    var itemsWidth = Math.max(tmp0, b);
    var tmp;
    if (hasDoc) {
      var tmp0_0 = viewport.d8c_1 - itemsWidth | 0;
      // Inline function 'kotlin.math.max' call
      var b_0 = CompletionMenu_getInstance().g9h_1.d8c_1;
      tmp = Math.max(tmp0_0, b_0);
    } else {
      tmp = 0;
    }
    var docWidth = tmp;
    if ((itemsWidth + docWidth | 0) > viewport.d8c_1) {
      var tmp0_1 = viewport.d8c_1 - docWidth | 0;
      // Inline function 'kotlin.math.max' call
      var b_1 = CompletionMenu_getInstance().e9h_1.d8c_1;
      itemsWidth = Math.max(tmp0_1, b_1);
    }
    var tmp0_2 = viewport.e8c_1;
    // Inline function 'kotlin.math.max' call
    var b_2 = CompletionMenu_getInstance().e9h_1.e8c_1;
    var itemsHeight = Math.max(tmp0_2, b_2);
    var itemsAdjusted = ensureNotNull(itemsScroll.c93(Companion_getInstance_151().m94_1)).o94(itemsScroll, itemsDim, new Vector(itemsWidth, itemsHeight), itemsWidth);
    var docAdjusted = Companion_getInstance_136().h8c_1;
    if (hasDoc) {
      var tmp0_3 = viewport.e8c_1;
      // Inline function 'kotlin.math.max' call
      var b_3 = CompletionMenu_getInstance().g9h_1.e8c_1;
      var docHeight = Math.max(tmp0_3, b_3);
      docAdjusted = ensureNotNull(menu.s9h_1.c93(Companion_getInstance_151().m94_1)).o94(menu.s9h_1, get_dimension(menu.s9h_1), new Vector(docWidth, docHeight), docWidth);
    }
    var tmp_0 = itemsAdjusted.d8c_1 + docAdjusted.d8c_1 | 0;
    var tmp0_4 = itemsAdjusted.e8c_1;
    // Inline function 'kotlin.math.max' call
    var b_4 = docAdjusted.e8c_1;
    var tmp$ret$5 = Math.max(tmp0_4, b_4);
    return new Vector(tmp_0, tmp$ret$5);
  };
  protoOf(CompletionMenuSpec).p94 = function (cell, popup) {
    // Inline function 'kotlin.require' call
    if (!(cell instanceof CompletionMenuCell)) {
      var message = 'Unsupported cell type: ' + toString_1(cell);
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    var crossAlignment = cell.g94();
    if (popup === get_BOTTOM_POPUP()) {
      crossAlignment.d2x(Alignment_START_getInstance());
    } else if (popup === get_TOP_POPUP()) {
      crossAlignment.d2x(Alignment_END_getInstance());
    } else
      throw IllegalArgumentException_init_$Create$_0('Unexpected position change: ' + popup.toString());
  };
  function CompletionMenuTrait() {
    CellTrait.call(this);
    this.q9k_1 = new CompletionMenuSpec();
  }
  protoOf(CompletionMenuTrait).n91 = function (cell, spec) {
    var tmp;
    if (spec === Companion_getInstance_151().m94_1) {
      tmp = this.q9k_1;
    } else {
      tmp = protoOf(CellTrait).n91.call(this, cell, spec);
    }
    return tmp;
  };
  function CompletionMenuModelMapper(source, renderer, completer, emptyCompletionDelay) {
    Mapper.call(this, source, new CompletionMenuCell());
    this.s9j_1 = renderer;
    this.t9j_1 = completer;
    this.u9j_1 = emptyCompletionDelay;
  }
  protoOf(CompletionMenuModelMapper).a88 = function (conf) {
    protoOf(Mapper).a88.call(this, conf);
    var tmp = Synchronizers_instance;
    var tmp_0 = this.f86_1.r9h_1.n9g_1.o35();
    conf.h5v(tmp.c8b(this.e86_1.y9h_1, tmp_0, CompletionMenu$CompletionItemMapper$_init_$ref_j3qln0()));
    var delayPassed = delayPassedProperty(this, this.u9j_1, conf);
    // Inline function 'jetbrains.ocelot.mapper.core.Synchronizers.forEventSource' call
    var src = EventSources_instance.x2v([this.e86_1.a9i_1, delayPassed, this.e86_1.y9h_1, this.e86_1.z9h_1]);
    var tmp$ret$0 = new CompletionMenu$CompletionMenuModelMapper$registerSynchronizers$$inlined$forEventSource$1(this, delayPassed, src);
    conf.h5v(tmp$ret$0);
    // Inline function 'jetbrains.ocelot.base.observable.event.eventHandler' call
    var tmp$ret$1 = new CompletionMenu$CompletionMenuModelMapper$registerSynchronizers$$inlined$eventHandler$1(this);
    conf.h5v(this.e86_1.b9i_1.j2s(tmp$ret$1));
    var showTarget = Properties_getInstance().c2y([this.e86_1.a9i_1, delayPassed]);
    var tmp_1 = EventSources_instance.x2v([this.e86_1.a9i_1, this.e86_1.y9h_1, this.e86_1.x9i(), this.e86_1.y9i()]);
    conf.h5v(tmp_1.z2r(CompletionMenu$CompletionMenuModelMapper$registerSynchronizers$lambda(this)));
    initPlaceholders(this);
    conf.h5v(syncOneWay(showTarget, this.f86_1.m92()));
    var docCell = new CompletionMenu$CompletionMenuModelMapper$registerSynchronizers$docCell$1(this);
    // Inline function 'jetbrains.ocelot.base.observable.property.writableProperty' call
    var tmp$ret$2 = new CompletionMenu$CompletionMenuModelMapper$registerSynchronizers$$inlined$writableProperty$1(this);
    conf.h5v(syncOneWay(docCell, tmp$ret$2));
  };
  function CompletionItemMapper(source) {
    Mapper.call(this, source, new HorizontalCell());
    this.n9i_1 = TextCell_init_$Create$();
    this.o9i_1 = TextCell_init_$Create$();
    this.p9i_1 = Companion_getInstance_29().m2l_1;
    this.q9i_1 = Companion_getInstance_29().m2l_1;
    this.f86_1.h94().d2x(true);
    this.n9i_1.o8w().d2x(source.c9k());
    this.f86_1.o35().j(this.n9i_1);
    var additionalText = source.d9k();
    if (!(additionalText == null)) {
      this.o9i_1.o8w().d2x(' ' + additionalText);
      this.o9i_1.i90(Companion_getInstance_154().h8x_1, true);
      this.f86_1.o35().j(this.o9i_1);
    }
  }
  protoOf(CompletionItemMapper).a88 = function (conf) {
    protoOf(Mapper).a88.call(this, conf);
    var tmp = this.j86_1;
    var parentMapper = tmp instanceof CompletionMenuModelMapper ? tmp : THROW_CCE();
    var parentMapperSource = parentMapper.e86_1;
    var selectedItem = parentMapperSource.c9i_1;
    var hoveredItem = parentMapperSource.d9i_1;
    conf.h5v(this.f86_1.w92(new CompletionMenu$CompletionItemMapper$registerSynchronizers$1(parentMapper, this, hoveredItem)));
    var text = parentMapperSource.x9h_1;
    var matches = toDerivedProperty(CompletionMenu$CompletionItemMapper$registerSynchronizers$lambda(this, text), [text]);
    var selected = isSame(selectedItem, this.e86_1);
    var completionMenuMode = parentMapperSource.r9k();
    var textColor = toDerivedProperty(CompletionMenu$CompletionItemMapper$registerSynchronizers$lambda_0(selected, completionMenuMode, matches), [selected, completionMenuMode, matches]);
    conf.h5v(syncOneWay(textColor, this.n9i_1.b97()));
    conf.h5v(syncOneWay(toDerivedProperty(CompletionMenu$CompletionItemMapper$registerSynchronizers$lambda_1(selected, completionMenuMode), [selected, completionMenuMode]), this.o9i_1.b97()));
    conf.h5v(selected.z2r(CompletionMenu$CompletionItemMapper$registerSynchronizers$lambda_2(this)));
    // Inline function 'jetbrains.ocelot.base.observable.property.writableProperty' call
    var tmp$ret$0 = new CompletionMenu$CompletionItemMapper$registerSynchronizers$$inlined$writableProperty$1(this, completionMenuMode);
    conf.h5v(syncOneWay(selected, tmp$ret$0));
  };
  protoOf(CompletionItemMapper).r9i = function () {
    if (!this.f86_1.f89()) {
      return Unit_instance;
    }
    var dimension = get_dimension(this.f86_1);
    if (dimension.e8c_1 === 0 && dimension.d8c_1 === 0) {
      return Unit_instance;
    }
    scrollTo_2(this.f86_1, new Rectangle(Companion_getInstance_136().h8c_1, new Vector(1, dimension.e8c_1)));
  };
  function ColorScheme() {
    this.y9j_1 = null;
    this.z9j_1 = null;
    this.a9k_1 = null;
  }
  protoOf(ColorScheme).s9k = function (whenNoSelection) {
    this.y9j_1 = whenNoSelection;
    return this;
  };
  protoOf(ColorScheme).t9k = function (whenPreviewSelection) {
    this.z9j_1 = whenPreviewSelection;
    return this;
  };
  protoOf(ColorScheme).u9k = function (whenNormalSelection) {
    this.a9k_1 = whenNormalSelection;
    return this;
  };
  protoOf(ColorScheme).m9k = function (selected, mode, matches) {
    return ensureNotNull(this.y9k(selected, mode)).v9k_1.b9l(matches);
  };
  protoOf(ColorScheme).n9k = function (selected, mode) {
    return ensureNotNull(this.y9k(selected, mode)).w9k_1;
  };
  protoOf(ColorScheme).b9k = function (mode) {
    return ensureNotNull(this.c9l(true, mode)).x9k_1;
  };
  protoOf(ColorScheme).y9k = function (selected, mode) {
    return this.c9l(selected.uv(), mode.uv());
  };
  protoOf(ColorScheme).c9l = function (selected, mode) {
    if (!selected) {
      return this.y9j_1;
    }
    var tmp;
    switch (mode.x2_1) {
      case 0:
        tmp = this.z9j_1;
        break;
      case 1:
        tmp = this.a9k_1;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  };
  function ItemColors(textColors, additional) {
    this.v9k_1 = textColors;
    this.w9k_1 = additional;
    this.x9k_1 = null;
  }
  protoOf(ItemColors).d9l = function (background) {
    this.x9k_1 = background;
    return this;
  };
  function TextColors(match, noMatch) {
    this.z9k_1 = match;
    this.a9l_1 = noMatch;
  }
  protoOf(TextColors).b9l = function (matches) {
    return matches.uv() ? this.z9k_1 : this.a9l_1;
  };
  function CompletionMenu$createCell$$inlined$toDisposable$1($mapper) {
    this.e9l_1 = $mapper;
  }
  protoOf(CompletionMenu$createCell$$inlined$toDisposable$1).zr = function () {
    this.e9l_1.k89();
    return Unit_instance;
  };
  function CompletionMenu() {
    CompletionMenu_instance = this;
    this.v9g_1 = new Color(159, 182, 198);
    this.w9g_1 = new Color(0, 62, 149);
    this.x9g_1 = new Color(247, 232, 193);
    this.y9g_1 = new Color(96, 96, 96);
    this.z9g_1 = (new ColorScheme()).s9k(new ItemColors(new TextColors(Companion_getInstance_210().d96_1, Companion_getInstance_210().o95_1), Companion_getInstance_210().r95_1)).t9k((new ItemColors(new TextColors(Companion_getInstance_210().f96_1, Companion_getInstance_210().o95_1), this.y9g_1)).d9l(this.v9g_1)).u9k((new ItemColors(new TextColors(this.x9g_1, Companion_getInstance_210().m95_1), Companion_getInstance_210().q95_1)).d9l(this.w9g_1));
    this.a9h_1 = new Color(226, 242, 254);
    this.b9h_1 = new Color(253, 255, 218);
    this.c9h_1 = new Border(Companion_getInstance_210().p95_1, 1);
    this.d9h_1 = new Vector(600, 200);
    this.e9h_1 = new Vector(150, 50);
    this.f9h_1 = new Vector(600, 200);
    this.g9h_1 = new Vector(150, 50);
    this.h9h_1 = new CompletionMenuTrait();
  }
  protoOf(CompletionMenu).f9l = function (model, completer, renderer, reg, emptyCompletionDelay) {
    var mapper = new CompletionMenuModelMapper(model, renderer, completer, emptyCompletionDelay);
    mapper.j89();
    // Inline function 'jetbrains.ocelot.base.disposable.toDisposable' call
    var tmp$ret$0 = new CompletionMenu$createCell$$inlined$toDisposable$1(mapper);
    reg.l2l([tmp$ret$0]);
    return mapper.f86_1;
  };
  var CompletionMenu_instance;
  function CompletionMenu_getInstance() {
    if (CompletionMenu_instance == null)
      new CompletionMenu();
    return CompletionMenu_instance;
  }
  var CompletionMode_AUTO_INPLACE_instance;
  var CompletionMode_INPLACE_instance;
  var CompletionMode_INSERT_instance;
  var CompletionMode_INSERT_WITH_SPACE_instance;
  var CompletionMode_entriesInitialized;
  function CompletionMode_initEntries() {
    if (CompletionMode_entriesInitialized)
      return Unit_instance;
    CompletionMode_entriesInitialized = true;
    CompletionMode_AUTO_INPLACE_instance = new CompletionMode('AUTO_INPLACE', 0);
    CompletionMode_INPLACE_instance = new CompletionMode('INPLACE', 1);
    CompletionMode_INSERT_instance = new CompletionMode('INSERT', 2);
    CompletionMode_INSERT_WITH_SPACE_instance = new CompletionMode('INSERT_WITH_SPACE', 3);
  }
  function CompletionMode(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function CompletionMode_AUTO_INPLACE_getInstance() {
    CompletionMode_initEntries();
    return CompletionMode_AUTO_INPLACE_instance;
  }
  function CompletionMode_INPLACE_getInstance() {
    CompletionMode_initEntries();
    return CompletionMode_INPLACE_instance;
  }
  function CompletionMode_INSERT_getInstance() {
    CompletionMode_initEntries();
    return CompletionMode_INSERT_instance;
  }
  function CompletionMode_INSERT_WITH_SPACE_getInstance() {
    CompletionMode_initEntries();
    return CompletionMode_INSERT_WITH_SPACE_instance;
  }
  function createInplaceEvent($this) {
    var event = KeyEvent_init_$Create$(Key_TAB_getInstance());
    event.m8i(Companion_instance_149.s92($this.i9k_1));
    return event;
  }
  function setCompletionMode($this, event) {
    var tmp;
    if (event instanceof KeyEvent) {
      tmp = $this.i9k_1.i90(CompletionSupport_getInstance().g9f_1, getCompletionMode($this, event));
    } else {
      tmp = Companion_getInstance_29().m2l_1;
    }
    return tmp;
  }
  function getCompletionMode($this, event) {
    return event.m8j(Key_ENTER_getInstance(), []) ? CompletionMode_INSERT_getInstance() : event.m8j(Key_SPACE_getInstance(), []) ? CompletionMode_INSERT_WITH_SPACE_getInstance() : event.m8j(Key_TAB_getInstance(), []) ? CompletionMode_INPLACE_getInstance() : $this.i9k_1.k91(CompletionSupport_getInstance().g9f_1);
  }
  function CompletionSupport$Completer$completeInCommand$lambda(this$0, $item) {
    return function () {
      this$0.k9k($item, createInplaceEvent(this$0));
      return Unit_instance;
    };
  }
  function canComplete($this, cell) {
    var current = ensureNotNull(cell.s8x()).z92().uv();
    while (!(current === cell)) {
      var parent = ensureNotNull(current).bp();
      // Inline function 'kotlin.checkNotNull' call
      $l$block: {
        // Inline function 'kotlin.checkNotNull' call
        if (parent == null) {
          var message = 'Required value was null.';
          throw IllegalStateException_init_$Create$_0(toString_1(message));
        } else {
          break $l$block;
        }
      }
      var index = parent.o35().w(current);
      if (!(index === 0)) {
        return false;
      }
      current = parent;
    }
    return true;
  }
  function closeCompletionMenu($this, event) {
    event.n8i();
    $this.h9l_1._v.zr();
    $this.i9l_1();
  }
  function wrap_0($this, otherParams) {
    return new CompletionSupport$showSideTransformPopup$textEditingTrait$1$wrap$1($this.r9l_1, otherParams);
  }
  function _no_name_provided__qut3iv($cacheable, $supplier, this$0, $wrap) {
    this.s9l_1 = $cacheable;
    this.t9l_1 = $supplier;
    this.u9l_1 = this$0;
    this.v9l_1 = $wrap;
  }
  protoOf(_no_name_provided__qut3iv).q9f = function () {
    return this.s9l_1;
  };
  protoOf(_no_name_provided__qut3iv).m9e = function (completionContext) {
    return this.t9l_1.m9e(wrap_0(this.u9l_1, completionContext)).w9l().y9l(this.v9l_1).uv();
  };
  function CompletionSupport$showSideTransformPopup$o$get$lambda($spec, $supplier, this$0, $wrap) {
    return function (inputSpec) {
      var tmp;
      if (inputSpec === $spec) {
        // Inline function 'jetbrains.ocelot.projectional.cell.completion.context.completionSupplier' call
        var tmp$ret$1 = new _no_name_provided__qut3iv(false, $supplier, this$0, $wrap);
        tmp = new SpecMatchResult(tmp$ret$1);
      } else {
        tmp = null;
      }
      return tmp;
    };
  }
  function CompletionSupport$showSideTransformPopup$textEditingTrait$1$wrap$1($endRT, $otherParams) {
    this.z9l_1 = $endRT;
    this.a9m_1 = $otherParams;
    BaseCompletionContext.call(this);
  }
  protoOf(CompletionSupport$showSideTransformPopup$textEditingTrait$1$wrap$1).b9m = function () {
    return this.a9m_1.b9m();
  };
  function bindPosition($this, source, popup) {
    return PropertyBinding_instance.n30(source.n92(Completion_getInstance().c9e_1), popup.n92(get_POPUP_X_POSITION()));
  }
  function validateNoPositioning($this, cell) {
    assertNoPositioning($this, cell, cell.k91(Completion_getInstance().c9e_1));
    var tmp = cell.n92(Completion_getInstance().c9e_1);
    return tmp.z2r(CompletionSupport$validateNoPositioning$lambda(cell));
  }
  function assertNoPositioning($this, cell, pos) {
    // Inline function 'kotlin.check' call
    if (!(pos === 0)) {
      var message = 'Positioning only allowed for menu created on editable TextCell, but encountered: ' + toString_1(cell);
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
  }
  function prefixText($this, textCell) {
    return new CompletionSupport$prefixText$1(textCell);
  }
  function connect($this, source, target) {
    target.g93($this.i9f_1, source);
    return source.g93($this.j9f_1, target);
  }
  function Completer(source, handler) {
    this.i9k_1 = source;
    this.j9k_1 = handler;
  }
  protoOf(Completer).c9m = function (item) {
    var tmp = ensureNotNull(this.i9k_1.s8x());
    tmp.d9m(CompletionSupport$Completer$completeInCommand$lambda(this, item));
  };
  protoOf(Completer).k9k = function (item, cause) {
    var modeReg = setCompletionMode(this, cause);
    try {
      this.j9k_1(ensureNotNull(item));
    }finally {
      modeReg.zr();
    }
    cause.n8i();
  };
  function sam$jetbrains_ocelot_base_edt_EdtTask$0_6(function_0) {
    this.e9m_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_6).au = function () {
    return this.e9m_1();
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_6).f3 = function () {
    return this.e9m_1;
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_6).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, EdtTask) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_6).hashCode = function () {
    return hashCode(this.f3());
  };
  function CompletionSupport$SOURCE$lambda(cell) {
    return cell;
  }
  function CompletionSupport$TARGET$lambda(cell) {
    return cell;
  }
  function CompletionSupport$TRAIT$1() {
    CellTrait.call(this);
  }
  protoOf(CompletionSupport$TRAIT$1).i92 = function (cell, event) {
    if (canComplete(this, cell)) {
      var controller = Completion_getInstance().w9f(cell);
      if (!controller.io() && controller.d9f()) {
        controller.e9f(Companion_getInstance_167().k9m(event.h9m_1).f40());
      }
      event.n8i();
    }
    protoOf(CellTrait).i92.call(this, cell, event);
  };
  function CompletionSupport$showCompletion$lambda($completionReg, $restoreEnvState, $prefixText) {
    return function (item) {
      $completionReg._v.zr();
      $restoreEnvState();
      item.s9m($prefixText.uv())();
      return Unit_instance;
    };
  }
  function CompletionSupport$showCompletion$lambda_0($completer, $menuModel) {
    return function (event) {
      var tmp;
      if (event.t2y_1) {
        $completer.c9m($menuModel.c9i_1.uv());
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CompletionSupport$showCompletion$$inlined$toDisposable$1($singleOptionCompletionReg) {
    this.t9m_1 = $singleOptionCompletionReg;
  }
  protoOf(CompletionSupport$showCompletion$$inlined$toDisposable$1).zr = function () {
    this.t9m_1._v.zr();
    return Unit_instance;
  };
  function CompletionSupport$showCompletion$lambda$lambda($menuModel, $event) {
    return function () {
      $menuModel.x9h_1.d2x($event.t2y_1);
      return Unit_instance;
    };
  }
  function CompletionSupport$showCompletion$lambda_1($singleOptionCompletionReg, $editor, $menuModel) {
    return function (event) {
      $singleOptionCompletionReg._v.zr();
      $singleOptionCompletionReg._v = Companion_getInstance_29().m2l_1;
      var tmp = ensureNotNull($editor.s8x()).m93();
      var tmp_0 = CompletionSupport$showCompletion$lambda$lambda($menuModel, event);
      tmp.u39(new sam$jetbrains_ocelot_base_edt_EdtTask$0_6(tmp_0));
      return Unit_instance;
    };
  }
  function CompletionSupport$showCompletion$$inlined$writableProperty$1($itemsShownConsumer) {
    this.u9m_1 = $itemsShownConsumer;
  }
  protoOf(CompletionSupport$showCompletion$$inlined$writableProperty$1).x9j = function (newValue) {
    if (newValue) {
      this.u9m_1(true);
    }
    return Unit_instance;
  };
  protoOf(CompletionSupport$showCompletion$$inlined$writableProperty$1).d2x = function (newValue) {
    return this.x9j((newValue == null ? true : !(newValue == null)) ? newValue : THROW_CCE());
  };
  function CompletionSupport$showCompletion$$inlined$toDisposable$2($itemsShownConsumer) {
    this.v9m_1 = $itemsShownConsumer;
  }
  protoOf(CompletionSupport$showCompletion$$inlined$toDisposable$2).zr = function () {
    this.v9m_1(false);
    return Unit_instance;
  };
  function CompletionSupport$showCompletion$5($menuModel, $completionReg, $restoreEnvState, $completer, $completionCell, $editor) {
    this.g9l_1 = $menuModel;
    this.h9l_1 = $completionReg;
    this.i9l_1 = $restoreEnvState;
    this.j9l_1 = $completer;
    this.k9l_1 = $completionCell;
    this.l9l_1 = $editor;
    CellTrait.call(this);
  }
  protoOf(CompletionSupport$showCompletion$5).q91 = function (cell, event) {
    if (!this.g9l_1.e9i_1.uv()) {
      this.h9l_1._v.zr();
    }
  };
  protoOf(CompletionSupport$showCompletion$5).s8z = function (cell, event) {
    if (event.m8j(Key_ESCAPE_getInstance(), [])) {
      closeCompletionMenu(this, event);
      return Unit_instance;
    }
    if (event.o8j([KeyStrokeSpecs_getInstance().j8k_1])) {
      event.n8i();
      this.g9l_1.e9i_1.d2x(!this.g9l_1.e9i_1.uv());
      return Unit_instance;
    }
    var selectedItem = this.g9l_1.c9i_1.uv();
    if (event.m8j(Key_SPACE_getInstance(), []) && this.g9l_1.f9i_1) {
      if (!(selectedItem == null) && this.g9l_1.r9k().uv().equals(CompletionItemSelectionMode_NORMAL_getInstance())) {
        this.j9l_1.k9k(selectedItem, event);
      } else {
        closeCompletionMenu(this, event);
      }
      return Unit_instance;
    }
    if (selectedItem == null)
      return Unit_instance;
    if (event.m8j(Key_ENTER_getInstance(), []) || event.m8j(Key_TAB_getInstance(), [])) {
      this.j9l_1.k9k(selectedItem, event);
      return Unit_instance;
    }
    if (event.m8j(Key_UP_getInstance(), [])) {
      this.g9l_1.w9m();
      event.n8i();
      return Unit_instance;
    }
    if (event.m8j(Key_DOWN_getInstance(), [])) {
      this.g9l_1.x9m();
      event.n8i();
      return Unit_instance;
    }
    if (event.m8j(Key_PAGE_UP_getInstance(), []) || event.m8j(Key_PAGE_DOWN_getInstance(), [])) {
      var pageHeight = get_dimension(this.k9l_1).e8c_1 / get_dimension(this.l9l_1).e8c_1 | 0;
      var inductionVariable = 0;
      if (inductionVariable < pageHeight)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          if (event.m8j(Key_PAGE_DOWN_getInstance(), [])) {
            this.g9l_1.x9m();
          } else {
            this.g9l_1.w9m();
          }
        }
         while (inductionVariable < pageHeight);
      event.n8i();
    }
  };
  protoOf(CompletionSupport$showCompletion$5).n91 = function (cell, spec) {
    if (spec === CompletionSupport_getInstance().k9f_1) {
      return this.g9l_1.r9k().uv().equals(CompletionItemSelectionMode_PREVIEW_getInstance());
    }
    var tmp;
    if (spec === CompletionSupport_getInstance().h9f_1) {
      tmp = this.g9l_1;
    } else {
      tmp = protoOf(CellTrait).n91.call(this, cell, spec);
    }
    return tmp;
  };
  function CompletionSupport$showCompletion$$inlined$toDisposable$3($completionCell, $disposeMenuMapper, $positionBinding) {
    this.y9m_1 = $completionCell;
    this.z9m_1 = $disposeMenuMapper;
    this.a9n_1 = $positionBinding;
  }
  protoOf(CompletionSupport$showCompletion$$inlined$toDisposable$3).zr = function () {
    if (this.y9m_1.f89()) {
      this.y9m_1.r3p();
    }
    this.z9m_1.zr();
    this.a9n_1.zr();
    return Unit_instance;
  };
  function CompletionSupport$showCompletion$lambda_2($completionReg) {
    return function (it) {
      $completionReg._v.zr();
      return Unit_instance;
    };
  }
  function CompletionSupport$showCompletion$$inlined$toDisposable$4($restoreEnvState) {
    this.b9n_1 = $restoreEnvState;
  }
  protoOf(CompletionSupport$showCompletion$$inlined$toDisposable$4).zr = function () {
    this.b9n_1();
    return Unit_instance;
  };
  function CompletionSupport$validateNoPositioning$lambda($cell) {
    return function (e) {
      assertNoPositioning(CompletionSupport_getInstance(), $cell, e.t2y_1);
      return Unit_instance;
    };
  }
  function CompletionSupport$prefixText$1($textCell) {
    this.g9n_1 = $textCell;
    DerivedProperty.call(this, [$textCell.t96()]);
  }
  protoOf(CompletionSupport$prefixText$1).q2w = function () {
    return this.g9n_1.s96();
  };
  protoOf(CompletionSupport$prefixText$1).v2w = function () {
    return 'prefixText(' + this.g9n_1.toString() + ')';
  };
  function CompletionSupport$showSideTransformPopup$wrap$2$1($input, $completed) {
    this.i9n_1 = $completed;
    WrapperCompletionItem.call(this, $input);
  }
  protoOf(CompletionSupport$showSideTransformPopup$wrap$2$1).s9m = function (text) {
    this.i9n_1._v = true;
    return protoOf(WrapperCompletionItem).s9m.call(this, text);
  };
  function CompletionSupport$showSideTransformPopup$lambda($completed) {
    return function (input) {
      return new CompletionSupport$showSideTransformPopup$wrap$2$1(input, $completed);
    };
  }
  function CompletionSupport$showSideTransformPopup$lambda_0(it) {
    return Unit_instance;
  }
  function CompletionSupport$showSideTransformPopup$textEditingTrait$1($supplier, $wrap, $dismiss, $cell, $container, $endRT) {
    this.m9l_1 = $supplier;
    this.n9l_1 = $wrap;
    this.o9l_1 = $dismiss;
    this.p9l_1 = $cell;
    this.q9l_1 = $container;
    this.r9l_1 = $endRT;
    TextEditingTrait.call(this);
  }
  protoOf(CompletionSupport$showSideTransformPopup$textEditingTrait$1).n91 = function (cell, spec) {
    // Inline function 'jetbrains.ocelot.projectional.cell.trait.specMatcher' call
    var spec_0 = Completion_getInstance().u9d_1;
    var specMatcher = CompletionSupport$showSideTransformPopup$o$get$lambda(spec_0, this.m9l_1, this, this.n9l_1);
    // Inline function 'jetbrains.ocelot.projectional.cell.trait.getSpecValue' call
    var result = specMatcher(spec);
    var tmp;
    if (result == null) {
      tmp = protoOf(TextEditingTrait).n91.call(this, cell, spec);
    } else {
      tmp = result.o9n_1;
    }
    return tmp;
  };
  protoOf(CompletionSupport$showSideTransformPopup$textEditingTrait$1).x8z = function (cell, prop, event) {
    if (prop === Companion_getInstance_154().b8x_1) {
      var tmp = event.t2y_1;
      // Inline function 'kotlin.text.isEmpty' call
      var this_0 = (!(tmp == null) ? typeof tmp === 'string' : false) ? tmp : THROW_CCE();
      if (charSequenceLength(this_0) === 0) {
        this.o9l_1._v(false);
      }
    }
    protoOf(TextEditingTrait).x8z.call(this, cell, prop, event);
  };
  protoOf(CompletionSupport$showSideTransformPopup$textEditingTrait$1).s8z = function (cell, event) {
    var tmp;
    if (event.m8j(Key_ESCAPE_getInstance(), [])) {
      this.o9l_1._v(false);
      event.n8i();
      tmp = Unit_instance;
    } else {
      protoOf(TextEditingTrait).s8z.call(this, cell, event);
      tmp = Unit_instance;
    }
    return tmp;
  };
  protoOf(CompletionSupport$showSideTransformPopup$textEditingTrait$1).p9n = function (editor, typed) {
    if (protoOf(TextEditingTrait).p9n.call(this, editor, typed))
      return true;
    if (!editor.v96())
      return false;
    var text = editor.o8w().uv();
    var completionResult = this.m9l_1.m9e(wrap_0(this, Companion_getInstance_164().i9e_1));
    if (!get_isReady(completionResult))
      return false;
    var completion = CompletionItems_init_$Create$(this.m9l_1.m9e(wrap_0(this, Companion_getInstance_164().i9e_1)));
    if (completion.r9n(text, this.p9l_1.c93(TextEditing_getInstance().c9a_1))) {
      completion.q9n(text).r(0).s9m(text)();
      return true;
    }
    var prefix = dropLast_0(text, 1);
    var suffix = substring_0(text, text.length - 1 | 0);
    var tmp;
    var tmp_0;
    // Inline function 'kotlin.text.isNotEmpty' call
    if (charSequenceLength(prefix) > 0) {
      tmp_0 = completion.q9n(prefix).p() === 1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = completion.c9f(text).s();
    } else {
      tmp = false;
    }
    if (tmp) {
      completion.q9n(prefix).r(0).s9m(prefix)();
      var inductionVariable = 0;
      var last = suffix.length;
      while (inductionVariable < last) {
        var element = charCodeAt(suffix, inductionVariable);
        inductionVariable = inductionVariable + 1 | 0;
        this.q9l_1.j8n(KeyEvent_init_$Create$(Key_UNKNOWN_getInstance(), element));
      }
      return true;
    }
    return false;
  };
  protoOf(CompletionSupport$showSideTransformPopup$textEditingTrait$1).q91 = function (cell, event) {
    protoOf(TextEditingTrait).q91.call(this, cell, event);
    this.o9l_1._v(true);
  };
  function CompletionSupport$showSideTransformPopup$lambda_1($dismissed, $popup, $traitReg, $targetRegistration, $completed, $restoreState) {
    return function (focusLoss) {
      var tmp;
      if (!$dismissed._v) {
        $dismissed._v = true;
        $popup.r3p();
        $traitReg.zr();
        $targetRegistration.zr();
        var tmp_0;
        if (!$completed._v && !focusLoss) {
          tmp_0 = $restoreState();
        }
        tmp = tmp_0;
      }
      return Unit_instance;
    };
  }
  function CompletionSupport() {
    CompletionSupport_instance = this;
    this.g9f_1 = CellPropertySpec_init_$Create$('completionMode', CompletionMode_AUTO_INPLACE_getInstance());
    this.h9f_1 = CellTraitPropertySpec_init_$Create$('model', null);
    var tmp = this;
    tmp.i9f_1 = new CellTraitPropertySpec('completionSource', CompletionSupport$SOURCE$lambda);
    var tmp_0 = this;
    tmp_0.j9f_1 = new CellTraitPropertySpec('completionBase', CompletionSupport$TARGET$lambda);
    this.k9f_1 = CellTraitPropertySpec_init_$Create$('isPreviewSelection', false);
    var tmp_1 = this;
    tmp_1.l9f_1 = new CompletionSupport$TRAIT$1();
  }
  protoOf(CompletionSupport).x9n = function () {
    return this.l9f_1;
  };
  protoOf(CompletionSupport).m9f = function (editor, completionResult, parameters, cellCleanup, restoreCellsState) {
    // Inline function 'kotlin.require' call
    if (!editor.y92().uv()) {
      var message = 'Editor is not focused';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    var completionSource = editor.c93(this.i9f_1);
    var prefixText_0 = prefixText(this, editor);
    var builder = Companion_getInstance_166().c9o(completionResult).k9o(prefixText_0.uv()).s9o(parameters.n9o_1).t9o(completionSource.c93(Completion_getInstance().d9e_1));
    var tmp0_safe_receiver = parameters.o9o_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      builder.u9o(tmp0_safe_receiver);
    }
    var tmp1_safe_receiver = parameters.p9o_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      builder.v9o(tmp1_safe_receiver);
    }
    var tmp2_safe_receiver = parameters.q9o_1;
    if (tmp2_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      builder.w9o(tmp2_safe_receiver);
    }
    var menuModel = builder.f40();
    var completionReg = {_v: menuModel.j2l(cellCleanup)};
    var restoreEnvState = seqActions([restoreCellsState, parameters.l9o_1]);
    var completer = new Completer(completionSource, CompletionSupport$showCompletion$lambda(completionReg, restoreEnvState, prefixText_0));
    var singleOptionCompletionReg = {_v: Companion_getInstance_29().m2l_1};
    var tmp;
    if (parameters.m9o_1) {
      // Inline function 'kotlin.text.isNotEmpty' call
      var this_0 = prefixText_0.uv();
      tmp = charSequenceLength(this_0) > 0;
    } else {
      tmp = false;
    }
    if (tmp) {
      var completeSelected = Properties_getInstance().b2y([menuModel.x9o(), menuModel.a9i_1]);
      if (completeSelected.uv()) {
        completer.c9m(menuModel.c9i_1.uv());
        return Companion_getInstance_29().m2l_1;
      }
      singleOptionCompletionReg._v = completeSelected.z2r(CompletionSupport$showCompletion$lambda_0(completer, menuModel));
      var tmp_0 = completionReg._v;
      // Inline function 'jetbrains.ocelot.base.disposable.toDisposable' call
      var tmp$ret$9 = new CompletionSupport$showCompletion$$inlined$toDisposable$1(singleOptionCompletionReg);
      completionReg._v = tmp_0.j2l(tmp$ret$9);
    }
    var tmp_1 = completionReg._v;
    completionReg._v = tmp_1.j2l(prefixText_0.z2r(CompletionSupport$showCompletion$lambda_1(singleOptionCompletionReg, editor, menuModel)));
    var itemsShownConsumer = completionSource.c93(Completion_getInstance().b9e_1);
    var tmp_2 = completionReg._v;
    var tmp_3 = PropertyBinding_instance;
    var tmp_4 = notNull(menuModel.c9i_1);
    // Inline function 'jetbrains.ocelot.base.observable.property.writableProperty' call
    var tmp$ret$10 = new CompletionSupport$showCompletion$$inlined$writableProperty$1(itemsShownConsumer);
    completionReg._v = tmp_2.j2l(tmp_3.n30(tmp_4, tmp$ret$10));
    var tmp_5 = completionReg._v;
    // Inline function 'jetbrains.ocelot.base.disposable.toDisposable' call
    var tmp$ret$11 = new CompletionSupport$showCompletion$$inlined$toDisposable$2(itemsShownConsumer);
    completionReg._v = tmp_5.j2l(tmp$ret$11);
    var disposeMenuMapper = new CompositeDisposable([]);
    var renderer = completionSource.c93(Completion_getInstance().a9e_1);
    var completionCell = CompletionMenu_getInstance().f9l(menuModel, completer, renderer, disposeMenuMapper, parameters.r9o_1);
    var tmp_6 = completionReg._v;
    completionReg._v = tmp_6.j2l(editor.w92(new CompletionSupport$showCompletion$5(menuModel, completionReg, restoreEnvState, completer, completionCell, editor)));
    var tmp_7;
    if (completionSource === editor) {
      tmp_7 = bindPosition(this, completionSource, completionCell);
    } else {
      tmp_7 = validateNoPositioning(this, completionSource);
    }
    var positionBinding = tmp_7;
    var tmp_8 = completionReg._v;
    // Inline function 'jetbrains.ocelot.base.disposable.toDisposable' call
    var tmp$ret$12 = new CompletionSupport$showCompletion$$inlined$toDisposable$3(completionCell, disposeMenuMapper, positionBinding);
    completionReg._v = tmp_8.j2l(tmp$ret$12);
    get_bottomPopupProp(editor).d2x(completionCell);
    var tmp_9 = completionReg._v;
    var tmp_10 = get_bottomPopupProp(editor);
    completionReg._v = tmp_9.j2l(tmp_10.z2r(CompletionSupport$showCompletion$lambda_2(completionReg)));
    // Inline function 'jetbrains.ocelot.base.disposable.toDisposable' call
    return (new CompletionSupport$showCompletion$$inlined$toDisposable$4(restoreEnvState)).j2l(completionReg._v);
  };
  protoOf(CompletionSupport).y9o = function (cell, side, supplier, endRT) {
    // Inline function 'kotlin.check' call
    if (!(cell.k91(side) == null)) {
      var message = 'Popup is already set: cell=' + toString_1(cell) + ', side=' + side.toString();
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    var container = cell.s8x();
    var completed = {_v: false};
    var dismissed = {_v: false};
    var restoreState = ensureNotNull(container).f9f();
    var wrap = CompletionSupport$showSideTransformPopup$lambda(completed);
    var popup = new HorizontalCell();
    var textCell = TextCell_init_$Create$();
    var dismiss = {_v: CompletionSupport$showSideTransformPopup$lambda_0};
    textCell.p92().d2x(true);
    var textEditingTrait = new CompletionSupport$showSideTransformPopup$textEditingTrait$1(supplier, wrap, dismiss, cell, container, endRT);
    var traitReg = textCell.w92(textEditingTrait);
    popup.o35().j(textCell);
    cell.i90(side, popup);
    var targetRegistration = connect(this, cell, textCell);
    textCell.s8n();
    dismiss._v = CompletionSupport$showSideTransformPopup$lambda_1(dismissed, popup, traitReg, targetRegistration, completed, restoreState);
    return textCell;
  };
  var CompletionSupport_instance;
  function CompletionSupport_getInstance() {
    if (CompletionSupport_instance == null)
      new CompletionSupport();
    return CompletionSupport_instance;
  }
  function DefaultCompletionConfig() {
    BaseCompletionConfig.call(this);
  }
  protoOf(DefaultCompletionConfig).p9d = function (completionItems, prefixText) {
    var matches = completionItems.q9n(prefixText);
    var strictlyPrefixed = completionItems.z9o(prefixText);
    return matches.p() === 1 && strictlyPrefixed.s();
  };
  function PopupCompletionEditor$1() {
    TextEditingTrait.call(this);
  }
  protoOf(PopupCompletionEditor$1).i92 = function (cell, event) {
  };
  function PopupCompletionEditor$$inlined$toDisposable$1($popup) {
    this.a9p_1 = $popup;
  }
  protoOf(PopupCompletionEditor$$inlined$toDisposable$1).zr = function () {
    this.a9p_1.r3p();
    return Unit_instance;
  };
  function PopupCompletionEditor(cell) {
    // Inline function 'kotlin.check' call
    if (!(get_frontPopup(cell) == null)) {
      var message = "Can't create editor: front popup is already set";
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    this.b9p_1 = TextCell_init_$Create$();
    this.b9p_1.p92().d2x(true);
    this.b9p_1.w92(new PopupCompletionEditor$1());
    var popup = new HorizontalCell();
    popup.o35().j(this.b9p_1);
    get_frontPopupProp(cell).d2x(popup);
    var tmp = this;
    var tmp_0 = this.b9p_1.g93(CompletionSupport_getInstance().i9f_1, cell);
    // Inline function 'jetbrains.ocelot.base.disposable.toDisposable' call
    var tmp$ret$2 = new PopupCompletionEditor$$inlined$toDisposable$1(popup);
    tmp.c9p_1 = tmp_0.j2l(tmp$ret$2);
  }
  protoOf(PopupCompletionEditor).g9e = function () {
    return this.b9p_1;
  };
  protoOf(PopupCompletionEditor).zr = function () {
    return this.c9p_1.zr();
  };
  function Side$LEFT() {
    Side_0.call(this, 'LEFT', 0);
    Side_LEFT_instance = this;
  }
  protoOf(Side$LEFT).f9p = function () {
    return get_LEFT_POPUP();
  };
  protoOf(Side$LEFT).g9p = function () {
    return Completion_getInstance().v9d_1;
  };
  protoOf(Side$LEFT).h9p = function () {
    return Completion_getInstance().x9d_1;
  };
  var Side_LEFT_instance;
  function Side$RIGHT() {
    Side_0.call(this, 'RIGHT', 1);
    Side_RIGHT_instance = this;
  }
  protoOf(Side$RIGHT).f9p = function () {
    return get_RIGHT_POPUP();
  };
  protoOf(Side$RIGHT).g9p = function () {
    return Completion_getInstance().w9d_1;
  };
  protoOf(Side$RIGHT).h9p = function () {
    return Completion_getInstance().y9d_1;
  };
  var Side_RIGHT_instance;
  function expand($this, editor, sideText) {
    var expanderFunction = editor.c93($this.h9p());
    var cellAction = expanderFunction(sideText);
    cellAction();
  }
  function Side$expansionProvider$lambda$lambda($cell, this$0) {
    return function (sideText) {
      var popupCell = CompletionSupport_getInstance().y9o($cell, this$0.f9p(), $cell.c93(this$0.g9p()), false);
      popupCell.o8w().d2x(sideText);
      return toEnd_0(popupCell);
    };
  }
  function Side$expansionProvider$lambda(this$0) {
    return function (cell) {
      return Side$expansionProvider$lambda$lambda(cell, this$0);
    };
  }
  function Side$handleSideTransform$lambda($editor, $cellText, $sideCompletion, $sideText) {
    return function () {
      $editor.o8w().d2x($cellText);
      $sideCompletion.l9p($sideText);
      return Unit_instance;
    };
  }
  function Side$handleSideTransform$lambda_0($editor, $cellText, this$0, $sideText) {
    return function () {
      $editor.o8w().d2x($cellText);
      expand(this$0, $editor, $sideText);
      return Unit_instance;
    };
  }
  var Side_entriesInitialized;
  function Side_initEntries() {
    if (Side_entriesInitialized)
      return Unit_instance;
    Side_entriesInitialized = true;
    Side_LEFT_instance = new Side$LEFT();
    Side_RIGHT_instance = new Side$RIGHT();
  }
  function Side_0(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  protoOf(Side_0).t9f = function () {
    return Side$expansionProvider$lambda(this);
  };
  protoOf(Side_0).i9p = function (editor, cellText, sideText, eagerCompletion) {
    var completionResult = Completion_getInstance().y9f(editor, Companion_getInstance_164().i9e_1, this.g9p());
    if (!get_isReady(completionResult))
      return false;
    var sideCompletion = CompletionItems_init_$Create$(completionResult);
    var tmp;
    if (sideCompletion.r9n(sideText, eagerCompletion)) {
      var tmp_0 = ensureNotNull(editor.s8x());
      tmp_0.d9m(Side$handleSideTransform$lambda(editor, cellText, sideCompletion, sideText));
      tmp = true;
    } else if (sideCompletion.m9p(sideText)) {
      var tmp_1 = ensureNotNull(editor.s8x());
      tmp_1.d9m(Side$handleSideTransform$lambda_0(editor, cellText, this, sideText));
      tmp = true;
    } else {
      tmp = false;
    }
    return tmp;
  };
  function Side_LEFT_getInstance() {
    Side_initEntries();
    return Side_LEFT_instance;
  }
  function Side_RIGHT_getInstance() {
    Side_initEntries();
    return Side_RIGHT_instance;
  }
  function SimpleCompletionEditor(editor) {
    this.n9p_1 = editor;
  }
  protoOf(SimpleCompletionEditor).g9e = function () {
    return this.n9p_1;
  };
  protoOf(SimpleCompletionEditor).zr = function () {
  };
  function BaseCompletionContext() {
  }
  protoOf(BaseCompletionContext).b9m = function () {
    return false;
  };
  function CompletionContext$Companion$MENU$1() {
    BaseCompletionContext.call(this);
  }
  protoOf(CompletionContext$Companion$MENU$1).b9m = function () {
    return true;
  };
  function CompletionContext$Companion$BULK$1() {
    BaseCompletionContext.call(this);
  }
  function CompletionContext$Companion$TOKENIZATION$1() {
    BaseCompletionContext.call(this);
  }
  function Companion_164() {
    Companion_instance_164 = this;
    this.i9e_1 = new BaseCompletionContext();
    var tmp = this;
    tmp.j9e_1 = new CompletionContext$Companion$MENU$1();
    var tmp_0 = this;
    tmp_0.k9e_1 = new CompletionContext$Companion$BULK$1();
    var tmp_1 = this;
    tmp_1.l9e_1 = new CompletionContext$Companion$TOKENIZATION$1();
  }
  var Companion_instance_164;
  function Companion_getInstance_164() {
    if (Companion_instance_164 == null)
      new Companion_164();
    return Companion_instance_164;
  }
  function CompletionSupplement() {
  }
  protoOf(CompletionSupplement).o9p = function (items) {
    return toCompletionSupplier_0(items);
  };
  var CompletionSupplement_instance;
  function CompletionSupplement_getInstance() {
    return CompletionSupplement_instance;
  }
  function get_EMPTY_COMPLETION_SUPPLIER() {
    _init_properties_CompletionSupplier_kt__qq82i0();
    return EMPTY_COMPLETION_SUPPLIER;
  }
  var EMPTY_COMPLETION_SUPPLIER;
  function simpleCompletionSupplier(items) {
    _init_properties_CompletionSupplier_kt__qq82i0();
    return toCompletionSupplier_0(items);
  }
  function toCompletionSupplier(_this__u8e3s4) {
    _init_properties_CompletionSupplier_kt__qq82i0();
    // Inline function 'jetbrains.ocelot.projectional.cell.completion.context.completionSupplier' call
    return new toCompletionSupplier$$inlined$completionSupplier$1(true, _this__u8e3s4);
  }
  function toCompletionSupplier_0(_this__u8e3s4) {
    _init_properties_CompletionSupplier_kt__qq82i0();
    return toCompletionSupplier(toList(_this__u8e3s4));
  }
  function EMPTY_COMPLETION_SUPPLIER$$inlined$completionSupplier$1($cacheable) {
    this.p9p_1 = $cacheable;
  }
  protoOf(EMPTY_COMPLETION_SUPPLIER$$inlined$completionSupplier$1).q9f = function () {
    return this.p9p_1;
  };
  protoOf(EMPTY_COMPLETION_SUPPLIER$$inlined$completionSupplier$1).m9e = function (completionContext) {
    return Companion_getInstance_168().q9p_1;
  };
  function toCompletionSupplier$$inlined$completionSupplier$1($cacheable, $this_toCompletionSupplier) {
    this.r9p_1 = $cacheable;
    this.s9p_1 = $this_toCompletionSupplier;
  }
  protoOf(toCompletionSupplier$$inlined$completionSupplier$1).q9f = function () {
    return this.r9p_1;
  };
  protoOf(toCompletionSupplier$$inlined$completionSupplier$1).m9e = function (completionContext) {
    return new SimpleCompletionResult(this.s9p_1);
  };
  var properties_initialized_CompletionSupplier_kt_83ae2y;
  function _init_properties_CompletionSupplier_kt__qq82i0() {
    if (!properties_initialized_CompletionSupplier_kt_83ae2y) {
      properties_initialized_CompletionSupplier_kt_83ae2y = true;
      // Inline function 'jetbrains.ocelot.projectional.cell.completion.context.completionSupplier' call
      EMPTY_COMPLETION_SUPPLIER = new EMPTY_COMPLETION_SUPPLIER$$inlined$completionSupplier$1(true);
    }
  }
  var CompletionItemSelectionMode_PREVIEW_instance;
  var CompletionItemSelectionMode_NORMAL_instance;
  function Companion_165() {
  }
  protoOf(Companion_165).t9p = function (createdByAutoCompletion) {
    return createdByAutoCompletion ? CompletionItemSelectionMode_PREVIEW_getInstance() : CompletionItemSelectionMode_NORMAL_getInstance();
  };
  var Companion_instance_165;
  function Companion_getInstance_165() {
    return Companion_instance_165;
  }
  var CompletionItemSelectionMode_entriesInitialized;
  function CompletionItemSelectionMode_initEntries() {
    if (CompletionItemSelectionMode_entriesInitialized)
      return Unit_instance;
    CompletionItemSelectionMode_entriesInitialized = true;
    CompletionItemSelectionMode_PREVIEW_instance = new CompletionItemSelectionMode('PREVIEW', 0);
    CompletionItemSelectionMode_NORMAL_instance = new CompletionItemSelectionMode('NORMAL', 1);
  }
  function CompletionItemSelectionMode(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function CompletionItemSelectionMode_PREVIEW_getInstance() {
    CompletionItemSelectionMode_initEntries();
    return CompletionItemSelectionMode_PREVIEW_instance;
  }
  function CompletionItemSelectionMode_NORMAL_getInstance() {
    CompletionItemSelectionMode_initEntries();
    return CompletionItemSelectionMode_NORMAL_instance;
  }
  function handleItem($this, item, loadMoreDistance) {
    if ($this.y9p_1)
      return Unit_instance;
    var index = lastIndexOf_1($this.d9q_1.y9h_1, item);
    if (!(index === -1) && hasNotLoadedItems($this) && $this.w9p_1.uv().g9q($this.b9q_1, index, loadMoreDistance)) {
      $this.t9i();
    }
  }
  function hasNotLoadedItems($this) {
    return $this.b9q_1.p() < ensureNotNull($this.z9p_1).p();
  }
  function initAllItems($this) {
    var prefix = $this.d9q_1.x9h_1.uv();
    var result = filterByPrefix($this, prefix);
    return sortedWith(result, Companion_getInstance_166().b9o_1);
  }
  function doReInitItems($this, selectedItem) {
    $this.z9p_1 = initAllItems($this);
    $this.a9q_1.d2x(ensureNotNull($this.z9p_1).p());
    var tmp;
    if (selectedItem == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp = ensureNotNull($this.z9p_1).w(selectedItem);
    }
    var tmp1_elvis_lhs = tmp;
    var selectedIndex = tmp1_elvis_lhs == null ? -1 : tmp1_elvis_lhs;
    var initiallyVisible = $this.w9p_1.uv().h9q(ensureNotNull($this.z9p_1), $this.u9p_1, selectedIndex);
    $this.b9q_1.k2();
    $this.b9q_1.q(initiallyVisible);
  }
  function filterByPrefix($this, prefix) {
    var result = ArrayList_init_$Create$();
    var _iterator__ex2g4s = $this.v9p_1.l2n().m();
    while (_iterator__ex2g4s.n()) {
      var item = _iterator__ex2g4s.o();
      if (item.n9n(prefix)) {
        result.j(item);
      }
    }
    return result;
  }
  function CompletionMenuModel$MyVisibleItemsUpdater$lambda(this$0) {
    return function (event) {
      var tmp;
      var tmp_0;
      // Inline function 'kotlin.text.isNotEmpty' call
      var this_0 = event.s2y_1;
      if (charSequenceLength(this_0) > 0) {
        tmp_0 = true;
      } else {
        // Inline function 'kotlin.text.isNotEmpty' call
        var this_1 = event.t2y_1;
        tmp_0 = charSequenceLength(this_1) > 0;
      }
      if (tmp_0) {
        this$0.w9p_1.d2x(LoadDirection_DOWN_getInstance());
        this$0.i9q(false);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CompletionMenuModel$MyVisibleItemsUpdater$lambda_0(this$0) {
    return function (event) {
      var tmp;
      if (event instanceof CompletionItemsAddedEvent) {
        this$0.i9q(false);
        tmp = Unit_instance;
      } else {
        if (event instanceof ErrorDuringCompletionItems) {
          this$0.c9q_1.d2x(true);
          tmp = Unit_instance;
        } else {
          noWhenBranchMatchedException();
        }
      }
      return Unit_instance;
    };
  }
  function CompletionMenuModel$MyVisibleItemsUpdater$lambda_1(this$0, $loadMoreSelectionDistance) {
    return function (it) {
      handleItem(this$0, it.t2y_1, $loadMoreSelectionDistance);
      return Unit_instance;
    };
  }
  function CompletionMenuModel$MyVisibleItemsUpdater$lambda_2(this$0, $loadMoreHoverDistance) {
    return function (it) {
      handleItem(this$0, it.t2y_1, $loadMoreHoverDistance);
      return Unit_instance;
    };
  }
  function CompletionMenuModel$MyVisibleItemsUpdater$reInitItems$lambda($selected) {
    return function (handler) {
      handler.n2s($selected);
      return Unit_instance;
    };
  }
  function CompletionMenuModel$LoadDirection$DOWN() {
    LoadDirection.call(this, 'DOWN', 0);
    LoadDirection_DOWN_instance = this;
  }
  protoOf(CompletionMenuModel$LoadDirection$DOWN).g9q = function (loaded, index, loadMoreDistance) {
    return ((loaded.p() - 1 | 0) - index | 0) <= loadMoreDistance;
  };
  protoOf(CompletionMenuModel$LoadDirection$DOWN).l9q = function (loaded, chunk, all) {
    var lastLoaded = all.v(last(loaded));
    if (lastLoaded === get_lastIndex_2(all)) {
      return Unit_instance;
    }
    var tmp0 = lastLoaded + chunk | 0;
    // Inline function 'kotlin.math.min' call
    var b = get_lastIndex_2(all);
    var newLastLoaded = Math.min(tmp0, b);
    loaded.q(all.g2(lastLoaded + 1 | 0, newLastLoaded + 1 | 0));
  };
  protoOf(CompletionMenuModel$LoadDirection$DOWN).h9q = function (src, chunk, selected) {
    // Inline function 'kotlin.math.max' call
    var b = selected + 1 | 0;
    var tmp0 = Math.max(chunk, b);
    // Inline function 'kotlin.math.min' call
    var b_0 = src.p();
    var tmp$ret$1 = Math.min(tmp0, b_0);
    return src.g2(0, tmp$ret$1);
  };
  var LoadDirection_DOWN_instance;
  function CompletionMenuModel$LoadDirection$UP() {
    LoadDirection.call(this, 'UP', 1);
    LoadDirection_UP_instance = this;
  }
  protoOf(CompletionMenuModel$LoadDirection$UP).g9q = function (loaded, index, loadMoreDistance) {
    return index <= loadMoreDistance;
  };
  protoOf(CompletionMenuModel$LoadDirection$UP).l9q = function (loaded, chunk, all) {
    var firstLoaded = all.w(loaded.r(0));
    if (firstLoaded === 0) {
      return Unit_instance;
    }
    // Inline function 'kotlin.math.max' call
    var a = firstLoaded - chunk | 0;
    var newFirstLoaded = Math.max(a, 0);
    loaded.i2(0, all.g2(newFirstLoaded, firstLoaded));
  };
  protoOf(CompletionMenuModel$LoadDirection$UP).h9q = function (src, chunk, selected) {
    // Inline function 'kotlin.math.max' call
    var a = src.p() - chunk | 0;
    var oneChunkDown = Math.max(a, 0);
    var tmp;
    if (selected >= 0) {
      // Inline function 'kotlin.math.min' call
      tmp = Math.min(oneChunkDown, selected);
    } else {
      tmp = oneChunkDown;
    }
    var fromIndex = tmp;
    return subListTail(src, fromIndex);
  };
  var LoadDirection_UP_instance;
  var LoadDirection_entriesInitialized;
  function LoadDirection_initEntries() {
    if (LoadDirection_entriesInitialized)
      return Unit_instance;
    LoadDirection_entriesInitialized = true;
    LoadDirection_DOWN_instance = new CompletionMenuModel$LoadDirection$DOWN();
    LoadDirection_UP_instance = new CompletionMenuModel$LoadDirection$UP();
  }
  function CompletionMenuModel$Companion$ITEMS_COMPARATOR$1() {
  }
  protoOf(CompletionMenuModel$Companion$ITEMS_COMPARATOR$1).o9q = function (a, b) {
    var delta = b.l9n() - a.l9n() | 0;
    var tmp;
    if (!(delta === 0)) {
      tmp = delta;
    } else {
      var text1 = '';
      var tmp_0;
      if (a.l9k(text1) && !b.l9k(text1)) {
        tmp_0 = -1;
      } else if (!a.l9k(text1) && b.l9k(text1)) {
        tmp_0 = 1;
      } else {
        tmp_0 = compareTo_1(a.c9k(), b.c9k(), true);
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  protoOf(CompletionMenuModel$Companion$ITEMS_COMPARATOR$1).compare = function (a, b) {
    var tmp = (!(a == null) ? isInterface(a, CompletionItem) : false) ? a : THROW_CCE();
    return this.o9q(tmp, (!(b == null) ? isInterface(b, CompletionItem) : false) ? b : THROW_CCE());
  };
  function _get_selectedIndex__ymlfp6($this) {
    var selected = $this.c9i_1.uv();
    $l$block: {
      // Inline function 'kotlin.checkNotNull' call
      if (selected == null) {
        var message = 'No selected item';
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      } else {
        break $l$block;
      }
    }
    var index = $this.y9h_1.w(selected);
    // Inline function 'kotlin.check' call
    if (!!(index === -1)) {
      var message_0 = 'Selected item not found in visible items';
      throw IllegalStateException_init_$Create$_0(toString_1(message_0));
    }
    return index;
  }
  function updateSelectedItem($this) {
    if ($this.y9h_1.s()) {
      $this.c9i_1.d2x(null);
    } else {
      $this.c9i_1.d2x($this.y9h_1.r(0));
    }
  }
  function setSelectedText($this, text) {
    var _iterator__ex2g4s = $this.y9h_1.m();
    while (_iterator__ex2g4s.n()) {
      var item = _iterator__ex2g4s.o();
      if (text === item.c9k()) {
        $this.c9i_1.d2x(item);
        return true;
      }
    }
    return false;
  }
  function setSelectedItem($this, direction) {
    if ($this.y9h_1.s()) {
      $this.c9i_1.d2x(null);
    }
    var index = direction === LoadDirection_DOWN_getInstance() ? 0 : get_lastIndex_2($this.y9h_1);
    $this.c9i_1.d2x($this.y9h_1.r(index));
  }
  function MyVisibleItemsUpdater($outer, chunkSize, loadMoreSelectionDistance, loadMoreHoverDistance, source) {
    this.d9q_1 = $outer;
    this.u9p_1 = chunkSize;
    this.v9p_1 = source;
    this.w9p_1 = new ValueProperty(LoadDirection_DOWN_getInstance());
    this.y9p_1 = false;
    this.z9p_1 = null;
    this.a9q_1 = new ValueProperty(0);
    this.b9q_1 = new ObservableArrayList();
    this.c9q_1 = new ValueProperty(false);
    var tmp = this;
    var tmp_0 = this.d9q_1.x9h_1.z2r(CompletionMenuModel$MyVisibleItemsUpdater$lambda(this));
    var tmp_1 = tmp_0.j2l(this.v9p_1.z2r(CompletionMenuModel$MyVisibleItemsUpdater$lambda_0(this)));
    var tmp_2 = tmp_1.j2l(this.d9q_1.c9i_1.z2r(CompletionMenuModel$MyVisibleItemsUpdater$lambda_1(this, loadMoreSelectionDistance)));
    tmp.x9p_1 = tmp_2.j2l(this.d9q_1.d9i_1.z2r(CompletionMenuModel$MyVisibleItemsUpdater$lambda_2(this, loadMoreHoverDistance)));
  }
  protoOf(MyVisibleItemsUpdater).t9i = function () {
    this.w9p_1.uv().l9q(this.b9q_1, this.u9p_1, ensureNotNull(this.z9p_1));
  };
  protoOf(MyVisibleItemsUpdater).zr = function () {
    return this.x9p_1.zr();
  };
  protoOf(MyVisibleItemsUpdater).p9q = function (direction) {
    if (hasNotLoadedItems(this)) {
      this.w9p_1.d2x(direction);
      this.i9q(true);
    } else {
      setSelectedItem(this.d9q_1, direction);
    }
  };
  protoOf(MyVisibleItemsUpdater).i9q = function (directionChanged) {
    var selected = this.d9q_1.c9i_1.uv();
    var selectedText = selected == null ? null : selected.c9k();
    doReInitItems(this, directionChanged ? null : selected);
    this.y9p_1 = true;
    try {
      if (directionChanged) {
        setSelectedItem(this.d9q_1, this.w9p_1.uv());
      } else if (selectedText == null || !setSelectedText(this.d9q_1, selectedText)) {
        updateSelectedItem(this.d9q_1);
      }
    }finally {
      this.y9p_1 = false;
    }
    this.d9q_1.b9i_1.k2s(CompletionMenuModel$MyVisibleItemsUpdater$reInitItems$lambda(selected));
    this.d9q_1.v9h_1.d2x(this.b9q_1.p() === 1);
  };
  function LoadDirection(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function Builder(completionResult) {
    this.d9o_1 = completionResult;
    this.e9o_1 = 20;
    this.f9o_1 = 8;
    this.g9o_1 = 12;
    this.h9o_1 = '';
    this.i9o_1 = false;
    this.j9o_1 = true;
  }
  protoOf(Builder).u9o = function (chunkSize) {
    this.e9o_1 = chunkSize;
    return this;
  };
  protoOf(Builder).v9o = function (loadMoreSelectionDistance) {
    this.f9o_1 = loadMoreSelectionDistance;
    return this;
  };
  protoOf(Builder).w9o = function (loadMoreHoverDistance) {
    this.g9o_1 = loadMoreHoverDistance;
    return this;
  };
  protoOf(Builder).k9o = function (prefixText) {
    this.h9o_1 = prefixText;
    return this;
  };
  protoOf(Builder).s9o = function (createdByAutoCompletion) {
    this.i9o_1 = createdByAutoCompletion;
    return this;
  };
  protoOf(Builder).t9o = function (value) {
    this.j9o_1 = value;
    return this;
  };
  protoOf(Builder).f40 = function () {
    return new CompletionMenuModel(this);
  };
  function Companion_166() {
    Companion_instance_166 = this;
    this.y9n_1 = 20;
    this.z9n_1 = 12;
    this.a9o_1 = 8;
    var tmp = this;
    tmp.b9o_1 = new CompletionMenuModel$Companion$ITEMS_COMPARATOR$1();
  }
  protoOf(Companion_166).c9o = function (completionResult) {
    return new Builder(completionResult);
  };
  var Companion_instance_166;
  function Companion_getInstance_166() {
    if (Companion_instance_166 == null)
      new Companion_166();
    return Companion_instance_166;
  }
  function CompletionMenuModel$_get_isDirectionDown_$lambda_n9qqs9(direction) {
    return direction === LoadDirection_DOWN_getInstance();
  }
  function LoadDirection_DOWN_getInstance() {
    LoadDirection_initEntries();
    return LoadDirection_DOWN_instance;
  }
  function LoadDirection_UP_getInstance() {
    LoadDirection_initEntries();
    return LoadDirection_UP_instance;
  }
  function CompletionMenuModel(builder) {
    Companion_getInstance_166();
    this.v9h_1 = new ValueProperty(false);
    this.b9i_1 = new Listeners();
    this.c9i_1 = new ValueProperty(null);
    this.d9i_1 = new ValueProperty(null);
    this.e9i_1 = new ValueProperty(false);
    this.x9h_1 = new ValueProperty(builder.h9o_1);
    this.a9i_1 = builder.d9o_1.q9q();
    this.u9h_1 = new MyVisibleItemsUpdater(this, builder.e9o_1, builder.f9o_1, builder.g9o_1, builder.d9o_1);
    this.y9h_1 = this.u9h_1.b9q_1;
    this.z9h_1 = this.u9h_1.c9q_1;
    this.u9h_1.i9q(false);
    var initialMode = Companion_instance_165.t9p(builder.i9o_1);
    this.w9h_1 = new ValueProperty(initialMode);
    this.f9i_1 = builder.j9o_1;
  }
  protoOf(CompletionMenuModel).y9i = function () {
    return map_0(this.u9h_1.w9p_1, CompletionMenuModel$_get_isDirectionDown_$lambda_n9qqs9);
  };
  protoOf(CompletionMenuModel).x9i = function () {
    return this.u9h_1.a9q_1;
  };
  protoOf(CompletionMenuModel).u9i = function () {
    return ensureNotNull(this.u9h_1.z9p_1);
  };
  protoOf(CompletionMenuModel).x9o = function () {
    return this.v9h_1;
  };
  protoOf(CompletionMenuModel).r9k = function () {
    return this.w9h_1;
  };
  protoOf(CompletionMenuModel).zr = function () {
    return this.u9h_1.zr();
  };
  protoOf(CompletionMenuModel).w9m = function () {
    this.w9h_1.d2x(CompletionItemSelectionMode_NORMAL_getInstance());
    var index = _get_selectedIndex__ymlfp6(this);
    if (index > 0) {
      this.c9i_1.d2x(this.y9h_1.r(index - 1 | 0));
    } else {
      this.u9h_1.p9q(LoadDirection_UP_getInstance());
    }
  };
  protoOf(CompletionMenuModel).x9m = function () {
    this.w9h_1.d2x(CompletionItemSelectionMode_NORMAL_getInstance());
    var index = _get_selectedIndex__ymlfp6(this);
    if (index < (this.y9h_1.p() - 1 | 0)) {
      this.c9i_1.d2x(this.y9h_1.r(index + 1 | 0));
    } else {
      this.u9h_1.p9q(LoadDirection_DOWN_getInstance());
    }
  };
  protoOf(CompletionMenuModel).t9i = function () {
    return this.u9h_1.t9i();
  };
  function CompletionParameters$Builder$restoreAction$lambda() {
    return Unit_instance;
  }
  function Builder_0() {
    var tmp = this;
    tmp.l9m_1 = CompletionParameters$Builder$restoreAction$lambda;
    this.m9m_1 = true;
    this.n9m_1 = false;
    this.o9m_1 = null;
    this.p9m_1 = null;
    this.q9m_1 = null;
    this.r9m_1 = 500;
  }
  protoOf(Builder_0).r9q = function (restoreAction) {
    this.l9m_1 = restoreAction;
    return this;
  };
  protoOf(Builder_0).s9q = function (singleOption) {
    this.m9m_1 = singleOption;
    return this;
  };
  protoOf(Builder_0).f40 = function () {
    return new CompletionParameters(this);
  };
  function Companion_167() {
    Companion_instance_167 = this;
    this.i9m_1 = (new Builder_0()).f40();
    this.j9m_1 = 500;
  }
  protoOf(Companion_167).c5f = function () {
    return new Builder_0();
  };
  protoOf(Companion_167).k9m = function (isSingleOption) {
    return (new Builder_0()).s9q(isSingleOption);
  };
  var Companion_instance_167;
  function Companion_getInstance_167() {
    if (Companion_instance_167 == null)
      new Companion_167();
    return Companion_instance_167;
  }
  function CompletionParameters(builder) {
    Companion_getInstance_167();
    this.l9o_1 = builder.l9m_1;
    this.m9o_1 = builder.m9m_1;
    this.n9o_1 = builder.n9m_1;
    this.o9o_1 = builder.o9m_1;
    this.p9o_1 = builder.p9m_1;
    this.q9o_1 = builder.q9m_1;
    this.r9o_1 = builder.r9m_1;
  }
  function BaseCompletionItem() {
  }
  protoOf(BaseCompletionItem).v9j = function () {
    return null;
  };
  protoOf(BaseCompletionItem).k9n = function () {
    return 0;
  };
  protoOf(BaseCompletionItem).l9n = function () {
    return 0;
  };
  protoOf(BaseCompletionItem).d9k = function () {
    return null;
  };
  protoOf(BaseCompletionItem).n9n = function (text) {
    return this.m9n(text) || this.l9k(text);
  };
  function CompletionItem() {
  }
  function completionItemByTextMatcher(matcher, visibleText, sortPriority, additionalText, completer) {
    return new CompletionItemByTextMatcher(matcher, visibleText, sortPriority, additionalText, completer);
  }
  function CompletionItemByTextMatcher(matcher, visibleText, sortPriority, additionalText, completer) {
    additionalText = additionalText === VOID ? null : additionalText;
    BaseCompletionItem.call(this);
    this.t9q_1 = matcher;
    this.u9q_1 = visibleText;
    this.v9q_1 = sortPriority;
    this.w9q_1 = additionalText;
    this.x9q_1 = completer;
  }
  protoOf(CompletionItemByTextMatcher).c9k = function () {
    return this.u9q_1;
  };
  protoOf(CompletionItemByTextMatcher).l9n = function () {
    return this.v9q_1;
  };
  protoOf(CompletionItemByTextMatcher).s9m = function (text) {
    return this.x9q_1(text);
  };
  protoOf(CompletionItemByTextMatcher).m9n = function (text) {
    return this.t9q_1.y9q(text) && !this.l9k(text);
  };
  protoOf(CompletionItemByTextMatcher).l9k = function (text) {
    return this.t9q_1.l9k(text);
  };
  protoOf(CompletionItemByTextMatcher).d9k = function () {
    return this.w9q_1;
  };
  protoOf(CompletionItemByTextMatcher).toString = function () {
    return "CompletionItem{visibleText='" + this.u9q_1 + "', matcher=" + toString_1(this.t9q_1) + '}';
  };
  function CompletionItems_init_$Init$(completionResult, $this) {
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.check' call
    if (!get_isReady(completionResult)) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    CompletionItems.call($this, completionResult.l2n());
    return $this;
  }
  function CompletionItems_init_$Create$(completionResult) {
    return CompletionItems_init_$Init$(completionResult, objectCreate(protoOf(CompletionItems)));
  }
  function reduce($this, items) {
    var tmp;
    if (items.p() <= 1) {
      tmp = items;
    } else {
      var iterator = items.m();
      var firstItem = iterator.o();
      var winningPriority = firstItem.k9n();
      var winningItems = ArrayList_init_$Create$();
      winningItems.j(firstItem);
      while (iterator.n()) {
        var item = iterator.o();
        if (item.k9n() === winningPriority) {
          winningItems.j(item);
        } else if (item.k9n() > winningPriority) {
          winningPriority = item.k9n();
          winningItems.k2();
          winningItems.j(item);
        }
      }
      tmp = winningItems;
    }
    return tmp;
  }
  function CompletionItems(items) {
    this.b9f_1 = ArrayList_init_$Create$_1(toList_0(items));
  }
  protoOf(CompletionItems).w2m = function () {
    return this.b9f_1.s();
  };
  protoOf(CompletionItems).l2n = function () {
    return this.b9f_1;
  };
  protoOf(CompletionItems).c9f = function (prefix) {
    // Inline function 'kotlin.collections.filter' call
    var tmp0 = this.l2n();
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList_init_$Create$();
    var _iterator__ex2g4s = tmp0.m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      if (element.n9n(prefix)) {
        destination.j(element);
      }
    }
    return destination;
  };
  protoOf(CompletionItems).z9o = function (prefix) {
    // Inline function 'kotlin.collections.filter' call
    var tmp0 = this.l2n();
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList_init_$Create$();
    var _iterator__ex2g4s = tmp0.m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      if (element.m9n(prefix)) {
        destination.j(element);
      }
    }
    return destination;
  };
  protoOf(CompletionItems).q9n = function (text) {
    // Inline function 'kotlin.collections.filter' call
    var tmp0 = this.l2n();
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList_init_$Create$();
    var _iterator__ex2g4s = tmp0.m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      if (element.l9k(text)) {
        destination.j(element);
      }
    }
    var list = destination;
    return reduce(this, list);
  };
  protoOf(CompletionItems).r9n = function (text, eager) {
    var matches = this.q9n(text);
    if (!(matches.p() === 1)) {
      return false;
    }
    if (eager) {
      return true;
    }
    var strictlyPrefixed = this.z9o(text);
    if (matches.e2(strictlyPrefixed)) {
      return true;
    }
    var allItems = ArrayList_init_$Create$_1(plus_5(matches, strictlyPrefixed));
    var reduced = reduce(this, allItems);
    return reduced.p() === 1 && reduced.e2(matches);
  };
  protoOf(CompletionItems).l9p = function (text) {
    this.q9n(text).r(0).s9m(text)();
  };
  protoOf(CompletionItems).m9p = function (text) {
    // Inline function 'kotlin.collections.isNotEmpty' call
    return !this.c9f(text).s();
  };
  function Companion_168() {
    Companion_instance_168 = this;
    this.q9p_1 = new EmptyCompletionResult();
  }
  var Companion_instance_168;
  function Companion_getInstance_168() {
    if (Companion_instance_168 == null)
      new Companion_168();
    return Companion_instance_168;
  }
  function CompletionResult() {
  }
  function get_isReady(_this__u8e3s4) {
    return _this__u8e3s4.q9q().uv();
  }
  function await_2(_this__u8e3s4, $completion) {
    var tmp = new $awaitCOROUTINE$_1(_this__u8e3s4, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  }
  function $awaitCOROUTINE$_1(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.i9r_1 = _this__u8e3s4;
  }
  protoOf($awaitCOROUTINE$_1).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = awaitValue_0(this.i9r_1.q9q(), true, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return this.i9r_1;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function CompletionResultChangeEvent() {
  }
  function CompletionItemsAddedEvent() {
    CompletionItemsAddedEvent_instance = this;
    CompletionResultChangeEvent.call(this);
  }
  var CompletionItemsAddedEvent_instance;
  function CompletionItemsAddedEvent_getInstance() {
    if (CompletionItemsAddedEvent_instance == null)
      new CompletionItemsAddedEvent();
    return CompletionItemsAddedEvent_instance;
  }
  function ErrorDuringCompletionItems(error) {
    CompletionResultChangeEvent.call(this);
    this.j9r_1 = error;
  }
  function CompletionResultTransformer$TransformedCompletionResult$addHandler$lambda($handler) {
    return function (it) {
      $handler.n2s(CompletionItemsAddedEvent_getInstance());
      return Unit_instance;
    };
  }
  function CompletionResultTransformer$add$1$addHandler$$inlined$eventHandler$1($handler) {
    this.k9r_1 = $handler;
  }
  protoOf(CompletionResultTransformer$add$1$addHandler$$inlined$eventHandler$1).o2v = function (event) {
    this.k9r_1.n2s(event);
    return Unit_instance;
  };
  protoOf(CompletionResultTransformer$add$1$addHandler$$inlined$eventHandler$1).n2s = function (event) {
    return this.o2v((event == null ? true : !(event == null)) ? event : THROW_CCE());
  };
  function TransformedCompletionResult($outer) {
    this.l9r_1 = $outer;
  }
  protoOf(TransformedCompletionResult).q9q = function () {
    return this.l9r_1.x9l_1.q9q();
  };
  protoOf(TransformedCompletionResult).z9q = function (handler) {
    return this.l9r_1.x9l_1.z2r(CompletionResultTransformer$TransformedCompletionResult$addHandler$lambda(handler));
  };
  protoOf(TransformedCompletionResult).y2r = function (handler) {
    return this.z9q(handler);
  };
  protoOf(TransformedCompletionResult).zr = function () {
    this.l9r_1.x9l_1.zr();
  };
  function Companion_169() {
  }
  protoOf(Companion_169).o8u = function () {
    return new CompletionResultTransformer(Companion_getInstance_168().q9p_1);
  };
  var Companion_instance_169;
  function Companion_getInstance_169() {
    return Companion_instance_169;
  }
  function CompletionResultTransformer$add$1(this$0, $result) {
    this.m9r_1 = this$0;
    this.n9r_1 = $result;
  }
  protoOf(CompletionResultTransformer$add$1).l2n = function () {
    return plus_5(this.m9r_1.x9l_1.l2n(), this.n9r_1.l2n());
  };
  protoOf(CompletionResultTransformer$add$1).q9q = function () {
    return and(this.m9r_1.x9l_1.q9q(), this.n9r_1.q9q());
  };
  protoOf(CompletionResultTransformer$add$1).z9q = function (handler) {
    // Inline function 'jetbrains.ocelot.base.observable.event.eventHandler' call
    var eventHandler = new CompletionResultTransformer$add$1$addHandler$$inlined$eventHandler$1(handler);
    return this.m9r_1.x9l_1.z9q(eventHandler).j2l(this.n9r_1.z9q(eventHandler));
  };
  protoOf(CompletionResultTransformer$add$1).y2r = function (handler) {
    return this.z9q(handler);
  };
  protoOf(CompletionResultTransformer$add$1).zr = function () {
    this.m9r_1.x9l_1.zr();
    this.n9r_1.zr();
  };
  function CompletionResultTransformer$map$transformedCompletionResult$1(this$0, $transform) {
    this.p9r_1 = this$0;
    this.q9r_1 = $transform;
    TransformedCompletionResult.call(this, this$0);
  }
  protoOf(CompletionResultTransformer$map$transformedCompletionResult$1).l2n = function () {
    var result = ArrayList_init_$Create$();
    var _iterator__ex2g4s = this.p9r_1.x9l_1.l2n().m();
    while (_iterator__ex2g4s.n()) {
      var item = _iterator__ex2g4s.o();
      var transformed = this.q9r_1(item);
      result.j(transformed);
    }
    return result;
  };
  function CompletionResultTransformer(completionResult) {
    this.x9l_1 = completionResult;
  }
  protoOf(CompletionResultTransformer).r9r = function (result) {
    return new CompletionResultTransformer(new CompletionResultTransformer$add$1(this, result));
  };
  protoOf(CompletionResultTransformer).y9l = function (transform) {
    var transformedCompletionResult = new CompletionResultTransformer$map$transformedCompletionResult$1(this, transform);
    return new CompletionResultTransformer(transformedCompletionResult);
  };
  protoOf(CompletionResultTransformer).uv = function () {
    return this.x9l_1;
  };
  function EmptyCompletionResult() {
    ReadyCompletionResult.call(this);
  }
  function FlowBasedCompletionResult$completionCollectorJob$slambda$slambda$lambda(it) {
    it.n2s(CompletionItemsAddedEvent_getInstance());
    return Unit_instance;
  }
  function FlowBasedCompletionResult$completionCollectorJob$slambda$slambda(this$0, resultContinuation) {
    this.b9s_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(FlowBasedCompletionResult$completionCollectorJob$slambda$slambda).d9s = function (item, $completion) {
    var tmp = this.e9s(item, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(FlowBasedCompletionResult$completionCollectorJob$slambda$slambda).v9 = function (p1, $completion) {
    return this.d9s((!(p1 == null) ? isInterface(p1, CompletionItem) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(FlowBasedCompletionResult$completionCollectorJob$slambda$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        if (tmp === 0) {
          this.g9_1 = 1;
          var tmp_0 = this.b9s_1;
          var tmp0 = this.b9s_1.i9s_1;
          var element = this.c9s_1;
          tmp_0.i9s_1 = tmp0.j(element);
          this.b9s_1.g9s_1.k2s(FlowBasedCompletionResult$completionCollectorJob$slambda$slambda$lambda);
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(FlowBasedCompletionResult$completionCollectorJob$slambda$slambda).e9s = function (item, completion) {
    var i = new FlowBasedCompletionResult$completionCollectorJob$slambda$slambda(this.b9s_1, completion);
    i.c9s_1 = item;
    return i;
  };
  function FlowBasedCompletionResult$completionCollectorJob$slambda$slambda_0(this$0, resultContinuation) {
    var i = new FlowBasedCompletionResult$completionCollectorJob$slambda$slambda(this$0, resultContinuation);
    var l = function (item, $completion) {
      return i.d9s(item, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function FlowBasedCompletionResult$completionCollectorJob$slambda$lambda($e) {
    return function (it) {
      it.n2s(new ErrorDuringCompletionItems($e));
      return Unit_instance;
    };
  }
  function sam$kotlinx_coroutines_flow_FlowCollector$0_9(function_0) {
    this.l9s_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_9).x18 = function (value, $completion) {
    return this.l9s_1(value, $completion);
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_9).f3 = function () {
    return this.l9s_1;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_9).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, FlowCollector) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_9).hashCode = function () {
    return hashCode(this.f3());
  };
  function FlowBasedCompletionResult$completionCollectorJob$slambda(this$0, resultContinuation) {
    this.u9s_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(FlowBasedCompletionResult$completionCollectorJob$slambda).e1h = function ($this$launch, $completion) {
    var tmp = this.f1h($this$launch, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(FlowBasedCompletionResult$completionCollectorJob$slambda).v9 = function (p1, $completion) {
    return this.e1h((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(FlowBasedCompletionResult$completionCollectorJob$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 4;
            this.g9_1 = 3;
            this.f9_1 = 1;
            var tmp_0 = cancellable(this.u9s_1.f9s_1);
            var tmp_1 = FlowBasedCompletionResult$completionCollectorJob$slambda$slambda_0(this.u9s_1, null);
            suspendResult = tmp_0.f18(new sam$kotlinx_coroutines_flow_FlowCollector$0_9(tmp_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.u9s_1.k9s_1.d2x(true);
            this.g9_1 = 4;
            this.f9_1 = 2;
            continue $sm;
          case 2:
            this.g9_1 = 4;
            return Unit_instance;
          case 3:
            this.g9_1 = 4;
            var tmp_2 = this.i9_1;
            if (tmp_2 instanceof Error) {
              var e = this.i9_1;
              if (!(e instanceof CancellationException)) {
                this.u9s_1.j9s_1 = true;
                this.u9s_1.g9s_1.k2s(FlowBasedCompletionResult$completionCollectorJob$slambda$lambda(e));
              }
              this.u9s_1.k9s_1.d2x(true);
              throw e;
            } else {
              throw this.i9_1;
            }

          case 4:
            throw this.i9_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.g9_1 === 4) {
          throw e_0;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(FlowBasedCompletionResult$completionCollectorJob$slambda).f1h = function ($this$launch, completion) {
    var i = new FlowBasedCompletionResult$completionCollectorJob$slambda(this.u9s_1, completion);
    i.v9s_1 = $this$launch;
    return i;
  };
  function FlowBasedCompletionResult$completionCollectorJob$slambda_0(this$0, resultContinuation) {
    var i = new FlowBasedCompletionResult$completionCollectorJob$slambda(this$0, resultContinuation);
    var l = function ($this$launch, $completion) {
      return i.e1h($this$launch, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function FlowBasedCompletionResult(coroutineScope, completionItemFlow) {
    this.f9s_1 = completionItemFlow;
    this.g9s_1 = new Listeners();
    var tmp = this;
    tmp.h9s_1 = launch(coroutineScope, VOID, VOID, FlowBasedCompletionResult$completionCollectorJob$slambda_0(this, null));
    this.i9s_1 = persistentListOf();
    this.j9s_1 = false;
    this.k9s_1 = new ValueProperty(false);
  }
  protoOf(FlowBasedCompletionResult).l2n = function () {
    return this.i9s_1;
  };
  protoOf(FlowBasedCompletionResult).q9q = function () {
    return this.k9s_1;
  };
  protoOf(FlowBasedCompletionResult).z9q = function (handler) {
    return this.g9s_1.j2s(handler);
  };
  protoOf(FlowBasedCompletionResult).y2r = function (handler) {
    return this.z9q(handler);
  };
  protoOf(FlowBasedCompletionResult).zr = function () {
    this.h9s_1.sp();
  };
  function ReadyCompletionResult() {
    this.s9r_1 = false;
  }
  protoOf(ReadyCompletionResult).q9q = function () {
    return Properties_getInstance().z2x_1;
  };
  protoOf(ReadyCompletionResult).z9q = function (handler) {
    return Companion_getInstance_29().m2l_1;
  };
  protoOf(ReadyCompletionResult).y2r = function (handler) {
    return this.z9q(handler);
  };
  protoOf(ReadyCompletionResult).zr = function () {
  };
  function SimpleCompletionItem(matchingText, visibleText, sortPriority, isCaseSensitive) {
    visibleText = visibleText === VOID ? matchingText : visibleText;
    sortPriority = sortPriority === VOID ? 0 : sortPriority;
    isCaseSensitive = isCaseSensitive === VOID ? true : isCaseSensitive;
    BaseCompletionItem.call(this);
    this.w9s_1 = matchingText;
    this.x9s_1 = visibleText;
    this.y9s_1 = sortPriority;
    this.z9s_1 = simpleTextMatcher(this.w9s_1, isCaseSensitive);
  }
  protoOf(SimpleCompletionItem).c9k = function () {
    return this.x9s_1;
  };
  protoOf(SimpleCompletionItem).l9n = function () {
    return this.y9s_1;
  };
  protoOf(SimpleCompletionItem).m9n = function (text) {
    return this.z9s_1.y9q(text) && !this.l9k(text);
  };
  protoOf(SimpleCompletionItem).l9k = function (text) {
    return this.z9s_1.l9k(text);
  };
  protoOf(SimpleCompletionItem).toString = function () {
    return "CompletionItem{visibleText='" + this.c9k() + "', matcher=" + toString_1(this.z9s_1) + '}';
  };
  function SimpleCompletionResult(items) {
    ReadyCompletionResult.call(this);
    this.b9t_1 = items;
  }
  protoOf(SimpleCompletionResult).l2n = function () {
    return this.b9t_1;
  };
  function WrapperCompletionItem(item) {
    this.j9n_1 = item;
  }
  protoOf(WrapperCompletionItem).toString = function () {
    return 'Wrapper { ' + toString_1(this.j9n_1) + ' }';
  };
  protoOf(WrapperCompletionItem).k9n = function () {
    return this.j9n_1.k9n();
  };
  protoOf(WrapperCompletionItem).l9n = function () {
    return this.j9n_1.l9n();
  };
  protoOf(WrapperCompletionItem).v9j = function () {
    return this.j9n_1.v9j();
  };
  protoOf(WrapperCompletionItem).c9k = function () {
    return this.j9n_1.c9k();
  };
  protoOf(WrapperCompletionItem).d9k = function () {
    return this.j9n_1.d9k();
  };
  protoOf(WrapperCompletionItem).m9n = function (text) {
    return this.j9n_1.m9n(text);
  };
  protoOf(WrapperCompletionItem).n9n = function (text) {
    return this.j9n_1.n9n(text);
  };
  protoOf(WrapperCompletionItem).l9k = function (text) {
    return this.j9n_1.l9k(text);
  };
  protoOf(WrapperCompletionItem).s9m = function (text) {
    return this.j9n_1.s9m(text);
  };
  function SimpleCaseSensitiveMatcher(matchingText) {
    this.c9t_1 = matchingText;
  }
  protoOf(SimpleCaseSensitiveMatcher).y9q = function (text) {
    return startsWith(this.c9t_1, text);
  };
  protoOf(SimpleCaseSensitiveMatcher).l9k = function (text) {
    return this.c9t_1 === text;
  };
  protoOf(SimpleCaseSensitiveMatcher).toString = function () {
    return "{pattern='" + this.c9t_1 + "', ignoreCase=false}";
  };
  function SimpleIgnoreCaseMatcher(matchingText) {
    var tmp = this;
    // Inline function 'kotlin.text.lowercase' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.d9t_1 = matchingText.toLowerCase();
  }
  protoOf(SimpleIgnoreCaseMatcher).y9q = function (text) {
    // Inline function 'kotlin.text.lowercase' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = text.toLowerCase();
    return startsWith(this.d9t_1, tmp$ret$1);
  };
  protoOf(SimpleIgnoreCaseMatcher).l9k = function (text) {
    return equals_0(this.d9t_1, text, true);
  };
  protoOf(SimpleIgnoreCaseMatcher).toString = function () {
    return "{pattern='" + this.d9t_1 + "', ignoreCase=true}";
  };
  function simpleTextMatcher(matchingText, isCaseSensitive) {
    var tmp;
    if (isCaseSensitive) {
      tmp = new SimpleCaseSensitiveMatcher(matchingText);
    } else {
      tmp = new SimpleIgnoreCaseMatcher(matchingText);
    }
    return tmp;
  }
  function get_hasFocusability() {
    _init_properties_CellHasFocusability_kt__h7a9uw();
    return hasFocusability;
  }
  var hasFocusability;
  function get_hasVisibility() {
    _init_properties_CellHasFocusability_kt__h7a9uw();
    return hasVisibility;
  }
  var hasVisibility;
  function get_compositeFocusables() {
    _init_properties_CellHasFocusability_kt__h7a9uw();
    return compositeFocusables;
  }
  var compositeFocusables;
  function get_cellNavCompositeFocusables() {
    _init_properties_CellHasFocusability_kt__h7a9uw();
    return cellNavCompositeFocusables;
  }
  var cellNavCompositeFocusables;
  function firstFocusable(_this__u8e3s4) {
    _init_properties_CellHasFocusability_kt__h7a9uw();
    return get_compositeFocusables().w8s(_this__u8e3s4);
  }
  function lastFocusable(_this__u8e3s4) {
    _init_properties_CellHasFocusability_kt__h7a9uw();
    return get_compositeFocusables().y8s(_this__u8e3s4);
  }
  function isVisible_1(_this__u8e3s4) {
    _init_properties_CellHasFocusability_kt__h7a9uw();
    return isVisible_0(_this__u8e3s4, get_hasVisibility());
  }
  function prevFocusable(_this__u8e3s4) {
    _init_properties_CellHasFocusability_kt__h7a9uw();
    return get_cellNavCompositeFocusables().r8s(_this__u8e3s4);
  }
  function nextFocusable(_this__u8e3s4) {
    _init_properties_CellHasFocusability_kt__h7a9uw();
    return get_cellNavCompositeFocusables().t8s(_this__u8e3s4);
  }
  function firstFocusable_0(_this__u8e3s4, deepest) {
    _init_properties_CellHasFocusability_kt__h7a9uw();
    return get_compositeFocusables().x8s(_this__u8e3s4, deepest);
  }
  function lastFocusable_0(_this__u8e3s4, deepest) {
    _init_properties_CellHasFocusability_kt__h7a9uw();
    return get_compositeFocusables().z8s(_this__u8e3s4, deepest);
  }
  function hasFocusability$lambda(cell) {
    _init_properties_CellHasFocusability_kt__h7a9uw();
    return cell.p92();
  }
  function hasVisibility$lambda(cell) {
    _init_properties_CellHasFocusability_kt__h7a9uw();
    return cell.m92();
  }
  var properties_initialized_CellHasFocusability_kt_sx6cue;
  function _init_properties_CellHasFocusability_kt__h7a9uw() {
    if (!properties_initialized_CellHasFocusability_kt_sx6cue) {
      properties_initialized_CellHasFocusability_kt_sx6cue = true;
      hasFocusability = hasFocusability$lambda;
      hasVisibility = hasVisibility$lambda;
      compositeFocusables = new CompositeFocusables(get_hasFocusability(), get_hasVisibility());
      cellNavCompositeFocusables = new NavCompositeFocusables(get_hasFocusability(), get_hasVisibility());
    }
  }
  function CellContainer() {
    return new CellContainerImpl();
  }
  function CellContainerPeerAdapter(edt) {
    this.e9t_1 = edt;
  }
  protoOf(CellContainerPeerAdapter).m93 = function () {
    return this.e9t_1;
  };
  protoOf(CellContainerPeerAdapter).n93 = function () {
    throw UnsupportedOperationException_init_$Create$();
  };
  protoOf(CellContainerPeerAdapter).o93 = function (tv, x) {
    throw UnsupportedOperationException_init_$Create$();
  };
  protoOf(CellContainerPeerAdapter).p93 = function (tv, caret) {
    return 0;
  };
  protoOf(CellContainerPeerAdapter).q93 = function (cell) {
    return Companion_getInstance_135().g8c_1;
  };
  protoOf(CellContainerPeerAdapter).r93 = function (cell) {
    return Companion_getInstance_136().h8c_1;
  };
  protoOf(CellContainerPeerAdapter).s93 = function (cell, offset) {
  };
  protoOf(CellContainerPeerAdapter).b93 = function (rectSupplier, cell) {
    return Asyncs_instance.a38();
  };
  protoOf(CellContainerPeerAdapter).u93 = function (root, loc) {
    return Cells_getInstance().u93(root, loc);
  };
  protoOf(CellContainerPeerAdapter).v93 = function (cell) {
    return Rectangle_init_$Create$(0, 0, 10000, 10000);
  };
  function resetEdt(_this__u8e3s4, edt) {
    var cellContainerPeer = new CellContainerPeerAdapter(edt);
    _this__u8e3s4.j9t(cellContainerPeer);
  }
  function get_CompletedJob() {
    _init_properties_CellCoroutines_kt__imgk8t();
    var tmp0 = CompletedJob$delegate;
    var tmp = KProperty0;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('CompletedJob', 0, tmp, _get_CompletedJob_$ref_g2mu8o(), null);
    return tmp0.a1();
  }
  var CompletedJob$delegate;
  function coroutineScope_0(_this__u8e3s4) {
    _init_properties_CellCoroutines_kt__imgk8t();
    return CoroutineScope_0(get_asCoroutineDispatcher(_this__u8e3s4.m93()));
  }
  function launch_0(_this__u8e3s4, key, cleanup, block) {
    key = key === VOID ? null : key;
    cleanup = cleanup === VOID ? Companion_getInstance_29().m2l_1 : cleanup;
    _init_properties_CellCoroutines_kt__imgk8t();
    if (!_this__u8e3s4.f89())
      return get_CompletedJob();
    var cell = _this__u8e3s4;
    if (!(key == null)) {
      var tmp0_safe_receiver = cell.c93(key);
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.sp();
      }
    }
    var threadSafe = newThreadSafeChecker();
    var tmp = coroutineScope_0(ensureNotNull(_this__u8e3s4.s8x()));
    var job = launch(tmp, VOID, VOID, launch$slambda_0(threadSafe, block, null));
    job.kp(launch$lambda(key, job, cell, cleanup));
    if (!(key == null)) {
      cell.g93(key, job);
    }
    return job;
  }
  function CompletedJob$delegate$lambda() {
    _init_properties_CellCoroutines_kt__imgk8t();
    // Inline function 'kotlin.also' call
    var this_0 = Job_0();
    this_0.su();
    return this_0;
  }
  function _get_CompletedJob_$ref_g2mu8o() {
    return function () {
      return get_CompletedJob();
    };
  }
  function launch$slambda($threadSafe, $block, resultContinuation) {
    this.s9t_1 = $threadSafe;
    this.t9t_1 = $block;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(launch$slambda).e1h = function ($this$launch, $completion) {
    var tmp = this.f1h($this$launch, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(launch$slambda).v9 = function (p1, $completion) {
    return this.e1h((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(launch$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.s9t_1.u2o();
            this.f9_1 = 1;
            suspendResult = this.t9t_1(this.u9t_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(launch$slambda).f1h = function ($this$launch, completion) {
    var i = new launch$slambda(this.s9t_1, this.t9t_1, completion);
    i.u9t_1 = $this$launch;
    return i;
  };
  function launch$slambda_0($threadSafe, $block, resultContinuation) {
    var i = new launch$slambda($threadSafe, $block, resultContinuation);
    var l = function ($this$launch, $completion) {
      return i.e1h($this$launch, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function launch$lambda($key, $job, $cell, $cleanup) {
    return function (it) {
      var tmp;
      if ($key == null || $job === $cell.c93($key)) {
        $cleanup.zr();
        tmp = Unit_instance;
      }
      var tmp_0;
      if (!($key == null) && $job === $cell.c93($key)) {
        $cell.g93($key, null);
        tmp_0 = Unit_instance;
      }
      return Unit_instance;
    };
  }
  var properties_initialized_CellCoroutines_kt_tvm401;
  function _init_properties_CellCoroutines_kt__imgk8t() {
    if (!properties_initialized_CellCoroutines_kt_tvm401) {
      properties_initialized_CellCoroutines_kt_tvm401 = true;
      CompletedJob$delegate = lazy(CompletedJob$delegate$lambda);
    }
  }
  function Companion_170() {
    Companion_instance_170 = this;
    this.s8y_1 = new CellEventSpec('keyPressed');
    this.t8y_1 = new CellEventSpec('keyReleased');
    this.u8y_1 = new CellEventSpec('keyTyped');
    this.v8y_1 = new CellEventSpec('mouseClicked');
    this.w8y_1 = new CellEventSpec('mouseDoubleClicked');
    this.x8y_1 = new CellEventSpec('mousePressed');
    this.y8y_1 = new CellEventSpec('mouseReleased');
    this.z8y_1 = new CellEventSpec('mouseMoved');
    this.a8z_1 = new CellEventSpec('mouseReleased');
    this.b8z_1 = new CellEventSpec('mouseEntered');
    this.c8z_1 = new CellEventSpec('mouseLeft');
    this.d8z_1 = new CellEventSpec('touchStarted');
    this.e8z_1 = new CellEventSpec('touchLongTapped');
    this.f8z_1 = new CellEventSpec('touchMoved');
    this.g8z_1 = new CellEventSpec('touchDragged');
    this.h8z_1 = new CellEventSpec('touchEnded');
    this.i8z_1 = new CellEventSpec('popupRequested');
    this.j8z_1 = new CellEventSpec('focusGained');
    this.k8z_1 = new CellEventSpec('focusLost');
    this.l8z_1 = new CellEventSpec('copy');
    this.m8z_1 = new CellEventSpec('cut');
    this.n8z_1 = new CellEventSpec('cut');
    this.o8z_1 = new CellEventSpec('complete');
    this.p8z_1 = new CellEventSpec('compositionStarted');
    this.q8z_1 = new CellEventSpec('compositionUpdated');
    this.r8z_1 = new CellEventSpec('compositionEnded');
  }
  var Companion_instance_170;
  function Companion_getInstance_170() {
    if (Companion_instance_170 == null)
      new Companion_170();
    return Companion_instance_170;
  }
  function CellEventSpec(name) {
    Companion_getInstance_170();
    this.o8y_1 = name;
  }
  protoOf(CellEventSpec).p8y = function (cell, event, trait) {
    var tmp;
    if (equals(this, Companion_getInstance_170().j8z_1)) {
      trait.p91(cell, event instanceof FocusEvent ? event : THROW_CCE());
      tmp = Unit_instance;
    } else if (equals(this, Companion_getInstance_170().k8z_1)) {
      trait.q91(cell, event instanceof FocusEvent ? event : THROW_CCE());
      tmp = Unit_instance;
    } else if (equals(this, Companion_getInstance_170().v8y_1)) {
      trait.r91(cell, event instanceof MouseEvent ? event : THROW_CCE());
      tmp = Unit_instance;
    } else if (equals(this, Companion_getInstance_170().w8y_1)) {
      trait.s91(cell, event instanceof MouseEvent ? event : THROW_CCE());
      tmp = Unit_instance;
    } else if (equals(this, Companion_getInstance_170().x8y_1)) {
      trait.t91(cell, event instanceof MouseEvent ? event : THROW_CCE());
      tmp = Unit_instance;
    } else if (equals(this, Companion_getInstance_170().y8y_1)) {
      trait.u91(cell, event instanceof MouseEvent ? event : THROW_CCE());
      tmp = Unit_instance;
    } else if (equals(this, Companion_getInstance_170().z8y_1)) {
      trait.v91(cell, event instanceof MouseEvent ? event : THROW_CCE());
      tmp = Unit_instance;
    } else if (equals(this, Companion_getInstance_170().a8z_1)) {
      trait.w91(cell, event instanceof MouseEvent ? event : THROW_CCE());
      tmp = Unit_instance;
    } else if (equals(this, Companion_getInstance_170().b8z_1)) {
      trait.x91(cell, event instanceof MouseEvent ? event : THROW_CCE());
      tmp = Unit_instance;
    } else if (equals(this, Companion_getInstance_170().c8z_1)) {
      trait.y91(cell, event instanceof MouseEvent ? event : THROW_CCE());
      tmp = Unit_instance;
    } else if (equals(this, Companion_getInstance_170().d8z_1)) {
      trait.z91(cell, event instanceof TouchEvent ? event : THROW_CCE());
      tmp = Unit_instance;
    } else if (equals(this, Companion_getInstance_170().e8z_1)) {
      trait.a92(cell, event instanceof TouchEvent ? event : THROW_CCE());
      tmp = Unit_instance;
    } else if (equals(this, Companion_getInstance_170().f8z_1)) {
      trait.b92(cell, event instanceof TouchEvent ? event : THROW_CCE());
      tmp = Unit_instance;
    } else if (equals(this, Companion_getInstance_170().g8z_1)) {
      trait.c92(cell, event instanceof TouchEvent ? event : THROW_CCE());
      tmp = Unit_instance;
    } else if (equals(this, Companion_getInstance_170().h8z_1)) {
      trait.d92(cell, event instanceof TouchEvent ? event : THROW_CCE());
      tmp = Unit_instance;
    } else if (equals(this, Companion_getInstance_170().i8z_1)) {
      trait.e92(cell, event instanceof MouseEvent ? event : THROW_CCE());
      tmp = Unit_instance;
    } else if (equals(this, Companion_getInstance_170().l8z_1)) {
      trait.f92(cell, event instanceof CopyCutEvent ? event : THROW_CCE());
      tmp = Unit_instance;
    } else if (equals(this, Companion_getInstance_170().m8z_1)) {
      trait.g92(cell, event instanceof CopyCutEvent ? event : THROW_CCE());
      tmp = Unit_instance;
    } else if (equals(this, Companion_getInstance_170().n8z_1)) {
      trait.h92(cell, event instanceof PasteEvent ? event : THROW_CCE());
      tmp = Unit_instance;
    } else if (equals(this, Companion_getInstance_170().o8z_1)) {
      trait.i92(cell, event instanceof CompletionEvent ? event : THROW_CCE());
      tmp = Unit_instance;
    } else if (equals(this, Companion_getInstance_170().p8z_1)) {
      trait.j92(cell, event instanceof CompositionEvent ? event : THROW_CCE());
      tmp = Unit_instance;
    } else if (equals(this, Companion_getInstance_170().q8z_1)) {
      trait.k92(cell, event instanceof CompositionEvent ? event : THROW_CCE());
      tmp = Unit_instance;
    } else if (equals(this, Companion_getInstance_170().r8z_1)) {
      trait.l92(cell, event instanceof CompositionEvent ? event : THROW_CCE());
      tmp = Unit_instance;
    } else {
      throw IllegalStateException_init_$Create$_0('Unknown event type ' + toString_1(event));
    }
    return tmp;
  };
  protoOf(CellEventSpec).toString = function () {
    return this.o8y_1;
  };
  function CompletionEvent(isSingleOption) {
    isSingleOption = isSingleOption === VOID ? true : isSingleOption;
    Event_0.call(this);
    this.h9m_1 = isSingleOption;
  }
  protoOf(CompletionEvent).toString = function () {
    return 'CompletionEvent[singleOption=' + this.h9m_1 + ']';
  };
  var EventPriority_NORMAL_instance;
  var EventPriority_LOW_instance;
  function values_6() {
    return [EventPriority_NORMAL_getInstance(), EventPriority_LOW_getInstance()];
  }
  var EventPriority_entriesInitialized;
  function EventPriority_initEntries() {
    if (EventPriority_entriesInitialized)
      return Unit_instance;
    EventPriority_entriesInitialized = true;
    EventPriority_NORMAL_instance = new EventPriority('NORMAL', 0);
    EventPriority_LOW_instance = new EventPriority('LOW', 1);
  }
  function EventPriority(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function EventPriority_NORMAL_getInstance() {
    EventPriority_initEntries();
    return EventPriority_NORMAL_instance;
  }
  function EventPriority_LOW_getInstance() {
    EventPriority_initEntries();
    return EventPriority_LOW_instance;
  }
  function FocusEvent(oldValue, newValue) {
    Event_0.call(this);
    this.x9t_1 = oldValue;
    this.y9t_1 = newValue;
  }
  protoOf(FocusEvent).n8i = function () {
    throw IllegalStateException_init_$Create$();
  };
  protoOf(FocusEvent).toString = function () {
    return 'FocusEvent[' + toString_0(this.x9t_1) + '->' + toString_0(this.y9t_1) + ']';
  };
  function Companion_171() {
    Companion_instance_171 = this;
    this.z9t_1 = CellPropertySpec_init_$Create$('image', Companion_instance_212.a9u(Companion_getInstance_136().h8c_1));
  }
  var Companion_instance_171;
  function Companion_getInstance_171() {
    if (Companion_instance_171 == null)
      new Companion_171();
    return Companion_instance_171;
  }
  function ImageCell() {
    Companion_getInstance_171();
    BaseCell_init_$Init$(this);
    this.y8w_1 = this.n92(Companion_getInstance_171().z9t_1);
  }
  protoOf(ImageCell).z8w = function () {
    return this.y8w_1;
  };
  function sam$jetbrains_ocelot_base_clipboard_ClipboardAdapter$0_0(function_0) {
    this.b9u_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_base_clipboard_ClipboardAdapter$0_0).u8o = function (systemClipboard) {
    return this.b9u_1(systemClipboard);
  };
  protoOf(sam$jetbrains_ocelot_base_clipboard_ClipboardAdapter$0_0).f3 = function () {
    return this.b9u_1;
  };
  protoOf(sam$jetbrains_ocelot_base_clipboard_ClipboardAdapter$0_0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, ClipboardAdapter) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_base_clipboard_ClipboardAdapter$0_0).hashCode = function () {
    return hashCode(this.f3());
  };
  function CellContainerImpl$Companion$defaultClipboardAdapter$lambda(it) {
    return defaultSystemClipboardInteraction(it);
  }
  function _get_externalClipboard__nfl76u($this) {
    var tmp0_elvis_lhs = $this.l9u_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.also' call
      var this_0 = $this.k9u_1.u8o($this.j9u_1.n93());
      $this.l9u_1 = this_0;
      tmp = this_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function createFocusedCellProp($this) {
    return new CellContainerImpl$createFocusedCellProp$1($this);
  }
  function changeCellUnderMouse($this, e, newValue) {
    if ($this.d9u_1 === newValue) {
      return Unit_instance;
    }
    var oldValue = $this.d9u_1;
    $this.d9u_1 = newValue;
    if (!(oldValue == null)) {
      oldValue.i90(get_HOVERED(), false);
      dispatch_3($this, oldValue, Companion_instance_141.o8l(e.z8l()), Companion_getInstance_170().c8z_1);
    }
    if (!(newValue == null)) {
      newValue.i90(get_HOVERED(), true);
      dispatch_3($this, newValue, Companion_instance_141.o8l(e.z8l()), Companion_getInstance_170().b8z_1);
    }
  }
  function mouseEventHappened($this, event, eventSpec, target) {
    if (equals(eventSpec, Companion_getInstance_170().x8y_1))
      $this.f9u_1 = target;
    else if (equals(eventSpec, Companion_getInstance_170().y8y_1))
      $this.f9u_1 = null;
    if (eventSpec === Companion_getInstance_170().a8z_1 && !($this.f9u_1 == null)) {
      dispatch_3($this, $this.f9u_1, event, eventSpec);
    } else {
      dispatch_3($this, target, event, eventSpec);
    }
  }
  function mouseEventHappened$default($this, event, eventSpec, target, $super) {
    target = target === VOID ? $this.n9u(event.z8l()) : target;
    return mouseEventHappened($this, event, eventSpec, target);
  }
  function dispatch_2($this, event, spec) {
    dispatch_3($this, $this.e9u_1.uv(), event, spec);
  }
  function dispatch_3($this, target, event, spec) {
    if (!(target == null)) {
      $this.d9m(CellContainerImpl$dispatch$lambda(target, event, spec));
    }
  }
  function isDependent($this, value, cell) {
    return !(value == null) && isDescendant(cell, value);
  }
  function Companion_172() {
    Companion_instance_172 = this;
    this.o9u_1 = new CellContainerPeerAdapter(new NullEventDispatchThread());
    var tmp = this;
    var tmp_0 = CellContainerImpl$Companion$defaultClipboardAdapter$lambda;
    tmp.p9u_1 = new sam$jetbrains_ocelot_base_clipboard_ClipboardAdapter$0_0(tmp_0);
  }
  var Companion_instance_172;
  function Companion_getInstance_172() {
    if (Companion_instance_172 == null)
      new Companion_172();
    return Companion_instance_172;
  }
  function CellContainerImpl$createFocusedCellProp$1(this$0) {
    this.t9u_1 = this$0;
    ValueProperty.call(this, null);
    this.s9u_1 = false;
  }
  protoOf(CellContainerImpl$createFocusedCellProp$1).u9u = function (newValue) {
    // Inline function 'kotlin.check' call
    if (!!this.s9u_1) {
      var message = "You can't change focus in focusCell change handler";
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    this.s9u_1 = true;
    try {
      if (!(newValue == null)) {
        // Inline function 'kotlin.check' call
        if (!canFocus(newValue)) {
          var message_0 = 'Cannot set focus to ' + toString_1(newValue);
          throw IllegalStateException_init_$Create$_0(toString_1(message_0));
        }
        // Inline function 'kotlin.require' call
        // Inline function 'kotlin.require' call
        if (!equals(newValue.s8x(), this.t9u_1)) {
          var message_1 = 'Failed requirement.';
          throw IllegalArgumentException_init_$Create$_0(toString_1(message_1));
        }
      }
      var oldValue = this.uv();
      if (oldValue === newValue)
        return Unit_instance;
      if (oldValue == null)
        null;
      else
        oldValue.i90(get_FOCUSED(), false);
      protoOf(ValueProperty).d2x.call(this, newValue);
      if (!(oldValue == null)) {
        dispatch_3(this.t9u_1, oldValue, new FocusEvent(oldValue, newValue), Companion_getInstance_170().k8z_1);
      }
      if (!(newValue == null)) {
        dispatch_3(this.t9u_1, newValue, new FocusEvent(oldValue, newValue), Companion_getInstance_170().j8z_1);
        newValue.i90(get_FOCUSED(), true);
      }
    }finally {
      this.s9u_1 = false;
    }
  };
  protoOf(CellContainerImpl$createFocusedCellProp$1).d2x = function (newValue) {
    return this.u9u((newValue == null ? true : isInterface(newValue, Cell)) ? newValue : THROW_CCE());
  };
  function CellContainerImpl$saveState$lambda($oldCell, this$0) {
    return function () {
      var tmp;
      if ($oldCell == null) {
        this$0.e9u_1.d2x(null);
        tmp = Unit_instance;
      } else {
        $oldCell.s8n();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CellContainerImpl$pasteFromExternalClipboard$slambda(this$0, resultContinuation) {
    this.d9v_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CellContainerImpl$pasteFromExternalClipboard$slambda).e1h = function ($this$launch, $completion) {
    var tmp = this.f1h($this$launch, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(CellContainerImpl$pasteFromExternalClipboard$slambda).v9 = function (p1, $completion) {
    return this.e1h((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CellContainerImpl$pasteFromExternalClipboard$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = _get_externalClipboard__nfl76u(this.d9v_1).p8p(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp0_safe_receiver = suspendResult;
            if (tmp0_safe_receiver == null)
              null;
            else {
              this.d9v_1.f9v(new PasteEvent(tmp0_safe_receiver));
            }

            return Unit_instance;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(CellContainerImpl$pasteFromExternalClipboard$slambda).f1h = function ($this$launch, completion) {
    var i = new CellContainerImpl$pasteFromExternalClipboard$slambda(this.d9v_1, completion);
    i.e9v_1 = $this$launch;
    return i;
  };
  function CellContainerImpl$pasteFromExternalClipboard$slambda_0(this$0, resultContinuation) {
    var i = new CellContainerImpl$pasteFromExternalClipboard$slambda(this$0, resultContinuation);
    var l = function ($this$launch, $completion) {
      return i.e1h($this$launch, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function CellContainerImpl$dispatch$lambda($target, $event, $spec) {
    return function () {
      $target.r92($event, $spec);
      return Unit_instance;
    };
  }
  function CellContainerListener$onBeforeCommand$ref() {
    var l = function (p0) {
      p0.h93();
      return Unit_instance;
    };
    l.callableName = 'onBeforeCommand';
    return l;
  }
  function CellContainerListener$onAfterCommand$ref() {
    var l = function (p0) {
      p0.i93();
      return Unit_instance;
    };
    l.callableName = 'onAfterCommand';
    return l;
  }
  function CellContainerImpl$cellPropertyChanged$lambda($cell, $prop, $change) {
    return function (listener) {
      listener.j93($cell, $prop, $change);
      return Unit_instance;
    };
  }
  function CellContainerImpl$cellChildAdded$lambda($cell, $change) {
    return function (listener) {
      listener.k93($cell, $change);
      return Unit_instance;
    };
  }
  function CellContainerImpl$cellChildRemoved$lambda($cell, $change) {
    return function (listener) {
      listener.l93($cell, $change);
      return Unit_instance;
    };
  }
  function CellContainerImpl() {
    Companion_getInstance_172();
    this.c9u_1 = new RootCell(this);
    this.d9u_1 = null;
    this.e9u_1 = createFocusedCellProp(this);
    this.f9u_1 = null;
    var tmp = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp.g9u_1 = ArrayList_init_$Create$();
    this.h9u_1 = new Listeners();
    this.i9u_1 = false;
    this.j9u_1 = Companion_getInstance_172().o9u_1;
    this.k9u_1 = Companion_getInstance_172().p9u_1;
    this.l9u_1 = null;
    this.m9u_1 = null;
  }
  protoOf(CellContainerImpl).t42 = function () {
    return this.c9u_1;
  };
  protoOf(CellContainerImpl).w93 = function () {
    return this.j9u_1;
  };
  protoOf(CellContainerImpl).m93 = function () {
    return this.w93().m93();
  };
  protoOf(CellContainerImpl).j9t = function (peer) {
    this.j9u_1 = peer;
  };
  protoOf(CellContainerImpl).g9v = function (adapter) {
    this.k9u_1 = adapter;
  };
  protoOf(CellContainerImpl).f9f = function () {
    var oldCell = this.e9u_1.uv();
    return CellContainerImpl$saveState$lambda(oldCell, this);
  };
  protoOf(CellContainerImpl).i8n = function (e) {
    if (e.o8j([KeyStrokeSpecs_getInstance().d8k_1])) {
      this.e8o(new CopyCutEvent());
      e.n8i();
    } else if (e.o8j([KeyStrokeSpecs_getInstance().e8k_1])) {
      this.d8o(new CopyCutEvent());
      e.n8i();
    } else if (e.o8j([KeyStrokeSpecs_getInstance().f8k_1])) {
      this.p8o();
      e.n8i();
    } else {
      if (e.o8j([KeyStrokeSpecs_getInstance().i8k_1])) {
        var event = new CompletionEvent();
        this.h9v(event);
        if (event.l8i_1) {
          e.n8i();
          return Unit_instance;
        }
      }
      dispatch_2(this, e, Companion_getInstance_170().s8y_1);
    }
  };
  protoOf(CellContainerImpl).f8o = function (e) {
    return dispatch_2(this, e, Companion_getInstance_170().t8y_1);
  };
  protoOf(CellContainerImpl).j8n = function (e) {
    return dispatch_2(this, e, Companion_getInstance_170().u8y_1);
  };
  protoOf(CellContainerImpl).o8n = function (e) {
    return mouseEventHappened$default(this, e, Companion_getInstance_170().v8y_1);
  };
  protoOf(CellContainerImpl).q8n = function (e) {
    return mouseEventHappened$default(this, e, Companion_getInstance_170().w8y_1);
  };
  protoOf(CellContainerImpl).r8n = function (e) {
    return mouseEventHappened$default(this, e, Companion_getInstance_170().x8y_1);
  };
  protoOf(CellContainerImpl).t8n = function (e) {
    return mouseEventHappened$default(this, e, Companion_getInstance_170().y8y_1);
  };
  protoOf(CellContainerImpl).v8n = function (e) {
    var cellUnderMouse = this.n9u(e.z8l());
    changeCellUnderMouse(this, e, cellUnderMouse);
    mouseEventHappened(this, e, Companion_getInstance_170().z8y_1, cellUnderMouse);
  };
  protoOf(CellContainerImpl).u8n = function (e) {
    var cellUnderMouse = this.n9u(e.z8l());
    mouseEventHappened(this, e, Companion_getInstance_170().a8z_1, cellUnderMouse);
    changeCellUnderMouse(this, e, cellUnderMouse);
  };
  protoOf(CellContainerImpl).w8n = function (e) {
    changeCellUnderMouse(this, e, this.n9u(e.z8l()));
  };
  protoOf(CellContainerImpl).y8n = function (e) {
    return changeCellUnderMouse(this, e, null);
  };
  protoOf(CellContainerImpl).e8o = function (e) {
    dispatch_2(this, e, Companion_getInstance_170().l8z_1);
    if (e.l8i_1) {
      _get_externalClipboard__nfl76u(this).n8p(e.s8i_1);
    }
  };
  protoOf(CellContainerImpl).d8o = function (e) {
    dispatch_2(this, e, Companion_getInstance_170().m8z_1);
    if (e.l8i_1) {
      _get_externalClipboard__nfl76u(this).n8p(e.s8i_1);
    }
  };
  protoOf(CellContainerImpl).f9v = function (e) {
    dispatch_2(this, e, Companion_getInstance_170().n8z_1);
  };
  protoOf(CellContainerImpl).h9v = function (event) {
    return dispatch_2(this, event, Companion_getInstance_170().o8z_1);
  };
  protoOf(CellContainerImpl).g8o = function (text) {
    var content = TextContentHelper_getInstance().r8m(text);
    var pasteEvent = new PasteEvent(content);
    dispatch_2(this, pasteEvent, Companion_getInstance_170().n8z_1);
  };
  protoOf(CellContainerImpl).p8o = function () {
    var tmp = coroutineScope_0(this);
    var tmp_0 = CoroutineStart_UNDISPATCHED_getInstance();
    launch(tmp, VOID, tmp_0, CellContainerImpl$pasteFromExternalClipboard$slambda_0(this, null));
  };
  protoOf(CellContainerImpl).m8o = function (e) {
    this.m9u_1 = this.e9u_1.uv();
    dispatch_3(this, this.m9u_1, e, Companion_getInstance_170().p8z_1);
  };
  protoOf(CellContainerImpl).n8o = function (e) {
    return dispatch_3(this, this.m9u_1, e, Companion_getInstance_170().q8z_1);
  };
  protoOf(CellContainerImpl).o8o = function (e) {
    dispatch_3(this, this.m9u_1, e, Companion_getInstance_170().r8z_1);
    this.m9u_1 = null;
  };
  protoOf(CellContainerImpl).u93 = function (current, loc) {
    return this.w93().u93(current, loc);
  };
  protoOf(CellContainerImpl).n9u = function (loc) {
    var target = null;
    var _iterator__ex2g4s = this.g9u_1.m();
    $l$loop: while (_iterator__ex2g4s.n()) {
      var popup = _iterator__ex2g4s.o();
      target = this.u93(popup, loc);
      if (!(target == null))
        break $l$loop;
    }
    if (target == null) {
      target = this.u93(this.c9u_1, loc);
    }
    if (target == null) {
      target = this.c9u_1;
    }
    return target;
  };
  protoOf(CellContainerImpl).d9m = function (runnable) {
    if (this.i9u_1) {
      runnable();
    } else {
      this.i9u_1 = true;
      this.h9u_1.k2s(CellContainerListener$onBeforeCommand$ref());
      try {
        runnable();
      }finally {
        this.h9u_1.k2s(CellContainerListener$onAfterCommand$ref());
        this.i9u_1 = false;
      }
    }
  };
  protoOf(CellContainerImpl).c90 = function (cell) {
    var _iterator__ex2g4s = get_asBaseCellInternal(cell).d90().m();
    while (_iterator__ex2g4s.n()) {
      var popup = _iterator__ex2g4s.o();
      this.g9u_1.j(popup);
    }
  };
  protoOf(CellContainerImpl).e90 = function (cell) {
    var _iterator__ex2g4s = get_asBaseCellInternal(cell).d90().m();
    while (_iterator__ex2g4s.n()) {
      var popup = _iterator__ex2g4s.o();
      this.g9u_1.h2(popup);
    }
  };
  protoOf(CellContainerImpl).t8x = function (removing) {
    // Inline function 'kotlin.require' call
    if (!equals(this, removing.s8x())) {
      var message = 'Not attached to current container: ' + toString_1(removing);
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    if (isDependent(this, this.e9u_1.uv(), removing)) {
      this.e9u_1.d2x(null);
    }
    if (isDependent(this, this.d9u_1, removing)) {
      this.d9u_1 = null;
    }
  };
  protoOf(CellContainerImpl).y8z = function (cell, prop, change) {
    this.h9u_1.k2s(CellContainerImpl$cellPropertyChanged$lambda(cell, prop, change));
  };
  protoOf(CellContainerImpl).l90 = function (cell, change) {
    this.h9u_1.k2s(CellContainerImpl$cellChildAdded$lambda(cell, change));
  };
  protoOf(CellContainerImpl).n90 = function (cell, change) {
    this.h9u_1.k2s(CellContainerImpl$cellChildRemoved$lambda(cell, change));
  };
  protoOf(CellContainerImpl).j90 = function (cell) {
    this.g9u_1.j(cell);
  };
  protoOf(CellContainerImpl).h90 = function (cell) {
    this.t8x(cell);
    this.g9u_1.h2(cell);
  };
  protoOf(CellContainerImpl).i9v = function (listener) {
    return this.h9u_1.j2s(listener);
  };
  protoOf(CellContainerImpl).j9v = function () {
    this.j9u_1 = Companion_getInstance_172().o9u_1;
  };
  protoOf(CellContainerImpl).v93 = function (cell) {
    return this.w93().v93(cell);
  };
  protoOf(CellContainerImpl).z92 = function () {
    return this.e9u_1;
  };
  protoOf(CellContainerImpl).k9v = function (cell) {
    // Inline function 'kotlin.sequences.find' call
    var tmp0 = ancestors(cell);
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.sequences.firstOrNull' call
      var _iterator__ex2g4s = tmp0.m();
      while (_iterator__ex2g4s.n()) {
        var element = _iterator__ex2g4s.o();
        if (element.k91(Companion_getInstance_153().s94_1)) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    var scrollRoot = tmp$ret$1;
    return scrollRoot == null ? this.c9u_1 : scrollRoot.y35();
  };
  function RootCell(cellContainer) {
    BaseCell.call(this, cellContainer);
  }
  function handleChildAdd($this, event) {
    checkRootIndent($this);
    var tmp0_safe_receiver = $this.v9v_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.k2s(IndentCell$handleChildAdd$lambda(event));
    }
  }
  function handleChildRemove($this, event) {
    checkRootIndent($this);
    var tmp0_safe_receiver = $this.v9v_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.k2s(IndentCell$handleChildRemove$lambda(event));
    }
  }
  function handlePropertyChanged($this, cell, prop, event) {
    checkRootIndent($this);
    var tmp0_safe_receiver = $this.v9v_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.k2s(IndentCell$handlePropertyChanged$lambda(cell, prop, event));
    }
  }
  function checkRootIndent($this) {
    // Inline function 'kotlin.check' call
    if (!$this.w9v()) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    return Unit_instance;
  }
  function IndentCell$scrollToAsync$lambda($rectSupplier, this$0, $ancestor) {
    return function () {
      var rect = $rectSupplier();
      return new Rectangle(rect.b8c_1.i8c(get_origin(this$0).j8c(get_origin($ancestor))), rect.c8c_1);
    };
  }
  function IndentCell$handleChildAdd$lambda($event) {
    return function (listener) {
      listener.x9v($event);
      return Unit_instance;
    };
  }
  function IndentCell$handleChildRemove$lambda($event) {
    return function (listener) {
      listener.y9v($event);
      return Unit_instance;
    };
  }
  function IndentCell$handlePropertyChanged$lambda($cell, $prop, $event) {
    return function (listener) {
      listener.z9v($cell, $prop, $event);
      return Unit_instance;
    };
  }
  function IndentCell$addListener$$inlined$toDisposable$1($disposable, $listeners, this$0) {
    this.a9w_1 = $disposable;
    this.b9w_1 = $listeners;
    this.c9w_1 = this$0;
  }
  protoOf(IndentCell$addListener$$inlined$toDisposable$1).zr = function () {
    this.a9w_1.zr();
    if (this.b9w_1._v.w2m()) {
      this.c9w_1.v9v_1 = null;
    }
    return Unit_instance;
  };
  function IndentCell(isIndented, indentNumSpaces) {
    isIndented = isIndented === VOID ? false : isIndented;
    indentNumSpaces = indentNumSpaces === VOID ? 2 : indentNumSpaces;
    BaseCell_init_$Init$(this);
    this.t9v_1 = isIndented;
    this.u9v_1 = indentNumSpaces;
    this.v9v_1 = null;
  }
  protoOf(IndentCell).w9v = function () {
    var tmp;
    if (this.f89()) {
      var tmp_0 = this.bp();
      tmp = !(tmp_0 instanceof IndentCell);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(IndentCell).a93 = function (rectSupplier) {
    // Inline function 'kotlin.sequences.find' call
    var tmp0 = ancestors(this);
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.sequences.firstOrNull' call
      var _iterator__ex2g4s = tmp0.m();
      while (_iterator__ex2g4s.n()) {
        var element = _iterator__ex2g4s.o();
        if (!(element instanceof IndentCell)) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    var ancestor = tmp$ret$1;
    var tmp = ensureNotNull(ancestor);
    return tmp.a93(IndentCell$scrollToAsync$lambda(rectSupplier, this, ancestor));
  };
  protoOf(IndentCell).d9w = function () {
    var tmp;
    if (this.w9v()) {
      tmp = this;
    } else {
      var parent = this.bp();
      var tmp_0;
      if (parent instanceof IndentCell) {
        tmp_0 = parent.d9w();
      } else {
        tmp_0 = null;
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  protoOf(IndentCell).w8z = function (prop, event) {
    protoOf(BaseCell).w8z.call(this, prop, event);
    var tmp0_safe_receiver = this.d9w();
    if (tmp0_safe_receiver == null)
      null;
    else {
      handlePropertyChanged(tmp0_safe_receiver, this, prop, event);
    }
  };
  protoOf(IndentCell).v8x = function (event) {
    protoOf(BaseCell).v8x.call(this, event);
    var tmp0_safe_receiver = this.d9w();
    if (tmp0_safe_receiver == null)
      null;
    else {
      handleChildAdd(tmp0_safe_receiver, event);
    }
  };
  protoOf(IndentCell).u8x = function (event) {
    protoOf(BaseCell).u8x.call(this, event);
    var tmp0_safe_receiver = this.d9w();
    if (tmp0_safe_receiver == null)
      null;
    else {
      handleChildRemove(tmp0_safe_receiver, event);
    }
  };
  protoOf(IndentCell).e9w = function (listener) {
    checkRootIndent(this);
    var listeners = {_v: this.v9v_1};
    if (listeners._v == null) {
      listeners._v = new Listeners();
      this.v9v_1 = listeners._v;
    }
    var disposable = listeners._v.j2s(listener);
    // Inline function 'jetbrains.ocelot.base.disposable.toDisposable' call
    return new IndentCell$addListener$$inlined$toDisposable$1(disposable, listeners, this);
  };
  function NewLineCell() {
    IndentCell.call(this);
  }
  protoOf(NewLineCell).v8x = function (event) {
    throw IllegalStateException_init_$Create$_0("You shouldn't add anything to new line cells");
  };
  function isNotRootIndent($this, cell) {
    var tmp;
    if (cell instanceof IndentCell) {
      tmp = !cell.w9v();
    } else {
      tmp = false;
    }
    return tmp;
  }
  function BaseIndentUpdatingListener(indentUpdater) {
    this.q9w_1 = indentUpdater;
  }
  protoOf(BaseIndentUpdatingListener).x9v = function (event) {
    var newItem = event.u2r();
    this.q9w_1.c8v(newItem);
    if (this.q9w_1.g8v(newItem)) {
      if (this.q9w_1.i8v(newItem) && isNotRootIndent(this, newItem.bp())) {
        this.s9w(newItem);
      } else if (!this.q9w_1.i8v(newItem)) {
        this.r9w(newItem);
      }
    }
  };
  protoOf(BaseIndentUpdatingListener).y9v = function (event) {
    this.q9w_1.d8v(event.s2r());
  };
  protoOf(BaseIndentUpdatingListener).z9v = function (cell, prop, event) {
    if (CounterUtil_getInstance().o9b(prop)) {
      this.v9w(cell, prop, event);
    } else if (isPopupProp(prop)) {
      var propertyChangeEvent = event instanceof PropertyChangeEvent ? event : THROW_CCE();
      this.u9w(propertyChangeEvent);
    } else if (prop === get_VISIBLE()) {
      if (!(event instanceof PropertyChangeEvent))
        THROW_CCE();
      this.q9w_1.e8v(cell, event);
      if (event.t2y_1) {
        this.r9w(cell);
      }
    } else if (Companion_getInstance_158().w9a_1.t(prop) && isNotRootIndent(this, cell)) {
      this.t9w(cell, prop);
    }
  };
  protoOf(BaseIndentUpdatingListener).r9w = function (cell) {
    var _iterator__ex2g4s = Companion_getInstance_158().w9a_1.m();
    while (_iterator__ex2g4s.n()) {
      var p = _iterator__ex2g4s.o();
      this.t9w(cell, p);
    }
  };
  function childAdded($this, child, watchVisibility) {
    if ($this.g8v(child)) {
      // Inline function 'kotlin.check' call
      if (!!$this.h8v(child)) {
        var message = 'child ' + toString_1(child) + ' is already attached';
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      }
      setAttached($this, child, true);
      onChildAdd($this, child);
    }
    if (watchVisibility) {
      // Inline function 'kotlin.check' call
      if (!!$this.x8u_1.o2(child)) {
        throw IllegalStateException_init_$Create$_0('Check failed.');
      }
      var tmp0 = $this.x8u_1;
      // Inline function 'kotlin.collections.set' call
      var value = watch_0($this, child);
      tmp0.t2(child, value);
    }
    if (!$this.i8v(child)) {
      var children = child.o35();
      var _iterator__ex2g4s = children.m();
      while (_iterator__ex2g4s.n()) {
        var c = _iterator__ex2g4s.o();
        childAdded($this, c, watchVisibility);
      }
    }
  }
  function childRemoved($this, child, unwatchVisibility) {
    var children = child.o35();
    if (unwatchVisibility) {
      ensureNotNull($this.x8u_1.u2(child)).zr();
    }
    if (!$this.i8v(child)) {
      var inductionVariable = children.p() - 1 | 0;
      if (0 <= inductionVariable)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + -1 | 0;
          var c = children.r(i);
          childRemoved($this, c, unwatchVisibility);
        }
         while (0 <= inductionVariable);
    }
    if ($this.g8v(child)) {
      // Inline function 'kotlin.check' call
      if (!$this.h8v(child)) {
        var message = 'child ' + toString_1(child) + ' is already detached';
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      }
      onChildRemove($this, child);
      setAttached($this, child, false);
    }
  }
  function onChildAdd($this, child) {
    var insertAt = new Position($this, child);
    var prevNewLinePos = prevNewLine($this, insertAt.y9w());
    if ($this.i8v(child)) {
      var wrapper = $this.s8u_1.n8v(child);
      // Inline function 'kotlin.collections.set' call
      $this.v8u_1.t2(child, wrapper);
      if (prevNewLinePos == null) {
        var first = new Position($this, firstLeaf($this, $this.q8u_1));
        children($this, $this.t8u_1).m2(first.z9w(insertAt), wrapper.w8v());
        var tmp0 = $this.w8u_1;
        // Inline function 'kotlin.collections.set' call
        var value = $this.t8u_1;
        tmp0.t2(child, value);
      } else {
        var targetLine = ensureNotNull($this.u8u_1.q2(prevNewLinePos.uv()));
        var indentDelta = calculateIndent($this, prevNewLinePos.uv()) > 0 ? 1 : 0;
        children($this, targetLine).m2((prevNewLinePos.z9w(insertAt) - 1 | 0) + indentDelta | 0, wrapper.w8v());
        // Inline function 'kotlin.collections.set' call
        $this.w8u_1.t2(child, targetLine);
      }
      wrapper.x8v();
    } else {
      if (child instanceof NewLineCell) {
        var nextNewLinePos = nextNewLine($this, insertAt.o());
        var newLine = $this.s8u_1.l8v();
        var indent = calculateIndent($this, child);
        if (indent > 0) {
          var indentItem = $this.s8u_1.m8v(indent);
          children($this, newLine).j(indentItem);
        }
        // Inline function 'kotlin.collections.set' call
        $this.u8u_1.t2(child, newLine);
        if (prevNewLinePos == null) {
          targetChildren($this).m2(1, newLine);
        } else {
          var prevLine = $this.u8u_1.q2(prevNewLinePos.uv());
          var prevLineIndex = lastIndexOf_1(targetChildren($this), prevLine);
          targetChildren($this).m2(prevLineIndex + 1 | 0, newLine);
        }
        var positions = nextNewLinePos == null ? toEnd($this, insertAt.o()) : range($this, insertAt.o(), nextNewLinePos);
        $l$loop: while (positions.n()) {
          var part = positions.o().uv();
          if (!$this.i8v(part))
            continue $l$loop;
          var wrapper_0 = ensureNotNull($this.v8u_1.q2(part));
          var item = wrapper_0.w8v();
          if ($this.s8u_1.r8v(item) == null) {
            throw IllegalStateException_init_$Create$();
          }
          removeFromParent_0($this, item);
          children($this, newLine).j(item);
        }
      }
    }
  }
  function targetChildren($this) {
    return children($this, $this.r8u_1);
  }
  function onChildRemove($this, child) {
    var removeAt = new Position($this, child);
    var prevNewLinePos = prevNewLine($this, removeAt.y9w());
    if ($this.i8v(child)) {
      var line;
      var index;
      if (prevNewLinePos == null) {
        var first = new Position($this, firstLeaf($this, $this.q8u_1));
        line = $this.t8u_1;
        index = first.z9w(removeAt);
      } else {
        line = ensureNotNull($this.u8u_1.q2(prevNewLinePos.uv()));
        index = (prevNewLinePos.z9w(removeAt) - 1 | 0) + (calculateIndent($this, prevNewLinePos.uv()) > 0 ? 1 : 0) | 0;
      }
      var toRemove = children($this, line).r(index);
      var wrapper = $this.v8u_1.q2(child);
      // Inline function 'kotlin.check' call
      if (!(ensureNotNull(wrapper).w8v() === toRemove)) {
        throw IllegalStateException_init_$Create$_0('Check failed.');
      }
      $this.w8u_1.u2(child);
      ensureNotNull($this.v8u_1.u2(child)).h4();
      children($this, line).n2(index);
    } else {
      if (child instanceof NewLineCell) {
        var lineCell = $this.u8u_1.u2(child);
        // Inline function 'kotlin.check' call
        if (!!(lineCell == null)) {
          throw IllegalStateException_init_$Create$_0('Check failed.');
        }
        if (calculateIndent($this, child) > 0) {
          children($this, lineCell).n2(0);
        }
        removeFromParent_0($this, lineCell);
        var tmp;
        if (prevNewLinePos == null) {
          tmp = $this.t8u_1;
        } else {
          tmp = ensureNotNull($this.u8u_1.q2(prevNewLinePos.uv()));
        }
        var mergeWith = tmp;
        var _iterator__ex2g4s = ArrayList_init_$Create$_1(children($this, lineCell)).m();
        while (_iterator__ex2g4s.n()) {
          var c = _iterator__ex2g4s.o();
          removeFromParent_0($this, c);
          children($this, mergeWith).j(c);
        }
      }
    }
  }
  function removeFromParent_0($this, c) {
    children($this, $this.s8u_1.r8v(c)).h2(c);
  }
  function prevNewLine($this, from) {
    var current = from;
    while (!(current == null)) {
      var tmp = current.uv();
      if (tmp instanceof NewLineCell) {
        return current;
      }
      current = current.y9w();
    }
    return null;
  }
  function nextNewLine($this, from) {
    var current = from;
    while (!(current == null)) {
      var tmp = current.uv();
      if (tmp instanceof NewLineCell) {
        return current;
      }
      current = current.o();
    }
    return null;
  }
  function toEnd($this, pos) {
    return new IndentUpdater$toEnd$1(pos);
  }
  function range($this, from, to) {
    return new IndentUpdater$range$1(from, to);
  }
  function calculateIndent($this, part) {
    var result = 0;
    var current = part.bp();
    var prevCurrent = part;
    while (!(current === $this.q8u_1)) {
      var prevNewLine_0 = prevNewLine($this, new Position($this, ensureNotNull(prevCurrent)));
      if (isIndented($this, current) && !(prevNewLine_0 == null) && prevNewLine_0.uv().bp() === current) {
        var tmp = result;
        result = tmp + (current instanceof IndentCell ? current : THROW_CCE()).u9v_1 | 0;
      }
      prevCurrent = current;
      current = ensureNotNull(current).bp();
    }
    return result;
  }
  function firstLeaf($this, item) {
    if ($this.i8v(item))
      return item;
    var _iterator__ex2g4s = item.o35().m();
    while (_iterator__ex2g4s.n()) {
      var child = _iterator__ex2g4s.o();
      if ($this.g8v(child) && !isEmptyIndent($this, child)) {
        return firstLeaf($this, child);
      }
    }
    return item;
  }
  function children($this, target) {
    return $this.s8u_1.p8v(target);
  }
  function setAttached($this, src, value) {
    if (value) {
      $this.a8v_1.j(src);
    } else {
      $this.a8v_1.h2(src);
    }
  }
  function isEmptyIndent($this, source) {
    if (!(source instanceof IndentCell))
      return false;
    var _iterator__ex2g4s = source.o35().m();
    $l$loop: while (_iterator__ex2g4s.n()) {
      var cell = _iterator__ex2g4s.o();
      if (!$this.g8v(cell))
        continue $l$loop;
      if (!isEmptyIndent($this, cell))
        return false;
    }
    return true;
  }
  function watch_0($this, child) {
    var tmp;
    if ($this.i8v(child)) {
      var tmp_0 = child.m92();
      tmp = tmp_0.z2r(IndentUpdater$watch$lambda($this, child));
    } else {
      tmp = Companion_getInstance_29().m2l_1;
    }
    return tmp;
  }
  function isIndented($this, src) {
    var tmp;
    if (src instanceof IndentCell) {
      tmp = src.t9v_1;
    } else {
      tmp = false;
    }
    return tmp;
  }
  function getCorrespondingLine($this, cell) {
    // Inline function 'kotlin.sequences.filterIsInstance' call
    var this_0 = ancestorsFrom(cell);
    var tmp = filter(this_0, IndentUpdater$getCorrespondingLine$lambda);
    var tmp$ret$0 = isInterface(tmp, Sequence) ? tmp : THROW_CCE();
    var indentParent = first_1(tmp$ret$0);
    var indentContainer = indentParent.d9w();
    var indentUpdater = $this.s8u_1.u8v(indentContainer);
    var tmp_0 = ancestorsFrom(cell);
    // Inline function 'kotlin.sequences.find' call
    var tmp0 = map(tmp_0, IndentUpdater$getCorrespondingLine$lambda_0(indentUpdater));
    var tmp$ret$2;
    $l$block: {
      // Inline function 'kotlin.sequences.firstOrNull' call
      var _iterator__ex2g4s = tmp0.m();
      while (_iterator__ex2g4s.n()) {
        var element = _iterator__ex2g4s.o();
        if (!(element == null)) {
          tmp$ret$2 = element;
          break $l$block;
        }
      }
      tmp$ret$2 = null;
    }
    return tmp$ret$2;
  }
  function IndentUpdater$toEnd$1($pos) {
    this.a9x_1 = $pos;
  }
  protoOf(IndentUpdater$toEnd$1).n = function () {
    return !(this.a9x_1 == null);
  };
  protoOf(IndentUpdater$toEnd$1).o = function () {
    var result = this.a9x_1;
    this.a9x_1 = ensureNotNull(this.a9x_1).o();
    return ensureNotNull(result);
  };
  function IndentUpdater$range$1($from, $to) {
    this.c9x_1 = $to;
    this.b9x_1 = $from;
  }
  protoOf(IndentUpdater$range$1).n = function () {
    return !equals(this.b9x_1, this.c9x_1);
  };
  protoOf(IndentUpdater$range$1).o = function () {
    var result = this.b9x_1;
    this.b9x_1 = ensureNotNull(this.b9x_1).o();
    return ensureNotNull(result);
  };
  function IndentUpdater$watch$lambda(this$0, $child) {
    return function (event) {
      this$0.j8v($child, event);
      return Unit_instance;
    };
  }
  function IndentUpdater$getCorrespondingLine$lambda(it) {
    return it instanceof IndentCell;
  }
  function IndentUpdater$getCorrespondingLine$lambda_0($indentUpdater) {
    return function (current) {
      return $indentUpdater.w8u_1.q2(current);
    };
  }
  function IndentUpdater(root, target, indentUpdaterTarget) {
    this.q8u_1 = root;
    this.r8u_1 = target;
    this.s8u_1 = indentUpdaterTarget;
    this.t8u_1 = this.s8u_1.l8v();
    this.u8u_1 = HashMap_init_$Create$();
    this.v8u_1 = HashMap_init_$Create$();
    this.w8u_1 = HashMap_init_$Create$();
    this.x8u_1 = HashMap_init_$Create$();
    this.y8u_1 = false;
    this.z8u_1 = null;
    this.a8v_1 = HashSet_init_$Create$();
    targetChildren(this).j(this.t8u_1);
  }
  protoOf(IndentUpdater).b8v = function () {
    this.y8u_1 = true;
  };
  protoOf(IndentUpdater).c8v = function (child) {
    return childAdded(this, child, true);
  };
  protoOf(IndentUpdater).d8v = function (child) {
    return childRemoved(this, child, true);
  };
  protoOf(IndentUpdater).e8v = function (item, change) {
    if (item === this.f8v())
      return Unit_instance;
    if (change.t2y_1) {
      childAdded(this, item, false);
    } else {
      this.z8u_1 = item;
      try {
        childRemoved(this, item, false);
      }finally {
        this.z8u_1 = null;
      }
    }
  };
  protoOf(IndentUpdater).f8v = function () {
    return this.q8u_1;
  };
  protoOf(IndentUpdater).g8v = function (source) {
    var current = source;
    while (!(current === this.q8u_1)) {
      var tmp0 = current;
      $l$block: {
        // Inline function 'kotlin.checkNotNull' call
        if (tmp0 == null) {
          var message = "Can't find a root indent container for " + toString_1(source);
          throw IllegalStateException_init_$Create$_0(toString_1(message));
        } else {
          break $l$block;
        }
      }
      if (!current.k91(get_VISIBLE()) && !(current === this.z8u_1)) {
        return false;
      }
      current = current.bp();
    }
    return true;
  };
  protoOf(IndentUpdater).h8v = function (src) {
    return this.a8v_1.t(src);
  };
  protoOf(IndentUpdater).i8v = function (source) {
    return !(source instanceof IndentCell);
  };
  protoOf(IndentUpdater).j8v = function (cell, event) {
  };
  protoOf(IndentUpdater).k8v = function (cell) {
    if (cell.o35().s())
      return get_bounds(this.q8u_1);
    var firstLeaf = firstVisibleLeaf(cell);
    if (firstLeaf == null || firstLeaf === cell)
      return null;
    var firstLine = getCorrespondingLine(this, firstLeaf);
    // Inline function 'kotlin.check' call
    if (!!(firstLine == null)) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    var tmp0_elvis_lhs = lastVisibleLeaf(cell);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var lastLeaf = tmp;
    var lastLine = getCorrespondingLine(this, lastLeaf);
    // Inline function 'kotlin.check' call
    if (!!(lastLine == null)) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    var tmp_0;
    if (firstLine === lastLine) {
      var singleLineBounds = this.s8u_1.t8v(firstLine);
      var lastBounds = get_bounds(lastLeaf);
      var firstBoundsOriginX = get_origin(firstLeaf).d8c_1;
      tmp_0 = new Rectangle(new Vector(firstBoundsOriginX, singleLineBounds.b8c_1.e8c_1), new Vector((lastBounds.b8c_1.d8c_1 + lastBounds.c8c_1.d8c_1 | 0) - firstBoundsOriginX | 0, singleLineBounds.c8c_1.e8c_1));
    } else {
      var firstLineBounds = this.s8u_1.t8v(firstLine);
      var lastLineBounds = this.s8u_1.t8v(lastLine);
      var firstLineOrigin = firstLineBounds.b8c_1;
      var lastLineOrigin = lastLineBounds.b8c_1;
      var lastLineDimension = lastLineBounds.c8c_1;
      tmp_0 = new Rectangle(firstLineOrigin, new Vector((lastLineOrigin.d8c_1 + lastLineDimension.d8c_1 | 0) - firstLineOrigin.d8c_1 | 0, (lastLineOrigin.e8c_1 + lastLineDimension.e8c_1 | 0) - firstLineOrigin.e8c_1 | 0));
    }
    return tmp_0;
  };
  function Position$nextLeaves$1$iterator$1($item, this$0) {
    this.f9x_1 = this$0;
    this.d9x_1 = $item;
    this.e9x_1 = next(this$0, $item);
  }
  protoOf(Position$nextLeaves$1$iterator$1).n = function () {
    return !(this.e9x_1 == null);
  };
  protoOf(Position$nextLeaves$1$iterator$1).o = function () {
    this.d9x_1 = this.e9x_1;
    this.e9x_1 = next(this.f9x_1, this.d9x_1);
    return ensureNotNull(this.d9x_1);
  };
  function next($this, item) {
    var tmp0_elvis_lhs = nextVisibleLeaf($this, item);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var next = tmp;
    return upperMostCell($this, next);
  }
  function prev($this, item) {
    var tmp0_elvis_lhs = prevVisibleLeaf($this, item);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var prev = tmp;
    return upperMostCell($this, prev);
  }
  function upperMostCell($this, item) {
    var current = item.bp();
    var upperMostCell = item;
    var root = $this.w9w_1.f8v();
    while (!(current === root)) {
      // Inline function 'kotlin.checkNotNull' call
      var tmp0 = current;
      $l$block: {
        // Inline function 'kotlin.checkNotNull' call
        if (tmp0 == null) {
          var message = 'Required value was null.';
          throw IllegalStateException_init_$Create$_0(toString_1(message));
        } else {
          break $l$block;
        }
      }
      if ($this.w9w_1.i8v(current)) {
        upperMostCell = current;
      }
      current = current.bp();
    }
    return upperMostCell;
  }
  function nextLeaves($this, item) {
    return new Position$nextLeaves$1(item, $this);
  }
  function nextVisibleLeaf($this, item) {
    var root = $this.w9w_1.f8v();
    var current = nextLeaf($this, item, root);
    while (!(current == null)) {
      if ($this.w9w_1.g8v(current))
        return current;
      current = nextLeaf($this, current, root);
    }
    return null;
  }
  function prevVisibleLeaf($this, item) {
    var root = $this.w9w_1.f8v();
    var current = prevLeaf($this, item, root);
    while (!(current == null)) {
      if ($this.w9w_1.g8v(current))
        return current;
      current = prevLeaf($this, current, root);
    }
    return null;
  }
  function firstChild_0($this, p) {
    var current = p.y35();
    while (!(current == null)) {
      if ($this.w9w_1.h8v(current))
        return current;
      current = current.p35();
    }
    return null;
  }
  function lastChild($this, p) {
    var current = p.z35();
    while (!(current == null)) {
      if ($this.w9w_1.h8v(current))
        return current;
      current = current.s35();
    }
    return null;
  }
  function prevSibling($this, c) {
    var current = c.s35();
    while (!(current == null)) {
      if ($this.w9w_1.h8v(current))
        return current;
      if (!$this.w9w_1.y8u_1 && $this.w9w_1.g8v(current))
        return null;
      current = current.s35();
    }
    return null;
  }
  function nextSibling($this, c) {
    var current = c.p35();
    while (!(current == null)) {
      if ($this.w9w_1.h8v(current))
        return current;
      if (!$this.w9w_1.y8u_1 && $this.w9w_1.g8v(current))
        return null;
      current = current.p35();
    }
    return null;
  }
  function firstLeaf_0($this, p) {
    var $this_0 = $this;
    var p_0 = p;
    $l$1: do {
      $l$0: do {
        var tmp0_elvis_lhs = firstChild_0($this_0, p_0);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          return p_0;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var first = tmp;
        $this_0 = $this_0;
        p_0 = first;
        continue $l$0;
      }
       while (false);
    }
     while (true);
  }
  function lastLeaf($this, p) {
    var $this_0 = $this;
    var p_0 = p;
    $l$1: do {
      $l$0: do {
        var tmp0_elvis_lhs = lastChild($this_0, p_0);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          return p_0;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var last = tmp;
        $this_0 = $this_0;
        p_0 = last;
        continue $l$0;
      }
       while (false);
    }
     while (true);
  }
  function nextLeaf($this, c, within) {
    var current = c;
    while (true) {
      var nextSibling_0 = nextSibling($this, ensureNotNull(current));
      if (!(nextSibling_0 == null)) {
        return firstLeaf_0($this, nextSibling_0);
      }
      var parent = current.bp();
      if (parent === within)
        return null;
      current = parent;
    }
  }
  function prevLeaf($this, c, within) {
    var current = c;
    while (true) {
      var prevSibling_0 = prevSibling($this, ensureNotNull(current));
      if (!(prevSibling_0 == null)) {
        return lastLeaf($this, prevSibling_0);
      }
      var parent = current.bp();
      if (parent === within)
        return null;
      current = parent;
    }
  }
  function Position$nextLeaves$1($item, this$0) {
    this.g9x_1 = $item;
    this.h9x_1 = this$0;
  }
  protoOf(Position$nextLeaves$1).m = function () {
    return new Position$nextLeaves$1$iterator$1(this.g9x_1, this.h9x_1);
  };
  function Position(updater, cell) {
    this.w9w_1 = updater;
    this.x9w_1 = cell;
  }
  protoOf(Position).o = function () {
    var tmp0_elvis_lhs = next(this, this.x9w_1);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var current = tmp;
    return new Position(this.w9w_1, current);
  };
  protoOf(Position).y9w = function () {
    var tmp0_elvis_lhs = prev(this, this.x9w_1);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var current = tmp;
    return new Position(this.w9w_1, current);
  };
  protoOf(Position).uv = function () {
    return this.x9w_1;
  };
  protoOf(Position).z9w = function (to) {
    if (to.x9w_1 === this.x9w_1)
      return 0;
    var tmp;
    if (Composites_instance.h36(this.x9w_1, to.x9w_1)) {
      var count = 0;
      var _iterator__ex2g4s = nextLeaves(this, this.x9w_1).m();
      $l$loop: while (_iterator__ex2g4s.n()) {
        var p = _iterator__ex2g4s.o();
        if (!(p instanceof IndentCell)) {
          count = count + 1 | 0;
        }
        if (p === to.x9w_1)
          break $l$loop;
      }
      tmp = count;
    } else {
      tmp = -to.z9w(this) | 0;
    }
    return tmp;
  };
  protoOf(Position).equals = function (other) {
    var tmp;
    if (!(other instanceof Position)) {
      tmp = false;
    } else {
      tmp = this.x9w_1 === other.x9w_1;
    }
    return tmp;
  };
  protoOf(Position).hashCode = function () {
    return hashCode(this.x9w_1);
  };
  function setAncestorProperty($this, leafMapper, spec, container, leaf) {
    var value = $this.i9x(spec, container, leaf);
    if (!equals(value, spec.b90(leaf))) {
      leafMapper.g9b(spec, value);
    }
  }
  function AncestorUtil() {
  }
  protoOf(AncestorUtil).i9x = function (spec, container, leaf) {
    var tmp0_safe_receiver = leaf.bp();
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'jetbrains.ocelot.base.composite.dispatchByParent' call
      var current = tmp0_safe_receiver;
      while (!(current == null)) {
        var $this$dispatchByParent = current;
        var value = $this$dispatchByParent.k91(spec);
        if (!equals(value, spec.b90($this$dispatchByParent))) {
          return value;
        }
        if ($this$dispatchByParent === container)
          return spec.b90(leaf);
        current = current.bp();
      }
    }
    return spec.b90(leaf);
  };
  protoOf(AncestorUtil).j9x = function (leafMapper, container, leaf) {
    var _iterator__ex2g4s = Companion_getInstance_158().w9a_1.m();
    while (_iterator__ex2g4s.n()) {
      var spec = _iterator__ex2g4s.o();
      setAncestorProperty(this, leafMapper, spec, container, leaf);
    }
  };
  var AncestorUtil_instance;
  function AncestorUtil_getInstance() {
    return AncestorUtil_instance;
  }
  function CellMapperContext(rootElement) {
    this.k9x_1 = rootElement;
    this.l9x_1 = HashMap_init_$Create$();
  }
  protoOf(CellMapperContext).m9x = function (mapper) {
    var target = mapper.f86_1;
    // Inline function 'kotlin.check' call
    if (!(this.l9x_1.q2(target) == null)) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    // Inline function 'kotlin.collections.set' call
    this.l9x_1.t2(target, mapper);
  };
  protoOf(CellMapperContext).n9x = function (mapper) {
    var result = this.l9x_1.u2(mapper.f86_1);
    // Inline function 'kotlin.check' call
    if (!(result === mapper)) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
  };
  protoOf(CellMapperContext).o9x = function (target) {
    return this.l9x_1.q2(target);
  };
  function CellMapperUtils() {
  }
  protoOf(CellMapperUtils).p9x = function (cell, ctx, factory) {
    var indentCell = cell instanceof IndentCell ? cell : THROW_CCE();
    // Inline function 'kotlin.check' call
    if (!indentCell.w9v()) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    return factory(indentCell, ctx);
  };
  var CellMapperUtils_instance;
  function CellMapperUtils_getInstance() {
    return CellMapperUtils_instance;
  }
  function IndentUtil() {
  }
  protoOf(IndentUtil).q9x = function (cell, handler) {
    var _iterator__ex2g4s = cell.o35().m();
    $l$loop: while (_iterator__ex2g4s.n()) {
      var child = _iterator__ex2g4s.o();
      if (!isVisible_1(child))
        continue $l$loop;
      if (child instanceof IndentCell) {
        this.q9x(child, handler);
      } else {
        handler(child);
      }
    }
  };
  var IndentUtil_instance;
  function IndentUtil_getInstance() {
    return IndentUtil_instance;
  }
  function Companion_173() {
    Companion_instance_173 = this;
    this.r9x_1 = new EmptyView();
  }
  var Companion_instance_173;
  function Companion_getInstance_173() {
    if (Companion_instance_173 == null)
      new Companion_173();
    return Companion_instance_173;
  }
  function EmptyView() {
    Companion_getInstance_173();
  }
  protoOf(EmptyView).q33 = function () {
    throw UnsupportedOperationException_init_$Create$();
  };
  protoOf(EmptyView).s9x = function () {
    return Companion_getInstance_136().h8c_1;
  };
  protoOf(EmptyView).t9x = function () {
    return 0;
  };
  protoOf(EmptyView).u9x = function (message) {
    return false;
  };
  protoOf(EmptyView).v9x = function (maxWidth) {
    return false;
  };
  function _get_linkText__2j4ckc($this) {
    if ($this.x9x_1 == null) {
      return '';
    }
    var sb = new StringBuilder('\n');
    getLinkText($this, $this.x9x_1, sb);
    return sb.toString();
  }
  function getLinkText($this, cell, sb) {
    if (cell instanceof TextCell) {
      sb.j8(cell.o8w().uv());
    } else {
      var _iterator__ex2g4s = cell.o35().m();
      while (_iterator__ex2g4s.n()) {
        var child = _iterator__ex2g4s.o();
        getLinkText($this, child, sb);
      }
    }
  }
  function Message(text, link, styler) {
    text = text === VOID ? null : text;
    link = link === VOID ? null : link;
    styler = styler === VOID ? null : styler;
    this.w9x_1 = text;
    this.x9x_1 = link;
    this.y9x_1 = styler;
    // Inline function 'kotlin.require' call
    if (!(!(this.w9x_1 == null) || !(this.x9x_1 == null))) {
      var message = 'Both text and link are null';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
  }
  protoOf(Message).z9x = function () {
    var tmp;
    if (this.x9x_1 == null) {
      tmp = new SimpleMessageView(ensureNotNull(this.w9x_1));
    } else {
      if (!(this.x9x_1.bp() == null)) {
        this.x9x_1.r3p();
      }
      tmp = new MessageViewWithLink(this.w9x_1, this.x9x_1);
    }
    return tmp;
  };
  protoOf(Message).equals = function (other) {
    if (this === other)
      return true;
    if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    var message = other instanceof Message ? other : THROW_CCE();
    return !(this.w9x_1 == ensureNotNull(message).w9x_1) ? false : this.x9x_1 === message.x9x_1;
  };
  protoOf(Message).hashCode = function () {
    // Inline function 'kotlin.hashCode' call
    var tmp0_safe_receiver = this.w9x_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    var result = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    var tmp = imul(31, result);
    var tmp0_safe_receiver_0 = this.x9x_1;
    var tmp1_elvis_lhs_0 = tmp0_safe_receiver_0 == null ? null : hashCode(tmp0_safe_receiver_0);
    result = tmp + (tmp1_elvis_lhs_0 == null ? 0 : tmp1_elvis_lhs_0) | 0;
    return result;
  };
  protoOf(Message).toString = function () {
    return plus_12(this.w9x_1, _get_linkText__2j4ckc(this));
  };
  function MessageCell$Companion$TRAIT$1() {
    CellTrait.call(this);
    this.a9y_1 = new MessagePopupSpec();
  }
  protoOf(MessageCell$Companion$TRAIT$1).n91 = function (cell, spec) {
    var specMatcher = specMatcherValue(Companion_getInstance_151().m94_1, this.a9y_1);
    // Inline function 'jetbrains.ocelot.projectional.cell.trait.getSpecValue' call
    var result = specMatcher(spec);
    var tmp;
    if (result == null) {
      tmp = protoOf(CellTrait).n91.call(this, cell, spec);
    } else {
      tmp = result.o9n_1;
    }
    return tmp;
  };
  function MessagePopupSpec() {
  }
  protoOf(MessagePopupSpec).q94 = function (cell) {
    return false;
  };
  protoOf(MessagePopupSpec).o94 = function (cell, dimension, viewport, alignedWidth) {
    var messageCell = cell instanceof MessageCell ? cell : THROW_CCE();
    return messageCell.l9y(dimension, new Vector(alignedWidth, viewport.e8c_1));
  };
  protoOf(MessagePopupSpec).p94 = function (cell, popup) {
  };
  function Companion_174() {
    Companion_instance_174 = this;
    this.m9y_1 = new Border(Companion_getInstance_210().r95_1, 1);
    this.n9y_1 = new Vector(600, 600);
    this.o9y_1 = 5;
    var tmp = this;
    tmp.p9y_1 = new MessageCell$Companion$TRAIT$1();
  }
  var Companion_instance_174;
  function Companion_getInstance_174() {
    if (Companion_instance_174 == null)
      new Companion_174();
    return Companion_instance_174;
  }
  function MessageCell(message) {
    Companion_getInstance_174();
    VerticalCell.call(this);
    this.j9y_1 = new ScrollCell();
    this.k9y_1 = message.z9x();
    this.j9y_1.o35().j(ensureNotNull(this.k9y_1.q33()));
    this.j9y_1.i90(Companion_getInstance_153().r94_1, Companion_getInstance_174().n9y_1);
    this.o35().j(this.j9y_1);
    this.i90(get_HAS_POPUP_DECORATION(), true);
    this.i90(get_HAS_SHADOW(), true);
    this.i90(get_BACKGROUND(), Companion_getInstance_210().c96_1);
    this.i90(get_BORDER(), Companion_getInstance_174().m9y_1);
    this.w92(Companion_getInstance_174().p9y_1);
  }
  protoOf(MessageCell).t9x = function () {
    return this.k9y_1.t9x();
  };
  protoOf(MessageCell).l9y = function (dimension, viewport) {
    var changedLayout = this.k9y_1.v9x(viewport.d8c_1 - 5 | 0);
    var maxLineDimension = this.k9y_1.s9x();
    var height = imul(maxLineDimension.e8c_1, this.t9x()) + 5 | 0;
    var scroll = height > viewport.e8c_1;
    this.j9y_1.i90(Companion_getInstance_153().t94_1, scroll);
    this.j9y_1.i90(Companion_getInstance_153().r94_1, viewport);
    var tmp;
    if (changedLayout) {
      var tmp0 = maxLineDimension.d8c_1 + 5 | 0;
      // Inline function 'kotlin.math.min' call
      var b = viewport.d8c_1;
      var tmp$ret$0 = Math.min(tmp0, b);
      tmp = new Vector(tmp$ret$0, scroll ? viewport.e8c_1 : height);
    } else {
      tmp = dimension;
    }
    return tmp;
  };
  function canHaveMessages($this, cell) {
    return !inPopup(cell);
  }
  function hasAnyMessage($this, cell) {
    return $this.y9y(cell) || $this.z9y(cell) || $this.a9z(cell) || $this.b9z(cell);
  }
  function set_1($this, cell, message, prop) {
    return $this.c9z(cell, new Message(message), prop);
  }
  function MessageController$install$lambda(cell) {
    return hasAnyMessage(MessageController_getInstance(), cell) && canHaveMessages(MessageController_getInstance(), cell);
  }
  function MessageController$install$lambda_0(cell) {
    return !Companion_getInstance_177().g9z(cell) && !hasAnyMessage(MessageController_getInstance(), cell);
  }
  function MessageController() {
    MessageController_instance = this;
    this.q9y_1 = 300;
    this.r9y_1 = 13;
    this.s9y_1 = Companion_getInstance_211().h9z('Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif');
    this.t9y_1 = CellPropertySpec_init_$Create$('error', null);
    this.u9y_1 = CellPropertySpec_init_$Create$('warning', null);
    this.v9y_1 = CellPropertySpec_init_$Create$('broken', null);
    this.w9y_1 = CellPropertySpec_init_$Create$('info', null);
    this.x9y_1 = listOf_0([this.w9y_1, this.v9y_1, this.t9y_1, this.u9y_1]);
  }
  protoOf(MessageController).i9z = function (container, styler) {
    var trait = new MessageTrait(container, new StyleApplicator(styler));
    var tmp = Companion_getInstance_187();
    var tmp_0 = MessageController$install$lambda;
    return tmp.k9z(container, trait, tmp_0, MessageController$install$lambda_0);
  };
  protoOf(MessageController).l9z = function (container, styler, $super) {
    styler = styler === VOID ? null : styler;
    return $super === VOID ? this.i9z(container, styler) : $super.i9z.call(this, container, styler);
  };
  protoOf(MessageController).m9z = function (cell, message) {
    return set_1(this, cell, message, this.t9y_1);
  };
  protoOf(MessageController).n9z = function (cell, message) {
    return set_1(this, cell, message, this.w9y_1);
  };
  protoOf(MessageController).o9z = function (cell, message) {
    return this.c9z(cell, message, this.w9y_1);
  };
  protoOf(MessageController).c9z = function (cell, message, prop) {
    var tmp;
    if (canHaveMessages(this, cell)) {
      tmp = setBackingToDefault(cell, prop, message);
    } else {
      tmp = Companion_getInstance_29().m2l_1;
    }
    return tmp;
  };
  protoOf(MessageController).y9y = function (cell) {
    return !(cell.k91(this.v9y_1) == null);
  };
  protoOf(MessageController).a9z = function (cell) {
    return !(cell.k91(this.u9y_1) == null);
  };
  protoOf(MessageController).z9y = function (cell) {
    return !(this.p9z(cell) == null);
  };
  protoOf(MessageController).b9z = function (cell) {
    return !(this.q9z(cell) == null);
  };
  protoOf(MessageController).p9z = function (cell) {
    return cell.k91(this.t9y_1);
  };
  protoOf(MessageController).q9z = function (cell) {
    return cell.k91(this.w9y_1);
  };
  var MessageController_instance;
  function MessageController_getInstance() {
    if (MessageController_instance == null)
      new MessageController();
    return MessageController_instance;
  }
  function setBackingToDefault(cell, prop, newValue) {
    cell.i90(prop, newValue);
    // Inline function 'jetbrains.ocelot.base.disposable.toDisposable' call
    return new setBackingToDefault$$inlined$toDisposable$1(cell, prop);
  }
  function setBackingToDefault$$inlined$toDisposable$1($cell, $prop) {
    this.r9z_1 = $cell;
    this.s9z_1 = $prop;
  }
  protoOf(setBackingToDefault$$inlined$toDisposable$1).zr = function () {
    this.r9z_1.i90(this.s9z_1, this.s9z_1.b90(this.r9z_1));
    return Unit_instance;
  };
  function subscribe($this, cell) {
    $this.w9z_1.t2(cell, doSubscribe($this, cell));
  }
  function doSubscribe($this, cell) {
    var result = Companion_getInstance_29().m2l_1;
    var _iterator__ex2g4s = get_POPUP_SPECS().m();
    while (_iterator__ex2g4s.n()) {
      var spec = _iterator__ex2g4s.o();
      var prop = ensureNotNull(cell).n92(spec);
      if (!(prop.uv() == null)) {
        $this.y9z_1.n2s(new PropertyChangeEvent(null, prop.uv()));
      }
      result = result.j2l(prop.y2r($this.y9z_1));
    }
    var tmp = result;
    // Inline function 'jetbrains.ocelot.base.disposable.toDisposable' call
    var tmp$ret$0 = new MessagePopupSupport$doSubscribe$$inlined$toDisposable$1(cell, $this);
    result = tmp.j2l(tmp$ret$0);
    result = result.j2l(ensureNotNull(cell).o35().y2r($this.aa0_1));
    var _iterator__ex2g4s_0 = cell.o35().m();
    while (_iterator__ex2g4s_0.n()) {
      var child = _iterator__ex2g4s_0.o();
      subscribe($this, child);
    }
    return result;
  }
  function onChildrenUpdated($this, event) {
    switch (event.r2r_1.x2_1) {
      case 0:
        subscribe($this, event.u2r());
        break;
      case 2:
        unsubscribe($this, event.s2r());
        break;
      case 1:
        unsubscribe($this, event.s2r());
        subscribe($this, event.u2r());
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    updateVisibility($this);
  }
  function onChildPopupBecameVisible($this, visible) {
    $this.v9z_1 = $this.v9z_1 + (visible ? 1 : -1) | 0;
    updateVisibility($this);
  }
  function onChildPopupChanged($this, event) {
    if (isRelevant($this, event.s2y_1)) {
      unsubscribePopup($this, ensureNotNull(event.s2y_1));
    }
    if (isRelevant($this, event.t2y_1)) {
      subscribePopup($this, ensureNotNull(event.t2y_1));
    }
    updateVisibility($this);
  }
  function isRelevant($this, popup) {
    return !(popup == null) && !(popup === $this.t9z_1) && !Companion_instance_175.ba0(popup);
  }
  function subscribePopup($this, popup) {
    $this.x9z_1.t2(popup, popup.m92().y2r($this.z9z_1));
    if (popup.m92().uv()) {
      $this.v9z_1 = $this.v9z_1 + 1 | 0;
    }
  }
  function unsubscribePopup($this, popup) {
    if ($this.x9z_1.w2m()) {
      return Unit_instance;
    }
    var tmp0_elvis_lhs = $this.x9z_1.u2(popup);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var disposable = tmp;
    disposable.zr();
    if (popup.m92().uv()) {
      $this.v9z_1 = $this.v9z_1 - 1 | 0;
    }
  }
  function updateVisibility($this) {
    // Inline function 'kotlin.check' call
    if (!($this.v9z_1 >= 0)) {
      var message = 'count=' + $this.v9z_1;
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    $this.t9z_1.m92().d2x($this.v9z_1 === 0 || $this.u9z_1);
  }
  function unsubscribe($this, cell) {
    var tmp0_elvis_lhs = $this.w9z_1.u2(cell);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalStateException_init_$Create$_0('Not registered ' + toString_1(cell));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var value = tmp;
    value.zr();
  }
  function Companion_175() {
  }
  protoOf(Companion_175).ba0 = function (popup) {
    var spec = popup.c93(Companion_getInstance_151().m94_1);
    return !(spec == null) && spec.n94();
  };
  var Companion_instance_175;
  function Companion_getInstance_175() {
    return Companion_instance_175;
  }
  function MessagePopupSupport$$inlined$eventHandler$1(this$0) {
    this.ca0_1 = this$0;
  }
  protoOf(MessagePopupSupport$$inlined$eventHandler$1).o2v = function (event) {
    onChildPopupBecameVisible(this.ca0_1, event.t2y_1);
    return Unit_instance;
  };
  protoOf(MessagePopupSupport$$inlined$eventHandler$1).n2s = function (event) {
    return this.o2v((event == null ? true : !(event == null)) ? event : THROW_CCE());
  };
  function MessagePopupSupport$$inlined$eventHandler$2(this$0) {
    this.da0_1 = this$0;
  }
  protoOf(MessagePopupSupport$$inlined$eventHandler$2).o2v = function (event) {
    var this_0 = this.da0_1;
    onChildPopupChanged(this_0, event);
    return Unit_instance;
  };
  protoOf(MessagePopupSupport$$inlined$eventHandler$2).n2s = function (event) {
    return this.o2v((event == null ? true : !(event == null)) ? event : THROW_CCE());
  };
  function MessagePopupSupport$$inlined$eventHandler$3(this$0) {
    this.ea0_1 = this$0;
  }
  protoOf(MessagePopupSupport$$inlined$eventHandler$3).o2v = function (event) {
    var this_0 = this.ea0_1;
    onChildrenUpdated(this_0, event);
    return Unit_instance;
  };
  protoOf(MessagePopupSupport$$inlined$eventHandler$3).n2s = function (event) {
    return this.o2v((event == null ? true : !(event == null)) ? event : THROW_CCE());
  };
  function MessagePopupSupport$doSubscribe$$inlined$toDisposable$1($cell, this$0) {
    this.fa0_1 = $cell;
    this.ga0_1 = this$0;
  }
  protoOf(MessagePopupSupport$doSubscribe$$inlined$toDisposable$1).zr = function () {
    var _iterator__ex2g4s = get_POPUP_SPECS().m();
    while (_iterator__ex2g4s.n()) {
      var spec = _iterator__ex2g4s.o();
      var popup = ensureNotNull(this.fa0_1).k91(spec);
      if (!(popup == null)) {
        this.ga0_1.y9z_1.n2s(new PropertyChangeEvent(popup, null));
      }
    }
    return Unit_instance;
  };
  function MessagePopupSupport(messagePopup, forceHide, forceShow) {
    this.t9z_1 = messagePopup;
    this.u9z_1 = forceShow;
    this.v9z_1 = 0;
    this.w9z_1 = new ListMap();
    this.x9z_1 = new ListMap();
    var tmp = this;
    // Inline function 'jetbrains.ocelot.base.observable.event.eventHandler' call
    tmp.z9z_1 = new MessagePopupSupport$$inlined$eventHandler$1(this);
    var tmp_0 = this;
    // Inline function 'jetbrains.ocelot.base.observable.event.eventHandler' call
    tmp_0.y9z_1 = new MessagePopupSupport$$inlined$eventHandler$2(this);
    var tmp_1 = this;
    // Inline function 'jetbrains.ocelot.base.observable.event.eventHandler' call
    tmp_1.aa0_1 = new MessagePopupSupport$$inlined$eventHandler$3(this);
    if (forceHide) {
      this.ha0(true);
    }
    subscribe(this, ensureNotNull(this.t9z_1.bp()));
    updateVisibility(this);
  }
  protoOf(MessagePopupSupport).ia0 = function () {
    return this.t9z_1.m92().uv();
  };
  protoOf(MessagePopupSupport).zr = function () {
    var _iterator__ex2g4s = this.w9z_1.y2m().m();
    while (_iterator__ex2g4s.n()) {
      var registration = _iterator__ex2g4s.o();
      registration.zr();
    }
    this.w9z_1.k2();
    this.x9z_1.k2();
    this.t9z_1.m92().d2x(false);
  };
  protoOf(MessagePopupSupport).ha0 = function (forceHide) {
    if (forceHide) {
      this.u9z_1 = false;
      this.v9z_1 = this.v9z_1 + 1 | 0;
    } else {
      this.v9z_1 = this.v9z_1 - 1 | 0;
    }
    updateVisibility(this);
  };
  protoOf(MessagePopupSupport).ja0 = function () {
    this.u9z_1 = true;
    updateVisibility(this);
  };
  function setProp($this, cell, prop, newValue) {
    var oldValue = cell.k91(prop);
    cell.i90(prop, newValue);
    // Inline function 'jetbrains.ocelot.base.disposable.toDisposable' call
    return new MessageStyler$setProp$$inlined$toDisposable$1(cell, prop, newValue, oldValue);
  }
  function Companion_176() {
    Companion_instance_176 = this;
    this.ka0_1 = new Color(248, 231, 172);
  }
  var Companion_instance_176;
  function Companion_getInstance_176() {
    if (Companion_instance_176 == null)
      new Companion_176();
    return Companion_instance_176;
  }
  function MessageStyler$setProp$$inlined$toDisposable$1($cell, $prop, $newValue, $oldValue) {
    this.la0_1 = $cell;
    this.ma0_1 = $prop;
    this.na0_1 = $newValue;
    this.oa0_1 = $oldValue;
  }
  protoOf(MessageStyler$setProp$$inlined$toDisposable$1).zr = function () {
    var value = this.la0_1.k91(this.ma0_1);
    if (equals(this.na0_1, value)) {
      this.la0_1.i90(this.ma0_1, this.oa0_1);
    }
    return Unit_instance;
  };
  function MessageStyler() {
    Companion_getInstance_176();
  }
  protoOf(MessageStyler).pa0 = function (cell) {
    return setProp(this, cell, get_LINK(), true);
  };
  protoOf(MessageStyler).qa0 = function (cell) {
    var tmp;
    if (cell instanceof TextCell) {
      tmp = setProp(this, cell, Companion_getInstance_154().c8x_1, Companion_getInstance_210().s95_1);
    } else {
      tmp = setProp(this, cell, get_BACKGROUND(), Companion_getInstance_210().k96_1);
    }
    return tmp;
  };
  protoOf(MessageStyler).ra0 = function (cell) {
    var tmp;
    if (cell instanceof TextCell) {
      tmp = setProp(this, cell, Companion_getInstance_154().c8x_1, Companion_getInstance_210().s95_1);
    } else {
      tmp = setProp(this, cell, get_RED_UNDERLINE(), true);
    }
    return tmp;
  };
  protoOf(MessageStyler).sa0 = function (cell) {
    return setProp(this, cell, get_BACKGROUND(), Companion_getInstance_176().ka0_1);
  };
  var HoverState_NONE_instance;
  var HoverState_PENDING_HIDE_instance;
  var HoverState_PENDING_SHOW_instance;
  var HoverState_entriesInitialized;
  function HoverState_initEntries() {
    if (HoverState_entriesInitialized)
      return Unit_instance;
    HoverState_entriesInitialized = true;
    HoverState_NONE_instance = new HoverState('NONE', 0);
    HoverState_PENDING_HIDE_instance = new HoverState('PENDING_HIDE', 1);
    HoverState_PENDING_SHOW_instance = new HoverState('PENDING_SHOW', 2);
  }
  function schedule($this, action) {
    var removeAction = MessageTrait$MyHoverController$schedule$lambda($this, action);
    $this.wa0_1 = _get_edt__e67mgs($this.xa0_1).v39(300, new sam$jetbrains_ocelot_base_edt_EdtTask$0_7(removeAction));
    // Inline function 'jetbrains.ocelot.base.disposable.toDisposable' call
    return (new MessageTrait$MyHoverController$schedule$$inlined$toDisposable$1(removeAction)).j2l($this.wa0_1);
  }
  function cancelHide($this, support) {
    if ($this.ya0(support) && $this.ta0_1.equals(HoverState_PENDING_HIDE_getInstance())) {
      $this.wa0_1.zr();
      cleanup_0($this);
      return true;
    }
    return false;
  }
  function cleanup_0($this) {
    $this.ua0_1 = null;
    $this.ta0_1 = HoverState_NONE_getInstance();
    $this.wa0_1 = Companion_getInstance_29().m2l_1;
    $this.va0_1 = Companion_getInstance_29().m2l_1;
  }
  function sam$jetbrains_ocelot_base_edt_EdtTask$0_7(function_0) {
    this.za0_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_7).au = function () {
    return this.za0_1();
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_7).f3 = function () {
    return this.za0_1;
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_7).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, EdtTask) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_7).hashCode = function () {
    return hashCode(this.f3());
  };
  function MessageTrait$MyHoverController$scheduleHide$lambda(this$0, $support) {
    return function () {
      hide_0(this$0, $support);
      return Unit_instance;
    };
  }
  function MessageTrait$MyHoverController$scheduleShow$lambda(this$0, $support) {
    return function () {
      var tmp;
      if (!this$0.ea1_1) {
        $support.ha0(false);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function MessageTrait$MyHoverController$schedule$lambda(this$0, $action) {
    return function () {
      cleanup_0(this$0);
      $action();
      return Unit_instance;
    };
  }
  function MessageTrait$MyHoverController$schedule$$inlined$toDisposable$1($removeAction) {
    this.ka1_1 = $removeAction;
  }
  protoOf(MessageTrait$MyHoverController$schedule$$inlined$toDisposable$1).zr = function () {
    this.ka1_1();
    return Unit_instance;
  };
  function _get_edt__e67mgs($this) {
    return $this.aa1_1.m93();
  }
  function postpone($this, cell, prop, event) {
    checkNotApplyingPendingUpdates($this);
    // Inline function 'kotlin.collections.getOrPut' call
    var this_0 = $this.ga1_1;
    var value = this_0.q2(cell);
    var tmp;
    if (value == null) {
      var answer = HashMap_init_$Create$();
      this_0.t2(cell, answer);
      tmp = answer;
    } else {
      tmp = value;
    }
    var updates = tmp;
    if (updates.o2(prop)) {
      var changeEvent = ensureNotNull(updates.q2(prop));
      var oldValue = changeEvent.s2y_1;
      if (equals(oldValue, event.t2y_1)) {
        updates.u2(prop);
      } else {
        // Inline function 'kotlin.collections.set' call
        var value_0 = new PropertyChangeEvent(oldValue, event.t2y_1);
        updates.t2(prop, value_0);
      }
    } else {
      // Inline function 'kotlin.collections.set' call
      updates.t2(prop, event);
    }
  }
  function setPopup($this, cell, message) {
    var popup = new MessageCell(message);
    popup.i90(get_VISIBLE(), false);
    cell.i90(Companion_getInstance_177().e9z_1, true);
    updatePopupValue($this, cell, popup);
  }
  function removePopup($this, cell, popup) {
    $l$block: {
      // Inline function 'kotlin.checkNotNull' call
      if (popup == null) {
        var message = 'Null popup value';
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      } else {
        break $l$block;
      }
    }
    hide($this, popup);
    if (cell.k91(Companion_getInstance_177().d9z_1) === popup) {
      updatePopupValue($this, cell, null);
    }
    cell.i90(Companion_getInstance_177().e9z_1, false);
  }
  function updatePopupValue($this, cell, newPopup) {
    $this.ha1_1 = true;
    try {
      cell.i90(Companion_getInstance_177().d9z_1, newPopup);
    }finally {
      $this.ha1_1 = false;
    }
  }
  function onEditingKeyEvent($this) {
    $this.da1_1 = _get_edt__e67mgs($this).t39();
    if ($this.ea1_1)
      return Unit_instance;
    setForceHide($this, true);
    var tmp = $this;
    var tmp_0 = _get_edt__e67mgs($this);
    var tmp_1 = MessageTrait$onEditingKeyEvent$lambda($this);
    tmp.ca1_1 = tmp_0.w39(300, new sam$jetbrains_ocelot_base_edt_EdtTask$0_8(tmp_1));
  }
  function applyPendingUpdates($this) {
    checkNotApplyingPendingUpdates($this);
    $this.fa1_1 = true;
    try {
      setForceHide($this, false);
      // Inline function 'kotlin.collections.iterator' call
      var _iterator__ex2g4s = $this.ga1_1.y().m();
      while (_iterator__ex2g4s.n()) {
        var _destruct__k2r9zo = _iterator__ex2g4s.o();
        // Inline function 'kotlin.collections.component1' call
        var cell = _destruct__k2r9zo.z();
        // Inline function 'kotlin.collections.component2' call
        var value = _destruct__k2r9zo.a1();
        // Inline function 'kotlin.collections.iterator' call
        var _iterator__ex2g4s_0 = value.y().m();
        while (_iterator__ex2g4s_0.n()) {
          var _destruct__k2r9zo_0 = _iterator__ex2g4s_0.o();
          // Inline function 'kotlin.collections.component1' call
          var key = _destruct__k2r9zo_0.z();
          // Inline function 'kotlin.collections.component2' call
          var value1 = _destruct__k2r9zo_0.a1();
          apply($this, cell, key, value1);
        }
      }
    }finally {
      $this.fa1_1 = false;
      $this.ga1_1.k2();
    }
  }
  function checkNotApplyingPendingUpdates($this) {
    // Inline function 'kotlin.check' call
    if (!!$this.fa1_1) {
      var message = 'applying pending updates';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
  }
  function setForceHide($this, forceHide) {
    if ($this.ea1_1 === forceHide)
      return Unit_instance;
    if (forceHide) {
      $this.ja1_1.la1();
    }
    $this.ea1_1 = forceHide;
    if (!($this.ia1_1 == null)) {
      var _iterator__ex2g4s = ensureNotNull($this.ia1_1).s2().m();
      while (_iterator__ex2g4s.n()) {
        var support = _iterator__ex2g4s.o();
        if (!$this.ja1_1.ya0(support)) {
          support.ha0($this.ea1_1);
        }
      }
    }
  }
  function getSupport($this, cell) {
    var popup = getMessagePopup($this, cell);
    var tmp;
    if (popup == null || $this.ia1_1 == null) {
      tmp = null;
    } else {
      tmp = ensureNotNull($this.ia1_1).q2(popup);
    }
    return tmp;
  }
  function shouldCloseMessage($this, cell, fromCell) {
    return cell == null || !(getMessagePopup($this, cell) == null) || !isDescendant(fromCell, cell);
  }
  function hidePopupOnMouseEvent($this, cell) {
    var support = getSupport($this, cell);
    if (!(support == null) && !$this.ja1_1.ya0(support)) {
      $this.ja1_1.ma1(support);
    } else {
      hidePopup($this, cell);
    }
  }
  function showPopupOnMouseEvent($this, cell) {
    var support = showPopup($this, cell, false);
    var shouldShow = !(support == null);
    if (shouldShow) {
      $this.ja1_1.na1(support);
    }
    return shouldShow;
  }
  function showPopupOnKeyEvent($this, cell) {
    return !(showPopup($this, cell, true) == null);
  }
  function showPopup($this, cell, forceShow) {
    var popup = getMessagePopup($this, cell);
    return popup == null ? null : show($this, popup, forceShow, cell.k91(Companion_getInstance_177().f9z_1));
  }
  function hidePopup($this, cell) {
    var popup = getMessagePopup($this, cell);
    return !(popup == null) && hide($this, popup);
  }
  function getMessagePopup($this, cell) {
    return Companion_getInstance_177().g9z(cell) ? cell.k91(Companion_getInstance_177().d9z_1) : null;
  }
  function show($this, popup, forceShow, userHide) {
    if ($this.ia1_1 == null) {
      $this.ia1_1 = HashMap_init_$Create$();
    }
    var support = ensureNotNull($this.ia1_1).q2(popup);
    if (!(support == null)) {
      if (forceShow) {
        support.ja0();
      } else if (!$this.ea1_1 && shouldPostponeShow($this, support)) {
        support.ha0(true);
      }
    } else {
      var forceHide = !forceShow || $this.ea1_1;
      support = new MessagePopupSupport(popup, forceHide, forceShow);
      if (userHide) {
        support.ha0(true);
      }
      var tmp0 = ensureNotNull($this.ia1_1);
      // Inline function 'kotlin.collections.set' call
      var value = support;
      tmp0.t2(popup, value);
    }
    return support;
  }
  function shouldPostponeShow($this, support) {
    return !support.ia0() && !$this.ja1_1.ya0(support);
  }
  function hide($this, popup) {
    if ($this.ia1_1 == null)
      return false;
    var support = ensureNotNull($this.ia1_1).u2(popup);
    if (!(support == null)) {
      onHide($this, support);
      return true;
    }
    return false;
  }
  function hide_0($this, support) {
    if (!($this.ia1_1 == null)) {
      ensureNotNull($this.ia1_1).s2().h2(support);
    }
    onHide($this, support);
  }
  function onHide($this, support) {
    if (!($this.ia1_1 == null) && ensureNotNull($this.ia1_1).s()) {
      $this.ia1_1 = null;
    }
    $this.ja1_1.oa1(support);
    support.zr();
  }
  function apply($this, cell, prop, change) {
    $this.ba1_1.ra1(cell);
    updatePopup($this, cell, prop, change);
  }
  function updatePopup($this, cell, prop, change) {
    var currentPopup = cell.k91(Companion_getInstance_177().d9z_1);
    var messagePopupActive = Companion_getInstance_177().g9z(cell);
    if (change.t2y_1 == null && messagePopupActive) {
      var next = getNextNonNull($this, cell, prop);
      if (next == null) {
        removePopup($this, cell, currentPopup);
      } else {
        updateMessage($this, cell, currentPopup instanceof MessageCell ? currentPopup : THROW_CCE(), ensureNotNull(cell.k91(next)));
      }
      return Unit_instance;
    }
    if (change.s2y_1 == null) {
      if (messagePopupActive) {
        var withHighestPriority = getFirstNonNull($this, cell);
        if (compare_0($this, prop, withHighestPriority)) {
          updateMessage($this, cell, currentPopup instanceof MessageCell ? currentPopup : THROW_CCE(), ensureNotNull(change.t2y_1));
        }
      } else if (currentPopup == null) {
        setPopup($this, cell, ensureNotNull(cell.k91(prop)));
      }
      return Unit_instance;
    }
    if (messagePopupActive) {
      var withHighestPriority_0 = getFirstNonNull($this, cell);
      if (prop === withHighestPriority_0) {
        updateMessage($this, cell, currentPopup instanceof MessageCell ? currentPopup : THROW_CCE(), ensureNotNull(change.t2y_1));
      }
    }
  }
  function updateMessage($this, cell, previousPopup, message) {
    cell.i90(Companion_getInstance_177().e9z_1, true);
    if (previousPopup.k9y_1.u9x(message)) {
      return Unit_instance;
    }
    var newPopup = new MessageCell(message);
    newPopup.m92().d2x(previousPopup.m92().uv());
    updatePopupValue($this, cell, newPopup);
  }
  function compare_0($this, p1, p2) {
    return MessageController_getInstance().x9y_1.w(p1) <= indexOf_5(MessageController_getInstance().x9y_1, p2);
  }
  function getFirstNonNull($this, cell) {
    return getNextNonNull($this, cell, null);
  }
  function getNextNonNull($this, cell, prop) {
    var _iterator__ex2g4s = MessageController_getInstance().x9y_1.m();
    while (_iterator__ex2g4s.n()) {
      var p = _iterator__ex2g4s.o();
      if (!(cell.k91(p) == null) && !(p === prop))
        return p;
    }
    return null;
  }
  function HoverState(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function MyHoverController($outer) {
    this.xa0_1 = $outer;
    this.ta0_1 = HoverState_NONE_getInstance();
    this.ua0_1 = null;
    this.va0_1 = Companion_getInstance_29().m2l_1;
    this.wa0_1 = Companion_getInstance_29().m2l_1;
  }
  protoOf(MyHoverController).ya0 = function (support) {
    return this.ua0_1 === support;
  };
  protoOf(MyHoverController).ma1 = function (support) {
    // Inline function 'kotlin.check' call
    if (!this.ta0_1.equals(HoverState_NONE_getInstance())) {
      var message = 'hide watched support';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    this.ua0_1 = support;
    this.ta0_1 = HoverState_PENDING_HIDE_getInstance();
    var tmp = this;
    tmp.va0_1 = schedule(this, MessageTrait$MyHoverController$scheduleHide$lambda(this.xa0_1, support));
  };
  protoOf(MyHoverController).na1 = function (support) {
    var wasPendingHide = cancelHide(this, support);
    if (!wasPendingHide && !this.ya0(support) && !ensureNotNull(support).ia0()) {
      this.va0_1.zr();
      this.ua0_1 = support;
      this.ta0_1 = HoverState_PENDING_SHOW_getInstance();
      var tmp = this;
      tmp.va0_1 = schedule(this, MessageTrait$MyHoverController$scheduleShow$lambda(this.xa0_1, support));
    }
  };
  protoOf(MyHoverController).la1 = function () {
    if (!(this.ua0_1 == null)) {
      this.va0_1.zr();
    }
  };
  protoOf(MyHoverController).oa1 = function (support) {
    var wasPendingHide = cancelHide(this, support);
    if (!wasPendingHide && this.ya0(support)) {
      this.va0_1.zr();
    }
  };
  function Companion_177() {
    Companion_instance_177 = this;
    this.d9z_1 = get_TOP_POPUP();
    this.e9z_1 = CellPropertySpec_init_$Create$('isMessagePopupActive', false);
    this.f9z_1 = CellPropertySpec_init_$Create$('hideMessage', false);
  }
  protoOf(Companion_177).g9z = function (cell) {
    return cell.k91(this.e9z_1);
  };
  var Companion_instance_177;
  function Companion_getInstance_177() {
    if (Companion_instance_177 == null)
      new Companion_177();
    return Companion_instance_177;
  }
  function sam$jetbrains_ocelot_base_edt_EdtTask$0_8(function_0) {
    this.sa1_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_8).au = function () {
    return this.sa1_1();
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_8).f3 = function () {
    return this.sa1_1;
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_8).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, EdtTask) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_8).hashCode = function () {
    return hashCode(this.f3());
  };
  function MessageTrait$onEditingKeyEvent$lambda(this$0) {
    return function () {
      var tmp;
      if (subtract_1(_get_edt__e67mgs(this$0).t39(), this$0.da1_1) >= 300n) {
        this$0.ca1_1.zr();
        this$0.ca1_1 = Companion_getInstance_29().m2l_1;
        applyPendingUpdates(this$0);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function HoverState_NONE_getInstance() {
    HoverState_initEntries();
    return HoverState_NONE_instance;
  }
  function HoverState_PENDING_HIDE_getInstance() {
    HoverState_initEntries();
    return HoverState_PENDING_HIDE_instance;
  }
  function HoverState_PENDING_SHOW_getInstance() {
    HoverState_initEntries();
    return HoverState_PENDING_SHOW_instance;
  }
  function MessageTrait(container, styler) {
    Companion_getInstance_177();
    CellTrait.call(this);
    this.aa1_1 = container;
    this.ba1_1 = styler;
    this.ca1_1 = Companion_getInstance_29().m2l_1;
    this.da1_1 = 0n;
    this.ea1_1 = false;
    this.fa1_1 = false;
    this.ga1_1 = HashMap_init_$Create$();
    this.ha1_1 = false;
    this.ia1_1 = null;
    this.ja1_1 = new MyHoverController(this);
  }
  protoOf(MessageTrait).o91 = function (cell) {
    var _iterator__ex2g4s = MessageController_getInstance().x9y_1.m();
    while (_iterator__ex2g4s.n()) {
      var prop = _iterator__ex2g4s.o();
      var value = cell.k91(prop);
      if (!(value == null)) {
        this.x8z(cell, prop, new PropertyChangeEvent(null, value));
      }
    }
  };
  protoOf(MessageTrait).x8z = function (cell, prop, event) {
    if (contains_5(MessageController_getInstance().x9y_1, prop)) {
      var cellPropertySpec = prop instanceof CellPropertySpec ? prop : THROW_CCE();
      var propertyChangeEvent = event instanceof PropertyChangeEvent ? event : THROW_CCE();
      if (this.ea1_1) {
        postpone(this, cell, cellPropertySpec, propertyChangeEvent);
      } else {
        apply(this, cell, cellPropertySpec, propertyChangeEvent);
      }
    } else if (isPopupProp(prop) && !this.ha1_1) {
      var change = event instanceof PropertyChangeEvent ? event : THROW_CCE();
      var popup = change.t2y_1;
      if (popup == null) {
        var message = getFirstNonNull(this, cell);
        if (!(message == null)) {
          setPopup(this, cell, ensureNotNull(cell.k91(message)));
        }
      } else if (Companion_getInstance_177().g9z(cell)) {
        if (prop === Companion_getInstance_177().d9z_1) {
          removePopup(this, cell, change.s2y_1);
        } else if (!Companion_instance_175.ba0(popup)) {
          hidePopup(this, cell);
        }
      }
    }
    protoOf(CellTrait).x8z.call(this, cell, prop, event);
  };
  protoOf(MessageTrait).q8y = function (cell, event) {
    return onEditingKeyEvent(this);
  };
  protoOf(MessageTrait).s8z = function (cell, event) {
    var tmp;
    if (cell instanceof TextCell) {
      tmp = event.m8j(Key_BACKSPACE_getInstance(), []) || event.m8j(Key_DELETE_getInstance(), []) || event.o8j([KeyStrokeSpecs_getInstance().h8l_1]);
    } else {
      tmp = false;
    }
    if (tmp) {
      onEditingKeyEvent(this);
      return Unit_instance;
    }
    if (event.o8j([KeyStrokeSpecs_getInstance().k8k_1])) {
      if (showPopupOnKeyEvent(this, cell)) {
        event.n8i();
      }
      return Unit_instance;
    } else if (event.m8j(Key_ESCAPE_getInstance(), [])) {
      if (hidePopup(this, cell)) {
        event.n8i();
      }
      return Unit_instance;
    }
    protoOf(CellTrait).s8z.call(this, cell, event);
  };
  protoOf(MessageTrait).q91 = function (cell, event) {
    if (shouldCloseMessage(this, event.y9t_1, cell)) {
      hidePopup(this, cell);
    }
  };
  protoOf(MessageTrait).x91 = function (cell, event) {
    if (showPopupOnMouseEvent(this, cell)) {
      event.n8i();
    }
  };
  protoOf(MessageTrait).y91 = function (cell, event) {
    if (shouldCloseMessage(this, ensureNotNull(cell.s8x()).n9u(event.z8l()), cell)) {
      hidePopupOnMouseEvent(this, cell);
    }
  };
  protoOf(MessageTrait).v91 = function (cell, event) {
    if (showPopupOnMouseEvent(this, cell)) {
      event.n8i();
    }
  };
  protoOf(MessageTrait).c91 = function (cell) {
    this.ba1_1.ta1(cell);
    if (!this.fa1_1) {
      this.ga1_1.u2(cell);
    }
    var _iterator__ex2g4s = get_POPUP_SPECS().m();
    while (_iterator__ex2g4s.n()) {
      var prop = _iterator__ex2g4s.o();
      var popup = cell.k91(prop);
      if (!(popup == null)) {
        hide(this, popup);
      }
    }
  };
  function MessageView() {
  }
  function applyStyle($this, cell) {
    if (cell instanceof TextCell) {
      $this.ua1(cell);
    } else {
      var _iterator__ex2g4s = cell.o35().m();
      while (_iterator__ex2g4s.n()) {
        var child = _iterator__ex2g4s.o();
        applyStyle($this, child);
      }
    }
  }
  function MessageViewWithLink(text, link) {
    this.va1_1 = null;
    this.wa1_1 = null;
    applyStyle(this, link);
    if (text == null) {
      this.wa1_1 = Companion_getInstance_173().r9x_1;
      this.va1_1 = link;
    } else {
      this.wa1_1 = new SimpleMessageView(text);
      this.va1_1 = new VerticalCell();
      CellFactory_instance.u9g(ensureNotNull(this.va1_1), [ensureNotNull(ensureNotNull(this.wa1_1).q33()), link]);
    }
  }
  protoOf(MessageViewWithLink).q33 = function () {
    return this.va1_1;
  };
  protoOf(MessageViewWithLink).s9x = function () {
    var maxLineDimension = ensureNotNull(this.wa1_1).s9x();
    var linkDim = get_dimension(ensureNotNull(this.xa1()));
    var tmp0 = maxLineDimension.d8c_1;
    // Inline function 'kotlin.math.max' call
    var b = linkDim.d8c_1;
    var tmp = Math.max(tmp0, b);
    var tmp0_0 = maxLineDimension.e8c_1;
    // Inline function 'kotlin.math.max' call
    var b_0 = linkDim.e8c_1;
    var tmp$ret$1 = Math.max(tmp0_0, b_0);
    return new Vector(tmp, tmp$ret$1);
  };
  protoOf(MessageViewWithLink).t9x = function () {
    return ensureNotNull(this.wa1_1).t9x() + 1 | 0;
  };
  protoOf(MessageViewWithLink).xa1 = function () {
    return ensureNotNull(this.va1_1).z35();
  };
  protoOf(MessageViewWithLink).v9x = function (maxWidth) {
    return ensureNotNull(this.wa1_1).v9x(maxWidth);
  };
  protoOf(MessageViewWithLink).u9x = function (message) {
    return message.x9x_1 === this.xa1();
  };
  function refresh($this) {
    var lineCells = $this.ya1_1.q92();
    var i = 0;
    var _iterator__ex2g4s = $this.za1_1.m();
    while (_iterator__ex2g4s.n()) {
      var text = _iterator__ex2g4s.o();
      if (lineCells.p() > i) {
        lineCells.r(i).i90(Companion_getInstance_154().b8x_1, text);
      } else {
        lineCells.j(createLine($this, text));
      }
      i = i + 1 | 0;
    }
    var inductionVariable = lineCells.p() - 1 | 0;
    var last = i;
    if (last <= inductionVariable)
      do {
        var j = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        lineCells.n2(j);
      }
       while (!(j === last));
  }
  function createLine($this, text) {
    var line = TextCell_init_$Create$_0(text);
    $this.ua1(line);
    return line;
  }
  function SimpleMessageView$lambda($lines) {
    return function (index) {
      return get_dimension($lines.r(index));
    };
  }
  function SimpleMessageView(message) {
    this.ya1_1 = new VerticalCell();
    var lines = this.ya1_1.o35();
    var tmp = this;
    tmp.za1_1 = new WordWrapper(message, SimpleMessageView$lambda(lines));
    refresh(this);
  }
  protoOf(SimpleMessageView).q33 = function () {
    return this.ya1_1;
  };
  protoOf(SimpleMessageView).s9x = function () {
    return this.za1_1.s9x();
  };
  protoOf(SimpleMessageView).t9x = function () {
    return this.za1_1.t9x();
  };
  protoOf(SimpleMessageView).v9x = function (maxWidth) {
    var updated = this.za1_1.ga2(maxWidth);
    if (updated) {
      refresh(this);
    }
    return updated;
  };
  protoOf(SimpleMessageView).u9x = function (message) {
    if (message.x9x_1 == null) {
      if (this.za1_1.ha2(ensureNotNull(message.w9x_1))) {
        refresh(this);
      }
      return true;
    }
    return false;
  };
  function doApply($this, cell, message, prop) {
    var styler = message.y9x_1;
    if (!(styler == null)) {
      return styler(cell);
    }
    var decorator = $this.pa1_1.q2(prop);
    $l$block: {
      // Inline function 'kotlin.checkNotNull' call
      if (decorator == null) {
        var message_0 = 'No decorator for property: ' + prop.toString();
        throw IllegalStateException_init_$Create$_0(toString_1(message_0));
      } else {
        break $l$block;
      }
    }
    return decorator(cell);
  }
  function Companion_178() {
    Companion_instance_178 = this;
    var list = ArrayList_init_$Create$_1(MessageController_getInstance().x9y_1);
    reverse(list);
    this.ia2_1 = list;
  }
  var Companion_instance_178;
  function Companion_getInstance_178() {
    if (Companion_instance_178 == null)
      new Companion_178();
    return Companion_instance_178;
  }
  function StyleApplicator$lambda($styler) {
    return function (cell) {
      return $styler.pa0(cell);
    };
  }
  function StyleApplicator$lambda_0($styler) {
    return function (cell) {
      return $styler.sa0(cell);
    };
  }
  function StyleApplicator$lambda_1($styler) {
    return function (cell) {
      return $styler.ra0(cell);
    };
  }
  function StyleApplicator$lambda_2($styler) {
    return function (cell) {
      return $styler.qa0(cell);
    };
  }
  function StyleApplicator(messageStyler) {
    Companion_getInstance_178();
    this.qa1_1 = new DisposableMap();
    var styler = messageStyler == null ? new MessageStyler() : messageStyler;
    var tmp = this;
    var tmp_0 = MessageController_getInstance().w9y_1;
    var tmp_1 = to(tmp_0, StyleApplicator$lambda(styler));
    var tmp_2 = MessageController_getInstance().u9y_1;
    var tmp_3 = to(tmp_2, StyleApplicator$lambda_0(styler));
    var tmp_4 = MessageController_getInstance().t9y_1;
    var tmp_5 = to(tmp_4, StyleApplicator$lambda_1(styler));
    var tmp_6 = MessageController_getInstance().v9y_1;
    tmp.pa1_1 = mapOf_0([tmp_1, tmp_3, tmp_5, to(tmp_6, StyleApplicator$lambda_2(styler))]);
  }
  protoOf(StyleApplicator).ra1 = function (cell) {
    this.qa1_1.q2l(cell);
    var disposable = Companion_getInstance_29().m2l_1;
    var _iterator__ex2g4s = Companion_getInstance_178().ia2_1.m();
    while (_iterator__ex2g4s.n()) {
      var prop = _iterator__ex2g4s.o();
      var message = cell.k91(prop);
      if (!(message == null)) {
        disposable = disposable.j2l(doApply(this, cell, message, prop));
      }
    }
    this.qa1_1.p2l(cell, disposable);
  };
  protoOf(StyleApplicator).ta1 = function (cell) {
    this.qa1_1.q2l(cell);
  };
  function areLineMetricsDefined($this) {
    return !($this.da2_1 === 0) && !($this.ea2_1 === 0);
  }
  function resetMetrics($this) {
    $this.ea2_1 = 0;
    $this.da2_1 = 0;
  }
  function arrange($this, line, index) {
    if (line.w2m()) {
      return false;
    }
    var partsNum = line.la2();
    var metrics = new Metrics();
    var shouldSplit = false;
    var inductionVariable = 0;
    if (inductionVariable < partsNum)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var dim = $this.aa2_1(index + i | 0);
        updateMaxLineHeight($this, dim.e8c_1);
        if (!(dim.d8c_1 === 0)) {
          var symbolApproxWidth = 1 + (dim.d8c_1 / line.ma2(i) | 0) | 0;
          metrics.pa2(symbolApproxWidth, dim.d8c_1);
          if (dim.d8c_1 > $this.fa2_1) {
            shouldSplit = true;
          }
        }
      }
       while (inductionVariable < partsNum);
    if (metrics.na2_1 < 2) {
      return false;
    }
    var changed = false;
    if (shouldSplit || partsNum > 1) {
      var maxLineLength = $this.fa2_1 / metrics.na2_1 | 0;
      var breaks = arrange_0($this, line.ja2_1, maxLineLength);
      changed = line.qa2(breaks);
    }
    if (changed) {
      updateMaxLineWidth($this, imul(line.ra2(), metrics.na2_1));
    } else {
      updateMaxLineWidth($this, metrics.oa2_1);
    }
    return changed;
  }
  function arrange_0($this, text, maxLineLength) {
    var linesNum = (text.length / maxLineLength | 0) + 1 | 0;
    // Inline function 'kotlin.math.min' call
    var a = linesNum + (text.length / linesNum | 0) | 0;
    var preferredLineLength = Math.min(a, maxLineLength);
    var lineBreaks = ArrayList_init_$Create$();
    var lineStart = 0;
    lineBreaks.j(lineStart);
    while (lineStart < text.length) {
      var maxIndex = lineStart + maxLineLength | 0;
      var lineEnd;
      if (maxIndex < text.length) {
        var preferredLineEnd = (lineStart + preferredLineLength | 0) - 1 | 0;
        lineEnd = getNextSpaceIndex($this, text, preferredLineEnd, maxIndex);
        if (lineEnd === -1) {
          lineEnd = getPrevSpaceIndex($this, text, maxIndex, lineStart);
          if (lineEnd === -1) {
            lineEnd = preferredLineEnd;
          }
        }
      } else {
        lineEnd = text.length - 1 | 0;
      }
      lineEnd = lineEnd + 1 | 0;
      lineBreaks.j(lineEnd);
      lineStart = lineEnd;
    }
    return lineBreaks;
  }
  function getNextSpaceIndex($this, text, beginIndex, endIndex) {
    var inductionVariable = beginIndex;
    if (inductionVariable < endIndex)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (charCodeAt(text, i) === _Char___init__impl__6a9atx(32))
          return i;
      }
       while (inductionVariable < endIndex);
    return -1;
  }
  function getPrevSpaceIndex($this, text, beginIndex, endIndex) {
    var inductionVariable = beginIndex - 1 | 0;
    var last = (endIndex - 1 | 0) + 1 | 0;
    if (last <= inductionVariable)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        if (charCodeAt(text, i) === _Char___init__impl__6a9atx(32))
          return i;
      }
       while (!(i === last));
    return -1;
  }
  function updateMaxLineHeight($this, h) {
    if (h > $this.ea2_1) {
      $this.ea2_1 = h;
    }
  }
  function updateMaxLineWidth($this, w) {
    if (w > $this.da2_1) {
      $this.da2_1 = w;
    }
  }
  function Metrics() {
    this.na2_1 = 0;
    this.oa2_1 = 0;
  }
  protoOf(Metrics).pa2 = function (symbolWidth, width) {
    if (symbolWidth > this.na2_1) {
      this.na2_1 = symbolWidth;
    }
    if (width > this.oa2_1) {
      this.oa2_1 = width;
    }
  };
  function Line(text) {
    this.ja2_1 = text;
    this.ka2_1 = mutableListOf([0, this.ja2_1.length]);
  }
  protoOf(Line).w2m = function () {
    // Inline function 'kotlin.text.isEmpty' call
    var this_0 = this.ja2_1;
    return charSequenceLength(this_0) === 0;
  };
  protoOf(Line).la2 = function () {
    return this.ka2_1.p() - 1 | 0;
  };
  protoOf(Line).ra2 = function () {
    var max = 0;
    var inductionVariable = 0;
    var last = this.ka2_1.p() - 1 | 0;
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var length = this.ka2_1.r(i + 1 | 0) - this.ka2_1.r(i) | 0;
        if (length > max) {
          max = length;
        }
      }
       while (inductionVariable < last);
    return max;
  };
  protoOf(Line).sa2 = function (index) {
    return substring(this.ja2_1, this.ka2_1.r(index), this.ka2_1.r(index + 1 | 0));
  };
  protoOf(Line).ma2 = function (partIndex) {
    return this.ka2_1.r(partIndex + 1 | 0) - this.ka2_1.r(partIndex) | 0;
  };
  protoOf(Line).qa2 = function (breaks) {
    if (equals(this.ka2_1, breaks)) {
      return false;
    }
    this.ka2_1.k2();
    this.ka2_1.q(breaks);
    return true;
  };
  protoOf(Line).toString = function () {
    return this.ja2_1 + ', breaks=' + toString_1(this.ka2_1);
  };
  function WordWrapper$iterator$1(this$0) {
    this.va2_1 = this$0;
    this.ta2_1 = 0;
    this.ua2_1 = 0;
  }
  protoOf(WordWrapper$iterator$1).n = function () {
    return this.ta2_1 < this.va2_1.ca2_1.p();
  };
  protoOf(WordWrapper$iterator$1).o = function () {
    var line = this.va2_1.ca2_1.r(this.ta2_1);
    var _unary__edvuaz = this.ua2_1;
    this.ua2_1 = _unary__edvuaz + 1 | 0;
    var next = line.sa2(_unary__edvuaz);
    if (this.ua2_1 === line.la2()) {
      this.ta2_1 = this.ta2_1 + 1 | 0;
      this.ua2_1 = 0;
    }
    return next;
  };
  function WordWrapper(text, dimensionSupplier) {
    this.aa2_1 = dimensionSupplier;
    this.ba2_1 = null;
    var tmp = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp.ca2_1 = ArrayList_init_$Create$();
    this.da2_1 = 0;
    this.ea2_1 = 0;
    this.fa2_1 = 0;
    this.ha2(text);
  }
  protoOf(WordWrapper).s9x = function () {
    return new Vector(this.da2_1, this.ea2_1);
  };
  protoOf(WordWrapper).t9x = function () {
    var size = 0;
    var _iterator__ex2g4s = this.ca2_1.m();
    while (_iterator__ex2g4s.n()) {
      var line = _iterator__ex2g4s.o();
      size = size + line.la2() | 0;
    }
    return size;
  };
  protoOf(WordWrapper).ha2 = function (text) {
    if (text === this.ba2_1) {
      return false;
    }
    this.ba2_1 = text;
    this.ca2_1.k2();
    resetMetrics(this);
    // Inline function 'kotlin.text.toRegex' call
    // Inline function 'kotlin.text.split' call
    var splitLines = Regex_init_$Create$('\\n').id(text, 0);
    var _iterator__ex2g4s = splitLines.m();
    while (_iterator__ex2g4s.n()) {
      var line = _iterator__ex2g4s.o();
      this.ca2_1.j(new Line(line));
    }
    return true;
  };
  protoOf(WordWrapper).ga2 = function (viewportWidth) {
    if (this.fa2_1 === viewportWidth && areLineMetricsDefined(this)) {
      return false;
    }
    this.fa2_1 = viewportWidth;
    resetMetrics(this);
    var changed = false;
    var resultLineIndex = 0;
    var _iterator__ex2g4s = this.ca2_1.m();
    while (_iterator__ex2g4s.n()) {
      var line = _iterator__ex2g4s.o();
      var oldPartsNumber = line.la2();
      if (arrange(this, line, resultLineIndex)) {
        changed = true;
      }
      resultLineIndex = resultLineIndex + oldPartsNumber | 0;
    }
    return changed;
  };
  protoOf(WordWrapper).m = function () {
    return new WordWrapper$iterator$1(this);
  };
  function get_TOP_POPUP() {
    _init_properties_Popup_kt__lluomy();
    return TOP_POPUP;
  }
  var TOP_POPUP;
  function get_BOTTOM_POPUP() {
    _init_properties_Popup_kt__lluomy();
    return BOTTOM_POPUP;
  }
  var BOTTOM_POPUP;
  function get_FRONT_POPUP() {
    _init_properties_Popup_kt__lluomy();
    return FRONT_POPUP;
  }
  var FRONT_POPUP;
  function get_LEFT_POPUP() {
    _init_properties_Popup_kt__lluomy();
    return LEFT_POPUP;
  }
  var LEFT_POPUP;
  function get_RIGHT_POPUP() {
    _init_properties_Popup_kt__lluomy();
    return RIGHT_POPUP;
  }
  var RIGHT_POPUP;
  function get_POPUP_SPECS() {
    _init_properties_Popup_kt__lluomy();
    return POPUP_SPECS;
  }
  var POPUP_SPECS;
  function get_POPUP() {
    _init_properties_Popup_kt__lluomy();
    return POPUP;
  }
  var POPUP;
  function get_frontPopup(_this__u8e3s4) {
    _init_properties_Popup_kt__lluomy();
    return _this__u8e3s4.k91(get_FRONT_POPUP());
  }
  function getNonPopupAncestor(_this__u8e3s4) {
    _init_properties_Popup_kt__lluomy();
    // Inline function 'kotlin.sequences.find' call
    var tmp0 = ancestorsFrom(_this__u8e3s4);
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.sequences.firstOrNull' call
      var _iterator__ex2g4s = tmp0.m();
      while (_iterator__ex2g4s.n()) {
        var element = _iterator__ex2g4s.o();
        if (getContainingPopup(element) == null) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    return tmp$ret$1;
  }
  function isPopupProp(_this__u8e3s4) {
    _init_properties_Popup_kt__lluomy();
    return contains_5(get_POPUP_SPECS(), _this__u8e3s4);
  }
  function get_bottomPopupProp(_this__u8e3s4) {
    _init_properties_Popup_kt__lluomy();
    return _this__u8e3s4.n92(get_BOTTOM_POPUP());
  }
  function get_frontPopupProp(_this__u8e3s4) {
    _init_properties_Popup_kt__lluomy();
    return _this__u8e3s4.n92(get_FRONT_POPUP());
  }
  function inPopup(_this__u8e3s4) {
    _init_properties_Popup_kt__lluomy();
    return !(getContainingPopup(_this__u8e3s4) == null);
  }
  function getContainingPopup(_this__u8e3s4) {
    _init_properties_Popup_kt__lluomy();
    // Inline function 'kotlin.sequences.find' call
    var tmp0 = ancestorsFrom(_this__u8e3s4);
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.sequences.firstOrNull' call
      var _iterator__ex2g4s = tmp0.m();
      while (_iterator__ex2g4s.n()) {
        var element = _iterator__ex2g4s.o();
        if (get_isPopup(element)) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    return tmp$ret$1;
  }
  function get_isPopup(_this__u8e3s4) {
    _init_properties_Popup_kt__lluomy();
    return _this__u8e3s4.k91(get_POPUP());
  }
  function get_rightPopup(_this__u8e3s4) {
    _init_properties_Popup_kt__lluomy();
    return _this__u8e3s4.k91(get_RIGHT_POPUP());
  }
  function get_leftPopup(_this__u8e3s4) {
    _init_properties_Popup_kt__lluomy();
    return _this__u8e3s4.k91(get_LEFT_POPUP());
  }
  var properties_initialized_Popup_kt_wwy6qs;
  function _init_properties_Popup_kt__lluomy() {
    if (!properties_initialized_Popup_kt_wwy6qs) {
      properties_initialized_Popup_kt_wwy6qs = true;
      TOP_POPUP = CellPropertySpec_init_$Create$('topPopup', null);
      BOTTOM_POPUP = CellPropertySpec_init_$Create$('bottomPopup', null);
      FRONT_POPUP = CellPropertySpec_init_$Create$('frontPopup', null);
      LEFT_POPUP = CellPropertySpec_init_$Create$('leftPopup', null);
      RIGHT_POPUP = CellPropertySpec_init_$Create$('rightPopup', null);
      POPUP_SPECS = listOf_0([get_LEFT_POPUP(), get_RIGHT_POPUP(), get_TOP_POPUP(), get_BOTTOM_POPUP(), get_FRONT_POPUP()]);
      POPUP = CellPropertySpec_init_$Create$('popup', false);
    }
  }
  function shouldScrollTo($this, popup) {
    var spec = popup.c93(Companion_getInstance_151().m94_1);
    return !(spec == null) && spec.q94(popup);
  }
  function updateScroll($this, mapper) {
    var source = mapper.e86_1;
    if (!shouldScrollTo($this, source)) {
      return Unit_instance;
    }
    if (source.k91(get_VISIBLE())) {
      $this.ya2(source);
    } else {
      var disposable = {_v: null};
      var tmp = source.m92();
      var value = tmp.z2r(BasePopupManager$updateScroll$lambda(disposable, $this, source));
      disposable._v = value;
    }
  }
  function findMapper($this, popup) {
    var _iterator__ex2g4s = ensureNotNull($this.xa2_1).m();
    while (_iterator__ex2g4s.n()) {
      var mapper = _iterator__ex2g4s.o();
      if (mapper.e86_1 === popup) {
        return mapper;
      }
    }
    throw IllegalStateException_init_$Create$_0('No registered mapper for popup ' + toString_1(popup));
  }
  function BasePopupManager$updateScroll$lambda($disposable, this$0, $source) {
    return function (event) {
      var tmp;
      if (event.t2y_1) {
        ensureNotNull($disposable._v).zr();
        this$0.ya2($source);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function BasePopupManager$getUpdatePositionTask$lambda(this$0, $mapper) {
    return function () {
      this$0.za2($mapper).ba3($mapper.e86_1, $mapper.f86_1);
      return Unit_instance;
    };
  }
  function BasePopupManager() {
    this.wa2_1 = null;
    this.xa2_1 = null;
  }
  protoOf(BasePopupManager).zr = function () {
    var disposable = this.wa2_1;
    if (!(disposable == null)) {
      disposable.zr();
      this.wa2_1 = null;
    }
    var popups = this.xa2_1;
    if (!(popups == null)) {
      var _iterator__ex2g4s = popups.m();
      while (_iterator__ex2g4s.n()) {
        var popup = _iterator__ex2g4s.o();
        this.ea3(popup);
      }
      this.xa2_1 = null;
    }
  };
  protoOf(BasePopupManager).ga3 = function (cell) {
    var _iterator__ex2g4s = get_POPUP_SPECS().m();
    while (_iterator__ex2g4s.n()) {
      var ps = _iterator__ex2g4s.o();
      var popup = cell.k91(ps);
      if (!(popup == null)) {
        this.ha3(new PropertyChangeEvent(null, popup));
      }
    }
  };
  protoOf(BasePopupManager).ia3 = function (popup, prop, change) {
    var tmp;
    var tmp_0;
    if (prop === get_VISIBLE()) {
      var tmp_1 = change.t2y_1;
      tmp_0 = (!(tmp_1 == null) ? typeof tmp_1 === 'boolean' : false) ? tmp_1 : THROW_CCE();
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = true;
    } else {
      tmp = prop === get_POPUP_X_POSITION();
    }
    if (tmp) {
      var mapper = findMapper(this, popup);
      this.ja3(mapper);
    }
  };
  protoOf(BasePopupManager).ha3 = function (event) {
    var oldValue = event.s2y_1;
    if (!(oldValue == null)) {
      var popup = findMapper(this, oldValue);
      ensureNotNull(this.xa2_1).h2(popup);
      this.ea3(popup);
      if (ensureNotNull(this.xa2_1).s()) {
        this.xa2_1 = null;
        ensureNotNull(this.wa2_1).zr();
        this.wa2_1 = null;
      }
    }
    var newValue = event.t2y_1;
    if (!(newValue == null)) {
      if (this.xa2_1 == null) {
        this.xa2_1 = this.ca3();
        this.wa2_1 = this.fa3();
      }
      this.ka3();
      newValue.w92(Companion_getInstance_179().la3_1);
      var popup_0 = this.da3(newValue);
      ensureNotNull(this.xa2_1).j(popup_0);
      this.ja3(popup_0);
      updateScroll(this, popup_0);
    }
  };
  protoOf(BasePopupManager).n2s = function (event) {
    return this.ha3(event instanceof PropertyChangeEvent ? event : THROW_CCE());
  };
  protoOf(BasePopupManager).ya2 = function (popup) {
    if (popup.f89()) {
      scrollTo_0(popup);
    }
  };
  protoOf(BasePopupManager).ka3 = function () {
    if (this.xa2_1 == null) {
      return Unit_instance;
    }
    var _iterator__ex2g4s = ensureNotNull(this.xa2_1).m();
    while (_iterator__ex2g4s.n()) {
      var popup = _iterator__ex2g4s.o();
      this.ja3(popup);
    }
  };
  protoOf(BasePopupManager).ja3 = function (popupMapper) {
    if (popupMapper.e86_1.f89() && popupMapper.e86_1.k91(get_VISIBLE())) {
      this.ma3(popupMapper)();
    }
  };
  protoOf(BasePopupManager).ma3 = function (mapper) {
    return BasePopupManager$getUpdatePositionTask$lambda(this, mapper);
  };
  function Companion_179() {
    Companion_instance_179 = this;
    this.la3_1 = new ConsumeMouseButtonTrait();
  }
  var Companion_instance_179;
  function Companion_getInstance_179() {
    if (Companion_instance_179 == null)
      new Companion_179();
    return Companion_instance_179;
  }
  function ConsumeMouseButtonTrait() {
    Companion_getInstance_179();
    CellTrait.call(this);
  }
  protoOf(ConsumeMouseButtonTrait).r91 = function (cell, event) {
    event.n8i();
  };
  protoOf(ConsumeMouseButtonTrait).s91 = function (cell, event) {
    event.n8i();
  };
  protoOf(ConsumeMouseButtonTrait).t91 = function (cell, event) {
    event.n8i();
  };
  protoOf(ConsumeMouseButtonTrait).u91 = function (cell, event) {
    event.n8i();
  };
  protoOf(ConsumeMouseButtonTrait).w91 = function (cell, event) {
    event.n8i();
  };
  protoOf(ConsumeMouseButtonTrait).z91 = function (cell, event) {
    event.n8i();
  };
  protoOf(ConsumeMouseButtonTrait).d92 = function (cell, event) {
    event.n8i();
  };
  protoOf(ConsumeMouseButtonTrait).e92 = function (cell, event) {
    event.n8i();
  };
  function PopupPositionUpdater_init_$Init$(rightBottomMargin, $this) {
    PopupPositionUpdater.call($this);
    $this.aa3_1 = rightBottomMargin;
    return $this;
  }
  function getRole($this, parent, popup) {
    var _iterator__ex2g4s = get_POPUP_SPECS().m();
    while (_iterator__ex2g4s.n()) {
      var spec = _iterator__ex2g4s.o();
      if (parent.k91(spec) === popup)
        return spec;
    }
    throw IllegalStateException_init_$Create$_0(toString_1(parent) + ' has no popup same to ' + toString_1(popup));
  }
  function hasVisiblePopup($this, opposite, parent) {
    var oppositePopup = parent.k91(opposite);
    return !(oppositePopup == null) && oppositePopup.k91(get_VISIBLE());
  }
  function updateTop($this, hasBottom, ctx) {
    var viewport = $this.na3();
    if (hasBottom) {
      return showTop($this, viewport, ctx);
    }
    var topSpace = ctx.sa3_1.b8c_1.e8c_1 - viewport.b8c_1.e8c_1 | 0;
    var bottomSpace = (viewport.c8c_1.e8c_1 - topSpace | 0) - ctx.sa3_1.c8c_1.e8c_1 | 0;
    var top = topSpace >= $this.ta3(ctx.qa3_1, ctx.ra3_1.e8c_1);
    var tmp;
    if (top || topSpace > bottomSpace) {
      tmp = showTop($this, viewport, ctx);
    } else {
      tmp = showBottom($this, viewport, ctx);
    }
    return tmp;
  }
  function updateBottom($this, hasTop, ctx) {
    var viewport = $this.na3();
    if (hasTop) {
      return showBottom($this, viewport, ctx);
    }
    var topSpace = ctx.sa3_1.b8c_1.e8c_1 - viewport.b8c_1.e8c_1 | 0;
    var bottomSpace = (viewport.c8c_1.e8c_1 - topSpace | 0) - ctx.sa3_1.c8c_1.e8c_1 | 0;
    var bottom = bottomSpace >= $this.ta3(ctx.qa3_1, ctx.ra3_1.e8c_1);
    var tmp;
    if (bottom || bottomSpace > topSpace) {
      tmp = showBottom($this, viewport, ctx);
    } else {
      tmp = showTop($this, viewport, ctx);
    }
    return tmp;
  }
  function showBottom($this, viewport, ctx) {
    firePosition($this, ctx.pa3_1, get_BOTTOM_POPUP());
    $this.ua3(ctx.qa3_1);
    return showVertical($this, viewport, false, ctx);
  }
  function showTop($this, viewport, ctx) {
    firePosition($this, ctx.pa3_1, get_TOP_POPUP());
    $this.va3(ctx.qa3_1);
    return showVertical($this, viewport, true, ctx);
  }
  function firePosition($this, popupCell, position) {
    var spec = popupCell.c93(Companion_getInstance_151().m94_1);
    if (spec == null)
      null;
    else {
      spec.p94(popupCell, position);
    }
  }
  function showVertical($this, viewport, showTop, ctx) {
    var width = ctx.ra3_1.d8c_1;
    var height = $this.ta3(ctx.qa3_1, ctx.ra3_1.e8c_1);
    var tmp0 = ctx.wa3() + ctx.sa3_1.b8c_1.d8c_1 | 0;
    // Inline function 'kotlin.math.max' call
    var b = viewport.b8c_1.d8c_1;
    var left = Math.max(tmp0, b);
    var top = showTop ? ctx.sa3_1.b8c_1.e8c_1 - height | 0 : ctx.sa3_1.b8c_1.e8c_1 + ctx.sa3_1.c8c_1.e8c_1 | 0;
    var maxX = viewport.b8c_1.d8c_1 + viewport.c8c_1.d8c_1 | 0;
    var setMarginY = !ctx.pa3_1.k91(get_HAS_POPUP_DECORATION());
    var spec = ctx.pa3_1.c93(Companion_getInstance_151().m94_1);
    if (!(spec == null)) {
      // Inline function 'kotlin.math.max' call
      var a = viewport.c8c_1.d8c_1 - $this.aa3_1 | 0;
      var maxWidth = Math.max(a, 150);
      var maxAlignedWidth = (maxX - left | 0) - $this.aa3_1 | 0;
      if (maxAlignedWidth < 150) {
        maxAlignedWidth = maxWidth;
      }
      var parentVisibleOffsetTop = ctx.sa3_1.b8c_1.e8c_1 - viewport.b8c_1.e8c_1 | 0;
      var tmp;
      if (showTop) {
        tmp = parentVisibleOffsetTop;
      } else {
        tmp = (viewport.c8c_1.e8c_1 - ctx.sa3_1.c8c_1.e8c_1 | 0) - parentVisibleOffsetTop | 0;
      }
      var maxVisibleSpace = tmp;
      // Inline function 'kotlin.math.min' call
      var b_0 = viewport.c8c_1.e8c_1 - ctx.sa3_1.c8c_1.e8c_1 | 0;
      var maxVisibleHeight = Math.min(maxVisibleSpace, b_0);
      if (setMarginY) {
        maxVisibleHeight = maxVisibleHeight - $this.aa3_1 | 0;
      }
      // Inline function 'kotlin.math.max' call
      var a_0 = $this.xa3(ctx.qa3_1, maxVisibleHeight);
      var maxHeight = Math.max(a_0, 25);
      var adjustedDim = spec.o94(ctx.pa3_1, ctx.ra3_1, new Vector(maxWidth, maxHeight), maxAlignedWidth);
      width = adjustedDim.d8c_1;
      height = $this.ta3(ctx.qa3_1, adjustedDim.e8c_1);
      if (showTop) {
        top = ctx.sa3_1.b8c_1.e8c_1 - height | 0;
      }
    }
    if (showTop && setMarginY) {
      top = top - $this.aa3_1 | 0;
    }
    if ((left + width | 0) > maxX) {
      var tmp0_0 = viewport.b8c_1.d8c_1;
      // Inline function 'kotlin.math.max' call
      var b_1 = (maxX - width | 0) - $this.aa3_1 | 0;
      left = Math.max(tmp0_0, b_1);
    }
    var maxY = viewport.b8c_1.e8c_1 + viewport.c8c_1.e8c_1 | 0;
    if ((top + height | 0) > maxY) {
      var tmp0_1 = viewport.b8c_1.e8c_1;
      // Inline function 'kotlin.math.max' call
      var b_2 = maxY - height | 0;
      top = Math.max(tmp0_1, b_2);
    } else if (top < viewport.b8c_1.e8c_1) {
      top = viewport.b8c_1.e8c_1;
    }
    return $this.ya3(ctx.qa3_1, left, top);
  }
  function updateFront($this, ctx) {
    return $this.ya3(ctx.qa3_1, ctx.wa3() + ctx.sa3_1.b8c_1.d8c_1 | 0, ctx.sa3_1.b8c_1.e8c_1);
  }
  function updateLeft($this, ctx) {
    return $this.ya3(ctx.qa3_1, (ctx.wa3() + ctx.sa3_1.b8c_1.d8c_1 | 0) - ctx.ra3_1.d8c_1 | 0, ctx.sa3_1.b8c_1.e8c_1);
  }
  function updateRight($this, ctx) {
    return showRight($this, $this.na3(), ctx);
  }
  function showRight($this, viewport, ctx) {
    var left = (ctx.wa3() + ctx.sa3_1.b8c_1.d8c_1 | 0) + ctx.sa3_1.c8c_1.d8c_1 | 0;
    var top = ctx.sa3_1.b8c_1.e8c_1;
    var height = $this.ta3(ctx.qa3_1, ctx.ra3_1.e8c_1);
    var maxY = viewport.b8c_1.e8c_1 + viewport.c8c_1.e8c_1 | 0;
    var setMarginY = !ctx.pa3_1.k91(get_HAS_POPUP_DECORATION());
    if (setMarginY) {
      maxY = maxY - $this.aa3_1 | 0;
    }
    if ((top + height | 0) > maxY) {
      top = (top - height | 0) + ctx.sa3_1.c8c_1.e8c_1 | 0;
    }
    var maxX = viewport.b8c_1.d8c_1 + viewport.c8c_1.d8c_1 | 0;
    if ((left + ctx.ra3_1.d8c_1 | 0) > maxX) {
      left = (left - ctx.ra3_1.d8c_1 | 0) - ctx.sa3_1.c8c_1.d8c_1 | 0;
    }
    return $this.ya3(ctx.qa3_1, left, top);
  }
  function Context(parent, popupCell, popupView, popupDimension) {
    this.oa3_1 = parent;
    this.pa3_1 = popupCell;
    this.qa3_1 = popupView;
    this.ra3_1 = popupDimension;
    this.sa3_1 = get_bounds(this.oa3_1);
  }
  protoOf(Context).wa3 = function () {
    var pos = this.pa3_1.k91(get_POPUP_X_POSITION());
    var tmp = this.oa3_1;
    if (!(tmp instanceof TextCell)) {
      // Inline function 'kotlin.check' call
      if (!(pos === 0)) {
        var message = 'Only supported when parent is TextCell, but encountered: ' + toString_1(this.oa3_1);
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      }
      return 0;
    }
    return this.oa3_1.z96(pos);
  };
  function Companion_180() {
    this.za3_1 = 150;
    this.aa4_1 = 25;
  }
  var Companion_instance_180;
  function Companion_getInstance_180() {
    return Companion_instance_180;
  }
  protoOf(PopupPositionUpdater).ba3 = function (popupCell, popupView) {
    var parent = popupCell.bp();
    var ctx = new Context(ensureNotNull(parent), popupCell, popupView, this.ba4(popupView));
    var tmp0_subject = getRole(this, parent, popupCell);
    return equals(tmp0_subject, get_BOTTOM_POPUP()) ? updateBottom(this, hasVisiblePopup(this, get_TOP_POPUP(), parent), ctx) : equals(tmp0_subject, get_FRONT_POPUP()) ? updateFront(this, ctx) : equals(tmp0_subject, get_RIGHT_POPUP()) ? updateRight(this, ctx) : equals(tmp0_subject, get_LEFT_POPUP()) ? updateLeft(this, ctx) : equals(tmp0_subject, get_TOP_POPUP()) ? updateTop(this, hasVisiblePopup(this, get_BOTTOM_POPUP(), parent), ctx) : false;
  };
  protoOf(PopupPositionUpdater).va3 = function (popup) {
  };
  protoOf(PopupPositionUpdater).ua3 = function (popup) {
  };
  protoOf(PopupPositionUpdater).ta3 = function (popup, height) {
    return height;
  };
  protoOf(PopupPositionUpdater).xa3 = function (popup, height) {
    return height;
  };
  function PopupPositionUpdater() {
  }
  function CellDefaultPositionHandler(cell) {
    DefaultPositionHandler.call(this);
    this.ca4_1 = cell;
  }
  protoOf(CellDefaultPositionHandler).x96 = function () {
    var firstFocusable_0 = firstFocusable(this.ca4_1);
    var tmp;
    if (firstFocusable_0 === this.ca4_1 || firstFocusable_0 == null) {
      tmp = protoOf(DefaultPositionHandler).x96.call(this);
    } else {
      tmp = get_positionHandler(firstFocusable_0).x96();
    }
    return tmp;
  };
  protoOf(CellDefaultPositionHandler).v96 = function () {
    var lastFocusable_0 = lastFocusable(this.ca4_1);
    var tmp;
    if (lastFocusable_0 === this.ca4_1 || lastFocusable_0 == null) {
      tmp = protoOf(DefaultPositionHandler).v96.call(this);
    } else {
      tmp = get_positionHandler(lastFocusable_0).v96();
    }
    return tmp;
  };
  protoOf(CellDefaultPositionHandler).w2m = function () {
    var firstFocusable_0 = firstFocusable(this.ca4_1);
    var lastFocusable_0 = lastFocusable(this.ca4_1);
    return firstFocusable_0 === lastFocusable_0 && (firstFocusable_0 == null || firstFocusable_0 === this.ca4_1 || get_positionHandler(firstFocusable_0).w2m());
  };
  protoOf(CellDefaultPositionHandler).da4 = function (position) {
    var remains = position;
    var _iterator__ex2g4s = this.ca4_1.o35().m();
    while (_iterator__ex2g4s.n()) {
      var cell = _iterator__ex2g4s.o();
      var setResult = get_positionHandler(cell).da4(remains);
      if (setResult.ea4_1) {
        return setResult;
      }
      remains = setResult.fa4_1;
    }
    return new SetPositionResult(false, remains);
  };
  function DefaultPositionHandler$caretOffset$1() {
  }
  protoOf(DefaultPositionHandler$caretOffset$1).uv = function () {
    return 0;
  };
  protoOf(DefaultPositionHandler$caretOffset$1).na4 = function (handler) {
    return Companion_getInstance_29().m2l_1;
  };
  protoOf(DefaultPositionHandler$caretOffset$1).y2r = function (handler) {
    return this.na4(handler);
  };
  protoOf(DefaultPositionHandler$caretOffset$1).oa4 = function (newValue) {
  };
  protoOf(DefaultPositionHandler$caretOffset$1).d2x = function (newValue) {
    return this.oa4((!(newValue == null) ? typeof newValue === 'number' : false) ? newValue : THROW_CCE());
  };
  protoOf(DefaultPositionHandler$caretOffset$1).v2w = function () {
    return 'defaultCaretOffset';
  };
  function DefaultPositionHandler() {
  }
  protoOf(DefaultPositionHandler).x96 = function () {
    return false;
  };
  protoOf(DefaultPositionHandler).v96 = function () {
    return false;
  };
  protoOf(DefaultPositionHandler).ga4 = function () {
    return this.x96();
  };
  protoOf(DefaultPositionHandler).ha4 = function () {
    return this.v96();
  };
  protoOf(DefaultPositionHandler).ia4 = function () {
    return this.w2m();
  };
  protoOf(DefaultPositionHandler).ja4 = function () {
  };
  protoOf(DefaultPositionHandler).ka4 = function () {
  };
  protoOf(DefaultPositionHandler).la4 = function () {
    return new DefaultPositionHandler$caretOffset$1();
  };
  protoOf(DefaultPositionHandler).ma4 = function (offset) {
    return 2147483647;
  };
  function NewLineCellPositionHandler(cell) {
    DefaultPositionHandler.call(this);
    this.pa4_1 = cell;
  }
  protoOf(NewLineCellPositionHandler).x96 = function () {
    return true;
  };
  protoOf(NewLineCellPositionHandler).v96 = function () {
    return true;
  };
  protoOf(NewLineCellPositionHandler).w2m = function () {
    return true;
  };
  protoOf(NewLineCellPositionHandler).da4 = function (position) {
    return new SetPositionResult(false, position - this.pa4_1.u9v_1 | 0);
  };
  function PositionHandler$Companion$PROPERTY$lambda(cell) {
    var tmp;
    if (cell instanceof TextCell) {
      tmp = new TextPositionHandler(cell);
    } else {
      if (cell instanceof NewLineCell) {
        tmp = new NewLineCellPositionHandler(cell);
      } else {
        tmp = new CellDefaultPositionHandler(cell);
      }
    }
    return tmp;
  }
  function SetPositionResult(isPositionHasBeenSet, carryOut) {
    this.ea4_1 = isPositionHasBeenSet;
    this.fa4_1 = carryOut;
  }
  function Companion_181() {
    Companion_instance_181 = this;
    var tmp = this;
    tmp.qa4_1 = new CellTraitPropertySpec('positionHandler', PositionHandler$Companion$PROPERTY$lambda);
  }
  var Companion_instance_181;
  function Companion_getInstance_181() {
    if (Companion_instance_181 == null)
      new Companion_181();
    return Companion_instance_181;
  }
  function toEnd_0(_this__u8e3s4) {
    return toEnd$lambda(_this__u8e3s4);
  }
  function toLastFocusable(_this__u8e3s4) {
    return toLastFocusable$lambda(_this__u8e3s4);
  }
  function toHome(_this__u8e3s4) {
    return toHome$lambda(_this__u8e3s4);
  }
  function toFirstFocusable(_this__u8e3s4) {
    return toFirstFocusable$lambda(_this__u8e3s4);
  }
  function get_positionHandler(_this__u8e3s4) {
    return _this__u8e3s4.c93(Companion_getInstance_181().qa4_1);
  }
  function Positions() {
  }
  protoOf(Positions).ra4 = function (cell) {
    var first = firstFocusable(cell);
    return !(first == null) && first.y92().uv() && get_positionHandler(first).x96();
  };
  protoOf(Positions).sa4 = function (cell) {
    var last = lastFocusable(cell);
    return !(last == null) && last.y92().uv() && get_positionHandler(last).v96();
  };
  protoOf(Positions).ta4 = function (cell) {
    var first = firstFocusable(cell);
    return !(first == null) && first.y92().uv() && get_positionHandler(first).ga4();
  };
  protoOf(Positions).ua4 = function (cell) {
    var last = lastFocusable(cell);
    return !(last == null) && last.y92().uv() && get_positionHandler(last).ha4();
  };
  var Positions_instance;
  function Positions_getInstance() {
    return Positions_instance;
  }
  function isEmpty(_this__u8e3s4) {
    return get_positionHandler(_this__u8e3s4).w2m();
  }
  function isVisuallyEmpty(_this__u8e3s4) {
    return get_positionHandler(_this__u8e3s4).ia4();
  }
  function toPosition(_this__u8e3s4, pos) {
    return toPosition$lambda(_this__u8e3s4, pos);
  }
  function toEnd$lambda($this_toEnd) {
    return function () {
      // Inline function 'kotlin.check' call
      if (!$this_toEnd.p92().uv()) {
        throw IllegalStateException_init_$Create$_0('Check failed.');
      }
      get_positionHandler($this_toEnd).ka4();
      $this_toEnd.s8n();
      CellScrolling_getInstance().xa4($this_toEnd);
      return Unit_instance;
    };
  }
  function toLastFocusable$lambda($this_toLastFocusable) {
    return function () {
      var cell = lastFocusable($this_toLastFocusable);
      var tmp;
      if (!(cell == null)) {
        tmp = toEnd_0(cell)();
      }
      return Unit_instance;
    };
  }
  function toHome$lambda($this_toHome) {
    return function () {
      // Inline function 'kotlin.check' call
      if (!$this_toHome.p92().uv()) {
        throw IllegalStateException_init_$Create$_0('Check failed.');
      }
      get_positionHandler($this_toHome).ja4();
      $this_toHome.s8n();
      CellScrolling_getInstance().xa4($this_toHome);
      return Unit_instance;
    };
  }
  function toFirstFocusable$lambda($this_toFirstFocusable) {
    return function () {
      var cell = firstFocusable($this_toFirstFocusable);
      var tmp;
      if (!(cell == null)) {
        tmp = toHome(cell)();
      }
      return Unit_instance;
    };
  }
  function toPosition$lambda($this_toPosition, $pos) {
    return function () {
      $this_toPosition.s8n();
      get_positionHandler($this_toPosition).da4($pos);
      CellScrolling_getInstance().xa4($this_toPosition);
      return Unit_instance;
    };
  }
  function _get_length__w7ahp7($this) {
    return $this.ya4_1.o8w().uv().length;
  }
  function hasPosition($this, position) {
    return $this.ya4_1.p92().w2w() && !(position === 0 && !$this.ya4_1.c93(TextEditing_getInstance().u99_1)) && !(position === $this.ya4_1.w96() && !$this.ya4_1.c93(TextEditing_getInstance().v99_1)) && position <= _get_length__w7ahp7($this);
  }
  function TextPositionHandler$caretOffset$derivedOffset$1(this$0) {
    this.da5_1 = this$0;
    DerivedProperty.call(this, []);
  }
  protoOf(TextPositionHandler$caretOffset$derivedOffset$1).q2w = function () {
    return this.da5_1.ya4_1.z96(this.da5_1.ya4_1.t96().uv());
  };
  protoOf(TextPositionHandler$caretOffset$derivedOffset$1).v2w = function () {
    return 'derivedOffset(' + this.da5_1.ya4_1.toString() + ')';
  };
  function TextPositionHandler$caretOffset$1($derivedOffset, this$0) {
    this.ea5_1 = $derivedOffset;
    this.fa5_1 = this$0;
  }
  protoOf(TextPositionHandler$caretOffset$1).uv = function () {
    return this.ea5_1.uv();
  };
  protoOf(TextPositionHandler$caretOffset$1).na4 = function (handler) {
    return this.ea5_1.u2w(handler);
  };
  protoOf(TextPositionHandler$caretOffset$1).y2r = function (handler) {
    return this.na4(handler);
  };
  protoOf(TextPositionHandler$caretOffset$1).oa4 = function (newValue) {
    var tmp0 = Companion_getInstance_184().ha5(this.fa5_1.ya4_1);
    var tmp0_0 = Companion_getInstance_184().ia5(this.fa5_1.ya4_1);
    // Inline function 'kotlin.math.min' call
    var b = this.fa5_1.ya4_1.m97(newValue);
    // Inline function 'kotlin.math.max' call
    var b_0 = Math.min(tmp0_0, b);
    var caretAt = Math.max(tmp0, b_0);
    this.fa5_1.ya4_1.t96().d2x(caretAt);
  };
  protoOf(TextPositionHandler$caretOffset$1).d2x = function (newValue) {
    return this.oa4((!(newValue == null) ? typeof newValue === 'number' : false) ? newValue : THROW_CCE());
  };
  protoOf(TextPositionHandler$caretOffset$1).v2w = function () {
    return 'caretOffset(' + this.fa5_1.ya4_1.toString() + ')';
  };
  function TextPositionHandler(editor) {
    this.ya4_1 = editor;
  }
  protoOf(TextPositionHandler).x96 = function () {
    return Companion_getInstance_184().ha5(this.ya4_1) === this.ya4_1.t96().uv();
  };
  protoOf(TextPositionHandler).v96 = function () {
    return Companion_getInstance_184().ia5(this.ya4_1) === this.ya4_1.t96().uv();
  };
  protoOf(TextPositionHandler).w2m = function () {
    return Companion_getInstance_184().ha5(this.ya4_1) === Companion_getInstance_184().ia5(this.ya4_1);
  };
  protoOf(TextPositionHandler).ga4 = function () {
    return this.ya4_1.t96().uv() === 0;
  };
  protoOf(TextPositionHandler).ha4 = function () {
    return this.ya4_1.t96().uv() === this.ya4_1.o8w().uv().length;
  };
  protoOf(TextPositionHandler).ia4 = function () {
    // Inline function 'kotlin.text.isEmpty' call
    var this_0 = this.ya4_1.o8w().uv();
    return charSequenceLength(this_0) === 0;
  };
  protoOf(TextPositionHandler).ja4 = function () {
    this.ya4_1.t96().d2x(Companion_getInstance_184().ha5(this.ya4_1));
  };
  protoOf(TextPositionHandler).ka4 = function () {
    this.ya4_1.t96().d2x(Companion_getInstance_184().ia5(this.ya4_1));
  };
  protoOf(TextPositionHandler).la4 = function () {
    var derivedOffset = new TextPositionHandler$caretOffset$derivedOffset$1(this);
    return new TextPositionHandler$caretOffset$1(derivedOffset, this);
  };
  protoOf(TextPositionHandler).da4 = function (position) {
    if (hasPosition(this, position)) {
      this.ya4_1.t96().d2x(position);
      this.ya4_1.c97().d2x(true);
      this.ya4_1.s8n();
      return new SetPositionResult(true, 0);
    }
    var leftAhead = position - _get_length__w7ahp7(this) | 0;
    // Inline function 'kotlin.require' call
    if (!(leftAhead >= 0)) {
      var message = 'Position ' + position + ' in ' + this.ya4_1.toString() + ' is not available';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    return new SetPositionResult(false, leftAhead);
  };
  protoOf(TextPositionHandler).ma4 = function (offset) {
    var originX = get_origin(this.ya4_1).d8c_1;
    var tmp0 = abs_0((originX + this.ya4_1.z96(Companion_getInstance_184().ia5(this.ya4_1)) | 0) - offset | 0);
    // Inline function 'kotlin.math.min' call
    var b = abs_0((originX + this.ya4_1.z96(Companion_getInstance_184().ha5(this.ya4_1)) | 0) - offset | 0);
    return Math.min(tmp0, b);
  };
  function doClearComposite($this, cell, interval) {
    var text = cell.o8w().uv();
    var lowerEndpoint = interval.v36_1;
    var newText = take_1(text, lowerEndpoint) + substring_0(text, interval.f37());
    cell.o8w().d2x(newText);
    cell.t96().d2x(lowerEndpoint);
    cell.i90(Companion_getInstance_154().m8x_1, minus_2(cell.k91(Companion_getInstance_154().m8x_1), getCompositeDecoration($this, interval)));
  }
  function getCompositeDecoration($this, interval) {
    return new BackgroundHighlightTextDecoration(Companion_getInstance_210().p95_1, interval);
  }
  function InputMethodEditorUtil$showComposite$$inlined$toDisposable$1($cell, $interval) {
    this.ja5_1 = $cell;
    this.ka5_1 = $interval;
  }
  protoOf(InputMethodEditorUtil$showComposite$$inlined$toDisposable$1).zr = function () {
    doClearComposite(InputMethodEditorUtil_getInstance(), this.ja5_1, this.ka5_1);
    return Unit_instance;
  };
  function InputMethodEditorUtil() {
    InputMethodEditorUtil_instance = this;
    this.la5_1 = CellPropertySpec_init_$Create$('compositionReg', Companion_getInstance_29().m2l_1);
  }
  protoOf(InputMethodEditorUtil).ma5 = function (cell) {
    return !(cell.k91(this.la5_1) === Companion_getInstance_29().m2l_1);
  };
  protoOf(InputMethodEditorUtil).na5 = function (cell) {
    cell.k91(this.la5_1).zr();
    cell.i90(this.la5_1, Companion_getInstance_29().m2l_1);
  };
  protoOf(InputMethodEditorUtil).oa5 = function (cell, composite) {
    this.na5(cell);
    var caretPosition = cell.t96().uv();
    var interval = Companion_instance_37.z36(caretPosition, composite.length);
    // Inline function 'jetbrains.ocelot.base.disposable.toDisposable' call
    var tmp$ret$0 = new InputMethodEditorUtil$showComposite$$inlined$toDisposable$1(cell, interval);
    cell.i90(this.la5_1, tmp$ret$0);
    var newText = cell.s96() + composite + cell.u96();
    var newCaret = caretPosition + composite.length | 0;
    cell.o8w().d2x(newText);
    cell.t96().d2x(newCaret);
    cell.i90(Companion_getInstance_154().m8x_1, plus_11(HashSet_init_$Create$_0(cell.k91(Companion_getInstance_154().m8x_1)), getCompositeDecoration(this, interval)));
  };
  var InputMethodEditorUtil_instance;
  function InputMethodEditorUtil_getInstance() {
    if (InputMethodEditorUtil_instance == null)
      new InputMethodEditorUtil();
    return InputMethodEditorUtil_instance;
  }
  function get_STATE_HANDLER() {
    _init_properties_StateHandlers_kt__hg1r2w();
    return STATE_HANDLER;
  }
  var STATE_HANDLER;
  function get_STATE_HANDLER_WITH_VALID() {
    _init_properties_StateHandlers_kt__hg1r2w();
    return STATE_HANDLER_WITH_VALID;
  }
  var STATE_HANDLER_WITH_VALID;
  function STATE_HANDLER$1() {
    TextEditorStateHandler.call(this);
  }
  protoOf(STATE_HANDLER$1).pa5 = function (editor, validator) {
    return new TextEditorCellState();
  };
  protoOf(STATE_HANDLER$1).qa5 = function (editor, state) {
  };
  function STATE_HANDLER_WITH_VALID$1() {
    TextEditorStateHandler.call(this);
  }
  protoOf(STATE_HANDLER_WITH_VALID$1).pa5 = function (editor, validator) {
    var text = editor.o8w().uv();
    var isValid = ensureNotNull(validator)(text);
    return new TextEditorCellState(VOID, text, isValid);
  };
  protoOf(STATE_HANDLER_WITH_VALID$1).qa5 = function (editor, state) {
    editor.o8w().d2x(state.va5_1);
  };
  var properties_initialized_StateHandlers_kt_cy39me;
  function _init_properties_StateHandlers_kt__hg1r2w() {
    if (!properties_initialized_StateHandlers_kt_cy39me) {
      properties_initialized_StateHandlers_kt_cy39me = true;
      STATE_HANDLER = new STATE_HANDLER$1();
      STATE_HANDLER_WITH_VALID = new STATE_HANDLER_WITH_VALID$1();
    }
  }
  function TextCopyPasteTrait() {
    TextCopyTrait.call(this);
  }
  protoOf(TextCopyPasteTrait).h92 = function (cell, event) {
    var content = event.c8m_1;
    if (!content.e8i(ContentKinds_getInstance().f8m_1) && !(content.e8i(ContentKinds_getInstance().g8m_1) && !(cell.c93(TextEditing_getInstance().b9a_1) == null))) {
      return Unit_instance;
    }
    var editor = cell instanceof TextCell ? cell : THROW_CCE();
    var tmp;
    if (content.e8i(ContentKinds_getInstance().f8m_1)) {
      tmp = content.f8i(ContentKinds_getInstance().f8m_1);
    } else {
      var adapt = ensureNotNull(cell.c93(TextEditing_getInstance().b9a_1));
      tmp = adapt(content.f8i(ContentKinds_getInstance().g8m_1));
    }
    var string = tmp;
    this.xa5(editor, string);
    event.p8i();
  };
  protoOf(TextCopyPasteTrait).g92 = function (cell, event) {
    if (this.aa6(cell)) {
      var content = this.ya5(cell);
      var editor = cell instanceof TextCell ? cell : THROW_CCE();
      this.za5(editor, event);
      event.u8i(content);
    }
  };
  function TextCopyTrait() {
    CellTrait.call(this);
  }
  protoOf(TextCopyTrait).f92 = function (cell, event) {
    if (this.aa6(cell)) {
      event.t8i(this.ya5(cell));
    }
  };
  protoOf(TextCopyTrait).aa6 = function (cell) {
    var editor = cell instanceof TextCell ? cell : THROW_CCE();
    return editor.h97().uv() && !(editor.i97().uv() === editor.j97().uv());
  };
  protoOf(TextCopyTrait).ya5 = function (cell) {
    var editor = cell instanceof TextCell ? cell : THROW_CCE();
    var selection = editor.a97();
    var selected = substring(editor.o8w().uv(), selection.h95_1, selection.i95_1);
    return TextContentHelper_getInstance().r8m(selected);
  };
  function TextEditing$textNavigation$o$get$lambda($spec) {
    return function (matcher) {
      return matcher($spec);
    };
  }
  function TextEditing$textNavigation$o$get$lambda_0($spec) {
    return function (matcher) {
      return matcher($spec);
    };
  }
  function TextEditing$adaptMultilinePaste$o$get$lambda(strings) {
    return joinToString_0(strings, ' ');
  }
  function TextEditing$AFTER_TYPE$lambda(it) {
    return TextEditing$AFTER_TYPE$lambda$lambda;
  }
  function TextEditing$AFTER_TYPE$lambda$lambda() {
    return false;
  }
  function TextEditing$AFTER_PASTE$lambda(it) {
    return TextEditing$AFTER_PASTE$lambda$lambda;
  }
  function TextEditing$AFTER_PASTE$lambda$lambda() {
    return false;
  }
  function TextEditing$AFTER_DELETE$lambda(it) {
    return TextEditing$AFTER_DELETE$lambda$lambda;
  }
  function TextEditing$AFTER_DELETE$lambda$lambda() {
    return false;
  }
  function TextEditing$PREFIX_EAGER_COMPLETION$lambda(_unused_var__etf5q3) {
    return true;
  }
  function TextEditing$PROPAGATE_SUFFIX$lambda(_unused_var__etf5q3, _unused_var__etf5q3_0) {
    return true;
  }
  function TextEditing$ON_VALIDATOR_CHANGED$lambda(it) {
    return TextEditing$ON_VALIDATOR_CHANGED$lambda$lambda;
  }
  function TextEditing$ON_VALIDATOR_CHANGED$lambda$lambda() {
    return Unit_instance;
  }
  function TextEditing$TEXT_NAVIGATION_TRAIT$1() {
    BaseDerivedCellTrait.call(this, new TextNavigationTrait());
  }
  protoOf(TextEditing$TEXT_NAVIGATION_TRAIT$1).n91 = function (cell, spec) {
    // Inline function 'jetbrains.ocelot.projectional.cell.trait.getSpecValue' call
    var result = TextEditing_getInstance().h9a_1(spec);
    var tmp;
    if (result == null) {
      tmp = protoOf(BaseDerivedCellTrait).n91.call(this, cell, spec);
    } else {
      tmp = result.o9n_1;
    }
    return tmp;
  };
  function TextEditing$TEXT_EDITING_TRAIT$1() {
    BaseDerivedCellTrait.call(this, new TextEditingTrait());
  }
  protoOf(TextEditing$TEXT_EDITING_TRAIT$1).o91 = function (cell) {
    protoOf(BaseDerivedCellTrait).o91.call(this, cell);
    assertFocusable(cell);
  };
  protoOf(TextEditing$TEXT_EDITING_TRAIT$1).n91 = function (cell, spec) {
    // Inline function 'jetbrains.ocelot.projectional.cell.trait.getSpecValue' call
    var result = TextEditing_getInstance().h9a_1(spec);
    var tmp;
    if (result == null) {
      tmp = protoOf(BaseDerivedCellTrait).n91.call(this, cell, spec);
    } else {
      tmp = result.o9n_1;
    }
    return tmp;
  };
  function TextEditing$textNavigation$lambda($spec, $firstAllowed) {
    return function (inputSpec) {
      var tmp;
      if (inputSpec === $spec) {
        var tmp$ret$0 = $firstAllowed();
        tmp = new SpecMatchResult(tmp$ret$0);
      } else {
        tmp = null;
      }
      return tmp;
    };
  }
  function TextEditing$textNavigation$lambda_0($spec, $lastAllowed) {
    return function (inputSpec) {
      var tmp;
      if (inputSpec === $spec) {
        var tmp$ret$0 = $lastAllowed();
        tmp = new SpecMatchResult(tmp$ret$0);
      } else {
        tmp = null;
      }
      return tmp;
    };
  }
  function TextEditing$textNavigation$1($matchers) {
    this.fa6_1 = $matchers;
    DerivedCellTrait.call(this);
  }
  protoOf(TextEditing$textNavigation$1).da6 = function (cell) {
    return TextEditing_getInstance().i9a_1;
  };
  protoOf(TextEditing$textNavigation$1).n91 = function (cell, spec) {
    // Inline function 'jetbrains.ocelot.projectional.cell.trait.getSpecValue' call
    var specMatchers = this.fa6_1;
    var tmp = asSequence_0(specMatchers);
    var result = firstOrNull_2(filterNotNull_0(map(tmp, TextEditing$textNavigation$o$get$lambda(spec))));
    var tmp_0;
    if (result == null) {
      tmp_0 = protoOf(DerivedCellTrait).n91.call(this, cell, spec);
    } else {
      tmp_0 = result.o9n_1;
    }
    return tmp_0;
  };
  function TextEditing$textNavigation$2($matchers) {
    this.ga6_1 = $matchers;
    DerivedCellTrait.call(this);
  }
  protoOf(TextEditing$textNavigation$2).da6 = function (cell) {
    return TextEditing_getInstance().i9a_1;
  };
  protoOf(TextEditing$textNavigation$2).o91 = function (cell) {
    protoOf(DerivedCellTrait).o91.call(this, cell);
    assertFocusable(cell);
  };
  protoOf(TextEditing$textNavigation$2).n91 = function (cell, spec) {
    // Inline function 'jetbrains.ocelot.projectional.cell.trait.getSpecValue' call
    var specMatchers = this.ga6_1;
    var tmp = asSequence_0(specMatchers);
    var result = firstOrNull_2(filterNotNull_0(map(tmp, TextEditing$textNavigation$o$get$lambda_0(spec))));
    var tmp_0;
    if (result == null) {
      tmp_0 = protoOf(DerivedCellTrait).n91.call(this, cell, spec);
    } else {
      tmp_0 = result.o9n_1;
    }
    return tmp_0;
  };
  function TextEditing$validTextEditing$2($validator) {
    this.ha6_1 = $validator;
    DerivedCellTrait.call(this);
  }
  protoOf(TextEditing$validTextEditing$2).da6 = function (cell) {
    return TextEditing_getInstance().l9a_1;
  };
  protoOf(TextEditing$validTextEditing$2).n91 = function (cell, spec) {
    var specMatcher = specMatcherValue(Companion_getInstance_185().ia6_1, this.ha6_1);
    // Inline function 'jetbrains.ocelot.projectional.cell.trait.getSpecValue' call
    var result = specMatcher(spec);
    var tmp;
    if (result == null) {
      tmp = protoOf(DerivedCellTrait).n91.call(this, cell, spec);
    } else {
      tmp = result.o9n_1;
    }
    return tmp;
  };
  function TextEditing$adaptMultilinePaste$$inlined$propertyTrait$1($propSpec) {
    this.la6_1 = $propSpec;
    CellTrait.call(this);
  }
  protoOf(TextEditing$adaptMultilinePaste$$inlined$propertyTrait$1).n91 = function (cell, spec) {
    var tmp;
    if (spec === this.la6_1) {
      tmp = TextEditing$adaptMultilinePaste$o$get$lambda;
    } else {
      tmp = protoOf(CellTrait).n91.call(this, cell, spec);
    }
    return tmp;
  };
  function TextEditing() {
    TextEditing_instance = this;
    this.s99_1 = CellTraitPropertySpec_init_$Create$('navigable', false);
    this.t99_1 = CellTraitPropertySpec_init_$Create$('editable', false);
    this.u99_1 = CellTraitPropertySpec_init_$Create$('firstAllowed', true);
    this.v99_1 = CellTraitPropertySpec_init_$Create$('lastAllowed', true);
    this.w99_1 = CellTraitPropertySpec_init_$Create$('dotLikeRt', false);
    this.x99_1 = CellTraitPropertySpec_init_$Create$('clearOnDelete', false);
    var tmp = this;
    tmp.y99_1 = new CellTraitPropertySpec('afterType', TextEditing$AFTER_TYPE$lambda);
    var tmp_0 = this;
    tmp_0.z99_1 = new CellTraitPropertySpec('afterPaste', TextEditing$AFTER_PASTE$lambda);
    var tmp_1 = this;
    tmp_1.a9a_1 = new CellTraitPropertySpec('afterDelete', TextEditing$AFTER_DELETE$lambda);
    this.b9a_1 = CellTraitPropertySpec_init_$Create$('adaptMultilinePaste', null);
    this.c9a_1 = CellTraitPropertySpec_init_$Create$('eagerCompletion', false);
    var tmp_2 = this;
    tmp_2.d9a_1 = CellTraitPropertySpec_init_$Create$('prefixEagerCompletion', TextEditing$PREFIX_EAGER_COMPLETION$lambda);
    var tmp_3 = this;
    tmp_3.e9a_1 = CellTraitPropertySpec_init_$Create$('propagateSuffix', TextEditing$PROPAGATE_SUFFIX$lambda);
    this.f9a_1 = Companion_getInstance_185().ia6_1;
    var tmp_4 = this;
    tmp_4.g9a_1 = new CellTraitPropertySpec('onValidatorChanged', TextEditing$ON_VALIDATOR_CHANGED$lambda);
    this.h9a_1 = specMatcherValue(Companion_getInstance_189().ma6_1, get_STATE_HANDLER());
    var tmp_5 = this;
    tmp_5.i9a_1 = new TextEditing$TEXT_NAVIGATION_TRAIT$1();
    var tmp_6 = this;
    tmp_6.j9a_1 = new TextEditing$TEXT_EDITING_TRAIT$1();
    this.k9a_1 = new TextCopyTrait();
    this.l9a_1 = new ValidTextEditingTrait();
  }
  protoOf(TextEditing).na6 = function () {
    return this.i9a_1;
  };
  protoOf(TextEditing).oa6 = function (firstAllowed, lastAllowed) {
    // Inline function 'jetbrains.ocelot.projectional.cell.trait.specMatcher' call
    var spec = this.u99_1;
    var tmp = TextEditing$textNavigation$lambda(spec, firstAllowed);
    // Inline function 'jetbrains.ocelot.projectional.cell.trait.specMatcher' call
    var spec_0 = this.v99_1;
    var tmp$ret$1 = TextEditing$textNavigation$lambda_0(spec_0, lastAllowed);
    var matchers = listOf_0([tmp, tmp$ret$1]);
    return new TextEditing$textNavigation$1(matchers);
  };
  protoOf(TextEditing).pa6 = function (firstAllowed, lastAllowed, selectionAvailable) {
    var matchers = listOf_0([specMatcherValue(this.u99_1, firstAllowed), specMatcherValue(this.v99_1, lastAllowed), specMatcherValue(Companion_getInstance_184().ga5_1, selectionAvailable)]);
    return new TextEditing$textNavigation$2(matchers);
  };
  protoOf(TextEditing).m9a = function (firstAllowed, lastAllowed, selectionAvailable, $super) {
    selectionAvailable = selectionAvailable === VOID ? true : selectionAvailable;
    return $super === VOID ? this.pa6(firstAllowed, lastAllowed, selectionAvailable) : $super.pa6.call(this, firstAllowed, lastAllowed, selectionAvailable);
  };
  protoOf(TextEditing).qa6 = function () {
    return CompositeCellTraits_instance.ra6([this.i9a_1, this.k9a_1]);
  };
  protoOf(TextEditing).sa6 = function () {
    return this.j9a_1;
  };
  protoOf(TextEditing).ta6 = function (validator) {
    return new TextEditing$validTextEditing$2(validator);
  };
  protoOf(TextEditing).ua6 = function () {
    // Inline function 'jetbrains.ocelot.projectional.cell.trait.propertyTrait' call
    var propSpec = this.b9a_1;
    return new TextEditing$adaptMultilinePaste$$inlined$propertyTrait$1(propSpec);
  };
  var TextEditing_instance;
  function TextEditing_getInstance() {
    if (TextEditing_instance == null)
      new TextEditing();
    return TextEditing_instance;
  }
  function Companion_182() {
    Companion_instance_182 = this;
    this.va6_1 = CellPropertySpec_init_$Create$('textCellStateBeforeCompletion', null);
  }
  protoOf(Companion_182).wa6 = function (cell) {
    if (cell.k91(this.va6_1) == null) {
      cell.i90(this.va6_1, new TextCellStateBeforeCompletion(cell));
    }
  };
  var Companion_instance_182;
  function Companion_getInstance_182() {
    if (Companion_instance_182 == null)
      new Companion_182();
    return Companion_instance_182;
  }
  function setText($this, editor, text) {
    return editor.o8w().d2x(text);
  }
  function isEmpty_0($this, editor) {
    // Inline function 'kotlin.text.isEmpty' call
    var this_0 = editor.o8w().uv();
    return charSequenceLength(this_0) === 0;
  }
  function CopyPasteTrait($outer) {
    this.xa6_1 = $outer;
    TextCopyPasteTrait.call(this);
  }
  protoOf(CopyPasteTrait).xa5 = function (editor, text) {
    clearSelection(this.xa6_1, editor);
    pasteText(this.xa6_1, editor, text);
    this.xa6_1.u9n(editor);
  };
  protoOf(CopyPasteTrait).za5 = function (editor, event) {
    clearSelection(this.xa6_1, editor);
    this.xa6_1.v9n(editor);
    if (isEmpty_0(Companion_getInstance_183(), editor)) {
      editor.v92(new DerivedCopyCutEvent(event, event.s8i_1), Cells_getInstance().g9t_1);
    }
  };
  function dispatchBecameEmpty($this, editor, initial) {
    if (isEmpty_0(Companion_getInstance_183(), editor)) {
      editor.v92(new DerivedEvent(initial), Cells_getInstance().g9t_1);
    }
  }
  function scrollTo_3($this, cell, cause) {
    if (cell.f89()) {
      CellScrolling_getInstance().ya6(cell, cause);
    }
  }
  function maybeShowRightTransformCompletion($this, completionItems, editor) {
    if (editor.c93(Completion_getInstance().z9d_1).p9d(completionItems, editor.s96())) {
      var supplier = editor.c93(Completion_getInstance().w9d_1);
      if (editor.k91(get_RIGHT_POPUP()) == null) {
        var popup = CompletionSupport_getInstance().y9o(editor, get_RIGHT_POPUP(), supplier, true);
        var tmp = Completion_getInstance().w9f(popup);
        var tmp_0 = Companion_getInstance_167().c5f();
        tmp.e9f(tmp_0.r9q(TextCell$focus$ref(editor)).f40());
      }
      return true;
    }
    return false;
  }
  function completeOrShow($this, completionItems, editor, controller, event, stateUnchanged) {
    if (!(completionItems == null) && stateUnchanged) {
      var prefixText = editor.s96();
      var prefixed = completionItems.c9f(prefixText);
      var currentText = editor.o8w().uv();
      var tmp;
      var tmp_0;
      if (prefixed.p() === 1) {
        // Inline function 'kotlin.text.isNotEmpty' call
        tmp_0 = charSequenceLength(currentText) > 0;
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        tmp = $this.t9n(editor);
      } else {
        tmp = false;
      }
      if (tmp) {
        var tmp_1 = ensureNotNull(editor.s8x());
        tmp_1.d9m(TextEditingTrait$completeOrShow$lambda(prefixed, prefixText));
        return Unit_instance;
      }
    }
    if (controller.d9f()) {
      var completionParameters = Companion_getInstance_167().k9m(event.h9m_1).f40();
      controller.e9f(completionParameters);
    }
  }
  function completeOrShow$default($this, completionItems, editor, controller, event, stateUnchanged, $super) {
    stateUnchanged = stateUnchanged === VOID ? true : stateUnchanged;
    return completeOrShow($this, completionItems, editor, controller, event, stateUnchanged);
  }
  function clearSelection($this, editor) {
    if (!editor.h97().uv())
      return Unit_instance;
    var text = editor.o8w().uv();
    var selection = editor.a97();
    setText(Companion_getInstance_183(), editor, take_1(text, selection.h95_1) + substring_0(text, selection.i95_1));
    editor.t96().d2x(selection.h95_1);
    editor.h97().d2x(false);
  }
  function pasteText($this, editor, text) {
    var currentText = editor.o8w().uv();
    var caret = editor.t96().uv();
    setText(Companion_getInstance_183(), editor, take_1(currentText, caret) + text + substring_0(currentText, caret));
    if (editor.f89()) {
      editor.t96().d2x(caret + text.length | 0);
    }
  }
  function callCustomProcessor($this, editor, prop) {
    var processor = editor.c93(prop);
    return processor();
  }
  function TextCellStateBeforeCompletion(cell) {
    Companion_getInstance_182();
    this.za6_1 = cell.o8w().w2w();
    this.aa7_1 = cell.s8x();
  }
  protoOf(TextCellStateBeforeCompletion).ba7 = function (cell) {
    return cell.o8w().w2w() === this.za6_1 && cell.s8x() === this.aa7_1;
  };
  protoOf(TextCellStateBeforeCompletion).ca7 = function (cell) {
    return !(cell.s8x() === this.aa7_1) ? null : !startsWith(cell.o8w().w2w(), this.za6_1) ? null : cell.o8w().w2w().length - this.za6_1.length | 0;
  };
  protoOf(TextCellStateBeforeCompletion).da7 = function (cell) {
    return !(cell.s8x() === this.aa7_1) ? null : !startsWith(this.za6_1, cell.o8w().w2w()) ? null : this.za6_1.length - cell.o8w().w2w().length | 0;
  };
  function Companion_183() {
    Companion_instance_183 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.ea7_1 = [new TextNavigationTrait()];
  }
  var Companion_instance_183;
  function Companion_getInstance_183() {
    if (Companion_instance_183 == null)
      new Companion_183();
    return Companion_instance_183;
  }
  function TextEditingTrait$onComplete$slambda(this$0, $editor, $controller, $event, $savedState, resultContinuation) {
    this.na7_1 = this$0;
    this.oa7_1 = $editor;
    this.pa7_1 = $controller;
    this.qa7_1 = $event;
    this.ra7_1 = $savedState;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(TextEditingTrait$onComplete$slambda).ta7 = function (it, $completion) {
    var tmp = this.ua7(it, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(TextEditingTrait$onComplete$slambda).v9 = function (p1, $completion) {
    return this.ta7((p1 == null ? true : p1 instanceof CompletionItems) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(TextEditingTrait$onComplete$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        if (tmp === 0) {
          this.g9_1 = 1;
          completeOrShow(this.na7_1, this.sa7_1, this.oa7_1, this.pa7_1, this.qa7_1, this.na7_1.w9n(this.oa7_1, this.ra7_1));
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(TextEditingTrait$onComplete$slambda).ua7 = function (it, completion) {
    var i = new TextEditingTrait$onComplete$slambda(this.na7_1, this.oa7_1, this.pa7_1, this.qa7_1, this.ra7_1, completion);
    i.sa7_1 = it;
    return i;
  };
  function TextEditingTrait$onComplete$slambda_0(this$0, $editor, $controller, $event, $savedState, resultContinuation) {
    var i = new TextEditingTrait$onComplete$slambda(this$0, $editor, $controller, $event, $savedState, resultContinuation);
    var l = function (it, $completion) {
      return i.ta7(it, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function TextCell$focus$ref(p0) {
    var l = function () {
      p0.s8n();
      return Unit_instance;
    };
    l.callableName = 'focus';
    return l;
  }
  function TextEditingTrait$completeOrShow$lambda($prefixed, $prefixText) {
    return function () {
      $prefixed.r(0).s9m($prefixText)();
      return Unit_instance;
    };
  }
  function TextEditingTrait() {
    Companion_getInstance_183();
    CompositeCellTrait.call(this);
  }
  protoOf(TextEditingTrait).s9n = function (cell) {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return arrayConcat([Companion_getInstance_183().ea7_1, [new CopyPasteTrait(this)]]);
  };
  protoOf(TextEditingTrait).n91 = function (cell, spec) {
    var specMatcher = specMatcherValue(TextEditing_getInstance().t99_1, true);
    // Inline function 'jetbrains.ocelot.projectional.cell.trait.getSpecValue' call
    var result = specMatcher(spec);
    var tmp;
    if (result == null) {
      tmp = protoOf(CompositeCellTrait).n91.call(this, cell, spec);
    } else {
      tmp = result.o9n_1;
    }
    return tmp;
  };
  protoOf(TextEditingTrait).s8z = function (cell, event) {
    var editor = cell instanceof TextCell ? cell : THROW_CCE();
    var currentText = editor.o8w().uv();
    var caret = editor.t96().uv();
    var textLen = currentText.length;
    // Inline function 'kotlin.text.isNotEmpty' call
    var nonEmptyText = charSequenceLength(currentText) > 0;
    if (editor.h97().uv() && (event.m8j(Key_BACKSPACE_getInstance(), []) || event.m8j(Key_DELETE_getInstance(), []))) {
      clearSelection(this, editor);
      this.v9n(editor);
      dispatchBecameEmpty(this, editor, event);
      event.p8i();
      return Unit_instance;
    }
    if (event.m8j(Key_BACKSPACE_getInstance(), []) && caret > 0) {
      editor.t96().d2x(caret - 1 | 0);
      setText(Companion_getInstance_183(), editor, take_1(currentText, caret - 1 | 0) + substring_0(currentText, caret));
      this.v9n(editor);
      dispatchBecameEmpty(this, editor, event);
      scrollTo_3(this, cell, event);
      event.p8i();
      return Unit_instance;
    }
    if (event.m8j(Key_DELETE_getInstance(), []) && caret < textLen) {
      setText(Companion_getInstance_183(), editor, take_1(currentText, caret) + substring_0(currentText, caret + 1 | 0));
      this.v9n(editor);
      dispatchBecameEmpty(this, editor, event);
      event.p8i();
      return Unit_instance;
    }
    if (event.o8j([KeyStrokeSpecs_getInstance().h8l_1]) && cell.c93(TextEditing_getInstance().x99_1) && nonEmptyText) {
      setText(Companion_getInstance_183(), editor, '');
      this.v9n(editor);
      dispatchBecameEmpty(this, editor, event);
      event.p8i();
      return Unit_instance;
    }
    if (event.o8j([KeyStrokeSpecs_getInstance().i8l_1]) && nonEmptyText && caret > 0) {
      editor.t96().d2x(0);
      setText(Companion_getInstance_183(), editor, substring(currentText, caret, textLen));
      this.v9n(editor);
      dispatchBecameEmpty(this, editor, event);
      event.p8i();
      return Unit_instance;
    }
    if (editor.h97().uv() && event.o8j([KeyStrokeSpecs_getInstance().g8l_1])) {
      var selection = editor.a97();
      var selected = substring(editor.o8w().uv(), selection.h95_1, selection.i95_1);
      editor.o8w().d2x(insert(currentText, selection.h95_1, selected));
      this.p9n(editor, event.i8j_1);
      dispatchBecameEmpty(this, editor, event);
      event.p8i();
    }
    protoOf(CompositeCellTrait).s8z.call(this, cell, event);
  };
  protoOf(TextEditingTrait).i92 = function (cell, event) {
    var controller = Completion_getInstance().w9f(cell);
    if (controller.io()) {
      protoOf(CompositeCellTrait).i92.call(this, cell, event);
      return Unit_instance;
    }
    var editor = cell instanceof TextCell ? cell : THROW_CCE();
    var immediateRtApplicable = editor.v96() && editor.c93(TextEditing_getInstance().w99_1) && valueIsSet(editor, Completion_getInstance().w9d_1);
    if (valueIsSet(editor, Completion_getInstance().u9d_1) || immediateRtApplicable) {
      var result = controller.p9f();
      if (get_isReady(result)) {
        var completionItems = CompletionItems_init_$Create$(result);
        if (immediateRtApplicable) {
          if (maybeShowRightTransformCompletion(this, completionItems, editor)) {
            return Unit_instance;
          }
        }
        completeOrShow$default(this, completionItems, editor, controller, event);
      } else {
        var savedState = new TextCellStateBeforeCompletion(editor);
        var timeout = fromInt_0(editor.c93(Completion_getInstance().z9d_1).q9d());
        var tmp = AsyncCompletionSupport_getInstance();
        tmp.m9d(editor, result, timeout, VOID, TextEditingTrait$onComplete$slambda_0(this, editor, controller, event, savedState, null));
      }
      event.n8i();
    }
  };
  protoOf(TextEditingTrait).t9n = function (editor) {
    return true;
  };
  protoOf(TextEditingTrait).q8y = function (cell, event) {
    var editor = cell instanceof TextCell ? cell : THROW_CCE();
    clearSelection(this, editor);
    var text = toString(event.i8j_1);
    pasteText(this, editor, text);
    if (editor.f89()) {
      CellScrolling_getInstance().ya6(editor, event);
      this.p9n(editor, event.i8j_1);
    }
    event.n8i();
  };
  protoOf(TextEditingTrait).j92 = function (cell, event) {
    clearSelection(this, cell instanceof TextCell ? cell : THROW_CCE());
    InputMethodEditorUtil_getInstance().oa5(cell, event.j8i_1);
    event.n8i();
  };
  protoOf(TextEditingTrait).k92 = function (cell, event) {
    var tmp = InputMethodEditorUtil_getInstance();
    tmp.oa5(cell instanceof TextCell ? cell : THROW_CCE(), event.j8i_1);
    event.n8i();
  };
  protoOf(TextEditingTrait).l92 = function (cell, event) {
    var tmp = InputMethodEditorUtil_getInstance();
    tmp.na5(cell instanceof TextCell ? cell : THROW_CCE());
    event.n8i();
  };
  protoOf(TextEditingTrait).p9n = function (editor, typed) {
    return callCustomProcessor(this, editor, TextEditing_getInstance().y99_1);
  };
  protoOf(TextEditingTrait).u9n = function (editor) {
    return callCustomProcessor(this, editor, TextEditing_getInstance().z99_1);
  };
  protoOf(TextEditingTrait).v9n = function (editor) {
    return callCustomProcessor(this, editor, TextEditing_getInstance().a9a_1);
  };
  protoOf(TextEditingTrait).w9n = function (_this__u8e3s4, state) {
    return state.ba7(_this__u8e3s4);
  };
  protoOf(TextEditingTrait).va7 = function (_this__u8e3s4, state) {
    return state.ca7(_this__u8e3s4);
  };
  protoOf(TextEditingTrait).wa7 = function (_this__u8e3s4, state) {
    return state.da7(_this__u8e3s4);
  };
  function insert(_this__u8e3s4, offset, str) {
    return (new StringBuilder(_this__u8e3s4)).jc(offset, str).toString();
  }
  function TextEditorCellState(caretPosition, text, isValid) {
    caretPosition = caretPosition === VOID ? 0 : caretPosition;
    text = text === VOID ? '' : text;
    isValid = isValid === VOID ? true : isValid;
    this.ua5_1 = caretPosition;
    this.va5_1 = text;
    this.wa5_1 = isValid;
  }
  protoOf(TextEditorCellState).xa7 = function (state) {
    var tmp;
    if (!(state instanceof TextEditorCellState)) {
      tmp = this.wa5_1 ? CellStateDifference_NAVIGATION_getInstance() : CellStateDifference_EDIT_getInstance();
    } else {
      if (!(this.va5_1 === state.va5_1)) {
        tmp = CellStateDifference_EDIT_getInstance();
      } else {
        if (this.ua5_1 === state.ua5_1) {
          tmp = CellStateDifference_EQUAL_getInstance();
        } else {
          tmp = CellStateDifference_NAVIGATION_getInstance();
        }
      }
    }
    return tmp;
  };
  protoOf(TextEditorCellState).toString = function () {
    return "text = '" + this.va5_1 + "' caret pos = " + this.ua5_1 + ' valid = ' + this.wa5_1;
  };
  protoOf(TextEditorCellState).hashCode = function () {
    var result = this.ua5_1;
    result = imul(result, 31) + getStringHashCode(this.va5_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.wa5_1) | 0;
    return result;
  };
  protoOf(TextEditorCellState).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TextEditorCellState))
      return false;
    if (!(this.ua5_1 === other.ua5_1))
      return false;
    if (!(this.va5_1 === other.va5_1))
      return false;
    if (!(this.wa5_1 === other.wa5_1))
      return false;
    return true;
  };
  function TextEditorStateHandler() {
  }
  protoOf(TextEditorStateHandler).ra5 = function (cell) {
    var validator = cell.c93(Companion_getInstance_185().ia6_1);
    return validator == null || validator(cell.o8w().uv());
  };
  protoOf(TextEditorStateHandler).ya7 = function (cell) {
    return this.ra5(cell instanceof TextCell ? cell : THROW_CCE());
  };
  protoOf(TextEditorStateHandler).sa5 = function (cell) {
    var validator = cell.c93(Companion_getInstance_185().ia6_1);
    var result = this.pa5(cell, validator);
    var caretPosition = cell.t96().uv();
    return new TextEditorCellState(caretPosition, result.va5_1, result.wa5_1);
  };
  protoOf(TextEditorStateHandler).za7 = function (cell) {
    return this.sa5(cell instanceof TextCell ? cell : THROW_CCE());
  };
  protoOf(TextEditorStateHandler).ta5 = function (cell, state) {
    this.qa5(cell, state);
    cell.t96().d2x(state.ua5_1);
  };
  protoOf(TextEditorStateHandler).aa8 = function (cell, state) {
    var tmp = cell instanceof TextCell ? cell : THROW_CCE();
    return this.ta5(tmp, state instanceof TextEditorCellState ? state : THROW_CCE());
  };
  function assertFocusable(_this__u8e3s4) {
    // Inline function 'kotlin.check' call
    if (!_this__u8e3s4.p92().uv()) {
      var message = 'Focusable cell expected: ' + toString_1(_this__u8e3s4);
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
  }
  function TextEditorUtil() {
  }
  protoOf(TextEditorUtil).ba8 = function (cell, prop, event) {
    if (prop === Companion_getInstance_154().b8x_1) {
      var editor = cell instanceof TextCell ? cell : THROW_CCE();
      var stringChangeEvent = event instanceof PropertyChangeEvent ? event : THROW_CCE();
      var newValue = stringChangeEvent.t2y_1;
      var tmp1_elvis_lhs = newValue == null ? null : newValue.length;
      var newLength = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
      var caretPosition = editor.t96();
      if (caretPosition.uv() > newLength) {
        caretPosition.d2x(newLength);
      }
    }
  };
  var TextEditorUtil_instance;
  function TextEditorUtil_getInstance() {
    return TextEditorUtil_instance;
  }
  function isFirstAllowed($this, cell) {
    return cell.c93(TextEditing_getInstance().u99_1);
  }
  function isLastAllowed($this, cell) {
    return cell.c93(TextEditing_getInstance().v99_1);
  }
  function isSelectionAvailable($this, cell) {
    return cell.c93(Companion_getInstance_184().ga5_1);
  }
  function isCaretKey($this, selectionAvailable, event, key, modifiers) {
    if (event.m8j(key, modifiers.slice()))
      return true;
    if (!selectionAvailable)
      return false;
    var mods = ArrayList_init_$Create$_1(toList(modifiers));
    mods.j(ModifierKey_SHIFT_getInstance());
    // Inline function 'kotlin.collections.toTypedArray' call
    var typedArray = copyToArray(mods);
    return event.m8j(key, typedArray.slice());
  }
  function isDisableSelectionOnArrowMove($this, editor, shift) {
    return !shift && editor.h97().uv();
  }
  function updateCaretOnArrowMove($this, editor, shift, left) {
    if (isDisableSelectionOnArrowMove($this, editor, shift)) {
      if (left) {
        editor.t96().d2x(editor.i97().uv());
      }
    } else {
      var caret = editor.t96().uv();
      editor.t96().d2x(caret + (left ? -1 : 1) | 0);
    }
  }
  function scrollAndUpdateSelectionVisibility($this, event, editor, prevCaret, shift) {
    CellScrolling_getInstance().ya6(editor, event);
    setSelectionVisible($this, editor, prevCaret, shift);
    event.p8i();
  }
  function setSelectionVisible($this, editor, prevCaret, shift) {
    var selectionVisible = editor.h97();
    if (shift) {
      var newCaret = editor.t96().uv();
      if (selectionVisible.uv()) {
        if (newCaret === editor.i97().uv()) {
          selectionVisible.d2x(false);
        }
      } else if (!(newCaret === prevCaret)) {
        editor.i97().d2x(prevCaret);
        selectionVisible.d2x(true);
      }
    } else if (selectionVisible.uv()) {
      selectionVisible.d2x(false);
    }
  }
  function isAllSelected($this, editor) {
    var tmp;
    if (editor.h97().uv()) {
      tmp = getCurrentSelection($this, editor).z8b() === getMaxSelection($this, editor).z8b();
    } else {
      tmp = false;
    }
    return tmp;
  }
  function selectAll($this, editor) {
    var maxSelection = getMaxSelection($this, editor);
    editor.i97().d2x(maxSelection.ca8_1);
    editor.t96().d2x(maxSelection.da8_1);
    editor.h97().d2x(true);
  }
  function getCurrentSelection($this, editor) {
    // Inline function 'kotlin.check' call
    if (!editor.h97().uv()) {
      var message = 'No selection';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    return new Selection_0(editor.i97().uv(), editor.t96().uv());
  }
  function getMaxSelection($this, editor) {
    var min = Companion_getInstance_184().ha5(editor);
    var max = Companion_getInstance_184().ia5(editor);
    var last = editor.w96();
    var tmp;
    if (max >= (last - min | 0)) {
      tmp = new Selection_0(0, max);
    } else {
      tmp = new Selection_0(last, min);
    }
    return tmp;
  }
  function showSideCompletion($this, cell, key, popupProp) {
    var completion = Completion_getInstance().y9f(cell, Companion_getInstance_164().i9e_1, key);
    var tmp;
    if (get_isReady(completion) && CompletionItems_init_$Create$(completion).w2m()) {
      tmp = false;
    } else {
      var popup = CompletionSupport_getInstance().y9o(cell, popupProp, cell.c93(key), false);
      var tmp_0 = Completion_getInstance().w9f(popup);
      var tmp_1 = Companion_getInstance_167().c5f();
      tmp_0.e9f(tmp_1.r9q(Cell$focus$ref(cell)).f40());
      tmp = true;
    }
    return tmp;
  }
  function showCompletion($this, cell, text, key, popupProp) {
    var completionResult = Completion_getInstance().y9f(cell, Companion_getInstance_164().i9e_1, key);
    if (get_isReady(completionResult)) {
      var completion = CompletionItems_init_$Create$(completionResult);
      if (completion.r9n(text, cell.c93(TextEditing_getInstance().c9a_1))) {
        completion.l9p(text);
        return true;
      }
      if (!completion.m9p(text))
        return false;
    }
    var popup = CompletionSupport_getInstance().y9o(cell, popupProp, cell.c93(key), false);
    popup.o8w().d2x(text);
    popup.t96().d2x(popup.w96());
    return true;
  }
  function editorSelect($this, editor, word) {
    editor.i97().d2x(word.v36_1);
    editor.t96().d2x(word.w36_1);
    editor.h97().d2x(true);
    CellScrolling_getInstance().xa4(editor);
  }
  function getWordAtCaret($this, editor) {
    var tmp;
    if (!editor.c97().uv() || Companion_getInstance_184().ha5(editor) === Companion_getInstance_184().ia5(editor)) {
      tmp = Companion_instance_37.a37(-1);
    } else {
      var caret = editor.t96().uv();
      var text = editor.o8w().uv();
      var tmp_0;
      if (caret === Companion_getInstance_184().ha5(editor) || charCodeAt(text, caret - 1 | 0) === _Char___init__impl__6a9atx(32)) {
        tmp_0 = new Interval(caret, getWordRightBound($this, editor, caret));
      } else if (caret === Companion_getInstance_184().ia5(editor) || charCodeAt(text, caret) === _Char___init__impl__6a9atx(32)) {
        tmp_0 = new Interval(getWordStart($this, editor, caret), caret);
      } else {
        tmp_0 = new Interval(getWordStart($this, editor, caret), getWordRightBound($this, editor, caret));
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  function getWordRightBound($this, editor, left) {
    var text = editor.o8w().uv();
    var pos = left;
    $l$loop: while (pos < Companion_getInstance_184().ia5(editor) && charCodeAt(text, pos) !== _Char___init__impl__6a9atx(32)) {
      pos = pos + 1 | 0;
    }
    return pos;
  }
  function getWordStart($this, editor, rightBound) {
    var text = editor.o8w().uv();
    var pos = rightBound - 1 | 0;
    $l$loop: while (pos >= Companion_getInstance_184().ha5(editor) && charCodeAt(text, pos) !== _Char___init__impl__6a9atx(32)) {
      pos = pos - 1 | 0;
    }
    return pos + 1 | 0;
  }
  function handleShiftMousePressed($this, editor, pos) {
    if (editor.y92().uv()) {
      if (!editor.h97().uv()) {
        editor.i97().d2x(editor.t96().uv());
      }
    } else {
      editor.i97().d2x(pos);
    }
    editor.t96().d2x(pos);
    if (!(editor.i97().uv() === pos)) {
      editor.h97().d2x(true);
    }
  }
  function handleMousePressed($this, editor, pos) {
    editor.i97().d2x(pos);
    editor.t96().d2x(pos);
    editor.h97().d2x(false);
  }
  function getPosAt($this, editor, event) {
    var xOffset = event.x8l_1 - get_origin(editor).d8c_1 | 0;
    var yOffset = event.y8l_1 - get_origin(editor).e8c_1 | 0;
    if (yOffset < 0 || yOffset > get_dimension(editor).e8c_1 || xOffset < 0 || xOffset > get_dimension(editor).d8c_1) {
      return -1;
    }
    var maxPos = Companion_getInstance_184().ia5(editor);
    var minPos = Companion_getInstance_184().ha5(editor);
    // Inline function 'kotlin.math.min' call
    var a = editor.m97(xOffset);
    // Inline function 'kotlin.math.max' call
    var b = Math.min(a, maxPos);
    return Math.max(minPos, b);
  }
  function Selection_0(start, caret) {
    this.ca8_1 = start;
    this.da8_1 = caret;
  }
  protoOf(Selection_0).z8b = function () {
    var tmp;
    if (this.ca8_1 > this.da8_1) {
      tmp = this.ca8_1 - this.da8_1 | 0;
    } else {
      tmp = this.da8_1 - this.ca8_1 | 0;
    }
    return tmp;
  };
  function Companion_184() {
    Companion_instance_184 = this;
    this.ga5_1 = CellTraitPropertySpec_init_$Create$('selectionAvailable', true);
  }
  protoOf(Companion_184).ha5 = function (cell) {
    return isFirstAllowed(this, cell) ? 0 : 1;
  };
  protoOf(Companion_184).ia5 = function (cell) {
    var last = cell.w96();
    return isLastAllowed(this, cell) ? last : last - 1 | 0;
  };
  var Companion_instance_184;
  function Companion_getInstance_184() {
    if (Companion_instance_184 == null)
      new Companion_184();
    return Companion_instance_184;
  }
  function Cell$focus$ref(p0) {
    var l = function () {
      p0.s8n();
      return Unit_instance;
    };
    l.callableName = 'focus';
    return l;
  }
  function TextNavigationTrait() {
    Companion_getInstance_184();
    CellTrait.call(this);
  }
  protoOf(TextNavigationTrait).s8z = function (cell, event) {
    var editor = cell instanceof TextCell ? cell : THROW_CCE();
    var currentText = editor.o8w().uv();
    var caret = editor.t96().uv();
    var minCaret = Companion_getInstance_184().ha5(editor);
    var textLen = currentText.length;
    var maxCaret = isLastAllowed(Companion_getInstance_184(), editor) ? textLen : textLen - 1 | 0;
    var selectionAvailable = isSelectionAvailable(this, editor);
    var shift = event.t8j(ModifierKey_SHIFT_getInstance());
    if (isCaretKey(this, selectionAvailable, event, Key_LEFT_getInstance(), []) && (caret > minCaret || isDisableSelectionOnArrowMove(this, editor, shift))) {
      updateCaretOnArrowMove(this, editor, shift, caret > minCaret);
      scrollAndUpdateSelectionVisibility(this, event, editor, caret, shift);
      return Unit_instance;
    }
    if (isCaretKey(this, selectionAvailable, event, Key_RIGHT_getInstance(), []) && (caret < maxCaret || isDisableSelectionOnArrowMove(this, editor, shift))) {
      updateCaretOnArrowMove(this, editor, shift, false);
      scrollAndUpdateSelectionVisibility(this, event, editor, caret, shift);
      return Unit_instance;
    }
    if (caret > 0 && event.o8j([KeyStrokeSpecs_getInstance().z8k_1])) {
      editor.t96().d2x(0);
      setSelectionVisible(this, editor, caret, shift);
      CellScrolling_getInstance().ya6(editor, event);
      event.n8i();
      return Unit_instance;
    }
    if (caret < maxCaret && event.o8j([KeyStrokeSpecs_getInstance().y8k_1])) {
      editor.t96().d2x(maxCaret);
      setSelectionVisible(this, editor, caret, shift);
      CellScrolling_getInstance().ya6(editor, event);
      event.n8i();
      return Unit_instance;
    }
    if (event.o8j([KeyStrokeSpecs_getInstance().t8k_1]) && !isAllSelected(this, editor)) {
      selectAll(this, editor);
      CellScrolling_getInstance().ya6(editor, event);
      event.n8i();
      return Unit_instance;
    }
    protoOf(CellTrait).s8z.call(this, cell, event);
  };
  protoOf(TextNavigationTrait).x8z = function (cell, prop, event) {
    if (prop === get_FOCUSED()) {
      var editor = cell instanceof TextCell ? cell : THROW_CCE();
      var booleanEvent = event instanceof PropertyChangeEvent ? event : THROW_CCE();
      editor.c97().d2x(booleanEvent.t2y_1);
      if (!booleanEvent.t2y_1) {
        editor.h97().d2x(false);
      }
      if (!booleanEvent.t2y_1)
        return Unit_instance;
      var caret = editor.t96().uv();
      var text = editor.o8w().uv();
      if (!isFirstAllowed(Companion_getInstance_184(), editor) && caret === 0) {
        editor.t96().d2x(1);
      }
      if (!isLastAllowed(Companion_getInstance_184(), editor) && caret === text.length) {
        editor.t96().d2x(text.length - 1 | 0);
      }
    }
    TextEditorUtil_instance.ba8(cell, prop, event);
    protoOf(CellTrait).x8z.call(this, cell, prop, event);
  };
  protoOf(TextNavigationTrait).t8z = function (cell, event) {
    var editor = cell instanceof TextCell ? cell : THROW_CCE();
    // Inline function 'kotlin.text.trim' call
    var this_0 = toString(event.i8j_1);
    // Inline function 'kotlin.text.trim' call
    var this_1 = isCharSequence(this_0) ? this_0 : THROW_CCE();
    var startIndex = 0;
    var endIndex = charSequenceLength(this_1) - 1 | 0;
    var startFound = false;
    $l$loop: while (startIndex <= endIndex) {
      var index = !startFound ? startIndex : endIndex;
      var ch = charSequenceGet(this_1, index);
      var match = Char__compareTo_impl_ypi4mb(ch, _Char___init__impl__6a9atx(32)) <= 0;
      if (!startFound) {
        if (!match)
          startFound = true;
        else
          startIndex = startIndex + 1 | 0;
      } else {
        if (!match)
          break $l$loop;
        else
          endIndex = endIndex - 1 | 0;
      }
    }
    var tmp$ret$1 = charSequenceSubSequence(this_1, startIndex, endIndex + 1 | 0);
    var s = toString_1(tmp$ret$1);
    if (editor.v96() && showCompletion(this, editor, s, Completion_getInstance().w9d_1, get_RIGHT_POPUP())) {
      event.n8i();
    } else if (editor.x96() && showCompletion(this, editor, s, Completion_getInstance().v9d_1, get_LEFT_POPUP())) {
      event.n8i();
    }
    protoOf(CellTrait).t8z.call(this, cell, event);
  };
  protoOf(TextNavigationTrait).i92 = function (cell, event) {
    var editor = cell instanceof TextCell ? cell : THROW_CCE();
    var rt = get_rightPopup(cell) == null && editor.v96() && valueIsSet(cell, Completion_getInstance().w9d_1);
    var lt = get_leftPopup(cell) == null && editor.x96() && valueIsSet(cell, Completion_getInstance().v9d_1);
    var completionResult = Completion_getInstance().z9f(cell, Companion_getInstance_164().i9e_1);
    if (get_isReady(completionResult) && CompletionItems_init_$Create$(completionResult).w2m()) {
      if (rt && showSideCompletion(this, editor, Completion_getInstance().w9d_1, get_RIGHT_POPUP())) {
        event.n8i();
        return Unit_instance;
      }
      if (lt && showSideCompletion(this, editor, Completion_getInstance().v9d_1, get_LEFT_POPUP())) {
        event.n8i();
        return Unit_instance;
      }
    }
    protoOf(CellTrait).i92.call(this, cell, event);
  };
  protoOf(TextNavigationTrait).s91 = function (cell, event) {
    var editor = cell instanceof TextCell ? cell : THROW_CCE();
    var word = getWordAtCaret(this, editor);
    if (word.s()) {
      protoOf(CellTrait).s91.call(this, cell, event);
    } else {
      editorSelect(this, editor, word);
    }
  };
  protoOf(TextNavigationTrait).t91 = function (cell, event) {
    if (!event.t8l_1.equals(MouseButton_LEFT_getInstance()) || !cell.p92().w2w())
      return Unit_instance;
    var from = ensureNotNull(cell.s8x()).z92().uv();
    var editor = cell instanceof TextCell ? cell : THROW_CCE();
    var pos = getPosAt(this, editor, event);
    if (pos === -1) {
      return Unit_instance;
    }
    if (event.u8l_1.z8j_1) {
      if (!(from === cell)) {
        return Unit_instance;
      }
      handleShiftMousePressed(this, editor, pos);
    } else {
      handleMousePressed(this, editor, pos);
    }
    editor.s8n();
    event.n8i();
    cell.u92(new FocusEvent(from, cell), Cells_getInstance().f9t_1);
  };
  protoOf(TextNavigationTrait).w91 = function (cell, event) {
    if (!event.t8l_1.equals(MouseButton_LEFT_getInstance()) || !cell.p92().w2w())
      return Unit_instance;
    var editor = cell instanceof TextCell ? cell : THROW_CCE();
    var pos = getPosAt(this, editor, event);
    if (pos === -1) {
      return Unit_instance;
    }
    editor.t96().d2x(pos);
    editor.h97().d2x(true);
    editor.s8n();
    event.p8i();
  };
  protoOf(TextNavigationTrait).n91 = function (cell, spec) {
    var specMatcher = specMatcherValue(TextEditing_getInstance().s99_1, true);
    // Inline function 'jetbrains.ocelot.projectional.cell.trait.getSpecValue' call
    var result = specMatcher(spec);
    var tmp;
    if (result == null) {
      tmp = protoOf(CellTrait).n91.call(this, cell, spec);
    } else {
      tmp = result.o9n_1;
    }
    return tmp;
  };
  function handle($this, cell, runnable) {
    var disposable = cell.g93(Companion_getInstance_185().ka6_1, true);
    try {
      runnable();
    }finally {
      disposable.zr();
      validate_1($this, cell);
    }
  }
  function validate_1($this, cell) {
    var editor = cell instanceof TextCell ? cell : THROW_CCE();
    if (isValid_0($this, editor)) {
      cell.c93(Companion_getInstance_185().ja6_1).zr();
    } else if (!InputMethodEditorUtil_getInstance().ma5(editor)) {
      var text = editor.o8w().uv();
      // Inline function 'kotlin.text.isNotEmpty' call
      if (charSequenceLength(text) > 0) {
        cell.c93(Companion_getInstance_185().ja6_1).zr();
        var removeError = {_v: null};
        var tmp = Companion_getInstance_185().ja6_1;
        var tmp_0 = MessageController_getInstance().m9z(cell, "Invalid '" + text + "'");
        // Inline function 'jetbrains.ocelot.base.disposable.toDisposable' call
        var tmp$ret$1 = new ValidTextEditingTrait$validate$$inlined$toDisposable$1(removeError);
        var disposable = cell.g93(tmp, tmp_0.j2l(tmp$ret$1));
        removeError._v = disposable;
      }
    }
  }
  function onAfterTextAdded($this, editor, cp, sideTransformationsAllowed) {
    var eagerCompletion = editor.c93(TextEditing_getInstance().c9a_1);
    if (!eagerCompletion && isValid_0($this, editor))
      return false;
    // Inline function 'kotlin.text.isEmpty' call
    var this_0 = editor.o8w().w2w();
    if (charSequenceLength(this_0) === 0)
      return false;
    var completionResult = Completion_getInstance().z9f(editor, cp);
    var tmp;
    if (get_isReady(completionResult)) {
      tmp = onAfterTextAdded$action(editor, eagerCompletion, sideTransformationsAllowed, $this, CompletionItems_init_$Create$(completionResult), 1);
    } else {
      Companion_getInstance_182().wa6(editor);
      var tmp_0 = ValidTextEditingTrait$onAfterTextAdded$lambda(editor);
      var clearState = new sam$jetbrains_ocelot_base_disposable_Disposable$0_4(tmp_0);
      var tmp_1 = AsyncCompletionSupport_getInstance();
      tmp_1.k9d(editor, completionResult, clearState, ValidTextEditingTrait$onAfterTextAdded$slambda_0(editor, $this, eagerCompletion, sideTransformationsAllowed, null));
      tmp = true;
    }
    return tmp;
  }
  function getValidator($this, editor) {
    return editor.c93(Companion_getInstance_185().ia6_1);
  }
  function isValid_0($this, editor) {
    var tmp0_safe_receiver = getValidator($this, editor);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver(editor.o8w().uv());
    return tmp1_elvis_lhs == null ? true : tmp1_elvis_lhs;
  }
  function assertValid_0($this, cell) {
    if (cell instanceof TextCell) {
      var validator = getValidator($this, cell);
      // Inline function 'kotlin.check' call
      if (!(validator == null || validator(cell.o8w().uv()))) {
        var message = 'Completion should lead to a valid result, otherwise we might have a stack overflow error; cell: ' + cell.toString();
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      }
    }
  }
  function Companion_185() {
    Companion_instance_185 = this;
    this.ia6_1 = CellTraitPropertySpec_init_$Create$('validator', null);
    this.ja6_1 = CellTraitPropertySpec_init_$Create$('validationError', Companion_getInstance_29().m2l_1);
    this.ka6_1 = CellTraitPropertySpec_init_$Create$('inHandler', false);
  }
  var Companion_instance_185;
  function Companion_getInstance_185() {
    if (Companion_instance_185 == null)
      new Companion_185();
    return Companion_instance_185;
  }
  function sam$jetbrains_ocelot_base_disposable_Disposable$0_4(function_0) {
    this.ea8_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0_4).zr = function () {
    return this.ea8_1();
  };
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0_4).f3 = function () {
    return this.ea8_1;
  };
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0_4).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Disposable) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0_4).hashCode = function () {
    return hashCode(this.f3());
  };
  function onAfterTextAdded$action($editor, eagerCompletion, $sideTransformationsAllowed, this$0, completion, transformPartLength) {
    var text = $editor.o8w().w2w();
    if (completion.r9n(text, eagerCompletion)) {
      var tmp = ensureNotNull($editor.s8x());
      tmp.d9m(ValidTextEditingTrait$onAfterTextAdded$action$lambda(completion, text));
      return true;
    }
    var completed = false;
    if ($sideTransformationsAllowed) {
      if ($editor.v96() && !completion.m9p(text)) {
        var prefix = take_1(text, text.length - transformPartLength | 0);
        var suffix = substring_0(text, text.length - transformPartLength | 0);
        if (ensureNotNull(getValidator(this$0, $editor))(prefix)) {
          var tmp_0 = Side_RIGHT_getInstance();
          // Inline function 'kotlin.text.trim' call
          // Inline function 'kotlin.text.trim' call
          var this_0 = isCharSequence(suffix) ? suffix : THROW_CCE();
          var startIndex = 0;
          var endIndex = charSequenceLength(this_0) - 1 | 0;
          var startFound = false;
          $l$loop: while (startIndex <= endIndex) {
            var index = !startFound ? startIndex : endIndex;
            var it = charSequenceGet(this_0, index);
            var match = Char__compareTo_impl_ypi4mb(it, _Char___init__impl__6a9atx(32)) <= 0;
            if (!startFound) {
              if (!match)
                startFound = true;
              else
                startIndex = startIndex + 1 | 0;
            } else {
              if (!match)
                break $l$loop;
              else
                endIndex = endIndex - 1 | 0;
            }
          }
          var tmp$ret$1 = charSequenceSubSequence(this_0, startIndex, endIndex + 1 | 0);
          var tmp$ret$2 = toString_1(tmp$ret$1);
          completed = tmp_0.i9p($editor, prefix, tmp$ret$2, eagerCompletion);
        } else {
          var eager = $editor.c93(TextEditing_getInstance().d9a_1)(suffix);
          if (completion.r9n(prefix, eager)) {
            var container = $editor.s8x();
            var match_0 = completion.q9n(prefix).r(0);
            var tmp_1 = ensureNotNull(container);
            tmp_1.d9m(ValidTextEditingTrait$onAfterTextAdded$action$lambda_0(match_0, prefix, this$0, container, $editor, suffix));
          }
        }
      } else if ($editor.t96().uv() === transformPartLength && (!Completion_getInstance().x9f($editor) || (Completion_getInstance().x9f($editor) && !Completion_getInstance().w9f($editor).o9f()))) {
        // Inline function 'kotlin.text.trim' call
        var this_1 = take_1(text, transformPartLength);
        // Inline function 'kotlin.text.trim' call
        var this_2 = isCharSequence(this_1) ? this_1 : THROW_CCE();
        var startIndex_0 = 0;
        var endIndex_0 = charSequenceLength(this_2) - 1 | 0;
        var startFound_0 = false;
        $l$loop_0: while (startIndex_0 <= endIndex_0) {
          var index_0 = !startFound_0 ? startIndex_0 : endIndex_0;
          var it_0 = charSequenceGet(this_2, index_0);
          var match_1 = Char__compareTo_impl_ypi4mb(it_0, _Char___init__impl__6a9atx(32)) <= 0;
          if (!startFound_0) {
            if (!match_1)
              startFound_0 = true;
            else
              startIndex_0 = startIndex_0 + 1 | 0;
          } else {
            if (!match_1)
              break $l$loop_0;
            else
              endIndex_0 = endIndex_0 - 1 | 0;
          }
        }
        var tmp$ret$4 = charSequenceSubSequence(this_2, startIndex_0, endIndex_0 + 1 | 0);
        var prefix_0 = toString_1(tmp$ret$4);
        var suffix_0 = substring_0(text, transformPartLength);
        if (ensureNotNull(getValidator(this$0, $editor))(suffix_0)) {
          completed = Side_LEFT_getInstance().i9p($editor, suffix_0, prefix_0, eagerCompletion);
          if (completed && Completion_getInstance().x9f($editor)) {
            Completion_getInstance().w9f($editor).n9f();
          }
        }
      }
    }
    return completed;
  }
  function ValidTextEditingTrait$onKeyPressed$lambda(this$0, $cell, $event) {
    return function () {
      protoOf(TextEditingTrait).s8z.call(this$0, $cell, $event);
      return Unit_instance;
    };
  }
  function ValidTextEditingTrait$onKeyTyped$lambda(this$0, $cell, $event) {
    return function () {
      protoOf(TextEditingTrait).q8y.call(this$0, $cell, $event);
      return Unit_instance;
    };
  }
  function ValidTextEditingTrait$onPaste$lambda(this$0, $cell, $event) {
    return function () {
      protoOf(TextEditingTrait).h92.call(this$0, $cell, $event);
      return Unit_instance;
    };
  }
  function ValidTextEditingTrait$onCut$lambda(this$0, $cell, $event) {
    return function () {
      protoOf(TextEditingTrait).g92.call(this$0, $cell, $event);
      return Unit_instance;
    };
  }
  function ValidTextEditingTrait$validate$$inlined$toDisposable$1($removeError) {
    this.fa8_1 = $removeError;
  }
  protoOf(ValidTextEditingTrait$validate$$inlined$toDisposable$1).zr = function () {
    ensureNotNull(this.fa8_1._v).zr();
    return Unit_instance;
  };
  function ValidTextEditingTrait$onAfterTextAdded$lambda($editor) {
    return function () {
      $editor.i90(Companion_getInstance_182().va6_1, null);
      return Unit_instance;
    };
  }
  function ValidTextEditingTrait$onAfterTextAdded$slambda($editor, this$0, $eagerCompletion, $sideTransformationsAllowed, resultContinuation) {
    this.oa8_1 = $editor;
    this.pa8_1 = this$0;
    this.qa8_1 = $eagerCompletion;
    this.ra8_1 = $sideTransformationsAllowed;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ValidTextEditingTrait$onAfterTextAdded$slambda).ta8 = function (it, $completion) {
    var tmp = this.ua8(it, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(ValidTextEditingTrait$onAfterTextAdded$slambda).v9 = function (p1, $completion) {
    return this.ta8(p1 instanceof CompletionItems ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ValidTextEditingTrait$onAfterTextAdded$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        if (tmp === 0) {
          this.g9_1 = 1;
          var savedState = ensureNotNull(this.oa8_1.k91(Companion_getInstance_182().va6_1));
          var tmp0_elvis_lhs = this.pa8_1.va7(this.oa8_1, savedState);
          var newTextLength = tmp0_elvis_lhs == null ? this.pa8_1.wa7(this.oa8_1, savedState) : tmp0_elvis_lhs;
          if (!(newTextLength == null)) {
            onAfterTextAdded$action(this.oa8_1, this.qa8_1, this.ra8_1, this.pa8_1, this.sa8_1, newTextLength + 1 | 0);
          }
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(ValidTextEditingTrait$onAfterTextAdded$slambda).ua8 = function (it, completion) {
    var i = new ValidTextEditingTrait$onAfterTextAdded$slambda(this.oa8_1, this.pa8_1, this.qa8_1, this.ra8_1, completion);
    i.sa8_1 = it;
    return i;
  };
  function ValidTextEditingTrait$onAfterTextAdded$slambda_0($editor, this$0, $eagerCompletion, $sideTransformationsAllowed, resultContinuation) {
    var i = new ValidTextEditingTrait$onAfterTextAdded$slambda($editor, this$0, $eagerCompletion, $sideTransformationsAllowed, resultContinuation);
    var l = function (it, $completion) {
      return i.ta8(it, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function ValidTextEditingTrait$get$lambda$lambda(this$0, $cell) {
    return function () {
      validate_1(this$0, $cell);
      return Unit_instance;
    };
  }
  function ValidTextEditingTrait$get$lambda($spec, this$0, $cell) {
    return function (inputSpec) {
      var tmp;
      if (inputSpec === $spec) {
        var tmp$ret$0 = ValidTextEditingTrait$get$lambda$lambda(this$0, $cell);
        tmp = new SpecMatchResult(tmp$ret$0);
      } else {
        tmp = null;
      }
      return tmp;
    };
  }
  function ValidTextEditingTrait$get$lambda_0($spec) {
    return function (matcher) {
      return matcher($spec);
    };
  }
  function ValidTextEditingTrait$onAfterTextAdded$action$lambda($completion, $text) {
    return function () {
      $completion.l9p($text);
      return Unit_instance;
    };
  }
  function ValidTextEditingTrait$onAfterTextAdded$action$lambda_0($match, $prefix, this$0, $container, $editor, $suffix) {
    return function () {
      $match.s9m($prefix)();
      assertValid_0(this$0, $container.z92().uv());
      var propagate = $editor.c93(TextEditing_getInstance().e9a_1)($match, $suffix);
      var tmp;
      if (propagate) {
        $container.j8n(KeyEvent_init_$Create$(Key_UNKNOWN_getInstance(), charCodeAt($suffix, 0)));
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ValidTextEditingTrait() {
    Companion_getInstance_185();
    TextEditingTrait.call(this);
  }
  protoOf(ValidTextEditingTrait).o91 = function (cell) {
    protoOf(TextEditingTrait).o91.call(this, cell);
    validate_1(this, cell);
    assertFocusable(cell);
  };
  protoOf(ValidTextEditingTrait).s8z = function (cell, event) {
    var editor = cell instanceof TextCell ? cell : THROW_CCE();
    if (event.m8j(Key_ENTER_getInstance(), []) && !editor.w2m() && !isValid_0(this, editor)) {
      var completionSupplier = cell.c93(Completion_getInstance().u9d_1);
      if (!(completionSupplier === Completion_getInstance().u9d_1.b90(cell))) {
        var completionResult = completionSupplier.m9e(Companion_getInstance_164().i9e_1);
        if (get_isReady(completionResult)) {
          var completionItems = CompletionItems_init_$Create$(completionResult);
          var prefixText = editor.s96();
          if (completionItems.r9n(prefixText, true)) {
            completionItems.l9p(prefixText);
          }
        }
        event.n8i();
        return Unit_instance;
      }
    }
    var key = event.z();
    if (key.equals(Key_BACKSPACE_getInstance()) || key.equals(Key_DELETE_getInstance())) {
      handle(this, cell, ValidTextEditingTrait$onKeyPressed$lambda(this, cell, event));
      return Unit_instance;
    }
    protoOf(TextEditingTrait).s8z.call(this, cell, event);
  };
  protoOf(ValidTextEditingTrait).q8y = function (cell, event) {
    handle(this, cell, ValidTextEditingTrait$onKeyTyped$lambda(this, cell, event));
  };
  protoOf(ValidTextEditingTrait).h92 = function (cell, event) {
    handle(this, cell, ValidTextEditingTrait$onPaste$lambda(this, cell, event));
  };
  protoOf(ValidTextEditingTrait).g92 = function (cell, event) {
    handle(this, cell, ValidTextEditingTrait$onCut$lambda(this, cell, event));
  };
  protoOf(ValidTextEditingTrait).t9n = function (editor) {
    return !isValid_0(this, editor);
  };
  protoOf(ValidTextEditingTrait).x8z = function (cell, prop, event) {
    if (prop === Companion_getInstance_154().b8x_1 && !cell.c93(Companion_getInstance_185().ka6_1)) {
      validate_1(this, cell);
    }
    protoOf(TextEditingTrait).x8z.call(this, cell, prop, event);
  };
  protoOf(ValidTextEditingTrait).p9n = function (editor, typed) {
    if (protoOf(TextEditingTrait).p9n.call(this, editor, typed))
      return true;
    var afterTextAdded = onAfterTextAdded(this, editor, Companion_getInstance_164().i9e_1, true);
    if (!afterTextAdded) {
      editor.c93(ValidTextEditingTraitSpecs_getInstance().va8_1)(new Char(typed));
    }
    return afterTextAdded;
  };
  protoOf(ValidTextEditingTrait).u9n = function (editor) {
    var tmp;
    if (protoOf(TextEditingTrait).u9n.call(this, editor)) {
      tmp = true;
    } else {
      tmp = onAfterTextAdded(this, editor, Companion_getInstance_164().k9e_1, false);
    }
    return tmp;
  };
  protoOf(ValidTextEditingTrait).v9n = function (editor) {
    if (protoOf(TextEditingTrait).v9n.call(this, editor)) {
      return true;
    }
    if (editor.bp() == null)
      return true;
    if (!editor.c93(TextEditing_getInstance().c9a_1))
      return true;
    if (isValid_0(this, editor))
      return true;
    var text = editor.o8w().uv();
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(text) === 0)
      return true;
    var completionResult = editor.c93(Completion_getInstance().u9d_1).m9e(Companion_getInstance_164().i9e_1);
    if (get_isReady(completionResult)) {
      var completion = CompletionItems_init_$Create$(completionResult);
      if (completion.r9n(text, true)) {
        completion.l9p(text);
      }
    }
    return true;
  };
  protoOf(ValidTextEditingTrait).n91 = function (cell, spec) {
    // Inline function 'jetbrains.ocelot.projectional.cell.trait.specMatcher' call
    var spec_0 = TextEditing_getInstance().g9a_1;
    var tmp$ret$0 = ValidTextEditingTrait$get$lambda(spec_0, this, cell);
    var matchers = listOf_0([tmp$ret$0, specMatcherValue(Companion_getInstance_189().ma6_1, get_STATE_HANDLER_WITH_VALID())]);
    // Inline function 'jetbrains.ocelot.projectional.cell.trait.getSpecValue' call
    var tmp = asSequence_0(matchers);
    var result = firstOrNull_2(filterNotNull_0(map(tmp, ValidTextEditingTrait$get$lambda_0(spec))));
    var tmp_0;
    if (result == null) {
      tmp_0 = protoOf(TextEditingTrait).n91.call(this, cell, spec);
    } else {
      tmp_0 = result.o9n_1;
    }
    return tmp_0;
  };
  function ValidTextEditingTraitSpecs$AFTER_TYPE_TEXT_NOT_ADDED_HANDLER$lambda(_unused_var__etf5q3) {
    return Unit_instance;
  }
  function ValidTextEditingTraitSpecs() {
    ValidTextEditingTraitSpecs_instance = this;
    var tmp = this;
    tmp.va8_1 = CellTraitPropertySpec_init_$Create$('afterTypeTextNotAddedHandler', ValidTextEditingTraitSpecs$AFTER_TYPE_TEXT_NOT_ADDED_HANDLER$lambda);
  }
  var ValidTextEditingTraitSpecs_instance;
  function ValidTextEditingTraitSpecs_getInstance() {
    if (ValidTextEditingTraitSpecs_instance == null)
      new ValidTextEditingTraitSpecs();
    return ValidTextEditingTraitSpecs_instance;
  }
  function BaseDerivedCellTrait(base) {
    DerivedCellTrait.call(this);
    this.ca6_1 = base;
  }
  protoOf(BaseDerivedCellTrait).da6 = function (cell) {
    return this.ca6_1;
  };
  function CellTrait$Companion$EMPTY$1() {
    CellTrait.call(this);
  }
  function Companion_186() {
    Companion_instance_186 = this;
    var tmp = this;
    tmp.wa8_1 = new CellTrait$Companion$EMPTY$1();
    var tmp_0 = this;
    // Inline function 'kotlin.emptyArray' call
    tmp_0.xa8_1 = [];
  }
  var Companion_instance_186;
  function Companion_getInstance_186() {
    if (Companion_instance_186 == null)
      new Companion_186();
    return Companion_instance_186;
  }
  function CellTrait() {
    Companion_getInstance_186();
  }
  protoOf(CellTrait).o91 = function (cell) {
  };
  protoOf(CellTrait).c91 = function (cell) {
  };
  protoOf(CellTrait).f90 = function (cell) {
  };
  protoOf(CellTrait).g90 = function (cell, root) {
  };
  protoOf(CellTrait).x8z = function (cell, prop, event) {
  };
  protoOf(CellTrait).p91 = function (cell, event) {
  };
  protoOf(CellTrait).q91 = function (cell, event) {
  };
  protoOf(CellTrait).r91 = function (cell, event) {
  };
  protoOf(CellTrait).s91 = function (cell, event) {
  };
  protoOf(CellTrait).t91 = function (cell, event) {
  };
  protoOf(CellTrait).u91 = function (cell, event) {
  };
  protoOf(CellTrait).v91 = function (cell, event) {
  };
  protoOf(CellTrait).w91 = function (cell, event) {
  };
  protoOf(CellTrait).x91 = function (cell, event) {
  };
  protoOf(CellTrait).y91 = function (cell, event) {
  };
  protoOf(CellTrait).z91 = function (cell, event) {
  };
  protoOf(CellTrait).a92 = function (cell, event) {
  };
  protoOf(CellTrait).b92 = function (cell, event) {
  };
  protoOf(CellTrait).c92 = function (cell, event) {
  };
  protoOf(CellTrait).d92 = function (cell, event) {
  };
  protoOf(CellTrait).e92 = function (cell, event) {
  };
  protoOf(CellTrait).s8z = function (cell, event) {
  };
  protoOf(CellTrait).v8z = function (cell, event) {
  };
  protoOf(CellTrait).r8y = function (cell, event) {
  };
  protoOf(CellTrait).u8z = function (cell, event) {
  };
  protoOf(CellTrait).q8y = function (cell, event) {
  };
  protoOf(CellTrait).t8z = function (cell, event) {
  };
  protoOf(CellTrait).f92 = function (cell, event) {
  };
  protoOf(CellTrait).g92 = function (cell, event) {
  };
  protoOf(CellTrait).h92 = function (cell, event) {
  };
  protoOf(CellTrait).i92 = function (cell, event) {
  };
  protoOf(CellTrait).j92 = function (cell, event) {
  };
  protoOf(CellTrait).k92 = function (cell, event) {
  };
  protoOf(CellTrait).l92 = function (cell, event) {
  };
  protoOf(CellTrait).i8y = function (cell, spec, event) {
  };
  protoOf(CellTrait).n91 = function (cell, spec) {
    return null;
  };
  function CellTraitEventSpec(name, isBubbling) {
    isBubbling = isBubbling === VOID ? true : isBubbling;
    this.j8y_1 = name;
    this.k8y_1 = isBubbling;
  }
  protoOf(CellTraitEventSpec).toString = function () {
    return this.j8y_1;
  };
  function CellTraitPropertySpec_init_$Init$(name, defaultValue, $this) {
    CellTraitPropertySpec.call($this, name, CellTraitPropertySpec$_init_$lambda_v3qcup(defaultValue));
    return $this;
  }
  function CellTraitPropertySpec_init_$Create$(name, defaultValue) {
    return CellTraitPropertySpec_init_$Init$(name, defaultValue, objectCreate(protoOf(CellTraitPropertySpec)));
  }
  function CellTraitPropertySpec$_init_$lambda_v3qcup($defaultValue) {
    return function (it) {
      return $defaultValue;
    };
  }
  function CellTraitPropertySpec(name, defaultValueSupplier) {
    this.e93_1 = name;
    this.f93_1 = defaultValueSupplier;
  }
  protoOf(CellTraitPropertySpec).b90 = function (cell) {
    return this.f93_1(cell);
  };
  protoOf(CellTraitPropertySpec).toString = function () {
    return this.e93_1;
  };
  function valueIsSet(_this__u8e3s4, spec) {
    return !(_this__u8e3s4.c93(spec) === spec.b90(_this__u8e3s4));
  }
  function CellTraits$captureTo$rootReg$1($targetReg, $targetTrait) {
    this.ya8_1 = $targetReg;
    this.za8_1 = $targetTrait;
    CellTrait.call(this);
  }
  protoOf(CellTraits$captureTo$rootReg$1).p91 = function (cell, event) {
    protoOf(CellTrait).p91.call(this, cell, event);
    this.ya8_1._v.zr();
    this.ya8_1._v = ensureNotNull(event.y9t_1).w92(this.za8_1);
  };
  protoOf(CellTraits$captureTo$rootReg$1).q91 = function (cell, event) {
    this.ya8_1._v.zr();
    this.ya8_1._v = Companion_getInstance_29().m2l_1;
    protoOf(CellTrait).q91.call(this, cell, event);
  };
  function CellTraits$captureTo$$inlined$toDisposable$1($targetReg, $rootReg) {
    this.aa9_1 = $targetReg;
    this.ba9_1 = $rootReg;
  }
  protoOf(CellTraits$captureTo$$inlined$toDisposable$1).zr = function () {
    this.aa9_1._v.zr();
    this.ba9_1.zr();
    return Unit_instance;
  };
  function CellTraits$propWithDefaultInRoot$lambda($defaultValue, $holder) {
    return function (cell) {
      var tmp;
      if (!cell.f89()) {
        tmp = $defaultValue;
      } else {
        var root = ensureNotNull(cell.s8x()).t42();
        var tmp_0;
        if (cell === root) {
          tmp_0 = $defaultValue;
        } else {
          tmp_0 = root.c93(ensureNotNull($holder._v));
        }
        tmp = tmp_0;
      }
      return tmp;
    };
  }
  function CellTraits() {
  }
  protoOf(CellTraits).ca9 = function (root, targetTrait) {
    var targetReg = {_v: Companion_getInstance_29().m2l_1};
    if (isDescendantCellFocused(root)) {
      var container = ensureNotNull(root.s8x());
      var focusedCell = ensureNotNull(container.z92().uv());
      targetReg._v = focusedCell.w92(targetTrait);
    }
    var rootReg = root.w92(new CellTraits$captureTo$rootReg$1(targetReg, targetTrait));
    // Inline function 'jetbrains.ocelot.base.disposable.toDisposable' call
    return new CellTraits$captureTo$$inlined$toDisposable$1(targetReg, rootReg);
  };
  protoOf(CellTraits).u9f = function (name) {
    return this.v9f(name, null);
  };
  protoOf(CellTraits).v9f = function (name, defaultValue) {
    var holder = {_v: null};
    var spec = new CellTraitPropertySpec(name, CellTraits$propWithDefaultInRoot$lambda(defaultValue, holder));
    holder._v = spec;
    return holder._v;
  };
  var CellTraits_instance;
  function CellTraits_getInstance() {
    return CellTraits_instance;
  }
  function CompositeCellTrait() {
    CellTrait.call(this);
  }
  protoOf(CompositeCellTrait).o91 = function (cell) {
    // Inline function 'jetbrains.ocelot.projectional.cell.trait.CompositeCellTrait.process' call
    var indexedObject = this.s9n(cell);
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var trait = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      trait.o91(cell);
    }
    return Unit_instance;
  };
  protoOf(CompositeCellTrait).c91 = function (cell) {
    // Inline function 'jetbrains.ocelot.projectional.cell.trait.CompositeCellTrait.process' call
    var indexedObject = this.s9n(cell);
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var trait = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      trait.c91(cell);
    }
    return Unit_instance;
  };
  protoOf(CompositeCellTrait).f90 = function (cell) {
    // Inline function 'jetbrains.ocelot.projectional.cell.trait.CompositeCellTrait.process' call
    var indexedObject = this.s9n(cell);
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var trait = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      trait.f90(cell);
    }
    return Unit_instance;
  };
  protoOf(CompositeCellTrait).g90 = function (cell, root) {
    // Inline function 'jetbrains.ocelot.projectional.cell.trait.CompositeCellTrait.process' call
    var indexedObject = this.s9n(cell);
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var trait = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      trait.g90(cell, root);
    }
    return Unit_instance;
  };
  protoOf(CompositeCellTrait).x8z = function (cell, prop, event) {
    // Inline function 'jetbrains.ocelot.projectional.cell.trait.CompositeCellTrait.process' call
    var indexedObject = this.s9n(cell);
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var trait = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      trait.x8z(cell, prop, event);
    }
    return Unit_instance;
  };
  protoOf(CompositeCellTrait).p91 = function (cell, event) {
    // Inline function 'jetbrains.ocelot.projectional.cell.trait.CompositeCellTrait.process' call
    var indexedObject = this.s9n(cell);
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var trait = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      trait.p91(cell, event);
    }
    return Unit_instance;
  };
  protoOf(CompositeCellTrait).q91 = function (cell, event) {
    // Inline function 'jetbrains.ocelot.projectional.cell.trait.CompositeCellTrait.process' call
    var indexedObject = this.s9n(cell);
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var trait = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      trait.q91(cell, event);
    }
    return Unit_instance;
  };
  protoOf(CompositeCellTrait).r91 = function (cell, event) {
    // Inline function 'jetbrains.ocelot.projectional.cell.trait.CompositeCellTrait.untilConsumed' call
    var indexedObject = this.s9n(cell);
    var inductionVariable = 0;
    var last = indexedObject.length;
    $l$loop: while (inductionVariable < last) {
      var trait = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (event.l8i_1) {
        break $l$loop;
      }
      trait.r91(cell, event);
    }
    return Unit_instance;
  };
  protoOf(CompositeCellTrait).s91 = function (cell, event) {
    // Inline function 'jetbrains.ocelot.projectional.cell.trait.CompositeCellTrait.untilConsumed' call
    var indexedObject = this.s9n(cell);
    var inductionVariable = 0;
    var last = indexedObject.length;
    $l$loop: while (inductionVariable < last) {
      var trait = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (event.l8i_1) {
        break $l$loop;
      }
      trait.s91(cell, event);
    }
    return Unit_instance;
  };
  protoOf(CompositeCellTrait).t91 = function (cell, event) {
    // Inline function 'jetbrains.ocelot.projectional.cell.trait.CompositeCellTrait.untilConsumed' call
    var indexedObject = this.s9n(cell);
    var inductionVariable = 0;
    var last = indexedObject.length;
    $l$loop: while (inductionVariable < last) {
      var trait = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (event.l8i_1) {
        break $l$loop;
      }
      trait.t91(cell, event);
    }
    return Unit_instance;
  };
  protoOf(CompositeCellTrait).u91 = function (cell, event) {
    // Inline function 'jetbrains.ocelot.projectional.cell.trait.CompositeCellTrait.untilConsumed' call
    var indexedObject = this.s9n(cell);
    var inductionVariable = 0;
    var last = indexedObject.length;
    $l$loop: while (inductionVariable < last) {
      var trait = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (event.l8i_1) {
        break $l$loop;
      }
      trait.u91(cell, event);
    }
    return Unit_instance;
  };
  protoOf(CompositeCellTrait).v91 = function (cell, event) {
    // Inline function 'jetbrains.ocelot.projectional.cell.trait.CompositeCellTrait.untilConsumed' call
    var indexedObject = this.s9n(cell);
    var inductionVariable = 0;
    var last = indexedObject.length;
    $l$loop: while (inductionVariable < last) {
      var trait = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (event.l8i_1) {
        break $l$loop;
      }
      trait.v91(cell, event);
    }
    return Unit_instance;
  };
  protoOf(CompositeCellTrait).w91 = function (cell, event) {
    // Inline function 'jetbrains.ocelot.projectional.cell.trait.CompositeCellTrait.untilConsumed' call
    var indexedObject = this.s9n(cell);
    var inductionVariable = 0;
    var last = indexedObject.length;
    $l$loop: while (inductionVariable < last) {
      var trait = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (event.l8i_1) {
        break $l$loop;
      }
      trait.w91(cell, event);
    }
    return Unit_instance;
  };
  protoOf(CompositeCellTrait).x91 = function (cell, event) {
    // Inline function 'jetbrains.ocelot.projectional.cell.trait.CompositeCellTrait.untilConsumed' call
    var indexedObject = this.s9n(cell);
    var inductionVariable = 0;
    var last = indexedObject.length;
    $l$loop: while (inductionVariable < last) {
      var trait = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (event.l8i_1) {
        break $l$loop;
      }
      trait.x91(cell, event);
    }
    return Unit_instance;
  };
  protoOf(CompositeCellTrait).y91 = function (cell, event) {
    // Inline function 'jetbrains.ocelot.projectional.cell.trait.CompositeCellTrait.untilConsumed' call
    var indexedObject = this.s9n(cell);
    var inductionVariable = 0;
    var last = indexedObject.length;
    $l$loop: while (inductionVariable < last) {
      var trait = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (event.l8i_1) {
        break $l$loop;
      }
      trait.y91(cell, event);
    }
    return Unit_instance;
  };
  protoOf(CompositeCellTrait).z91 = function (cell, event) {
    // Inline function 'jetbrains.ocelot.projectional.cell.trait.CompositeCellTrait.untilConsumed' call
    var indexedObject = this.s9n(cell);
    var inductionVariable = 0;
    var last = indexedObject.length;
    $l$loop: while (inductionVariable < last) {
      var trait = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (event.l8i_1) {
        break $l$loop;
      }
      trait.z91(cell, event);
    }
    return Unit_instance;
  };
  protoOf(CompositeCellTrait).a92 = function (cell, event) {
    // Inline function 'jetbrains.ocelot.projectional.cell.trait.CompositeCellTrait.untilConsumed' call
    var indexedObject = this.s9n(cell);
    var inductionVariable = 0;
    var last = indexedObject.length;
    $l$loop: while (inductionVariable < last) {
      var trait = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (event.l8i_1) {
        break $l$loop;
      }
      trait.a92(cell, event);
    }
    return Unit_instance;
  };
  protoOf(CompositeCellTrait).b92 = function (cell, event) {
    // Inline function 'jetbrains.ocelot.projectional.cell.trait.CompositeCellTrait.untilConsumed' call
    var indexedObject = this.s9n(cell);
    var inductionVariable = 0;
    var last = indexedObject.length;
    $l$loop: while (inductionVariable < last) {
      var trait = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (event.l8i_1) {
        break $l$loop;
      }
      trait.b92(cell, event);
    }
    return Unit_instance;
  };
  protoOf(CompositeCellTrait).c92 = function (cell, event) {
    // Inline function 'jetbrains.ocelot.projectional.cell.trait.CompositeCellTrait.untilConsumed' call
    var indexedObject = this.s9n(cell);
    var inductionVariable = 0;
    var last = indexedObject.length;
    $l$loop: while (inductionVariable < last) {
      var trait = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (event.l8i_1) {
        break $l$loop;
      }
      trait.c92(cell, event);
    }
    return Unit_instance;
  };
  protoOf(CompositeCellTrait).d92 = function (cell, event) {
    // Inline function 'jetbrains.ocelot.projectional.cell.trait.CompositeCellTrait.untilConsumed' call
    var indexedObject = this.s9n(cell);
    var inductionVariable = 0;
    var last = indexedObject.length;
    $l$loop: while (inductionVariable < last) {
      var trait = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (event.l8i_1) {
        break $l$loop;
      }
      trait.d92(cell, event);
    }
    return Unit_instance;
  };
  protoOf(CompositeCellTrait).e92 = function (cell, event) {
    // Inline function 'jetbrains.ocelot.projectional.cell.trait.CompositeCellTrait.untilConsumed' call
    var indexedObject = this.s9n(cell);
    var inductionVariable = 0;
    var last = indexedObject.length;
    $l$loop: while (inductionVariable < last) {
      var trait = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (event.l8i_1) {
        break $l$loop;
      }
      trait.e92(cell, event);
    }
    return Unit_instance;
  };
  protoOf(CompositeCellTrait).s8z = function (cell, event) {
    // Inline function 'jetbrains.ocelot.projectional.cell.trait.CompositeCellTrait.untilConsumed' call
    var indexedObject = this.s9n(cell);
    var inductionVariable = 0;
    var last = indexedObject.length;
    $l$loop: while (inductionVariable < last) {
      var trait = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (event.l8i_1) {
        break $l$loop;
      }
      trait.s8z(cell, event);
    }
    return Unit_instance;
  };
  protoOf(CompositeCellTrait).v8z = function (cell, event) {
    // Inline function 'jetbrains.ocelot.projectional.cell.trait.CompositeCellTrait.untilConsumed' call
    var indexedObject = this.s9n(cell);
    var inductionVariable = 0;
    var last = indexedObject.length;
    $l$loop: while (inductionVariable < last) {
      var trait = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (event.l8i_1) {
        break $l$loop;
      }
      trait.v8z(cell, event);
    }
    return Unit_instance;
  };
  protoOf(CompositeCellTrait).r8y = function (cell, event) {
    // Inline function 'jetbrains.ocelot.projectional.cell.trait.CompositeCellTrait.untilConsumed' call
    var indexedObject = this.s9n(cell);
    var inductionVariable = 0;
    var last = indexedObject.length;
    $l$loop: while (inductionVariable < last) {
      var trait = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (event.l8i_1) {
        break $l$loop;
      }
      trait.r8y(cell, event);
    }
    return Unit_instance;
  };
  protoOf(CompositeCellTrait).u8z = function (cell, event) {
    // Inline function 'jetbrains.ocelot.projectional.cell.trait.CompositeCellTrait.untilConsumed' call
    var indexedObject = this.s9n(cell);
    var inductionVariable = 0;
    var last = indexedObject.length;
    $l$loop: while (inductionVariable < last) {
      var trait = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (event.l8i_1) {
        break $l$loop;
      }
      trait.u8z(cell, event);
    }
    return Unit_instance;
  };
  protoOf(CompositeCellTrait).q8y = function (cell, event) {
    // Inline function 'jetbrains.ocelot.projectional.cell.trait.CompositeCellTrait.untilConsumed' call
    var indexedObject = this.s9n(cell);
    var inductionVariable = 0;
    var last = indexedObject.length;
    $l$loop: while (inductionVariable < last) {
      var trait = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (event.l8i_1) {
        break $l$loop;
      }
      trait.q8y(cell, event);
    }
    return Unit_instance;
  };
  protoOf(CompositeCellTrait).t8z = function (cell, event) {
    // Inline function 'jetbrains.ocelot.projectional.cell.trait.CompositeCellTrait.untilConsumed' call
    var indexedObject = this.s9n(cell);
    var inductionVariable = 0;
    var last = indexedObject.length;
    $l$loop: while (inductionVariable < last) {
      var trait = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (event.l8i_1) {
        break $l$loop;
      }
      trait.t8z(cell, event);
    }
    return Unit_instance;
  };
  protoOf(CompositeCellTrait).f92 = function (cell, event) {
    // Inline function 'jetbrains.ocelot.projectional.cell.trait.CompositeCellTrait.untilConsumed' call
    var indexedObject = this.s9n(cell);
    var inductionVariable = 0;
    var last = indexedObject.length;
    $l$loop: while (inductionVariable < last) {
      var trait = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (event.l8i_1) {
        break $l$loop;
      }
      trait.f92(cell, event);
    }
    return Unit_instance;
  };
  protoOf(CompositeCellTrait).g92 = function (cell, event) {
    // Inline function 'jetbrains.ocelot.projectional.cell.trait.CompositeCellTrait.untilConsumed' call
    var indexedObject = this.s9n(cell);
    var inductionVariable = 0;
    var last = indexedObject.length;
    $l$loop: while (inductionVariable < last) {
      var trait = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (event.l8i_1) {
        break $l$loop;
      }
      trait.g92(cell, event);
    }
    return Unit_instance;
  };
  protoOf(CompositeCellTrait).h92 = function (cell, event) {
    // Inline function 'jetbrains.ocelot.projectional.cell.trait.CompositeCellTrait.untilConsumed' call
    var indexedObject = this.s9n(cell);
    var inductionVariable = 0;
    var last = indexedObject.length;
    $l$loop: while (inductionVariable < last) {
      var trait = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (event.l8i_1) {
        break $l$loop;
      }
      trait.h92(cell, event);
    }
    return Unit_instance;
  };
  protoOf(CompositeCellTrait).i92 = function (cell, event) {
    // Inline function 'jetbrains.ocelot.projectional.cell.trait.CompositeCellTrait.untilConsumed' call
    var indexedObject = this.s9n(cell);
    var inductionVariable = 0;
    var last = indexedObject.length;
    $l$loop: while (inductionVariable < last) {
      var trait = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (event.l8i_1) {
        break $l$loop;
      }
      trait.i92(cell, event);
    }
    return Unit_instance;
  };
  protoOf(CompositeCellTrait).j92 = function (cell, event) {
    // Inline function 'jetbrains.ocelot.projectional.cell.trait.CompositeCellTrait.untilConsumed' call
    var indexedObject = this.s9n(cell);
    var inductionVariable = 0;
    var last = indexedObject.length;
    $l$loop: while (inductionVariable < last) {
      var trait = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (event.l8i_1) {
        break $l$loop;
      }
      trait.j92(cell, event);
    }
    return Unit_instance;
  };
  protoOf(CompositeCellTrait).k92 = function (cell, event) {
    // Inline function 'jetbrains.ocelot.projectional.cell.trait.CompositeCellTrait.untilConsumed' call
    var indexedObject = this.s9n(cell);
    var inductionVariable = 0;
    var last = indexedObject.length;
    $l$loop: while (inductionVariable < last) {
      var trait = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (event.l8i_1) {
        break $l$loop;
      }
      trait.k92(cell, event);
    }
    return Unit_instance;
  };
  protoOf(CompositeCellTrait).l92 = function (cell, event) {
    // Inline function 'jetbrains.ocelot.projectional.cell.trait.CompositeCellTrait.untilConsumed' call
    var indexedObject = this.s9n(cell);
    var inductionVariable = 0;
    var last = indexedObject.length;
    $l$loop: while (inductionVariable < last) {
      var trait = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (event.l8i_1) {
        break $l$loop;
      }
      trait.l92(cell, event);
    }
    return Unit_instance;
  };
  protoOf(CompositeCellTrait).i8y = function (cell, spec, event) {
    // Inline function 'jetbrains.ocelot.projectional.cell.trait.CompositeCellTrait.untilConsumed' call
    var indexedObject = this.s9n(cell);
    var inductionVariable = 0;
    var last = indexedObject.length;
    $l$loop: while (inductionVariable < last) {
      var trait = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (event.l8i_1) {
        break $l$loop;
      }
      trait.i8y(cell, spec, event);
    }
    return Unit_instance;
  };
  protoOf(CompositeCellTrait).n91 = function (cell, spec) {
    var indexedObject = this.s9n(cell);
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var trait = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      var result = trait.n91(cell, spec);
      if (!(result == null)) {
        return result;
      }
    }
    return null;
  };
  function CompositeCellTraits$forConstant$1($base) {
    this.da9_1 = $base;
    CompositeCellTrait.call(this);
  }
  protoOf(CompositeCellTraits$forConstant$1).s9n = function (cell) {
    return this.da9_1;
  };
  function CompositeCellTraits() {
  }
  protoOf(CompositeCellTraits).ra6 = function (base) {
    return new CompositeCellTraits$forConstant$1(base);
  };
  var CompositeCellTraits_instance;
  function CompositeCellTraits_getInstance() {
    return CompositeCellTraits_instance;
  }
  function DerivedCellTrait() {
    CellTrait.call(this);
  }
  protoOf(DerivedCellTrait).o91 = function (cell) {
    return this.da6(cell).o91(cell);
  };
  protoOf(DerivedCellTrait).c91 = function (cell) {
    return this.da6(cell).c91(cell);
  };
  protoOf(DerivedCellTrait).f90 = function (cell) {
    return this.da6(cell).f90(cell);
  };
  protoOf(DerivedCellTrait).g90 = function (cell, root) {
    return this.da6(cell).g90(cell, root);
  };
  protoOf(DerivedCellTrait).x8z = function (cell, prop, event) {
    this.da6(cell).x8z(cell, prop, event);
  };
  protoOf(DerivedCellTrait).p91 = function (cell, event) {
    return this.da6(cell).p91(cell, event);
  };
  protoOf(DerivedCellTrait).q91 = function (cell, event) {
    return this.da6(cell).q91(cell, event);
  };
  protoOf(DerivedCellTrait).r91 = function (cell, event) {
    this.da6(cell).r91(cell, event);
  };
  protoOf(DerivedCellTrait).s91 = function (cell, event) {
    this.da6(cell).s91(cell, event);
  };
  protoOf(DerivedCellTrait).z91 = function (cell, event) {
    this.da6(cell).z91(cell, event);
  };
  protoOf(DerivedCellTrait).a92 = function (cell, event) {
    this.da6(cell).a92(cell, event);
  };
  protoOf(DerivedCellTrait).b92 = function (cell, event) {
    this.da6(cell).b92(cell, event);
  };
  protoOf(DerivedCellTrait).c92 = function (cell, event) {
    this.da6(cell).c92(cell, event);
  };
  protoOf(DerivedCellTrait).d92 = function (cell, event) {
    this.da6(cell).d92(cell, event);
  };
  protoOf(DerivedCellTrait).t91 = function (cell, event) {
    this.da6(cell).t91(cell, event);
  };
  protoOf(DerivedCellTrait).u91 = function (cell, event) {
    this.da6(cell).u91(cell, event);
  };
  protoOf(DerivedCellTrait).v91 = function (cell, event) {
    this.da6(cell).v91(cell, event);
  };
  protoOf(DerivedCellTrait).w91 = function (cell, event) {
    this.da6(cell).w91(cell, event);
  };
  protoOf(DerivedCellTrait).x91 = function (cell, event) {
    this.da6(cell).x91(cell, event);
  };
  protoOf(DerivedCellTrait).y91 = function (cell, event) {
    this.da6(cell).y91(cell, event);
  };
  protoOf(DerivedCellTrait).e92 = function (cell, event) {
    this.da6(cell).e92(cell, event);
  };
  protoOf(DerivedCellTrait).s8z = function (cell, event) {
    this.da6(cell).s8z(cell, event);
  };
  protoOf(DerivedCellTrait).v8z = function (cell, event) {
    this.da6(cell).v8z(cell, event);
  };
  protoOf(DerivedCellTrait).r8y = function (cell, event) {
    this.da6(cell).r8y(cell, event);
  };
  protoOf(DerivedCellTrait).u8z = function (cell, event) {
    this.da6(cell).u8z(cell, event);
  };
  protoOf(DerivedCellTrait).q8y = function (cell, event) {
    this.da6(cell).q8y(cell, event);
  };
  protoOf(DerivedCellTrait).t8z = function (cell, event) {
    this.da6(cell).t8z(cell, event);
  };
  protoOf(DerivedCellTrait).f92 = function (cell, event) {
    this.da6(cell).f92(cell, event);
  };
  protoOf(DerivedCellTrait).g92 = function (cell, event) {
    this.da6(cell).g92(cell, event);
  };
  protoOf(DerivedCellTrait).h92 = function (cell, event) {
    this.da6(cell).h92(cell, event);
  };
  protoOf(DerivedCellTrait).i92 = function (cell, event) {
    this.da6(cell).i92(cell, event);
  };
  protoOf(DerivedCellTrait).j92 = function (cell, event) {
    this.da6(cell).j92(cell, event);
  };
  protoOf(DerivedCellTrait).k92 = function (cell, event) {
    this.da6(cell).k92(cell, event);
  };
  protoOf(DerivedCellTrait).l92 = function (cell, event) {
    this.da6(cell).l92(cell, event);
  };
  protoOf(DerivedCellTrait).i8y = function (cell, spec, event) {
    this.da6(cell).i8y(cell, spec, event);
  };
  protoOf(DerivedCellTrait).n91 = function (cell, spec) {
    return this.da6(cell).n91(cell, spec);
  };
  function SpecMatchResult(value) {
    this.o9n_1 = value;
  }
  function specMatcherValue(spec, value) {
    // Inline function 'jetbrains.ocelot.projectional.cell.trait.specMatcher' call
    return specMatcherValue$lambda(spec, value);
  }
  function specMatcherValue$lambda($spec, $value) {
    return function (inputSpec) {
      var tmp;
      if (inputSpec === $spec) {
        var tmp$ret$0 = $value;
        tmp = new SpecMatchResult(tmp$ret$0);
      } else {
        tmp = null;
      }
      return tmp;
    };
  }
  function handleChildAdd_0($this, item) {
    $this.ea9(item);
    var _iterator__ex2g4s = item.o35().m();
    while (_iterator__ex2g4s.n()) {
      var child = _iterator__ex2g4s.o();
      handleChildAdd_0($this, child);
    }
  }
  function handleChildRemove_0($this, item) {
    $this.fa9(item);
    var _iterator__ex2g4s = item.o35().m();
    while (_iterator__ex2g4s.n()) {
      var child = _iterator__ex2g4s.o();
      handleChildRemove_0($this, child);
    }
  }
  function CellAttachWatcher() {
  }
  protoOf(CellAttachWatcher).ga9 = function (container) {
    handleChildAdd_0(this, container.t42());
  };
  protoOf(CellAttachWatcher).ea9 = function (cell) {
  };
  protoOf(CellAttachWatcher).fa9 = function (cell) {
  };
  protoOf(CellAttachWatcher).k93 = function (parent, change) {
    handleChildAdd_0(this, change.u2r());
  };
  protoOf(CellAttachWatcher).l93 = function (parent, change) {
    handleChildRemove_0(this, change.s2r());
  };
  protoOf(CellAttachWatcher).j93 = function (cell, prop, change) {
    if (isPopupProp(prop)) {
      var oldValue = change.s2y_1;
      if (!(oldValue == null)) {
        handleChildRemove_0(this, isInterface(oldValue, Cell) ? oldValue : THROW_CCE());
      }
      var newValue = change.t2y_1;
      if (!(newValue == null)) {
        handleChildAdd_0(this, isInterface(newValue, Cell) ? newValue : THROW_CCE());
      }
    }
  };
  function doInstall($this, container, trait, attachPredicate, detachPredicate) {
    var t = new TraitController(trait, attachPredicate, detachPredicate);
    t.ga9(container);
    return new Pair(container.i9v(t).j2l(t), t);
  }
  function TraitController$Companion$NOT_POPUP$lambda(cell) {
    return !inPopup(cell);
  }
  function isRegistered($this, cell) {
    return $this.ka9_1.r2l().t(cell);
  }
  function isProcessing($this, cell, processing) {
    return !(processing == null) && processing.t(cell);
  }
  function startAttaching($this, cell) {
    if ($this.la9_1 == null) {
      $this.la9_1 = HashSet_init_$Create$();
    } else if (ensureNotNull($this.la9_1).t(cell)) {
      return false;
    }
    ensureNotNull($this.la9_1).j(cell);
    return true;
  }
  function startDetaching($this, cell) {
    if ($this.ma9_1 == null) {
      $this.ma9_1 = HashSet_init_$Create$();
    } else if (ensureNotNull($this.ma9_1).t(cell)) {
      return false;
    }
    ensureNotNull($this.ma9_1).j(cell);
    return true;
  }
  function endAttaching($this, cell) {
    ensureNotNull($this.la9_1).h2(cell);
    if (ensureNotNull($this.la9_1).s()) {
      $this.la9_1 = null;
    }
  }
  function endDetaching($this, cell) {
    ensureNotNull($this.ma9_1).h2(cell);
    if (ensureNotNull($this.ma9_1).s()) {
      $this.ma9_1 = null;
    }
  }
  function Companion_187() {
    Companion_instance_187 = this;
    var tmp = this;
    tmp.j9z_1 = TraitController$Companion$NOT_POPUP$lambda;
  }
  protoOf(Companion_187).k9z = function (container, trait, attachPredicate, detachPredicate) {
    return doInstall(this, container, trait, attachPredicate, detachPredicate).pg_1;
  };
  var Companion_instance_187;
  function Companion_getInstance_187() {
    if (Companion_instance_187 == null)
      new Companion_187();
    return Companion_instance_187;
  }
  function TraitController(trait, attachPredicate, detachPredicate) {
    Companion_getInstance_187();
    CellAttachWatcher.call(this);
    this.ha9_1 = trait;
    this.ia9_1 = attachPredicate;
    this.ja9_1 = detachPredicate;
    this.ka9_1 = new DisposableMap();
    this.la9_1 = null;
    this.ma9_1 = null;
  }
  protoOf(TraitController).ea9 = function (cell) {
    if (isRegistered(this, cell) || !this.ia9_1(cell)) {
      return Unit_instance;
    }
    // Inline function 'kotlin.check' call
    if (!!isProcessing(this, cell, this.ma9_1)) {
      var message = toString_1(cell) + " came into 'attach' state while detaching, trait=" + toString_1(this.ha9_1);
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    if (!startAttaching(this, cell)) {
      return Unit_instance;
    }
    var disposable = cell.w92(this.ha9_1);
    endAttaching(this, cell);
    this.ka9_1.p2l(cell, disposable);
  };
  protoOf(TraitController).fa9 = function (cell) {
    this.ka9_1.q2l(cell);
  };
  protoOf(TraitController).j93 = function (cell, prop, change) {
    protoOf(CellAttachWatcher).j93.call(this, cell, prop, change);
    if (isRegistered(this, cell)) {
      if (this.ja9_1(cell)) {
        // Inline function 'kotlin.check' call
        if (!!isProcessing(this, cell, this.la9_1)) {
          var message = toString_1(cell) + " came into 'detach' state while attaching, trait=" + toString_1(this.ha9_1);
          throw IllegalStateException_init_$Create$_0(toString_1(message));
        }
        startDetaching(this, cell);
        this.fa9(cell);
        endDetaching(this, cell);
      }
    } else {
      this.ea9(cell);
    }
  };
  protoOf(TraitController).zr = function () {
    this.ka9_1.k2();
    if (!(this.la9_1 == null)) {
      ensureNotNull(this.la9_1).k2();
      this.la9_1 = null;
    }
    if (!(this.ma9_1 == null)) {
      ensureNotNull(this.ma9_1).k2();
      this.ma9_1 = null;
    }
  };
  function CellFactory() {
  }
  protoOf(CellFactory).u9g = function (target, cells) {
    addAll_0(target.q92(), cells);
    return target;
  };
  protoOf(CellFactory).na9 = function (cells) {
    var result = new HorizontalCell();
    this.u9g(result, cells.slice());
    return result;
  };
  protoOf(CellFactory).t9g = function (cells) {
    return this.oa9(false, cells.slice());
  };
  protoOf(CellFactory).oa9 = function (indent, cells) {
    var result = new VerticalCell();
    result.i98().d2x(indent);
    this.u9g(result, cells.slice());
    return result;
  };
  protoOf(CellFactory).pa9 = function (cells) {
    return this.qa9(false, cells.slice());
  };
  protoOf(CellFactory).qa9 = function (indent, cells) {
    return this.ra9(indent, 2, cells.slice());
  };
  protoOf(CellFactory).ra9 = function (indent, indentNumSpaces, cells) {
    var result = new IndentCell(indent, indentNumSpaces);
    addAll_0(result.o35(), cells);
    return result;
  };
  protoOf(CellFactory).l8v = function () {
    return new NewLineCell();
  };
  protoOf(CellFactory).sa9 = function (text, firstAllowed, lastAllowed, selectionAvailable) {
    var result = TextCell_init_$Create$_0(text);
    var tmp;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(text) === 0) {
      tmp = (firstAllowed && lastAllowed);
    } else {
      if (text.length === 1) {
        tmp = firstAllowed || lastAllowed;
      } else {
        tmp = true;
      }
    }
    var focusable = tmp;
    if (focusable) {
      result.p92().d2x(true);
      result.w92(TextEditing_getInstance().pa6(firstAllowed, lastAllowed, selectionAvailable));
    }
    return result;
  };
  protoOf(CellFactory).ta9 = function (text, firstAllowed, lastAllowed, selectionAvailable, $super) {
    firstAllowed = firstAllowed === VOID ? true : firstAllowed;
    lastAllowed = lastAllowed === VOID ? true : lastAllowed;
    selectionAvailable = selectionAvailable === VOID ? true : selectionAvailable;
    return $super === VOID ? this.sa9(text, firstAllowed, lastAllowed, selectionAvailable) : $super.sa9.call(this, text, firstAllowed, lastAllowed, selectionAvailable);
  };
  protoOf(CellFactory).ua9 = function (text) {
    // Inline function 'kotlin.apply' call
    var this_0 = this.ta9(text);
    this_0.b97().d2x(Companion_getInstance_210().x95_1);
    this_0.d97().d2x(true);
    return this_0;
  };
  protoOf(CellFactory).va9 = function (text) {
    return TextCell_init_$Create$_0(text);
  };
  protoOf(CellFactory).wa9 = function () {
    return this.va9(' ');
  };
  var CellFactory_instance;
  function CellFactory_getInstance() {
    return CellFactory_instance;
  }
  function _CellVisibleTree___init__impl__3mauq3(base) {
    return base;
  }
  function _CellVisibleTree___get_base__impl__vnz5zx($this) {
    return $this;
  }
  function CellVisibleTree__children_impl_ekqq80($this) {
    // Inline function 'kotlin.collections.filter' call
    var tmp0 = _CellVisibleTree___get_base__impl__vnz5zx($this).o35();
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList_init_$Create$();
    var _iterator__ex2g4s = tmp0.m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      if (element.m92().w2w()) {
        destination.j(element);
      }
    }
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(destination, 10));
    var _iterator__ex2g4s_0 = destination.m();
    while (_iterator__ex2g4s_0.n()) {
      var item = _iterator__ex2g4s_0.o();
      var tmp$ret$3 = new CellVisibleTree(_get_adapted__dk7bw0($this, item));
      destination_0.j(tmp$ret$3);
    }
    return destination_0;
  }
  function CellVisibleTree__nextSibling_impl_iya9os($this) {
    return nextVisibleSiblingOf($this, _CellVisibleTree___get_base__impl__vnz5zx($this));
  }
  function CellVisibleTree__nextSibling_impl_iya9os_0($this) {
    var tmp = CellVisibleTree__nextSibling_impl_iya9os($this.xa9_1);
    return tmp == null ? null : new CellVisibleTree(tmp);
  }
  function CellVisibleTree__prevSibling_impl_lvlxdg($this) {
    return prevVisibleSiblingOf($this, _CellVisibleTree___get_base__impl__vnz5zx($this));
  }
  function CellVisibleTree__prevSibling_impl_lvlxdg_0($this) {
    var tmp = CellVisibleTree__prevSibling_impl_lvlxdg($this.xa9_1);
    return tmp == null ? null : new CellVisibleTree(tmp);
  }
  function CellVisibleTree__firstChild_impl_91np0t($this) {
    var tmp0_elvis_lhs = _CellVisibleTree___get_base__impl__vnz5zx($this).y35();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var realFirst = tmp;
    if (realFirst.m92().w2w())
      return _get_adapted__dk7bw0($this, realFirst);
    return nextVisibleSiblingOf($this, realFirst);
  }
  function CellVisibleTree__firstChild_impl_91np0t_0($this) {
    var tmp = CellVisibleTree__firstChild_impl_91np0t($this.xa9_1);
    return tmp == null ? null : new CellVisibleTree(tmp);
  }
  function CellVisibleTree__lastChild_impl_13kpzp($this) {
    var tmp0_elvis_lhs = _CellVisibleTree___get_base__impl__vnz5zx($this).z35();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var realLast = tmp;
    if (realLast.m92().w2w())
      return _get_adapted__dk7bw0($this, realLast);
    return prevVisibleSiblingOf($this, realLast);
  }
  function CellVisibleTree__lastChild_impl_13kpzp_0($this) {
    var tmp = CellVisibleTree__lastChild_impl_13kpzp($this.xa9_1);
    return tmp == null ? null : new CellVisibleTree(tmp);
  }
  function nextVisibleSiblingOf($this, cell) {
    var next = cell;
    do {
      var tmp0_safe_receiver = next;
      next = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.p35();
    }
     while (!(next == null) && !next.m92().w2w());
    var tmp1_safe_receiver = next;
    return tmp1_safe_receiver == null ? null : _get_adapted__dk7bw0($this, tmp1_safe_receiver);
  }
  function prevVisibleSiblingOf($this, cell) {
    var prev = cell;
    do {
      var tmp0_safe_receiver = prev;
      prev = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.s35();
    }
     while (!(prev == null) && !prev.m92().w2w());
    var tmp1_safe_receiver = prev;
    return tmp1_safe_receiver == null ? null : _get_adapted__dk7bw0($this, tmp1_safe_receiver);
  }
  function _CellVisibleTree___get_parent__impl__cp5b38($this) {
    var tmp0_safe_receiver = _CellVisibleTree___get_base__impl__vnz5zx($this).bp();
    return tmp0_safe_receiver == null ? null : _get_adapted__dk7bw0($this, tmp0_safe_receiver);
  }
  function CellVisibleTree___get_parent__impl_rdwb1s($this) {
    var tmp = _CellVisibleTree___get_parent__impl__cp5b38($this.xa9_1);
    return tmp == null ? null : new CellVisibleTree(tmp);
  }
  function _get_adapted__dk7bw0($this, _this__u8e3s4) {
    return _CellVisibleTree___init__impl__3mauq3(_this__u8e3s4);
  }
  function CellVisibleTree__toString_impl_pq1dyr($this) {
    return 'CellVisibleTree(base=' + toString_1($this) + ')';
  }
  function CellVisibleTree__hashCode_impl_3yvh5w($this) {
    return hashCode($this);
  }
  function CellVisibleTree__equals_impl_zcmdj4($this, other) {
    if (!(other instanceof CellVisibleTree))
      return false;
    var tmp0_other_with_cast = other.xa9_1;
    if (!equals($this, tmp0_other_with_cast))
      return false;
    return true;
  }
  function CellVisibleTree(base) {
    this.xa9_1 = base;
  }
  protoOf(CellVisibleTree).o35 = function () {
    return CellVisibleTree__children_impl_ekqq80(this.xa9_1);
  };
  protoOf(CellVisibleTree).ya9 = function () {
    return CellVisibleTree__nextSibling_impl_iya9os(this.xa9_1);
  };
  protoOf(CellVisibleTree).p35 = function () {
    return CellVisibleTree__nextSibling_impl_iya9os_0(this);
  };
  protoOf(CellVisibleTree).za9 = function () {
    return CellVisibleTree__prevSibling_impl_lvlxdg(this.xa9_1);
  };
  protoOf(CellVisibleTree).s35 = function () {
    return CellVisibleTree__prevSibling_impl_lvlxdg_0(this);
  };
  protoOf(CellVisibleTree).aaa = function () {
    return CellVisibleTree__firstChild_impl_91np0t(this.xa9_1);
  };
  protoOf(CellVisibleTree).y35 = function () {
    return CellVisibleTree__firstChild_impl_91np0t_0(this);
  };
  protoOf(CellVisibleTree).baa = function () {
    return CellVisibleTree__lastChild_impl_13kpzp(this.xa9_1);
  };
  protoOf(CellVisibleTree).z35 = function () {
    return CellVisibleTree__lastChild_impl_13kpzp_0(this);
  };
  protoOf(CellVisibleTree).caa = function () {
    return _CellVisibleTree___get_parent__impl__cp5b38(this.xa9_1);
  };
  protoOf(CellVisibleTree).bp = function () {
    return CellVisibleTree___get_parent__impl_rdwb1s(this);
  };
  protoOf(CellVisibleTree).toString = function () {
    return CellVisibleTree__toString_impl_pq1dyr(this.xa9_1);
  };
  protoOf(CellVisibleTree).hashCode = function () {
    return CellVisibleTree__hashCode_impl_3yvh5w(this.xa9_1);
  };
  protoOf(CellVisibleTree).equals = function (other) {
    return CellVisibleTree__equals_impl_zcmdj4(this.xa9_1, other);
  };
  function get_visibleTree(_this__u8e3s4) {
    var tmp0 = ancestorsFrom(_this__u8e3s4);
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.sequences.all' call
      var _iterator__ex2g4s = tmp0.m();
      while (_iterator__ex2g4s.n()) {
        var element = _iterator__ex2g4s.o();
        if (!element.m92().w2w()) {
          tmp$ret$1 = false;
          break $l$block;
        }
      }
      tmp$ret$1 = true;
    }
    // Inline function 'kotlin.require' call
    if (!tmp$ret$1) {
      var message = 'Base cell must be visible';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    return _CellVisibleTree___init__impl__3mauq3(_this__u8e3s4);
  }
  function Cells() {
    Cells_instance = this;
    this.f9t_1 = new CellTraitEventSpec('userNavigation');
    this.g9t_1 = new CellTraitEventSpec('becameEmpty', false);
    this.h9t_1 = CellTraitPropertySpec_init_$Create$('nonChildNodeCell', false);
    this.i9t_1 = CellTraitPropertySpec_init_$Create$('cellAvoidedFromViewState', false);
  }
  protoOf(Cells).daa = function (cell) {
    var tmp1_elvis_lhs = cell == null ? null : cell.q90();
    return tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
  };
  protoOf(Cells).u93 = function (current, loc) {
    var isIndent = current instanceof IndentCell;
    if (!isIndent && !get_bounds(current).l8c(loc))
      return null;
    if (current instanceof NewLineCell)
      return null;
    var _iterator__ex2g4s = current.o35().m();
    $l$loop: while (_iterator__ex2g4s.n()) {
      var child = _iterator__ex2g4s.o();
      if (!child.m92().w2w())
        continue $l$loop;
      var result = this.u93(child, loc);
      if (!(result == null)) {
        return result;
      }
    }
    var tmp;
    if (!isIndent && get_bounds(current).l8c(loc)) {
      tmp = current;
    } else {
      tmp = null;
    }
    return tmp;
  };
  protoOf(Cells).eaa = function (current, loc, condition) {
    if (!current.m92().w2w()) {
      return null;
    }
    var bounds = get_bounds(current);
    if (loc.e8c_1 < bounds.b8c_1.e8c_1 || loc.e8c_1 > (bounds.b8c_1.e8c_1 + bounds.c8c_1.e8c_1 | 0)) {
      return null;
    }
    var result = null;
    var distance = 2147483647;
    var _iterator__ex2g4s = current.o35().m();
    $l$loop_0: while (_iterator__ex2g4s.n()) {
      var child = _iterator__ex2g4s.o();
      if (!child.m92().w2w())
        continue $l$loop_0;
      var tmp0_elvis_lhs = this.eaa(child, loc, condition);
      var tmp;
      if (tmp0_elvis_lhs == null) {
        continue $l$loop_0;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var closest = tmp;
      var newDistance = numberToInt(get_bounds(closest).s8c(loc));
      if (newDistance < distance) {
        result = closest;
        distance = newDistance;
      }
    }
    var tmp_0;
    if (result == null && condition(current)) {
      tmp_0 = current;
    } else {
      tmp_0 = result;
    }
    return tmp_0;
  };
  var Cells_instance;
  function Cells_getInstance() {
    if (Cells_instance == null)
      new Cells();
    return Cells_instance;
  }
  function whenAttached(_this__u8e3s4, action) {
    var tmp;
    if (_this__u8e3s4.f89()) {
      action();
      tmp = Companion_getInstance_29().m2l_1;
    } else {
      var disposable = {_v: Companion_getInstance_29().m2l_1};
      var tmp_0 = _this__u8e3s4.x92();
      var disposableForHandler = tmp_0.z2r(whenAttached$lambda(disposable, action));
      disposable._v = disposableForHandler;
      var tmp0_toDisposable_this = disposable._v;
      // Inline function 'jetbrains.ocelot.base.disposable.toDisposable' call
      tmp = new whenAttached$$inlined$toDisposable$1(tmp0_toDisposable_this);
    }
    return tmp;
  }
  function firstVisibleLeaf(_this__u8e3s4) {
    if (isInvisible(_this__u8e3s4))
      return null;
    var _iterator__ex2g4s = _this__u8e3s4.o35().m();
    while (_iterator__ex2g4s.n()) {
      var childCell = _iterator__ex2g4s.o();
      var firstVisible = firstVisibleLeaf(childCell);
      if (!(firstVisible == null)) {
        return firstVisible;
      }
    }
    var tmp;
    if (_this__u8e3s4 instanceof IndentCell) {
      tmp = null;
    } else {
      tmp = _this__u8e3s4;
    }
    return tmp;
  }
  function lastVisibleLeaf(_this__u8e3s4) {
    if (isInvisible(_this__u8e3s4))
      return null;
    var _iterator__ex2g4s = reversed(_this__u8e3s4.o35()).m();
    while (_iterator__ex2g4s.n()) {
      var childCell = _iterator__ex2g4s.o();
      var lastVisible = lastVisibleLeaf(childCell);
      if (!(lastVisible == null)) {
        return lastVisible;
      }
    }
    var tmp;
    if (_this__u8e3s4 instanceof IndentCell) {
      tmp = null;
    } else {
      tmp = _this__u8e3s4;
    }
    return tmp;
  }
  function prevVisibleLeaf_0(_this__u8e3s4, within) {
    var tmp = Composites_instance.b36(new CellVisibleTree(get_visibleTree(_this__u8e3s4)), new CellVisibleTree(get_visibleTree(within)));
    var tmp0_safe_receiver = tmp == null ? null : tmp.xa9_1;
    var tmp_0;
    var tmp_1 = tmp0_safe_receiver;
    if ((tmp_1 == null ? null : new CellVisibleTree(tmp_1)) == null) {
      tmp_0 = null;
    } else {
      tmp_0 = _CellVisibleTree___get_base__impl__vnz5zx(tmp0_safe_receiver);
    }
    return tmp_0;
  }
  function nextVisibleLeaf_0(_this__u8e3s4, within) {
    var tmp = Composites_instance.a36(new CellVisibleTree(get_visibleTree(_this__u8e3s4)), new CellVisibleTree(get_visibleTree(within)));
    var tmp0_safe_receiver = tmp == null ? null : tmp.xa9_1;
    var tmp_0;
    var tmp_1 = tmp0_safe_receiver;
    if ((tmp_1 == null ? null : new CellVisibleTree(tmp_1)) == null) {
      tmp_0 = null;
    } else {
      tmp_0 = _CellVisibleTree___get_base__impl__vnz5zx(tmp0_safe_receiver);
    }
    return tmp_0;
  }
  function prevVisibleLeaves(_this__u8e3s4) {
    var tmp = Composites_instance.d36(new CellVisibleTree(get_visibleTree(_this__u8e3s4)));
    return map(tmp, prevVisibleLeaves$lambda);
  }
  function isInvisible(_this__u8e3s4) {
    var tmp;
    if (!_this__u8e3s4.m92().uv()) {
      tmp = true;
    } else {
      tmp = _this__u8e3s4 instanceof NewLineCell;
    }
    return tmp;
  }
  function whenAttached$lambda($disposable, $action) {
    return function (event) {
      var container = event.t2y_1;
      var tmp;
      if (!(container == null)) {
        $disposable._v.zr();
        $disposable._v = Companion_getInstance_29().m2l_1;
        tmp = $action();
      }
      return Unit_instance;
    };
  }
  function whenAttached$$inlined$toDisposable$1($tmp0_toDisposable_this) {
    this.faa_1 = $tmp0_toDisposable_this;
  }
  protoOf(whenAttached$$inlined$toDisposable$1).zr = function () {
    this.faa_1.zr();
    return Unit_instance;
  };
  function prevVisibleLeaves$lambda(it) {
    return _CellVisibleTree___get_base__impl__vnz5zx(it.xa9_1);
  }
  function CellLists$separated$$inlined$separated$1($list, $separator) {
    this.iaa_1 = $separator;
    SeparatedCellList.call(this, $list);
  }
  protoOf(CellLists$separated$$inlined$separated$1).jaa = function (left, right) {
    return TextCell_init_$Create$_0(this.iaa_1);
  };
  protoOf(CellLists$separated$$inlined$separated$1).kaa = function (left, right) {
    var tmp = (!(left == null) ? isInterface(left, Cell) : false) ? left : THROW_CCE();
    return this.jaa(tmp, (!(right == null) ? isInterface(right, Cell) : false) ? right : THROW_CCE());
  };
  function CellLists$newLineSeparated$$inlined$separated$1($list) {
    SeparatedCellList.call(this, $list);
  }
  protoOf(CellLists$newLineSeparated$$inlined$separated$1).jaa = function (left, right) {
    return CellFactory_instance.l8v();
  };
  protoOf(CellLists$newLineSeparated$$inlined$separated$1).kaa = function (left, right) {
    var tmp = (!(left == null) ? isInterface(left, Cell) : false) ? left : THROW_CCE();
    return this.jaa(tmp, (!(right == null) ? isInterface(right, Cell) : false) ? right : THROW_CCE());
  };
  function CellLists$verticallySpaced$$inlined$separated$1($list, $linesCount) {
    this.raa_1 = $linesCount;
    SeparatedCellList.call(this, $list);
  }
  protoOf(CellLists$verticallySpaced$$inlined$separated$1).jaa = function (left, right) {
    // Inline function 'kotlin.with' call
    var indent = CellFactory_instance.pa9([]);
    // Inline function 'kotlin.repeat' call
    var times = this.raa_1;
    var inductionVariable = 0;
    if (inductionVariable < times)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        CellFactory_instance.u9g(indent, [CellFactory_instance.l8v(), CellFactory_instance.va9('')]);
      }
       while (inductionVariable < times);
    CellFactory_instance.u9g(indent, [CellFactory_instance.l8v()]);
    return indent;
  };
  protoOf(CellLists$verticallySpaced$$inlined$separated$1).kaa = function (left, right) {
    var tmp = (!(left == null) ? isInterface(left, Cell) : false) ? left : THROW_CCE();
    return this.jaa(tmp, (!(right == null) ? isInterface(right, Cell) : false) ? right : THROW_CCE());
  };
  function CellLists() {
  }
  protoOf(CellLists).saa = function (list, separator) {
    // Inline function 'jetbrains.ocelot.projectional.cell.util.cellLists.CellLists.separated' call
    return new CellLists$separated$$inlined$separated$1(list, separator);
  };
  protoOf(CellLists).taa = function (list) {
    // Inline function 'jetbrains.ocelot.projectional.cell.util.cellLists.CellLists.separated' call
    return new CellLists$newLineSeparated$$inlined$separated$1(list);
  };
  protoOf(CellLists).uaa = function (list, linesCount) {
    // Inline function 'kotlin.check' call
    if (!(linesCount > 0)) {
      var message = 'Lines count for vertical spacing must be positive';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    // Inline function 'jetbrains.ocelot.projectional.cell.util.cellLists.CellLists.separated' call
    return new CellLists$verticallySpaced$$inlined$separated$1(list, linesCount);
  };
  var CellLists_instance;
  function CellLists_getInstance() {
    return CellLists_instance;
  }
  function SeparatedCellList(baseList) {
    SeparatedList.call(this, baseList);
  }
  function SeparatedList(baseList) {
    AbstractMutableList.call(this);
    this.maa_1 = baseList;
    // Inline function 'kotlin.require' call
    if (!this.maa_1.s()) {
      var message = 'Cannot instantiate a separated list for a non-empty base list';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
  }
  protoOf(SeparatedList).p = function () {
    return (this.maa_1.p() + 1 | 0) / 2 | 0;
  };
  protoOf(SeparatedList).yg = function (index, element) {
    var result = this.n2(index);
    this.zg(index, element);
    return result;
  };
  protoOf(SeparatedList).l2 = function (index, element) {
    return this.yg(index, (element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  protoOf(SeparatedList).r = function (index) {
    return this.maa_1.r(imul(index, 2));
  };
  protoOf(SeparatedList).zg = function (index, element) {
    if (index === 0) {
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!this.maa_1.s()) {
        this.maa_1.m2(0, this.kaa(element, this.r(0)));
      }
      this.maa_1.m2(0, element);
    } else {
      var startIndex = imul(index, 2) - 1 | 0;
      this.maa_1.m2(startIndex, this.kaa(this.r(index - 1 | 0), element));
      this.maa_1.m2(startIndex + 1 | 0, element);
      if ((index + 1 | 0) < this.p()) {
        this.maa_1.l2(startIndex + 2 | 0, this.kaa(element, this.r(index + 1 | 0)));
      }
    }
  };
  protoOf(SeparatedList).m2 = function (index, element) {
    return this.zg(index, (element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  protoOf(SeparatedList).n2 = function (index) {
    var result;
    if (index === 0) {
      result = this.maa_1.n2(0);
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!this.s()) {
        this.maa_1.n2(0);
      }
    } else {
      var startIndex = imul(index, 2) - 1 | 0;
      this.maa_1.n2(startIndex);
      result = this.maa_1.n2(startIndex);
      if (this.p() > index) {
        this.maa_1.l2(startIndex, this.kaa(this.r(index - 1 | 0), this.r(index)));
      }
    }
    return result;
  };
  var CellStateDifference_EQUAL_instance;
  var CellStateDifference_NAVIGATION_instance;
  var CellStateDifference_EDIT_instance;
  function Companion_188() {
  }
  protoOf(Companion_188).vaa = function (difference1, difference2) {
    return difference1.x2_1 > difference2.x2_1 ? difference1 : difference2;
  };
  var Companion_instance_188;
  function Companion_getInstance_188() {
    return Companion_instance_188;
  }
  var CellStateDifference_entriesInitialized;
  function CellStateDifference_initEntries() {
    if (CellStateDifference_entriesInitialized)
      return Unit_instance;
    CellStateDifference_entriesInitialized = true;
    CellStateDifference_EQUAL_instance = new CellStateDifference('EQUAL', 0);
    CellStateDifference_NAVIGATION_instance = new CellStateDifference('NAVIGATION', 1);
    CellStateDifference_EDIT_instance = new CellStateDifference('EDIT', 2);
  }
  function CellStateDifference(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function CellStateDifference_EQUAL_getInstance() {
    CellStateDifference_initEntries();
    return CellStateDifference_EQUAL_instance;
  }
  function CellStateDifference_NAVIGATION_getInstance() {
    CellStateDifference_initEntries();
    return CellStateDifference_NAVIGATION_instance;
  }
  function CellStateDifference_EDIT_getInstance() {
    CellStateDifference_initEntries();
    return CellStateDifference_EDIT_instance;
  }
  function Companion_189() {
    Companion_instance_189 = this;
    this.ma6_1 = CellTraitPropertySpec_init_$Create$('cellStateHandler', null);
  }
  var Companion_instance_189;
  function Companion_getInstance_189() {
    if (Companion_instance_189 == null)
      new Companion_189();
    return Companion_instance_189;
  }
  function CellStateHandler() {
  }
  function get_stateHandler(_this__u8e3s4) {
    var tmp = _this__u8e3s4.c93(Companion_getInstance_189().ma6_1);
    return (!(tmp == null) ? isInterface(tmp, CellStateHandler) : false) ? tmp : THROW_CCE();
  }
  function Companion_190() {
    Companion_instance_190 = this;
    this.waa_1 = new CellTraitEventSpec('derivedVisibilityEvent', false);
  }
  var Companion_instance_190;
  function Companion_getInstance_190() {
    if (Companion_instance_190 == null)
      new Companion_190();
    return Companion_instance_190;
  }
  function DerivedVisibilityEvent(visible) {
    Companion_getInstance_190();
    Event_0.call(this);
    this.zaa_1 = visible;
  }
  function disambiguateIfNeeded($this, cell) {
    if ($this.bab_1.cab($this.aab_1, cell)) {
      addDisambiguationCell($this.bab_1, $this.aab_1);
    }
  }
  function DisambiguationCellSupport$DisambiguationCellTrait$get$lambda($spec) {
    return function (matcher) {
      return matcher($spec);
    };
  }
  function DisambiguationCellSupport$Companion$invoke$1($conflict) {
    this.dab_1 = $conflict;
    DisambiguationCellSupport.call(this);
  }
  protoOf(DisambiguationCellSupport$Companion$invoke$1).cab = function (bigCell, outermostLeaf) {
    return this.dab_1(bigCell, outermostLeaf);
  };
  function addDisambiguationCell($this, bigCell) {
    // Inline function 'kotlin.also' call
    var this_0 = new DisambiguationCell($this, bigCell);
    bigCell.i90(Companion_getInstance_191().eab_1, this_0);
    var tmp0_safe_receiver = bigCell.s8x();
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.m93();
    if (tmp1_safe_receiver == null)
      null;
    else {
      var tmp = DisambiguationCellSupport$addDisambiguationCell$lambda(bigCell, this_0);
      tmp1_safe_receiver.u39(new sam$jetbrains_ocelot_base_edt_EdtTask$0_9(tmp));
    }
  }
  function removeDisambiguationCell($this, bigCell) {
    var tmp0_safe_receiver = bigCell.k91(Companion_getInstance_191().eab_1);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      bigCell.i90(Companion_getInstance_191().eab_1, null);
      var tmp0_safe_receiver_0 = tmp0_safe_receiver.s8x();
      var tmp1_safe_receiver = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.m93();
      var tmp;
      if (tmp1_safe_receiver == null) {
        tmp = null;
      } else {
        var tmp_0 = DisambiguationCellSupport$removeDisambiguationCell$lambda(tmp0_safe_receiver);
        tmp1_safe_receiver.u39(new sam$jetbrains_ocelot_base_edt_EdtTask$0_10(tmp_0));
        tmp = Unit_instance;
      }
    }
  }
  function DisambiguationCell($outer, bigCell) {
    this.oab_1 = $outer;
    HorizontalCell.call(this);
    // Inline function 'kotlin.apply' call
    var this_0 = CellFactory_instance.wa9();
    this_0.g93(LeafCellTrackingTrait_getInstance().pab_1, true);
    var space = this_0;
    var tmp = this;
    // Inline function 'kotlin.apply' call
    var this_1 = CellFactory_instance.ta9(' ', VOID, false);
    this_1.p92().f2x(true);
    get_background(this_1).f2x(Companion_getInstance_210().t95_1);
    this_1.w92(new DisambiguationCellTrait(this.oab_1, bigCell));
    tmp.nab_1 = this_1;
    this.q92().j(space);
    this.q92().j(this.nab_1);
  }
  function MyFocusListener($outer, bigCell) {
    this.bab_1 = $outer;
    OutermostLeafCellFocusListener.call(this);
    this.aab_1 = bigCell;
  }
  protoOf(MyFocusListener).p91 = function (cell, event) {
    var tmp;
    if (!(event.x9t_1 == null)) {
      var tmp0_safe_receiver = this.aab_1.k91(Companion_getInstance_191().eab_1);
      tmp = event.x9t_1 === (tmp0_safe_receiver == null ? null : tmp0_safe_receiver.nab_1);
    } else {
      tmp = false;
    }
    if (tmp)
      return Unit_instance;
    disambiguateIfNeeded(this, cell);
  };
  protoOf(MyFocusListener).q91 = function (cell, event) {
    var tmp;
    if (!(event.y9t_1 == null)) {
      var tmp0_safe_receiver = this.aab_1.k91(Companion_getInstance_191().eab_1);
      tmp = event.y9t_1 === (tmp0_safe_receiver == null ? null : tmp0_safe_receiver.nab_1);
    } else {
      tmp = false;
    }
    if (tmp)
      return Unit_instance;
    removeDisambiguationCell(this.bab_1, this.aab_1);
  };
  protoOf(MyFocusListener).qab = function (cell, event) {
    disambiguateIfNeeded(this, cell);
  };
  protoOf(MyFocusListener).rab = function (cell, event) {
    removeDisambiguationCell(this.bab_1, this.aab_1);
  };
  function DisambiguationCellTrait($outer, bigCell) {
    this.uab_1 = $outer;
    CellTrait.call(this);
    this.sab_1 = bigCell;
    this.tab_1 = listOf_0([specMatcherValue(LeafCellTrackingTrait_getInstance().pab_1, true), specMatcherValue(Cells_getInstance().i9t_1, true)]);
  }
  protoOf(DisambiguationCellTrait).n91 = function (cell, spec) {
    // Inline function 'jetbrains.ocelot.projectional.cell.trait.getSpecValue' call
    var specMatchers = this.tab_1;
    var tmp = asSequence_0(specMatchers);
    var result = firstOrNull_2(filterNotNull_0(map(tmp, DisambiguationCellSupport$DisambiguationCellTrait$get$lambda(spec))));
    var tmp_0;
    if (result == null) {
      tmp_0 = protoOf(CellTrait).n91.call(this, cell, spec);
    } else {
      tmp_0 = result.o9n_1;
    }
    return tmp_0;
  };
  protoOf(DisambiguationCellTrait).q91 = function (cell, event) {
    if (equals(event.y9t_1, this.sab_1.k91(Companion_getInstance_193().wab_1)))
      return Unit_instance;
    removeDisambiguationCell(this.uab_1, this.sab_1);
  };
  function Companion_191() {
    Companion_instance_191 = this;
    this.eab_1 = CellPropertySpec_init_$Create$('disambiguationCell', null);
  }
  protoOf(Companion_191).zab = function (conflict) {
    return new DisambiguationCellSupport$Companion$invoke$1(conflict);
  };
  var Companion_instance_191;
  function Companion_getInstance_191() {
    if (Companion_instance_191 == null)
      new Companion_191();
    return Companion_instance_191;
  }
  function sam$jetbrains_ocelot_base_edt_EdtTask$0_9(function_0) {
    this.aac_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_9).au = function () {
    return this.aac_1();
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_9).f3 = function () {
    return this.aac_1;
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_9).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, EdtTask) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_9).hashCode = function () {
    return hashCode(this.f3());
  };
  function sam$jetbrains_ocelot_base_edt_EdtTask$0_10(function_0) {
    this.bac_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_10).au = function () {
    return this.bac_1();
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_10).f3 = function () {
    return this.bac_1;
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_10).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, EdtTask) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_10).hashCode = function () {
    return hashCode(this.f3());
  };
  function DisambiguationCellSupport$addDisambiguationCell$lambda($bigCell, $it) {
    return function () {
      $bigCell.q92().j($it);
      return Unit_instance;
    };
  }
  function DisambiguationCellSupport$removeDisambiguationCell$lambda($it) {
    return function () {
      var tmp;
      if (!($it.bp() == null)) {
        $it.r3p();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function DisambiguationCellSupport() {
    Companion_getInstance_191();
    CellTrait.call(this);
  }
  protoOf(DisambiguationCellSupport).n91 = function (cell, spec) {
    return spec === Companion_getInstance_192().eac_1 ? new MyFocusListener(this, cell) : null;
  };
  function notify($this, cell, visible) {
    cell.u92(new DerivedVisibilityEvent(visible), Companion_getInstance_190().waa_1);
    // Inline function 'kotlin.collections.filter' call
    var tmp0 = cell.o35();
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList_init_$Create$();
    var _iterator__ex2g4s = tmp0.m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      if (element.m92().w2w()) {
        destination.j(element);
      }
    }
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s_0 = destination.m();
    while (_iterator__ex2g4s_0.n()) {
      var element_0 = _iterator__ex2g4s_0.o();
      notify(EffectiveVisibilityTrackingTrait_getInstance(), element_0, visible);
    }
  }
  function EffectiveVisibilityTrackingTrait() {
    EffectiveVisibilityTrackingTrait_instance = this;
    CellTrait.call(this);
  }
  protoOf(EffectiveVisibilityTrackingTrait).x8z = function (cell, prop, event) {
    if (prop === get_VISIBLE()) {
      if (!(event instanceof PropertyChangeEvent))
        THROW_CCE();
      notify(this, cell, event.t2y_1);
    }
  };
  var EffectiveVisibilityTrackingTrait_instance;
  function EffectiveVisibilityTrackingTrait_getInstance() {
    if (EffectiveVisibilityTrackingTrait_instance == null)
      new EffectiveVisibilityTrackingTrait();
    return EffectiveVisibilityTrackingTrait_instance;
  }
  function LastCaretPositionSupport$ExtraCellTrait$get$lambda($spec) {
    return function (matcher) {
      return matcher($spec);
    };
  }
  function schedule_0($this, _this__u8e3s4, code) {
    if (!(_this__u8e3s4 == null)) {
      _this__u8e3s4.m93().u39(new sam$jetbrains_ocelot_base_edt_EdtTask$0_11(code));
    } else
      code();
  }
  function ExtraCell(bigCell) {
    TextCell_init_$Init$(this);
    this.w92(new ExtraCellTrait(bigCell));
    this.p92().f2x(true);
  }
  function ExtraCellTrait(bigCell) {
    CompositeCellTrait.call(this);
    this.fac_1 = new FocusTrait(bigCell);
    this.gac_1 = listOf_0([specMatcherValue(LeafCellTrackingTrait_getInstance().pab_1, true), specMatcherValue(Cells_getInstance().i9t_1, true)]);
  }
  protoOf(ExtraCellTrait).n91 = function (cell, spec) {
    // Inline function 'jetbrains.ocelot.projectional.cell.trait.getSpecValue' call
    var specMatchers = this.gac_1;
    var tmp = asSequence_0(specMatchers);
    var result = firstOrNull_2(filterNotNull_0(map(tmp, LastCaretPositionSupport$ExtraCellTrait$get$lambda(spec))));
    var tmp_0;
    if (result == null) {
      tmp_0 = protoOf(CompositeCellTrait).n91.call(this, cell, spec);
    } else {
      tmp_0 = result.o9n_1;
    }
    return tmp_0;
  };
  protoOf(ExtraCellTrait).s9n = function (cell) {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [TextEditing_getInstance().na6(), this.fac_1];
  };
  function FocusTrait(bigCell) {
    CellTrait.call(this);
    this.hac_1 = bigCell;
  }
  protoOf(FocusTrait).p91 = function (cell, event) {
    this.hac_1.c93(Companion_getInstance_192().eac_1).p91(cell, event);
  };
  protoOf(FocusTrait).q91 = function (cell, event) {
    this.hac_1.c93(Companion_getInstance_192().eac_1).q91(cell, event);
  };
  function sam$jetbrains_ocelot_base_edt_EdtTask$0_11(function_0) {
    this.iac_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_11).au = function () {
    return this.iac_1();
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_11).f3 = function () {
    return this.iac_1;
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_11).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, EdtTask) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_11).hashCode = function () {
    return hashCode(this.f3());
  };
  function onPropertyChanged$enclosing(_this__u8e3s4, $cell) {
    return _this__u8e3s4 == null ? $cell : ensureNotNull(_this__u8e3s4.bp());
  }
  function LastCaretPositionSupport$onPropertyChanged$$inlined$toDisposable$1($extraCell) {
    this.jac_1 = $extraCell;
  }
  protoOf(LastCaretPositionSupport$onPropertyChanged$$inlined$toDisposable$1).zr = function () {
    if (!(this.jac_1.bp() == null)) {
      this.jac_1.r3p();
    }
    return Unit_instance;
  };
  function LastCaretPositionSupport$onPropertyChanged$lambda($cleanUp, $reallyLastCell, $lastCell, $cell) {
    return function () {
      $cleanUp.zr();
      var tmp;
      if ($reallyLastCell instanceof ExtraCell) {
        onPropertyChanged$enclosing($lastCell, $cell).q92().j($reallyLastCell);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function LastCaretPositionSupport() {
    LastCaretPositionSupport_instance = this;
    CompositeCellTrait.call(this);
    this.kac_1 = CellPropertySpec_init_$Create$('extraCaretPositionCleanup', Companion_getInstance_29().m2l_1);
  }
  protoOf(LastCaretPositionSupport).s9n = function (cell) {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [OutermostLeafTrackers_getInstance().mac_1];
  };
  protoOf(LastCaretPositionSupport).x8z = function (cell, prop, event) {
    if (!(prop === Companion_getInstance_193().wab_1)) {
      protoOf(CompositeCellTrait).x8z.call(this, cell, prop, event);
      return Unit_instance;
    }
    if (!(event instanceof PropertyChangeEvent))
      THROW_CCE();
    var previousLastCell = event.s2y_1;
    var lastCell = event.t2y_1;
    if (!(previousLastCell == null) && previousLastCell.y92().w2w()) {
      cell.c93(Companion_getInstance_192().eac_1).rab(previousLastCell, event);
    }
    if (!(lastCell == null) && lastCell.y92().w2w()) {
      cell.c93(Companion_getInstance_192().eac_1).qab(lastCell, event);
    }
    var cleanUp = cell.k91(this.kac_1);
    var tmp;
    var tmp1_safe_receiver = lastCell == null ? null : lastCell.p92();
    if ((tmp1_safe_receiver == null ? null : tmp1_safe_receiver.uv()) === true) {
      cell.i90(this.kac_1, lastCell.w92(new FocusTrait(cell)));
      tmp = lastCell;
    } else {
      var extraCell = new ExtraCell(cell);
      // Inline function 'jetbrains.ocelot.base.disposable.toDisposable' call
      var tmp$ret$0 = new LastCaretPositionSupport$onPropertyChanged$$inlined$toDisposable$1(extraCell);
      cell.i90(this.kac_1, tmp$ret$0);
      tmp = extraCell;
    }
    var reallyLastCell = tmp;
    var tmp_0 = cell.s8x();
    schedule_0(this, tmp_0, LastCaretPositionSupport$onPropertyChanged$lambda(cleanUp, reallyLastCell, lastCell, cell));
  };
  var LastCaretPositionSupport_instance;
  function LastCaretPositionSupport_getInstance() {
    if (LastCaretPositionSupport_instance == null)
      new LastCaretPositionSupport();
    return LastCaretPositionSupport_instance;
  }
  function LeafCellTrackingTrait$Side$LEFT() {
    Side_1.call(this, 'LEFT', 0, Companion_getInstance_193().xab_1, Companion_getInstance_193().vab_1);
    Side_LEFT_instance_0 = this;
  }
  protoOf(LeafCellTrackingTrait$Side$LEFT).rac = function (cell) {
    return cell.s35();
  };
  protoOf(LeafCellTrackingTrait$Side$LEFT).sac = function (cell, within) {
    return Composites_instance.b36(cell, within);
  };
  var Side_LEFT_instance_0;
  function LeafCellTrackingTrait$Side$RIGHT() {
    Side_1.call(this, 'RIGHT', 1, Companion_getInstance_193().yab_1, Companion_getInstance_193().wab_1);
    Side_RIGHT_instance_0 = this;
  }
  protoOf(LeafCellTrackingTrait$Side$RIGHT).rac = function (cell) {
    return cell.p35();
  };
  protoOf(LeafCellTrackingTrait$Side$RIGHT).sac = function (cell, within) {
    return Composites_instance.a36(cell, within);
  };
  var Side_RIGHT_instance_0;
  function LeafCellTrackingTrait$Side$siblingsOf$lambda(this$0) {
    return function (it) {
      return this$0.rac(it);
    };
  }
  function LeafCellTrackingTrait$Side$adjacentLeavesOf$lambda(this$0, $within) {
    return function (it) {
      return this$0.sac(it, $within);
    };
  }
  var Side_entriesInitialized_0;
  function Side_initEntries_0() {
    if (Side_entriesInitialized_0)
      return Unit_instance;
    Side_entriesInitialized_0 = true;
    Side_LEFT_instance_0 = new LeafCellTrackingTrait$Side$LEFT();
    Side_RIGHT_instance_0 = new LeafCellTrackingTrait$Side$RIGHT();
  }
  function initialize($this, _this__u8e3s4, side, within) {
    var c = _this__u8e3s4;
    while (!(c == null) && c.c93($this.pab_1)) {
      c = findAdjacentLeaf($this, c, opposite($this, side), within);
    }
    within.i90(side.wac_1, c);
  }
  function onAdded($this, cell) {
    if (!isSignificant($this, cell))
      return Unit_instance;
    onAdded_0($this, cell, Side_LEFT_getInstance_0());
    onAdded_0($this, cell, Side_RIGHT_getInstance_0());
  }
  function onRemoved($this, cell, root, dueToInvisibility) {
    if (_get_isIgnored__bbdceh($this, cell))
      return Unit_instance;
    if (!dueToInvisibility && !isVisible_1(cell))
      return Unit_instance;
    onRemoved_0($this, cell, root, Side_LEFT_getInstance_0());
    onRemoved_0($this, cell, root, Side_RIGHT_getInstance_0());
  }
  function onRemoved$default($this, cell, root, dueToInvisibility, $super) {
    dueToInvisibility = dueToInvisibility === VOID ? false : dueToInvisibility;
    return onRemoved($this, cell, root, dueToInvisibility);
  }
  function onAdded_0($this, cell, side) {
    var _iterator__ex2g4s = ancestorsFrom(cell).m();
    $l$loop: while (_iterator__ex2g4s.n()) {
      var ancestor = _iterator__ex2g4s.o();
      if (ancestor.c93(side.vac_1)) {
        ancestor.i90(side.wac_1, cell);
      }
      if (hasSignificantNeighbours($this, ancestor, side)) {
        break $l$loop;
      }
    }
  }
  function onRemoved_0($this, cell, root, side) {
    var _iterator__ex2g4s = ancestors(root).m();
    $l$loop: while (_iterator__ex2g4s.n()) {
      var ancestor = _iterator__ex2g4s.o();
      if (ancestor.c93(side.vac_1) && ancestor.k91(side.wac_1) === cell) {
        var newOutermost = findAdjacentLeaf($this, root, opposite($this, side), ancestor);
        ancestor.i90(side.wac_1, newOutermost);
      }
      if (hasSignificantNeighbours($this, ancestor, side)) {
        break $l$loop;
      }
    }
  }
  function hasSignificantNeighbours($this, _this__u8e3s4, side) {
    var tmp0 = side.xac(_this__u8e3s4);
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.sequences.any' call
      var _iterator__ex2g4s = tmp0.m();
      while (_iterator__ex2g4s.n()) {
        var element = _iterator__ex2g4s.o();
        if (isSignificant(LeafCellTrackingTrait_getInstance(), element)) {
          tmp$ret$1 = true;
          break $l$block;
        }
      }
      tmp$ret$1 = false;
    }
    return tmp$ret$1;
  }
  function isSignificant($this, _this__u8e3s4) {
    if (!isVisible_1(_this__u8e3s4))
      return false;
    var tmp;
    if (_this__u8e3s4 instanceof TextCell) {
      tmp = !_get_isIgnored__bbdceh($this, _this__u8e3s4);
    } else {
      tmp = false;
    }
    if (tmp)
      return true;
    var tmp0 = _this__u8e3s4.o35();
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.any' call
      var tmp_0;
      if (isInterface(tmp0, Collection)) {
        tmp_0 = tmp0.s();
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        tmp$ret$0 = false;
        break $l$block_0;
      }
      var _iterator__ex2g4s = tmp0.m();
      while (_iterator__ex2g4s.n()) {
        var element = _iterator__ex2g4s.o();
        if (isSignificant(LeafCellTrackingTrait_getInstance(), element)) {
          tmp$ret$0 = true;
          break $l$block_0;
        }
      }
      tmp$ret$0 = false;
    }
    return tmp$ret$0;
  }
  function _get_isIgnored__bbdceh($this, _this__u8e3s4) {
    return _this__u8e3s4.c93($this.pab_1);
  }
  function findAdjacentLeaf($this, leaf, side, within) {
    var tmp = side.yac(leaf, within);
    return firstOrNull_2(filter(tmp, LeafCellTrackingTrait$findAdjacentLeaf$lambda));
  }
  function Side_1(name, ordinal, isTrackingEnabledPropertySpec, edgeLeafPropertySpec) {
    Enum.call(this, name, ordinal);
    this.vac_1 = isTrackingEnabledPropertySpec;
    this.wac_1 = edgeLeafPropertySpec;
  }
  protoOf(Side_1).xac = function (cell) {
    return generateSequenceFromNext(cell, VOID, LeafCellTrackingTrait$Side$siblingsOf$lambda(this));
  };
  protoOf(Side_1).yac = function (cell, within) {
    return generateSequenceFromNext(cell, VOID, LeafCellTrackingTrait$Side$adjacentLeavesOf$lambda(this, within));
  };
  function opposite($this, _this__u8e3s4) {
    var tmp;
    switch (_this__u8e3s4.x2_1) {
      case 0:
        tmp = Side_RIGHT_getInstance_0();
        break;
      case 1:
        tmp = Side_LEFT_getInstance_0();
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  function LeafCellTrackingTrait$findAdjacentLeaf$lambda(it) {
    return isVisible_1(it);
  }
  function Side_LEFT_getInstance_0() {
    Side_initEntries_0();
    return Side_LEFT_instance_0;
  }
  function Side_RIGHT_getInstance_0() {
    Side_initEntries_0();
    return Side_RIGHT_instance_0;
  }
  function LeafCellTrackingTrait() {
    LeafCellTrackingTrait_instance = this;
    CellTrait.call(this);
    this.pab_1 = CellTraitPropertySpec_init_$Create$('ignoreAsOutermostLeaf', false);
  }
  protoOf(LeafCellTrackingTrait).dad = function (trackingCell) {
    var tmp0_safe_receiver = firstVisibleLeaf(trackingCell);
    if (tmp0_safe_receiver == null)
      null;
    else {
      initialize(this, tmp0_safe_receiver, Side_LEFT_getInstance_0(), trackingCell);
    }
  };
  protoOf(LeafCellTrackingTrait).ead = function (trackingCell) {
    var tmp0_safe_receiver = lastVisibleLeaf(trackingCell);
    if (tmp0_safe_receiver == null)
      null;
    else {
      initialize(this, tmp0_safe_receiver, Side_RIGHT_getInstance_0(), trackingCell);
    }
  };
  protoOf(LeafCellTrackingTrait).o91 = function (cell) {
    onAdded(this, cell);
  };
  protoOf(LeafCellTrackingTrait).f90 = function (cell) {
    onAdded(this, cell);
  };
  protoOf(LeafCellTrackingTrait).g90 = function (cell, root) {
    onRemoved$default(this, cell, root);
  };
  protoOf(LeafCellTrackingTrait).x8z = function (cell, prop, event) {
    if (prop === get_VISIBLE()) {
      if (!(event instanceof PropertyChangeEvent))
        THROW_CCE();
      if (event.t2y_1) {
        onAdded(this, cell);
      } else {
        onRemoved(this, cell, cell, true);
      }
    }
  };
  protoOf(LeafCellTrackingTrait).i8y = function (cell, spec, event) {
    if (spec === Companion_getInstance_190().waa_1) {
      if (!(event instanceof DerivedVisibilityEvent))
        THROW_CCE();
      if (event.zaa_1) {
        onAdded(this, cell);
      } else {
        onRemoved(this, cell, cell, true);
      }
    }
  };
  var LeafCellTrackingTrait_instance;
  function LeafCellTrackingTrait_getInstance() {
    if (LeafCellTrackingTrait_instance == null)
      new LeafCellTrackingTrait();
    return LeafCellTrackingTrait_instance;
  }
  function Companion_192() {
    Companion_instance_192 = this;
    this.cac_1 = new OutermostLeafCellFocusListener();
    this.dac_1 = CellTraitPropertySpec_init_$Create$('outermostCaretListener', this.cac_1);
    this.eac_1 = CellTraitPropertySpec_init_$Create$('outermostCaretListener', this.cac_1);
  }
  var Companion_instance_192;
  function Companion_getInstance_192() {
    if (Companion_instance_192 == null)
      new Companion_192();
    return Companion_instance_192;
  }
  function OutermostLeafCellFocusListener() {
    Companion_getInstance_192();
  }
  protoOf(OutermostLeafCellFocusListener).p91 = function (cell, event) {
  };
  protoOf(OutermostLeafCellFocusListener).q91 = function (cell, event) {
  };
  protoOf(OutermostLeafCellFocusListener).qab = function (cell, event) {
  };
  protoOf(OutermostLeafCellFocusListener).rab = function (cell, event) {
  };
  function isTracking($this, sides) {
    return contains_0(sides, $this.fad_1) ? true : null;
  }
  function Companion_193() {
    Companion_instance_193 = this;
    this.vab_1 = CellPropertySpec_init_$Create$('firstTrackedLeaf', null);
    this.wab_1 = CellPropertySpec_init_$Create$('lastTrackedLeaf', null);
    this.xab_1 = CellTraitPropertySpec_init_$Create$('trackingFirstLeaf', false);
    this.yab_1 = CellTraitPropertySpec_init_$Create$('trackingLastLeaf', false);
  }
  var Companion_instance_193;
  function Companion_getInstance_193() {
    if (Companion_instance_193 == null)
      new Companion_193();
    return Companion_instance_193;
  }
  function OutermostLeafCellTracker(side) {
    Companion_getInstance_193();
    CellTrait.call(this);
    this.fad_1 = side;
  }
  protoOf(OutermostLeafCellTracker).o91 = function (cell) {
    protoOf(CellTrait).o91.call(this, cell);
    if (listOf_0([CellSides_LEFT_getInstance(), CellSides_BOTH_getInstance()]).t(this.fad_1)) {
      LeafCellTrackingTrait_getInstance().dad(cell);
    }
    if (listOf_0([CellSides_RIGHT_getInstance(), CellSides_BOTH_getInstance()]).t(this.fad_1)) {
      LeafCellTrackingTrait_getInstance().ead(cell);
    }
  };
  protoOf(OutermostLeafCellTracker).n91 = function (cell, spec) {
    return equals(spec, Companion_getInstance_193().xab_1) ? isTracking(this, [CellSides_LEFT_getInstance(), CellSides_BOTH_getInstance()]) : equals(spec, Companion_getInstance_193().yab_1) ? isTracking(this, [CellSides_RIGHT_getInstance(), CellSides_BOTH_getInstance()]) : protoOf(CellTrait).n91.call(this, cell, spec);
  };
  var CellSides_LEFT_instance;
  var CellSides_RIGHT_instance;
  var CellSides_BOTH_instance;
  var CellSides_entriesInitialized;
  function CellSides_initEntries() {
    if (CellSides_entriesInitialized)
      return Unit_instance;
    CellSides_entriesInitialized = true;
    CellSides_LEFT_instance = new CellSides('LEFT', 0);
    CellSides_RIGHT_instance = new CellSides('RIGHT', 1);
    CellSides_BOTH_instance = new CellSides('BOTH', 2);
  }
  function CellSides(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function CellSides_LEFT_getInstance() {
    CellSides_initEntries();
    return CellSides_LEFT_instance;
  }
  function CellSides_RIGHT_getInstance() {
    CellSides_initEntries();
    return CellSides_RIGHT_instance;
  }
  function CellSides_BOTH_getInstance() {
    CellSides_initEntries();
    return CellSides_BOTH_instance;
  }
  function OutermostLeafTrackers() {
    OutermostLeafTrackers_instance = this;
    this.lac_1 = new OutermostLeafCellTracker(CellSides_LEFT_getInstance());
    this.mac_1 = new OutermostLeafCellTracker(CellSides_RIGHT_getInstance());
  }
  var OutermostLeafTrackers_instance;
  function OutermostLeafTrackers_getInstance() {
    if (OutermostLeafTrackers_instance == null)
      new OutermostLeafTrackers();
    return OutermostLeafTrackers_instance;
  }
  function get_PLACEHOLDER_CELL() {
    _init_properties_Placeholders_kt__gibeo0();
    return PLACEHOLDER_CELL;
  }
  var PLACEHOLDER_CELL;
  function get_TEXT_CELL_WITH_ATTACHED_PLACEHOLDER() {
    _init_properties_Placeholders_kt__gibeo0();
    return TEXT_CELL_WITH_ATTACHED_PLACEHOLDER;
  }
  var TEXT_CELL_WITH_ATTACHED_PLACEHOLDER;
  function get_IS_PLACEHOLDER() {
    _init_properties_Placeholders_kt__gibeo0();
    return IS_PLACEHOLDER;
  }
  var IS_PLACEHOLDER;
  function placeholder(text) {
    _init_properties_Placeholders_kt__gibeo0();
    // Inline function 'kotlin.apply' call
    var this_0 = TextCell_init_$Create$_0(text);
    this_0.b97().d2x(Companion_getInstance_210().r95_1);
    return this_0;
  }
  function attachToPlaceholder(placeholderCell, textCell) {
    _init_properties_Placeholders_kt__gibeo0();
    placeholderCell.w92(new attachToPlaceholder$1(textCell));
    textCell.w92(new attachToPlaceholder$2(placeholderCell, textCell));
    var textValue = textCell.o8w().uv();
    var tmp = placeholderCell.m92();
    // Inline function 'kotlin.text.isEmpty' call
    var tmp$ret$0 = charSequenceLength(textValue) === 0;
    tmp.d2x(tmp$ret$0);
  }
  function placeholder_0(textCell, placeholderText) {
    _init_properties_Placeholders_kt__gibeo0();
    var placeholderCell = placeholder(placeholderText);
    attachToPlaceholder(placeholderCell, textCell);
    return placeholderCell;
  }
  function isPlaceholder(_this__u8e3s4) {
    _init_properties_Placeholders_kt__gibeo0();
    return _this__u8e3s4.c93(get_IS_PLACEHOLDER());
  }
  function getFirstPlaceholder(_this__u8e3s4) {
    _init_properties_Placeholders_kt__gibeo0();
    var result = null;
    var _iterator__ex2g4s = _this__u8e3s4.o35().m();
    $l$loop_1: while (_iterator__ex2g4s.n()) {
      var child = _iterator__ex2g4s.o();
      if (!child.m92().w2w()) {
        continue $l$loop_1;
      }
      if (isPlaceholder(child)) {
        // Inline function 'kotlin.check' call
        if (!(child instanceof TextCell)) {
          throw IllegalStateException_init_$Create$_0('Check failed.');
        }
        var textCell = placeholdersTextCell(child);
        if (textCell.p92().w2w()) {
          result = textCell;
          break $l$loop_1;
        }
      }
      var firstPlaceholder = getFirstPlaceholder(child);
      if (!(firstPlaceholder == null)) {
        result = firstPlaceholder;
        break $l$loop_1;
      }
    }
    return result;
  }
  function placeholdersTextCell(_this__u8e3s4) {
    _init_properties_Placeholders_kt__gibeo0();
    // Inline function 'kotlin.check' call
    if (!isPlaceholder(_this__u8e3s4)) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    return ensureNotNull(_this__u8e3s4.c93(get_TEXT_CELL_WITH_ATTACHED_PLACEHOLDER()));
  }
  function attachToPlaceholder$o$get$lambda($spec) {
    return function (matcher) {
      return matcher($spec);
    };
  }
  function attachToPlaceholder$1($textCell) {
    this.had_1 = $textCell;
    CellTrait.call(this);
    this.gad_1 = listOf_0([specMatcherValue(get_IS_PLACEHOLDER(), true), specMatcherValue(get_TEXT_CELL_WITH_ATTACHED_PLACEHOLDER(), $textCell)]);
  }
  protoOf(attachToPlaceholder$1).t91 = function (cell, event) {
    if (!this.had_1.p92().w2w())
      return Unit_instance;
    var prevFocused = ensureNotNull(cell.s8x()).z92().uv();
    this.had_1.s8n();
    event.n8i();
    cell.u92(new FocusEvent(prevFocused, cell), Cells_getInstance().f9t_1);
  };
  protoOf(attachToPlaceholder$1).n91 = function (cell, spec) {
    // Inline function 'jetbrains.ocelot.projectional.cell.trait.getSpecValue' call
    var specMatchers = this.gad_1;
    var tmp = asSequence_0(specMatchers);
    var result = firstOrNull_2(filterNotNull_0(map(tmp, attachToPlaceholder$o$get$lambda(spec))));
    var tmp_0;
    if (result == null) {
      tmp_0 = protoOf(CellTrait).n91.call(this, cell, spec);
    } else {
      tmp_0 = result.o9n_1;
    }
    return tmp_0;
  };
  function attachToPlaceholder$2($placeholderCell, $textCell) {
    this.iad_1 = $placeholderCell;
    this.jad_1 = $textCell;
    CellTrait.call(this);
  }
  protoOf(attachToPlaceholder$2).n91 = function (cell, spec) {
    var matcher = specMatcherValue(get_PLACEHOLDER_CELL(), this.iad_1);
    // Inline function 'jetbrains.ocelot.projectional.cell.trait.getSpecValue' call
    var result = matcher(spec);
    var tmp;
    if (result == null) {
      tmp = protoOf(CellTrait).n91.call(this, cell, spec);
    } else {
      tmp = result.o9n_1;
    }
    return tmp;
  };
  protoOf(attachToPlaceholder$2).x8z = function (cell, prop, event) {
    if (equals(prop, get_FOCUS_HIGHLIGHTED())) {
      var tmp = ensureNotNull(this.jad_1.c93(get_PLACEHOLDER_CELL())).o92();
      var tmp_0 = event.t2y_1;
      tmp.d2x((!(tmp_0 == null) ? typeof tmp_0 === 'boolean' : false) ? tmp_0 : THROW_CCE());
    } else if (equals(prop, Companion_getInstance_154().b8x_1)) {
      var tmp_1 = event.t2y_1;
      var value = (tmp_1 == null ? true : typeof tmp_1 === 'string') ? tmp_1 : THROW_CCE();
      var tmp_2 = ensureNotNull(this.jad_1.c93(get_PLACEHOLDER_CELL())).m92();
      // Inline function 'kotlin.text.isNullOrEmpty' call
      var tmp$ret$0 = value == null || charSequenceLength(value) === 0;
      tmp_2.d2x(tmp$ret$0);
    }
  };
  var properties_initialized_Placeholders_kt_1i1fdu;
  function _init_properties_Placeholders_kt__gibeo0() {
    if (!properties_initialized_Placeholders_kt_1i1fdu) {
      properties_initialized_Placeholders_kt_1i1fdu = true;
      PLACEHOLDER_CELL = CellTraitPropertySpec_init_$Create$('placeholderCell', null);
      TEXT_CELL_WITH_ATTACHED_PLACEHOLDER = CellTraitPropertySpec_init_$Create$('textCellWithAttachedPlaceholder', null);
      IS_PLACEHOLDER = CellTraitPropertySpec_init_$Create$('isPlaceholder', false);
    }
  }
  function assertValid_1($this) {
    // Inline function 'kotlin.check' call
    if (!$this.p38()) {
      var message = 'Not valid: ' + toString_1($this);
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
  }
  function CellScope() {
  }
  protoOf(CellScope).x9a = function () {
    assertValid_1(this);
    return this.kad();
  };
  protoOf(CellScope).lad = function () {
    assertValid_1(this);
    this.mad();
  };
  protoOf(CellScope).nad = function () {
    assertValid_1(this);
    return this.oad();
  };
  function FocusableCellScope(cell) {
    CellScope.call(this);
    this.pad_1 = cell;
  }
  protoOf(FocusableCellScope).p38 = function () {
    return this.pad_1.f89() && this.pad_1.p92().uv();
  };
  protoOf(FocusableCellScope).kad = function () {
    return this.pad_1.y92().uv();
  };
  protoOf(FocusableCellScope).mad = function () {
    this.pad_1.s8n();
    CellScrolling_getInstance().xa4(this.pad_1);
  };
  protoOf(FocusableCellScope).oad = function () {
    return CellScopes_getInstance().sad(this.pad_1.bp());
  };
  function CellScopes$PROPERTY$lambda(cell) {
    var tmp;
    if (!cell.p92().uv() || cell.c93(CellScopes_getInstance().qad_1)) {
      tmp = null;
    } else {
      tmp = new FocusableCellScope(cell);
    }
    return tmp;
  }
  function CellScopes$nearest$lambda(c) {
    return c.c93(CellScopes_getInstance().rad_1);
  }
  function CellScopes() {
    CellScopes_instance = this;
    this.qad_1 = CellTraitPropertySpec_init_$Create$('cellScopeIgnored', false);
    var tmp = this;
    tmp.rad_1 = new CellTraitPropertySpec('currentSelection', CellScopes$PROPERTY$lambda);
  }
  protoOf(CellScopes).sad = function (cell) {
    var tmp = ancestorsFrom(cell);
    return firstOrNull_2(filterNotNull_0(map(tmp, CellScopes$nearest$lambda)));
  };
  var CellScopes_instance;
  function CellScopes_getInstance() {
    if (CellScopes_instance == null)
      new CellScopes();
    return CellScopes_instance;
  }
  function _get_properties__8r22x4($this) {
    return $this.tad_1.c93(CellScrolling_getInstance().wa4_1);
  }
  function scrollToEditor($this, editor) {
    var root = ensureNotNull(ensureNotNull(editor.s8x()).k9v(editor));
    return scrollTo_1(root, CellScrolling$scrollToEditor$lambda(editor, root));
  }
  function scrollToEditorAsync($this, editor, cause) {
    var root = ensureNotNull(ensureNotNull(editor.s8x()).k9v(editor));
    return root.a93(CellScrolling$scrollToEditorAsync$lambda(editor, cause, root));
  }
  function calculateTarget($this, editor, cause) {
    var cellContainer = ensureNotNull(editor.s8x());
    var scrollCell = ensureNotNull(cellContainer.k9v(editor));
    var visibleRect = cellContainer.v93(scrollCell);
    var lineBounds = getLineBounds($this, editor);
    var lineFullyVisible = visibleRect.k8c(lineBounds);
    if (lineFullyVisible && shouldStayIfLineVisible($this, cause)) {
      return lineBounds;
    }
    var mainTarget = calculateMainTarget($this, editor, cause, lineFullyVisible);
    var snappedHome = SnappingHome_getInstance().wad(editor, mainTarget, lineBounds);
    var tmp;
    if (snappedHome.equals(mainTarget)) {
      tmp = Snapping_getInstance().zad(mainTarget, editor, cause);
    } else {
      tmp = snappedHome;
    }
    return tmp;
  }
  function isHome($this, event) {
    return event.o8j([KeyStrokeSpecs_getInstance().l8k_1, KeyStrokeSpecs_getInstance().w8k_1]);
  }
  function getLineBounds($this, editor) {
    return getLineBounds_0($this, editor, getVerticalChild($this, editor));
  }
  function getVerticalChild($this, from) {
    var tmp0 = ancestorsFrom(from);
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.sequences.first' call
      var _iterator__ex2g4s = tmp0.m();
      while (_iterator__ex2g4s.n()) {
        var element = _iterator__ex2g4s.o();
        var parentCell = element.bp();
        var tmp;
        if (parentCell == null) {
          tmp = true;
        } else {
          tmp = parentCell instanceof VerticalCell;
        }
        if (tmp) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      throw NoSuchElementException_init_$Create$_0('Sequence contains no element matching the predicate.');
    }
    return tmp$ret$1;
  }
  function getLineBounds_0($this, editor, within) {
    var upperLeftCell;
    var bottomRightCell;
    if (editor === within) {
      upperLeftCell = editor;
      bottomRightCell = editor;
    } else {
      upperLeftCell = findLineBound($this, editor, CellScrolling$getLineBounds$lambda(within));
      bottomRightCell = findLineBound($this, editor, CellScrolling$getLineBounds$lambda_0(within));
      if (upperLeftCell == null) {
        upperLeftCell = within;
      }
      if (bottomRightCell == null) {
        bottomRightCell = within;
      }
    }
    var upperLeft = get_origin(upperLeftCell);
    var bottomRight = get_origin(bottomRightCell).i8c(get_dimension(bottomRightCell));
    return new Rectangle(upperLeft, bottomRight.j8c(upperLeft));
  }
  function findLineBound($this, from, traverser) {
    var current = from;
    while (true) {
      var tmp0_elvis_lhs = traverser(current);
      var tmp;
      if (tmp0_elvis_lhs == null) {
        return null;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var next = tmp;
      if (next instanceof NewLineCell) {
        return current;
      }
      current = next;
    }
  }
  function calculateMainTarget($this, editor, e, lineFullyVisible) {
    var tmp;
    if (isGoRight($this, e)) {
      tmp = fromCaret($this, editor).fae().gae().q33();
    } else if (isGoLeft($this, e)) {
      tmp = fromCaret($this, editor).dae().eae().q33();
    } else if (isGoUp($this, e)) {
      var tmp_0 = fromCaret($this, editor);
      var tmp_1 = !lineFullyVisible;
      tmp = tmp_0.aae(tmp_1, CellScrolling$TargetBuilder$extendSideways$ref()).cae().q33();
    } else if (isGoDown($this, e)) {
      var tmp_2 = fromCaret($this, editor);
      var tmp_3 = !lineFullyVisible;
      tmp = tmp_2.aae(tmp_3, CellScrolling$TargetBuilder$extendSideways$ref_0()).bae().q33();
    } else {
      tmp = calculateSimpleTarget($this, editor);
    }
    return tmp;
  }
  function calculateSimpleTarget($this, editor) {
    return fromCaret($this, editor).hae().q33();
  }
  function isGoUp($this, event) {
    return event.m8j(Key_UP_getInstance(), []) || event.m8j(Key_PAGE_UP_getInstance(), []) || event.o8j([KeyStrokeSpecs_getInstance().c8l_1]);
  }
  function isGoDown($this, event) {
    return event.m8j(Key_DOWN_getInstance(), []) || event.m8j(Key_ENTER_getInstance(), []) || event.m8j(Key_PAGE_DOWN_getInstance(), []) || event.o8j([KeyStrokeSpecs_getInstance().d8l_1]);
  }
  function isGoLeft($this, event) {
    return event.m8j(Key_LEFT_getInstance(), []) || event.m8j(Key_BACKSPACE_getInstance(), []) || event.o8j([KeyStrokeSpecs_getInstance().a8l_1, KeyStrokeSpecs_getInstance().p8k_1, KeyStrokeSpecs_getInstance().l8k_1]);
  }
  function isGoRight($this, event) {
    return event.m8j(Key_RIGHT_getInstance(), []) || event.o8j([KeyStrokeSpecs_getInstance().b8l_1, KeyStrokeSpecs_getInstance().q8k_1, KeyStrokeSpecs_getInstance().m8k_1]);
  }
  function shouldStayIfLineVisible($this, event) {
    return !isHome($this, event) && !isGoUp($this, event) && !isGoDown($this, event);
  }
  function fromCaret($this, editor) {
    return new TargetBuilder(editor, editor.y96());
  }
  function TargetBuilder(editor, _target) {
    this.tad_1 = editor;
    this.uad_1 = _target;
  }
  protoOf(TargetBuilder).q33 = function () {
    return this.uad_1.q8c(get_bounds(ensureNotNull(ensureNotNull(this.tad_1.s8x()).k9v(this.tad_1))));
  };
  protoOf(TargetBuilder).aae = function (test, modification) {
    var tmp;
    if (test) {
      tmp = modification(this);
    } else {
      tmp = this;
    }
    return tmp;
  };
  protoOf(TargetBuilder).hae = function () {
    var sidewaysExtension = ScrollingUtil_instance.mae(_get_properties__8r22x4(this).lae_1, this.tad_1, 0);
    this.uad_1 = Rectangles_instance.g8d(sidewaysExtension, this.uad_1, sidewaysExtension);
    return this;
  };
  protoOf(TargetBuilder).cae = function () {
    var upExtension = ScrollingUtil_instance.nae(_get_properties__8r22x4(this).jae_1, this.tad_1);
    this.uad_1 = Rectangles_instance.c8d(this.uad_1, upExtension);
    return this;
  };
  protoOf(TargetBuilder).bae = function () {
    var upExtension = ScrollingUtil_instance.nae(_get_properties__8r22x4(this).jae_1, this.tad_1);
    this.uad_1 = Rectangles_instance.d8d(this.uad_1, upExtension);
    return this;
  };
  protoOf(TargetBuilder).eae = function () {
    var leftExtension = ScrollingUtil_instance.mae(_get_properties__8r22x4(this).iae_1, this.tad_1, 0);
    this.uad_1 = Rectangles_instance.e8d(this.uad_1, leftExtension);
    return this;
  };
  protoOf(TargetBuilder).gae = function () {
    var rightExtension = ScrollingUtil_instance.mae(_get_properties__8r22x4(this).iae_1, this.tad_1, 0);
    this.uad_1 = Rectangles_instance.f8d(this.uad_1, rightExtension);
    return this;
  };
  protoOf(TargetBuilder).fae = function () {
    var leftExtension = ScrollingUtil_instance.mae(_get_properties__8r22x4(this).kae_1, this.tad_1, 0);
    this.uad_1 = Rectangles_instance.e8d(this.uad_1, leftExtension);
    return this;
  };
  protoOf(TargetBuilder).dae = function () {
    var rightExtension = ScrollingUtil_instance.mae(_get_properties__8r22x4(this).kae_1, this.tad_1, 0);
    this.uad_1 = Rectangles_instance.f8d(this.uad_1, rightExtension);
    return this;
  };
  function CellScrolling$scrollToEditor$lambda($editor, $root) {
    return function () {
      var target = calculateSimpleTarget(CellScrolling_getInstance(), $editor);
      target = Snapping_getInstance().oae(target, $editor);
      return target.j8c(get_origin($root));
    };
  }
  function CellScrolling$scrollToEditorAsync$lambda($editor, $cause, $root) {
    return function () {
      var target = calculateTarget(CellScrolling_getInstance(), $editor, $cause);
      return target.j8c(get_origin($root));
    };
  }
  function CellScrolling$getLineBounds$lambda($within) {
    return function (cell) {
      return prevVisibleLeaf_0(cell, $within);
    };
  }
  function CellScrolling$getLineBounds$lambda_0($within) {
    return function (cell) {
      return nextVisibleLeaf_0(cell, $within);
    };
  }
  function CellScrolling$TargetBuilder$extendSideways$ref() {
    var l = function (p0) {
      return p0.hae();
    };
    l.callableName = 'extendSideways';
    return l;
  }
  function CellScrolling$TargetBuilder$extendSideways$ref_0() {
    var l = function (p0) {
      return p0.hae();
    };
    l.callableName = 'extendSideways';
    return l;
  }
  function CellScrolling() {
    CellScrolling_instance = this;
    this.va4_1 = Companion_instance_194.c5f().tae(6).uae(1).vae(3).wae(4).f40();
    this.wa4_1 = CellTraits_instance.v9f('scrollingParameters', this.va4_1);
  }
  protoOf(CellScrolling).xa4 = function (cell) {
    // Inline function 'kotlin.require' call
    if (!cell.f89()) {
      var message = "Can't scroll to non-attached cell";
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    var tmp;
    var tmp_0;
    if (cell instanceof TextCell) {
      tmp_0 = !inPopup(cell);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      scrollToEditor(this, cell);
      tmp = Unit_instance;
    } else {
      scrollTo_0(cell);
      tmp = Unit_instance;
    }
    return tmp;
  };
  protoOf(CellScrolling).xae = function (cell, cause) {
    // Inline function 'kotlin.require' call
    if (!cell.f89()) {
      var message = "Can't scroll to non-attached cell";
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    var tmp;
    var tmp_0;
    if (cell instanceof TextCell) {
      tmp_0 = !inPopup(cell);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = scrollToEditorAsync(this, cell, cause);
    } else {
      tmp = scrollToAsync(cell);
    }
    return tmp;
  };
  protoOf(CellScrolling).ya6 = function (cell, cause) {
    this.xae(cell, cause);
  };
  var CellScrolling_instance;
  function CellScrolling_getInstance() {
    if (CellScrolling_instance == null)
      new CellScrolling();
    return CellScrolling_instance;
  }
  function Builder_1() {
    this.pae_1 = 0;
    this.qae_1 = 0;
    this.rae_1 = 0;
    this.sae_1 = 0;
  }
  protoOf(Builder_1).tae = function (lookaheadChars) {
    this.pae_1 = lookaheadChars;
    return this;
  };
  protoOf(Builder_1).uae = function (lookaheadLines) {
    this.qae_1 = lookaheadLines;
    return this;
  };
  protoOf(Builder_1).vae = function (lookbehindChars) {
    this.rae_1 = lookbehindChars;
    return this;
  };
  protoOf(Builder_1).wae = function (lookSidewaysChars) {
    this.sae_1 = lookSidewaysChars;
    return this;
  };
  protoOf(Builder_1).f40 = function () {
    ScrollingUtil_instance.yae(new Int32Array([this.pae_1, this.qae_1, this.rae_1, this.sae_1]));
    return new ScrollingParameters(this);
  };
  function Companion_194() {
  }
  protoOf(Companion_194).c5f = function () {
    return new Builder_1();
  };
  var Companion_instance_194;
  function Companion_getInstance_194() {
    return Companion_instance_194;
  }
  function ScrollingParameters(builder) {
    this.iae_1 = builder.pae_1;
    this.jae_1 = builder.qae_1;
    this.kae_1 = builder.rae_1;
    this.lae_1 = builder.sae_1;
  }
  function findSuitableLike($this, example, cells) {
    // Inline function 'kotlin.sequences.filterIsInstance' call
    var tmp = filter(cells, ScrollingUtil$findSuitableLike$lambda);
    var tmp_0 = isInterface(tmp, Sequence) ? tmp : THROW_CCE();
    return firstOrNull_2(filter(tmp_0, ScrollingUtil$findSuitableLike$lambda_0(example)));
  }
  function isSuitable($this, cell) {
    return cell.m92().w2w() && !cell.w2m() && !isPlaceholder(cell) && cell.z96(1) > 0;
  }
  function isLike($this, cell, example) {
    return equals(cell.f97().uv(), example.f97().uv()) && cell.g97().uv() === example.g97().uv();
  }
  function ScrollingUtil$findSuitableLike$lambda(it) {
    return it instanceof TextCell;
  }
  function ScrollingUtil$findSuitableLike$lambda_0($example) {
    return function (cell) {
      return isSuitable(ScrollingUtil_instance, cell) && isLike(ScrollingUtil_instance, cell, $example);
    };
  }
  function ScrollingUtil() {
  }
  protoOf(ScrollingUtil).mae = function (chars, reference, defaultValue) {
    var tmp;
    if (isSuitable(this, reference)) {
      tmp = imul(reference.z96(1), chars);
    } else {
      var prev = findSuitableLike(this, reference, prevVisibleLeaves(reference));
      var tmp_0;
      if (!(prev == null)) {
        tmp_0 = imul(prev.z96(1), chars);
      } else {
        var next = findSuitableLike(this, reference, Composites_instance.c36(reference));
        var tmp_1;
        if (next == null) {
          tmp_1 = defaultValue;
        } else {
          tmp_1 = imul(next.z96(1), chars);
        }
        tmp_0 = tmp_1;
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  protoOf(ScrollingUtil).nae = function (lines, reference) {
    return imul(get_dimension(reference).e8c_1, lines);
  };
  protoOf(ScrollingUtil).yae = function (values) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.all' call
      var inductionVariable = 0;
      var last = values.length;
      while (inductionVariable < last) {
        var element = values[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        if (!(element >= 0)) {
          tmp$ret$1 = false;
          break $l$block;
        }
      }
      tmp$ret$1 = true;
    }
    var allNonNegative = tmp$ret$1;
    // Inline function 'kotlin.require' call
    if (!allNonNegative) {
      var message = 'Negatives are not allowed: ' + toString_1(values);
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
  };
  var ScrollingUtil_instance;
  function ScrollingUtil_getInstance() {
    return ScrollingUtil_instance;
  }
  function doSnapToRootBounds($this, rectangle, reference, verticalParams, horizontalParams) {
    var cellContainer = ensureNotNull(reference.s8x());
    var root = cellContainer.k9v(reference);
    var rootBounds = get_bounds(ensureNotNull(root));
    var visible = cellContainer.v93(root);
    var result = rectangle;
    var upperDistance = Rectangles_instance.x8c(result, rootBounds);
    var lowerDistance = Rectangles_instance.y8c(result, rootBounds);
    if (upperDistance < ScrollingUtil_instance.nae(verticalParams.zae_1, reference) && Rectangles_instance.w8c(visible).k8c(Rectangles_instance.w8c(Rectangles_instance.c8d(result, upperDistance)))) {
      result = Rectangles_instance.c8d(result, upperDistance);
    } else if (lowerDistance < ScrollingUtil_instance.nae(verticalParams.aaf_1, reference) && Rectangles_instance.w8c(visible).k8c(Rectangles_instance.w8c(Rectangles_instance.d8d(result, lowerDistance)))) {
      result = Rectangles_instance.d8d(result, lowerDistance);
    }
    var leftDistance = Rectangles_instance.z8c(result, rootBounds);
    var rightDistance = Rectangles_instance.a8d(result, rootBounds);
    if (leftDistance < ScrollingUtil_instance.mae(horizontalParams.zae_1, reference, 0) && Rectangles_instance.w8c(visible).k8c(Rectangles_instance.w8c(Rectangles_instance.e8d(result, leftDistance)))) {
      result = Rectangles_instance.e8d(result, leftDistance);
    } else if (rightDistance < ScrollingUtil_instance.mae(horizontalParams.aaf_1, reference, 0) && Rectangles_instance.w8c(visible).k8c(Rectangles_instance.w8c(Rectangles_instance.f8d(result, rightDistance)))) {
      result = Rectangles_instance.f8d(result, rightDistance);
    }
    return result;
  }
  function getParameters($this, cell) {
    return cell.c93($this.yad_1);
  }
  function Snapping() {
    Snapping_instance = this;
    this.xad_1 = Companion_instance_195.c5f().haf(4).iaf(1).jaf(6).kaf(4).laf(4).maf(4).f40();
    this.yad_1 = CellTraits_instance.v9f('snappingParameters', this.xad_1);
  }
  protoOf(Snapping).zad = function (rectangle, reference, cause) {
    var params = getParameters(this, reference);
    if (cause.o8j([KeyStrokeSpecs_getInstance().l8k_1])) {
      return doSnapToRootBounds(this, rectangle, reference, params.taf(), params.uaf());
    }
    var tmp;
    if (cause.o8j([KeyStrokeSpecs_getInstance().m8k_1])) {
      tmp = doSnapToRootBounds(this, rectangle, reference, params.taf(), params.vaf());
    } else {
      tmp = this.oae(rectangle, reference);
    }
    return tmp;
  };
  protoOf(Snapping).oae = function (rectangle, reference) {
    var params = getParameters(this, reference);
    return doSnapToRootBounds(this, rectangle, reference, params.taf(), params.waf());
  };
  var Snapping_instance;
  function Snapping_getInstance() {
    if (Snapping_instance == null)
      new Snapping();
    return Snapping_instance;
  }
  function SnappingHome() {
    SnappingHome_instance = this;
    this.vad_1 = CellTraits_instance.v9f('viewPartToSnap', 1.0 / 2);
  }
  protoOf(SnappingHome).wad = function (to, target, lineBounds) {
    var cellContainer = ensureNotNull(to.s8x());
    var root = cellContainer.k9v(to);
    var rootBounds = get_bounds(ensureNotNull(root));
    var viewportWidth = cellContainer.v93(root).c8c_1.d8c_1;
    var caretAbsX = Rectangles_instance.z8c(to.y96(), rootBounds);
    if (caretAbsX <= numberToInt(viewportWidth * to.c93(this.vad_1))) {
      var snappingSize = Rectangles_instance.z8c(target, rootBounds);
      var resultRect = Rectangles_instance.e8d(target, snappingSize);
      var resultLine = resultRect.m8c(lineBounds);
      if (resultLine.c8c_1.d8c_1 <= viewportWidth) {
        return resultRect;
      }
    }
    return target;
  };
  var SnappingHome_instance;
  function SnappingHome_getInstance() {
    if (SnappingHome_instance == null)
      new SnappingHome();
    return SnappingHome_instance;
  }
  function OneAxisSnapping(beginning, end) {
    this.zae_1 = beginning;
    this.aaf_1 = end;
  }
  function Builder_2() {
    this.baf_1 = 0;
    this.caf_1 = 0;
    this.daf_1 = 0;
    this.eaf_1 = 0;
    this.faf_1 = 0;
    this.gaf_1 = 0;
  }
  protoOf(Builder_2).haf = function (leftChars) {
    this.baf_1 = leftChars;
    return this;
  };
  protoOf(Builder_2).iaf = function (rightChars) {
    this.caf_1 = rightChars;
    return this;
  };
  protoOf(Builder_2).jaf = function (longLeftChars) {
    this.daf_1 = longLeftChars;
    return this;
  };
  protoOf(Builder_2).kaf = function (longRightChars) {
    this.eaf_1 = longRightChars;
    return this;
  };
  protoOf(Builder_2).laf = function (topLines) {
    this.faf_1 = topLines;
    return this;
  };
  protoOf(Builder_2).maf = function (bottomLines) {
    this.gaf_1 = bottomLines;
    return this;
  };
  protoOf(Builder_2).f40 = function () {
    ScrollingUtil_instance.yae(new Int32Array([this.baf_1, this.caf_1, this.daf_1, this.eaf_1, this.faf_1, this.gaf_1]));
    return new SnappingParameters(this);
  };
  function Companion_195() {
  }
  protoOf(Companion_195).c5f = function () {
    return new Builder_2();
  };
  var Companion_instance_195;
  function Companion_getInstance_195() {
    return Companion_instance_195;
  }
  function SnappingParameters(builder) {
    this.naf_1 = builder.baf_1;
    this.oaf_1 = builder.caf_1;
    this.paf_1 = builder.daf_1;
    this.qaf_1 = builder.eaf_1;
    this.raf_1 = builder.faf_1;
    this.saf_1 = builder.gaf_1;
  }
  protoOf(SnappingParameters).waf = function () {
    return new OneAxisSnapping(this.naf_1, this.oaf_1);
  };
  protoOf(SnappingParameters).vaf = function () {
    return new OneAxisSnapping(this.naf_1, this.qaf_1);
  };
  protoOf(SnappingParameters).uaf = function () {
    return new OneAxisSnapping(this.paf_1, this.oaf_1);
  };
  protoOf(SnappingParameters).taf = function () {
    return new OneAxisSnapping(this.raf_1, this.saf_1);
  };
  function URLCellTrait$Companion$URL$lambda(cell) {
    var tmp;
    if (cell instanceof TextCell) {
      tmp = cell.o8w().w2w();
    } else {
      tmp = null;
    }
    return tmp;
  }
  function tryToNavigate($this, cell) {
    var urlToUse = cell.c93(Companion_getInstance_196().xaf_1);
    if (!(urlToUse == null)) {
      $this.zaf(urlToUse);
      return true;
    }
    return false;
  }
  function Companion_196() {
    Companion_instance_196 = this;
    var tmp = this;
    tmp.xaf_1 = new CellTraitPropertySpec('CellURL', URLCellTrait$Companion$URL$lambda);
  }
  var Companion_instance_196;
  function Companion_getInstance_196() {
    if (Companion_instance_196 == null)
      new Companion_196();
    return Companion_instance_196;
  }
  function URLCellTrait(navigateKeyStrokes) {
    Companion_getInstance_196();
    CellTrait.call(this);
    this.yaf_1 = navigateKeyStrokes;
  }
  protoOf(URLCellTrait).o91 = function (cell) {
    cell.i90(get_LINK(), true);
    if (cell instanceof TextCell) {
      cell.b97().f2x(Companion_getInstance_210().w95_1);
    }
  };
  protoOf(URLCellTrait).s8z = function (cell, event) {
    if (event.r8j(this.yaf_1.slice()) && tryToNavigate(this, cell)) {
      event.n8i();
    } else {
      protoOf(CellTrait).s8z.call(this, cell, event);
    }
  };
  protoOf(URLCellTrait).r91 = function (cell, event) {
    if (tryToNavigate(this, cell)) {
      event.n8i();
    } else {
      protoOf(CellTrait).r91.call(this, cell, event);
    }
  };
  function _no_name_provided__qut3iv_0($matchingText, $sortPriority, $isCaseSensitive, $textCell, $name) {
    this.eag_1 = $textCell;
    this.fag_1 = $name;
    SimpleCompletionItem.call(this, $matchingText, VOID, $sortPriority, $isCaseSensitive);
  }
  protoOf(_no_name_provided__qut3iv_0).s9m = function (text) {
    this.eag_1.o8w().d2x(this.fag_1);
    return toEnd_0(this.eag_1);
  };
  function ValueEditors$getEnumValidatedProperty$o$matchers$lambda($spec, $enumInfo, $textCell) {
    return function (inputSpec) {
      var tmp;
      if (inputSpec === $spec) {
        // Inline function 'kotlin.collections.map' call
        var this_0 = $enumInfo.n24();
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
        var _iterator__ex2g4s = this_0.m();
        while (_iterator__ex2g4s.n()) {
          var item = _iterator__ex2g4s.o();
          // Inline function 'jetbrains.ocelot.projectional.cell.completion.result.simpleCompletionItem' call
          var tmp$ret$1 = new _no_name_provided__qut3iv_0(item, 0, true, $textCell, item);
          destination.j(tmp$ret$1);
        }
        var tmp$ret$4 = toCompletionSupplier(destination);
        tmp = new SpecMatchResult(tmp$ret$4);
      } else {
        tmp = null;
      }
      return tmp;
    };
  }
  function ValueEditors$getEnumValidatedProperty$o$get$lambda($spec) {
    return function (matcher) {
      return matcher($spec);
    };
  }
  function _no_name_provided__qut3iv_1($matchingText, $sortPriority, $isCaseSensitive, $textCell) {
    this.kag_1 = $textCell;
    SimpleCompletionItem.call(this, $matchingText, VOID, $sortPriority, $isCaseSensitive);
  }
  protoOf(_no_name_provided__qut3iv_1).s9m = function (text) {
    this.kag_1.o8w().d2x('true');
    return get_EMPTY_CELL_ACTION();
  };
  function _no_name_provided__qut3iv_2($matchingText, $sortPriority, $isCaseSensitive, $textCell) {
    this.pag_1 = $textCell;
    SimpleCompletionItem.call(this, $matchingText, VOID, $sortPriority, $isCaseSensitive);
  }
  protoOf(_no_name_provided__qut3iv_2).s9m = function (text) {
    this.pag_1.o8w().d2x('false');
    return get_EMPTY_CELL_ACTION();
  };
  function ValueEditors$booleanProperty$o$get$lambda($spec, $textCell) {
    return function (inputSpec) {
      var tmp;
      if (inputSpec === $spec) {
        // Inline function 'jetbrains.ocelot.projectional.cell.completion.result.simpleCompletionItem' call
        var tmp_0 = new _no_name_provided__qut3iv_1('true', 0, true, $textCell);
        // Inline function 'jetbrains.ocelot.projectional.cell.completion.result.simpleCompletionItem' call
        var tmp$ret$1 = new _no_name_provided__qut3iv_2('false', 0, true, $textCell);
        var tmp$ret$2 = simpleCompletionSupplier([tmp_0, tmp$ret$1]);
        tmp = new SpecMatchResult(tmp$ret$2);
      } else {
        tmp = null;
      }
      return tmp;
    };
  }
  function getEnumValidatedProperty($this, textCell, enumInfo) {
    var validator = ValueEditors$getEnumValidatedProperty$lambda(enumInfo);
    var trait = new ValueEditors$getEnumValidatedProperty$trait$1(validator, enumInfo, textCell);
    textCell.w92(trait);
    return asValidatedProp(textCell.o8w(), '', validator);
  }
  function intProperty$safeToInt(_this__u8e3s4) {
    var tmp;
    try {
      tmp = toInt(_this__u8e3s4);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof IllegalArgumentException) {
        var e = $p;
        tmp_0 = 0;
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  function ValueEditors$getEnumValidatedProperty$lambda($enumInfo) {
    return function (s) {
      var tmp;
      // Inline function 'kotlin.text.isEmpty' call
      if (charSequenceLength(s) === 0) {
        tmp = true;
      } else {
        tmp = $enumInfo.p24(s);
      }
      return tmp;
    };
  }
  function ValueEditors$getEnumValidatedProperty$trait$1($validator, $enumInfo, $textCell) {
    BaseDerivedCellTrait.call(this, TextEditing_getInstance().ta6($validator));
    var tmp = this;
    // Inline function 'jetbrains.ocelot.projectional.cell.trait.specMatcher' call
    var spec = Completion_getInstance().u9d_1;
    var tmp$ret$0 = ValueEditors$getEnumValidatedProperty$o$matchers$lambda(spec, $enumInfo, $textCell);
    tmp.rag_1 = listOf_0([tmp$ret$0, specMatcherValue(TextEditing_getInstance().x99_1, true)]);
  }
  protoOf(ValueEditors$getEnumValidatedProperty$trait$1).n91 = function (cell, spec) {
    // Inline function 'jetbrains.ocelot.projectional.cell.trait.getSpecValue' call
    var specMatchers = this.rag_1;
    var tmp = asSequence_0(specMatchers);
    var result = firstOrNull_2(filterNotNull_0(map(tmp, ValueEditors$getEnumValidatedProperty$o$get$lambda(spec))));
    var tmp_0;
    if (result == null) {
      tmp_0 = protoOf(BaseDerivedCellTrait).n91.call(this, cell, spec);
    } else {
      tmp_0 = result.o9n_1;
    }
    return tmp_0;
  };
  function EnumInfo$safeValueOf$ref(p0) {
    var l = function (_this__u8e3s4) {
      return p0.o24(_this__u8e3s4);
    };
    l.callableName = 'safeValueOf';
    return l;
  }
  function ValueEditors$nullableEnumProperty$lambda(enumT) {
    return enumT == null ? '' : '' + toString_0(enumT);
  }
  function ValueEditors$booleanProperty$trait$1($textCell) {
    this.tag_1 = $textCell;
    BaseDerivedCellTrait.call(this, TextEditing_getInstance().ta6(Validators_getInstance().y8t()));
  }
  protoOf(ValueEditors$booleanProperty$trait$1).n91 = function (cell, spec) {
    // Inline function 'jetbrains.ocelot.projectional.cell.trait.specMatcher' call
    var spec_0 = Completion_getInstance().u9d_1;
    var specMatcher = ValueEditors$booleanProperty$o$get$lambda(spec_0, this.tag_1);
    // Inline function 'jetbrains.ocelot.projectional.cell.trait.getSpecValue' call
    var result = specMatcher(spec);
    var tmp;
    if (result == null) {
      tmp = protoOf(BaseDerivedCellTrait).n91.call(this, cell, spec);
    } else {
      tmp = result.o9n_1;
    }
    return tmp;
  };
  function toBoolean$ref() {
    var l = function (p0) {
      return toBoolean(p0);
    };
    l.callableName = 'toBoolean';
    return l;
  }
  function ValueEditors$booleanProperty$lambda(bool) {
    return '' + bool;
  }
  function ValueEditors$intProperty$safeToInt$ref() {
    var l = function (p0) {
      return intProperty$safeToInt(p0);
    };
    l.callableName = 'safeToInt';
    return l;
  }
  function ValueEditors$intProperty$lambda(int) {
    return '' + int;
  }
  function ValueEditors() {
  }
  protoOf(ValueEditors).uag = function (textCell, enumInfo) {
    var validatedProperty = getEnumValidatedProperty(this, textCell, enumInfo);
    var sToT = EnumInfo$safeValueOf$ref(enumInfo);
    var tToS = ValueEditors$nullableEnumProperty$lambda;
    return map_1(validatedProperty, sToT, tToS);
  };
  protoOf(ValueEditors).vag = function (textCell) {
    var trait = new ValueEditors$booleanProperty$trait$1(textCell);
    textCell.w92(trait);
    var textProp = textCell.o8w();
    var sToT = toBoolean$ref();
    var tToS = ValueEditors$booleanProperty$lambda;
    return map_1(textProp, sToT, tToS);
  };
  protoOf(ValueEditors).wag = function (textCell) {
    textCell.w92(TextEditing_getInstance().ta6(Validators_getInstance().x8t()));
    var textProp = textCell.o8w();
    var sToT = ValueEditors$intProperty$safeToInt$ref();
    var tToS = ValueEditors$intProperty$lambda;
    return map_1(textProp, sToT, tToS);
  };
  var ValueEditors_instance;
  function ValueEditors_getInstance() {
    return ValueEditors_instance;
  }
  function ViewCell() {
  }
  protoOf(ViewCell).gah = function () {
    return this.fah_1;
  };
  function ToCellMapping() {
  }
  function getMapperCellFinder(ctx) {
    return new getMapperCellFinder$1(ctx);
  }
  function getMapperCellFinder$1($ctx) {
    this.jah_1 = $ctx;
  }
  protoOf(getMapperCellFinder$1).kah = function (source) {
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.jah_1.f8a(source);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.m();
    while (_iterator__ex2g4s.n()) {
      var item = _iterator__ex2g4s.o();
      var tmp$ret$0 = item.f86_1;
      destination.j(tmp$ret$0);
    }
    // Inline function 'kotlin.collections.filterIsInstance' call
    // Inline function 'kotlin.collections.filterIsInstanceTo' call
    var destination_0 = ArrayList_init_$Create$();
    var _iterator__ex2g4s_0 = destination.m();
    while (_iterator__ex2g4s_0.n()) {
      var element = _iterator__ex2g4s_0.o();
      if (!(element == null) ? isInterface(element, Cell) : false) {
        destination_0.j(element);
      }
    }
    return destination_0;
  };
  protoOf(getMapperCellFinder$1).lah = function (source) {
    return this.kah(!(source == null) ? source : THROW_CCE());
  };
  function getCellProviderFromMapper(mapper) {
    var mappingContext = mapper.b88();
    if (!mappingContext.i8a(Companion_getInstance_131().h87_1)) {
      mappingContext.g8a(Companion_getInstance_131().h87_1, new ByTargetIndex(mappingContext));
    }
    return new MapperCellProvider(mapper);
  }
  function doGetCells($this, mapper, actualSource) {
    if (mapper.e86_1 === actualSource) {
      return listOf(mapper.f86_1);
    }
    // Inline function 'kotlin.collections.listOf' call
    var result = emptyList();
    var foundInMapper = findCellInContainer($this, mapper, actualSource);
    if (!(foundInMapper == null)) {
      result = listOf(foundInMapper);
    }
    var tmp = result;
    var tmp_0 = mapper.n89();
    return plus_7(tmp, filterNotNull_0(map(tmp_0, MapperCellProvider$Companion$doGetCells$lambda(actualSource))));
  }
  function getSource($this, container, target) {
    var tmp;
    if (isInterface(container, ToCellMapping)) {
      tmp = container.iah(target);
    } else {
      tmp = null;
    }
    return tmp;
  }
  function findCellInContainer($this, container, source) {
    var tmp;
    if (isInterface(container, ToCellMapping)) {
      tmp = container.hah(source);
    } else {
      tmp = null;
    }
    return tmp;
  }
  function MapperCellProvider$Companion$doGetCells$lambda($actualSource) {
    return function (sync) {
      return findCellInContainer(Companion_getInstance_197(), sync, $actualSource);
    };
  }
  function _get_mappingContext__5ixeqe($this) {
    return $this.mah_1.b88();
  }
  function doGetSource($this, mapper, actualTarget) {
    var tmp;
    if (mapper.f86_1 === actualTarget) {
      tmp = mapper.e86_1;
    } else {
      var tmp0_elvis_lhs = getSource(Companion_getInstance_197(), mapper, actualTarget);
      var tmp_0;
      if (tmp0_elvis_lhs == null) {
        var tmp_1 = mapper.n89();
        tmp_0 = firstOrNull_2(filterNotNull_0(map(tmp_1, MapperCellProvider$doGetSource$lambda(actualTarget))));
      } else {
        tmp_0 = tmp0_elvis_lhs;
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  function lookupCells($this, source, actualSource, parents) {
    var $this_0 = $this;
    var source_0 = source;
    var actualSource_0 = actualSource;
    var parents_0 = parents;
    $l$1: do {
      $l$0: do {
        var mappers = _get_mappingContext__5ixeqe($this_0).e8a($this_0.mah_1, source_0);
        var tmp;
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!mappers.s()) {
          // Inline function 'kotlin.collections.flatMap' call
          // Inline function 'kotlin.collections.flatMapTo' call
          var destination = ArrayList_init_$Create$();
          var _iterator__ex2g4s = mappers.m();
          while (_iterator__ex2g4s.n()) {
            var element = _iterator__ex2g4s.o();
            var tmp_0;
            var tmp_1 = element.f86_1;
            if (!(tmp_1 == null) ? isInterface(tmp_1, Cell) : false) {
              var cellMapper = element instanceof Mapper ? element : THROW_CCE();
              tmp_0 = doGetCells(Companion_getInstance_197(), cellMapper, actualSource_0);
            } else {
              tmp_0 = emptyList();
            }
            var list = tmp_0;
            addAll_1(destination, list);
          }
          var cells = destination;
          tmp = Companion_instance_146.p8t(cells);
        } else {
          if (parents_0.n()) {
            var tmp0 = $this_0;
            var tmp1 = ensureNotNull(parents_0.o());
            var tmp2 = actualSource_0;
            var tmp3 = parents_0;
            $this_0 = tmp0;
            source_0 = tmp1;
            actualSource_0 = tmp2;
            parents_0 = tmp3;
            continue $l$0;
          } else {
            tmp = emptyList();
          }
        }
        return tmp;
      }
       while (false);
    }
     while (true);
  }
  function Companion_197() {
    Companion_instance_197 = this;
    this.nah_1 = emptyList().m();
  }
  var Companion_instance_197;
  function Companion_getInstance_197() {
    if (Companion_instance_197 == null)
      new Companion_197();
    return Companion_instance_197;
  }
  function MapperCellProvider$doGetSource$lambda($actualTarget) {
    return function (sync) {
      return getSource(Companion_getInstance_197(), sync, $actualTarget);
    };
  }
  function MapperCellProvider(rootMapper) {
    Companion_getInstance_197();
    this.mah_1 = rootMapper;
  }
  protoOf(MapperCellProvider).oah = function (sourcePath) {
    var tmp;
    if (sourcePath.n()) {
      var actualSource = ensureNotNull(sourcePath.o());
      tmp = lookupCells(this, actualSource, actualSource, sourcePath);
    } else {
      tmp = emptyList();
    }
    return tmp;
  };
  protoOf(MapperCellProvider).kah = function (source) {
    return lookupCells(this, source, source, Companion_getInstance_197().nah_1);
  };
  protoOf(MapperCellProvider).lah = function (source) {
    return this.kah(!(source == null) ? source : THROW_CCE());
  };
  protoOf(MapperCellProvider).pah = function (cell, predicate) {
    var index = _get_mappingContext__5ixeqe(this).h8a(Companion_getInstance_131().h87_1);
    // Inline function 'jetbrains.ocelot.base.composite.dispatchByParent' call
    var current = cell;
    while (!(current == null)) {
      var $this$dispatchByParent = current;
      var mappers = index.q87($this$dispatchByParent);
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!mappers.s()) {
        var mapper = first_0(mappers);
        var source = doGetSource(this, mapper, cell);
        if (!(source == null) && predicate(source)) {
          return source;
        }
        var mapperSource = mapper.e86_1;
        if (predicate(mapperSource)) {
          return mapperSource;
        }
      }
      current = current.bp();
    }
    return null;
  };
  function updateFocused($this, newFocused) {
    $this.rah_1.zr();
    $this.rah_1 = HighlightUtil_instance.uah(newFocused);
  }
  function updatePaired($this, newPaired, focused) {
    $this.sah_1.zr();
    $this.sah_1 = HighlightUtil_instance.vah(newPaired).j2l(HighlightUtil_instance.uah(minus_3(newPaired, focused)));
    $this.qah_1 = newPaired;
  }
  function CellNavigationController$FocusedCellHandler$onEvent$lambda($newFocused, this$0, $newFocusedSet) {
    return function (it) {
      var newPaired = PairUtil_instance.wah($newFocused);
      var tmp;
      if (!equals(newPaired, this$0.qah_1)) {
        updatePaired(this$0, newPaired, $newFocusedSet);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CellNavigationController$Companion$NAVIGABLE$lambda(cell) {
    return cell.c93(TextEditing_getInstance().s99_1) && cell.k91(get_FOCUSABLE()) && isVisible_1(cell);
  }
  function CellNavigationController$Companion$EDITABLE$lambda(cell) {
    return cell.c93(TextEditing_getInstance().t99_1) && cell.k91(get_FOCUSABLE()) && isVisible_1(cell) && !cell.c93(Companion_getInstance_198().zah_1);
  }
  function install_0($this) {
    var result = new CompositeDisposable([]);
    var tmp = selectedCaretOffset($this);
    var tmp_0 = tmp.z2r(CellNavigationController$install$lambda($this));
    var tmp_1 = focusedCell($this);
    result.l2l([tmp_0, tmp_1.z2r(CellNavigationController$install$lambda_0($this))]);
    var tmp_2 = $this.dai_1.t42();
    result.l2l([tmp_2.w92(new CellNavigationController$install$5($this))]);
    var focusedCellHandler = new FocusedCellHandler();
    result.l2l([$this.dai_1.z92().y2r(focusedCellHandler)]);
    result.l2l([focusedCellHandler]);
    return result;
  }
  function focusedCell($this) {
    return $this.dai_1.z92();
  }
  function scrollTo_4($this, cell) {
    var parent = cell.bp();
    if (parent == null) {
      scrollTo_0(cell);
    } else {
      var delta = new Vector(10, 10);
      var bounds = new Rectangle(get_origin(cell).j8c(get_origin(parent).i8c(delta)), get_dimension(cell).i8c(delta.x26(2)));
      var target = new Rectangle(Companion_getInstance_136().h8c_1, get_dimension(parent));
      if (bounds.p8c(target)) {
        scrollTo_2(parent, bounds.q8c(target));
      } else {
        scrollTo_0(cell);
      }
    }
  }
  function root_0($this) {
    return $this.dai_1.t42();
  }
  function moveCaretTo($this, cell, offset) {
    return get_positionHandler(cell).la4().d2x(offset);
  }
  function moveToHome($this, next) {
    var tmp1_safe_receiver = next == null ? null : get_positionHandler(next);
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.ja4();
    }
  }
  function moveToEnd($this, next) {
    var tmp1_safe_receiver = next == null ? null : get_positionHandler(next);
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.ka4();
    }
  }
  function selectedXOffset($this) {
    return selectedCaretOffset($this).uv() + get_origin(ensureNotNull(focusedCell($this).uv())).d8c_1 | 0;
  }
  function selectedCaretOffset($this) {
    var focusedCell_0 = focusedCell($this);
    var selector = CellNavigationController$selectedCaretOffset$lambda;
    return select(focusedCell_0, 0, selector);
  }
  function handleKeyPress($this, cell, event) {
    var current = ensureNotNull(focusedCell($this).uv());
    var currentOffset = {_v: null};
    if (event.m8j(Key_UP_getInstance(), []) || event.m8j(Key_DOWN_getInstance(), []) || event.m8j(Key_PAGE_UP_getInstance(), []) || event.m8j(Key_PAGE_DOWN_getInstance(), [])) {
      currentOffset._v = $this.eai_1;
      if (currentOffset._v == null) {
        currentOffset._v = selectedXOffset($this);
      }
    }
    var cellContainer = ensureNotNull(current.s8x());
    var visibleRect = cellContainer.v93(cellContainer.t42());
    var next = null;
    var restoreOffset = false;
    if (event.m8j(Key_RIGHT_getInstance(), [])) {
      next = nextFocusable(current);
      moveToHome($this, next);
    } else if (event.o8j([KeyStrokeSpecs_getInstance().q8k_1])) {
      next = nextEditable($this, current);
    } else if (event.o8j([KeyStrokeSpecs_getInstance().r8k_1])) {
      next = nextEditable($this, current);
    } else if (event.m8j(Key_LEFT_getInstance(), [])) {
      next = prevFocusable(current);
      moveToEnd($this, next);
    } else if (event.o8j([KeyStrokeSpecs_getInstance().p8k_1])) {
      next = prevEditable($this, current);
    } else if (event.o8j([KeyStrokeSpecs_getInstance().s8k_1])) {
      next = prevEditable($this, current);
    } else if (event.m8j(Key_UP_getInstance(), [])) {
      next = upperClosest($this, current, ensureNotNull(currentOffset._v));
      if (!(next == null)) {
        restoreOffset = true;
      } else {
        next = homeElement_0($this, current);
      }
    } else if (event.m8j(Key_DOWN_getInstance(), [])) {
      next = lowerClosest($this, current, ensureNotNull(currentOffset._v));
      if (!(next == null)) {
        restoreOffset = true;
      } else {
        next = endElement_0($this, current);
      }
    } else if (event.m8j(Key_PAGE_UP_getInstance(), [])) {
      var pageUpDown = new CellNavigationController$handleKeyPress$pageUpDown$1(current, currentOffset, visibleRect, $this);
      next = pageUpDown.u3a();
      restoreOffset = true;
    } else if (event.m8j(Key_PAGE_DOWN_getInstance(), [])) {
      var pageUpDown_0 = new CellNavigationController$handleKeyPress$pageUpDown$2(current, currentOffset, visibleRect, $this);
      next = pageUpDown_0.u3a();
      restoreOffset = true;
    } else if (event.o8j([KeyStrokeSpecs_getInstance().l8k_1])) {
      next = homeElement_0($this, current);
    } else if (event.o8j([KeyStrokeSpecs_getInstance().m8k_1])) {
      next = endElement_0($this, current);
    } else if (event.o8j([KeyStrokeSpecs_getInstance().n8k_1])) {
      next = firstFocusable_0(cell, true);
      moveToHome($this, next);
    } else if (event.o8j([KeyStrokeSpecs_getInstance().o8k_1])) {
      next = lastFocusable_0(cell, true);
      moveToEnd($this, next);
    } else if (event.o8j([KeyStrokeSpecs_getInstance().e8l_1])) {
      if (increaseSelection($this, current)) {
        event.n8i();
        return Unit_instance;
      }
    } else if (event.o8j([KeyStrokeSpecs_getInstance().f8l_1])) {
      if (decreaseSelection($this)) {
        event.n8i();
        return Unit_instance;
      }
      next = firstFocusable_0(current, false);
    } else if (event.o8j([KeyStrokeSpecs_getInstance().j8l_1]) && !(current.c93(Companion_getInstance_198().xah_1) == null)) {
      next = ensureNotNull(current.c93(Companion_getInstance_198().xah_1));
      if (Composites_instance.h36(next, current)) {
        moveToHome($this, next);
      } else {
        moveToEnd($this, next);
      }
      restoreOffset = false;
    }
    if (!(next == null)) {
      focusedCell($this).d2x(next);
      if (restoreOffset) {
        moveCaretTo($this, next, ensureNotNull(currentOffset._v) - get_origin(next).d8c_1 | 0);
        $this.eai_1 = currentOffset._v;
      }
      if (next instanceof TextCell) {
        CellScrolling_getInstance().ya6(next, event);
      } else {
        scrollTo_4($this, next);
      }
      event.n8i();
    }
  }
  function prevEditable($this, current) {
    var tmp;
    if (get_positionHandler(current).x96()) {
      // Inline function 'jetbrains.ocelot.base.composite.Composites.prevNavOrder' call
      var p = Companion_getInstance_198().cai_1;
      // Inline function 'kotlin.sequences.find' call
      var tmp0 = Composites_instance.g36(current);
      var tmp$ret$1;
      $l$block: {
        // Inline function 'kotlin.sequences.firstOrNull' call
        var _iterator__ex2g4s = tmp0.m();
        while (_iterator__ex2g4s.n()) {
          var element = _iterator__ex2g4s.o();
          if (p(element)) {
            tmp$ret$1 = element;
            break $l$block;
          }
        }
        tmp$ret$1 = null;
      }
      tmp = tmp$ret$1;
    } else {
      tmp = current;
    }
    var next = tmp;
    moveToHome($this, next);
    return next;
  }
  function nextEditable($this, current) {
    // Inline function 'jetbrains.ocelot.base.composite.Composites.nextNavOrder' call
    var p = Companion_getInstance_198().cai_1;
    // Inline function 'kotlin.sequences.find' call
    var tmp0 = Composites_instance.f36(current);
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.sequences.firstOrNull' call
      var _iterator__ex2g4s = tmp0.m();
      while (_iterator__ex2g4s.n()) {
        var element = _iterator__ex2g4s.o();
        if (p(element)) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    var next = tmp$ret$1;
    if (!(next == null)) {
      moveToHome($this, next);
    } else if (!get_positionHandler(current).v96()) {
      next = current;
      moveToEnd($this, next);
    }
    return next;
  }
  function endElement_0($this, current) {
    var next = endElement(current, 2);
    moveToEnd($this, next);
    return next;
  }
  function homeElement_0($this, current) {
    var next = homeElement(current, 2);
    moveToHome($this, next);
    return next;
  }
  function upperClosest($this, cell, offset) {
    var upDown = new CellNavigationController$upperClosest$upDown$1();
    return upDown.lai(cell, offset);
  }
  function increaseSelection($this, current) {
    if ($this.gai_1.s()) {
      var tmp0_elvis_lhs = getCurrentScope($this, current);
      var tmp;
      if (tmp0_elvis_lhs == null) {
        return false;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var currentScope = tmp;
      $this.gai_1.of(currentScope);
    }
    var next = $this.gai_1.mf().nad();
    while (!(next == null)) {
      if (!next.x9a()) {
        selectScope($this, next);
        $this.gai_1.of(next);
        return true;
      }
      next = next.nad();
    }
    return false;
  }
  function getCurrentScope($this, current) {
    var scope = current.c93(CellScopes_getInstance().rad_1);
    while (!(scope == null)) {
      var nextScope = scope.nad();
      if (nextScope == null || !nextScope.x9a()) {
        return scope;
      }
      scope = nextScope;
    }
    return null;
  }
  function decreaseSelection($this) {
    if ($this.gai_1.s()) {
      return false;
    }
    $this.gai_1.qf();
    while (!$this.gai_1.s()) {
      var scope = $this.gai_1.nf();
      if (ensureNotNull(scope).p38()) {
        selectScope($this, scope);
        return true;
      }
      $this.gai_1.qf();
    }
    return false;
  }
  function selectScope($this, scope) {
    try {
      $this.fai_1 = false;
      $this.dai_1.z92().d2x(null);
      scope.lad();
    }finally {
      $this.fai_1 = true;
    }
  }
  function lowerClosest($this, cell, offset) {
    var upDown = new CellNavigationController$lowerClosest$upDown$1();
    return upDown.lai(cell, offset);
  }
  function handleMousePress($this, event) {
    if (!event.t8l_1.equals(MouseButton_LEFT_getInstance()))
      return Unit_instance;
    var closest = findFocusableAt($this, event.z8l());
    if (closest == null || !Companion_getInstance_198().bai_1(closest)) {
      closest = Cells_getInstance().eaa(root_0($this), event.z8l(), Companion_getInstance_198().bai_1);
    }
    if (!(closest == null)) {
      var navigationEvent = new FocusEvent(focusedCell($this).uv(), closest);
      focusedCell($this).d2x(closest);
      if (event.x8l_1 < get_origin(closest).d8c_1) {
        moveToHome($this, closest);
      } else {
        moveToEnd($this, closest);
      }
      event.n8i();
      closest.u92(navigationEvent, Cells_getInstance().f9t_1);
    }
  }
  function findFocusableAt($this, loc) {
    var cell = $this.dai_1.u93(root_0($this), loc);
    var tmp;
    if (isTrivial($this, cell) || !ensureNotNull(cell).p92().uv()) {
      tmp = null;
    } else {
      tmp = cell;
    }
    return tmp;
  }
  function isTrivial($this, cell) {
    return cell == null || cell === root_0($this);
  }
  function FocusedCellHandler() {
    var tmp = this;
    // Inline function 'kotlin.collections.setOf' call
    tmp.qah_1 = emptySet();
    this.rah_1 = Companion_getInstance_29().m2l_1;
    this.sah_1 = Companion_getInstance_29().m2l_1;
    this.tah_1 = Companion_getInstance_29().m2l_1;
  }
  protoOf(FocusedCellHandler).ha3 = function (event) {
    var oldFocused = event.s2y_1;
    if (!(oldFocused == null)) {
      // Inline function 'kotlin.collections.setOf' call
      var tmp$ret$0 = emptySet();
      updateFocused(this, tmp$ret$0);
      // Inline function 'kotlin.collections.setOf' call
      var tmp = emptySet();
      // Inline function 'kotlin.collections.setOf' call
      var tmp$ret$2 = emptySet();
      updatePaired(this, tmp, tmp$ret$2);
      this.tah_1.zr();
      this.tah_1 = Companion_getInstance_29().m2l_1;
    }
    var newFocused = event.t2y_1;
    if (!(newFocused == null)) {
      var newFocusedSet = setOf(newFocused);
      updateFocused(this, newFocusedSet);
      updatePaired(this, PairUtil_instance.wah(newFocused), newFocusedSet);
      if (newFocused instanceof TextCell) {
        var tmp_0 = this;
        var tmp_1 = newFocused.t96();
        tmp_0.tah_1 = tmp_1.z2r(CellNavigationController$FocusedCellHandler$onEvent$lambda(newFocused, this, newFocusedSet));
      }
    }
  };
  protoOf(FocusedCellHandler).n2s = function (event) {
    return this.ha3(event instanceof PropertyChangeEvent ? event : THROW_CCE());
  };
  protoOf(FocusedCellHandler).zr = function () {
    this.rah_1.zr();
    this.sah_1.zr();
    this.tah_1.zr();
  };
  function PageUpDown(cell, offset, pageHeight) {
    this.hai_1 = cell;
    this.iai_1 = offset;
    this.jai_1 = pageHeight;
  }
  protoOf(PageUpDown).u3a = function () {
    var current = this.hai_1;
    while (true) {
      var next = this.mai(current, this.iai_1);
      if (next == null) {
        var tmp;
        if (next === this.hai_1) {
          tmp = null;
        } else {
          tmp = current;
        }
        return tmp;
      }
      if (get_bounds(this.hai_1).s8c(get_origin(next)) >= this.jai_1) {
        return next;
      }
      current = next;
    }
  };
  function Companion_198() {
    Companion_instance_198 = this;
    this.xah_1 = CellTraitPropertySpec_init_$Create$('pairCell', null);
    this.yah_1 = CellPropertySpec_init_$Create$('showFocusHighlight', false);
    this.zah_1 = CellTraitPropertySpec_init_$Create$('space', false);
    this.aai_1 = 2;
    var tmp = this;
    tmp.bai_1 = CellNavigationController$Companion$NAVIGABLE$lambda;
    var tmp_0 = this;
    tmp_0.cai_1 = CellNavigationController$Companion$EDITABLE$lambda;
  }
  protoOf(Companion_198).nai = function (container) {
    var controller = new CellNavigationController(container);
    return install_0(controller);
  };
  var Companion_instance_198;
  function Companion_getInstance_198() {
    if (Companion_instance_198 == null)
      new Companion_198();
    return Companion_instance_198;
  }
  function CellNavigationController$install$lambda(this$0) {
    return function (it) {
      this$0.eai_1 = null;
      return Unit_instance;
    };
  }
  function CellNavigationController$install$lambda_0(this$0) {
    return function (it) {
      var tmp;
      if (this$0.fai_1) {
        this$0.gai_1.k2();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CellNavigationController$install$5(this$0) {
    this.oai_1 = this$0;
    CellTrait.call(this);
  }
  protoOf(CellNavigationController$install$5).s8z = function (cell, event) {
    handleKeyPress(this.oai_1, cell, event);
    if (!event.l8i_1) {
      protoOf(CellTrait).s8z.call(this, cell, event);
    }
  };
  protoOf(CellNavigationController$install$5).t91 = function (cell, event) {
    handleMousePress(this.oai_1, event);
    if (!event.l8i_1) {
      protoOf(CellTrait).t91.call(this, cell, event);
    }
  };
  function CellNavigationController$selectedCaretOffset$lambda(cell) {
    var positionHandler = get_positionHandler(cell);
    return positionHandler.la4();
  }
  function CellNavigationController$handleKeyPress$pageUpDown$1($current, $currentOffset, $visibleRect, this$0) {
    this.sai_1 = this$0;
    PageUpDown.call(this, $current, ensureNotNull($currentOffset._v), $visibleRect.c8c_1.e8c_1);
  }
  protoOf(CellNavigationController$handleKeyPress$pageUpDown$1).mai = function (current, offset) {
    return upperClosest(this.sai_1, current, offset);
  };
  function CellNavigationController$handleKeyPress$pageUpDown$2($current, $currentOffset, $visibleRect, this$0) {
    this.wai_1 = this$0;
    PageUpDown.call(this, $current, ensureNotNull($currentOffset._v), $visibleRect.c8c_1.e8c_1);
  }
  protoOf(CellNavigationController$handleKeyPress$pageUpDown$2).mai = function (current, offset) {
    return lowerClosest(this.wai_1, current, offset);
  };
  function CellNavigationController$upperClosest$upDown$1() {
    UpDown.call(this);
  }
  protoOf(CellNavigationController$upperClosest$upDown$1).yai = function (cell) {
    return cell.s35();
  };
  protoOf(CellNavigationController$upperClosest$upDown$1).zai = function (cell, within) {
    return Composites_instance.b36(cell, within);
  };
  protoOf(CellNavigationController$upperClosest$upDown$1).aaj = function (within) {
    return Composites_instance.t35(within);
  };
  function CellNavigationController$lowerClosest$upDown$1() {
    UpDown.call(this);
  }
  protoOf(CellNavigationController$lowerClosest$upDown$1).yai = function (cell) {
    return cell.p35();
  };
  protoOf(CellNavigationController$lowerClosest$upDown$1).zai = function (cell, within) {
    return Composites_instance.a36(cell, within);
  };
  protoOf(CellNavigationController$lowerClosest$upDown$1).aaj = function (within) {
    return Composites_instance.q35(within);
  };
  function CellNavigationController(cellContainer) {
    Companion_getInstance_198();
    this.dai_1 = cellContainer;
    this.eai_1 = null;
    this.fai_1 = true;
    this.gai_1 = ArrayDeque_init_$Create$();
  }
  function highlightFocused($this, cell) {
    setFocusHighlighted($this, cell, true);
    var tmp = cell.n92(Companion_getInstance_198().yah_1);
    var showFocusHighlightHandler = tmp.z2r(HighlightUtil$highlightFocused$lambda(cell));
    // Inline function 'jetbrains.ocelot.base.disposable.toDisposable' call
    var disposeHandler = new HighlightUtil$highlightFocused$$inlined$toDisposable$1(cell);
    return showFocusHighlightHandler.j2l(disposeHandler);
  }
  function setFocusHighlighted($this, cell, value) {
    var showFocusHighlight = cell.k91(Companion_getInstance_198().yah_1);
    var tmp;
    if (showFocusHighlight) {
      tmp = value;
    } else {
      tmp = false;
    }
    var newValue = tmp;
    cell.o92().d2x(newValue);
  }
  function HighlightUtil$highlightFocused$lambda($cell) {
    return function (it) {
      setFocusHighlighted(HighlightUtil_instance, $cell, true);
      return Unit_instance;
    };
  }
  function HighlightUtil$highlightFocused$$inlined$toDisposable$1($cell) {
    this.caj_1 = $cell;
  }
  protoOf(HighlightUtil$highlightFocused$$inlined$toDisposable$1).zr = function () {
    setFocusHighlighted(HighlightUtil_instance, this.caj_1, false);
    return Unit_instance;
  };
  function HighlightUtil() {
  }
  protoOf(HighlightUtil).uah = function (cells) {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(cells, 10));
    var _iterator__ex2g4s = cells.m();
    while (_iterator__ex2g4s.n()) {
      var item = _iterator__ex2g4s.o();
      var tmp$ret$0 = highlightFocused(this, item);
      destination.j(tmp$ret$0);
    }
    var list = destination;
    return toDisposable(list);
  };
  protoOf(HighlightUtil).vah = function (paired) {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(paired, 10));
    var _iterator__ex2g4s = paired.m();
    while (_iterator__ex2g4s.n()) {
      var item = _iterator__ex2g4s.o();
      var tmp$ret$0 = item.i90(get_PAIR_HIGHLIGHTED(), true);
      destination.j(tmp$ret$0);
    }
    var list = destination;
    return toDisposable(list);
  };
  var HighlightUtil_instance;
  function HighlightUtil_getInstance() {
    return HighlightUtil_instance;
  }
  function closingFor(_this__u8e3s4, opening) {
    MatchingConstructs_instance.daj(opening, _this__u8e3s4);
    return _this__u8e3s4;
  }
  function pairOneWay($this, c1, c2) {
    c1.g93(Companion_getInstance_198().xah_1, c2);
  }
  function MatchingConstructs() {
  }
  protoOf(MatchingConstructs).daj = function (c1, c2) {
    pairOneWay(this, c1, c2);
    pairOneWay(this, c2, c1);
  };
  var MatchingConstructs_instance;
  function MatchingConstructs_getInstance() {
    return MatchingConstructs_instance;
  }
  function getPaired($this, focused, getSibling, inOrder) {
    var cell = getSibling(focused);
    $l$loop_0: while (!(cell == null)) {
      if (!cell.m92().uv()) {
        cell = getSibling(cell);
        continue $l$loop_0;
      }
      var pair = cell.c93(Companion_getInstance_198().xah_1);
      if (!(pair == null) && inOrder(cell, pair)) {
        return setOf_0([cell, pair]);
      }
      if (!get_positionHandler(cell).ia4()) {
        break $l$loop_0;
      }
      cell = getSibling(cell);
    }
    // Inline function 'kotlin.collections.setOf' call
    return emptySet();
  }
  function PairUtil$getPaired$lambda(cell) {
    return cell.p35();
  }
  function PairUtil$getPaired$lambda_0(next, pair) {
    return Composites_instance.h36(next, pair);
  }
  function PairUtil$getPaired$lambda_1(cell) {
    return cell.s35();
  }
  function PairUtil$getPaired$lambda_2(prev, pair) {
    return Composites_instance.h36(pair, prev);
  }
  function PairUtil() {
  }
  protoOf(PairUtil).wah = function (focusedCell) {
    var focusedPair = focusedCell.c93(Companion_getInstance_198().xah_1);
    if (!(focusedPair == null)) {
      return setOf_0([focusedCell, focusedPair]);
    }
    if (get_positionHandler(focusedCell).ha4()) {
      var tmp = PairUtil$getPaired$lambda;
      var pairedAhead = getPaired(this, focusedCell, tmp, PairUtil$getPaired$lambda_0);
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!pairedAhead.s()) {
        return pairedAhead;
      }
    }
    var tmp_0;
    if (get_positionHandler(focusedCell).ga4()) {
      var tmp_1 = PairUtil$getPaired$lambda_1;
      tmp_0 = getPaired(this, focusedCell, tmp_1, PairUtil$getPaired$lambda_2);
    } else {
      // Inline function 'kotlin.collections.setOf' call
      tmp_0 = emptySet();
    }
    return tmp_0;
  };
  var PairUtil_instance;
  function PairUtil_getInstance() {
    return PairUtil_instance;
  }
  function closest($this, candidates, offset) {
    if (candidates.s()) {
      return null;
    }
    var distance = UpDown$closest$lambda(candidates, offset);
    var tmp;
    if (candidates.p() >= 10) {
      tmp = Companion_instance_199.faj(candidates, offset);
    } else {
      tmp = candidates.p() / 2 | 0;
    }
    var currentIndex = tmp;
    var currentDistance = distance(currentIndex);
    $l$loop_0: while (true) {
      var leftDistance = 2147483647;
      if (currentIndex > 0) {
        leftDistance = distance(currentIndex - 1 | 0);
      }
      var rightDistance = 2147483647;
      if (currentIndex < (candidates.p() - 1 | 0)) {
        rightDistance = distance(currentIndex + 1 | 0);
      }
      if (leftDistance < currentDistance && leftDistance < rightDistance) {
        currentIndex = currentIndex - 1 | 0;
        currentDistance = leftDistance;
        continue $l$loop_0;
      }
      if (rightDistance < currentDistance && rightDistance < leftDistance) {
        currentIndex = currentIndex + 1 | 0;
        currentDistance = rightDistance;
        continue $l$loop_0;
      }
      break $l$loop_0;
    }
    return candidates.r(currentIndex);
  }
  function advanceLine($this, cell) {
    var current = cell;
    do {
      var parent = ensureNotNull(current).bp();
      var tmp;
      if (get_isRootCell(parent)) {
        tmp = true;
      } else {
        tmp = parent instanceof VerticalCell;
      }
      if (tmp) {
        var list = advanceLineWithin($this, cell, current);
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!list.s()) {
          return list;
        }
        var sibling = $this.yai(current);
        while (!(sibling == null)) {
          list = getLineAtBorder($this, sibling);
          // Inline function 'kotlin.collections.isNotEmpty' call
          if (!list.s()) {
            return list;
          }
          sibling = $this.yai(sibling);
        }
      }
      current = parent;
    }
     while (!(current == null));
    return emptyList();
  }
  function advanceLineWithin($this, current, within) {
    if (current === within) {
      return emptyList();
    }
    var tmp0_elvis_lhs = findNewline($this, current, within);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return emptyList();
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var newline = tmp;
    return getLineAfterNewline($this, newline, within);
  }
  function findNewline($this, from, within) {
    var cell = $this.zai(from, within);
    $l$loop: while (!(cell == null)) {
      if (!isVisible_2($this, cell)) {
        cell = $this.zai(cell, within);
        continue $l$loop;
      }
      if (cell instanceof NewLineCell) {
        return cell;
      }
      cell = $this.zai(cell, within);
    }
    return null;
  }
  function getLineAfterNewline($this, newline, within) {
    var from = $this.zai(newline, within);
    return getLine($this, from, within);
  }
  function getLineAtBorder($this, within) {
    var from = $this.aaj(within);
    return getLine($this, from, within);
  }
  function getLine($this, from, within) {
    var line = ArrayList_init_$Create$();
    var currentWithin = within;
    var cell = from;
    $l$loop_0: while (!(cell == null)) {
      if (!isVisible_2($this, cell)) {
        cell = cell === currentWithin ? null : $this.zai(cell, currentWithin);
        continue $l$loop_0;
      }
      var tmp;
      if (cell instanceof NewLineCell) {
        tmp = !line.s();
      } else {
        tmp = false;
      }
      if (tmp) {
        break $l$loop_0;
      }
      if (cell.p92().uv()) {
        line.j(cell);
        if (line.p() === 1) {
          var newWithin = findClosestVerticalChild($this, cell, currentWithin);
          if (!(newWithin == null)) {
            currentWithin = newWithin;
          }
        }
      }
      cell = cell === currentWithin ? null : $this.zai(cell, currentWithin);
    }
    return line;
  }
  function findClosestVerticalChild($this, from, within) {
    var cell = from;
    while (!(cell === within)) {
      var tmp0 = cell;
      $l$block: {
        // Inline function 'kotlin.checkNotNull' call
        if (tmp0 == null) {
          var message = toString_1(within) + ' does not enclose ' + toString_0(from);
          throw IllegalStateException_init_$Create$_0(toString_1(message));
        } else {
          break $l$block;
        }
      }
      var tmp = cell.bp();
      if (tmp instanceof VerticalCell) {
        return cell;
      }
      cell = cell.bp();
    }
    return null;
  }
  function isVisible_2($this, cell) {
    // Inline function 'kotlin.collections.getOrPut' call
    var this_0 = $this.kai_1;
    var value = this_0.q2(cell);
    var tmp;
    if (value == null) {
      var answer = getVisible($this, cell);
      this_0.t2(cell, answer);
      tmp = answer;
    } else {
      tmp = value;
    }
    return tmp;
  }
  function getVisible($this, cell) {
    var tmp0 = ancestorsFrom(cell);
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.sequences.all' call
      var _iterator__ex2g4s = tmp0.m();
      while (_iterator__ex2g4s.n()) {
        var element = _iterator__ex2g4s.o();
        if (!element.m92().uv()) {
          tmp$ret$1 = false;
          break $l$block;
        }
      }
      tmp$ret$1 = true;
    }
    return tmp$ret$1;
  }
  function Companion_199() {
    this.eaj_1 = 10;
  }
  protoOf(Companion_199).faj = function (cells, offset) {
    // Inline function 'kotlin.collections.isNotEmpty' call
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.require' call
    if (!!cells.s()) {
      var message = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    var left = get_origin(cells.r(0)).d8c_1;
    var rightBounds = get_bounds(last(cells));
    var right = rightBounds.b8c_1.d8c_1 + rightBounds.c8c_1.d8c_1 | 0;
    var tmp;
    if (left === right) {
      tmp = 0;
    } else {
      var index = imul(offset - left | 0, cells.p()) / (right - left | 0) | 0;
      tmp = index < 0 ? 0 : index > get_lastIndex_2(cells) ? get_lastIndex_2(cells) : index;
    }
    return tmp;
  };
  var Companion_instance_199;
  function Companion_getInstance_199() {
    return Companion_instance_199;
  }
  function UpDown$closest$lambda($candidates, $offset) {
    return function (index) {
      return get_positionHandler($candidates.r(index)).ma4($offset);
    };
  }
  function UpDown() {
    this.kai_1 = HashMap_init_$Create$();
  }
  protoOf(UpDown).lai = function (cell, offset) {
    return closest(this, advanceLine(this, cell), offset);
  };
  function RootController() {
  }
  protoOf(RootController).nai = function (container) {
    return Companion_getInstance_198().nai(container).j2l(MessageController_getInstance().l9z(container));
  };
  var RootController_instance;
  function RootController_getInstance() {
    return RootController_instance;
  }
  function InstallRootResult(cellContainer, installDisposable) {
    this.gaj_1 = cellContainer;
    this.haj_1 = installDisposable;
  }
  function installRoot(cellContainer, targetCell) {
    cellContainer.t42().q92().j(targetCell);
    return installRoot_0(cellContainer);
  }
  function installRoot_0(cellContainer) {
    cellContainer = cellContainer === VOID ? CellContainer() : cellContainer;
    var disposable = RootController_instance.nai(cellContainer);
    return new InstallRootResult(cellContainer, disposable);
  }
  function installRootFromMapper(mapper, cellContainer) {
    cellContainer = cellContainer === VOID ? CellContainer() : cellContainer;
    mapper.j89();
    return installRoot(cellContainer, mapper.f86_1);
  }
  function BaseProjectionalSynchronizer$CopyPasteTrait$pastePostProcess$slambda$lambda($update) {
    return function () {
      var tmp;
      if ($update.p38()) {
        $update.q38();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function pastePostProcess($this, items) {
    var tmp0_safe_receiver = $this.gak_1.zaj_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      launch_0($this.gak_1.iaj_1, VOID, VOID, BaseProjectionalSynchronizer$CopyPasteTrait$pastePostProcess$slambda_0(items, tmp0_safe_receiver, $this.gak_1, null));
    }
  }
  function BaseProjectionalSynchronizer$CopyPasteTrait$pastePostProcess$slambda($items, $handler, this$0, resultContinuation) {
    this.pak_1 = $items;
    this.qak_1 = $handler;
    this.rak_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(BaseProjectionalSynchronizer$CopyPasteTrait$pastePostProcess$slambda).e1h = function ($this$launch, $completion) {
    var tmp = this.f1h($this$launch, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(BaseProjectionalSynchronizer$CopyPasteTrait$pastePostProcess$slambda).v9 = function (p1, $completion) {
    return this.e1h((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(BaseProjectionalSynchronizer$CopyPasteTrait$pastePostProcess$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 6;
            this.uak_1 = this.pak_1.m();
            this.f9_1 = 1;
            continue $sm;
          case 1:
            if (!this.uak_1.n()) {
              this.f9_1 = 5;
              continue $sm;
            }

            var element = this.uak_1.o();
            this.tak_1 = this.qak_1.vak(element);
            this.g9_1 = 4;
            this.f9_1 = 2;
            suspendResult = this.tak_1.n38(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var update = suspendResult;
            var tmp0_safe_receiver = this.rak_1.iaj_1.s8x();
            var tmp_0;
            if (tmp0_safe_receiver == null) {
              tmp_0 = null;
            } else {
              tmp0_safe_receiver.d9m(BaseProjectionalSynchronizer$CopyPasteTrait$pastePostProcess$slambda$lambda(update));
              tmp_0 = Unit_instance;
            }

            if (tmp_0 == null) {
              this.tak_1.zr();
            }

            this.g9_1 = 6;
            this.f9_1 = 3;
            continue $sm;
          case 3:
            this.g9_1 = 6;
            this.f9_1 = 1;
            continue $sm;
          case 4:
            this.g9_1 = 6;
            var tmp_1 = this.i9_1;
            if (tmp_1 instanceof CancellationException) {
              var e = this.i9_1;
              this.tak_1.zr();
              throw e;
            } else {
              throw this.i9_1;
            }

          case 5:
            return Unit_instance;
          case 6:
            throw this.i9_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.g9_1 === 6) {
          throw e_0;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(BaseProjectionalSynchronizer$CopyPasteTrait$pastePostProcess$slambda).f1h = function ($this$launch, completion) {
    var i = new BaseProjectionalSynchronizer$CopyPasteTrait$pastePostProcess$slambda(this.pak_1, this.qak_1, this.rak_1, completion);
    i.sak_1 = $this$launch;
    return i;
  };
  function BaseProjectionalSynchronizer$CopyPasteTrait$pastePostProcess$slambda_0($items, $handler, this$0, resultContinuation) {
    var i = new BaseProjectionalSynchronizer$CopyPasteTrait$pastePostProcess$slambda($items, $handler, this$0, resultContinuation);
    var l = function ($this$launch, $completion) {
      return i.e1h($this$launch, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function isEmpty$ref() {
    var l = function (p0) {
      // Inline function 'kotlin.text.isEmpty' call
      return charSequenceLength(p0) === 0;
    };
    l.callableName = 'isEmpty';
    return l;
  }
  function BaseProjectionalSynchronizer$TargetCellList$getPlaceholderTrait$trait$1$get$matchers$1(this$0) {
    this.wak_1 = this$0;
  }
  protoOf(BaseProjectionalSynchronizer$TargetCellList$getPlaceholderTrait$trait$1$get$matchers$1).xak = function (target) {
    return insertItem(this.wak_1, target);
  };
  protoOf(BaseProjectionalSynchronizer$TargetCellList$getPlaceholderTrait$trait$1$get$matchers$1).yak = function (target) {
    return this.xak(!(target == null) ? target : THROW_CCE());
  };
  function BaseProjectionalSynchronizer$TargetCellList$getPlaceholderTrait$o$get$lambda($spec, this$0) {
    return function (inputSpec) {
      var tmp;
      if (inputSpec === $spec) {
        var role = new BaseProjectionalSynchronizer$TargetCellList$getPlaceholderTrait$trait$1$get$matchers$1(this$0);
        var tmp$ret$0 = this$0.zak(role);
        tmp = new SpecMatchResult(tmp$ret$0);
      } else {
        tmp = null;
      }
      return tmp;
    };
  }
  function BaseProjectionalSynchronizer$TargetCellList$getPlaceholderTrait$o$get$lambda_0($spec) {
    return function (matcher) {
      return matcher($spec);
    };
  }
  function addPlaceholderIfEnabled($this) {
    if ($this.cal_1.vaj_1) {
      $this.bal_1 = true;
      $this.cal_1.jaj_1.j(createPlaceholder($this));
    }
  }
  function createPlaceholder($this) {
    var mainCell = TextCell_init_$Create$();
    mainCell.p92().d2x(true);
    mainCell.w92(getPlaceholderTrait($this));
    var tmp0_elvis_lhs = $this.cal_1.oaj_1;
    var placeholderCell = placeholder_0(mainCell, tmp0_elvis_lhs == null ? '<empty>' : tmp0_elvis_lhs);
    var tmp1_safe_receiver = _get_placeholderVisibleCellTraitFactory__gdwcuq($this.cal_1)();
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      placeholderCell.w92(tmp1_safe_receiver);
    }
    var tmp;
    var tmp_0 = $this.cal_1.iaj_1;
    if (tmp_0 instanceof IndentCell) {
      tmp = CellFactory_instance.pa9([mainCell, placeholderCell]);
    } else {
      tmp = CellFactory_instance.na9([mainCell, placeholderCell]);
    }
    var result = tmp;
    result.g93(Companion_getInstance_181().qa4_1, get_positionHandler(mainCell));
    return result;
  }
  function getPlaceholderTrait($this) {
    var trait = new BaseProjectionalSynchronizer$TargetCellList$getPlaceholderTrait$trait$1($this.cal_1);
    return _get_placeholderCaretCellTraitFactory__i2cbur($this.cal_1)(trait);
  }
  function BaseProjectionalSynchronizer$TargetCellList$getPlaceholderTrait$trait$1(this$0) {
    this.eal_1 = this$0;
    var tmp = TextEditing_getInstance();
    BaseDerivedCellTrait.call(this, tmp.ta6(isEmpty$ref()));
  }
  protoOf(BaseProjectionalSynchronizer$TargetCellList$getPlaceholderTrait$trait$1).v8z = function (cell, event) {
    handlePlaceholderKeyPress(this.eal_1, event);
    if (!event.l8i_1) {
      protoOf(BaseDerivedCellTrait).v8z.call(this, cell, event);
    }
  };
  protoOf(BaseProjectionalSynchronizer$TargetCellList$getPlaceholderTrait$trait$1).n91 = function (cell, spec) {
    // Inline function 'jetbrains.ocelot.projectional.cell.trait.specMatcher' call
    var spec_0 = Completion_getInstance().u9d_1;
    var tmp$ret$0 = BaseProjectionalSynchronizer$TargetCellList$getPlaceholderTrait$o$get$lambda(spec_0, this.eal_1);
    var matchers = listOf_0([tmp$ret$0, specMatcherValue(TextEditing_getInstance().c9a_1, this.eal_1.bak_1)]);
    // Inline function 'jetbrains.ocelot.projectional.cell.trait.getSpecValue' call
    var tmp = asSequence_0(matchers);
    var result = firstOrNull_2(filterNotNull_0(map(tmp, BaseProjectionalSynchronizer$TargetCellList$getPlaceholderTrait$o$get$lambda_0(spec))));
    var tmp_0;
    if (result == null) {
      tmp_0 = protoOf(BaseDerivedCellTrait).n91.call(this, cell, spec);
    } else {
      tmp_0 = result.o9n_1;
    }
    return tmp_0;
  };
  function BaseProjectionalSynchronizer$SelectionCaptureTrait$_init_$lambda_74dg8i($support) {
    return function (it) {
      return $support;
    };
  }
  function _get_placeholderCaretCellTraitFactory__i2cbur($this) {
    var tmp = $this.paj_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('placeholderCaretCellTraitFactory');
    }
  }
  function _get_placeholderVisibleCellTraitFactory__gdwcuq($this) {
    var tmp = $this.qaj_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('placeholderVisibleCellTraitFactory');
    }
  }
  function _get_deleteHandler__p8aq26($this) {
    var tmp = $this.raj_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('deleteHandler');
    }
  }
  function _get_roleSynchronizerSelectionSupport__orr8w($this) {
    var tmp = $this.uaj_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('roleSynchronizerSelectionSupport');
    }
  }
  function _get_context__ps0bpe_0($this) {
    var tmp = $this.cak_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('context');
    }
  }
  function insertItem($this, item) {
    return $this.fal(listOf(item));
  }
  function isDeleteEvent($this, event) {
    return event.o8j([KeyStrokeSpecs_getInstance().h8l_1]) || event.m8j(Key_BACKSPACE_getInstance(), []) || event.m8j(Key_DELETE_getInstance(), []);
  }
  function handlePlaceholderKeyPress($this, event) {
    if ($this.hal(event) && $this.ial()) {
      insertItem($this, $this.gal())();
      event.n8i();
    }
    if (isDeleteEvent($this, event) && _get_deleteHandler__p8aq26($this).kal()) {
      _get_deleteHandler__p8aq26($this).jal()();
      event.n8i();
    }
  }
  function CopyPasteTrait_0($outer) {
    this.gak_1 = $outer;
    RoleSynchronizerCopyPasteTrait.call(this, $outer.yaj_1, _get_roleSynchronizerSelectionSupport__orr8w($outer));
  }
  protoOf(CopyPasteTrait_0).lal = function (items, cause, result) {
    this.gak_1.mal(items, cause, result);
  };
  protoOf(CopyPasteTrait_0).nal = function (items) {
    this.gak_1.fal(items)();
    pastePostProcess(this, items);
  };
  function TargetCellTrait($outer) {
    this.wal_1 = $outer;
    BaseDerivedCellTrait.call(this, new CopyPasteTrait_0($outer));
  }
  protoOf(TargetCellTrait).p91 = function (cell, event) {
    protoOf(BaseDerivedCellTrait).p91.call(this, cell, event);
    this.wal_1.xal();
  };
  protoOf(TargetCellTrait).q91 = function (cell, event) {
    protoOf(BaseDerivedCellTrait).q91.call(this, cell, event);
    this.wal_1.xal();
  };
  protoOf(TargetCellTrait).s8z = function (cell, event) {
    if (event.o8j([KeyStrokeSpecs_getInstance().g8l_1])) {
      this.wal_1.yal(event);
    } else {
      protoOf(BaseDerivedCellTrait).s8z.call(this, cell, event);
      this.wal_1.xal();
    }
  };
  protoOf(TargetCellTrait).q8y = function (cell, event) {
    protoOf(BaseDerivedCellTrait).q8y.call(this, cell, event);
    this.wal_1.xal();
  };
  protoOf(TargetCellTrait).r91 = function (cell, event) {
    protoOf(BaseDerivedCellTrait).r91.call(this, cell, event);
    this.wal_1.xal();
  };
  protoOf(TargetCellTrait).t91 = function (cell, event) {
    protoOf(BaseDerivedCellTrait).t91.call(this, cell, event);
    this.wal_1.xal();
  };
  function TargetCellList($outer) {
    this.cal_1 = $outer;
    AbstractMutableList.call(this);
    this.bal_1 = false;
  }
  protoOf(TargetCellList).zal = function () {
    var tmp;
    if (this.bal_1) {
      var tmp_0 = this.cal_1.jaj_1.r(0).o35().r(0);
      tmp = tmp_0 instanceof TextCell ? tmp_0 : THROW_CCE();
    } else {
      tmp = null;
    }
    return tmp;
  };
  protoOf(TargetCellList).p = function () {
    return this.bal_1 ? 0 : this.cal_1.jaj_1.p();
  };
  protoOf(TargetCellList).aam = function () {
    return addPlaceholderIfEnabled(this);
  };
  protoOf(TargetCellList).r = function (index) {
    if (this.bal_1) {
      throw CollectionIndexOutOfBoundsException_init_$Create$();
    }
    return this.cal_1.jaj_1.r(index);
  };
  protoOf(TargetCellList).w90 = function (index, element) {
    if (this.bal_1) {
      this.cal_1.jaj_1.n2(0);
      this.bal_1 = false;
    }
    this.cal_1.jaj_1.m2(index, element);
    this.cal_1.laj_1.m2(index, this.cal_1.bam(this.cal_1.x86().r(index).e86_1, element));
  };
  protoOf(TargetCellList).m2 = function (index, element) {
    return this.w90(index, (!(element == null) ? isInterface(element, Cell) : false) ? element : THROW_CCE());
  };
  protoOf(TargetCellList).n2 = function (index) {
    var result = this.cal_1.jaj_1.n2(index);
    this.cal_1.laj_1.n2(index).zr();
    if (this.cal_1.jaj_1.s()) {
      addPlaceholderIfEnabled(this);
    }
    return result;
  };
  protoOf(TargetCellList).v90 = function (index, element) {
    var result = this.n2(index);
    this.w90(index, element);
    return result;
  };
  protoOf(TargetCellList).l2 = function (index, element) {
    return this.v90(index, (!(element == null) ? isInterface(element, Cell) : false) ? element : THROW_CCE());
  };
  function SourceList($outer) {
    this.cam_1 = $outer;
    AbstractList.call(this);
  }
  protoOf(SourceList).p = function () {
    return this.cam_1.x86().p();
  };
  protoOf(SourceList).r = function (index) {
    return this.cam_1.x86().r(index).e86_1;
  };
  function SelectionCaptureTrait($outer, support) {
    this.eam_1 = $outer;
    BaseDerivedCellTrait.call(this, new BaseSelectionCaptureTrait(BaseProjectionalSynchronizer$SelectionCaptureTrait$_init_$lambda_74dg8i(support)));
  }
  protoOf(SelectionCaptureTrait).s8z = function (cell, event) {
    if (isDeleteEvent(this.eam_1, event)) {
      this.eam_1.gam(this.eam_1.fam(), event);
      this.eam_1.ham();
      event.p8i();
    } else {
      protoOf(BaseDerivedCellTrait).s8z.call(this, cell, event);
    }
  };
  protoOf(SelectionCaptureTrait).q8y = function (cell, event) {
    event.n8i();
    this.eam_1.iaj_1.r92(event.s3e(), Companion_getInstance_170().u8y_1);
  };
  protoOf(SelectionCaptureTrait).h92 = function (cell, event) {
    var container = ensureNotNull(this.eam_1.iaj_1.s8x());
    this.eam_1.gam(this.eam_1.fam(), event);
    event.p8i();
    if (this.eam_1.fam().s()) {
      container.f9v(new PasteEvent(event.c8m_1));
    } else {
      this.eam_1.iaj_1.r92(new PasteEvent(event.c8m_1), Companion_getInstance_170().n8z_1);
    }
  };
  function BaseProjectionalSynchronizer$clipboardHandler$lambda(this$0) {
    return function (item) {
      var index = indexOf_12(this$0, item);
      var cell = this$0.jaj_1.r(index);
      return toText_0(toBlock(cell));
    };
  }
  function BaseProjectionalSynchronizer$_get_onLastItemDeleted_$lambda_wk9nhe(this$0) {
    return function () {
      var tmp0_safe_receiver = this$0.naj_1.zal();
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.s8n();
      }
      return Unit_instance;
    };
  }
  function BaseProjectionalSynchronizer$getItemHandler$lambda($item) {
    return function (candidate) {
      return candidate.iam($item);
    };
  }
  function BaseProjectionalSynchronizer$handleSourceUpdate$ref(p0) {
    var l = function (_this__u8e3s4) {
      return p0.jam(_this__u8e3s4);
    };
    l.callableName = 'handleSourceUpdate';
    return l;
  }
  function BaseProjectionalSynchronizer$SelectionCaptureTrait$_init_$ref_fz6y14(p0) {
    var l = function (_this__u8e3s4) {
      var tmp0 = p0;
      return new SelectionCaptureTrait(tmp0, _this__u8e3s4);
    };
    l.callableName = '<init>';
    return l;
  }
  function BaseProjectionalSynchronizer$attach$4(this$0) {
    this.lam_1 = this$0;
    this.kam_1 = null;
  }
  protoOf(BaseProjectionalSynchronizer$attach$4).mam = function (event) {
    var targetCell = this.kam_1;
    if (!(targetCell == null)) {
      get_background(targetCell).d2x(null);
      get_bottomPopupProp(targetCell).d2x(null);
    }
    var newValue = event.t2y_1;
    if (!(newValue == null)) {
      var index = indexOf_12(this.lam_1, newValue);
      var cell = this.lam_1.jaj_1.r(index);
      get_background(cell).d2x(Companion_getInstance_210().k96_1);
      var frontPopup = TextCell_init_$Create$_0('Press Del or Backspace to delete. Esc to cancel.');
      get_background(frontPopup).d2x(Companion_getInstance_210().y95_1);
      this.kam_1 = cell;
    }
  };
  protoOf(BaseProjectionalSynchronizer$attach$4).n2s = function (event) {
    return this.mam(event instanceof PropertyChangeEvent ? event : THROW_CCE());
  };
  function BaseProjectionalSynchronizer(target, targetList, settings, isMultiItemPasteSupported) {
    this.iaj_1 = target;
    this.jaj_1 = targetList;
    this.kaj_1 = settings;
    this.laj_1 = ArrayList_init_$Create$_0(0);
    this.naj_1 = new TargetCellList(this);
    this.oaj_1 = null;
    this.saj_1 = HashSet_init_$Create$();
    this.taj_1 = new ValueProperty(null);
    this.vaj_1 = true;
    this.waj_1 = null;
    this.xaj_1 = emptyRoleCompletion();
    var tmp = this;
    tmp.yaj_1 = new ProjectionalClipboardHandler(isMultiItemPasteSupported, BaseProjectionalSynchronizer$clipboardHandler$lambda(this));
    this.zaj_1 = null;
    this.aak_1 = null;
    this.bak_1 = false;
  }
  protoOf(BaseProjectionalSynchronizer).nam = function () {
    var tmp = this.maj_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('selectionSupport');
    }
  };
  protoOf(BaseProjectionalSynchronizer).oam = function () {
    return this.naj_1;
  };
  protoOf(BaseProjectionalSynchronizer).qam = function () {
    return this.yaj_1;
  };
  protoOf(BaseProjectionalSynchronizer).ram = function () {
    return this.yaj_1.vam_1;
  };
  protoOf(BaseProjectionalSynchronizer).x86 = function () {
    return this.pam().x86();
  };
  protoOf(BaseProjectionalSynchronizer).aan = function () {
    var tmp0_elvis_lhs = this.aak_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      tmp = BaseProjectionalSynchronizer$_get_onLastItemDeleted_$lambda_wk9nhe(this);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  protoOf(BaseProjectionalSynchronizer).fam = function () {
    return this.nam().kan();
  };
  protoOf(BaseProjectionalSynchronizer).lan = function () {
    return this.nam().lan();
  };
  protoOf(BaseProjectionalSynchronizer).ial = function () {
    return !(this.waj_1 == null);
  };
  protoOf(BaseProjectionalSynchronizer).gal = function () {
    var itemHandler = this.waj_1;
    // Inline function 'kotlin.checkNotNull' call
    $l$block: {
      // Inline function 'kotlin.checkNotNull' call
      if (itemHandler == null) {
        var message = 'Required value was null.';
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      } else {
        break $l$block;
      }
    }
    return itemHandler.gal();
  };
  protoOf(BaseProjectionalSynchronizer).man = function (contextItem) {
    var handler = this.nan(contextItem);
    $l$block: {
      // Inline function 'kotlin.checkNotNull' call
      if (handler == null) {
        var message = 'no suitable item handler for ' + toString_1(contextItem);
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      } else {
        break $l$block;
      }
    }
    return handler.gal();
  };
  protoOf(BaseProjectionalSynchronizer).zak = function (role) {
    var contextMapper = _get_context__ps0bpe_0(this).z86();
    var contextNode = contextMapper.e86_1;
    return this.xaj_1.oan(contextMapper, contextNode, role);
  };
  protoOf(BaseProjectionalSynchronizer).pan = function (index) {
    return this.oam().r(index).c93(ProjectionalSynchronizers_getInstance().d99_1);
  };
  protoOf(BaseProjectionalSynchronizer).qan = function (action) {
    // Inline function 'kotlin.require' call
    if (!(this.vaj_1 || !(action == null))) {
      var message = "Can't set the default onLastItemDeleted action when the placeholder is disabled";
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    this.aak_1 = action;
  };
  protoOf(BaseProjectionalSynchronizer).ran = function (handler) {
    this.waj_1 = handler;
  };
  protoOf(BaseProjectionalSynchronizer).san = function (handler) {
    return this.ran(handler);
  };
  protoOf(BaseProjectionalSynchronizer).nan = function (item) {
    var tmp = asSequence_0(this.saj_1);
    var list = toList_2(take_0(filter(tmp, BaseProjectionalSynchronizer$getItemHandler$lambda(item)), 2));
    // Inline function 'kotlin.check' call
    if (!(list.p() <= 1)) {
      var message = 'found two item handlers applicable to ' + toString_1(item) + ': ' + toString_1(list.r(0)) + ' and ' + toString_1(list.r(1));
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    return list.s() ? this.waj_1 : first(list);
  };
  protoOf(BaseProjectionalSynchronizer).tan = function (eagerCompletion) {
    this.bak_1 = eagerCompletion;
  };
  protoOf(BaseProjectionalSynchronizer).y86 = function (ctx) {
    this.cak_1 = ctx;
    // Inline function 'kotlin.check' call
    if (!this.iaj_1.o35().s()) {
      var message = 'target cell for projectional synchronizer should be initially empty';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    var tmp = this;
    var tmp_0 = this.kaj_1.uan_1;
    var tmp_1 = new SourceList(this);
    var tmp_2 = BaseProjectionalSynchronizer$handleSourceUpdate$ref(this);
    // Inline function 'kotlin.also' call
    var this_0 = new RoleSynchronizerSelectionSupport(this, tmp_0, tmp_1, this.iaj_1, this.jaj_1, tmp_2, BaseProjectionalSynchronizer$SelectionCaptureTrait$_init_$ref_fz6y14(this));
    this.maj_1 = this_0.eao_1;
    tmp.uaj_1 = this_0;
    this.taj_1.y2r(new BaseProjectionalSynchronizer$attach$4(this));
    this.oaj_1 = this.kaj_1.xan_1;
    this.raj_1 = this.kaj_1.yan_1;
    this.paj_1 = this.kaj_1.van_1;
    this.qaj_1 = this.kaj_1.wan_1;
    this.naj_1.aam();
    this.pam().y86(ctx);
    this.iaj_1.w92(new TargetCellTrait(this));
  };
  protoOf(BaseProjectionalSynchronizer).xal = function () {
    return this.taj_1.d2x(null);
  };
  protoOf(BaseProjectionalSynchronizer).e6j = function () {
    _get_roleSynchronizerSelectionSupport__orr8w(this).zr();
    this.pam().e6j();
  };
  protoOf(BaseProjectionalSynchronizer).iao = function (completion) {
    this.xaj_1 = completion;
  };
  protoOf(BaseProjectionalSynchronizer).jao = function (completion) {
    return this.iao(completion);
  };
  protoOf(BaseProjectionalSynchronizer).kao = function () {
    return this.nam().kao();
  };
  protoOf(BaseProjectionalSynchronizer).lao = function (event, cell, ignoreEmpty) {
    var home = Positions_instance.ra4(cell);
    var end = Positions_instance.sa4(cell);
    if (ignoreEmpty && home && end) {
      return false;
    }
    if (event.m8j(Key_BACKSPACE_getInstance(), []) && (!home || end)) {
      return true;
    }
    return event.m8j(Key_DELETE_getInstance(), []) && (!end || home);
  };
  protoOf(BaseProjectionalSynchronizer).mao = function (event, cell) {
    var tmp;
    if (event.o8j([KeyStrokeSpecs_getInstance().h8l_1])) {
      tmp = true;
    } else {
      tmp = this.lao(event, cell, false);
    }
    return tmp;
  };
  protoOf(BaseProjectionalSynchronizer).ham = function () {
    var targetContainer = this.iaj_1.s8x();
    if (!(targetContainer == null)) {
      var focusedCell = ensureNotNull(targetContainer.z92().uv());
      CellScrolling_getInstance().xa4(focusedCell);
    }
  };
  protoOf(BaseProjectionalSynchronizer).nao = function (handler) {
    this.zaj_1 = handler;
  };
  protoOf(BaseProjectionalSynchronizer).oao = function (handler) {
    return this.nao(handler);
  };
  function _get_isEmpty__oti0q6($this) {
    return $this.pao_1.s();
  }
  function isLast($this, index) {
    return index === get_lastIndex_2($this.pao_1);
  }
  function isFirst($this, index) {
    return index === 0;
  }
  function isEmpty_1($this, index) {
    return $this.vao($this.qao_1.r(index));
  }
  function insertAfterFromHome($this, index, event) {
    var inserted = $this.wao() ? index : index + 1 | 0;
    $this.pao_1.m2(inserted, $this.xao($this.pao_1.r(index)));
    if (!isEmpty_1($this, inserted)) {
      $this.zao(inserted);
    } else {
      $this.yao(index + 1 | 0, event);
      if (!event.l8i_1 && !(inserted === index)) {
        $this.zao(inserted);
      }
    }
  }
  function selectAfterClear($this, index) {
    var tmp;
    if (_get_isEmpty__oti0q6($this)) {
      $this.cap();
      tmp = Unit_instance;
    } else if (isLast($this, index) || isFirst($this, index)) {
      $this.bap(index);
      tmp = Unit_instance;
    } else {
      $this.aap(index - 1 | 0);
      tmp = Unit_instance;
    }
    return tmp;
  }
  function isDeleteEvent_0($this, event) {
    return isDeleteCurrentEvent($this, event) || isSimpleDeleteEvent($this, event);
  }
  function isSimpleDeleteEvent($this, event) {
    return event.m8j(Key_BACKSPACE_getInstance(), []) || event.m8j(Key_DELETE_getInstance(), []);
  }
  function isDeleteCurrentEvent($this, event) {
    return event.o8j([KeyStrokeSpecs_getInstance().h8l_1]);
  }
  function CollectionEditor(items, views, forDeletion, canCreateNew, replaceWithNewOnDelete, splitJoinHandler) {
    this.pao_1 = items;
    this.qao_1 = views;
    this.rao_1 = forDeletion;
    this.sao_1 = canCreateNew;
    this.tao_1 = replaceWithNewOnDelete;
    this.uao_1 = splitJoinHandler;
  }
  protoOf(CollectionEditor).kap = function (cell, event) {
    var index = this.qao_1.w(cell);
    var isHome = this.hap(cell);
    var isEnd = this.iap(cell);
    if (this.sao_1) {
      if (this.lap(event) && isHome) {
        insertAfterFromHome(this, index, event);
        if (!event.l8i_1) {
          event.n8i();
        }
        return Unit_instance;
      }
      if (this.lap(event) && !isHome) {
        if (isEnd || !this.map(index, event)) {
          this.pao_1.m2(index + 1 | 0, this.xao(this.pao_1.r(index)));
          this.zao(index + 1 | 0);
        }
        event.n8i();
        return Unit_instance;
      }
      if (this.nap(event)) {
        if (isHome || isEnd || !this.map(index, event)) {
          var i = isEnd && !isHome && this.wao() ? index + 1 | 0 : index;
          this.pao_1.m2(i, this.xao(this.pao_1.r(index)));
          this.zao(i);
        }
        event.n8i();
        return Unit_instance;
      }
    }
    if (event.o8j([KeyStrokeSpecs_getInstance().g8l_1]) && this.fap() && this.dap() && !this.kao()) {
      this.pao_1.m2(index + 1 | 0, this.gap(this.pao_1.r(index)));
      this.aap(index + 1 | 0);
      event.n8i();
      return Unit_instance;
    }
    if (this.oap(index, event, cell)) {
      event.n8i();
      return Unit_instance;
    }
    if (this.eap()) {
      if (event.m8j(Key_BACKSPACE_getInstance(), []) && index > 0) {
        var removePrev = isHome && !isEmpty_1(this, index);
        var removeCur = isEmpty_1(this, index);
        if (removePrev) {
          this.pao_1.n2(index - 1 | 0);
          event.n8i();
          return Unit_instance;
        }
        if (removeCur) {
          this.pao_1.n2(index);
          this.aap(index - 1 | 0);
          event.n8i();
          return Unit_instance;
        }
      }
      if (event.m8j(Key_DELETE_getInstance(), []) && !isLast(this, index)) {
        var removeCur_0 = isEmpty_1(this, index);
        var removeNext = isEnd && !isEmpty_1(this, index);
        if (removeCur_0) {
          this.pao_1.n2(index);
          this.bap(index);
          event.n8i();
          return Unit_instance;
        }
        if (removeNext) {
          this.pao_1.n2(index + 1 | 0);
          event.n8i();
          return Unit_instance;
        }
      }
    }
    if (isSimpleDeleteEvent(this, event) && !(this.rao_1.uv() === this.pao_1.r(index)) && !isEmpty_1(this, index)) {
      if (this.jap(event)) {
        return Unit_instance;
      }
      this.rao_1.d2x(this.pao_1.r(index));
      event.n8i();
      return Unit_instance;
    }
    if (isDeleteEvent_0(this, event)) {
      if (this.jap(event)) {
        return Unit_instance;
      }
      if (this.tao_1(this.qao_1.r(index))) {
        this.pao_1.l2(index, this.xao(this.pao_1.r(index)));
        this.bap(index);
      } else {
        this.pao_1.n2(index);
        selectAfterClear(this, index);
      }
      event.n8i();
    }
  };
  protoOf(CollectionEditor).map = function (index, event) {
    var canSplit = this.uao_1.pap(this.pao_1, index, this.qao_1);
    if (canSplit) {
      var postSplitAction = this.uao_1.qap(this.pao_1, index, this.qao_1);
      if (this.nap(event)) {
        this.aap(index);
      } else {
        this.bap(index + 1 | 0);
      }
      postSplitAction();
    }
    return canSplit;
  };
  protoOf(CollectionEditor).oap = function (index, event, cell) {
    var joinIndex;
    var direction;
    if (event.m8j(Key_BACKSPACE_getInstance(), []) && index > 0 && this.hap(cell)) {
      joinIndex = index - 1 | 0;
      direction = JoinDirection_BACKWARD_getInstance();
    } else if (event.m8j(Key_DELETE_getInstance(), []) && !isLast(this, index) && this.iap(cell)) {
      joinIndex = index;
      direction = JoinDirection_FORWARD_getInstance();
    } else {
      return false;
    }
    var canJoin = this.uao_1.rap(this.pao_1, joinIndex, direction);
    if (canJoin) {
      this.uao_1.sap(this.pao_1, joinIndex, direction)();
    }
    return canJoin;
  };
  function NewItemOnly(itemSupplier) {
    DefaultProjectionalItemHandler.call(this);
    this.tap_1 = itemSupplier;
  }
  protoOf(NewItemOnly).uap = function () {
    return new NotSupported();
  };
  protoOf(NewItemOnly).gal = function () {
    return this.tap_1();
  };
  function Companion_200() {
  }
  protoOf(Companion_200).vap = function (itemSupplier) {
    return new NewItemOnly(itemSupplier);
  };
  var Companion_instance_200;
  function Companion_getInstance_200() {
    return Companion_instance_200;
  }
  function DefaultProjectionalItemHandler() {
  }
  protoOf(DefaultProjectionalItemHandler).iam = function (item) {
    return true;
  };
  function DeleteHandler$Companion$EMPTY$1() {
  }
  protoOf(DeleteHandler$Companion$EMPTY$1).kal = function () {
    return false;
  };
  protoOf(DeleteHandler$Companion$EMPTY$1).jal = function () {
    throw UnsupportedOperationException_init_$Create$();
  };
  function Companion_201() {
    Companion_instance_201 = this;
    var tmp = this;
    tmp.wap_1 = new DeleteHandler$Companion$EMPTY$1();
  }
  var Companion_instance_201;
  function Companion_getInstance_201() {
    if (Companion_instance_201 == null)
      new Companion_201();
    return Companion_instance_201;
  }
  function JoinChildrenEvent() {
    JoinChildrenEvent_instance = this;
    this.xap_1 = new CellTraitEventSpec('joinChildrenEvent', true);
  }
  protoOf(JoinChildrenEvent).yap = function (cell, keyEvent) {
    var derivedEvent = new DerivedEvent(keyEvent);
    cell.v92(derivedEvent, this.xap_1);
    return derivedEvent.l8i_1;
  };
  var JoinChildrenEvent_instance;
  function JoinChildrenEvent_getInstance() {
    if (JoinChildrenEvent_instance == null)
      new JoinChildrenEvent();
    return JoinChildrenEvent_instance;
  }
  function CreateNewElementHandle() {
  }
  function ProjectionalListSynchronizerSettings$endPositionChecker$lambda(cell) {
    return Positions_instance.sa4(cell);
  }
  function ProjectionalListSynchronizerSettings$replaceWithNewOnDelete$lambda(cell) {
    return !isEmpty(cell);
  }
  function ProjectionalListSynchronizerSettings() {
    ProjectionalSynchronizerSettings.call(this);
    this.faq_1 = null;
    var tmp = this;
    tmp.gaq_1 = ProjectionalListSynchronizerSettings$endPositionChecker$lambda;
    this.haq_1 = get_INSERT_BEFORE();
    this.iaq_1 = get_INSERT_AFTER();
    this.jaq_1 = true;
    var tmp_0 = this;
    tmp_0.kaq_1 = ProjectionalListSynchronizerSettings$replaceWithNewOnDelete$lambda;
    this.laq_1 = true;
    this.maq_1 = null;
  }
  protoOf(ProjectionalListSynchronizerSettings).naq = function () {
    return this;
  };
  protoOf(ProjectionalListSynchronizerSettings).oaq = function (trait) {
    this.maq_1 = trait;
  };
  protoOf(ProjectionalListSynchronizerSettings).paq = function (replaceWithNewOnDelete) {
    this.kaq_1 = replaceWithNewOnDelete;
    return this;
  };
  function _get_currentChildCompletion__dt6zjo($this) {
    var role = new ProjectionalObservableListSynchronizer$currentChildCompletion$role$1($this);
    return $this.zak(role);
  }
  function _get_currentCellIndex__uqju5o($this) {
    return indexOf_5($this.oam(), $this.lan());
  }
  function DefaultCreateNewItemCellTrait($outer) {
    this.taq_1 = $outer;
    CellTrait.call(this);
  }
  protoOf(DefaultCreateNewItemCellTrait).q8y = function (cell, event) {
    var tmp;
    var tmp_0 = this.taq_1.qar_1;
    if (!((tmp_0 == null ? null : new Char(tmp_0)) == null)) {
      var tmp_1 = this.taq_1.qar_1;
      tmp = equals(tmp_1 == null ? null : new Char(tmp_1), new Char(event.i8j_1));
    } else {
      tmp = false;
    }
    if (tmp) {
      createNewToTheRight(this.taq_1, cell)();
      event.n8i();
    }
    protoOf(CellTrait).q8y.call(this, cell, event);
  };
  function createNewToTheRight($this, cell) {
    var index = $this.oam().w(cell);
    var newItem = $this.gal();
    $this.par_1.m2(index + 1 | 0, newItem);
    return $this.pan(index + 1 | 0);
  }
  function getCollectionEditor($this, child) {
    var itemHandler = $this.nan(child);
    var tmp1_elvis_lhs = itemHandler == null ? null : itemHandler.uap();
    var splitJoinHandler = tmp1_elvis_lhs == null ? new NotSupported() : tmp1_elvis_lhs;
    return new ProjectionalObservableListSynchronizer$getCollectionEditor$1($this, splitJoinHandler);
  }
  function keyPressedInChild($this, event, child) {
    var collectionEditor = getCollectionEditor($this, child);
    collectionEditor.kap(ensureNotNull($this.lan()), event);
  }
  function replaceWithNewOnDelete($this) {
    var tmp;
    if ($this.ial()) {
      tmp = $this.war_1;
    } else {
      tmp = ProjectionalObservableListSynchronizer$replaceWithNewOnDelete$lambda;
    }
    return tmp;
  }
  function insertItems($this, insertIndex, items) {
    $this.par_1.i2(insertIndex, items);
    var target = $this.oam().r((insertIndex + items.p() | 0) - 1 | 0);
    toLastFocusable(target)();
  }
  function insertItemsAndSelect($this, items) {
    var selectionSupport = $this.nam();
    var selectionRange = selectionSupport.zar();
    var insertIndex = selectionRange.f37();
    insertItems($this, insertIndex, items);
    selectionSupport.aas(items);
  }
  function doClear($this, items) {
    var firstIndex = indexOf_5($this.par_1, items.r(0));
    var _iterator__ex2g4s = ArrayList_init_$Create$_1(items).m();
    while (_iterator__ex2g4s.n()) {
      var item = _iterator__ex2g4s.o();
      // Inline function 'kotlin.collections.remove' call
      var this_0 = $this.par_1;
      (isInterface(this_0, MutableCollection) ? this_0 : THROW_CCE()).h2(item);
    }
    selectAfterClear_0($this, firstIndex);
  }
  function selectAfterClear_0($this, index) {
    if ($this.par_1.s()) {
      $this.aan()();
    } else if (index < $this.par_1.p()) {
      var target = $this.oam().r(index);
      toFirstFocusable(target)();
    } else {
      var target_0 = $this.oam().r(index - 1 | 0);
      toLastFocusable(target_0)();
    }
  }
  function isEmpty_2($this, index) {
    return isEmpty($this.oam().r(index));
  }
  function sam$jetbrains_ocelot_projectional_editor_cell_ProjectionalListSynchronizerSettings_CreateNewElementHandle$0(function_0) {
    this.bas_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_projectional_editor_cell_ProjectionalListSynchronizerSettings_CreateNewElementHandle$0).zap = function (cell) {
    return this.bas_1(cell);
  };
  protoOf(sam$jetbrains_ocelot_projectional_editor_cell_ProjectionalListSynchronizerSettings_CreateNewElementHandle$0).f3 = function () {
    return this.bas_1;
  };
  protoOf(sam$jetbrains_ocelot_projectional_editor_cell_ProjectionalListSynchronizerSettings_CreateNewElementHandle$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, CreateNewElementHandle) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_projectional_editor_cell_ProjectionalListSynchronizerSettings_CreateNewElementHandle$0).hashCode = function () {
    return hashCode(this.f3());
  };
  function ProjectionalObservableListSynchronizer$createNewToTheRight$ref(p0) {
    var l = function (_this__u8e3s4) {
      var tmp0 = p0;
      return createNewToTheRight(tmp0, _this__u8e3s4);
    };
    l.callableName = 'createNewToTheRight';
    return l;
  }
  function ProjectionalObservableListSynchronizer$currentChildCompletion$role$1(this$0) {
    this.cas_1 = this$0;
  }
  protoOf(ProjectionalObservableListSynchronizer$currentChildCompletion$role$1).xak = function (target) {
    var index = _get_currentCellIndex__uqju5o(this.cas_1);
    this.cas_1.par_1.l2(index, target);
    return this.cas_1.oam().r(index).c93(ProjectionalSynchronizers_getInstance().d99_1);
  };
  protoOf(ProjectionalObservableListSynchronizer$currentChildCompletion$role$1).yak = function (target) {
    return this.xak(!(target == null) ? target : THROW_CCE());
  };
  function ProjectionalObservableListSynchronizer$doRegisterChild$trait$1(this$0, $child) {
    this.das_1 = this$0;
    this.eas_1 = $child;
    CompositeCellTrait.call(this);
  }
  protoOf(ProjectionalObservableListSynchronizer$doRegisterChild$trait$1).s9n = function (cell) {
    var tmp;
    if (cell instanceof TextCell) {
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = [this.das_1.uar_1];
    } else {
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = [this.das_1.uar_1, CompletionSupport_getInstance().x9n()];
    }
    return tmp;
  };
  protoOf(ProjectionalObservableListSynchronizer$doRegisterChild$trait$1).v8z = function (cell, event) {
    try {
      if (this.das_1.fam().p() <= 1) {
        keyPressedInChild(this.das_1, event, this.eas_1);
      }
    }finally {
      if (event.l8i_1 && cell.f89()) {
        this.das_1.ham();
      }
    }
    protoOf(CompositeCellTrait).v8z.call(this, cell, event);
  };
  protoOf(ProjectionalObservableListSynchronizer$doRegisterChild$trait$1).n91 = function (cell, spec) {
    var specMatcher = specMatcherValue(Completion_getInstance().u9d_1, _get_currentChildCompletion__dt6zjo(this.das_1));
    // Inline function 'jetbrains.ocelot.projectional.cell.trait.getSpecValue' call
    var result = specMatcher(spec);
    var tmp;
    if (result == null) {
      tmp = protoOf(CompositeCellTrait).n91.call(this, cell, spec);
    } else {
      tmp = result.o9n_1;
    }
    return tmp;
  };
  protoOf(ProjectionalObservableListSynchronizer$doRegisterChild$trait$1).i8y = function (cell, spec, event) {
    if (spec === Cells_getInstance().g9t_1 && cell.c93(ProjectionalSynchronizers_getInstance().f99_1)) {
      var index = this.das_1.oam().w(cell);
      if (index === -1)
        return Unit_instance;
      this.das_1.gam(this.das_1.par_1.g2(index, index + 1 | 0), event);
      event.n8i();
      return Unit_instance;
    }
    if (spec === JoinChildrenEvent_getInstance().xap_1) {
      var joinEvent = event instanceof DerivedEvent ? event : THROW_CCE();
      if (getCollectionEditor(this.das_1, this.eas_1).oap(this.das_1.par_1.w(this.eas_1), joinEvent.b8j_1, ensureNotNull(this.das_1.lan()))) {
        joinEvent.n8i();
        return Unit_instance;
      }
    }
    if (spec === Companion_getInstance_202().kas_1) {
      var splitEvent = event instanceof SplitChildEvent ? event : THROW_CCE();
      if (splitEvent.jas(cell)) {
        return Unit_instance;
      }
      if (this.das_1.ial()) {
        if (getCollectionEditor(this.das_1, this.eas_1).map(this.das_1.par_1.w(this.eas_1), splitEvent.b8j_1)) {
          splitEvent.n8i();
          return Unit_instance;
        }
      }
      return Unit_instance;
    }
    protoOf(CompositeCellTrait).i8y.call(this, cell, spec, event);
  };
  function ProjectionalObservableListSynchronizer$getCollectionEditor$1(this$0, $splitJoinHandler) {
    this.ras_1 = this$0;
    CollectionEditor.call(this, this$0.par_1, this$0.oam(), this$0.taj_1, this$0.ial(), replaceWithNewOnDelete(this$0), $splitJoinHandler);
  }
  protoOf(ProjectionalObservableListSynchronizer$getCollectionEditor$1).dap = function () {
    return this.ras_1.fam().s();
  };
  protoOf(ProjectionalObservableListSynchronizer$getCollectionEditor$1).wao = function () {
    return this.ras_1.var_1;
  };
  protoOf(ProjectionalObservableListSynchronizer$getCollectionEditor$1).eap = function () {
    return this.ras_1.xar_1;
  };
  protoOf(ProjectionalObservableListSynchronizer$getCollectionEditor$1).man = function (contextItem) {
    return this.ras_1.man(contextItem);
  };
  protoOf(ProjectionalObservableListSynchronizer$getCollectionEditor$1).xao = function (contextItem) {
    return this.man(!(contextItem == null) ? contextItem : THROW_CCE());
  };
  protoOf(ProjectionalObservableListSynchronizer$getCollectionEditor$1).fap = function () {
    return !(this.ras_1.ram() == null);
  };
  protoOf(ProjectionalObservableListSynchronizer$getCollectionEditor$1).sas = function (item) {
    return ensureNotNull(this.ras_1.ram()).tas(item);
  };
  protoOf(ProjectionalObservableListSynchronizer$getCollectionEditor$1).gap = function (item) {
    return this.sas(!(item == null) ? item : THROW_CCE());
  };
  protoOf(ProjectionalObservableListSynchronizer$getCollectionEditor$1).uas = function (item) {
    return isEmpty(item);
  };
  protoOf(ProjectionalObservableListSynchronizer$getCollectionEditor$1).vao = function (item) {
    return this.uas((!(item == null) ? isInterface(item, Cell) : false) ? item : THROW_CCE());
  };
  protoOf(ProjectionalObservableListSynchronizer$getCollectionEditor$1).vas = function (item) {
    return Positions_instance.ra4(item);
  };
  protoOf(ProjectionalObservableListSynchronizer$getCollectionEditor$1).hap = function (item) {
    return this.vas((!(item == null) ? isInterface(item, Cell) : false) ? item : THROW_CCE());
  };
  protoOf(ProjectionalObservableListSynchronizer$getCollectionEditor$1).was = function (item) {
    return this.ras_1.rar_1(item);
  };
  protoOf(ProjectionalObservableListSynchronizer$getCollectionEditor$1).iap = function (item) {
    return this.was((!(item == null) ? isInterface(item, Cell) : false) ? item : THROW_CCE());
  };
  protoOf(ProjectionalObservableListSynchronizer$getCollectionEditor$1).zao = function (index) {
    return this.ras_1.pan(index)();
  };
  protoOf(ProjectionalObservableListSynchronizer$getCollectionEditor$1).bap = function (index) {
    return toFirstFocusable(this.ras_1.oam().r(index))();
  };
  protoOf(ProjectionalObservableListSynchronizer$getCollectionEditor$1).aap = function (index) {
    return toLastFocusable(this.ras_1.oam().r(index))();
  };
  protoOf(ProjectionalObservableListSynchronizer$getCollectionEditor$1).cap = function () {
    return this.ras_1.aan()();
  };
  protoOf(ProjectionalObservableListSynchronizer$getCollectionEditor$1).kao = function () {
    return this.ras_1.kao();
  };
  protoOf(ProjectionalObservableListSynchronizer$getCollectionEditor$1).yao = function (index, event) {
    Companion_getInstance_202().xas(this.ras_1.iaj_1, event);
  };
  protoOf(ProjectionalObservableListSynchronizer$getCollectionEditor$1).jap = function (event) {
    return JoinChildrenEvent_getInstance().yap(this.ras_1.iaj_1, event);
  };
  protoOf(ProjectionalObservableListSynchronizer$getCollectionEditor$1).nap = function (event) {
    return event.o8j([this.ras_1.sar_1]);
  };
  protoOf(ProjectionalObservableListSynchronizer$getCollectionEditor$1).lap = function (event) {
    return event.o8j([this.ras_1.tar_1]);
  };
  function ProjectionalObservableListSynchronizer$replaceWithNewOnDelete$lambda(it) {
    return false;
  }
  function ProjectionalObservableListSynchronizer(source, target, targetList, factory, settings) {
    BaseProjectionalSynchronizer.call(this, target, targetList, settings, true);
    this.par_1 = source;
    this.qar_1 = settings.faq_1;
    this.rar_1 = settings.gaq_1;
    this.sar_1 = settings.haq_1;
    this.tar_1 = settings.iaq_1;
    var tmp = this;
    var createTrait = settings.maq_1;
    var tmp_0;
    if (createTrait == null) {
      tmp_0 = new DefaultCreateNewItemCellTrait(this);
    } else {
      var tmp_1 = ProjectionalObservableListSynchronizer$createNewToTheRight$ref(this);
      tmp_0 = createTrait(new sam$jetbrains_ocelot_projectional_editor_cell_ProjectionalListSynchronizerSettings_CreateNewElementHandle$0(tmp_1));
    }
    tmp.uar_1 = tmp_0;
    this.var_1 = settings.jaq_1;
    this.war_1 = settings.kaq_1;
    this.xar_1 = settings.laq_1;
    this.yar_1 = Synchronizers_instance.c8b(this.par_1, this.oam(), factory);
  }
  protoOf(ProjectionalObservableListSynchronizer).pam = function () {
    return this.yar_1;
  };
  protoOf(ProjectionalObservableListSynchronizer).jam = function (selectionSupport) {
    var updateHandler = new SourceUpdateHandler(this.par_1, selectionSupport);
    return this.par_1.y2r(updateHandler);
  };
  protoOf(ProjectionalObservableListSynchronizer).bam = function (child, childCell) {
    var trait = new ProjectionalObservableListSynchronizer$doRegisterChild$trait$1(this, child);
    return childCell.w92(trait);
  };
  protoOf(ProjectionalObservableListSynchronizer).fal = function (items) {
    var index = _get_currentCellIndex__uqju5o(this);
    if (index === -1) {
      this.par_1.q(items);
      return this.pan(get_lastIndex_2(items));
    }
    var tmp;
    if (Positions_instance.ra4(ensureNotNull(this.lan()))) {
      this.par_1.i2(index, items);
      var tmp_0;
      if (isEmpty_2(this, index)) {
        tmp_0 = get_EMPTY_CELL_ACTION();
      } else {
        tmp_0 = this.pan((index + items.p() | 0) - 1 | 0);
      }
      tmp = tmp_0;
    } else {
      this.par_1.i2(index + 1 | 0, items);
      tmp = this.pan(index + items.p() | 0);
    }
    return tmp;
  };
  protoOf(ProjectionalObservableListSynchronizer).hal = function (event) {
    return event.o8j([this.sar_1, this.tar_1]);
  };
  protoOf(ProjectionalObservableListSynchronizer).yal = function (event) {
    var clonerSupport = this.ram();
    var tmp;
    if (!(clonerSupport == null)) {
      // Inline function 'kotlin.collections.isNotEmpty' call
      tmp = !this.fam().s();
    } else {
      tmp = false;
    }
    if (tmp) {
      var copiedItems = clonerSupport.yas(this.fam());
      insertItemsAndSelect(this, copiedItems);
      event.n8i();
    } else {
      this.xal();
    }
  };
  protoOf(ProjectionalObservableListSynchronizer).gam = function (items, cause) {
    return doClear(this, items);
  };
  protoOf(ProjectionalObservableListSynchronizer).mal = function (items, cause, result) {
    return doClear(this, items);
  };
  function _get_completion__ojdpzl($this) {
    return $this.zak(new ProjectionalPropertySynchronizer$completion$1($this));
  }
  function handleItemKeyPress($this, event, cell) {
    if ($this.vat_1 && $this.lao(event, cell, true) && $this.taj_1.uv() == null) {
      $this.taj_1.d2x($this.uat_1.uv());
      event.n8i();
      return Unit_instance;
    }
    if ($this.vat_1 && $this.mao(event, cell)) {
      deleteItem($this, event);
      event.p8i();
    }
  }
  function deleteItem($this, cause) {
    clearSourceValue($this);
    $this.aan()();
    if ($this.iaj_1.c93(ProjectionalSynchronizers_getInstance().f99_1)) {
      var derivedEvent = new DerivedEvent(cause);
      $this.iaj_1.v92(derivedEvent, Cells_getInstance().g9t_1);
    }
  }
  function deleteItem_0($this, cause, result) {
    clearSourceValue($this);
    $this.aan()();
    if ($this.iaj_1.c93(ProjectionalSynchronizers_getInstance().f99_1)) {
      var derivedEvent = new DerivedCopyCutEvent(cause, result);
      $this.iaj_1.v92(derivedEvent, Cells_getInstance().g9t_1);
    }
  }
  function clearSourceValue($this) {
    return $this.uat_1.d2x(null);
  }
  function ProjectionalPropertySynchronizer$completion$1(this$0) {
    this.xat_1 = this$0;
  }
  protoOf(ProjectionalPropertySynchronizer$completion$1).xak = function (target) {
    this.xat_1.uat_1.d2x(target);
    return this.xat_1.pan(0);
  };
  protoOf(ProjectionalPropertySynchronizer$completion$1).yak = function (target) {
    return this.xak(!(target == null) ? target : THROW_CCE());
  };
  function ProjectionalPropertySynchronizer$doRegisterChild$trait$1(this$0) {
    this.yat_1 = this$0;
    DerivedCellTrait.call(this);
  }
  protoOf(ProjectionalPropertySynchronizer$doRegisterChild$trait$1).da6 = function (cell) {
    var tmp;
    if (cell instanceof TextCell) {
      tmp = Companion_getInstance_186().wa8_1;
    } else {
      tmp = CompletionSupport_getInstance().x9n();
    }
    return tmp;
  };
  protoOf(ProjectionalPropertySynchronizer$doRegisterChild$trait$1).v8z = function (cell, event) {
    handleItemKeyPress(this.yat_1, event, cell);
    if (event.l8i_1)
      return Unit_instance;
    this.s8z(cell, event);
  };
  protoOf(ProjectionalPropertySynchronizer$doRegisterChild$trait$1).n91 = function (cell, spec) {
    var specMatcher = specMatcherValue(Completion_getInstance().u9d_1, _get_completion__ojdpzl(this.yat_1));
    // Inline function 'jetbrains.ocelot.projectional.cell.trait.getSpecValue' call
    var result = specMatcher(spec);
    var tmp;
    if (result == null) {
      tmp = protoOf(DerivedCellTrait).n91.call(this, cell, spec);
    } else {
      tmp = result.o9n_1;
    }
    return tmp;
  };
  protoOf(ProjectionalPropertySynchronizer$doRegisterChild$trait$1).i8y = function (cell, spec, event) {
    if (spec === Cells_getInstance().g9t_1 && this.yat_1.vat_1 && cell.c93(ProjectionalSynchronizers_getInstance().f99_1)) {
      deleteItem(this.yat_1, event);
      event.p8i();
      return Unit_instance;
    }
    protoOf(DerivedCellTrait).i8y.call(this, cell, spec, event);
  };
  function ProjectionalPropertySynchronizer(source, target, factory, settings) {
    BaseProjectionalSynchronizer.call(this, target, target.q92(), settings, false);
    this.uat_1 = source;
    this.vat_1 = settings.eau_1;
    this.wat_1 = Synchronizers_instance.e8b(this.uat_1, toWritableProperty(this.oam()), factory);
  }
  protoOf(ProjectionalPropertySynchronizer).pam = function () {
    return this.wat_1;
  };
  protoOf(ProjectionalPropertySynchronizer).jam = function (selectionSupport) {
    return Companion_getInstance_29().m2l_1;
  };
  protoOf(ProjectionalPropertySynchronizer).bam = function (child, childCell) {
    var trait = new ProjectionalPropertySynchronizer$doRegisterChild$trait$1(this);
    return childCell.w92(trait);
  };
  protoOf(ProjectionalPropertySynchronizer).gam = function (items, cause) {
    var tmp;
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!items.s()) {
      tmp = this.vat_1;
    } else {
      tmp = false;
    }
    if (tmp) {
      deleteItem(this, cause);
    }
  };
  protoOf(ProjectionalPropertySynchronizer).mal = function (items, cause, result) {
    var tmp;
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!items.s()) {
      tmp = this.vat_1;
    } else {
      tmp = false;
    }
    if (tmp) {
      deleteItem_0(this, cause, result);
    }
  };
  protoOf(ProjectionalPropertySynchronizer).fal = function (items) {
    this.uat_1.d2x(items.r(0));
    return this.pan(0);
  };
  protoOf(ProjectionalPropertySynchronizer).yal = function (event) {
    return this.xal();
  };
  protoOf(ProjectionalPropertySynchronizer).hal = function (event) {
    return event.o8j([get_INSERT()]);
  };
  function ProjectionalPropertySynchronizerSettings() {
    ProjectionalSynchronizerSettings.call(this);
    this.eau_1 = true;
  }
  protoOf(ProjectionalPropertySynchronizerSettings).naq = function () {
    return this;
  };
  protoOf(ProjectionalPropertySynchronizerSettings).fau = function (canClear) {
    this.eau_1 = canClear;
    return this.naq();
  };
  function get_INSERT_BEFORE() {
    _init_properties_ProjectionalRoleKeys_kt__xanh8c();
    return INSERT_BEFORE;
  }
  var INSERT_BEFORE;
  function get_INSERT_AFTER() {
    _init_properties_ProjectionalRoleKeys_kt__xanh8c();
    return INSERT_AFTER;
  }
  var INSERT_AFTER;
  function get_INSERT() {
    _init_properties_ProjectionalRoleKeys_kt__xanh8c();
    return INSERT;
  }
  var INSERT;
  var properties_initialized_ProjectionalRoleKeys_kt_m5t412;
  function _init_properties_ProjectionalRoleKeys_kt__xanh8c() {
    if (!properties_initialized_ProjectionalRoleKeys_kt_m5t412) {
      properties_initialized_ProjectionalRoleKeys_kt_m5t412 = true;
      INSERT_BEFORE = KeyStrokeSpecs_getInstance().m8l([KeyStroke_init_$Create$(Key_ENTER_getInstance(), []).b8k([ModifierKey_META_getInstance()]), KeyStroke_init_$Create$(Key_INSERT_getInstance(), []), KeyStroke_init_$Create$(Key_ENTER_getInstance(), []).b8k([ModifierKey_CONTROL_getInstance()])]);
      INSERT_AFTER = KeyStrokeSpec_init_$Create$(Key_ENTER_getInstance(), []);
      INSERT = KeyStrokeSpecs_getInstance().n8l([get_INSERT_BEFORE(), get_INSERT_AFTER()]);
    }
  }
  function ProjectionalSynchronizerSettings$placeholderCaretCellTraitFactory$lambda(trait) {
    return trait;
  }
  function ProjectionalSynchronizerSettings$placeholderVisibleCellTraitFactory$lambda() {
    return null;
  }
  function ProjectionalSynchronizerSettings() {
    this.uan_1 = ProjectionalSelection_getInstance().gau_1;
    var tmp = this;
    tmp.van_1 = ProjectionalSynchronizerSettings$placeholderCaretCellTraitFactory$lambda;
    var tmp_0 = this;
    tmp_0.wan_1 = ProjectionalSynchronizerSettings$placeholderVisibleCellTraitFactory$lambda;
    this.xan_1 = null;
    this.yan_1 = Companion_getInstance_201().wap_1;
  }
  protoOf(ProjectionalSynchronizerSettings).saq = function (placeholderText) {
    this.xan_1 = placeholderText;
    return this.naq();
  };
  protoOf(ProjectionalSynchronizerSettings).qaq = function (factory) {
    this.van_1 = factory;
    return this.naq();
  };
  protoOf(ProjectionalSynchronizerSettings).raq = function (factory) {
    this.wan_1 = factory;
    return this.naq();
  };
  function toLastFocusable$ref() {
    var l = function (p0) {
      return toLastFocusable(p0);
    };
    l.callableName = 'toLastFocusable';
    return l;
  }
  function ProjectionalSynchronizers() {
    ProjectionalSynchronizers_instance = this;
    var tmp = this;
    tmp.d99_1 = new CellTraitPropertySpec('onCreate', toLastFocusable$ref());
    this.e99_1 = CellTraitPropertySpec_init_$Create$('ignoredCell', false);
    this.f99_1 = CellTraitPropertySpec_init_$Create$('deleteOnEmpty', false);
  }
  protoOf(ProjectionalSynchronizers).hau = function (source, target, targetList, factory, settings) {
    return new ProjectionalObservableListSynchronizer(source, target, targetList, factory, settings);
  };
  protoOf(ProjectionalSynchronizers).iau = function (source, target, factory, settings) {
    return new ProjectionalPropertySynchronizer(source, target, factory, settings);
  };
  var ProjectionalSynchronizers_instance;
  function ProjectionalSynchronizers_getInstance() {
    if (ProjectionalSynchronizers_instance == null)
      new ProjectionalSynchronizers();
    return ProjectionalSynchronizers_instance;
  }
  function copyHandlerTrait($this, sync, targetList, selectionSupport, clipboardParameters) {
    var clipboardHandler = new ProjectionalClipboardHandler(false, ReadOnlyProjectionalSynchronizers$copyHandlerTrait$lambda(sync, targetList));
    if (clipboardParameters == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      clipboardHandler.jau(clipboardParameters);
    }
    return new RoleSynchronizerCopyTrait(clipboardHandler, selectionSupport);
  }
  function rolePlaceholder($this, text, focusable) {
    var textCell = focusable ? CellFactory_instance.ta9('') : TextCell_init_$Create$_0('');
    var placeholder = placeholder_0(textCell, text);
    return CellFactory_instance.pa9([textCell, placeholder]);
  }
  function ReadOnlyProjectionalSynchronizers$forRole$lambda(it) {
    return Companion_getInstance_29().m2l_1;
  }
  function ReadOnlyProjectionalSynchronizers$forRole$lambda_0(selectionSupport) {
    return new BaseSelectionCaptureTrait(ReadOnlyProjectionalSynchronizers$forRole$lambda$lambda(selectionSupport));
  }
  function ReadOnlyProjectionalSynchronizers$forRole$lambda$lambda($selectionSupport) {
    return function (it) {
      return $selectionSupport;
    };
  }
  function ReadOnlyProjectionalSynchronizers$forRole$lambda_1($placeholder, $focusablePlaceholder) {
    return function () {
      return rolePlaceholder(ReadOnlyProjectionalSynchronizers_instance, $placeholder, $focusablePlaceholder);
    };
  }
  function ReadOnlyProjectionalSynchronizers$forSingleRole$target$1($targetCell, $targetList, $placeholder, $focusablePlaceholder) {
    this.kau_1 = $targetCell;
    this.lau_1 = $targetList;
    this.mau_1 = $placeholder;
    this.nau_1 = $focusablePlaceholder;
  }
  protoOf(ReadOnlyProjectionalSynchronizers$forSingleRole$target$1).u9u = function (newValue) {
    var children = this.kau_1.q92();
    children.k2();
    this.lau_1.k2();
    children.j(newValue == null ? rolePlaceholder(ReadOnlyProjectionalSynchronizers_instance, this.mau_1, this.nau_1) : newValue);
    if (!(newValue == null)) {
      this.lau_1.j(newValue);
    }
  };
  protoOf(ReadOnlyProjectionalSynchronizers$forSingleRole$target$1).d2x = function (newValue) {
    return this.u9u((newValue == null ? true : isInterface(newValue, Cell)) ? newValue : THROW_CCE());
  };
  function ReadOnlyProjectionalSynchronizers$forSingleRole$lambda(it) {
    return Companion_getInstance_29().m2l_1;
  }
  function ReadOnlyProjectionalSynchronizers$forSingleRole$lambda_0(selectionSupport) {
    return new BaseSelectionCaptureTrait(ReadOnlyProjectionalSynchronizers$forSingleRole$lambda$lambda(selectionSupport));
  }
  function ReadOnlyProjectionalSynchronizers$forSingleRole$lambda$lambda($selectionSupport) {
    return function (it) {
      return $selectionSupport;
    };
  }
  function ReadOnlyProjectionalSynchronizers$copyHandlerTrait$lambda($sync, $targetList) {
    return function (item) {
      var index = indexOf_12($sync, item);
      var cell = $targetList.r(index);
      return toText_0(toBlock(cell));
    };
  }
  function ReadOnlyProjectionalSynchronizers() {
  }
  protoOf(ReadOnlyProjectionalSynchronizers).oau = function (sourceList, targetCell, targetList, mapperFactory, placeholder, focusablePlaceholder, clipboardParameters) {
    var cellList = new ObservableArrayList();
    var mainSynchronizer = Synchronizers_instance.c8b(sourceList, cellList, mapperFactory);
    var tmp = new BaseSelectionSpec();
    var tmp_0 = ReadOnlyProjectionalSynchronizers$forRole$lambda;
    var synchronizerSelectionSupport = new RoleSynchronizerSelectionSupport(mainSynchronizer, tmp, sourceList, targetCell, targetList, tmp_0, ReadOnlyProjectionalSynchronizers$forRole$lambda_0);
    var traitAdded = targetCell.w92(copyHandlerTrait(this, mainSynchronizer, targetList, synchronizerSelectionSupport, clipboardParameters));
    var tmp_1 = Transformers_instance;
    var placeholderIfEmpty = tmp_1.m35(ReadOnlyProjectionalSynchronizers$forRole$lambda_1(placeholder, focusablePlaceholder));
    var placeholderTransformation = placeholderIfEmpty.u32(cellList, targetList);
    return Synchronizers_instance.h8b([mainSynchronizer, Synchronizers_instance.g8b([placeholderTransformation, synchronizerSelectionSupport, traitAdded])]);
  };
  protoOf(ReadOnlyProjectionalSynchronizers).pau = function (source, targetCell, mapperFactory, placeholder, focusablePlaceholder, clipboardParameters) {
    // Inline function 'kotlin.collections.arrayListOf' call
    var targetList = ArrayList_init_$Create$();
    var target = new ReadOnlyProjectionalSynchronizers$forSingleRole$target$1(targetCell, targetList, placeholder, focusablePlaceholder);
    target.u9u(null);
    var mainSynchronizer = Synchronizers_instance.e8b(source, target, mapperFactory);
    var sourceAsList = new ObservableArrayList();
    var tmp = new BaseSelectionSpec();
    var tmp_0 = targetCell.o35();
    var tmp_1 = ReadOnlyProjectionalSynchronizers$forSingleRole$lambda;
    var synchronizerSelectionSupport = new RoleSynchronizerSelectionSupport(mainSynchronizer, tmp, sourceAsList, targetCell, tmp_0, tmp_1, ReadOnlyProjectionalSynchronizers$forSingleRole$lambda_0);
    var traitAdded = targetCell.w92(copyHandlerTrait(this, mainSynchronizer, targetList, synchronizerSelectionSupport, clipboardParameters));
    var sourceToListTransform = Transformers_instance.n35().u32(source, sourceAsList);
    return Synchronizers_instance.h8b([mainSynchronizer, Synchronizers_instance.g8b([sourceToListTransform, synchronizerSelectionSupport, traitAdded])]);
  };
  var ReadOnlyProjectionalSynchronizers_instance;
  function ReadOnlyProjectionalSynchronizers_getInstance() {
    return ReadOnlyProjectionalSynchronizers_instance;
  }
  function canCut($this) {
    return $this.tal() && $this.qal_1.qau();
  }
  function cut($this, event) {
    var toCopy = $this.ual();
    var result = $this.qal_1.rau(toCopy);
    $this.lal(toCopy, event, result);
    return result;
  }
  function paste($this, clipboardContent) {
    var tmp0_elvis_lhs = $this.qal_1.sau(clipboardContent);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var items = tmp;
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!items.s()) {
      $this.nal(items);
    }
    return true;
  }
  function RoleSynchronizerCopyPasteTrait(clipboardHandler, selectionSupport) {
    RoleSynchronizerCopyTrait.call(this, clipboardHandler, selectionSupport);
    this.qal_1 = clipboardHandler;
  }
  protoOf(RoleSynchronizerCopyPasteTrait).g92 = function (cell, event) {
    if (canCut(this)) {
      var content = cut(this, event);
      event.u8i(content);
    } else {
      protoOf(RoleSynchronizerCopyTrait).g92.call(this, cell, event);
    }
  };
  protoOf(RoleSynchronizerCopyPasteTrait).h92 = function (cell, event) {
    var content = event.c8m_1;
    if (this.qal_1.tau(content) && paste(this, content)) {
      event.n8i();
    } else {
      protoOf(RoleSynchronizerCopyTrait).h92.call(this, cell, event);
    }
  };
  function _get_selectedItems__ypx024($this) {
    return $this.sal_1.eao_1.kan();
  }
  function _get_currentItem__jpszrv($this) {
    return $this.sal_1.uau();
  }
  function canCopy($this) {
    return $this.tal() && $this.ral_1.vau();
  }
  function copy($this) {
    var items = $this.ual();
    return $this.ral_1.wau(items);
  }
  function RoleSynchronizerCopyTrait(clipboardHandler, selectionSupport) {
    CellTrait.call(this);
    this.ral_1 = clipboardHandler;
    this.sal_1 = selectionSupport;
  }
  protoOf(RoleSynchronizerCopyTrait).f92 = function (cell, event) {
    if (canCopy(this)) {
      event.t8i(copy(this));
    } else {
      protoOf(CellTrait).f92.call(this, cell, event);
    }
  };
  protoOf(RoleSynchronizerCopyTrait).tal = function () {
    var tmp;
    var tmp_0;
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!_get_selectedItems__ypx024(this).s()) {
      tmp_0 = true;
    } else {
      tmp_0 = !(_get_currentItem__jpszrv(this) == null);
    }
    if (tmp_0) {
      tmp = !this.sal_1.eao_1.kao();
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(RoleSynchronizerCopyTrait).ual = function () {
    // Inline function 'kotlin.collections.buildList' call
    // Inline function 'kotlin.collections.buildListInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = ArrayList_init_$Create$();
    if (_get_selectedItems__ypx024(this).s()) {
      var current = _get_currentItem__jpszrv(this);
      if (!(current == null)) {
        this_0.j(current);
      }
    } else {
      this_0.q(_get_selectedItems__ypx024(this));
    }
    return this_0.i3();
  };
  function nextCell($this, root) {
    // Inline function 'jetbrains.ocelot.base.composite.Composites.nextNavOrder' call
    // Inline function 'kotlin.sequences.find' call
    var tmp0 = Composites_instance.f36(root);
    var tmp$ret$2;
    $l$block: {
      // Inline function 'kotlin.sequences.firstOrNull' call
      var _iterator__ex2g4s = tmp0.m();
      while (_iterator__ex2g4s.n()) {
        var element = _iterator__ex2g4s.o();
        if (isVisible_1(element) && !isIgnored(Companion_getInstance_202(), element)) {
          tmp$ret$2 = element;
          break $l$block;
        }
      }
      tmp$ret$2 = null;
    }
    return tmp$ret$2;
  }
  function isIgnored($this, cell) {
    var $this_0 = $this;
    var cell_0 = cell;
    $l$1: do {
      $l$0: do {
        var tmp;
        if (cell_0.c93(ProjectionalSynchronizers_getInstance().e99_1)) {
          tmp = true;
        } else {
          var parent = cell_0.bp();
          var tmp_0;
          if (parent == null) {
            tmp_0 = false;
          } else {
            $this_0 = $this_0;
            cell_0 = parent;
            continue $l$0;
          }
          tmp = tmp_0;
        }
        return tmp;
      }
       while (false);
    }
     while (true);
  }
  function Companion_202() {
    Companion_instance_202 = this;
    this.kas_1 = new CellTraitEventSpec('splitChildEvent', true);
  }
  protoOf(Companion_202).xas = function (cell, keyEvent) {
    var derivedEvent = new SplitChildEvent(cell, keyEvent);
    cell.v92(derivedEvent, this.kas_1);
  };
  var Companion_instance_202;
  function Companion_getInstance_202() {
    if (Companion_instance_202 == null)
      new Companion_202();
    return Companion_instance_202;
  }
  function SplitChildEvent(sourceCell, keyEvent) {
    Companion_getInstance_202();
    DerivedEvent.call(this, keyEvent);
    this.ias_1 = nextCell(Companion_getInstance_202(), sourceCell);
  }
  protoOf(SplitChildEvent).jas = function (dispatchedTo) {
    var tmp;
    if (this.ias_1 === nextCell(Companion_getInstance_202(), dispatchedTo)) {
      tmp = false;
    } else {
      this.n8i();
      tmp = true;
    }
    return tmp;
  };
  function ClipboardParameters$Companion$simple$lambda(it) {
    return it;
  }
  function ClipboardParameters$Companion$simple$lambda_0(it) {
    return it;
  }
  function Companion_203() {
  }
  protoOf(Companion_203).xau = function (kind, clonerSupport) {
    var tmp = ClipboardParameters$Companion$simple$lambda;
    return new ClipboardParameters(kind, clonerSupport, tmp, ClipboardParameters$Companion$simple$lambda_0);
  };
  var Companion_instance_203;
  function Companion_getInstance_203() {
    return Companion_instance_203;
  }
  function ClipboardParameters(contentKind, clonerSupport, toClipboardContent, fromClipboardContent) {
    this.yau_1 = contentKind;
    this.zau_1 = clonerSupport;
    this.aav_1 = toClipboardContent;
    this.bav_1 = fromClipboardContent;
  }
  function ClonerSupport() {
  }
  function sam$jetbrains_ocelot_projectional_editor_cell_clipboard_PasteHandler$0(function_0) {
    this.eav_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_projectional_editor_cell_clipboard_PasteHandler$0).vak = function (sourceItem) {
    return this.eav_1(sourceItem);
  };
  protoOf(sam$jetbrains_ocelot_projectional_editor_cell_clipboard_PasteHandler$0).f3 = function () {
    return this.eav_1;
  };
  protoOf(sam$jetbrains_ocelot_projectional_editor_cell_clipboard_PasteHandler$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, PasteHandler) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_projectional_editor_cell_clipboard_PasteHandler$0).hashCode = function () {
    return hashCode(this.f3());
  };
  function PasteHandler$plus$lambda(this$0, $other) {
    return function (sourceItem) {
      return this$0.vak(sourceItem).o38($other.vak(sourceItem));
    };
  }
  function PasteHandler() {
  }
  function ProjectionalClipboardContent(itemKind, items) {
    this.gav_1 = itemKind;
    this.hav_1 = items;
  }
  protoOf(ProjectionalClipboardContent).e8i = function (kind) {
    return this.hav_1.p() <= 1 && equals(kind, this.gav_1) || equals(kind, ContentKinds_getInstance().i8m(this.gav_1));
  };
  function get$capture(this$0, htmlText, kind) {
    return doGetListPersister$default(this$0, kind).p25(htmlText);
  }
  function serializeStructure($this, content, textual) {
    var tmp;
    if (content.hav_1.p() > 1) {
      var p = doGetListPersister($this, content.gav_1, textual);
      tmp = ensureNotNull(p.w24(content.hav_1));
    } else {
      var p_0 = doGetPersister($this, content.gav_1, textual);
      tmp = ensureNotNull(p_0.w24(content.hav_1.r(0)));
    }
    return tmp;
  }
  function doGetPersister($this, contentKind, textualContent) {
    var p = $this.jav(contentKind);
    return new ProjectionalClipboardContentSerializationAsHtml$doGetPersister$1(p, $this, textualContent, contentKind);
  }
  function doGetPersister$default($this, contentKind, textualContent, $super) {
    textualContent = textualContent === VOID ? null : textualContent;
    return doGetPersister($this, contentKind, textualContent);
  }
  function doGetListPersister($this, contentKind, textualContent) {
    var p = $this.jav(contentKind);
    return new ProjectionalClipboardContentSerializationAsHtml$doGetListPersister$1($this, p, textualContent, contentKind);
  }
  function doGetListPersister$default($this, contentKind, textualContent, $super) {
    textualContent = textualContent === VOID ? null : textualContent;
    return doGetListPersister($this, contentKind, textualContent);
  }
  function encloseInHtmlPre($this, _this__u8e3s4, content) {
    var tmp = '<pre dir="' + escapeHtml($this, _this__u8e3s4) + '">';
    var tmp1_elvis_lhs = content == null ? null : escapeHtml($this, content);
    return tmp + (tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs) + '<\/pre>';
  }
  function escapeHtml($this, _this__u8e3s4) {
    // Inline function 'kotlin.collections.fold' call
    var accumulator = _this__u8e3s4;
    var _iterator__ex2g4s = $this.iav_1.m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      var s = accumulator;
      accumulator = replace(s, element.pg_1, element.qg_1);
    }
    return accumulator;
  }
  function deEscapeHtml($this, _this__u8e3s4) {
    // Inline function 'kotlin.collections.fold' call
    var accumulator = _this__u8e3s4;
    var _iterator__ex2g4s = $this.iav_1.m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      var s = accumulator;
      accumulator = replace(s, element.qg_1, element.pg_1);
    }
    return accumulator;
  }
  function extractFromHtmlPre($this, _this__u8e3s4) {
    var trimmedOpening = substringAfter(_this__u8e3s4, '<pre dir="');
    var result = deEscapeHtml($this, substringBefore(trimmedOpening, '">'));
    return to(result, substringAfter(_this__u8e3s4, '<\/pre>'));
  }
  function encloseInDiv($this, _this__u8e3s4, contentKind, multiple) {
    return openingDiv($this, contentKind, multiple) + _this__u8e3s4 + '<\/div>';
  }
  function openingDiv($this, contentKind, multiple) {
    return openingDivPart($this, contentKind, multiple) + '>';
  }
  function openingDivPart($this, contentKind, multiple) {
    return '<div class="ocelot-projectional-' + multiple + '-' + toString_1(contentKind) + '-end"';
  }
  function extractFromDiv($this, _this__u8e3s4) {
    return substringBefore(substringAfter(_this__u8e3s4, ', end">'), '<\/div>');
  }
  function encloseInAuxiliaryPre($this, _this__u8e3s4) {
    return _this__u8e3s4 == null ? '' : '<pre class="y">' + escapeHtml($this, _this__u8e3s4) + '<\/pre>';
  }
  function trimAuxiliaryPre($this, _this__u8e3s4) {
    return substringBefore(_this__u8e3s4, '<pre class="y">');
  }
  function Companion_204() {
    Companion_instance_204 = this;
    this.kav_1 = '<pre dir="';
    this.lav_1 = '">';
    this.mav_1 = '<\/pre>';
    this.nav_1 = '<pre class="y">';
    var tmp = this;
    // Inline function 'kotlin.text.toRegex' call
    var this_0 = 'div class="ocelot-projectional-.+-.+-end"';
    tmp.oav_1 = Regex_init_$Create$(this_0);
    this.pav_1 = 'text/html';
  }
  var Companion_instance_204;
  function Companion_getInstance_204() {
    if (Companion_instance_204 == null)
      new Companion_204();
    return Companion_instance_204;
  }
  function ProjectionalClipboardContentSerializationAsHtml$deserialize$1($htmlText, this$0, $data) {
    this.qav_1 = $htmlText;
    this.rav_1 = this$0;
    this.sav_1 = $data;
  }
  protoOf(ProjectionalClipboardContentSerializationAsHtml$deserialize$1).e8i = function (kind) {
    var multiple = kind instanceof ListContentKind;
    var tmp0_safe_receiver = kind instanceof ListContentKind ? kind : null;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.e8m_1;
    var baseKind = tmp1_elvis_lhs == null ? kind : tmp1_elvis_lhs;
    return contains_8(this.qav_1, openingDivPart(this.rav_1, baseKind, multiple));
  };
  protoOf(ProjectionalClipboardContentSerializationAsHtml$deserialize$1).g8i = function () {
    var tmp0_elvis_lhs = this.sav_1.q2('text/plain');
    return tmp0_elvis_lhs == null ? toString_1(this) : tmp0_elvis_lhs;
  };
  protoOf(ProjectionalClipboardContentSerializationAsHtml$deserialize$1).f8i = function (kind) {
    var tmp;
    if (this.rav_1.tav(kind)) {
      tmp = doGetPersister$default(this.rav_1, kind).p25(this.qav_1);
    } else {
      var tmp_0;
      if (kind instanceof ListContentKind) {
        tmp_0 = this.rav_1.tav(kind.e8m_1);
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        var tmp_1 = get$capture(this.rav_1, this.qav_1, kind.e8m_1);
        tmp = !(tmp_1 == null) ? tmp_1 : THROW_CCE();
      } else {
        throw IllegalStateException_init_$Create$_0('get() is out of sync with isSupported()');
      }
    }
    return tmp;
  };
  function ProjectionalClipboardContentSerializationAsHtml$doGetPersister$1($p, this$0, $textualContent, $contentKind) {
    this.uav_1 = $p;
    this.vav_1 = this$0;
    this.wav_1 = $textualContent;
    this.xav_1 = $contentKind;
  }
  protoOf(ProjectionalClipboardContentSerializationAsHtml$doGetPersister$1).m25 = function () {
    return this.uav_1.m25();
  };
  protoOf(ProjectionalClipboardContentSerializationAsHtml$doGetPersister$1).n25 = function (value) {
    return encloseInDiv(this.vav_1, encloseInHtmlPre(this.vav_1, this.uav_1.n25(value), this.wav_1), this.xav_1, false);
  };
  protoOf(ProjectionalClipboardContentSerializationAsHtml$doGetPersister$1).o25 = function (value) {
    var serializedNode = extractFromHtmlPre(this.vav_1, extractFromDiv(this.vav_1, value)).pg_1;
    return this.uav_1.o25(serializedNode);
  };
  function ProjectionalClipboardContentSerializationAsHtml$doGetListPersister$1(this$0, $p, $textualContent, $contentKind) {
    this.yav_1 = this$0;
    this.zav_1 = $p;
    this.aaw_1 = $textualContent;
    this.baw_1 = $contentKind;
  }
  protoOf(ProjectionalClipboardContentSerializationAsHtml$doGetListPersister$1).m25 = function () {
    return new DefaultValueNullPersister(emptyList());
  };
  protoOf(ProjectionalClipboardContentSerializationAsHtml$doGetListPersister$1).caw = function (value) {
    // Inline function 'kotlin.collections.fold' call
    var accumulator = '';
    var _iterator__ex2g4s = value.m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      accumulator = accumulator + encloseInHtmlPre(this.yav_1, this.zav_1.n25(element), null);
    }
    var nodes = accumulator;
    var nodesAndText = nodes + encloseInAuxiliaryPre(this.yav_1, this.aaw_1);
    return encloseInDiv(this.yav_1, nodesAndText, this.baw_1, true);
  };
  protoOf(ProjectionalClipboardContentSerializationAsHtml$doGetListPersister$1).n25 = function (value) {
    return this.caw((!(value == null) ? isInterface(value, KtList) : false) ? value : THROW_CCE());
  };
  protoOf(ProjectionalClipboardContentSerializationAsHtml$doGetListPersister$1).o25 = function (value) {
    // Inline function 'kotlin.collections.arrayListOf' call
    var result = ArrayList_init_$Create$();
    var current = trimAuxiliaryPre(this.yav_1, extractFromDiv(this.yav_1, value));
    $l$loop: while (true) {
      // Inline function 'kotlin.text.isNotEmpty' call
      var this_0 = current;
      if (!(charSequenceLength(this_0) > 0)) {
        break $l$loop;
      }
      var _destruct__k2r9zo = extractFromHtmlPre(this.yav_1, current);
      var serializedNode = _destruct__k2r9zo.fg();
      var rest = _destruct__k2r9zo.gg();
      var node = this.zav_1.o25(serializedNode);
      result.j(node);
      current = rest;
    }
    return result;
  };
  function ProjectionalClipboardContentSerializationAsHtml() {
    Companion_getInstance_204();
    this.iav_1 = listOf_0([to('&', '&amp;'), to('<', '&lt;'), to('>', '&gt;'), to('"', '&quot;')]);
  }
  protoOf(ProjectionalClipboardContentSerializationAsHtml).a8p = function (content) {
    var tmp;
    if (content instanceof ProjectionalClipboardContent) {
      tmp = this.tav(content.gav_1);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(ProjectionalClipboardContentSerializationAsHtml).b8p = function (content) {
    if (!(content instanceof ProjectionalClipboardContent))
      THROW_CCE();
    var textual = getText(content);
    var textData = new MimeTypedData('text/plain', textual);
    var structure = serializeStructure(this, content, textual);
    var structureData = new MimeTypedData('text/html', structure);
    return mimeDataSet(listOf_0([structureData, textData]));
  };
  protoOf(ProjectionalClipboardContentSerializationAsHtml).y8o = function (data) {
    var tmp0_elvis_lhs = data.q2('text/html');
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var htmlText = tmp;
    if (!Companion_getInstance_204().oav_1.bd(htmlText))
      return null;
    return new ProjectionalClipboardContentSerializationAsHtml$deserialize$1(htmlText, this, data);
  };
  function createCopyClipboardContent($this, items) {
    return createClipboardContent($this, ensureNotNull($this.uam_1), items, false);
  }
  function OurClipboardContent() {
  }
  function createClipboardContent($this, clipboardParams, items, isCut) {
    var clonerSupport = ensureNotNull($this.vam_1);
    var copiedItems = clonerSupport.dav(items, true);
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(copiedItems, 10));
    var _iterator__ex2g4s = copiedItems.m();
    while (_iterator__ex2g4s.n()) {
      var item = _iterator__ex2g4s.o();
      var tmp$ret$0 = clipboardParams.aav_1(item);
      destination.j(tmp$ret$0);
    }
    var contents = destination;
    return new ProjectionalClipboardHandler$createClipboardContent$1($this, copiedItems, items, clipboardParams, contents, isCut);
  }
  function itemsToStringSupported($this) {
    return !($this.xam_1 == null) || !($this.wam_1 == null);
  }
  function itemsToString($this, items) {
    if (!($this.xam_1 == null)) {
      return ensureNotNull($this.xam_1)(items);
    }
    if (!($this.wam_1 == null)) {
      return ensureNotNull($this.wam_1)(items.r(0));
    }
    throw IllegalStateException_init_$Create$_0('itemsToStringSupported() and itemsToString() are inconsistent');
  }
  function itemsDefaultToString($this, items) {
    return joinToString_0(items, '\n', VOID, VOID, VOID, VOID, ProjectionalClipboardHandler$itemsDefaultToString$lambda($this));
  }
  function preserveOnPaste($this, _this__u8e3s4) {
    var tmp;
    if (isInterface(_this__u8e3s4, OurClipboardContent)) {
      tmp = _this__u8e3s4.daw();
    } else {
      tmp = false;
    }
    return tmp;
  }
  function ProjectionalClipboardHandler$createClipboardContent$1(this$0, $copiedItems, $items, $clipboardParams, $contents, $isCut) {
    this.iaw_1 = $contents;
    this.jaw_1 = $isCut;
    ProjectionalClipboardContent.call(this, $clipboardParams.yau_1, $contents);
    this.gaw_1 = 0;
    var tmp = this;
    var tmp_0;
    if (itemsToStringSupported(this$0)) {
      tmp_0 = itemsToString(this$0, $copiedItems);
    } else {
      tmp_0 = itemsDefaultToString(this$0, $items);
    }
    tmp.haw_1 = tmp_0;
  }
  protoOf(ProjectionalClipboardHandler$createClipboardContent$1).daw = function () {
    return this.jaw_1 && this.gaw_1 === 0;
  };
  protoOf(ProjectionalClipboardHandler$createClipboardContent$1).f8i = function (kind) {
    this.gaw_1 = this.gaw_1 + 1 | 0;
    var tmp;
    if (equals(kind, this.gav_1)) {
      var tmp_0 = this.iaw_1.r(0);
      tmp = !(tmp_0 == null) ? tmp_0 : THROW_CCE();
    } else {
      var tmp_1 = this.iaw_1;
      tmp = !(tmp_1 == null) ? tmp_1 : THROW_CCE();
    }
    return tmp;
  };
  protoOf(ProjectionalClipboardHandler$createClipboardContent$1).g8i = function () {
    return this.haw_1;
  };
  function ProjectionalClipboardHandler$itemsDefaultToString$lambda(this$0) {
    return function (it) {
      return this$0.tam_1(it);
    };
  }
  function ProjectionalClipboardHandler(isMultiItemPasteSupported, defaultItemToString) {
    this.sam_1 = isMultiItemPasteSupported;
    this.tam_1 = defaultItemToString;
    this.uam_1 = null;
    this.vam_1 = null;
    this.wam_1 = null;
    this.xam_1 = null;
    this.yam_1 = new ListMap();
    this.zam_1 = new ListMap();
  }
  protoOf(ProjectionalClipboardHandler).kaw = function (kind, clonerSupport) {
    var clipboardParameters = Companion_instance_203.xau(kind, clonerSupport);
    this.jau(clipboardParameters);
  };
  protoOf(ProjectionalClipboardHandler).law = function (kind, clonerSupport) {
    return this.kaw(kind, clonerSupport);
  };
  protoOf(ProjectionalClipboardHandler).jau = function (clipboardParameters) {
    this.uam_1 = clipboardParameters;
    this.vam_1 = clipboardParameters.zau_1;
    this.yam_1.t2(clipboardParameters.yau_1, clipboardParameters.bav_1);
  };
  protoOf(ProjectionalClipboardHandler).maw = function (clipboardParameters) {
    return this.jau(clipboardParameters);
  };
  protoOf(ProjectionalClipboardHandler).rau = function (items) {
    return createClipboardContent(this, ensureNotNull(this.uam_1), items, true);
  };
  protoOf(ProjectionalClipboardHandler).tau = function (content) {
    var _iterator__ex2g4s = this.yam_1.x2m().m();
    while (_iterator__ex2g4s.n()) {
      var kind = _iterator__ex2g4s.o();
      if (content.e8i(kind) || (this.sam_1 && content.e8i(ContentKinds_getInstance().i8m(kind)))) {
        return true;
      }
    }
    if (this.sam_1) {
      var _iterator__ex2g4s_0 = this.zam_1.x2m().m();
      while (_iterator__ex2g4s_0.n()) {
        var kind_0 = _iterator__ex2g4s_0.o();
        if (content.e8i(kind_0)) {
          return true;
        }
      }
    }
    return false;
  };
  protoOf(ProjectionalClipboardHandler).vau = function () {
    return !(this.uam_1 == null) || itemsToStringSupported(this);
  };
  protoOf(ProjectionalClipboardHandler).qau = function () {
    return !(this.uam_1 == null);
  };
  protoOf(ProjectionalClipboardHandler).wau = function (items) {
    var tmp;
    if (!(this.uam_1 == null)) {
      tmp = createCopyClipboardContent(this, items);
    } else if (itemsToStringSupported(this)) {
      tmp = TextContentHelper_getInstance().r8m(itemsToString(this, items));
    } else {
      throw IllegalStateException_init_$Create$_0('canCopyWholeItems() and copyWholeItems() are inconsistent');
    }
    return tmp;
  };
  protoOf(ProjectionalClipboardHandler).sau = function (clipboardContent) {
    var preserveMode = preserveOnPaste(this, clipboardContent);
    var clonerSupport = ensureNotNull(this.vam_1);
    var _iterator__ex2g4s = this.yam_1.z2m().m();
    $l$loop_0: while (_iterator__ex2g4s.n()) {
      var entry = _iterator__ex2g4s.o();
      var contentKind = entry.n2m();
      var tmp = entry.o2m();
      var fromContent = typeof tmp === 'function' ? tmp : THROW_CCE();
      if (clipboardContent.e8i(contentKind)) {
        var tmp0_elvis_lhs = fromContent(clipboardContent.f8i(contentKind));
        var tmp_0;
        if (tmp0_elvis_lhs == null) {
          continue $l$loop_0;
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        var item = tmp_0;
        var copiedItem = clonerSupport.cav(item, preserveMode);
        return listOf(copiedItem);
      } else if (this.sam_1) {
        var listContentKind = ContentKinds_getInstance().i8m(contentKind);
        if (clipboardContent.e8i(listContentKind)) {
          var list = clipboardContent.f8i(listContentKind);
          // Inline function 'kotlin.collections.mapNotNull' call
          // Inline function 'kotlin.collections.mapNotNullTo' call
          var destination = ArrayList_init_$Create$();
          // Inline function 'kotlin.collections.forEach' call
          var _iterator__ex2g4s_0 = list.m();
          while (_iterator__ex2g4s_0.n()) {
            var element = _iterator__ex2g4s_0.o();
            var tmp0_safe_receiver = fromContent(element);
            if (tmp0_safe_receiver == null)
              null;
            else {
              // Inline function 'kotlin.let' call
              destination.j(tmp0_safe_receiver);
            }
          }
          var convertedList = destination;
          if (convertedList.p() < list.p()) {
            continue $l$loop_0;
          }
          return clonerSupport.dav(convertedList, preserveMode);
        }
      }
    }
    if (this.sam_1) {
      var _iterator__ex2g4s_1 = this.zam_1.z2m().m();
      while (_iterator__ex2g4s_1.n()) {
        var entry_0 = _iterator__ex2g4s_1.o();
        var contentKind_0 = entry_0.n2m();
        if (clipboardContent.e8i(contentKind_0)) {
          var value = entry_0.o2m();
          var fromContent_0 = (!(value == null) ? typeof value === 'function' : false) ? value : THROW_CCE();
          var items = fromContent_0(clipboardContent.f8i(contentKind_0));
          return clonerSupport.dav(items, preserveMode);
        }
      }
    }
    return null;
  };
  function RoleCompletion() {
  }
  function toRoleCompletion(_this__u8e3s4) {
    var tmp = toRoleCompletion$lambda(_this__u8e3s4);
    return new sam$jetbrains_ocelot_projectional_editor_generic_roleCompletion_RoleCompletion$0(tmp);
  }
  function emptyRoleCompletion() {
    var tmp = emptyRoleCompletion$lambda;
    return new sam$jetbrains_ocelot_projectional_editor_generic_roleCompletion_RoleCompletion$0_0(tmp);
  }
  function sam$jetbrains_ocelot_projectional_editor_generic_roleCompletion_RoleCompletion$0(function_0) {
    this.naw_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_projectional_editor_generic_roleCompletion_RoleCompletion$0).oan = function (mapper, contextNode, target) {
    return this.naw_1(mapper, contextNode, target);
  };
  protoOf(sam$jetbrains_ocelot_projectional_editor_generic_roleCompletion_RoleCompletion$0).f3 = function () {
    return this.naw_1;
  };
  protoOf(sam$jetbrains_ocelot_projectional_editor_generic_roleCompletion_RoleCompletion$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, RoleCompletion) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_projectional_editor_generic_roleCompletion_RoleCompletion$0).hashCode = function () {
    return hashCode(this.f3());
  };
  function sam$jetbrains_ocelot_projectional_editor_generic_roleCompletion_RoleCompletion$0_0(function_0) {
    this.oaw_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_projectional_editor_generic_roleCompletion_RoleCompletion$0_0).oan = function (mapper, contextNode, target) {
    return this.oaw_1(mapper, contextNode, target);
  };
  protoOf(sam$jetbrains_ocelot_projectional_editor_generic_roleCompletion_RoleCompletion$0_0).f3 = function () {
    return this.oaw_1;
  };
  protoOf(sam$jetbrains_ocelot_projectional_editor_generic_roleCompletion_RoleCompletion$0_0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, RoleCompletion) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_projectional_editor_generic_roleCompletion_RoleCompletion$0_0).hashCode = function () {
    return hashCode(this.f3());
  };
  function toRoleCompletion$lambda($this_toRoleCompletion) {
    return function (_unused_var__etf5q3, contextNode, role) {
      // Inline function 'kotlin.collections.flatMap' call
      var tmp0 = $this_toRoleCompletion;
      // Inline function 'kotlin.collections.flatMapTo' call
      var destination = ArrayList_init_$Create$();
      var _iterator__ex2g4s = tmp0.m();
      while (_iterator__ex2g4s.n()) {
        var element = _iterator__ex2g4s.o();
        var list = element.paw(contextNode, role);
        addAll_1(destination, list);
      }
      return toCompletionSupplier(destination);
    };
  }
  function emptyRoleCompletion$lambda(_unused_var__etf5q3, _unused_var__etf5q3_0, _unused_var__etf5q3_1) {
    return get_EMPTY_COMPLETION_SUPPLIER();
  }
  var JoinDirection_FORWARD_instance;
  var JoinDirection_BACKWARD_instance;
  var JoinDirection_entriesInitialized;
  function JoinDirection_initEntries() {
    if (JoinDirection_entriesInitialized)
      return Unit_instance;
    JoinDirection_entriesInitialized = true;
    JoinDirection_FORWARD_instance = new JoinDirection('FORWARD', 0);
    JoinDirection_BACKWARD_instance = new JoinDirection('BACKWARD', 1);
  }
  function NotSupported() {
  }
  protoOf(NotSupported).pap = function (items, index, views) {
    return false;
  };
  protoOf(NotSupported).qap = function (items, index, views) {
    throw UnsupportedOperationException_init_$Create$();
  };
  protoOf(NotSupported).rap = function (items, leftIndex, direction) {
    return false;
  };
  protoOf(NotSupported).sap = function (items, leftIndex, direction) {
    throw UnsupportedOperationException_init_$Create$();
  };
  function JoinDirection(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function JoinDirection_FORWARD_getInstance() {
    JoinDirection_initEntries();
    return JoinDirection_FORWARD_instance;
  }
  function JoinDirection_BACKWARD_getInstance() {
    JoinDirection_initEntries();
    return JoinDirection_BACKWARD_instance;
  }
  function BaseSelectionCaptureTrait(getSelectionSupport) {
    CellTrait.call(this);
    this.qaw_1 = getSelectionSupport;
  }
  protoOf(BaseSelectionCaptureTrait).s8z = function (cell, event) {
    var selectionSupport = this.qaw_1(cell);
    selectionSupport.ban_1.raw(cell, event, selectionSupport);
    if (!event.l8i_1) {
      protoOf(CellTrait).s8z.call(this, cell, event);
    }
  };
  protoOf(BaseSelectionCaptureTrait).x8z = function (cell, prop, event) {
    var tmp;
    if (prop === Companion_getInstance_154().j8x_1) {
      var tmp_0 = event.t2y_1;
      tmp = (!(tmp_0 == null) ? typeof tmp_0 === 'boolean' : false) ? tmp_0 : THROW_CCE();
    } else {
      tmp = false;
    }
    if (tmp) {
      this.qaw_1(cell).saw();
    } else {
      protoOf(CellTrait).x8z.call(this, cell, prop, event);
    }
  };
  function BaseSelectionSpec$KeyDirection$FORWARD() {
    KeyDirection.call(this, 'FORWARD', 0);
    KeyDirection_FORWARD_instance = this;
  }
  protoOf(BaseSelectionSpec$KeyDirection$FORWARD).vaw = function () {
    return 1;
  };
  protoOf(BaseSelectionSpec$KeyDirection$FORWARD).waw = function (cell) {
    return Positions_instance.ua4(ensureNotNull(cell));
  };
  protoOf(BaseSelectionSpec$KeyDirection$FORWARD).xaw = function (interval) {
    return ensureNotNull(interval).w36_1;
  };
  protoOf(BaseSelectionSpec$KeyDirection$FORWARD).yaw = function (interval) {
    return interval.v36_1;
  };
  protoOf(BaseSelectionSpec$KeyDirection$FORWARD).zaw = function (list) {
    return list.p() - 1 | 0;
  };
  var KeyDirection_FORWARD_instance;
  function BaseSelectionSpec$KeyDirection$BACKWARD() {
    KeyDirection.call(this, 'BACKWARD', 1);
    KeyDirection_BACKWARD_instance = this;
  }
  protoOf(BaseSelectionSpec$KeyDirection$BACKWARD).vaw = function () {
    return -1;
  };
  protoOf(BaseSelectionSpec$KeyDirection$BACKWARD).waw = function (cell) {
    return Positions_instance.ta4(ensureNotNull(cell));
  };
  protoOf(BaseSelectionSpec$KeyDirection$BACKWARD).xaw = function (interval) {
    return ensureNotNull(interval).v36_1;
  };
  protoOf(BaseSelectionSpec$KeyDirection$BACKWARD).yaw = function (interval) {
    return interval.w36_1;
  };
  protoOf(BaseSelectionSpec$KeyDirection$BACKWARD).zaw = function (list) {
    return 0;
  };
  var KeyDirection_BACKWARD_instance;
  var KeyDirection_entriesInitialized;
  function KeyDirection_initEntries() {
    if (KeyDirection_entriesInitialized)
      return Unit_instance;
    KeyDirection_entriesInitialized = true;
    KeyDirection_FORWARD_instance = new BaseSelectionSpec$KeyDirection$FORWARD();
    KeyDirection_BACKWARD_instance = new BaseSelectionSpec$KeyDirection$BACKWARD();
  }
  function handleDragEvent($this, location) {
    if ($this.eax_1.gax(location)) {
      return false;
    }
    if ($this.eax_1.kan().s() && $this.dax_1 == null) {
      var tmp0_elvis_lhs = $this.eax_1.hax();
      var tmp;
      if (tmp0_elvis_lhs == null) {
        return true;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var startCell = tmp;
      $this.dax_1 = getStartPoint($this, startCell);
    }
    var handleResult = (new MouseSelectionHandler($this.eax_1)).jax(ensureNotNull($this.dax_1), location);
    if (handleResult.equals(MouseHandleResult_REDISPATCHED_TEXT_getInstance())) {
      ensureNotNull($this.dax_1).kax_1.r92(Companion_instance_141.o8l(location), Companion_getInstance_170().a8z_1);
    }
    return true;
  }
  function getStartPoint($this, cell) {
    if (cell == null) {
      return null;
    }
    var tmp;
    if ($this.eax_1.nax(cell)) {
      tmp = new SimpleSelectionBound(cell, false, false);
    } else {
      tmp = Companion_instance_209.s92(cell);
    }
    return tmp;
  }
  function clearMouseStart($this) {
    $this.dax_1 = null;
  }
  function changeKeyboardSelection($this, direction, support) {
    var currentCell = support.lan();
    if (support.kao() || currentCell == null)
      return false;
    var from = support.fan_1.w(currentCell);
    if (isEmptySideElemSelection($this, from, direction, support)) {
      var ctx = new KeyboardOperationContext(support.zar(), Companion_instance_37.a37(from), direction);
      select_0($this, ctx, support)();
      return true;
    }
    if (isVisuallyEmpty(support.fan_1.r(from))) {
      if (!isWithinBounds($this, from + direction.vaw() | 0, support.can_1)) {
        return false;
      }
      applyDelta($this, from, from + direction.vaw() | 0, direction, support);
      return true;
    }
    if (support.nax(support.fan_1.r(from))) {
      var tmp;
      if (direction.waw(support.fan_1.r(from)) && isWithinBounds($this, from + direction.vaw() | 0, support.can_1)) {
        tmp = from + direction.vaw() | 0;
      } else {
        tmp = from;
      }
      var to = tmp;
      applyDelta($this, from, to, direction, support);
      return true;
    }
    if (direction.waw(support.fan_1.r(from)) || support.rax(support.fan_1.r(from))) {
      if (!isWithinBounds($this, from + direction.vaw() | 0, support.can_1)) {
        return false;
      }
      applyDelta($this, from + direction.vaw() | 0, from + direction.vaw() | 0, direction, support);
      return true;
    }
    applyDelta($this, from, from, direction, support);
    return true;
  }
  function isWithinBounds($this, index, source) {
    return 0 <= index && index < source.p();
  }
  function isEmptySideElemSelection($this, index, direction, support) {
    return isVisuallyEmpty(support.fan_1.r(index)) && direction.zaw(support.can_1) === index && support.kan().s() && support.can_1.p() > 1;
  }
  function select_0($this, ctx, support) {
    if (ensureNotNull(ctx.tax_1).v36_1 > ensureNotNull(ctx.sax_1).w36_1) {
      support.kan().q(ctx.vax(support.can_1));
      support.wax();
      return support.xax(ctx.uax_1.xaw(ctx.tax_1), ctx.uax_1 === KeyDirection_BACKWARD_getInstance());
    }
    var inductionVariable = ctx.tax_1.w36_1;
    var last = ctx.tax_1.v36_1;
    if (last <= inductionVariable)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        support.kan().m2(0, support.can_1.r(i));
      }
       while (!(i === last));
    support.wax();
    return support.xax(ctx.uax_1.xaw(ctx.tax_1), ctx.uax_1 === KeyDirection_BACKWARD_getInstance());
  }
  function KeyDirection(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function direction($this, event) {
    var tmp;
    if (event.o8j([$this.zax_1, KeyStrokeSpecs_getInstance().x8k_1])) {
      tmp = KeyDirection_FORWARD_getInstance();
    } else if (event.o8j([$this.yax_1, KeyStrokeSpecs_getInstance().w8k_1])) {
      tmp = KeyDirection_BACKWARD_getInstance();
    } else {
      throw IllegalArgumentException_init_$Create$_0(event.toString());
    }
    return tmp;
  }
  function applyDelta($this, deltaStart, deltaEnd, direction, support) {
    var rawDelta = SelectionUtil_getInstance().bay(deltaStart, deltaEnd);
    var selection = support.zar();
    if (selection.l37(rawDelta)) {
      var deselectCtx = new KeyboardOperationContext(selection, rawDelta.m37(selection), direction);
      if (canDeselect($this, deselectCtx)) {
        deselect($this, deselectCtx, support)();
        return Unit_instance;
      }
    }
    var selectCtx = new KeyboardOperationContext(selection, SelectionUtil_getInstance().cay(rawDelta, selection), direction);
    if (canSelect($this, selectCtx)) {
      select_0($this, selectCtx, support)();
      return Unit_instance;
    }
    if (selection.l37(rawDelta)) {
      var retainCtx = new KeyboardOperationContext(selection, rawDelta.m37(selection), direction);
      if (canRetain($this, retainCtx)) {
        retain($this, retainCtx, support)();
        return Unit_instance;
      }
    }
    throw IllegalStateException_init_$Create$_0('Inconsistent state: selection' + selection + ', rawDelta=' + rawDelta + ', direction=' + direction.toString());
  }
  function changeKeyboardSideSelection($this, direction, support) {
    if (support.kao() || support.lan() == null)
      return false;
    var selection = support.zar();
    var newSelection = determineNewSideSelection($this, selection, direction, support);
    return applyNewSelection($this, selection, newSelection, direction, support);
  }
  function determineNewSideSelection($this, selection, direction, support) {
    var currentCell = ensureNotNull(support.lan());
    var current = support.fan_1.w(currentCell);
    if (selection.s()) {
      if (support.nax(currentCell) || !direction.waw(currentCell)) {
        return SelectionUtil_getInstance().bay(current, direction.zaw(support.can_1));
      }
      var tmp;
      if (!isWithinBounds($this, current + direction.vaw() | 0, support.can_1)) {
        tmp = SelectionUtil_getInstance().aay_1;
      } else {
        tmp = SelectionUtil_getInstance().bay(current + direction.vaw() | 0, direction.zaw(support.can_1));
      }
      return tmp;
    }
    if (isSameDirection($this, selection, current, direction, support)) {
      return SelectionUtil_getInstance().bay(direction.yaw(selection), direction.zaw(support.can_1));
    }
    var tmp_0;
    if (!isWithinBounds($this, direction.xaw(selection) + direction.vaw() | 0, support.can_1)) {
      tmp_0 = SelectionUtil_getInstance().aay_1;
    } else {
      tmp_0 = SelectionUtil_getInstance().bay(direction.xaw(selection) + direction.vaw() | 0, direction.zaw(support.can_1));
    }
    return tmp_0;
  }
  function isSameDirection($this, selection, current, direction, support) {
    if (selection.equals(Companion_instance_37.a37(current))) {
      return direction.waw(support.fan_1.r(current));
    }
    var extension = SelectionUtil_getInstance().bay(direction.xaw(selection), direction.zaw(support.can_1));
    return extension.i37(current);
  }
  function applyNewSelection($this, selection, newSelection, direction, support) {
    if (newSelection.s()) {
      var deselectCtx = new KeyboardOperationContext(selection, selection, direction);
      if (canDeselect($this, deselectCtx)) {
        deselect($this, deselectCtx, support)();
        return true;
      }
      return false;
    }
    var removed = SelectionUtil_getInstance().cay(selection, newSelection);
    var added = SelectionUtil_getInstance().cay(newSelection, selection);
    var deselectCtx_0 = new KeyboardOperationContext(selection, removed, direction);
    if (canDeselect($this, deselectCtx_0)) {
      var selectCtx = new KeyboardOperationContext(SelectionUtil_getInstance().cay(selection, ensureNotNull(removed)), added, direction);
      if (canSelect($this, selectCtx)) {
        deselect($this, deselectCtx_0, support);
        select_0($this, selectCtx, support)();
      } else {
        deselect($this, deselectCtx_0, support)();
      }
      return true;
    }
    var selectCtx_0 = new KeyboardOperationContext(selection, added, direction);
    if (canSelect($this, selectCtx_0)) {
      select_0($this, selectCtx_0, support)();
      return true;
    }
    return false;
  }
  function canDeselect($this, ctx) {
    if (ctx.day() || ensureNotNull(ctx.sax_1).s()) {
      return false;
    }
    var result = SelectionUtil_getInstance().cay(ctx.sax_1, ensureNotNull(ctx.tax_1));
    if (result == null || equals(result, ctx.sax_1)) {
      return false;
    }
    if (result.s()) {
      return true;
    }
    var cursor = ctx.uax_1.xaw(ctx.tax_1) + ctx.uax_1.vaw() | 0;
    return cursor === result.v36_1 || cursor === result.w36_1;
  }
  function deselect($this, ctx, support) {
    support.kan().j1(ctx.vax(support.can_1));
    support.wax();
    var tmp;
    if (support.kan().s()) {
      tmp = support.xax(ctx.uax_1.xaw(ctx.tax_1), ctx.uax_1 === KeyDirection_BACKWARD_getInstance());
    } else {
      tmp = support.xax(ctx.uax_1.xaw(ctx.tax_1) + ctx.uax_1.vaw() | 0, ctx.uax_1 === KeyDirection_FORWARD_getInstance());
    }
    return tmp;
  }
  function canRetain($this, ctx) {
    return !ctx.day() && !ensureNotNull(ctx.sax_1).s() && ctx.sax_1.l37(ensureNotNull(ctx.tax_1));
  }
  function retain($this, ctx, support) {
    var tmp0 = support.kan();
    // Inline function 'kotlin.collections.retainAll' call
    var elements = ctx.vax(support.can_1);
    (isInterface(tmp0, MutableCollection) ? tmp0 : THROW_CCE()).j2(elements);
    support.wax();
    return support.xax(ctx.uax_1.xaw(ctx.tax_1), ctx.uax_1 === KeyDirection_BACKWARD_getInstance());
  }
  function canSelect($this, ctx) {
    if (ctx.day()) {
      return false;
    }
    var delta = ensureNotNull(ctx.tax_1);
    var initial = ctx.sax_1;
    var result = SelectionUtil_getInstance().eay(initial, delta);
    if (result == null || equals(result, initial)) {
      return false;
    }
    var cursor = ctx.uax_1.xaw(delta);
    return cursor === result.v36_1 || cursor === result.w36_1;
  }
  function KeyboardOperationContext(initial, delta, direction) {
    this.sax_1 = initial;
    this.tax_1 = delta;
    this.uax_1 = direction;
  }
  protoOf(KeyboardOperationContext).day = function () {
    return this.tax_1 == null || this.tax_1.s();
  };
  protoOf(KeyboardOperationContext).vax = function (list) {
    return ensureNotNull(this.tax_1).o37(list);
  };
  function BaseSelectionSpec$createTargetTrait$1($support, this$0) {
    this.eax_1 = $support;
    this.fax_1 = this$0;
    BaseDerivedCellTrait.call(this, new BaseSelectionTargetTrait($support));
    this.dax_1 = null;
  }
  protoOf(BaseSelectionSpec$createTargetTrait$1).q91 = function (cell, event) {
    protoOf(BaseDerivedCellTrait).q91.call(this, cell, event);
    if (!this.eax_1.jan_1 && !this.eax_1.kao()) {
      clearMouseStart(this);
    }
  };
  protoOf(BaseSelectionSpec$createTargetTrait$1).s8z = function (cell, event) {
    this.fax_1.raw(cell, event, this.eax_1);
    if (event.l8i_1) {
      return Unit_instance;
    }
    protoOf(BaseDerivedCellTrait).s8z.call(this, cell, event);
  };
  protoOf(BaseSelectionSpec$createTargetTrait$1).i8y = function (cell, spec, event) {
    if (spec === Cells_getInstance().f9t_1) {
      clearMouseStart(this);
    }
    protoOf(BaseDerivedCellTrait).i8y.call(this, cell, spec, event);
  };
  protoOf(BaseSelectionSpec$createTargetTrait$1).t91 = function (cell, event) {
    if (event.t8l_1.equals(MouseButton_LEFT_getInstance())) {
      clearMouseStart(this);
    }
    protoOf(BaseDerivedCellTrait).t91.call(this, cell, event);
  };
  protoOf(BaseSelectionSpec$createTargetTrait$1).w91 = function (cell, event) {
    if (event.t8l_1.equals(MouseButton_LEFT_getInstance()) && handleDragEvent(this, event.z8l())) {
      event.n8i();
      return Unit_instance;
    }
    protoOf(BaseDerivedCellTrait).w91.call(this, cell, event);
  };
  function BaseSelectionSpec$captureKeyPress$lambda(this$0, $event, $selectionSupport) {
    return function () {
      var tmp;
      if (changeKeyboardSelection(this$0, direction(this$0, $event), $selectionSupport)) {
        $event.n8i();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function BaseSelectionSpec$captureKeyPress$lambda_0(this$0, $event, $selectionSupport) {
    return function () {
      var tmp;
      if (changeKeyboardSideSelection(this$0, direction(this$0, $event), $selectionSupport)) {
        $event.n8i();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function SelectionSupport$clearSelection$ref(p0) {
    var l = function () {
      p0.saw();
      return Unit_instance;
    };
    l.callableName = 'clearSelection';
    return l;
  }
  function KeyDirection_FORWARD_getInstance() {
    KeyDirection_initEntries();
    return KeyDirection_FORWARD_instance;
  }
  function KeyDirection_BACKWARD_getInstance() {
    KeyDirection_initEntries();
    return KeyDirection_BACKWARD_instance;
  }
  function BaseSelectionSpec(selectBefore, selectAfter) {
    selectBefore = selectBefore === VOID ? KeyStrokeSpecs_getInstance().n8l([KeyStrokeSpecs_getInstance().a8l_1, KeyStrokeSpecs_getInstance().c8l_1]) : selectBefore;
    selectAfter = selectAfter === VOID ? KeyStrokeSpecs_getInstance().n8l([KeyStrokeSpecs_getInstance().b8l_1, KeyStrokeSpecs_getInstance().d8l_1]) : selectAfter;
    this.yax_1 = selectBefore;
    this.zax_1 = selectAfter;
  }
  protoOf(BaseSelectionSpec).fay = function (support) {
    return new BaseSelectionSpec$createTargetTrait$1(support, this);
  };
  protoOf(BaseSelectionSpec).raw = function (cell, event, selectionSupport) {
    if (event.o8j([this.yax_1, this.zax_1])) {
      selectionSupport.hay(BaseSelectionSpec$captureKeyPress$lambda(this, event, selectionSupport));
    } else {
      if (event.o8j([KeyStrokeSpecs_getInstance().w8k_1, KeyStrokeSpecs_getInstance().x8k_1])) {
        selectionSupport.hay(BaseSelectionSpec$captureKeyPress$lambda_0(this, event, selectionSupport));
      } else {
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!selectionSupport.kan().s()) {
          var tmp = SelectionUtil_getInstance();
          tmp.gay(cell, event, selectionSupport, SelectionSupport$clearSelection$ref(selectionSupport));
        }
      }
    }
  };
  protoOf(BaseSelectionSpec).iay = function (start, end, support) {
    var currentIndex = indexOf_5(support.fan_1, support.lan());
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.require' call
    if (!(start <= currentIndex ? currentIndex <= end : false)) {
      var message = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
  };
  function findNext_0($this, selectionSupports) {
    var iterator = selectionSupports.m();
    while (iterator.n()) {
      var currentSupport = iterator.o();
      if (equals(currentSupport, $this.jay_1)) {
        if (iterator.n()) {
          return iterator.o();
        }
      }
    }
    return null;
  }
  function cancelSelection($this) {
    var tmp;
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!$this.lay_1.kan().s()) {
      tmp = !$this.lay_1.jan_1;
    } else {
      tmp = false;
    }
    if (tmp) {
      $this.may();
    }
  }
  function handleFocusGain($this, event) {
    var newValue = event.y9t_1;
    var expanded = !(newValue == null) ? expand_0($this, newValue) : null;
    if (expanded == null || !$this.lay_1.fan_1.t(expanded)) {
      expand_0($this, newValue);
      return Unit_instance;
    }
    if ($this.lay_1.jan_1)
      return Unit_instance;
    if (!Cells_getInstance().daa(newValue)) {
      var index = $this.lay_1.fan_1.w(expanded);
      var source = $this.lay_1.can_1;
      $this.lay_1.nay(source.r(index), source.r(index));
    } else {
      cancelSelection($this);
    }
  }
  function expand_0($this, cell) {
    var current = cell;
    while (true) {
      var tmp0_elvis_lhs = ensureNotNull(current).bp();
      var tmp;
      if (tmp0_elvis_lhs == null) {
        return current;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var parent = tmp;
      if (isSingleChild($this, current)) {
        if (parent === $this.lay_1.dan_1)
          return current;
        current = parent;
      } else {
        return current;
      }
    }
  }
  function isSingleChild($this, cell) {
    var tmp0_elvis_lhs = cell.bp();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var parent = tmp;
    var siblings = parent.o35();
    return siblings.t(cell) && siblings.p() === 1;
  }
  function SelectionCellScope(support, focused) {
    CellScope.call(this);
    this.jay_1 = support;
    this.kay_1 = focused;
  }
  protoOf(SelectionCellScope).p38 = function () {
    var tmp;
    if (this.kay_1.f89() && this.jay_1.dan_1.f89()) {
      // Inline function 'kotlin.collections.isNotEmpty' call
      tmp = !this.jay_1.can_1.s();
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(SelectionCellScope).kad = function () {
    return this.kay_1 === getFocused(this.jay_1) && this.jay_1.oay();
  };
  protoOf(SelectionCellScope).mad = function () {
    this.kay_1.s8n();
    var source = this.jay_1.can_1;
    this.jay_1.nay(first(source), last(source));
    CellScrolling_getInstance().xa4(this.kay_1);
  };
  protoOf(SelectionCellScope).oad = function () {
    var target = this.jay_1.dan_1;
    if (this.jay_1.oay() && target.c93(Companion_getInstance_207().ray_1)) {
      var selectionSupports = SelectionSupports_instance.pay(target);
      var next = findNext_0(this, selectionSupports);
      if (!(next == null)) {
        return new SelectionCellScope(next, ensureNotNull(next.fan_1.qay(this.kay_1)));
      }
    }
    var defaultScope = CellScopes_getInstance().rad_1.b90(target);
    return defaultScope == null ? CellScopes_getInstance().sad(target.bp()) : defaultScope;
  };
  function BaseSelectionTargetTrait(support) {
    CellTrait.call(this);
    this.lay_1 = support;
  }
  protoOf(BaseSelectionTargetTrait).p91 = function (cell, event) {
    protoOf(CellTrait).p91.call(this, cell, event);
    handleFocusGain(this, event);
  };
  protoOf(BaseSelectionTargetTrait).q91 = function (cell, event) {
    protoOf(CellTrait).q91.call(this, cell, event);
    var tmp;
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!this.lay_1.kan().s()) {
      tmp = !this.lay_1.jan_1;
    } else {
      tmp = false;
    }
    if (tmp) {
      cancelSelection(this);
    }
  };
  protoOf(BaseSelectionTargetTrait).may = function () {
    this.lay_1.saw();
  };
  protoOf(BaseSelectionTargetTrait).i8y = function (cell, spec, event) {
    if (spec === Cells_getInstance().f9t_1) {
      cancelSelection(this);
    } else {
      protoOf(CellTrait).i8y.call(this, cell, spec, event);
    }
  };
  protoOf(BaseSelectionTargetTrait).t91 = function (cell, event) {
    if (event.t8l_1.equals(MouseButton_LEFT_getInstance()) && !event.u8l_1.z8j_1) {
      cancelSelection(this);
    }
    protoOf(CellTrait).t91.call(this, cell, event);
  };
  protoOf(BaseSelectionTargetTrait).n91 = function (cell, spec) {
    if (spec === Companion_getInstance_208().say_1) {
      return this.lay_1;
    }
    var tmp;
    if (spec === CellScopes_getInstance().rad_1 && canCreateFrom(this.lay_1)) {
      tmp = new SelectionCellScope(this.lay_1, ensureNotNull(getFocused(this.lay_1)));
    } else {
      tmp = protoOf(CellTrait).n91.call(this, cell, spec);
    }
    return tmp;
  };
  function canCreateFrom(selectionSupport) {
    var tmp;
    if (!(getFocused(selectionSupport) == null)) {
      // Inline function 'kotlin.collections.isNotEmpty' call
      tmp = !selectionSupport.can_1.s();
    } else {
      tmp = false;
    }
    return tmp;
  }
  function getFocused(support) {
    return ensureNotNull(support.dan_1.s8x()).z92().uv();
  }
  function CellSelection() {
  }
  function Companion_205() {
  }
  var Companion_instance_205;
  function Companion_getInstance_205() {
    return Companion_instance_205;
  }
  function EditorSelectionBound(editor, position) {
    SelectionBound.call(this, editor, position === 0, position === editor.w96());
    this.way_1 = position;
  }
  protoOf(EditorSelectionBound).xay = function () {
    var reverted;
    if (this.kax_1.y92().uv() && this.kax_1.t96().uv() === this.way_1) {
      reverted = false;
    } else {
      reverted = true;
      toPosition(this.kax_1, this.way_1)();
    }
    return reverted;
  };
  protoOf(EditorSelectionBound).hashCode = function () {
    return imul(hashCode(this.kax_1), 37) + this.way_1 | 0;
  };
  protoOf(EditorSelectionBound).equals = function (other) {
    if (other instanceof EditorSelectionBound) {
      var that = other instanceof EditorSelectionBound ? other : THROW_CCE();
      return equals(this.kax_1, ensureNotNull(that).kax_1) && this.way_1 === that.way_1;
    }
    return false;
  };
  var MouseHandleResult_HANDLED_instance;
  var MouseHandleResult_REDISPATCHED_TEXT_instance;
  var MouseHandleResult_SKIPPED_instance;
  var MouseHandleResult_entriesInitialized;
  function MouseHandleResult_initEntries() {
    if (MouseHandleResult_entriesInitialized)
      return Unit_instance;
    MouseHandleResult_entriesInitialized = true;
    MouseHandleResult_HANDLED_instance = new MouseHandleResult('HANDLED', 0);
    MouseHandleResult_REDISPATCHED_TEXT_instance = new MouseHandleResult('REDISPATCHED_TEXT', 1);
    MouseHandleResult_SKIPPED_instance = new MouseHandleResult('SKIPPED', 2);
  }
  function MouseHandleResult(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function MouseHandleResult_HANDLED_getInstance() {
    MouseHandleResult_initEntries();
    return MouseHandleResult_HANDLED_instance;
  }
  function MouseHandleResult_REDISPATCHED_TEXT_getInstance() {
    MouseHandleResult_initEntries();
    return MouseHandleResult_REDISPATCHED_TEXT_instance;
  }
  function MouseHandleResult_SKIPPED_getInstance() {
    MouseHandleResult_initEntries();
    return MouseHandleResult_SKIPPED_instance;
  }
  var MouseChangeKind_NONE_instance;
  var MouseChangeKind_SELECT_instance;
  var MouseChangeKind_DESELECT_instance;
  var MouseChangeKind_entriesInitialized;
  function MouseChangeKind_initEntries() {
    if (MouseChangeKind_entriesInitialized)
      return Unit_instance;
    MouseChangeKind_entriesInitialized = true;
    MouseChangeKind_NONE_instance = new MouseChangeKind('NONE', 0);
    MouseChangeKind_SELECT_instance = new MouseChangeKind('SELECT', 1);
    MouseChangeKind_DESELECT_instance = new MouseChangeKind('DESELECT', 2);
  }
  function _get_selectionRange__oxzehm($this) {
    return $this.iax_1.zar();
  }
  function trySetPosition($this, cell, location) {
    var tmp = Cells_getInstance();
    var tmp0_elvis_lhs = tmp.eaa(cell, location, MouseSelectionHandler$trySetPosition$lambda);
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var closestCell = tmp_0;
    var editor = closestCell instanceof TextCell ? closestCell : THROW_CCE();
    var caret = editor.m97(location.d8c_1 - get_origin(editor).d8c_1 | 0);
    if (caret === 0) {
      toHome(editor)();
      return true;
    }
    if (caret === editor.w96()) {
      toEnd_0(editor)();
      return true;
    }
    toPosition(editor, caret)();
    return true;
  }
  function isMultiline($this, cell) {
    var firstVisibleLeaf_0 = ensureNotNull(firstVisibleLeaf(cell));
    var lastVisibleLeaf_0 = ensureNotNull(lastVisibleLeaf(cell));
    return isAbove(firstVisibleLeaf_0, lastVisibleLeaf_0);
  }
  function checkOrdered($this, a, b, condition) {
    return isDescendant(a, b) || isDescendant(b, a) ? false : Composites_instance.h36(a, b) ? condition(a, b) : condition(b, a);
  }
  function getChild_0($this, location) {
    var bestChild = -1;
    var bestDistance = 1.7976931348623157E308;
    var inductionVariable = 0;
    var last = $this.iax_1.fan_1.p();
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var child = $this.iax_1.fan_1.r(i);
        if (!(Cells_getInstance().u93(child, location) == null)) {
          return i;
        }
        var tmp = Cells_getInstance();
        var leaf = tmp.eaa(child, location, Cells$isLeaf$ref(Cells_getInstance()));
        if (!(leaf == null)) {
          var distance = get_bounds(leaf).s8c(location);
          if (distance < bestDistance) {
            bestChild = i;
            bestDistance = distance;
          }
        }
      }
       while (inductionVariable < last);
    return bestChild;
  }
  function toBound($this, childIndex, location) {
    var child = $this.iax_1.fan_1.r(childIndex);
    if (child.c93(TextEditing_getInstance().t99_1) || child.c93(TextEditing_getInstance().s99_1)) {
      var editor = child instanceof TextCell ? child : THROW_CCE();
      var position = editor.m97(location.d8c_1);
      return new EditorSelectionBound(editor, position);
    }
    return new SimpleSelectionBound(child, false, false);
  }
  function changeMouseSelection($this, startIndex, endIndex, endLocation) {
    if (startIndex === -1 || endIndex === -1) {
      return Unit_instance;
    }
    if (startIndex === endIndex && selectedItems($this).s() && !isDraggedEnough($this, startIndex, endLocation)) {
      return Unit_instance;
    }
    var oldRange = _get_selectionRange__oxzehm($this);
    var newRange = SelectionUtil_getInstance().bay(startIndex, endIndex);
    if (selectedItems($this).s()) {
      selectedItems($this).q(newRange.o37($this.iax_1.can_1));
    } else if (!newRange.equals(oldRange)) {
      changeSelectedRange($this, oldRange, newRange);
    }
    clearOtherSelections($this);
    var endCell = $this.iax_1.fan_1.r(endIndex);
    if (trySetPosition($this, endCell, endLocation)) {
      return Unit_instance;
    }
    var endCellCenter = get_bounds(endCell).v8c();
    $this.iax_1.xax(endIndex, endLocation.d8c_1 < endCellCenter.d8c_1)();
  }
  function changeSelection($this, r) {
    $this.iax_1.hay(r);
  }
  function selectedItems($this) {
    return $this.iax_1.kan();
  }
  function clearOtherSelections($this) {
    $this.iax_1.wax();
  }
  function isDraggedEnough($this, child, endLocation) {
    var tmp;
    if (isMultiline($this, $this.iax_1.fan_1.r(child))) {
      tmp = isDraggedWide($this, endLocation) || isDraggedTall($this, endLocation);
    } else {
      tmp = isDraggedToFocusable($this, endLocation);
    }
    return tmp;
  }
  function changeSelectedRange($this, oldRange, newRange) {
    if (!oldRange.l37(newRange)) {
      doReplaceSelection($this, newRange);
    } else {
      var leftChange = determineLeftChange($this, oldRange, newRange);
      var rightChange = determineRightChange($this, oldRange, newRange);
      doChangeLeft($this, leftChange);
      doChangeRight($this, rightChange);
    }
  }
  function doReplaceSelection($this, newRange) {
    selectedItems($this).k2();
    selectedItems($this).q(newRange.o37($this.iax_1.can_1));
  }
  function determineLeftChange($this, oldRange, newRange) {
    var common = oldRange.m37(newRange);
    var tmp;
    if (oldRange.v36_1 < common.v36_1) {
      tmp = new MouseChange(MouseChangeKind_DESELECT_getInstance(), new Interval(oldRange.v36_1, common.v36_1 - 1 | 0));
    } else if (newRange.v36_1 < common.v36_1) {
      tmp = new MouseChange(MouseChangeKind_SELECT_getInstance(), new Interval(newRange.v36_1, common.v36_1 - 1 | 0));
    } else {
      tmp = new MouseChange(MouseChangeKind_NONE_getInstance(), null);
    }
    return tmp;
  }
  function determineRightChange($this, oldRange, newRange) {
    var common = oldRange.m37(newRange);
    var tmp;
    if (oldRange.w36_1 > common.w36_1) {
      tmp = new MouseChange(MouseChangeKind_DESELECT_getInstance(), new Interval(common.w36_1 + 1 | 0, oldRange.w36_1));
    } else if (newRange.w36_1 > common.w36_1) {
      tmp = new MouseChange(MouseChangeKind_SELECT_getInstance(), new Interval(common.w36_1 + 1 | 0, newRange.w36_1));
    } else {
      tmp = new MouseChange(MouseChangeKind_NONE_getInstance(), null);
    }
    return tmp;
  }
  function doChangeLeft($this, change) {
    switch (change.yay_1.x2_1) {
      case 0:
        break;
      case 1:
        var _iterator__ex2g4s = ensureNotNull(change.zay_1).h37().m();
        while (_iterator__ex2g4s.n()) {
          var i = _iterator__ex2g4s.o();
          selectedItems($this).m2(0, $this.iax_1.can_1.r(i));
        }

        break;
      case 2:
        var _iterator__ex2g4s_0 = ensureNotNull(change.zay_1).g37().m();
        while (_iterator__ex2g4s_0.n()) {
          var i_0 = _iterator__ex2g4s_0.o();
          var deselected = selectedItems($this).n2(0);
          // Inline function 'kotlin.check' call
          if (!(deselected === $this.iax_1.can_1.r(i_0))) {
            var message = 'i = ' + i_0 + ', deselected=' + deselected + ', mustHaveBeen=' + toString_0($this.iax_1.can_1.r(i_0));
            throw IllegalStateException_init_$Create$_0(toString_1(message));
          }
        }

        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
  }
  function doChangeRight($this, change) {
    switch (change.yay_1.x2_1) {
      case 0:
        break;
      case 1:
        var _iterator__ex2g4s = ensureNotNull(change.zay_1).g37().m();
        while (_iterator__ex2g4s.n()) {
          var i = _iterator__ex2g4s.o();
          selectedItems($this).j($this.iax_1.can_1.r(i));
        }

        break;
      case 2:
        var _iterator__ex2g4s_0 = ensureNotNull(change.zay_1).h37().m();
        while (_iterator__ex2g4s_0.n()) {
          var i_0 = _iterator__ex2g4s_0.o();
          var deselected = selectedItems($this).n2(selectedItems($this).p() - 1 | 0);
          // Inline function 'kotlin.check' call
          if (!(deselected === $this.iax_1.can_1.r(i_0))) {
            var message = 'i = ' + i_0 + ', deselected=' + deselected + ', mustHaveBeen=' + toString_0($this.iax_1.can_1.r(i_0));
            throw IllegalStateException_init_$Create$_0(toString_1(message));
          }
        }

        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
  }
  function isDraggedWide($this, dragEnd) {
    var focused = ensureNotNull($this.iax_1.dan_1.s8x()).z92().uv();
    var end = Cells_getInstance().u93($this.iax_1.dan_1, dragEnd);
    var tmp;
    if (!(end == null)) {
      var tmp_0 = ensureNotNull(focused);
      tmp = checkOrdered($this, tmp_0, end, MouseSelectionHandler$isDraggedWide$lambda);
    } else {
      tmp = false;
    }
    return tmp;
  }
  function isDraggedTall($this, dragEnd) {
    var focused = ensureNotNull($this.iax_1.dan_1.s8x()).z92().uv();
    var tmp = Cells_getInstance();
    var closest = tmp.eaa($this.iax_1.dan_1, dragEnd, MouseSelectionHandler$isDraggedTall$lambda);
    var tmp_0;
    if (!(closest == null)) {
      var tmp_1 = ensureNotNull(focused);
      tmp_0 = checkOrdered($this, tmp_1, closest, MouseSelectionHandler$isDraggedTall$lambda_0);
    } else {
      tmp_0 = false;
    }
    return tmp_0;
  }
  function isDraggedToFocusable($this, endLocation) {
    var focused = ensureNotNull($this.iax_1.dan_1.s8x()).z92().uv();
    var underMouse = Cells_getInstance().u93($this.iax_1.dan_1, endLocation);
    return !(underMouse == null) && !(underMouse === focused) && underMouse.p92().uv();
  }
  function MouseChange(kind, range) {
    this.yay_1 = kind;
    this.zay_1 = range;
  }
  function MouseChangeKind(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function MouseSelectionHandler$trySetPosition$lambda(c) {
    var tmp;
    var tmp_0;
    if (c instanceof TextCell) {
      tmp_0 = c.p92().uv();
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = c.c93(TextEditing_getInstance().s99_1) || c.c93(TextEditing_getInstance().t99_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
  function MouseSelectionHandler$handleMouseEvent$lambda(this$0, $startIndex, $endIndex, $location) {
    return function () {
      changeMouseSelection(this$0, $startIndex + 1 | 0, $endIndex, $location);
      return Unit_instance;
    };
  }
  function MouseSelectionHandler$handleMouseEvent$lambda_0(this$0, $startIndex, $endIndex, $location) {
    return function () {
      changeMouseSelection(this$0, $startIndex - 1 | 0, $endIndex, $location);
      return Unit_instance;
    };
  }
  function MouseSelectionHandler$handleMouseEvent$lambda_1(this$0, $startIndex, $endIndex, $location) {
    return function () {
      changeMouseSelection(this$0, $startIndex, $endIndex, $location);
      return Unit_instance;
    };
  }
  function Cells$isLeaf$ref(p0) {
    var l = function (_this__u8e3s4) {
      return p0.daa(_this__u8e3s4);
    };
    l.callableName = 'isLeaf';
    return l;
  }
  function MouseSelectionHandler$isDraggedWide$lambda(a, b) {
    var afterA = ensureNotNull(Composites_instance.u35(a));
    if (isDescendant(b, afterA)) {
      return false;
    }
    return Composites_instance.h36(afterA, b);
  }
  function MouseSelectionHandler$isDraggedTall$lambda(cell) {
    return isVisible_1(cell);
  }
  function MouseSelectionHandler$isDraggedTall$lambda_0(upper, lower) {
    return isAbove(upper, lower);
  }
  function MouseChangeKind_NONE_getInstance() {
    MouseChangeKind_initEntries();
    return MouseChangeKind_NONE_instance;
  }
  function MouseChangeKind_SELECT_getInstance() {
    MouseChangeKind_initEntries();
    return MouseChangeKind_SELECT_instance;
  }
  function MouseChangeKind_DESELECT_getInstance() {
    MouseChangeKind_initEntries();
    return MouseChangeKind_DESELECT_instance;
  }
  function MouseSelectionHandler(support) {
    this.iax_1 = support;
  }
  protoOf(MouseSelectionHandler).jax = function (startBound, location) {
    var startIndex = this.iax_1.fan_1.w(startBound.kax_1);
    // Inline function 'kotlin.require' call
    if (!!(startIndex === -1)) {
      var message = toString_1(startBound.kax_1) + ' is not in target list';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    var endIndex = getChild_0(this, location);
    if (endIndex === -1) {
      return MouseHandleResult_SKIPPED_getInstance();
    }
    var endBound = toBound(this, endIndex, location);
    var tmp;
    var tmp_0;
    if (startBound instanceof EditorSelectionBound) {
      tmp_0 = endBound instanceof EditorSelectionBound;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = startBound.kax_1 === endBound.kax_1;
    } else {
      tmp = false;
    }
    if (tmp) {
      var tmp_1;
      if (startBound.xay()) {
        tmp_1 = MouseHandleResult_REDISPATCHED_TEXT_getInstance();
      } else {
        tmp_1 = MouseHandleResult_HANDLED_getInstance();
      }
      return tmp_1;
    }
    if (startIndex < endIndex && startBound.max_1) {
      changeSelection(this, MouseSelectionHandler$handleMouseEvent$lambda(this, startIndex, endIndex, location));
      return MouseHandleResult_HANDLED_getInstance();
    }
    if (startIndex > endIndex && startBound.lax_1) {
      changeSelection(this, MouseSelectionHandler$handleMouseEvent$lambda_0(this, startIndex, endIndex, location));
      return MouseHandleResult_HANDLED_getInstance();
    }
    changeSelection(this, MouseSelectionHandler$handleMouseEvent$lambda_1(this, startIndex, endIndex, location));
    return MouseHandleResult_HANDLED_getInstance();
  };
  function ProjectionalSelection() {
    ProjectionalSelection_instance = this;
    this.gau_1 = new BaseSelectionSpec();
  }
  var ProjectionalSelection_instance;
  function ProjectionalSelection_getInstance() {
    if (ProjectionalSelection_instance == null)
      new ProjectionalSelection();
    return ProjectionalSelection_instance;
  }
  function RoleSynchronizerSelectionSupport$1(this$0, $selectedItems) {
    this.aaz_1 = this$0;
    this.baz_1 = $selectedItems;
    CollectionAdapter.call(this);
  }
  protoOf(RoleSynchronizerSelectionSupport$1).m2r = function (event) {
    get_selected(this.aaz_1.bao_1.r(indexOf_12(this.aaz_1.zan_1, event.u2r()))).d2x(true);
    if (this.baz_1.p() === 1) {
      this.aaz_1.gao_1 = this.aaz_1.cao_1(this.aaz_1.eao_1);
      this.aaz_1.hao_1 = CellTraits_instance.ca9(this.aaz_1.aao_1, this.aaz_1.dao_1(this.aaz_1.eao_1));
    }
  };
  protoOf(RoleSynchronizerSelectionSupport$1).t2r = function (event) {
    if (this.baz_1.s()) {
      this.aaz_1.gao_1.zr();
      this.aaz_1.gao_1 = Companion_getInstance_29().m2l_1;
      this.aaz_1.hao_1.zr();
      this.aaz_1.hao_1 = Companion_getInstance_29().m2l_1;
    }
    var itemIndex = indexOf_12(this.aaz_1.zan_1, event.s2r());
    if (itemIndex >= 0) {
      get_selected(this.aaz_1.bao_1.r(itemIndex)).d2x(false);
    }
  };
  function RoleSynchronizerSelectionSupport(roleSynchronizer, selectionSpec, source, target, targetList, handleSourceUpdate, selectionCaptureTrait) {
    this.zan_1 = roleSynchronizer;
    this.aao_1 = target;
    this.bao_1 = targetList;
    this.cao_1 = handleSourceUpdate;
    this.dao_1 = selectionCaptureTrait;
    this.eao_1 = SelectionSupports_instance.caz(selectionSpec, source, this.aao_1, this.bao_1);
    this.gao_1 = Companion_getInstance_29().m2l_1;
    this.hao_1 = Companion_getInstance_29().m2l_1;
    var selectedItems = this.eao_1.kan();
    var tmp = this;
    var tmp_0 = this.eao_1.daz();
    tmp.fao_1 = tmp_0.x2r(new RoleSynchronizerSelectionSupport$1(this, selectedItems));
  }
  protoOf(RoleSynchronizerSelectionSupport).uau = function () {
    var tmp0_safe_receiver = this.eao_1.lan();
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      var index = this.bao_1.w(tmp0_safe_receiver);
      tmp = this.zan_1.x86().r(index).e86_1;
    }
    return tmp;
  };
  protoOf(RoleSynchronizerSelectionSupport).zr = function () {
    this.gao_1.zr();
    this.hao_1.zr();
    this.fao_1.zr();
  };
  function SelectionBound(cell, isVisuallyHome, isVisuallyEnd) {
    this.kax_1 = cell;
    this.lax_1 = isVisuallyHome;
    this.max_1 = isVisuallyEnd;
  }
  function updateCellSelection($this, selection) {
    if ($this.eaz_1 == null) {
      $this.eaz_1 = new SelectionId();
      $this.gaz_1.k2s(SelectionController$updateCellSelection$lambda($this, selection));
    } else {
      $this.gaz_1.k2s(SelectionController$updateCellSelection$lambda_0($this, selection));
    }
  }
  function Companion_206() {
    Companion_instance_206 = this;
    this.haz_1 = CellTraits_instance.u9f('SelectionController');
  }
  var Companion_instance_206;
  function Companion_getInstance_206() {
    if (Companion_instance_206 == null)
      new Companion_206();
    return Companion_instance_206;
  }
  function SelectionController$updateCellSelection$lambda(this$0, $selection) {
    return function (l) {
      l.iaz(ensureNotNull(this$0.eaz_1), $selection);
      return Unit_instance;
    };
  }
  function SelectionController$updateCellSelection$lambda_0(this$0, $selection) {
    return function (l) {
      l.jaz(ensureNotNull(this$0.eaz_1), $selection);
      return Unit_instance;
    };
  }
  function SelectionController$closeCellSelection$lambda(this$0) {
    return function (l) {
      l.kaz(ensureNotNull(this$0.eaz_1));
      return Unit_instance;
    };
  }
  function SelectionId() {
    BaseId.call(this);
  }
  function Companion_207() {
    Companion_instance_207 = this;
    this.ray_1 = CellTraitPropertySpec_init_$Create$('select_all_ancestors_while_increasing_selection', false);
  }
  var Companion_instance_207;
  function Companion_getInstance_207() {
    if (Companion_instance_207 == null)
      new Companion_207();
    return Companion_instance_207;
  }
  function hasTextSelection($this, cell) {
    var tmp;
    if (cell instanceof TextCell) {
      tmp = cell.h97().uv();
    } else {
      tmp = false;
    }
    return tmp;
  }
  function clearTextSelection($this, cell) {
    var textCell = cell instanceof TextCell ? cell : THROW_CCE();
    textCell.h97().d2x(false);
  }
  function hasLowerSelection($this, cell) {
    var selection = cell.c93(Companion_getInstance_208().say_1);
    var tmp;
    if (!(selection == null)) {
      // Inline function 'kotlin.collections.isNotEmpty' call
      tmp = !selection.kan().s();
    } else {
      tmp = false;
    }
    if (tmp) {
      return true;
    }
    var _iterator__ex2g4s = cell.o35().m();
    while (_iterator__ex2g4s.n()) {
      var child = _iterator__ex2g4s.o();
      if ($this.nax(child)) {
        return true;
      }
    }
    return false;
  }
  function TargetList(list) {
    AbstractList.call(this);
    this.qax_1 = list;
  }
  protoOf(TargetList).p = function () {
    return this.qax_1.p();
  };
  protoOf(TargetList).qay = function (cell) {
    // Inline function 'kotlin.sequences.find' call
    var tmp0 = ancestorsFrom(cell);
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.sequences.firstOrNull' call
      var _iterator__ex2g4s = tmp0.m();
      while (_iterator__ex2g4s.n()) {
        var element = _iterator__ex2g4s.o();
        if (this.qax_1.t(element)) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    return tmp$ret$1;
  };
  protoOf(TargetList).r = function (index) {
    return this.qax_1.r(index);
  };
  function Companion_208() {
    Companion_instance_208 = this;
    this.say_1 = CellTraitPropertySpec_init_$Create$('selectionSupport', null);
  }
  var Companion_instance_208;
  function Companion_getInstance_208() {
    if (Companion_instance_208 == null)
      new Companion_208();
    return Companion_instance_208;
  }
  function SelectionSupport$lambda(this$0) {
    return function (it) {
      var tmp;
      if (!(this$0.ian_1 == null) && !this$0.kao()) {
        var tmp_0;
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!this$0.kan().s()) {
          var startIndex = this$0.can_1.w(first(this$0.kan()));
          var endIndex = this$0.can_1.w(last(this$0.kan()));
          var size = this$0.fan_1.p();
          var tmp_1;
          if (startIndex >= 0 && endIndex >= 0 && startIndex < size && endIndex < size) {
            ensureNotNull(this$0.ian_1).maz(this$0.fan_1.r(startIndex), this$0.fan_1.r(endIndex));
            tmp_1 = Unit_instance;
          } else {
            // Inline function 'kotlin.check' call
            if (!this$0.jan_1) {
              var message = 'Intermediate state outside changing selection encountered. Selected items: ' + toString_1(this$0.kan());
              throw IllegalStateException_init_$Create$_0(toString_1(message));
            }
            tmp_1 = Unit_instance;
          }
          tmp_0 = tmp_1;
        } else {
          ensureNotNull(this$0.ian_1).laz();
          tmp_0 = Unit_instance;
        }
        tmp = tmp_0;
      }
      return Unit_instance;
    };
  }
  function SelectionSupport$select$lambda(this$0, $start, $end) {
    return function () {
      this$0.kan().k2();
      var inductionVariable = $start;
      var tmp;
      if (inductionVariable <= $end) {
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          this$0.kan().j(this$0.can_1.r(i));
        }
         while (!(i === $end));
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function MutableList$clear$ref(p0) {
    var l = function () {
      p0.k2();
      return Unit_instance;
    };
    l.callableName = 'clear';
    return l;
  }
  function SelectionSupport(spec, source, target, targetList, focusAndScrollTo) {
    Companion_getInstance_208();
    this.ban_1 = spec;
    this.can_1 = source;
    this.dan_1 = target;
    this.ean_1 = focusAndScrollTo;
    this.gan_1 = new ObservableArrayList();
    this.ian_1 = null;
    this.jan_1 = false;
    this.fan_1 = new TargetList(targetList);
    var preInstalled = this.dan_1.c93(Companion_getInstance_206().haz_1);
    if (!(preInstalled == null)) {
      this.naz(preInstalled);
    }
    this.han_1 = this.dan_1.w92(this.ban_1.fay(this));
    var tmp = this.daz();
    tmp.z2r(SelectionSupport$lambda(this));
  }
  protoOf(SelectionSupport).lan = function () {
    if (this.can_1.s())
      return null;
    var focusedCell = ensureNotNull(this.dan_1.s8x()).z92().uv();
    // Inline function 'kotlin.sequences.find' call
    var tmp0 = ancestorsFrom(focusedCell);
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.sequences.firstOrNull' call
      var _iterator__ex2g4s = tmp0.m();
      while (_iterator__ex2g4s.n()) {
        var element = _iterator__ex2g4s.o();
        if (element.bp() === this.dan_1) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    return tmp$ret$1;
  };
  protoOf(SelectionSupport).zar = function () {
    if (this.kan().s()) {
      return SelectionUtil_getInstance().aay_1;
    }
    var leftIndex = this.can_1.w(this.kan().r(0));
    var rightIndex = this.can_1.v(last(this.kan()));
    return new Interval(leftIndex, rightIndex);
  };
  protoOf(SelectionSupport).hax = function () {
    return this.oaz(ensureNotNull(this.dan_1.s8x()).z92().uv());
  };
  protoOf(SelectionSupport).oay = function () {
    return this.kan().p() === this.can_1.p();
  };
  protoOf(SelectionSupport).kan = function () {
    return this.gan_1;
  };
  protoOf(SelectionSupport).daz = function () {
    return this.gan_1;
  };
  protoOf(SelectionSupport).aas = function (items) {
    this.gan_1.k2();
    this.gan_1.q(items);
  };
  protoOf(SelectionSupport).rax = function (cell) {
    return cell.y92().uv() && !Cells_getInstance().daa(cell);
  };
  protoOf(SelectionSupport).kao = function () {
    var tmp0 = ancestorsFrom(this.dan_1);
    var tmp$ret$2;
    $l$block: {
      // Inline function 'kotlin.sequences.any' call
      var _iterator__ex2g4s = tmp0.m();
      while (_iterator__ex2g4s.n()) {
        var element = _iterator__ex2g4s.o();
        var tmp0_safe_receiver = element.bp();
        var support = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.c93(Companion_getInstance_208().say_1);
        var tmp;
        if (!(support == null)) {
          // Inline function 'kotlin.collections.isNotEmpty' call
          tmp = !support.kan().s();
        } else {
          tmp = false;
        }
        if (tmp) {
          tmp$ret$2 = true;
          break $l$block;
        }
      }
      tmp$ret$2 = false;
    }
    return tmp$ret$2;
  };
  protoOf(SelectionSupport).nay = function (from, to) {
    // Inline function 'kotlin.check' call
    if (!!this.jan_1) {
      var message = 'Selection is being changed';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    var start = this.can_1.w(from);
    var end = this.can_1.w(to);
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.require' call
    if (!(!(start === -1) && !(end === -1))) {
      var message_0 = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message_0));
    }
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.require' call
    if (!(start <= end)) {
      var message_1 = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message_1));
    }
    // Inline function 'kotlin.check' call
    if (!isDescendantCellFocused(this.dan_1)) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    this.ban_1.iay(start, end, this);
    this.hay(SelectionSupport$select$lambda(this, start, end));
  };
  protoOf(SelectionSupport).saw = function () {
    this.hay(MutableList$clear$ref(this.kan()));
  };
  protoOf(SelectionSupport).hay = function (r) {
    this.jan_1 = true;
    try {
      r();
    }finally {
      this.jan_1 = false;
    }
  };
  protoOf(SelectionSupport).naz = function (selectionController) {
    this.ian_1 = selectionController;
  };
  protoOf(SelectionSupport).nax = function (cell) {
    return hasTextSelection(this, cell) || hasLowerSelection(this, cell);
  };
  protoOf(SelectionSupport).wax = function () {
    var cell = ensureNotNull(this.dan_1.s8x()).z92().uv();
    if (hasTextSelection(this, cell)) {
      clearTextSelection(this, ensureNotNull(cell));
    }
    if (cell == null)
      null;
    else {
      // Inline function 'jetbrains.ocelot.base.composite.dispatchByParent' call
      var current = cell;
      while (!(current == null)) {
        var tmp0_safe_receiver = current.c93(Companion_getInstance_208().say_1);
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          if (!tmp0_safe_receiver.jan_1) {
            tmp0_safe_receiver.saw();
          }
        }
        current = current.bp();
      }
    }
  };
  protoOf(SelectionSupport).xax = function (index, first) {
    return this.ean_1(new Pair(index, first));
  };
  protoOf(SelectionSupport).oaz = function (cell) {
    return this.fan_1.qay(cell);
  };
  protoOf(SelectionSupport).zr = function () {
    this.han_1.zr();
  };
  protoOf(SelectionSupport).gax = function (location) {
    return this.can_1.s() || !get_bounds(this.dan_1).l8c(location);
  };
  function getNext($this) {
    while ($this.qaz_1.n()) {
      var cell = $this.qaz_1.o();
      var support = cell.c93(Companion_getInstance_208().say_1);
      if (!(support == null)) {
        return support;
      }
    }
    return null;
  }
  function SelectionSupports$selectionSupports$1$iterator$1($cellsIterator) {
    this.qaz_1 = $cellsIterator;
    this.paz_1 = getNext(this);
  }
  protoOf(SelectionSupports$selectionSupports$1$iterator$1).n = function () {
    return !(this.paz_1 == null);
  };
  protoOf(SelectionSupports$selectionSupports$1$iterator$1).o = function () {
    var next = this.paz_1;
    this.paz_1 = getNext(this);
    return ensureNotNull(next);
  };
  function defaultFocusAndScrollTo($this, list) {
    return SelectionSupports$defaultFocusAndScrollTo$lambda(list);
  }
  function SelectionSupports$defaultFocusAndScrollTo$lambda$lambda($first, $child) {
    return function () {
      var tmp;
      if ($first) {
        tmp = toFirstFocusable($child);
      } else {
        tmp = toLastFocusable($child);
      }
      var focusAction = tmp;
      focusAction();
      scrollTo_0($child);
      return Unit_instance;
    };
  }
  function SelectionSupports$defaultFocusAndScrollTo$lambda($list) {
    return function (_destruct__k2r9zo) {
      var index = _destruct__k2r9zo.fg();
      var first = _destruct__k2r9zo.gg();
      var child = $list.r(index);
      var cellAction = SelectionSupports$defaultFocusAndScrollTo$lambda$lambda(first, child);
      return cellAction;
    };
  }
  function SelectionSupports$selectionSupports$1($start) {
    this.raz_1 = $start;
  }
  protoOf(SelectionSupports$selectionSupports$1).m = function () {
    var cellsIterator = ancestorsFrom(this.raz_1).m();
    return new SelectionSupports$selectionSupports$1$iterator$1(cellsIterator);
  };
  function SelectionSupports() {
  }
  protoOf(SelectionSupports).caz = function (spec, source, target, targetList) {
    return this.saz(spec, source, target, targetList, defaultFocusAndScrollTo(this, targetList));
  };
  protoOf(SelectionSupports).saz = function (spec, source, target, targetList, focusAndScrollTo) {
    return new SelectionSupport(spec, source, target, targetList, focusAndScrollTo);
  };
  protoOf(SelectionSupports).pay = function (start) {
    return new SelectionSupports$selectionSupports$1(start);
  };
  var SelectionSupports_instance;
  function SelectionSupports_getInstance() {
    return SelectionSupports_instance;
  }
  function isGoBackward($this, event) {
    return event.o8j([KeyStrokeSpecs_getInstance().p8k_1]) || event.m8j(Key_UP_getInstance(), []) || event.m8j(Key_PAGE_UP_getInstance(), []) || event.o8j([KeyStrokeSpecs_getInstance().l8k_1]) || event.o8j([KeyStrokeSpecs_getInstance().n8k_1]);
  }
  function isGoForward($this, event) {
    return event.o8j([KeyStrokeSpecs_getInstance().q8k_1]) || event.m8j(Key_DOWN_getInstance(), []) || event.m8j(Key_PAGE_DOWN_getInstance(), []) || event.o8j([KeyStrokeSpecs_getInstance().m8k_1]) || event.o8j([KeyStrokeSpecs_getInstance().o8k_1]);
  }
  function SelectionUtil() {
    SelectionUtil_instance = this;
    this.aay_1 = Companion_instance_37.y36(-1, -1);
  }
  protoOf(SelectionUtil).cay = function (from, what) {
    var tmp;
    if (what.s() || !from.l37(what)) {
      tmp = from;
    } else if (what.j37(from)) {
      tmp = this.aay_1;
    } else if (from.j37(what)) {
      var tmp_0;
      if (from.v36_1 < what.v36_1) {
        var tmp_1;
        if (what.w36_1 < from.w36_1) {
          tmp_1 = null;
        } else {
          tmp_1 = Companion_instance_37.y36(from.v36_1, what.v36_1);
        }
        tmp_0 = tmp_1;
      } else {
        tmp_0 = new Interval(what.w36_1 + 1 | 0, from.w36_1);
      }
      tmp = tmp_0;
    } else if (from.i37(what.v36_1)) {
      tmp = Companion_instance_37.y36(from.v36_1, what.v36_1);
    } else if (from.i37(what.w36_1)) {
      tmp = new Interval(what.w36_1 + 1 | 0, from.w36_1);
    } else {
      throw IllegalStateException_init_$Create$();
    }
    return tmp;
  };
  protoOf(SelectionUtil).eay = function (a, b) {
    var tmp;
    if (a == null || a.s()) {
      tmp = b;
    } else if (b.s()) {
      tmp = a;
    } else if (a.l37(b) || (a.w36_1 + 1 | 0) === b.v36_1 || (b.w36_1 + 1 | 0) === a.v36_1) {
      tmp = a.n37(b);
    } else {
      tmp = null;
    }
    return tmp;
  };
  protoOf(SelectionUtil).bay = function (a, b) {
    var tmp;
    if (a > b) {
      tmp = new Interval(b, a);
    } else {
      tmp = new Interval(a, b);
    }
    return tmp;
  };
  protoOf(SelectionUtil).gay = function (cell, event, support, clear) {
    if (event.m8j(Key_LEFT_getInstance(), [])) {
      var firstSelected = support.fan_1.r(support.zar().v36_1);
      clear();
      toFirstFocusable(firstSelected)();
      event.n8i();
    } else if (event.m8j(Key_RIGHT_getInstance(), [])) {
      var lastSelected = support.fan_1.r(support.zar().w36_1);
      clear();
      toLastFocusable(lastSelected)();
      event.n8i();
    } else if (isGoBackward(this, event)) {
      clear();
      var focused = ensureNotNull(cell.s8x()).z92().uv();
      if (!Cells_getInstance().daa(focused)) {
        toFirstFocusable(ensureNotNull(focused))();
        event.n8i();
      }
    } else if (isGoForward(this, event)) {
      clear();
      var focused_0 = ensureNotNull(cell.s8x()).z92().uv();
      if (!Cells_getInstance().daa(focused_0)) {
        toLastFocusable(ensureNotNull(focused_0))();
        event.n8i();
      }
    }
  };
  var SelectionUtil_instance;
  function SelectionUtil_getInstance() {
    if (SelectionUtil_instance == null)
      new SelectionUtil();
    return SelectionUtil_instance;
  }
  function SimpleCellSelection(start, end) {
    CellSelection.call(this);
    this.taz_1 = start;
    this.uaz_1 = end;
  }
  function Companion_209() {
  }
  protoOf(Companion_209).s92 = function (cell) {
    return new SimpleSelectionBound(cell, Positions_instance.ta4(cell), Positions_instance.ua4(cell));
  };
  var Companion_instance_209;
  function Companion_getInstance_209() {
    return Companion_instance_209;
  }
  function SimpleSelectionBound(cell, visuallyHome, visuallyEnd) {
    SelectionBound.call(this, cell, visuallyHome, visuallyEnd);
  }
  protoOf(SimpleSelectionBound).hashCode = function () {
    var hash = hashCode(this.kax_1);
    hash = imul(37, hash) + getBooleanHashCode(this.lax_1) | 0;
    hash = imul(37, hash) + getBooleanHashCode(this.max_1) | 0;
    return hash;
  };
  protoOf(SimpleSelectionBound).equals = function (other) {
    if (other instanceof SimpleSelectionBound) {
      var that = other instanceof SimpleSelectionBound ? other : THROW_CCE();
      return equals(this.kax_1, ensureNotNull(that).kax_1) && this.lax_1 === that.lax_1 && this.max_1 === that.max_1;
    }
    return false;
  };
  function selection($this) {
    return $this.waz_1.kan();
  }
  function leftSelectionSiblingIndex($this, sourceIndex) {
    if (sourceIndex === 0) {
      return -1;
    }
    var leftSourceSibling = $this.vaz_1.r(sourceIndex - 1 | 0);
    return selection($this).w(leftSourceSibling);
  }
  function rightSelectionSiblingIndex($this, sourceIndex) {
    if (sourceIndex === ($this.vaz_1.p() - 1 | 0)) {
      return -1;
    }
    var rightSourceSibling = $this.vaz_1.r(sourceIndex + 1 | 0);
    return selection($this).v(rightSourceSibling);
  }
  function SourceUpdateHandler$onEvent$lambda(this$0, $event) {
    return function () {
      var selection_0 = selection(this$0);
      var tmp;
      if (EventType_ADD_getInstance().equals($event.r2r_1)) {
        var tmp_0;
        if (!selection_0.t($event.u2r())) {
          var leftSelectionSibling = leftSelectionSiblingIndex(this$0, $event.q2r_1);
          var tmp_1;
          if (!(leftSelectionSibling === -1)) {
            var rightSelectionSibling = rightSelectionSiblingIndex(this$0, $event.q2r_1);
            var tmp_2;
            if (!(rightSelectionSibling === -1)) {
              if (!((leftSelectionSibling + 1 | 0) === rightSelectionSibling)) {
                throw IllegalStateException_init_$Create$_0('Siblings inconsistent: ' + leftSelectionSibling + ', ' + rightSelectionSibling);
              }
              selection_0.m2(rightSelectionSibling, $event.u2r());
              tmp_2 = Unit_instance;
            }
            tmp_1 = tmp_2;
          }
          tmp_0 = tmp_1;
        }
        tmp = tmp_0;
      } else {
        var selectionIndex = selection_0.w($event.s2r());
        var tmp_3;
        if (!(selectionIndex === -1)) {
          switch ($event.r2r_1.x2_1) {
            case 1:
              selection_0.l2(selectionIndex, $event.u2r());
              break;
            case 2:
              selection_0.n2(selectionIndex);
              break;
            default:
              throw IllegalStateException_init_$Create$_0('' + $event.toString());
          }
          tmp_3 = Unit_instance;
        }
        tmp = tmp_3;
      }
      return Unit_instance;
    };
  }
  function SourceUpdateHandler(source, selectionSupport) {
    this.vaz_1 = source;
    this.waz_1 = selectionSupport;
  }
  protoOf(SourceUpdateHandler).xaz = function (event) {
    this.waz_1.hay(SourceUpdateHandler$onEvent$lambda(this, event));
  };
  protoOf(SourceUpdateHandler).n2s = function (event) {
    return this.xaz(event instanceof CollectionItemEvent ? event : THROW_CCE());
  };
  function Companion_210() {
    Companion_instance_210 = this;
    this.l95_1 = new Color(0, 0, 0, 0);
    this.m95_1 = new Color(255, 255, 255);
    this.n95_1 = new Color(204, 204, 204);
    this.o95_1 = new Color(0, 0, 0);
    this.p95_1 = new Color(192, 192, 192);
    this.q95_1 = new Color(210, 210, 210);
    this.r95_1 = new Color(128, 128, 128);
    this.s95_1 = new Color(255, 0, 0);
    this.t95_1 = new Color(210, 255, 210);
    this.u95_1 = new Color(0, 255, 0);
    this.v95_1 = new Color(0, 128, 0);
    this.w95_1 = new Color(0, 0, 255);
    this.x95_1 = new Color(0, 0, 128);
    this.y95_1 = new Color(210, 210, 255);
    this.z95_1 = new Color(255, 255, 0);
    this.a96_1 = new Color(174, 174, 36);
    this.b96_1 = new Color(255, 255, 128);
    this.c96_1 = new Color(255, 255, 210);
    this.d96_1 = new Color(255, 0, 255);
    this.e96_1 = new Color(255, 210, 255);
    this.f96_1 = new Color(128, 0, 128);
    this.g96_1 = new Color(0, 255, 255);
    this.h96_1 = new Color(210, 255, 255);
    this.i96_1 = new Color(255, 192, 0);
    this.j96_1 = new Color(255, 175, 175);
    this.k96_1 = new Color(255, 210, 210);
    this.l96_1 = 'rgb';
    this.m96_1 = 'color';
    this.n96_1 = 'rgba';
  }
  var Companion_instance_210;
  function Companion_getInstance_210() {
    if (Companion_instance_210 == null)
      new Companion_210();
    return Companion_instance_210;
  }
  function Color(red, green, blue, alpha) {
    Companion_getInstance_210();
    alpha = alpha === VOID ? 255 : alpha;
    this.yaz_1 = red;
    this.zaz_1 = green;
    this.ab0_1 = blue;
    this.bb0_1 = alpha;
  }
  protoOf(Color).cb0 = function () {
    var tmp;
    if (this.bb0_1 === 255) {
      tmp = 'rgb(' + this.yaz_1 + ',' + this.zaz_1 + ',' + this.ab0_1 + ')';
    } else {
      tmp = 'rgba(' + this.yaz_1 + ',' + this.zaz_1 + ',' + this.ab0_1 + ',' + this.bb0_1 / 255.0 + ')';
    }
    return tmp;
  };
  protoOf(Color).toString = function () {
    return 'color(' + this.yaz_1 + ',' + this.zaz_1 + ',' + this.ab0_1 + ',' + this.bb0_1 + ')';
  };
  protoOf(Color).hashCode = function () {
    var result = this.yaz_1;
    result = imul(result, 31) + this.zaz_1 | 0;
    result = imul(result, 31) + this.ab0_1 | 0;
    result = imul(result, 31) + this.bb0_1 | 0;
    return result;
  };
  protoOf(Color).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Color))
      return false;
    if (!(this.yaz_1 === other.yaz_1))
      return false;
    if (!(this.zaz_1 === other.zaz_1))
      return false;
    if (!(this.ab0_1 === other.ab0_1))
      return false;
    if (!(this.bb0_1 === other.bb0_1))
      return false;
    return true;
  };
  function Font(family, size, isBold, isItalic) {
    isBold = isBold === VOID ? false : isBold;
    isItalic = isItalic === VOID ? false : isItalic;
    this.o96_1 = family;
    this.p96_1 = size;
    this.q96_1 = isBold;
    this.r96_1 = isItalic;
  }
  protoOf(Font).toString = function () {
    var bold = this.q96_1 ? 'bold' : '';
    var italic = this.r96_1 ? 'italic' : '';
    return this.o96_1.toString() + ' ' + this.p96_1 + ' ' + bold + ' ' + italic;
  };
  protoOf(Font).hashCode = function () {
    var result = hashCode(this.o96_1);
    result = imul(result, 31) + this.p96_1 | 0;
    result = imul(result, 31) + getBooleanHashCode(this.q96_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.r96_1) | 0;
    return result;
  };
  protoOf(Font).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Font))
      return false;
    if (!equals(this.o96_1, other.o96_1))
      return false;
    if (!(this.p96_1 === other.p96_1))
      return false;
    if (!(this.q96_1 === other.q96_1))
      return false;
    if (!(this.r96_1 === other.r96_1))
      return false;
    return true;
  };
  function Companion_211() {
    Companion_instance_211 = this;
    this.j95_1 = this.h9z('monospace');
    this.k95_1 = this.h9z('serif');
  }
  protoOf(Companion_211).h9z = function (name) {
    return new FontFamily(name);
  };
  var Companion_instance_211;
  function Companion_getInstance_211() {
    if (Companion_instance_211 == null)
      new Companion_211();
    return Companion_instance_211;
  }
  function FontFamily(name) {
    Companion_getInstance_211();
    this.db0_1 = name;
  }
  protoOf(FontFamily).toString = function () {
    return this.db0_1;
  };
  function EmptyImageData(dim) {
    ImageData.call(this, dim);
  }
  function Companion_212() {
  }
  protoOf(Companion_212).a9u = function (dim) {
    return new EmptyImageData(dim);
  };
  protoOf(Companion_212).eb0 = function (dim, url) {
    return new UrlImageData(dim, url);
  };
  var Companion_instance_212;
  function Companion_getInstance_212() {
    return Companion_instance_212;
  }
  function ImageData(dimension) {
    this.p8w_1 = dimension;
  }
  function UrlImageData(dim, url) {
    ImageData.call(this, dim);
    this.gb0_1 = url;
  }
  function AlignmentProperties() {
    AlignmentProperties_instance = this;
    this.hb0_1 = ViewPropertySpec_init_$Create$('crossAlignment', ViewPropertyKind_RELAYOUT_AND_REPAINT_getInstance(), Alignment_START_getInstance());
    this.ib0_1 = ViewPropertySpec_init_$Create$('justifyContent', ViewPropertyKind_RELAYOUT_AND_REPAINT_getInstance(), false);
  }
  var AlignmentProperties_instance;
  function AlignmentProperties_getInstance() {
    if (AlignmentProperties_instance == null)
      new AlignmentProperties();
    return AlignmentProperties_instance;
  }
  function CustomViewFeatureSpec(name) {
    this.jb0_1 = name;
  }
  protoOf(CustomViewFeatureSpec).toString = function () {
    return this.jb0_1;
  };
  function ExternalPasteContent() {
  }
  protoOf(ExternalPasteContent).e8i = function (kind) {
    return false;
  };
  protoOf(ExternalPasteContent).f8i = function (kind) {
    throw IllegalArgumentException_init_$Create$();
  };
  var ExternalPasteContent_instance;
  function ExternalPasteContent_getInstance() {
    return ExternalPasteContent_instance;
  }
  function GroupView() {
    View.call(this);
  }
  protoOf(GroupView).ab1 = function (loc) {
    return false;
  };
  protoOf(GroupView).bb1 = function (ctx) {
    protoOf(View).bb1.call(this, ctx);
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.sb1();
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.m();
    while (_iterator__ex2g4s.n()) {
      var item = _iterator__ex2g4s.o();
      var tmp$ret$0 = item.tb1();
      destination.j(tmp$ret$0);
    }
    var visibleChildBounds = destination;
    var tmp = this.m92();
    // Inline function 'kotlin.collections.isNotEmpty' call
    var tmp$ret$3 = !visibleChildBounds.s();
    tmp.f2x(tmp$ret$3);
    // Inline function 'kotlin.collections.fold' call
    var accumulator = Companion_getInstance_135().g8c_1;
    var _iterator__ex2g4s_0 = visibleChildBounds.m();
    while (_iterator__ex2g4s_0.n()) {
      var element = _iterator__ex2g4s_0.o();
      accumulator = accumulator.m8c(element);
    }
    var bounds = accumulator;
    ctx.xb1(bounds, 0);
  };
  function hasMoreThanOneChild($this, _this__u8e3s4) {
    // Inline function 'kotlin.run' call
    var $this$run = _this__u8e3s4.m();
    var tmp;
    if ($this$run.n()) {
      // Inline function 'kotlin.apply' call
      $this$run.o();
      tmp = $this$run.n();
    } else {
      tmp = false;
    }
    return tmp;
  }
  function HorizontalView() {
    View.call(this);
  }
  protoOf(HorizontalView).bb1 = function (ctx) {
    protoOf(View).bb1.call(this, ctx);
    var width = 0;
    var aboveBaseline = 0;
    var belowBaseLine = 0;
    var children = this.sb1();
    var _iterator__ex2g4s = children.m();
    while (_iterator__ex2g4s.n()) {
      var child = _iterator__ex2g4s.o();
      var tmp0 = aboveBaseline;
      // Inline function 'kotlin.comparisons.maxOf' call
      var b = child.kb1_1;
      aboveBaseline = Math.max(tmp0, b);
      var bounds = child.tb1();
      var tmp0_0 = belowBaseLine;
      // Inline function 'kotlin.comparisons.maxOf' call
      var b_0 = bounds.c8c_1.e8c_1 - child.kb1_1 | 0;
      belowBaseLine = Math.max(tmp0_0, b_0);
      width = width + bounds.c8c_1.d8c_1 | 0;
    }
    var offset = 0;
    var _iterator__ex2g4s_0 = children.m();
    while (_iterator__ex2g4s_0.n()) {
      var child_0 = _iterator__ex2g4s_0.o();
      var newOrigin = ctx.mb3().i8c(new Vector(offset, aboveBaseline - child_0.kb1_1 | 0));
      child_0.qb2(newOrigin);
      offset = offset + child_0.tb1().c8c_1.d8c_1 | 0;
    }
    ctx.nb3(new Vector(width, aboveBaseline + belowBaseLine | 0), aboveBaseline);
  };
  protoOf(HorizontalView).sb2 = function (ctx) {
    protoOf(View).sb2.call(this, ctx);
    if (this.eb2(AlignmentProperties_getInstance().ib0_1) && hasMoreThanOneChild(this, this.sb1())) {
      this.ob3(ctx);
    }
  };
  function ImageView() {
  }
  function Companion_213() {
    Companion_instance_213 = this;
    this.pb3_1 = 5;
    this.qb3_1 = ViewPropertySpec_init_$Create$('color', ViewPropertyKind_REPAINT_getInstance(), Companion_getInstance_210().o95_1);
    this.rb3_1 = ViewPropertySpec_init_$Create$('width', ViewPropertyKind_RELAYOUT_AND_REPAINT_getInstance(), 1);
    this.sb3_1 = ViewPropertySpec_init_$Create$('start', ViewPropertyKind_RELAYOUT_AND_REPAINT_getInstance(), Companion_getInstance_136().h8c_1);
    this.tb3_1 = ViewPropertySpec_init_$Create$('end', ViewPropertyKind_RELAYOUT_AND_REPAINT_getInstance(), Companion_getInstance_136().h8c_1);
  }
  var Companion_instance_213;
  function Companion_getInstance_213() {
    if (Companion_instance_213 == null)
      new Companion_213();
    return Companion_instance_213;
  }
  function LineView() {
  }
  protoOf(LineView).p1 = function () {
    return this.kb4(Companion_getInstance_213().sb3_1);
  };
  protoOf(LineView).lb4 = function () {
    return this.kb4(Companion_getInstance_213().tb3_1);
  };
  protoOf(LineView).mb4 = function () {
    return this.gb2(Companion_getInstance_213().qb3_1);
  };
  protoOf(LineView).g8u = function () {
    return this.gb2(Companion_getInstance_213().rb3_1);
  };
  function Companion_214() {
    Companion_instance_214 = this;
    this.nb4_1 = new CustomViewFeatureSpec('points');
    this.ob4_1 = ViewPropertySpec_init_$Create$('color', ViewPropertyKind_REPAINT_getInstance(), Companion_getInstance_210().o95_1);
    this.pb4_1 = ViewPropertySpec_init_$Create$('width', ViewPropertyKind_RELAYOUT_AND_REPAINT_getInstance(), 1);
  }
  var Companion_instance_214;
  function Companion_getInstance_214() {
    if (Companion_instance_214 == null)
      new Companion_214();
    return Companion_instance_214;
  }
  function MultiPointView() {
  }
  protoOf(MultiPointView).mb4 = function () {
    return this.gb2(Companion_getInstance_214().ob4_1);
  };
  protoOf(MultiPointView).g8u = function () {
    return this.gb2(Companion_getInstance_214().pb4_1);
  };
  function NullViewContainerPeer() {
    this.ib5_1 = null;
    this.jb5_1 = new TrivialSystemClipboard();
  }
  protoOf(NullViewContainerPeer).kb5 = function (container) {
    this.ib5_1 = container;
  };
  protoOf(NullViewContainerPeer).e6j = function () {
  };
  protoOf(NullViewContainerPeer).lb5 = function (view) {
  };
  protoOf(NullViewContainerPeer).mb5 = function (view, change) {
  };
  protoOf(NullViewContainerPeer).nb5 = function (font, text) {
    return imul(text.length, 5);
  };
  function PolyLineView() {
  }
  function Companion_215() {
    Companion_instance_215 = this;
    this.ob5_1 = 5;
    this.pb5_1 = 5;
    this.qb5_1 = ViewPropertySpec_init_$Create$('maxDimension', ViewPropertyKind_RELAYOUT_getInstance(), Companion_getInstance_136().h8c_1);
    this.rb5_1 = ViewPropertySpec_init_$Create$('offset', ViewPropertyKind_RELAYOUT_AND_REPAINT_getInstance(), Companion_getInstance_136().h8c_1);
    this.sb5_1 = ViewPropertySpec_init_$Create$('scroll', ViewPropertyKind_RELAYOUT_AND_REPAINT_getInstance(), false);
  }
  var Companion_instance_215;
  function Companion_getInstance_215() {
    if (Companion_instance_215 == null)
      new Companion_215();
    return Companion_instance_215;
  }
  function ScrollView() {
  }
  protoOf(ScrollView).jb6 = function () {
    return this.gb2(Companion_getInstance_215().qb5_1);
  };
  protoOf(ScrollView).kb6 = function () {
    return this.gb2(Companion_getInstance_215().sb5_1);
  };
  function TextView$Companion$SELECTION_END$lambda(view) {
    return view.eb2(Companion_getInstance_216().tb6_1);
  }
  function Companion_216() {
    Companion_instance_216 = this;
    this.lb6_1 = new Font(Companion_getInstance_211().j95_1, 14);
    this.mb6_1 = ViewPropertySpec_init_$Create$('text', ViewPropertyKind_RELAYOUT_getInstance(), '');
    this.nb6_1 = ViewPropertySpec_init_$Create$('color', ViewPropertyKind_REPAINT_getInstance(), Companion_getInstance_210().o95_1);
    this.ob6_1 = ViewPropertySpec_init_$Create$('bold', ViewPropertyKind_REPAINT_getInstance(), false);
    this.pb6_1 = ViewPropertySpec_init_$Create$('italic', ViewPropertyKind_REPAINT_getInstance(), false);
    this.qb6_1 = ViewPropertySpec_init_$Create$('fontFamily', ViewPropertyKind_RELAYOUT_AND_REPAINT_getInstance(), this.lb6_1.o96_1);
    this.rb6_1 = ViewPropertySpec_init_$Create$('fontSize', ViewPropertyKind_RELAYOUT_AND_REPAINT_getInstance(), this.lb6_1.p96_1);
    this.sb6_1 = ViewPropertySpec_init_$Create$('caretVisible', ViewPropertyKind_REPAINT_getInstance(), false);
    this.tb6_1 = ViewPropertySpec_init_$Create$('caretPosition', ViewPropertyKind_REPAINT_getInstance(), 0);
    this.ub6_1 = ViewPropertySpec_init_$Create$('selectionVisible', ViewPropertyKind_REPAINT_getInstance(), false);
    this.vb6_1 = ViewPropertySpec_init_$Create$('selectionStart', ViewPropertyKind_REPAINT_getInstance(), 0);
    var tmp = this;
    var tmp_0 = ViewPropertyKind_REPAINT_getInstance();
    tmp.wb6_1 = new ViewPropertySpec('selectionEnd', tmp_0, TextView$Companion$SELECTION_END$lambda);
    this.xb6_1 = ViewPropertySpec_init_$Create$('textDecorations', ViewPropertyKind_REPAINT_getInstance(), emptySet());
    this.yb6_1 = createPropertySpec_0('textStyleRegions');
  }
  var Companion_instance_216;
  function Companion_getInstance_216() {
    if (Companion_instance_216 == null)
      new Companion_216();
    return Companion_instance_216;
  }
  function TextView() {
  }
  protoOf(TextView).o8w = function () {
    return this.gb2(Companion_getInstance_216().mb6_1);
  };
  protoOf(TextView).b97 = function () {
    return this.gb2(Companion_getInstance_216().nb6_1);
  };
  protoOf(TextView).d97 = function () {
    return this.gb2(Companion_getInstance_216().ob6_1);
  };
  protoOf(TextView).e97 = function () {
    return this.gb2(Companion_getInstance_216().pb6_1);
  };
  protoOf(TextView).f97 = function () {
    return this.gb2(Companion_getInstance_216().qb6_1);
  };
  protoOf(TextView).g97 = function () {
    return this.gb2(Companion_getInstance_216().rb6_1);
  };
  protoOf(TextView).c97 = function () {
    return this.gb2(Companion_getInstance_216().sb6_1);
  };
  protoOf(TextView).t96 = function () {
    return this.gb2(Companion_getInstance_216().tb6_1);
  };
  protoOf(TextView).h97 = function () {
    return this.gb2(Companion_getInstance_216().ub6_1);
  };
  protoOf(TextView).i97 = function () {
    return this.gb2(Companion_getInstance_216().vb6_1);
  };
  protoOf(TextView).j97 = function () {
    return this.gb2(Companion_getInstance_216().wb6_1);
  };
  function _get_myIndentWidth__n8y99f($this) {
    return $this.gb2(Companion_getInstance_217().qb7_1);
  }
  function stretchChildrenWidth($this, ctx) {
    if (!($this.eb2(AlignmentProperties_getInstance().hb0_1) === Alignment_STRETCH_getInstance()))
      return Unit_instance;
    var _iterator__ex2g4s = $this.sb1().m();
    while (_iterator__ex2g4s.n()) {
      var child = _iterator__ex2g4s.o();
      if (canStretch($this, child)) {
        child.sb2(ctx);
      }
      if (child instanceof VerticalView) {
        stretchChildrenWidth(child, ctx);
      }
    }
  }
  function canStretch($this, view) {
    var tmp;
    if (view instanceof VerticalView) {
      tmp = true;
    } else {
      tmp = view instanceof HorizontalView;
    }
    return tmp;
  }
  function Companion_217() {
    Companion_instance_217 = this;
    this.pb7_1 = ViewPropertySpec_init_$Create$('indent', ViewPropertyKind_RELAYOUT_getInstance(), false);
    this.qb7_1 = ViewPropertySpec_init_$Create$('indentWidth', ViewPropertyKind_NONE_getInstance(), 0);
  }
  var Companion_instance_217;
  function Companion_getInstance_217() {
    if (Companion_instance_217 == null)
      new Companion_217();
    return Companion_instance_217;
  }
  function VerticalView() {
    Companion_getInstance_217();
    View.call(this);
  }
  protoOf(VerticalView).hb8 = function () {
    return this.gb2(Companion_getInstance_217().pb7_1);
  };
  protoOf(VerticalView).ib8 = function () {
    return _get_myIndentWidth__n8y99f(this);
  };
  protoOf(VerticalView).bb1 = function (ctx) {
    protoOf(View).bb1.call(this, ctx);
    var origin = ctx.mb3();
    var width = 0;
    var height = 0;
    // Inline function 'kotlin.takeIf' call
    var this_0 = this.ib1_1;
    var tmp;
    if (this.hb8().w2w()) {
      tmp = this_0;
    } else {
      tmp = null;
    }
    var tmp0_safe_receiver = tmp;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.run' call
      tmp_0 = imul(tmp0_safe_receiver.jb8_1.nb5(Companion_getInstance_216().lb6_1, 'x'), 2);
    }
    var tmp1_elvis_lhs = tmp_0;
    var indentWidth = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    _get_myIndentWidth__n8y99f(this).d2x(indentWidth);
    var children = this.sb1();
    var _iterator__ex2g4s = children.m();
    while (_iterator__ex2g4s.n()) {
      var child = _iterator__ex2g4s.o();
      var bounds = child.tb1();
      child.qb2(origin.i8c(new Vector(indentWidth, height)));
      height = height + bounds.c8c_1.e8c_1 | 0;
      var tmp0 = width;
      // Inline function 'kotlin.comparisons.maxOf' call
      var b = bounds.c8c_1.d8c_1 + indentWidth | 0;
      width = Math.max(tmp0, b);
    }
    // Inline function 'kotlin.run' call
    var $this$run = children.m();
    var baseLine = $this$run.n() ? $this$run.o().kb1_1 : 0;
    ctx.nb3(new Vector(width, height), baseLine);
    stretchChildrenWidth(this, ctx);
  };
  function View$ChildList$o$onItemAdded$lambda($event) {
    return function (listener) {
      listener.rb8($event);
      return Unit_instance;
    };
  }
  function View$ChildList$o$onItemRemoved$lambda($event) {
    return function (listener) {
      listener.sb8($event);
      return Unit_instance;
    };
  }
  function View$ChildList$1(this$0) {
    this.tb8_1 = this$0;
    CollectionAdapter.call(this);
  }
  protoOf(View$ChildList$1).ub8 = function (event) {
    var tmp0_safe_receiver = this.tb8_1.ib1_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.vb8(this.tb8_1, event);
    }
    this.tb8_1.jb2(View$ChildList$o$onItemAdded$lambda(event));
    this.tb8_1.d5u();
  };
  protoOf(View$ChildList$1).m2r = function (event) {
    return this.ub8(event);
  };
  protoOf(View$ChildList$1).wb8 = function (event) {
    var tmp0_safe_receiver = this.tb8_1.ib1_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.xb8(this.tb8_1, event);
    }
    this.tb8_1.jb2(View$ChildList$o$onItemRemoved$lambda(event));
    this.tb8_1.d5u();
  };
  protoOf(View$ChildList$1).t2r = function (event) {
    return this.wb8(event);
  };
  function View$ChildList$beforeItemAdded$lambda(this$0) {
    return function (listener) {
      listener.yb8(new PropertyChangeEvent(null, this$0));
      return Unit_instance;
    };
  }
  function View$ChildList$beforeItemRemoved$lambda($oldParent) {
    return function (listener) {
      listener.yb8(new PropertyChangeEvent($oldParent, null));
      return Unit_instance;
    };
  }
  function getChildrenForIndexOperation($this) {
    var tmp0_elvis_lhs = $this.ab9_1.eb1_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw CollectionIndexOutOfBoundsException_init_$Create$();
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function getOrInitChildren($this) {
    var tmp0_elvis_lhs = $this.ab9_1.eb1_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.run' call
      var children = new ChildList_1($this.ab9_1);
      $this.ab9_1.eb1_1 = children;
      tmp = children;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function View$ExternalChildList$addListener$1($listener) {
    this.bb9_1 = $listener;
  }
  protoOf(View$ExternalChildList$addListener$1).rb8 = function (event) {
    return this.bb9_1.m2r(event);
  };
  protoOf(View$ExternalChildList$addListener$1).sb8 = function (event) {
    return this.bb9_1.t2r(event);
  };
  function View$ExternalChildList$addHandler$1($handler) {
    this.jb9_1 = $handler;
  }
  protoOf(View$ExternalChildList$addHandler$1).ub8 = function (event) {
    return this.jb9_1.n2s(event);
  };
  protoOf(View$ExternalChildList$addHandler$1).m2r = function (event) {
    return this.ub8(event);
  };
  protoOf(View$ExternalChildList$addHandler$1).kb9 = function (event) {
    return this.jb9_1.n2s(event);
  };
  protoOf(View$ExternalChildList$addHandler$1).n2r = function (event) {
    return this.kb9(event);
  };
  protoOf(View$ExternalChildList$addHandler$1).wb8 = function (event) {
    return this.jb9_1.n2s(event);
  };
  protoOf(View$ExternalChildList$addHandler$1).t2r = function (event) {
    return this.wb8(event);
  };
  function View$getProp$1$addHandler$1($spec, $handler) {
    this.lb9_1 = $spec;
    this.mb9_1 = $handler;
  }
  protoOf(View$getProp$1$addHandler$1).cb9 = function (prop, event) {
    if (!(prop === this.lb9_1))
      return Unit_instance;
    var propertyChangeEvent = event instanceof PropertyChangeEvent ? event : THROW_CCE();
    this.mb9_1.n2s(propertyChangeEvent);
  };
  function View$customFeatureChange$1$addHandler$1($featureSpec, $handler) {
    this.nb9_1 = $featureSpec;
    this.ob9_1 = $handler;
  }
  function View$valid$1$addHandler$1($handler) {
    this.pb9_1 = $handler;
  }
  protoOf(View$valid$1$addHandler$1).db9 = function () {
    this.pb9_1.n2s(new PropertyChangeEvent(false, true));
  };
  protoOf(View$valid$1$addHandler$1).eb9 = function () {
    this.pb9_1.n2s(new PropertyChangeEvent(true, false));
  };
  function View$toRootDelta$1$addHandler$reg$1($handler) {
    this.qb9_1 = $handler;
  }
  protoOf(View$toRootDelta$1$addHandler$reg$1).ib9 = function (change) {
    return this.qb9_1.n2s(change);
  };
  function View$toRootDelta$1$addHandler$$inlined$toDisposable$1(this$0, $reg) {
    this.rb9_1 = this$0;
    this.sb9_1 = $reg;
  }
  protoOf(View$toRootDelta$1$addHandler$$inlined$toDisposable$1).zr = function () {
    changeToRootDeltaListenersCount(this.rb9_1, -1);
    this.sb9_1.zr();
    return Unit_instance;
  };
  function View$_get_boundsProp_$o$addHandler$lambda_t9bhh($handler, this$0) {
    return function (event) {
      var oldDelta = event.s2y_1;
      var newDelta = event.t2y_1;
      $handler.n2s(new PropertyChangeEvent(_get_localBounds__4u83v5(this$0).i8c(oldDelta), _get_localBounds__4u83v5(this$0).i8c(newDelta)));
      return Unit_instance;
    };
  }
  function View$boundsProp$1$addHandler$3($handler) {
    this.tb9_1 = $handler;
  }
  protoOf(View$boundsProp$1$addHandler$3).hb9 = function (change) {
    this.tb9_1.n2s(new PropertyChangeEvent(change.s2y_1, change.t2y_1));
  };
  function View$attachEvents$1$addHandler$1($handler) {
    this.ub9_1 = $handler;
  }
  protoOf(View$attachEvents$1$addHandler$1).fb9 = function () {
    return this.ub9_1.n2s(null);
  };
  function _get_reversedVisibleChildren__bljkhq($this) {
    return reversed($this.sb1());
  }
  function getInitializedProperties($this) {
    var tmp0_elvis_lhs = $this.fb1_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.run' call
      var properties = new ListMap();
      $this.fb1_1 = properties;
      tmp = properties;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function getInitializedListeners($this) {
    var tmp0_elvis_lhs = $this.hb1_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.run' call
      var listeners = new Listeners();
      $this.hb1_1 = listeners;
      tmp = listeners;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function _set_localBounds__pg62gr($this, value) {
    $this.lb1_1 = value.b8c_1.d8c_1;
    $this.mb1_1 = value.b8c_1.e8c_1;
    $this.nb1_1 = value.c8c_1.d8c_1;
    $this.ob1_1 = value.c8c_1.e8c_1;
  }
  function _get_localBounds__4u83v5($this) {
    return Rectangle_init_$Create$($this.lb1_1, $this.mb1_1, $this.nb1_1, $this.ob1_1);
  }
  function detach_1($this) {
    var tmp0_elvis_lhs = $this.ib1_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalStateException_init_$Create$();
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var oldContainer = tmp;
    $this.jb2(ViewListener$onViewDetached$ref());
    $this.c87();
    var _iterator__ex2g4s = $this.o35().m();
    while (_iterator__ex2g4s.n()) {
      var child = _iterator__ex2g4s.o();
      detach_1(child);
    }
    oldContainer.vb9($this);
    $this.ib1_1 = null;
  }
  function changeToRootDeltaListenersCount($this, delta) {
    $this.rb1_1 = $this.rb1_1 + delta | 0;
    var tmp0_safe_receiver = $this.db1_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      changeToRootDeltaListenersCount(tmp0_safe_receiver, delta);
    }
  }
  function propertyChanged($this, prop, event) {
    var tmp;
    if (!(prop === Companion_getInstance_218().zb9_1) || !$this.yb1().w2w()) {
      tmp = true;
    } else {
      var tmp_0 = event.t2y_1;
      tmp = (!(tmp_0 == null) ? typeof tmp_0 === 'boolean' : false) ? tmp_0 : THROW_CCE();
    }
    // Inline function 'kotlin.check' call
    if (!tmp) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    prop.gba_1.kba($this);
    var tmp0_safe_receiver = $this.ib1_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.lba($this, prop, event);
    }
    $this.jb2(View$propertyChanged$lambda(prop, event));
  }
  function doMove($this, delta) {
    $this.pb1_1 = $this.pb1_1 + delta.d8c_1 | 0;
    $this.qb1_1 = $this.qb1_1 + delta.e8c_1 | 0;
    var tmp0_safe_receiver = $this.ib1_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      var newBounds = $this.tb1();
      var oldBounds = newBounds.j8c(delta);
      tmp0_safe_receiver.mba($this, new PropertyChangeEvent(oldBounds, newBounds));
    }
    if (!($this.rb1_1 === 0)) {
      fireMove($this, delta);
    }
  }
  function fireMove($this, delta) {
    $this.jb2(View$fireMove$lambda($this, delta));
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = $this.o35().m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      if (!(element.rb1_1 === 0)) {
        fireMove(element, delta);
      }
    }
  }
  function doJustifyByWidth($this, children, spaceToDistribute) {
    var estimatedInterval = spaceToDistribute / (children.p() - 1 | 0) | 0;
    var spaceLeft = spaceToDistribute;
    var inductionVariable = 1;
    var last = children.p();
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var prev = children.r(i - 1 | 0);
        var current = children.r(i);
        var tmp;
        if ((i + 1 | 0) === children.p() || spaceLeft < estimatedInterval) {
          tmp = spaceLeft;
        } else {
          tmp = estimatedInterval;
        }
        var interval = tmp;
        var currentInterval = current.tb1().b8c_1.d8c_1 - (prev.tb1().b8c_1.d8c_1 + prev.tb1().c8c_1.d8c_1 | 0) | 0;
        doMove(current, new Vector(interval - currentInterval | 0, 0));
        spaceLeft = spaceLeft - interval | 0;
      }
       while (inductionVariable < last);
  }
  function assertAncestorBoundsSet($this, ctx) {
    var view = ctx.ub1_1;
    // Inline function 'kotlin.check' call
    if (!contains_6(ancestors($this), view)) {
      var message = 'Must validate ancestor of ' + $this.toString() + ', but validating ' + view.toString();
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    // Inline function 'kotlin.check' call
    if (!ctx.wb1_1) {
      var message_0 = 'Bounds are not set for ' + view.toString();
      throw IllegalStateException_init_$Create$_0(toString_1(message_0));
    }
  }
  function toStringSuffix($this) {
    var result = '@' + toString_3(hashCode($this), 16);
    // Inline function 'kotlin.text.isNotEmpty' call
    var this_0 = $this.y2().w2w();
    if (charSequenceLength(this_0) > 0) {
      result = result + ('<' + $this.y2().w2w() + '>');
    }
    return result;
  }
  function ValidationContext(view, setBoundsAndBaseline) {
    this.ub1_1 = view;
    this.vb1_1 = setBoundsAndBaseline;
    this.wb1_1 = false;
  }
  protoOf(ValidationContext).mb3 = function () {
    return this.ub1_1.tb1().b8c_1;
  };
  protoOf(ValidationContext).nb3 = function (dim, baseLine) {
    var rectangle = new Rectangle(this.mb3(), dim);
    this.xb1(rectangle, baseLine);
  };
  protoOf(ValidationContext).xb1 = function (bounds, baseLine) {
    this.vb1_1(bounds, baseLine);
    this.wb1_1 = true;
  };
  function ChildList_1($outer) {
    this.qba_1 = $outer;
    ObservableArrayList.call(this);
    this.x2r(new View$ChildList$1(this.qba_1));
  }
  protoOf(ChildList_1).rba = function (index, item) {
    item.db1_1 = this.qba_1;
    var tmp0_safe_receiver = this.qba_1.ib1_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      item.db2(tmp0_safe_receiver);
    }
    item.jb2(View$ChildList$beforeItemAdded$lambda(this.qba_1));
  };
  protoOf(ChildList_1).s2s = function (index, item) {
    return this.rba(index, item instanceof View ? item : THROW_CCE());
  };
  protoOf(ChildList_1).sba = function (index, oldItem, newItem) {
    this.tba(index, oldItem);
    this.rba(index, newItem);
  };
  protoOf(ChildList_1).x2s = function (index, oldItem, newItem) {
    var tmp = oldItem instanceof View ? oldItem : THROW_CCE();
    return this.sba(index, tmp, newItem instanceof View ? newItem : THROW_CCE());
  };
  protoOf(ChildList_1).tba = function (index, item) {
    if (this.qba_1.f89()) {
      detach_1(item);
    }
    var oldParent = item.db1_1;
    item.db1_1 = null;
    item.jb2(View$ChildList$beforeItemRemoved$lambda(oldParent));
  };
  protoOf(ChildList_1).c2t = function (index, item) {
    return this.tba(index, item instanceof View ? item : THROW_CCE());
  };
  function ExternalChildList_0($outer) {
    this.ab9_1 = $outer;
    AbstractMutableList.call(this);
  }
  protoOf(ExternalChildList_0).r = function (index) {
    return getChildrenForIndexOperation(this).r(index);
  };
  protoOf(ExternalChildList_0).p = function () {
    var tmp0_safe_receiver = this.ab9_1.eb1_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.p();
    return tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
  };
  protoOf(ExternalChildList_0).uba = function (index, element) {
    return getChildrenForIndexOperation(this).l2(index, element);
  };
  protoOf(ExternalChildList_0).l2 = function (index, element) {
    return this.uba(index, element instanceof View ? element : THROW_CCE());
  };
  protoOf(ExternalChildList_0).vba = function (index, element) {
    return getOrInitChildren(this).m2(index, element);
  };
  protoOf(ExternalChildList_0).m2 = function (index, element) {
    return this.vba(index, element instanceof View ? element : THROW_CCE());
  };
  protoOf(ExternalChildList_0).n2 = function (index) {
    var children = getChildrenForIndexOperation(this);
    var result = children.n2(index);
    if (children.s())
      this.ab9_1.eb1_1 = null;
    return result;
  };
  protoOf(ExternalChildList_0).wba = function (listener) {
    return this.ab9_1.hb2(new View$ExternalChildList$addListener$1(listener));
  };
  protoOf(ExternalChildList_0).x2r = function (listener) {
    return this.wba(listener);
  };
  protoOf(ExternalChildList_0).xba = function (handler) {
    return this.wba(new View$ExternalChildList$addHandler$1(handler));
  };
  protoOf(ExternalChildList_0).y2r = function (handler) {
    return this.xba(handler);
  };
  function ToParentOffsetProperty($outer, baseProperty) {
    this.dbb_1 = $outer;
    DerivedProperty.call(this, [baseProperty, $outer.nb2()]);
    this.cbb_1 = baseProperty;
  }
  protoOf(ToParentOffsetProperty).q2w = function () {
    return this.cbb_1.w2w().i8c(this.dbb_1.nb2().w2w());
  };
  protoOf(ToParentOffsetProperty).ebb = function (newValue) {
    return this.cbb_1.f2x(newValue.j8c(this.dbb_1.nb2().w2w()));
  };
  protoOf(ToParentOffsetProperty).d2x = function (newValue) {
    return this.ebb(newValue instanceof Vector ? newValue : THROW_CCE());
  };
  function Companion_218() {
    Companion_instance_218 = this;
    this.wb9_1 = ViewPropertySpec_init_$Create$('name', ViewPropertyKind_NONE_getInstance(), '');
    this.xb9_1 = ViewPropertySpec_init_$Create$('visible', ViewPropertyKind_RELAYOUT_PARENT_getInstance(), true);
    this.yb9_1 = ViewPropertySpec_init_$Create$('focused', ViewPropertyKind_NONE_getInstance(), false);
    this.zb9_1 = ViewPropertySpec_init_$Create$('focusable', ViewPropertyKind_NONE_getInstance(), false);
    this.aba_1 = createPropertySpec('background', ViewPropertyKind_REPAINT_getInstance());
    this.bba_1 = createPropertySpec('border', ViewPropertyKind_REPAINT_getInstance());
    this.cba_1 = createPropertySpec('borderColor', ViewPropertyKind_REPAINT_getInstance());
    this.dba_1 = ViewPropertySpec_init_$Create$('borderWidth', ViewPropertyKind_REPAINT_getInstance(), 1);
    this.eba_1 = ViewPropertySpec_init_$Create$('hasShadow', ViewPropertyKind_REPAINT_getInstance(), false);
  }
  var Companion_instance_218;
  function Companion_getInstance_218() {
    if (Companion_instance_218 == null)
      new Companion_218();
    return Companion_instance_218;
  }
  function ViewListener$onViewAttached$ref() {
    var l = function (p0) {
      p0.fb9();
      return Unit_instance;
    };
    l.callableName = 'onViewAttached';
    return l;
  }
  function ViewListener$onViewDetached$ref() {
    var l = function (p0) {
      p0.gb9();
      return Unit_instance;
    };
    l.callableName = 'onViewDetached';
    return l;
  }
  function View$getProp$1($spec, this$0) {
    this.fbb_1 = $spec;
    this.gbb_1 = this$0;
  }
  protoOf(View$getProp$1).v2w = function () {
    return toString_1(this) + '.' + this.fbb_1.toString();
  };
  protoOf(View$getProp$1).uv = function () {
    return this.gbb_1.eb2(this.fbb_1);
  };
  protoOf(View$getProp$1).d2x = function (newValue) {
    this.gbb_1.fb2(this.fbb_1, newValue);
  };
  protoOf(View$getProp$1).u2w = function (handler) {
    return this.gbb_1.hb2(new View$getProp$1$addHandler$1(this.fbb_1, handler));
  };
  protoOf(View$getProp$1).y2r = function (handler) {
    return this.u2w(handler);
  };
  function View$addListener$$inlined$toDisposable$1($reg, $listeners, this$0) {
    this.hbb_1 = $reg;
    this.ibb_1 = $listeners;
    this.jbb_1 = this$0;
  }
  protoOf(View$addListener$$inlined$toDisposable$1).zr = function () {
    this.hbb_1.zr();
    if (this.ibb_1.w2m())
      this.jbb_1.hb1_1 = null;
    return Unit_instance;
  };
  function View$customFeatureChange$1(this$0, $featureSpec) {
    this.kbb_1 = this$0;
    this.lbb_1 = $featureSpec;
  }
  protoOf(View$customFeatureChange$1).mbb = function (handler) {
    return this.kbb_1.hb2(new View$customFeatureChange$1$addHandler$1(this.lbb_1, handler));
  };
  protoOf(View$customFeatureChange$1).y2r = function (handler) {
    return this.mbb(handler);
  };
  function View$valid$1(this$0) {
    this.nbb_1 = this$0;
    BaseReadableProperty.call(this);
  }
  protoOf(View$valid$1).uv = function () {
    return this.nbb_1.jb1_1;
  };
  protoOf(View$valid$1).obb = function (handler) {
    return this.nbb_1.hb2(new View$valid$1$addHandler$1(handler));
  };
  protoOf(View$valid$1).y2r = function (handler) {
    return this.obb(handler);
  };
  function ViewListener$onViewInvalidated$ref() {
    var l = function (p0) {
      p0.eb9();
      return Unit_instance;
    };
    l.callableName = 'onViewInvalidated';
    return l;
  }
  function View$validate$lambda$lambda($event) {
    return function (listener) {
      listener.hb9($event);
      return Unit_instance;
    };
  }
  function View$validate$lambda(this$0) {
    return function (newBounds, newBaseLine) {
      var oldBounds = this$0.tb1();
      _set_localBounds__pg62gr(this$0, newBounds.j8c(this$0.nb2().w2w()));
      var tmp;
      if (!oldBounds.equals(newBounds)) {
        var event = new PropertyChangeEvent(oldBounds, newBounds);
        this$0.jb2(View$validate$lambda$lambda(event));
        var tmp0_safe_receiver = this$0.ib1_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.mba(this$0, event);
        }
        tmp = Unit_instance;
      }
      this$0.kb1_1 = newBaseLine;
      return Unit_instance;
    };
  }
  function ViewListener$onViewValidated$ref() {
    var l = function (p0) {
      p0.db9();
      return Unit_instance;
    };
    l.callableName = 'onViewValidated';
    return l;
  }
  function View$toRootDelta$1(this$0) {
    this.pbb_1 = this$0;
    BaseReadableProperty.call(this);
  }
  protoOf(View$toRootDelta$1).uv = function () {
    var tmp0 = ancestorsFrom(this.pbb_1);
    // Inline function 'kotlin.sequences.fold' call
    var accumulator = Companion_getInstance_136().h8c_1;
    var _iterator__ex2g4s = tmp0.m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      accumulator = accumulator.i8c(new Vector(element.pb1_1, element.qb1_1));
    }
    return accumulator;
  };
  protoOf(View$toRootDelta$1).qbb = function (handler) {
    var reg = this.pbb_1.hb2(new View$toRootDelta$1$addHandler$reg$1(handler));
    changeToRootDeltaListenersCount(this.pbb_1, 1);
    // Inline function 'jetbrains.ocelot.base.disposable.toDisposable' call
    return new View$toRootDelta$1$addHandler$$inlined$toDisposable$1(this.pbb_1, reg);
  };
  protoOf(View$toRootDelta$1).y2r = function (handler) {
    return this.qbb(handler);
  };
  function View$boundsProp$1(this$0) {
    this.rbb_1 = this$0;
    BaseReadableProperty.call(this);
  }
  protoOf(View$boundsProp$1).uv = function () {
    return _get_localBounds__4u83v5(this.rbb_1).i8c(this.rbb_1.nb2().w2w());
  };
  protoOf(View$boundsProp$1).sbb = function (handler) {
    var tmp = this.rbb_1.nb2();
    var tmp_0 = tmp.z2r(View$_get_boundsProp_$o$addHandler$lambda_t9bhh(handler, this.rbb_1));
    return toDisposable_0([tmp_0, this.rbb_1.hb2(new View$boundsProp$1$addHandler$3(handler))]);
  };
  protoOf(View$boundsProp$1).y2r = function (handler) {
    return this.sbb(handler);
  };
  function View$propertyChanged$lambda($prop, $event) {
    return function (listener) {
      listener.cb9($prop, $event);
      return Unit_instance;
    };
  }
  function View$fireMove$lambda(this$0, $delta) {
    return function (listener) {
      var toRootDelta = this$0.nb2().w2w();
      var event = new PropertyChangeEvent(toRootDelta.j8c($delta), toRootDelta);
      listener.ib9(event);
      return Unit_instance;
    };
  }
  function View$attachEvents$1(this$0) {
    this.tbb_1 = this$0;
  }
  protoOf(View$attachEvents$1).ubb = function (handler) {
    return this.tbb_1.hb2(new View$attachEvents$1$addHandler$1(handler));
  };
  protoOf(View$attachEvents$1).y2r = function (handler) {
    return this.ubb(handler);
  };
  function View(isExtension) {
    Companion_getInstance_218();
    isExtension = isExtension === VOID ? false : isExtension;
    this.cb1_1 = isExtension;
    this.db1_1 = null;
    this.eb1_1 = null;
    this.fb1_1 = null;
    this.gb1_1 = null;
    this.hb1_1 = null;
    this.ib1_1 = null;
    this.jb1_1 = false;
    this.kb1_1 = 0;
    this.lb1_1 = 0;
    this.mb1_1 = 0;
    this.nb1_1 = 0;
    this.ob1_1 = 0;
    this.pb1_1 = 0;
    this.qb1_1 = 0;
    this.rb1_1 = 0;
  }
  protoOf(View).bp = function () {
    return this.db1_1;
  };
  protoOf(View).o35 = function () {
    return this.q92();
  };
  protoOf(View).q92 = function () {
    return new ExternalChildList_0(this);
  };
  protoOf(View).sb1 = function () {
    // Inline function 'kotlin.collections.filter' call
    var tmp0 = this.o35();
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList_init_$Create$();
    var _iterator__ex2g4s = tmp0.m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      if (element.m92().w2w()) {
        destination.j(element);
      }
    }
    return destination;
  };
  protoOf(View).f89 = function () {
    return !(this.ib1_1 == null);
  };
  protoOf(View).tb1 = function () {
    return this.ob2().w2w();
  };
  protoOf(View).m92 = function () {
    return this.gb2(Companion_getInstance_218().xb9_1);
  };
  protoOf(View).yb1 = function () {
    return this.gb2(Companion_getInstance_218().yb9_1);
  };
  protoOf(View).p92 = function () {
    return this.gb2(Companion_getInstance_218().zb9_1);
  };
  protoOf(View).c9b = function () {
    return this.gb2(Companion_getInstance_218().aba_1);
  };
  protoOf(View).ab2 = function () {
    return this.gb2(Companion_getInstance_218().cba_1);
  };
  protoOf(View).bb2 = function () {
    return this.gb2(Companion_getInstance_218().dba_1);
  };
  protoOf(View).cb2 = function () {
    return this.gb2(Companion_getInstance_218().eba_1);
  };
  protoOf(View).y2 = function () {
    return this.gb2(Companion_getInstance_218().wb9_1);
  };
  protoOf(View).zb1 = function (focused) {
    return this.gb2(Companion_getInstance_218().yb9_1).d2x(focused);
  };
  protoOf(View).p35 = function () {
    return Composites_instance.w35(this);
  };
  protoOf(View).s35 = function () {
    return Composites_instance.x35(this);
  };
  protoOf(View).y35 = function () {
    var tmp0_safe_receiver = this.eb1_1;
    return tmp0_safe_receiver == null ? null : first(tmp0_safe_receiver);
  };
  protoOf(View).z35 = function () {
    var tmp0_safe_receiver = this.eb1_1;
    return tmp0_safe_receiver == null ? null : last(tmp0_safe_receiver);
  };
  protoOf(View).b87 = function () {
  };
  protoOf(View).c87 = function () {
  };
  protoOf(View).db2 = function (newContainer) {
    // Inline function 'kotlin.check' call
    if (!(this.ib1_1 == null)) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    var _iterator__ex2g4s = this.o35().m();
    while (_iterator__ex2g4s.n()) {
      var child = _iterator__ex2g4s.o();
      child.db2(newContainer);
    }
    this.ib1_1 = newContainer;
    newContainer.vbb(this);
    this.b87();
    this.jb2(ViewListener$onViewAttached$ref());
  };
  protoOf(View).eb2 = function (prop) {
    var tmp0_safe_receiver = this.fb1_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      if (tmp0_safe_receiver.o2(prop)) {
        var tmp = tmp0_safe_receiver.q2(prop);
        return (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
      }
    }
    var tmp1_safe_receiver = this.gb1_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s = tmp1_safe_receiver.m();
      while (_iterator__ex2g4s.n()) {
        var element = _iterator__ex2g4s.o();
        // Inline function 'jetbrains.ocelot.projectional.view.ViewTrait.dispatchByParent' call
        var current = element;
        while (!(current == null)) {
          var $this$dispatchByParent = current;
          if ($this$dispatchByParent.abc(prop))
            return $this$dispatchByParent.zbb(prop);
          current = access$_get_parent__alxd0f(current);
        }
      }
    }
    return prop.bbc(this);
  };
  protoOf(View).fb2 = function (prop, value) {
    if (this.fb1_1 == null && value == null)
      return Unit_instance;
    var properties = getInitializedProperties(this);
    var oldValue = this.eb2(prop);
    if (value == null) {
      properties.u2(prop);
      if (properties.w2m())
        this.fb1_1 = null;
    } else {
      properties.t2(prop, value);
    }
    var newValue = this.eb2(prop);
    if (!equals(newValue, oldValue)) {
      propertyChanged(this, prop, new PropertyChangeEvent(oldValue, newValue));
    }
  };
  protoOf(View).kb4 = function (spec) {
    return new ToParentOffsetProperty(this, this.gb2(spec));
  };
  protoOf(View).gb2 = function (spec) {
    return new View$getProp$1(spec, this);
  };
  protoOf(View).hb2 = function (listener) {
    var listeners = getInitializedListeners(this);
    var reg = listeners.j2s(listener);
    // Inline function 'jetbrains.ocelot.base.disposable.toDisposable' call
    return new View$addListener$$inlined$toDisposable$1(reg, listeners, this);
  };
  protoOf(View).hb5 = function (featureSpec) {
    return new View$customFeatureChange$1(this, featureSpec);
  };
  protoOf(View).ib2 = function () {
    return new View$valid$1(this);
  };
  protoOf(View).d5u = function () {
    if (!this.jb1_1)
      return Unit_instance;
    this.jb1_1 = false;
    this.jb2(ViewListener$onViewInvalidated$ref());
    var tmp0_safe_receiver = this.db1_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.d5u();
    }
  };
  protoOf(View).jb2 = function (h) {
    var tmp0_safe_receiver = this.hb1_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.k2s(h);
    }
  };
  protoOf(View).cbc = function () {
    this.d5u();
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = this.o35().m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      element.d5u();
    }
  };
  protoOf(View).kb2 = function () {
    var tmp0_safe_receiver = this.ib1_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.dbc(this);
    }
  };
  protoOf(View).lb2 = function () {
    return this.kb2();
  };
  protoOf(View).bb1 = function (ctx) {
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = this.o35().m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      element.mb2();
    }
    return Unit_instance;
  };
  protoOf(View).mb2 = function () {
    if (this.jb1_1)
      return Unit_instance;
    this.bb1(new ValidationContext(this, View$validate$lambda(this)));
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = this.o35().m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      // Inline function 'kotlin.check' call
      if (!element.jb1_1) {
        var message = 'After doValidate all children must be valid';
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      }
    }
    this.jb1_1 = true;
    this.jb2(ViewListener$onViewValidated$ref());
  };
  protoOf(View).nb2 = function () {
    return new View$toRootDelta$1(this);
  };
  protoOf(View).ob2 = function () {
    return new View$boundsProp$1(this);
  };
  protoOf(View).pb2 = function (loc) {
    if (!this.m92().w2w())
      return null;
    var _iterator__ex2g4s = _get_reversedVisibleChildren__bljkhq(this).m();
    while (_iterator__ex2g4s.n()) {
      var child = _iterator__ex2g4s.o();
      if (child.tb1().l8c(loc)) {
        var result = child.pb2(loc);
        if (!(result == null))
          return result;
      }
    }
    return this.ab1(loc) ? this : null;
  };
  protoOf(View).ab1 = function (loc) {
    return this.tb1().l8c(loc);
  };
  protoOf(View).qb2 = function (to) {
    return this.rb2(to.j8c(this.tb1().b8c_1));
  };
  protoOf(View).rb2 = function (delta) {
    if (delta.equals(Companion_getInstance_136().h8c_1))
      return Unit_instance;
    var tmp0_safe_receiver = this.db1_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.d5u();
    }
    doMove(this, delta);
  };
  protoOf(View).sb2 = function (ctx) {
    assertAncestorBoundsSet(this, ctx);
    var oldBounds = this.tb1();
    this.nb1_1 = ensureNotNull(this.db1_1).tb1().c8c_1.d8c_1;
    var tmp0_safe_receiver = this.ib1_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.mba(this, new PropertyChangeEvent(oldBounds, this.tb1()));
    }
  };
  protoOf(View).ob3 = function (ctx) {
    assertAncestorBoundsSet(this, ctx);
    var children = toList_0(this.sb1());
    // Inline function 'kotlin.check' call
    if (!(children.p() >= 2)) {
      var message = 'To little visible children: ' + children.p();
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    var width = this.tb1().c8c_1.d8c_1;
    // Inline function 'kotlin.collections.sumOf' call
    var sum = 0;
    var _iterator__ex2g4s = children.m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      var tmp = sum;
      sum = tmp + element.tb1().c8c_1.d8c_1 | 0;
    }
    var childrenWidthsSum = sum;
    if (childrenWidthsSum === this.tb1().c8c_1.d8c_1) {
      return Unit_instance;
    }
    // Inline function 'kotlin.check' call
    if (!(childrenWidthsSum <= width)) {
      var message_0 = this.toString() + ', width=' + width + ', childrenWidthsSum=' + childrenWidthsSum;
      throw IllegalStateException_init_$Create$_0(toString_1(message_0));
    }
    doJustifyByWidth(this, children, width - childrenWidthsSum | 0);
  };
  protoOf(View).tb2 = function (spec, event) {
    var tmp0_safe_receiver = this.gb1_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s = tmp0_safe_receiver.m();
      while (_iterator__ex2g4s.n()) {
        var element = _iterator__ex2g4s.o();
        // Inline function 'jetbrains.ocelot.projectional.view.ViewTrait.dispatchByParent' call
        var current = element;
        while (!(current == null)) {
          current.ebc(this, spec, event);
          if (event.l8i_1)
            return Unit_instance;
          current = access$_get_parent__alxd0f(current);
        }
      }
    }
    var tmp1_safe_receiver = this.db1_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.tb2(spec, event);
    }
  };
  protoOf(View).ub2 = function () {
    return new View$attachEvents$1(this);
  };
  protoOf(View).toString = function () {
    return this.vb2() + toStringSuffix(this);
  };
  protoOf(View).vb2 = function () {
    var tmp0_elvis_lhs = getKClassFromExpression(this).ra();
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
  function ViewContainer$RootView$1() {
  }
  protoOf(ViewContainer$RootView$1).rb8 = function (event) {
    throw IllegalStateException_init_$Create$_0("It's forbidden to add children to root node");
  };
  protoOf(ViewContainer$RootView$1).sb8 = function (event) {
    throw IllegalStateException_init_$Create$_0("It's forbidden to remove children from root node");
  };
  function changeViewUnderMouse($this, e, newView) {
    if ($this.qb8_1 === newView)
      return Unit_instance;
    var tmp0_safe_receiver = $this.qb8_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      executeCommand($this, ViewContainer$changeViewUnderMouse$lambda(tmp0_safe_receiver, e));
    }
    if (newView == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      executeCommand($this, ViewContainer$changeViewUnderMouse$lambda_0(newView, e));
    }
    $this.qb8_1 = newView;
  }
  function dispatchMouseEvent($this, e, spec) {
    executeCommand($this, ViewContainer$dispatchMouseEvent$lambda($this, e, spec));
  }
  function executeCommand($this, r) {
    if ($this.pb8_1) {
      r();
    } else {
      $this.pb8_1 = true;
      $this.ob8_1.k2s(ViewContainerListener$onBeforeCommand$ref());
      try {
        r();
      }finally {
        $this.ob8_1.k2s(ViewContainerListener$onAfterCommand$ref());
        $this.pb8_1 = false;
      }
    }
  }
  function dispatchFocusBasedEvent($this, e, spec) {
    executeCommand($this, ViewContainer$dispatchFocusBasedEvent$lambda($this, spec, e));
  }
  function RootView($outer) {
    this.xbc_1 = $outer;
    View.call(this);
    this.vbc_1 = new GroupView();
    this.wbc_1 = new GroupView();
    var children = this.q92();
    children.j(this.wbc_1);
    children.j(this.vbc_1);
    this.hb2(new ViewContainer$RootView$1());
  }
  protoOf(RootView).mb2 = function () {
    protoOf(View).mb2.call(this);
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = this.xbc_1.nb8_1.m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      element();
    }
    this.xbc_1.nb8_1.k2();
  };
  protoOf(RootView).bb1 = function (ctx) {
    protoOf(View).bb1.call(this, ctx);
    var tmp0 = this.sb1();
    // Inline function 'kotlin.collections.fold' call
    var accumulator = Companion_getInstance_135().g8c_1;
    var _iterator__ex2g4s = tmp0.m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      accumulator = accumulator.m8c(element.tb1());
    }
    var current = accumulator;
    ctx.xb1(current, 0);
  };
  function FocusedViewProperty($outer) {
    this.abd_1 = $outer;
    ValueProperty.call(this, null);
  }
  protoOf(FocusedViewProperty).bbd = function (newValue) {
    if (!(newValue == null)) {
      // Inline function 'kotlin.check' call
      if (!newValue.p92().w2w()) {
        var message = 'cannot set focus: ' + newValue.toString();
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      }
      // Inline function 'kotlin.require' call
      // Inline function 'kotlin.require' call
      if (!(newValue.ib1_1 === this.abd_1)) {
        var message_0 = 'Failed requirement.';
        throw IllegalArgumentException_init_$Create$_0(toString_1(message_0));
      }
    }
    var oldValue = this.uv();
    if (oldValue === newValue)
      return Unit_instance;
    if (oldValue == null)
      null;
    else {
      oldValue.zb1(false);
    }
    protoOf(ValueProperty).d2x.call(this, newValue);
    if (newValue == null)
      null;
    else {
      newValue.zb1(true);
    }
  };
  protoOf(FocusedViewProperty).d2x = function (newValue) {
    return this.bbd((newValue == null ? true : newValue instanceof View) ? newValue : THROW_CCE());
  };
  function ViewContainer$mouseDragged$lambda(this$0, $e) {
    return function () {
      this$0.t42().mb2();
      var tmp0_safe_receiver = this$0.mb8_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.tb2(ViewEvents_getInstance().hbd_1, $e);
      }
      return Unit_instance;
    };
  }
  function ViewContainer$changeViewUnderMouse$lambda($oldView, $e) {
    return function () {
      $oldView.tb2(ViewEvents_getInstance().jbd_1, MouseEvent_init_$Create$($e.z8l(), $e.t8l_1, $e.u8l_1));
      return Unit_instance;
    };
  }
  function ViewContainer$changeViewUnderMouse$lambda_0($newView, $e) {
    return function () {
      $newView.tb2(ViewEvents_getInstance().ibd_1, MouseEvent_init_$Create$($e.z8l(), $e.t8l_1, $e.u8l_1));
      return Unit_instance;
    };
  }
  function ViewContainer$dispatchMouseEvent$lambda(this$0, $e, $spec) {
    return function () {
      this$0.t42().mb2();
      var tmp0_elvis_lhs = this$0.t42().pb2($e.z8l());
      var target = tmp0_elvis_lhs == null ? this$0.t42() : tmp0_elvis_lhs;
      var tmp;
      if ($spec === ViewEvents_getInstance().ebd_1) {
        this$0.mb8_1 = target;
        tmp = Unit_instance;
      }
      target.tb2($spec, $e);
      return Unit_instance;
    };
  }
  function ViewContainerListener$onBeforeCommand$ref() {
    var l = function (p0) {
      p0.h93();
      return Unit_instance;
    };
    l.callableName = 'onBeforeCommand';
    return l;
  }
  function ViewContainerListener$onAfterCommand$ref() {
    var l = function (p0) {
      p0.i93();
      return Unit_instance;
    };
    l.callableName = 'onAfterCommand';
    return l;
  }
  function ViewContainer$dispatchFocusBasedEvent$lambda(this$0, $spec, $e) {
    return function () {
      var tmp0_elvis_lhs = this$0.lb8_1.w2w();
      var target = tmp0_elvis_lhs == null ? this$0.t42() : tmp0_elvis_lhs;
      target.tb2($spec, $e);
      return Unit_instance;
    };
  }
  function ViewContainer$propertyChanged$lambda($view, $prop, $event) {
    return function (l) {
      l.wbd($view, $prop, $event);
      return Unit_instance;
    };
  }
  function ViewContainer$childAdded$lambda($parent, $event) {
    return function (l) {
      l.xbd($parent, $event);
      return Unit_instance;
    };
  }
  function ViewContainer$childRemoved$lambda($parent, $event) {
    return function (l) {
      l.ybd($parent, $event);
      return Unit_instance;
    };
  }
  function ViewContainer$viewAttached$lambda($view) {
    return function (l) {
      l.zbd($view);
      return Unit_instance;
    };
  }
  function ViewContainer$viewDetached$lambda($view) {
    return function (l) {
      l.abe($view);
      return Unit_instance;
    };
  }
  function ViewContainer() {
    this.jb8_1 = new NullViewContainerPeer();
    this.kb8_1 = new RootView(this);
    this.lb8_1 = new FocusedViewProperty(this);
    this.mb8_1 = null;
    this.nb8_1 = ArrayList_init_$Create$();
    this.ob8_1 = new Listeners();
    this.pb8_1 = false;
    this.qb8_1 = null;
    this.jb8_1.kb5(this);
    this.kb8_1.db2(this);
  }
  protoOf(ViewContainer).bbe = function (value) {
    this.jb8_1.e6j();
    this.jb8_1 = value;
    this.kb8_1.cbc();
    this.jb8_1.kb5(this);
  };
  protoOf(ViewContainer).t42 = function () {
    return this.kb8_1;
  };
  protoOf(ViewContainer).cbe = function () {
    return this.kb8_1.wbc_1;
  };
  protoOf(ViewContainer).dbe = function () {
    return this.kb8_1.vbc_1;
  };
  protoOf(ViewContainer).ebe = function (r) {
    if (this.kb8_1.jb1_1) {
      r();
    } else {
      this.nb8_1.j(r);
    }
  };
  protoOf(ViewContainer).dbc = function (view) {
    this.jb8_1.lb5(view);
  };
  protoOf(ViewContainer).mba = function (view, change) {
    this.jb8_1.mb5(view, change);
  };
  protoOf(ViewContainer).o8n = function (e) {
    return dispatchMouseEvent(this, e, ViewEvents_getInstance().cbd_1);
  };
  protoOf(ViewContainer).q8n = function (e) {
    return dispatchMouseEvent(this, e, ViewEvents_getInstance().dbd_1);
  };
  protoOf(ViewContainer).r8n = function (e) {
    return dispatchMouseEvent(this, e, ViewEvents_getInstance().ebd_1);
  };
  protoOf(ViewContainer).t8n = function (e) {
    var dragStart = this.mb8_1;
    if (dragStart == null) {
      dispatchMouseEvent(this, e, ViewEvents_getInstance().fbd_1);
    } else {
      this.t42().mb2();
      dragStart.tb2(ViewEvents_getInstance().fbd_1, e);
      this.mb8_1 = null;
    }
  };
  protoOf(ViewContainer).v8n = function (e) {
    changeViewUnderMouse(this, e, this.t42().pb2(e.z8l()));
    dispatchMouseEvent(this, e, ViewEvents_getInstance().gbd_1);
  };
  protoOf(ViewContainer).u8n = function (e) {
    executeCommand(this, ViewContainer$mouseDragged$lambda(this, e));
  };
  protoOf(ViewContainer).w8n = function (e) {
    this.t42().mb2();
    changeViewUnderMouse(this, e, this.t42().pb2(e.z8l()));
  };
  protoOf(ViewContainer).y8n = function (e) {
    this.t42().mb2();
    changeViewUnderMouse(this, e, null);
  };
  protoOf(ViewContainer).i8n = function (e) {
    dispatchFocusBasedEvent(this, e, ViewEvents_getInstance().qbd_1);
  };
  protoOf(ViewContainer).f8o = function (e) {
    dispatchFocusBasedEvent(this, e, ViewEvents_getInstance().rbd_1);
  };
  protoOf(ViewContainer).j8n = function (e) {
    dispatchFocusBasedEvent(this, e, ViewEvents_getInstance().sbd_1);
  };
  protoOf(ViewContainer).e8o = function (e) {
    dispatchFocusBasedEvent(this, e, ViewEvents_getInstance().tbd_1);
  };
  protoOf(ViewContainer).d8o = function (e) {
    dispatchFocusBasedEvent(this, e, ViewEvents_getInstance().ubd_1);
  };
  protoOf(ViewContainer).f9v = function (e) {
    dispatchFocusBasedEvent(this, e, ViewEvents_getInstance().vbd_1);
  };
  protoOf(ViewContainer).g8o = function (text) {
    var inductionVariable = 0;
    var last = text.length;
    while (inductionVariable < last) {
      var c = charCodeAt(text, inductionVariable);
      inductionVariable = inductionVariable + 1 | 0;
      if (c === _Char___init__impl__6a9atx(10)) {
        this.i8n(KeyEvent_init_$Create$(Key_ENTER_getInstance(), _Char___init__impl__6a9atx(65535)));
      } else {
        this.j8n(KeyEvent_init_$Create$(Key_UNKNOWN_getInstance(), c));
      }
    }
  };
  protoOf(ViewContainer).p8o = function () {
    this.f9v(new PasteEvent(ExternalPasteContent_instance));
  };
  protoOf(ViewContainer).m8o = function (e) {
  };
  protoOf(ViewContainer).n8o = function (e) {
  };
  protoOf(ViewContainer).o8o = function (e) {
  };
  protoOf(ViewContainer).lba = function (view, prop, event) {
    this.ob8_1.k2s(ViewContainer$propertyChanged$lambda(view, prop, event));
  };
  protoOf(ViewContainer).vb8 = function (parent, event) {
    this.ob8_1.k2s(ViewContainer$childAdded$lambda(parent, event));
  };
  protoOf(ViewContainer).xb8 = function (parent, event) {
    this.ob8_1.k2s(ViewContainer$childRemoved$lambda(parent, event));
  };
  protoOf(ViewContainer).vbb = function (view) {
    this.ob8_1.k2s(ViewContainer$viewAttached$lambda(view));
  };
  protoOf(ViewContainer).vb9 = function (view) {
    if (this.lb8_1.w2w() === view) {
      this.lb8_1.f2x(null);
    }
    this.ob8_1.k2s(ViewContainer$viewDetached$lambda(view));
  };
  function ViewContainerListener() {
  }
  function ViewEventSpec(name) {
    this.fbe_1 = name;
  }
  protoOf(ViewEventSpec).toString = function () {
    return this.fbe_1;
  };
  function ViewEvents() {
    ViewEvents_instance = this;
    this.cbd_1 = new ViewEventSpec('mouseClicked');
    this.dbd_1 = new ViewEventSpec('mouseDoubleClicked');
    this.ebd_1 = new ViewEventSpec('mousePressed');
    this.fbd_1 = new ViewEventSpec('mouseReleased');
    this.gbd_1 = new ViewEventSpec('mouseMoved');
    this.hbd_1 = new ViewEventSpec('mouseDragged');
    this.ibd_1 = new ViewEventSpec('mouseEntered');
    this.jbd_1 = new ViewEventSpec('mouseLeft');
    this.kbd_1 = new ViewEventSpec('touchStarted');
    this.lbd_1 = new ViewEventSpec('touchLongTapped');
    this.mbd_1 = new ViewEventSpec('touchMoved');
    this.nbd_1 = new ViewEventSpec('touchDragged');
    this.obd_1 = new ViewEventSpec('touchEnded');
    this.pbd_1 = new ViewEventSpec('popupRequested');
    this.qbd_1 = new ViewEventSpec('keyPressed');
    this.rbd_1 = new ViewEventSpec('keyReleased');
    this.sbd_1 = new ViewEventSpec('keyTyped');
    this.tbd_1 = new ViewEventSpec('copy');
    this.ubd_1 = new ViewEventSpec('cut');
    this.vbd_1 = new ViewEventSpec('paste');
  }
  var ViewEvents_instance;
  function ViewEvents_getInstance() {
    if (ViewEvents_instance == null)
      new ViewEvents();
    return ViewEvents_instance;
  }
  function ViewListener() {
  }
  function ViewPropertyKind$NONE() {
    ViewPropertyKind.call(this, 'NONE', 0);
    ViewPropertyKind_NONE_instance = this;
  }
  protoOf(ViewPropertyKind$NONE).kba = function (view) {
  };
  var ViewPropertyKind_NONE_instance;
  function ViewPropertyKind$REPAINT() {
    ViewPropertyKind.call(this, 'REPAINT', 1);
    ViewPropertyKind_REPAINT_instance = this;
  }
  protoOf(ViewPropertyKind$REPAINT).kba = function (view) {
    view.lb2();
  };
  var ViewPropertyKind_REPAINT_instance;
  function ViewPropertyKind$RELAYOUT() {
    ViewPropertyKind.call(this, 'RELAYOUT', 2);
    ViewPropertyKind_RELAYOUT_instance = this;
  }
  protoOf(ViewPropertyKind$RELAYOUT).kba = function (view) {
    view.d5u();
  };
  var ViewPropertyKind_RELAYOUT_instance;
  function ViewPropertyKind$RELAYOUT_AND_REPAINT() {
    ViewPropertyKind.call(this, 'RELAYOUT_AND_REPAINT', 3);
    ViewPropertyKind_RELAYOUT_AND_REPAINT_instance = this;
  }
  protoOf(ViewPropertyKind$RELAYOUT_AND_REPAINT).kba = function (view) {
    view.lb2();
    view.d5u();
  };
  var ViewPropertyKind_RELAYOUT_AND_REPAINT_instance;
  function ViewPropertyKind$RELAYOUT_PARENT() {
    ViewPropertyKind.call(this, 'RELAYOUT_PARENT', 4);
    ViewPropertyKind_RELAYOUT_PARENT_instance = this;
  }
  protoOf(ViewPropertyKind$RELAYOUT_PARENT).kba = function (view) {
    var tmp0_safe_receiver = view.db1_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.d5u();
    }
  };
  var ViewPropertyKind_RELAYOUT_PARENT_instance;
  var ViewPropertyKind_entriesInitialized;
  function ViewPropertyKind_initEntries() {
    if (ViewPropertyKind_entriesInitialized)
      return Unit_instance;
    ViewPropertyKind_entriesInitialized = true;
    ViewPropertyKind_NONE_instance = new ViewPropertyKind$NONE();
    ViewPropertyKind_REPAINT_instance = new ViewPropertyKind$REPAINT();
    ViewPropertyKind_RELAYOUT_instance = new ViewPropertyKind$RELAYOUT();
    ViewPropertyKind_RELAYOUT_AND_REPAINT_instance = new ViewPropertyKind$RELAYOUT_AND_REPAINT();
    ViewPropertyKind_RELAYOUT_PARENT_instance = new ViewPropertyKind$RELAYOUT_PARENT();
  }
  function ViewPropertyKind(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function ViewPropertyKind_NONE_getInstance() {
    ViewPropertyKind_initEntries();
    return ViewPropertyKind_NONE_instance;
  }
  function ViewPropertyKind_REPAINT_getInstance() {
    ViewPropertyKind_initEntries();
    return ViewPropertyKind_REPAINT_instance;
  }
  function ViewPropertyKind_RELAYOUT_getInstance() {
    ViewPropertyKind_initEntries();
    return ViewPropertyKind_RELAYOUT_instance;
  }
  function ViewPropertyKind_RELAYOUT_AND_REPAINT_getInstance() {
    ViewPropertyKind_initEntries();
    return ViewPropertyKind_RELAYOUT_AND_REPAINT_instance;
  }
  function ViewPropertyKind_RELAYOUT_PARENT_getInstance() {
    ViewPropertyKind_initEntries();
    return ViewPropertyKind_RELAYOUT_PARENT_instance;
  }
  function ViewPropertySpec_init_$Init$(name, kind, defaultValue, $this) {
    ViewPropertySpec.call($this, name, kind, ViewPropertySpec$_init_$lambda_8zh9pm(defaultValue));
    return $this;
  }
  function ViewPropertySpec_init_$Create$(name, kind, defaultValue) {
    return ViewPropertySpec_init_$Init$(name, kind, defaultValue, objectCreate(protoOf(ViewPropertySpec)));
  }
  function ViewPropertySpec$_init_$lambda_8zh9pm($defaultValue) {
    return function (it) {
      return $defaultValue;
    };
  }
  function ViewPropertySpec(name, kind, defaultValue) {
    kind = kind === VOID ? ViewPropertyKind_NONE_getInstance() : kind;
    this.fba_1 = name;
    this.gba_1 = kind;
    this.hba_1 = defaultValue;
  }
  protoOf(ViewPropertySpec).bbc = function (view) {
    return this.hba_1(view);
  };
  protoOf(ViewPropertySpec).toString = function () {
    return this.fba_1;
  };
  function createPropertySpec(name, kind) {
    return new ViewPropertySpec(name, kind, createPropertySpec$lambda);
  }
  function createPropertySpec_0(name) {
    return new ViewPropertySpec(name, VOID, createPropertySpec$lambda_0);
  }
  function createPropertySpec$lambda(it) {
    return null;
  }
  function createPropertySpec$lambda_0(it) {
    return null;
  }
  function access$_get_parent__alxd0f($this) {
    return $this.wbb_1;
  }
  function spaceDimensions(font) {
    return TextMetricsCalculator_getInstance().ube(font, ' ').vbe();
  }
  function Companion_219() {
    Companion_instance_219 = this;
    this.wbe_1 = false;
    this.xbe_1 = false;
    this.ybe_1 = new CellToDomCss();
  }
  protoOf(Companion_219).n26 = function () {
    if (!this.xbe_1) {
      this.xbe_1 = true;
    }
    return this.ybe_1;
  };
  protoOf(Companion_219).zbe = function (fontWidthCalculator) {
    if (this.wbe_1)
      return Unit_instance;
    StyleInjector_getInstance().c8i();
    var width = fontWidthCalculator();
    StyleInjector_getInstance().b8i('.' + this.ybe_1.ebf_1 + '{ padding-left: ' + width + 'px }');
    this.wbe_1 = true;
  };
  var Companion_instance_219;
  function Companion_getInstance_219() {
    if (Companion_instance_219 == null)
      new Companion_219();
    return Companion_instance_219;
  }
  function CellToDomCss() {
    Companion_getInstance_219();
    this.abf_1 = 'cell';
    this.bbf_1 = 'vertical';
    this.cbf_1 = 'rootContainer';
    this.dbf_1 = 'horizontal';
    this.ebf_1 = 'indented';
    this.fbf_1 = 'hidden';
    this.gbf_1 = 'outlined';
    this.hbf_1 = 'selected';
    this.ibf_1 = 'paired';
    this.jbf_1 = 'domCell';
    this.kbf_1 = 'hasShadow';
    this.lbf_1 = 'hasScroll';
    this.mbf_1 = 'userSelectable';
    this.nbf_1 = 'lineHighlight';
    this.obf_1 = 'content';
    this.pbf_1 = 'fitContentWidth';
    this.qbf_1 = 'underlinedRed';
    this.rbf_1 = 'underlinedYellow';
    this.sbf_1 = 'underlinedBlue';
    this.tbf_1 = 'rgba(0, 0, 0, 0.2)';
    this.ubf_1 = 'link';
    this.vbf_1 = 'popup';
    this.wbf_1 = 'passThroughMouse';
    this.xbf_1 = 'tooltip';
    this.ybf_1 = 'tooltipBottom';
    this.zbf_1 = 'tooltipTop';
    this.abg_1 = 'allowFlexWrap';
    this.bbg_1 = 'justifyContent';
  }
  function Companion_220() {
    Companion_instance_220 = this;
    this.cbg_1 = CellTraitPropertySpec_init_$Create$('userSelectable', false);
    this.dbg_1 = CellTraitPropertySpec_init_$Create$('captureFocus', false);
    this.ebg_1 = CellPropertySpec_init_$Create$('node', null);
  }
  var Companion_instance_220;
  function Companion_getInstance_220() {
    if (Companion_instance_220 == null)
      new Companion_220();
    return Companion_instance_220;
  }
  function DomCell() {
  }
  protoOf(DomCell).obg = function () {
    return this.nbg_1;
  };
  function forAlignment($this, sourceProperty, setProperty, clearProperty) {
    return bindStyle($this, asCssValue($this, sourceProperty), setProperty, clearProperty);
  }
  function asCssValue($this, alignmentProp) {
    return map_0(alignmentProp, AlignmentSynchronizers$asCssValue$lambda);
  }
  function bindStyle($this, stylePropertyValue, setProperty, clearProperty) {
    var tmp = PropertyBinding_instance;
    // Inline function 'jetbrains.ocelot.base.observable.property.writableProperty' call
    var tmp$ret$0 = new AlignmentSynchronizers$bindStyle$$inlined$writableProperty$1(clearProperty, setProperty);
    return tmp.n30(stylePropertyValue, tmp$ret$0);
  }
  function AlignmentSynchronizers$forCrossAlignment$lambda($target) {
    return function (item) {
      setAlignItems($target.style, item);
      return Unit_instance;
    };
  }
  function AlignmentSynchronizers$forCrossAlignment$lambda_0($target) {
    return function () {
      clearAlignItems($target.style);
      return Unit_instance;
    };
  }
  function AlignmentSynchronizers$forItemAlignment$lambda($target) {
    return function (item) {
      setSelfAlignment($target.style, item);
      return Unit_instance;
    };
  }
  function AlignmentSynchronizers$forItemAlignment$lambda_0($target) {
    return function () {
      clearSelfAlignment($target.style);
      return Unit_instance;
    };
  }
  function AlignmentSynchronizers$asCssValue$lambda(alignment) {
    var tmp;
    switch (alignment.x2_1) {
      case 0:
        tmp = CssAlignItem_STRETCH_getInstance();
        break;
      case 1:
        tmp = CssAlignItem_FLEX_START_getInstance();
        break;
      case 2:
        tmp = CssAlignItem_FLEX_END_getInstance();
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  function AlignmentSynchronizers$bindStyle$$inlined$writableProperty$1($clearProperty, $setProperty) {
    this.pbg_1 = $clearProperty;
    this.qbg_1 = $setProperty;
  }
  protoOf(AlignmentSynchronizers$bindStyle$$inlined$writableProperty$1).x9j = function (newValue) {
    if (newValue == null) {
      this.pbg_1();
    } else {
      this.qbg_1(newValue);
    }
    return Unit_instance;
  };
  protoOf(AlignmentSynchronizers$bindStyle$$inlined$writableProperty$1).d2x = function (newValue) {
    return this.x9j((newValue == null ? true : !(newValue == null)) ? newValue : THROW_CCE());
  };
  function AlignmentSynchronizers() {
  }
  protoOf(AlignmentSynchronizers).rbg = function (source, target) {
    var tmp = source.g94();
    var tmp_0 = AlignmentSynchronizers$forCrossAlignment$lambda(target);
    return forAlignment(this, tmp, tmp_0, AlignmentSynchronizers$forCrossAlignment$lambda_0(target));
  };
  protoOf(AlignmentSynchronizers).sbg = function (source, target) {
    var tmp = get_itemAlignment(source);
    var tmp_0 = AlignmentSynchronizers$forItemAlignment$lambda(target);
    return forAlignment(this, tmp, tmp_0, AlignmentSynchronizers$forItemAlignment$lambda_0(target));
  };
  var AlignmentSynchronizers_instance;
  function AlignmentSynchronizers_getInstance() {
    return AlignmentSynchronizers_instance;
  }
  function _get_targetList__52bhr0($this) {
    var tmp;
    if ($this.hbh_1) {
      tmp = $this.ibh_1;
    } else {
      tmp = $this.ebh_1;
    }
    return tmp;
  }
  function _get_underlines__ft6cho($this) {
    // Inline function 'kotlin.collections.buildList' call
    // Inline function 'kotlin.collections.buildListInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = ArrayList_init_$Create$();
    this_0.j(to($this.d9b(), Companion_getInstance_222().lbh_1.qbf_1));
    this_0.j(to($this.e9b(), Companion_getInstance_222().lbh_1.rbf_1));
    this_0.j(to($this.e86_1.k91(get_LINK()) && $this.e86_1.k91(get_HOVERED()), Companion_getInstance_222().lbh_1.sbf_1));
    return this_0.i3();
  }
  function schedulePropertyRefresh($this) {
    return $this.cbh_1.sbh($this);
  }
  function applyStyle_0($this) {
    $this.tbh(Companion_getInstance_222().lbh_1.gbf_1, $this.f9b());
    $this.tbh(Companion_getInstance_222().lbh_1.hbf_1, $this.x9a());
    $this.tbh(Companion_getInstance_222().lbh_1.ibf_1, $this.e86_1.k91(get_PAIR_HIGHLIGHTED()));
    $this.tbh(Companion_getInstance_222().lbh_1.ubf_1, $this.e86_1.k91(get_LINK()));
    var backgroundColor = null;
    if ($this.q90() && $this.b9b()) {
      backgroundColor = Companion_getInstance_222().lbh_1.tbf_1;
    } else if (!($this.c9b() == null)) {
      backgroundColor = ensureNotNull($this.c9b()).cb0();
    }
    setBackgroundColor_0($this, backgroundColor);
    setUnderline($this);
    updateBorder($this);
    $this.tbh(Companion_getInstance_222().lbh_1.fbf_1, !$this.e86_1.k91(get_VISIBLE()));
    $this.tbh(Companion_getInstance_222().lbh_1.kbf_1, $this.e86_1.k91(get_HAS_SHADOW()));
    $this.tbh(Companion_getInstance_222().lbh_1.abg_1, $this.e86_1.k91(Companion_getInstance_150().k94_1));
    $this.tbh(Companion_getInstance_222().lbh_1.bbg_1, $this.e86_1.k91(Companion_getInstance_150().l94_1));
  }
  function updateBorder($this) {
    var style = $this.f86_1.style;
    var border = get_border($this.e86_1).uv();
    if (border == null) {
      clearBorderTop(style);
      clearBorderBottom(style);
      clearBorderLeft(style);
      clearBorderRight(style);
      clearOutline(style);
    } else {
      switch (border.z8t_1.x2_1) {
        case 0:
          setBorderTop(style, Companion_instance_221.ubh(border.a8u_1));
          setBorderBottom(style, Companion_instance_221.ubh(border.b8u_1));
          style.borderLeft = Companion_instance_221.ubh(border.c8u_1);
          setBorderRight(style, Companion_instance_221.ubh(border.d8u_1));
          break;
        case 1:
          setOutline(style, Companion_instance_221.ubh(border.a8u_1));
          break;
        default:
          noWhenBranchMatchedException();
          break;
      }
    }
  }
  function setBackgroundColor_0($this, backgroundColor) {
    var style = $this.f86_1.style;
    if (backgroundColor == null) {
      clearBackgroundColor(style);
    } else {
      setBackgroundColor(style, backgroundColor);
    }
  }
  function setUnderline($this) {
    var underlined = false;
    var _iterator__ex2g4s = _get_underlines__ft6cho($this).m();
    while (_iterator__ex2g4s.n()) {
      var _destruct__k2r9zo = _iterator__ex2g4s.o();
      var first = _destruct__k2r9zo.fg();
      var second = _destruct__k2r9zo.gg();
      if (!underlined && first) {
        addClassName($this.f86_1, second);
        underlined = true;
      } else {
        removeClassName($this.f86_1, second);
      }
    }
  }
  function Companion_221() {
  }
  protoOf(Companion_221).ubh = function (side) {
    var width = side.f8u_1.toString();
    var color = side.e8u_1.cb0();
    return width + 'px ' + color + ' solid';
  };
  var Companion_instance_221;
  function Companion_getInstance_221() {
    return Companion_instance_221;
  }
  function BaseCellToDomMapper$createPopupManager$1(this$0) {
    this.abi_1 = this$0;
    DomPopupManager.call(this, this$0.cbh_1);
  }
  protoOf(BaseCellToDomMapper$createPopupManager$1).ca3 = function () {
    return this.abi_1.q89();
  };
  function BaseCellToDomMapper(source, context, target) {
    BaseCellMapper.call(this, source, target);
    this.cbh_1 = context;
    this.dbh_1 = null;
    this.ebh_1 = null;
    this.fbh_1 = null;
    this.gbh_1 = false;
    this.hbh_1 = false;
    this.ibh_1 = null;
    this.jbh_1 = null;
  }
  protoOf(BaseCellToDomMapper).jbi = function (placeholder) {
    if (this.hbh_1 === placeholder) {
      return Unit_instance;
    }
    this.hbh_1 = placeholder;
    var style = this.f86_1.style;
    if (this.hbh_1) {
      var bounds = Scrolling_instance.lbi(this.f86_1);
      if (this.kbi()) {
        this.ibh_1 = ArrayList_init_$Create$_1(ensureNotNull(this.ebh_1));
        ensureNotNull(this.ebh_1).k2();
      }
      setWidth(style, bounds.c8c_1.d8c_1);
      setHeight(style, bounds.c8c_1.e8c_1);
    } else {
      if (this.kbi()) {
        ensureNotNull(this.ebh_1).q(ensureNotNull(this.ibh_1));
        this.ibh_1 = null;
      }
      clearWidth(style);
      clearHeight(style);
    }
  };
  protoOf(BaseCellToDomMapper).kbi = function () {
    return true;
  };
  protoOf(BaseCellToDomMapper).mbi = function () {
    return true;
  };
  protoOf(BaseCellToDomMapper).o89 = function (ctx) {
    protoOf(BaseCellMapper).o89.call(this, ctx);
    this.cbh_1.m9x(this);
    this.fbh_1 = this.nbi();
    ensureNotNull(this.fbh_1).ga3(this.e86_1);
    this.gbh_1 = Composites_instance.r35(this.e86_1);
    this.e86_1.i90(Companion_getInstance_222().kbh_1, this.f86_1);
    addClassName(this.f86_1, Companion_getInstance_222().lbh_1.abf_1);
    if (this.kbi()) {
      this.dbh_1 = this.a87();
      this.ebh_1 = DomUtil_instance.q8d(this.f86_1);
      this.h9b();
    }
    if (this.e86_1.c93(Hints_getInstance().x93_1)) {
      this.jbh_1 = this.cbh_1.obi(this);
    }
    schedulePropertyRefresh(this);
    this.pbi();
  };
  protoOf(BaseCellToDomMapper).c87 = function () {
    this.e86_1.n92(Companion_getInstance_222().kbh_1).d2x(null);
    removeClassName(this.f86_1, Companion_getInstance_222().lbh_1.abf_1);
    if (this.gbh_1) {
      removeFromParent(this.f86_1);
    }
    ensureNotNull(this.fbh_1).zr();
    this.cbh_1.n9x(this);
    if (!(this.jbh_1 == null)) {
      ensureNotNull(this.jbh_1).zr();
    }
    protoOf(BaseCellMapper).c87.call(this);
  };
  protoOf(BaseCellToDomMapper).a88 = function (conf) {
    protoOf(BaseCellMapper).a88.call(this, conf);
    conf.h5v(AlignmentSynchronizers_instance.sbg(this.e86_1, this.f86_1));
  };
  protoOf(BaseCellToDomMapper).qbi = function (child) {
    return this.cbh_1.rbi(child);
  };
  protoOf(BaseCellToDomMapper).i9b = function (index, child) {
    if (!this.kbi())
      return Unit_instance;
    var mapper = this.qbi(child);
    ensureNotNull(_get_targetList__52bhr0(this)).m2(index, mapper.f86_1);
    ensureNotNull(this.dbh_1).m2(index, mapper);
    this.pbi();
  };
  protoOf(BaseCellToDomMapper).sbi = function (index) {
    if (!this.kbi())
      return Unit_instance;
    ensureNotNull(this.dbh_1).n2(index);
    ensureNotNull(_get_targetList__52bhr0(this)).n2(index);
    this.pbi();
  };
  protoOf(BaseCellToDomMapper).ha3 = function (event) {
    return ensureNotNull(this.fbh_1).n2s(event);
  };
  protoOf(BaseCellToDomMapper).n2s = function (event) {
    return this.ha3(event instanceof PropertyChangeEvent ? event : THROW_CCE());
  };
  protoOf(BaseCellToDomMapper).tbi = function (prop, change) {
    if (this.j86_1 == null)
      return Unit_instance;
    var tmp = this.j86_1;
    ensureNotNull((tmp instanceof BaseCellToDomMapper ? tmp : THROW_CCE()).fbh_1).ia3(this.e86_1, prop, change);
  };
  protoOf(BaseCellToDomMapper).ubi = function () {
    this.pbi();
    applyStyle_0(this);
  };
  protoOf(BaseCellToDomMapper).pbi = function () {
    return this.cbh_1.vbi(this);
  };
  protoOf(BaseCellToDomMapper).wbi = function () {
    if (this.hbh_1) {
      this.jbi(false);
      this.jbi(true);
    }
  };
  protoOf(BaseCellToDomMapper).tbh = function (cssStyle, apply) {
    var tmp;
    if (apply) {
      addClassName(this.f86_1, cssStyle);
      tmp = Unit_instance;
    } else {
      removeClassName(this.f86_1, cssStyle);
      tmp = Unit_instance;
    }
    return tmp;
  };
  protoOf(BaseCellToDomMapper).nbi = function () {
    return new BaseCellToDomMapper$createPopupManager$1(this);
  };
  function getBaseBounds($this, cell) {
    var mapper = getMapper($this.xbi_1, cell);
    var tmp;
    if (mapper == null) {
      var tmp_0;
      if (cell instanceof NewLineCell) {
        tmp_0 = null;
      } else {
        if (cell instanceof IndentCell) {
          var tmp_1 = getMapper($this.xbi_1, cell.d9w());
          var indentMapper = tmp_1 instanceof IndentRootCellMapper ? tmp_1 : THROW_CCE();
          tmp_0 = indentMapper.k8v(cell);
        } else {
          throw IllegalStateException_init_$Create$_0("Can't find a mapper for " + toString_1(cell));
        }
      }
      tmp = tmp_0;
    } else {
      revealParents($this, cell);
      var target = getElement($this.xbi_1, cell);
      var tmp_2;
      if (cell instanceof ScrollCell) {
        var tmp_3 = DomUtil_getInstance_0();
        tmp_2 = tmp_3.dbj(target instanceof HTMLElement ? target : THROW_CCE());
      } else {
        tmp_2 = DomUtil_getInstance_0().cbj(ensureNotNull(target));
      }
      tmp = tmp_2;
    }
    return tmp;
  }
  function revealParents($this, cell) {
    var mapper = ensureNotNull(getMapper($this.xbi_1, cell));
    $l$loop: while (true) {
      mapper.jbi(false);
      var mapperParent = mapper.j86_1;
      if (mapperParent instanceof BaseCellToDomMapper) {
        mapper = mapperParent;
      } else {
        break $l$loop;
      }
    }
  }
  function CellContainerToDomMapper$createCellContainerPeer$o$scrollToAsync$lambda($rectSupplier, this$0, $cell, $async) {
    return function () {
      var tmp;
      try {
        Scrolling_instance.ybj($rectSupplier(), ensureNotNull(getElement(this$0, $cell)));
        $async.w37(Unit_instance);
        tmp = Unit_instance;
      } catch ($p) {
        var tmp_0;
        if ($p instanceof RuntimeException) {
          var e = $p;
          $async.x37(e);
          tmp_0 = Unit_instance;
        } else {
          throw $p;
        }
        tmp = tmp_0;
      }
      return Unit_instance;
    };
  }
  function CellContainerToDomMapper$registerListeners$o$onEvent$lambda(this$0, $newValue) {
    return function () {
      var rootOrigin = get_origin(this$0.e86_1.t42());
      var cellOrigin = get_origin($newValue);
      var padding = DomUtil_getInstance_0().zbj(this$0.f86_1);
      var cellRelativeOrigin = cellOrigin.j8c(rootOrigin).i8c(padding);
      _get_cellToDomContext__dsuw81(this$0).rbh_1.ebk(cellRelativeOrigin.d8c_1, cellRelativeOrigin.e8c_1);
      return Unit_instance;
    };
  }
  function _get_cellToDomContext__dsuw81($this) {
    var tmp = $this.ubk_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('cellToDomContext');
    }
  }
  function _get_rootMapper__je6z14($this) {
    var tmp = $this.vbk_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('rootMapper');
    }
  }
  function refreshHideable($this) {
    $this.nbk_1.cbl();
  }
  function createRootMapper($this, source) {
    return CellMappers_instance.dbl(source, _get_cellToDomContext__dsuw81($this), $this.mbk_1);
  }
  function findCellFor($this, element) {
    var result = _get_cellToDomContext__dsuw81($this).o9x(element);
    if (!(result == null))
      return result.e86_1;
    var tmp0_elvis_lhs = element.parentElement;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var parent = tmp;
    return findCellFor($this, parent);
  }
  function getMapper($this, cell) {
    var descendantMapper = _get_rootMapper__je6z14($this).g89(cell);
    return (descendantMapper == null ? true : descendantMapper instanceof BaseCellToDomMapper) ? descendantMapper : THROW_CCE();
  }
  function getElement($this, cell) {
    var $this_0 = $this;
    var cell_0 = cell;
    $l$1: do {
      $l$0: do {
        if (cell_0 == null)
          return null;
        var mapper = getMapper($this_0, cell_0);
        var tmp;
        if (!(mapper == null)) {
          tmp = mapper.f86_1;
        } else {
          var parentCell = cell_0.bp();
          var tmp_0;
          if (parentCell == null) {
            tmp_0 = null;
          } else {
            $this_0 = $this_0;
            cell_0 = parentCell;
            continue $l$0;
          }
          tmp = tmp_0;
        }
        return tmp;
      }
       while (false);
    }
     while (true);
  }
  function createCellContainerPeer($this) {
    return new CellContainerToDomMapper$createCellContainerPeer$1($this);
  }
  function registerListeners($this) {
    var reg = new CompositeDisposable([]);
    var mouseTranslator = new CellContainerToDomMapper$registerListeners$mouseTranslator$1($this);
    reg.l2l([mouseTranslator.z8n()]);
    reg.l2l([_get_cellToDomContext__dsuw81($this).rbh_1.ebl($this.e86_1)]);
    var tmp = $this.e86_1.z92();
    reg.l2l([tmp.y2r(new CellContainerToDomMapper$registerListeners$1($this))]);
    return reg;
  }
  function isDomCellEvent($this, event) {
    var target = $this.e86_1.u93($this.e86_1.t42(), event.z8l());
    return target instanceof DomCell;
  }
  function isContainerEvent($this, event) {
    var root = $this.e86_1.t42();
    if (get_bounds(root).l8c(event.z8l())) {
      return true;
    }
    var target = $this.e86_1.u93(root, event.z8l());
    return !(target == null) && equals(target.s8x(), $this.e86_1);
  }
  function Companion_222() {
    Companion_instance_222 = this;
    this.kbh_1 = CellPropertySpec_init_$Create$('element', null);
    this.lbh_1 = Companion_getInstance_219().n26();
  }
  var Companion_instance_222;
  function Companion_getInstance_222() {
    if (Companion_instance_222 == null)
      new Companion_222();
    return Companion_instance_222;
  }
  function DoubleVector$_get_x_$ref_caz6ew(p0) {
    return function () {
      return p0.q8b_1;
    };
  }
  function CellContainerToDomMapper$getElement$ref(p0) {
    var l = function (_this__u8e3s4) {
      var tmp0 = p0;
      return getElement(tmp0, _this__u8e3s4);
    };
    l.callableName = 'getElement';
    return l;
  }
  function Element$_get_scrollWidth_$ref_9fbf35(p0) {
    return function () {
      return p0.scrollWidth;
    };
  }
  function CellContainerToDomMapper$onAttach$lambda(this$0, $window) {
    return function (it) {
      this$0.rbk_1 = $window.scrollX;
      this$0.sbk_1 = $window.scrollY;
      return true;
    };
  }
  function CellContainerToDomMapper$onAttach$lambda_0(this$0) {
    return function () {
      refreshHideable(this$0);
      return this$0.f89();
    };
  }
  function CellContainerToDomMapper$registerSynchronizers$$inlined$writableProperty$1(this$0) {
    this.fbl_1 = this$0;
  }
  protoOf(CellContainerToDomMapper$registerSynchronizers$$inlined$writableProperty$1).x9j = function (newValue) {
    if (newValue == null) {
      this.fbl_1.pbk_1.innerHTML = '';
    } else {
      this.fbl_1.pbk_1.appendChild(newValue);
    }
    return Unit_instance;
  };
  protoOf(CellContainerToDomMapper$registerSynchronizers$$inlined$writableProperty$1).d2x = function (newValue) {
    return this.x9j((newValue == null ? true : !(newValue == null)) ? newValue : THROW_CCE());
  };
  function CellContainerToDomMapper$createRootMapper$ref(p0) {
    var l = function (_this__u8e3s4) {
      var tmp0 = p0;
      return createRootMapper(tmp0, _this__u8e3s4);
    };
    l.callableName = 'createRootMapper';
    return l;
  }
  function CellContainerToDomMapper$registerSynchronizers$2(this$0) {
    this.gbl_1 = this$0;
  }
  protoOf(CellContainerToDomMapper$registerSynchronizers$2).j93 = function (cell, prop, change) {
    if (prop === Companion_getInstance_222().kbh_1)
      return Unit_instance;
    var mapper = getMapper(this.gbl_1, cell);
    if (!(mapper == null)) {
      if (isPopupProp(prop)) {
        if (mapper.mbi()) {
          var propertyChangeEvent = change instanceof PropertyChangeEvent ? change : THROW_CCE();
          mapper.ha3(propertyChangeEvent);
        }
      } else {
        this.gbl_1.nbk_1.sbh(mapper);
        if (get_isPopup(cell) && mapper.mbi()) {
          mapper.tbi(prop, change);
        }
      }
    }
  };
  protoOf(CellContainerToDomMapper$registerSynchronizers$2).k93 = function (parent, change) {
    var tmp0_elvis_lhs = getMapper(this.gbl_1, parent);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var mapper = tmp;
    mapper.i9b(change.q2r_1, change.u2r());
  };
  protoOf(CellContainerToDomMapper$registerSynchronizers$2).l93 = function (parent, change) {
    var tmp0_elvis_lhs = getMapper(this.gbl_1, parent);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var mapper = tmp;
    mapper.sbi(change.q2r_1);
  };
  function CellContainerToDomMapper$createCellContainerPeer$1(this$0) {
    this.xbi_1 = this$0;
  }
  protoOf(CellContainerToDomMapper$createCellContainerPeer$1).o93 = function (tv, x) {
    var tmp = getMapper(this.xbi_1, tv);
    var tmp0_elvis_lhs = (tmp == null ? true : tmp instanceof TextCellMapper) ? tmp : THROW_CCE();
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      throw IllegalStateException_init_$Create$_0("Can't find a mapper for " + tv.toString());
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var textMapper = tmp_0;
    return textMapper.m97(x);
  };
  protoOf(CellContainerToDomMapper$createCellContainerPeer$1).p93 = function (tv, caret) {
    var tmp = getMapper(this.xbi_1, tv);
    var tmp0_elvis_lhs = (tmp == null ? true : tmp instanceof TextCellMapper) ? tmp : THROW_CCE();
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      throw IllegalStateException_init_$Create$_0("Can't find a mapper for " + tv.toString());
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var textMapper = tmp_0;
    return textMapper.z96(caret);
  };
  protoOf(CellContainerToDomMapper$createCellContainerPeer$1).q93 = function (cell) {
    var tmp0_elvis_lhs = getBaseBounds(this, cell);
    return tmp0_elvis_lhs == null ? Companion_getInstance_135().g8c_1 : tmp0_elvis_lhs;
  };
  protoOf(CellContainerToDomMapper$createCellContainerPeer$1).r93 = function (cell) {
    var target = getElement(this.xbi_1, cell);
    return new Vector(numberToInt(ensureNotNull(target).scrollLeft), numberToInt(target.scrollTop));
  };
  protoOf(CellContainerToDomMapper$createCellContainerPeer$1).s93 = function (cell, offset) {
    var target = ensureNotNull(getElement(this.xbi_1, cell));
    target.scrollLeft = offset.d8c_1;
    target.scrollTop = offset.e8c_1;
  };
  protoOf(CellContainerToDomMapper$createCellContainerPeer$1).b93 = function (rectSupplier, cell) {
    var async = new SimpleAsync();
    var tmp = DomImmediatePolyfill_getInstance();
    tmp.x8h(CellContainerToDomMapper$createCellContainerPeer$o$scrollToAsync$lambda(rectSupplier, this.xbi_1, cell, async));
    return async;
  };
  protoOf(CellContainerToDomMapper$createCellContainerPeer$1).u93 = function (root, loc) {
    var tmp0_elvis_lhs = DomApi_instance.k8f().elementFromPoint(loc.d8c_1 - this.xbi_1.rbk_1, loc.e8c_1 - this.xbi_1.sbk_1);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var element = tmp;
    var tmp1_elvis_lhs = findCellFor(this.xbi_1, element);
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      return null;
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    var result = tmp_0;
    var tmp_1;
    if (isDescendant(root, result)) {
      tmp_1 = result;
    } else {
      tmp_1 = null;
    }
    return tmp_1;
  };
  protoOf(CellContainerToDomMapper$createCellContainerPeer$1).v93 = function (cell) {
    var element = getElement(this.xbi_1, cell);
    var tmp0_elvis_lhs = DomUtil_getInstance_0().bbm(ensureNotNull(element));
    return tmp0_elvis_lhs == null ? Rectangle_init_$Create$(0, 0, 0, 0) : tmp0_elvis_lhs;
  };
  protoOf(CellContainerToDomMapper$createCellContainerPeer$1).m93 = function () {
    return JsEventDispatchThread_getInstance();
  };
  protoOf(CellContainerToDomMapper$createCellContainerPeer$1).n93 = function () {
    return JsSystemClipboard_instance;
  };
  function CellContainerToDomMapper$registerListeners$mouseTranslator$1(this$0) {
    this.ebm_1 = this$0;
    MouseTranslator.call(this, this$0.f86_1, this$0.e86_1);
  }
  protoOf(CellContainerToDomMapper$registerListeners$mouseTranslator$1).p8n = function (e) {
    return !isContainerEvent(this.ebm_1, e) || isDomCellEvent(this.ebm_1, e);
  };
  protoOf(CellContainerToDomMapper$registerListeners$mouseTranslator$1).x8n = function (e) {
    return isDomCellEvent(this.ebm_1, e);
  };
  protoOf(CellContainerToDomMapper$registerListeners$mouseTranslator$1).s8n = function () {
    var textInput = _get_cellToDomContext__dsuw81(this.ebm_1).rbh_1;
    if (!textInput.gbm().uv()) {
      textInput.fbm();
    }
  };
  function CellContainerToDomMapper$registerListeners$1(this$0) {
    this.ibm_1 = this$0;
    this.hbm_1 = Companion_getInstance_29().m2l_1;
  }
  protoOf(CellContainerToDomMapper$registerListeners$1).ha3 = function (event) {
    this.hbm_1.zr();
    var newValue = event.t2y_1;
    if (newValue == null) {
      this.hbm_1 = Companion_getInstance_29().m2l_1;
      return Unit_instance;
    }
    var tmp = this;
    var tmp_0 = DomUtil_getInstance_0();
    tmp.hbm_1 = tmp_0.jbm(CellContainerToDomMapper$registerListeners$o$onEvent$lambda(this.ibm_1, newValue));
  };
  protoOf(CellContainerToDomMapper$registerListeners$1).n2s = function (event) {
    return this.ha3(event instanceof PropertyChangeEvent ? event : THROW_CCE());
  };
  function CellContainerToDomMapper(source, target, config, extensionViewMapperFactories) {
    Companion_getInstance_222();
    config = config === VOID ? new CellToDomConfig() : config;
    extensionViewMapperFactories = extensionViewMapperFactories === VOID ? emptyList() : extensionViewMapperFactories;
    Mapper.call(this, source, target);
    this.mbk_1 = extensionViewMapperFactories;
    this.nbk_1 = new CellMapperRefresher(config.nbm_1, config.pbm());
    this.obk_1 = config.qbm();
    this.qbk_1 = config.rbm();
    this.rbk_1 = 0.0;
    this.sbk_1 = 0.0;
    this.tbk_1 = null;
    var tmp = Companion_getInstance_219();
    var tmp_0 = KProperty0;
    tmp.zbe(getPropertyCallableRef('x', 0, tmp_0, DoubleVector$_get_x_$ref_caz6ew(TextMetricsCalculator_getInstance().ube(Companion_getInstance_154().a8x_1, 'xx').vbe()), null));
    this.pbk_1 = DomApi_instance.m8f();
    addClassName(this.pbk_1, Companion_getInstance_222().lbh_1.obf_1);
    if (config.tbm()) {
      addClassName(this.pbk_1, config.sbm());
    }
  }
  protoOf(CellContainerToDomMapper).l89 = function (ctx) {
    protoOf(Mapper).l89.call(this, ctx);
    this.ubk_1 = new CellToDomContext(this.f86_1, this.nbk_1, this.qbk_1, this.mbk_1);
  };
  protoOf(CellContainerToDomMapper).o89 = function (ctx) {
    protoOf(Mapper).o89.call(this, ctx);
    var peer = createCellContainerPeer(this);
    this.e86_1.j9t(peer);
    var tmp = this.g89(this.e86_1.t42());
    var descendantMapper = tmp instanceof Mapper ? tmp : THROW_CCE();
    this.vbk_1 = descendantMapper;
    setTabIndex(this.f86_1, 0);
    addClassName(this.f86_1, Companion_getInstance_222().lbh_1.cbf_1);
    var tmp_0 = peer.m93();
    var tmp_1 = CellContainerToDomMapper$getElement$ref(this);
    var tmp_2 = KProperty0;
    this.obk_1.ubm(this.f86_1, tmp_0, tmp_1, getPropertyCallableRef('scrollWidth', 0, tmp_2, Element$_get_scrollWidth_$ref_9fbf35(this.pbk_1), null));
    this.f86_1.appendChild(this.pbk_1);
    var window_0 = DomApi_instance.l8f();
    this.rbk_1 = window_0.scrollX;
    this.sbk_1 = window_0.scrollY;
    var runner = CellContainerToDomMapper$onAttach$lambda(this, window_0);
    this.tbk_1 = on(window_0, Companion_getInstance_139().f8h_1, runner);
    var tmp_3 = Companion_getInstance_39().k3a_1;
    tmp_3.d3b(100, CellContainerToDomMapper$onAttach$lambda_0(this));
  };
  protoOf(CellContainerToDomMapper).c87 = function () {
    protoOf(Mapper).c87.call(this);
    this.e86_1.j9v();
    removeClassName(this.f86_1, Companion_getInstance_222().lbh_1.cbf_1);
    removeFromParent(this.pbk_1);
    this.obk_1.zr();
    ensureNotNull(this.tbk_1).zr();
    _get_cellToDomContext__dsuw81(this).zr();
  };
  protoOf(CellContainerToDomMapper).a88 = function (conf) {
    protoOf(Mapper).a88.call(this, conf);
    var tmp = Synchronizers_instance;
    var tmp_0 = this.e86_1.t42();
    // Inline function 'jetbrains.ocelot.base.observable.property.writableProperty' call
    var tmp_1 = new CellContainerToDomMapper$registerSynchronizers$$inlined$writableProperty$1(this);
    conf.h5v(tmp.d8b(tmp_0, tmp_1, CellContainerToDomMapper$createRootMapper$ref(this)));
    conf.h5v(this.e86_1.i9v(new CellContainerToDomMapper$registerSynchronizers$2(this)));
    if (!this.qbk_1) {
      conf.h5v(registerListeners(this));
    }
  };
  function _get_loadableRect__lsn5h5($this) {
    return scale($this, Scrolling_instance.vbm(), $this.wbk_1);
  }
  function requestRefresh($this) {
    if ($this.bbl_1)
      return Unit_instance;
    $this.bbl_1 = true;
    $this.xbk_1(CellMapperRefresher$requestRefresh$lambda($this));
  }
  function updateHideable($this) {
    var visible = _get_loadableRect__lsn5h5($this);
    var _iterator__ex2g4s = $this.abl_1.m();
    while (_iterator__ex2g4s.n()) {
      var m = _iterator__ex2g4s.o();
      var bounds = Scrolling_instance.lbi(m.f86_1);
      m.jbi(!visible.p8c(bounds));
    }
  }
  function scale($this, r, c) {
    var origin = r.b8c_1;
    var dimension = r.c8c_1;
    var g = (c - 1.0) / 2;
    return new Rectangle(origin.j8c(new Vector(numberToInt(dimension.d8c_1 * g), numberToInt(dimension.e8c_1 * g))), new Vector(numberToInt(dimension.d8c_1 * c), numberToInt(dimension.e8c_1 * c)));
  }
  function Companion_223() {
    this.wbm_1 = true;
  }
  var Companion_instance_223;
  function Companion_getInstance_223() {
    return Companion_instance_223;
  }
  function CellMapperRefresher$prepareFrame$lambda(it) {
    var tmp = DomApi_instance.l8f();
    return tmp.requestAnimationFrame(CellMapperRefresher$prepareFrame$lambda$lambda(it));
  }
  function CellMapperRefresher$prepareFrame$lambda$lambda($it) {
    return function (it) {
      $it();
      return Unit_instance;
    };
  }
  function CellMapperRefresher$prepareFrame$lambda_0(it) {
    it();
    return Unit_instance;
  }
  function CellMapperRefresher$requestRefresh$lambda(this$0) {
    return function () {
      var _iterator__ex2g4s = this$0.zbk_1.m();
      while (_iterator__ex2g4s.n()) {
        var m = _iterator__ex2g4s.o();
        m.ubi();
      }
      this$0.zbk_1.k2();
      var _iterator__ex2g4s_0 = this$0.ybk_1.m();
      while (_iterator__ex2g4s_0.n()) {
        var m_0 = _iterator__ex2g4s_0.o();
        m_0.wbi();
      }
      this$0.ybk_1.k2();
      this$0.bbl_1 = false;
      return Unit_instance;
    };
  }
  function CellMapperRefresher$registerHideable$$inlined$toDisposable$1(this$0, $mapper) {
    this.xbm_1 = this$0;
    this.ybm_1 = $mapper;
  }
  protoOf(CellMapperRefresher$registerHideable$$inlined$toDisposable$1).zr = function () {
    this.xbm_1.abl_1.h2(this.ybm_1);
    return Unit_instance;
  };
  function CellMapperRefresher(visibilityExpansion, requestAnimationFrame) {
    this.wbk_1 = visibilityExpansion;
    var tmp = this;
    var tmp_0;
    if (requestAnimationFrame) {
      tmp_0 = CellMapperRefresher$prepareFrame$lambda;
    } else {
      tmp_0 = CellMapperRefresher$prepareFrame$lambda_0;
    }
    tmp.xbk_1 = tmp_0;
    this.ybk_1 = HashSet_init_$Create$();
    this.zbk_1 = HashSet_init_$Create$();
    this.abl_1 = HashSet_init_$Create$();
    this.bbl_1 = false;
  }
  protoOf(CellMapperRefresher).obi = function (mapper) {
    if (false) {
      return Companion_getInstance_29().m2l_1;
    }
    this.abl_1.j(mapper);
    // Inline function 'jetbrains.ocelot.base.disposable.toDisposable' call
    return new CellMapperRefresher$registerHideable$$inlined$toDisposable$1(this, mapper);
  };
  protoOf(CellMapperRefresher).sbh = function (mapper) {
    this.zbk_1.j(mapper);
    requestRefresh(this);
  };
  protoOf(CellMapperRefresher).vbi = function (mapper) {
    var $this = this;
    var mapper_0 = mapper;
    $l$1: do {
      $l$0: do {
        requestRefresh($this);
        if (mapper_0.hbh_1) {
          $this.ybk_1.j(mapper_0);
        }
        var mapperParent = mapper_0.j86_1;
        if (mapperParent instanceof BaseCellToDomMapper) {
          $this = $this;
          mapper_0 = mapperParent;
          continue $l$0;
        }
        break $l$1;
      }
       while (false);
    }
     while (true);
  };
  protoOf(CellMapperRefresher).cbl = function () {
    updateHideable(this);
  };
  function IndentRootCellMapper$_init_$ref_ys71v8() {
    var l = function (p0, p1) {
      return new IndentRootCellMapper(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function CellMappers() {
  }
  protoOf(CellMappers).dbl = function (source, ctx, extensionViewMapperFactories) {
    var tmp;
    if (source instanceof TextCell) {
      tmp = new TextCellMapper(source, ctx);
    } else {
      if (source instanceof HorizontalCell) {
        tmp = new HorizontalCellMapper(source, ctx);
      } else {
        if (source instanceof VerticalCell) {
          tmp = new VerticalCellMapper(source, ctx);
        } else {
          if (source instanceof ScrollCell) {
            tmp = new ScrollCellMapper(source, ctx);
          } else {
            if (source instanceof ImageCell) {
              tmp = new ImageCellMapper(source, ctx);
            } else {
              if (source instanceof IndentCell) {
                var tmp_0 = CellMapperUtils_instance;
                tmp = tmp_0.p9x(source, ctx, IndentRootCellMapper$_init_$ref_ys71v8());
              } else {
                if (get_isRootCell(source)) {
                  tmp = new RootCellMapper(source, ctx);
                } else {
                  if (source instanceof DomCell) {
                    tmp = new DomCellMapper(source, ctx);
                  } else {
                    if (source instanceof ViewCell) {
                      tmp = new ViewCellMapper(source, ctx, extensionViewMapperFactories);
                    } else {
                      if (source instanceof TextPlaceholderCell) {
                        tmp = new TextPlaceholderCellMapper(source, ctx);
                      } else {
                        tmp = new DefaultCellMapper(source, ctx);
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    return tmp;
  };
  var CellMappers_instance;
  function CellMappers_getInstance() {
    return CellMappers_instance;
  }
  function CellToDomConfig() {
    this.kbm_1 = false;
    this.lbm_1 = true;
    this.mbm_1 = Companion_getInstance_227().zbm_1;
    this.nbm_1 = 1.4;
    this.obm_1 = null;
  }
  protoOf(CellToDomConfig).rbm = function () {
    return this.kbm_1;
  };
  protoOf(CellToDomConfig).pbm = function () {
    return this.lbm_1;
  };
  protoOf(CellToDomConfig).qbm = function () {
    return this.mbm_1;
  };
  protoOf(CellToDomConfig).tbm = function () {
    return !(this.obm_1 == null);
  };
  protoOf(CellToDomConfig).sbm = function () {
    var tmp0_elvis_lhs = this.obm_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalStateException_init_$Create$_0('Content class is not set');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  protoOf(CellToDomConfig).abn = function (eventDisabled) {
    this.kbm_1 = eventDisabled;
  };
  protoOf(CellToDomConfig).bbn = function (requestAnimationFrame) {
    this.lbm_1 = requestAnimationFrame;
  };
  protoOf(CellToDomConfig).cbn = function (lineHighlight) {
    this.mbm_1 = lineHighlight;
  };
  function CellToDomContext(rootElement, cellMapperRefresher, isEventsDisabled, extensionViewMapperFactories) {
    CellMapperContext.call(this, rootElement);
    this.obh_1 = cellMapperRefresher;
    this.pbh_1 = isEventsDisabled;
    this.qbh_1 = extensionViewMapperFactories;
    this.rbh_1 = new DomTextInput(rootElement);
  }
  protoOf(CellToDomContext).rbi = function (cell) {
    return CellMappers_instance.dbl(cell, this, this.qbh_1);
  };
  protoOf(CellToDomContext).sbh = function (mapper) {
    this.obh_1.sbh(mapper);
  };
  protoOf(CellToDomContext).vbi = function (mapper) {
    this.obh_1.vbi(mapper);
  };
  protoOf(CellToDomContext).obi = function (mapper) {
    return this.obh_1.obi(mapper);
  };
  protoOf(CellToDomContext).zr = function () {
    this.rbh_1.zr();
  };
  function DefaultCellMapper(source, ctx) {
    BaseCellToDomMapper.call(this, source, ctx, DomApi_instance.m8f());
    setColor(this.f86_1.style, 'red');
    this.f86_1.innerText = "Can't create a mapper for '" + getKClassFromExpression(source).ra() + "'";
  }
  function _get_edt__e67mgs_0($this) {
    var tmp = $this.gbn_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('edt');
    }
  }
  function _get_lineElement__ck1iy1($this) {
    var activeCell = $this.dbn_1.uv();
    var tmp;
    var tmp_0;
    var tmp_1;
    if (activeCell == null) {
      tmp_1 = true;
    } else {
      tmp_1 = activeCell instanceof DomCell;
    }
    if (tmp_1) {
      tmp_0 = true;
    } else {
      tmp_0 = !Cells_getInstance().daa(activeCell);
    }
    if (tmp_0) {
      tmp = null;
    } else {
      tmp = ensureNotNull($this.fbn_1)(activeCell);
    }
    return tmp;
  }
  function invalidate($this) {
    $this.ibn_1 = false;
    var tmp = _get_edt__e67mgs_0($this);
    var tmp_0 = DefaultLineHighlight$invalidate$lambda($this);
    tmp.v39(0, new sam$jetbrains_ocelot_base_edt_EdtTask$0_12(tmp_0));
  }
  function refresh_0($this) {
    if ($this.ibn_1)
      return Unit_instance;
    shutdownContentHandler($this);
    cancelDelayedUpdate($this);
    var lineElement = _get_lineElement__ck1iy1($this);
    if (lineElement == null) {
      hideHighlight($this);
      $this.mbn_1 = null;
    } else {
      var newLayout = calculateLayout($this, lineElement);
      if (!newLayout.equals($this.mbn_1)) {
        showHighlight($this, newLayout);
        $this.mbn_1 = newLayout;
      }
      setupContentHandler($this);
      scheduleDelayedUpdate($this);
    }
    $this.ibn_1 = true;
  }
  function hideHighlight($this) {
    setVisibility($this.ebn_1.style, CssVisibility_HIDDEN_getInstance());
  }
  function showHighlight($this, layout) {
    var style = $this.ebn_1.style;
    setVisibility(style, CssVisibility_VISIBLE_getInstance());
    setTop(style, layout.nbn_1);
    setHeight(style, layout.obn_1);
    setWidth(style, layout.pbn_1);
  }
  function calculateLayout($this, lineElement) {
    var owner = $this.ebn_1.parentElement;
    var top = getAbsoluteTop(lineElement) - getAbsoluteTop(ensureNotNull(owner)) + owner.scrollTop;
    var height = lineElement.clientHeight;
    var width = ensureNotNull($this.jbn_1)();
    return new HighlightLayout(numberToInt(top), height, width);
  }
  function scheduleDelayedUpdate($this) {
    var tmp = $this;
    var tmp_0 = _get_edt__e67mgs_0($this);
    var tmp_1 = DefaultLineHighlight$scheduleDelayedUpdate$lambda($this);
    tmp.lbn_1 = tmp_0.v39(200, new sam$jetbrains_ocelot_base_edt_EdtTask$0_13(tmp_1));
  }
  function cancelDelayedUpdate($this) {
    $this.lbn_1.zr();
    $this.lbn_1 = Companion_getInstance_29().m2l_1;
  }
  function setupContentHandler($this) {
    var activeCell = $this.dbn_1.uv();
    if (activeCell instanceof TextCell) {
      var tmp = $this;
      var tmp_0 = activeCell.o8w();
      tmp.kbn_1 = tmp_0.z2r(DefaultLineHighlight$setupContentHandler$lambda($this));
    }
  }
  function shutdownContentHandler($this) {
    $this.kbn_1.zr();
    $this.kbn_1 = Companion_getInstance_29().m2l_1;
  }
  function HighlightLayout(top, height, width) {
    this.nbn_1 = top;
    this.obn_1 = height;
    this.pbn_1 = width;
  }
  protoOf(HighlightLayout).toString = function () {
    return 'HighlightLayout(top=' + this.nbn_1 + ', height=' + this.obn_1 + ', width=' + this.pbn_1 + ')';
  };
  protoOf(HighlightLayout).hashCode = function () {
    var result = this.nbn_1;
    result = imul(result, 31) + this.obn_1 | 0;
    result = imul(result, 31) + this.pbn_1 | 0;
    return result;
  };
  protoOf(HighlightLayout).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof HighlightLayout))
      return false;
    if (!(this.nbn_1 === other.nbn_1))
      return false;
    if (!(this.obn_1 === other.obn_1))
      return false;
    if (!(this.pbn_1 === other.pbn_1))
      return false;
    return true;
  };
  function Companion_224() {
    this.qbn_1 = 200;
  }
  var Companion_instance_224;
  function Companion_getInstance_224() {
    return Companion_instance_224;
  }
  function sam$jetbrains_ocelot_base_edt_EdtTask$0_12(function_0) {
    this.rbn_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_12).au = function () {
    return this.rbn_1();
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_12).f3 = function () {
    return this.rbn_1;
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_12).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, EdtTask) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_12).hashCode = function () {
    return hashCode(this.f3());
  };
  function sam$jetbrains_ocelot_base_edt_EdtTask$0_13(function_0) {
    this.sbn_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_13).au = function () {
    return this.sbn_1();
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_13).f3 = function () {
    return this.sbn_1;
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_13).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, EdtTask) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_13).hashCode = function () {
    return hashCode(this.f3());
  };
  function sam$jetbrains_ocelot_base_edt_EdtTask$0_14(function_0) {
    this.tbn_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_14).au = function () {
    return this.tbn_1();
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_14).f3 = function () {
    return this.tbn_1;
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_14).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, EdtTask) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_14).hashCode = function () {
    return hashCode(this.f3());
  };
  function DefaultLineHighlight$attach$lambda(this$0) {
    return function (it) {
      invalidate(this$0);
      return Unit_instance;
    };
  }
  function DefaultLineHighlight$invalidate$lambda(this$0) {
    return function () {
      refresh_0(this$0);
      return Unit_instance;
    };
  }
  function DefaultLineHighlight$scheduleDelayedUpdate$lambda(this$0) {
    return function () {
      this$0.ibn_1 = false;
      refresh_0(this$0);
      return Unit_instance;
    };
  }
  function DefaultLineHighlight$setupContentHandler$lambda$lambda(this$0) {
    return function () {
      var style = this$0.ebn_1.style;
      setWidth(style, ensureNotNull(this$0.jbn_1)());
      return Unit_instance;
    };
  }
  function DefaultLineHighlight$setupContentHandler$lambda(this$0) {
    return function (it) {
      var tmp = _get_edt__e67mgs_0(this$0);
      var tmp_0 = DefaultLineHighlight$setupContentHandler$lambda$lambda(this$0);
      tmp.u39(new sam$jetbrains_ocelot_base_edt_EdtTask$0_14(tmp_0));
      return Unit_instance;
    };
  }
  function DefaultLineHighlight(activeCell) {
    this.dbn_1 = activeCell;
    this.fbn_1 = null;
    this.hbn_1 = Companion_getInstance_29().m2l_1;
    this.ibn_1 = false;
    this.jbn_1 = null;
    this.kbn_1 = Companion_getInstance_29().m2l_1;
    this.lbn_1 = Companion_getInstance_29().m2l_1;
    this.mbn_1 = null;
    this.ebn_1 = DomApi_instance.m8f();
    addClassName(this.ebn_1, Companion_getInstance_222().lbh_1.nbf_1);
  }
  protoOf(DefaultLineHighlight).ubm = function (parent, edt, elementSupplier, widthSupplier) {
    parent.appendChild(this.ebn_1);
    this.fbn_1 = elementSupplier;
    this.gbn_1 = edt;
    this.jbn_1 = widthSupplier;
    var tmp = this;
    tmp.hbn_1 = this.dbn_1.z2r(DefaultLineHighlight$attach$lambda(this));
    invalidate(this);
  };
  protoOf(DefaultLineHighlight).zr = function () {
    this.hbn_1.zr();
    shutdownContentHandler(this);
    cancelDelayedUpdate(this);
    removeFromParent(this.ebn_1);
  };
  function setSingletonChild($this, child) {
    removeAllChildren($this.f86_1);
    if (child == null) {
      return Unit_instance;
    }
    $this.f86_1.appendChild(child);
  }
  function attachListeners($this, node) {
    if (node == null) {
      return Unit_instance;
    }
    if ($this.e86_1.c93(Companion_getInstance_220().dbg_1)) {
      var handler = DomCellMapper$attachListeners$lambda;
      $this.lbo_1 = on(node, Companion_getInstance_139().q8g_1, handler);
    }
  }
  function detachListeners($this, node) {
    if (node == null) {
      return Unit_instance;
    }
    ensureNotNull($this.lbo_1).zr();
  }
  function DomCellMapper$registerSynchronizers$$inlined$writableProperty$1(this$0) {
    this.mbo_1 = this$0;
  }
  protoOf(DomCellMapper$registerSynchronizers$$inlined$writableProperty$1).x9j = function (newValue) {
    var this_0 = this.mbo_1;
    setSingletonChild(this_0, newValue);
    return Unit_instance;
  };
  protoOf(DomCellMapper$registerSynchronizers$$inlined$writableProperty$1).d2x = function (newValue) {
    return this.x9j((newValue == null ? true : !(newValue == null)) ? newValue : THROW_CCE());
  };
  function DomCellMapper$registerSynchronizers$lambda(this$0) {
    return function (event) {
      detachListeners(this$0, event.s2y_1);
      attachListeners(this$0, event.t2y_1);
      return Unit_instance;
    };
  }
  function DomCellMapper$registerSynchronizers$3(this$0) {
    this.nbo_1 = this$0;
    CellTrait.call(this);
  }
  protoOf(DomCellMapper$registerSynchronizers$3).p91 = function (cell, event) {
    var node = this.nbo_1.e86_1.obg().uv();
    if (!(node == null) && node.nodeType === 1) {
      var element = cast_0(node);
      element.focus();
    }
    protoOf(CellTrait).p91.call(this, cell, event);
  };
  protoOf(DomCellMapper$registerSynchronizers$3).q91 = function (cell, event) {
    this.nbo_1.cbh_1.rbh_1.fbm();
    protoOf(CellTrait).q91.call(this, cell, event);
  };
  function DomCellMapper$attachListeners$lambda(_unused_var__etf5q3) {
    return false;
  }
  function DomCellMapper(source, ctx) {
    BaseCellToDomMapper.call(this, source, ctx, DomApi_instance.m8f());
    this.lbo_1 = null;
    addClassName(this.f86_1, Companion_getInstance_222().lbh_1.jbf_1);
  }
  protoOf(DomCellMapper).kbi = function () {
    return false;
  };
  protoOf(DomCellMapper).ubi = function () {
    protoOf(BaseCellToDomMapper).ubi.call(this);
    this.tbh(Companion_getInstance_222().lbh_1.mbf_1, this.e86_1.c93(Companion_getInstance_220().cbg_1));
    if (this.e86_1.c93(Companion_getInstance_220().dbg_1)) {
      setTabIndex(this.f86_1, 0);
    } else {
      clearTabIndex(this.f86_1);
    }
  };
  protoOf(DomCellMapper).a88 = function (conf) {
    protoOf(BaseCellToDomMapper).a88.call(this, conf);
    var tmp = this.e86_1.obg();
    // Inline function 'jetbrains.ocelot.base.observable.property.writableProperty' call
    var tmp$ret$0 = new DomCellMapper$registerSynchronizers$$inlined$writableProperty$1(this);
    conf.h5v(syncOneWay(tmp, tmp$ret$0));
    attachListeners(this, this.e86_1.obg().uv());
    var tmp_0 = this.e86_1.obg();
    conf.h5v(tmp_0.z2r(DomCellMapper$registerSynchronizers$lambda(this)));
    conf.h5v(this.e86_1.w92(new DomCellMapper$registerSynchronizers$3(this)));
  };
  protoOf(DomCellMapper).c87 = function () {
    protoOf(BaseCellToDomMapper).c87.call(this);
    setSingletonChild(this, null);
  };
  function isVisible_3($this, parent) {
    var visibleRootPart = DomUtil_getInstance_0().bbm($this.qbo_1.dbi_1.k9x_1);
    var tmp1_elvis_lhs = visibleRootPart == null ? null : visibleRootPart.p8c(get_bounds(parent));
    return tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
  }
  function DomPopupManager$UpdatePositionTask$run$ref(p0) {
    var l = function () {
      p0.au();
      return Unit_instance;
    };
    l.callableName = 'run';
    return l;
  }
  function _get_positionUpdater__wwdan($this) {
    var tmp0 = $this.ebi_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('positionUpdater', 1, tmp, DomPopupManager$_get_positionUpdater_$ref_tympb5(), null);
    return tmp0.a1();
  }
  function UpdatePositionTask($outer, popupMapper) {
    this.qbo_1 = $outer;
    this.obo_1 = popupMapper;
    this.pbo_1 = 0;
  }
  protoOf(UpdatePositionTask).au = function () {
    var source = this.obo_1.e86_1;
    if (!source.f89()) {
      return Unit_instance;
    }
    var parent = source.bp();
    if (!isVisible_3(this, ensureNotNull(parent))) {
      setDisplay(this.obo_1.f86_1.style, CssDisplay_NONE_getInstance());
      return Unit_instance;
    }
    clearDisplay(this.obo_1.f86_1.style);
    var changed = this.qbo_1.hbi(this.obo_1).ba3(source, this.obo_1.f86_1);
    this.pbo_1 = this.pbo_1 + 1 | 0;
    if (changed && this.pbo_1 < 5) {
      var tmp = DomImmediatePolyfill_getInstance();
      tmp.x8h(DomPopupManager$UpdatePositionTask$run$ref(this));
    }
  };
  function Companion_225() {
    this.rbo_1 = 5;
    this.sbo_1 = 50;
    this.tbo_1 = 100;
    this.ubo_1 = 5;
  }
  var Companion_instance_225;
  function Companion_getInstance_225() {
    return Companion_instance_225;
  }
  function sam$jetbrains_ocelot_base_edt_EdtTask$0_15(function_0) {
    this.vbo_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_15).au = function () {
    return this.vbo_1();
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_15).f3 = function () {
    return this.vbo_1;
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_15).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, EdtTask) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_15).hashCode = function () {
    return hashCode(this.f3());
  };
  function DomPopupManager$positionUpdater$delegate$lambda(this$0) {
    return function () {
      return new PopupPositioner(this$0.dbi_1, 5);
    };
  }
  function DomPopupManager$_get_positionUpdater_$ref_tympb5() {
    return function (p0) {
      return _get_positionUpdater__wwdan(p0);
    };
  }
  function DomPopupManager$attachPopup$lambda$lambda(this$0, $mapper) {
    return function () {
      this$0.ja3($mapper);
      return Unit_instance;
    };
  }
  function DomPopupManager$attachPopup$lambda(this$0, $mapper) {
    return function (it) {
      var tmp = DomImmediatePolyfill_getInstance();
      tmp.x8h(DomPopupManager$attachPopup$lambda$lambda(this$0, $mapper));
      return Unit_instance;
    };
  }
  function DomPopupManager$updatePopupPositions$ref(p0) {
    var l = function () {
      p0.ka3();
      return Unit_instance;
    };
    l.callableName = 'updatePopupPositions';
    return l;
  }
  function DomPopupManager$setPopupUpdate$$inlined$toDisposable$1($timer) {
    this.wbo_1 = $timer;
  }
  protoOf(DomPopupManager$setPopupUpdate$$inlined$toDisposable$1).zr = function () {
    this.wbo_1.i3a();
    return Unit_instance;
  };
  function DomPopupManager$scrollToPopup$lambda($popup) {
    return function () {
      var tmp;
      if ($popup.f89()) {
        scrollTo_0($popup);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function DomPopupManager$UpdatePositionTask$run$ref_0(p0) {
    var l = function () {
      p0.au();
      return Unit_instance;
    };
    l.callableName = 'run';
    return l;
  }
  function DomPopupManager(context) {
    BasePopupManager.call(this);
    this.dbi_1 = context;
    var tmp = this;
    tmp.ebi_1 = lazy(DomPopupManager$positionUpdater$delegate$lambda(this));
    this.fbi_1 = null;
  }
  protoOf(DomPopupManager).da3 = function (popup) {
    var mapper = this.dbi_1.rbi(popup);
    var element = mapper.f86_1;
    this.dbi_1.k9x_1.appendChild(element);
    addClassName(element, Companion_getInstance_222().lbh_1.vbf_1);
    setPosition(element.style, CssPosition_FIXED_getInstance());
    if (popup instanceof LayoutCell) {
      addClassName(element, Companion_getInstance_222().lbh_1.wbf_1);
    }
    setZIndex(element.style, 100 + popup.k91(get_POPUP_Z_ADJUSTMENT()) | 0);
    setMarginRight(element.style, 5);
    setMarginBottom(element.style, 5);
    if (this.fbi_1 == null) {
      this.fbi_1 = HashMap_init_$Create$();
    }
    var tmp;
    if (popup instanceof ScrollCell) {
      var tmp_0 = popup.g95();
      tmp = tmp_0.z2r(DomPopupManager$attachPopup$lambda(this, mapper));
    } else {
      tmp = Companion_getInstance_29().m2l_1;
    }
    var scrollReg = tmp;
    var tmp0 = ensureNotNull(this.fbi_1);
    // Inline function 'kotlin.collections.set' call
    var value = new CompositeDisposable([Tooltip_instance.ybo(mapper), scrollReg]);
    tmp0.t2(element, value);
    return mapper;
  };
  protoOf(DomPopupManager).gbi = function (popup) {
    removeFromParent(popup.f86_1);
    ensureNotNull(ensureNotNull(this.fbi_1).u2(popup.f86_1)).zr();
    if (ensureNotNull(this.fbi_1).s()) {
      this.fbi_1 = null;
    }
  };
  protoOf(DomPopupManager).ea3 = function (popup) {
    return this.gbi(popup);
  };
  protoOf(DomPopupManager).fa3 = function () {
    var timer = new Timer(DomPopupManager$updatePopupPositions$ref(this));
    timer.n3a(50);
    // Inline function 'jetbrains.ocelot.base.disposable.toDisposable' call
    return new DomPopupManager$setPopupUpdate$$inlined$toDisposable$1(timer);
  };
  protoOf(DomPopupManager).hbi = function (popup) {
    return _get_positionUpdater__wwdan(this);
  };
  protoOf(DomPopupManager).za2 = function (popup) {
    return this.hbi(popup);
  };
  protoOf(DomPopupManager).ya2 = function (popup) {
    if (popup.f89()) {
      var tmp = ensureNotNull(popup.s8x()).m93();
      var tmp_0 = DomPopupManager$scrollToPopup$lambda(popup);
      tmp.v39(50, new sam$jetbrains_ocelot_base_edt_EdtTask$0_15(tmp_0));
    }
  };
  protoOf(DomPopupManager).ibi = function (mapper) {
    return DomPopupManager$UpdatePositionTask$run$ref_0(new UpdatePositionTask(this, mapper));
  };
  protoOf(DomPopupManager).ma3 = function (mapper) {
    return this.ibi(mapper);
  };
  function DomProperties() {
    DomProperties_instance = this;
    this.zbo_1 = CellPropertySpec_init_$Create$('rootPaddingPx', 15);
  }
  var DomProperties_instance;
  function DomProperties_getInstance() {
    if (DomProperties_instance == null)
      new DomProperties();
    return DomProperties_instance;
  }
  function _get_isTextAreaFullyVisible__mocubj($this) {
    return equals(DomUtil_getInstance_0().bbm($this.bbk_1), DomUtil_getInstance_0().dbj($this.bbk_1));
  }
  function addFocusHandlers($this, rootElement) {
    var focusHandler = DomTextInput$addFocusHandlers$lambda($this);
    var blurHandler = DomTextInput$addFocusHandlers$lambda_0($this);
    var rootFocusHandler = DomTextInput$addFocusHandlers$lambda_1($this);
    return new CompositeDisposable([on($this.bbk_1, Companion_getInstance_139().q8g_1, focusHandler), on($this.bbk_1, Companion_getInstance_139().b8g_1, blurHandler), on(rootElement, Companion_getInstance_139().q8g_1, rootFocusHandler)]);
  }
  function moveTextAreaToVisiblePlace($this) {
    var rootVisiblePart = DomUtil_getInstance_0().bbm($this.abk_1);
    if (rootVisiblePart == null) {
      moveTextArea($this, 0, 0, CssPosition_FIXED_getInstance());
      return Unit_instance;
    }
    var visibleCenter = rootVisiblePart.v8c();
    moveTextAreaToFixed($this, visibleCenter.d8c_1, visibleCenter.e8c_1);
  }
  function moveTextAreaToFixed($this, x, y) {
    moveTextArea($this, x, y, CssPosition_FIXED_getInstance());
  }
  function moveTextArea($this, x, y, position) {
    var style = $this.bbk_1.style;
    setLeft(style, x);
    setTop(style, y);
    setPosition(style, position);
  }
  function DomTextInput$addFocusHandlers$lambda(this$0) {
    return function (_unused_var__etf5q3) {
      this$0.cbk_1.d2x(true);
      return false;
    };
  }
  function DomTextInput$addFocusHandlers$lambda_0(this$0) {
    return function (_unused_var__etf5q3) {
      this$0.cbk_1.d2x(false);
      return false;
    };
  }
  function DomTextInput$addFocusHandlers$lambda_1(this$0) {
    return function (_unused_var__etf5q3) {
      var tmp;
      if (!this$0.cbk_1.uv()) {
        this$0.fbm();
        tmp = Unit_instance;
      }
      return false;
    };
  }
  function DomTextInput(rootElement) {
    this.abk_1 = rootElement;
    this.bbk_1 = HiddenTextAreaHelper_instance.abp();
    this.cbk_1 = new ValueProperty(false);
    this.abk_1.appendChild(this.bbk_1);
    this.dbk_1 = addFocusHandlers(this, this.abk_1);
  }
  protoOf(DomTextInput).gbm = function () {
    return this.cbk_1;
  };
  protoOf(DomTextInput).fbm = function () {
    if (!_get_isTextAreaFullyVisible__mocubj(this)) {
      moveTextAreaToVisiblePlace(this);
    }
    this.bbk_1.focus();
  };
  protoOf(DomTextInput).ebk = function (x, y) {
    moveTextArea(this, x, y, CssPosition_ABSOLUTE_getInstance());
  };
  protoOf(DomTextInput).ebl = function (target) {
    return (new TextAreaKeyTranslator(this.bbk_1, this.abk_1, target)).z8n();
  };
  protoOf(DomTextInput).zr = function () {
    this.dbk_1.zr();
    removeFromParent(this.bbk_1);
  };
  function EmptyLineHighlight() {
  }
  protoOf(EmptyLineHighlight).ubm = function (parent, edt, elementSupplier, widthSupplier) {
  };
  protoOf(EmptyLineHighlight).zr = function () {
  };
  function create_0($this, position) {
    var textarea = DomApi_instance.q8f();
    var style = textarea.style;
    setPosition(style, position);
    setLeft(style, 0.0);
    setTop(style, 0.0);
    setHeight(style, 1);
    setWidth(style, 1);
    setOverflow(style, CssOverflow_HIDDEN_getInstance());
    setZIndex(style, -1);
    setPadding(style, 0.0);
    setColor(style, Companion_getInstance_210().l95_1.cb0());
    setBorderStyle(style, CssBorderStyle_NONE_getInstance());
    setOutlineStyle(style, CssOutlineStyle_NONE_getInstance());
    return textarea;
  }
  function HiddenTextAreaHelper() {
  }
  protoOf(HiddenTextAreaHelper).abp = function () {
    return create_0(this, CssPosition_ABSOLUTE_getInstance());
  };
  var HiddenTextAreaHelper_instance;
  function HiddenTextAreaHelper_getInstance() {
    return HiddenTextAreaHelper_instance;
  }
  function HorizontalCellMapper(source, ctx) {
    BaseCellToDomMapper.call(this, source, ctx, DomApi_instance.m8f());
    addClassName(this.f86_1, Companion_getInstance_222().lbh_1.dbf_1);
  }
  protoOf(HorizontalCellMapper).a88 = function (conf) {
    protoOf(BaseCellToDomMapper).a88.call(this, conf);
    conf.h5v(AlignmentSynchronizers_instance.rbg(this.e86_1, this.f86_1));
  };
  function Companion_226() {
    this.sbp_1 = 'width';
    this.tbp_1 = 'height';
  }
  var Companion_instance_226;
  function Companion_getInstance_226() {
    return Companion_instance_226;
  }
  function ImageCellMapper$registerSynchronizers$$inlined$writableProperty$1(this$0) {
    this.ubp_1 = this$0;
  }
  protoOf(ImageCellMapper$registerSynchronizers$$inlined$writableProperty$1).x9j = function (newValue) {
    if (newValue == null) {
      this.ubp_1.f86_1.removeAttribute('width');
      this.ubp_1.f86_1.removeAttribute('height');
    } else {
      var dimension = newValue.p8w_1;
      this.ubp_1.f86_1.setAttribute('width', '' + dimension.d8c_1);
      this.ubp_1.f86_1.setAttribute('height', '' + dimension.e8c_1);
    }
    if (newValue instanceof UrlImageData) {
      this.ubp_1.f86_1.setAttribute('src', newValue.gb0_1);
    }
    return Unit_instance;
  };
  protoOf(ImageCellMapper$registerSynchronizers$$inlined$writableProperty$1).d2x = function (newValue) {
    return this.x9j((newValue == null ? true : !(newValue == null)) ? newValue : THROW_CCE());
  };
  function ImageCellMapper(source, ctx) {
    BaseCellToDomMapper.call(this, source, ctx, DomApi_instance.r8f());
    setVerticalAlign(this.f86_1.style, CssVerticalAlign_BOTTOM_getInstance());
  }
  protoOf(ImageCellMapper).a88 = function (conf) {
    protoOf(BaseCellToDomMapper).a88.call(this, conf);
    var tmp = this.e86_1.z8w();
    // Inline function 'jetbrains.ocelot.base.observable.property.writableProperty' call
    var tmp$ret$0 = new ImageCellMapper$registerSynchronizers$$inlined$writableProperty$1(this);
    conf.h5v(syncOneWay(tmp, tmp$ret$0));
  };
  function IndentRootCellMapper$2$wrap$1($mapper, this$0, $source, $cell) {
    this.nbq_1 = $mapper;
    this.obq_1 = this$0;
    this.pbq_1 = $source;
    this.qbq_1 = $cell;
    this.mbq_1 = $mapper.f86_1;
  }
  protoOf(IndentRootCellMapper$2$wrap$1).w8v = function () {
    return this.mbq_1;
  };
  protoOf(IndentRootCellMapper$2$wrap$1).x8v = function () {
    this.obq_1.vbj_1.j(this.nbq_1);
    this.obq_1.pbi();
  };
  protoOf(IndentRootCellMapper$2$wrap$1).h4 = function () {
    CounterUtil_getInstance().q9b(this.pbq_1, this.qbq_1, this.nbq_1);
    this.obq_1.vbj_1.h2(this.nbq_1);
    this.obq_1.pbi();
  };
  function IndentRootCellMapper$2(this$0, $source) {
    this.rbq_1 = this$0;
    this.sbq_1 = $source;
  }
  protoOf(IndentRootCellMapper$2).l8v = function () {
    var result = DomApi_instance.m8f();
    addClassName(result, Companion_getInstance_222().lbh_1.dbf_1);
    return result;
  };
  protoOf(IndentRootCellMapper$2).m8v = function (size) {
    var result = DomApi_instance.m8f();
    var editor = new DomTextEditor(result);
    editor.ibr(repeat(' ', size));
    return result;
  };
  protoOf(IndentRootCellMapper$2).n8v = function (cell) {
    var mapper = this.rbq_1.qbi(cell);
    CounterUtil_getInstance().p9b(this.sbq_1, cell, mapper);
    return new IndentRootCellMapper$2$wrap$1(mapper, this.rbq_1, this.sbq_1, cell);
  };
  protoOf(IndentRootCellMapper$2).jbr = function (item) {
    // Inline function 'kotlin.check' call
    if (!(item instanceof Element)) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    return DomUtil_instance.q8d(item);
  };
  protoOf(IndentRootCellMapper$2).p8v = function (item) {
    return this.jbr((item == null ? true : item instanceof Node) ? item : THROW_CCE());
  };
  protoOf(IndentRootCellMapper$2).kbr = function (item) {
    // Inline function 'kotlin.check' call
    if (!(item instanceof Element)) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    return item.parentElement;
  };
  protoOf(IndentRootCellMapper$2).r8v = function (item) {
    return this.kbr((item == null ? true : item instanceof Node) ? item : THROW_CCE());
  };
  protoOf(IndentRootCellMapper$2).u8v = function (cell) {
    var descendantMapper = this.rbq_1.g89(ensureNotNull(cell).d9w());
    var mapper = descendantMapper instanceof IndentRootCellMapper ? descendantMapper : THROW_CCE();
    return mapper.wbj_1;
  };
  protoOf(IndentRootCellMapper$2).lbr = function (item) {
    // Inline function 'kotlin.check' call
    if (!(ensureNotNull(item).nodeType === 1)) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    var tmp = DomUtil_getInstance_0();
    return tmp.dbj(item instanceof HTMLElement ? item : THROW_CCE());
  };
  protoOf(IndentRootCellMapper$2).t8v = function (item) {
    return this.lbr((item == null ? true : item instanceof Node) ? item : THROW_CCE());
  };
  function IndentRootCellMapper$onAttach$o$updateCounters$lambda(this$0, $prop, $event) {
    return function (item) {
      var tmp = this$0.g89(item);
      var mapper = tmp instanceof BaseCellToDomMapper ? tmp : THROW_CCE();
      var tmp_0;
      if (CounterUtil_getInstance().n9b(mapper, $prop, $event)) {
        this$0.cbh_1.sbh(mapper);
        tmp_0 = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function IndentRootCellMapper$onAttach$o$updateLeavesProperty$lambda(this$0, $prop) {
    return function (item) {
      var tmp = this$0.g89(item);
      var mapper = tmp instanceof BaseCellToDomMapper ? tmp : THROW_CCE();
      mapper.g9b($prop, AncestorUtil_instance.i9x($prop, this$0.e86_1, item));
      this$0.cbh_1.sbh(mapper);
      return Unit_instance;
    };
  }
  function IndentRootCellMapper$1($source, this$0) {
    IndentUpdater.call(this, $source, this$0.f86_1, new IndentRootCellMapper$2(this$0, $source));
  }
  protoOf(IndentRootCellMapper$1).j8v = function (cell, event) {
    return this.e8v(cell, event);
  };
  function IndentRootCellMapper$onAttach$1(this$0) {
    this.ybr_1 = this$0;
    BaseIndentUpdatingListener.call(this, this$0.wbj_1);
    this.r9w(this$0.e86_1);
  }
  protoOf(IndentRootCellMapper$onAttach$1).u9w = function (event) {
    return this.ybr_1.ha3(event);
  };
  protoOf(IndentRootCellMapper$onAttach$1).v9w = function (cell, prop, event) {
    var tmp = IndentUtil_instance;
    tmp.q9x(cell, IndentRootCellMapper$onAttach$o$updateCounters$lambda(this.ybr_1, prop, event));
  };
  protoOf(IndentRootCellMapper$onAttach$1).t9w = function (cell, prop) {
    var tmp = IndentUtil_instance;
    tmp.q9x(cell, IndentRootCellMapper$onAttach$o$updateLeavesProperty$lambda(this.ybr_1, prop));
  };
  protoOf(IndentRootCellMapper$onAttach$1).s9w = function (leaf) {
    var tmp = this.ybr_1.g89(leaf);
    var leafMapper = tmp instanceof BaseCellToDomMapper ? tmp : THROW_CCE();
    AncestorUtil_instance.j9x(leafMapper, this.ybr_1.e86_1, leaf);
  };
  function IndentRootCellMapper$createPopupManager$1(this$0) {
    this.ebs_1 = this$0;
    DomPopupManager.call(this, this$0.cbh_1);
  }
  protoOf(IndentRootCellMapper$createPopupManager$1).ga3 = function (cell) {
    protoOf(DomPopupManager).ga3.call(this, cell);
    // Inline function 'kotlin.collections.filterIsInstance' call
    var tmp0 = cell.o35();
    // Inline function 'kotlin.collections.filterIsInstanceTo' call
    var destination = ArrayList_init_$Create$();
    var _iterator__ex2g4s = tmp0.m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      if (element instanceof IndentCell) {
        destination.j(element);
      }
    }
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s_0 = destination.m();
    while (_iterator__ex2g4s_0.n()) {
      var element_0 = _iterator__ex2g4s_0.o();
      this.ga3(element_0);
    }
  };
  protoOf(IndentRootCellMapper$createPopupManager$1).da3 = function (popup) {
    var tmp = protoOf(DomPopupManager).da3.call(this, popup);
    var mapper = tmp instanceof BaseCellToDomMapper ? tmp : THROW_CCE();
    this.ebs_1.vbj_1.j(mapper);
    return mapper;
  };
  protoOf(IndentRootCellMapper$createPopupManager$1).gbi = function (popup) {
    // Inline function 'kotlin.collections.remove' call
    var this_0 = this.ebs_1.vbj_1;
    (isInterface(this_0, MutableCollection) ? this_0 : THROW_CCE()).h2(popup);
    protoOf(DomPopupManager).gbi.call(this, popup);
  };
  protoOf(IndentRootCellMapper$createPopupManager$1).ea3 = function (popup) {
    return this.gbi(popup);
  };
  protoOf(IndentRootCellMapper$createPopupManager$1).ca3 = function () {
    return HashSet_init_$Create$();
  };
  function IndentRootCellMapper(source, ctx) {
    BaseCellToDomMapper.call(this, source, ctx, DomApi_instance.m8f());
    this.xbj_1 = null;
    this.vbj_1 = this.q89();
    var tmp = this;
    tmp.wbj_1 = new IndentRootCellMapper$1(source, this);
  }
  protoOf(IndentRootCellMapper).kbi = function () {
    return false;
  };
  protoOf(IndentRootCellMapper).mbi = function () {
    return false;
  };
  protoOf(IndentRootCellMapper).o89 = function (ctx) {
    protoOf(BaseCellToDomMapper).o89.call(this, ctx);
    var _iterator__ex2g4s = this.e86_1.o35().m();
    while (_iterator__ex2g4s.n()) {
      var child = _iterator__ex2g4s.o();
      this.wbj_1.c8v(child);
    }
    this.wbj_1.b8v();
    var tmp = this;
    tmp.xbj_1 = this.e86_1.e9w(new IndentRootCellMapper$onAttach$1(this));
  };
  protoOf(IndentRootCellMapper).c87 = function () {
    var children = this.e86_1.o35();
    var inductionVariable = children.p() - 1 | 0;
    if (0 <= inductionVariable)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        var c = children.r(i);
        this.wbj_1.d8v(c);
      }
       while (0 <= inductionVariable);
    ensureNotNull(this.xbj_1).zr();
    protoOf(BaseCellToDomMapper).c87.call(this);
  };
  protoOf(IndentRootCellMapper).nbi = function () {
    return new IndentRootCellMapper$createPopupManager$1(this);
  };
  protoOf(IndentRootCellMapper).k8v = function (indentCell) {
    return this.wbj_1.k8v(indentCell);
  };
  function Companion_227() {
    Companion_instance_227 = this;
    this.zbm_1 = new EmptyLineHighlight();
  }
  var Companion_instance_227;
  function Companion_getInstance_227() {
    if (Companion_instance_227 == null)
      new Companion_227();
    return Companion_instance_227;
  }
  function Companion_228() {
    this.fbs_1 = 2;
  }
  protoOf(Companion_228).gbs = function (namedValue, valueInPixels) {
    if (namedValue == null || !endsWith(namedValue, CssUnit_PX_getInstance().u8d_1)) {
      return false;
    }
    // Inline function 'kotlin.text.trim' call
    var this_0 = dropLast_0(namedValue, CssUnit_PX_getInstance().u8d_1.length);
    // Inline function 'kotlin.text.trim' call
    var this_1 = isCharSequence(this_0) ? this_0 : THROW_CCE();
    var startIndex = 0;
    var endIndex = charSequenceLength(this_1) - 1 | 0;
    var startFound = false;
    $l$loop: while (startIndex <= endIndex) {
      var index = !startFound ? startIndex : endIndex;
      var it = charSequenceGet(this_1, index);
      var match = Char__compareTo_impl_ypi4mb(it, _Char___init__impl__6a9atx(32)) <= 0;
      if (!startFound) {
        if (!match)
          startFound = true;
        else
          startIndex = startIndex + 1 | 0;
      } else {
        if (!match)
          break $l$loop;
        else
          endIndex = endIndex - 1 | 0;
      }
    }
    var tmp$ret$1 = charSequenceSubSequence(this_1, startIndex, endIndex + 1 | 0);
    var number = toString_1(tmp$ret$1);
    var tmp;
    try {
      tmp = valueInPixels === toInt(number);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof NumberFormatException) {
        var e = $p;
        tmp_0 = false;
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  var Companion_instance_228;
  function Companion_getInstance_228() {
    return Companion_instance_228;
  }
  function PopupPositioner(context, rightBottomMargin) {
    PopupPositionUpdater_init_$Init$(rightBottomMargin, this);
    this.ibs_1 = context;
  }
  protoOf(PopupPositioner).na3 = function () {
    var topLeft = ensureNotNull(DomUtil_getInstance_0().bbm(this.ibs_1.k9x_1)).b8c_1;
    var bottomRight = new Vector(DomUtil_getInstance_0().jbs(), DomUtil_getInstance_0().kbs());
    return new Rectangle(topLeft, bottomRight.j8c(topLeft));
  };
  protoOf(PopupPositioner).lbs = function (popup) {
    var htmlElement = cast_0(popup);
    return new Vector(htmlElement.offsetWidth, htmlElement.offsetHeight);
  };
  protoOf(PopupPositioner).ba4 = function (popup) {
    return this.lbs(popup instanceof HTMLElement ? popup : THROW_CCE());
  };
  protoOf(PopupPositioner).mbs = function (popup) {
    return Tooltip_instance.nbs(popup);
  };
  protoOf(PopupPositioner).va3 = function (popup) {
    return this.mbs(popup instanceof HTMLElement ? popup : THROW_CCE());
  };
  protoOf(PopupPositioner).obs = function (popup) {
    return Tooltip_instance.pbs(popup);
  };
  protoOf(PopupPositioner).ua3 = function (popup) {
    return this.obs(popup instanceof HTMLElement ? popup : THROW_CCE());
  };
  protoOf(PopupPositioner).qbs = function (popup, height) {
    return Tooltip_instance.rbs(popup, height);
  };
  protoOf(PopupPositioner).ta3 = function (popup, height) {
    return this.qbs(popup instanceof HTMLElement ? popup : THROW_CCE(), height);
  };
  protoOf(PopupPositioner).sbs = function (popup, height) {
    return Tooltip_instance.tbs(popup, height);
  };
  protoOf(PopupPositioner).xa3 = function (popup, height) {
    return this.sbs(popup instanceof HTMLElement ? popup : THROW_CCE(), height);
  };
  protoOf(PopupPositioner).ubs = function (popup, left, top) {
    var style = popup.style;
    var changed = !Companion_instance_228.gbs(style.left, left) || !Companion_instance_228.gbs(style.top, top);
    setLeft(style, left);
    setTop(style, top);
    var htmlElement = cast_0(popup);
    return changed || htmlElement.offsetWidth <= 2;
  };
  protoOf(PopupPositioner).ya3 = function (popup, left, top) {
    return this.ubs(popup instanceof HTMLElement ? popup : THROW_CCE(), left, top);
  };
  function RootCellMapper(source, ctx) {
    BaseCellToDomMapper.call(this, source, ctx, DomApi_instance.m8f());
    var padding = source.k91(DomProperties_getInstance().zbo_1);
    setPadding(this.f86_1.style, padding);
  }
  function ScrollCellMapper(source, ctx) {
    BaseCellToDomMapper.call(this, source, ctx, DomApi_instance.m8f());
    setOverflowX(this.f86_1.style, CssOverflow_AUTO_getInstance());
    addClassName(this.f86_1, Companion_getInstance_222().lbh_1.lbf_1);
  }
  protoOf(ScrollCellMapper).ubi = function () {
    protoOf(BaseCellToDomMapper).ubi.call(this);
    var style = this.f86_1.style;
    var maxDim = this.e86_1.f95().uv();
    var borderTotalWidth = DomUtil_getInstance_0().mbt(this.f86_1) + DomUtil_getInstance_0().nbt(this.f86_1) | 0;
    if (maxDim.d8c_1 > borderTotalWidth) {
      setMaxWidth(style, maxDim.d8c_1 - borderTotalWidth);
    }
    var borderTotalHeight = DomUtil_getInstance_0().obt(this.f86_1) + DomUtil_getInstance_0().pbt(this.f86_1) | 0;
    if (maxDim.e8c_1 > borderTotalHeight) {
      setMaxHeight(style, maxDim.e8c_1 - borderTotalHeight);
    }
    setOverflowY(style, this.e86_1.g95().uv() ? CssOverflow_SCROLL_getInstance() : CssOverflow_HIDDEN_getInstance());
  };
  function updateCaretVisibility($this) {
    $this.ybl_1.qbt($this.cbh_1.rbh_1.gbm().uv() && $this.e86_1.c97().uv());
  }
  function Companion_229() {
    this.rbt_1 = 1000;
  }
  var Companion_instance_229;
  function Companion_getInstance_229() {
    return Companion_instance_229;
  }
  function TextCellMapper$refreshProperties$lambda(this$0) {
    return function () {
      var tmp;
      if (subtract_1(currentTimeMillis(), this$0.zbl_1) >= 1000n) {
        this$0.ybl_1.sbt();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function TextCellMapper$refreshProperties$lambda_0(this$0) {
    return function (it) {
      updateCaretVisibility(this$0);
      return Unit_instance;
    };
  }
  function TextCellMapper$refreshProperties$lambda_1(this$0) {
    return function (event) {
      var tmp;
      if (event.t2y_1) {
        this$0.zbl_1 = currentTimeMillis();
        updateCaretVisibility(this$0);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function TextCellMapper$refreshProperties$$inlined$toDisposable$1($timer) {
    this.tbt_1 = $timer;
  }
  protoOf(TextCellMapper$refreshProperties$$inlined$toDisposable$1).zr = function () {
    this.tbt_1.i3a();
    return Unit_instance;
  };
  function TextCellMapper(source, ctx) {
    BaseCellToDomMapper.call(this, source, ctx, DomApi_instance.m8f());
    this.ybl_1 = new DomTextEditor(this.f86_1);
    this.zbl_1 = currentTimeMillis();
    this.abm_1 = null;
  }
  protoOf(TextCellMapper).kbi = function () {
    return false;
  };
  protoOf(TextCellMapper).q90 = function () {
    return true;
  };
  protoOf(TextCellMapper).o89 = function (ctx) {
    protoOf(BaseCellToDomMapper).o89.call(this, ctx);
    addClassName(this.f86_1, Companion_getInstance_222().lbh_1.pbf_1);
  };
  protoOf(TextCellMapper).c87 = function () {
    protoOf(BaseCellToDomMapper).c87.call(this);
    if (!(this.abm_1 == null)) {
      ensureNotNull(this.abm_1).zr();
      this.abm_1 = null;
    }
  };
  protoOf(TextCellMapper).z96 = function (caret) {
    return numberToInt(this.ybl_1.z96(caret));
  };
  protoOf(TextCellMapper).m97 = function (x) {
    return this.ybl_1.ubt(x);
  };
  protoOf(TextCellMapper).ubi = function () {
    protoOf(BaseCellToDomMapper).ubi.call(this);
    var focused = this.e86_1.k91(get_FOCUSED());
    if (focused) {
      if (this.abm_1 == null) {
        var timer = new Timer(TextCellMapper$refreshProperties$lambda(this));
        timer.n3a(500);
        var tmp = this;
        var tmp_0 = this.cbh_1.rbh_1.gbm();
        var tmp_1 = tmp_0.z2r(TextCellMapper$refreshProperties$lambda_0(this));
        var tmp_2 = this.e86_1.c97();
        var tmp_3 = tmp_2.z2r(TextCellMapper$refreshProperties$lambda_1(this));
        // Inline function 'jetbrains.ocelot.base.disposable.toDisposable' call
        var tmp$ret$0 = new TextCellMapper$refreshProperties$$inlined$toDisposable$1(timer);
        tmp.abm_1 = new CompositeDisposable([tmp_1, tmp_3, tmp$ret$0]);
      }
    } else {
      if (!(this.abm_1 == null)) {
        ensureNotNull(this.abm_1).zr();
        this.abm_1 = null;
      }
    }
    this.zbl_1 = currentTimeMillis();
    this.ybl_1.vbt(this.e86_1.o8w().uv(), this.e86_1.l97().uv());
    this.ybl_1.wbt(this.e86_1.t96().uv());
    this.ybl_1.qbt(this.e86_1.c97().uv());
    this.ybl_1.xbt(this.e86_1.b97().uv());
    this.ybl_1.ybt(this.e86_1.d97().uv());
    this.ybl_1.zbt(this.e86_1.e97().uv());
    this.ybl_1.abu(this.e86_1.f97().uv());
    this.ybl_1.bbu(this.e86_1.g97().uv());
    this.ybl_1.cbu(this.e86_1.h97().uv());
    this.ybl_1.dbu(this.e86_1.i97().uv());
    this.ybl_1.ebu(this.e86_1.j97().uv());
    this.ybl_1.fbu(this.e86_1.k97().uv());
  };
  function updateWidth($this, widthChars) {
    setWidth(style($this), numberToInt(widthChars * charWidth($this)));
  }
  function updateHeight($this, heightLines) {
    setHeight(style($this), numberToInt(heightLines * charHeight($this)));
  }
  function charWidth($this) {
    return DomUtil_getInstance_0().bbj_1.vbe().q8b_1;
  }
  function charHeight($this) {
    return DomUtil_getInstance_0().bbj_1.vbe().r8b_1;
  }
  function style($this) {
    return $this.f86_1.style;
  }
  function TextPlaceholderCellMapper$registerSynchronizers$$inlined$writableProperty$1(this$0) {
    this.gbu_1 = this$0;
  }
  protoOf(TextPlaceholderCellMapper$registerSynchronizers$$inlined$writableProperty$1).x9j = function (newValue) {
    var this_0 = this.gbu_1;
    updateWidth(this_0, newValue);
    return Unit_instance;
  };
  protoOf(TextPlaceholderCellMapper$registerSynchronizers$$inlined$writableProperty$1).d2x = function (newValue) {
    return this.x9j((newValue == null ? true : !(newValue == null)) ? newValue : THROW_CCE());
  };
  function TextPlaceholderCellMapper$registerSynchronizers$$inlined$writableProperty$2(this$0) {
    this.hbu_1 = this$0;
  }
  protoOf(TextPlaceholderCellMapper$registerSynchronizers$$inlined$writableProperty$2).x9j = function (newValue) {
    var this_0 = this.hbu_1;
    updateHeight(this_0, newValue);
    return Unit_instance;
  };
  protoOf(TextPlaceholderCellMapper$registerSynchronizers$$inlined$writableProperty$2).d2x = function (newValue) {
    return this.x9j((newValue == null ? true : !(newValue == null)) ? newValue : THROW_CCE());
  };
  function TextPlaceholderCellMapper(source, ctx) {
    BaseCellToDomMapper.call(this, source, ctx, DomApi_instance.m8f());
  }
  protoOf(TextPlaceholderCellMapper).a88 = function (conf) {
    protoOf(BaseCellToDomMapper).a88.call(this, conf);
    var tmp = this.e86_1.x97();
    // Inline function 'jetbrains.ocelot.base.observable.property.writableProperty' call
    var tmp$ret$0 = new TextPlaceholderCellMapper$registerSynchronizers$$inlined$writableProperty$1(this);
    conf.h5v(syncOneWay(tmp, tmp$ret$0));
    var tmp_0 = this.e86_1.y97();
    // Inline function 'jetbrains.ocelot.base.observable.property.writableProperty' call
    var tmp$ret$1 = new TextPlaceholderCellMapper$registerSynchronizers$$inlined$writableProperty$2(this);
    conf.h5v(syncOneWay(tmp_0, tmp$ret$1));
  };
  function injectCornerStyle($this, id, cell) {
    var cellBorder = get_border(cell).uv();
    var top = cellBorder == null ? null : cellBorder.a8u_1;
    var border = top == null ? 'none' : Companion_instance_221.ubh(top);
    var backgroundColor = cell.k91(get_BACKGROUND());
    var tmp2_elvis_lhs = backgroundColor == null ? null : backgroundColor.cb0();
    var backgroundValue = tmp2_elvis_lhs == null ? Companion_getInstance_210().m95_1.cb0() : tmp2_elvis_lhs;
    var styleElement = StyleInjector_getInstance().d8i('.' + id + '::before { border-top: ' + border + '; border-left: ' + border + '; background: linear-gradient(135deg, ' + (backgroundValue + ' 0%, ' + backgroundValue + ' 55%, rgba(0,0,0,0) 56%, rgba(0,0,0,0) 100%) }'));
    // Inline function 'jetbrains.ocelot.base.disposable.toDisposable' call
    return new Tooltip$injectCornerStyle$$inlined$toDisposable$1(styleElement);
  }
  function isTooltip($this, element) {
    return element.classList.contains(Companion_getInstance_222().lbh_1.xbf_1);
  }
  function Tooltip$injectCornerStyle$$inlined$toDisposable$1($styleElement) {
    this.zbu_1 = $styleElement;
  }
  protoOf(Tooltip$injectCornerStyle$$inlined$toDisposable$1).zr = function () {
    removeFromParent(this.zbu_1);
    return Unit_instance;
  };
  function Tooltip() {
    this.xbo_1 = 6;
  }
  protoOf(Tooltip).ybo = function (popupMapper) {
    var cell = popupMapper.e86_1;
    if (!get_isPopup(cell) || !cell.k91(get_HAS_POPUP_DECORATION())) {
      return Companion_getInstance_29().m2l_1;
    }
    var id = Companion_getInstance_222().lbh_1.xbf_1 + toString_3(hashCode(cell), 16);
    addClassName(popupMapper.f86_1, Companion_getInstance_222().lbh_1.xbf_1);
    addClassName(popupMapper.f86_1, id);
    return injectCornerStyle(this, id, cell);
  };
  protoOf(Tooltip).pbs = function (tooltip) {
    if (!isTooltip(this, tooltip))
      return Unit_instance;
    clearMarginBottom(tooltip.style);
    setMarginTop(tooltip.style, 6);
    removeClassName(tooltip, Companion_getInstance_222().lbh_1.zbf_1);
    addClassName(tooltip, Companion_getInstance_222().lbh_1.ybf_1);
  };
  protoOf(Tooltip).nbs = function (tooltip) {
    if (!isTooltip(this, tooltip))
      return Unit_instance;
    clearMarginTop(tooltip.style);
    setMarginBottom(tooltip.style, 6);
    removeClassName(tooltip, Companion_getInstance_222().lbh_1.ybf_1);
    addClassName(tooltip, Companion_getInstance_222().lbh_1.zbf_1);
  };
  protoOf(Tooltip).rbs = function (popup, height) {
    return isTooltip(this, popup) ? height + 6 | 0 : height;
  };
  protoOf(Tooltip).tbs = function (popup, height) {
    return isTooltip(this, popup) ? height - 6 | 0 : height;
  };
  var Tooltip_instance;
  function Tooltip_getInstance() {
    return Tooltip_instance;
  }
  function VerticalCellMapper(source, ctx) {
    BaseCellToDomMapper.call(this, source, ctx, DomApi_instance.m8f());
    addClassName(this.f86_1, Companion_getInstance_222().lbh_1.bbf_1);
  }
  protoOf(VerticalCellMapper).a88 = function (conf) {
    protoOf(BaseCellToDomMapper).a88.call(this, conf);
    conf.h5v(AlignmentSynchronizers_instance.rbg(this.e86_1, this.f86_1));
  };
  protoOf(VerticalCellMapper).ubi = function () {
    protoOf(BaseCellToDomMapper).ubi.call(this);
    this.tbh(Companion_getInstance_222().lbh_1.ebf_1, this.e86_1.k91(Companion_getInstance_156().z97_1));
  };
  function ViewCellMapper$registerSynchronizers$$inlined$writableProperty$1(this$0) {
    this.rbv_1 = this$0;
  }
  protoOf(ViewCellMapper$registerSynchronizers$$inlined$writableProperty$1).x9j = function (newValue) {
    var children = this.rbv_1.kbw_1.cbe().q92();
    children.k2();
    if (!(newValue == null)) {
      children.j(newValue);
    }
    return Unit_instance;
  };
  protoOf(ViewCellMapper$registerSynchronizers$$inlined$writableProperty$1).d2x = function (newValue) {
    return this.x9j((newValue == null ? true : !(newValue == null)) ? newValue : THROW_CCE());
  };
  function ViewCellMapper(source, ctx, extensionViewMapperFactories) {
    BaseCellToDomMapper.call(this, source, ctx, DomApi_instance.m8f());
    this.jbw_1 = extensionViewMapperFactories;
    this.kbw_1 = new ViewContainer();
  }
  protoOf(ViewCellMapper).a88 = function (conf) {
    protoOf(BaseCellToDomMapper).a88.call(this, conf);
    var target = this.f86_1;
    var tmp;
    if (this.cbh_1.pbh_1) {
      tmp = ViewToDom_instance.mbw(this.kbw_1, target, this.jbw_1, true);
    } else {
      tmp = ViewToDom_instance.lbw(this.kbw_1, target, this.jbw_1);
    }
    var disposable = tmp;
    conf.h5v(disposable);
    var tmp_0 = this.e86_1.gah();
    // Inline function 'jetbrains.ocelot.base.observable.property.writableProperty' call
    var tmp$ret$0 = new ViewCellMapper$registerSynchronizers$$inlined$writableProperty$1(this);
    conf.h5v(syncOneWay(tmp_0, tmp$ret$0));
  };
  protoOf(ViewCellMapper).c87 = function () {
    protoOf(BaseCellToDomMapper).c87.call(this);
    this.kbw_1.cbe().q92().k2();
  };
  function _get_isCurrentFontMonospaced__wrvp72($this) {
    return equals(DomUtil_getInstance_0().zbi_1, $this.dbr_1.o96_1);
  }
  function _get_cachedOrEstimatedLineHeight__5rm6fz($this) {
    var cached = Companion_getInstance_230().obw_1.q2($this.dbr_1);
    var tmp1_elvis_lhs = cached == null ? null : cached;
    return tmp1_elvis_lhs == null ? $this.ebr_1.vbe().r8b_1 : tmp1_elvis_lhs;
  }
  function _get_lineHeight__binsk0($this) {
    var cached = Companion_getInstance_230().obw_1.q2($this.dbr_1);
    if (!(cached == null)) {
      return cached;
    } else {
      // Inline function 'kotlin.text.isNullOrEmpty' call
      var this_0 = $this.zbq_1;
      if (!(this_0 == null || charSequenceLength(this_0) === 0)) {
        var clientHeight = $this.ubq_1.clientHeight;
        if (clientHeight > 0) {
          Companion_getInstance_230().obw_1.t2($this.dbr_1, clientHeight);
          return clientHeight;
        }
      }
    }
    return $this.ebr_1.vbe().r8b_1;
  }
  function _get_charWidth__5ojr27($this) {
    var tmp;
    if (containsChinese($this, ensureNotNull($this.zbq_1))) {
      tmp = TextMetricsCalculator_getInstance().pbw($this.dbr_1, ensureNotNull($this.zbq_1)) / ensureNotNull($this.zbq_1).length;
    } else {
      tmp = $this.ebr_1.vbe().q8b_1;
    }
    return tmp;
  }
  function updateIfMonospaced($this, origin) {
    return equals(origin, Companion_getInstance_211().j95_1) ? DomUtil_getInstance_0().zbi_1 : origin;
  }
  function updateFontMetrics($this) {
    $this.ebr_1 = DomUtil_getInstance_0().abj_1.equals($this.dbr_1) ? DomUtil_getInstance_0().bbj_1 : TextMetricsCalculator_getInstance().qbw($this.dbr_1);
  }
  function doSetText($this, text) {
    $this.zbq_1 = text;
    updateText($this);
    if ($this.ybq_1) {
      updateSelectionBoundsAndText($this);
    }
  }
  function showCaret($this, style) {
    setRootZIndex($this, 1);
    style.borderLeft = '1px solid black';
  }
  function hideCaret($this, style) {
    setRootZIndex($this, 0);
    clearBorderLeft(style);
  }
  function updateCaretVisibility_0($this) {
    var visible = !($this.fbr_1 == null);
    if (visible === $this.bbr_1)
      return Unit_instance;
    if ($this.bbr_1) {
      var caretDiv = DomApi_instance.m8f();
      addClassName(caretDiv, 'user-caret');
      var caretStyle = caretDiv.style;
      setPosition(caretStyle, CssPosition_ABSOLUTE_getInstance());
      setZIndex(caretStyle, 10);
      setTop(caretStyle, 0.0);
      setWidth(caretStyle, 1);
      showCaret($this, caretStyle);
      $this.fbr_1 = caretDiv;
      $this.tbq_1.appendChild(ensureNotNull($this.fbr_1));
    } else {
      setRootZIndex($this, 0);
      removeFromParent(ensureNotNull($this.fbr_1));
      $this.fbr_1 = null;
    }
  }
  function setRootZIndex($this, zIndex) {
    setZIndex($this.tbq_1.style, zIndex);
  }
  function updateCaretBounds($this) {
    if ($this.fbr_1 == null)
      return Unit_instance;
    var caretStyle = ensureNotNull($this.fbr_1).style;
    setLeft(caretStyle, $this.z96($this.vbq_1));
    setHeight(caretStyle, numberToInt(_get_lineHeight__binsk0($this)));
  }
  function updateSelectionVisibility($this) {
    var visible = !($this.gbr_1 == null);
    if (visible === $this.ybq_1)
      return Unit_instance;
    var tmp = $this;
    var tmp_0;
    if ($this.ybq_1) {
      var selectionDiv = DomApi_instance.m8f();
      var selectionStyle = selectionDiv.style;
      setPosition(selectionStyle, CssPosition_ABSOLUTE_getInstance());
      setTop(selectionStyle, 0.0);
      setBackgroundColor(selectionStyle, 'Highlight');
      setColor(selectionStyle, 'HighlightText');
      setZIndex(selectionStyle, 1);
      $this.tbq_1.appendChild(selectionDiv);
      tmp_0 = selectionDiv;
    } else {
      removeFromParent(ensureNotNull($this.gbr_1));
      tmp_0 = null;
    }
    tmp.gbr_1 = tmp_0;
  }
  function updateSelectionBoundsAndText($this) {
    if ($this.gbr_1 == null)
      return Unit_instance;
    var tmp0 = $this.xbq_1;
    // Inline function 'kotlin.math.min' call
    var b = $this.wbq_1;
    var left = Math.min(tmp0, b);
    var tmp0_0 = $this.xbq_1;
    // Inline function 'kotlin.math.max' call
    var b_0 = $this.wbq_1;
    var right = Math.max(tmp0_0, b_0);
    var tmp0_elvis_lhs = $this.zbq_1;
    var text = tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
    text = substring(text, left, right);
    var selectionStyle = ensureNotNull($this.gbr_1).style;
    setHeight(selectionStyle, numberToInt(_get_lineHeight__binsk0($this)));
    setLeft(selectionStyle, $this.z96(left));
    setWidth(selectionStyle, numberToInt($this.z96(right) - $this.z96(left)));
    ensureNotNull($this.gbr_1).innerText = TextMetricsCalculator_getInstance().rbw(text);
  }
  function updateTextAppearance($this) {
    updateColor($this);
    updateFontFamily($this);
    updateFontSize($this);
    updateBold($this);
    updateItalic($this);
    updateText($this);
  }
  function updateColor($this) {
    var tmp0_safe_receiver = $this.cbr_1;
    var color = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.cb0();
    setColor($this.tbq_1.style, color);
  }
  function updateBold($this) {
    var fontWeight = $this.dbr_1.q96_1 ? CssFontWeight_BOLD_getInstance() : CssFontWeight_NORMAL_getInstance();
    setFontWeight($this.tbq_1.style, fontWeight);
  }
  function updateItalic($this) {
    var fontStyle = $this.dbr_1.r96_1 ? CssFontStyle_ITALIC_getInstance() : CssFontStyle_NORMAL_getInstance();
    setFontStyle_0($this.tbq_1.style, fontStyle);
  }
  function updateText($this) {
    removeAllChildren($this.ubq_1);
    var text = $this.zbq_1;
    // Inline function 'kotlin.text.isNullOrEmpty' call
    if (text == null || charSequenceLength(text) === 0) {
      var textNode = DomApi_instance.s8f('');
      insertFirst($this.ubq_1, textNode);
      setWidth($this.tbq_1.style, 1);
      setHeight($this.tbq_1.style, numberToInt(_get_cachedOrEstimatedLineHeight__5rm6fz($this)));
    } else {
      setTextValue($this, text);
      clearHeight($this.tbq_1.style);
      clearWidth($this.tbq_1.style);
    }
  }
  function setTextValue($this, text) {
    var textStyleRegions = $this.abr_1;
    // Inline function 'kotlin.collections.isNullOrEmpty' call
    if (textStyleRegions == null || textStyleRegions.s()) {
      var textNode = DomApi_instance.s8f(TextMetricsCalculator_getInstance().rbw(text));
      insertFirst($this.ubq_1, textNode);
    } else {
      var currentPosition = 0;
      var _iterator__ex2g4s = textStyleRegions.m();
      while (_iterator__ex2g4s.n()) {
        var region = _iterator__ex2g4s.o();
        var start = region.sbw_1;
        var defaultColorText = substring(text, currentPosition, start);
        // Inline function 'kotlin.text.isNotEmpty' call
        if (charSequenceLength(defaultColorText) > 0) {
          $this.ubq_1.appendChild(DomApi_instance.s8f(TextMetricsCalculator_getInstance().rbw(defaultColorText)));
        }
        var end = region.tbw_1;
        var regionText = substring(text, start, end);
        // Inline function 'kotlin.text.isNotEmpty' call
        if (charSequenceLength(regionText) > 0) {
          var regionSpan = cast_0(DomApi_instance.o8f());
          setColor(regionSpan.style, region.ubw_1.cb0());
          if (region.vbw_1) {
            setFontWeight(regionSpan.style, CssFontWeight_BOLD_getInstance());
          }
          regionSpan.appendChild(DomApi_instance.s8f(TextMetricsCalculator_getInstance().rbw(regionText)));
          $this.ubq_1.appendChild(regionSpan);
        }
        currentPosition = end;
      }
      var lastDefaultColorText = substring_0(text, currentPosition);
      // Inline function 'kotlin.text.isNotEmpty' call
      if (charSequenceLength(lastDefaultColorText) > 0) {
        $this.ubq_1.appendChild(DomApi_instance.s8f(TextMetricsCalculator_getInstance().rbw(lastDefaultColorText)));
      }
    }
  }
  function updateFontFamily($this) {
    setFontFamily($this.tbq_1.style, $this.dbr_1.o96_1.toString());
  }
  function updateFontSize($this) {
    setFontSize($this.tbq_1.style, $this.dbr_1.p96_1);
  }
  function containsChinese($this, prefix) {
    // Inline function 'kotlin.text.toRegex' call
    var this_0 = '.*[\u3400-\u9FBF]+.*';
    // Inline function 'kotlin.text.matches' call
    return Regex_init_$Create$(this_0).ad(prefix);
  }
  function clearTextDecorations($this) {
    if (!($this.hbr_1 == null)) {
      var _iterator__ex2g4s = ensureNotNull($this.hbr_1).m();
      while (_iterator__ex2g4s.n()) {
        var decoration = _iterator__ex2g4s.o();
        removeFromParent(decoration);
      }
      $this.hbr_1 = null;
    }
  }
  function addBackgroundHighlight($this, color, startPos, endPos) {
    ensureTextDecorationsInited($this);
    var overlay = DomApi_instance.m8f();
    var style = overlay.style;
    setBackgroundColor(style, color.cb0());
    applyAbsoluteStyle($this, style, startPos, endPos);
    $this.tbq_1.appendChild(overlay);
    ensureNotNull($this.hbr_1).j(overlay);
  }
  function addRedUnderline($this, from, to) {
    ensureTextDecorationsInited($this);
    var div = DomApi_instance.m8f();
    addClassName(div, Companion_getInstance_230().nbw_1.qbf_1);
    var style = div.style;
    applyAbsoluteStyle($this, style, from, to);
    $this.tbq_1.appendChild(div);
    ensureNotNull($this.hbr_1).j(div);
  }
  function applyAbsoluteStyle($this, style, from, to) {
    setPosition(style, CssPosition_ABSOLUTE_getInstance());
    setTop(style, 0.0);
    setZIndex(style, -1);
    setHeight(style, numberToInt(_get_lineHeight__binsk0($this)));
    var startOffset = $this.z96(from);
    var endOffset = $this.z96(to);
    setLeft(style, startOffset);
    setWidth(style, numberToInt(endOffset - startOffset));
  }
  function ensureTextDecorationsInited($this) {
    if ($this.hbr_1 == null) {
      $this.hbr_1 = ArrayList_init_$Create$_0(1);
    }
  }
  function Companion_230() {
    Companion_instance_230 = this;
    this.nbw_1 = Companion_getInstance_219().n26();
    this.obw_1 = new ListMap();
  }
  var Companion_instance_230;
  function Companion_getInstance_230() {
    if (Companion_instance_230 == null)
      new Companion_230();
    return Companion_instance_230;
  }
  function DomTextEditor(root) {
    Companion_getInstance_230();
    this.tbq_1 = root;
    this.ubq_1 = DomApi_instance.m8f();
    this.vbq_1 = 0;
    this.wbq_1 = 0;
    this.xbq_1 = 0;
    this.ybq_1 = false;
    this.zbq_1 = null;
    this.abr_1 = null;
    this.bbr_1 = false;
    this.cbr_1 = null;
    this.dbr_1 = DomUtil_getInstance_0().abj_1;
    this.ebr_1 = DomUtil_getInstance_0().bbj_1;
    this.fbr_1 = null;
    this.gbr_1 = null;
    this.hbr_1 = null;
    insertFirst(this.tbq_1, this.ubq_1);
    var rootStyle = this.tbq_1.style;
    setPosition(rootStyle, CssPosition_RELATIVE_getInstance());
    setWhiteSpace(rootStyle, CssWhiteSpace_NOWRAP_getInstance());
    updateTextAppearance(this);
    updateCaretVisibility_0(this);
    updateCaretBounds(this);
    updateSelectionVisibility(this);
    updateSelectionBoundsAndText(this);
  }
  protoOf(DomTextEditor).wbt = function (caretPosition) {
    if (this.vbq_1 === caretPosition)
      return Unit_instance;
    this.vbq_1 = caretPosition;
    updateCaretBounds(this);
    if (this.ybq_1) {
      updateSelectionBoundsAndText(this);
    }
    if (!(this.fbr_1 == null)) {
      showCaret(this, ensureNotNull(this.fbr_1).style);
    }
  };
  protoOf(DomTextEditor).dbu = function (selectionStart) {
    if (this.wbq_1 === selectionStart)
      return Unit_instance;
    this.wbq_1 = selectionStart;
    updateSelectionBoundsAndText(this);
  };
  protoOf(DomTextEditor).cbu = function (visible) {
    if (this.ybq_1 === visible)
      return Unit_instance;
    this.ybq_1 = visible;
    updateSelectionVisibility(this);
    updateSelectionBoundsAndText(this);
  };
  protoOf(DomTextEditor).qbt = function (caretVisible) {
    if (this.bbr_1 === caretVisible)
      return Unit_instance;
    this.bbr_1 = caretVisible;
    updateCaretVisibility_0(this);
    updateCaretBounds(this);
  };
  protoOf(DomTextEditor).xbt = function (textColor) {
    if (equals(textColor, this.cbr_1))
      return Unit_instance;
    this.cbr_1 = textColor;
    updateColor(this);
  };
  protoOf(DomTextEditor).ibr = function (text) {
    if (text == this.zbq_1)
      return Unit_instance;
    doSetText(this, text);
  };
  protoOf(DomTextEditor).o8w = function () {
    return this.zbq_1;
  };
  protoOf(DomTextEditor).ybt = function (bold) {
    if (this.dbr_1.q96_1 === bold)
      return Unit_instance;
    this.dbr_1 = new Font(this.dbr_1.o96_1, this.dbr_1.p96_1, bold, this.dbr_1.r96_1);
    updateFontMetrics(this);
    updateBold(this);
  };
  protoOf(DomTextEditor).zbt = function (italic) {
    if (this.dbr_1.r96_1 === italic)
      return Unit_instance;
    this.dbr_1 = new Font(this.dbr_1.o96_1, this.dbr_1.p96_1, this.dbr_1.q96_1, italic);
    updateFontMetrics(this);
    updateItalic(this);
  };
  protoOf(DomTextEditor).abu = function (origin) {
    var family = updateIfMonospaced(this, origin);
    if (equals(this.dbr_1.o96_1, family))
      return Unit_instance;
    this.dbr_1 = new Font(family, this.dbr_1.p96_1, this.dbr_1.q96_1, this.dbr_1.r96_1);
    updateFontMetrics(this);
    updateFontFamily(this);
    updateCaretBounds(this);
  };
  protoOf(DomTextEditor).bbu = function (size) {
    if (this.dbr_1.p96_1 === size)
      return Unit_instance;
    this.dbr_1 = new Font(this.dbr_1.o96_1, size, this.dbr_1.q96_1, this.dbr_1.r96_1);
    updateFontMetrics(this);
    updateFontSize(this);
    updateText(this);
    updateCaretBounds(this);
    updateSelectionVisibility(this);
    updateSelectionBoundsAndText(this);
  };
  protoOf(DomTextEditor).vbt = function (text, textStyleRegions) {
    if (text === this.zbq_1 && equals(this.abr_1, textStyleRegions))
      return Unit_instance;
    this.abr_1 = textStyleRegions;
    doSetText(this, text);
  };
  protoOf(DomTextEditor).ebu = function (end) {
    if (this.xbq_1 === end)
      return Unit_instance;
    this.xbq_1 = end;
    updateSelectionBoundsAndText(this);
  };
  protoOf(DomTextEditor).z96 = function (caretOffset) {
    if (caretOffset === 0 || this.zbq_1 == null)
      return 0.0;
    var tmp;
    if (_get_isCurrentFontMonospaced__wrvp72(this)) {
      var prefix = substring(ensureNotNull(this.zbq_1), 0, caretOffset);
      var tmp_0;
      if (containsChinese(this, prefix)) {
        tmp_0 = TextMetricsCalculator_getInstance().pbw(this.dbr_1, prefix);
      } else {
        tmp_0 = caretOffset * this.ebr_1.vbe().q8b_1;
      }
      tmp = tmp_0;
    } else {
      tmp = TextMetricsCalculator_getInstance().pbw(this.dbr_1, substring(ensureNotNull(this.zbq_1), 0, caretOffset));
    }
    return tmp;
  };
  protoOf(DomTextEditor).ubt = function (caretOffset) {
    if (caretOffset <= 0)
      return 0;
    var text = this.zbq_1;
    // Inline function 'kotlin.text.isNullOrEmpty' call
    if (text == null || charSequenceLength(text) === 0)
      return 0;
    if (_get_isCurrentFontMonospaced__wrvp72(this)) {
      var charWidth = _get_charWidth__5ojr27(this);
      var pos = caretOffset / charWidth;
      var tail = caretOffset % charWidth;
      if (tail > charWidth / 2) {
        pos = pos + 1.0;
      }
      var len = text.length;
      return pos > len ? len : numberToInt(pos);
    }
    var inductionVariable = 0;
    var last = text.length;
    if (inductionVariable <= last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (TextMetricsCalculator_getInstance().pbw(this.dbr_1, take_1(text, i)) >= caretOffset)
          return i;
      }
       while (!(i === last));
    return text.length;
  };
  protoOf(DomTextEditor).fbu = function (textDecorations) {
    clearTextDecorations(this);
    if (this.zbq_1 == null)
      return Unit_instance;
    var _iterator__ex2g4s = TextDecorations_getInstance().j8t(textDecorations).m();
    while (_iterator__ex2g4s.n()) {
      var current = _iterator__ex2g4s.o();
      var range = TextDecorations_getInstance().k8t(current, ensureNotNull(this.zbq_1).length);
      if (!range.s()) {
        var lowerEndpoint = range.v36_1;
        var upperEndpoint = range.f37();
        if (current instanceof BackgroundHighlightTextDecoration) {
          addBackgroundHighlight(this, current.e8t_1, lowerEndpoint, upperEndpoint);
        } else {
          if (current instanceof RedUnderlineTextDecoration) {
            addRedUnderline(this, lowerEndpoint, upperEndpoint);
          } else {
            throw IllegalArgumentException_init_$Create$_0('Unknown decoration kind: ' + toString_1(getKClassFromExpression(current)));
          }
        }
      }
    }
  };
  protoOf(DomTextEditor).sbt = function () {
    if (this.fbr_1 == null)
      return Unit_instance;
    var style = ensureNotNull(this.fbr_1).style;
    // Inline function 'kotlin.text.isEmpty' call
    var this_0 = style.borderLeft;
    if (charSequenceLength(this_0) === 0) {
      showCaret(this, style);
    } else {
      hideCaret(this, style);
    }
  };
  function visiblePart($this, ctx, relativeRect) {
    var currentContext = ctx;
    var currentAbsoluteRect = relativeRect.i8c(new Vector(numberToInt(getAbsoluteLeft(currentContext)), numberToInt(getAbsoluteTop(currentContext))));
    while (true) {
      var offsetParent = currentContext.offsetParent;
      if (offsetParent == null) {
        var windowBounds = $this.wbw();
        var tmp;
        if (!windowBounds.p8c(currentAbsoluteRect)) {
          tmp = null;
        } else {
          tmp = windowBounds.q8c(currentAbsoluteRect);
        }
        return tmp;
      }
      var tmp_0;
      if (Scrolling_instance.xbw(currentContext)) {
        tmp_0 = getAbsoluteClientAreaBounds($this, currentContext);
      } else {
        tmp_0 = $this.cbj(currentContext);
      }
      var ctxBounds = tmp_0;
      if (!ctxBounds.p8c(currentAbsoluteRect)) {
        return null;
      }
      currentAbsoluteRect = ctxBounds.q8c(currentAbsoluteRect);
      currentContext = cast_0(offsetParent);
    }
  }
  function getAbsoluteClientAreaBounds($this, element) {
    var absoluteOrigin = getAbsoluteOrigin($this, element);
    var offsetDimension = getOffsetDimension($this, element);
    var clientDimension = getClientDimension($this, element);
    if (offsetDimension.equals(clientDimension)) {
      return new Rectangle(absoluteOrigin, offsetDimension);
    }
    var clientAreaOffset = new Vector($this.mbt(element), $this.obt(element));
    return new Rectangle(absoluteOrigin.i8c(clientAreaOffset), clientDimension);
  }
  function getAbsoluteOrigin($this, element) {
    return new Vector(numberToInt(getAbsoluteLeft(element)), numberToInt(getAbsoluteTop(element)));
  }
  function getOffsetDimension($this, element) {
    return new Vector(element.offsetWidth, element.offsetHeight);
  }
  function getScrollDimension($this, element) {
    return new Vector(element.scrollWidth, element.scrollHeight);
  }
  function getClientDimension($this, element) {
    return new Vector(element.clientWidth, element.clientHeight);
  }
  function getLeftPadding($this, element) {
    return getPixelsProperty($this, element, 'padding-left');
  }
  function getTopPadding($this, element) {
    return getPixelsProperty($this, element, 'padding-top');
  }
  function getPixelsProperty($this, element, property) {
    var value = getProperty(DomApi_instance.l8f().getComputedStyle(element), property);
    if (!endsWith(value, 'px')) {
      $this.ybi_1.c2q(DomUtil$getPixelsProperty$lambda(value));
      return 0;
    }
    var tmp;
    try {
      // Inline function 'kotlin.text.toFloat' call
      var this_0 = replace(value, 'px', '');
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var subpixelValue = toDouble(this_0);
      // Inline function 'kotlin.math.roundToInt' call
      tmp = roundToInt(subpixelValue);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof NumberFormatException) {
        var e = $p;
        ThrowableHandlers_getInstance().k2r_1.j2r(e);
        tmp_0 = 0;
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  function getValueMessage($this, value) {
    return 'Bad value: ' + value;
  }
  function DomUtil$LOG$lambda() {
    return Unit_instance;
  }
  function DomUtil$getPixelsProperty$lambda($value) {
    return function () {
      return getValueMessage(DomUtil_getInstance_0(), $value);
    };
  }
  function DomUtil$scheduleDeferred$lambda($cancelled, $runnable) {
    return function () {
      var tmp;
      if (!$cancelled._v) {
        tmp = $runnable();
      }
      return Unit_instance;
    };
  }
  function DomUtil$scheduleDeferred$$inlined$toDisposable$1($cancelled) {
    this.ybw_1 = $cancelled;
  }
  protoOf(DomUtil$scheduleDeferred$$inlined$toDisposable$1).zr = function () {
    this.ybw_1._v = true;
    return Unit_instance;
  };
  function DomUtil_0() {
    DomUtil_instance_0 = this;
    var tmp = this;
    var tmp_0 = KotlinLogging_getInstance();
    tmp.ybi_1 = tmp_0.i2q(DomUtil$LOG$lambda);
    this.zbi_1 = Companion_getInstance_211().h9z("Menlo, Consolas, Monaco, 'Courier New', monospace");
    this.abj_1 = new Font(this.zbi_1, 14);
    this.bbj_1 = TextMetricsCalculator_getInstance().qbw(this.abj_1);
  }
  protoOf(DomUtil_0).wbw = function () {
    return new Rectangle(Companion_getInstance_136().h8c_1, new Vector(this.jbs(), this.kbs()));
  };
  protoOf(DomUtil_0).jbs = function () {
    return ensureNotNull(DomApi_instance.k8f().documentElement).clientWidth;
  };
  protoOf(DomUtil_0).kbs = function () {
    return ensureNotNull(DomApi_instance.k8f().documentElement).clientHeight;
  };
  protoOf(DomUtil_0).bbm = function (ctx) {
    var htmlElement = cast_0(ctx);
    return visiblePart(this, htmlElement, new Rectangle(Companion_getInstance_136().h8c_1, new Vector(ctx.scrollWidth, ctx.scrollHeight)));
  };
  protoOf(DomUtil_0).zbj = function (ctx) {
    return new Vector(getLeftPadding(this, ctx), getTopPadding(this, ctx));
  };
  protoOf(DomUtil_0).dbj = function (element) {
    return new Rectangle(getAbsoluteOrigin(this, element), getOffsetDimension(this, element));
  };
  protoOf(DomUtil_0).cbj = function (element) {
    return new Rectangle(getAbsoluteOrigin(this, element), getScrollDimension(this, element));
  };
  protoOf(DomUtil_0).mbt = function (element) {
    return getPixelsProperty(this, element, 'border-left-width');
  };
  protoOf(DomUtil_0).nbt = function (element) {
    return getPixelsProperty(this, element, 'border-right-width');
  };
  protoOf(DomUtil_0).obt = function (element) {
    return getPixelsProperty(this, element, 'border-top-width');
  };
  protoOf(DomUtil_0).pbt = function (element) {
    return getPixelsProperty(this, element, 'border-bottom-width');
  };
  protoOf(DomUtil_0).jbm = function (runnable) {
    var cancelled = {_v: false};
    var tmp = Companion_getInstance_39().k3a_1;
    tmp.l3a(DomUtil$scheduleDeferred$lambda(cancelled, runnable));
    // Inline function 'jetbrains.ocelot.base.disposable.toDisposable' call
    return new DomUtil$scheduleDeferred$$inlined$toDisposable$1(cancelled);
  };
  var DomUtil_instance_0;
  function DomUtil_getInstance_0() {
    if (DomUtil_instance_0 == null)
      new DomUtil_0();
    return DomUtil_instance_0;
  }
  function _get_withDefault__8or87q($this, _this__u8e3s4) {
    return _this__u8e3s4 == null ? CssOverflow_AUTO_getInstance() : _this__u8e3s4;
  }
  function isOverflowScrollOrAuto($this, overflow) {
    return overflow === CssOverflow_AUTO_getInstance() || overflow === CssOverflow_SCROLL_getInstance();
  }
  function trimToElement($this, rect, elem) {
    return rect.q8c(Rectangle_init_$Create$(0, 0, elem.scrollWidth, elem.scrollHeight));
  }
  function adjustScrollers($this, target, element) {
    var targetAbs = target.i8c(getAbsoluteLeftTop($this, element));
    var parent = element.parentElement;
    $l$loop: while (!(parent == null)) {
      if (!$this.xbw(parent)) {
        parent = parent.parentElement;
        continue $l$loop;
      }
      var scrollTop = parent.scrollTop;
      var parentTop = getAbsoluteTop(parent);
      var parentHeight = parent.clientHeight;
      var scrollLeft = parent.scrollLeft;
      var parentLeft = getAbsoluteLeft(parent);
      var parentWidth = parent.clientWidth;
      var visX = Companion_instance_37.x36(numberToInt(parentLeft), parentWidth);
      var targetX = targetAbs.t8c();
      var deltaX = getDelta_0($this, visX, targetX);
      if (!(deltaX === 0)) {
        parent.scrollLeft = scrollLeft + deltaX;
        var delta = new Vector(deltaX, 0);
        targetAbs = targetAbs.j8c(delta);
      }
      var visY = Companion_instance_37.x36(numberToInt(parentTop), parentHeight);
      var targetY = targetAbs.u8c();
      var deltaY = getDelta_0($this, visY, targetY);
      if (!(deltaY === 0)) {
        parent.scrollTop = scrollTop + deltaY;
        var delta_0 = new Vector(0, deltaY);
        targetAbs = targetAbs.j8c(delta_0);
      }
      parent = parent.parentElement;
    }
  }
  function getAbsoluteLeftTop($this, element) {
    return new Vector(numberToInt(getAbsoluteLeft(element)), numberToInt(getAbsoluteTop(element)));
  }
  function scrollWindow($this, winBounds, targetBounds) {
    if (winBounds.k8c(targetBounds)) {
      return Unit_instance;
    }
    var tmp = KProperty1;
    var deltaX = getDelta($this, winBounds, targetBounds, getPropertyCallableRef('x', 1, tmp, Vector$_get_x_$ref_75496h(), null));
    var tmp_0 = KProperty1;
    var deltaY = getDelta($this, winBounds, targetBounds, getPropertyCallableRef('y', 1, tmp_0, Vector$_get_y_$ref_6o2msa(), null));
    if (deltaX === 0 && deltaY === 0) {
      return Unit_instance;
    }
    var window_0 = DomApi_instance.l8f();
    window_0.scrollTo(window_0.scrollX + deltaX, window_0.scrollY + deltaY);
  }
  function getDelta($this, a, b, getDim) {
    var aInterval = getInterval($this, a, getDim);
    var bInterval = getInterval($this, b, getDim);
    return getDelta_0($this, aInterval, bInterval);
  }
  function getInterval($this, rectangle, getDim) {
    return Companion_instance_37.x36(getDim(rectangle.b8c_1), getDim(rectangle.c8c_1));
  }
  function getDelta_0($this, vis, target) {
    if (vis.a() < target.a()) {
      var tmp;
      if (vis.k37(target)) {
        tmp = 0;
      } else {
        tmp = target.v36_1 - vis.v36_1 | 0;
      }
      return tmp;
    }
    if (target.v36_1 < vis.v36_1) {
      return target.v36_1 - vis.v36_1 | 0;
    }
    var tmp_0;
    if (target.w36_1 > vis.w36_1) {
      tmp_0 = target.w36_1 - vis.w36_1 | 0;
    } else {
      tmp_0 = 0;
    }
    return tmp_0;
  }
  function Vector$_get_x_$ref_75496h() {
    return function (p0) {
      return p0.d8c_1;
    };
  }
  function Vector$_get_y_$ref_6o2msa() {
    return function (p0) {
      return p0.e8c_1;
    };
  }
  function Scrolling() {
  }
  protoOf(Scrolling).vbm = function () {
    var window_0 = DomApi_instance.l8f();
    return Rectangle_init_$Create$(numberToInt(window_0.scrollX), numberToInt(window_0.scrollY), DomUtil_getInstance_0().jbs(), DomUtil_getInstance_0().kbs());
  };
  protoOf(Scrolling).lbi = function (element) {
    return DomUtil_getInstance_0().cbj(element);
  };
  protoOf(Scrolling).xbw = function (element) {
    var style = DomApi_instance.l8f().getComputedStyle(element);
    return isOverflowScrollOrAuto(this, _get_withDefault__8or87q(this, get_cssOverflow(style))) || isOverflowScrollOrAuto(this, _get_withDefault__8or87q(this, get_cssOverflowX(style))) || isOverflowScrollOrAuto(this, _get_withDefault__8or87q(this, get_cssOverflowY(style)));
  };
  protoOf(Scrolling).ybj = function (rawTarget, element) {
    var target = trimToElement(this, rawTarget, element);
    adjustScrollers(this, target, element);
    var winAbsBounds = DomUtil_getInstance_0().wbw();
    var elementAbsBounds = this.lbi(element);
    var targetAbsBounds = target.i8c(elementAbsBounds.b8c_1);
    scrollWindow(this, winAbsBounds, targetAbsBounds);
  };
  var Scrolling_instance;
  function Scrolling_getInstance() {
    return Scrolling_instance;
  }
  function _get_isFirefox__qyvnc2($this) {
    // Inline function 'kotlin.text.lowercase' call
    // Inline function 'kotlin.js.asDynamic' call
    var agent = DomApi_instance.l8f().navigator.userAgent.toLowerCase();
    return contains_8(agent, 'firefox');
  }
  function calculateDimension($this, font, text) {
    return new DoubleVector($this.pbw(font, text), adjustHeight($this, font.p96_1));
  }
  function calculateWidthByCanvas($this, font, text) {
    var canvas_0 = canvas($this);
    var ctx = get_context2d(canvas_0);
    ctx.font = getFontString($this, font);
    return ctx.measureText($this.rbw(text)).width;
  }
  function calculateWidthByElement($this, font, text) {
    var span = cast_0(DomApi_instance.o8f());
    var style = span.style;
    setDisplay(style, CssDisplay_INLINE_BLOCK_getInstance());
    setVisibility(style, CssVisibility_HIDDEN_getInstance());
    setFont(style, getFontString($this, font));
    span.innerText = text;
    ensureNotNull(DomApi_instance.k8f().body).appendChild(span);
    var width = span.getBoundingClientRect().width;
    removeFromParent(span);
    return width;
  }
  function adjustHeight($this, height) {
    return _get_isFirefox__qyvnc2($this) ? height + 1 | 0 : height;
  }
  function fontBaseLine($this, font) {
    var allCharsHeight = measureHeight($this, font, $this.sbe_1);
    var ascent = measureHeight($this, font, 'A');
    var lineSpace = font.p96_1 - allCharsHeight | 0;
    return (lineSpace / 2 | 0) + ascent | 0;
  }
  function measureHeight($this, font, text) {
    var canvas_0 = canvas($this);
    var ctx = get_context2d(canvas_0);
    ctx.font = getFontString($this, font);
    ctx.fillStyle = 'rgb(255, 0, 0)';
    var width = ctx.measureText(text).width;
    var canvasHeight = imul(font.p96_1, 2);
    canvas_0.height = canvasHeight;
    canvas_0.height = imul(font.p96_1, 2);
    canvas_0.width = numberToInt(width);
    ctx.fillText(text, 0.0, font.p96_1);
    var imageData = ctx.getImageData(0.0, 0.0, width, canvasHeight);
    var imageDataArray = imageData.data;
    var firstY = canvasHeight - 1 | 0;
    var lastY = 0;
    var inductionVariable = 0;
    var last = numberToInt(width);
    if (inductionVariable < last)
      do {
        var x = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < canvasHeight)
          do {
            var y = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            // Inline function 'org.khronos.webgl.get' call
            // Inline function 'kotlin.js.asDynamic' call
            var red = imageDataArray[imul(4, x + imul(y, imageData.width) | 0)];
            if (!(red === 0)) {
              if (firstY > y) {
                firstY = y;
              }
              if (lastY < y) {
                lastY = y;
              }
            }
          }
           while (inductionVariable_0 < canvasHeight);
      }
       while (inductionVariable < last);
    return lastY - firstY | 0;
  }
  function getFontString($this, font) {
    var result = StringBuilder_init_$Create$_1();
    if (font.q96_1) {
      result.j8(' bold');
    }
    if (font.r96_1) {
      result.j8(' italic');
    }
    result.k8(_Char___init__impl__6a9atx(32)).gc(font.p96_1).j8('px ').i8(font.o96_1);
    return result.toString();
  }
  function canvas($this) {
    return DomApi_instance.p8f();
  }
  function TextMetricsCalculator$calculateApprox$1($dimension, $font) {
    this.zbw_1 = $dimension;
    this.abx_1 = $font;
  }
  protoOf(TextMetricsCalculator$calculateApprox$1).vbe = function () {
    return this.zbw_1;
  };
  protoOf(TextMetricsCalculator$calculateApprox$1).bbx = function () {
    return imul(2, this.abx_1.p96_1) / 3 | 0;
  };
  function TextMetricsCalculator$calculate$1($dimension, $baseLine) {
    this.cbx_1 = $dimension;
    this.dbx_1 = $baseLine;
  }
  protoOf(TextMetricsCalculator$calculate$1).vbe = function () {
    return this.cbx_1;
  };
  protoOf(TextMetricsCalculator$calculate$1).bbx = function () {
    return this.dbx_1;
  };
  function TextMetricsCalculator() {
    TextMetricsCalculator_instance = this;
    this.qbe_1 = 'x';
    this.rbe_1 = 4;
    this.sbe_1 = Char__rangeTo_impl_tkncvp(_Char___init__impl__6a9atx(97), _Char___init__impl__6a9atx(122)).toString() + Char__rangeTo_impl_tkncvp(_Char___init__impl__6a9atx(65), _Char___init__impl__6a9atx(90)).toString();
    this.tbe_1 = HashMap_init_$Create$();
  }
  protoOf(TextMetricsCalculator).qbw = function (font) {
    // Inline function 'kotlin.collections.getOrPut' call
    var this_0 = this.tbe_1;
    var value = this_0.q2(font);
    var tmp;
    if (value == null) {
      var answer = TextMetricsCalculator_getInstance().ube(font, 'x');
      this_0.t2(font, answer);
      tmp = answer;
    } else {
      tmp = value;
    }
    return tmp;
  };
  protoOf(TextMetricsCalculator).ebx = function (font, text) {
    var dimension = calculateDimension(this, font, text);
    return new TextMetricsCalculator$calculateApprox$1(dimension, font);
  };
  protoOf(TextMetricsCalculator).ube = function (font, text) {
    var dimension = calculateDimension(this, font, text);
    var baseLine = fontBaseLine(this, font);
    return new TextMetricsCalculator$calculate$1(dimension, baseLine);
  };
  protoOf(TextMetricsCalculator).pbw = function (font, text) {
    return _get_isFirefox__qyvnc2(this) ? calculateWidthByElement(this, font, text) : calculateWidthByCanvas(this, font, text);
  };
  protoOf(TextMetricsCalculator).rbw = function (text) {
    // Inline function 'kotlin.text.toRegex' call
    // Inline function 'kotlin.text.replace' call
    return Regex_init_$Create$(' ').fd(text, '\xA0');
  };
  var TextMetricsCalculator_instance;
  function TextMetricsCalculator_getInstance() {
    if (TextMetricsCalculator_instance == null)
      new TextMetricsCalculator();
    return TextMetricsCalculator_instance;
  }
  function DomView() {
  }
  function BaseViewMapper$registerSynchronizers$o$doAttach$lambda($valid, $positionInParent, this$0, $targetStyle) {
    return function () {
      var tmp;
      if ($valid._v) {
        return Unit_instance;
      }
      var _destruct__k2r9zo = $positionInParent.uv();
      var origin = _destruct__k2r9zo.fg();
      var dimension = _destruct__k2r9zo.gg();
      var tmp_0;
      if (!_get_isDomPosition__rgfrao(this$0)) {
        setLeft($targetStyle, origin.d8c_1);
        setTop($targetStyle, origin.e8c_1);
        tmp_0 = Unit_instance;
      }
      var tmp_1;
      if (!this$0.obx()) {
        var width = dimension.d8c_1;
        var height = dimension.e8c_1;
        setWidth($targetStyle, width);
        setHeight($targetStyle, height);
        tmp_1 = Unit_instance;
      }
      $valid._v = true;
      return Unit_instance;
    };
  }
  function BaseViewMapper$registerSynchronizers$o$doAttach$lambda$lambda($valid, $positionInParent, this$0, $targetStyle) {
    return function () {
      var tmp;
      if ($valid._v) {
        return Unit_instance;
      }
      var _destruct__k2r9zo = $positionInParent.uv();
      var origin = _destruct__k2r9zo.fg();
      var dimension = _destruct__k2r9zo.gg();
      var tmp_0;
      if (!_get_isDomPosition__rgfrao(this$0)) {
        setLeft($targetStyle, origin.d8c_1);
        setTop($targetStyle, origin.e8c_1);
        tmp_0 = Unit_instance;
      }
      var tmp_1;
      if (!this$0.obx()) {
        var width = dimension.d8c_1;
        var height = dimension.e8c_1;
        setWidth($targetStyle, width);
        setHeight($targetStyle, height);
        tmp_1 = Unit_instance;
      }
      $valid._v = true;
      return Unit_instance;
    };
  }
  function BaseViewMapper$registerSynchronizers$o$doAttach$lambda_0($valid, this$0, $positionInParent, $targetStyle) {
    return function (it) {
      $valid._v = false;
      this$0.pbx(BaseViewMapper$registerSynchronizers$o$doAttach$lambda$lambda($valid, $positionInParent, this$0, $targetStyle));
      return Unit_instance;
    };
  }
  function BaseViewMapper$registerSynchronizers$o$doAttach$lambda_1(this$0, $targetStyle) {
    return function (it) {
      var border = this$0.e86_1.ab2().w2w();
      if (border == null) {
        clearOutlineStyle($targetStyle);
        clearOutlineColor($targetStyle);
        clearBorderWidth($targetStyle);
      } else {
        setOutlineColor($targetStyle, border.cb0());
        setOutlineWidth($targetStyle, this$0.e86_1.bb2().w2w());
        setOutlineStyle($targetStyle, CssOutlineStyle_SOLID_getInstance());
      }
      return Unit_instance;
    };
  }
  function BaseViewMapper$registerSynchronizers$o$set$lambda($targetStyle, $value) {
    return function () {
      setDisplay($targetStyle, $value ? CssDisplay_BLOCK_getInstance() : CssDisplay_NONE_getInstance());
      return Unit_instance;
    };
  }
  function _get_isDomPosition__rgfrao($this) {
    var tmp = $this.j86_1;
    var tmp0_safe_receiver = tmp instanceof BaseViewMapper ? tmp : null;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.obx();
    return tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
  }
  function BaseViewMapper$whenValid$lambda(this$0, $r, $disposable) {
    return function (it) {
      this$0.pbx($r);
      var tmp0_safe_receiver = $disposable._v;
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.zr();
      }
      return Unit_instance;
    };
  }
  function BaseViewMapper$registerSynchronizers$lambda(this$0, $it) {
    return function () {
      var sourceBounds = this$0.e86_1.ob2().w2w();
      var parentSourceBounds = $it.e86_1.ob2().w2w();
      return sourceBounds.j8c(parentSourceBounds.b8c_1);
    };
  }
  function BaseViewMapper$registerSynchronizers$$inlined$forEventSource$1($valid, this$0, $src, $positionInParent, $targetStyle) {
    this.rbx_1 = $valid;
    this.sbx_1 = this$0;
    this.tbx_1 = $src;
    this.ubx_1 = $positionInParent;
    this.vbx_1 = $targetStyle;
    DisposableSynchronizer.call(this);
  }
  protoOf(BaseViewMapper$registerSynchronizers$$inlined$forEventSource$1).s87 = function (ctx) {
    this.rbx_1._v = false;
    this.sbx_1.pbx(BaseViewMapper$registerSynchronizers$o$doAttach$lambda(this.rbx_1, this.ubx_1, this.sbx_1, this.vbx_1));
    return this.tbx_1.z2r(BaseViewMapper$registerSynchronizers$o$doAttach$lambda_0(this.rbx_1, this.sbx_1, this.ubx_1, this.vbx_1));
  };
  function BaseViewMapper$registerSynchronizers$$inlined$writableProperty$1($targetStyle) {
    this.wbx_1 = $targetStyle;
  }
  protoOf(BaseViewMapper$registerSynchronizers$$inlined$writableProperty$1).x9j = function (newValue) {
    var tmp1_safe_receiver = newValue == null ? null : newValue.cb0();
    var tmp;
    if (tmp1_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.also' call
      setBackgroundColor(this.wbx_1, tmp1_safe_receiver);
      tmp = tmp1_safe_receiver;
    }
    if (tmp == null)
      clearBackgroundColor(this.wbx_1);
    return Unit_instance;
  };
  protoOf(BaseViewMapper$registerSynchronizers$$inlined$writableProperty$1).d2x = function (newValue) {
    return this.x9j((newValue == null ? true : !(newValue == null)) ? newValue : THROW_CCE());
  };
  function BaseViewMapper$registerSynchronizers$$inlined$forEventSource$2(this$0, $targetStyle, $src) {
    this.ybx_1 = this$0;
    this.zbx_1 = $targetStyle;
    this.aby_1 = $src;
    DisposableSynchronizer.call(this);
  }
  protoOf(BaseViewMapper$registerSynchronizers$$inlined$forEventSource$2).s87 = function (ctx) {
    var border = this.ybx_1.e86_1.ab2().w2w();
    if (border == null) {
      clearOutlineStyle(this.zbx_1);
      clearOutlineColor(this.zbx_1);
      clearBorderWidth(this.zbx_1);
    } else {
      setOutlineColor(this.zbx_1, border.cb0());
      setOutlineWidth(this.zbx_1, this.ybx_1.e86_1.bb2().w2w());
      setOutlineStyle(this.zbx_1, CssOutlineStyle_SOLID_getInstance());
    }
    return this.aby_1.z2r(BaseViewMapper$registerSynchronizers$o$doAttach$lambda_1(this.ybx_1, this.zbx_1));
  };
  function BaseViewMapper$registerSynchronizers$$inlined$writableProperty$2(this$0, $targetStyle) {
    this.bby_1 = this$0;
    this.cby_1 = $targetStyle;
  }
  protoOf(BaseViewMapper$registerSynchronizers$$inlined$writableProperty$2).x9j = function (newValue) {
    this.bby_1.pbx(BaseViewMapper$registerSynchronizers$o$set$lambda(this.cby_1, newValue));
    return Unit_instance;
  };
  protoOf(BaseViewMapper$registerSynchronizers$$inlined$writableProperty$2).d2x = function (newValue) {
    return this.x9j((newValue == null ? true : !(newValue == null)) ? newValue : THROW_CCE());
  };
  function BaseViewMapper$registerSynchronizers$$inlined$writableProperty$3($targetStyle) {
    this.dby_1 = $targetStyle;
  }
  protoOf(BaseViewMapper$registerSynchronizers$$inlined$writableProperty$3).x9j = function (newValue) {
    if (newValue)
      setBoxShadow(this.dby_1, '2px 2px 4px black');
    else
      clearBoxShadow(this.dby_1);
    return Unit_instance;
  };
  protoOf(BaseViewMapper$registerSynchronizers$$inlined$writableProperty$3).d2x = function (newValue) {
    return this.x9j((newValue == null ? true : !(newValue == null)) ? newValue : THROW_CCE());
  };
  function BaseViewMapper(context, source, target) {
    Mapper.call(this, source, target);
    this.mbx_1 = context;
    this.nbx_1 = false;
    var tmp0_safe_receiver = source.ib1_1;
    if (source === (tmp0_safe_receiver == null ? null : tmp0_safe_receiver.dbe())) {
      setZIndex(target.style, 100);
    }
  }
  protoOf(BaseViewMapper).obx = function () {
    return this.nbx_1;
  };
  protoOf(BaseViewMapper).pbx = function (r) {
    var container = this.e86_1.ib1_1;
    if (container == null) {
      var disposable = {_v: null};
      var tmp = this.e86_1.ub2();
      disposable._v = tmp.z2r(BaseViewMapper$whenValid$lambda(this, r, disposable));
    } else {
      container.ebe(r);
    }
  };
  protoOf(BaseViewMapper).a88 = function (conf) {
    protoOf(Mapper).a88.call(this, conf);
    var targetStyle = this.f86_1.style;
    if (!_get_isDomPosition__rgfrao(this)) {
      setPosition(targetStyle, CssPosition_ABSOLUTE_getInstance());
    } else {
      setPosition(targetStyle, CssPosition_RELATIVE_getInstance());
    }
    if (!_get_isDomPosition__rgfrao(this) || !this.obx()) {
      var tmp = this.j86_1;
      var tmp0_safe_receiver = tmp instanceof BaseViewMapper ? tmp : null;
      var tmp_0;
      if (tmp0_safe_receiver == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlin.let' call
        tmp_0 = toDerivedProperty(BaseViewMapper$registerSynchronizers$lambda(this, tmp0_safe_receiver), [this.e86_1.ob2(), tmp0_safe_receiver.e86_1.ob2()]);
      }
      var tmp1_elvis_lhs = tmp_0;
      var positionInParent = tmp1_elvis_lhs == null ? this.e86_1.ob2() : tmp1_elvis_lhs;
      var valid = {_v: false};
      // Inline function 'jetbrains.ocelot.mapper.core.Synchronizers.forEventSource' call
      var src = EventSources_instance.x2v([positionInParent, this.e86_1.ab2(), this.e86_1.bb2()]);
      var tmp$ret$2 = new BaseViewMapper$registerSynchronizers$$inlined$forEventSource$1(valid, this, src, positionInParent, targetStyle);
      conf.h5v(tmp$ret$2);
    }
    var tmp_1 = this.e86_1.c9b();
    // Inline function 'jetbrains.ocelot.base.observable.property.writableProperty' call
    var tmp$ret$3 = new BaseViewMapper$registerSynchronizers$$inlined$writableProperty$1(targetStyle);
    conf.h5v(syncOneWay(tmp_1, tmp$ret$3));
    // Inline function 'jetbrains.ocelot.mapper.core.Synchronizers.forEventSource' call
    var src_0 = EventSources_instance.x2v([this.e86_1.ab2(), this.e86_1.bb2()]);
    var tmp$ret$4 = new BaseViewMapper$registerSynchronizers$$inlined$forEventSource$2(this, targetStyle, src_0);
    conf.h5v(tmp$ret$4);
    var tmp_2 = this.e86_1.m92();
    // Inline function 'jetbrains.ocelot.base.observable.property.writableProperty' call
    var tmp$ret$5 = new BaseViewMapper$registerSynchronizers$$inlined$writableProperty$2(this, targetStyle);
    conf.h5v(syncOneWay(tmp_2, tmp$ret$5));
    var tmp_3 = this.e86_1.cb2();
    // Inline function 'jetbrains.ocelot.base.observable.property.writableProperty' call
    var tmp$ret$6 = new BaseViewMapper$registerSynchronizers$$inlined$writableProperty$3(targetStyle);
    conf.h5v(syncOneWay(tmp_3, tmp$ret$6));
  };
  protoOf(BaseViewMapper).eby = function () {
    // Inline function 'kotlin.apply' call
    var this_0 = SvgUtil_instance.fby();
    setPosition(this_0.style, CssPosition_ABSOLUTE_getInstance());
    setLeft(this_0.style, 0);
    setTop(this_0.style, 0);
    return this_0;
  };
  function CompositeViewMapper(ctx, source, target) {
    BaseViewMapper.call(this, ctx, source, target);
  }
  protoOf(CompositeViewMapper).a88 = function (conf) {
    protoOf(BaseViewMapper).a88.call(this, conf);
    conf.h5v(Synchronizers_instance.c8b(this.e86_1.o35(), DomUtil_instance.q8d(this.f86_1), this.mbx_1.pby()));
  };
  function DomViewMapper$registerSynchronizers$o$doAttach$lambda($tmp4_forEventSource_this) {
    return function (it) {
      $tmp4_forEventSource_this.mb2();
      return Unit_instance;
    };
  }
  function DomUtil$dimension$ref(p0) {
    var l = function (_this__u8e3s4) {
      return p0.r8d(_this__u8e3s4);
    };
    l.callableName = 'dimension';
    return l;
  }
  function DomViewMapper$registerSynchronizers$$inlined$forEventSource$1($tmp4_forEventSource_this, $src) {
    this.rby_1 = $tmp4_forEventSource_this;
    this.sby_1 = $src;
    DisposableSynchronizer.call(this);
  }
  protoOf(DomViewMapper$registerSynchronizers$$inlined$forEventSource$1).s87 = function (ctx) {
    this.rby_1.mb2();
    return this.sby_1.z2r(DomViewMapper$registerSynchronizers$o$doAttach$lambda(this.rby_1));
  };
  function DomViewMapper$registerSynchronizers$$inlined$writableProperty$1(this$0) {
    this.tby_1 = this$0;
  }
  protoOf(DomViewMapper$registerSynchronizers$$inlined$writableProperty$1).x9j = function (newValue) {
    this.tby_1.f86_1.innerHTML = '';
    if (!(newValue == null)) {
      this.tby_1.f86_1.appendChild(newValue);
    }
    return Unit_instance;
  };
  protoOf(DomViewMapper$registerSynchronizers$$inlined$writableProperty$1).d2x = function (newValue) {
    return this.x9j((newValue == null ? true : !(newValue == null)) ? newValue : THROW_CCE());
  };
  function DomViewMapper$registerSynchronizers$$inlined$writableProperty$2(this$0) {
    this.uby_1 = this$0;
  }
  protoOf(DomViewMapper$registerSynchronizers$$inlined$writableProperty$2).x9j = function (newValue) {
    if (newValue) {
      var tmp0_safe_receiver = this.uby_1.e86_1.lbz_1.w2w();
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.focus();
      }
    }
    return Unit_instance;
  };
  protoOf(DomViewMapper$registerSynchronizers$$inlined$writableProperty$2).d2x = function (newValue) {
    return this.x9j((newValue == null ? true : !(newValue == null)) ? newValue : THROW_CCE());
  };
  function DomViewMapper(ctx, source) {
    BaseViewMapper.call(this, ctx, source, DomApi_instance.m8f());
  }
  protoOf(DomViewMapper).a88 = function (conf) {
    protoOf(BaseViewMapper).a88.call(this, conf);
    var tmp = Companion_getInstance_136().h8c_1;
    var bounds = select(this.e86_1.lbz_1, tmp, DomUtil$dimension$ref(DomUtil_instance));
    var tmp4_forEventSource_this = this.e86_1;
    // Inline function 'jetbrains.ocelot.mapper.core.Synchronizers.forEventSource' call
    var tmp$ret$0 = new DomViewMapper$registerSynchronizers$$inlined$forEventSource$1(tmp4_forEventSource_this, bounds);
    conf.h5v(tmp$ret$0);
    // Inline function 'jetbrains.ocelot.base.observable.property.writableProperty' call
    var tmp$ret$1 = new DomViewMapper$registerSynchronizers$$inlined$writableProperty$1(this);
    conf.h5v(syncOneWay(this.e86_1.lbz_1, tmp$ret$1));
    var tmp_0 = this.e86_1.yb1();
    // Inline function 'jetbrains.ocelot.base.observable.property.writableProperty' call
    var tmp$ret$2 = new DomViewMapper$registerSynchronizers$$inlined$writableProperty$2(this);
    conf.h5v(syncOneWay(tmp_0, tmp$ret$2));
  };
  function DomViewSynchronizers$boundsSynchronizer$$inlined$writableProperty$1($el) {
    this.vbz_1 = $el;
  }
  protoOf(DomViewSynchronizers$boundsSynchronizer$$inlined$writableProperty$1).x9j = function (newValue) {
    setWidth(this.vbz_1.style, newValue.c8c_1.d8c_1 + 1 | 0);
    setHeight(this.vbz_1.style, newValue.c8c_1.e8c_1 + 1 | 0);
    return Unit_instance;
  };
  protoOf(DomViewSynchronizers$boundsSynchronizer$$inlined$writableProperty$1).d2x = function (newValue) {
    return this.x9j((newValue == null ? true : !(newValue == null)) ? newValue : THROW_CCE());
  };
  function DomViewSynchronizers() {
  }
  protoOf(DomViewSynchronizers).wbz = function (view, el) {
    var tmp = view.ob2();
    // Inline function 'jetbrains.ocelot.base.observable.property.writableProperty' call
    var tmp$ret$0 = new DomViewSynchronizers$boundsSynchronizer$$inlined$writableProperty$1(el);
    return syncOneWay(tmp, tmp$ret$0);
  };
  var DomViewSynchronizers_instance;
  function DomViewSynchronizers_getInstance() {
    return DomViewSynchronizers_instance;
  }
  function HorizontalViewMapper$registerSynchronizers$lambda(this$0) {
    return function (source) {
      // Inline function 'kotlin.apply' call
      var this_0 = this$0.mbx_1.pby()(source);
      setFloat(this_0.f86_1.style, CssFloat_LEFT_getInstance());
      return this_0;
    };
  }
  function HorizontalViewMapper(ctx, source) {
    BaseViewMapper.call(this, ctx, source, DomApi_instance.m8f());
    this.gc0_1 = true;
    this.hc0_1 = DomApi_instance.m8f();
    this.f86_1.appendChild(this.hc0_1);
    var clear = DomApi_instance.m8f();
    setClear(clear.style, CssClear_BOTH_getInstance());
    this.f86_1.appendChild(clear);
  }
  protoOf(HorizontalViewMapper).obx = function () {
    return this.gc0_1;
  };
  protoOf(HorizontalViewMapper).a88 = function (conf) {
    protoOf(BaseViewMapper).a88.call(this, conf);
    var tmp = Synchronizers_instance;
    var tmp_0 = this.e86_1.o35();
    var tmp_1 = DomUtil_instance.q8d(this.hc0_1);
    conf.h5v(tmp.c8b(tmp_0, tmp_1, HorizontalViewMapper$registerSynchronizers$lambda(this)));
  };
  function ImageViewMapper$registerSynchronizers$$inlined$writableProperty$1(this$0) {
    this.ic0_1 = this$0;
  }
  protoOf(ImageViewMapper$registerSynchronizers$$inlined$writableProperty$1).x9j = function (newValue) {
    this.ic0_1.f86_1.width = newValue.p8w_1.d8c_1;
    this.ic0_1.f86_1.height = newValue.p8w_1.e8c_1;
    if (newValue instanceof UrlImageData) {
      this.ic0_1.f86_1.src = newValue.gb0_1;
    } else {
      if (newValue instanceof EmptyImageData) {
        this.ic0_1.f86_1.src = '';
      } else {
        throw UnsupportedOperationException_init_$Create$();
      }
    }
    return Unit_instance;
  };
  protoOf(ImageViewMapper$registerSynchronizers$$inlined$writableProperty$1).d2x = function (newValue) {
    return this.x9j((newValue == null ? true : !(newValue == null)) ? newValue : THROW_CCE());
  };
  function ImageViewMapper(ctx, source) {
    BaseViewMapper.call(this, ctx, source, DomApi_instance.r8f());
  }
  protoOf(ImageViewMapper).a88 = function (conf) {
    protoOf(BaseViewMapper).a88.call(this, conf);
    // Inline function 'jetbrains.ocelot.base.observable.property.writableProperty' call
    var tmp$ret$0 = new ImageViewMapper$registerSynchronizers$$inlined$writableProperty$1(this);
    conf.h5v(syncOneWay(this.e86_1.ic1_1, tmp$ret$0));
  };
  function LineViewMapper$registerSynchronizers$o$set$lambda($line, $x, $y) {
    return function () {
      $line.setAttribute('x1', '' + ($x + 1 | 0));
      $line.setAttribute('y1', '' + ($y + 1 | 0));
      return Unit_instance;
    };
  }
  function LineViewMapper$registerSynchronizers$o$set$lambda_0($line, $x, $y) {
    return function () {
      $line.setAttribute('x2', '' + ($x + 1 | 0));
      $line.setAttribute('y2', '' + ($y + 1 | 0));
      return Unit_instance;
    };
  }
  function LineViewMapper$registerSynchronizers$lambda(this$0) {
    return function () {
      return this$0.e86_1.p1().w2w().j8c(this$0.e86_1.ob2().w2w().b8c_1);
    };
  }
  function LineViewMapper$registerSynchronizers$$inlined$writableProperty$1(this$0, $line) {
    this.jc1_1 = this$0;
    this.kc1_1 = $line;
  }
  protoOf(LineViewMapper$registerSynchronizers$$inlined$writableProperty$1).x9j = function (newValue) {
    var x = newValue.fg();
    var y = newValue.gg();
    this.jc1_1.pbx(LineViewMapper$registerSynchronizers$o$set$lambda(this.kc1_1, x, y));
    return Unit_instance;
  };
  protoOf(LineViewMapper$registerSynchronizers$$inlined$writableProperty$1).d2x = function (newValue) {
    return this.x9j((newValue == null ? true : !(newValue == null)) ? newValue : THROW_CCE());
  };
  function LineViewMapper$registerSynchronizers$lambda_0(this$0) {
    return function () {
      return this$0.e86_1.lb4().w2w().j8c(this$0.e86_1.ob2().w2w().b8c_1);
    };
  }
  function LineViewMapper$registerSynchronizers$$inlined$writableProperty$2(this$0, $line) {
    this.lc1_1 = this$0;
    this.mc1_1 = $line;
  }
  protoOf(LineViewMapper$registerSynchronizers$$inlined$writableProperty$2).x9j = function (newValue) {
    var x = newValue.fg();
    var y = newValue.gg();
    this.lc1_1.pbx(LineViewMapper$registerSynchronizers$o$set$lambda_0(this.mc1_1, x, y));
    return Unit_instance;
  };
  protoOf(LineViewMapper$registerSynchronizers$$inlined$writableProperty$2).d2x = function (newValue) {
    return this.x9j((newValue == null ? true : !(newValue == null)) ? newValue : THROW_CCE());
  };
  function LineViewMapper$registerSynchronizers$$inlined$writableProperty$3($line) {
    this.nc1_1 = $line;
  }
  protoOf(LineViewMapper$registerSynchronizers$$inlined$writableProperty$3).x9j = function (newValue) {
    this.nc1_1.style.color = newValue.cb0();
    return Unit_instance;
  };
  protoOf(LineViewMapper$registerSynchronizers$$inlined$writableProperty$3).d2x = function (newValue) {
    return this.x9j((newValue == null ? true : !(newValue == null)) ? newValue : THROW_CCE());
  };
  function LineViewMapper$registerSynchronizers$$inlined$writableProperty$4($line) {
    this.oc1_1 = $line;
  }
  protoOf(LineViewMapper$registerSynchronizers$$inlined$writableProperty$4).x9j = function (newValue) {
    setStrokeWidth(this.oc1_1.style, newValue);
    return Unit_instance;
  };
  protoOf(LineViewMapper$registerSynchronizers$$inlined$writableProperty$4).d2x = function (newValue) {
    return this.x9j((newValue == null ? true : !(newValue == null)) ? newValue : THROW_CCE());
  };
  function LineViewMapper(ctx, source) {
    BaseViewMapper.call(this, ctx, source, DomApi_instance.m8f());
  }
  protoOf(LineViewMapper).a88 = function (conf) {
    protoOf(BaseViewMapper).a88.call(this, conf);
    var svg = this.eby();
    this.f86_1.appendChild(svg);
    var line = SvgUtil_instance.yc1();
    svg.appendChild(line);
    conf.h5v(DomViewSynchronizers_instance.wbz(this.e86_1, svg));
    var viewLineStart = toDerivedProperty(LineViewMapper$registerSynchronizers$lambda(this), [this.e86_1.p1(), this.e86_1.ob2()]);
    // Inline function 'jetbrains.ocelot.base.observable.property.writableProperty' call
    var svgLineStart = new LineViewMapper$registerSynchronizers$$inlined$writableProperty$1(this, line);
    conf.h5v(syncOneWay(viewLineStart, svgLineStart));
    var viewLineEnd = toDerivedProperty(LineViewMapper$registerSynchronizers$lambda_0(this), [this.e86_1.lb4(), this.e86_1.ob2()]);
    // Inline function 'jetbrains.ocelot.base.observable.property.writableProperty' call
    var svgLineEnd = new LineViewMapper$registerSynchronizers$$inlined$writableProperty$2(this, line);
    conf.h5v(syncOneWay(viewLineEnd, svgLineEnd));
    var tmp = this.e86_1.mb4();
    // Inline function 'jetbrains.ocelot.base.observable.property.writableProperty' call
    var tmp$ret$2 = new LineViewMapper$registerSynchronizers$$inlined$writableProperty$3(line);
    conf.h5v(syncOneWay(tmp, tmp$ret$2));
    var tmp_0 = this.e86_1.g8u();
    // Inline function 'jetbrains.ocelot.base.observable.property.writableProperty' call
    var tmp$ret$3 = new LineViewMapper$registerSynchronizers$$inlined$writableProperty$4(line);
    conf.h5v(syncOneWay(tmp_0, tmp$ret$3));
  };
  function updatePoints($this) {
    var origin = $this.ac2_1.tb1().b8c_1;
    // Inline function 'kotlin.collections.map' call
    var this_0 = $this.ac2_1.gb5_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.m();
    while (_iterator__ex2g4s.n()) {
      var item = _iterator__ex2g4s.o();
      var tmp$ret$0 = item.j8c(origin);
      destination.j(tmp$ret$0);
    }
    var _iterator__ex2g4s_0 = destination.m();
    while (_iterator__ex2g4s_0.n()) {
      var _destruct__k2r9zo = _iterator__ex2g4s_0.o();
      var vx = _destruct__k2r9zo.fg();
      var vy = _destruct__k2r9zo.gg();
      var x = !(vx === 0) ? vx : 1;
      var y = !(vy === 0) ? vy : 1;
      $this.cc2_1.points.appendItem(new DOMPoint(x, y));
    }
  }
  function MultiPointViewMapper$registerSynchronizers$o$attach$lambda$lambda(this$0) {
    return function () {
      updatePoints(this$0);
      return Unit_instance;
    };
  }
  function MultiPointViewMapper$registerSynchronizers$o$attach$lambda(this$0, this$1) {
    return function (it) {
      this$0.pbx(MultiPointViewMapper$registerSynchronizers$o$attach$lambda$lambda(this$1));
      return Unit_instance;
    };
  }
  function MultiPointViewMapper$registerSynchronizers$o$attach$lambda_0(this$0) {
    return function () {
      updatePoints(this$0);
      return Unit_instance;
    };
  }
  function Companion_231() {
    this.dc2_1 = 'none';
  }
  var Companion_instance_231;
  function Companion_getInstance_231() {
    return Companion_instance_231;
  }
  function MultiPointViewMapper$registerSynchronizers$1($multiPointView, this$0, $polyLine) {
    this.ac2_1 = $multiPointView;
    this.bc2_1 = this$0;
    this.cc2_1 = $polyLine;
    this.zc1_1 = Companion_getInstance_29().m2l_1;
  }
  protoOf(MultiPointViewMapper$registerSynchronizers$1).y86 = function (ctx) {
    var tmp = this;
    var tmp_0 = this.ac2_1.hb5(Companion_getInstance_214().nb4_1);
    tmp.zc1_1 = tmp_0.z2r(MultiPointViewMapper$registerSynchronizers$o$attach$lambda(this.bc2_1, this));
    this.bc2_1.pbx(MultiPointViewMapper$registerSynchronizers$o$attach$lambda_0(this));
  };
  protoOf(MultiPointViewMapper$registerSynchronizers$1).e6j = function () {
    this.zc1_1.zr();
    // Inline function 'kotlin.also' call
    this.zc1_1 = Companion_getInstance_29().m2l_1;
  };
  function MultiPointViewMapper$registerSynchronizers$$inlined$writableProperty$1($style, $isPolyLine) {
    this.ec2_1 = $style;
    this.fc2_1 = $isPolyLine;
  }
  protoOf(MultiPointViewMapper$registerSynchronizers$$inlined$writableProperty$1).x9j = function (newValue) {
    var cssColor = newValue.cb0();
    setFill(this.ec2_1, this.fc2_1 ? 'none' : cssColor);
    this.ec2_1.color = this.fc2_1 ? cssColor : 'none';
    return Unit_instance;
  };
  protoOf(MultiPointViewMapper$registerSynchronizers$$inlined$writableProperty$1).d2x = function (newValue) {
    return this.x9j((newValue == null ? true : !(newValue == null)) ? newValue : THROW_CCE());
  };
  function MultiPointViewMapper$registerSynchronizers$$inlined$writableProperty$2($style) {
    this.gc2_1 = $style;
  }
  protoOf(MultiPointViewMapper$registerSynchronizers$$inlined$writableProperty$2).x9j = function (newValue) {
    setStrokeWidth(this.gc2_1, newValue);
    return Unit_instance;
  };
  protoOf(MultiPointViewMapper$registerSynchronizers$$inlined$writableProperty$2).d2x = function (newValue) {
    return this.x9j((newValue == null ? true : !(newValue == null)) ? newValue : THROW_CCE());
  };
  function MultiPointViewMapper(ctx, source) {
    BaseViewMapper.call(this, ctx, source, DomApi_instance.m8f());
  }
  protoOf(MultiPointViewMapper).a88 = function (conf) {
    protoOf(BaseViewMapper).a88.call(this, conf);
    var svg = this.eby();
    this.f86_1.appendChild(svg);
    var polyLine = SvgUtil_instance.qc2();
    svg.appendChild(polyLine);
    var style = polyLine.style;
    var multiPointView = this.e86_1;
    var isPolyLine = multiPointView instanceof PolyLineView;
    setStrokeWidth(style, 1);
    conf.h5v(new MultiPointViewMapper$registerSynchronizers$1(multiPointView, this, polyLine));
    conf.h5v(DomViewSynchronizers_instance.wbz(multiPointView, svg));
    // Inline function 'jetbrains.ocelot.base.observable.property.writableProperty' call
    var svgPolylineColorProp = new MultiPointViewMapper$registerSynchronizers$$inlined$writableProperty$1(style, isPolyLine);
    conf.h5v(syncOneWay(multiPointView.mb4(), svgPolylineColorProp));
    // Inline function 'jetbrains.ocelot.base.observable.property.writableProperty' call
    var svgPolylineWidthProp = new MultiPointViewMapper$registerSynchronizers$$inlined$writableProperty$2(style);
    conf.h5v(syncOneWay(multiPointView.g8u(), svgPolylineWidthProp));
  };
  function ScrollViewMapper$registerSynchronizers$$inlined$writableProperty$1($style) {
    this.rc2_1 = $style;
  }
  protoOf(ScrollViewMapper$registerSynchronizers$$inlined$writableProperty$1).x9j = function (newValue) {
    setOverflow(this.rc2_1, newValue ? CssOverflow_HIDDEN_getInstance() : CssOverflow_VISIBLE_getInstance());
    return Unit_instance;
  };
  protoOf(ScrollViewMapper$registerSynchronizers$$inlined$writableProperty$1).d2x = function (newValue) {
    return this.x9j((newValue == null ? true : !(newValue == null)) ? newValue : THROW_CCE());
  };
  function ScrollViewMapper$registerSynchronizers$$inlined$writableProperty$2($style) {
    this.sc2_1 = $style;
  }
  protoOf(ScrollViewMapper$registerSynchronizers$$inlined$writableProperty$2).x9j = function (newValue) {
    var x = newValue.fg();
    var y = newValue.gg();
    if (x > 0) {
      setMaxWidth(this.sc2_1, x);
    }
    if (y > 0) {
      setMaxWidth(this.sc2_1, y);
    }
    return Unit_instance;
  };
  protoOf(ScrollViewMapper$registerSynchronizers$$inlined$writableProperty$2).d2x = function (newValue) {
    return this.x9j((newValue == null ? true : !(newValue == null)) ? newValue : THROW_CCE());
  };
  function ScrollViewMapper(ctx, source) {
    CompositeViewMapper.call(this, ctx, source, DomApi_instance.m8f());
    this.cc3_1 = true;
  }
  protoOf(ScrollViewMapper).obx = function () {
    return this.cc3_1;
  };
  protoOf(ScrollViewMapper).a88 = function (conf) {
    protoOf(CompositeViewMapper).a88.call(this, conf);
    var style = this.f86_1.style;
    // Inline function 'jetbrains.ocelot.base.observable.property.writableProperty' call
    var divOverflow = new ScrollViewMapper$registerSynchronizers$$inlined$writableProperty$1(style);
    conf.h5v(syncOneWay(this.e86_1.kb6(), divOverflow));
    // Inline function 'jetbrains.ocelot.base.observable.property.writableProperty' call
    var divMaxDimensions = new ScrollViewMapper$registerSynchronizers$$inlined$writableProperty$2(style);
    conf.h5v(syncOneWay(this.e86_1.jb6(), divMaxDimensions));
  };
  function createSvgElement($this, name) {
    var element = document.createElementNS('http://www.w3.org/2000/svg', name);
    return element instanceof SVGElement ? element : THROW_CCE();
  }
  function SvgUtil() {
  }
  protoOf(SvgUtil).qc2 = function () {
    return createSvgElement(this, 'polyline');
  };
  protoOf(SvgUtil).yc1 = function () {
    return createSvgElement(this, 'line');
  };
  protoOf(SvgUtil).fby = function () {
    return createSvgElement(this, 'svg');
  };
  var SvgUtil_instance;
  function SvgUtil_getInstance() {
    return SvgUtil_instance;
  }
  function DomTextEditor$_get_selectionVisible_$ref_yrl09o(p0) {
    return function () {
      return p0.ybq_1;
    };
  }
  function DomTextEditor$_set_selectionVisible_$ref_mbgdp4(p0) {
    return function (_this__u8e3s4) {
      p0.cbu(_this__u8e3s4);
      return Unit_instance;
    };
  }
  function TextViewMapper$registerSynchronizers$$inlined$writableProperty$1($tmp0_writableProperty_this) {
    this.dc3_1 = $tmp0_writableProperty_this;
  }
  protoOf(TextViewMapper$registerSynchronizers$$inlined$writableProperty$1).x9j = function (newValue) {
    this.dc3_1.set(newValue);
    return Unit_instance;
  };
  protoOf(TextViewMapper$registerSynchronizers$$inlined$writableProperty$1).d2x = function (newValue) {
    return this.x9j((newValue == null ? true : !(newValue == null)) ? newValue : THROW_CCE());
  };
  function DomTextEditor$_get_selectionStart_$ref_pvvbak(p0) {
    return function () {
      return p0.wbq_1;
    };
  }
  function DomTextEditor$_set_selectionStart_$ref_b7dfk8(p0) {
    return function (_this__u8e3s4) {
      p0.dbu(_this__u8e3s4);
      return Unit_instance;
    };
  }
  function TextViewMapper$registerSynchronizers$$inlined$writableProperty$2($tmp0_writableProperty_this) {
    this.ec3_1 = $tmp0_writableProperty_this;
  }
  protoOf(TextViewMapper$registerSynchronizers$$inlined$writableProperty$2).x9j = function (newValue) {
    this.ec3_1.set(newValue);
    return Unit_instance;
  };
  protoOf(TextViewMapper$registerSynchronizers$$inlined$writableProperty$2).d2x = function (newValue) {
    return this.x9j((newValue == null ? true : !(newValue == null)) ? newValue : THROW_CCE());
  };
  function TextViewMapper$registerSynchronizers$$inlined$writableProperty$3($editor) {
    this.fc3_1 = $editor;
  }
  protoOf(TextViewMapper$registerSynchronizers$$inlined$writableProperty$3).x9j = function (newValue) {
    this.fc3_1.ebu(newValue);
    return Unit_instance;
  };
  protoOf(TextViewMapper$registerSynchronizers$$inlined$writableProperty$3).d2x = function (newValue) {
    return this.x9j((newValue == null ? true : !(newValue == null)) ? newValue : THROW_CCE());
  };
  function DomTextEditor$_get_text_$ref_sliauj(p0) {
    return function () {
      return p0.o8w();
    };
  }
  function DomTextEditor$_set_text_$ref_fslzdr(p0) {
    return function (_this__u8e3s4) {
      p0.ibr(_this__u8e3s4);
      return Unit_instance;
    };
  }
  function TextViewMapper$registerSynchronizers$$inlined$writableProperty$4($tmp0_writableProperty_this) {
    this.gc3_1 = $tmp0_writableProperty_this;
  }
  protoOf(TextViewMapper$registerSynchronizers$$inlined$writableProperty$4).x9j = function (newValue) {
    this.gc3_1.set(newValue);
    return Unit_instance;
  };
  protoOf(TextViewMapper$registerSynchronizers$$inlined$writableProperty$4).d2x = function (newValue) {
    return this.x9j((newValue == null ? true : !(newValue == null)) ? newValue : THROW_CCE());
  };
  function DomTextEditor$_get_textColor_$ref_fljue6(p0) {
    return function () {
      return p0.cbr_1;
    };
  }
  function DomTextEditor$_set_textColor_$ref_dsbvu(p0) {
    return function (_this__u8e3s4) {
      p0.xbt(_this__u8e3s4);
      return Unit_instance;
    };
  }
  function TextViewMapper$registerSynchronizers$$inlined$writableProperty$5($tmp0_writableProperty_this) {
    this.hc3_1 = $tmp0_writableProperty_this;
  }
  protoOf(TextViewMapper$registerSynchronizers$$inlined$writableProperty$5).x9j = function (newValue) {
    this.hc3_1.set(newValue);
    return Unit_instance;
  };
  protoOf(TextViewMapper$registerSynchronizers$$inlined$writableProperty$5).d2x = function (newValue) {
    return this.x9j((newValue == null ? true : !(newValue == null)) ? newValue : THROW_CCE());
  };
  function DomTextEditor$_get_isCaretVisible_$ref_ynx5c9(p0) {
    return function () {
      return p0.bbr_1;
    };
  }
  function DomTextEditor$_set_isCaretVisible_$ref_2fblij(p0) {
    return function (_this__u8e3s4) {
      p0.qbt(_this__u8e3s4);
      return Unit_instance;
    };
  }
  function TextViewMapper$registerSynchronizers$$inlined$writableProperty$6($tmp0_writableProperty_this) {
    this.ic3_1 = $tmp0_writableProperty_this;
  }
  protoOf(TextViewMapper$registerSynchronizers$$inlined$writableProperty$6).x9j = function (newValue) {
    this.ic3_1.set(newValue);
    return Unit_instance;
  };
  protoOf(TextViewMapper$registerSynchronizers$$inlined$writableProperty$6).d2x = function (newValue) {
    return this.x9j((newValue == null ? true : !(newValue == null)) ? newValue : THROW_CCE());
  };
  function DomTextEditor$_get_caretPosition_$ref_vya970(p0) {
    return function () {
      return p0.vbq_1;
    };
  }
  function DomTextEditor$_set_caretPosition_$ref_hd0whs(p0) {
    return function (_this__u8e3s4) {
      p0.wbt(_this__u8e3s4);
      return Unit_instance;
    };
  }
  function TextViewMapper$registerSynchronizers$$inlined$writableProperty$7($tmp0_writableProperty_this) {
    this.jc3_1 = $tmp0_writableProperty_this;
  }
  protoOf(TextViewMapper$registerSynchronizers$$inlined$writableProperty$7).x9j = function (newValue) {
    this.jc3_1.set(newValue);
    return Unit_instance;
  };
  protoOf(TextViewMapper$registerSynchronizers$$inlined$writableProperty$7).d2x = function (newValue) {
    return this.x9j((newValue == null ? true : !(newValue == null)) ? newValue : THROW_CCE());
  };
  function TextViewMapper$registerSynchronizers$$inlined$writableProperty$8($editor) {
    this.kc3_1 = $editor;
  }
  protoOf(TextViewMapper$registerSynchronizers$$inlined$writableProperty$8).x9j = function (newValue) {
    this.kc3_1.ybt(newValue);
    return Unit_instance;
  };
  protoOf(TextViewMapper$registerSynchronizers$$inlined$writableProperty$8).d2x = function (newValue) {
    return this.x9j((newValue == null ? true : !(newValue == null)) ? newValue : THROW_CCE());
  };
  function TextViewMapper$registerSynchronizers$$inlined$writableProperty$9($editor) {
    this.lc3_1 = $editor;
  }
  protoOf(TextViewMapper$registerSynchronizers$$inlined$writableProperty$9).x9j = function (newValue) {
    this.lc3_1.zbt(newValue);
    return Unit_instance;
  };
  protoOf(TextViewMapper$registerSynchronizers$$inlined$writableProperty$9).d2x = function (newValue) {
    return this.x9j((newValue == null ? true : !(newValue == null)) ? newValue : THROW_CCE());
  };
  function TextViewMapper$registerSynchronizers$$inlined$writableProperty$10($editor) {
    this.mc3_1 = $editor;
  }
  protoOf(TextViewMapper$registerSynchronizers$$inlined$writableProperty$10).x9j = function (newValue) {
    this.mc3_1.abu(newValue);
    return Unit_instance;
  };
  protoOf(TextViewMapper$registerSynchronizers$$inlined$writableProperty$10).d2x = function (newValue) {
    return this.x9j((newValue == null ? true : !(newValue == null)) ? newValue : THROW_CCE());
  };
  function TextViewMapper$registerSynchronizers$$inlined$writableProperty$11($editor) {
    this.nc3_1 = $editor;
  }
  protoOf(TextViewMapper$registerSynchronizers$$inlined$writableProperty$11).x9j = function (newValue) {
    this.nc3_1.bbu(newValue);
    return Unit_instance;
  };
  protoOf(TextViewMapper$registerSynchronizers$$inlined$writableProperty$11).d2x = function (newValue) {
    return this.x9j((newValue == null ? true : !(newValue == null)) ? newValue : THROW_CCE());
  };
  function TextViewMapper(ctx, source) {
    BaseViewMapper.call(this, ctx, source, DomApi_instance.m8f());
    this.xc3_1 = true;
  }
  protoOf(TextViewMapper).obx = function () {
    return this.xc3_1;
  };
  protoOf(TextViewMapper).a88 = function (conf) {
    var editor = new DomTextEditor(this.f86_1);
    // Inline function 'kotlin.with' call
    var $this$with = this.f86_1.style;
    setPosition($this$with, CssPosition_ABSOLUTE_getInstance());
    setDisplay($this$with, CssDisplay_BLOCK_getInstance());
    protoOf(BaseViewMapper).a88.call(this, conf);
    var tmp = this.e86_1.h97();
    var tmp_0 = KMutableProperty0;
    var tmp_1 = DomTextEditor$_get_selectionVisible_$ref_yrl09o(editor);
    var tmp0_writableProperty_this = getPropertyCallableRef('selectionVisible', 0, tmp_0, tmp_1, DomTextEditor$_set_selectionVisible_$ref_mbgdp4(editor));
    // Inline function 'jetbrains.ocelot.base.observable.property.writableProperty' call
    var tmp$ret$2 = new TextViewMapper$registerSynchronizers$$inlined$writableProperty$1(tmp0_writableProperty_this);
    conf.h5v(syncOneWay(tmp, tmp$ret$2));
    var tmp_2 = this.e86_1.i97();
    var tmp_3 = KMutableProperty0;
    var tmp_4 = DomTextEditor$_get_selectionStart_$ref_pvvbak(editor);
    var tmp0_writableProperty_this_0 = getPropertyCallableRef('selectionStart', 0, tmp_3, tmp_4, DomTextEditor$_set_selectionStart_$ref_b7dfk8(editor));
    // Inline function 'jetbrains.ocelot.base.observable.property.writableProperty' call
    var tmp$ret$3 = new TextViewMapper$registerSynchronizers$$inlined$writableProperty$2(tmp0_writableProperty_this_0);
    conf.h5v(syncOneWay(tmp_2, tmp$ret$3));
    var tmp_5 = this.e86_1.j97();
    // Inline function 'jetbrains.ocelot.base.observable.property.writableProperty' call
    var tmp$ret$4 = new TextViewMapper$registerSynchronizers$$inlined$writableProperty$3(editor);
    conf.h5v(syncOneWay(tmp_5, tmp$ret$4));
    var tmp_6 = this.e86_1.o8w();
    var tmp_7 = KMutableProperty0;
    var tmp_8 = DomTextEditor$_get_text_$ref_sliauj(editor);
    var tmp0_writableProperty_this_1 = getPropertyCallableRef('text', 0, tmp_7, tmp_8, DomTextEditor$_set_text_$ref_fslzdr(editor));
    // Inline function 'jetbrains.ocelot.base.observable.property.writableProperty' call
    var tmp$ret$5 = new TextViewMapper$registerSynchronizers$$inlined$writableProperty$4(tmp0_writableProperty_this_1);
    conf.h5v(syncOneWay(tmp_6, tmp$ret$5));
    var tmp_9 = this.e86_1.b97();
    var tmp_10 = KMutableProperty0;
    var tmp_11 = DomTextEditor$_get_textColor_$ref_fljue6(editor);
    var tmp0_writableProperty_this_2 = getPropertyCallableRef('textColor', 0, tmp_10, tmp_11, DomTextEditor$_set_textColor_$ref_dsbvu(editor));
    // Inline function 'jetbrains.ocelot.base.observable.property.writableProperty' call
    var tmp$ret$6 = new TextViewMapper$registerSynchronizers$$inlined$writableProperty$5(tmp0_writableProperty_this_2);
    conf.h5v(syncOneWay(tmp_9, tmp$ret$6));
    var tmp_12 = this.e86_1.c97();
    var tmp_13 = KMutableProperty0;
    var tmp_14 = DomTextEditor$_get_isCaretVisible_$ref_ynx5c9(editor);
    var tmp0_writableProperty_this_3 = getPropertyCallableRef('isCaretVisible', 0, tmp_13, tmp_14, DomTextEditor$_set_isCaretVisible_$ref_2fblij(editor));
    // Inline function 'jetbrains.ocelot.base.observable.property.writableProperty' call
    var tmp$ret$7 = new TextViewMapper$registerSynchronizers$$inlined$writableProperty$6(tmp0_writableProperty_this_3);
    conf.h5v(syncOneWay(tmp_12, tmp$ret$7));
    var tmp_15 = this.e86_1.t96();
    var tmp_16 = KMutableProperty0;
    var tmp_17 = DomTextEditor$_get_caretPosition_$ref_vya970(editor);
    var tmp0_writableProperty_this_4 = getPropertyCallableRef('caretPosition', 0, tmp_16, tmp_17, DomTextEditor$_set_caretPosition_$ref_hd0whs(editor));
    // Inline function 'jetbrains.ocelot.base.observable.property.writableProperty' call
    var tmp$ret$8 = new TextViewMapper$registerSynchronizers$$inlined$writableProperty$7(tmp0_writableProperty_this_4);
    conf.h5v(syncOneWay(tmp_15, tmp$ret$8));
    var tmp_18 = this.e86_1.d97();
    // Inline function 'jetbrains.ocelot.base.observable.property.writableProperty' call
    var tmp$ret$9 = new TextViewMapper$registerSynchronizers$$inlined$writableProperty$8(editor);
    conf.h5v(syncOneWay(tmp_18, tmp$ret$9));
    var tmp_19 = this.e86_1.e97();
    // Inline function 'jetbrains.ocelot.base.observable.property.writableProperty' call
    var tmp$ret$10 = new TextViewMapper$registerSynchronizers$$inlined$writableProperty$9(editor);
    conf.h5v(syncOneWay(tmp_19, tmp$ret$10));
    var tmp_20 = this.e86_1.f97();
    // Inline function 'jetbrains.ocelot.base.observable.property.writableProperty' call
    var tmp$ret$11 = new TextViewMapper$registerSynchronizers$$inlined$writableProperty$10(editor);
    conf.h5v(syncOneWay(tmp_20, tmp$ret$11));
    var tmp_21 = this.e86_1.g97();
    // Inline function 'jetbrains.ocelot.base.observable.property.writableProperty' call
    var tmp$ret$12 = new TextViewMapper$registerSynchronizers$$inlined$writableProperty$11(editor);
    conf.h5v(syncOneWay(tmp_21, tmp$ret$12));
  };
  function setTargetWidth($this, value) {
    setPaddingLeft($this.f86_1.style, value);
  }
  function VerticalViewMapper$registerSynchronizers$$inlined$writableProperty$1(this$0) {
    this.yc3_1 = this$0;
  }
  protoOf(VerticalViewMapper$registerSynchronizers$$inlined$writableProperty$1).x9j = function (newValue) {
    var this_0 = this.yc3_1;
    setTargetWidth(this_0, newValue);
    return Unit_instance;
  };
  protoOf(VerticalViewMapper$registerSynchronizers$$inlined$writableProperty$1).d2x = function (newValue) {
    return this.x9j((newValue == null ? true : !(newValue == null)) ? newValue : THROW_CCE());
  };
  function VerticalViewMapper(ctx, source) {
    CompositeViewMapper.call(this, ctx, source, DomApi_instance.m8f());
    this.ic4_1 = true;
  }
  protoOf(VerticalViewMapper).obx = function () {
    return this.ic4_1;
  };
  protoOf(VerticalViewMapper).a88 = function (conf) {
    protoOf(CompositeViewMapper).a88.call(this, conf);
    var tmp = this.e86_1.ib8();
    // Inline function 'jetbrains.ocelot.base.observable.property.writableProperty' call
    var tmp$ret$0 = new VerticalViewMapper$registerSynchronizers$$inlined$writableProperty$1(this);
    conf.h5v(syncOneWay(tmp, tmp$ret$0));
  };
  function View$validate$ref(p0) {
    var l = function () {
      p0.mb2();
      return Unit_instance;
    };
    l.callableName = 'validate';
    return l;
  }
  function ViewContainerToElementMapper$onAttach$o$attach$lambda($container) {
    return function (it) {
      var tmp = DomImmediatePolyfill_getInstance();
      tmp.x8h(View$validate$ref($container.t42()));
      return Unit_instance;
    };
  }
  function setRootDivSize($this, value) {
    var bottomRight = value.b8c_1.i8c(value.c8c_1);
    // Inline function 'kotlin.with' call
    var $this$with = $this.qc4_1.style;
    setWidth($this$with, bottomRight.d8c_1);
    setHeight($this$with, bottomRight.e8c_1);
  }
  function registerListeners_0($this, conf) {
    var mouseTranslator = new ViewContainerToElementMapper$registerListeners$mouseTranslator$1($this);
    var keyTranslator = new SimpleKeyTranslator($this.qc4_1, $this.e86_1);
    conf.h5v(new CompositeDisposable([mouseTranslator.z8n(), keyTranslator.z8n()]));
  }
  function disablePopup($this, el) {
    var tmp = Companion_getInstance_139().h8g_1;
    var tmp_0 = ViewContainerToElementMapper$disablePopup$lambda;
    on(el, tmp, typeof tmp_0 === 'function' ? tmp_0 : THROW_CCE());
  }
  function isDomViewEvent($this, e) {
    var tmp = $this.e86_1.t42().pb2(e.z8l());
    return tmp instanceof DomView;
  }
  function isContainerEvent_0($this, evt) {
    return $this.e86_1.cbe().tb1().l8c(evt.z8l());
  }
  function ViewContainerToElementMapper$viewToDomContext$1($eventsDisabled, $extensionViewMapperFactories) {
    this.uc4_1 = $extensionViewMapperFactories;
    this.tc4_1 = $eventsDisabled;
  }
  protoOf(ViewContainerToElementMapper$viewToDomContext$1).pby = function () {
    return ViewMapperFactory_instance.wc4(this, this.uc4_1);
  };
  function ViewContainerToElementMapper$registerSynchronizers$$inlined$writableProperty$1(this$0) {
    this.xc4_1 = this$0;
  }
  protoOf(ViewContainerToElementMapper$registerSynchronizers$$inlined$writableProperty$1).x9j = function (newValue) {
    var this_0 = this.xc4_1;
    setRootDivSize(this_0, newValue);
    return Unit_instance;
  };
  protoOf(ViewContainerToElementMapper$registerSynchronizers$$inlined$writableProperty$1).d2x = function (newValue) {
    return this.x9j((newValue == null ? true : !(newValue == null)) ? newValue : THROW_CCE());
  };
  function ViewContainerToElementMapper$registerListeners$mouseTranslator$1(this$0) {
    this.ac5_1 = this$0;
    MouseTranslator.call(this, this$0.qc4_1, this$0.e86_1);
  }
  protoOf(ViewContainerToElementMapper$registerListeners$mouseTranslator$1).p8n = function (e) {
    return !isContainerEvent_0(this.ac5_1, e) || isDomViewEvent(this.ac5_1, e);
  };
  protoOf(ViewContainerToElementMapper$registerListeners$mouseTranslator$1).x8n = function (e) {
    return isDomViewEvent(this.ac5_1, e);
  };
  protoOf(ViewContainerToElementMapper$registerListeners$mouseTranslator$1).m8n = function (vec) {
    var result = protoOf(MouseTranslator).m8n.call(this, vec);
    return result.j8c(new Vector(numberToInt(getAbsoluteLeft(this.ac5_1.qc4_1)), numberToInt(getAbsoluteTop(this.ac5_1.qc4_1))));
  };
  protoOf(ViewContainerToElementMapper$registerListeners$mouseTranslator$1).s8n = function () {
    return this.ac5_1.qc4_1.focus();
  };
  function ViewContainerToElementMapper$onAttach$1(this$0, $rootMapper, $fontHeight, $baseLine, $fontWidth) {
    this.cc5_1 = this$0;
    this.dc5_1 = $rootMapper;
    this.ec5_1 = $fontHeight;
    this.fc5_1 = $baseLine;
    this.gc5_1 = $fontWidth;
    this.bc5_1 = null;
  }
  protoOf(ViewContainerToElementMapper$onAttach$1).kb5 = function (container) {
    var tmp = this;
    var tmp_0 = container.t42().ib2();
    tmp.bc5_1 = tmp_0.z2r(ViewContainerToElementMapper$onAttach$o$attach$lambda(container));
    container.t42().mb2();
  };
  protoOf(ViewContainerToElementMapper$onAttach$1).e6j = function () {
    return ensureNotNull(this.bc5_1).zr();
  };
  protoOf(ViewContainerToElementMapper$onAttach$1).lb5 = function (view) {
  };
  protoOf(ViewContainerToElementMapper$onAttach$1).mb5 = function (view, change) {
  };
  protoOf(ViewContainerToElementMapper$onAttach$1).nb5 = function (font, text) {
    var tmp;
    if (equals(Companion_getInstance_216().lb6_1.o96_1, Companion_getInstance_211().j95_1) && font.equals(Companion_getInstance_216().lb6_1)) {
      tmp = numberToInt(text.length * this.gc5_1);
    } else {
      tmp = numberToInt(TextMetricsCalculator_getInstance().ebx(font, text).vbe().q8b_1);
    }
    return tmp;
  };
  function ViewContainerToElementMapper$disablePopup$lambda(_unused_var__etf5q3) {
    return false;
  }
  function ViewContainerToElementMapper(source, target, eventsDisabled, extensionViewMapperFactories) {
    Mapper.call(this, source, target);
    var tmp = this;
    // Inline function 'kotlin.also' call
    var this_0 = DomApi_instance.m8f();
    disablePopup(this, this_0);
    target.appendChild(this_0);
    this_0.tabIndex = 0;
    // Inline function 'kotlin.with' call
    var $this$with = this_0.style;
    setPosition($this$with, CssPosition_RELATIVE_getInstance());
    setPadding($this$with, 0);
    setOverflow($this$with, CssOverflow_VISIBLE_getInstance());
    setOutlineStyle($this$with, CssOutlineStyle_NONE_getInstance());
    tmp.qc4_1 = this_0;
    this.rc4_1 = this.r89();
    var tmp_0 = this;
    tmp_0.sc4_1 = new ViewContainerToElementMapper$viewToDomContext$1(eventsDisabled, extensionViewMapperFactories);
  }
  protoOf(ViewContainerToElementMapper).a88 = function (conf) {
    protoOf(Mapper).a88.call(this, conf);
    var tmp = this.e86_1.t42().ob2();
    // Inline function 'jetbrains.ocelot.base.observable.property.writableProperty' call
    var tmp$ret$0 = new ViewContainerToElementMapper$registerSynchronizers$$inlined$writableProperty$1(this);
    conf.h5v(syncOneWay(tmp, tmp$ret$0));
    if (!this.sc4_1.tc4_1) {
      registerListeners_0(this, conf);
    }
  };
  protoOf(ViewContainerToElementMapper).o89 = function (ctx) {
    protoOf(Mapper).o89.call(this, ctx);
    var rootMapper = this.sc4_1.pby()(this.e86_1.t42());
    this.rc4_1.f2x(rootMapper);
    this.qc4_1.appendChild(rootMapper.f86_1);
    var metrics = TextMetricsCalculator_getInstance().qbw(Companion_getInstance_216().lb6_1);
    var baseLine = metrics.bbx();
    var fontWidth = metrics.vbe().q8b_1;
    var fontHeight = metrics.vbe().r8b_1;
    this.e86_1.bbe(new ViewContainerToElementMapper$onAttach$1(this, rootMapper, fontHeight, baseLine, fontWidth));
  };
  protoOf(ViewContainerToElementMapper).c87 = function () {
    protoOf(Mapper).c87.call(this);
    this.e86_1.bbe(new NullViewContainerPeer());
  };
  function getExtensionViewMapper($this, _this__u8e3s4, view, ctx) {
    var tmp;
    if (view.cb1_1) {
      var tmp$ret$1;
      $l$block: {
        // Inline function 'kotlin.collections.firstOrNull' call
        var _iterator__ex2g4s = _this__u8e3s4.m();
        while (_iterator__ex2g4s.n()) {
          var element = _iterator__ex2g4s.o();
          if (element.hc5(view)) {
            tmp$ret$1 = element;
            break $l$block;
          }
        }
        tmp$ret$1 = null;
      }
      var tmp0_safe_receiver = tmp$ret$1;
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.ic5(ctx, view);
      var tmp_0;
      if (tmp1_elvis_lhs == null) {
        throw UnsupportedOperationException_init_$Create$_0("Unknown view: '" + getKClassFromExpression(view).ra() + "'. The corresponding ExtensionViewMapperFactory needs to be registered.");
      } else {
        tmp_0 = tmp1_elvis_lhs;
      }
      tmp = tmp_0;
    } else {
      tmp = null;
    }
    return tmp;
  }
  function ViewMapperFactory$getMapperFactory$lambda($ctx, $extensionViewMapperFactories) {
    return function (view) {
      var tmp;
      if (view instanceof TextView) {
        tmp = new TextViewMapper($ctx, view);
      } else {
        if (view instanceof LineView) {
          tmp = new LineViewMapper($ctx, view);
        } else {
          if (view instanceof MultiPointView) {
            tmp = new MultiPointViewMapper($ctx, view);
          } else {
            if (false && getKClassFromExpression(view) === getKClass(VerticalView)) {
              tmp = new VerticalViewMapper($ctx, view instanceof VerticalView ? view : THROW_CCE());
            } else {
              if (false && getKClassFromExpression(view) === getKClass(HorizontalView)) {
                tmp = new HorizontalViewMapper($ctx, view instanceof HorizontalView ? view : THROW_CCE());
              } else {
                if (view instanceof ScrollView) {
                  tmp = new ScrollViewMapper($ctx, view);
                } else {
                  if (view instanceof ImageView) {
                    tmp = new ImageViewMapper($ctx, view);
                  } else {
                    if (view instanceof DomView) {
                      tmp = new DomViewMapper($ctx, view);
                    } else {
                      var tmp0_elvis_lhs = getExtensionViewMapper(ViewMapperFactory_instance, $extensionViewMapperFactories, view, $ctx);
                      tmp = tmp0_elvis_lhs == null ? new CompositeViewMapper($ctx, view, DomApi_instance.m8f()) : tmp0_elvis_lhs;
                    }
                  }
                }
              }
            }
          }
        }
      }
      var result = tmp;
      var tmp_0;
      if (view instanceof VerticalView) {
        tmp_0 = 'V';
      } else {
        if (view instanceof HorizontalView) {
          tmp_0 = 'H';
        } else {
          if (view instanceof TextView) {
            tmp_0 = 'T';
          } else {
            if (view instanceof ScrollView) {
              tmp_0 = 'S';
            } else {
              tmp_0 = null;
            }
          }
        }
      }
      var className = tmp_0;
      var tmp_1;
      if (!(className == null)) {
        addClassName(result.f86_1, className);
        tmp_1 = Unit_instance;
      }
      return result;
    };
  }
  function ViewMapperFactory() {
    this.vc4_1 = false;
  }
  protoOf(ViewMapperFactory).wc4 = function (ctx, extensionViewMapperFactories) {
    return ViewMapperFactory$getMapperFactory$lambda(ctx, extensionViewMapperFactories);
  };
  var ViewMapperFactory_instance;
  function ViewMapperFactory_getInstance() {
    return ViewMapperFactory_instance;
  }
  function ViewToDom() {
  }
  protoOf(ViewToDom).mbw = function (container, element, extensionViewMapperFactories, eventsDisabled) {
    return Mappers_instance.c8a(new ViewContainerToElementMapper(container, element, eventsDisabled, extensionViewMapperFactories));
  };
  protoOf(ViewToDom).lbw = function (container, element, extensionViewMapperFactories, eventsDisabled, $super) {
    extensionViewMapperFactories = extensionViewMapperFactories === VOID ? emptyList() : extensionViewMapperFactories;
    eventsDisabled = eventsDisabled === VOID ? false : eventsDisabled;
    return $super === VOID ? this.mbw(container, element, extensionViewMapperFactories, eventsDisabled) : $super.mbw.call(this, container, element, extensionViewMapperFactories, eventsDisabled);
  };
  var ViewToDom_instance;
  function ViewToDom_getInstance() {
    return ViewToDom_instance;
  }
  function getPathAndState($this, state, getState) {
    var path = ArrayList_init_$Create$();
    var current = state.jc5_1;
    $l$loop: while (isInterface(current, HasOperationTargetData)) {
      var targetedOperation = current;
      path.j(ensureNotNull(targetedOperation.l3p()));
      current = targetedOperation.s3z();
    }
    // Inline function 'kotlin.check' call
    if (!(current instanceof CellOperation)) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    var cellOperation = current;
    path.j(cellOperation.lc5_1);
    return new Pair(path, getState(cellOperation));
  }
  function getFocusState($this, provider, cellProvider, cell) {
    var tmp0_elvis_lhs = cellProvider.nc5(cell);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var node = tmp;
    if (isFocusSuspended($this, cell)) {
      return null;
    }
    var tmp1_elvis_lhs = Companion_instance_233.oc5(cell, cellProvider);
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      return null;
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    var cellPath = tmp_0;
    var operation = new FocusOperation(cellPath);
    return new NodeCellState(provider.pc5(node, operation, cellProvider));
  }
  function isFocusSuspended($this, cell) {
    var tmp0 = ancestorsFrom(cell);
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.sequences.any' call
      var _iterator__ex2g4s = tmp0.m();
      while (_iterator__ex2g4s.n()) {
        var element = _iterator__ex2g4s.o();
        if (element.c93(Companion_getInstance_232().qc5_1)) {
          tmp$ret$1 = true;
          break $l$block;
        }
      }
      tmp$ret$1 = false;
    }
    return tmp$ret$1;
  }
  function getNodeState($this, cell, provider, cellProvider) {
    var tmp0_elvis_lhs = cellProvider.nc5(cell);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var node = tmp;
    var cellPath = ensureNotNull(Companion_instance_233.oc5(cell, cellProvider));
    var state = get_stateHandler(cell).za7(cell);
    var operation = new CellStateOperation(state, cellPath);
    return new NodeCellState(provider.pc5(node, operation, cellProvider));
  }
  function CellContainerState$Companion$getPathToCellStateMap$lambda(operation) {
    // Inline function 'kotlin.check' call
    if (!(operation instanceof CellStateOperation)) {
      var message = 'Expected CellStateOperation, actual ' + toString_1(getKClassFromExpression(operation));
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    return operation.uc5_1;
  }
  function CellContainerState$Companion$getPath$lambda(_unused_var__etf5q3) {
    return null;
  }
  function Companion_232() {
    Companion_instance_232 = this;
    this.qc5_1 = CellTraitPropertySpec_init_$Create$('suspendFocusState', false);
  }
  protoOf(Companion_232).vc5 = function (states) {
    var map = HashMap_init_$Create$();
    var getState = CellContainerState$Companion$getPathToCellStateMap$lambda;
    var _iterator__ex2g4s = states.m();
    $l$loop: while (_iterator__ex2g4s.n()) {
      var state = _iterator__ex2g4s.o();
      if (state.r3x()) {
        continue $l$loop;
      }
      var pair = getPathAndState(this, state, getState);
      // Inline function 'kotlin.check' call
      if (!!map.o2(pair.pg_1)) {
        throw IllegalStateException_init_$Create$_0('Check failed.');
      }
      var tmp2 = pair.pg_1;
      // Inline function 'kotlin.collections.set' call
      var value = pair.qg_1;
      map.t2(tmp2, value);
    }
    return map;
  };
  protoOf(Companion_232).wc5 = function (state) {
    var tmp;
    if (state.r3x()) {
      tmp = null;
    } else {
      var tmp_0 = CellContainerState$Companion$getPath$lambda;
      var getState = typeof tmp_0 === 'function' ? tmp_0 : THROW_CCE();
      tmp = getPathAndState(this, state, getState).pg_1;
    }
    return tmp;
  };
  protoOf(Companion_232).xc5 = function (focus1, focus2) {
    var tmp;
    if (focus1 == null || focus2 == null) {
      tmp = focus1 === focus2;
    } else {
      tmp = equals(this.wc5(focus1), this.wc5(focus2));
    }
    return tmp;
  };
  protoOf(Companion_232).yc5 = function (state1, state2) {
    if (state1 == null || state2 == null) {
      return state1 === state2;
    }
    var tmp;
    if (!this.xc5(state1.ac6_1, state2.ac6_1)) {
      tmp = false;
    } else {
      tmp = equals(this.vc5(state1.bc6_1), this.vc5(state2.bc6_1));
    }
    return tmp;
  };
  protoOf(Companion_232).cc6 = function (containerId, selectedCell, cellsToSave, provider, cellProvider) {
    var focus = null;
    var toFocus = selectedCell;
    while (!(toFocus == null) && toFocus.c93(Cells_getInstance().i9t_1)) {
      toFocus = prevFocusable(toFocus);
    }
    if (!(toFocus == null)) {
      focus = getFocusState(this, provider, cellProvider, toFocus);
    }
    var states = LinkedHashSet_init_$Create$();
    var _iterator__ex2g4s = cellsToSave.m();
    $l$loop: while (_iterator__ex2g4s.n()) {
      var cell = _iterator__ex2g4s.o();
      if (cell.c93(Cells_getInstance().i9t_1))
        continue $l$loop;
      var nodeState = getNodeState(this, cell, provider, cellProvider);
      if (!(nodeState == null)) {
        states.j(nodeState);
      }
    }
    return new CellContainerState(containerId, focus, states);
  };
  var Companion_instance_232;
  function Companion_getInstance_232() {
    if (Companion_instance_232 == null)
      new Companion_232();
    return Companion_instance_232;
  }
  function CellContainerState(containerId, nodeFocus, cellStates) {
    Companion_getInstance_232();
    this.zc5_1 = containerId;
    this.ac6_1 = nodeFocus;
    this.bc6_1 = cellStates;
  }
  protoOf(CellContainerState).dc6 = function (context, provider) {
    var _iterator__ex2g4s = this.bc6_1.m();
    while (_iterator__ex2g4s.n()) {
      var state = _iterator__ex2g4s.o();
      state.ec6(context, provider);
    }
    var tmp0_safe_receiver = this.ac6_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.ec6(context, provider);
    }
  };
  protoOf(CellContainerState).fc6 = function (operation) {
    var transformedStates = LinkedHashSet_init_$Create$();
    var _iterator__ex2g4s = this.bc6_1.m();
    while (_iterator__ex2g4s.n()) {
      var state = _iterator__ex2g4s.o();
      transformedStates.j(new NodeCellState(operation.z3x(state.jc5_1, true)));
    }
    var focus = null;
    if (!(this.ac6_1 == null)) {
      focus = new NodeCellState(operation.z3x(this.ac6_1.jc5_1, true));
    }
    return new CellContainerState(this.zc5_1, focus, transformedStates);
  };
  protoOf(CellContainerState).h53 = function (operation) {
    return this.fc6(operation);
  };
  protoOf(CellContainerState).toString = function () {
    var result = StringBuilder_init_$Create$_1();
    result.j8('CellContainerState@').j8(toString_3(hashCode(this), 16)).j8(' : container id=').i8(this.zc5_1);
    result.j8('\n  focus: ').i8(this.ac6_1);
    result.j8('\n  states:');
    if (this.bc6_1.s()) {
      result.j8(' <empty>');
    } else {
      var _iterator__ex2g4s = this.bc6_1.m();
      while (_iterator__ex2g4s.n()) {
        var state = _iterator__ex2g4s.o();
        result.j8('\n    ').i8(state);
      }
    }
    return result.toString();
  };
  function _get_nodeCellProvider__5glot2($this) {
    var tmp = $this.mc5_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('nodeCellProvider');
    }
  }
  function CellOperation(path) {
    BaseOperation.call(this);
    this.lc5_1 = path;
  }
  protoOf(CellOperation).gc6 = function (provider) {
    this.mc5_1 = provider;
  };
  protoOf(CellOperation).hc6 = function (model, nodeFactory) {
    this.ic6(model, _get_nodeCellProvider__5glot2(this));
    return model;
  };
  protoOf(CellOperation).y3x = function (model, nodeFactory) {
    return this.hc6(model instanceof OtNode ? model : THROW_CCE(), nodeFactory);
  };
  protoOf(CellOperation).jc6 = function (otherOp, server) {
    return new NopOperation();
  };
  protoOf(CellOperation).q43 = function (otherOp, server) {
    return this.jc6(otherOp, server);
  };
  protoOf(CellOperation).q3z = function () {
    throw IllegalStateException_init_$Create$();
  };
  protoOf(CellOperation).kc6 = function (node, provider) {
    return this.lc5_1.nc6(node, provider);
  };
  protoOf(CellOperation).toString = function () {
    var name = getKClassFromExpression(this).ra();
    return plus_12(name, '@') + toString_3(hashCode(this), 16) + new Char(_Char___init__impl__6a9atx(40)) + this.lc5_1 + toString(_Char___init__impl__6a9atx(41));
  };
  function find_1($this, cell, node, provider) {
    var nodeCells = provider.oc6(node);
    var index = 0;
    var _iterator__ex2g4s = nodeCells.m();
    $l$loop: while (_iterator__ex2g4s.n()) {
      var nodeCell = _iterator__ex2g4s.o();
      if (isDescendant(nodeCell, cell)) {
        break $l$loop;
      }
      index = index + 1 | 0;
    }
    var tmp;
    if (index === nodeCells.p()) {
      tmp = null;
    } else {
      var treePath = TreePath_init_$Create$_0(cell, nodeCells.r(index));
      var cellPath = new CellPath(index, treePath);
      tmp = new Pair(cellPath, node);
    }
    return tmp;
  }
  function hasNodeCell($this, node, provider) {
    return $this.lc6_1 < provider.oc6(node).p();
  }
  function Companion_233() {
  }
  protoOf(Companion_233).oc5 = function (cell, provider) {
    var tmp0_elvis_lhs = this.pc6(cell, provider);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var cellPathNodePair = tmp;
    return cellPathNodePair.pg_1;
  };
  protoOf(Companion_233).pc6 = function (cell, provider) {
    var tmp0_safe_receiver = provider.nc5(cell);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp = find_1(Companion_instance_233, cell, tmp0_safe_receiver, provider);
    }
    return tmp;
  };
  protoOf(Companion_233).qc6 = function (cell, provider) {
    var tmp0_elvis_lhs = cell.bp();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var parentCell = tmp;
    var tmp1_elvis_lhs = this.pc6(parentCell, provider);
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      return null;
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    var _destruct__k2r9zo = tmp_0;
    var parentCellPath = _destruct__k2r9zo.fg();
    var node = _destruct__k2r9zo.gg();
    var pathInParent = TreePath_init_$Create$_0(cell, ensureNotNull(cell.bp()));
    return to(parentCellPath.rc6(VOID, parentCellPath.mc6_1.s8t(pathInParent)), node);
  };
  var Companion_instance_233;
  function Companion_getInstance_233() {
    return Companion_instance_233;
  }
  function CellPath(index, path) {
    this.lc6_1 = index;
    this.mc6_1 = path;
  }
  protoOf(CellPath).nc6 = function (node, provider) {
    return this.mc6_1.q8t(this.sc6(node, provider));
  };
  protoOf(CellPath).tc6 = function (node, provider) {
    var tmp;
    if (hasNodeCell(this, node, provider)) {
      tmp = this.mc6_1.r8t(this.sc6(node, provider));
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(CellPath).sc6 = function (node, provider) {
    return provider.oc6(node).r(this.lc6_1);
  };
  protoOf(CellPath).uc6 = function (index, path) {
    return new CellPath(index, path);
  };
  protoOf(CellPath).rc6 = function (index, path, $super) {
    index = index === VOID ? this.lc6_1 : index;
    path = path === VOID ? this.mc6_1 : path;
    return $super === VOID ? this.uc6(index, path) : $super.uc6.call(this, index, path);
  };
  protoOf(CellPath).toString = function () {
    return 'CellPath(index=' + this.lc6_1 + ', path=' + this.mc6_1.toString() + ')';
  };
  protoOf(CellPath).hashCode = function () {
    var result = this.lc6_1;
    result = imul(result, 31) + this.mc6_1.hashCode() | 0;
    return result;
  };
  protoOf(CellPath).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CellPath))
      return false;
    if (!(this.lc6_1 === other.lc6_1))
      return false;
    if (!this.mc6_1.equals(other.mc6_1))
      return false;
    return true;
  };
  function CellStateAfterExternalOpRestorer(cellStateManager) {
    this.vc6_1 = cellStateManager;
    this.wc6_1 = null;
  }
  protoOf(CellStateAfterExternalOpRestorer).w3y = function () {
    this.wc6_1 = this.vc6_1.fc7();
  };
  protoOf(CellStateAfterExternalOpRestorer).gc7 = function (op) {
    if (!(this.wc6_1 == null)) {
      try {
        var transformed = ensureNotNull(this.wc6_1).fc6(op);
        if (!Companion_getInstance_232().yc5(transformed, this.wc6_1)) {
          transformed.dc6(this.vc6_1.yc6_1, this.vc6_1.bc7_1);
        }
      }finally {
        this.wc6_1 = null;
      }
    }
  };
  protoOf(CellStateAfterExternalOpRestorer).x3y = function (op) {
    return this.gc7(op);
  };
  function _get_focusedCellContext__gbcdrf($this) {
    var tmp0_safe_receiver = $this.zc6_1.z92().uv();
    var normalizedFocusedCell = tmp0_safe_receiver == null ? null : getNonPopupAncestor(tmp0_safe_receiver);
    var cellToFocus = normalizedFocusedCell;
    if (!(normalizedFocusedCell == null) && !normalizedFocusedCell.p92().uv()) {
      cellToFocus = firstFocusable(normalizedFocusedCell);
    }
    return to(normalizedFocusedCell, cellToFocus);
  }
  function _get_stateContext__44199p($this) {
    var focusedCellCtx = _get_focusedCellContext__gbcdrf($this);
    var focusedCellAndAncestors = ArrayDeque_init_$Create$();
    var current = focusedCellCtx.pg_1;
    while (!(current == null)) {
      var handler = current.c93(Companion_getInstance_189().ma6_1);
      if (!(handler == null)) {
        focusedCellAndAncestors.m2(0, current);
      }
      current = current.bp();
    }
    var cellsToSave = LinkedHashSet_init_$Create$_0(focusedCellAndAncestors);
    cellsToSave.q($this.cc7_1);
    return new Pair(focusedCellCtx.qg_1, cellsToSave);
  }
  function focusedState($this, cell) {
    return Companion_getInstance_232().cc6($this.xc6_1, cell, emptySet(), $this.ac7_1, $this.bc7_1);
  }
  function doGetCellContainerState($this) {
    var ctx = _get_stateContext__44199p($this);
    return Companion_getInstance_232().cc6($this.xc6_1, ctx.pg_1, ctx.qg_1, $this.ac7_1, $this.bc7_1);
  }
  function CellStateManager$1(this$0) {
    this.hc7_1 = this$0;
  }
  protoOf(CellStateManager$1).j93 = function (cell, prop, change) {
    this.hc7_1.ec7_1 = null;
  };
  protoOf(CellStateManager$1).k93 = function (parent, change) {
    this.hc7_1.ec7_1 = null;
  };
  protoOf(CellStateManager$1).l93 = function (parent, change) {
    this.hc7_1.ec7_1 = null;
  };
  function CellStateManager(containerId, entityContext, cellContainer, operationProvider, cellProvider) {
    this.xc6_1 = containerId;
    this.yc6_1 = entityContext;
    this.zc6_1 = cellContainer;
    this.ac7_1 = operationProvider;
    this.bc7_1 = cellProvider;
    this.cc7_1 = HashSet_init_$Create$();
    this.ec7_1 = null;
    var tmp = this;
    tmp.dc7_1 = this.zc6_1.i9v(new CellStateManager$1(this));
  }
  protoOf(CellStateManager).ic7 = function () {
    return focusedState(this, _get_focusedCellContext__gbcdrf(this).qg_1);
  };
  protoOf(CellStateManager).fc7 = function () {
    var state = this.ec7_1;
    if (state == null) {
      state = doGetCellContainerState(this);
      this.ec7_1 = state;
    }
    return state;
  };
  protoOf(CellStateManager).jc7 = function () {
    var _iterator__ex2g4s = _get_stateContext__44199p(this).qg_1.m();
    while (_iterator__ex2g4s.n()) {
      var cell = _iterator__ex2g4s.o();
      if (get_stateHandler(cell).ya7(cell)) {
        if (this.cc7_1.t(cell)) {
          this.cc7_1.h2(cell);
          this.ec7_1 = null;
        }
      } else {
        if (!this.cc7_1.t(cell)) {
          this.cc7_1.j(cell);
          this.ec7_1 = null;
        }
      }
    }
  };
  protoOf(CellStateManager).kc7 = function (removed) {
    if (this.cc7_1.t(removed)) {
      this.cc7_1.h2(removed);
      this.ec7_1 = null;
    }
    var _iterator__ex2g4s = removed.o35().m();
    while (_iterator__ex2g4s.n()) {
      var child = _iterator__ex2g4s.o();
      this.kc7(child);
    }
  };
  protoOf(CellStateManager).lc7 = function (state) {
    if (equals(this.xc6_1, state.zc5_1)) {
      state.dc6(this.yc6_1, this.bc7_1);
    }
  };
  protoOf(CellStateManager).mc7 = function (cell) {
    // Inline function 'kotlin.require' call
    if (!equals(cell.s8x(), this.zc6_1)) {
      var message = toString_1(cell) + " doesn't belong to " + toString_1(this.zc6_1) + ': ' + toString_0(cell.s8x());
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    return focusedState(this, cell);
  };
  protoOf(CellStateManager).zr = function () {
    this.cc7_1.k2();
    this.dc7_1.zr();
  };
  function CellStateOperation$doExecute$lambda(this$0, $node, $provider) {
    return function () {
      var cell = this$0.kc6($node, $provider);
      get_stateHandler(cell).aa8(cell, this$0.uc5_1);
      return Unit_instance;
    };
  }
  function CellStateOperation(cellState, path) {
    CellOperation.call(this, path);
    this.uc5_1 = cellState;
  }
  protoOf(CellStateOperation).jc6 = function (otherOp, server) {
    var tmp;
    var tmp_0 = this.uc5_1;
    if (isInterface(tmp_0, TransformableCellState)) {
      var transformedState = this.uc5_1.nc7(otherOp);
      var tmp_1;
      if (transformedState == null) {
        tmp_1 = new NopOperation();
      } else {
        tmp_1 = new CellStateOperation(transformedState, this.lc5_1);
      }
      tmp = tmp_1;
    } else {
      tmp = new NopOperation();
    }
    return tmp;
  };
  protoOf(CellStateOperation).q43 = function (otherOp, server) {
    return this.jc6(otherOp, server);
  };
  protoOf(CellStateOperation).ic6 = function (node, provider) {
    var nodeCell = this.lc5_1.sc6(node, provider);
    whenDescendantsReady(nodeCell, CellStateOperation$doExecute$lambda(this, node, provider));
  };
  function DefaultOperationProvider$ModelOperationSupplier$get$ref(p0) {
    var l = function (_this__u8e3s4, p0_0) {
      return p0.pc7(_this__u8e3s4, p0_0);
    };
    l.callableName = 'get';
    return l;
  }
  function ModelOperationSupplier(cellProvider) {
    this.oc7_1 = cellProvider;
  }
  protoOf(ModelOperationSupplier).pc7 = function (node, operation) {
    var nodeCell = firstOrNull_1(this.oc7_1.oc6(node));
    var tmp;
    if (!(nodeCell == null) && nodeCell.c93(Cells_getInstance().h9t_1)) {
      // Inline function 'kotlin.checkNotNull' call
      var tmp0 = Companion_instance_233.qc6(nodeCell, this.oc7_1);
      var tmp$ret$1;
      $l$block: {
        // Inline function 'kotlin.checkNotNull' call
        if (tmp0 == null) {
          var message = 'Required value was null.';
          throw IllegalStateException_init_$Create$_0(toString_1(message));
        } else {
          tmp$ret$1 = tmp0;
          break $l$block;
        }
      }
      var _destruct__k2r9zo = tmp$ret$1;
      var cellPath = _destruct__k2r9zo.fg();
      var enclosingNode = _destruct__k2r9zo.gg();
      var nonChildNodeOp = new NonChildNodeOperation(cellPath, node.z3n(), operation);
      var tmp_0 = ModelOperationConverter_instance;
      tmp = tmp_0.h4l(enclosingNode, nonChildNodeOp, DefaultOperationProvider$ModelOperationSupplier$get$ref(this));
    } else if (node.d3o() == null) {
      tmp = new SetModelOperation(operation);
    } else {
      tmp = null;
    }
    return tmp;
  };
  function DefaultOperationProvider$ModelOperationSupplier$get$ref_0(p0) {
    var l = function (_this__u8e3s4, p0_0) {
      return p0.pc7(_this__u8e3s4, p0_0);
    };
    l.callableName = 'get';
    return l;
  }
  function DefaultOperationProvider(root, modelId) {
    this.qc7_1 = root;
    this.rc7_1 = modelId;
  }
  protoOf(DefaultOperationProvider).pc5 = function (node, operation, cellProvider) {
    var tmp = ModelOperationConverter_instance;
    var nodeOp = tmp.h4l(node, operation, DefaultOperationProvider$ModelOperationSupplier$get$ref_0(new ModelOperationSupplier(cellProvider)));
    var entityOp = new ChangeModelBlobOperation(this.rc7_1, nodeOp);
    return OperationConverter_instance.m3z(this.qc7_1, entityOp);
  };
  function FocusOperation$doExecute$lambda(this$0, $node, $provider) {
    return function () {
      var tmp;
      if (this$0.lc5_1.tc6($node, $provider)) {
        var cell = this$0.kc6($node, $provider);
        ensureNotNull(cell.s8x()).z92().d2x(cell);
        tmp = Unit_instance;
      } else {
        tmp = toLastFocusable(this$0.lc5_1.sc6($node, $provider))();
      }
      return Unit_instance;
    };
  }
  function FocusOperation(path) {
    CellOperation.call(this, path);
  }
  protoOf(FocusOperation).ic6 = function (node, provider) {
    var nodeCell = this.lc5_1.sc6(node, provider);
    whenDescendantsReady(nodeCell, FocusOperation$doExecute$lambda(this, node, provider));
  };
  function dropHead($this) {
    if (!($this.xc7_1 === get_lastIndex_2($this.wc7_1))) {
      subListTail_0($this.wc7_1, $this.xc7_1 + 1 | 0).k2();
    }
  }
  function dropTail($this) {
    var size = $this.wc7_1.p();
    if (size > $this.vc7_1) {
      $this.wc7_1.g2(0, size - $this.vc7_1 | 0).k2();
    }
  }
  function shouldPush($this, location) {
    return !(location == null) && equals(location.s8x(), ensureNotNull($this.dc8_1.bc8_1).zc6_1);
  }
  function ensureCellStateManagerSet($this) {
    var tmp0 = $this.bc8_1;
    $l$block: {
      // Inline function 'kotlin.checkNotNull' call
      if (tmp0 == null) {
        var message = 'Navigation while no cell container available';
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      } else {
        break $l$block;
      }
    }
  }
  function navigate($this, back) {
    ensureCellStateManagerSet($this);
    var fromState = ensureNotNull($this.bc8_1).ic7();
    var tmp0_elvis_lhs = $this.zc7_1.ec8(back, fromState);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var toState = tmp;
    var toContainerId = toState.zc5_1;
    if (equals(fromState.zc5_1, toContainerId)) {
      navigate_0($this, toState);
    } else {
      $this.fc8(toContainerId, NavigationManager$navigate$lambda($this, toState));
    }
  }
  function navigate_0($this, to) {
    var toContainerId = to.zc5_1;
    var stateManager = ensureNotNull($this.bc8_1);
    var managerContainerId = stateManager.xc6_1;
    // Inline function 'kotlin.check' call
    if (!equals(toContainerId, managerContainerId)) {
      var message = 'Restoring mismatching state: expected container id=' + toString_1(toContainerId) + ', actual id=' + toString_1(managerContainerId);
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    stateManager.lc7(to);
  }
  function MyStack(maxSize) {
    this.vc7_1 = maxSize;
    this.wc7_1 = ArrayList_init_$Create$_0(this.vc7_1);
    this.xc7_1 = 0;
  }
  protoOf(MyStack).gc8 = function (op) {
    var inductionVariable = this.wc7_1.p() - 1 | 0;
    if (0 <= inductionVariable)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        var location = this.wc7_1.r(i);
        var newLocation = location.fc6(op);
        this.wc7_1.l2(i, newLocation);
      }
       while (0 <= inductionVariable);
  };
  protoOf(MyStack).ec8 = function (back, from) {
    var position = back ? this.xc7_1 - 1 | 0 : this.xc7_1 < (this.wc7_1.p() - 1 | 0) ? this.xc7_1 + 1 | 0 : -1;
    if (position < 0) {
      return null;
    }
    var current = this.wc7_1.r(this.xc7_1);
    if (!Companion_getInstance_232().yc5(current, from)) {
      this.wc7_1.l2(this.xc7_1, from);
    }
    var to = this.wc7_1.r(position);
    this.xc7_1 = position;
    return to;
  };
  protoOf(MyStack).hc8 = function (state, isFrom) {
    var tmp;
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!this.wc7_1.s()) {
      tmp = isFrom;
    } else {
      tmp = false;
    }
    if (tmp) {
      dropHead(this);
      if (Companion_getInstance_232().yc5(this.wc7_1.r(this.xc7_1), state)) {
        this.wc7_1.n2(this.xc7_1);
      }
    }
    this.wc7_1.j(state);
    dropTail(this);
    this.xc7_1 = get_lastIndex_2(this.wc7_1);
  };
  function NavigationManager$1(this$0) {
    this.dc8_1 = this$0;
    CellTrait.call(this);
  }
  protoOf(NavigationManager$1).i8y = function (cell, spec, event) {
    if (spec === Cells_getInstance().f9t_1) {
      ensureCellStateManagerSet(this.dc8_1);
      var e = event instanceof FocusEvent ? event : THROW_CCE();
      var oldValue = e.x9t_1;
      var newValue = e.y9t_1;
      if (oldValue === newValue) {
        return Unit_instance;
      }
      if (shouldPush(this, oldValue)) {
        this.dc8_1.zc7_1.hc8(ensureNotNull(this.dc8_1.bc8_1).mc7(ensureNotNull(oldValue)), true);
      }
      if (shouldPush(this, newValue)) {
        this.dc8_1.zc7_1.hc8(ensureNotNull(this.dc8_1.bc8_1).mc7(ensureNotNull(newValue)), false);
      }
    } else {
      protoOf(CellTrait).i8y.call(this, cell, spec, event);
    }
  };
  protoOf(NavigationManager$1).s8z = function (cell, event) {
    var back = event.o8j([KeyStrokeSpecs_getInstance().k8l_1]);
    if (back || event.o8j([KeyStrokeSpecs_getInstance().l8l_1])) {
      event.n8i();
      navigate(this.dc8_1, back);
      return Unit_instance;
    }
    protoOf(CellTrait).s8z.call(this, cell, event);
  };
  function NavigationManager$2(this$0) {
    this.ic8_1 = this$0;
  }
  protoOf(NavigationManager$2).jc8 = function (op) {
    return this.ic8_1.zc7_1.gc8(op);
  };
  protoOf(NavigationManager$2).r3y = function (op) {
    return this.jc8(op);
  };
  protoOf(NavigationManager$2).gc7 = function (op) {
    return this.ic8_1.zc7_1.gc8(op);
  };
  protoOf(NavigationManager$2).x3y = function (op) {
    return this.gc7(op);
  };
  function NavigationManager$navigate$lambda(this$0, $toState) {
    return function () {
      navigate_0(this$0, $toState);
      return Unit_instance;
    };
  }
  function NavigationManager(processor, maxStackSize) {
    this.bc8_1 = null;
    this.cc8_1 = Companion_getInstance_29().m2l_1;
    this.zc7_1 = new MyStack(maxStackSize);
    var tmp = this;
    tmp.yc7_1 = new NavigationManager$1(this);
    var tmp_0 = this;
    tmp_0.ac8_1 = processor.d3z(new NavigationManager$2(this));
  }
  protoOf(NavigationManager).kc8 = function (cellStateManager) {
    this.cc8_1.zr();
    this.bc8_1 = cellStateManager;
    var tmp = this;
    var tmp1_safe_receiver = cellStateManager == null ? null : cellStateManager.zc6_1;
    var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.t42();
    var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.w92(this.yc7_1);
    tmp.cc8_1 = tmp3_elvis_lhs == null ? Companion_getInstance_29().m2l_1 : tmp3_elvis_lhs;
  };
  protoOf(NavigationManager).zr = function () {
    this.cc8_1.zr();
    this.ac8_1.zr();
  };
  function NodeCellState$restore$1($cellProvider) {
    this.lc8_1 = $cellProvider;
    OperationCondition.call(this);
  }
  protoOf(NodeCellState$restore$1).q40 = function (op) {
    if (op instanceof CellOperation) {
      op.gc6(this.lc8_1);
      return true;
    }
    return false;
  };
  function NodeCellState(operation) {
    this.jc5_1 = operation;
  }
  protoOf(NodeCellState).r3x = function () {
    return this.jc5_1.r3x();
  };
  protoOf(NodeCellState).ec6 = function (context, cellProvider) {
    (new NodeCellState$restore$1(cellProvider)).p40(this.jc5_1);
    this.jc5_1.i43(context);
  };
  protoOf(NodeCellState).toString = function () {
    return 'NodeCellState[' + toString_1(this.jc5_1) + ']';
  };
  function NonChildNodeOperation$doExecute$lambda(this$0, $node, $provider) {
    return function () {
      var cell = this$0.lc5_1.nc6($node, $provider);
      var innerNode = $provider.nc5(cell);
      var tmp;
      if (!(innerNode == null) && NodeUtil_instance.e3w(this$0.pc8_1, innerNode.z3n())) {
        var tmp_0 = this$0.qc8_1;
        if (tmp_0 instanceof CellOperation) {
          this$0.qc8_1.gc6($provider);
        }
        this$0.qc8_1.i43(innerNode);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function NonChildNodeOperation(cellPath, nodeId, operation) {
    CellOperation.call(this, cellPath);
    this.pc8_1 = nodeId;
    this.qc8_1 = operation;
  }
  protoOf(NonChildNodeOperation).s3z = function () {
    return this.qc8_1;
  };
  protoOf(NonChildNodeOperation).l3p = function () {
    return this.lc5_1;
  };
  protoOf(NonChildNodeOperation).ic6 = function (node, provider) {
    var nodeCell = this.lc5_1.sc6(node, provider);
    whenDescendantsReady(nodeCell, NonChildNodeOperation$doExecute$lambda(this, node, provider));
  };
  function undo($this, kind, cellContainer) {
    var tmp;
    if (kind.equals(ActionKind_UNDO_getInstance())) {
      tmp = $this.rc8_1.a53();
    } else {
      tmp = $this.rc8_1.g53();
    }
    var stateProp = tmp;
    var undoState = stateProp.uv();
    if (undoState.e53()) {
      confirmUndo($this, stateProp, kind, cellContainer);
    } else {
      handleRejection($this, kind, undoState);
    }
  }
  function handleRejection($this, kind, state) {
    $this.sc8_1.tc8(state.c53_1, kind, state.n53());
  }
  function confirmUndo($this, state, kind, cellContainer) {
    var tmp = $this.sc8_1.uc8(state.uv().c53_1, kind);
    tmp.r37(OtSupport$UndoTrait$confirmUndo$lambda(state, kind, cellContainer, $this));
  }
  function UndoManager$undo$ref(p0) {
    var l = function () {
      p0.z52();
      return Unit_instance;
    };
    l.callableName = 'undo';
    return l;
  }
  function UndoManager$redo$ref(p0) {
    var l = function () {
      p0.f53();
      return Unit_instance;
    };
    l.callableName = 'redo';
    return l;
  }
  function OtSupport$UndoTrait$confirmUndo$lambda($state, $kind, $cellContainer, this$0) {
    return function (value) {
      var tmp;
      if (value) {
        var currentState = $state.uv();
        var tmp_0;
        if (currentState.e53()) {
          var tmp_1;
          if ($kind.equals(ActionKind_UNDO_getInstance())) {
            $cellContainer.d9m(UndoManager$undo$ref(this$0.rc8_1));
            tmp_1 = Unit_instance;
          } else {
            $cellContainer.d9m(UndoManager$redo$ref(this$0.rc8_1));
            tmp_1 = Unit_instance;
          }
          tmp_0 = tmp_1;
        } else {
          handleRejection(this$0, $kind, currentState);
          tmp_0 = Unit_instance;
        }
        tmp = tmp_0;
      }
      return Unit_instance;
    };
  }
  function OtSupport$CellContainerCommandWatcher$lambda(this$0, $undoManager) {
    return function (event) {
      var newValue = event.t2y_1;
      var tmp;
      if (!(newValue === Companion_getInstance_48().z3w_1)) {
        // Inline function 'kotlin.check' call
        if (!(event.s2y_1 === Companion_getInstance_48().z3w_1)) {
          var message = 'Reset non-default group id: ' + event.toString();
          throw IllegalStateException_init_$Create$_0(toString_1(message));
        }
        var tmp_0;
        if (this$0.vc8_1.l3x_1) {
          $undoManager.s52(newValue);
          tmp_0 = Unit_instance;
        }
        tmp = tmp_0;
      }
      return Unit_instance;
    };
  }
  function getUndoGroupId($this, cellContainer) {
    return cellContainer.t42().n92($this.cc9_1);
  }
  function UndoTrait(undoManager, undoStateHandler) {
    CellTrait.call(this);
    this.rc8_1 = undoManager;
    this.sc8_1 = undoStateHandler;
  }
  protoOf(UndoTrait).s8z = function (cell, event) {
    var tmp;
    if (event.o8j([KeyStrokeSpecs_getInstance().g8k_1])) {
      event.n8i();
      undo(this, ActionKind_UNDO_getInstance(), ensureNotNull(cell.s8x()));
      tmp = Unit_instance;
    } else if (event.o8j([KeyStrokeSpecs_getInstance().h8k_1])) {
      event.n8i();
      undo(this, ActionKind_REDO_getInstance(), ensureNotNull(cell.s8x()));
      tmp = Unit_instance;
    } else {
      protoOf(CellTrait).s8z.call(this, cell, event);
      tmp = Unit_instance;
    }
    return tmp;
  };
  function CellContainerCommandWatcher(processor, cellStateManager, undoManager) {
    this.vc8_1 = processor;
    this.wc8_1 = cellStateManager;
    this.xc8_1 = getUndoGroupId(Companion_getInstance_234(), this.wc8_1.zc6_1);
    this.zc8_1 = false;
    var tmp = this;
    tmp.yc8_1 = this.xc8_1.z2r(OtSupport$CellContainerCommandWatcher$lambda(this, undoManager));
  }
  protoOf(CellContainerCommandWatcher).h93 = function () {
    if (!this.vc8_1.m3x_1) {
      this.vc8_1.f3z(this.xc8_1.uv());
      this.zc8_1 = true;
    }
  };
  protoOf(CellContainerCommandWatcher).i93 = function () {
    if (this.zc8_1) {
      this.zc8_1 = false;
      this.vc8_1.g3z();
      this.wc8_1.jc7();
    }
  };
  protoOf(CellContainerCommandWatcher).l93 = function (parent, change) {
    return this.wc8_1.kc7(change.s2r());
  };
  protoOf(CellContainerCommandWatcher).zr = function () {
    this.yc8_1.zr();
    this.i93();
  };
  function Companion_234() {
    Companion_instance_234 = this;
    this.ac9_1 = 100;
    this.bc9_1 = 10;
    this.cc9_1 = CellPropertySpec_init_$Create$('undoGroupId', Companion_getInstance_48().z3w_1);
  }
  protoOf(Companion_234).dc9 = function () {
    return Companion_getInstance_232().qc5_1;
  };
  var Companion_instance_234;
  function Companion_getInstance_234() {
    if (Companion_instance_234 == null)
      new Companion_234();
    return Companion_instance_234;
  }
  function OtSupport(commandProcessor, cellStateManager, undoManager, undoStateHandler, allowUndo) {
    Companion_getInstance_234();
    allowUndo = allowUndo === VOID ? true : allowUndo;
    this.ec9_1 = cellStateManager;
    this.fc9_1 = undoManager;
    this.hc9_1 = new CompositeDisposable([]);
    var containerWatcher = new CellContainerCommandWatcher(commandProcessor, this.ec9_1, this.fc9_1);
    var cellContainer = this.ec9_1.zc6_1;
    this.gc9_1 = containerWatcher.j2l(cellContainer.i9v(containerWatcher)).j2l(commandProcessor.d3z(new CellStateAfterExternalOpRestorer(this.ec9_1)));
    if (allowUndo) {
      var trait = new UndoTrait(this.fc9_1, undoStateHandler);
      this.ic9(cellContainer.t42().w92(trait));
    }
  }
  protoOf(OtSupport).ic9 = function (action) {
    this.hc9_1.l2l([action]);
  };
  protoOf(OtSupport).zr = function () {
    this.hc9_1.zr();
    this.gc9_1.zr();
  };
  function getSelectionUndoCommandType($this, savedSelection, currentSelection) {
    if (savedSelection == null) {
      return UndoCommandType_EMPTY_getInstance();
    }
    var path = Companion_getInstance_232().wc5(savedSelection);
    return path == null ? UndoCommandType_EMPTY_getInstance() : Companion_getInstance_232().xc5(savedSelection, currentSelection) ? UndoCommandType_EMPTY_getInstance() : UndoCommandType_NAVIGATION_getInstance();
  }
  function OtViewStateProvider() {
    this.jc9_1 = null;
  }
  protoOf(OtViewStateProvider).n52 = function () {
    var tmp;
    if (this.jc9_1 == null) {
      tmp = null;
    } else {
      tmp = ensureNotNull(this.jc9_1).fc7();
    }
    return tmp;
  };
  protoOf(OtViewStateProvider).kc8 = function (cellStateManager) {
    this.jc9_1 = cellStateManager;
  };
  protoOf(OtViewStateProvider).kc9 = function (state) {
    var tmp0 = this.jc9_1;
    $l$block: {
      // Inline function 'kotlin.checkNotNull' call
      if (tmp0 == null) {
        var message = 'Unable to restore state: ' + state.toString();
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      } else {
        break $l$block;
      }
    }
    ensureNotNull(this.jc9_1).lc7(state);
  };
  protoOf(OtViewStateProvider).s51 = function (state) {
    return this.kc9(state instanceof CellContainerState ? state : THROW_CCE());
  };
  protoOf(OtViewStateProvider).lc9 = function (saved, current) {
    if (!equals(saved.zc5_1, current.zc5_1)) {
      return UndoCommandType_NAVIGATION_getInstance();
    }
    var savedPaths = Companion_getInstance_232().vc5(saved.bc6_1);
    var currentPaths = Companion_getInstance_232().vc5(current.bc6_1);
    var containerStateDifference = CellStateDifference_EQUAL_getInstance();
    var _iterator__ex2g4s = savedPaths.r2().m();
    while (_iterator__ex2g4s.n()) {
      var path = _iterator__ex2g4s.o();
      var cellState = currentPaths.q2(path);
      var cellDifference = getValue_0(savedPaths, path).xa7(cellState);
      if (cellDifference.equals(CellStateDifference_EDIT_getInstance())) {
        return UndoCommandType_EDITING_getInstance();
      }
      containerStateDifference = Companion_instance_188.vaa(containerStateDifference, cellDifference);
    }
    var tmp;
    if (!containerStateDifference.equals(CellStateDifference_EQUAL_getInstance())) {
      tmp = UndoCommandType_NAVIGATION_getInstance();
    } else {
      tmp = getSelectionUndoCommandType(this, saved.ac6_1, current.ac6_1);
    }
    return tmp;
  };
  protoOf(OtViewStateProvider).v53 = function (saved, current) {
    var tmp = saved instanceof CellContainerState ? saved : THROW_CCE();
    return this.lc9(tmp, current instanceof CellContainerState ? current : THROW_CCE());
  };
  protoOf(OtViewStateProvider).toString = function () {
    var name = getKClassFromExpression(this).ra();
    return plus_12(name, '@') + toString_3(hashCode(this), 16);
  };
  function SimpleUndoStateHandler() {
  }
  protoOf(SimpleUndoStateHandler).uc8 = function (groupId, actionKind) {
    return Asyncs_instance.y37(true);
  };
  protoOf(SimpleUndoStateHandler).tc8 = function (groupId, actionKind, rejectionInfo) {
  };
  function TransformableCellState() {
  }
  var ActionKind_UNDO_instance;
  var ActionKind_REDO_instance;
  var ActionKind_entriesInitialized;
  function ActionKind_initEntries() {
    if (ActionKind_entriesInitialized)
      return Unit_instance;
    ActionKind_entriesInitialized = true;
    ActionKind_UNDO_instance = new ActionKind('UNDO', 0);
    ActionKind_REDO_instance = new ActionKind('REDO', 1);
  }
  function ActionKind(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function Companion_235() {
    Companion_instance_235 = this;
    this.mc9_1 = new SimpleUndoStateHandler();
  }
  var Companion_instance_235;
  function Companion_getInstance_235() {
    if (Companion_instance_235 == null)
      new Companion_235();
    return Companion_instance_235;
  }
  function ActionKind_UNDO_getInstance() {
    ActionKind_initEntries();
    return ActionKind_UNDO_instance;
  }
  function ActionKind_REDO_getInstance() {
    ActionKind_initEntries();
    return ActionKind_REDO_instance;
  }
  function NodeCellProvider$getNode$lambda(it) {
    return true;
  }
  function NodeCellProvider() {
  }
  function NodeWrapperCellProvider$getCells$sourcePath$1($nodeWrapper) {
    this.oc9_1 = $nodeWrapper;
  }
  protoOf(NodeWrapperCellProvider$getCells$sourcePath$1).n = function () {
    return !(this.oc9_1 == null);
  };
  protoOf(NodeWrapperCellProvider$getCells$sourcePath$1).o = function () {
    var tmp0_elvis_lhs = this.oc9_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw NoSuchElementException_init_$Create$();
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var next = tmp;
    this.oc9_1 = next.d3o();
    return next;
  };
  function NodeWrapperCellProvider$getNode$lambda($predicate) {
    return function (source) {
      var tmp;
      if (source instanceof NodeWrapper) {
        tmp = $predicate(source.b57_1);
      } else {
        tmp = false;
      }
      return tmp;
    };
  }
  function NodeWrapperCellProvider(wrapperContext, provider) {
    this.pc9_1 = wrapperContext;
    this.qc9_1 = provider;
  }
  protoOf(NodeWrapperCellProvider).oc6 = function (source) {
    var nodeWrapper = this.pc9_1.c57(source instanceof Node_0 ? source : THROW_CCE());
    var sourcePath = new NodeWrapperCellProvider$getCells$sourcePath$1(nodeWrapper);
    return this.qc9_1.oah(sourcePath);
  };
  protoOf(NodeWrapperCellProvider).nc9 = function (cell, predicate) {
    var tmp = this.qc9_1.pah(cell, NodeWrapperCellProvider$getNode$lambda(predicate));
    var source = tmp instanceof NodeWrapper ? tmp : null;
    return source == null ? null : source.b57_1;
  };
  function OtNodeCellProvider$getCells$sourcePath$1($source) {
    this.rc9_1 = $source;
  }
  protoOf(OtNodeCellProvider$getCells$sourcePath$1).n = function () {
    return !(this.rc9_1 == null);
  };
  protoOf(OtNodeCellProvider$getCells$sourcePath$1).o = function () {
    var tmp0_elvis_lhs = this.rc9_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw NoSuchElementException_init_$Create$();
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var next = tmp;
    this.rc9_1 = next.d3o();
    return next;
  };
  function OtNodeCellProvider$getNode$lambda($predicate) {
    return function (source) {
      var tmp;
      if (source instanceof OtNode) {
        tmp = $predicate(source);
      } else {
        tmp = false;
      }
      return tmp;
    };
  }
  function OtNodeCellProvider(provider) {
    this.sc9_1 = provider;
  }
  protoOf(OtNodeCellProvider).oc6 = function (source) {
    var sourcePath = new OtNodeCellProvider$getCells$sourcePath$1(source);
    return this.sc9_1.oah(sourcePath);
  };
  protoOf(OtNodeCellProvider).nc9 = function (cell, predicate) {
    var tmp = this.sc9_1.pah(cell, OtNodeCellProvider$getNode$lambda(predicate));
    var source = tmp instanceof OtNode ? tmp : null;
    return source;
  };
  function getNodeWrapperCellProviderFromMapper(mapper, context) {
    context = context === VOID ? mapper.e86_1.a57_1 : context;
    var cellProvider = getCellProviderFromMapper(mapper);
    return new NodeWrapperCellProvider(context, cellProvider);
  }
  function getNodeCellProviderFromMapper(mapper) {
    var tmp0_subject = mapper.e86_1;
    var tmp;
    if (tmp0_subject instanceof OtNode) {
      tmp = getOtNodeCellProviderFromMapper(mapper instanceof Mapper ? mapper : THROW_CCE());
    } else {
      if (tmp0_subject instanceof NodeWrapper) {
        tmp = getNodeWrapperCellProviderFromMapper(mapper instanceof Mapper ? mapper : THROW_CCE());
      } else {
        var message = 'Unexpected source: ' + toString_0(mapper.e86_1);
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      }
    }
    return tmp;
  }
  function getOtNodeCellProviderFromMapper(mapper) {
    var cellProvider = getCellProviderFromMapper(mapper);
    return new OtNodeCellProvider(cellProvider);
  }
  function _get_cellContainer__92er8y($this) {
    var tmp = $this.tc9_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('cellContainer');
    }
  }
  function _get_processor__en8wzl($this) {
    var tmp = $this.uc9_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('processor');
    }
  }
  function _get_cellProvider__u40mk8($this) {
    var tmp = $this.vc9_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('cellProvider');
    }
  }
  function _get_operationProvider__dyl06f($this) {
    var tmp = $this.wc9_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('operationProvider');
    }
  }
  function verifyComponents($this) {
    // Inline function 'kotlin.check' call
    if (!($this.zc9_1 >= 0)) {
      var message = 'Max navigation stack size value is negative';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    // Inline function 'kotlin.check' call
    if (!($this.yc9_1 >= 0)) {
      var message_0 = 'Max undo stack size is negative';
      throw IllegalStateException_init_$Create$_0(toString_1(message_0));
    }
  }
  function OtSupportBuilder() {
    this.xc9_1 = Companion_getInstance_235().mc9_1;
    this.yc9_1 = 100;
    this.zc9_1 = 10;
    this.aca_1 = true;
  }
  protoOf(OtSupportBuilder).f40 = function () {
    verifyComponents(this);
    var undoManager = singleStackUndoManager(_get_processor__en8wzl(this), this.yc9_1, this.aca_1);
    var otViewStateProvider = new OtViewStateProvider();
    var viewStateProviderReg = undoManager.v52(otViewStateProvider);
    var navigationManager = new SingleNavigationManager(_get_processor__en8wzl(this), this.zc9_1);
    var cellStateManager = new CellStateManager(ensureNotNull(undoManager.l51_1), _get_processor__en8wzl(this).b3x_1, _get_cellContainer__92er8y(this), _get_operationProvider__dyl06f(this), _get_cellProvider__u40mk8(this));
    otViewStateProvider.kc8(cellStateManager);
    navigationManager.kc8(cellStateManager);
    var otSupport = new OtSupport(_get_processor__en8wzl(this), cellStateManager, undoManager, this.xc9_1, this.aca_1);
    otSupport.ic9(viewStateProviderReg);
    otSupport.ic9(cellStateManager);
    otSupport.ic9(undoManager);
    otSupport.ic9(navigationManager);
    return otSupport;
  };
  protoOf(OtSupportBuilder).bca = function (cellContainer) {
    this.tc9_1 = cellContainer;
    return this;
  };
  protoOf(OtSupportBuilder).cca = function (processor) {
    this.uc9_1 = processor;
    return this;
  };
  protoOf(OtSupportBuilder).dca = function (cellProvider) {
    this.vc9_1 = cellProvider;
    return this;
  };
  protoOf(OtSupportBuilder).eca = function (operationProvider) {
    this.wc9_1 = operationProvider;
    return this;
  };
  function SingleNavigationManager(processor, maxStackSize) {
    NavigationManager.call(this, processor, maxStackSize);
  }
  protoOf(SingleNavigationManager).fc8 = function (containerId, callback) {
    throw UnsupportedOperationException_init_$Create$();
  };
  function _get_cm__ndbyw1($this) {
    var tmp = $this.oca_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('cm');
    }
  }
  function _get_hm__ndc2li($this) {
    var tmp = $this.pca_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('hm');
    }
  }
  function HighlightErrorsSynchronizer$trait$1(this$0) {
    this.rca_1 = this$0;
    CellTrait.call(this);
  }
  protoOf(HighlightErrorsSynchronizer$trait$1).n91 = function (cell, spec) {
    if (spec === Companion_getInstance_242().sca_1) {
      var highlighter = _get_hm__ndc2li(this.rca_1).w2w();
      return highlighter;
    }
    return protoOf(CellTrait).n91.call(this, cell, spec);
  };
  function HighlightErrorsSynchronizer(coroutineScope, source, cell, checking) {
    this.kca_1 = coroutineScope;
    this.lca_1 = source;
    this.mca_1 = cell;
    this.nca_1 = checking;
    var tmp = this;
    tmp.qca_1 = new HighlightErrorsSynchronizer$trait$1(this);
  }
  protoOf(HighlightErrorsSynchronizer).y86 = function (ctx) {
    this.oca_1 = ctx.z86().r89();
    this.pca_1 = ctx.z86().r89();
    this.mca_1.w92(this.qca_1);
    var checker = new CheckNodeMapper(this.kca_1, this.nca_1, this.lca_1);
    var highlighter = new ProjectionalHighlightMapper(this.lca_1, this.mca_1, ctx.z86(), checker.f86_1);
    _get_cm__ndbyw1(this).f2x(checker);
    _get_hm__ndc2li(this).f2x(highlighter);
  };
  protoOf(HighlightErrorsSynchronizer).e6j = function () {
    _get_cm__ndbyw1(this).f2x(null);
    _get_hm__ndc2li(this).f2x(null);
  };
  function get_highlighted(_this__u8e3s4) {
    return new highlighted$1(_this__u8e3s4);
  }
  function highlighted(_this__u8e3s4, coroutineScope, errorCheckConfig) {
    var tmp;
    if (_this__u8e3s4.f86_1.c93(Companion_getInstance_236().tca_1)) {
      tmp = _this__u8e3s4;
    } else {
      tmp = Mappers_instance.d8a(_this__u8e3s4, [new HighlightingMapper(coroutineScope, errorCheckConfig, _this__u8e3s4.e86_1, _this__u8e3s4.f86_1)]);
    }
    return tmp;
  }
  function Companion_236() {
    Companion_instance_236 = this;
    this.tca_1 = CellTraitPropertySpec_init_$Create$('SuppressErrorChecking', false);
  }
  var Companion_instance_236;
  function Companion_getInstance_236() {
    if (Companion_instance_236 == null)
      new Companion_236();
    return Companion_instance_236;
  }
  function HighlightingMapper(coroutineScope, errorCheckConfig, node, cell) {
    Companion_getInstance_236();
    Mapper.call(this, node, cell);
    this.bcb_1 = coroutineScope;
    this.ccb_1 = errorCheckConfig;
    this.dcb_1 = false;
  }
  protoOf(HighlightingMapper).g87 = function () {
    return this.dcb_1;
  };
  protoOf(HighlightingMapper).a88 = function (conf) {
    protoOf(Mapper).a88.call(this, conf);
    var tmp = getKClassFromExpression(this.e86_1);
    var concept = isInterface(tmp, KClass) ? tmp : THROW_CCE();
    conf.h5v(new HighlightErrorsSynchronizer(this.bcb_1, this.e86_1, this.f86_1, this.ccb_1.j70(concept)));
  };
  function highlighted$1($this_highlighted) {
    this.fcb_1 = $this_highlighted;
    this.ecb_1 = $this_highlighted;
  }
  protoOf(highlighted$1).gcb = function (configuration, source) {
    return highlighted(this.fcb_1.hcb(configuration, source), configuration, configuration);
  };
  protoOf(highlighted$1).hcb = function (configuration, source) {
    var tmp = (!(configuration == null) ? isInterface(configuration, CoroutineScope) ? isInterface(configuration, ErrorCheckConfig) : false : false) ? configuration : THROW_CCE();
    return this.gcb(tmp, isInterface(source, DomainNode) ? source : THROW_CCE());
  };
  protoOf(highlighted$1).icb = function () {
    return this.ecb_1.icb();
  };
  function Companion_237() {
    Companion_instance_237 = this;
    this.jcb_1 = CellTraitPropertySpec_init_$Create$('SecondaryCellForNode', false);
  }
  var Companion_instance_237;
  function Companion_getInstance_237() {
    if (Companion_instance_237 == null)
      new Companion_237();
    return Companion_instance_237;
  }
  function ProjectionalHighlightMapper(source, target, enclosing, errors) {
    Companion_getInstance_237();
    ErrorHighlighterBase.call(this, source, target, errors);
    this.tcb_1 = enclosing;
  }
  protoOf(ProjectionalHighlightMapper).g87 = function () {
    return false;
  };
  protoOf(ProjectionalHighlightMapper).ucb = function () {
    var result = ArrayList_init_$Create$();
    var _iterator__ex2g4s = get_descendants(this.f86_1).m();
    while (_iterator__ex2g4s.n()) {
      var cell = _iterator__ex2g4s.o();
      var descendant = cell.c93(Companion_getInstance_242().sca_1);
      if (!(descendant == null)) {
        result.j(descendant);
      }
    }
    return result;
  };
  protoOf(ProjectionalHighlightMapper).vcb = function (node) {
    var mappers = this.b88().e8a(root(this.tcb_1), node);
    var targetCells = HashSet_init_$Create$();
    var _iterator__ex2g4s = mappers.m();
    while (_iterator__ex2g4s.n()) {
      var m = _iterator__ex2g4s.o();
      var mapperTarget = m.f86_1;
      var tmp;
      if (!(mapperTarget == null) ? isInterface(mapperTarget, Cell) : false) {
        tmp = !mapperTarget.c93(Companion_getInstance_237().jcb_1);
      } else {
        tmp = false;
      }
      if (tmp) {
        targetCells.j(mapperTarget);
      }
    }
    // Inline function 'kotlin.check' call
    if (!(targetCells.p() <= 1)) {
      var message = 'ambiguous mapper for descendant node mentioned in error';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    return firstOrNull_0(targetCells);
  };
  protoOf(ProjectionalHighlightMapper).wcb = function (visual, error) {
    return ErrorHighlightingController_instance.xcb(visual, error.e());
  };
  protoOf(ProjectionalHighlightMapper).ycb = function (visual, error) {
    return this.wcb((!(visual == null) ? isInterface(visual, Cell) : false) ? visual : THROW_CCE(), error);
  };
  protoOf(ProjectionalHighlightMapper).zcb = function (visualGroup, error) {
    return ErrorHighlightingController_instance.acc(visualGroup, error.e());
  };
  protoOf(ProjectionalHighlightMapper).bcc = function (visualGroup, error) {
    return this.zcb(visualGroup, error);
  };
  function update_0($this, cell) {
    return update_1($this, cell, (new ErrorSupport(cell)).mcc());
  }
  function update_1($this, cell, errors) {
    // Inline function 'kotlin.collections.isNotEmpty' call
    var tmp$ret$0 = !errors.s();
    underline($this, cell, tmp$ret$0);
    var tmp;
    if (errors.s()) {
      tmp = null;
    } else {
      var wholeMessage = StringBuilder_init_$Create$_1();
      var _iterator__ex2g4s = errors.m();
      while (_iterator__ex2g4s.n()) {
        var msg = _iterator__ex2g4s.o();
        wholeMessage.j8(msg);
        wholeMessage.j8('\n');
      }
      tmp = new Message(wholeMessage.toString());
    }
    var message = tmp;
    MessageController_getInstance().o9z(cell, message);
  }
  function underline($this, cell, bool) {
    // Inline function 'kotlin.collections.filterIsInstance' call
    var tmp0 = get_descendants(cell);
    // Inline function 'kotlin.collections.filterIsInstanceTo' call
    var destination = ArrayList_init_$Create$();
    var _iterator__ex2g4s = tmp0.m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      if (element instanceof TextCell) {
        destination.j(element);
      }
    }
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s_0 = destination.m();
    while (_iterator__ex2g4s_0.n()) {
      var element_0 = _iterator__ex2g4s_0.o();
      element_0.i90(get_RED_UNDERLINE(), bool);
    }
  }
  function ErrorHighlighterTrait() {
    ErrorHighlighterTrait_instance = this;
    CellTrait.call(this);
  }
  protoOf(ErrorHighlighterTrait).o91 = function (cell) {
    update_0(this, cell);
  };
  protoOf(ErrorHighlighterTrait).c91 = function (cell) {
    update_1(this, cell, emptyList());
  };
  protoOf(ErrorHighlighterTrait).i8y = function (cell, spec, event) {
    if (equals(spec, Companion_getInstance_238().occ_1)) {
      update_0(this, cell);
      return Unit_instance;
    }
    protoOf(CellTrait).i8y.call(this, cell, spec, event);
  };
  var ErrorHighlighterTrait_instance;
  function ErrorHighlighterTrait_getInstance() {
    if (ErrorHighlighterTrait_instance == null)
      new ErrorHighlighterTrait();
    return ErrorHighlighterTrait_instance;
  }
  function ErrorHighlightingController$install$lambda(cell) {
    return NumberOfMessages_getInstance().rcc(cell);
  }
  function ErrorHighlightingController$install$lambda_0(cell) {
    return NumberOfMessages_getInstance().scc(cell);
  }
  function ErrorHighlightingController() {
  }
  protoOf(ErrorHighlightingController).nai = function (cellContainer) {
    var trait = ErrorHighlighterTrait_getInstance();
    var needsAttach = ErrorHighlightingController$install$lambda;
    var needsDetach = ErrorHighlightingController$install$lambda_0;
    return Companion_getInstance_187().k9z(cellContainer, trait, needsAttach, needsDetach).j2l(cellContainer.t42().w92(new MouseTracker()));
  };
  protoOf(ErrorHighlightingController).xcb = function (cell, message) {
    return cell.c93(Companion_getInstance_238().ncc_1).tcc(message);
  };
  protoOf(ErrorHighlightingController).acc = function (cellGroup, message) {
    var reg = new CompositeDisposable([]);
    var groupTrait = new ShowCellGroupTrait(HashSet_init_$Create$_0(cellGroup));
    var _iterator__ex2g4s = cellGroup.m();
    while (_iterator__ex2g4s.n()) {
      var cell = _iterator__ex2g4s.o();
      reg.l2l([this.xcb(cell, message)]);
      reg.l2l([cell.w92(groupTrait)]);
    }
    return reg;
  };
  var ErrorHighlightingController_instance;
  function ErrorHighlightingController_getInstance() {
    return ErrorHighlightingController_instance;
  }
  function ErrorSupport$Companion$PROPERTY$lambda(it) {
    return new ErrorSupport(it);
  }
  function sendEvent($this) {
    return $this.lcc_1.u92(new Event_0(), Companion_getInstance_238().occ_1);
  }
  function Companion_238() {
    Companion_instance_238 = this;
    var tmp = this;
    tmp.ncc_1 = new CellTraitPropertySpec('errorConsumer', ErrorSupport$Companion$PROPERTY$lambda);
    this.occ_1 = new CellTraitEventSpec('errorSetChanged', false);
    this.pcc_1 = CellPropertySpec_init_$Create$('errorList', null);
  }
  var Companion_instance_238;
  function Companion_getInstance_238() {
    if (Companion_instance_238 == null)
      new Companion_238();
    return Companion_instance_238;
  }
  function ErrorSupport$addError$$inlined$toDisposable$1(this$0, $message) {
    this.ucc_1 = this$0;
    this.vcc_1 = $message;
  }
  protoOf(ErrorSupport$addError$$inlined$toDisposable$1).zr = function () {
    var list = this.ucc_1.lcc_1.k91(Companion_getInstance_238().pcc_1);
    // Inline function 'kotlin.check' call
    if (!(!(list == null) && list.t(this.vcc_1))) {
      var message = 'Unbalanced disposal of added error message. Maybe dispose() was called more than once';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    list.h2(this.vcc_1);
    if (list.s()) {
      this.ucc_1.lcc_1.i90(Companion_getInstance_238().pcc_1, null);
    }
    sendEvent(this.ucc_1);
    NumberOfMessages_getInstance().wcc(this.ucc_1.lcc_1);
    return Unit_instance;
  };
  function ErrorSupport(cell) {
    Companion_getInstance_238();
    this.lcc_1 = cell;
  }
  protoOf(ErrorSupport).mcc = function () {
    // Inline function 'kotlin.collections.orEmpty' call
    var tmp0_elvis_lhs = this.lcc_1.k91(Companion_getInstance_238().pcc_1);
    return tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
  };
  protoOf(ErrorSupport).tcc = function (message) {
    var tmp0_elvis_lhs = this.lcc_1.k91(Companion_getInstance_238().pcc_1);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.also' call
      var this_0 = ArrayList_init_$Create$();
      this.lcc_1.i90(Companion_getInstance_238().pcc_1, this_0);
      tmp = this_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var errorList = tmp;
    errorList.j(message);
    NumberOfMessages_getInstance().xcc(this.lcc_1);
    sendEvent(this);
    // Inline function 'jetbrains.ocelot.base.disposable.toDisposable' call
    return new ErrorSupport$addError$$inlined$toDisposable$1(this, message);
  };
  function Companion_239() {
    Companion_instance_239 = this;
    this.ycc_1 = CellTraitPropertySpec_init_$Create$('cellUnderMouse', null);
  }
  var Companion_instance_239;
  function Companion_getInstance_239() {
    if (Companion_instance_239 == null)
      new Companion_239();
    return Companion_instance_239;
  }
  function MouseTracker() {
    Companion_getInstance_239();
    CellTrait.call(this);
    this.zcc_1 = Companion_getInstance_136().h8c_1;
  }
  protoOf(MouseTracker).n91 = function (cell, spec) {
    var tmp;
    if (equals(spec, Companion_getInstance_239().ycc_1)) {
      tmp = ensureNotNull(cell.s8x()).n9u(this.zcc_1);
    } else {
      tmp = protoOf(CellTrait).n91.call(this, cell, spec);
    }
    return tmp;
  };
  protoOf(MouseTracker).v91 = function (cell, event) {
    this.zcc_1 = event.z8l();
  };
  function NumberOfMessages() {
    NumberOfMessages_instance = this;
    this.qcc_1 = CellPropertySpec_init_$Create$('numberOfMessages', 0);
  }
  protoOf(NumberOfMessages).xcc = function (cell) {
    var numOfMsgs = cell.k91(this.qcc_1);
    numOfMsgs = numOfMsgs + 1 | 0;
    cell.i90(this.qcc_1, numOfMsgs);
  };
  protoOf(NumberOfMessages).wcc = function (cell) {
    var numOfMsgs = cell.k91(this.qcc_1);
    // Inline function 'kotlin.check' call
    if (!!(numOfMsgs === 0)) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    numOfMsgs = numOfMsgs - 1 | 0;
    cell.i90(this.qcc_1, numOfMsgs);
  };
  protoOf(NumberOfMessages).rcc = function (cell) {
    return cell.k91(this.qcc_1) > 0;
  };
  protoOf(NumberOfMessages).scc = function (cell) {
    return !this.rcc(cell);
  };
  var NumberOfMessages_instance;
  function NumberOfMessages_getInstance() {
    if (NumberOfMessages_instance == null)
      new NumberOfMessages();
    return NumberOfMessages_instance;
  }
  function enter($this, source) {
    if (showFlagsUnset($this)) {
      show_0($this);
    }
    $this.ccd_1[source] = true;
  }
  function leave($this, source) {
    $this.ccd_1[source] = false;
    if (showFlagsUnset($this)) {
      hide_1($this);
    }
  }
  function showFlagsUnset($this) {
    return !$this.ccd_1[0] && !$this.ccd_1[1];
  }
  function show_0($this) {
    var reg = new CompositeDisposable([]);
    var _iterator__ex2g4s = $this.acd_1.m();
    while (_iterator__ex2g4s.n()) {
      var c = _iterator__ex2g4s.o();
      reg.l2l([mark($this, c)]);
    }
    $this.bcd_1 = reg;
  }
  function hide_1($this) {
    $this.bcd_1.zr();
    $this.bcd_1 = Companion_getInstance_29().m2l_1;
  }
  function mark($this, cell) {
    return cell.i90(get_BACKGROUND(), Companion_getInstance_210().k96_1);
  }
  function Companion_240() {
    this.dcd_1 = 0;
    this.ecd_1 = 1;
  }
  var Companion_instance_240;
  function Companion_getInstance_240() {
    return Companion_instance_240;
  }
  function ShowCellGroupTrait(myCellGroup) {
    CellTrait.call(this);
    this.acd_1 = myCellGroup;
    this.bcd_1 = Companion_getInstance_29().m2l_1;
    this.ccd_1 = booleanArray(2);
  }
  protoOf(ShowCellGroupTrait).o91 = function (cell) {
    protoOf(CellTrait).o91.call(this, cell);
    // Inline function 'kotlin.check' call
    if (!this.acd_1.t(cell)) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    if (isDescendantCellFocused(cell)) {
      enter(this, Companion_instance_240.dcd_1);
    }
    var underMouse = ensureNotNull(cell.s8x()).t42().c93(Companion_getInstance_239().ycc_1);
    if (!(underMouse == null) && isDescendant(cell, underMouse)) {
      enter(this, Companion_instance_240.ecd_1);
    }
  };
  protoOf(ShowCellGroupTrait).c91 = function (cell) {
    hide_1(this);
    protoOf(CellTrait).c91.call(this, cell);
  };
  protoOf(ShowCellGroupTrait).x91 = function (cell, event) {
    protoOf(CellTrait).x91.call(this, cell, event);
    enter(this, Companion_instance_240.ecd_1);
  };
  protoOf(ShowCellGroupTrait).y91 = function (cell, event) {
    leave(this, Companion_instance_240.ecd_1);
    protoOf(CellTrait).y91.call(this, cell, event);
  };
  protoOf(ShowCellGroupTrait).p91 = function (cell, event) {
    protoOf(CellTrait).p91.call(this, cell, event);
    enter(this, Companion_instance_240.dcd_1);
  };
  protoOf(ShowCellGroupTrait).q91 = function (cell, event) {
    leave(this, Companion_instance_240.dcd_1);
    protoOf(CellTrait).q91.call(this, cell, event);
  };
  function CheckNodeMapper(coroutineScope, checkers, node, errors) {
    errors = errors === VOID ? ObservableHashSet_init_$Create$() : errors;
    Mapper.call(this, node, errors);
    this.mcd_1 = coroutineScope;
    this.ncd_1 = checkers;
  }
  protoOf(CheckNodeMapper).g87 = function () {
    return false;
  };
  protoOf(CheckNodeMapper).a88 = function (conf) {
    protoOf(Mapper).a88.call(this, conf);
    conf.h5v(new CheckNodeSynchronizer(this.mcd_1, this.ncd_1, this.e86_1, this.f86_1));
  };
  function CheckNodeSynchronizer$Companion$LOG$lambda() {
    return Unit_instance;
  }
  function prepare($this, checker) {
    var job = launch($this.ocd_1, VOID, VOID, CheckNodeSynchronizer$prepare$slambda_0($this, checker, null));
    if (!job.dp()) {
      // Inline function 'kotlin.collections.set' call
      $this.tcd_1.t2(checker, job);
    }
  }
  function run($this, checker, $completion) {
    var tmp = new $runCOROUTINE$($this, checker, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  }
  function CheckResultEntry($outer, invalidator, errors) {
    this.jce_1 = $outer;
    this.hce_1 = invalidator;
    this.ice_1 = errors;
  }
  protoOf(CheckResultEntry).kce = function () {
    this.hce_1.zr();
    this.jce_1.rcd_1.j1(this.ice_1);
  };
  function Companion_241() {
    Companion_instance_241 = this;
    this.lce_1 = 300n;
    var tmp = this;
    var tmp_0 = KotlinLogging_getInstance();
    tmp.mce_1 = tmp_0.i2q(CheckNodeSynchronizer$Companion$LOG$lambda);
  }
  var Companion_instance_241;
  function Companion_getInstance_241() {
    if (Companion_instance_241 == null)
      new Companion_241();
    return Companion_instance_241;
  }
  function CheckNodeSynchronizer$prepare$slambda(this$0, $checker, resultContinuation) {
    this.vce_1 = this$0;
    this.wce_1 = $checker;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CheckNodeSynchronizer$prepare$slambda).e1h = function ($this$launch, $completion) {
    var tmp = this.f1h($this$launch, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(CheckNodeSynchronizer$prepare$slambda).v9 = function (p1, $completion) {
    return this.e1h((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CheckNodeSynchronizer$prepare$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 6;
            this.f9_1 = 1;
            continue $sm;
          case 1:
            this.g9_1 = 5;
            this.f9_1 = 2;
            suspendResult = delay_0(300n, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.f9_1 = 3;
            suspendResult = run(this.vce_1, this.wce_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            this.g9_1 = 6;
            this.f9_1 = 4;
            continue $sm;
          case 4:
            this.g9_1 = 6;
            this.vce_1.tcd_1.u2(this.wce_1);
            return Unit_instance;
          case 5:
            this.g9_1 = 6;
            var t = this.i9_1;
            this.vce_1.tcd_1.u2(this.wce_1);
            throw t;
          case 6:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 6) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(CheckNodeSynchronizer$prepare$slambda).f1h = function ($this$launch, completion) {
    var i = new CheckNodeSynchronizer$prepare$slambda(this.vce_1, this.wce_1, completion);
    i.xce_1 = $this$launch;
    return i;
  };
  function CheckNodeSynchronizer$prepare$slambda_0(this$0, $checker, resultContinuation) {
    var i = new CheckNodeSynchronizer$prepare$slambda(this$0, $checker, resultContinuation);
    var l = function ($this$launch, $completion) {
      return i.e1h($this$launch, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function CheckNodeSynchronizer$run$$inlined$eventHandler$1(this$0, $checker) {
    this.yce_1 = this$0;
    this.zce_1 = $checker;
  }
  protoOf(CheckNodeSynchronizer$run$$inlined$eventHandler$1).o2v = function (event) {
    prepare(this.yce_1, this.zce_1);
    return Unit_instance;
  };
  protoOf(CheckNodeSynchronizer$run$$inlined$eventHandler$1).n2s = function (event) {
    return this.o2v((event == null ? true : !(event == null)) ? event : THROW_CCE());
  };
  function CheckNodeSynchronizer$run$lambda($checker, this$0) {
    return function () {
      return 'Got exception during checker execution. Checker: ' + toString_1($checker) + ', node: ' + toString_1(this$0.qcd_1);
    };
  }
  function $runCOROUTINE$(_this__u8e3s4, checker, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.cce_1 = _this__u8e3s4;
    this.dce_1 = checker;
  }
  protoOf($runCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 3;
            var tmp_0 = this;
            tmp_0.fce_1 = new CheckNodeSynchronizer$run$$inlined$eventHandler$1(this.cce_1, this.dce_1);
            this.ece_1 = new Invalidator();
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = supervise(this.dce_1.q70(this.cce_1.qcd_1), this.ece_1, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.gce_1 = suspendResult;
            this.g9_1 = 3;
            this.f9_1 = 4;
            continue $sm;
          case 2:
            this.g9_1 = 3;
            var tmp_1 = this.i9_1;
            if (tmp_1 instanceof AlreadyInvalidException) {
              var exception = this.i9_1;
              var tmp_2 = this;
              prepare(this.cce_1, this.dce_1);
              return Unit_instance;
            } else {
              throw this.i9_1;
            }

          case 3:
            throw this.i9_1;
          case 4:
            this.g9_1 = 3;
            var checkInv = this.gce_1;
            checkInv.n5u().y2r(this.fce_1);
            var tmp_3;
            try {
              tmp_3 = checkInv.m5u();
            } catch ($p) {
              var tmp_4;
              if ($p instanceof Error) {
                var exception_0 = $p;
                var tmp_5 = Companion_getInstance_241().mce_1;
                tmp_5.h2q(exception_0, CheckNodeSynchronizer$run$lambda(this.dce_1, this.cce_1));
                return Unit_instance;
              } else {
                throw $p;
              }
            }

            var value = tmp_3;
            var newCheckResult = new CheckResultEntry(this.cce_1, this.ece_1, value);
            var previous = this.cce_1.scd_1.q2(this.dce_1);
            if (!(previous == null)) {
              this.cce_1.rcd_1.j1(previous.ice_1);
            }

            var tmp0 = this.cce_1.scd_1;
            var key = this.dce_1;
            tmp0.t2(key, newCheckResult);
            this.cce_1.rcd_1.q(newCheckResult.ice_1);
            return Unit_instance;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 3) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function CheckNodeSynchronizer(coroutineScope, checkers, node, errors) {
    Companion_getInstance_241();
    this.ocd_1 = coroutineScope;
    this.pcd_1 = checkers;
    this.qcd_1 = node;
    this.rcd_1 = errors;
    this.scd_1 = HashMap_init_$Create$();
    this.tcd_1 = HashMap_init_$Create$();
  }
  protoOf(CheckNodeSynchronizer).y86 = function (ctx) {
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = this.pcd_1.m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      prepare(this, element);
    }
  };
  protoOf(CheckNodeSynchronizer).e6j = function () {
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = this.pcd_1.m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      var tmp0_safe_receiver = this.scd_1.u2(element);
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.kce();
      }
      var tmp1_safe_receiver = this.tcd_1.u2(element);
      if (tmp1_safe_receiver == null)
        null;
      else {
        cancel_2(tmp1_safe_receiver, 'on CheckNodeSynchronizer#detach()');
      }
    }
  };
  function ErrorHighlighterBase$registerSynchronizers$o$doAttach$lambda(this$0) {
    return function (event) {
      switch (event.r2r_1.x2_1) {
        case 0:
          show_1(this$0, event.u2r());
          break;
        case 2:
          hide_2(this$0, event.s2r());
          break;
        case 1:
          hide_2(this$0, event.s2r());
          show_1(this$0, event.u2r());
          break;
        default:
          noWhenBranchMatchedException();
          break;
      }
      return Unit_instance;
    };
  }
  function show_1($this, error) {
    var nodes = error.f3o();
    var reg;
    if (nodes.p() === 1) {
      var node = nodes.m().o();
      var hi = $this.vcb(node);
      var tmp;
      if (hi == null) {
        tmp = null;
      } else {
        // Inline function 'kotlin.let' call
        tmp = $this.ycb(hi, error);
      }
      var tmp1_elvis_lhs = tmp;
      reg = tmp1_elvis_lhs == null ? markForeignNode($this, node, error) : tmp1_elvis_lhs;
    } else {
      var ownHis = HashSet_init_$Create$();
      var foreignNodes = HashSet_init_$Create$();
      var _iterator__ex2g4s = error.f3o().m();
      while (_iterator__ex2g4s.n()) {
        var nodeToHighlight = _iterator__ex2g4s.o();
        var hi_0 = $this.vcb(nodeToHighlight);
        if (!(hi_0 == null)) {
          ownHis.j(hi_0);
        } else {
          foreignNodes.j(nodeToHighlight);
        }
      }
      if (foreignNodes.s()) {
        reg = $this.bcc(ownHis, error);
      } else {
        var composite = new CompositeDisposable([$this.bcc(ownHis, error)]);
        var _iterator__ex2g4s_0 = foreignNodes.m();
        while (_iterator__ex2g4s_0.n()) {
          var foreignNode = _iterator__ex2g4s_0.o();
          composite.l2l([markForeignNode($this, foreignNode, error)]);
        }
        reg = composite;
      }
    }
    var tmp0 = $this.kcc_1;
    // Inline function 'kotlin.collections.set' call
    var value = reg;
    tmp0.t2(error, value);
  }
  function hide_2($this, error) {
    ensureNotNull($this.kcc_1.u2(error)).zr();
  }
  function markForeignNode($this, node, error) {
    var _iterator__ex2g4s = $this.ucb().m();
    while (_iterator__ex2g4s.n()) {
      var highlighter = _iterator__ex2g4s.o();
      var reg = markWith($this, highlighter, node, error);
      if (!(reg == null)) {
        return reg;
      }
    }
    throw IllegalStateException_init_$Create$();
  }
  function markWith($this, hir, node, error) {
    var hi = hir.vcb(node);
    return hi == null ? null : hir.ycb(hi, error);
  }
  function Companion_242() {
    Companion_instance_242 = this;
    this.sca_1 = CellTraitPropertySpec_init_$Create$('highlighter', null);
  }
  var Companion_instance_242;
  function Companion_getInstance_242() {
    if (Companion_instance_242 == null)
      new Companion_242();
    return Companion_instance_242;
  }
  function ErrorHighlighterBase$registerSynchronizers$1(this$0) {
    this.acf_1 = this$0;
  }
  protoOf(ErrorHighlighterBase$registerSynchronizers$1).y86 = function (ctx) {
    var _iterator__ex2g4s = this.acf_1.jcc_1.m();
    while (_iterator__ex2g4s.n()) {
      var e = _iterator__ex2g4s.o();
      show_1(this.acf_1, e);
    }
  };
  protoOf(ErrorHighlighterBase$registerSynchronizers$1).e6j = function () {
    var _iterator__ex2g4s = this.acf_1.kcc_1.s2().m();
    while (_iterator__ex2g4s.n()) {
      var reg = _iterator__ex2g4s.o();
      reg.zr();
    }
    this.acf_1.kcc_1.k2();
  };
  function ErrorHighlighterBase$registerSynchronizers$$inlined$forEventSource$1($src, this$0) {
    this.ccf_1 = $src;
    this.dcf_1 = this$0;
    DisposableSynchronizer.call(this);
  }
  protoOf(ErrorHighlighterBase$registerSynchronizers$$inlined$forEventSource$1).s87 = function (ctx) {
    return this.ccf_1.z2r(ErrorHighlighterBase$registerSynchronizers$o$doAttach$lambda(this.dcf_1));
  };
  function ErrorHighlighterBase(source, target, errors) {
    Companion_getInstance_242();
    Mapper.call(this, source, target);
    this.jcc_1 = errors;
    this.kcc_1 = HashMap_init_$Create$();
  }
  protoOf(ErrorHighlighterBase).ucb = function () {
    return emptyList();
  };
  protoOf(ErrorHighlighterBase).a88 = function (conf) {
    conf.h5v(new ErrorHighlighterBase$registerSynchronizers$1(this));
    // Inline function 'jetbrains.ocelot.mapper.core.Synchronizers.forEventSource' call
    var src = this.jcc_1;
    var tmp$ret$0 = new ErrorHighlighterBase$registerSynchronizers$$inlined$forEventSource$1(src, this);
    conf.h5v(tmp$ret$0);
  };
  function buildRoleCompletion(childContext, coroutineScope, wrapperContext, resolveConfig, completionSupplier) {
    var tmp = buildRoleCompletion$lambda(coroutineScope, wrapperContext, resolveConfig, childContext, completionSupplier);
    return new sam$jetbrains_ocelot_projectional_editor_generic_roleCompletion_RoleCompletion$0_1(tmp);
  }
  function sam$jetbrains_ocelot_projectional_editor_generic_roleCompletion_RoleCompletion$0_1(function_0) {
    this.ecf_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_projectional_editor_generic_roleCompletion_RoleCompletion$0_1).oan = function (mapper, contextNode, target) {
    return this.ecf_1(mapper, contextNode, target);
  };
  protoOf(sam$jetbrains_ocelot_projectional_editor_generic_roleCompletion_RoleCompletion$0_1).f3 = function () {
    return this.ecf_1;
  };
  protoOf(sam$jetbrains_ocelot_projectional_editor_generic_roleCompletion_RoleCompletion$0_1).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, RoleCompletion) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_projectional_editor_generic_roleCompletion_RoleCompletion$0_1).hashCode = function () {
    return hashCode(this.f3());
  };
  function buildRoleCompletion$lambda($coroutineScope, $wrapperContext, $resolveConfig, $childContext, $completionSupplier) {
    return function (mapper, contextNode, role) {
      var completionBuilder = new CompletionBuilderImpl($coroutineScope);
      var builder = new NodeCompletionBuilderImpl($wrapperContext, $coroutineScope, $resolveConfig, $childContext, (contextNode == null ? true : isInterface(contextNode, DomainNode)) ? contextNode : THROW_CCE(), role, mapper, completionBuilder);
      $completionSupplier(builder);
      return completionBuilder.jcf();
    };
  }
  function CellAwareCompletionSupplier$createEventHandler$o$onEvent$slambda($controller, $cell, resultContinuation) {
    this.scf_1 = $controller;
    this.tcf_1 = $cell;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CellAwareCompletionSupplier$createEventHandler$o$onEvent$slambda).e1h = function ($this$launch, $completion) {
    var tmp = this.f1h($this$launch, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(CellAwareCompletionSupplier$createEventHandler$o$onEvent$slambda).v9 = function (p1, $completion) {
    return this.e1h((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CellAwareCompletionSupplier$createEventHandler$o$onEvent$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        if (tmp === 0) {
          this.g9_1 = 1;
          this.scf_1.n9f();
          Completion_getInstance().w9f(this.tcf_1).e9f(Companion_getInstance_167().c5f().s9q(false).f40());
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(CellAwareCompletionSupplier$createEventHandler$o$onEvent$slambda).f1h = function ($this$launch, completion) {
    var i = new CellAwareCompletionSupplier$createEventHandler$o$onEvent$slambda(this.scf_1, this.tcf_1, completion);
    i.ucf_1 = $this$launch;
    return i;
  };
  function CellAwareCompletionSupplier$createEventHandler$o$onEvent$slambda_0($controller, $cell, resultContinuation) {
    var i = new CellAwareCompletionSupplier$createEventHandler$o$onEvent$slambda($controller, $cell, resultContinuation);
    var l = function ($this$launch, $completion) {
      return i.e1h($this$launch, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function createEventHandler_0($this, cell) {
    // Inline function 'jetbrains.ocelot.base.observable.event.eventHandler' call
    return new CellAwareCompletionSupplier$createEventHandler$$inlined$eventHandler$1(cell);
  }
  function CellAwareCompletionSupplier$asSupplier$$inlined$completionSupplier$1($cacheable, this$0) {
    this.vcf_1 = $cacheable;
    this.wcf_1 = this$0;
  }
  protoOf(CellAwareCompletionSupplier$asSupplier$$inlined$completionSupplier$1).q9f = function () {
    return this.vcf_1;
  };
  protoOf(CellAwareCompletionSupplier$asSupplier$$inlined$completionSupplier$1).m9e = function (completionContext) {
    return this.wcf_1.xcf(completionContext);
  };
  function CellAwareCompletionSupplier$invoke$$inlined$eventHandler$1($cr, $invalidator, $validReg, $activeReg) {
    this.ycf_1 = $cr;
    this.zcf_1 = $invalidator;
    this.acg_1 = $validReg;
    this.bcg_1 = $activeReg;
  }
  protoOf(CellAwareCompletionSupplier$invoke$$inlined$eventHandler$1).o2v = function (event) {
    var deactivated = !event.t2y_1;
    if (deactivated) {
      if (this.ycf_1.n5u().p38()) {
        this.zcf_1.zr();
        this.acg_1.zr();
      }
      this.bcg_1._v.zr();
    }
    return Unit_instance;
  };
  protoOf(CellAwareCompletionSupplier$invoke$$inlined$eventHandler$1).n2s = function (event) {
    return this.o2v((event == null ? true : !(event == null)) ? event : THROW_CCE());
  };
  function CellAwareCompletionSupplier$createEventHandler$$inlined$eventHandler$1($cell) {
    this.ccg_1 = $cell;
  }
  protoOf(CellAwareCompletionSupplier$createEventHandler$$inlined$eventHandler$1).o2v = function (event) {
    var controller = Completion_getInstance().w9f(this.ccg_1);
    if (controller.io()) {
      launch_0(this.ccg_1, VOID, VOID, CellAwareCompletionSupplier$createEventHandler$o$onEvent$slambda_0(controller, this.ccg_1, null));
    }
    return Unit_instance;
  };
  protoOf(CellAwareCompletionSupplier$createEventHandler$$inlined$eventHandler$1).n2s = function (event) {
    return this.o2v((event == null ? true : !(event == null)) ? event : THROW_CCE());
  };
  function CellAwareCompletionSupplier() {
  }
  protoOf(CellAwareCompletionSupplier).ecg = function () {
    // Inline function 'jetbrains.ocelot.projectional.cell.completion.context.completionSupplier' call
    return new CellAwareCompletionSupplier$asSupplier$$inlined$completionSupplier$1(false, this);
  };
  protoOf(CellAwareCompletionSupplier).xcf = function (context) {
    var cell = this.dcg();
    if (cell == null) {
      return this.fcg(null, context, Companion_getInstance_79().u5u_1).m5u();
    }
    var controller = Completion_getInstance().w9f(cell);
    if (!context.b9m()) {
      return this.fcg(cell, context, Companion_getInstance_79().u5u_1).m5u();
    }
    var invalidator = new Invalidator();
    var cr = this.fcg(cell, context, invalidator);
    var validReg = cr.n5u().y2r(createEventHandler_0(this, cell));
    var activeReg = {_v: Companion_getInstance_29().m2l_1};
    var tmp = controller.a9f();
    // Inline function 'jetbrains.ocelot.base.observable.event.eventHandler' call
    var tmp$ret$0 = new CellAwareCompletionSupplier$invoke$$inlined$eventHandler$1(cr, invalidator, validReg, activeReg);
    activeReg._v = tmp.y2r(tmp$ret$0);
    return cr.m5u();
  };
  function CompletionBuilder() {
    CompletionItemKindProvider.call(this);
  }
  function CompletionBuilderBase$does$2$$inlined$simpleCompletionItem$1($matchingText, $sortPriority, $isCaseSensitive, $action) {
    this.ocg_1 = $action;
    SimpleCompletionItem.call(this, $matchingText, VOID, $sortPriority, $isCaseSensitive);
  }
  protoOf(CompletionBuilderBase$does$2$$inlined$simpleCompletionItem$1).s9m = function (text) {
    return this.ocg_1();
  };
  function CompletionBuilderBase$does$lambda($this_does, $action) {
    return function (sortPriority) {
      var tmp0 = $this_does;
      // Inline function 'jetbrains.ocelot.projectional.cell.completion.result.simpleCompletionItem' call
      var sortPriority_0 = sortPriority.qcg();
      return new CompletionBuilderBase$does$2$$inlined$simpleCompletionItem$1(tmp0, sortPriority_0, false, $action);
    };
  }
  function CompletionBuilderBase$does$lambda_0($action) {
    return function (sortPriority) {
      return completionItemForNumber(sortPriority.qcg(), $action);
    };
  }
  function CompletionBuilderBase$does$lambda_1($action) {
    return function (sortPriority) {
      return completionItemForId(sortPriority.qcg(), $action);
    };
  }
  function CompletionBuilderBase() {
    CompletionBuilder.call(this);
  }
  protoOf(CompletionBuilderBase).gcg = function (_this__u8e3s4, action) {
    this.rcg(CompletionBuilderBase$does$lambda(_this__u8e3s4, action));
  };
  protoOf(CompletionBuilderBase).tcg = function (_this__u8e3s4, action) {
    this.rcg(CompletionBuilderBase$does$lambda_0(action));
  };
  protoOf(CompletionBuilderBase).ucg = function (_this__u8e3s4, action) {
    this.rcg(CompletionBuilderBase$does$lambda_1(action));
  };
  function _get_nextSortPriorityRange__jg7xx3($this) {
    var tmp = Companion_getInstance_243();
    var _unary__edvuaz = $this.icf_1;
    $this.icf_1 = _unary__edvuaz - 1 | 0;
    return tmp.xcg(_unary__edvuaz);
  }
  function CompletionBuilderImpl$async$slambda($completion, $priorityRange, resultContinuation) {
    this.gch_1 = $completion;
    this.hch_1 = $priorityRange;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CompletionBuilderImpl$async$slambda).jch = function ($this$channelFlow, $completion) {
    var tmp = this.kch($this$channelFlow, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(CompletionBuilderImpl$async$slambda).v9 = function (p1, $completion) {
    return this.jch((!(p1 == null) ? isInterface(p1, ProducerScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CompletionBuilderImpl$async$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.gch_1(new CoroutineCompletionBuilder(this.ich_1, this.ich_1.d11(), this.hch_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(CompletionBuilderImpl$async$slambda).kch = function ($this$channelFlow, completion) {
    var i = new CompletionBuilderImpl$async$slambda(this.gch_1, this.hch_1, completion);
    i.ich_1 = $this$channelFlow;
    return i;
  };
  function CompletionBuilderImpl$async$slambda_0($completion, $priorityRange, resultContinuation) {
    var i = new CompletionBuilderImpl$async$slambda($completion, $priorityRange, resultContinuation);
    var l = function ($this$channelFlow, $completion) {
      return i.jch($this$channelFlow, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function CompletionBuilderImpl$async$2$$inlined$completionSupplier$1($cacheable, $completionResult) {
    this.lch_1 = $cacheable;
    this.mch_1 = $completionResult;
  }
  protoOf(CompletionBuilderImpl$async$2$$inlined$completionSupplier$1).q9f = function () {
    return this.lch_1;
  };
  protoOf(CompletionBuilderImpl$async$2$$inlined$completionSupplier$1).m9e = function (completionContext) {
    return this.mch_1;
  };
  function CompletionBuilderImpl$async$lambda($completionResult) {
    return function (it) {
      // Inline function 'jetbrains.ocelot.projectional.cell.completion.context.completionSupplier' call
      return new CompletionBuilderImpl$async$2$$inlined$completionSupplier$1(false, $completionResult);
    };
  }
  function CompletionBuilderImpl(coroutineScope) {
    CompletionBuilderBase.call(this);
    this.fcf_1 = coroutineScope;
    this.gcf_1 = ArrayList_init_$Create$();
    this.hcf_1 = ArrayList_init_$Create$();
    this.icf_1 = 32767;
  }
  protoOf(CompletionBuilderImpl).rcg = function (completionItem) {
    this.gcf_1.j(completionItem(_get_nextSortPriorityRange__jg7xx3(this)));
  };
  protoOf(CompletionBuilderImpl).scg = function (completionSupplier) {
    this.hcf_1.j(completionSupplier(_get_nextSortPriorityRange__jg7xx3(this)));
  };
  protoOf(CompletionBuilderImpl).hcg = function (completion) {
    var priorityRange = _get_nextSortPriorityRange__jg7xx3(this);
    var completionResult = new FlowBasedCompletionResult(this.fcf_1, channelFlow(CompletionBuilderImpl$async$slambda_0(completion, priorityRange, null)));
    this.scg(CompletionBuilderImpl$async$lambda(completionResult));
  };
  protoOf(CompletionBuilderImpl).jcf = function () {
    var tmp0 = this.hcf_1;
    // Inline function 'kotlin.collections.fold' call
    var accumulator = toCompletionSupplier(this.gcf_1);
    var _iterator__ex2g4s = tmp0.m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      var p0 = accumulator;
      accumulator = plus_15(p0, element);
    }
    return accumulator;
  };
  function CoroutineCompletionBuilder$item$slambda(this$0, $completionItem, resultContinuation) {
    this.vch_1 = this$0;
    this.wch_1 = $completionItem;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CoroutineCompletionBuilder$item$slambda).e1h = function ($this$launch, $completion) {
    var tmp = this.f1h($this$launch, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(CoroutineCompletionBuilder$item$slambda).v9 = function (p1, $completion) {
    return this.e1h((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CoroutineCompletionBuilder$item$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.vch_1.zch_1.z15(this.wch_1(this.vch_1.aci_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(CoroutineCompletionBuilder$item$slambda).f1h = function ($this$launch, completion) {
    var i = new CoroutineCompletionBuilder$item$slambda(this.vch_1, this.wch_1, completion);
    i.xch_1 = $this$launch;
    return i;
  };
  function CoroutineCompletionBuilder$item$slambda_0(this$0, $completionItem, resultContinuation) {
    var i = new CoroutineCompletionBuilder$item$slambda(this$0, $completionItem, resultContinuation);
    var l = function ($this$launch, $completion) {
      return i.e1h($this$launch, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function CoroutineCompletionBuilder$async$slambda($completion, this$0, resultContinuation) {
    this.jci_1 = $completion;
    this.kci_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CoroutineCompletionBuilder$async$slambda).e1h = function ($this$launch, $completion) {
    var tmp = this.f1h($this$launch, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(CoroutineCompletionBuilder$async$slambda).v9 = function (p1, $completion) {
    return this.e1h((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CoroutineCompletionBuilder$async$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.jci_1(this.kci_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(CoroutineCompletionBuilder$async$slambda).f1h = function ($this$launch, completion) {
    var i = new CoroutineCompletionBuilder$async$slambda(this.jci_1, this.kci_1, completion);
    i.lci_1 = $this$launch;
    return i;
  };
  function CoroutineCompletionBuilder$async$slambda_0($completion, this$0, resultContinuation) {
    var i = new CoroutineCompletionBuilder$async$slambda($completion, this$0, resultContinuation);
    var l = function ($this$launch, $completion) {
      return i.e1h($this$launch, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function CoroutineCompletionBuilder(coroutineScope, channel, sortPriority) {
    CompletionBuilderBase.call(this);
    this.ych_1 = coroutineScope;
    this.zch_1 = channel;
    this.aci_1 = sortPriority;
  }
  protoOf(CoroutineCompletionBuilder).rcg = function (completionItem) {
    launch(this.ych_1, VOID, VOID, CoroutineCompletionBuilder$item$slambda_0(this, completionItem, null));
  };
  protoOf(CoroutineCompletionBuilder).scg = function (completionSupplier) {
    throw UnsupportedOperationException_init_$Create$_0('Operation not support yet');
  };
  protoOf(CoroutineCompletionBuilder).hcg = function (completion) {
    launch(this.ych_1, VOID, VOID, CoroutineCompletionBuilder$async$slambda_0(completion, this, null));
  };
  function ReferenceKind(tag, options) {
    CompletionItemKind.call(this);
    this.mci_1 = tag;
    this.nci_1 = options;
  }
  function CustomCompletionKind() {
    CompletionItemKind.call(this);
  }
  function NumberKind() {
    NumberKind_instance = this;
    CompletionItemKind.call(this);
  }
  var NumberKind_instance;
  function NumberKind_getInstance() {
    if (NumberKind_instance == null)
      new NumberKind();
    return NumberKind_instance;
  }
  function StringKind() {
    StringKind_instance = this;
    CompletionItemKind.call(this);
  }
  var StringKind_instance;
  function StringKind_getInstance() {
    if (StringKind_instance == null)
      new StringKind();
    return StringKind_instance;
  }
  function OtherCompletionKind(supplier) {
    CompletionItemKind.call(this);
    this.pci_1 = supplier;
  }
  function CompletionItemKind() {
  }
  function CompletionItemKindProvider() {
  }
  protoOf(CompletionItemKindProvider).qci = function () {
    return StringKind_getInstance();
  };
  protoOf(CompletionItemKindProvider).rci = function () {
    return NumberKind_getInstance();
  };
  protoOf(CompletionItemKindProvider).icg = function (tag, options) {
    return new ReferenceKind(tag, options);
  };
  protoOf(CompletionItemKindProvider).jcg = function (tag, options, $super) {
    options = options === VOID ? new CompletionOptions() : options;
    return $super === VOID ? this.icg(tag, options) : $super.icg.call(this, tag, options);
  };
  function CompletionOptions(caseSensitive, useTokens, exactMatchFirst) {
    caseSensitive = caseSensitive === VOID ? false : caseSensitive;
    useTokens = useTokens === VOID ? true : useTokens;
    exactMatchFirst = exactMatchFirst === VOID ? true : exactMatchFirst;
    this.sci_1 = caseSensitive;
    this.tci_1 = useTokens;
    this.uci_1 = exactMatchFirst;
  }
  function toFilterSettings(_this__u8e3s4) {
    return Companion_getInstance_100().u6r(!_this__u8e3s4.sci_1, _this__u8e3s4.tci_1);
  }
  function completionResult(_this__u8e3s4, action, filter, referenceTargets, sortPriorityRange) {
    // Inline function 'kotlinx.coroutines.flow.map' call
    // Inline function 'kotlinx.coroutines.flow.unsafeTransform' call
    // Inline function 'kotlinx.coroutines.flow.internal.unsafeFlow' call
    var items = new completionResult$$inlined$map$1(referenceTargets, filter, sortPriorityRange, action);
    return new FlowBasedCompletionResult(_this__u8e3s4, items);
  }
  function completionResult$o$collect$slambda$lambda($action, $item) {
    return function (it) {
      return $action($item.vci_1);
    };
  }
  function sam$kotlinx_coroutines_flow_FlowCollector$0_10(function_0) {
    this.xci_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_10).x18 = function (value, $completion) {
    return this.xci_1(value, $completion);
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_10).f3 = function () {
    return this.xci_1;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_10).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, FlowCollector) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_10).hashCode = function () {
    return hashCode(this.f3());
  };
  function completionResult$o$collect$slambda($$this$unsafeFlow, $filter, $sortPriorityRange, $action, resultContinuation) {
    this.gcj_1 = $$this$unsafeFlow;
    this.hcj_1 = $filter;
    this.icj_1 = $sortPriorityRange;
    this.jcj_1 = $action;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(completionResult$o$collect$slambda).f1q = function (value, $completion) {
    var tmp = this.g1q(value, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(completionResult$o$collect$slambda).v9 = function (p1, $completion) {
    return this.f1q((p1 == null ? true : !(p1 == null)) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(completionResult$o$collect$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            var tmp0 = this.gcj_1;
            var value = this.kcj_1;
            this.f9_1 = 1;
            var matcher = new TextMatcherByFilterSettings(this.hcj_1, get_tokenized(value.vci_1.l6q_1));
            var tmp_0 = this.icj_1.lcj(value.wci_1);
            suspendResult = tmp0.x18(completionItemByTextMatcher(matcher, value.vci_1.l6q_1, tmp_0, value.vci_1.m6q_1, completionResult$o$collect$slambda$lambda(this.jcj_1, value)), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(completionResult$o$collect$slambda).g1q = function (value, completion) {
    var i = new completionResult$o$collect$slambda(this.gcj_1, this.hcj_1, this.icj_1, this.jcj_1, completion);
    i.kcj_1 = value;
    return i;
  };
  function completionResult$o$collect$slambda_0($$this$unsafeFlow, $filter, $sortPriorityRange, $action, resultContinuation) {
    var i = new completionResult$o$collect$slambda($$this$unsafeFlow, $filter, $sortPriorityRange, $action, resultContinuation);
    var l = function (value, $completion) {
      return i.f1q(value, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function $collectCOROUTINE$_15(_this__u8e3s4, collector, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.ucj_1 = _this__u8e3s4;
    this.vcj_1 = collector;
  }
  protoOf($collectCOROUTINE$_15).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            var $this$unsafeFlow = this.vcj_1;
            this.f9_1 = 1;
            var tmp_0 = completionResult$o$collect$slambda_0($this$unsafeFlow, this.ucj_1.xcj_1, this.ucj_1.ycj_1, this.ucj_1.zcj_1, null);
            suspendResult = this.ucj_1.wcj_1.f18(new sam$kotlinx_coroutines_flow_FlowCollector$0_10(tmp_0), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function completionResult$$inlined$map$1($this, $filter, $sortPriorityRange, $action) {
    this.wcj_1 = $this;
    this.xcj_1 = $filter;
    this.ycj_1 = $sortPriorityRange;
    this.zcj_1 = $action;
  }
  protoOf(completionResult$$inlined$map$1).y18 = function (collector, $completion) {
    var tmp = new $collectCOROUTINE$_15(this, collector, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(completionResult$$inlined$map$1).f18 = function (collector, $completion) {
    return this.y18(collector, $completion);
  };
  function NodeCompletionBuilder() {
    CompletionItemKindProvider.call(this);
  }
  protoOf(NodeCompletionBuilder).hck = function (_this__u8e3s4, factory) {
    _this__u8e3s4.oci(this, factory);
  };
  protoOf(NodeCompletionBuilder).ick = function (other) {
    return new OtherCompletionKind(other);
  };
  function NodeProducerBuilder() {
  }
  protoOf(NodeProducerBuilder).nck = function (action) {
    return action;
  };
  function ActionOnCell() {
  }
  function sam$jetbrains_ocelot_langDef_completion_ActionOnCell$0(function_0) {
    this.pck_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_langDef_completion_ActionOnCell$0).ock = function (cell) {
    return this.pck_1(cell);
  };
  protoOf(sam$jetbrains_ocelot_langDef_completion_ActionOnCell$0).f3 = function () {
    return this.pck_1;
  };
  protoOf(sam$jetbrains_ocelot_langDef_completion_ActionOnCell$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, ActionOnCell) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_langDef_completion_ActionOnCell$0).hashCode = function () {
    return hashCode(this.f3());
  };
  function NodeCompletionBuilderBase$Builder$produce$lambda($defaultAction) {
    return function (it) {
      return $defaultAction;
    };
  }
  function cellAction($this, factory) {
    var builder = new Builder_3($this);
    var action = factory(builder);
    var tmp0_safe_receiver = builder.qck_1;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      var tmp0_safe_receiver_0 = $this.sck(tmp0_safe_receiver);
      var tmp_0;
      if (tmp0_safe_receiver_0 == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlin.let' call
        tmp_0 = action.ock(tmp0_safe_receiver_0);
      }
      tmp = tmp_0;
    }
    var tmp1_elvis_lhs = tmp;
    return tmp1_elvis_lhs == null ? get_EMPTY_CELL_ACTION() : tmp1_elvis_lhs;
  }
  function Builder_3($outer) {
    this.rck_1 = $outer;
    NodeProducerBuilder.call(this);
    this.qck_1 = null;
  }
  protoOf(Builder_3).mck = function (node) {
    var defaultAction = this.rck_1.tck(node);
    this.qck_1 = node;
    var tmp = NodeCompletionBuilderBase$Builder$produce$lambda(defaultAction);
    return this.nck(new sam$jetbrains_ocelot_langDef_completion_ActionOnCell$0(tmp));
  };
  function NodeCompletionBuilderBase$does$lambda(this$0, $factory) {
    return function () {
      return cellAction(this$0, $factory);
    };
  }
  function NodeCompletionBuilderBase$produces$lambda($factory) {
    return function ($this$does) {
      return $this$does.mck($factory());
    };
  }
  function NodeCompletionBuilderBase$does$lambda$lambda($factory, $string) {
    return function ($this$cellAction) {
      return $factory($this$cellAction, $string);
    };
  }
  function NodeCompletionBuilderBase$does$lambda_0(this$0, $factory) {
    return function (string) {
      return cellAction(this$0, NodeCompletionBuilderBase$does$lambda$lambda($factory, string));
    };
  }
  function NodeCompletionBuilderBase$produces$lambda_0($factory) {
    return function ($this$does, string) {
      return $this$does.mck($factory(string));
    };
  }
  function NodeCompletionBuilderBase$does$lambda$lambda_0($factory, $number) {
    return function ($this$cellAction) {
      return $factory($this$cellAction, $number);
    };
  }
  function NodeCompletionBuilderBase$does$lambda_1(this$0, $factory) {
    return function (number) {
      return cellAction(this$0, NodeCompletionBuilderBase$does$lambda$lambda_0($factory, number));
    };
  }
  function NodeCompletionBuilderBase$produces$lambda_1($factory) {
    return function ($this$does, number) {
      return $this$does.mck($factory(number));
    };
  }
  function NodeCompletionBuilderBase$produces$8$referenceCompletion$1(this$0, $supplier, $this_produces, $sortPriorityContext, $factory) {
    this.yck_1 = this$0;
    this.zck_1 = $supplier;
    this.acl_1 = $factory;
    ReferenceCompletionBase.call(this, this$0.bcl(), $supplier, $this_produces.nci_1, $sortPriorityContext);
  }
  protoOf(NodeCompletionBuilderBase$produces$8$referenceCompletion$1).ccl = function (item) {
    return this.yck_1.tck(this.acl_1(item.k6q_1));
  };
  protoOf(NodeCompletionBuilderBase$produces$8$referenceCompletion$1).q72 = function (filter) {
    var tmp;
    if (!(this.yck_1.dcl() == null)) {
      tmp = toEnclosingNodeContext(ensureNotNull(this.yck_1.dcl()));
    } else if (!(this.yck_1.ack() == null)) {
      tmp = new EnclosingNodeContext(ensureNotNull(this.yck_1.ack()), null);
    } else {
      throw IllegalArgumentException_init_$Create$_0("Either childContext or editor's context node must not be null");
    }
    var elementsContext = tmp;
    return this.zck_1.o6q(elementsContext, filter);
  };
  protoOf(NodeCompletionBuilderBase$produces$8$referenceCompletion$1).dcg = function () {
    var tmp = this.yck_1.z86().f86_1;
    var tmp0_safe_receiver = ((!(tmp == null) ? isInterface(tmp, Cell) : false) ? tmp : THROW_CCE()).s8x();
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.z92();
    return tmp1_safe_receiver == null ? null : tmp1_safe_receiver.w2w();
  };
  function NodeCompletionBuilderBase$produces$lambda_2(this$0, $supplier, $this_produces, $factory) {
    return function (sortPriorityContext) {
      var referenceCompletion = new NodeCompletionBuilderBase$produces$8$referenceCompletion$1(this$0, $supplier, $this_produces, sortPriorityContext, $factory);
      return referenceCompletion.ecg();
    };
  }
  function NodeCompletionBuilderBase() {
    NodeCompletionBuilder.call(this);
  }
  protoOf(NodeCompletionBuilderBase).lcl = function (_this__u8e3s4, factory) {
    // Inline function 'kotlin.with' call
    this.kcl().gcg(_this__u8e3s4, NodeCompletionBuilderBase$does$lambda(this, factory));
    return Unit_instance;
  };
  protoOf(NodeCompletionBuilderBase).bck = function (_this__u8e3s4, factory) {
    return this.lcl(_this__u8e3s4, NodeCompletionBuilderBase$produces$lambda(factory));
  };
  protoOf(NodeCompletionBuilderBase).cck = function (_this__u8e3s4, factory) {
    // Inline function 'kotlin.with' call
    this.kcl().ucg(_this__u8e3s4, NodeCompletionBuilderBase$does$lambda_0(this, factory));
    return Unit_instance;
  };
  protoOf(NodeCompletionBuilderBase).dck = function (_this__u8e3s4, factory) {
    return this.cck(_this__u8e3s4, NodeCompletionBuilderBase$produces$lambda_0(factory));
  };
  protoOf(NodeCompletionBuilderBase).eck = function (_this__u8e3s4, factory) {
    // Inline function 'kotlin.with' call
    this.kcl().tcg(_this__u8e3s4, NodeCompletionBuilderBase$does$lambda_1(this, factory));
    return Unit_instance;
  };
  protoOf(NodeCompletionBuilderBase).fck = function (_this__u8e3s4, factory) {
    return this.eck(_this__u8e3s4, NodeCompletionBuilderBase$produces$lambda_1(factory));
  };
  protoOf(NodeCompletionBuilderBase).mcl = function (_this__u8e3s4, factory) {
    var supplier = this.jcl().d6u(_this__u8e3s4.mci_1);
    var tmp = this.kcl();
    tmp.scg(NodeCompletionBuilderBase$produces$lambda_2(this, supplier, _this__u8e3s4, factory));
  };
  protoOf(NodeCompletionBuilderBase).gck = function (_this__u8e3s4, factory) {
    return this.mcl(_this__u8e3s4, factory);
  };
  function NodeCompletionBuilderImpl$produces$transformRole$1(this$0, $factory) {
    this.ncl_1 = this$0;
    this.ocl_1 = $factory;
  }
  protoOf(NodeCompletionBuilderImpl$produces$transformRole$1).pcl = function (target) {
    return this.ncl_1.tck(this.ocl_1(target));
  };
  protoOf(NodeCompletionBuilderImpl$produces$transformRole$1).yak = function (target) {
    return this.pcl(isInterface(target, DomainNode) ? target : THROW_CCE());
  };
  function NodeCompletionBuilderImpl$async$slambda(this$0, $completion, resultContinuation) {
    this.hcm_1 = this$0;
    this.icm_1 = $completion;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(NodeCompletionBuilderImpl$async$slambda).kcm = function ($this$async, $completion) {
    var tmp = this.lcm($this$async, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(NodeCompletionBuilderImpl$async$slambda).v9 = function (p1, $completion) {
    return this.kcm(p1 instanceof CompletionBuilder ? p1 : THROW_CCE(), $completion);
  };
  protoOf(NodeCompletionBuilderImpl$async$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            var asyncBuilder = this.jcm_1;
            var tmp_0 = this.hcm_1.l6z();
            var tmp_1 = this.hcm_1.bcl();
            var tmp_2 = this.hcm_1.jcl();
            var tmp_3 = this.hcm_1.dcl();
            var tmp_4 = this.hcm_1.ack();
            var nodeCompletionBuilder = new NodeCompletionBuilderImpl(tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, this.hcm_1.vcl_1, this.hcm_1.wcl_1, asyncBuilder instanceof CompletionBuilderBase ? asyncBuilder : THROW_CCE());
            this.f9_1 = 1;
            suspendResult = this.icm_1(nodeCompletionBuilder, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(NodeCompletionBuilderImpl$async$slambda).lcm = function ($this$async, completion) {
    var i = new NodeCompletionBuilderImpl$async$slambda(this.hcm_1, this.icm_1, completion);
    i.jcm_1 = $this$async;
    return i;
  };
  function NodeCompletionBuilderImpl$async$slambda_0(this$0, $completion, resultContinuation) {
    var i = new NodeCompletionBuilderImpl$async$slambda(this$0, $completion, resultContinuation);
    var l = function ($this$async, $completion) {
      return i.kcm($this$async, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function NodeCompletionBuilderImpl(wrapperContext, coroutineScope, resolveConfig, childContext, contextNode, role, mapper, completionBuilder) {
    NodeCompletionBuilderBase.call(this);
    this.qcl_1 = wrapperContext;
    this.rcl_1 = coroutineScope;
    this.scl_1 = resolveConfig;
    this.tcl_1 = childContext;
    this.ucl_1 = contextNode;
    this.vcl_1 = role;
    this.wcl_1 = mapper;
    this.xcl_1 = completionBuilder;
    this.ycl_1 = this.wcl_1.j86_1;
  }
  protoOf(NodeCompletionBuilderImpl).l6z = function () {
    return this.qcl_1;
  };
  protoOf(NodeCompletionBuilderImpl).bcl = function () {
    return this.rcl_1;
  };
  protoOf(NodeCompletionBuilderImpl).jcl = function () {
    return this.scl_1;
  };
  protoOf(NodeCompletionBuilderImpl).dcl = function () {
    return this.tcl_1;
  };
  protoOf(NodeCompletionBuilderImpl).ack = function () {
    return this.ucl_1;
  };
  protoOf(NodeCompletionBuilderImpl).z86 = function () {
    return this.wcl_1;
  };
  protoOf(NodeCompletionBuilderImpl).kcl = function () {
    return this.xcl_1;
  };
  protoOf(NodeCompletionBuilderImpl).tck = function (value) {
    return this.vcl_1.yak(value);
  };
  protoOf(NodeCompletionBuilderImpl).sck = function (value) {
    var ctx = this.wcl_1.b88();
    var tmp;
    if (this.wcl_1.f89()) {
      tmp = this.wcl_1;
    } else {
      var tmp0_elvis_lhs = this.ycl_1;
      var tmp_0;
      if (tmp0_elvis_lhs == null) {
        return null;
      } else {
        tmp_0 = tmp0_elvis_lhs;
      }
      tmp = tmp_0;
    }
    var fromMapper = tmp;
    // Inline function 'kotlin.collections.map' call
    var this_0 = ctx.e8a(fromMapper, value);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.m();
    while (_iterator__ex2g4s.n()) {
      var item = _iterator__ex2g4s.o();
      var tmp$ret$0 = item.f86_1;
      destination.j(tmp$ret$0);
    }
    // Inline function 'kotlin.collections.filterIsInstance' call
    // Inline function 'kotlin.collections.filterIsInstanceTo' call
    var destination_0 = ArrayList_init_$Create$();
    var _iterator__ex2g4s_0 = destination.m();
    while (_iterator__ex2g4s_0.n()) {
      var element = _iterator__ex2g4s_0.o();
      if (!(element == null) ? isInterface(element, Cell) : false) {
        destination_0.j(element);
      }
    }
    return firstOrNull_1(destination_0);
  };
  protoOf(NodeCompletionBuilderImpl).jck = function (_this__u8e3s4, factory) {
    var transformRole = new NodeCompletionBuilderImpl$produces$transformRole$1(this, factory);
    var builder = new NodeCompletionBuilderImpl(this.l6z(), this.bcl(), this.jcl(), this.dcl(), this.ack(), transformRole, this.wcl_1, this.kcl());
    _this__u8e3s4.pci_1(builder);
  };
  protoOf(NodeCompletionBuilderImpl).kck = function (node, link, supplier) {
    var newContext = singleChildContext(node, link);
    var builder = new NodeCompletionBuilderImpl(this.l6z(), this.bcl(), this.jcl(), newContext, this.ack(), this.vcl_1, this.wcl_1, this.kcl());
    supplier(builder);
  };
  protoOf(NodeCompletionBuilderImpl).lck = function (completion) {
    var tmp = this.kcl();
    tmp.hcg(NodeCompletionBuilderImpl$async$slambda_0(this, completion, null));
  };
  function hackyGetCompletionEditor($this, cell) {
    if (!(get_frontPopup(cell) == null)) {
      var childOfPopup = ensureNotNull(get_frontPopup(cell)).y35();
      var tmp;
      if (!(childOfPopup instanceof TextCell)) {
        tmp = null;
      } else {
        tmp = childOfPopup;
      }
      return tmp;
    }
    return cell.k91(Companion_getInstance_162().h9e_1)().g9e();
  }
  function PrefixBasedCompletionSupplier() {
    CellAwareCompletionSupplier.call(this);
  }
  protoOf(PrefixBasedCompletionSupplier).fcg = function (cell, context, invalidationContext) {
    if (cell == null) {
      return invalidationContext.z5v(this.icl('', context));
    }
    var tmp;
    if (cell.c93(TextEditing_getInstance().t99_1)) {
      tmp = cell;
    } else {
      tmp = cell.y35();
    }
    var currentCell = tmp;
    if (currentCell == null) {
      return invalidationContext.z5v(this.icl('', context));
    }
    var tmp0_elvis_lhs = hackyGetCompletionEditor(this, currentCell);
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      return invalidationContext.z5v(this.icl('', context));
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var editor = tmp_0;
    invalidationContext.x5u(editor.o8w(), Invalidation_getInstance().g5u_1);
    var prefixText = editor.s96();
    var completionResult = this.icl(prefixText, context);
    return invalidationContext.z5v(completionResult);
  };
  function completion(_this__u8e3s4, provider, source, result, cell, completionOptions, completionAction) {
    completionOptions = completionOptions === VOID ? new CompletionOptions() : completionOptions;
    completionAction = completionAction === VOID ? null : completionAction;
    return (new ReferenceCompletion(_this__u8e3s4, cell, result, provider, source, completionOptions, completionAction)).ecg();
  }
  function ReferenceCompletion(coroutineScope, completionCell, reference, provider, refSource, completionOptions, completionAction) {
    completionAction = completionAction === VOID ? null : completionAction;
    ReferenceCompletionBase.call(this, coroutineScope, provider, completionOptions, Companion_getInstance_243().vcg_1);
    this.qcm_1 = completionCell;
    this.rcm_1 = reference;
    this.scm_1 = refSource;
    this.tcm_1 = completionAction;
  }
  protoOf(ReferenceCompletion).dcg = function () {
    return this.qcm_1;
  };
  protoOf(ReferenceCompletion).q72 = function (filter) {
    var tmp;
    try {
      tmp = this.fcl_1.o6q(new SourceNodeContext(this.scm_1), filter);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var t = $p;
        ThrowableHandlers_getInstance().k2r_1.j2r(t);
        tmp_0 = emptyFlow();
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  protoOf(ReferenceCompletion).ccl = function (item) {
    this.rcm_1.d2x(item.k6q_1);
    var tmp0_safe_receiver = this.tcm_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver(item);
    return tmp1_elvis_lhs == null ? toFirstPlaceholderWhenSettled(this.qcm_1) : tmp1_elvis_lhs;
  };
  function ReferenceCompletionBase$getSortedElements$o$collect$slambda($$this$unsafeFlow, $priorityFunction, resultContinuation) {
    this.ccn_1 = $$this$unsafeFlow;
    this.dcn_1 = $priorityFunction;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ReferenceCompletionBase$getSortedElements$o$collect$slambda).f1q = function (value, $completion) {
    var tmp = this.g1q(value, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(ReferenceCompletionBase$getSortedElements$o$collect$slambda).v9 = function (p1, $completion) {
    return this.f1q((p1 == null ? true : !(p1 == null)) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ReferenceCompletionBase$getSortedElements$o$collect$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            var tmp0 = this.ccn_1;
            var value = this.ecn_1;
            this.f9_1 = 1;
            var sortPriority = this.dcn_1(value.l6q_1);
            suspendResult = tmp0.x18(new SortedReferenceTargetItem(value, sortPriority), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(ReferenceCompletionBase$getSortedElements$o$collect$slambda).g1q = function (value, completion) {
    var i = new ReferenceCompletionBase$getSortedElements$o$collect$slambda(this.ccn_1, this.dcn_1, completion);
    i.ecn_1 = value;
    return i;
  };
  function ReferenceCompletionBase$getSortedElements$o$collect$slambda_0($$this$unsafeFlow, $priorityFunction, resultContinuation) {
    var i = new ReferenceCompletionBase$getSortedElements$o$collect$slambda($$this$unsafeFlow, $priorityFunction, resultContinuation);
    var l = function (value, $completion) {
      return i.f1q(value, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function $collectCOROUTINE$_16(_this__u8e3s4, collector, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.ncn_1 = _this__u8e3s4;
    this.ocn_1 = collector;
  }
  protoOf($collectCOROUTINE$_16).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            var $this$unsafeFlow = this.ocn_1;
            this.f9_1 = 1;
            var tmp_0 = ReferenceCompletionBase$getSortedElements$o$collect$slambda_0($this$unsafeFlow, this.ncn_1.qcn_1, null);
            suspendResult = this.ncn_1.pcn_1.f18(new sam$kotlinx_coroutines_flow_FlowCollector$0_11(tmp_0), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function getSortedElements($this, filter) {
    var tmp;
    if (!$this.gcl_1.uci_1) {
      tmp = ReferenceCompletionBase$getSortedElements$lambda;
    } else if (filter.h6r_1) {
      tmp = exactPrefixFirst($this, filter);
    } else {
      tmp = ReferenceCompletionBase$getSortedElements$lambda_0;
    }
    var priorityFunction = tmp;
    // Inline function 'kotlinx.coroutines.flow.map' call
    // Inline function 'kotlinx.coroutines.flow.unsafeTransform' call
    var this_0 = $this.q72(filter);
    // Inline function 'kotlinx.coroutines.flow.internal.unsafeFlow' call
    return new ReferenceCompletionBase$getSortedElements$$inlined$map$1(this_0, priorityFunction);
  }
  function exactPrefixFirst($this, _this__u8e3s4) {
    var prefixFilter = _this__u8e3s4.o6r(VOID, VOID, false);
    return ReferenceCompletionBase$exactPrefixFirst$lambda(prefixFilter);
  }
  function sam$kotlinx_coroutines_flow_FlowCollector$0_11(function_0) {
    this.rcn_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_11).x18 = function (value, $completion) {
    return this.rcn_1(value, $completion);
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_11).f3 = function () {
    return this.rcn_1;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_11).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, FlowCollector) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_11).hashCode = function () {
    return hashCode(this.f3());
  };
  function ReferenceCompletionBase$getSortedElements$lambda(_unused_var__etf5q3) {
    return 0;
  }
  function ReferenceCompletionBase$getSortedElements$lambda_0(_unused_var__etf5q3) {
    return 0;
  }
  function ReferenceCompletionBase$getSortedElements$$inlined$map$1($this, $priorityFunction) {
    this.pcn_1 = $this;
    this.qcn_1 = $priorityFunction;
  }
  protoOf(ReferenceCompletionBase$getSortedElements$$inlined$map$1).y18 = function (collector, $completion) {
    var tmp = new $collectCOROUTINE$_16(this, collector, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(ReferenceCompletionBase$getSortedElements$$inlined$map$1).f18 = function (collector, $completion) {
    return this.y18(collector, $completion);
  };
  function ReferenceCompletionBase$exactPrefixFirst$lambda($prefixFilter) {
    return function (string) {
      return $prefixFilter.m6r(string) ? 1 : 0;
    };
  }
  function ReferenceCompletionBase$consumeItem$ref(p0) {
    var l = function (_this__u8e3s4) {
      return p0.ccl(_this__u8e3s4);
    };
    l.callableName = 'consumeItem';
    return l;
  }
  function ReferenceCompletionBase(coroutineScope, provider, completionOptions, sortPriorityRange) {
    PrefixBasedCompletionSupplier.call(this);
    this.ecl_1 = coroutineScope;
    this.fcl_1 = provider;
    this.gcl_1 = completionOptions;
    this.hcl_1 = sortPriorityRange;
  }
  protoOf(ReferenceCompletionBase).icl = function (pattern, context) {
    var filter = TextFilter_init_$Create$_1(pattern, toFilterSettings(this.gcl_1));
    var elementsFlow = getSortedElements(this, filter);
    return completionResult(this.ecl_1, ReferenceCompletionBase$consumeItem$ref(this), filter, elementsFlow, this.hcl_1);
  };
  function Companion_243() {
    Companion_instance_243 = this;
    this.vcg_1 = new SortPriorityRange(0);
    this.wcg_1 = 65535;
  }
  protoOf(Companion_243).xcg = function (slot) {
    var tmp;
    if (slot > 32767) {
      tmp = 32767;
    } else if (slot < -32768) {
      tmp = -32768;
    } else {
      tmp = toShort(slot);
    }
    var shortSlot = tmp;
    return new SortPriorityRange(shortSlot);
  };
  var Companion_instance_243;
  function Companion_getInstance_243() {
    if (Companion_instance_243 == null)
      new Companion_243();
    return Companion_instance_243;
  }
  function SortPriorityRange(slot) {
    Companion_getInstance_243();
    this.pcg_1 = slot * 65535 | 0;
  }
  protoOf(SortPriorityRange).lcj = function (local) {
    return this.pcg_1 + local | 0;
  };
  protoOf(SortPriorityRange).qcg = function (local, $super) {
    local = local === VOID ? 0 : local;
    return $super === VOID ? this.lcj(local) : $super.lcj.call(this, local);
  };
  function SortedReferenceTargetItem(targetItem, sortPriority) {
    this.vci_1 = targetItem;
    this.wci_1 = sortPriority;
  }
  function updateText_0($this, text) {
    if (!($this.ucn_1 == null) && $this.vcn().j6r_1 === text) {
      return Unit_instance;
    }
    $this.ucn_1 = get_tokenized(text);
  }
  function TextMatcherByFilterSettings(filterSettings, itemText) {
    this.scn_1 = filterSettings;
    this.tcn_1 = itemText;
  }
  protoOf(TextMatcherByFilterSettings).vcn = function () {
    var tmp = this.ucn_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('tokenizedText');
    }
  };
  protoOf(TextMatcherByFilterSettings).y9q = function (text) {
    updateText_0(this, text);
    return TextFilter_init_$Create$(this.vcn(), this.scn_1).i6r(this.tcn_1);
  };
  protoOf(TextMatcherByFilterSettings).l9k = function (text) {
    return equals_0(this.tcn_1.j6r_1, text, this.scn_1.a6r());
  };
  protoOf(TextMatcherByFilterSettings).toString = function () {
    return "{pattern='" + this.tcn_1.j6r_1 + "', ignoreCase=" + this.scn_1.a6r() + ', tokenization=' + this.scn_1.b6r() + '}';
  };
  function completes(_this__u8e3s4, action) {
    // Inline function 'jetbrains.ocelot.projectional.cell.completion.result.simpleCompletionItem' call
    return new completes$$inlined$simpleCompletionItem$1(_this__u8e3s4, 0, true, action);
  }
  function simpleCompletion(_this__u8e3s4) {
    return new simpleCompletion$1(_this__u8e3s4);
  }
  function produces(_this__u8e3s4, action) {
    return new Pair(_this__u8e3s4, action);
  }
  function intRoleCompletion() {
    return new intRoleCompletion$1();
  }
  function completionForNumber(consumer) {
    return CompletionSupplement_instance.o9p([completionItemForNumber(0, consumer)]);
  }
  function completionItemForNumber(sortPriority, consumer) {
    return new completionItemForNumber$1(sortPriority, consumer);
  }
  function completionItemForId(sortPriority, consumer) {
    return completionItemForValidator(get_IdentifierValidator(), sortPriority, consumer);
  }
  function completionItemForValidator(validator, sortPriority, consumer) {
    return new completionItemForValidator$1(sortPriority, validator, consumer);
  }
  function completes$$inlined$simpleCompletionItem$1($matchingText, $sortPriority, $isCaseSensitive, $action) {
    this.aco_1 = $action;
    SimpleCompletionItem.call(this, $matchingText, VOID, $sortPriority, $isCaseSensitive);
  }
  protoOf(completes$$inlined$simpleCompletionItem$1).s9m = function (text) {
    return this.aco_1();
  };
  function createRoleCompletion$completionItem($target, ci) {
    // Inline function 'jetbrains.ocelot.projectional.cell.completion.result.simpleCompletionItem' call
    var matchingText = ci.pg_1;
    return new simpleCompletion$1$createRoleCompletion$completionItem$$inlined$simpleCompletionItem$1(matchingText, 0, true, $target, ci);
  }
  function simpleCompletion$1$createRoleCompletion$completionItem$$inlined$simpleCompletionItem$1($matchingText, $sortPriority, $isCaseSensitive, $target, $ci) {
    this.fco_1 = $target;
    this.gco_1 = $ci;
    SimpleCompletionItem.call(this, $matchingText, VOID, $sortPriority, $isCaseSensitive);
  }
  protoOf(simpleCompletion$1$createRoleCompletion$completionItem$$inlined$simpleCompletionItem$1).s9m = function (text) {
    return this.fco_1.yak(this.gco_1.qg_1(text));
  };
  function simpleCompletion$1($this_simpleCompletion) {
    this.hco_1 = $this_simpleCompletion;
  }
  protoOf(simpleCompletion$1).ico = function (mapper, contextNode, target) {
    var tmp = CompletionSupplement_instance;
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.hco_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.m();
    while (_iterator__ex2g4s.n()) {
      var item = _iterator__ex2g4s.o();
      var tmp$ret$0 = createRoleCompletion$completionItem(target, item);
      destination.j(tmp$ret$0);
    }
    // Inline function 'kotlin.collections.toTypedArray' call
    var tmp$ret$3 = copyToArray(destination);
    return tmp.o9p(tmp$ret$3.slice());
  };
  protoOf(simpleCompletion$1).oan = function (mapper, contextNode, target) {
    return this.ico(mapper, contextNode, target);
  };
  function intRoleCompletion$o$createRoleCompletion$lambda($target) {
    return function (it) {
      return $target.yak(it);
    };
  }
  function intRoleCompletion$1() {
  }
  protoOf(intRoleCompletion$1).jco = function (mapper, contextNode, target) {
    return completionForNumber(intRoleCompletion$o$createRoleCompletion$lambda(target));
  };
  protoOf(intRoleCompletion$1).oan = function (mapper, contextNode, target) {
    return this.jco(mapper, contextNode, target);
  };
  function completionItemForNumber$1($sortPriority, $consumer) {
    this.lco_1 = $consumer;
    BaseCompletionItem.call(this);
    this.kco_1 = $sortPriority;
  }
  protoOf(completionItemForNumber$1).c9k = function () {
    return 'number';
  };
  protoOf(completionItemForNumber$1).l9n = function () {
    return this.kco_1;
  };
  protoOf(completionItemForNumber$1).m9n = function (text) {
    return '' === text || this.l9k(text);
  };
  protoOf(completionItemForNumber$1).l9k = function (text) {
    return Validators_getInstance().w8t()(text);
  };
  protoOf(completionItemForNumber$1).s9m = function (text) {
    var tmp;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(text) === 0) {
      tmp = 0;
    } else {
      tmp = toInt(text);
    }
    var value = tmp;
    return this.lco_1(value);
  };
  protoOf(completionItemForNumber$1).toString = function () {
    return 'number completion';
  };
  function completionItemForValidator$1($sortPriority, $validator, $consumer) {
    this.oco_1 = $validator;
    this.pco_1 = $consumer;
    BaseCompletionItem.call(this);
    this.mco_1 = 'id';
    this.nco_1 = $sortPriority;
  }
  protoOf(completionItemForValidator$1).c9k = function () {
    return this.mco_1;
  };
  protoOf(completionItemForValidator$1).l9n = function () {
    return this.nco_1;
  };
  protoOf(completionItemForValidator$1).m9n = function (text) {
    var tmp;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(text) === 0) {
      tmp = true;
    } else {
      tmp = this.oco_1(text);
    }
    return tmp;
  };
  protoOf(completionItemForValidator$1).l9k = function (text) {
    return this.oco_1(text);
  };
  protoOf(completionItemForValidator$1).s9m = function (text) {
    return this.pco_1(text);
  };
  function map_2(_this__u8e3s4, f) {
    var tmp = map$lambda(_this__u8e3s4, f);
    return new sam$jetbrains_ocelot_projectional_editor_generic_roleCompletion_RoleCompletion$0_2(tmp);
  }
  function plus_14(_this__u8e3s4, other) {
    var tmp = plus$lambda(_this__u8e3s4, other);
    return new sam$jetbrains_ocelot_projectional_editor_generic_roleCompletion_RoleCompletion$0_3(tmp);
  }
  function map_3(_this__u8e3s4, f) {
    return new map$3(_this__u8e3s4, f);
  }
  function plus_15(_this__u8e3s4, other) {
    // Inline function 'jetbrains.ocelot.projectional.cell.completion.context.completionSupplier' call
    return new plus$$inlined$completionSupplier$1(false, _this__u8e3s4, other);
  }
  function combine_0(_this__u8e3s4, other) {
    var t = Companion_instance_169.o8u();
    t = t.r9r(_this__u8e3s4);
    t = t.r9r(other);
    return t.uv();
  }
  function sam$jetbrains_ocelot_projectional_editor_generic_roleCompletion_RoleCompletion$0_2(function_0) {
    this.qco_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_projectional_editor_generic_roleCompletion_RoleCompletion$0_2).oan = function (mapper, contextNode, target) {
    return this.qco_1(mapper, contextNode, target);
  };
  protoOf(sam$jetbrains_ocelot_projectional_editor_generic_roleCompletion_RoleCompletion$0_2).f3 = function () {
    return this.qco_1;
  };
  protoOf(sam$jetbrains_ocelot_projectional_editor_generic_roleCompletion_RoleCompletion$0_2).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, RoleCompletion) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_projectional_editor_generic_roleCompletion_RoleCompletion$0_2).hashCode = function () {
    return hashCode(this.f3());
  };
  function sam$jetbrains_ocelot_projectional_editor_generic_roleCompletion_RoleCompletion$0_3(function_0) {
    this.rco_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_projectional_editor_generic_roleCompletion_RoleCompletion$0_3).oan = function (mapper, contextNode, target) {
    return this.rco_1(mapper, contextNode, target);
  };
  protoOf(sam$jetbrains_ocelot_projectional_editor_generic_roleCompletion_RoleCompletion$0_3).f3 = function () {
    return this.rco_1;
  };
  protoOf(sam$jetbrains_ocelot_projectional_editor_generic_roleCompletion_RoleCompletion$0_3).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, RoleCompletion) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_projectional_editor_generic_roleCompletion_RoleCompletion$0_3).hashCode = function () {
    return hashCode(this.f3());
  };
  function map$lambda($this_map, $f) {
    return function (mapper, contextNode, target) {
      return $this_map.oan(mapper, contextNode, map_3(target, $f));
    };
  }
  function plus$lambda($this_plus, $other) {
    return function (mapper, contextNode, target) {
      var cs1 = $this_plus.oan(mapper, contextNode, target);
      var cs2 = $other.oan(mapper, contextNode, target);
      return plus_15(cs1, cs2);
    };
  }
  function map$3($this_map, $f) {
    this.sco_1 = $this_map;
    this.tco_1 = $f;
  }
  protoOf(map$3).uco = function (target) {
    return this.sco_1.yak(this.tco_1(target));
  };
  protoOf(map$3).yak = function (target) {
    return this.uco(!(target == null) ? target : THROW_CCE());
  };
  function plus$$inlined$completionSupplier$1($cacheable, $this_plus, $other) {
    this.vco_1 = $cacheable;
    this.wco_1 = $this_plus;
    this.xco_1 = $other;
  }
  protoOf(plus$$inlined$completionSupplier$1).q9f = function () {
    return this.vco_1;
  };
  protoOf(plus$$inlined$completionSupplier$1).m9e = function (completionContext) {
    return combine_0(this.wco_1.m9e(completionContext), this.xco_1.m9e(completionContext));
  };
  function editorString(_this__u8e3s4, mark) {
    return new editorString$1(mark);
  }
  function sam$jetbrains_ocelot_langDef_completion_ActionOnCell$0_0(function_0) {
    this.yco_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_langDef_completion_ActionOnCell$0_0).ock = function (cell) {
    return this.yco_1(cell);
  };
  protoOf(sam$jetbrains_ocelot_langDef_completion_ActionOnCell$0_0).f3 = function () {
    return this.yco_1;
  };
  protoOf(sam$jetbrains_ocelot_langDef_completion_ActionOnCell$0_0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, ActionOnCell) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_langDef_completion_ActionOnCell$0_0).hashCode = function () {
    return hashCode(this.f3());
  };
  function editorString$o$provideCompletion$lambda$lambda($mark) {
    return function (it) {
      var tmp0_safe_receiver = find_2(it, $mark);
      return tmp0_safe_receiver == null ? null : toEnd_0(tmp0_safe_receiver);
    };
  }
  function editorString$o$provideCompletion$lambda($factory, $mark) {
    return function ($this$does, string) {
      var node = $factory(string);
      $this$does.mck(node);
      var tmp = editorString$o$provideCompletion$lambda$lambda($mark);
      return $this$does.nck(new sam$jetbrains_ocelot_langDef_completion_ActionOnCell$0_0(tmp));
    };
  }
  function editorString$1($mark) {
    this.zco_1 = $mark;
    CustomCompletionKind.call(this);
  }
  protoOf(editorString$1).acp = function (_this__u8e3s4, factory) {
    var tmp = _this__u8e3s4.qci();
    _this__u8e3s4.cck(tmp, editorString$o$provideCompletion$lambda(factory, this.zco_1));
  };
  protoOf(editorString$1).oci = function (_this__u8e3s4, factory) {
    return this.acp(_this__u8e3s4, factory);
  };
  function nodeRefCompletion(_this__u8e3s4, refTag, childContext) {
    childContext = childContext === VOID ? null : childContext;
    return nodeRefCompletion_0(_this__u8e3s4, _this__u8e3s4.d6u(refTag), childContext);
  }
  function nodeRefCompletion_0(_this__u8e3s4, provider, childContext) {
    childContext = childContext === VOID ? null : childContext;
    return nodeRefCompletion_1(provider, _this__u8e3s4, childContext);
  }
  function nodeRefCompletion_1(supplier, coroutineScope, childContext) {
    childContext = childContext === VOID ? null : childContext;
    return new nodeRefCompletion$1(coroutineScope, supplier, childContext);
  }
  function nodeRefCompletion$1$createRoleCompletion$completionBase$1($coroutineScope, $supplier, $target, $childContext, $contextNode, $mapper) {
    this.fcp_1 = $supplier;
    this.gcp_1 = $target;
    this.hcp_1 = $childContext;
    this.icp_1 = $contextNode;
    this.jcp_1 = $mapper;
    ReferenceCompletionBase.call(this, $coroutineScope, $supplier, new CompletionOptions(), Companion_getInstance_243().vcg_1);
  }
  protoOf(nodeRefCompletion$1$createRoleCompletion$completionBase$1).ccl = function (item) {
    return this.gcp_1.yak(item.k6q_1);
  };
  protoOf(nodeRefCompletion$1$createRoleCompletion$completionBase$1).q72 = function (filter) {
    var tmp;
    if (!(this.hcp_1 == null)) {
      tmp = toEnclosingNodeContext(this.hcp_1);
    } else if (!(this.icp_1 == null)) {
      tmp = new EnclosingNodeContext(this.icp_1, null);
    } else {
      throw IllegalArgumentException_init_$Create$_0("Either childContext or editor's context node must not be null");
    }
    var elementsContext = tmp;
    return this.fcp_1.o6q(elementsContext, filter);
  };
  protoOf(nodeRefCompletion$1$createRoleCompletion$completionBase$1).dcg = function () {
    var tmp = this.jcp_1.f86_1;
    var tmp0_safe_receiver = ((!(tmp == null) ? isInterface(tmp, Cell) : false) ? tmp : THROW_CCE()).s8x();
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.z92();
    return tmp1_safe_receiver == null ? null : tmp1_safe_receiver.w2w();
  };
  function nodeRefCompletion$1($coroutineScope, $supplier, $childContext) {
    this.kcp_1 = $coroutineScope;
    this.lcp_1 = $supplier;
    this.mcp_1 = $childContext;
  }
  protoOf(nodeRefCompletion$1).ncp = function (mapper, contextNode, target) {
    var completionBase = new nodeRefCompletion$1$createRoleCompletion$completionBase$1(this.kcp_1, this.lcp_1, target, this.mcp_1, contextNode, mapper);
    return completionBase.ecg();
  };
  protoOf(nodeRefCompletion$1).oan = function (mapper, contextNode, target) {
    return this.ncp(mapper, contextNode, target);
  };
  function BaseCellBuilder$build$lambda($childSetupFunctions, this$0, $context, $source, $resultCell) {
    return function () {
      var _iterator__ex2g4s = $childSetupFunctions.m();
      while (_iterator__ex2g4s.n()) {
        var sf = _iterator__ex2g4s.o();
        sf();
      }
      var _iterator__ex2g4s_0 = this$0.rcp_1.m();
      while (_iterator__ex2g4s_0.n()) {
        var sync = _iterator__ex2g4s_0.o();
        sync($context, $source, $resultCell);
      }
      var _iterator__ex2g4s_1 = this$0.qcp_1.m();
      while (_iterator__ex2g4s_1.n()) {
        var setupFun = _iterator__ex2g4s_1.o();
        setupFun($context, $source, $resultCell);
      }
      var _iterator__ex2g4s_2 = this$0.scp_1.m();
      while (_iterator__ex2g4s_2.n()) {
        var builder = _iterator__ex2g4s_2.o();
        $resultCell.w92(builder.vcp());
      }
      return Unit_instance;
    };
  }
  function BaseCellBuilder() {
    this.ocp_1 = ArrayList_init_$Create$();
    this.pcp_1 = false;
    this.qcp_1 = ArrayList_init_$Create$();
    this.rcp_1 = ArrayList_init_$Create$();
    this.scp_1 = ArrayList_init_$Create$();
  }
  protoOf(BaseCellBuilder).wcp = function (child) {
    // Inline function 'kotlin.check' call
    if (!!this.pcp_1) {
      var message = 'trying to update children after builder initialization';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    this.ocp_1.j(child);
  };
  protoOf(BaseCellBuilder).xcp = function (init) {
    // Inline function 'kotlin.check' call
    if (!!this.pcp_1) {
      var message = 'trying to add setup block after builder initialization';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    this.qcp_1.j(init);
  };
  protoOf(BaseCellBuilder).ycp = function (init) {
    // Inline function 'kotlin.check' call
    if (!!this.pcp_1) {
      var message = 'trying to add setupSynchronizers block after builder initialization';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    this.rcp_1.j(init);
  };
  protoOf(BaseCellBuilder).acq = function (source, cellMap, context) {
    this.pcp_1 = true;
    var result = this.zcp(source, context);
    var resultCell = result.bcq_1;
    var id = result.ccq_1;
    if (!(id == null)) {
      var contextKey = new ContextKey(this, id);
      var previousValue = cellMap.t2(contextKey, resultCell);
      // Inline function 'kotlin.check' call
      if (!(previousValue == null)) {
        var message = 'previous value present: ' + toString_0(previousValue) + ', cell builder: ' + toString_1(this) + ', value: ' + result.toString();
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      }
    }
    var childSetupFunctions = ArrayList_init_$Create$();
    var _iterator__ex2g4s = this.ocp_1.m();
    while (_iterator__ex2g4s.n()) {
      var childCellBuilder = _iterator__ex2g4s.o();
      var buildResult = childCellBuilder.acq(source, cellMap, context);
      var cell = buildResult.dcq_1;
      childSetupFunctions.j(buildResult.ecq_1);
      resultCell.q92().j(cell);
    }
    return new CellBuildResult(resultCell, BaseCellBuilder$build$lambda(childSetupFunctions, this, context, source, resultCell));
  };
  function CellBuildResult(cell, setupFunction) {
    this.dcq_1 = cell;
    this.ecq_1 = setupFunction;
  }
  protoOf(CellBuildResult).toString = function () {
    return 'CellBuildResult(cell=' + toString_1(this.dcq_1) + ', setupFunction=' + toString_1(this.ecq_1) + ')';
  };
  protoOf(CellBuildResult).hashCode = function () {
    var result = hashCode(this.dcq_1);
    result = imul(result, 31) + hashCode(this.ecq_1) | 0;
    return result;
  };
  protoOf(CellBuildResult).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CellBuildResult))
      return false;
    if (!equals(this.dcq_1, other.dcq_1))
      return false;
    if (!equals(this.ecq_1, other.ecq_1))
      return false;
    return true;
  };
  function CellBuilderContext() {
  }
  function rootIndent(_this__u8e3s4, init) {
    return indent(_this__u8e3s4, VOID, rootIndent$lambda(init));
  }
  function textProperty(_this__u8e3s4, placeholder, property) {
    return editableText(_this__u8e3s4, VOID, VOID, placeholder, textProperty$lambda(property));
  }
  function indentLabel(_this__u8e3s4, text_0, allowLast) {
    allowLast = allowLast === VOID ? false : allowLast;
    // Inline function 'kotlin.apply' call
    text(_this__u8e3s4, text_0).ycp(indentLabel$lambda(text_0, allowLast));
  }
  function decimalProperty(_this__u8e3s4, placeholder, property) {
    var tmp = bigDecimalValidator$ref();
    return editableText(_this__u8e3s4, tmp, VOID, placeholder, decimalProperty$lambda(property));
  }
  function integerProperty(_this__u8e3s4, placeholder, property) {
    var tmp0_validator = Validators_getInstance().x8t();
    return editableText(_this__u8e3s4, tmp0_validator, VOID, placeholder, integerProperty$lambda(property));
  }
  function selectFirstPlaceholderOnCreate(_this__u8e3s4) {
    var tmp = ProjectionalSynchronizers_getInstance().d99_1;
    trait(_this__u8e3s4, tmp, selectFirstPlaceholderOnCreate$lambda);
  }
  function rootIndent$lambda($init) {
    return function ($this$indent) {
      $init($this$indent);
      selectFirstPlaceholderOnCreate($this$indent);
      return Unit_instance;
    };
  }
  function textProperty$lambda($property) {
    return function ($this$editableText) {
      textSyncTwoWay($this$editableText, $property);
      return Unit_instance;
    };
  }
  function indentLabel$1($textCell) {
    this.jcq_1 = $textCell;
  }
  protoOf(indentLabel$1).l5u = function (context) {
    return prevCellIsPlaceholderOrNone(context, this.jcq_1);
  };
  function indentLabel$lambda$lambda($prevIsPlaceholder) {
    return function () {
      return $prevIsPlaceholder.w2w();
    };
  }
  function indentLabel$lambda$lambda_0($allowLast) {
    return function () {
      return $allowLast;
    };
  }
  function _no_name_provided__qut3iv_3($traitDisposable, $textCell) {
    this.kcq_1 = $traitDisposable;
    this.lcq_1 = $textCell;
  }
  protoOf(_no_name_provided__qut3iv_3).x9j = function (newValue) {
    var tmp0_safe_receiver = this.kcq_1._v;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.zr();
    }
    if (newValue) {
      this.kcq_1._v = this.lcq_1.w92(TextEditing_getInstance().m9a(true, false));
    }
    return Unit_instance;
  };
  protoOf(_no_name_provided__qut3iv_3).d2x = function (newValue) {
    return this.x9j((newValue == null ? true : !(newValue == null)) ? newValue : THROW_CCE());
  };
  function indentLabel$lambda($text, $allowLast) {
    return function ($this$setupSynchronizers, _unused_var__etf5q3, textCell) {
      var tmp;
      // Inline function 'kotlin.text.isNotEmpty' call
      var this_0 = $text;
      if (charSequenceLength(this_0) > 0) {
        var prevIsPlaceholder = new EagerInvalidatable(new indentLabel$1(textCell));
        if ($allowLast || $text.length > 1) {
          textCell.p92().f2x(true);
          var tmp_0 = TextEditing_getInstance();
          var tmp_1 = indentLabel$lambda$lambda(prevIsPlaceholder);
          textCell.w92(tmp_0.oa6(tmp_1, indentLabel$lambda$lambda_0($allowLast)));
        } else {
          var traitDisposable = {_v: null};
          $this$setupSynchronizers.l8b(syncOneWay(prevIsPlaceholder, textCell.p92()));
          // Inline function 'jetbrains.ocelot.base.observable.property.writableProperty' call
          var tmp$ret$1 = new _no_name_provided__qut3iv_3(traitDisposable, textCell);
          $this$setupSynchronizers.l8b(syncOneWay(prevIsPlaceholder, tmp$ret$1));
        }
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function bigDecimalValidator$ref() {
    var l = function (p0) {
      return bigDecimalValidator(p0);
    };
    l.callableName = 'bigDecimalValidator';
    return l;
  }
  function decimalProperty$lambda($property) {
    return function ($this$editableText) {
      decimalSyncTwoWay($this$editableText, $property);
      return Unit_instance;
    };
  }
  function integerProperty$lambda($property) {
    return function ($this$editableText) {
      intSyncTwoWay($this$editableText, $property);
      return Unit_instance;
    };
  }
  function selectFirstPlaceholderOnCreate$lambda($this$trait, _unused_var__etf5q3, cell) {
    return toFirstPlaceholderWhenSettled(cell);
  }
  function CellBuilderId(name) {
    BaseId.call(this, VOID, name);
  }
  function keyword(_this__u8e3s4, text) {
    var factory = keyword$lambda(text);
    cell(_this__u8e3s4, 'keyword', factory);
  }
  function space(_this__u8e3s4) {
    text(_this__u8e3s4, ' ');
  }
  function newLine(_this__u8e3s4) {
    cell(_this__u8e3s4, 'newLine', CellFactory$newLine$ref(CellFactory_instance));
  }
  function rightTransform(_this__u8e3s4, init) {
    return addTraitOnAttach(_this__u8e3s4, rightTransform$lambda(init));
  }
  function indent(_this__u8e3s4, isIndented, init) {
    isIndented = isIndented === VOID ? false : isIndented;
    var factory = indent$lambda(isIndented);
    return cell(_this__u8e3s4, 'indent', factory, init);
  }
  function addTraitOnAttach(_this__u8e3s4, traitFactory) {
    return addTraitOnAttachGeneric(_this__u8e3s4, addTraitOnAttach$lambda(traitFactory));
  }
  function label(_this__u8e3s4, text) {
    var factory = label$lambda(text);
    return cell(_this__u8e3s4, 'label', factory);
  }
  function horizontal(_this__u8e3s4, init) {
    return cell(_this__u8e3s4, 'horizontal', HorizontalCell$_init_$ref_7uua69(), init);
  }
  function placeholderInCollection(_this__u8e3s4, text, collectionItemCompletion) {
    text = text === VOID ? '' : text;
    return editableText(_this__u8e3s4, VOID, VOID, text, placeholderInCollection$lambda(collectionItemCompletion));
  }
  function focusable(_this__u8e3s4, newValue) {
    return _this__u8e3s4.xcp(focusable$lambda(newValue));
  }
  function editableText(_this__u8e3s4, validator, text, placeholderText, init) {
    validator = validator === VOID ? null : validator;
    text = text === VOID ? '' : text;
    placeholderText = placeholderText === VOID ? null : placeholderText;
    var tmp;
    if (init === VOID) {
      tmp = editableText$lambda;
    } else {
      tmp = init;
    }
    init = tmp;
    var id = new CellBuilderId('editableText');
    var namedCellFactory = new NamedCellFactory('editableText', TextCell$_init_$ref_mn70h6(), id);
    var mainCellBuilder = cell_0(_this__u8e3s4, namedCellFactory, editableText$lambda_0(text, validator));
    init(mainCellBuilder);
    if (!(placeholderText == null)) {
      var placeholderNamedCellFactory = new NamedCellFactory('placeholderText (editableText)', editableText$lambda_1(placeholderText), id);
      var placeholderCellBuilder = cell_0(_this__u8e3s4, placeholderNamedCellFactory);
      _this__u8e3s4.xcp(editableText$lambda_2(mainCellBuilder, id, placeholderCellBuilder));
    }
    return mainCellBuilder;
  }
  function text(_this__u8e3s4, text) {
    var factory = text$lambda(text);
    return cell(_this__u8e3s4, "text('" + text + "')", factory);
  }
  function trait(_this__u8e3s4, propSpec, specAction) {
    return addTrait_0(_this__u8e3s4, trait$lambda(propSpec, specAction));
  }
  function cell(_this__u8e3s4, name, factory, init) {
    var tmp;
    if (init === VOID) {
      tmp = cell$lambda;
    } else {
      tmp = init;
    }
    init = tmp;
    return cell_0(_this__u8e3s4, new NamedCellFactory(name, factory), init);
  }
  function addTraitOnAttachGeneric(_this__u8e3s4, traitFactory) {
    _this__u8e3s4.ycp(addTraitOnAttachGeneric$lambda(traitFactory));
  }
  function addTrait(_this__u8e3s4, trait) {
    return addTrait_0(_this__u8e3s4, addTrait$lambda(trait));
  }
  function completion_0(_this__u8e3s4, init) {
    return addTraitOnAttachGeneric(_this__u8e3s4, completion$lambda(init));
  }
  function cell_0(_this__u8e3s4, namedCellFactory, init) {
    var tmp;
    if (init === VOID) {
      tmp = cell$lambda_0;
    } else {
      tmp = init;
    }
    init = tmp;
    var result = new SimpleCellBuilder(namedCellFactory, _this__u8e3s4.fcq());
    init(result);
    _this__u8e3s4.wcp(result);
    return result;
  }
  function setText_0(_this__u8e3s4, newValue) {
    return _this__u8e3s4.xcp(setText$lambda(newValue));
  }
  function addTrait_0(_this__u8e3s4, traitFactory) {
    return _this__u8e3s4.xcp(addTrait$lambda_0(traitFactory));
  }
  function completion_1(_this__u8e3s4, init) {
    return addTraitOnAttach(_this__u8e3s4, completion$lambda_0(init));
  }
  function keyword$lambda($text) {
    return function () {
      return CellFactory_instance.ua9($text);
    };
  }
  function CellFactory$newLine$ref(p0) {
    var l = function () {
      return p0.l8v();
    };
    l.callableName = 'newLine';
    return l;
  }
  function rightTransform$2$$inlined$propertyTrait$1($propSpec, $init, $this_addTraitOnAttach, $source, $textCell, $cellFinder) {
    this.mcq_1 = $propSpec;
    this.ncq_1 = $init;
    this.ocq_1 = $this_addTraitOnAttach;
    this.pcq_1 = $source;
    this.qcq_1 = $textCell;
    this.rcq_1 = $cellFinder;
    CellTrait.call(this);
  }
  protoOf(rightTransform$2$$inlined$propertyTrait$1).n91 = function (cell, spec) {
    var tmp;
    if (spec === this.mcq_1) {
      tmp = this.ncq_1(this.ocq_1, this.pcq_1, this.qcq_1, this.rcq_1);
    } else {
      tmp = protoOf(CellTrait).n91.call(this, cell, spec);
    }
    return tmp;
  };
  function rightTransform$lambda($init) {
    return function ($this$addTraitOnAttach, source, textCell, cellFinder) {
      var tmp;
      if (!$this$addTraitOnAttach.scq()) {
        // Inline function 'jetbrains.ocelot.projectional.cell.trait.propertyTrait' call
        var propSpec = Completion_getInstance().w9d_1;
        tmp = new rightTransform$2$$inlined$propertyTrait$1(propSpec, $init, $this$addTraitOnAttach, source, textCell, cellFinder);
      } else {
        tmp = Companion_getInstance_186().wa8_1;
      }
      return tmp;
    };
  }
  function indent$lambda($isIndented) {
    return function () {
      return new IndentCell($isIndented);
    };
  }
  function addTraitOnAttach$lambda($traitFactory) {
    return function ($this$addTraitOnAttachGeneric, source, cell, mappingContext) {
      var cellFinder = getMapperCellFinder(mappingContext);
      return $traitFactory($this$addTraitOnAttachGeneric, source, cell, cellFinder);
    };
  }
  function label$lambda($text) {
    return function () {
      return CellFactory_instance.ta9($text);
    };
  }
  function HorizontalCell$_init_$ref_7uua69() {
    var l = function () {
      return new HorizontalCell();
    };
    l.callableName = '<init>';
    return l;
  }
  function isEmpty$ref_0() {
    var l = function (p0) {
      // Inline function 'kotlin.text.isEmpty' call
      return charSequenceLength(p0) === 0;
    };
    l.callableName = 'isEmpty';
    return l;
  }
  function placeholderInCollection$lambda$lambda($collectionItemCompletion) {
    return function ($this$completion, mapper) {
      var roleCompletion = $collectionItemCompletion($this$completion);
      return getCollectionPlaceholderCompletionSupplier(mapper, roleCompletion);
    };
  }
  function placeholderInCollection$lambda($collectionItemCompletion) {
    return function ($this$editableText) {
      var tmp = TextEditing_getInstance();
      addTrait($this$editableText, tmp.ta6(isEmpty$ref_0()));
      completion_0($this$editableText, placeholderInCollection$lambda$lambda($collectionItemCompletion));
      return Unit_instance;
    };
  }
  function focusable$lambda($newValue) {
    return function ($this$setup, _unused_var__etf5q3, cell) {
      cell.p92().d2x($newValue);
      return Unit_instance;
    };
  }
  function editableText$lambda(_this__u8e3s4) {
    return Unit_instance;
  }
  function TextCell$_init_$ref_mn70h6() {
    var l = function () {
      return TextCell_init_$Create$();
    };
    l.callableName = '<init>';
    return l;
  }
  function editableText$lambda$lambda($validator) {
    return function ($this$addTrait, _unused_var__etf5q3, _unused_var__etf5q3_0) {
      return $this$addTrait.gcq().scq() ? TextEditing_getInstance().na6() : $validator == null ? TextEditing_getInstance().sa6() : TextEditing_getInstance().ta6($validator);
    };
  }
  function editableText$lambda_0($text, $validator) {
    return function ($this$cell) {
      focusable($this$cell, true);
      setText_0($this$cell, $text);
      addTrait_0($this$cell, editableText$lambda$lambda($validator));
      return Unit_instance;
    };
  }
  function editableText$lambda_1($placeholderText) {
    return function () {
      return placeholder($placeholderText);
    };
  }
  function editableText$lambda_2($mainCellBuilder, $id, $placeholderCellBuilder) {
    return function ($this$setup, _unused_var__etf5q3, _unused_var__etf5q3_0) {
      var mainTextCell = $this$setup.icq($mainCellBuilder, $id);
      var placeholderTextCell = $this$setup.icq($placeholderCellBuilder, $id);
      attachToPlaceholder(placeholderTextCell, mainTextCell);
      return Unit_instance;
    };
  }
  function text$lambda($text) {
    return function () {
      return TextCell_init_$Create$_0($text);
    };
  }
  function trait$2$$inlined$propertyTrait$1($propSpec, $specAction, $this_addTrait, $source, $cellT) {
    this.tcq_1 = $propSpec;
    this.ucq_1 = $specAction;
    this.vcq_1 = $this_addTrait;
    this.wcq_1 = $source;
    this.xcq_1 = $cellT;
    CellTrait.call(this);
  }
  protoOf(trait$2$$inlined$propertyTrait$1).n91 = function (cell, spec) {
    var tmp;
    if (spec === this.tcq_1) {
      tmp = this.ucq_1(this.vcq_1, this.wcq_1, this.xcq_1);
    } else {
      tmp = protoOf(CellTrait).n91.call(this, cell, spec);
    }
    return tmp;
  };
  function trait$lambda($propSpec, $specAction) {
    return function ($this$addTrait, source, cellT) {
      // Inline function 'jetbrains.ocelot.projectional.cell.trait.propertyTrait' call
      var propSpec = $propSpec;
      return new trait$2$$inlined$propertyTrait$1(propSpec, $specAction, $this$addTrait, source, cellT);
    };
  }
  function cell$lambda(_this__u8e3s4) {
    return Unit_instance;
  }
  function addTraitOnAttachGeneric$2$sync$1($traitFactory, $this_setupSynchronizers, $source, $cell) {
    this.zcq_1 = $traitFactory;
    this.acr_1 = $this_setupSynchronizers;
    this.bcr_1 = $source;
    this.ccr_1 = $cell;
    DisposableSynchronizer.call(this);
  }
  protoOf(addTraitOnAttachGeneric$2$sync$1).s87 = function (ctx) {
    var trait = this.zcq_1(this.acr_1.gcq(), this.bcr_1, this.ccr_1, ctx.b88());
    return this.ccr_1.w92(trait);
  };
  function addTraitOnAttachGeneric$lambda($traitFactory) {
    return function ($this$setupSynchronizers, source, cell) {
      var sync = new addTraitOnAttachGeneric$2$sync$1($traitFactory, $this$setupSynchronizers, source, cell);
      $this$setupSynchronizers.l8b(sync);
      return Unit_instance;
    };
  }
  function addTrait$lambda($trait) {
    return function ($this$addTrait, _unused_var__etf5q3, _unused_var__etf5q3_0) {
      return $trait;
    };
  }
  function completion$2$$inlined$propertyTrait$1($propSpec, $mappingContext, $source, $init, $this_addTraitOnAttachGeneric) {
    this.dcr_1 = $propSpec;
    this.ecr_1 = $mappingContext;
    this.fcr_1 = $source;
    this.gcr_1 = $init;
    this.hcr_1 = $this_addTraitOnAttachGeneric;
    CellTrait.call(this);
  }
  protoOf(completion$2$$inlined$propertyTrait$1).n91 = function (cell, spec) {
    var tmp;
    if (spec === this.dcr_1) {
      var tmp0 = this.ecr_1.f8a(this.fcr_1);
      var tmp$ret$1;
      $l$block: {
        // Inline function 'kotlin.collections.firstOrNull' call
        var _iterator__ex2g4s = tmp0.m();
        while (_iterator__ex2g4s.n()) {
          var element = _iterator__ex2g4s.o();
          var tmp_0 = element.f86_1;
          if (!(tmp_0 == null) ? isInterface(tmp_0, Cell) : false) {
            tmp$ret$1 = element;
            break $l$block;
          }
        }
        tmp$ret$1 = null;
      }
      var mapper = ensureNotNull(tmp$ret$1);
      if (!(mapper instanceof Mapper))
        THROW_CCE();
      tmp = this.gcr_1(this.hcr_1, mapper);
    } else {
      tmp = protoOf(CellTrait).n91.call(this, cell, spec);
    }
    return tmp;
  };
  function completion$lambda($init) {
    return function ($this$addTraitOnAttachGeneric, source, _unused_var__etf5q3, mappingContext) {
      // Inline function 'jetbrains.ocelot.projectional.cell.trait.propertyTrait' call
      var propSpec = Completion_getInstance().u9d_1;
      return new completion$2$$inlined$propertyTrait$1(propSpec, mappingContext, source, $init, $this$addTraitOnAttachGeneric);
    };
  }
  function cell$lambda_0(_this__u8e3s4) {
    return Unit_instance;
  }
  function setText$lambda($newValue) {
    return function ($this$setup, _unused_var__etf5q3, cell) {
      cell.o8w().d2x($newValue);
      return Unit_instance;
    };
  }
  function addTrait$lambda_0($traitFactory) {
    return function ($this$setup, source, cell) {
      cell.w92($traitFactory($this$setup, source, cell));
      return Unit_instance;
    };
  }
  function completion$4$$inlined$propertyTrait$1($propSpec, $init, $this_addTraitOnAttach, $source, $cell, $cellFinder) {
    this.icr_1 = $propSpec;
    this.jcr_1 = $init;
    this.kcr_1 = $this_addTraitOnAttach;
    this.lcr_1 = $source;
    this.mcr_1 = $cell;
    this.ncr_1 = $cellFinder;
    CellTrait.call(this);
  }
  protoOf(completion$4$$inlined$propertyTrait$1).n91 = function (cell, spec) {
    var tmp;
    if (spec === this.icr_1) {
      tmp = this.jcr_1(this.kcr_1, this.lcr_1, this.mcr_1, this.ncr_1);
    } else {
      tmp = protoOf(CellTrait).n91.call(this, cell, spec);
    }
    return tmp;
  };
  function completion$lambda_0($init) {
    return function ($this$addTraitOnAttach, source, cell, cellFinder) {
      // Inline function 'jetbrains.ocelot.projectional.cell.trait.propertyTrait' call
      var propSpec = Completion_getInstance().u9d_1;
      return new completion$4$$inlined$propertyTrait$1(propSpec, $init, $this$addTraitOnAttach, source, cell, cellFinder);
    };
  }
  function CellCreationResult(cell, id) {
    id = id === VOID ? null : id;
    this.bcq_1 = cell;
    this.ccq_1 = id;
  }
  protoOf(CellCreationResult).toString = function () {
    return 'CellCreationResult(cell=' + toString_1(this.bcq_1) + ', id=' + toString_0(this.ccq_1) + ')';
  };
  protoOf(CellCreationResult).hashCode = function () {
    var result = hashCode(this.bcq_1);
    result = imul(result, 31) + (this.ccq_1 == null ? 0 : this.ccq_1.hashCode()) | 0;
    return result;
  };
  protoOf(CellCreationResult).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CellCreationResult))
      return false;
    if (!equals(this.bcq_1, other.bcq_1))
      return false;
    if (!equals(this.ccq_1, other.ccq_1))
      return false;
    return true;
  };
  function CompositeMapperBuilder(sourceType, scope, builders, errorBuilder) {
    errorBuilder = errorBuilder === VOID ? invalidMapperBuilder(scope, sourceType) : errorBuilder;
    this.ocr_1 = sourceType;
    this.pcr_1 = scope;
    this.qcr_1 = builders;
    this.rcr_1 = errorBuilder;
  }
  protoOf(CompositeMapperBuilder).icb = function () {
    return this.ocr_1;
  };
  protoOf(CompositeMapperBuilder).hcb = function (configuration, source) {
    var _iterator__ex2g4s = this.qcr_1.m();
    $l$loop: while (_iterator__ex2g4s.n()) {
      var builder = _iterator__ex2g4s.o();
      var tmp0_elvis_lhs = buildSafe(builder, configuration, source);
      var tmp;
      if (tmp0_elvis_lhs == null) {
        continue $l$loop;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      return tmp;
    }
    return this.rcr_1.hcb(configuration, source);
  };
  function ContextKey(builder, id) {
    this.scr_1 = builder;
    this.tcr_1 = id;
  }
  protoOf(ContextKey).toString = function () {
    return 'ContextKey(builder=' + toString_1(this.scr_1) + ', id=' + this.tcr_1.toString() + ')';
  };
  protoOf(ContextKey).hashCode = function () {
    var result = hashCode(this.scr_1);
    result = imul(result, 31) + this.tcr_1.hashCode() | 0;
    return result;
  };
  protoOf(ContextKey).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ContextKey))
      return false;
    if (!equals(this.scr_1, other.scr_1))
      return false;
    if (!this.tcr_1.equals(other.tcr_1))
      return false;
    return true;
  };
  function EditorScope() {
    var tmp = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.ucr_1 = ArrayList_init_$Create$();
  }
  protoOf(EditorScope).vcr = function (builder) {
    this.ucr_1.j(builder);
  };
  protoOf(EditorScope).wcr = function () {
    var tmp = this.ucr_1;
    return isInterface(tmp, KtList) ? tmp : THROW_CCE();
  };
  protoOf(EditorScope).xcr = function (sourceType) {
    return this.ycr(new CompositeMapperBuilder(sourceType, this, this.wcr()));
  };
  protoOf(EditorScope).ycr = function (_this__u8e3s4) {
    return _this__u8e3s4;
  };
  function LazyMapperBuilder$_get_delegate_$ref_20un2r() {
    return function (p0) {
      return p0.acs();
    };
  }
  function LazyMapperBuilder(builderProvider) {
    this.zcr_1 = lazy(builderProvider);
  }
  protoOf(LazyMapperBuilder).acs = function () {
    var tmp0 = this.zcr_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('delegate', 1, tmp, LazyMapperBuilder$_get_delegate_$ref_20un2r(), null);
    return tmp0.a1();
  };
  protoOf(LazyMapperBuilder).icb = function () {
    return this.acs().icb();
  };
  protoOf(LazyMapperBuilder).hcb = function (configuration, source) {
    return this.acs().hcb(configuration, source);
  };
  function buildFactory(_this__u8e3s4, configuration) {
    return buildFactory$lambda(_this__u8e3s4, configuration);
  }
  function invalidMapperBuilder(_this__u8e3s4, type) {
    return new invalidMapperBuilder$1(_this__u8e3s4, type);
  }
  function buildSafe(_this__u8e3s4, configuration, source) {
    if (_this__u8e3s4.icb().sa(source)) {
      return _this__u8e3s4.hcb(configuration, (!(source == null) ? isInterface(source, DomainNode) : false) ? source : THROW_CCE());
    }
    return null;
  }
  function buildFactory$lambda($this_buildFactory, $configuration) {
    return function (it) {
      return $this_buildFactory.hcb($configuration, it);
    };
  }
  function invalidMapperBuilder$1($this_invalidMapperBuilder, $type) {
    this.bcs_1 = $this_invalidMapperBuilder;
    this.ccs_1 = $type;
  }
  protoOf(invalidMapperBuilder$1).icb = function () {
    return this.ccs_1;
  };
  protoOf(invalidMapperBuilder$1).hcb = function (configuration, source) {
    throw IllegalStateException_init_$Create$_0("Can't create a mapper for " + toString_1(source));
  };
  function indentChild(_this__u8e3s4, role, mapperBuilder, placeholderText, init) {
    placeholderText = placeholderText === VOID ? null : placeholderText;
    init = init === VOID ? null : init;
    var cellFactory = new NamedCellFactory('indentChild', indentChild$lambda);
    return child(_this__u8e3s4, role, cellFactory, mapperBuilder, placeholderText, init);
  }
  function indentChildren(_this__u8e3s4, role, mapperBuilder, placeholderText, childrenDecorator, init) {
    placeholderText = placeholderText === VOID ? null : placeholderText;
    childrenDecorator = childrenDecorator === VOID ? null : childrenDecorator;
    init = init === VOID ? null : init;
    var cellFactory = new NamedCellFactory('indentChildren', indentChildren$lambda);
    return children_0(_this__u8e3s4, role, cellFactory, placeholderText, mapperBuilder, childrenDecorator, init);
  }
  function child(_this__u8e3s4, role, cellFactory, mapperBuilder, placeholderText, init) {
    placeholderText = placeholderText === VOID ? null : placeholderText;
    init = init === VOID ? null : init;
    return projectionalChild(_this__u8e3s4, child$lambda(role), cellFactory, mapperBuilder, placeholderText, VOID, init);
  }
  function children_0(_this__u8e3s4, role, cellFactory, placeholderText, mapperBuilder, childrenDecorator, init) {
    childrenDecorator = childrenDecorator === VOID ? null : childrenDecorator;
    init = init === VOID ? null : init;
    return cell_0(_this__u8e3s4, cellFactory, children$lambda(childrenDecorator, role, mapperBuilder, placeholderText, init));
  }
  function projectionalChild(_this__u8e3s4, property, cellFactory, mapperBuilder, placeholderText, placeholderTraitFactory, init) {
    placeholderText = placeholderText === VOID ? null : placeholderText;
    var tmp;
    if (placeholderTraitFactory === VOID) {
      tmp = projectionalChild$lambda;
    } else {
      tmp = placeholderTraitFactory;
    }
    placeholderTraitFactory = tmp;
    init = init === VOID ? null : init;
    return cell_0(_this__u8e3s4, cellFactory, projectionalChild$lambda_0(property, mapperBuilder, placeholderText, init, placeholderTraitFactory));
  }
  function placeholder_1(text) {
    var textCell = CellFactory_instance.ta9('');
    var placeholder = placeholder_0(textCell, text == null ? '<empty>' : text);
    return CellFactory_instance.pa9([textCell, placeholder]);
  }
  function indentChild$lambda() {
    return new IndentCell();
  }
  function indentChildren$lambda() {
    return new IndentCell();
  }
  function child$lambda($role) {
    return function (source, _unused_var__etf5q3) {
      return $role(source);
    };
  }
  function children$lambda$lambda$lambda($placeholderText) {
    return function () {
      return placeholder_1($placeholderText);
    };
  }
  function children$lambda$lambda$lambda_0(it) {
    return false;
  }
  function children$lambda$lambda($childrenDecorator, $role, $mapperBuilder, $placeholderText, $init) {
    return function ($this$setupSynchronizers, source, cell) {
      var cellChildren = cell.q92();
      var tmp;
      if ($childrenDecorator == null) {
        tmp = cellChildren;
      } else {
        tmp = $childrenDecorator(cellChildren);
      }
      var targetList = tmp;
      var sourceList = $role(source);
      var mapperFactory = buildFactory($mapperBuilder, $this$setupSynchronizers.gcq());
      var tmp_0;
      if ($this$setupSynchronizers.gcq().scq()) {
        var cellList = new ObservableArrayList();
        $this$setupSynchronizers.l8b(Synchronizers_instance.c8b(sourceList.m5y(), cellList, mapperFactory));
        var tmp_1 = Transformers_instance;
        var placeholderIfEmpty = tmp_1.m35(children$lambda$lambda$lambda($placeholderText));
        var transformation = placeholderIfEmpty.u32(cellList, targetList);
        $this$setupSynchronizers.l8b(Synchronizers_instance.g8b([transformation]));
        tmp_0 = Unit_instance;
      } else {
        var tmp_2 = new ProjectionalListSynchronizerSettings();
        var settings = tmp_2.paq(children$lambda$lambda$lambda_0);
        if (!($placeholderText == null)) {
          settings.saq($placeholderText);
        }
        var synchronizer = ProjectionalSynchronizers_getInstance().hau(sourceList.m5y(), cell, targetList, mapperFactory, settings);
        if (!($init == null)) {
          $init(new SimpleProjectionalRoleSynchronizerBuilder(synchronizer, $this$setupSynchronizers.gcq()));
        }
        $this$setupSynchronizers.l8b(synchronizer);
        tmp_0 = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function children$lambda($childrenDecorator, $role, $mapperBuilder, $placeholderText, $init) {
    return function ($this$cell) {
      $this$cell.ycp(children$lambda$lambda($childrenDecorator, $role, $mapperBuilder, $placeholderText, $init));
      return Unit_instance;
    };
  }
  function projectionalChild$lambda(_this__u8e3s4, _unused_var__etf5q3, trait) {
    return trait;
  }
  function projectionalChild$4$2$target$1($cell, $placeholderText) {
    this.dcs_1 = $cell;
    this.ecs_1 = $placeholderText;
  }
  protoOf(projectionalChild$4$2$target$1).u9u = function (newValue) {
    var children = this.dcs_1.q92();
    children.k2();
    children.j(newValue == null ? placeholder_1(this.ecs_1) : newValue);
  };
  protoOf(projectionalChild$4$2$target$1).d2x = function (newValue) {
    return this.u9u((newValue == null ? true : isInterface(newValue, Cell)) ? newValue : THROW_CCE());
  };
  function projectionalChild$lambda$lambda$lambda($placeholderTraitFactory, $this_setupSynchronizers, $source) {
    return function (trait) {
      return $placeholderTraitFactory($this_setupSynchronizers.gcq(), $source, trait);
    };
  }
  function projectionalChild$lambda$lambda($property, $mapperBuilder, $placeholderText, $init, $placeholderTraitFactory) {
    return function ($this$setupSynchronizers, source, cell) {
      var sourceProp = $property(source, cell);
      var mapperFactory = buildFactory($mapperBuilder, $this$setupSynchronizers.gcq());
      var tmp;
      if ($this$setupSynchronizers.gcq().scq()) {
        var target = new projectionalChild$4$2$target$1(cell, $placeholderText);
        target.u9u(null);
        $this$setupSynchronizers.l8b(Synchronizers_instance.e8b(sourceProp.m5y(), target, mapperFactory));
        tmp = Unit_instance;
      } else {
        var tmp_0 = new ProjectionalPropertySynchronizerSettings();
        var tmp_1 = tmp_0.qaq(projectionalChild$lambda$lambda$lambda($placeholderTraitFactory, $this$setupSynchronizers, source));
        var tmp0_elvis_lhs = $placeholderText;
        var settings = tmp_1.saq(tmp0_elvis_lhs == null ? '<empty>' : tmp0_elvis_lhs);
        var synchronizer = ProjectionalSynchronizers_getInstance().iau(sourceProp.m5y(), cell, mapperFactory, settings);
        if (!($init == null)) {
          $init(new SimpleProjectionalRoleSynchronizerBuilder(synchronizer, $this$setupSynchronizers.gcq()));
        }
        $this$setupSynchronizers.l8b(synchronizer);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function projectionalChild$lambda_0($property, $mapperBuilder, $placeholderText, $init, $placeholderTraitFactory) {
    return function ($this$cell) {
      $this$cell.ycp(projectionalChild$lambda$lambda($property, $mapperBuilder, $placeholderText, $init, $placeholderTraitFactory));
      return Unit_instance;
    };
  }
  function NamedCellFactory(name, factory, id) {
    id = id === VOID ? null : id;
    this.fcs_1 = name;
    this.gcs_1 = factory;
    this.hcs_1 = id;
  }
  protoOf(NamedCellFactory).toString = function () {
    return 'NamedCellFactory(name=' + this.fcs_1 + ', factory=' + toString_1(this.gcs_1) + ', id=' + toString_0(this.hcs_1) + ')';
  };
  protoOf(NamedCellFactory).hashCode = function () {
    var result = getStringHashCode(this.fcs_1);
    result = imul(result, 31) + hashCode(this.gcs_1) | 0;
    result = imul(result, 31) + (this.hcs_1 == null ? 0 : this.hcs_1.hashCode()) | 0;
    return result;
  };
  protoOf(NamedCellFactory).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof NamedCellFactory))
      return false;
    if (!(this.fcs_1 === other.fcs_1))
      return false;
    if (!equals(this.gcs_1, other.gcs_1))
      return false;
    if (!equals(this.hcs_1, other.hcs_1))
      return false;
    return true;
  };
  function defaultItem(_this__u8e3s4, fact) {
    _this__u8e3s4.ics(defaultItem$lambda(fact));
  }
  function defaultItem$lambda$lambda($fact, $this_default) {
    return function () {
      return $fact($this_default);
    };
  }
  function defaultItem$lambda($fact) {
    return function ($this$default) {
      var tmp = Companion_instance_200;
      return tmp.vap(defaultItem$lambda$lambda($fact, $this$default));
    };
  }
  function ReferenceCellBuilder() {
  }
  function SimpleCellBuilder(cellFactory, scope) {
    BaseCellBuilder.call(this);
    this.qcs_1 = cellFactory;
    this.rcs_1 = scope;
  }
  protoOf(SimpleCellBuilder).fcq = function () {
    return this.rcs_1;
  };
  protoOf(SimpleCellBuilder).z3n = function () {
    return this.qcs_1.hcs_1;
  };
  protoOf(SimpleCellBuilder).zcp = function (source, context) {
    var cell = this.qcs_1.gcs_1();
    return new CellCreationResult(cell, this.z3n());
  };
  protoOf(SimpleCellBuilder).toString = function () {
    return 'SimpleCellBuilder(cellFactory=' + this.qcs_1.toString() + ', scope=' + toString_1(this.rcs_1) + ')';
  };
  protoOf(SimpleCellBuilder).hashCode = function () {
    var result = this.qcs_1.hashCode();
    result = imul(result, 31) + hashCode(this.rcs_1) | 0;
    return result;
  };
  protoOf(SimpleCellBuilder).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SimpleCellBuilder))
      return false;
    if (!this.qcs_1.equals(other.qcs_1))
      return false;
    if (!equals(this.rcs_1, other.rcs_1))
      return false;
    return true;
  };
  function RootCellBuilderImpl($outer) {
    this.scs_1 = $outer;
  }
  protoOf(RootCellBuilderImpl).fcq = function () {
    return this.scs_1.tcs_1;
  };
  protoOf(RootCellBuilderImpl).wcs = function (init) {
    throw UnsupportedOperationException_init_$Create$();
  };
  protoOf(RootCellBuilderImpl).xcp = function (init) {
    return this.wcs(init);
  };
  protoOf(RootCellBuilderImpl).xcs = function (init) {
    throw UnsupportedOperationException_init_$Create$();
  };
  protoOf(RootCellBuilderImpl).ycp = function (init) {
    return this.xcs(init);
  };
  protoOf(RootCellBuilderImpl).ycs = function (source, cellMap, context) {
    throw UnsupportedOperationException_init_$Create$();
  };
  protoOf(RootCellBuilderImpl).acq = function (source, cellMap, context) {
    return this.ycs((!(source == null) ? isInterface(source, DomainNode) : false) ? source : THROW_CCE(), cellMap, context);
  };
  protoOf(RootCellBuilderImpl).wcp = function (child) {
    // Inline function 'kotlin.check' call
    if (!(this.scs_1.vcs_1 == null)) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    this.scs_1.vcs_1 = child;
  };
  function SimpleMapperBuilder$build$builderContext$1($configuration, $synchronizers, $builderMap) {
    this.zcs_1 = $configuration;
    this.act_1 = $synchronizers;
    this.bct_1 = $builderMap;
  }
  protoOf(SimpleMapperBuilder$build$builderContext$1).gcq = function () {
    return this.zcs_1;
  };
  protoOf(SimpleMapperBuilder$build$builderContext$1).l8b = function (sync) {
    // Inline function 'kotlin.collections.plusAssign' call
    this.act_1.j(sync);
  };
  protoOf(SimpleMapperBuilder$build$builderContext$1).hcq = function (key) {
    var cell = this.bct_1.q2(key);
    $l$block: {
      // Inline function 'kotlin.checkNotNull' call
      if (cell == null) {
        var message = 'cell not found for key: ' + key.toString();
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      } else {
        break $l$block;
      }
    }
    return isInterface(cell, Cell) ? cell : THROW_CCE();
  };
  function SimpleMapperBuilder$build$1($source, $rootCell, $synchronizers) {
    this.jct_1 = $synchronizers;
    Mapper.call(this, $source, $rootCell);
  }
  protoOf(SimpleMapperBuilder$build$1).a88 = function (conf) {
    var _iterator__ex2g4s = this.jct_1.m();
    while (_iterator__ex2g4s.n()) {
      var sync = _iterator__ex2g4s.o();
      conf.h5v(sync);
    }
  };
  function SimpleMapperBuilder(scope, sourceType) {
    this.tcs_1 = scope;
    this.ucs_1 = sourceType;
    this.vcs_1 = null;
  }
  protoOf(SimpleMapperBuilder).icb = function () {
    return this.ucs_1;
  };
  protoOf(SimpleMapperBuilder).hcb = function (configuration, source) {
    var rootCellBuilder = this.vcs_1;
    // Inline function 'kotlin.checkNotNull' call
    $l$block: {
      // Inline function 'kotlin.checkNotNull' call
      if (rootCellBuilder == null) {
        var message = 'Required value was null.';
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      } else {
        break $l$block;
      }
    }
    var synchronizers = ArrayList_init_$Create$();
    var builderMap = HashMap_init_$Create$();
    var builderContext = new SimpleMapperBuilder$build$builderContext$1(configuration, synchronizers, builderMap);
    var rootResult = rootCellBuilder.acq(source, builderMap, builderContext);
    var rootCell = rootResult.dcq_1;
    rootResult.ecq_1();
    return new SimpleMapperBuilder$build$1(source, rootCell, synchronizers);
  };
  function SimpleProjectionalRoleSynchronizerBuilder(synchronizer, configuration) {
    this.kct_1 = synchronizer;
    this.lct_1 = configuration;
  }
  protoOf(SimpleProjectionalRoleSynchronizerBuilder).mct = function (factory) {
    return this.kct_1.jao(factory(this.lct_1));
  };
  protoOf(SimpleProjectionalRoleSynchronizerBuilder).ics = function (factory) {
    return this.kct_1.san(factory(this.lct_1));
  };
  protoOf(SimpleProjectionalRoleSynchronizerBuilder).nct = function (kind, clonerSupport) {
    return this.kct_1.qam().law(kind, clonerSupport(this.lct_1));
  };
  function textSyncTwoWay(_this__u8e3s4, prop) {
    // Inline function 'jetbrains.ocelot.langDef.editor.textCellSyncTwoWay' call
    _this__u8e3s4.xcp(textSyncTwoWay$lambda(prop));
    return Unit_instance;
  }
  function decimalSyncTwoWay(_this__u8e3s4, prop) {
    // Inline function 'jetbrains.ocelot.langDef.editor.textCellSyncTwoWay' call
    _this__u8e3s4.xcp(decimalSyncTwoWay$lambda(prop));
    return Unit_instance;
  }
  function intSyncTwoWay(_this__u8e3s4, prop) {
    // Inline function 'jetbrains.ocelot.langDef.editor.textCellSyncTwoWay' call
    _this__u8e3s4.xcp(intSyncTwoWay$lambda(prop, ValueEditors_instance));
    return Unit_instance;
  }
  function textSyncTwoWay$lambda($prop) {
    return function ($this$setup, source, textCell) {
      var sourceProp = $prop(source);
      var targetProp = textCell.o8w();
      $this$setup.l8b(syncTwoWay(sourceProp.m5y(), targetProp));
      return Unit_instance;
    };
  }
  function decimalSyncTwoWay$lambda($prop) {
    return function ($this$setup, source, textCell) {
      var sourceProp = $prop(source);
      var targetProp = decimalProperty_0(textCell);
      $this$setup.l8b(syncTwoWay(sourceProp.m5y(), targetProp));
      return Unit_instance;
    };
  }
  function intSyncTwoWay$lambda($prop, $tmp4_textCellSyncTwoWay_this) {
    return function ($this$setup, source, textCell) {
      var sourceProp = $prop(source);
      var targetProp = $tmp4_textCellSyncTwoWay_this.wag(textCell);
      $this$setup.l8b(syncTwoWay(sourceProp.m5y(), targetProp));
      return Unit_instance;
    };
  }
  function NodeContentKind() {
  }
  var NodeContentKind_instance;
  function NodeContentKind_getInstance() {
    return NodeContentKind_instance;
  }
  function EditorNode(node) {
    this.oct_1 = node;
  }
  protoOf(EditorNode).toString = function () {
    return 'EditorNode(node=' + toString_1(this.oct_1) + ')';
  };
  protoOf(EditorNode).hashCode = function () {
    return hashCode(this.oct_1);
  };
  protoOf(EditorNode).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof EditorNode))
      return false;
    if (!equals(this.oct_1, other.oct_1))
      return false;
    return true;
  };
  function Companion_244() {
    Companion_instance_244 = this;
    this.pct_1 = new PresentationMode(SourceMode_EDITABLE_getInstance(), true, true, true, true);
    this.qct_1 = this.pct_1.zct(SourceMode_IMMUTABLE_getInstance());
    this.rct_1 = this.pct_1.zct(SourceMode_STATIC_getInstance());
    this.sct_1 = new PresentationMode(SourceMode_STATIC_getInstance(), true, false, false, false);
    this.tct_1 = this.sct_1.zct(VOID, false);
  }
  var Companion_instance_244;
  function Companion_getInstance_244() {
    if (Companion_instance_244 == null)
      new Companion_244();
    return Companion_instance_244;
  }
  function PresentationMode(source, interactive, caretNavigation, followReferences, showErrors) {
    Companion_getInstance_244();
    this.uct_1 = source;
    this.vct_1 = interactive;
    this.wct_1 = caretNavigation;
    this.xct_1 = followReferences;
    this.yct_1 = showErrors;
    // Inline function 'kotlin.require' call
    if (!(this.vct_1 || !this.wct_1)) {
      var message = 'caretNavigation requires an interactive editor';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    // Inline function 'kotlin.require' call
    if (!(this.vct_1 || !this.xct_1)) {
      var message_0 = 'followReferences requires an interactive editor';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message_0));
    }
    // Inline function 'kotlin.require' call
    if (!(!this.uct_1.equals(SourceMode_EDITABLE_getInstance()) || this.vct_1)) {
      var message_1 = 'an editable source requires an interactive editor';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message_1));
    }
    // Inline function 'kotlin.require' call
    if (!(!this.uct_1.equals(SourceMode_EDITABLE_getInstance()) || this.wct_1)) {
      var message_2 = 'an editable source requires caret navigation';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message_2));
    }
  }
  protoOf(PresentationMode).acu = function () {
    return !this.uct_1.equals(SourceMode_EDITABLE_getInstance());
  };
  protoOf(PresentationMode).bcu = function (source, interactive, caretNavigation, followReferences, showErrors) {
    return new PresentationMode(source, interactive, caretNavigation, followReferences, showErrors);
  };
  protoOf(PresentationMode).zct = function (source, interactive, caretNavigation, followReferences, showErrors, $super) {
    source = source === VOID ? this.uct_1 : source;
    interactive = interactive === VOID ? this.vct_1 : interactive;
    caretNavigation = caretNavigation === VOID ? this.wct_1 : caretNavigation;
    followReferences = followReferences === VOID ? this.xct_1 : followReferences;
    showErrors = showErrors === VOID ? this.yct_1 : showErrors;
    return $super === VOID ? this.bcu(source, interactive, caretNavigation, followReferences, showErrors) : $super.bcu.call(this, source, interactive, caretNavigation, followReferences, showErrors);
  };
  protoOf(PresentationMode).toString = function () {
    return 'PresentationMode(source=' + this.uct_1.toString() + ', interactive=' + this.vct_1 + ', caretNavigation=' + this.wct_1 + ', followReferences=' + this.xct_1 + ', showErrors=' + this.yct_1 + ')';
  };
  protoOf(PresentationMode).hashCode = function () {
    var result = this.uct_1.hashCode();
    result = imul(result, 31) + getBooleanHashCode(this.vct_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.wct_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.xct_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.yct_1) | 0;
    return result;
  };
  protoOf(PresentationMode).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PresentationMode))
      return false;
    if (!this.uct_1.equals(other.uct_1))
      return false;
    if (!(this.vct_1 === other.vct_1))
      return false;
    if (!(this.wct_1 === other.wct_1))
      return false;
    if (!(this.xct_1 === other.xct_1))
      return false;
    if (!(this.yct_1 === other.yct_1))
      return false;
    return true;
  };
  var SourceMode_EDITABLE_instance;
  var SourceMode_IMMUTABLE_instance;
  var SourceMode_STATIC_instance;
  var SourceMode_entriesInitialized;
  function SourceMode_initEntries() {
    if (SourceMode_entriesInitialized)
      return Unit_instance;
    SourceMode_entriesInitialized = true;
    SourceMode_EDITABLE_instance = new SourceMode('EDITABLE', 0);
    SourceMode_IMMUTABLE_instance = new SourceMode('IMMUTABLE', 1);
    SourceMode_STATIC_instance = new SourceMode('STATIC', 2);
  }
  function SourceMode(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function SourceMode_EDITABLE_getInstance() {
    SourceMode_initEntries();
    return SourceMode_EDITABLE_instance;
  }
  function SourceMode_IMMUTABLE_getInstance() {
    SourceMode_initEntries();
    return SourceMode_IMMUTABLE_instance;
  }
  function SourceMode_STATIC_getInstance() {
    SourceMode_initEntries();
    return SourceMode_STATIC_instance;
  }
  function get_spaceDoesntCloseCompletion() {
    // Inline function 'jetbrains.ocelot.projectional.cell.trait.propertyTrait' call
    var propSpec = Completion_getInstance().d9e_1;
    return new spaceDoesntCloseCompletion$$inlined$propertyTrait$1(propSpec);
  }
  function spaceDoesntCloseCompletion$$inlined$propertyTrait$1($propSpec) {
    this.ccu_1 = $propSpec;
    CellTrait.call(this);
  }
  protoOf(spaceDoesntCloseCompletion$$inlined$propertyTrait$1).n91 = function (cell, spec) {
    var tmp;
    if (spec === this.ccu_1) {
      tmp = false;
    } else {
      tmp = protoOf(CellTrait).n91.call(this, cell, spec);
    }
    return tmp;
  };
  function CompoundSideTransformTrait$Side$LEFT() {
    Side_2.call(this, 'LEFT', 0, CompoundSideTransformTrait_getInstance().dcu_1);
    Side_LEFT_instance_1 = this;
  }
  protoOf(CompoundSideTransformTrait$Side$LEFT).rac = function (cell) {
    return cell.s35();
  };
  var Side_LEFT_instance_1;
  function CompoundSideTransformTrait$Side$RIGHT() {
    Side_2.call(this, 'RIGHT', 1, CompoundSideTransformTrait_getInstance().ecu_1);
    Side_RIGHT_instance_1 = this;
  }
  protoOf(CompoundSideTransformTrait$Side$RIGHT).rac = function (cell) {
    return cell.p35();
  };
  var Side_RIGHT_instance_1;
  function CompoundSideTransformTrait$Side$siblingsOf$lambda(this$0) {
    return function (it) {
      return this$0.rac(it);
    };
  }
  var Side_entriesInitialized_1;
  function Side_initEntries_1() {
    if (Side_entriesInitialized_1)
      return Unit_instance;
    Side_entriesInitialized_1 = true;
    Side_LEFT_instance_1 = new CompoundSideTransformTrait$Side$LEFT();
    Side_RIGHT_instance_1 = new CompoundSideTransformTrait$Side$RIGHT();
  }
  function collectCompletion($this, cell, side) {
    var result = get_EMPTY_COMPLETION_SUPPLIER();
    var _iterator__ex2g4s = ancestorsFrom(cell).m();
    $l$loop: while (_iterator__ex2g4s.n()) {
      var ancestor = _iterator__ex2g4s.o();
      var ownCompletion = ancestor.c93(side.kcu_1);
      if (!(ownCompletion == null))
        result = plus_15(result, ownCompletion);
      var tmp0 = side.xac(ancestor);
      var tmp$ret$1;
      $l$block: {
        // Inline function 'kotlin.sequences.any' call
        var _iterator__ex2g4s_0 = tmp0.m();
        while (_iterator__ex2g4s_0.n()) {
          var element = _iterator__ex2g4s_0.o();
          if (isSignificant_0(CompoundSideTransformTrait_getInstance(), element)) {
            tmp$ret$1 = true;
            break $l$block;
          }
        }
        tmp$ret$1 = false;
      }
      if (tmp$ret$1) {
        break $l$loop;
      }
    }
    return result;
  }
  function isSignificant_0($this, _this__u8e3s4) {
    if (!isVisible_1(_this__u8e3s4))
      return false;
    if (_this__u8e3s4 instanceof TextCell)
      return true;
    var tmp0 = _this__u8e3s4.o35();
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.any' call
      var tmp;
      if (isInterface(tmp0, Collection)) {
        tmp = tmp0.s();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = false;
        break $l$block_0;
      }
      var _iterator__ex2g4s = tmp0.m();
      while (_iterator__ex2g4s.n()) {
        var element = _iterator__ex2g4s.o();
        if (isSignificant_0(CompoundSideTransformTrait_getInstance(), element)) {
          tmp$ret$0 = true;
          break $l$block_0;
        }
      }
      tmp$ret$0 = false;
    }
    return tmp$ret$0;
  }
  function Side_2(name, ordinal, transformPropertySpec) {
    Enum.call(this, name, ordinal);
    this.kcu_1 = transformPropertySpec;
  }
  protoOf(Side_2).xac = function (cell) {
    return generateSequenceFromNext(cell, VOID, CompoundSideTransformTrait$Side$siblingsOf$lambda(this));
  };
  function Side_LEFT_getInstance_1() {
    Side_initEntries_1();
    return Side_LEFT_instance_1;
  }
  function Side_RIGHT_getInstance_1() {
    Side_initEntries_1();
    return Side_RIGHT_instance_1;
  }
  function CompoundSideTransformTrait() {
    CompoundSideTransformTrait_instance = this;
    CellTrait.call(this);
    this.dcu_1 = CellTraitPropertySpec_init_$Create$('ownLeftTransform', null);
    this.ecu_1 = CellTraitPropertySpec_init_$Create$('ownRightTransform', null);
  }
  protoOf(CompoundSideTransformTrait).n91 = function (cell, spec) {
    return equals(spec, Completion_getInstance().w9d_1) ? collectCompletion(this, cell, Side_RIGHT_getInstance_1()) : equals(spec, Completion_getInstance().v9d_1) ? collectCompletion(this, cell, Side_LEFT_getInstance_1()) : protoOf(CellTrait).n91.call(this, cell, spec);
  };
  var CompoundSideTransformTrait_instance;
  function CompoundSideTransformTrait_getInstance() {
    if (CompoundSideTransformTrait_instance == null)
      new CompoundSideTransformTrait();
    return CompoundSideTransformTrait_instance;
  }
  function LineMapper$lambda(this$0) {
    return function (it) {
      var tmp = this$0.f86_1.bp();
      var multilineCell = tmp instanceof MultilineTextCell ? tmp : THROW_CCE();
      multilineCell.ycu(this$0.f86_1);
      return Unit_instance;
    };
  }
  function LineMapper$registerSynchronizers$$inlined$writableProperty$1($tmp0_writableProperty_this) {
    this.zcu_1 = $tmp0_writableProperty_this;
  }
  protoOf(LineMapper$registerSynchronizers$$inlined$writableProperty$1).x9j = function (newValue) {
    this.zcu_1.d2x(newValue);
    return Unit_instance;
  };
  protoOf(LineMapper$registerSynchronizers$$inlined$writableProperty$1).d2x = function (newValue) {
    return this.x9j((newValue == null ? true : !(newValue == null)) ? newValue : THROW_CCE());
  };
  function LineMapper(textSpecification, textStyle, source) {
    Mapper.call(this, source, TextCell_init_$Create$());
    this.hcv_1 = textSpecification.jcv_1.n6m_1(source).m5y();
    this.f86_1.p92().d2x(true);
    textStyle(this.f86_1);
    var tmp = this.f86_1.t96();
    tmp.z2r(LineMapper$lambda(this));
  }
  protoOf(LineMapper).a88 = function (conf) {
    protoOf(Mapper).a88.call(this, conf);
    var tmp0_writableProperty_this = this.f86_1.o8w();
    // Inline function 'jetbrains.ocelot.base.observable.property.writableProperty' call
    var writableProp = new LineMapper$registerSynchronizers$$inlined$writableProperty$1(tmp0_writableProperty_this);
    conf.h5v(syncOneWay(this.hcv_1, writableProp));
  };
  function _get_isNonEmpty__e86o73($this) {
    return $this.lcv_1.ocv($this.kcv_1) > 0;
  }
  function Companion_245() {
  }
  protoOf(Companion_245).pcv = function (a, b) {
    return a.ocv(b) < 0 ? new MultilineSelection(a, b) : new MultilineSelection(b, a);
  };
  var Companion_instance_245;
  function Companion_getInstance_245() {
    return Companion_instance_245;
  }
  function MultilineSelection(start, end) {
    this.kcv_1 = start;
    this.lcv_1 = end;
  }
  protoOf(MultilineSelection).qcv = function () {
    return numberRangeToNumber(this.kcv_1.mcv_1, this.lcv_1.mcv_1);
  };
  protoOf(MultilineSelection).rcv = function () {
    return until(this.kcv_1.mcv_1 + 1 | 0, this.lcv_1.mcv_1);
  };
  protoOf(MultilineSelection).scv = function () {
    return this.kcv_1.mcv_1 === this.lcv_1.mcv_1;
  };
  protoOf(MultilineSelection).tcv = function () {
    return _get_isNonEmpty__e86o73(this) ? this : null;
  };
  protoOf(MultilineSelection).ucv = function (model, textNode) {
    if (this.scv()) {
      model.zcv(this.kcv_1.mcv_1).q3n(this.kcv_1.ncv_1, this.lcv_1.ncv_1 - this.kcv_1.ncv_1 | 0);
    } else {
      var firstLine = model.zcv(this.kcv_1.mcv_1);
      firstLine.q3n(this.kcv_1.ncv_1, firstLine.w2w().length - this.kcv_1.ncv_1 | 0);
      var lastLineNode = model.acw(this.lcv_1.mcv_1);
      var lastLine = model.zcv(this.lcv_1.mcv_1);
      lastLine.q3n(0, this.lcv_1.ncv_1);
      model.bcw(this.rcv());
      model.ycv_1.c6o(textNode, lastLineNode);
    }
    return this.kcv_1;
  };
  protoOf(MultilineSelection).ccw = function (model) {
    var tmp;
    if (this.scv()) {
      var string = substring(model.zcv(this.kcv_1.mcv_1).uv(), this.kcv_1.ncv_1, this.lcv_1.ncv_1);
      tmp = TextContentHelper_getInstance().t8m(string);
    } else {
      var firstString = substring_0(model.zcv(this.kcv_1.mcv_1).uv(), this.kcv_1.ncv_1);
      var lastString = substring(model.zcv(this.lcv_1.mcv_1).uv(), 0, this.lcv_1.ncv_1);
      // Inline function 'kotlin.collections.map' call
      var this_0 = this.rcv();
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
      var inductionVariable = this_0.c1_1;
      var last = this_0.d1_1;
      if (inductionVariable <= last)
        do {
          var item = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var it = item;
          var tmp$ret$0 = model.zcv(it).uv();
          destination.j(tmp$ret$0);
        }
         while (!(item === last));
      var innerStrings = destination;
      var allStrings = plus_5(plus_5(listOf(firstString), innerStrings), listOf(lastString));
      tmp = TextContentHelper_getInstance().u8m(allStrings);
    }
    return tmp;
  };
  protoOf(MultilineSelection).toString = function () {
    return 'MultilineSelection(start=' + this.kcv_1.toString() + ', end=' + this.lcv_1.toString() + ')';
  };
  protoOf(MultilineSelection).hashCode = function () {
    var result = this.kcv_1.hashCode();
    result = imul(result, 31) + this.lcv_1.hashCode() | 0;
    return result;
  };
  protoOf(MultilineSelection).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof MultilineSelection))
      return false;
    if (!this.kcv_1.equals(other.kcv_1))
      return false;
    if (!this.lcv_1.equals(other.lcv_1))
      return false;
    return true;
  };
  function onSelectionChanged($this, event) {
    var tmp0_safe_receiver = event.s2y_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.collections.forEach' call
      var progression = tmp0_safe_receiver.qcv();
      var inductionVariable = progression.c1_1;
      var last = progression.d1_1;
      if (inductionVariable <= last)
        do {
          var element = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var index = element;
          textCell($this, index).h97().f2x(false);
        }
         while (!(element === last));
    }
    var tmp1_safe_receiver = event.t2y_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.collections.forEach' call
      var progression_0 = tmp1_safe_receiver.qcv();
      var inductionVariable_0 = progression_0.c1_1;
      var last_0 = progression_0.d1_1;
      if (inductionVariable_0 <= last_0)
        do {
          var element_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var index_0 = element_0;
          textCell($this, index_0).h97().f2x(true);
        }
         while (!(element_0 === last_0));
      // Inline function 'kotlin.collections.forEach' call
      var progression_1 = tmp1_safe_receiver.rcv();
      var inductionVariable_1 = progression_1.c1_1;
      var last_1 = progression_1.d1_1;
      if (inductionVariable_1 <= last_1)
        do {
          var element_1 = inductionVariable_1;
          inductionVariable_1 = inductionVariable_1 + 1 | 0;
          var index_1 = element_1;
          selectAllLine($this, index_1);
        }
         while (!(element_1 === last_1));
      if (tmp1_safe_receiver.kcv_1.mcv_1 < tmp1_safe_receiver.lcv_1.mcv_1) {
        selectLineFrom($this, tmp1_safe_receiver.kcv_1.mcv_1, tmp1_safe_receiver.kcv_1.ncv_1);
        selectLineUntil($this, tmp1_safe_receiver.lcv_1.mcv_1, tmp1_safe_receiver.lcv_1.ncv_1);
      } else {
        selectLine($this, tmp1_safe_receiver.kcv_1.mcv_1, tmp1_safe_receiver.kcv_1.ncv_1, tmp1_safe_receiver.lcv_1.ncv_1);
      }
    }
  }
  function selectAllLine($this, line) {
    // Inline function 'kotlin.with' call
    var $this$with = textCell($this, line);
    $this$with.i97().f2x(0);
    $this$with.j97().f2x($this$with.w96());
    return Unit_instance;
  }
  function selectLineFrom($this, line, position) {
    // Inline function 'kotlin.with' call
    var $this$with = textCell($this, line);
    $this$with.i97().f2x(position);
    $this$with.j97().f2x($this$with.w96());
    return Unit_instance;
  }
  function selectLineUntil($this, line, position) {
    // Inline function 'kotlin.with' call
    var $this$with = textCell($this, line);
    $this$with.i97().f2x(0);
    $this$with.j97().f2x(position);
    return Unit_instance;
  }
  function selectLine($this, line, from, to) {
    // Inline function 'kotlin.with' call
    var $this$with = textCell($this, line);
    $this$with.i97().f2x(from);
    $this$with.j97().f2x(to);
    return Unit_instance;
  }
  function textCell($this, index) {
    var tmp = _get_childrenCells__2b6phd($this).r(index);
    return tmp instanceof TextCell ? tmp : THROW_CCE();
  }
  function runCaretOperation($this, updateCaretRunnable) {
    if (!$this.wcu_1) {
      $this.wcu_1 = true;
      try {
        updateCaretRunnable();
      }finally {
        $this.wcu_1 = false;
      }
    }
  }
  function renderCaret($this, position) {
    if (!(position == null)) {
      var tmp = $this.o35().r(position.mcv_1);
      var line = tmp instanceof TextCell ? tmp : THROW_CCE();
      line.t96().d2x(position.ncv_1);
      line.c97().d2x(true);
      hideCaretExcept($this, line);
    }
  }
  function hideCaretExcept($this, except) {
    var _iterator__ex2g4s = $this.o35().m();
    while (_iterator__ex2g4s.n()) {
      var line = _iterator__ex2g4s.o();
      if (!(line === except)) {
        (line instanceof TextCell ? line : THROW_CCE()).c97().d2x(false);
        if (line.y92().uv()) {
          ensureNotNull(line.s8x()).z92().d2x(null);
        }
      }
    }
  }
  function renderFocus($this, position) {
    if (!(position == null)) {
      var line = _get_childrenCells__2b6phd($this).r(position.mcv_1);
      line.s8n();
    }
  }
  function _get_childrenCells__2b6phd($this) {
    var tmp0 = $this.xcu_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('childrenCells', 1, tmp, MultilineTextCell$_get_childrenCells_$ref_ty5fl2(), null);
    return tmp0.a1();
  }
  function lineNumber($this, y) {
    var tmp0 = $this.o35();
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.indexOfFirst' call
      var index = 0;
      var _iterator__ex2g4s = tmp0.m();
      while (_iterator__ex2g4s.n()) {
        var item = _iterator__ex2g4s.o();
        if (get_bounds(item).u8c().i37(y)) {
          tmp$ret$1 = index;
          break $l$block;
        }
        index = index + 1 | 0;
      }
      tmp$ret$1 = -1;
    }
    return tmp$ret$1;
  }
  function Companion_246() {
    Companion_instance_246 = this;
    this.dcw_1 = CellPropertySpec_init_$Create$('documentPosition', null);
    this.ecw_1 = CellPropertySpec_init_$Create$('multilineSelection', null);
    this.fcw_1 = CellPropertySpec_init_$Create$('multilineSelectionOrigin', null);
  }
  var Companion_instance_246;
  function Companion_getInstance_246() {
    if (Companion_instance_246 == null)
      new Companion_246();
    return Companion_instance_246;
  }
  function MultilineTextCell$lambda$lambda($event, this$0) {
    return function () {
      var newValue = $event.t2y_1;
      renderCaret(this$0, newValue);
      renderFocus(this$0, newValue);
      return Unit_instance;
    };
  }
  function MultilineTextCell$lambda(this$0) {
    return function (event) {
      runCaretOperation(this$0, MultilineTextCell$lambda$lambda(event, this$0));
      return Unit_instance;
    };
  }
  function MultilineTextCell$onSelectionChanged$ref(p0) {
    var l = function (_this__u8e3s4) {
      var tmp0 = p0;
      onSelectionChanged(tmp0, _this__u8e3s4);
      return Unit_instance;
    };
    l.callableName = 'onSelectionChanged';
    return l;
  }
  function MultilineTextCell$synchronizePosition$lambda(this$0, $lineCell) {
    return function () {
      var line = this$0.o35().w($lineCell);
      var offset = $lineCell.t96().uv();
      var pos = new Position_0(line, offset);
      this$0.i90(Companion_getInstance_246().dcw_1, pos);
      renderCaret(this$0, pos);
      return Unit_instance;
    };
  }
  function MultilineTextCell$hideCaret$lambda(this$0) {
    return function () {
      hideCaretExcept(this$0, null);
      return Unit_instance;
    };
  }
  function MultilineTextCell$childrenCells$delegate$lambda(this$0) {
    return function () {
      return this$0.o35();
    };
  }
  function MultilineTextCell$_get_childrenCells_$ref_ty5fl2() {
    return function (p0) {
      return _get_childrenCells__2b6phd(p0);
    };
  }
  function MultilineTextCell() {
    Companion_getInstance_246();
    VerticalCell.call(this);
    this.wcu_1 = false;
    var tmp = this.n92(Companion_getInstance_246().dcw_1);
    tmp.z2r(MultilineTextCell$lambda(this));
    var tmp_0 = this.n92(Companion_getInstance_246().ecw_1);
    tmp_0.z2r(MultilineTextCell$onSelectionChanged$ref(this));
    var tmp_1 = this;
    tmp_1.xcu_1 = lazy(MultilineTextCell$childrenCells$delegate$lambda(this));
  }
  protoOf(MultilineTextCell).ycu = function (lineCell) {
    runCaretOperation(this, MultilineTextCell$synchronizePosition$lambda(this, lineCell));
  };
  protoOf(MultilineTextCell).gcw = function () {
    runCaretOperation(this, MultilineTextCell$hideCaret$lambda(this));
  };
  protoOf(MultilineTextCell).hcw = function (point) {
    var lineNumber_0 = lineNumber(this, point.e8c_1);
    if (lineNumber_0 < 0)
      return null;
    var line = textCell(this, lineNumber_0);
    var lastPos = line.w96();
    // Inline function 'kotlin.math.min' call
    var a = line.m97(point.d8c_1 - get_origin(line).d8c_1 | 0);
    var linePosition = Math.min(a, lastPos);
    var position = new Position_0(lineNumber_0, linePosition);
    this.i90(Companion_getInstance_246().dcw_1, position);
    return position;
  };
  function onCopyCut($this, cell, event, isCut) {
    if (!cell.k91(get_SELECTED()))
      return onCopyCut$default(isCut, $this, cell, event);
    var tmp0_elvis_lhs = allText($this);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return onCopyCut$default(isCut, $this, cell, event);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var content = tmp;
    event.t8i(content);
    if (isCut) {
      $this.ncw_1.icw_1.d2x(null);
      toFirstFocusable($this.ncw_1.kcw_1)();
    }
  }
  function allText($this) {
    var strings = $this.mcw_1.ocw();
    return strings.s() ? null : strings.p() === 1 ? TextContentHelper_getInstance().t8m(first(strings)) : TextContentHelper_getInstance().u8m(strings);
  }
  function onCopyCut$default($isCut, this$0, $cell, $event) {
    var tmp;
    if ($isCut) {
      protoOf(CellTrait).g92.call(this$0, $cell, $event);
      tmp = Unit_instance;
    } else {
      protoOf(CellTrait).f92.call(this$0, $cell, $event);
      tmp = Unit_instance;
    }
    return tmp;
  }
  function mapperFactory($this, node) {
    var textModel = new TextModel(node, $this.lcw_1.pcw_1, MultilineTextSynchronizerFactory$SynchronizerSetup$lineFactory$ref($this), $this.lcw_1.tcw_1.w6n($this.lcw_1.pcw_1.icv_1, $this.lcw_1.pcw_1.jcv_1));
    // Inline function 'kotlin.apply' call
    var this_0 = new TextMapper(textModel, $this.lcw_1.qcw_1, new TransformablePositionStateTrait($this.lcw_1.rcw_1, $this.lcw_1.pcw_1), $this.lcw_1.ucw_1, $this.lcw_1.vcw_1);
    this_0.f86_1.w92(new CopyCutOnWholeMultilineTextCell($this, textModel));
    return this_0;
  }
  function _get_completion__ojdpzl_0($this) {
    var tmp = MultilineTextSynchronizerFactory$SynchronizerSetup$_get_completion_$lambda_scdf0d($this);
    return new sam$jetbrains_ocelot_projectional_editor_generic_roleCompletion_RoleCompletion$0_4(tmp);
  }
  function nodeFactory($this, startText) {
    return nodeFactory_0($this, startText == null ? listOf('') : listOf(startText));
  }
  function nodeFactory$default($this, startText, $super) {
    startText = startText === VOID ? null : startText;
    return nodeFactory($this, startText);
  }
  function nodeFactory_0($this, lines) {
    // Inline function 'kotlin.collections.isNotEmpty' call
    // Inline function 'kotlin.check' call
    if (!!lines.s()) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    var textNode = createInstance($this.lcw_1.rcw_1, $this.lcw_1.pcw_1.icv_1.g6h_1, $this.lcw_1.scw_1);
    var formattedLines = (new TextFormatter($this.lcw_1.ucw_1)).ycw(lines);
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(formattedLines, 10));
    var _iterator__ex2g4s = formattedLines.m();
    while (_iterator__ex2g4s.n()) {
      var item = _iterator__ex2g4s.o();
      var tmp$ret$2 = lineFactory($this, item);
      destination.j(tmp$ret$2);
    }
    var lineNodes = destination;
    $this.lcw_1.pcw_1.icv_1.h6h_1(textNode).q(lineNodes);
    return textNode;
  }
  function lineFactory($this, text) {
    // Inline function 'kotlin.also' call
    var this_0 = createInstance($this.lcw_1.rcw_1, $this.lcw_1.pcw_1.jcv_1.m6m_1, $this.lcw_1.scw_1);
    if (!(text == null)) {
      $this.lcw_1.pcw_1.jcv_1.n6m_1(this_0).m5y().o3n(0, text);
    }
    return this_0;
  }
  function lineFactory$default($this, text, $super) {
    text = text === VOID ? null : text;
    return lineFactory($this, text);
  }
  function MultilinePasteOnPlaceholder($outer) {
    this.zcw_1 = $outer;
    CellTrait.call(this);
  }
  protoOf(MultilinePasteOnPlaceholder).h92 = function (cell, event) {
    var content = event.c8m_1;
    if (content.e8i(ContentKinds_getInstance().f8m_1))
      return protoOf(CellTrait).h92.call(this, cell, event);
    if (content.e8i(ContentKinds_getInstance().g8m_1)) {
      var textNode = nodeFactory_0(this.zcw_1, toList_0(content.f8i(ContentKinds_getInstance().g8m_1)));
      this.zcw_1.icw_1.d2x(textNode);
      toFirstFocusable(this.zcw_1.kcw_1)();
      event.n8i();
    } else {
      protoOf(CellTrait).h92.call(this, cell, event);
    }
  };
  function CopyCutOnWholeMultilineTextCell($outer, model) {
    this.ncw_1 = $outer;
    CellTrait.call(this);
    this.mcw_1 = model;
  }
  protoOf(CopyCutOnWholeMultilineTextCell).f92 = function (cell, event) {
    onCopyCut(this, cell, event, false);
  };
  protoOf(CopyCutOnWholeMultilineTextCell).g92 = function (cell, event) {
    onCopyCut(this, cell, event, !this.ncw_1.lcw_1.vcw_1);
  };
  function sam$jetbrains_ocelot_projectional_editor_generic_roleCompletion_RoleCompletion$0_4(function_0) {
    this.acx_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_projectional_editor_generic_roleCompletion_RoleCompletion$0_4).oan = function (mapper, contextNode, target) {
    return this.acx_1(mapper, contextNode, target);
  };
  protoOf(sam$jetbrains_ocelot_projectional_editor_generic_roleCompletion_RoleCompletion$0_4).f3 = function () {
    return this.acx_1;
  };
  protoOf(sam$jetbrains_ocelot_projectional_editor_generic_roleCompletion_RoleCompletion$0_4).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, RoleCompletion) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_projectional_editor_generic_roleCompletion_RoleCompletion$0_4).hashCode = function () {
    return hashCode(this.f3());
  };
  function MultilineTextSynchronizerFactory$SynchronizerSetup$mapperFactory$ref(p0) {
    var l = function (_this__u8e3s4) {
      var tmp0 = p0;
      return mapperFactory(tmp0, _this__u8e3s4);
    };
    l.callableName = 'mapperFactory';
    return l;
  }
  function MultilineTextSynchronizerFactory$SynchronizerSetup$lambda(this$0, this$1) {
    return function (trait) {
      var tmp;
      if (this$0.vcw_1) {
        tmp = TextEditing_getInstance().qa6();
      } else {
        tmp = CompositeCellTraits_instance.ra6([new MultilinePasteOnPlaceholder(this$1), trait]);
      }
      return tmp;
    };
  }
  function MultilineTextSynchronizerFactory$SynchronizerSetup$mapperFactory$ref_0(p0) {
    var l = function (_this__u8e3s4) {
      var tmp0 = p0;
      return mapperFactory(tmp0, _this__u8e3s4);
    };
    l.callableName = 'mapperFactory';
    return l;
  }
  function MultilineTextSynchronizerFactory$SynchronizerSetup$nodeFactory$ref(p0) {
    return function () {
      var tmp0 = p0;
      return nodeFactory$default(tmp0);
    };
  }
  function MultilineTextSynchronizerFactory$SynchronizerSetup$lineFactory$ref(p0) {
    return function () {
      var tmp0 = p0;
      return lineFactory$default(tmp0);
    };
  }
  function MultilineTextSynchronizerFactory$SynchronizerSetup$completion$2$1(this$0, $target) {
    this.ccx_1 = this$0;
    this.dcx_1 = $target;
    BaseCompletionItem.call(this);
    this.bcx_1 = 'Start typing';
  }
  protoOf(MultilineTextSynchronizerFactory$SynchronizerSetup$completion$2$1).c9k = function () {
    return this.bcx_1;
  };
  protoOf(MultilineTextSynchronizerFactory$SynchronizerSetup$completion$2$1).m9n = function (text) {
    return true;
  };
  protoOf(MultilineTextSynchronizerFactory$SynchronizerSetup$completion$2$1).l9k = function (text) {
    return true;
  };
  protoOf(MultilineTextSynchronizerFactory$SynchronizerSetup$completion$2$1).s9m = function (text) {
    var textNode = nodeFactory(this.ccx_1, text);
    return this.dcx_1.yak(textNode);
  };
  function MultilineTextSynchronizerFactory$SynchronizerSetup$_get_completion_$lambda_scdf0d(this$0) {
    return function (_unused_var__etf5q3, _unused_var__etf5q3_0, target) {
      var tmp;
      if (!(this$0.icw_1.uv() == null)) {
        tmp = get_EMPTY_COMPLETION_SUPPLIER();
      } else {
        var tmp_0 = CompletionSupplement_instance;
        tmp = tmp_0.o9p([new MultilineTextSynchronizerFactory$SynchronizerSetup$completion$2$1(this$0, target)]);
      }
      return tmp;
    };
  }
  function SynchronizerSetup($outer, source, placeholder) {
    this.lcw_1 = $outer;
    this.icw_1 = source;
    this.kcw_1 = CellFactory_instance.na9([]);
    if (this.lcw_1.vcw_1) {
      var tmp = this;
      var tmp_0 = ReadOnlyProjectionalSynchronizers_instance;
      var tmp_1 = MultilineTextSynchronizerFactory$SynchronizerSetup$mapperFactory$ref(this);
      tmp.jcw_1 = tmp_0.pau(this.icw_1, this.kcw_1, tmp_1, placeholder == null ? '<text>' : placeholder, this.lcw_1.wcw_1, null);
    } else {
      var tmp_2 = new ProjectionalPropertySynchronizerSettings();
      var tmp_3 = tmp_2.saq(placeholder == null ? '<text>' : placeholder);
      var settings = tmp_3.qaq(MultilineTextSynchronizerFactory$SynchronizerSetup$lambda(this.lcw_1, this));
      var tmp_4 = this;
      var tmp_5 = ProjectionalSynchronizers_getInstance();
      tmp_4.jcw_1 = tmp_5.iau(this.icw_1, this.kcw_1, MultilineTextSynchronizerFactory$SynchronizerSetup$mapperFactory$ref_0(this), settings);
      var tmp_6 = Companion_instance_200;
      this.jcw_1.san(tmp_6.vap(MultilineTextSynchronizerFactory$SynchronizerSetup$nodeFactory$ref(this)));
      this.jcw_1.jao(_get_completion__ojdpzl_0(this));
      this.jcw_1.tan(true);
    }
  }
  protoOf(SynchronizerSetup).ecx = function () {
    return to(this.jcw_1, this.kcw_1);
  };
  function MultilineTextSynchronizerFactory(textSpecification, textStyle, conceptRegistry, wrapperContext, splitMergeSupportFactory, pasteLineWidth, readOnly, caretNavigation) {
    pasteLineWidth = pasteLineWidth === VOID ? 80 : pasteLineWidth;
    readOnly = readOnly === VOID ? false : readOnly;
    caretNavigation = caretNavigation === VOID ? true : caretNavigation;
    this.pcw_1 = textSpecification;
    this.qcw_1 = textStyle;
    this.rcw_1 = conceptRegistry;
    this.scw_1 = wrapperContext;
    this.tcw_1 = splitMergeSupportFactory;
    this.ucw_1 = pasteLineWidth;
    this.vcw_1 = readOnly;
    this.wcw_1 = caretNavigation;
    // Inline function 'kotlin.require' call
    if (!(this.wcw_1 || this.vcw_1)) {
      var message = 'Non-readonly text makes no sense without caret';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
  }
  protoOf(MultilineTextSynchronizerFactory).fcx = function (source, placeholder) {
    return (new SynchronizerSetup(this, source, placeholder)).ecx();
  };
  function _get_isInvalid__ofio3g($this, _this__u8e3s4) {
    return _this__u8e3s4.mcv_1 === -1 && _this__u8e3s4.ncv_1 === -1;
  }
  function getLength($this, model, line) {
    return model.zcv(line).uv().length;
  }
  function Companion_247() {
    Companion_instance_247 = this;
    this.gcx_1 = new Position_0(-1, -1);
  }
  var Companion_instance_247;
  function Companion_getInstance_247() {
    if (Companion_instance_247 == null)
      new Companion_247();
    return Companion_instance_247;
  }
  function Position_0(line, offset) {
    Companion_getInstance_247();
    this.mcv_1 = line;
    this.ncv_1 = offset;
    if (!_get_isInvalid__ofio3g(Companion_getInstance_247(), this)) {
      // Inline function 'kotlin.require' call
      if (!(this.mcv_1 >= 0)) {
        var message = 'Line should be non-negative, but was ' + this.mcv_1;
        throw IllegalArgumentException_init_$Create$_0(toString_1(message));
      }
      // Inline function 'kotlin.require' call
      if (!(this.ncv_1 >= 0)) {
        var message_0 = 'Offset should be non-negative, but was ' + this.ncv_1;
        throw IllegalArgumentException_init_$Create$_0(toString_1(message_0));
      }
    }
  }
  protoOf(Position_0).hcx = function (model) {
    return this.ncv_1 > 0 ? new Position_0(this.mcv_1, this.ncv_1 - 1 | 0) : this.mcv_1 > 0 ? new Position_0(this.mcv_1 - 1 | 0, getLength(this, model, this.mcv_1 - 1 | 0)) : this;
  };
  protoOf(Position_0).icx = function (model) {
    return this.ncv_1 < getLength(this, model, this.mcv_1) ? new Position_0(this.mcv_1, this.ncv_1 + 1 | 0) : this.mcv_1 < (model.qcv().p() - 1 | 0) ? new Position_0(this.mcv_1 + 1 | 0, 0) : this;
  };
  protoOf(Position_0).jcx = function (model) {
    var tmp;
    if (this.mcv_1 > 0) {
      var tmp_0 = this.mcv_1 - 1 | 0;
      var tmp0 = this.ncv_1;
      // Inline function 'kotlin.math.min' call
      var b = getLength(this, model, this.mcv_1 - 1 | 0);
      var tmp$ret$0 = Math.min(tmp0, b);
      tmp = new Position_0(tmp_0, tmp$ret$0);
    } else {
      tmp = this;
    }
    return tmp;
  };
  protoOf(Position_0).kcx = function (model) {
    var tmp;
    if (this.mcv_1 < (model.qcv().p() - 1 | 0)) {
      var tmp_0 = this.mcv_1 + 1 | 0;
      var tmp0 = this.ncv_1;
      // Inline function 'kotlin.math.min' call
      var b = getLength(this, model, this.mcv_1 + 1 | 0);
      var tmp$ret$0 = Math.min(tmp0, b);
      tmp = new Position_0(tmp_0, tmp$ret$0);
    } else {
      tmp = this;
    }
    return tmp;
  };
  protoOf(Position_0).lcx = function (model) {
    return new Position_0(this.mcv_1, 0);
  };
  protoOf(Position_0).mcx = function (model) {
    return new Position_0(this.mcv_1, getLength(this, model, this.mcv_1));
  };
  protoOf(Position_0).ncx = function (model, ch) {
    model.zcv(this.mcv_1).o3n(this.ncv_1, toString(ch));
    return new Position_0(this.mcv_1, this.ncv_1 + 1 | 0);
  };
  protoOf(Position_0).ocx = function (model) {
    model.ycv_1.a6o(model.vcv_1, this.mcv_1 + 1 | 0, this.ncv_1);
    return new Position_0(this.mcv_1 + 1 | 0, 0);
  };
  protoOf(Position_0).pcx = function (model) {
    if (this.ncv_1 < getLength(this, model, this.mcv_1)) {
      model.zcv(this.mcv_1).q3n(this.ncv_1, 1);
    } else if (this.mcv_1 < (model.qcv().p() - 1 | 0)) {
      model.ycv_1.c6o(model.vcv_1, model.acw(this.mcv_1 + 1 | 0));
    }
    return this;
  };
  protoOf(Position_0).qcx = function (model) {
    var tmp;
    if (this.ncv_1 > 0) {
      model.zcv(this.mcv_1).q3n(this.ncv_1 - 1 | 0, 1);
      tmp = new Position_0(this.mcv_1, this.ncv_1 - 1 | 0);
    } else if (this.mcv_1 > 0) {
      var prevLineLen = getLength(this, model, this.mcv_1 - 1 | 0);
      model.ycv_1.c6o(model.vcv_1, model.acw(this.mcv_1));
      tmp = new Position_0(this.mcv_1 - 1 | 0, prevLineLen);
    } else {
      tmp = this;
    }
    return tmp;
  };
  protoOf(Position_0).ocv = function (other) {
    var lines = this.mcv_1 - other.mcv_1 | 0;
    return !(lines === 0) ? lines : this.ncv_1 - other.ncv_1 | 0;
  };
  protoOf(Position_0).d = function (other) {
    return this.ocv(other instanceof Position_0 ? other : THROW_CCE());
  };
  protoOf(Position_0).toString = function () {
    return '(' + this.mcv_1 + ', ' + this.ncv_1 + ')';
  };
  protoOf(Position_0).hashCode = function () {
    var result = this.mcv_1;
    result = imul(result, 31) + this.ncv_1 | 0;
    return result;
  };
  protoOf(Position_0).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Position_0))
      return false;
    if (!(this.mcv_1 === other.mcv_1))
      return false;
    if (!(this.ncv_1 === other.ncv_1))
      return false;
    return true;
  };
  function PositionHandler() {
  }
  protoOf(PositionHandler).rcx = function (cell) {
    return false;
  };
  protoOf(PositionHandler).ya7 = function (cell) {
    return this.rcx(cell instanceof MultilineTextCell ? cell : THROW_CCE());
  };
  protoOf(PositionHandler).scx = function (cell) {
    var pos = cell.k91(Companion_getInstance_246().dcw_1);
    return !(pos == null) ? this.ucx(pos) : this.tcx();
  };
  protoOf(PositionHandler).za7 = function (cell) {
    return this.scx(cell instanceof MultilineTextCell ? cell : THROW_CCE());
  };
  protoOf(PositionHandler).vcx = function (cell, state) {
    if (!equals(state, this.tcx())) {
      cell.i90(Companion_getInstance_246().dcw_1, state.wcx_1);
    }
  };
  protoOf(PositionHandler).aa8 = function (cell, state) {
    var tmp = cell instanceof MultilineTextCell ? cell : THROW_CCE();
    return this.vcx(tmp, state instanceof TextPositionState ? state : THROW_CCE());
  };
  function get_defaultTextPositionStateHandlerTrait() {
    // Inline function 'jetbrains.ocelot.projectional.cell.trait.propertyTrait' call
    var propSpec = Companion_getInstance_189().ma6_1;
    return new defaultTextPositionStateHandlerTrait$$inlined$propertyTrait$1(propSpec);
  }
  function SimpleTextPositionHandler() {
    PositionHandler.call(this);
    this.xcx_1 = new TextPositionState(Companion_getInstance_247().gcx_1);
  }
  protoOf(SimpleTextPositionHandler).tcx = function () {
    return this.xcx_1;
  };
  protoOf(SimpleTextPositionHandler).ucx = function (position) {
    return new TextPositionState(position);
  };
  function TextPositionState(position) {
    this.wcx_1 = position;
  }
  protoOf(TextPositionState).xa7 = function (state) {
    return equals(this, state) ? CellStateDifference_EQUAL_getInstance() : CellStateDifference_NAVIGATION_getInstance();
  };
  function defaultTextPositionStateHandlerTrait$$inlined$propertyTrait$1($propSpec) {
    this.ycx_1 = $propSpec;
    CellTrait.call(this);
  }
  protoOf(defaultTextPositionStateHandlerTrait$$inlined$propertyTrait$1).n91 = function (cell, spec) {
    var tmp;
    if (spec === this.ycx_1) {
      tmp = new SimpleTextPositionHandler();
    } else {
      tmp = protoOf(CellTrait).n91.call(this, cell, spec);
    }
    return tmp;
  };
  function staticMultilineText(textSpecification, textStyle, text) {
    var cell = new MultilineTextCell();
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = textSpecification.icv_1.h6h_1(text).m5y().m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      var lineText = textSpecification.jcv_1.n6m_1(element).m5y().w2w();
      var lineCell = TextCell_init_$Create$_0(lineText);
      textStyle(lineCell);
      cell.q92().j(lineCell);
    }
    return cell;
  }
  function TextFormatter$breakLongString$slambda($input, this$0, resultContinuation) {
    this.hcy_1 = $input;
    this.icy_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(TextFormatter$breakLongString$slambda).ncy = function ($this$sequence, $completion) {
    var tmp = this.ocy($this$sequence, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(TextFormatter$breakLongString$slambda).v9 = function (p1, $completion) {
    return this.ncy(p1 instanceof SequenceScope ? p1 : THROW_CCE(), $completion);
  };
  protoOf(TextFormatter$breakLongString$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 4;
            this.lcy_1 = this.hcy_1;
            this.mcy_1 = 0;
            this.kcy_1 = this.icy_1.xcw_1;
            this.f9_1 = 1;
            continue $sm;
          case 1:
            if (!(this.mcy_1 <= (this.lcy_1.length - 1 | 0))) {
              this.f9_1 = 3;
              continue $sm;
            }

            if (this.kcy_1 <= (this.lcy_1.length - 1 | 0)) {
              while (this.kcy_1 > this.mcy_1 && !isWhitespace(charCodeAt(this.hcy_1, this.kcy_1))) {
                this.kcy_1 = this.kcy_1 - 1 | 0;
              }
            }

            if (this.kcy_1 === this.mcy_1) {
              var tmp_0 = this;
              var tmp0 = this.kcy_1 + this.icy_1.xcw_1 | 0;
              var b = this.lcy_1.length;
              tmp_0.kcy_1 = Math.min(tmp0, b);
              while (this.kcy_1 < this.lcy_1.length && !(charCodeAt(this.hcy_1, this.kcy_1) === _Char___init__impl__6a9atx(32))) {
                this.kcy_1 = this.kcy_1 + 1 | 0;
              }
            }

            this.f9_1 = 2;
            suspendResult = this.jcy_1.dh(substring_1(this.lcy_1, until(this.mcy_1, this.kcy_1)), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.kcy_1 = this.kcy_1 + 1 | 0;
            this.mcy_1 = this.kcy_1;
            var tmp_1 = this;
            var tmp0_0 = this.kcy_1 + this.icy_1.xcw_1 | 0;
            var b_0 = this.lcy_1.length;
            tmp_1.kcy_1 = Math.min(tmp0_0, b_0);
            this.f9_1 = 1;
            continue $sm;
          case 3:
            return Unit_instance;
          case 4:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 4) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(TextFormatter$breakLongString$slambda).ocy = function ($this$sequence, completion) {
    var i = new TextFormatter$breakLongString$slambda(this.hcy_1, this.icy_1, completion);
    i.jcy_1 = $this$sequence;
    return i;
  };
  function TextFormatter$breakLongString$slambda_0($input, this$0, resultContinuation) {
    var i = new TextFormatter$breakLongString$slambda($input, this$0, resultContinuation);
    var l = function ($this$sequence, $completion) {
      return i.ncy($this$sequence, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function TextFormatter(lineWidth) {
    this.xcw_1 = lineWidth;
  }
  protoOf(TextFormatter).ycw = function (input) {
    // Inline function 'kotlin.collections.flatMap' call
    // Inline function 'kotlin.collections.flatMapTo' call
    var destination = ArrayList_init_$Create$();
    var _iterator__ex2g4s = input.m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      var list = this.pcy(element);
      addAll_1(destination, list);
    }
    return destination;
  };
  protoOf(TextFormatter).pcy = function (input) {
    var tmp;
    if (input.length <= this.xcw_1) {
      tmp = listOf(input);
    } else {
      tmp = toList_2(sequence(TextFormatter$breakLongString$slambda_0(input, this, null)));
    }
    return tmp;
  };
  function TextMapper$ReadOnlyTextCellTrait$onKeyPressed$lambda(this$0) {
    return function (it) {
      return it.jcx(this$0.xcy_1);
    };
  }
  function TextMapper$ReadOnlyTextCellTrait$onKeyPressed$lambda_0(this$0) {
    return function (it) {
      return it.kcx(this$0.xcy_1);
    };
  }
  function TextMapper$ReadOnlyTextCellTrait$onKeyPressed$lambda_1(this$0) {
    return function (it) {
      return it.hcx(this$0.xcy_1);
    };
  }
  function TextMapper$ReadOnlyTextCellTrait$onKeyPressed$lambda_2(this$0) {
    return function (it) {
      return it.icx(this$0.xcy_1);
    };
  }
  function TextMapper$ReadOnlyTextCellTrait$onKeyPressed$lambda_3(this$0) {
    return function (it) {
      return it.lcx(this$0.xcy_1);
    };
  }
  function TextMapper$ReadOnlyTextCellTrait$onKeyPressed$lambda_4(this$0) {
    return function (it) {
      return it.mcx(this$0.xcy_1);
    };
  }
  function TextMapper$EditableTextCellTrait$onKeyPressed$lambda(this$0) {
    return function (it) {
      return it.pcx(this$0.xcy_1);
    };
  }
  function TextMapper$EditableTextCellTrait$onKeyPressed$lambda_0(this$0) {
    return function (it) {
      return it.qcx(this$0.xcy_1);
    };
  }
  function TextMapper$EditableTextCellTrait$onKeyPressed$lambda_1(this$0) {
    return function (it) {
      return it.ocx(this$0.xcy_1);
    };
  }
  function TextMapper$EditableTextCellTrait$onKeyTyped$lambda(this$0, $event) {
    return function (it) {
      return it.ncx(this$0.xcy_1, $event.i8j_1);
    };
  }
  function TextMapper$EditableTextCellTrait$onPaste$lambda(this$0, $content, $event) {
    return function (position) {
      this$0.xcy_1.bcz(this$0.acz_1.ycw($content.f8i(ContentKinds_getInstance().g8m_1)), position);
      $event.n8i();
      return position;
    };
  }
  function TextMapper$EditableTextCellTrait$onPaste$lambda_0($content, this$0, $event) {
    return function (position) {
      var text = $content.f8i(ContentKinds_getInstance().f8m_1);
      var tmp;
      if (text.length <= this$0.zcy_1) {
        this$0.xcy_1.ccz($content.f8i(ContentKinds_getInstance().f8m_1), position);
        tmp = Unit_instance;
      } else {
        var splitStrings = this$0.acz_1.pcy(text);
        this$0.xcy_1.bcz(splitStrings, position);
        tmp = Unit_instance;
      }
      $event.n8i();
      return position;
    };
  }
  function ReadOnlyTextCellTrait($outer) {
    this.ecz_1 = $outer;
    CellTrait.call(this);
    this.dcz_1 = null;
  }
  protoOf(ReadOnlyTextCellTrait).fcz = function (cell, event, isCut) {
    var tmp0_elvis_lhs = cell.k91(Companion_getInstance_246().ecw_1);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var selection = tmp;
    var clipboardContent = selection.ccw(this.ecz_1.xcy_1);
    if (isCut) {
      this.gcz(cell);
      cell.i90(Companion_getInstance_246().dcw_1, selection.ucv(this.ecz_1.xcy_1, this.ecz_1.e86_1));
    }
    event.t8i(clipboardContent);
    return true;
  };
  protoOf(ReadOnlyTextCellTrait).hcz = function (_this__u8e3s4, key) {
    return _this__u8e3s4.m8j(key, []) || _this__u8e3s4.m8j(key, [ModifierKey_SHIFT_getInstance()]);
  };
  protoOf(ReadOnlyTextCellTrait).icz = function (_this__u8e3s4, keyStroke) {
    return _this__u8e3s4.o8j([keyStroke]) || _this__u8e3s4.o8j([keyStroke.c8k(ModifierKey_SHIFT_getInstance())]);
  };
  protoOf(ReadOnlyTextCellTrait).jcz = function (_this__u8e3s4) {
    return _this__u8e3s4.t8j(ModifierKey_SHIFT_getInstance());
  };
  protoOf(ReadOnlyTextCellTrait).kcz = function (cell) {
    return ensureNotNull(cell.k91(Companion_getInstance_246().dcw_1));
  };
  protoOf(ReadOnlyTextCellTrait).lcz = function (cell, event, action) {
    var caret = this.kcz(cell);
    var newPosition = action(caret);
    if (newPosition.equals(caret)) {
      if (this.jcz(event)) {
        this.gcz(cell);
      }
    } else {
      cell.i90(Companion_getInstance_246().dcw_1, newPosition);
      if (this.jcz(event)) {
        this.mcz(cell, caret, newPosition);
      } else {
        this.gcz(cell);
      }
      event.n8i();
    }
  };
  protoOf(ReadOnlyTextCellTrait).ncz = function (cell, action) {
    var selection = cell.k91(Companion_getInstance_246().ecw_1);
    if (!(selection == null)) {
      this.gcz(cell);
      cell.i90(Companion_getInstance_246().dcw_1, selection.ucv(this.ecz_1.xcy_1, this.ecz_1.e86_1));
    } else {
      var caret = this.kcz(cell);
      cell.i90(Companion_getInstance_246().dcw_1, action(caret));
    }
  };
  protoOf(ReadOnlyTextCellTrait).ocz = function (cell, action) {
    var selection = cell.k91(Companion_getInstance_246().ecw_1);
    var tmp;
    if (!(selection == null)) {
      this.gcz(cell);
      tmp = selection.ucv(this.ecz_1.xcy_1, this.ecz_1.e86_1);
    } else {
      tmp = this.kcz(cell);
    }
    var caret = tmp;
    cell.i90(Companion_getInstance_246().dcw_1, action(caret));
  };
  protoOf(ReadOnlyTextCellTrait).mcz = function (_this__u8e3s4, previousCaret, to) {
    var tmp0_elvis_lhs = _this__u8e3s4.k91(Companion_getInstance_246().fcw_1);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.run' call
      _this__u8e3s4.i90(Companion_getInstance_246().fcw_1, previousCaret);
      tmp = previousCaret;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var origin = tmp;
    _this__u8e3s4.i90(Companion_getInstance_246().ecw_1, Companion_instance_245.pcv(origin, to).tcv());
  };
  protoOf(ReadOnlyTextCellTrait).gcz = function (_this__u8e3s4) {
    _this__u8e3s4.i90(Companion_getInstance_246().ecw_1, null);
    _this__u8e3s4.i90(Companion_getInstance_246().fcw_1, null);
  };
  protoOf(ReadOnlyTextCellTrait).s8z = function (cell, event) {
    if (this.hcz(event, Key_UP_getInstance())) {
      this.lcz(cell, event, TextMapper$ReadOnlyTextCellTrait$onKeyPressed$lambda(this.ecz_1));
    } else if (this.hcz(event, Key_DOWN_getInstance())) {
      this.lcz(cell, event, TextMapper$ReadOnlyTextCellTrait$onKeyPressed$lambda_0(this.ecz_1));
    } else if (this.hcz(event, Key_LEFT_getInstance())) {
      this.lcz(cell, event, TextMapper$ReadOnlyTextCellTrait$onKeyPressed$lambda_1(this.ecz_1));
    } else if (this.hcz(event, Key_RIGHT_getInstance())) {
      this.lcz(cell, event, TextMapper$ReadOnlyTextCellTrait$onKeyPressed$lambda_2(this.ecz_1));
    } else if (this.icz(event, KeyStrokeSpecs_getInstance().l8k_1)) {
      this.lcz(cell, event, TextMapper$ReadOnlyTextCellTrait$onKeyPressed$lambda_3(this.ecz_1));
    } else if (this.icz(event, KeyStrokeSpecs_getInstance().m8k_1)) {
      this.lcz(cell, event, TextMapper$ReadOnlyTextCellTrait$onKeyPressed$lambda_4(this.ecz_1));
    }
  };
  protoOf(ReadOnlyTextCellTrait).t91 = function (cell, event) {
    // Inline function 'kotlin.check' call
    if (!(cell instanceof MultilineTextCell)) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    var oldPosition = cell.k91(Companion_getInstance_246().dcw_1);
    this.dcz_1 = cell.hcw(new Vector(event.x8l_1, event.y8l_1));
    if (event.u8l_1.z8j_1) {
      var position = this.kcz(cell);
      var old = equals(oldPosition, Companion_getInstance_247().gcx_1) || oldPosition == null ? new Position_0(0, 0) : oldPosition;
      this.mcz(cell, old, position);
    } else {
      this.gcz(cell);
    }
    event.n8i();
  };
  protoOf(ReadOnlyTextCellTrait).u91 = function (cell, event) {
    this.dcz_1 = null;
  };
  protoOf(ReadOnlyTextCellTrait).w91 = function (cell, event) {
    // Inline function 'kotlin.check' call
    if (!(cell instanceof MultilineTextCell)) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    if (!(this.dcz_1 == null)) {
      var currPosition = cell.hcw(new Vector(event.x8l_1, event.y8l_1));
      if (!(currPosition == null)) {
        this.mcz(cell, ensureNotNull(this.dcz_1), currPosition);
        event.n8i();
        return Unit_instance;
      }
    }
    protoOf(CellTrait).w91.call(this, cell, event);
  };
  protoOf(ReadOnlyTextCellTrait).f92 = function (cell, event) {
    if (!this.fcz(cell, event, false)) {
      protoOf(CellTrait).f92.call(this, cell, event);
    }
  };
  protoOf(ReadOnlyTextCellTrait).g92 = function (cell, event) {
    if (!this.fcz(cell, event, false)) {
      protoOf(CellTrait).g92.call(this, cell, event);
    }
  };
  protoOf(ReadOnlyTextCellTrait).p91 = function (cell, event) {
    // Inline function 'kotlin.check' call
    if (!(cell instanceof MultilineTextCell)) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    var tmp = event.y9t_1;
    cell.ycu(tmp instanceof TextCell ? tmp : THROW_CCE());
  };
  protoOf(ReadOnlyTextCellTrait).q91 = function (cell, event) {
    if (!(event.y9t_1 == null) && !contains_5(this.ecz_1.f86_1.o35(), event.y9t_1)) {
      this.dcz_1 = null;
      // Inline function 'kotlin.check' call
      if (!(cell instanceof MultilineTextCell)) {
        throw IllegalStateException_init_$Create$_0('Check failed.');
      }
      this.gcz(cell);
      cell.gcw();
    }
  };
  function EditableTextCellTrait($outer) {
    this.rcz_1 = $outer;
    ReadOnlyTextCellTrait.call(this, $outer);
  }
  protoOf(EditableTextCellTrait).s8z = function (cell, event) {
    if (event.m8j(Key_DELETE_getInstance(), [])) {
      if (!this.rcz_1.xcy_1.w2m()) {
        this.ncz(cell, TextMapper$EditableTextCellTrait$onKeyPressed$lambda(this.rcz_1));
        event.n8i();
      }
    } else if (event.m8j(Key_BACKSPACE_getInstance(), [])) {
      if (!this.rcz_1.xcy_1.w2m()) {
        this.ncz(cell, TextMapper$EditableTextCellTrait$onKeyPressed$lambda_0(this.rcz_1));
        event.n8i();
      }
    } else if (event.m8j(Key_ENTER_getInstance(), [])) {
      this.ocz(cell, TextMapper$EditableTextCellTrait$onKeyPressed$lambda_1(this.rcz_1));
      event.n8i();
    } else {
      protoOf(ReadOnlyTextCellTrait).s8z.call(this, cell, event);
    }
  };
  protoOf(EditableTextCellTrait).q8y = function (cell, event) {
    this.ocz(cell, TextMapper$EditableTextCellTrait$onKeyTyped$lambda(this.rcz_1, event));
    event.n8i();
  };
  protoOf(EditableTextCellTrait).h92 = function (cell, event) {
    var content = event.c8m_1;
    if (content.e8i(ContentKinds_getInstance().g8m_1)) {
      this.ocz(cell, TextMapper$EditableTextCellTrait$onPaste$lambda(this.rcz_1, content, event));
    } else if (content.e8i(ContentKinds_getInstance().f8m_1)) {
      this.ocz(cell, TextMapper$EditableTextCellTrait$onPaste$lambda_0(content, this.rcz_1, event));
    } else {
      protoOf(ReadOnlyTextCellTrait).h92.call(this, cell, event);
    }
  };
  protoOf(EditableTextCellTrait).g92 = function (cell, event) {
    this.fcz(cell, event, true);
  };
  function TextMapper$registerSynchronizers$lambda(this$0) {
    return function (it) {
      return new LineMapper(this$0.xcy_1.wcv_1, this$0.ycy_1, it);
    };
  }
  function TextMapper(model, textStyle, cellStateHandlerTrait, pasteLineWidth, readOnly) {
    cellStateHandlerTrait = cellStateHandlerTrait === VOID ? get_defaultTextPositionStateHandlerTrait() : cellStateHandlerTrait;
    Mapper.call(this, model.vcv_1, new MultilineTextCell());
    this.xcy_1 = model;
    this.ycy_1 = textStyle;
    this.zcy_1 = pasteLineWidth;
    var textCellTrait = readOnly ? new ReadOnlyTextCellTrait(this) : new EditableTextCellTrait(this);
    this.f86_1.w92(CompositeCellTraits_instance.ra6([textCellTrait, cellStateHandlerTrait]));
    this.acz_1 = new TextFormatter(this.zcy_1);
  }
  protoOf(TextMapper).a88 = function (conf) {
    protoOf(Mapper).a88.call(this, conf);
    var tmp = Synchronizers_instance;
    var tmp_0 = this.xcy_1.wcv_1.icv_1.h6h_1(this.e86_1).m5y();
    var tmp_1 = this.f86_1.o35();
    conf.h5v(tmp.c8b(tmp_0, tmp_1, TextMapper$registerSynchronizers$lambda(this)));
  };
  function _get_mutableLines__1k6msy($this) {
    return $this.wcv_1.icv_1.h6h_1($this.vcv_1).m5y();
  }
  function lineText($this, line) {
    return $this.wcv_1.jcv_1.n6m_1(line).m5y();
  }
  function TextModel(node, specification, lineFactory, splitMergeSupport) {
    this.vcv_1 = node;
    this.wcv_1 = specification;
    this.xcv_1 = lineFactory;
    this.ycv_1 = splitMergeSupport;
  }
  protoOf(TextModel).qcv = function () {
    return _get_mutableLines__1k6msy(this);
  };
  protoOf(TextModel).acw = function (index) {
    return this.qcv().r(index);
  };
  protoOf(TextModel).zcv = function (index) {
    return lineText(this, this.acw(index));
  };
  protoOf(TextModel).ocw = function () {
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.qcv();
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.m();
    while (_iterator__ex2g4s.n()) {
      var item = _iterator__ex2g4s.o();
      var tmp$ret$0 = lineText(this, item).uv();
      destination.j(tmp$ret$0);
    }
    return destination;
  };
  protoOf(TextModel).w2m = function () {
    var tmp;
    if (this.qcv().s()) {
      tmp = true;
    } else {
      var tmp_0;
      if (this.qcv().p() === 1) {
        // Inline function 'kotlin.text.isEmpty' call
        var this_0 = this.zcv(0).uv();
        tmp_0 = charSequenceLength(this_0) === 0;
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  protoOf(TextModel).ccz = function (string, position) {
    this.zcv(position.mcv_1).o3n(position.ncv_1, string);
  };
  protoOf(TextModel).bcz = function (strings, position) {
    var list = toList_0(strings);
    if (list.s())
      return Unit_instance;
    var startLine = this.zcv(position.mcv_1);
    var tailToCarryOver = substring_0(startLine.uv(), position.ncv_1);
    startLine.q3n(position.ncv_1, tailToCarryOver.length);
    this.ccz(first(list), position);
    // Inline function 'kotlin.collections.map' call
    var this_0 = drop(list, 1);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.m();
    while (_iterator__ex2g4s.n()) {
      var item = _iterator__ex2g4s.o();
      var newLine = this.xcv_1();
      lineText(this, newLine).o3n(0, item);
      destination.j(newLine);
    }
    var newLines = destination;
    _get_mutableLines__1k6msy(this).i2(position.mcv_1 + 1 | 0, newLines);
    var lastAdded = this.zcv(position.mcv_1 + newLines.p() | 0);
    lastAdded.o3n(lastAdded.uv().length, tailToCarryOver);
  };
  protoOf(TextModel).bcw = function (range) {
    if (range.s())
      return Unit_instance;
    // Inline function 'kotlin.collections.forEach' call
    var progression = reversed_0(range);
    var inductionVariable = progression.c1_1;
    var last = progression.d1_1;
    var step = progression.e1_1;
    if (step > 0 && inductionVariable <= last || (step < 0 && last <= inductionVariable))
      do {
        var element = inductionVariable;
        inductionVariable = inductionVariable + step | 0;
        var it = element;
        _get_mutableLines__1k6msy(this).n2(it);
      }
       while (!(element === last));
  };
  protoOf(TextModel).toString = function () {
    return 'TextModel(node=' + toString_1(this.vcv_1) + ', specification=' + this.wcv_1.toString() + ', lineFactory=' + toString_1(this.xcv_1) + ', splitMergeSupport=' + toString_1(this.ycv_1) + ')';
  };
  protoOf(TextModel).hashCode = function () {
    var result = hashCode(this.vcv_1);
    result = imul(result, 31) + this.wcv_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.xcv_1) | 0;
    result = imul(result, 31) + hashCode(this.ycv_1) | 0;
    return result;
  };
  protoOf(TextModel).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TextModel))
      return false;
    if (!equals(this.vcv_1, other.vcv_1))
      return false;
    if (!this.wcv_1.equals(other.wcv_1))
      return false;
    if (!equals(this.xcv_1, other.xcv_1))
      return false;
    if (!equals(this.ycv_1, other.ycv_1))
      return false;
    return true;
  };
  function TransformablePositionStateTrait(conceptRegistry, textSpecification) {
    CellTrait.call(this);
    this.scz_1 = new TransformableTextPositionStateHandler(conceptRegistry, textSpecification);
  }
  protoOf(TransformablePositionStateTrait).n91 = function (cell, spec) {
    return equals(spec, Companion_getInstance_189().ma6_1) ? this.scz_1 : equals(spec, Companion_getInstance_234().dc9()) ? true : protoOf(CellTrait).n91.call(this, cell, spec);
  };
  function doTransformThrough($this, _this__u8e3s4, lineOp) {
    var tmp;
    if (lineOp.r3x()) {
      tmp = _this__u8e3s4;
    } else {
      if (lineOp instanceof ChangeChildOperation_0) {
        if (!(lineOp.l3p() === _this__u8e3s4.mcv_1)) {
          return _this__u8e3s4;
        }
        var operation = lineOp.s3z();
        var tmp_0;
        var tmp_1;
        if (operation instanceof ChangePropertyOperation) {
          tmp_1 = operation.l3p().equals($this.xcz_1.ucz_1);
        } else {
          tmp_1 = false;
        }
        if (tmp_1) {
          var textOp = operation.s3z();
          var tmp_2;
          var tmp_3;
          if (textOp instanceof InsertTextOperation) {
            tmp_3 = textOp.m3p() <= _this__u8e3s4.ncv_1;
          } else {
            tmp_3 = false;
          }
          if (tmp_3) {
            tmp_2 = new Position_0(_this__u8e3s4.mcv_1, _this__u8e3s4.ncv_1 + textOp.a() | 0);
          } else {
            var tmp_4;
            if (textOp instanceof DeleteTextOperation) {
              tmp_4 = textOp.m3p() < _this__u8e3s4.ncv_1;
            } else {
              tmp_4 = false;
            }
            if (tmp_4) {
              tmp_2 = new Position_0(_this__u8e3s4.mcv_1, _this__u8e3s4.ncv_1 - textOp.a() | 0);
            } else {
              return null;
            }
          }
          tmp_0 = tmp_2;
        } else {
          return null;
        }
        tmp = tmp_0;
      } else {
        if (lineOp instanceof AddChildSplitPropertyOperation) {
          var tmp_5;
          if (lineOp.o41_1 <= _this__u8e3s4.mcv_1) {
            tmp_5 = new Position_0(_this__u8e3s4.mcv_1 + 1 | 0, _this__u8e3s4.ncv_1);
          } else if ((lineOp.o41_1 - 1 | 0) === _this__u8e3s4.mcv_1 && lineOp.p41_1 < _this__u8e3s4.ncv_1) {
            tmp_5 = new Position_0(_this__u8e3s4.mcv_1 + 1 | 0, _this__u8e3s4.ncv_1 - lineOp.p41_1 | 0);
          } else {
            tmp_5 = _this__u8e3s4;
          }
          tmp = tmp_5;
        } else {
          if (lineOp instanceof MergePropertyRemoveChildOperation) {
            var removeIndex = lineOp.v40_1;
            tmp = removeIndex < _this__u8e3s4.mcv_1 ? new Position_0(_this__u8e3s4.mcv_1 - 1 | 0, _this__u8e3s4.ncv_1) : removeIndex === _this__u8e3s4.mcv_1 ? new Position_0(_this__u8e3s4.mcv_1 - 1 | 0, lineOp.w40_1 + _this__u8e3s4.ncv_1 | 0) : _this__u8e3s4;
          } else {
            if (lineOp instanceof CompositeOperation) {
              var compositeOperation = lineOp instanceof CompositeOperation ? lineOp : THROW_CCE();
              var lineOps = compositeOperation.j3w();
              var transformed = _this__u8e3s4;
              var _iterator__ex2g4s = lineOps.m();
              while (_iterator__ex2g4s.n()) {
                var op = _iterator__ex2g4s.o();
                var tmp0_elvis_lhs = doTransformThrough($this, transformed, op);
                transformed = tmp0_elvis_lhs == null ? transformed : tmp0_elvis_lhs;
              }
              tmp = transformed;
            } else {
              return null;
            }
          }
        }
      }
    }
    return tmp;
  }
  function role($this, _this__u8e3s4, conceptRegistry) {
    return conceptRegistry.l6l(_this__u8e3s4.icv_1.g6h_1).u6m(_this__u8e3s4.icv_1);
  }
  function property($this, _this__u8e3s4, conceptRegistry) {
    return conceptRegistry.l6l(_this__u8e3s4.jcv_1.m6m_1).v6m(_this__u8e3s4.jcv_1);
  }
  function TransformableTextPositionState($outer, position) {
    this.xcz_1 = $outer;
    TextPositionState.call(this, position);
  }
  protoOf(TransformableTextPositionState).nc7 = function (op) {
    var tmp;
    if (equals(this, this.xcz_1.vcz_1)) {
      tmp = this.xcz_1.vcz_1;
    } else {
      var tmp_0;
      if (op instanceof ChildListOperation) {
        tmp_0 = this.xcz_1.tcz_1.equals(op.l3p());
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        var tmp0_safe_receiver = doTransformThrough(this, this.wcx_1, op.s3z());
        var tmp_1;
        if (tmp0_safe_receiver == null) {
          tmp_1 = null;
        } else {
          // Inline function 'kotlin.let' call
          tmp_1 = new TransformableTextPositionState(this.xcz_1, tmp0_safe_receiver);
        }
        tmp = tmp_1;
      } else {
        throw UnsupportedOperationException_init_$Create$_0(toString_1(op));
      }
    }
    return tmp;
  };
  function Companion_248() {
  }
  var Companion_instance_248;
  function Companion_getInstance_248() {
    return Companion_instance_248;
  }
  function TransformableTextPositionStateHandler(conceptRegistry, textSpecification) {
    PositionHandler.call(this);
    var tmp = this;
    var tmp0 = role(Companion_instance_248, textSpecification, conceptRegistry);
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.checkNotNull' call
      if (tmp0 == null) {
        var message = 'No OT specifics data found for link ' + textSpecification.icv_1.toString();
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      } else {
        tmp$ret$1 = tmp0;
        break $l$block;
      }
    }
    tmp.tcz_1 = tmp$ret$1;
    var tmp_0 = this;
    var tmp0_0 = property(Companion_instance_248, textSpecification, conceptRegistry);
    var tmp$ret$3;
    $l$block_0: {
      // Inline function 'kotlin.checkNotNull' call
      if (tmp0_0 == null) {
        var message_0 = 'No OT specifics data found for link ' + textSpecification.jcv_1.toString();
        throw IllegalStateException_init_$Create$_0(toString_1(message_0));
      } else {
        tmp$ret$3 = tmp0_0;
        break $l$block_0;
      }
    }
    tmp_0.ucz_1 = tmp$ret$3;
    this.vcz_1 = new TransformableTextPositionState(this, Companion_getInstance_247().gcx_1);
  }
  protoOf(TransformableTextPositionStateHandler).tcx = function () {
    return this.vcz_1;
  };
  protoOf(TransformableTextPositionStateHandler).ucx = function (position) {
    return new TransformableTextPositionState(this, position);
  };
  function children_1(_this__u8e3s4, builder, role) {
    // Inline function 'kotlin.with' call
    var tmp = builder.zcz_1;
    var tmp_0 = builder.bd0_1;
    return indentChildren(_this__u8e3s4, role, builder.ycz_1, tmp, tmp_0, children$lambda_0(builder));
  }
  function ChildBuilder$separated$lambda($value) {
    return function (it) {
      return CellLists_instance.saa(it, $value);
    };
  }
  function ChildBuilder$newLineSeparated$lambda(it) {
    return CellLists_instance.taa(it);
  }
  function ChildBuilder(mapperBuilder) {
    this.ycz_1 = mapperBuilder;
    this.zcz_1 = null;
    this.ad0_1 = null;
    this.bd0_1 = null;
    this.cd0_1 = null;
    this.dd0_1 = null;
    this.ed0_1 = null;
  }
  protoOf(ChildBuilder).fd0 = function (factory) {
    this.cd0_1 = factory;
  };
  protoOf(ChildBuilder).gd0 = function (value) {
    this.zcz_1 = value;
  };
  protoOf(ChildBuilder).hd0 = function (factory) {
    this.ad0_1 = factory;
  };
  protoOf(ChildBuilder).id0 = function (value) {
    var tmp = this;
    tmp.bd0_1 = ChildBuilder$separated$lambda(value);
  };
  protoOf(ChildBuilder).jd0 = function () {
    var tmp = this;
    tmp.bd0_1 = ChildBuilder$newLineSeparated$lambda;
  };
  protoOf(ChildBuilder).kd0 = function (contendKindName, cloner) {
    this.dd0_1 = contendKindName;
    this.ed0_1 = cloner;
  };
  protoOf(ChildBuilder).s3e = function () {
    // Inline function 'kotlin.let' call
    var it = new ChildBuilder(this.ycz_1);
    it.zcz_1 = this.zcz_1;
    it.ad0_1 = this.ad0_1;
    it.bd0_1 = this.bd0_1;
    it.cd0_1 = this.cd0_1;
    return it;
  };
  function child_0(_this__u8e3s4, builder, role) {
    // Inline function 'kotlin.with' call
    var tmp = builder.zcz_1;
    return indentChild(_this__u8e3s4, role, builder.ycz_1, tmp, child$lambda_0(builder));
  }
  function children$lambda_0($$this$with) {
    return function ($this$indentChildren) {
      var tmp0_safe_receiver = $$this$with.cd0_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        $this$indentChildren.mct(tmp0_safe_receiver);
      }
      var tmp1_safe_receiver = $$this$with.ad0_1;
      if (tmp1_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        defaultItem($this$indentChildren, tmp1_safe_receiver);
      }
      var tmp;
      if (!($$this$with.dd0_1 == null)) {
        var contentKind = ContentKinds_getInstance().h8m(ensureNotNull($$this$with.dd0_1));
        $this$indentChildren.nct(contentKind, ensureNotNull($$this$with.ed0_1));
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function child$lambda_0($$this$with) {
    return function ($this$indentChild) {
      var tmp0_safe_receiver = $$this$with.cd0_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        $this$indentChild.mct(tmp0_safe_receiver);
      }
      var tmp1_safe_receiver = $$this$with.ad0_1;
      if (tmp1_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        defaultItem($this$indentChild, tmp1_safe_receiver);
      }
      return Unit_instance;
    };
  }
  function bigDecimalValidator(string) {
    return !(toBigDecimalOrNull(string) == null);
  }
  function decimalProperty_0(textCell) {
    var tmp = TextEditing_getInstance();
    textCell.w92(tmp.ta6(bigDecimalValidator$ref_0()));
    var textProp = textCell.o8w();
    var sToT = decimalProperty$safeToDecimal$ref();
    var tToS = decimalProperty$lambda_0;
    return map_1(textProp, sToT, tToS);
  }
  function toBigDecimalOrNull(_this__u8e3s4) {
    var tmp;
    try {
      var tmp_0;
      if (contains_8(_this__u8e3s4, 'e', true)) {
        tmp_0 = null;
      } else {
        tmp_0 = Companion_getInstance_24().j29(_this__u8e3s4);
      }
      tmp = tmp_0;
    } catch ($p) {
      var tmp_1;
      if ($p instanceof ArithmeticException) {
        var _unused_var__etf5q3 = $p;
        tmp_1 = null;
      } else {
        if ($p instanceof NumberFormatException) {
          var _unused_var__etf5q3_0 = $p;
          tmp_1 = null;
        } else {
          if ($p instanceof IndexOutOfBoundsException) {
            var _unused_var__etf5q3_1 = $p;
            tmp_1 = null;
          } else {
            throw $p;
          }
        }
      }
      tmp = tmp_1;
    }
    return tmp;
  }
  function decimalProperty$safeToDecimal(_this__u8e3s4) {
    var tmp0_elvis_lhs = toBigDecimalOrNull(_this__u8e3s4);
    return tmp0_elvis_lhs == null ? Companion_getInstance_24().b28_1 : tmp0_elvis_lhs;
  }
  function bigDecimalValidator$ref_0() {
    var l = function (p0) {
      return bigDecimalValidator(p0);
    };
    l.callableName = 'bigDecimalValidator';
    return l;
  }
  function decimalProperty$safeToDecimal$ref() {
    var l = function (p0) {
      return decimalProperty$safeToDecimal(p0);
    };
    l.callableName = 'safeToDecimal';
    return l;
  }
  function decimalProperty$lambda_0(num) {
    return num.m2a();
  }
  function keyword_0(_this__u8e3s4, text, init) {
    var tmp;
    if (init === VOID) {
      tmp = keyword$lambda_0;
    } else {
      tmp = init;
    }
    init = tmp;
    return label_0(_this__u8e3s4, text, true, true, keyword$lambda_1(init));
  }
  function space_0(_this__u8e3s4) {
    var cell = CellFactory_instance.wa9();
    return addNoDecorationChildCell(_this__u8e3s4, cell);
  }
  function newLine_0(_this__u8e3s4) {
    var cell = CellFactory_instance.l8v();
    return addNoDecorationChildCell(_this__u8e3s4, cell);
  }
  function indent_0(_this__u8e3s4, isIndented, indentNumSpaces, init) {
    isIndented = isIndented === VOID ? false : isIndented;
    indentNumSpaces = indentNumSpaces === VOID ? _this__u8e3s4.ld0().md0() : indentNumSpaces;
    var cell = new IndentCell(isIndented, indentNumSpaces);
    return addDecoratedCell(_this__u8e3s4, cell, init);
  }
  function label_0(_this__u8e3s4, text, firstAllowed, lastAllowed, init) {
    firstAllowed = firstAllowed === VOID ? true : firstAllowed;
    lastAllowed = lastAllowed === VOID ? true : lastAllowed;
    var tmp;
    if (init === VOID) {
      tmp = label$lambda_0;
    } else {
      tmp = init;
    }
    init = tmp;
    var tmp_0;
    if (!get_internalConfig(_this__u8e3s4).nd0().wct_1) {
      tmp_0 = addDecoratedCell(_this__u8e3s4, CellFactory_instance.va9(text), init);
    } else {
      var cell = CellFactory_instance.ta9(text, firstAllowed, lastAllowed);
      if (get_internalConfig(_this__u8e3s4).nd0().uct_1.equals(SourceMode_EDITABLE_getInstance())) {
        cell.w92(CompoundSideTransformTrait_getInstance());
      }
      tmp_0 = addDecoratedCell(_this__u8e3s4, cell, init);
    }
    return tmp_0;
  }
  function horizontal_0(_this__u8e3s4, init) {
    var cell = new HorizontalCell();
    return addDecoratedCell(_this__u8e3s4, cell, init);
  }
  function addNoDecorationChildCell(_this__u8e3s4, cell) {
    var editorBuilder = asInternalEditorBuilder(_this__u8e3s4);
    editorBuilder.od0(cell);
    return cell;
  }
  function addDecoratedCell(_this__u8e3s4, cell, init) {
    addChildEditorBuilder(_this__u8e3s4, cell, init);
    return cell;
  }
  function addChildEditorBuilder(_this__u8e3s4, cell, init) {
    var editorBuilder = asInternalEditorBuilder(_this__u8e3s4);
    var childEditorBuilder = editorBuilder.pd0(cell);
    init(childEditorBuilder);
    editorBuilder.od0(cell);
  }
  function textCell_0(_this__u8e3s4, text, init) {
    var tmp;
    if (init === VOID) {
      tmp = textCell$lambda;
    } else {
      tmp = init;
    }
    init = tmp;
    var cell = TextCell_init_$Create$_0(text);
    if (get_internalConfig(_this__u8e3s4).nd0().uct_1.equals(SourceMode_EDITABLE_getInstance())) {
      cell.w92(CompoundSideTransformTrait_getInstance());
      cell.w92(LeafCellTrackingTrait_getInstance());
    }
    return addDecoratedCell(_this__u8e3s4, cell, init);
  }
  function vertical(_this__u8e3s4, init) {
    var cell = new VerticalCell();
    return addDecoratedCell(_this__u8e3s4, cell, init);
  }
  function placeholder_2(_this__u8e3s4, text, textCell, init) {
    var tmp;
    if (init === VOID) {
      tmp = placeholder$lambda;
    } else {
      tmp = init;
    }
    init = tmp;
    var cell = placeholder_0(textCell, text);
    cell.w92(LeafCellTrackingTrait_getInstance());
    return addDecoratedCell(_this__u8e3s4, cell, init);
  }
  function keyword$lambda_0(_this__u8e3s4) {
    return Unit_instance;
  }
  function keyword$lambda_1($init) {
    return function ($this$label) {
      $this$label.qd0().b97().d2x(Companion_getInstance_210().x95_1);
      $this$label.qd0().d97().d2x(true);
      $init($this$label);
      return Unit_instance;
    };
  }
  function label$lambda_0(_this__u8e3s4) {
    return Unit_instance;
  }
  function textCell$lambda(_this__u8e3s4) {
    return Unit_instance;
  }
  function placeholder$lambda(_this__u8e3s4) {
    return Unit_instance;
  }
  function indentLabel_0(_this__u8e3s4, text, allowLast) {
    allowLast = allowLast === VOID ? false : allowLast;
    return textCell_0(_this__u8e3s4, text, indentLabel$lambda_0(text, allowLast));
  }
  function ensureLastCaretPosition(_this__u8e3s4) {
    if (!get_internalConfig(_this__u8e3s4).nd0().wct_1)
      return Unit_instance;
    _this__u8e3s4.qd0().w92(LastCaretPositionSupport_getInstance());
  }
  function placeholderInCollection_0(_this__u8e3s4, text, collectionItemCompletion) {
    text = text === VOID ? '' : text;
    var tmp = isEmpty$ref_1();
    // Inline function 'kotlin.apply' call
    var this_0 = editableText_0(_this__u8e3s4, VOID, text, tmp, VOID, placeholderInCollection$lambda_0(collectionItemCompletion));
    this_0.w92(LeafCellTrackingTrait_getInstance());
    return this_0;
  }
  function considerEmptyBy(_this__u8e3s4, cell) {
    cell.w92(new considerEmptyBy$1(_this__u8e3s4));
  }
  function deleteIfEmpty(_this__u8e3s4) {
    _this__u8e3s4.qd0().g93(ProjectionalSynchronizers_getInstance().f99_1, true);
  }
  function rightTransform_0(_this__u8e3s4, init) {
    return rightTransform_1(_this__u8e3s4, _this__u8e3s4.qd0(), init);
  }
  function rightTransform_1(_this__u8e3s4, cell, init) {
    return addTraitOnAttach_1(_this__u8e3s4, cell, rightTransform$lambda_0(_this__u8e3s4, cell, init));
  }
  function decimalProperty_1(_this__u8e3s4, placeholder, property) {
    var tmp = bigDecimalValidator$ref_1();
    return editableText_0(_this__u8e3s4, VOID, placeholder, tmp, VOID, decimalProperty$lambda_1(property));
  }
  function integerProperty_0(_this__u8e3s4, placeholder, property) {
    var tmp = Validators_getInstance().x8t();
    return editableText_0(_this__u8e3s4, VOID, placeholder, tmp, VOID, integerProperty$lambda_0(property));
  }
  function disambiguateBy(_this__u8e3s4, horizontalCollection) {
    var tmp = _this__u8e3s4.qd0();
    var tmp_0 = Companion_getInstance_191();
    tmp.w92(tmp_0.zab(disambiguateBy$lambda(horizontalCollection)));
  }
  function booleanProperty(_this__u8e3s4, placeholder, property) {
    var tmp = Validators_getInstance().y8t();
    return editableText_0(_this__u8e3s4, VOID, placeholder, tmp, VOID, booleanProperty$lambda(property));
  }
  function image(_this__u8e3s4, imageData) {
    var imageCell = new ImageCell();
    PropertyBinding_instance.n30(imageData, imageCell.z8w());
    asInternalEditorBuilder(_this__u8e3s4).od0(imageCell);
    return imageCell;
  }
  function indentLabel$2$prevIsPlaceholder$1($this_textCell) {
    this.rd0_1 = $this_textCell;
  }
  protoOf(indentLabel$2$prevIsPlaceholder$1).l5u = function (context) {
    return prevCellIsPlaceholderOrNone(context, this.rd0_1.qd0());
  };
  function indentLabel$lambda$lambda_1($prevIsPlaceholder) {
    return function () {
      return $prevIsPlaceholder.w2w();
    };
  }
  function indentLabel$lambda$lambda_2($allowLast) {
    return function () {
      return $allowLast;
    };
  }
  function indentLabel$2$$inlined$writableProperty$1($traitDisposable, $this_textCell) {
    this.sd0_1 = $traitDisposable;
    this.td0_1 = $this_textCell;
  }
  protoOf(indentLabel$2$$inlined$writableProperty$1).x9j = function (newValue) {
    var tmp0_safe_receiver = this.sd0_1._v;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.zr();
    }
    if (newValue) {
      this.sd0_1._v = this.td0_1.qd0().w92(TextEditing_getInstance().m9a(true, false));
    }
    return Unit_instance;
  };
  protoOf(indentLabel$2$$inlined$writableProperty$1).d2x = function (newValue) {
    return this.x9j((newValue == null ? true : !(newValue == null)) ? newValue : THROW_CCE());
  };
  function indentLabel$lambda_0($text, $allowLast) {
    return function ($this$textCell) {
      var tmp;
      var tmp_0;
      // Inline function 'kotlin.text.isNotEmpty' call
      var this_0 = $text;
      if (charSequenceLength(this_0) > 0) {
        tmp_0 = get_internalConfig($this$textCell).nd0().wct_1;
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        var prevIsPlaceholder = new EagerInvalidatable(new indentLabel$2$prevIsPlaceholder$1($this$textCell));
        if ($allowLast || $text.length > 1) {
          $this$textCell.qd0().p92().f2x(true);
          var tmp_1 = $this$textCell.qd0();
          var tmp_2 = TextEditing_getInstance();
          var tmp_3 = indentLabel$lambda$lambda_1(prevIsPlaceholder);
          tmp_1.w92(tmp_2.oa6(tmp_3, indentLabel$lambda$lambda_2($allowLast)));
        } else {
          var traitDisposable = {_v: null};
          $this$textCell.l8b(syncOneWay(prevIsPlaceholder, $this$textCell.qd0().p92()));
          // Inline function 'jetbrains.ocelot.base.observable.property.writableProperty' call
          var tmp$ret$1 = new indentLabel$2$$inlined$writableProperty$1(traitDisposable, $this$textCell);
          $this$textCell.l8b(syncOneWay(prevIsPlaceholder, tmp$ret$1));
        }
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function isEmpty$ref_1() {
    var l = function (p0) {
      // Inline function 'kotlin.text.isEmpty' call
      return charSequenceLength(p0) === 0;
    };
    l.callableName = 'isEmpty';
    return l;
  }
  function placeholderInCollection$lambda$lambda_0($this_editableText, $collectionItemCompletion) {
    return function (mapper) {
      var commonConfig = get_internalConfig($this_editableText).ud0();
      var coroutineScope = commonConfig;
      var wrapperContext = get_internalConfig($this_editableText).l6z();
      var resolveConfig = commonConfig;
      var roleCompletion = buildRoleCompletion(null, coroutineScope, wrapperContext, resolveConfig, $collectionItemCompletion);
      return getCollectionPlaceholderCompletionSupplier(mapper, roleCompletion);
    };
  }
  function placeholderInCollection$lambda_0($collectionItemCompletion) {
    return function ($this$editableText) {
      attachCompletion($this$editableText, placeholderInCollection$lambda$lambda_0($this$editableText, $collectionItemCompletion));
      return Unit_instance;
    };
  }
  function considerEmptyBy$1($this_considerEmptyBy) {
    this.vd0_1 = $this_considerEmptyBy;
    CellTrait.call(this);
  }
  protoOf(considerEmptyBy$1).i8y = function (cell, spec, event) {
    if (spec === Cells_getInstance().g9t_1) {
      var derivedBecameEmpty = new DerivedEvent(event);
      this.vd0_1.qd0().v92(derivedBecameEmpty, Cells_getInstance().g9t_1);
    } else {
      protoOf(CellTrait).i8y.call(this, cell, spec, event);
    }
  };
  protoOf(considerEmptyBy$1).n91 = function (cell, spec) {
    var tmp;
    if (spec === ProjectionalSynchronizers_getInstance().f99_1) {
      tmp = true;
    } else {
      tmp = protoOf(CellTrait).n91.call(this, cell, spec);
    }
    return tmp;
  };
  function rightTransform$2$$inlined$propertyTrait$1_0($propSpec, $cell, $init, $this_rightTransform, $cellFinder) {
    this.wd0_1 = $propSpec;
    this.xd0_1 = $cell;
    this.yd0_1 = $init;
    this.zd0_1 = $this_rightTransform;
    this.ad1_1 = $cellFinder;
    CellTrait.call(this);
  }
  protoOf(rightTransform$2$$inlined$propertyTrait$1_0).n91 = function (cell, spec) {
    var tmp;
    if (spec === this.wd0_1) {
      var builder = new CompletionBuilderImpl(coroutineScope_0(ensureNotNull(this.xd0_1.s8x())));
      this.yd0_1(builder, this.zd0_1.m6d(), this.xd0_1, this.ad1_1);
      tmp = builder.jcf();
    } else {
      tmp = protoOf(CellTrait).n91.call(this, cell, spec);
    }
    return tmp;
  };
  function rightTransform$lambda_0($this_rightTransform, $cell, $init) {
    return function (_unused_var__etf5q3, _unused_var__etf5q3_0, cellFinder) {
      var tmp;
      if (get_internalConfig($this_rightTransform).acu()) {
        tmp = Companion_getInstance_186().wa8_1;
      } else {
        // Inline function 'jetbrains.ocelot.projectional.cell.trait.propertyTrait' call
        var propSpec = CompoundSideTransformTrait_getInstance().ecu_1;
        tmp = new rightTransform$2$$inlined$propertyTrait$1_0(propSpec, $cell, $init, $this_rightTransform, cellFinder);
      }
      return tmp;
    };
  }
  function bigDecimalValidator$ref_1() {
    var l = function (p0) {
      return bigDecimalValidator(p0);
    };
    l.callableName = 'bigDecimalValidator';
    return l;
  }
  function decimalProperty$lambda$lambda(it) {
    return it.m2a();
  }
  function decimalProperty$lambda_1($property) {
    return function ($this$editableText) {
      var tmp;
      switch (get_internalConfig($this$editableText).nd0().uct_1.x2_1) {
        case 0:
          // Inline function 'jetbrains.ocelot.langDef.editor.values.decimalSyncTwoWay' call

          // Inline function 'jetbrains.ocelot.langDef.editorBuilder.textCellSyncTwoWay' call

          var sourceProp = $property($this$editableText.m6d());
          var p0 = $this$editableText.qd0();
          var targetProp = decimalProperty_0(p0);
          $this$editableText.l8b(syncTwoWay(sourceProp.m5y(), targetProp));
          tmp = Unit_instance;
          break;
        case 1:
          // Inline function 'jetbrains.ocelot.langDef.editor.values.decimalSyncOneWay' call

          var sourceProp_0 = $property($this$editableText.m6d());
          var tmp_0 = sourceProp_0.m5y();
          $this$editableText.l8b(syncOneWay(map_0(tmp_0, decimalProperty$lambda$lambda), $this$editableText.qd0().o8w()));
          tmp = Unit_instance;
          break;
        default:
          $this$editableText.qd0().o8w().f2x($property($this$editableText.m6d()).m5y().w2w().m2a());
          tmp = Unit_instance;
          break;
      }
      return Unit_instance;
    };
  }
  function integerProperty$lambda$lambda(it) {
    return '' + it;
  }
  function integerProperty$lambda_0($property) {
    return function ($this$editableText) {
      var tmp;
      switch (get_internalConfig($this$editableText).nd0().uct_1.x2_1) {
        case 0:
          // Inline function 'jetbrains.ocelot.langDef.editorBuilder.intSyncTwoWay' call

          // Inline function 'jetbrains.ocelot.langDef.editorBuilder.textCellSyncTwoWay' call

          var sourceProp = $property($this$editableText.m6d());
          var p0 = $this$editableText.qd0();
          var targetProp = ValueEditors_instance.wag(p0);
          $this$editableText.l8b(syncTwoWay(sourceProp.m5y(), targetProp));
          tmp = Unit_instance;
          break;
        case 1:
          // Inline function 'jetbrains.ocelot.langDef.editorBuilder.intSyncOneWay' call

          var sourceProp_0 = $property($this$editableText.m6d());
          var tmp_0 = sourceProp_0.m5y();
          $this$editableText.l8b(syncOneWay(map_0(tmp_0, integerProperty$lambda$lambda), $this$editableText.qd0().o8w()));
          tmp = Unit_instance;
          break;
        default:
          $this$editableText.qd0().o8w().f2x($property($this$editableText.m6d()).m5y().w2w().toString());
          tmp = Unit_instance;
          break;
      }
      return Unit_instance;
    };
  }
  function disambiguateBy$lambda($horizontalCollection) {
    return function (_unused_var__etf5q3, outermostLeaf) {
      return isDescendant($horizontalCollection, outermostLeaf);
    };
  }
  function booleanProperty$lambda$lambda(it) {
    return '' + it;
  }
  function booleanProperty$lambda($property) {
    return function ($this$editableText) {
      var tmp;
      switch (get_internalConfig($this$editableText).nd0().uct_1.x2_1) {
        case 0:
          // Inline function 'jetbrains.ocelot.langDef.editorBuilder.booleanSyncTwoWay' call

          // Inline function 'jetbrains.ocelot.langDef.editorBuilder.textCellSyncTwoWay' call

          var sourceProp = $property($this$editableText.m6d());
          var p0 = $this$editableText.qd0();
          var targetProp = ValueEditors_instance.vag(p0);
          $this$editableText.l8b(syncTwoWay(sourceProp.m5y(), targetProp));
          tmp = Unit_instance;
          break;
        case 1:
          // Inline function 'jetbrains.ocelot.langDef.editorBuilder.booleanSyncOneWay' call

          var sourceProp_0 = $property($this$editableText.m6d());
          var tmp_0 = sourceProp_0.m5y();
          $this$editableText.l8b(syncOneWay(map_0(tmp_0, booleanProperty$lambda$lambda), $this$editableText.qd0().o8w()));
          tmp = Unit_instance;
          break;
        default:
          $this$editableText.qd0().o8w().f2x($property($this$editableText.m6d()).m5y().w2w().toString());
          tmp = Unit_instance;
          break;
      }
      return Unit_instance;
    };
  }
  function mark_0(_this__u8e3s4, mark) {
    return mark.cd1(_this__u8e3s4);
  }
  function Companion_249() {
    Companion_instance_249 = this;
    this.dd1_1 = CellTraitPropertySpec_init_$Create$('cellMark', null);
  }
  var Companion_instance_249;
  function Companion_getInstance_249() {
    if (Companion_instance_249 == null)
      new Companion_249();
    return Companion_instance_249;
  }
  function CellMark$trait$1(this$0) {
    this.ed1_1 = this$0;
    CellTrait.call(this);
  }
  protoOf(CellMark$trait$1).n91 = function (cell, spec) {
    var tmp;
    if (equals(spec, Companion_getInstance_249().dd1_1)) {
      tmp = this.ed1_1;
    } else {
      tmp = protoOf(CellTrait).n91.call(this, cell, spec);
    }
    return tmp;
  };
  function CellMark() {
    Companion_getInstance_249();
    var tmp = this;
    tmp.bd1_1 = new CellMark$trait$1(this);
  }
  protoOf(CellMark).cd1 = function (cell) {
    cell.w92(this.bd1_1);
  };
  protoOf(CellMark).fd1 = function (cell) {
    return equals(cell.c93(Companion_getInstance_249().dd1_1), this);
  };
  function find_2(_this__u8e3s4, mark) {
    var tmp0 = get_descendants(_this__u8e3s4);
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var _iterator__ex2g4s = tmp0.m();
      while (_iterator__ex2g4s.n()) {
        var element = _iterator__ex2g4s.o();
        if (mark.fd1(element)) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    return tmp$ret$1;
  }
  function children_2(_this__u8e3s4, sourceClass, contextLink, placeholderText, placeholderTraitFactory, separator, itemFactory, pasteHandler, onLastItemDeleted, layout, sourceListRole) {
    contextLink = contextLink === VOID ? null : contextLink;
    placeholderText = placeholderText === VOID ? null : placeholderText;
    var tmp;
    if (placeholderTraitFactory === VOID) {
      tmp = children$lambda_1;
    } else {
      tmp = placeholderTraitFactory;
    }
    placeholderTraitFactory = tmp;
    separator = separator === VOID ? null : separator;
    itemFactory = itemFactory === VOID ? null : itemFactory;
    pasteHandler = pasteHandler === VOID ? null : pasteHandler;
    onLastItemDeleted = onLastItemDeleted === VOID ? null : onLastItemDeleted;
    layout = layout === VOID ? Layout_INDENT_getInstance() : layout;
    var tmp_0;
    switch (layout.x2_1) {
      case 0:
        tmp_0 = indent_0(_this__u8e3s4, VOID, VOID, children$lambda_2(sourceClass, contextLink, placeholderText, placeholderTraitFactory, separator, itemFactory, pasteHandler, onLastItemDeleted, sourceListRole));
        break;
      case 1:
        tmp_0 = horizontal_0(_this__u8e3s4, children$lambda_3(sourceClass, contextLink, placeholderText, placeholderTraitFactory, separator, itemFactory, pasteHandler, onLastItemDeleted, sourceListRole));
        break;
      case 2:
        tmp_0 = vertical(_this__u8e3s4, children$lambda_4(sourceClass, contextLink, placeholderText, placeholderTraitFactory, separator, itemFactory, pasteHandler, onLastItemDeleted, sourceListRole));
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp_0;
  }
  var Layout_INDENT_instance;
  var Layout_HORIZONTAL_instance;
  var Layout_VERTICAL_instance;
  var Layout_entriesInitialized;
  function Layout_initEntries() {
    if (Layout_entriesInitialized)
      return Unit_instance;
    Layout_entriesInitialized = true;
    Layout_INDENT_instance = new Layout('INDENT', 0);
    Layout_HORIZONTAL_instance = new Layout('HORIZONTAL', 1);
    Layout_VERTICAL_instance = new Layout('VERTICAL', 2);
  }
  function Layout(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function child_1(_this__u8e3s4, sourceClass, role, placeholderText, placeholderTraitFactory, itemFactory, pasteHandler, onLastItemDeleted, canClear, contextLink, completionSupplier) {
    placeholderText = placeholderText === VOID ? null : placeholderText;
    var tmp;
    if (placeholderTraitFactory === VOID) {
      tmp = child$lambda_1;
    } else {
      tmp = placeholderTraitFactory;
    }
    placeholderTraitFactory = tmp;
    itemFactory = itemFactory === VOID ? null : itemFactory;
    pasteHandler = pasteHandler === VOID ? null : pasteHandler;
    onLastItemDeleted = onLastItemDeleted === VOID ? null : onLastItemDeleted;
    canClear = canClear === VOID ? null : canClear;
    contextLink = contextLink === VOID ? null : contextLink;
    completionSupplier = completionSupplier === VOID ? null : completionSupplier;
    var roleWithCell = child$lambda_2(role);
    var editorRegistry = get_internalConfig(_this__u8e3s4).gd1();
    var tmp_0;
    if (contextLink == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_0 = new ChildContext(_this__u8e3s4.m6d(), contextLink);
    }
    var childContext = tmp_0;
    var roleSpec = editorRegistry.hd1(sourceClass, childContext, placeholderText, itemFactory, pasteHandler, onLastItemDeleted, canClear, completionSupplier);
    return extendedChild(_this__u8e3s4, roleSpec, roleWithCell, placeholderTraitFactory);
  }
  function buildChildren(_this__u8e3s4, sourceClass, contextLink, placeholderText, placeholderTraitFactory, collectionSeparator, itemFactory, pasteHandler, onLastItemDeleted, sourceListRole) {
    placeholderText = placeholderText === VOID ? null : placeholderText;
    var tmp;
    if (placeholderTraitFactory === VOID) {
      tmp = buildChildren$lambda;
    } else {
      tmp = placeholderTraitFactory;
    }
    placeholderTraitFactory = tmp;
    collectionSeparator = collectionSeparator === VOID ? null : collectionSeparator;
    itemFactory = itemFactory === VOID ? null : itemFactory;
    pasteHandler = pasteHandler === VOID ? null : pasteHandler;
    onLastItemDeleted = onLastItemDeleted === VOID ? null : onLastItemDeleted;
    var editorRegistry = get_internalConfig(_this__u8e3s4).gd1();
    var tmp_0;
    if (contextLink == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_0 = new ChildContext(_this__u8e3s4.m6d(), contextLink);
    }
    var childContext = tmp_0;
    var roleSpec = editorRegistry.id1(sourceClass, childContext, placeholderText, collectionSeparator, itemFactory, pasteHandler, onLastItemDeleted);
    var cellChildren = _this__u8e3s4.qd0().o35();
    var separator = roleSpec.qd1_1;
    var tmp2_elvis_lhs = separator == null ? null : separator.rd1(cellChildren);
    var targetList = tmp2_elvis_lhs == null ? cellChildren : tmp2_elvis_lhs;
    var sourceList = sourceListRole(_this__u8e3s4.m6d());
    var mapperFactoryFunction = roleSpec.zd1();
    if (get_internalConfig(_this__u8e3s4).acu()) {
      _this__u8e3s4.l8b(ReadOnlyProjectionalSynchronizers_instance.oau(sourceList.m5y(), _this__u8e3s4.qd0(), targetList, mapperFactoryFunction, roleSpec.ud1_1, get_internalConfig(_this__u8e3s4).nd0().wct_1, roleSpec.wd1_1));
    } else {
      var tmp_1;
      if (!_this__u8e3s4.ld0().ad2()) {
        tmp_1 = buildChildren$lambda_0(placeholderTraitFactory);
      } else {
        tmp_1 = placeholderTraitFactory;
      }
      var finalPlaceholderTraitFactory = tmp_1;
      var tmp_2 = new ProjectionalListSynchronizerSettings();
      var tmp_3 = tmp_2.paq(buildChildren$lambda_1);
      var settings = tmp_3.qaq(buildChildren$lambda_2(finalPlaceholderTraitFactory, _this__u8e3s4));
      settings.saq(roleSpec.ud1_1);
      settings.raq(buildChildren$lambda_3);
      if (separator instanceof StringSeparator) {
        separatorSideTransform(separator.bd2_1, settings);
      }
      var synchronizer = ProjectionalSynchronizers_getInstance().hau(sourceList.m5y(), _this__u8e3s4.qd0(), targetList, mapperFactoryFunction, settings);
      setRoleSpec(synchronizer, roleSpec);
      _this__u8e3s4.l8b(synchronizer);
    }
  }
  function extendedChild(_this__u8e3s4, roleSpec, role, placeholderTraitFactory, before, after) {
    var tmp;
    if (placeholderTraitFactory === VOID) {
      tmp = extendedChild$lambda;
    } else {
      tmp = placeholderTraitFactory;
    }
    placeholderTraitFactory = tmp;
    var tmp_0;
    if (before === VOID) {
      tmp_0 = extendedChild$lambda_0;
    } else {
      tmp_0 = before;
    }
    before = tmp_0;
    var tmp_1;
    if (after === VOID) {
      tmp_1 = extendedChild$lambda_1;
    } else {
      tmp_1 = after;
    }
    after = tmp_1;
    return indent_0(_this__u8e3s4, VOID, VOID, extendedChild$lambda_2(before, role, roleSpec, placeholderTraitFactory, after));
  }
  function separatorSideTransform(separator, settings) {
    settings.oaq(separatorSideTransform$lambda(separator));
  }
  function setRoleSpec(_this__u8e3s4, roleSpec) {
    var roleCompletion = roleSpec.vd1_1;
    if (!(roleCompletion == null)) {
      _this__u8e3s4.jao(roleCompletion);
    }
    var itemFactory = roleSpec.td1_1;
    if (!(itemFactory == null)) {
      var itemHandler = Companion_instance_200.vap(itemFactory);
      _this__u8e3s4.san(itemHandler);
    }
    if (!(roleSpec.yd1_1 == null)) {
      _this__u8e3s4.qan(roleSpec.yd1_1);
    }
    var clipboardParameters = roleSpec.wd1_1;
    if (!(clipboardParameters == null)) {
      _this__u8e3s4.qam().maw(clipboardParameters);
    }
    var tmp0_safe_receiver = roleSpec.xd1_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      _this__u8e3s4.oao(tmp0_safe_receiver);
    }
  }
  function children$lambda_1(_unused_var__etf5q3, trait) {
    return trait;
  }
  function children$lambda_2($sourceClass, $contextLink, $placeholderText, $placeholderTraitFactory, $separator, $itemFactory, $pasteHandler, $onLastItemDeleted, $sourceListRole) {
    return function ($this$indent) {
      buildChildren($this$indent, $sourceClass, $contextLink, $placeholderText, $placeholderTraitFactory, $separator, $itemFactory, $pasteHandler, $onLastItemDeleted, $sourceListRole);
      return Unit_instance;
    };
  }
  function children$lambda_3($sourceClass, $contextLink, $placeholderText, $placeholderTraitFactory, $separator, $itemFactory, $pasteHandler, $onLastItemDeleted, $sourceListRole) {
    return function ($this$horizontal) {
      buildChildren($this$horizontal, $sourceClass, $contextLink, $placeholderText, $placeholderTraitFactory, $separator, $itemFactory, $pasteHandler, $onLastItemDeleted, $sourceListRole);
      return Unit_instance;
    };
  }
  function children$lambda_4($sourceClass, $contextLink, $placeholderText, $placeholderTraitFactory, $separator, $itemFactory, $pasteHandler, $onLastItemDeleted, $sourceListRole) {
    return function ($this$vertical) {
      buildChildren($this$vertical, $sourceClass, $contextLink, $placeholderText, $placeholderTraitFactory, $separator, $itemFactory, $pasteHandler, $onLastItemDeleted, $sourceListRole);
      return Unit_instance;
    };
  }
  function child$lambda_1(_unused_var__etf5q3, trait) {
    return trait;
  }
  function child$lambda_2($role) {
    return function (source, _unused_var__etf5q3) {
      return $role(source);
    };
  }
  function buildChildren$lambda(_unused_var__etf5q3, trait) {
    return trait;
  }
  function buildChildren$lambda_0($placeholderTraitFactory) {
    return function (source, trait) {
      return CompositeCellTraits_instance.ra6([get_spaceDoesntCloseCompletion(), $placeholderTraitFactory(source, trait)]);
    };
  }
  function buildChildren$lambda_1(it) {
    return false;
  }
  function buildChildren$lambda_2($finalPlaceholderTraitFactory, $this_buildChildren) {
    return function (trait) {
      return $finalPlaceholderTraitFactory($this_buildChildren.m6d(), trait);
    };
  }
  function buildChildren$lambda_3() {
    return LeafCellTrackingTrait_getInstance();
  }
  function extendedChild$lambda(_unused_var__etf5q3, trait) {
    return trait;
  }
  function extendedChild$lambda_0(_this__u8e3s4) {
    return Unit_instance;
  }
  function extendedChild$lambda_1(_this__u8e3s4) {
    return Unit_instance;
  }
  function extendedChild$lambda$lambda($placeholderTraitFactory) {
    return function (source, trait) {
      return CompositeCellTraits_instance.ra6([get_spaceDoesntCloseCompletion(), $placeholderTraitFactory(source, trait)]);
    };
  }
  function extendedChild$lambda$lambda_0($finalPlaceholderTraitFactory, $this_indent) {
    return function (trait) {
      return $finalPlaceholderTraitFactory($this_indent.m6d(), trait);
    };
  }
  function extendedChild$lambda$lambda_1() {
    return LeafCellTrackingTrait_getInstance();
  }
  function extendedChild$lambda_2($before, $role, $roleSpec, $placeholderTraitFactory, $after) {
    return function ($this$indent) {
      $before($this$indent);
      var sourceProp = $role($this$indent.m6d(), $this$indent.qd0());
      var mapperFactoryFunction = $roleSpec.zd1();
      var tmp;
      if (get_internalConfig($this$indent).acu()) {
        $this$indent.l8b(ReadOnlyProjectionalSynchronizers_instance.pau($role($this$indent.m6d(), $this$indent.qd0()).m5y(), $this$indent.qd0(), mapperFactoryFunction, $roleSpec.ud1_1, get_internalConfig($this$indent).nd0().wct_1, $roleSpec.wd1_1));
        tmp = Unit_instance;
      } else {
        var tmp_0;
        if (!$this$indent.ld0().ad2()) {
          tmp_0 = extendedChild$lambda$lambda($placeholderTraitFactory);
        } else {
          tmp_0 = $placeholderTraitFactory;
        }
        var finalPlaceholderTraitFactory = tmp_0;
        var tmp_1 = new ProjectionalPropertySynchronizerSettings();
        var tmp_2 = tmp_1.qaq(extendedChild$lambda$lambda_0(finalPlaceholderTraitFactory, $this$indent));
        var settings = tmp_2.raq(extendedChild$lambda$lambda_1).saq($roleSpec.ud1_1).fau($roleSpec.kd2_1);
        var synchronizer = ProjectionalSynchronizers_getInstance().iau(sourceProp.m5y(), $this$indent.qd0(), mapperFactoryFunction, settings);
        setRoleSpec(synchronizer, $roleSpec);
        $this$indent.l8b(synchronizer);
        tmp = Unit_instance;
      }
      $after($this$indent);
      return Unit_instance;
    };
  }
  function separatorSideTransform$lambda$o$get$lambda($createHandle, $cell) {
    return function () {
      return $createHandle.zap($cell);
    };
  }
  function separatorSideTransform$2$$inlined$propertyFromCellTrait$1($propSpec, $separator, $createHandle) {
    this.ld2_1 = $propSpec;
    this.md2_1 = $separator;
    this.nd2_1 = $createHandle;
    CellTrait.call(this);
  }
  protoOf(separatorSideTransform$2$$inlined$propertyFromCellTrait$1).n91 = function (cell, spec) {
    var tmp;
    if (spec === this.ld2_1) {
      var separatorSideTransform = completes(this.md2_1, separatorSideTransform$lambda$o$get$lambda(this.nd2_1, cell));
      tmp = simpleCompletionSupplier([separatorSideTransform]);
    } else {
      tmp = protoOf(CellTrait).n91.call(this, cell, spec);
    }
    return tmp;
  };
  function separatorSideTransform$lambda($separator) {
    return function (createHandle) {
      // Inline function 'jetbrains.ocelot.projectional.cell.trait.propertyFromCellTrait' call
      var propSpec = CompoundSideTransformTrait_getInstance().ecu_1;
      return new separatorSideTransform$2$$inlined$propertyFromCellTrait$1(propSpec, $separator, createHandle);
    };
  }
  function Layout_INDENT_getInstance() {
    Layout_initEntries();
    return Layout_INDENT_instance;
  }
  function Layout_HORIZONTAL_getInstance() {
    Layout_initEntries();
    return Layout_HORIZONTAL_instance;
  }
  function Layout_VERTICAL_getInstance() {
    Layout_initEntries();
    return Layout_VERTICAL_instance;
  }
  function asInternalEditorBuilder(_this__u8e3s4) {
    return isInterface(_this__u8e3s4, InternalEditorBuilder) ? _this__u8e3s4 : THROW_CCE();
  }
  function EditorMapperFactoryImpl(editorRegistry) {
    this.od2_1 = editorRegistry;
  }
  protoOf(EditorMapperFactoryImpl).pd2 = function (source, sourceClass) {
    var mapperFactory = this.od2_1.qd2(sourceClass);
    return mapperFactory.rd2(source);
  };
  function editorSetup(editorDefinitions, conceptRegistry, builderConfigFactory) {
    var editorRegistry = new EditorRegistryImpl(editorDefinitions, conceptRegistry);
    editorRegistry.zd2(builderConfigFactory(editorRegistry));
    return new EditorMapperFactoryImpl(editorRegistry);
  }
  function addTraitOnAttach_0(_this__u8e3s4, traitFactory) {
    addTraitOnAttach_1(_this__u8e3s4, _this__u8e3s4.qd0(), traitFactory);
  }
  function attachCompletion(_this__u8e3s4, init) {
    var tmp = _this__u8e3s4.qd0();
    var sync = createOnAttachSynchronizer(tmp, attachCompletion$lambda(_this__u8e3s4, init));
    _this__u8e3s4.l8b(sync);
  }
  function addTraitOnAttach_1(_this__u8e3s4, subCell, traitFactory) {
    var tmp = _this__u8e3s4.m6d();
    var sync = createOnAttachSynchronizer_0(tmp, subCell, addTraitOnAttach$lambda_0(traitFactory));
    _this__u8e3s4.l8b(sync);
  }
  function createOnAttachSynchronizer(cell, traitFactory) {
    return new createOnAttachSynchronizer$1(cell, traitFactory);
  }
  function createOnAttachSynchronizer_0(source, cell, traitFactory) {
    return createOnAttachSynchronizer(cell, createOnAttachSynchronizer$lambda(traitFactory, source, cell));
  }
  function attachCompletion$2$$inlined$propertyTrait$2($propSpec, $init, $mapper) {
    this.ad3_1 = $propSpec;
    this.bd3_1 = $init;
    this.cd3_1 = $mapper;
    CellTrait.call(this);
  }
  protoOf(attachCompletion$2$$inlined$propertyTrait$2).n91 = function (cell, spec) {
    var tmp;
    if (spec === this.ad3_1) {
      tmp = this.bd3_1(this.cd3_1);
    } else {
      tmp = protoOf(CellTrait).n91.call(this, cell, spec);
    }
    return tmp;
  };
  function attachCompletion$lambda($this_attachCompletion, $init) {
    return function (mappingContext) {
      var tmp0 = mappingContext.f8a($this_attachCompletion.m6d());
      var tmp$ret$1;
      $l$block: {
        // Inline function 'kotlin.collections.firstOrNull' call
        var _iterator__ex2g4s = tmp0.m();
        while (_iterator__ex2g4s.n()) {
          var element = _iterator__ex2g4s.o();
          var tmp = element.f86_1;
          if (!(tmp == null) ? isInterface(tmp, Cell) : false) {
            tmp$ret$1 = element;
            break $l$block;
          }
        }
        tmp$ret$1 = null;
      }
      var mapper = ensureNotNull(tmp$ret$1);
      if (!(mapper instanceof Mapper))
        THROW_CCE();
      // Inline function 'jetbrains.ocelot.projectional.cell.trait.propertyTrait' call
      var propSpec = Completion_getInstance().u9d_1;
      return new attachCompletion$2$$inlined$propertyTrait$2(propSpec, $init, mapper);
    };
  }
  function addTraitOnAttach$lambda_0($traitFactory) {
    return function (source, cell, cellFinder) {
      return $traitFactory(source, cell, cellFinder);
    };
  }
  function createOnAttachSynchronizer$1($cell, $traitFactory) {
    this.ed3_1 = $cell;
    this.fd3_1 = $traitFactory;
    DisposableSynchronizer.call(this);
  }
  protoOf(createOnAttachSynchronizer$1).s87 = function (ctx) {
    return this.ed3_1.w92(this.fd3_1(ctx.b88()));
  };
  function createOnAttachSynchronizer$lambda($traitFactory, $source, $cell) {
    return function (mappingContext) {
      var cellFinder = getMapperCellFinder(mappingContext);
      return $traitFactory($source, $cell, cellFinder);
    };
  }
  function getDebugIdText(_this__u8e3s4) {
    return take_1(get_stringId(_this__u8e3s4), 4);
  }
  function textProperty_0(_this__u8e3s4, placeholder, property, init) {
    var tmp;
    if (init === VOID) {
      tmp = textProperty$lambda_0;
    } else {
      tmp = init;
    }
    init = tmp;
    return editableText_0(_this__u8e3s4, VOID, placeholder, VOID, VOID, textProperty$lambda_1(property, init));
  }
  function editableText_0(_this__u8e3s4, text, placeholderText, validator, readOnly, init) {
    text = text === VOID ? '' : text;
    placeholderText = placeholderText === VOID ? null : placeholderText;
    validator = validator === VOID ? null : validator;
    readOnly = readOnly === VOID ? false : readOnly;
    var tmp;
    if (init === VOID) {
      tmp = editableText$lambda_3;
    } else {
      tmp = init;
    }
    init = tmp;
    var mainTextCell = textCell_0(_this__u8e3s4, text, editableText$lambda_4(readOnly, validator, init));
    if (!(placeholderText == null)) {
      placeholder_2(_this__u8e3s4, placeholderText, mainTextCell);
    }
    return mainTextCell;
  }
  function textProperty$lambda_0(_this__u8e3s4) {
    return Unit_instance;
  }
  function textProperty$lambda_1($property, $init) {
    return function ($this$editableText) {
      var tmp;
      switch (get_internalConfig($this$editableText).nd0().uct_1.x2_1) {
        case 0:
          // Inline function 'jetbrains.ocelot.langDef.editorBuilder.textSyncTwoWay' call

          // Inline function 'jetbrains.ocelot.langDef.editorBuilder.textCellSyncTwoWay' call

          var sourceProp = $property($this$editableText.m6d());
          var targetProp = $this$editableText.qd0().o8w();
          $this$editableText.l8b(syncTwoWay(sourceProp.m5y(), targetProp));
          tmp = Unit_instance;
          break;
        case 1:
          // Inline function 'jetbrains.ocelot.langDef.editorBuilder.textSyncTwoWay' call

          // Inline function 'jetbrains.ocelot.langDef.editorBuilder.textCellSyncTwoWay' call

          var sourceProp_0 = $property($this$editableText.m6d());
          var targetProp_0 = $this$editableText.qd0().o8w();
          $this$editableText.l8b(syncTwoWay(sourceProp_0.m5y(), targetProp_0));
          tmp = Unit_instance;
          break;
        default:
          $this$editableText.qd0().o8w().f2x($property($this$editableText.m6d()).m5y().w2w());
          tmp = Unit_instance;
          break;
      }
      $init($this$editableText);
      return Unit_instance;
    };
  }
  function editableText$lambda_3(_this__u8e3s4) {
    return Unit_instance;
  }
  function editableText$lambda_4($readOnly, $validator, $init) {
    return function ($this$textCell) {
      $this$textCell.qd0().p92().f2x(get_internalConfig($this$textCell).nd0().wct_1);
      var tmp;
      if (get_internalConfig($this$textCell).nd0().uct_1.equals(SourceMode_EDITABLE_getInstance()) && !$readOnly) {
        var trait = $validator == null ? TextEditing_getInstance().sa6() : TextEditing_getInstance().ta6($validator);
        $this$textCell.qd0().w92(trait);
        $this$textCell.qd0().w92(LeafCellTrackingTrait_getInstance());
        tmp = Unit_instance;
      } else if (get_internalConfig($this$textCell).nd0().wct_1) {
        $this$textCell.qd0().w92(TextEditing_getInstance().qa6());
        tmp = Unit_instance;
      }
      $init($this$textCell);
      return Unit_instance;
    };
  }
  function multilineText(_this__u8e3s4, placeholder, textSpecification, text, textStyle) {
    var tmp;
    if (textStyle === VOID) {
      tmp = multilineText$lambda;
    } else {
      tmp = textStyle;
    }
    textStyle = tmp;
    var tmp_0;
    if (get_internalConfig(_this__u8e3s4).nd0().uct_1.equals(SourceMode_STATIC_getInstance()) && !get_internalConfig(_this__u8e3s4).nd0().wct_1) {
      var textNode = text(_this__u8e3s4.m6d()).m5y().w2w();
      var tmp_1;
      if (textNode == null) {
        tmp_1 = null;
      } else {
        // Inline function 'kotlin.let' call
        tmp_1 = staticMultilineText(textSpecification, textStyle, textNode);
      }
      var tmp1_elvis_lhs = tmp_1;
      var tmp_2;
      if (tmp1_elvis_lhs == null) {
        var tmp_3 = TextCell_init_$Create$();
        tmp_2 = placeholder_0(tmp_3, placeholder == null ? '<empty>' : placeholder);
      } else {
        tmp_2 = tmp1_elvis_lhs;
      }
      tmp_0 = tmp_2;
    } else {
      var syncFactory = new MultilineTextSynchronizerFactory(textSpecification, textStyle, get_internalConfig(_this__u8e3s4).gd3(), get_internalConfig(_this__u8e3s4).l6z(), get_internalConfig(_this__u8e3s4).hd3(), VOID, get_internalConfig(_this__u8e3s4).acu(), get_internalConfig(_this__u8e3s4).nd0().wct_1);
      var _destruct__k2r9zo = syncFactory.fcx(text(_this__u8e3s4.m6d()).m5y(), placeholder);
      var synchronizer = _destruct__k2r9zo.fg();
      var cell = _destruct__k2r9zo.gg();
      _this__u8e3s4.l8b(synchronizer);
      tmp_0 = cell;
    }
    var cell_0 = tmp_0;
    asInternalEditorBuilder(_this__u8e3s4).od0(cell_0);
    return cell_0;
  }
  function TextSpecification(linesRole, textProperty) {
    this.icv_1 = linesRole;
    this.jcv_1 = textProperty;
  }
  protoOf(TextSpecification).toString = function () {
    return 'TextSpecification(linesRole=' + this.icv_1.toString() + ', textProperty=' + this.jcv_1.toString() + ')';
  };
  protoOf(TextSpecification).hashCode = function () {
    var result = this.icv_1.hashCode();
    result = imul(result, 31) + this.jcv_1.hashCode() | 0;
    return result;
  };
  protoOf(TextSpecification).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TextSpecification))
      return false;
    if (!this.icv_1.equals(other.icv_1))
      return false;
    if (!this.jcv_1.equals(other.jcv_1))
      return false;
    return true;
  };
  function multilineText$lambda(it) {
    return Unit_instance;
  }
  function ChildRoleDefaults(placeholderText, completionSupplier, itemFactory, canCreateNewItems, canClear) {
    RoleDefaults.call(this, placeholderText, completionSupplier, itemFactory, canCreateNewItems);
    this.md3_1 = canClear;
  }
  function childRoleDefaults(placeholderText, completionSupplier, itemFactory, canCreateNewItems, canClear) {
    placeholderText = placeholderText === VOID ? '<empty>' : placeholderText;
    completionSupplier = completionSupplier === VOID ? null : completionSupplier;
    itemFactory = itemFactory === VOID ? null : itemFactory;
    canCreateNewItems = canCreateNewItems === VOID ? true : canCreateNewItems;
    canClear = canClear === VOID ? true : canClear;
    return new ChildRoleDefaults(placeholderText, completionSupplier, itemFactory, canCreateNewItems, canClear);
  }
  function ChildrenRoleDefaults(newItemClass, placeholderText, itemFactory, separator, completionSupplier, canCreateNewItems) {
    RoleDefaults.call(this, placeholderText, completionSupplier, itemFactory, canCreateNewItems);
    this.rd3_1 = newItemClass;
    this.sd3_1 = separator;
  }
  function get_defaultChildrenSeparator() {
    return NewLineSeparator_getInstance();
  }
  function EditorBuilder() {
  }
  function EditorDefinition(sourceClass, roleDefaults, customCompletion, waitUntilReady, conceptClass, triggerDependencies, init) {
    RoleEditorDefinition.call(this, sourceClass, roleDefaults, customCompletion, waitUntilReady, conceptClass, triggerDependencies, init);
  }
  protoOf(EditorDefinition).dd4 = function () {
    return listOf(this);
  };
  protoOf(EditorDefinition).ed4 = function (conceptRegistry) {
    var tmp;
    if (this.jd4_1) {
      var matchingText = conceptRegistry.m6l(this.fd4_1);
      tmp = listOf(matchingText);
    } else {
      tmp = emptyList();
    }
    return tmp;
  };
  function HierarchyEditorDefinition$_init_$lambda_kestau(_this__u8e3s4) {
    return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
  }
  function HierarchyEditorDefinition(sourceClass, roleDefaults, editorDefinitions) {
    var tmp = emptyList();
    RoleEditorDefinition.call(this, sourceClass, roleDefaults, null, false, true, tmp, HierarchyEditorDefinition$_init_$lambda_kestau);
    this.td4_1 = editorDefinitions;
  }
  protoOf(HierarchyEditorDefinition).dd4 = function () {
    // Inline function 'kotlin.collections.flatMap' call
    var tmp0 = this.td4_1;
    // Inline function 'kotlin.collections.flatMapTo' call
    var destination = ArrayList_init_$Create$();
    var _iterator__ex2g4s = tmp0.m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      var list = element.dd4();
      addAll_1(destination, list);
    }
    return plus_6(destination, this);
  };
  protoOf(HierarchyEditorDefinition).ed4 = function (conceptRegistry) {
    // Inline function 'kotlin.collections.flatMap' call
    var tmp0 = this.td4_1;
    // Inline function 'kotlin.collections.flatMapTo' call
    var destination = ArrayList_init_$Create$();
    var _iterator__ex2g4s = tmp0.m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      var list = element.ed4(conceptRegistry);
      addAll_1(destination, list);
    }
    return destination;
  };
  function InvalidatingEditorBuilder(execution) {
    QueryBuilder.call(this, execution);
  }
  function RoleDefaults(placeholderText, completionSupplier, itemFactory, canCreateNewItems) {
    this.ud4_1 = placeholderText;
    this.vd4_1 = completionSupplier;
    this.wd4_1 = itemFactory;
    this.xd4_1 = canCreateNewItems;
  }
  function RoleEditorDefinition(sourceClass, roleDefaults, customCompletion, waitUntilReady, conceptClass, triggerDependencies, init) {
    this.fd4_1 = sourceClass;
    this.gd4_1 = roleDefaults;
    this.hd4_1 = customCompletion;
    this.id4_1 = waitUntilReady;
    this.jd4_1 = conceptClass;
    this.kd4_1 = triggerDependencies;
    this.ld4_1 = init;
  }
  function maybe($this, _this__u8e3s4) {
    return _this__u8e3s4 ? ' ' : '';
  }
  function StringSeparator(text, leftSpace, rightSpace) {
    CollectionSeparator.call(this);
    this.bd2_1 = text;
    this.cd2_1 = maybe(this, leftSpace) + this.bd2_1 + maybe(this, rightSpace);
  }
  protoOf(StringSeparator).rd1 = function (list) {
    return CellLists_instance.saa(list, this.cd2_1);
  };
  function separator(value, leftSpace, rightSpace) {
    leftSpace = leftSpace === VOID ? false : leftSpace;
    rightSpace = rightSpace === VOID ? true : rightSpace;
    return new StringSeparator(value, leftSpace, rightSpace);
  }
  function EmptyLinesSeparator(linesCount) {
    linesCount = linesCount === VOID ? 1 : linesCount;
    CollectionSeparator.call(this);
    this.yd4_1 = linesCount;
  }
  protoOf(EmptyLinesSeparator).rd1 = function (list) {
    return CellLists_instance.uaa(list, this.yd4_1);
  };
  function blankLine() {
    return new EmptyLinesSeparator();
  }
  function CollectionSeparator() {
  }
  function get_blankLines(_this__u8e3s4) {
    return new EmptyLinesSeparator(_this__u8e3s4);
  }
  function NewLineSeparator() {
    NewLineSeparator_instance = this;
    CollectionSeparator.call(this);
  }
  protoOf(NewLineSeparator).rd1 = function (list) {
    return CellLists_instance.taa(list);
  };
  var NewLineSeparator_instance;
  function NewLineSeparator_getInstance() {
    if (NewLineSeparator_instance == null)
      new NewLineSeparator();
    return NewLineSeparator_instance;
  }
  function EditorBuilderConfigImpl(wrapperContext, conceptRegistry, nodeFactory, nodeAdaptationSupport, splitMergeSupportFactory, editorRegistry, commonConfig, errorCheckConfig, mode, indentNumSpaces, spaceClosesCompletion) {
    this.zd4_1 = wrapperContext;
    this.ad5_1 = conceptRegistry;
    this.bd5_1 = nodeFactory;
    this.cd5_1 = nodeAdaptationSupport;
    this.dd5_1 = splitMergeSupportFactory;
    this.ed5_1 = editorRegistry;
    this.fd5_1 = commonConfig;
    this.gd5_1 = errorCheckConfig;
    this.hd5_1 = mode;
    this.id5_1 = indentNumSpaces;
    this.jd5_1 = spaceClosesCompletion;
  }
  protoOf(EditorBuilderConfigImpl).l6z = function () {
    return this.zd4_1;
  };
  protoOf(EditorBuilderConfigImpl).gd3 = function () {
    return this.ad5_1;
  };
  protoOf(EditorBuilderConfigImpl).kd5 = function () {
    return this.bd5_1;
  };
  protoOf(EditorBuilderConfigImpl).ld5 = function () {
    return this.cd5_1;
  };
  protoOf(EditorBuilderConfigImpl).hd3 = function () {
    return this.dd5_1;
  };
  protoOf(EditorBuilderConfigImpl).gd1 = function () {
    return this.ed5_1;
  };
  protoOf(EditorBuilderConfigImpl).ud0 = function () {
    return this.fd5_1;
  };
  protoOf(EditorBuilderConfigImpl).md5 = function () {
    return this.gd5_1;
  };
  protoOf(EditorBuilderConfigImpl).nd0 = function () {
    return this.hd5_1;
  };
  protoOf(EditorBuilderConfigImpl).md0 = function () {
    return this.id5_1;
  };
  protoOf(EditorBuilderConfigImpl).ad2 = function () {
    return this.jd5_1;
  };
  function getAllEditorDefinitions($this, editorDefinitions) {
    // Inline function 'kotlin.collections.flatMap' call
    // Inline function 'kotlin.collections.flatMapTo' call
    var destination = ArrayList_init_$Create$();
    var _iterator__ex2g4s = editorDefinitions.m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      var list = element.dd4();
      addAll_1(destination, list);
    }
    return destination;
  }
  function _get_editorMap__nnqhs2($this) {
    var tmp = $this.ud2_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('editorMap');
    }
  }
  function _get_roleDefaultsMap__g90zzx($this) {
    var tmp = $this.vd2_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('roleDefaultsMap');
    }
  }
  function _get_exactClasses__7l6rjw($this) {
    var tmp = $this.wd2_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('exactClasses');
    }
  }
  function _get_config__hi7kzb($this) {
    var tmp = $this.xd2_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('config');
    }
  }
  function getEditor($this, sourceClass) {
    var editor = _get_editorMap__nnqhs2($this).q2(sourceClass);
    $l$block: {
      // Inline function 'kotlin.checkNotNull' call
      if (editor == null) {
        var message = 'cannot find editor for: ' + toString_1(sourceClass);
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      } else {
        break $l$block;
      }
    }
    return editor instanceof RoleEditor ? editor : THROW_CCE();
  }
  function toInterfaceClass($this, implClass) {
    var conceptClass = $this.td2_1.n6l(implClass);
    return isInterface(conceptClass, KClass) ? conceptClass : THROW_CCE();
  }
  function getRoleDefaults($this, sourceClass) {
    return _get_roleDefaultsMap__g90zzx($this).q2(sourceClass);
  }
  function createEditor($this, editorDefinition) {
    var tmp;
    if (editorDefinition instanceof EditorDefinition) {
      tmp = editor(_get_config__hi7kzb($this), editorDefinition);
    } else {
      if (editorDefinition instanceof HierarchyEditorDefinition) {
        tmp = hierarchyEditor(_get_config__hi7kzb($this), editorDefinition);
      } else {
        throw UnsupportedOperationException_init_$Create$();
      }
    }
    return tmp;
  }
  function Companion_250() {
  }
  var Companion_instance_250;
  function Companion_getInstance_250() {
    return Companion_instance_250;
  }
  function EditorRegistryImpl$init$lambda(editorDefinition) {
    return !(editorDefinition.gd4_1 == null);
  }
  function EditorRegistryImpl(editorDefinitions, conceptRegistry) {
    this.td2_1 = conceptRegistry;
    this.yd2_1 = getAllEditorDefinitions(Companion_instance_250, editorDefinitions);
  }
  protoOf(EditorRegistryImpl).zd2 = function (config) {
    this.xd2_1 = config;
    var tmp = this;
    // Inline function 'kotlin.collections.associate' call
    var this_0 = this.yd2_1;
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
    // Inline function 'kotlin.collections.associateTo' call
    var destination = LinkedHashMap_init_$Create$_0(capacity);
    var _iterator__ex2g4s = this_0.m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      // Inline function 'kotlin.collections.plusAssign' call
      var pair = to(element.fd4_1, createEditor(this, element));
      destination.t2(pair.pg_1, pair.qg_1);
    }
    tmp.ud2_1 = destination;
    var tmp_0 = this;
    var tmp_1 = asSequence_0(this.yd2_1);
    // Inline function 'kotlin.sequences.associate' call
    var tmp0 = filter(tmp_1, EditorRegistryImpl$init$lambda);
    // Inline function 'kotlin.sequences.associateTo' call
    var destination_0 = LinkedHashMap_init_$Create$();
    var _iterator__ex2g4s_0 = tmp0.m();
    while (_iterator__ex2g4s_0.n()) {
      var element_0 = _iterator__ex2g4s_0.o();
      // Inline function 'kotlin.collections.plusAssign' call
      var pair_0 = to(element_0.fd4_1, ensureNotNull(element_0.gd4_1));
      destination_0.t2(pair_0.pg_1, pair_0.qg_1);
    }
    tmp_0.vd2_1 = destination_0;
    var tmp_2 = this;
    // Inline function 'kotlin.collections.filter' call
    var tmp0_0 = this.yd2_1;
    // Inline function 'kotlin.collections.filterTo' call
    var destination_1 = ArrayList_init_$Create$();
    var _iterator__ex2g4s_1 = tmp0_0.m();
    while (_iterator__ex2g4s_1.n()) {
      var element_1 = _iterator__ex2g4s_1.o();
      if (!element_1.jd4_1) {
        destination_1.j(element_1);
      }
    }
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_2 = ArrayList_init_$Create$_0(collectionSizeOrDefault(destination_1, 10));
    var _iterator__ex2g4s_2 = destination_1.m();
    while (_iterator__ex2g4s_2.n()) {
      var item = _iterator__ex2g4s_2.o();
      var tmp$ret$11 = item.fd4_1;
      destination_2.j(tmp$ret$11);
    }
    tmp_2.wd2_1 = toSet_0(destination_2);
  };
  protoOf(EditorRegistryImpl).id1 = function (sourceClass, childContext, placeholderText, separator, itemFactory, pasteHandler, onLastItemDeleted) {
    var editor = getEditor(this, sourceClass);
    var tmp = getRoleDefaults(this, sourceClass);
    var roleDefaults = (tmp == null ? true : tmp instanceof RoleDefaults) ? tmp : THROW_CCE();
    $l$block: {
      // Inline function 'kotlin.checkNotNull' call
      if (roleDefaults == null) {
        var message = 'cannot find role defaults for collection of ' + toString_1(sourceClass);
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      } else {
        break $l$block;
      }
    }
    var resultPlaceholderText = placeholderText == null ? roleDefaults.ud4_1 : placeholderText;
    var tmp_0;
    if (separator == null) {
      var tmp2_safe_receiver = roleDefaults instanceof ChildrenRoleDefaults ? roleDefaults : null;
      tmp_0 = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.sd3_1;
    } else {
      tmp_0 = separator;
    }
    var tmp3_elvis_lhs = tmp_0;
    var childrenSeparator = tmp3_elvis_lhs == null ? get_defaultChildrenSeparator() : tmp3_elvis_lhs;
    var tmp4_safe_receiver = roleDefaults instanceof ChildrenRoleDefaults ? roleDefaults : null;
    var tmp5_elvis_lhs = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.rd3_1;
    var tmp_1;
    if (tmp5_elvis_lhs == null) {
      tmp_1 = isInterface(sourceClass, KClass) ? sourceClass : THROW_CCE();
    } else {
      tmp_1 = tmp5_elvis_lhs;
    }
    var newItemClass = tmp_1;
    var resultItemFactory = itemFactory == null ? roleDefaults.wd4_1 : itemFactory;
    var completionSupplier = roleDefaults.vd4_1;
    var canCreateNewItems = roleDefaults.xd4_1;
    return editor.qd5(childContext, newItemClass, resultItemFactory, resultPlaceholderText, childrenSeparator, completionSupplier, canCreateNewItems, pasteHandler, onLastItemDeleted, this.td2_1);
  };
  protoOf(EditorRegistryImpl).hd1 = function (sourceClass, childContext, placeholderText, itemFactory, pasteHandler, onLastItemDeleted, canClear, completionSupplier) {
    var editor = getEditor(this, sourceClass);
    var tmp = getRoleDefaults(this, sourceClass);
    var tmp0_elvis_lhs = (tmp == null ? true : tmp instanceof RoleDefaults) ? tmp : THROW_CCE();
    var roleDefaults = tmp0_elvis_lhs == null ? childRoleDefaults() : tmp0_elvis_lhs;
    var resultPlaceholderText = placeholderText == null ? roleDefaults.ud4_1 : placeholderText;
    var resultCompletionSupplier = completionSupplier == null ? roleDefaults.vd4_1 : completionSupplier;
    var resultItemFactory = itemFactory == null ? roleDefaults.wd4_1 : itemFactory;
    var canCreateNewItems = roleDefaults.xd4_1;
    var tmp_0;
    if (canClear == null) {
      var tmp5_safe_receiver = roleDefaults instanceof ChildRoleDefaults ? roleDefaults : null;
      tmp_0 = tmp5_safe_receiver == null ? null : tmp5_safe_receiver.md3_1;
    } else {
      tmp_0 = canClear;
    }
    var tmp6_elvis_lhs = tmp_0;
    var resultCanClear = tmp6_elvis_lhs == null ? true : tmp6_elvis_lhs;
    return editor.rd5(childContext, resultPlaceholderText, resultCompletionSupplier, resultItemFactory, canCreateNewItems, pasteHandler, onLastItemDeleted, resultCanClear, this.td2_1);
  };
  protoOf(EditorRegistryImpl).qd2 = function (sourceClass) {
    var interfaceClass = _get_exactClasses__7l6rjw(this).t(sourceClass) ? sourceClass : toInterfaceClass(this, sourceClass);
    var editor = getEditor(this, interfaceClass);
    return editor.sd5();
  };
  function BaseRoleSpec$getMapperFactoryFunction$lambda(this$0) {
    return function (item) {
      return this$0.sd1_1.rd2(item);
    };
  }
  function BaseRoleSpec(mapperFactory, itemFactory, placeholderText, roleCompletion, clipboardParameters, pasteHandler, onLastItemDeleted) {
    this.sd1_1 = mapperFactory;
    this.td1_1 = itemFactory;
    this.ud1_1 = placeholderText;
    this.vd1_1 = roleCompletion;
    this.wd1_1 = clipboardParameters;
    this.xd1_1 = pasteHandler;
    this.yd1_1 = onLastItemDeleted;
  }
  protoOf(BaseRoleSpec).zd1 = function () {
    return BaseRoleSpec$getMapperFactoryFunction$lambda(this);
  };
  function ChildRoleSpec(mapperFactory, placeholderText, itemFactory, roleCompletion, clipboardParameters, pasteHandler, onLastItemDeleted, canClear) {
    placeholderText = placeholderText === VOID ? '<empty>' : placeholderText;
    itemFactory = itemFactory === VOID ? null : itemFactory;
    roleCompletion = roleCompletion === VOID ? null : roleCompletion;
    clipboardParameters = clipboardParameters === VOID ? null : clipboardParameters;
    pasteHandler = pasteHandler === VOID ? null : pasteHandler;
    onLastItemDeleted = onLastItemDeleted === VOID ? null : onLastItemDeleted;
    canClear = canClear === VOID ? true : canClear;
    BaseRoleSpec.call(this, mapperFactory, itemFactory, placeholderText, roleCompletion, clipboardParameters, pasteHandler, onLastItemDeleted);
    this.kd2_1 = canClear;
  }
  function ChildrenRoleSpec(mapperFactory, itemFactory, placeholderText, roleCompletion, separator, clipboardParameters, pasteHandler, onLastItemDeleted) {
    placeholderText = placeholderText === VOID ? '<empty>' : placeholderText;
    roleCompletion = roleCompletion === VOID ? null : roleCompletion;
    separator = separator === VOID ? null : separator;
    clipboardParameters = clipboardParameters === VOID ? null : clipboardParameters;
    onLastItemDeleted = onLastItemDeleted === VOID ? null : onLastItemDeleted;
    BaseRoleSpec.call(this, mapperFactory, itemFactory, placeholderText, roleCompletion, clipboardParameters, pasteHandler, onLastItemDeleted);
    this.qd1_1 = separator;
  }
  function get_internalConfig(_this__u8e3s4) {
    var tmp = _this__u8e3s4.ld0();
    return isInterface(tmp, InternalEditorBuilderConfig) ? tmp : THROW_CCE();
  }
  function InternalEditorBuilder() {
  }
  function InternalEditorBuilderConfig() {
  }
  function handleInvalidatable($this, invalidatable) {
    // Inline function 'kotlin.runCatching' call
    var tmp;
    try {
      invalidatable.m5u();
      // Inline function 'kotlin.Companion.success' call
      tmp = _Result___init__impl__xyqfz8(Unit_instance);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var e = $p;
        // Inline function 'kotlin.Companion.failure' call
        tmp_0 = _Result___init__impl__xyqfz8(createFailure(e));
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    // Inline function 'kotlin.onFailure' call
    var this_0 = tmp;
    if (Result__exceptionOrNull_impl_p6xea9(this_0) == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      contentUpdated($this);
      return Unit_instance;
    }
    if (!invalidatable.n5u().p38()) {
      contentUpdated($this);
      return Unit_instance;
    }
    var tmp_1 = $this;
    var tmp_2 = invalidatable.n5u();
    tmp_1.vd5_1 = tmp_2.z2r(BaseEditor$createMapper$o$handleInvalidatable$lambda($this));
  }
  function contentUpdated($this) {
    var cellContainer = $this.zd5_1.s8x();
    $l$block: {
      // Inline function 'kotlin.checkNotNull' call
      if (cellContainer == null) {
        var message = 'cell container is null';
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      } else {
        break $l$block;
      }
    }
    var tmp = cellContainer.m93();
    var tmp_0 = BaseEditor$createMapper$o$contentUpdated$lambda(cellContainer, $this.ad6_1, $this.zd5_1, $this, $this.wd5_1, $this.xd5_1);
    tmp.u39(new sam$jetbrains_ocelot_base_edt_EdtTask$0_16(tmp_0));
  }
  function BaseEditor$createMapper$o$attach$lambda(this$0) {
    return function (it) {
      contentUpdated(this$0);
      return Unit_instance;
    };
  }
  function BaseEditor$createMapper$o$handleInvalidatable$lambda(this$0) {
    return function (it) {
      contentUpdated(this$0);
      return Unit_instance;
    };
  }
  function BaseEditor$createMapper$o$contentUpdated$lambda($cellContainer, $reloadableSynchronizer, $rootCell, this$0, this$1, $source) {
    return function () {
      var wasFocused = !($cellContainer.z92().uv() == null);
      $reloadableSynchronizer.k2();
      $rootCell.o35().k2();
      handleInvalidatable(this$0, initBuilder(this$1, $source, $rootCell, $reloadableSynchronizer));
      $reloadableSynchronizer.m8b();
      var tmp;
      if (wasFocused && $cellContainer.z92().uv() == null) {
        tmp = $rootCell.c93(ProjectionalSynchronizers_getInstance().d99_1)();
      }
      return Unit_instance;
    };
  }
  function initBuilder($this, source, rootCell, reloadableSynchronizer) {
    var editorBuilder = new SimpleEditorBuilder($this.od5_1, source, rootCell, reloadableSynchronizer);
    return $this.fd6_1(editorBuilder);
  }
  function createMapper_0($this, source) {
    var rootCell = new IndentCell();
    rootCell.g93(ProjectionalSynchronizers_getInstance().d99_1, toFirstPlaceholderWhenSettled(rootCell));
    var reloadableSynchronizer = new ReloadableSynchronizer();
    var invalidatable = initBuilder($this, source, rootCell, reloadableSynchronizer);
    var triggerContentUpdateSynchronizer = new BaseEditor$createMapper$triggerContentUpdateSynchronizer$1($this, source, invalidatable, rootCell, reloadableSynchronizer);
    return new EditorBuilderMapper(source, rootCell, reloadableSynchronizer, triggerContentUpdateSynchronizer);
  }
  function WaitingMapperFactory(mapperFactory) {
    this.gd6_1 = mapperFactory;
  }
  protoOf(WaitingMapperFactory).hd6 = function (source) {
    var baseMapper = this.gd6_1.rd2(source);
    baseMapper.f86_1.w92(EffectiveVisibilityTrackingTrait_getInstance());
    return new WaitingMapper(baseMapper);
  };
  protoOf(WaitingMapperFactory).rd2 = function (source) {
    return this.hd6((source == null ? true : !(source == null)) ? source : THROW_CCE());
  };
  function sam$jetbrains_ocelot_base_edt_EdtTask$0_16(function_0) {
    this.id6_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_16).au = function () {
    return this.id6_1();
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_16).f3 = function () {
    return this.id6_1;
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_16).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, EdtTask) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_16).hashCode = function () {
    return hashCode(this.f3());
  };
  function BaseEditor$createMapper$triggerContentUpdateSynchronizer$1(this$0, $source, $invalidatable, $rootCell, $reloadableSynchronizer) {
    this.wd5_1 = this$0;
    this.xd5_1 = $source;
    this.yd5_1 = $invalidatable;
    this.zd5_1 = $rootCell;
    this.ad6_1 = $reloadableSynchronizer;
    this.ud5_1 = Companion_getInstance_29().m2l_1;
    this.vd5_1 = Companion_getInstance_29().m2l_1;
  }
  protoOf(BaseEditor$createMapper$triggerContentUpdateSynchronizer$1).y86 = function (ctx) {
    var newDependenciesDisposal = new CompositeDisposable([]);
    var _iterator__ex2g4s = this.wd5_1.ed6_1.m();
    while (_iterator__ex2g4s.n()) {
      var triggerDependency = _iterator__ex2g4s.o();
      var commonConfig = this.wd5_1.od5_1.ud0();
      var eventSource = triggerDependency(this.xd5_1, commonConfig);
      var handler = eventSource.z2r(BaseEditor$createMapper$o$attach$lambda(this));
      newDependenciesDisposal.l2l([handler]);
    }
    this.ud5_1 = newDependenciesDisposal;
    handleInvalidatable(this, this.yd5_1);
  };
  protoOf(BaseEditor$createMapper$triggerContentUpdateSynchronizer$1).e6j = function () {
    this.ud5_1.zr();
    this.vd5_1.zr();
  };
  function BaseEditor$createMapperFactory$$inlined$mapperFactory$1(this$0) {
    this.jd6_1 = this$0;
  }
  protoOf(BaseEditor$createMapperFactory$$inlined$mapperFactory$1).kd6 = function (source) {
    var mapper = createMapper_0(this.jd6_1, source);
    var tmp;
    if (this.jd6_1.od5_1.nd5()) {
      var tmp_0 = this.jd6_1.od5_1.ud0();
      var tmp0_elvis_lhs = this.jd6_1.od5_1.md5();
      tmp = highlighted(mapper, tmp_0, tmp0_elvis_lhs == null ? EmptyErrorCheckConfig_instance : tmp0_elvis_lhs);
    } else {
      tmp = mapper;
    }
    return tmp;
  };
  protoOf(BaseEditor$createMapperFactory$$inlined$mapperFactory$1).rd2 = function (source) {
    return this.kd6((source == null ? true : !(source == null)) ? source : THROW_CCE());
  };
  function BaseEditor(config, sourceClass, waitUntilReady, triggerDependencies, init) {
    RoleEditor.call(this, config, sourceClass);
    this.dd6_1 = waitUntilReady;
    this.ed6_1 = triggerDependencies;
    this.fd6_1 = init;
  }
  protoOf(BaseEditor).sd5 = function () {
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.internal.roleEditor.mapperFactory' call
    var factory = new BaseEditor$createMapperFactory$$inlined$mapperFactory$1(this);
    return this.dd6_1 ? new WaitingMapperFactory(factory) : factory;
  };
  function Editor$getDefaultCompletionSuppliers$$inlined$map$1$getCompletionItems$1($matchingText, $sortPriority, $isCaseSensitive, $targetFactory, $role) {
    this.rd6_1 = $targetFactory;
    this.sd6_1 = $role;
    SimpleCompletionItem.call(this, $matchingText, VOID, $sortPriority, $isCaseSensitive);
  }
  protoOf(Editor$getDefaultCompletionSuppliers$$inlined$map$1$getCompletionItems$1).s9m = function (text) {
    var target = this.rd6_1();
    return this.sd6_1.yak(target);
  };
  function getDefaultCompletionSuppliers($this) {
    // Inline function 'kotlin.collections.map' call
    var this_0 = $this.yd6_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.m();
    while (_iterator__ex2g4s.n()) {
      var item = _iterator__ex2g4s.o();
      // Inline function 'jetbrains.ocelot.projectional.editor.generic.role.item' call
      var targetFactory = $this.ld6();
      var tmp$ret$1 = new Editor$getDefaultCompletionSuppliers$$inlined$map$1(item, targetFactory);
      destination.j(tmp$ret$1);
    }
    return destination;
  }
  function Editor$getDefaultCompletionSuppliers$$inlined$map$1($matchingText, $targetFactory) {
    this.ad7_1 = $matchingText;
    this.bd7_1 = $targetFactory;
  }
  protoOf(Editor$getDefaultCompletionSuppliers$$inlined$map$1).cd7 = function (contextNode, role) {
    // Inline function 'jetbrains.ocelot.projectional.cell.completion.result.simpleCompletionItem' call
    var matchingText = this.ad7_1;
    var completionItem = new Editor$getDefaultCompletionSuppliers$$inlined$map$1$getCompletionItems$1(matchingText, 0, true, this.bd7_1, role);
    return listOf(completionItem);
  };
  protoOf(Editor$getDefaultCompletionSuppliers$$inlined$map$1).paw = function (contextNode, role) {
    return this.cd7(contextNode, role);
  };
  function Editor$getCompletionSuppliers$completionSupplier$1(this$0) {
    this.dd7_1 = this$0;
  }
  protoOf(Editor$getCompletionSuppliers$completionSupplier$1).ed7 = function (contextNode, role) {
    // Inline function 'kotlin.collections.buildList' call
    // Inline function 'kotlin.collections.buildListInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = ArrayList_init_$Create$();
    var completionItemsSupplier = this.dd7_1.zd6_1.gd7_1;
    var suppliers = completionItemsSupplier(contextNode);
    this_0.q(suppliers);
    if (this.dd7_1.zd6_1.fd7_1) {
      this_0.q(getDefaultCompletionSuppliers(this.dd7_1));
    }
    // Inline function 'kotlin.collections.flatMap' call
    var tmp0 = this_0.i3();
    // Inline function 'kotlin.collections.flatMapTo' call
    var destination = ArrayList_init_$Create$();
    var _iterator__ex2g4s = tmp0.m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      var list = element.paw(contextNode, role);
      addAll_1(destination, list);
    }
    return destination;
  };
  protoOf(Editor$getCompletionSuppliers$completionSupplier$1).paw = function (contextNode, role) {
    return this.ed7(contextNode, role);
  };
  function Editor(config, sourceClass, matchingTexts, customCompletion, waitUntilReady, triggerDependencies, init) {
    BaseEditor.call(this, config, sourceClass, waitUntilReady, triggerDependencies, init);
    this.yd6_1 = matchingTexts;
    this.zd6_1 = customCompletion;
  }
  protoOf(Editor).md6 = function () {
    var completionSuppliers = this.hd7();
    return toRoleCompletion(completionSuppliers);
  };
  protoOf(Editor).hd7 = function () {
    var tmp;
    if (this.zd6_1 == null) {
      tmp = getDefaultCompletionSuppliers(this);
    } else {
      var completionSupplier = new Editor$getCompletionSuppliers$completionSupplier$1(this);
      tmp = listOf(completionSupplier);
    }
    return tmp;
  };
  function EditorBuilderMapper(source, cell, reloadableSynchronizer, triggerDisposable) {
    Mapper.call(this, source, cell);
    this.pd7_1 = reloadableSynchronizer;
    this.qd7_1 = triggerDisposable;
  }
  protoOf(EditorBuilderMapper).a88 = function (conf) {
    conf.h5v(this.pd7_1);
    conf.h5v(this.qd7_1);
  };
  function createEditorMap($this, editors) {
    // Inline function 'kotlin.collections.associateBy' call
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(editors, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap_init_$Create$_0(capacity);
    var _iterator__ex2g4s = editors.m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      var tmp$ret$0 = element.pd5_1;
      destination.t2(tmp$ret$0, element);
    }
    return destination;
  }
  function HierarchyRoleEditor$createMapperFactory$$inlined$mapperFactory$1(this$0) {
    this.rd7_1 = this$0;
  }
  protoOf(HierarchyRoleEditor$createMapperFactory$$inlined$mapperFactory$1).kd6 = function (source) {
    var implClass = getKClassFromExpression(source);
    var conceptClass = this.rd7_1.od5_1.gd3().n6l(implClass);
    // Inline function 'kotlin.collections.get' call
    var this_0 = this.rd7_1.vd7_1;
    var tmp = (isInterface(this_0, KtMap) ? this_0 : THROW_CCE()).q2(conceptClass);
    var editor = (tmp == null ? true : tmp instanceof BaseEditor) ? tmp : THROW_CCE();
    $l$block: {
      // Inline function 'kotlin.checkNotNull' call
      if (editor == null) {
        var message = 'cannot find editor for: ' + toString_1(conceptClass);
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      } else {
        break $l$block;
      }
    }
    return editor.sd5().rd2(source);
  };
  protoOf(HierarchyRoleEditor$createMapperFactory$$inlined$mapperFactory$1).rd2 = function (source) {
    return this.kd6((source == null ? true : !(source == null)) ? source : THROW_CCE());
  };
  function HierarchyRoleEditor(config, sourceClass, allEditors, editors) {
    RoleEditor.call(this, config, sourceClass);
    this.ud7_1 = editors;
    this.vd7_1 = createEditorMap(this, allEditors);
  }
  protoOf(HierarchyRoleEditor).sd5 = function () {
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.internal.roleEditor.mapperFactory' call
    return new HierarchyRoleEditor$createMapperFactory$$inlined$mapperFactory$1(this);
  };
  protoOf(HierarchyRoleEditor).md6 = function () {
    // Inline function 'kotlin.collections.flatMap' call
    var tmp0 = this.ud7_1;
    // Inline function 'kotlin.collections.flatMapTo' call
    var destination = ArrayList_init_$Create$();
    var _iterator__ex2g4s = tmp0.m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      var list = element.hd7();
      addAll_1(destination, list);
    }
    return toRoleCompletion(destination);
  };
  function $prepareCOROUTINE$_0(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.ed8_1 = _this__u8e3s4;
  }
  protoOf($prepareCOROUTINE$_0).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 12;
            this.md8_1 = this.ed8_1.pd8_1.g6j(true).m();
            this.f9_1 = 1;
            continue $sm;
          case 1:
            if (!this.md8_1.n()) {
              this.f9_1 = 11;
              continue $sm;
            }

            var element = this.md8_1.o();
            this.jd8_1 = element;
            var conceptId = this.jd8_1.f3t();
            var properties = toOtNode(this.jd8_1).c3e();
            var destination = ArrayList_init_$Create$();
            var _iterator__ex2g4s = properties.m();
            while (_iterator__ex2g4s.n()) {
              var element_0 = _iterator__ex2g4s.o();
              var tmp0_safe_receiver = getReferenceTag(this.ed8_1.qd8_1.sd8_1.t6i(conceptId), element_0);
              if (tmp0_safe_receiver == null)
                null;
              else {
                destination.j(tmp0_safe_receiver);
              }
            }

            var references = destination;
            this.ld8_1 = references.m();
            this.f9_1 = 2;
            continue $sm;
          case 2:
            if (!this.ld8_1.n()) {
              this.f9_1 = 10;
              continue $sm;
            }

            var element_1 = this.ld8_1.o();
            this.kd8_1 = element_1;
            var tmp_0 = this.kd8_1;
            if (!(tmp_0 instanceof RefTag))
              THROW_CCE();
            var tmp_1 = this;
            var tmp_2 = this.jd8_1;
            tmp_1.fd8_1 = (isInterface(tmp_2, TypedOtNode) ? tmp_2 : THROW_CCE()).c6j(this.kd8_1);
            this.f9_1 = 3;
            suspendResult = supervise(this.fd8_1.w6o(), new Invalidator(), VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            this.id8_1 = suspendResult;
            if (this.id8_1.m5u() == null) {
              this.f9_1 = 4;
              suspendResult = supervise(this.fd8_1.x6o(), new Invalidator(), VOID, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.f9_1 = 9;
              continue $sm;
            }

          case 4:
            this.hd8_1 = suspendResult;
            var targetNode = this.hd8_1.m5u();
            if (!(targetNode == null)) {
              this.f9_1 = 5;
              suspendResult = supervise(getPresentation(this.ed8_1.qd8_1.rd8_1, this.kd8_1, targetNode), new Invalidator(), VOID, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.f9_1 = 8;
              continue $sm;
            }

          case 5:
            this.gd8_1 = suspendResult;
            var nameValue = this.gd8_1.m5u();
            if (!(nameValue == null)) {
              var targetSupplier = this.ed8_1.qd8_1.rd8_1.d6u(this.kd8_1);
              var matchingElements = targetSupplier.o6q(new SourceNodeContext(this.jd8_1), TextFilter_init_$Create$_0(nameValue, this.ed8_1.qd8_1.td8_1, false));
              this.f9_1 = 6;
              suspendResult = firstOrNull_3(matchingElements, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.f9_1 = 7;
              continue $sm;
            }

          case 6:
            var tmp0_safe_receiver_0 = suspendResult;
            if (tmp0_safe_receiver_0 == null)
              null;
            else {
              depend_1(this.ed8_1.nd8_1, this.id8_1);
              depend_1(this.ed8_1.nd8_1, this.hd8_1);
              depend_1(this.ed8_1.nd8_1, this.gd8_1);
              var tmp_3 = this.fd8_1;
              if (!isInterface(tmp_3, Reference))
                THROW_CCE();
              var tmp0 = this.ed8_1.od8_1;
              var tmp2 = this.fd8_1;
              var value = tmp0_safe_receiver_0.k6q_1;
              tmp0.t2(tmp2, value);
            }

            this.f9_1 = 7;
            continue $sm;
          case 7:
            this.f9_1 = 8;
            continue $sm;
          case 8:
            this.f9_1 = 9;
            continue $sm;
          case 9:
            this.f9_1 = 2;
            continue $sm;
          case 10:
            this.f9_1 = 1;
            continue $sm;
          case 11:
            return new Update(this.ed8_1.nd8_1, this.ed8_1.od8_1);
          case 12:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 12) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function Update(invalidationContext, substitutions) {
    this.ud8_1 = invalidationContext;
    this.vd8_1 = substitutions;
  }
  protoOf(Update).p38 = function () {
    return this.ud8_1.p38();
  };
  protoOf(Update).q38 = function () {
    this.ud8_1.zr();
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s = this.vd8_1.y().m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      // Inline function 'kotlin.collections.component1' call
      var reference = element.z();
      // Inline function 'kotlin.collections.component2' call
      var referenceContents = element.a1();
      reference.b6p(referenceContents);
    }
  };
  function NodeWrapperReferenceAdapter$afterPaste$1($sourceItem, this$0) {
    this.pd8_1 = $sourceItem;
    this.qd8_1 = this$0;
    this.nd8_1 = new Invalidator();
    var tmp = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp.od8_1 = LinkedHashMap_init_$Create$();
  }
  protoOf(NodeWrapperReferenceAdapter$afterPaste$1).zr = function () {
    this.nd8_1.zr();
  };
  protoOf(NodeWrapperReferenceAdapter$afterPaste$1).n38 = function ($completion) {
    var tmp = new $prepareCOROUTINE$_0(this, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  function NodeWrapperReferenceAdapter(resolveConfig, conceptRegistry, ignoreCase) {
    this.rd8_1 = resolveConfig;
    this.sd8_1 = conceptRegistry;
    this.td8_1 = ignoreCase;
  }
  protoOf(NodeWrapperReferenceAdapter).wd8 = function (sourceItem) {
    return new NodeWrapperReferenceAdapter$afterPaste$1(sourceItem, this);
  };
  protoOf(NodeWrapperReferenceAdapter).vak = function (sourceItem) {
    return this.wd8((!(sourceItem == null) ? isInterface(sourceItem, DomainNode) : false) ? sourceItem : THROW_CCE());
  };
  function _get_wrapperContext__m0ag33($this) {
    return $this.od5_1.l6z();
  }
  function getItemFactory($this, itemClass, customItemFactory, canCreateNewItems) {
    var tmp;
    if (!(customItemFactory == null)) {
      tmp = RoleEditor$getItemFactory$lambda(customItemFactory, $this);
    } else if (canCreateNewItems) {
      var f = RoleEditor$getItemFactory$lambda_0($this, itemClass);
      tmp = f;
    } else {
      tmp = null;
    }
    return tmp;
  }
  function getItemFactory$default($this, itemClass, customItemFactory, canCreateNewItems, $super) {
    canCreateNewItems = canCreateNewItems === VOID ? true : canCreateNewItems;
    return getItemFactory($this, itemClass, customItemFactory, canCreateNewItems);
  }
  function getClipboardParameters($this, conceptRegistry, nodeFactory) {
    return getNodeClipboardParameters($this.pd5_1, conceptRegistry, nodeFactory, $this.od5_1.ld5());
  }
  function getRoleCompletion($this, childContext, completionSupplier) {
    var tmp;
    if (completionSupplier == null) {
      tmp = $this.md6();
    } else {
      var commonConfig = $this.od5_1.ud0();
      var resolveConfig = commonConfig;
      var coroutineScope = commonConfig;
      tmp = buildRoleCompletion(childContext, coroutineScope, _get_wrapperContext__m0ag33($this), resolveConfig, completionSupplier);
    }
    return tmp;
  }
  function RoleEditor$getItemFactory$lambda($customItemFactory, this$0) {
    return function () {
      return $customItemFactory(_get_wrapperContext__m0ag33(this$0));
    };
  }
  function RoleEditor$getItemFactory$lambda_0(this$0, $itemClass) {
    return function () {
      var conceptRegistry = this$0.od5_1.gd3();
      return createInstance(conceptRegistry, $itemClass, _get_wrapperContext__m0ag33(this$0));
    };
  }
  function RoleEditor(config, sourceClass) {
    this.od5_1 = config;
    this.pd5_1 = sourceClass;
  }
  protoOf(RoleEditor).ld6 = function () {
    return ensureNotNull(getItemFactory$default(this, this.pd5_1, null));
  };
  protoOf(RoleEditor).qd5 = function (childContext, newItemClass, customItemFactory, placeholderText, separator, completionSupplier, canCreateNewItems, pasteHandler, onLastItemDeleted, conceptRegistry) {
    var clipboardParameters = getClipboardParameters(this, conceptRegistry, get_nodeFactory(_get_wrapperContext__m0ag33(this)));
    var nodeWrapperReferenceAdapter = new NodeWrapperReferenceAdapter(this.od5_1.ud0(), conceptRegistry, true);
    var itemFactory = getItemFactory(this, newItemClass, customItemFactory, canCreateNewItems);
    var roleCompletion = getRoleCompletion(this, childContext, completionSupplier);
    var tmp;
    if (pasteHandler == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp = pasteHandler.fav(nodeWrapperReferenceAdapter);
    }
    var tmp1_elvis_lhs = tmp;
    var finalPasteHandler = tmp1_elvis_lhs == null ? nodeWrapperReferenceAdapter : tmp1_elvis_lhs;
    return new ChildrenRoleSpec(this.sd5(), itemFactory, placeholderText, roleCompletion, separator, clipboardParameters, finalPasteHandler, onLastItemDeleted);
  };
  protoOf(RoleEditor).rd5 = function (childContext, placeholderText, completionSupplier, customItemFactory, canCreateNewItems, pasteHandler, onLastItemDeleted, canClear, conceptRegistry) {
    var clipboardParameters = getClipboardParameters(this, conceptRegistry, get_nodeFactory(_get_wrapperContext__m0ag33(this)));
    var nodeWrapperReferenceAdapter = new NodeWrapperReferenceAdapter(this.od5_1.ud0(), conceptRegistry, true);
    var roleCompletion = getRoleCompletion(this, childContext, completionSupplier);
    var itemFactory = getItemFactory(this, this.pd5_1, customItemFactory, canCreateNewItems);
    var tmp;
    if (pasteHandler == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp = pasteHandler.fav(nodeWrapperReferenceAdapter);
    }
    var tmp1_elvis_lhs = tmp;
    var finalPasteHandler = tmp1_elvis_lhs == null ? nodeWrapperReferenceAdapter : tmp1_elvis_lhs;
    return new ChildRoleSpec(this.sd5(), placeholderText, itemFactory, roleCompletion, clipboardParameters, finalPasteHandler, onLastItemDeleted, canClear);
  };
  function editor(config, editorDefinition) {
    var sourceClass = editorDefinition.fd4_1;
    var matchingTexts = editorDefinition.ed4(config.gd3());
    var customCompletion = editorDefinition.hd4_1;
    var waiting = editorDefinition.id4_1;
    var triggerDependencies = editorDefinition.kd4_1;
    var init = editorDefinition.ld4_1;
    return new Editor(config, sourceClass, matchingTexts, customCompletion, waiting, triggerDependencies, init);
  }
  function hierarchyEditor(config, editorDefinition) {
    var sourceClass = editorDefinition.fd4_1;
    // Inline function 'kotlin.collections.filterIsInstance' call
    var tmp0 = editorDefinition.dd4();
    // Inline function 'kotlin.collections.filterIsInstanceTo' call
    var destination = ArrayList_init_$Create$();
    var _iterator__ex2g4s = tmp0.m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      if (element instanceof EditorDefinition) {
        destination.j(element);
      }
    }
    var allEditors = getEditors(destination, config);
    var editors = getEditors(editorDefinition.td4_1, config);
    return new HierarchyRoleEditor(config, sourceClass, allEditors, editors);
  }
  function getEditors(_this__u8e3s4, config) {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(_this__u8e3s4, 10));
    var _iterator__ex2g4s = _this__u8e3s4.m();
    while (_iterator__ex2g4s.n()) {
      var item = _iterator__ex2g4s.o();
      var tmp$ret$0 = editor(config, item);
      destination.j(tmp$ret$0);
    }
    // Inline function 'kotlin.collections.filterIsInstance' call
    // Inline function 'kotlin.collections.filterIsInstanceTo' call
    var destination_0 = ArrayList_init_$Create$();
    var _iterator__ex2g4s_0 = destination.m();
    while (_iterator__ex2g4s_0.n()) {
      var element = _iterator__ex2g4s_0.o();
      if (element instanceof Editor) {
        destination_0.j(element);
      }
    }
    return destination_0;
  }
  function editor_0(config, sourceClass, init) {
    var matchingText = getMatchingText(config, sourceClass);
    var matchingTexts = listOf(matchingText);
    var tmp = emptyList();
    return new Editor(config, sourceClass, matchingTexts, null, false, tmp, editor$lambda(init));
  }
  function getMatchingText(config, sourceClass) {
    return config.gd3().m6l(sourceClass);
  }
  function editor$lambda($init) {
    return function ($this$Editor) {
      $init($this$Editor);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function SimpleEditorBuilder$addKeyPressedHandler$$inlined$keyPressedCellTrait$1($handler) {
    this.xd8_1 = $handler;
    CellTrait.call(this);
  }
  protoOf(SimpleEditorBuilder$addKeyPressedHandler$$inlined$keyPressedCellTrait$1).s8z = function (cell, event) {
    return this.xd8_1(cell, event);
  };
  function SimpleEditorBuilder$invalidating$1(this$0, $execution) {
    InvalidatingEditorBuilder.call(this, $execution);
    this.zd8_1 = this$0;
  }
  protoOf(SimpleEditorBuilder$invalidating$1).ld0 = function () {
    return this.zd8_1.ad9_1;
  };
  protoOf(SimpleEditorBuilder$invalidating$1).m6d = function () {
    return this.zd8_1.bd9_1;
  };
  protoOf(SimpleEditorBuilder$invalidating$1).qd0 = function () {
    return this.zd8_1.cd9_1;
  };
  protoOf(SimpleEditorBuilder$invalidating$1).l8b = function (synchronizer) {
    this.zd8_1.l8b(synchronizer);
  };
  protoOf(SimpleEditorBuilder$invalidating$1).td3 = function (handler) {
    this.zd8_1.td3(handler);
  };
  protoOf(SimpleEditorBuilder$invalidating$1).ud3 = function (invalidationContext) {
    return this.zd8_1.ud3(invalidationContext);
  };
  protoOf(SimpleEditorBuilder$invalidating$1).vd3 = function (body) {
    this.zd8_1.vd3(body);
  };
  protoOf(SimpleEditorBuilder$invalidating$1).pd0 = function (cell) {
    return this.zd8_1.pd0(cell);
  };
  protoOf(SimpleEditorBuilder$invalidating$1).od0 = function (cell) {
    this.zd8_1.od0(cell);
  };
  protoOf(SimpleEditorBuilder$invalidating$1).td5 = function (disposable) {
    this.zd8_1.td5(disposable);
  };
  function SimpleEditorBuilder$buildAsync$slambda($body, resultContinuation) {
    this.md9_1 = $body;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(SimpleEditorBuilder$buildAsync$slambda).e1h = function ($this$launchWith, $completion) {
    var tmp = this.f1h($this$launchWith, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(SimpleEditorBuilder$buildAsync$slambda).v9 = function (p1, $completion) {
    return this.e1h((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(SimpleEditorBuilder$buildAsync$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.md9_1(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(SimpleEditorBuilder$buildAsync$slambda).f1h = function ($this$launchWith, completion) {
    var i = new SimpleEditorBuilder$buildAsync$slambda(this.md9_1, completion);
    i.nd9_1 = $this$launchWith;
    return i;
  };
  function SimpleEditorBuilder$buildAsync$slambda_0($body, resultContinuation) {
    var i = new SimpleEditorBuilder$buildAsync$slambda($body, resultContinuation);
    var l = function ($this$launchWith, $completion) {
      return i.e1h($this$launchWith, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function SimpleEditorBuilder(config, source, targetCell, reloadableSynchronizer) {
    this.ad9_1 = config;
    this.bd9_1 = source;
    this.cd9_1 = targetCell;
    this.dd9_1 = reloadableSynchronizer;
  }
  protoOf(SimpleEditorBuilder).ld0 = function () {
    return this.ad9_1;
  };
  protoOf(SimpleEditorBuilder).m6d = function () {
    return this.bd9_1;
  };
  protoOf(SimpleEditorBuilder).qd0 = function () {
    return this.cd9_1;
  };
  protoOf(SimpleEditorBuilder).od0 = function (cell) {
    this.cd9_1.q92().j(cell);
  };
  protoOf(SimpleEditorBuilder).pd0 = function (cell) {
    return new SimpleEditorBuilder(this.ad9_1, this.bd9_1, cell, this.dd9_1);
  };
  protoOf(SimpleEditorBuilder).l8b = function (synchronizer) {
    return this.dd9_1.l8b(synchronizer);
  };
  protoOf(SimpleEditorBuilder).td5 = function (disposable) {
    var synchronizer = Synchronizers_instance.g8b([disposable]);
    this.l8b(synchronizer);
  };
  protoOf(SimpleEditorBuilder).od9 = function (cellTrait) {
    var disposable = this.cd9_1.w92(cellTrait);
    this.td5(disposable);
  };
  protoOf(SimpleEditorBuilder).td3 = function (handler) {
    // Inline function 'jetbrains.ocelot.projectional.cell.trait.keyPressedCellTrait' call
    var tmp$ret$0 = new SimpleEditorBuilder$addKeyPressedHandler$$inlined$keyPressedCellTrait$1(handler);
    return this.od9(tmp$ret$0);
  };
  protoOf(SimpleEditorBuilder).ud3 = function (invalidationContext) {
    var execution = new Execution(invalidationContext, EmptyCoroutineContext_instance);
    return new SimpleEditorBuilder$invalidating$1(this, execution);
  };
  protoOf(SimpleEditorBuilder).vd3 = function (body) {
    var tmp = get_internalConfig(this).ud0();
    var tmp_0 = new CellAsyncTracker(this.cd9_1);
    launchWith(tmp, tmp_0, SimpleEditorBuilder$buildAsync$slambda_0(body, null));
  };
  function _get_preservingCloner__c4xitv($this) {
    return BaseNodeCloneSupport$_get_preservingCloner_$lambda_fq5e8v;
  }
  function copyListNoPreservation($this, sourceItems) {
    var internalReferenceIds = findInternalReferenceIds($this, sourceItems);
    var oldToNewIdMap = HashMap_init_$Create$();
    var nodeCopier = new BaseNodeCloneSupport$copyListNoPreservation$nodeCopier$1($this, internalReferenceIds, oldToNewIdMap);
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(sourceItems, 10));
    var _iterator__ex2g4s = sourceItems.m();
    while (_iterator__ex2g4s.n()) {
      var item = _iterator__ex2g4s.o();
      var tmp$ret$0 = nodeCopier.w3q(toOtNode(item));
      destination.j(tmp$ret$0);
    }
    var list = destination;
    var context = get_wrapperContextOrNull(first(sourceItems));
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(list, 10));
    var _iterator__ex2g4s_0 = list.m();
    while (_iterator__ex2g4s_0.n()) {
      var item_0 = _iterator__ex2g4s_0.o();
      fixReferencesInsideCopiedNode($this, $this.pd9_1, item_0, oldToNewIdMap);
      var tmp = toDomainNode(item_0, context);
      var wrapper = isInterface(tmp, DomainNode) ? tmp : THROW_CCE();
      destination_0.j(wrapper);
    }
    return destination_0;
  }
  function containsRefPropertyId($this, _this__u8e3s4, node, propertyId) {
    return !(getReferenceTag(_this__u8e3s4.t6i(node.e3m_1), propertyId) == null);
  }
  function fixReferencesInsideCopiedNode($this, _this__u8e3s4, node, oldToNewIdMap) {
    var _iterator__ex2g4s = node.c3e().m();
    while (_iterator__ex2g4s.n()) {
      var propertyId = _iterator__ex2g4s.o();
      if (containsRefPropertyId($this, _this__u8e3s4, node, propertyId)) {
        var idProp = node.d3n(propertyId);
        var referenceId = idProp.uv();
        if (!(referenceId == null)) {
          var newId = oldToNewIdMap.q2(referenceId);
          if (!(newId == null)) {
            idProp.d2x(newId);
          }
        }
      }
    }
    var _iterator__ex2g4s_0 = node.z3d().m();
    while (_iterator__ex2g4s_0.n()) {
      var childId = _iterator__ex2g4s_0.o();
      var childNodes = node.p3m(childId);
      var _iterator__ex2g4s_1 = childNodes.m();
      while (_iterator__ex2g4s_1.n()) {
        var childNode = _iterator__ex2g4s_1.o();
        fixReferencesInsideCopiedNode($this, _this__u8e3s4, childNode, oldToNewIdMap);
      }
    }
  }
  function findInternalReferenceIds($this, nodeWrappers) {
    var internalNodeIds = HashSet_init_$Create$();
    var referencedNodeIds = HashSet_init_$Create$();
    var _iterator__ex2g4s = nodeWrappers.m();
    while (_iterator__ex2g4s.n()) {
      var nodeWrapper = _iterator__ex2g4s.o();
      findInternalReferences($this, $this.pd9_1, toOtNode(nodeWrapper), internalNodeIds, referencedNodeIds);
    }
    return intersect(internalNodeIds, referencedNodeIds);
  }
  function findInternalReferences($this, _this__u8e3s4, node, internalNodeIds, referencedNodeIds) {
    internalNodeIds.j(node.l3o());
    var _iterator__ex2g4s = node.c3e().m();
    while (_iterator__ex2g4s.n()) {
      var propertyId = _iterator__ex2g4s.o();
      if (containsRefPropertyId($this, _this__u8e3s4, node, propertyId)) {
        var idProp = node.d3n(propertyId);
        var targetId = idProp.uv();
        if (!(targetId == null)) {
          referencedNodeIds.j(targetId);
        }
      }
    }
    var _iterator__ex2g4s_0 = node.z3d().m();
    while (_iterator__ex2g4s_0.n()) {
      var childId = _iterator__ex2g4s_0.o();
      var childNodes = node.p3m(childId);
      var _iterator__ex2g4s_1 = childNodes.m();
      while (_iterator__ex2g4s_1.n()) {
        var childNode = _iterator__ex2g4s_1.o();
        findInternalReferences($this, _this__u8e3s4, childNode, internalNodeIds, referencedNodeIds);
      }
    }
  }
  function BaseNodeCloneSupport$_get_preservingCloner_$lambda_fq5e8v(node) {
    var tmp = toDomainNode(toOtNode(node).h3o(), get_wrapperContextOrNull(node));
    return isInterface(tmp, DomainNode) ? tmp : THROW_CCE();
  }
  function BaseNodeCloneSupport$copyListNoPreservation$nodeCopier$1(this$0, $internalReferenceIds, $oldToNewIdMap) {
    this.rd9_1 = this$0;
    this.sd9_1 = $internalReferenceIds;
    this.td9_1 = $oldToNewIdMap;
    NodeCopier.call(this);
  }
  protoOf(BaseNodeCloneSupport$copyListNoPreservation$nodeCopier$1).v3q = function (node) {
    var newNode = this.rd9_1.qd9_1.h3t(node.e3m_1);
    var oldId = node.l3o();
    if (this.sd9_1.t(oldId)) {
      var newId = newNode.l3o();
      // Inline function 'kotlin.collections.set' call
      this.td9_1.t2(oldId, newId);
    }
    return newNode;
  };
  function BaseNodeCloneSupport(conceptRegistry, nodeFactory) {
    this.pd9_1 = conceptRegistry;
    this.qd9_1 = nodeFactory;
  }
  protoOf(BaseNodeCloneSupport).ud9 = function (sourceItem, preserveMode) {
    var list = this.vd9(listOf(sourceItem), preserveMode);
    return first(list);
  };
  protoOf(BaseNodeCloneSupport).cav = function (sourceItem, preserveMode) {
    return this.ud9((!(sourceItem == null) ? isInterface(sourceItem, DomainNode) : false) ? sourceItem : THROW_CCE(), preserveMode);
  };
  protoOf(BaseNodeCloneSupport).vd9 = function (sourceItems, preserveMode) {
    // Inline function 'kotlin.collections.isNotEmpty' call
    // Inline function 'kotlin.require' call
    if (!!sourceItems.s()) {
      var message = 'source items are empty';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    var tmp;
    if (preserveMode) {
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(sourceItems, 10));
      var _iterator__ex2g4s = sourceItems.m();
      while (_iterator__ex2g4s.n()) {
        var item = _iterator__ex2g4s.o();
        var tmp$ret$3 = _get_preservingCloner__c4xitv(this)(item);
        destination.j(tmp$ret$3);
      }
      tmp = destination;
    } else {
      tmp = copyListNoPreservation(this, sourceItems);
    }
    return tmp;
  };
  protoOf(BaseNodeCloneSupport).dav = function (sourceItems, preserveMode) {
    return this.vd9(sourceItems, preserveMode);
  };
  function getNodeClipboardParameters(sourceClass, conceptRegistry, nodeFactory, nodeAdaptationSupport) {
    var cloneSupport = new BaseNodeCloneSupport(conceptRegistry, nodeFactory);
    var tmp = NodeContentKind_instance;
    var tmp_0 = EditorNode$_init_$ref_q6smba();
    return new ClipboardParameters(tmp, cloneSupport, tmp_0, getNodeClipboardParameters$lambda(nodeAdaptationSupport, sourceClass));
  }
  function EditorNode$_init_$ref_q6smba() {
    var l = function (p0) {
      return new EditorNode(p0);
    };
    l.callableName = '<init>';
    return l;
  }
  function getNodeClipboardParameters$lambda($nodeAdaptationSupport, $sourceClass) {
    return function (content) {
      var tmp0_safe_receiver = $nodeAdaptationSupport.l6x(content.oct_1, $sourceClass);
      var tmp;
      if (tmp0_safe_receiver == null) {
        tmp = null;
      } else {
        // Inline function 'kotlin.also' call
        // Inline function 'kotlin.check' call
        if (!$sourceClass.sa(tmp0_safe_receiver)) {
          throw IllegalStateException_init_$Create$_0('Check failed.');
        }
        tmp = tmp0_safe_receiver;
      }
      return tmp;
    };
  }
  function referenceTarget(_this__u8e3s4, targetClass, childPlaceholderText, referenceTag, referenceProvider, referencedPropertySupplier, validator, options, containerInit, textCellInit) {
    options = options === VOID ? new CompletionOptions() : options;
    var tmp;
    if (referencedPropertySupplier == null) {
      tmp = referenceTarget$lambda(_this__u8e3s4, referenceTag);
    } else {
      tmp = referencedPropertySupplier;
    }
    var presentationQuery = tmp;
    var referenceTextPropSupplier = getLoopQuerySupplier(presentationQuery);
    return referenceTarget_0(_this__u8e3s4, targetClass, childPlaceholderText, referenceTag, referenceProvider, referenceTextPropSupplier, validator, options, containerInit, textCellInit);
  }
  function referenceTarget_0(_this__u8e3s4, targetClass, childPlaceholderText, referenceTag, referenceProvider, referenceTextPropSupplier, validator, options, containerInit, textCellInit) {
    var commonConfig = get_internalConfig(_this__u8e3s4).ud0();
    var refCompletion = referenceTarget$lambda_0(commonConfig, referenceTag, referenceProvider, options);
    var roleEditor = getReferenceRoleEditor(_this__u8e3s4, targetClass, referenceTag.x6l_1, referenceTextPropSupplier, refCompletion, validator, referenceProvider, containerInit, textCellInit);
    var roleSpec = new ChildRoleSpec(roleEditor.sd5(), childPlaceholderText);
    var tmp = referenceTarget$lambda_1;
    var tmp_0 = referenceTarget$lambda_2(_this__u8e3s4, refCompletion);
    var tmp_1 = referenceTarget$lambda_3(referenceProvider);
    return extendedChild(_this__u8e3s4, roleSpec, tmp, tmp_0, tmp_1, referenceTarget$lambda_4(commonConfig, referenceProvider));
  }
  function getReferenceRoleEditor(_this__u8e3s4, targetClass, contentClass, referencedTextPropSupplier, refCompletion, validator, referenceProvider, containerInit, textCellInit) {
    var tmp = get_internalConfig(_this__u8e3s4);
    return editor_0(tmp, targetClass, getReferenceRoleEditor$lambda(validator, containerInit, referencedTextPropSupplier, contentClass, referenceProvider, textCellInit, refCompletion));
  }
  function $runSuspendCOROUTINE$_36(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.eda_1 = _this__u8e3s4;
    this.fda_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_36).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            var $this$suspendingQuery = this.fda_1;
            this.f9_1 = 1;
            suspendResult = $this$suspendingQuery.k60(this.eda_1.gda_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp0_elvis_lhs = suspendResult;
            return tmp0_elvis_lhs == null ? '<no presentation>' : tmp0_elvis_lhs;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function referenceTarget$2$$inlined$mapSuspending$1($this) {
    this.gda_1 = $this;
  }
  protoOf(referenceTarget$2$$inlined$mapSuspending$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_36(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(referenceTarget$2$$inlined$mapSuspending$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function referenceTarget$lambda($this_referenceTarget, $referenceTag) {
    return function (target) {
      // Inline function 'jetbrains.ocelot.langDef.query.mapSuspending' call
      var this_0 = getPresentation(get_internalConfig($this_referenceTarget).ud0(), $referenceTag, target);
      // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
      return new referenceTarget$2$$inlined$mapSuspending$1(this_0);
    };
  }
  function referenceTarget$lambda_0($commonConfig, $referenceTag, $referenceProvider, $options) {
    return function (src, cell, cellAction) {
      return completion($commonConfig, $commonConfig.d6u($referenceTag), src, $referenceProvider(src), cell, $options, cellAction);
    };
  }
  function referenceTarget$lambda_1(_unused_var__etf5q3, cell) {
    return get_forQueries(referenceData(cell).jda_1);
  }
  function referenceTarget$lambda$o$get$lambda($cell) {
    return function (it) {
      return signalCompletionHappened($cell, false, it);
    };
  }
  function referenceTarget$4$$inlined$propertyFromCellTrait$1($propSpec, $refCompletion, $source) {
    this.rda_1 = $propSpec;
    this.sda_1 = $refCompletion;
    this.tda_1 = $source;
    CellTrait.call(this);
  }
  protoOf(referenceTarget$4$$inlined$propertyFromCellTrait$1).n91 = function (cell, spec) {
    var tmp;
    if (spec === this.rda_1) {
      tmp = this.sda_1(this.tda_1, cell, referenceTarget$lambda$o$get$lambda(cell));
    } else {
      tmp = protoOf(CellTrait).n91.call(this, cell, spec);
    }
    return tmp;
  };
  function referenceTarget$lambda_2($this_referenceTarget, $refCompletion) {
    return function (source, trait) {
      // Inline function 'jetbrains.ocelot.projectional.cell.trait.propertyFromCellTrait' call
      var propSpec = Completion_getInstance().u9d_1;
      var notifyTrait = new referenceTarget$4$$inlined$propertyFromCellTrait$1(propSpec, $refCompletion, source);
      var tmp;
      if ($this_referenceTarget.ld0().ad2()) {
        tmp = CompositeCellTraits_instance.ra6([notifyTrait, trait]);
      } else {
        tmp = CompositeCellTraits_instance.ra6([notifyTrait, get_spaceDoesntCloseCompletion(), trait]);
      }
      return tmp;
    };
  }
  function referenceTarget$lambda_3($referenceProvider) {
    return function ($this$extendedChild) {
      Companion_getInstance_251().vda($this$extendedChild.qd0());
      var referenceData_0 = referenceData($this$extendedChild.qd0());
      referenceData_0.wda($this$extendedChild.m6d(), $referenceProvider($this$extendedChild.m6d()));
      return Unit_instance;
    };
  }
  function referenceTarget$8$focusKeeper$1($this_extendedChild) {
    this.xda_1 = $this_extendedChild;
  }
  protoOf(referenceTarget$8$focusKeeper$1).yda = function () {
    return isDescendantCellFocused(this.xda_1.qd0());
  };
  protoOf(referenceTarget$8$focusKeeper$1).zda = function () {
    toPlaceholderOrEndOfFocusable(this.xda_1.qd0())();
  };
  function referenceTarget$lambda_4($commonConfig, $referenceProvider) {
    return function ($this$extendedChild) {
      var tmp;
      if (get_internalConfig($this$extendedChild).nd0().wct_1) {
        tmp = new referenceTarget$8$focusKeeper$1($this$extendedChild);
      } else {
        tmp = null;
      }
      var focusKeeper = tmp;
      var tmp0 = $commonConfig;
      var tmp2 = $this$extendedChild.m6d();
      var tmp4 = $this$extendedChild.qd0();
      var tmp6 = $referenceProvider;
      // Inline function 'jetbrains.ocelot.langDef.references.synchronizers.getReferenceTargetSync' call
      var asyncTracker = new CellAsyncTracker($this$extendedChild.qd0());
      var referenceData_0 = referenceData(tmp4);
      var tmp$ret$0 = ReferenceSynchronizers_instance.bdb(tmp0, tmp6(tmp2), referenceData_0.jda_1, ResolveKind_LOOSE_getInstance(), focusKeeper, asyncTracker);
      $this$extendedChild.l8b(tmp$ret$0);
      $this$extendedChild.l8b(getReferenceDataMonitorSynchronizer($this$extendedChild.qd0()));
      var tmp_0;
      if (get_internalConfig($this$extendedChild).nd0().yct_1) {
        $this$extendedChild.l8b(referenceOutOfScopeSynchronizer($commonConfig, $this$extendedChild.qd0(), $referenceProvider($this$extendedChild.m6d())));
        $this$extendedChild.l8b(highlightReferenceTargetOutOfSync($this$extendedChild.qd0(), $this$extendedChild.qd0().n92(ReferenceCells_getInstance().cdb_1)));
        tmp_0 = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function getReferenceRoleEditor$2$2$2$$inlined$propertyTrait$1($propSpec, $textCell, $refCompletion) {
    this.ddb_1 = $propSpec;
    this.edb_1 = $textCell;
    this.fdb_1 = $refCompletion;
    CellTrait.call(this);
  }
  protoOf(getReferenceRoleEditor$2$2$2$$inlined$propertyTrait$1).n91 = function (cell, spec) {
    var tmp;
    if (spec === this.ddb_1) {
      var refCompletionArgs = getRefCompletionArgs(this.edb_1);
      var source = refCompletionArgs.gdb_1;
      var cellAction = refCompletionArgs.hdb_1;
      tmp = this.fdb_1(source, this.edb_1, cellAction);
    } else {
      tmp = protoOf(CellTrait).n91.call(this, cell, spec);
    }
    return tmp;
  };
  function getReferenceRoleEditor$lambda$lambda$lambda($this_editableText, $refCompletion) {
    return function (_unused_var__etf5q3, textCell, _unused_var__etf5q3_0) {
      // Inline function 'jetbrains.ocelot.projectional.cell.trait.propertyTrait' call
      var propSpec = Completion_getInstance().u9d_1;
      var completionTrait = new getReferenceRoleEditor$2$2$2$$inlined$propertyTrait$1(propSpec, textCell, $refCompletion);
      var tmp;
      if ($this_editableText.ld0().ad2()) {
        tmp = completionTrait;
      } else {
        tmp = CompositeCellTraits_instance.ra6([get_spaceDoesntCloseCompletion(), completionTrait]);
      }
      return tmp;
    };
  }
  function getReferenceRoleEditor$lambda$lambda($referencedTextPropSupplier, $coroutineScope, $referencedTextProp, $contentClass, $referenceProvider, $textCellInit, $refCompletion) {
    return function ($this$editableText) {
      var textPropSupplier = $referencedTextPropSupplier($this$editableText.m6d(), $coroutineScope, $this$editableText.qd0());
      $referencedTextProp._v = textPropSupplier;
      $this$editableText.l8b(syncOneWay(textPropSupplier, $this$editableText.qd0().o8w()));
      var disposableRefSupport = connectWithRefSupport($this$editableText.qd0(), textPropSupplier, $contentClass, $referenceProvider);
      asInternalEditorBuilder($this$editableText).td5(disposableRefSupport);
      addTraitOnAttach_0($this$editableText, getReferenceRoleEditor$lambda$lambda$lambda($this$editableText, $refCompletion));
      $textCellInit($this$editableText);
      return Unit_instance;
    };
  }
  function getReferenceRoleEditor$2$4$1($referenceDataProp, $this_label) {
    this.idb_1 = $referenceDataProp;
    this.jdb_1 = $this_label;
  }
  protoOf(getReferenceRoleEditor$2$4$1).c8y = function (container) {
    this.idb_1.d2x(get_enclosingRefData(this.jdb_1.qd0()));
  };
  function getReferenceRoleEditor$2$4$textProp$1($referencedTextProp, $referenceDataProp) {
    this.odb_1 = $referenceDataProp;
    DerivedProperty.call(this, [ensureNotNull($referencedTextProp._v), $referenceDataProp]);
  }
  protoOf(getReferenceRoleEditor$2$4$textProp$1).q2w = function () {
    var referenceData = this.odb_1.uv();
    var tmp;
    if (referenceData == null) {
      tmp = '?';
    } else {
      var targetProp = referenceData.jda_1;
      var tmp_0 = targetProp.uv();
      var nodeValue = (tmp_0 == null ? true : isInterface(tmp_0, DomainNode)) ? tmp_0 : THROW_CCE();
      var tmp1_elvis_lhs = nodeValue == null ? null : getDebugIdText(nodeValue);
      tmp = tmp1_elvis_lhs == null ? '?' : tmp1_elvis_lhs;
    }
    var value = tmp;
    return '(' + value + ')';
  };
  function getReferenceRoleEditor$lambda$lambda_0($referencedTextProp) {
    return function ($this$label) {
      var referenceDataProp = new ValueProperty(null);
      var tmp = $this$label.qd0();
      tmp.y90(new getReferenceRoleEditor$2$4$1(referenceDataProp, $this$label));
      var textProp = new getReferenceRoleEditor$2$4$textProp$1($referencedTextProp, referenceDataProp);
      $this$label.l8b(syncOneWay(textProp, $this$label.qd0().o8w()));
      return Unit_instance;
    };
  }
  function getReferenceRoleEditor$lambda($validator, $containerInit, $referencedTextPropSupplier, $contentClass, $referenceProvider, $textCellInit, $refCompletion) {
    return function ($this$editor) {
      $this$editor.qd0().g93(Companion_getInstance_236().tca_1, true);
      $this$editor.qd0().g93(Companion_getInstance_237().jcb_1, true);
      $this$editor.qd0().g93(Cells_getInstance().h9t_1, true);
      var coroutineScope = get_internalConfig($this$editor).ud0();
      var referencedTextProp = {_v: null};
      editableText_0($this$editor, VOID, '<no reference>', $validator, VOID, getReferenceRoleEditor$lambda$lambda($referencedTextPropSupplier, coroutineScope, referencedTextProp, $contentClass, $referenceProvider, $textCellInit, $refCompletion));
      var tmp;
      if (false) {
        label_0($this$editor, '', VOID, VOID, getReferenceRoleEditor$lambda$lambda_0(referencedTextProp));
        tmp = Unit_instance;
      }
      $containerInit($this$editor);
      return Unit_instance;
    };
  }
  function EditorMapperFactory() {
  }
  function getCollectionPlaceholderCompletionSupplier(mapper, roleCompletion) {
    var elementPlaceholder = mapper.e86_1;
    var role = new getCollectionPlaceholderCompletionSupplier$role$1(elementPlaceholder, mapper);
    return roleCompletion.oan(mapper, elementPlaceholder, role);
  }
  function getCollectionPlaceholderCompletionSupplier$role$1($elementPlaceholder, $mapper) {
    this.pdb_1 = $elementPlaceholder;
    this.qdb_1 = $mapper;
  }
  protoOf(getCollectionPlaceholderCompletionSupplier$role$1).rdb = function (target) {
    this.pdb_1.d6j(target);
    var tmp0_safe_receiver = firstOrNull_0(getMapperCellFinder(this.qdb_1.b88()).lah(target));
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.c93(ProjectionalSynchronizers_getInstance().d99_1);
    return tmp1_elvis_lhs == null ? get_EMPTY_CELL_ACTION() : tmp1_elvis_lhs;
  };
  protoOf(getCollectionPlaceholderCompletionSupplier$role$1).yak = function (target) {
    return this.rdb(isInterface(target, DomainNode) ? target : THROW_CCE());
  };
  function prevCellIsPlaceholderOrNone(_this__u8e3s4, cell) {
    if (cell.s8x() == null) {
      depend(_this__u8e3s4, cell.x92());
      return _this__u8e3s4.z5v(true);
    }
    var tmp0_elvis_lhs = cell.s35();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return _this__u8e3s4.z5v(true);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var endLeafCell = tmp;
    while (true) {
      if (endLeafCell instanceof TextCell) {
        return _this__u8e3s4.z5v(depend(_this__u8e3s4, endLeafCell.m92()) && isPlaceholder(endLeafCell));
      }
      if (!(endLeafCell instanceof IndentCell)) {
        return _this__u8e3s4.z5v(false);
      }
      var tmp1_elvis_lhs = lastOrNull(depend_0(_this__u8e3s4, endLeafCell.o35()));
      var tmp_0;
      if (tmp1_elvis_lhs == null) {
        return _this__u8e3s4.z5v(false);
      } else {
        tmp_0 = tmp1_elvis_lhs;
      }
      endLeafCell = tmp_0;
    }
  }
  function getLoopQuerySupplier(property) {
    return getLoopQuerySupplier$lambda(property);
  }
  function getLoopQuery(coroutineScope, property, source, textCell) {
    var query = property(source);
    var loopingQuery = new LoopingQuery(coroutineScope.ho(), query, VOID, new CellAsyncTracker(textCell));
    return withDefault(loopingQuery, '');
  }
  function getLoopQuerySupplier$lambda($property) {
    return function (target, coroutineScope, textCell) {
      return getLoopQuery(coroutineScope, $property, target, textCell);
    };
  }
  function ReferenceCells() {
    ReferenceCells_instance = this;
    this.cdb_1 = CellPropertySpec_init_$Create$('outOfSyncWithReferenceTarget', false);
  }
  var ReferenceCells_instance;
  function ReferenceCells_getInstance() {
    if (ReferenceCells_instance == null)
      new ReferenceCells();
    return ReferenceCells_instance;
  }
  function get_GET_TARGET() {
    _init_properties_ReferenceTrait_kt__jsd8bn();
    return GET_TARGET;
  }
  var GET_TARGET;
  function constantReferenceTrait(target) {
    _init_properties_ReferenceTrait_kt__jsd8bn();
    return new ReferenceTrait(constantReferenceTrait$slambda_0(target, null));
  }
  function $runSuspendCOROUTINE$_37(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.adc_1 = _this__u8e3s4;
    this.bdc_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_37).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            var $this$executeSuspendingQuery = this.bdc_1;
            this.f9_1 = 1;
            suspendResult = this.adc_1.ddc_1.cdc_1($this$executeSuspendingQuery, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function ReferenceTrait$get$2$$inlined$executeSuspendingQuery$1(this$0) {
    this.ddc_1 = this$0;
  }
  protoOf(ReferenceTrait$get$2$$inlined$executeSuspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_37(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(ReferenceTrait$get$2$$inlined$executeSuspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function ReferenceTrait$get$slambda(this$0, resultContinuation) {
    this.mdc_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ReferenceTrait$get$slambda).odc = function ($completion) {
    var tmp = this.y9e($completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(ReferenceTrait$get$slambda).z9e = function ($completion) {
    return this.odc($completion);
  };
  protoOf(ReferenceTrait$get$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 3;
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = execute_1(new ReferenceTrait$get$2$$inlined$executeSuspendingQuery$1(this.mdc_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.ndc_1 = suspendResult;
            this.g9_1 = 3;
            this.f9_1 = 4;
            continue $sm;
          case 2:
            this.g9_1 = 3;
            var tmp_0 = this.i9_1;
            if (tmp_0 instanceof Error) {
              var e = this.i9_1;
              var tmp_1 = this;
              ThrowableHandlers_getInstance().k2r_1.j2r(e);
              tmp_1.ndc_1 = null;
              this.f9_1 = 4;
              continue $sm;
            } else {
              throw this.i9_1;
            }

          case 3:
            throw this.i9_1;
          case 4:
            this.g9_1 = 3;
            return this.ndc_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.g9_1 === 3) {
          throw e_0;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(ReferenceTrait$get$slambda).y9e = function (completion) {
    return new ReferenceTrait$get$slambda(this.mdc_1, completion);
  };
  function ReferenceTrait$get$slambda_0(this$0, resultContinuation) {
    var i = new ReferenceTrait$get$slambda(this$0, resultContinuation);
    var l = function ($completion) {
      return i.odc($completion);
    };
    l.$arity = 0;
    return l;
  }
  function ReferenceTrait(f) {
    CellTrait.call(this);
    this.cdc_1 = f;
  }
  protoOf(ReferenceTrait).n91 = function (cell, spec) {
    var tmp;
    if (equals(spec, get_GET_TARGET())) {
      // Inline function 'kotlin.suspend' call
      tmp = ReferenceTrait$get$slambda_0(this, null);
    } else {
      tmp = protoOf(CellTrait).n91.call(this, cell, spec);
    }
    return tmp;
  };
  function referenceTrait(reference) {
    _init_properties_ReferenceTrait_kt__jsd8bn();
    return new ReferenceTrait(referenceTrait$slambda_0(reference, null));
  }
  function constantReferenceTrait$slambda($target, resultContinuation) {
    this.xdc_1 = $target;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(constantReferenceTrait$slambda).zdc = function ($this$ReferenceTrait, $completion) {
    var tmp = this.add($this$ReferenceTrait, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(constantReferenceTrait$slambda).v9 = function (p1, $completion) {
    return this.zdc(p1 instanceof QueryBuilder ? p1 : THROW_CCE(), $completion);
  };
  protoOf(constantReferenceTrait$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        if (tmp === 0) {
          this.g9_1 = 1;
          return this.xdc_1;
        } else if (tmp === 1) {
          throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(constantReferenceTrait$slambda).add = function ($this$ReferenceTrait, completion) {
    var i = new constantReferenceTrait$slambda(this.xdc_1, completion);
    i.ydc_1 = $this$ReferenceTrait;
    return i;
  };
  function constantReferenceTrait$slambda_0($target, resultContinuation) {
    var i = new constantReferenceTrait$slambda($target, resultContinuation);
    var l = function ($this$ReferenceTrait, $completion) {
      return i.zdc($this$ReferenceTrait, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function referenceTrait$slambda($reference, resultContinuation) {
    this.jdd_1 = $reference;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(referenceTrait$slambda).zdc = function ($this$ReferenceTrait, $completion) {
    var tmp = this.add($this$ReferenceTrait, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(referenceTrait$slambda).v9 = function (p1, $completion) {
    return this.zdc(p1 instanceof QueryBuilder ? p1 : THROW_CCE(), $completion);
  };
  protoOf(referenceTrait$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.kdd_1.k60(this.jdd_1.x6o(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(referenceTrait$slambda).add = function ($this$ReferenceTrait, completion) {
    var i = new referenceTrait$slambda(this.jdd_1, completion);
    i.kdd_1 = $this$ReferenceTrait;
    return i;
  };
  function referenceTrait$slambda_0($reference, resultContinuation) {
    var i = new referenceTrait$slambda($reference, resultContinuation);
    var l = function ($this$ReferenceTrait, $completion) {
      return i.zdc($this$ReferenceTrait, $completion);
    };
    l.$arity = 1;
    return l;
  }
  var properties_initialized_ReferenceTrait_kt_7039y3;
  function _init_properties_ReferenceTrait_kt__jsd8bn() {
    if (!properties_initialized_ReferenceTrait_kt_7039y3) {
      properties_initialized_ReferenceTrait_kt_7039y3 = true;
      GET_TARGET = CellTraitPropertySpec_init_$Create$('resolveFunction', null);
    }
  }
  function focusGuarded(_this__u8e3s4, focusKeeper) {
    var writableProperty = _this__u8e3s4;
    return new focusGuarded$1(writableProperty, focusKeeper);
  }
  function guardFocus(focusKeeper, block) {
    var hadFocusBefore = focusKeeper.yda();
    try {
      return block();
    }finally {
      if (hadFocusBefore && !focusKeeper.yda()) {
        focusKeeper.zda();
      }
    }
  }
  function focusGuarded$o$set$lambda($writableProperty, $newValue) {
    return function () {
      $writableProperty.d2x($newValue);
      return Unit_instance;
    };
  }
  function focusGuarded$1($writableProperty, $focusKeeper) {
    this.ldd_1 = $writableProperty;
    this.mdd_1 = $focusKeeper;
  }
  protoOf(focusGuarded$1).vv = function (newValue) {
    if (newValue == null) {
      this.ldd_1.d2x(newValue);
    } else {
      guardFocus(this.mdd_1, focusGuarded$o$set$lambda(this.ldd_1, newValue));
    }
  };
  protoOf(focusGuarded$1).d2x = function (newValue) {
    return this.vv((newValue == null ? true : !(newValue == null)) ? newValue : THROW_CCE());
  };
  function RefCompletionArgs(source, completionAction) {
    this.gdb_1 = source;
    this.hdb_1 = completionAction;
  }
  protoOf(RefCompletionArgs).toString = function () {
    return 'RefCompletionArgs(source=' + toString_0(this.gdb_1) + ', completionAction=' + toString_1(this.hdb_1) + ')';
  };
  protoOf(RefCompletionArgs).hashCode = function () {
    var result = this.gdb_1 == null ? 0 : hashCode(this.gdb_1);
    result = imul(result, 31) + hashCode(this.hdb_1) | 0;
    return result;
  };
  protoOf(RefCompletionArgs).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RefCompletionArgs))
      return false;
    if (!equals(this.gdb_1, other.gdb_1))
      return false;
    if (!equals(this.hdb_1, other.hdb_1))
      return false;
    return true;
  };
  function getRefCompletionArgs(textCell) {
    var referenceData = get_enclosingRefData(textCell);
    var completionAction = getRefCompletionArgs$lambda(textCell);
    var referenceDataSource = ensureNotNull(referenceData.ida_1);
    var source = !(referenceDataSource == null) ? referenceDataSource : THROW_CCE();
    return new RefCompletionArgs(source, completionAction);
  }
  function getRefCompletionArgs$lambda$lambda($textCell, $item) {
    return function () {
      $textCell.o8w().f2x($item.l6q_1);
      return Unit_instance;
    };
  }
  function getRefCompletionArgs$lambda($textCell) {
    return function (item) {
      return seqActions([getRefCompletionArgs$lambda$lambda($textCell, item), signalCompletionHappened($textCell, true, item)]);
    };
  }
  function Companion_251() {
    Companion_instance_251 = this;
    this.uda_1 = CellPropertySpec_init_$Create$('refTargetSupport', null);
  }
  protoOf(Companion_251).vda = function (cell) {
    cell.i90(this.uda_1, new ReferenceData_0(cell));
  };
  var Companion_instance_251;
  function Companion_getInstance_251() {
    if (Companion_instance_251 == null)
      new Companion_251();
    return Companion_instance_251;
  }
  function ReferenceData$lambda(this$0) {
    return function (it) {
      var _unary__edvuaz = this$0.nda_1;
      this$0.nda_1 = add_2(_unary__edvuaz, get_ONE());
      return Unit_instance;
    };
  }
  function ReferenceData$attach$lambda(this$0) {
    return function (event) {
      this$0.mda_1 = event.t2y_1;
      return Unit_instance;
    };
  }
  function ReferenceData_0(bigCell) {
    Companion_getInstance_251();
    this.hda_1 = bigCell;
    this.ida_1 = null;
    this.jda_1 = new ValueProperty(null);
    this.kda_1 = null;
    this.lda_1 = null;
    this.mda_1 = null;
    this.nda_1 = 0n;
    this.oda_1 = -9223372036854775808n;
    this.pda_1 = false;
    this.qda_1 = null;
    this.jda_1.z2r(ReferenceData$lambda(this));
  }
  protoOf(ReferenceData_0).wda = function (source, ref) {
    this.ida_1 = source;
    this.kda_1 = ref.z6o().m5y();
    var tmp = ensureNotNull(this.kda_1);
    tmp.z2r(ReferenceData$attach$lambda(this));
  };
  protoOf(ReferenceData_0).ndd = function (inside, refContents) {
    this.oda_1 = this.nda_1;
    this.pda_1 = inside;
    this.lda_1 = refContents;
  };
  protoOf(ReferenceData_0).odd = function () {
    var tmp;
    var tmp_0;
    var tmp_1 = this.nda_1;
    // Inline function 'kotlin.Long.plus' call
    var this_0 = this.oda_1;
    if (tmp_1 === add_2(this_0, fromInt_0(1))) {
      tmp_0 = equals(this.lda_1, this.mda_1);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.nda_1 > 0n;
    } else {
      tmp = false;
    }
    return tmp;
  };
  function get_enclosingRefData(_this__u8e3s4) {
    var tmp = ancestors(_this__u8e3s4);
    return first_1(filterNotNull_0(map(tmp, _get_enclosingRefData_$lambda_pshpn5)));
  }
  function signalCompletionHappened(_this__u8e3s4, inside, item) {
    return signalCompletionHappened$lambda(_this__u8e3s4, inside, item);
  }
  function referenceData(_this__u8e3s4) {
    var referenceData = ensureNotNull(_this__u8e3s4.k91(Companion_getInstance_251().uda_1));
    return referenceData instanceof ReferenceData_0 ? referenceData : THROW_CCE();
  }
  function _get_enclosingRefData_$lambda_pshpn5(cell) {
    return cell.k91(Companion_getInstance_251().uda_1);
  }
  function signalCompletionHappened$lambda($this_signalCompletionHappened, $inside, $item) {
    return function () {
      var referenceData = get_enclosingRefData($this_signalCompletionHappened);
      referenceData.ndd($inside, $item.k6q_1);
      return Unit_instance;
    };
  }
  function getReferenceDataMonitorSynchronizer(cell) {
    var referenceData_0 = referenceData(cell);
    var tmp = Synchronizers_instance;
    return tmp.f8b(referenceData_0.jda_1, getReferenceDataMonitorSynchronizer$lambda(referenceData_0, cell));
  }
  function connectWithRefSupport(textCell, currentTargetText, contentClass, referenceProvider) {
    var disposable = new CompositeDisposable([]);
    disposable.j2l(whenAttached_0(textCell, connectWithRefSupport$lambda(textCell, disposable, referenceProvider, currentTargetText)));
    return disposable;
  }
  function toPlaceholderOrEndOfFocusable(_this__u8e3s4) {
    return toPlaceholderOrEndOfFocusable$lambda(_this__u8e3s4);
  }
  function whenAttached_0(_this__u8e3s4, f) {
    return whenAttached(_this__u8e3s4, whenAttached$lambda_0(_this__u8e3s4, f));
  }
  function eventuallyFalse(_this__u8e3s4, handler) {
    var d = _this__u8e3s4.z2r(eventuallyFalse$lambda(handler));
    var tmp = eventuallyFalse$lambda_0(handler);
    return d.j2l(new sam$jetbrains_ocelot_base_disposable_Disposable$0_5(tmp));
  }
  function sam$jetbrains_ocelot_base_disposable_Disposable$0_5(function_0) {
    this.pdd_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0_5).zr = function () {
    return this.pdd_1();
  };
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0_5).f3 = function () {
    return this.pdd_1;
  };
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0_5).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Disposable) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0_5).hashCode = function () {
    return hashCode(this.f3());
  };
  function getReferenceDataMonitorSynchronizer$lambda$lambda($this$actionWhenSettled) {
    return toEnd_0($this$actionWhenSettled);
  }
  function getReferenceDataMonitorSynchronizer$lambda($referenceData, $cell) {
    return function () {
      var tmp;
      if ($referenceData.odd()) {
        var tmp_0;
        if ($referenceData.pda_1 && !($referenceData.qda_1 == null)) {
          var tmp_1 = ensureNotNull($referenceData.qda_1);
          tmp_0 = actionWhenSettled(tmp_1, getReferenceDataMonitorSynchronizer$lambda$lambda);
        } else {
          tmp_0 = toPlaceholderOrEndOfFocusable($cell);
        }
        var action = tmp_0;
        tmp = action();
      }
      return Unit_instance;
    };
  }
  function connectWithRefSupport$2$1($referenceData, $referenceProvider, $sourceNode) {
    this.qdd_1 = $referenceData;
    this.rdd_1 = $referenceProvider;
    this.sdd_1 = $sourceNode;
    CellTrait.call(this);
  }
  protoOf(connectWithRefSupport$2$1).i8y = function (cell, spec, event) {
    if (spec === Cells_getInstance().g9t_1) {
      var derivedBecameEmpty = new DerivedEvent(event);
      this.qdd_1.hda_1.v92(derivedBecameEmpty, Cells_getInstance().g9t_1);
      this.rdd_1(this.sdd_1).b6p(null);
      this.qdd_1.jda_1.d2x(null);
      if (!derivedBecameEmpty.l8i_1)
        toFirstFocusable(this.qdd_1.hda_1)();
    } else {
      protoOf(CellTrait).i8y.call(this, cell, spec, event);
    }
  };
  function connectWithRefSupport$lambda$lambda($referenceProvider, $sourceNode) {
    return function (it) {
      var tmp;
      if (it.t2y_1 == null) {
        $referenceProvider($sourceNode).b6p(null);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function connectWithRefSupport$lambda$lambda_0($referenceData) {
    return function (bool) {
      $referenceData.hda_1.i90(ReferenceCells_getInstance().cdb_1, bool);
      return Unit_instance;
    };
  }
  function connectWithRefSupport$lambda($textCell, $disposable, $referenceProvider, $currentTargetText) {
    return function (referenceData) {
      var tmp = referenceData.ida_1;
      var sourceNode = (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
      referenceData.qda_1 = $textCell;
      $disposable.j2l($textCell.w92(referenceTrait($referenceProvider(sourceNode))));
      $disposable.j2l($textCell.w92(new connectWithRefSupport$2$1(referenceData, $referenceProvider, sourceNode)));
      $disposable.j2l(referenceData.jda_1.z2r(connectWithRefSupport$lambda$lambda($referenceProvider, sourceNode)));
      var tmp_0 = notEqual($textCell.o8w(), $currentTargetText);
      $disposable.j2l(eventuallyFalse(tmp_0, connectWithRefSupport$lambda$lambda_0(referenceData)));
      return Unit_instance;
    };
  }
  function toPlaceholderOrEndOfFocusable$lambda$lambda(it) {
    var tmp0_elvis_lhs = getFirstPlaceholder(it);
    return tmp0_elvis_lhs == null ? firstFocusable(it) : tmp0_elvis_lhs;
  }
  function toPlaceholderOrEndOfFocusable$lambda$lambda_0(it) {
    return toEnd_0(it);
  }
  function toPlaceholderOrEndOfFocusable$lambda($this_toPlaceholderOrEndOfFocusable) {
    return function () {
      var tmp = toPlaceholderOrEndOfFocusable$lambda$lambda;
      whenSettled($this_toPlaceholderOrEndOfFocusable, tmp, toPlaceholderOrEndOfFocusable$lambda$lambda_0);
      return Unit_instance;
    };
  }
  function whenAttached$lambda_0($this_whenAttached, $f) {
    return function () {
      var referenceData = get_enclosingRefData($this_whenAttached);
      $f(referenceData);
      return Unit_instance;
    };
  }
  function eventuallyFalse$lambda($handler) {
    return function (event) {
      $handler(event.t2y_1);
      return Unit_instance;
    };
  }
  function eventuallyFalse$lambda_0($handler) {
    return function () {
      $handler(false);
      return Unit_instance;
    };
  }
  function referenceOutOfScopeSynchronizer(coroutineScope, cell, ref) {
    var outOfScopeMessage = new referenceOutOfScopeSynchronizer$outOfScopeMessage$1(cell, ref);
    var target = new ValueProperty(Unit_instance);
    var notResolved = and(isNull(target), not(isNull(ref.c6p())));
    var tmp = Synchronizers_instance;
    var tmp_0 = ReferenceSynchronizers_instance.tdd(coroutineScope, ref, target, ResolveKind_STRICT_getInstance());
    // Inline function 'jetbrains.ocelot.mapper.core.Synchronizers.forDisposable' call
    var tmp$ret$0 = new referenceOutOfScopeSynchronizer$$inlined$forDisposable$1(notResolved, outOfScopeMessage);
    return tmp.h8b([tmp_0, tmp$ret$0]);
  }
  function highlightReferenceTargetOutOfSync(cell, outOfSync) {
    var visual = new highlightReferenceTargetOutOfSync$visual$1(cell);
    return syncOneWay(outOfSync, visual);
  }
  function ReferenceSynchronizers$forReferenceTarget$slambda(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ReferenceSynchronizers$forReferenceTarget$slambda).dde = function (it, $completion) {
    var tmp = this.ede(it, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(ReferenceSynchronizers$forReferenceTarget$slambda).v9 = function (p1, $completion) {
    return this.dde(p1 instanceof Outcome ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ReferenceSynchronizers$forReferenceTarget$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = delay_0(300n, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return true;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(ReferenceSynchronizers$forReferenceTarget$slambda).ede = function (it, completion) {
    var i = new ReferenceSynchronizers$forReferenceTarget$slambda(completion);
    i.cde_1 = it;
    return i;
  };
  function ReferenceSynchronizers$forReferenceTarget$slambda_0(resultContinuation) {
    var i = new ReferenceSynchronizers$forReferenceTarget$slambda(resultContinuation);
    var l = function (it, $completion) {
      return i.dde(it, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function ReferenceSynchronizers() {
    this.adb_1 = 300n;
  }
  protoOf(ReferenceSynchronizers).bdb = function (coroutineScope, ref, target, resolveKind, focusKeeper, asyncTracker) {
    var tmp;
    if (focusKeeper == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp = focusGuarded(target, focusKeeper);
    }
    var tmp1_elvis_lhs = tmp;
    var guardedTarget = tmp1_elvis_lhs == null ? target : tmp1_elvis_lhs;
    var tmp_0 = coroutineScope.ho();
    var tmp_1;
    switch (resolveKind.x2_1) {
      case 0:
        tmp_1 = ref.w6o();
        break;
      case 1:
        tmp_1 = ref.x6o();
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    var tmp_2 = tmp_1;
    var query = new LoopingQuery(tmp_0, tmp_2, ReferenceSynchronizers$forReferenceTarget$slambda_0(null), asyncTracker);
    return syncOneWay(asNullableProperty(query), guardedTarget);
  };
  protoOf(ReferenceSynchronizers).tdd = function (coroutineScope, ref, target, resolveKind, focusKeeper, asyncTracker, $super) {
    focusKeeper = focusKeeper === VOID ? null : focusKeeper;
    asyncTracker = asyncTracker === VOID ? Companion_getInstance_38().h39_1 : asyncTracker;
    return $super === VOID ? this.bdb(coroutineScope, ref, target, resolveKind, focusKeeper, asyncTracker) : $super.bdb.call(this, coroutineScope, ref, target, resolveKind, focusKeeper, asyncTracker);
  };
  var ReferenceSynchronizers_instance;
  function ReferenceSynchronizers_getInstance() {
    return ReferenceSynchronizers_instance;
  }
  var ResolveKind_STRICT_instance;
  var ResolveKind_LOOSE_instance;
  var ResolveKind_entriesInitialized;
  function ResolveKind_initEntries() {
    if (ResolveKind_entriesInitialized)
      return Unit_instance;
    ResolveKind_entriesInitialized = true;
    ResolveKind_STRICT_instance = new ResolveKind('STRICT', 0);
    ResolveKind_LOOSE_instance = new ResolveKind('LOOSE', 1);
  }
  function ResolveKind(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function referenceOutOfScopeSynchronizer$outOfScopeMessage$1($cell, $ref) {
    this.gde_1 = $cell;
    this.hde_1 = $ref;
    this.fde_1 = Companion_getInstance_29().m2l_1;
  }
  protoOf(referenceOutOfScopeSynchronizer$outOfScopeMessage$1).z2o = function (newValue) {
    this.fde_1.zr();
    var tmp = this;
    var tmp_0;
    if (newValue) {
      tmp_0 = MessageController_getInstance().n9z(this.gde_1, 'out of scope (contents of reference: ' + toString_0(this.hde_1.c6p().w2w()) + ')').j2l(this.gde_1.i90(get_RED_UNDERLINE(), true));
    } else {
      tmp_0 = Companion_getInstance_29().m2l_1;
    }
    tmp.fde_1 = tmp_0;
  };
  protoOf(referenceOutOfScopeSynchronizer$outOfScopeMessage$1).d2x = function (newValue) {
    return this.z2o((!(newValue == null) ? typeof newValue === 'boolean' : false) ? newValue : THROW_CCE());
  };
  function referenceOutOfScopeSynchronizer$$inlined$forDisposable$1($notResolved, $outOfScopeMessage) {
    this.jde_1 = $notResolved;
    this.kde_1 = $outOfScopeMessage;
    DisposableSynchronizer.call(this);
  }
  protoOf(referenceOutOfScopeSynchronizer$$inlined$forDisposable$1).s87 = function (ctx) {
    return PropertyBinding_instance.n30(this.jde_1, this.kde_1);
  };
  function highlightReferenceTargetOutOfSync$visual$1($cell) {
    this.mde_1 = $cell;
    this.lde_1 = Companion_getInstance_29().m2l_1;
  }
  protoOf(highlightReferenceTargetOutOfSync$visual$1).z2o = function (newValue) {
    var tmp = this;
    var tmp_0;
    if (newValue) {
      tmp_0 = this.mde_1.i90(get_BACKGROUND(), Companion_getInstance_210().q95_1).j2l(this.mde_1.i90(get_RED_UNDERLINE(), true)).j2l(MessageController_getInstance().n9z(this.mde_1, 'Reference text has been changed and is inconsistent with the current target node'));
    } else {
      this.lde_1.zr();
      tmp_0 = Companion_getInstance_29().m2l_1;
    }
    tmp.lde_1 = tmp_0;
  };
  protoOf(highlightReferenceTargetOutOfSync$visual$1).d2x = function (newValue) {
    return this.z2o((!(newValue == null) ? typeof newValue === 'boolean' : false) ? newValue : THROW_CCE());
  };
  function ResolveKind_STRICT_getInstance() {
    ResolveKind_initEntries();
    return ResolveKind_STRICT_instance;
  }
  function ResolveKind_LOOSE_getInstance() {
    ResolveKind_initEntries();
    return ResolveKind_LOOSE_instance;
  }
  function findUsagesView(builder) {
    return new FindUsagesViewConfigImpl(builder);
  }
  function FindUsagesViewConfig(builder) {
    this.nde_1 = builder;
  }
  function addDefaultUsageView($this, _this__u8e3s4) {
    // Inline function 'jetbrains.ocelot.langDef.usages.viewFor' call
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
    var init = FindUsagesViewConfigImpl$addDefaultUsageView$lambda($this);
    var triggerDependencies = emptyList();
    var tmp = getKClass(DefaultUsagePresentation);
    var def = new EditorDefinition(tmp, null, null, false, false, triggerDependencies, FindUsagesViewConfigImpl$addDefaultUsageView$lambda_0(init));
    _this__u8e3s4.ode(def);
  }
  function showAnyNode($this, _this__u8e3s4, node) {
    var nodeProperty = new ValueProperty(node);
    var klass = getKClassFromExpression(node);
    var tmp = get_internalConfig(_this__u8e3s4).gd3().n6l(klass);
    var concept = isInterface(tmp, KClass) ? tmp : THROW_CCE();
    child_1(_this__u8e3s4, concept, FindUsagesViewConfigImpl$showAnyNode$lambda(nodeProperty));
  }
  function FindUsagesViewConfigImpl$addDefaultUsageView$lambda(this$0) {
    return function ($this$viewFor) {
      showAnyNode(this$0, $this$viewFor, $this$viewFor.m6d().x85_1);
      return Unit_instance;
    };
  }
  function FindUsagesViewConfigImpl$addDefaultUsageView$lambda_0($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function FindUsagesViewConfigImpl$showAnyNode$lambda($nodeProperty) {
    return function (it) {
      return get_forQueries($nodeProperty);
    };
  }
  function FindUsagesViewConfigImpl(builder) {
    FindUsagesViewConfig.call(this, builder);
  }
  protoOf(FindUsagesViewConfigImpl).qde = function () {
    var impl = new FindUsagesViewBuilderImpl();
    addDefaultUsageView(this, impl);
    this.nde_1(impl);
    return impl.rde_1;
  };
  function FindUsagesViewBuilderImpl() {
    var tmp = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.rde_1 = ArrayList_init_$Create$();
  }
  protoOf(FindUsagesViewBuilderImpl).ode = function (editor) {
    this.rde_1.j(editor);
  };
  function Logger() {
  }
  function JSLogger() {
  }
  protoOf(JSLogger).sde = function (msg, thrown) {
    return console.error(msg, thrown);
  };
  protoOf(JSLogger).ude = function (msg, thrown) {
    return console.warn(msg, thrown);
  };
  protoOf(JSLogger).wde = function (msg) {
    return console.info(msg);
  };
  protoOf(JSLogger).xde = function (msg) {
    return console.log(msg);
  };
  var JSLogger_instance;
  function JSLogger_getInstance() {
    return JSLogger_instance;
  }
  function getLogger(name) {
    return JSLogger_instance;
  }
  function getLogger_0(clazz) {
    return getLogger(ensureNotNull(clazz.ra()));
  }
  function edt($this, coroutineContext) {
    var tmp0_elvis_lhs = coroutineContext.s9(Key_getInstance_0());
    return tmp0_elvis_lhs == null ? get_asCoroutineDispatcher(get_platformEdt()) : tmp0_elvis_lhs;
  }
  function Companion_252() {
  }
  var Companion_instance_252;
  function Companion_getInstance_252() {
    return Companion_instance_252;
  }
  function DomainModel$services$lambda(this$0) {
    return function () {
      return this$0.zde_1.p6g();
    };
  }
  function DomainModel$services$lambda_0(it) {
    return new ResolveConfigImpl(ReferenceFactoryRegistryService_getInstance().e3b(it), ReferenceTargetsSuppliersRegistryService_getInstance().e3b(it), ReferenceTargetPresentationProvidersRegistryService_getInstance().e3b(it));
  }
  function DomainModel$services$lambda_1(this$0) {
    return function (it) {
      return new NodeSetupContext(this$0.zde_1.l6z(), ReferenceFactoryRegistryService_getInstance().e3b(it));
    };
  }
  function DomainModel$services$lambda_2(it) {
    return ConceptRegistryService_instance.e3b(it).k6l(ReferenceFactoryRegistryService_getInstance().e3b(it));
  }
  function DomainModel(language, structureModel, additionalServices, parentCoroutineContext) {
    parentCoroutineContext = parentCoroutineContext === VOID ? EmptyCoroutineContext_instance : parentCoroutineContext;
    this.yde_1 = language;
    this.zde_1 = structureModel;
    this.adf_1 = SupervisorJob(parentCoroutineContext.s9(Key_instance_3));
    this.bdf_1 = edt(Companion_instance_252, parentCoroutineContext);
    this.cdf_1 = parentCoroutineContext.wi(this.adf_1).wi(this.bdf_1);
    var tmp = this;
    // Inline function 'kotlin.collections.buildList' call
    // Inline function 'kotlin.collections.buildListInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = ArrayList_init_$Create$();
    var tmp_0 = Companion_instance_41.k3b(this.cdf_1, [CoroutineContextService_getInstance()]);
    var tmp_1 = Companion_instance_41.o3b(this.zde_1);
    var tmp_2 = Companion_instance_41.k3b(this.zde_1.c6y(), [UseExperimentalNodeService_instance]);
    var tmp_3 = Companion_instance_41;
    var initialServices = listOf_0([tmp_0, tmp_1, tmp_2, tmp_3.k3b(new NodePointersService(DomainModel$services$lambda(this)), [Companion_instance_88]), Companion_instance_41.k3b(this.zde_1.l6z(), [WrapperContextService_instance]), ensureNotNull(this.yde_1.q6f(StructureAspect_instance)), Companion_instance_41.k3b(new GlobalNodeFinder(this.zde_1.p6g()), [Companion_instance_95]), Companion_instance_41.k3b(new SameModelNodeFinder(this.zde_1.l6z()), [Companion_instance_92])]);
    this_0.q(initialServices);
    var tmp0_safe_receiver = this.yde_1.q6f(ReferenceFactoryRegistryAspect_instance);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      this_0.j(tmp0_safe_receiver);
    }
    var tmp1_safe_receiver = this.yde_1.q6f(ReferenceTargetsSuppliersRegistryAspect_instance);
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      this_0.j(tmp1_safe_receiver);
    }
    var tmp2_safe_receiver = this.yde_1.q6f(ReferenceTargetPresentationProvidersRegistryAspect_instance);
    if (tmp2_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      this_0.j(tmp2_safe_receiver);
    }
    var tmp_4 = Companion_instance_41;
    var tmp_5 = [ResolveConfigService_instance];
    this_0.j(tmp_4.m3b(tmp_5, VOID, DomainModel$services$lambda_0));
    var tmp_6 = Companion_instance_41;
    var tmp_7 = [NodeSetupContextService_instance];
    this_0.j(tmp_6.m3b(tmp_7, VOID, DomainModel$services$lambda_1(this)));
    var tmp_8;
    if (this.zde_1.c6y()) {
      var tmp_9 = Companion_instance_41;
      var tmp_10 = [OtNodeFactoryService_instance];
      tmp_8 = tmp_9.m3b(tmp_10, VOID, DomainModel$services$lambda_2);
    } else {
      tmp_8 = Companion_instance_41.k3b(RawNodeFactory_instance, [OtNodeFactoryService_instance]);
    }
    var otNodeFactoryService = tmp_8;
    this_0.j(otNodeFactoryService);
    addAll_0(this_0, additionalServices);
    // Inline function 'kotlin.collections.toTypedArray' call
    var this_1 = this_0.i3();
    var tmp$ret$10 = copyToArray(this_1);
    tmp.ddf_1 = serviceContainer(tmp$ret$10.slice());
    this.edf_1 = ensureNotNull(this.ddf_1.h3b(ConceptRegistryService_instance));
    this.fdf_1 = ensureNotNull(this.ddf_1.h3b(ResolveConfigService_instance));
    this.gdf_1 = ensureNotNull(this.ddf_1.h3b(NodeSetupContextService_instance));
    this.hdf_1 = ensureNotNull(this.ddf_1.h3b(OtNodeFactoryService_instance));
    var wrapperContext = this.zde_1.l6z();
    var tmp_11 = this.edf_1;
    if (isInterface(tmp_11, NodeWrapperConceptRegistry)) {
      wrapperContext.j58(this.edf_1.j6l());
    }
    wrapperContext.o58(Companion_getInstance_93().p6l_1, this.gdf_1);
    wrapperContext.o58(get_OT_CONCEPT_REGISTRY_CONTEXT_KEY(), this.edf_1);
    wrapperContext.o58(get_OT_NODE_FACTORY_CONTEXT_KEY(), this.hdf_1);
    wrapperContext.o58(get_TYPED_NODE_CONTEXT_KEY(), new TypedNodeContext(this.edf_1, ReferenceFactoryRegistryService_getInstance().e3b(this.ddf_1)));
    wrapperContext.o58(get_USE_EXPERIMENTAL_NODE_KEY(), this.zde_1.c6y());
  }
  protoOf(DomainModel).zr = function () {
    this.ddf_1.zr();
    this.adf_1.sp();
  };
  function ByteReadChannel(content) {
    return ByteReadChannel_0(content, 0, content.length);
  }
  function _get_isCancelled__nhbn6y($this) {
    var tmp0_safe_receiver = $this.odf_1.kotlinx$atomicfu$value;
    return !((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.wdf_1) == null);
  }
  function flushImpl($this) {
    if ($this.pdf_1.w2m()) {
      $this.tdf_1.ydf();
      return false;
    }
    flushWrittenBytes($this);
    $this.tdf_1.ydf();
    return true;
  }
  function flushWrittenBytes($this) {
    // Inline function 'kotlinx.atomicfu.locks.synchronized' call
    $this.udf_1;
    var size = $this.pdf_1.p();
    var buffer = ensureNotNull($this.pdf_1.pdg());
    $this.vdf_1.qdg(buffer);
    $this.mdf_1.atomicfu$addAndGet(size);
  }
  function ensureNotClosed($this) {
    if ($this.sdg()) {
      var tmp0_elvis_lhs = $this.rdg();
      throw tmp0_elvis_lhs == null ? new ClosedWriteChannelException('Channel ' + toString_1($this) + ' is already closed') : tmp0_elvis_lhs;
    }
  }
  function ensureNotFailed($this) {
    var tmp0_safe_receiver = $this.rdg();
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      throw tmp0_safe_receiver;
    }
  }
  function ensureNotFailed_0($this, closeable) {
    var tmp0_safe_receiver = $this.rdg();
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      closeable.zu();
      throw tmp0_safe_receiver;
    }
  }
  function readRemainingSuspend($this, builder, limit, $completion) {
    var tmp = new $readRemainingSuspendCOROUTINE$($this, builder, limit, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  }
  function addBytesRead($this, count) {
    // Inline function 'kotlin.require' call
    if (!(count >= 0)) {
      var message = "Can't read negative amount of bytes: " + count;
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    // Inline function 'kotlinx.atomicfu.AtomicInt.minusAssign' call
    $this.ndf_1.atomicfu$getAndAdd(-count | 0);
    $this.kdf_1.atomicfu$addAndGet$long(fromInt_0(count));
    // Inline function 'kotlinx.atomicfu.AtomicInt.minusAssign' call
    $this.mdf_1.atomicfu$getAndAdd(-count | 0);
    // Inline function 'kotlin.check' call
    if (!($this.ndf_1.kotlinx$atomicfu$value >= 0)) {
      var message_0 = 'Readable bytes count is negative: ' + $this.edh() + ', ' + count + ' in ' + toString_1($this);
      throw IllegalStateException_init_$Create$_0(toString_1(message_0));
    }
    // Inline function 'kotlin.check' call
    if (!($this.edh() >= 0)) {
      var message_1 = 'Readable bytes count is negative: ' + $this.edh() + ', ' + count + ' in ' + toString_1($this);
      throw IllegalStateException_init_$Create$_0(toString_1(message_1));
    }
  }
  function addBytesWritten($this, count) {
    // Inline function 'kotlin.require' call
    if (!(count >= 0)) {
      var message = "Can't write negative amount of bytes: " + count;
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    // Inline function 'kotlinx.atomicfu.AtomicInt.plusAssign' call
    $this.ndf_1.atomicfu$getAndAdd(count);
    $this.ldf_1.atomicfu$addAndGet$long(fromInt_0(count));
    // Inline function 'kotlin.check' call
    if (!($this.ndf_1.kotlinx$atomicfu$value >= 0)) {
      var message_0 = 'Readable bytes count is negative: ' + $this.ndf_1.kotlinx$atomicfu$value + ', ' + count + ' in ' + toString_1($this);
      throw IllegalStateException_init_$Create$_0(toString_1(message_0));
    }
  }
  function ByteChannelSequentialBase$awaitAtLeastNBytesAvailableForWrite$lambda(this$0, $count) {
    return function () {
      return this$0.fdh() < $count && !this$0.sdg();
    };
  }
  function ByteChannelSequentialBase$awaitAtLeastNBytesAvailableForRead$lambda(this$0, $count) {
    return function () {
      return this$0.edh() < $count && !this$0.gdh();
    };
  }
  function $awaitAtLeastNBytesAvailableForWriteCOROUTINE$(_this__u8e3s4, count, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.pdh_1 = _this__u8e3s4;
    this.qdh_1 = count;
  }
  protoOf($awaitAtLeastNBytesAvailableForWriteCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 4;
            this.f9_1 = 1;
            continue $sm;
          case 1:
            if (!(this.pdh_1.fdh() < this.qdh_1 && !this.pdh_1.sdg())) {
              this.f9_1 = 5;
              continue $sm;
            }

            if (!flushImpl(this.pdh_1)) {
              this.f9_1 = 2;
              suspendResult = this.pdh_1.tdf_1.rdh(ByteChannelSequentialBase$awaitAtLeastNBytesAvailableForWrite$lambda(this.pdh_1, this.qdh_1), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.f9_1 = 3;
              continue $sm;
            }

          case 2:
            this.f9_1 = 3;
            continue $sm;
          case 3:
            this.f9_1 = 1;
            continue $sm;
          case 4:
            throw this.i9_1;
          case 5:
            return Unit_instance;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 4) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function $awaitAtLeastNBytesAvailableForReadCOROUTINE$(_this__u8e3s4, count, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.adi_1 = _this__u8e3s4;
    this.bdi_1 = count;
  }
  protoOf($awaitAtLeastNBytesAvailableForReadCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 3;
            this.f9_1 = 1;
            continue $sm;
          case 1:
            if (!(this.adi_1.edh() < this.bdi_1 && !this.adi_1.gdh())) {
              this.f9_1 = 4;
              continue $sm;
            }

            this.f9_1 = 2;
            suspendResult = this.adi_1.tdf_1.rdh(ByteChannelSequentialBase$awaitAtLeastNBytesAvailableForRead$lambda(this.adi_1, this.bdi_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.f9_1 = 1;
            continue $sm;
          case 3:
            throw this.i9_1;
          case 4:
            return Unit_instance;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 3) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function $writeFullyCOROUTINE$(_this__u8e3s4, src, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.kdi_1 = _this__u8e3s4;
    this.ldi_1 = src;
  }
  protoOf($writeFullyCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.kdi_1.mdi(1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var this_0 = this.ldi_1;
            var count = this_0.pdi_1 - this_0.odi_1 | 0;
            writeFully_2(this.kdi_1.pdf_1, this.ldi_1);
            this.kdi_1.tdi(count);
            return Unit_instance;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function $writeFullyCOROUTINE$_0(_this__u8e3s4, src, offset, length, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.cdj_1 = _this__u8e3s4;
    this.ddj_1 = src;
    this.edj_1 = offset;
    this.fdj_1 = length;
  }
  protoOf($writeFullyCOROUTINE$_0).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 4;
            this.gdj_1 = this.edj_1;
            this.hdj_1 = this.edj_1 + this.fdj_1 | 0;
            this.f9_1 = 1;
            continue $sm;
          case 1:
            if (!(this.gdj_1 < this.hdj_1)) {
              this.f9_1 = 3;
              continue $sm;
            }

            this.f9_1 = 2;
            suspendResult = this.cdj_1.mdi(1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var tmp0 = this.cdj_1.fdh();
            var b = this.hdj_1 - this.gdj_1 | 0;
            var bytesCount = Math.min(tmp0, b);
            writeFully_3(this.cdj_1.pdf_1, this.ddj_1, this.gdj_1, bytesCount);
            this.gdj_1 = this.gdj_1 + bytesCount | 0;
            this.cdj_1.tdi(bytesCount);
            this.f9_1 = 1;
            continue $sm;
          case 3:
            return Unit_instance;
          case 4:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 4) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function $readRemainingCOROUTINE$(_this__u8e3s4, limit, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.qdj_1 = _this__u8e3s4;
    this.rdj_1 = limit;
  }
  protoOf($readRemainingCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 3;
            ensureNotFailed(this.qdj_1);
            var builder = new BytePacketBuilder();
            var tmp0 = this.rdj_1;
            var b = this.qdj_1.qdf_1.adk();
            var size = tmp0 <= b ? tmp0 : b;
            builder.bdk(this.qdj_1.qdf_1, size);
            this.qdj_1.cdk(convertToInt(size));
            var tmp0_0 = this.rdj_1;
            var other = builder.p();
            var newLimit = subtract_1(tmp0_0, fromInt_0(other));
            if (newLimit === 0n || this.qdj_1.gdh()) {
              var tmp_0 = this;
              ensureNotFailed_0(this.qdj_1, builder);
              tmp_0.sdj_1 = builder.f40();
              this.f9_1 = 2;
              continue $sm;
            } else {
              this.f9_1 = 1;
              suspendResult = readRemainingSuspend(this.qdj_1, builder, this.rdj_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            this.sdj_1 = suspendResult;
            this.f9_1 = 2;
            continue $sm;
          case 2:
            return this.sdj_1;
          case 3:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 3) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function $readRemainingSuspendCOROUTINE$(_this__u8e3s4, builder, limit, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.bdh_1 = _this__u8e3s4;
    this.cdh_1 = builder;
    this.ddh_1 = limit;
  }
  protoOf($readRemainingSuspendCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 5;
            this.f9_1 = 1;
            continue $sm;
          case 1:
            if (!(fromInt_0(this.cdh_1.p()) < this.ddh_1)) {
              this.f9_1 = 4;
              continue $sm;
            }

            var tmp0 = this.ddh_1;
            var other = this.cdh_1.p();
            var tmp0_0 = subtract_1(tmp0, fromInt_0(other));
            var b = this.bdh_1.qdf_1.adk();
            var partLimit = tmp0_0 <= b ? tmp0_0 : b;
            this.cdh_1.bdk(this.bdh_1.qdf_1, partLimit);
            this.bdh_1.cdk(convertToInt(partLimit));
            ensureNotFailed_0(this.bdh_1, this.cdh_1);
            if (this.bdh_1.gdh() || this.cdh_1.p() === convertToInt(this.ddh_1)) {
              this.f9_1 = 4;
              continue $sm;
            } else {
              this.f9_1 = 2;
              continue $sm;
            }

          case 2:
            this.f9_1 = 3;
            suspendResult = this.bdh_1.ddk(1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            this.f9_1 = 1;
            continue $sm;
          case 4:
            ensureNotFailed_0(this.bdh_1, this.cdh_1);
            return this.cdh_1.f40();
          case 5:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 5) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function $readAvailableCOROUTINE$(_this__u8e3s4, dst, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.mdk_1 = _this__u8e3s4;
    this.ndk_1 = dst;
  }
  protoOf($readAvailableCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 3;
            var tmp0_safe_receiver = this.mdk_1.rdg();
            if (tmp0_safe_receiver == null)
              null;
            else {
              throw tmp0_safe_receiver;
            }

            if (this.mdk_1.sdg() && this.mdk_1.edh() === 0)
              return -1;
            var this_0 = this.ndk_1;
            if ((this_0.rdi_1 - this_0.pdi_1 | 0) === 0)
              return 0;
            if (this.mdk_1.edh() === 0) {
              this.f9_1 = 1;
              suspendResult = this.mdk_1.ddk(1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.f9_1 = 2;
              continue $sm;
            }

          case 1:
            this.f9_1 = 2;
            continue $sm;
          case 2:
            if (!this.mdk_1.qdf_1.pdk()) {
              this.mdk_1.odk();
            }

            var this_1 = this.ndk_1;
            var tmp0 = fromInt_0(this_1.rdi_1 - this_1.pdi_1 | 0);
            var b = this.mdk_1.qdf_1.adk();
            var size = convertToInt(tmp0 <= b ? tmp0 : b);
            readFully_2(this.mdk_1.qdf_1, this.ndk_1, size);
            this.mdk_1.cdk(size);
            return size;
          case 3:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 3) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function $readAvailableCOROUTINE$_0(_this__u8e3s4, dst, offset, length, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.ydk_1 = _this__u8e3s4;
    this.zdk_1 = dst;
    this.adl_1 = offset;
    this.bdl_1 = length;
  }
  protoOf($readAvailableCOROUTINE$_0).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 3;
            var tmp0_safe_receiver = this.ydk_1.rdg();
            if (tmp0_safe_receiver == null)
              null;
            else {
              throw tmp0_safe_receiver;
            }

            if (this.ydk_1.sdg() && this.ydk_1.edh() === 0)
              return -1;
            if (this.bdl_1 === 0)
              return 0;
            if (this.ydk_1.edh() === 0) {
              this.f9_1 = 1;
              suspendResult = this.ydk_1.ddk(1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.f9_1 = 2;
              continue $sm;
            }

          case 1:
            this.f9_1 = 2;
            continue $sm;
          case 2:
            if (!this.ydk_1.qdf_1.pdk()) {
              this.ydk_1.odk();
            }

            var tmp0 = fromInt_0(this.bdl_1);
            var b = this.ydk_1.qdf_1.adk();
            var size = convertToInt(tmp0 <= b ? tmp0 : b);
            readFully_1(this.ydk_1.qdf_1, this.zdk_1, this.adl_1, size);
            this.ydk_1.cdk(size);
            return size;
          case 3:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 3) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function $awaitInternalAtLeast1COROUTINE$(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.kdl_1 = _this__u8e3s4;
  }
  protoOf($awaitInternalAtLeast1COROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            if (!this.kdl_1.qdf_1.mdl()) {
              var tmp_0 = this;
              tmp_0.ldl_1 = true;
              this.f9_1 = 3;
              continue $sm;
            } else {
              this.f9_1 = 1;
              suspendResult = this.kdl_1.ddk(1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            this.ldl_1 = suspendResult;
            this.f9_1 = 3;
            continue $sm;
          case 2:
            throw this.i9_1;
          case 3:
            return this.ldl_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function $awaitSuspendCOROUTINE$(_this__u8e3s4, atLeast, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.vdl_1 = _this__u8e3s4;
    this.wdl_1 = atLeast;
  }
  protoOf($awaitSuspendCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            if (!(this.wdl_1 >= 0)) {
              var message = 'Failed requirement.';
              throw IllegalArgumentException_init_$Create$_0(toString_1(message));
            }

            this.f9_1 = 1;
            suspendResult = this.vdl_1.xdl(this.wdl_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.vdl_1.odk();
            var tmp0_safe_receiver = this.vdl_1.rdg();
            if (tmp0_safe_receiver == null)
              null;
            else {
              throw tmp0_safe_receiver;
            }

            return !this.vdl_1.gdh() && this.vdl_1.edh() >= this.wdl_1;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function ByteChannelSequentialBase(initial, autoFlush, pool) {
    pool = pool === VOID ? Companion_getInstance_256().cdm() : pool;
    this.idf_1 = autoFlush;
    this.jdf_1 = atomic$ref$1(Companion_getInstance_256().zdl_1);
    this.kdf_1 = atomic$long$1(0n);
    this.ldf_1 = atomic$long$1(0n);
    this.mdf_1 = atomic$int$1(0);
    this.ndf_1 = atomic$int$1(0);
    this.odf_1 = atomic$ref$1(null);
    this.pdf_1 = new BytePacketBuilder(pool);
    this.qdf_1 = ByteReadPacket_init_$Create$(initial, pool);
    this.rdf_1 = atomic$int$1(0);
    this.sdf_1 = atomic$ref$1(Companion_getInstance_256().zdl_1);
    this.tdf_1 = new AwaitingSlot();
    this.udf_1 = new Object();
    this.vdf_1 = new BytePacketBuilder();
    var count = convertToInt(remainingAll(initial));
    this.tdi(count);
    this.mdf_1.atomicfu$addAndGet(count);
  }
  protoOf(ByteChannelSequentialBase).ddm = function () {
    return this.idf_1;
  };
  protoOf(ByteChannelSequentialBase).sdg = function () {
    return !(this.odf_1.kotlinx$atomicfu$value == null);
  };
  protoOf(ByteChannelSequentialBase).edh = function () {
    return this.mdf_1.kotlinx$atomicfu$value;
  };
  protoOf(ByteChannelSequentialBase).fdh = function () {
    // Inline function 'kotlin.comparisons.maxOf' call
    var b = 4088 - this.ndf_1.kotlinx$atomicfu$value | 0;
    return Math.max(0, b);
  };
  protoOf(ByteChannelSequentialBase).gdh = function () {
    return _get_isCancelled__nhbn6y(this) || (this.sdg() && this.ndf_1.kotlinx$atomicfu$value === 0);
  };
  protoOf(ByteChannelSequentialBase).rdg = function () {
    var tmp0_safe_receiver = this.odf_1.kotlinx$atomicfu$value;
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.wdf_1;
  };
  protoOf(ByteChannelSequentialBase).mdi = function (count, $completion) {
    var tmp = new $awaitAtLeastNBytesAvailableForWriteCOROUTINE$(this, count, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(ByteChannelSequentialBase).xdl = function (count, $completion) {
    var tmp = new $awaitAtLeastNBytesAvailableForReadCOROUTINE$(this, count, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(ByteChannelSequentialBase).c9 = function () {
    flushImpl(this);
  };
  protoOf(ByteChannelSequentialBase).odk = function () {
    // Inline function 'kotlinx.atomicfu.locks.synchronized' call
    this.udf_1;
    unsafeAppend(this.qdf_1, this.vdf_1);
  };
  protoOf(ByteChannelSequentialBase).edm = function (src, $completion) {
    var tmp = new $writeFullyCOROUTINE$(this, src, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(ByteChannelSequentialBase).fdm = function (src, offset, length, $completion) {
    var tmp = new $writeFullyCOROUTINE$_0(this, src, offset, length, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(ByteChannelSequentialBase).cdk = function (count) {
    addBytesRead(this, count);
    this.tdf_1.ydf();
  };
  protoOf(ByteChannelSequentialBase).gdm = function (limit, $completion) {
    var tmp = new $readRemainingCOROUTINE$(this, limit, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(ByteChannelSequentialBase).idm = function (dst, $completion) {
    return this.jdm(dst instanceof Buffer ? dst : THROW_CCE(), $completion);
  };
  protoOf(ByteChannelSequentialBase).jdm = function (dst, $completion) {
    var tmp = new $readAvailableCOROUTINE$(this, dst, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(ByteChannelSequentialBase).kdm = function (dst, offset, length, $completion) {
    var tmp = new $readAvailableCOROUTINE$_0(this, dst, offset, length, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(ByteChannelSequentialBase).ldm = function ($completion) {
    var tmp = new $awaitInternalAtLeast1COROUTINE$(this, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(ByteChannelSequentialBase).ddk = function (atLeast, $completion) {
    var tmp = new $awaitSuspendCOROUTINE$(this, atLeast, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(ByteChannelSequentialBase).qt = function (cause) {
    if (!(this.rdg() == null) || this.sdg()) {
      return false;
    }
    return this.g16(cause == null ? CancellationException_init_$Create$_0('Channel cancelled') : cause);
  };
  protoOf(ByteChannelSequentialBase).g16 = function (cause) {
    var closeElement = cause == null ? get_CLOSED_SUCCESS() : new CloseElement(cause);
    if (!this.odf_1.atomicfu$compareAndSet(null, closeElement))
      return false;
    if (!(cause == null)) {
      this.qdf_1.zu();
      this.pdf_1.zu();
      this.vdf_1.zu();
    } else {
      this.c9();
      this.pdf_1.zu();
    }
    this.tdf_1.mdm(cause);
    return true;
  };
  protoOf(ByteChannelSequentialBase).ndm = function (dst, limit) {
    var size = this.qdf_1.adk();
    var tmp;
    if (size <= limit) {
      dst.pdf_1.odm(this.qdf_1);
      dst.tdi(convertToInt(size));
      this.cdk(convertToInt(size));
      tmp = size;
    } else {
      tmp = 0n;
    }
    return tmp;
  };
  protoOf(ByteChannelSequentialBase).tdi = function (count) {
    addBytesWritten(this, count);
    if (this.sdg()) {
      this.pdf_1.zu();
      ensureNotClosed(this);
    }
    if (this.ddm() || this.fdh() === 0) {
      this.c9();
    }
  };
  function cancel_3(_this__u8e3s4) {
    return _this__u8e3s4.qt(null);
  }
  function readAvailable(_this__u8e3s4, dst, $completion) {
    return _this__u8e3s4.kdm(dst, 0, dst.length, $completion);
  }
  function close_1(_this__u8e3s4) {
    return _this__u8e3s4.g16(null);
  }
  function ClosedWriteChannelException(message) {
    CancellationException_init_$Init$_0(message, this);
    captureStack(this, ClosedWriteChannelException);
  }
  function writeFully(_this__u8e3s4, src, $completion) {
    return _this__u8e3s4.fdm(src, 0, src.length, $completion);
  }
  function get_CLOSED_SUCCESS() {
    _init_properties_CloseElement_kt__5e72ik();
    return CLOSED_SUCCESS;
  }
  var CLOSED_SUCCESS;
  function CloseElement(cause) {
    this.wdf_1 = cause;
  }
  var properties_initialized_CloseElement_kt_clkism;
  function _init_properties_CloseElement_kt__5e72ik() {
    if (!properties_initialized_CloseElement_kt_clkism) {
      properties_initialized_CloseElement_kt_clkism = true;
      CLOSED_SUCCESS = new CloseElement(null);
    }
  }
  function writer(_this__u8e3s4, coroutineContext, autoFlush, block) {
    coroutineContext = coroutineContext === VOID ? EmptyCoroutineContext_instance : coroutineContext;
    autoFlush = autoFlush === VOID ? false : autoFlush;
    return launchChannel(_this__u8e3s4, coroutineContext, ByteChannel(autoFlush), true, block);
  }
  function WriterScope() {
  }
  function ChannelJob(delegate, channel) {
    this.qdm_1 = delegate;
    this.rdm_1 = channel;
  }
  protoOf(ChannelJob).d11 = function () {
    return this.rdm_1;
  };
  protoOf(ChannelJob).io = function () {
    return this.qdm_1.io();
  };
  protoOf(ChannelJob).dp = function () {
    return this.qdm_1.dp();
  };
  protoOf(ChannelJob).z = function () {
    return this.qdm_1.z();
  };
  protoOf(ChannelJob).op = function () {
    return this.qdm_1.op();
  };
  protoOf(ChannelJob).bp = function () {
    return this.qdm_1.bp();
  };
  protoOf(ChannelJob).zp = function (child) {
    return this.qdm_1.zp(child);
  };
  protoOf(ChannelJob).rp = function (cause) {
    this.qdm_1.rp(cause);
  };
  protoOf(ChannelJob).vi = function (initial, operation) {
    return this.qdm_1.vi(initial, operation);
  };
  protoOf(ChannelJob).s9 = function (key) {
    return this.qdm_1.s9(key);
  };
  protoOf(ChannelJob).hp = function () {
    return this.qdm_1.hp();
  };
  protoOf(ChannelJob).lp = function (onCancelling, invokeImmediately, handler) {
    return this.qdm_1.lp(onCancelling, invokeImmediately, handler);
  };
  protoOf(ChannelJob).kp = function (handler) {
    return this.qdm_1.kp(handler);
  };
  protoOf(ChannelJob).np = function ($completion) {
    return this.qdm_1.np($completion);
  };
  protoOf(ChannelJob).ui = function (key) {
    return this.qdm_1.ui(key);
  };
  protoOf(ChannelJob).wi = function (context) {
    return this.qdm_1.wi(context);
  };
  protoOf(ChannelJob).fp = function () {
    return this.qdm_1.fp();
  };
  protoOf(ChannelJob).toString = function () {
    return 'ChannelJob[' + toString_1(this.qdm_1) + ']';
  };
  function launchChannel(_this__u8e3s4, context, channel, attachJob, block) {
    var dispatcher = _this__u8e3s4.ho().s9(Key_getInstance_0());
    var job = launch(_this__u8e3s4, context, VOID, launchChannel$slambda_0(attachJob, channel, block, dispatcher, null));
    job.kp(launchChannel$lambda(channel));
    return new ChannelJob(job, channel);
  }
  function ChannelScope(delegate, channel) {
    this.sdm_1 = channel;
    this.tdm_1 = delegate;
  }
  protoOf(ChannelScope).d11 = function () {
    return this.sdm_1;
  };
  protoOf(ChannelScope).ho = function () {
    return this.tdm_1.ho();
  };
  function launchChannel$slambda($attachJob, $channel, $block, $dispatcher, resultContinuation) {
    this.cdn_1 = $attachJob;
    this.ddn_1 = $channel;
    this.edn_1 = $block;
    this.fdn_1 = $dispatcher;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(launchChannel$slambda).e1h = function ($this$launch, $completion) {
    var tmp = this.f1h($this$launch, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(launchChannel$slambda).v9 = function (p1, $completion) {
    return this.e1h((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(launchChannel$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 3;
            if (this.cdn_1) {
              this.ddn_1.pdm(ensureNotNull(this.gdn_1.ho().s9(Key_instance_3)));
            }

            var tmp_0 = new ChannelScope(this.gdn_1, this.ddn_1);
            var scope = isInterface(tmp_0, CoroutineScope) ? tmp_0 : THROW_CCE();
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.edn_1(scope, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.g9_1 = 3;
            this.f9_1 = 4;
            continue $sm;
          case 2:
            this.g9_1 = 3;
            var tmp_1 = this.i9_1;
            if (tmp_1 instanceof Error) {
              var cause = this.i9_1;
              if (!equals(this.fdn_1, Dispatchers_getInstance().vz_1) && !(this.fdn_1 == null)) {
                throw cause;
              }
              this.ddn_1.qt(cause);
              this.f9_1 = 4;
              continue $sm;
            } else {
              throw this.i9_1;
            }

          case 3:
            throw this.i9_1;
          case 4:
            this.g9_1 = 3;
            return Unit_instance;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 3) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(launchChannel$slambda).f1h = function ($this$launch, completion) {
    var i = new launchChannel$slambda(this.cdn_1, this.ddn_1, this.edn_1, this.fdn_1, completion);
    i.gdn_1 = $this$launch;
    return i;
  };
  function launchChannel$slambda_0($attachJob, $channel, $block, $dispatcher, resultContinuation) {
    var i = new launchChannel$slambda($attachJob, $channel, $block, $dispatcher, resultContinuation);
    var l = function ($this$launch, $completion) {
      return i.e1h($this$launch, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function launchChannel$lambda($channel) {
    return function (cause) {
      $channel.g16(cause);
      return Unit_instance;
    };
  }
  function unwrapCancellationException(_this__u8e3s4) {
    var exception = _this__u8e3s4;
    $l$loop: while (exception instanceof CancellationException) {
      if (equals(exception, exception.cause)) {
        return _this__u8e3s4;
      }
      var tmp0_elvis_lhs = exception.cause;
      var tmp;
      if (tmp0_elvis_lhs == null) {
        return exception;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      exception = tmp;
    }
    return exception;
  }
  function decode(_this__u8e3s4, input, max) {
    max = max === VOID ? 2147483647 : max;
    var tmp0 = fromInt_0(max);
    // Inline function 'kotlin.comparisons.minOf' call
    var b = sizeEstimate(input);
    var tmp$ret$0 = tmp0 <= b ? tmp0 : b;
    // Inline function 'kotlin.text.buildString' call
    var capacity = convertToInt(tmp$ret$0);
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder_init_$Create$(capacity);
    decode_0(_this__u8e3s4, input, this_0, max);
    return this_0.toString();
  }
  function encode(_this__u8e3s4, input, fromIndex, toIndex) {
    fromIndex = fromIndex === VOID ? 0 : fromIndex;
    toIndex = toIndex === VOID ? charSequenceLength(input) : toIndex;
    var tmp$ret$2;
    $l$block: {
      // Inline function 'io.ktor.utils.io.core.buildPacket' call
      // Inline function 'kotlin.contracts.contract' call
      var builder = new BytePacketBuilder();
      try {
        encodeToImpl(_this__u8e3s4, builder, input, fromIndex, toIndex);
        tmp$ret$2 = builder.f40();
        break $l$block;
      } catch ($p) {
        if ($p instanceof Error) {
          var t = $p;
          builder.zu();
          throw t;
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$2;
  }
  function sizeEstimate(_this__u8e3s4) {
    var tmp;
    if (_this__u8e3s4 instanceof ByteReadPacket) {
      tmp = _this__u8e3s4.adk();
    } else {
      // Inline function 'kotlin.comparisons.maxOf' call
      var a = _this__u8e3s4.adk();
      tmp = a >= 16n ? a : 16n;
    }
    return tmp;
  }
  function encodeToImpl(_this__u8e3s4, destination, input, fromIndex, toIndex) {
    var start = fromIndex;
    if (start >= toIndex)
      return 0;
    var bytesWritten = 0;
    // Inline function 'io.ktor.utils.io.core.writeWhileSize' call
    var tail = prepareWriteHead(destination, 1, null);
    try {
      var size;
      $l$loop: while (true) {
        var view = tail;
        // Inline function 'io.ktor.utils.io.core.Buffer.writeRemaining' call
        var before = view.rdi_1 - view.pdi_1 | 0;
        var rc = encodeImpl(_this__u8e3s4, input, start, toIndex, view);
        // Inline function 'kotlin.check' call
        if (!(rc >= 0)) {
          throw IllegalStateException_init_$Create$_0('Check failed.');
        }
        start = start + rc | 0;
        var tmp = bytesWritten;
        // Inline function 'io.ktor.utils.io.core.Buffer.writeRemaining' call
        bytesWritten = tmp + (before - (view.rdi_1 - view.pdi_1 | 0) | 0) | 0;
        size = start >= toIndex ? 0 : rc === 0 ? 8 : 1;
        if (size <= 0)
          break $l$loop;
        tail = prepareWriteHead(destination, size, tail);
      }
    }finally {
      destination.hdn();
    }
    bytesWritten = bytesWritten + encodeCompleteImpl(_this__u8e3s4, destination) | 0;
    return bytesWritten;
  }
  function encodeCompleteImpl(_this__u8e3s4, dst) {
    var size = 1;
    var bytesWritten = 0;
    // Inline function 'io.ktor.utils.io.core.writeWhile' call
    var tail = prepareWriteHead(dst, 1, null);
    try {
      $l$loop: while (true) {
        var view = tail;
        // Inline function 'io.ktor.utils.io.core.Buffer.writeRemaining' call
        var before = view.rdi_1 - view.pdi_1 | 0;
        if (encodeComplete(_this__u8e3s4, view)) {
          size = 0;
        } else {
          size = size + 1 | 0;
        }
        var tmp = bytesWritten;
        // Inline function 'io.ktor.utils.io.core.Buffer.writeRemaining' call
        bytesWritten = tmp + (before - (view.rdi_1 - view.pdi_1 | 0) | 0) | 0;
        if (!(size > 0))
          break $l$loop;
        tail = prepareWriteHead(dst, 1, tail);
      }
    }finally {
      dst.hdn();
    }
    return bytesWritten;
  }
  function Companion_253() {
    this.idn_1 = 8;
  }
  protoOf(Companion_253).jdn = function () {
    return Companion_getInstance_256().zdl_1;
  };
  var Companion_instance_253;
  function Companion_getInstance_253() {
    return Companion_instance_253;
  }
  function Buffer(memory) {
    this.ndi_1 = memory;
    this.odi_1 = 0;
    this.pdi_1 = 0;
    this.qdi_1 = 0;
    var tmp = this;
    // Inline function 'io.ktor.utils.io.bits.Memory.size32' call
    tmp.rdi_1 = this.ndi_1.kdn_1.byteLength;
    var tmp_0 = this;
    // Inline function 'io.ktor.utils.io.bits.Memory.size32' call
    tmp_0.sdi_1 = this.ndi_1.kdn_1.byteLength;
  }
  protoOf(Buffer).ldn = function (count) {
    if (count === 0)
      return Unit_instance;
    var newReadPosition = this.odi_1 + count | 0;
    if (count < 0 || newReadPosition > this.pdi_1) {
      // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
      var tmp$ret$1 = this.pdi_1 - this.odi_1 | 0;
      discardFailed(count, tmp$ret$1);
    }
    this.odi_1 = newReadPosition;
  };
  protoOf(Buffer).mdn = function (count) {
    var newWritePosition = this.pdi_1 + count | 0;
    if (count < 0 || newWritePosition > this.rdi_1) {
      // Inline function 'io.ktor.utils.io.core.Buffer.writeRemaining' call
      var tmp$ret$0 = this.rdi_1 - this.pdi_1 | 0;
      commitWrittenFailed(count, tmp$ret$0);
    }
    this.pdi_1 = newWritePosition;
  };
  protoOf(Buffer).ndn = function (position) {
    var limit = this.rdi_1;
    if (position < this.pdi_1) {
      var tmp = position - this.pdi_1 | 0;
      // Inline function 'io.ktor.utils.io.core.Buffer.writeRemaining' call
      var tmp$ret$0 = this.rdi_1 - this.pdi_1 | 0;
      commitWrittenFailed(tmp, tmp$ret$0);
    }
    if (position >= limit) {
      if (position === limit) {
        this.pdi_1 = position;
        return false;
      }
      var tmp_0 = position - this.pdi_1 | 0;
      // Inline function 'io.ktor.utils.io.core.Buffer.writeRemaining' call
      var tmp$ret$1 = this.rdi_1 - this.pdi_1 | 0;
      commitWrittenFailed(tmp_0, tmp$ret$1);
    }
    this.pdi_1 = position;
    return true;
  };
  protoOf(Buffer).odn = function (position) {
    if (position < 0 || position > this.pdi_1) {
      var tmp = position - this.odi_1 | 0;
      // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
      var tmp$ret$0 = this.pdi_1 - this.odi_1 | 0;
      discardFailed(tmp, tmp$ret$0);
    }
    if (!(this.odi_1 === position)) {
      this.odi_1 = position;
    }
  };
  protoOf(Buffer).pdn = function (count) {
    var newReadPosition = this.odi_1 - count | 0;
    if (newReadPosition < this.qdi_1) {
      rewindFailed(count, this.odi_1 - this.qdi_1 | 0);
    }
    this.odi_1 = newReadPosition;
  };
  protoOf(Buffer).qdn = function (startGap) {
    // Inline function 'kotlin.require' call
    if (!(startGap >= 0)) {
      var message = "startGap shouldn't be negative: " + startGap;
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    if (this.odi_1 >= startGap) {
      this.qdi_1 = startGap;
      return Unit_instance;
    }
    if (this.odi_1 === this.pdi_1) {
      if (startGap > this.rdi_1) {
        startGapReservationFailedDueToLimit(this, startGap);
      }
      this.pdi_1 = startGap;
      this.odi_1 = startGap;
      this.qdi_1 = startGap;
      return Unit_instance;
    }
    startGapReservationFailed(this, startGap);
  };
  protoOf(Buffer).rdn = function (endGap) {
    // Inline function 'kotlin.require' call
    if (!(endGap >= 0)) {
      var message = "endGap shouldn't be negative: " + endGap;
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    var newLimit = this.sdi_1 - endGap | 0;
    if (newLimit >= this.pdi_1) {
      this.rdi_1 = newLimit;
      return Unit_instance;
    }
    if (newLimit < 0) {
      endGapReservationFailedDueToCapacity(this, endGap);
    }
    if (newLimit < this.qdi_1) {
      endGapReservationFailedDueToStartGap(this, endGap);
    }
    if (this.odi_1 === this.pdi_1) {
      this.rdi_1 = newLimit;
      this.odi_1 = newLimit;
      this.pdi_1 = newLimit;
      return Unit_instance;
    }
    endGapReservationFailedDueToContent(this, endGap);
  };
  protoOf(Buffer).sdn = function () {
    this.qdi_1 = 0;
    this.odi_1 = 0;
    var capacity = this.sdi_1;
    this.pdi_1 = capacity;
  };
  protoOf(Buffer).tdn = function () {
    this.udn(this.sdi_1 - this.qdi_1 | 0);
  };
  protoOf(Buffer).udn = function (limit) {
    var startGap = this.qdi_1;
    this.odi_1 = startGap;
    this.pdi_1 = startGap;
    this.rdi_1 = limit;
  };
  protoOf(Buffer).vdn = function () {
    this.wdn(0);
    this.xdn();
  };
  protoOf(Buffer).xdn = function () {
    this.rdi_1 = this.sdi_1;
  };
  protoOf(Buffer).wdn = function (newReadPosition) {
    // Inline function 'kotlin.require' call
    if (!(newReadPosition >= 0)) {
      var message = "newReadPosition shouldn't be negative: " + newReadPosition;
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    // Inline function 'kotlin.require' call
    if (!(newReadPosition <= this.odi_1)) {
      var message_0 = "newReadPosition shouldn't be ahead of the read position: " + newReadPosition + ' > ' + this.odi_1;
      throw IllegalArgumentException_init_$Create$_0(toString_1(message_0));
    }
    this.odi_1 = newReadPosition;
    if (this.qdi_1 > newReadPosition) {
      this.qdi_1 = newReadPosition;
    }
  };
  protoOf(Buffer).ydn = function (copy) {
    copy.rdi_1 = this.rdi_1;
    copy.qdi_1 = this.qdi_1;
    copy.odi_1 = this.odi_1;
    copy.pdi_1 = this.pdi_1;
  };
  protoOf(Buffer).zdn = function () {
    var readPosition = this.odi_1;
    if (readPosition === this.pdi_1) {
      throw new EOFException('No readable bytes available.');
    }
    this.odi_1 = readPosition + 1 | 0;
    // Inline function 'io.ktor.utils.io.bits.get' call
    // Inline function 'io.ktor.utils.io.bits.Memory.loadAt' call
    return this.ndi_1.kdn_1.getInt8(readPosition);
  };
  protoOf(Buffer).ado = function (value) {
    var writePosition = this.pdi_1;
    if (writePosition === this.rdi_1) {
      throw new InsufficientSpaceException('No free space in the buffer to write a byte');
    }
    // Inline function 'io.ktor.utils.io.bits.set' call
    // Inline function 'io.ktor.utils.io.bits.Memory.storeAt' call
    this.ndi_1.kdn_1.setInt8(writePosition, value);
    this.pdi_1 = writePosition + 1 | 0;
  };
  protoOf(Buffer).y3w = function () {
    this.vdn();
    this.tdn();
  };
  protoOf(Buffer).toString = function () {
    var tmp = 'Buffer[0x' + toString_3(hashCode(this), 16) + ']';
    // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
    var tmp_0 = this.pdi_1 - this.odi_1 | 0;
    // Inline function 'io.ktor.utils.io.core.Buffer.writeRemaining' call
    var tmp_1 = this.rdi_1 - this.pdi_1 | 0;
    var tmp_2 = this.qdi_1;
    // Inline function 'io.ktor.utils.io.core.Buffer.endGap' call
    return tmp + ('(' + tmp_0 + ' used, ' + tmp_1 + ' free, ' + (tmp_2 + (this.sdi_1 - this.rdi_1 | 0) | 0) + ' reserved of ' + this.sdi_1 + ')');
  };
  function discardFailed(count, readRemaining) {
    throw new EOFException('Unable to discard ' + count + ' bytes: only ' + readRemaining + ' available for reading');
  }
  function commitWrittenFailed(count, writeRemaining) {
    throw new EOFException('Unable to discard ' + count + ' bytes: only ' + writeRemaining + ' available for writing');
  }
  function rewindFailed(count, rewindRemaining) {
    throw IllegalArgumentException_init_$Create$_0('Unable to rewind ' + count + ' bytes: only ' + rewindRemaining + ' could be rewinded');
  }
  function startGapReservationFailedDueToLimit(_this__u8e3s4, startGap) {
    if (startGap > _this__u8e3s4.sdi_1) {
      throw IllegalArgumentException_init_$Create$_0('Start gap ' + startGap + ' is bigger than the capacity ' + _this__u8e3s4.sdi_1);
    }
    // Inline function 'io.ktor.utils.io.core.Buffer.endGap' call
    var tmp$ret$0 = _this__u8e3s4.sdi_1 - _this__u8e3s4.rdi_1 | 0;
    throw IllegalStateException_init_$Create$_0('Unable to reserve ' + startGap + ' start gap: there are already ' + tmp$ret$0 + ' bytes reserved in the end');
  }
  function startGapReservationFailed(_this__u8e3s4, startGap) {
    var tmp = 'Unable to reserve ' + startGap + ' start gap: ';
    // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
    var tmp$ret$0 = _this__u8e3s4.pdi_1 - _this__u8e3s4.odi_1 | 0;
    throw IllegalStateException_init_$Create$_0(tmp + ('there are already ' + tmp$ret$0 + ' content bytes starting at offset ' + _this__u8e3s4.odi_1));
  }
  function endGapReservationFailedDueToCapacity(_this__u8e3s4, endGap) {
    throw IllegalArgumentException_init_$Create$_0('End gap ' + endGap + ' is too big: capacity is ' + _this__u8e3s4.sdi_1);
  }
  function endGapReservationFailedDueToStartGap(_this__u8e3s4, endGap) {
    throw IllegalArgumentException_init_$Create$_0('End gap ' + endGap + ' is too big: there are already ' + _this__u8e3s4.qdi_1 + ' bytes reserved in the beginning');
  }
  function endGapReservationFailedDueToContent(_this__u8e3s4, endGap) {
    var tmp = 'Unable to reserve end gap ' + endGap + ':';
    // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
    var tmp$ret$0 = _this__u8e3s4.pdi_1 - _this__u8e3s4.odi_1 | 0;
    throw IllegalArgumentException_init_$Create$_0(tmp + (' there are already ' + tmp$ret$0 + ' content bytes at offset ' + _this__u8e3s4.odi_1));
  }
  function InsufficientSpaceException_init_$Init$(name, size, availableSpace, $this) {
    InsufficientSpaceException.call($this, 'Not enough free space to write ' + name + ' of ' + size + ' bytes, available ' + availableSpace + ' bytes.');
    return $this;
  }
  function InsufficientSpaceException_init_$Create$(name, size, availableSpace) {
    var tmp = InsufficientSpaceException_init_$Init$(name, size, availableSpace, objectCreate(protoOf(InsufficientSpaceException)));
    captureStack(tmp, InsufficientSpaceException_init_$Create$);
    return tmp;
  }
  function InsufficientSpaceException(message) {
    message = message === VOID ? 'Not enough free space' : message;
    Exception_init_$Init$_0(message, this);
    captureStack(this, InsufficientSpaceException);
  }
  function restoreStartGap(_this__u8e3s4, size) {
    _this__u8e3s4.wdn(_this__u8e3s4.odi_1 - size | 0);
  }
  function writeBufferAppend(_this__u8e3s4, other, maxSize) {
    // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
    // Inline function 'kotlin.comparisons.minOf' call
    var a = other.pdi_1 - other.odi_1 | 0;
    var size = Math.min(a, maxSize);
    // Inline function 'io.ktor.utils.io.core.Buffer.writeRemaining' call
    if ((_this__u8e3s4.rdi_1 - _this__u8e3s4.pdi_1 | 0) <= size) {
      writeBufferAppendUnreserve(_this__u8e3s4, size);
    }
    // Inline function 'io.ktor.utils.io.core.write' call
    // Inline function 'kotlin.contracts.contract' call
    var tmp0 = _this__u8e3s4.ndi_1;
    var tmp2 = _this__u8e3s4.pdi_1;
    _this__u8e3s4.rdi_1;
    // Inline function 'io.ktor.utils.io.core.read' call
    // Inline function 'kotlin.contracts.contract' call
    var tmp0_0 = other.ndi_1;
    var tmp2_0 = other.odi_1;
    other.pdi_1;
    tmp0_0.bdo(tmp0, tmp2_0, size, tmp2);
    var rc = size;
    other.ldn(rc);
    var rc_0 = rc;
    _this__u8e3s4.mdn(rc_0);
    return rc_0;
  }
  function writeBufferPrepend(_this__u8e3s4, other) {
    // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
    var size = other.pdi_1 - other.odi_1 | 0;
    var readPosition = _this__u8e3s4.odi_1;
    if (readPosition < size) {
      throw IllegalArgumentException_init_$Create$_0('Not enough space in the beginning to prepend bytes');
    }
    var newReadPosition = readPosition - size | 0;
    other.ndi_1.bdo(_this__u8e3s4.ndi_1, other.odi_1, size, newReadPosition);
    other.ldn(size);
    _this__u8e3s4.wdn(newReadPosition);
    return size;
  }
  function writeBufferAppendUnreserve(_this__u8e3s4, writeSize) {
    // Inline function 'io.ktor.utils.io.core.Buffer.writeRemaining' call
    var tmp = _this__u8e3s4.rdi_1 - _this__u8e3s4.pdi_1 | 0;
    // Inline function 'io.ktor.utils.io.core.Buffer.endGap' call
    if ((tmp + (_this__u8e3s4.sdi_1 - _this__u8e3s4.rdi_1 | 0) | 0) < writeSize) {
      throw IllegalArgumentException_init_$Create$_0("Can't append buffer: not enough free space at the end");
    }
    var newWritePosition = _this__u8e3s4.pdi_1 + writeSize | 0;
    var overrunSize = newWritePosition - _this__u8e3s4.rdi_1 | 0;
    if (overrunSize > 0) {
      _this__u8e3s4.xdn();
    }
  }
  function get_DefaultChunkedBufferPool() {
    _init_properties_BufferFactory_kt__uj6b48();
    return DefaultChunkedBufferPool;
  }
  var DefaultChunkedBufferPool;
  function DefaultBufferPool(bufferSize, capacity, allocator) {
    bufferSize = bufferSize === VOID ? 4096 : bufferSize;
    capacity = capacity === VOID ? 1000 : capacity;
    allocator = allocator === VOID ? DefaultAllocator_instance : allocator;
    DefaultPool.call(this, capacity);
    this.fdo_1 = bufferSize;
    this.gdo_1 = allocator;
  }
  protoOf(DefaultBufferPool).hdo = function () {
    return new ChunkBuffer(this.gdo_1.ido(this.fdo_1), null, this);
  };
  protoOf(DefaultBufferPool).jdo = function (instance) {
    this.gdo_1.kdo(instance.ndi_1);
    protoOf(DefaultPool).odo.call(this, instance);
    instance.zdo();
  };
  protoOf(DefaultBufferPool).odo = function (instance) {
    return this.jdo(instance instanceof ChunkBuffer ? instance : THROW_CCE());
  };
  protoOf(DefaultBufferPool).adp = function (instance) {
    protoOf(DefaultPool).bdp.call(this, instance);
    // Inline function 'io.ktor.utils.io.bits.Memory.size' call
    var this_0 = instance.ndi_1;
    // Inline function 'kotlin.check' call
    if (!(fromInt_0(this_0.kdn_1.byteLength) === fromInt_0(this.fdo_1))) {
      // Inline function 'io.ktor.utils.io.bits.Memory.size' call
      var this_1 = instance.ndi_1;
      var tmp$ret$1 = fromInt_0(this_1.kdn_1.byteLength);
      var message = 'Buffer size mismatch. Expected: ' + this.fdo_1 + ', actual: ' + tmp$ret$1.toString();
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    // Inline function 'kotlin.check' call
    if (!!(instance === Companion_getInstance_256().zdl_1)) {
      var message_0 = "ChunkBuffer.Empty couldn't be recycled";
      throw IllegalStateException_init_$Create$_0(toString_1(message_0));
    }
    // Inline function 'kotlin.check' call
    if (!!(instance === Companion_instance_253.jdn())) {
      var message_1 = "Empty instance couldn't be recycled";
      throw IllegalStateException_init_$Create$_0(toString_1(message_1));
    }
    // Inline function 'kotlin.check' call
    if (!(instance.cdp() === 0)) {
      var message_2 = 'Unable to clear buffer: it is still in use.';
      throw IllegalStateException_init_$Create$_0(toString_1(message_2));
    }
    // Inline function 'kotlin.check' call
    if (!(instance.h12() == null)) {
      var message_3 = "Recycled instance shouldn't be a part of a chain.";
      throw IllegalStateException_init_$Create$_0(toString_1(message_3));
    }
    // Inline function 'kotlin.check' call
    if (!(instance.ydo_1 == null)) {
      var message_4 = "Recycled instance shouldn't be a view or another buffer.";
      throw IllegalStateException_init_$Create$_0(toString_1(message_4));
    }
  };
  protoOf(DefaultBufferPool).bdp = function (instance) {
    return this.adp(instance instanceof ChunkBuffer ? instance : THROW_CCE());
  };
  protoOf(DefaultBufferPool).ddp = function (instance) {
    // Inline function 'kotlin.apply' call
    var this_0 = protoOf(DefaultPool).edp.call(this, instance);
    this_0.fdp();
    this_0.y3w();
    return this_0;
  };
  protoOf(DefaultBufferPool).edp = function (instance) {
    return this.ddp(instance instanceof ChunkBuffer ? instance : THROW_CCE());
  };
  var properties_initialized_BufferFactory_kt_q9tgbq;
  function _init_properties_BufferFactory_kt__uj6b48() {
    if (!properties_initialized_BufferFactory_kt_q9tgbq) {
      properties_initialized_BufferFactory_kt_q9tgbq = true;
      DefaultChunkedBufferPool = new DefaultBufferPool();
    }
  }
  function writeFully_0(_this__u8e3s4, src, length) {
    // Inline function 'kotlin.require' call
    if (!(length >= 0)) {
      var message = "length shouldn't be negative: " + length;
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
    // Inline function 'kotlin.require' call
    if (!(length <= (src.pdi_1 - src.odi_1 | 0))) {
      // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
      var message_0 = "length shouldn't be greater than the source read remaining: " + length + ' > ' + (src.pdi_1 - src.odi_1 | 0);
      throw IllegalArgumentException_init_$Create$_0(toString_1(message_0));
    }
    // Inline function 'io.ktor.utils.io.core.Buffer.writeRemaining' call
    // Inline function 'kotlin.require' call
    if (!(length <= (_this__u8e3s4.rdi_1 - _this__u8e3s4.pdi_1 | 0))) {
      // Inline function 'io.ktor.utils.io.core.Buffer.writeRemaining' call
      var message_1 = "length shouldn't be greater than the destination write remaining space: " + length + ' > ' + (_this__u8e3s4.rdi_1 - _this__u8e3s4.pdi_1 | 0);
      throw IllegalArgumentException_init_$Create$_0(toString_1(message_1));
    }
    // Inline function 'io.ktor.utils.io.core.writeExact' call
    var name = 'buffer readable content';
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'io.ktor.utils.io.core.write' call
    // Inline function 'kotlin.contracts.contract' call
    var tmp0 = _this__u8e3s4.ndi_1;
    var tmp2 = _this__u8e3s4.pdi_1;
    var writeRemaining = _this__u8e3s4.rdi_1 - tmp2 | 0;
    if (writeRemaining < length) {
      throw InsufficientSpaceException_init_$Create$(name, length, writeRemaining);
    }
    src.ndi_1.bdo(tmp0, src.odi_1, length, tmp2);
    src.ldn(length);
    var rc = length;
    _this__u8e3s4.mdn(rc);
  }
  function writeShort(_this__u8e3s4, value) {
    // Inline function 'io.ktor.utils.io.core.writeExact' call
    var name = 'short integer';
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'io.ktor.utils.io.core.write' call
    // Inline function 'kotlin.contracts.contract' call
    var tmp0 = _this__u8e3s4.ndi_1;
    var tmp2 = _this__u8e3s4.pdi_1;
    var writeRemaining = _this__u8e3s4.rdi_1 - tmp2 | 0;
    if (writeRemaining < 2) {
      throw InsufficientSpaceException_init_$Create$(name, 2, writeRemaining);
    }
    // Inline function 'io.ktor.utils.io.bits.storeShortAt' call
    tmp0.kdn_1.setInt16(tmp2, value, false);
    var rc = 2;
    _this__u8e3s4.mdn(rc);
    return Unit_instance;
  }
  function writeFully_1(_this__u8e3s4, source, offset, length) {
    offset = offset === VOID ? 0 : offset;
    length = length === VOID ? source.length - offset | 0 : length;
    // Inline function 'io.ktor.utils.io.core.writeExact' call
    var name = 'byte array';
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'io.ktor.utils.io.core.write' call
    // Inline function 'kotlin.contracts.contract' call
    var tmp0 = _this__u8e3s4.ndi_1;
    var tmp2 = _this__u8e3s4.pdi_1;
    var writeRemaining = _this__u8e3s4.rdi_1 - tmp2 | 0;
    if (writeRemaining < length) {
      throw InsufficientSpaceException_init_$Create$(name, length, writeRemaining);
    }
    // Inline function 'io.ktor.utils.io.bits.storeByteArray' call
    // Inline function 'io.ktor.utils.io.bits.useMemory' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.let' call
    of_0(Companion_getInstance_258(), source, offset, length).bdo(tmp0, 0, length, tmp2);
    var rc = length;
    _this__u8e3s4.mdn(rc);
  }
  function readFully(_this__u8e3s4, destination, offset, length) {
    offset = offset === VOID ? 0 : offset;
    length = length === VOID ? destination.length - offset | 0 : length;
    // Inline function 'io.ktor.utils.io.core.readExact' call
    var name = 'byte array';
    // Inline function 'kotlin.contracts.contract' call
    var value;
    // Inline function 'io.ktor.utils.io.core.read' call
    // Inline function 'kotlin.contracts.contract' call
    var tmp0 = _this__u8e3s4.ndi_1;
    var tmp2 = _this__u8e3s4.odi_1;
    if ((_this__u8e3s4.pdi_1 - tmp2 | 0) < length) {
      throw new EOFException('Not enough bytes to read a ' + name + ' of size ' + length + '.');
    }
    // Inline function 'io.ktor.utils.io.bits.loadByteArray' call
    copyTo_2(tmp0, destination, tmp2, length, offset);
    value = Unit_instance;
    var rc = length;
    _this__u8e3s4.ldn(rc);
  }
  function readShort(_this__u8e3s4) {
    // Inline function 'io.ktor.utils.io.core.readExact' call
    var name = 'short integer';
    // Inline function 'kotlin.contracts.contract' call
    var value;
    // Inline function 'io.ktor.utils.io.core.read' call
    // Inline function 'kotlin.contracts.contract' call
    var tmp0 = _this__u8e3s4.ndi_1;
    var tmp2 = _this__u8e3s4.odi_1;
    if ((_this__u8e3s4.pdi_1 - tmp2 | 0) < 2) {
      throw new EOFException('Not enough bytes to read a ' + name + ' of size ' + 2 + '.');
    }
    // Inline function 'io.ktor.utils.io.bits.loadShortAt' call
    value = tmp0.kdn_1.getInt16(tmp2, false);
    var rc = 2;
    _this__u8e3s4.ldn(rc);
    return value;
  }
  function readFully_0(_this__u8e3s4, dst, length) {
    var tmp;
    if (length === VOID) {
      // Inline function 'io.ktor.utils.io.core.Buffer.writeRemaining' call
      tmp = dst.rdi_1 - dst.pdi_1 | 0;
    } else {
      tmp = length;
    }
    length = tmp;
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.require' call
    if (!(length >= 0)) {
      var message = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    // Inline function 'io.ktor.utils.io.core.Buffer.writeRemaining' call
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.require' call
    if (!(length <= (dst.rdi_1 - dst.pdi_1 | 0))) {
      var message_0 = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message_0));
    }
    // Inline function 'io.ktor.utils.io.core.readExact' call
    var name = 'buffer content';
    // Inline function 'kotlin.contracts.contract' call
    var value;
    // Inline function 'io.ktor.utils.io.core.read' call
    // Inline function 'kotlin.contracts.contract' call
    var tmp0 = _this__u8e3s4.ndi_1;
    var tmp2 = _this__u8e3s4.odi_1;
    if ((_this__u8e3s4.pdi_1 - tmp2 | 0) < length) {
      throw new EOFException('Not enough bytes to read a ' + name + ' of size ' + length + '.');
    }
    tmp0.bdo(dst.ndi_1, tmp2, length, dst.pdi_1);
    dst.mdn(length);
    value = Unit_instance;
    var rc = length;
    _this__u8e3s4.ldn(rc);
    return length;
  }
  function remainingAll(_this__u8e3s4) {
    return remainingAll_0(_this__u8e3s4, 0n);
  }
  function findTail(_this__u8e3s4) {
    var $this = _this__u8e3s4;
    $l$1: do {
      $l$0: do {
        var tmp0_elvis_lhs = $this.h12();
        var tmp;
        if (tmp0_elvis_lhs == null) {
          return $this;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var next = tmp;
        $this = next;
        continue $l$0;
      }
       while (false);
    }
     while (true);
  }
  function releaseAll(_this__u8e3s4, pool) {
    var current = _this__u8e3s4;
    while (!(current == null)) {
      var next = current.idp();
      current.jdp(pool);
      current = next;
    }
  }
  function remainingAll_0(_this__u8e3s4, n) {
    var $this = _this__u8e3s4;
    var n_0 = n;
    $l$1: do {
      $l$0: do {
        // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
        var this_0 = $this;
        var tmp$ret$0 = this_0.pdi_1 - this_0.odi_1 | 0;
        var rem = add_2(fromInt_0(tmp$ret$0), n_0);
        var tmp0_elvis_lhs = $this.h12();
        var tmp;
        if (tmp0_elvis_lhs == null) {
          return rem;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var next = tmp;
        $this = next;
        n_0 = rem;
        continue $l$0;
      }
       while (false);
    }
     while (true);
  }
  function BytePacketBuilder(pool) {
    pool = pool === VOID ? Companion_getInstance_256().cdm() : pool;
    Output.call(this, pool);
  }
  protoOf(BytePacketBuilder).p = function () {
    return this.kdp();
  };
  protoOf(BytePacketBuilder).w2m = function () {
    return this.kdp() === 0;
  };
  protoOf(BytePacketBuilder).ldp = function () {
  };
  protoOf(BytePacketBuilder).mdp = function (source, offset, length) {
  };
  protoOf(BytePacketBuilder).k8 = function (value) {
    var tmp = protoOf(Output).k8.call(this, value);
    return tmp instanceof BytePacketBuilder ? tmp : THROW_CCE();
  };
  protoOf(BytePacketBuilder).k = function (value) {
    var tmp = protoOf(Output).k.call(this, value);
    return tmp instanceof BytePacketBuilder ? tmp : THROW_CCE();
  };
  protoOf(BytePacketBuilder).ec = function (value, startIndex, endIndex) {
    var tmp = protoOf(Output).ec.call(this, value, startIndex, endIndex);
    return tmp instanceof BytePacketBuilder ? tmp : THROW_CCE();
  };
  protoOf(BytePacketBuilder).f40 = function () {
    var size = this.p();
    var head = this.pdg();
    return head == null ? Companion_getInstance_254().ndp_1 : new ByteReadPacket(head, fromInt_0(size), this.hdg_1);
  };
  protoOf(BytePacketBuilder).toString = function () {
    return 'BytePacketBuilder[0x' + hashCode(this) + ']';
  };
  function ByteReadPacket_init_$Init$(head, pool, $this) {
    ByteReadPacket.call($this, head, remainingAll(head), pool);
    return $this;
  }
  function ByteReadPacket_init_$Create$(head, pool) {
    return ByteReadPacket_init_$Init$(head, pool, objectCreate(protoOf(ByteReadPacket)));
  }
  function Companion_254() {
    Companion_instance_254 = this;
    this.ndp_1 = new ByteReadPacket(Companion_getInstance_256().zdl_1, 0n, Companion_getInstance_256().ydl_1);
  }
  var Companion_instance_254;
  function Companion_getInstance_254() {
    if (Companion_instance_254 == null)
      new Companion_254();
    return Companion_instance_254;
  }
  function ByteReadPacket(head, remaining, pool) {
    Companion_getInstance_254();
    Input.call(this, head, remaining, pool);
    this.tdp();
  }
  protoOf(ByteReadPacket).bdq = function () {
    return null;
  };
  protoOf(ByteReadPacket).cdq = function (destination, offset, length) {
    return 0;
  };
  protoOf(ByteReadPacket).ddq = function () {
  };
  protoOf(ByteReadPacket).toString = function () {
    return 'ByteReadPacket[' + hashCode(this) + ']';
  };
  function _set__head__b4pap2($this, newHead) {
    $this.udj_1 = newHead;
    $this.vdj_1 = newHead.ndi_1;
    $this.wdj_1 = newHead.odi_1;
    $this.xdj_1 = newHead.pdi_1;
  }
  function readASCII($this, out, min, max) {
    if (max === 0 && min === 0)
      return 0;
    else if ($this.mdl())
      if (min === 0)
        return 0;
      else {
        atLeastMinCharactersRequire($this, min);
      }
     else if (max < min) {
      minShouldBeLess($this, min, max);
    }
    var copied = 0;
    var utf8 = false;
    $l$block: {
      // Inline function 'io.ktor.utils.io.core.takeWhile' call
      var release = true;
      var tmp0_elvis_lhs = prepareReadFirstHead($this, 1);
      var tmp;
      if (tmp0_elvis_lhs == null) {
        break $l$block;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var current = tmp;
      try {
        $l$loop_0: do {
          var tmp0 = current;
          var tmp$ret$5;
          $l$block_0: {
            // Inline function 'io.ktor.utils.io.core.internal.decodeASCII' call
            // Inline function 'io.ktor.utils.io.core.read' call
            // Inline function 'kotlin.contracts.contract' call
            var tmp0_0 = tmp0.ndi_1;
            var tmp2 = tmp0.odi_1;
            var endExclusive = tmp0.pdi_1;
            var inductionVariable = tmp2;
            if (inductionVariable < endExclusive)
              do {
                var index = inductionVariable;
                inductionVariable = inductionVariable + 1 | 0;
                // Inline function 'io.ktor.utils.io.bits.get' call
                // Inline function 'io.ktor.utils.io.bits.Memory.loadAt' call
                var codepoint = tmp0_0.kdn_1.getInt8(index) & 255;
                var tmp_0;
                if ((codepoint & 128) === 128) {
                  tmp_0 = true;
                } else {
                  var it = numberToChar(codepoint);
                  var tmp_1;
                  if (copied === max) {
                    tmp_1 = false;
                  } else {
                    out.k8(it);
                    copied = copied + 1 | 0;
                    tmp_1 = true;
                  }
                  tmp_0 = !tmp_1;
                }
                if (tmp_0) {
                  tmp0.ldn(index - tmp2 | 0);
                  tmp$ret$5 = false;
                  break $l$block_0;
                }
              }
               while (inductionVariable < endExclusive);
            var rc = endExclusive - tmp2 | 0;
            tmp0.ldn(rc);
            tmp$ret$5 = true;
          }
          var rc_0 = tmp$ret$5;
          var tmp_2;
          if (rc_0) {
            tmp_2 = true;
          } else if (copied === max) {
            tmp_2 = false;
          } else {
            utf8 = true;
            tmp_2 = false;
          }
          if (!tmp_2) {
            break $l$loop_0;
          }
          release = false;
          var tmp1_elvis_lhs = prepareReadNextHead($this, current);
          var tmp_3;
          if (tmp1_elvis_lhs == null) {
            break $l$loop_0;
          } else {
            tmp_3 = tmp1_elvis_lhs;
          }
          var next = tmp_3;
          current = next;
          release = true;
        }
         while (true);
      }finally {
        if (release) {
          completeReadHead($this, current);
        }
      }
    }
    if (utf8) {
      return copied + readUtf8($this, out, min - copied | 0, max - copied | 0) | 0;
    }
    if (copied < min) {
      prematureEndOfStreamChars($this, min, copied);
    }
    return copied;
  }
  function atLeastMinCharactersRequire($this, min) {
    throw new EOFException('at least ' + min + ' characters required but no bytes available');
  }
  function minShouldBeLess($this, min, max) {
    throw IllegalArgumentException_init_$Create$_0('min should be less or equal to max but min = ' + min + ', max = ' + max);
  }
  function prematureEndOfStreamChars($this, min, copied) {
    throw new MalformedUTF8InputException('Premature end of stream: expected at least ' + min + ' chars but had only ' + copied);
  }
  function readUtf8($this, out, min, max) {
    var copied = 0;
    $l$block: {
      // Inline function 'io.ktor.utils.io.core.takeWhileSize' call
      var release = true;
      var tmp0_elvis_lhs = prepareReadFirstHead($this, 1);
      var tmp;
      if (tmp0_elvis_lhs == null) {
        break $l$block;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var current = tmp;
      var size = 1;
      try {
        $l$loop_0: do {
          // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
          var this_0 = current;
          var before = this_0.pdi_1 - this_0.odi_1 | 0;
          var after;
          if (before >= size) {
            try {
              var tmp0 = current;
              var tmp$ret$6;
              $l$block_3: {
                // Inline function 'io.ktor.utils.io.core.internal.decodeUTF8' call
                var byteCount = 0;
                var value = 0;
                var lastByteCount = 0;
                // Inline function 'io.ktor.utils.io.core.read' call
                // Inline function 'kotlin.contracts.contract' call
                var tmp0_0 = tmp0.ndi_1;
                var tmp2 = tmp0.odi_1;
                var endExclusive = tmp0.pdi_1;
                var inductionVariable = tmp2;
                if (inductionVariable < endExclusive)
                  do {
                    var index = inductionVariable;
                    inductionVariable = inductionVariable + 1 | 0;
                    // Inline function 'io.ktor.utils.io.bits.get' call
                    // Inline function 'io.ktor.utils.io.bits.Memory.loadAt' call
                    var v = tmp0_0.kdn_1.getInt8(index) & 255;
                    if ((v & 128) === 0) {
                      if (!(byteCount === 0)) {
                        malformedByteCount(byteCount);
                      }
                      var it = numberToChar(v);
                      var tmp_0;
                      if (copied === max) {
                        tmp_0 = false;
                      } else {
                        out.k8(it);
                        copied = copied + 1 | 0;
                        tmp_0 = true;
                      }
                      if (!tmp_0) {
                        tmp0.ldn(index - tmp2 | 0);
                        tmp$ret$6 = -1;
                        break $l$block_3;
                      }
                    } else if (byteCount === 0) {
                      var mask = 128;
                      value = v;
                      var inductionVariable_0 = 1;
                      if (inductionVariable_0 <= 6)
                        $l$loop: do {
                          var i = inductionVariable_0;
                          inductionVariable_0 = inductionVariable_0 + 1 | 0;
                          if (!((value & mask) === 0)) {
                            value = value & ~mask;
                            mask = mask >> 1;
                            byteCount = byteCount + 1 | 0;
                          } else {
                            break $l$loop;
                          }
                        }
                         while (inductionVariable_0 <= 6);
                      lastByteCount = byteCount;
                      byteCount = byteCount - 1 | 0;
                      if (lastByteCount > (endExclusive - index | 0)) {
                        tmp0.ldn(index - tmp2 | 0);
                        tmp$ret$6 = lastByteCount;
                        break $l$block_3;
                      }
                    } else {
                      value = value << 6 | v & 127;
                      byteCount = byteCount - 1 | 0;
                      if (byteCount === 0) {
                        if (isBmpCodePoint(value)) {
                          var it_0 = numberToChar(value);
                          var tmp_1;
                          if (copied === max) {
                            tmp_1 = false;
                          } else {
                            out.k8(it_0);
                            copied = copied + 1 | 0;
                            tmp_1 = true;
                          }
                          if (!tmp_1) {
                            tmp0.ldn(((index - tmp2 | 0) - lastByteCount | 0) + 1 | 0);
                            tmp$ret$6 = -1;
                            break $l$block_3;
                          }
                        } else if (!isValidCodePoint(value)) {
                          malformedCodePoint(value);
                        } else {
                          var tmp_2;
                          var it_1 = numberToChar(highSurrogate(value));
                          var tmp_3;
                          if (copied === max) {
                            tmp_3 = false;
                          } else {
                            out.k8(it_1);
                            copied = copied + 1 | 0;
                            tmp_3 = true;
                          }
                          if (!tmp_3) {
                            tmp_2 = true;
                          } else {
                            var it_2 = numberToChar(lowSurrogate(value));
                            var tmp_4;
                            if (copied === max) {
                              tmp_4 = false;
                            } else {
                              out.k8(it_2);
                              copied = copied + 1 | 0;
                              tmp_4 = true;
                            }
                            tmp_2 = !tmp_4;
                          }
                          if (tmp_2) {
                            tmp0.ldn(((index - tmp2 | 0) - lastByteCount | 0) + 1 | 0);
                            tmp$ret$6 = -1;
                            break $l$block_3;
                          }
                        }
                        value = 0;
                      }
                    }
                  }
                   while (inductionVariable < endExclusive);
                var rc = endExclusive - tmp2 | 0;
                tmp0.ldn(rc);
                tmp$ret$6 = 0;
              }
              var size_0 = tmp$ret$6;
              size = size_0 === 0 ? 1 : size_0 > 0 ? size_0 : 0;
            }finally {
              // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
              var this_1 = current;
              after = this_1.pdi_1 - this_1.odi_1 | 0;
            }
          } else {
            after = before;
          }
          release = false;
          var tmp_5;
          if (after === 0) {
            tmp_5 = prepareReadNextHead($this, current);
          } else {
            var tmp_6;
            if (after < size) {
              tmp_6 = true;
            } else {
              // Inline function 'io.ktor.utils.io.core.Buffer.endGap' call
              var this_2 = current;
              tmp_6 = (this_2.sdi_1 - this_2.rdi_1 | 0) < 8;
            }
            if (tmp_6) {
              completeReadHead($this, current);
              tmp_5 = prepareReadFirstHead($this, size);
            } else {
              tmp_5 = current;
            }
          }
          var tmp1_elvis_lhs = tmp_5;
          var tmp_7;
          if (tmp1_elvis_lhs == null) {
            break $l$loop_0;
          } else {
            tmp_7 = tmp1_elvis_lhs;
          }
          var next = tmp_7;
          current = next;
          release = true;
        }
         while (size > 0);
      }finally {
        if (release) {
          completeReadHead($this, current);
        }
      }
    }
    if (copied < min) {
      prematureEndOfStreamChars($this, min, copied);
    }
    return copied;
  }
  function discardAsMuchAsPossible($this, n, skipped) {
    var $this_0 = $this;
    var n_0 = n;
    var skipped_0 = skipped;
    $l$1: do {
      $l$0: do {
        if (n_0 === 0n)
          return skipped_0;
        var tmp0_elvis_lhs = $this_0.qdq(1);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          return skipped_0;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var current = tmp;
        // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
        var tmp$ret$0 = current.pdi_1 - current.odi_1 | 0;
        var tmp0 = fromInt_0(tmp$ret$0);
        // Inline function 'kotlin.comparisons.minOf' call
        var b = n_0;
        var tmp$ret$1 = tmp0 <= b ? tmp0 : b;
        var size = convertToInt(tmp$ret$1);
        current.ldn(size);
        var tmp1_this = $this_0;
        tmp1_this.wdj_1 = tmp1_this.wdj_1 + size | 0;
        afterRead($this_0, current);
        var tmp0_0 = $this_0;
        // Inline function 'kotlin.Long.minus' call
        var this_0 = n_0;
        var tmp1 = subtract_1(this_0, fromInt_0(size));
        // Inline function 'kotlin.Long.plus' call
        var this_1 = skipped_0;
        var tmp2 = add_2(this_1, fromInt_0(size));
        $this_0 = tmp0_0;
        n_0 = tmp1;
        skipped_0 = tmp2;
        continue $l$0;
      }
       while (false);
    }
     while (true);
  }
  function discardAsMuchAsPossible_0($this, n, skipped) {
    var currentCount = n;
    var currentSkipped = skipped;
    while (true) {
      if (currentCount === 0) {
        return currentSkipped;
      }
      var tmp0_elvis_lhs = $this.qdq(1);
      var tmp;
      if (tmp0_elvis_lhs == null) {
        return currentSkipped;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var current = tmp;
      // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
      var tmp0 = current.pdi_1 - current.odi_1 | 0;
      // Inline function 'kotlin.comparisons.minOf' call
      var b = currentCount;
      var size = Math.min(tmp0, b);
      current.ldn(size);
      $this.wdj_1 = $this.wdj_1 + size | 0;
      afterRead($this, current);
      currentCount = currentCount - size | 0;
      currentSkipped = currentSkipped + size | 0;
    }
  }
  function fixGapAfterReadFallback($this, current) {
    if ($this.zdj_1 && current.h12() == null) {
      $this.wdj_1 = current.odi_1;
      $this.xdj_1 = current.pdi_1;
      $this.edq(0n);
      return Unit_instance;
    }
    // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
    var size = current.pdi_1 - current.odi_1 | 0;
    // Inline function 'io.ktor.utils.io.core.Buffer.endGap' call
    // Inline function 'kotlin.comparisons.minOf' call
    var b = 8 - (current.sdi_1 - current.rdi_1 | 0) | 0;
    var overrun = Math.min(size, b);
    if (size > overrun) {
      fixGapAfterReadFallbackUnreserved($this, current, size, overrun);
    } else {
      var new_0 = $this.tdj_1.gdp();
      new_0.rdn(8);
      new_0.sdq(current.idp());
      writeBufferAppend(new_0, current, size);
      _set__head__b4pap2($this, new_0);
    }
    current.jdp($this.tdj_1);
  }
  function fixGapAfterReadFallbackUnreserved($this, current, size, overrun) {
    var chunk1 = $this.tdj_1.gdp();
    var chunk2 = $this.tdj_1.gdp();
    chunk1.rdn(8);
    chunk2.rdn(8);
    chunk1.sdq(chunk2);
    chunk2.sdq(current.idp());
    writeBufferAppend(chunk1, current, size - overrun | 0);
    writeBufferAppend(chunk2, current, overrun);
    _set__head__b4pap2($this, chunk1);
    $this.edq(remainingAll(chunk2));
  }
  function ensureNext($this, current, empty) {
    var $this_0 = $this;
    var current_0 = current;
    var empty_0 = empty;
    $l$1: do {
      $l$0: do {
        if (current_0 === empty_0) {
          return doFill($this_0);
        }
        var next = current_0.idp();
        current_0.jdp($this_0.tdj_1);
        var tmp;
        if (next == null) {
          _set__head__b4pap2($this_0, empty_0);
          $this_0.edq(0n);
          var tmp0 = $this_0;
          var tmp1 = empty_0;
          var tmp2 = empty_0;
          $this_0 = tmp0;
          current_0 = tmp1;
          empty_0 = tmp2;
          continue $l$0;
        } else {
          // Inline function 'io.ktor.utils.io.core.canRead' call
          if (next.pdi_1 > next.odi_1) {
            _set__head__b4pap2($this_0, next);
            var tmp0_this = $this_0;
            var tmp0_0 = tmp0_this.ydj_1;
            // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
            // Inline function 'kotlin.Long.minus' call
            var other = next.pdi_1 - next.odi_1 | 0;
            var tmp$ret$2 = subtract_1(tmp0_0, fromInt_0(other));
            tmp0_this.edq(tmp$ret$2);
            tmp = next;
          } else {
            var tmp3 = $this_0;
            var tmp5 = empty_0;
            $this_0 = tmp3;
            current_0 = next;
            empty_0 = tmp5;
            continue $l$0;
          }
        }
        return tmp;
      }
       while (false);
    }
     while (true);
  }
  function doFill($this) {
    if ($this.zdj_1)
      return null;
    var chunk = $this.bdq();
    if (chunk == null) {
      $this.zdj_1 = true;
      return null;
    }
    appendView($this, chunk);
    return chunk;
  }
  function appendView($this, chunk) {
    var tail = findTail($this.udj_1);
    if (tail === Companion_getInstance_256().zdl_1) {
      _set__head__b4pap2($this, chunk);
      // Inline function 'kotlin.require' call
      if (!($this.ydj_1 === 0n)) {
        throw IllegalStateException_init_$Create$_0('It should be no tail remaining bytes if current tail is EmptyBuffer');
      }
      var tmp0_safe_receiver = chunk.h12();
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : remainingAll(tmp0_safe_receiver);
      $this.edq(tmp1_elvis_lhs == null ? 0n : tmp1_elvis_lhs);
    } else {
      tail.sdq(chunk);
      $this.edq(add_2($this.ydj_1, remainingAll(chunk)));
    }
  }
  function prepareReadLoop($this, minSize, head) {
    var $this_0 = $this;
    var minSize_0 = minSize;
    var head_0 = head;
    $l$1: do {
      $l$0: do {
        // Inline function 'io.ktor.utils.io.core.Input.headRemaining' call
        var this_0 = $this_0;
        var headSize = this_0.xdj_1 - this_0.wdj_1 | 0;
        if (headSize >= minSize_0)
          return head_0;
        var tmp0_elvis_lhs = head_0.h12();
        var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? doFill($this_0) : tmp0_elvis_lhs;
        var tmp;
        if (tmp1_elvis_lhs == null) {
          return null;
        } else {
          tmp = tmp1_elvis_lhs;
        }
        var next = tmp;
        if (headSize === 0) {
          if (!(head_0 === Companion_getInstance_256().zdl_1)) {
            $this_0.rdq(head_0);
          }
          var tmp0 = $this_0;
          var tmp1 = minSize_0;
          $this_0 = tmp0;
          minSize_0 = tmp1;
          head_0 = next;
          continue $l$0;
        } else {
          var desiredExtraBytes = minSize_0 - headSize | 0;
          var copied = writeBufferAppend(head_0, next, desiredExtraBytes);
          $this_0.xdj_1 = head_0.pdi_1;
          var tmp2_this = $this_0;
          // Inline function 'kotlin.Long.minus' call
          var this_1 = tmp2_this.ydj_1;
          var tmp$ret$1 = subtract_1(this_1, fromInt_0(copied));
          tmp2_this.edq(tmp$ret$1);
          // Inline function 'io.ktor.utils.io.core.canRead' call
          if (!(next.pdi_1 > next.odi_1)) {
            head_0.sdq(null);
            head_0.sdq(next.idp());
            next.jdp($this_0.tdj_1);
          } else {
            next.qdn(copied);
          }
        }
        // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
        var this_2 = head_0;
        if ((this_2.pdi_1 - this_2.odi_1 | 0) >= minSize_0)
          return head_0;
        if (minSize_0 > 8) {
          minSizeIsTooBig($this_0, minSize_0);
        }
        var tmp3 = $this_0;
        var tmp4 = minSize_0;
        var tmp5 = head_0;
        $this_0 = tmp3;
        minSize_0 = tmp4;
        head_0 = tmp5;
        continue $l$0;
      }
       while (false);
    }
     while (true);
  }
  function minSizeIsTooBig($this, minSize) {
    throw IllegalStateException_init_$Create$_0('minSize of ' + minSize + ' is too big (should be less than 8)');
  }
  function afterRead($this, head) {
    // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
    if ((head.pdi_1 - head.odi_1 | 0) === 0) {
      $this.rdq(head);
    }
  }
  function Companion_255() {
  }
  var Companion_instance_255;
  function Companion_getInstance_255() {
    return Companion_instance_255;
  }
  function Input(head, remaining, pool) {
    head = head === VOID ? Companion_getInstance_256().zdl_1 : head;
    remaining = remaining === VOID ? remainingAll(head) : remaining;
    pool = pool === VOID ? Companion_getInstance_256().cdm() : pool;
    this.tdj_1 = pool;
    this.udj_1 = head;
    this.vdj_1 = head.ndi_1;
    this.wdj_1 = head.odi_1;
    this.xdj_1 = head.pdi_1;
    var tmp = this;
    // Inline function 'kotlin.Long.minus' call
    var other = this.xdj_1 - this.wdj_1 | 0;
    tmp.ydj_1 = subtract_1(remaining, fromInt_0(other));
    this.zdj_1 = false;
  }
  protoOf(Input).mdl = function () {
    var tmp;
    var tmp_0;
    // Inline function 'io.ktor.utils.io.core.Input.headRemaining' call
    if ((this.xdj_1 - this.wdj_1 | 0) === 0) {
      tmp_0 = this.ydj_1 === 0n;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.zdj_1 || doFill(this) == null;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(Input).odp = function () {
    // Inline function 'kotlin.also' call
    var this_0 = this.udj_1;
    this_0.odn(this.wdj_1);
    return this_0;
  };
  protoOf(Input).edq = function (newValue) {
    // Inline function 'kotlin.require' call
    if (!(newValue >= 0n)) {
      var message = "tailRemaining shouldn't be negative: " + newValue.toString();
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    this.ydj_1 = newValue;
  };
  protoOf(Input).adk = function () {
    // Inline function 'io.ktor.utils.io.core.Input.headRemaining' call
    var tmp$ret$0 = this.xdj_1 - this.wdj_1 | 0;
    return add_2(fromInt_0(tmp$ret$0), this.ydj_1);
  };
  protoOf(Input).pdk = function () {
    return !(this.wdj_1 === this.xdj_1) || !(this.ydj_1 === 0n);
  };
  protoOf(Input).zu = function () {
    var head = this.odp();
    var empty = Companion_getInstance_256().zdl_1;
    if (!(head === empty)) {
      _set__head__b4pap2(this, empty);
      this.edq(0n);
      releaseAll(head, this.tdj_1);
    }
  };
  protoOf(Input).d2n = function () {
    this.zu();
    if (!this.zdj_1) {
      this.zdj_1 = true;
    }
    this.ddq();
  };
  protoOf(Input).pdg = function () {
    var head = this.odp();
    var empty = Companion_getInstance_256().zdl_1;
    if (head === empty)
      return null;
    _set__head__b4pap2(this, empty);
    this.edq(0n);
    return head;
  };
  protoOf(Input).fdq = function () {
    var head = this.odp();
    var next = head.h12();
    var empty = Companion_getInstance_256().zdl_1;
    if (head === empty)
      return null;
    if (next == null) {
      _set__head__b4pap2(this, empty);
      this.edq(0n);
    } else {
      _set__head__b4pap2(this, next);
      var tmp0 = this.ydj_1;
      // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
      // Inline function 'kotlin.Long.minus' call
      var other = next.pdi_1 - next.odi_1 | 0;
      var tmp$ret$1 = subtract_1(tmp0, fromInt_0(other));
      this.edq(tmp$ret$1);
    }
    head.sdq(null);
    return head;
  };
  protoOf(Input).gdq = function (chain) {
    if (chain === Companion_getInstance_256().zdl_1)
      return Unit_instance;
    var size = remainingAll(chain);
    if (this.udj_1 === Companion_getInstance_256().zdl_1) {
      _set__head__b4pap2(this, chain);
      // Inline function 'io.ktor.utils.io.core.Input.headRemaining' call
      // Inline function 'kotlin.Long.minus' call
      var other = this.xdj_1 - this.wdj_1 | 0;
      var tmp$ret$1 = subtract_1(size, fromInt_0(other));
      this.edq(tmp$ret$1);
    } else {
      findTail(this.udj_1).sdq(chain);
      this.edq(add_2(this.ydj_1, size));
    }
  };
  protoOf(Input).hdq = function (chain) {
    var tail = findTail(this.odp());
    // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
    var size = chain.pdi_1 - chain.odi_1 | 0;
    var tmp;
    if (size === 0) {
      tmp = true;
    } else {
      // Inline function 'io.ktor.utils.io.core.Buffer.writeRemaining' call
      tmp = (tail.rdi_1 - tail.pdi_1 | 0) < size;
    }
    if (tmp)
      return false;
    writeBufferAppend(tail, chain, size);
    if (this.odp() === tail) {
      this.xdj_1 = tail.pdi_1;
    } else {
      // Inline function 'kotlin.Long.plus' call
      var this_0 = this.ydj_1;
      var tmp$ret$2 = add_2(this_0, fromInt_0(size));
      this.edq(tmp$ret$2);
    }
    return true;
  };
  protoOf(Input).idq = function (n) {
    // Inline function 'kotlin.require' call
    if (!(n >= 0)) {
      var message = 'Negative discard is not allowed: ' + n;
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    return discardAsMuchAsPossible_0(this, n, 0);
  };
  protoOf(Input).ldn = function (n) {
    if (!(this.idq(n) === n))
      throw new EOFException('Unable to discard ' + n + ' bytes due to end of packet');
  };
  protoOf(Input).jdq = function (n) {
    if (n <= 0n)
      return 0n;
    return discardAsMuchAsPossible(this, n, 0n);
  };
  protoOf(Input).kdq = function (min, max) {
    if (min === 0 && (max === 0 || this.mdl()))
      return '';
    var remaining = this.adk();
    if (remaining > 0n && fromInt_0(max) >= remaining)
      return readTextExactBytes(this, convertToInt(remaining));
    // Inline function 'kotlin.text.buildString' call
    var capacity = coerceAtMost(coerceAtLeast(min, 16), max);
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder_init_$Create$(capacity);
    readASCII(this, this_0, min, max);
    return this_0.toString();
  };
  protoOf(Input).ldq = function (min, max, $super) {
    min = min === VOID ? 0 : min;
    max = max === VOID ? 2147483647 : max;
    return $super === VOID ? this.kdq(min, max) : $super.kdq.call(this, min, max);
  };
  protoOf(Input).mdq = function (minSize) {
    return prepareReadLoop(this, minSize, this.odp());
  };
  protoOf(Input).ndq = function (current) {
    return this.odq(current);
  };
  protoOf(Input).odq = function (current) {
    return ensureNext(this, current, Companion_getInstance_256().zdl_1);
  };
  protoOf(Input).pdq = function (current) {
    var tmp0_elvis_lhs = current.h12();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return fixGapAfterReadFallback(this, current);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var next = tmp;
    // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
    var remaining = current.pdi_1 - current.odi_1 | 0;
    // Inline function 'io.ktor.utils.io.core.Buffer.endGap' call
    // Inline function 'kotlin.comparisons.minOf' call
    var b = 8 - (current.sdi_1 - current.rdi_1 | 0) | 0;
    var overrunSize = Math.min(remaining, b);
    if (next.qdi_1 < overrunSize) {
      return fixGapAfterReadFallback(this, current);
    }
    restoreStartGap(next, overrunSize);
    if (remaining > overrunSize) {
      current.xdn();
      this.xdj_1 = current.pdi_1;
      // Inline function 'kotlin.Long.plus' call
      var this_0 = this.ydj_1;
      var tmp$ret$3 = add_2(this_0, fromInt_0(overrunSize));
      this.edq(tmp$ret$3);
    } else {
      _set__head__b4pap2(this, next);
      var tmp0 = this.ydj_1;
      // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
      // Inline function 'kotlin.Long.minus' call
      var other = (next.pdi_1 - next.odi_1 | 0) - overrunSize | 0;
      var tmp$ret$5 = subtract_1(tmp0, fromInt_0(other));
      this.edq(tmp$ret$5);
      current.idp();
      current.jdp(this.tdj_1);
    }
  };
  protoOf(Input).bdq = function () {
    var buffer = this.tdj_1.gdp();
    try {
      buffer.rdn(8);
      var tmp = buffer.pdi_1;
      // Inline function 'io.ktor.utils.io.core.Buffer.writeRemaining' call
      var tmp$ret$0 = buffer.rdi_1 - buffer.pdi_1 | 0;
      var copied = this.cdq(buffer.ndi_1, tmp, tmp$ret$0);
      if (copied === 0) {
        this.zdj_1 = true;
        // Inline function 'io.ktor.utils.io.core.canRead' call
        if (!(buffer.pdi_1 > buffer.odi_1)) {
          buffer.jdp(this.tdj_1);
          return null;
        }
      }
      buffer.mdn(copied);
      return buffer;
    } catch ($p) {
      if ($p instanceof Error) {
        var t = $p;
        buffer.jdp(this.tdj_1);
        throw t;
      } else {
        throw $p;
      }
    }
  };
  protoOf(Input).tdp = function () {
    if (!this.zdj_1) {
      this.zdj_1 = true;
    }
  };
  protoOf(Input).qdq = function (minSize) {
    var head = this.odp();
    if ((this.xdj_1 - this.wdj_1 | 0) >= minSize)
      return head;
    return prepareReadLoop(this, minSize, head);
  };
  protoOf(Input).rdq = function (head) {
    var tmp0_elvis_lhs = head.idp();
    var next = tmp0_elvis_lhs == null ? Companion_getInstance_256().zdl_1 : tmp0_elvis_lhs;
    _set__head__b4pap2(this, next);
    var tmp0 = this.ydj_1;
    // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
    // Inline function 'kotlin.Long.minus' call
    var other = next.pdi_1 - next.odi_1 | 0;
    var tmp$ret$1 = subtract_1(tmp0, fromInt_0(other));
    this.edq(tmp$ret$1);
    head.jdp(this.tdj_1);
    return next;
  };
  function discard(_this__u8e3s4) {
    return _this__u8e3s4.jdq(9223372036854775807n);
  }
  function readFully_1(_this__u8e3s4, dst, offset, length) {
    offset = offset === VOID ? 0 : offset;
    length = length === VOID ? dst.length - offset | 0 : length;
    // Inline function 'io.ktor.utils.io.core.readFullyBytesTemplate' call
    var remaining = length;
    var dstOffset = offset;
    $l$block: {
      // Inline function 'io.ktor.utils.io.core.takeWhile' call
      var release = true;
      var tmp0_elvis_lhs = prepareReadFirstHead(_this__u8e3s4, 1);
      var tmp;
      if (tmp0_elvis_lhs == null) {
        break $l$block;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var current = tmp;
      try {
        $l$loop_0: do {
          var buffer = current;
          var tmp0 = remaining;
          // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
          // Inline function 'kotlin.comparisons.minOf' call
          var b = buffer.pdi_1 - buffer.odi_1 | 0;
          var count = Math.min(tmp0, b);
          var dstOffset_0 = dstOffset;
          readFully(buffer, dst, dstOffset_0, count);
          remaining = remaining - count | 0;
          dstOffset = dstOffset + count | 0;
          if (!(remaining > 0)) {
            break $l$loop_0;
          }
          release = false;
          var tmp1_elvis_lhs = prepareReadNextHead(_this__u8e3s4, current);
          var tmp_0;
          if (tmp1_elvis_lhs == null) {
            break $l$loop_0;
          } else {
            tmp_0 = tmp1_elvis_lhs;
          }
          var next = tmp_0;
          current = next;
          release = true;
        }
         while (true);
      }finally {
        if (release) {
          completeReadHead(_this__u8e3s4, current);
        }
      }
    }
    // Inline function 'io.ktor.utils.io.core.requireNoRemaining' call
    var this_0 = remaining;
    if (this_0 > 0) {
      prematureEndOfStream(this_0);
    }
  }
  function readFully_2(_this__u8e3s4, dst, length) {
    var tmp;
    if (length === VOID) {
      // Inline function 'io.ktor.utils.io.core.Buffer.writeRemaining' call
      tmp = dst.rdi_1 - dst.pdi_1 | 0;
    } else {
      tmp = length;
    }
    length = tmp;
    // Inline function 'io.ktor.utils.io.core.readFullyBytesTemplate' call
    var remaining = length;
    var dstOffset = 0;
    $l$block: {
      // Inline function 'io.ktor.utils.io.core.takeWhile' call
      var release = true;
      var tmp0_elvis_lhs = prepareReadFirstHead(_this__u8e3s4, 1);
      var tmp_0;
      if (tmp0_elvis_lhs == null) {
        break $l$block;
      } else {
        tmp_0 = tmp0_elvis_lhs;
      }
      var current = tmp_0;
      try {
        $l$loop_0: do {
          var buffer = current;
          var tmp0 = remaining;
          // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
          // Inline function 'kotlin.comparisons.minOf' call
          var b = buffer.pdi_1 - buffer.odi_1 | 0;
          var count = Math.min(tmp0, b);
          readFully_0(buffer, dst, count);
          remaining = remaining - count | 0;
          dstOffset = dstOffset + count | 0;
          if (!(remaining > 0)) {
            break $l$loop_0;
          }
          release = false;
          var tmp1_elvis_lhs = prepareReadNextHead(_this__u8e3s4, current);
          var tmp_1;
          if (tmp1_elvis_lhs == null) {
            break $l$loop_0;
          } else {
            tmp_1 = tmp1_elvis_lhs;
          }
          var next = tmp_1;
          current = next;
          release = true;
        }
         while (true);
      }finally {
        if (release) {
          completeReadHead(_this__u8e3s4, current);
        }
      }
    }
    // Inline function 'io.ktor.utils.io.core.requireNoRemaining' call
    var this_0 = remaining;
    if (this_0 > 0) {
      prematureEndOfStream(this_0);
    }
  }
  function readShort_0(_this__u8e3s4) {
    var tmp$ret$3;
    $l$block: {
      // Inline function 'io.ktor.utils.io.core.readPrimitive' call
      // Inline function 'io.ktor.utils.io.core.Input.headRemaining' call
      if ((_this__u8e3s4.xdj_1 - _this__u8e3s4.wdj_1 | 0) > 2) {
        var index = _this__u8e3s4.wdj_1;
        _this__u8e3s4.wdj_1 = index + 2 | 0;
        // Inline function 'io.ktor.utils.io.bits.loadShortAt' call
        tmp$ret$3 = _this__u8e3s4.vdj_1.kdn_1.getInt16(index, false);
        break $l$block;
      }
      tmp$ret$3 = readShortFallback(_this__u8e3s4);
    }
    return tmp$ret$3;
  }
  function readShortFallback(_this__u8e3s4) {
    // Inline function 'io.ktor.utils.io.core.readPrimitiveFallback' call
    var tmp0_elvis_lhs = prepareReadFirstHead(_this__u8e3s4, 2);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      prematureEndOfStream(2);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var head = tmp;
    var value = readShort(head);
    completeReadHead(_this__u8e3s4, head);
    return value;
  }
  function flushChain($this) {
    var tmp0_elvis_lhs = $this.pdg();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var oldTail = tmp;
    try {
      // Inline function 'io.ktor.utils.io.core.forEachChunk' call
      // Inline function 'kotlin.contracts.contract' call
      var current = oldTail;
      $l$loop: do {
        var chunk = current;
        var tmp_0 = chunk.odi_1;
        // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
        var tmp$ret$1 = chunk.pdi_1 - chunk.odi_1 | 0;
        $this.mdp(chunk.ndi_1, tmp_0, tmp$ret$1);
        var tmp0_elvis_lhs_0 = current.h12();
        var tmp_1;
        if (tmp0_elvis_lhs_0 == null) {
          break $l$loop;
        } else {
          tmp_1 = tmp0_elvis_lhs_0;
        }
        current = tmp_1;
      }
       while (true);
    }finally {
      releaseAll(oldTail, $this.hdg_1);
    }
  }
  function appendNewChunk($this) {
    var new_0 = $this.hdg_1.gdp();
    new_0.rdn(8);
    $this.pdp(new_0);
    return new_0;
  }
  function appendChainImpl($this, head, newTail, chainedSizeDelta) {
    var _tail = $this.jdg_1;
    if (_tail == null) {
      $this.idg_1 = head;
      $this.odg_1 = 0;
    } else {
      _tail.sdq(head);
      var tailPosition = $this.ldg_1;
      _tail.ndn(tailPosition);
      $this.odg_1 = $this.odg_1 + (tailPosition - $this.ndg_1 | 0) | 0;
    }
    $this.jdg_1 = newTail;
    $this.odg_1 = $this.odg_1 + chainedSizeDelta | 0;
    $this.kdg_1 = newTail.ndi_1;
    $this.ldg_1 = newTail.pdi_1;
    $this.ndg_1 = newTail.odi_1;
    $this.mdg_1 = newTail.rdi_1;
  }
  function writeByteFallback($this, v) {
    appendNewChunk($this).ado(v);
    $this.ldg_1 = $this.ldg_1 + 1 | 0;
  }
  function appendCharFallback($this, c) {
    $l$block: {
      // Inline function 'io.ktor.utils.io.core.Output.write' call
      var buffer = $this.rdp(3);
      try {
        var tmp0 = buffer.ndi_1;
        var tmp2 = buffer.pdi_1;
        // Inline function 'kotlin.code' call
        // Inline function 'io.ktor.utils.io.core.internal.putUtf8Char' call
        var v = Char__toInt_impl_vasixd(c);
        var tmp;
        if (0 <= v ? v <= 127 : false) {
          // Inline function 'io.ktor.utils.io.bits.Memory.storeAt' call
          var value = toByte(v);
          tmp0.kdn_1.setInt8(tmp2, value);
          tmp = 1;
        } else if (128 <= v ? v <= 2047 : false) {
          // Inline function 'io.ktor.utils.io.bits.set' call
          // Inline function 'io.ktor.utils.io.bits.Memory.storeAt' call
          var value_0 = toByte(192 | v >> 6 & 31);
          tmp0.kdn_1.setInt8(tmp2, value_0);
          var tmp2_0 = tmp2 + 1 | 0;
          // Inline function 'io.ktor.utils.io.bits.set' call
          // Inline function 'io.ktor.utils.io.bits.Memory.storeAt' call
          var value_1 = toByte(128 | v & 63);
          tmp0.kdn_1.setInt8(tmp2_0, value_1);
          tmp = 2;
        } else if (2048 <= v ? v <= 65535 : false) {
          // Inline function 'io.ktor.utils.io.bits.set' call
          // Inline function 'io.ktor.utils.io.bits.Memory.storeAt' call
          var value_2 = toByte(224 | v >> 12 & 15);
          tmp0.kdn_1.setInt8(tmp2, value_2);
          var tmp2_1 = tmp2 + 1 | 0;
          // Inline function 'io.ktor.utils.io.bits.set' call
          // Inline function 'io.ktor.utils.io.bits.Memory.storeAt' call
          var value_3 = toByte(128 | v >> 6 & 63);
          tmp0.kdn_1.setInt8(tmp2_1, value_3);
          var tmp2_2 = tmp2 + 2 | 0;
          // Inline function 'io.ktor.utils.io.bits.set' call
          // Inline function 'io.ktor.utils.io.bits.Memory.storeAt' call
          var value_4 = toByte(128 | v & 63);
          tmp0.kdn_1.setInt8(tmp2_2, value_4);
          tmp = 3;
        } else if (65536 <= v ? v <= 1114111 : false) {
          // Inline function 'io.ktor.utils.io.bits.set' call
          // Inline function 'io.ktor.utils.io.bits.Memory.storeAt' call
          var value_5 = toByte(240 | v >> 18 & 7);
          tmp0.kdn_1.setInt8(tmp2, value_5);
          var tmp2_3 = tmp2 + 1 | 0;
          // Inline function 'io.ktor.utils.io.bits.set' call
          // Inline function 'io.ktor.utils.io.bits.Memory.storeAt' call
          var value_6 = toByte(128 | v >> 12 & 63);
          tmp0.kdn_1.setInt8(tmp2_3, value_6);
          var tmp2_4 = tmp2 + 2 | 0;
          // Inline function 'io.ktor.utils.io.bits.set' call
          // Inline function 'io.ktor.utils.io.bits.Memory.storeAt' call
          var value_7 = toByte(128 | v >> 6 & 63);
          tmp0.kdn_1.setInt8(tmp2_4, value_7);
          var tmp2_5 = tmp2 + 3 | 0;
          // Inline function 'io.ktor.utils.io.bits.set' call
          // Inline function 'io.ktor.utils.io.bits.Memory.storeAt' call
          var value_8 = toByte(128 | v & 63);
          tmp0.kdn_1.setInt8(tmp2_5, value_8);
          tmp = 4;
        } else {
          malformedCodePoint(v);
        }
        var size = tmp;
        buffer.mdn(size);
        var result = size;
        // Inline function 'kotlin.check' call
        if (!(result >= 0)) {
          var message = "The returned value shouldn't be negative";
          throw IllegalStateException_init_$Create$_0(toString_1(message));
        }
        break $l$block;
      }finally {
        $this.hdn();
      }
    }
  }
  function writePacketMerging($this, tail, foreignStolen, pool) {
    tail.ndn($this.ldg_1);
    // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
    var lastSize = tail.pdi_1 - tail.odi_1 | 0;
    // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
    var nextSize = foreignStolen.pdi_1 - foreignStolen.odi_1 | 0;
    var maxCopySize = get_PACKET_MAX_COPY_SIZE();
    var tmp;
    var tmp_0;
    if (nextSize < maxCopySize) {
      // Inline function 'io.ktor.utils.io.core.Buffer.endGap' call
      var tmp_1 = tail.sdi_1 - tail.rdi_1 | 0;
      // Inline function 'io.ktor.utils.io.core.Buffer.writeRemaining' call
      tmp_0 = nextSize <= (tmp_1 + (tail.rdi_1 - tail.pdi_1 | 0) | 0);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = nextSize;
    } else {
      tmp = -1;
    }
    var appendSize = tmp;
    var tmp_2;
    if (lastSize < maxCopySize && lastSize <= foreignStolen.qdi_1 && isExclusivelyOwned(foreignStolen)) {
      tmp_2 = lastSize;
    } else {
      tmp_2 = -1;
    }
    var prependSize = tmp_2;
    if (appendSize === -1 && prependSize === -1) {
      $this.qdp(foreignStolen);
    } else if (prependSize === -1 || appendSize <= prependSize) {
      // Inline function 'io.ktor.utils.io.core.Buffer.writeRemaining' call
      var tmp_3 = tail.rdi_1 - tail.pdi_1 | 0;
      // Inline function 'io.ktor.utils.io.core.Buffer.endGap' call
      var tmp$ret$5 = tail.sdi_1 - tail.rdi_1 | 0;
      writeBufferAppend(tail, foreignStolen, tmp_3 + tmp$ret$5 | 0);
      $this.hdn();
      var tmp0_safe_receiver = foreignStolen.idp();
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        $this.qdp(tmp0_safe_receiver);
      }
      foreignStolen.jdp(pool);
    } else if (appendSize === -1 || prependSize < appendSize) {
      writePacketSlowPrepend($this, foreignStolen, tail);
    } else {
      throw IllegalStateException_init_$Create$_0('prep = ' + prependSize + ', app = ' + appendSize);
    }
  }
  function writePacketSlowPrepend($this, foreignStolen, tail) {
    writeBufferPrepend(foreignStolen, tail);
    var tmp0_elvis_lhs = $this.idg_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var message = "head should't be null since it is already handled in the fast-path";
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var _head = tmp;
    if (_head === tail) {
      $this.idg_1 = foreignStolen;
    } else {
      var pre = _head;
      $l$loop: while (true) {
        var next = ensureNotNull(pre.h12());
        if (next === tail)
          break $l$loop;
        pre = next;
      }
      pre.sdq(foreignStolen);
    }
    tail.jdp($this.hdg_1);
    $this.jdg_1 = findTail(foreignStolen);
  }
  function Output(pool) {
    this.hdg_1 = pool;
    this.idg_1 = null;
    this.jdg_1 = null;
    this.kdg_1 = Companion_getInstance_258().tdq_1;
    this.ldg_1 = 0;
    this.mdg_1 = 0;
    this.ndg_1 = 0;
    this.odg_1 = 0;
  }
  protoOf(Output).kdp = function () {
    return this.odg_1 + (this.ldg_1 - this.ndg_1 | 0) | 0;
  };
  protoOf(Output).odp = function () {
    var tmp0_elvis_lhs = this.idg_1;
    return tmp0_elvis_lhs == null ? Companion_getInstance_256().zdl_1 : tmp0_elvis_lhs;
  };
  protoOf(Output).c9 = function () {
    flushChain(this);
  };
  protoOf(Output).pdg = function () {
    var tmp0_elvis_lhs = this.idg_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var head = tmp;
    var tmp1_safe_receiver = this.jdg_1;
    if (tmp1_safe_receiver == null)
      null;
    else
      tmp1_safe_receiver.ndn(this.ldg_1);
    this.idg_1 = null;
    this.jdg_1 = null;
    this.ldg_1 = 0;
    this.mdg_1 = 0;
    this.ndg_1 = 0;
    this.odg_1 = 0;
    this.kdg_1 = Companion_getInstance_258().tdq_1;
    return head;
  };
  protoOf(Output).pdp = function (buffer) {
    // Inline function 'kotlin.check' call
    if (!(buffer.h12() == null)) {
      var message = 'It should be a single buffer chunk.';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    appendChainImpl(this, buffer, buffer, 0);
  };
  protoOf(Output).qdp = function (head) {
    var tail = findTail(head);
    var tmp0 = remainingAll(head);
    // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
    // Inline function 'kotlin.Long.minus' call
    var other = tail.pdi_1 - tail.odi_1 | 0;
    var tmp0_0 = subtract_1(tmp0, fromInt_0(other));
    // Inline function 'io.ktor.utils.io.core.internal.toIntOrFail' call
    var name = 'total size increase';
    if (tmp0_0 >= 2147483647n) {
      failLongToIntConversion(tmp0_0, name);
    }
    var chainedSizeDelta = convertToInt(tmp0_0);
    appendChainImpl(this, head, tail, chainedSizeDelta);
  };
  protoOf(Output).ado = function (v) {
    var index = this.ldg_1;
    if (index < this.mdg_1) {
      this.ldg_1 = index + 1 | 0;
      // Inline function 'io.ktor.utils.io.bits.set' call
      // Inline function 'io.ktor.utils.io.bits.Memory.storeAt' call
      this.kdg_1.kdn_1.setInt8(index, v);
      return Unit_instance;
    }
    return writeByteFallback(this, v);
  };
  protoOf(Output).d2n = function () {
    try {
      this.c9();
    }finally {
      this.ldp();
    }
  };
  protoOf(Output).k8 = function (value) {
    var tailPosition = this.ldg_1;
    if ((this.mdg_1 - tailPosition | 0) >= 3) {
      var tmp0 = this.kdg_1;
      // Inline function 'kotlin.code' call
      // Inline function 'io.ktor.utils.io.core.internal.putUtf8Char' call
      var v = Char__toInt_impl_vasixd(value);
      var tmp;
      if (0 <= v ? v <= 127 : false) {
        // Inline function 'io.ktor.utils.io.bits.Memory.storeAt' call
        var value_0 = toByte(v);
        tmp0.kdn_1.setInt8(tailPosition, value_0);
        tmp = 1;
      } else if (128 <= v ? v <= 2047 : false) {
        // Inline function 'io.ktor.utils.io.bits.set' call
        // Inline function 'io.ktor.utils.io.bits.Memory.storeAt' call
        var value_1 = toByte(192 | v >> 6 & 31);
        tmp0.kdn_1.setInt8(tailPosition, value_1);
        var tmp2 = tailPosition + 1 | 0;
        // Inline function 'io.ktor.utils.io.bits.set' call
        // Inline function 'io.ktor.utils.io.bits.Memory.storeAt' call
        var value_2 = toByte(128 | v & 63);
        tmp0.kdn_1.setInt8(tmp2, value_2);
        tmp = 2;
      } else if (2048 <= v ? v <= 65535 : false) {
        // Inline function 'io.ktor.utils.io.bits.set' call
        // Inline function 'io.ktor.utils.io.bits.Memory.storeAt' call
        var value_3 = toByte(224 | v >> 12 & 15);
        tmp0.kdn_1.setInt8(tailPosition, value_3);
        var tmp2_0 = tailPosition + 1 | 0;
        // Inline function 'io.ktor.utils.io.bits.set' call
        // Inline function 'io.ktor.utils.io.bits.Memory.storeAt' call
        var value_4 = toByte(128 | v >> 6 & 63);
        tmp0.kdn_1.setInt8(tmp2_0, value_4);
        var tmp2_1 = tailPosition + 2 | 0;
        // Inline function 'io.ktor.utils.io.bits.set' call
        // Inline function 'io.ktor.utils.io.bits.Memory.storeAt' call
        var value_5 = toByte(128 | v & 63);
        tmp0.kdn_1.setInt8(tmp2_1, value_5);
        tmp = 3;
      } else if (65536 <= v ? v <= 1114111 : false) {
        // Inline function 'io.ktor.utils.io.bits.set' call
        // Inline function 'io.ktor.utils.io.bits.Memory.storeAt' call
        var value_6 = toByte(240 | v >> 18 & 7);
        tmp0.kdn_1.setInt8(tailPosition, value_6);
        var tmp2_2 = tailPosition + 1 | 0;
        // Inline function 'io.ktor.utils.io.bits.set' call
        // Inline function 'io.ktor.utils.io.bits.Memory.storeAt' call
        var value_7 = toByte(128 | v >> 12 & 63);
        tmp0.kdn_1.setInt8(tmp2_2, value_7);
        var tmp2_3 = tailPosition + 2 | 0;
        // Inline function 'io.ktor.utils.io.bits.set' call
        // Inline function 'io.ktor.utils.io.bits.Memory.storeAt' call
        var value_8 = toByte(128 | v >> 6 & 63);
        tmp0.kdn_1.setInt8(tmp2_3, value_8);
        var tmp2_4 = tailPosition + 3 | 0;
        // Inline function 'io.ktor.utils.io.bits.set' call
        // Inline function 'io.ktor.utils.io.bits.Memory.storeAt' call
        var value_9 = toByte(128 | v & 63);
        tmp0.kdn_1.setInt8(tmp2_4, value_9);
        tmp = 4;
      } else {
        malformedCodePoint(v);
      }
      var size = tmp;
      this.ldg_1 = tailPosition + size | 0;
      return this;
    }
    appendCharFallback(this, value);
    return this;
  };
  protoOf(Output).k = function (value) {
    if (value == null) {
      this.ec('null', 0, 4);
    } else {
      this.ec(value, 0, charSequenceLength(value));
    }
    return this;
  };
  protoOf(Output).ec = function (value, startIndex, endIndex) {
    if (value == null) {
      return this.ec('null', startIndex, endIndex);
    }
    writeText(this, value, startIndex, endIndex, Charsets_getInstance().udq_1);
    return this;
  };
  protoOf(Output).odm = function (packet) {
    var foreignStolen = packet.pdg();
    if (foreignStolen == null) {
      packet.zu();
      return Unit_instance;
    }
    var tail = this.jdg_1;
    if (tail == null) {
      this.qdp(foreignStolen);
      return Unit_instance;
    }
    writePacketMerging(this, tail, foreignStolen, packet.tdj_1);
  };
  protoOf(Output).qdg = function (chunkBuffer) {
    var _tail = this.jdg_1;
    if (_tail == null) {
      this.qdp(chunkBuffer);
      return Unit_instance;
    }
    writePacketMerging(this, _tail, chunkBuffer, this.hdg_1);
  };
  protoOf(Output).bdk = function (p, n) {
    var remaining = n;
    $l$loop: while (remaining > 0n) {
      // Inline function 'io.ktor.utils.io.core.Input.headRemaining' call
      var tmp$ret$0 = p.xdj_1 - p.wdj_1 | 0;
      var headRemaining = fromInt_0(tmp$ret$0);
      if (headRemaining <= remaining) {
        remaining = subtract_1(remaining, headRemaining);
        var tmp0_elvis_lhs = p.fdq();
        var tmp;
        if (tmp0_elvis_lhs == null) {
          throw new EOFException('Unexpected end of packet');
        } else {
          tmp = tmp0_elvis_lhs;
        }
        this.pdp(tmp);
      } else {
        // Inline function 'io.ktor.utils.io.core.read' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp0_elvis_lhs_0 = p.qdq(1);
        var tmp_0;
        if (tmp0_elvis_lhs_0 == null) {
          prematureEndOfStream(1);
        } else {
          tmp_0 = tmp0_elvis_lhs_0;
        }
        var buffer = tmp_0;
        var positionBefore = buffer.odi_1;
        try {
          writeFully_2(this, buffer, convertToInt(remaining));
        }finally {
          var positionAfter = buffer.odi_1;
          if (positionAfter < positionBefore) {
            throw IllegalStateException_init_$Create$_0("Buffer's position shouldn't be rewinded");
          }
          if (positionAfter === buffer.pdi_1) {
            p.odq(buffer);
          } else {
            p.wdj_1 = positionAfter;
          }
        }
        break $l$loop;
      }
    }
  };
  protoOf(Output).zu = function () {
    this.d2n();
  };
  protoOf(Output).rdp = function (n) {
    // Inline function 'io.ktor.utils.io.core.Output.tailRemaining' call
    if ((this.mdg_1 - this.ldg_1 | 0) >= n) {
      var tmp0_safe_receiver = this.jdg_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        tmp0_safe_receiver.ndn(this.ldg_1);
        return tmp0_safe_receiver;
      }
    }
    return appendNewChunk(this);
  };
  protoOf(Output).hdn = function () {
    var tmp0_safe_receiver = this.jdg_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      this.ldg_1 = tmp0_safe_receiver.pdi_1;
    }
  };
  protoOf(Output).sdp = function () {
    var head = this.odp();
    if (!(head === Companion_getInstance_256().zdl_1)) {
      // Inline function 'kotlin.check' call
      if (!(head.h12() == null)) {
        throw IllegalStateException_init_$Create$_0('Check failed.');
      }
      head.tdn();
      head.rdn(8);
      this.ldg_1 = head.pdi_1;
      this.ndg_1 = this.ldg_1;
      this.mdg_1 = head.rdi_1;
    }
  };
  function writeFully_2(_this__u8e3s4, src, length) {
    var tmp;
    if (length === VOID) {
      // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
      tmp = src.pdi_1 - src.odi_1 | 0;
    } else {
      tmp = length;
    }
    length = tmp;
    // Inline function 'io.ktor.utils.io.core.writeFullyBytesTemplate' call
    var currentOffset = 0;
    var remaining = length;
    // Inline function 'io.ktor.utils.io.core.writeWhile' call
    var tail = prepareWriteHead(_this__u8e3s4, 1, null);
    try {
      $l$loop: while (true) {
        var buffer = tail;
        var tmp0 = remaining;
        // Inline function 'io.ktor.utils.io.core.Buffer.writeRemaining' call
        // Inline function 'kotlin.comparisons.minOf' call
        var b = buffer.rdi_1 - buffer.pdi_1 | 0;
        var size = Math.min(tmp0, b);
        writeFully_0(buffer, src, size);
        currentOffset = currentOffset + size | 0;
        remaining = remaining - size | 0;
        if (!(remaining > 0))
          break $l$loop;
        tail = prepareWriteHead(_this__u8e3s4, 1, tail);
      }
    }finally {
      _this__u8e3s4.hdn();
    }
  }
  function writeFully_3(_this__u8e3s4, src, offset, length) {
    offset = offset === VOID ? 0 : offset;
    length = length === VOID ? src.length - offset | 0 : length;
    // Inline function 'io.ktor.utils.io.core.writeFullyBytesTemplate' call
    var currentOffset = offset;
    var remaining = length;
    // Inline function 'io.ktor.utils.io.core.writeWhile' call
    var tail = prepareWriteHead(_this__u8e3s4, 1, null);
    try {
      $l$loop: while (true) {
        var buffer = tail;
        var tmp0 = remaining;
        // Inline function 'io.ktor.utils.io.core.Buffer.writeRemaining' call
        // Inline function 'kotlin.comparisons.minOf' call
        var b = buffer.rdi_1 - buffer.pdi_1 | 0;
        var size = Math.min(tmp0, b);
        var currentOffset_0 = currentOffset;
        writeFully_1(buffer, src, currentOffset_0, size);
        currentOffset = currentOffset + size | 0;
        remaining = remaining - size | 0;
        if (!(remaining > 0))
          break $l$loop;
        tail = prepareWriteHead(_this__u8e3s4, 1, tail);
      }
    }finally {
      _this__u8e3s4.hdn();
    }
  }
  function writeShort_0(_this__u8e3s4, value) {
    var tmp$ret$2;
    $l$block: {
      // Inline function 'io.ktor.utils.io.core.writePrimitiveTemplate' call
      var index = _this__u8e3s4.ldg_1;
      if ((_this__u8e3s4.mdg_1 - index | 0) > 2) {
        _this__u8e3s4.ldg_1 = index + 2 | 0;
        // Inline function 'io.ktor.utils.io.bits.storeShortAt' call
        _this__u8e3s4.kdg_1.kdn_1.setInt16(index, value, false);
        tmp$ret$2 = true;
        break $l$block;
      }
      tmp$ret$2 = false;
    }
    if (!tmp$ret$2) {
      writeShortFallback(_this__u8e3s4, value);
    }
  }
  function writeShortFallback(_this__u8e3s4, value) {
    // Inline function 'io.ktor.utils.io.core.writePrimitiveFallbackTemplate' call
    var tail = _this__u8e3s4.rdp(2);
    writeShort(tail, value);
    _this__u8e3s4.hdn();
    if (!true) {
      // Inline function 'io.ktor.utils.io.bits.highByte' call
      var tmp$ret$2 = toByte(value >>> 8 | 0);
      _this__u8e3s4.ado(tmp$ret$2);
      // Inline function 'io.ktor.utils.io.bits.lowByte' call
      var tmp$ret$3 = toByte(value & 255);
      _this__u8e3s4.ado(tmp$ret$3);
    }
  }
  function readText(_this__u8e3s4, charset, max) {
    charset = charset === VOID ? Charsets_getInstance().udq_1 : charset;
    max = max === VOID ? 2147483647 : max;
    return decode(charset.xdq(), _this__u8e3s4, max);
  }
  function readBytes(_this__u8e3s4, n) {
    var tmp;
    if (n === VOID) {
      var tmp0 = _this__u8e3s4.adk();
      // Inline function 'io.ktor.utils.io.core.coerceAtMostMaxIntOrFail' call
      var message = 'Unable to convert to a ByteArray: packet is too big';
      if (tmp0 > 2147483647n)
        throw IllegalArgumentException_init_$Create$_0(message);
      tmp = convertToInt(tmp0);
    } else {
      tmp = n;
    }
    n = tmp;
    var tmp_0;
    if (!(n === 0)) {
      // Inline function 'kotlin.also' call
      var this_0 = new Int8Array(n);
      readFully_1(_this__u8e3s4, this_0, 0, n);
      tmp_0 = this_0;
    } else {
      tmp_0 = get_EmptyByteArray();
    }
    return tmp_0;
  }
  function writeText(_this__u8e3s4, text, fromIndex, toIndex, charset) {
    fromIndex = fromIndex === VOID ? 0 : fromIndex;
    toIndex = toIndex === VOID ? charSequenceLength(text) : toIndex;
    charset = charset === VOID ? Charsets_getInstance().udq_1 : charset;
    if (charset === Charsets_getInstance().udq_1) {
      return writeTextUtf8(_this__u8e3s4, text, fromIndex, toIndex);
    }
    encodeToImpl(charset.ydq(), _this__u8e3s4, text, fromIndex, toIndex);
  }
  function prematureEndOfStream(size) {
    throw new EOFException('Premature end of stream: expected ' + size + ' bytes');
  }
  function readTextExactBytes(_this__u8e3s4, bytesCount, charset) {
    charset = charset === VOID ? Charsets_getInstance().udq_1 : charset;
    return decodeExactBytes(charset.xdq(), _this__u8e3s4, bytesCount);
  }
  function writeTextUtf8(_this__u8e3s4, text, fromIndex, toIndex) {
    var index = fromIndex;
    // Inline function 'io.ktor.utils.io.core.writeWhileSize' call
    var tail = prepareWriteHead(_this__u8e3s4, 1, null);
    try {
      var size;
      $l$loop: while (true) {
        var buffer = tail;
        var memory = buffer.ndi_1;
        var dstOffset = buffer.pdi_1;
        var dstLimit = buffer.rdi_1;
        var tmp0_container = encodeUTF8(memory, text, index, toIndex, dstOffset, dstLimit);
        var characters = EncodeResult__component1_impl_36tlhi(tmp0_container);
        var bytes = EncodeResult__component2_impl_3nv7vp(tmp0_container);
        var tmp = index;
        // Inline function 'kotlin.UShort.toInt' call
        index = tmp + (_UShort___get_data__impl__g0245(characters) & 65535) | 0;
        // Inline function 'kotlin.UShort.toInt' call
        var tmp$ret$1 = _UShort___get_data__impl__g0245(bytes) & 65535;
        buffer.mdn(tmp$ret$1);
        var tmp_0;
        var tmp_1;
        // Inline function 'kotlin.UShort.toInt' call
        if ((_UShort___get_data__impl__g0245(characters) & 65535) === 0) {
          tmp_1 = index < toIndex;
        } else {
          tmp_1 = false;
        }
        if (tmp_1) {
          tmp_0 = 8;
        } else {
          if (index < toIndex) {
            tmp_0 = 1;
          } else {
            tmp_0 = 0;
          }
        }
        size = tmp_0;
        if (size <= 0)
          break $l$loop;
        tail = prepareWriteHead(_this__u8e3s4, size, tail);
      }
    }finally {
      _this__u8e3s4.hdn();
    }
  }
  function ChunkBuffer$Companion$EmptyPool$1() {
  }
  protoOf(ChunkBuffer$Companion$EmptyPool$1).gdp = function () {
    return Companion_getInstance_256().zdl_1;
  };
  protoOf(ChunkBuffer$Companion$EmptyPool$1).zdq = function (instance) {
    // Inline function 'kotlin.require' call
    if (!(instance === Companion_getInstance_256().zdl_1)) {
      var message = 'Only ChunkBuffer.Empty instance could be recycled.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
  };
  protoOf(ChunkBuffer$Companion$EmptyPool$1).hdp = function (instance) {
    return this.zdq(instance instanceof ChunkBuffer ? instance : THROW_CCE());
  };
  protoOf(ChunkBuffer$Companion$EmptyPool$1).zr = function () {
  };
  function ChunkBuffer$Companion$NoPool$1() {
    NoPoolImpl.call(this);
  }
  protoOf(ChunkBuffer$Companion$NoPool$1).gdp = function () {
    return new ChunkBuffer(DefaultAllocator_instance.ido(4096), null, this);
  };
  protoOf(ChunkBuffer$Companion$NoPool$1).zdq = function (instance) {
    DefaultAllocator_instance.kdo(instance.ndi_1);
  };
  protoOf(ChunkBuffer$Companion$NoPool$1).hdp = function (instance) {
    return this.zdq(instance instanceof ChunkBuffer ? instance : THROW_CCE());
  };
  function ChunkBuffer$Companion$NoPoolManuallyManaged$1() {
    NoPoolImpl.call(this);
  }
  protoOf(ChunkBuffer$Companion$NoPoolManuallyManaged$1).gdp = function () {
    throw UnsupportedOperationException_init_$Create$_0("This pool doesn't support borrow");
  };
  protoOf(ChunkBuffer$Companion$NoPoolManuallyManaged$1).zdq = function (instance) {
  };
  protoOf(ChunkBuffer$Companion$NoPoolManuallyManaged$1).hdp = function (instance) {
    return this.zdq(instance instanceof ChunkBuffer ? instance : THROW_CCE());
  };
  function appendNext($this, chunk) {
    if (!$this.wdo_1.atomicfu$compareAndSet(null, chunk)) {
      throw IllegalStateException_init_$Create$_0('This chunk has already a next chunk.');
    }
  }
  function Companion_256() {
    Companion_instance_256 = this;
    var tmp = this;
    tmp.ydl_1 = new ChunkBuffer$Companion$EmptyPool$1();
    this.zdl_1 = new ChunkBuffer(Companion_getInstance_258().tdq_1, null, this.ydl_1);
    var tmp_0 = this;
    tmp_0.adm_1 = new ChunkBuffer$Companion$NoPool$1();
    var tmp_1 = this;
    tmp_1.bdm_1 = new ChunkBuffer$Companion$NoPoolManuallyManaged$1();
  }
  protoOf(Companion_256).cdm = function () {
    return get_DefaultChunkedBufferPool();
  };
  var Companion_instance_256;
  function Companion_getInstance_256() {
    if (Companion_instance_256 == null)
      new Companion_256();
    return Companion_instance_256;
  }
  function ChunkBuffer(memory, origin, parentPool) {
    Companion_getInstance_256();
    Buffer.call(this, memory);
    this.vdo_1 = parentPool;
    // Inline function 'kotlin.require' call
    if (!!(origin === this)) {
      var message = "A chunk couldn't be a view of itself.";
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    this.wdo_1 = atomic$ref$1(null);
    this.xdo_1 = atomic$int$1(1);
    this.ydo_1 = origin;
  }
  protoOf(ChunkBuffer).sdq = function (newValue) {
    if (newValue == null) {
      this.idp();
    } else {
      appendNext(this, newValue);
    }
  };
  protoOf(ChunkBuffer).h12 = function () {
    return this.wdo_1.kotlinx$atomicfu$value;
  };
  protoOf(ChunkBuffer).cdp = function () {
    return this.xdo_1.kotlinx$atomicfu$value;
  };
  protoOf(ChunkBuffer).idp = function () {
    return this.wdo_1.atomicfu$getAndSet(null);
  };
  protoOf(ChunkBuffer).adr = function () {
    var tmp0_elvis_lhs = this.ydo_1;
    // Inline function 'kotlin.let' call
    var newOrigin = tmp0_elvis_lhs == null ? this : tmp0_elvis_lhs;
    newOrigin.bdr();
    // Inline function 'kotlin.also' call
    var this_0 = new ChunkBuffer(this.ndi_1, newOrigin, this.vdo_1);
    this.ydn(this_0);
    return this_0;
  };
  protoOf(ChunkBuffer).jdp = function (pool) {
    if (this.cdr()) {
      var origin = this.ydo_1;
      if (!(origin == null)) {
        this.zdo();
        origin.jdp(pool);
      } else {
        var tmp0_elvis_lhs = this.vdo_1;
        var poolToUse = tmp0_elvis_lhs == null ? pool : tmp0_elvis_lhs;
        poolToUse.hdp(this);
      }
    }
  };
  protoOf(ChunkBuffer).zdo = function () {
    if (!this.xdo_1.atomicfu$compareAndSet(0, -1)) {
      throw IllegalStateException_init_$Create$_0('Unable to unlink: buffer is in use.');
    }
    this.idp();
    this.ydo_1 = null;
  };
  protoOf(ChunkBuffer).bdr = function () {
    var tmp0 = this.xdo_1;
    $l$block: {
      // Inline function 'kotlinx.atomicfu.update' call
      while (true) {
        var cur = tmp0.kotlinx$atomicfu$value;
        if (cur <= 0)
          throw IllegalStateException_init_$Create$_0('Unable to acquire chunk: it is already released.');
        var upd = cur + 1 | 0;
        if (tmp0.atomicfu$compareAndSet(cur, upd)) {
          break $l$block;
        }
      }
    }
  };
  protoOf(ChunkBuffer).fdp = function () {
    var tmp0 = this.xdo_1;
    $l$block: {
      // Inline function 'kotlinx.atomicfu.update' call
      while (true) {
        var cur = tmp0.kotlinx$atomicfu$value;
        if (cur < 0) {
          throw IllegalStateException_init_$Create$_0("This instance is already disposed and couldn't be borrowed.");
        }
        if (cur > 0) {
          throw IllegalStateException_init_$Create$_0('This instance is already in use but somehow appeared in the pool.');
        }
        var upd = 1;
        if (tmp0.atomicfu$compareAndSet(cur, upd)) {
          break $l$block;
        }
      }
    }
  };
  protoOf(ChunkBuffer).cdr = function () {
    var tmp0 = this.xdo_1;
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlinx.atomicfu.updateAndGet' call
      while (true) {
        var cur = tmp0.kotlinx$atomicfu$value;
        if (cur <= 0)
          throw IllegalStateException_init_$Create$_0('Unable to release: it is already released.');
        var upd = cur - 1 | 0;
        if (tmp0.atomicfu$compareAndSet(cur, upd)) {
          tmp$ret$1 = upd;
          break $l$block;
        }
      }
    }
    return tmp$ret$1 === 0;
  };
  protoOf(ChunkBuffer).y3w = function () {
    // Inline function 'kotlin.require' call
    if (!(this.ydo_1 == null)) {
      var message = 'Unable to reset buffer with origin';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    protoOf(Buffer).y3w.call(this);
    this.wdo_1.kotlinx$atomicfu$value = null;
  };
  function isExclusivelyOwned(_this__u8e3s4) {
    return _this__u8e3s4.cdp() === 1;
  }
  function _EncodeResult___init__impl__vkc0cy(value) {
    return value;
  }
  function _EncodeResult___get_value__impl__h0r466($this) {
    return $this;
  }
  function _EncodeResult___init__impl__vkc0cy_0(characters, bytes) {
    // Inline function 'kotlin.UShort.toInt' call
    var tmp = (_UShort___get_data__impl__g0245(characters) & 65535) << 16;
    // Inline function 'kotlin.UShort.toInt' call
    var tmp$ret$1 = _UShort___get_data__impl__g0245(bytes) & 65535;
    return _EncodeResult___init__impl__vkc0cy(tmp | tmp$ret$1);
  }
  function _EncodeResult___get_characters__impl__rrxzcv($this) {
    // Inline function 'io.ktor.utils.io.bits.highShort' call
    var this_0 = _EncodeResult___get_value__impl__h0r466($this);
    // Inline function 'kotlin.toUShort' call
    var this_1 = toShort(this_0 >>> 16 | 0);
    return _UShort___init__impl__jigrne(this_1);
  }
  function _EncodeResult___get_bytes__impl__bt0kq0($this) {
    // Inline function 'io.ktor.utils.io.bits.lowShort' call
    var this_0 = _EncodeResult___get_value__impl__h0r466($this);
    // Inline function 'kotlin.toUShort' call
    var this_1 = toShort(this_0 & 65535);
    return _UShort___init__impl__jigrne(this_1);
  }
  function EncodeResult__component1_impl_36tlhi($this) {
    return _EncodeResult___get_characters__impl__rrxzcv($this);
  }
  function EncodeResult__component2_impl_3nv7vp($this) {
    return _EncodeResult___get_bytes__impl__bt0kq0($this);
  }
  function failLongToIntConversion(value, name) {
    throw IllegalArgumentException_init_$Create$_0('Long value ' + value.toString() + ' of ' + name + " doesn't fit into 32-bit integer");
  }
  function MalformedUTF8InputException(message) {
    Exception_init_$Init$_0(message, this);
    captureStack(this, MalformedUTF8InputException);
  }
  function encodeUTF8(_this__u8e3s4, text, from, to, dstOffset, dstLimit) {
    // Inline function 'kotlin.UShort.toInt' call
    var this_0 = _UShort___init__impl__jigrne(-1);
    // Inline function 'kotlin.comparisons.minOf' call
    var b = from + (_UShort___get_data__impl__g0245(this_0) & 65535) | 0;
    var lastCharIndex = Math.min(to, b);
    // Inline function 'kotlin.UShort.toInt' call
    var this_1 = _UShort___init__impl__jigrne(-1);
    var tmp$ret$2 = _UShort___get_data__impl__g0245(this_1) & 65535;
    var resultLimit = coerceAtMost(dstLimit, tmp$ret$2);
    var resultPosition = dstOffset;
    var index = from;
    $l$loop: do {
      if (resultPosition >= resultLimit || index >= lastCharIndex) {
        // Inline function 'kotlin.toUShort' call
        var this_2 = index - from | 0;
        var tmp = _UShort___init__impl__jigrne(toShort(this_2));
        // Inline function 'kotlin.toUShort' call
        var this_3 = resultPosition - dstOffset | 0;
        var tmp$ret$4 = _UShort___init__impl__jigrne(toShort(this_3));
        return _EncodeResult___init__impl__vkc0cy_0(tmp, tmp$ret$4);
      }
      var tmp0 = index;
      index = tmp0 + 1 | 0;
      // Inline function 'kotlin.code' call
      var this_4 = charSequenceGet(text, tmp0);
      var character = Char__toInt_impl_vasixd(this_4) & 65535;
      if ((character & 65408) === 0) {
        var tmp1 = resultPosition;
        resultPosition = tmp1 + 1 | 0;
        // Inline function 'io.ktor.utils.io.bits.Memory.storeAt' call
        var value = toByte(character);
        _this__u8e3s4.kdn_1.setInt8(tmp1, value);
      } else {
        break $l$loop;
      }
    }
     while (true);
    index = index - 1 | 0;
    return encodeUTF8Stage1(_this__u8e3s4, text, index, lastCharIndex, from, resultPosition, resultLimit, dstOffset);
  }
  function malformedByteCount(byteCount) {
    throw new MalformedUTF8InputException('Expected ' + byteCount + ' more character bytes');
  }
  function isBmpCodePoint(cp) {
    return (cp >>> 16 | 0) === 0;
  }
  function isValidCodePoint(codePoint) {
    return codePoint <= 1114111;
  }
  function malformedCodePoint(value) {
    throw IllegalArgumentException_init_$Create$_0('Malformed code-point ' + value + ' found');
  }
  function highSurrogate(cp) {
    return (cp >>> 10 | 0) + 55232 | 0;
  }
  function lowSurrogate(cp) {
    return (cp & 1023) + 56320 | 0;
  }
  function encodeUTF8Stage1(_this__u8e3s4, text, index1, lastCharIndex, from, resultPosition1, resultLimit, dstOffset) {
    var index = index1;
    var resultPosition = resultPosition1;
    var stage1Limit = resultLimit - 3 | 0;
    $l$loop: do {
      var freeSpace = stage1Limit - resultPosition | 0;
      if (freeSpace <= 0 || index >= lastCharIndex) {
        break $l$loop;
      }
      var tmp0 = index;
      index = tmp0 + 1 | 0;
      var character = charSequenceGet(text, tmp0);
      var tmp;
      if (isHighSurrogate(character)) {
        var tmp_0;
        if (index === lastCharIndex || !isLowSurrogate(charSequenceGet(text, index))) {
          tmp_0 = 63;
        } else {
          var tmp1 = index;
          index = tmp1 + 1 | 0;
          tmp_0 = codePoint(character, charSequenceGet(text, tmp1));
        }
        tmp = tmp_0;
      } else {
        // Inline function 'kotlin.code' call
        tmp = Char__toInt_impl_vasixd(character);
      }
      var codepoint = tmp;
      // Inline function 'io.ktor.utils.io.core.internal.putUtf8Char' call
      var offset = resultPosition;
      var tmp_1;
      if (0 <= codepoint ? codepoint <= 127 : false) {
        // Inline function 'io.ktor.utils.io.bits.Memory.storeAt' call
        var value = toByte(codepoint);
        _this__u8e3s4.kdn_1.setInt8(offset, value);
        tmp_1 = 1;
      } else if (128 <= codepoint ? codepoint <= 2047 : false) {
        // Inline function 'io.ktor.utils.io.bits.set' call
        // Inline function 'io.ktor.utils.io.bits.Memory.storeAt' call
        var value_0 = toByte(192 | codepoint >> 6 & 31);
        _this__u8e3s4.kdn_1.setInt8(offset, value_0);
        var tmp2 = offset + 1 | 0;
        // Inline function 'io.ktor.utils.io.bits.set' call
        // Inline function 'io.ktor.utils.io.bits.Memory.storeAt' call
        var value_1 = toByte(128 | codepoint & 63);
        _this__u8e3s4.kdn_1.setInt8(tmp2, value_1);
        tmp_1 = 2;
      } else if (2048 <= codepoint ? codepoint <= 65535 : false) {
        // Inline function 'io.ktor.utils.io.bits.set' call
        // Inline function 'io.ktor.utils.io.bits.Memory.storeAt' call
        var value_2 = toByte(224 | codepoint >> 12 & 15);
        _this__u8e3s4.kdn_1.setInt8(offset, value_2);
        var tmp2_0 = offset + 1 | 0;
        // Inline function 'io.ktor.utils.io.bits.set' call
        // Inline function 'io.ktor.utils.io.bits.Memory.storeAt' call
        var value_3 = toByte(128 | codepoint >> 6 & 63);
        _this__u8e3s4.kdn_1.setInt8(tmp2_0, value_3);
        var tmp2_1 = offset + 2 | 0;
        // Inline function 'io.ktor.utils.io.bits.set' call
        // Inline function 'io.ktor.utils.io.bits.Memory.storeAt' call
        var value_4 = toByte(128 | codepoint & 63);
        _this__u8e3s4.kdn_1.setInt8(tmp2_1, value_4);
        tmp_1 = 3;
      } else if (65536 <= codepoint ? codepoint <= 1114111 : false) {
        // Inline function 'io.ktor.utils.io.bits.set' call
        // Inline function 'io.ktor.utils.io.bits.Memory.storeAt' call
        var value_5 = toByte(240 | codepoint >> 18 & 7);
        _this__u8e3s4.kdn_1.setInt8(offset, value_5);
        var tmp2_2 = offset + 1 | 0;
        // Inline function 'io.ktor.utils.io.bits.set' call
        // Inline function 'io.ktor.utils.io.bits.Memory.storeAt' call
        var value_6 = toByte(128 | codepoint >> 12 & 63);
        _this__u8e3s4.kdn_1.setInt8(tmp2_2, value_6);
        var tmp2_3 = offset + 2 | 0;
        // Inline function 'io.ktor.utils.io.bits.set' call
        // Inline function 'io.ktor.utils.io.bits.Memory.storeAt' call
        var value_7 = toByte(128 | codepoint >> 6 & 63);
        _this__u8e3s4.kdn_1.setInt8(tmp2_3, value_7);
        var tmp2_4 = offset + 3 | 0;
        // Inline function 'io.ktor.utils.io.bits.set' call
        // Inline function 'io.ktor.utils.io.bits.Memory.storeAt' call
        var value_8 = toByte(128 | codepoint & 63);
        _this__u8e3s4.kdn_1.setInt8(tmp2_4, value_8);
        tmp_1 = 4;
      } else {
        malformedCodePoint(codepoint);
      }
      var size = tmp_1;
      resultPosition = resultPosition + size | 0;
    }
     while (true);
    if (resultPosition === stage1Limit) {
      return encodeUTF8Stage2(_this__u8e3s4, text, index, lastCharIndex, from, resultPosition, resultLimit, dstOffset);
    }
    // Inline function 'kotlin.toUShort' call
    var this_0 = index - from | 0;
    var tmp_2 = _UShort___init__impl__jigrne(toShort(this_0));
    // Inline function 'kotlin.toUShort' call
    var this_1 = resultPosition - dstOffset | 0;
    var tmp$ret$22 = _UShort___init__impl__jigrne(toShort(this_1));
    return _EncodeResult___init__impl__vkc0cy_0(tmp_2, tmp$ret$22);
  }
  function codePoint(high, low) {
    // Inline function 'kotlin.code' call
    var highValue = Char__toInt_impl_vasixd(high) - 55232 | 0;
    // Inline function 'kotlin.code' call
    var lowValue = Char__toInt_impl_vasixd(low) - 56320 | 0;
    return highValue << 10 | lowValue;
  }
  function encodeUTF8Stage2(_this__u8e3s4, text, index1, lastCharIndex, from, resultPosition1, resultLimit, dstOffset) {
    var index = index1;
    var resultPosition = resultPosition1;
    $l$loop_0: do {
      var freeSpace = resultLimit - resultPosition | 0;
      if (freeSpace <= 0 || index >= lastCharIndex) {
        break $l$loop_0;
      }
      var tmp0 = index;
      index = tmp0 + 1 | 0;
      var character = charSequenceGet(text, tmp0);
      var tmp;
      if (!isHighSurrogate(character)) {
        // Inline function 'kotlin.code' call
        tmp = Char__toInt_impl_vasixd(character);
      } else {
        var tmp_0;
        if (index === lastCharIndex || !isLowSurrogate(charSequenceGet(text, index))) {
          tmp_0 = 63;
        } else {
          var tmp1 = index;
          index = tmp1 + 1 | 0;
          tmp_0 = codePoint(character, charSequenceGet(text, tmp1));
        }
        tmp = tmp_0;
      }
      var codepoint = tmp;
      // Inline function 'io.ktor.utils.io.core.internal.charactersSize' call
      var tmp_1;
      if (1 <= codepoint ? codepoint <= 127 : false) {
        tmp_1 = 1;
      } else if (128 <= codepoint ? codepoint <= 2047 : false) {
        tmp_1 = 2;
      } else if (2048 <= codepoint ? codepoint <= 65535 : false) {
        tmp_1 = 3;
      } else if (65536 <= codepoint ? codepoint <= 1114111 : false) {
        tmp_1 = 4;
      } else {
        malformedCodePoint(codepoint);
      }
      if (tmp_1 > freeSpace) {
        index = index - 1 | 0;
        break $l$loop_0;
      }
      // Inline function 'io.ktor.utils.io.core.internal.putUtf8Char' call
      var offset = resultPosition;
      var tmp_2;
      if (0 <= codepoint ? codepoint <= 127 : false) {
        // Inline function 'io.ktor.utils.io.bits.Memory.storeAt' call
        var value = toByte(codepoint);
        _this__u8e3s4.kdn_1.setInt8(offset, value);
        tmp_2 = 1;
      } else if (128 <= codepoint ? codepoint <= 2047 : false) {
        // Inline function 'io.ktor.utils.io.bits.set' call
        // Inline function 'io.ktor.utils.io.bits.Memory.storeAt' call
        var value_0 = toByte(192 | codepoint >> 6 & 31);
        _this__u8e3s4.kdn_1.setInt8(offset, value_0);
        var tmp2 = offset + 1 | 0;
        // Inline function 'io.ktor.utils.io.bits.set' call
        // Inline function 'io.ktor.utils.io.bits.Memory.storeAt' call
        var value_1 = toByte(128 | codepoint & 63);
        _this__u8e3s4.kdn_1.setInt8(tmp2, value_1);
        tmp_2 = 2;
      } else if (2048 <= codepoint ? codepoint <= 65535 : false) {
        // Inline function 'io.ktor.utils.io.bits.set' call
        // Inline function 'io.ktor.utils.io.bits.Memory.storeAt' call
        var value_2 = toByte(224 | codepoint >> 12 & 15);
        _this__u8e3s4.kdn_1.setInt8(offset, value_2);
        var tmp2_0 = offset + 1 | 0;
        // Inline function 'io.ktor.utils.io.bits.set' call
        // Inline function 'io.ktor.utils.io.bits.Memory.storeAt' call
        var value_3 = toByte(128 | codepoint >> 6 & 63);
        _this__u8e3s4.kdn_1.setInt8(tmp2_0, value_3);
        var tmp2_1 = offset + 2 | 0;
        // Inline function 'io.ktor.utils.io.bits.set' call
        // Inline function 'io.ktor.utils.io.bits.Memory.storeAt' call
        var value_4 = toByte(128 | codepoint & 63);
        _this__u8e3s4.kdn_1.setInt8(tmp2_1, value_4);
        tmp_2 = 3;
      } else if (65536 <= codepoint ? codepoint <= 1114111 : false) {
        // Inline function 'io.ktor.utils.io.bits.set' call
        // Inline function 'io.ktor.utils.io.bits.Memory.storeAt' call
        var value_5 = toByte(240 | codepoint >> 18 & 7);
        _this__u8e3s4.kdn_1.setInt8(offset, value_5);
        var tmp2_2 = offset + 1 | 0;
        // Inline function 'io.ktor.utils.io.bits.set' call
        // Inline function 'io.ktor.utils.io.bits.Memory.storeAt' call
        var value_6 = toByte(128 | codepoint >> 12 & 63);
        _this__u8e3s4.kdn_1.setInt8(tmp2_2, value_6);
        var tmp2_3 = offset + 2 | 0;
        // Inline function 'io.ktor.utils.io.bits.set' call
        // Inline function 'io.ktor.utils.io.bits.Memory.storeAt' call
        var value_7 = toByte(128 | codepoint >> 6 & 63);
        _this__u8e3s4.kdn_1.setInt8(tmp2_3, value_7);
        var tmp2_4 = offset + 3 | 0;
        // Inline function 'io.ktor.utils.io.bits.set' call
        // Inline function 'io.ktor.utils.io.bits.Memory.storeAt' call
        var value_8 = toByte(128 | codepoint & 63);
        _this__u8e3s4.kdn_1.setInt8(tmp2_4, value_8);
        tmp_2 = 4;
      } else {
        malformedCodePoint(codepoint);
      }
      var size = tmp_2;
      resultPosition = resultPosition + size | 0;
    }
     while (true);
    // Inline function 'kotlin.toUShort' call
    var this_0 = index - from | 0;
    var tmp_3 = _UShort___init__impl__jigrne(toShort(this_0));
    // Inline function 'kotlin.toUShort' call
    var this_1 = resultPosition - dstOffset | 0;
    var tmp$ret$23 = _UShort___init__impl__jigrne(toShort(this_1));
    return _EncodeResult___init__impl__vkc0cy_0(tmp_3, tmp$ret$23);
  }
  function get_EmptyByteArray() {
    _init_properties_Unsafe_kt__orlvcq();
    return EmptyByteArray;
  }
  var EmptyByteArray;
  function completeReadHead(_this__u8e3s4, current) {
    _init_properties_Unsafe_kt__orlvcq();
    if (current === _this__u8e3s4)
      return Unit_instance;
    else {
      // Inline function 'io.ktor.utils.io.core.canRead' call
      if (!(current.pdi_1 > current.odi_1)) {
        _this__u8e3s4.odq(current);
      } else {
        // Inline function 'io.ktor.utils.io.core.Buffer.endGap' call
        if ((current.sdi_1 - current.rdi_1 | 0) < 8) {
          _this__u8e3s4.pdq(current);
        } else {
          _this__u8e3s4.wdj_1 = current.odi_1;
        }
      }
    }
  }
  function prepareReadFirstHead(_this__u8e3s4, minSize) {
    _init_properties_Unsafe_kt__orlvcq();
    return _this__u8e3s4.mdq(minSize);
  }
  function prepareReadNextHead(_this__u8e3s4, current) {
    _init_properties_Unsafe_kt__orlvcq();
    if (current === _this__u8e3s4) {
      return _this__u8e3s4.pdk() ? _this__u8e3s4 : null;
    }
    return _this__u8e3s4.ndq(current);
  }
  function prepareWriteHead(_this__u8e3s4, capacity, current) {
    _init_properties_Unsafe_kt__orlvcq();
    if (!(current == null)) {
      _this__u8e3s4.hdn();
    }
    return _this__u8e3s4.rdp(capacity);
  }
  function unsafeAppend(_this__u8e3s4, builder) {
    _init_properties_Unsafe_kt__orlvcq();
    var builderSize = builder.p();
    var tmp0_elvis_lhs = builder.pdg();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return 0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var builderHead = tmp;
    if (builderSize <= get_PACKET_MAX_COPY_SIZE() && builderHead.h12() == null && _this__u8e3s4.hdq(builderHead)) {
      builder.sdp();
      return builderSize;
    }
    _this__u8e3s4.gdq(builderHead);
    return builderSize;
  }
  var properties_initialized_Unsafe_kt_o5mw48;
  function _init_properties_Unsafe_kt__orlvcq() {
    if (!properties_initialized_Unsafe_kt_o5mw48) {
      properties_initialized_Unsafe_kt_o5mw48 = true;
      EmptyByteArray = new Int8Array(0);
    }
  }
  function trySuspend_1($this, sleepCondition, $completion) {
    var tmp = new $trySuspendCOROUTINE$($this, sleepCondition, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  }
  function $sleepCOROUTINE$(_this__u8e3s4, sleepCondition, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.wdr_1 = _this__u8e3s4;
    this.xdr_1 = sleepCondition;
  }
  protoOf($sleepCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 3;
            this.f9_1 = 1;
            suspendResult = trySuspend_1(this.wdr_1, this.xdr_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            if (suspendResult) {
              return Unit_instance;
            } else {
              this.f9_1 = 2;
              continue $sm;
            }

          case 2:
            this.wdr_1.ydf();
            return Unit_instance;
          case 3:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 3) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function $trySuspendCOROUTINE$(_this__u8e3s4, sleepCondition, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.ldr_1 = _this__u8e3s4;
    this.mdr_1 = sleepCondition;
  }
  protoOf($trySuspendCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 3;
            this.ndr_1 = false;
            var job = Job_0();
            if (this.ldr_1.xdf_1.atomicfu$compareAndSet(null, job) && this.mdr_1()) {
              this.ndr_1 = true;
              this.f9_1 = 1;
              suspendResult = job.np(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.f9_1 = 2;
              continue $sm;
            }

          case 1:
            this.f9_1 = 2;
            continue $sm;
          case 2:
            return this.ndr_1;
          case 3:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 3) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function AwaitingSlot() {
    this.xdf_1 = atomic$ref$1(null);
  }
  protoOf(AwaitingSlot).rdh = function (sleepCondition, $completion) {
    var tmp = new $sleepCOROUTINE$(this, sleepCondition, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(AwaitingSlot).ydf = function () {
    var tmp0_safe_receiver = this.xdf_1.atomicfu$getAndSet(null);
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver.su();
  };
  protoOf(AwaitingSlot).mdm = function (cause) {
    var tmp0_elvis_lhs = this.xdf_1.atomicfu$getAndSet(null);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var continuation = tmp;
    if (!(cause == null)) {
      continuation.ru(cause);
    } else {
      continuation.su();
    }
  };
  function copyToSequentialImpl(_this__u8e3s4, dst, limit, $completion) {
    var tmp = new $copyToSequentialImplCOROUTINE$(_this__u8e3s4, dst, limit, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  }
  function copyToTail(_this__u8e3s4, dst, limit, $completion) {
    var tmp = new $copyToTailCOROUTINE$(_this__u8e3s4, dst, limit, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  }
  function $copyToSequentialImplCOROUTINE$(_this__u8e3s4, dst, limit, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.gds_1 = _this__u8e3s4;
    this.hds_1 = dst;
    this.ids_1 = limit;
  }
  protoOf($copyToSequentialImplCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 10;
            if (!!(this.gds_1 === this.hds_1)) {
              var message = 'Failed requirement.';
              throw IllegalArgumentException_init_$Create$_0(toString_1(message));
            }

            if (!(this.gds_1.rdg() == null)) {
              this.hds_1.g16(this.gds_1.rdg());
              return 0n;
            }

            this.jds_1 = this.ids_1;
            this.f9_1 = 1;
            continue $sm;
          case 1:
            if (!(this.jds_1 > 0n)) {
              this.f9_1 = 9;
              continue $sm;
            }

            this.f9_1 = 2;
            suspendResult = this.gds_1.ldm(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            if (!suspendResult) {
              this.f9_1 = 9;
              continue $sm;
            } else {
              this.f9_1 = 3;
              continue $sm;
            }

          case 3:
            this.mds_1 = this.gds_1.ndm(this.hds_1, this.jds_1);
            if (this.mds_1 === 0n) {
              this.f9_1 = 6;
              suspendResult = copyToTail(this.gds_1, this.hds_1, this.jds_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              if (this.hds_1.fdh() === 0) {
                this.f9_1 = 4;
                suspendResult = this.hds_1.mdi(1, this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                this.f9_1 = 5;
                continue $sm;
              }
            }

          case 4:
            this.f9_1 = 5;
            continue $sm;
          case 5:
            this.kds_1 = this.mds_1;
            this.f9_1 = 8;
            continue $sm;
          case 6:
            this.lds_1 = suspendResult;
            if (this.lds_1 === 0n) {
              this.f9_1 = 9;
              continue $sm;
            } else {
              this.f9_1 = 7;
              continue $sm;
            }

          case 7:
            this.kds_1 = this.lds_1;
            this.f9_1 = 8;
            continue $sm;
          case 8:
            var copied = this.kds_1;
            this.jds_1 = subtract_1(this.jds_1, copied);
            if (copied > 0n) {
              this.hds_1.c9();
            }

            this.f9_1 = 1;
            continue $sm;
          case 9:
            return subtract_1(this.ids_1, this.jds_1);
          case 10:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 10) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function $copyToTailCOROUTINE$(_this__u8e3s4, dst, limit, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.vds_1 = _this__u8e3s4;
    this.wds_1 = dst;
    this.xds_1 = limit;
  }
  protoOf($copyToTailCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 9;
            this.yds_1 = Companion_getInstance_256().cdm().gdp();
            this.f9_1 = 1;
            continue $sm;
          case 1:
            this.f9_1 = 2;
            continue $sm;
          case 2:
            this.g9_1 = 8;
            this.yds_1.udn(convertToInt(coerceAtMost_0(this.xds_1, fromInt_0(this.yds_1.sdi_1))));
            this.f9_1 = 3;
            suspendResult = this.vds_1.idm(this.yds_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            this.adt_1 = suspendResult;
            if (this.adt_1 === -1) {
              this.yds_1.jdp(Companion_getInstance_256().cdm());
              this.zds_1 = 0n;
              this.g9_1 = 9;
              this.f9_1 = 6;
              continue $sm;
            } else {
              this.f9_1 = 4;
              continue $sm;
            }

          case 4:
            this.f9_1 = 5;
            suspendResult = this.wds_1.edm(this.yds_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 5:
            this.zds_1 = fromInt_0(this.adt_1);
            this.g9_1 = 9;
            this.f9_1 = 6;
            continue $sm;
          case 6:
            var tmp_0 = this.zds_1;
            this.g9_1 = 9;
            this.yds_1.jdp(Companion_getInstance_256().cdm());
            return tmp_0;
          case 7:
            this.g9_1 = 9;
            this.yds_1.jdp(Companion_getInstance_256().cdm());
            return Unit_instance;
          case 8:
            this.g9_1 = 9;
            var t = this.i9_1;
            this.yds_1.jdp(Companion_getInstance_256().cdm());
            throw t;
          case 9:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 9) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function get_ByteArrayPool() {
    _init_properties_ByteArrayPool_kt__kfi3uj();
    return ByteArrayPool;
  }
  var ByteArrayPool;
  function ByteArrayPool$1() {
    DefaultPool.call(this, 128);
  }
  protoOf(ByteArrayPool$1).hdo = function () {
    return new Int8Array(4096);
  };
  var properties_initialized_ByteArrayPool_kt_td6pfh;
  function _init_properties_ByteArrayPool_kt__kfi3uj() {
    if (!properties_initialized_ByteArrayPool_kt_td6pfh) {
      properties_initialized_ByteArrayPool_kt_td6pfh = true;
      ByteArrayPool = new ByteArrayPool$1();
    }
  }
  function ObjectPool() {
  }
  function NoPoolImpl() {
  }
  protoOf(NoPoolImpl).hdp = function (instance) {
  };
  protoOf(NoPoolImpl).zr = function () {
  };
  function copyTo(_this__u8e3s4, dst, limit, $completion) {
    var tmp = _this__u8e3s4 instanceof ByteChannelSequentialBase ? _this__u8e3s4 : THROW_CCE();
    return copyToSequentialImpl(tmp, dst instanceof ByteChannelSequentialBase ? dst : THROW_CCE(), limit, $completion);
  }
  function ByteChannel(autoFlush) {
    autoFlush = autoFlush === VOID ? false : autoFlush;
    return new ByteChannelJS(Companion_getInstance_256().zdl_1, autoFlush);
  }
  function ByteReadChannel_0(content, offset, length) {
    // Inline function 'kotlin.collections.isEmpty' call
    if (content.length === 0)
      return Companion_getInstance_257().jdn();
    var head = Companion_getInstance_256().cdm().gdp();
    var tail = head;
    var start = offset;
    var end = start + length | 0;
    $l$loop: while (true) {
      tail.rdn(8);
      var tmp0 = end - start | 0;
      // Inline function 'io.ktor.utils.io.core.Buffer.writeRemaining' call
      var this_0 = tail;
      // Inline function 'kotlin.comparisons.minOf' call
      var b = this_0.rdi_1 - this_0.pdi_1 | 0;
      var size = Math.min(tmp0, b);
      writeFully_1(tail instanceof Buffer ? tail : THROW_CCE(), content, start, size);
      start = start + size | 0;
      if (start === end)
        break $l$loop;
      var current = tail;
      tail = Companion_getInstance_256().cdm().gdp();
      current.sdq(tail);
    }
    // Inline function 'kotlin.apply' call
    var this_1 = new ByteChannelJS(head, false);
    close_1(this_1);
    return this_1;
  }
  function ByteChannelJS$attachJob$lambda(this$0) {
    return function (cause) {
      this$0.tdt_1 = null;
      var tmp;
      if (!(cause == null)) {
        this$0.qt(unwrapCancellationException(cause));
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ByteChannelJS(initial, autoFlush) {
    ByteChannelSequentialBase.call(this, initial, autoFlush);
    this.tdt_1 = null;
  }
  protoOf(ByteChannelJS).pdm = function (job) {
    var tmp0_safe_receiver = this.tdt_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.sp();
    }
    this.tdt_1 = job;
    job.mp(true, VOID, ByteChannelJS$attachJob$lambda(this));
  };
  protoOf(ByteChannelJS).toString = function () {
    return 'ByteChannel[' + toString_0(this.tdt_1) + ', ' + hashCode(this) + ']';
  };
  function ByteReadChannel$Companion$Empty$delegate$lambda() {
    // Inline function 'kotlin.apply' call
    var this_0 = new ByteChannelJS(Companion_getInstance_256().zdl_1, false);
    this_0.g16(null);
    return this_0;
  }
  function ByteReadChannel$Companion$_get_Empty_$ref_55olb0() {
    return function (p0) {
      return p0.jdn();
    };
  }
  function Companion_257() {
    Companion_instance_257 = this;
    var tmp = this;
    tmp.edt_1 = lazy(ByteReadChannel$Companion$Empty$delegate$lambda);
  }
  protoOf(Companion_257).jdn = function () {
    var tmp0 = this.edt_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('Empty', 1, tmp, ByteReadChannel$Companion$_get_Empty_$ref_55olb0(), null);
    return tmp0.a1();
  };
  var Companion_instance_257;
  function Companion_getInstance_257() {
    if (Companion_instance_257 == null)
      new Companion_257();
    return Companion_instance_257;
  }
  function ByteReadChannel_1() {
  }
  function DefaultAllocator() {
  }
  protoOf(DefaultAllocator).ido = function (size) {
    return new Memory(new DataView(new ArrayBuffer(size)));
  };
  protoOf(DefaultAllocator).kdo = function (instance) {
  };
  var DefaultAllocator_instance;
  function DefaultAllocator_getInstance() {
    return DefaultAllocator_instance;
  }
  function of(_this__u8e3s4, buffer, offset, length) {
    offset = offset === VOID ? 0 : offset;
    length = length === VOID ? buffer.byteLength - offset | 0 : length;
    return new Memory(new DataView(buffer, offset, length));
  }
  function of_0(_this__u8e3s4, array, offset, length) {
    offset = offset === VOID ? 0 : offset;
    length = length === VOID ? array.length - offset | 0 : length;
    // Inline function 'kotlin.js.asDynamic' call
    var typedArray = array;
    return of_1(Companion_getInstance_258(), typedArray, offset, length);
  }
  function of_1(_this__u8e3s4, view, offset, length) {
    offset = offset === VOID ? 0 : offset;
    length = length === VOID ? view.byteLength : length;
    return of(Companion_getInstance_258(), view.buffer, view.byteOffset + offset | 0, length);
  }
  function Companion_258() {
    Companion_instance_258 = this;
    this.tdq_1 = new Memory(new DataView(new ArrayBuffer(0)));
  }
  var Companion_instance_258;
  function Companion_getInstance_258() {
    if (Companion_instance_258 == null)
      new Companion_258();
    return Companion_instance_258;
  }
  function Memory(view) {
    Companion_getInstance_258();
    this.kdn_1 = view;
  }
  protoOf(Memory).udt = function (offset, length) {
    // Inline function 'kotlin.require' call
    if (!(offset >= 0)) {
      var message = "offset shouldn't be negative: " + offset;
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    // Inline function 'kotlin.require' call
    if (!(length >= 0)) {
      var message_0 = "length shouldn't be negative: " + length;
      throw IllegalArgumentException_init_$Create$_0(toString_1(message_0));
    }
    var tmp = fromInt_0(offset + length | 0);
    // Inline function 'io.ktor.utils.io.bits.Memory.size' call
    if (tmp > fromInt_0(this.kdn_1.byteLength)) {
      // Inline function 'io.ktor.utils.io.bits.Memory.size' call
      var tmp$ret$5 = fromInt_0(this.kdn_1.byteLength);
      throw IndexOutOfBoundsException_init_$Create$_0('offset + length > size: ' + offset + ' + ' + length + ' > ' + tmp$ret$5.toString());
    }
    return new Memory(new DataView(this.kdn_1.buffer, this.kdn_1.byteOffset + offset | 0, length));
  };
  protoOf(Memory).bdo = function (destination, offset, length, destinationOffset) {
    var src = new Int8Array(this.kdn_1.buffer, this.kdn_1.byteOffset + offset | 0, length);
    var dst = new Int8Array(destination.kdn_1.buffer, destination.kdn_1.byteOffset + destinationOffset | 0, length);
    dst.set(src);
  };
  function copyTo_0(_this__u8e3s4, destination, offset, length, destinationOffset) {
    copyTo_1(_this__u8e3s4.buffer, destination, offset + _this__u8e3s4.byteOffset | 0, length, destinationOffset);
  }
  function copyTo_1(_this__u8e3s4, destination, offset, length, destinationOffset) {
    var from = new Int8Array(_this__u8e3s4, offset, length);
    var to = new Int8Array(destination.kdn_1.buffer, destination.kdn_1.byteOffset + destinationOffset | 0, length);
    to.set(from, 0);
  }
  function copyTo_2(_this__u8e3s4, destination, offset, length, destinationOffset) {
    // Inline function 'kotlin.js.asDynamic' call
    var to = destination;
    var from = new Int8Array(_this__u8e3s4.kdn_1.buffer, _this__u8e3s4.kdn_1.byteOffset + offset | 0, length);
    to.set(from, destinationOffset);
  }
  function MalformedInputException(message) {
    extendThrowable(this, message);
    captureStack(this, MalformedInputException);
  }
  function Companion_259() {
  }
  protoOf(Companion_259).h9z = function (name) {
    switch (name) {
      case 'UTF-8':
      case 'utf-8':
      case 'UTF8':
      case 'utf8':
        return Charsets_getInstance().udq_1;
    }
    var tmp;
    var tmp_0;
    var tmp_1;
    switch (name) {
      case 'ISO-8859-1':
      case 'iso-8859-1':
        tmp_1 = true;
        break;
      default:
        // Inline function 'kotlin.let' call

        var it = replace_0(name, _Char___init__impl__6a9atx(95), _Char___init__impl__6a9atx(45));
        var tmp_2;
        if (it === 'iso-8859-1') {
          tmp_2 = true;
        } else {
          // Inline function 'kotlin.text.lowercase' call
          // Inline function 'kotlin.js.asDynamic' call
          tmp_2 = it.toLowerCase() === 'iso-8859-1';
        }

        tmp_1 = tmp_2;
        break;
    }
    if (tmp_1) {
      tmp_0 = true;
    } else {
      tmp_0 = name === 'latin1';
    }
    if (tmp_0) {
      tmp = true;
    } else {
      tmp = name === 'Latin1';
    }
    if (tmp) {
      return Charsets_getInstance().vdq_1;
    }
    throw IllegalArgumentException_init_$Create$_0('Charset ' + name + ' is not supported');
  };
  protoOf(Companion_259).vdt = function (charset) {
    var tmp;
    switch (charset) {
      case 'UTF-8':
      case 'utf-8':
      case 'UTF8':
      case 'utf8':
        tmp = true;
        break;
      default:
        var tmp_0;
        var tmp_1;
        switch (charset) {
          case 'ISO-8859-1':
          case 'iso-8859-1':
            tmp_1 = true;
            break;
          default:
            // Inline function 'kotlin.let' call

            var it = replace_0(charset, _Char___init__impl__6a9atx(95), _Char___init__impl__6a9atx(45));
            var tmp_2;
            if (it === 'iso-8859-1') {
              tmp_2 = true;
            } else {
              // Inline function 'kotlin.text.lowercase' call
              // Inline function 'kotlin.js.asDynamic' call
              tmp_2 = it.toLowerCase() === 'iso-8859-1';
            }

            tmp_1 = tmp_2;
            break;
        }

        if (tmp_1) {
          tmp_0 = true;
        } else {
          tmp_0 = charset === 'latin1';
        }

        if (tmp_0) {
          tmp = true;
        } else {
          tmp = false;
        }

        break;
    }
    return tmp;
  };
  var Companion_instance_259;
  function Companion_getInstance_259() {
    return Companion_instance_259;
  }
  function Charset(_name) {
    this.wdq_1 = _name;
  }
  protoOf(Charset).equals = function (other) {
    if (this === other)
      return true;
    if (other == null || !(this.constructor == other.constructor))
      return false;
    if (!(other instanceof Charset))
      THROW_CCE();
    if (!(this.wdq_1 === other.wdq_1))
      return false;
    return true;
  };
  protoOf(Charset).hashCode = function () {
    return getStringHashCode(this.wdq_1);
  };
  protoOf(Charset).toString = function () {
    return this.wdq_1;
  };
  function get_name_6(_this__u8e3s4) {
    return _this__u8e3s4.wdq_1;
  }
  function Charsets() {
    Charsets_instance = this;
    this.udq_1 = new CharsetImpl('UTF-8');
    this.vdq_1 = new CharsetImpl('ISO-8859-1');
  }
  var Charsets_instance;
  function Charsets_getInstance() {
    if (Charsets_instance == null)
      new Charsets();
    return Charsets_instance;
  }
  function CharsetDecoder(_charset) {
    this.wdt_1 = _charset;
  }
  function CharsetEncoder(_charset) {
    this.xdt_1 = _charset;
  }
  function decode_0(_this__u8e3s4, input, dst, max) {
    var decoder = Decoder_0(get_name_6(get_charset(_this__u8e3s4)), true);
    var charactersCopied = 0;
    $l$block: {
      // Inline function 'io.ktor.utils.io.core.takeWhileSize' call
      var release = true;
      var tmp0_elvis_lhs = prepareReadFirstHead(input, 1);
      var tmp;
      if (tmp0_elvis_lhs == null) {
        break $l$block;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var current = tmp;
      var size = 1;
      try {
        $l$loop: do {
          // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
          var this_0 = current;
          var before = this_0.pdi_1 - this_0.odi_1 | 0;
          var after;
          if (before >= size) {
            try {
              var tmp0 = current;
              var tmp$ret$3;
              $l$block_0: {
                var rem = max - charactersCopied | 0;
                // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
                var bufferSize = tmp0.pdi_1 - tmp0.odi_1 | 0;
                if (rem < bufferSize) {
                  tmp$ret$3 = 0;
                  break $l$block_0;
                }
                // Inline function 'io.ktor.utils.io.core.readDirectInt8Array' call
                // Inline function 'kotlin.contracts.contract' call
                // Inline function 'io.ktor.utils.io.core.read' call
                // Inline function 'kotlin.contracts.contract' call
                var tmp0_0 = tmp0.ndi_1;
                var tmp2 = tmp0.odi_1;
                var endExclusive = tmp0.pdi_1;
                var view = new Int8Array(tmp0_0.kdn_1.buffer, tmp0_0.kdn_1.byteOffset + tmp2 | 0, endExclusive - tmp2 | 0);
                $l$block_2: {
                  // Inline function 'io.ktor.utils.io.js.decodeWrap' call
                  try {
                    var tmp$ret$6;
                    $l$block_1: {
                      // Inline function 'io.ktor.utils.io.js.decodeStream' call
                      // Inline function 'io.ktor.utils.io.js.decodeWrap' call
                      try {
                        tmp$ret$6 = decoder.ydt(view, decodeOptions(true));
                        break $l$block_1;
                      } catch ($p) {
                        if ($p instanceof Error) {
                          var t = $p;
                          var tmp0_elvis_lhs_0 = t.message;
                          throw new MalformedInputException('Failed to decode bytes: ' + (tmp0_elvis_lhs_0 == null ? 'no cause provided' : tmp0_elvis_lhs_0));
                        } else {
                          throw $p;
                        }
                      }
                    }
                    break $l$block_2;
                  } catch ($p) {
                    if ($p instanceof Error) {
                      var t_0 = $p;
                      var tmp0_elvis_lhs_1 = t_0.message;
                      throw new MalformedInputException('Failed to decode bytes: ' + (tmp0_elvis_lhs_1 == null ? 'no cause provided' : tmp0_elvis_lhs_1));
                    } else {
                      throw $p;
                    }
                  }
                }
                var decodedText = tmp$ret$6;
                dst.k(decodedText);
                charactersCopied = charactersCopied + decodedText.length | 0;
                var rc = view.byteLength;
                tmp0.ldn(rc);
                var tmp_0;
                if (charactersCopied === max) {
                  var tmp_1;
                  try {
                    tmp_1 = decoder.zdt();
                  } catch ($p) {
                    var tmp_2;
                    var _ = $p;
                    tmp_2 = '';
                    tmp_1 = tmp_2;
                  }
                  var tail = tmp_1;
                  // Inline function 'kotlin.text.isNotEmpty' call
                  if (charSequenceLength(tail) > 0) {
                    tmp0.pdn(bufferSize);
                  }
                  tmp_0 = 0;
                } else if (charactersCopied < max) {
                  tmp_0 = 8;
                } else {
                  tmp_0 = 0;
                }
                tmp$ret$3 = tmp_0;
              }
              size = tmp$ret$3;
            }finally {
              // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
              var this_1 = current;
              after = this_1.pdi_1 - this_1.odi_1 | 0;
            }
          } else {
            after = before;
          }
          release = false;
          var tmp_3;
          if (after === 0) {
            tmp_3 = prepareReadNextHead(input, current);
          } else {
            var tmp_4;
            if (after < size) {
              tmp_4 = true;
            } else {
              // Inline function 'io.ktor.utils.io.core.Buffer.endGap' call
              var this_2 = current;
              tmp_4 = (this_2.sdi_1 - this_2.rdi_1 | 0) < 8;
            }
            if (tmp_4) {
              completeReadHead(input, current);
              tmp_3 = prepareReadFirstHead(input, size);
            } else {
              tmp_3 = current;
            }
          }
          var tmp1_elvis_lhs = tmp_3;
          var tmp_5;
          if (tmp1_elvis_lhs == null) {
            break $l$loop;
          } else {
            tmp_5 = tmp1_elvis_lhs;
          }
          var next = tmp_5;
          current = next;
          release = true;
        }
         while (size > 0);
      }finally {
        if (release) {
          completeReadHead(input, current);
        }
      }
    }
    if (charactersCopied < max) {
      var size_0 = 1;
      $l$block_3: {
        // Inline function 'io.ktor.utils.io.core.takeWhileSize' call
        var release_0 = true;
        var tmp0_elvis_lhs_2 = prepareReadFirstHead(input, 1);
        var tmp_6;
        if (tmp0_elvis_lhs_2 == null) {
          break $l$block_3;
        } else {
          tmp_6 = tmp0_elvis_lhs_2;
        }
        var current_0 = tmp_6;
        var size_1 = 1;
        try {
          $l$loop_0: do {
            // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
            var this_3 = current_0;
            var before_0 = this_3.pdi_1 - this_3.odi_1 | 0;
            var after_0;
            if (before_0 >= size_1) {
              try {
                // Inline function 'io.ktor.utils.io.core.readDirectInt8Array' call
                // Inline function 'kotlin.contracts.contract' call
                // Inline function 'io.ktor.utils.io.core.read' call
                var this_4 = current_0;
                // Inline function 'kotlin.contracts.contract' call
                var tmp0_1 = this_4.ndi_1;
                var tmp2_0 = this_4.odi_1;
                var endExclusive_0 = this_4.pdi_1;
                var view_0 = new Int8Array(tmp0_1.kdn_1.buffer, tmp0_1.kdn_1.byteOffset + tmp2_0 | 0, endExclusive_0 - tmp2_0 | 0);
                var result = decodeBufferImpl(view_0, decoder, max - charactersCopied | 0);
                dst.k(result.adu_1);
                charactersCopied = charactersCopied + result.adu_1.length | 0;
                var rc_0 = result.bdu_1;
                this_4.ldn(rc_0);
                var rc_1 = rc_0;
                if (rc_1 > 0)
                  size_0 = 1;
                else if (size_0 === 8)
                  size_0 = 0;
                else {
                  size_0 = size_0 + 1 | 0;
                }
                size_1 = size_0;
              }finally {
                // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
                var this_5 = current_0;
                after_0 = this_5.pdi_1 - this_5.odi_1 | 0;
              }
            } else {
              after_0 = before_0;
            }
            release_0 = false;
            var tmp_7;
            if (after_0 === 0) {
              tmp_7 = prepareReadNextHead(input, current_0);
            } else {
              var tmp_8;
              if (after_0 < size_1) {
                tmp_8 = true;
              } else {
                // Inline function 'io.ktor.utils.io.core.Buffer.endGap' call
                var this_6 = current_0;
                tmp_8 = (this_6.sdi_1 - this_6.rdi_1 | 0) < 8;
              }
              if (tmp_8) {
                completeReadHead(input, current_0);
                tmp_7 = prepareReadFirstHead(input, size_1);
              } else {
                tmp_7 = current_0;
              }
            }
            var tmp1_elvis_lhs_0 = tmp_7;
            var tmp_9;
            if (tmp1_elvis_lhs_0 == null) {
              break $l$loop_0;
            } else {
              tmp_9 = tmp1_elvis_lhs_0;
            }
            var next_0 = tmp_9;
            current_0 = next_0;
            release_0 = true;
          }
           while (size_1 > 0);
        }finally {
          if (release_0) {
            completeReadHead(input, current_0);
          }
        }
      }
    }
    return charactersCopied;
  }
  function encodeImpl(_this__u8e3s4, input, fromIndex, toIndex, dst) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.require' call
    if (!(fromIndex <= toIndex)) {
      var message = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    if (get_charset_0(_this__u8e3s4).equals(Charsets_getInstance().vdq_1)) {
      return encodeISO88591(input, fromIndex, toIndex, dst);
    }
    // Inline function 'kotlin.require' call
    if (!(get_charset_0(_this__u8e3s4) === Charsets_getInstance().udq_1)) {
      var message_0 = 'Only UTF-8 encoding is supported in JS';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message_0));
    }
    var encoder = new TextEncoder();
    var start = fromIndex;
    // Inline function 'io.ktor.utils.io.core.Buffer.writeRemaining' call
    var dstRemaining = dst.rdi_1 - dst.pdi_1 | 0;
    $l$loop: while (start < toIndex && dstRemaining > 0) {
      var tmp0 = toIndex - start | 0;
      // Inline function 'kotlin.comparisons.minOf' call
      var b = dstRemaining / 6 | 0;
      var tmp$ret$6 = Math.min(tmp0, b);
      var numChars = coerceAtLeast(tmp$ret$6, 1);
      var dropLastChar = isHighSurrogate(charSequenceGet(input, (start + numChars | 0) - 1 | 0));
      var endIndexExclusive = dropLastChar && numChars === 1 ? start + 2 | 0 : dropLastChar ? (start + numChars | 0) - 1 | 0 : start + numChars | 0;
      // Inline function 'kotlin.text.substring' call
      var startIndex = start;
      var tmp$ret$7 = toString_1(charSequenceSubSequence(input, startIndex, endIndexExclusive));
      var array1 = encoder.encode(tmp$ret$7);
      if (array1.length > dstRemaining)
        break $l$loop;
      writeFully_4(dst, array1);
      start = endIndexExclusive;
      dstRemaining = dstRemaining - array1.length | 0;
    }
    return start - fromIndex | 0;
  }
  function encodeComplete(_this__u8e3s4, dst) {
    return true;
  }
  function encodeToByteArray_0(_this__u8e3s4, input, fromIndex, toIndex) {
    fromIndex = fromIndex === VOID ? 0 : fromIndex;
    toIndex = toIndex === VOID ? charSequenceLength(input) : toIndex;
    return encodeToByteArrayImpl1(_this__u8e3s4, input, fromIndex, toIndex);
  }
  function decodeExactBytes(_this__u8e3s4, input, inputLength) {
    if (inputLength === 0)
      return '';
    // Inline function 'io.ktor.utils.io.core.Input.headRemaining' call
    if ((input.xdj_1 - input.wdj_1 | 0) >= inputLength) {
      var decoder = Decoder_0(get_charset(_this__u8e3s4).wdq_1, true);
      var head = input.odp();
      var view = input.vdj_1.kdn_1;
      var tmp$ret$2;
      $l$block: {
        // Inline function 'io.ktor.utils.io.js.decodeWrap' call
        try {
          var subView = head.odi_1 === 0 && inputLength === view.byteLength ? view : new DataView(view.buffer, view.byteOffset + head.odi_1 | 0, inputLength);
          tmp$ret$2 = decoder.cdu(subView);
          break $l$block;
        } catch ($p) {
          if ($p instanceof Error) {
            var t = $p;
            var tmp0_elvis_lhs = t.message;
            throw new MalformedInputException('Failed to decode bytes: ' + (tmp0_elvis_lhs == null ? 'no cause provided' : tmp0_elvis_lhs));
          } else {
            throw $p;
          }
        }
      }
      var text = tmp$ret$2;
      input.ldn(inputLength);
      return text;
    }
    return decodeExactBytesSlow(_this__u8e3s4, input, inputLength);
  }
  function CharsetImpl(name) {
    Charset.call(this, name);
    this.edu_1 = name;
  }
  protoOf(CharsetImpl).ydq = function () {
    return new CharsetEncoderImpl(this);
  };
  protoOf(CharsetImpl).xdq = function () {
    return new CharsetDecoderImpl(this);
  };
  protoOf(CharsetImpl).toString = function () {
    return 'CharsetImpl(name=' + this.edu_1 + ')';
  };
  protoOf(CharsetImpl).hashCode = function () {
    return getStringHashCode(this.edu_1);
  };
  protoOf(CharsetImpl).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CharsetImpl))
      return false;
    var tmp0_other_with_cast = other instanceof CharsetImpl ? other : THROW_CCE();
    if (!(this.edu_1 === tmp0_other_with_cast.edu_1))
      return false;
    return true;
  };
  function get_charset(_this__u8e3s4) {
    return _this__u8e3s4.wdt_1;
  }
  function get_charset_0(_this__u8e3s4) {
    return _this__u8e3s4.xdt_1;
  }
  function encodeToByteArrayImpl1(_this__u8e3s4, input, fromIndex, toIndex) {
    fromIndex = fromIndex === VOID ? 0 : fromIndex;
    toIndex = toIndex === VOID ? charSequenceLength(input) : toIndex;
    var start = fromIndex;
    if (start >= toIndex)
      return get_EmptyByteArray();
    var single = Companion_getInstance_256().cdm().gdp();
    try {
      var rc = encodeImpl(_this__u8e3s4, input, start, toIndex, single);
      start = start + rc | 0;
      if (start === toIndex) {
        // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
        var tmp$ret$0 = single.pdi_1 - single.odi_1 | 0;
        var result = new Int8Array(tmp$ret$0);
        // Inline function 'io.ktor.utils.io.core.readFully' call
        var length = result.length - 0 | 0;
        readFully(single instanceof Buffer ? single : THROW_CCE(), result, 0, length);
        return result;
      }
      var tmp$ret$4;
      $l$block: {
        // Inline function 'io.ktor.utils.io.core.buildPacket' call
        // Inline function 'kotlin.contracts.contract' call
        var builder = new BytePacketBuilder();
        try {
          builder.pdp(single.adr());
          encodeToImpl(_this__u8e3s4, builder, input, start, toIndex);
          tmp$ret$4 = builder.f40();
          break $l$block;
        } catch ($p) {
          if ($p instanceof Error) {
            var t = $p;
            builder.zu();
            throw t;
          } else {
            throw $p;
          }
        }
      }
      return readBytes(tmp$ret$4);
    }finally {
      single.jdp(Companion_getInstance_256().cdm());
    }
  }
  function decodeExactBytesSlow(_this__u8e3s4, input, inputLength) {
    var decoder = Decoder_0(get_name_6(get_charset(_this__u8e3s4)), true);
    var inputRemaining = inputLength;
    var sb = StringBuilder_init_$Create$(inputLength);
    $l$block_4: {
      // Inline function 'io.ktor.utils.io.js.decodeWrap' call
      try {
        $l$block: {
          // Inline function 'io.ktor.utils.io.core.takeWhileSize' call
          var release = true;
          var tmp0_elvis_lhs = prepareReadFirstHead(input, 6);
          var tmp;
          if (tmp0_elvis_lhs == null) {
            break $l$block;
          } else {
            tmp = tmp0_elvis_lhs;
          }
          var current = tmp;
          var size = 6;
          try {
            $l$loop: do {
              // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
              var this_0 = current;
              var before = this_0.pdi_1 - this_0.odi_1 | 0;
              var after;
              if (before >= size) {
                try {
                  var buffer = current;
                  // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
                  var chunkSize = buffer.pdi_1 - buffer.odi_1 | 0;
                  // Inline function 'kotlin.comparisons.minOf' call
                  var b = inputRemaining;
                  var size_0 = Math.min(chunkSize, b);
                  var tmp_0;
                  if (buffer.odi_1 === 0 && buffer.ndi_1.kdn_1.byteLength === size_0) {
                    var tmp2 = buffer.ndi_1.kdn_1;
                    var tmp$ret$4;
                    $l$block_0: {
                      // Inline function 'io.ktor.utils.io.js.decodeStream' call
                      // Inline function 'io.ktor.utils.io.js.decodeWrap' call
                      try {
                        tmp$ret$4 = decoder.ydt(tmp2, decodeOptions(true));
                        break $l$block_0;
                      } catch ($p) {
                        if ($p instanceof Error) {
                          var t = $p;
                          var tmp0_elvis_lhs_0 = t.message;
                          throw new MalformedInputException('Failed to decode bytes: ' + (tmp0_elvis_lhs_0 == null ? 'no cause provided' : tmp0_elvis_lhs_0));
                        } else {
                          throw $p;
                        }
                      }
                    }
                    tmp_0 = tmp$ret$4;
                  } else {
                    var tmp2_0 = new Int8Array(buffer.ndi_1.kdn_1.buffer, buffer.ndi_1.kdn_1.byteOffset + buffer.odi_1 | 0, size_0);
                    var tmp$ret$6;
                    $l$block_1: {
                      // Inline function 'io.ktor.utils.io.js.decodeStream' call
                      // Inline function 'io.ktor.utils.io.js.decodeWrap' call
                      try {
                        tmp$ret$6 = decoder.ydt(tmp2_0, decodeOptions(true));
                        break $l$block_1;
                      } catch ($p) {
                        if ($p instanceof Error) {
                          var t_0 = $p;
                          var tmp0_elvis_lhs_1 = t_0.message;
                          throw new MalformedInputException('Failed to decode bytes: ' + (tmp0_elvis_lhs_1 == null ? 'no cause provided' : tmp0_elvis_lhs_1));
                        } else {
                          throw $p;
                        }
                      }
                    }
                    tmp_0 = tmp$ret$6;
                  }
                  var text = tmp_0;
                  sb.j8(text);
                  buffer.ldn(size_0);
                  inputRemaining = inputRemaining - size_0 | 0;
                  size = inputRemaining > 0 ? 6 : 0;
                }finally {
                  // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
                  var this_1 = current;
                  after = this_1.pdi_1 - this_1.odi_1 | 0;
                }
              } else {
                after = before;
              }
              release = false;
              var tmp_1;
              if (after === 0) {
                tmp_1 = prepareReadNextHead(input, current);
              } else {
                var tmp_2;
                if (after < size) {
                  tmp_2 = true;
                } else {
                  // Inline function 'io.ktor.utils.io.core.Buffer.endGap' call
                  var this_2 = current;
                  tmp_2 = (this_2.sdi_1 - this_2.rdi_1 | 0) < 8;
                }
                if (tmp_2) {
                  completeReadHead(input, current);
                  tmp_1 = prepareReadFirstHead(input, size);
                } else {
                  tmp_1 = current;
                }
              }
              var tmp1_elvis_lhs = tmp_1;
              var tmp_3;
              if (tmp1_elvis_lhs == null) {
                break $l$loop;
              } else {
                tmp_3 = tmp1_elvis_lhs;
              }
              var next = tmp_3;
              current = next;
              release = true;
            }
             while (size > 0);
          }finally {
            if (release) {
              completeReadHead(input, current);
            }
          }
        }
        if (inputRemaining > 0) {
          $l$block_2: {
            // Inline function 'io.ktor.utils.io.core.takeWhile' call
            var release_0 = true;
            var tmp0_elvis_lhs_2 = prepareReadFirstHead(input, 1);
            var tmp_4;
            if (tmp0_elvis_lhs_2 == null) {
              break $l$block_2;
            } else {
              tmp_4 = tmp0_elvis_lhs_2;
            }
            var current_0 = tmp_4;
            try {
              $l$loop_1: do {
                var buffer_0 = current_0;
                // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
                var chunkSize_0 = buffer_0.pdi_1 - buffer_0.odi_1 | 0;
                // Inline function 'kotlin.comparisons.minOf' call
                var b_0 = inputRemaining;
                var size_1 = Math.min(chunkSize_0, b_0);
                var tmp_5;
                if (buffer_0.odi_1 === 0 && buffer_0.ndi_1.kdn_1.byteLength === size_1) {
                  tmp_5 = decoder.cdu(buffer_0.ndi_1.kdn_1);
                } else {
                  var tmp2_1 = new Int8Array(buffer_0.ndi_1.kdn_1.buffer, buffer_0.ndi_1.kdn_1.byteOffset + buffer_0.odi_1 | 0, size_1);
                  var tmp$ret$14;
                  $l$block_3: {
                    // Inline function 'io.ktor.utils.io.js.decodeStream' call
                    // Inline function 'io.ktor.utils.io.js.decodeWrap' call
                    try {
                      tmp$ret$14 = decoder.ydt(tmp2_1, decodeOptions(true));
                      break $l$block_3;
                    } catch ($p) {
                      if ($p instanceof Error) {
                        var t_1 = $p;
                        var tmp0_elvis_lhs_3 = t_1.message;
                        throw new MalformedInputException('Failed to decode bytes: ' + (tmp0_elvis_lhs_3 == null ? 'no cause provided' : tmp0_elvis_lhs_3));
                      } else {
                        throw $p;
                      }
                    }
                  }
                  tmp_5 = tmp$ret$14;
                }
                var text_0 = tmp_5;
                sb.j8(text_0);
                buffer_0.ldn(size_1);
                inputRemaining = inputRemaining - size_1 | 0;
                if (!true) {
                  break $l$loop_1;
                }
                release_0 = false;
                var tmp1_elvis_lhs_0 = prepareReadNextHead(input, current_0);
                var tmp_6;
                if (tmp1_elvis_lhs_0 == null) {
                  break $l$loop_1;
                } else {
                  tmp_6 = tmp1_elvis_lhs_0;
                }
                var next_0 = tmp_6;
                current_0 = next_0;
                release_0 = true;
              }
               while (true);
            }finally {
              if (release_0) {
                completeReadHead(input, current_0);
              }
            }
          }
        }
        sb.j8(decoder.zdt());
        break $l$block_4;
      } catch ($p) {
        if ($p instanceof Error) {
          var t_2 = $p;
          var tmp0_elvis_lhs_4 = t_2.message;
          throw new MalformedInputException('Failed to decode bytes: ' + (tmp0_elvis_lhs_4 == null ? 'no cause provided' : tmp0_elvis_lhs_4));
        } else {
          throw $p;
        }
      }
    }
    if (inputRemaining > 0) {
      throw new EOFException('Not enough bytes available: had only ' + (inputLength - inputRemaining | 0) + ' instead of ' + inputLength);
    }
    return sb.toString();
  }
  function CharsetEncoderImpl(charset) {
    CharsetEncoder.call(this, charset);
    this.gdu_1 = charset;
  }
  protoOf(CharsetEncoderImpl).toString = function () {
    return 'CharsetEncoderImpl(charset=' + this.gdu_1.toString() + ')';
  };
  protoOf(CharsetEncoderImpl).hashCode = function () {
    return this.gdu_1.hashCode();
  };
  protoOf(CharsetEncoderImpl).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CharsetEncoderImpl))
      return false;
    var tmp0_other_with_cast = other instanceof CharsetEncoderImpl ? other : THROW_CCE();
    if (!this.gdu_1.equals(tmp0_other_with_cast.gdu_1))
      return false;
    return true;
  };
  function CharsetDecoderImpl(charset) {
    CharsetDecoder.call(this, charset);
    this.idu_1 = charset;
  }
  protoOf(CharsetDecoderImpl).toString = function () {
    return 'CharsetDecoderImpl(charset=' + this.idu_1.toString() + ')';
  };
  protoOf(CharsetDecoderImpl).hashCode = function () {
    return this.idu_1.hashCode();
  };
  protoOf(CharsetDecoderImpl).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CharsetDecoderImpl))
      return false;
    var tmp0_other_with_cast = other instanceof CharsetDecoderImpl ? other : THROW_CCE();
    if (!this.idu_1.equals(tmp0_other_with_cast.idu_1))
      return false;
    return true;
  };
  function DecodeBufferResult(charactersDecoded, bytesConsumed) {
    this.adu_1 = charactersDecoded;
    this.bdu_1 = bytesConsumed;
  }
  protoOf(DecodeBufferResult).toString = function () {
    return 'DecodeBufferResult(charactersDecoded=' + this.adu_1 + ', bytesConsumed=' + this.bdu_1 + ')';
  };
  protoOf(DecodeBufferResult).hashCode = function () {
    var result = getStringHashCode(this.adu_1);
    result = imul(result, 31) + this.bdu_1 | 0;
    return result;
  };
  protoOf(DecodeBufferResult).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof DecodeBufferResult))
      return false;
    var tmp0_other_with_cast = other instanceof DecodeBufferResult ? other : THROW_CCE();
    if (!(this.adu_1 === tmp0_other_with_cast.adu_1))
      return false;
    if (!(this.bdu_1 === tmp0_other_with_cast.bdu_1))
      return false;
    return true;
  };
  function decodeBufferImpl(_this__u8e3s4, nativeDecoder, maxCharacters) {
    if (maxCharacters === 0) {
      return new DecodeBufferResult('', 0);
    }
    try {
      var sizeInBytes = coerceAtMost(maxCharacters, _this__u8e3s4.byteLength);
      var text = nativeDecoder.cdu(_this__u8e3s4.subarray(0, sizeInBytes));
      if (text.length <= maxCharacters) {
        return new DecodeBufferResult(text, sizeInBytes);
      }
    } catch ($p) {
      var _ = $p;
    }
    return decodeBufferImplSlow(_this__u8e3s4, nativeDecoder, maxCharacters);
  }
  function decodeBufferImplSlow(_this__u8e3s4, nativeDecoder, maxCharacters) {
    var maxBytes = coerceAtMost(maxCharacters >= 268435455 ? 2147483647 : imul(maxCharacters, 8), _this__u8e3s4.byteLength);
    var sizeInBytes = maxBytes;
    while (sizeInBytes > 8) {
      try {
        var text = nativeDecoder.cdu(_this__u8e3s4.subarray(0, sizeInBytes));
        if (text.length <= maxCharacters) {
          return new DecodeBufferResult(text, sizeInBytes);
        }
      } catch ($p) {
        var _ = $p;
      }
      sizeInBytes = sizeInBytes / 2 | 0;
    }
    sizeInBytes = 8;
    while (sizeInBytes > 0) {
      try {
        var text_0 = nativeDecoder.cdu(_this__u8e3s4.subarray(0, sizeInBytes));
        if (text_0.length <= maxCharacters) {
          return new DecodeBufferResult(text_0, sizeInBytes);
        }
      } catch ($p) {
        var __0 = $p;
      }
      sizeInBytes = sizeInBytes - 1 | 0;
    }
    $l$block: {
      // Inline function 'io.ktor.utils.io.js.decodeWrap' call
      try {
        nativeDecoder.cdu(_this__u8e3s4);
        break $l$block;
      } catch ($p) {
        if ($p instanceof Error) {
          var t = $p;
          var tmp0_elvis_lhs = t.message;
          throw new MalformedInputException('Failed to decode bytes: ' + (tmp0_elvis_lhs == null ? 'no cause provided' : tmp0_elvis_lhs));
        } else {
          throw $p;
        }
      }
    }
    throw new MalformedInputException('Unable to decode buffer');
  }
  function encodeISO88591(input, fromIndex, toIndex, dst) {
    if (fromIndex >= toIndex)
      return 0;
    // Inline function 'io.ktor.utils.io.core.writeDirect' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'io.ktor.utils.io.core.write' call
    // Inline function 'kotlin.contracts.contract' call
    var tmp0 = dst.ndi_1;
    var tmp2 = dst.pdi_1;
    var endExclusive = dst.rdi_1;
    var view = tmp0.udt(tmp2, endExclusive - tmp2 | 0).kdn_1;
    var i8 = new Int8Array(view.buffer, view.byteOffset, view.byteLength);
    var writeIndex = 0;
    var inductionVariable = fromIndex;
    if (inductionVariable < toIndex)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlin.code' call
        var this_0 = charSequenceGet(input, index);
        var character = Char__toInt_impl_vasixd(this_0);
        if (character > 255) {
          failedToMapError(character);
        }
        var tmp1 = writeIndex;
        writeIndex = tmp1 + 1 | 0;
        // Inline function 'org.khronos.webgl.set' call
        // Inline function 'kotlin.js.asDynamic' call
        i8[tmp1] = toByte(character);
      }
       while (inductionVariable < toIndex);
    var rc = writeIndex;
    dst.mdn(rc);
    return toIndex - fromIndex | 0;
  }
  function failedToMapError(ch) {
    throw new MalformedInputException('The character with unicode point ' + ch + " couldn't be mapped to ISO-8859-1 character");
  }
  function writeFully_4(_this__u8e3s4, src, offset, length) {
    offset = offset === VOID ? 0 : offset;
    length = length === VOID ? src.byteLength - offset | 0 : length;
    // Inline function 'io.ktor.utils.io.core.write' call
    // Inline function 'kotlin.contracts.contract' call
    var tmp0 = _this__u8e3s4.ndi_1;
    var tmp2 = _this__u8e3s4.pdi_1;
    if ((_this__u8e3s4.rdi_1 - tmp2 | 0) < length) {
      throw new InsufficientSpaceException('Not enough free space to write ' + length + ' bytes');
    }
    copyTo_0(src, tmp0, offset, length, tmp2);
    var rc = length;
    _this__u8e3s4.mdn(rc);
  }
  function Closeable() {
  }
  function get_PACKET_MAX_COPY_SIZE() {
    return PACKET_MAX_COPY_SIZE;
  }
  var PACKET_MAX_COPY_SIZE;
  function String_0(bytes, offset, length, charset) {
    offset = offset === VOID ? 0 : offset;
    length = length === VOID ? bytes.length : length;
    charset = charset === VOID ? Charsets_getInstance().udq_1 : charset;
    if (offset < 0 || length < 0 || (offset + length | 0) > bytes.length) {
      checkIndices(offset, length, bytes);
    }
    // Inline function 'kotlin.js.asDynamic' call
    var i8 = bytes;
    var bufferOffset = i8.byteOffset + offset | 0;
    var buffer = i8.buffer.slice(bufferOffset, bufferOffset + length | 0);
    var view = new ChunkBuffer(of(Companion_getInstance_258(), buffer), null, Companion_getInstance_256().adm_1);
    view.sdn();
    var packet = ByteReadPacket_init_$Create$(view, Companion_getInstance_256().bdm_1);
    return decode(charset.xdq(), packet, 2147483647);
  }
  function checkIndices(offset, length, bytes) {
    // Inline function 'kotlin.require' call
    if (!(offset >= 0)) {
      throw IndexOutOfBoundsException_init_$Create$_0('offset (' + offset + ") shouldn't be negative");
    }
    // Inline function 'kotlin.require' call
    if (!(length >= 0)) {
      throw IndexOutOfBoundsException_init_$Create$_0('length (' + length + ") shouldn't be negative");
    }
    // Inline function 'kotlin.require' call
    if (!((offset + length | 0) <= bytes.length)) {
      throw IndexOutOfBoundsException_init_$Create$_0('offset (' + offset + ') + length (' + length + ') > bytes.size (' + bytes.length + ')');
    }
    throw IndexOutOfBoundsException_init_$Create$();
  }
  function IOException_init_$Init$(message, $this) {
    IOException.call($this, message, null);
    return $this;
  }
  function IOException_init_$Create$(message) {
    var tmp = IOException_init_$Init$(message, objectCreate(protoOf(IOException)));
    captureStack(tmp, IOException_init_$Create$);
    return tmp;
  }
  function IOException(message, cause) {
    Exception_init_$Init$_1(message, cause, this);
    captureStack(this, IOException);
  }
  function EOFException(message) {
    IOException_init_$Init$(message, this);
    captureStack(this, EOFException);
  }
  function Decoder_0(encoding, fatal) {
    fatal = fatal === VOID ? true : fatal;
    var tmp;
    try {
      tmp = toKtor(new TextDecoder(encoding, textDecoderOptions(fatal)));
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var cause = $p;
        tmp_0 = new TextDecoderFallback(encoding, fatal);
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  function decodeOptions(stream) {
    // Inline function 'kotlin.apply' call
    var this_0 = new Object();
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.with' call
    this_0.stream = stream;
    return this_0;
  }
  function toKtor(_this__u8e3s4) {
    return new toKtor$1(_this__u8e3s4);
  }
  function textDecoderOptions(fatal) {
    fatal = fatal === VOID ? false : fatal;
    // Inline function 'kotlin.apply' call
    var this_0 = new Object();
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.with' call
    this_0.fatal = fatal;
    return this_0;
  }
  function toKtor$1($this_toKtor) {
    this.jdu_1 = $this_toKtor;
  }
  protoOf(toKtor$1).zdt = function () {
    return this.jdu_1.decode();
  };
  protoOf(toKtor$1).cdu = function (buffer) {
    return this.jdu_1.decode(buffer);
  };
  protoOf(toKtor$1).ydt = function (buffer, options) {
    return this.jdu_1.decode(buffer, options);
  };
  function get_ENCODING_ALIASES() {
    _init_properties_TextDecoderFallback_kt__nrrftl();
    return ENCODING_ALIASES;
  }
  var ENCODING_ALIASES;
  function get_REPLACEMENT() {
    _init_properties_TextDecoderFallback_kt__nrrftl();
    return REPLACEMENT;
  }
  var REPLACEMENT;
  function TextDecoderFallback(encoding, fatal) {
    this.kdu_1 = fatal;
    // Inline function 'kotlin.text.trim' call
    // Inline function 'kotlin.text.lowercase' call
    // Inline function 'kotlin.js.asDynamic' call
    var requestedEncoding = toString_1(trim(isCharSequence(encoding) ? encoding : THROW_CCE())).toLowerCase();
    // Inline function 'kotlin.check' call
    if (!get_ENCODING_ALIASES().t(requestedEncoding)) {
      var message = encoding + ' is not supported.';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
  }
  protoOf(TextDecoderFallback).zdt = function () {
    return '';
  };
  protoOf(TextDecoderFallback).cdu = function (buffer) {
    var tmp$ret$6;
    $l$block: {
      // Inline function 'io.ktor.utils.io.core.buildPacket' call
      // Inline function 'kotlin.contracts.contract' call
      var builder = new BytePacketBuilder();
      try {
        var bytes = buffer instanceof Int8Array ? buffer : THROW_CCE();
        var inductionVariable = 0;
        var last = bytes.length;
        if (inductionVariable < last)
          $l$loop: do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            // Inline function 'org.khronos.webgl.get' call
            // Inline function 'kotlin.js.asDynamic' call
            var byte = bytes[index];
            var point = toCodePoint(byte);
            if (point < 0) {
              // Inline function 'kotlin.check' call
              if (!!this.kdu_1) {
                var message = 'Invalid character: ' + point;
                throw IllegalStateException_init_$Create$_0(toString_1(message));
              }
              writeFully_3(builder, get_REPLACEMENT());
              continue $l$loop;
            }
            if (point > 255) {
              builder.ado(toByte(point >> 8));
            }
            builder.ado(toByte(point & 255));
          }
           while (inductionVariable < last);
        tmp$ret$6 = builder.f40();
        break $l$block;
      } catch ($p) {
        if ($p instanceof Error) {
          var t = $p;
          builder.zu();
          throw t;
        } else {
          throw $p;
        }
      }
    }
    return decodeToString(readBytes(tmp$ret$6));
  };
  protoOf(TextDecoderFallback).ydt = function (buffer, options) {
    return this.cdu(buffer);
  };
  function toCodePoint(_this__u8e3s4) {
    _init_properties_TextDecoderFallback_kt__nrrftl();
    var value = _this__u8e3s4 & 255;
    if (isASCII(value)) {
      return value;
    }
    return get_WIN1252_TABLE()[value - 128 | 0];
  }
  function isASCII(_this__u8e3s4) {
    _init_properties_TextDecoderFallback_kt__nrrftl();
    return 0 <= _this__u8e3s4 ? _this__u8e3s4 <= 127 : false;
  }
  var properties_initialized_TextDecoderFallback_kt_7y92ax;
  function _init_properties_TextDecoderFallback_kt__nrrftl() {
    if (!properties_initialized_TextDecoderFallback_kt_7y92ax) {
      properties_initialized_TextDecoderFallback_kt_7y92ax = true;
      ENCODING_ALIASES = setOf_0(['ansi_x3.4-1968', 'ascii', 'cp1252', 'cp819', 'csisolatin1', 'ibm819', 'iso-8859-1', 'iso-ir-100', 'iso8859-1', 'iso88591', 'iso_8859-1', 'iso_8859-1:1987', 'l1', 'latin1', 'us-ascii', 'windows-1252', 'x-cp1252']);
      // Inline function 'kotlin.byteArrayOf' call
      REPLACEMENT = new Int8Array([-17, -65, -67]);
    }
  }
  function get_WIN1252_TABLE() {
    _init_properties_Win1252Table_kt__tl0v64();
    return WIN1252_TABLE;
  }
  var WIN1252_TABLE;
  var properties_initialized_Win1252Table_kt_pkmjoq;
  function _init_properties_Win1252Table_kt__tl0v64() {
    if (!properties_initialized_Win1252Table_kt_pkmjoq) {
      properties_initialized_Win1252Table_kt_pkmjoq = true;
      // Inline function 'kotlin.intArrayOf' call
      WIN1252_TABLE = new Int32Array([8364, -1, 8218, 402, 8222, 8230, 8224, 8225, 710, 8240, 352, 8249, 338, -1, 381, -1, -1, 8216, 8217, 8220, 8221, 8226, 8211, 8212, 732, 8482, 353, 8250, 339, -1, 382, 376, 160, 161, 162, 163, 164, 165, 166, 167, 168, 169, 170, 171, 172, 173, 174, 175, 176, 177, 178, 179, 180, 181, 182, 183, 184, 185, 186, 187, 188, 189, 190, 191, 192, 193, 194, 195, 196, 197, 198, 199, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 242, 243, 244, 245, 246, 247, 248, 249, 250, 251, 252, 253, 254, 255]);
    }
  }
  function DefaultPool(capacity) {
    this.ldo_1 = capacity;
    var tmp = this;
    // Inline function 'kotlin.arrayOfNulls' call
    var size = this.ldo_1;
    tmp.mdo_1 = Array(size);
    this.ndo_1 = 0;
  }
  protoOf(DefaultPool).odo = function (instance) {
  };
  protoOf(DefaultPool).edp = function (instance) {
    return instance;
  };
  protoOf(DefaultPool).bdp = function (instance) {
  };
  protoOf(DefaultPool).gdp = function () {
    if (this.ndo_1 === 0)
      return this.hdo();
    this.ndo_1 = this.ndo_1 - 1 | 0;
    var idx = this.ndo_1;
    var tmp = this.mdo_1[idx];
    var instance = !(tmp == null) ? tmp : THROW_CCE();
    this.mdo_1[idx] = null;
    return this.edp(instance);
  };
  protoOf(DefaultPool).hdp = function (instance) {
    this.bdp(instance);
    if (this.ndo_1 === this.ldo_1) {
      this.odo(instance);
    } else {
      var tmp1 = this.ndo_1;
      this.ndo_1 = tmp1 + 1 | 0;
      this.mdo_1[tmp1] = instance;
    }
  };
  protoOf(DefaultPool).zr = function () {
    var inductionVariable = 0;
    var last = this.ndo_1;
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = this.mdo_1[i];
        var instance = !(tmp == null) ? tmp : THROW_CCE();
        this.mdo_1[i] = null;
        this.odo(instance);
      }
       while (inductionVariable < last);
    this.ndo_1 = 0;
  };
  function Attributes() {
  }
  function AttributeKey(name) {
    this.sdu_1 = name;
    // Inline function 'kotlin.text.isEmpty' call
    var this_0 = this.sdu_1;
    if (charSequenceLength(this_0) === 0) {
      throw IllegalStateException_init_$Create$_0("Name can't be blank");
    }
  }
  protoOf(AttributeKey).toString = function () {
    return 'AttributeKey: ' + this.sdu_1;
  };
  protoOf(AttributeKey).equals = function (other) {
    if (this === other)
      return true;
    if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    if (!(other instanceof AttributeKey))
      THROW_CCE();
    if (!(this.sdu_1 === other.sdu_1))
      return false;
    return true;
  };
  protoOf(AttributeKey).hashCode = function () {
    return getStringHashCode(this.sdu_1);
  };
  function putAll_1(_this__u8e3s4, other) {
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = other.rdu().m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      _this__u8e3s4.odu(element instanceof AttributeKey ? element : THROW_CCE(), other.ldu(element));
    }
  }
  var BASE64_INVERSE_ALPHABET;
  function encodeBase64(_this__u8e3s4) {
    _init_properties_Base64_kt__ymmsz3();
    var array = _this__u8e3s4;
    var position = 0;
    var writeOffset = 0;
    var charArray_0 = charArray((imul(_this__u8e3s4.length, 8) / 6 | 0) + 3 | 0);
    while ((position + 3 | 0) <= array.length) {
      var first = array[position];
      var second = array[position + 1 | 0];
      var third = array[position + 2 | 0];
      position = position + 3 | 0;
      var chunk = (first & 255) << 16 | (second & 255) << 8 | third & 255;
      var inductionVariable = 3;
      if (0 <= inductionVariable)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + -1 | 0;
          var char = chunk >> imul(6, index) & 63;
          var tmp1 = writeOffset;
          writeOffset = tmp1 + 1 | 0;
          // Inline function 'io.ktor.util.toBase64' call
          charArray_0[tmp1] = charCodeAt(access$_get_BASE64_ALPHABET_$tBase64Kt_i8vdt6(), char);
        }
         while (0 <= inductionVariable);
    }
    var remaining = array.length - position | 0;
    if (remaining === 0)
      return concatToString_0(charArray_0, 0, writeOffset);
    var tmp;
    if (remaining === 1) {
      tmp = (array[position] & 255) << 16 | 0 | 0;
    } else {
      tmp = (array[position] & 255) << 16 | (array[position + 1 | 0] & 255) << 8 | 0;
    }
    var chunk_0 = tmp;
    var padSize = imul(3 - remaining | 0, 8) / 6 | 0;
    var inductionVariable_0 = 3;
    if (padSize <= inductionVariable_0)
      do {
        var index_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + -1 | 0;
        var char_0 = chunk_0 >> imul(6, index_0) & 63;
        var tmp3 = writeOffset;
        writeOffset = tmp3 + 1 | 0;
        // Inline function 'io.ktor.util.toBase64' call
        charArray_0[tmp3] = charCodeAt(access$_get_BASE64_ALPHABET_$tBase64Kt_i8vdt6(), char_0);
      }
       while (!(index_0 === padSize));
    // Inline function 'kotlin.repeat' call
    var inductionVariable_1 = 0;
    if (inductionVariable_1 < padSize)
      do {
        var index_1 = inductionVariable_1;
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        var tmp0 = writeOffset;
        writeOffset = tmp0 + 1 | 0;
        charArray_0[tmp0] = _Char___init__impl__6a9atx(61);
      }
       while (inductionVariable_1 < padSize);
    return concatToString_0(charArray_0, 0, writeOffset);
  }
  function access$_get_BASE64_ALPHABET_$tBase64Kt_i8vdt6() {
    return 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
  }
  var properties_initialized_Base64_kt_5g824v;
  function _init_properties_Base64_kt__ymmsz3() {
    if (!properties_initialized_Base64_kt_5g824v) {
      properties_initialized_Base64_kt_5g824v = true;
      var tmp = 0;
      var tmp_0 = new Int32Array(256);
      while (tmp < 256) {
        var tmp_1 = tmp;
        tmp_0[tmp_1] = indexOf_8('ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/', numberToChar(tmp_1));
        tmp = tmp + 1 | 0;
      }
      BASE64_INVERSE_ALPHABET = tmp_0;
    }
  }
  function toByteArray(_this__u8e3s4, $completion) {
    var tmp = new $toByteArrayCOROUTINE$(_this__u8e3s4, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  }
  function $toByteArrayCOROUTINE$(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.bdv_1 = _this__u8e3s4;
  }
  protoOf($toByteArrayCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.bdv_1.hdm(VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            return readBytes(ARGUMENT);
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function CaseInsensitiveMap$_get_keys_$lambda_ptzlqj($this$$receiver) {
    return $this$$receiver.cdv_1;
  }
  function CaseInsensitiveMap$_get_keys_$lambda_ptzlqj_0($this$$receiver) {
    return caseInsensitive($this$$receiver);
  }
  function CaseInsensitiveMap$_get_entries_$lambda_r32w19($this$$receiver) {
    return new Entry_2($this$$receiver.z().cdv_1, $this$$receiver.a1());
  }
  function CaseInsensitiveMap$_get_entries_$lambda_r32w19_0($this$$receiver) {
    return new Entry_2(caseInsensitive($this$$receiver.z()), $this$$receiver.a1());
  }
  function CaseInsensitiveMap() {
    var tmp = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp.edv_1 = LinkedHashMap_init_$Create$();
  }
  protoOf(CaseInsensitiveMap).p = function () {
    return this.edv_1.p();
  };
  protoOf(CaseInsensitiveMap).k63 = function (key) {
    return this.edv_1.o2(new CaseInsensitiveString(key));
  };
  protoOf(CaseInsensitiveMap).o2 = function (key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return false;
    return this.k63((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  };
  protoOf(CaseInsensitiveMap).fdv = function (value) {
    return this.edv_1.p2(value);
  };
  protoOf(CaseInsensitiveMap).p2 = function (value) {
    if (!!(value == null))
      return false;
    return this.fdv(!(value == null) ? value : THROW_CCE());
  };
  protoOf(CaseInsensitiveMap).ld = function (key) {
    return this.edv_1.q2(caseInsensitive(key));
  };
  protoOf(CaseInsensitiveMap).q2 = function (key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return null;
    return this.ld((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  };
  protoOf(CaseInsensitiveMap).s = function () {
    return this.edv_1.s();
  };
  protoOf(CaseInsensitiveMap).k2 = function () {
    this.edv_1.k2();
  };
  protoOf(CaseInsensitiveMap).gdv = function (key, value) {
    return this.edv_1.t2(caseInsensitive(key), value);
  };
  protoOf(CaseInsensitiveMap).t2 = function (key, value) {
    var tmp = (!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE();
    return this.gdv(tmp, !(value == null) ? value : THROW_CCE());
  };
  protoOf(CaseInsensitiveMap).hdv = function (from) {
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s = from.y().m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      // Inline function 'kotlin.collections.component1' call
      var key = element.z();
      // Inline function 'kotlin.collections.component2' call
      var value = element.a1();
      this.gdv(key, value);
    }
  };
  protoOf(CaseInsensitiveMap).v2 = function (from) {
    return this.hdv(from);
  };
  protoOf(CaseInsensitiveMap).idv = function (key) {
    return this.edv_1.u2(caseInsensitive(key));
  };
  protoOf(CaseInsensitiveMap).u2 = function (key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return null;
    return this.idv((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  };
  protoOf(CaseInsensitiveMap).r2 = function () {
    var tmp = this.edv_1.r2();
    var tmp_0 = CaseInsensitiveMap$_get_keys_$lambda_ptzlqj;
    return new DelegatingMutableSet(tmp, tmp_0, CaseInsensitiveMap$_get_keys_$lambda_ptzlqj_0);
  };
  protoOf(CaseInsensitiveMap).y = function () {
    var tmp = this.edv_1.y();
    var tmp_0 = CaseInsensitiveMap$_get_entries_$lambda_r32w19;
    return new DelegatingMutableSet(tmp, tmp_0, CaseInsensitiveMap$_get_entries_$lambda_r32w19_0);
  };
  protoOf(CaseInsensitiveMap).s2 = function () {
    return this.edv_1.s2();
  };
  protoOf(CaseInsensitiveMap).equals = function (other) {
    var tmp;
    if (other == null) {
      tmp = true;
    } else {
      tmp = !(other instanceof CaseInsensitiveMap);
    }
    if (tmp)
      return false;
    return equals(other.edv_1, this.edv_1);
  };
  protoOf(CaseInsensitiveMap).hashCode = function () {
    return hashCode(this.edv_1);
  };
  function Entry_2(key, value) {
    this.jdv_1 = key;
    this.kdv_1 = value;
  }
  protoOf(Entry_2).z = function () {
    return this.jdv_1;
  };
  protoOf(Entry_2).a1 = function () {
    return this.kdv_1;
  };
  protoOf(Entry_2).hashCode = function () {
    return (527 + hashCode(ensureNotNull(this.jdv_1)) | 0) + hashCode(ensureNotNull(this.kdv_1)) | 0;
  };
  protoOf(Entry_2).equals = function (other) {
    var tmp;
    if (other == null) {
      tmp = true;
    } else {
      tmp = !(!(other == null) ? isInterface(other, Entry) : false);
    }
    if (tmp)
      return false;
    return equals(other.z(), this.jdv_1) && equals(other.a1(), this.kdv_1);
  };
  protoOf(Entry_2).toString = function () {
    return toString_0(this.jdv_1) + '=' + toString_0(this.kdv_1);
  };
  function toCharArray(_this__u8e3s4) {
    var tmp = 0;
    var tmp_0 = _this__u8e3s4.length;
    var tmp_1 = charArray(tmp_0);
    while (tmp < tmp_0) {
      var tmp_2 = tmp;
      tmp_1[tmp_2] = charCodeAt(_this__u8e3s4, tmp_2);
      tmp = tmp + 1 | 0;
    }
    return tmp_1;
  }
  function isLowerCase_0(_this__u8e3s4) {
    // Inline function 'kotlin.text.lowercaseChar' call
    // Inline function 'kotlin.text.lowercase' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp$ret$2 = toString(_this__u8e3s4).toLowerCase();
    return charCodeAt(tmp$ret$2, 0) === _this__u8e3s4;
  }
  function caseInsensitiveMap() {
    return new CaseInsensitiveMap();
  }
  function SilentSupervisor(parent) {
    parent = parent === VOID ? null : parent;
    var tmp = SupervisorJob(parent);
    // Inline function 'kotlinx.coroutines.CoroutineExceptionHandler' call
    var tmp$ret$0 = new SilentSupervisor$$inlined$CoroutineExceptionHandler$1();
    return tmp.wi(tmp$ret$0);
  }
  function SilentSupervisor$$inlined$CoroutineExceptionHandler$1() {
    AbstractCoroutineContextElement.call(this, Key_instance_1);
  }
  protoOf(SilentSupervisor$$inlined$CoroutineExceptionHandler$1).av = function (context, exception) {
    return Unit_instance;
  };
  function get_digits() {
    _init_properties_Crypto_kt__txayzl();
    return digits;
  }
  var digits;
  function generateNonce(size) {
    _init_properties_Crypto_kt__txayzl();
    var tmp$ret$2;
    $l$block: {
      // Inline function 'io.ktor.utils.io.core.buildPacket' call
      // Inline function 'kotlin.contracts.contract' call
      var builder = new BytePacketBuilder();
      try {
        while (builder.p() < size) {
          writeText(builder, generateNonce_0());
        }
        tmp$ret$2 = builder.f40();
        break $l$block;
      } catch ($p) {
        if ($p instanceof Error) {
          var t = $p;
          builder.zu();
          throw t;
        } else {
          throw $p;
        }
      }
    }
    return readBytes(tmp$ret$2, size);
  }
  function hex(bytes) {
    _init_properties_Crypto_kt__txayzl();
    var result = charArray(imul(bytes.length, 2));
    var resultIndex = 0;
    var digits = get_digits();
    var inductionVariable = 0;
    var last = bytes.length;
    if (inductionVariable < last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var b = bytes[index] & 255;
        var tmp1 = resultIndex;
        resultIndex = tmp1 + 1 | 0;
        result[tmp1] = digits[b >> 4];
        var tmp2 = resultIndex;
        resultIndex = tmp2 + 1 | 0;
        result[tmp2] = digits[b & 15];
      }
       while (inductionVariable < last);
    return concatToString(result);
  }
  var properties_initialized_Crypto_kt_8g5vqb;
  function _init_properties_Crypto_kt__txayzl() {
    if (!properties_initialized_Crypto_kt_8g5vqb) {
      properties_initialized_Crypto_kt_8g5vqb = true;
      digits = toCharArray('0123456789abcdef');
    }
  }
  function DelegatingMutableSet$iterator$1(this$0) {
    this.ndv_1 = this$0;
    this.mdv_1 = this$0.odv_1.m();
  }
  protoOf(DelegatingMutableSet$iterator$1).n = function () {
    return this.mdv_1.n();
  };
  protoOf(DelegatingMutableSet$iterator$1).o = function () {
    return this.ndv_1.pdv_1(this.mdv_1.o());
  };
  protoOf(DelegatingMutableSet$iterator$1).h4 = function () {
    return this.mdv_1.h4();
  };
  function DelegatingMutableSet(delegate, convertTo, convert) {
    this.odv_1 = delegate;
    this.pdv_1 = convertTo;
    this.qdv_1 = convert;
    this.rdv_1 = this.odv_1.p();
  }
  protoOf(DelegatingMutableSet).sdv = function (_this__u8e3s4) {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(_this__u8e3s4, 10));
    var _iterator__ex2g4s = _this__u8e3s4.m();
    while (_iterator__ex2g4s.n()) {
      var item = _iterator__ex2g4s.o();
      var tmp$ret$0 = this.qdv_1(item);
      destination.j(tmp$ret$0);
    }
    return destination;
  };
  protoOf(DelegatingMutableSet).tdv = function (_this__u8e3s4) {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(_this__u8e3s4, 10));
    var _iterator__ex2g4s = _this__u8e3s4.m();
    while (_iterator__ex2g4s.n()) {
      var item = _iterator__ex2g4s.o();
      var tmp$ret$0 = this.pdv_1(item);
      destination.j(tmp$ret$0);
    }
    return destination;
  };
  protoOf(DelegatingMutableSet).p = function () {
    return this.rdv_1;
  };
  protoOf(DelegatingMutableSet).udv = function (element) {
    return this.odv_1.j(this.qdv_1(element));
  };
  protoOf(DelegatingMutableSet).j = function (element) {
    return this.udv((element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  protoOf(DelegatingMutableSet).vdv = function (elements) {
    return this.odv_1.q(this.sdv(elements));
  };
  protoOf(DelegatingMutableSet).q = function (elements) {
    return this.vdv(elements);
  };
  protoOf(DelegatingMutableSet).k2 = function () {
    this.odv_1.k2();
  };
  protoOf(DelegatingMutableSet).wdv = function (element) {
    return this.odv_1.h2(this.qdv_1(element));
  };
  protoOf(DelegatingMutableSet).h2 = function (element) {
    if (!(element == null ? true : !(element == null)))
      return false;
    return this.wdv((element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  protoOf(DelegatingMutableSet).xdv = function (elements) {
    return this.odv_1.j1(this.sdv(elements));
  };
  protoOf(DelegatingMutableSet).j1 = function (elements) {
    return this.xdv(elements);
  };
  protoOf(DelegatingMutableSet).ydv = function (elements) {
    return this.odv_1.j2(this.sdv(elements));
  };
  protoOf(DelegatingMutableSet).j2 = function (elements) {
    return this.ydv(elements);
  };
  protoOf(DelegatingMutableSet).zdv = function (element) {
    return this.odv_1.t(this.qdv_1(element));
  };
  protoOf(DelegatingMutableSet).t = function (element) {
    if (!(element == null ? true : !(element == null)))
      return false;
    return this.zdv((element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  protoOf(DelegatingMutableSet).adw = function (elements) {
    return this.odv_1.e2(this.sdv(elements));
  };
  protoOf(DelegatingMutableSet).e2 = function (elements) {
    return this.adw(elements);
  };
  protoOf(DelegatingMutableSet).s = function () {
    return this.odv_1.s();
  };
  protoOf(DelegatingMutableSet).m = function () {
    return new DelegatingMutableSet$iterator$1(this);
  };
  protoOf(DelegatingMutableSet).hashCode = function () {
    return hashCode(this.odv_1);
  };
  protoOf(DelegatingMutableSet).equals = function (other) {
    var tmp;
    if (other == null) {
      tmp = true;
    } else {
      tmp = !(!(other == null) ? isInterface(other, KtSet) : false);
    }
    if (tmp)
      return false;
    var elements = this.tdv(this.odv_1);
    var tmp_0;
    if (other.e2(elements)) {
      // Inline function 'kotlin.collections.containsAll' call
      tmp_0 = elements.e2(other);
    } else {
      tmp_0 = false;
    }
    return tmp_0;
  };
  protoOf(DelegatingMutableSet).toString = function () {
    return toString_1(this.tdv(this.odv_1));
  };
  function PlatformUtils() {
    PlatformUtils_instance = this;
    this.bdw_1 = get_platform(this).equals(Platform_Browser_getInstance());
    this.cdw_1 = get_platform(this).equals(Platform_Node_getInstance());
    this.ddw_1 = get_platform(this).equals(Platform_Jvm_getInstance());
    this.edw_1 = get_platform(this).equals(Platform_Native_getInstance());
    this.fdw_1 = get_isDevelopmentMode(this);
    this.gdw_1 = get_isNewMemoryModel(this);
  }
  var PlatformUtils_instance;
  function PlatformUtils_getInstance() {
    if (PlatformUtils_instance == null)
      new PlatformUtils();
    return PlatformUtils_instance;
  }
  var Platform_Jvm_instance;
  var Platform_Native_instance;
  var Platform_Browser_instance;
  var Platform_Node_instance;
  var Platform_entriesInitialized_0;
  function Platform_initEntries_0() {
    if (Platform_entriesInitialized_0)
      return Unit_instance;
    Platform_entriesInitialized_0 = true;
    Platform_Jvm_instance = new Platform_0('Jvm', 0);
    Platform_Native_instance = new Platform_0('Native', 1);
    Platform_Browser_instance = new Platform_0('Browser', 2);
    Platform_Node_instance = new Platform_0('Node', 3);
  }
  function Platform_0(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function Platform_Jvm_getInstance() {
    Platform_initEntries_0();
    return Platform_Jvm_instance;
  }
  function Platform_Native_getInstance() {
    Platform_initEntries_0();
    return Platform_Native_instance;
  }
  function Platform_Browser_getInstance() {
    Platform_initEntries_0();
    return Platform_Browser_instance;
  }
  function Platform_Node_getInstance() {
    Platform_initEntries_0();
    return Platform_Node_instance;
  }
  function appendAll(_this__u8e3s4, builder) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = builder.hdw().m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      // Inline function 'kotlin.collections.component1' call
      var name = element.z();
      // Inline function 'kotlin.collections.component2' call
      var values = element.a1();
      _this__u8e3s4.idw(name, values);
    }
    return _this__u8e3s4;
  }
  function StringValues() {
  }
  function ensureListForKey($this, name) {
    var tmp0_elvis_lhs = $this.odw_1.q2(name);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.collections.mutableListOf' call
      // Inline function 'kotlin.also' call
      var this_0 = ArrayList_init_$Create$();
      $this.pdw(name);
      // Inline function 'kotlin.collections.set' call
      $this.odw_1.t2(name, this_0);
      tmp = this_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function StringValuesBuilderImpl$appendAll$lambda(this$0) {
    return function (name, values) {
      this$0.idw(name, values);
      return Unit_instance;
    };
  }
  function StringValuesBuilderImpl(caseInsensitiveName, size) {
    caseInsensitiveName = caseInsensitiveName === VOID ? false : caseInsensitiveName;
    size = size === VOID ? 8 : size;
    this.ndw_1 = caseInsensitiveName;
    this.odw_1 = this.ndw_1 ? caseInsensitiveMap() : LinkedHashMap_init_$Create$_0(size);
  }
  protoOf(StringValuesBuilderImpl).jdw = function () {
    return this.ndw_1;
  };
  protoOf(StringValuesBuilderImpl).kdw = function (name) {
    return this.odw_1.q2(name);
  };
  protoOf(StringValuesBuilderImpl).qdw = function (name, value) {
    var tmp0_safe_receiver = this.odw_1.q2(name);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.t(value);
    return tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
  };
  protoOf(StringValuesBuilderImpl).ldw = function () {
    return this.odw_1.r2();
  };
  protoOf(StringValuesBuilderImpl).s = function () {
    return this.odw_1.s();
  };
  protoOf(StringValuesBuilderImpl).hdw = function () {
    return unmodifiable(this.odw_1.y());
  };
  protoOf(StringValuesBuilderImpl).rdw = function (name, value) {
    this.sdw(value);
    var list = ensureListForKey(this, name);
    list.k2();
    list.j(value);
  };
  protoOf(StringValuesBuilderImpl).ld = function (name) {
    var tmp0_safe_receiver = this.kdw(name);
    return tmp0_safe_receiver == null ? null : firstOrNull_1(tmp0_safe_receiver);
  };
  protoOf(StringValuesBuilderImpl).tdw = function (name, value) {
    this.sdw(value);
    ensureListForKey(this, name).j(value);
  };
  protoOf(StringValuesBuilderImpl).udw = function (stringValues) {
    stringValues.mdw(StringValuesBuilderImpl$appendAll$lambda(this));
  };
  protoOf(StringValuesBuilderImpl).idw = function (name, values) {
    // Inline function 'kotlin.let' call
    var list = ensureListForKey(this, name);
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = values.m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      this.sdw(element);
      list.j(element);
    }
  };
  protoOf(StringValuesBuilderImpl).vdw = function (name) {
    this.odw_1.u2(name);
  };
  protoOf(StringValuesBuilderImpl).k2 = function () {
    this.odw_1.k2();
  };
  protoOf(StringValuesBuilderImpl).pdw = function (name) {
  };
  protoOf(StringValuesBuilderImpl).sdw = function (value) {
  };
  function listForKey($this, name) {
    return $this.xdw_1.q2(name);
  }
  function StringValuesImpl(caseInsensitiveName, values) {
    caseInsensitiveName = caseInsensitiveName === VOID ? false : caseInsensitiveName;
    values = values === VOID ? emptyMap() : values;
    this.wdw_1 = caseInsensitiveName;
    var tmp;
    if (this.wdw_1) {
      tmp = caseInsensitiveMap();
    } else {
      // Inline function 'kotlin.collections.mutableMapOf' call
      tmp = LinkedHashMap_init_$Create$();
    }
    var newMap = tmp;
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s = values.y().m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      // Inline function 'kotlin.collections.component1' call
      var key = element.z();
      // Inline function 'kotlin.collections.component2' call
      var value = element.a1();
      // Inline function 'kotlin.collections.List' call
      // Inline function 'kotlin.collections.MutableList' call
      var size = value.p();
      var list = ArrayList_init_$Create$_0(size);
      // Inline function 'kotlin.repeat' call
      var inductionVariable = 0;
      if (inductionVariable < size)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var tmp$ret$4 = value.r(index);
          list.j(tmp$ret$4);
        }
         while (inductionVariable < size);
      // Inline function 'kotlin.collections.set' call
      newMap.t2(key, list);
    }
    this.xdw_1 = newMap;
  }
  protoOf(StringValuesImpl).jdw = function () {
    return this.wdw_1;
  };
  protoOf(StringValuesImpl).ld = function (name) {
    var tmp0_safe_receiver = listForKey(this, name);
    return tmp0_safe_receiver == null ? null : firstOrNull_1(tmp0_safe_receiver);
  };
  protoOf(StringValuesImpl).kdw = function (name) {
    return listForKey(this, name);
  };
  protoOf(StringValuesImpl).ldw = function () {
    return unmodifiable(this.xdw_1.r2());
  };
  protoOf(StringValuesImpl).s = function () {
    return this.xdw_1.s();
  };
  protoOf(StringValuesImpl).hdw = function () {
    return unmodifiable(this.xdw_1.y());
  };
  protoOf(StringValuesImpl).mdw = function (body) {
    // Inline function 'kotlin.collections.iterator' call
    var tmp0_iterator = this.xdw_1.y().m();
    while (tmp0_iterator.n()) {
      var tmp1_loop_parameter = tmp0_iterator.o();
      // Inline function 'kotlin.collections.component1' call
      var key = tmp1_loop_parameter.z();
      // Inline function 'kotlin.collections.component2' call
      var value = tmp1_loop_parameter.a1();
      body(key, value);
    }
  };
  protoOf(StringValuesImpl).toString = function () {
    return 'StringValues(case=' + !this.wdw_1 + ') ' + toString_1(this.hdw());
  };
  protoOf(StringValuesImpl).equals = function (other) {
    if (this === other)
      return true;
    if (!(!(other == null) ? isInterface(other, StringValues) : false))
      return false;
    if (!(this.wdw_1 === other.jdw()))
      return false;
    return entriesEquals(this.hdw(), other.hdw());
  };
  protoOf(StringValuesImpl).hashCode = function () {
    return entriesHashCode(this.hdw(), imul(31, getBooleanHashCode(this.wdw_1)));
  };
  function entriesEquals(a, b) {
    return equals(a, b);
  }
  function entriesHashCode(entries, seed) {
    return imul(seed, 31) + hashCode(entries) | 0;
  }
  function toLowerCasePreservingASCIIRules(_this__u8e3s4) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.text.indexOfFirst' call
      var inductionVariable = 0;
      var last = charSequenceLength(_this__u8e3s4) - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var it = charSequenceGet(_this__u8e3s4, index);
          if (!(toLowerCasePreservingASCII(it) === it)) {
            tmp$ret$1 = index;
            break $l$block;
          }
        }
         while (inductionVariable <= last);
      tmp$ret$1 = -1;
    }
    var firstIndex = tmp$ret$1;
    if (firstIndex === -1) {
      return _this__u8e3s4;
    }
    var original = _this__u8e3s4;
    // Inline function 'kotlin.text.buildString' call
    var capacity = _this__u8e3s4.length;
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder_init_$Create$(capacity);
    this_0.ec(original, 0, firstIndex);
    var inductionVariable_0 = firstIndex;
    var last_0 = get_lastIndex_3(original);
    if (inductionVariable_0 <= last_0)
      do {
        var index_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        this_0.k8(toLowerCasePreservingASCII(charCodeAt(original, index_0)));
      }
       while (!(index_0 === last_0));
    return this_0.toString();
  }
  function toLowerCasePreservingASCII(ch) {
    var tmp;
    if (_Char___init__impl__6a9atx(65) <= ch ? ch <= _Char___init__impl__6a9atx(90) : false) {
      tmp = Char__plus_impl_qi7pgj(ch, 32);
    } else if (_Char___init__impl__6a9atx(0) <= ch ? ch <= _Char___init__impl__6a9atx(127) : false) {
      tmp = ch;
    } else {
      // Inline function 'kotlin.text.lowercaseChar' call
      // Inline function 'kotlin.text.lowercase' call
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.unsafeCast' call
      var tmp$ret$2 = toString(ch).toLowerCase();
      tmp = charCodeAt(tmp$ret$2, 0);
    }
    return tmp;
  }
  function CaseInsensitiveString(content) {
    this.cdv_1 = content;
    var tmp = this;
    // Inline function 'kotlin.text.lowercase' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = this.cdv_1.toLowerCase();
    tmp.ddv_1 = getStringHashCode(tmp$ret$1);
  }
  protoOf(CaseInsensitiveString).equals = function (other) {
    var tmp0_safe_receiver = other instanceof CaseInsensitiveString ? other : null;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.cdv_1;
    return (tmp1_safe_receiver == null ? null : equals_0(tmp1_safe_receiver, this.cdv_1, true)) === true;
  };
  protoOf(CaseInsensitiveString).hashCode = function () {
    return this.ddv_1;
  };
  protoOf(CaseInsensitiveString).toString = function () {
    return this.cdv_1;
  };
  function caseInsensitive(_this__u8e3s4) {
    return new CaseInsensitiveString(_this__u8e3s4);
  }
  function ChannelIOException() {
  }
  function CopyOnWriteHashMap() {
    this.ydw_1 = atomic$ref$1(emptyMap());
  }
  protoOf(CopyOnWriteHashMap).zdw = function (key) {
    return this.ydw_1.kotlinx$atomicfu$value.q2(key);
  };
  function Companion_260() {
    Companion_instance_260 = this;
    this.adx_1 = GMTDate_0(0n);
  }
  var Companion_instance_260;
  function Companion_getInstance_260() {
    if (Companion_instance_260 == null)
      new Companion_260();
    return Companion_instance_260;
  }
  function GMTDate(seconds, minutes, hours, dayOfWeek, dayOfMonth, dayOfYear, month, year, timestamp) {
    Companion_getInstance_260();
    this.bdx_1 = seconds;
    this.cdx_1 = minutes;
    this.ddx_1 = hours;
    this.edx_1 = dayOfWeek;
    this.fdx_1 = dayOfMonth;
    this.gdx_1 = dayOfYear;
    this.hdx_1 = month;
    this.idx_1 = year;
    this.jdx_1 = timestamp;
  }
  protoOf(GMTDate).kdx = function (other) {
    return compareTo_0(this.jdx_1, other.jdx_1);
  };
  protoOf(GMTDate).d = function (other) {
    return this.kdx(other instanceof GMTDate ? other : THROW_CCE());
  };
  protoOf(GMTDate).toString = function () {
    return 'GMTDate(seconds=' + this.bdx_1 + ', minutes=' + this.cdx_1 + ', hours=' + this.ddx_1 + ', dayOfWeek=' + this.edx_1.toString() + ', dayOfMonth=' + this.fdx_1 + ', dayOfYear=' + this.gdx_1 + ', month=' + this.hdx_1.toString() + ', year=' + this.idx_1 + ', timestamp=' + this.jdx_1.toString() + ')';
  };
  protoOf(GMTDate).hashCode = function () {
    var result = this.bdx_1;
    result = imul(result, 31) + this.cdx_1 | 0;
    result = imul(result, 31) + this.ddx_1 | 0;
    result = imul(result, 31) + this.edx_1.hashCode() | 0;
    result = imul(result, 31) + this.fdx_1 | 0;
    result = imul(result, 31) + this.gdx_1 | 0;
    result = imul(result, 31) + this.hdx_1.hashCode() | 0;
    result = imul(result, 31) + this.idx_1 | 0;
    result = imul(result, 31) + getBigIntHashCode(this.jdx_1) | 0;
    return result;
  };
  protoOf(GMTDate).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof GMTDate))
      return false;
    var tmp0_other_with_cast = other instanceof GMTDate ? other : THROW_CCE();
    if (!(this.bdx_1 === tmp0_other_with_cast.bdx_1))
      return false;
    if (!(this.cdx_1 === tmp0_other_with_cast.cdx_1))
      return false;
    if (!(this.ddx_1 === tmp0_other_with_cast.ddx_1))
      return false;
    if (!this.edx_1.equals(tmp0_other_with_cast.edx_1))
      return false;
    if (!(this.fdx_1 === tmp0_other_with_cast.fdx_1))
      return false;
    if (!(this.gdx_1 === tmp0_other_with_cast.gdx_1))
      return false;
    if (!this.hdx_1.equals(tmp0_other_with_cast.hdx_1))
      return false;
    if (!(this.idx_1 === tmp0_other_with_cast.idx_1))
      return false;
    if (!(this.jdx_1 === tmp0_other_with_cast.jdx_1))
      return false;
    return true;
  };
  var WeekDay_MONDAY_instance;
  var WeekDay_TUESDAY_instance;
  var WeekDay_WEDNESDAY_instance;
  var WeekDay_THURSDAY_instance;
  var WeekDay_FRIDAY_instance;
  var WeekDay_SATURDAY_instance;
  var WeekDay_SUNDAY_instance;
  function Companion_261() {
  }
  protoOf(Companion_261).ldx = function (ordinal) {
    return values_7()[ordinal];
  };
  var Companion_instance_261;
  function Companion_getInstance_261() {
    return Companion_instance_261;
  }
  function values_7() {
    return [WeekDay_MONDAY_getInstance(), WeekDay_TUESDAY_getInstance(), WeekDay_WEDNESDAY_getInstance(), WeekDay_THURSDAY_getInstance(), WeekDay_FRIDAY_getInstance(), WeekDay_SATURDAY_getInstance(), WeekDay_SUNDAY_getInstance()];
  }
  var WeekDay_entriesInitialized;
  function WeekDay_initEntries() {
    if (WeekDay_entriesInitialized)
      return Unit_instance;
    WeekDay_entriesInitialized = true;
    WeekDay_MONDAY_instance = new WeekDay('MONDAY', 0, 'Mon');
    WeekDay_TUESDAY_instance = new WeekDay('TUESDAY', 1, 'Tue');
    WeekDay_WEDNESDAY_instance = new WeekDay('WEDNESDAY', 2, 'Wed');
    WeekDay_THURSDAY_instance = new WeekDay('THURSDAY', 3, 'Thu');
    WeekDay_FRIDAY_instance = new WeekDay('FRIDAY', 4, 'Fri');
    WeekDay_SATURDAY_instance = new WeekDay('SATURDAY', 5, 'Sat');
    WeekDay_SUNDAY_instance = new WeekDay('SUNDAY', 6, 'Sun');
  }
  function WeekDay(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.odx_1 = value;
  }
  var Month_JANUARY_instance;
  var Month_FEBRUARY_instance;
  var Month_MARCH_instance;
  var Month_APRIL_instance;
  var Month_MAY_instance;
  var Month_JUNE_instance;
  var Month_JULY_instance;
  var Month_AUGUST_instance;
  var Month_SEPTEMBER_instance;
  var Month_OCTOBER_instance;
  var Month_NOVEMBER_instance;
  var Month_DECEMBER_instance;
  function Companion_262() {
  }
  protoOf(Companion_262).ldx = function (ordinal) {
    return values_8()[ordinal];
  };
  var Companion_instance_262;
  function Companion_getInstance_262() {
    return Companion_instance_262;
  }
  function values_8() {
    return [Month_JANUARY_getInstance(), Month_FEBRUARY_getInstance(), Month_MARCH_getInstance(), Month_APRIL_getInstance(), Month_MAY_getInstance(), Month_JUNE_getInstance(), Month_JULY_getInstance(), Month_AUGUST_getInstance(), Month_SEPTEMBER_getInstance(), Month_OCTOBER_getInstance(), Month_NOVEMBER_getInstance(), Month_DECEMBER_getInstance()];
  }
  var Month_entriesInitialized;
  function Month_initEntries() {
    if (Month_entriesInitialized)
      return Unit_instance;
    Month_entriesInitialized = true;
    Month_JANUARY_instance = new Month('JANUARY', 0, 'Jan');
    Month_FEBRUARY_instance = new Month('FEBRUARY', 1, 'Feb');
    Month_MARCH_instance = new Month('MARCH', 2, 'Mar');
    Month_APRIL_instance = new Month('APRIL', 3, 'Apr');
    Month_MAY_instance = new Month('MAY', 4, 'May');
    Month_JUNE_instance = new Month('JUNE', 5, 'Jun');
    Month_JULY_instance = new Month('JULY', 6, 'Jul');
    Month_AUGUST_instance = new Month('AUGUST', 7, 'Aug');
    Month_SEPTEMBER_instance = new Month('SEPTEMBER', 8, 'Sep');
    Month_OCTOBER_instance = new Month('OCTOBER', 9, 'Oct');
    Month_NOVEMBER_instance = new Month('NOVEMBER', 10, 'Nov');
    Month_DECEMBER_instance = new Month('DECEMBER', 11, 'Dec');
  }
  function Month(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.rdx_1 = value;
  }
  function WeekDay_MONDAY_getInstance() {
    WeekDay_initEntries();
    return WeekDay_MONDAY_instance;
  }
  function WeekDay_TUESDAY_getInstance() {
    WeekDay_initEntries();
    return WeekDay_TUESDAY_instance;
  }
  function WeekDay_WEDNESDAY_getInstance() {
    WeekDay_initEntries();
    return WeekDay_WEDNESDAY_instance;
  }
  function WeekDay_THURSDAY_getInstance() {
    WeekDay_initEntries();
    return WeekDay_THURSDAY_instance;
  }
  function WeekDay_FRIDAY_getInstance() {
    WeekDay_initEntries();
    return WeekDay_FRIDAY_instance;
  }
  function WeekDay_SATURDAY_getInstance() {
    WeekDay_initEntries();
    return WeekDay_SATURDAY_instance;
  }
  function WeekDay_SUNDAY_getInstance() {
    WeekDay_initEntries();
    return WeekDay_SUNDAY_instance;
  }
  function Month_JANUARY_getInstance() {
    Month_initEntries();
    return Month_JANUARY_instance;
  }
  function Month_FEBRUARY_getInstance() {
    Month_initEntries();
    return Month_FEBRUARY_instance;
  }
  function Month_MARCH_getInstance() {
    Month_initEntries();
    return Month_MARCH_instance;
  }
  function Month_APRIL_getInstance() {
    Month_initEntries();
    return Month_APRIL_instance;
  }
  function Month_MAY_getInstance() {
    Month_initEntries();
    return Month_MAY_instance;
  }
  function Month_JUNE_getInstance() {
    Month_initEntries();
    return Month_JUNE_instance;
  }
  function Month_JULY_getInstance() {
    Month_initEntries();
    return Month_JULY_instance;
  }
  function Month_AUGUST_getInstance() {
    Month_initEntries();
    return Month_AUGUST_instance;
  }
  function Month_SEPTEMBER_getInstance() {
    Month_initEntries();
    return Month_SEPTEMBER_instance;
  }
  function Month_OCTOBER_getInstance() {
    Month_initEntries();
    return Month_OCTOBER_instance;
  }
  function Month_NOVEMBER_getInstance() {
    Month_initEntries();
    return Month_NOVEMBER_instance;
  }
  function Month_DECEMBER_getInstance() {
    Month_initEntries();
    return Month_DECEMBER_instance;
  }
  var CONDITION_FALSE;
  var ALREADY_REMOVED;
  var LIST_EMPTY;
  var REMOVE_PREPARED;
  var NO_DECISION;
  function LockFreeLinkedListNode() {
  }
  protoOf(LockFreeLinkedListNode).h12 = function () {
    // Inline function 'kotlinx.atomicfu.loop' call
    var this_0 = this.sdx_1;
    while (true) {
      var next = this_0.kotlinx$atomicfu$value;
      if (!(next instanceof OpDescriptor_0))
        return next;
      next.gy(this);
    }
  };
  protoOf(LockFreeLinkedListNode).tdx = function () {
    return unwrap_0(this.h12());
  };
  function Symbol_1(symbol) {
    this.udx_1 = symbol;
  }
  protoOf(Symbol_1).toString = function () {
    return this.udx_1;
  };
  function Removed() {
  }
  function OpDescriptor_0() {
  }
  function unwrap_0(_this__u8e3s4) {
    _init_properties_LockFreeLinkedList_kt__wekxce();
    var tmp0_safe_receiver = _this__u8e3s4 instanceof Removed ? _this__u8e3s4 : null;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.vdx_1;
    var tmp;
    if (tmp1_elvis_lhs == null) {
      tmp = _this__u8e3s4 instanceof LockFreeLinkedListNode ? _this__u8e3s4 : THROW_CCE();
    } else {
      tmp = tmp1_elvis_lhs;
    }
    return tmp;
  }
  var properties_initialized_LockFreeLinkedList_kt_lnmdgw;
  function _init_properties_LockFreeLinkedList_kt__wekxce() {
    if (!properties_initialized_LockFreeLinkedList_kt_lnmdgw) {
      properties_initialized_LockFreeLinkedList_kt_lnmdgw = true;
      CONDITION_FALSE = new Symbol_1('CONDITION_FALSE');
      ALREADY_REMOVED = new Symbol_1('ALREADY_REMOVED');
      LIST_EMPTY = new Symbol_1('LIST_EMPTY');
      REMOVE_PREPARED = new Symbol_1('REMOVE_PREPARED');
      NO_DECISION = new Symbol_1('NO_DECISION');
    }
  }
  function proceedLoop($this, $completion) {
    var tmp = new $proceedLoopCOROUTINE$($this, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  }
  function $proceedLoopCOROUTINE$(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.edy_1 = _this__u8e3s4;
  }
  protoOf($proceedLoopCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 6;
            this.f9_1 = 1;
            continue $sm;
          case 1:
            this.fdy_1 = this.edy_1.ldy_1;
            if (this.fdy_1 === -1) {
              this.f9_1 = 5;
              continue $sm;
            } else {
              this.f9_1 = 2;
              continue $sm;
            }

          case 2:
            this.gdy_1 = this.edy_1.idy_1;
            if (this.fdy_1 >= this.gdy_1.p()) {
              this.edy_1.r51();
              this.f9_1 = 5;
              continue $sm;
            } else {
              this.f9_1 = 3;
              continue $sm;
            }

          case 3:
            var executeInterceptor = this.gdy_1.r(this.fdy_1);
            this.edy_1.ldy_1 = this.fdy_1 + 1 | 0;
            this.f9_1 = 4;
            suspendResult = (isSuspendFunction(executeInterceptor, 2) ? executeInterceptor : THROW_CCE())(this.edy_1, this.edy_1.kdy_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            this.f9_1 = 1;
            continue $sm;
          case 5:
            return this.edy_1.kdy_1;
          case 6:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 6) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function DebugPipelineContext(context, interceptors, subject, coroutineContext) {
    PipelineContext.call(this, context);
    this.idy_1 = interceptors;
    this.jdy_1 = coroutineContext;
    this.kdy_1 = subject;
    this.ldy_1 = 0;
  }
  protoOf(DebugPipelineContext).ho = function () {
    return this.jdy_1;
  };
  protoOf(DebugPipelineContext).mdy = function () {
    return this.kdy_1;
  };
  protoOf(DebugPipelineContext).r51 = function () {
    this.ldy_1 = -1;
  };
  protoOf(DebugPipelineContext).ndy = function (subject, $completion) {
    this.kdy_1 = subject;
    return this.ody($completion);
  };
  protoOf(DebugPipelineContext).ody = function ($completion) {
    var index = this.ldy_1;
    if (index < 0)
      return this.kdy_1;
    if (index >= this.idy_1.p()) {
      this.r51();
      return this.kdy_1;
    }
    return proceedLoop(this, $completion);
  };
  protoOf(DebugPipelineContext).pdy = function (initial, $completion) {
    this.ldy_1 = 0;
    this.kdy_1 = initial;
    return this.ody($completion);
  };
  function PhaseContent_init_$Init$(phase, relation, $this) {
    var tmp = Companion_getInstance_263().qdy_1;
    PhaseContent.call($this, phase, relation, isInterface(tmp, KtMutableList) ? tmp : THROW_CCE());
    // Inline function 'kotlin.check' call
    if (!Companion_getInstance_263().qdy_1.s()) {
      var message = 'The shared empty array list has been modified';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    return $this;
  }
  function PhaseContent_init_$Create$(phase, relation) {
    return PhaseContent_init_$Init$(phase, relation, objectCreate(protoOf(PhaseContent)));
  }
  function copyInterceptors($this) {
    $this.tdy_1 = $this.vdy();
    $this.udy_1 = false;
  }
  function Companion_263() {
    Companion_instance_263 = this;
    var tmp = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp.qdy_1 = ArrayList_init_$Create$();
  }
  var Companion_instance_263;
  function Companion_getInstance_263() {
    if (Companion_instance_263 == null)
      new Companion_263();
    return Companion_instance_263;
  }
  function PhaseContent(phase, relation, interceptors) {
    Companion_getInstance_263();
    this.rdy_1 = phase;
    this.sdy_1 = relation;
    this.tdy_1 = interceptors;
    this.udy_1 = true;
  }
  protoOf(PhaseContent).w2m = function () {
    return this.tdy_1.s();
  };
  protoOf(PhaseContent).p = function () {
    return this.tdy_1.p();
  };
  protoOf(PhaseContent).wdy = function (interceptor) {
    if (this.udy_1) {
      copyInterceptors(this);
    }
    this.tdy_1.j(interceptor);
  };
  protoOf(PhaseContent).xdy = function (destination) {
    var interceptors = this.tdy_1;
    if (destination instanceof ArrayList) {
      destination.o5(destination.p() + interceptors.p() | 0);
    }
    var inductionVariable = 0;
    var last = interceptors.p();
    if (inductionVariable < last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        destination.j(interceptors.r(index));
      }
       while (inductionVariable < last);
  };
  protoOf(PhaseContent).ydy = function () {
    this.udy_1 = true;
    return this.tdy_1;
  };
  protoOf(PhaseContent).vdy = function () {
    // Inline function 'kotlin.collections.mutableListOf' call
    // Inline function 'kotlin.apply' call
    var this_0 = ArrayList_init_$Create$();
    this_0.q(this.tdy_1);
    return this_0;
  };
  protoOf(PhaseContent).toString = function () {
    return 'Phase `' + this.rdy_1.zdy_1 + '`, ' + this.p() + ' handlers';
  };
  function _set_interceptors__wod97b($this, value) {
    $this.edz_1.kotlinx$atomicfu$value = value;
  }
  function _get_interceptors__h4min7($this) {
    return $this.edz_1.kotlinx$atomicfu$value;
  }
  function createContext($this, context, subject, coroutineContext) {
    return pipelineContextFor(context, sharedInterceptorsList($this), subject, coroutineContext, $this.hdz());
  }
  function findPhase($this, phase) {
    var phasesList = $this.cdz_1;
    var inductionVariable = 0;
    var last = phasesList.p();
    if (inductionVariable < last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var current = phasesList.r(index);
        if (current === phase) {
          var content = PhaseContent_init_$Create$(phase, Last_getInstance());
          phasesList.l2(index, content);
          return content;
        }
        var tmp;
        if (current instanceof PhaseContent) {
          tmp = current.rdy_1 === phase;
        } else {
          tmp = false;
        }
        if (tmp) {
          return current instanceof PhaseContent ? current : THROW_CCE();
        }
      }
       while (inductionVariable < last);
    return null;
  }
  function findPhaseIndex($this, phase) {
    var phasesList = $this.cdz_1;
    var inductionVariable = 0;
    var last = phasesList.p();
    if (inductionVariable < last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var current = phasesList.r(index);
        var tmp;
        if (current === phase) {
          tmp = true;
        } else {
          var tmp_0;
          if (current instanceof PhaseContent) {
            tmp_0 = current.rdy_1 === phase;
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        }
        if (tmp) {
          return index;
        }
      }
       while (inductionVariable < last);
    return -1;
  }
  function hasPhase($this, phase) {
    var phasesList = $this.cdz_1;
    var inductionVariable = 0;
    var last = phasesList.p();
    if (inductionVariable < last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var current = phasesList.r(index);
        var tmp;
        if (current === phase) {
          tmp = true;
        } else {
          var tmp_0;
          if (current instanceof PhaseContent) {
            tmp_0 = current.rdy_1 === phase;
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        }
        if (tmp) {
          return true;
        }
      }
       while (inductionVariable < last);
    return false;
  }
  function cacheInterceptors($this) {
    var interceptorsQuantity = $this.ddz_1;
    if (interceptorsQuantity === 0) {
      notSharedInterceptorsList($this, emptyList());
      return emptyList();
    }
    var phases = $this.cdz_1;
    if (interceptorsQuantity === 1) {
      var inductionVariable = 0;
      var last = get_lastIndex_2(phases);
      if (inductionVariable <= last)
        $l$loop_0: do {
          var phaseIndex = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var tmp = phases.r(phaseIndex);
          var tmp1_elvis_lhs = tmp instanceof PhaseContent ? tmp : null;
          var tmp_0;
          if (tmp1_elvis_lhs == null) {
            continue $l$loop_0;
          } else {
            tmp_0 = tmp1_elvis_lhs;
          }
          var phaseContent = tmp_0;
          if (phaseContent.w2m())
            continue $l$loop_0;
          var interceptors = phaseContent.ydy();
          setInterceptorsListFromPhase($this, phaseContent);
          return interceptors;
        }
         while (!(phaseIndex === last));
    }
    // Inline function 'kotlin.collections.mutableListOf' call
    var destination = ArrayList_init_$Create$();
    var inductionVariable_0 = 0;
    var last_0 = get_lastIndex_2(phases);
    if (inductionVariable_0 <= last_0)
      $l$loop_1: do {
        var phaseIndex_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var tmp_1 = phases.r(phaseIndex_0);
        var tmp3_elvis_lhs = tmp_1 instanceof PhaseContent ? tmp_1 : null;
        var tmp_2;
        if (tmp3_elvis_lhs == null) {
          continue $l$loop_1;
        } else {
          tmp_2 = tmp3_elvis_lhs;
        }
        var phase = tmp_2;
        phase.xdy(destination);
      }
       while (!(phaseIndex_0 === last_0));
    notSharedInterceptorsList($this, destination);
    return destination;
  }
  function sharedInterceptorsList($this) {
    if (_get_interceptors__h4min7($this) == null) {
      cacheInterceptors($this);
    }
    $this.fdz_1 = true;
    return ensureNotNull(_get_interceptors__h4min7($this));
  }
  function resetInterceptorsList($this) {
    _set_interceptors__wod97b($this, null);
    $this.fdz_1 = false;
    $this.gdz_1 = null;
  }
  function notSharedInterceptorsList($this, list) {
    _set_interceptors__wod97b($this, list);
    $this.fdz_1 = false;
    $this.gdz_1 = null;
  }
  function setInterceptorsListFromPhase($this, phaseContent) {
    _set_interceptors__wod97b($this, phaseContent.ydy());
    $this.fdz_1 = false;
    $this.gdz_1 = phaseContent.rdy_1;
  }
  function tryAddToPhaseFastPath($this, phase, block) {
    var currentInterceptors = _get_interceptors__h4min7($this);
    if ($this.cdz_1.s() || currentInterceptors == null) {
      return false;
    }
    var tmp;
    if ($this.fdz_1) {
      tmp = true;
    } else {
      tmp = !(!(currentInterceptors == null) ? isInterface(currentInterceptors, KtMutableList) : false);
    }
    if (tmp) {
      return false;
    }
    if (equals($this.gdz_1, phase)) {
      currentInterceptors.j(block);
      return true;
    }
    if (equals(phase, last($this.cdz_1)) || findPhaseIndex($this, phase) === get_lastIndex_2($this.cdz_1)) {
      ensureNotNull(findPhase($this, phase)).wdy(block);
      currentInterceptors.j(block);
      return true;
    }
    return false;
  }
  function Pipeline(phases) {
    this.adz_1 = AttributesJsFn(true);
    this.bdz_1 = false;
    this.cdz_1 = mutableListOf(phases.slice());
    this.ddz_1 = 0;
    this.edz_1 = atomic$ref$1(null);
    this.fdz_1 = false;
    this.gdz_1 = null;
  }
  protoOf(Pipeline).hdz = function () {
    return this.bdz_1;
  };
  protoOf(Pipeline).idz = function (context, subject, $completion) {
    // Inline function 'kotlin.js.getCoroutineContext' call
    var tmp$ret$0 = $completion.l9();
    return createContext(this, context, subject, tmp$ret$0).pdy(subject, $completion);
  };
  protoOf(Pipeline).kdz = function (reference, phase) {
    if (hasPhase(this, phase))
      return Unit_instance;
    var index = findPhaseIndex(this, reference);
    if (index === -1) {
      throw new InvalidPhaseException('Phase ' + reference.toString() + ' was not registered for this pipeline');
    }
    var lastRelatedPhaseIndex = index;
    var inductionVariable = index + 1 | 0;
    var last = get_lastIndex_2(this.cdz_1);
    if (inductionVariable <= last)
      $l$loop_0: do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = this.cdz_1.r(i);
        var tmp1_safe_receiver = tmp instanceof PhaseContent ? tmp : null;
        var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.sdy_1;
        var tmp_0;
        if (tmp2_elvis_lhs == null) {
          break $l$loop_0;
        } else {
          tmp_0 = tmp2_elvis_lhs;
        }
        var relation = tmp_0;
        var tmp3_safe_receiver = relation instanceof After ? relation : null;
        var tmp4_elvis_lhs = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.ldz_1;
        var tmp_1;
        if (tmp4_elvis_lhs == null) {
          continue $l$loop_0;
        } else {
          tmp_1 = tmp4_elvis_lhs;
        }
        var relatedTo = tmp_1;
        lastRelatedPhaseIndex = equals(relatedTo, reference) ? i : lastRelatedPhaseIndex;
      }
       while (!(i === last));
    this.cdz_1.m2(lastRelatedPhaseIndex + 1 | 0, PhaseContent_init_$Create$(phase, new After(reference)));
  };
  protoOf(Pipeline).mdz = function (reference, phase) {
    if (hasPhase(this, phase))
      return Unit_instance;
    var index = findPhaseIndex(this, reference);
    if (index === -1) {
      throw new InvalidPhaseException('Phase ' + reference.toString() + ' was not registered for this pipeline');
    }
    this.cdz_1.m2(index, PhaseContent_init_$Create$(phase, new Before(reference)));
  };
  protoOf(Pipeline).ndz = function (phase, block) {
    var tmp0_elvis_lhs = findPhase(this, phase);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw new InvalidPhaseException('Phase ' + phase.toString() + ' was not registered for this pipeline');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var phaseContent = tmp;
    if (typeof block !== 'function')
      THROW_CCE();
    if (tryAddToPhaseFastPath(this, phase, block)) {
      this.ddz_1 = this.ddz_1 + 1 | 0;
      return Unit_instance;
    }
    phaseContent.wdy(block);
    this.ddz_1 = this.ddz_1 + 1 | 0;
    resetInterceptorsList(this);
    this.odz();
  };
  protoOf(Pipeline).odz = function () {
  };
  function PipelineContext(context) {
    this.jdz_1 = context;
  }
  function pipelineContextFor(context, interceptors, subject, coroutineContext, debugMode) {
    debugMode = debugMode === VOID ? false : debugMode;
    var tmp;
    if (get_DISABLE_SFG() || debugMode) {
      tmp = new DebugPipelineContext(context, interceptors, subject, coroutineContext);
    } else {
      tmp = new SuspendFunctionGun(subject, context, interceptors);
    }
    return tmp;
  }
  function PipelinePhase(name) {
    this.zdy_1 = name;
  }
  protoOf(PipelinePhase).toString = function () {
    return "Phase('" + this.zdy_1 + "')";
  };
  function InvalidPhaseException(message) {
    extendThrowable(this, message);
    captureStack(this, InvalidPhaseException);
  }
  function After(relativeTo) {
    PipelinePhaseRelation.call(this);
    this.ldz_1 = relativeTo;
  }
  function Before(relativeTo) {
    PipelinePhaseRelation.call(this);
    this.pdz_1 = relativeTo;
  }
  function Last() {
    Last_instance = this;
    PipelinePhaseRelation.call(this);
  }
  var Last_instance;
  function Last_getInstance() {
    if (Last_instance == null)
      new Last();
    return Last_instance;
  }
  function PipelinePhaseRelation() {
  }
  function recoverStackTraceBridge(exception, continuation) {
    var tmp;
    try {
      tmp = withCause(recoverStackTrace(exception, continuation), exception.cause);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var _ = $p;
        tmp_0 = exception;
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  function loop($this, direct) {
    do {
      var currentIndex = $this.wdz_1;
      if (currentIndex === $this.rdz_1.p()) {
        if (!direct) {
          // Inline function 'kotlin.Companion.success' call
          var value = $this.tdz_1;
          var tmp$ret$0 = _Result___init__impl__xyqfz8(value);
          resumeRootWith($this, tmp$ret$0);
          return false;
        }
        return true;
      }
      $this.wdz_1 = currentIndex + 1 | 0;
      var next = $this.rdz_1.r(currentIndex);
      try {
        var result = next($this, $this.tdz_1, $this.sdz_1);
        if (result === get_COROUTINE_SUSPENDED())
          return false;
      } catch ($p) {
        if ($p instanceof Error) {
          var cause = $p;
          // Inline function 'kotlin.Companion.failure' call
          var tmp$ret$1 = _Result___init__impl__xyqfz8(createFailure(cause));
          resumeRootWith($this, tmp$ret$1);
          return false;
        } else {
          throw $p;
        }
      }
    }
     while (true);
  }
  function resumeRootWith($this, result) {
    if ($this.vdz_1 < 0) {
      // Inline function 'kotlin.error' call
      var message = 'No more continuations to resume';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    var next = ensureNotNull($this.udz_1[$this.vdz_1]);
    var tmp1 = $this.vdz_1;
    $this.vdz_1 = tmp1 - 1 | 0;
    $this.udz_1[tmp1] = null;
    if (!_Result___get_isFailure__impl__jpiriv(result)) {
      next.q9(result);
    } else {
      var exception = recoverStackTraceBridge(ensureNotNull(Result__exceptionOrNull_impl_p6xea9(result)), next);
      // Inline function 'kotlin.coroutines.resumeWithException' call
      // Inline function 'kotlin.Companion.failure' call
      var tmp$ret$0 = _Result___init__impl__xyqfz8(createFailure(exception));
      next.q9(tmp$ret$0);
    }
  }
  function discardLastRootContinuation($this) {
    if ($this.vdz_1 < 0)
      throw IllegalStateException_init_$Create$_0('No more continuations to resume');
    var tmp1 = $this.vdz_1;
    $this.vdz_1 = tmp1 - 1 | 0;
    $this.udz_1[tmp1] = null;
  }
  function SuspendFunctionGun$continuation$1(this$0) {
    this.ydz_1 = this$0;
    this.xdz_1 = -2147483648;
  }
  protoOf(SuspendFunctionGun$continuation$1).l9 = function () {
    var continuation = this.ydz_1.udz_1[this.ydz_1.vdz_1];
    if (!(continuation === this) && !(continuation == null))
      return continuation.l9();
    var index = this.ydz_1.vdz_1 - 1 | 0;
    while (index >= 0) {
      var tmp0 = index;
      index = tmp0 - 1 | 0;
      var cont = this.ydz_1.udz_1[tmp0];
      if (!(cont === this) && !(cont == null))
        return cont.l9();
    }
    // Inline function 'kotlin.error' call
    var message = 'Not started';
    throw IllegalStateException_init_$Create$_0(toString_1(message));
  };
  protoOf(SuspendFunctionGun$continuation$1).kh = function (result) {
    if (_Result___get_isFailure__impl__jpiriv(result)) {
      // Inline function 'kotlin.Companion.failure' call
      var exception = ensureNotNull(Result__exceptionOrNull_impl_p6xea9(result));
      var tmp$ret$0 = _Result___init__impl__xyqfz8(createFailure(exception));
      resumeRootWith(this.ydz_1, tmp$ret$0);
      return Unit_instance;
    }
    loop(this.ydz_1, false);
  };
  protoOf(SuspendFunctionGun$continuation$1).q9 = function (result) {
    return this.kh(result);
  };
  function SuspendFunctionGun(initial, context, blocks) {
    PipelineContext.call(this, context);
    this.rdz_1 = blocks;
    var tmp = this;
    tmp.sdz_1 = new SuspendFunctionGun$continuation$1(this);
    this.tdz_1 = initial;
    var tmp_0 = this;
    // Inline function 'kotlin.arrayOfNulls' call
    var size = this.rdz_1.p();
    tmp_0.udz_1 = Array(size);
    this.vdz_1 = -1;
    this.wdz_1 = 0;
  }
  protoOf(SuspendFunctionGun).ho = function () {
    return this.sdz_1.l9();
  };
  protoOf(SuspendFunctionGun).mdy = function () {
    return this.tdz_1;
  };
  protoOf(SuspendFunctionGun).ody = function ($completion) {
    var tmp$ret$0;
    $l$block_0: {
      if (this.wdz_1 === this.rdz_1.p()) {
        tmp$ret$0 = this.tdz_1;
        break $l$block_0;
      }
      this.zdz(intercepted($completion));
      if (loop(this, true)) {
        discardLastRootContinuation(this);
        tmp$ret$0 = this.tdz_1;
        break $l$block_0;
      }
      tmp$ret$0 = get_COROUTINE_SUSPENDED();
    }
    return tmp$ret$0;
  };
  protoOf(SuspendFunctionGun).ndy = function (subject, $completion) {
    this.tdz_1 = subject;
    return this.ody($completion);
  };
  protoOf(SuspendFunctionGun).pdy = function (initial, $completion) {
    this.wdz_1 = 0;
    if (this.wdz_1 === this.rdz_1.p())
      return initial;
    this.tdz_1 = initial;
    if (this.vdz_1 >= 0)
      throw IllegalStateException_init_$Create$_0('Already started');
    return this.ody($completion);
  };
  protoOf(SuspendFunctionGun).zdz = function (continuation) {
    this.vdz_1 = this.vdz_1 + 1 | 0;
    this.udz_1[this.vdz_1] = continuation;
  };
  function TypeInfo(type, reifiedType, kotlinType) {
    kotlinType = kotlinType === VOID ? null : kotlinType;
    this.ae0_1 = type;
    this.be0_1 = reifiedType;
    this.ce0_1 = kotlinType;
  }
  protoOf(TypeInfo).toString = function () {
    return 'TypeInfo(type=' + toString_1(this.ae0_1) + ', reifiedType=' + toString_1(this.be0_1) + ', kotlinType=' + toString_0(this.ce0_1) + ')';
  };
  protoOf(TypeInfo).hashCode = function () {
    var result = this.ae0_1.hashCode();
    result = imul(result, 31) + hashCode(this.be0_1) | 0;
    result = imul(result, 31) + (this.ce0_1 == null ? 0 : hashCode(this.ce0_1)) | 0;
    return result;
  };
  protoOf(TypeInfo).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TypeInfo))
      return false;
    var tmp0_other_with_cast = other instanceof TypeInfo ? other : THROW_CCE();
    if (!this.ae0_1.equals(tmp0_other_with_cast.ae0_1))
      return false;
    if (!equals(this.be0_1, tmp0_other_with_cast.be0_1))
      return false;
    if (!equals(this.ce0_1, tmp0_other_with_cast.ce0_1))
      return false;
    return true;
  };
  function AttributesJsFn(concurrent) {
    concurrent = concurrent === VOID ? false : concurrent;
    return new AttributesJs();
  }
  function AttributesJs() {
    var tmp = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp.de0_1 = LinkedHashMap_init_$Create$();
  }
  protoOf(AttributesJs).mdu = function (key) {
    var tmp = this.de0_1.q2(key);
    return (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
  };
  protoOf(AttributesJs).ndu = function (key) {
    return this.de0_1.o2(key);
  };
  protoOf(AttributesJs).odu = function (key, value) {
    // Inline function 'kotlin.collections.set' call
    this.de0_1.t2(key, value);
  };
  protoOf(AttributesJs).pdu = function (key) {
    this.de0_1.u2(key);
  };
  protoOf(AttributesJs).qdu = function (key, block) {
    var tmp0_safe_receiver = this.de0_1.q2(key);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      return !(tmp0_safe_receiver == null) ? tmp0_safe_receiver : THROW_CCE();
    }
    // Inline function 'kotlin.also' call
    var this_0 = block();
    // Inline function 'kotlin.collections.set' call
    this.de0_1.t2(key, this_0);
    return this_0;
  };
  protoOf(AttributesJs).rdu = function () {
    return toList_0(this.de0_1.r2());
  };
  function unmodifiable(_this__u8e3s4) {
    return _this__u8e3s4;
  }
  function get__crypto() {
    _init_properties_CryptoJs_kt__3vpuru();
    var tmp0 = _crypto$delegate;
    var tmp = KProperty0;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('_crypto', 0, tmp, _get__crypto_$ref_ac3xpc(), null);
    return tmp0.a1();
  }
  var _crypto$delegate;
  function generateNonce_0() {
    _init_properties_CryptoJs_kt__3vpuru();
    var buffer = new Int8Array(16);
    if (get_platform(PlatformUtils_getInstance()).x2_1 === 3) {
      get__crypto().randomFillSync(buffer);
    } else {
      get__crypto().getRandomValues(buffer);
    }
    return hex(buffer);
  }
  function _crypto$delegate$lambda() {
    _init_properties_CryptoJs_kt__3vpuru();
    return get_platform(PlatformUtils_getInstance()).x2_1 === 3 ? eval('require')('crypto') : window ? window.crypto ? window.crypto : window.msCrypto : self.crypto;
  }
  function _get__crypto_$ref_ac3xpc() {
    return function () {
      return get__crypto();
    };
  }
  var properties_initialized_CryptoJs_kt_linsrw;
  function _init_properties_CryptoJs_kt__3vpuru() {
    if (!properties_initialized_CryptoJs_kt_linsrw) {
      properties_initialized_CryptoJs_kt_linsrw = true;
      _crypto$delegate = lazy(_crypto$delegate$lambda);
    }
  }
  function get_platform(_this__u8e3s4) {
    var tmp = typeof process !== 'undefined' && process.versions != null && process.versions.node != null || (typeof window !== 'undefined' && typeof window.process !== 'undefined' && window.process.versions != null && window.process.versions.node != null);
    var hasNodeApi = (!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : THROW_CCE();
    return hasNodeApi ? Platform_Node_getInstance() : Platform_Browser_getInstance();
  }
  function get_isDevelopmentMode(_this__u8e3s4) {
    return false;
  }
  function get_isNewMemoryModel(_this__u8e3s4) {
    return true;
  }
  function GMTDate_0(timestamp) {
    timestamp = timestamp === VOID ? null : timestamp;
    var tmp1_safe_receiver = timestamp == null ? null : toNumber_0(timestamp);
    var tmp;
    if (tmp1_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp = new Date(tmp1_safe_receiver);
    }
    var tmp2_elvis_lhs = tmp;
    var date = tmp2_elvis_lhs == null ? new Date() : tmp2_elvis_lhs;
    if (isNaN_0(date.getTime()))
      throw new InvalidTimestampException(ensureNotNull(timestamp));
    // Inline function 'kotlin.with' call
    var dayOfWeek = Companion_instance_261.ldx((date.getUTCDay() + 6 | 0) % 7 | 0);
    var month = Companion_instance_262.ldx(date.getUTCMonth());
    return new GMTDate(date.getUTCSeconds(), date.getUTCMinutes(), date.getUTCHours(), dayOfWeek, date.getUTCDate(), date.getUTCFullYear(), month, date.getUTCFullYear(), numberToLong(date.getTime()));
  }
  function InvalidTimestampException(timestamp) {
    IllegalStateException_init_$Init$_0('Invalid date timestamp exception: ' + timestamp.toString(), this);
    captureStack(this, InvalidTimestampException);
  }
  function getTimeMillis() {
    return numberToLong((new Date()).getTime());
  }
  function KtorSimpleLogger(name) {
    return new KtorSimpleLogger$1();
  }
  function KtorSimpleLogger$1() {
    var tmp = this;
    var tmp_0;
    switch (PlatformUtils_getInstance().cdw_1 || PlatformUtils_getInstance().bdw_1) {
      case true:
        // Inline function 'kotlin.runCatching' call

        var tmp_1;
        try {
          var tmp_2 = process.env.KTOR_LOG_LEVEL;
          // Inline function 'kotlin.Companion.success' call
          var value = (tmp_2 == null ? true : typeof tmp_2 === 'string') ? tmp_2 : THROW_CCE();
          tmp_1 = _Result___init__impl__xyqfz8(value);
        } catch ($p) {
          var tmp_3;
          if ($p instanceof Error) {
            var e = $p;
            // Inline function 'kotlin.Companion.failure' call
            tmp_3 = _Result___init__impl__xyqfz8(createFailure(e));
          } else {
            throw $p;
          }
          tmp_1 = tmp_3;
        }

        // Inline function 'kotlin.Result.getOrNull' call

        var this_0 = tmp_1;
        var tmp_4;
        if (_Result___get_isFailure__impl__jpiriv(this_0)) {
          tmp_4 = null;
        } else {
          var tmp_5 = _Result___get_value__impl__bjfvqg(this_0);
          tmp_4 = (tmp_5 == null ? true : !(tmp_5 == null)) ? tmp_5 : THROW_CCE();
        }

        var tmp1_safe_receiver = tmp_4;
        var tmp_6;
        if (tmp1_safe_receiver == null) {
          tmp_6 = null;
        } else {
          // Inline function 'kotlin.let' call
          var tmp0 = values_9();
          var tmp$ret$6;
          $l$block: {
            // Inline function 'kotlin.collections.firstOrNull' call
            var inductionVariable = 0;
            var last = tmp0.length;
            while (inductionVariable < last) {
              var element = tmp0[inductionVariable];
              inductionVariable = inductionVariable + 1 | 0;
              if (element.w2_1 === tmp1_safe_receiver) {
                tmp$ret$6 = element;
                break $l$block;
              }
            }
            tmp$ret$6 = null;
          }
          tmp_6 = tmp$ret$6;
        }

        var tmp2_elvis_lhs = tmp_6;
        tmp_0 = tmp2_elvis_lhs == null ? LogLevel_INFO_getInstance() : tmp2_elvis_lhs;
        break;
      case false:
        tmp_0 = LogLevel_TRACE_getInstance();
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    tmp.ee0_1 = tmp_0;
  }
  protoOf(KtorSimpleLogger$1).fe0 = function (message) {
    if (this.ee0_1.a3(LogLevel_TRACE_getInstance()) > 0)
      return Unit_instance;
    console.debug('TRACE: ' + message);
  };
  var LogLevel_TRACE_instance;
  var LogLevel_DEBUG_instance;
  var LogLevel_INFO_instance;
  var LogLevel_WARN_instance;
  var LogLevel_ERROR_instance;
  var LogLevel_NONE_instance;
  function values_9() {
    return [LogLevel_TRACE_getInstance(), LogLevel_DEBUG_getInstance(), LogLevel_INFO_getInstance(), LogLevel_WARN_getInstance(), LogLevel_ERROR_getInstance(), LogLevel_NONE_getInstance()];
  }
  var LogLevel_entriesInitialized;
  function LogLevel_initEntries() {
    if (LogLevel_entriesInitialized)
      return Unit_instance;
    LogLevel_entriesInitialized = true;
    LogLevel_TRACE_instance = new LogLevel('TRACE', 0);
    LogLevel_DEBUG_instance = new LogLevel('DEBUG', 1);
    LogLevel_INFO_instance = new LogLevel('INFO', 2);
    LogLevel_WARN_instance = new LogLevel('WARN', 3);
    LogLevel_ERROR_instance = new LogLevel('ERROR', 4);
    LogLevel_NONE_instance = new LogLevel('NONE', 5);
  }
  function LogLevel(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function LogLevel_TRACE_getInstance() {
    LogLevel_initEntries();
    return LogLevel_TRACE_instance;
  }
  function LogLevel_DEBUG_getInstance() {
    LogLevel_initEntries();
    return LogLevel_DEBUG_instance;
  }
  function LogLevel_INFO_getInstance() {
    LogLevel_initEntries();
    return LogLevel_INFO_instance;
  }
  function LogLevel_WARN_getInstance() {
    LogLevel_initEntries();
    return LogLevel_WARN_instance;
  }
  function LogLevel_ERROR_getInstance() {
    LogLevel_initEntries();
    return LogLevel_ERROR_instance;
  }
  function LogLevel_NONE_getInstance() {
    LogLevel_initEntries();
    return LogLevel_NONE_instance;
  }
  function get_DISABLE_SFG() {
    return DISABLE_SFG;
  }
  var DISABLE_SFG;
  function withCause(_this__u8e3s4, cause) {
    return _this__u8e3s4;
  }
  function instanceOf(_this__u8e3s4, type) {
    return type.sa(_this__u8e3s4);
  }
  function typeInfoImpl(reifiedType, kClass, kType) {
    return new TypeInfo(kClass, reifiedType, kType);
  }
  function JsType() {
  }
  var JsType_instance;
  function JsType_getInstance() {
    return JsType_instance;
  }
  var Codes_NORMAL_instance;
  var Codes_GOING_AWAY_instance;
  var Codes_PROTOCOL_ERROR_instance;
  var Codes_CANNOT_ACCEPT_instance;
  var Codes_CLOSED_ABNORMALLY_instance;
  var Codes_NOT_CONSISTENT_instance;
  var Codes_VIOLATED_POLICY_instance;
  var Codes_TOO_BIG_instance;
  var Codes_NO_EXTENSION_instance;
  var Codes_INTERNAL_ERROR_instance;
  var Codes_SERVICE_RESTART_instance;
  var Codes_TRY_AGAIN_LATER_instance;
  function Companion_264() {
    Companion_instance_264 = this;
    var tmp = this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = values_10();
    var capacity = coerceAtLeast(mapCapacity(this_0.length), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap_init_$Create$_0(capacity);
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      var tmp$ret$0 = element.ie0_1;
      destination.t2(tmp$ret$0, element);
    }
    tmp.je0_1 = destination;
    this.ke0_1 = Codes_INTERNAL_ERROR_getInstance();
  }
  protoOf(Companion_264).le0 = function (code) {
    return this.je0_1.q2(code);
  };
  var Companion_instance_264;
  function Companion_getInstance_264() {
    Codes_initEntries();
    if (Companion_instance_264 == null)
      new Companion_264();
    return Companion_instance_264;
  }
  function values_10() {
    return [Codes_NORMAL_getInstance(), Codes_GOING_AWAY_getInstance(), Codes_PROTOCOL_ERROR_getInstance(), Codes_CANNOT_ACCEPT_getInstance(), Codes_CLOSED_ABNORMALLY_getInstance(), Codes_NOT_CONSISTENT_getInstance(), Codes_VIOLATED_POLICY_getInstance(), Codes_TOO_BIG_getInstance(), Codes_NO_EXTENSION_getInstance(), Codes_INTERNAL_ERROR_getInstance(), Codes_SERVICE_RESTART_getInstance(), Codes_TRY_AGAIN_LATER_getInstance()];
  }
  var Codes_entriesInitialized;
  function Codes_initEntries() {
    if (Codes_entriesInitialized)
      return Unit_instance;
    Codes_entriesInitialized = true;
    Codes_NORMAL_instance = new Codes('NORMAL', 0, 1000);
    Codes_GOING_AWAY_instance = new Codes('GOING_AWAY', 1, 1001);
    Codes_PROTOCOL_ERROR_instance = new Codes('PROTOCOL_ERROR', 2, 1002);
    Codes_CANNOT_ACCEPT_instance = new Codes('CANNOT_ACCEPT', 3, 1003);
    Codes_CLOSED_ABNORMALLY_instance = new Codes('CLOSED_ABNORMALLY', 4, 1006);
    Codes_NOT_CONSISTENT_instance = new Codes('NOT_CONSISTENT', 5, 1007);
    Codes_VIOLATED_POLICY_instance = new Codes('VIOLATED_POLICY', 6, 1008);
    Codes_TOO_BIG_instance = new Codes('TOO_BIG', 7, 1009);
    Codes_NO_EXTENSION_instance = new Codes('NO_EXTENSION', 8, 1010);
    Codes_INTERNAL_ERROR_instance = new Codes('INTERNAL_ERROR', 9, 1011);
    Codes_SERVICE_RESTART_instance = new Codes('SERVICE_RESTART', 10, 1012);
    Codes_TRY_AGAIN_LATER_instance = new Codes('TRY_AGAIN_LATER', 11, 1013);
    Companion_getInstance_264();
  }
  function CloseReason_init_$Init$(code, message, $this) {
    CloseReason.call($this, code.ie0_1, message);
    return $this;
  }
  function CloseReason_init_$Create$(code, message) {
    return CloseReason_init_$Init$(code, message, objectCreate(protoOf(CloseReason)));
  }
  function Codes(name, ordinal, code) {
    Enum.call(this, name, ordinal);
    this.ie0_1 = code;
  }
  function Codes_NORMAL_getInstance() {
    Codes_initEntries();
    return Codes_NORMAL_instance;
  }
  function Codes_GOING_AWAY_getInstance() {
    Codes_initEntries();
    return Codes_GOING_AWAY_instance;
  }
  function Codes_PROTOCOL_ERROR_getInstance() {
    Codes_initEntries();
    return Codes_PROTOCOL_ERROR_instance;
  }
  function Codes_CANNOT_ACCEPT_getInstance() {
    Codes_initEntries();
    return Codes_CANNOT_ACCEPT_instance;
  }
  function Codes_CLOSED_ABNORMALLY_getInstance() {
    Codes_initEntries();
    return Codes_CLOSED_ABNORMALLY_instance;
  }
  function Codes_NOT_CONSISTENT_getInstance() {
    Codes_initEntries();
    return Codes_NOT_CONSISTENT_instance;
  }
  function Codes_VIOLATED_POLICY_getInstance() {
    Codes_initEntries();
    return Codes_VIOLATED_POLICY_instance;
  }
  function Codes_TOO_BIG_getInstance() {
    Codes_initEntries();
    return Codes_TOO_BIG_instance;
  }
  function Codes_NO_EXTENSION_getInstance() {
    Codes_initEntries();
    return Codes_NO_EXTENSION_instance;
  }
  function Codes_INTERNAL_ERROR_getInstance() {
    Codes_initEntries();
    return Codes_INTERNAL_ERROR_instance;
  }
  function Codes_SERVICE_RESTART_getInstance() {
    Codes_initEntries();
    return Codes_SERVICE_RESTART_instance;
  }
  function Codes_TRY_AGAIN_LATER_getInstance() {
    Codes_initEntries();
    return Codes_TRY_AGAIN_LATER_instance;
  }
  function CloseReason(code, message) {
    this.me0_1 = code;
    this.ne0_1 = message;
  }
  protoOf(CloseReason).oe0 = function () {
    return Companion_getInstance_264().le0(this.me0_1);
  };
  protoOf(CloseReason).toString = function () {
    var tmp0_elvis_lhs = this.oe0();
    return 'CloseReason(reason=' + toString_1(tmp0_elvis_lhs == null ? this.me0_1 : tmp0_elvis_lhs) + ', message=' + this.ne0_1 + ')';
  };
  protoOf(CloseReason).hashCode = function () {
    var result = this.me0_1;
    result = imul(result, 31) + getStringHashCode(this.ne0_1) | 0;
    return result;
  };
  protoOf(CloseReason).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CloseReason))
      return false;
    var tmp0_other_with_cast = other instanceof CloseReason ? other : THROW_CCE();
    if (!(this.me0_1 === tmp0_other_with_cast.me0_1))
      return false;
    if (!(this.ne0_1 === tmp0_other_with_cast.ne0_1))
      return false;
    return true;
  };
  function get_LOGGER() {
    _init_properties_DefaultWebSocketSession_kt__469s0y();
    return LOGGER;
  }
  var LOGGER;
  function get_IncomingProcessorCoroutineName() {
    _init_properties_DefaultWebSocketSession_kt__469s0y();
    return IncomingProcessorCoroutineName;
  }
  var IncomingProcessorCoroutineName;
  function get_OutgoingProcessorCoroutineName() {
    _init_properties_DefaultWebSocketSession_kt__469s0y();
    return OutgoingProcessorCoroutineName;
  }
  var OutgoingProcessorCoroutineName;
  function get_NORMAL_CLOSE() {
    _init_properties_DefaultWebSocketSession_kt__469s0y();
    return NORMAL_CLOSE;
  }
  var NORMAL_CLOSE;
  function DefaultWebSocketSession() {
  }
  function DefaultWebSocketSession_0(session, pingInterval, timeoutMillis) {
    pingInterval = pingInterval === VOID ? -1n : pingInterval;
    timeoutMillis = timeoutMillis === VOID ? 15000n : timeoutMillis;
    _init_properties_DefaultWebSocketSession_kt__469s0y();
    // Inline function 'kotlin.require' call
    if (!!isInterface(session, DefaultWebSocketSession)) {
      var message = 'Cannot wrap other DefaultWebSocketSession';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    return new DefaultWebSocketSessionImpl(session, pingInterval, timeoutMillis);
  }
  function runIncomingProcessor($this, ponger) {
    var tmp = get_IncomingProcessorCoroutineName().wi(Dispatchers_getInstance().vz_1);
    return launch($this, tmp, VOID, DefaultWebSocketSessionImpl$runIncomingProcessor$slambda_0($this, ponger, null));
  }
  function runOutgoingProcessor($this) {
    var tmp = get_OutgoingProcessorCoroutineName().wi(Dispatchers_getInstance().vz_1);
    var tmp_0 = CoroutineStart_UNDISPATCHED_getInstance();
    return launch($this, tmp, tmp_0, DefaultWebSocketSessionImpl$runOutgoingProcessor$slambda_0($this, null));
  }
  function outgoingProcessorLoop($this, $completion) {
    var tmp = new $outgoingProcessorLoopCOROUTINE$($this, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  }
  function sendCloseSequence($this, reason, exception, $completion) {
    var tmp = new $sendCloseSequenceCOROUTINE$($this, reason, exception, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  }
  function sendCloseSequence$default($this, reason, exception, $completion, $super) {
    exception = exception === VOID ? null : exception;
    return sendCloseSequence($this, reason, exception, $completion);
  }
  function tryClose($this) {
    return $this.ze1_1.atomicfu$compareAndSet(false, true);
  }
  function runOrCancelPinger($this) {
    var interval = $this.ee2_1;
    var tmp;
    if ($this.ze1_1.kotlinx$atomicfu$value) {
      tmp = null;
    } else if (interval > 0n) {
      var tmp_0 = $this.ue1_1.ue0();
      var tmp_1 = $this.fe2_1;
      tmp = pinger($this, tmp_0, interval, tmp_1, DefaultWebSocketSessionImpl$runOrCancelPinger$slambda_0($this, null));
    } else {
      tmp = null;
    }
    var newPinger = tmp;
    var tmp0_safe_receiver = $this.ve1_1.atomicfu$getAndSet(newPinger);
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver.i16();
    var tmp2_safe_receiver = newPinger == null ? null : new ChannelResult(newPinger.a16(Companion_getInstance_265().he2_1));
    if (tmp2_safe_receiver == null)
      null;
    else
      _ChannelResult___get_isSuccess__impl__odq1z9(tmp2_safe_receiver.c16_1);
    if ($this.ze1_1.kotlinx$atomicfu$value && !(newPinger == null)) {
      runOrCancelPinger($this);
    }
  }
  function checkMaxFrameSize($this, packet, frame, $completion) {
    var tmp = new $checkMaxFrameSizeCOROUTINE$($this, packet, frame, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  }
  function processIncomingExtensions($this, frame) {
    // Inline function 'kotlin.collections.fold' call
    var accumulator = frame;
    var _iterator__ex2g4s = $this.ue2().m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      var current = accumulator;
      accumulator = element.ve2(current);
    }
    return accumulator;
  }
  function processOutgoingExtensions($this, frame) {
    // Inline function 'kotlin.collections.fold' call
    var accumulator = frame;
    var _iterator__ex2g4s = $this.ue2().m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      var current = accumulator;
      accumulator = element.we2(current);
    }
    return accumulator;
  }
  function Companion_265() {
    Companion_instance_265 = this;
    this.he2_1 = new Pong(new Int8Array(0), NonDisposableHandle_instance_0);
  }
  var Companion_instance_265;
  function Companion_getInstance_265() {
    if (Companion_instance_265 == null)
      new Companion_265();
    return Companion_instance_265;
  }
  function DefaultWebSocketSessionImpl$runIncomingProcessor$slambda(this$0, $ponger, resultContinuation) {
    this.fe3_1 = this$0;
    this.ge3_1 = $ponger;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(DefaultWebSocketSessionImpl$runIncomingProcessor$slambda).e1h = function ($this$launch, $completion) {
    var tmp = this.f1h($this$launch, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(DefaultWebSocketSessionImpl$runIncomingProcessor$slambda).v9 = function (p1, $completion) {
    return this.e1h((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(DefaultWebSocketSessionImpl$runIncomingProcessor$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 39;
            this.oe3_1 = null;
            this.je3_1 = null;
            this.ie3_1 = false;
            this.f9_1 = 1;
            continue $sm;
          case 1:
            this.f9_1 = 2;
            continue $sm;
          case 2:
            this.g9_1 = 33;
            this.g9_1 = 32;
            var tmp_0 = this;
            tmp_0.se3_1 = this.fe3_1.ue1_1.te0();
            this.f9_1 = 3;
            continue $sm;
          case 3:
            this.me3_1 = this.se3_1;
            this.le3_1 = null;
            this.f9_1 = 4;
            continue $sm;
          case 4:
            this.f9_1 = 5;
            continue $sm;
          case 5:
            this.f9_1 = 6;
            continue $sm;
          case 6:
            this.g9_1 = 29;
            this.g9_1 = 28;
            this.re3_1 = this.me3_1.m();
            this.f9_1 = 7;
            continue $sm;
          case 7:
            this.f9_1 = 8;
            suspendResult = this.re3_1.d14(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 8:
            if (!suspendResult) {
              this.f9_1 = 26;
              continue $sm;
            }

            var e = this.re3_1.o();
            var tmp_1 = this;
            tmp_1.qe3_1 = e;
            this.f9_1 = 9;
            continue $sm;
          case 9:
            this.pe3_1 = this.qe3_1;
            get_LOGGER().fe0('WebSocketSession(' + toString_1(this.he3_1) + ') receiving frame ' + this.pe3_1.toString());
            var tmp0_subject = this.pe3_1;
            if (tmp0_subject instanceof Close) {
              if (!this.fe3_1.ue0().f14()) {
                this.f9_1 = 20;
                var tmp_2 = this.fe3_1.ue0();
                var tmp1_elvis_lhs = readReason(this.pe3_1);
                suspendResult = tmp_2.z15(Close_init_$Create$(tmp1_elvis_lhs == null ? get_NORMAL_CLOSE() : tmp1_elvis_lhs), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                this.f9_1 = 21;
                continue $sm;
              }
            } else {
              if (tmp0_subject instanceof Pong) {
                var tmp2_safe_receiver = this.fe3_1.ve1_1.kotlinx$atomicfu$value;
                if (tmp2_safe_receiver == null) {
                  this.ne3_1 = null;
                  this.f9_1 = 17;
                  continue $sm;
                } else {
                  this.f9_1 = 16;
                  suspendResult = tmp2_safe_receiver.z15(this.pe3_1, this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  continue $sm;
                }
              } else {
                if (tmp0_subject instanceof Ping) {
                  this.f9_1 = 15;
                  suspendResult = this.ge3_1.z15(this.pe3_1, this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  continue $sm;
                } else {
                  this.f9_1 = 10;
                  suspendResult = checkMaxFrameSize(this.fe3_1, this.je3_1, this.pe3_1, this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  continue $sm;
                }
              }
            }

          case 10:
            if (!this.pe3_1.te3_1) {
              if (this.oe3_1 == null) {
                this.oe3_1 = this.pe3_1;
              }
              if (this.je3_1 == null) {
                this.je3_1 = new BytePacketBuilder();
              }
              writeFully_3(ensureNotNull(this.je3_1), this.pe3_1.ve3_1);
              this.f9_1 = 19;
              continue $sm;
            } else {
              this.f9_1 = 11;
              continue $sm;
            }

          case 11:
            if (this.oe3_1 == null) {
              this.f9_1 = 14;
              suspendResult = this.fe3_1.xe1_1.z15(processIncomingExtensions(this.fe3_1, this.pe3_1), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.f9_1 = 12;
              continue $sm;
            }

          case 12:
            writeFully_3(ensureNotNull(this.je3_1), this.pe3_1.ve3_1);
            var defragmented = Companion_getInstance_267().be4(true, ensureNotNull(this.oe3_1).ue3_1, readBytes(ensureNotNull(this.je3_1).f40()), ensureNotNull(this.oe3_1).xe3_1, ensureNotNull(this.oe3_1).ye3_1, ensureNotNull(this.oe3_1).ze3_1);
            this.oe3_1 = null;
            this.f9_1 = 13;
            suspendResult = this.fe3_1.xe1_1.z15(processIncomingExtensions(this.fe3_1, defragmented), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 13:
            this.f9_1 = 18;
            continue $sm;
          case 14:
            this.f9_1 = 19;
            continue $sm;
          case 15:
            this.f9_1 = 18;
            continue $sm;
          case 16:
            var tmp_3 = this;
            tmp_3.ne3_1 = Unit_instance;
            this.f9_1 = 17;
            continue $sm;
          case 17:
            this.f9_1 = 18;
            continue $sm;
          case 18:
            if (false) {
              this.f9_1 = 9;
              continue $sm;
            }

            this.f9_1 = 19;
            continue $sm;
          case 19:
            this.f9_1 = 7;
            continue $sm;
          case 20:
            this.f9_1 = 21;
            continue $sm;
          case 21:
            this.ie3_1 = true;
            this.f9_1 = 22;
            continue $sm;
          case 22:
            this.g9_1 = 32;
            cancelConsumed(this.me3_1, this.le3_1);
            this.g9_1 = 39;
            this.f9_1 = 23;
            continue $sm;
          case 23:
            this.g9_1 = 39;
            this.ge3_1.i16();
            var tmp0_safe_receiver = this.je3_1;
            if (tmp0_safe_receiver == null)
              null;
            else {
              tmp0_safe_receiver.zu();
            }

            this.fe3_1.xe1_1.i16();
            if (!this.ie3_1) {
              this.f9_1 = 24;
              suspendResult = close_2(this.fe3_1, CloseReason_init_$Create$(Codes_CLOSED_ABNORMALLY_getInstance(), 'Connection was closed without close frame'), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.f9_1 = 25;
              continue $sm;
            }

          case 24:
            this.f9_1 = 25;
            continue $sm;
          case 25:
            return Unit_instance;
          case 26:
            this.f9_1 = 27;
            continue $sm;
          case 27:
            this.g9_1 = 32;
            cancelConsumed(this.me3_1, this.le3_1);
            this.f9_1 = 31;
            continue $sm;
          case 28:
            this.g9_1 = 29;
            var tmp_4 = this.i9_1;
            if (tmp_4 instanceof Error) {
              var e_0 = this.i9_1;
              this.le3_1 = e_0;
              throw e_0;
            } else {
              throw this.i9_1;
            }

          case 29:
            this.g9_1 = 32;
            var t = this.i9_1;
            cancelConsumed(this.me3_1, this.le3_1);
            throw t;
          case 30:
            this.g9_1 = 32;
            cancelConsumed(this.me3_1, this.le3_1);
            if (false) {
              this.f9_1 = 3;
              continue $sm;
            }

            this.f9_1 = 31;
            continue $sm;
          case 31:
            this.g9_1 = 39;
            this.f9_1 = 36;
            continue $sm;
          case 32:
            this.g9_1 = 33;
            var tmp_5 = this.i9_1;
            if (tmp_5 instanceof ClosedSendChannelException) {
              var ignore = this.i9_1;
              this.g9_1 = 39;
              this.f9_1 = 36;
              continue $sm;
            } else {
              var tmp_6 = this.i9_1;
              if (tmp_6 instanceof Error) {
                var cause = this.i9_1;
                this.ge3_1.i16();
                this.fe3_1.xe1_1.g16(cause);
                this.g9_1 = 39;
                this.f9_1 = 36;
                continue $sm;
              } else {
                throw this.i9_1;
              }
            }

          case 33:
            this.g9_1 = 39;
            this.ke3_1 = this.i9_1;
            this.ge3_1.i16();
            var tmp0_safe_receiver_0 = this.je3_1;
            if (tmp0_safe_receiver_0 == null)
              null;
            else {
              tmp0_safe_receiver_0.zu();
            }

            this.fe3_1.xe1_1.i16();
            if (!this.ie3_1) {
              this.f9_1 = 34;
              suspendResult = close_2(this.fe3_1, CloseReason_init_$Create$(Codes_CLOSED_ABNORMALLY_getInstance(), 'Connection was closed without close frame'), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.f9_1 = 35;
              continue $sm;
            }

          case 34:
            this.f9_1 = 35;
            continue $sm;
          case 35:
            throw this.ke3_1;
          case 36:
            this.g9_1 = 39;
            this.ge3_1.i16();
            var tmp0_safe_receiver_1 = this.je3_1;
            if (tmp0_safe_receiver_1 == null)
              null;
            else {
              tmp0_safe_receiver_1.zu();
            }

            this.fe3_1.xe1_1.i16();
            if (!this.ie3_1) {
              this.f9_1 = 37;
              suspendResult = close_2(this.fe3_1, CloseReason_init_$Create$(Codes_CLOSED_ABNORMALLY_getInstance(), 'Connection was closed without close frame'), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.f9_1 = 38;
              continue $sm;
            }

          case 37:
            this.f9_1 = 38;
            continue $sm;
          case 38:
            return Unit_instance;
          case 39:
            throw this.i9_1;
        }
      } catch ($p) {
        var e_1 = $p;
        if (this.g9_1 === 39) {
          throw e_1;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e_1;
        }
      }
     while (true);
  };
  protoOf(DefaultWebSocketSessionImpl$runIncomingProcessor$slambda).f1h = function ($this$launch, completion) {
    var i = new DefaultWebSocketSessionImpl$runIncomingProcessor$slambda(this.fe3_1, this.ge3_1, completion);
    i.he3_1 = $this$launch;
    return i;
  };
  function DefaultWebSocketSessionImpl$runIncomingProcessor$slambda_0(this$0, $ponger, resultContinuation) {
    var i = new DefaultWebSocketSessionImpl$runIncomingProcessor$slambda(this$0, $ponger, resultContinuation);
    var l = function ($this$launch, $completion) {
      return i.e1h($this$launch, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function DefaultWebSocketSessionImpl$runOutgoingProcessor$slambda(this$0, resultContinuation) {
    this.ke4_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(DefaultWebSocketSessionImpl$runOutgoingProcessor$slambda).e1h = function ($this$launch, $completion) {
    var tmp = this.f1h($this$launch, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(DefaultWebSocketSessionImpl$runOutgoingProcessor$slambda).v9 = function (p1, $completion) {
    return this.e1h((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(DefaultWebSocketSessionImpl$runOutgoingProcessor$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 10;
            this.f9_1 = 1;
            continue $sm;
          case 1:
            this.g9_1 = 6;
            this.g9_1 = 3;
            this.f9_1 = 2;
            suspendResult = outgoingProcessorLoop(this.ke4_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.g9_1 = 10;
            this.f9_1 = 8;
            continue $sm;
          case 3:
            this.g9_1 = 6;
            var tmp_0 = this.i9_1;
            if (tmp_0 instanceof ClosedSendChannelException) {
              var ignore = this.i9_1;
              this.g9_1 = 10;
              this.f9_1 = 8;
              continue $sm;
            } else {
              var tmp_1 = this.i9_1;
              if (tmp_1 instanceof ClosedReceiveChannelException) {
                var ignore_0 = this.i9_1;
                this.g9_1 = 10;
                this.f9_1 = 8;
                continue $sm;
              } else {
                var tmp_2 = this.i9_1;
                if (tmp_2 instanceof CancellationException) {
                  var ignore_1 = this.i9_1;
                  this.f9_1 = 4;
                  suspendResult = sendCloseSequence$default(this.ke4_1, CloseReason_init_$Create$(Codes_NORMAL_getInstance(), ''), VOID, this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  continue $sm;
                } else {
                  var tmp_3 = this.i9_1;
                  if (tmp_3 instanceof ChannelIOException) {
                    var ignore_2 = this.i9_1;
                    this.g9_1 = 10;
                    this.f9_1 = 8;
                    continue $sm;
                  } else {
                    var tmp_4 = this.i9_1;
                    if (tmp_4 instanceof Error) {
                      var cause = this.i9_1;
                      this.ke4_1.ye1_1.rp(CancellationException_init_$Create$_1('Failed to send frame', cause));
                      this.f9_1 = 5;
                      suspendResult = closeExceptionally(this.ke4_1.ue1_1, cause, this);
                      if (suspendResult === get_COROUTINE_SUSPENDED()) {
                        return suspendResult;
                      }
                      continue $sm;
                    } else {
                      throw this.i9_1;
                    }
                  }
                }
              }
            }

          case 4:
            this.g9_1 = 10;
            this.f9_1 = 8;
            continue $sm;
          case 5:
            this.g9_1 = 10;
            this.f9_1 = 8;
            continue $sm;
          case 6:
            this.g9_1 = 10;
            this.me4_1 = this.i9_1;
            this.ke4_1.ye1_1.k16();
            this.f9_1 = 7;
            suspendResult = close_2(this.ke4_1.ue1_1, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 7:
            throw this.me4_1;
          case 8:
            this.g9_1 = 10;
            this.ke4_1.ye1_1.k16();
            this.f9_1 = 9;
            suspendResult = close_2(this.ke4_1.ue1_1, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 9:
            return Unit_instance;
          case 10:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 10) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(DefaultWebSocketSessionImpl$runOutgoingProcessor$slambda).f1h = function ($this$launch, completion) {
    var i = new DefaultWebSocketSessionImpl$runOutgoingProcessor$slambda(this.ke4_1, completion);
    i.le4_1 = $this$launch;
    return i;
  };
  function DefaultWebSocketSessionImpl$runOutgoingProcessor$slambda_0(this$0, resultContinuation) {
    var i = new DefaultWebSocketSessionImpl$runOutgoingProcessor$slambda(this$0, resultContinuation);
    var l = function ($this$launch, $completion) {
      return i.e1h($this$launch, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function DefaultWebSocketSessionImpl$runOrCancelPinger$slambda(this$0, resultContinuation) {
    this.ve4_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(DefaultWebSocketSessionImpl$runOrCancelPinger$slambda).xe4 = function (it, $completion) {
    var tmp = this.ye4(it, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(DefaultWebSocketSessionImpl$runOrCancelPinger$slambda).v9 = function (p1, $completion) {
    return this.xe4(p1 instanceof CloseReason ? p1 : THROW_CCE(), $completion);
  };
  protoOf(DefaultWebSocketSessionImpl$runOrCancelPinger$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = sendCloseSequence(this.ve4_1, this.we4_1, IOException_init_$Create$('Ping timeout'), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(DefaultWebSocketSessionImpl$runOrCancelPinger$slambda).ye4 = function (it, completion) {
    var i = new DefaultWebSocketSessionImpl$runOrCancelPinger$slambda(this.ve4_1, completion);
    i.we4_1 = it;
    return i;
  };
  function DefaultWebSocketSessionImpl$runOrCancelPinger$slambda_0(this$0, resultContinuation) {
    var i = new DefaultWebSocketSessionImpl$runOrCancelPinger$slambda(this$0, resultContinuation);
    var l = function (it, $completion) {
      return i.xe4(it, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function $outgoingProcessorLoopCOROUTINE$(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.fe1_1 = _this__u8e3s4;
  }
  protoOf($outgoingProcessorLoopCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 7;
            this.he1_1 = this.fe1_1.ye1_1.m();
            this.f9_1 = 1;
            continue $sm;
          case 1:
            this.f9_1 = 2;
            suspendResult = this.he1_1.d14(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            if (!suspendResult) {
              this.f9_1 = 6;
              continue $sm;
            }

            var frame = this.he1_1.o();
            get_LOGGER().fe0('Sending ' + frame.toString() + ' from session ' + toString_1(this.fe1_1));
            if (frame instanceof Close) {
              this.f9_1 = 3;
              suspendResult = sendCloseSequence$default(this.fe1_1, readReason(frame), VOID, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              var tmp_0;
              if (frame instanceof Text) {
                tmp_0 = true;
              } else {
                tmp_0 = frame instanceof Binary;
              }
              if (tmp_0) {
                this.ge1_1 = processOutgoingExtensions(this.fe1_1, frame);
                this.f9_1 = 4;
                continue $sm;
              } else {
                this.ge1_1 = frame;
                this.f9_1 = 4;
                continue $sm;
              }
            }

          case 3:
            this.f9_1 = 6;
            var tmp_1 = this;
            continue $sm;
          case 4:
            var processedFrame = this.ge1_1;
            this.f9_1 = 5;
            suspendResult = this.fe1_1.ue1_1.ue0().z15(processedFrame, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 5:
            this.f9_1 = 1;
            continue $sm;
          case 6:
            return Unit_instance;
          case 7:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 7) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function $sendCloseSequenceCOROUTINE$(_this__u8e3s4, reason, exception, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.qe1_1 = _this__u8e3s4;
    this.re1_1 = reason;
    this.se1_1 = exception;
  }
  protoOf($sendCloseSequenceCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 6;
            if (!tryClose(this.qe1_1))
              return Unit_instance;
            get_LOGGER().fe0('Sending Close Sequence for session ' + toString_1(this.qe1_1) + ' with reason ' + toString_0(this.re1_1) + ' and exception ' + toString_0(this.se1_1));
            this.qe1_1.ae2_1.su();
            var tmp_0 = this;
            var tmp0_elvis_lhs = this.re1_1;
            tmp_0.te1_1 = tmp0_elvis_lhs == null ? CloseReason_init_$Create$(Codes_NORMAL_getInstance(), '') : tmp0_elvis_lhs;
            this.f9_1 = 1;
            continue $sm;
          case 1:
            this.g9_1 = 5;
            runOrCancelPinger(this.qe1_1);
            if (!(this.te1_1.me0_1 === Codes_CLOSED_ABNORMALLY_getInstance().ie0_1)) {
              this.f9_1 = 2;
              suspendResult = this.qe1_1.ue1_1.ue0().z15(Close_init_$Create$(this.te1_1), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.f9_1 = 3;
              continue $sm;
            }

          case 2:
            this.f9_1 = 3;
            continue $sm;
          case 3:
            this.g9_1 = 6;
            this.f9_1 = 4;
            continue $sm;
          case 4:
            this.g9_1 = 6;
            this.qe1_1.we1_1.pu(this.te1_1);
            if (!(this.se1_1 == null)) {
              this.qe1_1.ye1_1.g16(this.se1_1);
              this.qe1_1.xe1_1.g16(this.se1_1);
            }

            return Unit_instance;
          case 5:
            this.g9_1 = 6;
            var t = this.i9_1;
            this.qe1_1.we1_1.pu(this.te1_1);
            if (!(this.se1_1 == null)) {
              this.qe1_1.ye1_1.g16(this.se1_1);
              this.qe1_1.xe1_1.g16(this.se1_1);
            }

            throw t;
          case 6:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 6) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function $checkMaxFrameSizeCOROUTINE$(_this__u8e3s4, packet, frame, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.qe2_1 = _this__u8e3s4;
    this.re2_1 = packet;
    this.se2_1 = frame;
  }
  protoOf($checkMaxFrameSizeCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 3;
            var tmp_0 = this;
            var tmp_1 = this.se2_1.ve3_1.length;
            var tmp0_safe_receiver = this.re2_1;
            var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.p();
            tmp_0.te2_1 = tmp_1 + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
            if (fromInt_0(this.te2_1) > this.qe2_1.se0()) {
              var tmp2_safe_receiver = this.re2_1;
              if (tmp2_safe_receiver == null)
                null;
              else {
                tmp2_safe_receiver.zu();
              }
              this.f9_1 = 2;
              suspendResult = close_2(this.qe2_1, CloseReason_init_$Create$(Codes_TOO_BIG_getInstance(), 'Frame is too big: ' + this.te2_1 + '. Max size is ' + this.qe2_1.se0().toString()), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.f9_1 = 1;
              continue $sm;
            }

          case 1:
            return Unit_instance;
          case 2:
            throw new FrameTooBigException(fromInt_0(this.te2_1));
          case 3:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 3) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function DefaultWebSocketSessionImpl(raw, pingInterval, timeoutMillis) {
    Companion_getInstance_265();
    this.ue1_1 = raw;
    this.ve1_1 = atomic$ref$1(null);
    this.we1_1 = CompletableDeferred();
    this.xe1_1 = Channel(8);
    this.ye1_1 = Channel(get_OUTGOING_CHANNEL_CAPACITY());
    this.ze1_1 = atomic$boolean$1(false);
    this.ae2_1 = Job_0(this.ue1_1.ho().s9(Key_instance_3));
    var tmp = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp.be2_1 = ArrayList_init_$Create$();
    this.ce2_1 = atomic$boolean$1(false);
    this.de2_1 = this.ue1_1.ho().wi(this.ae2_1).wi(new CoroutineName('ws-default'));
    this.ee2_1 = pingInterval;
    this.fe2_1 = timeoutMillis;
    this.ge2_1 = this.we1_1;
  }
  protoOf(DefaultWebSocketSessionImpl).te0 = function () {
    return this.xe1_1;
  };
  protoOf(DefaultWebSocketSessionImpl).ue0 = function () {
    return this.ye1_1;
  };
  protoOf(DefaultWebSocketSessionImpl).ue2 = function () {
    return this.be2_1;
  };
  protoOf(DefaultWebSocketSessionImpl).ho = function () {
    return this.de2_1;
  };
  protoOf(DefaultWebSocketSessionImpl).re0 = function (value) {
    this.ue1_1.re0(value);
  };
  protoOf(DefaultWebSocketSessionImpl).se0 = function () {
    return this.ue1_1.se0();
  };
  protoOf(DefaultWebSocketSessionImpl).pe0 = function () {
    return this.ge2_1;
  };
  protoOf(DefaultWebSocketSessionImpl).qe0 = function (negotiatedExtensions) {
    if (!this.ce2_1.atomicfu$compareAndSet(false, true)) {
      // Inline function 'kotlin.error' call
      var message = 'WebSocket session ' + toString_1(this) + ' is already started.';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    get_LOGGER().fe0('Starting default WebSocketSession(' + toString_1(this) + ') ' + ('with negotiated extensions: ' + joinToString_0(negotiatedExtensions)));
    this.be2_1.q(negotiatedExtensions);
    runOrCancelPinger(this);
    runIncomingProcessor(this, ponger(this, this.ue0()));
    runOutgoingProcessor(this);
  };
  protoOf(DefaultWebSocketSessionImpl).we0 = function ($completion) {
    return this.ue1_1.we0($completion);
  };
  var properties_initialized_DefaultWebSocketSession_kt_6cjlhc;
  function _init_properties_DefaultWebSocketSession_kt__469s0y() {
    if (!properties_initialized_DefaultWebSocketSession_kt_6cjlhc) {
      properties_initialized_DefaultWebSocketSession_kt_6cjlhc = true;
      LOGGER = KtorSimpleLogger('io.ktor.websocket.WebSocket');
      IncomingProcessorCoroutineName = new CoroutineName('ws-incoming-processor');
      OutgoingProcessorCoroutineName = new CoroutineName('ws-outgoing-processor');
      NORMAL_CLOSE = CloseReason_init_$Create$(Codes_NORMAL_getInstance(), 'OK');
    }
  }
  function NonDisposableHandle_0() {
  }
  protoOf(NonDisposableHandle_0).zr = function () {
  };
  protoOf(NonDisposableHandle_0).toString = function () {
    return 'NonDisposableHandle';
  };
  var NonDisposableHandle_instance_0;
  function NonDisposableHandle_getInstance_0() {
    return NonDisposableHandle_instance_0;
  }
  function readReason(_this__u8e3s4) {
    if (_this__u8e3s4.ve3_1.length < 2) {
      return null;
    }
    var tmp$ret$2;
    $l$block: {
      // Inline function 'io.ktor.utils.io.core.buildPacket' call
      // Inline function 'kotlin.contracts.contract' call
      var builder = new BytePacketBuilder();
      try {
        writeFully_3(builder, _this__u8e3s4.ve3_1);
        tmp$ret$2 = builder.f40();
        break $l$block;
      } catch ($p) {
        if ($p instanceof Error) {
          var t = $p;
          builder.zu();
          throw t;
        } else {
          throw $p;
        }
      }
    }
    var packet = tmp$ret$2;
    var code = readShort_0(packet);
    var message = packet.ldq();
    return new CloseReason(code, message);
  }
  function FrameTooBigException(frameSize) {
    Exception_init_$Init$(this);
    captureStack(this, FrameTooBigException);
    this.ze4_1 = frameSize;
    delete this.message;
  }
  protoOf(FrameTooBigException).e = function () {
    return 'Frame is too big: ' + this.ze4_1.toString();
  };
  var FrameType_TEXT_instance;
  var FrameType_BINARY_instance;
  var FrameType_CLOSE_instance;
  var FrameType_PING_instance;
  var FrameType_PONG_instance;
  function Companion_266() {
    Companion_instance_266 = this;
    var tmp = this;
    var tmp0 = values_11();
    var tmp$ret$1;
    $l$block_0: {
      // Inline function 'kotlin.collections.maxByOrNull' call
      // Inline function 'kotlin.collections.isEmpty' call
      if (tmp0.length === 0) {
        tmp$ret$1 = null;
        break $l$block_0;
      }
      var maxElem = tmp0[0];
      var lastIndex = get_lastIndex_0(tmp0);
      if (lastIndex === 0) {
        tmp$ret$1 = maxElem;
        break $l$block_0;
      }
      var maxValue = maxElem.de5_1;
      var inductionVariable = 1;
      if (inductionVariable <= lastIndex)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var e = tmp0[i];
          var v = e.de5_1;
          if (compareTo_0(maxValue, v) < 0) {
            maxElem = e;
            maxValue = v;
          }
        }
         while (!(i === lastIndex));
      tmp$ret$1 = maxElem;
    }
    tmp.ee5_1 = ensureNotNull(tmp$ret$1).de5_1;
    var tmp_0 = this;
    var tmp_1 = 0;
    var tmp_2 = this.ee5_1 + 1 | 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_3 = Array(tmp_2);
    while (tmp_1 < tmp_2) {
      var tmp_4 = tmp_1;
      var tmp0_0 = values_11();
      var tmp$ret$6;
      $l$block_2: {
        // Inline function 'kotlin.collections.singleOrNull' call
        var single = null;
        var found = false;
        var inductionVariable_0 = 0;
        var last = tmp0_0.length;
        while (inductionVariable_0 < last) {
          var element = tmp0_0[inductionVariable_0];
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          if (element.de5_1 === tmp_4) {
            if (found) {
              tmp$ret$6 = null;
              break $l$block_2;
            }
            single = element;
            found = true;
          }
        }
        if (!found) {
          tmp$ret$6 = null;
          break $l$block_2;
        }
        tmp$ret$6 = single;
      }
      tmp_3[tmp_4] = tmp$ret$6;
      tmp_1 = tmp_1 + 1 | 0;
    }
    tmp_0.fe5_1 = tmp_3;
  }
  var Companion_instance_266;
  function Companion_getInstance_266() {
    FrameType_initEntries();
    if (Companion_instance_266 == null)
      new Companion_266();
    return Companion_instance_266;
  }
  function values_11() {
    return [FrameType_TEXT_getInstance(), FrameType_BINARY_getInstance(), FrameType_CLOSE_getInstance(), FrameType_PING_getInstance(), FrameType_PONG_getInstance()];
  }
  var FrameType_entriesInitialized;
  function FrameType_initEntries() {
    if (FrameType_entriesInitialized)
      return Unit_instance;
    FrameType_entriesInitialized = true;
    FrameType_TEXT_instance = new FrameType('TEXT', 0, false, 1);
    FrameType_BINARY_instance = new FrameType('BINARY', 1, false, 2);
    FrameType_CLOSE_instance = new FrameType('CLOSE', 2, true, 8);
    FrameType_PING_instance = new FrameType('PING', 3, true, 9);
    FrameType_PONG_instance = new FrameType('PONG', 4, true, 10);
    Companion_getInstance_266();
  }
  function FrameType(name, ordinal, controlFrame, opcode) {
    Enum.call(this, name, ordinal);
    this.ce5_1 = controlFrame;
    this.de5_1 = opcode;
  }
  function FrameType_TEXT_getInstance() {
    FrameType_initEntries();
    return FrameType_TEXT_instance;
  }
  function FrameType_BINARY_getInstance() {
    FrameType_initEntries();
    return FrameType_BINARY_instance;
  }
  function FrameType_CLOSE_getInstance() {
    FrameType_initEntries();
    return FrameType_CLOSE_instance;
  }
  function FrameType_PING_getInstance() {
    FrameType_initEntries();
    return FrameType_PING_instance;
  }
  function FrameType_PONG_getInstance() {
    FrameType_initEntries();
    return FrameType_PONG_instance;
  }
  function get_PongerCoroutineName() {
    _init_properties_PingPong_kt__9aqxey();
    return PongerCoroutineName;
  }
  var PongerCoroutineName;
  function get_PingerCoroutineName() {
    _init_properties_PingPong_kt__9aqxey();
    return PingerCoroutineName;
  }
  var PingerCoroutineName;
  function ponger(_this__u8e3s4, outgoing) {
    _init_properties_PingPong_kt__9aqxey();
    var channel = Channel(5);
    var tmp = get_PongerCoroutineName();
    launch(_this__u8e3s4, tmp, VOID, ponger$slambda_0(channel, outgoing, null));
    return channel;
  }
  function pinger(_this__u8e3s4, outgoing, periodMillis, timeoutMillis, onTimeout) {
    _init_properties_PingPong_kt__9aqxey();
    var actorJob = Job_0();
    var channel = Channel(2147483647);
    var tmp = actorJob.wi(get_PingerCoroutineName());
    launch(_this__u8e3s4, tmp, VOID, pinger$slambda_0(periodMillis, timeoutMillis, onTimeout, channel, outgoing, null));
    var tmp_0 = ensureNotNull(_this__u8e3s4.ho().s9(Key_instance_3));
    tmp_0.kp(pinger$lambda(actorJob));
    return channel;
  }
  function ponger$slambda($channel, $outgoing, resultContinuation) {
    this.oe5_1 = $channel;
    this.pe5_1 = $outgoing;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ponger$slambda).e1h = function ($this$launch, $completion) {
    var tmp = this.f1h($this$launch, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(ponger$slambda).v9 = function (p1, $completion) {
    return this.e1h((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ponger$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 14;
            this.g9_1 = 13;
            var tmp_0 = this;
            tmp_0.ue5_1 = this.oe5_1;
            this.f9_1 = 1;
            continue $sm;
          case 1:
            this.se5_1 = this.ue5_1;
            this.re5_1 = null;
            this.f9_1 = 2;
            continue $sm;
          case 2:
            this.f9_1 = 3;
            continue $sm;
          case 3:
            this.g9_1 = 10;
            this.g9_1 = 9;
            this.te5_1 = this.se5_1.m();
            this.f9_1 = 4;
            continue $sm;
          case 4:
            this.f9_1 = 5;
            suspendResult = this.te5_1.d14(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 5:
            if (!suspendResult) {
              this.f9_1 = 7;
              continue $sm;
            }

            var e = this.te5_1.o();
            get_LOGGER().fe0('Received ping message, sending pong message');
            this.f9_1 = 6;
            suspendResult = this.pe5_1.z15(new Pong(e.ve3_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 6:
            this.f9_1 = 4;
            continue $sm;
          case 7:
            this.f9_1 = 8;
            continue $sm;
          case 8:
            this.g9_1 = 13;
            cancelConsumed(this.se5_1, this.re5_1);
            this.f9_1 = 12;
            continue $sm;
          case 9:
            this.g9_1 = 10;
            var tmp_1 = this.i9_1;
            if (tmp_1 instanceof Error) {
              var e_0 = this.i9_1;
              this.re5_1 = e_0;
              throw e_0;
            } else {
              throw this.i9_1;
            }

          case 10:
            this.g9_1 = 13;
            var t = this.i9_1;
            cancelConsumed(this.se5_1, this.re5_1);
            throw t;
          case 11:
            this.g9_1 = 13;
            cancelConsumed(this.se5_1, this.re5_1);
            if (false) {
              this.f9_1 = 1;
              continue $sm;
            }

            this.f9_1 = 12;
            continue $sm;
          case 12:
            this.g9_1 = 14;
            this.f9_1 = 15;
            continue $sm;
          case 13:
            this.g9_1 = 14;
            var tmp_2 = this.i9_1;
            if (tmp_2 instanceof ClosedSendChannelException) {
              var _ = this.i9_1;
              this.f9_1 = 15;
              continue $sm;
            } else {
              throw this.i9_1;
            }

          case 14:
            throw this.i9_1;
          case 15:
            this.g9_1 = 14;
            return Unit_instance;
        }
      } catch ($p) {
        var e_1 = $p;
        if (this.g9_1 === 14) {
          throw e_1;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e_1;
        }
      }
     while (true);
  };
  protoOf(ponger$slambda).f1h = function ($this$launch, completion) {
    var i = new ponger$slambda(this.oe5_1, this.pe5_1, completion);
    i.qe5_1 = $this$launch;
    return i;
  };
  function ponger$slambda_0($channel, $outgoing, resultContinuation) {
    var i = new ponger$slambda($channel, $outgoing, resultContinuation);
    var l = function ($this$launch, $completion) {
      return i.e1h($this$launch, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function pinger$slambda$slambda($channel, resultContinuation) {
    this.de6_1 = $channel;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(pinger$slambda$slambda).e1h = function ($this$withTimeoutOrNull, $completion) {
    var tmp = this.f1h($this$withTimeoutOrNull, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(pinger$slambda$slambda).v9 = function (p1, $completion) {
    return this.e1h((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(pinger$slambda$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 3;
            this.f9_1 = 1;
            continue $sm;
          case 1:
            if (!true) {
              this.f9_1 = 4;
              continue $sm;
            }

            this.f9_1 = 2;
            suspendResult = this.de6_1.d16(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.f9_1 = 1;
            continue $sm;
          case 3:
            throw this.i9_1;
          case 4:
            return Unit_instance;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 3) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(pinger$slambda$slambda).f1h = function ($this$withTimeoutOrNull, completion) {
    var i = new pinger$slambda$slambda(this.de6_1, completion);
    i.ee6_1 = $this$withTimeoutOrNull;
    return i;
  };
  function pinger$slambda$slambda_0($channel, resultContinuation) {
    var i = new pinger$slambda$slambda($channel, resultContinuation);
    var l = function ($this$withTimeoutOrNull, $completion) {
      return i.e1h($this$withTimeoutOrNull, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function pinger$slambda$slambda_1($outgoing, $pingMessage, $channel, resultContinuation) {
    this.ne6_1 = $outgoing;
    this.oe6_1 = $pingMessage;
    this.pe6_1 = $channel;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(pinger$slambda$slambda_1).e1h = function ($this$withTimeoutOrNull, $completion) {
    var tmp = this.f1h($this$withTimeoutOrNull, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(pinger$slambda$slambda_1).v9 = function (p1, $completion) {
    return this.e1h((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(pinger$slambda$slambda_1).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 6;
            get_LOGGER().fe0('WebSocket Pinger: sending ping frame');
            this.f9_1 = 1;
            var tmp0 = this.oe6_1;
            var tmp2 = Charsets_getInstance().vdq_1;
            var tmp$ret$0;
            l$ret$1: do {
              if (tmp2.equals(Charsets_getInstance().udq_1)) {
                tmp$ret$0 = encodeToByteArray(tmp0);
                break l$ret$1;
              }
              tmp$ret$0 = encodeToByteArray_0(tmp2.ydq(), tmp0, 0, tmp0.length);
            }
             while (false);
            suspendResult = this.ne6_1.z15(new Ping(tmp$ret$0), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.f9_1 = 2;
            continue $sm;
          case 2:
            if (!true) {
              this.f9_1 = 5;
              continue $sm;
            }

            this.f9_1 = 3;
            suspendResult = this.pe6_1.d16(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            this.re6_1 = suspendResult;
            if (String_0(this.re6_1.ve3_1, VOID, VOID, Charsets_getInstance().vdq_1) === this.oe6_1) {
              get_LOGGER().fe0('WebSocket Pinger: received valid pong frame ' + this.re6_1.toString());
              this.f9_1 = 5;
              continue $sm;
            } else {
              this.f9_1 = 4;
              continue $sm;
            }

          case 4:
            get_LOGGER().fe0('WebSocket Pinger: received invalid pong frame ' + this.re6_1.toString() + ', continue waiting');
            this.f9_1 = 2;
            continue $sm;
          case 5:
            return Unit_instance;
          case 6:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 6) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(pinger$slambda$slambda_1).f1h = function ($this$withTimeoutOrNull, completion) {
    var i = new pinger$slambda$slambda_1(this.ne6_1, this.oe6_1, this.pe6_1, completion);
    i.qe6_1 = $this$withTimeoutOrNull;
    return i;
  };
  function pinger$slambda$slambda_2($outgoing, $pingMessage, $channel, resultContinuation) {
    var i = new pinger$slambda$slambda_1($outgoing, $pingMessage, $channel, resultContinuation);
    var l = function ($this$withTimeoutOrNull, $completion) {
      return i.e1h($this$withTimeoutOrNull, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function pinger$slambda($periodMillis, $timeoutMillis, $onTimeout, $channel, $outgoing, resultContinuation) {
    this.ae7_1 = $periodMillis;
    this.be7_1 = $timeoutMillis;
    this.ce7_1 = $onTimeout;
    this.de7_1 = $channel;
    this.ee7_1 = $outgoing;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(pinger$slambda).e1h = function ($this$launch, $completion) {
    var tmp = this.f1h($this$launch, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(pinger$slambda).v9 = function (p1, $completion) {
    return this.e1h((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(pinger$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 9;
            get_LOGGER().fe0('Starting WebSocket pinger coroutine with period ' + this.ae7_1.toString() + ' ms and timeout ' + this.be7_1.toString() + ' ms');
            this.he7_1 = Random_1(getTimeMillis());
            this.ge7_1 = new Int8Array(32);
            this.g9_1 = 7;
            this.f9_1 = 1;
            continue $sm;
          case 1:
            if (!true) {
              this.f9_1 = 6;
              continue $sm;
            }

            this.f9_1 = 2;
            suspendResult = withTimeoutOrNull(this.ae7_1, pinger$slambda$slambda_0(this.de7_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.he7_1.ij(this.ge7_1);
            var pingMessage = '[ping ' + hex(this.ge7_1) + ' ping]';
            this.f9_1 = 3;
            suspendResult = withTimeoutOrNull(this.be7_1, pinger$slambda$slambda_2(this.ee7_1, pingMessage, this.de7_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            var rc = suspendResult;
            if (rc == null) {
              get_LOGGER().fe0('WebSocket pinger has timed out');
              this.f9_1 = 5;
              suspendResult = this.ce7_1(CloseReason_init_$Create$(Codes_INTERNAL_ERROR_getInstance(), 'Ping timeout'), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.f9_1 = 4;
              continue $sm;
            }

          case 4:
            this.f9_1 = 1;
            continue $sm;
          case 5:
            this.f9_1 = 6;
            continue $sm;
          case 6:
            this.g9_1 = 9;
            this.f9_1 = 8;
            continue $sm;
          case 7:
            this.g9_1 = 9;
            var tmp_0 = this.i9_1;
            if (tmp_0 instanceof CancellationException) {
              var ignore = this.i9_1;
              this.f9_1 = 8;
              continue $sm;
            } else {
              var tmp_1 = this.i9_1;
              if (tmp_1 instanceof ClosedReceiveChannelException) {
                var ignore_0 = this.i9_1;
                this.f9_1 = 8;
                continue $sm;
              } else {
                var tmp_2 = this.i9_1;
                if (tmp_2 instanceof ClosedSendChannelException) {
                  var ignore_1 = this.i9_1;
                  this.f9_1 = 8;
                  continue $sm;
                } else {
                  throw this.i9_1;
                }
              }
            }

          case 8:
            this.g9_1 = 9;
            return Unit_instance;
          case 9:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 9) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(pinger$slambda).f1h = function ($this$launch, completion) {
    var i = new pinger$slambda(this.ae7_1, this.be7_1, this.ce7_1, this.de7_1, this.ee7_1, completion);
    i.fe7_1 = $this$launch;
    return i;
  };
  function pinger$slambda_0($periodMillis, $timeoutMillis, $onTimeout, $channel, $outgoing, resultContinuation) {
    var i = new pinger$slambda($periodMillis, $timeoutMillis, $onTimeout, $channel, $outgoing, resultContinuation);
    var l = function ($this$launch, $completion) {
      return i.e1h($this$launch, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function pinger$lambda($actorJob) {
    return function (it) {
      $actorJob.sp();
      return Unit_instance;
    };
  }
  var properties_initialized_PingPong_kt_fbfhmc;
  function _init_properties_PingPong_kt__9aqxey() {
    if (!properties_initialized_PingPong_kt_fbfhmc) {
      properties_initialized_PingPong_kt_fbfhmc = true;
      PongerCoroutineName = new CoroutineName('ws-ponger');
      PingerCoroutineName = new CoroutineName('ws-pinger');
    }
  }
  function WebSocketExtensionsConfig() {
    var tmp = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp.ie7_1 = ArrayList_init_$Create$();
    var tmp_0 = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_0.je7_1 = [false, false, false];
  }
  protoOf(WebSocketExtensionsConfig).f40 = function () {
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.ie7_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.m();
    while (_iterator__ex2g4s.n()) {
      var item = _iterator__ex2g4s.o();
      var tmp$ret$0 = item();
      destination.j(tmp$ret$0);
    }
    return destination;
  };
  function parametersToString($this) {
    return $this.le7_1.s() ? '' : ', ' + joinToString_0($this.le7_1, ',');
  }
  function WebSocketExtensionHeader(name, parameters) {
    this.ke7_1 = name;
    this.le7_1 = parameters;
  }
  protoOf(WebSocketExtensionHeader).toString = function () {
    return this.ke7_1 + ' ' + parametersToString(this);
  };
  function parseWebSocketExtensions(value) {
    // Inline function 'kotlin.collections.map' call
    var this_0 = split_0(value, [',']);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.m();
    while (_iterator__ex2g4s.n()) {
      var item = _iterator__ex2g4s.o();
      var extension = split_0(item, [';']);
      // Inline function 'kotlin.text.trim' call
      var this_1 = first(extension);
      var name = toString_1(trim(isCharSequence(this_1) ? this_1 : THROW_CCE()));
      // Inline function 'kotlin.collections.map' call
      var this_2 = drop(extension, 1);
      // Inline function 'kotlin.collections.mapTo' call
      var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_2, 10));
      var _iterator__ex2g4s_0 = this_2.m();
      while (_iterator__ex2g4s_0.n()) {
        var item_0 = _iterator__ex2g4s_0.o();
        // Inline function 'kotlin.text.trim' call
        var tmp$ret$2 = toString_1(trim(isCharSequence(item_0) ? item_0 : THROW_CCE()));
        destination_0.j(tmp$ret$2);
      }
      var parameters = destination_0;
      var tmp$ret$5 = new WebSocketExtensionHeader(name, parameters);
      destination.j(tmp$ret$5);
    }
    return destination;
  }
  function close_2(_this__u8e3s4, reason, $completion) {
    reason = reason === VOID ? CloseReason_init_$Create$(Codes_NORMAL_getInstance(), '') : reason;
    var tmp = new $closeCOROUTINE$(_this__u8e3s4, reason, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  }
  function WebSocketSession() {
  }
  function closeExceptionally(_this__u8e3s4, cause, $completion) {
    var tmp;
    if (cause instanceof CancellationException) {
      tmp = CloseReason_init_$Create$(Codes_NORMAL_getInstance(), '');
    } else {
      tmp = CloseReason_init_$Create$(Codes_INTERNAL_ERROR_getInstance(), cause.toString());
    }
    var reason = tmp;
    return close_2(_this__u8e3s4, reason, $completion);
  }
  function $closeCOROUTINE$(_this__u8e3s4, reason, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.ue7_1 = _this__u8e3s4;
    this.ve7_1 = reason;
  }
  protoOf($closeCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 4;
            this.g9_1 = 3;
            this.f9_1 = 1;
            suspendResult = this.ue7_1.ve0(Close_init_$Create$(this.ve7_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.f9_1 = 2;
            suspendResult = this.ue7_1.we0(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.g9_1 = 4;
            this.f9_1 = 5;
            continue $sm;
          case 3:
            this.g9_1 = 4;
            var tmp_0 = this.i9_1;
            if (tmp_0 instanceof Error) {
              var _ = this.i9_1;
              this.f9_1 = 5;
              continue $sm;
            } else {
              throw this.i9_1;
            }

          case 4:
            throw this.i9_1;
          case 5:
            this.g9_1 = 4;
            return Unit_instance;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 4) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function Binary_init_$Init$(fin, data, $this) {
    Binary.call($this, fin, data, false, false, false);
    return $this;
  }
  function Binary_init_$Create$(fin, data) {
    return Binary_init_$Init$(fin, data, objectCreate(protoOf(Binary)));
  }
  function Text_init_$Init$(fin, data, $this) {
    Text.call($this, fin, data, false, false, false);
    return $this;
  }
  function Text_init_$Init$_0(text, $this) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'io.ktor.utils.io.core.toByteArray' call
      var charset = Charsets_getInstance().udq_1;
      if (charset.equals(Charsets_getInstance().udq_1)) {
        tmp$ret$0 = encodeToByteArray(text);
        break $l$block;
      }
      tmp$ret$0 = encodeToByteArray_0(charset.ydq(), text, 0, text.length);
    }
    Text_init_$Init$(true, tmp$ret$0, $this);
    return $this;
  }
  function Text_init_$Create$(text) {
    return Text_init_$Init$_0(text, objectCreate(protoOf(Text)));
  }
  function Close_init_$Init$(reason, $this) {
    var tmp$ret$2;
    $l$block: {
      // Inline function 'io.ktor.utils.io.core.buildPacket' call
      // Inline function 'kotlin.contracts.contract' call
      var builder = new BytePacketBuilder();
      try {
        writeShort_0(builder, reason.me0_1);
        writeText(builder, reason.ne0_1);
        tmp$ret$2 = builder.f40();
        break $l$block;
      } catch ($p) {
        if ($p instanceof Error) {
          var t = $p;
          builder.zu();
          throw t;
        } else {
          throw $p;
        }
      }
    }
    Close_init_$Init$_0(tmp$ret$2, $this);
    return $this;
  }
  function Close_init_$Create$(reason) {
    return Close_init_$Init$(reason, objectCreate(protoOf(Close)));
  }
  function Close_init_$Init$_0(packet, $this) {
    Close.call($this, readBytes(packet));
    return $this;
  }
  function Close_init_$Init$_1($this) {
    Close.call($this, Companion_getInstance_267().ae4_1);
    return $this;
  }
  function Close_init_$Create$_0() {
    return Close_init_$Init$_1(objectCreate(protoOf(Close)));
  }
  function Binary(fin, data, rsv1, rsv2, rsv3) {
    rsv1 = rsv1 === VOID ? false : rsv1;
    rsv2 = rsv2 === VOID ? false : rsv2;
    rsv3 = rsv3 === VOID ? false : rsv3;
    Frame.call(this, fin, FrameType_BINARY_getInstance(), data, NonDisposableHandle_instance_0, rsv1, rsv2, rsv3);
  }
  function Text(fin, data, rsv1, rsv2, rsv3) {
    rsv1 = rsv1 === VOID ? false : rsv1;
    rsv2 = rsv2 === VOID ? false : rsv2;
    rsv3 = rsv3 === VOID ? false : rsv3;
    Frame.call(this, fin, FrameType_TEXT_getInstance(), data, NonDisposableHandle_instance_0, rsv1, rsv2, rsv3);
  }
  function Close(data) {
    Frame.call(this, true, FrameType_CLOSE_getInstance(), data, NonDisposableHandle_instance_0, false, false, false);
  }
  function Ping(data) {
    Frame.call(this, true, FrameType_PING_getInstance(), data, NonDisposableHandle_instance_0, false, false, false);
  }
  function Pong(data, disposableHandle) {
    disposableHandle = disposableHandle === VOID ? NonDisposableHandle_instance_0 : disposableHandle;
    Frame.call(this, true, FrameType_PONG_getInstance(), data, disposableHandle, false, false, false);
  }
  function Companion_267() {
    Companion_instance_267 = this;
    this.ae4_1 = new Int8Array(0);
  }
  protoOf(Companion_267).be4 = function (fin, frameType, data, rsv1, rsv2, rsv3) {
    var tmp;
    switch (frameType.x2_1) {
      case 1:
        tmp = new Binary(fin, data, rsv1, rsv2, rsv3);
        break;
      case 0:
        tmp = new Text(fin, data, rsv1, rsv2, rsv3);
        break;
      case 2:
        tmp = new Close(data);
        break;
      case 3:
        tmp = new Ping(data);
        break;
      case 4:
        tmp = new Pong(data, NonDisposableHandle_instance_0);
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  };
  var Companion_instance_267;
  function Companion_getInstance_267() {
    if (Companion_instance_267 == null)
      new Companion_267();
    return Companion_instance_267;
  }
  function Frame(fin, frameType, data, disposableHandle, rsv1, rsv2, rsv3) {
    Companion_getInstance_267();
    disposableHandle = disposableHandle === VOID ? NonDisposableHandle_instance_0 : disposableHandle;
    rsv1 = rsv1 === VOID ? false : rsv1;
    rsv2 = rsv2 === VOID ? false : rsv2;
    rsv3 = rsv3 === VOID ? false : rsv3;
    this.te3_1 = fin;
    this.ue3_1 = frameType;
    this.ve3_1 = data;
    this.we3_1 = disposableHandle;
    this.xe3_1 = rsv1;
    this.ye3_1 = rsv2;
    this.ze3_1 = rsv3;
  }
  protoOf(Frame).toString = function () {
    return 'Frame ' + this.ue3_1.toString() + ' (fin=' + this.te3_1 + ', buffer len = ' + this.ve3_1.length + ')';
  };
  function get_OUTGOING_CHANNEL_CAPACITY() {
    return 8;
  }
  function Default_2() {
    Default_instance_1 = this;
    ProtoBuf.call(this, false, EmptySerializersModule_0());
  }
  var Default_instance_1;
  function Default_getInstance_1() {
    if (Default_instance_1 == null)
      new Default_2();
    return Default_instance_1;
  }
  function ProtoBuf(encodeDefaults, serializersModule) {
    Default_getInstance_1();
    this.we7_1 = encodeDefaults;
    this.xe7_1 = serializersModule;
  }
  protoOf(ProtoBuf).g59 = function () {
    return this.xe7_1;
  };
  protoOf(ProtoBuf).a5a = function (serializer, value) {
    var output = new ByteArrayOutput();
    var encoder = new ProtobufEncoder(this, new ProtobufWriter(output), serializer.v58());
    encoder.h59(serializer, value);
    return output.ge8();
  };
  protoOf(ProtoBuf).b5a = function (deserializer, bytes) {
    var input = new ByteArrayInput(bytes);
    var decoder = new ProtobufDecoder(this, new ProtobufReader(input), deserializer.v58());
    return decoder.k59(deserializer);
  };
  function ProtoBuf_0(from, builderAction) {
    from = from === VOID ? Default_getInstance_1() : from;
    var b = new ProtoBufBuilder(from);
    builderAction(b);
    return new ProtoBufImpl(b.qe8_1, b.re8_1);
  }
  function ProtoBufBuilder(proto) {
    this.qe8_1 = proto.we7_1;
    this.re8_1 = proto.g59();
  }
  function ProtoBufImpl(encodeDefaults, serializersModule) {
    ProtoBuf.call(this, encodeDefaults, serializersModule);
  }
  var ProtoIntegerType_DEFAULT_instance;
  var ProtoIntegerType_SIGNED_instance;
  var ProtoIntegerType_FIXED_instance;
  var ProtoIntegerType_entriesInitialized;
  function ProtoIntegerType_initEntries() {
    if (ProtoIntegerType_entriesInitialized)
      return Unit_instance;
    ProtoIntegerType_entriesInitialized = true;
    ProtoIntegerType_DEFAULT_instance = new ProtoIntegerType('DEFAULT', 0, 0n);
    ProtoIntegerType_SIGNED_instance = new ProtoIntegerType('SIGNED', 1, 8589934592n);
    ProtoIntegerType_FIXED_instance = new ProtoIntegerType('FIXED', 2, 17179869184n);
  }
  function ProtoIntegerType(name, ordinal, signature) {
    Enum.call(this, name, ordinal);
    this.ue8_1 = signature;
  }
  function ProtoNumber() {
  }
  function ProtoType() {
  }
  function ProtoPacked() {
  }
  function ProtoIntegerType_DEFAULT_getInstance() {
    ProtoIntegerType_initEntries();
    return ProtoIntegerType_DEFAULT_instance;
  }
  function ProtoIntegerType_SIGNED_getInstance() {
    ProtoIntegerType_initEntries();
    return ProtoIntegerType_SIGNED_instance;
  }
  function ProtoIntegerType_FIXED_getInstance() {
    ProtoIntegerType_initEntries();
    return ProtoIntegerType_FIXED_instance;
  }
  function extractProtoId(descriptor, index, zeroBasedDefault) {
    var annotations = descriptor.s5a(index);
    var inductionVariable = 0;
    var last = annotations.p() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var annotation = annotations.r(i);
        if (annotation instanceof ProtoNumber) {
          return annotation.ve8_1;
        }
      }
       while (inductionVariable <= last);
    return zeroBasedDefault ? index : index + 1 | 0;
  }
  function ProtobufDecodingException(message) {
    SerializationException_init_$Init$_0(message, this);
    captureStack(this, ProtobufDecodingException);
  }
  function get_isPackable(_this__u8e3s4) {
    var tmp0_subject = _this__u8e3s4.r5a();
    var tmp;
    var tmp_0;
    if (equals(tmp0_subject, STRING_getInstance())) {
      tmp_0 = true;
    } else {
      tmp_0 = !(tmp0_subject instanceof PrimitiveKind);
    }
    if (tmp_0) {
      tmp = false;
    } else {
      tmp = true;
    }
    return tmp;
  }
  function get_integerType(_this__u8e3s4) {
    var tmp0_subject = _this__u8e3s4 & 9223372028264841216n;
    return tmp0_subject === ProtoIntegerType_DEFAULT_getInstance().ue8_1 ? ProtoIntegerType_DEFAULT_getInstance() : tmp0_subject === ProtoIntegerType_SIGNED_getInstance().ue8_1 ? ProtoIntegerType_SIGNED_getInstance() : ProtoIntegerType_FIXED_getInstance();
  }
  function extractParameters(_this__u8e3s4, index) {
    var annotations = _this__u8e3s4.s5a(index);
    var protoId = index + 1 | 0;
    var format = ProtoIntegerType_DEFAULT_getInstance();
    var protoPacked = false;
    var inductionVariable = 0;
    var last = annotations.p() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var annotation = annotations.r(i);
        if (annotation instanceof ProtoNumber) {
          protoId = annotation.ve8_1;
        } else {
          if (annotation instanceof ProtoType) {
            format = annotation.we8_1;
          } else {
            if (annotation instanceof ProtoPacked) {
              protoPacked = true;
            }
          }
        }
      }
       while (inductionVariable <= last);
    var tmp0 = protoId;
    // Inline function 'kotlinx.serialization.protobuf.internal.ProtoDesc' call
    var packedBits = protoPacked ? 4294967296n : 0n;
    var signature = format.ue8_1 | packedBits;
    return signature | fromInt_0(tmp0);
  }
  function get_isPacked(_this__u8e3s4) {
    return !((_this__u8e3s4 & 4294967296n) === 0n);
  }
  function PackedArrayDecoder(proto, reader, descriptor) {
    ProtobufDecoder.call(this, proto, reader, descriptor);
    this.ge9_1 = 0;
  }
  protoOf(PackedArrayDecoder).d5q = function (_this__u8e3s4, index) {
    return 19500n;
  };
  protoOf(PackedArrayDecoder).g5c = function (descriptor) {
    throw SerializationException_init_$Create$_0('Packing only supports primitive number types. The input type however was a struct: ' + toString_1(descriptor));
  };
  protoOf(PackedArrayDecoder).w5c = function (descriptor) {
    if (this.ke8_1.me9())
      return -1;
    var tmp1 = this.ge9_1;
    this.ge9_1 = tmp1 + 1 | 0;
    return tmp1;
  };
  protoOf(PackedArrayDecoder).ne9 = function (tag) {
    throw SerializationException_init_$Create$_0('Packing only supports primitive number types. The actual reading is for string.');
  };
  function PackedArrayEncoder(proto, writer, curTag, descriptor, stream) {
    stream = stream === VOID ? new ByteArrayOutput() : stream;
    NestedRepeatedEncoder.call(this, proto, writer, curTag, descriptor, stream);
  }
  protoOf(PackedArrayEncoder).d5q = function (_this__u8e3s4, index) {
    return 19500n;
  };
  protoOf(PackedArrayEncoder).a5e = function (descriptor, collectionSize) {
    throw SerializationException_init_$Create$_0('Packing only supports primitive number types');
  };
  protoOf(PackedArrayEncoder).g5c = function (descriptor) {
    throw SerializationException_init_$Create$_0('Packing only supports primitive number types');
  };
  protoOf(PackedArrayEncoder).pea = function (tag, value) {
    throw SerializationException_init_$Create$_0('Packing only supports primitive number types');
  };
  function populateCacheMap($this, descriptor, elements) {
    var map = HashMap_init_$Create$_0(elements);
    var inductionVariable = 0;
    if (inductionVariable < elements)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlin.collections.set' call
        var key = extractProtoId(descriptor, i, false);
        map.t2(key, i);
      }
       while (inductionVariable < elements);
    $this.ne8_1 = map;
  }
  function getIndexByTag($this, protoTag) {
    var array = $this.me8_1;
    if (!(array == null)) {
      // Inline function 'kotlin.collections.getOrElse' call
      var tmp;
      if (0 <= protoTag ? protoTag <= (array.length - 1 | 0) : false) {
        tmp = array[protoTag];
      } else {
        tmp = -1;
      }
      return tmp;
    }
    return getIndexByTagSlowPath($this, protoTag);
  }
  function getIndexByTagSlowPath($this, protoTag) {
    // Inline function 'kotlin.collections.getOrElse' call
    var tmp0_elvis_lhs = ensureNotNull($this.ne8_1).q2(protoTag);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      tmp = -1;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function findIndexByTag($this, descriptor, protoTag) {
    if (protoTag < descriptor.p5a()) {
      var protoId = extractProtoId(descriptor, protoTag, true);
      if (protoId === protoTag)
        return protoTag;
    }
    return findIndexByTagSlowPath($this, descriptor, protoTag);
  }
  function findIndexByTagSlowPath($this, desc, protoTag) {
    var inductionVariable = 0;
    var last = desc.p5a();
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var protoId = extractProtoId(desc, i, true);
        if (protoId === protoTag)
          return i;
      }
       while (inductionVariable < last);
    throw new ProtobufDecodingException('' + protoTag + ' is not among valid ' + $this.le8_1.z59() + ' enum proto numbers');
  }
  function deserializeByteArray($this, previousValue) {
    var tag = $this.dea();
    var tmp;
    if (tag === 19500n) {
      tmp = $this.ke8_1.neb();
    } else {
      tmp = $this.ke8_1.meb();
    }
    var array = tmp;
    var tmp_0;
    if (previousValue == null) {
      tmp_0 = array;
    } else {
      // Inline function 'kotlin.collections.plus' call
      tmp_0 = primitiveArrayConcat([previousValue, array]);
    }
    return tmp_0;
  }
  function deserializeMap($this, deserializer, previousValue) {
    var serializer = deserializer instanceof MapLikeSerializer ? deserializer : THROW_CCE();
    var mapEntrySerial = MapEntrySerializer(serializer.w5f_1, serializer.x5f_1);
    var tmp0_safe_receiver = (!(previousValue == null) ? isInterface(previousValue, KtMap) : false) ? previousValue : null;
    var oldSet = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.y();
    var setOfEntries = (new LinkedHashSetSerializer(mapEntrySerial)).v5f($this, oldSet);
    // Inline function 'kotlin.collections.associateBy' call
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(setOfEntries, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap_init_$Create$_0(capacity);
    var _iterator__ex2g4s = setOfEntries.m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      var tmp = element.z();
      var tmp$ret$1 = element.a1();
      destination.t2(tmp, tmp$ret$1);
    }
    var tmp_0 = destination;
    return !(tmp_0 == null) ? tmp_0 : THROW_CCE();
  }
  function readIfAbsent_0($this, descriptor, index) {
    if (!descriptor.w5a(index)) {
      var elementDescriptor = descriptor.t5a(index);
      var kind = elementDescriptor.r5a();
      if (equals(kind, MAP_getInstance()) || equals(kind, LIST_getInstance())) {
        $this.oe8_1 = false;
        return true;
      } else if (elementDescriptor.i5a()) {
        $this.oe8_1 = true;
        return true;
      }
    }
    return false;
  }
  function ProtobufDecoder$readIfAbsent$ref(p0) {
    var l = function (_this__u8e3s4, p0_0) {
      var tmp0 = p0;
      return readIfAbsent_0(tmp0, _this__u8e3s4, p0_0);
    };
    l.callableName = 'readIfAbsent';
    return l;
  }
  function ProtobufDecoder(proto, reader, descriptor) {
    ProtobufTaggedDecoder.call(this);
    this.je8_1 = proto;
    this.ke8_1 = reader;
    this.le8_1 = descriptor;
    this.me8_1 = null;
    this.ne8_1 = null;
    this.oe8_1 = false;
    var tmp = this;
    tmp.pe8_1 = new ElementMarker(this.le8_1, ProtobufDecoder$readIfAbsent$ref(this));
    this.oe9(this.le8_1);
  }
  protoOf(ProtobufDecoder).g59 = function () {
    return this.je8_1.g59();
  };
  protoOf(ProtobufDecoder).oe9 = function (descriptor) {
    var elements = descriptor.p5a();
    if (elements < 32) {
      var cache = new Int32Array(elements + 1 | 0);
      var inductionVariable = 0;
      if (inductionVariable < elements)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var protoId = extractProtoId(descriptor, i, false);
          if (protoId <= elements) {
            cache[protoId] = i;
          } else {
            return populateCacheMap(this, descriptor, elements);
          }
        }
         while (inductionVariable < elements);
      this.me8_1 = cache;
    } else {
      populateCacheMap(this, descriptor, elements);
    }
  };
  protoOf(ProtobufDecoder).g5c = function (descriptor) {
    var tmp0_subject = descriptor.r5a();
    var tmp;
    if (equals(tmp0_subject, LIST_getInstance())) {
      var tag = this.dea();
      var tmp_0;
      if (equals(this.le8_1.r5a(), LIST_getInstance()) && !(tag === 19500n) && !equals(this.le8_1, descriptor)) {
        var reader = makeDelimited(this.ke8_1, tag);
        reader.peb();
        // Inline function 'kotlinx.serialization.protobuf.internal.ProtoDesc' call
        var tmp$ret$0 = ProtoIntegerType_DEFAULT_getInstance().ue8_1 | fromInt_0(1);
        tmp_0 = new RepeatedDecoder(this.je8_1, reader, tmp$ret$0, descriptor);
      } else if (this.ke8_1.je9_1 === 2 && get_isPackable(descriptor.t5a(0))) {
        var sliceReader = new ProtobufReader(this.ke8_1.oeb());
        tmp_0 = new PackedArrayDecoder(this.je8_1, sliceReader, descriptor);
      } else {
        tmp_0 = new RepeatedDecoder(this.je8_1, this.ke8_1, tag, descriptor);
      }
      return tmp_0;
    } else {
      var tmp_1;
      if (equals(tmp0_subject, CLASS_getInstance()) ? true : equals(tmp0_subject, OBJECT_getInstance())) {
        tmp_1 = true;
      } else {
        tmp_1 = tmp0_subject instanceof PolymorphicKind;
      }
      if (tmp_1) {
        var tag_0 = this.dea();
        if (tag_0 === 19500n && equals(this.le8_1, descriptor))
          return this;
        return new ProtobufDecoder(this.je8_1, makeDelimited(this.ke8_1, tag_0), descriptor);
      } else {
        if (equals(tmp0_subject, MAP_getInstance())) {
          tmp = new MapEntryReader(this.je8_1, makeDelimitedForced(this.ke8_1, this.dea()), this.dea(), descriptor);
        } else {
          throw SerializationException_init_$Create$_0('Primitives are not supported at top-level');
        }
      }
    }
    return tmp;
  };
  protoOf(ProtobufDecoder).h5c = function (descriptor) {
  };
  protoOf(ProtobufDecoder).pe9 = function (tag) {
    var value = this.se9(tag);
    var tmp;
    switch (value) {
      case 0:
        tmp = false;
        break;
      case 1:
        tmp = true;
        break;
      default:
        throw SerializationException_init_$Create$_0('Unexpected boolean value: ' + value);
    }
    return tmp;
  };
  protoOf(ProtobufDecoder).qe9 = function (tag) {
    return toByte(this.se9(tag));
  };
  protoOf(ProtobufDecoder).re9 = function (tag) {
    return toShort(this.se9(tag));
  };
  protoOf(ProtobufDecoder).se9 = function (tag) {
    var tmp;
    if (tag === 19500n) {
      tmp = this.ke8_1.reb();
    } else {
      tmp = this.ke8_1.qeb(get_integerType(tag));
    }
    return tmp;
  };
  protoOf(ProtobufDecoder).te9 = function (tag) {
    var tmp;
    if (tag === 19500n) {
      tmp = this.ke8_1.teb();
    } else {
      tmp = this.ke8_1.seb(get_integerType(tag));
    }
    return tmp;
  };
  protoOf(ProtobufDecoder).ue9 = function (tag) {
    var tmp;
    if (tag === 19500n) {
      tmp = this.ke8_1.veb();
    } else {
      tmp = this.ke8_1.ueb();
    }
    return tmp;
  };
  protoOf(ProtobufDecoder).ve9 = function (tag) {
    var tmp;
    if (tag === 19500n) {
      tmp = this.ke8_1.xeb();
    } else {
      tmp = this.ke8_1.web();
    }
    return tmp;
  };
  protoOf(ProtobufDecoder).we9 = function (tag) {
    return numberToChar(this.se9(tag));
  };
  protoOf(ProtobufDecoder).ne9 = function (tag) {
    var tmp;
    if (tag === 19500n) {
      tmp = this.ke8_1.yeb();
    } else {
      tmp = this.ke8_1.o2j();
    }
    return tmp;
  };
  protoOf(ProtobufDecoder).xe9 = function (tag, enumDescription) {
    return findIndexByTag(this, enumDescription, this.se9(tag));
  };
  protoOf(ProtobufDecoder).k59 = function (deserializer) {
    return this.f5c(deserializer, null);
  };
  protoOf(ProtobufDecoder).f5c = function (deserializer, previousValue) {
    var tmp;
    if (deserializer instanceof MapLikeSerializer) {
      tmp = deserializeMap(this, isInterface(deserializer, DeserializationStrategy) ? deserializer : THROW_CCE(), previousValue);
    } else {
      if (equals(deserializer.v58(), ByteArraySerializer().v58())) {
        var tmp_0 = deserializeByteArray(this, (previousValue == null ? true : isByteArray(previousValue)) ? previousValue : THROW_CCE());
        tmp = !(tmp_0 == null) ? tmp_0 : THROW_CCE();
      } else {
        if (deserializer instanceof AbstractCollectionSerializer) {
          tmp = (deserializer instanceof AbstractCollectionSerializer ? deserializer : THROW_CCE()).v5f(this, previousValue);
        } else {
          tmp = deserializer.j59(this);
        }
      }
    }
    return tmp;
  };
  protoOf(ProtobufDecoder).d5q = function (_this__u8e3s4, index) {
    return extractParameters(_this__u8e3s4, index);
  };
  protoOf(ProtobufDecoder).w5c = function (descriptor) {
    while (true) {
      var protoId = this.ke8_1.peb();
      if (protoId === -1) {
        return this.pe8_1.j5i();
      }
      var index = getIndexByTag(this, protoId);
      if (index === -1) {
        this.ke8_1.zeb();
      } else {
        this.pe8_1.i5i(index);
        return index;
      }
    }
  };
  protoOf(ProtobufDecoder).s5b = function () {
    return !this.oe8_1;
  };
  function decodeListIndexNoTag($this) {
    var size = negate_0($this.kec_1);
    $this.jec_1 = $this.jec_1 + 1 | 0;
    var idx = $this.jec_1;
    if (fromInt_0(idx) === size || $this.ke8_1.me9())
      return -1;
    return idx;
  }
  function decodeTaggedListIndex($this) {
    var tmp;
    if ($this.jec_1 === -1) {
      tmp = $this.ke8_1.ie9_1;
    } else {
      tmp = $this.ke8_1.peb();
    }
    var protoId = tmp;
    var tmp_0;
    // Inline function 'kotlinx.serialization.protobuf.internal.protoId' call
    var this_0 = $this.kec_1;
    if (protoId === convertToInt(this_0 & 2147483647n)) {
      $this.jec_1 = $this.jec_1 + 1 | 0;
      tmp_0 = $this.jec_1;
    } else {
      $this.ke8_1.lec();
      tmp_0 = -1;
    }
    return tmp_0;
  }
  function RepeatedDecoder(proto, decoder, currentTag, descriptor) {
    ProtobufDecoder.call(this, proto, decoder, descriptor);
    this.jec_1 = -1;
    var tmp = this;
    var tmp_0;
    if (currentTag === 19500n) {
      var length = this.ke8_1.reb();
      // Inline function 'kotlin.require' call
      if (!(length >= 0)) {
        var message = 'Expected positive length for ' + toString_1(descriptor) + ', but got ' + length;
        throw IllegalArgumentException_init_$Create$_0(toString_1(message));
      }
      tmp_0 = negate_0(fromInt_0(length));
    } else {
      tmp_0 = currentTag;
    }
    tmp.kec_1 = tmp_0;
  }
  protoOf(RepeatedDecoder).w5c = function (descriptor) {
    if (this.kec_1 > 0n) {
      return decodeTaggedListIndex(this);
    }
    return decodeListIndexNoTag(this);
  };
  protoOf(RepeatedDecoder).d5q = function (_this__u8e3s4, index) {
    if (this.kec_1 > 0n)
      return this.kec_1;
    return 19500n;
  };
  function makeDelimited(decoder, parentTag) {
    var tagless = parentTag === 19500n;
    var input = tagless ? decoder.mec() : decoder.oeb();
    return new ProtobufReader(input);
  }
  function MapEntryReader(proto, decoder, parentTag, descriptor) {
    ProtobufDecoder.call(this, proto, decoder, descriptor);
    this.wec_1 = parentTag;
  }
  protoOf(MapEntryReader).d5q = function (_this__u8e3s4, index) {
    var tmp;
    if ((index % 2 | 0) === 0) {
      // Inline function 'kotlinx.serialization.protobuf.internal.ProtoDesc' call
      tmp = get_integerType(this.wec_1).ue8_1 | fromInt_0(1);
    } else {
      // Inline function 'kotlinx.serialization.protobuf.internal.ProtoDesc' call
      tmp = get_integerType(this.wec_1).ue8_1 | fromInt_0(2);
    }
    return tmp;
  };
  function makeDelimitedForced(decoder, parentTag) {
    var tagless = parentTag === 19500n;
    var input = tagless ? decoder.mec() : decoder.oeb();
    return new ProtobufReader(input);
  }
  function serializeByteArray($this, value) {
    var tag = $this.eea();
    if (tag === 19500n) {
      $this.ce8_1.zec(value);
    } else {
      // Inline function 'kotlinx.serialization.protobuf.internal.protoId' call
      var tmp$ret$0 = convertToInt(tag & 2147483647n);
      $this.ce8_1.yec(value, tmp$ret$0);
    }
  }
  function serializeMap($this, serializer, value) {
    var casted = serializer instanceof MapLikeSerializer ? serializer : THROW_CCE();
    var mapEntrySerial = MapEntrySerializer(casted.w5f_1, casted.x5f_1);
    var tmp = SetSerializer(mapEntrySerial);
    tmp.i59($this, ((!(value == null) ? isInterface(value, KtMap) : false) ? value : THROW_CCE()).y());
  }
  function ProtobufEncoder(proto, writer, descriptor) {
    ProtobufTaggedEncoder.call(this);
    this.be8_1 = proto;
    this.ce8_1 = writer;
    this.de8_1 = descriptor;
  }
  protoOf(ProtobufEncoder).g59 = function () {
    return this.be8_1.g59();
  };
  protoOf(ProtobufEncoder).b5e = function (descriptor, index) {
    return this.be8_1.we7_1;
  };
  protoOf(ProtobufEncoder).a5e = function (descriptor, collectionSize) {
    var tmp0_subject = descriptor.r5a();
    var tmp;
    if (equals(tmp0_subject, LIST_getInstance())) {
      var tag = this.dea();
      var tmp_0;
      if (get_isPacked(tag) && get_isPackable(descriptor.t5a(0))) {
        tmp_0 = new PackedArrayEncoder(this.be8_1, this.ce8_1, this.dea(), descriptor);
      } else {
        if (tag === 19500n) {
          this.ce8_1.aed(collectionSize);
        }
        var tmp_1;
        if (equals(this.de8_1.r5a(), LIST_getInstance()) && !(tag === 19500n) && !equals(this.de8_1, descriptor)) {
          tmp_1 = new NestedRepeatedEncoder(this.be8_1, this.ce8_1, tag, descriptor);
        } else {
          tmp_1 = new RepeatedEncoder(this.be8_1, this.ce8_1, tag, descriptor);
        }
        tmp_0 = tmp_1;
      }
      tmp = tmp_0;
    } else if (equals(tmp0_subject, MAP_getInstance())) {
      tmp = new MapRepeatedEncoder(this.be8_1, this.q5r(), this.ce8_1, descriptor);
    } else {
      throw SerializationException_init_$Create$_0('This serial kind is not supported as collection: ' + toString_1(descriptor));
    }
    return tmp;
  };
  protoOf(ProtobufEncoder).g5c = function (descriptor) {
    var tmp0_subject = descriptor.r5a();
    var tmp;
    if (equals(tmp0_subject, LIST_getInstance())) {
      var tmp_0;
      if (get_isPackable(descriptor.t5a(0)) && get_isPacked(this.dea())) {
        tmp_0 = new PackedArrayEncoder(this.be8_1, this.ce8_1, this.dea(), descriptor);
      } else {
        tmp_0 = new RepeatedEncoder(this.be8_1, this.ce8_1, this.dea(), descriptor);
      }
      tmp = tmp_0;
    } else {
      var tmp_1;
      if (equals(tmp0_subject, CLASS_getInstance()) ? true : equals(tmp0_subject, OBJECT_getInstance())) {
        tmp_1 = true;
      } else {
        tmp_1 = tmp0_subject instanceof PolymorphicKind;
      }
      if (tmp_1) {
        var tag = this.dea();
        tmp = tag === 19500n && equals(descriptor, this.de8_1) ? this : new ObjectEncoder(this.be8_1, this.dea(), this.ce8_1, VOID, descriptor);
      } else {
        if (equals(tmp0_subject, MAP_getInstance())) {
          tmp = new MapRepeatedEncoder(this.be8_1, this.dea(), this.ce8_1, descriptor);
        } else {
          throw SerializationException_init_$Create$_0('This serial kind is not supported as structure: ' + toString_1(descriptor));
        }
      }
    }
    return tmp;
  };
  protoOf(ProtobufEncoder).zea = function (tag, value) {
    if (tag === 19500n) {
      this.ce8_1.aed(value);
    } else {
      // Inline function 'kotlinx.serialization.protobuf.internal.protoId' call
      var tmp$ret$0 = convertToInt(tag & 2147483647n);
      this.ce8_1.bed(value, tmp$ret$0, get_integerType(tag));
    }
  };
  protoOf(ProtobufEncoder).aeb = function (tag, value) {
    return this.zea(tag, value);
  };
  protoOf(ProtobufEncoder).beb = function (tag, value) {
    return this.zea(tag, value);
  };
  protoOf(ProtobufEncoder).ceb = function (tag, value) {
    return this.zea(tag, value ? 1 : 0);
  };
  protoOf(ProtobufEncoder).deb = function (tag, value) {
    // Inline function 'kotlin.code' call
    var tmp$ret$0 = Char__toInt_impl_vasixd(value);
    return this.zea(tag, tmp$ret$0);
  };
  protoOf(ProtobufEncoder).eeb = function (tag, value) {
    if (tag === 19500n) {
      this.ce8_1.d65(value);
    } else {
      // Inline function 'kotlinx.serialization.protobuf.internal.protoId' call
      var tmp$ret$0 = convertToInt(tag & 2147483647n);
      this.ce8_1.ced(value, tmp$ret$0, get_integerType(tag));
    }
  };
  protoOf(ProtobufEncoder).feb = function (tag, value) {
    if (tag === 19500n) {
      this.ce8_1.eed(value);
    } else {
      // Inline function 'kotlinx.serialization.protobuf.internal.protoId' call
      var tmp$ret$0 = convertToInt(tag & 2147483647n);
      this.ce8_1.ded(value, tmp$ret$0);
    }
  };
  protoOf(ProtobufEncoder).geb = function (tag, value) {
    if (tag === 19500n) {
      this.ce8_1.ged(value);
    } else {
      // Inline function 'kotlinx.serialization.protobuf.internal.protoId' call
      var tmp$ret$0 = convertToInt(tag & 2147483647n);
      this.ce8_1.fed(value, tmp$ret$0);
    }
  };
  protoOf(ProtobufEncoder).pea = function (tag, value) {
    if (tag === 19500n) {
      this.ce8_1.ied(value);
    } else {
      // Inline function 'kotlinx.serialization.protobuf.internal.protoId' call
      var tmp$ret$0 = convertToInt(tag & 2147483647n);
      this.ce8_1.hed(value, tmp$ret$0);
    }
  };
  protoOf(ProtobufEncoder).heb = function (tag, enumDescriptor, ordinal) {
    if (tag === 19500n) {
      this.ce8_1.aed(extractProtoId(enumDescriptor, ordinal, true));
    } else {
      var tmp = extractProtoId(enumDescriptor, ordinal, true);
      // Inline function 'kotlinx.serialization.protobuf.internal.protoId' call
      var tmp$ret$0 = convertToInt(tag & 2147483647n);
      this.ce8_1.bed(tmp, tmp$ret$0, ProtoIntegerType_DEFAULT_getInstance());
    }
  };
  protoOf(ProtobufEncoder).d5q = function (_this__u8e3s4, index) {
    return extractParameters(_this__u8e3s4, index);
  };
  protoOf(ProtobufEncoder).h59 = function (serializer, value) {
    var tmp;
    if (serializer instanceof MapLikeSerializer) {
      serializeMap(this, isInterface(serializer, SerializationStrategy) ? serializer : THROW_CCE(), value);
      tmp = Unit_instance;
    } else {
      if (equals(serializer.v58(), ByteArraySerializer().v58())) {
        serializeByteArray(this, (!(value == null) ? isByteArray(value) : false) ? value : THROW_CCE());
        tmp = Unit_instance;
      } else {
        serializer.i59(this, value);
        tmp = Unit_instance;
      }
    }
    return tmp;
  };
  function NestedRepeatedEncoder(proto, writer, curTag, descriptor, stream) {
    stream = stream === VOID ? new ByteArrayOutput() : stream;
    ProtobufEncoder.call(this, proto, new ProtobufWriter(stream), descriptor);
    this.wea_1 = writer;
    this.xea_1 = curTag;
    this.yea_1 = stream;
  }
  protoOf(NestedRepeatedEncoder).d5q = function (_this__u8e3s4, index) {
    // Inline function 'kotlinx.serialization.protobuf.internal.ProtoDesc' call
    return ProtoIntegerType_DEFAULT_getInstance().ue8_1 | fromInt_0(1);
  };
  protoOf(NestedRepeatedEncoder).p5r = function (descriptor) {
    // Inline function 'kotlinx.serialization.protobuf.internal.protoId' call
    var this_0 = this.xea_1;
    var tmp$ret$0 = convertToInt(this_0 & 2147483647n);
    this.wea_1.jed(this.yea_1, tmp$ret$0);
  };
  function RepeatedEncoder(proto, writer, curTag, descriptor) {
    ProtobufEncoder.call(this, proto, writer, descriptor);
    this.qed_1 = curTag;
  }
  protoOf(RepeatedEncoder).d5q = function (_this__u8e3s4, index) {
    return this.qed_1;
  };
  function MapRepeatedEncoder(proto, parentTag, parentWriter, descriptor) {
    ObjectEncoder.call(this, proto, parentTag, parentWriter, VOID, descriptor);
  }
  protoOf(MapRepeatedEncoder).d5q = function (_this__u8e3s4, index) {
    var tmp;
    if ((index % 2 | 0) === 0) {
      // Inline function 'kotlinx.serialization.protobuf.internal.ProtoDesc' call
      tmp = get_integerType(this.gee_1).ue8_1 | fromInt_0(1);
    } else {
      // Inline function 'kotlinx.serialization.protobuf.internal.ProtoDesc' call
      tmp = get_integerType(this.gee_1).ue8_1 | fromInt_0(2);
    }
    return tmp;
  };
  function ObjectEncoder(proto, parentTag, parentWriter, stream, descriptor) {
    stream = stream === VOID ? new ByteArrayOutput() : stream;
    ProtobufEncoder.call(this, proto, new ProtobufWriter(stream), descriptor);
    this.gee_1 = parentTag;
    this.hee_1 = parentWriter;
    this.iee_1 = stream;
  }
  protoOf(ObjectEncoder).p5r = function (descriptor) {
    if (!(this.gee_1 === 19500n)) {
      // Inline function 'kotlinx.serialization.protobuf.internal.protoId' call
      var this_0 = this.gee_1;
      var tmp$ret$0 = convertToInt(this_0 & 2147483647n);
      this.hee_1.jed(this.iee_1, tmp$ret$0);
    } else {
      this.hee_1.jee(this.iee_1);
    }
  };
  function updateIdAndType($this, header) {
    var tmp;
    if (header === -1) {
      $this.ie9_1 = -1;
      $this.je9_1 = -1;
      tmp = -1;
    } else {
      $this.ie9_1 = header >>> 3 | 0;
      $this.je9_1 = header & 7;
      tmp = $this.ie9_1;
    }
    return tmp;
  }
  function readIntLittleEndian($this) {
    var result = 0;
    var inductionVariable = 0;
    if (inductionVariable <= 3)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var byte = $this.he9_1.c67() & 255;
        result = result | byte << imul(i, 8);
      }
       while (inductionVariable <= 3);
    return result;
  }
  function readLongLittleEndian($this) {
    var result = 0n;
    var inductionVariable = 0;
    if (inductionVariable <= 7)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var byte = fromInt_0($this.he9_1.c67() & 255);
        result = result | shiftLeft(byte, imul(i, 8));
      }
       while (inductionVariable <= 7);
    return result;
  }
  function checkLength($this, length) {
    if (length < 0) {
      throw new ProtobufDecodingException('Unexpected negative length: ' + length);
    }
  }
  function decode32($this, format) {
    var tmp;
    switch (format.x2_1) {
      case 0:
        tmp = convertToInt($this.he9_1.nee(false));
        break;
      case 1:
        tmp = decodeSignedVarintInt($this, $this.he9_1);
        break;
      case 2:
        tmp = readIntLittleEndian($this);
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  function decode32$default($this, format, $super) {
    format = format === VOID ? ProtoIntegerType_DEFAULT_getInstance() : format;
    return decode32($this, format);
  }
  function decode64($this, format) {
    var tmp;
    switch (format.x2_1) {
      case 0:
        tmp = $this.he9_1.nee(false);
        break;
      case 1:
        tmp = decodeSignedVarintLong($this, $this.he9_1);
        break;
      case 2:
        tmp = readLongLittleEndian($this);
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  function decodeSignedVarintInt($this, input) {
    var raw = input.oee();
    var temp = (raw << 31 >> 31 ^ raw) >> 1;
    return temp ^ raw & -2147483648;
  }
  function decodeSignedVarintLong($this, input) {
    var raw = input.nee(false);
    var temp = shiftRight(shiftRight(shiftLeft(raw, 63), 63) ^ raw, 1);
    return temp ^ raw & -9223372036854775808n;
  }
  function ProtobufReader(input) {
    this.he9_1 = input;
    this.ie9_1 = -1;
    this.je9_1 = -1;
    this.ke9_1 = false;
    this.le9_1 = 0;
  }
  protoOf(ProtobufReader).me9 = function () {
    return !this.ke9_1 && this.he9_1.pee() === 0;
  };
  protoOf(ProtobufReader).peb = function () {
    if (this.ke9_1) {
      this.ke9_1 = false;
      var previousHeader = this.ie9_1 << 3 | this.je9_1;
      // Inline function 'kotlin.also' call
      var this_0 = updateIdAndType(this, this.le9_1);
      this.le9_1 = previousHeader;
      return this_0;
    }
    this.le9_1 = this.ie9_1 << 3 | this.je9_1;
    var header = convertToInt(this.he9_1.nee(true));
    return updateIdAndType(this, header);
  };
  protoOf(ProtobufReader).lec = function () {
    this.ke9_1 = true;
    var nextHeader = this.ie9_1 << 3 | this.je9_1;
    updateIdAndType(this, this.le9_1);
    this.le9_1 = nextHeader;
  };
  protoOf(ProtobufReader).zeb = function () {
    switch (this.je9_1) {
      case 0:
        this.qeb(ProtoIntegerType_DEFAULT_getInstance());
        break;
      case 1:
        this.seb(ProtoIntegerType_FIXED_getInstance());
        break;
      case 2:
        this.meb();
        break;
      case 5:
        this.qeb(ProtoIntegerType_FIXED_getInstance());
        break;
      default:
        throw new ProtobufDecodingException('Unsupported start group or end group wire type: ' + this.je9_1);
    }
  };
  protoOf(ProtobufReader).meb = function () {
    // Inline function 'kotlinx.serialization.protobuf.internal.ProtobufReader.assertWireType' call
    if (!(this.je9_1 === 2))
      throw new ProtobufDecodingException('Expected wire type ' + 2 + ', but found ' + this.je9_1);
    return this.neb();
  };
  protoOf(ProtobufReader).neb = function () {
    var length = decode32$default(this);
    checkLength(this, length);
    return this.he9_1.qee(length);
  };
  protoOf(ProtobufReader).oeb = function () {
    // Inline function 'kotlinx.serialization.protobuf.internal.ProtobufReader.assertWireType' call
    if (!(this.je9_1 === 2))
      throw new ProtobufDecodingException('Expected wire type ' + 2 + ', but found ' + this.je9_1);
    return this.mec();
  };
  protoOf(ProtobufReader).mec = function () {
    var length = decode32$default(this);
    checkLength(this, length);
    return this.he9_1.ree(length);
  };
  protoOf(ProtobufReader).qeb = function (format) {
    var wireType = format.equals(ProtoIntegerType_FIXED_getInstance()) ? 5 : 0;
    // Inline function 'kotlinx.serialization.protobuf.internal.ProtobufReader.assertWireType' call
    if (!(this.je9_1 === wireType))
      throw new ProtobufDecodingException('Expected wire type ' + wireType + ', but found ' + this.je9_1);
    return decode32(this, format);
  };
  protoOf(ProtobufReader).reb = function () {
    return decode32$default(this);
  };
  protoOf(ProtobufReader).seb = function (format) {
    var wireType = format.equals(ProtoIntegerType_FIXED_getInstance()) ? 1 : 0;
    // Inline function 'kotlinx.serialization.protobuf.internal.ProtobufReader.assertWireType' call
    if (!(this.je9_1 === wireType))
      throw new ProtobufDecodingException('Expected wire type ' + wireType + ', but found ' + this.je9_1);
    return decode64(this, format);
  };
  protoOf(ProtobufReader).teb = function () {
    return decode64(this, ProtoIntegerType_DEFAULT_getInstance());
  };
  protoOf(ProtobufReader).ueb = function () {
    // Inline function 'kotlinx.serialization.protobuf.internal.ProtobufReader.assertWireType' call
    if (!(this.je9_1 === 5))
      throw new ProtobufDecodingException('Expected wire type ' + 5 + ', but found ' + this.je9_1);
    // Inline function 'kotlin.fromBits' call
    var bits = readIntLittleEndian(this);
    return floatFromBits(bits);
  };
  protoOf(ProtobufReader).veb = function () {
    // Inline function 'kotlin.fromBits' call
    var bits = readIntLittleEndian(this);
    return floatFromBits(bits);
  };
  protoOf(ProtobufReader).web = function () {
    // Inline function 'kotlinx.serialization.protobuf.internal.ProtobufReader.assertWireType' call
    if (!(this.je9_1 === 1))
      throw new ProtobufDecodingException('Expected wire type ' + 1 + ', but found ' + this.je9_1);
    // Inline function 'kotlin.fromBits' call
    var bits = readLongLittleEndian(this);
    return doubleFromBits(bits);
  };
  protoOf(ProtobufReader).xeb = function () {
    // Inline function 'kotlin.fromBits' call
    var bits = readLongLittleEndian(this);
    return doubleFromBits(bits);
  };
  protoOf(ProtobufReader).o2j = function () {
    // Inline function 'kotlinx.serialization.protobuf.internal.ProtobufReader.assertWireType' call
    if (!(this.je9_1 === 2))
      throw new ProtobufDecodingException('Expected wire type ' + 2 + ', but found ' + this.je9_1);
    var length = decode32$default(this);
    checkLength(this, length);
    return this.he9_1.see(length);
  };
  protoOf(ProtobufReader).yeb = function () {
    var length = decode32$default(this);
    checkLength(this, length);
    return this.he9_1.see(length);
  };
  function expand_1($this) {
    $this.bea_1 = copyOf_2($this.bea_1, imul($this.bea_1.length, 2));
  }
  function ProtobufTaggedBase() {
    this.bea_1 = longArray(8);
    this.cea_1 = -1;
  }
  protoOf(ProtobufTaggedBase).q5r = function () {
    return this.bea_1[this.cea_1];
  };
  protoOf(ProtobufTaggedBase).dea = function () {
    return this.cea_1 === -1 ? 19500n : this.bea_1[this.cea_1];
  };
  protoOf(ProtobufTaggedBase).eea = function () {
    var tmp;
    if (this.cea_1 === -1) {
      tmp = 19500n;
    } else {
      var tmp_0 = this.bea_1;
      var tmp1 = this.cea_1;
      this.cea_1 = tmp1 - 1 | 0;
      tmp = tmp_0[tmp1];
    }
    return tmp;
  };
  protoOf(ProtobufTaggedBase).fea = function (tag) {
    if (tag === 19500n)
      return Unit_instance;
    this.cea_1 = this.cea_1 + 1 | 0;
    var idx = this.cea_1;
    if (this.cea_1 >= this.bea_1.length) {
      expand_1(this);
    }
    this.bea_1[idx] = tag;
  };
  protoOf(ProtobufTaggedBase).y5q = function () {
    if (this.cea_1 >= 0) {
      var tmp = this.bea_1;
      var tmp1 = this.cea_1;
      this.cea_1 = tmp1 - 1 | 0;
      return tmp[tmp1];
    }
    throw SerializationException_init_$Create$_0('No tag in stack for requested element');
  };
  function ProtobufTaggedDecoder() {
    ProtobufTaggedBase.call(this);
  }
  protoOf(ProtobufTaggedDecoder).aea = function (tag, inlineDescriptor) {
    // Inline function 'kotlin.apply' call
    this.fea(tag);
    return this;
  };
  protoOf(ProtobufTaggedDecoder).s5b = function () {
    return true;
  };
  protoOf(ProtobufTaggedDecoder).t5b = function () {
    return null;
  };
  protoOf(ProtobufTaggedDecoder).u5b = function () {
    return this.pe9(this.eea());
  };
  protoOf(ProtobufTaggedDecoder).v5b = function () {
    return this.qe9(this.eea());
  };
  protoOf(ProtobufTaggedDecoder).w5b = function () {
    return this.re9(this.eea());
  };
  protoOf(ProtobufTaggedDecoder).x5b = function () {
    return this.se9(this.eea());
  };
  protoOf(ProtobufTaggedDecoder).y5b = function () {
    return this.te9(this.eea());
  };
  protoOf(ProtobufTaggedDecoder).z5b = function () {
    return this.ue9(this.eea());
  };
  protoOf(ProtobufTaggedDecoder).a5c = function () {
    return this.ve9(this.eea());
  };
  protoOf(ProtobufTaggedDecoder).b5c = function () {
    return this.we9(this.eea());
  };
  protoOf(ProtobufTaggedDecoder).c5c = function () {
    return this.ne9(this.eea());
  };
  protoOf(ProtobufTaggedDecoder).d5c = function (enumDescriptor) {
    return this.xe9(this.eea(), enumDescriptor);
  };
  protoOf(ProtobufTaggedDecoder).g5c = function (descriptor) {
    return this;
  };
  protoOf(ProtobufTaggedDecoder).h5c = function (descriptor) {
  };
  protoOf(ProtobufTaggedDecoder).i5c = function (descriptor, index) {
    return this.pe9(this.d5q(descriptor, index));
  };
  protoOf(ProtobufTaggedDecoder).j5c = function (descriptor, index) {
    return this.qe9(this.d5q(descriptor, index));
  };
  protoOf(ProtobufTaggedDecoder).k5c = function (descriptor, index) {
    return this.re9(this.d5q(descriptor, index));
  };
  protoOf(ProtobufTaggedDecoder).l5c = function (descriptor, index) {
    return this.se9(this.d5q(descriptor, index));
  };
  protoOf(ProtobufTaggedDecoder).m5c = function (descriptor, index) {
    return this.te9(this.d5q(descriptor, index));
  };
  protoOf(ProtobufTaggedDecoder).n5c = function (descriptor, index) {
    return this.ue9(this.d5q(descriptor, index));
  };
  protoOf(ProtobufTaggedDecoder).o5c = function (descriptor, index) {
    return this.ve9(this.d5q(descriptor, index));
  };
  protoOf(ProtobufTaggedDecoder).p5c = function (descriptor, index) {
    return this.we9(this.d5q(descriptor, index));
  };
  protoOf(ProtobufTaggedDecoder).q5c = function (descriptor, index) {
    return this.ne9(this.d5q(descriptor, index));
  };
  protoOf(ProtobufTaggedDecoder).s5c = function (descriptor, index, deserializer, previousValue) {
    // Inline function 'kotlinx.serialization.protobuf.internal.ProtobufTaggedBase.tagBlock' call
    var tag = this.d5q(descriptor, index);
    this.fea(tag);
    return this.f5c(deserializer, previousValue);
  };
  protoOf(ProtobufTaggedDecoder).u5c = function (descriptor, index, deserializer, previousValue) {
    // Inline function 'kotlinx.serialization.protobuf.internal.ProtobufTaggedBase.tagBlock' call
    var tag = this.d5q(descriptor, index);
    this.fea(tag);
    var tmp;
    if (this.s5b()) {
      tmp = this.f5c(deserializer, previousValue);
    } else {
      tmp = this.t5b();
    }
    return tmp;
  };
  protoOf(ProtobufTaggedDecoder).e5c = function (descriptor) {
    return this.aea(this.y5q(), descriptor);
  };
  protoOf(ProtobufTaggedDecoder).r5c = function (descriptor, index) {
    return this.aea(this.d5q(descriptor, index), descriptor.t5a(index));
  };
  var NullableMode_ACCEPTABLE_instance;
  var NullableMode_OPTIONAL_instance;
  var NullableMode_COLLECTION_instance;
  var NullableMode_NOT_NULL_instance;
  var NullableMode_entriesInitialized;
  function NullableMode_initEntries() {
    if (NullableMode_entriesInitialized)
      return Unit_instance;
    NullableMode_entriesInitialized = true;
    NullableMode_ACCEPTABLE_instance = new NullableMode('ACCEPTABLE', 0);
    NullableMode_OPTIONAL_instance = new NullableMode('OPTIONAL', 1);
    NullableMode_COLLECTION_instance = new NullableMode('COLLECTION', 2);
    NullableMode_NOT_NULL_instance = new NullableMode('NOT_NULL', 3);
  }
  function NullableMode(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function NullableMode_ACCEPTABLE_getInstance() {
    NullableMode_initEntries();
    return NullableMode_ACCEPTABLE_instance;
  }
  function NullableMode_OPTIONAL_getInstance() {
    NullableMode_initEntries();
    return NullableMode_OPTIONAL_instance;
  }
  function NullableMode_COLLECTION_getInstance() {
    NullableMode_initEntries();
    return NullableMode_COLLECTION_instance;
  }
  function NullableMode_NOT_NULL_getInstance() {
    NullableMode_initEntries();
    return NullableMode_NOT_NULL_instance;
  }
  function ProtobufTaggedEncoder() {
    ProtobufTaggedBase.call(this);
    this.keb_1 = NullableMode_NOT_NULL_getInstance();
  }
  protoOf(ProtobufTaggedEncoder).leb = function (tag, inlineDescriptor) {
    // Inline function 'kotlin.apply' call
    this.fea(tag);
    return this;
  };
  protoOf(ProtobufTaggedEncoder).a5d = function () {
    if (!this.keb_1.equals(NullableMode_ACCEPTABLE_getInstance())) {
      var message;
      switch (this.keb_1.x2_1) {
        case 1:
          message = "'null' is not supported for optional properties in ProtoBuf";
          break;
        case 2:
          message = "'null' is not supported for collection types in ProtoBuf";
          break;
        case 3:
          message = "'null' is not allowed for not-null properties";
          break;
        default:
          message = "'null' is not supported in ProtoBuf";
          break;
      }
      throw SerializationException_init_$Create$_0(message);
    }
  };
  protoOf(ProtobufTaggedEncoder).b5d = function (value) {
    this.ceb(this.eea(), value);
  };
  protoOf(ProtobufTaggedEncoder).c5d = function (value) {
    this.aeb(this.eea(), value);
  };
  protoOf(ProtobufTaggedEncoder).d5d = function (value) {
    this.beb(this.eea(), value);
  };
  protoOf(ProtobufTaggedEncoder).e5d = function (value) {
    this.zea(this.eea(), value);
  };
  protoOf(ProtobufTaggedEncoder).f5d = function (value) {
    this.eeb(this.eea(), value);
  };
  protoOf(ProtobufTaggedEncoder).g5d = function (value) {
    this.feb(this.eea(), value);
  };
  protoOf(ProtobufTaggedEncoder).h5d = function (value) {
    this.geb(this.eea(), value);
  };
  protoOf(ProtobufTaggedEncoder).i5d = function (value) {
    this.deb(this.eea(), value);
  };
  protoOf(ProtobufTaggedEncoder).j5d = function (value) {
    this.pea(this.eea(), value);
  };
  protoOf(ProtobufTaggedEncoder).k5d = function (enumDescriptor, index) {
    return this.heb(this.eea(), enumDescriptor, index);
  };
  protoOf(ProtobufTaggedEncoder).h5c = function (descriptor) {
    if (this.cea_1 >= 0) {
      this.y5q();
    }
    this.p5r(descriptor);
  };
  protoOf(ProtobufTaggedEncoder).p5r = function (descriptor) {
  };
  protoOf(ProtobufTaggedEncoder).m5d = function (descriptor, index, value) {
    return this.ceb(this.d5q(descriptor, index), value);
  };
  protoOf(ProtobufTaggedEncoder).n5d = function (descriptor, index, value) {
    return this.aeb(this.d5q(descriptor, index), value);
  };
  protoOf(ProtobufTaggedEncoder).o5d = function (descriptor, index, value) {
    return this.beb(this.d5q(descriptor, index), value);
  };
  protoOf(ProtobufTaggedEncoder).p5d = function (descriptor, index, value) {
    return this.zea(this.d5q(descriptor, index), value);
  };
  protoOf(ProtobufTaggedEncoder).q5d = function (descriptor, index, value) {
    return this.eeb(this.d5q(descriptor, index), value);
  };
  protoOf(ProtobufTaggedEncoder).r5d = function (descriptor, index, value) {
    return this.feb(this.d5q(descriptor, index), value);
  };
  protoOf(ProtobufTaggedEncoder).s5d = function (descriptor, index, value) {
    return this.geb(this.d5q(descriptor, index), value);
  };
  protoOf(ProtobufTaggedEncoder).t5d = function (descriptor, index, value) {
    return this.deb(this.d5q(descriptor, index), value);
  };
  protoOf(ProtobufTaggedEncoder).u5d = function (descriptor, index, value) {
    return this.pea(this.d5q(descriptor, index), value);
  };
  protoOf(ProtobufTaggedEncoder).w5d = function (descriptor, index, serializer, value) {
    this.keb_1 = NullableMode_NOT_NULL_getInstance();
    this.fea(this.d5q(descriptor, index));
    this.h59(serializer, value);
  };
  protoOf(ProtobufTaggedEncoder).x5d = function (descriptor, index, serializer, value) {
    var elementKind = descriptor.t5a(index).r5a();
    var tmp = this;
    var tmp_0;
    if (descriptor.w5a(index)) {
      tmp_0 = NullableMode_OPTIONAL_getInstance();
    } else if (equals(elementKind, MAP_getInstance()) || equals(elementKind, LIST_getInstance())) {
      tmp_0 = NullableMode_COLLECTION_getInstance();
    } else {
      tmp_0 = NullableMode_ACCEPTABLE_getInstance();
    }
    tmp.keb_1 = tmp_0;
    this.fea(this.d5q(descriptor, index));
    this.y5d(serializer, value);
  };
  protoOf(ProtobufTaggedEncoder).l5d = function (descriptor) {
    return this.leb(this.y5q(), descriptor);
  };
  protoOf(ProtobufTaggedEncoder).v5d = function (descriptor, index) {
    return this.leb(this.d5q(descriptor, index), descriptor.t5a(index));
  };
  function encode32($this, _this__u8e3s4, number, format) {
    switch (format.x2_1) {
      case 2:
        $this.xec_1.aed(reverseBytes_1(number));
        break;
      case 0:
        _this__u8e3s4.tee(fromInt_0(number));
        break;
      case 1:
        _this__u8e3s4.uee(number << 1 ^ number >> 31);
        break;
    }
  }
  function encode32$default($this, _this__u8e3s4, number, format, $super) {
    format = format === VOID ? ProtoIntegerType_DEFAULT_getInstance() : format;
    return encode32($this, _this__u8e3s4, number, format);
  }
  function encode64($this, _this__u8e3s4, number, format) {
    switch (format.x2_1) {
      case 2:
        $this.xec_1.d65(reverseBytes_2(number));
        break;
      case 0:
        _this__u8e3s4.tee(number);
        break;
      case 1:
        _this__u8e3s4.tee(shiftLeft(number, 1) ^ shiftRight(number, 63));
        break;
    }
  }
  function encode64$default($this, _this__u8e3s4, number, format, $super) {
    format = format === VOID ? ProtoIntegerType_DEFAULT_getInstance() : format;
    return encode64($this, _this__u8e3s4, number, format);
  }
  function reverseBytes($this, _this__u8e3s4) {
    return reverseBytes_1(toRawBits(_this__u8e3s4));
  }
  function reverseBytes_0($this, _this__u8e3s4) {
    return reverseBytes_2(toRawBits_0(_this__u8e3s4));
  }
  function ProtobufWriter(out) {
    this.xec_1 = out;
  }
  protoOf(ProtobufWriter).yec = function (bytes, tag) {
    encode32$default(this, this.xec_1, tag << 3 | 2);
    this.zec(bytes);
  };
  protoOf(ProtobufWriter).zec = function (bytes) {
    encode32$default(this, this.xec_1, bytes.length);
    this.xec_1.vee(bytes);
  };
  protoOf(ProtobufWriter).jed = function (output, tag) {
    encode32$default(this, this.xec_1, tag << 3 | 2);
    this.jee(output);
  };
  protoOf(ProtobufWriter).jee = function (output) {
    encode32$default(this, this.xec_1, output.x2g());
    this.xec_1.wee(output);
  };
  protoOf(ProtobufWriter).bed = function (value, tag, format) {
    var wireType = format.equals(ProtoIntegerType_FIXED_getInstance()) ? 5 : 0;
    encode32$default(this, this.xec_1, tag << 3 | wireType);
    encode32(this, this.xec_1, value, format);
  };
  protoOf(ProtobufWriter).aed = function (value) {
    encode32$default(this, this.xec_1, value);
  };
  protoOf(ProtobufWriter).ced = function (value, tag, format) {
    var wireType = format.equals(ProtoIntegerType_FIXED_getInstance()) ? 1 : 0;
    encode32$default(this, this.xec_1, tag << 3 | wireType);
    encode64(this, this.xec_1, value, format);
  };
  protoOf(ProtobufWriter).d65 = function (value) {
    encode64$default(this, this.xec_1, value);
  };
  protoOf(ProtobufWriter).hed = function (value, tag) {
    var bytes = encodeToByteArray(value);
    this.yec(bytes, tag);
  };
  protoOf(ProtobufWriter).ied = function (value) {
    var bytes = encodeToByteArray(value);
    this.zec(bytes);
  };
  protoOf(ProtobufWriter).fed = function (value, tag) {
    encode32$default(this, this.xec_1, tag << 3 | 1);
    this.xec_1.d65(reverseBytes_0(this, value));
  };
  protoOf(ProtobufWriter).ged = function (value) {
    this.xec_1.d65(reverseBytes_0(this, value));
  };
  protoOf(ProtobufWriter).ded = function (value, tag) {
    encode32$default(this, this.xec_1, tag << 3 | 5);
    this.xec_1.aed(reverseBytes(this, value));
  };
  protoOf(ProtobufWriter).eed = function (value) {
    this.xec_1.aed(reverseBytes(this, value));
  };
  function Companion_268() {
    Companion_instance_268 = this;
    var tmp = this;
    var tmp_0 = 0;
    var tmp_1 = new Int32Array(65);
    while (tmp_0 < 65) {
      var tmp_2 = tmp_0;
      tmp_1[tmp_2] = (63 - tmp_2 | 0) / 7 | 0;
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp.xee_1 = tmp_1;
  }
  var Companion_instance_268;
  function Companion_getInstance_268() {
    if (Companion_instance_268 == null)
      new Companion_268();
    return Companion_instance_268;
  }
  function ensureCapacity_1($this, elementsToAppend) {
    if (($this.fe8_1 + elementsToAppend | 0) <= $this.ee8_1.length) {
      return Unit_instance;
    }
    var newArray = new Int8Array(takeHighestOneBit($this.fe8_1 + elementsToAppend | 0) << 1);
    // Inline function 'kotlin.collections.copyInto' call
    var this_0 = $this.ee8_1;
    var endIndex = this_0.length;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp = this_0;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    arrayCopy(tmp, newArray, 0, 0, endIndex);
    $this.ee8_1 = newArray;
  }
  function encodeVarint($this, value, length) {
    var current = value;
    var inductionVariable = 0;
    if (inductionVariable < length)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        $this.ee8_1[$this.fe8_1 + i | 0] = convertToByte(current & 127n | 128n);
        current = shiftRightUnsigned(current, 7);
      }
       while (inductionVariable < length);
    $this.ee8_1[$this.fe8_1 + length | 0] = convertToByte(current);
    $this.fe8_1 = $this.fe8_1 + (length + 1 | 0) | 0;
  }
  function varIntLength($this, value) {
    return Companion_getInstance_268().xee_1[countLeadingZeroBits(value)];
  }
  function ByteArrayOutput() {
    Companion_getInstance_268();
    this.ee8_1 = new Int8Array(32);
    this.fe8_1 = 0;
  }
  protoOf(ByteArrayOutput).x2g = function () {
    return this.fe8_1;
  };
  protoOf(ByteArrayOutput).ge8 = function () {
    var newArray = new Int8Array(this.fe8_1);
    var tmp0 = this.ee8_1;
    // Inline function 'kotlin.collections.copyInto' call
    var endIndex = this.fe8_1;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp = tmp0;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    arrayCopy(tmp, newArray, 0, 0, endIndex);
    return newArray;
  };
  protoOf(ByteArrayOutput).vee = function (buffer) {
    var count = buffer.length;
    if (count === 0) {
      return Unit_instance;
    }
    ensureCapacity_1(this, count);
    var tmp2 = this.ee8_1;
    // Inline function 'kotlin.collections.copyInto' call
    var destinationOffset = this.fe8_1;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp = buffer;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    arrayCopy(tmp, tmp2, destinationOffset, 0, count);
    this.fe8_1 = this.fe8_1 + count | 0;
  };
  protoOf(ByteArrayOutput).wee = function (output) {
    var count = output.x2g();
    ensureCapacity_1(this, count);
    var tmp0 = output.ee8_1;
    var tmp2 = this.ee8_1;
    // Inline function 'kotlin.collections.copyInto' call
    var destinationOffset = this.fe8_1;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp = tmp0;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    arrayCopy(tmp, tmp2, destinationOffset, 0, count);
    this.fe8_1 = this.fe8_1 + count | 0;
  };
  protoOf(ByteArrayOutput).aed = function (intValue) {
    ensureCapacity_1(this, 4);
    var inductionVariable = 3;
    if (0 <= inductionVariable)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        var tmp = this.ee8_1;
        var tmp2 = this.fe8_1;
        this.fe8_1 = tmp2 + 1 | 0;
        tmp[tmp2] = toByte(intValue >> imul(i, 8));
      }
       while (0 <= inductionVariable);
  };
  protoOf(ByteArrayOutput).d65 = function (longValue) {
    ensureCapacity_1(this, 8);
    var inductionVariable = 7;
    if (0 <= inductionVariable)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        var tmp = this.ee8_1;
        var tmp2 = this.fe8_1;
        this.fe8_1 = tmp2 + 1 | 0;
        tmp[tmp2] = convertToByte(shiftRight(longValue, imul(i, 8)));
      }
       while (0 <= inductionVariable);
  };
  protoOf(ByteArrayOutput).uee = function (value) {
    ensureCapacity_1(this, 5);
    if ((value & -128) === 0) {
      var tmp = this.ee8_1;
      var tmp1 = this.fe8_1;
      this.fe8_1 = tmp1 + 1 | 0;
      tmp[tmp1] = toByte(value);
      return Unit_instance;
    }
    var length = varIntLength(this, fromInt_0(value));
    encodeVarint(this, fromInt_0(value), length);
  };
  protoOf(ByteArrayOutput).tee = function (value) {
    var length = varIntLength(this, value);
    ensureCapacity_1(this, length + 1 | 0);
    encodeVarint(this, value, length);
  };
  function ensureEnoughBytes($this, bytesCount) {
    if (bytesCount > $this.pee()) {
      throw SerializationException_init_$Create$_0('Unexpected EOF, available ' + $this.pee() + ' bytes, requested: ' + bytesCount);
    }
  }
  function eof($this) {
    throw SerializationException_init_$Create$_0('Unexpected EOF');
  }
  function readVarint64SlowPath($this) {
    var result = 0n;
    var shift = 0;
    while (shift < 64) {
      var byte = $this.c67();
      result = result | shiftLeft(fromInt_0(byte & 127), shift);
      if ((byte & 128) === 0) {
        return result;
      }
      shift = shift + 7 | 0;
    }
    throw SerializationException_init_$Create$_0('Input stream is malformed: Varint too long (exceeded 64 bits)');
  }
  function readVarint32SlowPath($this) {
    var result = 0;
    var shift = 0;
    while (shift < 32) {
      var byte = $this.c67();
      result = result | (byte & 127) << shift;
      if ((byte & 128) === 0) {
        return result;
      }
      shift = shift + 7 | 0;
    }
    throw SerializationException_init_$Create$_0('Input stream is malformed: Varint too long (exceeded 32 bits)');
  }
  function ByteArrayInput(array, endIndex) {
    endIndex = endIndex === VOID ? array.length : endIndex;
    this.kee_1 = array;
    this.lee_1 = endIndex;
    this.mee_1 = 0;
  }
  protoOf(ByteArrayInput).pee = function () {
    return this.lee_1 - this.mee_1 | 0;
  };
  protoOf(ByteArrayInput).ree = function (size) {
    ensureEnoughBytes(this, size);
    var result = new ByteArrayInput(this.kee_1, this.mee_1 + size | 0);
    result.mee_1 = this.mee_1;
    this.mee_1 = this.mee_1 + size | 0;
    return result;
  };
  protoOf(ByteArrayInput).c67 = function () {
    var tmp;
    if (this.mee_1 < this.lee_1) {
      var tmp_0 = this.kee_1;
      var tmp1 = this.mee_1;
      this.mee_1 = tmp1 + 1 | 0;
      tmp = tmp_0[tmp1] & 255;
    } else {
      tmp = -1;
    }
    return tmp;
  };
  protoOf(ByteArrayInput).qee = function (bytesCount) {
    ensureEnoughBytes(this, bytesCount);
    var b = new Int8Array(bytesCount);
    var length = b.length;
    var copied = (this.lee_1 - this.mee_1 | 0) < length ? this.lee_1 - this.mee_1 | 0 : length;
    var tmp0 = this.kee_1;
    var tmp6 = this.mee_1;
    // Inline function 'kotlin.collections.copyInto' call
    var endIndex = this.mee_1 + copied | 0;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp = tmp0;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    arrayCopy(tmp, b, 0, tmp6, endIndex);
    this.mee_1 = this.mee_1 + copied | 0;
    return b;
  };
  protoOf(ByteArrayInput).see = function (length) {
    var result = decodeToString_0(this.kee_1, this.mee_1, this.mee_1 + length | 0);
    this.mee_1 = this.mee_1 + length | 0;
    return result;
  };
  protoOf(ByteArrayInput).oee = function () {
    if (this.mee_1 === this.lee_1) {
      eof(this);
    }
    var currentPosition = this.mee_1;
    var tmp = this.kee_1;
    var tmp0 = currentPosition;
    currentPosition = tmp0 + 1 | 0;
    var result = tmp[tmp0];
    if (result >= 0) {
      this.mee_1 = currentPosition;
      return result;
    } else if ((this.lee_1 - this.mee_1 | 0) > 1) {
      var tmp_0 = result;
      var tmp_1 = this.kee_1;
      var tmp1 = currentPosition;
      currentPosition = tmp1 + 1 | 0;
      result = tmp_0 ^ tmp_1[tmp1] << 7;
      if (result < 0) {
        this.mee_1 = currentPosition;
        return result ^ -128;
      }
    }
    return readVarint32SlowPath(this);
  };
  protoOf(ByteArrayInput).nee = function (eofAllowed) {
    if (this.mee_1 === this.lee_1) {
      if (eofAllowed)
        return -1n;
      else {
        eof(this);
      }
    }
    var currentPosition = this.mee_1;
    var tmp = this.kee_1;
    var tmp0 = currentPosition;
    currentPosition = tmp0 + 1 | 0;
    var result = fromInt_0(tmp[tmp0]);
    if (result >= 0n) {
      this.mee_1 = currentPosition;
      return result;
    } else if ((this.lee_1 - this.mee_1 | 0) > 1) {
      var tmp_0 = result;
      var tmp_1 = this.kee_1;
      var tmp1 = currentPosition;
      currentPosition = tmp1 + 1 | 0;
      result = tmp_0 ^ shiftLeft(fromInt_0(tmp_1[tmp1]), 7);
      if (result < 0n) {
        this.mee_1 = currentPosition;
        return result ^ -128n;
      }
    }
    return readVarint64SlowPath(this);
  };
  function reverseBytes_1(_this__u8e3s4) {
    return reverseBytes_3(toShort(_this__u8e3s4 & 65535)) << 16 | reverseBytes_3(toShort(_this__u8e3s4 >>> 16 | 0)) & 65535;
  }
  function reverseBytes_2(_this__u8e3s4) {
    return shiftLeft(fromInt_0(reverseBytes_1(convertToInt(_this__u8e3s4 & 4294967295n))), 32) | fromInt_0(reverseBytes_1(convertToInt(shiftRightUnsigned(_this__u8e3s4, 32)))) & 4294967295n;
  }
  function reverseBytes_3(_this__u8e3s4) {
    return toShort((_this__u8e3s4 & 255) << 8 | ((_this__u8e3s4 & 65535) >>> 8 | 0));
  }
  function Companion_269() {
  }
  var Companion_instance_269;
  function Companion_getInstance_269() {
    return Companion_instance_269;
  }
  function $serializer_6() {
    $serializer_instance_6 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('jetbrains.ocelot.langDef.rpc.MethodId', this, 1);
    tmp0_serialDesc.q5j('methodName', false);
    this.yee_1 = tmp0_serialDesc;
  }
  protoOf($serializer_6).zee = function (encoder, value) {
    var tmp0_desc = this.yee_1;
    var tmp1_output = encoder.g5c(tmp0_desc);
    tmp1_output.u5d(tmp0_desc, 0, value.aef_1);
    tmp1_output.h5c(tmp0_desc);
  };
  protoOf($serializer_6).i59 = function (encoder, value) {
    return this.zee(encoder, value instanceof MethodId ? value : THROW_CCE());
  };
  protoOf($serializer_6).j59 = function (decoder) {
    var tmp0_desc = this.yee_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.g5c(tmp0_desc);
    if (tmp5_input.v5c()) {
      tmp4_local0 = tmp5_input.q5c(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.w5c(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.q5c(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.h5c(tmp0_desc);
    return MethodId_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_6).v58 = function () {
    return this.yee_1;
  };
  protoOf($serializer_6).f5k = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance()];
  };
  var $serializer_instance_6;
  function $serializer_getInstance_6() {
    if ($serializer_instance_6 == null)
      new $serializer_6();
    return $serializer_instance_6;
  }
  function MethodId_init_$Init$(seen0, methodName, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_6().yee_1);
    }
    $this.aef_1 = methodName;
    return $this;
  }
  function MethodId_init_$Create$(seen0, methodName, serializationConstructorMarker) {
    return MethodId_init_$Init$(seen0, methodName, serializationConstructorMarker, objectCreate(protoOf(MethodId)));
  }
  function MethodId(methodName) {
    this.aef_1 = methodName;
  }
  protoOf(MethodId).toString = function () {
    return this.aef_1;
  };
  protoOf(MethodId).hashCode = function () {
    return getStringHashCode(this.aef_1);
  };
  protoOf(MethodId).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof MethodId))
      return false;
    if (!(this.aef_1 === other.aef_1))
      return false;
    return true;
  };
  function _get_$cachedSerializer__te6jhj_1($this) {
    return $this.bef_1.a1();
  }
  function InstanceId$Companion$_anonymous__ifoni9() {
    var tmp = getKClass(InstanceId);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = [getKClass(PublishedInstanceId), getKClass(RemoteInstanceId)];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_1 = [$serializer_getInstance_7(), $serializer_getInstance_8()];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$8 = [];
    return SealedClassSerializer_init_$Create$('jetbrains.ocelot.langDef.rpc.InstanceId', tmp, tmp_0, tmp_1, tmp$ret$8);
  }
  function Companion_270() {
    Companion_instance_270 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.bef_1 = lazy_0(tmp_0, InstanceId$Companion$_anonymous__ifoni9);
  }
  protoOf(Companion_270).i63 = function () {
    return _get_$cachedSerializer__te6jhj_1(this);
  };
  protoOf(Companion_270).q5k = function (typeParamsSerializers) {
    return this.i63();
  };
  var Companion_instance_270;
  function Companion_getInstance_270() {
    if (Companion_instance_270 == null)
      new Companion_270();
    return Companion_instance_270;
  }
  function InstanceId_init_$Init$(seen0, serializationConstructorMarker, $this) {
    return $this;
  }
  function InstanceId() {
    Companion_getInstance_270();
  }
  protoOf(InstanceId).toString = function () {
    return this.z3n().toString();
  };
  function Companion_271() {
  }
  var Companion_instance_271;
  function Companion_getInstance_271() {
    return Companion_instance_271;
  }
  function $serializer_7() {
    $serializer_instance_7 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('jetbrains.ocelot.langDef.rpc.PublishedInstanceId', this, 1);
    tmp0_serialDesc.q5j('id', false);
    this.cef_1 = tmp0_serialDesc;
  }
  protoOf($serializer_7).def = function (encoder, value) {
    var tmp0_desc = this.cef_1;
    var tmp1_output = encoder.g5c(tmp0_desc);
    tmp1_output.q5d(tmp0_desc, 0, value.eef_1);
    tmp1_output.h5c(tmp0_desc);
  };
  protoOf($serializer_7).i59 = function (encoder, value) {
    return this.def(encoder, value instanceof PublishedInstanceId ? value : THROW_CCE());
  };
  protoOf($serializer_7).j59 = function (decoder) {
    var tmp0_desc = this.cef_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0n;
    var tmp5_input = decoder.g5c(tmp0_desc);
    if (tmp5_input.v5c()) {
      tmp4_local0 = tmp5_input.m5c(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.w5c(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.m5c(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.h5c(tmp0_desc);
    return PublishedInstanceId_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_7).v58 = function () {
    return this.cef_1;
  };
  protoOf($serializer_7).f5k = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [LongSerializer_getInstance()];
  };
  var $serializer_instance_7;
  function $serializer_getInstance_7() {
    if ($serializer_instance_7 == null)
      new $serializer_7();
    return $serializer_instance_7;
  }
  function PublishedInstanceId_init_$Init$(seen0, id, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_7().cef_1);
    }
    InstanceId_init_$Init$(seen0, serializationConstructorMarker, $this);
    $this.eef_1 = id;
    return $this;
  }
  function PublishedInstanceId_init_$Create$(seen0, id, serializationConstructorMarker) {
    return PublishedInstanceId_init_$Init$(seen0, id, serializationConstructorMarker, objectCreate(protoOf(PublishedInstanceId)));
  }
  function PublishedInstanceId(id) {
    InstanceId.call(this);
    this.eef_1 = id;
  }
  protoOf(PublishedInstanceId).z3n = function () {
    return this.eef_1;
  };
  protoOf(PublishedInstanceId).toString = function () {
    return 'Published#' + this.eef_1.toString();
  };
  protoOf(PublishedInstanceId).hashCode = function () {
    return getBigIntHashCode(this.eef_1);
  };
  protoOf(PublishedInstanceId).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PublishedInstanceId))
      return false;
    if (!(this.eef_1 === other.eef_1))
      return false;
    return true;
  };
  function Companion_272() {
  }
  var Companion_instance_272;
  function Companion_getInstance_272() {
    return Companion_instance_272;
  }
  function $serializer_8() {
    $serializer_instance_8 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('jetbrains.ocelot.langDef.rpc.RemoteInstanceId', this, 1);
    tmp0_serialDesc.q5j('id', false);
    this.fef_1 = tmp0_serialDesc;
  }
  protoOf($serializer_8).gef = function (encoder, value) {
    var tmp0_desc = this.fef_1;
    var tmp1_output = encoder.g5c(tmp0_desc);
    tmp1_output.q5d(tmp0_desc, 0, value.hef_1);
    tmp1_output.h5c(tmp0_desc);
  };
  protoOf($serializer_8).i59 = function (encoder, value) {
    return this.gef(encoder, value instanceof RemoteInstanceId ? value : THROW_CCE());
  };
  protoOf($serializer_8).j59 = function (decoder) {
    var tmp0_desc = this.fef_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0n;
    var tmp5_input = decoder.g5c(tmp0_desc);
    if (tmp5_input.v5c()) {
      tmp4_local0 = tmp5_input.m5c(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.w5c(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.m5c(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.h5c(tmp0_desc);
    return RemoteInstanceId_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_8).v58 = function () {
    return this.fef_1;
  };
  protoOf($serializer_8).f5k = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [LongSerializer_getInstance()];
  };
  var $serializer_instance_8;
  function $serializer_getInstance_8() {
    if ($serializer_instance_8 == null)
      new $serializer_8();
    return $serializer_instance_8;
  }
  function RemoteInstanceId_init_$Init$(seen0, id, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_8().fef_1);
    }
    InstanceId_init_$Init$(seen0, serializationConstructorMarker, $this);
    $this.hef_1 = id;
    return $this;
  }
  function RemoteInstanceId_init_$Create$(seen0, id, serializationConstructorMarker) {
    return RemoteInstanceId_init_$Init$(seen0, id, serializationConstructorMarker, objectCreate(protoOf(RemoteInstanceId)));
  }
  function RemoteInstanceId(id) {
    InstanceId.call(this);
    this.hef_1 = id;
  }
  protoOf(RemoteInstanceId).z3n = function () {
    return this.hef_1;
  };
  protoOf(RemoteInstanceId).toString = function () {
    return 'Remote#' + this.hef_1.toString();
  };
  protoOf(RemoteInstanceId).hashCode = function () {
    return getBigIntHashCode(this.hef_1);
  };
  protoOf(RemoteInstanceId).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RemoteInstanceId))
      return false;
    if (!(this.hef_1 === other.hef_1))
      return false;
    return true;
  };
  function get_published(_this__u8e3s4) {
    return new PublishedInstanceId(_this__u8e3s4.z3n());
  }
  function get_opposite(_this__u8e3s4) {
    var tmp;
    if (_this__u8e3s4 instanceof PublishedInstanceId) {
      tmp = new RemoteInstanceId(_this__u8e3s4.eef_1);
    } else {
      if (_this__u8e3s4 instanceof RemoteInstanceId) {
        tmp = new PublishedInstanceId(_this__u8e3s4.hef_1);
      } else {
        noWhenBranchMatchedException();
      }
    }
    return tmp;
  }
  function ImmediateMethodHandle() {
  }
  function InstanceDescriptor() {
    var tmp = this;
    // Inline function 'kotlin.collections.hashMapOf' call
    tmp.jef_1 = HashMap_init_$Create$();
  }
  protoOf(InstanceDescriptor).lef = function (method) {
    var tmp0 = this.jef_1;
    // Inline function 'kotlin.collections.set' call
    var key = method.z3n();
    tmp0.t2(key, method);
  };
  function InstancePublication() {
  }
  function LocalInstancePublication(instance, id, facade, publicationDisposal) {
    this.nef_1 = publicationDisposal;
    this.oef_1 = instance;
    this.pef_1 = id;
    this.qef_1 = facade;
  }
  protoOf(LocalInstancePublication).b3c = function () {
    return this.oef_1;
  };
  protoOf(LocalInstancePublication).z3n = function () {
    return this.pef_1;
  };
  protoOf(LocalInstancePublication).mef = function () {
    return this.qef_1;
  };
  protoOf(LocalInstancePublication).zr = function () {
    this.nef_1.zr();
  };
  protoOf(LocalInstancePublication).j2l = function (disposable) {
    return this.nef_1.j2l(disposable);
  };
  function RemoteInstancePublication(id, endpoint, instance) {
    this.ref_1 = id;
    this.sef_1 = endpoint;
    this.tef_1 = instance;
  }
  protoOf(RemoteInstancePublication).z3n = function () {
    return this.ref_1;
  };
  protoOf(RemoteInstancePublication).b3c = function () {
    return this.tef_1;
  };
  protoOf(RemoteInstancePublication).zr = function () {
    this.sef_1.zr();
  };
  protoOf(RemoteInstancePublication).mef = function () {
    return this.sef_1.mef();
  };
  function InstancePublicationSerializer(instanceDescriptor) {
    this.uef_1 = instanceDescriptor;
    this.vef_1 = Companion_getInstance_273().i63();
    this.wef_1 = this.vef_1.v58();
  }
  protoOf(InstancePublicationSerializer).v58 = function () {
    return this.wef_1;
  };
  protoOf(InstancePublicationSerializer).j59 = function (decoder) {
    var _destruct__k2r9zo = decoder.k59(this.vef_1);
    var facade = _destruct__k2r9zo.fg();
    var id = _destruct__k2r9zo.gg();
    var tmp;
    if (id instanceof PublishedInstanceId) {
      tmp = facade.beg(id, this.uef_1);
    } else {
      if (id instanceof RemoteInstanceId) {
        tmp = facade.aeg(id, this.uef_1);
      } else {
        noWhenBranchMatchedException();
      }
    }
    return tmp;
  };
  protoOf(InstancePublicationSerializer).ceg = function (encoder, value) {
    var transfer = new InstancePublicationTransfer(value.mef(), value.z3n());
    encoder.h59(this.vef_1, transfer);
  };
  protoOf(InstancePublicationSerializer).i59 = function (encoder, value) {
    return this.ceg(encoder, (!(value == null) ? isInterface(value, InstancePublication) : false) ? value : THROW_CCE());
  };
  function InstancePublicationTransfer$Companion$$childSerializers$_anonymous__e0vb3s() {
    var tmp = getKClass(RpcFacade);
    var tmp_0 = getKClass(RpcFacade);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$2 = [];
    var tmp_1 = PolymorphicSerializer_init_$Create$(tmp_0, tmp$ret$2);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$5 = [];
    return new ContextualSerializer(tmp, tmp_1, tmp$ret$5);
  }
  function InstancePublicationTransfer$Companion$$childSerializers$_anonymous__e0vb3s_0() {
    var tmp = getKClass(InstanceId);
    var tmp_0 = Companion_getInstance_270().i63();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$2 = [];
    return new ContextualSerializer(tmp, tmp_0, tmp$ret$2);
  }
  function Companion_273() {
    Companion_instance_273 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_1 = lazy_0(tmp_0, InstancePublicationTransfer$Companion$$childSerializers$_anonymous__e0vb3s);
    var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.xef_1 = [tmp_1, lazy_0(tmp_2, InstancePublicationTransfer$Companion$$childSerializers$_anonymous__e0vb3s_0)];
  }
  protoOf(Companion_273).i63 = function () {
    return $serializer_getInstance_9();
  };
  var Companion_instance_273;
  function Companion_getInstance_273() {
    if (Companion_instance_273 == null)
      new Companion_273();
    return Companion_instance_273;
  }
  function $serializer_9() {
    $serializer_instance_9 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('jetbrains.ocelot.langDef.rpc.InstancePublicationTransfer', this, 2);
    tmp0_serialDesc.q5j('facade', false);
    tmp0_serialDesc.q5j('id', false);
    this.deg_1 = tmp0_serialDesc;
  }
  protoOf($serializer_9).eeg = function (encoder, value) {
    var tmp0_desc = this.deg_1;
    var tmp1_output = encoder.g5c(tmp0_desc);
    var tmp2_cached = Companion_getInstance_273().xef_1;
    tmp1_output.w5d(tmp0_desc, 0, tmp2_cached[0].a1(), value.yef_1);
    tmp1_output.w5d(tmp0_desc, 1, tmp2_cached[1].a1(), value.zef_1);
    tmp1_output.h5c(tmp0_desc);
  };
  protoOf($serializer_9).i59 = function (encoder, value) {
    return this.eeg(encoder, value instanceof InstancePublicationTransfer ? value : THROW_CCE());
  };
  protoOf($serializer_9).j59 = function (decoder) {
    var tmp0_desc = this.deg_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.g5c(tmp0_desc);
    var tmp7_cached = Companion_getInstance_273().xef_1;
    if (tmp6_input.v5c()) {
      tmp4_local0 = tmp6_input.s5c(tmp0_desc, 0, tmp7_cached[0].a1(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.s5c(tmp0_desc, 1, tmp7_cached[1].a1(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.w5c(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.s5c(tmp0_desc, 0, tmp7_cached[0].a1(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.s5c(tmp0_desc, 1, tmp7_cached[1].a1(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.h5c(tmp0_desc);
    return InstancePublicationTransfer_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_9).v58 = function () {
    return this.deg_1;
  };
  protoOf($serializer_9).f5k = function () {
    var tmp0_cached = Companion_getInstance_273().xef_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0].a1(), tmp0_cached[1].a1()];
  };
  var $serializer_instance_9;
  function $serializer_getInstance_9() {
    if ($serializer_instance_9 == null)
      new $serializer_9();
    return $serializer_instance_9;
  }
  function InstancePublicationTransfer_init_$Init$(seen0, facade, id, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_9().deg_1);
    }
    $this.yef_1 = facade;
    $this.zef_1 = id;
    return $this;
  }
  function InstancePublicationTransfer_init_$Create$(seen0, facade, id, serializationConstructorMarker) {
    return InstancePublicationTransfer_init_$Init$(seen0, facade, id, serializationConstructorMarker, objectCreate(protoOf(InstancePublicationTransfer)));
  }
  function InstancePublicationTransfer(facade, id) {
    Companion_getInstance_273();
    this.yef_1 = facade;
    this.zef_1 = id;
  }
  protoOf(InstancePublicationTransfer).fg = function () {
    return this.yef_1;
  };
  protoOf(InstancePublicationTransfer).gg = function () {
    return this.zef_1;
  };
  protoOf(InstancePublicationTransfer).toString = function () {
    return 'InstancePublicationTransfer(facade=' + toString_1(this.yef_1) + ', id=' + this.zef_1.toString() + ')';
  };
  protoOf(InstancePublicationTransfer).hashCode = function () {
    var result = hashCode(this.yef_1);
    result = imul(result, 31) + hashCode(this.zef_1) | 0;
    return result;
  };
  protoOf(InstancePublicationTransfer).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof InstancePublicationTransfer))
      return false;
    if (!equals(this.yef_1, other.yef_1))
      return false;
    if (!equals(this.zef_1, other.zef_1))
      return false;
    return true;
  };
  function OppositeInstanceIdSerializer() {
    OppositeInstanceIdSerializer_instance = this;
    this.feg_1 = Companion_getInstance_270().i63().v58();
  }
  protoOf(OppositeInstanceIdSerializer).v58 = function () {
    return this.feg_1;
  };
  protoOf(OppositeInstanceIdSerializer).j59 = function (decoder) {
    return get_opposite(decoder.k59(Companion_getInstance_270().i63()));
  };
  protoOf(OppositeInstanceIdSerializer).geg = function (encoder, value) {
    return encoder.h59(Companion_getInstance_270().i63(), get_opposite(value));
  };
  protoOf(OppositeInstanceIdSerializer).i59 = function (encoder, value) {
    return this.geg(encoder, value instanceof InstanceId ? value : THROW_CCE());
  };
  var OppositeInstanceIdSerializer_instance;
  function OppositeInstanceIdSerializer_getInstance() {
    if (OppositeInstanceIdSerializer_instance == null)
      new OppositeInstanceIdSerializer();
    return OppositeInstanceIdSerializer_instance;
  }
  function method(_this__u8e3s4, id, parameterSerializer, resultSerializer, handle) {
    var descriptor = new MethodDescriptorImpl(new MethodId(id), parameterSerializer, resultSerializer, handle);
    _this__u8e3s4.lef(descriptor);
    return descriptor;
  }
  function MethodDescriptorImpl(id, parameterSerializer, resultSerializer, handle) {
    this.heg_1 = id;
    this.ieg_1 = parameterSerializer;
    this.jeg_1 = resultSerializer;
    this.keg_1 = handle;
  }
  protoOf(MethodDescriptorImpl).z3n = function () {
    return this.heg_1;
  };
  protoOf(MethodDescriptorImpl).leg = function () {
    return this.ieg_1;
  };
  protoOf(MethodDescriptorImpl).meg = function () {
    return this.jeg_1;
  };
  protoOf(MethodDescriptorImpl).neg = function (instance, parameter, $completion) {
    return this.keg_1(instance, parameter, $completion);
  };
  protoOf(MethodDescriptorImpl).oeg = function (endpoint, parameter, $completion) {
    return endpoint.peg(this.heg_1, this.ieg_1, this.jeg_1, parameter, $completion);
  };
  function RemoteInvocationException(message) {
    RuntimeException_init_$Init$_0(message, this);
    captureStack(this, RemoteInvocationException);
  }
  function CallRemote(instanceId, methodId, parameter, result) {
    RpcEndpointMethod.call(this, result);
    this.reg_1 = instanceId;
    this.seg_1 = methodId;
    this.teg_1 = parameter;
    this.ueg_1 = result;
  }
  protoOf(CallRemote).toString = function () {
    return 'CallRemote(instanceId=' + this.reg_1.toString() + ', methodId=' + this.seg_1.toString() + ', parameter=' + toString_1(this.teg_1) + ', result=' + toString_1(this.ueg_1) + ')';
  };
  protoOf(CallRemote).hashCode = function () {
    var result = this.reg_1.hashCode();
    result = imul(result, 31) + this.seg_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.teg_1) | 0;
    result = imul(result, 31) + hashCode(this.ueg_1) | 0;
    return result;
  };
  protoOf(CallRemote).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CallRemote))
      return false;
    if (!this.reg_1.equals(other.reg_1))
      return false;
    if (!this.seg_1.equals(other.seg_1))
      return false;
    if (!equals(this.teg_1, other.teg_1))
      return false;
    if (!equals(this.ueg_1, other.ueg_1))
      return false;
    return true;
  };
  function DisposeRemote(instanceId) {
    RpcEndpointMethod.call(this, Job_0());
    this.xeg_1 = instanceId;
  }
  protoOf(DisposeRemote).toString = function () {
    return 'DisposeRemote(instanceId=' + this.xeg_1.toString() + ')';
  };
  protoOf(DisposeRemote).hashCode = function () {
    return this.xeg_1.hashCode();
  };
  protoOf(DisposeRemote).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof DisposeRemote))
      return false;
    if (!this.xeg_1.equals(other.xeg_1))
      return false;
    return true;
  };
  function RpcEndpointMethod(job) {
    this.veg_1 = job;
  }
  protoOf(RpcEndpointMethod).zp = function (child) {
    return this.veg_1.zp(child);
  };
  protoOf(RpcEndpointMethod).rp = function (cause) {
    this.veg_1.rp(cause);
  };
  protoOf(RpcEndpointMethod).hp = function () {
    return this.veg_1.hp();
  };
  protoOf(RpcEndpointMethod).lp = function (onCancelling, invokeImmediately, handler) {
    return this.veg_1.lp(onCancelling, invokeImmediately, handler);
  };
  protoOf(RpcEndpointMethod).kp = function (handler) {
    return this.veg_1.kp(handler);
  };
  protoOf(RpcEndpointMethod).np = function ($completion) {
    return this.veg_1.np($completion);
  };
  protoOf(RpcEndpointMethod).wi = function (context) {
    return this.veg_1.wi(context);
  };
  protoOf(RpcEndpointMethod).fp = function () {
    return this.veg_1.fp();
  };
  protoOf(RpcEndpointMethod).io = function () {
    return this.veg_1.io();
  };
  protoOf(RpcEndpointMethod).dp = function () {
    return this.veg_1.dp();
  };
  protoOf(RpcEndpointMethod).op = function () {
    return this.veg_1.op();
  };
  protoOf(RpcEndpointMethod).bp = function () {
    return this.veg_1.bp();
  };
  protoOf(RpcEndpointMethod).s9 = function (key) {
    return this.veg_1.s9(key);
  };
  protoOf(RpcEndpointMethod).vi = function (initial, operation) {
    return this.veg_1.vi(initial, operation);
  };
  protoOf(RpcEndpointMethod).ui = function (key) {
    return this.veg_1.ui(key);
  };
  protoOf(RpcEndpointMethod).z = function () {
    return this.veg_1.z();
  };
  function RpcFacade() {
  }
  function RpcFacadeCancellationException() {
    CancellationException_init_$Init$_0('RPC facade has been disposed', this);
    captureStack(this, RpcFacadeCancellationException);
  }
  function get_LOG_0() {
    _init_properties_RpcFacadeImpl_kt__t7eclv();
    return LOG_0;
  }
  var LOG_0;
  function rpcFacade(_this__u8e3s4, incoming, outgoing, newCoroutineContext) {
    newCoroutineContext = newCoroutineContext === VOID ? EmptyCoroutineContext_instance : newCoroutineContext;
    _init_properties_RpcFacadeImpl_kt__t7eclv();
    var channel = Channel(2147483647, VOID, rpcFacade$lambda);
    var job = Job_0(get_job(_this__u8e3s4.ho()));
    var facade = new RpcFacadeImpl(channel, job);
    var publisher = facade.deh_1;
    var tmp = newCoroutineContext.wi(facade.beh_1);
    var tmp_0 = launch(_this__u8e3s4, tmp, VOID, rpcFacade$slambda_0(outgoing, publisher, incoming, job, channel, null));
    tmp_0.kp(rpcFacade$lambda_0(outgoing, channel, publisher));
    return facade;
  }
  function $callRemoteCOROUTINE$(_this__u8e3s4, methodId, parameterSerializer, resultSerializer, parameter, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.meh_1 = _this__u8e3s4;
    this.neh_1 = methodId;
    this.oeh_1 = parameterSerializer;
    this.peh_1 = resultSerializer;
    this.qeh_1 = parameter;
  }
  protoOf($callRemoteCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 6;
            this.seh_1 = this.meh_1.xeh_1.ceh_1.veh_1.a5a(this.oeh_1, this.qeh_1);
            this.reh_1 = CompletableDeferred();
            var tmp_0 = this;
            tmp_0.teh_1 = this.meh_1.xeh_1;
            this.f9_1 = 1;
            continue $sm;
          case 1:
            this.teh_1;
            this.g9_1 = 5;
            this.f9_1 = 2;
            suspendResult = this.meh_1.xeh_1.aeh_1.z15(new CallRemote(this.meh_1.weh_1, this.neh_1, this.seh_1, this.reh_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.f9_1 = 3;
            suspendResult = this.reh_1.nr(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            var resultBytes = suspendResult;
            var tmp_1 = this;
            return this.meh_1.xeh_1.ceh_1.ueh_1.b5a(this.peh_1, resultBytes);
          case 4:
            return Unit_instance;
          case 5:
            this.g9_1 = 6;
            var tmp_2 = this.i9_1;
            if (tmp_2 instanceof CancellationException) {
              var exception = this.i9_1;
              throw new RpcFacadeCancellationException();
            } else {
              throw this.i9_1;
            }

          case 6:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 6) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function RpcEndpointImpl($outer, instanceId) {
    this.xeh_1 = $outer;
    this.weh_1 = instanceId;
  }
  protoOf(RpcEndpointImpl).mef = function () {
    return this.xeh_1;
  };
  protoOf(RpcEndpointImpl).zr = function () {
    this.xeh_1;
    $l$block: {
      // Inline function 'jetbrains.ocelot.langDef.rpc.RpcFacadeImpl.coerceCancellation' call
      try {
        ChannelResult__getOrThrow_impl_od1axs(this.xeh_1.aeh_1.a16(new DisposeRemote(this.weh_1)));
        break $l$block;
      } catch ($p) {
        if ($p instanceof CancellationException) {
          var exception = $p;
          throw new RpcFacadeCancellationException();
        } else {
          throw $p;
        }
      }
    }
  };
  protoOf(RpcEndpointImpl).peg = function (methodId, parameterSerializer, resultSerializer, parameter, $completion) {
    var tmp = new $callRemoteCOROUTINE$(this, methodId, parameterSerializer, resultSerializer, parameter, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  function sam$jetbrains_ocelot_base_disposable_Disposable$0_6(function_0) {
    this.yeh_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0_6).zr = function () {
    return this.yeh_1();
  };
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0_6).f3 = function () {
    return this.yeh_1;
  };
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0_6).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Disposable) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0_6).hashCode = function () {
    return hashCode(this.f3());
  };
  function sam$jetbrains_ocelot_base_disposable_Disposable$0_7(function_0) {
    this.zeh_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0_7).zr = function () {
    return this.zeh_1();
  };
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0_7).f3 = function () {
    return this.zeh_1;
  };
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0_7).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Disposable) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0_7).hashCode = function () {
    return hashCode(this.f3());
  };
  function RpcFacadeImpl$publishInstance$lambda($instanceId) {
    return function () {
      return 'Processed publishInstance(): ' + $instanceId.toString();
    };
  }
  function RpcFacadeImpl$publishInstance$lambda_0(this$0, $instanceId) {
    return function () {
      this$0.deh_1.eei($instanceId);
      return Unit_instance;
    };
  }
  function RpcFacadeImpl$obtainLocalInstance$lambda(this$0, $instanceId) {
    return function () {
      this$0.deh_1.eei($instanceId);
      return Unit_instance;
    };
  }
  function RpcFacadeImpl(channel, job) {
    this.aeh_1 = channel;
    this.beh_1 = job;
    this.ceh_1 = new BinaryFormatsImpl(this);
    this.deh_1 = new RpcInstancesPublisher(this.ceh_1);
  }
  protoOf(RpcFacadeImpl).gw = function () {
    return this.beh_1;
  };
  protoOf(RpcFacadeImpl).yeg = function (instance, instanceDescriptor, instanceDisposal, $completion) {
    var entry = new PublicationEntry(instance, instanceDescriptor, instanceDisposal);
    var instanceId = this.deh_1.fei(entry);
    var tmp = get_LOG_0();
    tmp.a2q(RpcFacadeImpl$publishInstance$lambda(instanceId));
    var tmp_0 = RpcFacadeImpl$publishInstance$lambda_0(this, instanceId);
    return new LocalInstancePublication(entry.gei_1, instanceId, this, new sam$jetbrains_ocelot_base_disposable_Disposable$0_6(tmp_0));
  };
  protoOf(RpcFacadeImpl).aeg = function (instanceId, instanceDescriptor) {
    var endpoint = new RpcEndpointImpl(this, instanceId);
    return new RemoteInstancePublication(instanceId, endpoint, instanceDescriptor.kef(endpoint));
  };
  protoOf(RpcFacadeImpl).beg = function (instanceId, instanceDescriptor) {
    var instance = this.deh_1.jei(instanceId);
    var tmp = RpcFacadeImpl$obtainLocalInstance$lambda(this, instanceId);
    return new LocalInstancePublication(instance, instanceId, this, new sam$jetbrains_ocelot_base_disposable_Disposable$0_7(tmp));
  };
  function rpcIncomingMessagesProcessor(_this__u8e3s4, messages, outgoingCalls, incomingCalls, publisher, facadeJob) {
    _init_properties_RpcFacadeImpl_kt__t7eclv();
    launch(_this__u8e3s4, VOID, VOID, rpcIncomingMessagesProcessor$slambda_0(messages, incomingCalls, publisher, outgoingCalls, facadeJob, null));
  }
  function rpcOutgoingCallsProcessor(_this__u8e3s4, messages, outgoing, outgoingCalls) {
    _init_properties_RpcFacadeImpl_kt__t7eclv();
    launch(_this__u8e3s4, VOID, VOID, rpcOutgoingCallsProcessor$slambda_0(messages, outgoingCalls, outgoing, null));
  }
  function BinaryFormatsImpl$incoming$lambda($facade) {
    return function ($this$ProtoBuf) {
      var tmp = $this$ProtoBuf;
      // Inline function 'kotlinx.serialization.modules.SerializersModule' call
      var builder = new SerializersModuleBuilder();
      builder.k5t(getKClass(RpcFacade), new RpcFacadeIntrinsicSerializer($facade));
      builder.k5t(getKClass(InstanceId), Companion_getInstance_270().i63());
      tmp.re8_1 = builder.t5h();
      return Unit_instance;
    };
  }
  function BinaryFormatsImpl$outgoing$lambda($facade) {
    return function ($this$ProtoBuf) {
      var tmp = $this$ProtoBuf;
      // Inline function 'kotlinx.serialization.modules.SerializersModule' call
      var builder = new SerializersModuleBuilder();
      builder.k5t(getKClass(RpcFacade), new RpcFacadeIntrinsicSerializer($facade));
      builder.k5t(getKClass(InstanceId), OppositeInstanceIdSerializer_getInstance());
      tmp.re8_1 = builder.t5h();
      return Unit_instance;
    };
  }
  function BinaryFormatsImpl(facade) {
    var tmp = this;
    tmp.ueh_1 = ProtoBuf_0(VOID, BinaryFormatsImpl$incoming$lambda(facade));
    var tmp_0 = this;
    tmp_0.veh_1 = ProtoBuf_0(VOID, BinaryFormatsImpl$outgoing$lambda(facade));
  }
  protoOf(BinaryFormatsImpl).te0 = function () {
    return this.ueh_1;
  };
  protoOf(BinaryFormatsImpl).ue0 = function () {
    return this.veh_1;
  };
  function LOG$lambda_0() {
    _init_properties_RpcFacadeImpl_kt__t7eclv();
    return Unit_instance;
  }
  function rpcFacade$lambda(it) {
    _init_properties_RpcFacadeImpl_kt__t7eclv();
    it.sp();
    return Unit_instance;
  }
  function rpcFacade$slambda($outgoing, $publisher, $incoming, $job, $channel, resultContinuation) {
    this.sei_1 = $outgoing;
    this.tei_1 = $publisher;
    this.uei_1 = $incoming;
    this.vei_1 = $job;
    this.wei_1 = $channel;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(rpcFacade$slambda).e1h = function ($this$launch, $completion) {
    var tmp = this.f1h($this$launch, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(rpcFacade$slambda).v9 = function (p1, $completion) {
    return this.e1h((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(rpcFacade$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        if (tmp === 0) {
          this.g9_1 = 1;
          var outgoingCalls = rpcOutgoingCalls(this.xei_1);
          var incomingCalls = rpcIncomingCalls(this.xei_1, this.sei_1, this.tei_1);
          rpcIncomingMessagesProcessor(this.xei_1, this.uei_1, outgoingCalls, incomingCalls, this.tei_1, this.vei_1);
          rpcOutgoingCallsProcessor(this.xei_1, this.wei_1, this.sei_1, outgoingCalls);
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(rpcFacade$slambda).f1h = function ($this$launch, completion) {
    var i = new rpcFacade$slambda(this.sei_1, this.tei_1, this.uei_1, this.vei_1, this.wei_1, completion);
    i.xei_1 = $this$launch;
    return i;
  };
  function rpcFacade$slambda_0($outgoing, $publisher, $incoming, $job, $channel, resultContinuation) {
    var i = new rpcFacade$slambda($outgoing, $publisher, $incoming, $job, $channel, resultContinuation);
    var l = function ($this$launch, $completion) {
      return i.e1h($this$launch, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function rpcFacade$lambda_0($outgoing, $channel, $publisher) {
    return function (it) {
      $outgoing.i16();
      $channel.k16();
      $publisher.zr();
      return Unit_instance;
    };
  }
  function rpcIncomingMessagesProcessor$slambda$lambda($$this$with) {
    return function () {
      return 'Received call request with id ' + $$this$with.yei_1.toString() + ', instance ' + $$this$with.zei_1.toString() + ', method ' + $$this$with.aej_1.toString();
    };
  }
  function rpcIncomingMessagesProcessor$slambda$lambda_0($instanceId) {
    return function () {
      return 'Received dispose request with of instance ' + $instanceId.toString();
    };
  }
  function rpcIncomingMessagesProcessor$slambda$lambda_1() {
    return 'Error during handling dispose request';
  }
  function rpcIncomingMessagesProcessor$slambda$lambda_2($message) {
    return function () {
      return 'Received answer response for call ' + $message.cej_1.toString();
    };
  }
  function rpcIncomingMessagesProcessor$slambda$lambda_3($message) {
    return function () {
      return 'Received error answer response for call ' + $message.eej_1.toString();
    };
  }
  function rpcIncomingMessagesProcessor$slambda($messages, $incomingCalls, $publisher, $outgoingCalls, $facadeJob, resultContinuation) {
    this.oej_1 = $messages;
    this.pej_1 = $incomingCalls;
    this.qej_1 = $publisher;
    this.rej_1 = $outgoingCalls;
    this.sej_1 = $facadeJob;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(rpcIncomingMessagesProcessor$slambda).e1h = function ($this$launch, $completion) {
    var tmp = this.f1h($this$launch, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(rpcIncomingMessagesProcessor$slambda).v9 = function (p1, $completion) {
    return this.e1h((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(rpcIncomingMessagesProcessor$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 11;
            this.f9_1 = 1;
            continue $sm;
          case 1:
            this.g9_1 = 10;
            this.uej_1 = this.oej_1.m();
            this.f9_1 = 2;
            continue $sm;
          case 2:
            this.f9_1 = 3;
            suspendResult = this.uej_1.d14(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            if (!suspendResult) {
              this.f9_1 = 8;
              continue $sm;
            }

            var message = this.uej_1.o();
            if (message instanceof Call) {
              var tmp_0 = get_LOG_0();
              tmp_0.a2q(rpcIncomingMessagesProcessor$slambda$lambda(message));
              this.f9_1 = 6;
              suspendResult = this.pej_1.cek(message.yei_1, get_published(message.zei_1), message.aej_1, message.bej_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              if (message instanceof Dispose) {
                try {
                  var instanceId = get_published(message.yej_1);
                  var tmp_1 = get_LOG_0();
                  tmp_1.a2q(rpcIncomingMessagesProcessor$slambda$lambda_0(instanceId));
                  this.qej_1.eei(instanceId);
                } catch ($p) {
                  if ($p instanceof Exception) {
                    var e = $p;
                    var tmp_2 = get_LOG_0();
                    tmp_2.h2q(e, rpcIncomingMessagesProcessor$slambda$lambda_1);
                  } else {
                    throw $p;
                  }
                }
                this.f9_1 = 7;
                continue $sm;
              } else {
                if (message instanceof Answer) {
                  var tmp_3 = get_LOG_0();
                  tmp_3.a2q(rpcIncomingMessagesProcessor$slambda$lambda_2(message));
                  this.f9_1 = 5;
                  suspendResult = this.rej_1.xej(message.cej_1, message.dej_1, this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  continue $sm;
                } else {
                  if (message instanceof ErrorAnswer) {
                    var tmp_4 = get_LOG_0();
                    tmp_4.a2q(rpcIncomingMessagesProcessor$slambda$lambda_3(message));
                    this.f9_1 = 4;
                    suspendResult = this.rej_1.wej(message.eej_1, message.fej_1, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) {
                      return suspendResult;
                    }
                    continue $sm;
                  } else {
                    noWhenBranchMatchedException();
                  }
                }
              }
            }

            break;
          case 4:
            this.f9_1 = 7;
            continue $sm;
          case 5:
            this.f9_1 = 7;
            continue $sm;
          case 6:
            this.f9_1 = 7;
            continue $sm;
          case 7:
            this.f9_1 = 2;
            continue $sm;
          case 8:
            this.g9_1 = 11;
            this.f9_1 = 9;
            continue $sm;
          case 9:
            this.g9_1 = 11;
            this.sej_1.sp();
            return Unit_instance;
          case 10:
            this.g9_1 = 11;
            var t = this.i9_1;
            this.sej_1.sp();
            throw t;
          case 11:
            throw this.i9_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.g9_1 === 11) {
          throw e_0;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(rpcIncomingMessagesProcessor$slambda).f1h = function ($this$launch, completion) {
    var i = new rpcIncomingMessagesProcessor$slambda(this.oej_1, this.pej_1, this.qej_1, this.rej_1, this.sej_1, completion);
    i.tej_1 = $this$launch;
    return i;
  };
  function rpcIncomingMessagesProcessor$slambda_0($messages, $incomingCalls, $publisher, $outgoingCalls, $facadeJob, resultContinuation) {
    var i = new rpcIncomingMessagesProcessor$slambda($messages, $incomingCalls, $publisher, $outgoingCalls, $facadeJob, resultContinuation);
    var l = function ($this$launch, $completion) {
      return i.e1h($this$launch, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function rpcOutgoingCallsProcessor$slambda$lambda($message, $callId) {
    return function () {
      return 'Processed callRemote(' + $message.reg_1.toString() + ', ' + $message.seg_1.toString() + '): ' + $callId.toString();
    };
  }
  function rpcOutgoingCallsProcessor$slambda$lambda_0($message) {
    return function () {
      return 'Processed disposeRemote(' + $message.xeg_1.toString() + ')';
    };
  }
  function rpcOutgoingCallsProcessor$slambda$lambda_1() {
    return 'RPC facade is disposed';
  }
  function rpcOutgoingCallsProcessor$slambda($messages, $outgoingCalls, $outgoing, resultContinuation) {
    this.lek_1 = $messages;
    this.mek_1 = $outgoingCalls;
    this.nek_1 = $outgoing;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(rpcOutgoingCallsProcessor$slambda).e1h = function ($this$launch, $completion) {
    var tmp = this.f1h($this$launch, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(rpcOutgoingCallsProcessor$slambda).v9 = function (p1, $completion) {
    return this.e1h((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(rpcOutgoingCallsProcessor$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 11;
            this.f9_1 = 1;
            continue $sm;
          case 1:
            this.g9_1 = 10;
            this.rek_1 = this.lek_1.m();
            this.f9_1 = 2;
            continue $sm;
          case 2:
            this.f9_1 = 3;
            suspendResult = this.rek_1.d14(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            if (!suspendResult) {
              this.f9_1 = 8;
              continue $sm;
            }

            this.qek_1 = this.rek_1.o();
            var tmp0_subject = this.qek_1;
            if (tmp0_subject instanceof CallRemote) {
              this.f9_1 = 5;
              suspendResult = this.mek_1.sek(this.qek_1.ueg_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              if (tmp0_subject instanceof DisposeRemote) {
                this.f9_1 = 4;
                suspendResult = this.nek_1.z15(new Dispose(this.qek_1.xeg_1), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                noWhenBranchMatchedException();
              }
            }

            break;
          case 4:
            var tmp_0 = get_LOG_0();
            tmp_0.a2q(rpcOutgoingCallsProcessor$slambda$lambda_0(this.qek_1));
            this.f9_1 = 7;
            continue $sm;
          case 5:
            this.pek_1 = suspendResult;
            this.f9_1 = 6;
            suspendResult = this.nek_1.z15(new Call(this.pek_1, this.qek_1.reg_1, this.qek_1.seg_1, this.qek_1.teg_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 6:
            var tmp_1 = get_LOG_0();
            tmp_1.a2q(rpcOutgoingCallsProcessor$slambda$lambda(this.qek_1, this.pek_1));
            this.f9_1 = 7;
            continue $sm;
          case 7:
            this.f9_1 = 2;
            continue $sm;
          case 8:
            this.g9_1 = 11;
            this.f9_1 = 9;
            continue $sm;
          case 9:
            this.g9_1 = 11;
            var tmp_2 = get_LOG_0();
            tmp_2.x2p(rpcOutgoingCallsProcessor$slambda$lambda_1);
            return Unit_instance;
          case 10:
            this.g9_1 = 11;
            var t = this.i9_1;
            var tmp_3 = get_LOG_0();
            tmp_3.x2p(rpcOutgoingCallsProcessor$slambda$lambda_1);
            throw t;
          case 11:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 11) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(rpcOutgoingCallsProcessor$slambda).f1h = function ($this$launch, completion) {
    var i = new rpcOutgoingCallsProcessor$slambda(this.lek_1, this.mek_1, this.nek_1, completion);
    i.oek_1 = $this$launch;
    return i;
  };
  function rpcOutgoingCallsProcessor$slambda_0($messages, $outgoingCalls, $outgoing, resultContinuation) {
    var i = new rpcOutgoingCallsProcessor$slambda($messages, $outgoingCalls, $outgoing, resultContinuation);
    var l = function ($this$launch, $completion) {
      return i.e1h($this$launch, $completion);
    };
    l.$arity = 1;
    return l;
  }
  var properties_initialized_RpcFacadeImpl_kt_cmxezz;
  function _init_properties_RpcFacadeImpl_kt__t7eclv() {
    if (!properties_initialized_RpcFacadeImpl_kt_cmxezz) {
      properties_initialized_RpcFacadeImpl_kt_cmxezz = true;
      var tmp = KotlinLogging_getInstance();
      LOG_0 = tmp.i2q(LOG$lambda_0);
    }
  }
  function _get_$cachedSerializer__te6jhj_2($this) {
    return $this.tek_1.a1();
  }
  function RpcFacadeIntrinsicSerializer$RpcFacadeStub$_anonymous__8jv50q() {
    var tmp = RpcFacadeStub_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$2 = [];
    return ObjectSerializer_init_$Create$('jetbrains.ocelot.langDef.rpc.RpcFacadeIntrinsicSerializer.RpcFacadeStub', tmp, tmp$ret$2);
  }
  function RpcFacadeStub() {
    RpcFacadeStub_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.tek_1 = lazy_0(tmp_0, RpcFacadeIntrinsicSerializer$RpcFacadeStub$_anonymous__8jv50q);
  }
  protoOf(RpcFacadeStub).i63 = function () {
    return _get_$cachedSerializer__te6jhj_2(this);
  };
  protoOf(RpcFacadeStub).q5k = function (typeParamsSerializers) {
    return this.i63();
  };
  var RpcFacadeStub_instance;
  function RpcFacadeStub_getInstance() {
    if (RpcFacadeStub_instance == null)
      new RpcFacadeStub();
    return RpcFacadeStub_instance;
  }
  function RpcFacadeIntrinsicSerializer(facade) {
    this.uek_1 = facade;
    this.vek_1 = RpcFacadeStub_getInstance().i63().v58();
  }
  protoOf(RpcFacadeIntrinsicSerializer).v58 = function () {
    return this.vek_1;
  };
  protoOf(RpcFacadeIntrinsicSerializer).j59 = function (decoder) {
    decoder.k59(RpcFacadeStub_getInstance().i63());
    return this.uek_1;
  };
  protoOf(RpcFacadeIntrinsicSerializer).wek = function (encoder, value) {
    encoder.h59(RpcFacadeStub_getInstance().i63(), RpcFacadeStub_getInstance());
  };
  protoOf(RpcFacadeIntrinsicSerializer).i59 = function (encoder, value) {
    return this.wek(encoder, (!(value == null) ? isInterface(value, RpcFacade) : false) ? value : THROW_CCE());
  };
  function mixinFacade(_this__u8e3s4) {
    return new mixinFacade$1(_this__u8e3s4);
  }
  function RpcFacadeMixin$Companion$$childSerializers$_anonymous__iop008() {
    var tmp = getKClass(RpcFacade);
    var tmp_0 = getKClass(RpcFacade);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$2 = [];
    var tmp_1 = PolymorphicSerializer_init_$Create$(tmp_0, tmp$ret$2);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$5 = [];
    return new ContextualSerializer(tmp, tmp_1, tmp$ret$5);
  }
  function $serializer_init_$Init$(typeSerial0, $this) {
    $serializer_10.call($this);
    $this.yek_1 = typeSerial0;
    return $this;
  }
  function $serializer_init_$Create$(typeSerial0) {
    return $serializer_init_$Init$(typeSerial0, objectCreate(protoOf($serializer_10)));
  }
  function Companion_274() {
    Companion_instance_274 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.zek_1 = [lazy_0(tmp_0, RpcFacadeMixin$Companion$$childSerializers$_anonymous__iop008), null];
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('jetbrains.ocelot.langDef.rpc.RpcFacadeMixin', null, 2);
    tmp0_serialDesc.q5j('facade', false);
    tmp0_serialDesc.q5j('parameter', false);
    this.ael_1 = tmp0_serialDesc;
  }
  protoOf(Companion_274).bel = function (typeSerial0) {
    return $serializer_init_$Create$(typeSerial0);
  };
  protoOf(Companion_274).q5k = function (typeParamsSerializers) {
    return this.bel(typeParamsSerializers[0]);
  };
  var Companion_instance_274;
  function Companion_getInstance_274() {
    if (Companion_instance_274 == null)
      new Companion_274();
    return Companion_instance_274;
  }
  function $serializer_10() {
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('jetbrains.ocelot.langDef.rpc.RpcFacadeMixin', this, 2);
    tmp0_serialDesc.q5j('facade', false);
    tmp0_serialDesc.q5j('parameter', false);
    this.xek_1 = tmp0_serialDesc;
  }
  protoOf($serializer_10).cel = function (encoder, value) {
    var tmp0_desc = this.xek_1;
    var tmp1_output = encoder.g5c(tmp0_desc);
    var tmp2_cached = Companion_getInstance_274().zek_1;
    tmp1_output.w5d(tmp0_desc, 0, tmp2_cached[0].a1(), value.del_1);
    tmp1_output.w5d(tmp0_desc, 1, this.yek_1, value.eel_1);
    tmp1_output.h5c(tmp0_desc);
  };
  protoOf($serializer_10).i59 = function (encoder, value) {
    return this.cel(encoder, value instanceof RpcFacadeMixin ? value : THROW_CCE());
  };
  protoOf($serializer_10).j59 = function (decoder) {
    var tmp0_desc = this.xek_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.g5c(tmp0_desc);
    var tmp7_cached = Companion_getInstance_274().zek_1;
    if (tmp6_input.v5c()) {
      tmp4_local0 = tmp6_input.s5c(tmp0_desc, 0, tmp7_cached[0].a1(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.s5c(tmp0_desc, 1, this.yek_1, tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.w5c(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.s5c(tmp0_desc, 0, tmp7_cached[0].a1(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.s5c(tmp0_desc, 1, this.yek_1, tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.h5c(tmp0_desc);
    return RpcFacadeMixin_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_10).v58 = function () {
    return this.xek_1;
  };
  protoOf($serializer_10).f5k = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_274().zek_1[0].a1(), this.yek_1];
  };
  protoOf($serializer_10).g5k = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [this.yek_1];
  };
  function RpcFacadeMixin_init_$Init$(seen0, facade, parameter, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, Companion_getInstance_274().ael_1);
    }
    $this.del_1 = facade;
    $this.eel_1 = parameter;
    return $this;
  }
  function RpcFacadeMixin_init_$Create$(seen0, facade, parameter, serializationConstructorMarker) {
    return RpcFacadeMixin_init_$Init$(seen0, facade, parameter, serializationConstructorMarker, objectCreate(protoOf(RpcFacadeMixin)));
  }
  function RpcFacadeMixin(facade, parameter) {
    Companion_getInstance_274();
    this.del_1 = facade;
    this.eel_1 = parameter;
  }
  protoOf(RpcFacadeMixin).fg = function () {
    return this.del_1;
  };
  protoOf(RpcFacadeMixin).gg = function () {
    return this.eel_1;
  };
  protoOf(RpcFacadeMixin).toString = function () {
    return 'RpcFacadeMixin(facade=' + toString_1(this.del_1) + ', parameter=' + toString_0(this.eel_1) + ')';
  };
  protoOf(RpcFacadeMixin).hashCode = function () {
    var result = hashCode(this.del_1);
    result = imul(result, 31) + (this.eel_1 == null ? 0 : hashCode(this.eel_1)) | 0;
    return result;
  };
  protoOf(RpcFacadeMixin).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RpcFacadeMixin))
      return false;
    if (!equals(this.del_1, other.del_1))
      return false;
    if (!equals(this.eel_1, other.eel_1))
      return false;
    return true;
  };
  function get_withFacade(_this__u8e3s4) {
    return Companion_getInstance_274().bel(_this__u8e3s4);
  }
  function mixedTo(_this__u8e3s4, parameter) {
    return new RpcFacadeMixin(_this__u8e3s4, parameter);
  }
  function mixinFacade$1($this_mixinFacade) {
    this.fel_1 = $this_mixinFacade;
  }
  protoOf(mixinFacade$1).oeg = function (endpoint, parameter, $completion) {
    return this.fel_1.oeg(endpoint, mixedTo(endpoint.mef(), parameter), $completion);
  };
  function get_LOG_1() {
    _init_properties_RpcIncomingCalls_kt__keqp3e();
    return LOG_1;
  }
  var LOG_1;
  function RpcIncomingCalls$launchCall$slambda$lambda($callId) {
    return function () {
      return 'Execution of a call ' + $callId.toString() + ' completed successfully';
    };
  }
  function RpcIncomingCalls$launchCall$slambda$lambda_0($callId) {
    return function () {
      return 'Execution of a call ' + $callId.toString() + ' cancelled since RPC facade has been disposed';
    };
  }
  function RpcIncomingCalls$launchCall$slambda$lambda_1($callId, $it) {
    return function () {
      return 'Execution of a call ' + $callId.toString() + ' completed with an error: ' + $it.toString();
    };
  }
  function launchCall($this, callId, methodHandle, parameter) {
    launch($this.zej_1, VOID, VOID, RpcIncomingCalls$launchCall$slambda_0(methodHandle, parameter, $this, callId, null));
  }
  function RpcIncomingCalls$processCall$lambda($callId, $instanceId, $methodId) {
    return function () {
      return 'Processing a call ' + $callId.toString() + ', instance: ' + $instanceId.toString() + ', method: ' + $methodId.toString();
    };
  }
  function RpcIncomingCalls$processCall$lambda_0($callId, $instanceId, $methodId) {
    return function () {
      return 'Error during accessing a method for call ' + $callId.toString() + ' (instance: ' + $instanceId.toString() + ', method: ' + $methodId.toString() + ')';
    };
  }
  function RpcIncomingCalls$launchCall$slambda($methodHandle, $parameter, this$0, $callId, resultContinuation) {
    this.oel_1 = $methodHandle;
    this.pel_1 = $parameter;
    this.qel_1 = this$0;
    this.rel_1 = $callId;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(RpcIncomingCalls$launchCall$slambda).e1h = function ($this$launch, $completion) {
    var tmp = this.f1h($this$launch, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(RpcIncomingCalls$launchCall$slambda).v9 = function (p1, $completion) {
    return this.e1h((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(RpcIncomingCalls$launchCall$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 9;
            this.sel_1;
            this.g9_1 = 2;
            var tmp_0 = this;
            tmp_0.xel_1 = Companion_instance_17;
            this.f9_1 = 1;
            suspendResult = this.oel_1.bem(this.pel_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp2 = suspendResult;
            var tmp_1 = this;
            this.xel_1;
            tmp_1.wel_1 = _Result___init__impl__xyqfz8(tmp2);
            this.g9_1 = 9;
            this.f9_1 = 3;
            continue $sm;
          case 2:
            this.g9_1 = 9;
            var tmp_2 = this.i9_1;
            if (tmp_2 instanceof Error) {
              var e = this.i9_1;
              var tmp_3 = this;
              tmp_3.wel_1 = _Result___init__impl__xyqfz8(createFailure(e));
              this.f9_1 = 3;
              continue $sm;
            } else {
              throw this.i9_1;
            }

          case 3:
            this.g9_1 = 9;
            this.vel_1 = this.wel_1;
            if (_Result___get_isSuccess__impl__sndoy8(this.vel_1)) {
              var tmp_4 = _Result___get_value__impl__bjfvqg(this.vel_1);
              var it = (tmp_4 == null ? true : !(tmp_4 == null)) ? tmp_4 : THROW_CCE();
              var tmp_5 = get_LOG_1();
              tmp_5.a2q(RpcIncomingCalls$launchCall$slambda$lambda(this.rel_1));
              this.f9_1 = 4;
              suspendResult = this.qel_1.aek_1.z15(new Answer(this.rel_1, it), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.f9_1 = 5;
              continue $sm;
            }

          case 4:
            this.f9_1 = 5;
            continue $sm;
          case 5:
            this.tel_1 = this.vel_1;
            var tmp0_safe_receiver = Result__exceptionOrNull_impl_p6xea9(this.tel_1);
            if (tmp0_safe_receiver == null) {
              this.uel_1 = null;
              this.f9_1 = 8;
              continue $sm;
            } else {
              if (tmp0_safe_receiver instanceof CancellationException) {
                var tmp_6 = get_LOG_1();
                tmp_6.a2q(RpcIncomingCalls$launchCall$slambda$lambda_0(this.rel_1));
                this.f9_1 = 7;
                continue $sm;
              } else {
                var tmp_7 = get_LOG_1();
                tmp_7.e2q(tmp0_safe_receiver, RpcIncomingCalls$launchCall$slambda$lambda_1(this.rel_1, tmp0_safe_receiver));
                this.f9_1 = 6;
                suspendResult = this.qel_1.aek_1.z15(Companion_getInstance_279().dem(this.rel_1, this.oel_1.yel_1, this.oel_1.zel_1, tmp0_safe_receiver), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              }
            }

          case 6:
            this.f9_1 = 7;
            continue $sm;
          case 7:
            var tmp_8 = this;
            tmp_8.uel_1 = Unit_instance;
            this.f9_1 = 8;
            continue $sm;
          case 8:
            return Unit_instance;
          case 9:
            throw this.i9_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.g9_1 === 9) {
          throw e_0;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(RpcIncomingCalls$launchCall$slambda).f1h = function ($this$launch, completion) {
    var i = new RpcIncomingCalls$launchCall$slambda(this.oel_1, this.pel_1, this.qel_1, this.rel_1, completion);
    i.sel_1 = $this$launch;
    return i;
  };
  function RpcIncomingCalls$launchCall$slambda_0($methodHandle, $parameter, this$0, $callId, resultContinuation) {
    var i = new RpcIncomingCalls$launchCall$slambda($methodHandle, $parameter, this$0, $callId, resultContinuation);
    var l = function ($this$launch, $completion) {
      return i.e1h($this$launch, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function $processCallCOROUTINE$(_this__u8e3s4, callId, instanceId, methodId, parameter, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.mem_1 = _this__u8e3s4;
    this.nem_1 = callId;
    this.oem_1 = instanceId;
    this.pem_1 = methodId;
    this.qem_1 = parameter;
  }
  protoOf($processCallCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 4;
            var tmp_0 = get_LOG_1();
            tmp_0.a2q(RpcIncomingCalls$processCall$lambda(this.nem_1, this.oem_1, this.pem_1));
            this.g9_1 = 1;
            var tmp_1 = this;
            tmp_1.rem_1 = this.mem_1.bek_1.sem(this.oem_1, this.pem_1);
            this.g9_1 = 4;
            this.f9_1 = 3;
            continue $sm;
          case 1:
            this.g9_1 = 4;
            var tmp_2 = this.i9_1;
            if (tmp_2 instanceof Exception) {
              var e = this.i9_1;
              var tmp_3 = get_LOG_1();
              tmp_3.h2q(e, RpcIncomingCalls$processCall$lambda_0(this.nem_1, this.oem_1, this.pem_1));
              this.f9_1 = 2;
              suspendResult = this.mem_1.aek_1.z15(new ErrorAnswer(this.nem_1, ensureNotNull(e.message)), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              throw this.i9_1;
            }

          case 2:
            var tmp_4 = this;
            return Unit_instance;
          case 3:
            this.g9_1 = 4;
            var methodHandle = this.rem_1;
            launchCall(this.mem_1, this.nem_1, methodHandle, this.qem_1);
            return Unit_instance;
          case 4:
            throw this.i9_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.g9_1 === 4) {
          throw e_0;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e_0;
        }
      }
     while (true);
  };
  function RpcIncomingCalls(scope, outgoing, publisher) {
    this.zej_1 = scope;
    this.aek_1 = outgoing;
    this.bek_1 = publisher;
  }
  protoOf(RpcIncomingCalls).cek = function (callId, instanceId, methodId, parameter, $completion) {
    var tmp = new $processCallCOROUTINE$(this, callId, instanceId, methodId, parameter, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  function rpcIncomingCalls(_this__u8e3s4, outgoing, publisher) {
    _init_properties_RpcIncomingCalls_kt__keqp3e();
    return new RpcIncomingCalls(_this__u8e3s4, outgoing, publisher);
  }
  function LOG$lambda_1() {
    _init_properties_RpcIncomingCalls_kt__keqp3e();
    return Unit_instance;
  }
  var properties_initialized_RpcIncomingCalls_kt_x8oz58;
  function _init_properties_RpcIncomingCalls_kt__keqp3e() {
    if (!properties_initialized_RpcIncomingCalls_kt_x8oz58) {
      properties_initialized_RpcIncomingCalls_kt_x8oz58 = true;
      var tmp = KotlinLogging_getInstance();
      LOG_1 = tmp.i2q(LOG$lambda_1);
    }
  }
  function get_LOG_2() {
    _init_properties_RpcInstancesPublisher_kt__kqbo5r();
    return LOG_2;
  }
  var LOG_2;
  function RpcInstancesPublisher$publishInstance$lambda(this$0, $entry) {
    return function () {
      var _unary__edvuaz = this$0.cei_1;
      this$0.cei_1 = add_2(_unary__edvuaz, get_ONE());
      // Inline function 'kotlin.also' call
      var this_0 = new PublishedInstanceId(_unary__edvuaz);
      var tmp0 = this$0.dei_1;
      // Inline function 'kotlin.collections.set' call
      var value = $entry;
      tmp0.t2(this_0, value);
      return this_0;
    };
  }
  function RpcInstancesPublisher$publishInstance$lambda_0($id) {
    return function () {
      return 'Publishing instance with id: ' + $id.toString();
    };
  }
  function RpcInstancesPublisher$accessInstance$lambda(this$0, $id) {
    return function () {
      return this$0.dei_1.q2($id);
    };
  }
  function RpcInstancesPublisher$accessInstance$lambda_0($id) {
    return function () {
      return 'Accessing a non-published instance ' + $id.toString();
    };
  }
  function RpcInstancesPublisher$disposeInstance$lambda($instanceId) {
    return function () {
      return 'Disposing publication for instance ' + $instanceId.toString();
    };
  }
  function RpcInstancesPublisher$disposeInstance$lambda_0(this$0, $instanceId) {
    return function () {
      return this$0.dei_1.u2($instanceId);
    };
  }
  function RpcInstancesPublisher$disposeInstance$lambda_1($instanceId) {
    return function () {
      return 'Disposing occurred for a non-published instance ' + $instanceId.toString();
    };
  }
  function RpcInstancesPublisher$accessMethod$lambda($instanceId) {
    return function () {
      return 'Accessing method for published instance ' + $instanceId.toString();
    };
  }
  function RpcInstancesPublisher$accessMethod$lambda_0(this$0, $instanceId) {
    return function () {
      return this$0.dei_1.q2($instanceId);
    };
  }
  function RpcInstancesPublisher$accessMethod$lambda_1($instanceId) {
    return function () {
      return 'Accessing method for a non-published instance ' + $instanceId.toString();
    };
  }
  function RpcInstancesPublisher$accessMethod$lambda_2($methodId, $instanceId) {
    return function () {
      return 'Accessing non-existing method ' + $methodId.toString() + ' for an instance ' + $instanceId.toString();
    };
  }
  function RpcInstancesPublisher$dispose$lambda(this$0) {
    return function () {
      var _iterator__ex2g4s = this$0.dei_1.s2().m();
      while (_iterator__ex2g4s.n()) {
        var entry = _iterator__ex2g4s.o();
        entry.iei_1.zr();
      }
      return Unit_instance;
    };
  }
  function RpcInstancesPublisher(formats) {
    this.aei_1 = formats;
    this.bei_1 = newLock();
    this.cei_1 = 0n;
    var tmp = this;
    // Inline function 'kotlin.collections.hashMapOf' call
    tmp.dei_1 = HashMap_init_$Create$();
  }
  protoOf(RpcInstancesPublisher).fei = function (entry) {
    var id = this.bei_1.t2o(RpcInstancesPublisher$publishInstance$lambda(this, entry));
    var tmp = get_LOG_2();
    tmp.a2q(RpcInstancesPublisher$publishInstance$lambda_0(id));
    return id;
  };
  protoOf(RpcInstancesPublisher).jei = function (id) {
    var entry = this.bei_1.t2o(RpcInstancesPublisher$accessInstance$lambda(this, id));
    if (entry == null) {
      var tmp = get_LOG_2();
      tmp.f2q(RpcInstancesPublisher$accessInstance$lambda_0(id));
      throw new MissingInstanceException(id);
    }
    var tmp_0 = entry.gei_1;
    return !(tmp_0 == null) ? tmp_0 : THROW_CCE();
  };
  protoOf(RpcInstancesPublisher).eei = function (instanceId) {
    var tmp = get_LOG_2();
    tmp.a2q(RpcInstancesPublisher$disposeInstance$lambda(instanceId));
    var removed = this.bei_1.t2o(RpcInstancesPublisher$disposeInstance$lambda_0(this, instanceId));
    if (removed == null) {
      var tmp_0 = get_LOG_2();
      tmp_0.f2q(RpcInstancesPublisher$disposeInstance$lambda_1(instanceId));
      throw new MissingInstanceException(instanceId);
    }
    removed.iei_1.zr();
  };
  protoOf(RpcInstancesPublisher).sem = function (instanceId, methodId) {
    var tmp = get_LOG_2();
    tmp.a2q(RpcInstancesPublisher$accessMethod$lambda(instanceId));
    var entry = this.bei_1.t2o(RpcInstancesPublisher$accessMethod$lambda_0(this, instanceId));
    if (entry == null) {
      var tmp_0 = get_LOG_2();
      tmp_0.f2q(RpcInstancesPublisher$accessMethod$lambda_1(instanceId));
      throw new MissingInstanceException(instanceId);
    }
    var method = entry.tem(instanceId, methodId, this.aei_1);
    if (method == null) {
      var tmp_1 = get_LOG_2();
      tmp_1.f2q(RpcInstancesPublisher$accessMethod$lambda_2(methodId, instanceId));
      throw new MissingMethodException(instanceId, methodId);
    }
    return method;
  };
  protoOf(RpcInstancesPublisher).zr = function () {
    this.bei_1.t2o(RpcInstancesPublisher$dispose$lambda(this));
  };
  function asHandle($this, _this__u8e3s4, formats) {
    return PublicationEntry$asHandle$slambda_0(formats, _this__u8e3s4, $this, null);
  }
  function PublicationEntry$asHandle$slambda($formats, $this_asHandle, this$0, resultContinuation) {
    this.cen_1 = $formats;
    this.den_1 = $this_asHandle;
    this.een_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(PublicationEntry$asHandle$slambda).bem = function (parameterBytes, $completion) {
    var tmp = this.ien(parameterBytes, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(PublicationEntry$asHandle$slambda).v9 = function (p1, $completion) {
    return this.bem((!(p1 == null) ? isByteArray(p1) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(PublicationEntry$asHandle$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            var parameter = this.cen_1.te0().b5a(this.den_1.leg(), this.fen_1);
            this.hen_1 = this.cen_1.ue0();
            this.gen_1 = this.den_1.meg();
            this.f9_1 = 1;
            suspendResult = this.den_1.neg(this.een_1.gei_1, parameter, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            return this.hen_1.a5a(this.gen_1, ARGUMENT);
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(PublicationEntry$asHandle$slambda).ien = function (parameterBytes, completion) {
    var i = new PublicationEntry$asHandle$slambda(this.cen_1, this.den_1, this.een_1, completion);
    i.fen_1 = parameterBytes;
    return i;
  };
  function PublicationEntry$asHandle$slambda_0($formats, $this_asHandle, this$0, resultContinuation) {
    var i = new PublicationEntry$asHandle$slambda($formats, $this_asHandle, this$0, resultContinuation);
    var l = function (parameterBytes, $completion) {
      return i.bem(parameterBytes, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function PublicationEntry(instance, descriptor, instanceDisposal) {
    this.gei_1 = instance;
    this.hei_1 = descriptor;
    this.iei_1 = instanceDisposal;
  }
  protoOf(PublicationEntry).tem = function (instanceId, methodId, formats) {
    var tmp0_elvis_lhs = this.hei_1.jef_1.q2(methodId);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var descriptor = tmp;
    return new PublishedMethodHandle(instanceId, methodId, asHandle(this, descriptor, formats));
  };
  function MissingInstanceException(id) {
    RuntimeException_init_$Init$_0('Published instance not found with id: ' + id.toString(), this);
    captureStack(this, MissingInstanceException);
    this.jen_1 = id;
  }
  function PublishedMethodHandle(instanceId, methodId, handle) {
    this.yel_1 = instanceId;
    this.zel_1 = methodId;
    this.aem_1 = handle;
  }
  protoOf(PublishedMethodHandle).bem = function (array, $completion) {
    return this.aem_1(array, $completion);
  };
  function MissingMethodException(id, methodId) {
    RuntimeException_init_$Init$_0('Published instance ' + id.toString() + ' has no method with id: ' + methodId.toString(), this);
    captureStack(this, MissingMethodException);
    this.ken_1 = id;
    this.len_1 = methodId;
  }
  function LOG$lambda_2() {
    _init_properties_RpcInstancesPublisher_kt__kqbo5r();
    return Unit_instance;
  }
  var properties_initialized_RpcInstancesPublisher_kt_x0rcwd;
  function _init_properties_RpcInstancesPublisher_kt__kqbo5r() {
    if (!properties_initialized_RpcInstancesPublisher_kt_x0rcwd) {
      properties_initialized_RpcInstancesPublisher_kt_x0rcwd = true;
      var tmp = KotlinLogging_getInstance();
      LOG_2 = tmp.i2q(LOG$lambda_2);
    }
  }
  function RpcMessage$Call$Companion$$childSerializers$_anonymous__9isgeu() {
    return Companion_getInstance_270().i63();
  }
  function Companion_275() {
    Companion_instance_275 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.men_1 = [null, lazy_0(tmp_0, RpcMessage$Call$Companion$$childSerializers$_anonymous__9isgeu), null, null];
  }
  var Companion_instance_275;
  function Companion_getInstance_275() {
    if (Companion_instance_275 == null)
      new Companion_275();
    return Companion_instance_275;
  }
  function $serializer_11() {
    $serializer_instance_10 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('jetbrains.ocelot.langDef.rpc.RpcMessage.Call', this, 4);
    tmp0_serialDesc.q5j('callId', false);
    tmp0_serialDesc.q5j('instanceId', false);
    tmp0_serialDesc.q5j('methodId', false);
    tmp0_serialDesc.q5j('parameters', true);
    this.nen_1 = tmp0_serialDesc;
  }
  protoOf($serializer_11).oen = function (encoder, value) {
    var tmp0_desc = this.nen_1;
    var tmp1_output = encoder.g5c(tmp0_desc);
    var tmp2_cached = Companion_getInstance_275().men_1;
    tmp1_output.q5d(tmp0_desc, 0, value.yei_1);
    tmp1_output.w5d(tmp0_desc, 1, tmp2_cached[1].a1(), value.zei_1);
    tmp1_output.w5d(tmp0_desc, 2, $serializer_getInstance_6(), value.aej_1);
    if (tmp1_output.b5e(tmp0_desc, 3) ? true : !equals(value.bej_1, new Int8Array(0))) {
      tmp1_output.w5d(tmp0_desc, 3, ByteArraySerializer_getInstance(), value.bej_1);
    }
    tmp1_output.h5c(tmp0_desc);
  };
  protoOf($serializer_11).i59 = function (encoder, value) {
    return this.oen(encoder, value instanceof Call ? value : THROW_CCE());
  };
  protoOf($serializer_11).j59 = function (decoder) {
    var tmp0_desc = this.nen_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0n;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_input = decoder.g5c(tmp0_desc);
    var tmp9_cached = Companion_getInstance_275().men_1;
    if (tmp8_input.v5c()) {
      tmp4_local0 = tmp8_input.m5c(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.s5c(tmp0_desc, 1, tmp9_cached[1].a1(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.s5c(tmp0_desc, 2, $serializer_getInstance_6(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.s5c(tmp0_desc, 3, ByteArraySerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.w5c(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.m5c(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.s5c(tmp0_desc, 1, tmp9_cached[1].a1(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.s5c(tmp0_desc, 2, $serializer_getInstance_6(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.s5c(tmp0_desc, 3, ByteArraySerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp8_input.h5c(tmp0_desc);
    return Call_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  };
  protoOf($serializer_11).v58 = function () {
    return this.nen_1;
  };
  protoOf($serializer_11).f5k = function () {
    var tmp0_cached = Companion_getInstance_275().men_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [LongSerializer_getInstance(), tmp0_cached[1].a1(), $serializer_getInstance_6(), ByteArraySerializer_getInstance()];
  };
  var $serializer_instance_10;
  function $serializer_getInstance_10() {
    if ($serializer_instance_10 == null)
      new $serializer_11();
    return $serializer_instance_10;
  }
  function Call_init_$Init$(seen0, callId, instanceId, methodId, parameters, serializationConstructorMarker, $this) {
    if (!(7 === (7 & seen0))) {
      throwMissingFieldException(seen0, 7, $serializer_getInstance_10().nen_1);
    }
    RpcMessage_init_$Init$(seen0, serializationConstructorMarker, $this);
    $this.yei_1 = callId;
    $this.zei_1 = instanceId;
    $this.aej_1 = methodId;
    if (0 === (seen0 & 8))
      $this.bej_1 = new Int8Array(0);
    else
      $this.bej_1 = parameters;
    return $this;
  }
  function Call_init_$Create$(seen0, callId, instanceId, methodId, parameters, serializationConstructorMarker) {
    return Call_init_$Init$(seen0, callId, instanceId, methodId, parameters, serializationConstructorMarker, objectCreate(protoOf(Call)));
  }
  function RpcMessage$Dispose$Companion$$childSerializers$_anonymous__xek3o3() {
    return Companion_getInstance_270().i63();
  }
  function Companion_276() {
    Companion_instance_276 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.pen_1 = [lazy_0(tmp_0, RpcMessage$Dispose$Companion$$childSerializers$_anonymous__xek3o3)];
  }
  var Companion_instance_276;
  function Companion_getInstance_276() {
    if (Companion_instance_276 == null)
      new Companion_276();
    return Companion_instance_276;
  }
  function $serializer_12() {
    $serializer_instance_11 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('jetbrains.ocelot.langDef.rpc.RpcMessage.Dispose', this, 1);
    tmp0_serialDesc.q5j('instanceId', false);
    this.qen_1 = tmp0_serialDesc;
  }
  protoOf($serializer_12).ren = function (encoder, value) {
    var tmp0_desc = this.qen_1;
    var tmp1_output = encoder.g5c(tmp0_desc);
    var tmp2_cached = Companion_getInstance_276().pen_1;
    tmp1_output.w5d(tmp0_desc, 0, tmp2_cached[0].a1(), value.yej_1);
    tmp1_output.h5c(tmp0_desc);
  };
  protoOf($serializer_12).i59 = function (encoder, value) {
    return this.ren(encoder, value instanceof Dispose ? value : THROW_CCE());
  };
  protoOf($serializer_12).j59 = function (decoder) {
    var tmp0_desc = this.qen_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.g5c(tmp0_desc);
    var tmp6_cached = Companion_getInstance_276().pen_1;
    if (tmp5_input.v5c()) {
      tmp4_local0 = tmp5_input.s5c(tmp0_desc, 0, tmp6_cached[0].a1(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.w5c(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.s5c(tmp0_desc, 0, tmp6_cached[0].a1(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.h5c(tmp0_desc);
    return Dispose_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_12).v58 = function () {
    return this.qen_1;
  };
  protoOf($serializer_12).f5k = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_276().pen_1[0].a1()];
  };
  var $serializer_instance_11;
  function $serializer_getInstance_11() {
    if ($serializer_instance_11 == null)
      new $serializer_12();
    return $serializer_instance_11;
  }
  function Dispose_init_$Init$(seen0, instanceId, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_11().qen_1);
    }
    RpcMessage_init_$Init$(seen0, serializationConstructorMarker, $this);
    $this.yej_1 = instanceId;
    return $this;
  }
  function Dispose_init_$Create$(seen0, instanceId, serializationConstructorMarker) {
    return Dispose_init_$Init$(seen0, instanceId, serializationConstructorMarker, objectCreate(protoOf(Dispose)));
  }
  function Companion_277() {
  }
  var Companion_instance_277;
  function Companion_getInstance_277() {
    return Companion_instance_277;
  }
  function $serializer_13() {
    $serializer_instance_12 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('jetbrains.ocelot.langDef.rpc.RpcMessage.Answer', this, 2);
    tmp0_serialDesc.q5j('callId', false);
    tmp0_serialDesc.q5j('result', false);
    this.sen_1 = tmp0_serialDesc;
  }
  protoOf($serializer_13).ten = function (encoder, value) {
    var tmp0_desc = this.sen_1;
    var tmp1_output = encoder.g5c(tmp0_desc);
    tmp1_output.q5d(tmp0_desc, 0, value.cej_1);
    tmp1_output.w5d(tmp0_desc, 1, ByteArraySerializer_getInstance(), value.dej_1);
    tmp1_output.h5c(tmp0_desc);
  };
  protoOf($serializer_13).i59 = function (encoder, value) {
    return this.ten(encoder, value instanceof Answer ? value : THROW_CCE());
  };
  protoOf($serializer_13).j59 = function (decoder) {
    var tmp0_desc = this.sen_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0n;
    var tmp5_local1 = null;
    var tmp6_input = decoder.g5c(tmp0_desc);
    if (tmp6_input.v5c()) {
      tmp4_local0 = tmp6_input.m5c(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.s5c(tmp0_desc, 1, ByteArraySerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.w5c(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.m5c(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.s5c(tmp0_desc, 1, ByteArraySerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.h5c(tmp0_desc);
    return Answer_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_13).v58 = function () {
    return this.sen_1;
  };
  protoOf($serializer_13).f5k = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [LongSerializer_getInstance(), ByteArraySerializer_getInstance()];
  };
  var $serializer_instance_12;
  function $serializer_getInstance_12() {
    if ($serializer_instance_12 == null)
      new $serializer_13();
    return $serializer_instance_12;
  }
  function Answer_init_$Init$(seen0, callId, result, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_12().sen_1);
    }
    RpcMessage_init_$Init$(seen0, serializationConstructorMarker, $this);
    $this.cej_1 = callId;
    $this.dej_1 = result;
    return $this;
  }
  function Answer_init_$Create$(seen0, callId, result, serializationConstructorMarker) {
    return Answer_init_$Init$(seen0, callId, result, serializationConstructorMarker, objectCreate(protoOf(Answer)));
  }
  function Companion_278() {
  }
  var Companion_instance_278;
  function Companion_getInstance_278() {
    return Companion_instance_278;
  }
  function $serializer_14() {
    $serializer_instance_13 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('jetbrains.ocelot.langDef.rpc.RpcMessage.ErrorAnswer', this, 2);
    tmp0_serialDesc.q5j('callId', false);
    tmp0_serialDesc.q5j('errorMessage', false);
    this.uen_1 = tmp0_serialDesc;
  }
  protoOf($serializer_14).ven = function (encoder, value) {
    var tmp0_desc = this.uen_1;
    var tmp1_output = encoder.g5c(tmp0_desc);
    tmp1_output.q5d(tmp0_desc, 0, value.eej_1);
    tmp1_output.u5d(tmp0_desc, 1, value.fej_1);
    tmp1_output.h5c(tmp0_desc);
  };
  protoOf($serializer_14).i59 = function (encoder, value) {
    return this.ven(encoder, value instanceof ErrorAnswer ? value : THROW_CCE());
  };
  protoOf($serializer_14).j59 = function (decoder) {
    var tmp0_desc = this.uen_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0n;
    var tmp5_local1 = null;
    var tmp6_input = decoder.g5c(tmp0_desc);
    if (tmp6_input.v5c()) {
      tmp4_local0 = tmp6_input.m5c(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.q5c(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.w5c(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.m5c(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.q5c(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.h5c(tmp0_desc);
    return ErrorAnswer_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_14).v58 = function () {
    return this.uen_1;
  };
  protoOf($serializer_14).f5k = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [LongSerializer_getInstance(), StringSerializer_getInstance()];
  };
  var $serializer_instance_13;
  function $serializer_getInstance_13() {
    if ($serializer_instance_13 == null)
      new $serializer_14();
    return $serializer_instance_13;
  }
  function ErrorAnswer_init_$Init$(seen0, callId, errorMessage, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_13().uen_1);
    }
    RpcMessage_init_$Init$(seen0, serializationConstructorMarker, $this);
    $this.eej_1 = callId;
    $this.fej_1 = errorMessage;
    return $this;
  }
  function ErrorAnswer_init_$Create$(seen0, callId, errorMessage, serializationConstructorMarker) {
    return ErrorAnswer_init_$Init$(seen0, callId, errorMessage, serializationConstructorMarker, objectCreate(protoOf(ErrorAnswer)));
  }
  function _get_$cachedSerializer__te6jhj_3($this) {
    return $this.cem_1.a1();
  }
  function RpcMessage$Companion$_anonymous__qcfs19() {
    var tmp = getKClass(RpcMessage);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = [getKClass(Answer), getKClass(Call), getKClass(Dispose), getKClass(ErrorAnswer)];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_1 = [$serializer_getInstance_12(), $serializer_getInstance_10(), $serializer_getInstance_11(), $serializer_getInstance_13()];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$8 = [];
    return SealedClassSerializer_init_$Create$('jetbrains.ocelot.langDef.rpc.RpcMessage', tmp, tmp_0, tmp_1, tmp$ret$8);
  }
  function Call(callId, instanceId, methodId, parameters) {
    Companion_getInstance_275();
    parameters = parameters === VOID ? new Int8Array(0) : parameters;
    RpcMessage.call(this);
    this.yei_1 = callId;
    this.zei_1 = instanceId;
    this.aej_1 = methodId;
    this.bej_1 = parameters;
  }
  protoOf(Call).toString = function () {
    return 'Call(callId=' + this.yei_1.toString() + ', instanceId=' + this.zei_1.toString() + ', methodId=' + this.aej_1.toString() + ', parameters=' + toString_1(this.bej_1) + ')';
  };
  protoOf(Call).hashCode = function () {
    var result = getBigIntHashCode(this.yei_1);
    result = imul(result, 31) + hashCode(this.zei_1) | 0;
    result = imul(result, 31) + this.aej_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.bej_1) | 0;
    return result;
  };
  protoOf(Call).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Call))
      return false;
    if (!(this.yei_1 === other.yei_1))
      return false;
    if (!equals(this.zei_1, other.zei_1))
      return false;
    if (!this.aej_1.equals(other.aej_1))
      return false;
    if (!equals(this.bej_1, other.bej_1))
      return false;
    return true;
  };
  function Dispose(instanceId) {
    Companion_getInstance_276();
    RpcMessage.call(this);
    this.yej_1 = instanceId;
  }
  protoOf(Dispose).toString = function () {
    return 'Dispose(instanceId=' + this.yej_1.toString() + ')';
  };
  protoOf(Dispose).hashCode = function () {
    return hashCode(this.yej_1);
  };
  protoOf(Dispose).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Dispose))
      return false;
    if (!equals(this.yej_1, other.yej_1))
      return false;
    return true;
  };
  function Answer(callId, result) {
    RpcMessage.call(this);
    this.cej_1 = callId;
    this.dej_1 = result;
  }
  protoOf(Answer).toString = function () {
    return 'Answer(callId=' + this.cej_1.toString() + ', result=' + toString_1(this.dej_1) + ')';
  };
  protoOf(Answer).hashCode = function () {
    var result = getBigIntHashCode(this.cej_1);
    result = imul(result, 31) + hashCode(this.dej_1) | 0;
    return result;
  };
  protoOf(Answer).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Answer))
      return false;
    if (!(this.cej_1 === other.cej_1))
      return false;
    if (!equals(this.dej_1, other.dej_1))
      return false;
    return true;
  };
  function ErrorAnswer(callId, errorMessage) {
    RpcMessage.call(this);
    this.eej_1 = callId;
    this.fej_1 = errorMessage;
  }
  protoOf(ErrorAnswer).toString = function () {
    return 'ErrorAnswer(callId=' + this.eej_1.toString() + ', errorMessage=' + this.fej_1 + ')';
  };
  protoOf(ErrorAnswer).hashCode = function () {
    var result = getBigIntHashCode(this.eej_1);
    result = imul(result, 31) + getStringHashCode(this.fej_1) | 0;
    return result;
  };
  protoOf(ErrorAnswer).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ErrorAnswer))
      return false;
    if (!(this.eej_1 === other.eej_1))
      return false;
    if (!(this.fej_1 === other.fej_1))
      return false;
    return true;
  };
  function Companion_279() {
    Companion_instance_279 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.cem_1 = lazy_0(tmp_0, RpcMessage$Companion$_anonymous__qcfs19);
  }
  protoOf(Companion_279).dem = function (callId, instanceId, methodId, throwable) {
    var tmp = 'Exception on calling the remote method (instance = ' + instanceId.toString() + ', method = ' + methodId.toString() + '): ';
    var tmp0_elvis_lhs = throwable.message;
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      var tmp1_safe_receiver = throwable.cause;
      tmp_0 = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.message;
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var tmp2_elvis_lhs = tmp_0;
    return new ErrorAnswer(callId, tmp + (tmp2_elvis_lhs == null ? '' : tmp2_elvis_lhs));
  };
  protoOf(Companion_279).i63 = function () {
    return _get_$cachedSerializer__te6jhj_3(this);
  };
  protoOf(Companion_279).q5k = function (typeParamsSerializers) {
    return this.i63();
  };
  var Companion_instance_279;
  function Companion_getInstance_279() {
    if (Companion_instance_279 == null)
      new Companion_279();
    return Companion_instance_279;
  }
  function RpcMessage_init_$Init$(seen0, serializationConstructorMarker, $this) {
    return $this;
  }
  function RpcMessage() {
    Companion_getInstance_279();
  }
  function get_LOG_3() {
    _init_properties_RpcOutgoingCalls_kt__8dk83o();
    return LOG_3;
  }
  var LOG_3;
  function $startCallCOROUTINE$(_this__u8e3s4, answer, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.eeo_1 = _this__u8e3s4;
    this.feo_1 = answer;
  }
  protoOf($startCallCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 3;
            this.geo_1 = CompletableDeferred();
            this.f9_1 = 1;
            suspendResult = this.eeo_1.vej_1.z15(new InitiateCall(this.feo_1, this.geo_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.f9_1 = 2;
            suspendResult = this.geo_1.nr(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return suspendResult;
          case 3:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 3) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function $completeCallCOROUTINE$(_this__u8e3s4, callId, answer, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.peo_1 = _this__u8e3s4;
    this.qeo_1 = callId;
    this.reo_1 = answer;
  }
  protoOf($completeCallCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 3;
            this.seo_1 = LoggableJob('completeCall(' + this.qeo_1.toString() + ')');
            this.f9_1 = 1;
            suspendResult = this.peo_1.vej_1.z15(new CompleteCall(this.qeo_1, this.reo_1, this.seo_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.f9_1 = 2;
            suspendResult = this.seo_1.np(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 3) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function $failCallCOROUTINE$(_this__u8e3s4, callId, reason, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.bep_1 = _this__u8e3s4;
    this.cep_1 = callId;
    this.dep_1 = reason;
  }
  protoOf($failCallCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 3;
            this.eep_1 = LoggableJob('failCall(' + this.cep_1.toString() + ')');
            this.f9_1 = 1;
            suspendResult = this.bep_1.vej_1.z15(new FailCall(this.cep_1, this.dep_1, this.eep_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.f9_1 = 2;
            suspendResult = this.eep_1.np(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 3) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function RpcOutgoingCalls(channel) {
    this.vej_1 = channel;
  }
  protoOf(RpcOutgoingCalls).sek = function (answer, $completion) {
    var tmp = new $startCallCOROUTINE$(this, answer, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(RpcOutgoingCalls).xej = function (callId, answer, $completion) {
    var tmp = new $completeCallCOROUTINE$(this, callId, answer, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(RpcOutgoingCalls).wej = function (callId, reason, $completion) {
    var tmp = new $failCallCOROUTINE$(this, callId, reason, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  function rpcOutgoingCalls(_this__u8e3s4) {
    _init_properties_RpcOutgoingCalls_kt__8dk83o();
    var channel = Channel();
    var tmp = launch(_this__u8e3s4, VOID, VOID, rpcOutgoingCalls$slambda_0(channel, null));
    tmp.kp(rpcOutgoingCalls$lambda(channel));
    return new RpcOutgoingCalls(channel);
  }
  function InitiateCall(answer, callId) {
    RpcOutgoingCallsMessage.call(this);
    this.fep_1 = answer;
    this.gep_1 = callId;
  }
  protoOf(InitiateCall).toString = function () {
    return 'InitiateCall(answer=' + toString_1(this.fep_1) + ', callId=' + toString_1(this.gep_1) + ')';
  };
  protoOf(InitiateCall).hashCode = function () {
    var result = hashCode(this.fep_1);
    result = imul(result, 31) + hashCode(this.gep_1) | 0;
    return result;
  };
  protoOf(InitiateCall).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof InitiateCall))
      return false;
    if (!equals(this.fep_1, other.fep_1))
      return false;
    if (!equals(this.gep_1, other.gep_1))
      return false;
    return true;
  };
  function CompleteCall(callId, answer, result) {
    RpcOutgoingCallsMessage.call(this);
    this.hep_1 = callId;
    this.iep_1 = answer;
    this.jep_1 = result;
  }
  function FailCall(callId, reason, result) {
    RpcOutgoingCallsMessage.call(this);
    this.kep_1 = callId;
    this.lep_1 = reason;
    this.mep_1 = result;
  }
  function RpcOutgoingCallsMessage() {
  }
  function LoggableJob(jobName) {
    _init_properties_RpcOutgoingCalls_kt__8dk83o();
    // Inline function 'kotlin.apply' call
    var this_0 = Job_0();
    this_0.kp(LoggableJob$lambda(jobName));
    return this_0;
  }
  function MissingOutgoingCallException(id) {
    RuntimeException_init_$Init$_0('Outgoing call with id ' + id.toString() + ' not found', this);
    captureStack(this, MissingOutgoingCallException);
    this.nep_1 = id;
  }
  function LOG$lambda_3() {
    _init_properties_RpcOutgoingCalls_kt__8dk83o();
    return Unit_instance;
  }
  function rpcOutgoingCalls$slambda$lambda($callId) {
    return function () {
      return 'Initiated outgoing call with id: ' + $callId.toString();
    };
  }
  function rpcOutgoingCalls$slambda$lambda_0($callId) {
    return function () {
      return 'Completing an absent outgoing call with id ' + $callId.toString();
    };
  }
  function rpcOutgoingCalls$slambda$lambda_1($callId) {
    return function () {
      return 'Outgoing call with id ' + $callId.toString() + ' completed';
    };
  }
  function rpcOutgoingCalls$slambda$lambda_2($callId) {
    return function () {
      return 'Failing an absent outgoing call with id ' + $callId.toString();
    };
  }
  function rpcOutgoingCalls$slambda$lambda_3($callId) {
    return function () {
      return 'Outgoing call with id ' + $callId.toString() + ' failed';
    };
  }
  function rpcOutgoingCalls$slambda($channel, resultContinuation) {
    this.wep_1 = $channel;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(rpcOutgoingCalls$slambda).e1h = function ($this$launch, $completion) {
    var tmp = this.f1h($this$launch, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(rpcOutgoingCalls$slambda).v9 = function (p1, $completion) {
    return this.e1h((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(rpcOutgoingCalls$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 10;
            this.feq_1 = 0n;
            var tmp_0 = this;
            tmp_0.yep_1 = HashMap_init_$Create$();
            this.f9_1 = 1;
            continue $sm;
          case 1:
            this.g9_1 = 9;
            this.geq_1 = this.wep_1.m();
            this.f9_1 = 2;
            continue $sm;
          case 2:
            this.f9_1 = 3;
            suspendResult = this.geq_1.d14(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            if (!suspendResult) {
              this.f9_1 = 7;
              continue $sm;
            }

            this.aeq_1 = this.geq_1.o();
            var tmp0_subject = this.aeq_1;
            if (tmp0_subject instanceof InitiateCall) {
              var tmp_1 = this;
              var _unary__edvuaz = this.feq_1;
              this.feq_1 = add_2(_unary__edvuaz, get_ONE());
              var callId = _unary__edvuaz;
              var tmp_2 = get_LOG_3();
              tmp_2.a2q(rpcOutgoingCalls$slambda$lambda(callId));
              var tmp0 = this.yep_1;
              var value = this.aeq_1.fep_1;
              tmp0.t2(callId, value);
              tmp_1.zep_1 = this.aeq_1.gep_1.pu(callId);
              this.f9_1 = 6;
              continue $sm;
            } else {
              if (tmp0_subject instanceof CompleteCall) {
                this.ceq_1 = this.aeq_1.hep_1;
                this.beq_1 = this.yep_1.u2(this.ceq_1);
                if (this.beq_1 == null) {
                  var tmp_3 = get_LOG_3();
                  tmp_3.f2q(rpcOutgoingCalls$slambda$lambda_0(this.ceq_1));
                  this.aeq_1.jep_1.ru(new MissingOutgoingCallException(this.ceq_1));
                  this.f9_1 = 2;
                  continue $sm;
                } else {
                  this.f9_1 = 5;
                  continue $sm;
                }
              } else {
                if (tmp0_subject instanceof FailCall) {
                  this.eeq_1 = this.aeq_1.kep_1;
                  this.deq_1 = this.yep_1.u2(this.eeq_1);
                  if (this.deq_1 == null) {
                    var tmp_4 = get_LOG_3();
                    tmp_4.f2q(rpcOutgoingCalls$slambda$lambda_2(this.eeq_1));
                    this.aeq_1.mep_1.ru(new MissingOutgoingCallException(this.eeq_1));
                    this.f9_1 = 2;
                    continue $sm;
                  } else {
                    this.f9_1 = 4;
                    continue $sm;
                  }
                } else {
                  var tmp_5 = this;
                  noWhenBranchMatchedException();
                }
              }
            }

            break;
          case 4:
            var tmp_6 = get_LOG_3();
            tmp_6.a2q(rpcOutgoingCalls$slambda$lambda_3(this.eeq_1));
            this.deq_1.ru(new RemoteInvocationException(this.aeq_1.lep_1));
            this.zep_1 = this.aeq_1.mep_1.su();
            this.f9_1 = 6;
            continue $sm;
          case 5:
            var tmp_7 = get_LOG_3();
            tmp_7.a2q(rpcOutgoingCalls$slambda$lambda_1(this.ceq_1));
            this.beq_1.pu(this.aeq_1.iep_1);
            this.zep_1 = this.aeq_1.jep_1.su();
            this.f9_1 = 6;
            continue $sm;
          case 6:
            this.f9_1 = 2;
            continue $sm;
          case 7:
            this.g9_1 = 10;
            this.f9_1 = 8;
            continue $sm;
          case 8:
            this.g9_1 = 10;
            var _iterator__ex2g4s = this.yep_1.s2().m();
            while (_iterator__ex2g4s.n()) {
              var call = _iterator__ex2g4s.o();
              call.rp(new RpcFacadeCancellationException());
            }

            return Unit_instance;
          case 9:
            this.g9_1 = 10;
            var t = this.i9_1;
            var _iterator__ex2g4s_0 = this.yep_1.s2().m();
            while (_iterator__ex2g4s_0.n()) {
              var call_0 = _iterator__ex2g4s_0.o();
              call_0.rp(new RpcFacadeCancellationException());
            }

            throw t;
          case 10:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 10) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(rpcOutgoingCalls$slambda).f1h = function ($this$launch, completion) {
    var i = new rpcOutgoingCalls$slambda(this.wep_1, completion);
    i.xep_1 = $this$launch;
    return i;
  };
  function rpcOutgoingCalls$slambda_0($channel, resultContinuation) {
    var i = new rpcOutgoingCalls$slambda($channel, resultContinuation);
    var l = function ($this$launch, $completion) {
      return i.e1h($this$launch, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function rpcOutgoingCalls$lambda($channel) {
    return function (it) {
      $channel.i16();
      return Unit_instance;
    };
  }
  function LoggableJob$lambda$lambda($jobName) {
    return function () {
      return "Job '" + $jobName + "' completed with an exception";
    };
  }
  function LoggableJob$lambda($jobName) {
    return function (exception) {
      var tmp;
      if (!(exception == null)) {
        var tmp_0 = get_LOG_3();
        tmp_0.h2q(exception, LoggableJob$lambda$lambda($jobName));
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  var properties_initialized_RpcOutgoingCalls_kt_8fayzq;
  function _init_properties_RpcOutgoingCalls_kt__8dk83o() {
    if (!properties_initialized_RpcOutgoingCalls_kt_8fayzq) {
      properties_initialized_RpcOutgoingCalls_kt_8fayzq = true;
      var tmp = KotlinLogging_getInstance();
      LOG_3 = tmp.i2q(LOG$lambda_3);
    }
  }
  function Runnable_0() {
  }
  function RunnableSerializer() {
    RunnableSerializer_instance = this;
    InstancePublicationSerializer.call(this, Descriptor_getInstance());
  }
  var RunnableSerializer_instance;
  function RunnableSerializer_getInstance() {
    if (RunnableSerializer_instance == null)
      new RunnableSerializer();
    return RunnableSerializer_instance;
  }
  function RemoteRunnable$Descriptor$run$slambda(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(RemoteRunnable$Descriptor$run$slambda).seq = function (instance, _unused_var__etf5q3, $completion) {
    var tmp = this.teq(instance, _unused_var__etf5q3, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(RemoteRunnable$Descriptor$run$slambda).w9 = function (p1, p2, $completion) {
    var tmp = (!(p1 == null) ? isInterface(p1, Runnable_0) : false) ? p1 : THROW_CCE();
    return this.seq(tmp, p2 instanceof Unit ? p2 : THROW_CCE(), $completion);
  };
  protoOf(RemoteRunnable$Descriptor$run$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.qeq_1.heq(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(RemoteRunnable$Descriptor$run$slambda).teq = function (instance, _unused_var__etf5q3, completion) {
    var i = new RemoteRunnable$Descriptor$run$slambda(completion);
    i.qeq_1 = instance;
    i.req_1 = _unused_var__etf5q3;
    return i;
  };
  function RemoteRunnable$Descriptor$run$slambda_0(resultContinuation) {
    var i = new RemoteRunnable$Descriptor$run$slambda(resultContinuation);
    var l = function (instance, _unused_var__etf5q3, $completion) {
      return i.seq(instance, _unused_var__etf5q3, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function Descriptor_0() {
    Descriptor_instance = this;
    InstanceDescriptor.call(this);
    var tmp = this;
    var tmp_0 = serializer_3(Unit_instance);
    var tmp_1 = serializer_3(Unit_instance);
    tmp.veq_1 = method(this, 'run', tmp_0, tmp_1, RemoteRunnable$Descriptor$run$slambda_0(null));
  }
  protoOf(Descriptor_0).weq = function (endpoint) {
    return new RemoteRunnable(endpoint);
  };
  protoOf(Descriptor_0).kef = function (endpoint) {
    return this.weq(endpoint);
  };
  var Descriptor_instance;
  function Descriptor_getInstance() {
    if (Descriptor_instance == null)
      new Descriptor_0();
    return Descriptor_instance;
  }
  function RemoteRunnable(endpoint) {
    this.xeq_1 = endpoint;
  }
  protoOf(RemoteRunnable).heq = function ($completion) {
    return Descriptor_getInstance().veq_1.oeg(this.xeq_1, Unit_instance, $completion);
  };
  function RpcFacadeContainer$Companion$LOG$lambda() {
    return Unit_instance;
  }
  function Companion_280() {
    Companion_instance_280 = this;
    var tmp = this;
    var tmp_0 = KotlinLogging_getInstance();
    tmp.yeq_1 = tmp_0.i2q(RpcFacadeContainer$Companion$LOG$lambda);
  }
  var Companion_instance_280;
  function Companion_getInstance_280() {
    if (Companion_instance_280 == null)
      new Companion_280();
    return Companion_instance_280;
  }
  function RpcFacadeContainer() {
    Companion_getInstance_280();
    this.zeq_1 = null;
  }
  function flowBasedMethod(_this__u8e3s4, id, parameterSerializer, resultSerializer, elementSerializer, handle) {
    var collectorSerializer = new PublishedFlowCollectorSerializer(elementSerializer);
    var tmp = get_withFacade(PairSerializer(collectorSerializer, parameterSerializer));
    var tmp_0 = PairSerializer(resultSerializer, PublishedDisposableSerializer_getInstance());
    var emitHandle = method(_this__u8e3s4, id, tmp, tmp_0, flowBasedMethod$slambda_0(handle, null));
    return new flowBasedMethod$1(collectorSerializer, emitHandle);
  }
  function flowBasedMethod$slambda$slambda$o$collect$slambda($$this$unsafeFlow, resultContinuation) {
    this.ier_1 = $$this$unsafeFlow;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(flowBasedMethod$slambda$slambda$o$collect$slambda).f1q = function (value, $completion) {
    var tmp = this.g1q(value, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(flowBasedMethod$slambda$slambda$o$collect$slambda).v9 = function (p1, $completion) {
    return this.f1q((p1 == null ? true : !(p1 == null)) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(flowBasedMethod$slambda$slambda$o$collect$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            var tmp0 = this.ier_1;
            var value = this.jer_1;
            this.f9_1 = 1;
            suspendResult = tmp0.x18(new Element_2(value), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(flowBasedMethod$slambda$slambda$o$collect$slambda).g1q = function (value, completion) {
    var i = new flowBasedMethod$slambda$slambda$o$collect$slambda(this.ier_1, completion);
    i.jer_1 = value;
    return i;
  };
  function flowBasedMethod$slambda$slambda$o$collect$slambda_0($$this$unsafeFlow, resultContinuation) {
    var i = new flowBasedMethod$slambda$slambda$o$collect$slambda($$this$unsafeFlow, resultContinuation);
    var l = function (value, $completion) {
      return i.f1q(value, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function $collectCOROUTINE$_17(_this__u8e3s4, collector, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.ser_1 = _this__u8e3s4;
    this.ter_1 = collector;
  }
  protoOf($collectCOROUTINE$_17).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            var $this$unsafeFlow = this.ter_1;
            this.f9_1 = 1;
            var tmp_0 = flowBasedMethod$slambda$slambda$o$collect$slambda_0($this$unsafeFlow, null);
            suspendResult = this.ser_1.uer_1.f18(new sam$kotlinx_coroutines_flow_FlowCollector$0_12(tmp_0), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function flowBasedMethod$2$2$$inlined$map$1($this) {
    this.uer_1 = $this;
  }
  protoOf(flowBasedMethod$2$2$$inlined$map$1).y18 = function (collector, $completion) {
    var tmp = new $collectCOROUTINE$_17(this, collector, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(flowBasedMethod$2$2$$inlined$map$1).f18 = function (collector, $completion) {
    return this.y18(collector, $completion);
  };
  function sam$kotlinx_coroutines_flow_FlowCollector$0_12(function_0) {
    this.ver_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_12).x18 = function (value, $completion) {
    return this.ver_1(value, $completion);
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_12).f3 = function () {
    return this.ver_1;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_12).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, FlowCollector) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_12).hashCode = function () {
    return hashCode(this.f3());
  };
  function flowBasedMethod$slambda$slambda($collector, $flow, $stoppedByCaller, resultContinuation) {
    this.ees_1 = $collector;
    this.fes_1 = $flow;
    this.ges_1 = $stoppedByCaller;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(flowBasedMethod$slambda$slambda).e1h = function ($this$launch, $completion) {
    var tmp = this.f1h($this$launch, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(flowBasedMethod$slambda$slambda).v9 = function (p1, $completion) {
    return this.e1h((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(flowBasedMethod$slambda$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 7;
            this.g9_1 = 4;
            this.f9_1 = 1;
            var tmp_0 = this.ees_1.b3c();
            var this_0 = this.fes_1;
            suspendResult = emitAll_0(tmp_0, new flowBasedMethod$2$2$$inlined$map$1(this_0), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.f9_1 = 2;
            suspendResult = this.ees_1.b3c().x18(new End(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.g9_1 = 7;
            this.f9_1 = 3;
            continue $sm;
          case 3:
            this.g9_1 = 7;
            return Unit_instance;
          case 4:
            this.g9_1 = 7;
            var tmp_1 = this.i9_1;
            if (tmp_1 instanceof RuntimeException) {
              this.ies_1 = this.i9_1;
              if (!this.ges_1._v) {
                this.f9_1 = 5;
                var tmp_2 = this.ees_1.b3c();
                var tmp0_elvis_lhs = this.ies_1.message;
                suspendResult = tmp_2.x18(new Error_1(tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                this.f9_1 = 6;
                continue $sm;
              }
            } else {
              throw this.i9_1;
            }

          case 5:
            this.f9_1 = 6;
            continue $sm;
          case 6:
            throw this.ies_1;
          case 7:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 7) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(flowBasedMethod$slambda$slambda).f1h = function ($this$launch, completion) {
    var i = new flowBasedMethod$slambda$slambda(this.ees_1, this.fes_1, this.ges_1, completion);
    i.hes_1 = $this$launch;
    return i;
  };
  function flowBasedMethod$slambda$slambda_0($collector, $flow, $stoppedByCaller, resultContinuation) {
    var i = new flowBasedMethod$slambda$slambda($collector, $flow, $stoppedByCaller, resultContinuation);
    var l = function ($this$launch, $completion) {
      return i.e1h($this$launch, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function flowBasedMethod$2$$inlined$toDisposable$1($stoppedByCaller, $job) {
    this.jes_1 = $stoppedByCaller;
    this.kes_1 = $job;
  }
  protoOf(flowBasedMethod$2$$inlined$toDisposable$1).zr = function () {
    this.jes_1._v = true;
    this.kes_1.sp();
    return Unit_instance;
  };
  function flowBasedMethod$slambda($handle, resultContinuation) {
    this.tes_1 = $handle;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(flowBasedMethod$slambda).zes = function (instance, _destruct__k2r9zo, $completion) {
    var tmp = this.aet(instance, _destruct__k2r9zo, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(flowBasedMethod$slambda).w9 = function (p1, p2, $completion) {
    var tmp = (!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE();
    return this.zes(tmp, p2 instanceof RpcFacadeMixin ? p2 : THROW_CCE(), $completion);
  };
  protoOf(flowBasedMethod$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 3;
            this.xes_1 = this.ves_1.fg();
            var param = this.ves_1.gg();
            this.yes_1 = param.fg();
            var parameter = param.gg();
            this.f9_1 = 1;
            suspendResult = this.tes_1(this.ues_1, parameter, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var _destruct__k2r9zo = suspendResult;
            this.wes_1 = _destruct__k2r9zo.fg();
            var flow = _destruct__k2r9zo.gg();
            var stoppedByCaller = {_v: false};
            if (!get_isActive(this.ues_1)) {
              var message = 'Instance ' + toString_1(this.ues_1) + ' in not an active coroutine scope';
              throw IllegalStateException_init_$Create$_0(toString_1(message));
            }

            var job = launch(this.ues_1, VOID, VOID, flowBasedMethod$slambda$slambda_0(this.yes_1, flow, stoppedByCaller, null));
            var flowCollecting = new flowBasedMethod$2$$inlined$toDisposable$1(stoppedByCaller, job);
            this.f9_1 = 2;
            suspendResult = this.xes_1.yeg(flowCollecting, Companion_getInstance_282(), flowCollecting, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var publication = suspendResult;
            return to(this.wes_1, publication);
          case 3:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 3) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(flowBasedMethod$slambda).aet = function (instance, _destruct__k2r9zo, completion) {
    var i = new flowBasedMethod$slambda(this.tes_1, completion);
    i.ues_1 = instance;
    i.ves_1 = _destruct__k2r9zo;
    return i;
  };
  function flowBasedMethod$slambda_0($handle, resultContinuation) {
    var i = new flowBasedMethod$slambda($handle, resultContinuation);
    var l = function (instance, _destruct__k2r9zo, $completion) {
      return i.zes(instance, _destruct__k2r9zo, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function flowBasedMethod$o$call$slambda($lastMessage, resultContinuation) {
    this.jet_1 = $lastMessage;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(flowBasedMethod$o$call$slambda).net = function ($this$transformWhile, it, $completion) {
    var tmp = this.oet($this$transformWhile, it, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(flowBasedMethod$o$call$slambda).w9 = function (p1, p2, $completion) {
    var tmp = (!(p1 == null) ? isInterface(p1, FlowCollector) : false) ? p1 : THROW_CCE();
    return this.net(tmp, p2 instanceof FlowMessage ? p2 : THROW_CCE(), $completion);
  };
  protoOf(flowBasedMethod$o$call$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 3;
            this.jet_1._v = this.let_1;
            var tmp0_subject = this.let_1;
            if (tmp0_subject instanceof Element_2) {
              this.f9_1 = 1;
              suspendResult = this.ket_1.x18(this.let_1.qet_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              if (tmp0_subject instanceof Error_1) {
                var tmp_0 = this;
                throw RuntimeException_init_$Create$_0(this.let_1.pet_1);
              } else {
                if (tmp0_subject instanceof End) {
                  this.met_1 = false;
                  this.f9_1 = 2;
                  continue $sm;
                } else {
                  var tmp_1 = this;
                  noWhenBranchMatchedException();
                }
              }
            }

            break;
          case 1:
            this.met_1 = true;
            this.f9_1 = 2;
            continue $sm;
          case 2:
            return this.met_1;
          case 3:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 3) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(flowBasedMethod$o$call$slambda).oet = function ($this$transformWhile, it, completion) {
    var i = new flowBasedMethod$o$call$slambda(this.jet_1, completion);
    i.ket_1 = $this$transformWhile;
    i.let_1 = it;
    return i;
  };
  function flowBasedMethod$o$call$slambda_0($lastMessage, resultContinuation) {
    var i = new flowBasedMethod$o$call$slambda($lastMessage, resultContinuation);
    var l = function ($this$transformWhile, it, $completion) {
      return i.net($this$transformWhile, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function flowBasedMethod$o$call$slambda_1($lastMessage, $flowCollecting, $publication, resultContinuation) {
    this.zet_1 = $lastMessage;
    this.aeu_1 = $flowCollecting;
    this.beu_1 = $publication;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(flowBasedMethod$o$call$slambda_1).eeu = function ($this$onCompletion, it, $completion) {
    var tmp = this.feu($this$onCompletion, it, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(flowBasedMethod$o$call$slambda_1).w9 = function (p1, p2, $completion) {
    var tmp = (!(p1 == null) ? isInterface(p1, FlowCollector) : false) ? p1 : THROW_CCE();
    return this.eeu(tmp, (p2 == null ? true : p2 instanceof Error) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(flowBasedMethod$o$call$slambda_1).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        if (tmp === 0) {
          this.g9_1 = 1;
          var it = this.zet_1._v;
          var stoppedByCallee = !(it == null) && it.geu();
          if (!stoppedByCallee) {
            this.aeu_1.b3c().zr();
          }
          this.beu_1.zr();
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(flowBasedMethod$o$call$slambda_1).feu = function ($this$onCompletion, it, completion) {
    var i = new flowBasedMethod$o$call$slambda_1(this.zet_1, this.aeu_1, this.beu_1, completion);
    i.ceu_1 = $this$onCompletion;
    i.deu_1 = it;
    return i;
  };
  function flowBasedMethod$o$call$slambda_2($lastMessage, $flowCollecting, $publication, resultContinuation) {
    var i = new flowBasedMethod$o$call$slambda_1($lastMessage, $flowCollecting, $publication, resultContinuation);
    var l = function ($this$onCompletion, it, $completion) {
      return i.eeu($this$onCompletion, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function $callCOROUTINE$(_this__u8e3s4, endpoint, parameter, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.peu_1 = _this__u8e3s4;
    this.qeu_1 = endpoint;
    this.reu_1 = parameter;
  }
  protoOf($callCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 3;
            this.teu_1 = Channel();
            var collector = new SendingCollector(this.teu_1);
            this.ueu_1 = this.qeu_1.mef();
            this.f9_1 = 1;
            suspendResult = this.ueu_1.zeg(collector, this.peu_1.veu_1.uef_1, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.seu_1 = suspendResult;
            this.f9_1 = 2;
            suspendResult = this.peu_1.weu_1.oeg(this.qeu_1, mixedTo(this.ueu_1, to(this.seu_1, this.reu_1)), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var _destruct__k2r9zo = suspendResult;
            var result = _destruct__k2r9zo.fg();
            var flowCollecting = _destruct__k2r9zo.gg();
            var lastMessage = {_v: null};
            var tmp_0 = consumeAsFlow(this.teu_1);
            var tmp_1 = transformWhile(tmp_0, flowBasedMethod$o$call$slambda_0(lastMessage, null));
            var flow = onCompletion(tmp_1, flowBasedMethod$o$call$slambda_2(lastMessage, flowCollecting, this.seu_1, null));
            return to(result, flow);
          case 3:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 3) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function flowBasedMethod$1($collectorSerializer, $emitHandle) {
    this.veu_1 = $collectorSerializer;
    this.weu_1 = $emitHandle;
  }
  protoOf(flowBasedMethod$1).xeu = function (endpoint, parameter, $completion) {
    var tmp = new $callCOROUTINE$(this, endpoint, parameter, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(flowBasedMethod$1).oeg = function (endpoint, parameter, $completion) {
    return this.xeu(endpoint, (parameter == null ? true : !(parameter == null)) ? parameter : THROW_CCE(), $completion);
  };
  function flowMethod(_this__u8e3s4, id, parameterSerializer, elementSerializer, handle) {
    var tmp = id + '/stop';
    var tmp_0 = get_withFacade(serializer_3(Unit_instance));
    var tmp_1 = RunnableSerializer_getInstance();
    var stopHandleMethod = method(_this__u8e3s4, tmp, tmp_0, tmp_1, flowMethod$slambda_0(null));
    var collectorSerializer = new PublishedFlowCollectorSerializer(elementSerializer);
    var tmp_2 = TripleSerializer(collectorSerializer, parameterSerializer, RunnableSerializer_getInstance());
    var tmp_3 = serializer_3(Unit_instance);
    var emitHandle = method(_this__u8e3s4, id, tmp_2, tmp_3, flowMethod$slambda_2(handle, null));
    var tmp_4 = flowMethod$lambda(stopHandleMethod, collectorSerializer, emitHandle);
    return new sam$jetbrains_ocelot_langDef_rpc_ImmediateMethodHandle$0(tmp_4);
  }
  function StopHandle() {
    this.yeu_1 = false;
  }
  protoOf(StopHandle).zeu = function () {
    this.yeu_1 = true;
  };
  protoOf(StopHandle).heq = function ($completion) {
    this.zeu();
    return Unit_instance;
  };
  function sam$jetbrains_ocelot_langDef_rpc_ImmediateMethodHandle$0(function_0) {
    this.aev_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_langDef_rpc_ImmediateMethodHandle$0).ief = function (endpoint, parameter) {
    return this.aev_1(endpoint, parameter);
  };
  protoOf(sam$jetbrains_ocelot_langDef_rpc_ImmediateMethodHandle$0).f3 = function () {
    return this.aev_1;
  };
  protoOf(sam$jetbrains_ocelot_langDef_rpc_ImmediateMethodHandle$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, ImmediateMethodHandle) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_langDef_rpc_ImmediateMethodHandle$0).hashCode = function () {
    return hashCode(this.f3());
  };
  function flowMethod$slambda(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(flowMethod$slambda).lev = function (_unused_var__etf5q3, _destruct__k2r9zo, $completion) {
    var tmp = this.mev(_unused_var__etf5q3, _destruct__k2r9zo, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(flowMethod$slambda).w9 = function (p1, p2, $completion) {
    var tmp = !(p1 == null) ? p1 : THROW_CCE();
    return this.lev(tmp, p2 instanceof RpcFacadeMixin ? p2 : THROW_CCE(), $completion);
  };
  protoOf(flowMethod$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            var facade = this.kev_1.fg();
            var stopHandle = new StopHandle();
            this.f9_1 = 1;
            suspendResult = facade.zeg(stopHandle, Descriptor_getInstance(), VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(flowMethod$slambda).mev = function (_unused_var__etf5q3, _destruct__k2r9zo, completion) {
    var i = new flowMethod$slambda(completion);
    i.jev_1 = _unused_var__etf5q3;
    i.kev_1 = _destruct__k2r9zo;
    return i;
  };
  function flowMethod$slambda_0(resultContinuation) {
    var i = new flowMethod$slambda(resultContinuation);
    var l = function (_unused_var__etf5q3, _destruct__k2r9zo, $completion) {
      return i.lev(_unused_var__etf5q3, _destruct__k2r9zo, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function flowMethod$slambda$o$collect$slambda($$this$unsafeFlow, resultContinuation) {
    this.vev_1 = $$this$unsafeFlow;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(flowMethod$slambda$o$collect$slambda).f1q = function (value, $completion) {
    var tmp = this.g1q(value, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(flowMethod$slambda$o$collect$slambda).v9 = function (p1, $completion) {
    return this.f1q((p1 == null ? true : !(p1 == null)) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(flowMethod$slambda$o$collect$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            var tmp0 = this.vev_1;
            var value = this.wev_1;
            this.f9_1 = 1;
            suspendResult = tmp0.x18(new Element_2(value), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(flowMethod$slambda$o$collect$slambda).g1q = function (value, completion) {
    var i = new flowMethod$slambda$o$collect$slambda(this.vev_1, completion);
    i.wev_1 = value;
    return i;
  };
  function flowMethod$slambda$o$collect$slambda_0($$this$unsafeFlow, resultContinuation) {
    var i = new flowMethod$slambda$o$collect$slambda($$this$unsafeFlow, resultContinuation);
    var l = function (value, $completion) {
      return i.f1q(value, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function $collectCOROUTINE$_18(_this__u8e3s4, collector, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.few_1 = _this__u8e3s4;
    this.gew_1 = collector;
  }
  protoOf($collectCOROUTINE$_18).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            var $this$unsafeFlow = this.gew_1;
            this.f9_1 = 1;
            var tmp_0 = flowMethod$slambda$o$collect$slambda_0($this$unsafeFlow, null);
            suspendResult = this.few_1.hew_1.f18(new sam$kotlinx_coroutines_flow_FlowCollector$0_13(tmp_0), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function sam$kotlinx_coroutines_flow_FlowCollector$0_13(function_0) {
    this.iew_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_13).x18 = function (value, $completion) {
    return this.iew_1(value, $completion);
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_13).f3 = function () {
    return this.iew_1;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_13).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, FlowCollector) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_13).hashCode = function () {
    return hashCode(this.f3());
  };
  function flowMethod$slambda$slambda($stopHandle, resultContinuation) {
    this.rew_1 = $stopHandle;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(flowMethod$slambda$slambda).tew = function (it, $completion) {
    var tmp = this.uew(it, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(flowMethod$slambda$slambda).v9 = function (p1, $completion) {
    return this.tew((p1 == null ? true : !(p1 == null)) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(flowMethod$slambda$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        if (tmp === 0) {
          this.g9_1 = 1;
          return !this.rew_1.yeu_1;
        } else if (tmp === 1) {
          throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(flowMethod$slambda$slambda).uew = function (it, completion) {
    var i = new flowMethod$slambda$slambda(this.rew_1, completion);
    i.sew_1 = it;
    return i;
  };
  function flowMethod$slambda$slambda_0($stopHandle, resultContinuation) {
    var i = new flowMethod$slambda$slambda($stopHandle, resultContinuation);
    var l = function (it, $completion) {
      return i.tew(it, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function flowMethod$2$$inlined$map$1($this) {
    this.hew_1 = $this;
  }
  protoOf(flowMethod$2$$inlined$map$1).y18 = function (collector, $completion) {
    var tmp = new $collectCOROUTINE$_18(this, collector, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(flowMethod$2$$inlined$map$1).f18 = function (collector, $completion) {
    return this.y18(collector, $completion);
  };
  function flowMethod$slambda_1($handle, resultContinuation) {
    this.dex_1 = $handle;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(flowMethod$slambda_1).jex = function (instance, _destruct__k2r9zo, $completion) {
    var tmp = this.kex(instance, _destruct__k2r9zo, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(flowMethod$slambda_1).w9 = function (p1, p2, $completion) {
    var tmp = !(p1 == null) ? p1 : THROW_CCE();
    return this.jex(tmp, p2 instanceof Triple ? p2 : THROW_CCE(), $completion);
  };
  protoOf(flowMethod$slambda_1).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 5;
            this.gex_1 = this.fex_1.fg();
            this.iex_1 = this.fex_1.gg();
            this.hex_1 = this.fex_1.zl();
            this.f9_1 = 1;
            continue $sm;
          case 1:
            this.g9_1 = 4;
            var flow = this.dex_1(this.eex_1, this.iex_1);
            var tmp_0 = this.hex_1;
            var stopPublication = tmp_0 instanceof LocalInstancePublication ? tmp_0 : THROW_CCE();
            var tmp_1 = stopPublication.oef_1;
            var stopHandle = tmp_1 instanceof StopHandle ? tmp_1 : THROW_CCE();
            this.f9_1 = 2;
            var tmp_2 = this.gex_1.b3c();
            var this_0 = takeWhile(flow, flowMethod$slambda$slambda_0(stopHandle, null));
            suspendResult = emitAll_0(tmp_2, new flowMethod$2$$inlined$map$1(this_0), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.g9_1 = 5;
            this.f9_1 = 3;
            continue $sm;
          case 3:
            this.g9_1 = 5;
            this.gex_1.zr();
            return Unit_instance;
          case 4:
            this.g9_1 = 5;
            var t = this.i9_1;
            this.gex_1.zr();
            throw t;
          case 5:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 5) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(flowMethod$slambda_1).kex = function (instance, _destruct__k2r9zo, completion) {
    var i = new flowMethod$slambda_1(this.dex_1, completion);
    i.eex_1 = instance;
    i.fex_1 = _destruct__k2r9zo;
    return i;
  };
  function flowMethod$slambda_2($handle, resultContinuation) {
    var i = new flowMethod$slambda_1($handle, resultContinuation);
    var l = function (instance, _destruct__k2r9zo, $completion) {
      return i.jex(instance, _destruct__k2r9zo, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function flowMethod$lambda$slambda($endpoint, $stopHandleMethod, $collectorSerializer, $emitHandle, $parameter, resultContinuation) {
    this.tex_1 = $endpoint;
    this.uex_1 = $stopHandleMethod;
    this.vex_1 = $collectorSerializer;
    this.wex_1 = $emitHandle;
    this.xex_1 = $parameter;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(flowMethod$lambda$slambda).dey = function ($this$channelFlow, $completion) {
    var tmp = this.eey($this$channelFlow, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(flowMethod$lambda$slambda).v9 = function (p1, $completion) {
    return this.dey((!(p1 == null) ? isInterface(p1, ProducerScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(flowMethod$lambda$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 10;
            this.cey_1 = this.tex_1.mef();
            this.f9_1 = 1;
            suspendResult = this.uex_1.oeg(this.tex_1, mixedTo(this.cey_1, Unit_instance), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.zex_1 = suspendResult;
            var collector = new SendingCollector(this.yex_1.d11());
            this.f9_1 = 2;
            suspendResult = this.cey_1.zeg(collector, this.vex_1.uef_1, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.bey_1 = suspendResult;
            this.f9_1 = 3;
            continue $sm;
          case 3:
            this.g9_1 = 9;
            this.g9_1 = 5;
            this.f9_1 = 4;
            suspendResult = this.wex_1.oeg(this.tex_1, new Triple(this.bey_1, this.xex_1, this.zex_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            this.g9_1 = 10;
            this.f9_1 = 8;
            continue $sm;
          case 5:
            this.g9_1 = 9;
            var tmp_0 = this.i9_1;
            if (tmp_0 instanceof Exception) {
              this.aey_1 = this.i9_1;
              var tmp_1 = this.aey_1;
              if (!(tmp_1 instanceof RemoteInvocationException)) {
                this.f9_1 = 6;
                suspendResult = this.zex_1.b3c().heq(this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                this.f9_1 = 7;
                continue $sm;
              }
            } else {
              throw this.i9_1;
            }

          case 6:
            this.f9_1 = 7;
            continue $sm;
          case 7:
            throw this.aey_1;
          case 8:
            this.g9_1 = 10;
            this.zex_1.zr();
            return Unit_instance;
          case 9:
            this.g9_1 = 10;
            var t = this.i9_1;
            this.zex_1.zr();
            throw t;
          case 10:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 10) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(flowMethod$lambda$slambda).eey = function ($this$channelFlow, completion) {
    var i = new flowMethod$lambda$slambda(this.tex_1, this.uex_1, this.vex_1, this.wex_1, this.xex_1, completion);
    i.yex_1 = $this$channelFlow;
    return i;
  };
  function flowMethod$lambda$slambda_0($endpoint, $stopHandleMethod, $collectorSerializer, $emitHandle, $parameter, resultContinuation) {
    var i = new flowMethod$lambda$slambda($endpoint, $stopHandleMethod, $collectorSerializer, $emitHandle, $parameter, resultContinuation);
    var l = function ($this$channelFlow, $completion) {
      return i.dey($this$channelFlow, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function flowMethod$lambda$o$collect$slambda($$this$unsafeFlow, resultContinuation) {
    this.ney_1 = $$this$unsafeFlow;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(flowMethod$lambda$o$collect$slambda).f1q = function (value, $completion) {
    var tmp = this.g1q(value, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(flowMethod$lambda$o$collect$slambda).v9 = function (p1, $completion) {
    return this.f1q((p1 == null ? true : !(p1 == null)) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(flowMethod$lambda$o$collect$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            var tmp0 = this.ney_1;
            var value = this.oey_1;
            this.f9_1 = 1;
            suspendResult = tmp0.x18(expectElement(value), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(flowMethod$lambda$o$collect$slambda).g1q = function (value, completion) {
    var i = new flowMethod$lambda$o$collect$slambda(this.ney_1, completion);
    i.oey_1 = value;
    return i;
  };
  function flowMethod$lambda$o$collect$slambda_0($$this$unsafeFlow, resultContinuation) {
    var i = new flowMethod$lambda$o$collect$slambda($$this$unsafeFlow, resultContinuation);
    var l = function (value, $completion) {
      return i.f1q(value, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function $collectCOROUTINE$_19(_this__u8e3s4, collector, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.xey_1 = _this__u8e3s4;
    this.yey_1 = collector;
  }
  protoOf($collectCOROUTINE$_19).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            var $this$unsafeFlow = this.yey_1;
            this.f9_1 = 1;
            var tmp_0 = flowMethod$lambda$o$collect$slambda_0($this$unsafeFlow, null);
            suspendResult = this.xey_1.zey_1.f18(new sam$kotlinx_coroutines_flow_FlowCollector$0_13(tmp_0), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function flowMethod$2$$inlined$map$2($this) {
    this.zey_1 = $this;
  }
  protoOf(flowMethod$2$$inlined$map$2).y18 = function (collector, $completion) {
    var tmp = new $collectCOROUTINE$_19(this, collector, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(flowMethod$2$$inlined$map$2).f18 = function (collector, $completion) {
    return this.y18(collector, $completion);
  };
  function flowMethod$lambda($stopHandleMethod, $collectorSerializer, $emitHandle) {
    return function (endpoint, parameter) {
      // Inline function 'kotlinx.coroutines.flow.map' call
      // Inline function 'kotlinx.coroutines.flow.unsafeTransform' call
      var this_0 = channelFlow(flowMethod$lambda$slambda_0(endpoint, $stopHandleMethod, $collectorSerializer, $emitHandle, parameter, null));
      // Inline function 'kotlinx.coroutines.flow.internal.unsafeFlow' call
      return new flowMethod$2$$inlined$map$2(this_0);
    };
  }
  function PublishedFlowCollectorSerializer(elementSerializer) {
    InstancePublicationSerializer.call(this, new Descriptor_1(elementSerializer));
  }
  function RemoteFlowCollector$Descriptor$emit$slambda(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(RemoteFlowCollector$Descriptor$emit$slambda).kez = function (instance, value, $completion) {
    var tmp = this.lez(instance, value, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(RemoteFlowCollector$Descriptor$emit$slambda).w9 = function (p1, p2, $completion) {
    var tmp = (!(p1 == null) ? isInterface(p1, FlowCollector) : false) ? p1 : THROW_CCE();
    return this.kez(tmp, p2 instanceof FlowMessageData ? p2 : THROW_CCE(), $completion);
  };
  protoOf(RemoteFlowCollector$Descriptor$emit$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.iez_1.x18(fromFlatData(this.jez_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(RemoteFlowCollector$Descriptor$emit$slambda).lez = function (instance, value, completion) {
    var i = new RemoteFlowCollector$Descriptor$emit$slambda(completion);
    i.iez_1 = instance;
    i.jez_1 = value;
    return i;
  };
  function RemoteFlowCollector$Descriptor$emit$slambda_0(resultContinuation) {
    var i = new RemoteFlowCollector$Descriptor$emit$slambda(resultContinuation);
    var l = function (instance, value, $completion) {
      return i.kez(instance, value, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function Descriptor_1(elementSerializer) {
    InstanceDescriptor.call(this);
    var tmp = this;
    var tmp_0 = Companion_getInstance_281().nez(elementSerializer);
    var tmp_1 = serializer_3(Unit_instance);
    tmp.pez_1 = method(this, 'emit', tmp_0, tmp_1, RemoteFlowCollector$Descriptor$emit$slambda_0(null));
  }
  protoOf(Descriptor_1).qez = function (endpoint) {
    return new RemoteFlowCollector(endpoint, this);
  };
  protoOf(Descriptor_1).kef = function (endpoint) {
    return this.qez(endpoint);
  };
  function RemoteFlowCollector(endpoint, descriptor) {
    this.rez_1 = endpoint;
    this.sez_1 = descriptor;
  }
  protoOf(RemoteFlowCollector).tez = function (value, $completion) {
    return this.sez_1.pez_1.oeg(this.rez_1, toFlatData(value), $completion);
  };
  protoOf(RemoteFlowCollector).x18 = function (value, $completion) {
    return this.tez(value instanceof FlowMessage ? value : THROW_CCE(), $completion);
  };
  function FlowMessage() {
  }
  function Element_2(element) {
    FlowMessage.call(this);
    this.qet_1 = element;
  }
  protoOf(Element_2).geu = function () {
    return false;
  };
  protoOf(Element_2).toString = function () {
    return 'Element(element=' + toString_0(this.qet_1) + ')';
  };
  protoOf(Element_2).hashCode = function () {
    return this.qet_1 == null ? 0 : hashCode(this.qet_1);
  };
  protoOf(Element_2).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Element_2))
      return false;
    if (!equals(this.qet_1, other.qet_1))
      return false;
    return true;
  };
  function End() {
    FlowMessage.call(this);
  }
  protoOf(End).geu = function () {
    return true;
  };
  function Error_1(message) {
    FlowMessage.call(this);
    this.pet_1 = message;
  }
  protoOf(Error_1).geu = function () {
    return true;
  };
  protoOf(Error_1).toString = function () {
    return 'Error(message=' + this.pet_1 + ')';
  };
  protoOf(Error_1).hashCode = function () {
    return getStringHashCode(this.pet_1);
  };
  protoOf(Error_1).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Error_1))
      return false;
    if (!(this.pet_1 === other.pet_1))
      return false;
    return true;
  };
  function expectElement(_this__u8e3s4) {
    // Inline function 'kotlin.check' call
    if (!(_this__u8e3s4 instanceof Element_2)) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    return _this__u8e3s4.qet_1;
  }
  function $serializer_init_$Init$_0(typeSerial0, $this) {
    $serializer_15.call($this);
    $this.vez_1 = typeSerial0;
    return $this;
  }
  function $serializer_init_$Create$_0(typeSerial0) {
    return $serializer_init_$Init$_0(typeSerial0, objectCreate(protoOf($serializer_15)));
  }
  function Companion_281() {
    Companion_instance_281 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('jetbrains.ocelot.langDef.rpc.flow.FlowMessageData', null, 2);
    tmp0_serialDesc.q5j('element', true);
    tmp0_serialDesc.q5j('errorMessage', true);
    this.mez_1 = tmp0_serialDesc;
  }
  protoOf(Companion_281).nez = function (typeSerial0) {
    return $serializer_init_$Create$_0(typeSerial0);
  };
  protoOf(Companion_281).q5k = function (typeParamsSerializers) {
    return this.nez(typeParamsSerializers[0]);
  };
  var Companion_instance_281;
  function Companion_getInstance_281() {
    if (Companion_instance_281 == null)
      new Companion_281();
    return Companion_instance_281;
  }
  function $serializer_15() {
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('jetbrains.ocelot.langDef.rpc.flow.FlowMessageData', this, 2);
    tmp0_serialDesc.q5j('element', true);
    tmp0_serialDesc.q5j('errorMessage', true);
    this.uez_1 = tmp0_serialDesc;
  }
  protoOf($serializer_15).wez = function (encoder, value) {
    var tmp0_desc = this.uez_1;
    var tmp1_output = encoder.g5c(tmp0_desc);
    if (tmp1_output.b5e(tmp0_desc, 0) ? true : !(value.xez_1 == null)) {
      tmp1_output.x5d(tmp0_desc, 0, this.vez_1, value.xez_1);
    }
    if (tmp1_output.b5e(tmp0_desc, 1) ? true : !(value.yez_1 == null)) {
      tmp1_output.x5d(tmp0_desc, 1, StringSerializer_getInstance(), value.yez_1);
    }
    tmp1_output.h5c(tmp0_desc);
  };
  protoOf($serializer_15).i59 = function (encoder, value) {
    return this.wez(encoder, value instanceof FlowMessageData ? value : THROW_CCE());
  };
  protoOf($serializer_15).j59 = function (decoder) {
    var tmp0_desc = this.uez_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.g5c(tmp0_desc);
    if (tmp6_input.v5c()) {
      tmp4_local0 = tmp6_input.u5c(tmp0_desc, 0, this.vez_1, tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.u5c(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.w5c(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.u5c(tmp0_desc, 0, this.vez_1, tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.u5c(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.h5c(tmp0_desc);
    return FlowMessageData_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_15).v58 = function () {
    return this.uez_1;
  };
  protoOf($serializer_15).f5k = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable(this.vez_1), get_nullable(StringSerializer_getInstance())];
  };
  protoOf($serializer_15).g5k = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [this.vez_1];
  };
  function FlowMessageData_init_$Init$(seen0, element, errorMessage, serializationConstructorMarker, $this) {
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, Companion_getInstance_281().mez_1);
    }
    if (0 === (seen0 & 1))
      $this.xez_1 = null;
    else
      $this.xez_1 = element;
    if (0 === (seen0 & 2))
      $this.yez_1 = null;
    else
      $this.yez_1 = errorMessage;
    return $this;
  }
  function FlowMessageData_init_$Create$(seen0, element, errorMessage, serializationConstructorMarker) {
    return FlowMessageData_init_$Init$(seen0, element, errorMessage, serializationConstructorMarker, objectCreate(protoOf(FlowMessageData)));
  }
  function FlowMessageData(element, errorMessage) {
    Companion_getInstance_281();
    element = element === VOID ? null : element;
    errorMessage = errorMessage === VOID ? null : errorMessage;
    this.xez_1 = element;
    this.yez_1 = errorMessage;
  }
  protoOf(FlowMessageData).toString = function () {
    return 'FlowMessageData(element=' + toString_0(this.xez_1) + ', errorMessage=' + this.yez_1 + ')';
  };
  protoOf(FlowMessageData).hashCode = function () {
    var result = this.xez_1 == null ? 0 : hashCode(this.xez_1);
    result = imul(result, 31) + (this.yez_1 == null ? 0 : getStringHashCode(this.yez_1)) | 0;
    return result;
  };
  protoOf(FlowMessageData).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof FlowMessageData))
      return false;
    if (!equals(this.xez_1, other.xez_1))
      return false;
    if (!(this.yez_1 == other.yez_1))
      return false;
    return true;
  };
  function toFlatData(_this__u8e3s4) {
    var tmp;
    if (_this__u8e3s4 instanceof Element_2) {
      tmp = new FlowMessageData(_this__u8e3s4.qet_1);
    } else {
      if (_this__u8e3s4 instanceof Error_1) {
        tmp = new FlowMessageData(VOID, _this__u8e3s4.pet_1);
      } else {
        if (_this__u8e3s4 instanceof End) {
          tmp = new FlowMessageData();
        } else {
          noWhenBranchMatchedException();
        }
      }
    }
    return tmp;
  }
  function fromFlatData(_this__u8e3s4) {
    return !(_this__u8e3s4.xez_1 == null) ? new Element_2(_this__u8e3s4.xez_1) : !(_this__u8e3s4.yez_1 == null) ? new Error_1(_this__u8e3s4.yez_1) : new End();
  }
  function PublishedDisposableSerializer() {
    PublishedDisposableSerializer_instance = this;
    InstancePublicationSerializer.call(this, Companion_getInstance_282());
  }
  var PublishedDisposableSerializer_instance;
  function PublishedDisposableSerializer_getInstance() {
    if (PublishedDisposableSerializer_instance == null)
      new PublishedDisposableSerializer();
    return PublishedDisposableSerializer_instance;
  }
  function Companion_282() {
    Companion_instance_282 = this;
    InstanceDescriptor.call(this);
  }
  protoOf(Companion_282).af0 = function (endpoint) {
    return new RemoteDisposable(endpoint);
  };
  protoOf(Companion_282).kef = function (endpoint) {
    return this.af0(endpoint);
  };
  var Companion_instance_282;
  function Companion_getInstance_282() {
    if (Companion_instance_282 == null)
      new Companion_282();
    return Companion_instance_282;
  }
  function RemoteDisposable(endpoint) {
    Companion_getInstance_282();
    this.bf0_1 = endpoint;
  }
  protoOf(RemoteDisposable).zr = function () {
    this.bf0_1.zr();
  };
  function get_LOG_4() {
    _init_properties_RpcClient_kt__px582m();
    return LOG_4;
  }
  var LOG_4;
  function RpcClient(states, coroutineScope) {
    this.cf0_1 = coroutineScope;
    this.df0_1 = states;
  }
  protoOf(RpcClient).ho = function () {
    return this.cf0_1.ho();
  };
  function wsRpcClient(_this__u8e3s4, schema, wsSessionProvider) {
    _init_properties_RpcClient_kt__px582m();
    return rpcClient(_this__u8e3s4, wsRpcClient$lambda(wsSessionProvider, schema));
  }
  function rpcClient(_this__u8e3s4, entriesProvider) {
    _init_properties_RpcClient_kt__px582m();
    var job = Job_0(get_job(_this__u8e3s4.ho()));
    var rpcClientScope = CoroutineScope_0(_this__u8e3s4.ho().wi(job));
    var entriesChannel = entriesProvider(rpcClientScope);
    var sharedFlowDeferred = async(rpcClientScope, VOID, VOID, rpcClient$slambda_0(entriesChannel, rpcClientScope, null));
    return new RpcClient(flow(rpcClient$slambda_2(sharedFlowDeferred, null)), rpcClientScope);
  }
  function wsEntryPoints(_this__u8e3s4, wsSessionProvider, schema) {
    _init_properties_RpcClient_kt__px582m();
    return produce_0(_this__u8e3s4, VOID, VOID, wsEntryPoints$slambda_0(wsSessionProvider, schema, null));
  }
  function sessionJob(_this__u8e3s4) {
    _init_properties_RpcClient_kt__px582m();
    var tmp = SupervisorJob(get_job(_this__u8e3s4.ho()));
    // Inline function 'kotlinx.coroutines.CoroutineExceptionHandler' call
    var tmp$ret$0 = new sessionJob$$inlined$CoroutineExceptionHandler$1();
    return tmp.wi(tmp$ret$0);
  }
  function LOG$lambda_4() {
    _init_properties_RpcClient_kt__px582m();
    return Unit_instance;
  }
  function wsRpcClient$lambda($wsSessionProvider, $schema) {
    return function ($this$rpcClient) {
      return wsEntryPoints($this$rpcClient, $wsSessionProvider, $schema);
    };
  }
  function rpcClient$slambda($entriesChannel, $rpcClientScope, resultContinuation) {
    this.mf0_1 = $entriesChannel;
    this.nf0_1 = $rpcClientScope;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(rpcClient$slambda).pf0 = function ($this$async, $completion) {
    var tmp = this.f1h($this$async, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(rpcClient$slambda).v9 = function (p1, $completion) {
    return this.pf0((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(rpcClient$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = stateIn(consumeAsFlow(this.mf0_1), this.nf0_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(rpcClient$slambda).f1h = function ($this$async, completion) {
    var i = new rpcClient$slambda(this.mf0_1, this.nf0_1, completion);
    i.of0_1 = $this$async;
    return i;
  };
  function rpcClient$slambda_0($entriesChannel, $rpcClientScope, resultContinuation) {
    var i = new rpcClient$slambda($entriesChannel, $rpcClientScope, resultContinuation);
    var l = function ($this$async, $completion) {
      return i.pf0($this$async, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function rpcClient$slambda_1($sharedFlowDeferred, resultContinuation) {
    this.yf0_1 = $sharedFlowDeferred;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(rpcClient$slambda_1).z1h = function ($this$flow, $completion) {
    var tmp = this.a1i($this$flow, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(rpcClient$slambda_1).v9 = function (p1, $completion) {
    return this.z1h((!(p1 == null) ? isInterface(p1, FlowCollector) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(rpcClient$slambda_1).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 3;
            this.f9_1 = 1;
            suspendResult = this.yf0_1.nr(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            this.f9_1 = 2;
            suspendResult = emitAll_0(this.zf0_1, ARGUMENT, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 3) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(rpcClient$slambda_1).a1i = function ($this$flow, completion) {
    var i = new rpcClient$slambda_1(this.yf0_1, completion);
    i.zf0_1 = $this$flow;
    return i;
  };
  function rpcClient$slambda_2($sharedFlowDeferred, resultContinuation) {
    var i = new rpcClient$slambda_1($sharedFlowDeferred, resultContinuation);
    var l = function ($this$flow, $completion) {
      return i.z1h($this$flow, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function wsEntryPoints$slambda$slambda($this_produce, resultContinuation) {
    this.if1_1 = $this_produce;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(wsEntryPoints$slambda$slambda).kf1 = function (it, $completion) {
    var tmp = this.lf1(it, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(wsEntryPoints$slambda$slambda).v9 = function (p1, $completion) {
    return this.kf1(!(p1 == null) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(wsEntryPoints$slambda$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.if1_1.d11().z15(this.jf1_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(wsEntryPoints$slambda$slambda).lf1 = function (it, completion) {
    var i = new wsEntryPoints$slambda$slambda(this.if1_1, completion);
    i.jf1_1 = it;
    return i;
  };
  function wsEntryPoints$slambda$slambda_0($this_produce, resultContinuation) {
    var i = new wsEntryPoints$slambda$slambda($this_produce, resultContinuation);
    var l = function (it, $completion) {
      return i.kf1(it, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function wsEntryPoints$slambda($wsSessionProvider, $schema, resultContinuation) {
    this.uf1_1 = $wsSessionProvider;
    this.vf1_1 = $schema;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(wsEntryPoints$slambda).r1g = function ($this$produce, $completion) {
    var tmp = this.s1g($this$produce, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(wsEntryPoints$slambda).v9 = function (p1, $completion) {
    return this.r1g((!(p1 == null) ? isInterface(p1, ProducerScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(wsEntryPoints$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 11;
            var tmp_0 = this;
            tmp_0.af2_1 = this.uf1_1;
            this.f9_1 = 1;
            continue $sm;
          case 1:
            this.yf1_1 = this.af2_1;
            this.xf1_1 = null;
            this.f9_1 = 2;
            continue $sm;
          case 2:
            this.f9_1 = 3;
            continue $sm;
          case 3:
            this.g9_1 = 10;
            this.g9_1 = 9;
            this.zf1_1 = this.yf1_1.m();
            this.f9_1 = 4;
            continue $sm;
          case 4:
            this.f9_1 = 5;
            suspendResult = this.zf1_1.d14(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 5:
            if (!suspendResult) {
              this.f9_1 = 7;
              continue $sm;
            }

            var e = this.zf1_1.o();
            this.f9_1 = 6;
            var tmp_1 = rpcSession(this.wf1_1, sessionJob(this.wf1_1), get_ClientRpcInitiationHandler(), e);
            suspendResult = this.vf1_1.cf2(tmp_1, wsEntryPoints$slambda$slambda_0(this.wf1_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 6:
            this.f9_1 = 4;
            continue $sm;
          case 7:
            this.g9_1 = 11;
            this.f9_1 = 8;
            continue $sm;
          case 8:
            this.g9_1 = 11;
            cancelConsumed(this.yf1_1, this.xf1_1);
            this.f9_1 = 13;
            continue $sm;
          case 9:
            this.g9_1 = 10;
            var tmp_2 = this.i9_1;
            if (tmp_2 instanceof Error) {
              var e_0 = this.i9_1;
              this.xf1_1 = e_0;
              throw e_0;
            } else {
              throw this.i9_1;
            }

          case 10:
            this.g9_1 = 11;
            var t = this.i9_1;
            cancelConsumed(this.yf1_1, this.xf1_1);
            throw t;
          case 11:
            throw this.i9_1;
          case 12:
            this.g9_1 = 11;
            cancelConsumed(this.yf1_1, this.xf1_1);
            if (false) {
              this.f9_1 = 1;
              continue $sm;
            }

            this.f9_1 = 13;
            continue $sm;
          case 13:
            return Unit_instance;
        }
      } catch ($p) {
        var e_1 = $p;
        if (this.g9_1 === 11) {
          throw e_1;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e_1;
        }
      }
     while (true);
  };
  protoOf(wsEntryPoints$slambda).s1g = function ($this$produce, completion) {
    var i = new wsEntryPoints$slambda(this.uf1_1, this.vf1_1, completion);
    i.wf1_1 = $this$produce;
    return i;
  };
  function wsEntryPoints$slambda_0($wsSessionProvider, $schema, resultContinuation) {
    var i = new wsEntryPoints$slambda($wsSessionProvider, $schema, resultContinuation);
    var l = function ($this$produce, $completion) {
      return i.r1g($this$produce, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function sessionJob$o$handleException$lambda($throwable) {
    return function () {
      return 'Session finished with an exception ' + $throwable.toString();
    };
  }
  function sessionJob$$inlined$CoroutineExceptionHandler$1() {
    AbstractCoroutineContextElement.call(this, Key_instance_1);
  }
  protoOf(sessionJob$$inlined$CoroutineExceptionHandler$1).av = function (context, exception) {
    var tmp = get_LOG_4();
    tmp.e2q(exception, sessionJob$o$handleException$lambda(exception));
    return Unit_instance;
  };
  var properties_initialized_RpcClient_kt_x4l1a8;
  function _init_properties_RpcClient_kt__px582m() {
    if (!properties_initialized_RpcClient_kt_x4l1a8) {
      properties_initialized_RpcClient_kt_x4l1a8 = true;
      var tmp = KotlinLogging_getInstance();
      LOG_4 = tmp.i2q(LOG$lambda_4);
    }
  }
  function get_RPC_INITIAL_SEQUENCE() {
    _init_properties_RpcInitiationHandler_kt__6estzr();
    return RPC_INITIAL_SEQUENCE;
  }
  var RPC_INITIAL_SEQUENCE;
  function get_NoRpcInitiationHandler() {
    _init_properties_RpcInitiationHandler_kt__6estzr();
    return NoRpcInitiationHandler;
  }
  var NoRpcInitiationHandler;
  function get_ClientRpcInitiationHandler() {
    _init_properties_RpcInitiationHandler_kt__6estzr();
    return ClientRpcInitiationHandler;
  }
  var ClientRpcInitiationHandler;
  var ServerRpcInitiationHandler;
  function RpcInitiationHandler() {
  }
  function sam$jetbrains_ocelot_langDef_rpc_session_RpcInitiationHandler$0(function_0) {
    this.ff2_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_langDef_rpc_session_RpcInitiationHandler$0).ef2 = function (_this__u8e3s4, session, initiationJob) {
    return this.ff2_1(_this__u8e3s4, session, initiationJob);
  };
  protoOf(sam$jetbrains_ocelot_langDef_rpc_session_RpcInitiationHandler$0).f3 = function () {
    return this.ff2_1;
  };
  protoOf(sam$jetbrains_ocelot_langDef_rpc_session_RpcInitiationHandler$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, RpcInitiationHandler) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_langDef_rpc_session_RpcInitiationHandler$0).hashCode = function () {
    return hashCode(this.f3());
  };
  function sam$jetbrains_ocelot_langDef_rpc_session_RpcInitiationHandler$0_0(function_0) {
    this.gf2_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_langDef_rpc_session_RpcInitiationHandler$0_0).ef2 = function (_this__u8e3s4, session, initiationJob) {
    return this.gf2_1(_this__u8e3s4, session, initiationJob);
  };
  protoOf(sam$jetbrains_ocelot_langDef_rpc_session_RpcInitiationHandler$0_0).f3 = function () {
    return this.gf2_1;
  };
  protoOf(sam$jetbrains_ocelot_langDef_rpc_session_RpcInitiationHandler$0_0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, RpcInitiationHandler) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_langDef_rpc_session_RpcInitiationHandler$0_0).hashCode = function () {
    return hashCode(this.f3());
  };
  function sam$jetbrains_ocelot_langDef_rpc_session_RpcInitiationHandler$0_1(function_0) {
    this.hf2_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_langDef_rpc_session_RpcInitiationHandler$0_1).ef2 = function (_this__u8e3s4, session, initiationJob) {
    return this.hf2_1(_this__u8e3s4, session, initiationJob);
  };
  protoOf(sam$jetbrains_ocelot_langDef_rpc_session_RpcInitiationHandler$0_1).f3 = function () {
    return this.hf2_1;
  };
  protoOf(sam$jetbrains_ocelot_langDef_rpc_session_RpcInitiationHandler$0_1).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, RpcInitiationHandler) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_langDef_rpc_session_RpcInitiationHandler$0_1).hashCode = function () {
    return hashCode(this.f3());
  };
  function NoRpcInitiationHandler$lambda($this$RpcInitiationHandler, _unused_var__etf5q3, initiationJob) {
    _init_properties_RpcInitiationHandler_kt__6estzr();
    initiationJob.su();
    return Unit_instance;
  }
  function ClientRpcInitiationHandler$lambda($this$RpcInitiationHandler, session, initiationJob) {
    _init_properties_RpcInitiationHandler_kt__6estzr();
    launch($this$RpcInitiationHandler, VOID, VOID, ClientRpcInitiationHandler$lambda$slambda_0(session, initiationJob, null));
    return Unit_instance;
  }
  function ClientRpcInitiationHandler$lambda$slambda($session, $initiationJob, resultContinuation) {
    this.qf2_1 = $session;
    this.rf2_1 = $initiationJob;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ClientRpcInitiationHandler$lambda$slambda).e1h = function ($this$launch, $completion) {
    var tmp = this.f1h($this$launch, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(ClientRpcInitiationHandler$lambda$slambda).v9 = function (p1, $completion) {
    return this.e1h((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ClientRpcInitiationHandler$lambda$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.qf2_1.tf2_1.d16(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var initial = suspendResult;
            var tmp_0;
            if (initial instanceof Binary) {
              tmp_0 = contentEquals(initial.ve3_1, get_RPC_INITIAL_SEQUENCE());
            } else {
              tmp_0 = false;
            }

            if (tmp_0) {
              this.rf2_1.su();
            } else {
              this.rf2_1.ru(IllegalStateException_init_$Create$_0('Invalid rpc initial sequence: ' + initial.toString() + ', ' + toString_1(initial.ve3_1)));
            }

            return Unit_instance;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(ClientRpcInitiationHandler$lambda$slambda).f1h = function ($this$launch, completion) {
    var i = new ClientRpcInitiationHandler$lambda$slambda(this.qf2_1, this.rf2_1, completion);
    i.sf2_1 = $this$launch;
    return i;
  };
  function ClientRpcInitiationHandler$lambda$slambda_0($session, $initiationJob, resultContinuation) {
    var i = new ClientRpcInitiationHandler$lambda$slambda($session, $initiationJob, resultContinuation);
    var l = function ($this$launch, $completion) {
      return i.e1h($this$launch, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function ServerRpcInitiationHandler$lambda($this$RpcInitiationHandler, session, initiationJob) {
    _init_properties_RpcInitiationHandler_kt__6estzr();
    launch($this$RpcInitiationHandler, VOID, VOID, ServerRpcInitiationHandler$lambda$slambda_0(initiationJob, session, null));
    return Unit_instance;
  }
  function ServerRpcInitiationHandler$lambda$slambda($initiationJob, $session, resultContinuation) {
    this.df3_1 = $initiationJob;
    this.ef3_1 = $session;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ServerRpcInitiationHandler$lambda$slambda).e1h = function ($this$launch, $completion) {
    var tmp = this.f1h($this$launch, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(ServerRpcInitiationHandler$lambda$slambda).v9 = function (p1, $completion) {
    return this.e1h((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ServerRpcInitiationHandler$lambda$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 3;
            this.f9_1 = 1;
            suspendResult = this.df3_1.np(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.f9_1 = 2;
            suspendResult = this.ef3_1.uf2_1.z15(Binary_init_$Create$(true, get_RPC_INITIAL_SEQUENCE()), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 3) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(ServerRpcInitiationHandler$lambda$slambda).f1h = function ($this$launch, completion) {
    var i = new ServerRpcInitiationHandler$lambda$slambda(this.df3_1, this.ef3_1, completion);
    i.ff3_1 = $this$launch;
    return i;
  };
  function ServerRpcInitiationHandler$lambda$slambda_0($initiationJob, $session, resultContinuation) {
    var i = new ServerRpcInitiationHandler$lambda$slambda($initiationJob, $session, resultContinuation);
    var l = function ($this$launch, $completion) {
      return i.e1h($this$launch, $completion);
    };
    l.$arity = 1;
    return l;
  }
  var properties_initialized_RpcInitiationHandler_kt_679g2d;
  function _init_properties_RpcInitiationHandler_kt__6estzr() {
    if (!properties_initialized_RpcInitiationHandler_kt_679g2d) {
      properties_initialized_RpcInitiationHandler_kt_679g2d = true;
      // Inline function 'kotlin.byteArrayOf' call
      RPC_INITIAL_SEQUENCE = new Int8Array([75, 79, 67, 82, 80, 67]);
      var tmp = NoRpcInitiationHandler$lambda;
      NoRpcInitiationHandler = new sam$jetbrains_ocelot_langDef_rpc_session_RpcInitiationHandler$0(tmp);
      var tmp_0 = ClientRpcInitiationHandler$lambda;
      ClientRpcInitiationHandler = new sam$jetbrains_ocelot_langDef_rpc_session_RpcInitiationHandler$0_0(tmp_0);
      var tmp_1 = ServerRpcInitiationHandler$lambda;
      ServerRpcInitiationHandler = new sam$jetbrains_ocelot_langDef_rpc_session_RpcInitiationHandler$0_1(tmp_1);
    }
  }
  function RpcSchema$connect$slambda$lambda($facade) {
    return function (it) {
      $facade.gw().sp();
      return Unit_instance;
    };
  }
  function RpcSchema$connect$slambda($session, this$0, $connection, resultContinuation) {
    this.of3_1 = $session;
    this.pf3_1 = this$0;
    this.qf3_1 = $connection;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(RpcSchema$connect$slambda).e1h = function ($this$coroutineScope, $completion) {
    var tmp = this.f1h($this$coroutineScope, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(RpcSchema$connect$slambda).v9 = function (p1, $completion) {
    return this.e1h((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(RpcSchema$connect$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 3;
            var facade = rpcFacade(this.rf3_1, this.of3_1.te0(), this.of3_1.ue0(), this.of3_1.y2());
            this.sf3_1 = facade.aeg(new RemoteInstanceId(0n), this.pf3_1.bf2_1).b3c();
            var tmp_0 = this.of3_1.gw();
            tmp_0.kp(RpcSchema$connect$slambda$lambda(facade));
            this.f9_1 = 1;
            suspendResult = this.of3_1.tf3().np(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.f9_1 = 2;
            suspendResult = this.qf3_1(this.sf3_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 3) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(RpcSchema$connect$slambda).f1h = function ($this$coroutineScope, completion) {
    var i = new RpcSchema$connect$slambda(this.of3_1, this.pf3_1, this.qf3_1, completion);
    i.rf3_1 = $this$coroutineScope;
    return i;
  };
  function RpcSchema$connect$slambda_0($session, this$0, $connection, resultContinuation) {
    var i = new RpcSchema$connect$slambda($session, this$0, $connection, resultContinuation);
    var l = function ($this$coroutineScope, $completion) {
      return i.e1h($this$coroutineScope, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function RpcSchema(entryPointDescriptor) {
    this.bf2_1 = entryPointDescriptor;
  }
  protoOf(RpcSchema).cf2 = function (session, connection, $completion) {
    return coroutineScope(RpcSchema$connect$slambda_0(session, this, connection, null), $completion);
  };
  function Companion_283() {
    Companion_instance_283 = this;
    this.uf3_1 = new RpcSessionCounter();
  }
  protoOf(Companion_283).vf3 = function (coroutineContext) {
    var tmp0_elvis_lhs = coroutineContext.s9(Companion_getInstance_283());
    var counter = tmp0_elvis_lhs == null ? this.uf3_1 : tmp0_elvis_lhs;
    var tmp1_safe_receiver = coroutineContext.s9(Key_instance_2);
    var oldName = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.cv_1;
    var tmp;
    if (oldName == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp = oldName + '-';
    }
    var tmp3_elvis_lhs = tmp;
    var prefix = tmp3_elvis_lhs == null ? '' : tmp3_elvis_lhs;
    var _unary__edvuaz = counter.xf3_1;
    counter.xf3_1 = _unary__edvuaz + 1 | 0;
    return new CoroutineName(prefix + _unary__edvuaz);
  };
  var Companion_instance_283;
  function Companion_getInstance_283() {
    if (Companion_instance_283 == null)
      new Companion_283();
    return Companion_instance_283;
  }
  function RpcSessionCounter() {
    Companion_getInstance_283();
    AbstractCoroutineContextElement.call(this, Companion_getInstance_283());
    this.xf3_1 = 0;
  }
  function rpcSession(_this__u8e3s4, context, initiationHandler, launcher) {
    context = context === VOID ? EmptyCoroutineContext_instance : context;
    initiationHandler = initiationHandler === VOID ? get_NoRpcInitiationHandler() : initiationHandler;
    var newContext = _this__u8e3s4.ho().wi(context);
    var job = Job_0(get_job(newContext));
    var name = Companion_getInstance_283().vf3(newContext);
    var outgoing = Channel();
    var incoming = Channel();
    var initiationJob = Job_0(job);
    var tmp = newContext.wi(job).wi(name);
    launch(_this__u8e3s4, tmp, VOID, rpcSession$slambda_0(launcher, initiationHandler, initiationJob, incoming, outgoing, null));
    return new WsRpcSession(incoming, outgoing, job, name, initiationJob);
  }
  function WsRpcSession(incoming, outgoing, job, name, initiationJob) {
    this.yf3_1 = incoming;
    this.zf3_1 = outgoing;
    this.af4_1 = job;
    this.bf4_1 = name;
    this.cf4_1 = initiationJob;
  }
  protoOf(WsRpcSession).te0 = function () {
    return this.yf3_1;
  };
  protoOf(WsRpcSession).ue0 = function () {
    return this.zf3_1;
  };
  protoOf(WsRpcSession).gw = function () {
    return this.af4_1;
  };
  protoOf(WsRpcSession).y2 = function () {
    return this.bf4_1;
  };
  protoOf(WsRpcSession).tf3 = function () {
    return this.cf4_1;
  };
  function rpcSession$slambda$slambda($initiationJob, $wsSession, $incoming, resultContinuation) {
    this.lf4_1 = $initiationJob;
    this.mf4_1 = $wsSession;
    this.nf4_1 = $incoming;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(rpcSession$slambda$slambda).e1h = function ($this$launch, $completion) {
    var tmp = this.f1h($this$launch, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(rpcSession$slambda$slambda).v9 = function (p1, $completion) {
    return this.e1h((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(rpcSession$slambda$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 15;
            this.f9_1 = 1;
            suspendResult = this.lf4_1.np(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp_0 = this;
            tmp_0.sf4_1 = this.mf4_1.tf2_1;
            this.f9_1 = 2;
            continue $sm;
          case 2:
            this.qf4_1 = this.sf4_1;
            this.pf4_1 = null;
            this.f9_1 = 3;
            continue $sm;
          case 3:
            this.f9_1 = 4;
            continue $sm;
          case 4:
            this.g9_1 = 12;
            this.g9_1 = 11;
            this.rf4_1 = this.qf4_1.m();
            this.f9_1 = 5;
            continue $sm;
          case 5:
            this.f9_1 = 6;
            suspendResult = this.rf4_1.d14(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 6:
            if (!suspendResult) {
              this.f9_1 = 9;
              continue $sm;
            }

            var e = this.rf4_1.o();
            if (e instanceof Binary) {
              var message = Default_getInstance_1().b5a(Companion_getInstance_279().i63(), e.ve3_1);
              this.f9_1 = 7;
              suspendResult = this.nf4_1.z15(message, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.f9_1 = 8;
              continue $sm;
            }

          case 7:
            this.f9_1 = 8;
            continue $sm;
          case 8:
            this.f9_1 = 5;
            continue $sm;
          case 9:
            this.g9_1 = 15;
            this.f9_1 = 10;
            continue $sm;
          case 10:
            this.g9_1 = 15;
            cancelConsumed(this.qf4_1, this.pf4_1);
            this.f9_1 = 14;
            continue $sm;
          case 11:
            this.g9_1 = 12;
            var tmp_1 = this.i9_1;
            if (tmp_1 instanceof Error) {
              var e_0 = this.i9_1;
              this.pf4_1 = e_0;
              throw e_0;
            } else {
              throw this.i9_1;
            }

          case 12:
            this.g9_1 = 15;
            var t = this.i9_1;
            cancelConsumed(this.qf4_1, this.pf4_1);
            throw t;
          case 13:
            this.g9_1 = 15;
            cancelConsumed(this.qf4_1, this.pf4_1);
            if (false) {
              this.f9_1 = 2;
              continue $sm;
            }

            this.f9_1 = 14;
            continue $sm;
          case 14:
            this.nf4_1.i16();
            return Unit_instance;
          case 15:
            throw this.i9_1;
        }
      } catch ($p) {
        var e_1 = $p;
        if (this.g9_1 === 15) {
          throw e_1;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e_1;
        }
      }
     while (true);
  };
  protoOf(rpcSession$slambda$slambda).f1h = function ($this$launch, completion) {
    var i = new rpcSession$slambda$slambda(this.lf4_1, this.mf4_1, this.nf4_1, completion);
    i.of4_1 = $this$launch;
    return i;
  };
  function rpcSession$slambda$slambda_0($initiationJob, $wsSession, $incoming, resultContinuation) {
    var i = new rpcSession$slambda$slambda($initiationJob, $wsSession, $incoming, resultContinuation);
    var l = function ($this$launch, $completion) {
      return i.e1h($this$launch, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function rpcSession$slambda$slambda_1($outgoing, $wsSession, resultContinuation) {
    this.bf5_1 = $outgoing;
    this.cf5_1 = $wsSession;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(rpcSession$slambda$slambda_1).e1h = function ($this$launch, $completion) {
    var tmp = this.f1h($this$launch, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(rpcSession$slambda$slambda_1).v9 = function (p1, $completion) {
    return this.e1h((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(rpcSession$slambda$slambda_1).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 14;
            this.g9_1 = 13;
            var tmp_0 = this;
            tmp_0.hf5_1 = this.bf5_1;
            this.f9_1 = 1;
            continue $sm;
          case 1:
            this.ff5_1 = this.hf5_1;
            this.ef5_1 = null;
            this.f9_1 = 2;
            continue $sm;
          case 2:
            this.f9_1 = 3;
            continue $sm;
          case 3:
            this.g9_1 = 10;
            this.g9_1 = 9;
            this.gf5_1 = this.ff5_1.m();
            this.f9_1 = 4;
            continue $sm;
          case 4:
            this.f9_1 = 5;
            suspendResult = this.gf5_1.d14(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 5:
            if (!suspendResult) {
              this.f9_1 = 7;
              continue $sm;
            }

            var e = this.gf5_1.o();
            var data = Default_getInstance_1().a5a(Companion_getInstance_279().i63(), e);
            this.f9_1 = 6;
            suspendResult = this.cf5_1.uf2_1.z15(Binary_init_$Create$(true, data), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 6:
            this.f9_1 = 4;
            continue $sm;
          case 7:
            this.f9_1 = 8;
            continue $sm;
          case 8:
            this.g9_1 = 13;
            cancelConsumed(this.ff5_1, this.ef5_1);
            this.f9_1 = 12;
            continue $sm;
          case 9:
            this.g9_1 = 10;
            var tmp_1 = this.i9_1;
            if (tmp_1 instanceof Error) {
              var e_0 = this.i9_1;
              this.ef5_1 = e_0;
              throw e_0;
            } else {
              throw this.i9_1;
            }

          case 10:
            this.g9_1 = 13;
            var t = this.i9_1;
            cancelConsumed(this.ff5_1, this.ef5_1);
            throw t;
          case 11:
            this.g9_1 = 13;
            cancelConsumed(this.ff5_1, this.ef5_1);
            if (false) {
              this.f9_1 = 1;
              continue $sm;
            }

            this.f9_1 = 12;
            continue $sm;
          case 12:
            this.g9_1 = 14;
            this.f9_1 = 15;
            continue $sm;
          case 13:
            this.g9_1 = 14;
            var tmp_2 = this.i9_1;
            if (tmp_2 instanceof ClosedSendChannelException) {
              var e_1 = this.i9_1;
              this.f9_1 = 15;
              continue $sm;
            } else {
              throw this.i9_1;
            }

          case 14:
            throw this.i9_1;
          case 15:
            this.g9_1 = 14;
            return Unit_instance;
        }
      } catch ($p) {
        var e_2 = $p;
        if (this.g9_1 === 14) {
          throw e_2;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e_2;
        }
      }
     while (true);
  };
  protoOf(rpcSession$slambda$slambda_1).f1h = function ($this$launch, completion) {
    var i = new rpcSession$slambda$slambda_1(this.bf5_1, this.cf5_1, completion);
    i.df5_1 = $this$launch;
    return i;
  };
  function rpcSession$slambda$slambda_2($outgoing, $wsSession, resultContinuation) {
    var i = new rpcSession$slambda$slambda_1($outgoing, $wsSession, resultContinuation);
    var l = function ($this$launch, $completion) {
      return i.e1h($this$launch, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function rpcSession$slambda($launcher, $initiationHandler, $initiationJob, $incoming, $outgoing, resultContinuation) {
    this.qf5_1 = $launcher;
    this.rf5_1 = $initiationHandler;
    this.sf5_1 = $initiationJob;
    this.tf5_1 = $incoming;
    this.uf5_1 = $outgoing;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(rpcSession$slambda).e1h = function ($this$launch, $completion) {
    var tmp = this.f1h($this$launch, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(rpcSession$slambda).v9 = function (p1, $completion) {
    return this.e1h((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(rpcSession$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        if (tmp === 0) {
          this.g9_1 = 1;
          var wsSession = this.qf5_1(this.vf5_1);
          this.rf5_1.ef2(this.vf5_1, wsSession, this.sf5_1);
          launch(this.vf5_1, VOID, VOID, rpcSession$slambda$slambda_0(this.sf5_1, wsSession, this.tf5_1, null));
          launch(this.vf5_1, VOID, VOID, rpcSession$slambda$slambda_2(this.uf5_1, wsSession, null));
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(rpcSession$slambda).f1h = function ($this$launch, completion) {
    var i = new rpcSession$slambda(this.qf5_1, this.rf5_1, this.sf5_1, this.tf5_1, this.uf5_1, completion);
    i.vf5_1 = $this$launch;
    return i;
  };
  function rpcSession$slambda_0($launcher, $initiationHandler, $initiationJob, $incoming, $outgoing, resultContinuation) {
    var i = new rpcSession$slambda($launcher, $initiationHandler, $initiationJob, $incoming, $outgoing, resultContinuation);
    var l = function ($this$launch, $completion) {
      return i.e1h($this$launch, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function get_WS_SESSION_RECONNECT_DURATION() {
    _init_properties_WsSession_kt__dx1ve0();
    return WS_SESSION_RECONNECT_DURATION;
  }
  var WS_SESSION_RECONNECT_DURATION;
  function WsSession(incoming, outgoing) {
    this.tf2_1 = incoming;
    this.uf2_1 = outgoing;
  }
  protoOf(WsSession).toString = function () {
    return 'WsSession(incoming=' + toString_1(this.tf2_1) + ', outgoing=' + toString_1(this.uf2_1) + ')';
  };
  protoOf(WsSession).hashCode = function () {
    var result = hashCode(this.tf2_1);
    result = imul(result, 31) + hashCode(this.uf2_1) | 0;
    return result;
  };
  protoOf(WsSession).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof WsSession))
      return false;
    if (!equals(this.tf2_1, other.tf2_1))
      return false;
    if (!equals(this.uf2_1, other.uf2_1))
      return false;
    return true;
  };
  function WsSessionScope$bind$slambda$slambda($incoming, this$0, resultContinuation) {
    this.ef6_1 = $incoming;
    this.ff6_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(WsSessionScope$bind$slambda$slambda).e1h = function ($this$launch, $completion) {
    var tmp = this.f1h($this$launch, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(WsSessionScope$bind$slambda$slambda).v9 = function (p1, $completion) {
    return this.e1h((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(WsSessionScope$bind$slambda$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 11;
            var tmp_0 = this;
            tmp_0.kf6_1 = this.ef6_1;
            this.f9_1 = 1;
            continue $sm;
          case 1:
            this.if6_1 = this.kf6_1;
            this.hf6_1 = null;
            this.f9_1 = 2;
            continue $sm;
          case 2:
            this.f9_1 = 3;
            continue $sm;
          case 3:
            this.g9_1 = 10;
            this.g9_1 = 9;
            this.jf6_1 = this.if6_1.m();
            this.f9_1 = 4;
            continue $sm;
          case 4:
            this.f9_1 = 5;
            suspendResult = this.jf6_1.d14(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 5:
            if (!suspendResult) {
              this.f9_1 = 7;
              continue $sm;
            }

            var e = this.jf6_1.o();
            this.f9_1 = 6;
            suspendResult = this.ff6_1.mf6_1.z15(e, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 6:
            this.f9_1 = 4;
            continue $sm;
          case 7:
            this.g9_1 = 11;
            this.f9_1 = 8;
            continue $sm;
          case 8:
            this.g9_1 = 11;
            cancelConsumed(this.if6_1, this.hf6_1);
            this.f9_1 = 13;
            continue $sm;
          case 9:
            this.g9_1 = 10;
            var tmp_1 = this.i9_1;
            if (tmp_1 instanceof Error) {
              var e_0 = this.i9_1;
              this.hf6_1 = e_0;
              throw e_0;
            } else {
              throw this.i9_1;
            }

          case 10:
            this.g9_1 = 11;
            var t = this.i9_1;
            cancelConsumed(this.if6_1, this.hf6_1);
            throw t;
          case 11:
            throw this.i9_1;
          case 12:
            this.g9_1 = 11;
            cancelConsumed(this.if6_1, this.hf6_1);
            if (false) {
              this.f9_1 = 1;
              continue $sm;
            }

            this.f9_1 = 13;
            continue $sm;
          case 13:
            return Unit_instance;
        }
      } catch ($p) {
        var e_1 = $p;
        if (this.g9_1 === 11) {
          throw e_1;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e_1;
        }
      }
     while (true);
  };
  protoOf(WsSessionScope$bind$slambda$slambda).f1h = function ($this$launch, completion) {
    var i = new WsSessionScope$bind$slambda$slambda(this.ef6_1, this.ff6_1, completion);
    i.gf6_1 = $this$launch;
    return i;
  };
  function WsSessionScope$bind$slambda$slambda_0($incoming, this$0, resultContinuation) {
    var i = new WsSessionScope$bind$slambda$slambda($incoming, this$0, resultContinuation);
    var l = function ($this$launch, $completion) {
      return i.e1h($this$launch, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function WsSessionScope$bind$slambda$slambda_1(this$0, $outgoing, resultContinuation) {
    this.wf6_1 = this$0;
    this.xf6_1 = $outgoing;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(WsSessionScope$bind$slambda$slambda_1).e1h = function ($this$launch, $completion) {
    var tmp = this.f1h($this$launch, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(WsSessionScope$bind$slambda$slambda_1).v9 = function (p1, $completion) {
    return this.e1h((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(WsSessionScope$bind$slambda$slambda_1).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 11;
            var tmp_0 = this;
            tmp_0.cf7_1 = this.wf6_1.nf6_1;
            this.f9_1 = 1;
            continue $sm;
          case 1:
            this.af7_1 = this.cf7_1;
            this.zf6_1 = null;
            this.f9_1 = 2;
            continue $sm;
          case 2:
            this.f9_1 = 3;
            continue $sm;
          case 3:
            this.g9_1 = 10;
            this.g9_1 = 9;
            this.bf7_1 = this.af7_1.m();
            this.f9_1 = 4;
            continue $sm;
          case 4:
            this.f9_1 = 5;
            suspendResult = this.bf7_1.d14(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 5:
            if (!suspendResult) {
              this.f9_1 = 7;
              continue $sm;
            }

            var e = this.bf7_1.o();
            this.f9_1 = 6;
            suspendResult = this.xf6_1.z15(e, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 6:
            this.f9_1 = 4;
            continue $sm;
          case 7:
            this.g9_1 = 11;
            this.f9_1 = 8;
            continue $sm;
          case 8:
            this.g9_1 = 11;
            cancelConsumed(this.af7_1, this.zf6_1);
            this.f9_1 = 13;
            continue $sm;
          case 9:
            this.g9_1 = 10;
            var tmp_1 = this.i9_1;
            if (tmp_1 instanceof Error) {
              var e_0 = this.i9_1;
              this.zf6_1 = e_0;
              throw e_0;
            } else {
              throw this.i9_1;
            }

          case 10:
            this.g9_1 = 11;
            var t = this.i9_1;
            cancelConsumed(this.af7_1, this.zf6_1);
            throw t;
          case 11:
            throw this.i9_1;
          case 12:
            this.g9_1 = 11;
            cancelConsumed(this.af7_1, this.zf6_1);
            if (false) {
              this.f9_1 = 1;
              continue $sm;
            }

            this.f9_1 = 13;
            continue $sm;
          case 13:
            return Unit_instance;
        }
      } catch ($p) {
        var e_1 = $p;
        if (this.g9_1 === 11) {
          throw e_1;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e_1;
        }
      }
     while (true);
  };
  protoOf(WsSessionScope$bind$slambda$slambda_1).f1h = function ($this$launch, completion) {
    var i = new WsSessionScope$bind$slambda$slambda_1(this.wf6_1, this.xf6_1, completion);
    i.yf6_1 = $this$launch;
    return i;
  };
  function WsSessionScope$bind$slambda$slambda_2(this$0, $outgoing, resultContinuation) {
    var i = new WsSessionScope$bind$slambda$slambda_1(this$0, $outgoing, resultContinuation);
    var l = function ($this$launch, $completion) {
      return i.e1h($this$launch, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function WsSessionScope$bind$slambda$slambda_3(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(WsSessionScope$bind$slambda$slambda_3).x9e = function ($completion) {
    var tmp = this.y9e($completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(WsSessionScope$bind$slambda$slambda_3).z9e = function ($completion) {
    return this.x9e($completion);
  };
  protoOf(WsSessionScope$bind$slambda$slambda_3).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        if (tmp === 0) {
          this.g9_1 = 1;
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(WsSessionScope$bind$slambda$slambda_3).y9e = function (completion) {
    return new WsSessionScope$bind$slambda$slambda_3(completion);
  };
  function WsSessionScope$bind$slambda$slambda_4(resultContinuation) {
    var i = new WsSessionScope$bind$slambda$slambda_3(resultContinuation);
    var l = function ($completion) {
      return i.x9e($completion);
    };
    l.$arity = 0;
    return l;
  }
  function WsSessionScope$bind$slambda$slambda_5(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(WsSessionScope$bind$slambda$slambda_5).x9e = function ($completion) {
    var tmp = this.y9e($completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(WsSessionScope$bind$slambda$slambda_5).z9e = function ($completion) {
    return this.x9e($completion);
  };
  protoOf(WsSessionScope$bind$slambda$slambda_5).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        if (tmp === 0) {
          this.g9_1 = 1;
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(WsSessionScope$bind$slambda$slambda_5).y9e = function (completion) {
    return new WsSessionScope$bind$slambda$slambda_5(completion);
  };
  function WsSessionScope$bind$slambda$slambda_6(resultContinuation) {
    var i = new WsSessionScope$bind$slambda$slambda_5(resultContinuation);
    var l = function ($completion) {
      return i.x9e($completion);
    };
    l.$arity = 0;
    return l;
  }
  function WsSessionScope$bind$slambda(this$0, $connectionJob, $bindingJob, $incoming, $outgoing, resultContinuation) {
    this.bf8_1 = this$0;
    this.cf8_1 = $connectionJob;
    this.df8_1 = $bindingJob;
    this.ef8_1 = $incoming;
    this.ff8_1 = $outgoing;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(WsSessionScope$bind$slambda).e1h = function ($this$withContext, $completion) {
    var tmp = this.f1h($this$withContext, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(WsSessionScope$bind$slambda).v9 = function (p1, $completion) {
    return this.e1h((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(WsSessionScope$bind$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            launch(this.gf8_1, VOID, VOID, WsSessionScope$bind$slambda$slambda_0(this.ef8_1, this.bf8_1, null));
            launch(this.gf8_1, VOID, VOID, WsSessionScope$bind$slambda$slambda_2(this.bf8_1, this.ff8_1, null));
            var $this$run = new SelectImplementation(this.l9());
            var tmp_0 = this.bf8_1.lf6_1.op();
            $this$run.g22(tmp_0, WsSessionScope$bind$slambda$slambda_4(null));
            var tmp_1 = this.cf8_1.op();
            $this$run.g22(tmp_1, WsSessionScope$bind$slambda$slambda_6(null));
            this.f9_1 = 1;
            suspendResult = $this$run.f22(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.bf8_1.mf6_1.i16();
            this.bf8_1.nf6_1.k16();
            this.df8_1.sp();
            return Unit_instance;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(WsSessionScope$bind$slambda).f1h = function ($this$withContext, completion) {
    var i = new WsSessionScope$bind$slambda(this.bf8_1, this.cf8_1, this.df8_1, this.ef8_1, this.ff8_1, completion);
    i.gf8_1 = $this$withContext;
    return i;
  };
  function WsSessionScope$bind$slambda_0(this$0, $connectionJob, $bindingJob, $incoming, $outgoing, resultContinuation) {
    var i = new WsSessionScope$bind$slambda(this$0, $connectionJob, $bindingJob, $incoming, $outgoing, resultContinuation);
    var l = function ($this$withContext, $completion) {
      return i.e1h($this$withContext, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function WsSessionScope(sessionJob, sessionIncoming, sessionOutgoing) {
    this.lf6_1 = sessionJob;
    this.mf6_1 = sessionIncoming;
    this.nf6_1 = sessionOutgoing;
  }
  protoOf(WsSessionScope).hf8 = function (incoming, outgoing, connectionJob, $completion) {
    // Inline function 'kotlin.js.getCoroutineContext' call
    var tmp$ret$0 = $completion.l9();
    var bindingJob = Job_0(get_job(tmp$ret$0));
    return withContext(bindingJob, WsSessionScope$bind$slambda_0(this, connectionJob, bindingJob, incoming, outgoing, null), $completion);
  };
  function WsSessionProvider(_this__u8e3s4, session) {
    _init_properties_WsSession_kt__dx1ve0();
    return produce_0(_this__u8e3s4, VOID, VOID, WsSessionProvider$slambda_0(session, null));
  }
  function WsSession_0(_this__u8e3s4, body) {
    _init_properties_WsSession_kt__dx1ve0();
    var sessionIncoming = Channel();
    var sessionOutgoing = Channel();
    var sessionJob = Job_0(get_job(_this__u8e3s4.ho()));
    launch(_this__u8e3s4, VOID, VOID, WsSession$slambda_0(body, sessionJob, sessionIncoming, sessionOutgoing, null));
    return new WsSession(sessionIncoming, sessionOutgoing);
  }
  function WsSessionProvider$slambda$lambda($session) {
    return function ($this$send) {
      return WsSession_0($this$send, $session);
    };
  }
  function WsSessionProvider$slambda$lambda_0($session) {
    return function ($this$send) {
      return WsSession_0($this$send, $session);
    };
  }
  function WsSessionProvider$slambda($session, resultContinuation) {
    this.qf8_1 = $session;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(WsSessionProvider$slambda).sf8 = function ($this$produce, $completion) {
    var tmp = this.tf8($this$produce, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(WsSessionProvider$slambda).v9 = function (p1, $completion) {
    return this.sf8((!(p1 == null) ? isInterface(p1, ProducerScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(WsSessionProvider$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 6;
            this.f9_1 = 1;
            var tmp_0 = this.rf8_1.d11();
            suspendResult = tmp_0.z15(WsSessionProvider$slambda$lambda(this.qf8_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.f9_1 = 2;
            continue $sm;
          case 2:
            if (!get_isActive_0(this.rf8_1.ho())) {
              this.f9_1 = 5;
              continue $sm;
            }

            this.f9_1 = 3;
            suspendResult = delay(get_WS_SESSION_RECONNECT_DURATION(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            this.f9_1 = 4;
            var tmp_1 = this.rf8_1.d11();
            suspendResult = tmp_1.z15(WsSessionProvider$slambda$lambda_0(this.qf8_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            this.f9_1 = 2;
            continue $sm;
          case 5:
            return Unit_instance;
          case 6:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 6) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(WsSessionProvider$slambda).tf8 = function ($this$produce, completion) {
    var i = new WsSessionProvider$slambda(this.qf8_1, completion);
    i.rf8_1 = $this$produce;
    return i;
  };
  function WsSessionProvider$slambda_0($session, resultContinuation) {
    var i = new WsSessionProvider$slambda($session, resultContinuation);
    var l = function ($this$produce, $completion) {
      return i.sf8($this$produce, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function WsSession$slambda($body, $sessionJob, $sessionIncoming, $sessionOutgoing, resultContinuation) {
    this.cf9_1 = $body;
    this.df9_1 = $sessionJob;
    this.ef9_1 = $sessionIncoming;
    this.ff9_1 = $sessionOutgoing;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(WsSession$slambda).e1h = function ($this$launch, $completion) {
    var tmp = this.f1h($this$launch, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(WsSession$slambda).v9 = function (p1, $completion) {
    return this.e1h((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(WsSession$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.cf9_1(new WsSessionScope(this.df9_1, this.ef9_1, this.ff9_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(WsSession$slambda).f1h = function ($this$launch, completion) {
    var i = new WsSession$slambda(this.cf9_1, this.df9_1, this.ef9_1, this.ff9_1, completion);
    i.gf9_1 = $this$launch;
    return i;
  };
  function WsSession$slambda_0($body, $sessionJob, $sessionIncoming, $sessionOutgoing, resultContinuation) {
    var i = new WsSession$slambda($body, $sessionJob, $sessionIncoming, $sessionOutgoing, resultContinuation);
    var l = function ($this$launch, $completion) {
      return i.e1h($this$launch, $completion);
    };
    l.$arity = 1;
    return l;
  }
  var properties_initialized_WsSession_kt_f6mf4a;
  function _init_properties_WsSession_kt__dx1ve0() {
    if (!properties_initialized_WsSession_kt_f6mf4a) {
      properties_initialized_WsSession_kt_f6mf4a = true;
      // Inline function 'kotlin.time.Companion.seconds' call
      Companion_getInstance_16();
      WS_SESSION_RECONNECT_DURATION = toDuration_0(30, DurationUnit_SECONDS_getInstance());
    }
  }
  function NodeErrorInfo$Companion$$childSerializers$_anonymous__yuiely() {
    return new ArrayListSerializer($serializer_getInstance_16());
  }
  function Companion_284() {
    Companion_instance_284 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.hf9_1 = [lazy_0(tmp_0, NodeErrorInfo$Companion$$childSerializers$_anonymous__yuiely)];
  }
  var Companion_instance_284;
  function Companion_getInstance_284() {
    if (Companion_instance_284 == null)
      new Companion_284();
    return Companion_instance_284;
  }
  function $serializer_16() {
    $serializer_instance_14 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('jetbrains.ocelot.langDef.check.remote.NodeErrorInfo', this, 1);
    tmp0_serialDesc.q5j('nodeErrors', true);
    this.if9_1 = tmp0_serialDesc;
  }
  protoOf($serializer_16).jf9 = function (encoder, value) {
    var tmp0_desc = this.if9_1;
    var tmp1_output = encoder.g5c(tmp0_desc);
    var tmp2_cached = Companion_getInstance_284().hf9_1;
    if (tmp1_output.b5e(tmp0_desc, 0) ? true : !equals(value.kf9_1, emptyList())) {
      tmp1_output.w5d(tmp0_desc, 0, tmp2_cached[0].a1(), value.kf9_1);
    }
    tmp1_output.h5c(tmp0_desc);
  };
  protoOf($serializer_16).i59 = function (encoder, value) {
    return this.jf9(encoder, value instanceof NodeErrorInfo ? value : THROW_CCE());
  };
  protoOf($serializer_16).j59 = function (decoder) {
    var tmp0_desc = this.if9_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.g5c(tmp0_desc);
    var tmp6_cached = Companion_getInstance_284().hf9_1;
    if (tmp5_input.v5c()) {
      tmp4_local0 = tmp5_input.s5c(tmp0_desc, 0, tmp6_cached[0].a1(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.w5c(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.s5c(tmp0_desc, 0, tmp6_cached[0].a1(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.h5c(tmp0_desc);
    return NodeErrorInfo_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_16).v58 = function () {
    return this.if9_1;
  };
  protoOf($serializer_16).f5k = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_284().hf9_1[0].a1()];
  };
  var $serializer_instance_14;
  function $serializer_getInstance_14() {
    if ($serializer_instance_14 == null)
      new $serializer_16();
    return $serializer_instance_14;
  }
  function NodeErrorInfo_init_$Init$(seen0, nodeErrors, serializationConstructorMarker, $this) {
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_14().if9_1);
    }
    if (0 === (seen0 & 1))
      $this.kf9_1 = emptyList();
    else
      $this.kf9_1 = nodeErrors;
    return $this;
  }
  function NodeErrorInfo_init_$Create$(seen0, nodeErrors, serializationConstructorMarker) {
    return NodeErrorInfo_init_$Init$(seen0, nodeErrors, serializationConstructorMarker, objectCreate(protoOf(NodeErrorInfo)));
  }
  function NodeErrorInfo(nodeErrors) {
    Companion_getInstance_284();
    nodeErrors = nodeErrors === VOID ? emptyList() : nodeErrors;
    this.kf9_1 = nodeErrors;
  }
  protoOf(NodeErrorInfo).toString = function () {
    return 'NodeErrorInfo(nodeErrors=' + toString_1(this.kf9_1) + ')';
  };
  protoOf(NodeErrorInfo).hashCode = function () {
    return hashCode(this.kf9_1);
  };
  protoOf(NodeErrorInfo).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof NodeErrorInfo))
      return false;
    if (!equals(this.kf9_1, other.kf9_1))
      return false;
    return true;
  };
  function SerializedError$Companion$$childSerializers$_anonymous__abg77e() {
    return new EnumSerializer('jetbrains.ocelot.langDef.check.api.ErrorKind', values_4());
  }
  function SerializedError$Companion$$childSerializers$_anonymous__abg77e_0() {
    return new ArrayListSerializer(NodePointerSerializer_getInstance());
  }
  function Companion_285() {
    Companion_instance_285 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_1 = lazy_0(tmp_0, SerializedError$Companion$$childSerializers$_anonymous__abg77e);
    var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.lf9_1 = [null, tmp_1, lazy_0(tmp_2, SerializedError$Companion$$childSerializers$_anonymous__abg77e_0)];
  }
  var Companion_instance_285;
  function Companion_getInstance_285() {
    if (Companion_instance_285 == null)
      new Companion_285();
    return Companion_instance_285;
  }
  function $serializer_17() {
    $serializer_instance_15 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('jetbrains.ocelot.langDef.check.remote.SerializedError', this, 3);
    tmp0_serialDesc.q5j('message', false);
    tmp0_serialDesc.q5j('kind', false);
    tmp0_serialDesc.q5j('nodePointers', false);
    this.mf9_1 = tmp0_serialDesc;
  }
  protoOf($serializer_17).nf9 = function (encoder, value) {
    var tmp0_desc = this.mf9_1;
    var tmp1_output = encoder.g5c(tmp0_desc);
    var tmp2_cached = Companion_getInstance_285().lf9_1;
    tmp1_output.u5d(tmp0_desc, 0, value.of9_1);
    tmp1_output.w5d(tmp0_desc, 1, tmp2_cached[1].a1(), value.pf9_1);
    tmp1_output.w5d(tmp0_desc, 2, tmp2_cached[2].a1(), value.qf9_1);
    tmp1_output.h5c(tmp0_desc);
  };
  protoOf($serializer_17).i59 = function (encoder, value) {
    return this.nf9(encoder, value instanceof SerializedError ? value : THROW_CCE());
  };
  protoOf($serializer_17).j59 = function (decoder) {
    var tmp0_desc = this.mf9_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.g5c(tmp0_desc);
    var tmp8_cached = Companion_getInstance_285().lf9_1;
    if (tmp7_input.v5c()) {
      tmp4_local0 = tmp7_input.q5c(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.s5c(tmp0_desc, 1, tmp8_cached[1].a1(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.s5c(tmp0_desc, 2, tmp8_cached[2].a1(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.w5c(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.q5c(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.s5c(tmp0_desc, 1, tmp8_cached[1].a1(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.s5c(tmp0_desc, 2, tmp8_cached[2].a1(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.h5c(tmp0_desc);
    return SerializedError_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_17).v58 = function () {
    return this.mf9_1;
  };
  protoOf($serializer_17).f5k = function () {
    var tmp0_cached = Companion_getInstance_285().lf9_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), tmp0_cached[1].a1(), tmp0_cached[2].a1()];
  };
  var $serializer_instance_15;
  function $serializer_getInstance_15() {
    if ($serializer_instance_15 == null)
      new $serializer_17();
    return $serializer_instance_15;
  }
  function SerializedError_init_$Init$(seen0, message, kind, nodePointers, serializationConstructorMarker, $this) {
    if (!(7 === (7 & seen0))) {
      throwMissingFieldException(seen0, 7, $serializer_getInstance_15().mf9_1);
    }
    $this.of9_1 = message;
    $this.pf9_1 = kind;
    $this.qf9_1 = nodePointers;
    return $this;
  }
  function SerializedError_init_$Create$(seen0, message, kind, nodePointers, serializationConstructorMarker) {
    return SerializedError_init_$Init$(seen0, message, kind, nodePointers, serializationConstructorMarker, objectCreate(protoOf(SerializedError)));
  }
  function SerializedError() {
  }
  protoOf(SerializedError).toString = function () {
    return 'SerializedError(message=' + this.of9_1 + ', kind=' + this.pf9_1.toString() + ', nodePointers=' + toString_1(this.qf9_1) + ')';
  };
  protoOf(SerializedError).hashCode = function () {
    var result = getStringHashCode(this.of9_1);
    result = imul(result, 31) + this.pf9_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.qf9_1) | 0;
    return result;
  };
  protoOf(SerializedError).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SerializedError))
      return false;
    if (!(this.of9_1 === other.of9_1))
      return false;
    if (!this.pf9_1.equals(other.pf9_1))
      return false;
    if (!equals(this.qf9_1, other.qf9_1))
      return false;
    return true;
  };
  function deserialize_0(_this__u8e3s4, nodePointerSupport) {
    return new deserialize$1(_this__u8e3s4, nodePointerSupport);
  }
  function deserialize$1($this_deserialize, $nodePointerSupport) {
    this.rf9_1 = $this_deserialize.of9_1;
    this.sf9_1 = $this_deserialize.pf9_1;
    var tmp = this;
    // Inline function 'kotlin.collections.mapNotNull' call
    var tmp0 = $this_deserialize.qf9_1;
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var destination = ArrayList_init_$Create$();
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = tmp0.m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      var tmp0_safe_receiver = execute_0($nodePointerSupport.i6g(element));
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        destination.j(tmp0_safe_receiver);
      }
    }
    tmp.tf9_1 = destination;
  }
  protoOf(deserialize$1).e = function () {
    return this.rf9_1;
  };
  protoOf(deserialize$1).f3o = function () {
    return this.tf9_1;
  };
  function SerializedNodeErrors$Companion$$childSerializers$_anonymous__qrnnuh() {
    return new ArrayListSerializer($serializer_getInstance_15());
  }
  function Companion_286() {
    Companion_instance_286 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.uf9_1 = [null, lazy_0(tmp_0, SerializedNodeErrors$Companion$$childSerializers$_anonymous__qrnnuh)];
  }
  var Companion_instance_286;
  function Companion_getInstance_286() {
    if (Companion_instance_286 == null)
      new Companion_286();
    return Companion_instance_286;
  }
  function $serializer_18() {
    $serializer_instance_16 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('jetbrains.ocelot.langDef.check.remote.SerializedNodeErrors', this, 2);
    tmp0_serialDesc.q5j('checkedNode', false);
    tmp0_serialDesc.q5j('errors', false);
    this.vf9_1 = tmp0_serialDesc;
  }
  protoOf($serializer_18).wf9 = function (encoder, value) {
    var tmp0_desc = this.vf9_1;
    var tmp1_output = encoder.g5c(tmp0_desc);
    var tmp2_cached = Companion_getInstance_286().uf9_1;
    tmp1_output.w5d(tmp0_desc, 0, NodePointerSerializer_getInstance(), value.xf9_1);
    tmp1_output.w5d(tmp0_desc, 1, tmp2_cached[1].a1(), value.yf9_1);
    tmp1_output.h5c(tmp0_desc);
  };
  protoOf($serializer_18).i59 = function (encoder, value) {
    return this.wf9(encoder, value instanceof SerializedNodeErrors ? value : THROW_CCE());
  };
  protoOf($serializer_18).j59 = function (decoder) {
    var tmp0_desc = this.vf9_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.g5c(tmp0_desc);
    var tmp7_cached = Companion_getInstance_286().uf9_1;
    if (tmp6_input.v5c()) {
      tmp4_local0 = tmp6_input.s5c(tmp0_desc, 0, NodePointerSerializer_getInstance(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.s5c(tmp0_desc, 1, tmp7_cached[1].a1(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.w5c(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.s5c(tmp0_desc, 0, NodePointerSerializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.s5c(tmp0_desc, 1, tmp7_cached[1].a1(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.h5c(tmp0_desc);
    return SerializedNodeErrors_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_18).v58 = function () {
    return this.vf9_1;
  };
  protoOf($serializer_18).f5k = function () {
    var tmp0_cached = Companion_getInstance_286().uf9_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [NodePointerSerializer_getInstance(), tmp0_cached[1].a1()];
  };
  var $serializer_instance_16;
  function $serializer_getInstance_16() {
    if ($serializer_instance_16 == null)
      new $serializer_18();
    return $serializer_instance_16;
  }
  function SerializedNodeErrors_init_$Init$(seen0, checkedNode, errors, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_16().vf9_1);
    }
    $this.xf9_1 = checkedNode;
    $this.yf9_1 = errors;
    return $this;
  }
  function SerializedNodeErrors_init_$Create$(seen0, checkedNode, errors, serializationConstructorMarker) {
    return SerializedNodeErrors_init_$Init$(seen0, checkedNode, errors, serializationConstructorMarker, objectCreate(protoOf(SerializedNodeErrors)));
  }
  function SerializedNodeErrors() {
  }
  protoOf(SerializedNodeErrors).toString = function () {
    return 'SerializedNodeErrors(checkedNode=' + this.xf9_1.toString() + ', errors=' + toString_1(this.yf9_1) + ')';
  };
  protoOf(SerializedNodeErrors).hashCode = function () {
    var result = this.xf9_1.hashCode();
    result = imul(result, 31) + hashCode(this.yf9_1) | 0;
    return result;
  };
  protoOf(SerializedNodeErrors).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SerializedNodeErrors))
      return false;
    if (!this.xf9_1.equals(other.xf9_1))
      return false;
    if (!equals(this.yf9_1, other.yf9_1))
      return false;
    return true;
  };
  function Companion_287() {
  }
  var Companion_instance_287;
  function Companion_getInstance_287() {
    return Companion_instance_287;
  }
  function $serializer_19() {
    $serializer_instance_17 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('jetbrains.ocelot.langDef.check.remote.live.NodeErrorInfoMessage.StateReceived', this, 1);
    tmp0_serialDesc.q5j('info', false);
    this.zf9_1 = tmp0_serialDesc;
  }
  protoOf($serializer_19).afa = function (encoder, value) {
    var tmp0_desc = this.zf9_1;
    var tmp1_output = encoder.g5c(tmp0_desc);
    tmp1_output.w5d(tmp0_desc, 0, $serializer_getInstance_14(), value.bfa_1);
    tmp1_output.h5c(tmp0_desc);
  };
  protoOf($serializer_19).i59 = function (encoder, value) {
    return this.afa(encoder, value instanceof StateReceived ? value : THROW_CCE());
  };
  protoOf($serializer_19).j59 = function (decoder) {
    var tmp0_desc = this.zf9_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.g5c(tmp0_desc);
    if (tmp5_input.v5c()) {
      tmp4_local0 = tmp5_input.s5c(tmp0_desc, 0, $serializer_getInstance_14(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.w5c(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.s5c(tmp0_desc, 0, $serializer_getInstance_14(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.h5c(tmp0_desc);
    return StateReceived_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_19).v58 = function () {
    return this.zf9_1;
  };
  protoOf($serializer_19).f5k = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_14()];
  };
  var $serializer_instance_17;
  function $serializer_getInstance_17() {
    if ($serializer_instance_17 == null)
      new $serializer_19();
    return $serializer_instance_17;
  }
  function StateReceived_init_$Init$(seen0, info, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_17().zf9_1);
    }
    NodeErrorInfoMessage_init_$Init$(seen0, serializationConstructorMarker, $this);
    $this.bfa_1 = info;
    return $this;
  }
  function StateReceived_init_$Create$(seen0, info, serializationConstructorMarker) {
    return StateReceived_init_$Init$(seen0, info, serializationConstructorMarker, objectCreate(protoOf(StateReceived)));
  }
  function Companion_288() {
  }
  var Companion_instance_288;
  function Companion_getInstance_288() {
    return Companion_instance_288;
  }
  function $serializer_20() {
    $serializer_instance_18 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('jetbrains.ocelot.langDef.check.remote.live.NodeErrorInfoMessage.UpdateReceived', this, 1);
    tmp0_serialDesc.q5j('update', false);
    this.cfa_1 = tmp0_serialDesc;
  }
  protoOf($serializer_20).dfa = function (encoder, value) {
    var tmp0_desc = this.cfa_1;
    var tmp1_output = encoder.g5c(tmp0_desc);
    tmp1_output.w5d(tmp0_desc, 0, $serializer_getInstance_19(), value.efa_1);
    tmp1_output.h5c(tmp0_desc);
  };
  protoOf($serializer_20).i59 = function (encoder, value) {
    return this.dfa(encoder, value instanceof UpdateReceived ? value : THROW_CCE());
  };
  protoOf($serializer_20).j59 = function (decoder) {
    var tmp0_desc = this.cfa_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.g5c(tmp0_desc);
    if (tmp5_input.v5c()) {
      tmp4_local0 = tmp5_input.s5c(tmp0_desc, 0, $serializer_getInstance_19(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.w5c(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.s5c(tmp0_desc, 0, $serializer_getInstance_19(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.h5c(tmp0_desc);
    return UpdateReceived_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_20).v58 = function () {
    return this.cfa_1;
  };
  protoOf($serializer_20).f5k = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_19()];
  };
  var $serializer_instance_18;
  function $serializer_getInstance_18() {
    if ($serializer_instance_18 == null)
      new $serializer_20();
    return $serializer_instance_18;
  }
  function UpdateReceived_init_$Init$(seen0, update, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_18().cfa_1);
    }
    NodeErrorInfoMessage_init_$Init$(seen0, serializationConstructorMarker, $this);
    $this.efa_1 = update;
    return $this;
  }
  function UpdateReceived_init_$Create$(seen0, update, serializationConstructorMarker) {
    return UpdateReceived_init_$Init$(seen0, update, serializationConstructorMarker, objectCreate(protoOf(UpdateReceived)));
  }
  function _get_$cachedSerializer__te6jhj_4($this) {
    return $this.ffa_1.a1();
  }
  function NodeErrorInfoMessage$Companion$_anonymous__hwe998() {
    var tmp = getKClass(NodeErrorInfoMessage);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = [getKClass(StateReceived), getKClass(UpdateReceived)];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_1 = [$serializer_getInstance_17(), $serializer_getInstance_18()];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$8 = [];
    return SealedClassSerializer_init_$Create$('jetbrains.ocelot.langDef.check.remote.live.NodeErrorInfoMessage', tmp, tmp_0, tmp_1, tmp$ret$8);
  }
  function StateReceived(info) {
    NodeErrorInfoMessage.call(this);
    this.bfa_1 = info;
  }
  protoOf(StateReceived).toString = function () {
    return 'StateReceived(info=' + this.bfa_1.toString() + ')';
  };
  protoOf(StateReceived).hashCode = function () {
    return this.bfa_1.hashCode();
  };
  protoOf(StateReceived).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof StateReceived))
      return false;
    if (!this.bfa_1.equals(other.bfa_1))
      return false;
    return true;
  };
  function UpdateReceived(update) {
    NodeErrorInfoMessage.call(this);
    this.efa_1 = update;
  }
  protoOf(UpdateReceived).toString = function () {
    return 'UpdateReceived(update=' + this.efa_1.toString() + ')';
  };
  protoOf(UpdateReceived).hashCode = function () {
    return this.efa_1.hashCode();
  };
  protoOf(UpdateReceived).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof UpdateReceived))
      return false;
    if (!this.efa_1.equals(other.efa_1))
      return false;
    return true;
  };
  function Companion_289() {
    Companion_instance_289 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.ffa_1 = lazy_0(tmp_0, NodeErrorInfoMessage$Companion$_anonymous__hwe998);
  }
  protoOf(Companion_289).i63 = function () {
    return _get_$cachedSerializer__te6jhj_4(this);
  };
  protoOf(Companion_289).q5k = function (typeParamsSerializers) {
    return this.i63();
  };
  var Companion_instance_289;
  function Companion_getInstance_289() {
    if (Companion_instance_289 == null)
      new Companion_289();
    return Companion_instance_289;
  }
  function NodeErrorInfoMessage_init_$Init$(seen0, serializationConstructorMarker, $this) {
    return $this;
  }
  function NodeErrorInfoMessage() {
    Companion_getInstance_289();
  }
  function NodeErrorInfoUpdate$Companion$$childSerializers$_anonymous__qkb1ir() {
    return new ArrayListSerializer($serializer_getInstance_16());
  }
  function NodeErrorInfoUpdate$Companion$$childSerializers$_anonymous__qkb1ir_0() {
    return new ArrayListSerializer(NodePointerSerializer_getInstance());
  }
  function Companion_290() {
    Companion_instance_290 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_1 = lazy_0(tmp_0, NodeErrorInfoUpdate$Companion$$childSerializers$_anonymous__qkb1ir);
    var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.gfa_1 = [tmp_1, lazy_0(tmp_2, NodeErrorInfoUpdate$Companion$$childSerializers$_anonymous__qkb1ir_0)];
    this.hfa_1 = new NodeErrorInfoUpdate();
  }
  var Companion_instance_290;
  function Companion_getInstance_290() {
    if (Companion_instance_290 == null)
      new Companion_290();
    return Companion_instance_290;
  }
  function $serializer_21() {
    $serializer_instance_19 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('jetbrains.ocelot.langDef.check.remote.live.NodeErrorInfoUpdate', this, 2);
    tmp0_serialDesc.q5j('updatedNodeErrors', true);
    tmp0_serialDesc.q5j('droppedNodeErrors', true);
    this.ifa_1 = tmp0_serialDesc;
  }
  protoOf($serializer_21).jfa = function (encoder, value) {
    var tmp0_desc = this.ifa_1;
    var tmp1_output = encoder.g5c(tmp0_desc);
    var tmp2_cached = Companion_getInstance_290().gfa_1;
    if (tmp1_output.b5e(tmp0_desc, 0) ? true : !equals(value.kfa_1, emptyList())) {
      tmp1_output.w5d(tmp0_desc, 0, tmp2_cached[0].a1(), value.kfa_1);
    }
    if (tmp1_output.b5e(tmp0_desc, 1) ? true : !equals(value.lfa_1, emptyList())) {
      tmp1_output.w5d(tmp0_desc, 1, tmp2_cached[1].a1(), value.lfa_1);
    }
    tmp1_output.h5c(tmp0_desc);
  };
  protoOf($serializer_21).i59 = function (encoder, value) {
    return this.jfa(encoder, value instanceof NodeErrorInfoUpdate ? value : THROW_CCE());
  };
  protoOf($serializer_21).j59 = function (decoder) {
    var tmp0_desc = this.ifa_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.g5c(tmp0_desc);
    var tmp7_cached = Companion_getInstance_290().gfa_1;
    if (tmp6_input.v5c()) {
      tmp4_local0 = tmp6_input.s5c(tmp0_desc, 0, tmp7_cached[0].a1(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.s5c(tmp0_desc, 1, tmp7_cached[1].a1(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.w5c(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.s5c(tmp0_desc, 0, tmp7_cached[0].a1(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.s5c(tmp0_desc, 1, tmp7_cached[1].a1(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.h5c(tmp0_desc);
    return NodeErrorInfoUpdate_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_21).v58 = function () {
    return this.ifa_1;
  };
  protoOf($serializer_21).f5k = function () {
    var tmp0_cached = Companion_getInstance_290().gfa_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0].a1(), tmp0_cached[1].a1()];
  };
  var $serializer_instance_19;
  function $serializer_getInstance_19() {
    if ($serializer_instance_19 == null)
      new $serializer_21();
    return $serializer_instance_19;
  }
  function NodeErrorInfoUpdate_init_$Init$(seen0, updatedNodeErrors, droppedNodeErrors, serializationConstructorMarker, $this) {
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_19().ifa_1);
    }
    if (0 === (seen0 & 1))
      $this.kfa_1 = emptyList();
    else
      $this.kfa_1 = updatedNodeErrors;
    if (0 === (seen0 & 2))
      $this.lfa_1 = emptyList();
    else
      $this.lfa_1 = droppedNodeErrors;
    return $this;
  }
  function NodeErrorInfoUpdate_init_$Create$(seen0, updatedNodeErrors, droppedNodeErrors, serializationConstructorMarker) {
    return NodeErrorInfoUpdate_init_$Init$(seen0, updatedNodeErrors, droppedNodeErrors, serializationConstructorMarker, objectCreate(protoOf(NodeErrorInfoUpdate)));
  }
  function NodeErrorInfoUpdate(updatedNodeErrors, droppedNodeErrors) {
    Companion_getInstance_290();
    updatedNodeErrors = updatedNodeErrors === VOID ? emptyList() : updatedNodeErrors;
    droppedNodeErrors = droppedNodeErrors === VOID ? emptyList() : droppedNodeErrors;
    this.kfa_1 = updatedNodeErrors;
    this.lfa_1 = droppedNodeErrors;
  }
  protoOf(NodeErrorInfoUpdate).toString = function () {
    return 'NodeErrorInfoUpdate(updatedNodeErrors=' + toString_1(this.kfa_1) + ', droppedNodeErrors=' + toString_1(this.lfa_1) + ')';
  };
  protoOf(NodeErrorInfoUpdate).hashCode = function () {
    var result = hashCode(this.kfa_1);
    result = imul(result, 31) + hashCode(this.lfa_1) | 0;
    return result;
  };
  protoOf(NodeErrorInfoUpdate).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof NodeErrorInfoUpdate))
      return false;
    if (!equals(this.kfa_1, other.kfa_1))
      return false;
    if (!equals(this.lfa_1, other.lfa_1))
      return false;
    return true;
  };
  function NodeErrorProvider(errors) {
    this.mfa_1 = errors;
  }
  protoOf(NodeErrorProvider).toString = function () {
    return 'NodeErrorProvider(errors=' + toString_1(this.mfa_1) + ')';
  };
  protoOf(NodeErrorProvider).hashCode = function () {
    return hashCode(this.mfa_1);
  };
  protoOf(NodeErrorProvider).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof NodeErrorProvider))
      return false;
    if (!equals(this.mfa_1, other.mfa_1))
      return false;
    return true;
  };
  function NodeResolveInfo$Companion$$childSerializers$_anonymous__jl0ope() {
    return new ArrayListSerializer($serializer_getInstance());
  }
  function NodeResolveInfo$Companion$$childSerializers$_anonymous__jl0ope_0() {
    return new ArrayListSerializer($serializer_getInstance_21());
  }
  function Companion_291() {
    Companion_instance_291 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_1 = lazy_0(tmp_0, NodeResolveInfo$Companion$$childSerializers$_anonymous__jl0ope);
    var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.nfa_1 = [tmp_1, lazy_0(tmp_2, NodeResolveInfo$Companion$$childSerializers$_anonymous__jl0ope_0)];
  }
  var Companion_instance_291;
  function Companion_getInstance_291() {
    if (Companion_instance_291 == null)
      new Companion_291();
    return Companion_instance_291;
  }
  function $serializer_22() {
    $serializer_instance_20 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('jetbrains.ocelot.langDef.references.remote.NodeResolveInfo', this, 2);
    tmp0_serialDesc.q5j('targets', true);
    tmp0_serialDesc.q5j('references', true);
    this.ofa_1 = tmp0_serialDesc;
  }
  protoOf($serializer_22).pfa = function (encoder, value) {
    var tmp0_desc = this.ofa_1;
    var tmp1_output = encoder.g5c(tmp0_desc);
    var tmp2_cached = Companion_getInstance_291().nfa_1;
    if (tmp1_output.b5e(tmp0_desc, 0) ? true : !equals(value.qfa_1, emptyList())) {
      tmp1_output.w5d(tmp0_desc, 0, tmp2_cached[0].a1(), value.qfa_1);
    }
    if (tmp1_output.b5e(tmp0_desc, 1) ? true : !equals(value.rfa_1, emptyList())) {
      tmp1_output.w5d(tmp0_desc, 1, tmp2_cached[1].a1(), value.rfa_1);
    }
    tmp1_output.h5c(tmp0_desc);
  };
  protoOf($serializer_22).i59 = function (encoder, value) {
    return this.pfa(encoder, value instanceof NodeResolveInfo ? value : THROW_CCE());
  };
  protoOf($serializer_22).j59 = function (decoder) {
    var tmp0_desc = this.ofa_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.g5c(tmp0_desc);
    var tmp7_cached = Companion_getInstance_291().nfa_1;
    if (tmp6_input.v5c()) {
      tmp4_local0 = tmp6_input.s5c(tmp0_desc, 0, tmp7_cached[0].a1(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.s5c(tmp0_desc, 1, tmp7_cached[1].a1(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.w5c(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.s5c(tmp0_desc, 0, tmp7_cached[0].a1(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.s5c(tmp0_desc, 1, tmp7_cached[1].a1(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.h5c(tmp0_desc);
    return NodeResolveInfo_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_22).v58 = function () {
    return this.ofa_1;
  };
  protoOf($serializer_22).f5k = function () {
    var tmp0_cached = Companion_getInstance_291().nfa_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0].a1(), tmp0_cached[1].a1()];
  };
  var $serializer_instance_20;
  function $serializer_getInstance_20() {
    if ($serializer_instance_20 == null)
      new $serializer_22();
    return $serializer_instance_20;
  }
  function NodeResolveInfo_init_$Init$(seen0, targets, references, serializationConstructorMarker, $this) {
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_20().ofa_1);
    }
    if (0 === (seen0 & 1))
      $this.qfa_1 = emptyList();
    else
      $this.qfa_1 = targets;
    if (0 === (seen0 & 2))
      $this.rfa_1 = emptyList();
    else
      $this.rfa_1 = references;
    return $this;
  }
  function NodeResolveInfo_init_$Create$(seen0, targets, references, serializationConstructorMarker) {
    return NodeResolveInfo_init_$Init$(seen0, targets, references, serializationConstructorMarker, objectCreate(protoOf(NodeResolveInfo)));
  }
  function NodeResolveInfo(targets, references) {
    Companion_getInstance_291();
    targets = targets === VOID ? emptyList() : targets;
    references = references === VOID ? emptyList() : references;
    this.qfa_1 = targets;
    this.rfa_1 = references;
  }
  protoOf(NodeResolveInfo).toString = function () {
    return 'NodeResolveInfo(targets=' + toString_1(this.qfa_1) + ', references=' + toString_1(this.rfa_1) + ')';
  };
  protoOf(NodeResolveInfo).hashCode = function () {
    var result = hashCode(this.qfa_1);
    result = imul(result, 31) + hashCode(this.rfa_1) | 0;
    return result;
  };
  protoOf(NodeResolveInfo).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof NodeResolveInfo))
      return false;
    if (!equals(this.qfa_1, other.qfa_1))
      return false;
    if (!equals(this.rfa_1, other.rfa_1))
      return false;
    return true;
  };
  function $serializer_23() {
    $serializer_instance_21 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('jetbrains.ocelot.langDef.references.remote.SerializedReference', this, 2);
    tmp0_serialDesc.q5j('location', false);
    tmp0_serialDesc.q5j('value', false);
    this.sfa_1 = tmp0_serialDesc;
  }
  protoOf($serializer_23).tfa = function (encoder, value) {
    var tmp0_desc = this.sfa_1;
    var tmp1_output = encoder.g5c(tmp0_desc);
    tmp1_output.w5d(tmp0_desc, 0, $serializer_getInstance_22(), value.ufa_1);
    tmp1_output.w5d(tmp0_desc, 1, $serializer_getInstance_23(), value.vfa_1);
    tmp1_output.h5c(tmp0_desc);
  };
  protoOf($serializer_23).i59 = function (encoder, value) {
    return this.tfa(encoder, value instanceof SerializedReference ? value : THROW_CCE());
  };
  protoOf($serializer_23).j59 = function (decoder) {
    var tmp0_desc = this.sfa_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.g5c(tmp0_desc);
    if (tmp6_input.v5c()) {
      tmp4_local0 = tmp6_input.s5c(tmp0_desc, 0, $serializer_getInstance_22(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.s5c(tmp0_desc, 1, $serializer_getInstance_23(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.w5c(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.s5c(tmp0_desc, 0, $serializer_getInstance_22(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.s5c(tmp0_desc, 1, $serializer_getInstance_23(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.h5c(tmp0_desc);
    return SerializedReference_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_23).v58 = function () {
    return this.sfa_1;
  };
  protoOf($serializer_23).f5k = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_22(), $serializer_getInstance_23()];
  };
  var $serializer_instance_21;
  function $serializer_getInstance_21() {
    if ($serializer_instance_21 == null)
      new $serializer_23();
    return $serializer_instance_21;
  }
  function SerializedReference_init_$Init$(seen0, location, value, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_21().sfa_1);
    }
    $this.ufa_1 = location;
    $this.vfa_1 = value;
    return $this;
  }
  function SerializedReference_init_$Create$(seen0, location, value, serializationConstructorMarker) {
    return SerializedReference_init_$Init$(seen0, location, value, serializationConstructorMarker, objectCreate(protoOf(SerializedReference)));
  }
  function SerializedReference() {
  }
  protoOf(SerializedReference).toString = function () {
    return 'SerializedReference(location=' + this.ufa_1.toString() + ', value=' + this.vfa_1.toString() + ')';
  };
  protoOf(SerializedReference).hashCode = function () {
    var result = this.ufa_1.hashCode();
    result = imul(result, 31) + this.vfa_1.hashCode() | 0;
    return result;
  };
  protoOf(SerializedReference).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SerializedReference))
      return false;
    if (!this.ufa_1.equals(other.ufa_1))
      return false;
    if (!this.vfa_1.equals(other.vfa_1))
      return false;
    return true;
  };
  function Companion_292() {
  }
  var Companion_instance_292;
  function Companion_getInstance_292() {
    return Companion_instance_292;
  }
  function $serializer_24() {
    $serializer_instance_22 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('jetbrains.ocelot.langDef.references.remote.SerializedReferenceLocation', this, 2);
    tmp0_serialDesc.q5j('source', false);
    tmp0_serialDesc.q5j('tag', false);
    this.wfa_1 = tmp0_serialDesc;
  }
  protoOf($serializer_24).xfa = function (encoder, value) {
    var tmp0_desc = this.wfa_1;
    var tmp1_output = encoder.g5c(tmp0_desc);
    tmp1_output.w5d(tmp0_desc, 0, NodePointerSerializer_getInstance(), value.yfa_1);
    tmp1_output.u5d(tmp0_desc, 1, value.zfa_1);
    tmp1_output.h5c(tmp0_desc);
  };
  protoOf($serializer_24).i59 = function (encoder, value) {
    return this.xfa(encoder, value instanceof SerializedReferenceLocation ? value : THROW_CCE());
  };
  protoOf($serializer_24).j59 = function (decoder) {
    var tmp0_desc = this.wfa_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.g5c(tmp0_desc);
    if (tmp6_input.v5c()) {
      tmp4_local0 = tmp6_input.s5c(tmp0_desc, 0, NodePointerSerializer_getInstance(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.q5c(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.w5c(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.s5c(tmp0_desc, 0, NodePointerSerializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.q5c(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.h5c(tmp0_desc);
    return SerializedReferenceLocation_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_24).v58 = function () {
    return this.wfa_1;
  };
  protoOf($serializer_24).f5k = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [NodePointerSerializer_getInstance(), StringSerializer_getInstance()];
  };
  var $serializer_instance_22;
  function $serializer_getInstance_22() {
    if ($serializer_instance_22 == null)
      new $serializer_24();
    return $serializer_instance_22;
  }
  function SerializedReferenceLocation_init_$Init$(seen0, source, tag, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_22().wfa_1);
    }
    $this.yfa_1 = source;
    $this.zfa_1 = tag;
    return $this;
  }
  function SerializedReferenceLocation_init_$Create$(seen0, source, tag, serializationConstructorMarker) {
    return SerializedReferenceLocation_init_$Init$(seen0, source, tag, serializationConstructorMarker, objectCreate(protoOf(SerializedReferenceLocation)));
  }
  function SerializedReferenceLocation(source, tag) {
    this.yfa_1 = source;
    this.zfa_1 = tag;
  }
  protoOf(SerializedReferenceLocation).toString = function () {
    return 'SerializedReferenceLocation(source=' + this.yfa_1.toString() + ', tag=' + this.zfa_1 + ')';
  };
  protoOf(SerializedReferenceLocation).hashCode = function () {
    var result = this.yfa_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.zfa_1) | 0;
    return result;
  };
  protoOf(SerializedReferenceLocation).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SerializedReferenceLocation))
      return false;
    if (!this.yfa_1.equals(other.yfa_1))
      return false;
    if (!(this.zfa_1 === other.zfa_1))
      return false;
    return true;
  };
  function Companion_293() {
    Companion_instance_293 = this;
    this.afb_1 = new SerializedReferenceValue();
  }
  var Companion_instance_293;
  function Companion_getInstance_293() {
    if (Companion_instance_293 == null)
      new Companion_293();
    return Companion_instance_293;
  }
  function $serializer_25() {
    $serializer_instance_23 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('jetbrains.ocelot.langDef.references.remote.SerializedReferenceValue', this, 2);
    tmp0_serialDesc.q5j('resolveResult', true);
    tmp0_serialDesc.q5j('findResult', true);
    this.bfb_1 = tmp0_serialDesc;
  }
  protoOf($serializer_25).cfb = function (encoder, value) {
    var tmp0_desc = this.bfb_1;
    var tmp1_output = encoder.g5c(tmp0_desc);
    if (tmp1_output.b5e(tmp0_desc, 0) ? true : !(value.dfb_1 == null)) {
      tmp1_output.x5d(tmp0_desc, 0, NodePointerSerializer_getInstance(), value.dfb_1);
    }
    if (tmp1_output.b5e(tmp0_desc, 1) ? true : !(value.efb_1 == null)) {
      tmp1_output.x5d(tmp0_desc, 1, NodePointerSerializer_getInstance(), value.efb_1);
    }
    tmp1_output.h5c(tmp0_desc);
  };
  protoOf($serializer_25).i59 = function (encoder, value) {
    return this.cfb(encoder, value instanceof SerializedReferenceValue ? value : THROW_CCE());
  };
  protoOf($serializer_25).j59 = function (decoder) {
    var tmp0_desc = this.bfb_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.g5c(tmp0_desc);
    if (tmp6_input.v5c()) {
      tmp4_local0 = tmp6_input.u5c(tmp0_desc, 0, NodePointerSerializer_getInstance(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.u5c(tmp0_desc, 1, NodePointerSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.w5c(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.u5c(tmp0_desc, 0, NodePointerSerializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.u5c(tmp0_desc, 1, NodePointerSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.h5c(tmp0_desc);
    return SerializedReferenceValue_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_25).v58 = function () {
    return this.bfb_1;
  };
  protoOf($serializer_25).f5k = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable(NodePointerSerializer_getInstance()), get_nullable(NodePointerSerializer_getInstance())];
  };
  var $serializer_instance_23;
  function $serializer_getInstance_23() {
    if ($serializer_instance_23 == null)
      new $serializer_25();
    return $serializer_instance_23;
  }
  function SerializedReferenceValue_init_$Init$(seen0, resolveResult, findResult, serializationConstructorMarker, $this) {
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_23().bfb_1);
    }
    if (0 === (seen0 & 1))
      $this.dfb_1 = null;
    else
      $this.dfb_1 = resolveResult;
    if (0 === (seen0 & 2))
      $this.efb_1 = null;
    else
      $this.efb_1 = findResult;
    return $this;
  }
  function SerializedReferenceValue_init_$Create$(seen0, resolveResult, findResult, serializationConstructorMarker) {
    return SerializedReferenceValue_init_$Init$(seen0, resolveResult, findResult, serializationConstructorMarker, objectCreate(protoOf(SerializedReferenceValue)));
  }
  function SerializedReferenceValue(resolveResult, findResult) {
    Companion_getInstance_293();
    resolveResult = resolveResult === VOID ? null : resolveResult;
    findResult = findResult === VOID ? null : findResult;
    this.dfb_1 = resolveResult;
    this.efb_1 = findResult;
  }
  protoOf(SerializedReferenceValue).toString = function () {
    return 'SerializedReferenceValue(resolveResult=' + toString_0(this.dfb_1) + ', findResult=' + toString_0(this.efb_1) + ')';
  };
  protoOf(SerializedReferenceValue).hashCode = function () {
    var result = this.dfb_1 == null ? 0 : this.dfb_1.hashCode();
    result = imul(result, 31) + (this.efb_1 == null ? 0 : this.efb_1.hashCode()) | 0;
    return result;
  };
  protoOf(SerializedReferenceValue).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SerializedReferenceValue))
      return false;
    if (!equals(this.dfb_1, other.dfb_1))
      return false;
    if (!equals(this.efb_1, other.efb_1))
      return false;
    return true;
  };
  function Companion_294() {
    Companion_instance_294 = this;
    this.ffb_1 = new NodeResolutionProvider(emptyFlow(), Empty_instance_2);
  }
  var Companion_instance_294;
  function Companion_getInstance_294() {
    if (Companion_instance_294 == null)
      new Companion_294();
    return Companion_instance_294;
  }
  function NodeResolutionProvider(messages, completion) {
    Companion_getInstance_294();
    this.gfb_1 = messages;
    this.hfb_1 = completion;
  }
  protoOf(NodeResolutionProvider).toString = function () {
    return 'NodeResolutionProvider(messages=' + toString_1(this.gfb_1) + ', completion=' + toString_1(this.hfb_1) + ')';
  };
  protoOf(NodeResolutionProvider).hashCode = function () {
    var result = hashCode(this.gfb_1);
    result = imul(result, 31) + hashCode(this.hfb_1) | 0;
    return result;
  };
  protoOf(NodeResolutionProvider).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof NodeResolutionProvider))
      return false;
    if (!equals(this.gfb_1, other.gfb_1))
      return false;
    if (!equals(this.hfb_1, other.hfb_1))
      return false;
    return true;
  };
  function Companion_295() {
  }
  var Companion_instance_295;
  function Companion_getInstance_295() {
    return Companion_instance_295;
  }
  function $serializer_26() {
    $serializer_instance_24 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('jetbrains.ocelot.langDef.references.remote.live.NodeResolveInfoMessage.StateReceived', this, 1);
    tmp0_serialDesc.q5j('info', false);
    this.ifb_1 = tmp0_serialDesc;
  }
  protoOf($serializer_26).jfb = function (encoder, value) {
    var tmp0_desc = this.ifb_1;
    var tmp1_output = encoder.g5c(tmp0_desc);
    tmp1_output.w5d(tmp0_desc, 0, $serializer_getInstance_20(), value.kfb_1);
    tmp1_output.h5c(tmp0_desc);
  };
  protoOf($serializer_26).i59 = function (encoder, value) {
    return this.jfb(encoder, value instanceof StateReceived_0 ? value : THROW_CCE());
  };
  protoOf($serializer_26).j59 = function (decoder) {
    var tmp0_desc = this.ifb_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.g5c(tmp0_desc);
    if (tmp5_input.v5c()) {
      tmp4_local0 = tmp5_input.s5c(tmp0_desc, 0, $serializer_getInstance_20(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.w5c(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.s5c(tmp0_desc, 0, $serializer_getInstance_20(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.h5c(tmp0_desc);
    return StateReceived_init_$Create$_0(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_26).v58 = function () {
    return this.ifb_1;
  };
  protoOf($serializer_26).f5k = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_20()];
  };
  var $serializer_instance_24;
  function $serializer_getInstance_24() {
    if ($serializer_instance_24 == null)
      new $serializer_26();
    return $serializer_instance_24;
  }
  function StateReceived_init_$Init$_0(seen0, info, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_24().ifb_1);
    }
    NodeResolveInfoMessage_init_$Init$(seen0, serializationConstructorMarker, $this);
    $this.kfb_1 = info;
    return $this;
  }
  function StateReceived_init_$Create$_0(seen0, info, serializationConstructorMarker) {
    return StateReceived_init_$Init$_0(seen0, info, serializationConstructorMarker, objectCreate(protoOf(StateReceived_0)));
  }
  function Companion_296() {
  }
  var Companion_instance_296;
  function Companion_getInstance_296() {
    return Companion_instance_296;
  }
  function $serializer_27() {
    $serializer_instance_25 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('jetbrains.ocelot.langDef.references.remote.live.NodeResolveInfoMessage.UpdateReceived', this, 1);
    tmp0_serialDesc.q5j('update', false);
    this.lfb_1 = tmp0_serialDesc;
  }
  protoOf($serializer_27).mfb = function (encoder, value) {
    var tmp0_desc = this.lfb_1;
    var tmp1_output = encoder.g5c(tmp0_desc);
    tmp1_output.w5d(tmp0_desc, 0, $serializer_getInstance_26(), value.nfb_1);
    tmp1_output.h5c(tmp0_desc);
  };
  protoOf($serializer_27).i59 = function (encoder, value) {
    return this.mfb(encoder, value instanceof UpdateReceived_0 ? value : THROW_CCE());
  };
  protoOf($serializer_27).j59 = function (decoder) {
    var tmp0_desc = this.lfb_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.g5c(tmp0_desc);
    if (tmp5_input.v5c()) {
      tmp4_local0 = tmp5_input.s5c(tmp0_desc, 0, $serializer_getInstance_26(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.w5c(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.s5c(tmp0_desc, 0, $serializer_getInstance_26(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.h5c(tmp0_desc);
    return UpdateReceived_init_$Create$_0(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_27).v58 = function () {
    return this.lfb_1;
  };
  protoOf($serializer_27).f5k = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_26()];
  };
  var $serializer_instance_25;
  function $serializer_getInstance_25() {
    if ($serializer_instance_25 == null)
      new $serializer_27();
    return $serializer_instance_25;
  }
  function UpdateReceived_init_$Init$_0(seen0, update, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_25().lfb_1);
    }
    NodeResolveInfoMessage_init_$Init$(seen0, serializationConstructorMarker, $this);
    $this.nfb_1 = update;
    return $this;
  }
  function UpdateReceived_init_$Create$_0(seen0, update, serializationConstructorMarker) {
    return UpdateReceived_init_$Init$_0(seen0, update, serializationConstructorMarker, objectCreate(protoOf(UpdateReceived_0)));
  }
  function _get_$cachedSerializer__te6jhj_5($this) {
    return $this.ofb_1.a1();
  }
  function NodeResolveInfoMessage$Companion$_anonymous__e62eyo() {
    var tmp = getKClass(NodeResolveInfoMessage);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = [getKClass(StateReceived_0), getKClass(UpdateReceived_0)];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_1 = [$serializer_getInstance_24(), $serializer_getInstance_25()];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$8 = [];
    return SealedClassSerializer_init_$Create$('jetbrains.ocelot.langDef.references.remote.live.NodeResolveInfoMessage', tmp, tmp_0, tmp_1, tmp$ret$8);
  }
  function StateReceived_0(info) {
    NodeResolveInfoMessage.call(this);
    this.kfb_1 = info;
  }
  protoOf(StateReceived_0).toString = function () {
    return 'StateReceived(info=' + this.kfb_1.toString() + ')';
  };
  protoOf(StateReceived_0).hashCode = function () {
    return this.kfb_1.hashCode();
  };
  protoOf(StateReceived_0).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof StateReceived_0))
      return false;
    if (!this.kfb_1.equals(other.kfb_1))
      return false;
    return true;
  };
  function UpdateReceived_0(update) {
    NodeResolveInfoMessage.call(this);
    this.nfb_1 = update;
  }
  protoOf(UpdateReceived_0).toString = function () {
    return 'UpdateReceived(update=' + this.nfb_1.toString() + ')';
  };
  protoOf(UpdateReceived_0).hashCode = function () {
    return this.nfb_1.hashCode();
  };
  protoOf(UpdateReceived_0).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof UpdateReceived_0))
      return false;
    if (!this.nfb_1.equals(other.nfb_1))
      return false;
    return true;
  };
  function Companion_297() {
    Companion_instance_297 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.ofb_1 = lazy_0(tmp_0, NodeResolveInfoMessage$Companion$_anonymous__e62eyo);
  }
  protoOf(Companion_297).i63 = function () {
    return _get_$cachedSerializer__te6jhj_5(this);
  };
  protoOf(Companion_297).q5k = function (typeParamsSerializers) {
    return this.i63();
  };
  var Companion_instance_297;
  function Companion_getInstance_297() {
    if (Companion_instance_297 == null)
      new Companion_297();
    return Companion_instance_297;
  }
  function NodeResolveInfoMessage_init_$Init$(seen0, serializationConstructorMarker, $this) {
    return $this;
  }
  function NodeResolveInfoMessage() {
    Companion_getInstance_297();
  }
  function NodeResolveInfoUpdate$Companion$$childSerializers$_anonymous__k49wdl() {
    return new ArrayListSerializer($serializer_getInstance_21());
  }
  function NodeResolveInfoUpdate$Companion$$childSerializers$_anonymous__k49wdl_0() {
    return new ArrayListSerializer($serializer_getInstance_22());
  }
  function NodeResolveInfoUpdate$Companion$$childSerializers$_anonymous__k49wdl_1() {
    return new ArrayListSerializer($serializer_getInstance());
  }
  function NodeResolveInfoUpdate$Companion$$childSerializers$_anonymous__k49wdl_2() {
    return new ArrayListSerializer(NodePointerSerializer_getInstance());
  }
  function Companion_298() {
    Companion_instance_298 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_1 = lazy_0(tmp_0, NodeResolveInfoUpdate$Companion$$childSerializers$_anonymous__k49wdl);
    var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_3 = lazy_0(tmp_2, NodeResolveInfoUpdate$Companion$$childSerializers$_anonymous__k49wdl_0);
    var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_5 = lazy_0(tmp_4, NodeResolveInfoUpdate$Companion$$childSerializers$_anonymous__k49wdl_1);
    var tmp_6 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.pfb_1 = [tmp_1, tmp_3, tmp_5, lazy_0(tmp_6, NodeResolveInfoUpdate$Companion$$childSerializers$_anonymous__k49wdl_2)];
    this.qfb_1 = new NodeResolveInfoUpdate(emptyList(), emptyList(), emptyList(), emptyList());
  }
  var Companion_instance_298;
  function Companion_getInstance_298() {
    if (Companion_instance_298 == null)
      new Companion_298();
    return Companion_instance_298;
  }
  function $serializer_28() {
    $serializer_instance_26 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('jetbrains.ocelot.langDef.references.remote.live.NodeResolveInfoUpdate', this, 4);
    tmp0_serialDesc.q5j('updatedReferences', true);
    tmp0_serialDesc.q5j('droppedReferences', true);
    tmp0_serialDesc.q5j('updatedTargets', true);
    tmp0_serialDesc.q5j('droppedTargets', true);
    this.rfb_1 = tmp0_serialDesc;
  }
  protoOf($serializer_28).sfb = function (encoder, value) {
    var tmp0_desc = this.rfb_1;
    var tmp1_output = encoder.g5c(tmp0_desc);
    var tmp2_cached = Companion_getInstance_298().pfb_1;
    if (tmp1_output.b5e(tmp0_desc, 0) ? true : !equals(value.tfb_1, emptyList())) {
      tmp1_output.w5d(tmp0_desc, 0, tmp2_cached[0].a1(), value.tfb_1);
    }
    if (tmp1_output.b5e(tmp0_desc, 1) ? true : !equals(value.ufb_1, emptyList())) {
      tmp1_output.w5d(tmp0_desc, 1, tmp2_cached[1].a1(), value.ufb_1);
    }
    if (tmp1_output.b5e(tmp0_desc, 2) ? true : !equals(value.vfb_1, emptyList())) {
      tmp1_output.w5d(tmp0_desc, 2, tmp2_cached[2].a1(), value.vfb_1);
    }
    if (tmp1_output.b5e(tmp0_desc, 3) ? true : !equals(value.wfb_1, emptyList())) {
      tmp1_output.w5d(tmp0_desc, 3, tmp2_cached[3].a1(), value.wfb_1);
    }
    tmp1_output.h5c(tmp0_desc);
  };
  protoOf($serializer_28).i59 = function (encoder, value) {
    return this.sfb(encoder, value instanceof NodeResolveInfoUpdate ? value : THROW_CCE());
  };
  protoOf($serializer_28).j59 = function (decoder) {
    var tmp0_desc = this.rfb_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_input = decoder.g5c(tmp0_desc);
    var tmp9_cached = Companion_getInstance_298().pfb_1;
    if (tmp8_input.v5c()) {
      tmp4_local0 = tmp8_input.s5c(tmp0_desc, 0, tmp9_cached[0].a1(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.s5c(tmp0_desc, 1, tmp9_cached[1].a1(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.s5c(tmp0_desc, 2, tmp9_cached[2].a1(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.s5c(tmp0_desc, 3, tmp9_cached[3].a1(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.w5c(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.s5c(tmp0_desc, 0, tmp9_cached[0].a1(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.s5c(tmp0_desc, 1, tmp9_cached[1].a1(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.s5c(tmp0_desc, 2, tmp9_cached[2].a1(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.s5c(tmp0_desc, 3, tmp9_cached[3].a1(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp8_input.h5c(tmp0_desc);
    return NodeResolveInfoUpdate_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  };
  protoOf($serializer_28).v58 = function () {
    return this.rfb_1;
  };
  protoOf($serializer_28).f5k = function () {
    var tmp0_cached = Companion_getInstance_298().pfb_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0].a1(), tmp0_cached[1].a1(), tmp0_cached[2].a1(), tmp0_cached[3].a1()];
  };
  var $serializer_instance_26;
  function $serializer_getInstance_26() {
    if ($serializer_instance_26 == null)
      new $serializer_28();
    return $serializer_instance_26;
  }
  function NodeResolveInfoUpdate_init_$Init$(seen0, updatedReferences, droppedReferences, updatedTargets, droppedTargets, serializationConstructorMarker, $this) {
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_26().rfb_1);
    }
    if (0 === (seen0 & 1))
      $this.tfb_1 = emptyList();
    else
      $this.tfb_1 = updatedReferences;
    if (0 === (seen0 & 2))
      $this.ufb_1 = emptyList();
    else
      $this.ufb_1 = droppedReferences;
    if (0 === (seen0 & 4))
      $this.vfb_1 = emptyList();
    else
      $this.vfb_1 = updatedTargets;
    if (0 === (seen0 & 8))
      $this.wfb_1 = emptyList();
    else
      $this.wfb_1 = droppedTargets;
    return $this;
  }
  function NodeResolveInfoUpdate_init_$Create$(seen0, updatedReferences, droppedReferences, updatedTargets, droppedTargets, serializationConstructorMarker) {
    return NodeResolveInfoUpdate_init_$Init$(seen0, updatedReferences, droppedReferences, updatedTargets, droppedTargets, serializationConstructorMarker, objectCreate(protoOf(NodeResolveInfoUpdate)));
  }
  function NodeResolveInfoUpdate(updatedReferences, droppedReferences, updatedTargets, droppedTargets) {
    Companion_getInstance_298();
    updatedReferences = updatedReferences === VOID ? emptyList() : updatedReferences;
    droppedReferences = droppedReferences === VOID ? emptyList() : droppedReferences;
    updatedTargets = updatedTargets === VOID ? emptyList() : updatedTargets;
    droppedTargets = droppedTargets === VOID ? emptyList() : droppedTargets;
    this.tfb_1 = updatedReferences;
    this.ufb_1 = droppedReferences;
    this.vfb_1 = updatedTargets;
    this.wfb_1 = droppedTargets;
  }
  protoOf(NodeResolveInfoUpdate).toString = function () {
    return 'NodeResolveInfoUpdate(updatedReferences=' + toString_1(this.tfb_1) + ', droppedReferences=' + toString_1(this.ufb_1) + ', updatedTargets=' + toString_1(this.vfb_1) + ', droppedTargets=' + toString_1(this.wfb_1) + ')';
  };
  protoOf(NodeResolveInfoUpdate).hashCode = function () {
    var result = hashCode(this.tfb_1);
    result = imul(result, 31) + hashCode(this.ufb_1) | 0;
    result = imul(result, 31) + hashCode(this.vfb_1) | 0;
    result = imul(result, 31) + hashCode(this.wfb_1) | 0;
    return result;
  };
  protoOf(NodeResolveInfoUpdate).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof NodeResolveInfoUpdate))
      return false;
    if (!equals(this.tfb_1, other.tfb_1))
      return false;
    if (!equals(this.ufb_1, other.ufb_1))
      return false;
    if (!equals(this.vfb_1, other.vfb_1))
      return false;
    if (!equals(this.wfb_1, other.wfb_1))
      return false;
    return true;
  };
  function ReferenceCompletionService$Companion$elements$lambda(instance, parameters) {
    var tagName = parameters.fg();
    var enclosing = parameters.gg();
    var enclosingChildLink = parameters.zl();
    var source = parameters.b2d();
    var filter = parameters.c2d();
    return instance.cfc(tagName, enclosing, enclosingChildLink, source, filter);
  }
  function Companion_299() {
  }
  protoOf(Companion_299).i63 = function () {
    return $serializer_getInstance_27();
  };
  var Companion_instance_299;
  function Companion_getInstance_299() {
    return Companion_instance_299;
  }
  function $serializer_29() {
    $serializer_instance_27 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('jetbrains.ocelot.langDef.references.remote.live.ReferenceCompletionService.ElementsParameters', this, 5);
    tmp0_serialDesc.q5j('tagName', false);
    tmp0_serialDesc.q5j('enclosing', false);
    tmp0_serialDesc.q5j('enclosingChildLink', false);
    tmp0_serialDesc.q5j('source', false);
    tmp0_serialDesc.q5j('filter', false);
    this.dfc_1 = tmp0_serialDesc;
  }
  protoOf($serializer_29).efc = function (encoder, value) {
    var tmp0_desc = this.dfc_1;
    var tmp1_output = encoder.g5c(tmp0_desc);
    tmp1_output.u5d(tmp0_desc, 0, value.xfb_1);
    tmp1_output.x5d(tmp0_desc, 1, NodePointerSerializer_getInstance(), value.yfb_1);
    tmp1_output.w5d(tmp0_desc, 2, $serializer_getInstance_5(), value.zfb_1);
    tmp1_output.x5d(tmp0_desc, 3, NodePointerSerializer_getInstance(), value.afc_1);
    tmp1_output.w5d(tmp0_desc, 4, $serializer_getInstance_0(), value.bfc_1);
    tmp1_output.h5c(tmp0_desc);
  };
  protoOf($serializer_29).i59 = function (encoder, value) {
    return this.efc(encoder, value instanceof ElementsParameters ? value : THROW_CCE());
  };
  protoOf($serializer_29).j59 = function (decoder) {
    var tmp0_desc = this.dfc_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_input = decoder.g5c(tmp0_desc);
    if (tmp9_input.v5c()) {
      tmp4_local0 = tmp9_input.q5c(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp9_input.u5c(tmp0_desc, 1, NodePointerSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp9_input.s5c(tmp0_desc, 2, $serializer_getInstance_5(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp9_input.u5c(tmp0_desc, 3, NodePointerSerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp9_input.s5c(tmp0_desc, 4, $serializer_getInstance_0(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp9_input.w5c(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp9_input.q5c(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp9_input.u5c(tmp0_desc, 1, NodePointerSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp9_input.s5c(tmp0_desc, 2, $serializer_getInstance_5(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp9_input.u5c(tmp0_desc, 3, NodePointerSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp9_input.s5c(tmp0_desc, 4, $serializer_getInstance_0(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp9_input.h5c(tmp0_desc);
    return ElementsParameters_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
  };
  protoOf($serializer_29).v58 = function () {
    return this.dfc_1;
  };
  protoOf($serializer_29).f5k = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), get_nullable(NodePointerSerializer_getInstance()), $serializer_getInstance_5(), get_nullable(NodePointerSerializer_getInstance()), $serializer_getInstance_0()];
  };
  var $serializer_instance_27;
  function $serializer_getInstance_27() {
    if ($serializer_instance_27 == null)
      new $serializer_29();
    return $serializer_instance_27;
  }
  function ElementsParameters_init_$Init$(seen0, tagName, enclosing, enclosingChildLink, source, filter, serializationConstructorMarker, $this) {
    if (!(31 === (31 & seen0))) {
      throwMissingFieldException(seen0, 31, $serializer_getInstance_27().dfc_1);
    }
    $this.xfb_1 = tagName;
    $this.yfb_1 = enclosing;
    $this.zfb_1 = enclosingChildLink;
    $this.afc_1 = source;
    $this.bfc_1 = filter;
    return $this;
  }
  function ElementsParameters_init_$Create$(seen0, tagName, enclosing, enclosingChildLink, source, filter, serializationConstructorMarker) {
    return ElementsParameters_init_$Init$(seen0, tagName, enclosing, enclosingChildLink, source, filter, serializationConstructorMarker, objectCreate(protoOf(ElementsParameters)));
  }
  function Remote(endpoint) {
    this.ffc_1 = endpoint;
  }
  protoOf(Remote).cfc = function (tagName, enclosing, enclosingChildLink, source, filter) {
    return Companion_getInstance_300().hfc_1.ief(this.ffc_1, new ElementsParameters(tagName, enclosing, enclosingChildLink, source, filter));
  };
  function Companion_300() {
    Companion_instance_300 = this;
    InstanceDescriptor.call(this);
    var tmp = this;
    var tmp_0 = Companion_instance_299.i63();
    var tmp_1 = Companion_getInstance_301().i63();
    tmp.hfc_1 = flowMethod(this, 'elements', tmp_0, tmp_1, ReferenceCompletionService$Companion$elements$lambda);
  }
  protoOf(Companion_300).jfc = function (endpoint) {
    return new Remote(endpoint);
  };
  protoOf(Companion_300).kef = function (endpoint) {
    return this.jfc(endpoint);
  };
  var Companion_instance_300;
  function Companion_getInstance_300() {
    if (Companion_instance_300 == null)
      new Companion_300();
    return Companion_instance_300;
  }
  function Empty_3() {
  }
  protoOf(Empty_3).cfc = function (tagName, enclosing, enclosingChildLink, source, filter) {
    return emptyFlow();
  };
  var Empty_instance_2;
  function Empty_getInstance_2() {
    return Empty_instance_2;
  }
  function ElementsParameters(tagName, enclosing, enclosingChildLink, source, filter) {
    this.xfb_1 = tagName;
    this.yfb_1 = enclosing;
    this.zfb_1 = enclosingChildLink;
    this.afc_1 = source;
    this.bfc_1 = filter;
  }
  protoOf(ElementsParameters).fg = function () {
    return this.xfb_1;
  };
  protoOf(ElementsParameters).gg = function () {
    return this.yfb_1;
  };
  protoOf(ElementsParameters).zl = function () {
    return this.zfb_1;
  };
  protoOf(ElementsParameters).b2d = function () {
    return this.afc_1;
  };
  protoOf(ElementsParameters).c2d = function () {
    return this.bfc_1;
  };
  protoOf(ElementsParameters).toString = function () {
    return 'ElementsParameters(tagName=' + this.xfb_1 + ', enclosing=' + toString_0(this.yfb_1) + ', enclosingChildLink=' + this.zfb_1.toString() + ', source=' + toString_0(this.afc_1) + ', filter=' + this.bfc_1.toString() + ')';
  };
  protoOf(ElementsParameters).hashCode = function () {
    var result = getStringHashCode(this.xfb_1);
    result = imul(result, 31) + (this.yfb_1 == null ? 0 : this.yfb_1.hashCode()) | 0;
    result = imul(result, 31) + this.zfb_1.hashCode() | 0;
    result = imul(result, 31) + (this.afc_1 == null ? 0 : this.afc_1.hashCode()) | 0;
    result = imul(result, 31) + this.bfc_1.hashCode() | 0;
    return result;
  };
  protoOf(ElementsParameters).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ElementsParameters))
      return false;
    if (!(this.xfb_1 === other.xfb_1))
      return false;
    if (!equals(this.yfb_1, other.yfb_1))
      return false;
    if (!this.zfb_1.equals(other.zfb_1))
      return false;
    if (!equals(this.afc_1, other.afc_1))
      return false;
    if (!this.bfc_1.equals(other.bfc_1))
      return false;
    return true;
  };
  function Serializer_0() {
    Serializer_instance = this;
    InstancePublicationSerializer.call(this, Companion_getInstance_300());
  }
  var Serializer_instance;
  function Serializer_getInstance() {
    if (Serializer_instance == null)
      new Serializer_0();
    return Serializer_instance;
  }
  function ReferenceTargetsBatch$Companion$$childSerializers$_anonymous__dljgo7() {
    return new ArrayListSerializer($serializer_getInstance_29());
  }
  function Companion_301() {
    Companion_instance_301 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.ifc_1 = [lazy_0(tmp_0, ReferenceTargetsBatch$Companion$$childSerializers$_anonymous__dljgo7)];
  }
  protoOf(Companion_301).i63 = function () {
    return $serializer_getInstance_28();
  };
  var Companion_instance_301;
  function Companion_getInstance_301() {
    if (Companion_instance_301 == null)
      new Companion_301();
    return Companion_instance_301;
  }
  function $serializer_30() {
    $serializer_instance_28 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('jetbrains.ocelot.langDef.references.remote.live.ReferenceTargetsBatch', this, 1);
    tmp0_serialDesc.q5j('targets', false);
    this.kfc_1 = tmp0_serialDesc;
  }
  protoOf($serializer_30).lfc = function (encoder, value) {
    var tmp0_desc = this.kfc_1;
    var tmp1_output = encoder.g5c(tmp0_desc);
    var tmp2_cached = Companion_getInstance_301().ifc_1;
    tmp1_output.w5d(tmp0_desc, 0, tmp2_cached[0].a1(), value.mfc_1);
    tmp1_output.h5c(tmp0_desc);
  };
  protoOf($serializer_30).i59 = function (encoder, value) {
    return this.lfc(encoder, value instanceof ReferenceTargetsBatch ? value : THROW_CCE());
  };
  protoOf($serializer_30).j59 = function (decoder) {
    var tmp0_desc = this.kfc_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.g5c(tmp0_desc);
    var tmp6_cached = Companion_getInstance_301().ifc_1;
    if (tmp5_input.v5c()) {
      tmp4_local0 = tmp5_input.s5c(tmp0_desc, 0, tmp6_cached[0].a1(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.w5c(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.s5c(tmp0_desc, 0, tmp6_cached[0].a1(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.h5c(tmp0_desc);
    return ReferenceTargetsBatch_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_30).v58 = function () {
    return this.kfc_1;
  };
  protoOf($serializer_30).f5k = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_301().ifc_1[0].a1()];
  };
  var $serializer_instance_28;
  function $serializer_getInstance_28() {
    if ($serializer_instance_28 == null)
      new $serializer_30();
    return $serializer_instance_28;
  }
  function ReferenceTargetsBatch_init_$Init$(seen0, targets, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_28().kfc_1);
    }
    $this.mfc_1 = targets;
    return $this;
  }
  function ReferenceTargetsBatch_init_$Create$(seen0, targets, serializationConstructorMarker) {
    return ReferenceTargetsBatch_init_$Init$(seen0, targets, serializationConstructorMarker, objectCreate(protoOf(ReferenceTargetsBatch)));
  }
  function ReferenceTargetsBatch() {
  }
  protoOf(ReferenceTargetsBatch).toString = function () {
    return 'ReferenceTargetsBatch(targets=' + toString_1(this.mfc_1) + ')';
  };
  protoOf(ReferenceTargetsBatch).hashCode = function () {
    return hashCode(this.mfc_1);
  };
  protoOf(ReferenceTargetsBatch).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ReferenceTargetsBatch))
      return false;
    if (!equals(this.mfc_1, other.mfc_1))
      return false;
    return true;
  };
  function ReferenceTarget$Companion$$childSerializers$_anonymous__s6ug1a() {
    return Companion_getInstance_105().i63();
  }
  function Companion_302() {
    Companion_instance_302 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.nfc_1 = [lazy_0(tmp_0, ReferenceTarget$Companion$$childSerializers$_anonymous__s6ug1a), null, null];
  }
  var Companion_instance_302;
  function Companion_getInstance_302() {
    if (Companion_instance_302 == null)
      new Companion_302();
    return Companion_instance_302;
  }
  function $serializer_31() {
    $serializer_instance_29 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('jetbrains.ocelot.langDef.references.remote.live.ReferenceTarget', this, 3);
    tmp0_serialDesc.q5j('content', false);
    tmp0_serialDesc.q5j('presentation', false);
    tmp0_serialDesc.q5j('additionalText', true);
    this.ofc_1 = tmp0_serialDesc;
  }
  protoOf($serializer_31).pfc = function (encoder, value) {
    var tmp0_desc = this.ofc_1;
    var tmp1_output = encoder.g5c(tmp0_desc);
    var tmp2_cached = Companion_getInstance_302().nfc_1;
    tmp1_output.w5d(tmp0_desc, 0, tmp2_cached[0].a1(), value.qfc_1);
    tmp1_output.u5d(tmp0_desc, 1, value.rfc_1);
    if (tmp1_output.b5e(tmp0_desc, 2) ? true : !(value.sfc_1 == null)) {
      tmp1_output.x5d(tmp0_desc, 2, StringSerializer_getInstance(), value.sfc_1);
    }
    tmp1_output.h5c(tmp0_desc);
  };
  protoOf($serializer_31).i59 = function (encoder, value) {
    return this.pfc(encoder, value instanceof ReferenceTarget ? value : THROW_CCE());
  };
  protoOf($serializer_31).j59 = function (decoder) {
    var tmp0_desc = this.ofc_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.g5c(tmp0_desc);
    var tmp8_cached = Companion_getInstance_302().nfc_1;
    if (tmp7_input.v5c()) {
      tmp4_local0 = tmp7_input.s5c(tmp0_desc, 0, tmp8_cached[0].a1(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.q5c(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.u5c(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.w5c(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.s5c(tmp0_desc, 0, tmp8_cached[0].a1(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.q5c(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.u5c(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.h5c(tmp0_desc);
    return ReferenceTarget_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_31).v58 = function () {
    return this.ofc_1;
  };
  protoOf($serializer_31).f5k = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_302().nfc_1[0].a1(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance())];
  };
  var $serializer_instance_29;
  function $serializer_getInstance_29() {
    if ($serializer_instance_29 == null)
      new $serializer_31();
    return $serializer_instance_29;
  }
  function ReferenceTarget_init_$Init$(seen0, content, presentation, additionalText, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_29().ofc_1);
    }
    $this.qfc_1 = content;
    $this.rfc_1 = presentation;
    if (0 === (seen0 & 4))
      $this.sfc_1 = null;
    else
      $this.sfc_1 = additionalText;
    return $this;
  }
  function ReferenceTarget_init_$Create$(seen0, content, presentation, additionalText, serializationConstructorMarker) {
    return ReferenceTarget_init_$Init$(seen0, content, presentation, additionalText, serializationConstructorMarker, objectCreate(protoOf(ReferenceTarget)));
  }
  function ReferenceTarget() {
  }
  protoOf(ReferenceTarget).toString = function () {
    return 'ReferenceTarget(content=' + toString_1(this.qfc_1) + ', presentation=' + this.rfc_1 + ', additionalText=' + this.sfc_1 + ')';
  };
  protoOf(ReferenceTarget).hashCode = function () {
    var result = hashCode(this.qfc_1);
    result = imul(result, 31) + getStringHashCode(this.rfc_1) | 0;
    result = imul(result, 31) + (this.sfc_1 == null ? 0 : getStringHashCode(this.sfc_1)) | 0;
    return result;
  };
  protoOf(ReferenceTarget).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ReferenceTarget))
      return false;
    if (!equals(this.qfc_1, other.qfc_1))
      return false;
    if (!(this.rfc_1 === other.rfc_1))
      return false;
    if (!(this.sfc_1 == other.sfc_1))
      return false;
    return true;
  };
  function Companion_303() {
  }
  protoOf(Companion_303).i63 = function () {
    return $serializer_getInstance_30();
  };
  var Companion_instance_303;
  function Companion_getInstance_303() {
    return Companion_instance_303;
  }
  function $serializer_32() {
    $serializer_instance_30 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('jetbrains.ocelot.langDef.references.remote.precalculated.SerializedResolvedNode', this, 2);
    tmp0_serialDesc.q5j('node', false);
    tmp0_serialDesc.q5j('resolveInfo', false);
    this.tfc_1 = tmp0_serialDesc;
  }
  protoOf($serializer_32).ufc = function (encoder, value) {
    var tmp0_desc = this.tfc_1;
    var tmp1_output = encoder.g5c(tmp0_desc);
    tmp1_output.w5d(tmp0_desc, 0, $serializer_getInstance(), value.node);
    tmp1_output.w5d(tmp0_desc, 1, $serializer_getInstance_20(), value.resolveInfo);
    tmp1_output.h5c(tmp0_desc);
  };
  protoOf($serializer_32).i59 = function (encoder, value) {
    return this.ufc(encoder, value instanceof SerializedResolvedNode ? value : THROW_CCE());
  };
  protoOf($serializer_32).j59 = function (decoder) {
    var tmp0_desc = this.tfc_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.g5c(tmp0_desc);
    if (tmp6_input.v5c()) {
      tmp4_local0 = tmp6_input.s5c(tmp0_desc, 0, $serializer_getInstance(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.s5c(tmp0_desc, 1, $serializer_getInstance_20(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.w5c(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.s5c(tmp0_desc, 0, $serializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.s5c(tmp0_desc, 1, $serializer_getInstance_20(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.h5c(tmp0_desc);
    return SerializedResolvedNode_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_32).v58 = function () {
    return this.tfc_1;
  };
  protoOf($serializer_32).f5k = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance(), $serializer_getInstance_20()];
  };
  var $serializer_instance_30;
  function $serializer_getInstance_30() {
    if ($serializer_instance_30 == null)
      new $serializer_32();
    return $serializer_instance_30;
  }
  function SerializedResolvedNode_init_$Init$(seen0, node, resolveInfo, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_30().tfc_1);
    }
    $this.node = node;
    $this.resolveInfo = resolveInfo;
    return $this;
  }
  function SerializedResolvedNode_init_$Create$(seen0, node, resolveInfo, serializationConstructorMarker) {
    return SerializedResolvedNode_init_$Init$(seen0, node, resolveInfo, serializationConstructorMarker, objectCreate(protoOf(SerializedResolvedNode)));
  }
  function SerializedResolvedNode(node, resolveInfo) {
    this.node = node;
    this.resolveInfo = resolveInfo;
  }
  protoOf(SerializedResolvedNode).w85 = function () {
    return this.node;
  };
  protoOf(SerializedResolvedNode).vfc = function () {
    return this.resolveInfo;
  };
  protoOf(SerializedResolvedNode).fg = function () {
    return this.node;
  };
  protoOf(SerializedResolvedNode).gg = function () {
    return this.resolveInfo;
  };
  protoOf(SerializedResolvedNode).wfc = function (node, resolveInfo) {
    return new SerializedResolvedNode(node, resolveInfo);
  };
  protoOf(SerializedResolvedNode).copy = function (node, resolveInfo, $super) {
    node = node === VOID ? this.node : node;
    resolveInfo = resolveInfo === VOID ? this.resolveInfo : resolveInfo;
    return $super === VOID ? this.wfc(node, resolveInfo) : $super.wfc.call(this, node, resolveInfo);
  };
  protoOf(SerializedResolvedNode).toString = function () {
    return 'SerializedResolvedNode(node=' + this.node.toString() + ', resolveInfo=' + this.resolveInfo.toString() + ')';
  };
  protoOf(SerializedResolvedNode).hashCode = function () {
    var result = this.node.hashCode();
    result = imul(result, 31) + this.resolveInfo.hashCode() | 0;
    return result;
  };
  protoOf(SerializedResolvedNode).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SerializedResolvedNode))
      return false;
    if (!this.node.equals(other.node))
      return false;
    if (!this.resolveInfo.equals(other.resolveInfo))
      return false;
    return true;
  };
  function DerivedDataMessage$Resolution$Companion$$childSerializers$_anonymous__wsob1i() {
    return Companion_getInstance_297().i63();
  }
  function Companion_304() {
    Companion_instance_304 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.xfc_1 = [lazy_0(tmp_0, DerivedDataMessage$Resolution$Companion$$childSerializers$_anonymous__wsob1i)];
  }
  var Companion_instance_304;
  function Companion_getInstance_304() {
    if (Companion_instance_304 == null)
      new Companion_304();
    return Companion_instance_304;
  }
  function $serializer_33() {
    $serializer_instance_31 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('jetbrains.ocelot.langDef.remote.live.DerivedDataMessage.Resolution', this, 1);
    tmp0_serialDesc.q5j('payload', false);
    this.yfc_1 = tmp0_serialDesc;
  }
  protoOf($serializer_33).zfc = function (encoder, value) {
    var tmp0_desc = this.yfc_1;
    var tmp1_output = encoder.g5c(tmp0_desc);
    var tmp2_cached = Companion_getInstance_304().xfc_1;
    tmp1_output.w5d(tmp0_desc, 0, tmp2_cached[0].a1(), value.afd_1);
    tmp1_output.h5c(tmp0_desc);
  };
  protoOf($serializer_33).i59 = function (encoder, value) {
    return this.zfc(encoder, value instanceof Resolution ? value : THROW_CCE());
  };
  protoOf($serializer_33).j59 = function (decoder) {
    var tmp0_desc = this.yfc_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.g5c(tmp0_desc);
    var tmp6_cached = Companion_getInstance_304().xfc_1;
    if (tmp5_input.v5c()) {
      tmp4_local0 = tmp5_input.s5c(tmp0_desc, 0, tmp6_cached[0].a1(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.w5c(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.s5c(tmp0_desc, 0, tmp6_cached[0].a1(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.h5c(tmp0_desc);
    return Resolution_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_33).v58 = function () {
    return this.yfc_1;
  };
  protoOf($serializer_33).f5k = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_304().xfc_1[0].a1()];
  };
  var $serializer_instance_31;
  function $serializer_getInstance_31() {
    if ($serializer_instance_31 == null)
      new $serializer_33();
    return $serializer_instance_31;
  }
  function Resolution_init_$Init$(seen0, payload, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_31().yfc_1);
    }
    DerivedDataMessage_init_$Init$(seen0, serializationConstructorMarker, $this);
    $this.afd_1 = payload;
    return $this;
  }
  function Resolution_init_$Create$(seen0, payload, serializationConstructorMarker) {
    return Resolution_init_$Init$(seen0, payload, serializationConstructorMarker, objectCreate(protoOf(Resolution)));
  }
  function DerivedDataMessage$Error$Companion$$childSerializers$_anonymous__o15746() {
    return Companion_getInstance_289().i63();
  }
  function Companion_305() {
    Companion_instance_305 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.bfd_1 = [lazy_0(tmp_0, DerivedDataMessage$Error$Companion$$childSerializers$_anonymous__o15746)];
  }
  var Companion_instance_305;
  function Companion_getInstance_305() {
    if (Companion_instance_305 == null)
      new Companion_305();
    return Companion_instance_305;
  }
  function $serializer_34() {
    $serializer_instance_32 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('jetbrains.ocelot.langDef.remote.live.DerivedDataMessage.Error', this, 1);
    tmp0_serialDesc.q5j('payload', false);
    this.cfd_1 = tmp0_serialDesc;
  }
  protoOf($serializer_34).dfd = function (encoder, value) {
    var tmp0_desc = this.cfd_1;
    var tmp1_output = encoder.g5c(tmp0_desc);
    var tmp2_cached = Companion_getInstance_305().bfd_1;
    tmp1_output.w5d(tmp0_desc, 0, tmp2_cached[0].a1(), value.efd_1);
    tmp1_output.h5c(tmp0_desc);
  };
  protoOf($serializer_34).i59 = function (encoder, value) {
    return this.dfd(encoder, value instanceof Error_2 ? value : THROW_CCE());
  };
  protoOf($serializer_34).j59 = function (decoder) {
    var tmp0_desc = this.cfd_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.g5c(tmp0_desc);
    var tmp6_cached = Companion_getInstance_305().bfd_1;
    if (tmp5_input.v5c()) {
      tmp4_local0 = tmp5_input.s5c(tmp0_desc, 0, tmp6_cached[0].a1(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.w5c(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.s5c(tmp0_desc, 0, tmp6_cached[0].a1(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.h5c(tmp0_desc);
    return Error_init_$Create$_2(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_34).v58 = function () {
    return this.cfd_1;
  };
  protoOf($serializer_34).f5k = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_305().bfd_1[0].a1()];
  };
  var $serializer_instance_32;
  function $serializer_getInstance_32() {
    if ($serializer_instance_32 == null)
      new $serializer_34();
    return $serializer_instance_32;
  }
  function Error_init_$Init$_2(seen0, payload, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_32().cfd_1);
    }
    DerivedDataMessage_init_$Init$(seen0, serializationConstructorMarker, $this);
    $this.efd_1 = payload;
    return $this;
  }
  function Error_init_$Create$_2(seen0, payload, serializationConstructorMarker) {
    return Error_init_$Init$_2(seen0, payload, serializationConstructorMarker, objectCreate(protoOf(Error_2)));
  }
  function _get_$cachedSerializer__te6jhj_6($this) {
    return $this.ffd_1.a1();
  }
  function DerivedDataMessage$Companion$_anonymous__gs7ndd() {
    var tmp = getKClass(DerivedDataMessage);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = [getKClass(Error_2), getKClass(Resolution)];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_1 = [$serializer_getInstance_32(), $serializer_getInstance_31()];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$8 = [];
    return SealedClassSerializer_init_$Create$('jetbrains.ocelot.langDef.remote.live.DerivedDataMessage', tmp, tmp_0, tmp_1, tmp$ret$8);
  }
  function Resolution(payload) {
    Companion_getInstance_304();
    DerivedDataMessage.call(this);
    this.afd_1 = payload;
  }
  protoOf(Resolution).toString = function () {
    return 'Resolution(payload=' + toString_1(this.afd_1) + ')';
  };
  protoOf(Resolution).hashCode = function () {
    return hashCode(this.afd_1);
  };
  protoOf(Resolution).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Resolution))
      return false;
    if (!equals(this.afd_1, other.afd_1))
      return false;
    return true;
  };
  function Error_2(payload) {
    Companion_getInstance_305();
    DerivedDataMessage.call(this);
    this.efd_1 = payload;
  }
  protoOf(Error_2).toString = function () {
    return 'Error(payload=' + toString_1(this.efd_1) + ')';
  };
  protoOf(Error_2).hashCode = function () {
    return hashCode(this.efd_1);
  };
  protoOf(Error_2).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Error_2))
      return false;
    if (!equals(this.efd_1, other.efd_1))
      return false;
    return true;
  };
  function Companion_306() {
    Companion_instance_306 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.ffd_1 = lazy_0(tmp_0, DerivedDataMessage$Companion$_anonymous__gs7ndd);
  }
  protoOf(Companion_306).i63 = function () {
    return _get_$cachedSerializer__te6jhj_6(this);
  };
  protoOf(Companion_306).q5k = function (typeParamsSerializers) {
    return this.i63();
  };
  var Companion_instance_306;
  function Companion_getInstance_306() {
    if (Companion_instance_306 == null)
      new Companion_306();
    return Companion_instance_306;
  }
  function DerivedDataMessage_init_$Init$(seen0, serializationConstructorMarker, $this) {
    return $this;
  }
  function DerivedDataMessage() {
    Companion_getInstance_306();
  }
  function derivedDataMethod(_this__u8e3s4, id, parameterSerializer, handle) {
    var tmp = get_withFacade(parameterSerializer);
    var tmp_0 = PairSerializer(Serializer_getInstance(), serializer_4(BooleanCompanionObject_instance));
    var tmp_1 = Companion_getInstance_306().i63();
    var inner = mixinFacade(flowBasedMethod(_this__u8e3s4, id, tmp, tmp_0, tmp_1, derivedDataMethod$slambda_0(handle, null)));
    return new derivedDataMethod$1(inner);
  }
  function derivedDataMethod$slambda($handle, resultContinuation) {
    this.ofd_1 = $handle;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(derivedDataMethod$slambda).tfd = function (instance, _destruct__k2r9zo, $completion) {
    var tmp = this.ufd(instance, _destruct__k2r9zo, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(derivedDataMethod$slambda).w9 = function (p1, p2, $completion) {
    var tmp = (!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE();
    return this.tfd(tmp, p2 instanceof RpcFacadeMixin ? p2 : THROW_CCE(), $completion);
  };
  protoOf(derivedDataMethod$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 3;
            this.sfd_1 = this.qfd_1.fg();
            var parameter = this.qfd_1.gg();
            this.f9_1 = 1;
            suspendResult = this.ofd_1(this.pfd_1, parameter, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.rfd_1 = suspendResult;
            this.f9_1 = 2;
            suspendResult = this.sfd_1.zeg(this.rfd_1.wfd_1, Companion_getInstance_300(), VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var publication = suspendResult;
            return to(to(publication, this.rfd_1.xfd_1), this.rfd_1.vfd_1);
          case 3:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 3) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(derivedDataMethod$slambda).ufd = function (instance, _destruct__k2r9zo, completion) {
    var i = new derivedDataMethod$slambda(this.ofd_1, completion);
    i.pfd_1 = instance;
    i.qfd_1 = _destruct__k2r9zo;
    return i;
  };
  function derivedDataMethod$slambda_0($handle, resultContinuation) {
    var i = new derivedDataMethod$slambda($handle, resultContinuation);
    var l = function (instance, _destruct__k2r9zo, $completion) {
      return i.tfd(instance, _destruct__k2r9zo, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function $callCOROUTINE$_0(_this__u8e3s4, endpoint, parameter, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.gfe_1 = _this__u8e3s4;
    this.hfe_1 = endpoint;
    this.ife_1 = parameter;
  }
  protoOf($callCOROUTINE$_0).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.gfe_1.jfe_1.oeg(this.hfe_1, this.ife_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var _destruct__k2r9zo = suspendResult;
            var initial = _destruct__k2r9zo.fg();
            var messages = _destruct__k2r9zo.gg();
            var publication = initial.fg();
            var nodeErrorInfoIncluded = initial.gg();
            return new DerivedDataProvider(messages, publication.b3c(), nodeErrorInfoIncluded);
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function derivedDataMethod$1($inner) {
    this.jfe_1 = $inner;
  }
  protoOf(derivedDataMethod$1).kfe = function (endpoint, parameter, $completion) {
    var tmp = new $callCOROUTINE$_0(this, endpoint, parameter, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(derivedDataMethod$1).oeg = function (endpoint, parameter, $completion) {
    return this.kfe(endpoint, (parameter == null ? true : !(parameter == null)) ? parameter : THROW_CCE(), $completion);
  };
  function DerivedDataProvider(messages, completion, nodeErrorInfoIncluded) {
    this.vfd_1 = messages;
    this.wfd_1 = completion;
    this.xfd_1 = nodeErrorInfoIncluded;
  }
  protoOf(DerivedDataProvider).toString = function () {
    return 'DerivedDataProvider(messages=' + toString_1(this.vfd_1) + ', completion=' + toString_1(this.wfd_1) + ', nodeErrorInfoIncluded=' + this.xfd_1 + ')';
  };
  protoOf(DerivedDataProvider).hashCode = function () {
    var result = hashCode(this.vfd_1);
    result = imul(result, 31) + hashCode(this.wfd_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.xfd_1) | 0;
    return result;
  };
  protoOf(DerivedDataProvider).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof DerivedDataProvider))
      return false;
    if (!equals(this.vfd_1, other.vfd_1))
      return false;
    if (!equals(this.wfd_1, other.wfd_1))
      return false;
    if (!(this.xfd_1 === other.xfd_1))
      return false;
    return true;
  };
  function RemoteErrorCheckConfig$checking$o$check$o$run$lambda(this$0, $pointer) {
    return function (handler) {
      return this$0.nfe_1.k2w($pointer, handler);
    };
  }
  function RemoteErrorCheckConfig$checking$1$check$$inlined$query$1($node, this$0) {
    this.ofe_1 = $node;
    this.pfe_1 = this$0;
  }
  protoOf(RemoteErrorCheckConfig$checking$1$check$$inlined$query$1).n5w = function (builder) {
    var tmp$ret$0;
    $l$block: {
      var tmp0_elvis_lhs = get_pointer(this.ofe_1);
      var tmp;
      if (tmp0_elvis_lhs == null) {
        tmp$ret$0 = emptyList();
        break $l$block;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var pointer = tmp;
      var tmp_0 = RemoteErrorCheckConfig$checking$o$check$o$run$lambda(this.pfe_1, pointer);
      builder.q5w_1.o5w_1.x5u(new sam$jetbrains_ocelot_base_observable_event_EventSource$0_0(tmp_0), Invalidation_getInstance().g5u_1);
      var tmp1_safe_receiver = this.pfe_1.mfe_1.q2(pointer);
      var tmp_1;
      if (tmp1_safe_receiver == null) {
        tmp_1 = null;
      } else {
        // Inline function 'kotlin.collections.map' call
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp1_safe_receiver, 10));
        var _iterator__ex2g4s = tmp1_safe_receiver.m();
        while (_iterator__ex2g4s.n()) {
          var item = _iterator__ex2g4s.o();
          var tmp$ret$1 = deserialize_0(item, this.pfe_1.lfe_1);
          destination.j(tmp$ret$1);
        }
        tmp_1 = destination;
      }
      var tmp2_elvis_lhs = tmp_1;
      tmp$ret$0 = tmp2_elvis_lhs == null ? emptyList() : tmp2_elvis_lhs;
    }
    return tmp$ret$0;
  };
  function sam$jetbrains_ocelot_base_observable_event_EventSource$0_0(function_0) {
    this.qfe_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_base_observable_event_EventSource$0_0).y2r = function (handler) {
    return this.qfe_1(handler);
  };
  protoOf(sam$jetbrains_ocelot_base_observable_event_EventSource$0_0).f3 = function () {
    return this.qfe_1;
  };
  protoOf(sam$jetbrains_ocelot_base_observable_event_EventSource$0_0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, EventSource) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_base_observable_event_EventSource$0_0).hashCode = function () {
    return hashCode(this.f3());
  };
  function RemoteErrorCheckConfig$messageReceived$lambda(it) {
    it.n2s(Unit_instance);
    return Unit_instance;
  }
  function RemoteErrorCheckConfig$messageReceived$lambda_0(it) {
    it.n2s(Unit_instance);
    return Unit_instance;
  }
  function RemoteErrorCheckConfig$messageReceived$lambda_1(it) {
    it.n2s(Unit_instance);
    return Unit_instance;
  }
  function RemoteErrorCheckConfig$checking$1(this$0) {
    this.rfe_1 = this$0;
  }
  protoOf(RemoteErrorCheckConfig$checking$1).q70 = function (node) {
    // Inline function 'jetbrains.ocelot.langDef.query.query' call
    return new RemoteErrorCheckConfig$checking$1$check$$inlined$query$1(node, this.rfe_1);
  };
  function RemoteErrorCheckConfig(nodePointerSupport) {
    this.lfe_1 = nodePointerSupport;
    var tmp = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp.mfe_1 = LinkedHashMap_init_$Create$();
    this.nfe_1 = new ListenersMap();
  }
  protoOf(RemoteErrorCheckConfig).sfe = function (message) {
    if (message instanceof StateReceived) {
      // Inline function 'kotlin.collections.associate' call
      var this_0 = message.bfa_1.kf9_1;
      var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
      // Inline function 'kotlin.collections.associateTo' call
      var destination = LinkedHashMap_init_$Create$_0(capacity);
      var _iterator__ex2g4s = this_0.m();
      while (_iterator__ex2g4s.n()) {
        var element = _iterator__ex2g4s.o();
        // Inline function 'kotlin.collections.plusAssign' call
        var pair = to(element.xf9_1, element.yf9_1);
        destination.t2(pair.pg_1, pair.qg_1);
      }
      var newErrors = destination;
      var allPointers = plus_10(this.mfe_1.r2(), newErrors.r2());
      this.mfe_1.k2();
      this.mfe_1.v2(newErrors);
      var _iterator__ex2g4s_0 = allPointers.m();
      while (_iterator__ex2g4s_0.n()) {
        var pointer = _iterator__ex2g4s_0.o();
        this.nfe_1.l2w(pointer, RemoteErrorCheckConfig$messageReceived$lambda);
      }
    } else {
      if (message instanceof UpdateReceived) {
        var _iterator__ex2g4s_1 = message.efa_1.kfa_1.m();
        while (_iterator__ex2g4s_1.n()) {
          var nodeErrors = _iterator__ex2g4s_1.o();
          var tmp0 = this.mfe_1;
          var tmp2 = nodeErrors.xf9_1;
          // Inline function 'kotlin.collections.set' call
          var value = nodeErrors.yf9_1;
          tmp0.t2(tmp2, value);
          this.nfe_1.l2w(nodeErrors.xf9_1, RemoteErrorCheckConfig$messageReceived$lambda_0);
        }
        var _iterator__ex2g4s_2 = message.efa_1.lfa_1.m();
        while (_iterator__ex2g4s_2.n()) {
          var pointer_0 = _iterator__ex2g4s_2.o();
          this.mfe_1.u2(pointer_0);
          this.nfe_1.l2w(pointer_0, RemoteErrorCheckConfig$messageReceived$lambda_1);
        }
      } else {
        noWhenBranchMatchedException();
      }
    }
  };
  protoOf(RemoteErrorCheckConfig).j70 = function (concept) {
    return listOf(new RemoteErrorCheckConfig$checking$1(this));
  };
  function remoteErrorCheck() {
    var tmp = Companion_instance_41;
    var tmp_0 = [Companion_instance_118];
    return tmp.m3b(tmp_0, VOID, remoteErrorCheck$lambda);
  }
  function remoteErrorCheck$lambda(services) {
    var config = new RemoteErrorCheckConfig(Companion_instance_88.e3b(services).p6g());
    var tmp = CoroutineScope_0(CoroutineContextService_getInstance().e3b(services));
    launch(tmp, VOID, VOID, remoteErrorCheck$lambda$slambda_0(services, config, null));
    return config;
  }
  function sam$kotlinx_coroutines_flow_FlowCollector$0_14(function_0) {
    this.tfe_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_14).x18 = function (value, $completion) {
    return this.tfe_1(value, $completion);
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_14).f3 = function () {
    return this.tfe_1;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_14).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, FlowCollector) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_14).hashCode = function () {
    return hashCode(this.f3());
  };
  function remoteErrorCheck$lambda$slambda$slambda(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(remoteErrorCheck$lambda$slambda$slambda).eff = function ($this$transformLatest, it, $completion) {
    var tmp = this.fff($this$transformLatest, it, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(remoteErrorCheck$lambda$slambda$slambda).w9 = function (p1, p2, $completion) {
    var tmp = (!(p1 == null) ? isInterface(p1, FlowCollector) : false) ? p1 : THROW_CCE();
    return this.eff(tmp, (p2 == null ? true : !(p2 == null)) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(remoteErrorCheck$lambda$slambda$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            var it = this.dff_1;
            suspendResult = emitAll_0(this.cff_1, it.hff_1.mfa_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(remoteErrorCheck$lambda$slambda$slambda).fff = function ($this$transformLatest, it, completion) {
    var i = new remoteErrorCheck$lambda$slambda$slambda(completion);
    i.cff_1 = $this$transformLatest;
    i.dff_1 = it;
    return i;
  };
  function remoteErrorCheck$lambda$slambda$slambda_0(resultContinuation) {
    var i = new remoteErrorCheck$lambda$slambda$slambda(resultContinuation);
    var l = function ($this$transformLatest, it, $completion) {
      return i.eff($this$transformLatest, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function remoteErrorCheck$lambda$slambda$slambda_1($config, resultContinuation) {
    this.qff_1 = $config;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(remoteErrorCheck$lambda$slambda$slambda_1).sff = function (it, $completion) {
    var tmp = this.tff(it, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(remoteErrorCheck$lambda$slambda$slambda_1).v9 = function (p1, $completion) {
    return this.sff(p1 instanceof NodeErrorInfoMessage ? p1 : THROW_CCE(), $completion);
  };
  protoOf(remoteErrorCheck$lambda$slambda$slambda_1).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        if (tmp === 0) {
          this.g9_1 = 1;
          this.qff_1.sfe(this.rff_1);
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(remoteErrorCheck$lambda$slambda$slambda_1).tff = function (it, completion) {
    var i = new remoteErrorCheck$lambda$slambda$slambda_1(this.qff_1, completion);
    i.rff_1 = it;
    return i;
  };
  function remoteErrorCheck$lambda$slambda$slambda_2($config, resultContinuation) {
    var i = new remoteErrorCheck$lambda$slambda$slambda_1($config, resultContinuation);
    var l = function (it, $completion) {
      return i.sff(it, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function remoteErrorCheck$lambda$slambda($services, $config, resultContinuation) {
    this.cfg_1 = $services;
    this.dfg_1 = $config;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(remoteErrorCheck$lambda$slambda).e1h = function ($this$launch, $completion) {
    var tmp = this.f1h($this$launch, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(remoteErrorCheck$lambda$slambda).v9 = function (p1, $completion) {
    return this.e1h((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(remoteErrorCheck$lambda$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            var this_0 = Companion_instance_310.e3b(this.cfg_1).ffg_1;
            var tmp_0 = transformLatest(this_0, remoteErrorCheck$lambda$slambda$slambda_0(null));
            var tmp_1 = remoteErrorCheck$lambda$slambda$slambda_2(this.dfg_1, null);
            suspendResult = tmp_0.f18(new sam$kotlinx_coroutines_flow_FlowCollector$0_14(tmp_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(remoteErrorCheck$lambda$slambda).f1h = function ($this$launch, completion) {
    var i = new remoteErrorCheck$lambda$slambda(this.cfg_1, this.dfg_1, completion);
    i.efg_1 = $this$launch;
    return i;
  };
  function remoteErrorCheck$lambda$slambda_0($services, $config, resultContinuation) {
    var i = new remoteErrorCheck$lambda$slambda($services, $config, resultContinuation);
    var l = function ($this$launch, $completion) {
      return i.e1h($this$launch, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function LiveResolutionClient(messages, completionServices, stateApplied) {
    this.hfg_1 = messages;
    this.ifg_1 = completionServices;
    this.jfg_1 = stateApplied;
  }
  protoOf(LiveResolutionClient).cfc = function (tagName, enclosing, enclosingChildLink, source, filter) {
    return this.ifg_1.a1().cfc(tagName, enclosing, enclosingChildLink, source, filter);
  };
  protoOf(LiveResolutionClient).kfg = function (source, tag, property) {
    // Inline function 'kotlin.check' call
    if (!_ChannelResult___get_isSuccess__impl__odq1z9(this.hfg_1.a16(new ReferenceActivated(source, tag, property)))) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
  };
  function LiveResolutionClient_0(_this__u8e3s4, persister, nodeStorage, wrapperContext, providers, rootHolder) {
    var messages = Channel(2147483647);
    var completionServices = MutableStateFlow(Empty_instance_2);
    var stateApplied = MutableStateFlow(false);
    launch(_this__u8e3s4, VOID, VOID, LiveResolutionClient$slambda_0(providers, messages, stateApplied, completionServices, null));
    var client = {_v: null};
    launch(_this__u8e3s4, VOID, VOID, LiveResolutionClient$slambda_2(rootHolder, client, wrapperContext, persister, nodeStorage, messages, stateApplied, null));
    client._v = new LiveResolutionClient(messages, completionServices, stateApplied);
    var tmp;
    if (client._v == null) {
      throwUninitializedPropertyAccessException('client');
    } else {
      tmp = client._v;
    }
    return tmp;
  }
  function activateStateReferences(client, wrapperContext, node, activated) {
    var wrapper = toDomainNode(node, wrapperContext);
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s = (isInterface(wrapper, TypedOtNode) ? wrapper : THROW_CCE()).b6j().y().m();
    while (_iterator__ex2g4s.n()) {
      var _destruct__k2r9zo = _iterator__ex2g4s.o();
      // Inline function 'kotlin.collections.component1' call
      var tag = _destruct__k2r9zo.z();
      // Inline function 'kotlin.collections.component2' call
      var reference = _destruct__k2r9zo.a1();
      // Inline function 'kotlin.check' call
      if (!(reference instanceof LiveResolutionReference)) {
        throw IllegalStateException_init_$Create$_0('Check failed.');
      }
      if (activated) {
        client.kfg(wrapper, tag, reference.mfg_1);
      } else {
        client.kfg(wrapper, tag, null);
      }
    }
  }
  function createReferenceActivatorNodeListener(client, wrapperContext) {
    return new createReferenceActivatorNodeListener$1(client, wrapperContext);
  }
  function LiveResolutionClientState$findTarget$o$run$lambda(this$0, $pointer) {
    return function (handler) {
      return this$0.vfg_1.k2w($pointer, handler);
    };
  }
  function restoreState($this, info) {
    var droppedTargets = toMap($this.ufg_1);
    $this.ufg_1.k2();
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s = droppedTargets.y().m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      // Inline function 'kotlin.collections.component1' call
      var pointer = element.z();
      // Inline function 'kotlin.collections.component2' call
      var value = element.a1();
      activateTargetReferences($this, value, false);
      var event = new PropertyChangeEvent(value, null);
      $this.vfg_1.l2w(pointer, LiveResolutionClientState$restoreState$lambda(event));
    }
    $this.rfg_1.k2();
    updateTargets($this, info.qfa_1);
    updateReferences($this, info.rfa_1);
  }
  function updateState_0($this, update) {
    updateTargets($this, update.vfb_1);
    dropTargets($this, update.wfb_1);
    updateReferences($this, update.tfb_1);
    dropReferences($this, update.ufb_1);
  }
  function updateTargets($this, updatedTargets) {
    var _iterator__ex2g4s = updatedTargets.m();
    while (_iterator__ex2g4s.n()) {
      var target = _iterator__ex2g4s.o();
      var targetValue = $this.nfg_1.p25(target.content);
      $this.ofg_1.u6f(target.pointer, targetValue);
      var previousTargetValue = $this.ufg_1.q2(target.pointer);
      if (!equals(previousTargetValue, targetValue)) {
        if (!(previousTargetValue == null)) {
          activateTargetReferences($this, previousTargetValue, false);
        }
        activateTargetReferences($this, targetValue, true);
        var tmp0 = $this.ufg_1;
        // Inline function 'kotlin.collections.set' call
        var key = target.pointer;
        tmp0.t2(key, targetValue);
        var event = new PropertyChangeEvent(previousTargetValue, targetValue);
        $this.vfg_1.l2w(target.pointer, LiveResolutionClientState$updateTargets$lambda(event));
      }
    }
  }
  function dropTargets($this, droppedTargetPointers) {
    var _iterator__ex2g4s = droppedTargetPointers.m();
    while (_iterator__ex2g4s.n()) {
      var targetPointer = _iterator__ex2g4s.o();
      var previousTargetValue = $this.ufg_1.q2(targetPointer);
      if (!(previousTargetValue == null)) {
        activateTargetReferences($this, previousTargetValue, false);
        $this.ufg_1.u2(targetPointer);
        var event = new PropertyChangeEvent(previousTargetValue, null);
        $this.vfg_1.l2w(targetPointer, LiveResolutionClientState$dropTargets$lambda(event));
      }
    }
  }
  function dropReferences($this, droppedReferences) {
    var _iterator__ex2g4s = droppedReferences.m();
    while (_iterator__ex2g4s.n()) {
      var location = _iterator__ex2g4s.o();
      var tmp0_safe_receiver = $this.sfg_1.q2(location);
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.d2x(Companion_getInstance_308().wfg_1);
      }
      $this.rfg_1.u2(location);
    }
  }
  function updateReferences($this, updatedReferences) {
    var _iterator__ex2g4s = updatedReferences.m();
    while (_iterator__ex2g4s.n()) {
      var reference = _iterator__ex2g4s.o();
      var location = reference.ufa_1;
      var tmp0_elvis_lhs = reference.vfa_1.dfb_1;
      var tmp = tmp0_elvis_lhs == null ? reference.vfa_1.efb_1 : tmp0_elvis_lhs;
      var value = new LiveResolutionReferenceValue(reference.vfa_1.dfb_1, tmp, LiveResolutionClientState$findTarget$ref($this));
      var state = $this.sfg_1.q2(location);
      if (state == null) {
        // Inline function 'kotlin.collections.set' call
        $this.rfg_1.t2(location, value);
      } else {
        state.d2x(value);
      }
    }
  }
  function findTarget($this, pointer) {
    // Inline function 'jetbrains.ocelot.langDef.query.query' call
    return new LiveResolutionClientState$findTarget$$inlined$query$1($this, pointer);
  }
  function findLocalTarget($this, pointer) {
    // Inline function 'jetbrains.ocelot.langDef.query.query' call
    return new LiveResolutionClientState$findLocalTarget$$inlined$query$1($this, pointer);
  }
  function activateTargetReferences($this, target, activated) {
    var _iterator__ex2g4s = target.g6j(true).m();
    while (_iterator__ex2g4s.n()) {
      var targetChild = _iterator__ex2g4s.o();
      // Inline function 'kotlin.collections.iterator' call
      var _iterator__ex2g4s_0 = (isInterface(targetChild, TypedOtNode) ? targetChild : THROW_CCE()).b6j().y().m();
      while (_iterator__ex2g4s_0.n()) {
        var _destruct__k2r9zo = _iterator__ex2g4s_0.o();
        // Inline function 'kotlin.collections.component1' call
        var tag = _destruct__k2r9zo.z();
        // Inline function 'kotlin.collections.component2' call
        var reference = _destruct__k2r9zo.a1();
        // Inline function 'kotlin.check' call
        if (!(reference instanceof LiveResolutionReference)) {
          throw IllegalStateException_init_$Create$_0('Check failed.');
        }
        if (activated) {
          $this.xfg(targetChild, tag, reference.mfg_1);
        } else {
          $this.xfg(targetChild, tag, null);
        }
      }
    }
  }
  function sam$jetbrains_ocelot_base_observable_event_EventSource$0_1(function_0) {
    this.yfg_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_base_observable_event_EventSource$0_1).y2r = function (handler) {
    return this.yfg_1(handler);
  };
  protoOf(sam$jetbrains_ocelot_base_observable_event_EventSource$0_1).f3 = function () {
    return this.yfg_1;
  };
  protoOf(sam$jetbrains_ocelot_base_observable_event_EventSource$0_1).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, EventSource) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_base_observable_event_EventSource$0_1).hashCode = function () {
    return hashCode(this.f3());
  };
  function LiveResolutionClientState$restoreState$lambda($event) {
    return function (it) {
      it.n2s($event);
      return Unit_instance;
    };
  }
  function LiveResolutionClientState$updateTargets$lambda($event) {
    return function (it) {
      it.n2s($event);
      return Unit_instance;
    };
  }
  function LiveResolutionClientState$dropTargets$lambda($event) {
    return function (it) {
      it.n2s($event);
      return Unit_instance;
    };
  }
  function LiveResolutionClientState$findTarget$ref(p0) {
    var l = function (_this__u8e3s4) {
      var tmp0 = p0;
      return findTarget(tmp0, _this__u8e3s4);
    };
    l.callableName = 'findTarget';
    return l;
  }
  function LiveResolutionClientState$findTarget$$inlined$query$1(this$0, $pointer) {
    this.zfg_1 = this$0;
    this.afh_1 = $pointer;
  }
  protoOf(LiveResolutionClientState$findTarget$$inlined$query$1).n5w = function (builder) {
    var tmp = LiveResolutionClientState$findTarget$o$run$lambda(this.zfg_1, this.afh_1);
    builder.q5w_1.o5w_1.x5u(new sam$jetbrains_ocelot_base_observable_event_EventSource$0_1(tmp), Invalidation_getInstance().g5u_1);
    var tmp0_elvis_lhs = this.zfg_1.ufg_1.q2(this.afh_1);
    return tmp0_elvis_lhs == null ? builder.l60(findLocalTarget(this.zfg_1, this.afh_1)) : tmp0_elvis_lhs;
  };
  function LiveResolutionClientState$findLocalTarget$$inlined$query$1(this$0, $pointer) {
    this.bfh_1 = this$0;
    this.cfh_1 = $pointer;
  }
  protoOf(LiveResolutionClientState$findLocalTarget$$inlined$query$1).n5w = function (builder) {
    var tmp$ret$0;
    $l$block: {
      var tmp0_elvis_lhs = builder.l60(this.bfh_1.pfg_1.h6g(this.cfh_1.nodeId));
      var tmp;
      if (tmp0_elvis_lhs == null) {
        tmp$ret$0 = null;
        break $l$block;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var otNode = tmp;
      tmp$ret$0 = toDomainNode(otNode, this.bfh_1.qfg_1);
    }
    return tmp$ret$0;
  };
  function LiveResolutionClientState(persister, storage, localTargetQueryProvider, wrapperContext) {
    this.nfg_1 = persister;
    this.ofg_1 = storage;
    this.pfg_1 = localTargetQueryProvider;
    this.qfg_1 = wrapperContext;
    var tmp = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp.rfg_1 = LinkedHashMap_init_$Create$();
    var tmp_0 = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp_0.sfg_1 = LinkedHashMap_init_$Create$();
    var tmp_1 = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp_1.tfg_1 = LinkedHashMap_init_$Create$();
    var tmp_2 = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp_2.ufg_1 = LinkedHashMap_init_$Create$();
    this.vfg_1 = new ListenersMap();
  }
  protoOf(LiveResolutionClientState).dfh = function (message) {
    if (message instanceof StateReceived_0) {
      restoreState(this, message.kfb_1);
    } else {
      if (message instanceof UpdateReceived_0) {
        updateState_0(this, message.nfb_1);
      } else {
        noWhenBranchMatchedException();
      }
    }
  };
  protoOf(LiveResolutionClientState).efh = function (source, tag, update) {
    if (update) {
      this.tfg_1.u2(source);
    }
    // Inline function 'kotlin.collections.getOrPut' call
    var this_0 = this.tfg_1;
    var value = this_0.q2(source);
    var tmp;
    if (value == null) {
      var answer = ensureNotNull(get_pointer(source));
      this_0.t2(source, answer);
      tmp = answer;
    } else {
      tmp = value;
    }
    var sourceLocation = tmp;
    return new SerializedReferenceLocation(sourceLocation, tag.y6l_1);
  };
  protoOf(LiveResolutionClientState).xfg = function (source, tag, stateProperty) {
    var location = this.efh(source, tag, !(stateProperty == null));
    if (stateProperty == null) {
      var tmp0_elvis_lhs = this.sfg_1.u2(location);
      var tmp;
      if (tmp0_elvis_lhs == null) {
        return Unit_instance;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var currentState = tmp;
      // Inline function 'kotlin.takeIf' call
      var this_0 = currentState.uv();
      var tmp_0;
      if (!equals(this_0, Companion_getInstance_308().wfg_1)) {
        tmp_0 = this_0;
      } else {
        tmp_0 = null;
      }
      var tmp1_elvis_lhs = tmp_0;
      var tmp_1;
      if (tmp1_elvis_lhs == null) {
        return Unit_instance;
      } else {
        tmp_1 = tmp1_elvis_lhs;
      }
      var currentValue = tmp_1;
      // Inline function 'kotlin.collections.set' call
      this.rfg_1.t2(location, currentValue);
    } else {
      // Inline function 'kotlin.collections.contains' call
      // Inline function 'kotlin.collections.containsKey' call
      var this_1 = this.sfg_1;
      // Inline function 'kotlin.require' call
      // Inline function 'kotlin.require' call
      if (!!(isInterface(this_1, KtMap) ? this_1 : THROW_CCE()).o2(location)) {
        var message = 'Failed requirement.';
        throw IllegalArgumentException_init_$Create$_0(toString_1(message));
      }
      var tmp2_elvis_lhs = this.rfg_1.u2(location);
      var currentValue_0 = tmp2_elvis_lhs == null ? Companion_getInstance_308().wfg_1 : tmp2_elvis_lhs;
      stateProperty.d2x(currentValue_0);
      // Inline function 'kotlin.collections.set' call
      this.sfg_1.t2(location, stateProperty);
    }
  };
  function LiveResolutionClient$slambda$slambda$slambda($messages, resultContinuation) {
    this.nfh_1 = $messages;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(LiveResolutionClient$slambda$slambda$slambda).pfh = function (it, $completion) {
    var tmp = this.qfh(it, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(LiveResolutionClient$slambda$slambda$slambda).v9 = function (p1, $completion) {
    return this.pfh(p1 instanceof NodeResolveInfoMessage ? p1 : THROW_CCE(), $completion);
  };
  protoOf(LiveResolutionClient$slambda$slambda$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.nfh_1.z15(new MessageReceived(this.ofh_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(LiveResolutionClient$slambda$slambda$slambda).qfh = function (it, completion) {
    var i = new LiveResolutionClient$slambda$slambda$slambda(this.nfh_1, completion);
    i.ofh_1 = it;
    return i;
  };
  function LiveResolutionClient$slambda$slambda$slambda_0($messages, resultContinuation) {
    var i = new LiveResolutionClient$slambda$slambda$slambda($messages, resultContinuation);
    var l = function (it, $completion) {
      return i.pfh(it, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function sam$kotlinx_coroutines_flow_FlowCollector$0_15(function_0) {
    this.rfh_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_15).x18 = function (value, $completion) {
    return this.rfh_1(value, $completion);
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_15).f3 = function () {
    return this.rfh_1;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_15).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, FlowCollector) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_15).hashCode = function () {
    return hashCode(this.f3());
  };
  function LiveResolutionClient$slambda$slambda($stateApplied, $completionServices, $messages, resultContinuation) {
    this.afi_1 = $stateApplied;
    this.bfi_1 = $completionServices;
    this.cfi_1 = $messages;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(LiveResolutionClient$slambda$slambda).efi = function (compound, $completion) {
    var tmp = this.ffi(compound, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(LiveResolutionClient$slambda$slambda).v9 = function (p1, $completion) {
    return this.efi(p1 instanceof NodeDerivedDataProvider ? p1 : THROW_CCE(), $completion);
  };
  protoOf(LiveResolutionClient$slambda$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.afi_1.r1f(false);
            this.bfi_1.r1f(this.dfi_1.gff_1.hfb_1);
            this.f9_1 = 1;
            var tmp_0 = LiveResolutionClient$slambda$slambda$slambda_0(this.cfi_1, null);
            suspendResult = this.dfi_1.gff_1.gfb_1.f18(new sam$kotlinx_coroutines_flow_FlowCollector$0_15(tmp_0), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(LiveResolutionClient$slambda$slambda).ffi = function (compound, completion) {
    var i = new LiveResolutionClient$slambda$slambda(this.afi_1, this.bfi_1, this.cfi_1, completion);
    i.dfi_1 = compound;
    return i;
  };
  function LiveResolutionClient$slambda$slambda_0($stateApplied, $completionServices, $messages, resultContinuation) {
    var i = new LiveResolutionClient$slambda$slambda($stateApplied, $completionServices, $messages, resultContinuation);
    var l = function (compound, $completion) {
      return i.efi(compound, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function LiveResolutionClient$slambda($providers, $messages, $stateApplied, $completionServices, resultContinuation) {
    this.ofi_1 = $providers;
    this.pfi_1 = $messages;
    this.qfi_1 = $stateApplied;
    this.rfi_1 = $completionServices;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(LiveResolutionClient$slambda).e1h = function ($this$launch, $completion) {
    var tmp = this.f1h($this$launch, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(LiveResolutionClient$slambda).v9 = function (p1, $completion) {
    return this.e1h((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(LiveResolutionClient$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 5;
            this.f9_1 = 1;
            continue $sm;
          case 1:
            this.g9_1 = 4;
            this.f9_1 = 2;
            suspendResult = collectLatest(this.ofi_1, LiveResolutionClient$slambda$slambda_0(this.qfi_1, this.rfi_1, this.pfi_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.g9_1 = 5;
            this.f9_1 = 3;
            continue $sm;
          case 3:
            this.g9_1 = 5;
            this.pfi_1.i16();
            return Unit_instance;
          case 4:
            this.g9_1 = 5;
            var t = this.i9_1;
            this.pfi_1.i16();
            throw t;
          case 5:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 5) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(LiveResolutionClient$slambda).f1h = function ($this$launch, completion) {
    var i = new LiveResolutionClient$slambda(this.ofi_1, this.pfi_1, this.qfi_1, this.rfi_1, completion);
    i.sfi_1 = $this$launch;
    return i;
  };
  function LiveResolutionClient$slambda_0($providers, $messages, $stateApplied, $completionServices, resultContinuation) {
    var i = new LiveResolutionClient$slambda($providers, $messages, $stateApplied, $completionServices, resultContinuation);
    var l = function ($this$launch, $completion) {
      return i.e1h($this$launch, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function LiveResolutionClient$slambda_1($rootHolder, $client, $wrapperContext, $persister, $nodeStorage, $messages, $stateApplied, resultContinuation) {
    this.bfj_1 = $rootHolder;
    this.cfj_1 = $client;
    this.dfj_1 = $wrapperContext;
    this.efj_1 = $persister;
    this.ffj_1 = $nodeStorage;
    this.gfj_1 = $messages;
    this.hfj_1 = $stateApplied;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(LiveResolutionClient$slambda_1).e1h = function ($this$launch, $completion) {
    var tmp = this.f1h($this$launch, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(LiveResolutionClient$slambda_1).v9 = function (p1, $completion) {
    return this.e1h((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(LiveResolutionClient$slambda_1).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 20;
            this.f9_1 = 1;
            suspendResult = awaitNotNull(this.bfj_1.u6z_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.pfj_1 = suspendResult;
            var _iterator__ex2g4s = this.pfj_1.f3o().m();
            while (_iterator__ex2g4s.n()) {
              var element = _iterator__ex2g4s.o();
              var tmp_0;
              if (this.cfj_1._v == null) {
                throwUninitializedPropertyAccessException('client');
              } else {
                tmp_0 = this.cfj_1._v;
              }
              activateStateReferences(tmp_0, this.dfj_1, element, true);
            }

            var tmp_1 = this;
            var tmp_2;
            if (this.cfj_1._v == null) {
              throwUninitializedPropertyAccessException('client');
            } else {
              tmp_2 = this.cfj_1._v;
            }

            tmp_1.qfj_1 = this.pfj_1.i3o(createReferenceActivatorNodeListener(tmp_2, this.dfj_1));
            this.f9_1 = 2;
            continue $sm;
          case 2:
            this.jfj_1 = this.qfj_1;
            this.f9_1 = 3;
            continue $sm;
          case 3:
            this.f9_1 = 4;
            continue $sm;
          case 4:
            this.g9_1 = 16;
            this.jfj_1;
            this.mfj_1 = new LiveResolutionClientState(this.efj_1, this.ffj_1, new FindNodeQueryProvider(this.pfj_1), this.dfj_1);
            var tmp_3 = this;
            tmp_3.ofj_1 = this.gfj_1;
            this.f9_1 = 5;
            continue $sm;
          case 5:
            this.lfj_1 = this.ofj_1;
            this.kfj_1 = null;
            this.f9_1 = 6;
            continue $sm;
          case 6:
            this.f9_1 = 7;
            continue $sm;
          case 7:
            this.g9_1 = 13;
            this.g9_1 = 12;
            this.nfj_1 = this.lfj_1.m();
            this.f9_1 = 8;
            continue $sm;
          case 8:
            this.f9_1 = 9;
            suspendResult = this.nfj_1.d14(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 9:
            if (!suspendResult) {
              this.f9_1 = 10;
              continue $sm;
            }

            var e = this.nfj_1.o();
            if (e instanceof MessageReceived) {
              this.mfj_1.dfh(e.ufj_1);
              var tmp_4 = e.ufj_1;
              if (tmp_4 instanceof StateReceived_0) {
                this.hfj_1.r1f(true);
              }
            } else {
              if (e instanceof ReferenceActivated) {
                this.mfj_1.xfg(e.rfj_1, e.sfj_1, e.tfj_1);
              } else {
                noWhenBranchMatchedException();
              }
            }

            this.f9_1 = 8;
            continue $sm;
          case 10:
            this.f9_1 = 11;
            continue $sm;
          case 11:
            this.g9_1 = 16;
            cancelConsumed(this.lfj_1, this.kfj_1);
            this.f9_1 = 15;
            continue $sm;
          case 12:
            this.g9_1 = 13;
            var tmp_5 = this.i9_1;
            if (tmp_5 instanceof Error) {
              var e_0 = this.i9_1;
              this.kfj_1 = e_0;
              throw e_0;
            } else {
              throw this.i9_1;
            }

          case 13:
            this.g9_1 = 16;
            var t = this.i9_1;
            cancelConsumed(this.lfj_1, this.kfj_1);
            throw t;
          case 14:
            this.g9_1 = 16;
            cancelConsumed(this.lfj_1, this.kfj_1);
            if (false) {
              this.f9_1 = 5;
              continue $sm;
            }

            this.f9_1 = 15;
            continue $sm;
          case 15:
            this.g9_1 = 20;
            this.f9_1 = 17;
            var tmp_6 = this;
            continue $sm;
          case 16:
            this.g9_1 = 20;
            var t_0 = this.i9_1;
            this.jfj_1.zr();
            throw t_0;
          case 17:
            this.g9_1 = 20;
            this.jfj_1.zr();
            this.f9_1 = 19;
            continue $sm;
          case 18:
            this.g9_1 = 20;
            this.jfj_1.zr();
            if (false) {
              this.f9_1 = 2;
              continue $sm;
            }

            this.f9_1 = 19;
            continue $sm;
          case 19:
            return Unit_instance;
          case 20:
            throw this.i9_1;
        }
      } catch ($p) {
        var e_1 = $p;
        if (this.g9_1 === 20) {
          throw e_1;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e_1;
        }
      }
     while (true);
  };
  protoOf(LiveResolutionClient$slambda_1).f1h = function ($this$launch, completion) {
    var i = new LiveResolutionClient$slambda_1(this.bfj_1, this.cfj_1, this.dfj_1, this.efj_1, this.ffj_1, this.gfj_1, this.hfj_1, completion);
    i.ifj_1 = $this$launch;
    return i;
  };
  function LiveResolutionClient$slambda_2($rootHolder, $client, $wrapperContext, $persister, $nodeStorage, $messages, $stateApplied, resultContinuation) {
    var i = new LiveResolutionClient$slambda_1($rootHolder, $client, $wrapperContext, $persister, $nodeStorage, $messages, $stateApplied, resultContinuation);
    var l = function ($this$launch, $completion) {
      return i.e1h($this$launch, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function createReferenceActivatorNodeListener$1($client, $wrapperContext) {
    this.vfj_1 = $client;
    this.wfj_1 = $wrapperContext;
  }
  protoOf(createReferenceActivatorNodeListener$1).b3o = function (node) {
    activateStateReferences(this.vfj_1, this.wfj_1, node, true);
  };
  protoOf(createReferenceActivatorNodeListener$1).c3o = function (node) {
    activateStateReferences(this.vfj_1, this.wfj_1, node, false);
  };
  function MessageReceived(message) {
    LiveResolutionClientMessage.call(this);
    this.ufj_1 = message;
  }
  protoOf(MessageReceived).toString = function () {
    return 'MessageReceived(message=' + toString_1(this.ufj_1) + ')';
  };
  protoOf(MessageReceived).hashCode = function () {
    return hashCode(this.ufj_1);
  };
  protoOf(MessageReceived).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof MessageReceived))
      return false;
    if (!equals(this.ufj_1, other.ufj_1))
      return false;
    return true;
  };
  function ReferenceActivated(source, tag, property) {
    LiveResolutionClientMessage.call(this);
    this.rfj_1 = source;
    this.sfj_1 = tag;
    this.tfj_1 = property;
  }
  protoOf(ReferenceActivated).toString = function () {
    return 'ReferenceActivated(source=' + toString_1(this.rfj_1) + ', tag=' + this.sfj_1.toString() + ', property=' + toString_0(this.tfj_1) + ')';
  };
  protoOf(ReferenceActivated).hashCode = function () {
    var result = hashCode(this.rfj_1);
    result = imul(result, 31) + this.sfj_1.hashCode() | 0;
    result = imul(result, 31) + (this.tfj_1 == null ? 0 : hashCode(this.tfj_1)) | 0;
    return result;
  };
  protoOf(ReferenceActivated).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ReferenceActivated))
      return false;
    if (!equals(this.rfj_1, other.rfj_1))
      return false;
    if (!this.sfj_1.equals(other.sfj_1))
      return false;
    if (!equals(this.tfj_1, other.tfj_1))
      return false;
    return true;
  };
  function LiveResolutionClientMessage() {
  }
  function sam$jetbrains_ocelot_langDef_references_ReferenceFactory$0_2(function_0) {
    this.xfj_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_langDef_references_ReferenceFactory$0_2).t6p = function (source, property) {
    return this.xfj_1(source, property);
  };
  protoOf(sam$jetbrains_ocelot_langDef_references_ReferenceFactory$0_2).f3 = function () {
    return this.xfj_1;
  };
  protoOf(sam$jetbrains_ocelot_langDef_references_ReferenceFactory$0_2).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, ReferenceFactory) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_langDef_references_ReferenceFactory$0_2).hashCode = function () {
    return hashCode(this.f3());
  };
  function LiveResolutionReference$Companion$factory$lambda(_unused_var__etf5q3, property) {
    return new LiveResolutionReference(property);
  }
  function $runSuspendCOROUTINE$_38(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.gfk_1 = _this__u8e3s4;
    this.hfk_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_38).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            var $this$suspendingQuery = this.hfk_1;
            var tmp_0 = this;
            tmp_0.ifk_1 = $this$suspendingQuery;
            this.f9_1 = 1;
            suspendResult = $this$suspendingQuery.k60(this.gfk_1.jfk_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp2 = suspendResult;
            return this.ifk_1.l60(tmp2.lfk_1);
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function $runSuspendCOROUTINE$_39(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.ufk_1 = _this__u8e3s4;
    this.vfk_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_39).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            var $this$suspendingQuery = this.vfk_1;
            var tmp_0 = this;
            tmp_0.wfk_1 = $this$suspendingQuery;
            this.f9_1 = 1;
            suspendResult = $this$suspendingQuery.k60(this.ufk_1.xfk_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp2 = suspendResult;
            return this.wfk_1.l60(tmp2.kfk_1);
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function Companion_307() {
  }
  protoOf(Companion_307).yfk = function () {
    var tmp = LiveResolutionReference$Companion$factory$lambda;
    return new sam$jetbrains_ocelot_langDef_references_ReferenceFactory$0_2(tmp);
  };
  var Companion_instance_307;
  function Companion_getInstance_307() {
    return Companion_instance_307;
  }
  function LiveResolutionReference$resolve$$inlined$flatMap$1($this) {
    this.jfk_1 = $this;
  }
  protoOf(LiveResolutionReference$resolve$$inlined$flatMap$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_38(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(LiveResolutionReference$resolve$$inlined$flatMap$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function LiveResolutionReference$find$$inlined$flatMap$1($this) {
    this.xfk_1 = $this;
  }
  protoOf(LiveResolutionReference$find$$inlined$flatMap$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_39(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(LiveResolutionReference$find$$inlined$flatMap$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function LiveResolutionReference(property) {
    PropertyBasedReference.call(this, property);
    this.mfg_1 = new ValueProperty(Companion_getInstance_308().wfg_1);
  }
  protoOf(LiveResolutionReference).w6o = function () {
    // Inline function 'jetbrains.ocelot.langDef.query.flatMap' call
    var this_0 = waitUntilNot(this.mfg_1, Companion_getInstance_308().wfg_1);
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new LiveResolutionReference$resolve$$inlined$flatMap$1(this_0);
  };
  protoOf(LiveResolutionReference).x6o = function () {
    // Inline function 'jetbrains.ocelot.langDef.query.flatMap' call
    var this_0 = waitUntilNot(this.mfg_1, Companion_getInstance_308().wfg_1);
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new LiveResolutionReference$find$$inlined$flatMap$1(this_0);
  };
  protoOf(LiveResolutionReference).d2x = function (newValue) {
    return this.b6p((newValue == null ? true : newValue instanceof ReferenceContent) ? newValue : THROW_CCE());
  };
  protoOf(LiveResolutionReference).r5w = function (builder, $completion) {
    return this.e6p(builder, $completion);
  };
  function LiveResolutionReferenceValue$Companion$MISSING$lambda(it) {
    return constant(null);
  }
  function Companion_308() {
    Companion_instance_308 = this;
    var tmp = this;
    tmp.wfg_1 = new LiveResolutionReferenceValue(null, null, LiveResolutionReferenceValue$Companion$MISSING$lambda);
  }
  var Companion_instance_308;
  function Companion_getInstance_308() {
    if (Companion_instance_308 == null)
      new Companion_308();
    return Companion_instance_308;
  }
  function LiveResolutionReferenceValue(resolveResultPointer, findResultPointer, targetQuery) {
    Companion_getInstance_308();
    var tmp = this;
    var tmp_0;
    if (findResultPointer == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_0 = targetQuery(findResultPointer);
    }
    var tmp1_elvis_lhs = tmp_0;
    tmp.kfk_1 = tmp1_elvis_lhs == null ? Companion_getInstance_81().g60_1 : tmp1_elvis_lhs;
    var tmp_1 = this;
    var tmp_2;
    if (resolveResultPointer == null) {
      tmp_2 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_2 = targetQuery(resolveResultPointer);
    }
    var tmp1_elvis_lhs_0 = tmp_2;
    tmp_1.lfk_1 = tmp1_elvis_lhs_0 == null ? Companion_getInstance_81().g60_1 : tmp1_elvis_lhs_0;
  }
  function remote(_this__u8e3s4, tags) {
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = tags.m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      _this__u8e3s4.j6t(element, Companion_instance_307.yfk());
    }
  }
  function RemoteReferenceTargetsSupplier$getElements$slambda$slambda($this_flow, this$0, resultContinuation) {
    this.hfl_1 = $this_flow;
    this.ifl_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(RemoteReferenceTargetsSupplier$getElements$slambda$slambda).lfl = function (it, $completion) {
    var tmp = this.mfl(it, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(RemoteReferenceTargetsSupplier$getElements$slambda$slambda).v9 = function (p1, $completion) {
    return this.lfl(p1 instanceof ReferenceTargetsBatch ? p1 : THROW_CCE(), $completion);
  };
  protoOf(RemoteReferenceTargetsSupplier$getElements$slambda$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 4;
            this.kfl_1 = this.jfl_1.mfc_1.m();
            this.f9_1 = 1;
            continue $sm;
          case 1:
            if (!this.kfl_1.n()) {
              this.f9_1 = 3;
              continue $sm;
            }

            var element = this.kfl_1.o();
            this.f9_1 = 2;
            suspendResult = this.hfl_1.x18(new ReferenceTargetItem(cast(this.ifl_1.nfl_1.x6l_1, element.qfc_1), element.rfc_1, element.sfc_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.f9_1 = 1;
            continue $sm;
          case 3:
            return Unit_instance;
          case 4:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 4) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(RemoteReferenceTargetsSupplier$getElements$slambda$slambda).mfl = function (it, completion) {
    var i = new RemoteReferenceTargetsSupplier$getElements$slambda$slambda(this.hfl_1, this.ifl_1, completion);
    i.jfl_1 = it;
    return i;
  };
  function RemoteReferenceTargetsSupplier$getElements$slambda$slambda_0($this_flow, this$0, resultContinuation) {
    var i = new RemoteReferenceTargetsSupplier$getElements$slambda$slambda($this_flow, this$0, resultContinuation);
    var l = function (it, $completion) {
      return i.lfl(it, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function serializedLink($this, _this__u8e3s4) {
    var tmp;
    if (_this__u8e3s4 instanceof SourceNodeContext) {
      tmp = Companion_getInstance_111().x6v_1;
    } else {
      if (_this__u8e3s4 instanceof EnclosingNodeContext) {
        tmp = persistLink($this, _this__u8e3s4);
      } else {
        noWhenBranchMatchedException();
      }
    }
    return tmp;
  }
  function persistLink($this, _this__u8e3s4) {
    var tmp0_elvis_lhs = _this__u8e3s4.g6p_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Companion_getInstance_111().x6v_1;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var link = tmp;
    return new SerializedChildLink($this.ofl_1.f6h(_this__u8e3s4.f6p_1, link));
  }
  function sam$kotlinx_coroutines_flow_FlowCollector$0_16(function_0) {
    this.qfl_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_16).x18 = function (value, $completion) {
    return this.qfl_1(value, $completion);
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_16).f3 = function () {
    return this.qfl_1;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_16).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, FlowCollector) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_16).hashCode = function () {
    return hashCode(this.f3());
  };
  function RemoteReferenceTargetsSupplier$getElements$slambda($context, this$0, $filter, resultContinuation) {
    this.zfl_1 = $context;
    this.afm_1 = this$0;
    this.bfm_1 = $filter;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(RemoteReferenceTargetsSupplier$getElements$slambda).dfm = function ($this$flow, $completion) {
    var tmp = this.efm($this$flow, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(RemoteReferenceTargetsSupplier$getElements$slambda).v9 = function (p1, $completion) {
    return this.dfm((!(p1 == null) ? isInterface(p1, FlowCollector) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(RemoteReferenceTargetsSupplier$getElements$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            var tmp_0 = this.zfl_1;
            var tmp0_safe_receiver = tmp_0 instanceof EnclosingNodeContext ? tmp_0 : null;
            var tmp_1 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.f6p_1;
            var enclosing = (!(tmp_1 == null) ? isInterface(tmp_1, DomainNode) : false) ? tmp_1 : null;
            var tmp_2 = this.zfl_1;
            var tmp1_safe_receiver = tmp_2 instanceof SourceNodeContext ? tmp_2 : null;
            var source = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.i6p_1;
            this.f9_1 = 1;
            var tmp_3 = enclosing == null ? null : get_pointer(enclosing);
            var tmp_4 = serializedLink(this.afm_1, this.zfl_1);
            var tmp_5 = this.afm_1.pfl_1.cfc(this.afm_1.nfl_1.y6l_1, tmp_3, tmp_4, source == null ? null : get_pointer(source), this.bfm_1);
            var tmp_6 = RemoteReferenceTargetsSupplier$getElements$slambda$slambda_0(this.cfm_1, this.afm_1, null);
            suspendResult = tmp_5.f18(new sam$kotlinx_coroutines_flow_FlowCollector$0_16(tmp_6), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(RemoteReferenceTargetsSupplier$getElements$slambda).efm = function ($this$flow, completion) {
    var i = new RemoteReferenceTargetsSupplier$getElements$slambda(this.zfl_1, this.afm_1, this.bfm_1, completion);
    i.cfm_1 = $this$flow;
    return i;
  };
  function RemoteReferenceTargetsSupplier$getElements$slambda_0($context, this$0, $filter, resultContinuation) {
    var i = new RemoteReferenceTargetsSupplier$getElements$slambda($context, this$0, $filter, resultContinuation);
    var l = function ($this$flow, $completion) {
      return i.dfm($this$flow, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function RemoteReferenceTargetsSupplier(tag, persister, completionService) {
    this.nfl_1 = tag;
    this.ofl_1 = persister;
    this.pfl_1 = completionService;
  }
  protoOf(RemoteReferenceTargetsSupplier).o6q = function (context, filter) {
    return flow(RemoteReferenceTargetsSupplier$getElements$slambda_0(context, this, filter, null));
  };
  function remote_0(_this__u8e3s4, tags) {
    var serializationConfig = Companion_instance_110.e3b(_this__u8e3s4);
    var derivedDataService = Companion_instance_310.e3b(_this__u8e3s4);
    var coroutineScope = CoroutineScope_0(CoroutineContextService_getInstance().e3b(_this__u8e3s4));
    var client = LiveResolutionClient_0(coroutineScope, serializationConfig.q6v(getKClass(DomainNode)), Companion_getInstance_89().e3b(_this__u8e3s4).r6g_1, WrapperContextService_instance.e3b(_this__u8e3s4), derivedDataService.ffg_1, Companion_getInstance_117().e3b(_this__u8e3s4));
    launch(coroutineScope, VOID, VOID, remote$slambda_0(client, derivedDataService, null));
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = tags.m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      remoteReferenceTargetsSupplier(_this__u8e3s4, element, serializationConfig, client);
    }
  }
  function remoteReferenceTargetsSupplier(_this__u8e3s4, tag, serializationConfig, referenceCompletionService) {
    var tmp = serializationConfig.q6v(getKClass(DomainNode));
    var referenceTargetsSupplier = new RemoteReferenceTargetsSupplier(tag, isInterface(tmp, NodePersister) ? tmp : THROW_CCE(), referenceCompletionService);
    _this__u8e3s4.b6u(tag, referenceTargetsSupplier);
  }
  function sam$kotlinx_coroutines_flow_FlowCollector$0_17(function_0) {
    this.ffm_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_17).x18 = function (value, $completion) {
    return this.ffm_1(value, $completion);
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_17).f3 = function () {
    return this.ffm_1;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_17).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, FlowCollector) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_17).hashCode = function () {
    return hashCode(this.f3());
  };
  function remote$slambda$slambda($derivedDataService, resultContinuation) {
    this.ofm_1 = $derivedDataService;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(remote$slambda$slambda).qfm = function (it, $completion) {
    var tmp = this.rfm(it, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(remote$slambda$slambda).v9 = function (p1, $completion) {
    return this.qfm((!(p1 == null) ? typeof p1 === 'boolean' : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(remote$slambda$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        if (tmp === 0) {
          this.g9_1 = 1;
          this.ofm_1.gfg_1.r1f(this.pfm_1);
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(remote$slambda$slambda).rfm = function (it, completion) {
    var i = new remote$slambda$slambda(this.ofm_1, completion);
    i.pfm_1 = it;
    return i;
  };
  function remote$slambda$slambda_0($derivedDataService, resultContinuation) {
    var i = new remote$slambda$slambda($derivedDataService, resultContinuation);
    var l = function (it, $completion) {
      return i.qfm(it, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function remote$slambda($client, $derivedDataService, resultContinuation) {
    this.afn_1 = $client;
    this.bfn_1 = $derivedDataService;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(remote$slambda).e1h = function ($this$launch, $completion) {
    var tmp = this.f1h($this$launch, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(remote$slambda).v9 = function (p1, $completion) {
    return this.e1h((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(remote$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            var tmp_0 = remote$slambda$slambda_0(this.bfn_1, null);
            suspendResult = this.afn_1.jfg_1.f1d(new sam$kotlinx_coroutines_flow_FlowCollector$0_17(tmp_0), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            throwKotlinNothingValueException();
            break;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(remote$slambda).f1h = function ($this$launch, completion) {
    var i = new remote$slambda(this.afn_1, this.bfn_1, completion);
    i.cfn_1 = $this$launch;
    return i;
  };
  function remote$slambda_0($client, $derivedDataService, resultContinuation) {
    var i = new remote$slambda($client, $derivedDataService, resultContinuation);
    var l = function ($this$launch, $completion) {
      return i.e1h($this$launch, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function precalculated(_this__u8e3s4, tags) {
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = tags.m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      _this__u8e3s4.j6t(element, Companion_instance_96.w6p());
    }
  }
  function _get_targets__run9lb($this) {
    var tmp0 = $this.ifn_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('targets', 1, tmp, PrecalculatedResolutionService$_get_targets_$ref_vyz8qq(), null);
    return tmp0.a1();
  }
  function setReferences($this, node) {
    var references = (isInterface(node, TypedOtNode) ? node : THROW_CCE()).b6j();
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s = references.y().m();
    while (_iterator__ex2g4s.n()) {
      var _destruct__k2r9zo = _iterator__ex2g4s.o();
      // Inline function 'kotlin.collections.component1' call
      var tag = _destruct__k2r9zo.z();
      // Inline function 'kotlin.collections.component2' call
      var reference = _destruct__k2r9zo.a1();
      // Inline function 'kotlin.check' call
      if (!(reference instanceof PrecalculatedResolutionReference)) {
        throw IllegalStateException_init_$Create$_0('Check failed.');
      }
      var location = new SerializedReferenceLocation(ensureNotNull(get_pointer(node)), tag.y6l_1);
      var tmp0_elvis_lhs = $this.hfn_1.q2(location);
      var value = tmp0_elvis_lhs == null ? Companion_getInstance_293().afb_1 : tmp0_elvis_lhs;
      var resolveResult = findTarget_0($this, tag.w6l_1, value.dfb_1);
      var tmp;
      if (!(value.efb_1 == null)) {
        tmp = findTarget_0($this, tag.w6l_1, value.efb_1);
      } else {
        tmp = resolveResult;
      }
      var findResult = tmp;
      reference.c6q_1.d2x(new PrecalculatedResolutionReferenceValue(resolveResult, findResult));
    }
    var _iterator__ex2g4s_0 = node.h6j().m();
    while (_iterator__ex2g4s_0.n()) {
      var childNode = _iterator__ex2g4s_0.o();
      setReferences($this, childNode);
    }
  }
  function findTarget_0($this, kClass, pointer) {
    var tmp;
    if (pointer == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      var tmp0_elvis_lhs = _get_targets__run9lb($this).q2(pointer);
      var target = tmp0_elvis_lhs == null ? findLocalTarget_0($this, pointer) : tmp0_elvis_lhs;
      // Inline function 'kotlin.checkNotNull' call
      $l$block: {
        // Inline function 'kotlin.checkNotNull' call
        if (target == null) {
          var message = 'Required value was null.';
          throw IllegalStateException_init_$Create$_0(toString_1(message));
        } else {
          break $l$block;
        }
      }
      var tmp1_elvis_lhs = safeCast(kClass, target);
      var tmp_0;
      if (tmp1_elvis_lhs == null) {
        var message_0 = 'Target ' + toString_1(target) + ' cannot be cast to ' + toString_1(kClass);
        throw IllegalStateException_init_$Create$_0(toString_1(message_0));
      } else {
        tmp_0 = tmp1_elvis_lhs;
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  function findLocalTarget_0($this, pointer) {
    var tmp0_elvis_lhs = $this.ffn_1.u6z_1.uv();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var model = tmp;
    var tmp1_elvis_lhs = model.g3o(pointer.nodeId);
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      return null;
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    var otNode = tmp_0;
    return toDomainNode(otNode, $this.gfn_1);
  }
  function Companion_309() {
  }
  var Companion_instance_309;
  function Companion_getInstance_309() {
    return Companion_instance_309;
  }
  function PrecalculatedResolutionService$targets$delegate$lambda($resolveInfo, this$0) {
    return function () {
      // Inline function 'kotlin.collections.associate' call
      var this_0 = $resolveInfo.qfa_1;
      var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
      // Inline function 'kotlin.collections.associateTo' call
      var destination = LinkedHashMap_init_$Create$_0(capacity);
      var _iterator__ex2g4s = this_0.m();
      while (_iterator__ex2g4s.n()) {
        var element = _iterator__ex2g4s.o();
        var node = this$0.efn_1.p25(element.content);
        this$0.dfn_1.u6f(element.pointer, node);
        // Inline function 'kotlin.collections.plusAssign' call
        var pair = to(element.pointer, node);
        destination.t2(pair.pg_1, pair.qg_1);
      }
      return destination;
    };
  }
  function PrecalculatedResolutionService$_get_targets_$ref_vyz8qq() {
    return function (p0) {
      return _get_targets__run9lb(p0);
    };
  }
  function PrecalculatedResolutionService(nodeStorage, persister, rootHolder, wrapperContext, resolveInfo) {
    this.dfn_1 = nodeStorage;
    this.efn_1 = persister;
    this.ffn_1 = rootHolder;
    this.gfn_1 = wrapperContext;
    var tmp = this;
    // Inline function 'kotlin.collections.associate' call
    var this_0 = resolveInfo.rfa_1;
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
    // Inline function 'kotlin.collections.associateTo' call
    var destination = LinkedHashMap_init_$Create$_0(capacity);
    var _iterator__ex2g4s = this_0.m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      // Inline function 'kotlin.collections.plusAssign' call
      var pair = to(element.ufa_1, element.vfa_1);
      destination.t2(pair.pg_1, pair.qg_1);
    }
    tmp.hfn_1 = destination;
    var tmp_0 = this;
    tmp_0.ifn_1 = lazy(PrecalculatedResolutionService$targets$delegate$lambda(resolveInfo, this));
  }
  protoOf(PrecalculatedResolutionService).jfn = function () {
    var tmp0_elvis_lhs = this.ffn_1.u6z_1.uv();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var model = tmp;
    var rootNode = toDomainNode(model.k3e_1, this.gfn_1);
    setReferences(this, rootNode);
    var _iterator__ex2g4s = _get_targets__run9lb(this).s2().m();
    while (_iterator__ex2g4s.n()) {
      var node = _iterator__ex2g4s.o();
      setReferences(this, node);
    }
  };
  function precalculatedResolutionService(resolveInfo) {
    var tmp = Companion_instance_41;
    var tmp_0 = [Companion_instance_309];
    return tmp.m3b(tmp_0, VOID, precalculatedResolutionService$lambda(resolveInfo));
  }
  function precalculatedResolutionService$lambda($resolveInfo) {
    return function (it) {
      return new PrecalculatedResolutionService(Companion_getInstance_89().e3b(it).r6g_1, Companion_instance_110.e3b(it).q6v(getKClass(DomainNode)), Companion_getInstance_117().e3b(it), WrapperContextService_instance.e3b(it), $resolveInfo);
    };
  }
  function get_LOG_5() {
    _init_properties_LiveDerivedDataService_kt__84mg5i();
    return LOG_5;
  }
  var LOG_5;
  function Companion_310() {
  }
  var Companion_instance_310;
  function Companion_getInstance_310() {
    return Companion_instance_310;
  }
  function LiveDerivedDataService(providers, resolutionReady) {
    this.ffg_1 = providers;
    this.gfg_1 = resolutionReady;
  }
  function LiveDerivedDataService_0(_this__u8e3s4, providers) {
    _init_properties_LiveDerivedDataService_kt__84mg5i();
    var sharedProviders = shareIn(providers, _this__u8e3s4, Companion_getInstance_23().q1d_1, 1);
    var compoundProviders = MutableSharedFlow(1);
    var resolutionReady = MutableStateFlow(false);
    launch(_this__u8e3s4, VOID, VOID, LiveDerivedDataService$slambda_0(sharedProviders, resolutionReady, compoundProviders, null));
    return new LiveDerivedDataService(compoundProviders, resolutionReady);
  }
  function LOG$lambda_5() {
    _init_properties_LiveDerivedDataService_kt__84mg5i();
    return Unit_instance;
  }
  function LiveDerivedDataService$slambda$slambda$slambda$lambda() {
    return 'Potential memory leak. Received node error info from server but no consumer is subscribed. Did you forget to configure remoteErrorCheck()?';
  }
  function LiveDerivedDataService$slambda$slambda$slambda($errorSubscribed, resultContinuation) {
    this.sfn_1 = $errorSubscribed;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(LiveDerivedDataService$slambda$slambda$slambda).ufn = function ($this$onStart, $completion) {
    var tmp = this.vfn($this$onStart, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(LiveDerivedDataService$slambda$slambda$slambda).v9 = function (p1, $completion) {
    return this.ufn((!(p1 == null) ? isInterface(p1, FlowCollector) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(LiveDerivedDataService$slambda$slambda$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        if (tmp === 0) {
          this.g9_1 = 1;
          this.sfn_1._v = true;
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(LiveDerivedDataService$slambda$slambda$slambda).vfn = function ($this$onStart, completion) {
    var i = new LiveDerivedDataService$slambda$slambda$slambda(this.sfn_1, completion);
    i.tfn_1 = $this$onStart;
    return i;
  };
  function LiveDerivedDataService$slambda$slambda$slambda_0($errorSubscribed, resultContinuation) {
    var i = new LiveDerivedDataService$slambda$slambda$slambda($errorSubscribed, resultContinuation);
    var l = function ($this$onStart, $completion) {
      return i.ufn($this$onStart, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function LiveDerivedDataService$slambda$slambda$slambda_1($resolutionMessages, $firstErrorSeen, $errorSubscribed, $errorMessages, resultContinuation) {
    this.efo_1 = $resolutionMessages;
    this.ffo_1 = $firstErrorSeen;
    this.gfo_1 = $errorSubscribed;
    this.hfo_1 = $errorMessages;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(LiveDerivedDataService$slambda$slambda$slambda_1).jfo = function (msg, $completion) {
    var tmp = this.kfo(msg, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(LiveDerivedDataService$slambda$slambda$slambda_1).v9 = function (p1, $completion) {
    return this.jfo(p1 instanceof DerivedDataMessage ? p1 : THROW_CCE(), $completion);
  };
  protoOf(LiveDerivedDataService$slambda$slambda$slambda_1).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 4;
            var tmp0_subject = this.ifo_1;
            if (tmp0_subject instanceof Resolution) {
              this.f9_1 = 2;
              suspendResult = this.efo_1.z15(this.ifo_1.afd_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              if (tmp0_subject instanceof Error_2) {
                if (!this.ffo_1._v) {
                  this.ffo_1._v = true;
                  if (!this.gfo_1._v) {
                    var tmp_0 = get_LOG_5();
                    tmp_0.c2q(LiveDerivedDataService$slambda$slambda$slambda$lambda);
                  }
                }
                this.f9_1 = 1;
                suspendResult = this.hfo_1.z15(this.ifo_1.efd_1, this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                noWhenBranchMatchedException();
              }
            }

            break;
          case 1:
            this.f9_1 = 3;
            continue $sm;
          case 2:
            this.f9_1 = 3;
            continue $sm;
          case 3:
            return Unit_instance;
          case 4:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 4) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(LiveDerivedDataService$slambda$slambda$slambda_1).kfo = function (msg, completion) {
    var i = new LiveDerivedDataService$slambda$slambda$slambda_1(this.efo_1, this.ffo_1, this.gfo_1, this.hfo_1, completion);
    i.ifo_1 = msg;
    return i;
  };
  function LiveDerivedDataService$slambda$slambda$slambda_2($resolutionMessages, $firstErrorSeen, $errorSubscribed, $errorMessages, resultContinuation) {
    var i = new LiveDerivedDataService$slambda$slambda$slambda_1($resolutionMessages, $firstErrorSeen, $errorSubscribed, $errorMessages, resultContinuation);
    var l = function (msg, $completion) {
      return i.jfo(msg, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function sam$kotlinx_coroutines_flow_FlowCollector$0_18(function_0) {
    this.lfo_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_18).x18 = function (value, $completion) {
    return this.lfo_1(value, $completion);
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_18).f3 = function () {
    return this.lfo_1;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_18).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, FlowCollector) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_18).hashCode = function () {
    return hashCode(this.f3());
  };
  function LiveDerivedDataService$slambda$slambda($resolutionReady, $compoundProviders, resultContinuation) {
    this.ufo_1 = $resolutionReady;
    this.vfo_1 = $compoundProviders;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(LiveDerivedDataService$slambda$slambda).bfp = function (derivedProvider, $completion) {
    var tmp = this.cfp(derivedProvider, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(LiveDerivedDataService$slambda$slambda).v9 = function (p1, $completion) {
    return this.bfp(p1 instanceof DerivedDataProvider ? p1 : THROW_CCE(), $completion);
  };
  protoOf(LiveDerivedDataService$slambda$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 6;
            this.ufo_1.r1f(false);
            this.yfo_1 = Channel(2147483647);
            this.xfo_1 = Channel(2147483647);
            this.zfo_1 = {_v: false};
            this.f9_1 = 1;
            var tmp_0 = new NodeResolutionProvider(consumeAsFlow(this.yfo_1), this.wfo_1.wfd_1);
            var tmp_1 = consumeAsFlow(this.xfo_1);
            suspendResult = this.vfo_1.x18(new NodeDerivedDataProvider(tmp_0, new NodeErrorProvider(onStart(tmp_1, LiveDerivedDataService$slambda$slambda$slambda_0(this.zfo_1, null)))), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.afp_1 = {_v: false};
            this.f9_1 = 2;
            continue $sm;
          case 2:
            this.g9_1 = 5;
            this.f9_1 = 3;
            var tmp_2 = LiveDerivedDataService$slambda$slambda$slambda_2(this.yfo_1, this.afp_1, this.zfo_1, this.xfo_1, null);
            suspendResult = this.wfo_1.vfd_1.f18(new sam$kotlinx_coroutines_flow_FlowCollector$0_18(tmp_2), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            this.g9_1 = 6;
            this.f9_1 = 4;
            continue $sm;
          case 4:
            this.g9_1 = 6;
            this.yfo_1.i16();
            this.xfo_1.i16();
            return Unit_instance;
          case 5:
            this.g9_1 = 6;
            var t = this.i9_1;
            this.yfo_1.i16();
            this.xfo_1.i16();
            throw t;
          case 6:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 6) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(LiveDerivedDataService$slambda$slambda).cfp = function (derivedProvider, completion) {
    var i = new LiveDerivedDataService$slambda$slambda(this.ufo_1, this.vfo_1, completion);
    i.wfo_1 = derivedProvider;
    return i;
  };
  function LiveDerivedDataService$slambda$slambda_0($resolutionReady, $compoundProviders, resultContinuation) {
    var i = new LiveDerivedDataService$slambda$slambda($resolutionReady, $compoundProviders, resultContinuation);
    var l = function (derivedProvider, $completion) {
      return i.bfp(derivedProvider, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function LiveDerivedDataService$slambda($sharedProviders, $resolutionReady, $compoundProviders, resultContinuation) {
    this.lfp_1 = $sharedProviders;
    this.mfp_1 = $resolutionReady;
    this.nfp_1 = $compoundProviders;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(LiveDerivedDataService$slambda).e1h = function ($this$launch, $completion) {
    var tmp = this.f1h($this$launch, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(LiveDerivedDataService$slambda).v9 = function (p1, $completion) {
    return this.e1h((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(LiveDerivedDataService$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = collectLatest(this.lfp_1, LiveDerivedDataService$slambda$slambda_0(this.mfp_1, this.nfp_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(LiveDerivedDataService$slambda).f1h = function ($this$launch, completion) {
    var i = new LiveDerivedDataService$slambda(this.lfp_1, this.mfp_1, this.nfp_1, completion);
    i.ofp_1 = $this$launch;
    return i;
  };
  function LiveDerivedDataService$slambda_0($sharedProviders, $resolutionReady, $compoundProviders, resultContinuation) {
    var i = new LiveDerivedDataService$slambda($sharedProviders, $resolutionReady, $compoundProviders, resultContinuation);
    var l = function ($this$launch, $completion) {
      return i.e1h($this$launch, $completion);
    };
    l.$arity = 1;
    return l;
  }
  var properties_initialized_LiveDerivedDataService_kt_xngc84;
  function _init_properties_LiveDerivedDataService_kt__84mg5i() {
    if (!properties_initialized_LiveDerivedDataService_kt_xngc84) {
      properties_initialized_LiveDerivedDataService_kt_xngc84 = true;
      var tmp = KotlinLogging_getInstance();
      LOG_5 = tmp.i2q(LOG$lambda_5);
    }
  }
  function NodeDerivedDataProvider(resolution, errors) {
    this.gff_1 = resolution;
    this.hff_1 = errors;
  }
  protoOf(NodeDerivedDataProvider).toString = function () {
    return 'NodeDerivedDataProvider(resolution=' + this.gff_1.toString() + ', errors=' + this.hff_1.toString() + ')';
  };
  protoOf(NodeDerivedDataProvider).hashCode = function () {
    var result = this.gff_1.hashCode();
    result = imul(result, 31) + this.hff_1.hashCode() | 0;
    return result;
  };
  protoOf(NodeDerivedDataProvider).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof NodeDerivedDataProvider))
      return false;
    if (!this.gff_1.equals(other.gff_1))
      return false;
    if (!this.hff_1.equals(other.hff_1))
      return false;
    return true;
  };
  function BioKbOtStructureRuntime() {
  }
  protoOf(BioKbOtStructureRuntime).pfp = function (_this__u8e3s4) {
    btbConceptRegistry(_this__u8e3s4);
  };
  function Context_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ContextConcept_getInstance().m6n_1) : nodeId;
    return Context_1(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function OntologyLibraryReference(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(OntologyLibraryReferenceConcept_getInstance().m6n_1) : nodeId;
    return OntologyLibraryReference_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function OntologyElementReference(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(OntologyElementReferenceConcept_getInstance().m6n_1) : nodeId;
    return OntologyElementReference_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function Category(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(CategoryConcept_getInstance().m6n_1) : nodeId;
    return Category_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function OntologyImportRootReference(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(OntologyImportRootReferenceConcept_getInstance().m6n_1) : nodeId;
    return OntologyImportRootReference_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function TypePlaceholder(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(TypePlaceholderConcept_getInstance().m6n_1) : nodeId;
    return TypePlaceholder_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function OntologyElementType(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(OntologyElementTypeConcept_getInstance().m6n_1) : nodeId;
    return OntologyElementType_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function ProcessType(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ProcessTypeConcept_getInstance().m6n_1) : nodeId;
    return ProcessType_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function LibraryProcessSpecification(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(LibraryProcessSpecificationConcept_getInstance().m6n_1) : nodeId;
    return LibraryProcessSpecification_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function OneOf(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(OneOfConcept_getInstance().m6n_1) : nodeId;
    return OneOf_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function PropertyReferenceOperation(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(PropertyReferenceOperationConcept_getInstance().m6n_1) : nodeId;
    return PropertyReferenceOperation_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function SetValuedPropertyParameter(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(SetValuedPropertyParameterConcept_getInstance().m6n_1) : nodeId;
    return SetValuedPropertyParameter_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function IsExpression(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(IsExpressionConcept_getInstance().m6n_1) : nodeId;
    return IsExpression_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function ClassExpressionPlaceholder(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ClassExpressionPlaceholderConcept_getInstance().m6n_1) : nodeId;
    return ClassExpressionPlaceholder_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function QualifiedOntologyElementReference(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(QualifiedOntologyElementReferenceConcept_getInstance().m6n_1) : nodeId;
    return QualifiedOntologyElementReference_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function UnionClass(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(UnionClassConcept_getInstance().m6n_1) : nodeId;
    return UnionClass_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function VariableDeclaration(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(VariableDeclarationConcept_getInstance().m6n_1) : nodeId;
    return VariableDeclaration_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function FunctionTerm(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(FunctionTermConcept_getInstance().m6n_1) : nodeId;
    return FunctionTerm_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function MeasurableValue(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(MeasurableValueConcept_getInstance().m6n_1) : nodeId;
    return MeasurableValue_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function EnumValue(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(EnumValueConcept_getInstance().m6n_1) : nodeId;
    return EnumValue_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function StringValue(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(StringValueConcept_getInstance().m6n_1) : nodeId;
    return StringValue_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function IntegerValue(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(IntegerValueConcept_getInstance().m6n_1) : nodeId;
    return IntegerValue_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function VariableReferenceValue(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(VariableReferenceValueConcept_getInstance().m6n_1) : nodeId;
    return VariableReferenceValue_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function SetExpression(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(SetExpressionConcept_getInstance().m6n_1) : nodeId;
    return SetExpression_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function OntologyElementReferenceValueLibrary(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(OntologyElementReferenceValueLibraryConcept_getInstance().m6n_1) : nodeId;
    return OntologyElementReferenceValueLibrary_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function OntologyElementReferenceValue(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(OntologyElementReferenceValueConcept_getInstance().m6n_1) : nodeId;
    return OntologyElementReferenceValue_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function ComplexNotionValue(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ComplexNotionValueConcept_getInstance().m6n_1) : nodeId;
    return ComplexNotionValue_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function ComplexNotionElementValue(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ComplexNotionElementValueConcept_getInstance().m6n_1) : nodeId;
    return ComplexNotionElementValue_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function UnknownComplexNotionValue(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(UnknownComplexNotionValueConcept_getInstance().m6n_1) : nodeId;
    return UnknownComplexNotionValue_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function ConstantCustomCell(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ConstantCustomCellConcept_getInstance().m6n_1) : nodeId;
    return ConstantCustomCell_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function ProcessPropertyCustomCell(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ProcessPropertyCustomCellConcept_getInstance().m6n_1) : nodeId;
    return ProcessPropertyCustomCell_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function PropertyCustomCell(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(PropertyCustomCellConcept_getInstance().m6n_1) : nodeId;
    return PropertyCustomCell_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function LinkCustomCell(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(LinkCustomCellConcept_getInstance().m6n_1) : nodeId;
    return LinkCustomCell_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function KindCustomCell(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(KindCustomCellConcept_getInstance().m6n_1) : nodeId;
    return KindCustomCell_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function ReturnTypeCustomCell(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ReturnTypeCustomCellConcept_getInstance().m6n_1) : nodeId;
    return ReturnTypeCustomCell_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function CardinalityCustomCell(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(CardinalityCustomCellConcept_getInstance().m6n_1) : nodeId;
    return CardinalityCustomCell_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function DeclarationNameCustomCell(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(DeclarationNameCustomCellConcept_getInstance().m6n_1) : nodeId;
    return DeclarationNameCustomCell_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function PropertiesCustomCell(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(PropertiesCustomCellConcept_getInstance().m6n_1) : nodeId;
    return PropertiesCustomCell_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function FieldDeclaration(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(FieldDeclarationConcept_getInstance().m6n_1) : nodeId;
    return FieldDeclaration_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function FactPrecondition(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(FactPreconditionConcept_getInstance().m6n_1) : nodeId;
    return FactPrecondition_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function Cardinality(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(CardinalityConcept_getInstance().m6n_1) : nodeId;
    return Cardinality_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function CardinalityBoundN(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(CardinalityBoundNConcept_getInstance().m6n_1) : nodeId;
    return CardinalityBoundN_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function CardinalityBoundPlaceholder(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(CardinalityBoundPlaceholderConcept_getInstance().m6n_1) : nodeId;
    return CardinalityBoundPlaceholder_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function CardinalityBoundConstant(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(CardinalityBoundConstantConcept_getInstance().m6n_1) : nodeId;
    return CardinalityBoundConstant_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function KnowledgeSourceReferencePlaceholder(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(KnowledgeSourceReferencePlaceholderConcept_getInstance().m6n_1) : nodeId;
    return KnowledgeSourceReferencePlaceholder_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function Page(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(PageConcept_getInstance().m6n_1) : nodeId;
    return Page_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function Author(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(AuthorConcept_getInstance().m6n_1) : nodeId;
    return Author_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function LibraryItemPlaceholder(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(LibraryItemPlaceholderConcept_getInstance().m6n_1) : nodeId;
    return LibraryItemPlaceholder_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function UrlKnowledgeSourceReference(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(UrlKnowledgeSourceReferenceConcept_getInstance().m6n_1) : nodeId;
    return UrlKnowledgeSourceReference_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function PubMedSourceReference(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(PubMedSourceReferenceConcept_getInstance().m6n_1) : nodeId;
    return PubMedSourceReference_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function PublishedSourceReference(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(PublishedSourceReferenceConcept_getInstance().m6n_1) : nodeId;
    return PublishedSourceReference_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function PageRange(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(PageRangeConcept_getInstance().m6n_1) : nodeId;
    return PageRange_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function Book(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(BookConcept_getInstance().m6n_1) : nodeId;
    return Book_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function Paper(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(PaperConcept_getInstance().m6n_1) : nodeId;
    return Paper_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function LinkDeclaration(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(LinkDeclarationConcept_getInstance().m6n_1) : nodeId;
    return LinkDeclaration_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function RelationFactExpression(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(RelationFactExpressionConcept_getInstance().m6n_1) : nodeId;
    return RelationFactExpression_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function MultipliedExpression(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(MultipliedExpressionConcept_getInstance().m6n_1) : nodeId;
    return MultipliedExpression_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function NotionPlaceholder(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(NotionPlaceholderConcept_getInstance().m6n_1) : nodeId;
    return NotionPlaceholder_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function MeasurementUnit(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(MeasurementUnitConcept_getInstance().m6n_1) : nodeId;
    return MeasurementUnit_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function EnumerationConstant(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(EnumerationConstantConcept_getInstance().m6n_1) : nodeId;
    return EnumerationConstant_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function EnumerableNotion(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(EnumerableNotionConcept_getInstance().m6n_1) : nodeId;
    return EnumerableNotion_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function MeasurableNotion(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(MeasurableNotionConcept_getInstance().m6n_1) : nodeId;
    return MeasurableNotion_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function ObjectPropertyDeclaration(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ObjectPropertyDeclarationConcept_getInstance().m6n_1) : nodeId;
    return ObjectPropertyDeclaration_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function NoValues(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(NoValuesConcept_getInstance().m6n_1) : nodeId;
    return NoValues_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function MultiplePropertyValueRange(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(MultiplePropertyValueRangeConcept_getInstance().m6n_1) : nodeId;
    return MultiplePropertyValueRange_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function SinglePropertyValueRange(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(SinglePropertyValueRangeConcept_getInstance().m6n_1) : nodeId;
    return SinglePropertyValueRange_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function PropertyConstraint(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(PropertyConstraintConcept_getInstance().m6n_1) : nodeId;
    return PropertyConstraint_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function OntologyElementSynonym(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(OntologyElementSynonymConcept_getInstance().m6n_1) : nodeId;
    return OntologyElementSynonym_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function OntologyElementDefinition(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(OntologyElementDefinitionConcept_getInstance().m6n_1) : nodeId;
    return OntologyElementDefinition_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function OntologyIsRelation(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(OntologyIsRelationConcept_getInstance().m6n_1) : nodeId;
    return OntologyIsRelation_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function OntologyCardinalityRelation(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(OntologyCardinalityRelationConcept_getInstance().m6n_1) : nodeId;
    return OntologyCardinalityRelation_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function ProcessReference(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ProcessReferenceConcept_getInstance().m6n_1) : nodeId;
    return ProcessReference_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function ProcessProperty(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ProcessPropertyConcept_getInstance().m6n_1) : nodeId;
    return ProcessProperty_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function MultipleProcessPropertyValueRange(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(MultipleProcessPropertyValueRangeConcept_getInstance().m6n_1) : nodeId;
    return MultipleProcessPropertyValueRange_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function ProcessPropertyDefault(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ProcessPropertyDefaultConcept_getInstance().m6n_1) : nodeId;
    return ProcessPropertyDefault_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function EmptyBindingEntry(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(EmptyBindingEntryConcept_getInstance().m6n_1) : nodeId;
    return EmptyBindingEntry_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function EmptyPropertyLibraryElement(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(EmptyPropertyLibraryElementConcept_getInstance().m6n_1) : nodeId;
    return EmptyPropertyLibraryElement_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function OntologyLink(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(OntologyLinkConcept_getInstance().m6n_1) : nodeId;
    return OntologyLink_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function BindingProperty(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(BindingPropertyConcept_getInstance().m6n_1) : nodeId;
    return BindingProperty_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function ImportedLink(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ImportedLinkConcept_getInstance().m6n_1) : nodeId;
    return ImportedLink_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function ImportedProperty(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ImportedPropertyConcept_getInstance().m6n_1) : nodeId;
    return ImportedProperty_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function PropertyValue(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(PropertyValueConcept_getInstance().m6n_1) : nodeId;
    return PropertyValue_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function OntologyLinkValue(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(OntologyLinkValueConcept_getInstance().m6n_1) : nodeId;
    return OntologyLinkValue_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function ProcessPropertyValue(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ProcessPropertyValueConcept_getInstance().m6n_1) : nodeId;
    return ProcessPropertyValue_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function PropertyDeclaration(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(PropertyDeclarationConcept_getInstance().m6n_1) : nodeId;
    return PropertyDeclaration_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function PrimitivePropertyType(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(PrimitivePropertyTypeConcept_getInstance().m6n_1) : nodeId;
    return PrimitivePropertyType_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function OntologyElementPropertyType(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(OntologyElementPropertyTypeConcept_getInstance().m6n_1) : nodeId;
    return OntologyElementPropertyType_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function FindNewConnectionCommand(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(FindNewConnectionCommandConcept_getInstance().m6n_1) : nodeId;
    return FindNewConnectionCommand_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function FindConnectionCommand(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(FindConnectionCommandConcept_getInstance().m6n_1) : nodeId;
    return FindConnectionCommand_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function LibraryProcessSpecificationQuery(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(LibraryProcessSpecificationQueryConcept_getInstance().m6n_1) : nodeId;
    return LibraryProcessSpecificationQuery_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function VariablePattern(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(VariablePatternConcept_getInstance().m6n_1) : nodeId;
    return VariablePattern_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function OrValueQuery(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(OrValueQueryConcept_getInstance().m6n_1) : nodeId;
    return OrValueQuery_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function ContextQuery(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ContextQueryConcept_getInstance().m6n_1) : nodeId;
    return ContextQuery_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function BindingValueMask(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(BindingValueMaskConcept_getInstance().m6n_1) : nodeId;
    return BindingValueMask_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function OntologyLinkDeclarationValueQuery(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(OntologyLinkDeclarationValueQueryConcept_getInstance().m6n_1) : nodeId;
    return OntologyLinkDeclarationValueQuery_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function PropertyDeclarationValueQuery(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(PropertyDeclarationValueQueryConcept_getInstance().m6n_1) : nodeId;
    return PropertyDeclarationValueQuery_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function ClassExpressionType(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ClassExpressionTypeConcept_getInstance().m6n_1) : nodeId;
    return ClassExpressionType_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function PrimitiveNotionType(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(PrimitiveNotionTypeConcept_getInstance().m6n_1) : nodeId;
    return PrimitiveNotionType_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function Url(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(UrlConcept_getInstance().m6n_1) : nodeId;
    return Url_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function FactSet(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(FactSetConcept_getInstance().m6n_1) : nodeId;
    return FactSet_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function ComplexNotionTemplate(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ComplexNotionTemplateConcept_getInstance().m6n_1) : nodeId;
    return ComplexNotionTemplate_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function ComplexNotionTemplatePlaceholder(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ComplexNotionTemplatePlaceholderConcept_getInstance().m6n_1) : nodeId;
    return ComplexNotionTemplatePlaceholder_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function ComplexNotionElement(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ComplexNotionElementConcept_getInstance().m6n_1) : nodeId;
    return ComplexNotionElement_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function ComplexNotion(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ComplexNotionConcept_getInstance().m6n_1) : nodeId;
    return ComplexNotion_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function ComplexNotionTemplateTextElement(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ComplexNotionTemplateTextElementConcept_getInstance().m6n_1) : nodeId;
    return ComplexNotionTemplateTextElement_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function ComplexNotionTemplateRefElement(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ComplexNotionTemplateRefElementConcept_getInstance().m6n_1) : nodeId;
    return ComplexNotionTemplateRefElement_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function ExtensionFieldReference(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ExtensionFieldReferenceConcept_getInstance().m6n_1) : nodeId;
    return ExtensionFieldReference_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function BindingValuePlaceholder(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(BindingValuePlaceholderConcept_getInstance().m6n_1) : nodeId;
    return BindingValuePlaceholder_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function Fact(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(FactConcept_getInstance().m6n_1) : nodeId;
    return Fact_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function ExtensionDeclaration(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ExtensionDeclarationConcept_getInstance().m6n_1) : nodeId;
    return ExtensionDeclaration_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function FactReference(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(FactReferenceConcept_getInstance().m6n_1) : nodeId;
    return FactReference_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function FunctionDeclaration(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(FunctionDeclarationConcept_getInstance().m6n_1) : nodeId;
    return FunctionDeclaration_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function OntologyElement(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(OntologyElementConcept_getInstance().m6n_1) : nodeId;
    return OntologyElement_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function LocalOntologyElementReference(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(LocalOntologyElementReferenceConcept_getInstance().m6n_1) : nodeId;
    return LocalOntologyElementReference_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function ProcessDeclaration(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ProcessDeclarationConcept_getInstance().m6n_1) : nodeId;
    return ProcessDeclaration_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function ProcessKind(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ProcessKindConcept_getInstance().m6n_1) : nodeId;
    return ProcessKind_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function BindingValuePlaceholderQuery(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(BindingValuePlaceholderQueryConcept_getInstance().m6n_1) : nodeId;
    return BindingValuePlaceholderQuery_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function ProcessRelationDeclaration(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ProcessRelationDeclarationConcept_getInstance().m6n_1) : nodeId;
    return ProcessRelationDeclaration_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function OntologyImport(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(OntologyImportConcept_getInstance().m6n_1) : nodeId;
    return OntologyImport_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function Context_1(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ContextConcept_getInstance().m6n_1) : nodeId;
    return ContextConcept_getInstance().d6o(context, nodeId);
  }
  function OntologyLibraryReference_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(OntologyLibraryReferenceConcept_getInstance().m6n_1) : nodeId;
    return OntologyLibraryReferenceConcept_getInstance().d6o(context, nodeId);
  }
  function OntologyElementReference_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(OntologyElementReferenceConcept_getInstance().m6n_1) : nodeId;
    return OntologyElementReferenceConcept_getInstance().d6o(context, nodeId);
  }
  function Category_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(CategoryConcept_getInstance().m6n_1) : nodeId;
    return CategoryConcept_getInstance().d6o(context, nodeId);
  }
  function OntologyImportRootReference_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(OntologyImportRootReferenceConcept_getInstance().m6n_1) : nodeId;
    return OntologyImportRootReferenceConcept_getInstance().d6o(context, nodeId);
  }
  function TypePlaceholder_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(TypePlaceholderConcept_getInstance().m6n_1) : nodeId;
    return TypePlaceholderConcept_getInstance().d6o(context, nodeId);
  }
  function OntologyElementType_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(OntologyElementTypeConcept_getInstance().m6n_1) : nodeId;
    return OntologyElementTypeConcept_getInstance().d6o(context, nodeId);
  }
  function ProcessType_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ProcessTypeConcept_getInstance().m6n_1) : nodeId;
    return ProcessTypeConcept_getInstance().d6o(context, nodeId);
  }
  function LibraryProcessSpecification_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(LibraryProcessSpecificationConcept_getInstance().m6n_1) : nodeId;
    return LibraryProcessSpecificationConcept_getInstance().d6o(context, nodeId);
  }
  function OneOf_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(OneOfConcept_getInstance().m6n_1) : nodeId;
    return OneOfConcept_getInstance().d6o(context, nodeId);
  }
  function PropertyReferenceOperation_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(PropertyReferenceOperationConcept_getInstance().m6n_1) : nodeId;
    return PropertyReferenceOperationConcept_getInstance().d6o(context, nodeId);
  }
  function SetValuedPropertyParameter_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(SetValuedPropertyParameterConcept_getInstance().m6n_1) : nodeId;
    return SetValuedPropertyParameterConcept_getInstance().d6o(context, nodeId);
  }
  function IsExpression_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(IsExpressionConcept_getInstance().m6n_1) : nodeId;
    return IsExpressionConcept_getInstance().d6o(context, nodeId);
  }
  function ClassExpressionPlaceholder_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ClassExpressionPlaceholderConcept_getInstance().m6n_1) : nodeId;
    return ClassExpressionPlaceholderConcept_getInstance().d6o(context, nodeId);
  }
  function QualifiedOntologyElementReference_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(QualifiedOntologyElementReferenceConcept_getInstance().m6n_1) : nodeId;
    return QualifiedOntologyElementReferenceConcept_getInstance().d6o(context, nodeId);
  }
  function UnionClass_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(UnionClassConcept_getInstance().m6n_1) : nodeId;
    return UnionClassConcept_getInstance().d6o(context, nodeId);
  }
  function VariableDeclaration_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(VariableDeclarationConcept_getInstance().m6n_1) : nodeId;
    return VariableDeclarationConcept_getInstance().d6o(context, nodeId);
  }
  function FunctionTerm_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(FunctionTermConcept_getInstance().m6n_1) : nodeId;
    return FunctionTermConcept_getInstance().d6o(context, nodeId);
  }
  function MeasurableValue_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(MeasurableValueConcept_getInstance().m6n_1) : nodeId;
    return MeasurableValueConcept_getInstance().d6o(context, nodeId);
  }
  function EnumValue_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(EnumValueConcept_getInstance().m6n_1) : nodeId;
    return EnumValueConcept_getInstance().d6o(context, nodeId);
  }
  function StringValue_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(StringValueConcept_getInstance().m6n_1) : nodeId;
    return StringValueConcept_getInstance().d6o(context, nodeId);
  }
  function IntegerValue_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(IntegerValueConcept_getInstance().m6n_1) : nodeId;
    return IntegerValueConcept_getInstance().d6o(context, nodeId);
  }
  function VariableReferenceValue_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(VariableReferenceValueConcept_getInstance().m6n_1) : nodeId;
    return VariableReferenceValueConcept_getInstance().d6o(context, nodeId);
  }
  function SetExpression_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(SetExpressionConcept_getInstance().m6n_1) : nodeId;
    return SetExpressionConcept_getInstance().d6o(context, nodeId);
  }
  function OntologyElementReferenceValueLibrary_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(OntologyElementReferenceValueLibraryConcept_getInstance().m6n_1) : nodeId;
    return OntologyElementReferenceValueLibraryConcept_getInstance().d6o(context, nodeId);
  }
  function OntologyElementReferenceValue_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(OntologyElementReferenceValueConcept_getInstance().m6n_1) : nodeId;
    return OntologyElementReferenceValueConcept_getInstance().d6o(context, nodeId);
  }
  function ComplexNotionValue_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ComplexNotionValueConcept_getInstance().m6n_1) : nodeId;
    return ComplexNotionValueConcept_getInstance().d6o(context, nodeId);
  }
  function ComplexNotionElementValue_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ComplexNotionElementValueConcept_getInstance().m6n_1) : nodeId;
    return ComplexNotionElementValueConcept_getInstance().d6o(context, nodeId);
  }
  function UnknownComplexNotionValue_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(UnknownComplexNotionValueConcept_getInstance().m6n_1) : nodeId;
    return UnknownComplexNotionValueConcept_getInstance().d6o(context, nodeId);
  }
  function ConstantCustomCell_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ConstantCustomCellConcept_getInstance().m6n_1) : nodeId;
    return ConstantCustomCellConcept_getInstance().d6o(context, nodeId);
  }
  function ProcessPropertyCustomCell_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ProcessPropertyCustomCellConcept_getInstance().m6n_1) : nodeId;
    return ProcessPropertyCustomCellConcept_getInstance().d6o(context, nodeId);
  }
  function PropertyCustomCell_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(PropertyCustomCellConcept_getInstance().m6n_1) : nodeId;
    return PropertyCustomCellConcept_getInstance().d6o(context, nodeId);
  }
  function LinkCustomCell_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(LinkCustomCellConcept_getInstance().m6n_1) : nodeId;
    return LinkCustomCellConcept_getInstance().d6o(context, nodeId);
  }
  function KindCustomCell_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(KindCustomCellConcept_getInstance().m6n_1) : nodeId;
    return KindCustomCellConcept_getInstance().d6o(context, nodeId);
  }
  function ReturnTypeCustomCell_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ReturnTypeCustomCellConcept_getInstance().m6n_1) : nodeId;
    return ReturnTypeCustomCellConcept_getInstance().d6o(context, nodeId);
  }
  function CardinalityCustomCell_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(CardinalityCustomCellConcept_getInstance().m6n_1) : nodeId;
    return CardinalityCustomCellConcept_getInstance().d6o(context, nodeId);
  }
  function DeclarationNameCustomCell_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(DeclarationNameCustomCellConcept_getInstance().m6n_1) : nodeId;
    return DeclarationNameCustomCellConcept_getInstance().d6o(context, nodeId);
  }
  function PropertiesCustomCell_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(PropertiesCustomCellConcept_getInstance().m6n_1) : nodeId;
    return PropertiesCustomCellConcept_getInstance().d6o(context, nodeId);
  }
  function FieldDeclaration_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(FieldDeclarationConcept_getInstance().m6n_1) : nodeId;
    return FieldDeclarationConcept_getInstance().d6o(context, nodeId);
  }
  function FactPrecondition_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(FactPreconditionConcept_getInstance().m6n_1) : nodeId;
    return FactPreconditionConcept_getInstance().d6o(context, nodeId);
  }
  function Cardinality_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(CardinalityConcept_getInstance().m6n_1) : nodeId;
    return CardinalityConcept_getInstance().d6o(context, nodeId);
  }
  function CardinalityBoundN_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(CardinalityBoundNConcept_getInstance().m6n_1) : nodeId;
    return CardinalityBoundNConcept_getInstance().d6o(context, nodeId);
  }
  function CardinalityBoundPlaceholder_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(CardinalityBoundPlaceholderConcept_getInstance().m6n_1) : nodeId;
    return CardinalityBoundPlaceholderConcept_getInstance().d6o(context, nodeId);
  }
  function CardinalityBoundConstant_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(CardinalityBoundConstantConcept_getInstance().m6n_1) : nodeId;
    return CardinalityBoundConstantConcept_getInstance().d6o(context, nodeId);
  }
  function KnowledgeSourceReferencePlaceholder_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(KnowledgeSourceReferencePlaceholderConcept_getInstance().m6n_1) : nodeId;
    return KnowledgeSourceReferencePlaceholderConcept_getInstance().d6o(context, nodeId);
  }
  function Page_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(PageConcept_getInstance().m6n_1) : nodeId;
    return PageConcept_getInstance().d6o(context, nodeId);
  }
  function Author_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(AuthorConcept_getInstance().m6n_1) : nodeId;
    return AuthorConcept_getInstance().d6o(context, nodeId);
  }
  function LibraryItemPlaceholder_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(LibraryItemPlaceholderConcept_getInstance().m6n_1) : nodeId;
    return LibraryItemPlaceholderConcept_getInstance().d6o(context, nodeId);
  }
  function UrlKnowledgeSourceReference_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(UrlKnowledgeSourceReferenceConcept_getInstance().m6n_1) : nodeId;
    return UrlKnowledgeSourceReferenceConcept_getInstance().d6o(context, nodeId);
  }
  function PubMedSourceReference_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(PubMedSourceReferenceConcept_getInstance().m6n_1) : nodeId;
    return PubMedSourceReferenceConcept_getInstance().d6o(context, nodeId);
  }
  function PublishedSourceReference_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(PublishedSourceReferenceConcept_getInstance().m6n_1) : nodeId;
    return PublishedSourceReferenceConcept_getInstance().d6o(context, nodeId);
  }
  function PageRange_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(PageRangeConcept_getInstance().m6n_1) : nodeId;
    return PageRangeConcept_getInstance().d6o(context, nodeId);
  }
  function Book_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(BookConcept_getInstance().m6n_1) : nodeId;
    return BookConcept_getInstance().d6o(context, nodeId);
  }
  function Paper_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(PaperConcept_getInstance().m6n_1) : nodeId;
    return PaperConcept_getInstance().d6o(context, nodeId);
  }
  function LinkDeclaration_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(LinkDeclarationConcept_getInstance().m6n_1) : nodeId;
    return LinkDeclarationConcept_getInstance().d6o(context, nodeId);
  }
  function RelationFactExpression_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(RelationFactExpressionConcept_getInstance().m6n_1) : nodeId;
    return RelationFactExpressionConcept_getInstance().d6o(context, nodeId);
  }
  function MultipliedExpression_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(MultipliedExpressionConcept_getInstance().m6n_1) : nodeId;
    return MultipliedExpressionConcept_getInstance().d6o(context, nodeId);
  }
  function NotionPlaceholder_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(NotionPlaceholderConcept_getInstance().m6n_1) : nodeId;
    return NotionPlaceholderConcept_getInstance().d6o(context, nodeId);
  }
  function MeasurementUnit_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(MeasurementUnitConcept_getInstance().m6n_1) : nodeId;
    return MeasurementUnitConcept_getInstance().d6o(context, nodeId);
  }
  function EnumerationConstant_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(EnumerationConstantConcept_getInstance().m6n_1) : nodeId;
    return EnumerationConstantConcept_getInstance().d6o(context, nodeId);
  }
  function EnumerableNotion_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(EnumerableNotionConcept_getInstance().m6n_1) : nodeId;
    return EnumerableNotionConcept_getInstance().d6o(context, nodeId);
  }
  function MeasurableNotion_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(MeasurableNotionConcept_getInstance().m6n_1) : nodeId;
    return MeasurableNotionConcept_getInstance().d6o(context, nodeId);
  }
  function ObjectPropertyDeclaration_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ObjectPropertyDeclarationConcept_getInstance().m6n_1) : nodeId;
    return ObjectPropertyDeclarationConcept_getInstance().d6o(context, nodeId);
  }
  function NoValues_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(NoValuesConcept_getInstance().m6n_1) : nodeId;
    return NoValuesConcept_getInstance().d6o(context, nodeId);
  }
  function MultiplePropertyValueRange_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(MultiplePropertyValueRangeConcept_getInstance().m6n_1) : nodeId;
    return MultiplePropertyValueRangeConcept_getInstance().d6o(context, nodeId);
  }
  function SinglePropertyValueRange_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(SinglePropertyValueRangeConcept_getInstance().m6n_1) : nodeId;
    return SinglePropertyValueRangeConcept_getInstance().d6o(context, nodeId);
  }
  function PropertyConstraint_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(PropertyConstraintConcept_getInstance().m6n_1) : nodeId;
    return PropertyConstraintConcept_getInstance().d6o(context, nodeId);
  }
  function OntologyElementSynonym_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(OntologyElementSynonymConcept_getInstance().m6n_1) : nodeId;
    return OntologyElementSynonymConcept_getInstance().d6o(context, nodeId);
  }
  function OntologyElementDefinition_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(OntologyElementDefinitionConcept_getInstance().m6n_1) : nodeId;
    return OntologyElementDefinitionConcept_getInstance().d6o(context, nodeId);
  }
  function OntologyIsRelation_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(OntologyIsRelationConcept_getInstance().m6n_1) : nodeId;
    return OntologyIsRelationConcept_getInstance().d6o(context, nodeId);
  }
  function OntologyCardinalityRelation_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(OntologyCardinalityRelationConcept_getInstance().m6n_1) : nodeId;
    return OntologyCardinalityRelationConcept_getInstance().d6o(context, nodeId);
  }
  function ProcessReference_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ProcessReferenceConcept_getInstance().m6n_1) : nodeId;
    return ProcessReferenceConcept_getInstance().d6o(context, nodeId);
  }
  function ProcessProperty_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ProcessPropertyConcept_getInstance().m6n_1) : nodeId;
    return ProcessPropertyConcept_getInstance().d6o(context, nodeId);
  }
  function MultipleProcessPropertyValueRange_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(MultipleProcessPropertyValueRangeConcept_getInstance().m6n_1) : nodeId;
    return MultipleProcessPropertyValueRangeConcept_getInstance().d6o(context, nodeId);
  }
  function ProcessPropertyDefault_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ProcessPropertyDefaultConcept_getInstance().m6n_1) : nodeId;
    return ProcessPropertyDefaultConcept_getInstance().d6o(context, nodeId);
  }
  function EmptyBindingEntry_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(EmptyBindingEntryConcept_getInstance().m6n_1) : nodeId;
    return EmptyBindingEntryConcept_getInstance().d6o(context, nodeId);
  }
  function EmptyPropertyLibraryElement_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(EmptyPropertyLibraryElementConcept_getInstance().m6n_1) : nodeId;
    return EmptyPropertyLibraryElementConcept_getInstance().d6o(context, nodeId);
  }
  function OntologyLink_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(OntologyLinkConcept_getInstance().m6n_1) : nodeId;
    return OntologyLinkConcept_getInstance().d6o(context, nodeId);
  }
  function BindingProperty_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(BindingPropertyConcept_getInstance().m6n_1) : nodeId;
    return BindingPropertyConcept_getInstance().d6o(context, nodeId);
  }
  function ImportedLink_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ImportedLinkConcept_getInstance().m6n_1) : nodeId;
    return ImportedLinkConcept_getInstance().d6o(context, nodeId);
  }
  function ImportedProperty_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ImportedPropertyConcept_getInstance().m6n_1) : nodeId;
    return ImportedPropertyConcept_getInstance().d6o(context, nodeId);
  }
  function PropertyValue_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(PropertyValueConcept_getInstance().m6n_1) : nodeId;
    return PropertyValueConcept_getInstance().d6o(context, nodeId);
  }
  function OntologyLinkValue_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(OntologyLinkValueConcept_getInstance().m6n_1) : nodeId;
    return OntologyLinkValueConcept_getInstance().d6o(context, nodeId);
  }
  function ProcessPropertyValue_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ProcessPropertyValueConcept_getInstance().m6n_1) : nodeId;
    return ProcessPropertyValueConcept_getInstance().d6o(context, nodeId);
  }
  function PropertyDeclaration_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(PropertyDeclarationConcept_getInstance().m6n_1) : nodeId;
    return PropertyDeclarationConcept_getInstance().d6o(context, nodeId);
  }
  function PrimitivePropertyType_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(PrimitivePropertyTypeConcept_getInstance().m6n_1) : nodeId;
    return PrimitivePropertyTypeConcept_getInstance().d6o(context, nodeId);
  }
  function OntologyElementPropertyType_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(OntologyElementPropertyTypeConcept_getInstance().m6n_1) : nodeId;
    return OntologyElementPropertyTypeConcept_getInstance().d6o(context, nodeId);
  }
  function FindNewConnectionCommand_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(FindNewConnectionCommandConcept_getInstance().m6n_1) : nodeId;
    return FindNewConnectionCommandConcept_getInstance().d6o(context, nodeId);
  }
  function FindConnectionCommand_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(FindConnectionCommandConcept_getInstance().m6n_1) : nodeId;
    return FindConnectionCommandConcept_getInstance().d6o(context, nodeId);
  }
  function LibraryProcessSpecificationQuery_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(LibraryProcessSpecificationQueryConcept_getInstance().m6n_1) : nodeId;
    return LibraryProcessSpecificationQueryConcept_getInstance().d6o(context, nodeId);
  }
  function VariablePattern_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(VariablePatternConcept_getInstance().m6n_1) : nodeId;
    return VariablePatternConcept_getInstance().d6o(context, nodeId);
  }
  function OrValueQuery_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(OrValueQueryConcept_getInstance().m6n_1) : nodeId;
    return OrValueQueryConcept_getInstance().d6o(context, nodeId);
  }
  function ContextQuery_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ContextQueryConcept_getInstance().m6n_1) : nodeId;
    return ContextQueryConcept_getInstance().d6o(context, nodeId);
  }
  function BindingValueMask_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(BindingValueMaskConcept_getInstance().m6n_1) : nodeId;
    return BindingValueMaskConcept_getInstance().d6o(context, nodeId);
  }
  function OntologyLinkDeclarationValueQuery_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(OntologyLinkDeclarationValueQueryConcept_getInstance().m6n_1) : nodeId;
    return OntologyLinkDeclarationValueQueryConcept_getInstance().d6o(context, nodeId);
  }
  function PropertyDeclarationValueQuery_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(PropertyDeclarationValueQueryConcept_getInstance().m6n_1) : nodeId;
    return PropertyDeclarationValueQueryConcept_getInstance().d6o(context, nodeId);
  }
  function ClassExpressionType_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ClassExpressionTypeConcept_getInstance().m6n_1) : nodeId;
    return ClassExpressionTypeConcept_getInstance().d6o(context, nodeId);
  }
  function PrimitiveNotionType_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(PrimitiveNotionTypeConcept_getInstance().m6n_1) : nodeId;
    return PrimitiveNotionTypeConcept_getInstance().d6o(context, nodeId);
  }
  function Url_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(UrlConcept_getInstance().m6n_1) : nodeId;
    return UrlConcept_getInstance().d6o(context, nodeId);
  }
  function FactSet_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(FactSetConcept_getInstance().m6n_1) : nodeId;
    return FactSetConcept_getInstance().d6o(context, nodeId);
  }
  function ComplexNotionTemplate_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ComplexNotionTemplateConcept_getInstance().m6n_1) : nodeId;
    return ComplexNotionTemplateConcept_getInstance().d6o(context, nodeId);
  }
  function ComplexNotionTemplatePlaceholder_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ComplexNotionTemplatePlaceholderConcept_getInstance().m6n_1) : nodeId;
    return ComplexNotionTemplatePlaceholderConcept_getInstance().d6o(context, nodeId);
  }
  function ComplexNotionElement_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ComplexNotionElementConcept_getInstance().m6n_1) : nodeId;
    return ComplexNotionElementConcept_getInstance().d6o(context, nodeId);
  }
  function ComplexNotion_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ComplexNotionConcept_getInstance().m6n_1) : nodeId;
    return ComplexNotionConcept_getInstance().d6o(context, nodeId);
  }
  function ComplexNotionTemplateTextElement_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ComplexNotionTemplateTextElementConcept_getInstance().m6n_1) : nodeId;
    return ComplexNotionTemplateTextElementConcept_getInstance().d6o(context, nodeId);
  }
  function ComplexNotionTemplateRefElement_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ComplexNotionTemplateRefElementConcept_getInstance().m6n_1) : nodeId;
    return ComplexNotionTemplateRefElementConcept_getInstance().d6o(context, nodeId);
  }
  function ExtensionFieldReference_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ExtensionFieldReferenceConcept_getInstance().m6n_1) : nodeId;
    return ExtensionFieldReferenceConcept_getInstance().d6o(context, nodeId);
  }
  function BindingValuePlaceholder_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(BindingValuePlaceholderConcept_getInstance().m6n_1) : nodeId;
    return BindingValuePlaceholderConcept_getInstance().d6o(context, nodeId);
  }
  function Fact_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(FactConcept_getInstance().m6n_1) : nodeId;
    return FactConcept_getInstance().d6o(context, nodeId);
  }
  function ExtensionDeclaration_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ExtensionDeclarationConcept_getInstance().m6n_1) : nodeId;
    return ExtensionDeclarationConcept_getInstance().d6o(context, nodeId);
  }
  function FactReference_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(FactReferenceConcept_getInstance().m6n_1) : nodeId;
    return FactReferenceConcept_getInstance().d6o(context, nodeId);
  }
  function FunctionDeclaration_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(FunctionDeclarationConcept_getInstance().m6n_1) : nodeId;
    return FunctionDeclarationConcept_getInstance().d6o(context, nodeId);
  }
  function OntologyElement_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(OntologyElementConcept_getInstance().m6n_1) : nodeId;
    return OntologyElementConcept_getInstance().d6o(context, nodeId);
  }
  function LocalOntologyElementReference_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(LocalOntologyElementReferenceConcept_getInstance().m6n_1) : nodeId;
    return LocalOntologyElementReferenceConcept_getInstance().d6o(context, nodeId);
  }
  function ProcessDeclaration_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ProcessDeclarationConcept_getInstance().m6n_1) : nodeId;
    return ProcessDeclarationConcept_getInstance().d6o(context, nodeId);
  }
  function ProcessKind_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ProcessKindConcept_getInstance().m6n_1) : nodeId;
    return ProcessKindConcept_getInstance().d6o(context, nodeId);
  }
  function BindingValuePlaceholderQuery_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(BindingValuePlaceholderQueryConcept_getInstance().m6n_1) : nodeId;
    return BindingValuePlaceholderQueryConcept_getInstance().d6o(context, nodeId);
  }
  function ProcessRelationDeclaration_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ProcessRelationDeclarationConcept_getInstance().m6n_1) : nodeId;
    return ProcessRelationDeclarationConcept_getInstance().d6o(context, nodeId);
  }
  function OntologyImport_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(OntologyImportConcept_getInstance().m6n_1) : nodeId;
    return OntologyImportConcept_getInstance().d6o(context, nodeId);
  }
  function ObjectPropertyReferenceValue(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ObjectPropertyReferenceValueConcept_getInstance().m6n_1) : nodeId;
    return ObjectPropertyReferenceValue_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function ConstantPrecondition(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ConstantPreconditionConcept_getInstance().m6n_1) : nodeId;
    return ConstantPreconditionConcept_getInstance().d6o(context, nodeId);
  }
  function QueryLabelsFactExpressionContainer(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(QueryLabelsFactExpressionContainerConcept_getInstance().m6n_1) : nodeId;
    return QueryLabelsFactExpressionContainerConcept_getInstance().d6o(context, nodeId);
  }
  function NewFactReference(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(NewFactReferenceConcept_getInstance().m6n_1) : nodeId;
    return NewFactReferenceConcept_getInstance().d6o(context, nodeId);
  }
  function ModifierFactExpression(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ModifierFactExpressionConcept_getInstance().m6n_1) : nodeId;
    return ModifierFactExpressionConcept_getInstance().d6o(context, nodeId);
  }
  function ProcessPrerequisite(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ProcessPrerequisiteConcept_getInstance().m6n_1) : nodeId;
    return ProcessPrerequisiteConcept_getInstance().d6o(context, nodeId);
  }
  function ProcessEffect(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ProcessEffectConcept_getInstance().m6n_1) : nodeId;
    return ProcessEffectConcept_getInstance().d6o(context, nodeId);
  }
  function NotionType(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(NotionTypeConcept_getInstance().m6n_1) : nodeId;
    return NotionTypeConcept_getInstance().d6o(context, nodeId);
  }
  function ObjectPropertyReferenceValue_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ObjectPropertyReferenceValueConcept_getInstance().m6n_1) : nodeId;
    return ObjectPropertyReferenceValueConcept_getInstance().d6o(context, nodeId);
  }
  function BTBDocument(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(BTBDocumentConcept_getInstance().m6n_1) : nodeId;
    return BTBDocument_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function OntologyImportRoot(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(OntologyImportRootConcept_getInstance().m6n_1) : nodeId;
    return OntologyImportRoot_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function OntologyLibrary(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(OntologyLibraryConcept_getInstance().m6n_1) : nodeId;
    return OntologyLibrary_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function ProcessKindContainer(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ProcessKindContainerConcept_getInstance().m6n_1) : nodeId;
    return ProcessKindContainer_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function ProcessLibrary(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ProcessLibraryConcept_getInstance().m6n_1) : nodeId;
    return ProcessLibrary_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function RelationContainer(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(RelationContainerConcept_getInstance().m6n_1) : nodeId;
    return RelationContainer_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function NotionLibrary(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(NotionLibraryConcept_getInstance().m6n_1) : nodeId;
    return NotionLibrary_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function FunctionLibrary(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(FunctionLibraryConcept_getInstance().m6n_1) : nodeId;
    return FunctionLibrary_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function ExtensionLibrary(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ExtensionLibraryConcept_getInstance().m6n_1) : nodeId;
    return ExtensionLibrary_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function PropertyLibrary(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(PropertyLibraryConcept_getInstance().m6n_1) : nodeId;
    return PropertyLibrary_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function LinkLibrary(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(LinkLibraryConcept_getInstance().m6n_1) : nodeId;
    return LinkLibrary_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function PublishedSourcesLibrary(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(PublishedSourcesLibraryConcept_getInstance().m6n_1) : nodeId;
    return PublishedSourcesLibrary_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function QueryCommands(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(QueryCommandsConcept_getInstance().m6n_1) : nodeId;
    return QueryCommands_0(context.m58(Companion_getInstance_93().p6l_1), nodeId);
  }
  function BTBDocument_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(BTBDocumentConcept_getInstance().m6n_1) : nodeId;
    // Inline function 'kotlin.apply' call
    var this_0 = BTBDocumentConcept_getInstance().d6o(context, nodeId);
    new Model(toOtNode(this_0));
    return this_0;
  }
  function OntologyImportRoot_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(OntologyImportRootConcept_getInstance().m6n_1) : nodeId;
    // Inline function 'kotlin.apply' call
    var this_0 = OntologyImportRootConcept_getInstance().d6o(context, nodeId);
    new Model(toOtNode(this_0));
    return this_0;
  }
  function OntologyLibrary_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(OntologyLibraryConcept_getInstance().m6n_1) : nodeId;
    // Inline function 'kotlin.apply' call
    var this_0 = OntologyLibraryConcept_getInstance().d6o(context, nodeId);
    new Model(toOtNode(this_0));
    return this_0;
  }
  function ProcessKindContainer_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ProcessKindContainerConcept_getInstance().m6n_1) : nodeId;
    // Inline function 'kotlin.apply' call
    var this_0 = ProcessKindContainerConcept_getInstance().d6o(context, nodeId);
    new Model(toOtNode(this_0));
    return this_0;
  }
  function ProcessLibrary_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ProcessLibraryConcept_getInstance().m6n_1) : nodeId;
    // Inline function 'kotlin.apply' call
    var this_0 = ProcessLibraryConcept_getInstance().d6o(context, nodeId);
    new Model(toOtNode(this_0));
    return this_0;
  }
  function RelationContainer_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(RelationContainerConcept_getInstance().m6n_1) : nodeId;
    // Inline function 'kotlin.apply' call
    var this_0 = RelationContainerConcept_getInstance().d6o(context, nodeId);
    new Model(toOtNode(this_0));
    return this_0;
  }
  function NotionLibrary_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(NotionLibraryConcept_getInstance().m6n_1) : nodeId;
    // Inline function 'kotlin.apply' call
    var this_0 = NotionLibraryConcept_getInstance().d6o(context, nodeId);
    new Model(toOtNode(this_0));
    return this_0;
  }
  function FunctionLibrary_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(FunctionLibraryConcept_getInstance().m6n_1) : nodeId;
    // Inline function 'kotlin.apply' call
    var this_0 = FunctionLibraryConcept_getInstance().d6o(context, nodeId);
    new Model(toOtNode(this_0));
    return this_0;
  }
  function ExtensionLibrary_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ExtensionLibraryConcept_getInstance().m6n_1) : nodeId;
    // Inline function 'kotlin.apply' call
    var this_0 = ExtensionLibraryConcept_getInstance().d6o(context, nodeId);
    new Model(toOtNode(this_0));
    return this_0;
  }
  function PropertyLibrary_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(PropertyLibraryConcept_getInstance().m6n_1) : nodeId;
    // Inline function 'kotlin.apply' call
    var this_0 = PropertyLibraryConcept_getInstance().d6o(context, nodeId);
    new Model(toOtNode(this_0));
    return this_0;
  }
  function LinkLibrary_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(LinkLibraryConcept_getInstance().m6n_1) : nodeId;
    // Inline function 'kotlin.apply' call
    var this_0 = LinkLibraryConcept_getInstance().d6o(context, nodeId);
    new Model(toOtNode(this_0));
    return this_0;
  }
  function PublishedSourcesLibrary_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(PublishedSourcesLibraryConcept_getInstance().m6n_1) : nodeId;
    // Inline function 'kotlin.apply' call
    var this_0 = PublishedSourcesLibraryConcept_getInstance().d6o(context, nodeId);
    new Model(toOtNode(this_0));
    return this_0;
  }
  function QueryCommands_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(QueryCommandsConcept_getInstance().m6n_1) : nodeId;
    // Inline function 'kotlin.apply' call
    var this_0 = QueryCommandsConcept_getInstance().d6o(context, nodeId);
    new Model(toOtNode(this_0));
    return this_0;
  }
  function AbstractBindingDeclaration$_get_ontologyElements_$ref_egks01() {
    return function (p0) {
      return p0.qfp();
    };
  }
  function AbstractBindingDeclaration$_get_entries_$ref_fnlsrh() {
    return function (p0) {
      return p0.y();
    };
  }
  function AbstractBindingDeclaration$_get_properties_$ref_4foxw4() {
    return function (p0) {
      return p0.rfp();
    };
  }
  function AbstractBindingDeclaration$_get_customEditor_$ref_6c7l07() {
    return function (p0) {
      return p0.sfp();
    };
  }
  function AbstractBindingDeclaration$_get_customEditorEnabled_$ref_h4m7ao() {
    return function (p0) {
      return p0.tfp();
    };
  }
  function AbstractBindingValue$_get_value_$ref_r1k0yv() {
    return function (p0) {
      return p0.a1();
    };
  }
  function AbstractLink$_get_specializes_$ref_yv3dpc() {
    return function (p0) {
      return p0.ufp();
    };
  }
  function AuthoredWork$_get_authors_$ref_88kya7() {
    return function (p0) {
      return p0.vfp();
    };
  }
  function AuthoredWork$_get_title_$ref_mtfkzj() {
    return function (p0) {
      return p0.wfp();
    };
  }
  function BTBDocument$_get_factSets_$ref_40l74m() {
    return function (p0) {
      return p0.xfp();
    };
  }
  function BTBDocument$_get_categories_$ref_emheyf() {
    return function (p0) {
      return p0.yfp();
    };
  }
  function BTBDocument$_get_imports_$ref_o0awgp() {
    return function (p0) {
      return p0.zfp();
    };
  }
  function BindingProperty$_get_property_$ref_iv28zz() {
    return function (p0) {
      return p0.q6q();
    };
  }
  function BindingValueMask$_get_value_$ref_srt04j() {
    return function (p0) {
      return p0.a1();
    };
  }
  function Book$_get_edition_$ref_uuzusn() {
    return function (p0) {
      return p0.afq();
    };
  }
  function Cardinality$_get_lowerBound_$ref_entgur() {
    return function (p0) {
      return p0.bfq();
    };
  }
  function Cardinality$_get_upperBound_$ref_jgtibw() {
    return function (p0) {
      return p0.cfq();
    };
  }
  function Cardinality$_get_deprecatedUpperBound_$ref_fpwpvl() {
    return function (p0) {
      return p0.dfq();
    };
  }
  function CardinalityBoundConstant$_get_value_$ref_d0ff0h() {
    return function (p0) {
      return p0.a1();
    };
  }
  function CardinalityBoundPlaceholder$_get_bound_$ref_92a5xd() {
    return function (p0) {
      return p0.efq();
    };
  }
  function Category$_get_library_$ref_sghxsx() {
    return function (p0) {
      return p0.ffq();
    };
  }
  function Category$_get_element_$ref_9nwohu() {
    return function (p0) {
      return p0.gfq();
    };
  }
  function ClassExpressionType$_get_classExpression_$ref_lk9vu2() {
    return function (p0) {
      return p0.hfq();
    };
  }
  function ComplexNotion$_get_elements_$ref_mrhdwi() {
    return function (p0) {
      return p0.ifq();
    };
  }
  function ComplexNotion$_get_template_$ref_kdbfun() {
    return function (p0) {
      return p0.jfq();
    };
  }
  function ComplexNotionElement$_get_elementType_$ref_czuq0z() {
    return function (p0) {
      return p0.kfq();
    };
  }
  function ComplexNotionElement$_get_unknownValueAllowed_$ref_30zrma() {
    return function (p0) {
      return p0.lfq();
    };
  }
  function ComplexNotionElementValue$_get_element_$ref_dgdsiu() {
    return function (p0) {
      return p0.gfq();
    };
  }
  function ComplexNotionElementValue$_get_value_$ref_kz5f7p() {
    return function (p0) {
      return p0.a1();
    };
  }
  function ComplexNotionTemplate$_get_elements_$ref_5kithk() {
    return function (p0) {
      return p0.ifq();
    };
  }
  function ComplexNotionTemplateRefElement$_get_element_$ref_c3f83c() {
    return function (p0) {
      return p0.gfq();
    };
  }
  function ComplexNotionTemplateTextElement$_get_text_$ref_ugb33() {
    return function (p0) {
      return p0.o8w();
    };
  }
  function ComplexNotionValue$_get_notion_$ref_1p18cj() {
    return function (p0) {
      return p0.mfq();
    };
  }
  function ComplexNotionValue$_get_elementValues_$ref_bqs60m() {
    return function (p0) {
      return p0.nfq();
    };
  }
  function ConstantCustomCell$_get_text_$ref_as957e() {
    return function (p0) {
      return p0.o8w();
    };
  }
  function ConstantPrecondition$_get_kind_$ref_e7xzm6() {
    return function (p0) {
      return p0.r5a();
    };
  }
  function Context$_get_library_$ref_4eq8r4() {
    return function (p0) {
      return p0.ffq();
    };
  }
  function Context$_get_element_$ref_n7bi27() {
    return function (p0) {
      return p0.gfq();
    };
  }
  function ContextQuery$_get_library_$ref_n5vw3e() {
    return function (p0) {
      return p0.ffq();
    };
  }
  function ContextQuery$_get_element_$ref_t2mwkn() {
    return function (p0) {
      return p0.gfq();
    };
  }
  function CustomEditor$_get_cells_$ref_phh77b() {
    return function (p0) {
      return p0.ofq();
    };
  }
  function DeclarationValueQuery$_get_value_$ref_j2fwpw() {
    return function (p0) {
      return p0.a1();
    };
  }
  function EnumValue$_get_constant_$ref_wk6jkm() {
    return function (p0) {
      return p0.pfq();
    };
  }
  function EnumerableNotion$_get_constants_$ref_ynx7ue() {
    return function (p0) {
      return p0.qfq();
    };
  }
  function ExtensionDeclaration$_get_fields_$ref_y00c96() {
    return function (p0) {
      return p0.rfq();
    };
  }
  function ExtensionDeclaration$_get_type_$ref_2sz2on() {
    return function (p0) {
      return p0.sfq();
    };
  }
  function ExtensionFieldReference$_get_field_$ref_4bdhle() {
    return function (p0) {
      return p0.tfq();
    };
  }
  function ExtensionLibrary$_get_extensions_$ref_a2rnfy() {
    return function (p0) {
      return p0.ue2();
    };
  }
  function Fact$_get_precondition_$ref_4fc0ee() {
    return function (p0) {
      return p0.ufq();
    };
  }
  function Fact$_get_specification_$ref_jrnjv() {
    return function (p0) {
      return p0.vfq();
    };
  }
  function FactPrecondition$_get_facts_$ref_m1xslj() {
    return function (p0) {
      return p0.wfq();
    };
  }
  function FactPrecondition$_get_relation_$ref_m111b2() {
    return function (p0) {
      return p0.xfq();
    };
  }
  function FactReference$_get_ref_$ref_yrgsjs() {
    return function (p0) {
      return p0.yfq();
    };
  }
  function FactSet$_get_factSetId_$ref_vbwuu7() {
    return function (p0) {
      return p0.zfq();
    };
  }
  function FactSet$_get_factsContext_$ref_cvizsw() {
    return function (p0) {
      return p0.afr();
    };
  }
  function FactSet$_get_contexts_$ref_i2luf8() {
    return function (p0) {
      return p0.bfr();
    };
  }
  function FactSet$_get_facts_$ref_jljgph() {
    return function (p0) {
      return p0.wfq();
    };
  }
  function FactSet$_get_newFacts_$ref_l1v7cv() {
    return function (p0) {
      return p0.cfr();
    };
  }
  function FieldDeclaration$_get_type_$ref_bpg0gs() {
    return function (p0) {
      return p0.sfq();
    };
  }
  function FieldDeclaration$_get_cardinality_$ref_jc2wge() {
    return function (p0) {
      return p0.dfr();
    };
  }
  function FindConnectionCommand$_get_contextQuery_$ref_mokctt() {
    return function (p0) {
      return p0.efr();
    };
  }
  function FindConnectionCommand$_get_from_$ref_q9ldq8() {
    return function (p0) {
      return p0.f4b();
    };
  }
  function FindConnectionCommand$_get_to_$ref_pv3m1b() {
    return function (p0) {
      return p0.g4b();
    };
  }
  function FindNewConnectionCommand$_get_contextQueries_$ref_s8ua7z() {
    return function (p0) {
      return p0.ffr();
    };
  }
  function FindNewConnectionCommand$_get_from_$ref_5jecnm() {
    return function (p0) {
      return p0.f4b();
    };
  }
  function FindNewConnectionCommand$_get_to_$ref_isfjel() {
    return function (p0) {
      return p0.g4b();
    };
  }
  function FunctionDeclaration$_get_returnType_$ref_ypk7g2() {
    return function (p0) {
      return p0.gfr();
    };
  }
  function FunctionDeclaration$_get_cardinality_$ref_danp80() {
    return function (p0) {
      return p0.dfr();
    };
  }
  function FunctionLibrary$_get_functions_$ref_ag5k04() {
    return function (p0) {
      return p0.hfr();
    };
  }
  function FunctionTerm$_get_function_$ref_fl3laa() {
    return function (p0) {
      return p0.ifr();
    };
  }
  function FunctionTerm$_get_specificator_$ref_6446ni() {
    return function (p0) {
      return p0.jfr();
    };
  }
  function FunctionTerm$_get_parameters_$ref_14vbsg() {
    return function (p0) {
      return p0.kfr();
    };
  }
  function HasComments$_get_comment_$ref_ob8p9n() {
    return function (p0) {
      return p0.lfr();
    };
  }
  function HasFactExpression$_get_expression_$ref_bmlpmw() {
    return function (p0) {
      return p0.mfr();
    };
  }
  function HasKnowledgeSources$_get_sources_$ref_6mibyw() {
    return function (p0) {
      return p0.nfr();
    };
  }
  function HasPropertyConstraints$_get_constraints_$ref_5lfcib() {
    return function (p0) {
      return p0.ofr();
    };
  }
  function HasQueryLabels$_get_noEntry_$ref_215uy0() {
    return function (p0) {
      return p0.pfr();
    };
  }
  function HasQueryLabels$_get_noExit_$ref_pxrte() {
    return function (p0) {
      return p0.qfr();
    };
  }
  function HasVariables$_get_variables_$ref_6jdr2() {
    return function (p0) {
      return p0.rfr();
    };
  }
  function ImportedLink$_get_declaration_$ref_rf42xs() {
    return function (p0) {
      return p0.sfr();
    };
  }
  function ImportedProperty$_get_declaration_$ref_692xl1() {
    return function (p0) {
      return p0.sfr();
    };
  }
  function InheritedProcessProperty$_get_type_$ref_7uh7x6() {
    return function (p0) {
      return p0.sfq();
    };
  }
  function InheritedProcessProperty$_get_default_$ref_c5hrt1() {
    return function (p0) {
      return p0.g3b();
    };
  }
  function InheritedProcessProperty$_get_inheritedFrom_$ref_gkccsi() {
    return function (p0) {
      return p0.tfr();
    };
  }
  function InstanceRelationDeclaration$_get_domain_$ref_oqqnwx() {
    return function (p0) {
      return p0.ufr();
    };
  }
  function InstanceRelationDeclaration$_get_range_$ref_6vz34o() {
    return function (p0) {
      return p0.hd();
    };
  }
  function InstanceRelationValue$_get_value_$ref_n9b6s5() {
    return function (p0) {
      return p0.a1();
    };
  }
  function InstanceRelationValue$_get_relation_$ref_1y8jwi() {
    return function (p0) {
      return p0.xfq();
    };
  }
  function IntegerValue$_get_value_$ref_c1etoe() {
    return function (p0) {
      return p0.a1();
    };
  }
  function IsExpression$_get_subject_$ref_1r93qq() {
    return function (p0) {
      return p0.mdy();
    };
  }
  function IsExpression$_get_value_$ref_6as7yl() {
    return function (p0) {
      return p0.a1();
    };
  }
  function LibraryProcessSpecification$_get_process_$ref_7klwyk() {
    return function (p0) {
      return p0.vfr();
    };
  }
  function LibraryProcessSpecification$_get_parameters_$ref_yticl7() {
    return function (p0) {
      return p0.kfr();
    };
  }
  function LibraryProcessSpecificationQuery$_get_process_$ref_2u429m() {
    return function (p0) {
      return p0.vfr();
    };
  }
  function LibraryProcessSpecificationQuery$_get_kind_$ref_ulcr75() {
    return function (p0) {
      return p0.r5a();
    };
  }
  function LibraryProcessSpecificationQuery$_get_parameters_$ref_6fozj9() {
    return function (p0) {
      return p0.kfr();
    };
  }
  function LinkCustomCell$_get_link_$ref_hxxns9() {
    return function (p0) {
      return p0.xa1();
    };
  }
  function LinkDeclaration$_get_specificator_$ref_gfmbhm() {
    return function (p0) {
      return p0.jfr();
    };
  }
  function LinkDeclaration$_get_type_$ref_9mjtus() {
    return function (p0) {
      return p0.sfq();
    };
  }
  function LinkLibrary$_get_links_$ref_y40czo() {
    return function (p0) {
      return p0.wfr();
    };
  }
  function LocalOntologyElementReference$_get_element_$ref_rimyqf() {
    return function (p0) {
      return p0.gfq();
    };
  }
  function MeasurableNotion$_get_units_$ref_k7fkf7() {
    return function (p0) {
      return p0.xfr();
    };
  }
  function MeasurableValue$_get_amount_$ref_ornak6() {
    return function (p0) {
      return p0.yfr();
    };
  }
  function MeasurableValue$_get_unit_$ref_ez4szu() {
    return function (p0) {
      return p0.zfr();
    };
  }
  function MeasurementUnit$_get_main_$ref_qfidtn() {
    return function (p0) {
      return p0.afs();
    };
  }
  function ModifierContainer$_get_modifiers_$ref_pj92fq() {
    return function (p0) {
      return p0.l8j();
    };
  }
  function ModifierFactExpression$_get_modifier_$ref_tzyw3w() {
    return function (p0) {
      return p0.bfs();
    };
  }
  function ModifierFactExpression$_get_expression_$ref_xrw8dn() {
    return function (p0) {
      return p0.mfr();
    };
  }
  function MultilineText$_get_lines_$ref_okds4p() {
    return function (p0) {
      return p0.qcv();
    };
  }
  function MultipleProcessPropertyValueRange$_get_type_$ref_fp68ik() {
    return function (p0) {
      return p0.sfq();
    };
  }
  function MultiplePropertyValueRange$_get_types_$ref_3rqsk4() {
    return function (p0) {
      return p0.cfs();
    };
  }
  function MultipliedExpression$_get_rawMultiplier_$ref_pej37m() {
    return function (p0) {
      return p0.dfs();
    };
  }
  function MultipliedExpression$_get_expression_$ref_l608dh() {
    return function (p0) {
      return p0.mfr();
    };
  }
  function NewFact$_get_expression_$ref_buri7u() {
    return function (p0) {
      return p0.mfr();
    };
  }
  function NewFactReference$_get_ref_$ref_4jyz94() {
    return function (p0) {
      return p0.yfq();
    };
  }
  function NotionLibrary$_get_notions_$ref_ejoba4() {
    return function (p0) {
      return p0.efs();
    };
  }
  function NotionType$_get_notion_$ref_5i807a() {
    return function (p0) {
      return p0.mfq();
    };
  }
  function ObjectPropertiesLibrary$_get_properties_$ref_3l7x8e() {
    return function (p0) {
      return p0.rfp();
    };
  }
  function ObjectPropertyDeclaration$_get_grouping_$ref_xld1xn() {
    return function (p0) {
      return p0.ffs();
    };
  }
  function ObjectPropertyDeclaration$_get_superProperty_$ref_32i1ji() {
    return function (p0) {
      return p0.gfs();
    };
  }
  function ObjectPropertyDeclaration$_get_domain_$ref_u5oj2s() {
    return function (p0) {
      return p0.ufr();
    };
  }
  function ObjectPropertyDeclaration$_get_range_$ref_rc2nln() {
    return function (p0) {
      return p0.hd();
    };
  }
  function ObjectPropertyDeclaration$_get_dependent_$ref_o70pa5() {
    return function (p0) {
      return p0.hfs();
    };
  }
  function ObjectPropertyDeclaration$_get_inverse_$ref_tftvf2() {
    return function (p0) {
      return p0.ifs();
    };
  }
  function ObjectPropertyReferenceValue$_get_operand_$ref_4h40b1() {
    return function (p0) {
      return p0.jfs();
    };
  }
  function ObjectPropertyReferenceValue$_get_property_$ref_zar09b() {
    return function (p0) {
      return p0.q6q();
    };
  }
  function OldPublishedSource$_get_authorsProperty_$ref_umm0gx() {
    return function (p0) {
      return p0.kfs();
    };
  }
  function OldPublishedSource$_get_data_$ref_qz5g2a() {
    return function (p0) {
      return p0.lfs();
    };
  }
  function OneOf$_get_expressions_$ref_t8u9ia() {
    return function (p0) {
      return p0.mfs();
    };
  }
  function OntologyCardinalityRelation$_get_classExpression_$ref_42v2qv() {
    return function (p0) {
      return p0.hfq();
    };
  }
  function OntologyCardinalityRelation$_get_cardinality_$ref_ld39xl() {
    return function (p0) {
      return p0.dfr();
    };
  }
  function OntologyElement$_get_superElements_$ref_eb9rkn() {
    return function (p0) {
      return p0.nfs();
    };
  }
  function OntologyElement$_get_enclosingElements_$ref_uplwca() {
    return function (p0) {
      return p0.ofs();
    };
  }
  function OntologyElement$_get_taxon_$ref_my9s4f() {
    return function (p0) {
      return p0.pfs();
    };
  }
  function OntologyElement$_get_url_$ref_6gfppi() {
    return function (p0) {
      return p0.qfs();
    };
  }
  function OntologyElement$_get_nameHint_$ref_xvfepr() {
    return function (p0) {
      return p0.rfs();
    };
  }
  function OntologyElement$_get_additionalUrls_$ref_n8oe7a() {
    return function (p0) {
      return p0.sfs();
    };
  }
  function OntologyElement$_get_synonyms_$ref_j21l21() {
    return function (p0) {
      return p0.tfs();
    };
  }
  function OntologyElement$_get_xRefContainers_$ref_tur9gc() {
    return function (p0) {
      return p0.ufs();
    };
  }
  function OntologyElement$_get_oldDefinition_$ref_nndimn() {
    return function (p0) {
      return p0.vfs();
    };
  }
  function OntologyElement$_get_definition_$ref_ra1mma() {
    return function (p0) {
      return p0.wfs();
    };
  }
  function OntologyElementDefinition$_get_classExpression_$ref_7q14es() {
    return function (p0) {
      return p0.hfq();
    };
  }
  function OntologyElementPropertyType$_get_specificator_$ref_coyqyi() {
    return function (p0) {
      return p0.jfr();
    };
  }
  function OntologyElementPropertyType$_get_library_$ref_izz7j1() {
    return function (p0) {
      return p0.ffq();
    };
  }
  function OntologyElementPropertyType$_get_element_$ref_x8jl50() {
    return function (p0) {
      return p0.gfq();
    };
  }
  function OntologyElementReference$_get_element_$ref_3s4b1e() {
    return function (p0) {
      return p0.gfq();
    };
  }
  function OntologyElementReferenceValue$_get_element_$ref_kjo2gj() {
    return function (p0) {
      return p0.gfq();
    };
  }
  function OntologyElementReferenceValueLibrary$_get_library_$ref_ni4dih() {
    return function (p0) {
      return p0.ffq();
    };
  }
  function OntologyElementSynonym$_get_name_$ref_ojzpad() {
    return function (p0) {
      return p0.y2();
    };
  }
  function OntologyElementType$_get_library_$ref_qnafmw() {
    return function (p0) {
      return p0.ffq();
    };
  }
  function OntologyElementType$_get_element_$ref_pl8d15() {
    return function (p0) {
      return p0.gfq();
    };
  }
  function OntologyImport$_get_ontology_$ref_5t3sat() {
    return function (p0) {
      return p0.xfs();
    };
  }
  function OntologyImport$_get_element_$ref_7h70ks() {
    return function (p0) {
      return p0.gfq();
    };
  }
  function OntologyImport$_get_libraryToUse_$ref_z1ihvd() {
    return function (p0) {
      return p0.yfs();
    };
  }
  function OntologyImportRoot$_get_imports_$ref_rcorbw() {
    return function (p0) {
      return p0.zfp();
    };
  }
  function OntologyImportRootReference$_get_ref_$ref_qpspni() {
    return function (p0) {
      return p0.yfq();
    };
  }
  function OntologyIsRelation$_get_elementReferenceProvider_$ref_bgjhbd() {
    return function (p0) {
      return p0.zfs();
    };
  }
  function OntologyLibrary$_get_elements_$ref_5im1vf() {
    return function (p0) {
      return p0.ifq();
    };
  }
  function OntologyLibraryReference$_get_ref_$ref_894de0() {
    return function (p0) {
      return p0.yfq();
    };
  }
  function OntologyLink$_get_link_$ref_38pp17() {
    return function (p0) {
      return p0.xa1();
    };
  }
  function OntologyLink$_get_defaultLibraryReference_$ref_7bd1ik() {
    return function (p0) {
      return p0.aft();
    };
  }
  function OntologyLinkDeclarationValueQuery$_get_linkDeclaration_$ref_tqydwc() {
    return function (p0) {
      return p0.bft();
    };
  }
  function OntologyLinkValue$_get_linkReference_$ref_kx9ikt() {
    return function (p0) {
      return p0.cft();
    };
  }
  function OrValueQuery$_get_left_$ref_6b13k3() {
    return function (p0) {
      return p0.dft();
    };
  }
  function OrValueQuery$_get_right_$ref_trhuiu() {
    return function (p0) {
      return p0.eft();
    };
  }
  function Page$_get_page_$ref_r03c4g() {
    return function (p0) {
      return p0.fft();
    };
  }
  function PageRange$_get_start_$ref_aos33s() {
    return function (p0) {
      return p0.p1();
    };
  }
  function PageRange$_get_end_$ref_yt6pin() {
    return function (p0) {
      return p0.lb4();
    };
  }
  function Paper$_get_sourceShortTitle_$ref_ie9m1x() {
    return function (p0) {
      return p0.gft();
    };
  }
  function Paper$_get_sourceFullTitle_$ref_16bavu() {
    return function (p0) {
      return p0.hft();
    };
  }
  function Paper$_get_volume_$ref_y3o3l4() {
    return function (p0) {
      return p0.ift();
    };
  }
  function Paper$_get_issue_$ref_72q3ox() {
    return function (p0) {
      return p0.jft();
    };
  }
  function Paper$_get_pubMedId_$ref_8q78t4() {
    return function (p0) {
      return p0.kft();
    };
  }
  function Paper$_get_pmcId_$ref_yj2pzt() {
    return function (p0) {
      return p0.lft();
    };
  }
  function Paper$_get_doi_$ref_ww6hfa() {
    return function (p0) {
      return p0.mft();
    };
  }
  function Paper$_get_pages_$ref_56726c() {
    return function (p0) {
      return p0.nft();
    };
  }
  function PartValue$_get_operand_$ref_v35dwv() {
    return function (p0) {
      return p0.jfs();
    };
  }
  function PartValue$_get_operation_$ref_y8479p() {
    return function (p0) {
      return p0.s3z();
    };
  }
  function PrimitiveNotionType$_get_primitiveKind_$ref_8wvqnr() {
    return function (p0) {
      return p0.oft();
    };
  }
  function PrimitivePropertyType$_get_primitiveKind_$ref_evjzav() {
    return function (p0) {
      return p0.oft();
    };
  }
  function ProcessDeclaration$_get_kind_$ref_2xm341() {
    return function (p0) {
      return p0.r5a();
    };
  }
  function ProcessDeclaration$_get_extends_$ref_8vc9n2() {
    return function (p0) {
      return p0.pft();
    };
  }
  function ProcessDeclaration$_get_inherited_$ref_wglzfx() {
    return function (p0) {
      return p0.qft();
    };
  }
  function ProcessDeclaration$_get_prerequisites_$ref_h8hogm() {
    return function (p0) {
      return p0.rft();
    };
  }
  function ProcessDeclaration$_get_effects_$ref_9vh0jp() {
    return function (p0) {
      return p0.sft();
    };
  }
  function ProcessDeclaration$_get_urls_$ref_6bvrzj() {
    return function (p0) {
      return p0.tft();
    };
  }
  function ProcessDeclaration$_get_inheritedProperties_$ref_y4og6() {
    return function (p0) {
      return p0.uft();
    };
  }
  function ProcessEffect$_get_entry_$ref_q4qg2e() {
    return function (p0) {
      return p0.vft();
    };
  }
  function ProcessKindContainer$_get_kinds_$ref_mesqat() {
    return function (p0) {
      return p0.wft();
    };
  }
  function ProcessLibrary$_get_processes_$ref_ex5w39() {
    return function (p0) {
      return p0.xft();
    };
  }
  function ProcessProperty$_get_type_$ref_nw63hc() {
    return function (p0) {
      return p0.sfq();
    };
  }
  function ProcessProperty$_get_aliasedProperties_$ref_lzqazi() {
    return function (p0) {
      return p0.yft();
    };
  }
  function ProcessProperty$_get_default_$ref_tilfgf() {
    return function (p0) {
      return p0.g3b();
    };
  }
  function ProcessPropertyCustomCell$_get_property_$ref_xoqnwu() {
    return function (p0) {
      return p0.q6q();
    };
  }
  function ProcessPropertyDefault$_get_value_$ref_p903q0() {
    return function (p0) {
      return p0.a1();
    };
  }
  function ProcessPropertyReference$_get_property_$ref_cvezoe() {
    return function (p0) {
      return p0.q6q();
    };
  }
  function ProcessPropertyValue$_get_property_$ref_uw44qs() {
    return function (p0) {
      return p0.q6q();
    };
  }
  function ProcessPropertyValue$_get_value_$ref_tp5tnc() {
    return function (p0) {
      return p0.a1();
    };
  }
  function ProcessReference$_get_process_$ref_dj3f61() {
    return function (p0) {
      return p0.vfr();
    };
  }
  function ProcessRelationDeclaration$_get_symbol_$ref_emzgvd() {
    return function (p0) {
      return p0.zft();
    };
  }
  function ProcessRelationDeclaration$_get_direction_$ref_nz8wp8() {
    return function (p0) {
      return p0.afu();
    };
  }
  function ProcessRelationDeclaration$_get_effect_$ref_iad94u() {
    return function (p0) {
      return p0.bfu();
    };
  }
  function ProcessType$_get_specification_$ref_tigm72() {
    return function (p0) {
      return p0.vfq();
    };
  }
  function PropertyConstraint$_get_operation_$ref_7z13uv() {
    return function (p0) {
      return p0.s3z();
    };
  }
  function PropertyConstraint$_get_property_$ref_tgowqf() {
    return function (p0) {
      return p0.q6q();
    };
  }
  function PropertyConstraint$_get_value_$ref_f1oxa5() {
    return function (p0) {
      return p0.a1();
    };
  }
  function PropertyCustomCell$_get_property_$ref_w2rusf() {
    return function (p0) {
      return p0.q6q();
    };
  }
  function PropertyDeclaration$_get_type_$ref_g8rthd() {
    return function (p0) {
      return p0.sfq();
    };
  }
  function PropertyDeclarationValueQuery$_get_propertyDeclaration_$ref_e83vu5() {
    return function (p0) {
      return p0.cfu();
    };
  }
  function PropertyLibrary$_get_elements_$ref_sclji9() {
    return function (p0) {
      return p0.ifq();
    };
  }
  function PropertyReferenceOperation$_get_property_$ref_vdhpuw() {
    return function (p0) {
      return p0.q6q();
    };
  }
  function PropertyReferenceOperation$_get_parameter_$ref_b85xok() {
    return function (p0) {
      return p0.dfu();
    };
  }
  function PropertyValue$_get_property_$ref_q9j7al() {
    return function (p0) {
      return p0.q6q();
    };
  }
  function PubMedSourceReference$_get_pubMedId_$ref_1o1oab() {
    return function (p0) {
      return p0.kft();
    };
  }
  function PublishedSourceReference$_get_source_$ref_v1fin3() {
    return function (p0) {
      return p0.m6d();
    };
  }
  function PublishedSourceReference$_get_pageSpecification_$ref_qx42i2() {
    return function (p0) {
      return p0.efu();
    };
  }
  function PublishedSourcesLibrary$_get_items_$ref_b4kv1p() {
    return function (p0) {
      return p0.l2n();
    };
  }
  function PublishedWork$_get_publisher_$ref_wshpep() {
    return function (p0) {
      return p0.ffu();
    };
  }
  function PublishedWork$_get_date_$ref_2srppr() {
    return function (p0) {
      return p0.gfu();
    };
  }
  function QualifiedOntologyElementReference$_get_libraryReference_$ref_eai4yc() {
    return function (p0) {
      return p0.hfu();
    };
  }
  function QualifiedOntologyElementReference$_get_elementReference_$ref_8q8mxh() {
    return function (p0) {
      return p0.ifu();
    };
  }
  function QueryCommands$_get_commands_$ref_yrumbe() {
    return function (p0) {
      return p0.u51();
    };
  }
  function QueryParametersBlackList$_get_library_$ref_orkkq4() {
    return function (p0) {
      return p0.ffq();
    };
  }
  function QueryParametersBlackList$_get_elements_$ref_q86wjg() {
    return function (p0) {
      return p0.ifq();
    };
  }
  function RelationContainer$_get_processRelations_$ref_503twx() {
    return function (p0) {
      return p0.jfu();
    };
  }
  function RelationContainer$_get_instanceRelations_$ref_i7dwvz() {
    return function (p0) {
      return p0.kfu();
    };
  }
  function RelationFactExpression$_get_left_$ref_54k8bt() {
    return function (p0) {
      return p0.dft();
    };
  }
  function RelationFactExpression$_get_right_$ref_6t11ls() {
    return function (p0) {
      return p0.eft();
    };
  }
  function RelationFactExpression$_get_relation_$ref_nkh94u() {
    return function (p0) {
      return p0.xfq();
    };
  }
  function SetExpression$_get_expressions_$ref_ildcnv() {
    return function (p0) {
      return p0.mfs();
    };
  }
  function SetExpression$_get_isOpen_$ref_wh1gog() {
    return function (p0) {
      return p0.lfu();
    };
  }
  function SetValuedPropertyParameter$_get_value_$ref_w1ervu() {
    return function (p0) {
      return p0.a1();
    };
  }
  function SimplePropertyType$_get_notion_$ref_xv0vzc() {
    return function (p0) {
      return p0.mfq();
    };
  }
  function SinglePropertyValueRange$_get_types_$ref_qpyu2c() {
    return function (p0) {
      return p0.cfs();
    };
  }
  function StringValue$_get_value_$ref_2kxcol() {
    return function (p0) {
      return p0.a1();
    };
  }
  function TextLine$_get_text_$ref_oszt1s() {
    return function (p0) {
      return p0.o8w();
    };
  }
  function UnionClass$_get_classes_$ref_qbevup() {
    return function (p0) {
      return p0.mfu();
    };
  }
  function Url$_get_value_$ref_ipaaxy() {
    return function (p0) {
      return p0.a1();
    };
  }
  function UrlKnowledgeSourceReference$_get_url_$ref_7q1e5u() {
    return function (p0) {
      return p0.qfs();
    };
  }
  function ValueWithRelations$_get_value_$ref_wsflth() {
    return function (p0) {
      return p0.a1();
    };
  }
  function ValueWithRelations$_get_relations_$ref_f0av7f() {
    return function (p0) {
      return p0.nfu();
    };
  }
  function VariableDeclaration$_get_spec_$ref_h7083f() {
    return function (p0) {
      return p0.ofu();
    };
  }
  function VariableDeclaration$_get_relations_$ref_zic3pf() {
    return function (p0) {
      return p0.nfu();
    };
  }
  function VariablePattern$_get_variable_$ref_umy4xe() {
    return function (p0) {
      return p0.pfu();
    };
  }
  function VariableReferenceValue$_get_variable_$ref_zhtoxs() {
    return function (p0) {
      return p0.pfu();
    };
  }
  function XRefContainer$_get_xRef_$ref_p0397h() {
    return function (p0) {
      return p0.qfu();
    };
  }
  function LinkStub$_get_name_$ref_o9qxf9() {
    return function (p0) {
      return p0.y2();
    };
  }
  function PropertyStub$_get_type_$ref_iyorzz() {
    return function (p0) {
      return p0.sfq();
    };
  }
  function PropertyStub$_get_name_$ref_75aflc() {
    return function (p0) {
      return p0.y2();
    };
  }
  function DirectlyNamed$_get_name_$ref_qbhw34() {
    return function (p0) {
      return p0.y2();
    };
  }
  function DocumentNode$_get_documentId_$ref_eou2dn() {
    return function (p0) {
      return p0.d6g();
    };
  }
  function BtbMetaModel() {
    BtbMetaModel_instance = this;
    var tmp = this;
    var tmp_0 = getKClass(AbstractBindingDeclaration);
    var tmp_1 = listOf_0([getKClass(BTBNode), getKClass(DirectlyNamed), getKClass(HasComments)]);
    var tmp_2 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_0 = getPropertyCallableRef('ontologyElements', 1, tmp_2, AbstractBindingDeclaration$_get_ontologyElements_$ref_egks01(), null);
    var tmp0_link = new MultipleChildLink(getKClass(AbstractBindingDeclaration), this_0);
    var tmp_3 = new ChildrenMemberData(tmp0_link, 'ontologyElements', getKClass(OntologyElementType_1), true);
    var tmp_4 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_1 = getPropertyCallableRef('entries', 1, tmp_4, AbstractBindingDeclaration$_get_entries_$ref_fnlsrh(), null);
    var tmp1_link = new MultipleChildLink(getKClass(AbstractBindingDeclaration), this_1);
    var tmp_5 = new ChildrenMemberData(tmp1_link, 'entries', getKClass(AbstractBindingEntry), true);
    var tmp_6 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_2 = getPropertyCallableRef('properties', 1, tmp_6, AbstractBindingDeclaration$_get_properties_$ref_4foxw4(), null);
    var tmp2_link = new MultipleChildLink(getKClass(AbstractBindingDeclaration), this_2);
    var tmp_7 = new ChildrenMemberData(tmp2_link, 'properties', getKClass(ProcessProperty_1), true);
    var tmp_8 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_3 = getPropertyCallableRef('customEditor', 1, tmp_8, AbstractBindingDeclaration$_get_customEditor_$ref_6c7l07(), null);
    var tmp3_link = new SingleChildLink(getKClass(AbstractBindingDeclaration), this_3);
    var tmp_9 = new ChildrenMemberData(tmp3_link, 'customEditor', getKClass(CustomEditor), false);
    var tmp_10 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_4 = getPropertyCallableRef('customEditorEnabled', 1, tmp_10, AbstractBindingDeclaration$_get_customEditorEnabled_$ref_h4m7ao(), null);
    var tmp$ret$4 = new ValueAttributeLink(getKClass(AbstractBindingDeclaration), this_4, createKType(PrimitiveClasses_getInstance().lb(), arrayOf([]), false));
    var tmp_11 = to(tmp_0, new ConceptData('AbstractBindingDeclaration', 'jetbrains.biokb.lang.model.AbstractBindingDeclaration', false, false, VOID, tmp_1, listOf_0([tmp_3, tmp_5, tmp_7, tmp_9, new AttributeData(tmp$ret$4, 'customEditorEnabled', new SimpleAttributeType(false, PrimitiveClasses_getInstance().lb()))])));
    var tmp_12 = to(getKClass(AbstractBindingEntry), new ConceptData('AbstractBindingEntry', 'jetbrains.biokb.lang.model.AbstractBindingEntry', false, false, VOID, listOf(getKClass(BTBNode))));
    var tmp_13 = getKClass(AbstractBindingValue);
    var tmp_14 = getKClass(BindingValuePlaceholder_1);
    var tmp_15 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_5 = getPropertyCallableRef('value', 1, tmp_15, AbstractBindingValue$_get_value_$ref_r1k0yv(), null);
    var tmp4_link = new SingleChildLink(getKClass(AbstractBindingValue), this_5);
    var tmp_16 = to(tmp_13, new ConceptData('AbstractBindingValue', 'jetbrains.biokb.lang.model.AbstractBindingValue', false, false, tmp_14, VOID, listOf(new ChildrenMemberData(tmp4_link, 'value', getKClass(AbstractValue), false))));
    var tmp_17 = to(getKClass(AbstractBindingValueQuery), new ConceptData('AbstractBindingValueQuery', 'jetbrains.biokb.lang.model.AbstractBindingValueQuery', false, false, getKClass(BindingValuePlaceholderQuery_1)));
    var tmp_18 = getKClass(AbstractLink);
    var tmp_19 = getKClass(AbstractBindingEntry);
    var tmp_20 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var this_6 = getPropertyCallableRef('specializes', 1, tmp_20, AbstractLink$_get_specializes_$ref_yv3dpc(), null);
    var tmp5_link = new ReferenceLink(getKClass(AbstractLink), this_6, getKClass(AbstractLink), getKClass(QualifiedReferenceContent));
    var tmp_21 = to(tmp_18, new ConceptData('AbstractLink', 'jetbrains.biokb.lang.model.AbstractLink', false, false, tmp_19, VOID, listOf(new ReferenceMemberData(tmp5_link, 'specializes', getKClass(AbstractLink)))));
    var tmp_22 = to(getKClass(AbstractNotion), new ConceptData('AbstractNotion', 'jetbrains.biokb.lang.model.AbstractNotion', false, false, VOID, listOf_0([getKClass(BTBNode), getKClass(DirectlyNamed)])));
    var tmp_23 = to(getKClass(AbstractOntologyRelation), new ConceptData('AbstractOntologyRelation', 'jetbrains.biokb.lang.model.AbstractOntologyRelation', false, false, VOID, listOf(getKClass(BTBNode))));
    var tmp_24 = to(getKClass(AbstractProcessSpecification), new ConceptData('AbstractProcessSpecification', 'jetbrains.biokb.lang.model.AbstractProcessSpecification', false, false, VOID, listOf(getKClass(BTBNode))));
    var tmp_25 = to(getKClass(AbstractProperty), new ConceptData('AbstractProperty', 'jetbrains.biokb.lang.model.AbstractProperty', false, false, getKClass(AbstractBindingEntry)));
    var tmp_26 = to(getKClass(AbstractValue), new ConceptData('AbstractValue', 'jetbrains.biokb.lang.model.AbstractValue', false, false, VOID, listOf(getKClass(BTBNode))));
    var tmp_27 = to(getKClass(AllowedComplexNotionType), new ConceptData('AllowedComplexNotionType', 'jetbrains.biokb.lang.model.AllowedComplexNotionType', false, false, VOID, listOf(getKClass(BTBNode))));
    var tmp_28 = to(getKClass(AllowedComplexNotionValue), new ConceptData('AllowedComplexNotionValue', 'jetbrains.biokb.lang.model.AllowedComplexNotionValue', false, false, VOID, listOf(getKClass(BTBNode))));
    var tmp_29 = to(getKClass(AnonymousClass), new ConceptData('AnonymousClass', 'jetbrains.biokb.lang.model.AnonymousClass', false, false, VOID, listOf_0([getKClass(ClassExpression), getKClass(ClassDeclaration), getKClass(AbstractValue), getKClass(FactExpression)])));
    var tmp_30 = to(getKClass(Author_1), new ConceptData('Author', 'jetbrains.biokb.lang.model.Author', true, false, VOID, listOf_0([getKClass(DirectlyNamed), getKClass(BTBNode)])));
    var tmp_31 = getKClass(AuthoredWork);
    var tmp_32 = listOf(getKClass(BTBNode));
    var tmp_33 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_7 = getPropertyCallableRef('authors', 1, tmp_33, AuthoredWork$_get_authors_$ref_88kya7(), null);
    var tmp6_link = new MultipleChildLink(getKClass(AuthoredWork), this_7);
    var tmp_34 = new ChildrenMemberData(tmp6_link, 'authors', getKClass(Author_1), true);
    var tmp_35 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_8 = getPropertyCallableRef('title', 1, tmp_35, AuthoredWork$_get_title_$ref_mtfkzj(), null);
    var tmp$ret$8 = new ValueAttributeLink(getKClass(AuthoredWork), this_8, createKType(PrimitiveClasses_getInstance().tb(), arrayOf([]), false));
    var tmp_36 = to(tmp_31, new ConceptData('AuthoredWork', 'jetbrains.biokb.lang.model.AuthoredWork', true, false, VOID, tmp_32, listOf_0([tmp_34, new AttributeData(tmp$ret$8, 'title', new SimpleAttributeType(false, PrimitiveClasses_getInstance().tb()))])));
    var tmp_37 = getKClass(BTBDocument_1);
    var tmp_38 = getKClass(DocumentNode_0);
    var tmp_39 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_9 = getPropertyCallableRef('factSets', 1, tmp_39, BTBDocument$_get_factSets_$ref_40l74m(), null);
    var tmp7_link = new MultipleChildLink(getKClass(BTBDocument_1), this_9);
    var tmp_40 = new ChildrenMemberData(tmp7_link, 'factSets', getKClass(FactSet_1), true);
    var tmp_41 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_10 = getPropertyCallableRef('categories', 1, tmp_41, BTBDocument$_get_categories_$ref_emheyf(), null);
    var tmp8_link = new MultipleChildLink(getKClass(BTBDocument_1), this_10);
    var tmp_42 = new ChildrenMemberData(tmp8_link, 'categories', getKClass(Category_1), true);
    var tmp_43 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_11 = getPropertyCallableRef('imports', 1, tmp_43, BTBDocument$_get_imports_$ref_o0awgp(), null);
    var tmp9_link = new MultipleChildLink(getKClass(BTBDocument_1), this_11);
    var tmp_44 = to(tmp_37, new ConceptData('BTBDocument', 'jetbrains.biokb.lang.model.BTBDocument', true, false, tmp_38, VOID, listOf_0([tmp_40, tmp_42, new ChildrenMemberData(tmp9_link, 'imports', getKClass(OntologyImportRootReference_1), true)])));
    var tmp_45 = to(getKClass(BTBNode), new ConceptData('BTBNode', 'jetbrains.biokb.lang.model.BTBNode', false, false));
    var tmp_46 = getKClass(BindingProperty_1);
    var tmp_47 = getKClass(AbstractProperty);
    var tmp_48 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_12 = getPropertyCallableRef('property', 1, tmp_48, BindingProperty$_get_property_$ref_iv28zz(), null);
    var tmp10_link = new SingleChildLink(getKClass(BindingProperty_1), this_12);
    var tmp_49 = to(tmp_46, new ConceptData('BindingProperty', 'jetbrains.biokb.lang.model.BindingProperty', true, false, tmp_47, VOID, listOf(new ChildrenMemberData(tmp10_link, 'property', getKClass(PropertyDeclaration_1), false))));
    var tmp_50 = getKClass(BindingValueMask_1);
    var tmp_51 = getKClass(AbstractBindingValueQuery);
    var tmp_52 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_13 = getPropertyCallableRef('value', 1, tmp_52, BindingValueMask$_get_value_$ref_srt04j(), null);
    var tmp11_link = new SingleChildLink(getKClass(BindingValueMask_1), this_13);
    var tmp_53 = to(tmp_50, new ConceptData('BindingValueMask', 'jetbrains.biokb.lang.model.BindingValueMask', true, false, tmp_51, VOID, listOf(new ChildrenMemberData(tmp11_link, 'value', getKClass(BindingValuePlaceholder_1), false))));
    var tmp_54 = to(getKClass(BindingValuePlaceholder_1), new ConceptData('BindingValuePlaceholder', 'jetbrains.biokb.lang.model.BindingValuePlaceholder', true, false, VOID, listOf(getKClass(BTBNode))));
    var tmp_55 = to(getKClass(BindingValuePlaceholderQuery_1), new ConceptData('BindingValuePlaceholderQuery', 'jetbrains.biokb.lang.model.BindingValuePlaceholderQuery', true, false, VOID, listOf(getKClass(BTBNode))));
    var tmp_56 = getKClass(Book_1);
    var tmp_57 = getKClass(PublishedWork);
    var tmp_58 = listOf(getKClass(LibraryItem));
    var tmp_59 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_14 = getPropertyCallableRef('edition', 1, tmp_59, Book$_get_edition_$ref_uuzusn(), null);
    var tmp$ret$14 = new ValueAttributeLink(getKClass(Book_1), this_14, createKType(PrimitiveClasses_getInstance().tb(), arrayOf([]), false));
    var tmp_60 = to(tmp_56, new ConceptData('Book', 'jetbrains.biokb.lang.model.Book', true, false, tmp_57, tmp_58, listOf(new AttributeData(tmp$ret$14, 'edition', new SimpleAttributeType(false, PrimitiveClasses_getInstance().tb())))));
    var tmp_61 = getKClass(Cardinality_1);
    var tmp_62 = listOf(getKClass(BTBNode));
    var tmp_63 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_15 = getPropertyCallableRef('lowerBound', 1, tmp_63, Cardinality$_get_lowerBound_$ref_entgur(), null);
    var tmp12_link = new SingleChildLink(getKClass(Cardinality_1), this_15);
    var tmp_64 = new ChildrenMemberData(tmp12_link, 'lowerBound', getKClass(CardinalityBoundConstant_1), false);
    var tmp_65 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_16 = getPropertyCallableRef('upperBound', 1, tmp_65, Cardinality$_get_upperBound_$ref_jgtibw(), null);
    var tmp13_link = new SingleChildLink(getKClass(Cardinality_1), this_16);
    var tmp_66 = new ChildrenMemberData(tmp13_link, 'upperBound', getKClass(CardinalityBoundPlaceholder_1), false);
    var tmp_67 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_17 = getPropertyCallableRef('deprecatedUpperBound', 1, tmp_67, Cardinality$_get_deprecatedUpperBound_$ref_fpwpvl(), null);
    var tmp14_link = new SingleChildLink(getKClass(Cardinality_1), this_17);
    var tmp_68 = to(tmp_61, new ConceptData('Cardinality', 'jetbrains.biokb.lang.model.Cardinality', true, false, VOID, tmp_62, listOf_0([tmp_64, tmp_66, new ChildrenMemberData(tmp14_link, 'deprecatedUpperBound', getKClass(CardinalityBoundPlaceholder_1), false)])));
    var tmp_69 = to(getKClass(CardinalityBound), new ConceptData('CardinalityBound', 'jetbrains.biokb.lang.model.CardinalityBound', true, false, VOID, listOf(getKClass(BTBNode))));
    var tmp_70 = getKClass(CardinalityBoundConstant_1);
    var tmp_71 = getKClass(CardinalityBound);
    var tmp_72 = listOf(getKClass(BTBNode));
    var tmp_73 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_18 = getPropertyCallableRef('value', 1, tmp_73, CardinalityBoundConstant$_get_value_$ref_d0ff0h(), null);
    var tmp$ret$18 = new ValueAttributeLink(getKClass(CardinalityBoundConstant_1), this_18, createKType(PrimitiveClasses_getInstance().ob(), arrayOf([]), false));
    var tmp_74 = to(tmp_70, new ConceptData('CardinalityBoundConstant', 'jetbrains.biokb.lang.model.CardinalityBoundConstant', true, false, tmp_71, tmp_72, listOf(new AttributeData(tmp$ret$18, 'value', new SimpleAttributeType(false, PrimitiveClasses_getInstance().ob())))));
    var tmp_75 = to(getKClass(CardinalityBoundN_1), new ConceptData('CardinalityBoundN', 'jetbrains.biokb.lang.model.CardinalityBoundN', true, false, getKClass(CardinalityBound)));
    var tmp_76 = getKClass(CardinalityBoundPlaceholder_1);
    var tmp_77 = listOf(getKClass(BTBNode));
    var tmp_78 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_19 = getPropertyCallableRef('bound', 1, tmp_78, CardinalityBoundPlaceholder$_get_bound_$ref_92a5xd(), null);
    var tmp15_link = new SingleChildLink(getKClass(CardinalityBoundPlaceholder_1), this_19);
    var tmp_79 = to(tmp_76, new ConceptData('CardinalityBoundPlaceholder', 'jetbrains.biokb.lang.model.CardinalityBoundPlaceholder', true, false, VOID, tmp_77, listOf(new ChildrenMemberData(tmp15_link, 'bound', getKClass(CardinalityBound), false))));
    var tmp_80 = to(getKClass(CardinalityCustomCell_1), new ConceptData('CardinalityCustomCell', 'jetbrains.biokb.lang.model.CardinalityCustomCell', true, false, getKClass(CustomCell)));
    var tmp_81 = getKClass(Category_1);
    var tmp_82 = listOf(getKClass(BTBNode));
    var tmp_83 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_20 = getPropertyCallableRef('library', 1, tmp_83, Category$_get_library_$ref_sghxsx(), null);
    var tmp16_link = new SingleChildLink(getKClass(Category_1), this_20);
    var tmp_84 = new ChildrenMemberData(tmp16_link, 'library', getKClass(OntologyLibraryReference_1), false);
    var tmp_85 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_21 = getPropertyCallableRef('element', 1, tmp_85, Category$_get_element_$ref_9nwohu(), null);
    var tmp17_link = new SingleChildLink(getKClass(Category_1), this_21);
    var tmp_86 = to(tmp_81, new ConceptData('Category', 'jetbrains.biokb.lang.model.Category', true, false, VOID, tmp_82, listOf_0([tmp_84, new ChildrenMemberData(tmp17_link, 'element', getKClass(OntologyElementReference_1), false)])));
    var tmp_87 = to(getKClass(ClassDeclaration), new ConceptData('ClassDeclaration', 'jetbrains.biokb.lang.model.ClassDeclaration', false, false, VOID, listOf(getKClass(BTBNode))));
    var tmp_88 = to(getKClass(ClassExpression), new ConceptData('ClassExpression', 'jetbrains.biokb.lang.model.ClassExpression', false, false, getKClass(ClassExpressionPlaceholder_1)));
    var tmp_89 = to(getKClass(ClassExpressionPlaceholder_1), new ConceptData('ClassExpressionPlaceholder', 'jetbrains.biokb.lang.model.ClassExpressionPlaceholder', true, false, VOID, listOf(getKClass(BTBNode))));
    var tmp_90 = getKClass(ClassExpressionType_1);
    var tmp_91 = getKClass(Type);
    var tmp_92 = listOf(getKClass(ProcessPropertyType));
    var tmp_93 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_22 = getPropertyCallableRef('classExpression', 1, tmp_93, ClassExpressionType$_get_classExpression_$ref_lk9vu2(), null);
    var tmp18_link = new SingleChildLink(getKClass(ClassExpressionType_1), this_22);
    var tmp_94 = to(tmp_90, new ConceptData('ClassExpressionType', 'jetbrains.biokb.lang.model.ClassExpressionType', true, true, tmp_91, tmp_92, listOf(new ChildrenMemberData(tmp18_link, 'classExpression', getKClass(UnionClass_1), false))));
    var tmp_95 = to(getKClass(Command_0), new ConceptData('Command', 'jetbrains.biokb.lang.model.Command', false, false, VOID, listOf(getKClass(BTBNode))));
    var tmp_96 = getKClass(ComplexNotion_1);
    var tmp_97 = getKClass(AbstractNotion);
    var tmp_98 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_23 = getPropertyCallableRef('elements', 1, tmp_98, ComplexNotion$_get_elements_$ref_mrhdwi(), null);
    var tmp19_link = new MultipleChildLink(getKClass(ComplexNotion_1), this_23);
    var tmp_99 = new ChildrenMemberData(tmp19_link, 'elements', getKClass(ComplexNotionElement_1), true);
    var tmp_100 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_24 = getPropertyCallableRef('template', 1, tmp_100, ComplexNotion$_get_template_$ref_kdbfun(), null);
    var tmp20_link = new SingleChildLink(getKClass(ComplexNotion_1), this_24);
    var tmp_101 = to(tmp_96, new ConceptData('ComplexNotion', 'jetbrains.biokb.lang.model.ComplexNotion', true, false, tmp_97, VOID, listOf_0([tmp_99, new ChildrenMemberData(tmp20_link, 'template', getKClass(ComplexNotionTemplate_1), false)])));
    var tmp_102 = getKClass(ComplexNotionElement_1);
    var tmp_103 = listOf_0([getKClass(BTBNode), getKClass(DirectlyNamed)]);
    var tmp_104 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_25 = getPropertyCallableRef('elementType', 1, tmp_104, ComplexNotionElement$_get_elementType_$ref_czuq0z(), null);
    var tmp21_link = new SingleChildLink(getKClass(ComplexNotionElement_1), this_25);
    var tmp_105 = new ChildrenMemberData(tmp21_link, 'elementType', getKClass(AllowedComplexNotionType), false);
    var tmp_106 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_26 = getPropertyCallableRef('unknownValueAllowed', 1, tmp_106, ComplexNotionElement$_get_unknownValueAllowed_$ref_30zrma(), null);
    var tmp$ret$26 = new ValueAttributeLink(getKClass(ComplexNotionElement_1), this_26, createKType(PrimitiveClasses_getInstance().lb(), arrayOf([]), false));
    var tmp_107 = to(tmp_102, new ConceptData('ComplexNotionElement', 'jetbrains.biokb.lang.model.ComplexNotionElement', true, false, VOID, tmp_103, listOf_0([tmp_105, new AttributeData(tmp$ret$26, 'unknownValueAllowed', new SimpleAttributeType(false, PrimitiveClasses_getInstance().lb()))])));
    var tmp_108 = getKClass(ComplexNotionElementValue_1);
    var tmp_109 = listOf(getKClass(BTBNode));
    var tmp_110 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var this_27 = getPropertyCallableRef('element', 1, tmp_110, ComplexNotionElementValue$_get_element_$ref_dgdsiu(), null);
    var tmp22_link = new ReferenceLink(getKClass(ComplexNotionElementValue_1), this_27, getKClass(ComplexNotionElement_1), getKClass(QualifiedReferenceContent));
    var tmp_111 = new ReferenceMemberData(tmp22_link, 'element', getKClass(ComplexNotionElement_1));
    var tmp_112 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_28 = getPropertyCallableRef('value', 1, tmp_112, ComplexNotionElementValue$_get_value_$ref_kz5f7p(), null);
    var tmp23_link = new SingleChildLink(getKClass(ComplexNotionElementValue_1), this_28);
    var tmp_113 = to(tmp_108, new ConceptData('ComplexNotionElementValue', 'jetbrains.biokb.lang.model.ComplexNotionElementValue', true, false, VOID, tmp_109, listOf_0([tmp_111, new ChildrenMemberData(tmp23_link, 'value', getKClass(AllowedComplexNotionValue), false)])));
    var tmp_114 = getKClass(ComplexNotionTemplate_1);
    var tmp_115 = listOf(getKClass(BTBNode));
    var tmp_116 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_29 = getPropertyCallableRef('elements', 1, tmp_116, ComplexNotionTemplate$_get_elements_$ref_5kithk(), null);
    var tmp24_link = new MultipleChildLink(getKClass(ComplexNotionTemplate_1), this_29);
    var tmp_117 = to(tmp_114, new ConceptData('ComplexNotionTemplate', 'jetbrains.biokb.lang.model.ComplexNotionTemplate', true, false, VOID, tmp_115, listOf(new ChildrenMemberData(tmp24_link, 'elements', getKClass(ComplexNotionTemplateElement), true))));
    var tmp_118 = to(getKClass(ComplexNotionTemplateElement), new ConceptData('ComplexNotionTemplateElement', 'jetbrains.biokb.lang.model.ComplexNotionTemplateElement', false, false, VOID, listOf(getKClass(BTBNode))));
    var tmp_119 = to(getKClass(ComplexNotionTemplatePlaceholder_1), new ConceptData('ComplexNotionTemplatePlaceholder', 'jetbrains.biokb.lang.model.ComplexNotionTemplatePlaceholder', true, false, getKClass(ComplexNotionTemplateElement)));
    var tmp_120 = getKClass(ComplexNotionTemplateRefElement_1);
    var tmp_121 = getKClass(ComplexNotionTemplateElement);
    var tmp_122 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var this_30 = getPropertyCallableRef('element', 1, tmp_122, ComplexNotionTemplateRefElement$_get_element_$ref_c3f83c(), null);
    var tmp25_link = new ReferenceLink(getKClass(ComplexNotionTemplateRefElement_1), this_30, getKClass(ComplexNotionElement_1), getKClass(LocalReferenceContent));
    var tmp_123 = to(tmp_120, new ConceptData('ComplexNotionTemplateRefElement', 'jetbrains.biokb.lang.model.ComplexNotionTemplateRefElement', true, false, tmp_121, VOID, listOf(new ReferenceMemberData(tmp25_link, 'element', getKClass(ComplexNotionElement_1)))));
    var tmp_124 = getKClass(ComplexNotionTemplateTextElement_1);
    var tmp_125 = getKClass(ComplexNotionTemplateElement);
    var tmp_126 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_31 = getPropertyCallableRef('text', 1, tmp_126, ComplexNotionTemplateTextElement$_get_text_$ref_ugb33(), null);
    var tmp$ret$31 = new ValueAttributeLink(getKClass(ComplexNotionTemplateTextElement_1), this_31, createKType(PrimitiveClasses_getInstance().tb(), arrayOf([]), false));
    var tmp_127 = to(tmp_124, new ConceptData('ComplexNotionTemplateTextElement', 'jetbrains.biokb.lang.model.ComplexNotionTemplateTextElement', true, false, tmp_125, VOID, listOf(new AttributeData(tmp$ret$31, 'text', new SimpleAttributeType(false, PrimitiveClasses_getInstance().tb())))));
    var tmp_128 = getKClass(ComplexNotionValue_1);
    var tmp_129 = listOf_0([getKClass(AbstractValue), getKClass(FactExpression)]);
    var tmp_130 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var this_32 = getPropertyCallableRef('notion', 1, tmp_130, ComplexNotionValue$_get_notion_$ref_1p18cj(), null);
    var tmp26_link = new ReferenceLink(getKClass(ComplexNotionValue_1), this_32, getKClass(ComplexNotion_1), getKClass(QualifiedReferenceContent));
    var tmp_131 = new ReferenceMemberData(tmp26_link, 'notion', getKClass(ComplexNotion_1));
    var tmp_132 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_33 = getPropertyCallableRef('elementValues', 1, tmp_132, ComplexNotionValue$_get_elementValues_$ref_bqs60m(), null);
    var tmp27_link = new MultipleChildLink(getKClass(ComplexNotionValue_1), this_33);
    var tmp_133 = to(tmp_128, new ConceptData('ComplexNotionValue', 'jetbrains.biokb.lang.model.ComplexNotionValue', true, false, VOID, tmp_129, listOf_0([tmp_131, new ChildrenMemberData(tmp27_link, 'elementValues', getKClass(ComplexNotionElementValue_1), true)])));
    var tmp_134 = getKClass(ConstantCustomCell_1);
    var tmp_135 = getKClass(CustomCell);
    var tmp_136 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_34 = getPropertyCallableRef('text', 1, tmp_136, ConstantCustomCell$_get_text_$ref_as957e(), null);
    var tmp$ret$34 = new ValueAttributeLink(getKClass(ConstantCustomCell_1), this_34, createKType(PrimitiveClasses_getInstance().tb(), arrayOf([]), false));
    var tmp_137 = to(tmp_134, new ConceptData('ConstantCustomCell', 'jetbrains.biokb.lang.model.ConstantCustomCell', true, false, tmp_135, VOID, listOf(new AttributeData(tmp$ret$34, 'text', new SimpleAttributeType(false, PrimitiveClasses_getInstance().tb())))));
    var tmp_138 = getKClass(ConstantPrecondition_0);
    var tmp_139 = getKClass(Precondition);
    var tmp_140 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_35 = getPropertyCallableRef('kind', 1, tmp_140, ConstantPrecondition$_get_kind_$ref_e7xzm6(), null);
    var tmp$ret$35 = new ValueAttributeLink(getKClass(ConstantPrecondition_0), this_35, createKType(getKClass(When), arrayOf([]), true));
    var tmp_141 = to(tmp_138, new ConceptData('ConstantPrecondition', 'jetbrains.biokb.lang.model.ConstantPrecondition', true, false, tmp_139, VOID, listOf(new AttributeData(tmp$ret$35, 'kind', new EnumAttributeType(true, getKClass(When), listOf_0([When_ALWAYS_getInstance(), When_NEVER_getInstance()]))))));
    var tmp_142 = getKClass(Context_2);
    var tmp_143 = listOf_0([getKClass(BTBNode), getKClass(DirectlyNamed)]);
    var tmp_144 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_36 = getPropertyCallableRef('library', 1, tmp_144, Context$_get_library_$ref_4eq8r4(), null);
    var tmp28_link = new SingleChildLink(getKClass(Context_2), this_36);
    var tmp_145 = new ChildrenMemberData(tmp28_link, 'library', getKClass(OntologyLibraryReference_1), false);
    var tmp_146 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_37 = getPropertyCallableRef('element', 1, tmp_146, Context$_get_element_$ref_n7bi27(), null);
    var tmp29_link = new SingleChildLink(getKClass(Context_2), this_37);
    var tmp_147 = to(tmp_142, new ConceptData('Context', 'jetbrains.biokb.lang.model.Context', true, false, VOID, tmp_143, listOf_0([tmp_145, new ChildrenMemberData(tmp29_link, 'element', getKClass(OntologyElementReference_1), false)])));
    var tmp_148 = getKClass(ContextQuery_1);
    var tmp_149 = listOf(getKClass(BTBNode));
    var tmp_150 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_38 = getPropertyCallableRef('library', 1, tmp_150, ContextQuery$_get_library_$ref_n5vw3e(), null);
    var tmp30_link = new SingleChildLink(getKClass(ContextQuery_1), this_38);
    var tmp_151 = new ChildrenMemberData(tmp30_link, 'library', getKClass(OntologyLibraryReference_1), false);
    var tmp_152 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_39 = getPropertyCallableRef('element', 1, tmp_152, ContextQuery$_get_element_$ref_t2mwkn(), null);
    var tmp31_link = new SingleChildLink(getKClass(ContextQuery_1), this_39);
    var tmp_153 = to(tmp_148, new ConceptData('ContextQuery', 'jetbrains.biokb.lang.model.ContextQuery', true, false, VOID, tmp_149, listOf_0([tmp_151, new ChildrenMemberData(tmp31_link, 'element', getKClass(OntologyElementReference_1), false)])));
    var tmp_154 = to(getKClass(CustomCell), new ConceptData('CustomCell', 'jetbrains.biokb.lang.model.CustomCell', false, false, VOID, listOf(getKClass(BTBNode))));
    var tmp_155 = getKClass(CustomEditor);
    var tmp_156 = listOf(getKClass(BTBNode));
    var tmp_157 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_40 = getPropertyCallableRef('cells', 1, tmp_157, CustomEditor$_get_cells_$ref_phh77b(), null);
    var tmp32_link = new MultipleChildLink(getKClass(CustomEditor), this_40);
    var tmp_158 = to(tmp_155, new ConceptData('CustomEditor', 'jetbrains.biokb.lang.model.CustomEditor', true, false, VOID, tmp_156, listOf(new ChildrenMemberData(tmp32_link, 'cells', getKClass(CustomCell), true))));
    var tmp_159 = to(getKClass(DeclarationNameCustomCell_1), new ConceptData('DeclarationNameCustomCell', 'jetbrains.biokb.lang.model.DeclarationNameCustomCell', true, false, getKClass(CustomCell)));
    var tmp_160 = getKClass(DeclarationValueQuery);
    var tmp_161 = getKClass(AbstractBindingValueQuery);
    var tmp_162 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_41 = getPropertyCallableRef('value', 1, tmp_162, DeclarationValueQuery$_get_value_$ref_j2fwpw(), null);
    var tmp33_link = new SingleChildLink(getKClass(DeclarationValueQuery), this_41);
    var tmp_163 = to(tmp_160, new ConceptData('DeclarationValueQuery', 'jetbrains.biokb.lang.model.DeclarationValueQuery', true, false, tmp_161, VOID, listOf(new ChildrenMemberData(tmp33_link, 'value', getKClass(AbstractValue), false))));
    var tmp_164 = to(getKClass(DocumentNode_0), new ConceptData('DocumentNode', 'jetbrains.biokb.lang.model.DocumentNode', false, false, VOID, listOf_0([getKClass(BTBNode), getKClass(DocumentNode), getKClass(ExternallyNamed)])));
    var tmp_165 = to(getKClass(EmptyBindingEntry_1), new ConceptData('EmptyBindingEntry', 'jetbrains.biokb.lang.model.EmptyBindingEntry', true, false, getKClass(AbstractBindingEntry)));
    var tmp_166 = to(getKClass(EmptyPropertyLibraryElement_1), new ConceptData('EmptyPropertyLibraryElement', 'jetbrains.biokb.lang.model.EmptyPropertyLibraryElement', true, false, VOID, listOf(getKClass(PropertyLibraryElement))));
    var tmp_167 = getKClass(EnumValue_1);
    var tmp_168 = listOf_0([getKClass(AbstractValue), getKClass(FactExpression), getKClass(AllowedComplexNotionValue)]);
    var tmp_169 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var this_42 = getPropertyCallableRef('constant', 1, tmp_169, EnumValue$_get_constant_$ref_wk6jkm(), null);
    var tmp34_link = new ReferenceLink(getKClass(EnumValue_1), this_42, getKClass(EnumerationConstant_1), getKClass(QualifiedReferenceContent));
    var tmp_170 = to(tmp_167, new ConceptData('EnumValue', 'jetbrains.biokb.lang.model.EnumValue', true, false, VOID, tmp_168, listOf(new ReferenceMemberData(tmp34_link, 'constant', getKClass(EnumerationConstant_1)))));
    var tmp_171 = getKClass(EnumerableNotion_1);
    var tmp_172 = getKClass(AbstractNotion);
    var tmp_173 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_43 = getPropertyCallableRef('constants', 1, tmp_173, EnumerableNotion$_get_constants_$ref_ynx7ue(), null);
    var tmp35_link = new MultipleChildLink(getKClass(EnumerableNotion_1), this_43);
    var tmp_174 = to(tmp_171, new ConceptData('EnumerableNotion', 'jetbrains.biokb.lang.model.EnumerableNotion', true, false, tmp_172, VOID, listOf(new ChildrenMemberData(tmp35_link, 'constants', getKClass(EnumerationConstant_1), true))));
    var tmp_175 = to(getKClass(EnumerationConstant_1), new ConceptData('EnumerationConstant', 'jetbrains.biokb.lang.model.EnumerationConstant', true, false, VOID, listOf_0([getKClass(BTBNode), getKClass(DirectlyNamed)])));
    var tmp_176 = getKClass(ExtensionDeclaration_1);
    var tmp_177 = listOf_0([getKClass(BTBNode), getKClass(DirectlyNamed)]);
    var tmp_178 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_44 = getPropertyCallableRef('fields', 1, tmp_178, ExtensionDeclaration$_get_fields_$ref_y00c96(), null);
    var tmp36_link = new MultipleChildLink(getKClass(ExtensionDeclaration_1), this_44);
    var tmp_179 = new ChildrenMemberData(tmp36_link, 'fields', getKClass(FieldDeclaration_1), true);
    var tmp_180 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_45 = getPropertyCallableRef('type', 1, tmp_180, ExtensionDeclaration$_get_type_$ref_2sz2on(), null);
    var tmp37_link = new SingleChildLink(getKClass(ExtensionDeclaration_1), this_45);
    var tmp_181 = to(tmp_176, new ConceptData('ExtensionDeclaration', 'jetbrains.biokb.lang.model.ExtensionDeclaration', true, false, VOID, tmp_177, listOf_0([tmp_179, new ChildrenMemberData(tmp37_link, 'type', getKClass(OntologyElementType_1), false)])));
    var tmp_182 = getKClass(ExtensionFieldReference_1);
    var tmp_183 = getKClass(PartReferenceOperation);
    var tmp_184 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var this_46 = getPropertyCallableRef('field', 1, tmp_184, ExtensionFieldReference$_get_field_$ref_4bdhle(), null);
    var tmp38_link = new ReferenceLink(getKClass(ExtensionFieldReference_1), this_46, getKClass(FieldDeclaration_1), getKClass(QualifiedReferenceContent));
    var tmp_185 = to(tmp_182, new ConceptData('ExtensionFieldReference', 'jetbrains.biokb.lang.model.ExtensionFieldReference', true, false, tmp_183, VOID, listOf(new ReferenceMemberData(tmp38_link, 'field', getKClass(FieldDeclaration_1)))));
    var tmp_186 = getKClass(ExtensionLibrary_1);
    var tmp_187 = getKClass(DocumentNode_0);
    var tmp_188 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_47 = getPropertyCallableRef('extensions', 1, tmp_188, ExtensionLibrary$_get_extensions_$ref_a2rnfy(), null);
    var tmp39_link = new MultipleChildLink(getKClass(ExtensionLibrary_1), this_47);
    var tmp_189 = to(tmp_186, new ConceptData('ExtensionLibrary', 'jetbrains.biokb.lang.model.ExtensionLibrary', true, false, tmp_187, VOID, listOf(new ChildrenMemberData(tmp39_link, 'extensions', getKClass(ExtensionDeclaration_1), true))));
    var tmp_190 = to(getKClass(ExternallyNamed), new ConceptData('ExternallyNamed', 'jetbrains.biokb.lang.model.ExternallyNamed', false, false, VOID, listOf(getKClass(DirectlyNamed))));
    var tmp_191 = getKClass(Fact_1);
    var tmp_192 = listOf_0([getKClass(BTBNode), getKClass(DirectlyNamed)]);
    var tmp_193 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_48 = getPropertyCallableRef('precondition', 1, tmp_193, Fact$_get_precondition_$ref_4fc0ee(), null);
    var tmp40_link = new SingleChildLink(getKClass(Fact_1), this_48);
    var tmp_194 = new ChildrenMemberData(tmp40_link, 'precondition', getKClass(Precondition), false);
    var tmp_195 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_49 = getPropertyCallableRef('specification', 1, tmp_195, Fact$_get_specification_$ref_jrnjv(), null);
    var tmp41_link = new SingleChildLink(getKClass(Fact_1), this_49);
    var tmp_196 = to(tmp_191, new ConceptData('Fact', 'jetbrains.biokb.lang.model.Fact', true, false, VOID, tmp_192, listOf_0([tmp_194, new ChildrenMemberData(tmp41_link, 'specification', getKClass(AbstractProcessSpecification), false)])));
    var tmp_197 = to(getKClass(FactExpression), new ConceptData('FactExpression', 'jetbrains.biokb.lang.model.FactExpression', false, false, getKClass(FactExpressionPlaceholder)));
    var tmp_198 = to(getKClass(FactExpressionPlaceholder), new ConceptData('FactExpressionPlaceholder', 'jetbrains.biokb.lang.model.FactExpressionPlaceholder', true, false, VOID, listOf(getKClass(BTBNode))));
    var tmp_199 = getKClass(FactPrecondition_1);
    var tmp_200 = getKClass(Precondition);
    var tmp_201 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_50 = getPropertyCallableRef('facts', 1, tmp_201, FactPrecondition$_get_facts_$ref_m1xslj(), null);
    var tmp42_link = new MultipleChildLink(getKClass(FactPrecondition_1), this_50);
    var tmp_202 = new ChildrenMemberData(tmp42_link, 'facts', getKClass(FactReference_1), true);
    var tmp_203 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var this_51 = getPropertyCallableRef('relation', 1, tmp_203, FactPrecondition$_get_relation_$ref_m111b2(), null);
    var tmp43_link = new ReferenceLink(getKClass(FactPrecondition_1), this_51, getKClass(ProcessRelationDeclaration_1), getKClass(QualifiedReferenceContent));
    var tmp_204 = to(tmp_199, new ConceptData('FactPrecondition', 'jetbrains.biokb.lang.model.FactPrecondition', true, false, tmp_200, VOID, listOf_0([tmp_202, new ReferenceMemberData(tmp43_link, 'relation', getKClass(ProcessRelationDeclaration_1))])));
    var tmp_205 = getKClass(FactReference_1);
    var tmp_206 = listOf(getKClass(BTBNode));
    var tmp_207 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var this_52 = getPropertyCallableRef('ref', 1, tmp_207, FactReference$_get_ref_$ref_yrgsjs(), null);
    var tmp44_link = new ReferenceLink(getKClass(FactReference_1), this_52, getKClass(Fact_1), getKClass(LocalReferenceContent));
    var tmp_208 = to(tmp_205, new ConceptData('FactReference', 'jetbrains.biokb.lang.model.FactReference', true, false, VOID, tmp_206, listOf(new ReferenceMemberData(tmp44_link, 'ref', getKClass(Fact_1)))));
    var tmp_209 = getKClass(FactSet_1);
    var tmp_210 = listOf_0([getKClass(BTBNode), getKClass(DirectlyNamed), getKClass(HasKnowledgeSources), getKClass(HasComments), getKClass(HasVariables)]);
    var tmp_211 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_53 = getPropertyCallableRef('factSetId', 1, tmp_211, FactSet$_get_factSetId_$ref_vbwuu7(), null);
    var tmp$ret$53 = new ValueAttributeLink(getKClass(FactSet_1), this_53, createKType(PrimitiveClasses_getInstance().tb(), arrayOf([]), false));
    var tmp_212 = new AttributeData(tmp$ret$53, 'factSetId', new SimpleAttributeType(false, PrimitiveClasses_getInstance().tb()));
    var tmp_213 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_54 = getPropertyCallableRef('factsContext', 1, tmp_213, FactSet$_get_factsContext_$ref_cvizsw(), null);
    var tmp45_link = new SingleChildLink(getKClass(FactSet_1), this_54);
    var tmp_214 = new ChildrenMemberData(tmp45_link, 'factsContext', getKClass(Context_2), false);
    var tmp_215 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_55 = getPropertyCallableRef('contexts', 1, tmp_215, FactSet$_get_contexts_$ref_i2luf8(), null);
    var tmp46_link = new MultipleChildLink(getKClass(FactSet_1), this_55);
    var tmp_216 = new ChildrenMemberData(tmp46_link, 'contexts', getKClass(Context_2), true);
    var tmp_217 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_56 = getPropertyCallableRef('facts', 1, tmp_217, FactSet$_get_facts_$ref_jljgph(), null);
    var tmp47_link = new MultipleChildLink(getKClass(FactSet_1), this_56);
    var tmp_218 = new ChildrenMemberData(tmp47_link, 'facts', getKClass(Fact_1), true);
    var tmp_219 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_57 = getPropertyCallableRef('newFacts', 1, tmp_219, FactSet$_get_newFacts_$ref_l1v7cv(), null);
    var tmp48_link = new MultipleChildLink(getKClass(FactSet_1), this_57);
    var tmp_220 = to(tmp_209, new ConceptData('FactSet', 'jetbrains.biokb.lang.model.FactSet', true, false, VOID, tmp_210, listOf_0([tmp_212, tmp_214, tmp_216, tmp_218, new ChildrenMemberData(tmp48_link, 'newFacts', getKClass(NewFact), true)])));
    var tmp_221 = getKClass(FieldDeclaration_1);
    var tmp_222 = listOf_0([getKClass(BTBNode), getKClass(DirectlyNamed)]);
    var tmp_223 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_58 = getPropertyCallableRef('type', 1, tmp_223, FieldDeclaration$_get_type_$ref_bpg0gs(), null);
    var tmp49_link = new SingleChildLink(getKClass(FieldDeclaration_1), this_58);
    var tmp_224 = new ChildrenMemberData(tmp49_link, 'type', getKClass(OntologyElementType_1), false);
    var tmp_225 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_59 = getPropertyCallableRef('cardinality', 1, tmp_225, FieldDeclaration$_get_cardinality_$ref_jc2wge(), null);
    var tmp50_link = new SingleChildLink(getKClass(FieldDeclaration_1), this_59);
    var tmp_226 = to(tmp_221, new ConceptData('FieldDeclaration', 'jetbrains.biokb.lang.model.FieldDeclaration', true, false, VOID, tmp_222, listOf_0([tmp_224, new ChildrenMemberData(tmp50_link, 'cardinality', getKClass(Cardinality_1), false)])));
    var tmp_227 = getKClass(FindConnectionCommand_1);
    var tmp_228 = getKClass(Command_0);
    var tmp_229 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_60 = getPropertyCallableRef('contextQuery', 1, tmp_229, FindConnectionCommand$_get_contextQuery_$ref_mokctt(), null);
    var tmp51_link = new SingleChildLink(getKClass(FindConnectionCommand_1), this_60);
    var tmp_230 = new ChildrenMemberData(tmp51_link, 'contextQuery', getKClass(ContextQuery_1), false);
    var tmp_231 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_61 = getPropertyCallableRef('from', 1, tmp_231, FindConnectionCommand$_get_from_$ref_q9ldq8(), null);
    var tmp52_link = new SingleChildLink(getKClass(FindConnectionCommand_1), this_61);
    var tmp_232 = new ChildrenMemberData(tmp52_link, 'from', getKClass(LibraryProcessSpecificationQuery_1), false);
    var tmp_233 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_62 = getPropertyCallableRef('to', 1, tmp_233, FindConnectionCommand$_get_to_$ref_pv3m1b(), null);
    var tmp53_link = new SingleChildLink(getKClass(FindConnectionCommand_1), this_62);
    var tmp_234 = to(tmp_227, new ConceptData('FindConnectionCommand', 'jetbrains.biokb.lang.model.FindConnectionCommand', true, false, tmp_228, VOID, listOf_0([tmp_230, tmp_232, new ChildrenMemberData(tmp53_link, 'to', getKClass(LibraryProcessSpecificationQuery_1), false)])));
    var tmp_235 = getKClass(FindNewConnectionCommand_1);
    var tmp_236 = getKClass(Command_0);
    var tmp_237 = listOf(getKClass(HasVariables));
    var tmp_238 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_63 = getPropertyCallableRef('contextQueries', 1, tmp_238, FindNewConnectionCommand$_get_contextQueries_$ref_s8ua7z(), null);
    var tmp54_link = new MultipleChildLink(getKClass(FindNewConnectionCommand_1), this_63);
    var tmp_239 = new ChildrenMemberData(tmp54_link, 'contextQueries', getKClass(ContextQuery_1), true);
    var tmp_240 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_64 = getPropertyCallableRef('from', 1, tmp_240, FindNewConnectionCommand$_get_from_$ref_5jecnm(), null);
    var tmp55_link = new SingleChildLink(getKClass(FindNewConnectionCommand_1), this_64);
    var tmp_241 = new ChildrenMemberData(tmp55_link, 'from', getKClass(Pattern), false);
    var tmp_242 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_65 = getPropertyCallableRef('to', 1, tmp_242, FindNewConnectionCommand$_get_to_$ref_isfjel(), null);
    var tmp56_link = new SingleChildLink(getKClass(FindNewConnectionCommand_1), this_65);
    var tmp_243 = to(tmp_235, new ConceptData('FindNewConnectionCommand', 'jetbrains.biokb.lang.model.FindNewConnectionCommand', true, false, tmp_236, tmp_237, listOf_0([tmp_239, tmp_241, new ChildrenMemberData(tmp56_link, 'to', getKClass(Pattern), false)])));
    var tmp_244 = getKClass(FunctionDeclaration_1);
    var tmp_245 = getKClass(AbstractBindingDeclaration);
    var tmp_246 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_66 = getPropertyCallableRef('returnType', 1, tmp_246, FunctionDeclaration$_get_returnType_$ref_ypk7g2(), null);
    var tmp57_link = new SingleChildLink(getKClass(FunctionDeclaration_1), this_66);
    var tmp_247 = new ChildrenMemberData(tmp57_link, 'returnType', getKClass(OntologyElementType_1), false);
    var tmp_248 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_67 = getPropertyCallableRef('cardinality', 1, tmp_248, FunctionDeclaration$_get_cardinality_$ref_danp80(), null);
    var tmp58_link = new SingleChildLink(getKClass(FunctionDeclaration_1), this_67);
    var tmp_249 = to(tmp_244, new ConceptData('FunctionDeclaration', 'jetbrains.biokb.lang.model.FunctionDeclaration', true, false, tmp_245, VOID, listOf_0([tmp_247, new ChildrenMemberData(tmp58_link, 'cardinality', getKClass(Cardinality_1), false)])));
    var tmp_250 = getKClass(FunctionLibrary_1);
    var tmp_251 = getKClass(DocumentNode_0);
    var tmp_252 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_68 = getPropertyCallableRef('functions', 1, tmp_252, FunctionLibrary$_get_functions_$ref_ag5k04(), null);
    var tmp59_link = new MultipleChildLink(getKClass(FunctionLibrary_1), this_68);
    var tmp_253 = to(tmp_250, new ConceptData('FunctionLibrary', 'jetbrains.biokb.lang.model.FunctionLibrary', true, false, tmp_251, VOID, listOf(new ChildrenMemberData(tmp59_link, 'functions', getKClass(FunctionDeclaration_1), true))));
    var tmp_254 = getKClass(FunctionTerm_1);
    var tmp_255 = listOf(getKClass(AbstractValue));
    var tmp_256 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var this_69 = getPropertyCallableRef('function', 1, tmp_256, FunctionTerm$_get_function_$ref_fl3laa(), null);
    var tmp60_link = new ReferenceLink(getKClass(FunctionTerm_1), this_69, getKClass(FunctionDeclaration_1), getKClass(QualifiedReferenceContent));
    var tmp_257 = new ReferenceMemberData(tmp60_link, 'function', getKClass(FunctionDeclaration_1));
    var tmp_258 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_70 = getPropertyCallableRef('specificator', 1, tmp_258, FunctionTerm$_get_specificator_$ref_6446ni(), null);
    var tmp$ret$70 = new ValueAttributeLink(getKClass(FunctionTerm_1), this_70, createKType(getKClass(CardinalitySpecificator), arrayOf([]), false));
    var tmp_259 = new AttributeData(tmp$ret$70, 'specificator', new EnumAttributeType(false, getKClass(CardinalitySpecificator), listOf_0([CardinalitySpecificator_ALL_OF_getInstance(), CardinalitySpecificator_SOME_OF_getInstance(), CardinalitySpecificator_AT_LEAST_ONE_OF_getInstance(), CardinalitySpecificator_EXACTLY_ONE_OF_getInstance()])));
    var tmp_260 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_71 = getPropertyCallableRef('parameters', 1, tmp_260, FunctionTerm$_get_parameters_$ref_14vbsg(), null);
    var tmp61_link = new MultipleChildLink(getKClass(FunctionTerm_1), this_71);
    var tmp_261 = to(tmp_254, new ConceptData('FunctionTerm', 'jetbrains.biokb.lang.model.FunctionTerm', true, false, VOID, tmp_255, listOf_0([tmp_257, tmp_259, new ChildrenMemberData(tmp61_link, 'parameters', getKClass(BindingValuePlaceholder_1), true)])));
    var tmp_262 = getKClass(HasComments);
    var tmp_263 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_72 = getPropertyCallableRef('comment', 1, tmp_263, HasComments$_get_comment_$ref_ob8p9n(), null);
    var tmp62_link = new SingleChildLink(getKClass(HasComments), this_72);
    var tmp_264 = to(tmp_262, new ConceptData('HasComments', 'jetbrains.biokb.lang.model.HasComments', false, false, VOID, VOID, listOf(new ChildrenMemberData(tmp62_link, 'comment', getKClass(MultilineText), false))));
    var tmp_265 = getKClass(HasFactExpression);
    var tmp_266 = listOf(getKClass(BTBNode));
    var tmp_267 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_73 = getPropertyCallableRef('expression', 1, tmp_267, HasFactExpression$_get_expression_$ref_bmlpmw(), null);
    var tmp63_link = new SingleChildLink(getKClass(HasFactExpression), this_73);
    var tmp_268 = to(tmp_265, new ConceptData('HasFactExpression', 'jetbrains.biokb.lang.model.HasFactExpression', false, false, VOID, tmp_266, listOf(new ChildrenMemberData(tmp63_link, 'expression', getKClass(FactExpression), false))));
    var tmp_269 = getKClass(HasKnowledgeSources);
    var tmp_270 = listOf(getKClass(BTBNode));
    var tmp_271 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_74 = getPropertyCallableRef('sources', 1, tmp_271, HasKnowledgeSources$_get_sources_$ref_6mibyw(), null);
    var tmp64_link = new MultipleChildLink(getKClass(HasKnowledgeSources), this_74);
    var tmp_272 = to(tmp_269, new ConceptData('HasKnowledgeSources', 'jetbrains.biokb.lang.model.HasKnowledgeSources', false, false, VOID, tmp_270, listOf(new ChildrenMemberData(tmp64_link, 'sources', getKClass(KnowledgeSourceReference), true))));
    var tmp_273 = getKClass(HasPropertyConstraints);
    var tmp_274 = listOf(getKClass(BTBNode));
    var tmp_275 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_75 = getPropertyCallableRef('constraints', 1, tmp_275, HasPropertyConstraints$_get_constraints_$ref_5lfcib(), null);
    var tmp65_link = new MultipleChildLink(getKClass(HasPropertyConstraints), this_75);
    var tmp_276 = to(tmp_273, new ConceptData('HasPropertyConstraints', 'jetbrains.biokb.lang.model.HasPropertyConstraints', false, false, VOID, tmp_274, listOf(new ChildrenMemberData(tmp65_link, 'constraints', getKClass(PropertyConstraint_1), true))));
    var tmp_277 = getKClass(HasQueryLabels);
    var tmp_278 = listOf(getKClass(BTBNode));
    var tmp_279 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_76 = getPropertyCallableRef('noEntry', 1, tmp_279, HasQueryLabels$_get_noEntry_$ref_215uy0(), null);
    var tmp$ret$76 = new ValueAttributeLink(getKClass(HasQueryLabels), this_76, createKType(PrimitiveClasses_getInstance().lb(), arrayOf([]), false));
    var tmp_280 = new AttributeData(tmp$ret$76, 'noEntry', new SimpleAttributeType(false, PrimitiveClasses_getInstance().lb()));
    var tmp_281 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_77 = getPropertyCallableRef('noExit', 1, tmp_281, HasQueryLabels$_get_noExit_$ref_pxrte(), null);
    var tmp$ret$77 = new ValueAttributeLink(getKClass(HasQueryLabels), this_77, createKType(PrimitiveClasses_getInstance().lb(), arrayOf([]), false));
    var tmp_282 = to(tmp_277, new ConceptData('HasQueryLabels', 'jetbrains.biokb.lang.model.HasQueryLabels', false, false, VOID, tmp_278, listOf_0([tmp_280, new AttributeData(tmp$ret$77, 'noExit', new SimpleAttributeType(false, PrimitiveClasses_getInstance().lb()))])));
    var tmp_283 = getKClass(HasVariables);
    var tmp_284 = listOf(getKClass(BTBNode));
    var tmp_285 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_78 = getPropertyCallableRef('variables', 1, tmp_285, HasVariables$_get_variables_$ref_6jdr2(), null);
    var tmp66_link = new MultipleChildLink(getKClass(HasVariables), this_78);
    var tmp_286 = to(tmp_283, new ConceptData('HasVariables', 'jetbrains.biokb.lang.model.HasVariables', false, false, VOID, tmp_284, listOf(new ChildrenMemberData(tmp66_link, 'variables', getKClass(VariableDeclaration_1), true))));
    var tmp_287 = getKClass(ImportedLink_1);
    var tmp_288 = getKClass(AbstractLink);
    var tmp_289 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var this_79 = getPropertyCallableRef('declaration', 1, tmp_289, ImportedLink$_get_declaration_$ref_rf42xs(), null);
    var tmp67_link = new ReferenceLink(getKClass(ImportedLink_1), this_79, getKClass(LinkDeclaration_1), getKClass(QualifiedReferenceContent));
    var tmp_290 = to(tmp_287, new ConceptData('ImportedLink', 'jetbrains.biokb.lang.model.ImportedLink', true, false, tmp_288, VOID, listOf(new ReferenceMemberData(tmp67_link, 'declaration', getKClass(LinkDeclaration_1)))));
    var tmp_291 = getKClass(ImportedProperty_1);
    var tmp_292 = getKClass(AbstractProperty);
    var tmp_293 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var this_80 = getPropertyCallableRef('declaration', 1, tmp_293, ImportedProperty$_get_declaration_$ref_692xl1(), null);
    var tmp68_link = new ReferenceLink(getKClass(ImportedProperty_1), this_80, getKClass(PropertyDeclaration_1), getKClass(QualifiedReferenceContent));
    var tmp_294 = to(tmp_291, new ConceptData('ImportedProperty', 'jetbrains.biokb.lang.model.ImportedProperty', true, false, tmp_292, VOID, listOf(new ReferenceMemberData(tmp68_link, 'declaration', getKClass(PropertyDeclaration_1)))));
    var tmp_295 = getKClass(InheritedProcessProperty);
    var tmp_296 = listOf_0([getKClass(BTBNode), getKClass(DirectlyNamed)]);
    var tmp_297 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_81 = getPropertyCallableRef('type', 1, tmp_297, InheritedProcessProperty$_get_type_$ref_7uh7x6(), null);
    var tmp69_link = new SingleChildLink(getKClass(InheritedProcessProperty), this_81);
    var tmp_298 = new ChildrenMemberData(tmp69_link, 'type', getKClass(ProcessPropertyValueRange), false);
    var tmp_299 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_82 = getPropertyCallableRef('default', 1, tmp_299, InheritedProcessProperty$_get_default_$ref_c5hrt1(), null);
    var tmp70_link = new SingleChildLink(getKClass(InheritedProcessProperty), this_82);
    var tmp_300 = new ChildrenMemberData(tmp70_link, 'default', getKClass(ProcessPropertyDefault_1), false);
    var tmp_301 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_83 = getPropertyCallableRef('inheritedFrom', 1, tmp_301, InheritedProcessProperty$_get_inheritedFrom_$ref_gkccsi(), null);
    var tmp71_link = new SingleChildLink(getKClass(InheritedProcessProperty), this_83);
    var tmp_302 = to(tmp_295, new ConceptData('InheritedProcessProperty', 'jetbrains.biokb.lang.model.InheritedProcessProperty', true, false, VOID, tmp_296, listOf_0([tmp_298, tmp_300, new ChildrenMemberData(tmp71_link, 'inheritedFrom', getKClass(ProcessReference_1), false)])));
    var tmp_303 = getKClass(InstanceRelationDeclaration);
    var tmp_304 = listOf_0([getKClass(BTBNode), getKClass(DirectlyNamed)]);
    var tmp_305 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_84 = getPropertyCallableRef('domain', 1, tmp_305, InstanceRelationDeclaration$_get_domain_$ref_oqqnwx(), null);
    var tmp72_link = new SingleChildLink(getKClass(InstanceRelationDeclaration), this_84);
    var tmp_306 = new ChildrenMemberData(tmp72_link, 'domain', getKClass(Type), false);
    var tmp_307 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_85 = getPropertyCallableRef('range', 1, tmp_307, InstanceRelationDeclaration$_get_range_$ref_6vz34o(), null);
    var tmp73_link = new SingleChildLink(getKClass(InstanceRelationDeclaration), this_85);
    var tmp_308 = to(tmp_303, new ConceptData('InstanceRelationDeclaration', 'jetbrains.biokb.lang.model.InstanceRelationDeclaration', true, false, VOID, tmp_304, listOf_0([tmp_306, new ChildrenMemberData(tmp73_link, 'range', getKClass(Type), false)])));
    var tmp_309 = getKClass(InstanceRelationValue);
    var tmp_310 = getKClass(InstanceRelationValuePlaceholder);
    var tmp_311 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_86 = getPropertyCallableRef('value', 1, tmp_311, InstanceRelationValue$_get_value_$ref_n9b6s5(), null);
    var tmp74_link = new SingleChildLink(getKClass(InstanceRelationValue), this_86);
    var tmp_312 = new ChildrenMemberData(tmp74_link, 'value', getKClass(AbstractValue), false);
    var tmp_313 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var this_87 = getPropertyCallableRef('relation', 1, tmp_313, InstanceRelationValue$_get_relation_$ref_1y8jwi(), null);
    var tmp75_link = new ReferenceLink(getKClass(InstanceRelationValue), this_87, getKClass(InstanceRelationDeclaration), getKClass(QualifiedReferenceContent));
    var tmp_314 = to(tmp_309, new ConceptData('InstanceRelationValue', 'jetbrains.biokb.lang.model.InstanceRelationValue', true, false, tmp_310, VOID, listOf_0([tmp_312, new ReferenceMemberData(tmp75_link, 'relation', getKClass(InstanceRelationDeclaration))])));
    var tmp_315 = to(getKClass(InstanceRelationValuePlaceholder), new ConceptData('InstanceRelationValuePlaceholder', 'jetbrains.biokb.lang.model.InstanceRelationValuePlaceholder', true, false, VOID, listOf(getKClass(BTBNode))));
    var tmp_316 = getKClass(IntegerValue_1);
    var tmp_317 = listOf_0([getKClass(AbstractValue), getKClass(FactExpression), getKClass(AllowedComplexNotionValue)]);
    var tmp_318 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_88 = getPropertyCallableRef('value', 1, tmp_318, IntegerValue$_get_value_$ref_c1etoe(), null);
    var tmp$ret$88 = new ValueAttributeLink(getKClass(IntegerValue_1), this_88, createKType(PrimitiveClasses_getInstance().ob(), arrayOf([]), false));
    var tmp_319 = to(tmp_316, new ConceptData('IntegerValue', 'jetbrains.biokb.lang.model.IntegerValue', true, false, VOID, tmp_317, listOf(new AttributeData(tmp$ret$88, 'value', new SimpleAttributeType(false, PrimitiveClasses_getInstance().ob())))));
    var tmp_320 = getKClass(IsExpression_1);
    var tmp_321 = listOf(getKClass(FactExpression));
    var tmp_322 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_89 = getPropertyCallableRef('subject', 1, tmp_322, IsExpression$_get_subject_$ref_1r93qq(), null);
    var tmp76_link = new SingleChildLink(getKClass(IsExpression_1), this_89);
    var tmp_323 = new ChildrenMemberData(tmp76_link, 'subject', getKClass(ObjectPropertyReferenceValue_1), false);
    var tmp_324 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_90 = getPropertyCallableRef('value', 1, tmp_324, IsExpression$_get_value_$ref_6as7yl(), null);
    var tmp77_link = new SingleChildLink(getKClass(IsExpression_1), this_90);
    var tmp_325 = to(tmp_320, new ConceptData('IsExpression', 'jetbrains.biokb.lang.model.IsExpression', true, false, VOID, tmp_321, listOf_0([tmp_323, new ChildrenMemberData(tmp77_link, 'value', getKClass(AbstractValue), false)])));
    var tmp_326 = to(getKClass(KindCustomCell_1), new ConceptData('KindCustomCell', 'jetbrains.biokb.lang.model.KindCustomCell', true, false, getKClass(CustomCell)));
    var tmp_327 = to(getKClass(KnowledgeSourceReference), new ConceptData('KnowledgeSourceReference', 'jetbrains.biokb.lang.model.KnowledgeSourceReference', false, false, VOID, listOf(getKClass(BTBNode))));
    var tmp_328 = to(getKClass(KnowledgeSourceReferencePlaceholder_1), new ConceptData('KnowledgeSourceReferencePlaceholder', 'jetbrains.biokb.lang.model.KnowledgeSourceReferencePlaceholder', true, false, getKClass(KnowledgeSourceReference)));
    var tmp_329 = to(getKClass(LibraryItem), new ConceptData('LibraryItem', 'jetbrains.biokb.lang.model.LibraryItem', false, false, VOID, listOf(getKClass(BTBNode))));
    var tmp_330 = to(getKClass(LibraryItemPlaceholder_1), new ConceptData('LibraryItemPlaceholder', 'jetbrains.biokb.lang.model.LibraryItemPlaceholder', true, false, VOID, listOf(getKClass(LibraryItem))));
    var tmp_331 = getKClass(LibraryProcessSpecification_1);
    var tmp_332 = getKClass(AbstractProcessSpecification);
    var tmp_333 = listOf_0([getKClass(ProcessProvider), getKClass(FactExpression)]);
    var tmp_334 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var this_91 = getPropertyCallableRef('process', 1, tmp_334, LibraryProcessSpecification$_get_process_$ref_7klwyk(), null);
    var tmp78_link = new ReferenceLink(getKClass(LibraryProcessSpecification_1), this_91, getKClass(ProcessDeclaration_1), getKClass(QualifiedReferenceContent));
    var tmp_335 = new ReferenceMemberData(tmp78_link, 'process', getKClass(ProcessDeclaration_1));
    var tmp_336 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_92 = getPropertyCallableRef('parameters', 1, tmp_336, LibraryProcessSpecification$_get_parameters_$ref_yticl7(), null);
    var tmp79_link = new MultipleChildLink(getKClass(LibraryProcessSpecification_1), this_92);
    var tmp_337 = to(tmp_331, new ConceptData('LibraryProcessSpecification', 'jetbrains.biokb.lang.model.LibraryProcessSpecification', true, false, tmp_332, tmp_333, listOf_0([tmp_335, new ChildrenMemberData(tmp79_link, 'parameters', getKClass(BindingValuePlaceholder_1), true)])));
    var tmp_338 = getKClass(LibraryProcessSpecificationQuery_1);
    var tmp_339 = listOf_0([getKClass(BTBNode), getKClass(ProcessProvider)]);
    var tmp_340 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var this_93 = getPropertyCallableRef('process', 1, tmp_340, LibraryProcessSpecificationQuery$_get_process_$ref_2u429m(), null);
    var tmp80_link = new ReferenceLink(getKClass(LibraryProcessSpecificationQuery_1), this_93, getKClass(ProcessDeclaration_1), getKClass(QualifiedReferenceContent));
    var tmp_341 = new ReferenceMemberData(tmp80_link, 'process', getKClass(ProcessDeclaration_1));
    var tmp_342 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var this_94 = getPropertyCallableRef('kind', 1, tmp_342, LibraryProcessSpecificationQuery$_get_kind_$ref_ulcr75(), null);
    var tmp81_link = new ReferenceLink(getKClass(LibraryProcessSpecificationQuery_1), this_94, getKClass(ProcessKind_1), getKClass(QualifiedReferenceContent));
    var tmp_343 = new ReferenceMemberData(tmp81_link, 'kind', getKClass(ProcessKind_1));
    var tmp_344 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_95 = getPropertyCallableRef('parameters', 1, tmp_344, LibraryProcessSpecificationQuery$_get_parameters_$ref_6fozj9(), null);
    var tmp82_link = new MultipleChildLink(getKClass(LibraryProcessSpecificationQuery_1), this_95);
    var tmp_345 = to(tmp_338, new ConceptData('LibraryProcessSpecificationQuery', 'jetbrains.biokb.lang.model.LibraryProcessSpecificationQuery', true, false, VOID, tmp_339, listOf_0([tmp_341, tmp_343, new ChildrenMemberData(tmp82_link, 'parameters', getKClass(BindingValuePlaceholderQuery_1), true)])));
    var tmp_346 = getKClass(LinkCustomCell_1);
    var tmp_347 = getKClass(CustomCell);
    var tmp_348 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var this_96 = getPropertyCallableRef('link', 1, tmp_348, LinkCustomCell$_get_link_$ref_hxxns9(), null);
    var tmp83_link = new ReferenceLink(getKClass(LinkCustomCell_1), this_96, getKClass(AbstractLink), getKClass(QualifiedReferenceContent));
    var tmp_349 = to(tmp_346, new ConceptData('LinkCustomCell', 'jetbrains.biokb.lang.model.LinkCustomCell', true, false, tmp_347, VOID, listOf(new ReferenceMemberData(tmp83_link, 'link', getKClass(AbstractLink)))));
    var tmp_350 = getKClass(LinkDeclaration_1);
    var tmp_351 = listOf_0([getKClass(BTBNode), getKClass(DirectlyNamed)]);
    var tmp_352 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_97 = getPropertyCallableRef('specificator', 1, tmp_352, LinkDeclaration$_get_specificator_$ref_gfmbhm(), null);
    var tmp$ret$97 = new ValueAttributeLink(getKClass(LinkDeclaration_1), this_97, createKType(getKClass(LinkTypeSpecificator), arrayOf([]), true));
    var tmp_353 = new AttributeData(tmp$ret$97, 'specificator', new EnumAttributeType(true, getKClass(LinkTypeSpecificator), listOf_0([LinkTypeSpecificator_INSTANCE_OF_getInstance(), LinkTypeSpecificator_TYPE_OF_getInstance()])));
    var tmp_354 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_98 = getPropertyCallableRef('type', 1, tmp_354, LinkDeclaration$_get_type_$ref_9mjtus(), null);
    var tmp84_link = new SingleChildLink(getKClass(LinkDeclaration_1), this_98);
    var tmp_355 = to(tmp_350, new ConceptData('LinkDeclaration', 'jetbrains.biokb.lang.model.LinkDeclaration', true, false, VOID, tmp_351, listOf_0([tmp_353, new ChildrenMemberData(tmp84_link, 'type', getKClass(OntologyElementType_1), false)])));
    var tmp_356 = getKClass(LinkLibrary_1);
    var tmp_357 = getKClass(DocumentNode_0);
    var tmp_358 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_99 = getPropertyCallableRef('links', 1, tmp_358, LinkLibrary$_get_links_$ref_y40czo(), null);
    var tmp85_link = new MultipleChildLink(getKClass(LinkLibrary_1), this_99);
    var tmp_359 = to(tmp_356, new ConceptData('LinkLibrary', 'jetbrains.biokb.lang.model.LinkLibrary', true, false, tmp_357, VOID, listOf(new ChildrenMemberData(tmp85_link, 'links', getKClass(LinkDeclaration_1), true))));
    var tmp_360 = getKClass(LocalOntologyElementReference_1);
    var tmp_361 = listOf_0([getKClass(BTBNode), getKClass(OntologyElementReferenceProvider)]);
    var tmp_362 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var this_100 = getPropertyCallableRef('element', 1, tmp_362, LocalOntologyElementReference$_get_element_$ref_rimyqf(), null);
    var tmp86_link = new ReferenceLink(getKClass(LocalOntologyElementReference_1), this_100, getKClass(OntologyElement_1), getKClass(LocalReferenceContent));
    var tmp_363 = to(tmp_360, new ConceptData('LocalOntologyElementReference', 'jetbrains.biokb.lang.model.LocalOntologyElementReference', true, false, VOID, tmp_361, listOf(new ReferenceMemberData(tmp86_link, 'element', getKClass(OntologyElement_1)))));
    var tmp_364 = getKClass(MeasurableNotion_1);
    var tmp_365 = getKClass(AbstractNotion);
    var tmp_366 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_101 = getPropertyCallableRef('units', 1, tmp_366, MeasurableNotion$_get_units_$ref_k7fkf7(), null);
    var tmp87_link = new MultipleChildLink(getKClass(MeasurableNotion_1), this_101);
    var tmp_367 = to(tmp_364, new ConceptData('MeasurableNotion', 'jetbrains.biokb.lang.model.MeasurableNotion', true, false, tmp_365, VOID, listOf(new ChildrenMemberData(tmp87_link, 'units', getKClass(MeasurementUnit_1), true))));
    var tmp_368 = getKClass(MeasurableValue_1);
    var tmp_369 = listOf_0([getKClass(AbstractValue), getKClass(FactExpression), getKClass(AllowedComplexNotionValue)]);
    var tmp_370 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_102 = getPropertyCallableRef('amount', 1, tmp_370, MeasurableValue$_get_amount_$ref_ornak6(), null);
    var tmp$ret$102 = new ValueAttributeLink(getKClass(MeasurableValue_1), this_102, createKType(getKClass(BigDecimal), arrayOf([]), false));
    var tmp_371 = new AttributeData(tmp$ret$102, 'amount', new SimpleAttributeType(false, getKClass(BigDecimal)));
    var tmp_372 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var this_103 = getPropertyCallableRef('unit', 1, tmp_372, MeasurableValue$_get_unit_$ref_ez4szu(), null);
    var tmp88_link = new ReferenceLink(getKClass(MeasurableValue_1), this_103, getKClass(MeasurementUnit_1), getKClass(QualifiedReferenceContent));
    var tmp_373 = to(tmp_368, new ConceptData('MeasurableValue', 'jetbrains.biokb.lang.model.MeasurableValue', true, false, VOID, tmp_369, listOf_0([tmp_371, new ReferenceMemberData(tmp88_link, 'unit', getKClass(MeasurementUnit_1))])));
    var tmp_374 = getKClass(MeasurementUnit_1);
    var tmp_375 = listOf_0([getKClass(BTBNode), getKClass(DirectlyNamed)]);
    var tmp_376 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_104 = getPropertyCallableRef('main', 1, tmp_376, MeasurementUnit$_get_main_$ref_qfidtn(), null);
    var tmp$ret$104 = new ValueAttributeLink(getKClass(MeasurementUnit_1), this_104, createKType(PrimitiveClasses_getInstance().lb(), arrayOf([]), false));
    var tmp_377 = to(tmp_374, new ConceptData('MeasurementUnit', 'jetbrains.biokb.lang.model.MeasurementUnit', true, false, VOID, tmp_375, listOf(new AttributeData(tmp$ret$104, 'main', new SimpleAttributeType(false, PrimitiveClasses_getInstance().lb())))));
    var tmp_378 = getKClass(ModifierContainer);
    var tmp_379 = getKClass(DocumentNode_0);
    var tmp_380 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_105 = getPropertyCallableRef('modifiers', 1, tmp_380, ModifierContainer$_get_modifiers_$ref_pj92fq(), null);
    var tmp89_link = new MultipleChildLink(getKClass(ModifierContainer), this_105);
    var tmp_381 = to(tmp_378, new ConceptData('ModifierContainer', 'jetbrains.biokb.lang.model.ModifierContainer', true, false, tmp_379, VOID, listOf(new ChildrenMemberData(tmp89_link, 'modifiers', getKClass(ModifierDeclaration), true))));
    var tmp_382 = to(getKClass(ModifierDeclaration), new ConceptData('ModifierDeclaration', 'jetbrains.biokb.lang.model.ModifierDeclaration', true, false, VOID, listOf_0([getKClass(BTBNode), getKClass(DirectlyNamed)])));
    var tmp_383 = getKClass(ModifierFactExpression_0);
    var tmp_384 = listOf(getKClass(FactExpression));
    var tmp_385 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var this_106 = getPropertyCallableRef('modifier', 1, tmp_385, ModifierFactExpression$_get_modifier_$ref_tzyw3w(), null);
    var tmp90_link = new ReferenceLink(getKClass(ModifierFactExpression_0), this_106, getKClass(ModifierDeclaration), getKClass(QualifiedReferenceContent));
    var tmp_386 = new ReferenceMemberData(tmp90_link, 'modifier', getKClass(ModifierDeclaration));
    var tmp_387 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_107 = getPropertyCallableRef('expression', 1, tmp_387, ModifierFactExpression$_get_expression_$ref_xrw8dn(), null);
    var tmp91_link = new SingleChildLink(getKClass(ModifierFactExpression_0), this_107);
    var tmp_388 = to(tmp_383, new ConceptData('ModifierFactExpression', 'jetbrains.biokb.lang.model.ModifierFactExpression', true, false, VOID, tmp_384, listOf_0([tmp_386, new ChildrenMemberData(tmp91_link, 'expression', getKClass(FactExpression), false)])));
    var tmp_389 = getKClass(MultilineText);
    var tmp_390 = listOf(getKClass(BTBNode));
    var tmp_391 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_108 = getPropertyCallableRef('lines', 1, tmp_391, MultilineText$_get_lines_$ref_okds4p(), null);
    var tmp92_link = new MultipleChildLink(getKClass(MultilineText), this_108);
    var tmp_392 = to(tmp_389, new ConceptData('MultilineText', 'jetbrains.biokb.lang.model.MultilineText', true, false, VOID, tmp_390, listOf(new ChildrenMemberData(tmp92_link, 'lines', getKClass(TextLine), true))));
    var tmp_393 = getKClass(MultipleProcessPropertyValueRange_1);
    var tmp_394 = listOf(getKClass(ProcessPropertyValueRange));
    var tmp_395 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_109 = getPropertyCallableRef('type', 1, tmp_395, MultipleProcessPropertyValueRange$_get_type_$ref_fp68ik(), null);
    var tmp93_link = new SingleChildLink(getKClass(MultipleProcessPropertyValueRange_1), this_109);
    var tmp_396 = to(tmp_393, new ConceptData('MultipleProcessPropertyValueRange', 'jetbrains.biokb.lang.model.MultipleProcessPropertyValueRange', true, false, VOID, tmp_394, listOf(new ChildrenMemberData(tmp93_link, 'type', getKClass(ProcessPropertyType), false))));
    var tmp_397 = getKClass(MultiplePropertyValueRange_1);
    var tmp_398 = getKClass(PropertyValueRange);
    var tmp_399 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_110 = getPropertyCallableRef('types', 1, tmp_399, MultiplePropertyValueRange$_get_types_$ref_3rqsk4(), null);
    var tmp94_link = new MultipleChildLink(getKClass(MultiplePropertyValueRange_1), this_110);
    var tmp_400 = to(tmp_397, new ConceptData('MultiplePropertyValueRange', 'jetbrains.biokb.lang.model.MultiplePropertyValueRange', true, false, tmp_398, VOID, listOf(new ChildrenMemberData(tmp94_link, 'types', getKClass(Type), true))));
    var tmp_401 = getKClass(MultipliedExpression_1);
    var tmp_402 = listOf(getKClass(FactExpression));
    var tmp_403 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_111 = getPropertyCallableRef('rawMultiplier', 1, tmp_403, MultipliedExpression$_get_rawMultiplier_$ref_pej37m(), null);
    var tmp$ret$111 = new ValueAttributeLink(getKClass(MultipliedExpression_1), this_111, createKType(PrimitiveClasses_getInstance().ob(), arrayOf([]), false));
    var tmp_404 = new AttributeData(tmp$ret$111, 'rawMultiplier', new SimpleAttributeType(false, PrimitiveClasses_getInstance().ob()));
    var tmp_405 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_112 = getPropertyCallableRef('expression', 1, tmp_405, MultipliedExpression$_get_expression_$ref_l608dh(), null);
    var tmp95_link = new SingleChildLink(getKClass(MultipliedExpression_1), this_112);
    var tmp_406 = to(tmp_401, new ConceptData('MultipliedExpression', 'jetbrains.biokb.lang.model.MultipliedExpression', true, false, VOID, tmp_402, listOf_0([tmp_404, new ChildrenMemberData(tmp95_link, 'expression', getKClass(FactExpressionPlaceholder), false)])));
    var tmp_407 = getKClass(NewFact);
    var tmp_408 = listOf_0([getKClass(BTBNode), getKClass(DirectlyNamed)]);
    var tmp_409 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_113 = getPropertyCallableRef('expression', 1, tmp_409, NewFact$_get_expression_$ref_buri7u(), null);
    var tmp96_link = new SingleChildLink(getKClass(NewFact), this_113);
    var tmp_410 = to(tmp_407, new ConceptData('NewFact', 'jetbrains.biokb.lang.model.NewFact', true, false, VOID, tmp_408, listOf(new ChildrenMemberData(tmp96_link, 'expression', getKClass(FactExpression), false))));
    var tmp_411 = getKClass(NewFactReference_0);
    var tmp_412 = listOf(getKClass(FactExpression));
    var tmp_413 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var this_114 = getPropertyCallableRef('ref', 1, tmp_413, NewFactReference$_get_ref_$ref_4jyz94(), null);
    var tmp97_link = new ReferenceLink(getKClass(NewFactReference_0), this_114, getKClass(NewFact), getKClass(LocalReferenceContent));
    var tmp_414 = to(tmp_411, new ConceptData('NewFactReference', 'jetbrains.biokb.lang.model.NewFactReference', true, false, VOID, tmp_412, listOf(new ReferenceMemberData(tmp97_link, 'ref', getKClass(NewFact)))));
    var tmp_415 = to(getKClass(NoValues_1), new ConceptData('NoValues', 'jetbrains.biokb.lang.model.NoValues', true, false, getKClass(PropertyValueRange)));
    var tmp_416 = getKClass(NotionLibrary_1);
    var tmp_417 = getKClass(DocumentNode_0);
    var tmp_418 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_115 = getPropertyCallableRef('notions', 1, tmp_418, NotionLibrary$_get_notions_$ref_ejoba4(), null);
    var tmp98_link = new MultipleChildLink(getKClass(NotionLibrary_1), this_115);
    var tmp_419 = to(tmp_416, new ConceptData('NotionLibrary', 'jetbrains.biokb.lang.model.NotionLibrary', true, false, tmp_417, VOID, listOf(new ChildrenMemberData(tmp98_link, 'notions', getKClass(AbstractNotion), true))));
    var tmp_420 = to(getKClass(NotionPlaceholder_1), new ConceptData('NotionPlaceholder', 'jetbrains.biokb.lang.model.NotionPlaceholder', true, false, getKClass(AbstractNotion)));
    var tmp_421 = getKClass(NotionType_0);
    var tmp_422 = getKClass(Type);
    var tmp_423 = listOf(getKClass(AllowedComplexNotionType));
    var tmp_424 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var this_116 = getPropertyCallableRef('notion', 1, tmp_424, NotionType$_get_notion_$ref_5i807a(), null);
    var tmp99_link = new ReferenceLink(getKClass(NotionType_0), this_116, getKClass(AbstractNotion), getKClass(QualifiedReferenceContent));
    var tmp_425 = to(tmp_421, new ConceptData('NotionType', 'jetbrains.biokb.lang.model.NotionType', true, false, tmp_422, tmp_423, listOf(new ReferenceMemberData(tmp99_link, 'notion', getKClass(AbstractNotion)))));
    var tmp_426 = getKClass(ObjectPropertiesLibrary);
    var tmp_427 = getKClass(DocumentNode_0);
    var tmp_428 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_117 = getPropertyCallableRef('properties', 1, tmp_428, ObjectPropertiesLibrary$_get_properties_$ref_3l7x8e(), null);
    var tmp100_link = new MultipleChildLink(getKClass(ObjectPropertiesLibrary), this_117);
    var tmp_429 = to(tmp_426, new ConceptData('ObjectPropertiesLibrary', 'jetbrains.biokb.lang.model.ObjectPropertiesLibrary', true, false, tmp_427, VOID, listOf(new ChildrenMemberData(tmp100_link, 'properties', getKClass(ObjectPropertyDeclaration_1), true))));
    var tmp_430 = getKClass(ObjectPropertyDeclaration_1);
    var tmp_431 = listOf_0([getKClass(BTBNode), getKClass(DirectlyNamed), getKClass(HasComments)]);
    var tmp_432 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_118 = getPropertyCallableRef('grouping', 1, tmp_432, ObjectPropertyDeclaration$_get_grouping_$ref_xld1xn(), null);
    var tmp$ret$118 = new ValueAttributeLink(getKClass(ObjectPropertyDeclaration_1), this_118, createKType(PrimitiveClasses_getInstance().lb(), arrayOf([]), false));
    var tmp_433 = new AttributeData(tmp$ret$118, 'grouping', new SimpleAttributeType(false, PrimitiveClasses_getInstance().lb()));
    var tmp_434 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var this_119 = getPropertyCallableRef('superProperty', 1, tmp_434, ObjectPropertyDeclaration$_get_superProperty_$ref_32i1ji(), null);
    var tmp101_link = new ReferenceLink(getKClass(ObjectPropertyDeclaration_1), this_119, getKClass(ObjectPropertyDeclaration_1), getKClass(QualifiedReferenceContent));
    var tmp_435 = new ReferenceMemberData(tmp101_link, 'superProperty', getKClass(ObjectPropertyDeclaration_1));
    var tmp_436 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_120 = getPropertyCallableRef('domain', 1, tmp_436, ObjectPropertyDeclaration$_get_domain_$ref_u5oj2s(), null);
    var tmp102_link = new MultipleChildLink(getKClass(ObjectPropertyDeclaration_1), this_120);
    var tmp_437 = new ChildrenMemberData(tmp102_link, 'domain', getKClass(Type), true);
    var tmp_438 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_121 = getPropertyCallableRef('range', 1, tmp_438, ObjectPropertyDeclaration$_get_range_$ref_rc2nln(), null);
    var tmp103_link = new SingleChildLink(getKClass(ObjectPropertyDeclaration_1), this_121);
    var tmp_439 = new ChildrenMemberData(tmp103_link, 'range', getKClass(PropertyValueRange), false);
    var tmp_440 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_122 = getPropertyCallableRef('dependent', 1, tmp_440, ObjectPropertyDeclaration$_get_dependent_$ref_o70pa5(), null);
    var tmp$ret$122 = new ValueAttributeLink(getKClass(ObjectPropertyDeclaration_1), this_122, createKType(PrimitiveClasses_getInstance().lb(), arrayOf([]), false));
    var tmp_441 = new AttributeData(tmp$ret$122, 'dependent', new SimpleAttributeType(false, PrimitiveClasses_getInstance().lb()));
    var tmp_442 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var this_123 = getPropertyCallableRef('inverse', 1, tmp_442, ObjectPropertyDeclaration$_get_inverse_$ref_tftvf2(), null);
    var tmp104_link = new ReferenceLink(getKClass(ObjectPropertyDeclaration_1), this_123, getKClass(ObjectPropertyDeclaration_1), getKClass(QualifiedReferenceContent));
    var tmp_443 = to(tmp_430, new ConceptData('ObjectPropertyDeclaration', 'jetbrains.biokb.lang.model.ObjectPropertyDeclaration', true, false, VOID, tmp_431, listOf_0([tmp_433, tmp_435, tmp_437, tmp_439, tmp_441, new ReferenceMemberData(tmp104_link, 'inverse', getKClass(ObjectPropertyDeclaration_1))])));
    var tmp_444 = getKClass(ObjectPropertyReferenceValue_1);
    var tmp_445 = listOf_0([getKClass(AbstractValue), getKClass(FactExpression)]);
    var tmp_446 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_124 = getPropertyCallableRef('operand', 1, tmp_446, ObjectPropertyReferenceValue$_get_operand_$ref_4h40b1(), null);
    var tmp105_link = new SingleChildLink(getKClass(ObjectPropertyReferenceValue_1), this_124);
    var tmp_447 = new ChildrenMemberData(tmp105_link, 'operand', getKClass(AbstractValue), false);
    var tmp_448 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_125 = getPropertyCallableRef('property', 1, tmp_448, ObjectPropertyReferenceValue$_get_property_$ref_zar09b(), null);
    var tmp106_link = new SingleChildLink(getKClass(ObjectPropertyReferenceValue_1), this_125);
    var tmp_449 = to(tmp_444, new ConceptData('ObjectPropertyReferenceValue', 'jetbrains.biokb.lang.model.ObjectPropertyReferenceValue', true, false, VOID, tmp_445, listOf_0([tmp_447, new ChildrenMemberData(tmp106_link, 'property', getKClass(PropertyReferenceOperation_1), false)])));
    var tmp_450 = getKClass(OldPublishedSource);
    var tmp_451 = getKClass(PublishedWork);
    var tmp_452 = listOf(getKClass(LibraryItem));
    var tmp_453 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_126 = getPropertyCallableRef('authorsProperty', 1, tmp_453, OldPublishedSource$_get_authorsProperty_$ref_umm0gx(), null);
    var tmp$ret$126 = new ValueAttributeLink(getKClass(OldPublishedSource), this_126, createKType(PrimitiveClasses_getInstance().tb(), arrayOf([]), false));
    var tmp_454 = new AttributeData(tmp$ret$126, 'authorsProperty', new SimpleAttributeType(false, PrimitiveClasses_getInstance().tb()));
    var tmp_455 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_127 = getPropertyCallableRef('data', 1, tmp_455, OldPublishedSource$_get_data_$ref_qz5g2a(), null);
    var tmp$ret$127 = new ValueAttributeLink(getKClass(OldPublishedSource), this_127, createKType(PrimitiveClasses_getInstance().tb(), arrayOf([]), false));
    var tmp_456 = to(tmp_450, new ConceptData('OldPublishedSource', 'jetbrains.biokb.lang.model.OldPublishedSource', true, false, tmp_451, tmp_452, listOf_0([tmp_454, new AttributeData(tmp$ret$127, 'data', new SimpleAttributeType(false, PrimitiveClasses_getInstance().tb()))])));
    var tmp_457 = getKClass(OneOf_1);
    var tmp_458 = getKClass(Type);
    var tmp_459 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_128 = getPropertyCallableRef('expressions', 1, tmp_459, OneOf$_get_expressions_$ref_t8u9ia(), null);
    var tmp107_link = new MultipleChildLink(getKClass(OneOf_1), this_128);
    var tmp_460 = to(tmp_457, new ConceptData('OneOf', 'jetbrains.biokb.lang.model.OneOf', true, false, tmp_458, VOID, listOf(new ChildrenMemberData(tmp107_link, 'expressions', getKClass(FactExpressionPlaceholder), true))));
    var tmp_461 = getKClass(OntologyCardinalityRelation_1);
    var tmp_462 = getKClass(AbstractOntologyRelation);
    var tmp_463 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_129 = getPropertyCallableRef('classExpression', 1, tmp_463, OntologyCardinalityRelation$_get_classExpression_$ref_42v2qv(), null);
    var tmp108_link = new SingleChildLink(getKClass(OntologyCardinalityRelation_1), this_129);
    var tmp_464 = new ChildrenMemberData(tmp108_link, 'classExpression', getKClass(ClassExpression), false);
    var tmp_465 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_130 = getPropertyCallableRef('cardinality', 1, tmp_465, OntologyCardinalityRelation$_get_cardinality_$ref_ld39xl(), null);
    var tmp109_link = new SingleChildLink(getKClass(OntologyCardinalityRelation_1), this_130);
    var tmp_466 = to(tmp_461, new ConceptData('OntologyCardinalityRelation', 'jetbrains.biokb.lang.model.OntologyCardinalityRelation', true, false, tmp_462, VOID, listOf_0([tmp_464, new ChildrenMemberData(tmp109_link, 'cardinality', getKClass(Cardinality_1), false)])));
    var tmp_467 = getKClass(OntologyElement_1);
    var tmp_468 = listOf_0([getKClass(BTBNode), getKClass(DirectlyNamed), getKClass(ClassDeclaration), getKClass(HasPropertyConstraints), getKClass(HasComments)]);
    var tmp_469 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_131 = getPropertyCallableRef('superElements', 1, tmp_469, OntologyElement$_get_superElements_$ref_eb9rkn(), null);
    var tmp110_link = new MultipleChildLink(getKClass(OntologyElement_1), this_131);
    var tmp_470 = new ChildrenMemberData(tmp110_link, 'superElements', getKClass(OntologyIsRelation_1), true);
    var tmp_471 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_132 = getPropertyCallableRef('enclosingElements', 1, tmp_471, OntologyElement$_get_enclosingElements_$ref_uplwca(), null);
    var tmp111_link = new MultipleChildLink(getKClass(OntologyElement_1), this_132);
    var tmp_472 = new ChildrenMemberData(tmp111_link, 'enclosingElements', getKClass(OntologyCardinalityRelation_1), true);
    var tmp_473 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_133 = getPropertyCallableRef('taxon', 1, tmp_473, OntologyElement$_get_taxon_$ref_my9s4f(), null);
    var tmp112_link = new SingleChildLink(getKClass(OntologyElement_1), this_133);
    var tmp_474 = new ChildrenMemberData(tmp112_link, 'taxon', getKClass(ClassExpression), false);
    var tmp_475 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_134 = getPropertyCallableRef('url', 1, tmp_475, OntologyElement$_get_url_$ref_6gfppi(), null);
    var tmp$ret$134 = new ValueAttributeLink(getKClass(OntologyElement_1), this_134, createKType(PrimitiveClasses_getInstance().tb(), arrayOf([]), false));
    var tmp_476 = new AttributeData(tmp$ret$134, 'url', new SimpleAttributeType(false, PrimitiveClasses_getInstance().tb()));
    var tmp_477 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_135 = getPropertyCallableRef('nameHint', 1, tmp_477, OntologyElement$_get_nameHint_$ref_xvfepr(), null);
    var tmp$ret$135 = new ValueAttributeLink(getKClass(OntologyElement_1), this_135, createKType(PrimitiveClasses_getInstance().tb(), arrayOf([]), false));
    var tmp_478 = new AttributeData(tmp$ret$135, 'nameHint', new SimpleAttributeType(false, PrimitiveClasses_getInstance().tb()));
    var tmp_479 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_136 = getPropertyCallableRef('additionalUrls', 1, tmp_479, OntologyElement$_get_additionalUrls_$ref_n8oe7a(), null);
    var tmp113_link = new MultipleChildLink(getKClass(OntologyElement_1), this_136);
    var tmp_480 = new ChildrenMemberData(tmp113_link, 'additionalUrls', getKClass(Url_1), true);
    var tmp_481 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_137 = getPropertyCallableRef('synonyms', 1, tmp_481, OntologyElement$_get_synonyms_$ref_j21l21(), null);
    var tmp114_link = new MultipleChildLink(getKClass(OntologyElement_1), this_137);
    var tmp_482 = new ChildrenMemberData(tmp114_link, 'synonyms', getKClass(OntologyElementSynonym_1), true);
    var tmp_483 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_138 = getPropertyCallableRef('xRefContainers', 1, tmp_483, OntologyElement$_get_xRefContainers_$ref_tur9gc(), null);
    var tmp115_link = new MultipleChildLink(getKClass(OntologyElement_1), this_138);
    var tmp_484 = new ChildrenMemberData(tmp115_link, 'xRefContainers', getKClass(XRefContainer), true);
    var tmp_485 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_139 = getPropertyCallableRef('oldDefinition', 1, tmp_485, OntologyElement$_get_oldDefinition_$ref_nndimn(), null);
    var tmp116_link = new SingleChildLink(getKClass(OntologyElement_1), this_139);
    var tmp_486 = new ChildrenMemberData(tmp116_link, 'oldDefinition', getKClass(AnonymousClass), false);
    var tmp_487 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_140 = getPropertyCallableRef('definition', 1, tmp_487, OntologyElement$_get_definition_$ref_ra1mma(), null);
    var tmp117_link = new SingleChildLink(getKClass(OntologyElement_1), this_140);
    var tmp_488 = to(tmp_467, new ConceptData('OntologyElement', 'jetbrains.biokb.lang.model.OntologyElement', true, false, VOID, tmp_468, listOf_0([tmp_470, tmp_472, tmp_474, tmp_476, tmp_478, tmp_480, tmp_482, tmp_484, tmp_486, new ChildrenMemberData(tmp117_link, 'definition', getKClass(OntologyElementDefinition_1), false)])));
    var tmp_489 = getKClass(OntologyElementDefinition_1);
    var tmp_490 = listOf_0([getKClass(BTBNode), getKClass(HasPropertyConstraints)]);
    var tmp_491 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_141 = getPropertyCallableRef('classExpression', 1, tmp_491, OntologyElementDefinition$_get_classExpression_$ref_7q14es(), null);
    var tmp118_link = new SingleChildLink(getKClass(OntologyElementDefinition_1), this_141);
    var tmp_492 = to(tmp_489, new ConceptData('OntologyElementDefinition', 'jetbrains.biokb.lang.model.OntologyElementDefinition', true, false, VOID, tmp_490, listOf(new ChildrenMemberData(tmp118_link, 'classExpression', getKClass(ClassExpression), false))));
    var tmp_493 = getKClass(OntologyElementPropertyType_1);
    var tmp_494 = listOf(getKClass(ProcessPropertyType));
    var tmp_495 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_142 = getPropertyCallableRef('specificator', 1, tmp_495, OntologyElementPropertyType$_get_specificator_$ref_coyqyi(), null);
    var tmp$ret$142 = new ValueAttributeLink(getKClass(OntologyElementPropertyType_1), this_142, createKType(getKClass(LinkTypeSpecificator), arrayOf([]), true));
    var tmp_496 = new AttributeData(tmp$ret$142, 'specificator', new EnumAttributeType(true, getKClass(LinkTypeSpecificator), listOf_0([LinkTypeSpecificator_INSTANCE_OF_getInstance(), LinkTypeSpecificator_TYPE_OF_getInstance()])));
    var tmp_497 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_143 = getPropertyCallableRef('library', 1, tmp_497, OntologyElementPropertyType$_get_library_$ref_izz7j1(), null);
    var tmp119_link = new SingleChildLink(getKClass(OntologyElementPropertyType_1), this_143);
    var tmp_498 = new ChildrenMemberData(tmp119_link, 'library', getKClass(OntologyLibraryReference_1), false);
    var tmp_499 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_144 = getPropertyCallableRef('element', 1, tmp_499, OntologyElementPropertyType$_get_element_$ref_x8jl50(), null);
    var tmp120_link = new SingleChildLink(getKClass(OntologyElementPropertyType_1), this_144);
    var tmp_500 = to(tmp_493, new ConceptData('OntologyElementPropertyType', 'jetbrains.biokb.lang.model.OntologyElementPropertyType', true, false, VOID, tmp_494, listOf_0([tmp_496, tmp_498, new ChildrenMemberData(tmp120_link, 'element', getKClass(OntologyElementReference_1), false)])));
    var tmp_501 = getKClass(OntologyElementReference_1);
    var tmp_502 = listOf_0([getKClass(BTBNode), getKClass(OntologyElementReferenceProvider)]);
    var tmp_503 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var this_145 = getPropertyCallableRef('element', 1, tmp_503, OntologyElementReference$_get_element_$ref_3s4b1e(), null);
    var tmp121_link = new ReferenceLink(getKClass(OntologyElementReference_1), this_145, getKClass(OntologyElement_1), getKClass(QualifiedReferenceContent));
    var tmp_504 = to(tmp_501, new ConceptData('OntologyElementReference', 'jetbrains.biokb.lang.model.OntologyElementReference', true, false, VOID, tmp_502, listOf(new ReferenceMemberData(tmp121_link, 'element', getKClass(OntologyElement_1)))));
    var tmp_505 = to(getKClass(OntologyElementReferenceProvider), new ConceptData('OntologyElementReferenceProvider', 'jetbrains.biokb.lang.model.OntologyElementReferenceProvider', false, false, VOID, listOf(getKClass(ClassExpression))));
    var tmp_506 = getKClass(OntologyElementReferenceValue_1);
    var tmp_507 = listOf_0([getKClass(AbstractValue), getKClass(FactExpression)]);
    var tmp_508 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_146 = getPropertyCallableRef('element', 1, tmp_508, OntologyElementReferenceValue$_get_element_$ref_kjo2gj(), null);
    var tmp122_link = new SingleChildLink(getKClass(OntologyElementReferenceValue_1), this_146);
    var tmp_509 = to(tmp_506, new ConceptData('OntologyElementReferenceValue', 'jetbrains.biokb.lang.model.OntologyElementReferenceValue', true, false, VOID, tmp_507, listOf(new ChildrenMemberData(tmp122_link, 'element', getKClass(OntologyElementReference_1), false))));
    var tmp_510 = getKClass(OntologyElementReferenceValueLibrary_1);
    var tmp_511 = getKClass(OntologyElementReferenceValue_1);
    var tmp_512 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_147 = getPropertyCallableRef('library', 1, tmp_512, OntologyElementReferenceValueLibrary$_get_library_$ref_ni4dih(), null);
    var tmp123_link = new SingleChildLink(getKClass(OntologyElementReferenceValueLibrary_1), this_147);
    var tmp_513 = to(tmp_510, new ConceptData('OntologyElementReferenceValueLibrary', 'jetbrains.biokb.lang.model.OntologyElementReferenceValueLibrary', true, false, tmp_511, VOID, listOf(new ChildrenMemberData(tmp123_link, 'library', getKClass(OntologyLibraryReference_1), false))));
    var tmp_514 = getKClass(OntologyElementSynonym_1);
    var tmp_515 = listOf(getKClass(BTBNode));
    var tmp_516 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_148 = getPropertyCallableRef('name', 1, tmp_516, OntologyElementSynonym$_get_name_$ref_ojzpad(), null);
    var tmp$ret$148 = new ValueAttributeLink(getKClass(OntologyElementSynonym_1), this_148, createKType(PrimitiveClasses_getInstance().tb(), arrayOf([]), false));
    var tmp_517 = to(tmp_514, new ConceptData('OntologyElementSynonym', 'jetbrains.biokb.lang.model.OntologyElementSynonym', true, false, VOID, tmp_515, listOf(new AttributeData(tmp$ret$148, 'name', new SimpleAttributeType(false, PrimitiveClasses_getInstance().tb())))));
    var tmp_518 = getKClass(OntologyElementType_1);
    var tmp_519 = getKClass(Type);
    var tmp_520 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_149 = getPropertyCallableRef('library', 1, tmp_520, OntologyElementType$_get_library_$ref_qnafmw(), null);
    var tmp124_link = new SingleChildLink(getKClass(OntologyElementType_1), this_149);
    var tmp_521 = new ChildrenMemberData(tmp124_link, 'library', getKClass(OntologyLibraryReference_1), false);
    var tmp_522 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_150 = getPropertyCallableRef('element', 1, tmp_522, OntologyElementType$_get_element_$ref_pl8d15(), null);
    var tmp125_link = new SingleChildLink(getKClass(OntologyElementType_1), this_150);
    var tmp_523 = to(tmp_518, new ConceptData('OntologyElementType', 'jetbrains.biokb.lang.model.OntologyElementType', true, false, tmp_519, VOID, listOf_0([tmp_521, new ChildrenMemberData(tmp125_link, 'element', getKClass(OntologyElementReference_1), false)])));
    var tmp_524 = getKClass(OntologyImport_1);
    var tmp_525 = listOf(getKClass(BTBNode));
    var tmp_526 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_151 = getPropertyCallableRef('ontology', 1, tmp_526, OntologyImport$_get_ontology_$ref_5t3sat(), null);
    var tmp126_link = new SingleChildLink(getKClass(OntologyImport_1), this_151);
    var tmp_527 = new ChildrenMemberData(tmp126_link, 'ontology', getKClass(OntologyLibraryReference_1), false);
    var tmp_528 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_152 = getPropertyCallableRef('element', 1, tmp_528, OntologyImport$_get_element_$ref_7h70ks(), null);
    var tmp127_link = new SingleChildLink(getKClass(OntologyImport_1), this_152);
    var tmp_529 = new ChildrenMemberData(tmp127_link, 'element', getKClass(OntologyElementReference_1), false);
    var tmp_530 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_153 = getPropertyCallableRef('libraryToUse', 1, tmp_530, OntologyImport$_get_libraryToUse_$ref_z1ihvd(), null);
    var tmp128_link = new SingleChildLink(getKClass(OntologyImport_1), this_153);
    var tmp_531 = to(tmp_524, new ConceptData('OntologyImport', 'jetbrains.biokb.lang.model.OntologyImport', true, false, VOID, tmp_525, listOf_0([tmp_527, tmp_529, new ChildrenMemberData(tmp128_link, 'libraryToUse', getKClass(OntologyLibraryReference_1), false)])));
    var tmp_532 = getKClass(OntologyImportRoot_1);
    var tmp_533 = getKClass(DocumentNode_0);
    var tmp_534 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_154 = getPropertyCallableRef('imports', 1, tmp_534, OntologyImportRoot$_get_imports_$ref_rcorbw(), null);
    var tmp129_link = new MultipleChildLink(getKClass(OntologyImportRoot_1), this_154);
    var tmp_535 = to(tmp_532, new ConceptData('OntologyImportRoot', 'jetbrains.biokb.lang.model.OntologyImportRoot', true, false, tmp_533, VOID, listOf(new ChildrenMemberData(tmp129_link, 'imports', getKClass(OntologyImport_1), true))));
    var tmp_536 = getKClass(OntologyImportRootReference_1);
    var tmp_537 = listOf(getKClass(BTBNode));
    var tmp_538 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var this_155 = getPropertyCallableRef('ref', 1, tmp_538, OntologyImportRootReference$_get_ref_$ref_qpspni(), null);
    var tmp130_link = new ReferenceLink(getKClass(OntologyImportRootReference_1), this_155, getKClass(OntologyImportRoot_1), getKClass(QualifiedReferenceContent));
    var tmp_539 = to(tmp_536, new ConceptData('OntologyImportRootReference', 'jetbrains.biokb.lang.model.OntologyImportRootReference', true, false, VOID, tmp_537, listOf(new ReferenceMemberData(tmp130_link, 'ref', getKClass(OntologyImportRoot_1)))));
    var tmp_540 = getKClass(OntologyIsRelation_1);
    var tmp_541 = getKClass(AbstractOntologyRelation);
    var tmp_542 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_156 = getPropertyCallableRef('elementReferenceProvider', 1, tmp_542, OntologyIsRelation$_get_elementReferenceProvider_$ref_bgjhbd(), null);
    var tmp131_link = new SingleChildLink(getKClass(OntologyIsRelation_1), this_156);
    var tmp_543 = to(tmp_540, new ConceptData('OntologyIsRelation', 'jetbrains.biokb.lang.model.OntologyIsRelation', true, false, tmp_541, VOID, listOf(new ChildrenMemberData(tmp131_link, 'elementReferenceProvider', getKClass(OntologyElementReferenceProvider), false))));
    var tmp_544 = getKClass(OntologyLibrary_1);
    var tmp_545 = getKClass(DocumentNode_0);
    var tmp_546 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_157 = getPropertyCallableRef('elements', 1, tmp_546, OntologyLibrary$_get_elements_$ref_5im1vf(), null);
    var tmp132_link = new MultipleChildLink(getKClass(OntologyLibrary_1), this_157);
    var tmp_547 = to(tmp_544, new ConceptData('OntologyLibrary', 'jetbrains.biokb.lang.model.OntologyLibrary', true, false, tmp_545, VOID, listOf(new ChildrenMemberData(tmp132_link, 'elements', getKClass(OntologyElement_1), true))));
    var tmp_548 = getKClass(OntologyLibraryReference_1);
    var tmp_549 = listOf(getKClass(BTBNode));
    var tmp_550 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var this_158 = getPropertyCallableRef('ref', 1, tmp_550, OntologyLibraryReference$_get_ref_$ref_894de0(), null);
    var tmp133_link = new ReferenceLink(getKClass(OntologyLibraryReference_1), this_158, getKClass(OntologyLibrary_1), getKClass(QualifiedReferenceContent));
    var tmp_551 = to(tmp_548, new ConceptData('OntologyLibraryReference', 'jetbrains.biokb.lang.model.OntologyLibraryReference', true, false, VOID, tmp_549, listOf(new ReferenceMemberData(tmp133_link, 'ref', getKClass(OntologyLibrary_1)))));
    var tmp_552 = getKClass(OntologyLink_1);
    var tmp_553 = getKClass(AbstractLink);
    var tmp_554 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_159 = getPropertyCallableRef('link', 1, tmp_554, OntologyLink$_get_link_$ref_38pp17(), null);
    var tmp134_link = new SingleChildLink(getKClass(OntologyLink_1), this_159);
    var tmp_555 = new ChildrenMemberData(tmp134_link, 'link', getKClass(LinkDeclaration_1), false);
    var tmp_556 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_160 = getPropertyCallableRef('defaultLibraryReference', 1, tmp_556, OntologyLink$_get_defaultLibraryReference_$ref_7bd1ik(), null);
    var tmp135_link = new SingleChildLink(getKClass(OntologyLink_1), this_160);
    var tmp_557 = to(tmp_552, new ConceptData('OntologyLink', 'jetbrains.biokb.lang.model.OntologyLink', true, false, tmp_553, VOID, listOf_0([tmp_555, new ChildrenMemberData(tmp135_link, 'defaultLibraryReference', getKClass(OntologyLibraryReference_1), false)])));
    var tmp_558 = getKClass(OntologyLinkDeclarationValueQuery_1);
    var tmp_559 = getKClass(DeclarationValueQuery);
    var tmp_560 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var this_161 = getPropertyCallableRef('linkDeclaration', 1, tmp_560, OntologyLinkDeclarationValueQuery$_get_linkDeclaration_$ref_tqydwc(), null);
    var tmp136_link = new ReferenceLink(getKClass(OntologyLinkDeclarationValueQuery_1), this_161, getKClass(LinkDeclaration_1), getKClass(QualifiedReferenceContent));
    var tmp_561 = to(tmp_558, new ConceptData('OntologyLinkDeclarationValueQuery', 'jetbrains.biokb.lang.model.OntologyLinkDeclarationValueQuery', true, false, tmp_559, VOID, listOf(new ReferenceMemberData(tmp136_link, 'linkDeclaration', getKClass(LinkDeclaration_1)))));
    var tmp_562 = getKClass(OntologyLinkValue_1);
    var tmp_563 = getKClass(AbstractBindingValue);
    var tmp_564 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var this_162 = getPropertyCallableRef('linkReference', 1, tmp_564, OntologyLinkValue$_get_linkReference_$ref_kx9ikt(), null);
    var tmp137_link = new ReferenceLink(getKClass(OntologyLinkValue_1), this_162, getKClass(AbstractLink), getKClass(QualifiedReferenceContent));
    var tmp_565 = to(tmp_562, new ConceptData('OntologyLinkValue', 'jetbrains.biokb.lang.model.OntologyLinkValue', true, false, tmp_563, VOID, listOf(new ReferenceMemberData(tmp137_link, 'linkReference', getKClass(AbstractLink)))));
    var tmp_566 = getKClass(OrValueQuery_1);
    var tmp_567 = getKClass(AbstractBindingValueQuery);
    var tmp_568 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_163 = getPropertyCallableRef('left', 1, tmp_568, OrValueQuery$_get_left_$ref_6b13k3(), null);
    var tmp138_link = new SingleChildLink(getKClass(OrValueQuery_1), this_163);
    var tmp_569 = new ChildrenMemberData(tmp138_link, 'left', getKClass(AbstractBindingValueQuery), false);
    var tmp_570 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_164 = getPropertyCallableRef('right', 1, tmp_570, OrValueQuery$_get_right_$ref_trhuiu(), null);
    var tmp139_link = new SingleChildLink(getKClass(OrValueQuery_1), this_164);
    var tmp_571 = to(tmp_566, new ConceptData('OrValueQuery', 'jetbrains.biokb.lang.model.OrValueQuery', true, false, tmp_567, VOID, listOf_0([tmp_569, new ChildrenMemberData(tmp139_link, 'right', getKClass(AbstractBindingValueQuery), false)])));
    var tmp_572 = getKClass(Page_1);
    var tmp_573 = getKClass(PageSpecification);
    var tmp_574 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_165 = getPropertyCallableRef('page', 1, tmp_574, Page$_get_page_$ref_r03c4g(), null);
    var tmp$ret$165 = new ValueAttributeLink(getKClass(Page_1), this_165, createKType(PrimitiveClasses_getInstance().ob(), arrayOf([]), false));
    var tmp_575 = to(tmp_572, new ConceptData('Page', 'jetbrains.biokb.lang.model.Page', true, false, tmp_573, VOID, listOf(new AttributeData(tmp$ret$165, 'page', new SimpleAttributeType(false, PrimitiveClasses_getInstance().ob())))));
    var tmp_576 = getKClass(PageRange_1);
    var tmp_577 = getKClass(PageSpecification);
    var tmp_578 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_166 = getPropertyCallableRef('start', 1, tmp_578, PageRange$_get_start_$ref_aos33s(), null);
    var tmp$ret$166 = new ValueAttributeLink(getKClass(PageRange_1), this_166, createKType(PrimitiveClasses_getInstance().ob(), arrayOf([]), false));
    var tmp_579 = new AttributeData(tmp$ret$166, 'start', new SimpleAttributeType(false, PrimitiveClasses_getInstance().ob()));
    var tmp_580 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_167 = getPropertyCallableRef('end', 1, tmp_580, PageRange$_get_end_$ref_yt6pin(), null);
    var tmp$ret$167 = new ValueAttributeLink(getKClass(PageRange_1), this_167, createKType(PrimitiveClasses_getInstance().ob(), arrayOf([]), false));
    var tmp_581 = to(tmp_576, new ConceptData('PageRange', 'jetbrains.biokb.lang.model.PageRange', true, false, tmp_577, VOID, listOf_0([tmp_579, new AttributeData(tmp$ret$167, 'end', new SimpleAttributeType(false, PrimitiveClasses_getInstance().ob()))])));
    var tmp_582 = to(getKClass(PageSpecification), new ConceptData('PageSpecification', 'jetbrains.biokb.lang.model.PageSpecification', false, false, VOID, listOf(getKClass(BTBNode))));
    var tmp_583 = getKClass(Paper_1);
    var tmp_584 = getKClass(PublishedWork);
    var tmp_585 = listOf(getKClass(LibraryItem));
    var tmp_586 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_168 = getPropertyCallableRef('sourceShortTitle', 1, tmp_586, Paper$_get_sourceShortTitle_$ref_ie9m1x(), null);
    var tmp$ret$168 = new ValueAttributeLink(getKClass(Paper_1), this_168, createKType(PrimitiveClasses_getInstance().tb(), arrayOf([]), false));
    var tmp_587 = new AttributeData(tmp$ret$168, 'sourceShortTitle', new SimpleAttributeType(false, PrimitiveClasses_getInstance().tb()));
    var tmp_588 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_169 = getPropertyCallableRef('sourceFullTitle', 1, tmp_588, Paper$_get_sourceFullTitle_$ref_16bavu(), null);
    var tmp$ret$169 = new ValueAttributeLink(getKClass(Paper_1), this_169, createKType(PrimitiveClasses_getInstance().tb(), arrayOf([]), false));
    var tmp_589 = new AttributeData(tmp$ret$169, 'sourceFullTitle', new SimpleAttributeType(false, PrimitiveClasses_getInstance().tb()));
    var tmp_590 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_170 = getPropertyCallableRef('volume', 1, tmp_590, Paper$_get_volume_$ref_y3o3l4(), null);
    var tmp$ret$170 = new ValueAttributeLink(getKClass(Paper_1), this_170, createKType(PrimitiveClasses_getInstance().tb(), arrayOf([]), false));
    var tmp_591 = new AttributeData(tmp$ret$170, 'volume', new SimpleAttributeType(false, PrimitiveClasses_getInstance().tb()));
    var tmp_592 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_171 = getPropertyCallableRef('issue', 1, tmp_592, Paper$_get_issue_$ref_72q3ox(), null);
    var tmp$ret$171 = new ValueAttributeLink(getKClass(Paper_1), this_171, createKType(PrimitiveClasses_getInstance().tb(), arrayOf([]), false));
    var tmp_593 = new AttributeData(tmp$ret$171, 'issue', new SimpleAttributeType(false, PrimitiveClasses_getInstance().tb()));
    var tmp_594 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_172 = getPropertyCallableRef('pubMedId', 1, tmp_594, Paper$_get_pubMedId_$ref_8q78t4(), null);
    var tmp$ret$172 = new ValueAttributeLink(getKClass(Paper_1), this_172, createKType(PrimitiveClasses_getInstance().tb(), arrayOf([]), false));
    var tmp_595 = new AttributeData(tmp$ret$172, 'pubMedId', new SimpleAttributeType(false, PrimitiveClasses_getInstance().tb()));
    var tmp_596 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_173 = getPropertyCallableRef('pmcId', 1, tmp_596, Paper$_get_pmcId_$ref_yj2pzt(), null);
    var tmp$ret$173 = new ValueAttributeLink(getKClass(Paper_1), this_173, createKType(PrimitiveClasses_getInstance().tb(), arrayOf([]), false));
    var tmp_597 = new AttributeData(tmp$ret$173, 'pmcId', new SimpleAttributeType(false, PrimitiveClasses_getInstance().tb()));
    var tmp_598 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_174 = getPropertyCallableRef('doi', 1, tmp_598, Paper$_get_doi_$ref_ww6hfa(), null);
    var tmp$ret$174 = new ValueAttributeLink(getKClass(Paper_1), this_174, createKType(PrimitiveClasses_getInstance().tb(), arrayOf([]), false));
    var tmp_599 = new AttributeData(tmp$ret$174, 'doi', new SimpleAttributeType(false, PrimitiveClasses_getInstance().tb()));
    var tmp_600 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_175 = getPropertyCallableRef('pages', 1, tmp_600, Paper$_get_pages_$ref_56726c(), null);
    var tmp140_link = new SingleChildLink(getKClass(Paper_1), this_175);
    var tmp_601 = to(tmp_583, new ConceptData('Paper', 'jetbrains.biokb.lang.model.Paper', true, false, tmp_584, tmp_585, listOf_0([tmp_587, tmp_589, tmp_591, tmp_593, tmp_595, tmp_597, tmp_599, new ChildrenMemberData(tmp140_link, 'pages', getKClass(PageSpecification), false)])));
    var tmp_602 = to(getKClass(PartReferenceOperation), new ConceptData('PartReferenceOperation', 'jetbrains.biokb.lang.model.PartReferenceOperation', false, false, VOID, listOf(getKClass(BTBNode))));
    var tmp_603 = getKClass(PartValue);
    var tmp_604 = listOf(getKClass(AbstractValue));
    var tmp_605 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_176 = getPropertyCallableRef('operand', 1, tmp_605, PartValue$_get_operand_$ref_v35dwv(), null);
    var tmp141_link = new SingleChildLink(getKClass(PartValue), this_176);
    var tmp_606 = new ChildrenMemberData(tmp141_link, 'operand', getKClass(VariableReferenceValue_1), false);
    var tmp_607 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_177 = getPropertyCallableRef('operation', 1, tmp_607, PartValue$_get_operation_$ref_y8479p(), null);
    var tmp142_link = new SingleChildLink(getKClass(PartValue), this_177);
    var tmp_608 = to(tmp_603, new ConceptData('PartValue', 'jetbrains.biokb.lang.model.PartValue', true, false, VOID, tmp_604, listOf_0([tmp_606, new ChildrenMemberData(tmp142_link, 'operation', getKClass(PartReferenceOperation), false)])));
    var tmp_609 = to(getKClass(Pattern), new ConceptData('Pattern', 'jetbrains.biokb.lang.model.Pattern', false, false, VOID, listOf(getKClass(BTBNode))));
    var tmp_610 = to(getKClass(Precondition), new ConceptData('Precondition', 'jetbrains.biokb.lang.model.Precondition', true, false, VOID, listOf(getKClass(BTBNode))));
    var tmp_611 = getKClass(PrimitiveNotionType_1);
    var tmp_612 = getKClass(Type);
    var tmp_613 = listOf(getKClass(AllowedComplexNotionType));
    var tmp_614 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_178 = getPropertyCallableRef('primitiveKind', 1, tmp_614, PrimitiveNotionType$_get_primitiveKind_$ref_8wvqnr(), null);
    var tmp$ret$178 = new ValueAttributeLink(getKClass(PrimitiveNotionType_1), this_178, createKType(getKClass(PrimitiveKind_0), arrayOf([]), true));
    var tmp_615 = to(tmp_611, new ConceptData('PrimitiveNotionType', 'jetbrains.biokb.lang.model.PrimitiveNotionType', true, false, tmp_612, tmp_613, listOf(new AttributeData(tmp$ret$178, 'primitiveKind', new EnumAttributeType(true, getKClass(PrimitiveKind_0), listOf_0([PrimitiveKind_STRING_getInstance(), PrimitiveKind_INTEGER_getInstance()]))))));
    var tmp_616 = getKClass(PrimitivePropertyType_1);
    var tmp_617 = listOf(getKClass(ProcessPropertyType));
    var tmp_618 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_179 = getPropertyCallableRef('primitiveKind', 1, tmp_618, PrimitivePropertyType$_get_primitiveKind_$ref_evjzav(), null);
    var tmp$ret$179 = new ValueAttributeLink(getKClass(PrimitivePropertyType_1), this_179, createKType(getKClass(PrimitiveKind_0), arrayOf([]), true));
    var tmp_619 = to(tmp_616, new ConceptData('PrimitivePropertyType', 'jetbrains.biokb.lang.model.PrimitivePropertyType', true, false, VOID, tmp_617, listOf(new AttributeData(tmp$ret$179, 'primitiveKind', new EnumAttributeType(true, getKClass(PrimitiveKind_0), listOf_0([PrimitiveKind_STRING_getInstance(), PrimitiveKind_INTEGER_getInstance()]))))));
    var tmp_620 = getKClass(ProcessDeclaration_1);
    var tmp_621 = getKClass(AbstractBindingDeclaration);
    var tmp_622 = listOf(getKClass(HasVariables));
    var tmp_623 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var this_180 = getPropertyCallableRef('kind', 1, tmp_623, ProcessDeclaration$_get_kind_$ref_2xm341(), null);
    var tmp143_link = new ReferenceLink(getKClass(ProcessDeclaration_1), this_180, getKClass(ProcessKind_1), getKClass(QualifiedReferenceContent));
    var tmp_624 = new ReferenceMemberData(tmp143_link, 'kind', getKClass(ProcessKind_1));
    var tmp_625 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var this_181 = getPropertyCallableRef('extends', 1, tmp_625, ProcessDeclaration$_get_extends_$ref_8vc9n2(), null);
    var tmp144_link = new ReferenceLink(getKClass(ProcessDeclaration_1), this_181, getKClass(ProcessDeclaration_1), getKClass(QualifiedReferenceContent));
    var tmp_626 = new ReferenceMemberData(tmp144_link, 'extends', getKClass(ProcessDeclaration_1));
    var tmp_627 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_182 = getPropertyCallableRef('inherited', 1, tmp_627, ProcessDeclaration$_get_inherited_$ref_wglzfx(), null);
    var tmp145_link = new MultipleChildLink(getKClass(ProcessDeclaration_1), this_182);
    var tmp_628 = new ChildrenMemberData(tmp145_link, 'inherited', getKClass(ProcessReference_1), true);
    var tmp_629 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_183 = getPropertyCallableRef('prerequisites', 1, tmp_629, ProcessDeclaration$_get_prerequisites_$ref_h8hogm(), null);
    var tmp146_link = new MultipleChildLink(getKClass(ProcessDeclaration_1), this_183);
    var tmp_630 = new ChildrenMemberData(tmp146_link, 'prerequisites', getKClass(ProcessPrerequisite_0), true);
    var tmp_631 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_184 = getPropertyCallableRef('effects', 1, tmp_631, ProcessDeclaration$_get_effects_$ref_9vh0jp(), null);
    var tmp147_link = new MultipleChildLink(getKClass(ProcessDeclaration_1), this_184);
    var tmp_632 = new ChildrenMemberData(tmp147_link, 'effects', getKClass(ProcessEffect_0), true);
    var tmp_633 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_185 = getPropertyCallableRef('urls', 1, tmp_633, ProcessDeclaration$_get_urls_$ref_6bvrzj(), null);
    var tmp148_link = new MultipleChildLink(getKClass(ProcessDeclaration_1), this_185);
    var tmp_634 = new ChildrenMemberData(tmp148_link, 'urls', getKClass(Url_1), true);
    var tmp_635 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_186 = getPropertyCallableRef('inheritedProperties', 1, tmp_635, ProcessDeclaration$_get_inheritedProperties_$ref_y4og6(), null);
    var tmp149_link = new MultipleChildLink(getKClass(ProcessDeclaration_1), this_186);
    var tmp_636 = to(tmp_620, new ConceptData('ProcessDeclaration', 'jetbrains.biokb.lang.model.ProcessDeclaration', true, false, tmp_621, tmp_622, listOf_0([tmp_624, tmp_626, tmp_628, tmp_630, tmp_632, tmp_634, new ChildrenMemberData(tmp149_link, 'inheritedProperties', getKClass(InheritedProcessProperty), true)])));
    var tmp_637 = getKClass(ProcessEffect_0);
    var tmp_638 = listOf_0([getKClass(HasQueryLabels), getKClass(HasFactExpression)]);
    var tmp_639 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_187 = getPropertyCallableRef('entry', 1, tmp_639, ProcessEffect$_get_entry_$ref_q4qg2e(), null);
    var tmp$ret$187 = new ValueAttributeLink(getKClass(ProcessEffect_0), this_187, createKType(PrimitiveClasses_getInstance().lb(), arrayOf([]), false));
    var tmp_640 = to(tmp_637, new ConceptData('ProcessEffect', 'jetbrains.biokb.lang.model.ProcessEffect', true, false, VOID, tmp_638, listOf(new AttributeData(tmp$ret$187, 'entry', new SimpleAttributeType(false, PrimitiveClasses_getInstance().lb())))));
    var tmp_641 = to(getKClass(ProcessKind_1), new ConceptData('ProcessKind', 'jetbrains.biokb.lang.model.ProcessKind', true, false, VOID, listOf_0([getKClass(BTBNode), getKClass(DirectlyNamed)])));
    var tmp_642 = getKClass(ProcessKindContainer_1);
    var tmp_643 = getKClass(DocumentNode_0);
    var tmp_644 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_188 = getPropertyCallableRef('kinds', 1, tmp_644, ProcessKindContainer$_get_kinds_$ref_mesqat(), null);
    var tmp150_link = new MultipleChildLink(getKClass(ProcessKindContainer_1), this_188);
    var tmp_645 = to(tmp_642, new ConceptData('ProcessKindContainer', 'jetbrains.biokb.lang.model.ProcessKindContainer', true, false, tmp_643, VOID, listOf(new ChildrenMemberData(tmp150_link, 'kinds', getKClass(ProcessKind_1), true))));
    var tmp_646 = getKClass(ProcessLibrary_1);
    var tmp_647 = getKClass(DocumentNode_0);
    var tmp_648 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_189 = getPropertyCallableRef('processes', 1, tmp_648, ProcessLibrary$_get_processes_$ref_ex5w39(), null);
    var tmp151_link = new MultipleChildLink(getKClass(ProcessLibrary_1), this_189);
    var tmp_649 = to(tmp_646, new ConceptData('ProcessLibrary', 'jetbrains.biokb.lang.model.ProcessLibrary', true, false, tmp_647, VOID, listOf(new ChildrenMemberData(tmp151_link, 'processes', getKClass(ProcessDeclaration_1), true))));
    var tmp_650 = to(getKClass(ProcessPrerequisite_0), new ConceptData('ProcessPrerequisite', 'jetbrains.biokb.lang.model.ProcessPrerequisite', true, false, VOID, listOf_0([getKClass(HasQueryLabels), getKClass(HasFactExpression)])));
    var tmp_651 = getKClass(ProcessProperty_1);
    var tmp_652 = listOf_0([getKClass(BTBNode), getKClass(DirectlyNamed)]);
    var tmp_653 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_190 = getPropertyCallableRef('type', 1, tmp_653, ProcessProperty$_get_type_$ref_nw63hc(), null);
    var tmp152_link = new SingleChildLink(getKClass(ProcessProperty_1), this_190);
    var tmp_654 = new ChildrenMemberData(tmp152_link, 'type', getKClass(ProcessPropertyValueRange), false);
    var tmp_655 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_191 = getPropertyCallableRef('aliasedProperties', 1, tmp_655, ProcessProperty$_get_aliasedProperties_$ref_lzqazi(), null);
    var tmp153_link = new MultipleChildLink(getKClass(ProcessProperty_1), this_191);
    var tmp_656 = new ChildrenMemberData(tmp153_link, 'aliasedProperties', getKClass(ProcessPropertyReference), true);
    var tmp_657 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_192 = getPropertyCallableRef('default', 1, tmp_657, ProcessProperty$_get_default_$ref_tilfgf(), null);
    var tmp154_link = new SingleChildLink(getKClass(ProcessProperty_1), this_192);
    var tmp_658 = to(tmp_651, new ConceptData('ProcessProperty', 'jetbrains.biokb.lang.model.ProcessProperty', true, false, VOID, tmp_652, listOf_0([tmp_654, tmp_656, new ChildrenMemberData(tmp154_link, 'default', getKClass(ProcessPropertyDefault_1), false)])));
    var tmp_659 = getKClass(ProcessPropertyCustomCell_1);
    var tmp_660 = getKClass(CustomCell);
    var tmp_661 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var this_193 = getPropertyCallableRef('property', 1, tmp_661, ProcessPropertyCustomCell$_get_property_$ref_xoqnwu(), null);
    var tmp155_link = new ReferenceLink(getKClass(ProcessPropertyCustomCell_1), this_193, getKClass(ProcessProperty_1), getKClass(QualifiedReferenceContent));
    var tmp_662 = to(tmp_659, new ConceptData('ProcessPropertyCustomCell', 'jetbrains.biokb.lang.model.ProcessPropertyCustomCell', true, false, tmp_660, VOID, listOf(new ReferenceMemberData(tmp155_link, 'property', getKClass(ProcessProperty_1)))));
    var tmp_663 = getKClass(ProcessPropertyDefault_1);
    var tmp_664 = listOf(getKClass(BTBNode));
    var tmp_665 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_194 = getPropertyCallableRef('value', 1, tmp_665, ProcessPropertyDefault$_get_value_$ref_p903q0(), null);
    var tmp156_link = new SingleChildLink(getKClass(ProcessPropertyDefault_1), this_194);
    var tmp_666 = to(tmp_663, new ConceptData('ProcessPropertyDefault', 'jetbrains.biokb.lang.model.ProcessPropertyDefault', true, false, VOID, tmp_664, listOf(new ChildrenMemberData(tmp156_link, 'value', getKClass(AbstractValue), false))));
    var tmp_667 = getKClass(ProcessPropertyReference);
    var tmp_668 = getKClass(VariableInitializer);
    var tmp_669 = listOf_0([getKClass(FactExpression), getKClass(AbstractValue)]);
    var tmp_670 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var this_195 = getPropertyCallableRef('property', 1, tmp_670, ProcessPropertyReference$_get_property_$ref_cvezoe(), null);
    var tmp157_link = new ReferenceLink(getKClass(ProcessPropertyReference), this_195, getKClass(ProcessProperty_1), getKClass(QualifiedReferenceContent));
    var tmp_671 = to(tmp_667, new ConceptData('ProcessPropertyReference', 'jetbrains.biokb.lang.model.ProcessPropertyReference', true, false, tmp_668, tmp_669, listOf(new ReferenceMemberData(tmp157_link, 'property', getKClass(ProcessProperty_1)))));
    var tmp_672 = to(getKClass(ProcessPropertyType), new ConceptData('ProcessPropertyType', 'jetbrains.biokb.lang.model.ProcessPropertyType', false, false, VOID, listOf(getKClass(ProcessPropertyValueRange))));
    var tmp_673 = getKClass(ProcessPropertyValue_1);
    var tmp_674 = getKClass(BindingValuePlaceholder_1);
    var tmp_675 = listOf(getKClass(HasQueryLabels));
    var tmp_676 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var this_196 = getPropertyCallableRef('property', 1, tmp_676, ProcessPropertyValue$_get_property_$ref_uw44qs(), null);
    var tmp158_link = new ReferenceLink(getKClass(ProcessPropertyValue_1), this_196, getKClass(ProcessProperty_1), getKClass(QualifiedReferenceContent));
    var tmp_677 = new ReferenceMemberData(tmp158_link, 'property', getKClass(ProcessProperty_1));
    var tmp_678 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_197 = getPropertyCallableRef('value', 1, tmp_678, ProcessPropertyValue$_get_value_$ref_tp5tnc(), null);
    var tmp159_link = new SingleChildLink(getKClass(ProcessPropertyValue_1), this_197);
    var tmp_679 = to(tmp_673, new ConceptData('ProcessPropertyValue', 'jetbrains.biokb.lang.model.ProcessPropertyValue', true, false, tmp_674, tmp_675, listOf_0([tmp_677, new ChildrenMemberData(tmp159_link, 'value', getKClass(AbstractValue), false)])));
    var tmp_680 = to(getKClass(ProcessPropertyValueRange), new ConceptData('ProcessPropertyValueRange', 'jetbrains.biokb.lang.model.ProcessPropertyValueRange', false, false, VOID, listOf(getKClass(BTBNode))));
    var tmp_681 = to(getKClass(ProcessProvider), new ConceptData('ProcessProvider', 'jetbrains.biokb.lang.model.ProcessProvider', false, false, VOID, listOf(getKClass(BTBNode))));
    var tmp_682 = getKClass(ProcessReference_1);
    var tmp_683 = listOf(getKClass(BTBNode));
    var tmp_684 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var this_198 = getPropertyCallableRef('process', 1, tmp_684, ProcessReference$_get_process_$ref_dj3f61(), null);
    var tmp160_link = new ReferenceLink(getKClass(ProcessReference_1), this_198, getKClass(ProcessDeclaration_1), getKClass(QualifiedReferenceContent));
    var tmp_685 = to(tmp_682, new ConceptData('ProcessReference', 'jetbrains.biokb.lang.model.ProcessReference', true, false, VOID, tmp_683, listOf(new ReferenceMemberData(tmp160_link, 'process', getKClass(ProcessDeclaration_1)))));
    var tmp_686 = getKClass(ProcessRelationDeclaration_1);
    var tmp_687 = listOf_0([getKClass(BTBNode), getKClass(DirectlyNamed)]);
    var tmp_688 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_199 = getPropertyCallableRef('symbol', 1, tmp_688, ProcessRelationDeclaration$_get_symbol_$ref_emzgvd(), null);
    var tmp$ret$199 = new ValueAttributeLink(getKClass(ProcessRelationDeclaration_1), this_199, createKType(PrimitiveClasses_getInstance().tb(), arrayOf([]), false));
    var tmp_689 = new AttributeData(tmp$ret$199, 'symbol', new SimpleAttributeType(false, PrimitiveClasses_getInstance().tb()));
    var tmp_690 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_200 = getPropertyCallableRef('direction', 1, tmp_690, ProcessRelationDeclaration$_get_direction_$ref_nz8wp8(), null);
    var tmp$ret$200 = new ValueAttributeLink(getKClass(ProcessRelationDeclaration_1), this_200, createKType(getKClass(RelationDirection), arrayOf([]), true));
    var tmp_691 = new AttributeData(tmp$ret$200, 'direction', new EnumAttributeType(true, getKClass(RelationDirection), listOf_0([RelationDirection_UNIDIRECTIONAL_getInstance(), RelationDirection_BIDIRECTIONAL_getInstance()])));
    var tmp_692 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_201 = getPropertyCallableRef('effect', 1, tmp_692, ProcessRelationDeclaration$_get_effect_$ref_iad94u(), null);
    var tmp$ret$201 = new ValueAttributeLink(getKClass(ProcessRelationDeclaration_1), this_201, createKType(getKClass(RelationEffect), arrayOf([]), true));
    var tmp_693 = to(tmp_686, new ConceptData('ProcessRelationDeclaration', 'jetbrains.biokb.lang.model.ProcessRelationDeclaration', true, false, VOID, tmp_687, listOf_0([tmp_689, tmp_691, new AttributeData(tmp$ret$201, 'effect', new EnumAttributeType(true, getKClass(RelationEffect), listOf_0([RelationEffect_POSITIVE_getInstance(), RelationEffect_NEGATIVE_getInstance(), RelationEffect_UNKNOWN_getInstance(), RelationEffect_NO_EFFECT_getInstance()])))])));
    var tmp_694 = getKClass(ProcessType_1);
    var tmp_695 = getKClass(Type);
    var tmp_696 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_202 = getPropertyCallableRef('specification', 1, tmp_696, ProcessType$_get_specification_$ref_tigm72(), null);
    var tmp161_link = new SingleChildLink(getKClass(ProcessType_1), this_202);
    var tmp_697 = to(tmp_694, new ConceptData('ProcessType', 'jetbrains.biokb.lang.model.ProcessType', true, true, tmp_695, VOID, listOf(new ChildrenMemberData(tmp161_link, 'specification', getKClass(LibraryProcessSpecification_1), false))));
    var tmp_698 = to(getKClass(PropertiesCustomCell_1), new ConceptData('PropertiesCustomCell', 'jetbrains.biokb.lang.model.PropertiesCustomCell', true, false, getKClass(CustomCell)));
    var tmp_699 = getKClass(PropertyConstraint_1);
    var tmp_700 = listOf_0([getKClass(BTBNode), getKClass(HasPropertyConstraints)]);
    var tmp_701 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_203 = getPropertyCallableRef('operation', 1, tmp_701, PropertyConstraint$_get_operation_$ref_7z13uv(), null);
    var tmp$ret$203 = new ValueAttributeLink(getKClass(PropertyConstraint_1), this_203, createKType(getKClass(ConstraintOperation), arrayOf([]), true));
    var tmp_702 = new AttributeData(tmp$ret$203, 'operation', new EnumAttributeType(true, getKClass(ConstraintOperation), listOf_0([ConstraintOperation_ADDITION_ASSIGNMENT_getInstance(), ConstraintOperation_SUBTRACT_ASSIGNMENT_getInstance()])));
    var tmp_703 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var this_204 = getPropertyCallableRef('property', 1, tmp_703, PropertyConstraint$_get_property_$ref_tgowqf(), null);
    var tmp162_link = new ReferenceLink(getKClass(PropertyConstraint_1), this_204, getKClass(ObjectPropertyDeclaration_1), getKClass(QualifiedReferenceContent));
    var tmp_704 = new ReferenceMemberData(tmp162_link, 'property', getKClass(ObjectPropertyDeclaration_1));
    var tmp_705 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_205 = getPropertyCallableRef('value', 1, tmp_705, PropertyConstraint$_get_value_$ref_f1oxa5(), null);
    var tmp163_link = new SingleChildLink(getKClass(PropertyConstraint_1), this_205);
    var tmp_706 = to(tmp_699, new ConceptData('PropertyConstraint', 'jetbrains.biokb.lang.model.PropertyConstraint', true, false, VOID, tmp_700, listOf_0([tmp_702, tmp_704, new ChildrenMemberData(tmp163_link, 'value', getKClass(AbstractValue), false)])));
    var tmp_707 = getKClass(PropertyCustomCell_1);
    var tmp_708 = getKClass(CustomCell);
    var tmp_709 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var this_206 = getPropertyCallableRef('property', 1, tmp_709, PropertyCustomCell$_get_property_$ref_w2rusf(), null);
    var tmp164_link = new ReferenceLink(getKClass(PropertyCustomCell_1), this_206, getKClass(AbstractProperty), getKClass(QualifiedReferenceContent));
    var tmp_710 = to(tmp_707, new ConceptData('PropertyCustomCell', 'jetbrains.biokb.lang.model.PropertyCustomCell', true, false, tmp_708, VOID, listOf(new ReferenceMemberData(tmp164_link, 'property', getKClass(AbstractProperty)))));
    var tmp_711 = getKClass(PropertyDeclaration_1);
    var tmp_712 = listOf_0([getKClass(BTBNode), getKClass(DirectlyNamed), getKClass(PropertyLibraryElement)]);
    var tmp_713 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_207 = getPropertyCallableRef('type', 1, tmp_713, PropertyDeclaration$_get_type_$ref_g8rthd(), null);
    var tmp165_link = new SingleChildLink(getKClass(PropertyDeclaration_1), this_207);
    var tmp_714 = to(tmp_711, new ConceptData('PropertyDeclaration', 'jetbrains.biokb.lang.model.PropertyDeclaration', true, false, VOID, tmp_712, listOf(new ChildrenMemberData(tmp165_link, 'type', getKClass(NotionType_0), false))));
    var tmp_715 = getKClass(PropertyDeclarationValueQuery_1);
    var tmp_716 = getKClass(DeclarationValueQuery);
    var tmp_717 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var this_208 = getPropertyCallableRef('propertyDeclaration', 1, tmp_717, PropertyDeclarationValueQuery$_get_propertyDeclaration_$ref_e83vu5(), null);
    var tmp166_link = new ReferenceLink(getKClass(PropertyDeclarationValueQuery_1), this_208, getKClass(PropertyDeclaration_1), getKClass(QualifiedReferenceContent));
    var tmp_718 = to(tmp_715, new ConceptData('PropertyDeclarationValueQuery', 'jetbrains.biokb.lang.model.PropertyDeclarationValueQuery', true, false, tmp_716, VOID, listOf(new ReferenceMemberData(tmp166_link, 'propertyDeclaration', getKClass(PropertyDeclaration_1)))));
    var tmp_719 = getKClass(PropertyLibrary_1);
    var tmp_720 = getKClass(DocumentNode_0);
    var tmp_721 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_209 = getPropertyCallableRef('elements', 1, tmp_721, PropertyLibrary$_get_elements_$ref_sclji9(), null);
    var tmp167_link = new MultipleChildLink(getKClass(PropertyLibrary_1), this_209);
    var tmp_722 = to(tmp_719, new ConceptData('PropertyLibrary', 'jetbrains.biokb.lang.model.PropertyLibrary', true, false, tmp_720, VOID, listOf(new ChildrenMemberData(tmp167_link, 'elements', getKClass(PropertyLibraryElement), true))));
    var tmp_723 = to(getKClass(PropertyLibraryElement), new ConceptData('PropertyLibraryElement', 'jetbrains.biokb.lang.model.PropertyLibraryElement', false, false, VOID, listOf(getKClass(BTBNode))));
    var tmp_724 = getKClass(PropertyReferenceOperation_1);
    var tmp_725 = listOf(getKClass(BTBNode));
    var tmp_726 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var this_210 = getPropertyCallableRef('property', 1, tmp_726, PropertyReferenceOperation$_get_property_$ref_vdhpuw(), null);
    var tmp168_link = new ReferenceLink(getKClass(PropertyReferenceOperation_1), this_210, getKClass(ObjectPropertyDeclaration_1), getKClass(QualifiedReferenceContent));
    var tmp_727 = new ReferenceMemberData(tmp168_link, 'property', getKClass(ObjectPropertyDeclaration_1));
    var tmp_728 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_211 = getPropertyCallableRef('parameter', 1, tmp_728, PropertyReferenceOperation$_get_parameter_$ref_b85xok(), null);
    var tmp169_link = new SingleChildLink(getKClass(PropertyReferenceOperation_1), this_211);
    var tmp_729 = to(tmp_724, new ConceptData('PropertyReferenceOperation', 'jetbrains.biokb.lang.model.PropertyReferenceOperation', true, false, VOID, tmp_725, listOf_0([tmp_727, new ChildrenMemberData(tmp169_link, 'parameter', getKClass(SetValuedPropertyParameter_1), false)])));
    var tmp_730 = getKClass(PropertyValue_1);
    var tmp_731 = getKClass(AbstractBindingValue);
    var tmp_732 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var this_212 = getPropertyCallableRef('property', 1, tmp_732, PropertyValue$_get_property_$ref_q9j7al(), null);
    var tmp170_link = new ReferenceLink(getKClass(PropertyValue_1), this_212, getKClass(AbstractProperty), getKClass(QualifiedReferenceContent));
    var tmp_733 = to(tmp_730, new ConceptData('PropertyValue', 'jetbrains.biokb.lang.model.PropertyValue', true, false, tmp_731, VOID, listOf(new ReferenceMemberData(tmp170_link, 'property', getKClass(AbstractProperty)))));
    var tmp_734 = to(getKClass(PropertyValueRange), new ConceptData('PropertyValueRange', 'jetbrains.biokb.lang.model.PropertyValueRange', false, false, VOID, listOf(getKClass(BTBNode))));
    var tmp_735 = getKClass(PubMedSourceReference_1);
    var tmp_736 = getKClass(KnowledgeSourceReference);
    var tmp_737 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_213 = getPropertyCallableRef('pubMedId', 1, tmp_737, PubMedSourceReference$_get_pubMedId_$ref_1o1oab(), null);
    var tmp$ret$213 = new ValueAttributeLink(getKClass(PubMedSourceReference_1), this_213, createKType(PrimitiveClasses_getInstance().tb(), arrayOf([]), false));
    var tmp_738 = to(tmp_735, new ConceptData('PubMedSourceReference', 'jetbrains.biokb.lang.model.PubMedSourceReference', true, false, tmp_736, VOID, listOf(new AttributeData(tmp$ret$213, 'pubMedId', new SimpleAttributeType(false, PrimitiveClasses_getInstance().tb())))));
    var tmp_739 = getKClass(PublishedSourceReference_1);
    var tmp_740 = getKClass(KnowledgeSourceReference);
    var tmp_741 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var this_214 = getPropertyCallableRef('source', 1, tmp_741, PublishedSourceReference$_get_source_$ref_v1fin3(), null);
    var tmp171_link = new ReferenceLink(getKClass(PublishedSourceReference_1), this_214, getKClass(PublishedWork), getKClass(QualifiedReferenceContent));
    var tmp_742 = new ReferenceMemberData(tmp171_link, 'source', getKClass(PublishedWork));
    var tmp_743 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_215 = getPropertyCallableRef('pageSpecification', 1, tmp_743, PublishedSourceReference$_get_pageSpecification_$ref_qx42i2(), null);
    var tmp172_link = new SingleChildLink(getKClass(PublishedSourceReference_1), this_215);
    var tmp_744 = to(tmp_739, new ConceptData('PublishedSourceReference', 'jetbrains.biokb.lang.model.PublishedSourceReference', true, false, tmp_740, VOID, listOf_0([tmp_742, new ChildrenMemberData(tmp172_link, 'pageSpecification', getKClass(PageSpecification), false)])));
    var tmp_745 = getKClass(PublishedSourcesLibrary_1);
    var tmp_746 = getKClass(DocumentNode_0);
    var tmp_747 = listOf(getKClass(BTBNode));
    var tmp_748 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_216 = getPropertyCallableRef('items', 1, tmp_748, PublishedSourcesLibrary$_get_items_$ref_b4kv1p(), null);
    var tmp173_link = new MultipleChildLink(getKClass(PublishedSourcesLibrary_1), this_216);
    var tmp_749 = to(tmp_745, new ConceptData('PublishedSourcesLibrary', 'jetbrains.biokb.lang.model.PublishedSourcesLibrary', true, false, tmp_746, tmp_747, listOf(new ChildrenMemberData(tmp173_link, 'items', getKClass(LibraryItem), true))));
    var tmp_750 = getKClass(PublishedWork);
    var tmp_751 = getKClass(AuthoredWork);
    var tmp_752 = listOf(getKClass(DirectlyNamed));
    var tmp_753 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_217 = getPropertyCallableRef('publisher', 1, tmp_753, PublishedWork$_get_publisher_$ref_wshpep(), null);
    var tmp$ret$217 = new ValueAttributeLink(getKClass(PublishedWork), this_217, createKType(PrimitiveClasses_getInstance().tb(), arrayOf([]), false));
    var tmp_754 = new AttributeData(tmp$ret$217, 'publisher', new SimpleAttributeType(false, PrimitiveClasses_getInstance().tb()));
    var tmp_755 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_218 = getPropertyCallableRef('date', 1, tmp_755, PublishedWork$_get_date_$ref_2srppr(), null);
    var tmp$ret$218 = new ValueAttributeLink(getKClass(PublishedWork), this_218, createKType(PrimitiveClasses_getInstance().tb(), arrayOf([]), false));
    var tmp_756 = to(tmp_750, new ConceptData('PublishedWork', 'jetbrains.biokb.lang.model.PublishedWork', true, false, tmp_751, tmp_752, listOf_0([tmp_754, new AttributeData(tmp$ret$218, 'date', new SimpleAttributeType(false, PrimitiveClasses_getInstance().tb()))])));
    var tmp_757 = getKClass(QualifiedOntologyElementReference_1);
    var tmp_758 = listOf(getKClass(OntologyElementReferenceProvider));
    var tmp_759 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_219 = getPropertyCallableRef('libraryReference', 1, tmp_759, QualifiedOntologyElementReference$_get_libraryReference_$ref_eai4yc(), null);
    var tmp174_link = new SingleChildLink(getKClass(QualifiedOntologyElementReference_1), this_219);
    var tmp_760 = new ChildrenMemberData(tmp174_link, 'libraryReference', getKClass(OntologyLibraryReference_1), false);
    var tmp_761 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_220 = getPropertyCallableRef('elementReference', 1, tmp_761, QualifiedOntologyElementReference$_get_elementReference_$ref_8q8mxh(), null);
    var tmp175_link = new SingleChildLink(getKClass(QualifiedOntologyElementReference_1), this_220);
    var tmp_762 = to(tmp_757, new ConceptData('QualifiedOntologyElementReference', 'jetbrains.biokb.lang.model.QualifiedOntologyElementReference', true, false, VOID, tmp_758, listOf_0([tmp_760, new ChildrenMemberData(tmp175_link, 'elementReference', getKClass(OntologyElementReference_1), false)])));
    var tmp_763 = getKClass(QueryCommands_1);
    var tmp_764 = getKClass(DocumentNode_0);
    var tmp_765 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_221 = getPropertyCallableRef('commands', 1, tmp_765, QueryCommands$_get_commands_$ref_yrumbe(), null);
    var tmp176_link = new MultipleChildLink(getKClass(QueryCommands_1), this_221);
    var tmp_766 = to(tmp_763, new ConceptData('QueryCommands', 'jetbrains.biokb.lang.model.QueryCommands', true, false, tmp_764, VOID, listOf(new ChildrenMemberData(tmp176_link, 'commands', getKClass(Command_0), true))));
    var tmp_767 = to(getKClass(QueryLabelsFactExpressionContainer_0), new ConceptData('QueryLabelsFactExpressionContainer', 'jetbrains.biokb.lang.model.QueryLabelsFactExpressionContainer', true, false, VOID, listOf_0([getKClass(HasQueryLabels), getKClass(HasFactExpression)])));
    var tmp_768 = getKClass(QueryParametersBlackList);
    var tmp_769 = getKClass(DocumentNode_0);
    var tmp_770 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var this_222 = getPropertyCallableRef('library', 1, tmp_770, QueryParametersBlackList$_get_library_$ref_orkkq4(), null);
    var tmp177_link = new ReferenceLink(getKClass(QueryParametersBlackList), this_222, getKClass(OntologyLibrary_1), getKClass(QualifiedReferenceContent));
    var tmp_771 = new ReferenceMemberData(tmp177_link, 'library', getKClass(OntologyLibrary_1));
    var tmp_772 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_223 = getPropertyCallableRef('elements', 1, tmp_772, QueryParametersBlackList$_get_elements_$ref_q86wjg(), null);
    var tmp178_link = new MultipleChildLink(getKClass(QueryParametersBlackList), this_223);
    var tmp_773 = to(tmp_768, new ConceptData('QueryParametersBlackList', 'jetbrains.biokb.lang.model.QueryParametersBlackList', true, false, tmp_769, VOID, listOf_0([tmp_771, new ChildrenMemberData(tmp178_link, 'elements', getKClass(OntologyElementReference_1), true)])));
    var tmp_774 = getKClass(RelationContainer_1);
    var tmp_775 = getKClass(DocumentNode_0);
    var tmp_776 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_224 = getPropertyCallableRef('processRelations', 1, tmp_776, RelationContainer$_get_processRelations_$ref_503twx(), null);
    var tmp179_link = new MultipleChildLink(getKClass(RelationContainer_1), this_224);
    var tmp_777 = new ChildrenMemberData(tmp179_link, 'processRelations', getKClass(ProcessRelationDeclaration_1), true);
    var tmp_778 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_225 = getPropertyCallableRef('instanceRelations', 1, tmp_778, RelationContainer$_get_instanceRelations_$ref_i7dwvz(), null);
    var tmp180_link = new MultipleChildLink(getKClass(RelationContainer_1), this_225);
    var tmp_779 = to(tmp_774, new ConceptData('RelationContainer', 'jetbrains.biokb.lang.model.RelationContainer', true, false, tmp_775, VOID, listOf_0([tmp_777, new ChildrenMemberData(tmp180_link, 'instanceRelations', getKClass(InstanceRelationDeclaration), true)])));
    var tmp_780 = getKClass(RelationFactExpression_1);
    var tmp_781 = listOf(getKClass(FactExpression));
    var tmp_782 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_226 = getPropertyCallableRef('left', 1, tmp_782, RelationFactExpression$_get_left_$ref_54k8bt(), null);
    var tmp181_link = new SingleChildLink(getKClass(RelationFactExpression_1), this_226);
    var tmp_783 = new ChildrenMemberData(tmp181_link, 'left', getKClass(QueryLabelsFactExpressionContainer_0), false);
    var tmp_784 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_227 = getPropertyCallableRef('right', 1, tmp_784, RelationFactExpression$_get_right_$ref_6t11ls(), null);
    var tmp182_link = new SingleChildLink(getKClass(RelationFactExpression_1), this_227);
    var tmp_785 = new ChildrenMemberData(tmp182_link, 'right', getKClass(QueryLabelsFactExpressionContainer_0), false);
    var tmp_786 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var this_228 = getPropertyCallableRef('relation', 1, tmp_786, RelationFactExpression$_get_relation_$ref_nkh94u(), null);
    var tmp183_link = new ReferenceLink(getKClass(RelationFactExpression_1), this_228, getKClass(ProcessRelationDeclaration_1), getKClass(QualifiedReferenceContent));
    var tmp_787 = to(tmp_780, new ConceptData('RelationFactExpression', 'jetbrains.biokb.lang.model.RelationFactExpression', true, false, VOID, tmp_781, listOf_0([tmp_783, tmp_785, new ReferenceMemberData(tmp183_link, 'relation', getKClass(ProcessRelationDeclaration_1))])));
    var tmp_788 = to(getKClass(ReturnTypeCustomCell_1), new ConceptData('ReturnTypeCustomCell', 'jetbrains.biokb.lang.model.ReturnTypeCustomCell', true, false, getKClass(CustomCell)));
    var tmp_789 = getKClass(SetExpression_1);
    var tmp_790 = listOf_0([getKClass(AbstractValue), getKClass(FactExpression)]);
    var tmp_791 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_229 = getPropertyCallableRef('expressions', 1, tmp_791, SetExpression$_get_expressions_$ref_ildcnv(), null);
    var tmp184_link = new MultipleChildLink(getKClass(SetExpression_1), this_229);
    var tmp_792 = new ChildrenMemberData(tmp184_link, 'expressions', getKClass(FactExpressionPlaceholder), true);
    var tmp_793 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_230 = getPropertyCallableRef('isOpen', 1, tmp_793, SetExpression$_get_isOpen_$ref_wh1gog(), null);
    var tmp$ret$230 = new ValueAttributeLink(getKClass(SetExpression_1), this_230, createKType(PrimitiveClasses_getInstance().lb(), arrayOf([]), false));
    var tmp_794 = to(tmp_789, new ConceptData('SetExpression', 'jetbrains.biokb.lang.model.SetExpression', true, false, VOID, tmp_790, listOf_0([tmp_792, new AttributeData(tmp$ret$230, 'isOpen', new SimpleAttributeType(false, PrimitiveClasses_getInstance().lb()))])));
    var tmp_795 = getKClass(SetValuedPropertyParameter_1);
    var tmp_796 = listOf(getKClass(BTBNode));
    var tmp_797 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_231 = getPropertyCallableRef('value', 1, tmp_797, SetValuedPropertyParameter$_get_value_$ref_w1ervu(), null);
    var tmp185_link = new SingleChildLink(getKClass(SetValuedPropertyParameter_1), this_231);
    var tmp_798 = to(tmp_795, new ConceptData('SetValuedPropertyParameter', 'jetbrains.biokb.lang.model.SetValuedPropertyParameter', true, false, VOID, tmp_796, listOf(new ChildrenMemberData(tmp185_link, 'value', getKClass(AbstractValue), false))));
    var tmp_799 = getKClass(SimplePropertyType);
    var tmp_800 = listOf(getKClass(ProcessPropertyType));
    var tmp_801 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var this_232 = getPropertyCallableRef('notion', 1, tmp_801, SimplePropertyType$_get_notion_$ref_xv0vzc(), null);
    var tmp186_link = new ReferenceLink(getKClass(SimplePropertyType), this_232, getKClass(AbstractNotion), getKClass(QualifiedReferenceContent));
    var tmp_802 = to(tmp_799, new ConceptData('SimplePropertyType', 'jetbrains.biokb.lang.model.SimplePropertyType', true, false, VOID, tmp_800, listOf(new ReferenceMemberData(tmp186_link, 'notion', getKClass(AbstractNotion)))));
    var tmp_803 = getKClass(SinglePropertyValueRange_1);
    var tmp_804 = getKClass(PropertyValueRange);
    var tmp_805 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_233 = getPropertyCallableRef('types', 1, tmp_805, SinglePropertyValueRange$_get_types_$ref_qpyu2c(), null);
    var tmp187_link = new MultipleChildLink(getKClass(SinglePropertyValueRange_1), this_233);
    var tmp_806 = to(tmp_803, new ConceptData('SinglePropertyValueRange', 'jetbrains.biokb.lang.model.SinglePropertyValueRange', true, true, tmp_804, VOID, listOf(new ChildrenMemberData(tmp187_link, 'types', getKClass(Type), true))));
    var tmp_807 = getKClass(StringValue_1);
    var tmp_808 = listOf_0([getKClass(AbstractValue), getKClass(FactExpression), getKClass(AllowedComplexNotionValue)]);
    var tmp_809 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_234 = getPropertyCallableRef('value', 1, tmp_809, StringValue$_get_value_$ref_2kxcol(), null);
    var tmp$ret$234 = new ValueAttributeLink(getKClass(StringValue_1), this_234, createKType(PrimitiveClasses_getInstance().tb(), arrayOf([]), false));
    var tmp_810 = to(tmp_807, new ConceptData('StringValue', 'jetbrains.biokb.lang.model.StringValue', true, false, VOID, tmp_808, listOf(new AttributeData(tmp$ret$234, 'value', new SimpleAttributeType(false, PrimitiveClasses_getInstance().tb())))));
    var tmp_811 = getKClass(TextLine);
    var tmp_812 = listOf(getKClass(BTBNode));
    var tmp_813 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_235 = getPropertyCallableRef('text', 1, tmp_813, TextLine$_get_text_$ref_oszt1s(), null);
    var tmp$ret$235 = new TextAttributeLink(getKClass(TextLine), this_235);
    var tmp_814 = to(tmp_811, new ConceptData('TextLine', 'jetbrains.biokb.lang.model.TextLine', true, false, VOID, tmp_812, listOf(new AttributeData(tmp$ret$235, 'text', new SimpleAttributeType(false, PrimitiveClasses_getInstance().tb())))));
    var tmp_815 = to(getKClass(Type), new ConceptData('Type', 'jetbrains.biokb.lang.model.Type', false, false, getKClass(VariableSpecification)));
    var tmp_816 = to(getKClass(TypePlaceholder_1), new ConceptData('TypePlaceholder', 'jetbrains.biokb.lang.model.TypePlaceholder', true, false, getKClass(Type)));
    var tmp_817 = getKClass(UnionClass_1);
    var tmp_818 = listOf(getKClass(AnonymousClass));
    var tmp_819 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_236 = getPropertyCallableRef('classes', 1, tmp_819, UnionClass$_get_classes_$ref_qbevup(), null);
    var tmp188_link = new MultipleChildLink(getKClass(UnionClass_1), this_236);
    var tmp_820 = to(tmp_817, new ConceptData('UnionClass', 'jetbrains.biokb.lang.model.UnionClass', true, false, VOID, tmp_818, listOf(new ChildrenMemberData(tmp188_link, 'classes', getKClass(ClassExpressionPlaceholder_1), true))));
    var tmp_821 = to(getKClass(UnknownComplexNotionValue_1), new ConceptData('UnknownComplexNotionValue', 'jetbrains.biokb.lang.model.UnknownComplexNotionValue', true, false, VOID, listOf(getKClass(AllowedComplexNotionValue))));
    var tmp_822 = getKClass(Url_1);
    var tmp_823 = listOf(getKClass(BTBNode));
    var tmp_824 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_237 = getPropertyCallableRef('value', 1, tmp_824, Url$_get_value_$ref_ipaaxy(), null);
    var tmp$ret$237 = new ValueAttributeLink(getKClass(Url_1), this_237, createKType(PrimitiveClasses_getInstance().tb(), arrayOf([]), false));
    var tmp_825 = to(tmp_822, new ConceptData('Url', 'jetbrains.biokb.lang.model.Url', true, false, VOID, tmp_823, listOf(new AttributeData(tmp$ret$237, 'value', new SimpleAttributeType(false, PrimitiveClasses_getInstance().tb())))));
    var tmp_826 = getKClass(UrlKnowledgeSourceReference_1);
    var tmp_827 = getKClass(KnowledgeSourceReference);
    var tmp_828 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_238 = getPropertyCallableRef('url', 1, tmp_828, UrlKnowledgeSourceReference$_get_url_$ref_7q1e5u(), null);
    var tmp$ret$238 = new ValueAttributeLink(getKClass(UrlKnowledgeSourceReference_1), this_238, createKType(PrimitiveClasses_getInstance().tb(), arrayOf([]), false));
    var tmp_829 = to(tmp_826, new ConceptData('UrlKnowledgeSourceReference', 'jetbrains.biokb.lang.model.UrlKnowledgeSourceReference', true, false, tmp_827, VOID, listOf(new AttributeData(tmp$ret$238, 'url', new SimpleAttributeType(false, PrimitiveClasses_getInstance().tb())))));
    var tmp_830 = getKClass(ValueWithRelations);
    var tmp_831 = listOf(getKClass(AbstractValue));
    var tmp_832 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_239 = getPropertyCallableRef('value', 1, tmp_832, ValueWithRelations$_get_value_$ref_wsflth(), null);
    var tmp189_link = new SingleChildLink(getKClass(ValueWithRelations), this_239);
    var tmp_833 = new ChildrenMemberData(tmp189_link, 'value', getKClass(AbstractValue), false);
    var tmp_834 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_240 = getPropertyCallableRef('relations', 1, tmp_834, ValueWithRelations$_get_relations_$ref_f0av7f(), null);
    var tmp190_link = new MultipleChildLink(getKClass(ValueWithRelations), this_240);
    var tmp_835 = to(tmp_830, new ConceptData('ValueWithRelations', 'jetbrains.biokb.lang.model.ValueWithRelations', true, false, VOID, tmp_831, listOf_0([tmp_833, new ChildrenMemberData(tmp190_link, 'relations', getKClass(InstanceRelationValuePlaceholder), true)])));
    var tmp_836 = getKClass(VariableDeclaration_1);
    var tmp_837 = listOf_0([getKClass(BTBNode), getKClass(DirectlyNamed), getKClass(HasQueryLabels), getKClass(HasPropertyConstraints)]);
    var tmp_838 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_241 = getPropertyCallableRef('spec', 1, tmp_838, VariableDeclaration$_get_spec_$ref_h7083f(), null);
    var tmp191_link = new SingleChildLink(getKClass(VariableDeclaration_1), this_241);
    var tmp_839 = new ChildrenMemberData(tmp191_link, 'spec', getKClass(VariableSpecification), false);
    var tmp_840 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_242 = getPropertyCallableRef('relations', 1, tmp_840, VariableDeclaration$_get_relations_$ref_zic3pf(), null);
    var tmp192_link = new MultipleChildLink(getKClass(VariableDeclaration_1), this_242);
    var tmp_841 = to(tmp_836, new ConceptData('VariableDeclaration', 'jetbrains.biokb.lang.model.VariableDeclaration', true, false, VOID, tmp_837, listOf_0([tmp_839, new ChildrenMemberData(tmp192_link, 'relations', getKClass(InstanceRelationValuePlaceholder), true)])));
    var tmp_842 = to(getKClass(VariableInitializer), new ConceptData('VariableInitializer', 'jetbrains.biokb.lang.model.VariableInitializer', true, false, getKClass(VariableSpecification)));
    var tmp_843 = getKClass(VariablePattern_1);
    var tmp_844 = getKClass(Pattern);
    var tmp_845 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var this_243 = getPropertyCallableRef('variable', 1, tmp_845, VariablePattern$_get_variable_$ref_umy4xe(), null);
    var tmp193_link = new ReferenceLink(getKClass(VariablePattern_1), this_243, getKClass(VariableDeclaration_1), getKClass(LocalReferenceContent));
    var tmp_846 = to(tmp_843, new ConceptData('VariablePattern', 'jetbrains.biokb.lang.model.VariablePattern', true, false, tmp_844, VOID, listOf(new ReferenceMemberData(tmp193_link, 'variable', getKClass(VariableDeclaration_1)))));
    var tmp_847 = getKClass(VariableReferenceValue_1);
    var tmp_848 = getKClass(VariableInitializer);
    var tmp_849 = listOf_0([getKClass(AbstractValue), getKClass(FactExpression)]);
    var tmp_850 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var this_244 = getPropertyCallableRef('variable', 1, tmp_850, VariableReferenceValue$_get_variable_$ref_zhtoxs(), null);
    var tmp194_link = new ReferenceLink(getKClass(VariableReferenceValue_1), this_244, getKClass(VariableDeclaration_1), getKClass(LocalReferenceContent));
    var tmp_851 = to(tmp_847, new ConceptData('VariableReferenceValue', 'jetbrains.biokb.lang.model.VariableReferenceValue', true, false, tmp_848, tmp_849, listOf(new ReferenceMemberData(tmp194_link, 'variable', getKClass(VariableDeclaration_1)))));
    var tmp_852 = to(getKClass(VariableSpecification), new ConceptData('VariableSpecification', 'jetbrains.biokb.lang.model.VariableSpecification', false, false, VOID, listOf(getKClass(BTBNode))));
    var tmp_853 = getKClass(XRefContainer);
    var tmp_854 = listOf(getKClass(BTBNode));
    var tmp_855 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_245 = getPropertyCallableRef('xRef', 1, tmp_855, XRefContainer$_get_xRef_$ref_p0397h(), null);
    var tmp$ret$245 = new ValueAttributeLink(getKClass(XRefContainer), this_245, createKType(PrimitiveClasses_getInstance().tb(), arrayOf([]), false));
    var tmp_856 = to(tmp_853, new ConceptData('XRefContainer', 'jetbrains.biokb.lang.model.XRefContainer', true, false, VOID, tmp_854, listOf(new AttributeData(tmp$ret$245, 'xRef', new SimpleAttributeType(false, PrimitiveClasses_getInstance().tb())))));
    var tmp_857 = getKClass(LinkStub);
    var tmp_858 = getKClass(AbstractLink);
    var tmp_859 = listOf(getKClass(ExternallyNamed));
    var tmp_860 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_246 = getPropertyCallableRef('name', 1, tmp_860, LinkStub$_get_name_$ref_o9qxf9(), null);
    var tmp$ret$246 = new ValueAttributeLink(getKClass(LinkStub), this_246, createKType(PrimitiveClasses_getInstance().tb(), arrayOf([]), false));
    var tmp_861 = to(tmp_857, new ConceptData('LinkStub', 'jetbrains.biokb.lang.model.stub.LinkStub', true, false, tmp_858, tmp_859, listOf(new AttributeData(tmp$ret$246, 'name', new SimpleAttributeType(false, PrimitiveClasses_getInstance().tb())))));
    var tmp_862 = to(getKClass(NotionStub), new ConceptData('NotionStub', 'jetbrains.biokb.lang.model.stub.NotionStub', true, false, getKClass(AbstractNotion), listOf(getKClass(DirectlyNamed))));
    var tmp_863 = getKClass(PropertyStub);
    var tmp_864 = getKClass(AbstractProperty);
    var tmp_865 = listOf(getKClass(ExternallyNamed));
    var tmp_866 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_247 = getPropertyCallableRef('type', 1, tmp_866, PropertyStub$_get_type_$ref_iyorzz(), null);
    var tmp195_link = new ValueAttributeLink(getKClass(PropertyStub), this_247, createKType(getKClass(NotionType_0), arrayOf([]), true));
    var tmp_867 = new ChildrenMemberData(tmp195_link, 'type', getKClass(NotionType_0), false);
    var tmp_868 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_248 = getPropertyCallableRef('name', 1, tmp_868, PropertyStub$_get_name_$ref_75aflc(), null);
    var tmp$ret$248 = new ValueAttributeLink(getKClass(PropertyStub), this_248, createKType(PrimitiveClasses_getInstance().tb(), arrayOf([]), false));
    var tmp_869 = to(tmp_863, new ConceptData('PropertyStub', 'jetbrains.biokb.lang.model.stub.PropertyStub', true, false, tmp_864, tmp_865, listOf_0([tmp_867, new AttributeData(tmp$ret$248, 'name', new SimpleAttributeType(false, PrimitiveClasses_getInstance().tb()))])));
    var tmp_870 = getKClass(DirectlyNamed);
    var tmp_871 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_249 = getPropertyCallableRef('name', 1, tmp_871, DirectlyNamed$_get_name_$ref_qbhw34(), null);
    var tmp$ret$249 = new ValueAttributeLink(getKClass(DirectlyNamed), this_249, createKType(PrimitiveClasses_getInstance().tb(), arrayOf([]), false));
    var tmp_872 = to(tmp_870, new ConceptData('DirectlyNamed', 'jetbrains.ocelot.langDef.structure.DirectlyNamed', false, false, VOID, VOID, listOf(new AttributeData(tmp$ret$249, 'name', new SimpleAttributeType(false, PrimitiveClasses_getInstance().tb())))));
    var tmp_873 = getKClass(DocumentNode);
    var tmp_874 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_250 = getPropertyCallableRef('documentId', 1, tmp_874, DocumentNode$_get_documentId_$ref_eou2dn(), null);
    var tmp$ret$250 = new ValueAttributeLink(getKClass(DocumentNode), this_250, createKType(PrimitiveClasses_getInstance().tb(), arrayOf([]), false));
    tmp.rfu_1 = mapOf_0([tmp_11, tmp_12, tmp_16, tmp_17, tmp_21, tmp_22, tmp_23, tmp_24, tmp_25, tmp_26, tmp_27, tmp_28, tmp_29, tmp_30, tmp_36, tmp_44, tmp_45, tmp_49, tmp_53, tmp_54, tmp_55, tmp_60, tmp_68, tmp_69, tmp_74, tmp_75, tmp_79, tmp_80, tmp_86, tmp_87, tmp_88, tmp_89, tmp_94, tmp_95, tmp_101, tmp_107, tmp_113, tmp_117, tmp_118, tmp_119, tmp_123, tmp_127, tmp_133, tmp_137, tmp_141, tmp_147, tmp_153, tmp_154, tmp_158, tmp_159, tmp_163, tmp_164, tmp_165, tmp_166, tmp_170, tmp_174, tmp_175, tmp_181, tmp_185, tmp_189, tmp_190, tmp_196, tmp_197, tmp_198, tmp_204, tmp_208, tmp_220, tmp_226, tmp_234, tmp_243, tmp_249, tmp_253, tmp_261, tmp_264, tmp_268, tmp_272, tmp_276, tmp_282, tmp_286, tmp_290, tmp_294, tmp_302, tmp_308, tmp_314, tmp_315, tmp_319, tmp_325, tmp_326, tmp_327, tmp_328, tmp_329, tmp_330, tmp_337, tmp_345, tmp_349, tmp_355, tmp_359, tmp_363, tmp_367, tmp_373, tmp_377, tmp_381, tmp_382, tmp_388, tmp_392, tmp_396, tmp_400, tmp_406, tmp_410, tmp_414, tmp_415, tmp_419, tmp_420, tmp_425, tmp_429, tmp_443, tmp_449, tmp_456, tmp_460, tmp_466, tmp_488, tmp_492, tmp_500, tmp_504, tmp_505, tmp_509, tmp_513, tmp_517, tmp_523, tmp_531, tmp_535, tmp_539, tmp_543, tmp_547, tmp_551, tmp_557, tmp_561, tmp_565, tmp_571, tmp_575, tmp_581, tmp_582, tmp_601, tmp_602, tmp_608, tmp_609, tmp_610, tmp_615, tmp_619, tmp_636, tmp_640, tmp_641, tmp_645, tmp_649, tmp_650, tmp_658, tmp_662, tmp_666, tmp_671, tmp_672, tmp_679, tmp_680, tmp_681, tmp_685, tmp_693, tmp_697, tmp_698, tmp_706, tmp_710, tmp_714, tmp_718, tmp_722, tmp_723, tmp_729, tmp_733, tmp_734, tmp_738, tmp_744, tmp_749, tmp_756, tmp_762, tmp_766, tmp_767, tmp_773, tmp_779, tmp_787, tmp_788, tmp_794, tmp_798, tmp_802, tmp_806, tmp_810, tmp_814, tmp_815, tmp_816, tmp_820, tmp_821, tmp_825, tmp_829, tmp_835, tmp_841, tmp_842, tmp_846, tmp_851, tmp_852, tmp_856, tmp_861, tmp_862, tmp_869, tmp_872, to(tmp_873, new ConceptData('DocumentNode', 'jetbrains.ocelot.langDef.structure.DocumentNode', false, false, VOID, VOID, listOf(new AttributeData(tmp$ret$250, 'documentId', new SimpleAttributeType(false, PrimitiveClasses_getInstance().tb())))))]);
  }
  protoOf(BtbMetaModel).d6x = function () {
    return this.rfu_1;
  };
  var BtbMetaModel_instance;
  function BtbMetaModel_getInstance() {
    if (BtbMetaModel_instance == null)
      new BtbMetaModel();
    return BtbMetaModel_instance;
  }
  function GeneratedBioKbStuff() {
  }
  protoOf(GeneratedBioKbStuff).sfu = function () {
    return new BioKbOtStructureRuntime();
  };
  var GeneratedBioKbStuff_instance;
  function GeneratedBioKbStuff_getInstance() {
    return GeneratedBioKbStuff_instance;
  }
  function AbstractBindingDeclaration$_get_ontologyElements_$ref_egks01_0() {
    return function (p0) {
      return p0.qfp();
    };
  }
  function AbstractBindingDeclaration$_get_entries_$ref_fnlsrh_0() {
    return function (p0) {
      return p0.y();
    };
  }
  function AbstractBindingDeclaration$_get_properties_$ref_4foxw4_0() {
    return function (p0) {
      return p0.rfp();
    };
  }
  function AbstractBindingDeclaration$_get_customEditor_$ref_6c7l07_0() {
    return function (p0) {
      return p0.sfp();
    };
  }
  function AbstractBindingDeclaration$_get_customEditorEnabled_$ref_h4m7ao_0() {
    return function (p0) {
      return p0.tfp();
    };
  }
  function AbstractBindingDeclarationConcept() {
    AbstractBindingDeclarationConcept_instance = this;
    OTAbstractConceptDescriptor.call(this, Companion_instance_94.k6m([BTBNodeConcept_getInstance(), DirectlyNamedConcept_getInstance(), HasCommentsConcept_getInstance()]));
    var tmp = this;
    var tmp_0 = KProperty1;
    var tmp4 = getPropertyCallableRef('ontologyElements', 1, tmp_0, AbstractBindingDeclaration$_get_ontologyElements_$ref_egks01_0(), null);
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childrenRole' call
    var name = 'ontologyElements';
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$0 = new MultipleChildLink(getKClass(AbstractBindingDeclaration), tmp4);
    tmp.zfu_1 = this.p6m(tmp$ret$0, name);
    var tmp_1 = this;
    var tmp_2 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childrenRole' call
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_0 = getPropertyCallableRef('entries', 1, tmp_2, AbstractBindingDeclaration$_get_entries_$ref_fnlsrh_0(), null);
    var tmp$ret$2 = new MultipleChildLink(getKClass(AbstractBindingDeclaration), this_0);
    tmp_1.afv_1 = this.p6m(tmp$ret$2, 'entries');
    var tmp_3 = this;
    var tmp_4 = KProperty1;
    var tmp4_0 = getPropertyCallableRef('properties', 1, tmp_4, AbstractBindingDeclaration$_get_properties_$ref_4foxw4_0(), null);
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childrenRole' call
    var name_0 = 'properties';
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$4 = new MultipleChildLink(getKClass(AbstractBindingDeclaration), tmp4_0);
    tmp_3.bfv_1 = this.p6m(tmp$ret$4, name_0);
    var tmp_5 = this;
    var tmp_6 = KProperty1;
    var tmp4_1 = getPropertyCallableRef('customEditor', 1, tmp_6, AbstractBindingDeclaration$_get_customEditor_$ref_6c7l07_0(), null);
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    var name_1 = 'customEditor';
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$6 = new SingleChildLink(getKClass(AbstractBindingDeclaration), tmp4_1);
    tmp_5.cfv_1 = this.o6m(tmp$ret$6, name_1);
    var tmp_7 = this;
    var tmp_8 = KProperty1;
    tmp_7.dfv_1 = this.r6m(getPropertyCallableRef('customEditorEnabled', 1, tmp_8, AbstractBindingDeclaration$_get_customEditorEnabled_$ref_h4m7ao_0(), null), 'customEditorEnabled');
    this.efv_1 = new DomainNodeChildrenPropertyDescriptor(this.zfu_1.s6i_1);
    this.ffv_1 = new DomainNodeChildrenPropertyDescriptor(this.afv_1.s6i_1);
    this.gfv_1 = new DomainNodeChildrenPropertyDescriptor(this.bfv_1.s6i_1);
    this.hfv_1 = new DomainNodeChildPropertyDescriptor(this.cfv_1.s6i_1);
    this.ifv_1 = new DomainNodePropertyDescriptor(this.dfv_1, toNonNullPersister(NonNullPersisters_getInstance().k25(), new DefaultValueNullPersister(false)));
  }
  var AbstractBindingDeclarationConcept_instance;
  function AbstractBindingDeclarationConcept_getInstance() {
    if (AbstractBindingDeclarationConcept_instance == null)
      new AbstractBindingDeclarationConcept();
    return AbstractBindingDeclarationConcept_instance;
  }
  function AbstractBindingEntryConcept() {
    AbstractBindingEntryConcept_instance = this;
    OTAbstractConceptDescriptor.call(this, Companion_instance_94.k6m([BTBNodeConcept_getInstance()]));
  }
  var AbstractBindingEntryConcept_instance;
  function AbstractBindingEntryConcept_getInstance() {
    if (AbstractBindingEntryConcept_instance == null)
      new AbstractBindingEntryConcept();
    return AbstractBindingEntryConcept_instance;
  }
  function AbstractBindingValue$_get_value_$ref_r1k0yv_0() {
    return function (p0) {
      return p0.a1();
    };
  }
  function AbstractBindingValueConcept() {
    AbstractBindingValueConcept_instance = this;
    OTAbstractConceptDescriptor.call(this, Companion_instance_94.k6m([BindingValuePlaceholderConcept_getInstance()]));
    var tmp = this;
    var tmp_0 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_0 = getPropertyCallableRef('value', 1, tmp_0, AbstractBindingValue$_get_value_$ref_r1k0yv_0(), null);
    var tmp$ret$0 = new SingleChildLink(getKClass(AbstractBindingValue), this_0);
    tmp.pfv_1 = this.o6m(tmp$ret$0, 'value');
    this.qfv_1 = new DomainNodeChildPropertyDescriptor(this.pfv_1.s6i_1);
  }
  var AbstractBindingValueConcept_instance;
  function AbstractBindingValueConcept_getInstance() {
    if (AbstractBindingValueConcept_instance == null)
      new AbstractBindingValueConcept();
    return AbstractBindingValueConcept_instance;
  }
  function AbstractBindingValueQueryConcept() {
    AbstractBindingValueQueryConcept_instance = this;
    OTAbstractConceptDescriptor.call(this, Companion_instance_94.k6m([BindingValuePlaceholderQueryConcept_getInstance()]));
  }
  var AbstractBindingValueQueryConcept_instance;
  function AbstractBindingValueQueryConcept_getInstance() {
    if (AbstractBindingValueQueryConcept_instance == null)
      new AbstractBindingValueQueryConcept();
    return AbstractBindingValueQueryConcept_instance;
  }
  function AbstractLink$_get_specializes_$ref_yv3dpc_0() {
    return function (p0) {
      return p0.ufp();
    };
  }
  function AbstractLinkConcept() {
    AbstractLinkConcept_instance = this;
    OTAbstractConceptDescriptor.call(this, Companion_instance_94.k6m([AbstractBindingEntryConcept_getInstance()]));
    var tmp = this;
    var tmp_0 = KProperty1;
    var tmp4 = getPropertyCallableRef('specializes', 1, tmp_0, AbstractLink$_get_specializes_$ref_yv3dpc_0(), null);
    var tmp6 = Companion_getInstance_329().rfv_1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.referenceRole' call
    var name = 'specializes';
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var tmp$ret$0 = new ReferenceLink(getKClass(AbstractLink), tmp4, getKClass(AbstractLink), getKClass(QualifiedReferenceContent));
    tmp.yfv_1 = this.q6m(tmp$ret$0, tmp6, name);
    this.zfv_1 = new DomainNodeReferencePropertyDescriptor(this.yfv_1, ReferenceContentPersisters_getInstance().d6m(getKClass(QualifiedReferenceContent)), getKClass(QualifiedReferenceContent));
  }
  var AbstractLinkConcept_instance;
  function AbstractLinkConcept_getInstance() {
    if (AbstractLinkConcept_instance == null)
      new AbstractLinkConcept();
    return AbstractLinkConcept_instance;
  }
  function AbstractNotionConcept() {
    AbstractNotionConcept_instance = this;
    OTAbstractConceptDescriptor.call(this, Companion_instance_94.k6m([BTBNodeConcept_getInstance(), DirectlyNamedConcept_getInstance()]));
  }
  var AbstractNotionConcept_instance;
  function AbstractNotionConcept_getInstance() {
    if (AbstractNotionConcept_instance == null)
      new AbstractNotionConcept();
    return AbstractNotionConcept_instance;
  }
  function AbstractOntologyRelationConcept() {
    AbstractOntologyRelationConcept_instance = this;
    OTAbstractConceptDescriptor.call(this, Companion_instance_94.k6m([BTBNodeConcept_getInstance()]));
  }
  var AbstractOntologyRelationConcept_instance;
  function AbstractOntologyRelationConcept_getInstance() {
    if (AbstractOntologyRelationConcept_instance == null)
      new AbstractOntologyRelationConcept();
    return AbstractOntologyRelationConcept_instance;
  }
  function AbstractProcessSpecificationConcept() {
    AbstractProcessSpecificationConcept_instance = this;
    OTAbstractConceptDescriptor.call(this, Companion_instance_94.k6m([BTBNodeConcept_getInstance()]));
  }
  var AbstractProcessSpecificationConcept_instance;
  function AbstractProcessSpecificationConcept_getInstance() {
    if (AbstractProcessSpecificationConcept_instance == null)
      new AbstractProcessSpecificationConcept();
    return AbstractProcessSpecificationConcept_instance;
  }
  function AbstractPropertyConcept() {
    AbstractPropertyConcept_instance = this;
    OTAbstractConceptDescriptor.call(this, Companion_instance_94.k6m([AbstractBindingEntryConcept_getInstance()]));
  }
  var AbstractPropertyConcept_instance;
  function AbstractPropertyConcept_getInstance() {
    if (AbstractPropertyConcept_instance == null)
      new AbstractPropertyConcept();
    return AbstractPropertyConcept_instance;
  }
  function AbstractValueConcept() {
    AbstractValueConcept_instance = this;
    OTAbstractConceptDescriptor.call(this, Companion_instance_94.k6m([BTBNodeConcept_getInstance()]));
  }
  var AbstractValueConcept_instance;
  function AbstractValueConcept_getInstance() {
    if (AbstractValueConcept_instance == null)
      new AbstractValueConcept();
    return AbstractValueConcept_instance;
  }
  function AllowedComplexNotionTypeConcept() {
    AllowedComplexNotionTypeConcept_instance = this;
    OTAbstractConceptDescriptor.call(this, Companion_instance_94.k6m([BTBNodeConcept_getInstance()]));
  }
  var AllowedComplexNotionTypeConcept_instance;
  function AllowedComplexNotionTypeConcept_getInstance() {
    if (AllowedComplexNotionTypeConcept_instance == null)
      new AllowedComplexNotionTypeConcept();
    return AllowedComplexNotionTypeConcept_instance;
  }
  function AllowedComplexNotionValueConcept() {
    AllowedComplexNotionValueConcept_instance = this;
    OTAbstractConceptDescriptor.call(this, Companion_instance_94.k6m([BTBNodeConcept_getInstance()]));
  }
  var AllowedComplexNotionValueConcept_instance;
  function AllowedComplexNotionValueConcept_getInstance() {
    if (AllowedComplexNotionValueConcept_instance == null)
      new AllowedComplexNotionValueConcept();
    return AllowedComplexNotionValueConcept_instance;
  }
  function AnonymousClassConcept() {
    AnonymousClassConcept_instance = this;
    OTAbstractConceptDescriptor.call(this, Companion_instance_94.k6m([ClassExpressionConcept_getInstance(), ClassDeclarationConcept_getInstance(), AbstractValueConcept_getInstance(), FactExpressionConcept_getInstance()]));
  }
  var AnonymousClassConcept_instance;
  function AnonymousClassConcept_getInstance() {
    if (AnonymousClassConcept_instance == null)
      new AnonymousClassConcept();
    return AnonymousClassConcept_instance;
  }
  function AuthorImpl$_init_$ref_3dxjqy() {
    var l = function (p0, p1) {
      return new AuthorImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function AuthorConcept$_init_$lambda_rm44xa(context, nodeId) {
    return new TypedAuthorImpl(context, VOID, nodeId);
  }
  function AuthorConcept() {
    AuthorConcept_instance = this;
    var tmp = AuthorImpl$_init_$ref_3dxjqy();
    OtConceptDescriptor.call(this, 'Author', VOID, tmp, AuthorConcept$_init_$lambda_rm44xa, Companion_instance_94.k6m([DirectlyNamedConcept_getInstance(), BTBNodeConcept_getInstance()]));
  }
  var AuthorConcept_instance;
  function AuthorConcept_getInstance() {
    if (AuthorConcept_instance == null)
      new AuthorConcept();
    return AuthorConcept_instance;
  }
  function AuthoredWorkImpl$_init_$ref_2tbewa() {
    var l = function (p0, p1) {
      return new AuthoredWorkImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function AuthoredWorkConcept$_init_$lambda_hq3c3i(context, nodeId) {
    return new TypedAuthoredWorkImpl(context, VOID, nodeId);
  }
  function AuthoredWork$_get_authors_$ref_88kya7_0() {
    return function (p0) {
      return p0.vfp();
    };
  }
  function AuthoredWork$_get_title_$ref_mtfkzj_0() {
    return function (p0) {
      return p0.wfp();
    };
  }
  function AuthoredWorkConcept() {
    AuthoredWorkConcept_instance = this;
    var tmp = AuthoredWorkImpl$_init_$ref_2tbewa();
    OtConceptDescriptor.call(this, 'AuthoredWork', VOID, tmp, AuthoredWorkConcept$_init_$lambda_hq3c3i, Companion_instance_94.k6m([BTBNodeConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    var tmp4 = getPropertyCallableRef('authors', 1, tmp_1, AuthoredWork$_get_authors_$ref_88kya7_0(), null);
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childrenRole' call
    var name = 'authors_list';
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$0 = new MultipleChildLink(getKClass(AuthoredWork), tmp4);
    tmp_0.kfw_1 = this.p6m(tmp$ret$0, name);
    var tmp_2 = this;
    var tmp_3 = KProperty1;
    tmp_2.lfw_1 = this.r6m(getPropertyCallableRef('title', 1, tmp_3, AuthoredWork$_get_title_$ref_mtfkzj_0(), null), 'title');
    this.mfw_1 = new DomainNodeChildrenPropertyDescriptor(this.kfw_1.s6i_1);
    this.nfw_1 = new DomainNodePropertyDescriptor(this.lfw_1, toNonNullPersister(NonNullPersisters_getInstance().h25(), new DefaultValueNullPersister('')));
  }
  var AuthoredWorkConcept_instance;
  function AuthoredWorkConcept_getInstance() {
    if (AuthoredWorkConcept_instance == null)
      new AuthoredWorkConcept();
    return AuthoredWorkConcept_instance;
  }
  function BTBDocumentImpl$_init_$ref_6ye4qi() {
    var l = function (p0, p1) {
      return new BTBDocumentImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function BTBDocumentConcept$_init_$lambda_3ce17y(context, nodeId) {
    return new TypedBTBDocumentImpl(context, VOID, nodeId);
  }
  function BTBDocument$_get_factSets_$ref_40l74m_0() {
    return function (p0) {
      return p0.xfp();
    };
  }
  function BTBDocument$_get_categories_$ref_emheyf_0() {
    return function (p0) {
      return p0.yfp();
    };
  }
  function BTBDocument$_get_imports_$ref_o0awgp_0() {
    return function (p0) {
      return p0.zfp();
    };
  }
  function BTBDocumentConcept() {
    BTBDocumentConcept_instance = this;
    var tmp = BTBDocumentImpl$_init_$ref_6ye4qi();
    OtConceptDescriptor.call(this, 'BTBDocument', VOID, tmp, BTBDocumentConcept$_init_$lambda_3ce17y, Companion_instance_94.k6m([DocumentNodeConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    var tmp4 = getPropertyCallableRef('factSets', 1, tmp_1, BTBDocument$_get_factSets_$ref_40l74m_0(), null);
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childrenRole' call
    var name = 'factSets';
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$0 = new MultipleChildLink(getKClass(BTBDocument_1), tmp4);
    tmp_0.yfw_1 = this.p6m(tmp$ret$0, name);
    var tmp_2 = this;
    var tmp_3 = KProperty1;
    var tmp4_0 = getPropertyCallableRef('categories', 1, tmp_3, BTBDocument$_get_categories_$ref_emheyf_0(), null);
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childrenRole' call
    var name_0 = 'categories';
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$2 = new MultipleChildLink(getKClass(BTBDocument_1), tmp4_0);
    tmp_2.zfw_1 = this.p6m(tmp$ret$2, name_0);
    var tmp_4 = this;
    var tmp_5 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childrenRole' call
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_0 = getPropertyCallableRef('imports', 1, tmp_5, BTBDocument$_get_imports_$ref_o0awgp_0(), null);
    var tmp$ret$4 = new MultipleChildLink(getKClass(BTBDocument_1), this_0);
    tmp_4.afx_1 = this.p6m(tmp$ret$4, 'imports');
    this.bfx_1 = new DomainNodeChildrenPropertyDescriptor(this.yfw_1.s6i_1);
    this.cfx_1 = new DomainNodeChildrenPropertyDescriptor(this.zfw_1.s6i_1);
    this.dfx_1 = new DomainNodeChildrenPropertyDescriptor(this.afx_1.s6i_1);
  }
  var BTBDocumentConcept_instance;
  function BTBDocumentConcept_getInstance() {
    if (BTBDocumentConcept_instance == null)
      new BTBDocumentConcept();
    return BTBDocumentConcept_instance;
  }
  function BTBNodeConcept() {
    BTBNodeConcept_instance = this;
    OTAbstractConceptDescriptor.call(this);
  }
  var BTBNodeConcept_instance;
  function BTBNodeConcept_getInstance() {
    if (BTBNodeConcept_instance == null)
      new BTBNodeConcept();
    return BTBNodeConcept_instance;
  }
  function BindingPropertyImpl$_init_$ref_d0d8rv() {
    var l = function (p0, p1) {
      return new BindingPropertyImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function BindingPropertyConcept$_init_$lambda_4epohp(context, nodeId) {
    return new TypedBindingPropertyImpl(context, VOID, nodeId);
  }
  function BindingProperty$_get_property_$ref_iv28zz_0() {
    return function (p0) {
      return p0.q6q();
    };
  }
  function BindingPropertyConcept() {
    BindingPropertyConcept_instance = this;
    var tmp = BindingPropertyImpl$_init_$ref_d0d8rv();
    OtConceptDescriptor.call(this, 'BindingProperty', VOID, tmp, BindingPropertyConcept$_init_$lambda_4epohp, Companion_instance_94.k6m([AbstractPropertyConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    var tmp4 = getPropertyCallableRef('property', 1, tmp_1, BindingProperty$_get_property_$ref_iv28zz_0(), null);
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    var name = 'property';
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$0 = new SingleChildLink(getKClass(BindingProperty_1), tmp4);
    tmp_0.ofx_1 = this.o6m(tmp$ret$0, name);
    this.pfx_1 = new DomainNodeChildPropertyDescriptor(this.ofx_1.s6i_1);
  }
  var BindingPropertyConcept_instance;
  function BindingPropertyConcept_getInstance() {
    if (BindingPropertyConcept_instance == null)
      new BindingPropertyConcept();
    return BindingPropertyConcept_instance;
  }
  function BindingValueMaskImpl$_init_$ref_yxhrh() {
    var l = function (p0, p1) {
      return new BindingValueMaskImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function BindingValueMaskConcept$_init_$lambda_uabsud(context, nodeId) {
    return new TypedBindingValueMaskImpl(context, VOID, nodeId);
  }
  function BindingValueMask$_get_value_$ref_srt04j_0() {
    return function (p0) {
      return p0.a1();
    };
  }
  function BindingValueMaskConcept() {
    BindingValueMaskConcept_instance = this;
    var tmp = BindingValueMaskImpl$_init_$ref_yxhrh();
    OtConceptDescriptor.call(this, 'BindingValueMask', VOID, tmp, BindingValueMaskConcept$_init_$lambda_uabsud, Companion_instance_94.k6m([AbstractBindingValueQueryConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_0 = getPropertyCallableRef('value', 1, tmp_1, BindingValueMask$_get_value_$ref_srt04j_0(), null);
    var tmp$ret$0 = new SingleChildLink(getKClass(BindingValueMask_1), this_0);
    tmp_0.afy_1 = this.o6m(tmp$ret$0, 'value');
    this.bfy_1 = new DomainNodeChildPropertyDescriptor(this.afy_1.s6i_1);
  }
  var BindingValueMaskConcept_instance;
  function BindingValueMaskConcept_getInstance() {
    if (BindingValueMaskConcept_instance == null)
      new BindingValueMaskConcept();
    return BindingValueMaskConcept_instance;
  }
  function BindingValuePlaceholderImpl$_init_$ref_5w9ztq() {
    var l = function (p0, p1) {
      return new BindingValuePlaceholderImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function BindingValuePlaceholderConcept$_init_$lambda_g8hwmu(context, nodeId) {
    return new TypedBindingValuePlaceholderImpl(context, VOID, nodeId);
  }
  function BindingValuePlaceholderConcept() {
    BindingValuePlaceholderConcept_instance = this;
    var tmp = BindingValuePlaceholderImpl$_init_$ref_5w9ztq();
    OtConceptDescriptor.call(this, 'BindingValuePlaceholder', VOID, tmp, BindingValuePlaceholderConcept$_init_$lambda_g8hwmu, Companion_instance_94.k6m([BTBNodeConcept_getInstance()]));
  }
  var BindingValuePlaceholderConcept_instance;
  function BindingValuePlaceholderConcept_getInstance() {
    if (BindingValuePlaceholderConcept_instance == null)
      new BindingValuePlaceholderConcept();
    return BindingValuePlaceholderConcept_instance;
  }
  function BindingValuePlaceholderQueryImpl$_init_$ref_2h3rj0() {
    var l = function (p0, p1) {
      return new BindingValuePlaceholderQueryImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function BindingValuePlaceholderQueryConcept$_init_$lambda_szxmbg(context, nodeId) {
    return new TypedBindingValuePlaceholderQueryImpl(context, VOID, nodeId);
  }
  function BindingValuePlaceholderQueryConcept() {
    BindingValuePlaceholderQueryConcept_instance = this;
    var tmp = BindingValuePlaceholderQueryImpl$_init_$ref_2h3rj0();
    OtConceptDescriptor.call(this, 'BindingValuePlaceholderQuery', VOID, tmp, BindingValuePlaceholderQueryConcept$_init_$lambda_szxmbg, Companion_instance_94.k6m([BTBNodeConcept_getInstance()]));
  }
  var BindingValuePlaceholderQueryConcept_instance;
  function BindingValuePlaceholderQueryConcept_getInstance() {
    if (BindingValuePlaceholderQueryConcept_instance == null)
      new BindingValuePlaceholderQueryConcept();
    return BindingValuePlaceholderQueryConcept_instance;
  }
  function BookImpl$_init_$ref_1p7hng() {
    var l = function (p0, p1) {
      return new BookImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function BookConcept$_init_$lambda_rvnjpo(context, nodeId) {
    return new TypedBookImpl(context, VOID, nodeId);
  }
  function Book$_get_edition_$ref_uuzusn_0() {
    return function (p0) {
      return p0.afq();
    };
  }
  function BookConcept() {
    BookConcept_instance = this;
    var tmp = BookImpl$_init_$ref_1p7hng();
    OtConceptDescriptor.call(this, 'Book', VOID, tmp, BookConcept$_init_$lambda_rvnjpo, Companion_instance_94.k6m([PublishedWorkConcept_getInstance(), LibraryItemConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    tmp_0.mfy_1 = this.r6m(getPropertyCallableRef('edition', 1, tmp_1, Book$_get_edition_$ref_uuzusn_0(), null), 'edition');
    this.nfy_1 = new DomainNodePropertyDescriptor(this.mfy_1, toNonNullPersister(NonNullPersisters_getInstance().h25(), new DefaultValueNullPersister('')));
  }
  var BookConcept_instance;
  function BookConcept_getInstance() {
    if (BookConcept_instance == null)
      new BookConcept();
    return BookConcept_instance;
  }
  function CardinalityBoundImpl$_init_$ref_iazhjp() {
    var l = function (p0, p1) {
      return new CardinalityBoundImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function CardinalityBoundConcept$_init_$lambda_qvwo9f(context, nodeId) {
    return new TypedCardinalityBoundImpl(context, VOID, nodeId);
  }
  function CardinalityBoundConcept() {
    CardinalityBoundConcept_instance = this;
    var tmp = CardinalityBoundImpl$_init_$ref_iazhjp();
    OtConceptDescriptor.call(this, 'CardinalityBound', VOID, tmp, CardinalityBoundConcept$_init_$lambda_qvwo9f, Companion_instance_94.k6m([BTBNodeConcept_getInstance()]));
  }
  var CardinalityBoundConcept_instance;
  function CardinalityBoundConcept_getInstance() {
    if (CardinalityBoundConcept_instance == null)
      new CardinalityBoundConcept();
    return CardinalityBoundConcept_instance;
  }
  function CardinalityBoundConstantImpl$_init_$ref_4ykgj3() {
    var l = function (p0, p1) {
      return new CardinalityBoundConstantImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function CardinalityBoundConstantConcept$_init_$lambda_um3s47(context, nodeId) {
    return new TypedCardinalityBoundConstantImpl(context, VOID, nodeId);
  }
  function CardinalityBoundConstant$_get_value_$ref_d0ff0h_0() {
    return function (p0) {
      return p0.a1();
    };
  }
  function CardinalityBoundConstantConcept() {
    CardinalityBoundConstantConcept_instance = this;
    var tmp = CardinalityBoundConstantImpl$_init_$ref_4ykgj3();
    OtConceptDescriptor.call(this, 'CardinalityBoundConstant', VOID, tmp, CardinalityBoundConstantConcept$_init_$lambda_um3s47, Companion_instance_94.k6m([CardinalityBoundConcept_getInstance(), BTBNodeConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    tmp_0.yfy_1 = this.r6m(getPropertyCallableRef('value', 1, tmp_1, CardinalityBoundConstant$_get_value_$ref_d0ff0h_0(), null), 'value');
    this.zfy_1 = new DomainNodePropertyDescriptor(this.yfy_1, toNonNullPersister(NonNullPersisters_getInstance().i25()));
  }
  var CardinalityBoundConstantConcept_instance;
  function CardinalityBoundConstantConcept_getInstance() {
    if (CardinalityBoundConstantConcept_instance == null)
      new CardinalityBoundConstantConcept();
    return CardinalityBoundConstantConcept_instance;
  }
  function CardinalityBoundNImpl$_init_$ref_n9bief() {
    var l = function (p0, p1) {
      return new CardinalityBoundNImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function CardinalityBoundNConcept$_init_$lambda_p9j5z3(context, nodeId) {
    return new TypedCardinalityBoundNImpl(context, VOID, nodeId);
  }
  function CardinalityBoundNConcept() {
    CardinalityBoundNConcept_instance = this;
    var tmp = CardinalityBoundNImpl$_init_$ref_n9bief();
    OtConceptDescriptor.call(this, 'CardinalityBoundN', VOID, tmp, CardinalityBoundNConcept$_init_$lambda_p9j5z3, Companion_instance_94.k6m([CardinalityBoundConcept_getInstance()]));
  }
  var CardinalityBoundNConcept_instance;
  function CardinalityBoundNConcept_getInstance() {
    if (CardinalityBoundNConcept_instance == null)
      new CardinalityBoundNConcept();
    return CardinalityBoundNConcept_instance;
  }
  function CardinalityBoundPlaceholderImpl$_init_$ref_ksoo8u() {
    var l = function (p0, p1) {
      return new CardinalityBoundPlaceholderImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function CardinalityBoundPlaceholderConcept$_init_$lambda_8kiy92(context, nodeId) {
    return new TypedCardinalityBoundPlaceholderImpl(context, VOID, nodeId);
  }
  function CardinalityBoundPlaceholder$_get_bound_$ref_92a5xd_0() {
    return function (p0) {
      return p0.efq();
    };
  }
  function CardinalityBoundPlaceholderConcept() {
    CardinalityBoundPlaceholderConcept_instance = this;
    var tmp = CardinalityBoundPlaceholderImpl$_init_$ref_ksoo8u();
    OtConceptDescriptor.call(this, 'CardinalityBoundPlaceholder', VOID, tmp, CardinalityBoundPlaceholderConcept$_init_$lambda_8kiy92, Companion_instance_94.k6m([BTBNodeConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_0 = getPropertyCallableRef('bound', 1, tmp_1, CardinalityBoundPlaceholder$_get_bound_$ref_92a5xd_0(), null);
    var tmp$ret$0 = new SingleChildLink(getKClass(CardinalityBoundPlaceholder_1), this_0);
    tmp_0.kfz_1 = this.o6m(tmp$ret$0, 'bound');
    this.lfz_1 = new DomainNodeChildPropertyDescriptor(this.kfz_1.s6i_1);
  }
  var CardinalityBoundPlaceholderConcept_instance;
  function CardinalityBoundPlaceholderConcept_getInstance() {
    if (CardinalityBoundPlaceholderConcept_instance == null)
      new CardinalityBoundPlaceholderConcept();
    return CardinalityBoundPlaceholderConcept_instance;
  }
  function CardinalityImpl$_init_$ref_e6f85z() {
    var l = function (p0, p1) {
      return new CardinalityImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function CardinalityConcept$_init_$lambda_l8hgz3(context, nodeId) {
    return new TypedCardinalityImpl(context, VOID, nodeId);
  }
  function Cardinality$_get_lowerBound_$ref_entgur_0() {
    return function (p0) {
      return p0.bfq();
    };
  }
  function Cardinality$_get_upperBound_$ref_jgtibw_0() {
    return function (p0) {
      return p0.cfq();
    };
  }
  function Cardinality$_get_deprecatedUpperBound_$ref_fpwpvl_0() {
    return function (p0) {
      return p0.dfq();
    };
  }
  function CardinalityConcept() {
    CardinalityConcept_instance = this;
    var tmp = CardinalityImpl$_init_$ref_e6f85z();
    OtConceptDescriptor.call(this, 'Cardinality', VOID, tmp, CardinalityConcept$_init_$lambda_l8hgz3, Companion_instance_94.k6m([BTBNodeConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    var tmp4 = getPropertyCallableRef('lowerBound', 1, tmp_1, Cardinality$_get_lowerBound_$ref_entgur_0(), null);
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    var name = 'lowerBound';
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$0 = new SingleChildLink(getKClass(Cardinality_1), tmp4);
    tmp_0.wfz_1 = this.o6m(tmp$ret$0, name);
    var tmp_2 = this;
    var tmp_3 = KProperty1;
    var tmp4_0 = getPropertyCallableRef('upperBound', 1, tmp_3, Cardinality$_get_upperBound_$ref_jgtibw_0(), null);
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    var name_0 = 'upperBoundPlaceholder';
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$2 = new SingleChildLink(getKClass(Cardinality_1), tmp4_0);
    tmp_2.xfz_1 = this.o6m(tmp$ret$2, name_0);
    var tmp_4 = this;
    var tmp_5 = KProperty1;
    var tmp4_1 = getPropertyCallableRef('deprecatedUpperBound', 1, tmp_5, Cardinality$_get_deprecatedUpperBound_$ref_fpwpvl_0(), null);
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    var name_1 = 'upperBound';
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$4 = new SingleChildLink(getKClass(Cardinality_1), tmp4_1);
    tmp_4.yfz_1 = this.o6m(tmp$ret$4, name_1);
    this.zfz_1 = new DomainNodeChildPropertyDescriptor(this.wfz_1.s6i_1);
    this.ag0_1 = new DomainNodeChildPropertyDescriptor(this.xfz_1.s6i_1);
    this.bg0_1 = new DomainNodeChildPropertyDescriptor(this.yfz_1.s6i_1);
  }
  var CardinalityConcept_instance;
  function CardinalityConcept_getInstance() {
    if (CardinalityConcept_instance == null)
      new CardinalityConcept();
    return CardinalityConcept_instance;
  }
  function CardinalityCustomCellImpl$_init_$ref_a34zvo() {
    var l = function (p0, p1) {
      return new CardinalityCustomCellImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function CardinalityCustomCellConcept$_init_$lambda_cbn9xg(context, nodeId) {
    return new TypedCardinalityCustomCellImpl(context, VOID, nodeId);
  }
  function CardinalityCustomCellConcept() {
    CardinalityCustomCellConcept_instance = this;
    var tmp = CardinalityCustomCellImpl$_init_$ref_a34zvo();
    OtConceptDescriptor.call(this, 'CardinalityCustomCell', VOID, tmp, CardinalityCustomCellConcept$_init_$lambda_cbn9xg, Companion_instance_94.k6m([CustomCellConcept_getInstance()]));
  }
  var CardinalityCustomCellConcept_instance;
  function CardinalityCustomCellConcept_getInstance() {
    if (CardinalityCustomCellConcept_instance == null)
      new CardinalityCustomCellConcept();
    return CardinalityCustomCellConcept_instance;
  }
  function CategoryImpl$_init_$ref_yj9xg9() {
    var l = function (p0, p1) {
      return new CategoryImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function CategoryConcept$_init_$lambda_ldaz5t(context, nodeId) {
    return new TypedCategoryImpl(context, VOID, nodeId);
  }
  function Category$_get_library_$ref_sghxsx_0() {
    return function (p0) {
      return p0.ffq();
    };
  }
  function Category$_get_element_$ref_9nwohu_0() {
    return function (p0) {
      return p0.gfq();
    };
  }
  function CategoryConcept() {
    CategoryConcept_instance = this;
    var tmp = CategoryImpl$_init_$ref_yj9xg9();
    OtConceptDescriptor.call(this, 'Category', VOID, tmp, CategoryConcept$_init_$lambda_ldaz5t, Companion_instance_94.k6m([BTBNodeConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_0 = getPropertyCallableRef('library', 1, tmp_1, Category$_get_library_$ref_sghxsx_0(), null);
    var tmp$ret$0 = new SingleChildLink(getKClass(Category_1), this_0);
    tmp_0.mg0_1 = this.o6m(tmp$ret$0, 'library');
    var tmp_2 = this;
    var tmp_3 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_1 = getPropertyCallableRef('element', 1, tmp_3, Category$_get_element_$ref_9nwohu_0(), null);
    var tmp$ret$2 = new SingleChildLink(getKClass(Category_1), this_1);
    tmp_2.ng0_1 = this.o6m(tmp$ret$2, 'element');
    this.og0_1 = new DomainNodeChildPropertyDescriptor(this.mg0_1.s6i_1);
    this.pg0_1 = new DomainNodeChildPropertyDescriptor(this.ng0_1.s6i_1);
  }
  var CategoryConcept_instance;
  function CategoryConcept_getInstance() {
    if (CategoryConcept_instance == null)
      new CategoryConcept();
    return CategoryConcept_instance;
  }
  function ClassDeclarationConcept() {
    ClassDeclarationConcept_instance = this;
    OTAbstractConceptDescriptor.call(this, Companion_instance_94.k6m([BTBNodeConcept_getInstance()]));
  }
  var ClassDeclarationConcept_instance;
  function ClassDeclarationConcept_getInstance() {
    if (ClassDeclarationConcept_instance == null)
      new ClassDeclarationConcept();
    return ClassDeclarationConcept_instance;
  }
  function ClassExpressionConcept() {
    ClassExpressionConcept_instance = this;
    OTAbstractConceptDescriptor.call(this, Companion_instance_94.k6m([ClassExpressionPlaceholderConcept_getInstance()]));
  }
  var ClassExpressionConcept_instance;
  function ClassExpressionConcept_getInstance() {
    if (ClassExpressionConcept_instance == null)
      new ClassExpressionConcept();
    return ClassExpressionConcept_instance;
  }
  function ClassExpressionPlaceholderImpl$_init_$ref_yvwlnm() {
    var l = function (p0, p1) {
      return new ClassExpressionPlaceholderImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function ClassExpressionPlaceholderConcept$_init_$lambda_cileva(context, nodeId) {
    return new TypedClassExpressionPlaceholderImpl(context, VOID, nodeId);
  }
  function ClassExpressionPlaceholderConcept() {
    ClassExpressionPlaceholderConcept_instance = this;
    var tmp = ClassExpressionPlaceholderImpl$_init_$ref_yvwlnm();
    OtConceptDescriptor.call(this, 'ClassExpression', VOID, tmp, ClassExpressionPlaceholderConcept$_init_$lambda_cileva, Companion_instance_94.k6m([BTBNodeConcept_getInstance()]));
  }
  var ClassExpressionPlaceholderConcept_instance;
  function ClassExpressionPlaceholderConcept_getInstance() {
    if (ClassExpressionPlaceholderConcept_instance == null)
      new ClassExpressionPlaceholderConcept();
    return ClassExpressionPlaceholderConcept_instance;
  }
  function ClassExpressionTypeImpl$_init_$ref_os18kb() {
    var l = function (p0, p1) {
      return new ClassExpressionTypeImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function ClassExpressionTypeConcept$_init_$lambda_v4kvn(context, nodeId) {
    return new TypedClassExpressionTypeImpl(context, VOID, nodeId);
  }
  function ClassExpressionType$_get_classExpression_$ref_lk9vu2_0() {
    return function (p0) {
      return p0.hfq();
    };
  }
  function ClassExpressionTypeConcept() {
    ClassExpressionTypeConcept_instance = this;
    var tmp = ClassExpressionTypeImpl$_init_$ref_os18kb();
    OtConceptDescriptor.call(this, 'ClassExpressionType', VOID, tmp, ClassExpressionTypeConcept$_init_$lambda_v4kvn, Companion_instance_94.k6m([TypeConcept_getInstance(), ProcessPropertyTypeConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    var tmp4 = getPropertyCallableRef('classExpression', 1, tmp_1, ClassExpressionType$_get_classExpression_$ref_lk9vu2_0(), null);
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    var name = 'classExpression';
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$0 = new SingleChildLink(getKClass(ClassExpressionType_1), tmp4);
    tmp_0.ag1_1 = this.o6m(tmp$ret$0, name);
    this.bg1_1 = new DomainNodeChildPropertyDescriptor(this.ag1_1.s6i_1);
  }
  var ClassExpressionTypeConcept_instance;
  function ClassExpressionTypeConcept_getInstance() {
    if (ClassExpressionTypeConcept_instance == null)
      new ClassExpressionTypeConcept();
    return ClassExpressionTypeConcept_instance;
  }
  function CommandConcept() {
    CommandConcept_instance = this;
    OTAbstractConceptDescriptor.call(this, Companion_instance_94.k6m([BTBNodeConcept_getInstance()]));
  }
  var CommandConcept_instance;
  function CommandConcept_getInstance() {
    if (CommandConcept_instance == null)
      new CommandConcept();
    return CommandConcept_instance;
  }
  function ComplexNotionImpl$_init_$ref_p9xpb4() {
    var l = function (p0, p1) {
      return new ComplexNotionImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function ComplexNotionConcept$_init_$lambda_xukvm0(context, nodeId) {
    return new TypedComplexNotionImpl(context, VOID, nodeId);
  }
  function ComplexNotion$_get_elements_$ref_mrhdwi_0() {
    return function (p0) {
      return p0.ifq();
    };
  }
  function ComplexNotion$_get_template_$ref_kdbfun_0() {
    return function (p0) {
      return p0.jfq();
    };
  }
  function ComplexNotionConcept() {
    ComplexNotionConcept_instance = this;
    var tmp = ComplexNotionImpl$_init_$ref_p9xpb4();
    OtConceptDescriptor.call(this, 'ComplexNotion', VOID, tmp, ComplexNotionConcept$_init_$lambda_xukvm0, Companion_instance_94.k6m([AbstractNotionConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    var tmp4 = getPropertyCallableRef('elements', 1, tmp_1, ComplexNotion$_get_elements_$ref_mrhdwi_0(), null);
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childrenRole' call
    var name = 'elements';
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$0 = new MultipleChildLink(getKClass(ComplexNotion_1), tmp4);
    tmp_0.mg1_1 = this.p6m(tmp$ret$0, name);
    var tmp_2 = this;
    var tmp_3 = KProperty1;
    var tmp4_0 = getPropertyCallableRef('template', 1, tmp_3, ComplexNotion$_get_template_$ref_kdbfun_0(), null);
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    var name_0 = 'template';
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$2 = new SingleChildLink(getKClass(ComplexNotion_1), tmp4_0);
    tmp_2.ng1_1 = this.o6m(tmp$ret$2, name_0);
    this.og1_1 = new DomainNodeChildrenPropertyDescriptor(this.mg1_1.s6i_1);
    this.pg1_1 = new DomainNodeChildPropertyDescriptor(this.ng1_1.s6i_1);
  }
  var ComplexNotionConcept_instance;
  function ComplexNotionConcept_getInstance() {
    if (ComplexNotionConcept_instance == null)
      new ComplexNotionConcept();
    return ComplexNotionConcept_instance;
  }
  function ComplexNotionElementImpl$_init_$ref_4wvphu() {
    var l = function (p0, p1) {
      return new ComplexNotionElementImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function ComplexNotionElementConcept$_init_$lambda_aud3i2(context, nodeId) {
    return new TypedComplexNotionElementImpl(context, VOID, nodeId);
  }
  function ComplexNotionElement$_get_elementType_$ref_czuq0z_0() {
    return function (p0) {
      return p0.kfq();
    };
  }
  function ComplexNotionElement$_get_unknownValueAllowed_$ref_30zrma_0() {
    return function (p0) {
      return p0.lfq();
    };
  }
  function ComplexNotionElementConcept() {
    ComplexNotionElementConcept_instance = this;
    var tmp = ComplexNotionElementImpl$_init_$ref_4wvphu();
    OtConceptDescriptor.call(this, 'ComplexNotionElement', VOID, tmp, ComplexNotionElementConcept$_init_$lambda_aud3i2, Companion_instance_94.k6m([BTBNodeConcept_getInstance(), DirectlyNamedConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    var tmp4 = getPropertyCallableRef('elementType', 1, tmp_1, ComplexNotionElement$_get_elementType_$ref_czuq0z_0(), null);
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    var name = 'elementType';
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$0 = new SingleChildLink(getKClass(ComplexNotionElement_1), tmp4);
    tmp_0.ag2_1 = this.o6m(tmp$ret$0, name);
    var tmp_2 = this;
    var tmp_3 = KProperty1;
    tmp_2.bg2_1 = this.r6m(getPropertyCallableRef('unknownValueAllowed', 1, tmp_3, ComplexNotionElement$_get_unknownValueAllowed_$ref_30zrma_0(), null), 'unknownValueAllowed');
    this.cg2_1 = new DomainNodeChildPropertyDescriptor(this.ag2_1.s6i_1);
    this.dg2_1 = new DomainNodePropertyDescriptor(this.bg2_1, toNonNullPersister(NonNullPersisters_getInstance().k25(), new DefaultValueNullPersister(false)));
  }
  var ComplexNotionElementConcept_instance;
  function ComplexNotionElementConcept_getInstance() {
    if (ComplexNotionElementConcept_instance == null)
      new ComplexNotionElementConcept();
    return ComplexNotionElementConcept_instance;
  }
  function ComplexNotionElementValueImpl$_init_$ref_lc9itn() {
    var l = function (p0, p1) {
      return new ComplexNotionElementValueImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function ComplexNotionElementValueConcept$_init_$lambda_jcrty5(context, nodeId) {
    return new TypedComplexNotionElementValueImpl(context, VOID, nodeId);
  }
  function ComplexNotionElementValue$_get_element_$ref_dgdsiu_0() {
    return function (p0) {
      return p0.gfq();
    };
  }
  function ComplexNotionElementValue$_get_value_$ref_kz5f7p_0() {
    return function (p0) {
      return p0.a1();
    };
  }
  function ComplexNotionElementValueConcept() {
    ComplexNotionElementValueConcept_instance = this;
    var tmp = ComplexNotionElementValueImpl$_init_$ref_lc9itn();
    OtConceptDescriptor.call(this, 'ComplexNotionElementValue', VOID, tmp, ComplexNotionElementValueConcept$_init_$lambda_jcrty5, Companion_instance_94.k6m([BTBNodeConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    var tmp4 = getPropertyCallableRef('element', 1, tmp_1, ComplexNotionElementValue$_get_element_$ref_dgdsiu_0(), null);
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.referenceRole' call
    var tag = Companion_getInstance_320().eg2_1;
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var tmp$ret$0 = new ReferenceLink(getKClass(ComplexNotionElementValue_1), tmp4, getKClass(ComplexNotionElement_1), getKClass(QualifiedReferenceContent));
    tmp_0.pg2_1 = this.q6m(tmp$ret$0, tag, 'element');
    var tmp_2 = this;
    var tmp_3 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_0 = getPropertyCallableRef('value', 1, tmp_3, ComplexNotionElementValue$_get_value_$ref_kz5f7p_0(), null);
    var tmp$ret$2 = new SingleChildLink(getKClass(ComplexNotionElementValue_1), this_0);
    tmp_2.qg2_1 = this.o6m(tmp$ret$2, 'value');
    this.rg2_1 = new DomainNodeReferencePropertyDescriptor(this.pg2_1, ReferenceContentPersisters_getInstance().d6m(getKClass(QualifiedReferenceContent)), getKClass(QualifiedReferenceContent));
    this.sg2_1 = new DomainNodeChildPropertyDescriptor(this.qg2_1.s6i_1);
  }
  var ComplexNotionElementValueConcept_instance;
  function ComplexNotionElementValueConcept_getInstance() {
    if (ComplexNotionElementValueConcept_instance == null)
      new ComplexNotionElementValueConcept();
    return ComplexNotionElementValueConcept_instance;
  }
  function ComplexNotionTemplateImpl$_init_$ref_8lopx6() {
    var l = function (p0, p1) {
      return new ComplexNotionTemplateImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function ComplexNotionTemplateConcept$_init_$lambda_6g32aq(context, nodeId) {
    return new TypedComplexNotionTemplateImpl(context, VOID, nodeId);
  }
  function ComplexNotionTemplate$_get_elements_$ref_5kithk_0() {
    return function (p0) {
      return p0.ifq();
    };
  }
  function ComplexNotionTemplateConcept() {
    ComplexNotionTemplateConcept_instance = this;
    var tmp = ComplexNotionTemplateImpl$_init_$ref_8lopx6();
    OtConceptDescriptor.call(this, 'ComplexNotionTemplate', VOID, tmp, ComplexNotionTemplateConcept$_init_$lambda_6g32aq, Companion_instance_94.k6m([BTBNodeConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    var tmp4 = getPropertyCallableRef('elements', 1, tmp_1, ComplexNotionTemplate$_get_elements_$ref_5kithk_0(), null);
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childrenRole' call
    var name = 'elements';
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$0 = new MultipleChildLink(getKClass(ComplexNotionTemplate_1), tmp4);
    tmp_0.dg3_1 = this.p6m(tmp$ret$0, name);
    this.eg3_1 = new DomainNodeChildrenPropertyDescriptor(this.dg3_1.s6i_1);
  }
  var ComplexNotionTemplateConcept_instance;
  function ComplexNotionTemplateConcept_getInstance() {
    if (ComplexNotionTemplateConcept_instance == null)
      new ComplexNotionTemplateConcept();
    return ComplexNotionTemplateConcept_instance;
  }
  function ComplexNotionTemplateElementConcept() {
    ComplexNotionTemplateElementConcept_instance = this;
    OTAbstractConceptDescriptor.call(this, Companion_instance_94.k6m([BTBNodeConcept_getInstance()]));
  }
  var ComplexNotionTemplateElementConcept_instance;
  function ComplexNotionTemplateElementConcept_getInstance() {
    if (ComplexNotionTemplateElementConcept_instance == null)
      new ComplexNotionTemplateElementConcept();
    return ComplexNotionTemplateElementConcept_instance;
  }
  function ComplexNotionTemplatePlaceholderImpl$_init_$ref_k63n8x() {
    var l = function (p0, p1) {
      return new ComplexNotionTemplatePlaceholderImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function ComplexNotionTemplatePlaceholderConcept$_init_$lambda_fr2jg7(context, nodeId) {
    return new TypedComplexNotionTemplatePlaceholderImpl(context, VOID, nodeId);
  }
  function ComplexNotionTemplatePlaceholderConcept() {
    ComplexNotionTemplatePlaceholderConcept_instance = this;
    var tmp = ComplexNotionTemplatePlaceholderImpl$_init_$ref_k63n8x();
    OtConceptDescriptor.call(this, 'ComplexNotionTemplatePlaceholder', VOID, tmp, ComplexNotionTemplatePlaceholderConcept$_init_$lambda_fr2jg7, Companion_instance_94.k6m([ComplexNotionTemplateElementConcept_getInstance()]));
  }
  var ComplexNotionTemplatePlaceholderConcept_instance;
  function ComplexNotionTemplatePlaceholderConcept_getInstance() {
    if (ComplexNotionTemplatePlaceholderConcept_instance == null)
      new ComplexNotionTemplatePlaceholderConcept();
    return ComplexNotionTemplatePlaceholderConcept_instance;
  }
  function ComplexNotionTemplateRefElementImpl$_init_$ref_sz40bn() {
    var l = function (p0, p1) {
      return new ComplexNotionTemplateRefElementImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function ComplexNotionTemplateRefElementConcept$_init_$lambda_8ylqt1(context, nodeId) {
    return new TypedComplexNotionTemplateRefElementImpl(context, VOID, nodeId);
  }
  function ComplexNotionTemplateRefElement$_get_element_$ref_c3f83c_0() {
    return function (p0) {
      return p0.gfq();
    };
  }
  function ComplexNotionTemplateRefElementConcept() {
    ComplexNotionTemplateRefElementConcept_instance = this;
    var tmp = ComplexNotionTemplateRefElementImpl$_init_$ref_sz40bn();
    OtConceptDescriptor.call(this, 'ComplexNotionTemplateRefElement', VOID, tmp, ComplexNotionTemplateRefElementConcept$_init_$lambda_8ylqt1, Companion_instance_94.k6m([ComplexNotionTemplateElementConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    var tmp4 = getPropertyCallableRef('element', 1, tmp_1, ComplexNotionTemplateRefElement$_get_element_$ref_c3f83c_0(), null);
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.referenceRole' call
    var tag = Companion_getInstance_321().fg3_1;
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var tmp$ret$0 = new ReferenceLink(getKClass(ComplexNotionTemplateRefElement_1), tmp4, getKClass(ComplexNotionElement_1), getKClass(LocalReferenceContent));
    tmp_0.qg3_1 = this.q6m(tmp$ret$0, tag, 'element');
    this.rg3_1 = new DomainNodeReferencePropertyDescriptor(this.qg3_1, ReferenceContentPersisters_getInstance().d6m(getKClass(LocalReferenceContent)), getKClass(LocalReferenceContent));
  }
  var ComplexNotionTemplateRefElementConcept_instance;
  function ComplexNotionTemplateRefElementConcept_getInstance() {
    if (ComplexNotionTemplateRefElementConcept_instance == null)
      new ComplexNotionTemplateRefElementConcept();
    return ComplexNotionTemplateRefElementConcept_instance;
  }
  function ComplexNotionTemplateTextElementImpl$_init_$ref_gec3vv() {
    var l = function (p0, p1) {
      return new ComplexNotionTemplateTextElementImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function ComplexNotionTemplateTextElementConcept$_init_$lambda_1emkml(context, nodeId) {
    return new TypedComplexNotionTemplateTextElementImpl(context, VOID, nodeId);
  }
  function ComplexNotionTemplateTextElement$_get_text_$ref_ugb33_0() {
    return function (p0) {
      return p0.o8w();
    };
  }
  function ComplexNotionTemplateTextElementConcept() {
    ComplexNotionTemplateTextElementConcept_instance = this;
    var tmp = ComplexNotionTemplateTextElementImpl$_init_$ref_gec3vv();
    OtConceptDescriptor.call(this, 'ComplexNotionTemplateTextElement', VOID, tmp, ComplexNotionTemplateTextElementConcept$_init_$lambda_1emkml, Companion_instance_94.k6m([ComplexNotionTemplateElementConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    tmp_0.cg4_1 = this.r6m(getPropertyCallableRef('text', 1, tmp_1, ComplexNotionTemplateTextElement$_get_text_$ref_ugb33_0(), null), 'text');
    this.dg4_1 = new DomainNodePropertyDescriptor(this.cg4_1, toNonNullPersister(NonNullPersisters_getInstance().h25(), new DefaultValueNullPersister('')));
  }
  var ComplexNotionTemplateTextElementConcept_instance;
  function ComplexNotionTemplateTextElementConcept_getInstance() {
    if (ComplexNotionTemplateTextElementConcept_instance == null)
      new ComplexNotionTemplateTextElementConcept();
    return ComplexNotionTemplateTextElementConcept_instance;
  }
  function ComplexNotionValueImpl$_init_$ref_g292uf() {
    var l = function (p0, p1) {
      return new ComplexNotionValueImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function ComplexNotionValueConcept$_init_$lambda_hp4yk1(context, nodeId) {
    return new TypedComplexNotionValueImpl(context, VOID, nodeId);
  }
  function ComplexNotionValue$_get_notion_$ref_1p18cj_0() {
    return function (p0) {
      return p0.mfq();
    };
  }
  function ComplexNotionValue$_get_elementValues_$ref_bqs60m_0() {
    return function (p0) {
      return p0.nfq();
    };
  }
  function ComplexNotionValueConcept() {
    ComplexNotionValueConcept_instance = this;
    var tmp = ComplexNotionValueImpl$_init_$ref_g292uf();
    OtConceptDescriptor.call(this, 'ComplexNotionValue', VOID, tmp, ComplexNotionValueConcept$_init_$lambda_hp4yk1, Companion_instance_94.k6m([AbstractValueConcept_getInstance(), FactExpressionConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    var tmp4 = getPropertyCallableRef('notion', 1, tmp_1, ComplexNotionValue$_get_notion_$ref_1p18cj_0(), null);
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.referenceRole' call
    var tag = Companion_getInstance_319().eg4_1;
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var tmp$ret$0 = new ReferenceLink(getKClass(ComplexNotionValue_1), tmp4, getKClass(ComplexNotion_1), getKClass(QualifiedReferenceContent));
    tmp_0.pg4_1 = this.q6m(tmp$ret$0, tag, 'notion');
    var tmp_2 = this;
    var tmp_3 = KProperty1;
    var tmp4_0 = getPropertyCallableRef('elementValues', 1, tmp_3, ComplexNotionValue$_get_elementValues_$ref_bqs60m_0(), null);
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childrenRole' call
    var name = 'elementValues';
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$2 = new MultipleChildLink(getKClass(ComplexNotionValue_1), tmp4_0);
    tmp_2.qg4_1 = this.p6m(tmp$ret$2, name);
    this.rg4_1 = new DomainNodeReferencePropertyDescriptor(this.pg4_1, ReferenceContentPersisters_getInstance().d6m(getKClass(QualifiedReferenceContent)), getKClass(QualifiedReferenceContent));
    this.sg4_1 = new DomainNodeChildrenPropertyDescriptor(this.qg4_1.s6i_1);
  }
  var ComplexNotionValueConcept_instance;
  function ComplexNotionValueConcept_getInstance() {
    if (ComplexNotionValueConcept_instance == null)
      new ComplexNotionValueConcept();
    return ComplexNotionValueConcept_instance;
  }
  function ConstantCustomCellImpl$_init_$ref_4rmnle() {
    var l = function (p0, p1) {
      return new ConstantCustomCellImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function ConstantCustomCellConcept$_init_$lambda_3mzxeu(context, nodeId) {
    return new TypedConstantCustomCellImpl(context, VOID, nodeId);
  }
  function ConstantCustomCell$_get_text_$ref_as957e_0() {
    return function (p0) {
      return p0.o8w();
    };
  }
  function ConstantCustomCellConcept() {
    ConstantCustomCellConcept_instance = this;
    var tmp = ConstantCustomCellImpl$_init_$ref_4rmnle();
    OtConceptDescriptor.call(this, 'ConstantCustomCell', VOID, tmp, ConstantCustomCellConcept$_init_$lambda_3mzxeu, Companion_instance_94.k6m([CustomCellConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    tmp_0.dg5_1 = this.r6m(getPropertyCallableRef('text', 1, tmp_1, ConstantCustomCell$_get_text_$ref_as957e_0(), null), 'text');
    this.eg5_1 = new DomainNodePropertyDescriptor(this.dg5_1, toNonNullPersister(NonNullPersisters_getInstance().h25(), new DefaultValueNullPersister('')));
  }
  var ConstantCustomCellConcept_instance;
  function ConstantCustomCellConcept_getInstance() {
    if (ConstantCustomCellConcept_instance == null)
      new ConstantCustomCellConcept();
    return ConstantCustomCellConcept_instance;
  }
  function ConstantPreconditionImpl$_init_$ref_i7ey2f() {
    var l = function (p0, p1) {
      return new ConstantPreconditionImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function ConstantPreconditionConcept$_init_$lambda_qup7q7(context, nodeId) {
    return new TypedConstantPreconditionImpl(context, VOID, nodeId);
  }
  function ConstantPrecondition$_get_kind_$ref_e7xzm6_0() {
    return function (p0) {
      return p0.r5a();
    };
  }
  function ConstantPreconditionConcept$KIND_PERSISTER$$inlined$enumPersister$1() {
  }
  protoOf(ConstantPreconditionConcept$KIND_PERSISTER$$inlined$enumPersister$1).v24 = function (value) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'jetbrains.ocelot.base.enums.Enums.valueOf' call
      // Inline function 'kotlin.enumValues' call
      var indexedObject = values_12();
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var e = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        if (value === e.toString()) {
          tmp$ret$1 = e;
          break $l$block;
        }
      }
      throw IllegalArgumentException_init_$Create$_0(value);
    }
    return tmp$ret$1;
  };
  protoOf(ConstantPreconditionConcept$KIND_PERSISTER$$inlined$enumPersister$1).fg5 = function (value) {
    return value.toString();
  };
  protoOf(ConstantPreconditionConcept$KIND_PERSISTER$$inlined$enumPersister$1).w24 = function (value) {
    return this.fg5(value instanceof When ? value : THROW_CCE());
  };
  protoOf(ConstantPreconditionConcept$KIND_PERSISTER$$inlined$enumPersister$1).toString = function () {
    return 'enumPersister';
  };
  function ConstantPreconditionConcept$kindPropertyDescriptor$$inlined$enumPersister$1() {
  }
  protoOf(ConstantPreconditionConcept$kindPropertyDescriptor$$inlined$enumPersister$1).v24 = function (value) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'jetbrains.ocelot.base.enums.Enums.valueOf' call
      // Inline function 'kotlin.enumValues' call
      var indexedObject = values_12();
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var e = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        if (value === e.toString()) {
          tmp$ret$1 = e;
          break $l$block;
        }
      }
      throw IllegalArgumentException_init_$Create$_0(value);
    }
    return tmp$ret$1;
  };
  protoOf(ConstantPreconditionConcept$kindPropertyDescriptor$$inlined$enumPersister$1).fg5 = function (value) {
    return value.toString();
  };
  protoOf(ConstantPreconditionConcept$kindPropertyDescriptor$$inlined$enumPersister$1).w24 = function (value) {
    return this.fg5(value instanceof When ? value : THROW_CCE());
  };
  protoOf(ConstantPreconditionConcept$kindPropertyDescriptor$$inlined$enumPersister$1).toString = function () {
    return 'enumPersister';
  };
  function ConstantPreconditionConcept() {
    ConstantPreconditionConcept_instance = this;
    var tmp = ConstantPreconditionImpl$_init_$ref_i7ey2f();
    OtConceptDescriptor.call(this, 'ConstantPrecondition', VOID, tmp, ConstantPreconditionConcept$_init_$lambda_qup7q7, Companion_instance_94.k6m([PreconditionConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    tmp_0.qg5_1 = this.r6m(getPropertyCallableRef('kind', 1, tmp_1, ConstantPrecondition$_get_kind_$ref_e7xzm6_0(), null), 'kind');
    var tmp_2 = this;
    // Inline function 'jetbrains.ocelot.base.persister.NonNullPersisters.enumPersister' call
    NonNullPersisters_getInstance();
    var tmp$ret$0 = new ConstantPreconditionConcept$KIND_PERSISTER$$inlined$enumPersister$1();
    tmp_2.rg5_1 = toNullablePersister(tmp$ret$0);
    var tmp_3 = this;
    // Inline function 'jetbrains.ocelot.base.persister.NonNullPersisters.enumPersister' call
    NonNullPersisters_getInstance();
    var tmp$ret$1 = new ConstantPreconditionConcept$kindPropertyDescriptor$$inlined$enumPersister$1();
    tmp_3.sg5_1 = new DomainNodePropertyDescriptor(this.qg5_1, toNullablePersister(tmp$ret$1));
  }
  var ConstantPreconditionConcept_instance;
  function ConstantPreconditionConcept_getInstance() {
    if (ConstantPreconditionConcept_instance == null)
      new ConstantPreconditionConcept();
    return ConstantPreconditionConcept_instance;
  }
  function ContextImpl$_init_$ref_y1alzq() {
    var l = function (p0, p1) {
      return new ContextImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function ContextConcept$_init_$lambda_sz1t8y(context, nodeId) {
    return new TypedContextImpl(context, VOID, nodeId);
  }
  function Context$_get_library_$ref_4eq8r4_0() {
    return function (p0) {
      return p0.ffq();
    };
  }
  function Context$_get_element_$ref_n7bi27_0() {
    return function (p0) {
      return p0.gfq();
    };
  }
  function ContextConcept() {
    ContextConcept_instance = this;
    var tmp = ContextImpl$_init_$ref_y1alzq();
    OtConceptDescriptor.call(this, 'Context', VOID, tmp, ContextConcept$_init_$lambda_sz1t8y, Companion_instance_94.k6m([BTBNodeConcept_getInstance(), DirectlyNamedConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_0 = getPropertyCallableRef('library', 1, tmp_1, Context$_get_library_$ref_4eq8r4_0(), null);
    var tmp$ret$0 = new SingleChildLink(getKClass(Context_2), this_0);
    tmp_0.dg6_1 = this.o6m(tmp$ret$0, 'library');
    var tmp_2 = this;
    var tmp_3 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_1 = getPropertyCallableRef('element', 1, tmp_3, Context$_get_element_$ref_n7bi27_0(), null);
    var tmp$ret$2 = new SingleChildLink(getKClass(Context_2), this_1);
    tmp_2.eg6_1 = this.o6m(tmp$ret$2, 'element');
    this.fg6_1 = new DomainNodeChildPropertyDescriptor(this.dg6_1.s6i_1);
    this.gg6_1 = new DomainNodeChildPropertyDescriptor(this.eg6_1.s6i_1);
  }
  var ContextConcept_instance;
  function ContextConcept_getInstance() {
    if (ContextConcept_instance == null)
      new ContextConcept();
    return ContextConcept_instance;
  }
  function ContextQueryImpl$_init_$ref_jz0o5w() {
    var l = function (p0, p1) {
      return new ContextQueryImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function ContextQueryConcept$_init_$lambda_o1905g(context, nodeId) {
    return new TypedContextQueryImpl(context, VOID, nodeId);
  }
  function ContextQuery$_get_library_$ref_n5vw3e_0() {
    return function (p0) {
      return p0.ffq();
    };
  }
  function ContextQuery$_get_element_$ref_t2mwkn_0() {
    return function (p0) {
      return p0.gfq();
    };
  }
  function ContextQueryConcept() {
    ContextQueryConcept_instance = this;
    var tmp = ContextQueryImpl$_init_$ref_jz0o5w();
    OtConceptDescriptor.call(this, 'ContextQuery', VOID, tmp, ContextQueryConcept$_init_$lambda_o1905g, Companion_instance_94.k6m([BTBNodeConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_0 = getPropertyCallableRef('library', 1, tmp_1, ContextQuery$_get_library_$ref_n5vw3e_0(), null);
    var tmp$ret$0 = new SingleChildLink(getKClass(ContextQuery_1), this_0);
    tmp_0.rg6_1 = this.o6m(tmp$ret$0, 'library');
    var tmp_2 = this;
    var tmp_3 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_1 = getPropertyCallableRef('element', 1, tmp_3, ContextQuery$_get_element_$ref_t2mwkn_0(), null);
    var tmp$ret$2 = new SingleChildLink(getKClass(ContextQuery_1), this_1);
    tmp_2.sg6_1 = this.o6m(tmp$ret$2, 'element');
    this.tg6_1 = new DomainNodeChildPropertyDescriptor(this.rg6_1.s6i_1);
    this.ug6_1 = new DomainNodeChildPropertyDescriptor(this.sg6_1.s6i_1);
  }
  var ContextQueryConcept_instance;
  function ContextQueryConcept_getInstance() {
    if (ContextQueryConcept_instance == null)
      new ContextQueryConcept();
    return ContextQueryConcept_instance;
  }
  function CustomCellConcept() {
    CustomCellConcept_instance = this;
    OTAbstractConceptDescriptor.call(this, Companion_instance_94.k6m([BTBNodeConcept_getInstance()]));
  }
  var CustomCellConcept_instance;
  function CustomCellConcept_getInstance() {
    if (CustomCellConcept_instance == null)
      new CustomCellConcept();
    return CustomCellConcept_instance;
  }
  function CustomEditorImpl$_init_$ref_7f9dlz() {
    var l = function (p0, p1) {
      return new CustomEditorImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function CustomEditorConcept$_init_$lambda_bashc1(context, nodeId) {
    return new TypedCustomEditorImpl(context, VOID, nodeId);
  }
  function CustomEditor$_get_cells_$ref_phh77b_0() {
    return function (p0) {
      return p0.ofq();
    };
  }
  function CustomEditorConcept() {
    CustomEditorConcept_instance = this;
    var tmp = CustomEditorImpl$_init_$ref_7f9dlz();
    OtConceptDescriptor.call(this, 'CustomEditor', VOID, tmp, CustomEditorConcept$_init_$lambda_bashc1, Companion_instance_94.k6m([BTBNodeConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childrenRole' call
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_0 = getPropertyCallableRef('cells', 1, tmp_1, CustomEditor$_get_cells_$ref_phh77b_0(), null);
    var tmp$ret$0 = new MultipleChildLink(getKClass(CustomEditor), this_0);
    tmp_0.fg7_1 = this.p6m(tmp$ret$0, 'cells');
    this.gg7_1 = new DomainNodeChildrenPropertyDescriptor(this.fg7_1.s6i_1);
  }
  var CustomEditorConcept_instance;
  function CustomEditorConcept_getInstance() {
    if (CustomEditorConcept_instance == null)
      new CustomEditorConcept();
    return CustomEditorConcept_instance;
  }
  function DeclarationNameCustomCellImpl$_init_$ref_djfdar() {
    var l = function (p0, p1) {
      return new DeclarationNameCustomCellImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function DeclarationNameCustomCellConcept$_init_$lambda_83cu4l(context, nodeId) {
    return new TypedDeclarationNameCustomCellImpl(context, VOID, nodeId);
  }
  function DeclarationNameCustomCellConcept() {
    DeclarationNameCustomCellConcept_instance = this;
    var tmp = DeclarationNameCustomCellImpl$_init_$ref_djfdar();
    OtConceptDescriptor.call(this, 'DeclarationNameCustomCell', VOID, tmp, DeclarationNameCustomCellConcept$_init_$lambda_83cu4l, Companion_instance_94.k6m([CustomCellConcept_getInstance()]));
  }
  var DeclarationNameCustomCellConcept_instance;
  function DeclarationNameCustomCellConcept_getInstance() {
    if (DeclarationNameCustomCellConcept_instance == null)
      new DeclarationNameCustomCellConcept();
    return DeclarationNameCustomCellConcept_instance;
  }
  function DeclarationValueQueryImpl$_init_$ref_1pv0ic() {
    var l = function (p0, p1) {
      return new DeclarationValueQueryImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function DeclarationValueQueryConcept$_init_$lambda_odg7ys(context, nodeId) {
    return new TypedDeclarationValueQueryImpl(context, VOID, nodeId);
  }
  function DeclarationValueQuery$_get_value_$ref_j2fwpw_0() {
    return function (p0) {
      return p0.a1();
    };
  }
  function DeclarationValueQueryConcept() {
    DeclarationValueQueryConcept_instance = this;
    var tmp = DeclarationValueQueryImpl$_init_$ref_1pv0ic();
    OtConceptDescriptor.call(this, 'DeclarationValueQuery', VOID, tmp, DeclarationValueQueryConcept$_init_$lambda_odg7ys, Companion_instance_94.k6m([AbstractBindingValueQueryConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_0 = getPropertyCallableRef('value', 1, tmp_1, DeclarationValueQuery$_get_value_$ref_j2fwpw_0(), null);
    var tmp$ret$0 = new SingleChildLink(getKClass(DeclarationValueQuery), this_0);
    tmp_0.rg7_1 = this.o6m(tmp$ret$0, 'value');
    this.sg7_1 = new DomainNodeChildPropertyDescriptor(this.rg7_1.s6i_1);
  }
  var DeclarationValueQueryConcept_instance;
  function DeclarationValueQueryConcept_getInstance() {
    if (DeclarationValueQueryConcept_instance == null)
      new DeclarationValueQueryConcept();
    return DeclarationValueQueryConcept_instance;
  }
  function DocumentNodeConcept() {
    DocumentNodeConcept_instance = this;
    OTAbstractConceptDescriptor.call(this, Companion_instance_94.k6m([BTBNodeConcept_getInstance(), DocumentNodeConcept_getInstance_0(), ExternallyNamedConcept_getInstance()]));
  }
  var DocumentNodeConcept_instance;
  function DocumentNodeConcept_getInstance() {
    if (DocumentNodeConcept_instance == null)
      new DocumentNodeConcept();
    return DocumentNodeConcept_instance;
  }
  function EmptyBindingEntryImpl$_init_$ref_vza823() {
    var l = function (p0, p1) {
      return new EmptyBindingEntryImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function EmptyBindingEntryConcept$_init_$lambda_31otr1(context, nodeId) {
    return new TypedEmptyBindingEntryImpl(context, VOID, nodeId);
  }
  function EmptyBindingEntryConcept() {
    EmptyBindingEntryConcept_instance = this;
    var tmp = EmptyBindingEntryImpl$_init_$ref_vza823();
    OtConceptDescriptor.call(this, 'EmptyBindingEntry', VOID, tmp, EmptyBindingEntryConcept$_init_$lambda_31otr1, Companion_instance_94.k6m([AbstractBindingEntryConcept_getInstance()]));
  }
  var EmptyBindingEntryConcept_instance;
  function EmptyBindingEntryConcept_getInstance() {
    if (EmptyBindingEntryConcept_instance == null)
      new EmptyBindingEntryConcept();
    return EmptyBindingEntryConcept_instance;
  }
  function EmptyPropertyLibraryElementImpl$_init_$ref_2qk0gy() {
    var l = function (p0, p1) {
      return new EmptyPropertyLibraryElementImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function EmptyPropertyLibraryElementConcept$_init_$lambda_aq558m(context, nodeId) {
    return new TypedEmptyPropertyLibraryElementImpl(context, VOID, nodeId);
  }
  function EmptyPropertyLibraryElementConcept() {
    EmptyPropertyLibraryElementConcept_instance = this;
    var tmp = EmptyPropertyLibraryElementImpl$_init_$ref_2qk0gy();
    OtConceptDescriptor.call(this, 'EmptyPropertyLibraryElement', VOID, tmp, EmptyPropertyLibraryElementConcept$_init_$lambda_aq558m, Companion_instance_94.k6m([PropertyLibraryElementConcept_getInstance()]));
  }
  var EmptyPropertyLibraryElementConcept_instance;
  function EmptyPropertyLibraryElementConcept_getInstance() {
    if (EmptyPropertyLibraryElementConcept_instance == null)
      new EmptyPropertyLibraryElementConcept();
    return EmptyPropertyLibraryElementConcept_instance;
  }
  function EnumValueImpl$_init_$ref_lxj98r() {
    var l = function (p0, p1) {
      return new EnumValueImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function EnumValueConcept$_init_$lambda_iya7f1(context, nodeId) {
    return new TypedEnumValueImpl(context, VOID, nodeId);
  }
  function EnumValue$_get_constant_$ref_wk6jkm_0() {
    return function (p0) {
      return p0.pfq();
    };
  }
  function EnumValueConcept() {
    EnumValueConcept_instance = this;
    var tmp = EnumValueImpl$_init_$ref_lxj98r();
    OtConceptDescriptor.call(this, 'EnumValue', VOID, tmp, EnumValueConcept$_init_$lambda_iya7f1, Companion_instance_94.k6m([AbstractValueConcept_getInstance(), FactExpressionConcept_getInstance(), AllowedComplexNotionValueConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    var tmp4 = getPropertyCallableRef('constant', 1, tmp_1, EnumValue$_get_constant_$ref_wk6jkm_0(), null);
    var tmp6 = Companion_getInstance_354().tg7_1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.referenceRole' call
    var name = 'constant';
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var tmp$ret$0 = new ReferenceLink(getKClass(EnumValue_1), tmp4, getKClass(EnumerationConstant_1), getKClass(QualifiedReferenceContent));
    tmp_0.eg8_1 = this.q6m(tmp$ret$0, tmp6, name);
    this.fg8_1 = new DomainNodeReferencePropertyDescriptor(this.eg8_1, ReferenceContentPersisters_getInstance().d6m(getKClass(QualifiedReferenceContent)), getKClass(QualifiedReferenceContent));
  }
  var EnumValueConcept_instance;
  function EnumValueConcept_getInstance() {
    if (EnumValueConcept_instance == null)
      new EnumValueConcept();
    return EnumValueConcept_instance;
  }
  function EnumerableNotionImpl$_init_$ref_f21glk() {
    var l = function (p0, p1) {
      return new EnumerableNotionImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function EnumerableNotionConcept$_init_$lambda_vrxgm8(context, nodeId) {
    return new TypedEnumerableNotionImpl(context, VOID, nodeId);
  }
  function EnumerableNotion$_get_constants_$ref_ynx7ue_0() {
    return function (p0) {
      return p0.qfq();
    };
  }
  function EnumerableNotionConcept() {
    EnumerableNotionConcept_instance = this;
    var tmp = EnumerableNotionImpl$_init_$ref_f21glk();
    OtConceptDescriptor.call(this, 'EnumerableNotion', VOID, tmp, EnumerableNotionConcept$_init_$lambda_vrxgm8, Companion_instance_94.k6m([AbstractNotionConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    var tmp4 = getPropertyCallableRef('constants', 1, tmp_1, EnumerableNotion$_get_constants_$ref_ynx7ue_0(), null);
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childrenRole' call
    var name = 'constants';
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$0 = new MultipleChildLink(getKClass(EnumerableNotion_1), tmp4);
    tmp_0.qg8_1 = this.p6m(tmp$ret$0, name);
    this.rg8_1 = new DomainNodeChildrenPropertyDescriptor(this.qg8_1.s6i_1);
  }
  var EnumerableNotionConcept_instance;
  function EnumerableNotionConcept_getInstance() {
    if (EnumerableNotionConcept_instance == null)
      new EnumerableNotionConcept();
    return EnumerableNotionConcept_instance;
  }
  function EnumerationConstantImpl$_init_$ref_egcl4q() {
    var l = function (p0, p1) {
      return new EnumerationConstantImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function EnumerationConstantConcept$_init_$lambda_xi55im(context, nodeId) {
    return new TypedEnumerationConstantImpl(context, VOID, nodeId);
  }
  function EnumerationConstantConcept() {
    EnumerationConstantConcept_instance = this;
    var tmp = EnumerationConstantImpl$_init_$ref_egcl4q();
    OtConceptDescriptor.call(this, 'EnumerationConstant', VOID, tmp, EnumerationConstantConcept$_init_$lambda_xi55im, Companion_instance_94.k6m([BTBNodeConcept_getInstance(), DirectlyNamedConcept_getInstance()]));
  }
  var EnumerationConstantConcept_instance;
  function EnumerationConstantConcept_getInstance() {
    if (EnumerationConstantConcept_instance == null)
      new EnumerationConstantConcept();
    return EnumerationConstantConcept_instance;
  }
  function ExtensionDeclarationImpl$_init_$ref_qxamtm() {
    var l = function (p0, p1) {
      return new ExtensionDeclarationImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function ExtensionDeclarationConcept$_init_$lambda_muywo2(context, nodeId) {
    return new TypedExtensionDeclarationImpl(context, VOID, nodeId);
  }
  function ExtensionDeclaration$_get_fields_$ref_y00c96_0() {
    return function (p0) {
      return p0.rfq();
    };
  }
  function ExtensionDeclaration$_get_type_$ref_2sz2on_0() {
    return function (p0) {
      return p0.sfq();
    };
  }
  function ExtensionDeclarationConcept() {
    ExtensionDeclarationConcept_instance = this;
    var tmp = ExtensionDeclarationImpl$_init_$ref_qxamtm();
    OtConceptDescriptor.call(this, 'ExtensionDeclaraiton', VOID, tmp, ExtensionDeclarationConcept$_init_$lambda_muywo2, Companion_instance_94.k6m([BTBNodeConcept_getInstance(), DirectlyNamedConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childrenRole' call
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_0 = getPropertyCallableRef('fields', 1, tmp_1, ExtensionDeclaration$_get_fields_$ref_y00c96_0(), null);
    var tmp$ret$0 = new MultipleChildLink(getKClass(ExtensionDeclaration_1), this_0);
    tmp_0.cg9_1 = this.p6m(tmp$ret$0, 'fields');
    var tmp_2 = this;
    var tmp_3 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_1 = getPropertyCallableRef('type', 1, tmp_3, ExtensionDeclaration$_get_type_$ref_2sz2on_0(), null);
    var tmp$ret$2 = new SingleChildLink(getKClass(ExtensionDeclaration_1), this_1);
    tmp_2.dg9_1 = this.o6m(tmp$ret$2, 'type');
    this.eg9_1 = new DomainNodeChildrenPropertyDescriptor(this.cg9_1.s6i_1);
    this.fg9_1 = new DomainNodeChildPropertyDescriptor(this.dg9_1.s6i_1);
  }
  var ExtensionDeclarationConcept_instance;
  function ExtensionDeclarationConcept_getInstance() {
    if (ExtensionDeclarationConcept_instance == null)
      new ExtensionDeclarationConcept();
    return ExtensionDeclarationConcept_instance;
  }
  function ExtensionFieldReferenceImpl$_init_$ref_cs8baj() {
    var l = function (p0, p1) {
      return new ExtensionFieldReferenceImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function ExtensionFieldReferenceConcept$_init_$lambda_r4s57x(context, nodeId) {
    return new TypedExtensionFieldReferenceImpl(context, VOID, nodeId);
  }
  function ExtensionFieldReference$_get_field_$ref_4bdhle_0() {
    return function (p0) {
      return p0.tfq();
    };
  }
  function ExtensionFieldReferenceConcept() {
    ExtensionFieldReferenceConcept_instance = this;
    var tmp = ExtensionFieldReferenceImpl$_init_$ref_cs8baj();
    OtConceptDescriptor.call(this, 'ExtensionFieldReference', VOID, tmp, ExtensionFieldReferenceConcept$_init_$lambda_r4s57x, Companion_instance_94.k6m([PartReferenceOperationConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    var tmp4 = getPropertyCallableRef('field', 1, tmp_1, ExtensionFieldReference$_get_field_$ref_4bdhle_0(), null);
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.referenceRole' call
    var tag = Companion_getInstance_325().gg9_1;
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var tmp$ret$0 = new ReferenceLink(getKClass(ExtensionFieldReference_1), tmp4, getKClass(FieldDeclaration_1), getKClass(QualifiedReferenceContent));
    tmp_0.rg9_1 = this.q6m(tmp$ret$0, tag, 'field');
    this.sg9_1 = new DomainNodeReferencePropertyDescriptor(this.rg9_1, ReferenceContentPersisters_getInstance().d6m(getKClass(QualifiedReferenceContent)), getKClass(QualifiedReferenceContent));
  }
  var ExtensionFieldReferenceConcept_instance;
  function ExtensionFieldReferenceConcept_getInstance() {
    if (ExtensionFieldReferenceConcept_instance == null)
      new ExtensionFieldReferenceConcept();
    return ExtensionFieldReferenceConcept_instance;
  }
  function ExtensionLibraryImpl$_init_$ref_sbhjqh() {
    var l = function (p0, p1) {
      return new ExtensionLibraryImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function ExtensionLibraryConcept$_init_$lambda_5ea0xr(context, nodeId) {
    return new TypedExtensionLibraryImpl(context, VOID, nodeId);
  }
  function ExtensionLibrary$_get_extensions_$ref_a2rnfy_0() {
    return function (p0) {
      return p0.ue2();
    };
  }
  function ExtensionLibraryConcept() {
    ExtensionLibraryConcept_instance = this;
    var tmp = ExtensionLibraryImpl$_init_$ref_sbhjqh();
    OtConceptDescriptor.call(this, 'ExtensionLibrary', VOID, tmp, ExtensionLibraryConcept$_init_$lambda_5ea0xr, Companion_instance_94.k6m([DocumentNodeConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    var tmp4 = getPropertyCallableRef('extensions', 1, tmp_1, ExtensionLibrary$_get_extensions_$ref_a2rnfy_0(), null);
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childrenRole' call
    var name = 'extensions';
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$0 = new MultipleChildLink(getKClass(ExtensionLibrary_1), tmp4);
    tmp_0.dga_1 = this.p6m(tmp$ret$0, name);
    this.ega_1 = new DomainNodeChildrenPropertyDescriptor(this.dga_1.s6i_1);
  }
  var ExtensionLibraryConcept_instance;
  function ExtensionLibraryConcept_getInstance() {
    if (ExtensionLibraryConcept_instance == null)
      new ExtensionLibraryConcept();
    return ExtensionLibraryConcept_instance;
  }
  function ExternallyNamedConcept() {
    ExternallyNamedConcept_instance = this;
    OTAbstractConceptDescriptor.call(this, Companion_instance_94.k6m([DirectlyNamedConcept_getInstance()]));
  }
  var ExternallyNamedConcept_instance;
  function ExternallyNamedConcept_getInstance() {
    if (ExternallyNamedConcept_instance == null)
      new ExternallyNamedConcept();
    return ExternallyNamedConcept_instance;
  }
  function FactImpl$_init_$ref_pt6bbb() {
    var l = function (p0, p1) {
      return new FactImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function FactConcept$_init_$lambda_a59cr5(context, nodeId) {
    return new TypedFactImpl(context, VOID, nodeId);
  }
  function Fact$_get_precondition_$ref_4fc0ee_0() {
    return function (p0) {
      return p0.ufq();
    };
  }
  function Fact$_get_specification_$ref_jrnjv_0() {
    return function (p0) {
      return p0.vfq();
    };
  }
  function FactConcept() {
    FactConcept_instance = this;
    var tmp = FactImpl$_init_$ref_pt6bbb();
    OtConceptDescriptor.call(this, 'Fact', VOID, tmp, FactConcept$_init_$lambda_a59cr5, Companion_instance_94.k6m([BTBNodeConcept_getInstance(), DirectlyNamedConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    var tmp4 = getPropertyCallableRef('precondition', 1, tmp_1, Fact$_get_precondition_$ref_4fc0ee_0(), null);
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    var name = 'precondition';
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$0 = new SingleChildLink(getKClass(Fact_1), tmp4);
    tmp_0.pga_1 = this.o6m(tmp$ret$0, name);
    var tmp_2 = this;
    var tmp_3 = KProperty1;
    var tmp4_0 = getPropertyCallableRef('specification', 1, tmp_3, Fact$_get_specification_$ref_jrnjv_0(), null);
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    var name_0 = 'specification';
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$2 = new SingleChildLink(getKClass(Fact_1), tmp4_0);
    tmp_2.qga_1 = this.o6m(tmp$ret$2, name_0);
    this.rga_1 = new DomainNodeChildPropertyDescriptor(this.pga_1.s6i_1);
    this.sga_1 = new DomainNodeChildPropertyDescriptor(this.qga_1.s6i_1);
  }
  var FactConcept_instance;
  function FactConcept_getInstance() {
    if (FactConcept_instance == null)
      new FactConcept();
    return FactConcept_instance;
  }
  function FactExpressionConcept() {
    FactExpressionConcept_instance = this;
    OTAbstractConceptDescriptor.call(this, Companion_instance_94.k6m([FactExpressionPlaceholderConcept_getInstance()]));
  }
  var FactExpressionConcept_instance;
  function FactExpressionConcept_getInstance() {
    if (FactExpressionConcept_instance == null)
      new FactExpressionConcept();
    return FactExpressionConcept_instance;
  }
  function FactExpressionPlaceholderImpl$_init_$ref_hsnuwa() {
    var l = function (p0, p1) {
      return new FactExpressionPlaceholderImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function FactExpressionPlaceholderConcept$_init_$lambda_ihskha(context, nodeId) {
    return new TypedFactExpressionPlaceholderImpl(context, VOID, nodeId);
  }
  function FactExpressionPlaceholderConcept() {
    FactExpressionPlaceholderConcept_instance = this;
    var tmp = FactExpressionPlaceholderImpl$_init_$ref_hsnuwa();
    OtConceptDescriptor.call(this, 'FactExpressionPlaceholder', VOID, tmp, FactExpressionPlaceholderConcept$_init_$lambda_ihskha, Companion_instance_94.k6m([BTBNodeConcept_getInstance()]));
  }
  var FactExpressionPlaceholderConcept_instance;
  function FactExpressionPlaceholderConcept_getInstance() {
    if (FactExpressionPlaceholderConcept_instance == null)
      new FactExpressionPlaceholderConcept();
    return FactExpressionPlaceholderConcept_instance;
  }
  function FactPreconditionImpl$_init_$ref_wo6ain() {
    var l = function (p0, p1) {
      return new FactPreconditionImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function FactPreconditionConcept$_init_$lambda_d85w9(context, nodeId) {
    return new TypedFactPreconditionImpl(context, VOID, nodeId);
  }
  function FactPrecondition$_get_facts_$ref_m1xslj_0() {
    return function (p0) {
      return p0.wfq();
    };
  }
  function FactPrecondition$_get_relation_$ref_m111b2_0() {
    return function (p0) {
      return p0.xfq();
    };
  }
  function FactPreconditionConcept() {
    FactPreconditionConcept_instance = this;
    var tmp = FactPreconditionImpl$_init_$ref_wo6ain();
    OtConceptDescriptor.call(this, 'FactPrecondition', VOID, tmp, FactPreconditionConcept$_init_$lambda_d85w9, Companion_instance_94.k6m([PreconditionConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childrenRole' call
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_0 = getPropertyCallableRef('facts', 1, tmp_1, FactPrecondition$_get_facts_$ref_m1xslj_0(), null);
    var tmp$ret$0 = new MultipleChildLink(getKClass(FactPrecondition_1), this_0);
    tmp_0.dgb_1 = this.p6m(tmp$ret$0, 'factRef');
    var tmp_2 = this;
    var tmp_3 = KProperty1;
    var tmp4 = getPropertyCallableRef('relation', 1, tmp_3, FactPrecondition$_get_relation_$ref_m111b2_0(), null);
    var tmp6 = Companion_getInstance_314().hgb_1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.referenceRole' call
    var name = 'relation';
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var tmp$ret$2 = new ReferenceLink(getKClass(FactPrecondition_1), tmp4, getKClass(ProcessRelationDeclaration_1), getKClass(QualifiedReferenceContent));
    tmp_2.egb_1 = this.q6m(tmp$ret$2, tmp6, name);
    this.fgb_1 = new DomainNodeChildrenPropertyDescriptor(this.dgb_1.s6i_1);
    this.ggb_1 = new DomainNodeReferencePropertyDescriptor(this.egb_1, ReferenceContentPersisters_getInstance().d6m(getKClass(QualifiedReferenceContent)), getKClass(QualifiedReferenceContent));
  }
  var FactPreconditionConcept_instance;
  function FactPreconditionConcept_getInstance() {
    if (FactPreconditionConcept_instance == null)
      new FactPreconditionConcept();
    return FactPreconditionConcept_instance;
  }
  function FactReferenceImpl$_init_$ref_dvtkjq() {
    var l = function (p0, p1) {
      return new FactReferenceImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function FactReferenceConcept$_init_$lambda_z7k4pu(context, nodeId) {
    return new TypedFactReferenceImpl(context, VOID, nodeId);
  }
  function FactReference$_get_ref_$ref_yrgsjs_0() {
    return function (p0) {
      return p0.yfq();
    };
  }
  function FactReferenceConcept() {
    FactReferenceConcept_instance = this;
    var tmp = FactReferenceImpl$_init_$ref_dvtkjq();
    OtConceptDescriptor.call(this, 'FactReference', VOID, tmp, FactReferenceConcept$_init_$lambda_z7k4pu, Companion_instance_94.k6m([BTBNodeConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    var tmp4 = getPropertyCallableRef('ref', 1, tmp_1, FactReference$_get_ref_$ref_yrgsjs_0(), null);
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.referenceRole' call
    var tag = Companion_getInstance_313().igb_1;
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var tmp$ret$0 = new ReferenceLink(getKClass(FactReference_1), tmp4, getKClass(Fact_1), getKClass(LocalReferenceContent));
    tmp_0.tgb_1 = this.q6m(tmp$ret$0, tag, 'fact');
    this.ugb_1 = new DomainNodeReferencePropertyDescriptor(this.tgb_1, ReferenceContentPersisters_getInstance().d6m(getKClass(LocalReferenceContent)), getKClass(LocalReferenceContent));
  }
  var FactReferenceConcept_instance;
  function FactReferenceConcept_getInstance() {
    if (FactReferenceConcept_instance == null)
      new FactReferenceConcept();
    return FactReferenceConcept_instance;
  }
  function FactSetImpl$_init_$ref_s0cjap() {
    var l = function (p0, p1) {
      return new FactSetImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function FactSetConcept$_init_$lambda_1ta36h(context, nodeId) {
    return new TypedFactSetImpl(context, VOID, nodeId);
  }
  function FactSet$_get_factSetId_$ref_vbwuu7_0() {
    return function (p0) {
      return p0.zfq();
    };
  }
  function FactSet$_get_factsContext_$ref_cvizsw_0() {
    return function (p0) {
      return p0.afr();
    };
  }
  function FactSet$_get_contexts_$ref_i2luf8_0() {
    return function (p0) {
      return p0.bfr();
    };
  }
  function FactSet$_get_facts_$ref_jljgph_0() {
    return function (p0) {
      return p0.wfq();
    };
  }
  function FactSet$_get_newFacts_$ref_l1v7cv_0() {
    return function (p0) {
      return p0.cfr();
    };
  }
  function FactSetConcept() {
    FactSetConcept_instance = this;
    var tmp = FactSetImpl$_init_$ref_s0cjap();
    OtConceptDescriptor.call(this, 'FactSet', VOID, tmp, FactSetConcept$_init_$lambda_1ta36h, Companion_instance_94.k6m([BTBNodeConcept_getInstance(), DirectlyNamedConcept_getInstance(), HasKnowledgeSourcesConcept_getInstance(), HasCommentsConcept_getInstance(), HasVariablesConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    tmp_0.fgc_1 = this.r6m(getPropertyCallableRef('factSetId', 1, tmp_1, FactSet$_get_factSetId_$ref_vbwuu7_0(), null), 'factSetId');
    var tmp_2 = this;
    var tmp_3 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_0 = getPropertyCallableRef('factsContext', 1, tmp_3, FactSet$_get_factsContext_$ref_cvizsw_0(), null);
    var tmp$ret$0 = new SingleChildLink(getKClass(FactSet_1), this_0);
    tmp_2.ggc_1 = this.o6m(tmp$ret$0, 'context');
    var tmp_4 = this;
    var tmp_5 = KProperty1;
    var tmp4 = getPropertyCallableRef('contexts', 1, tmp_5, FactSet$_get_contexts_$ref_i2luf8_0(), null);
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childrenRole' call
    var name = 'contexts';
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$2 = new MultipleChildLink(getKClass(FactSet_1), tmp4);
    tmp_4.hgc_1 = this.p6m(tmp$ret$2, name);
    var tmp_6 = this;
    var tmp_7 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childrenRole' call
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_1 = getPropertyCallableRef('facts', 1, tmp_7, FactSet$_get_facts_$ref_jljgph_0(), null);
    var tmp$ret$4 = new MultipleChildLink(getKClass(FactSet_1), this_1);
    tmp_6.igc_1 = this.p6m(tmp$ret$4, 'facts');
    var tmp_8 = this;
    var tmp_9 = KProperty1;
    var tmp4_0 = getPropertyCallableRef('newFacts', 1, tmp_9, FactSet$_get_newFacts_$ref_l1v7cv_0(), null);
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childrenRole' call
    var name_0 = 'newFacts';
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$6 = new MultipleChildLink(getKClass(FactSet_1), tmp4_0);
    tmp_8.jgc_1 = this.p6m(tmp$ret$6, name_0);
    this.kgc_1 = new DomainNodePropertyDescriptor(this.fgc_1, toNonNullPersister(NonNullPersisters_getInstance().h25(), new DefaultValueNullPersister('')));
    this.lgc_1 = new DomainNodeChildPropertyDescriptor(this.ggc_1.s6i_1);
    this.mgc_1 = new DomainNodeChildrenPropertyDescriptor(this.hgc_1.s6i_1);
    this.ngc_1 = new DomainNodeChildrenPropertyDescriptor(this.igc_1.s6i_1);
    this.ogc_1 = new DomainNodeChildrenPropertyDescriptor(this.jgc_1.s6i_1);
  }
  var FactSetConcept_instance;
  function FactSetConcept_getInstance() {
    if (FactSetConcept_instance == null)
      new FactSetConcept();
    return FactSetConcept_instance;
  }
  function FieldDeclarationImpl$_init_$ref_i0tp1h() {
    var l = function (p0, p1) {
      return new FieldDeclarationImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function FieldDeclarationConcept$_init_$lambda_i40rrx(context, nodeId) {
    return new TypedFieldDeclarationImpl(context, VOID, nodeId);
  }
  function FieldDeclaration$_get_type_$ref_bpg0gs_0() {
    return function (p0) {
      return p0.sfq();
    };
  }
  function FieldDeclaration$_get_cardinality_$ref_jc2wge_0() {
    return function (p0) {
      return p0.dfr();
    };
  }
  function FieldDeclarationConcept() {
    FieldDeclarationConcept_instance = this;
    var tmp = FieldDeclarationImpl$_init_$ref_i0tp1h();
    OtConceptDescriptor.call(this, 'FieldDeclaration', VOID, tmp, FieldDeclarationConcept$_init_$lambda_i40rrx, Companion_instance_94.k6m([BTBNodeConcept_getInstance(), DirectlyNamedConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_0 = getPropertyCallableRef('type', 1, tmp_1, FieldDeclaration$_get_type_$ref_bpg0gs_0(), null);
    var tmp$ret$0 = new SingleChildLink(getKClass(FieldDeclaration_1), this_0);
    tmp_0.zgc_1 = this.o6m(tmp$ret$0, 'type');
    var tmp_2 = this;
    var tmp_3 = KProperty1;
    var tmp4 = getPropertyCallableRef('cardinality', 1, tmp_3, FieldDeclaration$_get_cardinality_$ref_jc2wge_0(), null);
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    var name = 'cardinality';
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$2 = new SingleChildLink(getKClass(FieldDeclaration_1), tmp4);
    tmp_2.agd_1 = this.o6m(tmp$ret$2, name);
    this.bgd_1 = new DomainNodeChildPropertyDescriptor(this.zgc_1.s6i_1);
    this.cgd_1 = new DomainNodeChildPropertyDescriptor(this.agd_1.s6i_1);
  }
  var FieldDeclarationConcept_instance;
  function FieldDeclarationConcept_getInstance() {
    if (FieldDeclarationConcept_instance == null)
      new FieldDeclarationConcept();
    return FieldDeclarationConcept_instance;
  }
  function FindConnectionCommandImpl$_init_$ref_aput5d() {
    var l = function (p0, p1) {
      return new FindConnectionCommandImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function FindConnectionCommandConcept$_init_$lambda_qo234n(context, nodeId) {
    return new TypedFindConnectionCommandImpl(context, VOID, nodeId);
  }
  function FindConnectionCommand$_get_contextQuery_$ref_mokctt_0() {
    return function (p0) {
      return p0.efr();
    };
  }
  function FindConnectionCommand$_get_from_$ref_q9ldq8_0() {
    return function (p0) {
      return p0.f4b();
    };
  }
  function FindConnectionCommand$_get_to_$ref_pv3m1b_0() {
    return function (p0) {
      return p0.g4b();
    };
  }
  function FindConnectionCommandConcept() {
    FindConnectionCommandConcept_instance = this;
    var tmp = FindConnectionCommandImpl$_init_$ref_aput5d();
    OtConceptDescriptor.call(this, 'FindConnectionCommand', VOID, tmp, FindConnectionCommandConcept$_init_$lambda_qo234n, Companion_instance_94.k6m([CommandConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_0 = getPropertyCallableRef('contextQuery', 1, tmp_1, FindConnectionCommand$_get_contextQuery_$ref_mokctt_0(), null);
    var tmp$ret$0 = new SingleChildLink(getKClass(FindConnectionCommand_1), this_0);
    tmp_0.ngd_1 = this.o6m(tmp$ret$0, 'context');
    var tmp_2 = this;
    var tmp_3 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_1 = getPropertyCallableRef('from', 1, tmp_3, FindConnectionCommand$_get_from_$ref_q9ldq8_0(), null);
    var tmp$ret$2 = new SingleChildLink(getKClass(FindConnectionCommand_1), this_1);
    tmp_2.ogd_1 = this.o6m(tmp$ret$2, 'from');
    var tmp_4 = this;
    var tmp_5 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_2 = getPropertyCallableRef('to', 1, tmp_5, FindConnectionCommand$_get_to_$ref_pv3m1b_0(), null);
    var tmp$ret$4 = new SingleChildLink(getKClass(FindConnectionCommand_1), this_2);
    tmp_4.pgd_1 = this.o6m(tmp$ret$4, 'to');
    this.qgd_1 = new DomainNodeChildPropertyDescriptor(this.ngd_1.s6i_1);
    this.rgd_1 = new DomainNodeChildPropertyDescriptor(this.ogd_1.s6i_1);
    this.sgd_1 = new DomainNodeChildPropertyDescriptor(this.pgd_1.s6i_1);
  }
  var FindConnectionCommandConcept_instance;
  function FindConnectionCommandConcept_getInstance() {
    if (FindConnectionCommandConcept_instance == null)
      new FindConnectionCommandConcept();
    return FindConnectionCommandConcept_instance;
  }
  function FindNewConnectionCommandImpl$_init_$ref_vg1u7z() {
    var l = function (p0, p1) {
      return new FindNewConnectionCommandImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function FindNewConnectionCommandConcept$_init_$lambda_i0drh3(context, nodeId) {
    return new TypedFindNewConnectionCommandImpl(context, VOID, nodeId);
  }
  function FindNewConnectionCommand$_get_contextQueries_$ref_s8ua7z_0() {
    return function (p0) {
      return p0.ffr();
    };
  }
  function FindNewConnectionCommand$_get_from_$ref_5jecnm_0() {
    return function (p0) {
      return p0.f4b();
    };
  }
  function FindNewConnectionCommand$_get_to_$ref_isfjel_0() {
    return function (p0) {
      return p0.g4b();
    };
  }
  function FindNewConnectionCommandConcept() {
    FindNewConnectionCommandConcept_instance = this;
    var tmp = FindNewConnectionCommandImpl$_init_$ref_vg1u7z();
    OtConceptDescriptor.call(this, 'FindNewConnectionCommand', VOID, tmp, FindNewConnectionCommandConcept$_init_$lambda_i0drh3, Companion_instance_94.k6m([CommandConcept_getInstance(), HasVariablesConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    var tmp4 = getPropertyCallableRef('contextQueries', 1, tmp_1, FindNewConnectionCommand$_get_contextQueries_$ref_s8ua7z_0(), null);
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childrenRole' call
    var name = 'contextQueries';
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$0 = new MultipleChildLink(getKClass(FindNewConnectionCommand_1), tmp4);
    tmp_0.dge_1 = this.p6m(tmp$ret$0, name);
    var tmp_2 = this;
    var tmp_3 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_0 = getPropertyCallableRef('from', 1, tmp_3, FindNewConnectionCommand$_get_from_$ref_5jecnm_0(), null);
    var tmp$ret$2 = new SingleChildLink(getKClass(FindNewConnectionCommand_1), this_0);
    tmp_2.ege_1 = this.o6m(tmp$ret$2, 'from');
    var tmp_4 = this;
    var tmp_5 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_1 = getPropertyCallableRef('to', 1, tmp_5, FindNewConnectionCommand$_get_to_$ref_isfjel_0(), null);
    var tmp$ret$4 = new SingleChildLink(getKClass(FindNewConnectionCommand_1), this_1);
    tmp_4.fge_1 = this.o6m(tmp$ret$4, 'to');
    this.gge_1 = new DomainNodeChildrenPropertyDescriptor(this.dge_1.s6i_1);
    this.hge_1 = new DomainNodeChildPropertyDescriptor(this.ege_1.s6i_1);
    this.ige_1 = new DomainNodeChildPropertyDescriptor(this.fge_1.s6i_1);
  }
  var FindNewConnectionCommandConcept_instance;
  function FindNewConnectionCommandConcept_getInstance() {
    if (FindNewConnectionCommandConcept_instance == null)
      new FindNewConnectionCommandConcept();
    return FindNewConnectionCommandConcept_instance;
  }
  function FunctionDeclarationImpl$_init_$ref_7dy8pv() {
    var l = function (p0, p1) {
      return new FunctionDeclarationImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function FunctionDeclarationConcept$_init_$lambda_fmiqbf(context, nodeId) {
    return new TypedFunctionDeclarationImpl(context, VOID, nodeId);
  }
  function FunctionDeclaration$_get_returnType_$ref_ypk7g2_0() {
    return function (p0) {
      return p0.gfr();
    };
  }
  function FunctionDeclaration$_get_cardinality_$ref_danp80_0() {
    return function (p0) {
      return p0.dfr();
    };
  }
  function FunctionDeclarationConcept() {
    FunctionDeclarationConcept_instance = this;
    var tmp = FunctionDeclarationImpl$_init_$ref_7dy8pv();
    OtConceptDescriptor.call(this, 'FunctionDeclaration', VOID, tmp, FunctionDeclarationConcept$_init_$lambda_fmiqbf, Companion_instance_94.k6m([AbstractBindingDeclarationConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    var tmp4 = getPropertyCallableRef('returnType', 1, tmp_1, FunctionDeclaration$_get_returnType_$ref_ypk7g2_0(), null);
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    var name = 'returnType';
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$0 = new SingleChildLink(getKClass(FunctionDeclaration_1), tmp4);
    tmp_0.tge_1 = this.o6m(tmp$ret$0, name);
    var tmp_2 = this;
    var tmp_3 = KProperty1;
    var tmp4_0 = getPropertyCallableRef('cardinality', 1, tmp_3, FunctionDeclaration$_get_cardinality_$ref_danp80_0(), null);
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    var name_0 = 'cardinality';
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$2 = new SingleChildLink(getKClass(FunctionDeclaration_1), tmp4_0);
    tmp_2.uge_1 = this.o6m(tmp$ret$2, name_0);
    this.vge_1 = new DomainNodeChildPropertyDescriptor(this.tge_1.s6i_1);
    this.wge_1 = new DomainNodeChildPropertyDescriptor(this.uge_1.s6i_1);
  }
  var FunctionDeclarationConcept_instance;
  function FunctionDeclarationConcept_getInstance() {
    if (FunctionDeclarationConcept_instance == null)
      new FunctionDeclarationConcept();
    return FunctionDeclarationConcept_instance;
  }
  function FunctionLibraryImpl$_init_$ref_dz73cu() {
    var l = function (p0, p1) {
      return new FunctionLibraryImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function FunctionLibraryConcept$_init_$lambda_smc1k6(context, nodeId) {
    return new TypedFunctionLibraryImpl(context, VOID, nodeId);
  }
  function FunctionLibrary$_get_functions_$ref_ag5k04_0() {
    return function (p0) {
      return p0.hfr();
    };
  }
  function FunctionLibraryConcept() {
    FunctionLibraryConcept_instance = this;
    var tmp = FunctionLibraryImpl$_init_$ref_dz73cu();
    OtConceptDescriptor.call(this, 'FunctionLibrary', VOID, tmp, FunctionLibraryConcept$_init_$lambda_smc1k6, Companion_instance_94.k6m([DocumentNodeConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    var tmp4 = getPropertyCallableRef('functions', 1, tmp_1, FunctionLibrary$_get_functions_$ref_ag5k04_0(), null);
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childrenRole' call
    var name = 'functions';
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$0 = new MultipleChildLink(getKClass(FunctionLibrary_1), tmp4);
    tmp_0.hgf_1 = this.p6m(tmp$ret$0, name);
    this.igf_1 = new DomainNodeChildrenPropertyDescriptor(this.hgf_1.s6i_1);
  }
  var FunctionLibraryConcept_instance;
  function FunctionLibraryConcept_getInstance() {
    if (FunctionLibraryConcept_instance == null)
      new FunctionLibraryConcept();
    return FunctionLibraryConcept_instance;
  }
  function FunctionTermImpl$_init_$ref_55iiip() {
    var l = function (p0, p1) {
      return new FunctionTermImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function FunctionTermConcept$_init_$lambda_11undl(context, nodeId) {
    return new TypedFunctionTermImpl(context, VOID, nodeId);
  }
  function FunctionTerm$_get_function_$ref_fl3laa_0() {
    return function (p0) {
      return p0.ifr();
    };
  }
  function FunctionTerm$_get_specificator_$ref_6446ni_0() {
    return function (p0) {
      return p0.jfr();
    };
  }
  function FunctionTerm$_get_parameters_$ref_14vbsg_0() {
    return function (p0) {
      return p0.kfr();
    };
  }
  function FunctionTermConcept$SPECIFICATOR_PERSISTER$$inlined$enumPersister$1() {
  }
  protoOf(FunctionTermConcept$SPECIFICATOR_PERSISTER$$inlined$enumPersister$1).v24 = function (value) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'jetbrains.ocelot.base.enums.Enums.valueOf' call
      // Inline function 'kotlin.enumValues' call
      var indexedObject = values_13();
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var e = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        if (value === e.toString()) {
          tmp$ret$1 = e;
          break $l$block;
        }
      }
      throw IllegalArgumentException_init_$Create$_0(value);
    }
    return tmp$ret$1;
  };
  protoOf(FunctionTermConcept$SPECIFICATOR_PERSISTER$$inlined$enumPersister$1).jgf = function (value) {
    return value.toString();
  };
  protoOf(FunctionTermConcept$SPECIFICATOR_PERSISTER$$inlined$enumPersister$1).w24 = function (value) {
    return this.jgf(value instanceof CardinalitySpecificator ? value : THROW_CCE());
  };
  protoOf(FunctionTermConcept$SPECIFICATOR_PERSISTER$$inlined$enumPersister$1).toString = function () {
    return 'enumPersister';
  };
  function FunctionTermConcept$specificatorPropertyDescriptor$$inlined$enumPersister$1() {
  }
  protoOf(FunctionTermConcept$specificatorPropertyDescriptor$$inlined$enumPersister$1).v24 = function (value) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'jetbrains.ocelot.base.enums.Enums.valueOf' call
      // Inline function 'kotlin.enumValues' call
      var indexedObject = values_13();
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var e = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        if (value === e.toString()) {
          tmp$ret$1 = e;
          break $l$block;
        }
      }
      throw IllegalArgumentException_init_$Create$_0(value);
    }
    return tmp$ret$1;
  };
  protoOf(FunctionTermConcept$specificatorPropertyDescriptor$$inlined$enumPersister$1).jgf = function (value) {
    return value.toString();
  };
  protoOf(FunctionTermConcept$specificatorPropertyDescriptor$$inlined$enumPersister$1).w24 = function (value) {
    return this.jgf(value instanceof CardinalitySpecificator ? value : THROW_CCE());
  };
  protoOf(FunctionTermConcept$specificatorPropertyDescriptor$$inlined$enumPersister$1).toString = function () {
    return 'enumPersister';
  };
  function FunctionTermConcept() {
    FunctionTermConcept_instance = this;
    var tmp = FunctionTermImpl$_init_$ref_55iiip();
    OtConceptDescriptor.call(this, 'FunctionTerm', VOID, tmp, FunctionTermConcept$_init_$lambda_11undl, Companion_instance_94.k6m([AbstractValueConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    var tmp4 = getPropertyCallableRef('function', 1, tmp_1, FunctionTerm$_get_function_$ref_fl3laa_0(), null);
    var tmp6 = Companion_getInstance_326().kgf_1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.referenceRole' call
    var name = 'function';
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var tmp$ret$0 = new ReferenceLink(getKClass(FunctionTerm_1), tmp4, getKClass(FunctionDeclaration_1), getKClass(QualifiedReferenceContent));
    tmp_0.vgf_1 = this.q6m(tmp$ret$0, tmp6, name);
    var tmp_2 = this;
    var tmp_3 = KProperty1;
    tmp_2.wgf_1 = this.r6m(getPropertyCallableRef('specificator', 1, tmp_3, FunctionTerm$_get_specificator_$ref_6446ni_0(), null), 'specificator');
    var tmp_4 = this;
    var tmp_5 = KProperty1;
    var tmp4_0 = getPropertyCallableRef('parameters', 1, tmp_5, FunctionTerm$_get_parameters_$ref_14vbsg_0(), null);
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childrenRole' call
    var name_0 = 'parameters';
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$2 = new MultipleChildLink(getKClass(FunctionTerm_1), tmp4_0);
    tmp_4.xgf_1 = this.p6m(tmp$ret$2, name_0);
    var tmp_6 = this;
    // Inline function 'jetbrains.ocelot.base.persister.NonNullPersisters.enumPersister' call
    NonNullPersisters_getInstance();
    var tmp$ret$4 = new FunctionTermConcept$SPECIFICATOR_PERSISTER$$inlined$enumPersister$1();
    tmp_6.ygf_1 = toNonNullPersister(tmp$ret$4);
    this.zgf_1 = new DomainNodeReferencePropertyDescriptor(this.vgf_1, ReferenceContentPersisters_getInstance().d6m(getKClass(QualifiedReferenceContent)), getKClass(QualifiedReferenceContent));
    var tmp_7 = this;
    // Inline function 'jetbrains.ocelot.base.persister.NonNullPersisters.enumPersister' call
    NonNullPersisters_getInstance();
    var tmp$ret$5 = new FunctionTermConcept$specificatorPropertyDescriptor$$inlined$enumPersister$1();
    tmp_7.agg_1 = new DomainNodePropertyDescriptor(this.wgf_1, toNonNullPersister(tmp$ret$5));
    this.bgg_1 = new DomainNodeChildrenPropertyDescriptor(this.xgf_1.s6i_1);
  }
  var FunctionTermConcept_instance;
  function FunctionTermConcept_getInstance() {
    if (FunctionTermConcept_instance == null)
      new FunctionTermConcept();
    return FunctionTermConcept_instance;
  }
  function HasComments$_get_comment_$ref_ob8p9n_0() {
    return function (p0) {
      return p0.lfr();
    };
  }
  function HasCommentsConcept() {
    HasCommentsConcept_instance = this;
    OTAbstractConceptDescriptor.call(this);
    var tmp = this;
    var tmp_0 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_0 = getPropertyCallableRef('comment', 1, tmp_0, HasComments$_get_comment_$ref_ob8p9n_0(), null);
    var tmp$ret$0 = new SingleChildLink(getKClass(HasComments), this_0);
    tmp.igg_1 = this.o6m(tmp$ret$0, 'comment');
    this.jgg_1 = new DomainNodeChildPropertyDescriptor(this.igg_1.s6i_1);
  }
  var HasCommentsConcept_instance;
  function HasCommentsConcept_getInstance() {
    if (HasCommentsConcept_instance == null)
      new HasCommentsConcept();
    return HasCommentsConcept_instance;
  }
  function HasFactExpression$_get_expression_$ref_bmlpmw_0() {
    return function (p0) {
      return p0.mfr();
    };
  }
  function HasFactExpressionConcept() {
    HasFactExpressionConcept_instance = this;
    OTAbstractConceptDescriptor.call(this, Companion_instance_94.k6m([BTBNodeConcept_getInstance()]));
    var tmp = this;
    var tmp_0 = KProperty1;
    var tmp4 = getPropertyCallableRef('expression', 1, tmp_0, HasFactExpression$_get_expression_$ref_bmlpmw_0(), null);
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    var name = 'expression';
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$0 = new SingleChildLink(getKClass(HasFactExpression), tmp4);
    tmp.qgg_1 = this.o6m(tmp$ret$0, name);
    this.rgg_1 = new DomainNodeChildPropertyDescriptor(this.qgg_1.s6i_1);
  }
  var HasFactExpressionConcept_instance;
  function HasFactExpressionConcept_getInstance() {
    if (HasFactExpressionConcept_instance == null)
      new HasFactExpressionConcept();
    return HasFactExpressionConcept_instance;
  }
  function HasKnowledgeSources$_get_sources_$ref_6mibyw_0() {
    return function (p0) {
      return p0.nfr();
    };
  }
  function HasKnowledgeSourcesConcept() {
    HasKnowledgeSourcesConcept_instance = this;
    OTAbstractConceptDescriptor.call(this, Companion_instance_94.k6m([BTBNodeConcept_getInstance()]));
    var tmp = this;
    var tmp_0 = KProperty1;
    var tmp4 = getPropertyCallableRef('sources', 1, tmp_0, HasKnowledgeSources$_get_sources_$ref_6mibyw_0(), null);
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childrenRole' call
    var name = 'sourceRefs';
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$0 = new MultipleChildLink(getKClass(HasKnowledgeSources), tmp4);
    tmp.ygg_1 = this.p6m(tmp$ret$0, name);
    this.zgg_1 = new DomainNodeChildrenPropertyDescriptor(this.ygg_1.s6i_1);
  }
  var HasKnowledgeSourcesConcept_instance;
  function HasKnowledgeSourcesConcept_getInstance() {
    if (HasKnowledgeSourcesConcept_instance == null)
      new HasKnowledgeSourcesConcept();
    return HasKnowledgeSourcesConcept_instance;
  }
  function HasPropertyConstraints$_get_constraints_$ref_5lfcib_0() {
    return function (p0) {
      return p0.ofr();
    };
  }
  function HasPropertyConstraintsConcept() {
    HasPropertyConstraintsConcept_instance = this;
    OTAbstractConceptDescriptor.call(this, Companion_instance_94.k6m([BTBNodeConcept_getInstance()]));
    var tmp = this;
    var tmp_0 = KProperty1;
    var tmp4 = getPropertyCallableRef('constraints', 1, tmp_0, HasPropertyConstraints$_get_constraints_$ref_5lfcib_0(), null);
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childrenRole' call
    var name = 'constraints';
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$0 = new MultipleChildLink(getKClass(HasPropertyConstraints), tmp4);
    tmp.ggh_1 = this.p6m(tmp$ret$0, name);
    this.hgh_1 = new DomainNodeChildrenPropertyDescriptor(this.ggh_1.s6i_1);
  }
  var HasPropertyConstraintsConcept_instance;
  function HasPropertyConstraintsConcept_getInstance() {
    if (HasPropertyConstraintsConcept_instance == null)
      new HasPropertyConstraintsConcept();
    return HasPropertyConstraintsConcept_instance;
  }
  function HasQueryLabels$_get_noEntry_$ref_215uy0_0() {
    return function (p0) {
      return p0.pfr();
    };
  }
  function HasQueryLabels$_get_noExit_$ref_pxrte_0() {
    return function (p0) {
      return p0.qfr();
    };
  }
  function HasQueryLabelsConcept() {
    HasQueryLabelsConcept_instance = this;
    OTAbstractConceptDescriptor.call(this, Companion_instance_94.k6m([BTBNodeConcept_getInstance()]));
    var tmp = this;
    var tmp_0 = KProperty1;
    tmp.ogh_1 = this.r6m(getPropertyCallableRef('noEntry', 1, tmp_0, HasQueryLabels$_get_noEntry_$ref_215uy0_0(), null), 'noEntry');
    var tmp_1 = this;
    var tmp_2 = KProperty1;
    tmp_1.pgh_1 = this.r6m(getPropertyCallableRef('noExit', 1, tmp_2, HasQueryLabels$_get_noExit_$ref_pxrte_0(), null), 'noExit');
    this.qgh_1 = new DomainNodePropertyDescriptor(this.ogh_1, toNonNullPersister(NonNullPersisters_getInstance().k25(), new DefaultValueNullPersister(false)));
    this.rgh_1 = new DomainNodePropertyDescriptor(this.pgh_1, toNonNullPersister(NonNullPersisters_getInstance().k25(), new DefaultValueNullPersister(false)));
  }
  var HasQueryLabelsConcept_instance;
  function HasQueryLabelsConcept_getInstance() {
    if (HasQueryLabelsConcept_instance == null)
      new HasQueryLabelsConcept();
    return HasQueryLabelsConcept_instance;
  }
  function HasVariables$_get_variables_$ref_6jdr2_0() {
    return function (p0) {
      return p0.rfr();
    };
  }
  function HasVariablesConcept() {
    HasVariablesConcept_instance = this;
    OTAbstractConceptDescriptor.call(this, Companion_instance_94.k6m([BTBNodeConcept_getInstance()]));
    var tmp = this;
    var tmp_0 = KProperty1;
    var tmp4 = getPropertyCallableRef('variables', 1, tmp_0, HasVariables$_get_variables_$ref_6jdr2_0(), null);
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childrenRole' call
    var name = 'variables';
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$0 = new MultipleChildLink(getKClass(HasVariables), tmp4);
    tmp.ygh_1 = this.p6m(tmp$ret$0, name);
    this.zgh_1 = new DomainNodeChildrenPropertyDescriptor(this.ygh_1.s6i_1);
  }
  var HasVariablesConcept_instance;
  function HasVariablesConcept_getInstance() {
    if (HasVariablesConcept_instance == null)
      new HasVariablesConcept();
    return HasVariablesConcept_instance;
  }
  function ImportedLinkImpl$_init_$ref_d7f1kp() {
    var l = function (p0, p1) {
      return new ImportedLinkImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function ImportedLinkConcept$_init_$lambda_ik1xup(context, nodeId) {
    return new TypedImportedLinkImpl(context, VOID, nodeId);
  }
  function ImportedLink$_get_declaration_$ref_rf42xs_0() {
    return function (p0) {
      return p0.sfr();
    };
  }
  function ImportedLinkConcept() {
    ImportedLinkConcept_instance = this;
    var tmp = ImportedLinkImpl$_init_$ref_d7f1kp();
    OtConceptDescriptor.call(this, 'ImportedLink', VOID, tmp, ImportedLinkConcept$_init_$lambda_ik1xup, Companion_instance_94.k6m([AbstractLinkConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    var tmp4 = getPropertyCallableRef('declaration', 1, tmp_1, ImportedLink$_get_declaration_$ref_rf42xs_0(), null);
    var tmp6 = Companion_getInstance_330().agi_1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.referenceRole' call
    var name = 'declaration';
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var tmp$ret$0 = new ReferenceLink(getKClass(ImportedLink_1), tmp4, getKClass(LinkDeclaration_1), getKClass(QualifiedReferenceContent));
    tmp_0.lgi_1 = this.q6m(tmp$ret$0, tmp6, name);
    this.mgi_1 = new DomainNodeReferencePropertyDescriptor(this.lgi_1, ReferenceContentPersisters_getInstance().d6m(getKClass(QualifiedReferenceContent)), getKClass(QualifiedReferenceContent));
  }
  var ImportedLinkConcept_instance;
  function ImportedLinkConcept_getInstance() {
    if (ImportedLinkConcept_instance == null)
      new ImportedLinkConcept();
    return ImportedLinkConcept_instance;
  }
  function ImportedPropertyImpl$_init_$ref_42jth0() {
    var l = function (p0, p1) {
      return new ImportedPropertyImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function ImportedPropertyConcept$_init_$lambda_7uoy90(context, nodeId) {
    return new TypedImportedPropertyImpl(context, VOID, nodeId);
  }
  function ImportedProperty$_get_declaration_$ref_692xl1_0() {
    return function (p0) {
      return p0.sfr();
    };
  }
  function ImportedPropertyConcept() {
    ImportedPropertyConcept_instance = this;
    var tmp = ImportedPropertyImpl$_init_$ref_42jth0();
    OtConceptDescriptor.call(this, 'ImportedProperty', VOID, tmp, ImportedPropertyConcept$_init_$lambda_7uoy90, Companion_instance_94.k6m([AbstractPropertyConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    var tmp4 = getPropertyCallableRef('declaration', 1, tmp_1, ImportedProperty$_get_declaration_$ref_692xl1_0(), null);
    var tmp6 = Companion_getInstance_344().ngi_1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.referenceRole' call
    var name = 'declaration';
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var tmp$ret$0 = new ReferenceLink(getKClass(ImportedProperty_1), tmp4, getKClass(PropertyDeclaration_1), getKClass(QualifiedReferenceContent));
    tmp_0.ygi_1 = this.q6m(tmp$ret$0, tmp6, name);
    this.zgi_1 = new DomainNodeReferencePropertyDescriptor(this.ygi_1, ReferenceContentPersisters_getInstance().d6m(getKClass(QualifiedReferenceContent)), getKClass(QualifiedReferenceContent));
  }
  var ImportedPropertyConcept_instance;
  function ImportedPropertyConcept_getInstance() {
    if (ImportedPropertyConcept_instance == null)
      new ImportedPropertyConcept();
    return ImportedPropertyConcept_instance;
  }
  function InheritedProcessPropertyImpl$_init_$ref_xgd4jp() {
    var l = function (p0, p1) {
      return new InheritedProcessPropertyImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function InheritedProcessPropertyConcept$_init_$lambda_r1r55f(context, nodeId) {
    return new TypedInheritedProcessPropertyImpl(context, VOID, nodeId);
  }
  function InheritedProcessProperty$_get_type_$ref_7uh7x6_0() {
    return function (p0) {
      return p0.sfq();
    };
  }
  function InheritedProcessProperty$_get_default_$ref_c5hrt1_0() {
    return function (p0) {
      return p0.g3b();
    };
  }
  function InheritedProcessProperty$_get_inheritedFrom_$ref_gkccsi_0() {
    return function (p0) {
      return p0.tfr();
    };
  }
  function InheritedProcessPropertyConcept() {
    InheritedProcessPropertyConcept_instance = this;
    var tmp = InheritedProcessPropertyImpl$_init_$ref_xgd4jp();
    OtConceptDescriptor.call(this, 'InheritedProcessProperty', VOID, tmp, InheritedProcessPropertyConcept$_init_$lambda_r1r55f, Companion_instance_94.k6m([BTBNodeConcept_getInstance(), DirectlyNamedConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_0 = getPropertyCallableRef('type', 1, tmp_1, InheritedProcessProperty$_get_type_$ref_7uh7x6_0(), null);
    var tmp$ret$0 = new SingleChildLink(getKClass(InheritedProcessProperty), this_0);
    tmp_0.kgj_1 = this.o6m(tmp$ret$0, 'type');
    var tmp_2 = this;
    var tmp_3 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_1 = getPropertyCallableRef('default', 1, tmp_3, InheritedProcessProperty$_get_default_$ref_c5hrt1_0(), null);
    var tmp$ret$2 = new SingleChildLink(getKClass(InheritedProcessProperty), this_1);
    tmp_2.lgj_1 = this.o6m(tmp$ret$2, 'default');
    var tmp_4 = this;
    var tmp_5 = KProperty1;
    var tmp4 = getPropertyCallableRef('inheritedFrom', 1, tmp_5, InheritedProcessProperty$_get_inheritedFrom_$ref_gkccsi_0(), null);
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    var name = 'inheritedFrom';
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$4 = new SingleChildLink(getKClass(InheritedProcessProperty), tmp4);
    tmp_4.mgj_1 = this.o6m(tmp$ret$4, name);
    this.ngj_1 = new DomainNodeChildPropertyDescriptor(this.kgj_1.s6i_1);
    this.ogj_1 = new DomainNodeChildPropertyDescriptor(this.lgj_1.s6i_1);
    this.pgj_1 = new DomainNodeChildPropertyDescriptor(this.mgj_1.s6i_1);
  }
  var InheritedProcessPropertyConcept_instance;
  function InheritedProcessPropertyConcept_getInstance() {
    if (InheritedProcessPropertyConcept_instance == null)
      new InheritedProcessPropertyConcept();
    return InheritedProcessPropertyConcept_instance;
  }
  function InstanceRelationDeclarationImpl$_init_$ref_xyg2f0() {
    var l = function (p0, p1) {
      return new InstanceRelationDeclarationImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function InstanceRelationDeclarationConcept$_init_$lambda_9076uk(context, nodeId) {
    return new TypedInstanceRelationDeclarationImpl(context, VOID, nodeId);
  }
  function InstanceRelationDeclaration$_get_domain_$ref_oqqnwx_0() {
    return function (p0) {
      return p0.ufr();
    };
  }
  function InstanceRelationDeclaration$_get_range_$ref_6vz34o_0() {
    return function (p0) {
      return p0.hd();
    };
  }
  function InstanceRelationDeclarationConcept() {
    InstanceRelationDeclarationConcept_instance = this;
    var tmp = InstanceRelationDeclarationImpl$_init_$ref_xyg2f0();
    OtConceptDescriptor.call(this, 'InstanceRelationDeclaration', VOID, tmp, InstanceRelationDeclarationConcept$_init_$lambda_9076uk, Companion_instance_94.k6m([BTBNodeConcept_getInstance(), DirectlyNamedConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_0 = getPropertyCallableRef('domain', 1, tmp_1, InstanceRelationDeclaration$_get_domain_$ref_oqqnwx_0(), null);
    var tmp$ret$0 = new SingleChildLink(getKClass(InstanceRelationDeclaration), this_0);
    tmp_0.agk_1 = this.o6m(tmp$ret$0, 'domain');
    var tmp_2 = this;
    var tmp_3 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_1 = getPropertyCallableRef('range', 1, tmp_3, InstanceRelationDeclaration$_get_range_$ref_6vz34o_0(), null);
    var tmp$ret$2 = new SingleChildLink(getKClass(InstanceRelationDeclaration), this_1);
    tmp_2.bgk_1 = this.o6m(tmp$ret$2, 'range');
    this.cgk_1 = new DomainNodeChildPropertyDescriptor(this.agk_1.s6i_1);
    this.dgk_1 = new DomainNodeChildPropertyDescriptor(this.bgk_1.s6i_1);
  }
  var InstanceRelationDeclarationConcept_instance;
  function InstanceRelationDeclarationConcept_getInstance() {
    if (InstanceRelationDeclarationConcept_instance == null)
      new InstanceRelationDeclarationConcept();
    return InstanceRelationDeclarationConcept_instance;
  }
  function InstanceRelationValueImpl$_init_$ref_phql7() {
    var l = function (p0, p1) {
      return new InstanceRelationValueImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function InstanceRelationValueConcept$_init_$lambda_q9ihml(context, nodeId) {
    return new TypedInstanceRelationValueImpl(context, VOID, nodeId);
  }
  function InstanceRelationValue$_get_value_$ref_n9b6s5_0() {
    return function (p0) {
      return p0.a1();
    };
  }
  function InstanceRelationValue$_get_relation_$ref_1y8jwi_0() {
    return function (p0) {
      return p0.xfq();
    };
  }
  function InstanceRelationValueConcept() {
    InstanceRelationValueConcept_instance = this;
    var tmp = InstanceRelationValueImpl$_init_$ref_phql7();
    OtConceptDescriptor.call(this, 'InstanceRelationReferenceValue', VOID, tmp, InstanceRelationValueConcept$_init_$lambda_q9ihml, Companion_instance_94.k6m([InstanceRelationValuePlaceholderConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_0 = getPropertyCallableRef('value', 1, tmp_1, InstanceRelationValue$_get_value_$ref_n9b6s5_0(), null);
    var tmp$ret$0 = new SingleChildLink(getKClass(InstanceRelationValue), this_0);
    tmp_0.ogk_1 = this.o6m(tmp$ret$0, 'value');
    var tmp_2 = this;
    var tmp_3 = KProperty1;
    var tmp4 = getPropertyCallableRef('relation', 1, tmp_3, InstanceRelationValue$_get_relation_$ref_1y8jwi_0(), null);
    var tmp6 = Companion_getInstance_350().sgk_1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.referenceRole' call
    var name = 'property';
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var tmp$ret$2 = new ReferenceLink(getKClass(InstanceRelationValue), tmp4, getKClass(InstanceRelationDeclaration), getKClass(QualifiedReferenceContent));
    tmp_2.pgk_1 = this.q6m(tmp$ret$2, tmp6, name);
    this.qgk_1 = new DomainNodeChildPropertyDescriptor(this.ogk_1.s6i_1);
    this.rgk_1 = new DomainNodeReferencePropertyDescriptor(this.pgk_1, ReferenceContentPersisters_getInstance().d6m(getKClass(QualifiedReferenceContent)), getKClass(QualifiedReferenceContent));
  }
  var InstanceRelationValueConcept_instance;
  function InstanceRelationValueConcept_getInstance() {
    if (InstanceRelationValueConcept_instance == null)
      new InstanceRelationValueConcept();
    return InstanceRelationValueConcept_instance;
  }
  function InstanceRelationValuePlaceholderImpl$_init_$ref_y5nbke() {
    var l = function (p0, p1) {
      return new InstanceRelationValuePlaceholderImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function InstanceRelationValuePlaceholderConcept$_init_$lambda_282zd6(context, nodeId) {
    return new TypedInstanceRelationValuePlaceholderImpl(context, VOID, nodeId);
  }
  function InstanceRelationValuePlaceholderConcept() {
    InstanceRelationValuePlaceholderConcept_instance = this;
    var tmp = InstanceRelationValuePlaceholderImpl$_init_$ref_y5nbke();
    OtConceptDescriptor.call(this, 'InstanceRelationValuePlaceholder', VOID, tmp, InstanceRelationValuePlaceholderConcept$_init_$lambda_282zd6, Companion_instance_94.k6m([BTBNodeConcept_getInstance()]));
  }
  var InstanceRelationValuePlaceholderConcept_instance;
  function InstanceRelationValuePlaceholderConcept_getInstance() {
    if (InstanceRelationValuePlaceholderConcept_instance == null)
      new InstanceRelationValuePlaceholderConcept();
    return InstanceRelationValuePlaceholderConcept_instance;
  }
  function IntegerValueImpl$_init_$ref_2pzhma() {
    var l = function (p0, p1) {
      return new IntegerValueImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function IntegerValueConcept$_init_$lambda_bx1qyy(context, nodeId) {
    return new TypedIntegerValueImpl(context, VOID, nodeId);
  }
  function IntegerValue$_get_value_$ref_c1etoe_0() {
    return function (p0) {
      return p0.a1();
    };
  }
  function IntegerValueConcept() {
    IntegerValueConcept_instance = this;
    var tmp = IntegerValueImpl$_init_$ref_2pzhma();
    OtConceptDescriptor.call(this, 'IntegerValue', VOID, tmp, IntegerValueConcept$_init_$lambda_bx1qyy, Companion_instance_94.k6m([AbstractValueConcept_getInstance(), FactExpressionConcept_getInstance(), AllowedComplexNotionValueConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    tmp_0.dgl_1 = this.r6m(getPropertyCallableRef('value', 1, tmp_1, IntegerValue$_get_value_$ref_c1etoe_0(), null), 'value');
    this.egl_1 = new DomainNodePropertyDescriptor(this.dgl_1, toNonNullPersister(NonNullPersisters_getInstance().i25()));
  }
  var IntegerValueConcept_instance;
  function IntegerValueConcept_getInstance() {
    if (IntegerValueConcept_instance == null)
      new IntegerValueConcept();
    return IntegerValueConcept_instance;
  }
  function IsExpressionImpl$_init_$ref_i32f0d() {
    var l = function (p0, p1) {
      return new IsExpressionImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function IsExpressionConcept$_init_$lambda_ox5d3v(context, nodeId) {
    return new TypedIsExpressionImpl(context, VOID, nodeId);
  }
  function IsExpression$_get_subject_$ref_1r93qq_0() {
    return function (p0) {
      return p0.mdy();
    };
  }
  function IsExpression$_get_value_$ref_6as7yl_0() {
    return function (p0) {
      return p0.a1();
    };
  }
  function IsExpressionConcept() {
    IsExpressionConcept_instance = this;
    var tmp = IsExpressionImpl$_init_$ref_i32f0d();
    OtConceptDescriptor.call(this, 'IsExpression', VOID, tmp, IsExpressionConcept$_init_$lambda_ox5d3v, Companion_instance_94.k6m([FactExpressionConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_0 = getPropertyCallableRef('subject', 1, tmp_1, IsExpression$_get_subject_$ref_1r93qq_0(), null);
    var tmp$ret$0 = new SingleChildLink(getKClass(IsExpression_1), this_0);
    tmp_0.pgl_1 = this.o6m(tmp$ret$0, 'left');
    var tmp_2 = this;
    var tmp_3 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_1 = getPropertyCallableRef('value', 1, tmp_3, IsExpression$_get_value_$ref_6as7yl_0(), null);
    var tmp$ret$2 = new SingleChildLink(getKClass(IsExpression_1), this_1);
    tmp_2.qgl_1 = this.o6m(tmp$ret$2, 'right');
    this.rgl_1 = new DomainNodeChildPropertyDescriptor(this.pgl_1.s6i_1);
    this.sgl_1 = new DomainNodeChildPropertyDescriptor(this.qgl_1.s6i_1);
  }
  var IsExpressionConcept_instance;
  function IsExpressionConcept_getInstance() {
    if (IsExpressionConcept_instance == null)
      new IsExpressionConcept();
    return IsExpressionConcept_instance;
  }
  function KindCustomCellImpl$_init_$ref_w6oila() {
    var l = function (p0, p1) {
      return new KindCustomCellImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function KindCustomCellConcept$_init_$lambda_z0ndhm(context, nodeId) {
    return new TypedKindCustomCellImpl(context, VOID, nodeId);
  }
  function KindCustomCellConcept() {
    KindCustomCellConcept_instance = this;
    var tmp = KindCustomCellImpl$_init_$ref_w6oila();
    OtConceptDescriptor.call(this, 'KindCustomCell', VOID, tmp, KindCustomCellConcept$_init_$lambda_z0ndhm, Companion_instance_94.k6m([CustomCellConcept_getInstance()]));
  }
  var KindCustomCellConcept_instance;
  function KindCustomCellConcept_getInstance() {
    if (KindCustomCellConcept_instance == null)
      new KindCustomCellConcept();
    return KindCustomCellConcept_instance;
  }
  function KnowledgeSourceReferenceConcept() {
    KnowledgeSourceReferenceConcept_instance = this;
    OTAbstractConceptDescriptor.call(this, Companion_instance_94.k6m([BTBNodeConcept_getInstance()]));
  }
  var KnowledgeSourceReferenceConcept_instance;
  function KnowledgeSourceReferenceConcept_getInstance() {
    if (KnowledgeSourceReferenceConcept_instance == null)
      new KnowledgeSourceReferenceConcept();
    return KnowledgeSourceReferenceConcept_instance;
  }
  function KnowledgeSourceReferencePlaceholderImpl$_init_$ref_nw1ttw() {
    var l = function (p0, p1) {
      return new KnowledgeSourceReferencePlaceholderImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function KnowledgeSourceReferencePlaceholderConcept$_init_$lambda_tc6yqs(context, nodeId) {
    return new TypedKnowledgeSourceReferencePlaceholderImpl(context, VOID, nodeId);
  }
  function KnowledgeSourceReferencePlaceholderConcept() {
    KnowledgeSourceReferencePlaceholderConcept_instance = this;
    var tmp = KnowledgeSourceReferencePlaceholderImpl$_init_$ref_nw1ttw();
    OtConceptDescriptor.call(this, 'KnowledgeSourcePlaceholder', VOID, tmp, KnowledgeSourceReferencePlaceholderConcept$_init_$lambda_tc6yqs, Companion_instance_94.k6m([KnowledgeSourceReferenceConcept_getInstance()]));
  }
  var KnowledgeSourceReferencePlaceholderConcept_instance;
  function KnowledgeSourceReferencePlaceholderConcept_getInstance() {
    if (KnowledgeSourceReferencePlaceholderConcept_instance == null)
      new KnowledgeSourceReferencePlaceholderConcept();
    return KnowledgeSourceReferencePlaceholderConcept_instance;
  }
  function LibraryItemConcept() {
    LibraryItemConcept_instance = this;
    OTAbstractConceptDescriptor.call(this, Companion_instance_94.k6m([BTBNodeConcept_getInstance()]));
  }
  var LibraryItemConcept_instance;
  function LibraryItemConcept_getInstance() {
    if (LibraryItemConcept_instance == null)
      new LibraryItemConcept();
    return LibraryItemConcept_instance;
  }
  function LibraryItemPlaceholderImpl$_init_$ref_945co0() {
    var l = function (p0, p1) {
      return new LibraryItemPlaceholderImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function LibraryItemPlaceholderConcept$_init_$lambda_63hh6w(context, nodeId) {
    return new TypedLibraryItemPlaceholderImpl(context, VOID, nodeId);
  }
  function LibraryItemPlaceholderConcept() {
    LibraryItemPlaceholderConcept_instance = this;
    var tmp = LibraryItemPlaceholderImpl$_init_$ref_945co0();
    OtConceptDescriptor.call(this, 'PublishedSourcePlaceholder', VOID, tmp, LibraryItemPlaceholderConcept$_init_$lambda_63hh6w, Companion_instance_94.k6m([LibraryItemConcept_getInstance()]));
  }
  var LibraryItemPlaceholderConcept_instance;
  function LibraryItemPlaceholderConcept_getInstance() {
    if (LibraryItemPlaceholderConcept_instance == null)
      new LibraryItemPlaceholderConcept();
    return LibraryItemPlaceholderConcept_instance;
  }
  function LibraryProcessSpecificationImpl$_init_$ref_1nwbze() {
    var l = function (p0, p1) {
      return new LibraryProcessSpecificationImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function LibraryProcessSpecificationConcept$_init_$lambda_ywj102(context, nodeId) {
    return new TypedLibraryProcessSpecificationImpl(context, VOID, nodeId);
  }
  function LibraryProcessSpecification$_get_process_$ref_7klwyk_0() {
    return function (p0) {
      return p0.vfr();
    };
  }
  function LibraryProcessSpecification$_get_parameters_$ref_yticl7_0() {
    return function (p0) {
      return p0.kfr();
    };
  }
  function LibraryProcessSpecificationConcept() {
    LibraryProcessSpecificationConcept_instance = this;
    var tmp = LibraryProcessSpecificationImpl$_init_$ref_1nwbze();
    OtConceptDescriptor.call(this, 'LibraryProcessSpecification', VOID, tmp, LibraryProcessSpecificationConcept$_init_$lambda_ywj102, Companion_instance_94.k6m([AbstractProcessSpecificationConcept_getInstance(), ProcessProviderConcept_getInstance(), FactExpressionConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    var tmp4 = getPropertyCallableRef('process', 1, tmp_1, LibraryProcessSpecification$_get_process_$ref_7klwyk_0(), null);
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.referenceRole' call
    var tag = Companion_getInstance_311().tgl_1;
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var tmp$ret$0 = new ReferenceLink(getKClass(LibraryProcessSpecification_1), tmp4, getKClass(ProcessDeclaration_1), getKClass(QualifiedReferenceContent));
    tmp_0.egm_1 = this.q6m(tmp$ret$0, tag, 'process');
    var tmp_2 = this;
    var tmp_3 = KProperty1;
    var tmp4_0 = getPropertyCallableRef('parameters', 1, tmp_3, LibraryProcessSpecification$_get_parameters_$ref_yticl7_0(), null);
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childrenRole' call
    var name = 'parameters';
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$2 = new MultipleChildLink(getKClass(LibraryProcessSpecification_1), tmp4_0);
    tmp_2.fgm_1 = this.p6m(tmp$ret$2, name);
    this.ggm_1 = new DomainNodeReferencePropertyDescriptor(this.egm_1, ReferenceContentPersisters_getInstance().d6m(getKClass(QualifiedReferenceContent)), getKClass(QualifiedReferenceContent));
    this.hgm_1 = new DomainNodeChildrenPropertyDescriptor(this.fgm_1.s6i_1);
  }
  var LibraryProcessSpecificationConcept_instance;
  function LibraryProcessSpecificationConcept_getInstance() {
    if (LibraryProcessSpecificationConcept_instance == null)
      new LibraryProcessSpecificationConcept();
    return LibraryProcessSpecificationConcept_instance;
  }
  function LibraryProcessSpecificationQueryImpl$_init_$ref_1u06hg() {
    var l = function (p0, p1) {
      return new LibraryProcessSpecificationQueryImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function LibraryProcessSpecificationQueryConcept$_init_$lambda_6ipny4(context, nodeId) {
    return new TypedLibraryProcessSpecificationQueryImpl(context, VOID, nodeId);
  }
  function LibraryProcessSpecificationQuery$_get_process_$ref_2u429m_0() {
    return function (p0) {
      return p0.vfr();
    };
  }
  function LibraryProcessSpecificationQuery$_get_kind_$ref_ulcr75_0() {
    return function (p0) {
      return p0.r5a();
    };
  }
  function LibraryProcessSpecificationQuery$_get_parameters_$ref_6fozj9_0() {
    return function (p0) {
      return p0.kfr();
    };
  }
  function LibraryProcessSpecificationQueryConcept() {
    LibraryProcessSpecificationQueryConcept_instance = this;
    var tmp = LibraryProcessSpecificationQueryImpl$_init_$ref_1u06hg();
    OtConceptDescriptor.call(this, 'LibraryProcessSpecificationQuery', VOID, tmp, LibraryProcessSpecificationQueryConcept$_init_$lambda_6ipny4, Companion_instance_94.k6m([BTBNodeConcept_getInstance(), ProcessProviderConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    var tmp4 = getPropertyCallableRef('process', 1, tmp_1, LibraryProcessSpecificationQuery$_get_process_$ref_2u429m_0(), null);
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.referenceRole' call
    var tag = Companion_getInstance_345().jgm_1;
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var tmp$ret$0 = new ReferenceLink(getKClass(LibraryProcessSpecificationQuery_1), tmp4, getKClass(ProcessDeclaration_1), getKClass(QualifiedReferenceContent));
    tmp_0.ugm_1 = this.q6m(tmp$ret$0, tag, 'process');
    var tmp_2 = this;
    var tmp_3 = KProperty1;
    var tmp4_0 = getPropertyCallableRef('kind', 1, tmp_3, LibraryProcessSpecificationQuery$_get_kind_$ref_ulcr75_0(), null);
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.referenceRole' call
    var tag_0 = Companion_getInstance_345().igm_1;
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var tmp$ret$2 = new ReferenceLink(getKClass(LibraryProcessSpecificationQuery_1), tmp4_0, getKClass(ProcessKind_1), getKClass(QualifiedReferenceContent));
    tmp_2.vgm_1 = this.q6m(tmp$ret$2, tag_0, 'kind');
    var tmp_4 = this;
    var tmp_5 = KProperty1;
    var tmp4_1 = getPropertyCallableRef('parameters', 1, tmp_5, LibraryProcessSpecificationQuery$_get_parameters_$ref_6fozj9_0(), null);
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childrenRole' call
    var name = 'parameters';
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$4 = new MultipleChildLink(getKClass(LibraryProcessSpecificationQuery_1), tmp4_1);
    tmp_4.wgm_1 = this.p6m(tmp$ret$4, name);
    this.xgm_1 = new DomainNodeReferencePropertyDescriptor(this.ugm_1, ReferenceContentPersisters_getInstance().d6m(getKClass(QualifiedReferenceContent)), getKClass(QualifiedReferenceContent));
    this.ygm_1 = new DomainNodeReferencePropertyDescriptor(this.vgm_1, ReferenceContentPersisters_getInstance().d6m(getKClass(QualifiedReferenceContent)), getKClass(QualifiedReferenceContent));
    this.zgm_1 = new DomainNodeChildrenPropertyDescriptor(this.wgm_1.s6i_1);
  }
  var LibraryProcessSpecificationQueryConcept_instance;
  function LibraryProcessSpecificationQueryConcept_getInstance() {
    if (LibraryProcessSpecificationQueryConcept_instance == null)
      new LibraryProcessSpecificationQueryConcept();
    return LibraryProcessSpecificationQueryConcept_instance;
  }
  function LinkCustomCellImpl$_init_$ref_nshxfs() {
    var l = function (p0, p1) {
      return new LinkCustomCellImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function LinkCustomCellConcept$_init_$lambda_q3coc0(context, nodeId) {
    return new TypedLinkCustomCellImpl(context, VOID, nodeId);
  }
  function LinkCustomCell$_get_link_$ref_hxxns9_0() {
    return function (p0) {
      return p0.xa1();
    };
  }
  function LinkCustomCellConcept() {
    LinkCustomCellConcept_instance = this;
    var tmp = LinkCustomCellImpl$_init_$ref_nshxfs();
    OtConceptDescriptor.call(this, 'LinkCustomCell', VOID, tmp, LinkCustomCellConcept$_init_$lambda_q3coc0, Companion_instance_94.k6m([CustomCellConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    var tmp4 = getPropertyCallableRef('link', 1, tmp_1, LinkCustomCell$_get_link_$ref_hxxns9_0(), null);
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.referenceRole' call
    var tag = Companion_getInstance_324().agn_1;
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var tmp$ret$0 = new ReferenceLink(getKClass(LinkCustomCell_1), tmp4, getKClass(AbstractLink), getKClass(QualifiedReferenceContent));
    tmp_0.lgn_1 = this.q6m(tmp$ret$0, tag, 'link');
    this.mgn_1 = new DomainNodeReferencePropertyDescriptor(this.lgn_1, ReferenceContentPersisters_getInstance().d6m(getKClass(QualifiedReferenceContent)), getKClass(QualifiedReferenceContent));
  }
  var LinkCustomCellConcept_instance;
  function LinkCustomCellConcept_getInstance() {
    if (LinkCustomCellConcept_instance == null)
      new LinkCustomCellConcept();
    return LinkCustomCellConcept_instance;
  }
  function LinkDeclarationImpl$_init_$ref_voaim3() {
    var l = function (p0, p1) {
      return new LinkDeclarationImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function LinkDeclarationConcept$_init_$lambda_guw7h9(context, nodeId) {
    return new TypedLinkDeclarationImpl(context, VOID, nodeId);
  }
  function LinkDeclaration$_get_specificator_$ref_gfmbhm_0() {
    return function (p0) {
      return p0.jfr();
    };
  }
  function LinkDeclaration$_get_type_$ref_9mjtus_0() {
    return function (p0) {
      return p0.sfq();
    };
  }
  function LinkDeclarationConcept$SPECIFICATOR_PERSISTER$$inlined$enumPersister$1() {
  }
  protoOf(LinkDeclarationConcept$SPECIFICATOR_PERSISTER$$inlined$enumPersister$1).v24 = function (value) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'jetbrains.ocelot.base.enums.Enums.valueOf' call
      // Inline function 'kotlin.enumValues' call
      var indexedObject = values_14();
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var e = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        if (value === e.toString()) {
          tmp$ret$1 = e;
          break $l$block;
        }
      }
      throw IllegalArgumentException_init_$Create$_0(value);
    }
    return tmp$ret$1;
  };
  protoOf(LinkDeclarationConcept$SPECIFICATOR_PERSISTER$$inlined$enumPersister$1).ngn = function (value) {
    return value.toString();
  };
  protoOf(LinkDeclarationConcept$SPECIFICATOR_PERSISTER$$inlined$enumPersister$1).w24 = function (value) {
    return this.ngn(value instanceof LinkTypeSpecificator ? value : THROW_CCE());
  };
  protoOf(LinkDeclarationConcept$SPECIFICATOR_PERSISTER$$inlined$enumPersister$1).toString = function () {
    return 'enumPersister';
  };
  function LinkDeclarationConcept$specificatorPropertyDescriptor$$inlined$enumPersister$1() {
  }
  protoOf(LinkDeclarationConcept$specificatorPropertyDescriptor$$inlined$enumPersister$1).v24 = function (value) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'jetbrains.ocelot.base.enums.Enums.valueOf' call
      // Inline function 'kotlin.enumValues' call
      var indexedObject = values_14();
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var e = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        if (value === e.toString()) {
          tmp$ret$1 = e;
          break $l$block;
        }
      }
      throw IllegalArgumentException_init_$Create$_0(value);
    }
    return tmp$ret$1;
  };
  protoOf(LinkDeclarationConcept$specificatorPropertyDescriptor$$inlined$enumPersister$1).ngn = function (value) {
    return value.toString();
  };
  protoOf(LinkDeclarationConcept$specificatorPropertyDescriptor$$inlined$enumPersister$1).w24 = function (value) {
    return this.ngn(value instanceof LinkTypeSpecificator ? value : THROW_CCE());
  };
  protoOf(LinkDeclarationConcept$specificatorPropertyDescriptor$$inlined$enumPersister$1).toString = function () {
    return 'enumPersister';
  };
  function LinkDeclarationConcept() {
    LinkDeclarationConcept_instance = this;
    var tmp = LinkDeclarationImpl$_init_$ref_voaim3();
    OtConceptDescriptor.call(this, 'LinkDeclaration', VOID, tmp, LinkDeclarationConcept$_init_$lambda_guw7h9, Companion_instance_94.k6m([BTBNodeConcept_getInstance(), DirectlyNamedConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    tmp_0.ygn_1 = this.r6m(getPropertyCallableRef('specificator', 1, tmp_1, LinkDeclaration$_get_specificator_$ref_gfmbhm_0(), null), 'specificator');
    var tmp_2 = this;
    var tmp_3 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_0 = getPropertyCallableRef('type', 1, tmp_3, LinkDeclaration$_get_type_$ref_9mjtus_0(), null);
    var tmp$ret$0 = new SingleChildLink(getKClass(LinkDeclaration_1), this_0);
    tmp_2.zgn_1 = this.o6m(tmp$ret$0, 'type');
    var tmp_4 = this;
    // Inline function 'jetbrains.ocelot.base.persister.NonNullPersisters.enumPersister' call
    NonNullPersisters_getInstance();
    var tmp$ret$2 = new LinkDeclarationConcept$SPECIFICATOR_PERSISTER$$inlined$enumPersister$1();
    tmp_4.ago_1 = toNullablePersister(tmp$ret$2);
    var tmp_5 = this;
    // Inline function 'jetbrains.ocelot.base.persister.NonNullPersisters.enumPersister' call
    NonNullPersisters_getInstance();
    var tmp$ret$3 = new LinkDeclarationConcept$specificatorPropertyDescriptor$$inlined$enumPersister$1();
    tmp_5.bgo_1 = new DomainNodePropertyDescriptor(this.ygn_1, toNullablePersister(tmp$ret$3));
    this.cgo_1 = new DomainNodeChildPropertyDescriptor(this.zgn_1.s6i_1);
  }
  var LinkDeclarationConcept_instance;
  function LinkDeclarationConcept_getInstance() {
    if (LinkDeclarationConcept_instance == null)
      new LinkDeclarationConcept();
    return LinkDeclarationConcept_instance;
  }
  function LinkLibraryImpl$_init_$ref_3a0qos() {
    var l = function (p0, p1) {
      return new LinkLibraryImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function LinkLibraryConcept$_init_$lambda_7ufdj0(context, nodeId) {
    return new TypedLinkLibraryImpl(context, VOID, nodeId);
  }
  function LinkLibrary$_get_links_$ref_y40czo_0() {
    return function (p0) {
      return p0.wfr();
    };
  }
  function LinkLibraryConcept() {
    LinkLibraryConcept_instance = this;
    var tmp = LinkLibraryImpl$_init_$ref_3a0qos();
    OtConceptDescriptor.call(this, 'LinkLibrary', VOID, tmp, LinkLibraryConcept$_init_$lambda_7ufdj0, Companion_instance_94.k6m([DocumentNodeConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childrenRole' call
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_0 = getPropertyCallableRef('links', 1, tmp_1, LinkLibrary$_get_links_$ref_y40czo_0(), null);
    var tmp$ret$0 = new MultipleChildLink(getKClass(LinkLibrary_1), this_0);
    tmp_0.ngo_1 = this.p6m(tmp$ret$0, 'links');
    this.ogo_1 = new DomainNodeChildrenPropertyDescriptor(this.ngo_1.s6i_1);
  }
  var LinkLibraryConcept_instance;
  function LinkLibraryConcept_getInstance() {
    if (LinkLibraryConcept_instance == null)
      new LinkLibraryConcept();
    return LinkLibraryConcept_instance;
  }
  function LocalOntologyElementReferenceImpl$_init_$ref_kzz15o() {
    var l = function (p0, p1) {
      return new LocalOntologyElementReferenceImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function LocalOntologyElementReferenceConcept$_init_$lambda_iyyozw(context, nodeId) {
    return new TypedLocalOntologyElementReferenceImpl(context, VOID, nodeId);
  }
  function LocalOntologyElementReference$_get_element_$ref_rimyqf_0() {
    return function (p0) {
      return p0.gfq();
    };
  }
  function LocalOntologyElementReferenceConcept() {
    LocalOntologyElementReferenceConcept_instance = this;
    var tmp = LocalOntologyElementReferenceImpl$_init_$ref_kzz15o();
    OtConceptDescriptor.call(this, 'LocalOntologyElementReference', VOID, tmp, LocalOntologyElementReferenceConcept$_init_$lambda_iyyozw, Companion_instance_94.k6m([BTBNodeConcept_getInstance(), OntologyElementReferenceProviderConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    var tmp4 = getPropertyCallableRef('element', 1, tmp_1, LocalOntologyElementReference$_get_element_$ref_rimyqf_0(), null);
    var tmp6 = Companion_getInstance_337().pgo_1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.referenceRole' call
    var name = 'localElement';
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var tmp$ret$0 = new ReferenceLink(getKClass(LocalOntologyElementReference_1), tmp4, getKClass(OntologyElement_1), getKClass(LocalReferenceContent));
    tmp_0.agp_1 = this.q6m(tmp$ret$0, tmp6, name);
    this.bgp_1 = new DomainNodeReferencePropertyDescriptor(this.agp_1, ReferenceContentPersisters_getInstance().d6m(getKClass(LocalReferenceContent)), getKClass(LocalReferenceContent));
  }
  var LocalOntologyElementReferenceConcept_instance;
  function LocalOntologyElementReferenceConcept_getInstance() {
    if (LocalOntologyElementReferenceConcept_instance == null)
      new LocalOntologyElementReferenceConcept();
    return LocalOntologyElementReferenceConcept_instance;
  }
  function MeasurableNotionImpl$_init_$ref_bbltld() {
    var l = function (p0, p1) {
      return new MeasurableNotionImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function MeasurableNotionConcept$_init_$lambda_ocyadj(context, nodeId) {
    return new TypedMeasurableNotionImpl(context, VOID, nodeId);
  }
  function MeasurableNotion$_get_units_$ref_k7fkf7_0() {
    return function (p0) {
      return p0.xfr();
    };
  }
  function MeasurableNotionConcept() {
    MeasurableNotionConcept_instance = this;
    var tmp = MeasurableNotionImpl$_init_$ref_bbltld();
    OtConceptDescriptor.call(this, 'MeasurableNotion', VOID, tmp, MeasurableNotionConcept$_init_$lambda_ocyadj, Companion_instance_94.k6m([AbstractNotionConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childrenRole' call
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_0 = getPropertyCallableRef('units', 1, tmp_1, MeasurableNotion$_get_units_$ref_k7fkf7_0(), null);
    var tmp$ret$0 = new MultipleChildLink(getKClass(MeasurableNotion_1), this_0);
    tmp_0.mgp_1 = this.p6m(tmp$ret$0, 'units');
    this.ngp_1 = new DomainNodeChildrenPropertyDescriptor(this.mgp_1.s6i_1);
  }
  var MeasurableNotionConcept_instance;
  function MeasurableNotionConcept_getInstance() {
    if (MeasurableNotionConcept_instance == null)
      new MeasurableNotionConcept();
    return MeasurableNotionConcept_instance;
  }
  function MeasurableValueImpl$_init_$ref_9xaz7v() {
    var l = function (p0, p1) {
      return new MeasurableValueImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function MeasurableValueConcept$_init_$lambda_4s9b8z(context, nodeId) {
    return new TypedMeasurableValueImpl(context, VOID, nodeId);
  }
  function MeasurableValue$_get_amount_$ref_ornak6_0() {
    return function (p0) {
      return p0.yfr();
    };
  }
  function MeasurableValue$_get_unit_$ref_ez4szu_0() {
    return function (p0) {
      return p0.zfr();
    };
  }
  function MeasurableValueConcept() {
    MeasurableValueConcept_instance = this;
    var tmp = MeasurableValueImpl$_init_$ref_9xaz7v();
    OtConceptDescriptor.call(this, 'MeasurableValue', VOID, tmp, MeasurableValueConcept$_init_$lambda_4s9b8z, Companion_instance_94.k6m([AbstractValueConcept_getInstance(), FactExpressionConcept_getInstance(), AllowedComplexNotionValueConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    tmp_0.ygp_1 = this.r6m(getPropertyCallableRef('amount', 1, tmp_1, MeasurableValue$_get_amount_$ref_ornak6_0(), null), 'amount');
    var tmp_2 = this;
    var tmp_3 = KProperty1;
    var tmp4 = getPropertyCallableRef('unit', 1, tmp_3, MeasurableValue$_get_unit_$ref_ez4szu_0(), null);
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.referenceRole' call
    var tag = Companion_getInstance_353().cgq_1;
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var tmp$ret$0 = new ReferenceLink(getKClass(MeasurableValue_1), tmp4, getKClass(MeasurementUnit_1), getKClass(QualifiedReferenceContent));
    tmp_2.zgp_1 = this.q6m(tmp$ret$0, tag, 'unit');
    this.agq_1 = new DomainNodePropertyDescriptor(this.ygp_1, AttributePersisters_getInstance().m6j_1);
    this.bgq_1 = new DomainNodeReferencePropertyDescriptor(this.zgp_1, ReferenceContentPersisters_getInstance().d6m(getKClass(QualifiedReferenceContent)), getKClass(QualifiedReferenceContent));
  }
  var MeasurableValueConcept_instance;
  function MeasurableValueConcept_getInstance() {
    if (MeasurableValueConcept_instance == null)
      new MeasurableValueConcept();
    return MeasurableValueConcept_instance;
  }
  function MeasurementUnitImpl$_init_$ref_g1fhtx() {
    var l = function (p0, p1) {
      return new MeasurementUnitImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function MeasurementUnitConcept$_init_$lambda_wj7of7(context, nodeId) {
    return new TypedMeasurementUnitImpl(context, VOID, nodeId);
  }
  function MeasurementUnit$_get_main_$ref_qfidtn_0() {
    return function (p0) {
      return p0.afs();
    };
  }
  function MeasurementUnitConcept() {
    MeasurementUnitConcept_instance = this;
    var tmp = MeasurementUnitImpl$_init_$ref_g1fhtx();
    OtConceptDescriptor.call(this, 'MeasurementUnit', VOID, tmp, MeasurementUnitConcept$_init_$lambda_wj7of7, Companion_instance_94.k6m([BTBNodeConcept_getInstance(), DirectlyNamedConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    tmp_0.ngq_1 = this.r6m(getPropertyCallableRef('main', 1, tmp_1, MeasurementUnit$_get_main_$ref_qfidtn_0(), null), 'main');
    this.ogq_1 = new DomainNodePropertyDescriptor(this.ngq_1, toNonNullPersister(NonNullPersisters_getInstance().k25(), new DefaultValueNullPersister(false)));
  }
  var MeasurementUnitConcept_instance;
  function MeasurementUnitConcept_getInstance() {
    if (MeasurementUnitConcept_instance == null)
      new MeasurementUnitConcept();
    return MeasurementUnitConcept_instance;
  }
  function ModifierContainerImpl$_init_$ref_l6cqm3() {
    var l = function (p0, p1) {
      return new ModifierContainerImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function ModifierContainerConcept$_init_$lambda_cl7avn(context, nodeId) {
    return new TypedModifierContainerImpl(context, VOID, nodeId);
  }
  function ModifierContainer$_get_modifiers_$ref_pj92fq_0() {
    return function (p0) {
      return p0.l8j();
    };
  }
  function ModifierContainerConcept() {
    ModifierContainerConcept_instance = this;
    var tmp = ModifierContainerImpl$_init_$ref_l6cqm3();
    OtConceptDescriptor.call(this, 'ModifierContainer', VOID, tmp, ModifierContainerConcept$_init_$lambda_cl7avn, Companion_instance_94.k6m([DocumentNodeConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    var tmp4 = getPropertyCallableRef('modifiers', 1, tmp_1, ModifierContainer$_get_modifiers_$ref_pj92fq_0(), null);
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childrenRole' call
    var name = 'modifiers';
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$0 = new MultipleChildLink(getKClass(ModifierContainer), tmp4);
    tmp_0.zgq_1 = this.p6m(tmp$ret$0, name);
    this.agr_1 = new DomainNodeChildrenPropertyDescriptor(this.zgq_1.s6i_1);
  }
  var ModifierContainerConcept_instance;
  function ModifierContainerConcept_getInstance() {
    if (ModifierContainerConcept_instance == null)
      new ModifierContainerConcept();
    return ModifierContainerConcept_instance;
  }
  function ModifierDeclarationImpl$_init_$ref_vtdlnm() {
    var l = function (p0, p1) {
      return new ModifierDeclarationImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function ModifierDeclarationConcept$_init_$lambda_g8fm12(context, nodeId) {
    return new TypedModifierDeclarationImpl(context, VOID, nodeId);
  }
  function ModifierDeclarationConcept() {
    ModifierDeclarationConcept_instance = this;
    var tmp = ModifierDeclarationImpl$_init_$ref_vtdlnm();
    OtConceptDescriptor.call(this, 'ModifierDeclaration', VOID, tmp, ModifierDeclarationConcept$_init_$lambda_g8fm12, Companion_instance_94.k6m([BTBNodeConcept_getInstance(), DirectlyNamedConcept_getInstance()]));
  }
  var ModifierDeclarationConcept_instance;
  function ModifierDeclarationConcept_getInstance() {
    if (ModifierDeclarationConcept_instance == null)
      new ModifierDeclarationConcept();
    return ModifierDeclarationConcept_instance;
  }
  function ModifierFactExpressionImpl$_init_$ref_g3i7l6() {
    var l = function (p0, p1) {
      return new ModifierFactExpressionImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function ModifierFactExpressionConcept$_init_$lambda_l5rn42(context, nodeId) {
    return new TypedModifierFactExpressionImpl(context, VOID, nodeId);
  }
  function ModifierFactExpression$_get_modifier_$ref_tzyw3w_0() {
    return function (p0) {
      return p0.bfs();
    };
  }
  function ModifierFactExpression$_get_expression_$ref_xrw8dn_0() {
    return function (p0) {
      return p0.mfr();
    };
  }
  function ModifierFactExpressionConcept() {
    ModifierFactExpressionConcept_instance = this;
    var tmp = ModifierFactExpressionImpl$_init_$ref_g3i7l6();
    OtConceptDescriptor.call(this, 'ModifierFactExpression', VOID, tmp, ModifierFactExpressionConcept$_init_$lambda_l5rn42, Companion_instance_94.k6m([FactExpressionConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    var tmp4 = getPropertyCallableRef('modifier', 1, tmp_1, ModifierFactExpression$_get_modifier_$ref_tzyw3w_0(), null);
    var tmp6 = Companion_getInstance_312().bgr_1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.referenceRole' call
    var name = 'modifier';
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var tmp$ret$0 = new ReferenceLink(getKClass(ModifierFactExpression_0), tmp4, getKClass(ModifierDeclaration), getKClass(QualifiedReferenceContent));
    tmp_0.mgr_1 = this.q6m(tmp$ret$0, tmp6, name);
    var tmp_2 = this;
    var tmp_3 = KProperty1;
    var tmp4_0 = getPropertyCallableRef('expression', 1, tmp_3, ModifierFactExpression$_get_expression_$ref_xrw8dn_0(), null);
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    var name_0 = 'expression';
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$2 = new SingleChildLink(getKClass(ModifierFactExpression_0), tmp4_0);
    tmp_2.ngr_1 = this.o6m(tmp$ret$2, name_0);
    this.ogr_1 = new DomainNodeReferencePropertyDescriptor(this.mgr_1, ReferenceContentPersisters_getInstance().d6m(getKClass(QualifiedReferenceContent)), getKClass(QualifiedReferenceContent));
    this.pgr_1 = new DomainNodeChildPropertyDescriptor(this.ngr_1.s6i_1);
  }
  var ModifierFactExpressionConcept_instance;
  function ModifierFactExpressionConcept_getInstance() {
    if (ModifierFactExpressionConcept_instance == null)
      new ModifierFactExpressionConcept();
    return ModifierFactExpressionConcept_instance;
  }
  function MultilineTextImpl$_init_$ref_yept91() {
    var l = function (p0, p1) {
      return new MultilineTextImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function MultilineTextConcept$_init_$lambda_472car(context, nodeId) {
    return new TypedMultilineTextImpl(context, VOID, nodeId);
  }
  function MultilineText$_get_lines_$ref_okds4p_0() {
    return function (p0) {
      return p0.qcv();
    };
  }
  function MultilineTextConcept() {
    MultilineTextConcept_instance = this;
    var tmp = MultilineTextImpl$_init_$ref_yept91();
    OtConceptDescriptor.call(this, 'MultilineText', VOID, tmp, MultilineTextConcept$_init_$lambda_472car, Companion_instance_94.k6m([BTBNodeConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childrenRole' call
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_0 = getPropertyCallableRef('lines', 1, tmp_1, MultilineText$_get_lines_$ref_okds4p_0(), null);
    var tmp$ret$0 = new MultipleChildLink(getKClass(MultilineText), this_0);
    tmp_0.ags_1 = this.p6m(tmp$ret$0, 'lines');
    this.bgs_1 = new DomainNodeChildrenPropertyDescriptor(this.ags_1.s6i_1);
  }
  var MultilineTextConcept_instance;
  function MultilineTextConcept_getInstance() {
    if (MultilineTextConcept_instance == null)
      new MultilineTextConcept();
    return MultilineTextConcept_instance;
  }
  function MultipleProcessPropertyValueRangeImpl$_init_$ref_e13gzp() {
    var l = function (p0, p1) {
      return new MultipleProcessPropertyValueRangeImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function MultipleProcessPropertyValueRangeConcept$_init_$lambda_4f6kwt(context, nodeId) {
    return new TypedMultipleProcessPropertyValueRangeImpl(context, VOID, nodeId);
  }
  function MultipleProcessPropertyValueRange$_get_type_$ref_fp68ik_0() {
    return function (p0) {
      return p0.sfq();
    };
  }
  function MultipleProcessPropertyValueRangeConcept() {
    MultipleProcessPropertyValueRangeConcept_instance = this;
    var tmp = MultipleProcessPropertyValueRangeImpl$_init_$ref_e13gzp();
    OtConceptDescriptor.call(this, 'MultipleProcessPropertyValueRange', VOID, tmp, MultipleProcessPropertyValueRangeConcept$_init_$lambda_4f6kwt, Companion_instance_94.k6m([ProcessPropertyValueRangeConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_0 = getPropertyCallableRef('type', 1, tmp_1, MultipleProcessPropertyValueRange$_get_type_$ref_fp68ik_0(), null);
    var tmp$ret$0 = new SingleChildLink(getKClass(MultipleProcessPropertyValueRange_1), this_0);
    tmp_0.mgs_1 = this.o6m(tmp$ret$0, 'type');
    this.ngs_1 = new DomainNodeChildPropertyDescriptor(this.mgs_1.s6i_1);
  }
  var MultipleProcessPropertyValueRangeConcept_instance;
  function MultipleProcessPropertyValueRangeConcept_getInstance() {
    if (MultipleProcessPropertyValueRangeConcept_instance == null)
      new MultipleProcessPropertyValueRangeConcept();
    return MultipleProcessPropertyValueRangeConcept_instance;
  }
  function MultiplePropertyValueRangeImpl$_init_$ref_og45as() {
    var l = function (p0, p1) {
      return new MultiplePropertyValueRangeImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function MultiplePropertyValueRangeConcept$_init_$lambda_xrm9m4(context, nodeId) {
    return new TypedMultiplePropertyValueRangeImpl(context, VOID, nodeId);
  }
  function MultiplePropertyValueRange$_get_types_$ref_3rqsk4_0() {
    return function (p0) {
      return p0.cfs();
    };
  }
  function MultiplePropertyValueRangeConcept() {
    MultiplePropertyValueRangeConcept_instance = this;
    var tmp = MultiplePropertyValueRangeImpl$_init_$ref_og45as();
    OtConceptDescriptor.call(this, 'MultiplePropertyValueRange', VOID, tmp, MultiplePropertyValueRangeConcept$_init_$lambda_xrm9m4, Companion_instance_94.k6m([PropertyValueRangeConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childrenRole' call
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_0 = getPropertyCallableRef('types', 1, tmp_1, MultiplePropertyValueRange$_get_types_$ref_3rqsk4_0(), null);
    var tmp$ret$0 = new MultipleChildLink(getKClass(MultiplePropertyValueRange_1), this_0);
    tmp_0.ygs_1 = this.p6m(tmp$ret$0, 'types');
    this.zgs_1 = new DomainNodeChildrenPropertyDescriptor(this.ygs_1.s6i_1);
  }
  var MultiplePropertyValueRangeConcept_instance;
  function MultiplePropertyValueRangeConcept_getInstance() {
    if (MultiplePropertyValueRangeConcept_instance == null)
      new MultiplePropertyValueRangeConcept();
    return MultiplePropertyValueRangeConcept_instance;
  }
  function MultipliedExpressionImpl$_init_$ref_oyzeue() {
    var l = function (p0, p1) {
      return new MultipliedExpressionImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function MultipliedExpressionConcept$_init_$lambda_xs4tn2(context, nodeId) {
    return new TypedMultipliedExpressionImpl(context, VOID, nodeId);
  }
  function MultipliedExpression$_get_rawMultiplier_$ref_pej37m_0() {
    return function (p0) {
      return p0.dfs();
    };
  }
  function MultipliedExpression$_get_expression_$ref_l608dh_0() {
    return function (p0) {
      return p0.mfr();
    };
  }
  function MultipliedExpressionConcept() {
    MultipliedExpressionConcept_instance = this;
    var tmp = MultipliedExpressionImpl$_init_$ref_oyzeue();
    OtConceptDescriptor.call(this, 'MultipliedExpression', VOID, tmp, MultipliedExpressionConcept$_init_$lambda_xs4tn2, Companion_instance_94.k6m([FactExpressionConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    tmp_0.kgt_1 = this.r6m(getPropertyCallableRef('rawMultiplier', 1, tmp_1, MultipliedExpression$_get_rawMultiplier_$ref_pej37m_0(), null), 'multiplier');
    var tmp_2 = this;
    var tmp_3 = KProperty1;
    var tmp4 = getPropertyCallableRef('expression', 1, tmp_3, MultipliedExpression$_get_expression_$ref_l608dh_0(), null);
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    var name = 'expression';
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$0 = new SingleChildLink(getKClass(MultipliedExpression_1), tmp4);
    tmp_2.lgt_1 = this.o6m(tmp$ret$0, name);
    this.mgt_1 = new DomainNodePropertyDescriptor(this.kgt_1, toNonNullPersister(NonNullPersisters_getInstance().i25()));
    this.ngt_1 = new DomainNodeChildPropertyDescriptor(this.lgt_1.s6i_1);
  }
  var MultipliedExpressionConcept_instance;
  function MultipliedExpressionConcept_getInstance() {
    if (MultipliedExpressionConcept_instance == null)
      new MultipliedExpressionConcept();
    return MultipliedExpressionConcept_instance;
  }
  function NewFactImpl$_init_$ref_iy80jd() {
    var l = function (p0, p1) {
      return new NewFactImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function NewFactConcept$_init_$lambda_rd31r(context, nodeId) {
    return new TypedNewFactImpl(context, VOID, nodeId);
  }
  function NewFact$_get_expression_$ref_buri7u_0() {
    return function (p0) {
      return p0.mfr();
    };
  }
  function NewFactConcept() {
    NewFactConcept_instance = this;
    var tmp = NewFactImpl$_init_$ref_iy80jd();
    OtConceptDescriptor.call(this, 'NewFact', VOID, tmp, NewFactConcept$_init_$lambda_rd31r, Companion_instance_94.k6m([BTBNodeConcept_getInstance(), DirectlyNamedConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    var tmp4 = getPropertyCallableRef('expression', 1, tmp_1, NewFact$_get_expression_$ref_buri7u_0(), null);
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    var name = 'expression';
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$0 = new SingleChildLink(getKClass(NewFact), tmp4);
    tmp_0.ygt_1 = this.o6m(tmp$ret$0, name);
    this.zgt_1 = new DomainNodeChildPropertyDescriptor(this.ygt_1.s6i_1);
  }
  var NewFactConcept_instance;
  function NewFactConcept_getInstance() {
    if (NewFactConcept_instance == null)
      new NewFactConcept();
    return NewFactConcept_instance;
  }
  function NewFactReferenceImpl$_init_$ref_2k5k92() {
    var l = function (p0, p1) {
      return new NewFactReferenceImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function NewFactReferenceConcept$_init_$lambda_bmulcu(context, nodeId) {
    return new TypedNewFactReferenceImpl(context, VOID, nodeId);
  }
  function NewFactReference$_get_ref_$ref_4jyz94_0() {
    return function (p0) {
      return p0.yfq();
    };
  }
  function NewFactReferenceConcept() {
    NewFactReferenceConcept_instance = this;
    var tmp = NewFactReferenceImpl$_init_$ref_2k5k92();
    OtConceptDescriptor.call(this, 'NewFactReference', VOID, tmp, NewFactReferenceConcept$_init_$lambda_bmulcu, Companion_instance_94.k6m([FactExpressionConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    var tmp4 = getPropertyCallableRef('ref', 1, tmp_1, NewFactReference$_get_ref_$ref_4jyz94_0(), null);
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.referenceRole' call
    var tag = Companion_getInstance_315().agu_1;
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var tmp$ret$0 = new ReferenceLink(getKClass(NewFactReference_0), tmp4, getKClass(NewFact), getKClass(LocalReferenceContent));
    tmp_0.lgu_1 = this.q6m(tmp$ret$0, tag, 'ref');
    this.mgu_1 = new DomainNodeReferencePropertyDescriptor(this.lgu_1, ReferenceContentPersisters_getInstance().d6m(getKClass(LocalReferenceContent)), getKClass(LocalReferenceContent));
  }
  var NewFactReferenceConcept_instance;
  function NewFactReferenceConcept_getInstance() {
    if (NewFactReferenceConcept_instance == null)
      new NewFactReferenceConcept();
    return NewFactReferenceConcept_instance;
  }
  function NoValuesImpl$_init_$ref_ehnszm() {
    var l = function (p0, p1) {
      return new NoValuesImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function NoValuesConcept$_init_$lambda_x3fplm(context, nodeId) {
    return new TypedNoValuesImpl(context, VOID, nodeId);
  }
  function NoValuesConcept() {
    NoValuesConcept_instance = this;
    var tmp = NoValuesImpl$_init_$ref_ehnszm();
    OtConceptDescriptor.call(this, 'NoValues', VOID, tmp, NoValuesConcept$_init_$lambda_x3fplm, Companion_instance_94.k6m([PropertyValueRangeConcept_getInstance()]));
  }
  var NoValuesConcept_instance;
  function NoValuesConcept_getInstance() {
    if (NoValuesConcept_instance == null)
      new NoValuesConcept();
    return NoValuesConcept_instance;
  }
  function NotionLibraryImpl$_init_$ref_mwqjgf() {
    var l = function (p0, p1) {
      return new NotionLibraryImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function NotionLibraryConcept$_init_$lambda_4m94pj(context, nodeId) {
    return new TypedNotionLibraryImpl(context, VOID, nodeId);
  }
  function NotionLibrary$_get_notions_$ref_ejoba4_0() {
    return function (p0) {
      return p0.efs();
    };
  }
  function NotionLibraryConcept() {
    NotionLibraryConcept_instance = this;
    var tmp = NotionLibraryImpl$_init_$ref_mwqjgf();
    OtConceptDescriptor.call(this, 'NotionsLibrary', VOID, tmp, NotionLibraryConcept$_init_$lambda_4m94pj, Companion_instance_94.k6m([DocumentNodeConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childrenRole' call
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_0 = getPropertyCallableRef('notions', 1, tmp_1, NotionLibrary$_get_notions_$ref_ejoba4_0(), null);
    var tmp$ret$0 = new MultipleChildLink(getKClass(NotionLibrary_1), this_0);
    tmp_0.xgu_1 = this.p6m(tmp$ret$0, 'notions');
    this.ygu_1 = new DomainNodeChildrenPropertyDescriptor(this.xgu_1.s6i_1);
  }
  var NotionLibraryConcept_instance;
  function NotionLibraryConcept_getInstance() {
    if (NotionLibraryConcept_instance == null)
      new NotionLibraryConcept();
    return NotionLibraryConcept_instance;
  }
  function NotionPlaceholderImpl$_init_$ref_o93ttz() {
    var l = function (p0, p1) {
      return new NotionPlaceholderImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function NotionPlaceholderConcept$_init_$lambda_uzt1y9(context, nodeId) {
    return new TypedNotionPlaceholderImpl(context, VOID, nodeId);
  }
  function NotionPlaceholderConcept() {
    NotionPlaceholderConcept_instance = this;
    var tmp = NotionPlaceholderImpl$_init_$ref_o93ttz();
    OtConceptDescriptor.call(this, 'NotionPlaceholder', VOID, tmp, NotionPlaceholderConcept$_init_$lambda_uzt1y9, Companion_instance_94.k6m([AbstractNotionConcept_getInstance()]));
  }
  var NotionPlaceholderConcept_instance;
  function NotionPlaceholderConcept_getInstance() {
    if (NotionPlaceholderConcept_instance == null)
      new NotionPlaceholderConcept();
    return NotionPlaceholderConcept_instance;
  }
  function NotionTypeImpl$_init_$ref_xybv8q() {
    var l = function (p0, p1) {
      return new NotionTypeImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function NotionTypeConcept$_init_$lambda_me3gnm(context, nodeId) {
    return new TypedNotionTypeImpl(context, VOID, nodeId);
  }
  function NotionType$_get_notion_$ref_5i807a_0() {
    return function (p0) {
      return p0.mfq();
    };
  }
  function NotionTypeConcept() {
    NotionTypeConcept_instance = this;
    var tmp = NotionTypeImpl$_init_$ref_xybv8q();
    OtConceptDescriptor.call(this, 'NotionType', VOID, tmp, NotionTypeConcept$_init_$lambda_me3gnm, Companion_instance_94.k6m([TypeConcept_getInstance(), AllowedComplexNotionTypeConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    var tmp4 = getPropertyCallableRef('notion', 1, tmp_1, NotionType$_get_notion_$ref_5i807a_0(), null);
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.referenceRole' call
    var tag = Companion_getInstance_351().zgu_1;
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var tmp$ret$0 = new ReferenceLink(getKClass(NotionType_0), tmp4, getKClass(AbstractNotion), getKClass(QualifiedReferenceContent));
    tmp_0.kgv_1 = this.q6m(tmp$ret$0, tag, 'notion');
    this.lgv_1 = new DomainNodeReferencePropertyDescriptor(this.kgv_1, ReferenceContentPersisters_getInstance().d6m(getKClass(QualifiedReferenceContent)), getKClass(QualifiedReferenceContent));
  }
  var NotionTypeConcept_instance;
  function NotionTypeConcept_getInstance() {
    if (NotionTypeConcept_instance == null)
      new NotionTypeConcept();
    return NotionTypeConcept_instance;
  }
  function ObjectPropertiesLibraryImpl$_init_$ref_sd76po() {
    var l = function (p0, p1) {
      return new ObjectPropertiesLibraryImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function ObjectPropertiesLibraryConcept$_init_$lambda_s3cvl8(context, nodeId) {
    return new TypedObjectPropertiesLibraryImpl(context, VOID, nodeId);
  }
  function ObjectPropertiesLibrary$_get_properties_$ref_3l7x8e_0() {
    return function (p0) {
      return p0.rfp();
    };
  }
  function ObjectPropertiesLibraryConcept() {
    ObjectPropertiesLibraryConcept_instance = this;
    var tmp = ObjectPropertiesLibraryImpl$_init_$ref_sd76po();
    OtConceptDescriptor.call(this, 'ObjectPropertiesLibrary', VOID, tmp, ObjectPropertiesLibraryConcept$_init_$lambda_s3cvl8, Companion_instance_94.k6m([DocumentNodeConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    var tmp4 = getPropertyCallableRef('properties', 1, tmp_1, ObjectPropertiesLibrary$_get_properties_$ref_3l7x8e_0(), null);
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childrenRole' call
    var name = 'properties';
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$0 = new MultipleChildLink(getKClass(ObjectPropertiesLibrary), tmp4);
    tmp_0.wgv_1 = this.p6m(tmp$ret$0, name);
    this.xgv_1 = new DomainNodeChildrenPropertyDescriptor(this.wgv_1.s6i_1);
  }
  var ObjectPropertiesLibraryConcept_instance;
  function ObjectPropertiesLibraryConcept_getInstance() {
    if (ObjectPropertiesLibraryConcept_instance == null)
      new ObjectPropertiesLibraryConcept();
    return ObjectPropertiesLibraryConcept_instance;
  }
  function ObjectPropertyDeclarationImpl$_init_$ref_q9z281() {
    var l = function (p0, p1) {
      return new ObjectPropertyDeclarationImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function ObjectPropertyDeclarationConcept$_init_$lambda_fj5jpz(context, nodeId) {
    return new TypedObjectPropertyDeclarationImpl(context, VOID, nodeId);
  }
  function ObjectPropertyDeclaration$_get_grouping_$ref_xld1xn_0() {
    return function (p0) {
      return p0.ffs();
    };
  }
  function ObjectPropertyDeclaration$_get_superProperty_$ref_32i1ji_0() {
    return function (p0) {
      return p0.gfs();
    };
  }
  function ObjectPropertyDeclaration$_get_domain_$ref_u5oj2s_0() {
    return function (p0) {
      return p0.ufr();
    };
  }
  function ObjectPropertyDeclaration$_get_range_$ref_rc2nln_0() {
    return function (p0) {
      return p0.hd();
    };
  }
  function ObjectPropertyDeclaration$_get_dependent_$ref_o70pa5_0() {
    return function (p0) {
      return p0.hfs();
    };
  }
  function ObjectPropertyDeclaration$_get_inverse_$ref_tftvf2_0() {
    return function (p0) {
      return p0.ifs();
    };
  }
  function ObjectPropertyDeclarationConcept() {
    ObjectPropertyDeclarationConcept_instance = this;
    var tmp = ObjectPropertyDeclarationImpl$_init_$ref_q9z281();
    OtConceptDescriptor.call(this, 'ObjectPropertyDeclaration', VOID, tmp, ObjectPropertyDeclarationConcept$_init_$lambda_fj5jpz, Companion_instance_94.k6m([BTBNodeConcept_getInstance(), DirectlyNamedConcept_getInstance(), HasCommentsConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    tmp_0.igw_1 = this.r6m(getPropertyCallableRef('grouping', 1, tmp_1, ObjectPropertyDeclaration$_get_grouping_$ref_xld1xn_0(), null), 'grouping');
    var tmp_2 = this;
    var tmp_3 = KProperty1;
    var tmp4 = getPropertyCallableRef('superProperty', 1, tmp_3, ObjectPropertyDeclaration$_get_superProperty_$ref_32i1ji_0(), null);
    var tmp6 = Companion_getInstance_332().ugw_1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.referenceRole' call
    var name = 'superProperty';
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var tmp$ret$0 = new ReferenceLink(getKClass(ObjectPropertyDeclaration_1), tmp4, getKClass(ObjectPropertyDeclaration_1), getKClass(QualifiedReferenceContent));
    tmp_2.jgw_1 = this.q6m(tmp$ret$0, tmp6, name);
    var tmp_4 = this;
    var tmp_5 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childrenRole' call
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_0 = getPropertyCallableRef('domain', 1, tmp_5, ObjectPropertyDeclaration$_get_domain_$ref_u5oj2s_0(), null);
    var tmp$ret$2 = new MultipleChildLink(getKClass(ObjectPropertyDeclaration_1), this_0);
    tmp_4.kgw_1 = this.p6m(tmp$ret$2, 'dmn');
    var tmp_6 = this;
    var tmp_7 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_1 = getPropertyCallableRef('range', 1, tmp_7, ObjectPropertyDeclaration$_get_range_$ref_rc2nln_0(), null);
    var tmp$ret$4 = new SingleChildLink(getKClass(ObjectPropertyDeclaration_1), this_1);
    tmp_6.lgw_1 = this.o6m(tmp$ret$4, 'range');
    var tmp_8 = this;
    var tmp_9 = KProperty1;
    tmp_8.mgw_1 = this.r6m(getPropertyCallableRef('dependent', 1, tmp_9, ObjectPropertyDeclaration$_get_dependent_$ref_o70pa5_0(), null), 'dependent');
    var tmp_10 = this;
    var tmp_11 = KProperty1;
    var tmp4_0 = getPropertyCallableRef('inverse', 1, tmp_11, ObjectPropertyDeclaration$_get_inverse_$ref_tftvf2_0(), null);
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.referenceRole' call
    var tag = Companion_getInstance_332().vgw_1;
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var tmp$ret$6 = new ReferenceLink(getKClass(ObjectPropertyDeclaration_1), tmp4_0, getKClass(ObjectPropertyDeclaration_1), getKClass(QualifiedReferenceContent));
    tmp_10.ngw_1 = this.q6m(tmp$ret$6, tag, 'inverse');
    this.ogw_1 = new DomainNodePropertyDescriptor(this.igw_1, toNonNullPersister(NonNullPersisters_getInstance().k25(), new DefaultValueNullPersister(false)));
    this.pgw_1 = new DomainNodeReferencePropertyDescriptor(this.jgw_1, ReferenceContentPersisters_getInstance().d6m(getKClass(QualifiedReferenceContent)), getKClass(QualifiedReferenceContent));
    this.qgw_1 = new DomainNodeChildrenPropertyDescriptor(this.kgw_1.s6i_1);
    this.rgw_1 = new DomainNodeChildPropertyDescriptor(this.lgw_1.s6i_1);
    this.sgw_1 = new DomainNodePropertyDescriptor(this.mgw_1, toNonNullPersister(NonNullPersisters_getInstance().k25(), new DefaultValueNullPersister(false)));
    this.tgw_1 = new DomainNodeReferencePropertyDescriptor(this.ngw_1, ReferenceContentPersisters_getInstance().d6m(getKClass(QualifiedReferenceContent)), getKClass(QualifiedReferenceContent));
  }
  var ObjectPropertyDeclarationConcept_instance;
  function ObjectPropertyDeclarationConcept_getInstance() {
    if (ObjectPropertyDeclarationConcept_instance == null)
      new ObjectPropertyDeclarationConcept();
    return ObjectPropertyDeclarationConcept_instance;
  }
  function ObjectPropertyReferenceValueImpl$_init_$ref_p57lbf() {
    var l = function (p0, p1) {
      return new ObjectPropertyReferenceValueImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function ObjectPropertyReferenceValueConcept$_init_$lambda_li5t4z(context, nodeId) {
    return new TypedObjectPropertyReferenceValueImpl(context, VOID, nodeId);
  }
  function ObjectPropertyReferenceValue$_get_operand_$ref_4h40b1_0() {
    return function (p0) {
      return p0.jfs();
    };
  }
  function ObjectPropertyReferenceValue$_get_property_$ref_zar09b_0() {
    return function (p0) {
      return p0.q6q();
    };
  }
  function ObjectPropertyReferenceValueConcept() {
    ObjectPropertyReferenceValueConcept_instance = this;
    var tmp = ObjectPropertyReferenceValueImpl$_init_$ref_p57lbf();
    OtConceptDescriptor.call(this, 'ObjectPropertyReferenceValue', VOID, tmp, ObjectPropertyReferenceValueConcept$_init_$lambda_li5t4z, Companion_instance_94.k6m([AbstractValueConcept_getInstance(), FactExpressionConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_0 = getPropertyCallableRef('operand', 1, tmp_1, ObjectPropertyReferenceValue$_get_operand_$ref_4h40b1_0(), null);
    var tmp$ret$0 = new SingleChildLink(getKClass(ObjectPropertyReferenceValue_1), this_0);
    tmp_0.ggx_1 = this.o6m(tmp$ret$0, 'operand');
    var tmp_2 = this;
    var tmp_3 = KProperty1;
    var tmp4 = getPropertyCallableRef('property', 1, tmp_3, ObjectPropertyReferenceValue$_get_property_$ref_zar09b_0(), null);
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    var name = 'property';
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$2 = new SingleChildLink(getKClass(ObjectPropertyReferenceValue_1), tmp4);
    tmp_2.hgx_1 = this.o6m(tmp$ret$2, name);
    this.igx_1 = new DomainNodeChildPropertyDescriptor(this.ggx_1.s6i_1);
    this.jgx_1 = new DomainNodeChildPropertyDescriptor(this.hgx_1.s6i_1);
  }
  var ObjectPropertyReferenceValueConcept_instance;
  function ObjectPropertyReferenceValueConcept_getInstance() {
    if (ObjectPropertyReferenceValueConcept_instance == null)
      new ObjectPropertyReferenceValueConcept();
    return ObjectPropertyReferenceValueConcept_instance;
  }
  function OldPublishedSourceImpl$_init_$ref_9vd5v() {
    var l = function (p0, p1) {
      return new OldPublishedSourceImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function OldPublishedSourceConcept$_init_$lambda_91keij(context, nodeId) {
    return new TypedOldPublishedSourceImpl(context, VOID, nodeId);
  }
  function OldPublishedSource$_get_authorsProperty_$ref_umm0gx_0() {
    return function (p0) {
      return p0.kfs();
    };
  }
  function OldPublishedSource$_get_data_$ref_qz5g2a_0() {
    return function (p0) {
      return p0.lfs();
    };
  }
  function OldPublishedSourceConcept() {
    OldPublishedSourceConcept_instance = this;
    var tmp = OldPublishedSourceImpl$_init_$ref_9vd5v();
    OtConceptDescriptor.call(this, 'PublishedSource', VOID, tmp, OldPublishedSourceConcept$_init_$lambda_91keij, Companion_instance_94.k6m([PublishedWorkConcept_getInstance(), LibraryItemConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    tmp_0.ugx_1 = this.r6m(getPropertyCallableRef('authorsProperty', 1, tmp_1, OldPublishedSource$_get_authorsProperty_$ref_umm0gx_0(), null), 'authors');
    var tmp_2 = this;
    var tmp_3 = KProperty1;
    tmp_2.vgx_1 = this.r6m(getPropertyCallableRef('data', 1, tmp_3, OldPublishedSource$_get_data_$ref_qz5g2a_0(), null), 'data');
    this.wgx_1 = new DomainNodePropertyDescriptor(this.ugx_1, toNonNullPersister(NonNullPersisters_getInstance().h25(), new DefaultValueNullPersister('')));
    this.xgx_1 = new DomainNodePropertyDescriptor(this.vgx_1, toNonNullPersister(NonNullPersisters_getInstance().h25(), new DefaultValueNullPersister('')));
  }
  var OldPublishedSourceConcept_instance;
  function OldPublishedSourceConcept_getInstance() {
    if (OldPublishedSourceConcept_instance == null)
      new OldPublishedSourceConcept();
    return OldPublishedSourceConcept_instance;
  }
  function OneOfImpl$_init_$ref_mbczyw() {
    var l = function (p0, p1) {
      return new OneOfImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function OneOfConcept$_init_$lambda_atpphc(context, nodeId) {
    return new TypedOneOfImpl(context, VOID, nodeId);
  }
  function OneOf$_get_expressions_$ref_t8u9ia_0() {
    return function (p0) {
      return p0.mfs();
    };
  }
  function OneOfConcept() {
    OneOfConcept_instance = this;
    var tmp = OneOfImpl$_init_$ref_mbczyw();
    OtConceptDescriptor.call(this, 'OneOf', VOID, tmp, OneOfConcept$_init_$lambda_atpphc, Companion_instance_94.k6m([TypeConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    var tmp4 = getPropertyCallableRef('expressions', 1, tmp_1, OneOf$_get_expressions_$ref_t8u9ia_0(), null);
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childrenRole' call
    var name = 'expressions';
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$0 = new MultipleChildLink(getKClass(OneOf_1), tmp4);
    tmp_0.igy_1 = this.p6m(tmp$ret$0, name);
    this.jgy_1 = new DomainNodeChildrenPropertyDescriptor(this.igy_1.s6i_1);
  }
  var OneOfConcept_instance;
  function OneOfConcept_getInstance() {
    if (OneOfConcept_instance == null)
      new OneOfConcept();
    return OneOfConcept_instance;
  }
  function OntologyCardinalityRelationImpl$_init_$ref_bsrbje() {
    var l = function (p0, p1) {
      return new OntologyCardinalityRelationImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function OntologyCardinalityRelationConcept$_init_$lambda_vxauwy(context, nodeId) {
    return new TypedOntologyCardinalityRelationImpl(context, VOID, nodeId);
  }
  function OntologyCardinalityRelation$_get_classExpression_$ref_42v2qv_0() {
    return function (p0) {
      return p0.hfq();
    };
  }
  function OntologyCardinalityRelation$_get_cardinality_$ref_ld39xl_0() {
    return function (p0) {
      return p0.dfr();
    };
  }
  function OntologyCardinalityRelationConcept() {
    OntologyCardinalityRelationConcept_instance = this;
    var tmp = OntologyCardinalityRelationImpl$_init_$ref_bsrbje();
    OtConceptDescriptor.call(this, 'OntologyCardinalityRelation', VOID, tmp, OntologyCardinalityRelationConcept$_init_$lambda_vxauwy, Companion_instance_94.k6m([AbstractOntologyRelationConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    var tmp4 = getPropertyCallableRef('classExpression', 1, tmp_1, OntologyCardinalityRelation$_get_classExpression_$ref_42v2qv_0(), null);
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    var name = 'elementReferenceProvider';
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$0 = new SingleChildLink(getKClass(OntologyCardinalityRelation_1), tmp4);
    tmp_0.ugy_1 = this.o6m(tmp$ret$0, name);
    var tmp_2 = this;
    var tmp_3 = KProperty1;
    var tmp4_0 = getPropertyCallableRef('cardinality', 1, tmp_3, OntologyCardinalityRelation$_get_cardinality_$ref_ld39xl_0(), null);
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    var name_0 = 'cardinality';
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$2 = new SingleChildLink(getKClass(OntologyCardinalityRelation_1), tmp4_0);
    tmp_2.vgy_1 = this.o6m(tmp$ret$2, name_0);
    this.wgy_1 = new DomainNodeChildPropertyDescriptor(this.ugy_1.s6i_1);
    this.xgy_1 = new DomainNodeChildPropertyDescriptor(this.vgy_1.s6i_1);
  }
  var OntologyCardinalityRelationConcept_instance;
  function OntologyCardinalityRelationConcept_getInstance() {
    if (OntologyCardinalityRelationConcept_instance == null)
      new OntologyCardinalityRelationConcept();
    return OntologyCardinalityRelationConcept_instance;
  }
  function OntologyElementImpl$_init_$ref_3aqors() {
    var l = function (p0, p1) {
      return new OntologyElementImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function OntologyElementConcept$_init_$lambda_9azl3k(context, nodeId) {
    return new TypedOntologyElementImpl(context, VOID, nodeId);
  }
  function OntologyElement$_get_superElements_$ref_eb9rkn_0() {
    return function (p0) {
      return p0.nfs();
    };
  }
  function OntologyElement$_get_enclosingElements_$ref_uplwca_0() {
    return function (p0) {
      return p0.ofs();
    };
  }
  function OntologyElement$_get_taxon_$ref_my9s4f_0() {
    return function (p0) {
      return p0.pfs();
    };
  }
  function OntologyElement$_get_url_$ref_6gfppi_0() {
    return function (p0) {
      return p0.qfs();
    };
  }
  function OntologyElement$_get_nameHint_$ref_xvfepr_0() {
    return function (p0) {
      return p0.rfs();
    };
  }
  function OntologyElement$_get_additionalUrls_$ref_n8oe7a_0() {
    return function (p0) {
      return p0.sfs();
    };
  }
  function OntologyElement$_get_synonyms_$ref_j21l21_0() {
    return function (p0) {
      return p0.tfs();
    };
  }
  function OntologyElement$_get_xRefContainers_$ref_tur9gc_0() {
    return function (p0) {
      return p0.ufs();
    };
  }
  function OntologyElement$_get_oldDefinition_$ref_nndimn_0() {
    return function (p0) {
      return p0.vfs();
    };
  }
  function OntologyElement$_get_definition_$ref_ra1mma_0() {
    return function (p0) {
      return p0.wfs();
    };
  }
  function OntologyElementConcept() {
    OntologyElementConcept_instance = this;
    var tmp = OntologyElementImpl$_init_$ref_3aqors();
    OtConceptDescriptor.call(this, 'OntologyElement', VOID, tmp, OntologyElementConcept$_init_$lambda_9azl3k, Companion_instance_94.k6m([BTBNodeConcept_getInstance(), DirectlyNamedConcept_getInstance(), ClassDeclarationConcept_getInstance(), HasPropertyConstraintsConcept_getInstance(), HasCommentsConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    var tmp4 = getPropertyCallableRef('superElements', 1, tmp_1, OntologyElement$_get_superElements_$ref_eb9rkn_0(), null);
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childrenRole' call
    var name = 'superElements';
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$0 = new MultipleChildLink(getKClass(OntologyElement_1), tmp4);
    tmp_0.igz_1 = this.p6m(tmp$ret$0, name);
    var tmp_2 = this;
    var tmp_3 = KProperty1;
    var tmp4_0 = getPropertyCallableRef('enclosingElements', 1, tmp_3, OntologyElement$_get_enclosingElements_$ref_uplwca_0(), null);
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childrenRole' call
    var name_0 = 'enclosingElements';
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$2 = new MultipleChildLink(getKClass(OntologyElement_1), tmp4_0);
    tmp_2.jgz_1 = this.p6m(tmp$ret$2, name_0);
    var tmp_4 = this;
    var tmp_5 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_0 = getPropertyCallableRef('taxon', 1, tmp_5, OntologyElement$_get_taxon_$ref_my9s4f_0(), null);
    var tmp$ret$4 = new SingleChildLink(getKClass(OntologyElement_1), this_0);
    tmp_4.kgz_1 = this.o6m(tmp$ret$4, 'taxon');
    var tmp_6 = this;
    var tmp_7 = KProperty1;
    tmp_6.lgz_1 = this.r6m(getPropertyCallableRef('url', 1, tmp_7, OntologyElement$_get_url_$ref_6gfppi_0(), null), 'url');
    var tmp_8 = this;
    var tmp_9 = KProperty1;
    tmp_8.mgz_1 = this.r6m(getPropertyCallableRef('nameHint', 1, tmp_9, OntologyElement$_get_nameHint_$ref_xvfepr_0(), null), 'nameHint');
    var tmp_10 = this;
    var tmp_11 = KProperty1;
    var tmp4_1 = getPropertyCallableRef('additionalUrls', 1, tmp_11, OntologyElement$_get_additionalUrls_$ref_n8oe7a_0(), null);
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childrenRole' call
    var name_1 = 'additionalUrls';
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$6 = new MultipleChildLink(getKClass(OntologyElement_1), tmp4_1);
    tmp_10.ngz_1 = this.p6m(tmp$ret$6, name_1);
    var tmp_12 = this;
    var tmp_13 = KProperty1;
    var tmp4_2 = getPropertyCallableRef('synonyms', 1, tmp_13, OntologyElement$_get_synonyms_$ref_j21l21_0(), null);
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childrenRole' call
    var name_2 = 'synonyms';
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$8 = new MultipleChildLink(getKClass(OntologyElement_1), tmp4_2);
    tmp_12.ogz_1 = this.p6m(tmp$ret$8, name_2);
    var tmp_14 = this;
    var tmp_15 = KProperty1;
    var tmp4_3 = getPropertyCallableRef('xRefContainers', 1, tmp_15, OntologyElement$_get_xRefContainers_$ref_tur9gc_0(), null);
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childrenRole' call
    var name_3 = 'xRefContainers';
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$10 = new MultipleChildLink(getKClass(OntologyElement_1), tmp4_3);
    tmp_14.pgz_1 = this.p6m(tmp$ret$10, name_3);
    var tmp_16 = this;
    var tmp_17 = KProperty1;
    var tmp4_4 = getPropertyCallableRef('oldDefinition', 1, tmp_17, OntologyElement$_get_oldDefinition_$ref_nndimn_0(), null);
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    var name_4 = 'oldDefinition';
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$12 = new SingleChildLink(getKClass(OntologyElement_1), tmp4_4);
    tmp_16.qgz_1 = this.o6m(tmp$ret$12, name_4);
    var tmp_18 = this;
    var tmp_19 = KProperty1;
    var tmp4_5 = getPropertyCallableRef('definition', 1, tmp_19, OntologyElement$_get_definition_$ref_ra1mma_0(), null);
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    var name_5 = 'definition';
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$14 = new SingleChildLink(getKClass(OntologyElement_1), tmp4_5);
    tmp_18.rgz_1 = this.o6m(tmp$ret$14, name_5);
    this.sgz_1 = new DomainNodeChildrenPropertyDescriptor(this.igz_1.s6i_1);
    this.tgz_1 = new DomainNodeChildrenPropertyDescriptor(this.jgz_1.s6i_1);
    this.ugz_1 = new DomainNodeChildPropertyDescriptor(this.kgz_1.s6i_1);
    this.vgz_1 = new DomainNodePropertyDescriptor(this.lgz_1, toNonNullPersister(NonNullPersisters_getInstance().h25(), new DefaultValueNullPersister('')));
    this.wgz_1 = new DomainNodePropertyDescriptor(this.mgz_1, toNonNullPersister(NonNullPersisters_getInstance().h25(), new DefaultValueNullPersister('')));
    this.xgz_1 = new DomainNodeChildrenPropertyDescriptor(this.ngz_1.s6i_1);
    this.ygz_1 = new DomainNodeChildrenPropertyDescriptor(this.ogz_1.s6i_1);
    this.zgz_1 = new DomainNodeChildrenPropertyDescriptor(this.pgz_1.s6i_1);
    this.ah0_1 = new DomainNodeChildPropertyDescriptor(this.qgz_1.s6i_1);
    this.bh0_1 = new DomainNodeChildPropertyDescriptor(this.rgz_1.s6i_1);
  }
  var OntologyElementConcept_instance;
  function OntologyElementConcept_getInstance() {
    if (OntologyElementConcept_instance == null)
      new OntologyElementConcept();
    return OntologyElementConcept_instance;
  }
  function OntologyElementDefinitionImpl$_init_$ref_pvcepx() {
    var l = function (p0, p1) {
      return new OntologyElementDefinitionImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function OntologyElementDefinitionConcept$_init_$lambda_bscz6l(context, nodeId) {
    return new TypedOntologyElementDefinitionImpl(context, VOID, nodeId);
  }
  function OntologyElementDefinition$_get_classExpression_$ref_7q14es_0() {
    return function (p0) {
      return p0.hfq();
    };
  }
  function OntologyElementDefinitionConcept() {
    OntologyElementDefinitionConcept_instance = this;
    var tmp = OntologyElementDefinitionImpl$_init_$ref_pvcepx();
    OtConceptDescriptor.call(this, 'OntologyElementDefinition', VOID, tmp, OntologyElementDefinitionConcept$_init_$lambda_bscz6l, Companion_instance_94.k6m([BTBNodeConcept_getInstance(), HasPropertyConstraintsConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    var tmp4 = getPropertyCallableRef('classExpression', 1, tmp_1, OntologyElementDefinition$_get_classExpression_$ref_7q14es_0(), null);
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    var name = 'classExpression';
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$0 = new SingleChildLink(getKClass(OntologyElementDefinition_1), tmp4);
    tmp_0.mh0_1 = this.o6m(tmp$ret$0, name);
    this.nh0_1 = new DomainNodeChildPropertyDescriptor(this.mh0_1.s6i_1);
  }
  var OntologyElementDefinitionConcept_instance;
  function OntologyElementDefinitionConcept_getInstance() {
    if (OntologyElementDefinitionConcept_instance == null)
      new OntologyElementDefinitionConcept();
    return OntologyElementDefinitionConcept_instance;
  }
  function OntologyElementPropertyTypeImpl$_init_$ref_za1621() {
    var l = function (p0, p1) {
      return new OntologyElementPropertyTypeImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function OntologyElementPropertyTypeConcept$_init_$lambda_8wnwcf(context, nodeId) {
    return new TypedOntologyElementPropertyTypeImpl(context, VOID, nodeId);
  }
  function OntologyElementPropertyType$_get_specificator_$ref_coyqyi_0() {
    return function (p0) {
      return p0.jfr();
    };
  }
  function OntologyElementPropertyType$_get_library_$ref_izz7j1_0() {
    return function (p0) {
      return p0.ffq();
    };
  }
  function OntologyElementPropertyType$_get_element_$ref_x8jl50_0() {
    return function (p0) {
      return p0.gfq();
    };
  }
  function OntologyElementPropertyTypeConcept$SPECIFICATOR_PERSISTER$$inlined$enumPersister$1() {
  }
  protoOf(OntologyElementPropertyTypeConcept$SPECIFICATOR_PERSISTER$$inlined$enumPersister$1).v24 = function (value) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'jetbrains.ocelot.base.enums.Enums.valueOf' call
      // Inline function 'kotlin.enumValues' call
      var indexedObject = values_14();
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var e = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        if (value === e.toString()) {
          tmp$ret$1 = e;
          break $l$block;
        }
      }
      throw IllegalArgumentException_init_$Create$_0(value);
    }
    return tmp$ret$1;
  };
  protoOf(OntologyElementPropertyTypeConcept$SPECIFICATOR_PERSISTER$$inlined$enumPersister$1).ngn = function (value) {
    return value.toString();
  };
  protoOf(OntologyElementPropertyTypeConcept$SPECIFICATOR_PERSISTER$$inlined$enumPersister$1).w24 = function (value) {
    return this.ngn(value instanceof LinkTypeSpecificator ? value : THROW_CCE());
  };
  protoOf(OntologyElementPropertyTypeConcept$SPECIFICATOR_PERSISTER$$inlined$enumPersister$1).toString = function () {
    return 'enumPersister';
  };
  function OntologyElementPropertyTypeConcept$specificatorPropertyDescriptor$$inlined$enumPersister$1() {
  }
  protoOf(OntologyElementPropertyTypeConcept$specificatorPropertyDescriptor$$inlined$enumPersister$1).v24 = function (value) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'jetbrains.ocelot.base.enums.Enums.valueOf' call
      // Inline function 'kotlin.enumValues' call
      var indexedObject = values_14();
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var e = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        if (value === e.toString()) {
          tmp$ret$1 = e;
          break $l$block;
        }
      }
      throw IllegalArgumentException_init_$Create$_0(value);
    }
    return tmp$ret$1;
  };
  protoOf(OntologyElementPropertyTypeConcept$specificatorPropertyDescriptor$$inlined$enumPersister$1).ngn = function (value) {
    return value.toString();
  };
  protoOf(OntologyElementPropertyTypeConcept$specificatorPropertyDescriptor$$inlined$enumPersister$1).w24 = function (value) {
    return this.ngn(value instanceof LinkTypeSpecificator ? value : THROW_CCE());
  };
  protoOf(OntologyElementPropertyTypeConcept$specificatorPropertyDescriptor$$inlined$enumPersister$1).toString = function () {
    return 'enumPersister';
  };
  function OntologyElementPropertyTypeConcept() {
    OntologyElementPropertyTypeConcept_instance = this;
    var tmp = OntologyElementPropertyTypeImpl$_init_$ref_za1621();
    OtConceptDescriptor.call(this, 'OntologyElementPropertyType', VOID, tmp, OntologyElementPropertyTypeConcept$_init_$lambda_8wnwcf, Companion_instance_94.k6m([ProcessPropertyTypeConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    tmp_0.yh0_1 = this.r6m(getPropertyCallableRef('specificator', 1, tmp_1, OntologyElementPropertyType$_get_specificator_$ref_coyqyi_0(), null), 'specificator');
    var tmp_2 = this;
    var tmp_3 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_0 = getPropertyCallableRef('library', 1, tmp_3, OntologyElementPropertyType$_get_library_$ref_izz7j1_0(), null);
    var tmp$ret$0 = new SingleChildLink(getKClass(OntologyElementPropertyType_1), this_0);
    tmp_2.zh0_1 = this.o6m(tmp$ret$0, 'library');
    var tmp_4 = this;
    var tmp_5 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_1 = getPropertyCallableRef('element', 1, tmp_5, OntologyElementPropertyType$_get_element_$ref_x8jl50_0(), null);
    var tmp$ret$2 = new SingleChildLink(getKClass(OntologyElementPropertyType_1), this_1);
    tmp_4.ah1_1 = this.o6m(tmp$ret$2, 'element');
    var tmp_6 = this;
    // Inline function 'jetbrains.ocelot.base.persister.NonNullPersisters.enumPersister' call
    NonNullPersisters_getInstance();
    var tmp$ret$4 = new OntologyElementPropertyTypeConcept$SPECIFICATOR_PERSISTER$$inlined$enumPersister$1();
    tmp_6.bh1_1 = toNullablePersister(tmp$ret$4);
    var tmp_7 = this;
    // Inline function 'jetbrains.ocelot.base.persister.NonNullPersisters.enumPersister' call
    NonNullPersisters_getInstance();
    var tmp$ret$5 = new OntologyElementPropertyTypeConcept$specificatorPropertyDescriptor$$inlined$enumPersister$1();
    tmp_7.ch1_1 = new DomainNodePropertyDescriptor(this.yh0_1, toNullablePersister(tmp$ret$5));
    this.dh1_1 = new DomainNodeChildPropertyDescriptor(this.zh0_1.s6i_1);
    this.eh1_1 = new DomainNodeChildPropertyDescriptor(this.ah1_1.s6i_1);
  }
  var OntologyElementPropertyTypeConcept_instance;
  function OntologyElementPropertyTypeConcept_getInstance() {
    if (OntologyElementPropertyTypeConcept_instance == null)
      new OntologyElementPropertyTypeConcept();
    return OntologyElementPropertyTypeConcept_instance;
  }
  function OntologyElementReferenceImpl$_init_$ref_92b7lz() {
    var l = function (p0, p1) {
      return new OntologyElementReferenceImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function OntologyElementReferenceConcept$_init_$lambda_5yxizj(context, nodeId) {
    return new TypedOntologyElementReferenceImpl(context, VOID, nodeId);
  }
  function OntologyElementReference$_get_element_$ref_3s4b1e_0() {
    return function (p0) {
      return p0.gfq();
    };
  }
  function OntologyElementReferenceConcept() {
    OntologyElementReferenceConcept_instance = this;
    var tmp = OntologyElementReferenceImpl$_init_$ref_92b7lz();
    OtConceptDescriptor.call(this, 'OntologyElementReference', VOID, tmp, OntologyElementReferenceConcept$_init_$lambda_5yxizj, Companion_instance_94.k6m([BTBNodeConcept_getInstance(), OntologyElementReferenceProviderConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    var tmp4 = getPropertyCallableRef('element', 1, tmp_1, OntologyElementReference$_get_element_$ref_3s4b1e_0(), null);
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.referenceRole' call
    var tag = Companion_getInstance_336().fh1_1;
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var tmp$ret$0 = new ReferenceLink(getKClass(OntologyElementReference_1), tmp4, getKClass(OntologyElement_1), getKClass(QualifiedReferenceContent));
    tmp_0.qh1_1 = this.q6m(tmp$ret$0, tag, 'element');
    this.rh1_1 = new DomainNodeReferencePropertyDescriptor(this.qh1_1, ReferenceContentPersisters_getInstance().d6m(getKClass(QualifiedReferenceContent)), getKClass(QualifiedReferenceContent));
  }
  var OntologyElementReferenceConcept_instance;
  function OntologyElementReferenceConcept_getInstance() {
    if (OntologyElementReferenceConcept_instance == null)
      new OntologyElementReferenceConcept();
    return OntologyElementReferenceConcept_instance;
  }
  function OntologyElementReferenceProviderConcept() {
    OntologyElementReferenceProviderConcept_instance = this;
    OTAbstractConceptDescriptor.call(this, Companion_instance_94.k6m([ClassExpressionConcept_getInstance()]));
  }
  var OntologyElementReferenceProviderConcept_instance;
  function OntologyElementReferenceProviderConcept_getInstance() {
    if (OntologyElementReferenceProviderConcept_instance == null)
      new OntologyElementReferenceProviderConcept();
    return OntologyElementReferenceProviderConcept_instance;
  }
  function OntologyElementReferenceValueImpl$_init_$ref_es0ctq() {
    var l = function (p0, p1) {
      return new OntologyElementReferenceValueImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function OntologyElementReferenceValueConcept$_init_$lambda_gorega(context, nodeId) {
    return new TypedOntologyElementReferenceValueImpl(context, VOID, nodeId);
  }
  function OntologyElementReferenceValue$_get_element_$ref_kjo2gj_0() {
    return function (p0) {
      return p0.gfq();
    };
  }
  function OntologyElementReferenceValueConcept() {
    OntologyElementReferenceValueConcept_instance = this;
    var tmp = OntologyElementReferenceValueImpl$_init_$ref_es0ctq();
    OtConceptDescriptor.call(this, 'OntologyElementReferenceValue', VOID, tmp, OntologyElementReferenceValueConcept$_init_$lambda_gorega, Companion_instance_94.k6m([AbstractValueConcept_getInstance(), FactExpressionConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_0 = getPropertyCallableRef('element', 1, tmp_1, OntologyElementReferenceValue$_get_element_$ref_kjo2gj_0(), null);
    var tmp$ret$0 = new SingleChildLink(getKClass(OntologyElementReferenceValue_1), this_0);
    tmp_0.ch2_1 = this.o6m(tmp$ret$0, 'element');
    this.dh2_1 = new DomainNodeChildPropertyDescriptor(this.ch2_1.s6i_1);
  }
  var OntologyElementReferenceValueConcept_instance;
  function OntologyElementReferenceValueConcept_getInstance() {
    if (OntologyElementReferenceValueConcept_instance == null)
      new OntologyElementReferenceValueConcept();
    return OntologyElementReferenceValueConcept_instance;
  }
  function OntologyElementReferenceValueLibraryImpl$_init_$ref_tg65st() {
    var l = function (p0, p1) {
      return new OntologyElementReferenceValueLibraryImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function OntologyElementReferenceValueLibraryConcept$_init_$lambda_8185fv(context, nodeId) {
    return new TypedOntologyElementReferenceValueLibraryImpl(context, VOID, nodeId);
  }
  function OntologyElementReferenceValueLibrary$_get_library_$ref_ni4dih_0() {
    return function (p0) {
      return p0.ffq();
    };
  }
  function OntologyElementReferenceValueLibraryConcept() {
    OntologyElementReferenceValueLibraryConcept_instance = this;
    var tmp = OntologyElementReferenceValueLibraryImpl$_init_$ref_tg65st();
    OtConceptDescriptor.call(this, 'OntologyElementReferenceValueLibrary', VOID, tmp, OntologyElementReferenceValueLibraryConcept$_init_$lambda_8185fv, Companion_instance_94.k6m([OntologyElementReferenceValueConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_0 = getPropertyCallableRef('library', 1, tmp_1, OntologyElementReferenceValueLibrary$_get_library_$ref_ni4dih_0(), null);
    var tmp$ret$0 = new SingleChildLink(getKClass(OntologyElementReferenceValueLibrary_1), this_0);
    tmp_0.oh2_1 = this.o6m(tmp$ret$0, 'library');
    this.ph2_1 = new DomainNodeChildPropertyDescriptor(this.oh2_1.s6i_1);
  }
  var OntologyElementReferenceValueLibraryConcept_instance;
  function OntologyElementReferenceValueLibraryConcept_getInstance() {
    if (OntologyElementReferenceValueLibraryConcept_instance == null)
      new OntologyElementReferenceValueLibraryConcept();
    return OntologyElementReferenceValueLibraryConcept_instance;
  }
  function OntologyElementSynonymImpl$_init_$ref_sk8zl5() {
    var l = function (p0, p1) {
      return new OntologyElementSynonymImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function OntologyElementSynonymConcept$_init_$lambda_vd5dkf(context, nodeId) {
    return new TypedOntologyElementSynonymImpl(context, VOID, nodeId);
  }
  function OntologyElementSynonym$_get_name_$ref_ojzpad_0() {
    return function (p0) {
      return p0.y2();
    };
  }
  function OntologyElementSynonymConcept() {
    OntologyElementSynonymConcept_instance = this;
    var tmp = OntologyElementSynonymImpl$_init_$ref_sk8zl5();
    OtConceptDescriptor.call(this, 'Synonym', VOID, tmp, OntologyElementSynonymConcept$_init_$lambda_vd5dkf, Companion_instance_94.k6m([BTBNodeConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    tmp_0.ah3_1 = this.r6m(getPropertyCallableRef('name', 1, tmp_1, OntologyElementSynonym$_get_name_$ref_ojzpad_0(), null), 'name');
    this.bh3_1 = new DomainNodePropertyDescriptor(this.ah3_1, toNonNullPersister(NonNullPersisters_getInstance().h25(), new DefaultValueNullPersister('')));
  }
  var OntologyElementSynonymConcept_instance;
  function OntologyElementSynonymConcept_getInstance() {
    if (OntologyElementSynonymConcept_instance == null)
      new OntologyElementSynonymConcept();
    return OntologyElementSynonymConcept_instance;
  }
  function OntologyElementTypeImpl$_init_$ref_dnw7pe() {
    var l = function (p0, p1) {
      return new OntologyElementTypeImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function OntologyElementTypeConcept$_init_$lambda_n5a40m(context, nodeId) {
    return new TypedOntologyElementTypeImpl(context, VOID, nodeId);
  }
  function OntologyElementType$_get_library_$ref_qnafmw_0() {
    return function (p0) {
      return p0.ffq();
    };
  }
  function OntologyElementType$_get_element_$ref_pl8d15_0() {
    return function (p0) {
      return p0.gfq();
    };
  }
  function OntologyElementTypeConcept() {
    OntologyElementTypeConcept_instance = this;
    var tmp = OntologyElementTypeImpl$_init_$ref_dnw7pe();
    OtConceptDescriptor.call(this, 'OntologyElementType', VOID, tmp, OntologyElementTypeConcept$_init_$lambda_n5a40m, Companion_instance_94.k6m([TypeConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_0 = getPropertyCallableRef('library', 1, tmp_1, OntologyElementType$_get_library_$ref_qnafmw_0(), null);
    var tmp$ret$0 = new SingleChildLink(getKClass(OntologyElementType_1), this_0);
    tmp_0.mh3_1 = this.o6m(tmp$ret$0, 'library');
    var tmp_2 = this;
    var tmp_3 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_1 = getPropertyCallableRef('element', 1, tmp_3, OntologyElementType$_get_element_$ref_pl8d15_0(), null);
    var tmp$ret$2 = new SingleChildLink(getKClass(OntologyElementType_1), this_1);
    tmp_2.nh3_1 = this.o6m(tmp$ret$2, 'element');
    this.oh3_1 = new DomainNodeChildPropertyDescriptor(this.mh3_1.s6i_1);
    this.ph3_1 = new DomainNodeChildPropertyDescriptor(this.nh3_1.s6i_1);
  }
  var OntologyElementTypeConcept_instance;
  function OntologyElementTypeConcept_getInstance() {
    if (OntologyElementTypeConcept_instance == null)
      new OntologyElementTypeConcept();
    return OntologyElementTypeConcept_instance;
  }
  function OntologyImportImpl$_init_$ref_wqann3() {
    var l = function (p0, p1) {
      return new OntologyImportImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function OntologyImportConcept$_init_$lambda_jllb4n(context, nodeId) {
    return new TypedOntologyImportImpl(context, VOID, nodeId);
  }
  function OntologyImport$_get_ontology_$ref_5t3sat_0() {
    return function (p0) {
      return p0.xfs();
    };
  }
  function OntologyImport$_get_element_$ref_7h70ks_0() {
    return function (p0) {
      return p0.gfq();
    };
  }
  function OntologyImport$_get_libraryToUse_$ref_z1ihvd_0() {
    return function (p0) {
      return p0.yfs();
    };
  }
  function OntologyImportConcept() {
    OntologyImportConcept_instance = this;
    var tmp = OntologyImportImpl$_init_$ref_wqann3();
    OtConceptDescriptor.call(this, 'OntologyImport', VOID, tmp, OntologyImportConcept$_init_$lambda_jllb4n, Companion_instance_94.k6m([BTBNodeConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    var tmp4 = getPropertyCallableRef('ontology', 1, tmp_1, OntologyImport$_get_ontology_$ref_5t3sat_0(), null);
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    var name = 'ontology';
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$0 = new SingleChildLink(getKClass(OntologyImport_1), tmp4);
    tmp_0.ah4_1 = this.o6m(tmp$ret$0, name);
    var tmp_2 = this;
    var tmp_3 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_0 = getPropertyCallableRef('element', 1, tmp_3, OntologyImport$_get_element_$ref_7h70ks_0(), null);
    var tmp$ret$2 = new SingleChildLink(getKClass(OntologyImport_1), this_0);
    tmp_2.bh4_1 = this.o6m(tmp$ret$2, 'element');
    var tmp_4 = this;
    var tmp_5 = KProperty1;
    var tmp4_0 = getPropertyCallableRef('libraryToUse', 1, tmp_5, OntologyImport$_get_libraryToUse_$ref_z1ihvd_0(), null);
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    var name_0 = 'libraryToUse';
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$4 = new SingleChildLink(getKClass(OntologyImport_1), tmp4_0);
    tmp_4.ch4_1 = this.o6m(tmp$ret$4, name_0);
    this.dh4_1 = new DomainNodeChildPropertyDescriptor(this.ah4_1.s6i_1);
    this.eh4_1 = new DomainNodeChildPropertyDescriptor(this.bh4_1.s6i_1);
    this.fh4_1 = new DomainNodeChildPropertyDescriptor(this.ch4_1.s6i_1);
  }
  var OntologyImportConcept_instance;
  function OntologyImportConcept_getInstance() {
    if (OntologyImportConcept_instance == null)
      new OntologyImportConcept();
    return OntologyImportConcept_instance;
  }
  function OntologyImportRootImpl$_init_$ref_43ud1r() {
    var l = function (p0, p1) {
      return new OntologyImportRootImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function OntologyImportRootConcept$_init_$lambda_hnj9ll(context, nodeId) {
    return new TypedOntologyImportRootImpl(context, VOID, nodeId);
  }
  function OntologyImportRoot$_get_imports_$ref_rcorbw_0() {
    return function (p0) {
      return p0.zfp();
    };
  }
  function OntologyImportRootConcept() {
    OntologyImportRootConcept_instance = this;
    var tmp = OntologyImportRootImpl$_init_$ref_43ud1r();
    OtConceptDescriptor.call(this, 'OntologyImportRoot', VOID, tmp, OntologyImportRootConcept$_init_$lambda_hnj9ll, Companion_instance_94.k6m([DocumentNodeConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childrenRole' call
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_0 = getPropertyCallableRef('imports', 1, tmp_1, OntologyImportRoot$_get_imports_$ref_rcorbw_0(), null);
    var tmp$ret$0 = new MultipleChildLink(getKClass(OntologyImportRoot_1), this_0);
    tmp_0.qh4_1 = this.p6m(tmp$ret$0, 'imports');
    this.rh4_1 = new DomainNodeChildrenPropertyDescriptor(this.qh4_1.s6i_1);
  }
  var OntologyImportRootConcept_instance;
  function OntologyImportRootConcept_getInstance() {
    if (OntologyImportRootConcept_instance == null)
      new OntologyImportRootConcept();
    return OntologyImportRootConcept_instance;
  }
  function OntologyImportRootReferenceImpl$_init_$ref_mgkrbk() {
    var l = function (p0, p1) {
      return new OntologyImportRootReferenceImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function OntologyImportRootReferenceConcept$_init_$lambda_n0554(context, nodeId) {
    return new TypedOntologyImportRootReferenceImpl(context, VOID, nodeId);
  }
  function OntologyImportRootReference$_get_ref_$ref_qpspni_0() {
    return function (p0) {
      return p0.yfq();
    };
  }
  function OntologyImportRootReferenceConcept() {
    OntologyImportRootReferenceConcept_instance = this;
    var tmp = OntologyImportRootReferenceImpl$_init_$ref_mgkrbk();
    OtConceptDescriptor.call(this, 'OntologyImportRootReference', VOID, tmp, OntologyImportRootReferenceConcept$_init_$lambda_n0554, Companion_instance_94.k6m([BTBNodeConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    var tmp4 = getPropertyCallableRef('ref', 1, tmp_1, OntologyImportRootReference$_get_ref_$ref_qpspni_0(), null);
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.referenceRole' call
    var tag = Companion_getInstance_327().sh4_1;
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var tmp$ret$0 = new ReferenceLink(getKClass(OntologyImportRootReference_1), tmp4, getKClass(OntologyImportRoot_1), getKClass(QualifiedReferenceContent));
    tmp_0.dh5_1 = this.q6m(tmp$ret$0, tag, 'root');
    this.eh5_1 = new DomainNodeReferencePropertyDescriptor(this.dh5_1, ReferenceContentPersisters_getInstance().d6m(getKClass(QualifiedReferenceContent)), getKClass(QualifiedReferenceContent));
  }
  var OntologyImportRootReferenceConcept_instance;
  function OntologyImportRootReferenceConcept_getInstance() {
    if (OntologyImportRootReferenceConcept_instance == null)
      new OntologyImportRootReferenceConcept();
    return OntologyImportRootReferenceConcept_instance;
  }
  function OntologyIsRelationImpl$_init_$ref_3lw5f4() {
    var l = function (p0, p1) {
      return new OntologyIsRelationImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function OntologyIsRelationConcept$_init_$lambda_wzklco(context, nodeId) {
    return new TypedOntologyIsRelationImpl(context, VOID, nodeId);
  }
  function OntologyIsRelation$_get_elementReferenceProvider_$ref_bgjhbd_0() {
    return function (p0) {
      return p0.zfs();
    };
  }
  function OntologyIsRelationConcept() {
    OntologyIsRelationConcept_instance = this;
    var tmp = OntologyIsRelationImpl$_init_$ref_3lw5f4();
    OtConceptDescriptor.call(this, 'OntologyIsRelation', VOID, tmp, OntologyIsRelationConcept$_init_$lambda_wzklco, Companion_instance_94.k6m([AbstractOntologyRelationConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    var tmp4 = getPropertyCallableRef('elementReferenceProvider', 1, tmp_1, OntologyIsRelation$_get_elementReferenceProvider_$ref_bgjhbd_0(), null);
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    var name = 'elementReferenceProvider';
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$0 = new SingleChildLink(getKClass(OntologyIsRelation_1), tmp4);
    tmp_0.ph5_1 = this.o6m(tmp$ret$0, name);
    this.qh5_1 = new DomainNodeChildPropertyDescriptor(this.ph5_1.s6i_1);
  }
  var OntologyIsRelationConcept_instance;
  function OntologyIsRelationConcept_getInstance() {
    if (OntologyIsRelationConcept_instance == null)
      new OntologyIsRelationConcept();
    return OntologyIsRelationConcept_instance;
  }
  function OntologyLibraryImpl$_init_$ref_r37q0p() {
    var l = function (p0, p1) {
      return new OntologyLibraryImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function OntologyLibraryConcept$_init_$lambda_dlbtox(context, nodeId) {
    return new TypedOntologyLibraryImpl(context, VOID, nodeId);
  }
  function OntologyLibrary$_get_elements_$ref_5im1vf_0() {
    return function (p0) {
      return p0.ifq();
    };
  }
  function OntologyLibraryConcept() {
    OntologyLibraryConcept_instance = this;
    var tmp = OntologyLibraryImpl$_init_$ref_r37q0p();
    OtConceptDescriptor.call(this, 'OntologyLibrary', VOID, tmp, OntologyLibraryConcept$_init_$lambda_dlbtox, Companion_instance_94.k6m([DocumentNodeConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    var tmp4 = getPropertyCallableRef('elements', 1, tmp_1, OntologyLibrary$_get_elements_$ref_5im1vf_0(), null);
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childrenRole' call
    var name = 'elements';
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$0 = new MultipleChildLink(getKClass(OntologyLibrary_1), tmp4);
    tmp_0.bh6_1 = this.p6m(tmp$ret$0, name);
    this.ch6_1 = new DomainNodeChildrenPropertyDescriptor(this.bh6_1.s6i_1);
  }
  var OntologyLibraryConcept_instance;
  function OntologyLibraryConcept_getInstance() {
    if (OntologyLibraryConcept_instance == null)
      new OntologyLibraryConcept();
    return OntologyLibraryConcept_instance;
  }
  function OntologyLibraryReferenceImpl$_init_$ref_qkmvp6() {
    var l = function (p0, p1) {
      return new OntologyLibraryReferenceImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function OntologyLibraryReferenceConcept$_init_$lambda_cxpvs2(context, nodeId) {
    return new TypedOntologyLibraryReferenceImpl(context, VOID, nodeId);
  }
  function OntologyLibraryReference$_get_ref_$ref_894de0_0() {
    return function (p0) {
      return p0.yfq();
    };
  }
  function OntologyLibraryReferenceConcept() {
    OntologyLibraryReferenceConcept_instance = this;
    var tmp = OntologyLibraryReferenceImpl$_init_$ref_qkmvp6();
    OtConceptDescriptor.call(this, 'OntologyLibraryReference', VOID, tmp, OntologyLibraryReferenceConcept$_init_$lambda_cxpvs2, Companion_instance_94.k6m([BTBNodeConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    var tmp4 = getPropertyCallableRef('ref', 1, tmp_1, OntologyLibraryReference$_get_ref_$ref_894de0_0(), null);
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.referenceRole' call
    var tag = Companion_getInstance_335().dh6_1;
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var tmp$ret$0 = new ReferenceLink(getKClass(OntologyLibraryReference_1), tmp4, getKClass(OntologyLibrary_1), getKClass(QualifiedReferenceContent));
    tmp_0.oh6_1 = this.q6m(tmp$ret$0, tag, 'library');
    this.ph6_1 = new DomainNodeReferencePropertyDescriptor(this.oh6_1, ReferenceContentPersisters_getInstance().d6m(getKClass(QualifiedReferenceContent)), getKClass(QualifiedReferenceContent));
  }
  var OntologyLibraryReferenceConcept_instance;
  function OntologyLibraryReferenceConcept_getInstance() {
    if (OntologyLibraryReferenceConcept_instance == null)
      new OntologyLibraryReferenceConcept();
    return OntologyLibraryReferenceConcept_instance;
  }
  function OntologyLinkImpl$_init_$ref_2lukmc() {
    var l = function (p0, p1) {
      return new OntologyLinkImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function OntologyLinkConcept$_init_$lambda_xpp46s(context, nodeId) {
    return new TypedOntologyLinkImpl(context, VOID, nodeId);
  }
  function OntologyLink$_get_link_$ref_38pp17_0() {
    return function (p0) {
      return p0.xa1();
    };
  }
  function OntologyLink$_get_defaultLibraryReference_$ref_7bd1ik_0() {
    return function (p0) {
      return p0.aft();
    };
  }
  function OntologyLinkConcept() {
    OntologyLinkConcept_instance = this;
    var tmp = OntologyLinkImpl$_init_$ref_2lukmc();
    OtConceptDescriptor.call(this, 'OntologyLink', VOID, tmp, OntologyLinkConcept$_init_$lambda_xpp46s, Companion_instance_94.k6m([AbstractLinkConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_0 = getPropertyCallableRef('link', 1, tmp_1, OntologyLink$_get_link_$ref_38pp17_0(), null);
    var tmp$ret$0 = new SingleChildLink(getKClass(OntologyLink_1), this_0);
    tmp_0.ah7_1 = this.o6m(tmp$ret$0, 'link');
    var tmp_2 = this;
    var tmp_3 = KProperty1;
    var tmp4 = getPropertyCallableRef('defaultLibraryReference', 1, tmp_3, OntologyLink$_get_defaultLibraryReference_$ref_7bd1ik_0(), null);
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    var name = 'defaultLibrary';
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$2 = new SingleChildLink(getKClass(OntologyLink_1), tmp4);
    tmp_2.bh7_1 = this.o6m(tmp$ret$2, name);
    this.ch7_1 = new DomainNodeChildPropertyDescriptor(this.ah7_1.s6i_1);
    this.dh7_1 = new DomainNodeChildPropertyDescriptor(this.bh7_1.s6i_1);
  }
  var OntologyLinkConcept_instance;
  function OntologyLinkConcept_getInstance() {
    if (OntologyLinkConcept_instance == null)
      new OntologyLinkConcept();
    return OntologyLinkConcept_instance;
  }
  function OntologyLinkDeclarationValueQueryImpl$_init_$ref_b82iar() {
    var l = function (p0, p1) {
      return new OntologyLinkDeclarationValueQueryImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function OntologyLinkDeclarationValueQueryConcept$_init_$lambda_3dpx85(context, nodeId) {
    return new TypedOntologyLinkDeclarationValueQueryImpl(context, VOID, nodeId);
  }
  function OntologyLinkDeclarationValueQuery$_get_linkDeclaration_$ref_tqydwc_0() {
    return function (p0) {
      return p0.bft();
    };
  }
  function OntologyLinkDeclarationValueQueryConcept() {
    OntologyLinkDeclarationValueQueryConcept_instance = this;
    var tmp = OntologyLinkDeclarationValueQueryImpl$_init_$ref_b82iar();
    OtConceptDescriptor.call(this, 'OntologyLinkDeclarationValueQuery', VOID, tmp, OntologyLinkDeclarationValueQueryConcept$_init_$lambda_3dpx85, Companion_instance_94.k6m([DeclarationValueQueryConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    var tmp4 = getPropertyCallableRef('linkDeclaration', 1, tmp_1, OntologyLinkDeclarationValueQuery$_get_linkDeclaration_$ref_tqydwc_0(), null);
    var tmp6 = Companion_getInstance_347().eh7_1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.referenceRole' call
    var name = 'linkDeclaration';
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var tmp$ret$0 = new ReferenceLink(getKClass(OntologyLinkDeclarationValueQuery_1), tmp4, getKClass(LinkDeclaration_1), getKClass(QualifiedReferenceContent));
    tmp_0.ph7_1 = this.q6m(tmp$ret$0, tmp6, name);
    this.qh7_1 = new DomainNodeReferencePropertyDescriptor(this.ph7_1, ReferenceContentPersisters_getInstance().d6m(getKClass(QualifiedReferenceContent)), getKClass(QualifiedReferenceContent));
  }
  var OntologyLinkDeclarationValueQueryConcept_instance;
  function OntologyLinkDeclarationValueQueryConcept_getInstance() {
    if (OntologyLinkDeclarationValueQueryConcept_instance == null)
      new OntologyLinkDeclarationValueQueryConcept();
    return OntologyLinkDeclarationValueQueryConcept_instance;
  }
  function OntologyLinkValueImpl$_init_$ref_i717bx() {
    var l = function (p0, p1) {
      return new OntologyLinkValueImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function OntologyLinkValueConcept$_init_$lambda_fqor1x(context, nodeId) {
    return new TypedOntologyLinkValueImpl(context, VOID, nodeId);
  }
  function OntologyLinkValue$_get_linkReference_$ref_kx9ikt_0() {
    return function (p0) {
      return p0.cft();
    };
  }
  function OntologyLinkValueConcept() {
    OntologyLinkValueConcept_instance = this;
    var tmp = OntologyLinkValueImpl$_init_$ref_i717bx();
    OtConceptDescriptor.call(this, 'OntologyLinkValue', VOID, tmp, OntologyLinkValueConcept$_init_$lambda_fqor1x, Companion_instance_94.k6m([AbstractBindingValueConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    var tmp4 = getPropertyCallableRef('linkReference', 1, tmp_1, OntologyLinkValue$_get_linkReference_$ref_kx9ikt_0(), null);
    var tmp6 = Companion_getInstance_331().rh7_1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.referenceRole' call
    var name = 'linkReference';
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var tmp$ret$0 = new ReferenceLink(getKClass(OntologyLinkValue_1), tmp4, getKClass(AbstractLink), getKClass(QualifiedReferenceContent));
    tmp_0.ch8_1 = this.q6m(tmp$ret$0, tmp6, name);
    this.dh8_1 = new DomainNodeReferencePropertyDescriptor(this.ch8_1, ReferenceContentPersisters_getInstance().d6m(getKClass(QualifiedReferenceContent)), getKClass(QualifiedReferenceContent));
  }
  var OntologyLinkValueConcept_instance;
  function OntologyLinkValueConcept_getInstance() {
    if (OntologyLinkValueConcept_instance == null)
      new OntologyLinkValueConcept();
    return OntologyLinkValueConcept_instance;
  }
  function OrValueQueryImpl$_init_$ref_37c1cb() {
    var l = function (p0, p1) {
      return new OrValueQueryImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function OrValueQueryConcept$_init_$lambda_g6vdb1(context, nodeId) {
    return new TypedOrValueQueryImpl(context, VOID, nodeId);
  }
  function OrValueQuery$_get_left_$ref_6b13k3_0() {
    return function (p0) {
      return p0.dft();
    };
  }
  function OrValueQuery$_get_right_$ref_trhuiu_0() {
    return function (p0) {
      return p0.eft();
    };
  }
  function OrValueQueryConcept() {
    OrValueQueryConcept_instance = this;
    var tmp = OrValueQueryImpl$_init_$ref_37c1cb();
    OtConceptDescriptor.call(this, 'OrValueQuery', VOID, tmp, OrValueQueryConcept$_init_$lambda_g6vdb1, Companion_instance_94.k6m([AbstractBindingValueQueryConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_0 = getPropertyCallableRef('left', 1, tmp_1, OrValueQuery$_get_left_$ref_6b13k3_0(), null);
    var tmp$ret$0 = new SingleChildLink(getKClass(OrValueQuery_1), this_0);
    tmp_0.oh8_1 = this.o6m(tmp$ret$0, 'left');
    var tmp_2 = this;
    var tmp_3 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_1 = getPropertyCallableRef('right', 1, tmp_3, OrValueQuery$_get_right_$ref_trhuiu_0(), null);
    var tmp$ret$2 = new SingleChildLink(getKClass(OrValueQuery_1), this_1);
    tmp_2.ph8_1 = this.o6m(tmp$ret$2, 'right');
    this.qh8_1 = new DomainNodeChildPropertyDescriptor(this.oh8_1.s6i_1);
    this.rh8_1 = new DomainNodeChildPropertyDescriptor(this.ph8_1.s6i_1);
  }
  var OrValueQueryConcept_instance;
  function OrValueQueryConcept_getInstance() {
    if (OrValueQueryConcept_instance == null)
      new OrValueQueryConcept();
    return OrValueQueryConcept_instance;
  }
  function PageImpl$_init_$ref_kbrpsa() {
    var l = function (p0, p1) {
      return new PageImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function PageConcept$_init_$lambda_tkv4vm(context, nodeId) {
    return new TypedPageImpl(context, VOID, nodeId);
  }
  function Page$_get_page_$ref_r03c4g_0() {
    return function (p0) {
      return p0.fft();
    };
  }
  function PageConcept() {
    PageConcept_instance = this;
    var tmp = PageImpl$_init_$ref_kbrpsa();
    OtConceptDescriptor.call(this, 'Page', VOID, tmp, PageConcept$_init_$lambda_tkv4vm, Companion_instance_94.k6m([PageSpecificationConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    tmp_0.ch9_1 = this.r6m(getPropertyCallableRef('page', 1, tmp_1, Page$_get_page_$ref_r03c4g_0(), null), 'page');
    this.dh9_1 = new DomainNodePropertyDescriptor(this.ch9_1, toNonNullPersister(NonNullPersisters_getInstance().i25()));
  }
  var PageConcept_instance;
  function PageConcept_getInstance() {
    if (PageConcept_instance == null)
      new PageConcept();
    return PageConcept_instance;
  }
  function PageRangeImpl$_init_$ref_z18kzt() {
    var l = function (p0, p1) {
      return new PageRangeImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function PageRangeConcept$_init_$lambda_8hq6rz(context, nodeId) {
    return new TypedPageRangeImpl(context, VOID, nodeId);
  }
  function PageRange$_get_start_$ref_aos33s_0() {
    return function (p0) {
      return p0.p1();
    };
  }
  function PageRange$_get_end_$ref_yt6pin_0() {
    return function (p0) {
      return p0.lb4();
    };
  }
  function PageRangeConcept() {
    PageRangeConcept_instance = this;
    var tmp = PageRangeImpl$_init_$ref_z18kzt();
    OtConceptDescriptor.call(this, 'PageRange', VOID, tmp, PageRangeConcept$_init_$lambda_8hq6rz, Companion_instance_94.k6m([PageSpecificationConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    tmp_0.oh9_1 = this.r6m(getPropertyCallableRef('start', 1, tmp_1, PageRange$_get_start_$ref_aos33s_0(), null), 'start');
    var tmp_2 = this;
    var tmp_3 = KProperty1;
    tmp_2.ph9_1 = this.r6m(getPropertyCallableRef('end', 1, tmp_3, PageRange$_get_end_$ref_yt6pin_0(), null), 'end');
    this.qh9_1 = new DomainNodePropertyDescriptor(this.oh9_1, toNonNullPersister(NonNullPersisters_getInstance().i25()));
    this.rh9_1 = new DomainNodePropertyDescriptor(this.ph9_1, toNonNullPersister(NonNullPersisters_getInstance().i25()));
  }
  var PageRangeConcept_instance;
  function PageRangeConcept_getInstance() {
    if (PageRangeConcept_instance == null)
      new PageRangeConcept();
    return PageRangeConcept_instance;
  }
  function PageSpecificationConcept() {
    PageSpecificationConcept_instance = this;
    OTAbstractConceptDescriptor.call(this, Companion_instance_94.k6m([BTBNodeConcept_getInstance()]));
  }
  var PageSpecificationConcept_instance;
  function PageSpecificationConcept_getInstance() {
    if (PageSpecificationConcept_instance == null)
      new PageSpecificationConcept();
    return PageSpecificationConcept_instance;
  }
  function PaperImpl$_init_$ref_70aa1l() {
    var l = function (p0, p1) {
      return new PaperImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function PaperConcept$_init_$lambda_31s4y7(context, nodeId) {
    return new TypedPaperImpl(context, VOID, nodeId);
  }
  function Paper$_get_sourceShortTitle_$ref_ie9m1x_0() {
    return function (p0) {
      return p0.gft();
    };
  }
  function Paper$_get_sourceFullTitle_$ref_16bavu_0() {
    return function (p0) {
      return p0.hft();
    };
  }
  function Paper$_get_volume_$ref_y3o3l4_0() {
    return function (p0) {
      return p0.ift();
    };
  }
  function Paper$_get_issue_$ref_72q3ox_0() {
    return function (p0) {
      return p0.jft();
    };
  }
  function Paper$_get_pubMedId_$ref_8q78t4_0() {
    return function (p0) {
      return p0.kft();
    };
  }
  function Paper$_get_pmcId_$ref_yj2pzt_0() {
    return function (p0) {
      return p0.lft();
    };
  }
  function Paper$_get_doi_$ref_ww6hfa_0() {
    return function (p0) {
      return p0.mft();
    };
  }
  function Paper$_get_pages_$ref_56726c_0() {
    return function (p0) {
      return p0.nft();
    };
  }
  function PaperConcept() {
    PaperConcept_instance = this;
    var tmp = PaperImpl$_init_$ref_70aa1l();
    OtConceptDescriptor.call(this, 'Paper', VOID, tmp, PaperConcept$_init_$lambda_31s4y7, Companion_instance_94.k6m([PublishedWorkConcept_getInstance(), LibraryItemConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    tmp_0.cha_1 = this.r6m(getPropertyCallableRef('sourceShortTitle', 1, tmp_1, Paper$_get_sourceShortTitle_$ref_ie9m1x_0(), null), 'journalShortTitle');
    var tmp_2 = this;
    var tmp_3 = KProperty1;
    tmp_2.dha_1 = this.r6m(getPropertyCallableRef('sourceFullTitle', 1, tmp_3, Paper$_get_sourceFullTitle_$ref_16bavu_0(), null), 'journalFullTitle');
    var tmp_4 = this;
    var tmp_5 = KProperty1;
    tmp_4.eha_1 = this.r6m(getPropertyCallableRef('volume', 1, tmp_5, Paper$_get_volume_$ref_y3o3l4_0(), null), 'volume');
    var tmp_6 = this;
    var tmp_7 = KProperty1;
    tmp_6.fha_1 = this.r6m(getPropertyCallableRef('issue', 1, tmp_7, Paper$_get_issue_$ref_72q3ox_0(), null), 'issue');
    var tmp_8 = this;
    var tmp_9 = KProperty1;
    tmp_8.gha_1 = this.r6m(getPropertyCallableRef('pubMedId', 1, tmp_9, Paper$_get_pubMedId_$ref_8q78t4_0(), null), 'pubmedId');
    var tmp_10 = this;
    var tmp_11 = KProperty1;
    tmp_10.hha_1 = this.r6m(getPropertyCallableRef('pmcId', 1, tmp_11, Paper$_get_pmcId_$ref_yj2pzt_0(), null), 'pmcId');
    var tmp_12 = this;
    var tmp_13 = KProperty1;
    tmp_12.iha_1 = this.r6m(getPropertyCallableRef('doi', 1, tmp_13, Paper$_get_doi_$ref_ww6hfa_0(), null), 'doi');
    var tmp_14 = this;
    var tmp_15 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_0 = getPropertyCallableRef('pages', 1, tmp_15, Paper$_get_pages_$ref_56726c_0(), null);
    var tmp$ret$0 = new SingleChildLink(getKClass(Paper_1), this_0);
    tmp_14.jha_1 = this.o6m(tmp$ret$0, 'pages');
    this.kha_1 = new DomainNodePropertyDescriptor(this.cha_1, toNonNullPersister(NonNullPersisters_getInstance().h25(), new DefaultValueNullPersister('')));
    this.lha_1 = new DomainNodePropertyDescriptor(this.dha_1, toNonNullPersister(NonNullPersisters_getInstance().h25(), new DefaultValueNullPersister('')));
    this.mha_1 = new DomainNodePropertyDescriptor(this.eha_1, toNonNullPersister(NonNullPersisters_getInstance().h25(), new DefaultValueNullPersister('')));
    this.nha_1 = new DomainNodePropertyDescriptor(this.fha_1, toNonNullPersister(NonNullPersisters_getInstance().h25(), new DefaultValueNullPersister('')));
    this.oha_1 = new DomainNodePropertyDescriptor(this.gha_1, toNonNullPersister(NonNullPersisters_getInstance().h25(), new DefaultValueNullPersister('')));
    this.pha_1 = new DomainNodePropertyDescriptor(this.hha_1, toNonNullPersister(NonNullPersisters_getInstance().h25(), new DefaultValueNullPersister('')));
    this.qha_1 = new DomainNodePropertyDescriptor(this.iha_1, toNonNullPersister(NonNullPersisters_getInstance().h25(), new DefaultValueNullPersister('')));
    this.rha_1 = new DomainNodeChildPropertyDescriptor(this.jha_1.s6i_1);
  }
  var PaperConcept_instance;
  function PaperConcept_getInstance() {
    if (PaperConcept_instance == null)
      new PaperConcept();
    return PaperConcept_instance;
  }
  function PartReferenceOperationConcept() {
    PartReferenceOperationConcept_instance = this;
    OTAbstractConceptDescriptor.call(this, Companion_instance_94.k6m([BTBNodeConcept_getInstance()]));
  }
  var PartReferenceOperationConcept_instance;
  function PartReferenceOperationConcept_getInstance() {
    if (PartReferenceOperationConcept_instance == null)
      new PartReferenceOperationConcept();
    return PartReferenceOperationConcept_instance;
  }
  function PartValueImpl$_init_$ref_y3ek61() {
    var l = function (p0, p1) {
      return new PartValueImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function PartValueConcept$_init_$lambda_41hjep(context, nodeId) {
    return new TypedPartValueImpl(context, VOID, nodeId);
  }
  function PartValue$_get_operand_$ref_v35dwv_0() {
    return function (p0) {
      return p0.jfs();
    };
  }
  function PartValue$_get_operation_$ref_y8479p_0() {
    return function (p0) {
      return p0.s3z();
    };
  }
  function PartValueConcept() {
    PartValueConcept_instance = this;
    var tmp = PartValueImpl$_init_$ref_y3ek61();
    OtConceptDescriptor.call(this, 'PartValue', VOID, tmp, PartValueConcept$_init_$lambda_41hjep, Companion_instance_94.k6m([AbstractValueConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_0 = getPropertyCallableRef('operand', 1, tmp_1, PartValue$_get_operand_$ref_v35dwv_0(), null);
    var tmp$ret$0 = new SingleChildLink(getKClass(PartValue), this_0);
    tmp_0.chb_1 = this.o6m(tmp$ret$0, 'operand');
    var tmp_2 = this;
    var tmp_3 = KProperty1;
    var tmp4 = getPropertyCallableRef('operation', 1, tmp_3, PartValue$_get_operation_$ref_y8479p_0(), null);
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    var name = 'operation';
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$2 = new SingleChildLink(getKClass(PartValue), tmp4);
    tmp_2.dhb_1 = this.o6m(tmp$ret$2, name);
    this.ehb_1 = new DomainNodeChildPropertyDescriptor(this.chb_1.s6i_1);
    this.fhb_1 = new DomainNodeChildPropertyDescriptor(this.dhb_1.s6i_1);
  }
  var PartValueConcept_instance;
  function PartValueConcept_getInstance() {
    if (PartValueConcept_instance == null)
      new PartValueConcept();
    return PartValueConcept_instance;
  }
  function PatternConcept() {
    PatternConcept_instance = this;
    OTAbstractConceptDescriptor.call(this, Companion_instance_94.k6m([BTBNodeConcept_getInstance()]));
  }
  var PatternConcept_instance;
  function PatternConcept_getInstance() {
    if (PatternConcept_instance == null)
      new PatternConcept();
    return PatternConcept_instance;
  }
  function PreconditionImpl$_init_$ref_xg8r4d() {
    var l = function (p0, p1) {
      return new PreconditionImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function PreconditionConcept$_init_$lambda_84bf8l(context, nodeId) {
    return new TypedPreconditionImpl(context, VOID, nodeId);
  }
  function PreconditionConcept() {
    PreconditionConcept_instance = this;
    var tmp = PreconditionImpl$_init_$ref_xg8r4d();
    OtConceptDescriptor.call(this, 'Precondition', VOID, tmp, PreconditionConcept$_init_$lambda_84bf8l, Companion_instance_94.k6m([BTBNodeConcept_getInstance()]));
  }
  var PreconditionConcept_instance;
  function PreconditionConcept_getInstance() {
    if (PreconditionConcept_instance == null)
      new PreconditionConcept();
    return PreconditionConcept_instance;
  }
  function PrimitiveNotionTypeImpl$_init_$ref_o8yi3z() {
    var l = function (p0, p1) {
      return new PrimitiveNotionTypeImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function PrimitiveNotionTypeConcept$_init_$lambda_eomxfd(context, nodeId) {
    return new TypedPrimitiveNotionTypeImpl(context, VOID, nodeId);
  }
  function PrimitiveNotionType$_get_primitiveKind_$ref_8wvqnr_0() {
    return function (p0) {
      return p0.oft();
    };
  }
  function PrimitiveNotionTypeConcept$PRIMITIVE_KIND_PERSISTER$$inlined$enumPersister$1() {
  }
  protoOf(PrimitiveNotionTypeConcept$PRIMITIVE_KIND_PERSISTER$$inlined$enumPersister$1).v24 = function (value) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'jetbrains.ocelot.base.enums.Enums.valueOf' call
      // Inline function 'kotlin.enumValues' call
      var indexedObject = values_18();
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var e = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        if (value === e.toString()) {
          tmp$ret$1 = e;
          break $l$block;
        }
      }
      throw IllegalArgumentException_init_$Create$_0(value);
    }
    return tmp$ret$1;
  };
  protoOf(PrimitiveNotionTypeConcept$PRIMITIVE_KIND_PERSISTER$$inlined$enumPersister$1).ghb = function (value) {
    return value.toString();
  };
  protoOf(PrimitiveNotionTypeConcept$PRIMITIVE_KIND_PERSISTER$$inlined$enumPersister$1).w24 = function (value) {
    return this.ghb(value instanceof PrimitiveKind_0 ? value : THROW_CCE());
  };
  protoOf(PrimitiveNotionTypeConcept$PRIMITIVE_KIND_PERSISTER$$inlined$enumPersister$1).toString = function () {
    return 'enumPersister';
  };
  function PrimitiveNotionTypeConcept$primitiveKindPropertyDescriptor$$inlined$enumPersister$1() {
  }
  protoOf(PrimitiveNotionTypeConcept$primitiveKindPropertyDescriptor$$inlined$enumPersister$1).v24 = function (value) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'jetbrains.ocelot.base.enums.Enums.valueOf' call
      // Inline function 'kotlin.enumValues' call
      var indexedObject = values_18();
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var e = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        if (value === e.toString()) {
          tmp$ret$1 = e;
          break $l$block;
        }
      }
      throw IllegalArgumentException_init_$Create$_0(value);
    }
    return tmp$ret$1;
  };
  protoOf(PrimitiveNotionTypeConcept$primitiveKindPropertyDescriptor$$inlined$enumPersister$1).ghb = function (value) {
    return value.toString();
  };
  protoOf(PrimitiveNotionTypeConcept$primitiveKindPropertyDescriptor$$inlined$enumPersister$1).w24 = function (value) {
    return this.ghb(value instanceof PrimitiveKind_0 ? value : THROW_CCE());
  };
  protoOf(PrimitiveNotionTypeConcept$primitiveKindPropertyDescriptor$$inlined$enumPersister$1).toString = function () {
    return 'enumPersister';
  };
  function PrimitiveNotionTypeConcept() {
    PrimitiveNotionTypeConcept_instance = this;
    var tmp = PrimitiveNotionTypeImpl$_init_$ref_o8yi3z();
    OtConceptDescriptor.call(this, 'PrimitiveNotionType', VOID, tmp, PrimitiveNotionTypeConcept$_init_$lambda_eomxfd, Companion_instance_94.k6m([TypeConcept_getInstance(), AllowedComplexNotionTypeConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    tmp_0.rhb_1 = this.r6m(getPropertyCallableRef('primitiveKind', 1, tmp_1, PrimitiveNotionType$_get_primitiveKind_$ref_8wvqnr_0(), null), 'primitiveKind');
    var tmp_2 = this;
    // Inline function 'jetbrains.ocelot.base.persister.NonNullPersisters.enumPersister' call
    NonNullPersisters_getInstance();
    var tmp$ret$0 = new PrimitiveNotionTypeConcept$PRIMITIVE_KIND_PERSISTER$$inlined$enumPersister$1();
    tmp_2.shb_1 = toNullablePersister(tmp$ret$0);
    var tmp_3 = this;
    // Inline function 'jetbrains.ocelot.base.persister.NonNullPersisters.enumPersister' call
    NonNullPersisters_getInstance();
    var tmp$ret$1 = new PrimitiveNotionTypeConcept$primitiveKindPropertyDescriptor$$inlined$enumPersister$1();
    tmp_3.thb_1 = new DomainNodePropertyDescriptor(this.rhb_1, toNullablePersister(tmp$ret$1));
  }
  var PrimitiveNotionTypeConcept_instance;
  function PrimitiveNotionTypeConcept_getInstance() {
    if (PrimitiveNotionTypeConcept_instance == null)
      new PrimitiveNotionTypeConcept();
    return PrimitiveNotionTypeConcept_instance;
  }
  function PrimitivePropertyTypeImpl$_init_$ref_lfom0f() {
    var l = function (p0, p1) {
      return new PrimitivePropertyTypeImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function PrimitivePropertyTypeConcept$_init_$lambda_91gho9(context, nodeId) {
    return new TypedPrimitivePropertyTypeImpl(context, VOID, nodeId);
  }
  function PrimitivePropertyType$_get_primitiveKind_$ref_evjzav_0() {
    return function (p0) {
      return p0.oft();
    };
  }
  function PrimitivePropertyTypeConcept$PRIMITIVE_KIND_PERSISTER$$inlined$enumPersister$1() {
  }
  protoOf(PrimitivePropertyTypeConcept$PRIMITIVE_KIND_PERSISTER$$inlined$enumPersister$1).v24 = function (value) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'jetbrains.ocelot.base.enums.Enums.valueOf' call
      // Inline function 'kotlin.enumValues' call
      var indexedObject = values_18();
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var e = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        if (value === e.toString()) {
          tmp$ret$1 = e;
          break $l$block;
        }
      }
      throw IllegalArgumentException_init_$Create$_0(value);
    }
    return tmp$ret$1;
  };
  protoOf(PrimitivePropertyTypeConcept$PRIMITIVE_KIND_PERSISTER$$inlined$enumPersister$1).ghb = function (value) {
    return value.toString();
  };
  protoOf(PrimitivePropertyTypeConcept$PRIMITIVE_KIND_PERSISTER$$inlined$enumPersister$1).w24 = function (value) {
    return this.ghb(value instanceof PrimitiveKind_0 ? value : THROW_CCE());
  };
  protoOf(PrimitivePropertyTypeConcept$PRIMITIVE_KIND_PERSISTER$$inlined$enumPersister$1).toString = function () {
    return 'enumPersister';
  };
  function PrimitivePropertyTypeConcept$primitiveKindPropertyDescriptor$$inlined$enumPersister$1() {
  }
  protoOf(PrimitivePropertyTypeConcept$primitiveKindPropertyDescriptor$$inlined$enumPersister$1).v24 = function (value) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'jetbrains.ocelot.base.enums.Enums.valueOf' call
      // Inline function 'kotlin.enumValues' call
      var indexedObject = values_18();
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var e = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        if (value === e.toString()) {
          tmp$ret$1 = e;
          break $l$block;
        }
      }
      throw IllegalArgumentException_init_$Create$_0(value);
    }
    return tmp$ret$1;
  };
  protoOf(PrimitivePropertyTypeConcept$primitiveKindPropertyDescriptor$$inlined$enumPersister$1).ghb = function (value) {
    return value.toString();
  };
  protoOf(PrimitivePropertyTypeConcept$primitiveKindPropertyDescriptor$$inlined$enumPersister$1).w24 = function (value) {
    return this.ghb(value instanceof PrimitiveKind_0 ? value : THROW_CCE());
  };
  protoOf(PrimitivePropertyTypeConcept$primitiveKindPropertyDescriptor$$inlined$enumPersister$1).toString = function () {
    return 'enumPersister';
  };
  function PrimitivePropertyTypeConcept() {
    PrimitivePropertyTypeConcept_instance = this;
    var tmp = PrimitivePropertyTypeImpl$_init_$ref_lfom0f();
    OtConceptDescriptor.call(this, 'PrimitivePropertyType', VOID, tmp, PrimitivePropertyTypeConcept$_init_$lambda_91gho9, Companion_instance_94.k6m([ProcessPropertyTypeConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    tmp_0.ehc_1 = this.r6m(getPropertyCallableRef('primitiveKind', 1, tmp_1, PrimitivePropertyType$_get_primitiveKind_$ref_evjzav_0(), null), 'primitiveKind');
    var tmp_2 = this;
    // Inline function 'jetbrains.ocelot.base.persister.NonNullPersisters.enumPersister' call
    NonNullPersisters_getInstance();
    var tmp$ret$0 = new PrimitivePropertyTypeConcept$PRIMITIVE_KIND_PERSISTER$$inlined$enumPersister$1();
    tmp_2.fhc_1 = toNullablePersister(tmp$ret$0);
    var tmp_3 = this;
    // Inline function 'jetbrains.ocelot.base.persister.NonNullPersisters.enumPersister' call
    NonNullPersisters_getInstance();
    var tmp$ret$1 = new PrimitivePropertyTypeConcept$primitiveKindPropertyDescriptor$$inlined$enumPersister$1();
    tmp_3.ghc_1 = new DomainNodePropertyDescriptor(this.ehc_1, toNullablePersister(tmp$ret$1));
  }
  var PrimitivePropertyTypeConcept_instance;
  function PrimitivePropertyTypeConcept_getInstance() {
    if (PrimitivePropertyTypeConcept_instance == null)
      new PrimitivePropertyTypeConcept();
    return PrimitivePropertyTypeConcept_instance;
  }
  function ProcessDeclarationImpl$_init_$ref_zcz0sm() {
    var l = function (p0, p1) {
      return new ProcessDeclarationImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function ProcessDeclarationConcept$_init_$lambda_8sxbse(context, nodeId) {
    return new TypedProcessDeclarationImpl(context, VOID, nodeId);
  }
  function ProcessDeclaration$_get_kind_$ref_2xm341_0() {
    return function (p0) {
      return p0.r5a();
    };
  }
  function ProcessDeclaration$_get_extends_$ref_8vc9n2_0() {
    return function (p0) {
      return p0.pft();
    };
  }
  function ProcessDeclaration$_get_inherited_$ref_wglzfx_0() {
    return function (p0) {
      return p0.qft();
    };
  }
  function ProcessDeclaration$_get_prerequisites_$ref_h8hogm_0() {
    return function (p0) {
      return p0.rft();
    };
  }
  function ProcessDeclaration$_get_effects_$ref_9vh0jp_0() {
    return function (p0) {
      return p0.sft();
    };
  }
  function ProcessDeclaration$_get_urls_$ref_6bvrzj_0() {
    return function (p0) {
      return p0.tft();
    };
  }
  function ProcessDeclaration$_get_inheritedProperties_$ref_y4og6_0() {
    return function (p0) {
      return p0.uft();
    };
  }
  function ProcessDeclarationConcept() {
    ProcessDeclarationConcept_instance = this;
    var tmp = ProcessDeclarationImpl$_init_$ref_zcz0sm();
    OtConceptDescriptor.call(this, 'ProcessDeclaration', VOID, tmp, ProcessDeclarationConcept$_init_$lambda_8sxbse, Companion_instance_94.k6m([AbstractBindingDeclarationConcept_getInstance(), HasVariablesConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    var tmp4 = getPropertyCallableRef('kind', 1, tmp_1, ProcessDeclaration$_get_kind_$ref_2xm341_0(), null);
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.referenceRole' call
    var tag = Companion_getInstance_338().hhc_1;
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var tmp$ret$0 = new ReferenceLink(getKClass(ProcessDeclaration_1), tmp4, getKClass(ProcessKind_1), getKClass(QualifiedReferenceContent));
    tmp_0.uhc_1 = this.q6m(tmp$ret$0, tag, 'kind');
    var tmp_2 = this;
    var tmp_3 = KProperty1;
    var tmp4_0 = getPropertyCallableRef('extends', 1, tmp_3, ProcessDeclaration$_get_extends_$ref_8vc9n2_0(), null);
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.referenceRole' call
    var tag_0 = Companion_getInstance_338().ihc_1;
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var tmp$ret$2 = new ReferenceLink(getKClass(ProcessDeclaration_1), tmp4_0, getKClass(ProcessDeclaration_1), getKClass(QualifiedReferenceContent));
    tmp_2.vhc_1 = this.q6m(tmp$ret$2, tag_0, 'extends');
    var tmp_4 = this;
    var tmp_5 = KProperty1;
    var tmp4_1 = getPropertyCallableRef('inherited', 1, tmp_5, ProcessDeclaration$_get_inherited_$ref_wglzfx_0(), null);
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childrenRole' call
    var name = 'inherited';
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$4 = new MultipleChildLink(getKClass(ProcessDeclaration_1), tmp4_1);
    tmp_4.whc_1 = this.p6m(tmp$ret$4, name);
    var tmp_6 = this;
    var tmp_7 = KProperty1;
    var tmp4_2 = getPropertyCallableRef('prerequisites', 1, tmp_7, ProcessDeclaration$_get_prerequisites_$ref_h8hogm_0(), null);
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childrenRole' call
    var name_0 = 'prerequisites';
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$6 = new MultipleChildLink(getKClass(ProcessDeclaration_1), tmp4_2);
    tmp_6.xhc_1 = this.p6m(tmp$ret$6, name_0);
    var tmp_8 = this;
    var tmp_9 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childrenRole' call
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_0 = getPropertyCallableRef('effects', 1, tmp_9, ProcessDeclaration$_get_effects_$ref_9vh0jp_0(), null);
    var tmp$ret$8 = new MultipleChildLink(getKClass(ProcessDeclaration_1), this_0);
    tmp_8.yhc_1 = this.p6m(tmp$ret$8, 'effects');
    var tmp_10 = this;
    var tmp_11 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childrenRole' call
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_1 = getPropertyCallableRef('urls', 1, tmp_11, ProcessDeclaration$_get_urls_$ref_6bvrzj_0(), null);
    var tmp$ret$10 = new MultipleChildLink(getKClass(ProcessDeclaration_1), this_1);
    tmp_10.zhc_1 = this.p6m(tmp$ret$10, 'urls');
    var tmp_12 = this;
    var tmp_13 = KProperty1;
    var tmp4_3 = getPropertyCallableRef('inheritedProperties', 1, tmp_13, ProcessDeclaration$_get_inheritedProperties_$ref_y4og6_0(), null);
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childrenRole' call
    var name_1 = 'inheritedProperties';
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$12 = new MultipleChildLink(getKClass(ProcessDeclaration_1), tmp4_3);
    tmp_12.ahd_1 = this.p6m(tmp$ret$12, name_1);
    this.bhd_1 = new DomainNodeReferencePropertyDescriptor(this.uhc_1, ReferenceContentPersisters_getInstance().d6m(getKClass(QualifiedReferenceContent)), getKClass(QualifiedReferenceContent));
    this.chd_1 = new DomainNodeReferencePropertyDescriptor(this.vhc_1, ReferenceContentPersisters_getInstance().d6m(getKClass(QualifiedReferenceContent)), getKClass(QualifiedReferenceContent));
    this.dhd_1 = new DomainNodeChildrenPropertyDescriptor(this.whc_1.s6i_1);
    this.ehd_1 = new DomainNodeChildrenPropertyDescriptor(this.xhc_1.s6i_1);
    this.fhd_1 = new DomainNodeChildrenPropertyDescriptor(this.yhc_1.s6i_1);
    this.ghd_1 = new DomainNodeChildrenPropertyDescriptor(this.zhc_1.s6i_1);
    this.hhd_1 = new DomainNodeChildrenPropertyDescriptor(this.ahd_1.s6i_1);
  }
  var ProcessDeclarationConcept_instance;
  function ProcessDeclarationConcept_getInstance() {
    if (ProcessDeclarationConcept_instance == null)
      new ProcessDeclarationConcept();
    return ProcessDeclarationConcept_instance;
  }
  function ProcessEffectImpl$_init_$ref_ybssb() {
    var l = function (p0, p1) {
      return new ProcessEffectImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function ProcessEffectConcept$_init_$lambda_4yzx25(context, nodeId) {
    return new TypedProcessEffectImpl(context, VOID, nodeId);
  }
  function ProcessEffect$_get_entry_$ref_q4qg2e_0() {
    return function (p0) {
      return p0.vft();
    };
  }
  function ProcessEffectConcept() {
    ProcessEffectConcept_instance = this;
    var tmp = ProcessEffectImpl$_init_$ref_ybssb();
    OtConceptDescriptor.call(this, 'ProcessEffect', VOID, tmp, ProcessEffectConcept$_init_$lambda_4yzx25, Companion_instance_94.k6m([HasQueryLabelsConcept_getInstance(), HasFactExpressionConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    tmp_0.shd_1 = this.r6m(getPropertyCallableRef('entry', 1, tmp_1, ProcessEffect$_get_entry_$ref_q4qg2e_0(), null), 'entry');
    this.thd_1 = new DomainNodePropertyDescriptor(this.shd_1, toNonNullPersister(NonNullPersisters_getInstance().k25(), new DefaultValueNullPersister(false)));
  }
  var ProcessEffectConcept_instance;
  function ProcessEffectConcept_getInstance() {
    if (ProcessEffectConcept_instance == null)
      new ProcessEffectConcept();
    return ProcessEffectConcept_instance;
  }
  function ProcessKindImpl$_init_$ref_p3yogy() {
    var l = function (p0, p1) {
      return new ProcessKindImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function ProcessKindConcept$_init_$lambda_7l5r96(context, nodeId) {
    return new TypedProcessKindImpl(context, VOID, nodeId);
  }
  function ProcessKindConcept() {
    ProcessKindConcept_instance = this;
    var tmp = ProcessKindImpl$_init_$ref_p3yogy();
    OtConceptDescriptor.call(this, 'ProcessKind', VOID, tmp, ProcessKindConcept$_init_$lambda_7l5r96, Companion_instance_94.k6m([BTBNodeConcept_getInstance(), DirectlyNamedConcept_getInstance()]));
  }
  var ProcessKindConcept_instance;
  function ProcessKindConcept_getInstance() {
    if (ProcessKindConcept_instance == null)
      new ProcessKindConcept();
    return ProcessKindConcept_instance;
  }
  function ProcessKindContainerImpl$_init_$ref_e5alaf() {
    var l = function (p0, p1) {
      return new ProcessKindContainerImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function ProcessKindContainerConcept$_init_$lambda_ls1vhd(context, nodeId) {
    return new TypedProcessKindContainerImpl(context, VOID, nodeId);
  }
  function ProcessKindContainer$_get_kinds_$ref_mesqat_0() {
    return function (p0) {
      return p0.wft();
    };
  }
  function ProcessKindContainerConcept() {
    ProcessKindContainerConcept_instance = this;
    var tmp = ProcessKindContainerImpl$_init_$ref_e5alaf();
    OtConceptDescriptor.call(this, 'ProcessKindContainer', VOID, tmp, ProcessKindContainerConcept$_init_$lambda_ls1vhd, Companion_instance_94.k6m([DocumentNodeConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childrenRole' call
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_0 = getPropertyCallableRef('kinds', 1, tmp_1, ProcessKindContainer$_get_kinds_$ref_mesqat_0(), null);
    var tmp$ret$0 = new MultipleChildLink(getKClass(ProcessKindContainer_1), this_0);
    tmp_0.ehe_1 = this.p6m(tmp$ret$0, 'kinds');
    this.fhe_1 = new DomainNodeChildrenPropertyDescriptor(this.ehe_1.s6i_1);
  }
  var ProcessKindContainerConcept_instance;
  function ProcessKindContainerConcept_getInstance() {
    if (ProcessKindContainerConcept_instance == null)
      new ProcessKindContainerConcept();
    return ProcessKindContainerConcept_instance;
  }
  function ProcessLibraryImpl$_init_$ref_l0hpi1() {
    var l = function (p0, p1) {
      return new ProcessLibraryImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function ProcessLibraryConcept$_init_$lambda_hjws1d(context, nodeId) {
    return new TypedProcessLibraryImpl(context, VOID, nodeId);
  }
  function ProcessLibrary$_get_processes_$ref_ex5w39_0() {
    return function (p0) {
      return p0.xft();
    };
  }
  function ProcessLibraryConcept() {
    ProcessLibraryConcept_instance = this;
    var tmp = ProcessLibraryImpl$_init_$ref_l0hpi1();
    OtConceptDescriptor.call(this, 'ProcessLibrary', VOID, tmp, ProcessLibraryConcept$_init_$lambda_hjws1d, Companion_instance_94.k6m([DocumentNodeConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    var tmp4 = getPropertyCallableRef('processes', 1, tmp_1, ProcessLibrary$_get_processes_$ref_ex5w39_0(), null);
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childrenRole' call
    var name = 'processes';
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$0 = new MultipleChildLink(getKClass(ProcessLibrary_1), tmp4);
    tmp_0.qhe_1 = this.p6m(tmp$ret$0, name);
    this.rhe_1 = new DomainNodeChildrenPropertyDescriptor(this.qhe_1.s6i_1);
  }
  var ProcessLibraryConcept_instance;
  function ProcessLibraryConcept_getInstance() {
    if (ProcessLibraryConcept_instance == null)
      new ProcessLibraryConcept();
    return ProcessLibraryConcept_instance;
  }
  function ProcessPrerequisiteImpl$_init_$ref_8xi1hc() {
    var l = function (p0, p1) {
      return new ProcessPrerequisiteImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function ProcessPrerequisiteConcept$_init_$lambda_ubdkd4(context, nodeId) {
    return new TypedProcessPrerequisiteImpl(context, VOID, nodeId);
  }
  function ProcessPrerequisiteConcept() {
    ProcessPrerequisiteConcept_instance = this;
    var tmp = ProcessPrerequisiteImpl$_init_$ref_8xi1hc();
    OtConceptDescriptor.call(this, 'ProcessPrerequisite', VOID, tmp, ProcessPrerequisiteConcept$_init_$lambda_ubdkd4, Companion_instance_94.k6m([HasQueryLabelsConcept_getInstance(), HasFactExpressionConcept_getInstance()]));
  }
  var ProcessPrerequisiteConcept_instance;
  function ProcessPrerequisiteConcept_getInstance() {
    if (ProcessPrerequisiteConcept_instance == null)
      new ProcessPrerequisiteConcept();
    return ProcessPrerequisiteConcept_instance;
  }
  function ProcessPropertyImpl$_init_$ref_heo8zj() {
    var l = function (p0, p1) {
      return new ProcessPropertyImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function ProcessPropertyConcept$_init_$lambda_24cp2f(context, nodeId) {
    return new TypedProcessPropertyImpl(context, VOID, nodeId);
  }
  function ProcessProperty$_get_type_$ref_nw63hc_0() {
    return function (p0) {
      return p0.sfq();
    };
  }
  function ProcessProperty$_get_aliasedProperties_$ref_lzqazi_0() {
    return function (p0) {
      return p0.yft();
    };
  }
  function ProcessProperty$_get_default_$ref_tilfgf_0() {
    return function (p0) {
      return p0.g3b();
    };
  }
  function ProcessPropertyConcept() {
    ProcessPropertyConcept_instance = this;
    var tmp = ProcessPropertyImpl$_init_$ref_heo8zj();
    OtConceptDescriptor.call(this, 'ProcessProperty', VOID, tmp, ProcessPropertyConcept$_init_$lambda_24cp2f, Companion_instance_94.k6m([BTBNodeConcept_getInstance(), DirectlyNamedConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_0 = getPropertyCallableRef('type', 1, tmp_1, ProcessProperty$_get_type_$ref_nw63hc_0(), null);
    var tmp$ret$0 = new SingleChildLink(getKClass(ProcessProperty_1), this_0);
    tmp_0.chf_1 = this.o6m(tmp$ret$0, 'type');
    var tmp_2 = this;
    var tmp_3 = KProperty1;
    var tmp4 = getPropertyCallableRef('aliasedProperties', 1, tmp_3, ProcessProperty$_get_aliasedProperties_$ref_lzqazi_0(), null);
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childrenRole' call
    var name = 'aliasedProperties';
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$2 = new MultipleChildLink(getKClass(ProcessProperty_1), tmp4);
    tmp_2.dhf_1 = this.p6m(tmp$ret$2, name);
    var tmp_4 = this;
    var tmp_5 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_1 = getPropertyCallableRef('default', 1, tmp_5, ProcessProperty$_get_default_$ref_tilfgf_0(), null);
    var tmp$ret$4 = new SingleChildLink(getKClass(ProcessProperty_1), this_1);
    tmp_4.ehf_1 = this.o6m(tmp$ret$4, 'default');
    this.fhf_1 = new DomainNodeChildPropertyDescriptor(this.chf_1.s6i_1);
    this.ghf_1 = new DomainNodeChildrenPropertyDescriptor(this.dhf_1.s6i_1);
    this.hhf_1 = new DomainNodeChildPropertyDescriptor(this.ehf_1.s6i_1);
  }
  var ProcessPropertyConcept_instance;
  function ProcessPropertyConcept_getInstance() {
    if (ProcessPropertyConcept_instance == null)
      new ProcessPropertyConcept();
    return ProcessPropertyConcept_instance;
  }
  function ProcessPropertyCustomCellImpl$_init_$ref_3fib6() {
    var l = function (p0, p1) {
      return new ProcessPropertyCustomCellImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function ProcessPropertyCustomCellConcept$_init_$lambda_22h7ru(context, nodeId) {
    return new TypedProcessPropertyCustomCellImpl(context, VOID, nodeId);
  }
  function ProcessPropertyCustomCell$_get_property_$ref_xoqnwu_0() {
    return function (p0) {
      return p0.q6q();
    };
  }
  function ProcessPropertyCustomCellConcept() {
    ProcessPropertyCustomCellConcept_instance = this;
    var tmp = ProcessPropertyCustomCellImpl$_init_$ref_3fib6();
    OtConceptDescriptor.call(this, 'ProcessPropertyCustomCell', VOID, tmp, ProcessPropertyCustomCellConcept$_init_$lambda_22h7ru, Companion_instance_94.k6m([CustomCellConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    var tmp4 = getPropertyCallableRef('property', 1, tmp_1, ProcessPropertyCustomCell$_get_property_$ref_xoqnwu_0(), null);
    var tmp6 = Companion_getInstance_322().ihf_1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.referenceRole' call
    var name = 'processProperty';
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var tmp$ret$0 = new ReferenceLink(getKClass(ProcessPropertyCustomCell_1), tmp4, getKClass(ProcessProperty_1), getKClass(QualifiedReferenceContent));
    tmp_0.thf_1 = this.q6m(tmp$ret$0, tmp6, name);
    this.uhf_1 = new DomainNodeReferencePropertyDescriptor(this.thf_1, ReferenceContentPersisters_getInstance().d6m(getKClass(QualifiedReferenceContent)), getKClass(QualifiedReferenceContent));
  }
  var ProcessPropertyCustomCellConcept_instance;
  function ProcessPropertyCustomCellConcept_getInstance() {
    if (ProcessPropertyCustomCellConcept_instance == null)
      new ProcessPropertyCustomCellConcept();
    return ProcessPropertyCustomCellConcept_instance;
  }
  function ProcessPropertyDefaultImpl$_init_$ref_c88qt4() {
    var l = function (p0, p1) {
      return new ProcessPropertyDefaultImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function ProcessPropertyDefaultConcept$_init_$lambda_krbjog(context, nodeId) {
    return new TypedProcessPropertyDefaultImpl(context, VOID, nodeId);
  }
  function ProcessPropertyDefault$_get_value_$ref_p903q0_0() {
    return function (p0) {
      return p0.a1();
    };
  }
  function ProcessPropertyDefaultConcept() {
    ProcessPropertyDefaultConcept_instance = this;
    var tmp = ProcessPropertyDefaultImpl$_init_$ref_c88qt4();
    OtConceptDescriptor.call(this, 'ProcessPropertyDefault', VOID, tmp, ProcessPropertyDefaultConcept$_init_$lambda_krbjog, Companion_instance_94.k6m([BTBNodeConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_0 = getPropertyCallableRef('value', 1, tmp_1, ProcessPropertyDefault$_get_value_$ref_p903q0_0(), null);
    var tmp$ret$0 = new SingleChildLink(getKClass(ProcessPropertyDefault_1), this_0);
    tmp_0.fhg_1 = this.o6m(tmp$ret$0, 'value');
    this.ghg_1 = new DomainNodeChildPropertyDescriptor(this.fhg_1.s6i_1);
  }
  var ProcessPropertyDefaultConcept_instance;
  function ProcessPropertyDefaultConcept_getInstance() {
    if (ProcessPropertyDefaultConcept_instance == null)
      new ProcessPropertyDefaultConcept();
    return ProcessPropertyDefaultConcept_instance;
  }
  function ProcessPropertyReferenceImpl$_init_$ref_l9uygu() {
    var l = function (p0, p1) {
      return new ProcessPropertyReferenceImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function ProcessPropertyReferenceConcept$_init_$lambda_tzmre2(context, nodeId) {
    return new TypedProcessPropertyReferenceImpl(context, VOID, nodeId);
  }
  function ProcessPropertyReference$_get_property_$ref_cvezoe_0() {
    return function (p0) {
      return p0.q6q();
    };
  }
  function ProcessPropertyReferenceConcept() {
    ProcessPropertyReferenceConcept_instance = this;
    var tmp = ProcessPropertyReferenceImpl$_init_$ref_l9uygu();
    OtConceptDescriptor.call(this, 'ProcessPropertyReference', VOID, tmp, ProcessPropertyReferenceConcept$_init_$lambda_tzmre2, Companion_instance_94.k6m([VariableInitializerConcept_getInstance(), FactExpressionConcept_getInstance(), AbstractValueConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    var tmp4 = getPropertyCallableRef('property', 1, tmp_1, ProcessPropertyReference$_get_property_$ref_cvezoe_0(), null);
    var tmp6 = Companion_getInstance_340().hhg_1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.referenceRole' call
    var name = 'propertyReference';
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var tmp$ret$0 = new ReferenceLink(getKClass(ProcessPropertyReference), tmp4, getKClass(ProcessProperty_1), getKClass(QualifiedReferenceContent));
    tmp_0.shg_1 = this.q6m(tmp$ret$0, tmp6, name);
    this.thg_1 = new DomainNodeReferencePropertyDescriptor(this.shg_1, ReferenceContentPersisters_getInstance().d6m(getKClass(QualifiedReferenceContent)), getKClass(QualifiedReferenceContent));
  }
  var ProcessPropertyReferenceConcept_instance;
  function ProcessPropertyReferenceConcept_getInstance() {
    if (ProcessPropertyReferenceConcept_instance == null)
      new ProcessPropertyReferenceConcept();
    return ProcessPropertyReferenceConcept_instance;
  }
  function ProcessPropertyTypeConcept() {
    ProcessPropertyTypeConcept_instance = this;
    OTAbstractConceptDescriptor.call(this, Companion_instance_94.k6m([ProcessPropertyValueRangeConcept_getInstance()]));
  }
  var ProcessPropertyTypeConcept_instance;
  function ProcessPropertyTypeConcept_getInstance() {
    if (ProcessPropertyTypeConcept_instance == null)
      new ProcessPropertyTypeConcept();
    return ProcessPropertyTypeConcept_instance;
  }
  function ProcessPropertyValueImpl$_init_$ref_xdb0tk() {
    var l = function (p0, p1) {
      return new ProcessPropertyValueImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function ProcessPropertyValueConcept$_init_$lambda_f39m6o(context, nodeId) {
    return new TypedProcessPropertyValueImpl(context, VOID, nodeId);
  }
  function ProcessPropertyValue$_get_property_$ref_uw44qs_0() {
    return function (p0) {
      return p0.q6q();
    };
  }
  function ProcessPropertyValue$_get_value_$ref_tp5tnc_0() {
    return function (p0) {
      return p0.a1();
    };
  }
  function ProcessPropertyValueConcept() {
    ProcessPropertyValueConcept_instance = this;
    var tmp = ProcessPropertyValueImpl$_init_$ref_xdb0tk();
    OtConceptDescriptor.call(this, 'ProcessPropertyValue', VOID, tmp, ProcessPropertyValueConcept$_init_$lambda_f39m6o, Companion_instance_94.k6m([BindingValuePlaceholderConcept_getInstance(), HasQueryLabelsConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    var tmp4 = getPropertyCallableRef('property', 1, tmp_1, ProcessPropertyValue$_get_property_$ref_uw44qs_0(), null);
    var tmp6 = Companion_getInstance_318().uhg_1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.referenceRole' call
    var name = 'property';
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var tmp$ret$0 = new ReferenceLink(getKClass(ProcessPropertyValue_1), tmp4, getKClass(ProcessProperty_1), getKClass(QualifiedReferenceContent));
    tmp_0.fhh_1 = this.q6m(tmp$ret$0, tmp6, name);
    var tmp_2 = this;
    var tmp_3 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_0 = getPropertyCallableRef('value', 1, tmp_3, ProcessPropertyValue$_get_value_$ref_tp5tnc_0(), null);
    var tmp$ret$2 = new SingleChildLink(getKClass(ProcessPropertyValue_1), this_0);
    tmp_2.ghh_1 = this.o6m(tmp$ret$2, 'value');
    this.hhh_1 = new DomainNodeReferencePropertyDescriptor(this.fhh_1, ReferenceContentPersisters_getInstance().d6m(getKClass(QualifiedReferenceContent)), getKClass(QualifiedReferenceContent));
    this.ihh_1 = new DomainNodeChildPropertyDescriptor(this.ghh_1.s6i_1);
  }
  var ProcessPropertyValueConcept_instance;
  function ProcessPropertyValueConcept_getInstance() {
    if (ProcessPropertyValueConcept_instance == null)
      new ProcessPropertyValueConcept();
    return ProcessPropertyValueConcept_instance;
  }
  function ProcessPropertyValueRangeConcept() {
    ProcessPropertyValueRangeConcept_instance = this;
    OTAbstractConceptDescriptor.call(this, Companion_instance_94.k6m([BTBNodeConcept_getInstance()]));
  }
  var ProcessPropertyValueRangeConcept_instance;
  function ProcessPropertyValueRangeConcept_getInstance() {
    if (ProcessPropertyValueRangeConcept_instance == null)
      new ProcessPropertyValueRangeConcept();
    return ProcessPropertyValueRangeConcept_instance;
  }
  function ProcessProviderConcept() {
    ProcessProviderConcept_instance = this;
    OTAbstractConceptDescriptor.call(this, Companion_instance_94.k6m([BTBNodeConcept_getInstance()]));
  }
  var ProcessProviderConcept_instance;
  function ProcessProviderConcept_getInstance() {
    if (ProcessProviderConcept_instance == null)
      new ProcessProviderConcept();
    return ProcessProviderConcept_instance;
  }
  function ProcessReferenceImpl$_init_$ref_k2mg3b() {
    var l = function (p0, p1) {
      return new ProcessReferenceImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function ProcessReferenceConcept$_init_$lambda_n8m65d(context, nodeId) {
    return new TypedProcessReferenceImpl(context, VOID, nodeId);
  }
  function ProcessReference$_get_process_$ref_dj3f61_0() {
    return function (p0) {
      return p0.vfr();
    };
  }
  function ProcessReferenceConcept() {
    ProcessReferenceConcept_instance = this;
    var tmp = ProcessReferenceImpl$_init_$ref_k2mg3b();
    OtConceptDescriptor.call(this, 'ProcessReference', VOID, tmp, ProcessReferenceConcept$_init_$lambda_n8m65d, Companion_instance_94.k6m([BTBNodeConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    var tmp4 = getPropertyCallableRef('process', 1, tmp_1, ProcessReference$_get_process_$ref_dj3f61_0(), null);
    var tmp6 = Companion_getInstance_339().jhh_1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.referenceRole' call
    var name = 'processRef';
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var tmp$ret$0 = new ReferenceLink(getKClass(ProcessReference_1), tmp4, getKClass(ProcessDeclaration_1), getKClass(QualifiedReferenceContent));
    tmp_0.uhh_1 = this.q6m(tmp$ret$0, tmp6, name);
    this.vhh_1 = new DomainNodeReferencePropertyDescriptor(this.uhh_1, ReferenceContentPersisters_getInstance().d6m(getKClass(QualifiedReferenceContent)), getKClass(QualifiedReferenceContent));
  }
  var ProcessReferenceConcept_instance;
  function ProcessReferenceConcept_getInstance() {
    if (ProcessReferenceConcept_instance == null)
      new ProcessReferenceConcept();
    return ProcessReferenceConcept_instance;
  }
  function ProcessRelationDeclarationImpl$_init_$ref_tn4fje() {
    var l = function (p0, p1) {
      return new ProcessRelationDeclarationImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function ProcessRelationDeclarationConcept$_init_$lambda_zda0by(context, nodeId) {
    return new TypedProcessRelationDeclarationImpl(context, VOID, nodeId);
  }
  function ProcessRelationDeclaration$_get_symbol_$ref_emzgvd_0() {
    return function (p0) {
      return p0.zft();
    };
  }
  function ProcessRelationDeclaration$_get_direction_$ref_nz8wp8_0() {
    return function (p0) {
      return p0.afu();
    };
  }
  function ProcessRelationDeclaration$_get_effect_$ref_iad94u_0() {
    return function (p0) {
      return p0.bfu();
    };
  }
  function ProcessRelationDeclarationConcept$DIRECTION_PERSISTER$$inlined$enumPersister$1() {
  }
  protoOf(ProcessRelationDeclarationConcept$DIRECTION_PERSISTER$$inlined$enumPersister$1).v24 = function (value) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'jetbrains.ocelot.base.enums.Enums.valueOf' call
      // Inline function 'kotlin.enumValues' call
      var indexedObject = values_16();
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var e = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        if (value === e.toString()) {
          tmp$ret$1 = e;
          break $l$block;
        }
      }
      throw IllegalArgumentException_init_$Create$_0(value);
    }
    return tmp$ret$1;
  };
  protoOf(ProcessRelationDeclarationConcept$DIRECTION_PERSISTER$$inlined$enumPersister$1).whh = function (value) {
    return value.toString();
  };
  protoOf(ProcessRelationDeclarationConcept$DIRECTION_PERSISTER$$inlined$enumPersister$1).w24 = function (value) {
    return this.whh(value instanceof RelationDirection ? value : THROW_CCE());
  };
  protoOf(ProcessRelationDeclarationConcept$DIRECTION_PERSISTER$$inlined$enumPersister$1).toString = function () {
    return 'enumPersister';
  };
  function ProcessRelationDeclarationConcept$EFFECT_PERSISTER$$inlined$enumPersister$1() {
  }
  protoOf(ProcessRelationDeclarationConcept$EFFECT_PERSISTER$$inlined$enumPersister$1).v24 = function (value) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'jetbrains.ocelot.base.enums.Enums.valueOf' call
      // Inline function 'kotlin.enumValues' call
      var indexedObject = values_17();
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var e = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        if (value === e.toString()) {
          tmp$ret$1 = e;
          break $l$block;
        }
      }
      throw IllegalArgumentException_init_$Create$_0(value);
    }
    return tmp$ret$1;
  };
  protoOf(ProcessRelationDeclarationConcept$EFFECT_PERSISTER$$inlined$enumPersister$1).xhh = function (value) {
    return value.toString();
  };
  protoOf(ProcessRelationDeclarationConcept$EFFECT_PERSISTER$$inlined$enumPersister$1).w24 = function (value) {
    return this.xhh(value instanceof RelationEffect ? value : THROW_CCE());
  };
  protoOf(ProcessRelationDeclarationConcept$EFFECT_PERSISTER$$inlined$enumPersister$1).toString = function () {
    return 'enumPersister';
  };
  function ProcessRelationDeclarationConcept$directionPropertyDescriptor$$inlined$enumPersister$1() {
  }
  protoOf(ProcessRelationDeclarationConcept$directionPropertyDescriptor$$inlined$enumPersister$1).v24 = function (value) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'jetbrains.ocelot.base.enums.Enums.valueOf' call
      // Inline function 'kotlin.enumValues' call
      var indexedObject = values_16();
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var e = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        if (value === e.toString()) {
          tmp$ret$1 = e;
          break $l$block;
        }
      }
      throw IllegalArgumentException_init_$Create$_0(value);
    }
    return tmp$ret$1;
  };
  protoOf(ProcessRelationDeclarationConcept$directionPropertyDescriptor$$inlined$enumPersister$1).whh = function (value) {
    return value.toString();
  };
  protoOf(ProcessRelationDeclarationConcept$directionPropertyDescriptor$$inlined$enumPersister$1).w24 = function (value) {
    return this.whh(value instanceof RelationDirection ? value : THROW_CCE());
  };
  protoOf(ProcessRelationDeclarationConcept$directionPropertyDescriptor$$inlined$enumPersister$1).toString = function () {
    return 'enumPersister';
  };
  function ProcessRelationDeclarationConcept$effectPropertyDescriptor$$inlined$enumPersister$1() {
  }
  protoOf(ProcessRelationDeclarationConcept$effectPropertyDescriptor$$inlined$enumPersister$1).v24 = function (value) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'jetbrains.ocelot.base.enums.Enums.valueOf' call
      // Inline function 'kotlin.enumValues' call
      var indexedObject = values_17();
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var e = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        if (value === e.toString()) {
          tmp$ret$1 = e;
          break $l$block;
        }
      }
      throw IllegalArgumentException_init_$Create$_0(value);
    }
    return tmp$ret$1;
  };
  protoOf(ProcessRelationDeclarationConcept$effectPropertyDescriptor$$inlined$enumPersister$1).xhh = function (value) {
    return value.toString();
  };
  protoOf(ProcessRelationDeclarationConcept$effectPropertyDescriptor$$inlined$enumPersister$1).w24 = function (value) {
    return this.xhh(value instanceof RelationEffect ? value : THROW_CCE());
  };
  protoOf(ProcessRelationDeclarationConcept$effectPropertyDescriptor$$inlined$enumPersister$1).toString = function () {
    return 'enumPersister';
  };
  function ProcessRelationDeclarationConcept() {
    ProcessRelationDeclarationConcept_instance = this;
    var tmp = ProcessRelationDeclarationImpl$_init_$ref_tn4fje();
    OtConceptDescriptor.call(this, 'RelationDeclaration', VOID, tmp, ProcessRelationDeclarationConcept$_init_$lambda_zda0by, Companion_instance_94.k6m([BTBNodeConcept_getInstance(), DirectlyNamedConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    tmp_0.ihi_1 = this.r6m(getPropertyCallableRef('symbol', 1, tmp_1, ProcessRelationDeclaration$_get_symbol_$ref_emzgvd_0(), null), 'symbol');
    var tmp_2 = this;
    var tmp_3 = KProperty1;
    tmp_2.jhi_1 = this.r6m(getPropertyCallableRef('direction', 1, tmp_3, ProcessRelationDeclaration$_get_direction_$ref_nz8wp8_0(), null), 'direction');
    var tmp_4 = this;
    var tmp_5 = KProperty1;
    tmp_4.khi_1 = this.r6m(getPropertyCallableRef('effect', 1, tmp_5, ProcessRelationDeclaration$_get_effect_$ref_iad94u_0(), null), 'effect');
    var tmp_6 = this;
    // Inline function 'jetbrains.ocelot.base.persister.NonNullPersisters.enumPersister' call
    NonNullPersisters_getInstance();
    var tmp$ret$0 = new ProcessRelationDeclarationConcept$DIRECTION_PERSISTER$$inlined$enumPersister$1();
    tmp_6.lhi_1 = toNullablePersister(tmp$ret$0);
    var tmp_7 = this;
    // Inline function 'jetbrains.ocelot.base.persister.NonNullPersisters.enumPersister' call
    NonNullPersisters_getInstance();
    var tmp$ret$1 = new ProcessRelationDeclarationConcept$EFFECT_PERSISTER$$inlined$enumPersister$1();
    tmp_7.mhi_1 = toNullablePersister(tmp$ret$1);
    this.nhi_1 = new DomainNodePropertyDescriptor(this.ihi_1, toNonNullPersister(NonNullPersisters_getInstance().h25(), new DefaultValueNullPersister('')));
    var tmp_8 = this;
    // Inline function 'jetbrains.ocelot.base.persister.NonNullPersisters.enumPersister' call
    NonNullPersisters_getInstance();
    var tmp$ret$2 = new ProcessRelationDeclarationConcept$directionPropertyDescriptor$$inlined$enumPersister$1();
    tmp_8.ohi_1 = new DomainNodePropertyDescriptor(this.jhi_1, toNullablePersister(tmp$ret$2));
    var tmp_9 = this;
    // Inline function 'jetbrains.ocelot.base.persister.NonNullPersisters.enumPersister' call
    NonNullPersisters_getInstance();
    var tmp$ret$3 = new ProcessRelationDeclarationConcept$effectPropertyDescriptor$$inlined$enumPersister$1();
    tmp_9.phi_1 = new DomainNodePropertyDescriptor(this.khi_1, toNullablePersister(tmp$ret$3));
  }
  var ProcessRelationDeclarationConcept_instance;
  function ProcessRelationDeclarationConcept_getInstance() {
    if (ProcessRelationDeclarationConcept_instance == null)
      new ProcessRelationDeclarationConcept();
    return ProcessRelationDeclarationConcept_instance;
  }
  function ProcessTypeImpl$_init_$ref_r1xhbw() {
    var l = function (p0, p1) {
      return new ProcessTypeImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function ProcessTypeConcept$_init_$lambda_rqcn1o(context, nodeId) {
    return new TypedProcessTypeImpl(context, VOID, nodeId);
  }
  function ProcessType$_get_specification_$ref_tigm72_0() {
    return function (p0) {
      return p0.vfq();
    };
  }
  function ProcessTypeConcept() {
    ProcessTypeConcept_instance = this;
    var tmp = ProcessTypeImpl$_init_$ref_r1xhbw();
    OtConceptDescriptor.call(this, 'ProcessType', VOID, tmp, ProcessTypeConcept$_init_$lambda_rqcn1o, Companion_instance_94.k6m([TypeConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    var tmp4 = getPropertyCallableRef('specification', 1, tmp_1, ProcessType$_get_specification_$ref_tigm72_0(), null);
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    var name = 'specification';
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$0 = new SingleChildLink(getKClass(ProcessType_1), tmp4);
    tmp_0.ahj_1 = this.o6m(tmp$ret$0, name);
    this.bhj_1 = new DomainNodeChildPropertyDescriptor(this.ahj_1.s6i_1);
  }
  var ProcessTypeConcept_instance;
  function ProcessTypeConcept_getInstance() {
    if (ProcessTypeConcept_instance == null)
      new ProcessTypeConcept();
    return ProcessTypeConcept_instance;
  }
  function PropertiesCustomCellImpl$_init_$ref_firujj() {
    var l = function (p0, p1) {
      return new PropertiesCustomCellImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function PropertiesCustomCellConcept$_init_$lambda_xk0qdl(context, nodeId) {
    return new TypedPropertiesCustomCellImpl(context, VOID, nodeId);
  }
  function PropertiesCustomCellConcept() {
    PropertiesCustomCellConcept_instance = this;
    var tmp = PropertiesCustomCellImpl$_init_$ref_firujj();
    OtConceptDescriptor.call(this, 'PropertiesCustomCell', VOID, tmp, PropertiesCustomCellConcept$_init_$lambda_xk0qdl, Companion_instance_94.k6m([CustomCellConcept_getInstance()]));
  }
  var PropertiesCustomCellConcept_instance;
  function PropertiesCustomCellConcept_getInstance() {
    if (PropertiesCustomCellConcept_instance == null)
      new PropertiesCustomCellConcept();
    return PropertiesCustomCellConcept_instance;
  }
  function PropertyConstraintImpl$_init_$ref_mdvtf1() {
    var l = function (p0, p1) {
      return new PropertyConstraintImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function PropertyConstraintConcept$_init_$lambda_pk21yj(context, nodeId) {
    return new TypedPropertyConstraintImpl(context, VOID, nodeId);
  }
  function PropertyConstraint$_get_operation_$ref_7z13uv_0() {
    return function (p0) {
      return p0.s3z();
    };
  }
  function PropertyConstraint$_get_property_$ref_tgowqf_0() {
    return function (p0) {
      return p0.q6q();
    };
  }
  function PropertyConstraint$_get_value_$ref_f1oxa5_0() {
    return function (p0) {
      return p0.a1();
    };
  }
  function PropertyConstraintConcept$OPERATION_PERSISTER$$inlined$enumPersister$1() {
  }
  protoOf(PropertyConstraintConcept$OPERATION_PERSISTER$$inlined$enumPersister$1).v24 = function (value) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'jetbrains.ocelot.base.enums.Enums.valueOf' call
      // Inline function 'kotlin.enumValues' call
      var indexedObject = values_15();
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var e = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        if (value === e.toString()) {
          tmp$ret$1 = e;
          break $l$block;
        }
      }
      throw IllegalArgumentException_init_$Create$_0(value);
    }
    return tmp$ret$1;
  };
  protoOf(PropertyConstraintConcept$OPERATION_PERSISTER$$inlined$enumPersister$1).chj = function (value) {
    return value.toString();
  };
  protoOf(PropertyConstraintConcept$OPERATION_PERSISTER$$inlined$enumPersister$1).w24 = function (value) {
    return this.chj(value instanceof ConstraintOperation ? value : THROW_CCE());
  };
  protoOf(PropertyConstraintConcept$OPERATION_PERSISTER$$inlined$enumPersister$1).toString = function () {
    return 'enumPersister';
  };
  function PropertyConstraintConcept$operationPropertyDescriptor$$inlined$enumPersister$1() {
  }
  protoOf(PropertyConstraintConcept$operationPropertyDescriptor$$inlined$enumPersister$1).v24 = function (value) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'jetbrains.ocelot.base.enums.Enums.valueOf' call
      // Inline function 'kotlin.enumValues' call
      var indexedObject = values_15();
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var e = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        if (value === e.toString()) {
          tmp$ret$1 = e;
          break $l$block;
        }
      }
      throw IllegalArgumentException_init_$Create$_0(value);
    }
    return tmp$ret$1;
  };
  protoOf(PropertyConstraintConcept$operationPropertyDescriptor$$inlined$enumPersister$1).chj = function (value) {
    return value.toString();
  };
  protoOf(PropertyConstraintConcept$operationPropertyDescriptor$$inlined$enumPersister$1).w24 = function (value) {
    return this.chj(value instanceof ConstraintOperation ? value : THROW_CCE());
  };
  protoOf(PropertyConstraintConcept$operationPropertyDescriptor$$inlined$enumPersister$1).toString = function () {
    return 'enumPersister';
  };
  function PropertyConstraintConcept() {
    PropertyConstraintConcept_instance = this;
    var tmp = PropertyConstraintImpl$_init_$ref_mdvtf1();
    OtConceptDescriptor.call(this, 'PropertyConstraint', VOID, tmp, PropertyConstraintConcept$_init_$lambda_pk21yj, Companion_instance_94.k6m([BTBNodeConcept_getInstance(), HasPropertyConstraintsConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    tmp_0.nhj_1 = this.r6m(getPropertyCallableRef('operation', 1, tmp_1, PropertyConstraint$_get_operation_$ref_7z13uv_0(), null), 'operation');
    var tmp_2 = this;
    var tmp_3 = KProperty1;
    var tmp4 = getPropertyCallableRef('property', 1, tmp_3, PropertyConstraint$_get_property_$ref_tgowqf_0(), null);
    var tmp6 = Companion_getInstance_333().uhj_1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.referenceRole' call
    var name = 'property';
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var tmp$ret$0 = new ReferenceLink(getKClass(PropertyConstraint_1), tmp4, getKClass(ObjectPropertyDeclaration_1), getKClass(QualifiedReferenceContent));
    tmp_2.ohj_1 = this.q6m(tmp$ret$0, tmp6, name);
    var tmp_4 = this;
    var tmp_5 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_0 = getPropertyCallableRef('value', 1, tmp_5, PropertyConstraint$_get_value_$ref_f1oxa5_0(), null);
    var tmp$ret$2 = new SingleChildLink(getKClass(PropertyConstraint_1), this_0);
    tmp_4.phj_1 = this.o6m(tmp$ret$2, 'value');
    var tmp_6 = this;
    // Inline function 'jetbrains.ocelot.base.persister.NonNullPersisters.enumPersister' call
    NonNullPersisters_getInstance();
    var tmp$ret$4 = new PropertyConstraintConcept$OPERATION_PERSISTER$$inlined$enumPersister$1();
    tmp_6.qhj_1 = toNullablePersister(tmp$ret$4);
    var tmp_7 = this;
    // Inline function 'jetbrains.ocelot.base.persister.NonNullPersisters.enumPersister' call
    NonNullPersisters_getInstance();
    var tmp$ret$5 = new PropertyConstraintConcept$operationPropertyDescriptor$$inlined$enumPersister$1();
    tmp_7.rhj_1 = new DomainNodePropertyDescriptor(this.nhj_1, toNullablePersister(tmp$ret$5));
    this.shj_1 = new DomainNodeReferencePropertyDescriptor(this.ohj_1, ReferenceContentPersisters_getInstance().d6m(getKClass(QualifiedReferenceContent)), getKClass(QualifiedReferenceContent));
    this.thj_1 = new DomainNodeChildPropertyDescriptor(this.phj_1.s6i_1);
  }
  var PropertyConstraintConcept_instance;
  function PropertyConstraintConcept_getInstance() {
    if (PropertyConstraintConcept_instance == null)
      new PropertyConstraintConcept();
    return PropertyConstraintConcept_instance;
  }
  function PropertyCustomCellImpl$_init_$ref_405iir() {
    var l = function (p0, p1) {
      return new PropertyCustomCellImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function PropertyCustomCellConcept$_init_$lambda_hcr0bv(context, nodeId) {
    return new TypedPropertyCustomCellImpl(context, VOID, nodeId);
  }
  function PropertyCustomCell$_get_property_$ref_w2rusf_0() {
    return function (p0) {
      return p0.q6q();
    };
  }
  function PropertyCustomCellConcept() {
    PropertyCustomCellConcept_instance = this;
    var tmp = PropertyCustomCellImpl$_init_$ref_405iir();
    OtConceptDescriptor.call(this, 'PropertyCustomCell', VOID, tmp, PropertyCustomCellConcept$_init_$lambda_hcr0bv, Companion_instance_94.k6m([CustomCellConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    var tmp4 = getPropertyCallableRef('property', 1, tmp_1, PropertyCustomCell$_get_property_$ref_w2rusf_0(), null);
    var tmp6 = Companion_getInstance_323().vhj_1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.referenceRole' call
    var name = 'property';
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var tmp$ret$0 = new ReferenceLink(getKClass(PropertyCustomCell_1), tmp4, getKClass(AbstractProperty), getKClass(QualifiedReferenceContent));
    tmp_0.ghk_1 = this.q6m(tmp$ret$0, tmp6, name);
    this.hhk_1 = new DomainNodeReferencePropertyDescriptor(this.ghk_1, ReferenceContentPersisters_getInstance().d6m(getKClass(QualifiedReferenceContent)), getKClass(QualifiedReferenceContent));
  }
  var PropertyCustomCellConcept_instance;
  function PropertyCustomCellConcept_getInstance() {
    if (PropertyCustomCellConcept_instance == null)
      new PropertyCustomCellConcept();
    return PropertyCustomCellConcept_instance;
  }
  function PropertyDeclarationImpl$_init_$ref_dhhw0w() {
    var l = function (p0, p1) {
      return new PropertyDeclarationImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function PropertyDeclarationConcept$_init_$lambda_3n3np4(context, nodeId) {
    return new TypedPropertyDeclarationImpl(context, VOID, nodeId);
  }
  function PropertyDeclaration$_get_type_$ref_g8rthd_0() {
    return function (p0) {
      return p0.sfq();
    };
  }
  function PropertyDeclarationConcept() {
    PropertyDeclarationConcept_instance = this;
    var tmp = PropertyDeclarationImpl$_init_$ref_dhhw0w();
    OtConceptDescriptor.call(this, 'PropertyDeclaration', VOID, tmp, PropertyDeclarationConcept$_init_$lambda_3n3np4, Companion_instance_94.k6m([BTBNodeConcept_getInstance(), DirectlyNamedConcept_getInstance(), PropertyLibraryElementConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_0 = getPropertyCallableRef('type', 1, tmp_1, PropertyDeclaration$_get_type_$ref_g8rthd_0(), null);
    var tmp$ret$0 = new SingleChildLink(getKClass(PropertyDeclaration_1), this_0);
    tmp_0.shk_1 = this.o6m(tmp$ret$0, 'type');
    this.thk_1 = new DomainNodeChildPropertyDescriptor(this.shk_1.s6i_1);
  }
  var PropertyDeclarationConcept_instance;
  function PropertyDeclarationConcept_getInstance() {
    if (PropertyDeclarationConcept_instance == null)
      new PropertyDeclarationConcept();
    return PropertyDeclarationConcept_instance;
  }
  function PropertyDeclarationValueQueryImpl$_init_$ref_1zl0i1() {
    var l = function (p0, p1) {
      return new PropertyDeclarationValueQueryImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function PropertyDeclarationValueQueryConcept$_init_$lambda_9v53z5(context, nodeId) {
    return new TypedPropertyDeclarationValueQueryImpl(context, VOID, nodeId);
  }
  function PropertyDeclarationValueQuery$_get_propertyDeclaration_$ref_e83vu5_0() {
    return function (p0) {
      return p0.cfu();
    };
  }
  function PropertyDeclarationValueQueryConcept() {
    PropertyDeclarationValueQueryConcept_instance = this;
    var tmp = PropertyDeclarationValueQueryImpl$_init_$ref_1zl0i1();
    OtConceptDescriptor.call(this, 'PropertyDeclarationValueQuery', VOID, tmp, PropertyDeclarationValueQueryConcept$_init_$lambda_9v53z5, Companion_instance_94.k6m([DeclarationValueQueryConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    var tmp4 = getPropertyCallableRef('propertyDeclaration', 1, tmp_1, PropertyDeclarationValueQuery$_get_propertyDeclaration_$ref_e83vu5_0(), null);
    var tmp6 = Companion_getInstance_348().uhk_1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.referenceRole' call
    var name = 'linkDeclaration';
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var tmp$ret$0 = new ReferenceLink(getKClass(PropertyDeclarationValueQuery_1), tmp4, getKClass(PropertyDeclaration_1), getKClass(QualifiedReferenceContent));
    tmp_0.fhl_1 = this.q6m(tmp$ret$0, tmp6, name);
    this.ghl_1 = new DomainNodeReferencePropertyDescriptor(this.fhl_1, ReferenceContentPersisters_getInstance().d6m(getKClass(QualifiedReferenceContent)), getKClass(QualifiedReferenceContent));
  }
  var PropertyDeclarationValueQueryConcept_instance;
  function PropertyDeclarationValueQueryConcept_getInstance() {
    if (PropertyDeclarationValueQueryConcept_instance == null)
      new PropertyDeclarationValueQueryConcept();
    return PropertyDeclarationValueQueryConcept_instance;
  }
  function PropertyLibraryImpl$_init_$ref_ayn5hd() {
    var l = function (p0, p1) {
      return new PropertyLibraryImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function PropertyLibraryConcept$_init_$lambda_7hwluf(context, nodeId) {
    return new TypedPropertyLibraryImpl(context, VOID, nodeId);
  }
  function PropertyLibrary$_get_elements_$ref_sclji9_0() {
    return function (p0) {
      return p0.ifq();
    };
  }
  function PropertyLibraryConcept() {
    PropertyLibraryConcept_instance = this;
    var tmp = PropertyLibraryImpl$_init_$ref_ayn5hd();
    OtConceptDescriptor.call(this, 'PropertyLibrary', VOID, tmp, PropertyLibraryConcept$_init_$lambda_7hwluf, Companion_instance_94.k6m([DocumentNodeConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    var tmp4 = getPropertyCallableRef('elements', 1, tmp_1, PropertyLibrary$_get_elements_$ref_sclji9_0(), null);
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childrenRole' call
    var name = 'properties';
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$0 = new MultipleChildLink(getKClass(PropertyLibrary_1), tmp4);
    tmp_0.rhl_1 = this.p6m(tmp$ret$0, name);
    this.shl_1 = new DomainNodeChildrenPropertyDescriptor(this.rhl_1.s6i_1);
  }
  var PropertyLibraryConcept_instance;
  function PropertyLibraryConcept_getInstance() {
    if (PropertyLibraryConcept_instance == null)
      new PropertyLibraryConcept();
    return PropertyLibraryConcept_instance;
  }
  function PropertyLibraryElementConcept() {
    PropertyLibraryElementConcept_instance = this;
    OTAbstractConceptDescriptor.call(this, Companion_instance_94.k6m([BTBNodeConcept_getInstance()]));
  }
  var PropertyLibraryElementConcept_instance;
  function PropertyLibraryElementConcept_getInstance() {
    if (PropertyLibraryElementConcept_instance == null)
      new PropertyLibraryElementConcept();
    return PropertyLibraryElementConcept_instance;
  }
  function PropertyReferenceOperationImpl$_init_$ref_4trzf0() {
    var l = function (p0, p1) {
      return new PropertyReferenceOperationImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function PropertyReferenceOperationConcept$_init_$lambda_i8u4wc(context, nodeId) {
    return new TypedPropertyReferenceOperationImpl(context, VOID, nodeId);
  }
  function PropertyReferenceOperation$_get_property_$ref_vdhpuw_0() {
    return function (p0) {
      return p0.q6q();
    };
  }
  function PropertyReferenceOperation$_get_parameter_$ref_b85xok_0() {
    return function (p0) {
      return p0.dfu();
    };
  }
  function PropertyReferenceOperationConcept() {
    PropertyReferenceOperationConcept_instance = this;
    var tmp = PropertyReferenceOperationImpl$_init_$ref_4trzf0();
    OtConceptDescriptor.call(this, 'PropertyReferenceOperation', VOID, tmp, PropertyReferenceOperationConcept$_init_$lambda_i8u4wc, Companion_instance_94.k6m([BTBNodeConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    var tmp4 = getPropertyCallableRef('property', 1, tmp_1, PropertyReferenceOperation$_get_property_$ref_vdhpuw_0(), null);
    var tmp6 = Companion_getInstance_355().thl_1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.referenceRole' call
    var name = 'property';
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var tmp$ret$0 = new ReferenceLink(getKClass(PropertyReferenceOperation_1), tmp4, getKClass(ObjectPropertyDeclaration_1), getKClass(QualifiedReferenceContent));
    tmp_0.ehm_1 = this.q6m(tmp$ret$0, tmp6, name);
    var tmp_2 = this;
    var tmp_3 = KProperty1;
    var tmp4_0 = getPropertyCallableRef('parameter', 1, tmp_3, PropertyReferenceOperation$_get_parameter_$ref_b85xok_0(), null);
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    var name_0 = 'parameter';
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$2 = new SingleChildLink(getKClass(PropertyReferenceOperation_1), tmp4_0);
    tmp_2.fhm_1 = this.o6m(tmp$ret$2, name_0);
    this.ghm_1 = new DomainNodeReferencePropertyDescriptor(this.ehm_1, ReferenceContentPersisters_getInstance().d6m(getKClass(QualifiedReferenceContent)), getKClass(QualifiedReferenceContent));
    this.hhm_1 = new DomainNodeChildPropertyDescriptor(this.fhm_1.s6i_1);
  }
  var PropertyReferenceOperationConcept_instance;
  function PropertyReferenceOperationConcept_getInstance() {
    if (PropertyReferenceOperationConcept_instance == null)
      new PropertyReferenceOperationConcept();
    return PropertyReferenceOperationConcept_instance;
  }
  function PropertyValueImpl$_init_$ref_c3xgaf() {
    var l = function (p0, p1) {
      return new PropertyValueImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function PropertyValueConcept$_init_$lambda_5skb8h(context, nodeId) {
    return new TypedPropertyValueImpl(context, VOID, nodeId);
  }
  function PropertyValue$_get_property_$ref_q9j7al_0() {
    return function (p0) {
      return p0.q6q();
    };
  }
  function PropertyValueConcept() {
    PropertyValueConcept_instance = this;
    var tmp = PropertyValueImpl$_init_$ref_c3xgaf();
    OtConceptDescriptor.call(this, 'PropertyValue', VOID, tmp, PropertyValueConcept$_init_$lambda_5skb8h, Companion_instance_94.k6m([AbstractBindingValueConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    var tmp4 = getPropertyCallableRef('property', 1, tmp_1, PropertyValue$_get_property_$ref_q9j7al_0(), null);
    var tmp6 = Companion_getInstance_342().ihm_1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.referenceRole' call
    var name = 'property';
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var tmp$ret$0 = new ReferenceLink(getKClass(PropertyValue_1), tmp4, getKClass(AbstractProperty), getKClass(QualifiedReferenceContent));
    tmp_0.thm_1 = this.q6m(tmp$ret$0, tmp6, name);
    this.uhm_1 = new DomainNodeReferencePropertyDescriptor(this.thm_1, ReferenceContentPersisters_getInstance().d6m(getKClass(QualifiedReferenceContent)), getKClass(QualifiedReferenceContent));
  }
  var PropertyValueConcept_instance;
  function PropertyValueConcept_getInstance() {
    if (PropertyValueConcept_instance == null)
      new PropertyValueConcept();
    return PropertyValueConcept_instance;
  }
  function PropertyValueRangeConcept() {
    PropertyValueRangeConcept_instance = this;
    OTAbstractConceptDescriptor.call(this, Companion_instance_94.k6m([BTBNodeConcept_getInstance()]));
  }
  var PropertyValueRangeConcept_instance;
  function PropertyValueRangeConcept_getInstance() {
    if (PropertyValueRangeConcept_instance == null)
      new PropertyValueRangeConcept();
    return PropertyValueRangeConcept_instance;
  }
  function PubMedSourceReferenceImpl$_init_$ref_5o0s4k() {
    var l = function (p0, p1) {
      return new PubMedSourceReferenceImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function PubMedSourceReferenceConcept$_init_$lambda_s2kf9g(context, nodeId) {
    return new TypedPubMedSourceReferenceImpl(context, VOID, nodeId);
  }
  function PubMedSourceReference$_get_pubMedId_$ref_1o1oab_0() {
    return function (p0) {
      return p0.kft();
    };
  }
  function PubMedSourceReferenceConcept() {
    PubMedSourceReferenceConcept_instance = this;
    var tmp = PubMedSourceReferenceImpl$_init_$ref_5o0s4k();
    OtConceptDescriptor.call(this, 'PubMedSourceReference', VOID, tmp, PubMedSourceReferenceConcept$_init_$lambda_s2kf9g, Companion_instance_94.k6m([KnowledgeSourceReferenceConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    tmp_0.fhn_1 = this.r6m(getPropertyCallableRef('pubMedId', 1, tmp_1, PubMedSourceReference$_get_pubMedId_$ref_1o1oab_0(), null), 'id');
    this.ghn_1 = new DomainNodePropertyDescriptor(this.fhn_1, toNonNullPersister(NonNullPersisters_getInstance().h25(), new DefaultValueNullPersister('')));
  }
  var PubMedSourceReferenceConcept_instance;
  function PubMedSourceReferenceConcept_getInstance() {
    if (PubMedSourceReferenceConcept_instance == null)
      new PubMedSourceReferenceConcept();
    return PubMedSourceReferenceConcept_instance;
  }
  function PublishedSourceReferenceImpl$_init_$ref_8p401v() {
    var l = function (p0, p1) {
      return new PublishedSourceReferenceImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function PublishedSourceReferenceConcept$_init_$lambda_1psbs5(context, nodeId) {
    return new TypedPublishedSourceReferenceImpl(context, VOID, nodeId);
  }
  function PublishedSourceReference$_get_source_$ref_v1fin3_0() {
    return function (p0) {
      return p0.m6d();
    };
  }
  function PublishedSourceReference$_get_pageSpecification_$ref_qx42i2_0() {
    return function (p0) {
      return p0.efu();
    };
  }
  function PublishedSourceReferenceConcept() {
    PublishedSourceReferenceConcept_instance = this;
    var tmp = PublishedSourceReferenceImpl$_init_$ref_8p401v();
    OtConceptDescriptor.call(this, 'PublishedSourceReference', VOID, tmp, PublishedSourceReferenceConcept$_init_$lambda_1psbs5, Companion_instance_94.k6m([KnowledgeSourceReferenceConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    var tmp4 = getPropertyCallableRef('source', 1, tmp_1, PublishedSourceReference$_get_source_$ref_v1fin3_0(), null);
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.referenceRole' call
    var tag = Companion_getInstance_328().hhn_1;
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var tmp$ret$0 = new ReferenceLink(getKClass(PublishedSourceReference_1), tmp4, getKClass(PublishedWork), getKClass(QualifiedReferenceContent));
    tmp_0.shn_1 = this.q6m(tmp$ret$0, tag, 'source');
    var tmp_2 = this;
    var tmp_3 = KProperty1;
    var tmp4_0 = getPropertyCallableRef('pageSpecification', 1, tmp_3, PublishedSourceReference$_get_pageSpecification_$ref_qx42i2_0(), null);
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    var name = 'pageSpecification';
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$2 = new SingleChildLink(getKClass(PublishedSourceReference_1), tmp4_0);
    tmp_2.thn_1 = this.o6m(tmp$ret$2, name);
    this.uhn_1 = new DomainNodeReferencePropertyDescriptor(this.shn_1, ReferenceContentPersisters_getInstance().d6m(getKClass(QualifiedReferenceContent)), getKClass(QualifiedReferenceContent));
    this.vhn_1 = new DomainNodeChildPropertyDescriptor(this.thn_1.s6i_1);
  }
  var PublishedSourceReferenceConcept_instance;
  function PublishedSourceReferenceConcept_getInstance() {
    if (PublishedSourceReferenceConcept_instance == null)
      new PublishedSourceReferenceConcept();
    return PublishedSourceReferenceConcept_instance;
  }
  function PublishedSourcesLibraryImpl$_init_$ref_mux0wk() {
    var l = function (p0, p1) {
      return new PublishedSourcesLibraryImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function PublishedSourcesLibraryConcept$_init_$lambda_2v7rjg(context, nodeId) {
    return new TypedPublishedSourcesLibraryImpl(context, VOID, nodeId);
  }
  function PublishedSourcesLibrary$_get_items_$ref_b4kv1p_0() {
    return function (p0) {
      return p0.l2n();
    };
  }
  function PublishedSourcesLibraryConcept() {
    PublishedSourcesLibraryConcept_instance = this;
    var tmp = PublishedSourcesLibraryImpl$_init_$ref_mux0wk();
    OtConceptDescriptor.call(this, 'PublishedSourcesLibrary', VOID, tmp, PublishedSourcesLibraryConcept$_init_$lambda_2v7rjg, Companion_instance_94.k6m([DocumentNodeConcept_getInstance(), BTBNodeConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childrenRole' call
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_0 = getPropertyCallableRef('items', 1, tmp_1, PublishedSourcesLibrary$_get_items_$ref_b4kv1p_0(), null);
    var tmp$ret$0 = new MultipleChildLink(getKClass(PublishedSourcesLibrary_1), this_0);
    tmp_0.gho_1 = this.p6m(tmp$ret$0, 'sources');
    this.hho_1 = new DomainNodeChildrenPropertyDescriptor(this.gho_1.s6i_1);
  }
  var PublishedSourcesLibraryConcept_instance;
  function PublishedSourcesLibraryConcept_getInstance() {
    if (PublishedSourcesLibraryConcept_instance == null)
      new PublishedSourcesLibraryConcept();
    return PublishedSourcesLibraryConcept_instance;
  }
  function PublishedWorkImpl$_init_$ref_ve8a6y() {
    var l = function (p0, p1) {
      return new PublishedWorkImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function PublishedWorkConcept$_init_$lambda_7k069u(context, nodeId) {
    return new TypedPublishedWorkImpl(context, VOID, nodeId);
  }
  function PublishedWork$_get_publisher_$ref_wshpep_0() {
    return function (p0) {
      return p0.ffu();
    };
  }
  function PublishedWork$_get_date_$ref_2srppr_0() {
    return function (p0) {
      return p0.gfu();
    };
  }
  function PublishedWorkConcept() {
    PublishedWorkConcept_instance = this;
    var tmp = PublishedWorkImpl$_init_$ref_ve8a6y();
    OtConceptDescriptor.call(this, 'PublishedWork', VOID, tmp, PublishedWorkConcept$_init_$lambda_7k069u, Companion_instance_94.k6m([AuthoredWorkConcept_getInstance(), DirectlyNamedConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    tmp_0.sho_1 = this.r6m(getPropertyCallableRef('publisher', 1, tmp_1, PublishedWork$_get_publisher_$ref_wshpep_0(), null), 'publisher');
    var tmp_2 = this;
    var tmp_3 = KProperty1;
    tmp_2.tho_1 = this.r6m(getPropertyCallableRef('date', 1, tmp_3, PublishedWork$_get_date_$ref_2srppr_0(), null), 'date');
    this.uho_1 = new DomainNodePropertyDescriptor(this.sho_1, toNonNullPersister(NonNullPersisters_getInstance().h25(), new DefaultValueNullPersister('')));
    this.vho_1 = new DomainNodePropertyDescriptor(this.tho_1, toNonNullPersister(NonNullPersisters_getInstance().h25(), new DefaultValueNullPersister('')));
  }
  var PublishedWorkConcept_instance;
  function PublishedWorkConcept_getInstance() {
    if (PublishedWorkConcept_instance == null)
      new PublishedWorkConcept();
    return PublishedWorkConcept_instance;
  }
  function QualifiedOntologyElementReferenceImpl$_init_$ref_vybrd7() {
    var l = function (p0, p1) {
      return new QualifiedOntologyElementReferenceImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function QualifiedOntologyElementReferenceConcept$_init_$lambda_dnlcgz(context, nodeId) {
    return new TypedQualifiedOntologyElementReferenceImpl(context, VOID, nodeId);
  }
  function QualifiedOntologyElementReference$_get_libraryReference_$ref_eai4yc_0() {
    return function (p0) {
      return p0.hfu();
    };
  }
  function QualifiedOntologyElementReference$_get_elementReference_$ref_8q8mxh_0() {
    return function (p0) {
      return p0.ifu();
    };
  }
  function QualifiedOntologyElementReferenceConcept() {
    QualifiedOntologyElementReferenceConcept_instance = this;
    var tmp = QualifiedOntologyElementReferenceImpl$_init_$ref_vybrd7();
    OtConceptDescriptor.call(this, 'QualifiedOntologyElementReferenceImpl', VOID, tmp, QualifiedOntologyElementReferenceConcept$_init_$lambda_dnlcgz, Companion_instance_94.k6m([OntologyElementReferenceProviderConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_0 = getPropertyCallableRef('libraryReference', 1, tmp_1, QualifiedOntologyElementReference$_get_libraryReference_$ref_eai4yc_0(), null);
    var tmp$ret$0 = new SingleChildLink(getKClass(QualifiedOntologyElementReference_1), this_0);
    tmp_0.ghp_1 = this.o6m(tmp$ret$0, 'library');
    var tmp_2 = this;
    var tmp_3 = KProperty1;
    var tmp4 = getPropertyCallableRef('elementReference', 1, tmp_3, QualifiedOntologyElementReference$_get_elementReference_$ref_8q8mxh_0(), null);
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    var name = 'elementReference';
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$2 = new SingleChildLink(getKClass(QualifiedOntologyElementReference_1), tmp4);
    tmp_2.hhp_1 = this.o6m(tmp$ret$2, name);
    this.ihp_1 = new DomainNodeChildPropertyDescriptor(this.ghp_1.s6i_1);
    this.jhp_1 = new DomainNodeChildPropertyDescriptor(this.hhp_1.s6i_1);
  }
  var QualifiedOntologyElementReferenceConcept_instance;
  function QualifiedOntologyElementReferenceConcept_getInstance() {
    if (QualifiedOntologyElementReferenceConcept_instance == null)
      new QualifiedOntologyElementReferenceConcept();
    return QualifiedOntologyElementReferenceConcept_instance;
  }
  function QueryCommandsImpl$_init_$ref_u2jq4r() {
    var l = function (p0, p1) {
      return new QueryCommandsImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function QueryCommandsConcept$_init_$lambda_jytcp9(context, nodeId) {
    return new TypedQueryCommandsImpl(context, VOID, nodeId);
  }
  function QueryCommands$_get_commands_$ref_yrumbe_0() {
    return function (p0) {
      return p0.u51();
    };
  }
  function QueryCommandsConcept() {
    QueryCommandsConcept_instance = this;
    var tmp = QueryCommandsImpl$_init_$ref_u2jq4r();
    OtConceptDescriptor.call(this, 'QueryCommands', VOID, tmp, QueryCommandsConcept$_init_$lambda_jytcp9, Companion_instance_94.k6m([DocumentNodeConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    var tmp4 = getPropertyCallableRef('commands', 1, tmp_1, QueryCommands$_get_commands_$ref_yrumbe_0(), null);
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childrenRole' call
    var name = 'commands';
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$0 = new MultipleChildLink(getKClass(QueryCommands_1), tmp4);
    tmp_0.uhp_1 = this.p6m(tmp$ret$0, name);
    this.vhp_1 = new DomainNodeChildrenPropertyDescriptor(this.uhp_1.s6i_1);
  }
  var QueryCommandsConcept_instance;
  function QueryCommandsConcept_getInstance() {
    if (QueryCommandsConcept_instance == null)
      new QueryCommandsConcept();
    return QueryCommandsConcept_instance;
  }
  function QueryLabelsFactExpressionContainerImpl$_init_$ref_y37l3j() {
    var l = function (p0, p1) {
      return new QueryLabelsFactExpressionContainerImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function QueryLabelsFactExpressionContainerConcept$_init_$lambda_wcjcd5(context, nodeId) {
    return new TypedQueryLabelsFactExpressionContainerImpl(context, VOID, nodeId);
  }
  function QueryLabelsFactExpressionContainerConcept() {
    QueryLabelsFactExpressionContainerConcept_instance = this;
    var tmp = QueryLabelsFactExpressionContainerImpl$_init_$ref_y37l3j();
    OtConceptDescriptor.call(this, 'QueryLabelsFactExpressionContainer', VOID, tmp, QueryLabelsFactExpressionContainerConcept$_init_$lambda_wcjcd5, Companion_instance_94.k6m([HasQueryLabelsConcept_getInstance(), HasFactExpressionConcept_getInstance()]));
  }
  var QueryLabelsFactExpressionContainerConcept_instance;
  function QueryLabelsFactExpressionContainerConcept_getInstance() {
    if (QueryLabelsFactExpressionContainerConcept_instance == null)
      new QueryLabelsFactExpressionContainerConcept();
    return QueryLabelsFactExpressionContainerConcept_instance;
  }
  function QueryParametersBlackListImpl$_init_$ref_ob5fba() {
    var l = function (p0, p1) {
      return new QueryParametersBlackListImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function QueryParametersBlackListConcept$_init_$lambda_rrf40i(context, nodeId) {
    return new TypedQueryParametersBlackListImpl(context, VOID, nodeId);
  }
  function QueryParametersBlackList$_get_library_$ref_orkkq4_0() {
    return function (p0) {
      return p0.ffq();
    };
  }
  function QueryParametersBlackList$_get_elements_$ref_q86wjg_0() {
    return function (p0) {
      return p0.ifq();
    };
  }
  function QueryParametersBlackListConcept() {
    QueryParametersBlackListConcept_instance = this;
    var tmp = QueryParametersBlackListImpl$_init_$ref_ob5fba();
    OtConceptDescriptor.call(this, 'QueryParametersBlackList', VOID, tmp, QueryParametersBlackListConcept$_init_$lambda_rrf40i, Companion_instance_94.k6m([DocumentNodeConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    var tmp4 = getPropertyCallableRef('library', 1, tmp_1, QueryParametersBlackList$_get_library_$ref_orkkq4_0(), null);
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.referenceRole' call
    var tag = Companion_getInstance_349().whp_1;
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var tmp$ret$0 = new ReferenceLink(getKClass(QueryParametersBlackList), tmp4, getKClass(OntologyLibrary_1), getKClass(QualifiedReferenceContent));
    tmp_0.hhq_1 = this.q6m(tmp$ret$0, tag, 'library');
    var tmp_2 = this;
    var tmp_3 = KProperty1;
    var tmp4_0 = getPropertyCallableRef('elements', 1, tmp_3, QueryParametersBlackList$_get_elements_$ref_q86wjg_0(), null);
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childrenRole' call
    var name = 'elements';
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$2 = new MultipleChildLink(getKClass(QueryParametersBlackList), tmp4_0);
    tmp_2.ihq_1 = this.p6m(tmp$ret$2, name);
    this.jhq_1 = new DomainNodeReferencePropertyDescriptor(this.hhq_1, ReferenceContentPersisters_getInstance().d6m(getKClass(QualifiedReferenceContent)), getKClass(QualifiedReferenceContent));
    this.khq_1 = new DomainNodeChildrenPropertyDescriptor(this.ihq_1.s6i_1);
  }
  var QueryParametersBlackListConcept_instance;
  function QueryParametersBlackListConcept_getInstance() {
    if (QueryParametersBlackListConcept_instance == null)
      new QueryParametersBlackListConcept();
    return QueryParametersBlackListConcept_instance;
  }
  function RelationContainerImpl$_init_$ref_3e7ye8() {
    var l = function (p0, p1) {
      return new RelationContainerImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function RelationContainerConcept$_init_$lambda_4lz394(context, nodeId) {
    return new TypedRelationContainerImpl(context, VOID, nodeId);
  }
  function RelationContainer$_get_processRelations_$ref_503twx_0() {
    return function (p0) {
      return p0.jfu();
    };
  }
  function RelationContainer$_get_instanceRelations_$ref_i7dwvz_0() {
    return function (p0) {
      return p0.kfu();
    };
  }
  function RelationContainerConcept() {
    RelationContainerConcept_instance = this;
    var tmp = RelationContainerImpl$_init_$ref_3e7ye8();
    OtConceptDescriptor.call(this, 'RelationContainer', VOID, tmp, RelationContainerConcept$_init_$lambda_4lz394, Companion_instance_94.k6m([DocumentNodeConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    var tmp4 = getPropertyCallableRef('processRelations', 1, tmp_1, RelationContainer$_get_processRelations_$ref_503twx_0(), null);
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childrenRole' call
    var name = 'relations';
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$0 = new MultipleChildLink(getKClass(RelationContainer_1), tmp4);
    tmp_0.vhq_1 = this.p6m(tmp$ret$0, name);
    var tmp_2 = this;
    var tmp_3 = KProperty1;
    var tmp4_0 = getPropertyCallableRef('instanceRelations', 1, tmp_3, RelationContainer$_get_instanceRelations_$ref_i7dwvz_0(), null);
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childrenRole' call
    var name_0 = 'instanceRelations';
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$2 = new MultipleChildLink(getKClass(RelationContainer_1), tmp4_0);
    tmp_2.whq_1 = this.p6m(tmp$ret$2, name_0);
    this.xhq_1 = new DomainNodeChildrenPropertyDescriptor(this.vhq_1.s6i_1);
    this.yhq_1 = new DomainNodeChildrenPropertyDescriptor(this.whq_1.s6i_1);
  }
  var RelationContainerConcept_instance;
  function RelationContainerConcept_getInstance() {
    if (RelationContainerConcept_instance == null)
      new RelationContainerConcept();
    return RelationContainerConcept_instance;
  }
  function RelationFactExpressionImpl$_init_$ref_4dswkl() {
    var l = function (p0, p1) {
      return new RelationFactExpressionImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function RelationFactExpressionConcept$_init_$lambda_7ahail(context, nodeId) {
    return new TypedRelationFactExpressionImpl(context, VOID, nodeId);
  }
  function RelationFactExpression$_get_left_$ref_54k8bt_0() {
    return function (p0) {
      return p0.dft();
    };
  }
  function RelationFactExpression$_get_right_$ref_6t11ls_0() {
    return function (p0) {
      return p0.eft();
    };
  }
  function RelationFactExpression$_get_relation_$ref_nkh94u_0() {
    return function (p0) {
      return p0.xfq();
    };
  }
  function RelationFactExpressionConcept() {
    RelationFactExpressionConcept_instance = this;
    var tmp = RelationFactExpressionImpl$_init_$ref_4dswkl();
    OtConceptDescriptor.call(this, 'RelationFactExpression', VOID, tmp, RelationFactExpressionConcept$_init_$lambda_7ahail, Companion_instance_94.k6m([FactExpressionConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_0 = getPropertyCallableRef('left', 1, tmp_1, RelationFactExpression$_get_left_$ref_54k8bt_0(), null);
    var tmp$ret$0 = new SingleChildLink(getKClass(RelationFactExpression_1), this_0);
    tmp_0.jhr_1 = this.o6m(tmp$ret$0, 'left');
    var tmp_2 = this;
    var tmp_3 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_1 = getPropertyCallableRef('right', 1, tmp_3, RelationFactExpression$_get_right_$ref_6t11ls_0(), null);
    var tmp$ret$2 = new SingleChildLink(getKClass(RelationFactExpression_1), this_1);
    tmp_2.khr_1 = this.o6m(tmp$ret$2, 'right');
    var tmp_4 = this;
    var tmp_5 = KProperty1;
    var tmp4 = getPropertyCallableRef('relation', 1, tmp_5, RelationFactExpression$_get_relation_$ref_nkh94u_0(), null);
    var tmp6 = Companion_getInstance_316().phr_1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.referenceRole' call
    var name = 'relation';
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var tmp$ret$4 = new ReferenceLink(getKClass(RelationFactExpression_1), tmp4, getKClass(ProcessRelationDeclaration_1), getKClass(QualifiedReferenceContent));
    tmp_4.lhr_1 = this.q6m(tmp$ret$4, tmp6, name);
    this.mhr_1 = new DomainNodeChildPropertyDescriptor(this.jhr_1.s6i_1);
    this.nhr_1 = new DomainNodeChildPropertyDescriptor(this.khr_1.s6i_1);
    this.ohr_1 = new DomainNodeReferencePropertyDescriptor(this.lhr_1, ReferenceContentPersisters_getInstance().d6m(getKClass(QualifiedReferenceContent)), getKClass(QualifiedReferenceContent));
  }
  var RelationFactExpressionConcept_instance;
  function RelationFactExpressionConcept_getInstance() {
    if (RelationFactExpressionConcept_instance == null)
      new RelationFactExpressionConcept();
    return RelationFactExpressionConcept_instance;
  }
  function ReturnTypeCustomCellImpl$_init_$ref_nusc14() {
    var l = function (p0, p1) {
      return new ReturnTypeCustomCellImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function ReturnTypeCustomCellConcept$_init_$lambda_9kfneo(context, nodeId) {
    return new TypedReturnTypeCustomCellImpl(context, VOID, nodeId);
  }
  function ReturnTypeCustomCellConcept() {
    ReturnTypeCustomCellConcept_instance = this;
    var tmp = ReturnTypeCustomCellImpl$_init_$ref_nusc14();
    OtConceptDescriptor.call(this, 'ReturnTypeCustomCell', VOID, tmp, ReturnTypeCustomCellConcept$_init_$lambda_9kfneo, Companion_instance_94.k6m([CustomCellConcept_getInstance()]));
  }
  var ReturnTypeCustomCellConcept_instance;
  function ReturnTypeCustomCellConcept_getInstance() {
    if (ReturnTypeCustomCellConcept_instance == null)
      new ReturnTypeCustomCellConcept();
    return ReturnTypeCustomCellConcept_instance;
  }
  function SetExpressionImpl$_init_$ref_70rzij() {
    var l = function (p0, p1) {
      return new SetExpressionImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function SetExpressionConcept$_init_$lambda_wznnab(context, nodeId) {
    return new TypedSetExpressionImpl(context, VOID, nodeId);
  }
  function SetExpression$_get_expressions_$ref_ildcnv_0() {
    return function (p0) {
      return p0.mfs();
    };
  }
  function SetExpression$_get_isOpen_$ref_wh1gog_0() {
    return function (p0) {
      return p0.lfu();
    };
  }
  function SetExpressionConcept() {
    SetExpressionConcept_instance = this;
    var tmp = SetExpressionImpl$_init_$ref_70rzij();
    OtConceptDescriptor.call(this, 'SetExpression', VOID, tmp, SetExpressionConcept$_init_$lambda_wznnab, Companion_instance_94.k6m([AbstractValueConcept_getInstance(), FactExpressionConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    var tmp4 = getPropertyCallableRef('expressions', 1, tmp_1, SetExpression$_get_expressions_$ref_ildcnv_0(), null);
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childrenRole' call
    var name = 'expressions';
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$0 = new MultipleChildLink(getKClass(SetExpression_1), tmp4);
    tmp_0.ahs_1 = this.p6m(tmp$ret$0, name);
    var tmp_2 = this;
    var tmp_3 = KProperty1;
    tmp_2.bhs_1 = this.r6m(getPropertyCallableRef('isOpen', 1, tmp_3, SetExpression$_get_isOpen_$ref_wh1gog_0(), null), 'isOpen');
    this.chs_1 = new DomainNodeChildrenPropertyDescriptor(this.ahs_1.s6i_1);
    this.dhs_1 = new DomainNodePropertyDescriptor(this.bhs_1, toNonNullPersister(NonNullPersisters_getInstance().k25(), new DefaultValueNullPersister(false)));
  }
  var SetExpressionConcept_instance;
  function SetExpressionConcept_getInstance() {
    if (SetExpressionConcept_instance == null)
      new SetExpressionConcept();
    return SetExpressionConcept_instance;
  }
  function SetValuedPropertyParameterImpl$_init_$ref_h96c1m() {
    var l = function (p0, p1) {
      return new SetValuedPropertyParameterImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function SetValuedPropertyParameterConcept$_init_$lambda_i7m6am(context, nodeId) {
    return new TypedSetValuedPropertyParameterImpl(context, VOID, nodeId);
  }
  function SetValuedPropertyParameter$_get_value_$ref_w1ervu_0() {
    return function (p0) {
      return p0.a1();
    };
  }
  function SetValuedPropertyParameterConcept() {
    SetValuedPropertyParameterConcept_instance = this;
    var tmp = SetValuedPropertyParameterImpl$_init_$ref_h96c1m();
    OtConceptDescriptor.call(this, 'SetValuedPropertyParameter', VOID, tmp, SetValuedPropertyParameterConcept$_init_$lambda_i7m6am, Companion_instance_94.k6m([BTBNodeConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_0 = getPropertyCallableRef('value', 1, tmp_1, SetValuedPropertyParameter$_get_value_$ref_w1ervu_0(), null);
    var tmp$ret$0 = new SingleChildLink(getKClass(SetValuedPropertyParameter_1), this_0);
    tmp_0.ohs_1 = this.o6m(tmp$ret$0, 'value');
    this.phs_1 = new DomainNodeChildPropertyDescriptor(this.ohs_1.s6i_1);
  }
  var SetValuedPropertyParameterConcept_instance;
  function SetValuedPropertyParameterConcept_getInstance() {
    if (SetValuedPropertyParameterConcept_instance == null)
      new SetValuedPropertyParameterConcept();
    return SetValuedPropertyParameterConcept_instance;
  }
  function SimplePropertyTypeImpl$_init_$ref_b6ab2c() {
    var l = function (p0, p1) {
      return new SimplePropertyTypeImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function SimplePropertyTypeConcept$_init_$lambda_tme4t8(context, nodeId) {
    return new TypedSimplePropertyTypeImpl(context, VOID, nodeId);
  }
  function SimplePropertyType$_get_notion_$ref_xv0vzc_0() {
    return function (p0) {
      return p0.mfq();
    };
  }
  function SimplePropertyTypeConcept() {
    SimplePropertyTypeConcept_instance = this;
    var tmp = SimplePropertyTypeImpl$_init_$ref_b6ab2c();
    OtConceptDescriptor.call(this, 'SimplePropertyType', VOID, tmp, SimplePropertyTypeConcept$_init_$lambda_tme4t8, Companion_instance_94.k6m([ProcessPropertyTypeConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    var tmp4 = getPropertyCallableRef('notion', 1, tmp_1, SimplePropertyType$_get_notion_$ref_xv0vzc_0(), null);
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.referenceRole' call
    var tag = Companion_getInstance_341().qhs_1;
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var tmp$ret$0 = new ReferenceLink(getKClass(SimplePropertyType), tmp4, getKClass(AbstractNotion), getKClass(QualifiedReferenceContent));
    tmp_0.bht_1 = this.q6m(tmp$ret$0, tag, 'notion');
    this.cht_1 = new DomainNodeReferencePropertyDescriptor(this.bht_1, ReferenceContentPersisters_getInstance().d6m(getKClass(QualifiedReferenceContent)), getKClass(QualifiedReferenceContent));
  }
  var SimplePropertyTypeConcept_instance;
  function SimplePropertyTypeConcept_getInstance() {
    if (SimplePropertyTypeConcept_instance == null)
      new SimplePropertyTypeConcept();
    return SimplePropertyTypeConcept_instance;
  }
  function SinglePropertyValueRangeImpl$_init_$ref_k2k2g4() {
    var l = function (p0, p1) {
      return new SinglePropertyValueRangeImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function SinglePropertyValueRangeConcept$_init_$lambda_8dh5o4(context, nodeId) {
    return new TypedSinglePropertyValueRangeImpl(context, VOID, nodeId);
  }
  function SinglePropertyValueRange$_get_types_$ref_qpyu2c_0() {
    return function (p0) {
      return p0.cfs();
    };
  }
  function SinglePropertyValueRangeConcept() {
    SinglePropertyValueRangeConcept_instance = this;
    var tmp = SinglePropertyValueRangeImpl$_init_$ref_k2k2g4();
    OtConceptDescriptor.call(this, 'SinglePropertyValueRange', VOID, tmp, SinglePropertyValueRangeConcept$_init_$lambda_8dh5o4, Companion_instance_94.k6m([PropertyValueRangeConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childrenRole' call
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_0 = getPropertyCallableRef('types', 1, tmp_1, SinglePropertyValueRange$_get_types_$ref_qpyu2c_0(), null);
    var tmp$ret$0 = new MultipleChildLink(getKClass(SinglePropertyValueRange_1), this_0);
    tmp_0.nht_1 = this.p6m(tmp$ret$0, 'types');
    this.oht_1 = new DomainNodeChildrenPropertyDescriptor(this.nht_1.s6i_1);
  }
  var SinglePropertyValueRangeConcept_instance;
  function SinglePropertyValueRangeConcept_getInstance() {
    if (SinglePropertyValueRangeConcept_instance == null)
      new SinglePropertyValueRangeConcept();
    return SinglePropertyValueRangeConcept_instance;
  }
  function StringValueImpl$_init_$ref_4jht39() {
    var l = function (p0, p1) {
      return new StringValueImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function StringValueConcept$_init_$lambda_jv8izh(context, nodeId) {
    return new TypedStringValueImpl(context, VOID, nodeId);
  }
  function StringValue$_get_value_$ref_2kxcol_0() {
    return function (p0) {
      return p0.a1();
    };
  }
  function StringValueConcept() {
    StringValueConcept_instance = this;
    var tmp = StringValueImpl$_init_$ref_4jht39();
    OtConceptDescriptor.call(this, 'StringValue', VOID, tmp, StringValueConcept$_init_$lambda_jv8izh, Companion_instance_94.k6m([AbstractValueConcept_getInstance(), FactExpressionConcept_getInstance(), AllowedComplexNotionValueConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    tmp_0.zht_1 = this.r6m(getPropertyCallableRef('value', 1, tmp_1, StringValue$_get_value_$ref_2kxcol_0(), null), 'value');
    this.ahu_1 = new DomainNodePropertyDescriptor(this.zht_1, toNonNullPersister(NonNullPersisters_getInstance().h25(), new DefaultValueNullPersister('')));
  }
  var StringValueConcept_instance;
  function StringValueConcept_getInstance() {
    if (StringValueConcept_instance == null)
      new StringValueConcept();
    return StringValueConcept_instance;
  }
  function TextLineImpl$_init_$ref_994090() {
    var l = function (p0, p1) {
      return new TextLineImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function TextLineConcept$_init_$lambda_lv3jac(context, nodeId) {
    return new TypedTextLineImpl(context, VOID, nodeId);
  }
  function TextLine$_get_text_$ref_oszt1s_0() {
    return function (p0) {
      return p0.o8w();
    };
  }
  function TextLineConcept() {
    TextLineConcept_instance = this;
    var tmp = TextLineImpl$_init_$ref_994090();
    OtConceptDescriptor.call(this, 'TextLine', VOID, tmp, TextLineConcept$_init_$lambda_lv3jac, Companion_instance_94.k6m([BTBNodeConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.textProperty' call
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_0 = getPropertyCallableRef('text', 1, tmp_1, TextLine$_get_text_$ref_oszt1s_0(), null);
    var tmp$ret$0 = new TextAttributeLink(getKClass(TextLine), this_0);
    tmp_0.lhu_1 = this.l6m(tmp$ret$0, 'text');
    this.mhu_1 = new DomainNodeTextPropertyDescriptor(this.lhu_1);
  }
  var TextLineConcept_instance;
  function TextLineConcept_getInstance() {
    if (TextLineConcept_instance == null)
      new TextLineConcept();
    return TextLineConcept_instance;
  }
  function TypeConcept() {
    TypeConcept_instance = this;
    OTAbstractConceptDescriptor.call(this, Companion_instance_94.k6m([VariableSpecificationConcept_getInstance()]));
  }
  var TypeConcept_instance;
  function TypeConcept_getInstance() {
    if (TypeConcept_instance == null)
      new TypeConcept();
    return TypeConcept_instance;
  }
  function TypePlaceholderImpl$_init_$ref_egxawc() {
    var l = function (p0, p1) {
      return new TypePlaceholderImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function TypePlaceholderConcept$_init_$lambda_733cg4(context, nodeId) {
    return new TypedTypePlaceholderImpl(context, VOID, nodeId);
  }
  function TypePlaceholderConcept() {
    TypePlaceholderConcept_instance = this;
    var tmp = TypePlaceholderImpl$_init_$ref_egxawc();
    OtConceptDescriptor.call(this, 'TypePlaceholder', VOID, tmp, TypePlaceholderConcept$_init_$lambda_733cg4, Companion_instance_94.k6m([TypeConcept_getInstance()]));
  }
  var TypePlaceholderConcept_instance;
  function TypePlaceholderConcept_getInstance() {
    if (TypePlaceholderConcept_instance == null)
      new TypePlaceholderConcept();
    return TypePlaceholderConcept_instance;
  }
  function UnionClassImpl$_init_$ref_kxg74s() {
    var l = function (p0, p1) {
      return new UnionClassImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function UnionClassConcept$_init_$lambda_tpo0wc(context, nodeId) {
    return new TypedUnionClassImpl(context, VOID, nodeId);
  }
  function UnionClass$_get_classes_$ref_qbevup_0() {
    return function (p0) {
      return p0.mfu();
    };
  }
  function UnionClassConcept() {
    UnionClassConcept_instance = this;
    var tmp = UnionClassImpl$_init_$ref_kxg74s();
    OtConceptDescriptor.call(this, 'UnionExpression', VOID, tmp, UnionClassConcept$_init_$lambda_tpo0wc, Companion_instance_94.k6m([AnonymousClassConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childrenRole' call
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_0 = getPropertyCallableRef('classes', 1, tmp_1, UnionClass$_get_classes_$ref_qbevup_0(), null);
    var tmp$ret$0 = new MultipleChildLink(getKClass(UnionClass_1), this_0);
    tmp_0.xhu_1 = this.p6m(tmp$ret$0, 'classes');
    this.yhu_1 = new DomainNodeChildrenPropertyDescriptor(this.xhu_1.s6i_1);
  }
  var UnionClassConcept_instance;
  function UnionClassConcept_getInstance() {
    if (UnionClassConcept_instance == null)
      new UnionClassConcept();
    return UnionClassConcept_instance;
  }
  function UnknownComplexNotionValueImpl$_init_$ref_nlsyoh() {
    var l = function (p0, p1) {
      return new UnknownComplexNotionValueImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function UnknownComplexNotionValueConcept$_init_$lambda_ii49zb(context, nodeId) {
    return new TypedUnknownComplexNotionValueImpl(context, VOID, nodeId);
  }
  function UnknownComplexNotionValueConcept() {
    UnknownComplexNotionValueConcept_instance = this;
    var tmp = UnknownComplexNotionValueImpl$_init_$ref_nlsyoh();
    OtConceptDescriptor.call(this, 'UnknownComplexNotionValue', VOID, tmp, UnknownComplexNotionValueConcept$_init_$lambda_ii49zb, Companion_instance_94.k6m([AllowedComplexNotionValueConcept_getInstance()]));
  }
  var UnknownComplexNotionValueConcept_instance;
  function UnknownComplexNotionValueConcept_getInstance() {
    if (UnknownComplexNotionValueConcept_instance == null)
      new UnknownComplexNotionValueConcept();
    return UnknownComplexNotionValueConcept_instance;
  }
  function UrlImpl$_init_$ref_9q5giy() {
    var l = function (p0, p1) {
      return new UrlImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function UrlConcept$_init_$lambda_nb6yge(context, nodeId) {
    return new TypedUrlImpl(context, VOID, nodeId);
  }
  function Url$_get_value_$ref_ipaaxy_0() {
    return function (p0) {
      return p0.a1();
    };
  }
  function UrlConcept() {
    UrlConcept_instance = this;
    var tmp = UrlImpl$_init_$ref_9q5giy();
    OtConceptDescriptor.call(this, 'ProcessUrl', VOID, tmp, UrlConcept$_init_$lambda_nb6yge, Companion_instance_94.k6m([BTBNodeConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    tmp_0.jhv_1 = this.r6m(getPropertyCallableRef('value', 1, tmp_1, Url$_get_value_$ref_ipaaxy_0(), null), 'url');
    this.khv_1 = new DomainNodePropertyDescriptor(this.jhv_1, toNonNullPersister(NonNullPersisters_getInstance().h25(), new DefaultValueNullPersister('')));
  }
  var UrlConcept_instance;
  function UrlConcept_getInstance() {
    if (UrlConcept_instance == null)
      new UrlConcept();
    return UrlConcept_instance;
  }
  function UrlKnowledgeSourceReferenceImpl$_init_$ref_sgpb50() {
    var l = function (p0, p1) {
      return new UrlKnowledgeSourceReferenceImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function UrlKnowledgeSourceReferenceConcept$_init_$lambda_68k7b8(context, nodeId) {
    return new TypedUrlKnowledgeSourceReferenceImpl(context, VOID, nodeId);
  }
  function UrlKnowledgeSourceReference$_get_url_$ref_7q1e5u_0() {
    return function (p0) {
      return p0.qfs();
    };
  }
  function UrlKnowledgeSourceReferenceConcept() {
    UrlKnowledgeSourceReferenceConcept_instance = this;
    var tmp = UrlKnowledgeSourceReferenceImpl$_init_$ref_sgpb50();
    OtConceptDescriptor.call(this, 'UrlKnowledgeSource', VOID, tmp, UrlKnowledgeSourceReferenceConcept$_init_$lambda_68k7b8, Companion_instance_94.k6m([KnowledgeSourceReferenceConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    tmp_0.vhv_1 = this.r6m(getPropertyCallableRef('url', 1, tmp_1, UrlKnowledgeSourceReference$_get_url_$ref_7q1e5u_0(), null), 'url');
    this.whv_1 = new DomainNodePropertyDescriptor(this.vhv_1, toNonNullPersister(NonNullPersisters_getInstance().h25(), new DefaultValueNullPersister('')));
  }
  var UrlKnowledgeSourceReferenceConcept_instance;
  function UrlKnowledgeSourceReferenceConcept_getInstance() {
    if (UrlKnowledgeSourceReferenceConcept_instance == null)
      new UrlKnowledgeSourceReferenceConcept();
    return UrlKnowledgeSourceReferenceConcept_instance;
  }
  function ValueWithRelationsImpl$_init_$ref_h1z1yz() {
    var l = function (p0, p1) {
      return new ValueWithRelationsImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function ValueWithRelationsConcept$_init_$lambda_md949p(context, nodeId) {
    return new TypedValueWithRelationsImpl(context, VOID, nodeId);
  }
  function ValueWithRelations$_get_value_$ref_wsflth_0() {
    return function (p0) {
      return p0.a1();
    };
  }
  function ValueWithRelations$_get_relations_$ref_f0av7f_0() {
    return function (p0) {
      return p0.nfu();
    };
  }
  function ValueWithRelationsConcept() {
    ValueWithRelationsConcept_instance = this;
    var tmp = ValueWithRelationsImpl$_init_$ref_h1z1yz();
    OtConceptDescriptor.call(this, 'ValueWithRelations', VOID, tmp, ValueWithRelationsConcept$_init_$lambda_md949p, Companion_instance_94.k6m([AbstractValueConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_0 = getPropertyCallableRef('value', 1, tmp_1, ValueWithRelations$_get_value_$ref_wsflth_0(), null);
    var tmp$ret$0 = new SingleChildLink(getKClass(ValueWithRelations), this_0);
    tmp_0.hhw_1 = this.o6m(tmp$ret$0, 'value');
    var tmp_2 = this;
    var tmp_3 = KProperty1;
    var tmp4 = getPropertyCallableRef('relations', 1, tmp_3, ValueWithRelations$_get_relations_$ref_f0av7f_0(), null);
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childrenRole' call
    var name = 'relations';
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$2 = new MultipleChildLink(getKClass(ValueWithRelations), tmp4);
    tmp_2.ihw_1 = this.p6m(tmp$ret$2, name);
    this.jhw_1 = new DomainNodeChildPropertyDescriptor(this.hhw_1.s6i_1);
    this.khw_1 = new DomainNodeChildrenPropertyDescriptor(this.ihw_1.s6i_1);
  }
  var ValueWithRelationsConcept_instance;
  function ValueWithRelationsConcept_getInstance() {
    if (ValueWithRelationsConcept_instance == null)
      new ValueWithRelationsConcept();
    return ValueWithRelationsConcept_instance;
  }
  function VariableDeclarationImpl$_init_$ref_lqg8ft() {
    var l = function (p0, p1) {
      return new VariableDeclarationImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function VariableDeclarationConcept$_init_$lambda_pqjz33(context, nodeId) {
    return new TypedVariableDeclarationImpl(context, VOID, nodeId);
  }
  function VariableDeclaration$_get_spec_$ref_h7083f_0() {
    return function (p0) {
      return p0.ofu();
    };
  }
  function VariableDeclaration$_get_relations_$ref_zic3pf_0() {
    return function (p0) {
      return p0.nfu();
    };
  }
  function VariableDeclarationConcept() {
    VariableDeclarationConcept_instance = this;
    var tmp = VariableDeclarationImpl$_init_$ref_lqg8ft();
    OtConceptDescriptor.call(this, 'VariableDeclaration', VOID, tmp, VariableDeclarationConcept$_init_$lambda_pqjz33, Companion_instance_94.k6m([BTBNodeConcept_getInstance(), DirectlyNamedConcept_getInstance(), HasQueryLabelsConcept_getInstance(), HasPropertyConstraintsConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_0 = getPropertyCallableRef('spec', 1, tmp_1, VariableDeclaration$_get_spec_$ref_h7083f_0(), null);
    var tmp$ret$0 = new SingleChildLink(getKClass(VariableDeclaration_1), this_0);
    tmp_0.vhw_1 = this.o6m(tmp$ret$0, 'type');
    var tmp_2 = this;
    var tmp_3 = KProperty1;
    var tmp4 = getPropertyCallableRef('relations', 1, tmp_3, VariableDeclaration$_get_relations_$ref_zic3pf_0(), null);
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childrenRole' call
    var name = 'relations';
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$2 = new MultipleChildLink(getKClass(VariableDeclaration_1), tmp4);
    tmp_2.whw_1 = this.p6m(tmp$ret$2, name);
    this.xhw_1 = new DomainNodeChildPropertyDescriptor(this.vhw_1.s6i_1);
    this.yhw_1 = new DomainNodeChildrenPropertyDescriptor(this.whw_1.s6i_1);
  }
  var VariableDeclarationConcept_instance;
  function VariableDeclarationConcept_getInstance() {
    if (VariableDeclarationConcept_instance == null)
      new VariableDeclarationConcept();
    return VariableDeclarationConcept_instance;
  }
  function VariableInitializerImpl$_init_$ref_ymrzmp() {
    var l = function (p0, p1) {
      return new VariableInitializerImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function VariableInitializerConcept$_init_$lambda_8mmarb(context, nodeId) {
    return new TypedVariableInitializerImpl(context, VOID, nodeId);
  }
  function VariableInitializerConcept() {
    VariableInitializerConcept_instance = this;
    var tmp = VariableInitializerImpl$_init_$ref_ymrzmp();
    OtConceptDescriptor.call(this, 'VariableInitializer', VOID, tmp, VariableInitializerConcept$_init_$lambda_8mmarb, Companion_instance_94.k6m([VariableSpecificationConcept_getInstance()]));
  }
  var VariableInitializerConcept_instance;
  function VariableInitializerConcept_getInstance() {
    if (VariableInitializerConcept_instance == null)
      new VariableInitializerConcept();
    return VariableInitializerConcept_instance;
  }
  function VariablePatternImpl$_init_$ref_rsgm7l() {
    var l = function (p0, p1) {
      return new VariablePatternImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function VariablePatternConcept$_init_$lambda_88jxfb(context, nodeId) {
    return new TypedVariablePatternImpl(context, VOID, nodeId);
  }
  function VariablePattern$_get_variable_$ref_umy4xe_0() {
    return function (p0) {
      return p0.pfu();
    };
  }
  function VariablePatternConcept() {
    VariablePatternConcept_instance = this;
    var tmp = VariablePatternImpl$_init_$ref_rsgm7l();
    OtConceptDescriptor.call(this, 'VariablePattern', VOID, tmp, VariablePatternConcept$_init_$lambda_88jxfb, Companion_instance_94.k6m([PatternConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    var tmp4 = getPropertyCallableRef('variable', 1, tmp_1, VariablePattern$_get_variable_$ref_umy4xe_0(), null);
    var tmp6 = Companion_getInstance_346().zhw_1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.referenceRole' call
    var name = 'variable';
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var tmp$ret$0 = new ReferenceLink(getKClass(VariablePattern_1), tmp4, getKClass(VariableDeclaration_1), getKClass(LocalReferenceContent));
    tmp_0.khx_1 = this.q6m(tmp$ret$0, tmp6, name);
    this.lhx_1 = new DomainNodeReferencePropertyDescriptor(this.khx_1, ReferenceContentPersisters_getInstance().d6m(getKClass(LocalReferenceContent)), getKClass(LocalReferenceContent));
  }
  var VariablePatternConcept_instance;
  function VariablePatternConcept_getInstance() {
    if (VariablePatternConcept_instance == null)
      new VariablePatternConcept();
    return VariablePatternConcept_instance;
  }
  function VariableReferenceValueImpl$_init_$ref_v2s40z() {
    var l = function (p0, p1) {
      return new VariableReferenceValueImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function VariableReferenceValueConcept$_init_$lambda_rhgscl(context, nodeId) {
    return new TypedVariableReferenceValueImpl(context, VOID, nodeId);
  }
  function VariableReferenceValue$_get_variable_$ref_zhtoxs_0() {
    return function (p0) {
      return p0.pfu();
    };
  }
  function VariableReferenceValueConcept() {
    VariableReferenceValueConcept_instance = this;
    var tmp = VariableReferenceValueImpl$_init_$ref_v2s40z();
    OtConceptDescriptor.call(this, 'VariableReferenceValue', VOID, tmp, VariableReferenceValueConcept$_init_$lambda_rhgscl, Companion_instance_94.k6m([VariableInitializerConcept_getInstance(), AbstractValueConcept_getInstance(), FactExpressionConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    var tmp4 = getPropertyCallableRef('variable', 1, tmp_1, VariableReferenceValue$_get_variable_$ref_zhtoxs_0(), null);
    var tmp6 = Companion_getInstance_352().mhx_1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.referenceRole' call
    var name = 'variable';
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var tmp$ret$0 = new ReferenceLink(getKClass(VariableReferenceValue_1), tmp4, getKClass(VariableDeclaration_1), getKClass(LocalReferenceContent));
    tmp_0.xhx_1 = this.q6m(tmp$ret$0, tmp6, name);
    this.yhx_1 = new DomainNodeReferencePropertyDescriptor(this.xhx_1, ReferenceContentPersisters_getInstance().d6m(getKClass(LocalReferenceContent)), getKClass(LocalReferenceContent));
  }
  var VariableReferenceValueConcept_instance;
  function VariableReferenceValueConcept_getInstance() {
    if (VariableReferenceValueConcept_instance == null)
      new VariableReferenceValueConcept();
    return VariableReferenceValueConcept_instance;
  }
  function VariableSpecificationConcept() {
    VariableSpecificationConcept_instance = this;
    OTAbstractConceptDescriptor.call(this, Companion_instance_94.k6m([BTBNodeConcept_getInstance()]));
  }
  var VariableSpecificationConcept_instance;
  function VariableSpecificationConcept_getInstance() {
    if (VariableSpecificationConcept_instance == null)
      new VariableSpecificationConcept();
    return VariableSpecificationConcept_instance;
  }
  function XRefContainerImpl$_init_$ref_w9w469() {
    var l = function (p0, p1) {
      return new XRefContainerImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function XRefContainerConcept$_init_$lambda_bet5h3(context, nodeId) {
    return new TypedXRefContainerImpl(context, VOID, nodeId);
  }
  function XRefContainer$_get_xRef_$ref_p0397h_0() {
    return function (p0) {
      return p0.qfu();
    };
  }
  function XRefContainerConcept() {
    XRefContainerConcept_instance = this;
    var tmp = XRefContainerImpl$_init_$ref_w9w469();
    OtConceptDescriptor.call(this, 'XRefContainer', VOID, tmp, XRefContainerConcept$_init_$lambda_bet5h3, Companion_instance_94.k6m([BTBNodeConcept_getInstance()]));
    var tmp_0 = this;
    var tmp_1 = KProperty1;
    tmp_0.jhy_1 = this.r6m(getPropertyCallableRef('xRef', 1, tmp_1, XRefContainer$_get_xRef_$ref_p0397h_0(), null), 'xRef');
    this.khy_1 = new DomainNodePropertyDescriptor(this.jhy_1, toNonNullPersister(NonNullPersisters_getInstance().h25(), new DefaultValueNullPersister('')));
  }
  var XRefContainerConcept_instance;
  function XRefContainerConcept_getInstance() {
    if (XRefContainerConcept_instance == null)
      new XRefContainerConcept();
    return XRefContainerConcept_instance;
  }
  function btbConceptRegistry(_this__u8e3s4) {
    structure(_this__u8e3s4, btbConceptRegistry$lambda);
  }
  function btbConceptRegistry$lambda($this$structure) {
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor = AbstractBindingDeclarationConcept_getInstance();
    $this$structure.e6y(getKClass(AbstractBindingDeclaration), descriptor);
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_0 = AbstractBindingEntryConcept_getInstance();
    $this$structure.e6y(getKClass(AbstractBindingEntry), descriptor_0);
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_1 = AbstractBindingValueConcept_getInstance();
    $this$structure.e6y(getKClass(AbstractBindingValue), descriptor_1);
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_2 = AbstractBindingValueQueryConcept_getInstance();
    $this$structure.e6y(getKClass(AbstractBindingValueQuery), descriptor_2);
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_3 = AbstractLinkConcept_getInstance();
    $this$structure.e6y(getKClass(AbstractLink), descriptor_3);
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_4 = AbstractNotionConcept_getInstance();
    $this$structure.e6y(getKClass(AbstractNotion), descriptor_4);
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_5 = AbstractOntologyRelationConcept_getInstance();
    $this$structure.e6y(getKClass(AbstractOntologyRelation), descriptor_5);
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_6 = AbstractProcessSpecificationConcept_getInstance();
    $this$structure.e6y(getKClass(AbstractProcessSpecification), descriptor_6);
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_7 = AbstractPropertyConcept_getInstance();
    $this$structure.e6y(getKClass(AbstractProperty), descriptor_7);
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_8 = AuthorConcept_getInstance();
    $this$structure.e6y(getKClass(Author_1), descriptor_8);
    $this$structure.f6y(getKClass(Author_1), $this$structure.c6y() ? getKClass(TypedAuthorImpl) : getKClass(AuthorImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_9 = AuthoredWorkConcept_getInstance();
    $this$structure.e6y(getKClass(AuthoredWork), descriptor_9);
    $this$structure.f6y(getKClass(AuthoredWork), $this$structure.c6y() ? getKClass(TypedAuthoredWorkImpl) : getKClass(AuthoredWorkImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_10 = BTBDocumentConcept_getInstance();
    $this$structure.e6y(getKClass(BTBDocument_1), descriptor_10);
    $this$structure.f6y(getKClass(BTBDocument_1), $this$structure.c6y() ? getKClass(TypedBTBDocumentImpl) : getKClass(BTBDocumentImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_11 = BindingPropertyConcept_getInstance();
    $this$structure.e6y(getKClass(BindingProperty_1), descriptor_11);
    $this$structure.f6y(getKClass(BindingProperty_1), $this$structure.c6y() ? getKClass(TypedBindingPropertyImpl) : getKClass(BindingPropertyImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_12 = BindingValueMaskConcept_getInstance();
    $this$structure.e6y(getKClass(BindingValueMask_1), descriptor_12);
    $this$structure.f6y(getKClass(BindingValueMask_1), $this$structure.c6y() ? getKClass(TypedBindingValueMaskImpl) : getKClass(BindingValueMaskImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_13 = BindingValuePlaceholderConcept_getInstance();
    $this$structure.e6y(getKClass(BindingValuePlaceholder_1), descriptor_13);
    $this$structure.f6y(getKClass(BindingValuePlaceholder_1), $this$structure.c6y() ? getKClass(TypedBindingValuePlaceholderImpl) : getKClass(BindingValuePlaceholderImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_14 = BindingValuePlaceholderQueryConcept_getInstance();
    $this$structure.e6y(getKClass(BindingValuePlaceholderQuery_1), descriptor_14);
    $this$structure.f6y(getKClass(BindingValuePlaceholderQuery_1), $this$structure.c6y() ? getKClass(TypedBindingValuePlaceholderQueryImpl) : getKClass(BindingValuePlaceholderQueryImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_15 = BookConcept_getInstance();
    $this$structure.e6y(getKClass(Book_1), descriptor_15);
    $this$structure.f6y(getKClass(Book_1), $this$structure.c6y() ? getKClass(TypedBookImpl) : getKClass(BookImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_16 = CardinalityConcept_getInstance();
    $this$structure.e6y(getKClass(Cardinality_1), descriptor_16);
    $this$structure.f6y(getKClass(Cardinality_1), $this$structure.c6y() ? getKClass(TypedCardinalityImpl) : getKClass(CardinalityImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_17 = CardinalityBoundConcept_getInstance();
    $this$structure.e6y(getKClass(CardinalityBound), descriptor_17);
    $this$structure.f6y(getKClass(CardinalityBound), $this$structure.c6y() ? getKClass(TypedCardinalityBoundImpl) : getKClass(CardinalityBoundImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_18 = CardinalityBoundConstantConcept_getInstance();
    $this$structure.e6y(getKClass(CardinalityBoundConstant_1), descriptor_18);
    $this$structure.f6y(getKClass(CardinalityBoundConstant_1), $this$structure.c6y() ? getKClass(TypedCardinalityBoundConstantImpl) : getKClass(CardinalityBoundConstantImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_19 = CardinalityBoundNConcept_getInstance();
    $this$structure.e6y(getKClass(CardinalityBoundN_1), descriptor_19);
    $this$structure.f6y(getKClass(CardinalityBoundN_1), $this$structure.c6y() ? getKClass(TypedCardinalityBoundNImpl) : getKClass(CardinalityBoundNImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_20 = CardinalityBoundPlaceholderConcept_getInstance();
    $this$structure.e6y(getKClass(CardinalityBoundPlaceholder_1), descriptor_20);
    $this$structure.f6y(getKClass(CardinalityBoundPlaceholder_1), $this$structure.c6y() ? getKClass(TypedCardinalityBoundPlaceholderImpl) : getKClass(CardinalityBoundPlaceholderImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_21 = CardinalityCustomCellConcept_getInstance();
    $this$structure.e6y(getKClass(CardinalityCustomCell_1), descriptor_21);
    $this$structure.f6y(getKClass(CardinalityCustomCell_1), $this$structure.c6y() ? getKClass(TypedCardinalityCustomCellImpl) : getKClass(CardinalityCustomCellImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_22 = CategoryConcept_getInstance();
    $this$structure.e6y(getKClass(Category_1), descriptor_22);
    $this$structure.f6y(getKClass(Category_1), $this$structure.c6y() ? getKClass(TypedCategoryImpl) : getKClass(CategoryImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_23 = ClassExpressionPlaceholderConcept_getInstance();
    $this$structure.e6y(getKClass(ClassExpressionPlaceholder_1), descriptor_23);
    $this$structure.f6y(getKClass(ClassExpressionPlaceholder_1), $this$structure.c6y() ? getKClass(TypedClassExpressionPlaceholderImpl) : getKClass(ClassExpressionPlaceholderImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_24 = ClassExpressionTypeConcept_getInstance();
    $this$structure.e6y(getKClass(ClassExpressionType_1), descriptor_24);
    $this$structure.f6y(getKClass(ClassExpressionType_1), $this$structure.c6y() ? getKClass(TypedClassExpressionTypeImpl) : getKClass(ClassExpressionTypeImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_25 = CommandConcept_getInstance();
    $this$structure.e6y(getKClass(Command_0), descriptor_25);
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_26 = ComplexNotionConcept_getInstance();
    $this$structure.e6y(getKClass(ComplexNotion_1), descriptor_26);
    $this$structure.f6y(getKClass(ComplexNotion_1), $this$structure.c6y() ? getKClass(TypedComplexNotionImpl) : getKClass(ComplexNotionImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_27 = ComplexNotionElementConcept_getInstance();
    $this$structure.e6y(getKClass(ComplexNotionElement_1), descriptor_27);
    $this$structure.f6y(getKClass(ComplexNotionElement_1), $this$structure.c6y() ? getKClass(TypedComplexNotionElementImpl) : getKClass(ComplexNotionElementImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_28 = ComplexNotionElementValueConcept_getInstance();
    $this$structure.e6y(getKClass(ComplexNotionElementValue_1), descriptor_28);
    $this$structure.f6y(getKClass(ComplexNotionElementValue_1), $this$structure.c6y() ? getKClass(TypedComplexNotionElementValueImpl) : getKClass(ComplexNotionElementValueImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_29 = ComplexNotionTemplateConcept_getInstance();
    $this$structure.e6y(getKClass(ComplexNotionTemplate_1), descriptor_29);
    $this$structure.f6y(getKClass(ComplexNotionTemplate_1), $this$structure.c6y() ? getKClass(TypedComplexNotionTemplateImpl) : getKClass(ComplexNotionTemplateImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_30 = ComplexNotionTemplateElementConcept_getInstance();
    $this$structure.e6y(getKClass(ComplexNotionTemplateElement), descriptor_30);
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_31 = ComplexNotionTemplatePlaceholderConcept_getInstance();
    $this$structure.e6y(getKClass(ComplexNotionTemplatePlaceholder_1), descriptor_31);
    $this$structure.f6y(getKClass(ComplexNotionTemplatePlaceholder_1), $this$structure.c6y() ? getKClass(TypedComplexNotionTemplatePlaceholderImpl) : getKClass(ComplexNotionTemplatePlaceholderImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_32 = ComplexNotionTemplateRefElementConcept_getInstance();
    $this$structure.e6y(getKClass(ComplexNotionTemplateRefElement_1), descriptor_32);
    $this$structure.f6y(getKClass(ComplexNotionTemplateRefElement_1), $this$structure.c6y() ? getKClass(TypedComplexNotionTemplateRefElementImpl) : getKClass(ComplexNotionTemplateRefElementImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_33 = ComplexNotionTemplateTextElementConcept_getInstance();
    $this$structure.e6y(getKClass(ComplexNotionTemplateTextElement_1), descriptor_33);
    $this$structure.f6y(getKClass(ComplexNotionTemplateTextElement_1), $this$structure.c6y() ? getKClass(TypedComplexNotionTemplateTextElementImpl) : getKClass(ComplexNotionTemplateTextElementImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_34 = ComplexNotionValueConcept_getInstance();
    $this$structure.e6y(getKClass(ComplexNotionValue_1), descriptor_34);
    $this$structure.f6y(getKClass(ComplexNotionValue_1), $this$structure.c6y() ? getKClass(TypedComplexNotionValueImpl) : getKClass(ComplexNotionValueImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_35 = ConstantCustomCellConcept_getInstance();
    $this$structure.e6y(getKClass(ConstantCustomCell_1), descriptor_35);
    $this$structure.f6y(getKClass(ConstantCustomCell_1), $this$structure.c6y() ? getKClass(TypedConstantCustomCellImpl) : getKClass(ConstantCustomCellImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_36 = ConstantPreconditionConcept_getInstance();
    $this$structure.e6y(getKClass(ConstantPrecondition_0), descriptor_36);
    $this$structure.f6y(getKClass(ConstantPrecondition_0), $this$structure.c6y() ? getKClass(TypedConstantPreconditionImpl) : getKClass(ConstantPreconditionImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_37 = ContextConcept_getInstance();
    $this$structure.e6y(getKClass(Context_2), descriptor_37);
    $this$structure.f6y(getKClass(Context_2), $this$structure.c6y() ? getKClass(TypedContextImpl) : getKClass(ContextImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_38 = ContextQueryConcept_getInstance();
    $this$structure.e6y(getKClass(ContextQuery_1), descriptor_38);
    $this$structure.f6y(getKClass(ContextQuery_1), $this$structure.c6y() ? getKClass(TypedContextQueryImpl) : getKClass(ContextQueryImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_39 = CustomCellConcept_getInstance();
    $this$structure.e6y(getKClass(CustomCell), descriptor_39);
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_40 = CustomEditorConcept_getInstance();
    $this$structure.e6y(getKClass(CustomEditor), descriptor_40);
    $this$structure.f6y(getKClass(CustomEditor), $this$structure.c6y() ? getKClass(TypedCustomEditorImpl) : getKClass(CustomEditorImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_41 = DeclarationNameCustomCellConcept_getInstance();
    $this$structure.e6y(getKClass(DeclarationNameCustomCell_1), descriptor_41);
    $this$structure.f6y(getKClass(DeclarationNameCustomCell_1), $this$structure.c6y() ? getKClass(TypedDeclarationNameCustomCellImpl) : getKClass(DeclarationNameCustomCellImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_42 = DeclarationValueQueryConcept_getInstance();
    $this$structure.e6y(getKClass(DeclarationValueQuery), descriptor_42);
    $this$structure.f6y(getKClass(DeclarationValueQuery), $this$structure.c6y() ? getKClass(TypedDeclarationValueQueryImpl) : getKClass(DeclarationValueQueryImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_43 = DocumentNodeConcept_getInstance();
    $this$structure.e6y(getKClass(DocumentNode_0), descriptor_43);
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_44 = EmptyBindingEntryConcept_getInstance();
    $this$structure.e6y(getKClass(EmptyBindingEntry_1), descriptor_44);
    $this$structure.f6y(getKClass(EmptyBindingEntry_1), $this$structure.c6y() ? getKClass(TypedEmptyBindingEntryImpl) : getKClass(EmptyBindingEntryImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_45 = EmptyPropertyLibraryElementConcept_getInstance();
    $this$structure.e6y(getKClass(EmptyPropertyLibraryElement_1), descriptor_45);
    $this$structure.f6y(getKClass(EmptyPropertyLibraryElement_1), $this$structure.c6y() ? getKClass(TypedEmptyPropertyLibraryElementImpl) : getKClass(EmptyPropertyLibraryElementImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_46 = EnumValueConcept_getInstance();
    $this$structure.e6y(getKClass(EnumValue_1), descriptor_46);
    $this$structure.f6y(getKClass(EnumValue_1), $this$structure.c6y() ? getKClass(TypedEnumValueImpl) : getKClass(EnumValueImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_47 = EnumerableNotionConcept_getInstance();
    $this$structure.e6y(getKClass(EnumerableNotion_1), descriptor_47);
    $this$structure.f6y(getKClass(EnumerableNotion_1), $this$structure.c6y() ? getKClass(TypedEnumerableNotionImpl) : getKClass(EnumerableNotionImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_48 = EnumerationConstantConcept_getInstance();
    $this$structure.e6y(getKClass(EnumerationConstant_1), descriptor_48);
    $this$structure.f6y(getKClass(EnumerationConstant_1), $this$structure.c6y() ? getKClass(TypedEnumerationConstantImpl) : getKClass(EnumerationConstantImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_49 = ExtensionDeclarationConcept_getInstance();
    $this$structure.e6y(getKClass(ExtensionDeclaration_1), descriptor_49);
    $this$structure.f6y(getKClass(ExtensionDeclaration_1), $this$structure.c6y() ? getKClass(TypedExtensionDeclarationImpl) : getKClass(ExtensionDeclarationImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_50 = ExtensionFieldReferenceConcept_getInstance();
    $this$structure.e6y(getKClass(ExtensionFieldReference_1), descriptor_50);
    $this$structure.f6y(getKClass(ExtensionFieldReference_1), $this$structure.c6y() ? getKClass(TypedExtensionFieldReferenceImpl) : getKClass(ExtensionFieldReferenceImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_51 = ExtensionLibraryConcept_getInstance();
    $this$structure.e6y(getKClass(ExtensionLibrary_1), descriptor_51);
    $this$structure.f6y(getKClass(ExtensionLibrary_1), $this$structure.c6y() ? getKClass(TypedExtensionLibraryImpl) : getKClass(ExtensionLibraryImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_52 = FactConcept_getInstance();
    $this$structure.e6y(getKClass(Fact_1), descriptor_52);
    $this$structure.f6y(getKClass(Fact_1), $this$structure.c6y() ? getKClass(TypedFactImpl) : getKClass(FactImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_53 = FactExpressionPlaceholderConcept_getInstance();
    $this$structure.e6y(getKClass(FactExpressionPlaceholder), descriptor_53);
    $this$structure.f6y(getKClass(FactExpressionPlaceholder), $this$structure.c6y() ? getKClass(TypedFactExpressionPlaceholderImpl) : getKClass(FactExpressionPlaceholderImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_54 = FactPreconditionConcept_getInstance();
    $this$structure.e6y(getKClass(FactPrecondition_1), descriptor_54);
    $this$structure.f6y(getKClass(FactPrecondition_1), $this$structure.c6y() ? getKClass(TypedFactPreconditionImpl) : getKClass(FactPreconditionImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_55 = FactReferenceConcept_getInstance();
    $this$structure.e6y(getKClass(FactReference_1), descriptor_55);
    $this$structure.f6y(getKClass(FactReference_1), $this$structure.c6y() ? getKClass(TypedFactReferenceImpl) : getKClass(FactReferenceImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_56 = FactSetConcept_getInstance();
    $this$structure.e6y(getKClass(FactSet_1), descriptor_56);
    $this$structure.f6y(getKClass(FactSet_1), $this$structure.c6y() ? getKClass(TypedFactSetImpl) : getKClass(FactSetImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_57 = FieldDeclarationConcept_getInstance();
    $this$structure.e6y(getKClass(FieldDeclaration_1), descriptor_57);
    $this$structure.f6y(getKClass(FieldDeclaration_1), $this$structure.c6y() ? getKClass(TypedFieldDeclarationImpl) : getKClass(FieldDeclarationImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_58 = FindConnectionCommandConcept_getInstance();
    $this$structure.e6y(getKClass(FindConnectionCommand_1), descriptor_58);
    $this$structure.f6y(getKClass(FindConnectionCommand_1), $this$structure.c6y() ? getKClass(TypedFindConnectionCommandImpl) : getKClass(FindConnectionCommandImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_59 = FindNewConnectionCommandConcept_getInstance();
    $this$structure.e6y(getKClass(FindNewConnectionCommand_1), descriptor_59);
    $this$structure.f6y(getKClass(FindNewConnectionCommand_1), $this$structure.c6y() ? getKClass(TypedFindNewConnectionCommandImpl) : getKClass(FindNewConnectionCommandImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_60 = FunctionDeclarationConcept_getInstance();
    $this$structure.e6y(getKClass(FunctionDeclaration_1), descriptor_60);
    $this$structure.f6y(getKClass(FunctionDeclaration_1), $this$structure.c6y() ? getKClass(TypedFunctionDeclarationImpl) : getKClass(FunctionDeclarationImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_61 = FunctionLibraryConcept_getInstance();
    $this$structure.e6y(getKClass(FunctionLibrary_1), descriptor_61);
    $this$structure.f6y(getKClass(FunctionLibrary_1), $this$structure.c6y() ? getKClass(TypedFunctionLibraryImpl) : getKClass(FunctionLibraryImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_62 = FunctionTermConcept_getInstance();
    $this$structure.e6y(getKClass(FunctionTerm_1), descriptor_62);
    $this$structure.f6y(getKClass(FunctionTerm_1), $this$structure.c6y() ? getKClass(TypedFunctionTermImpl) : getKClass(FunctionTermImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_63 = ImportedLinkConcept_getInstance();
    $this$structure.e6y(getKClass(ImportedLink_1), descriptor_63);
    $this$structure.f6y(getKClass(ImportedLink_1), $this$structure.c6y() ? getKClass(TypedImportedLinkImpl) : getKClass(ImportedLinkImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_64 = ImportedPropertyConcept_getInstance();
    $this$structure.e6y(getKClass(ImportedProperty_1), descriptor_64);
    $this$structure.f6y(getKClass(ImportedProperty_1), $this$structure.c6y() ? getKClass(TypedImportedPropertyImpl) : getKClass(ImportedPropertyImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_65 = InheritedProcessPropertyConcept_getInstance();
    $this$structure.e6y(getKClass(InheritedProcessProperty), descriptor_65);
    $this$structure.f6y(getKClass(InheritedProcessProperty), $this$structure.c6y() ? getKClass(TypedInheritedProcessPropertyImpl) : getKClass(InheritedProcessPropertyImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_66 = InstanceRelationDeclarationConcept_getInstance();
    $this$structure.e6y(getKClass(InstanceRelationDeclaration), descriptor_66);
    $this$structure.f6y(getKClass(InstanceRelationDeclaration), $this$structure.c6y() ? getKClass(TypedInstanceRelationDeclarationImpl) : getKClass(InstanceRelationDeclarationImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_67 = InstanceRelationValueConcept_getInstance();
    $this$structure.e6y(getKClass(InstanceRelationValue), descriptor_67);
    $this$structure.f6y(getKClass(InstanceRelationValue), $this$structure.c6y() ? getKClass(TypedInstanceRelationValueImpl) : getKClass(InstanceRelationValueImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_68 = InstanceRelationValuePlaceholderConcept_getInstance();
    $this$structure.e6y(getKClass(InstanceRelationValuePlaceholder), descriptor_68);
    $this$structure.f6y(getKClass(InstanceRelationValuePlaceholder), $this$structure.c6y() ? getKClass(TypedInstanceRelationValuePlaceholderImpl) : getKClass(InstanceRelationValuePlaceholderImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_69 = IntegerValueConcept_getInstance();
    $this$structure.e6y(getKClass(IntegerValue_1), descriptor_69);
    $this$structure.f6y(getKClass(IntegerValue_1), $this$structure.c6y() ? getKClass(TypedIntegerValueImpl) : getKClass(IntegerValueImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_70 = IsExpressionConcept_getInstance();
    $this$structure.e6y(getKClass(IsExpression_1), descriptor_70);
    $this$structure.f6y(getKClass(IsExpression_1), $this$structure.c6y() ? getKClass(TypedIsExpressionImpl) : getKClass(IsExpressionImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_71 = KindCustomCellConcept_getInstance();
    $this$structure.e6y(getKClass(KindCustomCell_1), descriptor_71);
    $this$structure.f6y(getKClass(KindCustomCell_1), $this$structure.c6y() ? getKClass(TypedKindCustomCellImpl) : getKClass(KindCustomCellImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_72 = KnowledgeSourceReferenceConcept_getInstance();
    $this$structure.e6y(getKClass(KnowledgeSourceReference), descriptor_72);
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_73 = KnowledgeSourceReferencePlaceholderConcept_getInstance();
    $this$structure.e6y(getKClass(KnowledgeSourceReferencePlaceholder_1), descriptor_73);
    $this$structure.f6y(getKClass(KnowledgeSourceReferencePlaceholder_1), $this$structure.c6y() ? getKClass(TypedKnowledgeSourceReferencePlaceholderImpl) : getKClass(KnowledgeSourceReferencePlaceholderImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_74 = LibraryItemPlaceholderConcept_getInstance();
    $this$structure.e6y(getKClass(LibraryItemPlaceholder_1), descriptor_74);
    $this$structure.f6y(getKClass(LibraryItemPlaceholder_1), $this$structure.c6y() ? getKClass(TypedLibraryItemPlaceholderImpl) : getKClass(LibraryItemPlaceholderImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_75 = LibraryProcessSpecificationConcept_getInstance();
    $this$structure.e6y(getKClass(LibraryProcessSpecification_1), descriptor_75);
    $this$structure.f6y(getKClass(LibraryProcessSpecification_1), $this$structure.c6y() ? getKClass(TypedLibraryProcessSpecificationImpl) : getKClass(LibraryProcessSpecificationImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_76 = LibraryProcessSpecificationQueryConcept_getInstance();
    $this$structure.e6y(getKClass(LibraryProcessSpecificationQuery_1), descriptor_76);
    $this$structure.f6y(getKClass(LibraryProcessSpecificationQuery_1), $this$structure.c6y() ? getKClass(TypedLibraryProcessSpecificationQueryImpl) : getKClass(LibraryProcessSpecificationQueryImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_77 = LinkCustomCellConcept_getInstance();
    $this$structure.e6y(getKClass(LinkCustomCell_1), descriptor_77);
    $this$structure.f6y(getKClass(LinkCustomCell_1), $this$structure.c6y() ? getKClass(TypedLinkCustomCellImpl) : getKClass(LinkCustomCellImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_78 = LinkDeclarationConcept_getInstance();
    $this$structure.e6y(getKClass(LinkDeclaration_1), descriptor_78);
    $this$structure.f6y(getKClass(LinkDeclaration_1), $this$structure.c6y() ? getKClass(TypedLinkDeclarationImpl) : getKClass(LinkDeclarationImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_79 = LinkLibraryConcept_getInstance();
    $this$structure.e6y(getKClass(LinkLibrary_1), descriptor_79);
    $this$structure.f6y(getKClass(LinkLibrary_1), $this$structure.c6y() ? getKClass(TypedLinkLibraryImpl) : getKClass(LinkLibraryImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_80 = LinkStubConcept_getInstance();
    $this$structure.e6y(getKClass(LinkStub), descriptor_80);
    $this$structure.f6y(getKClass(LinkStub), $this$structure.c6y() ? getKClass(TypedLinkStubImpl) : getKClass(LinkStubImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_81 = LocalOntologyElementReferenceConcept_getInstance();
    $this$structure.e6y(getKClass(LocalOntologyElementReference_1), descriptor_81);
    $this$structure.f6y(getKClass(LocalOntologyElementReference_1), $this$structure.c6y() ? getKClass(TypedLocalOntologyElementReferenceImpl) : getKClass(LocalOntologyElementReferenceImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_82 = MeasurableNotionConcept_getInstance();
    $this$structure.e6y(getKClass(MeasurableNotion_1), descriptor_82);
    $this$structure.f6y(getKClass(MeasurableNotion_1), $this$structure.c6y() ? getKClass(TypedMeasurableNotionImpl) : getKClass(MeasurableNotionImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_83 = MeasurableValueConcept_getInstance();
    $this$structure.e6y(getKClass(MeasurableValue_1), descriptor_83);
    $this$structure.f6y(getKClass(MeasurableValue_1), $this$structure.c6y() ? getKClass(TypedMeasurableValueImpl) : getKClass(MeasurableValueImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_84 = MeasurementUnitConcept_getInstance();
    $this$structure.e6y(getKClass(MeasurementUnit_1), descriptor_84);
    $this$structure.f6y(getKClass(MeasurementUnit_1), $this$structure.c6y() ? getKClass(TypedMeasurementUnitImpl) : getKClass(MeasurementUnitImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_85 = ModifierContainerConcept_getInstance();
    $this$structure.e6y(getKClass(ModifierContainer), descriptor_85);
    $this$structure.f6y(getKClass(ModifierContainer), $this$structure.c6y() ? getKClass(TypedModifierContainerImpl) : getKClass(ModifierContainerImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_86 = ModifierDeclarationConcept_getInstance();
    $this$structure.e6y(getKClass(ModifierDeclaration), descriptor_86);
    $this$structure.f6y(getKClass(ModifierDeclaration), $this$structure.c6y() ? getKClass(TypedModifierDeclarationImpl) : getKClass(ModifierDeclarationImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_87 = ModifierFactExpressionConcept_getInstance();
    $this$structure.e6y(getKClass(ModifierFactExpression_0), descriptor_87);
    $this$structure.f6y(getKClass(ModifierFactExpression_0), $this$structure.c6y() ? getKClass(TypedModifierFactExpressionImpl) : getKClass(ModifierFactExpressionImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_88 = MultilineTextConcept_getInstance();
    $this$structure.e6y(getKClass(MultilineText), descriptor_88);
    $this$structure.f6y(getKClass(MultilineText), $this$structure.c6y() ? getKClass(TypedMultilineTextImpl) : getKClass(MultilineTextImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_89 = MultipleProcessPropertyValueRangeConcept_getInstance();
    $this$structure.e6y(getKClass(MultipleProcessPropertyValueRange_1), descriptor_89);
    $this$structure.f6y(getKClass(MultipleProcessPropertyValueRange_1), $this$structure.c6y() ? getKClass(TypedMultipleProcessPropertyValueRangeImpl) : getKClass(MultipleProcessPropertyValueRangeImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_90 = MultiplePropertyValueRangeConcept_getInstance();
    $this$structure.e6y(getKClass(MultiplePropertyValueRange_1), descriptor_90);
    $this$structure.f6y(getKClass(MultiplePropertyValueRange_1), $this$structure.c6y() ? getKClass(TypedMultiplePropertyValueRangeImpl) : getKClass(MultiplePropertyValueRangeImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_91 = MultipliedExpressionConcept_getInstance();
    $this$structure.e6y(getKClass(MultipliedExpression_1), descriptor_91);
    $this$structure.f6y(getKClass(MultipliedExpression_1), $this$structure.c6y() ? getKClass(TypedMultipliedExpressionImpl) : getKClass(MultipliedExpressionImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_92 = NewFactConcept_getInstance();
    $this$structure.e6y(getKClass(NewFact), descriptor_92);
    $this$structure.f6y(getKClass(NewFact), $this$structure.c6y() ? getKClass(TypedNewFactImpl) : getKClass(NewFactImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_93 = NewFactReferenceConcept_getInstance();
    $this$structure.e6y(getKClass(NewFactReference_0), descriptor_93);
    $this$structure.f6y(getKClass(NewFactReference_0), $this$structure.c6y() ? getKClass(TypedNewFactReferenceImpl) : getKClass(NewFactReferenceImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_94 = NoValuesConcept_getInstance();
    $this$structure.e6y(getKClass(NoValues_1), descriptor_94);
    $this$structure.f6y(getKClass(NoValues_1), $this$structure.c6y() ? getKClass(TypedNoValuesImpl) : getKClass(NoValuesImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_95 = NotionLibraryConcept_getInstance();
    $this$structure.e6y(getKClass(NotionLibrary_1), descriptor_95);
    $this$structure.f6y(getKClass(NotionLibrary_1), $this$structure.c6y() ? getKClass(TypedNotionLibraryImpl) : getKClass(NotionLibraryImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_96 = NotionPlaceholderConcept_getInstance();
    $this$structure.e6y(getKClass(NotionPlaceholder_1), descriptor_96);
    $this$structure.f6y(getKClass(NotionPlaceholder_1), $this$structure.c6y() ? getKClass(TypedNotionPlaceholderImpl) : getKClass(NotionPlaceholderImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_97 = NotionStubConcept_getInstance();
    $this$structure.e6y(getKClass(NotionStub), descriptor_97);
    $this$structure.f6y(getKClass(NotionStub), $this$structure.c6y() ? getKClass(TypedNotionStubImpl) : getKClass(NotionStubImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_98 = NotionTypeConcept_getInstance();
    $this$structure.e6y(getKClass(NotionType_0), descriptor_98);
    $this$structure.f6y(getKClass(NotionType_0), $this$structure.c6y() ? getKClass(TypedNotionTypeImpl) : getKClass(NotionTypeImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_99 = ObjectPropertiesLibraryConcept_getInstance();
    $this$structure.e6y(getKClass(ObjectPropertiesLibrary), descriptor_99);
    $this$structure.f6y(getKClass(ObjectPropertiesLibrary), $this$structure.c6y() ? getKClass(TypedObjectPropertiesLibraryImpl) : getKClass(ObjectPropertiesLibraryImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_100 = ObjectPropertyDeclarationConcept_getInstance();
    $this$structure.e6y(getKClass(ObjectPropertyDeclaration_1), descriptor_100);
    $this$structure.f6y(getKClass(ObjectPropertyDeclaration_1), $this$structure.c6y() ? getKClass(TypedObjectPropertyDeclarationImpl) : getKClass(ObjectPropertyDeclarationImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_101 = ObjectPropertyReferenceValueConcept_getInstance();
    $this$structure.e6y(getKClass(ObjectPropertyReferenceValue_1), descriptor_101);
    $this$structure.f6y(getKClass(ObjectPropertyReferenceValue_1), $this$structure.c6y() ? getKClass(TypedObjectPropertyReferenceValueImpl) : getKClass(ObjectPropertyReferenceValueImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_102 = OldPublishedSourceConcept_getInstance();
    $this$structure.e6y(getKClass(OldPublishedSource), descriptor_102);
    $this$structure.f6y(getKClass(OldPublishedSource), $this$structure.c6y() ? getKClass(TypedOldPublishedSourceImpl) : getKClass(OldPublishedSourceImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_103 = OneOfConcept_getInstance();
    $this$structure.e6y(getKClass(OneOf_1), descriptor_103);
    $this$structure.f6y(getKClass(OneOf_1), $this$structure.c6y() ? getKClass(TypedOneOfImpl) : getKClass(OneOfImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_104 = OntologyCardinalityRelationConcept_getInstance();
    $this$structure.e6y(getKClass(OntologyCardinalityRelation_1), descriptor_104);
    $this$structure.f6y(getKClass(OntologyCardinalityRelation_1), $this$structure.c6y() ? getKClass(TypedOntologyCardinalityRelationImpl) : getKClass(OntologyCardinalityRelationImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_105 = OntologyElementConcept_getInstance();
    $this$structure.e6y(getKClass(OntologyElement_1), descriptor_105);
    $this$structure.f6y(getKClass(OntologyElement_1), $this$structure.c6y() ? getKClass(TypedOntologyElementImpl) : getKClass(OntologyElementImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_106 = OntologyElementDefinitionConcept_getInstance();
    $this$structure.e6y(getKClass(OntologyElementDefinition_1), descriptor_106);
    $this$structure.f6y(getKClass(OntologyElementDefinition_1), $this$structure.c6y() ? getKClass(TypedOntologyElementDefinitionImpl) : getKClass(OntologyElementDefinitionImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_107 = OntologyElementPropertyTypeConcept_getInstance();
    $this$structure.e6y(getKClass(OntologyElementPropertyType_1), descriptor_107);
    $this$structure.f6y(getKClass(OntologyElementPropertyType_1), $this$structure.c6y() ? getKClass(TypedOntologyElementPropertyTypeImpl) : getKClass(OntologyElementPropertyTypeImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_108 = OntologyElementReferenceConcept_getInstance();
    $this$structure.e6y(getKClass(OntologyElementReference_1), descriptor_108);
    $this$structure.f6y(getKClass(OntologyElementReference_1), $this$structure.c6y() ? getKClass(TypedOntologyElementReferenceImpl) : getKClass(OntologyElementReferenceImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_109 = OntologyElementReferenceValueConcept_getInstance();
    $this$structure.e6y(getKClass(OntologyElementReferenceValue_1), descriptor_109);
    $this$structure.f6y(getKClass(OntologyElementReferenceValue_1), $this$structure.c6y() ? getKClass(TypedOntologyElementReferenceValueImpl) : getKClass(OntologyElementReferenceValueImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_110 = OntologyElementReferenceValueLibraryConcept_getInstance();
    $this$structure.e6y(getKClass(OntologyElementReferenceValueLibrary_1), descriptor_110);
    $this$structure.f6y(getKClass(OntologyElementReferenceValueLibrary_1), $this$structure.c6y() ? getKClass(TypedOntologyElementReferenceValueLibraryImpl) : getKClass(OntologyElementReferenceValueLibraryImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_111 = OntologyElementSynonymConcept_getInstance();
    $this$structure.e6y(getKClass(OntologyElementSynonym_1), descriptor_111);
    $this$structure.f6y(getKClass(OntologyElementSynonym_1), $this$structure.c6y() ? getKClass(TypedOntologyElementSynonymImpl) : getKClass(OntologyElementSynonymImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_112 = OntologyElementTypeConcept_getInstance();
    $this$structure.e6y(getKClass(OntologyElementType_1), descriptor_112);
    $this$structure.f6y(getKClass(OntologyElementType_1), $this$structure.c6y() ? getKClass(TypedOntologyElementTypeImpl) : getKClass(OntologyElementTypeImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_113 = OntologyImportConcept_getInstance();
    $this$structure.e6y(getKClass(OntologyImport_1), descriptor_113);
    $this$structure.f6y(getKClass(OntologyImport_1), $this$structure.c6y() ? getKClass(TypedOntologyImportImpl) : getKClass(OntologyImportImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_114 = OntologyImportRootConcept_getInstance();
    $this$structure.e6y(getKClass(OntologyImportRoot_1), descriptor_114);
    $this$structure.f6y(getKClass(OntologyImportRoot_1), $this$structure.c6y() ? getKClass(TypedOntologyImportRootImpl) : getKClass(OntologyImportRootImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_115 = OntologyImportRootReferenceConcept_getInstance();
    $this$structure.e6y(getKClass(OntologyImportRootReference_1), descriptor_115);
    $this$structure.f6y(getKClass(OntologyImportRootReference_1), $this$structure.c6y() ? getKClass(TypedOntologyImportRootReferenceImpl) : getKClass(OntologyImportRootReferenceImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_116 = OntologyIsRelationConcept_getInstance();
    $this$structure.e6y(getKClass(OntologyIsRelation_1), descriptor_116);
    $this$structure.f6y(getKClass(OntologyIsRelation_1), $this$structure.c6y() ? getKClass(TypedOntologyIsRelationImpl) : getKClass(OntologyIsRelationImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_117 = OntologyLibraryConcept_getInstance();
    $this$structure.e6y(getKClass(OntologyLibrary_1), descriptor_117);
    $this$structure.f6y(getKClass(OntologyLibrary_1), $this$structure.c6y() ? getKClass(TypedOntologyLibraryImpl) : getKClass(OntologyLibraryImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_118 = OntologyLibraryReferenceConcept_getInstance();
    $this$structure.e6y(getKClass(OntologyLibraryReference_1), descriptor_118);
    $this$structure.f6y(getKClass(OntologyLibraryReference_1), $this$structure.c6y() ? getKClass(TypedOntologyLibraryReferenceImpl) : getKClass(OntologyLibraryReferenceImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_119 = OntologyLinkConcept_getInstance();
    $this$structure.e6y(getKClass(OntologyLink_1), descriptor_119);
    $this$structure.f6y(getKClass(OntologyLink_1), $this$structure.c6y() ? getKClass(TypedOntologyLinkImpl) : getKClass(OntologyLinkImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_120 = OntologyLinkDeclarationValueQueryConcept_getInstance();
    $this$structure.e6y(getKClass(OntologyLinkDeclarationValueQuery_1), descriptor_120);
    $this$structure.f6y(getKClass(OntologyLinkDeclarationValueQuery_1), $this$structure.c6y() ? getKClass(TypedOntologyLinkDeclarationValueQueryImpl) : getKClass(OntologyLinkDeclarationValueQueryImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_121 = OntologyLinkValueConcept_getInstance();
    $this$structure.e6y(getKClass(OntologyLinkValue_1), descriptor_121);
    $this$structure.f6y(getKClass(OntologyLinkValue_1), $this$structure.c6y() ? getKClass(TypedOntologyLinkValueImpl) : getKClass(OntologyLinkValueImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_122 = OrValueQueryConcept_getInstance();
    $this$structure.e6y(getKClass(OrValueQuery_1), descriptor_122);
    $this$structure.f6y(getKClass(OrValueQuery_1), $this$structure.c6y() ? getKClass(TypedOrValueQueryImpl) : getKClass(OrValueQueryImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_123 = PageConcept_getInstance();
    $this$structure.e6y(getKClass(Page_1), descriptor_123);
    $this$structure.f6y(getKClass(Page_1), $this$structure.c6y() ? getKClass(TypedPageImpl) : getKClass(PageImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_124 = PageRangeConcept_getInstance();
    $this$structure.e6y(getKClass(PageRange_1), descriptor_124);
    $this$structure.f6y(getKClass(PageRange_1), $this$structure.c6y() ? getKClass(TypedPageRangeImpl) : getKClass(PageRangeImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_125 = PageSpecificationConcept_getInstance();
    $this$structure.e6y(getKClass(PageSpecification), descriptor_125);
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_126 = PaperConcept_getInstance();
    $this$structure.e6y(getKClass(Paper_1), descriptor_126);
    $this$structure.f6y(getKClass(Paper_1), $this$structure.c6y() ? getKClass(TypedPaperImpl) : getKClass(PaperImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_127 = PartReferenceOperationConcept_getInstance();
    $this$structure.e6y(getKClass(PartReferenceOperation), descriptor_127);
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_128 = PartValueConcept_getInstance();
    $this$structure.e6y(getKClass(PartValue), descriptor_128);
    $this$structure.f6y(getKClass(PartValue), $this$structure.c6y() ? getKClass(TypedPartValueImpl) : getKClass(PartValueImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_129 = PatternConcept_getInstance();
    $this$structure.e6y(getKClass(Pattern), descriptor_129);
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_130 = PreconditionConcept_getInstance();
    $this$structure.e6y(getKClass(Precondition), descriptor_130);
    $this$structure.f6y(getKClass(Precondition), $this$structure.c6y() ? getKClass(TypedPreconditionImpl) : getKClass(PreconditionImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_131 = PrimitiveNotionTypeConcept_getInstance();
    $this$structure.e6y(getKClass(PrimitiveNotionType_1), descriptor_131);
    $this$structure.f6y(getKClass(PrimitiveNotionType_1), $this$structure.c6y() ? getKClass(TypedPrimitiveNotionTypeImpl) : getKClass(PrimitiveNotionTypeImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_132 = PrimitivePropertyTypeConcept_getInstance();
    $this$structure.e6y(getKClass(PrimitivePropertyType_1), descriptor_132);
    $this$structure.f6y(getKClass(PrimitivePropertyType_1), $this$structure.c6y() ? getKClass(TypedPrimitivePropertyTypeImpl) : getKClass(PrimitivePropertyTypeImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_133 = ProcessDeclarationConcept_getInstance();
    $this$structure.e6y(getKClass(ProcessDeclaration_1), descriptor_133);
    $this$structure.f6y(getKClass(ProcessDeclaration_1), $this$structure.c6y() ? getKClass(TypedProcessDeclarationImpl) : getKClass(ProcessDeclarationImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_134 = ProcessEffectConcept_getInstance();
    $this$structure.e6y(getKClass(ProcessEffect_0), descriptor_134);
    $this$structure.f6y(getKClass(ProcessEffect_0), $this$structure.c6y() ? getKClass(TypedProcessEffectImpl) : getKClass(ProcessEffectImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_135 = ProcessKindConcept_getInstance();
    $this$structure.e6y(getKClass(ProcessKind_1), descriptor_135);
    $this$structure.f6y(getKClass(ProcessKind_1), $this$structure.c6y() ? getKClass(TypedProcessKindImpl) : getKClass(ProcessKindImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_136 = ProcessKindContainerConcept_getInstance();
    $this$structure.e6y(getKClass(ProcessKindContainer_1), descriptor_136);
    $this$structure.f6y(getKClass(ProcessKindContainer_1), $this$structure.c6y() ? getKClass(TypedProcessKindContainerImpl) : getKClass(ProcessKindContainerImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_137 = ProcessLibraryConcept_getInstance();
    $this$structure.e6y(getKClass(ProcessLibrary_1), descriptor_137);
    $this$structure.f6y(getKClass(ProcessLibrary_1), $this$structure.c6y() ? getKClass(TypedProcessLibraryImpl) : getKClass(ProcessLibraryImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_138 = ProcessPrerequisiteConcept_getInstance();
    $this$structure.e6y(getKClass(ProcessPrerequisite_0), descriptor_138);
    $this$structure.f6y(getKClass(ProcessPrerequisite_0), $this$structure.c6y() ? getKClass(TypedProcessPrerequisiteImpl) : getKClass(ProcessPrerequisiteImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_139 = ProcessPropertyConcept_getInstance();
    $this$structure.e6y(getKClass(ProcessProperty_1), descriptor_139);
    $this$structure.f6y(getKClass(ProcessProperty_1), $this$structure.c6y() ? getKClass(TypedProcessPropertyImpl) : getKClass(ProcessPropertyImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_140 = ProcessPropertyCustomCellConcept_getInstance();
    $this$structure.e6y(getKClass(ProcessPropertyCustomCell_1), descriptor_140);
    $this$structure.f6y(getKClass(ProcessPropertyCustomCell_1), $this$structure.c6y() ? getKClass(TypedProcessPropertyCustomCellImpl) : getKClass(ProcessPropertyCustomCellImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_141 = ProcessPropertyDefaultConcept_getInstance();
    $this$structure.e6y(getKClass(ProcessPropertyDefault_1), descriptor_141);
    $this$structure.f6y(getKClass(ProcessPropertyDefault_1), $this$structure.c6y() ? getKClass(TypedProcessPropertyDefaultImpl) : getKClass(ProcessPropertyDefaultImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_142 = ProcessPropertyReferenceConcept_getInstance();
    $this$structure.e6y(getKClass(ProcessPropertyReference), descriptor_142);
    $this$structure.f6y(getKClass(ProcessPropertyReference), $this$structure.c6y() ? getKClass(TypedProcessPropertyReferenceImpl) : getKClass(ProcessPropertyReferenceImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_143 = ProcessPropertyValueConcept_getInstance();
    $this$structure.e6y(getKClass(ProcessPropertyValue_1), descriptor_143);
    $this$structure.f6y(getKClass(ProcessPropertyValue_1), $this$structure.c6y() ? getKClass(TypedProcessPropertyValueImpl) : getKClass(ProcessPropertyValueImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_144 = ProcessReferenceConcept_getInstance();
    $this$structure.e6y(getKClass(ProcessReference_1), descriptor_144);
    $this$structure.f6y(getKClass(ProcessReference_1), $this$structure.c6y() ? getKClass(TypedProcessReferenceImpl) : getKClass(ProcessReferenceImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_145 = ProcessRelationDeclarationConcept_getInstance();
    $this$structure.e6y(getKClass(ProcessRelationDeclaration_1), descriptor_145);
    $this$structure.f6y(getKClass(ProcessRelationDeclaration_1), $this$structure.c6y() ? getKClass(TypedProcessRelationDeclarationImpl) : getKClass(ProcessRelationDeclarationImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_146 = ProcessTypeConcept_getInstance();
    $this$structure.e6y(getKClass(ProcessType_1), descriptor_146);
    $this$structure.f6y(getKClass(ProcessType_1), $this$structure.c6y() ? getKClass(TypedProcessTypeImpl) : getKClass(ProcessTypeImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_147 = PropertiesCustomCellConcept_getInstance();
    $this$structure.e6y(getKClass(PropertiesCustomCell_1), descriptor_147);
    $this$structure.f6y(getKClass(PropertiesCustomCell_1), $this$structure.c6y() ? getKClass(TypedPropertiesCustomCellImpl) : getKClass(PropertiesCustomCellImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_148 = PropertyConstraintConcept_getInstance();
    $this$structure.e6y(getKClass(PropertyConstraint_1), descriptor_148);
    $this$structure.f6y(getKClass(PropertyConstraint_1), $this$structure.c6y() ? getKClass(TypedPropertyConstraintImpl) : getKClass(PropertyConstraintImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_149 = PropertyCustomCellConcept_getInstance();
    $this$structure.e6y(getKClass(PropertyCustomCell_1), descriptor_149);
    $this$structure.f6y(getKClass(PropertyCustomCell_1), $this$structure.c6y() ? getKClass(TypedPropertyCustomCellImpl) : getKClass(PropertyCustomCellImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_150 = PropertyDeclarationConcept_getInstance();
    $this$structure.e6y(getKClass(PropertyDeclaration_1), descriptor_150);
    $this$structure.f6y(getKClass(PropertyDeclaration_1), $this$structure.c6y() ? getKClass(TypedPropertyDeclarationImpl) : getKClass(PropertyDeclarationImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_151 = PropertyDeclarationValueQueryConcept_getInstance();
    $this$structure.e6y(getKClass(PropertyDeclarationValueQuery_1), descriptor_151);
    $this$structure.f6y(getKClass(PropertyDeclarationValueQuery_1), $this$structure.c6y() ? getKClass(TypedPropertyDeclarationValueQueryImpl) : getKClass(PropertyDeclarationValueQueryImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_152 = PropertyLibraryConcept_getInstance();
    $this$structure.e6y(getKClass(PropertyLibrary_1), descriptor_152);
    $this$structure.f6y(getKClass(PropertyLibrary_1), $this$structure.c6y() ? getKClass(TypedPropertyLibraryImpl) : getKClass(PropertyLibraryImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_153 = PropertyReferenceOperationConcept_getInstance();
    $this$structure.e6y(getKClass(PropertyReferenceOperation_1), descriptor_153);
    $this$structure.f6y(getKClass(PropertyReferenceOperation_1), $this$structure.c6y() ? getKClass(TypedPropertyReferenceOperationImpl) : getKClass(PropertyReferenceOperationImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_154 = PropertyStubConcept_getInstance();
    $this$structure.e6y(getKClass(PropertyStub), descriptor_154);
    $this$structure.f6y(getKClass(PropertyStub), $this$structure.c6y() ? getKClass(TypedPropertyStubImpl) : getKClass(PropertyStubImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_155 = PropertyValueConcept_getInstance();
    $this$structure.e6y(getKClass(PropertyValue_1), descriptor_155);
    $this$structure.f6y(getKClass(PropertyValue_1), $this$structure.c6y() ? getKClass(TypedPropertyValueImpl) : getKClass(PropertyValueImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_156 = PropertyValueRangeConcept_getInstance();
    $this$structure.e6y(getKClass(PropertyValueRange), descriptor_156);
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_157 = PubMedSourceReferenceConcept_getInstance();
    $this$structure.e6y(getKClass(PubMedSourceReference_1), descriptor_157);
    $this$structure.f6y(getKClass(PubMedSourceReference_1), $this$structure.c6y() ? getKClass(TypedPubMedSourceReferenceImpl) : getKClass(PubMedSourceReferenceImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_158 = PublishedSourceReferenceConcept_getInstance();
    $this$structure.e6y(getKClass(PublishedSourceReference_1), descriptor_158);
    $this$structure.f6y(getKClass(PublishedSourceReference_1), $this$structure.c6y() ? getKClass(TypedPublishedSourceReferenceImpl) : getKClass(PublishedSourceReferenceImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_159 = PublishedSourcesLibraryConcept_getInstance();
    $this$structure.e6y(getKClass(PublishedSourcesLibrary_1), descriptor_159);
    $this$structure.f6y(getKClass(PublishedSourcesLibrary_1), $this$structure.c6y() ? getKClass(TypedPublishedSourcesLibraryImpl) : getKClass(PublishedSourcesLibraryImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_160 = PublishedWorkConcept_getInstance();
    $this$structure.e6y(getKClass(PublishedWork), descriptor_160);
    $this$structure.f6y(getKClass(PublishedWork), $this$structure.c6y() ? getKClass(TypedPublishedWorkImpl) : getKClass(PublishedWorkImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_161 = QualifiedOntologyElementReferenceConcept_getInstance();
    $this$structure.e6y(getKClass(QualifiedOntologyElementReference_1), descriptor_161);
    $this$structure.f6y(getKClass(QualifiedOntologyElementReference_1), $this$structure.c6y() ? getKClass(TypedQualifiedOntologyElementReferenceImpl) : getKClass(QualifiedOntologyElementReferenceImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_162 = QueryCommandsConcept_getInstance();
    $this$structure.e6y(getKClass(QueryCommands_1), descriptor_162);
    $this$structure.f6y(getKClass(QueryCommands_1), $this$structure.c6y() ? getKClass(TypedQueryCommandsImpl) : getKClass(QueryCommandsImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_163 = QueryLabelsFactExpressionContainerConcept_getInstance();
    $this$structure.e6y(getKClass(QueryLabelsFactExpressionContainer_0), descriptor_163);
    $this$structure.f6y(getKClass(QueryLabelsFactExpressionContainer_0), $this$structure.c6y() ? getKClass(TypedQueryLabelsFactExpressionContainerImpl) : getKClass(QueryLabelsFactExpressionContainerImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_164 = QueryParametersBlackListConcept_getInstance();
    $this$structure.e6y(getKClass(QueryParametersBlackList), descriptor_164);
    $this$structure.f6y(getKClass(QueryParametersBlackList), $this$structure.c6y() ? getKClass(TypedQueryParametersBlackListImpl) : getKClass(QueryParametersBlackListImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_165 = RelationContainerConcept_getInstance();
    $this$structure.e6y(getKClass(RelationContainer_1), descriptor_165);
    $this$structure.f6y(getKClass(RelationContainer_1), $this$structure.c6y() ? getKClass(TypedRelationContainerImpl) : getKClass(RelationContainerImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_166 = RelationFactExpressionConcept_getInstance();
    $this$structure.e6y(getKClass(RelationFactExpression_1), descriptor_166);
    $this$structure.f6y(getKClass(RelationFactExpression_1), $this$structure.c6y() ? getKClass(TypedRelationFactExpressionImpl) : getKClass(RelationFactExpressionImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_167 = ReturnTypeCustomCellConcept_getInstance();
    $this$structure.e6y(getKClass(ReturnTypeCustomCell_1), descriptor_167);
    $this$structure.f6y(getKClass(ReturnTypeCustomCell_1), $this$structure.c6y() ? getKClass(TypedReturnTypeCustomCellImpl) : getKClass(ReturnTypeCustomCellImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_168 = SetExpressionConcept_getInstance();
    $this$structure.e6y(getKClass(SetExpression_1), descriptor_168);
    $this$structure.f6y(getKClass(SetExpression_1), $this$structure.c6y() ? getKClass(TypedSetExpressionImpl) : getKClass(SetExpressionImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_169 = SetValuedPropertyParameterConcept_getInstance();
    $this$structure.e6y(getKClass(SetValuedPropertyParameter_1), descriptor_169);
    $this$structure.f6y(getKClass(SetValuedPropertyParameter_1), $this$structure.c6y() ? getKClass(TypedSetValuedPropertyParameterImpl) : getKClass(SetValuedPropertyParameterImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_170 = SimplePropertyTypeConcept_getInstance();
    $this$structure.e6y(getKClass(SimplePropertyType), descriptor_170);
    $this$structure.f6y(getKClass(SimplePropertyType), $this$structure.c6y() ? getKClass(TypedSimplePropertyTypeImpl) : getKClass(SimplePropertyTypeImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_171 = SinglePropertyValueRangeConcept_getInstance();
    $this$structure.e6y(getKClass(SinglePropertyValueRange_1), descriptor_171);
    $this$structure.f6y(getKClass(SinglePropertyValueRange_1), $this$structure.c6y() ? getKClass(TypedSinglePropertyValueRangeImpl) : getKClass(SinglePropertyValueRangeImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_172 = StringValueConcept_getInstance();
    $this$structure.e6y(getKClass(StringValue_1), descriptor_172);
    $this$structure.f6y(getKClass(StringValue_1), $this$structure.c6y() ? getKClass(TypedStringValueImpl) : getKClass(StringValueImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_173 = TextLineConcept_getInstance();
    $this$structure.e6y(getKClass(TextLine), descriptor_173);
    $this$structure.f6y(getKClass(TextLine), $this$structure.c6y() ? getKClass(TypedTextLineImpl) : getKClass(TextLineImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_174 = TypeConcept_getInstance();
    $this$structure.e6y(getKClass(Type), descriptor_174);
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_175 = TypePlaceholderConcept_getInstance();
    $this$structure.e6y(getKClass(TypePlaceholder_1), descriptor_175);
    $this$structure.f6y(getKClass(TypePlaceholder_1), $this$structure.c6y() ? getKClass(TypedTypePlaceholderImpl) : getKClass(TypePlaceholderImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_176 = UnionClassConcept_getInstance();
    $this$structure.e6y(getKClass(UnionClass_1), descriptor_176);
    $this$structure.f6y(getKClass(UnionClass_1), $this$structure.c6y() ? getKClass(TypedUnionClassImpl) : getKClass(UnionClassImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_177 = UnknownComplexNotionValueConcept_getInstance();
    $this$structure.e6y(getKClass(UnknownComplexNotionValue_1), descriptor_177);
    $this$structure.f6y(getKClass(UnknownComplexNotionValue_1), $this$structure.c6y() ? getKClass(TypedUnknownComplexNotionValueImpl) : getKClass(UnknownComplexNotionValueImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_178 = UrlConcept_getInstance();
    $this$structure.e6y(getKClass(Url_1), descriptor_178);
    $this$structure.f6y(getKClass(Url_1), $this$structure.c6y() ? getKClass(TypedUrlImpl) : getKClass(UrlImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_179 = UrlKnowledgeSourceReferenceConcept_getInstance();
    $this$structure.e6y(getKClass(UrlKnowledgeSourceReference_1), descriptor_179);
    $this$structure.f6y(getKClass(UrlKnowledgeSourceReference_1), $this$structure.c6y() ? getKClass(TypedUrlKnowledgeSourceReferenceImpl) : getKClass(UrlKnowledgeSourceReferenceImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_180 = ValueWithRelationsConcept_getInstance();
    $this$structure.e6y(getKClass(ValueWithRelations), descriptor_180);
    $this$structure.f6y(getKClass(ValueWithRelations), $this$structure.c6y() ? getKClass(TypedValueWithRelationsImpl) : getKClass(ValueWithRelationsImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_181 = VariableDeclarationConcept_getInstance();
    $this$structure.e6y(getKClass(VariableDeclaration_1), descriptor_181);
    $this$structure.f6y(getKClass(VariableDeclaration_1), $this$structure.c6y() ? getKClass(TypedVariableDeclarationImpl) : getKClass(VariableDeclarationImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_182 = VariableInitializerConcept_getInstance();
    $this$structure.e6y(getKClass(VariableInitializer), descriptor_182);
    $this$structure.f6y(getKClass(VariableInitializer), $this$structure.c6y() ? getKClass(TypedVariableInitializerImpl) : getKClass(VariableInitializerImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_183 = VariablePatternConcept_getInstance();
    $this$structure.e6y(getKClass(VariablePattern_1), descriptor_183);
    $this$structure.f6y(getKClass(VariablePattern_1), $this$structure.c6y() ? getKClass(TypedVariablePatternImpl) : getKClass(VariablePatternImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_184 = VariableReferenceValueConcept_getInstance();
    $this$structure.e6y(getKClass(VariableReferenceValue_1), descriptor_184);
    $this$structure.f6y(getKClass(VariableReferenceValue_1), $this$structure.c6y() ? getKClass(TypedVariableReferenceValueImpl) : getKClass(VariableReferenceValueImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_185 = VariableSpecificationConcept_getInstance();
    $this$structure.e6y(getKClass(VariableSpecification), descriptor_185);
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_186 = XRefContainerConcept_getInstance();
    $this$structure.e6y(getKClass(XRefContainer), descriptor_186);
    $this$structure.f6y(getKClass(XRefContainer), $this$structure.c6y() ? getKClass(TypedXRefContainerImpl) : getKClass(XRefContainerImpl));
    return Unit_instance;
  }
  function AbstractBindingDeclarationImpl(context, node) {
    BTBNodeImpl.call(this, context, node);
    this.ohy_1 = this.s6j(AbstractBindingDeclarationConcept_getInstance().zfu_1);
    this.phy_1 = this.s6j(AbstractBindingDeclarationConcept_getInstance().afv_1);
    this.qhy_1 = this.s6j(AbstractBindingDeclarationConcept_getInstance().bfv_1);
    this.rhy_1 = this.r6j(AbstractBindingDeclarationConcept_getInstance().cfv_1);
    this.shy_1 = this.p6j(AbstractBindingDeclarationConcept_getInstance().dfv_1);
    this.thy_1 = this.i6j(DirectlyNamedConcept_getInstance().bhz_1);
    this.uhy_1 = this.r6j(HasCommentsConcept_getInstance().igg_1);
  }
  protoOf(AbstractBindingDeclarationImpl).qfp = function () {
    return this.ohy_1;
  };
  protoOf(AbstractBindingDeclarationImpl).y = function () {
    return this.phy_1;
  };
  protoOf(AbstractBindingDeclarationImpl).rfp = function () {
    return this.qhy_1;
  };
  protoOf(AbstractBindingDeclarationImpl).sfp = function () {
    return this.rhy_1;
  };
  protoOf(AbstractBindingDeclarationImpl).tfp = function () {
    return this.shy_1;
  };
  protoOf(AbstractBindingDeclarationImpl).y2 = function () {
    return this.thy_1;
  };
  protoOf(AbstractBindingDeclarationImpl).lfr = function () {
    return this.uhy_1;
  };
  function AbstractBindingEntryImpl(context, node) {
    BTBNodeImpl.call(this, context, node);
  }
  function AbstractBindingValueImpl(context, node) {
    BindingValuePlaceholderImpl.call(this, context, node);
    this.ghz_1 = this.r6j(AbstractBindingValueConcept_getInstance().pfv_1);
  }
  protoOf(AbstractBindingValueImpl).a1 = function () {
    return this.ghz_1;
  };
  function AbstractBindingValueQueryImpl(context, node) {
    BindingValuePlaceholderQueryImpl.call(this, context, node);
  }
  function AbstractLinkImpl(context, node) {
    AbstractBindingEntryImpl.call(this, context, node);
    this.khz_1 = context.u6l(AbstractLinkConcept_getInstance().yfv_1, this);
  }
  protoOf(AbstractLinkImpl).ufp = function () {
    return this.khz_1;
  };
  function AbstractNotionImpl(context, node) {
    BTBNodeImpl.call(this, context, node);
    this.ohz_1 = this.i6j(DirectlyNamedConcept_getInstance().bhz_1);
  }
  protoOf(AbstractNotionImpl).y2 = function () {
    return this.ohz_1;
  };
  function AbstractOntologyRelationImpl(context, node) {
    BTBNodeImpl.call(this, context, node);
  }
  function AbstractProcessSpecificationImpl(context, node) {
    BTBNodeImpl.call(this, context, node);
  }
  function AbstractPropertyImpl(context, node) {
    AbstractBindingEntryImpl.call(this, context, node);
  }
  function AuthorImpl(context, node) {
    node = node === VOID ? new Node_0(AuthorConcept_getInstance().m6n_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.shz_1 = this.i6j(DirectlyNamedConcept_getInstance().bhz_1);
  }
  protoOf(AuthorImpl).y2 = function () {
    return this.shz_1;
  };
  function AuthoredWorkImpl(context, node) {
    node = node === VOID ? new Node_0(AuthoredWorkConcept_getInstance().m6n_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.whz_1 = this.s6j(AuthoredWorkConcept_getInstance().kfw_1);
    this.xhz_1 = this.i6j(AuthoredWorkConcept_getInstance().lfw_1);
  }
  protoOf(AuthoredWorkImpl).vfp = function () {
    return this.whz_1;
  };
  protoOf(AuthoredWorkImpl).wfp = function () {
    return this.xhz_1;
  };
  function BTBDocumentImpl(context, node) {
    node = node === VOID ? new Node_0(BTBDocumentConcept_getInstance().m6n_1) : node;
    DocumentNodeImpl.call(this, context, node);
    this.di0_1 = this.s6j(BTBDocumentConcept_getInstance().yfw_1);
    this.ei0_1 = this.s6j(BTBDocumentConcept_getInstance().zfw_1);
    this.fi0_1 = this.s6j(BTBDocumentConcept_getInstance().afx_1);
  }
  protoOf(BTBDocumentImpl).xfp = function () {
    return this.di0_1;
  };
  protoOf(BTBDocumentImpl).yfp = function () {
    return this.ei0_1;
  };
  protoOf(BTBDocumentImpl).zfp = function () {
    return this.fi0_1;
  };
  function BindingPropertyImpl(context, node) {
    node = node === VOID ? new Node_0(BindingPropertyConcept_getInstance().m6n_1) : node;
    AbstractPropertyImpl.call(this, context, node);
    this.pi0_1 = this.r6j(BindingPropertyConcept_getInstance().ofx_1);
  }
  protoOf(BindingPropertyImpl).q6q = function () {
    return this.pi0_1;
  };
  function BindingValueMaskImpl(context, node) {
    node = node === VOID ? new Node_0(BindingValueMaskConcept_getInstance().m6n_1) : node;
    AbstractBindingValueQueryImpl.call(this, context, node);
    this.ti0_1 = this.r6j(BindingValueMaskConcept_getInstance().afy_1);
  }
  protoOf(BindingValueMaskImpl).a1 = function () {
    return this.ti0_1;
  };
  function BindingValuePlaceholderImpl(context, node) {
    node = node === VOID ? new Node_0(BindingValuePlaceholderConcept_getInstance().m6n_1) : node;
    BTBNodeImpl.call(this, context, node);
  }
  function BindingValuePlaceholderQueryImpl(context, node) {
    node = node === VOID ? new Node_0(BindingValuePlaceholderQueryConcept_getInstance().m6n_1) : node;
    BTBNodeImpl.call(this, context, node);
  }
  function BookImpl(context, node) {
    node = node === VOID ? new Node_0(BookConcept_getInstance().m6n_1) : node;
    PublishedWorkImpl.call(this, context, node);
    this.ci1_1 = this.i6j(BookConcept_getInstance().mfy_1);
  }
  protoOf(BookImpl).afq = function () {
    return this.ci1_1;
  };
  function CardinalityBoundConstantImpl(context, node) {
    node = node === VOID ? new Node_0(CardinalityBoundConstantConcept_getInstance().m6n_1) : node;
    CardinalityBoundImpl.call(this, context, node);
    this.pi1_1 = this.j6j(CardinalityBoundConstantConcept_getInstance().yfy_1);
  }
  protoOf(CardinalityBoundConstantImpl).a1 = function () {
    return this.pi1_1;
  };
  function CardinalityBoundImpl(context, node) {
    node = node === VOID ? new Node_0(CardinalityBoundConcept_getInstance().m6n_1) : node;
    BTBNodeImpl.call(this, context, node);
  }
  function CardinalityBoundNImpl(context, node) {
    node = node === VOID ? new Node_0(CardinalityBoundNConcept_getInstance().m6n_1) : node;
    CardinalityBoundImpl.call(this, context, node);
  }
  function CardinalityBoundPlaceholderImpl(context, node) {
    node = node === VOID ? new Node_0(CardinalityBoundPlaceholderConcept_getInstance().m6n_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.ti1_1 = this.r6j(CardinalityBoundPlaceholderConcept_getInstance().kfz_1);
  }
  protoOf(CardinalityBoundPlaceholderImpl).efq = function () {
    return this.ti1_1;
  };
  function CardinalityCustomCellImpl(context, node) {
    node = node === VOID ? new Node_0(CardinalityCustomCellConcept_getInstance().m6n_1) : node;
    CustomCellImpl.call(this, context, node);
  }
  function CardinalityImpl(context, node) {
    node = node === VOID ? new Node_0(CardinalityConcept_getInstance().m6n_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.xi1_1 = this.r6j(CardinalityConcept_getInstance().wfz_1);
    this.yi1_1 = this.r6j(CardinalityConcept_getInstance().xfz_1);
    this.zi1_1 = this.r6j(CardinalityConcept_getInstance().yfz_1);
  }
  protoOf(CardinalityImpl).bfq = function () {
    return this.xi1_1;
  };
  protoOf(CardinalityImpl).cfq = function () {
    return this.yi1_1;
  };
  protoOf(CardinalityImpl).dfq = function () {
    return this.zi1_1;
  };
  function CategoryImpl(context, node) {
    node = node === VOID ? new Node_0(CategoryConcept_getInstance().m6n_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.di2_1 = this.r6j(CategoryConcept_getInstance().mg0_1);
    this.ei2_1 = this.r6j(CategoryConcept_getInstance().ng0_1);
  }
  protoOf(CategoryImpl).ffq = function () {
    return this.di2_1;
  };
  protoOf(CategoryImpl).gfq = function () {
    return this.ei2_1;
  };
  function ClassExpressionPlaceholderImpl(context, node) {
    node = node === VOID ? new Node_0(ClassExpressionPlaceholderConcept_getInstance().m6n_1) : node;
    BTBNodeImpl.call(this, context, node);
  }
  function ClassExpressionTypeImpl(context, node) {
    node = node === VOID ? new Node_0(ClassExpressionTypeConcept_getInstance().m6n_1) : node;
    TypeImpl.call(this, context, node);
    this.ii2_1 = this.r6j(ClassExpressionTypeConcept_getInstance().ag1_1);
  }
  protoOf(ClassExpressionTypeImpl).hfq = function () {
    return this.ii2_1;
  };
  function CommandImpl(context, node) {
    BTBNodeImpl.call(this, context, node);
  }
  function ComplexNotionElementImpl(context, node) {
    node = node === VOID ? new Node_0(ComplexNotionElementConcept_getInstance().m6n_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.mi2_1 = this.r6j(ComplexNotionElementConcept_getInstance().ag2_1);
    this.ni2_1 = this.p6j(ComplexNotionElementConcept_getInstance().bg2_1);
    this.oi2_1 = this.i6j(DirectlyNamedConcept_getInstance().bhz_1);
  }
  protoOf(ComplexNotionElementImpl).kfq = function () {
    return this.mi2_1;
  };
  protoOf(ComplexNotionElementImpl).lfq = function () {
    return this.ni2_1;
  };
  protoOf(ComplexNotionElementImpl).y2 = function () {
    return this.oi2_1;
  };
  function ComplexNotionElementValueImpl(context, node) {
    node = node === VOID ? new Node_0(ComplexNotionElementValueConcept_getInstance().m6n_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.si2_1 = context.u6l(ComplexNotionElementValueConcept_getInstance().pg2_1, this);
    this.ti2_1 = this.r6j(ComplexNotionElementValueConcept_getInstance().qg2_1);
  }
  protoOf(ComplexNotionElementValueImpl).gfq = function () {
    return this.si2_1;
  };
  protoOf(ComplexNotionElementValueImpl).a1 = function () {
    return this.ti2_1;
  };
  function ComplexNotionImpl(context, node) {
    node = node === VOID ? new Node_0(ComplexNotionConcept_getInstance().m6n_1) : node;
    AbstractNotionImpl.call(this, context, node);
    this.yi2_1 = this.s6j(ComplexNotionConcept_getInstance().mg1_1);
    this.zi2_1 = this.r6j(ComplexNotionConcept_getInstance().ng1_1);
  }
  protoOf(ComplexNotionImpl).ifq = function () {
    return this.yi2_1;
  };
  protoOf(ComplexNotionImpl).jfq = function () {
    return this.zi2_1;
  };
  function ComplexNotionTemplateElementImpl(context, node) {
    BTBNodeImpl.call(this, context, node);
  }
  function ComplexNotionTemplateImpl(context, node) {
    node = node === VOID ? new Node_0(ComplexNotionTemplateConcept_getInstance().m6n_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.di3_1 = this.s6j(ComplexNotionTemplateConcept_getInstance().dg3_1);
  }
  protoOf(ComplexNotionTemplateImpl).ifq = function () {
    return this.di3_1;
  };
  function ComplexNotionTemplatePlaceholderImpl(context, node) {
    node = node === VOID ? new Node_0(ComplexNotionTemplatePlaceholderConcept_getInstance().m6n_1) : node;
    ComplexNotionTemplateElementImpl.call(this, context, node);
  }
  function ComplexNotionTemplateRefElementImpl(context, node) {
    node = node === VOID ? new Node_0(ComplexNotionTemplateRefElementConcept_getInstance().m6n_1) : node;
    ComplexNotionTemplateElementImpl.call(this, context, node);
    this.hi3_1 = context.u6l(ComplexNotionTemplateRefElementConcept_getInstance().qg3_1, this);
  }
  protoOf(ComplexNotionTemplateRefElementImpl).gfq = function () {
    return this.hi3_1;
  };
  function ComplexNotionTemplateTextElementImpl(context, node) {
    node = node === VOID ? new Node_0(ComplexNotionTemplateTextElementConcept_getInstance().m6n_1) : node;
    ComplexNotionTemplateElementImpl.call(this, context, node);
    this.li3_1 = this.i6j(ComplexNotionTemplateTextElementConcept_getInstance().cg4_1);
  }
  protoOf(ComplexNotionTemplateTextElementImpl).o8w = function () {
    return this.li3_1;
  };
  function ComplexNotionValueImpl(context, node) {
    node = node === VOID ? new Node_0(ComplexNotionValueConcept_getInstance().m6n_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.pi3_1 = context.u6l(ComplexNotionValueConcept_getInstance().pg4_1, this);
    this.qi3_1 = this.s6j(ComplexNotionValueConcept_getInstance().qg4_1);
  }
  protoOf(ComplexNotionValueImpl).mfq = function () {
    return this.pi3_1;
  };
  protoOf(ComplexNotionValueImpl).nfq = function () {
    return this.qi3_1;
  };
  function ConstantCustomCellImpl(context, node) {
    node = node === VOID ? new Node_0(ConstantCustomCellConcept_getInstance().m6n_1) : node;
    CustomCellImpl.call(this, context, node);
    this.vi3_1 = this.i6j(ConstantCustomCellConcept_getInstance().dg5_1);
  }
  protoOf(ConstantCustomCellImpl).o8w = function () {
    return this.vi3_1;
  };
  function ConstantPreconditionImpl(context, node) {
    node = node === VOID ? new Node_0(ConstantPreconditionConcept_getInstance().m6n_1) : node;
    PreconditionImpl.call(this, context, node);
    this.zi3_1 = this.o6j(ConstantPreconditionConcept_getInstance().qg5_1, ConstantPreconditionConcept_getInstance().rg5_1);
  }
  protoOf(ConstantPreconditionImpl).r5a = function () {
    return this.zi3_1;
  };
  function ContextImpl(context, node) {
    node = node === VOID ? new Node_0(ContextConcept_getInstance().m6n_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.di4_1 = this.r6j(ContextConcept_getInstance().dg6_1);
    this.ei4_1 = this.r6j(ContextConcept_getInstance().eg6_1);
    this.fi4_1 = this.i6j(DirectlyNamedConcept_getInstance().bhz_1);
  }
  protoOf(ContextImpl).ffq = function () {
    return this.di4_1;
  };
  protoOf(ContextImpl).gfq = function () {
    return this.ei4_1;
  };
  protoOf(ContextImpl).y2 = function () {
    return this.fi4_1;
  };
  function ContextQueryImpl(context, node) {
    node = node === VOID ? new Node_0(ContextQueryConcept_getInstance().m6n_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.ji4_1 = this.r6j(ContextQueryConcept_getInstance().rg6_1);
    this.ki4_1 = this.r6j(ContextQueryConcept_getInstance().sg6_1);
  }
  protoOf(ContextQueryImpl).ffq = function () {
    return this.ji4_1;
  };
  protoOf(ContextQueryImpl).gfq = function () {
    return this.ki4_1;
  };
  function CustomCellImpl(context, node) {
    BTBNodeImpl.call(this, context, node);
  }
  function CustomEditorImpl(context, node) {
    node = node === VOID ? new Node_0(CustomEditorConcept_getInstance().m6n_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.oi4_1 = this.s6j(CustomEditorConcept_getInstance().fg7_1);
  }
  protoOf(CustomEditorImpl).ofq = function () {
    return this.oi4_1;
  };
  function DeclarationNameCustomCellImpl(context, node) {
    node = node === VOID ? new Node_0(DeclarationNameCustomCellConcept_getInstance().m6n_1) : node;
    CustomCellImpl.call(this, context, node);
  }
  function DeclarationValueQueryImpl(context, node) {
    node = node === VOID ? new Node_0(DeclarationValueQueryConcept_getInstance().m6n_1) : node;
    AbstractBindingValueQueryImpl.call(this, context, node);
    this.si4_1 = this.r6j(DeclarationValueQueryConcept_getInstance().rg7_1);
  }
  protoOf(DeclarationValueQueryImpl).a1 = function () {
    return this.si4_1;
  };
  function DocumentNodeImpl(context, node) {
    BTBNodeImpl.call(this, context, node);
    this.ji0_1 = get_forQueries(new ValueProperty(''));
    this.ki0_1 = get_forQueries(new ValueProperty(''));
  }
  protoOf(DocumentNodeImpl).d6g = function () {
    return this.ji0_1;
  };
  protoOf(DocumentNodeImpl).y2 = function () {
    return this.ki0_1;
  };
  function EmptyBindingEntryImpl(context, node) {
    node = node === VOID ? new Node_0(EmptyBindingEntryConcept_getInstance().m6n_1) : node;
    AbstractBindingEntryImpl.call(this, context, node);
  }
  function EmptyPropertyLibraryElementImpl(context, node) {
    node = node === VOID ? new Node_0(EmptyPropertyLibraryElementConcept_getInstance().m6n_1) : node;
    BTBNodeImpl.call(this, context, node);
  }
  function EnumValueImpl(context, node) {
    node = node === VOID ? new Node_0(EnumValueConcept_getInstance().m6n_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.wi4_1 = context.u6l(EnumValueConcept_getInstance().eg8_1, this);
  }
  protoOf(EnumValueImpl).pfq = function () {
    return this.wi4_1;
  };
  function EnumerableNotionImpl(context, node) {
    node = node === VOID ? new Node_0(EnumerableNotionConcept_getInstance().m6n_1) : node;
    AbstractNotionImpl.call(this, context, node);
    this.bi5_1 = this.s6j(EnumerableNotionConcept_getInstance().qg8_1);
  }
  protoOf(EnumerableNotionImpl).qfq = function () {
    return this.bi5_1;
  };
  function EnumerationConstantImpl(context, node) {
    node = node === VOID ? new Node_0(EnumerationConstantConcept_getInstance().m6n_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.fi5_1 = this.i6j(DirectlyNamedConcept_getInstance().bhz_1);
  }
  protoOf(EnumerationConstantImpl).y2 = function () {
    return this.fi5_1;
  };
  function ExtensionDeclarationImpl(context, node) {
    node = node === VOID ? new Node_0(ExtensionDeclarationConcept_getInstance().m6n_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.ji5_1 = this.s6j(ExtensionDeclarationConcept_getInstance().cg9_1);
    this.ki5_1 = this.r6j(ExtensionDeclarationConcept_getInstance().dg9_1);
    this.li5_1 = this.i6j(DirectlyNamedConcept_getInstance().bhz_1);
  }
  protoOf(ExtensionDeclarationImpl).rfq = function () {
    return this.ji5_1;
  };
  protoOf(ExtensionDeclarationImpl).sfq = function () {
    return this.ki5_1;
  };
  protoOf(ExtensionDeclarationImpl).y2 = function () {
    return this.li5_1;
  };
  function ExtensionFieldReferenceImpl(context, node) {
    node = node === VOID ? new Node_0(ExtensionFieldReferenceConcept_getInstance().m6n_1) : node;
    PartReferenceOperationImpl.call(this, context, node);
    this.pi5_1 = context.u6l(ExtensionFieldReferenceConcept_getInstance().rg9_1, this);
  }
  protoOf(ExtensionFieldReferenceImpl).tfq = function () {
    return this.pi5_1;
  };
  function ExtensionLibraryImpl(context, node) {
    node = node === VOID ? new Node_0(ExtensionLibraryConcept_getInstance().m6n_1) : node;
    DocumentNodeImpl.call(this, context, node);
    this.vi5_1 = this.s6j(ExtensionLibraryConcept_getInstance().dga_1);
  }
  protoOf(ExtensionLibraryImpl).ue2 = function () {
    return this.vi5_1;
  };
  function FactExpressionPlaceholderImpl(context, node) {
    node = node === VOID ? new Node_0(FactExpressionPlaceholderConcept_getInstance().m6n_1) : node;
    BTBNodeImpl.call(this, context, node);
  }
  function FactImpl(context, node) {
    node = node === VOID ? new Node_0(FactConcept_getInstance().m6n_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.zi5_1 = this.r6j(FactConcept_getInstance().pga_1);
    this.ai6_1 = this.r6j(FactConcept_getInstance().qga_1);
    this.bi6_1 = this.i6j(DirectlyNamedConcept_getInstance().bhz_1);
  }
  protoOf(FactImpl).ufq = function () {
    return this.zi5_1;
  };
  protoOf(FactImpl).vfq = function () {
    return this.ai6_1;
  };
  protoOf(FactImpl).y2 = function () {
    return this.bi6_1;
  };
  function FactPreconditionImpl(context, node) {
    node = node === VOID ? new Node_0(FactPreconditionConcept_getInstance().m6n_1) : node;
    PreconditionImpl.call(this, context, node);
    this.fi6_1 = this.s6j(FactPreconditionConcept_getInstance().dgb_1);
    this.gi6_1 = context.u6l(FactPreconditionConcept_getInstance().egb_1, this);
  }
  protoOf(FactPreconditionImpl).wfq = function () {
    return this.fi6_1;
  };
  protoOf(FactPreconditionImpl).xfq = function () {
    return this.gi6_1;
  };
  function FactReferenceImpl(context, node) {
    node = node === VOID ? new Node_0(FactReferenceConcept_getInstance().m6n_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.ki6_1 = context.u6l(FactReferenceConcept_getInstance().tgb_1, this);
  }
  protoOf(FactReferenceImpl).yfq = function () {
    return this.ki6_1;
  };
  function FactSetImpl(context, node) {
    node = node === VOID ? new Node_0(FactSetConcept_getInstance().m6n_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.oi6_1 = this.i6j(FactSetConcept_getInstance().fgc_1);
    this.pi6_1 = this.r6j(FactSetConcept_getInstance().ggc_1);
    this.qi6_1 = this.s6j(FactSetConcept_getInstance().hgc_1);
    this.ri6_1 = this.s6j(FactSetConcept_getInstance().igc_1);
    this.si6_1 = this.s6j(FactSetConcept_getInstance().jgc_1);
    this.ti6_1 = this.i6j(DirectlyNamedConcept_getInstance().bhz_1);
    this.ui6_1 = this.s6j(HasKnowledgeSourcesConcept_getInstance().ygg_1);
    this.vi6_1 = this.r6j(HasCommentsConcept_getInstance().igg_1);
    this.wi6_1 = this.s6j(HasVariablesConcept_getInstance().ygh_1);
  }
  protoOf(FactSetImpl).zfq = function () {
    return this.oi6_1;
  };
  protoOf(FactSetImpl).afr = function () {
    return this.pi6_1;
  };
  protoOf(FactSetImpl).bfr = function () {
    return this.qi6_1;
  };
  protoOf(FactSetImpl).wfq = function () {
    return this.ri6_1;
  };
  protoOf(FactSetImpl).cfr = function () {
    return this.si6_1;
  };
  protoOf(FactSetImpl).y2 = function () {
    return this.ti6_1;
  };
  protoOf(FactSetImpl).nfr = function () {
    return this.ui6_1;
  };
  protoOf(FactSetImpl).lfr = function () {
    return this.vi6_1;
  };
  protoOf(FactSetImpl).rfr = function () {
    return this.wi6_1;
  };
  function FieldDeclarationImpl(context, node) {
    node = node === VOID ? new Node_0(FieldDeclarationConcept_getInstance().m6n_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.ai7_1 = this.r6j(FieldDeclarationConcept_getInstance().zgc_1);
    this.bi7_1 = this.r6j(FieldDeclarationConcept_getInstance().agd_1);
    this.ci7_1 = this.i6j(DirectlyNamedConcept_getInstance().bhz_1);
  }
  protoOf(FieldDeclarationImpl).sfq = function () {
    return this.ai7_1;
  };
  protoOf(FieldDeclarationImpl).dfr = function () {
    return this.bi7_1;
  };
  protoOf(FieldDeclarationImpl).y2 = function () {
    return this.ci7_1;
  };
  function FindConnectionCommandImpl(context, node) {
    node = node === VOID ? new Node_0(FindConnectionCommandConcept_getInstance().m6n_1) : node;
    CommandImpl.call(this, context, node);
    this.gi7_1 = this.r6j(FindConnectionCommandConcept_getInstance().ngd_1);
    this.hi7_1 = this.r6j(FindConnectionCommandConcept_getInstance().ogd_1);
    this.ii7_1 = this.r6j(FindConnectionCommandConcept_getInstance().pgd_1);
  }
  protoOf(FindConnectionCommandImpl).efr = function () {
    return this.gi7_1;
  };
  protoOf(FindConnectionCommandImpl).f4b = function () {
    return this.hi7_1;
  };
  protoOf(FindConnectionCommandImpl).g4b = function () {
    return this.ii7_1;
  };
  function FindNewConnectionCommandImpl(context, node) {
    node = node === VOID ? new Node_0(FindNewConnectionCommandConcept_getInstance().m6n_1) : node;
    CommandImpl.call(this, context, node);
    this.mi7_1 = this.s6j(FindNewConnectionCommandConcept_getInstance().dge_1);
    this.ni7_1 = this.r6j(FindNewConnectionCommandConcept_getInstance().ege_1);
    this.oi7_1 = this.r6j(FindNewConnectionCommandConcept_getInstance().fge_1);
    this.pi7_1 = this.s6j(HasVariablesConcept_getInstance().ygh_1);
  }
  protoOf(FindNewConnectionCommandImpl).ffr = function () {
    return this.mi7_1;
  };
  protoOf(FindNewConnectionCommandImpl).f4b = function () {
    return this.ni7_1;
  };
  protoOf(FindNewConnectionCommandImpl).g4b = function () {
    return this.oi7_1;
  };
  protoOf(FindNewConnectionCommandImpl).rfr = function () {
    return this.pi7_1;
  };
  function FunctionDeclarationImpl(context, node) {
    node = node === VOID ? new Node_0(FunctionDeclarationConcept_getInstance().m6n_1) : node;
    AbstractBindingDeclarationImpl.call(this, context, node);
    this.ai8_1 = this.r6j(FunctionDeclarationConcept_getInstance().tge_1);
    this.bi8_1 = this.r6j(FunctionDeclarationConcept_getInstance().uge_1);
  }
  protoOf(FunctionDeclarationImpl).gfr = function () {
    return this.ai8_1;
  };
  protoOf(FunctionDeclarationImpl).dfr = function () {
    return this.bi8_1;
  };
  function FunctionLibraryImpl(context, node) {
    node = node === VOID ? new Node_0(FunctionLibraryConcept_getInstance().m6n_1) : node;
    DocumentNodeImpl.call(this, context, node);
    this.hi8_1 = this.s6j(FunctionLibraryConcept_getInstance().hgf_1);
  }
  protoOf(FunctionLibraryImpl).hfr = function () {
    return this.hi8_1;
  };
  function FunctionTermImpl(context, node) {
    node = node === VOID ? new Node_0(FunctionTermConcept_getInstance().m6n_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.li8_1 = context.u6l(FunctionTermConcept_getInstance().vgf_1, this);
    this.mi8_1 = this.o6j(FunctionTermConcept_getInstance().wgf_1, FunctionTermConcept_getInstance().ygf_1);
    this.ni8_1 = this.s6j(FunctionTermConcept_getInstance().xgf_1);
  }
  protoOf(FunctionTermImpl).ifr = function () {
    return this.li8_1;
  };
  protoOf(FunctionTermImpl).jfr = function () {
    return this.mi8_1;
  };
  protoOf(FunctionTermImpl).kfr = function () {
    return this.ni8_1;
  };
  function ImportedLinkImpl(context, node) {
    node = node === VOID ? new Node_0(ImportedLinkConcept_getInstance().m6n_1) : node;
    AbstractLinkImpl.call(this, context, node);
    this.si8_1 = context.u6l(ImportedLinkConcept_getInstance().lgi_1, this);
  }
  protoOf(ImportedLinkImpl).sfr = function () {
    return this.si8_1;
  };
  function ImportedPropertyImpl(context, node) {
    node = node === VOID ? new Node_0(ImportedPropertyConcept_getInstance().m6n_1) : node;
    AbstractPropertyImpl.call(this, context, node);
    this.wi8_1 = context.u6l(ImportedPropertyConcept_getInstance().ygi_1, this);
  }
  protoOf(ImportedPropertyImpl).sfr = function () {
    return this.wi8_1;
  };
  function InheritedProcessPropertyImpl(context, node) {
    node = node === VOID ? new Node_0(InheritedProcessPropertyConcept_getInstance().m6n_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.ai9_1 = this.r6j(InheritedProcessPropertyConcept_getInstance().kgj_1);
    this.bi9_1 = this.r6j(InheritedProcessPropertyConcept_getInstance().lgj_1);
    this.ci9_1 = this.r6j(InheritedProcessPropertyConcept_getInstance().mgj_1);
    this.di9_1 = this.i6j(DirectlyNamedConcept_getInstance().bhz_1);
  }
  protoOf(InheritedProcessPropertyImpl).sfq = function () {
    return this.ai9_1;
  };
  protoOf(InheritedProcessPropertyImpl).g3b = function () {
    return this.bi9_1;
  };
  protoOf(InheritedProcessPropertyImpl).tfr = function () {
    return this.ci9_1;
  };
  protoOf(InheritedProcessPropertyImpl).y2 = function () {
    return this.di9_1;
  };
  function InstanceRelationDeclarationImpl(context, node) {
    node = node === VOID ? new Node_0(InstanceRelationDeclarationConcept_getInstance().m6n_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.hi9_1 = this.r6j(InstanceRelationDeclarationConcept_getInstance().agk_1);
    this.ii9_1 = this.r6j(InstanceRelationDeclarationConcept_getInstance().bgk_1);
    this.ji9_1 = this.i6j(DirectlyNamedConcept_getInstance().bhz_1);
  }
  protoOf(InstanceRelationDeclarationImpl).ufr = function () {
    return this.hi9_1;
  };
  protoOf(InstanceRelationDeclarationImpl).hd = function () {
    return this.ii9_1;
  };
  protoOf(InstanceRelationDeclarationImpl).y2 = function () {
    return this.ji9_1;
  };
  function InstanceRelationValueImpl(context, node) {
    node = node === VOID ? new Node_0(InstanceRelationValueConcept_getInstance().m6n_1) : node;
    InstanceRelationValuePlaceholderImpl.call(this, context, node);
    this.ni9_1 = this.r6j(InstanceRelationValueConcept_getInstance().ogk_1);
    this.oi9_1 = context.u6l(InstanceRelationValueConcept_getInstance().pgk_1, this);
  }
  protoOf(InstanceRelationValueImpl).a1 = function () {
    return this.ni9_1;
  };
  protoOf(InstanceRelationValueImpl).xfq = function () {
    return this.oi9_1;
  };
  function InstanceRelationValuePlaceholderImpl(context, node) {
    node = node === VOID ? new Node_0(InstanceRelationValuePlaceholderConcept_getInstance().m6n_1) : node;
    BTBNodeImpl.call(this, context, node);
  }
  function IntegerValueImpl(context, node) {
    node = node === VOID ? new Node_0(IntegerValueConcept_getInstance().m6n_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.si9_1 = this.j6j(IntegerValueConcept_getInstance().dgl_1);
  }
  protoOf(IntegerValueImpl).a1 = function () {
    return this.si9_1;
  };
  function IsExpressionImpl(context, node) {
    node = node === VOID ? new Node_0(IsExpressionConcept_getInstance().m6n_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.wi9_1 = this.r6j(IsExpressionConcept_getInstance().pgl_1);
    this.xi9_1 = this.r6j(IsExpressionConcept_getInstance().qgl_1);
  }
  protoOf(IsExpressionImpl).mdy = function () {
    return this.wi9_1;
  };
  protoOf(IsExpressionImpl).a1 = function () {
    return this.xi9_1;
  };
  function KindCustomCellImpl(context, node) {
    node = node === VOID ? new Node_0(KindCustomCellConcept_getInstance().m6n_1) : node;
    CustomCellImpl.call(this, context, node);
  }
  function KnowledgeSourceReferenceImpl(context, node) {
    BTBNodeImpl.call(this, context, node);
  }
  function KnowledgeSourceReferencePlaceholderImpl(context, node) {
    node = node === VOID ? new Node_0(KnowledgeSourceReferencePlaceholderConcept_getInstance().m6n_1) : node;
    KnowledgeSourceReferenceImpl.call(this, context, node);
  }
  function LibraryItemPlaceholderImpl(context, node) {
    node = node === VOID ? new Node_0(LibraryItemPlaceholderConcept_getInstance().m6n_1) : node;
    BTBNodeImpl.call(this, context, node);
  }
  function LibraryProcessSpecificationImpl(context, node) {
    node = node === VOID ? new Node_0(LibraryProcessSpecificationConcept_getInstance().m6n_1) : node;
    AbstractProcessSpecificationImpl.call(this, context, node);
    this.bia_1 = context.u6l(LibraryProcessSpecificationConcept_getInstance().egm_1, this);
    this.cia_1 = this.s6j(LibraryProcessSpecificationConcept_getInstance().fgm_1);
  }
  protoOf(LibraryProcessSpecificationImpl).vfr = function () {
    return this.bia_1;
  };
  protoOf(LibraryProcessSpecificationImpl).kfr = function () {
    return this.cia_1;
  };
  function LibraryProcessSpecificationQueryImpl(context, node) {
    node = node === VOID ? new Node_0(LibraryProcessSpecificationQueryConcept_getInstance().m6n_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.hia_1 = context.u6l(LibraryProcessSpecificationQueryConcept_getInstance().ugm_1, this);
    this.iia_1 = context.u6l(LibraryProcessSpecificationQueryConcept_getInstance().vgm_1, this);
    this.jia_1 = this.s6j(LibraryProcessSpecificationQueryConcept_getInstance().wgm_1);
  }
  protoOf(LibraryProcessSpecificationQueryImpl).vfr = function () {
    return this.hia_1;
  };
  protoOf(LibraryProcessSpecificationQueryImpl).r5a = function () {
    return this.iia_1;
  };
  protoOf(LibraryProcessSpecificationQueryImpl).kfr = function () {
    return this.jia_1;
  };
  function LinkCustomCellImpl(context, node) {
    node = node === VOID ? new Node_0(LinkCustomCellConcept_getInstance().m6n_1) : node;
    CustomCellImpl.call(this, context, node);
    this.nia_1 = context.u6l(LinkCustomCellConcept_getInstance().lgn_1, this);
  }
  protoOf(LinkCustomCellImpl).xa1 = function () {
    return this.nia_1;
  };
  function LinkDeclarationImpl(context, node) {
    node = node === VOID ? new Node_0(LinkDeclarationConcept_getInstance().m6n_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.ria_1 = this.o6j(LinkDeclarationConcept_getInstance().ygn_1, LinkDeclarationConcept_getInstance().ago_1);
    this.sia_1 = this.r6j(LinkDeclarationConcept_getInstance().zgn_1);
    this.tia_1 = this.i6j(DirectlyNamedConcept_getInstance().bhz_1);
  }
  protoOf(LinkDeclarationImpl).jfr = function () {
    return this.ria_1;
  };
  protoOf(LinkDeclarationImpl).sfq = function () {
    return this.sia_1;
  };
  protoOf(LinkDeclarationImpl).y2 = function () {
    return this.tia_1;
  };
  function LinkLibraryImpl(context, node) {
    node = node === VOID ? new Node_0(LinkLibraryConcept_getInstance().m6n_1) : node;
    DocumentNodeImpl.call(this, context, node);
    this.zia_1 = this.s6j(LinkLibraryConcept_getInstance().ngo_1);
  }
  protoOf(LinkLibraryImpl).wfr = function () {
    return this.zia_1;
  };
  function LocalOntologyElementReferenceImpl(context, node) {
    node = node === VOID ? new Node_0(LocalOntologyElementReferenceConcept_getInstance().m6n_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.dib_1 = context.u6l(LocalOntologyElementReferenceConcept_getInstance().agp_1, this);
  }
  protoOf(LocalOntologyElementReferenceImpl).gfq = function () {
    return this.dib_1;
  };
  function MeasurableNotionImpl(context, node) {
    node = node === VOID ? new Node_0(MeasurableNotionConcept_getInstance().m6n_1) : node;
    AbstractNotionImpl.call(this, context, node);
    this.jib_1 = this.s6j(MeasurableNotionConcept_getInstance().mgp_1);
  }
  protoOf(MeasurableNotionImpl).xfr = function () {
    return this.jib_1;
  };
  function MeasurableValueImpl(context, node) {
    node = node === VOID ? new Node_0(MeasurableValueConcept_getInstance().m6n_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.nib_1 = this.k6j(MeasurableValueConcept_getInstance().ygp_1);
    this.oib_1 = context.u6l(MeasurableValueConcept_getInstance().zgp_1, this);
  }
  protoOf(MeasurableValueImpl).yfr = function () {
    return this.nib_1;
  };
  protoOf(MeasurableValueImpl).zfr = function () {
    return this.oib_1;
  };
  function MeasurementUnitImpl(context, node) {
    node = node === VOID ? new Node_0(MeasurementUnitConcept_getInstance().m6n_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.tib_1 = this.p6j(MeasurementUnitConcept_getInstance().ngq_1);
    this.uib_1 = this.i6j(DirectlyNamedConcept_getInstance().bhz_1);
  }
  protoOf(MeasurementUnitImpl).afs = function () {
    return this.tib_1;
  };
  protoOf(MeasurementUnitImpl).y2 = function () {
    return this.uib_1;
  };
  function ModifierContainerImpl(context, node) {
    node = node === VOID ? new Node_0(ModifierContainerConcept_getInstance().m6n_1) : node;
    DocumentNodeImpl.call(this, context, node);
    this.aic_1 = this.s6j(ModifierContainerConcept_getInstance().zgq_1);
  }
  protoOf(ModifierContainerImpl).l8j = function () {
    return this.aic_1;
  };
  function ModifierDeclarationImpl(context, node) {
    node = node === VOID ? new Node_0(ModifierDeclarationConcept_getInstance().m6n_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.eic_1 = this.i6j(DirectlyNamedConcept_getInstance().bhz_1);
  }
  protoOf(ModifierDeclarationImpl).y2 = function () {
    return this.eic_1;
  };
  function ModifierFactExpressionImpl(context, node) {
    node = node === VOID ? new Node_0(ModifierFactExpressionConcept_getInstance().m6n_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.iic_1 = context.u6l(ModifierFactExpressionConcept_getInstance().mgr_1, this);
    this.jic_1 = this.r6j(ModifierFactExpressionConcept_getInstance().ngr_1);
  }
  protoOf(ModifierFactExpressionImpl).bfs = function () {
    return this.iic_1;
  };
  protoOf(ModifierFactExpressionImpl).mfr = function () {
    return this.jic_1;
  };
  function MultilineTextImpl(context, node) {
    node = node === VOID ? new Node_0(MultilineTextConcept_getInstance().m6n_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.nic_1 = this.s6j(MultilineTextConcept_getInstance().ags_1);
  }
  protoOf(MultilineTextImpl).qcv = function () {
    return this.nic_1;
  };
  function MultipleProcessPropertyValueRangeImpl(context, node) {
    node = node === VOID ? new Node_0(MultipleProcessPropertyValueRangeConcept_getInstance().m6n_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.ric_1 = this.r6j(MultipleProcessPropertyValueRangeConcept_getInstance().mgs_1);
  }
  protoOf(MultipleProcessPropertyValueRangeImpl).sfq = function () {
    return this.ric_1;
  };
  function MultiplePropertyValueRangeImpl(context, node) {
    node = node === VOID ? new Node_0(MultiplePropertyValueRangeConcept_getInstance().m6n_1) : node;
    PropertyValueRangeImpl.call(this, context, node);
    this.vic_1 = this.s6j(MultiplePropertyValueRangeConcept_getInstance().ygs_1);
  }
  protoOf(MultiplePropertyValueRangeImpl).cfs = function () {
    return this.vic_1;
  };
  function MultipliedExpressionImpl(context, node) {
    node = node === VOID ? new Node_0(MultipliedExpressionConcept_getInstance().m6n_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.zic_1 = this.j6j(MultipliedExpressionConcept_getInstance().kgt_1);
    this.aid_1 = this.r6j(MultipliedExpressionConcept_getInstance().lgt_1);
  }
  protoOf(MultipliedExpressionImpl).dfs = function () {
    return this.zic_1;
  };
  protoOf(MultipliedExpressionImpl).mfr = function () {
    return this.aid_1;
  };
  function NewFactImpl(context, node) {
    node = node === VOID ? new Node_0(NewFactConcept_getInstance().m6n_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.fid_1 = this.r6j(NewFactConcept_getInstance().ygt_1);
    this.gid_1 = this.i6j(DirectlyNamedConcept_getInstance().bhz_1);
  }
  protoOf(NewFactImpl).mfr = function () {
    return this.fid_1;
  };
  protoOf(NewFactImpl).y2 = function () {
    return this.gid_1;
  };
  function NewFactReferenceImpl(context, node) {
    node = node === VOID ? new Node_0(NewFactReferenceConcept_getInstance().m6n_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.kid_1 = context.u6l(NewFactReferenceConcept_getInstance().lgu_1, this);
  }
  protoOf(NewFactReferenceImpl).yfq = function () {
    return this.kid_1;
  };
  function NoValuesImpl(context, node) {
    node = node === VOID ? new Node_0(NoValuesConcept_getInstance().m6n_1) : node;
    PropertyValueRangeImpl.call(this, context, node);
  }
  function NotionLibraryImpl(context, node) {
    node = node === VOID ? new Node_0(NotionLibraryConcept_getInstance().m6n_1) : node;
    DocumentNodeImpl.call(this, context, node);
    this.qid_1 = this.s6j(NotionLibraryConcept_getInstance().xgu_1);
  }
  protoOf(NotionLibraryImpl).efs = function () {
    return this.qid_1;
  };
  function NotionPlaceholderImpl(context, node) {
    node = node === VOID ? new Node_0(NotionPlaceholderConcept_getInstance().m6n_1) : node;
    AbstractNotionImpl.call(this, context, node);
  }
  function NotionTypeImpl(context, node) {
    node = node === VOID ? new Node_0(NotionTypeConcept_getInstance().m6n_1) : node;
    TypeImpl.call(this, context, node);
    this.uid_1 = context.u6l(NotionTypeConcept_getInstance().kgv_1, this);
  }
  protoOf(NotionTypeImpl).mfq = function () {
    return this.uid_1;
  };
  function ObjectPropertiesLibraryImpl(context, node) {
    node = node === VOID ? new Node_0(ObjectPropertiesLibraryConcept_getInstance().m6n_1) : node;
    DocumentNodeImpl.call(this, context, node);
    this.aie_1 = this.s6j(ObjectPropertiesLibraryConcept_getInstance().wgv_1);
  }
  protoOf(ObjectPropertiesLibraryImpl).rfp = function () {
    return this.aie_1;
  };
  function ObjectPropertyDeclarationImpl(context, node) {
    node = node === VOID ? new Node_0(ObjectPropertyDeclarationConcept_getInstance().m6n_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.eie_1 = this.p6j(ObjectPropertyDeclarationConcept_getInstance().igw_1);
    this.fie_1 = context.u6l(ObjectPropertyDeclarationConcept_getInstance().jgw_1, this);
    this.gie_1 = this.s6j(ObjectPropertyDeclarationConcept_getInstance().kgw_1);
    this.hie_1 = this.r6j(ObjectPropertyDeclarationConcept_getInstance().lgw_1);
    this.iie_1 = this.p6j(ObjectPropertyDeclarationConcept_getInstance().mgw_1);
    this.jie_1 = context.u6l(ObjectPropertyDeclarationConcept_getInstance().ngw_1, this);
    this.kie_1 = this.i6j(DirectlyNamedConcept_getInstance().bhz_1);
    this.lie_1 = this.r6j(HasCommentsConcept_getInstance().igg_1);
  }
  protoOf(ObjectPropertyDeclarationImpl).ffs = function () {
    return this.eie_1;
  };
  protoOf(ObjectPropertyDeclarationImpl).gfs = function () {
    return this.fie_1;
  };
  protoOf(ObjectPropertyDeclarationImpl).ufr = function () {
    return this.gie_1;
  };
  protoOf(ObjectPropertyDeclarationImpl).hd = function () {
    return this.hie_1;
  };
  protoOf(ObjectPropertyDeclarationImpl).hfs = function () {
    return this.iie_1;
  };
  protoOf(ObjectPropertyDeclarationImpl).ifs = function () {
    return this.jie_1;
  };
  protoOf(ObjectPropertyDeclarationImpl).y2 = function () {
    return this.kie_1;
  };
  protoOf(ObjectPropertyDeclarationImpl).lfr = function () {
    return this.lie_1;
  };
  function ObjectPropertyReferenceValueImpl(context, node) {
    node = node === VOID ? new Node_0(ObjectPropertyReferenceValueConcept_getInstance().m6n_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.pie_1 = this.r6j(ObjectPropertyReferenceValueConcept_getInstance().ggx_1);
    this.qie_1 = this.r6j(ObjectPropertyReferenceValueConcept_getInstance().hgx_1);
  }
  protoOf(ObjectPropertyReferenceValueImpl).jfs = function () {
    return this.pie_1;
  };
  protoOf(ObjectPropertyReferenceValueImpl).q6q = function () {
    return this.qie_1;
  };
  function OldPublishedSourceImpl(context, node) {
    node = node === VOID ? new Node_0(OldPublishedSourceConcept_getInstance().m6n_1) : node;
    PublishedWorkImpl.call(this, context, node);
    this.aif_1 = this.i6j(OldPublishedSourceConcept_getInstance().ugx_1);
    this.bif_1 = this.i6j(OldPublishedSourceConcept_getInstance().vgx_1);
    this.cif_1 = get_name_4.call(this);
  }
  protoOf(OldPublishedSourceImpl).kfs = function () {
    return this.aif_1;
  };
  protoOf(OldPublishedSourceImpl).lfs = function () {
    return this.bif_1;
  };
  protoOf(OldPublishedSourceImpl).y2 = function () {
    return this.cif_1;
  };
  function OneOfImpl(context, node) {
    node = node === VOID ? new Node_0(OneOfConcept_getInstance().m6n_1) : node;
    TypeImpl.call(this, context, node);
    this.gif_1 = this.s6j(OneOfConcept_getInstance().igy_1);
  }
  protoOf(OneOfImpl).mfs = function () {
    return this.gif_1;
  };
  function OntologyCardinalityRelationImpl(context, node) {
    node = node === VOID ? new Node_0(OntologyCardinalityRelationConcept_getInstance().m6n_1) : node;
    AbstractOntologyRelationImpl.call(this, context, node);
    this.kif_1 = this.r6j(OntologyCardinalityRelationConcept_getInstance().ugy_1);
    this.lif_1 = this.r6j(OntologyCardinalityRelationConcept_getInstance().vgy_1);
  }
  protoOf(OntologyCardinalityRelationImpl).hfq = function () {
    return this.kif_1;
  };
  protoOf(OntologyCardinalityRelationImpl).dfr = function () {
    return this.lif_1;
  };
  function OntologyElementDefinitionImpl(context, node) {
    node = node === VOID ? new Node_0(OntologyElementDefinitionConcept_getInstance().m6n_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.pif_1 = this.r6j(OntologyElementDefinitionConcept_getInstance().mh0_1);
    this.qif_1 = this.s6j(HasPropertyConstraintsConcept_getInstance().ggh_1);
  }
  protoOf(OntologyElementDefinitionImpl).hfq = function () {
    return this.pif_1;
  };
  protoOf(OntologyElementDefinitionImpl).ofr = function () {
    return this.qif_1;
  };
  function OntologyElementImpl(context, node) {
    node = node === VOID ? new Node_0(OntologyElementConcept_getInstance().m6n_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.uif_1 = this.s6j(OntologyElementConcept_getInstance().igz_1);
    this.vif_1 = this.s6j(OntologyElementConcept_getInstance().jgz_1);
    this.wif_1 = this.r6j(OntologyElementConcept_getInstance().kgz_1);
    this.xif_1 = this.i6j(OntologyElementConcept_getInstance().lgz_1);
    this.yif_1 = this.i6j(OntologyElementConcept_getInstance().mgz_1);
    this.zif_1 = this.s6j(OntologyElementConcept_getInstance().ngz_1);
    this.aig_1 = this.s6j(OntologyElementConcept_getInstance().ogz_1);
    this.big_1 = this.s6j(OntologyElementConcept_getInstance().pgz_1);
    this.cig_1 = this.r6j(OntologyElementConcept_getInstance().qgz_1);
    this.dig_1 = this.r6j(OntologyElementConcept_getInstance().rgz_1);
    this.eig_1 = this.i6j(DirectlyNamedConcept_getInstance().bhz_1);
    this.fig_1 = this.s6j(HasPropertyConstraintsConcept_getInstance().ggh_1);
    this.gig_1 = this.r6j(HasCommentsConcept_getInstance().igg_1);
  }
  protoOf(OntologyElementImpl).nfs = function () {
    return this.uif_1;
  };
  protoOf(OntologyElementImpl).ofs = function () {
    return this.vif_1;
  };
  protoOf(OntologyElementImpl).pfs = function () {
    return this.wif_1;
  };
  protoOf(OntologyElementImpl).qfs = function () {
    return this.xif_1;
  };
  protoOf(OntologyElementImpl).rfs = function () {
    return this.yif_1;
  };
  protoOf(OntologyElementImpl).sfs = function () {
    return this.zif_1;
  };
  protoOf(OntologyElementImpl).tfs = function () {
    return this.aig_1;
  };
  protoOf(OntologyElementImpl).ufs = function () {
    return this.big_1;
  };
  protoOf(OntologyElementImpl).vfs = function () {
    return this.cig_1;
  };
  protoOf(OntologyElementImpl).wfs = function () {
    return this.dig_1;
  };
  protoOf(OntologyElementImpl).y2 = function () {
    return this.eig_1;
  };
  protoOf(OntologyElementImpl).ofr = function () {
    return this.fig_1;
  };
  protoOf(OntologyElementImpl).lfr = function () {
    return this.gig_1;
  };
  function OntologyElementPropertyTypeImpl(context, node) {
    node = node === VOID ? new Node_0(OntologyElementPropertyTypeConcept_getInstance().m6n_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.lig_1 = this.o6j(OntologyElementPropertyTypeConcept_getInstance().yh0_1, OntologyElementPropertyTypeConcept_getInstance().bh1_1);
    this.mig_1 = this.r6j(OntologyElementPropertyTypeConcept_getInstance().zh0_1);
    this.nig_1 = this.r6j(OntologyElementPropertyTypeConcept_getInstance().ah1_1);
  }
  protoOf(OntologyElementPropertyTypeImpl).jfr = function () {
    return this.lig_1;
  };
  protoOf(OntologyElementPropertyTypeImpl).ffq = function () {
    return this.mig_1;
  };
  protoOf(OntologyElementPropertyTypeImpl).gfq = function () {
    return this.nig_1;
  };
  function OntologyElementReferenceImpl(context, node) {
    node = node === VOID ? new Node_0(OntologyElementReferenceConcept_getInstance().m6n_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.rig_1 = context.u6l(OntologyElementReferenceConcept_getInstance().qh1_1, this);
  }
  protoOf(OntologyElementReferenceImpl).gfq = function () {
    return this.rig_1;
  };
  function OntologyElementReferenceValueImpl(context, node) {
    node = node === VOID ? new Node_0(OntologyElementReferenceValueConcept_getInstance().m6n_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.vig_1 = this.r6j(OntologyElementReferenceValueConcept_getInstance().ch2_1);
  }
  protoOf(OntologyElementReferenceValueImpl).gfq = function () {
    return this.vig_1;
  };
  function OntologyElementReferenceValueLibraryImpl(context, node) {
    node = node === VOID ? new Node_0(OntologyElementReferenceValueLibraryConcept_getInstance().m6n_1) : node;
    OntologyElementReferenceValueImpl.call(this, context, node);
    this.aih_1 = this.r6j(OntologyElementReferenceValueLibraryConcept_getInstance().oh2_1);
  }
  protoOf(OntologyElementReferenceValueLibraryImpl).ffq = function () {
    return this.aih_1;
  };
  function OntologyElementSynonymImpl(context, node) {
    node = node === VOID ? new Node_0(OntologyElementSynonymConcept_getInstance().m6n_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.eih_1 = this.i6j(OntologyElementSynonymConcept_getInstance().ah3_1);
  }
  protoOf(OntologyElementSynonymImpl).y2 = function () {
    return this.eih_1;
  };
  function OntologyElementTypeImpl(context, node) {
    node = node === VOID ? new Node_0(OntologyElementTypeConcept_getInstance().m6n_1) : node;
    TypeImpl.call(this, context, node);
    this.iih_1 = this.r6j(OntologyElementTypeConcept_getInstance().mh3_1);
    this.jih_1 = this.r6j(OntologyElementTypeConcept_getInstance().nh3_1);
  }
  protoOf(OntologyElementTypeImpl).ffq = function () {
    return this.iih_1;
  };
  protoOf(OntologyElementTypeImpl).gfq = function () {
    return this.jih_1;
  };
  function OntologyImportImpl(context, node) {
    node = node === VOID ? new Node_0(OntologyImportConcept_getInstance().m6n_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.nih_1 = this.r6j(OntologyImportConcept_getInstance().ah4_1);
    this.oih_1 = this.r6j(OntologyImportConcept_getInstance().bh4_1);
    this.pih_1 = this.r6j(OntologyImportConcept_getInstance().ch4_1);
  }
  protoOf(OntologyImportImpl).xfs = function () {
    return this.nih_1;
  };
  protoOf(OntologyImportImpl).gfq = function () {
    return this.oih_1;
  };
  protoOf(OntologyImportImpl).yfs = function () {
    return this.pih_1;
  };
  function OntologyImportRootImpl(context, node) {
    node = node === VOID ? new Node_0(OntologyImportRootConcept_getInstance().m6n_1) : node;
    DocumentNodeImpl.call(this, context, node);
    this.vih_1 = this.s6j(OntologyImportRootConcept_getInstance().qh4_1);
  }
  protoOf(OntologyImportRootImpl).zfp = function () {
    return this.vih_1;
  };
  function OntologyImportRootReferenceImpl(context, node) {
    node = node === VOID ? new Node_0(OntologyImportRootReferenceConcept_getInstance().m6n_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.zih_1 = context.u6l(OntologyImportRootReferenceConcept_getInstance().dh5_1, this);
  }
  protoOf(OntologyImportRootReferenceImpl).yfq = function () {
    return this.zih_1;
  };
  function OntologyIsRelationImpl(context, node) {
    node = node === VOID ? new Node_0(OntologyIsRelationConcept_getInstance().m6n_1) : node;
    AbstractOntologyRelationImpl.call(this, context, node);
    this.dii_1 = this.r6j(OntologyIsRelationConcept_getInstance().ph5_1);
  }
  protoOf(OntologyIsRelationImpl).zfs = function () {
    return this.dii_1;
  };
  function OntologyLibraryImpl(context, node) {
    node = node === VOID ? new Node_0(OntologyLibraryConcept_getInstance().m6n_1) : node;
    DocumentNodeImpl.call(this, context, node);
    this.kii_1 = this.s6j(OntologyLibraryConcept_getInstance().bh6_1);
  }
  protoOf(OntologyLibraryImpl).ifq = function () {
    return this.kii_1;
  };
  function OntologyLibraryReferenceImpl(context, node) {
    node = node === VOID ? new Node_0(OntologyLibraryReferenceConcept_getInstance().m6n_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.oii_1 = context.u6l(OntologyLibraryReferenceConcept_getInstance().oh6_1, this);
  }
  protoOf(OntologyLibraryReferenceImpl).yfq = function () {
    return this.oii_1;
  };
  function OntologyLinkDeclarationValueQueryImpl(context, node) {
    node = node === VOID ? new Node_0(OntologyLinkDeclarationValueQueryConcept_getInstance().m6n_1) : node;
    DeclarationValueQueryImpl.call(this, context, node);
    this.tii_1 = context.u6l(OntologyLinkDeclarationValueQueryConcept_getInstance().ph7_1, this);
  }
  protoOf(OntologyLinkDeclarationValueQueryImpl).bft = function () {
    return this.tii_1;
  };
  function OntologyLinkImpl(context, node) {
    node = node === VOID ? new Node_0(OntologyLinkConcept_getInstance().m6n_1) : node;
    AbstractLinkImpl.call(this, context, node);
    this.yii_1 = this.r6j(OntologyLinkConcept_getInstance().ah7_1);
    this.zii_1 = this.r6j(OntologyLinkConcept_getInstance().bh7_1);
  }
  protoOf(OntologyLinkImpl).xa1 = function () {
    return this.yii_1;
  };
  protoOf(OntologyLinkImpl).aft = function () {
    return this.zii_1;
  };
  function OntologyLinkValueImpl(context, node) {
    node = node === VOID ? new Node_0(OntologyLinkValueConcept_getInstance().m6n_1) : node;
    AbstractBindingValueImpl.call(this, context, node);
    this.eij_1 = context.u6l(OntologyLinkValueConcept_getInstance().ch8_1, this);
  }
  protoOf(OntologyLinkValueImpl).cft = function () {
    return this.eij_1;
  };
  function OrValueQueryImpl(context, node) {
    node = node === VOID ? new Node_0(OrValueQueryConcept_getInstance().m6n_1) : node;
    AbstractBindingValueQueryImpl.call(this, context, node);
    this.jij_1 = this.r6j(OrValueQueryConcept_getInstance().oh8_1);
    this.kij_1 = this.r6j(OrValueQueryConcept_getInstance().ph8_1);
  }
  protoOf(OrValueQueryImpl).dft = function () {
    return this.jij_1;
  };
  protoOf(OrValueQueryImpl).eft = function () {
    return this.kij_1;
  };
  function PageImpl(context, node) {
    node = node === VOID ? new Node_0(PageConcept_getInstance().m6n_1) : node;
    PageSpecificationImpl.call(this, context, node);
    this.oij_1 = this.j6j(PageConcept_getInstance().ch9_1);
  }
  protoOf(PageImpl).fft = function () {
    return this.oij_1;
  };
  function PageRangeImpl(context, node) {
    node = node === VOID ? new Node_0(PageRangeConcept_getInstance().m6n_1) : node;
    PageSpecificationImpl.call(this, context, node);
    this.sij_1 = this.j6j(PageRangeConcept_getInstance().oh9_1);
    this.tij_1 = this.j6j(PageRangeConcept_getInstance().ph9_1);
  }
  protoOf(PageRangeImpl).p1 = function () {
    return this.sij_1;
  };
  protoOf(PageRangeImpl).lb4 = function () {
    return this.tij_1;
  };
  function PageSpecificationImpl(context, node) {
    BTBNodeImpl.call(this, context, node);
  }
  function PaperImpl(context, node) {
    node = node === VOID ? new Node_0(PaperConcept_getInstance().m6n_1) : node;
    PublishedWorkImpl.call(this, context, node);
    this.cik_1 = this.i6j(PaperConcept_getInstance().cha_1);
    this.dik_1 = this.i6j(PaperConcept_getInstance().dha_1);
    this.eik_1 = this.i6j(PaperConcept_getInstance().eha_1);
    this.fik_1 = this.i6j(PaperConcept_getInstance().fha_1);
    this.gik_1 = this.i6j(PaperConcept_getInstance().gha_1);
    this.hik_1 = this.i6j(PaperConcept_getInstance().hha_1);
    this.iik_1 = this.i6j(PaperConcept_getInstance().iha_1);
    this.jik_1 = this.r6j(PaperConcept_getInstance().jha_1);
  }
  protoOf(PaperImpl).gft = function () {
    return this.cik_1;
  };
  protoOf(PaperImpl).hft = function () {
    return this.dik_1;
  };
  protoOf(PaperImpl).ift = function () {
    return this.eik_1;
  };
  protoOf(PaperImpl).jft = function () {
    return this.fik_1;
  };
  protoOf(PaperImpl).kft = function () {
    return this.gik_1;
  };
  protoOf(PaperImpl).lft = function () {
    return this.hik_1;
  };
  protoOf(PaperImpl).mft = function () {
    return this.iik_1;
  };
  protoOf(PaperImpl).nft = function () {
    return this.jik_1;
  };
  function PartReferenceOperationImpl(context, node) {
    BTBNodeImpl.call(this, context, node);
  }
  function PartValueImpl(context, node) {
    node = node === VOID ? new Node_0(PartValueConcept_getInstance().m6n_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.nik_1 = this.r6j(PartValueConcept_getInstance().chb_1);
    this.oik_1 = this.r6j(PartValueConcept_getInstance().dhb_1);
  }
  protoOf(PartValueImpl).jfs = function () {
    return this.nik_1;
  };
  protoOf(PartValueImpl).s3z = function () {
    return this.oik_1;
  };
  function PatternImpl(context, node) {
    BTBNodeImpl.call(this, context, node);
  }
  function PreconditionImpl(context, node) {
    node = node === VOID ? new Node_0(PreconditionConcept_getInstance().m6n_1) : node;
    BTBNodeImpl.call(this, context, node);
  }
  function PrimitiveNotionTypeImpl(context, node) {
    node = node === VOID ? new Node_0(PrimitiveNotionTypeConcept_getInstance().m6n_1) : node;
    TypeImpl.call(this, context, node);
    this.tik_1 = this.o6j(PrimitiveNotionTypeConcept_getInstance().rhb_1, PrimitiveNotionTypeConcept_getInstance().shb_1);
  }
  protoOf(PrimitiveNotionTypeImpl).oft = function () {
    return this.tik_1;
  };
  function PrimitivePropertyTypeImpl(context, node) {
    node = node === VOID ? new Node_0(PrimitivePropertyTypeConcept_getInstance().m6n_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.xik_1 = this.o6j(PrimitivePropertyTypeConcept_getInstance().ehc_1, PrimitivePropertyTypeConcept_getInstance().fhc_1);
  }
  protoOf(PrimitivePropertyTypeImpl).oft = function () {
    return this.xik_1;
  };
  function ProcessDeclarationImpl(context, node) {
    node = node === VOID ? new Node_0(ProcessDeclarationConcept_getInstance().m6n_1) : node;
    AbstractBindingDeclarationImpl.call(this, context, node);
    this.iil_1 = context.u6l(ProcessDeclarationConcept_getInstance().uhc_1, this);
    this.jil_1 = context.u6l(ProcessDeclarationConcept_getInstance().vhc_1, this);
    this.kil_1 = this.s6j(ProcessDeclarationConcept_getInstance().whc_1);
    this.lil_1 = this.s6j(ProcessDeclarationConcept_getInstance().xhc_1);
    this.mil_1 = this.s6j(ProcessDeclarationConcept_getInstance().yhc_1);
    this.nil_1 = this.s6j(ProcessDeclarationConcept_getInstance().zhc_1);
    this.oil_1 = this.s6j(ProcessDeclarationConcept_getInstance().ahd_1);
    this.pil_1 = this.s6j(HasVariablesConcept_getInstance().ygh_1);
  }
  protoOf(ProcessDeclarationImpl).r5a = function () {
    return this.iil_1;
  };
  protoOf(ProcessDeclarationImpl).pft = function () {
    return this.jil_1;
  };
  protoOf(ProcessDeclarationImpl).qft = function () {
    return this.kil_1;
  };
  protoOf(ProcessDeclarationImpl).rft = function () {
    return this.lil_1;
  };
  protoOf(ProcessDeclarationImpl).sft = function () {
    return this.mil_1;
  };
  protoOf(ProcessDeclarationImpl).tft = function () {
    return this.nil_1;
  };
  protoOf(ProcessDeclarationImpl).uft = function () {
    return this.oil_1;
  };
  protoOf(ProcessDeclarationImpl).rfr = function () {
    return this.pil_1;
  };
  function ProcessEffectImpl(context, node) {
    node = node === VOID ? new Node_0(ProcessEffectConcept_getInstance().m6n_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.zil_1 = this.p6j(ProcessEffectConcept_getInstance().shd_1);
    this.aim_1 = this.p6j(HasQueryLabelsConcept_getInstance().ogh_1);
    this.bim_1 = this.p6j(HasQueryLabelsConcept_getInstance().pgh_1);
    this.cim_1 = this.r6j(HasFactExpressionConcept_getInstance().qgg_1);
  }
  protoOf(ProcessEffectImpl).vft = function () {
    return this.zil_1;
  };
  protoOf(ProcessEffectImpl).pfr = function () {
    return this.aim_1;
  };
  protoOf(ProcessEffectImpl).qfr = function () {
    return this.bim_1;
  };
  protoOf(ProcessEffectImpl).mfr = function () {
    return this.cim_1;
  };
  function ProcessKindContainerImpl(context, node) {
    node = node === VOID ? new Node_0(ProcessKindContainerConcept_getInstance().m6n_1) : node;
    DocumentNodeImpl.call(this, context, node);
    this.iim_1 = this.s6j(ProcessKindContainerConcept_getInstance().ehe_1);
  }
  protoOf(ProcessKindContainerImpl).wft = function () {
    return this.iim_1;
  };
  function ProcessKindImpl(context, node) {
    node = node === VOID ? new Node_0(ProcessKindConcept_getInstance().m6n_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.mim_1 = this.i6j(DirectlyNamedConcept_getInstance().bhz_1);
  }
  protoOf(ProcessKindImpl).y2 = function () {
    return this.mim_1;
  };
  function ProcessLibraryImpl(context, node) {
    node = node === VOID ? new Node_0(ProcessLibraryConcept_getInstance().m6n_1) : node;
    DocumentNodeImpl.call(this, context, node);
    this.sim_1 = this.s6j(ProcessLibraryConcept_getInstance().qhe_1);
  }
  protoOf(ProcessLibraryImpl).xft = function () {
    return this.sim_1;
  };
  function ProcessPrerequisiteImpl(context, node) {
    node = node === VOID ? new Node_0(ProcessPrerequisiteConcept_getInstance().m6n_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.wim_1 = this.p6j(HasQueryLabelsConcept_getInstance().ogh_1);
    this.xim_1 = this.p6j(HasQueryLabelsConcept_getInstance().pgh_1);
    this.yim_1 = this.r6j(HasFactExpressionConcept_getInstance().qgg_1);
  }
  protoOf(ProcessPrerequisiteImpl).pfr = function () {
    return this.wim_1;
  };
  protoOf(ProcessPrerequisiteImpl).qfr = function () {
    return this.xim_1;
  };
  protoOf(ProcessPrerequisiteImpl).mfr = function () {
    return this.yim_1;
  };
  function ProcessPropertyCustomCellImpl(context, node) {
    node = node === VOID ? new Node_0(ProcessPropertyCustomCellConcept_getInstance().m6n_1) : node;
    CustomCellImpl.call(this, context, node);
    this.cin_1 = context.u6l(ProcessPropertyCustomCellConcept_getInstance().thf_1, this);
  }
  protoOf(ProcessPropertyCustomCellImpl).q6q = function () {
    return this.cin_1;
  };
  function ProcessPropertyDefaultImpl(context, node) {
    node = node === VOID ? new Node_0(ProcessPropertyDefaultConcept_getInstance().m6n_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.gin_1 = this.r6j(ProcessPropertyDefaultConcept_getInstance().fhg_1);
  }
  protoOf(ProcessPropertyDefaultImpl).a1 = function () {
    return this.gin_1;
  };
  function ProcessPropertyImpl(context, node) {
    node = node === VOID ? new Node_0(ProcessPropertyConcept_getInstance().m6n_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.kin_1 = this.r6j(ProcessPropertyConcept_getInstance().chf_1);
    this.lin_1 = this.s6j(ProcessPropertyConcept_getInstance().dhf_1);
    this.min_1 = this.r6j(ProcessPropertyConcept_getInstance().ehf_1);
    this.nin_1 = this.i6j(DirectlyNamedConcept_getInstance().bhz_1);
  }
  protoOf(ProcessPropertyImpl).sfq = function () {
    return this.kin_1;
  };
  protoOf(ProcessPropertyImpl).yft = function () {
    return this.lin_1;
  };
  protoOf(ProcessPropertyImpl).g3b = function () {
    return this.min_1;
  };
  protoOf(ProcessPropertyImpl).y2 = function () {
    return this.nin_1;
  };
  function ProcessPropertyReferenceImpl(context, node) {
    node = node === VOID ? new Node_0(ProcessPropertyReferenceConcept_getInstance().m6n_1) : node;
    VariableInitializerImpl.call(this, context, node);
    this.rin_1 = context.u6l(ProcessPropertyReferenceConcept_getInstance().shg_1, this);
  }
  protoOf(ProcessPropertyReferenceImpl).q6q = function () {
    return this.rin_1;
  };
  function ProcessPropertyValueImpl(context, node) {
    node = node === VOID ? new Node_0(ProcessPropertyValueConcept_getInstance().m6n_1) : node;
    BindingValuePlaceholderImpl.call(this, context, node);
    this.vin_1 = context.u6l(ProcessPropertyValueConcept_getInstance().fhh_1, this);
    this.win_1 = this.r6j(ProcessPropertyValueConcept_getInstance().ghh_1);
    this.xin_1 = this.p6j(HasQueryLabelsConcept_getInstance().ogh_1);
    this.yin_1 = this.p6j(HasQueryLabelsConcept_getInstance().pgh_1);
  }
  protoOf(ProcessPropertyValueImpl).q6q = function () {
    return this.vin_1;
  };
  protoOf(ProcessPropertyValueImpl).a1 = function () {
    return this.win_1;
  };
  protoOf(ProcessPropertyValueImpl).pfr = function () {
    return this.xin_1;
  };
  protoOf(ProcessPropertyValueImpl).qfr = function () {
    return this.yin_1;
  };
  function ProcessReferenceImpl(context, node) {
    node = node === VOID ? new Node_0(ProcessReferenceConcept_getInstance().m6n_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.cio_1 = context.u6l(ProcessReferenceConcept_getInstance().uhh_1, this);
  }
  protoOf(ProcessReferenceImpl).vfr = function () {
    return this.cio_1;
  };
  function ProcessRelationDeclarationImpl(context, node) {
    node = node === VOID ? new Node_0(ProcessRelationDeclarationConcept_getInstance().m6n_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.gio_1 = this.i6j(ProcessRelationDeclarationConcept_getInstance().ihi_1);
    this.hio_1 = this.o6j(ProcessRelationDeclarationConcept_getInstance().jhi_1, ProcessRelationDeclarationConcept_getInstance().lhi_1);
    this.iio_1 = this.o6j(ProcessRelationDeclarationConcept_getInstance().khi_1, ProcessRelationDeclarationConcept_getInstance().mhi_1);
    this.jio_1 = this.i6j(DirectlyNamedConcept_getInstance().bhz_1);
  }
  protoOf(ProcessRelationDeclarationImpl).zft = function () {
    return this.gio_1;
  };
  protoOf(ProcessRelationDeclarationImpl).afu = function () {
    return this.hio_1;
  };
  protoOf(ProcessRelationDeclarationImpl).bfu = function () {
    return this.iio_1;
  };
  protoOf(ProcessRelationDeclarationImpl).y2 = function () {
    return this.jio_1;
  };
  function ProcessTypeImpl(context, node) {
    node = node === VOID ? new Node_0(ProcessTypeConcept_getInstance().m6n_1) : node;
    TypeImpl.call(this, context, node);
    this.oio_1 = this.r6j(ProcessTypeConcept_getInstance().ahj_1);
  }
  protoOf(ProcessTypeImpl).vfq = function () {
    return this.oio_1;
  };
  function PropertiesCustomCellImpl(context, node) {
    node = node === VOID ? new Node_0(PropertiesCustomCellConcept_getInstance().m6n_1) : node;
    CustomCellImpl.call(this, context, node);
  }
  function PropertyConstraintImpl(context, node) {
    node = node === VOID ? new Node_0(PropertyConstraintConcept_getInstance().m6n_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.sio_1 = this.o6j(PropertyConstraintConcept_getInstance().nhj_1, PropertyConstraintConcept_getInstance().qhj_1);
    this.tio_1 = context.u6l(PropertyConstraintConcept_getInstance().ohj_1, this);
    this.uio_1 = this.r6j(PropertyConstraintConcept_getInstance().phj_1);
    this.vio_1 = this.s6j(HasPropertyConstraintsConcept_getInstance().ggh_1);
  }
  protoOf(PropertyConstraintImpl).s3z = function () {
    return this.sio_1;
  };
  protoOf(PropertyConstraintImpl).q6q = function () {
    return this.tio_1;
  };
  protoOf(PropertyConstraintImpl).a1 = function () {
    return this.uio_1;
  };
  protoOf(PropertyConstraintImpl).ofr = function () {
    return this.vio_1;
  };
  function PropertyCustomCellImpl(context, node) {
    node = node === VOID ? new Node_0(PropertyCustomCellConcept_getInstance().m6n_1) : node;
    CustomCellImpl.call(this, context, node);
    this.zio_1 = context.u6l(PropertyCustomCellConcept_getInstance().ghk_1, this);
  }
  protoOf(PropertyCustomCellImpl).q6q = function () {
    return this.zio_1;
  };
  function PropertyDeclarationImpl(context, node) {
    node = node === VOID ? new Node_0(PropertyDeclarationConcept_getInstance().m6n_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.dip_1 = this.r6j(PropertyDeclarationConcept_getInstance().shk_1);
    this.eip_1 = this.i6j(DirectlyNamedConcept_getInstance().bhz_1);
  }
  protoOf(PropertyDeclarationImpl).sfq = function () {
    return this.dip_1;
  };
  protoOf(PropertyDeclarationImpl).y2 = function () {
    return this.eip_1;
  };
  function PropertyDeclarationValueQueryImpl(context, node) {
    node = node === VOID ? new Node_0(PropertyDeclarationValueQueryConcept_getInstance().m6n_1) : node;
    DeclarationValueQueryImpl.call(this, context, node);
    this.jip_1 = context.u6l(PropertyDeclarationValueQueryConcept_getInstance().fhl_1, this);
  }
  protoOf(PropertyDeclarationValueQueryImpl).cfu = function () {
    return this.jip_1;
  };
  function PropertyLibraryImpl(context, node) {
    node = node === VOID ? new Node_0(PropertyLibraryConcept_getInstance().m6n_1) : node;
    DocumentNodeImpl.call(this, context, node);
    this.pip_1 = this.s6j(PropertyLibraryConcept_getInstance().rhl_1);
  }
  protoOf(PropertyLibraryImpl).ifq = function () {
    return this.pip_1;
  };
  function PropertyReferenceOperationImpl(context, node) {
    node = node === VOID ? new Node_0(PropertyReferenceOperationConcept_getInstance().m6n_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.tip_1 = context.u6l(PropertyReferenceOperationConcept_getInstance().ehm_1, this);
    this.uip_1 = this.r6j(PropertyReferenceOperationConcept_getInstance().fhm_1);
  }
  protoOf(PropertyReferenceOperationImpl).q6q = function () {
    return this.tip_1;
  };
  protoOf(PropertyReferenceOperationImpl).dfu = function () {
    return this.uip_1;
  };
  function PropertyValueImpl(context, node) {
    node = node === VOID ? new Node_0(PropertyValueConcept_getInstance().m6n_1) : node;
    AbstractBindingValueImpl.call(this, context, node);
    this.zip_1 = context.u6l(PropertyValueConcept_getInstance().thm_1, this);
  }
  protoOf(PropertyValueImpl).q6q = function () {
    return this.zip_1;
  };
  function PropertyValueRangeImpl(context, node) {
    BTBNodeImpl.call(this, context, node);
  }
  function PubMedSourceReferenceImpl(context, node) {
    node = node === VOID ? new Node_0(PubMedSourceReferenceConcept_getInstance().m6n_1) : node;
    KnowledgeSourceReferenceImpl.call(this, context, node);
    this.diq_1 = this.i6j(PubMedSourceReferenceConcept_getInstance().fhn_1);
  }
  protoOf(PubMedSourceReferenceImpl).kft = function () {
    return this.diq_1;
  };
  function PublishedSourceReferenceImpl(context, node) {
    node = node === VOID ? new Node_0(PublishedSourceReferenceConcept_getInstance().m6n_1) : node;
    KnowledgeSourceReferenceImpl.call(this, context, node);
    this.hiq_1 = context.u6l(PublishedSourceReferenceConcept_getInstance().shn_1, this);
    this.iiq_1 = this.r6j(PublishedSourceReferenceConcept_getInstance().thn_1);
  }
  protoOf(PublishedSourceReferenceImpl).m6d = function () {
    return this.hiq_1;
  };
  protoOf(PublishedSourceReferenceImpl).efu = function () {
    return this.iiq_1;
  };
  function PublishedSourcesLibraryImpl(context, node) {
    node = node === VOID ? new Node_0(PublishedSourcesLibraryConcept_getInstance().m6n_1) : node;
    DocumentNodeImpl.call(this, context, node);
    this.oiq_1 = this.s6j(PublishedSourcesLibraryConcept_getInstance().gho_1);
  }
  protoOf(PublishedSourcesLibraryImpl).l2n = function () {
    return this.oiq_1;
  };
  function PublishedWorkImpl(context, node) {
    node = node === VOID ? new Node_0(PublishedWorkConcept_getInstance().m6n_1) : node;
    AuthoredWorkImpl.call(this, context, node);
    this.ii1_1 = this.i6j(PublishedWorkConcept_getInstance().sho_1);
    this.ji1_1 = this.i6j(PublishedWorkConcept_getInstance().tho_1);
    this.ki1_1 = get_name_0.call(this);
  }
  protoOf(PublishedWorkImpl).ffu = function () {
    return this.ii1_1;
  };
  protoOf(PublishedWorkImpl).gfu = function () {
    return this.ji1_1;
  };
  protoOf(PublishedWorkImpl).y2 = function () {
    return this.ki1_1;
  };
  function QualifiedOntologyElementReferenceImpl(context, node) {
    node = node === VOID ? new Node_0(QualifiedOntologyElementReferenceConcept_getInstance().m6n_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.siq_1 = this.r6j(QualifiedOntologyElementReferenceConcept_getInstance().ghp_1);
    this.tiq_1 = this.r6j(QualifiedOntologyElementReferenceConcept_getInstance().hhp_1);
  }
  protoOf(QualifiedOntologyElementReferenceImpl).hfu = function () {
    return this.siq_1;
  };
  protoOf(QualifiedOntologyElementReferenceImpl).ifu = function () {
    return this.tiq_1;
  };
  function QueryCommandsImpl(context, node) {
    node = node === VOID ? new Node_0(QueryCommandsConcept_getInstance().m6n_1) : node;
    DocumentNodeImpl.call(this, context, node);
    this.ziq_1 = this.s6j(QueryCommandsConcept_getInstance().uhp_1);
  }
  protoOf(QueryCommandsImpl).u51 = function () {
    return this.ziq_1;
  };
  function QueryLabelsFactExpressionContainerImpl(context, node) {
    node = node === VOID ? new Node_0(QueryLabelsFactExpressionContainerConcept_getInstance().m6n_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.dir_1 = this.p6j(HasQueryLabelsConcept_getInstance().ogh_1);
    this.eir_1 = this.p6j(HasQueryLabelsConcept_getInstance().pgh_1);
    this.fir_1 = this.r6j(HasFactExpressionConcept_getInstance().qgg_1);
  }
  protoOf(QueryLabelsFactExpressionContainerImpl).pfr = function () {
    return this.dir_1;
  };
  protoOf(QueryLabelsFactExpressionContainerImpl).qfr = function () {
    return this.eir_1;
  };
  protoOf(QueryLabelsFactExpressionContainerImpl).mfr = function () {
    return this.fir_1;
  };
  function QueryParametersBlackListImpl(context, node) {
    node = node === VOID ? new Node_0(QueryParametersBlackListConcept_getInstance().m6n_1) : node;
    DocumentNodeImpl.call(this, context, node);
    this.lir_1 = context.u6l(QueryParametersBlackListConcept_getInstance().hhq_1, this);
    this.mir_1 = this.s6j(QueryParametersBlackListConcept_getInstance().ihq_1);
  }
  protoOf(QueryParametersBlackListImpl).ffq = function () {
    return this.lir_1;
  };
  protoOf(QueryParametersBlackListImpl).ifq = function () {
    return this.mir_1;
  };
  function RelationContainerImpl(context, node) {
    node = node === VOID ? new Node_0(RelationContainerConcept_getInstance().m6n_1) : node;
    DocumentNodeImpl.call(this, context, node);
    this.sir_1 = this.s6j(RelationContainerConcept_getInstance().vhq_1);
    this.tir_1 = this.s6j(RelationContainerConcept_getInstance().whq_1);
  }
  protoOf(RelationContainerImpl).jfu = function () {
    return this.sir_1;
  };
  protoOf(RelationContainerImpl).kfu = function () {
    return this.tir_1;
  };
  function RelationFactExpressionImpl(context, node) {
    node = node === VOID ? new Node_0(RelationFactExpressionConcept_getInstance().m6n_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.xir_1 = this.r6j(RelationFactExpressionConcept_getInstance().jhr_1);
    this.yir_1 = this.r6j(RelationFactExpressionConcept_getInstance().khr_1);
    this.zir_1 = context.u6l(RelationFactExpressionConcept_getInstance().lhr_1, this);
  }
  protoOf(RelationFactExpressionImpl).dft = function () {
    return this.xir_1;
  };
  protoOf(RelationFactExpressionImpl).eft = function () {
    return this.yir_1;
  };
  protoOf(RelationFactExpressionImpl).xfq = function () {
    return this.zir_1;
  };
  function ReturnTypeCustomCellImpl(context, node) {
    node = node === VOID ? new Node_0(ReturnTypeCustomCellConcept_getInstance().m6n_1) : node;
    CustomCellImpl.call(this, context, node);
  }
  function SetExpressionImpl(context, node) {
    node = node === VOID ? new Node_0(SetExpressionConcept_getInstance().m6n_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.dis_1 = this.s6j(SetExpressionConcept_getInstance().ahs_1);
    this.eis_1 = this.p6j(SetExpressionConcept_getInstance().bhs_1);
  }
  protoOf(SetExpressionImpl).mfs = function () {
    return this.dis_1;
  };
  protoOf(SetExpressionImpl).lfu = function () {
    return this.eis_1;
  };
  function SetValuedPropertyParameterImpl(context, node) {
    node = node === VOID ? new Node_0(SetValuedPropertyParameterConcept_getInstance().m6n_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.iis_1 = this.r6j(SetValuedPropertyParameterConcept_getInstance().ohs_1);
  }
  protoOf(SetValuedPropertyParameterImpl).a1 = function () {
    return this.iis_1;
  };
  function SimplePropertyTypeImpl(context, node) {
    node = node === VOID ? new Node_0(SimplePropertyTypeConcept_getInstance().m6n_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.mis_1 = context.u6l(SimplePropertyTypeConcept_getInstance().bht_1, this);
  }
  protoOf(SimplePropertyTypeImpl).mfq = function () {
    return this.mis_1;
  };
  function SinglePropertyValueRangeImpl(context, node) {
    node = node === VOID ? new Node_0(SinglePropertyValueRangeConcept_getInstance().m6n_1) : node;
    PropertyValueRangeImpl.call(this, context, node);
    this.qis_1 = this.s6j(SinglePropertyValueRangeConcept_getInstance().nht_1);
  }
  protoOf(SinglePropertyValueRangeImpl).cfs = function () {
    return this.qis_1;
  };
  function StringValueImpl(context, node) {
    node = node === VOID ? new Node_0(StringValueConcept_getInstance().m6n_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.uis_1 = this.i6j(StringValueConcept_getInstance().zht_1);
  }
  protoOf(StringValueImpl).a1 = function () {
    return this.uis_1;
  };
  function TextLineImpl(context, node) {
    node = node === VOID ? new Node_0(TextLineConcept_getInstance().m6n_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.yis_1 = this.q6j(TextLineConcept_getInstance().lhu_1);
  }
  protoOf(TextLineImpl).o8w = function () {
    return this.yis_1;
  };
  function TypeImpl(context, node) {
    VariableSpecificationImpl.call(this, context, node);
  }
  function TypePlaceholderImpl(context, node) {
    node = node === VOID ? new Node_0(TypePlaceholderConcept_getInstance().m6n_1) : node;
    TypeImpl.call(this, context, node);
  }
  function _get_ontologyElementsField__6bq4mb($this) {
    if ($this.lit_1 == null) {
      $this.lit_1 = $this.g6l(AbstractBindingDeclarationConcept_getInstance().efv_1);
    }
    return ensureNotNull($this.lit_1);
  }
  function _get_entriesField__p2z5bz($this) {
    if ($this.mit_1 == null) {
      $this.mit_1 = $this.g6l(AbstractBindingDeclarationConcept_getInstance().ffv_1);
    }
    return ensureNotNull($this.mit_1);
  }
  function _get_propertiesField__rzp1g6($this) {
    if ($this.nit_1 == null) {
      $this.nit_1 = $this.g6l(AbstractBindingDeclarationConcept_getInstance().gfv_1);
    }
    return ensureNotNull($this.nit_1);
  }
  function _get_customEditorField__k9tlsb($this) {
    if ($this.oit_1 == null) {
      $this.oit_1 = $this.d6l(AbstractBindingDeclarationConcept_getInstance().hfv_1);
    }
    return ensureNotNull($this.oit_1);
  }
  function _get_commentField__ylav5c($this) {
    if ($this.rit_1 == null) {
      $this.rit_1 = $this.d6l(HasCommentsConcept_getInstance().jgg_1);
    }
    return ensureNotNull($this.rit_1);
  }
  function TypedAbstractBindingDeclarationImpl(context, conceptId, nodeId) {
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.lit_1 = null;
    this.mit_1 = null;
    this.nit_1 = null;
    this.oit_1 = null;
    this.pit_1 = null;
    this.qit_1 = null;
    this.rit_1 = null;
  }
  protoOf(TypedAbstractBindingDeclarationImpl).qfp = function () {
    return this.i6l(_get_ontologyElementsField__6bq4mb(this));
  };
  protoOf(TypedAbstractBindingDeclarationImpl).y = function () {
    return this.i6l(_get_entriesField__p2z5bz(this));
  };
  protoOf(TypedAbstractBindingDeclarationImpl).rfp = function () {
    return this.i6l(_get_propertiesField__rzp1g6(this));
  };
  protoOf(TypedAbstractBindingDeclarationImpl).sfp = function () {
    return this.f6l(_get_customEditorField__k9tlsb(this));
  };
  protoOf(TypedAbstractBindingDeclarationImpl).tfp = function () {
    return this.x6k(AbstractBindingDeclarationConcept_getInstance().ifv_1);
  };
  protoOf(TypedAbstractBindingDeclarationImpl).y2 = function () {
    return this.x6k(DirectlyNamedConcept_getInstance().chz_1);
  };
  protoOf(TypedAbstractBindingDeclarationImpl).lfr = function () {
    return this.f6l(_get_commentField__ylav5c(this));
  };
  protoOf(TypedAbstractBindingDeclarationImpl).c3e = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.pit_1 == null)) {
      this_0.j(AbstractBindingDeclarationConcept_getInstance().ifv_1.m6o_1);
    }
    if (!(this.qit_1 == null)) {
      this_0.j(DirectlyNamedConcept_getInstance().chz_1.m6o_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedBTBNodeImpl).c3e.call(this));
  };
  protoOf(TypedAbstractBindingDeclarationImpl).z3d = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.lit_1 == null)) {
      this_0.j(AbstractBindingDeclarationConcept_getInstance().efv_1.h6l_1);
    }
    if (!(this.mit_1 == null)) {
      this_0.j(AbstractBindingDeclarationConcept_getInstance().ffv_1.h6l_1);
    }
    if (!(this.nit_1 == null)) {
      this_0.j(AbstractBindingDeclarationConcept_getInstance().gfv_1.h6l_1);
    }
    if (!(this.oit_1 == null)) {
      this_0.j(AbstractBindingDeclarationConcept_getInstance().hfv_1.e6l_1);
    }
    if (!(this.rit_1 == null)) {
      this_0.j(HasCommentsConcept_getInstance().jgg_1.e6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedBTBNodeImpl).z3d.call(this));
  };
  protoOf(TypedAbstractBindingDeclarationImpl).v6k = function (propertyId) {
    return propertyId.equals(AbstractBindingDeclarationConcept_getInstance().ifv_1.m6o_1) ? this.pit_1 : propertyId.equals(DirectlyNamedConcept_getInstance().chz_1.m6o_1) ? this.qit_1 : protoOf(TypedBTBNodeImpl).v6k.call(this, propertyId);
  };
  protoOf(TypedAbstractBindingDeclarationImpl).w6k = function (propertyId, value) {
    if (propertyId.equals(AbstractBindingDeclarationConcept_getInstance().ifv_1.m6o_1)) {
      this.pit_1 = value;
    } else if (propertyId.equals(DirectlyNamedConcept_getInstance().chz_1.m6o_1)) {
      this.qit_1 = value;
    } else {
      protoOf(TypedBTBNodeImpl).w6k.call(this, propertyId, value);
    }
  };
  protoOf(TypedAbstractBindingDeclarationImpl).p3m = function (childId) {
    return childId.equals(AbstractBindingDeclarationConcept_getInstance().efv_1.h6l_1) ? _get_ontologyElementsField__6bq4mb(this) : childId.equals(AbstractBindingDeclarationConcept_getInstance().ffv_1.h6l_1) ? _get_entriesField__p2z5bz(this) : childId.equals(AbstractBindingDeclarationConcept_getInstance().gfv_1.h6l_1) ? _get_propertiesField__rzp1g6(this) : childId.equals(AbstractBindingDeclarationConcept_getInstance().hfv_1.e6l_1) ? _get_customEditorField__k9tlsb(this) : childId.equals(HasCommentsConcept_getInstance().jgg_1.e6l_1) ? _get_commentField__ylav5c(this) : protoOf(TypedBTBNodeImpl).p3m.call(this, childId);
  };
  function TypedAbstractBindingEntryImpl(context, conceptId, nodeId) {
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
  }
  function _get_valueField__9y0rz6($this) {
    if ($this.qiu_1 == null) {
      $this.qiu_1 = $this.d6l(AbstractBindingValueConcept_getInstance().qfv_1);
    }
    return ensureNotNull($this.qiu_1);
  }
  function TypedAbstractBindingValueImpl(context, conceptId, nodeId) {
    TypedBindingValuePlaceholderImpl.call(this, context, conceptId, nodeId);
    this.qiu_1 = null;
  }
  protoOf(TypedAbstractBindingValueImpl).a1 = function () {
    return this.f6l(_get_valueField__9y0rz6(this));
  };
  protoOf(TypedAbstractBindingValueImpl).z3d = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.qiu_1 == null)) {
      this_0.j(AbstractBindingValueConcept_getInstance().qfv_1.e6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedBindingValuePlaceholderImpl).z3d.call(this));
  };
  protoOf(TypedAbstractBindingValueImpl).p3m = function (childId) {
    return childId.equals(AbstractBindingValueConcept_getInstance().qfv_1.e6l_1) ? _get_valueField__9y0rz6(this) : protoOf(TypedBindingValuePlaceholderImpl).p3m.call(this, childId);
  };
  function TypedAbstractBindingValueQueryImpl(context, conceptId, nodeId) {
    TypedBindingValuePlaceholderQueryImpl.call(this, context, conceptId, nodeId);
  }
  function TypedAbstractLinkImpl(context, conceptId, nodeId) {
    TypedAbstractBindingEntryImpl.call(this, context, conceptId, nodeId);
    this.biw_1 = null;
    this.ciw_1 = this.z6k(AbstractLinkConcept_getInstance().zfv_1);
  }
  protoOf(TypedAbstractLinkImpl).ufp = function () {
    return this.ciw_1;
  };
  protoOf(TypedAbstractLinkImpl).c3e = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.biw_1 == null)) {
      this_0.j(AbstractLinkConcept_getInstance().zfv_1.a6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedAbstractBindingEntryImpl).c3e.call(this));
  };
  protoOf(TypedAbstractLinkImpl).v6k = function (propertyId) {
    return propertyId.equals(AbstractLinkConcept_getInstance().zfv_1.a6l_1) ? this.biw_1 : protoOf(TypedAbstractBindingEntryImpl).v6k.call(this, propertyId);
  };
  protoOf(TypedAbstractLinkImpl).w6k = function (propertyId, value) {
    if (propertyId.equals(AbstractLinkConcept_getInstance().zfv_1.a6l_1)) {
      this.biw_1 = value;
    } else {
      protoOf(TypedAbstractBindingEntryImpl).w6k.call(this, propertyId, value);
    }
  };
  function TypedAbstractNotionImpl(context, conceptId, nodeId) {
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.piw_1 = null;
  }
  protoOf(TypedAbstractNotionImpl).y2 = function () {
    return this.x6k(DirectlyNamedConcept_getInstance().chz_1);
  };
  protoOf(TypedAbstractNotionImpl).c3e = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.piw_1 == null)) {
      this_0.j(DirectlyNamedConcept_getInstance().chz_1.m6o_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedBTBNodeImpl).c3e.call(this));
  };
  protoOf(TypedAbstractNotionImpl).v6k = function (propertyId) {
    return propertyId.equals(DirectlyNamedConcept_getInstance().chz_1.m6o_1) ? this.piw_1 : protoOf(TypedBTBNodeImpl).v6k.call(this, propertyId);
  };
  protoOf(TypedAbstractNotionImpl).w6k = function (propertyId, value) {
    if (propertyId.equals(DirectlyNamedConcept_getInstance().chz_1.m6o_1)) {
      this.piw_1 = value;
    } else {
      protoOf(TypedBTBNodeImpl).w6k.call(this, propertyId, value);
    }
  };
  function TypedAbstractOntologyRelationImpl(context, conceptId, nodeId) {
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
  }
  function TypedAbstractProcessSpecificationImpl(context, conceptId, nodeId) {
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
  }
  function TypedAbstractPropertyImpl(context, conceptId, nodeId) {
    TypedAbstractBindingEntryImpl.call(this, context, conceptId, nodeId);
  }
  function TypedAuthorImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? AuthorConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(AuthorConcept_getInstance().m6n_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.cix_1 = null;
  }
  protoOf(TypedAuthorImpl).y2 = function () {
    return this.x6k(DirectlyNamedConcept_getInstance().chz_1);
  };
  protoOf(TypedAuthorImpl).c3e = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.cix_1 == null)) {
      this_0.j(DirectlyNamedConcept_getInstance().chz_1.m6o_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedBTBNodeImpl).c3e.call(this));
  };
  protoOf(TypedAuthorImpl).g3p = function (nodeId) {
    return new TypedAuthorImpl(this.j6k_1, AuthorConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedAuthorImpl).v6k = function (propertyId) {
    return propertyId.equals(DirectlyNamedConcept_getInstance().chz_1.m6o_1) ? this.cix_1 : protoOf(TypedBTBNodeImpl).v6k.call(this, propertyId);
  };
  protoOf(TypedAuthorImpl).w6k = function (propertyId, value) {
    if (propertyId.equals(DirectlyNamedConcept_getInstance().chz_1.m6o_1)) {
      this.cix_1 = value;
    } else {
      protoOf(TypedBTBNodeImpl).w6k.call(this, propertyId, value);
    }
  };
  function _get_authorsField__o0tsl5($this) {
    if ($this.pix_1 == null) {
      $this.pix_1 = $this.g6l(AuthoredWorkConcept_getInstance().mfw_1);
    }
    return ensureNotNull($this.pix_1);
  }
  function TypedAuthoredWorkImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? AuthoredWorkConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(AuthoredWorkConcept_getInstance().m6n_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.pix_1 = null;
    this.qix_1 = null;
  }
  protoOf(TypedAuthoredWorkImpl).vfp = function () {
    return this.i6l(_get_authorsField__o0tsl5(this));
  };
  protoOf(TypedAuthoredWorkImpl).wfp = function () {
    return this.x6k(AuthoredWorkConcept_getInstance().nfw_1);
  };
  protoOf(TypedAuthoredWorkImpl).c3e = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.qix_1 == null)) {
      this_0.j(AuthoredWorkConcept_getInstance().nfw_1.m6o_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedBTBNodeImpl).c3e.call(this));
  };
  protoOf(TypedAuthoredWorkImpl).z3d = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.pix_1 == null)) {
      this_0.j(AuthoredWorkConcept_getInstance().mfw_1.h6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedBTBNodeImpl).z3d.call(this));
  };
  protoOf(TypedAuthoredWorkImpl).g3p = function (nodeId) {
    return new TypedAuthoredWorkImpl(this.j6k_1, AuthoredWorkConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedAuthoredWorkImpl).v6k = function (propertyId) {
    return propertyId.equals(AuthoredWorkConcept_getInstance().nfw_1.m6o_1) ? this.qix_1 : protoOf(TypedBTBNodeImpl).v6k.call(this, propertyId);
  };
  protoOf(TypedAuthoredWorkImpl).w6k = function (propertyId, value) {
    if (propertyId.equals(AuthoredWorkConcept_getInstance().nfw_1.m6o_1)) {
      this.qix_1 = value;
    } else {
      protoOf(TypedBTBNodeImpl).w6k.call(this, propertyId, value);
    }
  };
  protoOf(TypedAuthoredWorkImpl).p3m = function (childId) {
    return childId.equals(AuthoredWorkConcept_getInstance().mfw_1.h6l_1) ? _get_authorsField__o0tsl5(this) : protoOf(TypedBTBNodeImpl).p3m.call(this, childId);
  };
  function _get_factSetsField__38hxv0($this) {
    if ($this.fiy_1 == null) {
      $this.fiy_1 = $this.g6l(BTBDocumentConcept_getInstance().bfx_1);
    }
    return ensureNotNull($this.fiy_1);
  }
  function _get_categoriesField__hhjj3h($this) {
    if ($this.giy_1 == null) {
      $this.giy_1 = $this.g6l(BTBDocumentConcept_getInstance().cfx_1);
    }
    return ensureNotNull($this.giy_1);
  }
  function _get_importsField__w7vue7($this) {
    if ($this.hiy_1 == null) {
      $this.hiy_1 = $this.g6l(BTBDocumentConcept_getInstance().dfx_1);
    }
    return ensureNotNull($this.hiy_1);
  }
  function TypedBTBDocumentImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? BTBDocumentConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(BTBDocumentConcept_getInstance().m6n_1) : nodeId;
    TypedDocumentNodeImpl.call(this, context, conceptId, nodeId);
    this.fiy_1 = null;
    this.giy_1 = null;
    this.hiy_1 = null;
  }
  protoOf(TypedBTBDocumentImpl).xfp = function () {
    return this.i6l(_get_factSetsField__38hxv0(this));
  };
  protoOf(TypedBTBDocumentImpl).yfp = function () {
    return this.i6l(_get_categoriesField__hhjj3h(this));
  };
  protoOf(TypedBTBDocumentImpl).zfp = function () {
    return this.i6l(_get_importsField__w7vue7(this));
  };
  protoOf(TypedBTBDocumentImpl).z3d = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.fiy_1 == null)) {
      this_0.j(BTBDocumentConcept_getInstance().bfx_1.h6l_1);
    }
    if (!(this.giy_1 == null)) {
      this_0.j(BTBDocumentConcept_getInstance().cfx_1.h6l_1);
    }
    if (!(this.hiy_1 == null)) {
      this_0.j(BTBDocumentConcept_getInstance().dfx_1.h6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedDocumentNodeImpl).z3d.call(this));
  };
  protoOf(TypedBTBDocumentImpl).g3p = function (nodeId) {
    return new TypedBTBDocumentImpl(this.j6k_1, BTBDocumentConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedBTBDocumentImpl).p3m = function (childId) {
    return childId.equals(BTBDocumentConcept_getInstance().bfx_1.h6l_1) ? _get_factSetsField__38hxv0(this) : childId.equals(BTBDocumentConcept_getInstance().cfx_1.h6l_1) ? _get_categoriesField__hhjj3h(this) : childId.equals(BTBDocumentConcept_getInstance().dfx_1.h6l_1) ? _get_importsField__w7vue7(this) : protoOf(TypedDocumentNodeImpl).p3m.call(this, childId);
  };
  function _get_propertyField__spxghg($this) {
    if ($this.iiz_1 == null) {
      $this.iiz_1 = $this.d6l(BindingPropertyConcept_getInstance().pfx_1);
    }
    return ensureNotNull($this.iiz_1);
  }
  function TypedBindingPropertyImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? BindingPropertyConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(BindingPropertyConcept_getInstance().m6n_1) : nodeId;
    TypedAbstractPropertyImpl.call(this, context, conceptId, nodeId);
    this.iiz_1 = null;
  }
  protoOf(TypedBindingPropertyImpl).q6q = function () {
    return this.f6l(_get_propertyField__spxghg(this));
  };
  protoOf(TypedBindingPropertyImpl).z3d = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.iiz_1 == null)) {
      this_0.j(BindingPropertyConcept_getInstance().pfx_1.e6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedAbstractPropertyImpl).z3d.call(this));
  };
  protoOf(TypedBindingPropertyImpl).g3p = function (nodeId) {
    return new TypedBindingPropertyImpl(this.j6k_1, BindingPropertyConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedBindingPropertyImpl).p3m = function (childId) {
    return childId.equals(BindingPropertyConcept_getInstance().pfx_1.e6l_1) ? _get_propertyField__spxghg(this) : protoOf(TypedAbstractPropertyImpl).p3m.call(this, childId);
  };
  function _get_valueField__9y0rz6_0($this) {
    if ($this.viz_1 == null) {
      $this.viz_1 = $this.d6l(BindingValueMaskConcept_getInstance().bfy_1);
    }
    return ensureNotNull($this.viz_1);
  }
  function TypedBindingValueMaskImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? BindingValueMaskConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(BindingValueMaskConcept_getInstance().m6n_1) : nodeId;
    TypedAbstractBindingValueQueryImpl.call(this, context, conceptId, nodeId);
    this.viz_1 = null;
  }
  protoOf(TypedBindingValueMaskImpl).a1 = function () {
    return this.f6l(_get_valueField__9y0rz6_0(this));
  };
  protoOf(TypedBindingValueMaskImpl).z3d = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.viz_1 == null)) {
      this_0.j(BindingValueMaskConcept_getInstance().bfy_1.e6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedAbstractBindingValueQueryImpl).z3d.call(this));
  };
  protoOf(TypedBindingValueMaskImpl).g3p = function (nodeId) {
    return new TypedBindingValueMaskImpl(this.j6k_1, BindingValueMaskConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedBindingValueMaskImpl).p3m = function (childId) {
    return childId.equals(BindingValueMaskConcept_getInstance().bfy_1.e6l_1) ? _get_valueField__9y0rz6_0(this) : protoOf(TypedAbstractBindingValueQueryImpl).p3m.call(this, childId);
  };
  function TypedBindingValuePlaceholderImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? BindingValuePlaceholderConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(BindingValuePlaceholderConcept_getInstance().m6n_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
  }
  protoOf(TypedBindingValuePlaceholderImpl).g3p = function (nodeId) {
    return new TypedBindingValuePlaceholderImpl(this.j6k_1, BindingValuePlaceholderConcept_getInstance().m6n_1, nodeId);
  };
  function TypedBindingValuePlaceholderQueryImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? BindingValuePlaceholderQueryConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(BindingValuePlaceholderQueryConcept_getInstance().m6n_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
  }
  protoOf(TypedBindingValuePlaceholderQueryImpl).g3p = function (nodeId) {
    return new TypedBindingValuePlaceholderQueryImpl(this.j6k_1, BindingValuePlaceholderQueryConcept_getInstance().m6n_1, nodeId);
  };
  function TypedBookImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? BookConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(BookConcept_getInstance().m6n_1) : nodeId;
    TypedPublishedWorkImpl.call(this, context, conceptId, nodeId);
    this.nj0_1 = null;
  }
  protoOf(TypedBookImpl).afq = function () {
    return this.x6k(BookConcept_getInstance().nfy_1);
  };
  protoOf(TypedBookImpl).c3e = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.nj0_1 == null)) {
      this_0.j(BookConcept_getInstance().nfy_1.m6o_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedPublishedWorkImpl).c3e.call(this));
  };
  protoOf(TypedBookImpl).g3p = function (nodeId) {
    return new TypedBookImpl(this.j6k_1, BookConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedBookImpl).v6k = function (propertyId) {
    return propertyId.equals(BookConcept_getInstance().nfy_1.m6o_1) ? this.nj0_1 : protoOf(TypedPublishedWorkImpl).v6k.call(this, propertyId);
  };
  protoOf(TypedBookImpl).w6k = function (propertyId, value) {
    if (propertyId.equals(BookConcept_getInstance().nfy_1.m6o_1)) {
      this.nj0_1 = value;
    } else {
      protoOf(TypedPublishedWorkImpl).w6k.call(this, propertyId, value);
    }
  };
  function TypedCardinalityBoundConstantImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? CardinalityBoundConstantConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(CardinalityBoundConstantConcept_getInstance().m6n_1) : nodeId;
    TypedCardinalityBoundImpl.call(this, context, conceptId, nodeId);
    this.rj1_1 = null;
  }
  protoOf(TypedCardinalityBoundConstantImpl).a1 = function () {
    return this.x6k(CardinalityBoundConstantConcept_getInstance().zfy_1);
  };
  protoOf(TypedCardinalityBoundConstantImpl).c3e = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.rj1_1 == null)) {
      this_0.j(CardinalityBoundConstantConcept_getInstance().zfy_1.m6o_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedCardinalityBoundImpl).c3e.call(this));
  };
  protoOf(TypedCardinalityBoundConstantImpl).g3p = function (nodeId) {
    return new TypedCardinalityBoundConstantImpl(this.j6k_1, CardinalityBoundConstantConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedCardinalityBoundConstantImpl).v6k = function (propertyId) {
    return propertyId.equals(CardinalityBoundConstantConcept_getInstance().zfy_1.m6o_1) ? this.rj1_1 : protoOf(TypedCardinalityBoundImpl).v6k.call(this, propertyId);
  };
  protoOf(TypedCardinalityBoundConstantImpl).w6k = function (propertyId, value) {
    if (propertyId.equals(CardinalityBoundConstantConcept_getInstance().zfy_1.m6o_1)) {
      this.rj1_1 = value;
    } else {
      protoOf(TypedCardinalityBoundImpl).w6k.call(this, propertyId, value);
    }
  };
  function TypedCardinalityBoundImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? CardinalityBoundConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(CardinalityBoundConcept_getInstance().m6n_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
  }
  protoOf(TypedCardinalityBoundImpl).g3p = function (nodeId) {
    return new TypedCardinalityBoundImpl(this.j6k_1, CardinalityBoundConcept_getInstance().m6n_1, nodeId);
  };
  function TypedCardinalityBoundNImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? CardinalityBoundNConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(CardinalityBoundNConcept_getInstance().m6n_1) : nodeId;
    TypedCardinalityBoundImpl.call(this, context, conceptId, nodeId);
  }
  protoOf(TypedCardinalityBoundNImpl).g3p = function (nodeId) {
    return new TypedCardinalityBoundNImpl(this.j6k_1, CardinalityBoundNConcept_getInstance().m6n_1, nodeId);
  };
  function _get_boundField__2bbh0v($this) {
    if ($this.cj3_1 == null) {
      $this.cj3_1 = $this.d6l(CardinalityBoundPlaceholderConcept_getInstance().lfz_1);
    }
    return ensureNotNull($this.cj3_1);
  }
  function TypedCardinalityBoundPlaceholderImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? CardinalityBoundPlaceholderConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(CardinalityBoundPlaceholderConcept_getInstance().m6n_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.cj3_1 = null;
  }
  protoOf(TypedCardinalityBoundPlaceholderImpl).efq = function () {
    return this.f6l(_get_boundField__2bbh0v(this));
  };
  protoOf(TypedCardinalityBoundPlaceholderImpl).z3d = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.cj3_1 == null)) {
      this_0.j(CardinalityBoundPlaceholderConcept_getInstance().lfz_1.e6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedBTBNodeImpl).z3d.call(this));
  };
  protoOf(TypedCardinalityBoundPlaceholderImpl).g3p = function (nodeId) {
    return new TypedCardinalityBoundPlaceholderImpl(this.j6k_1, CardinalityBoundPlaceholderConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedCardinalityBoundPlaceholderImpl).p3m = function (childId) {
    return childId.equals(CardinalityBoundPlaceholderConcept_getInstance().lfz_1.e6l_1) ? _get_boundField__2bbh0v(this) : protoOf(TypedBTBNodeImpl).p3m.call(this, childId);
  };
  function TypedCardinalityCustomCellImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? CardinalityCustomCellConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(CardinalityCustomCellConcept_getInstance().m6n_1) : nodeId;
    TypedCustomCellImpl.call(this, context, conceptId, nodeId);
  }
  protoOf(TypedCardinalityCustomCellImpl).g3p = function (nodeId) {
    return new TypedCardinalityCustomCellImpl(this.j6k_1, CardinalityCustomCellConcept_getInstance().m6n_1, nodeId);
  };
  function _get_lowerBoundField__30y1f8($this) {
    if ($this.bj4_1 == null) {
      $this.bj4_1 = $this.d6l(CardinalityConcept_getInstance().zfz_1);
    }
    return ensureNotNull($this.bj4_1);
  }
  function _get_upperBoundField__ahukc3($this) {
    if ($this.cj4_1 == null) {
      $this.cj4_1 = $this.d6l(CardinalityConcept_getInstance().ag0_1);
    }
    return ensureNotNull($this.cj4_1);
  }
  function _get_deprecatedUpperBoundField__ezod52($this) {
    if ($this.dj4_1 == null) {
      $this.dj4_1 = $this.d6l(CardinalityConcept_getInstance().bg0_1);
    }
    return ensureNotNull($this.dj4_1);
  }
  function TypedCardinalityImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? CardinalityConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(CardinalityConcept_getInstance().m6n_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.bj4_1 = null;
    this.cj4_1 = null;
    this.dj4_1 = null;
  }
  protoOf(TypedCardinalityImpl).bfq = function () {
    return this.f6l(_get_lowerBoundField__30y1f8(this));
  };
  protoOf(TypedCardinalityImpl).cfq = function () {
    return this.f6l(_get_upperBoundField__ahukc3(this));
  };
  protoOf(TypedCardinalityImpl).dfq = function () {
    return this.f6l(_get_deprecatedUpperBoundField__ezod52(this));
  };
  protoOf(TypedCardinalityImpl).z3d = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.bj4_1 == null)) {
      this_0.j(CardinalityConcept_getInstance().zfz_1.e6l_1);
    }
    if (!(this.cj4_1 == null)) {
      this_0.j(CardinalityConcept_getInstance().ag0_1.e6l_1);
    }
    if (!(this.dj4_1 == null)) {
      this_0.j(CardinalityConcept_getInstance().bg0_1.e6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedBTBNodeImpl).z3d.call(this));
  };
  protoOf(TypedCardinalityImpl).g3p = function (nodeId) {
    return new TypedCardinalityImpl(this.j6k_1, CardinalityConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedCardinalityImpl).p3m = function (childId) {
    return childId.equals(CardinalityConcept_getInstance().zfz_1.e6l_1) ? _get_lowerBoundField__30y1f8(this) : childId.equals(CardinalityConcept_getInstance().ag0_1.e6l_1) ? _get_upperBoundField__ahukc3(this) : childId.equals(CardinalityConcept_getInstance().bg0_1.e6l_1) ? _get_deprecatedUpperBoundField__ezod52(this) : protoOf(TypedBTBNodeImpl).p3m.call(this, childId);
  };
  function _get_libraryField__um0bho($this) {
    if ($this.qj4_1 == null) {
      $this.qj4_1 = $this.d6l(CategoryConcept_getInstance().og0_1);
    }
    return ensureNotNull($this.qj4_1);
  }
  function _get_elementField__q1p5qr($this) {
    if ($this.rj4_1 == null) {
      $this.rj4_1 = $this.d6l(CategoryConcept_getInstance().pg0_1);
    }
    return ensureNotNull($this.rj4_1);
  }
  function TypedCategoryImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? CategoryConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(CategoryConcept_getInstance().m6n_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.qj4_1 = null;
    this.rj4_1 = null;
  }
  protoOf(TypedCategoryImpl).ffq = function () {
    return this.f6l(_get_libraryField__um0bho(this));
  };
  protoOf(TypedCategoryImpl).gfq = function () {
    return this.f6l(_get_elementField__q1p5qr(this));
  };
  protoOf(TypedCategoryImpl).z3d = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.qj4_1 == null)) {
      this_0.j(CategoryConcept_getInstance().og0_1.e6l_1);
    }
    if (!(this.rj4_1 == null)) {
      this_0.j(CategoryConcept_getInstance().pg0_1.e6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedBTBNodeImpl).z3d.call(this));
  };
  protoOf(TypedCategoryImpl).g3p = function (nodeId) {
    return new TypedCategoryImpl(this.j6k_1, CategoryConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedCategoryImpl).p3m = function (childId) {
    return childId.equals(CategoryConcept_getInstance().og0_1.e6l_1) ? _get_libraryField__um0bho(this) : childId.equals(CategoryConcept_getInstance().pg0_1.e6l_1) ? _get_elementField__q1p5qr(this) : protoOf(TypedBTBNodeImpl).p3m.call(this, childId);
  };
  function TypedClassExpressionPlaceholderImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? ClassExpressionPlaceholderConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ClassExpressionPlaceholderConcept_getInstance().m6n_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
  }
  protoOf(TypedClassExpressionPlaceholderImpl).g3p = function (nodeId) {
    return new TypedClassExpressionPlaceholderImpl(this.j6k_1, ClassExpressionPlaceholderConcept_getInstance().m6n_1, nodeId);
  };
  function _get_classExpressionField__3dueap($this) {
    if ($this.qj5_1 == null) {
      $this.qj5_1 = $this.d6l(ClassExpressionTypeConcept_getInstance().bg1_1);
    }
    return ensureNotNull($this.qj5_1);
  }
  function TypedClassExpressionTypeImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? ClassExpressionTypeConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ClassExpressionTypeConcept_getInstance().m6n_1) : nodeId;
    TypedTypeImpl.call(this, context, conceptId, nodeId);
    this.qj5_1 = null;
  }
  protoOf(TypedClassExpressionTypeImpl).hfq = function () {
    return this.f6l(_get_classExpressionField__3dueap(this));
  };
  protoOf(TypedClassExpressionTypeImpl).z3d = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.qj5_1 == null)) {
      this_0.j(ClassExpressionTypeConcept_getInstance().bg1_1.e6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedTypeImpl).z3d.call(this));
  };
  protoOf(TypedClassExpressionTypeImpl).g3p = function (nodeId) {
    return new TypedClassExpressionTypeImpl(this.j6k_1, ClassExpressionTypeConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedClassExpressionTypeImpl).p3m = function (childId) {
    return childId.equals(ClassExpressionTypeConcept_getInstance().bg1_1.e6l_1) ? _get_classExpressionField__3dueap(this) : protoOf(TypedTypeImpl).p3m.call(this, childId);
  };
  function TypedCommandImpl(context, conceptId, nodeId) {
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
  }
  function _get_elementTypeField__i197uv($this) {
    if ($this.dj6_1 == null) {
      $this.dj6_1 = $this.d6l(ComplexNotionElementConcept_getInstance().cg2_1);
    }
    return ensureNotNull($this.dj6_1);
  }
  function TypedComplexNotionElementImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? ComplexNotionElementConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ComplexNotionElementConcept_getInstance().m6n_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.dj6_1 = null;
    this.ej6_1 = null;
    this.fj6_1 = null;
  }
  protoOf(TypedComplexNotionElementImpl).kfq = function () {
    return this.f6l(_get_elementTypeField__i197uv(this));
  };
  protoOf(TypedComplexNotionElementImpl).lfq = function () {
    return this.x6k(ComplexNotionElementConcept_getInstance().dg2_1);
  };
  protoOf(TypedComplexNotionElementImpl).y2 = function () {
    return this.x6k(DirectlyNamedConcept_getInstance().chz_1);
  };
  protoOf(TypedComplexNotionElementImpl).c3e = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.ej6_1 == null)) {
      this_0.j(ComplexNotionElementConcept_getInstance().dg2_1.m6o_1);
    }
    if (!(this.fj6_1 == null)) {
      this_0.j(DirectlyNamedConcept_getInstance().chz_1.m6o_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedBTBNodeImpl).c3e.call(this));
  };
  protoOf(TypedComplexNotionElementImpl).z3d = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.dj6_1 == null)) {
      this_0.j(ComplexNotionElementConcept_getInstance().cg2_1.e6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedBTBNodeImpl).z3d.call(this));
  };
  protoOf(TypedComplexNotionElementImpl).g3p = function (nodeId) {
    return new TypedComplexNotionElementImpl(this.j6k_1, ComplexNotionElementConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedComplexNotionElementImpl).v6k = function (propertyId) {
    return propertyId.equals(ComplexNotionElementConcept_getInstance().dg2_1.m6o_1) ? this.ej6_1 : propertyId.equals(DirectlyNamedConcept_getInstance().chz_1.m6o_1) ? this.fj6_1 : protoOf(TypedBTBNodeImpl).v6k.call(this, propertyId);
  };
  protoOf(TypedComplexNotionElementImpl).w6k = function (propertyId, value) {
    if (propertyId.equals(ComplexNotionElementConcept_getInstance().dg2_1.m6o_1)) {
      this.ej6_1 = value;
    } else if (propertyId.equals(DirectlyNamedConcept_getInstance().chz_1.m6o_1)) {
      this.fj6_1 = value;
    } else {
      protoOf(TypedBTBNodeImpl).w6k.call(this, propertyId, value);
    }
  };
  protoOf(TypedComplexNotionElementImpl).p3m = function (childId) {
    return childId.equals(ComplexNotionElementConcept_getInstance().cg2_1.e6l_1) ? _get_elementTypeField__i197uv(this) : protoOf(TypedBTBNodeImpl).p3m.call(this, childId);
  };
  function _get_valueField__9y0rz6_1($this) {
    if ($this.uj6_1 == null) {
      $this.uj6_1 = $this.d6l(ComplexNotionElementValueConcept_getInstance().sg2_1);
    }
    return ensureNotNull($this.uj6_1);
  }
  function TypedComplexNotionElementValueImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? ComplexNotionElementValueConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ComplexNotionElementValueConcept_getInstance().m6n_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.sj6_1 = null;
    this.tj6_1 = this.z6k(ComplexNotionElementValueConcept_getInstance().rg2_1);
    this.uj6_1 = null;
  }
  protoOf(TypedComplexNotionElementValueImpl).gfq = function () {
    return this.tj6_1;
  };
  protoOf(TypedComplexNotionElementValueImpl).a1 = function () {
    return this.f6l(_get_valueField__9y0rz6_1(this));
  };
  protoOf(TypedComplexNotionElementValueImpl).c3e = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.sj6_1 == null)) {
      this_0.j(ComplexNotionElementValueConcept_getInstance().rg2_1.a6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedBTBNodeImpl).c3e.call(this));
  };
  protoOf(TypedComplexNotionElementValueImpl).z3d = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.uj6_1 == null)) {
      this_0.j(ComplexNotionElementValueConcept_getInstance().sg2_1.e6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedBTBNodeImpl).z3d.call(this));
  };
  protoOf(TypedComplexNotionElementValueImpl).g3p = function (nodeId) {
    return new TypedComplexNotionElementValueImpl(this.j6k_1, ComplexNotionElementValueConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedComplexNotionElementValueImpl).v6k = function (propertyId) {
    return propertyId.equals(ComplexNotionElementValueConcept_getInstance().rg2_1.a6l_1) ? this.sj6_1 : protoOf(TypedBTBNodeImpl).v6k.call(this, propertyId);
  };
  protoOf(TypedComplexNotionElementValueImpl).w6k = function (propertyId, value) {
    if (propertyId.equals(ComplexNotionElementValueConcept_getInstance().rg2_1.a6l_1)) {
      this.sj6_1 = value;
    } else {
      protoOf(TypedBTBNodeImpl).w6k.call(this, propertyId, value);
    }
  };
  protoOf(TypedComplexNotionElementValueImpl).p3m = function (childId) {
    return childId.equals(ComplexNotionElementValueConcept_getInstance().sg2_1.e6l_1) ? _get_valueField__9y0rz6_1(this) : protoOf(TypedBTBNodeImpl).p3m.call(this, childId);
  };
  function _get_elementsField__lf2xhu($this) {
    if ($this.ij7_1 == null) {
      $this.ij7_1 = $this.g6l(ComplexNotionConcept_getInstance().og1_1);
    }
    return ensureNotNull($this.ij7_1);
  }
  function _get_templateField__ol374f($this) {
    if ($this.jj7_1 == null) {
      $this.jj7_1 = $this.d6l(ComplexNotionConcept_getInstance().pg1_1);
    }
    return ensureNotNull($this.jj7_1);
  }
  function TypedComplexNotionImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? ComplexNotionConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ComplexNotionConcept_getInstance().m6n_1) : nodeId;
    TypedAbstractNotionImpl.call(this, context, conceptId, nodeId);
    this.ij7_1 = null;
    this.jj7_1 = null;
  }
  protoOf(TypedComplexNotionImpl).ifq = function () {
    return this.i6l(_get_elementsField__lf2xhu(this));
  };
  protoOf(TypedComplexNotionImpl).jfq = function () {
    return this.f6l(_get_templateField__ol374f(this));
  };
  protoOf(TypedComplexNotionImpl).z3d = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.ij7_1 == null)) {
      this_0.j(ComplexNotionConcept_getInstance().og1_1.h6l_1);
    }
    if (!(this.jj7_1 == null)) {
      this_0.j(ComplexNotionConcept_getInstance().pg1_1.e6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedAbstractNotionImpl).z3d.call(this));
  };
  protoOf(TypedComplexNotionImpl).g3p = function (nodeId) {
    return new TypedComplexNotionImpl(this.j6k_1, ComplexNotionConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedComplexNotionImpl).p3m = function (childId) {
    return childId.equals(ComplexNotionConcept_getInstance().og1_1.h6l_1) ? _get_elementsField__lf2xhu(this) : childId.equals(ComplexNotionConcept_getInstance().pg1_1.e6l_1) ? _get_templateField__ol374f(this) : protoOf(TypedAbstractNotionImpl).p3m.call(this, childId);
  };
  function TypedComplexNotionTemplateElementImpl(context, conceptId, nodeId) {
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
  }
  function _get_elementsField__lf2xhu_0($this) {
    if ($this.wj7_1 == null) {
      $this.wj7_1 = $this.g6l(ComplexNotionTemplateConcept_getInstance().eg3_1);
    }
    return ensureNotNull($this.wj7_1);
  }
  function TypedComplexNotionTemplateImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? ComplexNotionTemplateConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ComplexNotionTemplateConcept_getInstance().m6n_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.wj7_1 = null;
  }
  protoOf(TypedComplexNotionTemplateImpl).ifq = function () {
    return this.i6l(_get_elementsField__lf2xhu_0(this));
  };
  protoOf(TypedComplexNotionTemplateImpl).z3d = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.wj7_1 == null)) {
      this_0.j(ComplexNotionTemplateConcept_getInstance().eg3_1.h6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedBTBNodeImpl).z3d.call(this));
  };
  protoOf(TypedComplexNotionTemplateImpl).g3p = function (nodeId) {
    return new TypedComplexNotionTemplateImpl(this.j6k_1, ComplexNotionTemplateConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedComplexNotionTemplateImpl).p3m = function (childId) {
    return childId.equals(ComplexNotionTemplateConcept_getInstance().eg3_1.h6l_1) ? _get_elementsField__lf2xhu_0(this) : protoOf(TypedBTBNodeImpl).p3m.call(this, childId);
  };
  function TypedComplexNotionTemplatePlaceholderImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? ComplexNotionTemplatePlaceholderConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ComplexNotionTemplatePlaceholderConcept_getInstance().m6n_1) : nodeId;
    TypedComplexNotionTemplateElementImpl.call(this, context, conceptId, nodeId);
  }
  protoOf(TypedComplexNotionTemplatePlaceholderImpl).g3p = function (nodeId) {
    return new TypedComplexNotionTemplatePlaceholderImpl(this.j6k_1, ComplexNotionTemplatePlaceholderConcept_getInstance().m6n_1, nodeId);
  };
  function TypedComplexNotionTemplateRefElementImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? ComplexNotionTemplateRefElementConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ComplexNotionTemplateRefElementConcept_getInstance().m6n_1) : nodeId;
    TypedComplexNotionTemplateElementImpl.call(this, context, conceptId, nodeId);
    this.vj8_1 = null;
    this.wj8_1 = this.z6k(ComplexNotionTemplateRefElementConcept_getInstance().rg3_1);
  }
  protoOf(TypedComplexNotionTemplateRefElementImpl).gfq = function () {
    return this.wj8_1;
  };
  protoOf(TypedComplexNotionTemplateRefElementImpl).c3e = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.vj8_1 == null)) {
      this_0.j(ComplexNotionTemplateRefElementConcept_getInstance().rg3_1.a6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedComplexNotionTemplateElementImpl).c3e.call(this));
  };
  protoOf(TypedComplexNotionTemplateRefElementImpl).g3p = function (nodeId) {
    return new TypedComplexNotionTemplateRefElementImpl(this.j6k_1, ComplexNotionTemplateRefElementConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedComplexNotionTemplateRefElementImpl).v6k = function (propertyId) {
    return propertyId.equals(ComplexNotionTemplateRefElementConcept_getInstance().rg3_1.a6l_1) ? this.vj8_1 : protoOf(TypedComplexNotionTemplateElementImpl).v6k.call(this, propertyId);
  };
  protoOf(TypedComplexNotionTemplateRefElementImpl).w6k = function (propertyId, value) {
    if (propertyId.equals(ComplexNotionTemplateRefElementConcept_getInstance().rg3_1.a6l_1)) {
      this.vj8_1 = value;
    } else {
      protoOf(TypedComplexNotionTemplateElementImpl).w6k.call(this, propertyId, value);
    }
  };
  function TypedComplexNotionTemplateTextElementImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? ComplexNotionTemplateTextElementConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ComplexNotionTemplateTextElementConcept_getInstance().m6n_1) : nodeId;
    TypedComplexNotionTemplateElementImpl.call(this, context, conceptId, nodeId);
    this.jj9_1 = null;
  }
  protoOf(TypedComplexNotionTemplateTextElementImpl).o8w = function () {
    return this.x6k(ComplexNotionTemplateTextElementConcept_getInstance().dg4_1);
  };
  protoOf(TypedComplexNotionTemplateTextElementImpl).c3e = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.jj9_1 == null)) {
      this_0.j(ComplexNotionTemplateTextElementConcept_getInstance().dg4_1.m6o_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedComplexNotionTemplateElementImpl).c3e.call(this));
  };
  protoOf(TypedComplexNotionTemplateTextElementImpl).g3p = function (nodeId) {
    return new TypedComplexNotionTemplateTextElementImpl(this.j6k_1, ComplexNotionTemplateTextElementConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedComplexNotionTemplateTextElementImpl).v6k = function (propertyId) {
    return propertyId.equals(ComplexNotionTemplateTextElementConcept_getInstance().dg4_1.m6o_1) ? this.jj9_1 : protoOf(TypedComplexNotionTemplateElementImpl).v6k.call(this, propertyId);
  };
  protoOf(TypedComplexNotionTemplateTextElementImpl).w6k = function (propertyId, value) {
    if (propertyId.equals(ComplexNotionTemplateTextElementConcept_getInstance().dg4_1.m6o_1)) {
      this.jj9_1 = value;
    } else {
      protoOf(TypedComplexNotionTemplateElementImpl).w6k.call(this, propertyId, value);
    }
  };
  function _get_elementValuesField__rlis1($this) {
    if ($this.yj9_1 == null) {
      $this.yj9_1 = $this.g6l(ComplexNotionValueConcept_getInstance().sg4_1);
    }
    return ensureNotNull($this.yj9_1);
  }
  function TypedComplexNotionValueImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? ComplexNotionValueConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ComplexNotionValueConcept_getInstance().m6n_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.wj9_1 = null;
    this.xj9_1 = this.z6k(ComplexNotionValueConcept_getInstance().rg4_1);
    this.yj9_1 = null;
  }
  protoOf(TypedComplexNotionValueImpl).mfq = function () {
    return this.xj9_1;
  };
  protoOf(TypedComplexNotionValueImpl).nfq = function () {
    return this.i6l(_get_elementValuesField__rlis1(this));
  };
  protoOf(TypedComplexNotionValueImpl).c3e = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.wj9_1 == null)) {
      this_0.j(ComplexNotionValueConcept_getInstance().rg4_1.a6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedBTBNodeImpl).c3e.call(this));
  };
  protoOf(TypedComplexNotionValueImpl).z3d = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.yj9_1 == null)) {
      this_0.j(ComplexNotionValueConcept_getInstance().sg4_1.h6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedBTBNodeImpl).z3d.call(this));
  };
  protoOf(TypedComplexNotionValueImpl).g3p = function (nodeId) {
    return new TypedComplexNotionValueImpl(this.j6k_1, ComplexNotionValueConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedComplexNotionValueImpl).v6k = function (propertyId) {
    return propertyId.equals(ComplexNotionValueConcept_getInstance().rg4_1.a6l_1) ? this.wj9_1 : protoOf(TypedBTBNodeImpl).v6k.call(this, propertyId);
  };
  protoOf(TypedComplexNotionValueImpl).w6k = function (propertyId, value) {
    if (propertyId.equals(ComplexNotionValueConcept_getInstance().rg4_1.a6l_1)) {
      this.wj9_1 = value;
    } else {
      protoOf(TypedBTBNodeImpl).w6k.call(this, propertyId, value);
    }
  };
  protoOf(TypedComplexNotionValueImpl).p3m = function (childId) {
    return childId.equals(ComplexNotionValueConcept_getInstance().sg4_1.h6l_1) ? _get_elementValuesField__rlis1(this) : protoOf(TypedBTBNodeImpl).p3m.call(this, childId);
  };
  function TypedConstantCustomCellImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? ConstantCustomCellConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ConstantCustomCellConcept_getInstance().m6n_1) : nodeId;
    TypedCustomCellImpl.call(this, context, conceptId, nodeId);
    this.lja_1 = null;
  }
  protoOf(TypedConstantCustomCellImpl).o8w = function () {
    return this.x6k(ConstantCustomCellConcept_getInstance().eg5_1);
  };
  protoOf(TypedConstantCustomCellImpl).c3e = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.lja_1 == null)) {
      this_0.j(ConstantCustomCellConcept_getInstance().eg5_1.m6o_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedCustomCellImpl).c3e.call(this));
  };
  protoOf(TypedConstantCustomCellImpl).g3p = function (nodeId) {
    return new TypedConstantCustomCellImpl(this.j6k_1, ConstantCustomCellConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedConstantCustomCellImpl).v6k = function (propertyId) {
    return propertyId.equals(ConstantCustomCellConcept_getInstance().eg5_1.m6o_1) ? this.lja_1 : protoOf(TypedCustomCellImpl).v6k.call(this, propertyId);
  };
  protoOf(TypedConstantCustomCellImpl).w6k = function (propertyId, value) {
    if (propertyId.equals(ConstantCustomCellConcept_getInstance().eg5_1.m6o_1)) {
      this.lja_1 = value;
    } else {
      protoOf(TypedCustomCellImpl).w6k.call(this, propertyId, value);
    }
  };
  function TypedConstantPreconditionImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? ConstantPreconditionConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ConstantPreconditionConcept_getInstance().m6n_1) : nodeId;
    TypedPreconditionImpl.call(this, context, conceptId, nodeId);
    this.yja_1 = null;
  }
  protoOf(TypedConstantPreconditionImpl).r5a = function () {
    return this.x6k(ConstantPreconditionConcept_getInstance().sg5_1);
  };
  protoOf(TypedConstantPreconditionImpl).c3e = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.yja_1 == null)) {
      this_0.j(ConstantPreconditionConcept_getInstance().sg5_1.m6o_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedPreconditionImpl).c3e.call(this));
  };
  protoOf(TypedConstantPreconditionImpl).g3p = function (nodeId) {
    return new TypedConstantPreconditionImpl(this.j6k_1, ConstantPreconditionConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedConstantPreconditionImpl).v6k = function (propertyId) {
    return propertyId.equals(ConstantPreconditionConcept_getInstance().sg5_1.m6o_1) ? this.yja_1 : protoOf(TypedPreconditionImpl).v6k.call(this, propertyId);
  };
  protoOf(TypedConstantPreconditionImpl).w6k = function (propertyId, value) {
    if (propertyId.equals(ConstantPreconditionConcept_getInstance().sg5_1.m6o_1)) {
      this.yja_1 = value;
    } else {
      protoOf(TypedPreconditionImpl).w6k.call(this, propertyId, value);
    }
  };
  function _get_libraryField__um0bho_0($this) {
    if ($this.ljb_1 == null) {
      $this.ljb_1 = $this.d6l(ContextConcept_getInstance().fg6_1);
    }
    return ensureNotNull($this.ljb_1);
  }
  function _get_elementField__q1p5qr_0($this) {
    if ($this.mjb_1 == null) {
      $this.mjb_1 = $this.d6l(ContextConcept_getInstance().gg6_1);
    }
    return ensureNotNull($this.mjb_1);
  }
  function TypedContextImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? ContextConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ContextConcept_getInstance().m6n_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.ljb_1 = null;
    this.mjb_1 = null;
    this.njb_1 = null;
  }
  protoOf(TypedContextImpl).ffq = function () {
    return this.f6l(_get_libraryField__um0bho_0(this));
  };
  protoOf(TypedContextImpl).gfq = function () {
    return this.f6l(_get_elementField__q1p5qr_0(this));
  };
  protoOf(TypedContextImpl).y2 = function () {
    return this.x6k(DirectlyNamedConcept_getInstance().chz_1);
  };
  protoOf(TypedContextImpl).c3e = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.njb_1 == null)) {
      this_0.j(DirectlyNamedConcept_getInstance().chz_1.m6o_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedBTBNodeImpl).c3e.call(this));
  };
  protoOf(TypedContextImpl).z3d = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.ljb_1 == null)) {
      this_0.j(ContextConcept_getInstance().fg6_1.e6l_1);
    }
    if (!(this.mjb_1 == null)) {
      this_0.j(ContextConcept_getInstance().gg6_1.e6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedBTBNodeImpl).z3d.call(this));
  };
  protoOf(TypedContextImpl).g3p = function (nodeId) {
    return new TypedContextImpl(this.j6k_1, ContextConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedContextImpl).v6k = function (propertyId) {
    return propertyId.equals(DirectlyNamedConcept_getInstance().chz_1.m6o_1) ? this.njb_1 : protoOf(TypedBTBNodeImpl).v6k.call(this, propertyId);
  };
  protoOf(TypedContextImpl).w6k = function (propertyId, value) {
    if (propertyId.equals(DirectlyNamedConcept_getInstance().chz_1.m6o_1)) {
      this.njb_1 = value;
    } else {
      protoOf(TypedBTBNodeImpl).w6k.call(this, propertyId, value);
    }
  };
  protoOf(TypedContextImpl).p3m = function (childId) {
    return childId.equals(ContextConcept_getInstance().fg6_1.e6l_1) ? _get_libraryField__um0bho_0(this) : childId.equals(ContextConcept_getInstance().gg6_1.e6l_1) ? _get_elementField__q1p5qr_0(this) : protoOf(TypedBTBNodeImpl).p3m.call(this, childId);
  };
  function _get_libraryField__um0bho_1($this) {
    if ($this.ajc_1 == null) {
      $this.ajc_1 = $this.d6l(ContextQueryConcept_getInstance().tg6_1);
    }
    return ensureNotNull($this.ajc_1);
  }
  function _get_elementField__q1p5qr_1($this) {
    if ($this.bjc_1 == null) {
      $this.bjc_1 = $this.d6l(ContextQueryConcept_getInstance().ug6_1);
    }
    return ensureNotNull($this.bjc_1);
  }
  function TypedContextQueryImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? ContextQueryConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ContextQueryConcept_getInstance().m6n_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.ajc_1 = null;
    this.bjc_1 = null;
  }
  protoOf(TypedContextQueryImpl).ffq = function () {
    return this.f6l(_get_libraryField__um0bho_1(this));
  };
  protoOf(TypedContextQueryImpl).gfq = function () {
    return this.f6l(_get_elementField__q1p5qr_1(this));
  };
  protoOf(TypedContextQueryImpl).z3d = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.ajc_1 == null)) {
      this_0.j(ContextQueryConcept_getInstance().tg6_1.e6l_1);
    }
    if (!(this.bjc_1 == null)) {
      this_0.j(ContextQueryConcept_getInstance().ug6_1.e6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedBTBNodeImpl).z3d.call(this));
  };
  protoOf(TypedContextQueryImpl).g3p = function (nodeId) {
    return new TypedContextQueryImpl(this.j6k_1, ContextQueryConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedContextQueryImpl).p3m = function (childId) {
    return childId.equals(ContextQueryConcept_getInstance().tg6_1.e6l_1) ? _get_libraryField__um0bho_1(this) : childId.equals(ContextQueryConcept_getInstance().ug6_1.e6l_1) ? _get_elementField__q1p5qr_1(this) : protoOf(TypedBTBNodeImpl).p3m.call(this, childId);
  };
  function TypedCustomCellImpl(context, conceptId, nodeId) {
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
  }
  function _get_cellsField__aghev6($this) {
    if ($this.ojc_1 == null) {
      $this.ojc_1 = $this.g6l(CustomEditorConcept_getInstance().gg7_1);
    }
    return ensureNotNull($this.ojc_1);
  }
  function TypedCustomEditorImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? CustomEditorConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(CustomEditorConcept_getInstance().m6n_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.ojc_1 = null;
  }
  protoOf(TypedCustomEditorImpl).ofq = function () {
    return this.i6l(_get_cellsField__aghev6(this));
  };
  protoOf(TypedCustomEditorImpl).z3d = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.ojc_1 == null)) {
      this_0.j(CustomEditorConcept_getInstance().gg7_1.h6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedBTBNodeImpl).z3d.call(this));
  };
  protoOf(TypedCustomEditorImpl).g3p = function (nodeId) {
    return new TypedCustomEditorImpl(this.j6k_1, CustomEditorConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedCustomEditorImpl).p3m = function (childId) {
    return childId.equals(CustomEditorConcept_getInstance().gg7_1.h6l_1) ? _get_cellsField__aghev6(this) : protoOf(TypedBTBNodeImpl).p3m.call(this, childId);
  };
  function TypedDeclarationNameCustomCellImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? DeclarationNameCustomCellConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(DeclarationNameCustomCellConcept_getInstance().m6n_1) : nodeId;
    TypedCustomCellImpl.call(this, context, conceptId, nodeId);
  }
  protoOf(TypedDeclarationNameCustomCellImpl).g3p = function (nodeId) {
    return new TypedDeclarationNameCustomCellImpl(this.j6k_1, DeclarationNameCustomCellConcept_getInstance().m6n_1, nodeId);
  };
  function _get_valueField__9y0rz6_2($this) {
    if ($this.njd_1 == null) {
      $this.njd_1 = $this.d6l(DeclarationValueQueryConcept_getInstance().sg7_1);
    }
    return ensureNotNull($this.njd_1);
  }
  function TypedDeclarationValueQueryImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? DeclarationValueQueryConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(DeclarationValueQueryConcept_getInstance().m6n_1) : nodeId;
    TypedAbstractBindingValueQueryImpl.call(this, context, conceptId, nodeId);
    this.njd_1 = null;
  }
  protoOf(TypedDeclarationValueQueryImpl).a1 = function () {
    return this.f6l(_get_valueField__9y0rz6_2(this));
  };
  protoOf(TypedDeclarationValueQueryImpl).z3d = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.njd_1 == null)) {
      this_0.j(DeclarationValueQueryConcept_getInstance().sg7_1.e6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedAbstractBindingValueQueryImpl).z3d.call(this));
  };
  protoOf(TypedDeclarationValueQueryImpl).g3p = function (nodeId) {
    return new TypedDeclarationValueQueryImpl(this.j6k_1, DeclarationValueQueryConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedDeclarationValueQueryImpl).p3m = function (childId) {
    return childId.equals(DeclarationValueQueryConcept_getInstance().sg7_1.e6l_1) ? _get_valueField__9y0rz6_2(this) : protoOf(TypedAbstractBindingValueQueryImpl).p3m.call(this, childId);
  };
  function TypedDocumentNodeImpl(context, conceptId, nodeId) {
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.uiy_1 = new DomainNodeInMemoryProperty('');
    this.viy_1 = new DomainNodeInMemoryProperty('');
  }
  protoOf(TypedDocumentNodeImpl).d6g = function () {
    return this.uiy_1;
  };
  protoOf(TypedDocumentNodeImpl).y2 = function () {
    return this.viy_1;
  };
  function TypedEmptyBindingEntryImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? EmptyBindingEntryConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(EmptyBindingEntryConcept_getInstance().m6n_1) : nodeId;
    TypedAbstractBindingEntryImpl.call(this, context, conceptId, nodeId);
  }
  protoOf(TypedEmptyBindingEntryImpl).g3p = function (nodeId) {
    return new TypedEmptyBindingEntryImpl(this.j6k_1, EmptyBindingEntryConcept_getInstance().m6n_1, nodeId);
  };
  function TypedEmptyPropertyLibraryElementImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? EmptyPropertyLibraryElementConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(EmptyPropertyLibraryElementConcept_getInstance().m6n_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
  }
  protoOf(TypedEmptyPropertyLibraryElementImpl).g3p = function (nodeId) {
    return new TypedEmptyPropertyLibraryElementImpl(this.j6k_1, EmptyPropertyLibraryElementConcept_getInstance().m6n_1, nodeId);
  };
  function TypedEnumValueImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? EnumValueConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(EnumValueConcept_getInstance().m6n_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.yje_1 = null;
    this.zje_1 = this.z6k(EnumValueConcept_getInstance().fg8_1);
  }
  protoOf(TypedEnumValueImpl).pfq = function () {
    return this.zje_1;
  };
  protoOf(TypedEnumValueImpl).c3e = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.yje_1 == null)) {
      this_0.j(EnumValueConcept_getInstance().fg8_1.a6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedBTBNodeImpl).c3e.call(this));
  };
  protoOf(TypedEnumValueImpl).g3p = function (nodeId) {
    return new TypedEnumValueImpl(this.j6k_1, EnumValueConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedEnumValueImpl).v6k = function (propertyId) {
    return propertyId.equals(EnumValueConcept_getInstance().fg8_1.a6l_1) ? this.yje_1 : protoOf(TypedBTBNodeImpl).v6k.call(this, propertyId);
  };
  protoOf(TypedEnumValueImpl).w6k = function (propertyId, value) {
    if (propertyId.equals(EnumValueConcept_getInstance().fg8_1.a6l_1)) {
      this.yje_1 = value;
    } else {
      protoOf(TypedBTBNodeImpl).w6k.call(this, propertyId, value);
    }
  };
  function _get_constantsField__xzniww($this) {
    if ($this.njf_1 == null) {
      $this.njf_1 = $this.g6l(EnumerableNotionConcept_getInstance().rg8_1);
    }
    return ensureNotNull($this.njf_1);
  }
  function TypedEnumerableNotionImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? EnumerableNotionConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(EnumerableNotionConcept_getInstance().m6n_1) : nodeId;
    TypedAbstractNotionImpl.call(this, context, conceptId, nodeId);
    this.njf_1 = null;
  }
  protoOf(TypedEnumerableNotionImpl).qfq = function () {
    return this.i6l(_get_constantsField__xzniww(this));
  };
  protoOf(TypedEnumerableNotionImpl).z3d = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.njf_1 == null)) {
      this_0.j(EnumerableNotionConcept_getInstance().rg8_1.h6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedAbstractNotionImpl).z3d.call(this));
  };
  protoOf(TypedEnumerableNotionImpl).g3p = function (nodeId) {
    return new TypedEnumerableNotionImpl(this.j6k_1, EnumerableNotionConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedEnumerableNotionImpl).p3m = function (childId) {
    return childId.equals(EnumerableNotionConcept_getInstance().rg8_1.h6l_1) ? _get_constantsField__xzniww(this) : protoOf(TypedAbstractNotionImpl).p3m.call(this, childId);
  };
  function TypedEnumerationConstantImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? EnumerationConstantConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(EnumerationConstantConcept_getInstance().m6n_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.ajg_1 = null;
  }
  protoOf(TypedEnumerationConstantImpl).y2 = function () {
    return this.x6k(DirectlyNamedConcept_getInstance().chz_1);
  };
  protoOf(TypedEnumerationConstantImpl).c3e = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.ajg_1 == null)) {
      this_0.j(DirectlyNamedConcept_getInstance().chz_1.m6o_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedBTBNodeImpl).c3e.call(this));
  };
  protoOf(TypedEnumerationConstantImpl).g3p = function (nodeId) {
    return new TypedEnumerationConstantImpl(this.j6k_1, EnumerationConstantConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedEnumerationConstantImpl).v6k = function (propertyId) {
    return propertyId.equals(DirectlyNamedConcept_getInstance().chz_1.m6o_1) ? this.ajg_1 : protoOf(TypedBTBNodeImpl).v6k.call(this, propertyId);
  };
  protoOf(TypedEnumerationConstantImpl).w6k = function (propertyId, value) {
    if (propertyId.equals(DirectlyNamedConcept_getInstance().chz_1.m6o_1)) {
      this.ajg_1 = value;
    } else {
      protoOf(TypedBTBNodeImpl).w6k.call(this, propertyId, value);
    }
  };
  function _get_fieldsField__jxfhm8($this) {
    if ($this.njg_1 == null) {
      $this.njg_1 = $this.g6l(ExtensionDeclarationConcept_getInstance().eg9_1);
    }
    return ensureNotNull($this.njg_1);
  }
  function _get_typeField__jjl181($this) {
    if ($this.ojg_1 == null) {
      $this.ojg_1 = $this.d6l(ExtensionDeclarationConcept_getInstance().fg9_1);
    }
    return ensureNotNull($this.ojg_1);
  }
  function TypedExtensionDeclarationImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? ExtensionDeclarationConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ExtensionDeclarationConcept_getInstance().m6n_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.njg_1 = null;
    this.ojg_1 = null;
    this.pjg_1 = null;
  }
  protoOf(TypedExtensionDeclarationImpl).rfq = function () {
    return this.i6l(_get_fieldsField__jxfhm8(this));
  };
  protoOf(TypedExtensionDeclarationImpl).sfq = function () {
    return this.f6l(_get_typeField__jjl181(this));
  };
  protoOf(TypedExtensionDeclarationImpl).y2 = function () {
    return this.x6k(DirectlyNamedConcept_getInstance().chz_1);
  };
  protoOf(TypedExtensionDeclarationImpl).c3e = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.pjg_1 == null)) {
      this_0.j(DirectlyNamedConcept_getInstance().chz_1.m6o_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedBTBNodeImpl).c3e.call(this));
  };
  protoOf(TypedExtensionDeclarationImpl).z3d = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.njg_1 == null)) {
      this_0.j(ExtensionDeclarationConcept_getInstance().eg9_1.h6l_1);
    }
    if (!(this.ojg_1 == null)) {
      this_0.j(ExtensionDeclarationConcept_getInstance().fg9_1.e6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedBTBNodeImpl).z3d.call(this));
  };
  protoOf(TypedExtensionDeclarationImpl).g3p = function (nodeId) {
    return new TypedExtensionDeclarationImpl(this.j6k_1, ExtensionDeclarationConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedExtensionDeclarationImpl).v6k = function (propertyId) {
    return propertyId.equals(DirectlyNamedConcept_getInstance().chz_1.m6o_1) ? this.pjg_1 : protoOf(TypedBTBNodeImpl).v6k.call(this, propertyId);
  };
  protoOf(TypedExtensionDeclarationImpl).w6k = function (propertyId, value) {
    if (propertyId.equals(DirectlyNamedConcept_getInstance().chz_1.m6o_1)) {
      this.pjg_1 = value;
    } else {
      protoOf(TypedBTBNodeImpl).w6k.call(this, propertyId, value);
    }
  };
  protoOf(TypedExtensionDeclarationImpl).p3m = function (childId) {
    return childId.equals(ExtensionDeclarationConcept_getInstance().eg9_1.h6l_1) ? _get_fieldsField__jxfhm8(this) : childId.equals(ExtensionDeclarationConcept_getInstance().fg9_1.e6l_1) ? _get_typeField__jjl181(this) : protoOf(TypedBTBNodeImpl).p3m.call(this, childId);
  };
  function TypedExtensionFieldReferenceImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? ExtensionFieldReferenceConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ExtensionFieldReferenceConcept_getInstance().m6n_1) : nodeId;
    TypedPartReferenceOperationImpl.call(this, context, conceptId, nodeId);
    this.cjh_1 = null;
    this.djh_1 = this.z6k(ExtensionFieldReferenceConcept_getInstance().sg9_1);
  }
  protoOf(TypedExtensionFieldReferenceImpl).tfq = function () {
    return this.djh_1;
  };
  protoOf(TypedExtensionFieldReferenceImpl).c3e = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.cjh_1 == null)) {
      this_0.j(ExtensionFieldReferenceConcept_getInstance().sg9_1.a6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedPartReferenceOperationImpl).c3e.call(this));
  };
  protoOf(TypedExtensionFieldReferenceImpl).g3p = function (nodeId) {
    return new TypedExtensionFieldReferenceImpl(this.j6k_1, ExtensionFieldReferenceConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedExtensionFieldReferenceImpl).v6k = function (propertyId) {
    return propertyId.equals(ExtensionFieldReferenceConcept_getInstance().sg9_1.a6l_1) ? this.cjh_1 : protoOf(TypedPartReferenceOperationImpl).v6k.call(this, propertyId);
  };
  protoOf(TypedExtensionFieldReferenceImpl).w6k = function (propertyId, value) {
    if (propertyId.equals(ExtensionFieldReferenceConcept_getInstance().sg9_1.a6l_1)) {
      this.cjh_1 = value;
    } else {
      protoOf(TypedPartReferenceOperationImpl).w6k.call(this, propertyId, value);
    }
  };
  function _get_extensionsField__nt2et1($this) {
    if ($this.sjh_1 == null) {
      $this.sjh_1 = $this.g6l(ExtensionLibraryConcept_getInstance().ega_1);
    }
    return ensureNotNull($this.sjh_1);
  }
  function TypedExtensionLibraryImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? ExtensionLibraryConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ExtensionLibraryConcept_getInstance().m6n_1) : nodeId;
    TypedDocumentNodeImpl.call(this, context, conceptId, nodeId);
    this.sjh_1 = null;
  }
  protoOf(TypedExtensionLibraryImpl).ue2 = function () {
    return this.i6l(_get_extensionsField__nt2et1(this));
  };
  protoOf(TypedExtensionLibraryImpl).z3d = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.sjh_1 == null)) {
      this_0.j(ExtensionLibraryConcept_getInstance().ega_1.h6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedDocumentNodeImpl).z3d.call(this));
  };
  protoOf(TypedExtensionLibraryImpl).g3p = function (nodeId) {
    return new TypedExtensionLibraryImpl(this.j6k_1, ExtensionLibraryConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedExtensionLibraryImpl).p3m = function (childId) {
    return childId.equals(ExtensionLibraryConcept_getInstance().ega_1.h6l_1) ? _get_extensionsField__nt2et1(this) : protoOf(TypedDocumentNodeImpl).p3m.call(this, childId);
  };
  function TypedFactExpressionPlaceholderImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? FactExpressionPlaceholderConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(FactExpressionPlaceholderConcept_getInstance().m6n_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
  }
  protoOf(TypedFactExpressionPlaceholderImpl).g3p = function (nodeId) {
    return new TypedFactExpressionPlaceholderImpl(this.j6k_1, FactExpressionPlaceholderConcept_getInstance().m6n_1, nodeId);
  };
  function _get_preconditionField__y5h65t($this) {
    if ($this.rji_1 == null) {
      $this.rji_1 = $this.d6l(FactConcept_getInstance().rga_1);
    }
    return ensureNotNull($this.rji_1);
  }
  function _get_specificationField__lszznw($this) {
    if ($this.sji_1 == null) {
      $this.sji_1 = $this.d6l(FactConcept_getInstance().sga_1);
    }
    return ensureNotNull($this.sji_1);
  }
  function TypedFactImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? FactConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(FactConcept_getInstance().m6n_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.rji_1 = null;
    this.sji_1 = null;
    this.tji_1 = null;
  }
  protoOf(TypedFactImpl).ufq = function () {
    return this.f6l(_get_preconditionField__y5h65t(this));
  };
  protoOf(TypedFactImpl).vfq = function () {
    return this.f6l(_get_specificationField__lszznw(this));
  };
  protoOf(TypedFactImpl).y2 = function () {
    return this.x6k(DirectlyNamedConcept_getInstance().chz_1);
  };
  protoOf(TypedFactImpl).c3e = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.tji_1 == null)) {
      this_0.j(DirectlyNamedConcept_getInstance().chz_1.m6o_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedBTBNodeImpl).c3e.call(this));
  };
  protoOf(TypedFactImpl).z3d = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.rji_1 == null)) {
      this_0.j(FactConcept_getInstance().rga_1.e6l_1);
    }
    if (!(this.sji_1 == null)) {
      this_0.j(FactConcept_getInstance().sga_1.e6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedBTBNodeImpl).z3d.call(this));
  };
  protoOf(TypedFactImpl).g3p = function (nodeId) {
    return new TypedFactImpl(this.j6k_1, FactConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedFactImpl).v6k = function (propertyId) {
    return propertyId.equals(DirectlyNamedConcept_getInstance().chz_1.m6o_1) ? this.tji_1 : protoOf(TypedBTBNodeImpl).v6k.call(this, propertyId);
  };
  protoOf(TypedFactImpl).w6k = function (propertyId, value) {
    if (propertyId.equals(DirectlyNamedConcept_getInstance().chz_1.m6o_1)) {
      this.tji_1 = value;
    } else {
      protoOf(TypedBTBNodeImpl).w6k.call(this, propertyId, value);
    }
  };
  protoOf(TypedFactImpl).p3m = function (childId) {
    return childId.equals(FactConcept_getInstance().rga_1.e6l_1) ? _get_preconditionField__y5h65t(this) : childId.equals(FactConcept_getInstance().sga_1.e6l_1) ? _get_specificationField__lszznw(this) : protoOf(TypedBTBNodeImpl).p3m.call(this, childId);
  };
  function _get_factsField__7q8854($this) {
    if ($this.gjj_1 == null) {
      $this.gjj_1 = $this.g6l(FactPreconditionConcept_getInstance().fgb_1);
    }
    return ensureNotNull($this.gjj_1);
  }
  function TypedFactPreconditionImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? FactPreconditionConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(FactPreconditionConcept_getInstance().m6n_1) : nodeId;
    TypedPreconditionImpl.call(this, context, conceptId, nodeId);
    this.gjj_1 = null;
    this.hjj_1 = null;
    this.ijj_1 = this.z6k(FactPreconditionConcept_getInstance().ggb_1);
  }
  protoOf(TypedFactPreconditionImpl).wfq = function () {
    return this.i6l(_get_factsField__7q8854(this));
  };
  protoOf(TypedFactPreconditionImpl).xfq = function () {
    return this.ijj_1;
  };
  protoOf(TypedFactPreconditionImpl).c3e = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.hjj_1 == null)) {
      this_0.j(FactPreconditionConcept_getInstance().ggb_1.a6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedPreconditionImpl).c3e.call(this));
  };
  protoOf(TypedFactPreconditionImpl).z3d = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.gjj_1 == null)) {
      this_0.j(FactPreconditionConcept_getInstance().fgb_1.h6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedPreconditionImpl).z3d.call(this));
  };
  protoOf(TypedFactPreconditionImpl).g3p = function (nodeId) {
    return new TypedFactPreconditionImpl(this.j6k_1, FactPreconditionConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedFactPreconditionImpl).v6k = function (propertyId) {
    return propertyId.equals(FactPreconditionConcept_getInstance().ggb_1.a6l_1) ? this.hjj_1 : protoOf(TypedPreconditionImpl).v6k.call(this, propertyId);
  };
  protoOf(TypedFactPreconditionImpl).w6k = function (propertyId, value) {
    if (propertyId.equals(FactPreconditionConcept_getInstance().ggb_1.a6l_1)) {
      this.hjj_1 = value;
    } else {
      protoOf(TypedPreconditionImpl).w6k.call(this, propertyId, value);
    }
  };
  protoOf(TypedFactPreconditionImpl).p3m = function (childId) {
    return childId.equals(FactPreconditionConcept_getInstance().fgb_1.h6l_1) ? _get_factsField__7q8854(this) : protoOf(TypedPreconditionImpl).p3m.call(this, childId);
  };
  function TypedFactReferenceImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? FactReferenceConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(FactReferenceConcept_getInstance().m6n_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.vjj_1 = null;
    this.wjj_1 = this.z6k(FactReferenceConcept_getInstance().ugb_1);
  }
  protoOf(TypedFactReferenceImpl).yfq = function () {
    return this.wjj_1;
  };
  protoOf(TypedFactReferenceImpl).c3e = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.vjj_1 == null)) {
      this_0.j(FactReferenceConcept_getInstance().ugb_1.a6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedBTBNodeImpl).c3e.call(this));
  };
  protoOf(TypedFactReferenceImpl).g3p = function (nodeId) {
    return new TypedFactReferenceImpl(this.j6k_1, FactReferenceConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedFactReferenceImpl).v6k = function (propertyId) {
    return propertyId.equals(FactReferenceConcept_getInstance().ugb_1.a6l_1) ? this.vjj_1 : protoOf(TypedBTBNodeImpl).v6k.call(this, propertyId);
  };
  protoOf(TypedFactReferenceImpl).w6k = function (propertyId, value) {
    if (propertyId.equals(FactReferenceConcept_getInstance().ugb_1.a6l_1)) {
      this.vjj_1 = value;
    } else {
      protoOf(TypedBTBNodeImpl).w6k.call(this, propertyId, value);
    }
  };
  function _get_factsContextField__2692qp($this) {
    if ($this.kjk_1 == null) {
      $this.kjk_1 = $this.d6l(FactSetConcept_getInstance().lgc_1);
    }
    return ensureNotNull($this.kjk_1);
  }
  function _get_contextsField__9rt25h($this) {
    if ($this.ljk_1 == null) {
      $this.ljk_1 = $this.g6l(FactSetConcept_getInstance().mgc_1);
    }
    return ensureNotNull($this.ljk_1);
  }
  function _get_factsField__7q8854_0($this) {
    if ($this.mjk_1 == null) {
      $this.mjk_1 = $this.g6l(FactSetConcept_getInstance().ngc_1);
    }
    return ensureNotNull($this.mjk_1);
  }
  function _get_newFactsField__f3knr6($this) {
    if ($this.njk_1 == null) {
      $this.njk_1 = $this.g6l(FactSetConcept_getInstance().ogc_1);
    }
    return ensureNotNull($this.njk_1);
  }
  function _get_sourcesField__ca0b6f($this) {
    if ($this.pjk_1 == null) {
      $this.pjk_1 = $this.g6l(HasKnowledgeSourcesConcept_getInstance().zgg_1);
    }
    return ensureNotNull($this.pjk_1);
  }
  function _get_commentField__ylav5c_0($this) {
    if ($this.qjk_1 == null) {
      $this.qjk_1 = $this.d6l(HasCommentsConcept_getInstance().jgg_1);
    }
    return ensureNotNull($this.qjk_1);
  }
  function _get_variablesField__8i4vo8($this) {
    if ($this.rjk_1 == null) {
      $this.rjk_1 = $this.g6l(HasVariablesConcept_getInstance().zgh_1);
    }
    return ensureNotNull($this.rjk_1);
  }
  function TypedFactSetImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? FactSetConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(FactSetConcept_getInstance().m6n_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.jjk_1 = null;
    this.kjk_1 = null;
    this.ljk_1 = null;
    this.mjk_1 = null;
    this.njk_1 = null;
    this.ojk_1 = null;
    this.pjk_1 = null;
    this.qjk_1 = null;
    this.rjk_1 = null;
  }
  protoOf(TypedFactSetImpl).zfq = function () {
    return this.x6k(FactSetConcept_getInstance().kgc_1);
  };
  protoOf(TypedFactSetImpl).afr = function () {
    return this.f6l(_get_factsContextField__2692qp(this));
  };
  protoOf(TypedFactSetImpl).bfr = function () {
    return this.i6l(_get_contextsField__9rt25h(this));
  };
  protoOf(TypedFactSetImpl).wfq = function () {
    return this.i6l(_get_factsField__7q8854_0(this));
  };
  protoOf(TypedFactSetImpl).cfr = function () {
    return this.i6l(_get_newFactsField__f3knr6(this));
  };
  protoOf(TypedFactSetImpl).y2 = function () {
    return this.x6k(DirectlyNamedConcept_getInstance().chz_1);
  };
  protoOf(TypedFactSetImpl).nfr = function () {
    return this.i6l(_get_sourcesField__ca0b6f(this));
  };
  protoOf(TypedFactSetImpl).lfr = function () {
    return this.f6l(_get_commentField__ylav5c_0(this));
  };
  protoOf(TypedFactSetImpl).rfr = function () {
    return this.i6l(_get_variablesField__8i4vo8(this));
  };
  protoOf(TypedFactSetImpl).c3e = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.jjk_1 == null)) {
      this_0.j(FactSetConcept_getInstance().kgc_1.m6o_1);
    }
    if (!(this.ojk_1 == null)) {
      this_0.j(DirectlyNamedConcept_getInstance().chz_1.m6o_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedBTBNodeImpl).c3e.call(this));
  };
  protoOf(TypedFactSetImpl).z3d = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.kjk_1 == null)) {
      this_0.j(FactSetConcept_getInstance().lgc_1.e6l_1);
    }
    if (!(this.ljk_1 == null)) {
      this_0.j(FactSetConcept_getInstance().mgc_1.h6l_1);
    }
    if (!(this.mjk_1 == null)) {
      this_0.j(FactSetConcept_getInstance().ngc_1.h6l_1);
    }
    if (!(this.njk_1 == null)) {
      this_0.j(FactSetConcept_getInstance().ogc_1.h6l_1);
    }
    if (!(this.pjk_1 == null)) {
      this_0.j(HasKnowledgeSourcesConcept_getInstance().zgg_1.h6l_1);
    }
    if (!(this.qjk_1 == null)) {
      this_0.j(HasCommentsConcept_getInstance().jgg_1.e6l_1);
    }
    if (!(this.rjk_1 == null)) {
      this_0.j(HasVariablesConcept_getInstance().zgh_1.h6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedBTBNodeImpl).z3d.call(this));
  };
  protoOf(TypedFactSetImpl).g3p = function (nodeId) {
    return new TypedFactSetImpl(this.j6k_1, FactSetConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedFactSetImpl).v6k = function (propertyId) {
    return propertyId.equals(FactSetConcept_getInstance().kgc_1.m6o_1) ? this.jjk_1 : propertyId.equals(DirectlyNamedConcept_getInstance().chz_1.m6o_1) ? this.ojk_1 : protoOf(TypedBTBNodeImpl).v6k.call(this, propertyId);
  };
  protoOf(TypedFactSetImpl).w6k = function (propertyId, value) {
    if (propertyId.equals(FactSetConcept_getInstance().kgc_1.m6o_1)) {
      this.jjk_1 = value;
    } else if (propertyId.equals(DirectlyNamedConcept_getInstance().chz_1.m6o_1)) {
      this.ojk_1 = value;
    } else {
      protoOf(TypedBTBNodeImpl).w6k.call(this, propertyId, value);
    }
  };
  protoOf(TypedFactSetImpl).p3m = function (childId) {
    return childId.equals(FactSetConcept_getInstance().lgc_1.e6l_1) ? _get_factsContextField__2692qp(this) : childId.equals(FactSetConcept_getInstance().mgc_1.h6l_1) ? _get_contextsField__9rt25h(this) : childId.equals(FactSetConcept_getInstance().ngc_1.h6l_1) ? _get_factsField__7q8854_0(this) : childId.equals(FactSetConcept_getInstance().ogc_1.h6l_1) ? _get_newFactsField__f3knr6(this) : childId.equals(HasKnowledgeSourcesConcept_getInstance().zgg_1.h6l_1) ? _get_sourcesField__ca0b6f(this) : childId.equals(HasCommentsConcept_getInstance().jgg_1.e6l_1) ? _get_commentField__ylav5c_0(this) : childId.equals(HasVariablesConcept_getInstance().zgh_1.h6l_1) ? _get_variablesField__8i4vo8(this) : protoOf(TypedBTBNodeImpl).p3m.call(this, childId);
  };
  function _get_typeField__jjl181_0($this) {
    if ($this.ejl_1 == null) {
      $this.ejl_1 = $this.d6l(FieldDeclarationConcept_getInstance().bgd_1);
    }
    return ensureNotNull($this.ejl_1);
  }
  function _get_cardinalityField__qxjnpd($this) {
    if ($this.fjl_1 == null) {
      $this.fjl_1 = $this.d6l(FieldDeclarationConcept_getInstance().cgd_1);
    }
    return ensureNotNull($this.fjl_1);
  }
  function TypedFieldDeclarationImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? FieldDeclarationConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(FieldDeclarationConcept_getInstance().m6n_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.ejl_1 = null;
    this.fjl_1 = null;
    this.gjl_1 = null;
  }
  protoOf(TypedFieldDeclarationImpl).sfq = function () {
    return this.f6l(_get_typeField__jjl181_0(this));
  };
  protoOf(TypedFieldDeclarationImpl).dfr = function () {
    return this.f6l(_get_cardinalityField__qxjnpd(this));
  };
  protoOf(TypedFieldDeclarationImpl).y2 = function () {
    return this.x6k(DirectlyNamedConcept_getInstance().chz_1);
  };
  protoOf(TypedFieldDeclarationImpl).c3e = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.gjl_1 == null)) {
      this_0.j(DirectlyNamedConcept_getInstance().chz_1.m6o_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedBTBNodeImpl).c3e.call(this));
  };
  protoOf(TypedFieldDeclarationImpl).z3d = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.ejl_1 == null)) {
      this_0.j(FieldDeclarationConcept_getInstance().bgd_1.e6l_1);
    }
    if (!(this.fjl_1 == null)) {
      this_0.j(FieldDeclarationConcept_getInstance().cgd_1.e6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedBTBNodeImpl).z3d.call(this));
  };
  protoOf(TypedFieldDeclarationImpl).g3p = function (nodeId) {
    return new TypedFieldDeclarationImpl(this.j6k_1, FieldDeclarationConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedFieldDeclarationImpl).v6k = function (propertyId) {
    return propertyId.equals(DirectlyNamedConcept_getInstance().chz_1.m6o_1) ? this.gjl_1 : protoOf(TypedBTBNodeImpl).v6k.call(this, propertyId);
  };
  protoOf(TypedFieldDeclarationImpl).w6k = function (propertyId, value) {
    if (propertyId.equals(DirectlyNamedConcept_getInstance().chz_1.m6o_1)) {
      this.gjl_1 = value;
    } else {
      protoOf(TypedBTBNodeImpl).w6k.call(this, propertyId, value);
    }
  };
  protoOf(TypedFieldDeclarationImpl).p3m = function (childId) {
    return childId.equals(FieldDeclarationConcept_getInstance().bgd_1.e6l_1) ? _get_typeField__jjl181_0(this) : childId.equals(FieldDeclarationConcept_getInstance().cgd_1.e6l_1) ? _get_cardinalityField__qxjnpd(this) : protoOf(TypedBTBNodeImpl).p3m.call(this, childId);
  };
  function _get_contextQueryField__q258kw($this) {
    if ($this.tjl_1 == null) {
      $this.tjl_1 = $this.d6l(FindConnectionCommandConcept_getInstance().qgd_1);
    }
    return ensureNotNull($this.tjl_1);
  }
  function _get_fromField__7qc8o1($this) {
    if ($this.ujl_1 == null) {
      $this.ujl_1 = $this.d6l(FindConnectionCommandConcept_getInstance().rgd_1);
    }
    return ensureNotNull($this.ujl_1);
  }
  function _get_toField__k0vny($this) {
    if ($this.vjl_1 == null) {
      $this.vjl_1 = $this.d6l(FindConnectionCommandConcept_getInstance().sgd_1);
    }
    return ensureNotNull($this.vjl_1);
  }
  function TypedFindConnectionCommandImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? FindConnectionCommandConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(FindConnectionCommandConcept_getInstance().m6n_1) : nodeId;
    TypedCommandImpl.call(this, context, conceptId, nodeId);
    this.tjl_1 = null;
    this.ujl_1 = null;
    this.vjl_1 = null;
  }
  protoOf(TypedFindConnectionCommandImpl).efr = function () {
    return this.f6l(_get_contextQueryField__q258kw(this));
  };
  protoOf(TypedFindConnectionCommandImpl).f4b = function () {
    return this.f6l(_get_fromField__7qc8o1(this));
  };
  protoOf(TypedFindConnectionCommandImpl).g4b = function () {
    return this.f6l(_get_toField__k0vny(this));
  };
  protoOf(TypedFindConnectionCommandImpl).z3d = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.tjl_1 == null)) {
      this_0.j(FindConnectionCommandConcept_getInstance().qgd_1.e6l_1);
    }
    if (!(this.ujl_1 == null)) {
      this_0.j(FindConnectionCommandConcept_getInstance().rgd_1.e6l_1);
    }
    if (!(this.vjl_1 == null)) {
      this_0.j(FindConnectionCommandConcept_getInstance().sgd_1.e6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedCommandImpl).z3d.call(this));
  };
  protoOf(TypedFindConnectionCommandImpl).g3p = function (nodeId) {
    return new TypedFindConnectionCommandImpl(this.j6k_1, FindConnectionCommandConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedFindConnectionCommandImpl).p3m = function (childId) {
    return childId.equals(FindConnectionCommandConcept_getInstance().qgd_1.e6l_1) ? _get_contextQueryField__q258kw(this) : childId.equals(FindConnectionCommandConcept_getInstance().rgd_1.e6l_1) ? _get_fromField__7qc8o1(this) : childId.equals(FindConnectionCommandConcept_getInstance().sgd_1.e6l_1) ? _get_toField__k0vny(this) : protoOf(TypedCommandImpl).p3m.call(this, childId);
  };
  function _get_contextQueriesField__s7g0ia($this) {
    if ($this.ijm_1 == null) {
      $this.ijm_1 = $this.g6l(FindNewConnectionCommandConcept_getInstance().gge_1);
    }
    return ensureNotNull($this.ijm_1);
  }
  function _get_fromField__7qc8o1_0($this) {
    if ($this.jjm_1 == null) {
      $this.jjm_1 = $this.d6l(FindNewConnectionCommandConcept_getInstance().hge_1);
    }
    return ensureNotNull($this.jjm_1);
  }
  function _get_toField__k0vny_0($this) {
    if ($this.kjm_1 == null) {
      $this.kjm_1 = $this.d6l(FindNewConnectionCommandConcept_getInstance().ige_1);
    }
    return ensureNotNull($this.kjm_1);
  }
  function _get_variablesField__8i4vo8_0($this) {
    if ($this.ljm_1 == null) {
      $this.ljm_1 = $this.g6l(HasVariablesConcept_getInstance().zgh_1);
    }
    return ensureNotNull($this.ljm_1);
  }
  function TypedFindNewConnectionCommandImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? FindNewConnectionCommandConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(FindNewConnectionCommandConcept_getInstance().m6n_1) : nodeId;
    TypedCommandImpl.call(this, context, conceptId, nodeId);
    this.ijm_1 = null;
    this.jjm_1 = null;
    this.kjm_1 = null;
    this.ljm_1 = null;
  }
  protoOf(TypedFindNewConnectionCommandImpl).ffr = function () {
    return this.i6l(_get_contextQueriesField__s7g0ia(this));
  };
  protoOf(TypedFindNewConnectionCommandImpl).f4b = function () {
    return this.f6l(_get_fromField__7qc8o1_0(this));
  };
  protoOf(TypedFindNewConnectionCommandImpl).g4b = function () {
    return this.f6l(_get_toField__k0vny_0(this));
  };
  protoOf(TypedFindNewConnectionCommandImpl).rfr = function () {
    return this.i6l(_get_variablesField__8i4vo8_0(this));
  };
  protoOf(TypedFindNewConnectionCommandImpl).z3d = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.ijm_1 == null)) {
      this_0.j(FindNewConnectionCommandConcept_getInstance().gge_1.h6l_1);
    }
    if (!(this.jjm_1 == null)) {
      this_0.j(FindNewConnectionCommandConcept_getInstance().hge_1.e6l_1);
    }
    if (!(this.kjm_1 == null)) {
      this_0.j(FindNewConnectionCommandConcept_getInstance().ige_1.e6l_1);
    }
    if (!(this.ljm_1 == null)) {
      this_0.j(HasVariablesConcept_getInstance().zgh_1.h6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedCommandImpl).z3d.call(this));
  };
  protoOf(TypedFindNewConnectionCommandImpl).g3p = function (nodeId) {
    return new TypedFindNewConnectionCommandImpl(this.j6k_1, FindNewConnectionCommandConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedFindNewConnectionCommandImpl).p3m = function (childId) {
    return childId.equals(FindNewConnectionCommandConcept_getInstance().gge_1.h6l_1) ? _get_contextQueriesField__s7g0ia(this) : childId.equals(FindNewConnectionCommandConcept_getInstance().hge_1.e6l_1) ? _get_fromField__7qc8o1_0(this) : childId.equals(FindNewConnectionCommandConcept_getInstance().ige_1.e6l_1) ? _get_toField__k0vny_0(this) : childId.equals(HasVariablesConcept_getInstance().zgh_1.h6l_1) ? _get_variablesField__8i4vo8_0(this) : protoOf(TypedCommandImpl).p3m.call(this, childId);
  };
  function _get_returnTypeField__h3naf5($this) {
    if ($this.fjn_1 == null) {
      $this.fjn_1 = $this.d6l(FunctionDeclarationConcept_getInstance().vge_1);
    }
    return ensureNotNull($this.fjn_1);
  }
  function _get_cardinalityField__qxjnpd_0($this) {
    if ($this.gjn_1 == null) {
      $this.gjn_1 = $this.d6l(FunctionDeclarationConcept_getInstance().wge_1);
    }
    return ensureNotNull($this.gjn_1);
  }
  function TypedFunctionDeclarationImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? FunctionDeclarationConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(FunctionDeclarationConcept_getInstance().m6n_1) : nodeId;
    TypedAbstractBindingDeclarationImpl.call(this, context, conceptId, nodeId);
    this.fjn_1 = null;
    this.gjn_1 = null;
  }
  protoOf(TypedFunctionDeclarationImpl).gfr = function () {
    return this.f6l(_get_returnTypeField__h3naf5(this));
  };
  protoOf(TypedFunctionDeclarationImpl).dfr = function () {
    return this.f6l(_get_cardinalityField__qxjnpd_0(this));
  };
  protoOf(TypedFunctionDeclarationImpl).z3d = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.fjn_1 == null)) {
      this_0.j(FunctionDeclarationConcept_getInstance().vge_1.e6l_1);
    }
    if (!(this.gjn_1 == null)) {
      this_0.j(FunctionDeclarationConcept_getInstance().wge_1.e6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedAbstractBindingDeclarationImpl).z3d.call(this));
  };
  protoOf(TypedFunctionDeclarationImpl).g3p = function (nodeId) {
    return new TypedFunctionDeclarationImpl(this.j6k_1, FunctionDeclarationConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedFunctionDeclarationImpl).p3m = function (childId) {
    return childId.equals(FunctionDeclarationConcept_getInstance().vge_1.e6l_1) ? _get_returnTypeField__h3naf5(this) : childId.equals(FunctionDeclarationConcept_getInstance().wge_1.e6l_1) ? _get_cardinalityField__qxjnpd_0(this) : protoOf(TypedAbstractBindingDeclarationImpl).p3m.call(this, childId);
  };
  function _get_functionsField__8q6zm4($this) {
    if ($this.vjn_1 == null) {
      $this.vjn_1 = $this.g6l(FunctionLibraryConcept_getInstance().igf_1);
    }
    return ensureNotNull($this.vjn_1);
  }
  function TypedFunctionLibraryImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? FunctionLibraryConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(FunctionLibraryConcept_getInstance().m6n_1) : nodeId;
    TypedDocumentNodeImpl.call(this, context, conceptId, nodeId);
    this.vjn_1 = null;
  }
  protoOf(TypedFunctionLibraryImpl).hfr = function () {
    return this.i6l(_get_functionsField__8q6zm4(this));
  };
  protoOf(TypedFunctionLibraryImpl).z3d = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.vjn_1 == null)) {
      this_0.j(FunctionLibraryConcept_getInstance().igf_1.h6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedDocumentNodeImpl).z3d.call(this));
  };
  protoOf(TypedFunctionLibraryImpl).g3p = function (nodeId) {
    return new TypedFunctionLibraryImpl(this.j6k_1, FunctionLibraryConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedFunctionLibraryImpl).p3m = function (childId) {
    return childId.equals(FunctionLibraryConcept_getInstance().igf_1.h6l_1) ? _get_functionsField__8q6zm4(this) : protoOf(TypedDocumentNodeImpl).p3m.call(this, childId);
  };
  function _get_parametersField__3o4zz3($this) {
    if ($this.ljo_1 == null) {
      $this.ljo_1 = $this.g6l(FunctionTermConcept_getInstance().bgg_1);
    }
    return ensureNotNull($this.ljo_1);
  }
  function TypedFunctionTermImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? FunctionTermConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(FunctionTermConcept_getInstance().m6n_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.ijo_1 = null;
    this.jjo_1 = this.z6k(FunctionTermConcept_getInstance().zgf_1);
    this.kjo_1 = null;
    this.ljo_1 = null;
  }
  protoOf(TypedFunctionTermImpl).ifr = function () {
    return this.jjo_1;
  };
  protoOf(TypedFunctionTermImpl).jfr = function () {
    return this.x6k(FunctionTermConcept_getInstance().agg_1);
  };
  protoOf(TypedFunctionTermImpl).kfr = function () {
    return this.i6l(_get_parametersField__3o4zz3(this));
  };
  protoOf(TypedFunctionTermImpl).c3e = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.ijo_1 == null)) {
      this_0.j(FunctionTermConcept_getInstance().zgf_1.a6l_1);
    }
    if (!(this.kjo_1 == null)) {
      this_0.j(FunctionTermConcept_getInstance().agg_1.m6o_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedBTBNodeImpl).c3e.call(this));
  };
  protoOf(TypedFunctionTermImpl).z3d = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.ljo_1 == null)) {
      this_0.j(FunctionTermConcept_getInstance().bgg_1.h6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedBTBNodeImpl).z3d.call(this));
  };
  protoOf(TypedFunctionTermImpl).g3p = function (nodeId) {
    return new TypedFunctionTermImpl(this.j6k_1, FunctionTermConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedFunctionTermImpl).v6k = function (propertyId) {
    return propertyId.equals(FunctionTermConcept_getInstance().zgf_1.a6l_1) ? this.ijo_1 : propertyId.equals(FunctionTermConcept_getInstance().agg_1.m6o_1) ? this.kjo_1 : protoOf(TypedBTBNodeImpl).v6k.call(this, propertyId);
  };
  protoOf(TypedFunctionTermImpl).w6k = function (propertyId, value) {
    if (propertyId.equals(FunctionTermConcept_getInstance().zgf_1.a6l_1)) {
      this.ijo_1 = value;
    } else if (propertyId.equals(FunctionTermConcept_getInstance().agg_1.m6o_1)) {
      this.kjo_1 = value;
    } else {
      protoOf(TypedBTBNodeImpl).w6k.call(this, propertyId, value);
    }
  };
  protoOf(TypedFunctionTermImpl).p3m = function (childId) {
    return childId.equals(FunctionTermConcept_getInstance().bgg_1.h6l_1) ? _get_parametersField__3o4zz3(this) : protoOf(TypedBTBNodeImpl).p3m.call(this, childId);
  };
  function TypedImportedLinkImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? ImportedLinkConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ImportedLinkConcept_getInstance().m6n_1) : nodeId;
    TypedAbstractLinkImpl.call(this, context, conceptId, nodeId);
    this.ajp_1 = null;
    this.bjp_1 = this.z6k(ImportedLinkConcept_getInstance().mgi_1);
  }
  protoOf(TypedImportedLinkImpl).sfr = function () {
    return this.bjp_1;
  };
  protoOf(TypedImportedLinkImpl).c3e = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.ajp_1 == null)) {
      this_0.j(ImportedLinkConcept_getInstance().mgi_1.a6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedAbstractLinkImpl).c3e.call(this));
  };
  protoOf(TypedImportedLinkImpl).g3p = function (nodeId) {
    return new TypedImportedLinkImpl(this.j6k_1, ImportedLinkConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedImportedLinkImpl).v6k = function (propertyId) {
    return propertyId.equals(ImportedLinkConcept_getInstance().mgi_1.a6l_1) ? this.ajp_1 : protoOf(TypedAbstractLinkImpl).v6k.call(this, propertyId);
  };
  protoOf(TypedImportedLinkImpl).w6k = function (propertyId, value) {
    if (propertyId.equals(ImportedLinkConcept_getInstance().mgi_1.a6l_1)) {
      this.ajp_1 = value;
    } else {
      protoOf(TypedAbstractLinkImpl).w6k.call(this, propertyId, value);
    }
  };
  function TypedImportedPropertyImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? ImportedPropertyConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ImportedPropertyConcept_getInstance().m6n_1) : nodeId;
    TypedAbstractPropertyImpl.call(this, context, conceptId, nodeId);
    this.ojp_1 = null;
    this.pjp_1 = this.z6k(ImportedPropertyConcept_getInstance().zgi_1);
  }
  protoOf(TypedImportedPropertyImpl).sfr = function () {
    return this.pjp_1;
  };
  protoOf(TypedImportedPropertyImpl).c3e = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.ojp_1 == null)) {
      this_0.j(ImportedPropertyConcept_getInstance().zgi_1.a6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedAbstractPropertyImpl).c3e.call(this));
  };
  protoOf(TypedImportedPropertyImpl).g3p = function (nodeId) {
    return new TypedImportedPropertyImpl(this.j6k_1, ImportedPropertyConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedImportedPropertyImpl).v6k = function (propertyId) {
    return propertyId.equals(ImportedPropertyConcept_getInstance().zgi_1.a6l_1) ? this.ojp_1 : protoOf(TypedAbstractPropertyImpl).v6k.call(this, propertyId);
  };
  protoOf(TypedImportedPropertyImpl).w6k = function (propertyId, value) {
    if (propertyId.equals(ImportedPropertyConcept_getInstance().zgi_1.a6l_1)) {
      this.ojp_1 = value;
    } else {
      protoOf(TypedAbstractPropertyImpl).w6k.call(this, propertyId, value);
    }
  };
  function _get_typeField__jjl181_1($this) {
    if ($this.cjq_1 == null) {
      $this.cjq_1 = $this.d6l(InheritedProcessPropertyConcept_getInstance().ngj_1);
    }
    return ensureNotNull($this.cjq_1);
  }
  function _get_defaultField__5h0hf6($this) {
    if ($this.djq_1 == null) {
      $this.djq_1 = $this.d6l(InheritedProcessPropertyConcept_getInstance().ogj_1);
    }
    return ensureNotNull($this.djq_1);
  }
  function _get_inheritedFromField__e4r623($this) {
    if ($this.ejq_1 == null) {
      $this.ejq_1 = $this.d6l(InheritedProcessPropertyConcept_getInstance().pgj_1);
    }
    return ensureNotNull($this.ejq_1);
  }
  function TypedInheritedProcessPropertyImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? InheritedProcessPropertyConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(InheritedProcessPropertyConcept_getInstance().m6n_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.cjq_1 = null;
    this.djq_1 = null;
    this.ejq_1 = null;
    this.fjq_1 = null;
  }
  protoOf(TypedInheritedProcessPropertyImpl).sfq = function () {
    return this.f6l(_get_typeField__jjl181_1(this));
  };
  protoOf(TypedInheritedProcessPropertyImpl).g3b = function () {
    return this.f6l(_get_defaultField__5h0hf6(this));
  };
  protoOf(TypedInheritedProcessPropertyImpl).tfr = function () {
    return this.f6l(_get_inheritedFromField__e4r623(this));
  };
  protoOf(TypedInheritedProcessPropertyImpl).y2 = function () {
    return this.x6k(DirectlyNamedConcept_getInstance().chz_1);
  };
  protoOf(TypedInheritedProcessPropertyImpl).c3e = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.fjq_1 == null)) {
      this_0.j(DirectlyNamedConcept_getInstance().chz_1.m6o_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedBTBNodeImpl).c3e.call(this));
  };
  protoOf(TypedInheritedProcessPropertyImpl).z3d = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.cjq_1 == null)) {
      this_0.j(InheritedProcessPropertyConcept_getInstance().ngj_1.e6l_1);
    }
    if (!(this.djq_1 == null)) {
      this_0.j(InheritedProcessPropertyConcept_getInstance().ogj_1.e6l_1);
    }
    if (!(this.ejq_1 == null)) {
      this_0.j(InheritedProcessPropertyConcept_getInstance().pgj_1.e6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedBTBNodeImpl).z3d.call(this));
  };
  protoOf(TypedInheritedProcessPropertyImpl).g3p = function (nodeId) {
    return new TypedInheritedProcessPropertyImpl(this.j6k_1, InheritedProcessPropertyConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedInheritedProcessPropertyImpl).v6k = function (propertyId) {
    return propertyId.equals(DirectlyNamedConcept_getInstance().chz_1.m6o_1) ? this.fjq_1 : protoOf(TypedBTBNodeImpl).v6k.call(this, propertyId);
  };
  protoOf(TypedInheritedProcessPropertyImpl).w6k = function (propertyId, value) {
    if (propertyId.equals(DirectlyNamedConcept_getInstance().chz_1.m6o_1)) {
      this.fjq_1 = value;
    } else {
      protoOf(TypedBTBNodeImpl).w6k.call(this, propertyId, value);
    }
  };
  protoOf(TypedInheritedProcessPropertyImpl).p3m = function (childId) {
    return childId.equals(InheritedProcessPropertyConcept_getInstance().ngj_1.e6l_1) ? _get_typeField__jjl181_1(this) : childId.equals(InheritedProcessPropertyConcept_getInstance().ogj_1.e6l_1) ? _get_defaultField__5h0hf6(this) : childId.equals(InheritedProcessPropertyConcept_getInstance().pgj_1.e6l_1) ? _get_inheritedFromField__e4r623(this) : protoOf(TypedBTBNodeImpl).p3m.call(this, childId);
  };
  function _get_domainField__27e0qt($this) {
    if ($this.sjq_1 == null) {
      $this.sjq_1 = $this.d6l(InstanceRelationDeclarationConcept_getInstance().cgk_1);
    }
    return ensureNotNull($this.sjq_1);
  }
  function _get_rangeField__ko1zla($this) {
    if ($this.tjq_1 == null) {
      $this.tjq_1 = $this.d6l(InstanceRelationDeclarationConcept_getInstance().dgk_1);
    }
    return ensureNotNull($this.tjq_1);
  }
  function TypedInstanceRelationDeclarationImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? InstanceRelationDeclarationConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(InstanceRelationDeclarationConcept_getInstance().m6n_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.sjq_1 = null;
    this.tjq_1 = null;
    this.ujq_1 = null;
  }
  protoOf(TypedInstanceRelationDeclarationImpl).ufr = function () {
    return this.f6l(_get_domainField__27e0qt(this));
  };
  protoOf(TypedInstanceRelationDeclarationImpl).hd = function () {
    return this.f6l(_get_rangeField__ko1zla(this));
  };
  protoOf(TypedInstanceRelationDeclarationImpl).y2 = function () {
    return this.x6k(DirectlyNamedConcept_getInstance().chz_1);
  };
  protoOf(TypedInstanceRelationDeclarationImpl).c3e = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.ujq_1 == null)) {
      this_0.j(DirectlyNamedConcept_getInstance().chz_1.m6o_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedBTBNodeImpl).c3e.call(this));
  };
  protoOf(TypedInstanceRelationDeclarationImpl).z3d = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.sjq_1 == null)) {
      this_0.j(InstanceRelationDeclarationConcept_getInstance().cgk_1.e6l_1);
    }
    if (!(this.tjq_1 == null)) {
      this_0.j(InstanceRelationDeclarationConcept_getInstance().dgk_1.e6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedBTBNodeImpl).z3d.call(this));
  };
  protoOf(TypedInstanceRelationDeclarationImpl).g3p = function (nodeId) {
    return new TypedInstanceRelationDeclarationImpl(this.j6k_1, InstanceRelationDeclarationConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedInstanceRelationDeclarationImpl).v6k = function (propertyId) {
    return propertyId.equals(DirectlyNamedConcept_getInstance().chz_1.m6o_1) ? this.ujq_1 : protoOf(TypedBTBNodeImpl).v6k.call(this, propertyId);
  };
  protoOf(TypedInstanceRelationDeclarationImpl).w6k = function (propertyId, value) {
    if (propertyId.equals(DirectlyNamedConcept_getInstance().chz_1.m6o_1)) {
      this.ujq_1 = value;
    } else {
      protoOf(TypedBTBNodeImpl).w6k.call(this, propertyId, value);
    }
  };
  protoOf(TypedInstanceRelationDeclarationImpl).p3m = function (childId) {
    return childId.equals(InstanceRelationDeclarationConcept_getInstance().cgk_1.e6l_1) ? _get_domainField__27e0qt(this) : childId.equals(InstanceRelationDeclarationConcept_getInstance().dgk_1.e6l_1) ? _get_rangeField__ko1zla(this) : protoOf(TypedBTBNodeImpl).p3m.call(this, childId);
  };
  function _get_valueField__9y0rz6_3($this) {
    if ($this.hjr_1 == null) {
      $this.hjr_1 = $this.d6l(InstanceRelationValueConcept_getInstance().qgk_1);
    }
    return ensureNotNull($this.hjr_1);
  }
  function TypedInstanceRelationValueImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? InstanceRelationValueConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(InstanceRelationValueConcept_getInstance().m6n_1) : nodeId;
    TypedInstanceRelationValuePlaceholderImpl.call(this, context, conceptId, nodeId);
    this.hjr_1 = null;
    this.ijr_1 = null;
    this.jjr_1 = this.z6k(InstanceRelationValueConcept_getInstance().rgk_1);
  }
  protoOf(TypedInstanceRelationValueImpl).a1 = function () {
    return this.f6l(_get_valueField__9y0rz6_3(this));
  };
  protoOf(TypedInstanceRelationValueImpl).xfq = function () {
    return this.jjr_1;
  };
  protoOf(TypedInstanceRelationValueImpl).c3e = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.ijr_1 == null)) {
      this_0.j(InstanceRelationValueConcept_getInstance().rgk_1.a6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedInstanceRelationValuePlaceholderImpl).c3e.call(this));
  };
  protoOf(TypedInstanceRelationValueImpl).z3d = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.hjr_1 == null)) {
      this_0.j(InstanceRelationValueConcept_getInstance().qgk_1.e6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedInstanceRelationValuePlaceholderImpl).z3d.call(this));
  };
  protoOf(TypedInstanceRelationValueImpl).g3p = function (nodeId) {
    return new TypedInstanceRelationValueImpl(this.j6k_1, InstanceRelationValueConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedInstanceRelationValueImpl).v6k = function (propertyId) {
    return propertyId.equals(InstanceRelationValueConcept_getInstance().rgk_1.a6l_1) ? this.ijr_1 : protoOf(TypedInstanceRelationValuePlaceholderImpl).v6k.call(this, propertyId);
  };
  protoOf(TypedInstanceRelationValueImpl).w6k = function (propertyId, value) {
    if (propertyId.equals(InstanceRelationValueConcept_getInstance().rgk_1.a6l_1)) {
      this.ijr_1 = value;
    } else {
      protoOf(TypedInstanceRelationValuePlaceholderImpl).w6k.call(this, propertyId, value);
    }
  };
  protoOf(TypedInstanceRelationValueImpl).p3m = function (childId) {
    return childId.equals(InstanceRelationValueConcept_getInstance().qgk_1.e6l_1) ? _get_valueField__9y0rz6_3(this) : protoOf(TypedInstanceRelationValuePlaceholderImpl).p3m.call(this, childId);
  };
  function TypedInstanceRelationValuePlaceholderImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? InstanceRelationValuePlaceholderConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(InstanceRelationValuePlaceholderConcept_getInstance().m6n_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
  }
  protoOf(TypedInstanceRelationValuePlaceholderImpl).g3p = function (nodeId) {
    return new TypedInstanceRelationValuePlaceholderImpl(this.j6k_1, InstanceRelationValuePlaceholderConcept_getInstance().m6n_1, nodeId);
  };
  function TypedIntegerValueImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? IntegerValueConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(IntegerValueConcept_getInstance().m6n_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.ijs_1 = null;
  }
  protoOf(TypedIntegerValueImpl).a1 = function () {
    return this.x6k(IntegerValueConcept_getInstance().egl_1);
  };
  protoOf(TypedIntegerValueImpl).c3e = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.ijs_1 == null)) {
      this_0.j(IntegerValueConcept_getInstance().egl_1.m6o_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedBTBNodeImpl).c3e.call(this));
  };
  protoOf(TypedIntegerValueImpl).g3p = function (nodeId) {
    return new TypedIntegerValueImpl(this.j6k_1, IntegerValueConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedIntegerValueImpl).v6k = function (propertyId) {
    return propertyId.equals(IntegerValueConcept_getInstance().egl_1.m6o_1) ? this.ijs_1 : protoOf(TypedBTBNodeImpl).v6k.call(this, propertyId);
  };
  protoOf(TypedIntegerValueImpl).w6k = function (propertyId, value) {
    if (propertyId.equals(IntegerValueConcept_getInstance().egl_1.m6o_1)) {
      this.ijs_1 = value;
    } else {
      protoOf(TypedBTBNodeImpl).w6k.call(this, propertyId, value);
    }
  };
  function _get_subjectField__8sgco3($this) {
    if ($this.vjs_1 == null) {
      $this.vjs_1 = $this.d6l(IsExpressionConcept_getInstance().rgl_1);
    }
    return ensureNotNull($this.vjs_1);
  }
  function _get_valueField__9y0rz6_4($this) {
    if ($this.wjs_1 == null) {
      $this.wjs_1 = $this.d6l(IsExpressionConcept_getInstance().sgl_1);
    }
    return ensureNotNull($this.wjs_1);
  }
  function TypedIsExpressionImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? IsExpressionConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(IsExpressionConcept_getInstance().m6n_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.vjs_1 = null;
    this.wjs_1 = null;
  }
  protoOf(TypedIsExpressionImpl).mdy = function () {
    return this.f6l(_get_subjectField__8sgco3(this));
  };
  protoOf(TypedIsExpressionImpl).a1 = function () {
    return this.f6l(_get_valueField__9y0rz6_4(this));
  };
  protoOf(TypedIsExpressionImpl).z3d = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.vjs_1 == null)) {
      this_0.j(IsExpressionConcept_getInstance().rgl_1.e6l_1);
    }
    if (!(this.wjs_1 == null)) {
      this_0.j(IsExpressionConcept_getInstance().sgl_1.e6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedBTBNodeImpl).z3d.call(this));
  };
  protoOf(TypedIsExpressionImpl).g3p = function (nodeId) {
    return new TypedIsExpressionImpl(this.j6k_1, IsExpressionConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedIsExpressionImpl).p3m = function (childId) {
    return childId.equals(IsExpressionConcept_getInstance().rgl_1.e6l_1) ? _get_subjectField__8sgco3(this) : childId.equals(IsExpressionConcept_getInstance().sgl_1.e6l_1) ? _get_valueField__9y0rz6_4(this) : protoOf(TypedBTBNodeImpl).p3m.call(this, childId);
  };
  function TypedKindCustomCellImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? KindCustomCellConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(KindCustomCellConcept_getInstance().m6n_1) : nodeId;
    TypedCustomCellImpl.call(this, context, conceptId, nodeId);
  }
  protoOf(TypedKindCustomCellImpl).g3p = function (nodeId) {
    return new TypedKindCustomCellImpl(this.j6k_1, KindCustomCellConcept_getInstance().m6n_1, nodeId);
  };
  function TypedKnowledgeSourceReferenceImpl(context, conceptId, nodeId) {
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
  }
  function TypedKnowledgeSourceReferencePlaceholderImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? KnowledgeSourceReferencePlaceholderConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(KnowledgeSourceReferencePlaceholderConcept_getInstance().m6n_1) : nodeId;
    TypedKnowledgeSourceReferenceImpl.call(this, context, conceptId, nodeId);
  }
  protoOf(TypedKnowledgeSourceReferencePlaceholderImpl).g3p = function (nodeId) {
    return new TypedKnowledgeSourceReferencePlaceholderImpl(this.j6k_1, KnowledgeSourceReferencePlaceholderConcept_getInstance().m6n_1, nodeId);
  };
  function TypedLibraryItemPlaceholderImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? LibraryItemPlaceholderConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(LibraryItemPlaceholderConcept_getInstance().m6n_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
  }
  protoOf(TypedLibraryItemPlaceholderImpl).g3p = function (nodeId) {
    return new TypedLibraryItemPlaceholderImpl(this.j6k_1, LibraryItemPlaceholderConcept_getInstance().m6n_1, nodeId);
  };
  function _get_parametersField__3o4zz3_0($this) {
    if ($this.vju_1 == null) {
      $this.vju_1 = $this.g6l(LibraryProcessSpecificationConcept_getInstance().hgm_1);
    }
    return ensureNotNull($this.vju_1);
  }
  function TypedLibraryProcessSpecificationImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? LibraryProcessSpecificationConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(LibraryProcessSpecificationConcept_getInstance().m6n_1) : nodeId;
    TypedAbstractProcessSpecificationImpl.call(this, context, conceptId, nodeId);
    this.tju_1 = null;
    this.uju_1 = this.z6k(LibraryProcessSpecificationConcept_getInstance().ggm_1);
    this.vju_1 = null;
  }
  protoOf(TypedLibraryProcessSpecificationImpl).vfr = function () {
    return this.uju_1;
  };
  protoOf(TypedLibraryProcessSpecificationImpl).kfr = function () {
    return this.i6l(_get_parametersField__3o4zz3_0(this));
  };
  protoOf(TypedLibraryProcessSpecificationImpl).c3e = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.tju_1 == null)) {
      this_0.j(LibraryProcessSpecificationConcept_getInstance().ggm_1.a6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedAbstractProcessSpecificationImpl).c3e.call(this));
  };
  protoOf(TypedLibraryProcessSpecificationImpl).z3d = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.vju_1 == null)) {
      this_0.j(LibraryProcessSpecificationConcept_getInstance().hgm_1.h6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedAbstractProcessSpecificationImpl).z3d.call(this));
  };
  protoOf(TypedLibraryProcessSpecificationImpl).g3p = function (nodeId) {
    return new TypedLibraryProcessSpecificationImpl(this.j6k_1, LibraryProcessSpecificationConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedLibraryProcessSpecificationImpl).v6k = function (propertyId) {
    return propertyId.equals(LibraryProcessSpecificationConcept_getInstance().ggm_1.a6l_1) ? this.tju_1 : protoOf(TypedAbstractProcessSpecificationImpl).v6k.call(this, propertyId);
  };
  protoOf(TypedLibraryProcessSpecificationImpl).w6k = function (propertyId, value) {
    if (propertyId.equals(LibraryProcessSpecificationConcept_getInstance().ggm_1.a6l_1)) {
      this.tju_1 = value;
    } else {
      protoOf(TypedAbstractProcessSpecificationImpl).w6k.call(this, propertyId, value);
    }
  };
  protoOf(TypedLibraryProcessSpecificationImpl).p3m = function (childId) {
    return childId.equals(LibraryProcessSpecificationConcept_getInstance().hgm_1.h6l_1) ? _get_parametersField__3o4zz3_0(this) : protoOf(TypedAbstractProcessSpecificationImpl).p3m.call(this, childId);
  };
  function _get_parametersField__3o4zz3_1($this) {
    if ($this.mjv_1 == null) {
      $this.mjv_1 = $this.g6l(LibraryProcessSpecificationQueryConcept_getInstance().zgm_1);
    }
    return ensureNotNull($this.mjv_1);
  }
  function TypedLibraryProcessSpecificationQueryImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? LibraryProcessSpecificationQueryConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(LibraryProcessSpecificationQueryConcept_getInstance().m6n_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.ijv_1 = null;
    this.jjv_1 = this.z6k(LibraryProcessSpecificationQueryConcept_getInstance().xgm_1);
    this.kjv_1 = null;
    this.ljv_1 = this.z6k(LibraryProcessSpecificationQueryConcept_getInstance().ygm_1);
    this.mjv_1 = null;
  }
  protoOf(TypedLibraryProcessSpecificationQueryImpl).vfr = function () {
    return this.jjv_1;
  };
  protoOf(TypedLibraryProcessSpecificationQueryImpl).r5a = function () {
    return this.ljv_1;
  };
  protoOf(TypedLibraryProcessSpecificationQueryImpl).kfr = function () {
    return this.i6l(_get_parametersField__3o4zz3_1(this));
  };
  protoOf(TypedLibraryProcessSpecificationQueryImpl).c3e = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.ijv_1 == null)) {
      this_0.j(LibraryProcessSpecificationQueryConcept_getInstance().xgm_1.a6l_1);
    }
    if (!(this.kjv_1 == null)) {
      this_0.j(LibraryProcessSpecificationQueryConcept_getInstance().ygm_1.a6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedBTBNodeImpl).c3e.call(this));
  };
  protoOf(TypedLibraryProcessSpecificationQueryImpl).z3d = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.mjv_1 == null)) {
      this_0.j(LibraryProcessSpecificationQueryConcept_getInstance().zgm_1.h6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedBTBNodeImpl).z3d.call(this));
  };
  protoOf(TypedLibraryProcessSpecificationQueryImpl).g3p = function (nodeId) {
    return new TypedLibraryProcessSpecificationQueryImpl(this.j6k_1, LibraryProcessSpecificationQueryConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedLibraryProcessSpecificationQueryImpl).v6k = function (propertyId) {
    return propertyId.equals(LibraryProcessSpecificationQueryConcept_getInstance().xgm_1.a6l_1) ? this.ijv_1 : propertyId.equals(LibraryProcessSpecificationQueryConcept_getInstance().ygm_1.a6l_1) ? this.kjv_1 : protoOf(TypedBTBNodeImpl).v6k.call(this, propertyId);
  };
  protoOf(TypedLibraryProcessSpecificationQueryImpl).w6k = function (propertyId, value) {
    if (propertyId.equals(LibraryProcessSpecificationQueryConcept_getInstance().xgm_1.a6l_1)) {
      this.ijv_1 = value;
    } else if (propertyId.equals(LibraryProcessSpecificationQueryConcept_getInstance().ygm_1.a6l_1)) {
      this.kjv_1 = value;
    } else {
      protoOf(TypedBTBNodeImpl).w6k.call(this, propertyId, value);
    }
  };
  protoOf(TypedLibraryProcessSpecificationQueryImpl).p3m = function (childId) {
    return childId.equals(LibraryProcessSpecificationQueryConcept_getInstance().zgm_1.h6l_1) ? _get_parametersField__3o4zz3_1(this) : protoOf(TypedBTBNodeImpl).p3m.call(this, childId);
  };
  function TypedLinkCustomCellImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? LinkCustomCellConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(LinkCustomCellConcept_getInstance().m6n_1) : nodeId;
    TypedCustomCellImpl.call(this, context, conceptId, nodeId);
    this.zjv_1 = null;
    this.ajw_1 = this.z6k(LinkCustomCellConcept_getInstance().mgn_1);
  }
  protoOf(TypedLinkCustomCellImpl).xa1 = function () {
    return this.ajw_1;
  };
  protoOf(TypedLinkCustomCellImpl).c3e = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.zjv_1 == null)) {
      this_0.j(LinkCustomCellConcept_getInstance().mgn_1.a6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedCustomCellImpl).c3e.call(this));
  };
  protoOf(TypedLinkCustomCellImpl).g3p = function (nodeId) {
    return new TypedLinkCustomCellImpl(this.j6k_1, LinkCustomCellConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedLinkCustomCellImpl).v6k = function (propertyId) {
    return propertyId.equals(LinkCustomCellConcept_getInstance().mgn_1.a6l_1) ? this.zjv_1 : protoOf(TypedCustomCellImpl).v6k.call(this, propertyId);
  };
  protoOf(TypedLinkCustomCellImpl).w6k = function (propertyId, value) {
    if (propertyId.equals(LinkCustomCellConcept_getInstance().mgn_1.a6l_1)) {
      this.zjv_1 = value;
    } else {
      protoOf(TypedCustomCellImpl).w6k.call(this, propertyId, value);
    }
  };
  function _get_typeField__jjl181_2($this) {
    if ($this.ojw_1 == null) {
      $this.ojw_1 = $this.d6l(LinkDeclarationConcept_getInstance().cgo_1);
    }
    return ensureNotNull($this.ojw_1);
  }
  function TypedLinkDeclarationImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? LinkDeclarationConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(LinkDeclarationConcept_getInstance().m6n_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.njw_1 = null;
    this.ojw_1 = null;
    this.pjw_1 = null;
  }
  protoOf(TypedLinkDeclarationImpl).jfr = function () {
    return this.x6k(LinkDeclarationConcept_getInstance().bgo_1);
  };
  protoOf(TypedLinkDeclarationImpl).sfq = function () {
    return this.f6l(_get_typeField__jjl181_2(this));
  };
  protoOf(TypedLinkDeclarationImpl).y2 = function () {
    return this.x6k(DirectlyNamedConcept_getInstance().chz_1);
  };
  protoOf(TypedLinkDeclarationImpl).c3e = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.njw_1 == null)) {
      this_0.j(LinkDeclarationConcept_getInstance().bgo_1.m6o_1);
    }
    if (!(this.pjw_1 == null)) {
      this_0.j(DirectlyNamedConcept_getInstance().chz_1.m6o_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedBTBNodeImpl).c3e.call(this));
  };
  protoOf(TypedLinkDeclarationImpl).z3d = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.ojw_1 == null)) {
      this_0.j(LinkDeclarationConcept_getInstance().cgo_1.e6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedBTBNodeImpl).z3d.call(this));
  };
  protoOf(TypedLinkDeclarationImpl).g3p = function (nodeId) {
    return new TypedLinkDeclarationImpl(this.j6k_1, LinkDeclarationConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedLinkDeclarationImpl).v6k = function (propertyId) {
    return propertyId.equals(LinkDeclarationConcept_getInstance().bgo_1.m6o_1) ? this.njw_1 : propertyId.equals(DirectlyNamedConcept_getInstance().chz_1.m6o_1) ? this.pjw_1 : protoOf(TypedBTBNodeImpl).v6k.call(this, propertyId);
  };
  protoOf(TypedLinkDeclarationImpl).w6k = function (propertyId, value) {
    if (propertyId.equals(LinkDeclarationConcept_getInstance().bgo_1.m6o_1)) {
      this.njw_1 = value;
    } else if (propertyId.equals(DirectlyNamedConcept_getInstance().chz_1.m6o_1)) {
      this.pjw_1 = value;
    } else {
      protoOf(TypedBTBNodeImpl).w6k.call(this, propertyId, value);
    }
  };
  protoOf(TypedLinkDeclarationImpl).p3m = function (childId) {
    return childId.equals(LinkDeclarationConcept_getInstance().cgo_1.e6l_1) ? _get_typeField__jjl181_2(this) : protoOf(TypedBTBNodeImpl).p3m.call(this, childId);
  };
  function _get_linksField__3gitxy($this) {
    if ($this.ejx_1 == null) {
      $this.ejx_1 = $this.g6l(LinkLibraryConcept_getInstance().ogo_1);
    }
    return ensureNotNull($this.ejx_1);
  }
  function TypedLinkLibraryImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? LinkLibraryConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(LinkLibraryConcept_getInstance().m6n_1) : nodeId;
    TypedDocumentNodeImpl.call(this, context, conceptId, nodeId);
    this.ejx_1 = null;
  }
  protoOf(TypedLinkLibraryImpl).wfr = function () {
    return this.i6l(_get_linksField__3gitxy(this));
  };
  protoOf(TypedLinkLibraryImpl).z3d = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.ejx_1 == null)) {
      this_0.j(LinkLibraryConcept_getInstance().ogo_1.h6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedDocumentNodeImpl).z3d.call(this));
  };
  protoOf(TypedLinkLibraryImpl).g3p = function (nodeId) {
    return new TypedLinkLibraryImpl(this.j6k_1, LinkLibraryConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedLinkLibraryImpl).p3m = function (childId) {
    return childId.equals(LinkLibraryConcept_getInstance().ogo_1.h6l_1) ? _get_linksField__3gitxy(this) : protoOf(TypedDocumentNodeImpl).p3m.call(this, childId);
  };
  function TypedLocalOntologyElementReferenceImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? LocalOntologyElementReferenceConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(LocalOntologyElementReferenceConcept_getInstance().m6n_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.rjx_1 = null;
    this.sjx_1 = this.z6k(LocalOntologyElementReferenceConcept_getInstance().bgp_1);
  }
  protoOf(TypedLocalOntologyElementReferenceImpl).gfq = function () {
    return this.sjx_1;
  };
  protoOf(TypedLocalOntologyElementReferenceImpl).c3e = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.rjx_1 == null)) {
      this_0.j(LocalOntologyElementReferenceConcept_getInstance().bgp_1.a6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedBTBNodeImpl).c3e.call(this));
  };
  protoOf(TypedLocalOntologyElementReferenceImpl).g3p = function (nodeId) {
    return new TypedLocalOntologyElementReferenceImpl(this.j6k_1, LocalOntologyElementReferenceConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedLocalOntologyElementReferenceImpl).v6k = function (propertyId) {
    return propertyId.equals(LocalOntologyElementReferenceConcept_getInstance().bgp_1.a6l_1) ? this.rjx_1 : protoOf(TypedBTBNodeImpl).v6k.call(this, propertyId);
  };
  protoOf(TypedLocalOntologyElementReferenceImpl).w6k = function (propertyId, value) {
    if (propertyId.equals(LocalOntologyElementReferenceConcept_getInstance().bgp_1.a6l_1)) {
      this.rjx_1 = value;
    } else {
      protoOf(TypedBTBNodeImpl).w6k.call(this, propertyId, value);
    }
  };
  function _get_unitsField__kdaj8g($this) {
    if ($this.gjy_1 == null) {
      $this.gjy_1 = $this.g6l(MeasurableNotionConcept_getInstance().ngp_1);
    }
    return ensureNotNull($this.gjy_1);
  }
  function TypedMeasurableNotionImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? MeasurableNotionConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(MeasurableNotionConcept_getInstance().m6n_1) : nodeId;
    TypedAbstractNotionImpl.call(this, context, conceptId, nodeId);
    this.gjy_1 = null;
  }
  protoOf(TypedMeasurableNotionImpl).xfr = function () {
    return this.i6l(_get_unitsField__kdaj8g(this));
  };
  protoOf(TypedMeasurableNotionImpl).z3d = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.gjy_1 == null)) {
      this_0.j(MeasurableNotionConcept_getInstance().ngp_1.h6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedAbstractNotionImpl).z3d.call(this));
  };
  protoOf(TypedMeasurableNotionImpl).g3p = function (nodeId) {
    return new TypedMeasurableNotionImpl(this.j6k_1, MeasurableNotionConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedMeasurableNotionImpl).p3m = function (childId) {
    return childId.equals(MeasurableNotionConcept_getInstance().ngp_1.h6l_1) ? _get_unitsField__kdaj8g(this) : protoOf(TypedAbstractNotionImpl).p3m.call(this, childId);
  };
  function TypedMeasurableValueImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? MeasurableValueConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(MeasurableValueConcept_getInstance().m6n_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.tjy_1 = null;
    this.ujy_1 = null;
    this.vjy_1 = this.z6k(MeasurableValueConcept_getInstance().bgq_1);
  }
  protoOf(TypedMeasurableValueImpl).yfr = function () {
    return this.x6k(MeasurableValueConcept_getInstance().agq_1);
  };
  protoOf(TypedMeasurableValueImpl).zfr = function () {
    return this.vjy_1;
  };
  protoOf(TypedMeasurableValueImpl).c3e = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.tjy_1 == null)) {
      this_0.j(MeasurableValueConcept_getInstance().agq_1.m6o_1);
    }
    if (!(this.ujy_1 == null)) {
      this_0.j(MeasurableValueConcept_getInstance().bgq_1.a6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedBTBNodeImpl).c3e.call(this));
  };
  protoOf(TypedMeasurableValueImpl).g3p = function (nodeId) {
    return new TypedMeasurableValueImpl(this.j6k_1, MeasurableValueConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedMeasurableValueImpl).v6k = function (propertyId) {
    return propertyId.equals(MeasurableValueConcept_getInstance().agq_1.m6o_1) ? this.tjy_1 : propertyId.equals(MeasurableValueConcept_getInstance().bgq_1.a6l_1) ? this.ujy_1 : protoOf(TypedBTBNodeImpl).v6k.call(this, propertyId);
  };
  protoOf(TypedMeasurableValueImpl).w6k = function (propertyId, value) {
    if (propertyId.equals(MeasurableValueConcept_getInstance().agq_1.m6o_1)) {
      this.tjy_1 = value;
    } else if (propertyId.equals(MeasurableValueConcept_getInstance().bgq_1.a6l_1)) {
      this.ujy_1 = value;
    } else {
      protoOf(TypedBTBNodeImpl).w6k.call(this, propertyId, value);
    }
  };
  function TypedMeasurementUnitImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? MeasurementUnitConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(MeasurementUnitConcept_getInstance().m6n_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.ijz_1 = null;
    this.jjz_1 = null;
  }
  protoOf(TypedMeasurementUnitImpl).afs = function () {
    return this.x6k(MeasurementUnitConcept_getInstance().ogq_1);
  };
  protoOf(TypedMeasurementUnitImpl).y2 = function () {
    return this.x6k(DirectlyNamedConcept_getInstance().chz_1);
  };
  protoOf(TypedMeasurementUnitImpl).c3e = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.ijz_1 == null)) {
      this_0.j(MeasurementUnitConcept_getInstance().ogq_1.m6o_1);
    }
    if (!(this.jjz_1 == null)) {
      this_0.j(DirectlyNamedConcept_getInstance().chz_1.m6o_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedBTBNodeImpl).c3e.call(this));
  };
  protoOf(TypedMeasurementUnitImpl).g3p = function (nodeId) {
    return new TypedMeasurementUnitImpl(this.j6k_1, MeasurementUnitConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedMeasurementUnitImpl).v6k = function (propertyId) {
    return propertyId.equals(MeasurementUnitConcept_getInstance().ogq_1.m6o_1) ? this.ijz_1 : propertyId.equals(DirectlyNamedConcept_getInstance().chz_1.m6o_1) ? this.jjz_1 : protoOf(TypedBTBNodeImpl).v6k.call(this, propertyId);
  };
  protoOf(TypedMeasurementUnitImpl).w6k = function (propertyId, value) {
    if (propertyId.equals(MeasurementUnitConcept_getInstance().ogq_1.m6o_1)) {
      this.ijz_1 = value;
    } else if (propertyId.equals(DirectlyNamedConcept_getInstance().chz_1.m6o_1)) {
      this.jjz_1 = value;
    } else {
      protoOf(TypedBTBNodeImpl).w6k.call(this, propertyId, value);
    }
  };
  function _get_modifiersField__bh4sur($this) {
    if ($this.yjz_1 == null) {
      $this.yjz_1 = $this.g6l(ModifierContainerConcept_getInstance().agr_1);
    }
    return ensureNotNull($this.yjz_1);
  }
  function TypedModifierContainerImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? ModifierContainerConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ModifierContainerConcept_getInstance().m6n_1) : nodeId;
    TypedDocumentNodeImpl.call(this, context, conceptId, nodeId);
    this.yjz_1 = null;
  }
  protoOf(TypedModifierContainerImpl).l8j = function () {
    return this.i6l(_get_modifiersField__bh4sur(this));
  };
  protoOf(TypedModifierContainerImpl).z3d = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.yjz_1 == null)) {
      this_0.j(ModifierContainerConcept_getInstance().agr_1.h6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedDocumentNodeImpl).z3d.call(this));
  };
  protoOf(TypedModifierContainerImpl).g3p = function (nodeId) {
    return new TypedModifierContainerImpl(this.j6k_1, ModifierContainerConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedModifierContainerImpl).p3m = function (childId) {
    return childId.equals(ModifierContainerConcept_getInstance().agr_1.h6l_1) ? _get_modifiersField__bh4sur(this) : protoOf(TypedDocumentNodeImpl).p3m.call(this, childId);
  };
  function TypedModifierDeclarationImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? ModifierDeclarationConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ModifierDeclarationConcept_getInstance().m6n_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.lk0_1 = null;
  }
  protoOf(TypedModifierDeclarationImpl).y2 = function () {
    return this.x6k(DirectlyNamedConcept_getInstance().chz_1);
  };
  protoOf(TypedModifierDeclarationImpl).c3e = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.lk0_1 == null)) {
      this_0.j(DirectlyNamedConcept_getInstance().chz_1.m6o_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedBTBNodeImpl).c3e.call(this));
  };
  protoOf(TypedModifierDeclarationImpl).g3p = function (nodeId) {
    return new TypedModifierDeclarationImpl(this.j6k_1, ModifierDeclarationConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedModifierDeclarationImpl).v6k = function (propertyId) {
    return propertyId.equals(DirectlyNamedConcept_getInstance().chz_1.m6o_1) ? this.lk0_1 : protoOf(TypedBTBNodeImpl).v6k.call(this, propertyId);
  };
  protoOf(TypedModifierDeclarationImpl).w6k = function (propertyId, value) {
    if (propertyId.equals(DirectlyNamedConcept_getInstance().chz_1.m6o_1)) {
      this.lk0_1 = value;
    } else {
      protoOf(TypedBTBNodeImpl).w6k.call(this, propertyId, value);
    }
  };
  function _get_expressionField__tmo0lr($this) {
    if ($this.ak1_1 == null) {
      $this.ak1_1 = $this.d6l(ModifierFactExpressionConcept_getInstance().pgr_1);
    }
    return ensureNotNull($this.ak1_1);
  }
  function TypedModifierFactExpressionImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? ModifierFactExpressionConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ModifierFactExpressionConcept_getInstance().m6n_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.yk0_1 = null;
    this.zk0_1 = this.z6k(ModifierFactExpressionConcept_getInstance().ogr_1);
    this.ak1_1 = null;
  }
  protoOf(TypedModifierFactExpressionImpl).bfs = function () {
    return this.zk0_1;
  };
  protoOf(TypedModifierFactExpressionImpl).mfr = function () {
    return this.f6l(_get_expressionField__tmo0lr(this));
  };
  protoOf(TypedModifierFactExpressionImpl).c3e = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.yk0_1 == null)) {
      this_0.j(ModifierFactExpressionConcept_getInstance().ogr_1.a6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedBTBNodeImpl).c3e.call(this));
  };
  protoOf(TypedModifierFactExpressionImpl).z3d = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.ak1_1 == null)) {
      this_0.j(ModifierFactExpressionConcept_getInstance().pgr_1.e6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedBTBNodeImpl).z3d.call(this));
  };
  protoOf(TypedModifierFactExpressionImpl).g3p = function (nodeId) {
    return new TypedModifierFactExpressionImpl(this.j6k_1, ModifierFactExpressionConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedModifierFactExpressionImpl).v6k = function (propertyId) {
    return propertyId.equals(ModifierFactExpressionConcept_getInstance().ogr_1.a6l_1) ? this.yk0_1 : protoOf(TypedBTBNodeImpl).v6k.call(this, propertyId);
  };
  protoOf(TypedModifierFactExpressionImpl).w6k = function (propertyId, value) {
    if (propertyId.equals(ModifierFactExpressionConcept_getInstance().ogr_1.a6l_1)) {
      this.yk0_1 = value;
    } else {
      protoOf(TypedBTBNodeImpl).w6k.call(this, propertyId, value);
    }
  };
  protoOf(TypedModifierFactExpressionImpl).p3m = function (childId) {
    return childId.equals(ModifierFactExpressionConcept_getInstance().pgr_1.e6l_1) ? _get_expressionField__tmo0lr(this) : protoOf(TypedBTBNodeImpl).p3m.call(this, childId);
  };
  function _get_linesField__yc1kcw($this) {
    if ($this.nk1_1 == null) {
      $this.nk1_1 = $this.g6l(MultilineTextConcept_getInstance().bgs_1);
    }
    return ensureNotNull($this.nk1_1);
  }
  function TypedMultilineTextImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? MultilineTextConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(MultilineTextConcept_getInstance().m6n_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.nk1_1 = null;
  }
  protoOf(TypedMultilineTextImpl).qcv = function () {
    return this.i6l(_get_linesField__yc1kcw(this));
  };
  protoOf(TypedMultilineTextImpl).z3d = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.nk1_1 == null)) {
      this_0.j(MultilineTextConcept_getInstance().bgs_1.h6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedBTBNodeImpl).z3d.call(this));
  };
  protoOf(TypedMultilineTextImpl).g3p = function (nodeId) {
    return new TypedMultilineTextImpl(this.j6k_1, MultilineTextConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedMultilineTextImpl).p3m = function (childId) {
    return childId.equals(MultilineTextConcept_getInstance().bgs_1.h6l_1) ? _get_linesField__yc1kcw(this) : protoOf(TypedBTBNodeImpl).p3m.call(this, childId);
  };
  function _get_typeField__jjl181_3($this) {
    if ($this.ak2_1 == null) {
      $this.ak2_1 = $this.d6l(MultipleProcessPropertyValueRangeConcept_getInstance().ngs_1);
    }
    return ensureNotNull($this.ak2_1);
  }
  function TypedMultipleProcessPropertyValueRangeImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? MultipleProcessPropertyValueRangeConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(MultipleProcessPropertyValueRangeConcept_getInstance().m6n_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.ak2_1 = null;
  }
  protoOf(TypedMultipleProcessPropertyValueRangeImpl).sfq = function () {
    return this.f6l(_get_typeField__jjl181_3(this));
  };
  protoOf(TypedMultipleProcessPropertyValueRangeImpl).z3d = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.ak2_1 == null)) {
      this_0.j(MultipleProcessPropertyValueRangeConcept_getInstance().ngs_1.e6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedBTBNodeImpl).z3d.call(this));
  };
  protoOf(TypedMultipleProcessPropertyValueRangeImpl).g3p = function (nodeId) {
    return new TypedMultipleProcessPropertyValueRangeImpl(this.j6k_1, MultipleProcessPropertyValueRangeConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedMultipleProcessPropertyValueRangeImpl).p3m = function (childId) {
    return childId.equals(MultipleProcessPropertyValueRangeConcept_getInstance().ngs_1.e6l_1) ? _get_typeField__jjl181_3(this) : protoOf(TypedBTBNodeImpl).p3m.call(this, childId);
  };
  function _get_typesField__spk11y($this) {
    if ($this.nk2_1 == null) {
      $this.nk2_1 = $this.g6l(MultiplePropertyValueRangeConcept_getInstance().zgs_1);
    }
    return ensureNotNull($this.nk2_1);
  }
  function TypedMultiplePropertyValueRangeImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? MultiplePropertyValueRangeConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(MultiplePropertyValueRangeConcept_getInstance().m6n_1) : nodeId;
    TypedPropertyValueRangeImpl.call(this, context, conceptId, nodeId);
    this.nk2_1 = null;
  }
  protoOf(TypedMultiplePropertyValueRangeImpl).cfs = function () {
    return this.i6l(_get_typesField__spk11y(this));
  };
  protoOf(TypedMultiplePropertyValueRangeImpl).z3d = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.nk2_1 == null)) {
      this_0.j(MultiplePropertyValueRangeConcept_getInstance().zgs_1.h6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedPropertyValueRangeImpl).z3d.call(this));
  };
  protoOf(TypedMultiplePropertyValueRangeImpl).g3p = function (nodeId) {
    return new TypedMultiplePropertyValueRangeImpl(this.j6k_1, MultiplePropertyValueRangeConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedMultiplePropertyValueRangeImpl).p3m = function (childId) {
    return childId.equals(MultiplePropertyValueRangeConcept_getInstance().zgs_1.h6l_1) ? _get_typesField__spk11y(this) : protoOf(TypedPropertyValueRangeImpl).p3m.call(this, childId);
  };
  function _get_expressionField__tmo0lr_0($this) {
    if ($this.bk3_1 == null) {
      $this.bk3_1 = $this.d6l(MultipliedExpressionConcept_getInstance().ngt_1);
    }
    return ensureNotNull($this.bk3_1);
  }
  function TypedMultipliedExpressionImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? MultipliedExpressionConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(MultipliedExpressionConcept_getInstance().m6n_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.ak3_1 = null;
    this.bk3_1 = null;
  }
  protoOf(TypedMultipliedExpressionImpl).dfs = function () {
    return this.x6k(MultipliedExpressionConcept_getInstance().mgt_1);
  };
  protoOf(TypedMultipliedExpressionImpl).mfr = function () {
    return this.f6l(_get_expressionField__tmo0lr_0(this));
  };
  protoOf(TypedMultipliedExpressionImpl).c3e = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.ak3_1 == null)) {
      this_0.j(MultipliedExpressionConcept_getInstance().mgt_1.m6o_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedBTBNodeImpl).c3e.call(this));
  };
  protoOf(TypedMultipliedExpressionImpl).z3d = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.bk3_1 == null)) {
      this_0.j(MultipliedExpressionConcept_getInstance().ngt_1.e6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedBTBNodeImpl).z3d.call(this));
  };
  protoOf(TypedMultipliedExpressionImpl).g3p = function (nodeId) {
    return new TypedMultipliedExpressionImpl(this.j6k_1, MultipliedExpressionConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedMultipliedExpressionImpl).v6k = function (propertyId) {
    return propertyId.equals(MultipliedExpressionConcept_getInstance().mgt_1.m6o_1) ? this.ak3_1 : protoOf(TypedBTBNodeImpl).v6k.call(this, propertyId);
  };
  protoOf(TypedMultipliedExpressionImpl).w6k = function (propertyId, value) {
    if (propertyId.equals(MultipliedExpressionConcept_getInstance().mgt_1.m6o_1)) {
      this.ak3_1 = value;
    } else {
      protoOf(TypedBTBNodeImpl).w6k.call(this, propertyId, value);
    }
  };
  protoOf(TypedMultipliedExpressionImpl).p3m = function (childId) {
    return childId.equals(MultipliedExpressionConcept_getInstance().ngt_1.e6l_1) ? _get_expressionField__tmo0lr_0(this) : protoOf(TypedBTBNodeImpl).p3m.call(this, childId);
  };
  function _get_expressionField__tmo0lr_1($this) {
    if ($this.ok3_1 == null) {
      $this.ok3_1 = $this.d6l(NewFactConcept_getInstance().zgt_1);
    }
    return ensureNotNull($this.ok3_1);
  }
  function TypedNewFactImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? NewFactConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(NewFactConcept_getInstance().m6n_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.ok3_1 = null;
    this.pk3_1 = null;
  }
  protoOf(TypedNewFactImpl).mfr = function () {
    return this.f6l(_get_expressionField__tmo0lr_1(this));
  };
  protoOf(TypedNewFactImpl).y2 = function () {
    return this.x6k(DirectlyNamedConcept_getInstance().chz_1);
  };
  protoOf(TypedNewFactImpl).c3e = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.pk3_1 == null)) {
      this_0.j(DirectlyNamedConcept_getInstance().chz_1.m6o_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedBTBNodeImpl).c3e.call(this));
  };
  protoOf(TypedNewFactImpl).z3d = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.ok3_1 == null)) {
      this_0.j(NewFactConcept_getInstance().zgt_1.e6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedBTBNodeImpl).z3d.call(this));
  };
  protoOf(TypedNewFactImpl).g3p = function (nodeId) {
    return new TypedNewFactImpl(this.j6k_1, NewFactConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedNewFactImpl).v6k = function (propertyId) {
    return propertyId.equals(DirectlyNamedConcept_getInstance().chz_1.m6o_1) ? this.pk3_1 : protoOf(TypedBTBNodeImpl).v6k.call(this, propertyId);
  };
  protoOf(TypedNewFactImpl).w6k = function (propertyId, value) {
    if (propertyId.equals(DirectlyNamedConcept_getInstance().chz_1.m6o_1)) {
      this.pk3_1 = value;
    } else {
      protoOf(TypedBTBNodeImpl).w6k.call(this, propertyId, value);
    }
  };
  protoOf(TypedNewFactImpl).p3m = function (childId) {
    return childId.equals(NewFactConcept_getInstance().zgt_1.e6l_1) ? _get_expressionField__tmo0lr_1(this) : protoOf(TypedBTBNodeImpl).p3m.call(this, childId);
  };
  function TypedNewFactReferenceImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? NewFactReferenceConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(NewFactReferenceConcept_getInstance().m6n_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.ck4_1 = null;
    this.dk4_1 = this.z6k(NewFactReferenceConcept_getInstance().mgu_1);
  }
  protoOf(TypedNewFactReferenceImpl).yfq = function () {
    return this.dk4_1;
  };
  protoOf(TypedNewFactReferenceImpl).c3e = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.ck4_1 == null)) {
      this_0.j(NewFactReferenceConcept_getInstance().mgu_1.a6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedBTBNodeImpl).c3e.call(this));
  };
  protoOf(TypedNewFactReferenceImpl).g3p = function (nodeId) {
    return new TypedNewFactReferenceImpl(this.j6k_1, NewFactReferenceConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedNewFactReferenceImpl).v6k = function (propertyId) {
    return propertyId.equals(NewFactReferenceConcept_getInstance().mgu_1.a6l_1) ? this.ck4_1 : protoOf(TypedBTBNodeImpl).v6k.call(this, propertyId);
  };
  protoOf(TypedNewFactReferenceImpl).w6k = function (propertyId, value) {
    if (propertyId.equals(NewFactReferenceConcept_getInstance().mgu_1.a6l_1)) {
      this.ck4_1 = value;
    } else {
      protoOf(TypedBTBNodeImpl).w6k.call(this, propertyId, value);
    }
  };
  function TypedNoValuesImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? NoValuesConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(NoValuesConcept_getInstance().m6n_1) : nodeId;
    TypedPropertyValueRangeImpl.call(this, context, conceptId, nodeId);
  }
  protoOf(TypedNoValuesImpl).g3p = function (nodeId) {
    return new TypedNoValuesImpl(this.j6k_1, NoValuesConcept_getInstance().m6n_1, nodeId);
  };
  function _get_notionsField__scghe9($this) {
    if ($this.ek5_1 == null) {
      $this.ek5_1 = $this.g6l(NotionLibraryConcept_getInstance().ygu_1);
    }
    return ensureNotNull($this.ek5_1);
  }
  function TypedNotionLibraryImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? NotionLibraryConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(NotionLibraryConcept_getInstance().m6n_1) : nodeId;
    TypedDocumentNodeImpl.call(this, context, conceptId, nodeId);
    this.ek5_1 = null;
  }
  protoOf(TypedNotionLibraryImpl).efs = function () {
    return this.i6l(_get_notionsField__scghe9(this));
  };
  protoOf(TypedNotionLibraryImpl).z3d = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.ek5_1 == null)) {
      this_0.j(NotionLibraryConcept_getInstance().ygu_1.h6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedDocumentNodeImpl).z3d.call(this));
  };
  protoOf(TypedNotionLibraryImpl).g3p = function (nodeId) {
    return new TypedNotionLibraryImpl(this.j6k_1, NotionLibraryConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedNotionLibraryImpl).p3m = function (childId) {
    return childId.equals(NotionLibraryConcept_getInstance().ygu_1.h6l_1) ? _get_notionsField__scghe9(this) : protoOf(TypedDocumentNodeImpl).p3m.call(this, childId);
  };
  function TypedNotionPlaceholderImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? NotionPlaceholderConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(NotionPlaceholderConcept_getInstance().m6n_1) : nodeId;
    TypedAbstractNotionImpl.call(this, context, conceptId, nodeId);
  }
  protoOf(TypedNotionPlaceholderImpl).g3p = function (nodeId) {
    return new TypedNotionPlaceholderImpl(this.j6k_1, NotionPlaceholderConcept_getInstance().m6n_1, nodeId);
  };
  function TypedNotionTypeImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? NotionTypeConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(NotionTypeConcept_getInstance().m6n_1) : nodeId;
    TypedTypeImpl.call(this, context, conceptId, nodeId);
    this.ek6_1 = null;
    this.fk6_1 = this.z6k(NotionTypeConcept_getInstance().lgv_1);
  }
  protoOf(TypedNotionTypeImpl).mfq = function () {
    return this.fk6_1;
  };
  protoOf(TypedNotionTypeImpl).c3e = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.ek6_1 == null)) {
      this_0.j(NotionTypeConcept_getInstance().lgv_1.a6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedTypeImpl).c3e.call(this));
  };
  protoOf(TypedNotionTypeImpl).g3p = function (nodeId) {
    return new TypedNotionTypeImpl(this.j6k_1, NotionTypeConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedNotionTypeImpl).v6k = function (propertyId) {
    return propertyId.equals(NotionTypeConcept_getInstance().lgv_1.a6l_1) ? this.ek6_1 : protoOf(TypedTypeImpl).v6k.call(this, propertyId);
  };
  protoOf(TypedNotionTypeImpl).w6k = function (propertyId, value) {
    if (propertyId.equals(NotionTypeConcept_getInstance().lgv_1.a6l_1)) {
      this.ek6_1 = value;
    } else {
      protoOf(TypedTypeImpl).w6k.call(this, propertyId, value);
    }
  };
  function _get_propertiesField__rzp1g6_0($this) {
    if ($this.uk6_1 == null) {
      $this.uk6_1 = $this.g6l(ObjectPropertiesLibraryConcept_getInstance().xgv_1);
    }
    return ensureNotNull($this.uk6_1);
  }
  function TypedObjectPropertiesLibraryImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? ObjectPropertiesLibraryConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ObjectPropertiesLibraryConcept_getInstance().m6n_1) : nodeId;
    TypedDocumentNodeImpl.call(this, context, conceptId, nodeId);
    this.uk6_1 = null;
  }
  protoOf(TypedObjectPropertiesLibraryImpl).rfp = function () {
    return this.i6l(_get_propertiesField__rzp1g6_0(this));
  };
  protoOf(TypedObjectPropertiesLibraryImpl).z3d = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.uk6_1 == null)) {
      this_0.j(ObjectPropertiesLibraryConcept_getInstance().xgv_1.h6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedDocumentNodeImpl).z3d.call(this));
  };
  protoOf(TypedObjectPropertiesLibraryImpl).g3p = function (nodeId) {
    return new TypedObjectPropertiesLibraryImpl(this.j6k_1, ObjectPropertiesLibraryConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedObjectPropertiesLibraryImpl).p3m = function (childId) {
    return childId.equals(ObjectPropertiesLibraryConcept_getInstance().xgv_1.h6l_1) ? _get_propertiesField__rzp1g6_0(this) : protoOf(TypedDocumentNodeImpl).p3m.call(this, childId);
  };
  function _get_domainField__27e0qt_0($this) {
    if ($this.kk7_1 == null) {
      $this.kk7_1 = $this.g6l(ObjectPropertyDeclarationConcept_getInstance().qgw_1);
    }
    return ensureNotNull($this.kk7_1);
  }
  function _get_rangeField__ko1zla_0($this) {
    if ($this.lk7_1 == null) {
      $this.lk7_1 = $this.d6l(ObjectPropertyDeclarationConcept_getInstance().rgw_1);
    }
    return ensureNotNull($this.lk7_1);
  }
  function _get_commentField__ylav5c_1($this) {
    if ($this.qk7_1 == null) {
      $this.qk7_1 = $this.d6l(HasCommentsConcept_getInstance().jgg_1);
    }
    return ensureNotNull($this.qk7_1);
  }
  function TypedObjectPropertyDeclarationImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? ObjectPropertyDeclarationConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ObjectPropertyDeclarationConcept_getInstance().m6n_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.hk7_1 = null;
    this.ik7_1 = null;
    this.jk7_1 = this.z6k(ObjectPropertyDeclarationConcept_getInstance().pgw_1);
    this.kk7_1 = null;
    this.lk7_1 = null;
    this.mk7_1 = null;
    this.nk7_1 = null;
    this.ok7_1 = this.z6k(ObjectPropertyDeclarationConcept_getInstance().tgw_1);
    this.pk7_1 = null;
    this.qk7_1 = null;
  }
  protoOf(TypedObjectPropertyDeclarationImpl).ffs = function () {
    return this.x6k(ObjectPropertyDeclarationConcept_getInstance().ogw_1);
  };
  protoOf(TypedObjectPropertyDeclarationImpl).gfs = function () {
    return this.jk7_1;
  };
  protoOf(TypedObjectPropertyDeclarationImpl).ufr = function () {
    return this.i6l(_get_domainField__27e0qt_0(this));
  };
  protoOf(TypedObjectPropertyDeclarationImpl).hd = function () {
    return this.f6l(_get_rangeField__ko1zla_0(this));
  };
  protoOf(TypedObjectPropertyDeclarationImpl).hfs = function () {
    return this.x6k(ObjectPropertyDeclarationConcept_getInstance().sgw_1);
  };
  protoOf(TypedObjectPropertyDeclarationImpl).ifs = function () {
    return this.ok7_1;
  };
  protoOf(TypedObjectPropertyDeclarationImpl).y2 = function () {
    return this.x6k(DirectlyNamedConcept_getInstance().chz_1);
  };
  protoOf(TypedObjectPropertyDeclarationImpl).lfr = function () {
    return this.f6l(_get_commentField__ylav5c_1(this));
  };
  protoOf(TypedObjectPropertyDeclarationImpl).c3e = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.hk7_1 == null)) {
      this_0.j(ObjectPropertyDeclarationConcept_getInstance().ogw_1.m6o_1);
    }
    if (!(this.ik7_1 == null)) {
      this_0.j(ObjectPropertyDeclarationConcept_getInstance().pgw_1.a6l_1);
    }
    if (!(this.mk7_1 == null)) {
      this_0.j(ObjectPropertyDeclarationConcept_getInstance().sgw_1.m6o_1);
    }
    if (!(this.nk7_1 == null)) {
      this_0.j(ObjectPropertyDeclarationConcept_getInstance().tgw_1.a6l_1);
    }
    if (!(this.pk7_1 == null)) {
      this_0.j(DirectlyNamedConcept_getInstance().chz_1.m6o_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedBTBNodeImpl).c3e.call(this));
  };
  protoOf(TypedObjectPropertyDeclarationImpl).z3d = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.kk7_1 == null)) {
      this_0.j(ObjectPropertyDeclarationConcept_getInstance().qgw_1.h6l_1);
    }
    if (!(this.lk7_1 == null)) {
      this_0.j(ObjectPropertyDeclarationConcept_getInstance().rgw_1.e6l_1);
    }
    if (!(this.qk7_1 == null)) {
      this_0.j(HasCommentsConcept_getInstance().jgg_1.e6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedBTBNodeImpl).z3d.call(this));
  };
  protoOf(TypedObjectPropertyDeclarationImpl).g3p = function (nodeId) {
    return new TypedObjectPropertyDeclarationImpl(this.j6k_1, ObjectPropertyDeclarationConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedObjectPropertyDeclarationImpl).v6k = function (propertyId) {
    return propertyId.equals(ObjectPropertyDeclarationConcept_getInstance().ogw_1.m6o_1) ? this.hk7_1 : propertyId.equals(ObjectPropertyDeclarationConcept_getInstance().pgw_1.a6l_1) ? this.ik7_1 : propertyId.equals(ObjectPropertyDeclarationConcept_getInstance().sgw_1.m6o_1) ? this.mk7_1 : propertyId.equals(ObjectPropertyDeclarationConcept_getInstance().tgw_1.a6l_1) ? this.nk7_1 : propertyId.equals(DirectlyNamedConcept_getInstance().chz_1.m6o_1) ? this.pk7_1 : protoOf(TypedBTBNodeImpl).v6k.call(this, propertyId);
  };
  protoOf(TypedObjectPropertyDeclarationImpl).w6k = function (propertyId, value) {
    if (propertyId.equals(ObjectPropertyDeclarationConcept_getInstance().ogw_1.m6o_1)) {
      this.hk7_1 = value;
    } else if (propertyId.equals(ObjectPropertyDeclarationConcept_getInstance().pgw_1.a6l_1)) {
      this.ik7_1 = value;
    } else if (propertyId.equals(ObjectPropertyDeclarationConcept_getInstance().sgw_1.m6o_1)) {
      this.mk7_1 = value;
    } else if (propertyId.equals(ObjectPropertyDeclarationConcept_getInstance().tgw_1.a6l_1)) {
      this.nk7_1 = value;
    } else if (propertyId.equals(DirectlyNamedConcept_getInstance().chz_1.m6o_1)) {
      this.pk7_1 = value;
    } else {
      protoOf(TypedBTBNodeImpl).w6k.call(this, propertyId, value);
    }
  };
  protoOf(TypedObjectPropertyDeclarationImpl).p3m = function (childId) {
    return childId.equals(ObjectPropertyDeclarationConcept_getInstance().qgw_1.h6l_1) ? _get_domainField__27e0qt_0(this) : childId.equals(ObjectPropertyDeclarationConcept_getInstance().rgw_1.e6l_1) ? _get_rangeField__ko1zla_0(this) : childId.equals(HasCommentsConcept_getInstance().jgg_1.e6l_1) ? _get_commentField__ylav5c_1(this) : protoOf(TypedBTBNodeImpl).p3m.call(this, childId);
  };
  function _get_operandField__fjb16i($this) {
    if ($this.dk8_1 == null) {
      $this.dk8_1 = $this.d6l(ObjectPropertyReferenceValueConcept_getInstance().igx_1);
    }
    return ensureNotNull($this.dk8_1);
  }
  function _get_propertyField__spxghg_0($this) {
    if ($this.ek8_1 == null) {
      $this.ek8_1 = $this.d6l(ObjectPropertyReferenceValueConcept_getInstance().jgx_1);
    }
    return ensureNotNull($this.ek8_1);
  }
  function TypedObjectPropertyReferenceValueImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? ObjectPropertyReferenceValueConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ObjectPropertyReferenceValueConcept_getInstance().m6n_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.dk8_1 = null;
    this.ek8_1 = null;
  }
  protoOf(TypedObjectPropertyReferenceValueImpl).jfs = function () {
    return this.f6l(_get_operandField__fjb16i(this));
  };
  protoOf(TypedObjectPropertyReferenceValueImpl).q6q = function () {
    return this.f6l(_get_propertyField__spxghg_0(this));
  };
  protoOf(TypedObjectPropertyReferenceValueImpl).z3d = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.dk8_1 == null)) {
      this_0.j(ObjectPropertyReferenceValueConcept_getInstance().igx_1.e6l_1);
    }
    if (!(this.ek8_1 == null)) {
      this_0.j(ObjectPropertyReferenceValueConcept_getInstance().jgx_1.e6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedBTBNodeImpl).z3d.call(this));
  };
  protoOf(TypedObjectPropertyReferenceValueImpl).g3p = function (nodeId) {
    return new TypedObjectPropertyReferenceValueImpl(this.j6k_1, ObjectPropertyReferenceValueConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedObjectPropertyReferenceValueImpl).p3m = function (childId) {
    return childId.equals(ObjectPropertyReferenceValueConcept_getInstance().igx_1.e6l_1) ? _get_operandField__fjb16i(this) : childId.equals(ObjectPropertyReferenceValueConcept_getInstance().jgx_1.e6l_1) ? _get_propertyField__spxghg_0(this) : protoOf(TypedBTBNodeImpl).p3m.call(this, childId);
  };
  function TypedOldPublishedSourceImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? OldPublishedSourceConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(OldPublishedSourceConcept_getInstance().m6n_1) : nodeId;
    TypedPublishedWorkImpl.call(this, context, conceptId, nodeId);
    this.wk8_1 = null;
    this.xk8_1 = null;
    this.yk8_1 = get_name_4.call(this);
  }
  protoOf(TypedOldPublishedSourceImpl).kfs = function () {
    return this.x6k(OldPublishedSourceConcept_getInstance().wgx_1);
  };
  protoOf(TypedOldPublishedSourceImpl).lfs = function () {
    return this.x6k(OldPublishedSourceConcept_getInstance().xgx_1);
  };
  protoOf(TypedOldPublishedSourceImpl).c3e = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.wk8_1 == null)) {
      this_0.j(OldPublishedSourceConcept_getInstance().wgx_1.m6o_1);
    }
    if (!(this.xk8_1 == null)) {
      this_0.j(OldPublishedSourceConcept_getInstance().xgx_1.m6o_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedPublishedWorkImpl).c3e.call(this));
  };
  protoOf(TypedOldPublishedSourceImpl).y2 = function () {
    return this.yk8_1;
  };
  protoOf(TypedOldPublishedSourceImpl).g3p = function (nodeId) {
    return new TypedOldPublishedSourceImpl(this.j6k_1, OldPublishedSourceConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedOldPublishedSourceImpl).v6k = function (propertyId) {
    return propertyId.equals(OldPublishedSourceConcept_getInstance().wgx_1.m6o_1) ? this.wk8_1 : propertyId.equals(OldPublishedSourceConcept_getInstance().xgx_1.m6o_1) ? this.xk8_1 : protoOf(TypedPublishedWorkImpl).v6k.call(this, propertyId);
  };
  protoOf(TypedOldPublishedSourceImpl).w6k = function (propertyId, value) {
    if (propertyId.equals(OldPublishedSourceConcept_getInstance().wgx_1.m6o_1)) {
      this.wk8_1 = value;
    } else if (propertyId.equals(OldPublishedSourceConcept_getInstance().xgx_1.m6o_1)) {
      this.xk8_1 = value;
    } else {
      protoOf(TypedPublishedWorkImpl).w6k.call(this, propertyId, value);
    }
  };
  function _get_expressionsField__6fs50($this) {
    if ($this.lk9_1 == null) {
      $this.lk9_1 = $this.g6l(OneOfConcept_getInstance().jgy_1);
    }
    return ensureNotNull($this.lk9_1);
  }
  function TypedOneOfImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? OneOfConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(OneOfConcept_getInstance().m6n_1) : nodeId;
    TypedTypeImpl.call(this, context, conceptId, nodeId);
    this.lk9_1 = null;
  }
  protoOf(TypedOneOfImpl).mfs = function () {
    return this.i6l(_get_expressionsField__6fs50(this));
  };
  protoOf(TypedOneOfImpl).z3d = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.lk9_1 == null)) {
      this_0.j(OneOfConcept_getInstance().jgy_1.h6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedTypeImpl).z3d.call(this));
  };
  protoOf(TypedOneOfImpl).g3p = function (nodeId) {
    return new TypedOneOfImpl(this.j6k_1, OneOfConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedOneOfImpl).p3m = function (childId) {
    return childId.equals(OneOfConcept_getInstance().jgy_1.h6l_1) ? _get_expressionsField__6fs50(this) : protoOf(TypedTypeImpl).p3m.call(this, childId);
  };
  function _get_classExpressionField__3dueap_0($this) {
    if ($this.yk9_1 == null) {
      $this.yk9_1 = $this.d6l(OntologyCardinalityRelationConcept_getInstance().wgy_1);
    }
    return ensureNotNull($this.yk9_1);
  }
  function _get_cardinalityField__qxjnpd_1($this) {
    if ($this.zk9_1 == null) {
      $this.zk9_1 = $this.d6l(OntologyCardinalityRelationConcept_getInstance().xgy_1);
    }
    return ensureNotNull($this.zk9_1);
  }
  function TypedOntologyCardinalityRelationImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? OntologyCardinalityRelationConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(OntologyCardinalityRelationConcept_getInstance().m6n_1) : nodeId;
    TypedAbstractOntologyRelationImpl.call(this, context, conceptId, nodeId);
    this.yk9_1 = null;
    this.zk9_1 = null;
  }
  protoOf(TypedOntologyCardinalityRelationImpl).hfq = function () {
    return this.f6l(_get_classExpressionField__3dueap_0(this));
  };
  protoOf(TypedOntologyCardinalityRelationImpl).dfr = function () {
    return this.f6l(_get_cardinalityField__qxjnpd_1(this));
  };
  protoOf(TypedOntologyCardinalityRelationImpl).z3d = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.yk9_1 == null)) {
      this_0.j(OntologyCardinalityRelationConcept_getInstance().wgy_1.e6l_1);
    }
    if (!(this.zk9_1 == null)) {
      this_0.j(OntologyCardinalityRelationConcept_getInstance().xgy_1.e6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedAbstractOntologyRelationImpl).z3d.call(this));
  };
  protoOf(TypedOntologyCardinalityRelationImpl).g3p = function (nodeId) {
    return new TypedOntologyCardinalityRelationImpl(this.j6k_1, OntologyCardinalityRelationConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedOntologyCardinalityRelationImpl).p3m = function (childId) {
    return childId.equals(OntologyCardinalityRelationConcept_getInstance().wgy_1.e6l_1) ? _get_classExpressionField__3dueap_0(this) : childId.equals(OntologyCardinalityRelationConcept_getInstance().xgy_1.e6l_1) ? _get_cardinalityField__qxjnpd_1(this) : protoOf(TypedAbstractOntologyRelationImpl).p3m.call(this, childId);
  };
  function _get_classExpressionField__3dueap_1($this) {
    if ($this.mka_1 == null) {
      $this.mka_1 = $this.d6l(OntologyElementDefinitionConcept_getInstance().nh0_1);
    }
    return ensureNotNull($this.mka_1);
  }
  function _get_constraintsField__3m7315($this) {
    if ($this.nka_1 == null) {
      $this.nka_1 = $this.g6l(HasPropertyConstraintsConcept_getInstance().hgh_1);
    }
    return ensureNotNull($this.nka_1);
  }
  function TypedOntologyElementDefinitionImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? OntologyElementDefinitionConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(OntologyElementDefinitionConcept_getInstance().m6n_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.mka_1 = null;
    this.nka_1 = null;
  }
  protoOf(TypedOntologyElementDefinitionImpl).hfq = function () {
    return this.f6l(_get_classExpressionField__3dueap_1(this));
  };
  protoOf(TypedOntologyElementDefinitionImpl).ofr = function () {
    return this.i6l(_get_constraintsField__3m7315(this));
  };
  protoOf(TypedOntologyElementDefinitionImpl).z3d = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.mka_1 == null)) {
      this_0.j(OntologyElementDefinitionConcept_getInstance().nh0_1.e6l_1);
    }
    if (!(this.nka_1 == null)) {
      this_0.j(HasPropertyConstraintsConcept_getInstance().hgh_1.h6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedBTBNodeImpl).z3d.call(this));
  };
  protoOf(TypedOntologyElementDefinitionImpl).g3p = function (nodeId) {
    return new TypedOntologyElementDefinitionImpl(this.j6k_1, OntologyElementDefinitionConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedOntologyElementDefinitionImpl).p3m = function (childId) {
    return childId.equals(OntologyElementDefinitionConcept_getInstance().nh0_1.e6l_1) ? _get_classExpressionField__3dueap_1(this) : childId.equals(HasPropertyConstraintsConcept_getInstance().hgh_1.h6l_1) ? _get_constraintsField__3m7315(this) : protoOf(TypedBTBNodeImpl).p3m.call(this, childId);
  };
  function _get_superElementsField__k34qgz($this) {
    if ($this.akb_1 == null) {
      $this.akb_1 = $this.g6l(OntologyElementConcept_getInstance().sgz_1);
    }
    return ensureNotNull($this.akb_1);
  }
  function _get_enclosingElementsField__5hj60k($this) {
    if ($this.bkb_1 == null) {
      $this.bkb_1 = $this.g6l(OntologyElementConcept_getInstance().tgz_1);
    }
    return ensureNotNull($this.bkb_1);
  }
  function _get_taxonField__ozsb3v($this) {
    if ($this.ckb_1 == null) {
      $this.ckb_1 = $this.d6l(OntologyElementConcept_getInstance().ugz_1);
    }
    return ensureNotNull($this.ckb_1);
  }
  function _get_additionalUrlsField__fp4yua($this) {
    if ($this.fkb_1 == null) {
      $this.fkb_1 = $this.g6l(OntologyElementConcept_getInstance().xgz_1);
    }
    return ensureNotNull($this.fkb_1);
  }
  function _get_synonymsField__k9btgx($this) {
    if ($this.gkb_1 == null) {
      $this.gkb_1 = $this.g6l(OntologyElementConcept_getInstance().ygz_1);
    }
    return ensureNotNull($this.gkb_1);
  }
  function _get_xRefContainersField__3g8uxw($this) {
    if ($this.hkb_1 == null) {
      $this.hkb_1 = $this.g6l(OntologyElementConcept_getInstance().zgz_1);
    }
    return ensureNotNull($this.hkb_1);
  }
  function _get_oldDefinitionField__pdwtaj($this) {
    if ($this.ikb_1 == null) {
      $this.ikb_1 = $this.d6l(OntologyElementConcept_getInstance().ah0_1);
    }
    return ensureNotNull($this.ikb_1);
  }
  function _get_definitionField__4sf3wq($this) {
    if ($this.jkb_1 == null) {
      $this.jkb_1 = $this.d6l(OntologyElementConcept_getInstance().bh0_1);
    }
    return ensureNotNull($this.jkb_1);
  }
  function _get_constraintsField__3m7315_0($this) {
    if ($this.lkb_1 == null) {
      $this.lkb_1 = $this.g6l(HasPropertyConstraintsConcept_getInstance().hgh_1);
    }
    return ensureNotNull($this.lkb_1);
  }
  function _get_commentField__ylav5c_2($this) {
    if ($this.mkb_1 == null) {
      $this.mkb_1 = $this.d6l(HasCommentsConcept_getInstance().jgg_1);
    }
    return ensureNotNull($this.mkb_1);
  }
  function TypedOntologyElementImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? OntologyElementConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(OntologyElementConcept_getInstance().m6n_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.akb_1 = null;
    this.bkb_1 = null;
    this.ckb_1 = null;
    this.dkb_1 = null;
    this.ekb_1 = null;
    this.fkb_1 = null;
    this.gkb_1 = null;
    this.hkb_1 = null;
    this.ikb_1 = null;
    this.jkb_1 = null;
    this.kkb_1 = null;
    this.lkb_1 = null;
    this.mkb_1 = null;
  }
  protoOf(TypedOntologyElementImpl).nfs = function () {
    return this.i6l(_get_superElementsField__k34qgz(this));
  };
  protoOf(TypedOntologyElementImpl).ofs = function () {
    return this.i6l(_get_enclosingElementsField__5hj60k(this));
  };
  protoOf(TypedOntologyElementImpl).pfs = function () {
    return this.f6l(_get_taxonField__ozsb3v(this));
  };
  protoOf(TypedOntologyElementImpl).qfs = function () {
    return this.x6k(OntologyElementConcept_getInstance().vgz_1);
  };
  protoOf(TypedOntologyElementImpl).rfs = function () {
    return this.x6k(OntologyElementConcept_getInstance().wgz_1);
  };
  protoOf(TypedOntologyElementImpl).sfs = function () {
    return this.i6l(_get_additionalUrlsField__fp4yua(this));
  };
  protoOf(TypedOntologyElementImpl).tfs = function () {
    return this.i6l(_get_synonymsField__k9btgx(this));
  };
  protoOf(TypedOntologyElementImpl).ufs = function () {
    return this.i6l(_get_xRefContainersField__3g8uxw(this));
  };
  protoOf(TypedOntologyElementImpl).vfs = function () {
    return this.f6l(_get_oldDefinitionField__pdwtaj(this));
  };
  protoOf(TypedOntologyElementImpl).wfs = function () {
    return this.f6l(_get_definitionField__4sf3wq(this));
  };
  protoOf(TypedOntologyElementImpl).y2 = function () {
    return this.x6k(DirectlyNamedConcept_getInstance().chz_1);
  };
  protoOf(TypedOntologyElementImpl).ofr = function () {
    return this.i6l(_get_constraintsField__3m7315_0(this));
  };
  protoOf(TypedOntologyElementImpl).lfr = function () {
    return this.f6l(_get_commentField__ylav5c_2(this));
  };
  protoOf(TypedOntologyElementImpl).c3e = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.dkb_1 == null)) {
      this_0.j(OntologyElementConcept_getInstance().vgz_1.m6o_1);
    }
    if (!(this.ekb_1 == null)) {
      this_0.j(OntologyElementConcept_getInstance().wgz_1.m6o_1);
    }
    if (!(this.kkb_1 == null)) {
      this_0.j(DirectlyNamedConcept_getInstance().chz_1.m6o_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedBTBNodeImpl).c3e.call(this));
  };
  protoOf(TypedOntologyElementImpl).z3d = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.akb_1 == null)) {
      this_0.j(OntologyElementConcept_getInstance().sgz_1.h6l_1);
    }
    if (!(this.bkb_1 == null)) {
      this_0.j(OntologyElementConcept_getInstance().tgz_1.h6l_1);
    }
    if (!(this.ckb_1 == null)) {
      this_0.j(OntologyElementConcept_getInstance().ugz_1.e6l_1);
    }
    if (!(this.fkb_1 == null)) {
      this_0.j(OntologyElementConcept_getInstance().xgz_1.h6l_1);
    }
    if (!(this.gkb_1 == null)) {
      this_0.j(OntologyElementConcept_getInstance().ygz_1.h6l_1);
    }
    if (!(this.hkb_1 == null)) {
      this_0.j(OntologyElementConcept_getInstance().zgz_1.h6l_1);
    }
    if (!(this.ikb_1 == null)) {
      this_0.j(OntologyElementConcept_getInstance().ah0_1.e6l_1);
    }
    if (!(this.jkb_1 == null)) {
      this_0.j(OntologyElementConcept_getInstance().bh0_1.e6l_1);
    }
    if (!(this.lkb_1 == null)) {
      this_0.j(HasPropertyConstraintsConcept_getInstance().hgh_1.h6l_1);
    }
    if (!(this.mkb_1 == null)) {
      this_0.j(HasCommentsConcept_getInstance().jgg_1.e6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedBTBNodeImpl).z3d.call(this));
  };
  protoOf(TypedOntologyElementImpl).g3p = function (nodeId) {
    return new TypedOntologyElementImpl(this.j6k_1, OntologyElementConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedOntologyElementImpl).v6k = function (propertyId) {
    return propertyId.equals(OntologyElementConcept_getInstance().vgz_1.m6o_1) ? this.dkb_1 : propertyId.equals(OntologyElementConcept_getInstance().wgz_1.m6o_1) ? this.ekb_1 : propertyId.equals(DirectlyNamedConcept_getInstance().chz_1.m6o_1) ? this.kkb_1 : protoOf(TypedBTBNodeImpl).v6k.call(this, propertyId);
  };
  protoOf(TypedOntologyElementImpl).w6k = function (propertyId, value) {
    if (propertyId.equals(OntologyElementConcept_getInstance().vgz_1.m6o_1)) {
      this.dkb_1 = value;
    } else if (propertyId.equals(OntologyElementConcept_getInstance().wgz_1.m6o_1)) {
      this.ekb_1 = value;
    } else if (propertyId.equals(DirectlyNamedConcept_getInstance().chz_1.m6o_1)) {
      this.kkb_1 = value;
    } else {
      protoOf(TypedBTBNodeImpl).w6k.call(this, propertyId, value);
    }
  };
  protoOf(TypedOntologyElementImpl).p3m = function (childId) {
    return childId.equals(OntologyElementConcept_getInstance().sgz_1.h6l_1) ? _get_superElementsField__k34qgz(this) : childId.equals(OntologyElementConcept_getInstance().tgz_1.h6l_1) ? _get_enclosingElementsField__5hj60k(this) : childId.equals(OntologyElementConcept_getInstance().ugz_1.e6l_1) ? _get_taxonField__ozsb3v(this) : childId.equals(OntologyElementConcept_getInstance().xgz_1.h6l_1) ? _get_additionalUrlsField__fp4yua(this) : childId.equals(OntologyElementConcept_getInstance().ygz_1.h6l_1) ? _get_synonymsField__k9btgx(this) : childId.equals(OntologyElementConcept_getInstance().zgz_1.h6l_1) ? _get_xRefContainersField__3g8uxw(this) : childId.equals(OntologyElementConcept_getInstance().ah0_1.e6l_1) ? _get_oldDefinitionField__pdwtaj(this) : childId.equals(OntologyElementConcept_getInstance().bh0_1.e6l_1) ? _get_definitionField__4sf3wq(this) : childId.equals(HasPropertyConstraintsConcept_getInstance().hgh_1.h6l_1) ? _get_constraintsField__3m7315_0(this) : childId.equals(HasCommentsConcept_getInstance().jgg_1.e6l_1) ? _get_commentField__ylav5c_2(this) : protoOf(TypedBTBNodeImpl).p3m.call(this, childId);
  };
  function _get_libraryField__um0bho_2($this) {
    if ($this.akc_1 == null) {
      $this.akc_1 = $this.d6l(OntologyElementPropertyTypeConcept_getInstance().dh1_1);
    }
    return ensureNotNull($this.akc_1);
  }
  function _get_elementField__q1p5qr_2($this) {
    if ($this.bkc_1 == null) {
      $this.bkc_1 = $this.d6l(OntologyElementPropertyTypeConcept_getInstance().eh1_1);
    }
    return ensureNotNull($this.bkc_1);
  }
  function TypedOntologyElementPropertyTypeImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? OntologyElementPropertyTypeConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(OntologyElementPropertyTypeConcept_getInstance().m6n_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.zkb_1 = null;
    this.akc_1 = null;
    this.bkc_1 = null;
  }
  protoOf(TypedOntologyElementPropertyTypeImpl).jfr = function () {
    return this.x6k(OntologyElementPropertyTypeConcept_getInstance().ch1_1);
  };
  protoOf(TypedOntologyElementPropertyTypeImpl).ffq = function () {
    return this.f6l(_get_libraryField__um0bho_2(this));
  };
  protoOf(TypedOntologyElementPropertyTypeImpl).gfq = function () {
    return this.f6l(_get_elementField__q1p5qr_2(this));
  };
  protoOf(TypedOntologyElementPropertyTypeImpl).c3e = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.zkb_1 == null)) {
      this_0.j(OntologyElementPropertyTypeConcept_getInstance().ch1_1.m6o_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedBTBNodeImpl).c3e.call(this));
  };
  protoOf(TypedOntologyElementPropertyTypeImpl).z3d = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.akc_1 == null)) {
      this_0.j(OntologyElementPropertyTypeConcept_getInstance().dh1_1.e6l_1);
    }
    if (!(this.bkc_1 == null)) {
      this_0.j(OntologyElementPropertyTypeConcept_getInstance().eh1_1.e6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedBTBNodeImpl).z3d.call(this));
  };
  protoOf(TypedOntologyElementPropertyTypeImpl).g3p = function (nodeId) {
    return new TypedOntologyElementPropertyTypeImpl(this.j6k_1, OntologyElementPropertyTypeConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedOntologyElementPropertyTypeImpl).v6k = function (propertyId) {
    return propertyId.equals(OntologyElementPropertyTypeConcept_getInstance().ch1_1.m6o_1) ? this.zkb_1 : protoOf(TypedBTBNodeImpl).v6k.call(this, propertyId);
  };
  protoOf(TypedOntologyElementPropertyTypeImpl).w6k = function (propertyId, value) {
    if (propertyId.equals(OntologyElementPropertyTypeConcept_getInstance().ch1_1.m6o_1)) {
      this.zkb_1 = value;
    } else {
      protoOf(TypedBTBNodeImpl).w6k.call(this, propertyId, value);
    }
  };
  protoOf(TypedOntologyElementPropertyTypeImpl).p3m = function (childId) {
    return childId.equals(OntologyElementPropertyTypeConcept_getInstance().dh1_1.e6l_1) ? _get_libraryField__um0bho_2(this) : childId.equals(OntologyElementPropertyTypeConcept_getInstance().eh1_1.e6l_1) ? _get_elementField__q1p5qr_2(this) : protoOf(TypedBTBNodeImpl).p3m.call(this, childId);
  };
  function TypedOntologyElementReferenceImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? OntologyElementReferenceConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(OntologyElementReferenceConcept_getInstance().m6n_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.okc_1 = null;
    this.pkc_1 = this.z6k(OntologyElementReferenceConcept_getInstance().rh1_1);
  }
  protoOf(TypedOntologyElementReferenceImpl).gfq = function () {
    return this.pkc_1;
  };
  protoOf(TypedOntologyElementReferenceImpl).c3e = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.okc_1 == null)) {
      this_0.j(OntologyElementReferenceConcept_getInstance().rh1_1.a6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedBTBNodeImpl).c3e.call(this));
  };
  protoOf(TypedOntologyElementReferenceImpl).g3p = function (nodeId) {
    return new TypedOntologyElementReferenceImpl(this.j6k_1, OntologyElementReferenceConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedOntologyElementReferenceImpl).v6k = function (propertyId) {
    return propertyId.equals(OntologyElementReferenceConcept_getInstance().rh1_1.a6l_1) ? this.okc_1 : protoOf(TypedBTBNodeImpl).v6k.call(this, propertyId);
  };
  protoOf(TypedOntologyElementReferenceImpl).w6k = function (propertyId, value) {
    if (propertyId.equals(OntologyElementReferenceConcept_getInstance().rh1_1.a6l_1)) {
      this.okc_1 = value;
    } else {
      protoOf(TypedBTBNodeImpl).w6k.call(this, propertyId, value);
    }
  };
  function _get_elementField__q1p5qr_3($this) {
    if ($this.ckd_1 == null) {
      $this.ckd_1 = $this.d6l(OntologyElementReferenceValueConcept_getInstance().dh2_1);
    }
    return ensureNotNull($this.ckd_1);
  }
  function TypedOntologyElementReferenceValueImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? OntologyElementReferenceValueConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(OntologyElementReferenceValueConcept_getInstance().m6n_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.ckd_1 = null;
  }
  protoOf(TypedOntologyElementReferenceValueImpl).gfq = function () {
    return this.f6l(_get_elementField__q1p5qr_3(this));
  };
  protoOf(TypedOntologyElementReferenceValueImpl).z3d = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.ckd_1 == null)) {
      this_0.j(OntologyElementReferenceValueConcept_getInstance().dh2_1.e6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedBTBNodeImpl).z3d.call(this));
  };
  protoOf(TypedOntologyElementReferenceValueImpl).g3p = function (nodeId) {
    return new TypedOntologyElementReferenceValueImpl(this.j6k_1, OntologyElementReferenceValueConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedOntologyElementReferenceValueImpl).p3m = function (childId) {
    return childId.equals(OntologyElementReferenceValueConcept_getInstance().dh2_1.e6l_1) ? _get_elementField__q1p5qr_3(this) : protoOf(TypedBTBNodeImpl).p3m.call(this, childId);
  };
  function _get_libraryField__um0bho_3($this) {
    if ($this.qkd_1 == null) {
      $this.qkd_1 = $this.d6l(OntologyElementReferenceValueLibraryConcept_getInstance().ph2_1);
    }
    return ensureNotNull($this.qkd_1);
  }
  function TypedOntologyElementReferenceValueLibraryImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? OntologyElementReferenceValueLibraryConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(OntologyElementReferenceValueLibraryConcept_getInstance().m6n_1) : nodeId;
    TypedOntologyElementReferenceValueImpl.call(this, context, conceptId, nodeId);
    this.qkd_1 = null;
  }
  protoOf(TypedOntologyElementReferenceValueLibraryImpl).ffq = function () {
    return this.f6l(_get_libraryField__um0bho_3(this));
  };
  protoOf(TypedOntologyElementReferenceValueLibraryImpl).z3d = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.qkd_1 == null)) {
      this_0.j(OntologyElementReferenceValueLibraryConcept_getInstance().ph2_1.e6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedOntologyElementReferenceValueImpl).z3d.call(this));
  };
  protoOf(TypedOntologyElementReferenceValueLibraryImpl).g3p = function (nodeId) {
    return new TypedOntologyElementReferenceValueLibraryImpl(this.j6k_1, OntologyElementReferenceValueLibraryConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedOntologyElementReferenceValueLibraryImpl).p3m = function (childId) {
    return childId.equals(OntologyElementReferenceValueLibraryConcept_getInstance().ph2_1.e6l_1) ? _get_libraryField__um0bho_3(this) : protoOf(TypedOntologyElementReferenceValueImpl).p3m.call(this, childId);
  };
  function TypedOntologyElementSynonymImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? OntologyElementSynonymConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(OntologyElementSynonymConcept_getInstance().m6n_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.dke_1 = null;
  }
  protoOf(TypedOntologyElementSynonymImpl).y2 = function () {
    return this.x6k(OntologyElementSynonymConcept_getInstance().bh3_1);
  };
  protoOf(TypedOntologyElementSynonymImpl).c3e = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.dke_1 == null)) {
      this_0.j(OntologyElementSynonymConcept_getInstance().bh3_1.m6o_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedBTBNodeImpl).c3e.call(this));
  };
  protoOf(TypedOntologyElementSynonymImpl).g3p = function (nodeId) {
    return new TypedOntologyElementSynonymImpl(this.j6k_1, OntologyElementSynonymConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedOntologyElementSynonymImpl).v6k = function (propertyId) {
    return propertyId.equals(OntologyElementSynonymConcept_getInstance().bh3_1.m6o_1) ? this.dke_1 : protoOf(TypedBTBNodeImpl).v6k.call(this, propertyId);
  };
  protoOf(TypedOntologyElementSynonymImpl).w6k = function (propertyId, value) {
    if (propertyId.equals(OntologyElementSynonymConcept_getInstance().bh3_1.m6o_1)) {
      this.dke_1 = value;
    } else {
      protoOf(TypedBTBNodeImpl).w6k.call(this, propertyId, value);
    }
  };
  function _get_libraryField__um0bho_4($this) {
    if ($this.qke_1 == null) {
      $this.qke_1 = $this.d6l(OntologyElementTypeConcept_getInstance().oh3_1);
    }
    return ensureNotNull($this.qke_1);
  }
  function _get_elementField__q1p5qr_4($this) {
    if ($this.rke_1 == null) {
      $this.rke_1 = $this.d6l(OntologyElementTypeConcept_getInstance().ph3_1);
    }
    return ensureNotNull($this.rke_1);
  }
  function TypedOntologyElementTypeImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? OntologyElementTypeConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(OntologyElementTypeConcept_getInstance().m6n_1) : nodeId;
    TypedTypeImpl.call(this, context, conceptId, nodeId);
    this.qke_1 = null;
    this.rke_1 = null;
  }
  protoOf(TypedOntologyElementTypeImpl).ffq = function () {
    return this.f6l(_get_libraryField__um0bho_4(this));
  };
  protoOf(TypedOntologyElementTypeImpl).gfq = function () {
    return this.f6l(_get_elementField__q1p5qr_4(this));
  };
  protoOf(TypedOntologyElementTypeImpl).z3d = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.qke_1 == null)) {
      this_0.j(OntologyElementTypeConcept_getInstance().oh3_1.e6l_1);
    }
    if (!(this.rke_1 == null)) {
      this_0.j(OntologyElementTypeConcept_getInstance().ph3_1.e6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedTypeImpl).z3d.call(this));
  };
  protoOf(TypedOntologyElementTypeImpl).g3p = function (nodeId) {
    return new TypedOntologyElementTypeImpl(this.j6k_1, OntologyElementTypeConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedOntologyElementTypeImpl).p3m = function (childId) {
    return childId.equals(OntologyElementTypeConcept_getInstance().oh3_1.e6l_1) ? _get_libraryField__um0bho_4(this) : childId.equals(OntologyElementTypeConcept_getInstance().ph3_1.e6l_1) ? _get_elementField__q1p5qr_4(this) : protoOf(TypedTypeImpl).p3m.call(this, childId);
  };
  function _get_ontologyField__fslpom($this) {
    if ($this.ekf_1 == null) {
      $this.ekf_1 = $this.d6l(OntologyImportConcept_getInstance().dh4_1);
    }
    return ensureNotNull($this.ekf_1);
  }
  function _get_elementField__q1p5qr_5($this) {
    if ($this.fkf_1 == null) {
      $this.fkf_1 = $this.d6l(OntologyImportConcept_getInstance().eh4_1);
    }
    return ensureNotNull($this.fkf_1);
  }
  function _get_libraryToUseField__uukqo8($this) {
    if ($this.gkf_1 == null) {
      $this.gkf_1 = $this.d6l(OntologyImportConcept_getInstance().fh4_1);
    }
    return ensureNotNull($this.gkf_1);
  }
  function TypedOntologyImportImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? OntologyImportConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(OntologyImportConcept_getInstance().m6n_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.ekf_1 = null;
    this.fkf_1 = null;
    this.gkf_1 = null;
  }
  protoOf(TypedOntologyImportImpl).xfs = function () {
    return this.f6l(_get_ontologyField__fslpom(this));
  };
  protoOf(TypedOntologyImportImpl).gfq = function () {
    return this.f6l(_get_elementField__q1p5qr_5(this));
  };
  protoOf(TypedOntologyImportImpl).yfs = function () {
    return this.f6l(_get_libraryToUseField__uukqo8(this));
  };
  protoOf(TypedOntologyImportImpl).z3d = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.ekf_1 == null)) {
      this_0.j(OntologyImportConcept_getInstance().dh4_1.e6l_1);
    }
    if (!(this.fkf_1 == null)) {
      this_0.j(OntologyImportConcept_getInstance().eh4_1.e6l_1);
    }
    if (!(this.gkf_1 == null)) {
      this_0.j(OntologyImportConcept_getInstance().fh4_1.e6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedBTBNodeImpl).z3d.call(this));
  };
  protoOf(TypedOntologyImportImpl).g3p = function (nodeId) {
    return new TypedOntologyImportImpl(this.j6k_1, OntologyImportConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedOntologyImportImpl).p3m = function (childId) {
    return childId.equals(OntologyImportConcept_getInstance().dh4_1.e6l_1) ? _get_ontologyField__fslpom(this) : childId.equals(OntologyImportConcept_getInstance().eh4_1.e6l_1) ? _get_elementField__q1p5qr_5(this) : childId.equals(OntologyImportConcept_getInstance().fh4_1.e6l_1) ? _get_libraryToUseField__uukqo8(this) : protoOf(TypedBTBNodeImpl).p3m.call(this, childId);
  };
  function _get_importsField__w7vue7_0($this) {
    if ($this.vkf_1 == null) {
      $this.vkf_1 = $this.g6l(OntologyImportRootConcept_getInstance().rh4_1);
    }
    return ensureNotNull($this.vkf_1);
  }
  function TypedOntologyImportRootImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? OntologyImportRootConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(OntologyImportRootConcept_getInstance().m6n_1) : nodeId;
    TypedDocumentNodeImpl.call(this, context, conceptId, nodeId);
    this.vkf_1 = null;
  }
  protoOf(TypedOntologyImportRootImpl).zfp = function () {
    return this.i6l(_get_importsField__w7vue7_0(this));
  };
  protoOf(TypedOntologyImportRootImpl).z3d = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.vkf_1 == null)) {
      this_0.j(OntologyImportRootConcept_getInstance().rh4_1.h6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedDocumentNodeImpl).z3d.call(this));
  };
  protoOf(TypedOntologyImportRootImpl).g3p = function (nodeId) {
    return new TypedOntologyImportRootImpl(this.j6k_1, OntologyImportRootConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedOntologyImportRootImpl).p3m = function (childId) {
    return childId.equals(OntologyImportRootConcept_getInstance().rh4_1.h6l_1) ? _get_importsField__w7vue7_0(this) : protoOf(TypedDocumentNodeImpl).p3m.call(this, childId);
  };
  function TypedOntologyImportRootReferenceImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? OntologyImportRootReferenceConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(OntologyImportRootReferenceConcept_getInstance().m6n_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.ikg_1 = null;
    this.jkg_1 = this.z6k(OntologyImportRootReferenceConcept_getInstance().eh5_1);
  }
  protoOf(TypedOntologyImportRootReferenceImpl).yfq = function () {
    return this.jkg_1;
  };
  protoOf(TypedOntologyImportRootReferenceImpl).c3e = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.ikg_1 == null)) {
      this_0.j(OntologyImportRootReferenceConcept_getInstance().eh5_1.a6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedBTBNodeImpl).c3e.call(this));
  };
  protoOf(TypedOntologyImportRootReferenceImpl).g3p = function (nodeId) {
    return new TypedOntologyImportRootReferenceImpl(this.j6k_1, OntologyImportRootReferenceConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedOntologyImportRootReferenceImpl).v6k = function (propertyId) {
    return propertyId.equals(OntologyImportRootReferenceConcept_getInstance().eh5_1.a6l_1) ? this.ikg_1 : protoOf(TypedBTBNodeImpl).v6k.call(this, propertyId);
  };
  protoOf(TypedOntologyImportRootReferenceImpl).w6k = function (propertyId, value) {
    if (propertyId.equals(OntologyImportRootReferenceConcept_getInstance().eh5_1.a6l_1)) {
      this.ikg_1 = value;
    } else {
      protoOf(TypedBTBNodeImpl).w6k.call(this, propertyId, value);
    }
  };
  function _get_elementReferenceProviderField__dm1eyf($this) {
    if ($this.wkg_1 == null) {
      $this.wkg_1 = $this.d6l(OntologyIsRelationConcept_getInstance().qh5_1);
    }
    return ensureNotNull($this.wkg_1);
  }
  function TypedOntologyIsRelationImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? OntologyIsRelationConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(OntologyIsRelationConcept_getInstance().m6n_1) : nodeId;
    TypedAbstractOntologyRelationImpl.call(this, context, conceptId, nodeId);
    this.wkg_1 = null;
  }
  protoOf(TypedOntologyIsRelationImpl).zfs = function () {
    return this.f6l(_get_elementReferenceProviderField__dm1eyf(this));
  };
  protoOf(TypedOntologyIsRelationImpl).z3d = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.wkg_1 == null)) {
      this_0.j(OntologyIsRelationConcept_getInstance().qh5_1.e6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedAbstractOntologyRelationImpl).z3d.call(this));
  };
  protoOf(TypedOntologyIsRelationImpl).g3p = function (nodeId) {
    return new TypedOntologyIsRelationImpl(this.j6k_1, OntologyIsRelationConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedOntologyIsRelationImpl).p3m = function (childId) {
    return childId.equals(OntologyIsRelationConcept_getInstance().qh5_1.e6l_1) ? _get_elementReferenceProviderField__dm1eyf(this) : protoOf(TypedAbstractOntologyRelationImpl).p3m.call(this, childId);
  };
  function _get_elementsField__lf2xhu_1($this) {
    if ($this.lkh_1 == null) {
      $this.lkh_1 = $this.g6l(OntologyLibraryConcept_getInstance().ch6_1);
    }
    return ensureNotNull($this.lkh_1);
  }
  function TypedOntologyLibraryImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? OntologyLibraryConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(OntologyLibraryConcept_getInstance().m6n_1) : nodeId;
    TypedDocumentNodeImpl.call(this, context, conceptId, nodeId);
    this.lkh_1 = null;
  }
  protoOf(TypedOntologyLibraryImpl).ifq = function () {
    return this.i6l(_get_elementsField__lf2xhu_1(this));
  };
  protoOf(TypedOntologyLibraryImpl).z3d = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.lkh_1 == null)) {
      this_0.j(OntologyLibraryConcept_getInstance().ch6_1.h6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedDocumentNodeImpl).z3d.call(this));
  };
  protoOf(TypedOntologyLibraryImpl).g3p = function (nodeId) {
    return new TypedOntologyLibraryImpl(this.j6k_1, OntologyLibraryConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedOntologyLibraryImpl).p3m = function (childId) {
    return childId.equals(OntologyLibraryConcept_getInstance().ch6_1.h6l_1) ? _get_elementsField__lf2xhu_1(this) : protoOf(TypedDocumentNodeImpl).p3m.call(this, childId);
  };
  function TypedOntologyLibraryReferenceImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? OntologyLibraryReferenceConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(OntologyLibraryReferenceConcept_getInstance().m6n_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.ykh_1 = null;
    this.zkh_1 = this.z6k(OntologyLibraryReferenceConcept_getInstance().ph6_1);
  }
  protoOf(TypedOntologyLibraryReferenceImpl).yfq = function () {
    return this.zkh_1;
  };
  protoOf(TypedOntologyLibraryReferenceImpl).c3e = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.ykh_1 == null)) {
      this_0.j(OntologyLibraryReferenceConcept_getInstance().ph6_1.a6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedBTBNodeImpl).c3e.call(this));
  };
  protoOf(TypedOntologyLibraryReferenceImpl).g3p = function (nodeId) {
    return new TypedOntologyLibraryReferenceImpl(this.j6k_1, OntologyLibraryReferenceConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedOntologyLibraryReferenceImpl).v6k = function (propertyId) {
    return propertyId.equals(OntologyLibraryReferenceConcept_getInstance().ph6_1.a6l_1) ? this.ykh_1 : protoOf(TypedBTBNodeImpl).v6k.call(this, propertyId);
  };
  protoOf(TypedOntologyLibraryReferenceImpl).w6k = function (propertyId, value) {
    if (propertyId.equals(OntologyLibraryReferenceConcept_getInstance().ph6_1.a6l_1)) {
      this.ykh_1 = value;
    } else {
      protoOf(TypedBTBNodeImpl).w6k.call(this, propertyId, value);
    }
  };
  function TypedOntologyLinkDeclarationValueQueryImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? OntologyLinkDeclarationValueQueryConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(OntologyLinkDeclarationValueQueryConcept_getInstance().m6n_1) : nodeId;
    TypedDeclarationValueQueryImpl.call(this, context, conceptId, nodeId);
    this.nki_1 = null;
    this.oki_1 = this.z6k(OntologyLinkDeclarationValueQueryConcept_getInstance().qh7_1);
  }
  protoOf(TypedOntologyLinkDeclarationValueQueryImpl).bft = function () {
    return this.oki_1;
  };
  protoOf(TypedOntologyLinkDeclarationValueQueryImpl).c3e = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.nki_1 == null)) {
      this_0.j(OntologyLinkDeclarationValueQueryConcept_getInstance().qh7_1.a6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedDeclarationValueQueryImpl).c3e.call(this));
  };
  protoOf(TypedOntologyLinkDeclarationValueQueryImpl).g3p = function (nodeId) {
    return new TypedOntologyLinkDeclarationValueQueryImpl(this.j6k_1, OntologyLinkDeclarationValueQueryConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedOntologyLinkDeclarationValueQueryImpl).v6k = function (propertyId) {
    return propertyId.equals(OntologyLinkDeclarationValueQueryConcept_getInstance().qh7_1.a6l_1) ? this.nki_1 : protoOf(TypedDeclarationValueQueryImpl).v6k.call(this, propertyId);
  };
  protoOf(TypedOntologyLinkDeclarationValueQueryImpl).w6k = function (propertyId, value) {
    if (propertyId.equals(OntologyLinkDeclarationValueQueryConcept_getInstance().qh7_1.a6l_1)) {
      this.nki_1 = value;
    } else {
      protoOf(TypedDeclarationValueQueryImpl).w6k.call(this, propertyId, value);
    }
  };
  function _get_linkField__e0eken($this) {
    if ($this.dkj_1 == null) {
      $this.dkj_1 = $this.d6l(OntologyLinkConcept_getInstance().ch7_1);
    }
    return ensureNotNull($this.dkj_1);
  }
  function _get_defaultLibraryReferenceField__tuthwe($this) {
    if ($this.ekj_1 == null) {
      $this.ekj_1 = $this.d6l(OntologyLinkConcept_getInstance().dh7_1);
    }
    return ensureNotNull($this.ekj_1);
  }
  function TypedOntologyLinkImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? OntologyLinkConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(OntologyLinkConcept_getInstance().m6n_1) : nodeId;
    TypedAbstractLinkImpl.call(this, context, conceptId, nodeId);
    this.dkj_1 = null;
    this.ekj_1 = null;
  }
  protoOf(TypedOntologyLinkImpl).xa1 = function () {
    return this.f6l(_get_linkField__e0eken(this));
  };
  protoOf(TypedOntologyLinkImpl).aft = function () {
    return this.f6l(_get_defaultLibraryReferenceField__tuthwe(this));
  };
  protoOf(TypedOntologyLinkImpl).z3d = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.dkj_1 == null)) {
      this_0.j(OntologyLinkConcept_getInstance().ch7_1.e6l_1);
    }
    if (!(this.ekj_1 == null)) {
      this_0.j(OntologyLinkConcept_getInstance().dh7_1.e6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedAbstractLinkImpl).z3d.call(this));
  };
  protoOf(TypedOntologyLinkImpl).g3p = function (nodeId) {
    return new TypedOntologyLinkImpl(this.j6k_1, OntologyLinkConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedOntologyLinkImpl).p3m = function (childId) {
    return childId.equals(OntologyLinkConcept_getInstance().ch7_1.e6l_1) ? _get_linkField__e0eken(this) : childId.equals(OntologyLinkConcept_getInstance().dh7_1.e6l_1) ? _get_defaultLibraryReferenceField__tuthwe(this) : protoOf(TypedAbstractLinkImpl).p3m.call(this, childId);
  };
  function TypedOntologyLinkValueImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? OntologyLinkValueConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(OntologyLinkValueConcept_getInstance().m6n_1) : nodeId;
    TypedAbstractBindingValueImpl.call(this, context, conceptId, nodeId);
    this.skj_1 = null;
    this.tkj_1 = this.z6k(OntologyLinkValueConcept_getInstance().dh8_1);
  }
  protoOf(TypedOntologyLinkValueImpl).cft = function () {
    return this.tkj_1;
  };
  protoOf(TypedOntologyLinkValueImpl).c3e = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.skj_1 == null)) {
      this_0.j(OntologyLinkValueConcept_getInstance().dh8_1.a6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedAbstractBindingValueImpl).c3e.call(this));
  };
  protoOf(TypedOntologyLinkValueImpl).g3p = function (nodeId) {
    return new TypedOntologyLinkValueImpl(this.j6k_1, OntologyLinkValueConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedOntologyLinkValueImpl).v6k = function (propertyId) {
    return propertyId.equals(OntologyLinkValueConcept_getInstance().dh8_1.a6l_1) ? this.skj_1 : protoOf(TypedAbstractBindingValueImpl).v6k.call(this, propertyId);
  };
  protoOf(TypedOntologyLinkValueImpl).w6k = function (propertyId, value) {
    if (propertyId.equals(OntologyLinkValueConcept_getInstance().dh8_1.a6l_1)) {
      this.skj_1 = value;
    } else {
      protoOf(TypedAbstractBindingValueImpl).w6k.call(this, propertyId, value);
    }
  };
  function _get_leftField__72ma9q($this) {
    if ($this.gkk_1 == null) {
      $this.gkk_1 = $this.d6l(OrValueQueryConcept_getInstance().qh8_1);
    }
    return ensureNotNull($this.gkk_1);
  }
  function _get_rightField__qpqtcd($this) {
    if ($this.hkk_1 == null) {
      $this.hkk_1 = $this.d6l(OrValueQueryConcept_getInstance().rh8_1);
    }
    return ensureNotNull($this.hkk_1);
  }
  function TypedOrValueQueryImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? OrValueQueryConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(OrValueQueryConcept_getInstance().m6n_1) : nodeId;
    TypedAbstractBindingValueQueryImpl.call(this, context, conceptId, nodeId);
    this.gkk_1 = null;
    this.hkk_1 = null;
  }
  protoOf(TypedOrValueQueryImpl).dft = function () {
    return this.f6l(_get_leftField__72ma9q(this));
  };
  protoOf(TypedOrValueQueryImpl).eft = function () {
    return this.f6l(_get_rightField__qpqtcd(this));
  };
  protoOf(TypedOrValueQueryImpl).z3d = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.gkk_1 == null)) {
      this_0.j(OrValueQueryConcept_getInstance().qh8_1.e6l_1);
    }
    if (!(this.hkk_1 == null)) {
      this_0.j(OrValueQueryConcept_getInstance().rh8_1.e6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedAbstractBindingValueQueryImpl).z3d.call(this));
  };
  protoOf(TypedOrValueQueryImpl).g3p = function (nodeId) {
    return new TypedOrValueQueryImpl(this.j6k_1, OrValueQueryConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedOrValueQueryImpl).p3m = function (childId) {
    return childId.equals(OrValueQueryConcept_getInstance().qh8_1.e6l_1) ? _get_leftField__72ma9q(this) : childId.equals(OrValueQueryConcept_getInstance().rh8_1.e6l_1) ? _get_rightField__qpqtcd(this) : protoOf(TypedAbstractBindingValueQueryImpl).p3m.call(this, childId);
  };
  function TypedPageImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? PageConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(PageConcept_getInstance().m6n_1) : nodeId;
    TypedPageSpecificationImpl.call(this, context, conceptId, nodeId);
    this.ukk_1 = null;
  }
  protoOf(TypedPageImpl).fft = function () {
    return this.x6k(PageConcept_getInstance().dh9_1);
  };
  protoOf(TypedPageImpl).c3e = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.ukk_1 == null)) {
      this_0.j(PageConcept_getInstance().dh9_1.m6o_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedPageSpecificationImpl).c3e.call(this));
  };
  protoOf(TypedPageImpl).g3p = function (nodeId) {
    return new TypedPageImpl(this.j6k_1, PageConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedPageImpl).v6k = function (propertyId) {
    return propertyId.equals(PageConcept_getInstance().dh9_1.m6o_1) ? this.ukk_1 : protoOf(TypedPageSpecificationImpl).v6k.call(this, propertyId);
  };
  protoOf(TypedPageImpl).w6k = function (propertyId, value) {
    if (propertyId.equals(PageConcept_getInstance().dh9_1.m6o_1)) {
      this.ukk_1 = value;
    } else {
      protoOf(TypedPageSpecificationImpl).w6k.call(this, propertyId, value);
    }
  };
  function TypedPageRangeImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? PageRangeConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(PageRangeConcept_getInstance().m6n_1) : nodeId;
    TypedPageSpecificationImpl.call(this, context, conceptId, nodeId);
    this.hkl_1 = null;
    this.ikl_1 = null;
  }
  protoOf(TypedPageRangeImpl).p1 = function () {
    return this.x6k(PageRangeConcept_getInstance().qh9_1);
  };
  protoOf(TypedPageRangeImpl).lb4 = function () {
    return this.x6k(PageRangeConcept_getInstance().rh9_1);
  };
  protoOf(TypedPageRangeImpl).c3e = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.hkl_1 == null)) {
      this_0.j(PageRangeConcept_getInstance().qh9_1.m6o_1);
    }
    if (!(this.ikl_1 == null)) {
      this_0.j(PageRangeConcept_getInstance().rh9_1.m6o_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedPageSpecificationImpl).c3e.call(this));
  };
  protoOf(TypedPageRangeImpl).g3p = function (nodeId) {
    return new TypedPageRangeImpl(this.j6k_1, PageRangeConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedPageRangeImpl).v6k = function (propertyId) {
    return propertyId.equals(PageRangeConcept_getInstance().qh9_1.m6o_1) ? this.hkl_1 : propertyId.equals(PageRangeConcept_getInstance().rh9_1.m6o_1) ? this.ikl_1 : protoOf(TypedPageSpecificationImpl).v6k.call(this, propertyId);
  };
  protoOf(TypedPageRangeImpl).w6k = function (propertyId, value) {
    if (propertyId.equals(PageRangeConcept_getInstance().qh9_1.m6o_1)) {
      this.hkl_1 = value;
    } else if (propertyId.equals(PageRangeConcept_getInstance().rh9_1.m6o_1)) {
      this.ikl_1 = value;
    } else {
      protoOf(TypedPageSpecificationImpl).w6k.call(this, propertyId, value);
    }
  };
  function TypedPageSpecificationImpl(context, conceptId, nodeId) {
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
  }
  function _get_pagesField__b06ncl($this) {
    if ($this.hkm_1 == null) {
      $this.hkm_1 = $this.d6l(PaperConcept_getInstance().rha_1);
    }
    return ensureNotNull($this.hkm_1);
  }
  function TypedPaperImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? PaperConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(PaperConcept_getInstance().m6n_1) : nodeId;
    TypedPublishedWorkImpl.call(this, context, conceptId, nodeId);
    this.akm_1 = null;
    this.bkm_1 = null;
    this.ckm_1 = null;
    this.dkm_1 = null;
    this.ekm_1 = null;
    this.fkm_1 = null;
    this.gkm_1 = null;
    this.hkm_1 = null;
  }
  protoOf(TypedPaperImpl).gft = function () {
    return this.x6k(PaperConcept_getInstance().kha_1);
  };
  protoOf(TypedPaperImpl).hft = function () {
    return this.x6k(PaperConcept_getInstance().lha_1);
  };
  protoOf(TypedPaperImpl).ift = function () {
    return this.x6k(PaperConcept_getInstance().mha_1);
  };
  protoOf(TypedPaperImpl).jft = function () {
    return this.x6k(PaperConcept_getInstance().nha_1);
  };
  protoOf(TypedPaperImpl).kft = function () {
    return this.x6k(PaperConcept_getInstance().oha_1);
  };
  protoOf(TypedPaperImpl).lft = function () {
    return this.x6k(PaperConcept_getInstance().pha_1);
  };
  protoOf(TypedPaperImpl).mft = function () {
    return this.x6k(PaperConcept_getInstance().qha_1);
  };
  protoOf(TypedPaperImpl).nft = function () {
    return this.f6l(_get_pagesField__b06ncl(this));
  };
  protoOf(TypedPaperImpl).c3e = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.akm_1 == null)) {
      this_0.j(PaperConcept_getInstance().kha_1.m6o_1);
    }
    if (!(this.bkm_1 == null)) {
      this_0.j(PaperConcept_getInstance().lha_1.m6o_1);
    }
    if (!(this.ckm_1 == null)) {
      this_0.j(PaperConcept_getInstance().mha_1.m6o_1);
    }
    if (!(this.dkm_1 == null)) {
      this_0.j(PaperConcept_getInstance().nha_1.m6o_1);
    }
    if (!(this.ekm_1 == null)) {
      this_0.j(PaperConcept_getInstance().oha_1.m6o_1);
    }
    if (!(this.fkm_1 == null)) {
      this_0.j(PaperConcept_getInstance().pha_1.m6o_1);
    }
    if (!(this.gkm_1 == null)) {
      this_0.j(PaperConcept_getInstance().qha_1.m6o_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedPublishedWorkImpl).c3e.call(this));
  };
  protoOf(TypedPaperImpl).z3d = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.hkm_1 == null)) {
      this_0.j(PaperConcept_getInstance().rha_1.e6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedPublishedWorkImpl).z3d.call(this));
  };
  protoOf(TypedPaperImpl).g3p = function (nodeId) {
    return new TypedPaperImpl(this.j6k_1, PaperConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedPaperImpl).v6k = function (propertyId) {
    return propertyId.equals(PaperConcept_getInstance().kha_1.m6o_1) ? this.akm_1 : propertyId.equals(PaperConcept_getInstance().lha_1.m6o_1) ? this.bkm_1 : propertyId.equals(PaperConcept_getInstance().mha_1.m6o_1) ? this.ckm_1 : propertyId.equals(PaperConcept_getInstance().nha_1.m6o_1) ? this.dkm_1 : propertyId.equals(PaperConcept_getInstance().oha_1.m6o_1) ? this.ekm_1 : propertyId.equals(PaperConcept_getInstance().pha_1.m6o_1) ? this.fkm_1 : propertyId.equals(PaperConcept_getInstance().qha_1.m6o_1) ? this.gkm_1 : protoOf(TypedPublishedWorkImpl).v6k.call(this, propertyId);
  };
  protoOf(TypedPaperImpl).w6k = function (propertyId, value) {
    if (propertyId.equals(PaperConcept_getInstance().kha_1.m6o_1)) {
      this.akm_1 = value;
    } else if (propertyId.equals(PaperConcept_getInstance().lha_1.m6o_1)) {
      this.bkm_1 = value;
    } else if (propertyId.equals(PaperConcept_getInstance().mha_1.m6o_1)) {
      this.ckm_1 = value;
    } else if (propertyId.equals(PaperConcept_getInstance().nha_1.m6o_1)) {
      this.dkm_1 = value;
    } else if (propertyId.equals(PaperConcept_getInstance().oha_1.m6o_1)) {
      this.ekm_1 = value;
    } else if (propertyId.equals(PaperConcept_getInstance().pha_1.m6o_1)) {
      this.fkm_1 = value;
    } else if (propertyId.equals(PaperConcept_getInstance().qha_1.m6o_1)) {
      this.gkm_1 = value;
    } else {
      protoOf(TypedPublishedWorkImpl).w6k.call(this, propertyId, value);
    }
  };
  protoOf(TypedPaperImpl).p3m = function (childId) {
    return childId.equals(PaperConcept_getInstance().rha_1.e6l_1) ? _get_pagesField__b06ncl(this) : protoOf(TypedPublishedWorkImpl).p3m.call(this, childId);
  };
  function TypedPartReferenceOperationImpl(context, conceptId, nodeId) {
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
  }
  function _get_operandField__fjb16i_0($this) {
    if ($this.ukm_1 == null) {
      $this.ukm_1 = $this.d6l(PartValueConcept_getInstance().ehb_1);
    }
    return ensureNotNull($this.ukm_1);
  }
  function _get_operationField__jv73iw($this) {
    if ($this.vkm_1 == null) {
      $this.vkm_1 = $this.d6l(PartValueConcept_getInstance().fhb_1);
    }
    return ensureNotNull($this.vkm_1);
  }
  function TypedPartValueImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? PartValueConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(PartValueConcept_getInstance().m6n_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.ukm_1 = null;
    this.vkm_1 = null;
  }
  protoOf(TypedPartValueImpl).jfs = function () {
    return this.f6l(_get_operandField__fjb16i_0(this));
  };
  protoOf(TypedPartValueImpl).s3z = function () {
    return this.f6l(_get_operationField__jv73iw(this));
  };
  protoOf(TypedPartValueImpl).z3d = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.ukm_1 == null)) {
      this_0.j(PartValueConcept_getInstance().ehb_1.e6l_1);
    }
    if (!(this.vkm_1 == null)) {
      this_0.j(PartValueConcept_getInstance().fhb_1.e6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedBTBNodeImpl).z3d.call(this));
  };
  protoOf(TypedPartValueImpl).g3p = function (nodeId) {
    return new TypedPartValueImpl(this.j6k_1, PartValueConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedPartValueImpl).p3m = function (childId) {
    return childId.equals(PartValueConcept_getInstance().ehb_1.e6l_1) ? _get_operandField__fjb16i_0(this) : childId.equals(PartValueConcept_getInstance().fhb_1.e6l_1) ? _get_operationField__jv73iw(this) : protoOf(TypedBTBNodeImpl).p3m.call(this, childId);
  };
  function TypedPatternImpl(context, conceptId, nodeId) {
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
  }
  function TypedPreconditionImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? PreconditionConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(PreconditionConcept_getInstance().m6n_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
  }
  protoOf(TypedPreconditionImpl).g3p = function (nodeId) {
    return new TypedPreconditionImpl(this.j6k_1, PreconditionConcept_getInstance().m6n_1, nodeId);
  };
  function TypedPrimitiveNotionTypeImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? PrimitiveNotionTypeConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(PrimitiveNotionTypeConcept_getInstance().m6n_1) : nodeId;
    TypedTypeImpl.call(this, context, conceptId, nodeId);
    this.ukn_1 = null;
  }
  protoOf(TypedPrimitiveNotionTypeImpl).oft = function () {
    return this.x6k(PrimitiveNotionTypeConcept_getInstance().thb_1);
  };
  protoOf(TypedPrimitiveNotionTypeImpl).c3e = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.ukn_1 == null)) {
      this_0.j(PrimitiveNotionTypeConcept_getInstance().thb_1.m6o_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedTypeImpl).c3e.call(this));
  };
  protoOf(TypedPrimitiveNotionTypeImpl).g3p = function (nodeId) {
    return new TypedPrimitiveNotionTypeImpl(this.j6k_1, PrimitiveNotionTypeConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedPrimitiveNotionTypeImpl).v6k = function (propertyId) {
    return propertyId.equals(PrimitiveNotionTypeConcept_getInstance().thb_1.m6o_1) ? this.ukn_1 : protoOf(TypedTypeImpl).v6k.call(this, propertyId);
  };
  protoOf(TypedPrimitiveNotionTypeImpl).w6k = function (propertyId, value) {
    if (propertyId.equals(PrimitiveNotionTypeConcept_getInstance().thb_1.m6o_1)) {
      this.ukn_1 = value;
    } else {
      protoOf(TypedTypeImpl).w6k.call(this, propertyId, value);
    }
  };
  function TypedPrimitivePropertyTypeImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? PrimitivePropertyTypeConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(PrimitivePropertyTypeConcept_getInstance().m6n_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.hko_1 = null;
  }
  protoOf(TypedPrimitivePropertyTypeImpl).oft = function () {
    return this.x6k(PrimitivePropertyTypeConcept_getInstance().ghc_1);
  };
  protoOf(TypedPrimitivePropertyTypeImpl).c3e = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.hko_1 == null)) {
      this_0.j(PrimitivePropertyTypeConcept_getInstance().ghc_1.m6o_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedBTBNodeImpl).c3e.call(this));
  };
  protoOf(TypedPrimitivePropertyTypeImpl).g3p = function (nodeId) {
    return new TypedPrimitivePropertyTypeImpl(this.j6k_1, PrimitivePropertyTypeConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedPrimitivePropertyTypeImpl).v6k = function (propertyId) {
    return propertyId.equals(PrimitivePropertyTypeConcept_getInstance().ghc_1.m6o_1) ? this.hko_1 : protoOf(TypedBTBNodeImpl).v6k.call(this, propertyId);
  };
  protoOf(TypedPrimitivePropertyTypeImpl).w6k = function (propertyId, value) {
    if (propertyId.equals(PrimitivePropertyTypeConcept_getInstance().ghc_1.m6o_1)) {
      this.hko_1 = value;
    } else {
      protoOf(TypedBTBNodeImpl).w6k.call(this, propertyId, value);
    }
  };
  function _get_inheritedField__w0x2ob($this) {
    if ($this.fkp_1 == null) {
      $this.fkp_1 = $this.g6l(ProcessDeclarationConcept_getInstance().dhd_1);
    }
    return ensureNotNull($this.fkp_1);
  }
  function _get_prerequisitesField__14p2ge($this) {
    if ($this.gkp_1 == null) {
      $this.gkp_1 = $this.g6l(ProcessDeclarationConcept_getInstance().ehd_1);
    }
    return ensureNotNull($this.gkp_1);
  }
  function _get_effectsField__xeo0mr($this) {
    if ($this.hkp_1 == null) {
      $this.hkp_1 = $this.g6l(ProcessDeclarationConcept_getInstance().fhd_1);
    }
    return ensureNotNull($this.hkp_1);
  }
  function _get_urlsField__vlz2xn($this) {
    if ($this.ikp_1 == null) {
      $this.ikp_1 = $this.g6l(ProcessDeclarationConcept_getInstance().ghd_1);
    }
    return ensureNotNull($this.ikp_1);
  }
  function _get_inheritedPropertiesField__wj6j8i($this) {
    if ($this.jkp_1 == null) {
      $this.jkp_1 = $this.g6l(ProcessDeclarationConcept_getInstance().hhd_1);
    }
    return ensureNotNull($this.jkp_1);
  }
  function _get_variablesField__8i4vo8_1($this) {
    if ($this.kkp_1 == null) {
      $this.kkp_1 = $this.g6l(HasVariablesConcept_getInstance().zgh_1);
    }
    return ensureNotNull($this.kkp_1);
  }
  function TypedProcessDeclarationImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? ProcessDeclarationConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ProcessDeclarationConcept_getInstance().m6n_1) : nodeId;
    TypedAbstractBindingDeclarationImpl.call(this, context, conceptId, nodeId);
    this.bkp_1 = null;
    this.ckp_1 = this.z6k(ProcessDeclarationConcept_getInstance().bhd_1);
    this.dkp_1 = null;
    this.ekp_1 = this.z6k(ProcessDeclarationConcept_getInstance().chd_1);
    this.fkp_1 = null;
    this.gkp_1 = null;
    this.hkp_1 = null;
    this.ikp_1 = null;
    this.jkp_1 = null;
    this.kkp_1 = null;
  }
  protoOf(TypedProcessDeclarationImpl).r5a = function () {
    return this.ckp_1;
  };
  protoOf(TypedProcessDeclarationImpl).pft = function () {
    return this.ekp_1;
  };
  protoOf(TypedProcessDeclarationImpl).qft = function () {
    return this.i6l(_get_inheritedField__w0x2ob(this));
  };
  protoOf(TypedProcessDeclarationImpl).rft = function () {
    return this.i6l(_get_prerequisitesField__14p2ge(this));
  };
  protoOf(TypedProcessDeclarationImpl).sft = function () {
    return this.i6l(_get_effectsField__xeo0mr(this));
  };
  protoOf(TypedProcessDeclarationImpl).tft = function () {
    return this.i6l(_get_urlsField__vlz2xn(this));
  };
  protoOf(TypedProcessDeclarationImpl).uft = function () {
    return this.i6l(_get_inheritedPropertiesField__wj6j8i(this));
  };
  protoOf(TypedProcessDeclarationImpl).rfr = function () {
    return this.i6l(_get_variablesField__8i4vo8_1(this));
  };
  protoOf(TypedProcessDeclarationImpl).c3e = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.bkp_1 == null)) {
      this_0.j(ProcessDeclarationConcept_getInstance().bhd_1.a6l_1);
    }
    if (!(this.dkp_1 == null)) {
      this_0.j(ProcessDeclarationConcept_getInstance().chd_1.a6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedAbstractBindingDeclarationImpl).c3e.call(this));
  };
  protoOf(TypedProcessDeclarationImpl).z3d = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.fkp_1 == null)) {
      this_0.j(ProcessDeclarationConcept_getInstance().dhd_1.h6l_1);
    }
    if (!(this.gkp_1 == null)) {
      this_0.j(ProcessDeclarationConcept_getInstance().ehd_1.h6l_1);
    }
    if (!(this.hkp_1 == null)) {
      this_0.j(ProcessDeclarationConcept_getInstance().fhd_1.h6l_1);
    }
    if (!(this.ikp_1 == null)) {
      this_0.j(ProcessDeclarationConcept_getInstance().ghd_1.h6l_1);
    }
    if (!(this.jkp_1 == null)) {
      this_0.j(ProcessDeclarationConcept_getInstance().hhd_1.h6l_1);
    }
    if (!(this.kkp_1 == null)) {
      this_0.j(HasVariablesConcept_getInstance().zgh_1.h6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedAbstractBindingDeclarationImpl).z3d.call(this));
  };
  protoOf(TypedProcessDeclarationImpl).g3p = function (nodeId) {
    return new TypedProcessDeclarationImpl(this.j6k_1, ProcessDeclarationConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedProcessDeclarationImpl).v6k = function (propertyId) {
    return propertyId.equals(ProcessDeclarationConcept_getInstance().bhd_1.a6l_1) ? this.bkp_1 : propertyId.equals(ProcessDeclarationConcept_getInstance().chd_1.a6l_1) ? this.dkp_1 : protoOf(TypedAbstractBindingDeclarationImpl).v6k.call(this, propertyId);
  };
  protoOf(TypedProcessDeclarationImpl).w6k = function (propertyId, value) {
    if (propertyId.equals(ProcessDeclarationConcept_getInstance().bhd_1.a6l_1)) {
      this.bkp_1 = value;
    } else if (propertyId.equals(ProcessDeclarationConcept_getInstance().chd_1.a6l_1)) {
      this.dkp_1 = value;
    } else {
      protoOf(TypedAbstractBindingDeclarationImpl).w6k.call(this, propertyId, value);
    }
  };
  protoOf(TypedProcessDeclarationImpl).p3m = function (childId) {
    return childId.equals(ProcessDeclarationConcept_getInstance().dhd_1.h6l_1) ? _get_inheritedField__w0x2ob(this) : childId.equals(ProcessDeclarationConcept_getInstance().ehd_1.h6l_1) ? _get_prerequisitesField__14p2ge(this) : childId.equals(ProcessDeclarationConcept_getInstance().fhd_1.h6l_1) ? _get_effectsField__xeo0mr(this) : childId.equals(ProcessDeclarationConcept_getInstance().ghd_1.h6l_1) ? _get_urlsField__vlz2xn(this) : childId.equals(ProcessDeclarationConcept_getInstance().hhd_1.h6l_1) ? _get_inheritedPropertiesField__wj6j8i(this) : childId.equals(HasVariablesConcept_getInstance().zgh_1.h6l_1) ? _get_variablesField__8i4vo8_1(this) : protoOf(TypedAbstractBindingDeclarationImpl).p3m.call(this, childId);
  };
  function _get_expressionField__tmo0lr_2($this) {
    if ($this.akq_1 == null) {
      $this.akq_1 = $this.d6l(HasFactExpressionConcept_getInstance().rgg_1);
    }
    return ensureNotNull($this.akq_1);
  }
  function TypedProcessEffectImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? ProcessEffectConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ProcessEffectConcept_getInstance().m6n_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.xkp_1 = null;
    this.ykp_1 = null;
    this.zkp_1 = null;
    this.akq_1 = null;
  }
  protoOf(TypedProcessEffectImpl).vft = function () {
    return this.x6k(ProcessEffectConcept_getInstance().thd_1);
  };
  protoOf(TypedProcessEffectImpl).pfr = function () {
    return this.x6k(HasQueryLabelsConcept_getInstance().qgh_1);
  };
  protoOf(TypedProcessEffectImpl).qfr = function () {
    return this.x6k(HasQueryLabelsConcept_getInstance().rgh_1);
  };
  protoOf(TypedProcessEffectImpl).mfr = function () {
    return this.f6l(_get_expressionField__tmo0lr_2(this));
  };
  protoOf(TypedProcessEffectImpl).c3e = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.xkp_1 == null)) {
      this_0.j(ProcessEffectConcept_getInstance().thd_1.m6o_1);
    }
    if (!(this.ykp_1 == null)) {
      this_0.j(HasQueryLabelsConcept_getInstance().qgh_1.m6o_1);
    }
    if (!(this.zkp_1 == null)) {
      this_0.j(HasQueryLabelsConcept_getInstance().rgh_1.m6o_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedBTBNodeImpl).c3e.call(this));
  };
  protoOf(TypedProcessEffectImpl).z3d = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.akq_1 == null)) {
      this_0.j(HasFactExpressionConcept_getInstance().rgg_1.e6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedBTBNodeImpl).z3d.call(this));
  };
  protoOf(TypedProcessEffectImpl).g3p = function (nodeId) {
    return new TypedProcessEffectImpl(this.j6k_1, ProcessEffectConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedProcessEffectImpl).v6k = function (propertyId) {
    return propertyId.equals(ProcessEffectConcept_getInstance().thd_1.m6o_1) ? this.xkp_1 : propertyId.equals(HasQueryLabelsConcept_getInstance().qgh_1.m6o_1) ? this.ykp_1 : propertyId.equals(HasQueryLabelsConcept_getInstance().rgh_1.m6o_1) ? this.zkp_1 : protoOf(TypedBTBNodeImpl).v6k.call(this, propertyId);
  };
  protoOf(TypedProcessEffectImpl).w6k = function (propertyId, value) {
    if (propertyId.equals(ProcessEffectConcept_getInstance().thd_1.m6o_1)) {
      this.xkp_1 = value;
    } else if (propertyId.equals(HasQueryLabelsConcept_getInstance().qgh_1.m6o_1)) {
      this.ykp_1 = value;
    } else if (propertyId.equals(HasQueryLabelsConcept_getInstance().rgh_1.m6o_1)) {
      this.zkp_1 = value;
    } else {
      protoOf(TypedBTBNodeImpl).w6k.call(this, propertyId, value);
    }
  };
  protoOf(TypedProcessEffectImpl).p3m = function (childId) {
    return childId.equals(HasFactExpressionConcept_getInstance().rgg_1.e6l_1) ? _get_expressionField__tmo0lr_2(this) : protoOf(TypedBTBNodeImpl).p3m.call(this, childId);
  };
  function _get_kindsField__xft4vk($this) {
    if ($this.pkq_1 == null) {
      $this.pkq_1 = $this.g6l(ProcessKindContainerConcept_getInstance().fhe_1);
    }
    return ensureNotNull($this.pkq_1);
  }
  function TypedProcessKindContainerImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? ProcessKindContainerConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ProcessKindContainerConcept_getInstance().m6n_1) : nodeId;
    TypedDocumentNodeImpl.call(this, context, conceptId, nodeId);
    this.pkq_1 = null;
  }
  protoOf(TypedProcessKindContainerImpl).wft = function () {
    return this.i6l(_get_kindsField__xft4vk(this));
  };
  protoOf(TypedProcessKindContainerImpl).z3d = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.pkq_1 == null)) {
      this_0.j(ProcessKindContainerConcept_getInstance().fhe_1.h6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedDocumentNodeImpl).z3d.call(this));
  };
  protoOf(TypedProcessKindContainerImpl).g3p = function (nodeId) {
    return new TypedProcessKindContainerImpl(this.j6k_1, ProcessKindContainerConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedProcessKindContainerImpl).p3m = function (childId) {
    return childId.equals(ProcessKindContainerConcept_getInstance().fhe_1.h6l_1) ? _get_kindsField__xft4vk(this) : protoOf(TypedDocumentNodeImpl).p3m.call(this, childId);
  };
  function TypedProcessKindImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? ProcessKindConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ProcessKindConcept_getInstance().m6n_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.ckr_1 = null;
  }
  protoOf(TypedProcessKindImpl).y2 = function () {
    return this.x6k(DirectlyNamedConcept_getInstance().chz_1);
  };
  protoOf(TypedProcessKindImpl).c3e = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.ckr_1 == null)) {
      this_0.j(DirectlyNamedConcept_getInstance().chz_1.m6o_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedBTBNodeImpl).c3e.call(this));
  };
  protoOf(TypedProcessKindImpl).g3p = function (nodeId) {
    return new TypedProcessKindImpl(this.j6k_1, ProcessKindConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedProcessKindImpl).v6k = function (propertyId) {
    return propertyId.equals(DirectlyNamedConcept_getInstance().chz_1.m6o_1) ? this.ckr_1 : protoOf(TypedBTBNodeImpl).v6k.call(this, propertyId);
  };
  protoOf(TypedProcessKindImpl).w6k = function (propertyId, value) {
    if (propertyId.equals(DirectlyNamedConcept_getInstance().chz_1.m6o_1)) {
      this.ckr_1 = value;
    } else {
      protoOf(TypedBTBNodeImpl).w6k.call(this, propertyId, value);
    }
  };
  function _get_processesField__sgfytq($this) {
    if ($this.rkr_1 == null) {
      $this.rkr_1 = $this.g6l(ProcessLibraryConcept_getInstance().rhe_1);
    }
    return ensureNotNull($this.rkr_1);
  }
  function TypedProcessLibraryImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? ProcessLibraryConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ProcessLibraryConcept_getInstance().m6n_1) : nodeId;
    TypedDocumentNodeImpl.call(this, context, conceptId, nodeId);
    this.rkr_1 = null;
  }
  protoOf(TypedProcessLibraryImpl).xft = function () {
    return this.i6l(_get_processesField__sgfytq(this));
  };
  protoOf(TypedProcessLibraryImpl).z3d = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.rkr_1 == null)) {
      this_0.j(ProcessLibraryConcept_getInstance().rhe_1.h6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedDocumentNodeImpl).z3d.call(this));
  };
  protoOf(TypedProcessLibraryImpl).g3p = function (nodeId) {
    return new TypedProcessLibraryImpl(this.j6k_1, ProcessLibraryConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedProcessLibraryImpl).p3m = function (childId) {
    return childId.equals(ProcessLibraryConcept_getInstance().rhe_1.h6l_1) ? _get_processesField__sgfytq(this) : protoOf(TypedDocumentNodeImpl).p3m.call(this, childId);
  };
  function _get_expressionField__tmo0lr_3($this) {
    if ($this.gks_1 == null) {
      $this.gks_1 = $this.d6l(HasFactExpressionConcept_getInstance().rgg_1);
    }
    return ensureNotNull($this.gks_1);
  }
  function TypedProcessPrerequisiteImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? ProcessPrerequisiteConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ProcessPrerequisiteConcept_getInstance().m6n_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.eks_1 = null;
    this.fks_1 = null;
    this.gks_1 = null;
  }
  protoOf(TypedProcessPrerequisiteImpl).pfr = function () {
    return this.x6k(HasQueryLabelsConcept_getInstance().qgh_1);
  };
  protoOf(TypedProcessPrerequisiteImpl).qfr = function () {
    return this.x6k(HasQueryLabelsConcept_getInstance().rgh_1);
  };
  protoOf(TypedProcessPrerequisiteImpl).mfr = function () {
    return this.f6l(_get_expressionField__tmo0lr_3(this));
  };
  protoOf(TypedProcessPrerequisiteImpl).c3e = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.eks_1 == null)) {
      this_0.j(HasQueryLabelsConcept_getInstance().qgh_1.m6o_1);
    }
    if (!(this.fks_1 == null)) {
      this_0.j(HasQueryLabelsConcept_getInstance().rgh_1.m6o_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedBTBNodeImpl).c3e.call(this));
  };
  protoOf(TypedProcessPrerequisiteImpl).z3d = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.gks_1 == null)) {
      this_0.j(HasFactExpressionConcept_getInstance().rgg_1.e6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedBTBNodeImpl).z3d.call(this));
  };
  protoOf(TypedProcessPrerequisiteImpl).g3p = function (nodeId) {
    return new TypedProcessPrerequisiteImpl(this.j6k_1, ProcessPrerequisiteConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedProcessPrerequisiteImpl).v6k = function (propertyId) {
    return propertyId.equals(HasQueryLabelsConcept_getInstance().qgh_1.m6o_1) ? this.eks_1 : propertyId.equals(HasQueryLabelsConcept_getInstance().rgh_1.m6o_1) ? this.fks_1 : protoOf(TypedBTBNodeImpl).v6k.call(this, propertyId);
  };
  protoOf(TypedProcessPrerequisiteImpl).w6k = function (propertyId, value) {
    if (propertyId.equals(HasQueryLabelsConcept_getInstance().qgh_1.m6o_1)) {
      this.eks_1 = value;
    } else if (propertyId.equals(HasQueryLabelsConcept_getInstance().rgh_1.m6o_1)) {
      this.fks_1 = value;
    } else {
      protoOf(TypedBTBNodeImpl).w6k.call(this, propertyId, value);
    }
  };
  protoOf(TypedProcessPrerequisiteImpl).p3m = function (childId) {
    return childId.equals(HasFactExpressionConcept_getInstance().rgg_1.e6l_1) ? _get_expressionField__tmo0lr_3(this) : protoOf(TypedBTBNodeImpl).p3m.call(this, childId);
  };
  function TypedProcessPropertyCustomCellImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? ProcessPropertyCustomCellConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ProcessPropertyCustomCellConcept_getInstance().m6n_1) : nodeId;
    TypedCustomCellImpl.call(this, context, conceptId, nodeId);
    this.tks_1 = null;
    this.uks_1 = this.z6k(ProcessPropertyCustomCellConcept_getInstance().uhf_1);
  }
  protoOf(TypedProcessPropertyCustomCellImpl).q6q = function () {
    return this.uks_1;
  };
  protoOf(TypedProcessPropertyCustomCellImpl).c3e = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.tks_1 == null)) {
      this_0.j(ProcessPropertyCustomCellConcept_getInstance().uhf_1.a6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedCustomCellImpl).c3e.call(this));
  };
  protoOf(TypedProcessPropertyCustomCellImpl).g3p = function (nodeId) {
    return new TypedProcessPropertyCustomCellImpl(this.j6k_1, ProcessPropertyCustomCellConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedProcessPropertyCustomCellImpl).v6k = function (propertyId) {
    return propertyId.equals(ProcessPropertyCustomCellConcept_getInstance().uhf_1.a6l_1) ? this.tks_1 : protoOf(TypedCustomCellImpl).v6k.call(this, propertyId);
  };
  protoOf(TypedProcessPropertyCustomCellImpl).w6k = function (propertyId, value) {
    if (propertyId.equals(ProcessPropertyCustomCellConcept_getInstance().uhf_1.a6l_1)) {
      this.tks_1 = value;
    } else {
      protoOf(TypedCustomCellImpl).w6k.call(this, propertyId, value);
    }
  };
  function _get_valueField__9y0rz6_5($this) {
    if ($this.hkt_1 == null) {
      $this.hkt_1 = $this.d6l(ProcessPropertyDefaultConcept_getInstance().ghg_1);
    }
    return ensureNotNull($this.hkt_1);
  }
  function TypedProcessPropertyDefaultImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? ProcessPropertyDefaultConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ProcessPropertyDefaultConcept_getInstance().m6n_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.hkt_1 = null;
  }
  protoOf(TypedProcessPropertyDefaultImpl).a1 = function () {
    return this.f6l(_get_valueField__9y0rz6_5(this));
  };
  protoOf(TypedProcessPropertyDefaultImpl).z3d = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.hkt_1 == null)) {
      this_0.j(ProcessPropertyDefaultConcept_getInstance().ghg_1.e6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedBTBNodeImpl).z3d.call(this));
  };
  protoOf(TypedProcessPropertyDefaultImpl).g3p = function (nodeId) {
    return new TypedProcessPropertyDefaultImpl(this.j6k_1, ProcessPropertyDefaultConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedProcessPropertyDefaultImpl).p3m = function (childId) {
    return childId.equals(ProcessPropertyDefaultConcept_getInstance().ghg_1.e6l_1) ? _get_valueField__9y0rz6_5(this) : protoOf(TypedBTBNodeImpl).p3m.call(this, childId);
  };
  function _get_typeField__jjl181_4($this) {
    if ($this.ukt_1 == null) {
      $this.ukt_1 = $this.d6l(ProcessPropertyConcept_getInstance().fhf_1);
    }
    return ensureNotNull($this.ukt_1);
  }
  function _get_aliasedPropertiesField__w72rv1($this) {
    if ($this.vkt_1 == null) {
      $this.vkt_1 = $this.g6l(ProcessPropertyConcept_getInstance().ghf_1);
    }
    return ensureNotNull($this.vkt_1);
  }
  function _get_defaultField__5h0hf6_0($this) {
    if ($this.wkt_1 == null) {
      $this.wkt_1 = $this.d6l(ProcessPropertyConcept_getInstance().hhf_1);
    }
    return ensureNotNull($this.wkt_1);
  }
  function TypedProcessPropertyImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? ProcessPropertyConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ProcessPropertyConcept_getInstance().m6n_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.ukt_1 = null;
    this.vkt_1 = null;
    this.wkt_1 = null;
    this.xkt_1 = null;
  }
  protoOf(TypedProcessPropertyImpl).sfq = function () {
    return this.f6l(_get_typeField__jjl181_4(this));
  };
  protoOf(TypedProcessPropertyImpl).yft = function () {
    return this.i6l(_get_aliasedPropertiesField__w72rv1(this));
  };
  protoOf(TypedProcessPropertyImpl).g3b = function () {
    return this.f6l(_get_defaultField__5h0hf6_0(this));
  };
  protoOf(TypedProcessPropertyImpl).y2 = function () {
    return this.x6k(DirectlyNamedConcept_getInstance().chz_1);
  };
  protoOf(TypedProcessPropertyImpl).c3e = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.xkt_1 == null)) {
      this_0.j(DirectlyNamedConcept_getInstance().chz_1.m6o_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedBTBNodeImpl).c3e.call(this));
  };
  protoOf(TypedProcessPropertyImpl).z3d = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.ukt_1 == null)) {
      this_0.j(ProcessPropertyConcept_getInstance().fhf_1.e6l_1);
    }
    if (!(this.vkt_1 == null)) {
      this_0.j(ProcessPropertyConcept_getInstance().ghf_1.h6l_1);
    }
    if (!(this.wkt_1 == null)) {
      this_0.j(ProcessPropertyConcept_getInstance().hhf_1.e6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedBTBNodeImpl).z3d.call(this));
  };
  protoOf(TypedProcessPropertyImpl).g3p = function (nodeId) {
    return new TypedProcessPropertyImpl(this.j6k_1, ProcessPropertyConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedProcessPropertyImpl).v6k = function (propertyId) {
    return propertyId.equals(DirectlyNamedConcept_getInstance().chz_1.m6o_1) ? this.xkt_1 : protoOf(TypedBTBNodeImpl).v6k.call(this, propertyId);
  };
  protoOf(TypedProcessPropertyImpl).w6k = function (propertyId, value) {
    if (propertyId.equals(DirectlyNamedConcept_getInstance().chz_1.m6o_1)) {
      this.xkt_1 = value;
    } else {
      protoOf(TypedBTBNodeImpl).w6k.call(this, propertyId, value);
    }
  };
  protoOf(TypedProcessPropertyImpl).p3m = function (childId) {
    return childId.equals(ProcessPropertyConcept_getInstance().fhf_1.e6l_1) ? _get_typeField__jjl181_4(this) : childId.equals(ProcessPropertyConcept_getInstance().ghf_1.h6l_1) ? _get_aliasedPropertiesField__w72rv1(this) : childId.equals(ProcessPropertyConcept_getInstance().hhf_1.e6l_1) ? _get_defaultField__5h0hf6_0(this) : protoOf(TypedBTBNodeImpl).p3m.call(this, childId);
  };
  function TypedProcessPropertyReferenceImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? ProcessPropertyReferenceConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ProcessPropertyReferenceConcept_getInstance().m6n_1) : nodeId;
    TypedVariableInitializerImpl.call(this, context, conceptId, nodeId);
    this.kku_1 = null;
    this.lku_1 = this.z6k(ProcessPropertyReferenceConcept_getInstance().thg_1);
  }
  protoOf(TypedProcessPropertyReferenceImpl).q6q = function () {
    return this.lku_1;
  };
  protoOf(TypedProcessPropertyReferenceImpl).c3e = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.kku_1 == null)) {
      this_0.j(ProcessPropertyReferenceConcept_getInstance().thg_1.a6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedVariableInitializerImpl).c3e.call(this));
  };
  protoOf(TypedProcessPropertyReferenceImpl).g3p = function (nodeId) {
    return new TypedProcessPropertyReferenceImpl(this.j6k_1, ProcessPropertyReferenceConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedProcessPropertyReferenceImpl).v6k = function (propertyId) {
    return propertyId.equals(ProcessPropertyReferenceConcept_getInstance().thg_1.a6l_1) ? this.kku_1 : protoOf(TypedVariableInitializerImpl).v6k.call(this, propertyId);
  };
  protoOf(TypedProcessPropertyReferenceImpl).w6k = function (propertyId, value) {
    if (propertyId.equals(ProcessPropertyReferenceConcept_getInstance().thg_1.a6l_1)) {
      this.kku_1 = value;
    } else {
      protoOf(TypedVariableInitializerImpl).w6k.call(this, propertyId, value);
    }
  };
  function _get_valueField__9y0rz6_6($this) {
    if ($this.akv_1 == null) {
      $this.akv_1 = $this.d6l(ProcessPropertyValueConcept_getInstance().ihh_1);
    }
    return ensureNotNull($this.akv_1);
  }
  function TypedProcessPropertyValueImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? ProcessPropertyValueConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ProcessPropertyValueConcept_getInstance().m6n_1) : nodeId;
    TypedBindingValuePlaceholderImpl.call(this, context, conceptId, nodeId);
    this.yku_1 = null;
    this.zku_1 = this.z6k(ProcessPropertyValueConcept_getInstance().hhh_1);
    this.akv_1 = null;
    this.bkv_1 = null;
    this.ckv_1 = null;
  }
  protoOf(TypedProcessPropertyValueImpl).q6q = function () {
    return this.zku_1;
  };
  protoOf(TypedProcessPropertyValueImpl).a1 = function () {
    return this.f6l(_get_valueField__9y0rz6_6(this));
  };
  protoOf(TypedProcessPropertyValueImpl).pfr = function () {
    return this.x6k(HasQueryLabelsConcept_getInstance().qgh_1);
  };
  protoOf(TypedProcessPropertyValueImpl).qfr = function () {
    return this.x6k(HasQueryLabelsConcept_getInstance().rgh_1);
  };
  protoOf(TypedProcessPropertyValueImpl).c3e = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.yku_1 == null)) {
      this_0.j(ProcessPropertyValueConcept_getInstance().hhh_1.a6l_1);
    }
    if (!(this.bkv_1 == null)) {
      this_0.j(HasQueryLabelsConcept_getInstance().qgh_1.m6o_1);
    }
    if (!(this.ckv_1 == null)) {
      this_0.j(HasQueryLabelsConcept_getInstance().rgh_1.m6o_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedBindingValuePlaceholderImpl).c3e.call(this));
  };
  protoOf(TypedProcessPropertyValueImpl).z3d = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.akv_1 == null)) {
      this_0.j(ProcessPropertyValueConcept_getInstance().ihh_1.e6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedBindingValuePlaceholderImpl).z3d.call(this));
  };
  protoOf(TypedProcessPropertyValueImpl).g3p = function (nodeId) {
    return new TypedProcessPropertyValueImpl(this.j6k_1, ProcessPropertyValueConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedProcessPropertyValueImpl).v6k = function (propertyId) {
    return propertyId.equals(ProcessPropertyValueConcept_getInstance().hhh_1.a6l_1) ? this.yku_1 : propertyId.equals(HasQueryLabelsConcept_getInstance().qgh_1.m6o_1) ? this.bkv_1 : propertyId.equals(HasQueryLabelsConcept_getInstance().rgh_1.m6o_1) ? this.ckv_1 : protoOf(TypedBindingValuePlaceholderImpl).v6k.call(this, propertyId);
  };
  protoOf(TypedProcessPropertyValueImpl).w6k = function (propertyId, value) {
    if (propertyId.equals(ProcessPropertyValueConcept_getInstance().hhh_1.a6l_1)) {
      this.yku_1 = value;
    } else if (propertyId.equals(HasQueryLabelsConcept_getInstance().qgh_1.m6o_1)) {
      this.bkv_1 = value;
    } else if (propertyId.equals(HasQueryLabelsConcept_getInstance().rgh_1.m6o_1)) {
      this.ckv_1 = value;
    } else {
      protoOf(TypedBindingValuePlaceholderImpl).w6k.call(this, propertyId, value);
    }
  };
  protoOf(TypedProcessPropertyValueImpl).p3m = function (childId) {
    return childId.equals(ProcessPropertyValueConcept_getInstance().ihh_1.e6l_1) ? _get_valueField__9y0rz6_6(this) : protoOf(TypedBindingValuePlaceholderImpl).p3m.call(this, childId);
  };
  function TypedProcessReferenceImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? ProcessReferenceConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ProcessReferenceConcept_getInstance().m6n_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.pkv_1 = null;
    this.qkv_1 = this.z6k(ProcessReferenceConcept_getInstance().vhh_1);
  }
  protoOf(TypedProcessReferenceImpl).vfr = function () {
    return this.qkv_1;
  };
  protoOf(TypedProcessReferenceImpl).c3e = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.pkv_1 == null)) {
      this_0.j(ProcessReferenceConcept_getInstance().vhh_1.a6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedBTBNodeImpl).c3e.call(this));
  };
  protoOf(TypedProcessReferenceImpl).g3p = function (nodeId) {
    return new TypedProcessReferenceImpl(this.j6k_1, ProcessReferenceConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedProcessReferenceImpl).v6k = function (propertyId) {
    return propertyId.equals(ProcessReferenceConcept_getInstance().vhh_1.a6l_1) ? this.pkv_1 : protoOf(TypedBTBNodeImpl).v6k.call(this, propertyId);
  };
  protoOf(TypedProcessReferenceImpl).w6k = function (propertyId, value) {
    if (propertyId.equals(ProcessReferenceConcept_getInstance().vhh_1.a6l_1)) {
      this.pkv_1 = value;
    } else {
      protoOf(TypedBTBNodeImpl).w6k.call(this, propertyId, value);
    }
  };
  function TypedProcessRelationDeclarationImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? ProcessRelationDeclarationConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ProcessRelationDeclarationConcept_getInstance().m6n_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.dkw_1 = null;
    this.ekw_1 = null;
    this.fkw_1 = null;
    this.gkw_1 = null;
  }
  protoOf(TypedProcessRelationDeclarationImpl).zft = function () {
    return this.x6k(ProcessRelationDeclarationConcept_getInstance().nhi_1);
  };
  protoOf(TypedProcessRelationDeclarationImpl).afu = function () {
    return this.x6k(ProcessRelationDeclarationConcept_getInstance().ohi_1);
  };
  protoOf(TypedProcessRelationDeclarationImpl).bfu = function () {
    return this.x6k(ProcessRelationDeclarationConcept_getInstance().phi_1);
  };
  protoOf(TypedProcessRelationDeclarationImpl).y2 = function () {
    return this.x6k(DirectlyNamedConcept_getInstance().chz_1);
  };
  protoOf(TypedProcessRelationDeclarationImpl).c3e = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.dkw_1 == null)) {
      this_0.j(ProcessRelationDeclarationConcept_getInstance().nhi_1.m6o_1);
    }
    if (!(this.ekw_1 == null)) {
      this_0.j(ProcessRelationDeclarationConcept_getInstance().ohi_1.m6o_1);
    }
    if (!(this.fkw_1 == null)) {
      this_0.j(ProcessRelationDeclarationConcept_getInstance().phi_1.m6o_1);
    }
    if (!(this.gkw_1 == null)) {
      this_0.j(DirectlyNamedConcept_getInstance().chz_1.m6o_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedBTBNodeImpl).c3e.call(this));
  };
  protoOf(TypedProcessRelationDeclarationImpl).g3p = function (nodeId) {
    return new TypedProcessRelationDeclarationImpl(this.j6k_1, ProcessRelationDeclarationConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedProcessRelationDeclarationImpl).v6k = function (propertyId) {
    return propertyId.equals(ProcessRelationDeclarationConcept_getInstance().nhi_1.m6o_1) ? this.dkw_1 : propertyId.equals(ProcessRelationDeclarationConcept_getInstance().ohi_1.m6o_1) ? this.ekw_1 : propertyId.equals(ProcessRelationDeclarationConcept_getInstance().phi_1.m6o_1) ? this.fkw_1 : propertyId.equals(DirectlyNamedConcept_getInstance().chz_1.m6o_1) ? this.gkw_1 : protoOf(TypedBTBNodeImpl).v6k.call(this, propertyId);
  };
  protoOf(TypedProcessRelationDeclarationImpl).w6k = function (propertyId, value) {
    if (propertyId.equals(ProcessRelationDeclarationConcept_getInstance().nhi_1.m6o_1)) {
      this.dkw_1 = value;
    } else if (propertyId.equals(ProcessRelationDeclarationConcept_getInstance().ohi_1.m6o_1)) {
      this.ekw_1 = value;
    } else if (propertyId.equals(ProcessRelationDeclarationConcept_getInstance().phi_1.m6o_1)) {
      this.fkw_1 = value;
    } else if (propertyId.equals(DirectlyNamedConcept_getInstance().chz_1.m6o_1)) {
      this.gkw_1 = value;
    } else {
      protoOf(TypedBTBNodeImpl).w6k.call(this, propertyId, value);
    }
  };
  function _get_specificationField__lszznw_0($this) {
    if ($this.tkw_1 == null) {
      $this.tkw_1 = $this.d6l(ProcessTypeConcept_getInstance().bhj_1);
    }
    return ensureNotNull($this.tkw_1);
  }
  function TypedProcessTypeImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? ProcessTypeConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ProcessTypeConcept_getInstance().m6n_1) : nodeId;
    TypedTypeImpl.call(this, context, conceptId, nodeId);
    this.tkw_1 = null;
  }
  protoOf(TypedProcessTypeImpl).vfq = function () {
    return this.f6l(_get_specificationField__lszznw_0(this));
  };
  protoOf(TypedProcessTypeImpl).z3d = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.tkw_1 == null)) {
      this_0.j(ProcessTypeConcept_getInstance().bhj_1.e6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedTypeImpl).z3d.call(this));
  };
  protoOf(TypedProcessTypeImpl).g3p = function (nodeId) {
    return new TypedProcessTypeImpl(this.j6k_1, ProcessTypeConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedProcessTypeImpl).p3m = function (childId) {
    return childId.equals(ProcessTypeConcept_getInstance().bhj_1.e6l_1) ? _get_specificationField__lszznw_0(this) : protoOf(TypedTypeImpl).p3m.call(this, childId);
  };
  function TypedPropertiesCustomCellImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? PropertiesCustomCellConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(PropertiesCustomCellConcept_getInstance().m6n_1) : nodeId;
    TypedCustomCellImpl.call(this, context, conceptId, nodeId);
  }
  protoOf(TypedPropertiesCustomCellImpl).g3p = function (nodeId) {
    return new TypedPropertiesCustomCellImpl(this.j6k_1, PropertiesCustomCellConcept_getInstance().m6n_1, nodeId);
  };
  function _get_valueField__9y0rz6_7($this) {
    if ($this.vkx_1 == null) {
      $this.vkx_1 = $this.d6l(PropertyConstraintConcept_getInstance().thj_1);
    }
    return ensureNotNull($this.vkx_1);
  }
  function _get_constraintsField__3m7315_1($this) {
    if ($this.wkx_1 == null) {
      $this.wkx_1 = $this.g6l(HasPropertyConstraintsConcept_getInstance().hgh_1);
    }
    return ensureNotNull($this.wkx_1);
  }
  function TypedPropertyConstraintImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? PropertyConstraintConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(PropertyConstraintConcept_getInstance().m6n_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.skx_1 = null;
    this.tkx_1 = null;
    this.ukx_1 = this.z6k(PropertyConstraintConcept_getInstance().shj_1);
    this.vkx_1 = null;
    this.wkx_1 = null;
  }
  protoOf(TypedPropertyConstraintImpl).s3z = function () {
    return this.x6k(PropertyConstraintConcept_getInstance().rhj_1);
  };
  protoOf(TypedPropertyConstraintImpl).q6q = function () {
    return this.ukx_1;
  };
  protoOf(TypedPropertyConstraintImpl).a1 = function () {
    return this.f6l(_get_valueField__9y0rz6_7(this));
  };
  protoOf(TypedPropertyConstraintImpl).ofr = function () {
    return this.i6l(_get_constraintsField__3m7315_1(this));
  };
  protoOf(TypedPropertyConstraintImpl).c3e = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.skx_1 == null)) {
      this_0.j(PropertyConstraintConcept_getInstance().rhj_1.m6o_1);
    }
    if (!(this.tkx_1 == null)) {
      this_0.j(PropertyConstraintConcept_getInstance().shj_1.a6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedBTBNodeImpl).c3e.call(this));
  };
  protoOf(TypedPropertyConstraintImpl).z3d = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.vkx_1 == null)) {
      this_0.j(PropertyConstraintConcept_getInstance().thj_1.e6l_1);
    }
    if (!(this.wkx_1 == null)) {
      this_0.j(HasPropertyConstraintsConcept_getInstance().hgh_1.h6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedBTBNodeImpl).z3d.call(this));
  };
  protoOf(TypedPropertyConstraintImpl).g3p = function (nodeId) {
    return new TypedPropertyConstraintImpl(this.j6k_1, PropertyConstraintConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedPropertyConstraintImpl).v6k = function (propertyId) {
    return propertyId.equals(PropertyConstraintConcept_getInstance().rhj_1.m6o_1) ? this.skx_1 : propertyId.equals(PropertyConstraintConcept_getInstance().shj_1.a6l_1) ? this.tkx_1 : protoOf(TypedBTBNodeImpl).v6k.call(this, propertyId);
  };
  protoOf(TypedPropertyConstraintImpl).w6k = function (propertyId, value) {
    if (propertyId.equals(PropertyConstraintConcept_getInstance().rhj_1.m6o_1)) {
      this.skx_1 = value;
    } else if (propertyId.equals(PropertyConstraintConcept_getInstance().shj_1.a6l_1)) {
      this.tkx_1 = value;
    } else {
      protoOf(TypedBTBNodeImpl).w6k.call(this, propertyId, value);
    }
  };
  protoOf(TypedPropertyConstraintImpl).p3m = function (childId) {
    return childId.equals(PropertyConstraintConcept_getInstance().thj_1.e6l_1) ? _get_valueField__9y0rz6_7(this) : childId.equals(HasPropertyConstraintsConcept_getInstance().hgh_1.h6l_1) ? _get_constraintsField__3m7315_1(this) : protoOf(TypedBTBNodeImpl).p3m.call(this, childId);
  };
  function TypedPropertyCustomCellImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? PropertyCustomCellConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(PropertyCustomCellConcept_getInstance().m6n_1) : nodeId;
    TypedCustomCellImpl.call(this, context, conceptId, nodeId);
    this.jky_1 = null;
    this.kky_1 = this.z6k(PropertyCustomCellConcept_getInstance().hhk_1);
  }
  protoOf(TypedPropertyCustomCellImpl).q6q = function () {
    return this.kky_1;
  };
  protoOf(TypedPropertyCustomCellImpl).c3e = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.jky_1 == null)) {
      this_0.j(PropertyCustomCellConcept_getInstance().hhk_1.a6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedCustomCellImpl).c3e.call(this));
  };
  protoOf(TypedPropertyCustomCellImpl).g3p = function (nodeId) {
    return new TypedPropertyCustomCellImpl(this.j6k_1, PropertyCustomCellConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedPropertyCustomCellImpl).v6k = function (propertyId) {
    return propertyId.equals(PropertyCustomCellConcept_getInstance().hhk_1.a6l_1) ? this.jky_1 : protoOf(TypedCustomCellImpl).v6k.call(this, propertyId);
  };
  protoOf(TypedPropertyCustomCellImpl).w6k = function (propertyId, value) {
    if (propertyId.equals(PropertyCustomCellConcept_getInstance().hhk_1.a6l_1)) {
      this.jky_1 = value;
    } else {
      protoOf(TypedCustomCellImpl).w6k.call(this, propertyId, value);
    }
  };
  function _get_typeField__jjl181_5($this) {
    if ($this.xky_1 == null) {
      $this.xky_1 = $this.d6l(PropertyDeclarationConcept_getInstance().thk_1);
    }
    return ensureNotNull($this.xky_1);
  }
  function TypedPropertyDeclarationImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? PropertyDeclarationConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(PropertyDeclarationConcept_getInstance().m6n_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.xky_1 = null;
    this.yky_1 = null;
  }
  protoOf(TypedPropertyDeclarationImpl).sfq = function () {
    return this.f6l(_get_typeField__jjl181_5(this));
  };
  protoOf(TypedPropertyDeclarationImpl).y2 = function () {
    return this.x6k(DirectlyNamedConcept_getInstance().chz_1);
  };
  protoOf(TypedPropertyDeclarationImpl).c3e = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.yky_1 == null)) {
      this_0.j(DirectlyNamedConcept_getInstance().chz_1.m6o_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedBTBNodeImpl).c3e.call(this));
  };
  protoOf(TypedPropertyDeclarationImpl).z3d = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.xky_1 == null)) {
      this_0.j(PropertyDeclarationConcept_getInstance().thk_1.e6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedBTBNodeImpl).z3d.call(this));
  };
  protoOf(TypedPropertyDeclarationImpl).g3p = function (nodeId) {
    return new TypedPropertyDeclarationImpl(this.j6k_1, PropertyDeclarationConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedPropertyDeclarationImpl).v6k = function (propertyId) {
    return propertyId.equals(DirectlyNamedConcept_getInstance().chz_1.m6o_1) ? this.yky_1 : protoOf(TypedBTBNodeImpl).v6k.call(this, propertyId);
  };
  protoOf(TypedPropertyDeclarationImpl).w6k = function (propertyId, value) {
    if (propertyId.equals(DirectlyNamedConcept_getInstance().chz_1.m6o_1)) {
      this.yky_1 = value;
    } else {
      protoOf(TypedBTBNodeImpl).w6k.call(this, propertyId, value);
    }
  };
  protoOf(TypedPropertyDeclarationImpl).p3m = function (childId) {
    return childId.equals(PropertyDeclarationConcept_getInstance().thk_1.e6l_1) ? _get_typeField__jjl181_5(this) : protoOf(TypedBTBNodeImpl).p3m.call(this, childId);
  };
  function TypedPropertyDeclarationValueQueryImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? PropertyDeclarationValueQueryConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(PropertyDeclarationValueQueryConcept_getInstance().m6n_1) : nodeId;
    TypedDeclarationValueQueryImpl.call(this, context, conceptId, nodeId);
    this.mkz_1 = null;
    this.nkz_1 = this.z6k(PropertyDeclarationValueQueryConcept_getInstance().ghl_1);
  }
  protoOf(TypedPropertyDeclarationValueQueryImpl).cfu = function () {
    return this.nkz_1;
  };
  protoOf(TypedPropertyDeclarationValueQueryImpl).c3e = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.mkz_1 == null)) {
      this_0.j(PropertyDeclarationValueQueryConcept_getInstance().ghl_1.a6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedDeclarationValueQueryImpl).c3e.call(this));
  };
  protoOf(TypedPropertyDeclarationValueQueryImpl).g3p = function (nodeId) {
    return new TypedPropertyDeclarationValueQueryImpl(this.j6k_1, PropertyDeclarationValueQueryConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedPropertyDeclarationValueQueryImpl).v6k = function (propertyId) {
    return propertyId.equals(PropertyDeclarationValueQueryConcept_getInstance().ghl_1.a6l_1) ? this.mkz_1 : protoOf(TypedDeclarationValueQueryImpl).v6k.call(this, propertyId);
  };
  protoOf(TypedPropertyDeclarationValueQueryImpl).w6k = function (propertyId, value) {
    if (propertyId.equals(PropertyDeclarationValueQueryConcept_getInstance().ghl_1.a6l_1)) {
      this.mkz_1 = value;
    } else {
      protoOf(TypedDeclarationValueQueryImpl).w6k.call(this, propertyId, value);
    }
  };
  function _get_elementsField__lf2xhu_2($this) {
    if ($this.cl0_1 == null) {
      $this.cl0_1 = $this.g6l(PropertyLibraryConcept_getInstance().shl_1);
    }
    return ensureNotNull($this.cl0_1);
  }
  function TypedPropertyLibraryImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? PropertyLibraryConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(PropertyLibraryConcept_getInstance().m6n_1) : nodeId;
    TypedDocumentNodeImpl.call(this, context, conceptId, nodeId);
    this.cl0_1 = null;
  }
  protoOf(TypedPropertyLibraryImpl).ifq = function () {
    return this.i6l(_get_elementsField__lf2xhu_2(this));
  };
  protoOf(TypedPropertyLibraryImpl).z3d = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.cl0_1 == null)) {
      this_0.j(PropertyLibraryConcept_getInstance().shl_1.h6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedDocumentNodeImpl).z3d.call(this));
  };
  protoOf(TypedPropertyLibraryImpl).g3p = function (nodeId) {
    return new TypedPropertyLibraryImpl(this.j6k_1, PropertyLibraryConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedPropertyLibraryImpl).p3m = function (childId) {
    return childId.equals(PropertyLibraryConcept_getInstance().shl_1.h6l_1) ? _get_elementsField__lf2xhu_2(this) : protoOf(TypedDocumentNodeImpl).p3m.call(this, childId);
  };
  function _get_parameterField__e0nesm($this) {
    if ($this.rl0_1 == null) {
      $this.rl0_1 = $this.d6l(PropertyReferenceOperationConcept_getInstance().hhm_1);
    }
    return ensureNotNull($this.rl0_1);
  }
  function TypedPropertyReferenceOperationImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? PropertyReferenceOperationConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(PropertyReferenceOperationConcept_getInstance().m6n_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.pl0_1 = null;
    this.ql0_1 = this.z6k(PropertyReferenceOperationConcept_getInstance().ghm_1);
    this.rl0_1 = null;
  }
  protoOf(TypedPropertyReferenceOperationImpl).q6q = function () {
    return this.ql0_1;
  };
  protoOf(TypedPropertyReferenceOperationImpl).dfu = function () {
    return this.f6l(_get_parameterField__e0nesm(this));
  };
  protoOf(TypedPropertyReferenceOperationImpl).c3e = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.pl0_1 == null)) {
      this_0.j(PropertyReferenceOperationConcept_getInstance().ghm_1.a6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedBTBNodeImpl).c3e.call(this));
  };
  protoOf(TypedPropertyReferenceOperationImpl).z3d = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.rl0_1 == null)) {
      this_0.j(PropertyReferenceOperationConcept_getInstance().hhm_1.e6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedBTBNodeImpl).z3d.call(this));
  };
  protoOf(TypedPropertyReferenceOperationImpl).g3p = function (nodeId) {
    return new TypedPropertyReferenceOperationImpl(this.j6k_1, PropertyReferenceOperationConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedPropertyReferenceOperationImpl).v6k = function (propertyId) {
    return propertyId.equals(PropertyReferenceOperationConcept_getInstance().ghm_1.a6l_1) ? this.pl0_1 : protoOf(TypedBTBNodeImpl).v6k.call(this, propertyId);
  };
  protoOf(TypedPropertyReferenceOperationImpl).w6k = function (propertyId, value) {
    if (propertyId.equals(PropertyReferenceOperationConcept_getInstance().ghm_1.a6l_1)) {
      this.pl0_1 = value;
    } else {
      protoOf(TypedBTBNodeImpl).w6k.call(this, propertyId, value);
    }
  };
  protoOf(TypedPropertyReferenceOperationImpl).p3m = function (childId) {
    return childId.equals(PropertyReferenceOperationConcept_getInstance().hhm_1.e6l_1) ? _get_parameterField__e0nesm(this) : protoOf(TypedBTBNodeImpl).p3m.call(this, childId);
  };
  function TypedPropertyValueImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? PropertyValueConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(PropertyValueConcept_getInstance().m6n_1) : nodeId;
    TypedAbstractBindingValueImpl.call(this, context, conceptId, nodeId);
    this.fl1_1 = null;
    this.gl1_1 = this.z6k(PropertyValueConcept_getInstance().uhm_1);
  }
  protoOf(TypedPropertyValueImpl).q6q = function () {
    return this.gl1_1;
  };
  protoOf(TypedPropertyValueImpl).c3e = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.fl1_1 == null)) {
      this_0.j(PropertyValueConcept_getInstance().uhm_1.a6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedAbstractBindingValueImpl).c3e.call(this));
  };
  protoOf(TypedPropertyValueImpl).g3p = function (nodeId) {
    return new TypedPropertyValueImpl(this.j6k_1, PropertyValueConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedPropertyValueImpl).v6k = function (propertyId) {
    return propertyId.equals(PropertyValueConcept_getInstance().uhm_1.a6l_1) ? this.fl1_1 : protoOf(TypedAbstractBindingValueImpl).v6k.call(this, propertyId);
  };
  protoOf(TypedPropertyValueImpl).w6k = function (propertyId, value) {
    if (propertyId.equals(PropertyValueConcept_getInstance().uhm_1.a6l_1)) {
      this.fl1_1 = value;
    } else {
      protoOf(TypedAbstractBindingValueImpl).w6k.call(this, propertyId, value);
    }
  };
  function TypedPropertyValueRangeImpl(context, conceptId, nodeId) {
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
  }
  function TypedPubMedSourceReferenceImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? PubMedSourceReferenceConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(PubMedSourceReferenceConcept_getInstance().m6n_1) : nodeId;
    TypedKnowledgeSourceReferenceImpl.call(this, context, conceptId, nodeId);
    this.tl1_1 = null;
  }
  protoOf(TypedPubMedSourceReferenceImpl).kft = function () {
    return this.x6k(PubMedSourceReferenceConcept_getInstance().ghn_1);
  };
  protoOf(TypedPubMedSourceReferenceImpl).c3e = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.tl1_1 == null)) {
      this_0.j(PubMedSourceReferenceConcept_getInstance().ghn_1.m6o_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedKnowledgeSourceReferenceImpl).c3e.call(this));
  };
  protoOf(TypedPubMedSourceReferenceImpl).g3p = function (nodeId) {
    return new TypedPubMedSourceReferenceImpl(this.j6k_1, PubMedSourceReferenceConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedPubMedSourceReferenceImpl).v6k = function (propertyId) {
    return propertyId.equals(PubMedSourceReferenceConcept_getInstance().ghn_1.m6o_1) ? this.tl1_1 : protoOf(TypedKnowledgeSourceReferenceImpl).v6k.call(this, propertyId);
  };
  protoOf(TypedPubMedSourceReferenceImpl).w6k = function (propertyId, value) {
    if (propertyId.equals(PubMedSourceReferenceConcept_getInstance().ghn_1.m6o_1)) {
      this.tl1_1 = value;
    } else {
      protoOf(TypedKnowledgeSourceReferenceImpl).w6k.call(this, propertyId, value);
    }
  };
  function _get_pageSpecificationField__867h7f($this) {
    if ($this.il2_1 == null) {
      $this.il2_1 = $this.d6l(PublishedSourceReferenceConcept_getInstance().vhn_1);
    }
    return ensureNotNull($this.il2_1);
  }
  function TypedPublishedSourceReferenceImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? PublishedSourceReferenceConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(PublishedSourceReferenceConcept_getInstance().m6n_1) : nodeId;
    TypedKnowledgeSourceReferenceImpl.call(this, context, conceptId, nodeId);
    this.gl2_1 = null;
    this.hl2_1 = this.z6k(PublishedSourceReferenceConcept_getInstance().uhn_1);
    this.il2_1 = null;
  }
  protoOf(TypedPublishedSourceReferenceImpl).m6d = function () {
    return this.hl2_1;
  };
  protoOf(TypedPublishedSourceReferenceImpl).efu = function () {
    return this.f6l(_get_pageSpecificationField__867h7f(this));
  };
  protoOf(TypedPublishedSourceReferenceImpl).c3e = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.gl2_1 == null)) {
      this_0.j(PublishedSourceReferenceConcept_getInstance().uhn_1.a6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedKnowledgeSourceReferenceImpl).c3e.call(this));
  };
  protoOf(TypedPublishedSourceReferenceImpl).z3d = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.il2_1 == null)) {
      this_0.j(PublishedSourceReferenceConcept_getInstance().vhn_1.e6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedKnowledgeSourceReferenceImpl).z3d.call(this));
  };
  protoOf(TypedPublishedSourceReferenceImpl).g3p = function (nodeId) {
    return new TypedPublishedSourceReferenceImpl(this.j6k_1, PublishedSourceReferenceConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedPublishedSourceReferenceImpl).v6k = function (propertyId) {
    return propertyId.equals(PublishedSourceReferenceConcept_getInstance().uhn_1.a6l_1) ? this.gl2_1 : protoOf(TypedKnowledgeSourceReferenceImpl).v6k.call(this, propertyId);
  };
  protoOf(TypedPublishedSourceReferenceImpl).w6k = function (propertyId, value) {
    if (propertyId.equals(PublishedSourceReferenceConcept_getInstance().uhn_1.a6l_1)) {
      this.gl2_1 = value;
    } else {
      protoOf(TypedKnowledgeSourceReferenceImpl).w6k.call(this, propertyId, value);
    }
  };
  protoOf(TypedPublishedSourceReferenceImpl).p3m = function (childId) {
    return childId.equals(PublishedSourceReferenceConcept_getInstance().vhn_1.e6l_1) ? _get_pageSpecificationField__867h7f(this) : protoOf(TypedKnowledgeSourceReferenceImpl).p3m.call(this, childId);
  };
  function _get_itemsField__lgr4c1($this) {
    if ($this.xl2_1 == null) {
      $this.xl2_1 = $this.g6l(PublishedSourcesLibraryConcept_getInstance().hho_1);
    }
    return ensureNotNull($this.xl2_1);
  }
  function TypedPublishedSourcesLibraryImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? PublishedSourcesLibraryConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(PublishedSourcesLibraryConcept_getInstance().m6n_1) : nodeId;
    TypedDocumentNodeImpl.call(this, context, conceptId, nodeId);
    this.xl2_1 = null;
  }
  protoOf(TypedPublishedSourcesLibraryImpl).l2n = function () {
    return this.i6l(_get_itemsField__lgr4c1(this));
  };
  protoOf(TypedPublishedSourcesLibraryImpl).z3d = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.xl2_1 == null)) {
      this_0.j(PublishedSourcesLibraryConcept_getInstance().hho_1.h6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedDocumentNodeImpl).z3d.call(this));
  };
  protoOf(TypedPublishedSourcesLibraryImpl).g3p = function (nodeId) {
    return new TypedPublishedSourcesLibraryImpl(this.j6k_1, PublishedSourcesLibraryConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedPublishedSourcesLibraryImpl).p3m = function (childId) {
    return childId.equals(PublishedSourcesLibraryConcept_getInstance().hho_1.h6l_1) ? _get_itemsField__lgr4c1(this) : protoOf(TypedDocumentNodeImpl).p3m.call(this, childId);
  };
  function TypedPublishedWorkImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? PublishedWorkConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(PublishedWorkConcept_getInstance().m6n_1) : nodeId;
    TypedAuthoredWorkImpl.call(this, context, conceptId, nodeId);
    this.cj1_1 = null;
    this.dj1_1 = null;
    this.ej1_1 = get_name_0.call(this);
  }
  protoOf(TypedPublishedWorkImpl).ffu = function () {
    return this.x6k(PublishedWorkConcept_getInstance().uho_1);
  };
  protoOf(TypedPublishedWorkImpl).gfu = function () {
    return this.x6k(PublishedWorkConcept_getInstance().vho_1);
  };
  protoOf(TypedPublishedWorkImpl).c3e = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.cj1_1 == null)) {
      this_0.j(PublishedWorkConcept_getInstance().uho_1.m6o_1);
    }
    if (!(this.dj1_1 == null)) {
      this_0.j(PublishedWorkConcept_getInstance().vho_1.m6o_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedAuthoredWorkImpl).c3e.call(this));
  };
  protoOf(TypedPublishedWorkImpl).y2 = function () {
    return this.ej1_1;
  };
  protoOf(TypedPublishedWorkImpl).g3p = function (nodeId) {
    return new TypedPublishedWorkImpl(this.j6k_1, PublishedWorkConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedPublishedWorkImpl).v6k = function (propertyId) {
    return propertyId.equals(PublishedWorkConcept_getInstance().uho_1.m6o_1) ? this.cj1_1 : propertyId.equals(PublishedWorkConcept_getInstance().vho_1.m6o_1) ? this.dj1_1 : protoOf(TypedAuthoredWorkImpl).v6k.call(this, propertyId);
  };
  protoOf(TypedPublishedWorkImpl).w6k = function (propertyId, value) {
    if (propertyId.equals(PublishedWorkConcept_getInstance().uho_1.m6o_1)) {
      this.cj1_1 = value;
    } else if (propertyId.equals(PublishedWorkConcept_getInstance().vho_1.m6o_1)) {
      this.dj1_1 = value;
    } else {
      protoOf(TypedAuthoredWorkImpl).w6k.call(this, propertyId, value);
    }
  };
  function _get_libraryReferenceField__pf1ou1($this) {
    if ($this.kl3_1 == null) {
      $this.kl3_1 = $this.d6l(QualifiedOntologyElementReferenceConcept_getInstance().ihp_1);
    }
    return ensureNotNull($this.kl3_1);
  }
  function _get_elementReferenceField__f83ycm($this) {
    if ($this.ll3_1 == null) {
      $this.ll3_1 = $this.d6l(QualifiedOntologyElementReferenceConcept_getInstance().jhp_1);
    }
    return ensureNotNull($this.ll3_1);
  }
  function TypedQualifiedOntologyElementReferenceImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? QualifiedOntologyElementReferenceConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(QualifiedOntologyElementReferenceConcept_getInstance().m6n_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.kl3_1 = null;
    this.ll3_1 = null;
  }
  protoOf(TypedQualifiedOntologyElementReferenceImpl).hfu = function () {
    return this.f6l(_get_libraryReferenceField__pf1ou1(this));
  };
  protoOf(TypedQualifiedOntologyElementReferenceImpl).ifu = function () {
    return this.f6l(_get_elementReferenceField__f83ycm(this));
  };
  protoOf(TypedQualifiedOntologyElementReferenceImpl).z3d = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.kl3_1 == null)) {
      this_0.j(QualifiedOntologyElementReferenceConcept_getInstance().ihp_1.e6l_1);
    }
    if (!(this.ll3_1 == null)) {
      this_0.j(QualifiedOntologyElementReferenceConcept_getInstance().jhp_1.e6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedBTBNodeImpl).z3d.call(this));
  };
  protoOf(TypedQualifiedOntologyElementReferenceImpl).g3p = function (nodeId) {
    return new TypedQualifiedOntologyElementReferenceImpl(this.j6k_1, QualifiedOntologyElementReferenceConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedQualifiedOntologyElementReferenceImpl).p3m = function (childId) {
    return childId.equals(QualifiedOntologyElementReferenceConcept_getInstance().ihp_1.e6l_1) ? _get_libraryReferenceField__pf1ou1(this) : childId.equals(QualifiedOntologyElementReferenceConcept_getInstance().jhp_1.e6l_1) ? _get_elementReferenceField__f83ycm(this) : protoOf(TypedBTBNodeImpl).p3m.call(this, childId);
  };
  function _get_commandsField__o5mz41($this) {
    if ($this.al4_1 == null) {
      $this.al4_1 = $this.g6l(QueryCommandsConcept_getInstance().vhp_1);
    }
    return ensureNotNull($this.al4_1);
  }
  function TypedQueryCommandsImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? QueryCommandsConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(QueryCommandsConcept_getInstance().m6n_1) : nodeId;
    TypedDocumentNodeImpl.call(this, context, conceptId, nodeId);
    this.al4_1 = null;
  }
  protoOf(TypedQueryCommandsImpl).u51 = function () {
    return this.i6l(_get_commandsField__o5mz41(this));
  };
  protoOf(TypedQueryCommandsImpl).z3d = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.al4_1 == null)) {
      this_0.j(QueryCommandsConcept_getInstance().vhp_1.h6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedDocumentNodeImpl).z3d.call(this));
  };
  protoOf(TypedQueryCommandsImpl).g3p = function (nodeId) {
    return new TypedQueryCommandsImpl(this.j6k_1, QueryCommandsConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedQueryCommandsImpl).p3m = function (childId) {
    return childId.equals(QueryCommandsConcept_getInstance().vhp_1.h6l_1) ? _get_commandsField__o5mz41(this) : protoOf(TypedDocumentNodeImpl).p3m.call(this, childId);
  };
  function _get_expressionField__tmo0lr_4($this) {
    if ($this.pl4_1 == null) {
      $this.pl4_1 = $this.d6l(HasFactExpressionConcept_getInstance().rgg_1);
    }
    return ensureNotNull($this.pl4_1);
  }
  function TypedQueryLabelsFactExpressionContainerImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? QueryLabelsFactExpressionContainerConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(QueryLabelsFactExpressionContainerConcept_getInstance().m6n_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.nl4_1 = null;
    this.ol4_1 = null;
    this.pl4_1 = null;
  }
  protoOf(TypedQueryLabelsFactExpressionContainerImpl).pfr = function () {
    return this.x6k(HasQueryLabelsConcept_getInstance().qgh_1);
  };
  protoOf(TypedQueryLabelsFactExpressionContainerImpl).qfr = function () {
    return this.x6k(HasQueryLabelsConcept_getInstance().rgh_1);
  };
  protoOf(TypedQueryLabelsFactExpressionContainerImpl).mfr = function () {
    return this.f6l(_get_expressionField__tmo0lr_4(this));
  };
  protoOf(TypedQueryLabelsFactExpressionContainerImpl).c3e = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.nl4_1 == null)) {
      this_0.j(HasQueryLabelsConcept_getInstance().qgh_1.m6o_1);
    }
    if (!(this.ol4_1 == null)) {
      this_0.j(HasQueryLabelsConcept_getInstance().rgh_1.m6o_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedBTBNodeImpl).c3e.call(this));
  };
  protoOf(TypedQueryLabelsFactExpressionContainerImpl).z3d = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.pl4_1 == null)) {
      this_0.j(HasFactExpressionConcept_getInstance().rgg_1.e6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedBTBNodeImpl).z3d.call(this));
  };
  protoOf(TypedQueryLabelsFactExpressionContainerImpl).g3p = function (nodeId) {
    return new TypedQueryLabelsFactExpressionContainerImpl(this.j6k_1, QueryLabelsFactExpressionContainerConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedQueryLabelsFactExpressionContainerImpl).v6k = function (propertyId) {
    return propertyId.equals(HasQueryLabelsConcept_getInstance().qgh_1.m6o_1) ? this.nl4_1 : propertyId.equals(HasQueryLabelsConcept_getInstance().rgh_1.m6o_1) ? this.ol4_1 : protoOf(TypedBTBNodeImpl).v6k.call(this, propertyId);
  };
  protoOf(TypedQueryLabelsFactExpressionContainerImpl).w6k = function (propertyId, value) {
    if (propertyId.equals(HasQueryLabelsConcept_getInstance().qgh_1.m6o_1)) {
      this.nl4_1 = value;
    } else if (propertyId.equals(HasQueryLabelsConcept_getInstance().rgh_1.m6o_1)) {
      this.ol4_1 = value;
    } else {
      protoOf(TypedBTBNodeImpl).w6k.call(this, propertyId, value);
    }
  };
  protoOf(TypedQueryLabelsFactExpressionContainerImpl).p3m = function (childId) {
    return childId.equals(HasFactExpressionConcept_getInstance().rgg_1.e6l_1) ? _get_expressionField__tmo0lr_4(this) : protoOf(TypedBTBNodeImpl).p3m.call(this, childId);
  };
  function _get_elementsField__lf2xhu_3($this) {
    if ($this.gl5_1 == null) {
      $this.gl5_1 = $this.g6l(QueryParametersBlackListConcept_getInstance().khq_1);
    }
    return ensureNotNull($this.gl5_1);
  }
  function TypedQueryParametersBlackListImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? QueryParametersBlackListConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(QueryParametersBlackListConcept_getInstance().m6n_1) : nodeId;
    TypedDocumentNodeImpl.call(this, context, conceptId, nodeId);
    this.el5_1 = null;
    this.fl5_1 = this.z6k(QueryParametersBlackListConcept_getInstance().jhq_1);
    this.gl5_1 = null;
  }
  protoOf(TypedQueryParametersBlackListImpl).ffq = function () {
    return this.fl5_1;
  };
  protoOf(TypedQueryParametersBlackListImpl).ifq = function () {
    return this.i6l(_get_elementsField__lf2xhu_3(this));
  };
  protoOf(TypedQueryParametersBlackListImpl).c3e = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.el5_1 == null)) {
      this_0.j(QueryParametersBlackListConcept_getInstance().jhq_1.a6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedDocumentNodeImpl).c3e.call(this));
  };
  protoOf(TypedQueryParametersBlackListImpl).z3d = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.gl5_1 == null)) {
      this_0.j(QueryParametersBlackListConcept_getInstance().khq_1.h6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedDocumentNodeImpl).z3d.call(this));
  };
  protoOf(TypedQueryParametersBlackListImpl).g3p = function (nodeId) {
    return new TypedQueryParametersBlackListImpl(this.j6k_1, QueryParametersBlackListConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedQueryParametersBlackListImpl).v6k = function (propertyId) {
    return propertyId.equals(QueryParametersBlackListConcept_getInstance().jhq_1.a6l_1) ? this.el5_1 : protoOf(TypedDocumentNodeImpl).v6k.call(this, propertyId);
  };
  protoOf(TypedQueryParametersBlackListImpl).w6k = function (propertyId, value) {
    if (propertyId.equals(QueryParametersBlackListConcept_getInstance().jhq_1.a6l_1)) {
      this.el5_1 = value;
    } else {
      protoOf(TypedDocumentNodeImpl).w6k.call(this, propertyId, value);
    }
  };
  protoOf(TypedQueryParametersBlackListImpl).p3m = function (childId) {
    return childId.equals(QueryParametersBlackListConcept_getInstance().khq_1.h6l_1) ? _get_elementsField__lf2xhu_3(this) : protoOf(TypedDocumentNodeImpl).p3m.call(this, childId);
  };
  function _get_processRelationsField__rapabj($this) {
    if ($this.vl5_1 == null) {
      $this.vl5_1 = $this.g6l(RelationContainerConcept_getInstance().xhq_1);
    }
    return ensureNotNull($this.vl5_1);
  }
  function _get_instanceRelationsField__97xosz($this) {
    if ($this.wl5_1 == null) {
      $this.wl5_1 = $this.g6l(RelationContainerConcept_getInstance().yhq_1);
    }
    return ensureNotNull($this.wl5_1);
  }
  function TypedRelationContainerImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? RelationContainerConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(RelationContainerConcept_getInstance().m6n_1) : nodeId;
    TypedDocumentNodeImpl.call(this, context, conceptId, nodeId);
    this.vl5_1 = null;
    this.wl5_1 = null;
  }
  protoOf(TypedRelationContainerImpl).jfu = function () {
    return this.i6l(_get_processRelationsField__rapabj(this));
  };
  protoOf(TypedRelationContainerImpl).kfu = function () {
    return this.i6l(_get_instanceRelationsField__97xosz(this));
  };
  protoOf(TypedRelationContainerImpl).z3d = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.vl5_1 == null)) {
      this_0.j(RelationContainerConcept_getInstance().xhq_1.h6l_1);
    }
    if (!(this.wl5_1 == null)) {
      this_0.j(RelationContainerConcept_getInstance().yhq_1.h6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedDocumentNodeImpl).z3d.call(this));
  };
  protoOf(TypedRelationContainerImpl).g3p = function (nodeId) {
    return new TypedRelationContainerImpl(this.j6k_1, RelationContainerConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedRelationContainerImpl).p3m = function (childId) {
    return childId.equals(RelationContainerConcept_getInstance().xhq_1.h6l_1) ? _get_processRelationsField__rapabj(this) : childId.equals(RelationContainerConcept_getInstance().yhq_1.h6l_1) ? _get_instanceRelationsField__97xosz(this) : protoOf(TypedDocumentNodeImpl).p3m.call(this, childId);
  };
  function _get_leftField__72ma9q_0($this) {
    if ($this.jl6_1 == null) {
      $this.jl6_1 = $this.d6l(RelationFactExpressionConcept_getInstance().mhr_1);
    }
    return ensureNotNull($this.jl6_1);
  }
  function _get_rightField__qpqtcd_0($this) {
    if ($this.kl6_1 == null) {
      $this.kl6_1 = $this.d6l(RelationFactExpressionConcept_getInstance().nhr_1);
    }
    return ensureNotNull($this.kl6_1);
  }
  function TypedRelationFactExpressionImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? RelationFactExpressionConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(RelationFactExpressionConcept_getInstance().m6n_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.jl6_1 = null;
    this.kl6_1 = null;
    this.ll6_1 = null;
    this.ml6_1 = this.z6k(RelationFactExpressionConcept_getInstance().ohr_1);
  }
  protoOf(TypedRelationFactExpressionImpl).dft = function () {
    return this.f6l(_get_leftField__72ma9q_0(this));
  };
  protoOf(TypedRelationFactExpressionImpl).eft = function () {
    return this.f6l(_get_rightField__qpqtcd_0(this));
  };
  protoOf(TypedRelationFactExpressionImpl).xfq = function () {
    return this.ml6_1;
  };
  protoOf(TypedRelationFactExpressionImpl).c3e = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.ll6_1 == null)) {
      this_0.j(RelationFactExpressionConcept_getInstance().ohr_1.a6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedBTBNodeImpl).c3e.call(this));
  };
  protoOf(TypedRelationFactExpressionImpl).z3d = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.jl6_1 == null)) {
      this_0.j(RelationFactExpressionConcept_getInstance().mhr_1.e6l_1);
    }
    if (!(this.kl6_1 == null)) {
      this_0.j(RelationFactExpressionConcept_getInstance().nhr_1.e6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedBTBNodeImpl).z3d.call(this));
  };
  protoOf(TypedRelationFactExpressionImpl).g3p = function (nodeId) {
    return new TypedRelationFactExpressionImpl(this.j6k_1, RelationFactExpressionConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedRelationFactExpressionImpl).v6k = function (propertyId) {
    return propertyId.equals(RelationFactExpressionConcept_getInstance().ohr_1.a6l_1) ? this.ll6_1 : protoOf(TypedBTBNodeImpl).v6k.call(this, propertyId);
  };
  protoOf(TypedRelationFactExpressionImpl).w6k = function (propertyId, value) {
    if (propertyId.equals(RelationFactExpressionConcept_getInstance().ohr_1.a6l_1)) {
      this.ll6_1 = value;
    } else {
      protoOf(TypedBTBNodeImpl).w6k.call(this, propertyId, value);
    }
  };
  protoOf(TypedRelationFactExpressionImpl).p3m = function (childId) {
    return childId.equals(RelationFactExpressionConcept_getInstance().mhr_1.e6l_1) ? _get_leftField__72ma9q_0(this) : childId.equals(RelationFactExpressionConcept_getInstance().nhr_1.e6l_1) ? _get_rightField__qpqtcd_0(this) : protoOf(TypedBTBNodeImpl).p3m.call(this, childId);
  };
  function TypedReturnTypeCustomCellImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? ReturnTypeCustomCellConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ReturnTypeCustomCellConcept_getInstance().m6n_1) : nodeId;
    TypedCustomCellImpl.call(this, context, conceptId, nodeId);
  }
  protoOf(TypedReturnTypeCustomCellImpl).g3p = function (nodeId) {
    return new TypedReturnTypeCustomCellImpl(this.j6k_1, ReturnTypeCustomCellConcept_getInstance().m6n_1, nodeId);
  };
  function _get_expressionsField__6fs50_0($this) {
    if ($this.ll7_1 == null) {
      $this.ll7_1 = $this.g6l(SetExpressionConcept_getInstance().chs_1);
    }
    return ensureNotNull($this.ll7_1);
  }
  function TypedSetExpressionImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? SetExpressionConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(SetExpressionConcept_getInstance().m6n_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.ll7_1 = null;
    this.ml7_1 = null;
  }
  protoOf(TypedSetExpressionImpl).mfs = function () {
    return this.i6l(_get_expressionsField__6fs50_0(this));
  };
  protoOf(TypedSetExpressionImpl).lfu = function () {
    return this.x6k(SetExpressionConcept_getInstance().dhs_1);
  };
  protoOf(TypedSetExpressionImpl).c3e = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.ml7_1 == null)) {
      this_0.j(SetExpressionConcept_getInstance().dhs_1.m6o_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedBTBNodeImpl).c3e.call(this));
  };
  protoOf(TypedSetExpressionImpl).z3d = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.ll7_1 == null)) {
      this_0.j(SetExpressionConcept_getInstance().chs_1.h6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedBTBNodeImpl).z3d.call(this));
  };
  protoOf(TypedSetExpressionImpl).g3p = function (nodeId) {
    return new TypedSetExpressionImpl(this.j6k_1, SetExpressionConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedSetExpressionImpl).v6k = function (propertyId) {
    return propertyId.equals(SetExpressionConcept_getInstance().dhs_1.m6o_1) ? this.ml7_1 : protoOf(TypedBTBNodeImpl).v6k.call(this, propertyId);
  };
  protoOf(TypedSetExpressionImpl).w6k = function (propertyId, value) {
    if (propertyId.equals(SetExpressionConcept_getInstance().dhs_1.m6o_1)) {
      this.ml7_1 = value;
    } else {
      protoOf(TypedBTBNodeImpl).w6k.call(this, propertyId, value);
    }
  };
  protoOf(TypedSetExpressionImpl).p3m = function (childId) {
    return childId.equals(SetExpressionConcept_getInstance().chs_1.h6l_1) ? _get_expressionsField__6fs50_0(this) : protoOf(TypedBTBNodeImpl).p3m.call(this, childId);
  };
  function _get_valueField__9y0rz6_8($this) {
    if ($this.zl7_1 == null) {
      $this.zl7_1 = $this.d6l(SetValuedPropertyParameterConcept_getInstance().phs_1);
    }
    return ensureNotNull($this.zl7_1);
  }
  function TypedSetValuedPropertyParameterImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? SetValuedPropertyParameterConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(SetValuedPropertyParameterConcept_getInstance().m6n_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.zl7_1 = null;
  }
  protoOf(TypedSetValuedPropertyParameterImpl).a1 = function () {
    return this.f6l(_get_valueField__9y0rz6_8(this));
  };
  protoOf(TypedSetValuedPropertyParameterImpl).z3d = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.zl7_1 == null)) {
      this_0.j(SetValuedPropertyParameterConcept_getInstance().phs_1.e6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedBTBNodeImpl).z3d.call(this));
  };
  protoOf(TypedSetValuedPropertyParameterImpl).g3p = function (nodeId) {
    return new TypedSetValuedPropertyParameterImpl(this.j6k_1, SetValuedPropertyParameterConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedSetValuedPropertyParameterImpl).p3m = function (childId) {
    return childId.equals(SetValuedPropertyParameterConcept_getInstance().phs_1.e6l_1) ? _get_valueField__9y0rz6_8(this) : protoOf(TypedBTBNodeImpl).p3m.call(this, childId);
  };
  function TypedSimplePropertyTypeImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? SimplePropertyTypeConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(SimplePropertyTypeConcept_getInstance().m6n_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.ml8_1 = null;
    this.nl8_1 = this.z6k(SimplePropertyTypeConcept_getInstance().cht_1);
  }
  protoOf(TypedSimplePropertyTypeImpl).mfq = function () {
    return this.nl8_1;
  };
  protoOf(TypedSimplePropertyTypeImpl).c3e = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.ml8_1 == null)) {
      this_0.j(SimplePropertyTypeConcept_getInstance().cht_1.a6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedBTBNodeImpl).c3e.call(this));
  };
  protoOf(TypedSimplePropertyTypeImpl).g3p = function (nodeId) {
    return new TypedSimplePropertyTypeImpl(this.j6k_1, SimplePropertyTypeConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedSimplePropertyTypeImpl).v6k = function (propertyId) {
    return propertyId.equals(SimplePropertyTypeConcept_getInstance().cht_1.a6l_1) ? this.ml8_1 : protoOf(TypedBTBNodeImpl).v6k.call(this, propertyId);
  };
  protoOf(TypedSimplePropertyTypeImpl).w6k = function (propertyId, value) {
    if (propertyId.equals(SimplePropertyTypeConcept_getInstance().cht_1.a6l_1)) {
      this.ml8_1 = value;
    } else {
      protoOf(TypedBTBNodeImpl).w6k.call(this, propertyId, value);
    }
  };
  function _get_typesField__spk11y_0($this) {
    if ($this.al9_1 == null) {
      $this.al9_1 = $this.g6l(SinglePropertyValueRangeConcept_getInstance().oht_1);
    }
    return ensureNotNull($this.al9_1);
  }
  function TypedSinglePropertyValueRangeImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? SinglePropertyValueRangeConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(SinglePropertyValueRangeConcept_getInstance().m6n_1) : nodeId;
    TypedPropertyValueRangeImpl.call(this, context, conceptId, nodeId);
    this.al9_1 = null;
  }
  protoOf(TypedSinglePropertyValueRangeImpl).cfs = function () {
    return this.i6l(_get_typesField__spk11y_0(this));
  };
  protoOf(TypedSinglePropertyValueRangeImpl).z3d = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.al9_1 == null)) {
      this_0.j(SinglePropertyValueRangeConcept_getInstance().oht_1.h6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedPropertyValueRangeImpl).z3d.call(this));
  };
  protoOf(TypedSinglePropertyValueRangeImpl).g3p = function (nodeId) {
    return new TypedSinglePropertyValueRangeImpl(this.j6k_1, SinglePropertyValueRangeConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedSinglePropertyValueRangeImpl).p3m = function (childId) {
    return childId.equals(SinglePropertyValueRangeConcept_getInstance().oht_1.h6l_1) ? _get_typesField__spk11y_0(this) : protoOf(TypedPropertyValueRangeImpl).p3m.call(this, childId);
  };
  function TypedStringValueImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? StringValueConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(StringValueConcept_getInstance().m6n_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.nl9_1 = null;
  }
  protoOf(TypedStringValueImpl).a1 = function () {
    return this.x6k(StringValueConcept_getInstance().ahu_1);
  };
  protoOf(TypedStringValueImpl).c3e = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.nl9_1 == null)) {
      this_0.j(StringValueConcept_getInstance().ahu_1.m6o_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedBTBNodeImpl).c3e.call(this));
  };
  protoOf(TypedStringValueImpl).g3p = function (nodeId) {
    return new TypedStringValueImpl(this.j6k_1, StringValueConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedStringValueImpl).v6k = function (propertyId) {
    return propertyId.equals(StringValueConcept_getInstance().ahu_1.m6o_1) ? this.nl9_1 : protoOf(TypedBTBNodeImpl).v6k.call(this, propertyId);
  };
  protoOf(TypedStringValueImpl).w6k = function (propertyId, value) {
    if (propertyId.equals(StringValueConcept_getInstance().ahu_1.m6o_1)) {
      this.nl9_1 = value;
    } else {
      protoOf(TypedBTBNodeImpl).w6k.call(this, propertyId, value);
    }
  };
  function TypedTextLineImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? TextLineConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(TextLineConcept_getInstance().m6n_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.ala_1 = null;
  }
  protoOf(TypedTextLineImpl).o8w = function () {
    return this.y6k(TextLineConcept_getInstance().mhu_1);
  };
  protoOf(TypedTextLineImpl).c3e = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.ala_1 == null)) {
      this_0.j(TextLineConcept_getInstance().mhu_1.s6o_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedBTBNodeImpl).c3e.call(this));
  };
  protoOf(TypedTextLineImpl).g3p = function (nodeId) {
    return new TypedTextLineImpl(this.j6k_1, TextLineConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedTextLineImpl).v6k = function (propertyId) {
    return propertyId.equals(TextLineConcept_getInstance().mhu_1.s6o_1) ? this.ala_1 : protoOf(TypedBTBNodeImpl).v6k.call(this, propertyId);
  };
  protoOf(TypedTextLineImpl).w6k = function (propertyId, value) {
    if (propertyId.equals(TextLineConcept_getInstance().mhu_1.s6o_1)) {
      this.ala_1 = value;
    } else {
      protoOf(TypedBTBNodeImpl).w6k.call(this, propertyId, value);
    }
  };
  function TypedTypeImpl(context, conceptId, nodeId) {
    TypedVariableSpecificationImpl.call(this, context, conceptId, nodeId);
  }
  function TypedTypePlaceholderImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? TypePlaceholderConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(TypePlaceholderConcept_getInstance().m6n_1) : nodeId;
    TypedTypeImpl.call(this, context, conceptId, nodeId);
  }
  protoOf(TypedTypePlaceholderImpl).g3p = function (nodeId) {
    return new TypedTypePlaceholderImpl(this.j6k_1, TypePlaceholderConcept_getInstance().m6n_1, nodeId);
  };
  function _get_classesField__tqjl1z($this) {
    if ($this.zla_1 == null) {
      $this.zla_1 = $this.g6l(UnionClassConcept_getInstance().yhu_1);
    }
    return ensureNotNull($this.zla_1);
  }
  function TypedUnionClassImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? UnionClassConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(UnionClassConcept_getInstance().m6n_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.zla_1 = null;
  }
  protoOf(TypedUnionClassImpl).mfu = function () {
    return this.i6l(_get_classesField__tqjl1z(this));
  };
  protoOf(TypedUnionClassImpl).z3d = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.zla_1 == null)) {
      this_0.j(UnionClassConcept_getInstance().yhu_1.h6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedBTBNodeImpl).z3d.call(this));
  };
  protoOf(TypedUnionClassImpl).g3p = function (nodeId) {
    return new TypedUnionClassImpl(this.j6k_1, UnionClassConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedUnionClassImpl).p3m = function (childId) {
    return childId.equals(UnionClassConcept_getInstance().yhu_1.h6l_1) ? _get_classesField__tqjl1z(this) : protoOf(TypedBTBNodeImpl).p3m.call(this, childId);
  };
  function TypedUnknownComplexNotionValueImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? UnknownComplexNotionValueConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(UnknownComplexNotionValueConcept_getInstance().m6n_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
  }
  protoOf(TypedUnknownComplexNotionValueImpl).g3p = function (nodeId) {
    return new TypedUnknownComplexNotionValueImpl(this.j6k_1, UnknownComplexNotionValueConcept_getInstance().m6n_1, nodeId);
  };
  function TypedUrlImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? UrlConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(UrlConcept_getInstance().m6n_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.ylb_1 = null;
  }
  protoOf(TypedUrlImpl).a1 = function () {
    return this.x6k(UrlConcept_getInstance().khv_1);
  };
  protoOf(TypedUrlImpl).c3e = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.ylb_1 == null)) {
      this_0.j(UrlConcept_getInstance().khv_1.m6o_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedBTBNodeImpl).c3e.call(this));
  };
  protoOf(TypedUrlImpl).g3p = function (nodeId) {
    return new TypedUrlImpl(this.j6k_1, UrlConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedUrlImpl).v6k = function (propertyId) {
    return propertyId.equals(UrlConcept_getInstance().khv_1.m6o_1) ? this.ylb_1 : protoOf(TypedBTBNodeImpl).v6k.call(this, propertyId);
  };
  protoOf(TypedUrlImpl).w6k = function (propertyId, value) {
    if (propertyId.equals(UrlConcept_getInstance().khv_1.m6o_1)) {
      this.ylb_1 = value;
    } else {
      protoOf(TypedBTBNodeImpl).w6k.call(this, propertyId, value);
    }
  };
  function TypedUrlKnowledgeSourceReferenceImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? UrlKnowledgeSourceReferenceConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(UrlKnowledgeSourceReferenceConcept_getInstance().m6n_1) : nodeId;
    TypedKnowledgeSourceReferenceImpl.call(this, context, conceptId, nodeId);
    this.llc_1 = null;
  }
  protoOf(TypedUrlKnowledgeSourceReferenceImpl).qfs = function () {
    return this.x6k(UrlKnowledgeSourceReferenceConcept_getInstance().whv_1);
  };
  protoOf(TypedUrlKnowledgeSourceReferenceImpl).c3e = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.llc_1 == null)) {
      this_0.j(UrlKnowledgeSourceReferenceConcept_getInstance().whv_1.m6o_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedKnowledgeSourceReferenceImpl).c3e.call(this));
  };
  protoOf(TypedUrlKnowledgeSourceReferenceImpl).g3p = function (nodeId) {
    return new TypedUrlKnowledgeSourceReferenceImpl(this.j6k_1, UrlKnowledgeSourceReferenceConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedUrlKnowledgeSourceReferenceImpl).v6k = function (propertyId) {
    return propertyId.equals(UrlKnowledgeSourceReferenceConcept_getInstance().whv_1.m6o_1) ? this.llc_1 : protoOf(TypedKnowledgeSourceReferenceImpl).v6k.call(this, propertyId);
  };
  protoOf(TypedUrlKnowledgeSourceReferenceImpl).w6k = function (propertyId, value) {
    if (propertyId.equals(UrlKnowledgeSourceReferenceConcept_getInstance().whv_1.m6o_1)) {
      this.llc_1 = value;
    } else {
      protoOf(TypedKnowledgeSourceReferenceImpl).w6k.call(this, propertyId, value);
    }
  };
  function _get_valueField__9y0rz6_9($this) {
    if ($this.ylc_1 == null) {
      $this.ylc_1 = $this.d6l(ValueWithRelationsConcept_getInstance().jhw_1);
    }
    return ensureNotNull($this.ylc_1);
  }
  function _get_relationsField__kxte08($this) {
    if ($this.zlc_1 == null) {
      $this.zlc_1 = $this.g6l(ValueWithRelationsConcept_getInstance().khw_1);
    }
    return ensureNotNull($this.zlc_1);
  }
  function TypedValueWithRelationsImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? ValueWithRelationsConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ValueWithRelationsConcept_getInstance().m6n_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.ylc_1 = null;
    this.zlc_1 = null;
  }
  protoOf(TypedValueWithRelationsImpl).a1 = function () {
    return this.f6l(_get_valueField__9y0rz6_9(this));
  };
  protoOf(TypedValueWithRelationsImpl).nfu = function () {
    return this.i6l(_get_relationsField__kxte08(this));
  };
  protoOf(TypedValueWithRelationsImpl).z3d = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.ylc_1 == null)) {
      this_0.j(ValueWithRelationsConcept_getInstance().jhw_1.e6l_1);
    }
    if (!(this.zlc_1 == null)) {
      this_0.j(ValueWithRelationsConcept_getInstance().khw_1.h6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedBTBNodeImpl).z3d.call(this));
  };
  protoOf(TypedValueWithRelationsImpl).g3p = function (nodeId) {
    return new TypedValueWithRelationsImpl(this.j6k_1, ValueWithRelationsConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedValueWithRelationsImpl).p3m = function (childId) {
    return childId.equals(ValueWithRelationsConcept_getInstance().jhw_1.e6l_1) ? _get_valueField__9y0rz6_9(this) : childId.equals(ValueWithRelationsConcept_getInstance().khw_1.h6l_1) ? _get_relationsField__kxte08(this) : protoOf(TypedBTBNodeImpl).p3m.call(this, childId);
  };
  function _get_specField__gg1gz6($this) {
    if ($this.mld_1 == null) {
      $this.mld_1 = $this.d6l(VariableDeclarationConcept_getInstance().xhw_1);
    }
    return ensureNotNull($this.mld_1);
  }
  function _get_relationsField__kxte08_0($this) {
    if ($this.nld_1 == null) {
      $this.nld_1 = $this.g6l(VariableDeclarationConcept_getInstance().yhw_1);
    }
    return ensureNotNull($this.nld_1);
  }
  function _get_constraintsField__3m7315_2($this) {
    if ($this.rld_1 == null) {
      $this.rld_1 = $this.g6l(HasPropertyConstraintsConcept_getInstance().hgh_1);
    }
    return ensureNotNull($this.rld_1);
  }
  function TypedVariableDeclarationImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? VariableDeclarationConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(VariableDeclarationConcept_getInstance().m6n_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.mld_1 = null;
    this.nld_1 = null;
    this.old_1 = null;
    this.pld_1 = null;
    this.qld_1 = null;
    this.rld_1 = null;
  }
  protoOf(TypedVariableDeclarationImpl).ofu = function () {
    return this.f6l(_get_specField__gg1gz6(this));
  };
  protoOf(TypedVariableDeclarationImpl).nfu = function () {
    return this.i6l(_get_relationsField__kxte08_0(this));
  };
  protoOf(TypedVariableDeclarationImpl).y2 = function () {
    return this.x6k(DirectlyNamedConcept_getInstance().chz_1);
  };
  protoOf(TypedVariableDeclarationImpl).pfr = function () {
    return this.x6k(HasQueryLabelsConcept_getInstance().qgh_1);
  };
  protoOf(TypedVariableDeclarationImpl).qfr = function () {
    return this.x6k(HasQueryLabelsConcept_getInstance().rgh_1);
  };
  protoOf(TypedVariableDeclarationImpl).ofr = function () {
    return this.i6l(_get_constraintsField__3m7315_2(this));
  };
  protoOf(TypedVariableDeclarationImpl).c3e = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.old_1 == null)) {
      this_0.j(DirectlyNamedConcept_getInstance().chz_1.m6o_1);
    }
    if (!(this.pld_1 == null)) {
      this_0.j(HasQueryLabelsConcept_getInstance().qgh_1.m6o_1);
    }
    if (!(this.qld_1 == null)) {
      this_0.j(HasQueryLabelsConcept_getInstance().rgh_1.m6o_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedBTBNodeImpl).c3e.call(this));
  };
  protoOf(TypedVariableDeclarationImpl).z3d = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.mld_1 == null)) {
      this_0.j(VariableDeclarationConcept_getInstance().xhw_1.e6l_1);
    }
    if (!(this.nld_1 == null)) {
      this_0.j(VariableDeclarationConcept_getInstance().yhw_1.h6l_1);
    }
    if (!(this.rld_1 == null)) {
      this_0.j(HasPropertyConstraintsConcept_getInstance().hgh_1.h6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedBTBNodeImpl).z3d.call(this));
  };
  protoOf(TypedVariableDeclarationImpl).g3p = function (nodeId) {
    return new TypedVariableDeclarationImpl(this.j6k_1, VariableDeclarationConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedVariableDeclarationImpl).v6k = function (propertyId) {
    return propertyId.equals(DirectlyNamedConcept_getInstance().chz_1.m6o_1) ? this.old_1 : propertyId.equals(HasQueryLabelsConcept_getInstance().qgh_1.m6o_1) ? this.pld_1 : propertyId.equals(HasQueryLabelsConcept_getInstance().rgh_1.m6o_1) ? this.qld_1 : protoOf(TypedBTBNodeImpl).v6k.call(this, propertyId);
  };
  protoOf(TypedVariableDeclarationImpl).w6k = function (propertyId, value) {
    if (propertyId.equals(DirectlyNamedConcept_getInstance().chz_1.m6o_1)) {
      this.old_1 = value;
    } else if (propertyId.equals(HasQueryLabelsConcept_getInstance().qgh_1.m6o_1)) {
      this.pld_1 = value;
    } else if (propertyId.equals(HasQueryLabelsConcept_getInstance().rgh_1.m6o_1)) {
      this.qld_1 = value;
    } else {
      protoOf(TypedBTBNodeImpl).w6k.call(this, propertyId, value);
    }
  };
  protoOf(TypedVariableDeclarationImpl).p3m = function (childId) {
    return childId.equals(VariableDeclarationConcept_getInstance().xhw_1.e6l_1) ? _get_specField__gg1gz6(this) : childId.equals(VariableDeclarationConcept_getInstance().yhw_1.h6l_1) ? _get_relationsField__kxte08_0(this) : childId.equals(HasPropertyConstraintsConcept_getInstance().hgh_1.h6l_1) ? _get_constraintsField__3m7315_2(this) : protoOf(TypedBTBNodeImpl).p3m.call(this, childId);
  };
  function TypedVariableInitializerImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? VariableInitializerConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(VariableInitializerConcept_getInstance().m6n_1) : nodeId;
    TypedVariableSpecificationImpl.call(this, context, conceptId, nodeId);
  }
  protoOf(TypedVariableInitializerImpl).g3p = function (nodeId) {
    return new TypedVariableInitializerImpl(this.j6k_1, VariableInitializerConcept_getInstance().m6n_1, nodeId);
  };
  function TypedVariablePatternImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? VariablePatternConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(VariablePatternConcept_getInstance().m6n_1) : nodeId;
    TypedPatternImpl.call(this, context, conceptId, nodeId);
    this.qle_1 = null;
    this.rle_1 = this.z6k(VariablePatternConcept_getInstance().lhx_1);
  }
  protoOf(TypedVariablePatternImpl).pfu = function () {
    return this.rle_1;
  };
  protoOf(TypedVariablePatternImpl).c3e = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.qle_1 == null)) {
      this_0.j(VariablePatternConcept_getInstance().lhx_1.a6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedPatternImpl).c3e.call(this));
  };
  protoOf(TypedVariablePatternImpl).g3p = function (nodeId) {
    return new TypedVariablePatternImpl(this.j6k_1, VariablePatternConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedVariablePatternImpl).v6k = function (propertyId) {
    return propertyId.equals(VariablePatternConcept_getInstance().lhx_1.a6l_1) ? this.qle_1 : protoOf(TypedPatternImpl).v6k.call(this, propertyId);
  };
  protoOf(TypedVariablePatternImpl).w6k = function (propertyId, value) {
    if (propertyId.equals(VariablePatternConcept_getInstance().lhx_1.a6l_1)) {
      this.qle_1 = value;
    } else {
      protoOf(TypedPatternImpl).w6k.call(this, propertyId, value);
    }
  };
  function TypedVariableReferenceValueImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? VariableReferenceValueConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(VariableReferenceValueConcept_getInstance().m6n_1) : nodeId;
    TypedVariableInitializerImpl.call(this, context, conceptId, nodeId);
    this.elf_1 = null;
    this.flf_1 = this.z6k(VariableReferenceValueConcept_getInstance().yhx_1);
  }
  protoOf(TypedVariableReferenceValueImpl).pfu = function () {
    return this.flf_1;
  };
  protoOf(TypedVariableReferenceValueImpl).c3e = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.elf_1 == null)) {
      this_0.j(VariableReferenceValueConcept_getInstance().yhx_1.a6l_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedVariableInitializerImpl).c3e.call(this));
  };
  protoOf(TypedVariableReferenceValueImpl).g3p = function (nodeId) {
    return new TypedVariableReferenceValueImpl(this.j6k_1, VariableReferenceValueConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedVariableReferenceValueImpl).v6k = function (propertyId) {
    return propertyId.equals(VariableReferenceValueConcept_getInstance().yhx_1.a6l_1) ? this.elf_1 : protoOf(TypedVariableInitializerImpl).v6k.call(this, propertyId);
  };
  protoOf(TypedVariableReferenceValueImpl).w6k = function (propertyId, value) {
    if (propertyId.equals(VariableReferenceValueConcept_getInstance().yhx_1.a6l_1)) {
      this.elf_1 = value;
    } else {
      protoOf(TypedVariableInitializerImpl).w6k.call(this, propertyId, value);
    }
  };
  function TypedVariableSpecificationImpl(context, conceptId, nodeId) {
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
  }
  function TypedXRefContainerImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? XRefContainerConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(XRefContainerConcept_getInstance().m6n_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.slf_1 = null;
  }
  protoOf(TypedXRefContainerImpl).qfu = function () {
    return this.x6k(XRefContainerConcept_getInstance().khy_1);
  };
  protoOf(TypedXRefContainerImpl).c3e = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    if (!(this.slf_1 == null)) {
      this_0.j(XRefContainerConcept_getInstance().khy_1.m6o_1);
    }
    var tmp$ret$3 = this_0.i3();
    return plus_10(tmp$ret$3, protoOf(TypedBTBNodeImpl).c3e.call(this));
  };
  protoOf(TypedXRefContainerImpl).g3p = function (nodeId) {
    return new TypedXRefContainerImpl(this.j6k_1, XRefContainerConcept_getInstance().m6n_1, nodeId);
  };
  protoOf(TypedXRefContainerImpl).v6k = function (propertyId) {
    return propertyId.equals(XRefContainerConcept_getInstance().khy_1.m6o_1) ? this.slf_1 : protoOf(TypedBTBNodeImpl).v6k.call(this, propertyId);
  };
  protoOf(TypedXRefContainerImpl).w6k = function (propertyId, value) {
    if (propertyId.equals(XRefContainerConcept_getInstance().khy_1.m6o_1)) {
      this.slf_1 = value;
    } else {
      protoOf(TypedBTBNodeImpl).w6k.call(this, propertyId, value);
    }
  };
  function UnionClassImpl(context, node) {
    node = node === VOID ? new Node_0(UnionClassConcept_getInstance().m6n_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.wlf_1 = this.s6j(UnionClassConcept_getInstance().xhu_1);
  }
  protoOf(UnionClassImpl).mfu = function () {
    return this.wlf_1;
  };
  function UnknownComplexNotionValueImpl(context, node) {
    node = node === VOID ? new Node_0(UnknownComplexNotionValueConcept_getInstance().m6n_1) : node;
    BTBNodeImpl.call(this, context, node);
  }
  function UrlImpl(context, node) {
    node = node === VOID ? new Node_0(UrlConcept_getInstance().m6n_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.alg_1 = this.i6j(UrlConcept_getInstance().jhv_1);
  }
  protoOf(UrlImpl).a1 = function () {
    return this.alg_1;
  };
  function UrlKnowledgeSourceReferenceImpl(context, node) {
    node = node === VOID ? new Node_0(UrlKnowledgeSourceReferenceConcept_getInstance().m6n_1) : node;
    KnowledgeSourceReferenceImpl.call(this, context, node);
    this.elg_1 = this.i6j(UrlKnowledgeSourceReferenceConcept_getInstance().vhv_1);
  }
  protoOf(UrlKnowledgeSourceReferenceImpl).qfs = function () {
    return this.elg_1;
  };
  function ValueWithRelationsImpl(context, node) {
    node = node === VOID ? new Node_0(ValueWithRelationsConcept_getInstance().m6n_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.ilg_1 = this.r6j(ValueWithRelationsConcept_getInstance().hhw_1);
    this.jlg_1 = this.s6j(ValueWithRelationsConcept_getInstance().ihw_1);
  }
  protoOf(ValueWithRelationsImpl).a1 = function () {
    return this.ilg_1;
  };
  protoOf(ValueWithRelationsImpl).nfu = function () {
    return this.jlg_1;
  };
  function VariableDeclarationImpl(context, node) {
    node = node === VOID ? new Node_0(VariableDeclarationConcept_getInstance().m6n_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.nlg_1 = this.r6j(VariableDeclarationConcept_getInstance().vhw_1);
    this.olg_1 = this.s6j(VariableDeclarationConcept_getInstance().whw_1);
    this.plg_1 = this.i6j(DirectlyNamedConcept_getInstance().bhz_1);
    this.qlg_1 = this.p6j(HasQueryLabelsConcept_getInstance().ogh_1);
    this.rlg_1 = this.p6j(HasQueryLabelsConcept_getInstance().pgh_1);
    this.slg_1 = this.s6j(HasPropertyConstraintsConcept_getInstance().ggh_1);
  }
  protoOf(VariableDeclarationImpl).ofu = function () {
    return this.nlg_1;
  };
  protoOf(VariableDeclarationImpl).nfu = function () {
    return this.olg_1;
  };
  protoOf(VariableDeclarationImpl).y2 = function () {
    return this.plg_1;
  };
  protoOf(VariableDeclarationImpl).pfr = function () {
    return this.qlg_1;
  };
  protoOf(VariableDeclarationImpl).qfr = function () {
    return this.rlg_1;
  };
  protoOf(VariableDeclarationImpl).ofr = function () {
    return this.slg_1;
  };
  function VariableInitializerImpl(context, node) {
    node = node === VOID ? new Node_0(VariableInitializerConcept_getInstance().m6n_1) : node;
    VariableSpecificationImpl.call(this, context, node);
  }
  function VariablePatternImpl(context, node) {
    node = node === VOID ? new Node_0(VariablePatternConcept_getInstance().m6n_1) : node;
    PatternImpl.call(this, context, node);
    this.wlg_1 = context.u6l(VariablePatternConcept_getInstance().khx_1, this);
  }
  protoOf(VariablePatternImpl).pfu = function () {
    return this.wlg_1;
  };
  function VariableReferenceValueImpl(context, node) {
    node = node === VOID ? new Node_0(VariableReferenceValueConcept_getInstance().m6n_1) : node;
    VariableInitializerImpl.call(this, context, node);
    this.alh_1 = context.u6l(VariableReferenceValueConcept_getInstance().xhx_1, this);
  }
  protoOf(VariableReferenceValueImpl).pfu = function () {
    return this.alh_1;
  };
  function VariableSpecificationImpl(context, node) {
    BTBNodeImpl.call(this, context, node);
  }
  function XRefContainerImpl(context, node) {
    node = node === VOID ? new Node_0(XRefContainerConcept_getInstance().m6n_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.elh_1 = this.i6j(XRefContainerConcept_getInstance().jhy_1);
  }
  protoOf(XRefContainerImpl).qfu = function () {
    return this.elh_1;
  };
  function LinkStubImpl$_init_$ref_6cvkbn() {
    var l = function (p0, p1) {
      return new LinkStubImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function LinkStubConcept$_init_$lambda_hdvymj(context, nodeId) {
    return new TypedLinkStubImpl(context, VOID, nodeId);
  }
  function LinkStubConcept() {
    LinkStubConcept_instance = this;
    var tmp = LinkStubImpl$_init_$ref_6cvkbn();
    OtConceptDescriptor.call(this, 'LinkStub', VOID, tmp, LinkStubConcept$_init_$lambda_hdvymj, Companion_instance_94.k6m([AbstractLinkConcept_getInstance(), ExternallyNamedConcept_getInstance()]));
  }
  var LinkStubConcept_instance;
  function LinkStubConcept_getInstance() {
    if (LinkStubConcept_instance == null)
      new LinkStubConcept();
    return LinkStubConcept_instance;
  }
  function NotionStubImpl$_init_$ref_de8afy() {
    var l = function (p0, p1) {
      return new NotionStubImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function NotionStubConcept$_init_$lambda_8gh33u(context, nodeId) {
    return new TypedNotionStubImpl(context, VOID, nodeId);
  }
  function NotionStubConcept() {
    NotionStubConcept_instance = this;
    var tmp = NotionStubImpl$_init_$ref_de8afy();
    OtConceptDescriptor.call(this, 'NotionStub', VOID, tmp, NotionStubConcept$_init_$lambda_8gh33u, Companion_instance_94.k6m([AbstractNotionConcept_getInstance(), DirectlyNamedConcept_getInstance()]));
  }
  var NotionStubConcept_instance;
  function NotionStubConcept_getInstance() {
    if (NotionStubConcept_instance == null)
      new NotionStubConcept();
    return NotionStubConcept_instance;
  }
  function PropertyStubImpl$_init_$ref_arkxia() {
    var l = function (p0, p1) {
      return new PropertyStubImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function PropertyStubConcept$_init_$lambda_2eggai(context, nodeId) {
    return new TypedPropertyStubImpl(context, VOID, nodeId);
  }
  function PropertyStubConcept() {
    PropertyStubConcept_instance = this;
    var tmp = PropertyStubImpl$_init_$ref_arkxia();
    OtConceptDescriptor.call(this, 'PropertyStub', VOID, tmp, PropertyStubConcept$_init_$lambda_2eggai, Companion_instance_94.k6m([AbstractPropertyConcept_getInstance(), ExternallyNamedConcept_getInstance()]));
  }
  var PropertyStubConcept_instance;
  function PropertyStubConcept_getInstance() {
    if (PropertyStubConcept_instance == null)
      new PropertyStubConcept();
    return PropertyStubConcept_instance;
  }
  function LinkStubImpl(context, node) {
    node = node === VOID ? new Node_0(LinkStubConcept_getInstance().m6n_1) : node;
    AbstractLinkImpl.call(this, context, node);
    this.jlh_1 = get_forQueries(new ValueProperty(''));
    this.klh_1 = get_specializes.call(this);
  }
  protoOf(LinkStubImpl).y2 = function () {
    return this.jlh_1;
  };
  protoOf(LinkStubImpl).ufp = function () {
    return this.klh_1;
  };
  function NotionStubImpl(context, node) {
    node = node === VOID ? new Node_0(NotionStubConcept_getInstance().m6n_1) : node;
    AbstractNotionImpl.call(this, context, node);
    this.plh_1 = get_forQueries(new ValueProperty(''));
  }
  protoOf(NotionStubImpl).y2 = function () {
    return this.plh_1;
  };
  function PropertyStubImpl(context, node) {
    node = node === VOID ? new Node_0(PropertyStubConcept_getInstance().m6n_1) : node;
    AbstractPropertyImpl.call(this, context, node);
    this.tlh_1 = get_forQueries(new ValueProperty(null));
    this.ulh_1 = get_forQueries(new ValueProperty(''));
  }
  protoOf(PropertyStubImpl).sfq = function () {
    return this.tlh_1;
  };
  protoOf(PropertyStubImpl).y2 = function () {
    return this.ulh_1;
  };
  function TypedLinkStubImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? LinkStubConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(LinkStubConcept_getInstance().m6n_1) : nodeId;
    TypedAbstractLinkImpl.call(this, context, conceptId, nodeId);
    this.jli_1 = new DomainNodeInMemoryProperty('');
    this.kli_1 = get_specializes.call(this);
  }
  protoOf(TypedLinkStubImpl).y2 = function () {
    return this.jli_1;
  };
  protoOf(TypedLinkStubImpl).ufp = function () {
    return this.kli_1;
  };
  protoOf(TypedLinkStubImpl).g3p = function (nodeId) {
    return new TypedLinkStubImpl(this.j6k_1, LinkStubConcept_getInstance().m6n_1, nodeId);
  };
  function TypedNotionStubImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? NotionStubConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(NotionStubConcept_getInstance().m6n_1) : nodeId;
    TypedAbstractNotionImpl.call(this, context, conceptId, nodeId);
    this.yli_1 = new DomainNodeInMemoryProperty('');
  }
  protoOf(TypedNotionStubImpl).y2 = function () {
    return this.yli_1;
  };
  protoOf(TypedNotionStubImpl).g3p = function (nodeId) {
    return new TypedNotionStubImpl(this.j6k_1, NotionStubConcept_getInstance().m6n_1, nodeId);
  };
  function TypedPropertyStubImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? PropertyStubConcept_getInstance().m6n_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(PropertyStubConcept_getInstance().m6n_1) : nodeId;
    TypedAbstractPropertyImpl.call(this, context, conceptId, nodeId);
    this.llj_1 = new DomainNodeInMemoryProperty(null);
    this.mlj_1 = new DomainNodeInMemoryProperty('');
  }
  protoOf(TypedPropertyStubImpl).sfq = function () {
    return this.llj_1;
  };
  protoOf(TypedPropertyStubImpl).y2 = function () {
    return this.mlj_1;
  };
  protoOf(TypedPropertyStubImpl).g3p = function (nodeId) {
    return new TypedPropertyStubImpl(this.j6k_1, PropertyStubConcept_getInstance().m6n_1, nodeId);
  };
  function DirectlyNamed$_get_name_$ref_qbhw34_0() {
    return function (p0) {
      return p0.y2();
    };
  }
  function DirectlyNamedConcept() {
    DirectlyNamedConcept_instance = this;
    OTAbstractConceptDescriptor.call(this);
    var tmp = this;
    var tmp_0 = KProperty1;
    tmp.bhz_1 = this.r6m(getPropertyCallableRef('name', 1, tmp_0, DirectlyNamed$_get_name_$ref_qbhw34_0(), null), 'name');
    this.chz_1 = new DomainNodePropertyDescriptor(this.bhz_1, toNonNullPersister(NonNullPersisters_getInstance().h25(), new DefaultValueNullPersister('')));
  }
  var DirectlyNamedConcept_instance;
  function DirectlyNamedConcept_getInstance() {
    if (DirectlyNamedConcept_instance == null)
      new DirectlyNamedConcept();
    return DirectlyNamedConcept_instance;
  }
  function DocumentNode$_get_documentId_$ref_eou2dn_0() {
    return function (p0) {
      return p0.d6g();
    };
  }
  function DocumentNodeConcept_0() {
    DocumentNodeConcept_instance_0 = this;
    OTAbstractConceptDescriptor.call(this);
    var tmp = this;
    var tmp_0 = KProperty1;
    tmp.tlj_1 = this.r6m(getPropertyCallableRef('documentId', 1, tmp_0, DocumentNode$_get_documentId_$ref_eou2dn_0(), null), 'documentId');
    this.ulj_1 = new DomainNodePropertyDescriptor(this.tlj_1, toNonNullPersister(NonNullPersisters_getInstance().h25(), new DefaultValueNullPersister('')));
  }
  var DocumentNodeConcept_instance_0;
  function DocumentNodeConcept_getInstance_0() {
    if (DocumentNodeConcept_instance_0 == null)
      new DocumentNodeConcept_0();
    return DocumentNodeConcept_instance_0;
  }
  function get_btbMetaModel() {
    _init_properties_BTB_kt__ga36ou();
    return btbMetaModel;
  }
  var btbMetaModel;
  function $runSuspendCOROUTINE$_40(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.dlk_1 = _this__u8e3s4;
    this.elk_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_40).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 9;
            this.flk_1 = this.elk_1;
            var tmp0 = this.flk_1.l60(this.dlk_1.mlk_1.zfp());
            this.klk_1 = ArrayList_init_$Create$();
            this.llk_1 = tmp0.m();
            this.f9_1 = 1;
            continue $sm;
          case 1:
            if (!this.llk_1.n()) {
              this.f9_1 = 3;
              continue $sm;
            }

            var element = this.llk_1.o();
            this.f9_1 = 2;
            suspendResult = this.flk_1.k60(element.yfq(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var tmp0_safe_receiver = suspendResult;
            if (tmp0_safe_receiver == null)
              null;
            else {
              this.klk_1.j(tmp0_safe_receiver);
            }

            this.f9_1 = 1;
            continue $sm;
          case 3:
            var tmp0_0 = this.klk_1;
            var destination = ArrayList_init_$Create$();
            var _iterator__ex2g4s = tmp0_0.m();
            while (_iterator__ex2g4s.n()) {
              var element_0 = _iterator__ex2g4s.o();
              var list = this.flk_1.l60(element_0.zfp());
              addAll_1(destination, list);
            }

            this.glk_1 = ArrayList_init_$Create$();
            this.jlk_1 = destination.m();
            this.f9_1 = 4;
            continue $sm;
          case 4:
            if (!this.jlk_1.n()) {
              this.f9_1 = 8;
              continue $sm;
            }

            this.hlk_1 = this.jlk_1.o();
            var it = this.hlk_1;
            var tmp0_safe_receiver_0 = this.flk_1.l60(it.gfq());
            var tmp1_safe_receiver = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.gfq();
            if (tmp1_safe_receiver == null) {
              this.ilk_1 = null;
              this.f9_1 = 6;
              continue $sm;
            } else {
              this.f9_1 = 5;
              suspendResult = this.flk_1.k60(tmp1_safe_receiver, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 5:
            this.ilk_1 = suspendResult;
            this.f9_1 = 6;
            continue $sm;
          case 6:
            if (this.ilk_1 === this.dlk_1.nlk_1) {
              this.glk_1.j(this.hlk_1);
              this.f9_1 = 7;
              continue $sm;
            } else {
              this.f9_1 = 7;
              continue $sm;
            }

          case 7:
            this.f9_1 = 4;
            continue $sm;
          case 8:
            var tmp0_1 = this.glk_1;
            var destination_0 = ArrayList_init_$Create$();
            var _iterator__ex2g4s_0 = tmp0_1.m();
            while (_iterator__ex2g4s_0.n()) {
              var element_1 = _iterator__ex2g4s_0.o();
              var tmp0_safe_receiver_1 = this.flk_1.l60(element_1.yfs());
              if (tmp0_safe_receiver_1 == null)
                null;
              else {
                destination_0.j(tmp0_safe_receiver_1);
              }
            }

            return destination_0;
          case 9:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 9) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function BTBDocument$librariesForElement$$inlined$suspendingQuery$1(this$0, $element) {
    this.mlk_1 = this$0;
    this.nlk_1 = $element;
  }
  protoOf(BTBDocument$librariesForElement$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_40(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(BTBDocument$librariesForElement$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function BTBDocument_1() {
  }
  function Category_1() {
  }
  function FactSet_1() {
  }
  function Context_2() {
  }
  function Companion_311() {
    Companion_instance_311 = this;
    this.tgl_1 = Companion_getInstance_338().ihc_1;
  }
  var Companion_instance_311;
  function Companion_getInstance_311() {
    if (Companion_instance_311 == null)
      new Companion_311();
    return Companion_instance_311;
  }
  function LibraryProcessSpecification_1() {
  }
  function FactExpressionPlaceholder() {
  }
  function Companion_312() {
    Companion_instance_312 = this;
    var tmp = this;
    // Inline function 'jetbrains.ocelot.langDef.references.repoRefTag' call
    var name = 'modifierReference';
    tmp.bgr_1 = new RefTag(getKClass(ModifierFactExpression_0), getKClass(ModifierDeclaration), getKClass(QualifiedReferenceContent), name);
  }
  var Companion_instance_312;
  function Companion_getInstance_312() {
    if (Companion_instance_312 == null)
      new Companion_312();
    return Companion_instance_312;
  }
  function ModifierFactExpression_0() {
  }
  function Fact_1() {
  }
  function NewFact() {
  }
  function HasVariables() {
  }
  function MultilineText() {
  }
  function TextLine() {
  }
  function Precondition() {
  }
  function AbstractProcessSpecification() {
  }
  function Companion_313() {
    Companion_instance_313 = this;
    var tmp = this;
    // Inline function 'jetbrains.ocelot.langDef.references.localRefTag' call
    tmp.igb_1 = new RefTag(getKClass(FactReference_1), getKClass(Fact_1), getKClass(LocalReferenceContent), 'fact');
  }
  var Companion_instance_313;
  function Companion_getInstance_313() {
    if (Companion_instance_313 == null)
      new Companion_313();
    return Companion_instance_313;
  }
  function FactReference_1() {
  }
  function ConstantPrecondition_0() {
  }
  var When_ALWAYS_instance;
  var When_NEVER_instance;
  function values_12() {
    return [When_ALWAYS_getInstance(), When_NEVER_getInstance()];
  }
  var When_entriesInitialized;
  function When_initEntries() {
    if (When_entriesInitialized)
      return Unit_instance;
    When_entriesInitialized = true;
    When_ALWAYS_instance = new When('ALWAYS', 0);
    When_NEVER_instance = new When('NEVER', 1);
  }
  function When(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function Companion_314() {
    Companion_instance_314 = this;
    var tmp = this;
    // Inline function 'jetbrains.ocelot.langDef.references.repoRefTag' call
    var name = 'relation';
    tmp.hgb_1 = new RefTag(getKClass(FactPrecondition_1), getKClass(ProcessRelationDeclaration_1), getKClass(QualifiedReferenceContent), name);
  }
  var Companion_instance_314;
  function Companion_getInstance_314() {
    if (Companion_instance_314 == null)
      new Companion_314();
    return Companion_instance_314;
  }
  function FactPrecondition_1() {
  }
  function FactExpression() {
  }
  function Companion_315() {
    Companion_instance_315 = this;
    var tmp = this;
    // Inline function 'jetbrains.ocelot.langDef.references.localRefTag' call
    tmp.agu_1 = new RefTag(getKClass(NewFactReference_0), getKClass(NewFact), getKClass(LocalReferenceContent), 'newFact');
  }
  var Companion_instance_315;
  function Companion_getInstance_315() {
    if (Companion_instance_315 == null)
      new Companion_315();
    return Companion_instance_315;
  }
  function NewFactReference_0() {
  }
  function Companion_316() {
    Companion_instance_316 = this;
    var tmp = this;
    // Inline function 'jetbrains.ocelot.langDef.references.repoRefTag' call
    var name = 'relationInFact';
    tmp.phr_1 = new RefTag(getKClass(RelationFactExpression_1), getKClass(ProcessRelationDeclaration_1), getKClass(QualifiedReferenceContent), name);
  }
  var Companion_instance_316;
  function Companion_getInstance_316() {
    if (Companion_instance_316 == null)
      new Companion_316();
    return Companion_instance_316;
  }
  function RelationFactExpression_1() {
  }
  function QueryLabelsFactExpressionContainer_0() {
  }
  function HasFactExpression() {
  }
  function ProcessProvider() {
  }
  function Companion_317() {
    Companion_instance_317 = this;
    this.olk_1 = GeneratedBioKbStuff_instance;
  }
  var Companion_instance_317;
  function Companion_getInstance_317() {
    if (Companion_instance_317 == null)
      new Companion_317();
    return Companion_instance_317;
  }
  function When_ALWAYS_getInstance() {
    When_initEntries();
    return When_ALWAYS_instance;
  }
  function When_NEVER_getInstance() {
    When_initEntries();
    return When_NEVER_instance;
  }
  var properties_initialized_BTB_kt_kbff0g;
  function _init_properties_BTB_kt__ga36ou() {
    if (!properties_initialized_BTB_kt_kbff0g) {
      properties_initialized_BTB_kt_kbff0g = true;
      btbMetaModel = BtbMetaModel_getInstance();
    }
  }
  function BTBNode() {
  }
  function get_searchableNodeType(_this__u8e3s4) {
    var tmp;
    if (isInterface(_this__u8e3s4, ProcessDeclaration_1)) {
      tmp = 'process';
    } else {
      if (isInterface(_this__u8e3s4, ProcessKind_1)) {
        tmp = 'process kind';
      } else {
        if (isInterface(_this__u8e3s4, ProcessProperty_1)) {
          tmp = 'process property';
        } else {
          if (isInterface(_this__u8e3s4, PropertyDeclaration_1)) {
            tmp = 'process property';
          } else {
            if (isInterface(_this__u8e3s4, AbstractProperty)) {
              tmp = 'process property';
            } else {
              if (isInterface(_this__u8e3s4, LinkDeclaration_1)) {
                tmp = 'process link';
              } else {
                if (isInterface(_this__u8e3s4, ObjectPropertyDeclaration_1)) {
                  tmp = 'property';
                } else {
                  if (isInterface(_this__u8e3s4, AbstractLink)) {
                    tmp = 'process link';
                  } else {
                    if (isInterface(_this__u8e3s4, VariableDeclaration_1)) {
                      tmp = 'variable';
                    } else {
                      if (isInterface(_this__u8e3s4, ProcessRelationDeclaration_1)) {
                        tmp = 'fact relation';
                      } else {
                        if (isInterface(_this__u8e3s4, InstanceRelationDeclaration)) {
                          tmp = 'instance relation';
                        } else {
                          if (isInterface(_this__u8e3s4, Fact_1)) {
                            tmp = 'fact';
                          } else {
                            if (isInterface(_this__u8e3s4, FieldDeclaration_1)) {
                              tmp = 'extension field';
                            } else {
                              if (isInterface(_this__u8e3s4, FunctionDeclaration_1)) {
                                tmp = 'function';
                              } else {
                                if (isInterface(_this__u8e3s4, OntologyImportRoot_1)) {
                                  tmp = 'ontology import root';
                                } else {
                                  if (isInterface(_this__u8e3s4, MeasurementUnit_1)) {
                                    tmp = 'measurement unit';
                                  } else {
                                    if (isInterface(_this__u8e3s4, EnumerationConstant_1)) {
                                      tmp = 'enumeration constant';
                                    } else {
                                      if (isInterface(_this__u8e3s4, AbstractNotion)) {
                                        tmp = 'notion';
                                      } else {
                                        if (isInterface(_this__u8e3s4, OntologyElement_1)) {
                                          tmp = '';
                                        } else {
                                          if (isInterface(_this__u8e3s4, PublishedWork)) {
                                            tmp = 'published work';
                                          } else {
                                            tmp = ensureNotNull(getKClassFromExpression(_this__u8e3s4).ra());
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    return tmp;
  }
  function BTBNodePersister(wrapperContext, nodeFactory) {
    DomainNodePersister.call(this, wrapperContext, nodeFactory);
    this.slk_1 = wrapperContext;
    this.tlk_1 = new NullPersisterForNullable();
    this.ulk_1 = new BtbOtNodePersister(nodeFactory);
  }
  protoOf(BTBNodePersister).m25 = function () {
    return this.tlk_1;
  };
  protoOf(BTBNodePersister).vlk = function (value) {
    var tmp = toOtNode(value);
    var tmp_0;
    if (isInterface(value, ExternallyNamed)) {
      tmp_0 = execute_0(value.y2());
    } else {
      tmp_0 = null;
    }
    var nodeWithName = new NodeWithName(tmp, tmp_0);
    return this.ulk_1.ylk(nodeWithName);
  };
  protoOf(BTBNodePersister).n25 = function (value) {
    return this.vlk((!(value == null) ? isInterface(value, BTBNode) : false) ? value : THROW_CCE());
  };
  protoOf(BTBNodePersister).b6h = function (value) {
    return this.vlk(isInterface(value, BTBNode) ? value : THROW_CCE());
  };
  protoOf(BTBNodePersister).o25 = function (value) {
    var nodeWithName = this.ulk_1.o25(value);
    var tmp = toDomainNode(nodeWithName.zlk_1, this.slk_1);
    var btbNode = isInterface(tmp, BTBNode) ? tmp : THROW_CCE();
    if (!(nodeWithName.all_1 == null)) {
      // Inline function 'kotlin.require' call
      // Inline function 'kotlin.require' call
      if (!isInterface(btbNode, ExternallyNamed)) {
        var message = 'Failed requirement.';
        throw IllegalArgumentException_init_$Create$_0(toString_1(message));
      }
      btbNode.y2().d2x(nodeWithName.all_1);
    }
    return btbNode;
  };
  function BtbOtNodePersister$deserializeNonNull$lambda(this$0) {
    return function ($this$readArray) {
      var node = this$0.xlk_1.w3l(ensureNotNull($this$readArray.z2i()));
      var name = $this$readArray.y2i();
      return new NodeWithName(node, name);
    };
  }
  function BtbOtNodePersister(nodeFactory) {
    this.wlk_1 = new NullPersisterForNullable();
    this.xlk_1 = new Json2NodeConverter(new NodeIdPersistenceContext(), nodeFactory);
  }
  protoOf(BtbOtNodePersister).m25 = function () {
    return this.wlk_1;
  };
  protoOf(BtbOtNodePersister).ylk = function (value) {
    var json = new JsonArray();
    json.y2g((new Node2JsonConverter(new NodeIdPersistenceContext())).b3n(value.zlk_1));
    if (!(value.all_1 == null)) {
      json.m2h(value.all_1);
    }
    return json.toString();
  };
  protoOf(BtbOtNodePersister).n25 = function (value) {
    return this.ylk(value instanceof NodeWithName ? value : THROW_CCE());
  };
  protoOf(BtbOtNodePersister).o25 = function (value) {
    var tmp = CommonJsonStreamIterSupport_instance.g2l(value);
    var jsonReader = isInterface(tmp, JsonArrayReader) ? tmp : THROW_CCE();
    return jsonReader.x2i(BtbOtNodePersister$deserializeNonNull$lambda(this));
  };
  function NodeWithName(node, name) {
    this.zlk_1 = node;
    this.all_1 = name;
  }
  protoOf(NodeWithName).toString = function () {
    return 'NodeWithName(node=' + this.zlk_1.toString() + ', name=' + this.all_1 + ')';
  };
  protoOf(NodeWithName).hashCode = function () {
    var result = hashCode(this.zlk_1);
    result = imul(result, 31) + (this.all_1 == null ? 0 : getStringHashCode(this.all_1)) | 0;
    return result;
  };
  protoOf(NodeWithName).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof NodeWithName))
      return false;
    if (!equals(this.zlk_1, other.zlk_1))
      return false;
    if (!(this.all_1 == other.all_1))
      return false;
    return true;
  };
  function BindingValuePlaceholder_1() {
  }
  function Companion_318() {
    Companion_instance_318 = this;
    var tmp = this;
    // Inline function 'jetbrains.ocelot.langDef.references.repoRefTag' call
    var name = 'processPropertyInValue';
    tmp.uhg_1 = new RefTag(getKClass(ProcessPropertyValue_1), getKClass(ProcessProperty_1), getKClass(QualifiedReferenceContent), name);
  }
  var Companion_instance_318;
  function Companion_getInstance_318() {
    if (Companion_instance_318 == null)
      new Companion_318();
    return Companion_instance_318;
  }
  function ProcessPropertyValue_1() {
  }
  function AbstractBindingDeclaration() {
  }
  function AbstractBindingEntry() {
  }
  function EmptyBindingEntry_1() {
  }
  function AbstractBindingValue() {
  }
  function UnionClass_1() {
  }
  function ClassExpressionType_1() {
  }
  function ClassExpressionPlaceholder_1() {
  }
  function ClassExpression() {
  }
  function AnonymousClass$getClassDeclaration$$inlined$suspendingQuery$1(this$0) {
    this.bll_1 = this$0;
  }
  protoOf(AnonymousClass$getClassDeclaration$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    return this.bll_1;
  };
  protoOf(AnonymousClass$getClassDeclaration$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function AnonymousClass() {
  }
  function ClassDeclaration() {
  }
  function Companion_319() {
    Companion_instance_319 = this;
    var tmp = this;
    // Inline function 'jetbrains.ocelot.langDef.references.repoRefTag' call
    var name = 'complexNotion';
    tmp.eg4_1 = new RefTag(getKClass(BTBNode), getKClass(ComplexNotion_1), getKClass(QualifiedReferenceContent), name);
  }
  var Companion_instance_319;
  function Companion_getInstance_319() {
    if (Companion_instance_319 == null)
      new Companion_319();
    return Companion_instance_319;
  }
  function ComplexNotionValue_1() {
  }
  function Companion_320() {
    Companion_instance_320 = this;
    var tmp = this;
    // Inline function 'jetbrains.ocelot.langDef.references.repoRefTag' call
    tmp.eg2_1 = new RefTag(getKClass(BTBNode), getKClass(ComplexNotionElement_1), getKClass(QualifiedReferenceContent), 'element');
  }
  var Companion_instance_320;
  function Companion_getInstance_320() {
    if (Companion_instance_320 == null)
      new Companion_320();
    return Companion_instance_320;
  }
  function ComplexNotionElementValue_1() {
  }
  function AllowedComplexNotionType() {
  }
  function ComplexNotionElement_1() {
  }
  function ComplexNotion_1() {
  }
  function ComplexNotionTemplate_1() {
  }
  function ComplexNotionTemplateElement() {
  }
  function ComplexNotionTemplateTextElement_1() {
  }
  function Companion_321() {
    Companion_instance_321 = this;
    var tmp = this;
    // Inline function 'jetbrains.ocelot.langDef.references.localRefTag' call
    var name = 'templateElement';
    tmp.fg3_1 = new RefTag(getKClass(BTBNode), getKClass(ComplexNotionElement_1), getKClass(LocalReferenceContent), name);
  }
  var Companion_instance_321;
  function Companion_getInstance_321() {
    if (Companion_instance_321 == null)
      new Companion_321();
    return Companion_instance_321;
  }
  function ComplexNotionTemplateRefElement_1() {
  }
  function AllowedComplexNotionValue() {
  }
  function UnknownComplexNotionValue_1() {
  }
  function ComplexNotionTemplatePlaceholder_1() {
  }
  function CustomEditor() {
  }
  function CustomCell() {
  }
  function ConstantCustomCell_1() {
  }
  function Companion_322() {
    Companion_instance_322 = this;
    var tmp = this;
    // Inline function 'jetbrains.ocelot.langDef.references.repoRefTag' call
    var name = 'processProperty';
    tmp.ihf_1 = new RefTag(getKClass(ProcessPropertyCustomCell_1), getKClass(ProcessProperty_1), getKClass(QualifiedReferenceContent), name);
  }
  var Companion_instance_322;
  function Companion_getInstance_322() {
    if (Companion_instance_322 == null)
      new Companion_322();
    return Companion_instance_322;
  }
  function ProcessPropertyCustomCell_1() {
  }
  function Companion_323() {
    Companion_instance_323 = this;
    var tmp = this;
    // Inline function 'jetbrains.ocelot.langDef.references.repoRefTag' call
    var name = 'property';
    tmp.vhj_1 = new RefTag(getKClass(PropertyCustomCell_1), getKClass(AbstractProperty), getKClass(QualifiedReferenceContent), name);
  }
  var Companion_instance_323;
  function Companion_getInstance_323() {
    if (Companion_instance_323 == null)
      new Companion_323();
    return Companion_instance_323;
  }
  function PropertyCustomCell_1() {
  }
  function Companion_324() {
    Companion_instance_324 = this;
    var tmp = this;
    // Inline function 'jetbrains.ocelot.langDef.references.repoRefTag' call
    tmp.agn_1 = new RefTag(getKClass(LinkCustomCell_1), getKClass(AbstractLink), getKClass(QualifiedReferenceContent), 'link');
  }
  var Companion_instance_324;
  function Companion_getInstance_324() {
    if (Companion_instance_324 == null)
      new Companion_324();
    return Companion_instance_324;
  }
  function LinkCustomCell_1() {
  }
  function KindCustomCell_1() {
  }
  function ReturnTypeCustomCell_1() {
  }
  function CardinalityCustomCell_1() {
  }
  function DeclarationNameCustomCell_1() {
  }
  function PropertiesCustomCell_1() {
  }
  function DocumentNode_0() {
  }
  function ExtensionLibrary_1() {
  }
  function ExtensionDeclaration_1() {
  }
  function FieldDeclaration_1() {
  }
  function Companion_325() {
    Companion_instance_325 = this;
    var tmp = this;
    // Inline function 'jetbrains.ocelot.langDef.references.repoRefTag' call
    tmp.gg9_1 = new RefTag(getKClass(BTBNode), getKClass(FieldDeclaration_1), getKClass(QualifiedReferenceContent), 'field');
  }
  var Companion_instance_325;
  function Companion_getInstance_325() {
    if (Companion_instance_325 == null)
      new Companion_325();
    return Companion_instance_325;
  }
  function ExtensionFieldReference_1() {
  }
  function ExternallyNamed() {
  }
  function Companion_326() {
    Companion_instance_326 = this;
    var tmp = this;
    // Inline function 'jetbrains.ocelot.langDef.references.repoRefTag' call
    var name = 'function';
    tmp.kgf_1 = new RefTag(getKClass(BTBNode), getKClass(FunctionDeclaration_1), getKClass(QualifiedReferenceContent), name);
  }
  var Companion_instance_326;
  function Companion_getInstance_326() {
    if (Companion_instance_326 == null)
      new Companion_326();
    return Companion_instance_326;
  }
  function FunctionTerm_1() {
  }
  function FunctionDeclaration_1() {
  }
  function Cardinality_1() {
  }
  function FunctionLibrary_1() {
  }
  function CardinalityBoundPlaceholder_1() {
  }
  function CardinalityBound() {
  }
  function CardinalityBoundConstant_1() {
  }
  function CardinalityBoundN_1() {
  }
  var CardinalitySpecificator_ALL_OF_instance;
  var CardinalitySpecificator_SOME_OF_instance;
  var CardinalitySpecificator_AT_LEAST_ONE_OF_instance;
  var CardinalitySpecificator_EXACTLY_ONE_OF_instance;
  function values_13() {
    return [CardinalitySpecificator_ALL_OF_getInstance(), CardinalitySpecificator_SOME_OF_getInstance(), CardinalitySpecificator_AT_LEAST_ONE_OF_getInstance(), CardinalitySpecificator_EXACTLY_ONE_OF_getInstance()];
  }
  var CardinalitySpecificator_entriesInitialized;
  function CardinalitySpecificator_initEntries() {
    if (CardinalitySpecificator_entriesInitialized)
      return Unit_instance;
    CardinalitySpecificator_entriesInitialized = true;
    CardinalitySpecificator_ALL_OF_instance = new CardinalitySpecificator('ALL_OF', 0);
    CardinalitySpecificator_SOME_OF_instance = new CardinalitySpecificator('SOME_OF', 1);
    CardinalitySpecificator_AT_LEAST_ONE_OF_instance = new CardinalitySpecificator('AT_LEAST_ONE_OF', 2);
    CardinalitySpecificator_EXACTLY_ONE_OF_instance = new CardinalitySpecificator('EXACTLY_ONE_OF', 3);
  }
  function CardinalitySpecificator(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function CardinalitySpecificator_ALL_OF_getInstance() {
    CardinalitySpecificator_initEntries();
    return CardinalitySpecificator_ALL_OF_instance;
  }
  function CardinalitySpecificator_SOME_OF_getInstance() {
    CardinalitySpecificator_initEntries();
    return CardinalitySpecificator_SOME_OF_instance;
  }
  function CardinalitySpecificator_AT_LEAST_ONE_OF_getInstance() {
    CardinalitySpecificator_initEntries();
    return CardinalitySpecificator_AT_LEAST_ONE_OF_instance;
  }
  function CardinalitySpecificator_EXACTLY_ONE_OF_getInstance() {
    CardinalitySpecificator_initEntries();
    return CardinalitySpecificator_EXACTLY_ONE_OF_instance;
  }
  function HasComments() {
  }
  function Companion_327() {
    Companion_instance_327 = this;
    var tmp = this;
    // Inline function 'jetbrains.ocelot.langDef.references.repoRefTag' call
    var name = 'ontologyImport';
    tmp.sh4_1 = new RefTag(getKClass(OntologyImportRootReference_1), getKClass(OntologyImportRoot_1), getKClass(QualifiedReferenceContent), name);
  }
  var Companion_instance_327;
  function Companion_getInstance_327() {
    if (Companion_instance_327 == null)
      new Companion_327();
    return Companion_instance_327;
  }
  function OntologyImportRootReference_1() {
  }
  function OntologyImportRoot_1() {
  }
  function OntologyImport_1() {
  }
  function KnowledgeSourceReference() {
  }
  function KnowledgeSourceReferencePlaceholder_1() {
  }
  function UrlKnowledgeSourceReference_1() {
  }
  function PubMedSourceReference_1() {
  }
  function Companion_328() {
    Companion_instance_328 = this;
    var tmp = this;
    // Inline function 'jetbrains.ocelot.langDef.references.repoRefTag' call
    var name = 'publishedSource';
    tmp.hhn_1 = new RefTag(getKClass(PublishedSourceReference_1), getKClass(PublishedWork), getKClass(QualifiedReferenceContent), name);
  }
  var Companion_instance_328;
  function Companion_getInstance_328() {
    if (Companion_instance_328 == null)
      new Companion_328();
    return Companion_instance_328;
  }
  function PublishedSourceReference_1() {
  }
  function PageSpecification() {
  }
  function Page_1() {
  }
  function PageRange_1() {
  }
  function PublishedSourcesLibrary_1() {
  }
  function LibraryItemPlaceholder_1() {
  }
  function HasKnowledgeSources() {
  }
  function Companion_329() {
    Companion_instance_329 = this;
    var tmp = this;
    // Inline function 'jetbrains.ocelot.langDef.references.repoRefTag' call
    var name = 'abstractLink';
    tmp.rfv_1 = new RefTag(getKClass(BTBNode), getKClass(AbstractLink), getKClass(QualifiedReferenceContent), name);
  }
  var Companion_instance_329;
  function Companion_getInstance_329() {
    if (Companion_instance_329 == null)
      new Companion_329();
    return Companion_instance_329;
  }
  function AbstractLink() {
  }
  function LinkLibrary_1() {
  }
  function LinkDeclaration_1() {
  }
  var LinkTypeSpecificator_INSTANCE_OF_instance;
  var LinkTypeSpecificator_TYPE_OF_instance;
  function values_14() {
    return [LinkTypeSpecificator_INSTANCE_OF_getInstance(), LinkTypeSpecificator_TYPE_OF_getInstance()];
  }
  var LinkTypeSpecificator_entriesInitialized;
  function LinkTypeSpecificator_initEntries() {
    if (LinkTypeSpecificator_entriesInitialized)
      return Unit_instance;
    LinkTypeSpecificator_entriesInitialized = true;
    LinkTypeSpecificator_INSTANCE_OF_instance = new LinkTypeSpecificator('INSTANCE_OF', 0);
    LinkTypeSpecificator_TYPE_OF_instance = new LinkTypeSpecificator('TYPE_OF', 1);
  }
  function LinkTypeSpecificator(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function $runSuspendCOROUTINE$_41(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.kll_1 = _this__u8e3s4;
    this.lll_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_41).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 3;
            var $this$suspendingQuery = this.lll_1;
            var tmp0_safe_receiver = $this$suspendingQuery.l60(this.kll_1.nll_1.xa1());
            var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.sfq();
            var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : $this$suspendingQuery.l60(tmp1_safe_receiver);
            var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.gfq();
            var tmp4_safe_receiver = tmp3_safe_receiver == null ? null : $this$suspendingQuery.l60(tmp3_safe_receiver);
            var tmp5_safe_receiver = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.gfq();
            if (tmp5_safe_receiver == null) {
              this.mll_1 = null;
              this.f9_1 = 2;
              continue $sm;
            } else {
              this.f9_1 = 1;
              suspendResult = $this$suspendingQuery.k60(tmp5_safe_receiver, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            this.mll_1 = suspendResult;
            this.f9_1 = 2;
            continue $sm;
          case 2:
            return this.mll_1;
          case 3:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 3) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function OntologyLink$name$$inlined$suspendingQuery$1(this$0) {
    this.oll_1 = this$0;
  }
  protoOf(OntologyLink$name$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp0_safe_receiver = builder.l60(this.oll_1.xa1());
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.y2();
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : builder.l60(tmp1_safe_receiver);
    return tmp2_elvis_lhs == null ? '' : tmp2_elvis_lhs;
  };
  protoOf(OntologyLink$name$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function OntologyLink$element$$inlined$suspendingQuery$1(this$0) {
    this.nll_1 = this$0;
  }
  protoOf(OntologyLink$element$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_41(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(OntologyLink$element$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function OntologyLink$specificator$$inlined$query$1(this$0) {
    this.pll_1 = this$0;
  }
  protoOf(OntologyLink$specificator$$inlined$query$1).n5w = function (builder) {
    var tmp0_safe_receiver = builder.l60(this.pll_1.xa1());
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.jfr();
    return tmp1_safe_receiver == null ? null : builder.l60(tmp1_safe_receiver);
  };
  function OntologyLink_1() {
  }
  function $runSuspendCOROUTINE$_42(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.yll_1 = _this__u8e3s4;
    this.zll_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_42).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.alm_1 = this.zll_1;
            this.f9_1 = 1;
            suspendResult = this.alm_1.k60(this.yll_1.blm_1.sfr(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp0_safe_receiver = suspendResult;
            var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.y2();
            var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : this.alm_1.l60(tmp1_safe_receiver);
            return tmp2_elvis_lhs == null ? '' : tmp2_elvis_lhs;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function $runSuspendCOROUTINE$_43(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.klm_1 = _this__u8e3s4;
    this.llm_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_43).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.mlm_1 = this.llm_1;
            this.f9_1 = 1;
            suspendResult = this.mlm_1.k60(this.klm_1.nlm_1.sfr(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp0_safe_receiver = suspendResult;
            var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.jfr();
            return tmp1_safe_receiver == null ? null : this.mlm_1.l60(tmp1_safe_receiver);
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function $runSuspendCOROUTINE$_44(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.wlm_1 = _this__u8e3s4;
    this.xlm_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_44).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 4;
            this.zlm_1 = this.xlm_1;
            this.f9_1 = 1;
            suspendResult = this.zlm_1.k60(this.wlm_1.aln_1.sfr(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp0_safe_receiver = suspendResult;
            var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.sfq();
            var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : this.zlm_1.l60(tmp1_safe_receiver);
            var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.gfq();
            var tmp4_safe_receiver = tmp3_safe_receiver == null ? null : this.zlm_1.l60(tmp3_safe_receiver);
            var tmp5_safe_receiver = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.gfq();
            if (tmp5_safe_receiver == null) {
              this.ylm_1 = null;
              this.f9_1 = 3;
              continue $sm;
            } else {
              this.f9_1 = 2;
              suspendResult = this.zlm_1.k60(tmp5_safe_receiver, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 2:
            this.ylm_1 = suspendResult;
            this.f9_1 = 3;
            continue $sm;
          case 3:
            return this.ylm_1;
          case 4:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 4) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function Companion_330() {
    Companion_instance_330 = this;
    var tmp = this;
    // Inline function 'jetbrains.ocelot.langDef.references.repoRefTag' call
    var name = 'importedLinkReference';
    tmp.agi_1 = new RefTag(getKClass(ImportedLink_1), getKClass(LinkDeclaration_1), getKClass(QualifiedReferenceContent), name);
  }
  var Companion_instance_330;
  function Companion_getInstance_330() {
    if (Companion_instance_330 == null)
      new Companion_330();
    return Companion_instance_330;
  }
  function ImportedLink$name$$inlined$suspendingQuery$1(this$0) {
    this.blm_1 = this$0;
  }
  protoOf(ImportedLink$name$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_42(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(ImportedLink$name$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function ImportedLink$specificator$$inlined$suspendingQuery$1(this$0) {
    this.nlm_1 = this$0;
  }
  protoOf(ImportedLink$specificator$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_43(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(ImportedLink$specificator$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function ImportedLink$element$$inlined$suspendingQuery$1(this$0) {
    this.aln_1 = this$0;
  }
  protoOf(ImportedLink$element$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_44(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(ImportedLink$element$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function ImportedLink_1() {
  }
  function $runSuspendCOROUTINE$_45(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.jln_1 = _this__u8e3s4;
    this.kln_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_45).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 9;
            var tmp_0 = this;
            tmp_0.rln_1 = this.kln_1;
            this.lln_1 = Unit_instance;
            this.f9_1 = 1;
            continue $sm;
          case 1:
            this.nln_1 = this.rln_1;
            this.f9_1 = 2;
            suspendResult = this.nln_1.k60(this.jln_1.sln_1.cft(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var tmp0_safe_receiver = suspendResult;
            var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.gfq();
            if (tmp1_safe_receiver == null) {
              this.qln_1 = null;
              this.f9_1 = 4;
              continue $sm;
            } else {
              this.f9_1 = 3;
              suspendResult = this.nln_1.k60(tmp1_safe_receiver, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 3:
            this.qln_1 = suspendResult;
            this.f9_1 = 4;
            continue $sm;
          case 4:
            var tmp2_elvis_lhs = this.qln_1;
            if (tmp2_elvis_lhs == null) {
              this.lln_1 = emptyList();
              this.f9_1 = 8;
              var tmp_1 = this;
              continue $sm;
            } else {
              this.pln_1 = tmp2_elvis_lhs;
              this.f9_1 = 5;
              continue $sm;
            }

          case 5:
            this.mln_1 = this.pln_1;
            var this_0 = this.jln_1.sln_1;
            var tmp3_elvis_lhs = this.nln_1.l60(ancestorOrSelf(this_0, getKClass(BTBDocument_1)));
            if (tmp3_elvis_lhs == null) {
              this.lln_1 = emptyList();
              this.f9_1 = 8;
              var tmp_2 = this;
              continue $sm;
            } else {
              this.oln_1 = tmp3_elvis_lhs;
              this.f9_1 = 6;
              continue $sm;
            }

          case 6:
            var doc = this.oln_1;
            this.f9_1 = 7;
            suspendResult = this.nln_1.k60(doc.li0(this.mln_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 7:
            this.lln_1 = suspendResult;
            if (false) {
              this.f9_1 = 1;
              continue $sm;
            }

            this.f9_1 = 8;
            continue $sm;
          case 8:
            return this.lln_1;
          case 9:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 9) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function Companion_331() {
    Companion_instance_331 = this;
    this.rh7_1 = Companion_getInstance_329().rfv_1;
  }
  var Companion_instance_331;
  function Companion_getInstance_331() {
    if (Companion_instance_331 == null)
      new Companion_331();
    return Companion_instance_331;
  }
  function OntologyLinkValue$importedLibraries$$inlined$suspendingQuery$1(this$0) {
    this.sln_1 = this$0;
  }
  protoOf(OntologyLinkValue$importedLibraries$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_45(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(OntologyLinkValue$importedLibraries$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function OntologyLinkValue_1() {
  }
  function LinkTypeSpecificator_INSTANCE_OF_getInstance() {
    LinkTypeSpecificator_initEntries();
    return LinkTypeSpecificator_INSTANCE_OF_instance;
  }
  function LinkTypeSpecificator_TYPE_OF_getInstance() {
    LinkTypeSpecificator_initEntries();
    return LinkTypeSpecificator_TYPE_OF_instance;
  }
  function ModifierContainer() {
  }
  function ModifierDeclaration() {
  }
  function TypePlaceholder_1() {
  }
  function Companion_332() {
    Companion_instance_332 = this;
    var tmp = this;
    // Inline function 'jetbrains.ocelot.langDef.references.refTag' call
    var name = 'superProperty';
    tmp.ugw_1 = new RefTag(getKClass(ObjectPropertyDeclaration_1), getKClass(ObjectPropertyDeclaration_1), getKClass(QualifiedReferenceContent), name);
    var tmp_0 = this;
    // Inline function 'jetbrains.ocelot.langDef.references.refTag' call
    var name_0 = 'inverseProperty';
    tmp_0.vgw_1 = new RefTag(getKClass(ObjectPropertyDeclaration_1), getKClass(ObjectPropertyDeclaration_1), getKClass(QualifiedReferenceContent), name_0);
  }
  var Companion_instance_332;
  function Companion_getInstance_332() {
    if (Companion_instance_332 == null)
      new Companion_332();
    return Companion_instance_332;
  }
  function ObjectPropertyDeclaration_1() {
  }
  function Companion_333() {
    Companion_instance_333 = this;
    var tmp = this;
    // Inline function 'jetbrains.ocelot.langDef.references.repoRefTag' call
    var name = 'propertyInConstraint';
    tmp.uhj_1 = new RefTag(getKClass(PropertyConstraint_1), getKClass(ObjectPropertyDeclaration_1), getKClass(QualifiedReferenceContent), name);
  }
  var Companion_instance_333;
  function Companion_getInstance_333() {
    if (Companion_instance_333 == null)
      new Companion_333();
    return Companion_instance_333;
  }
  function PropertyConstraint_1() {
  }
  function PropertyValueRange() {
  }
  function ObjectPropertiesLibrary() {
  }
  function NoValues_1() {
  }
  function MultiplePropertyValueRange_1() {
  }
  function SinglePropertyValueRange_1() {
  }
  var ConstraintOperation_ADDITION_ASSIGNMENT_instance;
  var ConstraintOperation_SUBTRACT_ASSIGNMENT_instance;
  function Companion_334() {
    this.tln_1 = '=';
  }
  var Companion_instance_334;
  function Companion_getInstance_334() {
    return Companion_instance_334;
  }
  function values_15() {
    return [ConstraintOperation_ADDITION_ASSIGNMENT_getInstance(), ConstraintOperation_SUBTRACT_ASSIGNMENT_getInstance()];
  }
  var ConstraintOperation_entriesInitialized;
  function ConstraintOperation_initEntries() {
    if (ConstraintOperation_entriesInitialized)
      return Unit_instance;
    ConstraintOperation_entriesInitialized = true;
    ConstraintOperation_ADDITION_ASSIGNMENT_instance = new ConstraintOperation('ADDITION_ASSIGNMENT', 0, '+=');
    ConstraintOperation_SUBTRACT_ASSIGNMENT_instance = new ConstraintOperation('SUBTRACT_ASSIGNMENT', 1, '-=');
  }
  function ConstraintOperation(name, ordinal, label) {
    Enum.call(this, name, ordinal);
    this.wln_1 = label;
  }
  protoOf(ConstraintOperation).toString = function () {
    return this.wln_1;
  };
  function HasPropertyConstraints() {
  }
  function ConstraintOperation_ADDITION_ASSIGNMENT_getInstance() {
    ConstraintOperation_initEntries();
    return ConstraintOperation_ADDITION_ASSIGNMENT_instance;
  }
  function ConstraintOperation_SUBTRACT_ASSIGNMENT_getInstance() {
    ConstraintOperation_initEntries();
    return ConstraintOperation_SUBTRACT_ASSIGNMENT_instance;
  }
  function Companion_335() {
    Companion_instance_335 = this;
    var tmp = this;
    // Inline function 'jetbrains.ocelot.langDef.references.repoRefTag' call
    var name = 'ontologyLibrary';
    tmp.dh6_1 = new RefTag(getKClass(BTBNode), getKClass(OntologyLibrary_1), getKClass(QualifiedReferenceContent), name);
  }
  var Companion_instance_335;
  function Companion_getInstance_335() {
    if (Companion_instance_335 == null)
      new Companion_335();
    return Companion_instance_335;
  }
  function OntologyLibraryReference_1() {
  }
  function Companion_336() {
    Companion_instance_336 = this;
    var tmp = this;
    // Inline function 'jetbrains.ocelot.langDef.references.repoRefTag' call
    tmp.fh1_1 = new RefTag(getKClass(OntologyElementReference_1), getKClass(OntologyElement_1), getKClass(QualifiedReferenceContent), 'element');
  }
  var Companion_instance_336;
  function Companion_getInstance_336() {
    if (Companion_instance_336 == null)
      new Companion_336();
    return Companion_instance_336;
  }
  function OntologyElementReference_1() {
  }
  function OntologyLibrary_1() {
  }
  function OntologyElementType_1() {
  }
  function $runSuspendCOROUTINE$_46(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.flo_1 = _this__u8e3s4;
    this.glo_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_46).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 3;
            var $this$suspendingQuery = this.glo_1;
            var tmp0_safe_receiver = this.flo_1.ilo_1.gfq();
            if (tmp0_safe_receiver == null) {
              this.hlo_1 = null;
              this.f9_1 = 2;
              continue $sm;
            } else {
              this.f9_1 = 1;
              suspendResult = $this$suspendingQuery.k60(tmp0_safe_receiver, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            this.hlo_1 = suspendResult;
            this.f9_1 = 2;
            continue $sm;
          case 2:
            return this.hlo_1;
          case 3:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 3) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function OntologyElementReferenceProvider$getClassDeclaration$$inlined$suspendingQuery$1(this$0) {
    this.ilo_1 = this$0;
  }
  protoOf(OntologyElementReferenceProvider$getClassDeclaration$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_46(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(OntologyElementReferenceProvider$getClassDeclaration$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function OntologyElementReferenceProvider() {
  }
  function $runSuspendCOROUTINE$_47(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.rlo_1 = _this__u8e3s4;
    this.slo_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_47).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 7;
            this.vlo_1 = this.slo_1;
            var tmp0_safe_receiver = this.vlo_1.l60(this.rlo_1.ylo_1.pfs());
            var tmp_0;
            if (tmp0_safe_receiver == null) {
              tmp_0 = null;
            } else {
              tmp_0 = listOf(tmp0_safe_receiver);
            }

            var tmp1_elvis_lhs = tmp_0;
            if (tmp1_elvis_lhs == null) {
              this.f9_1 = 1;
              suspendResult = this.vlo_1.k60(getAllNaturalDefinitionElements(ontologyElementHierarchy(), this.rlo_1.ylo_1), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.xlo_1 = tmp1_elvis_lhs;
              this.f9_1 = 2;
              continue $sm;
            }

          case 1:
            var tmp_1 = this;
            var tmp0 = suspendResult;
            var destination = ArrayList_init_$Create$();
            var _iterator__ex2g4s = tmp0.m();
            while (_iterator__ex2g4s.n()) {
              var element = _iterator__ex2g4s.o();
              var tmp0_safe_receiver_0 = this.vlo_1.l60(element.pfs());
              if (tmp0_safe_receiver_0 == null)
                null;
              else {
                destination.j(tmp0_safe_receiver_0);
              }
            }

            tmp_1.xlo_1 = destination;
            this.f9_1 = 2;
            continue $sm;
          case 2:
            var rootTaxonClasses = this.xlo_1;
            this.tlo_1 = ArrayList_init_$Create$();
            this.wlo_1 = rootTaxonClasses.m();
            this.f9_1 = 3;
            continue $sm;
          case 3:
            if (!this.wlo_1.n()) {
              this.f9_1 = 6;
              continue $sm;
            }

            var element_0 = this.wlo_1.o();
            if (isInterface(element_0, UnionClass_1)) {
              this.ulo_1 = element_0;
              this.f9_1 = 5;
              continue $sm;
            } else {
              if (isInterface(element_0, OntologyElementReferenceProvider)) {
                this.f9_1 = 4;
                suspendResult = this.vlo_1.k60(element_0.eib(), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                var tmp_2 = this;
                noWhenBranchMatchedException();
              }
            }

            break;
          case 4:
            this.ulo_1 = suspendResult;
            this.f9_1 = 5;
            continue $sm;
          case 5:
            var tmp0_safe_receiver_1 = this.ulo_1;
            if (tmp0_safe_receiver_1 == null)
              null;
            else {
              this.tlo_1.j(tmp0_safe_receiver_1);
            }

            this.f9_1 = 3;
            continue $sm;
          case 6:
            return this.tlo_1;
          case 7:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 7) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function OntologyElement$allTaxonElements$$inlined$suspendingQuery$1(this$0) {
    this.ylo_1 = this$0;
  }
  protoOf(OntologyElement$allTaxonElements$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_47(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(OntologyElement$allTaxonElements$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function OntologyElement_1() {
  }
  function Companion_337() {
    Companion_instance_337 = this;
    var tmp = this;
    // Inline function 'jetbrains.ocelot.langDef.references.localRefTag' call
    var name = 'localElement';
    tmp.pgo_1 = new RefTag(getKClass(LocalOntologyElementReference_1), getKClass(OntologyElement_1), getKClass(LocalReferenceContent), name);
  }
  var Companion_instance_337;
  function Companion_getInstance_337() {
    if (Companion_instance_337 == null)
      new Companion_337();
    return Companion_instance_337;
  }
  function LocalOntologyElementReference_1() {
  }
  function QualifiedOntologyElementReference$element$$inlined$executeQuery$1(this$0) {
    this.zlo_1 = this$0;
  }
  protoOf(QualifiedOntologyElementReference$element$$inlined$executeQuery$1).n5w = function (builder) {
    var tmp0_safe_receiver = builder.l60(this.zlo_1.ifu());
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.gfq();
  };
  function QualifiedOntologyElementReference_1() {
  }
  function OntologyIsRelation$getElementReference$$inlined$executeQuery$1(this$0) {
    this.alp_1 = this$0;
  }
  protoOf(OntologyIsRelation$getElementReference$$inlined$executeQuery$1).n5w = function (builder) {
    var tmp0_safe_receiver = builder.l60(this.alp_1.zfs());
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.gfq();
  };
  function OntologyIsRelation_1() {
  }
  function OntologyCardinalityRelation_1() {
  }
  function OntologyElementDefinition_1() {
  }
  function OntologyElementSynonym_1() {
  }
  function AbstractOntologyRelation() {
  }
  function XRefContainer() {
  }
  function ProcessType_1() {
  }
  function $runSuspendCOROUTINE$_48(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.jlp_1 = _this__u8e3s4;
    this.klp_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_48).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 6;
            this.nlp_1 = this.klp_1;
            var tmp0 = this.nlp_1.l60(this.jlp_1.qlp_1.rfp());
            this.llp_1 = ArrayList_init_$Create$();
            this.plp_1 = tmp0.m();
            this.f9_1 = 1;
            continue $sm;
          case 1:
            if (!this.plp_1.n()) {
              this.f9_1 = 5;
              continue $sm;
            }

            var element = this.plp_1.o();
            var tmp0_0 = this.nlp_1.l60(element.yft());
            this.mlp_1 = ArrayList_init_$Create$();
            this.olp_1 = tmp0_0.m();
            this.f9_1 = 2;
            continue $sm;
          case 2:
            if (!this.olp_1.n()) {
              this.f9_1 = 4;
              continue $sm;
            }

            var element_0 = this.olp_1.o();
            this.f9_1 = 3;
            suspendResult = this.nlp_1.k60(element_0.q6q().w6o(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            var tmp0_safe_receiver = suspendResult;
            if (tmp0_safe_receiver == null)
              null;
            else {
              this.mlp_1.j(tmp0_safe_receiver);
            }

            this.f9_1 = 2;
            continue $sm;
          case 4:
            var list = this.mlp_1;
            addAll_1(this.llp_1, list);
            this.f9_1 = 1;
            continue $sm;
          case 5:
            var ARGUMENT = this.llp_1;
            return toSet_0(ARGUMENT);
          case 6:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 6) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function $runSuspendCOROUTINE$_49(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.zlp_1 = _this__u8e3s4;
    this.alq_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_49).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 7;
            this.dlq_1 = this.alq_1;
            var tmp0 = this.dlq_1.l60(this.zlp_1.hlq_1.qft());
            this.flq_1 = ArrayList_init_$Create$();
            this.glq_1 = tmp0.m();
            this.f9_1 = 1;
            continue $sm;
          case 1:
            if (!this.glq_1.n()) {
              this.f9_1 = 3;
              continue $sm;
            }

            var element = this.glq_1.o();
            this.f9_1 = 2;
            suspendResult = this.dlq_1.k60(element.vfr(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var tmp0_safe_receiver = suspendResult;
            if (tmp0_safe_receiver == null)
              null;
            else {
              this.flq_1.j(tmp0_safe_receiver);
            }

            this.f9_1 = 1;
            continue $sm;
          case 3:
            var ARGUMENT = this.flq_1;
            this.clq_1 = toSet_0(ARGUMENT);
            var tmp0_0 = this.clq_1;
            this.blq_1 = ArrayList_init_$Create$();
            this.elq_1 = tmp0_0.m();
            this.f9_1 = 4;
            continue $sm;
          case 4:
            if (!this.elq_1.n()) {
              this.f9_1 = 6;
              continue $sm;
            }

            var element_0 = this.elq_1.o();
            this.f9_1 = 5;
            suspendResult = this.dlq_1.k60(allProperties_0(element_0, emptySet(), this.clq_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 5:
            var list = suspendResult;
            addAll_1(this.blq_1, list);
            this.f9_1 = 4;
            continue $sm;
          case 6:
            var ARGUMENT_0 = this.blq_1;
            return distinct(ARGUMENT_0);
          case 7:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 7) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function ProcessDeclaration$allInheritedProcesses$o$runSuspend$lambda(this$0, $$this$suspendingQuery) {
    return function (element, _unused_var__etf5q3) {
      logCycle(this$0, $$this$suspendingQuery, element);
      return Unit_instance;
    };
  }
  function $runSuspendCOROUTINE$_50(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.qlq_1 = _this__u8e3s4;
    this.rlq_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_50).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 12;
            this.alr_1 = this.rlq_1;
            var tmp0 = this.qlq_1.flr_1;
            var cycleHandler = ProcessDeclaration$allInheritedProcesses$o$runSuspend$lambda(this.qlq_1.flr_1, this.alr_1);
            var tmp_0 = this;
            tmp_0.elr_1 = tmp0;
            var tmp_1 = this;
            tmp_1.dlr_1 = asTraverse(cycleHandler);
            this.f9_1 = 1;
            continue $sm;
          case 1:
            var this_0 = this.elr_1;
            this.clr_1 = this.dlr_1;
            this.vlq_1 = new PreProcessNodeFrame(this_0, null);
            this.tlq_1 = HashSet_init_$Create$();
            this.f9_1 = 2;
            continue $sm;
          case 2:
            if (!!(this.vlq_1 == null)) {
              this.f9_1 = 10;
              continue $sm;
            }

            this.ulq_1 = new TraversalContext(this.vlq_1);
            var tmp0_subject = this.vlq_1;
            if (tmp0_subject instanceof PreProcessNodeFrame) {
              if (this.tlq_1.t(this.ulq_1.w85())) {
                var tmp_2 = this;
                if (!isNoop(this.clr_1) && this.ulq_1.mlr(this.ulq_1.w85())) {
                  this.clr_1(this.ulq_1);
                }
                tmp_2.xlq_1 = this.vlq_1.hlr_1;
                this.f9_1 = 7;
                continue $sm;
              } else {
                this.ulq_1;
                var tmp0_0 = this.tlq_1;
                var element = this.ulq_1.w85();
                tmp0_0.j(element);
                var processDeclaration = this.ulq_1.w85();
                var tmp0_1 = this.alr_1.l60(processDeclaration.qft());
                this.zlq_1 = ArrayList_init_$Create$();
                this.blr_1 = tmp0_1.m();
                this.f9_1 = 3;
                continue $sm;
              }
            } else {
              if (tmp0_subject instanceof PostProcessChildNodeFrame) {
                this.wlq_1 = createNextChildProcessingFrame(this.vlq_1);
                this.f9_1 = 8;
                continue $sm;
              } else {
                if (tmp0_subject instanceof PostProcessNodeFrame) {
                  var tmp_3 = this;
                  this.ulq_1;
                  tmp_3.wlq_1 = this.vlq_1.hlr_1;
                  this.f9_1 = 8;
                  continue $sm;
                } else {
                  var tmp_4 = this;
                  noWhenBranchMatchedException();
                }
              }
            }

            break;
          case 3:
            if (!this.blr_1.n()) {
              this.f9_1 = 5;
              continue $sm;
            }

            var element_0 = this.blr_1.o();
            this.f9_1 = 4;
            suspendResult = this.alr_1.k60(element_0.vfr(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            var tmp0_safe_receiver = suspendResult;
            if (tmp0_safe_receiver == null)
              null;
            else {
              this.zlq_1.j(tmp0_safe_receiver);
            }

            this.f9_1 = 3;
            continue $sm;
          case 5:
            var tmp_5 = this;
            var this_1 = this.zlq_1;
            var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_1, 10));
            var _iterator__ex2g4s = this_1.m();
            while (_iterator__ex2g4s.n()) {
              var item = _iterator__ex2g4s.o();
              destination.j(new Pair(item, Unit_instance));
            }

            tmp_5.ylq_1 = destination;
            this.f9_1 = 6;
            continue $sm;
          case 6:
            var edges = this.ylq_1;
            this.xlq_1 = createChildProcessingFrame(this.vlq_1, edges.m());
            this.f9_1 = 7;
            continue $sm;
          case 7:
            this.wlq_1 = this.xlq_1;
            this.f9_1 = 8;
            continue $sm;
          case 8:
            this.vlq_1 = this.wlq_1;
            if (this.ulq_1.nlr()) {
              this.slq_1 = null;
              this.f9_1 = 11;
              continue $sm;
            } else {
              this.f9_1 = 9;
              continue $sm;
            }

          case 9:
            this.f9_1 = 2;
            continue $sm;
          case 10:
            this.slq_1 = this.tlq_1;
            if (false) {
              this.f9_1 = 1;
              continue $sm;
            }

            this.f9_1 = 11;
            continue $sm;
          case 11:
            var ARGUMENT = this.slq_1;
            return ensureNotNull(ARGUMENT);
          case 12:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 12) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function $runSuspendCOROUTINE$_51(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.wlr_1 = _this__u8e3s4;
    this.xlr_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_51).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 8;
            var tmp_0 = this;
            tmp_0.cls_1 = this.xlr_1;
            this.ylr_1 = Unit_instance;
            this.f9_1 = 1;
            continue $sm;
          case 1:
            this.als_1 = this.cls_1;
            this.f9_1 = 2;
            suspendResult = this.als_1.k60(this.wlr_1.dls_1.pft(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var tmp0_elvis_lhs = suspendResult;
            if (tmp0_elvis_lhs == null) {
              this.ylr_1 = emptyList();
              this.f9_1 = 7;
              var tmp_1 = this;
              continue $sm;
            } else {
              this.bls_1 = tmp0_elvis_lhs;
              this.f9_1 = 3;
              continue $sm;
            }

          case 3:
            this.zlr_1 = this.bls_1;
            if (this.zlr_1 === this.wlr_1.els_1) {
              var tmp_2 = this;
              var this_0 = this.wlr_1.fls_1;
              var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
              var _iterator__ex2g4s = this_0.m();
              while (_iterator__ex2g4s.n()) {
                var item = _iterator__ex2g4s.o();
                destination.j(this.als_1.l60(item.y2()));
              }
              tmp_2.ylr_1 = destination;
              this.f9_1 = 7;
              continue $sm;
            } else {
              this.f9_1 = 4;
              continue $sm;
            }

          case 4:
            if (this.wlr_1.fls_1.t(this.zlr_1)) {
              this.ylr_1 = emptyList();
              this.f9_1 = 7;
              continue $sm;
            } else {
              this.f9_1 = 5;
              continue $sm;
            }

          case 5:
            this.wlr_1.fls_1.j(this.zlr_1);
            this.f9_1 = 6;
            suspendResult = this.als_1.k60(cycleInExtends_0(this.zlr_1, this.wlr_1.els_1, this.wlr_1.fls_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 6:
            this.ylr_1 = suspendResult;
            if (false) {
              this.f9_1 = 1;
              continue $sm;
            }

            this.f9_1 = 7;
            continue $sm;
          case 7:
            return this.ylr_1;
          case 8:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 8) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function $runSuspendCOROUTINE$_52(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.ols_1 = _this__u8e3s4;
    this.pls_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_52).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 7;
            this.sls_1 = this.pls_1;
            this.qls_1 = ArrayList_init_$Create$();
            this.qls_1.q(this.sls_1.l60(this.ols_1.uls_1.y()));
            this.f9_1 = 1;
            suspendResult = this.sls_1.k60(this.ols_1.uls_1.pft(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var extended = suspendResult;
            if (!(extended == null) && !this.ols_1.vls_1.t(extended)) {
              this.ols_1.vls_1.j(extended);
              this.f9_1 = 2;
              suspendResult = this.sls_1.k60(allEntries_0(extended, this.ols_1.vls_1), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.f9_1 = 6;
              continue $sm;
            }

          case 2:
            var ARGUMENT = suspendResult;
            this.qls_1.q(ARGUMENT);
            var tmp0 = this.sls_1.l60(this.ols_1.uls_1.y());
            var destination = ArrayList_init_$Create$();
            var _iterator__ex2g4s = tmp0.m();
            while (_iterator__ex2g4s.n()) {
              var element = _iterator__ex2g4s.o();
              if (!(element == null) ? isInterface(element, AbstractLink) : false) {
                destination.j(element);
              }
            }

            this.rls_1 = ArrayList_init_$Create$();
            this.tls_1 = destination.m();
            this.f9_1 = 3;
            continue $sm;
          case 3:
            if (!this.tls_1.n()) {
              this.f9_1 = 5;
              continue $sm;
            }

            var element_0 = this.tls_1.o();
            this.f9_1 = 4;
            suspendResult = this.sls_1.k60(element_0.ufp(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            var tmp0_safe_receiver = suspendResult;
            if (tmp0_safe_receiver == null)
              null;
            else {
              this.rls_1.j(tmp0_safe_receiver);
            }

            this.f9_1 = 3;
            continue $sm;
          case 5:
            var ARGUMENT_0 = this.rls_1;
            this.qls_1.j1(ARGUMENT_0);
            this.f9_1 = 6;
            continue $sm;
          case 6:
            return this.qls_1;
          case 7:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 7) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function $runSuspendCOROUTINE$_53(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.elt_1 = _this__u8e3s4;
    this.flt_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_53).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 8;
            this.jlt_1 = this.flt_1;
            this.glt_1 = ArrayList_init_$Create$();
            this.glt_1.q(subtract(this.jlt_1.l60(this.elt_1.nlt_1.rfp()), this.elt_1.olt_1));
            this.f9_1 = 1;
            suspendResult = this.jlt_1.k60(this.elt_1.nlt_1.qil(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.ilt_1 = suspendResult;
            var tmp0 = this.jlt_1.l60(this.elt_1.nlt_1.qft());
            this.llt_1 = ArrayList_init_$Create$();
            this.mlt_1 = tmp0.m();
            this.f9_1 = 2;
            continue $sm;
          case 2:
            if (!this.mlt_1.n()) {
              this.f9_1 = 4;
              continue $sm;
            }

            var element = this.mlt_1.o();
            this.f9_1 = 3;
            suspendResult = this.jlt_1.k60(element.vfr().w6o(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            var tmp0_safe_receiver = suspendResult;
            if (tmp0_safe_receiver == null)
              null;
            else {
              this.llt_1.j(tmp0_safe_receiver);
            }

            this.f9_1 = 2;
            continue $sm;
          case 4:
            var inherited = this.llt_1;
            var newInherited = subtract(inherited, this.elt_1.plt_1);
            this.hlt_1 = plus_10(this.elt_1.plt_1, newInherited);
            this.klt_1 = newInherited.m();
            this.f9_1 = 5;
            continue $sm;
          case 5:
            if (!this.klt_1.n()) {
              this.f9_1 = 7;
              continue $sm;
            }

            var element_0 = this.klt_1.o();
            this.f9_1 = 6;
            suspendResult = this.jlt_1.k60(allProperties_0(element_0, plus_10(this.elt_1.olt_1, this.ilt_1), this.hlt_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 6:
            var ARGUMENT = suspendResult;
            this.glt_1.q(ARGUMENT);
            this.f9_1 = 5;
            continue $sm;
          case 7:
            return this.glt_1;
          case 8:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 8) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function logCycle($this, _this__u8e3s4, processDeclaration) {
    // Inline function 'jetbrains.ocelot.langDef.structure.ancestorOrSelf' call
    var tmp$ret$0 = ancestorOrSelf(processDeclaration, getKClass(ProcessLibrary_1));
    var library = _this__u8e3s4.l60(tmp$ret$0);
    var prefix = !(library == null) ? 'Library: ' + _this__u8e3s4.l60(library.y2()) + ', ' : '';
    Companion_getInstance_338().jhc_1.vde('There is a cycle in ProcessDeclaration library. ' + prefix + ' ProcessDeclaration: ' + toString_1(processDeclaration.y2()));
  }
  function cycleInExtends_0($this, origin, ps) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new ProcessDeclaration$cycleInExtends$$inlined$suspendingQuery$1($this, origin, ps);
  }
  function allEntries_0($this, ps) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new ProcessDeclaration$allEntries$$inlined$suspendingQuery$1($this, ps);
  }
  function allProperties_0($this, visitedAliasedProperties, visitedProcesses) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new ProcessDeclaration$allProperties$$inlined$suspendingQuery$1($this, visitedAliasedProperties, visitedProcesses);
  }
  function Companion_338() {
    Companion_instance_338 = this;
    var tmp = this;
    // Inline function 'jetbrains.ocelot.langDef.references.repoRefTag' call
    tmp.hhc_1 = new RefTag(getKClass(BTBNode), getKClass(ProcessKind_1), getKClass(QualifiedReferenceContent), 'kind');
    var tmp_0 = this;
    // Inline function 'jetbrains.ocelot.langDef.references.repoRefTag' call
    tmp_0.ihc_1 = new RefTag(getKClass(BTBNode), getKClass(ProcessDeclaration_1), getKClass(QualifiedReferenceContent), 'process');
    this.jhc_1 = getLogger_0(getKClass(ProcessDeclaration_1));
  }
  var Companion_instance_338;
  function Companion_getInstance_338() {
    if (Companion_instance_338 == null)
      new Companion_338();
    return Companion_instance_338;
  }
  function ProcessDeclaration$aliasedProperties$$inlined$suspendingQuery$1(this$0) {
    this.qlp_1 = this$0;
  }
  protoOf(ProcessDeclaration$aliasedProperties$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_48(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(ProcessDeclaration$aliasedProperties$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function ProcessDeclaration$allSuperProperties$$inlined$suspendingQuery$1(this$0) {
    this.hlq_1 = this$0;
  }
  protoOf(ProcessDeclaration$allSuperProperties$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_49(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(ProcessDeclaration$allSuperProperties$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function ProcessDeclaration$allInheritedProcesses$$inlined$suspendingQuery$1(this$0) {
    this.flr_1 = this$0;
  }
  protoOf(ProcessDeclaration$allInheritedProcesses$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_50(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(ProcessDeclaration$allInheritedProcesses$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function ProcessDeclaration$cycleInExtends$$inlined$suspendingQuery$1(this$0, $origin, $ps) {
    this.dls_1 = this$0;
    this.els_1 = $origin;
    this.fls_1 = $ps;
  }
  protoOf(ProcessDeclaration$cycleInExtends$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_51(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(ProcessDeclaration$cycleInExtends$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function ProcessDeclaration$allEntries$$inlined$suspendingQuery$1(this$0, $ps) {
    this.uls_1 = this$0;
    this.vls_1 = $ps;
  }
  protoOf(ProcessDeclaration$allEntries$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_52(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(ProcessDeclaration$allEntries$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function ProcessDeclaration$allProperties$$inlined$suspendingQuery$1(this$0, $visitedAliasedProperties, $visitedProcesses) {
    this.nlt_1 = this$0;
    this.olt_1 = $visitedAliasedProperties;
    this.plt_1 = $visitedProcesses;
  }
  protoOf(ProcessDeclaration$allProperties$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_53(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(ProcessDeclaration$allProperties$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function ProcessDeclaration_1() {
  }
  function ProcessLibrary_1() {
  }
  function ProcessKind_1() {
  }
  function Companion_339() {
    Companion_instance_339 = this;
    var tmp = this;
    // Inline function 'jetbrains.ocelot.langDef.references.repoRefTag' call
    var name = 'processReference';
    tmp.jhh_1 = new RefTag(getKClass(ProcessReference_1), getKClass(ProcessDeclaration_1), getKClass(QualifiedReferenceContent), name);
  }
  var Companion_instance_339;
  function Companion_getInstance_339() {
    if (Companion_instance_339 == null)
      new Companion_339();
    return Companion_instance_339;
  }
  function ProcessReference_1() {
  }
  function ProcessPrerequisite_0() {
  }
  function ProcessEffect_0() {
  }
  function ProcessKindContainer_1() {
  }
  function Companion_340() {
    Companion_instance_340 = this;
    var tmp = this;
    // Inline function 'jetbrains.ocelot.langDef.references.repoRefTag' call
    var name = 'propertyReference';
    tmp.hhg_1 = new RefTag(getKClass(ProcessPropertyReference), getKClass(ProcessProperty_1), getKClass(QualifiedReferenceContent), name);
  }
  var Companion_instance_340;
  function Companion_getInstance_340() {
    if (Companion_instance_340 == null)
      new Companion_340();
    return Companion_instance_340;
  }
  function ProcessPropertyReference() {
  }
  function ProcessProperty_1() {
  }
  function Companion_341() {
    Companion_instance_341 = this;
    var tmp = this;
    // Inline function 'jetbrains.ocelot.langDef.references.repoRefTag' call
    var name = 'notionReference';
    tmp.qhs_1 = new RefTag(getKClass(SimplePropertyType), getKClass(AbstractNotion), getKClass(QualifiedReferenceContent), name);
  }
  var Companion_instance_341;
  function Companion_getInstance_341() {
    if (Companion_instance_341 == null)
      new Companion_341();
    return Companion_instance_341;
  }
  function SimplePropertyType() {
  }
  function ProcessPropertyType$type$$inlined$query$1(this$0) {
    this.qlt_1 = this$0;
  }
  protoOf(ProcessPropertyType$type$$inlined$query$1).n5w = function (builder) {
    return this.qlt_1;
  };
  function ProcessPropertyType() {
  }
  function ProcessPropertyValueRange() {
  }
  function PrimitivePropertyType_1() {
  }
  function InheritedProcessProperty() {
  }
  function MultipleProcessPropertyValueRange_1() {
  }
  function ProcessPropertyDefault_1() {
  }
  function OntologyElementPropertyType_1() {
  }
  function Companion_342() {
    Companion_instance_342 = this;
    this.ihm_1 = Companion_getInstance_343().rlt_1;
  }
  var Companion_instance_342;
  function Companion_getInstance_342() {
    if (Companion_instance_342 == null)
      new Companion_342();
    return Companion_instance_342;
  }
  function PropertyValue_1() {
  }
  function Companion_343() {
    Companion_instance_343 = this;
    var tmp = this;
    // Inline function 'jetbrains.ocelot.langDef.references.repoRefTag' call
    var name = 'abstractProperty';
    tmp.rlt_1 = new RefTag(getKClass(BTBNode), getKClass(AbstractProperty), getKClass(QualifiedReferenceContent), name);
  }
  var Companion_instance_343;
  function Companion_getInstance_343() {
    if (Companion_instance_343 == null)
      new Companion_343();
    return Companion_instance_343;
  }
  function AbstractProperty() {
  }
  function BindingProperty$name$$inlined$query$1(this$0) {
    this.slt_1 = this$0;
  }
  protoOf(BindingProperty$name$$inlined$query$1).n5w = function (builder) {
    var tmp0_safe_receiver = builder.l60(this.slt_1.q6q());
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.y2();
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : builder.l60(tmp1_safe_receiver);
    return tmp2_elvis_lhs == null ? '' : tmp2_elvis_lhs;
  };
  function BindingProperty$type$$inlined$suspendingQuery$1(this$0) {
    this.tlt_1 = this$0;
  }
  protoOf(BindingProperty$type$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp0_safe_receiver = builder.l60(this.tlt_1.q6q());
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.sfq();
    return tmp1_safe_receiver == null ? null : builder.l60(tmp1_safe_receiver);
  };
  protoOf(BindingProperty$type$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function BindingProperty_1() {
  }
  function PropertyDeclaration_1() {
  }
  function $runSuspendCOROUTINE$_54(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.clu_1 = _this__u8e3s4;
    this.dlu_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_54).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.elu_1 = this.dlu_1;
            this.f9_1 = 1;
            suspendResult = this.elu_1.k60(this.clu_1.flu_1.sfr(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp0_safe_receiver = suspendResult;
            var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.y2();
            var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : this.elu_1.l60(tmp1_safe_receiver);
            return tmp2_elvis_lhs == null ? '' : tmp2_elvis_lhs;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function $runSuspendCOROUTINE$_55(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.olu_1 = _this__u8e3s4;
    this.plu_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_55).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.qlu_1 = this.plu_1;
            this.f9_1 = 1;
            suspendResult = this.qlu_1.k60(this.olu_1.rlu_1.sfr(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp0_safe_receiver = suspendResult;
            var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.sfq();
            return tmp1_safe_receiver == null ? null : this.qlu_1.l60(tmp1_safe_receiver);
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function Companion_344() {
    Companion_instance_344 = this;
    var tmp = this;
    // Inline function 'jetbrains.ocelot.langDef.references.repoRefTag' call
    var name = 'importedPropertyReference';
    tmp.ngi_1 = new RefTag(getKClass(ImportedProperty_1), getKClass(PropertyDeclaration_1), getKClass(QualifiedReferenceContent), name);
  }
  var Companion_instance_344;
  function Companion_getInstance_344() {
    if (Companion_instance_344 == null)
      new Companion_344();
    return Companion_instance_344;
  }
  function ImportedProperty$name$$inlined$suspendingQuery$1(this$0) {
    this.flu_1 = this$0;
  }
  protoOf(ImportedProperty$name$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_54(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(ImportedProperty$name$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function ImportedProperty$type$$inlined$suspendingQuery$1(this$0) {
    this.rlu_1 = this$0;
  }
  protoOf(ImportedProperty$type$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_55(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(ImportedProperty$type$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function ImportedProperty_1() {
  }
  function PropertyLibrary$properties$$inlined$map$1($this) {
    this.slu_1 = $this;
  }
  protoOf(PropertyLibrary$properties$$inlined$map$1).n5w = function (builder) {
    // Inline function 'kotlin.collections.filterIsInstance' call
    var tmp0 = builder.l60(this.slu_1);
    // Inline function 'kotlin.collections.filterIsInstanceTo' call
    var destination = ArrayList_init_$Create$();
    var _iterator__ex2g4s = tmp0.m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      if (!(element == null) ? isInterface(element, PropertyDeclaration_1) : false) {
        destination.j(element);
      }
    }
    return destination;
  };
  function PropertyLibrary_1() {
  }
  function PropertyLibraryElement() {
  }
  function EmptyPropertyLibraryElement_1() {
  }
  function authorsPart($this) {
    // Inline function 'jetbrains.ocelot.langDef.query.query' call
    return new PublishedWork$authorsPart$$inlined$query$1($this);
  }
  function PublishedWork$citation$$inlined$query$1(this$0) {
    this.tlu_1 = this$0;
  }
  protoOf(PublishedWork$citation$$inlined$query$1).n5w = function (builder) {
    var authorsAndName = builder.l60(authorsPart(this.tlu_1)) + builder.l60(get_forQueries_0(this.tlu_1.wfp().m5y()));
    var tmp;
    if (isBlank(builder.l60(this.tlu_1.gfu()))) {
      tmp = authorsAndName;
    } else {
      var tmp_0;
      // Inline function 'kotlin.text.trimEnd' call
      var tmp$ret$0 = toString_1(trimEnd(isCharSequence(authorsAndName) ? authorsAndName : THROW_CCE()));
      if (endsWith(tmp$ret$0, '.')) {
        tmp_0 = authorsAndName + ' ' + builder.l60(this.tlu_1.gfu());
      } else {
        tmp_0 = authorsAndName + '. ' + builder.l60(this.tlu_1.gfu());
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  function PublishedWork$authorsPart$$inlined$query$1(this$0) {
    this.ulu_1 = this$0;
  }
  protoOf(PublishedWork$authorsPart$$inlined$query$1).n5w = function (builder) {
    // Inline function 'kotlin.collections.map' call
    var this_0 = builder.l60(this.ulu_1.vfp());
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.m();
    while (_iterator__ex2g4s.n()) {
      var item = _iterator__ex2g4s.o();
      var tmp$ret$0 = item.y2().m5y().w2w();
      destination.j(tmp$ret$0);
    }
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination_0 = ArrayList_init_$Create$();
    var _iterator__ex2g4s_0 = destination.m();
    while (_iterator__ex2g4s_0.n()) {
      var element = _iterator__ex2g4s_0.o();
      // Inline function 'kotlin.text.isNotBlank' call
      if (!isBlank(element)) {
        destination_0.j(element);
      }
    }
    var list = destination_0;
    var shortList = list.p() <= 2 ? list : plus_6(take(list, 2), 'et al.');
    // Inline function 'kotlin.text.trimEnd' call
    var this_1 = joinToString_0(shortList, ', ');
    var authorsString = toString_1(trimEnd(isCharSequence(this_1) ? this_1 : THROW_CCE()));
    var tmp;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(authorsString) === 0) {
      tmp = '';
    } else {
      if (endsWith(authorsString, '.')) {
        tmp = authorsString + ' ';
      } else {
        tmp = authorsString + '. ';
      }
    }
    return tmp;
  };
  function PublishedWork() {
  }
  function Paper_1() {
  }
  function LibraryItem() {
  }
  function Author_1() {
  }
  function Book_1() {
  }
  function OldPublishedSource() {
  }
  function AuthoredWork() {
  }
  function QueryCommands_1() {
  }
  function Command_0() {
  }
  function FindNewConnectionCommand_1() {
  }
  function FindConnectionCommand_1() {
  }
  function Companion_345() {
    Companion_instance_345 = this;
    this.igm_1 = Companion_getInstance_338().hhc_1;
    this.jgm_1 = Companion_getInstance_338().ihc_1;
  }
  var Companion_instance_345;
  function Companion_getInstance_345() {
    if (Companion_instance_345 == null)
      new Companion_345();
    return Companion_instance_345;
  }
  function LibraryProcessSpecificationQuery_1() {
  }
  function ContextQuery_1() {
  }
  function Pattern() {
  }
  function Companion_346() {
    Companion_instance_346 = this;
    var tmp = this;
    // Inline function 'jetbrains.ocelot.langDef.references.localRefTag' call
    var name = 'variable';
    tmp.zhw_1 = new RefTag(getKClass(BTBNode), getKClass(VariableDeclaration_1), getKClass(LocalReferenceContent), name);
  }
  var Companion_instance_346;
  function Companion_getInstance_346() {
    if (Companion_instance_346 == null)
      new Companion_346();
    return Companion_instance_346;
  }
  function VariablePattern_1() {
  }
  function BindingValuePlaceholderQuery_1() {
  }
  function AbstractBindingValueQuery() {
  }
  function OrValueQuery_1() {
  }
  function BindingValueMask_1() {
  }
  function Companion_347() {
    Companion_instance_347 = this;
    var tmp = this;
    // Inline function 'jetbrains.ocelot.langDef.references.repoRefTag' call
    var name = 'linkDeclaration';
    tmp.eh7_1 = new RefTag(getKClass(BTBNode), getKClass(LinkDeclaration_1), getKClass(QualifiedReferenceContent), name);
  }
  var Companion_instance_347;
  function Companion_getInstance_347() {
    if (Companion_instance_347 == null)
      new Companion_347();
    return Companion_instance_347;
  }
  function OntologyLinkDeclarationValueQuery_1() {
  }
  function Companion_348() {
    Companion_instance_348 = this;
    var tmp = this;
    // Inline function 'jetbrains.ocelot.langDef.references.repoRefTag' call
    var name = 'propertyDeclaration';
    tmp.uhk_1 = new RefTag(getKClass(BTBNode), getKClass(PropertyDeclaration_1), getKClass(QualifiedReferenceContent), name);
  }
  var Companion_instance_348;
  function Companion_getInstance_348() {
    if (Companion_instance_348 == null)
      new Companion_348();
    return Companion_instance_348;
  }
  function PropertyDeclarationValueQuery_1() {
  }
  function Companion_349() {
    Companion_instance_349 = this;
    var tmp = this;
    // Inline function 'jetbrains.ocelot.langDef.references.repoRefTag' call
    tmp.whp_1 = new RefTag(getKClass(QueryParametersBlackList), getKClass(OntologyLibrary_1), getKClass(QualifiedReferenceContent), 'library');
  }
  var Companion_instance_349;
  function Companion_getInstance_349() {
    if (Companion_instance_349 == null)
      new Companion_349();
    return Companion_instance_349;
  }
  function QueryParametersBlackList() {
  }
  function DeclarationValueQuery() {
  }
  function InstanceRelationValuePlaceholder() {
  }
  function Companion_350() {
    Companion_instance_350 = this;
    var tmp = this;
    // Inline function 'jetbrains.ocelot.langDef.references.repoRefTag' call
    var name = 'instanceRelationInValue';
    tmp.sgk_1 = new RefTag(getKClass(InstanceRelationValue), getKClass(InstanceRelationDeclaration), getKClass(QualifiedReferenceContent), name);
  }
  var Companion_instance_350;
  function Companion_getInstance_350() {
    if (Companion_instance_350 == null)
      new Companion_350();
    return Companion_instance_350;
  }
  function InstanceRelationValue() {
  }
  function InstanceRelationDeclaration() {
  }
  function ProcessRelationDeclaration$isValid$$inlined$query$1(this$0) {
    this.vlu_1 = this$0;
  }
  protoOf(ProcessRelationDeclaration$isValid$$inlined$query$1).n5w = function (builder) {
    return !(builder.l60(this.vlu_1.afu()) == null) && !(builder.l60(this.vlu_1.bfu()) == null);
  };
  function ProcessRelationDeclaration_1() {
  }
  function RelationContainer_1() {
  }
  var RelationDirection_UNIDIRECTIONAL_instance;
  var RelationDirection_BIDIRECTIONAL_instance;
  function values_16() {
    return [RelationDirection_UNIDIRECTIONAL_getInstance(), RelationDirection_BIDIRECTIONAL_getInstance()];
  }
  var RelationDirection_entriesInitialized;
  function RelationDirection_initEntries() {
    if (RelationDirection_entriesInitialized)
      return Unit_instance;
    RelationDirection_entriesInitialized = true;
    RelationDirection_UNIDIRECTIONAL_instance = new RelationDirection('UNIDIRECTIONAL', 0, 'Unidirectional');
    RelationDirection_BIDIRECTIONAL_instance = new RelationDirection('BIDIRECTIONAL', 1, 'Bidirectional');
  }
  function RelationDirection(name, ordinal, displayName) {
    Enum.call(this, name, ordinal);
    this.ylu_1 = displayName;
  }
  protoOf(RelationDirection).toString = function () {
    return this.ylu_1;
  };
  var RelationEffect_POSITIVE_instance;
  var RelationEffect_NEGATIVE_instance;
  var RelationEffect_UNKNOWN_instance;
  var RelationEffect_NO_EFFECT_instance;
  function values_17() {
    return [RelationEffect_POSITIVE_getInstance(), RelationEffect_NEGATIVE_getInstance(), RelationEffect_UNKNOWN_getInstance(), RelationEffect_NO_EFFECT_getInstance()];
  }
  var RelationEffect_entriesInitialized;
  function RelationEffect_initEntries() {
    if (RelationEffect_entriesInitialized)
      return Unit_instance;
    RelationEffect_entriesInitialized = true;
    RelationEffect_POSITIVE_instance = new RelationEffect('POSITIVE', 0, 'Positive');
    RelationEffect_NEGATIVE_instance = new RelationEffect('NEGATIVE', 1, 'Negative');
    RelationEffect_UNKNOWN_instance = new RelationEffect('UNKNOWN', 2, 'Unknown');
    RelationEffect_NO_EFFECT_instance = new RelationEffect('NO_EFFECT', 3, 'No Effect');
  }
  function RelationEffect(name, ordinal, displayName) {
    Enum.call(this, name, ordinal);
    this.blv_1 = displayName;
  }
  protoOf(RelationEffect).toString = function () {
    return this.blv_1;
  };
  function RelationDirection_UNIDIRECTIONAL_getInstance() {
    RelationDirection_initEntries();
    return RelationDirection_UNIDIRECTIONAL_instance;
  }
  function RelationDirection_BIDIRECTIONAL_getInstance() {
    RelationDirection_initEntries();
    return RelationDirection_BIDIRECTIONAL_instance;
  }
  function RelationEffect_POSITIVE_getInstance() {
    RelationEffect_initEntries();
    return RelationEffect_POSITIVE_instance;
  }
  function RelationEffect_NEGATIVE_getInstance() {
    RelationEffect_initEntries();
    return RelationEffect_NEGATIVE_instance;
  }
  function RelationEffect_UNKNOWN_getInstance() {
    RelationEffect_initEntries();
    return RelationEffect_UNKNOWN_instance;
  }
  function RelationEffect_NO_EFFECT_getInstance() {
    RelationEffect_initEntries();
    return RelationEffect_NO_EFFECT_instance;
  }
  function Type() {
  }
  function Companion_351() {
    Companion_instance_351 = this;
    var tmp = this;
    // Inline function 'jetbrains.ocelot.langDef.references.repoRefTag' call
    tmp.zgu_1 = new RefTag(getKClass(BTBNode), getKClass(AbstractNotion), getKClass(QualifiedReferenceContent), 'notion');
  }
  var Companion_instance_351;
  function Companion_getInstance_351() {
    if (Companion_instance_351 == null)
      new Companion_351();
    return Companion_instance_351;
  }
  function NotionType_0() {
  }
  function PrimitiveNotionType_1() {
  }
  function OneOf_1() {
  }
  function MeasurementUnit_1() {
  }
  function EnumerationConstant_1() {
  }
  function AbstractNotion() {
  }
  var PrimitiveKind_STRING_instance;
  var PrimitiveKind_INTEGER_instance;
  function values_18() {
    return [PrimitiveKind_STRING_getInstance(), PrimitiveKind_INTEGER_getInstance()];
  }
  function get_entries() {
    if ($ENTRIES == null)
      $ENTRIES = enumEntries(values_18());
    return $ENTRIES;
  }
  var PrimitiveKind_entriesInitialized;
  function PrimitiveKind_initEntries() {
    if (PrimitiveKind_entriesInitialized)
      return Unit_instance;
    PrimitiveKind_entriesInitialized = true;
    PrimitiveKind_STRING_instance = new PrimitiveKind_0('STRING', 0, 'string');
    PrimitiveKind_INTEGER_instance = new PrimitiveKind_0('INTEGER', 1, 'integer');
  }
  var $ENTRIES;
  function PrimitiveKind_0(name, ordinal, displayName) {
    Enum.call(this, name, ordinal);
    this.elv_1 = displayName;
  }
  protoOf(PrimitiveKind_0).toString = function () {
    return this.elv_1;
  };
  function MeasurableNotion_1() {
  }
  function NotionLibrary_1() {
  }
  function NotionPlaceholder_1() {
  }
  function EnumerableNotion_1() {
  }
  function PrimitiveKind_STRING_getInstance() {
    PrimitiveKind_initEntries();
    return PrimitiveKind_STRING_instance;
  }
  function PrimitiveKind_INTEGER_getInstance() {
    PrimitiveKind_initEntries();
    return PrimitiveKind_INTEGER_instance;
  }
  function Url_1() {
  }
  function propertyReferenceValue($this, wrapperContext) {
    // Inline function 'kotlin.also' call
    var this_0 = ObjectPropertyReferenceValue(wrapperContext);
    var tmp = this_0.jfs();
    var tmp_0 = $this.f6j();
    tmp.f2x(isInterface(tmp_0, AbstractValue) ? tmp_0 : THROW_CCE());
    this_0.q6q().f2x(PropertyReferenceOperation(wrapperContext));
    return this_0;
  }
  function AbstractValue() {
  }
  function Companion_352() {
    Companion_instance_352 = this;
    var tmp = this;
    // Inline function 'jetbrains.ocelot.langDef.references.localRefTag' call
    var name = 'variable';
    tmp.mhx_1 = new RefTag(getKClass(BTBNode), getKClass(VariableDeclaration_1), getKClass(LocalReferenceContent), name);
  }
  var Companion_instance_352;
  function Companion_getInstance_352() {
    if (Companion_instance_352 == null)
      new Companion_352();
    return Companion_instance_352;
  }
  function VariableReferenceValue_1() {
  }
  function SetExpression_1() {
  }
  function Companion_353() {
    Companion_instance_353 = this;
    var tmp = this;
    // Inline function 'jetbrains.ocelot.langDef.references.repoRefTag' call
    tmp.cgq_1 = new RefTag(getKClass(BTBNode), getKClass(MeasurementUnit_1), getKClass(QualifiedReferenceContent), 'unit');
  }
  var Companion_instance_353;
  function Companion_getInstance_353() {
    if (Companion_instance_353 == null)
      new Companion_353();
    return Companion_instance_353;
  }
  function MeasurableValue_1() {
  }
  function Companion_354() {
    Companion_instance_354 = this;
    var tmp = this;
    // Inline function 'jetbrains.ocelot.langDef.references.repoRefTag' call
    var name = 'constant';
    tmp.tg7_1 = new RefTag(getKClass(BTBNode), getKClass(EnumerationConstant_1), getKClass(QualifiedReferenceContent), name);
  }
  var Companion_instance_354;
  function Companion_getInstance_354() {
    if (Companion_instance_354 == null)
      new Companion_354();
    return Companion_instance_354;
  }
  function EnumValue_1() {
  }
  function StringValue_1() {
  }
  function IntegerValue_1() {
  }
  function PartValue$transformToVariableReference$$inlined$executeQuery$1(this$0) {
    this.flv_1 = this$0;
  }
  protoOf(PartValue$transformToVariableReference$$inlined$executeQuery$1).n5w = function (builder) {
    var tmp0_safe_receiver = builder.l60(this.flv_1.jfs());
    var tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.f6j();
    var tmp1_safe_receiver = (!(tmp == null) ? isInterface(tmp, VariableReferenceValue_1) : false) ? tmp : null;
    var tmp_0;
    if (tmp1_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.also' call
      this.flv_1.d6j(tmp1_safe_receiver);
      tmp_0 = tmp1_safe_receiver;
    }
    return tmp_0;
  };
  function PartValue() {
  }
  function PartReferenceOperation() {
  }
  function ObjectPropertyReferenceValue$removePropertyReference$$inlined$executeQuery$1(this$0) {
    this.glv_1 = this$0;
  }
  protoOf(ObjectPropertyReferenceValue$removePropertyReference$$inlined$executeQuery$1).n5w = function (builder) {
    var tmp0_safe_receiver = builder.l60(this.glv_1.jfs());
    var tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.f6j();
    var tmp1_safe_receiver = (tmp == null ? true : isInterface(tmp, AbstractValue)) ? tmp : THROW_CCE();
    var tmp_0;
    if (tmp1_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.also' call
      this.glv_1.d6j(tmp1_safe_receiver);
      tmp_0 = tmp1_safe_receiver;
    }
    return tmp_0;
  };
  function ObjectPropertyReferenceValue_1() {
  }
  function ValueWithRelations() {
  }
  function OntologyElementReferenceValueLibrary_1() {
  }
  function OntologyElementReferenceValue_1() {
  }
  function Companion_355() {
    Companion_instance_355 = this;
    var tmp = this;
    // Inline function 'jetbrains.ocelot.langDef.references.repoRefTag' call
    var name = 'objectProperty';
    tmp.thl_1 = new RefTag(getKClass(BTBNode), getKClass(ObjectPropertyDeclaration_1), getKClass(QualifiedReferenceContent), name);
  }
  var Companion_instance_355;
  function Companion_getInstance_355() {
    if (Companion_instance_355 == null)
      new Companion_355();
    return Companion_instance_355;
  }
  function PropertyReferenceOperation_1() {
  }
  function SetValuedPropertyParameter_1() {
  }
  function IsExpression_1() {
  }
  function toMultiplierValue($this, stored) {
    switch (stored) {
      case -1:
        return Unknown_instance;
      case 0:
        return ImplicitOne_instance;
      case 1:
        return new Exact(1);
      default:
        return new Exact(stored);
    }
  }
  function toStoredMultiplier($this, value) {
    var tmp;
    if (equals(value, ImplicitOne_instance)) {
      tmp = 0;
    } else {
      if (equals(value, Unknown_instance)) {
        tmp = -1;
      } else {
        if (value instanceof Exact) {
          // Inline function 'kotlin.require' call
          if (!(value.hlv_1 > 0)) {
            var message = 'Multiplier must be a positive integer';
            throw IllegalArgumentException_init_$Create$_0(toString_1(message));
          }
          tmp = value.hlv_1;
        } else {
          noWhenBranchMatchedException();
        }
      }
    }
    return tmp;
  }
  function Companion_356() {
    this.ilv_1 = -1;
    this.jlv_1 = 0;
  }
  var Companion_instance_356;
  function Companion_getInstance_356() {
    return Companion_instance_356;
  }
  function MultipliedExpression$Companion$toMultiplierValue$ref(p0) {
    var l = function (_this__u8e3s4) {
      var tmp0 = p0;
      return toMultiplierValue(tmp0, _this__u8e3s4);
    };
    l.callableName = 'toMultiplierValue';
    return l;
  }
  function MultipliedExpression$Companion$toStoredMultiplier$ref(p0) {
    var l = function (_this__u8e3s4) {
      var tmp0 = p0;
      return toStoredMultiplier(tmp0, _this__u8e3s4);
    };
    l.callableName = 'toStoredMultiplier';
    return l;
  }
  function MultipliedExpression_1() {
  }
  function HasQueryLabels() {
  }
  function ImplicitOne() {
  }
  protoOf(ImplicitOne).toString = function () {
    return 'ImplicitOne';
  };
  protoOf(ImplicitOne).hashCode = function () {
    return -1633624251;
  };
  protoOf(ImplicitOne).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ImplicitOne))
      return false;
    return true;
  };
  var ImplicitOne_instance;
  function ImplicitOne_getInstance() {
    return ImplicitOne_instance;
  }
  function Unknown() {
  }
  protoOf(Unknown).toString = function () {
    return 'Unknown';
  };
  protoOf(Unknown).hashCode = function () {
    return 609749838;
  };
  protoOf(Unknown).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Unknown))
      return false;
    return true;
  };
  var Unknown_instance;
  function Unknown_getInstance() {
    return Unknown_instance;
  }
  function Exact(value) {
    this.hlv_1 = value;
  }
  protoOf(Exact).toString = function () {
    return 'Exact(value=' + this.hlv_1 + ')';
  };
  protoOf(Exact).hashCode = function () {
    return this.hlv_1;
  };
  protoOf(Exact).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Exact))
      return false;
    if (!(this.hlv_1 === other.hlv_1))
      return false;
    return true;
  };
  function Companion_357() {
    this.llv_1 = 'N';
  }
  protoOf(Companion_357).mlv = function (text) {
    var tmp;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(text) === 0) {
      tmp = ImplicitOne_instance;
    } else {
      if (equals_0(text, 'N', true)) {
        tmp = Unknown_instance;
      } else {
        var tmp0_safe_receiver = toIntOrNull(text);
        var tmp_0;
        if (tmp0_safe_receiver == null) {
          tmp_0 = null;
        } else {
          // Inline function 'kotlin.takeIf' call
          var tmp_1;
          if (tmp0_safe_receiver > 0) {
            tmp_1 = tmp0_safe_receiver;
          } else {
            tmp_1 = null;
          }
          tmp_0 = tmp_1;
        }
        var tmp1_safe_receiver = tmp_0;
        var tmp_2;
        if (tmp1_safe_receiver == null) {
          tmp_2 = null;
        } else {
          // Inline function 'kotlin.let' call
          tmp_2 = new Exact(tmp1_safe_receiver);
        }
        tmp = tmp_2;
      }
    }
    return tmp;
  };
  protoOf(Companion_357).nlv = function (text) {
    return !(this.mlv(text) == null);
  };
  var Companion_instance_357;
  function Companion_getInstance_357() {
    return Companion_instance_357;
  }
  function MultiplierValue() {
  }
  function VariableSpecification() {
  }
  function VariableDeclaration_1() {
  }
  function VariableInitializer() {
  }
  var serialization_0;
  function get_serializationWithName() {
    _init_properties_BTBConfiguration_kt__auaap2();
    return serializationWithName;
  }
  var serializationWithName;
  function get_nodeStorage() {
    _init_properties_BTBConfiguration_kt__auaap2();
    return nodeStorage;
  }
  var nodeStorage;
  function get_wrapperContext(_this__u8e3s4) {
    _init_properties_BTBConfiguration_kt__auaap2();
    return _this__u8e3s4.zde_1.l6z();
  }
  function createFrontendDomainModel(coroutineContext, client, entity, entityContext) {
    entityContext = entityContext === VOID ? new EntityContext() : entityContext;
    _init_properties_BTBConfiguration_kt__auaap2();
    var tmp = get_btbLanguageWithRemoteResolve();
    return buildClientBtbDomainModel(tmp, coroutineContext, entityContext, entity, createFrontendDomainModel$lambda(client));
  }
  function get_nodePointerSupport(_this__u8e3s4) {
    _init_properties_BTBConfiguration_kt__auaap2();
    return ensureNotNull(_this__u8e3s4.ddf_1.h3b(Companion_instance_88)).p6g();
  }
  function buildClientBtbDomainModel(language, coroutineContext, entityContext, entity, configure) {
    _init_properties_BTBConfiguration_kt__auaap2();
    var wrapperContext = WrapperContext_init_$Create$(entityContext);
    var nodePointerSupport = new SingleRootNodePointerSupport(wrapperContext);
    var structureModel = new SingleRootStructureModel(wrapperContext, nodePointerSupport, get_btbEntityNodeLayout(), entity, false);
    var builder = new BTBConfigurationBuilder(coroutineContext, language, structureModel);
    builder.slv(Companion_instance_41.k3b(structureModel.a70_1, [Companion_getInstance_117()]));
    configure(builder);
    return builder.f40();
  }
  function BTBConfigurationBuilder(coroutineContext, language, structureModel) {
    this.olv_1 = coroutineContext;
    this.plv_1 = language;
    this.qlv_1 = structureModel;
    this.rlv_1 = ArrayList_init_$Create$();
  }
  protoOf(BTBConfigurationBuilder).slv = function (service) {
    this.rlv_1.j(service);
  };
  protoOf(BTBConfigurationBuilder).f40 = function () {
    // Inline function 'kotlin.collections.toTypedArray' call
    var this_0 = this.rlv_1;
    var tmp$ret$0 = copyToArray(this_0);
    return new DomainModel(this.plv_1, this.qlv_1, tmp$ret$0.slice(), this.olv_1);
  };
  function createFreshDomainModel(useExperimentalNode) {
    useExperimentalNode = useExperimentalNode === VOID ? false : useExperimentalNode;
    _init_properties_BTBConfiguration_kt__auaap2();
    return createDomainModelWithLocalResolve(VOID, useExperimentalNode);
  }
  function createQueryFrontendDomainModel(coroutineContext, client, entity, entityContext) {
    entityContext = entityContext === VOID ? new EntityContext() : entityContext;
    _init_properties_BTBConfiguration_kt__auaap2();
    var tmp = get_btbLanguageWithRemoteResolve();
    return buildClientBtbDomainModel(tmp, coroutineContext, entityContext, entity, createQueryFrontendDomainModel$lambda(client));
  }
  function createDomainModelWithPrecalculatedResolve(coroutineContext, resolveInfo, entity) {
    coroutineContext = coroutineContext === VOID ? EmptyCoroutineContext_instance : coroutineContext;
    _init_properties_BTBConfiguration_kt__auaap2();
    var tmp = get_btbLanguageWithPrecalculatedResolve();
    var tmp_0 = new EntityContext();
    return buildClientBtbDomainModel(tmp, coroutineContext, tmp_0, entity, createDomainModelWithPrecalculatedResolve$lambda(resolveInfo));
  }
  function createDomainModelWithLocalResolve(coroutineContext, useExperimentalNode) {
    coroutineContext = coroutineContext === VOID ? EmptyCoroutineContext_instance : coroutineContext;
    useExperimentalNode = useExperimentalNode === VOID ? false : useExperimentalNode;
    _init_properties_BTBConfiguration_kt__auaap2();
    var repository = new LocalDocumentRepository(get_libraries());
    var tmp = get_btbLanguageWithLocalResolve();
    return buildLocalBtbDomainModel(tmp, repository, coroutineContext, VOID, useExperimentalNode, VOID, createDomainModelWithLocalResolve$lambda(repository));
  }
  function buildLocalBtbDomainModel(language, documentRepository, coroutineContext, entityContext, useExperimentalNode, nodePointerSupportFactory, configure) {
    coroutineContext = coroutineContext === VOID ? EmptyCoroutineContext_instance : coroutineContext;
    entityContext = entityContext === VOID ? new EntityContext() : entityContext;
    useExperimentalNode = useExperimentalNode === VOID ? false : useExperimentalNode;
    var tmp;
    if (nodePointerSupportFactory === VOID) {
      tmp = LocalNodePointerSupport$_init_$ref_vrx52y();
    } else {
      tmp = nodePointerSupportFactory;
    }
    nodePointerSupportFactory = tmp;
    _init_properties_BTBConfiguration_kt__auaap2();
    var wrapperContext = WrapperContext_init_$Create$(entityContext);
    var nodePointerSupport = nodePointerSupportFactory(wrapperContext, documentRepository);
    var structureModel = new BaseStructureModel(wrapperContext, nodePointerSupport, useExperimentalNode);
    var builder = new BTBConfigurationBuilder(coroutineContext, language, structureModel);
    configure(builder);
    return builder.f40();
  }
  function serialization$lambda_0($this$serialization) {
    _init_properties_BTBConfiguration_kt__auaap2();
    var wrapperContext = ensureNotNull($this$serialization.h3b(WrapperContextService_instance));
    $this$serialization.o6v(serialization$lambda$lambda(wrapperContext, $this$serialization));
    return Unit_instance;
  }
  function serialization$lambda$lambda($wrapperContext, $this_serialization) {
    return function () {
      return new DomainNodePersister($wrapperContext, OtNodeFactoryService_instance.e3b($this_serialization));
    };
  }
  function serializationWithName$lambda($this$serialization) {
    _init_properties_BTBConfiguration_kt__auaap2();
    var wrapperContext = ensureNotNull($this$serialization.h3b(WrapperContextService_instance));
    $this$serialization.o6v(serializationWithName$lambda$lambda(wrapperContext, $this$serialization));
    return Unit_instance;
  }
  function serializationWithName$lambda$lambda($wrapperContext, $this_serialization) {
    return function () {
      return new BTBNodePersister($wrapperContext, OtNodeFactoryService_instance.e3b($this_serialization));
    };
  }
  function createFrontendDomainModel$lambda$lambda($client) {
    return function (services) {
      return LiveDerivedDataService_0(CoroutineScope_0(CoroutineContextService_getInstance().e3b(services)), $client.ulv_1);
    };
  }
  function createFrontendDomainModel$lambda($client) {
    return function ($this$buildClientBtbDomainModel) {
      var tmp = Companion_instance_41;
      var tmp_0 = [Companion_instance_310];
      $this$buildClientBtbDomainModel.slv(tmp.m3b(tmp_0, VOID, createFrontendDomainModel$lambda$lambda($client)));
      $this$buildClientBtbDomainModel.slv(remoteErrorCheck());
      $this$buildClientBtbDomainModel.slv(get_serializationWithName());
      $this$buildClientBtbDomainModel.slv(get_nodeStorage());
      $this$buildClientBtbDomainModel.slv(Companion_instance_41.k3b(new RpcFacadeContainer(), [Companion_getInstance_280()]));
      return Unit_instance;
    };
  }
  function createQueryFrontendDomainModel$lambda$lambda($client) {
    return function (services) {
      return LiveDerivedDataService_0(CoroutineScope_0(CoroutineContextService_getInstance().e3b(services)), $client.ulv_1);
    };
  }
  function createQueryFrontendDomainModel$lambda($client) {
    return function ($this$buildClientBtbDomainModel) {
      $this$buildClientBtbDomainModel.slv(get_btbErrorChecking());
      var tmp = Companion_instance_41;
      var tmp_0 = [Companion_instance_310];
      $this$buildClientBtbDomainModel.slv(tmp.m3b(tmp_0, VOID, createQueryFrontendDomainModel$lambda$lambda($client)));
      $this$buildClientBtbDomainModel.slv(get_serializationWithName());
      $this$buildClientBtbDomainModel.slv(get_nodeStorage());
      $this$buildClientBtbDomainModel.slv(Companion_instance_41.k3b(new RpcFacadeContainer(), [Companion_getInstance_280()]));
      return Unit_instance;
    };
  }
  function createDomainModelWithPrecalculatedResolve$lambda($resolveInfo) {
    return function ($this$buildClientBtbDomainModel) {
      $this$buildClientBtbDomainModel.slv(get_serializationWithName());
      $this$buildClientBtbDomainModel.slv(get_nodeStorage());
      $this$buildClientBtbDomainModel.slv(ensureNotNull(get_btbLanguageWithPrecalculatedResolve().q6f(FindUsagesAspect_instance)));
      $this$buildClientBtbDomainModel.slv(precalculatedResolutionService($resolveInfo));
      return Unit_instance;
    };
  }
  function createDomainModelWithLocalResolve$lambda($repository) {
    return function ($this$buildLocalBtbDomainModel) {
      $this$buildLocalBtbDomainModel.slv(ensureNotNull(get_btbLanguageWithLocalResolve().q6f(ScopeAspect_instance)));
      $this$buildLocalBtbDomainModel.slv(ensureNotNull(get_btbLanguageWithLocalResolve().q6f(FindUsagesAspect_instance)));
      $this$buildLocalBtbDomainModel.slv(get_serializationWithName());
      $this$buildLocalBtbDomainModel.slv(get_btbErrorChecking());
      $this$buildLocalBtbDomainModel.slv(Companion_instance_41.k3b($repository, [Companion_instance_109]));
      $this$buildLocalBtbDomainModel.slv(Companion_instance_41.n3b($repository, [Companion_instance_107]));
      return Unit_instance;
    };
  }
  function LocalNodePointerSupport$_init_$ref_vrx52y() {
    var l = function (p0, p1) {
      return new LocalNodePointerSupport(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  var properties_initialized_BTBConfiguration_kt_ti9h4;
  function _init_properties_BTBConfiguration_kt__auaap2() {
    if (!properties_initialized_BTBConfiguration_kt_ti9h4) {
      properties_initialized_BTBConfiguration_kt_ti9h4 = true;
      serialization_0 = serialization(serialization$lambda_0);
      serializationWithName = serialization(serializationWithName$lambda);
      nodeStorage = Companion_instance_41.k3b(new NodeStorageService(DefaultNodeStorage_instance), [Companion_getInstance_89()]);
    }
  }
  function get_btbEntityNodeLayout() {
    _init_properties_BtbEntityNodeLayout_kt__gd8dvx();
    return btbEntityNodeLayout;
  }
  var btbEntityNodeLayout;
  var properties_initialized_BtbEntityNodeLayout_kt_ozjemn;
  function _init_properties_BtbEntityNodeLayout_kt__gd8dvx() {
    if (!properties_initialized_BtbEntityNodeLayout_kt_ozjemn) {
      properties_initialized_BtbEntityNodeLayout_kt_ozjemn = true;
      btbEntityNodeLayout = new EntityNodeLayout(EntityConceptId_init_$Create$_0('edited.v1'), EntityModelBlobId_init_$Create$_0('edited-node-model'));
    }
  }
  function btbStructure(_this__u8e3s4) {
    // Inline function 'kotlin.with' call
    Companion_getInstance_317().olk_1.sfu().pfp(_this__u8e3s4);
    return Unit_instance;
  }
  function RemoteDocumentClient(accession, providers) {
    this.tlv_1 = accession;
    this.ulv_1 = providers;
  }
  function get_btbErrorChecking() {
    return errorChecking(_get_btbErrorChecking_$lambda_iq0vgy);
  }
  function forDuplicatesBy(uniqueList, propertyNamePlural, name) {
    return duplicatesBy(uniqueList, propertyNamePlural, name);
  }
  function checkForCycleInVariableSpecs(_this__u8e3s4, variables, $completion) {
    var tmp = new $checkForCycleInVariableSpecsCOROUTINE$(_this__u8e3s4, variables, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  }
  function checkClassExpressionType(_this__u8e3s4, type) {
    var tmp0_safe_receiver = (!(type == null) ? isInterface(type, ClassExpressionType_1) : false) ? type : null;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : _this__u8e3s4.l60(tmp0_safe_receiver.hfq());
    var tmp;
    if (tmp1_elvis_lhs == null) {
      return emptyList();
    } else {
      tmp = tmp1_elvis_lhs;
    }
    var union = tmp;
    return checkEmptyUnion(_this__u8e3s4, union);
  }
  function checkOneOfType(_this__u8e3s4, variable, spec) {
    // Inline function 'kotlin.collections.mutableListOf' call
    var result = ArrayList_init_$Create$();
    var tmp;
    if (!(spec == null) ? isInterface(spec, OneOf_1) : false) {
      // Inline function 'kotlin.collections.isNotEmpty' call
      tmp = !_this__u8e3s4.l60(variable.ofr()).s();
    } else {
      tmp = false;
    }
    if (tmp) {
      result.j(new ErrorForAllNode('Constraints are not supported for One Of variable type', variable));
    }
    return result;
  }
  function checkForDuplicatePropertiesInConstraints(_this__u8e3s4, constraints, $completion) {
    var tmp = new $checkForDuplicatePropertiesInConstraintsCOROUTINE$(_this__u8e3s4, constraints, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  }
  function checkPropertyConstraintOperation(_this__u8e3s4, constraint, $completion) {
    var tmp = new $checkPropertyConstraintOperationCOROUTINE$(_this__u8e3s4, constraint, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  }
  function checkEmptyUnion(_this__u8e3s4, union) {
    var tmp;
    // Inline function 'kotlin.collections.filterIsInstance' call
    var tmp0 = _this__u8e3s4.l60(union.mfu());
    // Inline function 'kotlin.collections.filterIsInstanceTo' call
    var destination = ArrayList_init_$Create$();
    var _iterator__ex2g4s = tmp0.m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      if (!(element == null) ? isInterface(element, ClassExpression) : false) {
        destination.j(element);
      }
    }
    if (destination.s()) {
      tmp = listOf(new ErrorForAllNode('empty unions are not supported', union));
    } else {
      tmp = emptyList();
    }
    return tmp;
  }
  function checkForCycleInProcessDefaults(_this__u8e3s4, processDeclaration, $completion) {
    var tmp = new $checkForCycleInProcessDefaultsCOROUTINE$(_this__u8e3s4, processDeclaration, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  }
  function checkNewFact(fact) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new checkNewFact$$inlined$suspendingQuery$1(fact);
  }
  function checkOntologyElement(element) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new checkOntologyElement$$inlined$suspendingQuery$1(element);
  }
  function checkOntologyElementDefinition(definition) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new checkOntologyElementDefinition$$inlined$suspendingQuery$1(definition);
  }
  function checkProcessRelationDeclaration(relation) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new checkProcessRelationDeclaration$$inlined$suspendingQuery$1(relation);
  }
  function duplicatesBy(_this__u8e3s4, propertyNamePlural, uniqueProperty) {
    propertyNamePlural = propertyNamePlural === VOID ? 'names' : propertyNamePlural;
    // Inline function 'jetbrains.ocelot.langDef.query.query' call
    return new duplicatesBy$$inlined$query$1(_this__u8e3s4, uniqueProperty, propertyNamePlural);
  }
  function isProcessExpression(_this__u8e3s4, expression, $completion) {
    var tmp = new $isProcessExpressionCOROUTINE$(_this__u8e3s4, expression, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  }
  function unwrapMultiplier(_this__u8e3s4, expression) {
    var tmp0_safe_receiver = isInterface(expression, MultipliedExpression_1) ? expression : null;
    var tmp = tmp0_safe_receiver == null ? null : _this__u8e3s4.l60(tmp0_safe_receiver.mfr());
    var tmp1_elvis_lhs = (!(tmp == null) ? isInterface(tmp, FactExpression) : false) ? tmp : null;
    return tmp1_elvis_lhs == null ? expression : tmp1_elvis_lhs;
  }
  function checkProcessRelation(_this__u8e3s4, expression, $completion) {
    var tmp = new $checkProcessRelationCOROUTINE$(_this__u8e3s4, expression, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  }
  function checkPropertyConstraintOperation$isPropertyRangeMultiple($this_checkPropertyConstraintOperation, $constraint, $completion) {
    var tmp = new $checkPropertyConstraintOperation$isPropertyRangeMultipleCOROUTINE$($this_checkPropertyConstraintOperation, $constraint, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  }
  function _get_btbErrorChecking_$lambda_iq0vgy($this$errorChecking) {
    // Inline function 'jetbrains.ocelot.langDef.check.config.ErrorCheckConfigBuilder.check' call
    var code = _get_btbErrorChecking_$lambda$lambda_niu9bb;
    $this$errorChecking.k70(getKClass(BTBDocument_1), code);
    // Inline function 'jetbrains.ocelot.langDef.check.config.ErrorCheckConfigBuilder.check' call
    var tmp0 = _get_btbErrorChecking_$lambda$lambda_niu9bb_0($this$errorChecking);
    // Inline function 'jetbrains.biokb.lang.model.errorCheck.forDuplicates' call
    var uniqueList = _get_btbErrorChecking_$lambda$lambda_niu9bb_1;
    tmp0(_get_btbErrorChecking_$lambda$lambda_niu9bb_2(uniqueList));
    // Inline function 'jetbrains.ocelot.langDef.check.config.ErrorCheckConfigBuilder.check' call
    var tmp0_0 = _get_btbErrorChecking_$lambda$lambda_niu9bb_3($this$errorChecking);
    // Inline function 'jetbrains.biokb.lang.model.errorCheck.forDuplicates' call
    var uniqueList_0 = _get_btbErrorChecking_$lambda$lambda_niu9bb_4;
    tmp0_0(_get_btbErrorChecking_$lambda$lambda_niu9bb_5(uniqueList_0));
    // Inline function 'jetbrains.ocelot.langDef.check.config.ErrorCheckConfigBuilder.check' call
    var code_0 = _get_btbErrorChecking_$lambda$lambda_niu9bb_6;
    $this$errorChecking.k70(getKClass(FactSet_1), code_0);
    // Inline function 'jetbrains.ocelot.langDef.check.config.ErrorCheckConfigBuilder.check' call
    var code_1 = _get_btbErrorChecking_$lambda$lambda_niu9bb_7;
    $this$errorChecking.k70(getKClass(VariableDeclaration_1), code_1);
    // Inline function 'jetbrains.ocelot.langDef.check.config.ErrorCheckConfigBuilder.check' call
    var code_2 = _get_btbErrorChecking_$lambda$lambda_niu9bb_8;
    $this$errorChecking.k70(getKClass(VariableDeclaration_1), code_2);
    // Inline function 'jetbrains.ocelot.langDef.check.config.ErrorCheckConfigBuilder.check' call
    var code_3 = _get_btbErrorChecking_$lambda$lambda_niu9bb_9;
    $this$errorChecking.k70(getKClass(MultipliedExpression_1), code_3);
    // Inline function 'jetbrains.ocelot.langDef.check.config.ErrorCheckConfigBuilder.check' call
    var code_4 = _get_btbErrorChecking_$lambda$lambda_niu9bb_10;
    $this$errorChecking.k70(getKClass(PropertyConstraint_1), code_4);
    // Inline function 'jetbrains.ocelot.langDef.check.config.ErrorCheckConfigBuilder.check' call
    var code_5 = _get_btbErrorChecking_$lambda$lambda_niu9bb_11;
    $this$errorChecking.k70(getKClass(ObjectPropertyDeclaration_1), code_5);
    // Inline function 'jetbrains.ocelot.langDef.check.config.ErrorCheckConfigBuilder.check' call
    var code_6 = _get_btbErrorChecking_$lambda$lambda_niu9bb_12;
    $this$errorChecking.k70(getKClass(ObjectPropertyDeclaration_1), code_6);
    // Inline function 'jetbrains.ocelot.langDef.check.config.ErrorCheckConfigBuilder.check' call
    var code_7 = _get_btbErrorChecking_$lambda$lambda_niu9bb_13;
    $this$errorChecking.k70(getKClass(PropertyReferenceOperation_1), code_7);
    // Inline function 'jetbrains.ocelot.langDef.check.config.ErrorCheckConfigBuilder.check' call
    var tmp0_1 = _get_btbErrorChecking_$lambda$lambda_niu9bb_14($this$errorChecking);
    // Inline function 'jetbrains.biokb.lang.model.errorCheck.forDuplicates' call
    var uniqueList_1 = _get_btbErrorChecking_$lambda$lambda_niu9bb_15;
    tmp0_1(_get_btbErrorChecking_$lambda$lambda_niu9bb_16(uniqueList_1));
    // Inline function 'jetbrains.ocelot.langDef.check.config.ErrorCheckConfigBuilder.check' call
    var tmp0_2 = _get_btbErrorChecking_$lambda$lambda_niu9bb_17($this$errorChecking);
    // Inline function 'jetbrains.biokb.lang.model.errorCheck.forDuplicates' call
    var uniqueList_2 = _get_btbErrorChecking_$lambda$lambda_niu9bb_18;
    tmp0_2(_get_btbErrorChecking_$lambda$lambda_niu9bb_19(uniqueList_2));
    // Inline function 'jetbrains.ocelot.langDef.check.config.ErrorCheckConfigBuilder.check' call
    var tmp0_3 = _get_btbErrorChecking_$lambda$lambda_niu9bb_20($this$errorChecking);
    // Inline function 'jetbrains.biokb.lang.model.errorCheck.forDuplicates' call
    var uniqueList_3 = _get_btbErrorChecking_$lambda$lambda_niu9bb_21;
    tmp0_3(_get_btbErrorChecking_$lambda$lambda_niu9bb_22(uniqueList_3));
    // Inline function 'jetbrains.ocelot.langDef.check.config.ErrorCheckConfigBuilder.check' call
    var tmp0_4 = _get_btbErrorChecking_$lambda$lambda_niu9bb_23($this$errorChecking);
    // Inline function 'jetbrains.biokb.lang.model.errorCheck.forDuplicates' call
    var uniqueList_4 = _get_btbErrorChecking_$lambda$lambda_niu9bb_24;
    tmp0_4(_get_btbErrorChecking_$lambda$lambda_niu9bb_25(uniqueList_4));
    // Inline function 'jetbrains.ocelot.langDef.check.config.ErrorCheckConfigBuilder.check' call
    var tmp0_5 = _get_btbErrorChecking_$lambda$lambda_niu9bb_26($this$errorChecking);
    // Inline function 'jetbrains.biokb.lang.model.errorCheck.forDuplicates' call
    var uniqueList_5 = _get_btbErrorChecking_$lambda$lambda_niu9bb_27;
    tmp0_5(_get_btbErrorChecking_$lambda$lambda_niu9bb_28(uniqueList_5));
    // Inline function 'jetbrains.ocelot.langDef.check.config.ErrorCheckConfigBuilder.check' call
    var tmp0_6 = _get_btbErrorChecking_$lambda$lambda_niu9bb_29($this$errorChecking);
    // Inline function 'jetbrains.biokb.lang.model.errorCheck.forDuplicates' call
    var uniqueList_6 = _get_btbErrorChecking_$lambda$lambda_niu9bb_30;
    tmp0_6(_get_btbErrorChecking_$lambda$lambda_niu9bb_31(uniqueList_6));
    // Inline function 'jetbrains.ocelot.langDef.check.config.ErrorCheckConfigBuilder.check' call
    var tmp0_7 = _get_btbErrorChecking_$lambda$lambda_niu9bb_32($this$errorChecking);
    // Inline function 'jetbrains.biokb.lang.model.errorCheck.forDuplicates' call
    var uniqueList_7 = _get_btbErrorChecking_$lambda$lambda_niu9bb_33;
    tmp0_7(_get_btbErrorChecking_$lambda$lambda_niu9bb_34(uniqueList_7));
    // Inline function 'jetbrains.ocelot.langDef.check.config.ErrorCheckConfigBuilder.check' call
    var tmp0_8 = _get_btbErrorChecking_$lambda$lambda_niu9bb_35($this$errorChecking);
    // Inline function 'jetbrains.biokb.lang.model.errorCheck.forDuplicates' call
    var uniqueList_8 = _get_btbErrorChecking_$lambda$lambda_niu9bb_36;
    tmp0_8(_get_btbErrorChecking_$lambda$lambda_niu9bb_37(uniqueList_8));
    // Inline function 'jetbrains.ocelot.langDef.check.config.ErrorCheckConfigBuilder.check' call
    var code_8 = _get_btbErrorChecking_$lambda$lambda_niu9bb_38;
    $this$errorChecking.k70(getKClass(UnknownComplexNotionValue_1), code_8);
    // Inline function 'jetbrains.ocelot.langDef.check.config.ErrorCheckConfigBuilder.check' call
    var tmp0_9 = _get_btbErrorChecking_$lambda$lambda_niu9bb_39($this$errorChecking);
    // Inline function 'jetbrains.biokb.lang.model.errorCheck.forDuplicates' call
    var uniqueList_9 = _get_btbErrorChecking_$lambda$lambda_niu9bb_40;
    tmp0_9(_get_btbErrorChecking_$lambda$lambda_niu9bb_41(uniqueList_9));
    // Inline function 'jetbrains.ocelot.langDef.check.config.ErrorCheckConfigBuilder.check' call
    var tmp0_10 = _get_btbErrorChecking_$lambda$lambda_niu9bb_42($this$errorChecking);
    // Inline function 'jetbrains.biokb.lang.model.errorCheck.forDuplicates' call
    var uniqueList_10 = _get_btbErrorChecking_$lambda$lambda_niu9bb_43;
    tmp0_10(_get_btbErrorChecking_$lambda$lambda_niu9bb_44(uniqueList_10));
    // Inline function 'jetbrains.ocelot.langDef.check.config.ErrorCheckConfigBuilder.check' call
    var tmp0_11 = _get_btbErrorChecking_$lambda$lambda_niu9bb_45($this$errorChecking);
    // Inline function 'jetbrains.biokb.lang.model.errorCheck.forDuplicates' call
    var uniqueList_11 = _get_btbErrorChecking_$lambda$lambda_niu9bb_46;
    tmp0_11(_get_btbErrorChecking_$lambda$lambda_niu9bb_47(uniqueList_11));
    // Inline function 'jetbrains.ocelot.langDef.check.config.ErrorCheckConfigBuilder.check' call
    var tmp0_12 = _get_btbErrorChecking_$lambda$lambda_niu9bb_48($this$errorChecking);
    // Inline function 'jetbrains.biokb.lang.model.errorCheck.forDuplicates' call
    var uniqueList_12 = _get_btbErrorChecking_$lambda$lambda_niu9bb_49;
    tmp0_12(_get_btbErrorChecking_$lambda$lambda_niu9bb_50(uniqueList_12));
    // Inline function 'jetbrains.ocelot.langDef.check.config.ErrorCheckConfigBuilder.check' call
    var tmp0_13 = _get_btbErrorChecking_$lambda$lambda_niu9bb_51($this$errorChecking);
    // Inline function 'jetbrains.biokb.lang.model.errorCheck.forDuplicates' call
    var uniqueList_13 = _get_btbErrorChecking_$lambda$lambda_niu9bb_52;
    tmp0_13(_get_btbErrorChecking_$lambda$lambda_niu9bb_53(uniqueList_13));
    // Inline function 'jetbrains.ocelot.langDef.check.config.ErrorCheckConfigBuilder.check' call
    var code_9 = _get_btbErrorChecking_$lambda$lambda_niu9bb_54;
    $this$errorChecking.k70(getKClass(ProcessDeclaration_1), code_9);
    // Inline function 'jetbrains.ocelot.langDef.check.config.ErrorCheckConfigBuilder.check' call
    var tmp0_14 = _get_btbErrorChecking_$lambda$lambda_niu9bb_55($this$errorChecking);
    // Inline function 'jetbrains.biokb.lang.model.errorCheck.forDuplicates' call
    var uniqueList_14 = _get_btbErrorChecking_$lambda$lambda_niu9bb_56;
    tmp0_14(_get_btbErrorChecking_$lambda$lambda_niu9bb_57(uniqueList_14));
    // Inline function 'jetbrains.ocelot.langDef.check.config.ErrorCheckConfigBuilder.check' call
    var code_10 = _get_btbErrorChecking_$lambda$lambda_niu9bb_58;
    $this$errorChecking.k70(getKClass(ProcessDeclaration_1), code_10);
    // Inline function 'jetbrains.ocelot.langDef.check.config.ErrorCheckConfigBuilder.check' call
    var code_11 = _get_btbErrorChecking_$lambda$lambda_niu9bb_59;
    $this$errorChecking.k70(getKClass(ProcessDeclaration_1), code_11);
    // Inline function 'jetbrains.ocelot.langDef.check.config.ErrorCheckConfigBuilder.check' call
    var code_12 = _get_btbErrorChecking_$lambda$lambda_niu9bb_60;
    $this$errorChecking.k70(getKClass(ProcessProperty_1), code_12);
    // Inline function 'jetbrains.ocelot.langDef.check.config.ErrorCheckConfigBuilder.check' call
    var code_13 = _get_btbErrorChecking_$lambda$lambda_niu9bb_61;
    $this$errorChecking.k70(getKClass(NewFact), code_13);
    // Inline function 'jetbrains.ocelot.langDef.check.config.ErrorCheckConfigBuilder.check' call
    var code_14 = _get_btbErrorChecking_$lambda$lambda_niu9bb_62;
    $this$errorChecking.k70(getKClass(OntologyElement_1), code_14);
    // Inline function 'jetbrains.ocelot.langDef.check.config.ErrorCheckConfigBuilder.check' call
    var code_15 = _get_btbErrorChecking_$lambda$lambda_niu9bb_63;
    $this$errorChecking.k70(getKClass(OntologyElementDefinition_1), code_15);
    // Inline function 'jetbrains.ocelot.langDef.check.config.ErrorCheckConfigBuilder.check' call
    var code_16 = _get_btbErrorChecking_$lambda$lambda_niu9bb_64;
    $this$errorChecking.k70(getKClass(ProcessRelationDeclaration_1), code_16);
    // Inline function 'jetbrains.ocelot.langDef.check.config.ErrorCheckConfigBuilder.check' call
    var code_17 = _get_btbErrorChecking_$lambda$lambda_niu9bb_65;
    $this$errorChecking.k70(getKClass(OntologyLibrary_1), code_17);
    // Inline function 'jetbrains.ocelot.langDef.check.config.ErrorCheckConfigBuilder.check' call
    var code_18 = _get_btbErrorChecking_$lambda$lambda_niu9bb_66;
    $this$errorChecking.k70(getKClass(ProcessPropertyValue_1), code_18);
    // Inline function 'jetbrains.ocelot.langDef.check.config.ErrorCheckConfigBuilder.check' call
    var code_19 = _get_btbErrorChecking_$lambda$lambda_niu9bb_67;
    $this$errorChecking.k70(getKClass(ProcessPropertyValue_1), code_19);
    // Inline function 'jetbrains.ocelot.langDef.check.config.ErrorCheckConfigBuilder.check' call
    var code_20 = _get_btbErrorChecking_$lambda$lambda_niu9bb_68;
    $this$errorChecking.k70(getKClass(PropertyConstraint_1), code_20);
    return Unit_instance;
  }
  function _get_btbErrorChecking_$lambda$lambda_niu9bb(it) {
    var tmp = it.xfp();
    return forDuplicatesBy(tmp, 'fact set ids', _get_btbErrorChecking_$lambda$lambda$lambda_nrr43y);
  }
  function _get_btbErrorChecking_$lambda$lambda$lambda_nrr43y(it) {
    return it.zfq();
  }
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_0($this) {
    return function (code) {
      // Inline function 'jetbrains.ocelot.langDef.check.config.ErrorCheckConfigBuilder.check' call
      $this.k70(getKClass(FactSet_1), code);
      return Unit_instance;
    };
  }
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_1(it) {
    return it.wfq();
  }
  function _get_btbErrorChecking_$lambda$lambda$lambda_nrr43y_0(it) {
    return it.y2();
  }
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_2($uniqueList) {
    return function (node) {
      var tmp = $uniqueList(node);
      return duplicatesBy(tmp, VOID, _get_btbErrorChecking_$lambda$lambda$lambda_nrr43y_0);
    };
  }
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_3($this) {
    return function (code) {
      // Inline function 'jetbrains.ocelot.langDef.check.config.ErrorCheckConfigBuilder.check' call
      $this.k70(getKClass(FactSet_1), code);
      return Unit_instance;
    };
  }
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_4(it) {
    // Inline function 'jetbrains.ocelot.langDef.query.query' call
    return new btbErrorChecking$2$6$$inlined$query$1(it);
  }
  function btbErrorChecking$2$6$$inlined$query$1($it) {
    this.gm0_1 = $it;
  }
  protoOf(btbErrorChecking$2$6$$inlined$query$1).n5w = function (builder) {
    return plus_5(builder.l60(this.gm0_1.rfr()), builder.l60(this.gm0_1.cfr()));
  };
  function _get_btbErrorChecking_$lambda$lambda$lambda_nrr43y_1(it) {
    return it.y2();
  }
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_5($uniqueList) {
    return function (node) {
      var tmp = $uniqueList(node);
      return duplicatesBy(tmp, VOID, _get_btbErrorChecking_$lambda$lambda$lambda_nrr43y_1);
    };
  }
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_6(it) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new btbErrorChecking$2$8$$inlined$suspendingQuery$1(it);
  }
  function $runSuspendCOROUTINE$_56(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.pm0_1 = _this__u8e3s4;
    this.qm0_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_56).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            var $this$suspendingQuery = this.qm0_1;
            this.f9_1 = 1;
            suspendResult = checkForCycleInVariableSpecs($this$suspendingQuery, $this$suspendingQuery.l60(this.pm0_1.rm0_1.rfr()), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function btbErrorChecking$2$8$$inlined$suspendingQuery$1($it) {
    this.rm0_1 = $it;
  }
  protoOf(btbErrorChecking$2$8$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_56(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbErrorChecking$2$8$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_7(variableDeclaration) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new btbErrorChecking$2$10$$inlined$suspendingQuery$1(variableDeclaration);
  }
  function btbErrorChecking$2$10$$inlined$suspendingQuery$1($variableDeclaration) {
    this.sm0_1 = $variableDeclaration;
  }
  protoOf(btbErrorChecking$2$10$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    // Inline function 'kotlin.collections.arrayListOf' call
    var result = ArrayList_init_$Create$();
    var type = builder.l60(this.sm0_1.ofu());
    result.q(checkClassExpressionType(builder, type));
    result.q(checkOneOfType(builder, this.sm0_1, type));
    return result;
  };
  protoOf(btbErrorChecking$2$10$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_8(variableDeclaration) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new btbErrorChecking$2$12$$inlined$suspendingQuery$1(variableDeclaration);
  }
  function $runSuspendCOROUTINE$_57(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.bm1_1 = _this__u8e3s4;
    this.cm1_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_57).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            var $this$suspendingQuery = this.cm1_1;
            this.f9_1 = 1;
            suspendResult = checkForDuplicatePropertiesInConstraints($this$suspendingQuery, this.bm1_1.dm1_1.ofr(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function btbErrorChecking$2$12$$inlined$suspendingQuery$1($variableDeclaration) {
    this.dm1_1 = $variableDeclaration;
  }
  protoOf(btbErrorChecking$2$12$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_57(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbErrorChecking$2$12$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_9(multipliedExpression) {
    // Inline function 'jetbrains.ocelot.langDef.query.query' call
    return new btbErrorChecking$2$14$$inlined$query$1(multipliedExpression);
  }
  function btbErrorChecking$2$14$$inlined$query$1($multipliedExpression) {
    this.em1_1 = $multipliedExpression;
  }
  protoOf(btbErrorChecking$2$14$$inlined$query$1).n5w = function (builder) {
    var multiplierValue = builder.l60(this.em1_1.bid());
    var tmp;
    var tmp_0;
    if (multiplierValue instanceof Exact) {
      tmp_0 = multiplierValue.hlv_1 <= 0;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = listOf(new ErrorForAllNode('Multiplier must be a positive integer, implicit 1, or N', this.em1_1));
    } else {
      tmp = emptyList();
    }
    return tmp;
  };
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_10(constraint) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new btbErrorChecking$2$16$$inlined$suspendingQuery$1(constraint);
  }
  function $runSuspendCOROUTINE$_58(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.nm1_1 = _this__u8e3s4;
    this.om1_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_58).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 3;
            this.qm1_1 = this.om1_1;
            this.f9_1 = 1;
            suspendResult = checkForDuplicatePropertiesInConstraints(this.qm1_1, this.nm1_1.rm1_1.ofr(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.pm1_1 = suspendResult;
            this.f9_1 = 2;
            suspendResult = checkPropertyConstraintOperation(this.qm1_1, this.nm1_1.rm1_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var ARGUMENT = suspendResult;
            return plus_5(this.pm1_1, ARGUMENT);
          case 3:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 3) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function btbErrorChecking$2$16$$inlined$suspendingQuery$1($constraint) {
    this.rm1_1 = $constraint;
  }
  protoOf(btbErrorChecking$2$16$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_58(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbErrorChecking$2$16$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_11(property) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new btbErrorChecking$2$18$$inlined$suspendingQuery$1(property);
  }
  function btbErrorChecking$2$18$$inlined$suspendingQuery$1($property) {
    this.sm1_1 = $property;
  }
  protoOf(btbErrorChecking$2$18$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var range = builder.l60(this.sm1_1.hd());
    var tmp;
    if (!builder.l60(this.sm1_1.hfs()) && !(range == null)) {
      // Inline function 'kotlin.collections.filterNot' call
      var tmp0 = builder.l60(range.cfs());
      // Inline function 'kotlin.collections.filterNotTo' call
      var destination = ArrayList_init_$Create$();
      var _iterator__ex2g4s = tmp0.m();
      while (_iterator__ex2g4s.n()) {
        var element = _iterator__ex2g4s.o();
        var tmp_0;
        var tmp_1;
        if (isInterface(element, OntologyElementType_1)) {
          tmp_1 = true;
        } else {
          tmp_1 = isInterface(element, ClassExpressionType_1);
        }
        if (tmp_1) {
          tmp_0 = true;
        } else {
          tmp_0 = isInterface(element, TypePlaceholder_1);
        }
        if (!tmp_0) {
          destination.j(element);
        }
      }
      var nonOntologyTypes = destination;
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(nonOntologyTypes, 10));
      var _iterator__ex2g4s_0 = nonOntologyTypes.m();
      while (_iterator__ex2g4s_0.n()) {
        var item = _iterator__ex2g4s_0.o();
        // Inline function 'kotlin.collections.toTypedArray' call
        var tmp$ret$3 = copyToArray(nonOntologyTypes);
        var tmp$ret$4 = new ErrorForDescendants('Only ontology types are allowed for independent properties', tmp$ret$3.slice());
        destination_0.j(tmp$ret$4);
      }
      tmp = destination_0;
    } else {
      tmp = emptyList();
    }
    return tmp;
  };
  protoOf(btbErrorChecking$2$18$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_12(property) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new btbErrorChecking$2$20$$inlined$suspendingQuery$1(property);
  }
  function btbErrorChecking$2$20$$inlined$suspendingQuery$1($property) {
    this.tm1_1 = $property;
  }
  protoOf(btbErrorChecking$2$20$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp0_safe_receiver = builder.l60(this.tm1_1.hd());
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.cfs();
    // Inline function 'kotlin.collections.orEmpty' call
    var tmp0_elvis_lhs = tmp1_safe_receiver == null ? null : builder.l60(tmp1_safe_receiver);
    // Inline function 'kotlin.collections.filterIsInstance' call
    var tmp0 = tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
    // Inline function 'kotlin.collections.filterIsInstanceTo' call
    var destination = ArrayList_init_$Create$();
    var _iterator__ex2g4s = tmp0.m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      if (!(element == null) ? isInterface(element, ClassExpressionType_1) : false) {
        destination.j(element);
      }
    }
    // Inline function 'kotlin.collections.mapNotNull' call
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var destination_0 = ArrayList_init_$Create$();
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s_0 = destination.m();
    while (_iterator__ex2g4s_0.n()) {
      var element_0 = _iterator__ex2g4s_0.o();
      var tmp0_safe_receiver_0 = builder.l60(element_0.hfq());
      if (tmp0_safe_receiver_0 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        destination_0.j(tmp0_safe_receiver_0);
      }
    }
    // Inline function 'kotlin.collections.flatMap' call
    // Inline function 'kotlin.collections.flatMapTo' call
    var destination_1 = ArrayList_init_$Create$();
    var _iterator__ex2g4s_1 = destination_0.m();
    while (_iterator__ex2g4s_1.n()) {
      var element_1 = _iterator__ex2g4s_1.o();
      var list = checkEmptyUnion(builder, element_1);
      addAll_1(destination_1, list);
    }
    return destination_1;
  };
  protoOf(btbErrorChecking$2$20$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_13(operation) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new btbErrorChecking$2$22$$inlined$suspendingQuery$1(operation);
  }
  function $runSuspendCOROUTINE$_59(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.cm2_1 = _this__u8e3s4;
    this.dm2_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_59).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.em2_1 = this.dm2_1;
            this.f9_1 = 1;
            suspendResult = this.em2_1.k60(this.cm2_1.fm2_1.q6q().w6o(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp0_safe_receiver = suspendResult;
            var propertyRange = tmp0_safe_receiver == null ? null : this.em2_1.l60(tmp0_safe_receiver.hd());
            var parameter = this.em2_1.l60(this.cm2_1.fm2_1.dfu());
            var tmp_0;
            var tmp_1;
            if (!(parameter == null)) {
              tmp_1 = !(!(propertyRange == null) ? isInterface(propertyRange, MultiplePropertyValueRange_1) : false);
            } else {
              tmp_1 = false;
            }

            if (tmp_1) {
              tmp_0 = listOf(new ErrorForAllNode("Parameter makes no sense as property doesn't have 'set' type ", parameter));
            } else {
              tmp_0 = emptyList();
            }

            return tmp_0;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function btbErrorChecking$2$22$$inlined$suspendingQuery$1($operation) {
    this.fm2_1 = $operation;
  }
  protoOf(btbErrorChecking$2$22$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_59(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbErrorChecking$2$22$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_14($this) {
    return function (code) {
      // Inline function 'jetbrains.ocelot.langDef.check.config.ErrorCheckConfigBuilder.check' call
      $this.k70(getKClass(ProcessLibrary_1), code);
      return Unit_instance;
    };
  }
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_15(it) {
    return it.xft();
  }
  function _get_btbErrorChecking_$lambda$lambda$lambda_nrr43y_2(it) {
    return it.y2();
  }
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_16($uniqueList) {
    return function (node) {
      var tmp = $uniqueList(node);
      return duplicatesBy(tmp, VOID, _get_btbErrorChecking_$lambda$lambda$lambda_nrr43y_2);
    };
  }
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_17($this) {
    return function (code) {
      // Inline function 'jetbrains.ocelot.langDef.check.config.ErrorCheckConfigBuilder.check' call
      $this.k70(getKClass(PropertyLibrary_1), code);
      return Unit_instance;
    };
  }
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_18(it) {
    return it.rfp();
  }
  function _get_btbErrorChecking_$lambda$lambda$lambda_nrr43y_3(it) {
    return it.y2();
  }
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_19($uniqueList) {
    return function (node) {
      var tmp = $uniqueList(node);
      return duplicatesBy(tmp, VOID, _get_btbErrorChecking_$lambda$lambda$lambda_nrr43y_3);
    };
  }
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_20($this) {
    return function (code) {
      // Inline function 'jetbrains.ocelot.langDef.check.config.ErrorCheckConfigBuilder.check' call
      $this.k70(getKClass(ObjectPropertiesLibrary), code);
      return Unit_instance;
    };
  }
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_21(it) {
    return it.rfp();
  }
  function _get_btbErrorChecking_$lambda$lambda$lambda_nrr43y_4(it) {
    return it.y2();
  }
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_22($uniqueList) {
    return function (node) {
      var tmp = $uniqueList(node);
      return duplicatesBy(tmp, VOID, _get_btbErrorChecking_$lambda$lambda$lambda_nrr43y_4);
    };
  }
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_23($this) {
    return function (code) {
      // Inline function 'jetbrains.ocelot.langDef.check.config.ErrorCheckConfigBuilder.check' call
      $this.k70(getKClass(LinkLibrary_1), code);
      return Unit_instance;
    };
  }
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_24(it) {
    return it.wfr();
  }
  function _get_btbErrorChecking_$lambda$lambda$lambda_nrr43y_5(it) {
    return it.y2();
  }
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_25($uniqueList) {
    return function (node) {
      var tmp = $uniqueList(node);
      return duplicatesBy(tmp, VOID, _get_btbErrorChecking_$lambda$lambda$lambda_nrr43y_5);
    };
  }
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_26($this) {
    return function (code) {
      // Inline function 'jetbrains.ocelot.langDef.check.config.ErrorCheckConfigBuilder.check' call
      $this.k70(getKClass(NotionLibrary_1), code);
      return Unit_instance;
    };
  }
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_27(it) {
    return it.efs();
  }
  function _get_btbErrorChecking_$lambda$lambda$lambda_nrr43y_6(it) {
    return it.y2();
  }
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_28($uniqueList) {
    return function (node) {
      var tmp = $uniqueList(node);
      return duplicatesBy(tmp, VOID, _get_btbErrorChecking_$lambda$lambda$lambda_nrr43y_6);
    };
  }
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_29($this) {
    return function (code) {
      // Inline function 'jetbrains.ocelot.langDef.check.config.ErrorCheckConfigBuilder.check' call
      $this.k70(getKClass(EnumerableNotion_1), code);
      return Unit_instance;
    };
  }
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_30(it) {
    return it.qfq();
  }
  function _get_btbErrorChecking_$lambda$lambda$lambda_nrr43y_7(it) {
    return it.y2();
  }
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_31($uniqueList) {
    return function (node) {
      var tmp = $uniqueList(node);
      return duplicatesBy(tmp, VOID, _get_btbErrorChecking_$lambda$lambda$lambda_nrr43y_7);
    };
  }
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_32($this) {
    return function (code) {
      // Inline function 'jetbrains.ocelot.langDef.check.config.ErrorCheckConfigBuilder.check' call
      $this.k70(getKClass(MeasurableNotion_1), code);
      return Unit_instance;
    };
  }
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_33(it) {
    return it.xfr();
  }
  function _get_btbErrorChecking_$lambda$lambda$lambda_nrr43y_8(it) {
    return it.y2();
  }
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_34($uniqueList) {
    return function (node) {
      var tmp = $uniqueList(node);
      return duplicatesBy(tmp, VOID, _get_btbErrorChecking_$lambda$lambda$lambda_nrr43y_8);
    };
  }
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_35($this) {
    return function (code) {
      // Inline function 'jetbrains.ocelot.langDef.check.config.ErrorCheckConfigBuilder.check' call
      $this.k70(getKClass(ComplexNotion_1), code);
      return Unit_instance;
    };
  }
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_36(it) {
    return it.ifq();
  }
  function _get_btbErrorChecking_$lambda$lambda$lambda_nrr43y_9(it) {
    return it.y2();
  }
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_37($uniqueList) {
    return function (node) {
      var tmp = $uniqueList(node);
      return duplicatesBy(tmp, VOID, _get_btbErrorChecking_$lambda$lambda$lambda_nrr43y_9);
    };
  }
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_38(unknownValue) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new btbErrorChecking$2$40$$inlined$suspendingQuery$1(unknownValue);
  }
  function $runSuspendCOROUTINE$_60(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.om2_1 = _this__u8e3s4;
    this.pm2_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_60).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 3;
            this.qm2_1 = this.pm2_1;
            var tmp_0 = this.om2_1.sm2_1.bp();
            var tmp0_safe_receiver = (!(tmp_0 == null) ? isInterface(tmp_0, ComplexNotionElementValue_1) : false) ? tmp_0 : null;
            if (tmp0_safe_receiver == null) {
              this.rm2_1 = null;
              this.f9_1 = 2;
              continue $sm;
            } else {
              this.f9_1 = 1;
              suspendResult = this.qm2_1.k60(tmp0_safe_receiver.gfq(), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            this.rm2_1 = suspendResult;
            this.f9_1 = 2;
            continue $sm;
          case 2:
            var element = this.rm2_1;
            var tmp_1;
            if (!(element == null) && !this.qm2_1.l60(element.lfq())) {
              tmp_1 = listOf(new ErrorForAllNode("Unknown value is not allowed for element '" + this.qm2_1.l60(element.y2()) + "'", this.om2_1.sm2_1));
            } else {
              tmp_1 = emptyList();
            }

            return tmp_1;
          case 3:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 3) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function btbErrorChecking$2$40$$inlined$suspendingQuery$1($unknownValue) {
    this.sm2_1 = $unknownValue;
  }
  protoOf(btbErrorChecking$2$40$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_60(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbErrorChecking$2$40$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_39($this) {
    return function (code) {
      // Inline function 'jetbrains.ocelot.langDef.check.config.ErrorCheckConfigBuilder.check' call
      $this.k70(getKClass(ExtensionLibrary_1), code);
      return Unit_instance;
    };
  }
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_40(it) {
    return it.ue2();
  }
  function _get_btbErrorChecking_$lambda$lambda$lambda_nrr43y_10(it) {
    return it.y2();
  }
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_41($uniqueList) {
    return function (node) {
      var tmp = $uniqueList(node);
      return duplicatesBy(tmp, VOID, _get_btbErrorChecking_$lambda$lambda$lambda_nrr43y_10);
    };
  }
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_42($this) {
    return function (code) {
      // Inline function 'jetbrains.ocelot.langDef.check.config.ErrorCheckConfigBuilder.check' call
      $this.k70(getKClass(ExtensionDeclaration_1), code);
      return Unit_instance;
    };
  }
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_43(it) {
    return it.rfq();
  }
  function _get_btbErrorChecking_$lambda$lambda$lambda_nrr43y_11(it) {
    return it.y2();
  }
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_44($uniqueList) {
    return function (node) {
      var tmp = $uniqueList(node);
      return duplicatesBy(tmp, VOID, _get_btbErrorChecking_$lambda$lambda$lambda_nrr43y_11);
    };
  }
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_45($this) {
    return function (code) {
      // Inline function 'jetbrains.ocelot.langDef.check.config.ErrorCheckConfigBuilder.check' call
      $this.k70(getKClass(RelationContainer_1), code);
      return Unit_instance;
    };
  }
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_46(it) {
    return it.jfu();
  }
  function _get_btbErrorChecking_$lambda$lambda$lambda_nrr43y_12(it) {
    return it.y2();
  }
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_47($uniqueList) {
    return function (node) {
      var tmp = $uniqueList(node);
      return duplicatesBy(tmp, VOID, _get_btbErrorChecking_$lambda$lambda$lambda_nrr43y_12);
    };
  }
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_48($this) {
    return function (code) {
      // Inline function 'jetbrains.ocelot.langDef.check.config.ErrorCheckConfigBuilder.check' call
      $this.k70(getKClass(ModifierContainer), code);
      return Unit_instance;
    };
  }
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_49(it) {
    return it.l8j();
  }
  function _get_btbErrorChecking_$lambda$lambda$lambda_nrr43y_13(it) {
    return it.y2();
  }
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_50($uniqueList) {
    return function (node) {
      var tmp = $uniqueList(node);
      return duplicatesBy(tmp, VOID, _get_btbErrorChecking_$lambda$lambda$lambda_nrr43y_13);
    };
  }
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_51($this) {
    return function (code) {
      // Inline function 'jetbrains.ocelot.langDef.check.config.ErrorCheckConfigBuilder.check' call
      $this.k70(getKClass(ProcessKindContainer_1), code);
      return Unit_instance;
    };
  }
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_52(it) {
    return it.wft();
  }
  function _get_btbErrorChecking_$lambda$lambda$lambda_nrr43y_14(it) {
    return it.y2();
  }
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_53($uniqueList) {
    return function (node) {
      var tmp = $uniqueList(node);
      return duplicatesBy(tmp, VOID, _get_btbErrorChecking_$lambda$lambda$lambda_nrr43y_14);
    };
  }
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_54(process) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new btbErrorChecking$2$52$$inlined$suspendingQuery$1(process);
  }
  function $runSuspendCOROUTINE$_61(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.bm3_1 = _this__u8e3s4;
    this.cm3_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_61).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            var $this$suspendingQuery = this.cm3_1;
            this.f9_1 = 1;
            suspendResult = $this$suspendingQuery.k60(this.bm3_1.dm3_1.vil(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var cycle = suspendResult;
            return cycle.s() ? emptyList() : cycle.p() === 1 ? listOf(new ErrorForAllNode('process cannot extend itself', this.bm3_1.dm3_1)) : listOf(new ErrorForAllNode("cycle in 'process extends' chain: " + joinToString_0(cycle), this.bm3_1.dm3_1));
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function btbErrorChecking$2$52$$inlined$suspendingQuery$1($process) {
    this.dm3_1 = $process;
  }
  protoOf(btbErrorChecking$2$52$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_61(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbErrorChecking$2$52$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_55($this) {
    return function (code) {
      // Inline function 'jetbrains.ocelot.langDef.check.config.ErrorCheckConfigBuilder.check' call
      $this.k70(getKClass(ProcessDeclaration_1), code);
      return Unit_instance;
    };
  }
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_56(it) {
    // Inline function 'jetbrains.ocelot.langDef.query.query' call
    return new btbErrorChecking$2$54$$inlined$query$1(it);
  }
  function btbErrorChecking$2$54$$inlined$query$1($it) {
    this.em3_1 = $it;
  }
  protoOf(btbErrorChecking$2$54$$inlined$query$1).n5w = function (builder) {
    return plus_5(builder.l60(this.em3_1.rfp()), builder.l60(this.em3_1.rfr()));
  };
  function _get_btbErrorChecking_$lambda$lambda$lambda_nrr43y_15(it) {
    return it.y2();
  }
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_57($uniqueList) {
    return function (node) {
      var tmp = $uniqueList(node);
      return duplicatesBy(tmp, VOID, _get_btbErrorChecking_$lambda$lambda$lambda_nrr43y_15);
    };
  }
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_58(processDeclaration) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new btbErrorChecking$2$56$$inlined$suspendingQuery$1(processDeclaration);
  }
  function $runSuspendCOROUTINE$_62(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.nm3_1 = _this__u8e3s4;
    this.om3_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_62).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            var $this$suspendingQuery = this.om3_1;
            this.f9_1 = 1;
            suspendResult = checkForCycleInProcessDefaults($this$suspendingQuery, this.nm3_1.pm3_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function btbErrorChecking$2$56$$inlined$suspendingQuery$1($processDeclaration) {
    this.pm3_1 = $processDeclaration;
  }
  protoOf(btbErrorChecking$2$56$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_62(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbErrorChecking$2$56$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_59(it) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new btbErrorChecking$2$58$$inlined$suspendingQuery$1(it);
  }
  function $runSuspendCOROUTINE$_63(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.ym3_1 = _this__u8e3s4;
    this.zm3_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_63).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            var $this$suspendingQuery = this.zm3_1;
            this.f9_1 = 1;
            suspendResult = checkForCycleInVariableSpecs($this$suspendingQuery, $this$suspendingQuery.l60(this.ym3_1.am4_1.rfr()), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function btbErrorChecking$2$58$$inlined$suspendingQuery$1($it) {
    this.am4_1 = $it;
  }
  protoOf(btbErrorChecking$2$58$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_63(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbErrorChecking$2$58$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_60(property) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new btbErrorChecking$2$60$$inlined$suspendingQuery$1(property);
  }
  function btbErrorChecking$2$60$$inlined$suspendingQuery$1($property) {
    this.bm4_1 = $property;
  }
  protoOf(btbErrorChecking$2$60$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp0_safe_receiver = builder.l60(this.bm4_1.sfq());
    return checkClassExpressionType(builder, tmp0_safe_receiver == null ? null : builder.l60(tmp0_safe_receiver.sfq()));
  };
  protoOf(btbErrorChecking$2$60$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_61(fact) {
    return checkNewFact(fact);
  }
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_62(element) {
    return checkOntologyElement(element);
  }
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_63(definition) {
    return checkOntologyElementDefinition(definition);
  }
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_64(relation) {
    return checkProcessRelationDeclaration(relation);
  }
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_65(ontology) {
    return checkOntology(ontology, ontology.y2().m5y().w2w() === 'metaOntology');
  }
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_66(propertyValue) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new btbErrorChecking$2$72$$inlined$suspendingQuery$1(propertyValue);
  }
  function btbErrorChecking$2$72$$inlined$suspendingQuery$1($propertyValue) {
    this.cm4_1 = $propertyValue;
  }
  protoOf(btbErrorChecking$2$72$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp;
    if (builder.l60(this.cm4_1.a1()) == null) {
      tmp = listOf(new ErrorForAllNode('Empty process property value', this.cm4_1));
    } else {
      tmp = emptyList();
    }
    return tmp;
  };
  protoOf(btbErrorChecking$2$72$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_67(propertyValue) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new btbErrorChecking$2$74$$inlined$suspendingQuery$1(propertyValue);
  }
  function $runSuspendCOROUTINE$_64(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.lm4_1 = _this__u8e3s4;
    this.mm4_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_64).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 12;
            var tmp_0 = this;
            tmp_0.wm4_1 = this.mm4_1;
            this.nm4_1 = Unit_instance;
            this.f9_1 = 1;
            continue $sm;
          case 1:
            this.qm4_1 = this.wm4_1;
            this.sm4_1 = new AdapterCache();
            var tmp0_elvis_lhs = this.qm4_1.l60(this.lm4_1.xm4_1.a1());
            if (tmp0_elvis_lhs == null) {
              this.nm4_1 = emptyList();
              this.f9_1 = 11;
              var tmp_1 = this;
              continue $sm;
            } else {
              this.vm4_1 = tmp0_elvis_lhs;
              this.f9_1 = 2;
              continue $sm;
            }

          case 2:
            var value = this.vm4_1;
            this.f9_1 = 3;
            suspendResult = this.qm4_1.k60(toAdapter_2(value, DomainFactExpressionAdapterContext_instance, this.sm4_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            var tmp1_safe_receiver = suspendResult instanceof ClassValue ? suspendResult : null;
            var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.ym4_1;
            if (tmp2_elvis_lhs == null) {
              this.nm4_1 = emptyList();
              this.f9_1 = 11;
              var tmp_2 = this;
              continue $sm;
            } else {
              this.um4_1 = tmp2_elvis_lhs;
              this.f9_1 = 4;
              continue $sm;
            }

          case 4:
            this.pm4_1 = this.um4_1;
            this.f9_1 = 5;
            suspendResult = this.qm4_1.k60(this.lm4_1.xm4_1.q6q(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 5:
            var tmp3_elvis_lhs = suspendResult;
            if (tmp3_elvis_lhs == null) {
              this.nm4_1 = emptyList();
              this.f9_1 = 11;
              var tmp_3 = this;
              continue $sm;
            } else {
              this.tm4_1 = tmp3_elvis_lhs;
              this.f9_1 = 6;
              continue $sm;
            }

          case 6:
            var processParameter = this.tm4_1;
            this.f9_1 = 7;
            suspendResult = this.qm4_1.k60(expectedClass(processParameter, this.sm4_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 7:
            var tmp4_elvis_lhs = suspendResult;
            if (tmp4_elvis_lhs == null) {
              this.nm4_1 = emptyList();
              this.f9_1 = 11;
              var tmp_4 = this;
              continue $sm;
            } else {
              this.rm4_1 = tmp4_elvis_lhs;
              this.f9_1 = 8;
              continue $sm;
            }

          case 8:
            var expectedType = this.rm4_1;
            var typeComparer = new TypeComparer(new TypeNormalizer(), ontologyElementHierarchy());
            this.f9_1 = 9;
            suspendResult = this.qm4_1.k60(typeComparer.bm5(this.pm4_1, expectedType), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 9:
            if (!suspendResult) {
              var tmp_5 = this;
              tmp_5.om4_1 = listOf(new ErrorForAllNode("Value doesn't match process parameter type", this.lm4_1.xm4_1));
              this.f9_1 = 10;
              continue $sm;
            } else {
              var tmp_6 = this;
              tmp_6.om4_1 = emptyList();
              this.f9_1 = 10;
              continue $sm;
            }

          case 10:
            this.nm4_1 = this.om4_1;
            if (false) {
              this.f9_1 = 1;
              continue $sm;
            }

            this.f9_1 = 11;
            continue $sm;
          case 11:
            return this.nm4_1;
          case 12:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 12) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function btbErrorChecking$2$74$$inlined$suspendingQuery$1($propertyValue) {
    this.xm4_1 = $propertyValue;
  }
  protoOf(btbErrorChecking$2$74$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_64(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbErrorChecking$2$74$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_68(constraint) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new btbErrorChecking$2$76$$inlined$suspendingQuery$1(constraint);
  }
  function $runSuspendCOROUTINE$_65(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.km5_1 = _this__u8e3s4;
    this.lm5_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_65).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 18;
            var tmp_0 = this;
            tmp_0.am6_1 = this.lm5_1;
            this.mm5_1 = Unit_instance;
            this.f9_1 = 1;
            continue $sm;
          case 1:
            this.rm5_1 = this.am6_1;
            this.wm5_1 = new AdapterCache();
            var tmp0_elvis_lhs = this.rm5_1.l60(this.km5_1.bm6_1.a1());
            if (tmp0_elvis_lhs == null) {
              this.mm5_1 = emptyList();
              this.f9_1 = 17;
              var tmp_1 = this;
              continue $sm;
            } else {
              this.zm5_1 = tmp0_elvis_lhs;
              this.f9_1 = 2;
              continue $sm;
            }

          case 2:
            var value = this.zm5_1;
            this.f9_1 = 3;
            suspendResult = this.rm5_1.k60(toAdapter_2(value, DomainFactExpressionAdapterContext_instance, this.wm5_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            var tmp1_safe_receiver = suspendResult instanceof ClassValue ? suspendResult : null;
            var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.ym4_1;
            if (tmp2_elvis_lhs == null) {
              this.mm5_1 = emptyList();
              this.f9_1 = 17;
              var tmp_2 = this;
              continue $sm;
            } else {
              this.ym5_1 = tmp2_elvis_lhs;
              this.f9_1 = 4;
              continue $sm;
            }

          case 4:
            this.pm5_1 = this.ym5_1;
            this.f9_1 = 5;
            suspendResult = this.rm5_1.k60(this.km5_1.bm6_1.q6q(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 5:
            var tmp3_elvis_lhs = suspendResult;
            if (tmp3_elvis_lhs == null) {
              this.mm5_1 = emptyList();
              this.f9_1 = 17;
              var tmp_3 = this;
              continue $sm;
            } else {
              this.xm5_1 = tmp3_elvis_lhs;
              this.f9_1 = 6;
              continue $sm;
            }

          case 6:
            var property = this.xm5_1;
            this.f9_1 = 7;
            suspendResult = this.rm5_1.k60(expectedClassesForValue(property, this.wm5_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 7:
            var this_0 = suspendResult;
            if (this_0.s()) {
              this.mm5_1 = emptyList();
              this.f9_1 = 17;
              var tmp_4 = this;
              continue $sm;
            } else {
              this.vm5_1 = this_0;
              this.f9_1 = 8;
              continue $sm;
            }

          case 8:
            var expectedTypes = this.vm5_1;
            this.qm5_1 = new TypeComparer(new TypeNormalizer(), ontologyElementHierarchy());
            var tmp_5 = this;
            tmp_5.um5_1 = expectedTypes;
            this.f9_1 = 9;
            continue $sm;
          case 9:
            this.tm5_1 = this.um5_1;
            var tmp_6;
            var tmp_7 = this.tm5_1;
            if (isInterface(tmp_7, Collection)) {
              tmp_6 = this.tm5_1.s();
            } else {
              tmp_6 = false;
            }

            if (tmp_6) {
              this.om5_1 = false;
              this.f9_1 = 15;
              continue $sm;
            } else {
              this.f9_1 = 10;
              continue $sm;
            }

          case 10:
            this.sm5_1 = this.tm5_1.m();
            this.f9_1 = 11;
            continue $sm;
          case 11:
            if (!this.sm5_1.n()) {
              this.f9_1 = 14;
              continue $sm;
            }

            var element = this.sm5_1.o();
            this.f9_1 = 12;
            suspendResult = this.rm5_1.k60(this.qm5_1.bm5(this.pm5_1, element), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 12:
            if (suspendResult) {
              this.om5_1 = true;
              this.f9_1 = 15;
              continue $sm;
            } else {
              this.f9_1 = 13;
              continue $sm;
            }

          case 13:
            this.f9_1 = 11;
            continue $sm;
          case 14:
            this.om5_1 = false;
            if (false) {
              this.f9_1 = 9;
              continue $sm;
            }

            this.f9_1 = 15;
            continue $sm;
          case 15:
            if (!this.om5_1) {
              var tmp_8 = this;
              tmp_8.nm5_1 = listOf(new ErrorForAllNode("Value doesn't match property's range", this.km5_1.bm6_1));
              this.f9_1 = 16;
              continue $sm;
            } else {
              var tmp_9 = this;
              tmp_9.nm5_1 = emptyList();
              this.f9_1 = 16;
              continue $sm;
            }

          case 16:
            this.mm5_1 = this.nm5_1;
            if (false) {
              this.f9_1 = 1;
              continue $sm;
            }

            this.f9_1 = 17;
            continue $sm;
          case 17:
            return this.mm5_1;
          case 18:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 18) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function btbErrorChecking$2$76$$inlined$suspendingQuery$1($constraint) {
    this.bm6_1 = $constraint;
  }
  protoOf(btbErrorChecking$2$76$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_65(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbErrorChecking$2$76$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function checkForCycleInVariableSpecs$lambda($visited, $result) {
    return function ($this$traverseDepthFirst) {
      $visited.j($this$traverseDepthFirst.w85());
      $result.j($this$traverseDepthFirst.w85());
      return Unit_instance;
    };
  }
  function checkForCycleInProcessDefaults$lambda($currentCycle) {
    return function ($this$traverseDepthFirst) {
      var tmp0 = $this$traverseDepthFirst.cm6();
      var tmp$ret$0;
      $l$block_0: {
        // Inline function 'kotlin.collections.minByOrNull' call
        var iterator = tmp0.m();
        if (!iterator.n()) {
          tmp$ret$0 = null;
          break $l$block_0;
        }
        var minElem = iterator.o();
        if (!iterator.n()) {
          tmp$ret$0 = minElem;
          break $l$block_0;
        }
        var minValue = minElem.z3n().q36_1;
        do {
          var e = iterator.o();
          var v = e.z3n().q36_1;
          if (compareTo_0(minValue, v) > 0) {
            minElem = e;
            minValue = v;
          }
        }
         while (iterator.n());
        tmp$ret$0 = minElem;
      }
      var cycleStartNode = tmp$ret$0;
      var tmp;
      if (equals($this$traverseDepthFirst.w85(), cycleStartNode)) {
        var nodeIndex = $this$traverseDepthFirst.cm6().w($this$traverseDepthFirst.w85());
        // Inline function 'kotlin.collections.filter' call
        var tmp0_0 = $this$traverseDepthFirst.cm6();
        // Inline function 'kotlin.collections.filterTo' call
        var destination = ArrayList_init_$Create$();
        var _iterator__ex2g4s = tmp0_0.m();
        while (_iterator__ex2g4s.n()) {
          var element = _iterator__ex2g4s.o();
          if (drop($this$traverseDepthFirst.cm6(), nodeIndex).t(element)) {
            destination.j(element);
          }
        }
        var cycleNodes = destination;
        $currentCycle.k2();
        $currentCycle.q(cycleNodes);
        $currentCycle.j($this$traverseDepthFirst.w85());
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function checkForCycleInProcessDefaults$lambda_0($this_checkForCycleInProcessDefaults) {
    return function (it) {
      return $this_checkForCycleInProcessDefaults.l60(it.y2());
    };
  }
  function $runSuspendCOROUTINE$_66(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.lm6_1 = _this__u8e3s4;
    this.mm6_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_66).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 14;
            var tmp_0 = this;
            tmp_0.ym6_1 = this.mm6_1;
            this.nm6_1 = Unit_instance;
            this.f9_1 = 1;
            continue $sm;
          case 1:
            this.rm6_1 = this.ym6_1;
            var tmp0_elvis_lhs = this.rm6_1.l60(this.lm6_1.zm6_1.mfr());
            if (tmp0_elvis_lhs == null) {
              this.nm6_1 = emptyList();
              this.f9_1 = 13;
              var tmp_1 = this;
              continue $sm;
            } else {
              this.xm6_1 = tmp0_elvis_lhs;
              this.f9_1 = 2;
              continue $sm;
            }

          case 2:
            this.qm6_1 = this.xm6_1;
            this.om6_1 = ArrayList_init_$Create$();
            this.pm6_1 = this.om6_1;
            var tmp0_subject = this.qm6_1;
            if (isInterface(tmp0_subject, RelationFactExpression_1)) {
              this.sm6_1 = true;
              this.f9_1 = 11;
              continue $sm;
            } else {
              if (isInterface(tmp0_subject, SetExpression_1)) {
                var tmp_2 = this;
                var tmp0 = this.rm6_1.l60(this.qm6_1.mfs());
                var destination = ArrayList_init_$Create$();
                var _iterator__ex2g4s = tmp0.m();
                while (_iterator__ex2g4s.n()) {
                  var element = _iterator__ex2g4s.o();
                  if (!(element == null) ? isInterface(element, FactExpression) : false) {
                    destination.j(element);
                  }
                }
                tmp_2.wm6_1 = destination;
                this.f9_1 = 4;
                continue $sm;
              } else {
                this.f9_1 = 3;
                suspendResult = isProcessExpression(this.rm6_1, unwrapMultiplier(this.rm6_1, this.qm6_1), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              }
            }

          case 3:
            this.sm6_1 = suspendResult;
            this.f9_1 = 11;
            continue $sm;
          case 4:
            this.vm6_1 = this.wm6_1;
            var tmp_3;
            var tmp_4 = this.vm6_1;
            if (isInterface(tmp_4, Collection)) {
              tmp_3 = this.vm6_1.s();
            } else {
              tmp_3 = false;
            }

            if (tmp_3) {
              this.tm6_1 = true;
              this.f9_1 = 10;
              continue $sm;
            } else {
              this.f9_1 = 5;
              continue $sm;
            }

          case 5:
            this.um6_1 = this.vm6_1.m();
            this.f9_1 = 6;
            continue $sm;
          case 6:
            if (!this.um6_1.n()) {
              this.f9_1 = 9;
              continue $sm;
            }

            var element_0 = this.um6_1.o();
            this.f9_1 = 7;
            suspendResult = isProcessExpression(this.rm6_1, unwrapMultiplier(this.rm6_1, element_0), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 7:
            if (!suspendResult) {
              this.tm6_1 = false;
              this.f9_1 = 10;
              continue $sm;
            } else {
              this.f9_1 = 8;
              continue $sm;
            }

          case 8:
            this.f9_1 = 6;
            continue $sm;
          case 9:
            this.tm6_1 = true;
            if (false) {
              this.f9_1 = 4;
              continue $sm;
            }

            this.f9_1 = 10;
            continue $sm;
          case 10:
            this.sm6_1 = this.tm6_1;
            this.f9_1 = 11;
            continue $sm;
          case 11:
            var isRelationOrProcess = this.sm6_1;
            if (!isRelationOrProcess) {
              this.pm6_1.j(new ErrorForAllNode('Fact should be either relation or process', this.qm6_1));
            }

            this.f9_1 = 12;
            suspendResult = checkProcessRelation(this.rm6_1, this.qm6_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 12:
            var tmp1_safe_receiver = suspendResult;
            if (tmp1_safe_receiver == null)
              null;
            else {
              this.pm6_1.j(tmp1_safe_receiver);
            }

            this.nm6_1 = this.om6_1.i3();
            if (false) {
              this.f9_1 = 1;
              continue $sm;
            }

            this.f9_1 = 13;
            continue $sm;
          case 13:
            return this.nm6_1;
          case 14:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 14) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function checkNewFact$$inlined$suspendingQuery$1($fact) {
    this.zm6_1 = $fact;
  }
  protoOf(checkNewFact$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_66(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(checkNewFact$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function $runSuspendCOROUTINE$_67(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.im7_1 = _this__u8e3s4;
    this.jm7_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_67).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 3;
            this.lm7_1 = this.jm7_1;
            var ontologyHierarchy = ontologyElementHierarchy();
            var tmp_0 = this;
            tmp_0.km7_1 = ArrayList_init_$Create$();
            var tmp0_safe_receiver = this.lm7_1.l60(this.im7_1.mm7_1.vfs());
            if (tmp0_safe_receiver == null)
              null;
            else {
              this.km7_1.j(new ErrorForAllNode('Old definition is not supported, use definition instead', tmp0_safe_receiver));
            }

            this.f9_1 = 1;
            suspendResult = this.lm7_1.k60(isNatural_0(ontologyHierarchy, this.im7_1.mm7_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            if (!suspendResult) {
              if (!this.lm7_1.l60(this.im7_1.mm7_1.nfs()).s()) {
                this.km7_1.j(new ErrorForAllNode('Both definition and super-type is not currently supported', this.im7_1.mm7_1));
              }
              if (!this.lm7_1.l60(this.im7_1.mm7_1.ofr()).s()) {
                this.km7_1.j(new ErrorForAllNode('Both definition and properties are not currently supported', this.im7_1.mm7_1));
              }
              this.f9_1 = 2;
              continue $sm;
            } else {
              this.f9_1 = 2;
              continue $sm;
            }

          case 2:
            return this.km7_1;
          case 3:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 3) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function checkOntologyElement$$inlined$suspendingQuery$1($element) {
    this.mm7_1 = $element;
  }
  protoOf(checkOntologyElement$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_67(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(checkOntologyElement$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function checkOntologyElementDefinition$$inlined$suspendingQuery$1($definition) {
    this.nm7_1 = $definition;
  }
  protoOf(checkOntologyElementDefinition$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    // Inline function 'kotlin.collections.buildList' call
    // Inline function 'kotlin.collections.buildListInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = ArrayList_init_$Create$();
    var classExpression = builder.l60(this.nm7_1.hfq());
    if (classExpression == null) {
      this_0.j(new ErrorForAllNode('Empty definition is not supported', this.nm7_1));
    } else {
      if (isInterface(classExpression, UnionClass_1)) {
        var tmp0 = builder.l60(classExpression.mfu());
        var tmp$ret$0;
        $l$block_0: {
          // Inline function 'kotlin.collections.none' call
          var tmp;
          if (isInterface(tmp0, Collection)) {
            tmp = tmp0.s();
          } else {
            tmp = false;
          }
          if (tmp) {
            tmp$ret$0 = true;
            break $l$block_0;
          }
          var _iterator__ex2g4s = tmp0.m();
          while (_iterator__ex2g4s.n()) {
            var element = _iterator__ex2g4s.o();
            if (isInterface(element, ClassExpression)) {
              tmp$ret$0 = false;
              break $l$block_0;
            }
          }
          tmp$ret$0 = true;
        }
        if (tmp$ret$0) {
          this_0.j(new ErrorForAllNode('Empty definition is not supported', this.nm7_1));
        }
      } else {
        if (builder.l60(this.nm7_1.ofr()).s()) {
          this_0.j(new ErrorForAllNode('Non-union definition should include constraints', this.nm7_1));
        }
      }
    }
    return this_0.i3();
  };
  protoOf(checkOntologyElementDefinition$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function checkProcessRelationDeclaration$$inlined$suspendingQuery$1($relation) {
    this.om7_1 = $relation;
  }
  protoOf(checkProcessRelationDeclaration$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    // Inline function 'kotlin.collections.buildList' call
    // Inline function 'kotlin.collections.buildListInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = ArrayList_init_$Create$();
    if (builder.l60(this.om7_1.afu()) == null) {
      this_0.j(new ErrorForAllNode('direction is missing', this.om7_1));
    }
    if (builder.l60(this.om7_1.bfu()) == null) {
      this_0.j(new ErrorForAllNode('effect is missing', this.om7_1));
    }
    return this_0.i3();
  };
  protoOf(checkProcessRelationDeclaration$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function duplicatesBy$$inlined$query$1($this_duplicatesBy, $uniqueProperty, $propertyNamePlural) {
    this.pm7_1 = $this_duplicatesBy;
    this.qm7_1 = $uniqueProperty;
    this.rm7_1 = $propertyNamePlural;
  }
  protoOf(duplicatesBy$$inlined$query$1).n5w = function (builder) {
    // Inline function 'kotlin.collections.filter' call
    var tmp0 = builder.l60(this.pm7_1);
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList_init_$Create$();
    var _iterator__ex2g4s = tmp0.m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      // Inline function 'kotlin.text.isNotBlank' call
      var this_0 = builder.l60(this.qm7_1(element));
      if (!isBlank(this_0)) {
        destination.j(element);
      }
    }
    // Inline function 'kotlin.collections.groupBy' call
    // Inline function 'kotlin.collections.groupByTo' call
    var destination_0 = LinkedHashMap_init_$Create$();
    var _iterator__ex2g4s_0 = destination.m();
    while (_iterator__ex2g4s_0.n()) {
      var element_0 = _iterator__ex2g4s_0.o();
      var key = builder.l60(this.qm7_1(element_0));
      // Inline function 'kotlin.collections.getOrPut' call
      var value = destination_0.q2(key);
      var tmp;
      if (value == null) {
        var answer = ArrayList_init_$Create$();
        destination_0.t2(key, answer);
        tmp = answer;
      } else {
        tmp = value;
      }
      var list = tmp;
      list.j(element_0);
    }
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_1 = ArrayList_init_$Create$_0(destination_0.p());
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s_1 = destination_0.y().m();
    while (_iterator__ex2g4s_1.n()) {
      var item = _iterator__ex2g4s_1.o();
      var tmp$ret$10 = item.a1();
      destination_1.j(tmp$ret$10);
    }
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination_2 = ArrayList_init_$Create$();
    var _iterator__ex2g4s_2 = destination_1.m();
    while (_iterator__ex2g4s_2.n()) {
      var element_1 = _iterator__ex2g4s_2.o();
      if (element_1.p() > 1) {
        destination_2.j(element_1);
      }
    }
    var duplicates = destination_2;
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_3 = ArrayList_init_$Create$_0(collectionSizeOrDefault(duplicates, 10));
    var _iterator__ex2g4s_3 = duplicates.m();
    while (_iterator__ex2g4s_3.n()) {
      var item_0 = _iterator__ex2g4s_3.o();
      var tmp_0 = 'duplicate ' + this.rm7_1;
      // Inline function 'kotlin.collections.toTypedArray' call
      var tmp$ret$16 = copyToArray(item_0);
      var tmp$ret$17 = new ErrorForDescendants(tmp_0, tmp$ret$16.slice());
      destination_3.j(tmp$ret$17);
    }
    return destination_3;
  };
  function $checkForCycleInVariableSpecsCOROUTINE$(_this__u8e3s4, variables, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.dlw_1 = _this__u8e3s4;
    this.elw_1 = variables;
  }
  protoOf($checkForCycleInVariableSpecsCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 18;
            var tmp_0 = this;
            tmp_0.flw_1 = LinkedHashSet_init_$Create$();
            var tmp_1 = this;
            tmp_1.slw_1 = ArrayList_init_$Create$();
            this.wlw_1 = this.elw_1.m();
            this.f9_1 = 1;
            continue $sm;
          case 1:
            if (!this.wlw_1.n()) {
              this.f9_1 = 17;
              continue $sm;
            }

            var variable = this.wlw_1.o();
            var tmp_2 = this;
            tmp_2.vlw_1 = variable;
            var tmp_3 = this;
            tmp_3.ulw_1 = checkForCycleInVariableSpecs$lambda(this.slw_1, this.flw_1);
            this.f9_1 = 2;
            continue $sm;
          case 2:
            var this_0 = this.vlw_1;
            this.tlw_1 = this.ulw_1;
            this.jlw_1 = new PreProcessNodeFrame(this_0, null);
            this.hlw_1 = HashSet_init_$Create$();
            this.f9_1 = 3;
            continue $sm;
          case 3:
            if (!!(this.jlw_1 == null)) {
              this.f9_1 = 15;
              continue $sm;
            }

            this.ilw_1 = new TraversalContext(this.jlw_1);
            var tmp0_subject = this.jlw_1;
            if (tmp0_subject instanceof PreProcessNodeFrame) {
              if (this.hlw_1.t(this.ilw_1.w85())) {
                var tmp_4 = this;
                if (!isNoop(this.tlw_1) && this.ilw_1.mlr(this.ilw_1.w85())) {
                  this.tlw_1(this.ilw_1);
                }
                tmp_4.llw_1 = this.jlw_1.hlr_1;
                this.f9_1 = 12;
                continue $sm;
              } else {
                var $this$traverseDepthFirst = this.ilw_1;
                if (this.slw_1.j($this$traverseDepthFirst.w85())) {
                  var tmp0 = this.hlw_1;
                  var element = this.ilw_1.w85();
                  tmp0.j(element);
                  var next = this.ilw_1.w85();
                  this.plw_1 = this.dlw_1.l60(next.ofu());
                  var tmp_5 = this.plw_1;
                  if (!(tmp_5 == null) ? isInterface(tmp_5, VariableReferenceValue_1) : false) {
                    this.f9_1 = 7;
                    suspendResult = this.dlw_1.k60(this.plw_1.pfu(), this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) {
                      return suspendResult;
                    }
                    continue $sm;
                  } else {
                    var tmp_6 = this.plw_1;
                    if (!(tmp_6 == null) ? isInterface(tmp_6, OneOf_1) : false) {
                      var tmp0_0 = this.dlw_1.l60(this.plw_1.mfs());
                      var destination = ArrayList_init_$Create$();
                      var _iterator__ex2g4s = tmp0_0.m();
                      while (_iterator__ex2g4s.n()) {
                        var element_0 = _iterator__ex2g4s.o();
                        if (!(element_0 == null) ? isInterface(element_0, VariableReferenceValue_1) : false) {
                          destination.j(element_0);
                        }
                      }
                      this.qlw_1 = ArrayList_init_$Create$();
                      this.rlw_1 = destination.m();
                      this.f9_1 = 4;
                      continue $sm;
                    } else {
                      this.nlw_1 = emptyList();
                      this.f9_1 = 10;
                      continue $sm;
                    }
                  }
                } else {
                  var tmp_7 = this;
                  tmp_7.mlw_1 = emptyList();
                  this.f9_1 = 11;
                  continue $sm;
                }
              }
            } else {
              if (tmp0_subject instanceof PostProcessChildNodeFrame) {
                this.klw_1 = createNextChildProcessingFrame(this.jlw_1);
                this.f9_1 = 13;
                continue $sm;
              } else {
                if (tmp0_subject instanceof PostProcessNodeFrame) {
                  var tmp_8 = this;
                  this.ilw_1;
                  tmp_8.klw_1 = this.jlw_1.hlr_1;
                  this.f9_1 = 13;
                  continue $sm;
                } else {
                  var tmp_9 = this;
                  noWhenBranchMatchedException();
                }
              }
            }

            break;
          case 4:
            if (!this.rlw_1.n()) {
              this.f9_1 = 6;
              continue $sm;
            }

            var element_1 = this.rlw_1.o();
            this.f9_1 = 5;
            suspendResult = this.dlw_1.k60(element_1.pfu(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 5:
            var tmp0_safe_receiver = suspendResult;
            if (tmp0_safe_receiver == null)
              null;
            else {
              this.qlw_1.j(tmp0_safe_receiver);
            }

            this.f9_1 = 4;
            continue $sm;
          case 6:
            var tmp_10 = this;
            var this_1 = this.qlw_1;
            var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_1, 10));
            var _iterator__ex2g4s_0 = this_1.m();
            while (_iterator__ex2g4s_0.n()) {
              var item = _iterator__ex2g4s_0.o();
              destination_0.j(to(item, Unit_instance));
            }

            tmp_10.nlw_1 = destination_0;
            this.f9_1 = 10;
            continue $sm;
          case 7:
            if (!(suspendResult == null)) {
              this.f9_1 = 8;
              suspendResult = this.dlw_1.k60(this.plw_1.pfu(), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.olw_1 = emptyList();
              this.f9_1 = 9;
              continue $sm;
            }

          case 8:
            var ARGUMENT = suspendResult;
            var ARGUMENT_0 = ensureNotNull(ARGUMENT);
            var ARGUMENT_1 = to(ARGUMENT_0, Unit_instance);
            this.olw_1 = listOf(ARGUMENT_1);
            this.f9_1 = 9;
            continue $sm;
          case 9:
            this.nlw_1 = this.olw_1;
            this.f9_1 = 10;
            continue $sm;
          case 10:
            this.mlw_1 = this.nlw_1;
            this.f9_1 = 11;
            continue $sm;
          case 11:
            var edges = this.mlw_1;
            this.llw_1 = createChildProcessingFrame(this.jlw_1, edges.m());
            this.f9_1 = 12;
            continue $sm;
          case 12:
            this.klw_1 = this.llw_1;
            this.f9_1 = 13;
            continue $sm;
          case 13:
            this.jlw_1 = this.klw_1;
            if (this.ilw_1.nlr()) {
              this.glw_1 = null;
              this.f9_1 = 16;
              continue $sm;
            } else {
              this.f9_1 = 14;
              continue $sm;
            }

          case 14:
            this.f9_1 = 3;
            continue $sm;
          case 15:
            this.glw_1 = this.hlw_1;
            if (false) {
              this.f9_1 = 2;
              continue $sm;
            }

            this.f9_1 = 16;
            continue $sm;
          case 16:
            this.f9_1 = 1;
            continue $sm;
          case 17:
            var tmp_11;
            if (this.flw_1.s()) {
              tmp_11 = emptyList();
            } else {
              var this_2 = this.flw_1;
              tmp_11 = listOf(new ErrorForDescendants('Variables form a cycle with the initializers', copyToArray(this_2).slice()));
            }

            return tmp_11;
          case 18:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 18) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function $checkForDuplicatePropertiesInConstraintsCOROUTINE$(_this__u8e3s4, constraints, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.flx_1 = _this__u8e3s4;
    this.glx_1 = constraints;
  }
  protoOf($checkForDuplicatePropertiesInConstraintsCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 7;
            var tmp_0 = this;
            tmp_0.hlx_1 = HashMap_init_$Create$();
            this.llx_1 = this.flx_1.l60(this.glx_1).m();
            this.f9_1 = 1;
            continue $sm;
          case 1:
            if (!this.llx_1.n()) {
              this.f9_1 = 6;
              continue $sm;
            }

            this.ilx_1 = this.llx_1.o();
            if (!(this.flx_1.l60(this.ilx_1.s3z()) == null)) {
              this.f9_1 = 1;
              continue $sm;
            } else {
              this.f9_1 = 2;
              continue $sm;
            }

          case 2:
            this.f9_1 = 3;
            suspendResult = this.flx_1.k60(this.ilx_1.q6q(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            var tmp0_elvis_lhs = suspendResult;
            if (tmp0_elvis_lhs == null) {
              this.f9_1 = 1;
              var tmp_1 = this;
              continue $sm;
            } else {
              this.klx_1 = tmp0_elvis_lhs;
              this.f9_1 = 4;
              continue $sm;
            }

          case 4:
            this.jlx_1 = this.klx_1;
            var tmp_2 = this.flx_1.l60(this.jlx_1.hd());
            if (!(tmp_2 == null) ? isInterface(tmp_2, MultiplePropertyValueRange_1) : false) {
              this.f9_1 = 1;
              continue $sm;
            } else {
              this.f9_1 = 5;
              continue $sm;
            }

          case 5:
            var tmp0 = this.hlx_1;
            var key = this.jlx_1;
            var value = tmp0.q2(key);
            var tmp_3;
            if (value == null) {
              var answer = ArrayList_init_$Create$();
              tmp0.t2(key, answer);
              tmp_3 = answer;
            } else {
              tmp_3 = value;
            }

            tmp_3.j(this.ilx_1);
            this.f9_1 = 1;
            continue $sm;
          case 6:
            var tmp0_0 = this.hlx_1.s2();
            var destination = ArrayList_init_$Create$();
            var _iterator__ex2g4s = tmp0_0.m();
            while (_iterator__ex2g4s.n()) {
              var element = _iterator__ex2g4s.o();
              if (element.p() > 1) {
                destination.j(element);
              }
            }

            var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(destination, 10));
            var _iterator__ex2g4s_0 = destination.m();
            while (_iterator__ex2g4s_0.n()) {
              var item = _iterator__ex2g4s_0.o();
              destination_0.j(new ErrorForDescendants('Multiple constraints reference the same property', copyToArray(item).slice()));
            }

            return destination_0;
          case 7:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 7) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function $checkPropertyConstraintOperationCOROUTINE$(_this__u8e3s4, constraint, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.ulx_1 = _this__u8e3s4;
    this.vlx_1 = constraint;
  }
  protoOf($checkPropertyConstraintOperationCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 4;
            this.xlx_1 = this.ulx_1.l60(this.vlx_1.s3z());
            if (equals(this.xlx_1, ConstraintOperation_ADDITION_ASSIGNMENT_getInstance())) {
              this.f9_1 = 1;
              suspendResult = checkPropertyConstraintOperation$isPropertyRangeMultiple(this.ulx_1, this.vlx_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.ylx_1 = false;
              this.f9_1 = 2;
              continue $sm;
            }

          case 1:
            this.ylx_1 = !suspendResult;
            this.f9_1 = 2;
            continue $sm;
          case 2:
            if (this.ylx_1) {
              var tmp_0 = this;
              tmp_0.wlx_1 = listOf(new ErrorForAllNode('Property range must be multiple for ' + this.xlx_1.toString() + ' operation', this.vlx_1));
              this.f9_1 = 3;
              continue $sm;
            } else {
              var tmp_1 = this;
              tmp_1.wlx_1 = emptyList();
              this.f9_1 = 3;
              continue $sm;
            }

          case 3:
            return this.wlx_1;
          case 4:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 4) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function $checkForCycleInProcessDefaultsCOROUTINE$(_this__u8e3s4, processDeclaration, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.hly_1 = _this__u8e3s4;
    this.ily_1 = processDeclaration;
  }
  protoOf($checkForCycleInProcessDefaultsCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 14;
            var tmp_0 = this;
            tmp_0.jly_1 = ArrayList_init_$Create$();
            var tmp_1 = this;
            tmp_1.lly_1 = LinkedHashSet_init_$Create$();
            this.yly_1 = this.hly_1.l60(this.ily_1.rfp()).m();
            this.f9_1 = 1;
            continue $sm;
          case 1:
            if (!this.yly_1.n()) {
              this.f9_1 = 13;
              continue $sm;
            }

            this.xly_1 = this.yly_1.o();
            if (this.lly_1.t(this.xly_1)) {
              this.f9_1 = 1;
              continue $sm;
            } else {
              this.f9_1 = 2;
              continue $sm;
            }

          case 2:
            var tmp_2 = this;
            tmp_2.kly_1 = ArrayList_init_$Create$();
            var tmp_3 = this;
            tmp_3.wly_1 = this.xly_1;
            var tmp_4 = this;
            tmp_4.vly_1 = checkForCycleInProcessDefaults$lambda(this.kly_1);
            this.f9_1 = 3;
            continue $sm;
          case 3:
            var this_0 = this.wly_1;
            this.uly_1 = this.vly_1;
            this.ply_1 = new PreProcessNodeFrame(this_0, null);
            this.nly_1 = HashSet_init_$Create$();
            this.f9_1 = 4;
            continue $sm;
          case 4:
            if (!!(this.ply_1 == null)) {
              this.f9_1 = 11;
              continue $sm;
            }

            this.oly_1 = new TraversalContext(this.ply_1);
            var tmp0_subject = this.ply_1;
            if (tmp0_subject instanceof PreProcessNodeFrame) {
              if (this.nly_1.t(this.oly_1.w85())) {
                var tmp_5 = this;
                if (!isNoop(this.uly_1) && this.oly_1.mlr(this.oly_1.w85())) {
                  this.uly_1(this.oly_1);
                }
                tmp_5.rly_1 = this.ply_1.hlr_1;
                this.f9_1 = 8;
                continue $sm;
              } else {
                this.oly_1;
                var tmp0 = this.nly_1;
                var element = this.oly_1.w85();
                tmp0.j(element);
                var currentProperty = this.oly_1.w85();
                var tmp0_safe_receiver = this.hly_1.l60(currentProperty.g3b());
                var tmp_6 = tmp0_safe_receiver == null ? null : this.hly_1.l60(tmp0_safe_receiver.a1());
                var defaultValue = (!(tmp_6 == null) ? isInterface(tmp_6, ProcessPropertyReference) : false) ? tmp_6 : null;
                if (defaultValue == null) {
                  this.tly_1 = null;
                  this.f9_1 = 6;
                  continue $sm;
                } else {
                  this.f9_1 = 5;
                  suspendResult = this.hly_1.k60(defaultValue.q6q(), this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  continue $sm;
                }
              }
            } else {
              if (tmp0_subject instanceof PostProcessChildNodeFrame) {
                this.qly_1 = createNextChildProcessingFrame(this.ply_1);
                this.f9_1 = 9;
                continue $sm;
              } else {
                if (tmp0_subject instanceof PostProcessNodeFrame) {
                  var tmp_7 = this;
                  this.oly_1;
                  tmp_7.qly_1 = this.ply_1.hlr_1;
                  this.f9_1 = 9;
                  continue $sm;
                } else {
                  var tmp_8 = this;
                  noWhenBranchMatchedException();
                }
              }
            }

            break;
          case 5:
            this.tly_1 = suspendResult;
            this.f9_1 = 6;
            continue $sm;
          case 6:
            var nextProperty = this.tly_1;
            var tmp_9 = this;
            var tmp_10;
            if (!(nextProperty == null)) {
              tmp_10 = listOf(to(nextProperty, Unit_instance));
            } else {
              tmp_10 = emptyList();
            }

            tmp_9.sly_1 = tmp_10;
            this.f9_1 = 7;
            continue $sm;
          case 7:
            var edges = this.sly_1;
            this.rly_1 = createChildProcessingFrame(this.ply_1, edges.m());
            this.f9_1 = 8;
            continue $sm;
          case 8:
            this.qly_1 = this.rly_1;
            this.f9_1 = 9;
            continue $sm;
          case 9:
            this.ply_1 = this.qly_1;
            if (this.oly_1.nlr()) {
              this.mly_1 = null;
              this.f9_1 = 12;
              continue $sm;
            } else {
              this.f9_1 = 10;
              continue $sm;
            }

          case 10:
            this.f9_1 = 4;
            continue $sm;
          case 11:
            this.mly_1 = this.nly_1;
            if (false) {
              this.f9_1 = 3;
              continue $sm;
            }

            this.f9_1 = 12;
            continue $sm;
          case 12:
            if (!this.kly_1.s()) {
              this.jly_1.j(toList_0(this.kly_1));
              this.lly_1.q(this.kly_1);
            }

            this.f9_1 = 1;
            continue $sm;
          case 13:
            var this_1 = this.jly_1;
            var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_1, 10));
            var _iterator__ex2g4s = this_1.m();
            while (_iterator__ex2g4s.n()) {
              var item = _iterator__ex2g4s.o();
              var cyclePath = joinToString_0(item, ' -> ', VOID, VOID, VOID, VOID, checkForCycleInProcessDefaults$lambda_0(this.hly_1));
              var errorMessage = 'Cycle detected in default value references: ' + cyclePath;
              destination.j(new ErrorForDescendants(errorMessage, copyToArray(item).slice()));
            }

            return destination;
          case 14:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 14) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function $isProcessExpressionCOROUTINE$(_this__u8e3s4, expression, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.hlz_1 = _this__u8e3s4;
    this.ilz_1 = expression;
  }
  protoOf($isProcessExpressionCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 3;
            this.llz_1 = this.hlz_1;
            var tmp_0 = this.ilz_1;
            if (isInterface(tmp_0, LibraryProcessSpecification_1)) {
              this.jlz_1 = true;
              this.f9_1 = 4;
              continue $sm;
            } else {
              var tmp_1 = this.ilz_1;
              if (isInterface(tmp_1, VariableReferenceValue_1)) {
                this.f9_1 = 1;
                suspendResult = this.llz_1.k60(this.ilz_1.pfu(), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                this.klz_1 = false;
                this.f9_1 = 2;
                continue $sm;
              }
            }

          case 1:
            var tmp0_safe_receiver = suspendResult;
            var tmp_2 = this;
            var tmp_3 = tmp0_safe_receiver == null ? null : this.llz_1.l60(tmp0_safe_receiver.ofu());
            tmp_2.klz_1 = !(tmp_3 == null) ? isInterface(tmp_3, ProcessType_1) : false;
            this.f9_1 = 2;
            continue $sm;
          case 2:
            this.jlz_1 = this.klz_1;
            this.f9_1 = 4;
            continue $sm;
          case 3:
            throw this.i9_1;
          case 4:
            return this.jlz_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 3) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function $checkProcessRelationCOROUTINE$(_this__u8e3s4, expression, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.ulz_1 = _this__u8e3s4;
    this.vlz_1 = expression;
  }
  protoOf($checkProcessRelationCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            var tmp_0 = this.vlz_1;
            if (!isInterface(tmp_0, RelationFactExpression_1)) {
              return null;
            }

            this.f9_1 = 1;
            suspendResult = this.ulz_1.k60(this.vlz_1.xfq(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var relation = suspendResult;
            var tmp_1;
            if (!(relation == null) && !this.ulz_1.l60(relation.kio())) {
              tmp_1 = new ErrorForDescendants('The relation being used here has an incomplete declaration', [this.vlz_1]);
            } else {
              tmp_1 = null;
            }

            return tmp_1;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function $checkPropertyConstraintOperation$isPropertyRangeMultipleCOROUTINE$($this_checkPropertyConstraintOperation, $constraint, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.em0_1 = $this_checkPropertyConstraintOperation;
    this.fm0_1 = $constraint;
  }
  protoOf($checkPropertyConstraintOperation$isPropertyRangeMultipleCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.em0_1.k60(this.fm0_1.q6q(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp0_elvis_lhs = suspendResult;
            var tmp_0;
            if (tmp0_elvis_lhs == null) {
              return true;
            } else {
              tmp_0 = tmp0_elvis_lhs;
            }

            var property = tmp_0;
            var tmp1_elvis_lhs = this.em0_1.l60(property.hd());
            var tmp_1;
            if (tmp1_elvis_lhs == null) {
              return true;
            } else {
              tmp_1 = tmp1_elvis_lhs;
            }

            var range = tmp_1;
            return isInterface(range, MultiplePropertyValueRange_1);
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function checkOntology(ontology, isRootOntology) {
    return (new OntologyProcessor(ontology)).vm7(isRootOntology);
  }
  function $runSuspendCOROUTINE$_68(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.em8_1 = _this__u8e3s4;
    this.fm8_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_68).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 3;
            this.gm8_1 = this.fm8_1;
            this.f9_1 = 1;
            suspendResult = this.gm8_1.k60(detectDefinitionCycles(this.em8_1.hm8_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.f9_1 = 2;
            suspendResult = this.gm8_1.k60(analyzeSupertypes(this.em8_1.hm8_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var supertypeAnalyses = suspendResult;
            var result = LinkedHashMap_init_$Create$();
            var _iterator__ex2g4s = supertypeAnalyses.y().m();
            while (_iterator__ex2g4s.n()) {
              var entry = _iterator__ex2g4s.o();
              if (entry.a1().jm8_1) {
                result.t2(entry.z(), entry.a1());
              }
            }

            var this_0 = result.r2();
            var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
            var _iterator__ex2g4s_0 = this_0.m();
            while (_iterator__ex2g4s_0.n()) {
              var item = _iterator__ex2g4s_0.o();
              destination.j(new ErrorForAllNode('Cycle in super elements', item));
            }

            var superElementsCycleErrors = destination;
            var tmp_0;
            if (this.em8_1.im8_1) {
              tmp_0 = emptyList();
            } else {
              tmp_0 = metaOntologyAncestorErrors(this.em8_1.hm8_1, supertypeAnalyses);
            }

            var supertypeConstraintErrors = tmp_0;
            var tmp0 = this.gm8_1.l60(this.em8_1.hm8_1.sm7_1.ifq());
            var destination_0 = ArrayList_init_$Create$();
            var _iterator__ex2g4s_1 = tmp0.m();
            while (_iterator__ex2g4s_1.n()) {
              var element = _iterator__ex2g4s_1.o();
              if (this.em8_1.hm8_1.tm7_1.t(element)) {
                destination_0.j(element);
              }
            }

            var destination_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(destination_0, 10));
            var _iterator__ex2g4s_2 = destination_0.m();
            while (_iterator__ex2g4s_2.n()) {
              var item_0 = _iterator__ex2g4s_2.o();
              destination_1.j(new ErrorForAllNode('Cycle in definition', item_0));
            }

            var definitionCycleErrors = destination_1;
            return plus_5(plus_5(superElementsCycleErrors, supertypeConstraintErrors), definitionCycleErrors);
          case 3:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 3) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function $runSuspendCOROUTINE$_69(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.um8_1 = _this__u8e3s4;
    this.vm8_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_69).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 7;
            this.xm8_1 = this.vm8_1;
            this.zm8_1 = this.xm8_1.l60(this.um8_1.am9_1.sm7_1.ifq()).m();
            this.f9_1 = 1;
            continue $sm;
          case 1:
            if (!this.zm8_1.n()) {
              this.f9_1 = 6;
              continue $sm;
            }

            var element = this.zm8_1.o();
            this.wm8_1 = element;
            this.f9_1 = 2;
            suspendResult = this.xm8_1.k60(isNatural_0(this.um8_1.am9_1.um7_1, this.wm8_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            if (!suspendResult) {
              this.ym8_1 = !this.um8_1.am9_1.tm7_1.t(this.wm8_1);
              this.f9_1 = 3;
              continue $sm;
            } else {
              this.ym8_1 = false;
              this.f9_1 = 3;
              continue $sm;
            }

          case 3:
            if (this.ym8_1) {
              this.f9_1 = 4;
              suspendResult = this.xm8_1.k60(this.um8_1.am9_1.um7_1.bm9(toAdapter_0(this.wm8_1)), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.f9_1 = 5;
              continue $sm;
            }

          case 4:
            this.f9_1 = 5;
            continue $sm;
          case 5:
            this.f9_1 = 1;
            continue $sm;
          case 6:
            return Unit_instance;
          case 7:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 7) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function $runSuspendCOROUTINE$_70(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.km9_1 = _this__u8e3s4;
    this.lm9_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_70).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 6;
            this.pm9_1 = this.lm9_1;
            this.mm9_1 = LinkedHashMap_init_$Create$();
            this.om9_1 = this.mm9_1;
            this.qm9_1 = this.pm9_1.l60(this.km9_1.rm9_1.sm7_1.ifq()).m();
            this.f9_1 = 1;
            continue $sm;
          case 1:
            if (!this.qm9_1.n()) {
              this.f9_1 = 5;
              continue $sm;
            }

            var element = this.qm9_1.o();
            this.nm9_1 = element;
            this.f9_1 = 2;
            suspendResult = this.pm9_1.k60(isNatural_0(this.km9_1.rm9_1.um7_1, this.nm9_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            if (suspendResult) {
              this.f9_1 = 3;
              suspendResult = this.pm9_1.k60((new SupertypeGraphAnalyzer(this.nm9_1, this.km9_1.rm9_1.um7_1)).bma(), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.f9_1 = 4;
              continue $sm;
            }

          case 3:
            var ARGUMENT = suspendResult;
            this.om9_1.t2(this.nm9_1, ARGUMENT);
            this.f9_1 = 4;
            continue $sm;
          case 4:
            this.f9_1 = 1;
            continue $sm;
          case 5:
            return this.mm9_1.i3();
          case 6:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 6) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function recordDefinitionCycle($this, path) {
    var tmp0_elvis_lhs = lastOrNull(path);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var repeatedElement = tmp;
    var cycleStartIndex = path.w(repeatedElement);
    var tmp0 = path.g2(cycleStartIndex, get_lastIndex_2(path));
    // Inline function 'kotlin.collections.mapTo' call
    var destination = $this.tm7_1;
    var _iterator__ex2g4s = tmp0.m();
    while (_iterator__ex2g4s.n()) {
      var item = _iterator__ex2g4s.o();
      var tmp$ret$0 = item.cma();
      destination.j(tmp$ret$0);
    }
  }
  function detectDefinitionCycles($this) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new OntologyProcessor$detectDefinitionCycles$$inlined$suspendingQuery$1($this);
  }
  function analyzeSupertypes($this) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new OntologyProcessor$analyzeSupertypes$$inlined$suspendingQuery$1($this);
  }
  function metaOntologyAncestorErrors($this, supertypeAnalyses) {
    // Inline function 'kotlin.collections.mapNotNull' call
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var destination = ArrayList_init_$Create$();
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s = supertypeAnalyses.y().m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      var tmp$ret$3;
      $l$block: {
        // Inline function 'kotlin.collections.component1' call
        var element_0 = element.z();
        // Inline function 'kotlin.collections.component2' call
        var analysis = element.a1();
        if (analysis.jm8_1 || analysis.km8_1) {
          tmp$ret$3 = null;
          break $l$block;
        }
        var tmp0_subject = analysis.lm8_1.p();
        tmp$ret$3 = tmp0_subject === 0 ? new ErrorForAllNode("The element's supertypes do not lead to a metaOntology ancestor.", element_0) : tmp0_subject === 1 ? null : new ErrorForAllNode("More than one metaOntology ancestor was found for the element's supertypes.", element_0);
      }
      var tmp0_safe_receiver = tmp$ret$3;
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        destination.j(tmp0_safe_receiver);
      }
    }
    return destination;
  }
  function OntologyProcessor$recordDefinitionCycle$ref(p0) {
    var l = function (_this__u8e3s4) {
      var tmp0 = p0;
      recordDefinitionCycle(tmp0, _this__u8e3s4);
      return Unit_instance;
    };
    l.callableName = 'recordDefinitionCycle';
    return l;
  }
  function OntologyProcessor$checkErrors$$inlined$suspendingQuery$1(this$0, $rootOntology) {
    this.hm8_1 = this$0;
    this.im8_1 = $rootOntology;
  }
  protoOf(OntologyProcessor$checkErrors$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_68(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(OntologyProcessor$checkErrors$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function OntologyProcessor$detectDefinitionCycles$$inlined$suspendingQuery$1(this$0) {
    this.am9_1 = this$0;
  }
  protoOf(OntologyProcessor$detectDefinitionCycles$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_69(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(OntologyProcessor$detectDefinitionCycles$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function OntologyProcessor$analyzeSupertypes$$inlined$suspendingQuery$1(this$0) {
    this.rm9_1 = this$0;
  }
  protoOf(OntologyProcessor$analyzeSupertypes$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_70(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(OntologyProcessor$analyzeSupertypes$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function OntologyProcessor(ontology) {
    this.sm7_1 = ontology;
    this.tm7_1 = HashSet_init_$Create$();
    var tmp = this;
    tmp.um7_1 = createOntologyHierarchy(OntologyProcessor$recordDefinitionCycle$ref(this));
  }
  protoOf(OntologyProcessor).vm7 = function (rootOntology) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new OntologyProcessor$checkErrors$$inlined$suspendingQuery$1(this, rootOntology);
  };
  function SupertypeTraversalResult(hasCycle, hasUnresolvedReference, metaOntologyAncestors) {
    this.jm8_1 = hasCycle;
    this.km8_1 = hasUnresolvedReference;
    this.lm8_1 = metaOntologyAncestors;
  }
  protoOf(SupertypeTraversalResult).toString = function () {
    return 'SupertypeTraversalResult(hasCycle=' + this.jm8_1 + ', hasUnresolvedReference=' + this.km8_1 + ', metaOntologyAncestors=' + toString_1(this.lm8_1) + ')';
  };
  protoOf(SupertypeTraversalResult).hashCode = function () {
    var result = getBooleanHashCode(this.jm8_1);
    result = imul(result, 31) + getBooleanHashCode(this.km8_1) | 0;
    result = imul(result, 31) + hashCode(this.lm8_1) | 0;
    return result;
  };
  protoOf(SupertypeTraversalResult).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SupertypeTraversalResult))
      return false;
    if (!(this.jm8_1 === other.jm8_1))
      return false;
    if (!(this.km8_1 === other.km8_1))
      return false;
    if (!equals(this.lm8_1, other.lm8_1))
      return false;
    return true;
  };
  function $runSuspendCOROUTINE$_71(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.lma_1 = _this__u8e3s4;
    this.mma_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_71).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 7;
            this.oma_1 = this.mma_1;
            this.qma_1 = this.oma_1.l60(this.lma_1.rma_1.nfs()).m();
            this.f9_1 = 1;
            continue $sm;
          case 1:
            if (!this.qma_1.n()) {
              this.f9_1 = 6;
              continue $sm;
            }

            var element = this.qma_1.o();
            var tmp_0 = this;
            tmp_0.pma_1 = element;
            this.f9_1 = 2;
            continue $sm;
          case 2:
            var relation = this.pma_1;
            this.nma_1 = this.oma_1.l60(relation.zfs());
            if (this.nma_1 == null) {
              this.lma_1.sma_1.zm9_1 = true;
              this.f9_1 = 5;
              continue $sm;
            } else {
              this.f9_1 = 3;
              continue $sm;
            }

          case 3:
            this.f9_1 = 4;
            suspendResult = this.oma_1.k60(resolveSuperElement(this.nma_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            var superElement = suspendResult;
            if (superElement == null) {
              this.lma_1.sma_1.zm9_1 = true;
            } else {
              this.lma_1.sma_1.ym9_1.pf(superElement);
            }

            if (false) {
              this.f9_1 = 2;
              continue $sm;
            }

            this.f9_1 = 5;
            continue $sm;
          case 5:
            this.f9_1 = 1;
            continue $sm;
          case 6:
            return Unit_instance;
          case 7:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 7) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function $runSuspendCOROUTINE$_72(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.bmb_1 = _this__u8e3s4;
    this.cmb_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_72).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 10;
            this.emb_1 = this.cmb_1;
            this.f9_1 = 1;
            suspendResult = this.emb_1.k60(enqueue_0(this.bmb_1.gmb_1, this.bmb_1.gmb_1.sm9_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.f9_1 = 2;
            continue $sm;
          case 2:
            if (!!this.bmb_1.gmb_1.ym9_1.s()) {
              this.f9_1 = 9;
              continue $sm;
            }

            this.dmb_1 = this.bmb_1.gmb_1.ym9_1.sf();
            var tmp_0 = this;
            var tmp0 = get_pointer(this.dmb_1);
            var tmp$ret$0 = Unit_instance;
            l$ret$1: do {
              if (tmp0 == null) {
                var message = 'Required value was null.';
                throw IllegalStateException_init_$Create$_0(toString_1(message));
              } else {
                tmp$ret$0 = tmp0;
                break l$ret$1;
              }
            }
             while (false);
            tmp_0.fmb_1 = tmp$ret$0;
            if (this.fmb_1.equals(this.bmb_1.gmb_1.um9_1)) {
              this.bmb_1.gmb_1.ama_1 = true;
              this.f9_1 = 2;
              continue $sm;
            } else {
              this.f9_1 = 3;
              continue $sm;
            }

          case 3:
            if (!this.bmb_1.gmb_1.xm9_1.j(this.fmb_1)) {
              this.f9_1 = 2;
              continue $sm;
            } else {
              this.f9_1 = 4;
              continue $sm;
            }

          case 4:
            if (this.bmb_1.gmb_1.vm9_1 && isMetaOntologyElement(this.dmb_1)) {
              this.bmb_1.gmb_1.wm9_1.j(this.fmb_1);
              this.f9_1 = 2;
              continue $sm;
            } else {
              this.f9_1 = 5;
              continue $sm;
            }

          case 5:
            this.f9_1 = 6;
            suspendResult = this.emb_1.k60(isNatural_0(this.bmb_1.gmb_1.tm9_1, this.dmb_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 6:
            if (!suspendResult) {
              this.f9_1 = 2;
              continue $sm;
            } else {
              this.f9_1 = 7;
              continue $sm;
            }

          case 7:
            this.f9_1 = 8;
            suspendResult = this.emb_1.k60(enqueue_0(this.bmb_1.gmb_1, this.dmb_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 8:
            this.f9_1 = 2;
            continue $sm;
          case 9:
            return new SupertypeTraversalResult(this.bmb_1.gmb_1.ama_1, this.bmb_1.gmb_1.zm9_1, this.bmb_1.gmb_1.wm9_1);
          case 10:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 10) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function enqueue_0($this, element) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new SupertypeGraphAnalyzer$enqueue$$inlined$suspendingQuery$1(element, $this);
  }
  function SupertypeGraphAnalyzer$enqueue$$inlined$suspendingQuery$1($element, this$0) {
    this.rma_1 = $element;
    this.sma_1 = this$0;
  }
  protoOf(SupertypeGraphAnalyzer$enqueue$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_71(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(SupertypeGraphAnalyzer$enqueue$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function SupertypeGraphAnalyzer$analyze$$inlined$suspendingQuery$1(this$0) {
    this.gmb_1 = this$0;
  }
  protoOf(SupertypeGraphAnalyzer$analyze$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_72(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(SupertypeGraphAnalyzer$analyze$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function SupertypeGraphAnalyzer(startElement, ontologyHierarchy) {
    this.sm9_1 = startElement;
    this.tm9_1 = ontologyHierarchy;
    var tmp = this;
    // Inline function 'kotlin.checkNotNull' call
    var tmp0 = get_pointer(this.sm9_1);
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.checkNotNull' call
      if (tmp0 == null) {
        var message = 'Required value was null.';
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      } else {
        tmp$ret$1 = tmp0;
        break $l$block;
      }
    }
    tmp.um9_1 = tmp$ret$1;
    this.vm9_1 = !isMetaOntologyElement(this.sm9_1);
    var tmp_0 = this;
    // Inline function 'kotlin.collections.hashSetOf' call
    tmp_0.wm9_1 = HashSet_init_$Create$();
    this.xm9_1 = hashSetOf([this.um9_1]);
    this.ym9_1 = ArrayDeque_init_$Create$();
    this.zm9_1 = false;
    this.ama_1 = false;
  }
  protoOf(SupertypeGraphAnalyzer).bma = function () {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new SupertypeGraphAnalyzer$analyze$$inlined$suspendingQuery$1(this);
  };
  function isMetaOntologyElement(element) {
    var tmp = element.t42();
    var tmp0_safe_receiver = (!(tmp == null) ? isInterface(tmp, OntologyLibrary_1) : false) ? tmp : null;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.y2();
    return (tmp1_safe_receiver == null ? null : tmp1_safe_receiver.m5y().w2w()) === 'metaOntology';
  }
  function resolveSuperElement(reference) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new resolveSuperElement$$inlined$suspendingQuery$1(reference);
  }
  function $runSuspendCOROUTINE$_73(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.pmb_1 = _this__u8e3s4;
    this.qmb_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_73).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 3;
            var $this$suspendingQuery = this.qmb_1;
            var tmp0_safe_receiver = this.pmb_1.smb_1.gfq();
            if (tmp0_safe_receiver == null) {
              this.rmb_1 = null;
              this.f9_1 = 2;
              continue $sm;
            } else {
              this.f9_1 = 1;
              suspendResult = $this$suspendingQuery.k60(tmp0_safe_receiver, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            this.rmb_1 = suspendResult;
            this.f9_1 = 2;
            continue $sm;
          case 2:
            return this.rmb_1;
          case 3:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 3) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function resolveSuperElement$$inlined$suspendingQuery$1($reference) {
    this.smb_1 = $reference;
  }
  protoOf(resolveSuperElement$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_73(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(resolveSuperElement$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function OntologyLibraryReference_2(wrapperContext, libraryRef, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(OntologyLibraryReferenceConcept_getInstance().m6n_1) : nodeId;
    return OntologyLibraryReference_3(wrapperContext.m58(Companion_getInstance_93().p6l_1), libraryRef, nodeId);
  }
  function LocalOntologyElementReference_2(wrapperContext, elementRef, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(LocalOntologyElementReferenceConcept_getInstance().m6n_1) : nodeId;
    return LocalOntologyElementReference_3(wrapperContext.m58(Companion_getInstance_93().p6l_1), elementRef, nodeId);
  }
  function OntologyElementReference_2(wrapperContext, elementRef, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(OntologyElementReferenceConcept_getInstance().m6n_1) : nodeId;
    return OntologyElementReference_3(wrapperContext.m58(Companion_getInstance_93().p6l_1), elementRef, nodeId);
  }
  function ConstantPrecondition_1(wrapperContext, kindValue, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ConstantPreconditionConcept_getInstance().m6n_1) : nodeId;
    return ConstantPrecondition_2(wrapperContext.m58(Companion_getInstance_93().p6l_1), kindValue, nodeId);
  }
  function FactReference_2(wrapperContext, refValue, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(FactReferenceConcept_getInstance().m6n_1) : nodeId;
    return FactReference_3(wrapperContext.m58(Companion_getInstance_93().p6l_1), refValue, nodeId);
  }
  function QueryLabelsFactExpressionContainer_1(wrapperContext, expression, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(QueryLabelsFactExpressionContainerConcept_getInstance().m6n_1) : nodeId;
    return QueryLabelsFactExpressionContainer_2(wrapperContext.m58(Companion_getInstance_93().p6l_1), expression, nodeId);
  }
  function ProcessPropertyReference_0(wrapperContext, propertyRef, nodeId) {
    propertyRef = propertyRef === VOID ? null : propertyRef;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ProcessPropertyReferenceConcept_getInstance().m6n_1) : nodeId;
    return ProcessPropertyReference_1(wrapperContext.m58(Companion_getInstance_93().p6l_1), propertyRef, nodeId);
  }
  function NewFactReference_1(wrapperContext, refValue, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(NewFactReferenceConcept_getInstance().m6n_1) : nodeId;
    return NewFactReference_2(wrapperContext.m58(Companion_getInstance_93().p6l_1), refValue, nodeId);
  }
  function RelationFactExpression_2(wrapperContext, refValue, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(RelationFactExpressionConcept_getInstance().m6n_1) : nodeId;
    return RelationFactExpression_3(wrapperContext.m58(Companion_getInstance_93().p6l_1), refValue, nodeId);
  }
  function ModifierFactExpression_1(wrapperContext, refValue, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ModifierFactExpressionConcept_getInstance().m6n_1) : nodeId;
    return ModifierFactExpression_2(wrapperContext.m58(Companion_getInstance_93().p6l_1), refValue, nodeId);
  }
  function ExtensionFieldReference_2(wrapperContext, ref, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ExtensionFieldReferenceConcept_getInstance().m6n_1) : nodeId;
    return ExtensionFieldReference_3(wrapperContext.m58(Companion_getInstance_93().p6l_1), ref, nodeId);
  }
  function ProcessPrerequisite_1(wrapperContext, expression, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ProcessPrerequisiteConcept_getInstance().m6n_1) : nodeId;
    return ProcessPrerequisite_2(wrapperContext.m58(Companion_getInstance_93().p6l_1), expression, nodeId);
  }
  function ProcessEffect_1(wrapperContext, expression, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ProcessEffectConcept_getInstance().m6n_1) : nodeId;
    return ProcessEffect_2(wrapperContext.m58(Companion_getInstance_93().p6l_1), expression, nodeId);
  }
  function SimplePropertyType_0(wrapperContext, notionRef, nodeId) {
    notionRef = notionRef === VOID ? null : notionRef;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(SimplePropertyTypeConcept_getInstance().m6n_1) : nodeId;
    return SimplePropertyType_1(wrapperContext.m58(Companion_getInstance_93().p6l_1), notionRef, nodeId);
  }
  function InstanceRelationValue_0(wrapperContext, refValue, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(InstanceRelationValueConcept_getInstance().m6n_1) : nodeId;
    return InstanceRelationValue_1(wrapperContext.m58(Companion_getInstance_93().p6l_1), refValue, nodeId);
  }
  function LibraryProcessSpecification_2(wrapperContext, notionRef, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(LibraryProcessSpecificationConcept_getInstance().m6n_1) : nodeId;
    return LibraryProcessSpecification_3(wrapperContext.m58(Companion_getInstance_93().p6l_1), notionRef, nodeId);
  }
  function NotionType_1(wrapperContext, notionRef, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(NotionTypeConcept_getInstance().m6n_1) : nodeId;
    return NotionType_2(wrapperContext.m58(Companion_getInstance_93().p6l_1), notionRef, nodeId);
  }
  function OntologyLibraryReference_3(nodeSetupContext, libraryRef, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(OntologyLibraryReferenceConcept_getInstance().m6n_1) : nodeId;
    // Inline function 'kotlin.apply' call
    var this_0 = OntologyLibraryReference_0(nodeSetupContext, nodeId);
    this_0.yfq().f2x(libraryRef);
    return this_0;
  }
  function LocalOntologyElementReference_3(nodeSetupContext, elementRef, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(LocalOntologyElementReferenceConcept_getInstance().m6n_1) : nodeId;
    // Inline function 'kotlin.apply' call
    var this_0 = LocalOntologyElementReference_0(nodeSetupContext, nodeId);
    this_0.gfq().f2x(elementRef);
    return this_0;
  }
  function OntologyElementReference_3(nodeSetupContext, elementRef, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(OntologyElementReferenceConcept_getInstance().m6n_1) : nodeId;
    // Inline function 'kotlin.apply' call
    var this_0 = OntologyElementReference_0(nodeSetupContext, nodeId);
    this_0.gfq().f2x(elementRef);
    return this_0;
  }
  function ConstantPrecondition_2(nodeSetupContext, kindValue, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ConstantPreconditionConcept_getInstance().m6n_1) : nodeId;
    // Inline function 'kotlin.apply' call
    var this_0 = ConstantPrecondition(nodeSetupContext, nodeId);
    this_0.r5a().f2x(kindValue);
    return this_0;
  }
  function FactReference_3(nodeSetupContext, refValue, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(FactReferenceConcept_getInstance().m6n_1) : nodeId;
    // Inline function 'kotlin.apply' call
    var this_0 = FactReference_0(nodeSetupContext, nodeId);
    this_0.yfq().f2x(refValue);
    return this_0;
  }
  function QueryLabelsFactExpressionContainer_2(nodeSetupContext, expression, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(QueryLabelsFactExpressionContainerConcept_getInstance().m6n_1) : nodeId;
    // Inline function 'kotlin.apply' call
    var this_0 = QueryLabelsFactExpressionContainer(nodeSetupContext, nodeId);
    this_0.mfr().f2x(expression);
    return this_0;
  }
  function ProcessPropertyReference_1(nodeSetupContext, propertyRef, nodeId) {
    propertyRef = propertyRef === VOID ? null : propertyRef;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ProcessPropertyReferenceConcept_getInstance().m6n_1) : nodeId;
    // Inline function 'kotlin.apply' call
    var this_0 = ProcessPropertyReferenceConcept_getInstance().d6o(nodeSetupContext, nodeId);
    this_0.q6q().f2x(propertyRef);
    return this_0;
  }
  function NewFactReference_2(nodeSetupContext, refValue, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(NewFactReferenceConcept_getInstance().m6n_1) : nodeId;
    // Inline function 'kotlin.apply' call
    var this_0 = NewFactReference(nodeSetupContext, nodeId);
    this_0.yfq().f2x(refValue);
    return this_0;
  }
  function RelationFactExpression_3(nodeSetupContext, refValue, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(RelationFactExpressionConcept_getInstance().m6n_1) : nodeId;
    // Inline function 'kotlin.apply' call
    var this_0 = RelationFactExpression_0(nodeSetupContext, nodeId);
    this_0.xfq().f2x(refValue);
    return this_0;
  }
  function ModifierFactExpression_2(nodeSetupContext, refValue, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ModifierFactExpressionConcept_getInstance().m6n_1) : nodeId;
    // Inline function 'kotlin.apply' call
    var this_0 = ModifierFactExpression(nodeSetupContext, nodeId);
    this_0.bfs().f2x(refValue);
    return this_0;
  }
  function ExtensionFieldReference_3(nodeSetupContext, ref, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ExtensionFieldReferenceConcept_getInstance().m6n_1) : nodeId;
    // Inline function 'kotlin.apply' call
    var this_0 = ExtensionFieldReference_0(nodeSetupContext, nodeId);
    this_0.tfq().f2x(ref);
    return this_0;
  }
  function ProcessPrerequisite_2(nodeSetupContext, expression, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ProcessPrerequisiteConcept_getInstance().m6n_1) : nodeId;
    // Inline function 'kotlin.apply' call
    var this_0 = ProcessPrerequisite(nodeSetupContext, nodeId);
    this_0.mfr().f2x(expression);
    return this_0;
  }
  function ProcessEffect_2(nodeSetupContext, expression, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(ProcessEffectConcept_getInstance().m6n_1) : nodeId;
    // Inline function 'kotlin.apply' call
    var this_0 = ProcessEffect(nodeSetupContext, nodeId);
    this_0.mfr().f2x(expression);
    return this_0;
  }
  function SimplePropertyType_1(nodeSetupContext, notionRef, nodeId) {
    notionRef = notionRef === VOID ? null : notionRef;
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(SimplePropertyTypeConcept_getInstance().m6n_1) : nodeId;
    // Inline function 'kotlin.apply' call
    var this_0 = SimplePropertyTypeConcept_getInstance().d6o(nodeSetupContext, nodeId);
    this_0.mfq().f2x(notionRef);
    return this_0;
  }
  function InstanceRelationValue_1(nodeSetupContext, refValue, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(InstanceRelationValueConcept_getInstance().m6n_1) : nodeId;
    // Inline function 'kotlin.apply' call
    var this_0 = InstanceRelationValueConcept_getInstance().d6o(nodeSetupContext, nodeId);
    this_0.xfq().f2x(refValue);
    return this_0;
  }
  function LibraryProcessSpecification_3(nodeSetupContext, processRef, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(LibraryProcessSpecificationConcept_getInstance().m6n_1) : nodeId;
    // Inline function 'kotlin.apply' call
    var this_0 = LibraryProcessSpecification_0(nodeSetupContext, nodeId);
    this_0.vfr().f2x(processRef);
    return this_0;
  }
  function NotionType_2(nodeSetupContext, notionRef, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_47.t3o(NotionTypeConcept_getInstance().m6n_1) : nodeId;
    // Inline function 'kotlin.apply' call
    var this_0 = NotionType(nodeSetupContext, nodeId);
    this_0.mfq().f2x(notionRef);
    return this_0;
  }
  function ReferenceAspects() {
    ReferenceAspects_instance = this;
    this.tmb_1 = listOf_0([to(ExtensionFieldReferenceConcept_getInstance().m6n_1, ExtensionFieldReferenceConcept_getInstance().rg9_1), to(EnumValueConcept_getInstance().m6n_1, EnumValueConcept_getInstance().eg8_1), to(FunctionTermConcept_getInstance().m6n_1, FunctionTermConcept_getInstance().vgf_1), to(FactPreconditionConcept_getInstance().m6n_1, FactPreconditionConcept_getInstance().egb_1), to(ImportedLinkConcept_getInstance().m6n_1, ImportedLinkConcept_getInstance().lgi_1), to(ImportedLinkConcept_getInstance().m6n_1, AbstractLinkConcept_getInstance().yfv_1), to(OntologyLinkConcept_getInstance().m6n_1, AbstractLinkConcept_getInstance().yfv_1), to(ImportedPropertyConcept_getInstance().m6n_1, ImportedPropertyConcept_getInstance().ygi_1), to(LibraryProcessSpecificationConcept_getInstance().m6n_1, LibraryProcessSpecificationConcept_getInstance().egm_1), to(MeasurableValueConcept_getInstance().m6n_1, MeasurableValueConcept_getInstance().zgp_1), to(NotionTypeConcept_getInstance().m6n_1, NotionTypeConcept_getInstance().kgv_1), to(SimplePropertyTypeConcept_getInstance().m6n_1, SimplePropertyTypeConcept_getInstance().bht_1), to(OntologyLinkValueConcept_getInstance().m6n_1, OntologyLinkValueConcept_getInstance().ch8_1), to(OntologyElementReferenceConcept_getInstance().m6n_1, OntologyElementReferenceConcept_getInstance().qh1_1), to(OntologyLibraryReferenceConcept_getInstance().m6n_1, OntologyLibraryReferenceConcept_getInstance().oh6_1), to(ProcessDeclarationConcept_getInstance().m6n_1, ProcessDeclarationConcept_getInstance().vhc_1), to(ProcessReferenceConcept_getInstance().m6n_1, ProcessReferenceConcept_getInstance().uhh_1), to(ProcessDeclarationConcept_getInstance().m6n_1, ProcessDeclarationConcept_getInstance().uhc_1), to(PropertyValueConcept_getInstance().m6n_1, PropertyValueConcept_getInstance().thm_1), to(ProcessPropertyValueConcept_getInstance().m6n_1, ProcessPropertyValueConcept_getInstance().fhh_1), to(ProcessPropertyCustomCellConcept_getInstance().m6n_1, ProcessPropertyCustomCellConcept_getInstance().thf_1), to(ProcessPropertyReferenceConcept_getInstance().m6n_1, ProcessPropertyReferenceConcept_getInstance().shg_1), to(PropertyCustomCellConcept_getInstance().m6n_1, PropertyCustomCellConcept_getInstance().ghk_1), to(LinkCustomCellConcept_getInstance().m6n_1, LinkCustomCellConcept_getInstance().lgn_1), to(OntologyImportRootReferenceConcept_getInstance().m6n_1, OntologyImportRootReferenceConcept_getInstance().dh5_1), to(LibraryProcessSpecificationQueryConcept_getInstance().m6n_1, LibraryProcessSpecificationQueryConcept_getInstance().vgm_1), to(LibraryProcessSpecificationQueryConcept_getInstance().m6n_1, LibraryProcessSpecificationQueryConcept_getInstance().ugm_1), to(OntologyLinkDeclarationValueQueryConcept_getInstance().m6n_1, OntologyLinkDeclarationValueQueryConcept_getInstance().ph7_1), to(PropertyDeclarationValueQueryConcept_getInstance().m6n_1, PropertyDeclarationValueQueryConcept_getInstance().fhl_1), to(PublishedSourceReferenceConcept_getInstance().m6n_1, PublishedSourceReferenceConcept_getInstance().shn_1), to(InstanceRelationValueConcept_getInstance().m6n_1, InstanceRelationValueConcept_getInstance().pgk_1), to(FactReferenceConcept_getInstance().m6n_1, FactReferenceConcept_getInstance().tgb_1), to(VariableReferenceValueConcept_getInstance().m6n_1, VariableReferenceValueConcept_getInstance().xhx_1), to(LocalOntologyElementReferenceConcept_getInstance().m6n_1, LocalOntologyElementReferenceConcept_getInstance().agp_1), to(ModifierFactExpressionConcept_getInstance().m6n_1, ModifierFactExpressionConcept_getInstance().mgr_1), to(RelationFactExpressionConcept_getInstance().m6n_1, RelationFactExpressionConcept_getInstance().lhr_1), to(NewFactReferenceConcept_getInstance().m6n_1, NewFactReferenceConcept_getInstance().lgu_1), to(PropertyConstraintConcept_getInstance().m6n_1, PropertyConstraintConcept_getInstance().ohj_1), to(ObjectPropertyDeclarationConcept_getInstance().m6n_1, ObjectPropertyDeclarationConcept_getInstance().jgw_1), to(ObjectPropertyDeclarationConcept_getInstance().m6n_1, ObjectPropertyDeclarationConcept_getInstance().ngw_1), to(PropertyReferenceOperationConcept_getInstance().m6n_1, PropertyReferenceOperationConcept_getInstance().ehm_1)]);
    var tmp = this;
    // Inline function 'kotlin.collections.groupBy' call
    var tmp0 = this.tmb_1;
    // Inline function 'kotlin.collections.groupByTo' call
    var destination = LinkedHashMap_init_$Create$();
    var _iterator__ex2g4s = tmp0.m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      var key = element.pg_1;
      // Inline function 'kotlin.collections.getOrPut' call
      var value = destination.q2(key);
      var tmp_0;
      if (value == null) {
        var answer = ArrayList_init_$Create$();
        destination.t2(key, answer);
        tmp_0 = answer;
      } else {
        tmp_0 = value;
      }
      var list = tmp_0;
      var tmp$ret$3 = element.qg_1;
      list.j(tmp$ret$3);
    }
    tmp.umb_1 = destination;
  }
  protoOf(ReferenceAspects).vmb = function (nodeConceptId) {
    var tmp0_elvis_lhs = this.umb_1.q2(nodeConceptId);
    return tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
  };
  var ReferenceAspects_instance;
  function ReferenceAspects_getInstance() {
    if (ReferenceAspects_instance == null)
      new ReferenceAspects();
    return ReferenceAspects_instance;
  }
  function SuperElementUsage(node, usedElement, kind) {
    OntologyElementRelatedToAnotherElementUsage.call(this);
    this.wmb_1 = node;
    this.xmb_1 = usedElement;
    this.ymb_1 = kind;
  }
  protoOf(SuperElementUsage).w85 = function () {
    return this.wmb_1;
  };
  protoOf(SuperElementUsage).zmb = function () {
    return this.xmb_1;
  };
  function PartOfElementUsage(node, usedElement, kind) {
    OntologyElementRelatedToAnotherElementUsage.call(this);
    this.amc_1 = node;
    this.bmc_1 = usedElement;
    this.cmc_1 = kind;
  }
  protoOf(PartOfElementUsage).w85 = function () {
    return this.amc_1;
  };
  protoOf(PartOfElementUsage).zmb = function () {
    return this.bmc_1;
  };
  function ElementsTaxonUsage(node, taxonElement, kind) {
    OntologyElementUsageByAnotherElement.call(this);
    this.dmc_1 = node;
    this.emc_1 = taxonElement;
    this.fmc_1 = kind;
  }
  protoOf(ElementsTaxonUsage).w85 = function () {
    return this.dmc_1;
  };
  function CategoryOntologyUsage(node, kind) {
    UsagePresentationData.call(this);
    this.gmc_1 = node;
    this.hmc_1 = kind;
  }
  function FactSetContextOntologyUsage(node, context) {
    UsagePresentationData.call(this);
    this.imc_1 = node;
    this.jmc_1 = context;
  }
  function SomethingAsVariableSpecUsage(node) {
    UsagePresentationData.call(this);
    this.kmc_1 = node;
  }
  function AnyUsageInFact(node) {
    UsagePresentationData.call(this);
    this.lmc_1 = node;
  }
  function ProcessKindUsage(node) {
    UsageInProcess.call(this, node);
  }
  function ExtendedProcessUsage(node) {
    UsageInProcess.call(this, node);
  }
  function OntologyElementInBindingDeclarationUsage(node, elementType, kind) {
    UsageInBindingDeclaration.call(this, node);
    this.omc_1 = elementType;
    this.pmc_1 = kind;
  }
  function InheritedProcessUsage(node, inherited) {
    UsageInProcess.call(this, node);
    this.smc_1 = inherited;
  }
  function AnythingInsideCustomEditorUsage(node, cell) {
    UsageInBindingDeclaration.call(this, node);
    this.umc_1 = cell;
  }
  function AliasedBindingPropertyUsage(node, property, aliasedProperty) {
    UsageInBindingProperty.call(this);
    this.vmc_1 = node;
    this.wmc_1 = property;
    this.xmc_1 = aliasedProperty;
  }
  function PropertyTypeUsage(node, property) {
    UsageInBindingProperty.call(this);
    this.ymc_1 = node;
    this.zmc_1 = property;
  }
  function OldPropertyTypeNotionUsage(node, property) {
    UsageInBindingDeclaration.call(this, node);
    this.bmd_1 = property;
  }
  function OldLinkOntologyUsage(node, link) {
    UsageInBindingDeclaration.call(this, node);
    this.dmd_1 = link;
  }
  function OntologyInFunctionReturnTypeUsage(node, kind) {
    UsagePresentationData.call(this);
    this.emd_1 = node;
    this.fmd_1 = kind;
  }
  function OldImportedPropertyUsage(node, importedProperty) {
    UsageInBindingDeclaration.call(this, node);
    this.hmd_1 = importedProperty;
  }
  function OldImportedLinkUsage(node, importedLink) {
    UsageInBindingDeclaration.call(this, node);
    this.jmd_1 = importedLink;
  }
  function InOntologyImportForOntologyUsage(node, kind) {
    UsageInOntologyImport.call(this, node);
    this.lmd_1 = kind;
  }
  protoOf(InOntologyImportForOntologyUsage).mmd = function () {
    return 'replaced hierarchy:';
  };
  function InOntologyImportOntologyToUseUsage(node) {
    UsageInOntologyImport.call(this, node);
  }
  protoOf(InOntologyImportOntologyToUseUsage).mmd = function () {
    return 'ontology to use:';
  };
  function OntologyInExtensionTypeUsage(node, kind) {
    UsagePresentationData.call(this);
    this.pmd_1 = node;
    this.qmd_1 = kind;
  }
  function OntologyInExtensionFieldUsage(node, field, kind) {
    UsagePresentationData.call(this);
    this.rmd_1 = node;
    this.smd_1 = field;
    this.tmd_1 = kind;
  }
  function ImportOntologyImportRootUsage(node) {
    UsagePresentationData.call(this);
    this.umd_1 = node;
  }
  function PublishedSourceUsage(node) {
    UsagePresentationData.call(this);
    this.vmd_1 = node;
  }
  function TypeOfOldPropertyDeclarationUsage(node) {
    UsagePresentationData.call(this);
    this.wmd_1 = node;
  }
  function TypeOfOldLinkDeclarationUsage(node, kind) {
    UsagePresentationData.call(this);
    this.xmd_1 = node;
  }
  function OldLinkSpecializesLinkUsage(node, link) {
    UsageInBindingDeclaration.call(this, node);
    this.zmd_1 = link;
  }
  function ObjectPropertyUsageByAnotherProperty(node, kind) {
    UsagePresentationData.call(this);
    this.ame_1 = node;
    this.bme_1 = kind;
  }
  var ObjectPropertyUsageByAnotherPropertyKind_SUPER_PROPERTY_instance;
  var ObjectPropertyUsageByAnotherPropertyKind_INVERSE_PROPERTY_instance;
  var ObjectPropertyUsageByAnotherPropertyKind_entriesInitialized;
  function ObjectPropertyUsageByAnotherPropertyKind_initEntries() {
    if (ObjectPropertyUsageByAnotherPropertyKind_entriesInitialized)
      return Unit_instance;
    ObjectPropertyUsageByAnotherPropertyKind_entriesInitialized = true;
    ObjectPropertyUsageByAnotherPropertyKind_SUPER_PROPERTY_instance = new ObjectPropertyUsageByAnotherPropertyKind('SUPER_PROPERTY', 0);
    ObjectPropertyUsageByAnotherPropertyKind_INVERSE_PROPERTY_instance = new ObjectPropertyUsageByAnotherPropertyKind('INVERSE_PROPERTY', 1);
  }
  function ObjectPropertyUsageByAnotherPropertyKind(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function OntologyElementRelatedToAnotherElementUsage() {
    OntologyElementUsageByAnotherElement.call(this);
  }
  function OntologyElementUsageByAnotherElement() {
    UsagePresentationData.call(this);
  }
  function UsageInOntologyImport(node) {
    UsagePresentationData.call(this);
    this.nmd_1 = node;
  }
  protoOf(UsageInOntologyImport).w85 = function () {
    return this.nmd_1;
  };
  var OntologyTargetKind_ELEMENT_instance;
  var OntologyTargetKind_ONTOLOGY_instance;
  var OntologyTargetKind_entriesInitialized;
  function OntologyTargetKind_initEntries() {
    if (OntologyTargetKind_entriesInitialized)
      return Unit_instance;
    OntologyTargetKind_entriesInitialized = true;
    OntologyTargetKind_ELEMENT_instance = new OntologyTargetKind('ELEMENT', 0);
    OntologyTargetKind_ONTOLOGY_instance = new OntologyTargetKind('ONTOLOGY', 1);
  }
  function OntologyTargetKind(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function UsageInProcess(node) {
    UsagePresentationData.call(this);
    this.mmc_1 = node;
  }
  protoOf(UsageInProcess).w85 = function () {
    return this.mmc_1;
  };
  function UsageInBindingDeclaration(node) {
    UsagePresentationData.call(this);
    this.qmc_1 = node;
  }
  protoOf(UsageInBindingDeclaration).w85 = function () {
    return this.qmc_1;
  };
  function UsageInBindingProperty() {
    UsagePresentationData.call(this);
  }
  function SuperElementUsageKind() {
    SuperElementUsageKind_instance = this;
    UsageKind.call(this, 'superElement');
  }
  var SuperElementUsageKind_instance;
  function SuperElementUsageKind_getInstance() {
    if (SuperElementUsageKind_instance == null)
      new SuperElementUsageKind();
    return SuperElementUsageKind_instance;
  }
  function OntologyInSuperElementUsageKind() {
    OntologyInSuperElementUsageKind_instance = this;
    UsageKind.call(this, 'ontologyInSuperElement');
  }
  var OntologyInSuperElementUsageKind_instance;
  function OntologyInSuperElementUsageKind_getInstance() {
    if (OntologyInSuperElementUsageKind_instance == null)
      new OntologyInSuperElementUsageKind();
    return OntologyInSuperElementUsageKind_instance;
  }
  function PartOfElementUsageKind() {
    PartOfElementUsageKind_instance = this;
    UsageKind.call(this, 'partOfElement');
  }
  var PartOfElementUsageKind_instance;
  function PartOfElementUsageKind_getInstance() {
    if (PartOfElementUsageKind_instance == null)
      new PartOfElementUsageKind();
    return PartOfElementUsageKind_instance;
  }
  function OntologyInPartOfElementUsageKind() {
    OntologyInPartOfElementUsageKind_instance = this;
    UsageKind.call(this, 'ontologyInPartOfElement');
  }
  var OntologyInPartOfElementUsageKind_instance;
  function OntologyInPartOfElementUsageKind_getInstance() {
    if (OntologyInPartOfElementUsageKind_instance == null)
      new OntologyInPartOfElementUsageKind();
    return OntologyInPartOfElementUsageKind_instance;
  }
  function ElementsTaxonUsageKind() {
    ElementsTaxonUsageKind_instance = this;
    UsageKind.call(this, 'elementsTaxon');
  }
  var ElementsTaxonUsageKind_instance;
  function ElementsTaxonUsageKind_getInstance() {
    if (ElementsTaxonUsageKind_instance == null)
      new ElementsTaxonUsageKind();
    return ElementsTaxonUsageKind_instance;
  }
  function OntologyInElementsTaxonUsageKind() {
    OntologyInElementsTaxonUsageKind_instance = this;
    UsageKind.call(this, 'ontologyInElementsTaxon');
  }
  var OntologyInElementsTaxonUsageKind_instance;
  function OntologyInElementsTaxonUsageKind_getInstance() {
    if (OntologyInElementsTaxonUsageKind_instance == null)
      new OntologyInElementsTaxonUsageKind();
    return OntologyInElementsTaxonUsageKind_instance;
  }
  function OntologyInCategoryUsageKind() {
    OntologyInCategoryUsageKind_instance = this;
    UsageKind.call(this, 'ontologyInCategory');
  }
  var OntologyInCategoryUsageKind_instance;
  function OntologyInCategoryUsageKind_getInstance() {
    if (OntologyInCategoryUsageKind_instance == null)
      new OntologyInCategoryUsageKind();
    return OntologyInCategoryUsageKind_instance;
  }
  function ElementInCategoryUsageKind() {
    ElementInCategoryUsageKind_instance = this;
    UsageKind.call(this, 'elementInCategory');
  }
  var ElementInCategoryUsageKind_instance;
  function ElementInCategoryUsageKind_getInstance() {
    if (ElementInCategoryUsageKind_instance == null)
      new ElementInCategoryUsageKind();
    return ElementInCategoryUsageKind_instance;
  }
  function ElementInFactSetContextUsageKind() {
    ElementInFactSetContextUsageKind_instance = this;
    UsageKind.call(this, 'elementInFactSetContext');
  }
  var ElementInFactSetContextUsageKind_instance;
  function ElementInFactSetContextUsageKind_getInstance() {
    if (ElementInFactSetContextUsageKind_instance == null)
      new ElementInFactSetContextUsageKind();
    return ElementInFactSetContextUsageKind_instance;
  }
  function OntologyInFactSetContextUsageKind() {
    OntologyInFactSetContextUsageKind_instance = this;
    UsageKind.call(this, 'ontologyInFactSetContext');
  }
  var OntologyInFactSetContextUsageKind_instance;
  function OntologyInFactSetContextUsageKind_getInstance() {
    if (OntologyInFactSetContextUsageKind_instance == null)
      new OntologyInFactSetContextUsageKind();
    return OntologyInFactSetContextUsageKind_instance;
  }
  function AnythingInsideFactUsageKind() {
    AnythingInsideFactUsageKind_instance = this;
    UsageKind.call(this, 'anyUsageInsideFact');
  }
  var AnythingInsideFactUsageKind_instance;
  function AnythingInsideFactUsageKind_getInstance() {
    if (AnythingInsideFactUsageKind_instance == null)
      new AnythingInsideFactUsageKind();
    return AnythingInsideFactUsageKind_instance;
  }
  function SomethingAsVariableSpecUsageKind() {
    SomethingAsVariableSpecUsageKind_instance = this;
    UsageKind.call(this, 'variableType');
  }
  var SomethingAsVariableSpecUsageKind_instance;
  function SomethingAsVariableSpecUsageKind_getInstance() {
    if (SomethingAsVariableSpecUsageKind_instance == null)
      new SomethingAsVariableSpecUsageKind();
    return SomethingAsVariableSpecUsageKind_instance;
  }
  function ProcessKindUsageKind() {
    ProcessKindUsageKind_instance = this;
    UsageKind.call(this, 'processKind');
  }
  var ProcessKindUsageKind_instance;
  function ProcessKindUsageKind_getInstance() {
    if (ProcessKindUsageKind_instance == null)
      new ProcessKindUsageKind();
    return ProcessKindUsageKind_instance;
  }
  function ExtendedProcessUsageKind() {
    ExtendedProcessUsageKind_instance = this;
    UsageKind.call(this, 'extendedProcess');
  }
  var ExtendedProcessUsageKind_instance;
  function ExtendedProcessUsageKind_getInstance() {
    if (ExtendedProcessUsageKind_instance == null)
      new ExtendedProcessUsageKind();
    return ExtendedProcessUsageKind_instance;
  }
  function InheritedProcessUsageKind() {
    InheritedProcessUsageKind_instance = this;
    UsageKind.call(this, 'inheritedProcess');
  }
  var InheritedProcessUsageKind_instance;
  function InheritedProcessUsageKind_getInstance() {
    if (InheritedProcessUsageKind_instance == null)
      new InheritedProcessUsageKind();
    return InheritedProcessUsageKind_instance;
  }
  function FunctionReturnTypeOntologyUsageKind() {
    FunctionReturnTypeOntologyUsageKind_instance = this;
    UsageKind.call(this, 'ontologyInFunctionReturnType');
  }
  var FunctionReturnTypeOntologyUsageKind_instance;
  function FunctionReturnTypeOntologyUsageKind_getInstance() {
    if (FunctionReturnTypeOntologyUsageKind_instance == null)
      new FunctionReturnTypeOntologyUsageKind();
    return FunctionReturnTypeOntologyUsageKind_instance;
  }
  function FunctionReturnTypeOntologyElementUsageKind() {
    FunctionReturnTypeOntologyElementUsageKind_instance = this;
    UsageKind.call(this, 'ontologyElementInFunctionReturnType');
  }
  var FunctionReturnTypeOntologyElementUsageKind_instance;
  function FunctionReturnTypeOntologyElementUsageKind_getInstance() {
    if (FunctionReturnTypeOntologyElementUsageKind_instance == null)
      new FunctionReturnTypeOntologyElementUsageKind();
    return FunctionReturnTypeOntologyElementUsageKind_instance;
  }
  function AnythingInsideCustomEditorUsageKind() {
    AnythingInsideCustomEditorUsageKind_instance = this;
    UsageKind.call(this, 'anythingInsideCustomEditor');
  }
  var AnythingInsideCustomEditorUsageKind_instance;
  function AnythingInsideCustomEditorUsageKind_getInstance() {
    if (AnythingInsideCustomEditorUsageKind_instance == null)
      new AnythingInsideCustomEditorUsageKind();
    return AnythingInsideCustomEditorUsageKind_instance;
  }
  function OntologyElementInAbstractBindingElementsUsageKind() {
    OntologyElementInAbstractBindingElementsUsageKind_instance = this;
    UsageKind.call(this, 'ontologyElementInBindingDeclElementsUsageKind');
  }
  var OntologyElementInAbstractBindingElementsUsageKind_instance;
  function OntologyElementInAbstractBindingElementsUsageKind_getInstance() {
    if (OntologyElementInAbstractBindingElementsUsageKind_instance == null)
      new OntologyElementInAbstractBindingElementsUsageKind();
    return OntologyElementInAbstractBindingElementsUsageKind_instance;
  }
  function OntologyInAbstractBindingElementsUsageKind() {
    OntologyInAbstractBindingElementsUsageKind_instance = this;
    UsageKind.call(this, 'ontologyInBindingDeclElementsUsageKind');
  }
  var OntologyInAbstractBindingElementsUsageKind_instance;
  function OntologyInAbstractBindingElementsUsageKind_getInstance() {
    if (OntologyInAbstractBindingElementsUsageKind_instance == null)
      new OntologyInAbstractBindingElementsUsageKind();
    return OntologyInAbstractBindingElementsUsageKind_instance;
  }
  function AliasedPropertyUsageKind() {
    AliasedPropertyUsageKind_instance = this;
    UsageKind.call(this, 'propertyAlias');
  }
  var AliasedPropertyUsageKind_instance;
  function AliasedPropertyUsageKind_getInstance() {
    if (AliasedPropertyUsageKind_instance == null)
      new AliasedPropertyUsageKind();
    return AliasedPropertyUsageKind_instance;
  }
  function PropertyTypeOntologyUsageKind() {
    PropertyTypeOntologyUsageKind_instance = this;
    UsageKind.call(this, 'ontologyInPropertyType');
  }
  var PropertyTypeOntologyUsageKind_instance;
  function PropertyTypeOntologyUsageKind_getInstance() {
    if (PropertyTypeOntologyUsageKind_instance == null)
      new PropertyTypeOntologyUsageKind();
    return PropertyTypeOntologyUsageKind_instance;
  }
  function PropertyTypeOntologyElementUsageKind() {
    PropertyTypeOntologyElementUsageKind_instance = this;
    UsageKind.call(this, 'ontologyElementInPropertyType');
  }
  var PropertyTypeOntologyElementUsageKind_instance;
  function PropertyTypeOntologyElementUsageKind_getInstance() {
    if (PropertyTypeOntologyElementUsageKind_instance == null)
      new PropertyTypeOntologyElementUsageKind();
    return PropertyTypeOntologyElementUsageKind_instance;
  }
  function PropertyTypeNotionUsageKind() {
    PropertyTypeNotionUsageKind_instance = this;
    UsageKind.call(this, 'notionAsPropertyType');
  }
  var PropertyTypeNotionUsageKind_instance;
  function PropertyTypeNotionUsageKind_getInstance() {
    if (PropertyTypeNotionUsageKind_instance == null)
      new PropertyTypeNotionUsageKind();
    return PropertyTypeNotionUsageKind_instance;
  }
  function OldPropertyTypeNotionUsageKind() {
    OldPropertyTypeNotionUsageKind_instance = this;
    UsageKind.call(this, 'notionAsOldPropertyType');
  }
  var OldPropertyTypeNotionUsageKind_instance;
  function OldPropertyTypeNotionUsageKind_getInstance() {
    if (OldPropertyTypeNotionUsageKind_instance == null)
      new OldPropertyTypeNotionUsageKind();
    return OldPropertyTypeNotionUsageKind_instance;
  }
  function OldImportedPropertyUsageKind() {
    OldImportedPropertyUsageKind_instance = this;
    UsageKind.call(this, 'oldImportedProperty');
  }
  var OldImportedPropertyUsageKind_instance;
  function OldImportedPropertyUsageKind_getInstance() {
    if (OldImportedPropertyUsageKind_instance == null)
      new OldImportedPropertyUsageKind();
    return OldImportedPropertyUsageKind_instance;
  }
  function OldLinkOntologyUsageKind() {
    OldLinkOntologyUsageKind_instance = this;
    UsageKind.call(this, 'ontologyInOldLink');
  }
  var OldLinkOntologyUsageKind_instance;
  function OldLinkOntologyUsageKind_getInstance() {
    if (OldLinkOntologyUsageKind_instance == null)
      new OldLinkOntologyUsageKind();
    return OldLinkOntologyUsageKind_instance;
  }
  function OldLinkOntologyElementUsageKind() {
    OldLinkOntologyElementUsageKind_instance = this;
    UsageKind.call(this, 'ontologyElementInOldLink');
  }
  var OldLinkOntologyElementUsageKind_instance;
  function OldLinkOntologyElementUsageKind_getInstance() {
    if (OldLinkOntologyElementUsageKind_instance == null)
      new OldLinkOntologyElementUsageKind();
    return OldLinkOntologyElementUsageKind_instance;
  }
  function OldImportedLinkUsageKind() {
    OldImportedLinkUsageKind_instance = this;
    UsageKind.call(this, 'oldImportedLink');
  }
  var OldImportedLinkUsageKind_instance;
  function OldImportedLinkUsageKind_getInstance() {
    if (OldImportedLinkUsageKind_instance == null)
      new OldImportedLinkUsageKind();
    return OldImportedLinkUsageKind_instance;
  }
  function OldLinkSpecializesLinkUsageKind() {
    OldLinkSpecializesLinkUsageKind_instance = this;
    UsageKind.call(this, 'oldLinkSpecializesLink');
  }
  var OldLinkSpecializesLinkUsageKind_instance;
  function OldLinkSpecializesLinkUsageKind_getInstance() {
    if (OldLinkSpecializesLinkUsageKind_instance == null)
      new OldLinkSpecializesLinkUsageKind();
    return OldLinkSpecializesLinkUsageKind_instance;
  }
  function InOntologyImportForOntologyUsageKind() {
    InOntologyImportForOntologyUsageKind_instance = this;
    UsageKind.call(this, 'inOntologyImportForOntology');
  }
  var InOntologyImportForOntologyUsageKind_instance;
  function InOntologyImportForOntologyUsageKind_getInstance() {
    if (InOntologyImportForOntologyUsageKind_instance == null)
      new InOntologyImportForOntologyUsageKind();
    return InOntologyImportForOntologyUsageKind_instance;
  }
  function InOntologyImportForOntologyElementUsageKind() {
    InOntologyImportForOntologyElementUsageKind_instance = this;
    UsageKind.call(this, 'inOntologyImportForOntologyElement');
  }
  var InOntologyImportForOntologyElementUsageKind_instance;
  function InOntologyImportForOntologyElementUsageKind_getInstance() {
    if (InOntologyImportForOntologyElementUsageKind_instance == null)
      new InOntologyImportForOntologyElementUsageKind();
    return InOntologyImportForOntologyElementUsageKind_instance;
  }
  function InOntologyImportOntologyToUseUsageKind() {
    InOntologyImportOntologyToUseUsageKind_instance = this;
    UsageKind.call(this, 'inOntologyImportOntologyToUse');
  }
  var InOntologyImportOntologyToUseUsageKind_instance;
  function InOntologyImportOntologyToUseUsageKind_getInstance() {
    if (InOntologyImportOntologyToUseUsageKind_instance == null)
      new InOntologyImportOntologyToUseUsageKind();
    return InOntologyImportOntologyToUseUsageKind_instance;
  }
  function ExtensionTypeOntologyUsageKind() {
    ExtensionTypeOntologyUsageKind_instance = this;
    UsageKind.call(this, 'extensionTypeOntologyUsageKind');
  }
  var ExtensionTypeOntologyUsageKind_instance;
  function ExtensionTypeOntologyUsageKind_getInstance() {
    if (ExtensionTypeOntologyUsageKind_instance == null)
      new ExtensionTypeOntologyUsageKind();
    return ExtensionTypeOntologyUsageKind_instance;
  }
  function ExtensionTypeOntologyElementUsageKind() {
    ExtensionTypeOntologyElementUsageKind_instance = this;
    UsageKind.call(this, 'extensionTypeOntologyElementUsageKind');
  }
  var ExtensionTypeOntologyElementUsageKind_instance;
  function ExtensionTypeOntologyElementUsageKind_getInstance() {
    if (ExtensionTypeOntologyElementUsageKind_instance == null)
      new ExtensionTypeOntologyElementUsageKind();
    return ExtensionTypeOntologyElementUsageKind_instance;
  }
  function ExtensionFieldOntologyUsageKind() {
    ExtensionFieldOntologyUsageKind_instance = this;
    UsageKind.call(this, 'extensionFieldOntologyUsageKind');
  }
  var ExtensionFieldOntologyUsageKind_instance;
  function ExtensionFieldOntologyUsageKind_getInstance() {
    if (ExtensionFieldOntologyUsageKind_instance == null)
      new ExtensionFieldOntologyUsageKind();
    return ExtensionFieldOntologyUsageKind_instance;
  }
  function ExtensionFieldOntologyElementUsageKind() {
    ExtensionFieldOntologyElementUsageKind_instance = this;
    UsageKind.call(this, 'extensionFieldOntologyElementUsageKind');
  }
  var ExtensionFieldOntologyElementUsageKind_instance;
  function ExtensionFieldOntologyElementUsageKind_getInstance() {
    if (ExtensionFieldOntologyElementUsageKind_instance == null)
      new ExtensionFieldOntologyElementUsageKind();
    return ExtensionFieldOntologyElementUsageKind_instance;
  }
  function ImportOntologyImportRootUsageKind() {
    ImportOntologyImportRootUsageKind_instance = this;
    UsageKind.call(this, 'importOntologyImportRoot');
  }
  var ImportOntologyImportRootUsageKind_instance;
  function ImportOntologyImportRootUsageKind_getInstance() {
    if (ImportOntologyImportRootUsageKind_instance == null)
      new ImportOntologyImportRootUsageKind();
    return ImportOntologyImportRootUsageKind_instance;
  }
  function TypeOfOldPropertyNotionUsageKind() {
    TypeOfOldPropertyNotionUsageKind_instance = this;
    UsageKind.call(this, 'oldPropertyNotionTypeUsageKind');
  }
  var TypeOfOldPropertyNotionUsageKind_instance;
  function TypeOfOldPropertyNotionUsageKind_getInstance() {
    if (TypeOfOldPropertyNotionUsageKind_instance == null)
      new TypeOfOldPropertyNotionUsageKind();
    return TypeOfOldPropertyNotionUsageKind_instance;
  }
  function TypeOfOldLinkOntologyUsageKind() {
    TypeOfOldLinkOntologyUsageKind_instance = this;
    UsageKind.call(this, 'oldLinkOntologyInTypeUsageKind');
  }
  var TypeOfOldLinkOntologyUsageKind_instance;
  function TypeOfOldLinkOntologyUsageKind_getInstance() {
    if (TypeOfOldLinkOntologyUsageKind_instance == null)
      new TypeOfOldLinkOntologyUsageKind();
    return TypeOfOldLinkOntologyUsageKind_instance;
  }
  function TypeOfOldLinkOntologyElementUsageKind() {
    TypeOfOldLinkOntologyElementUsageKind_instance = this;
    UsageKind.call(this, 'oldLinkOntologyElementInTypeUsageKind');
  }
  var TypeOfOldLinkOntologyElementUsageKind_instance;
  function TypeOfOldLinkOntologyElementUsageKind_getInstance() {
    if (TypeOfOldLinkOntologyElementUsageKind_instance == null)
      new TypeOfOldLinkOntologyElementUsageKind();
    return TypeOfOldLinkOntologyElementUsageKind_instance;
  }
  function SuperPropertyUsageKind() {
    SuperPropertyUsageKind_instance = this;
    UsageKind.call(this, 'superPropertyUsageKind');
  }
  var SuperPropertyUsageKind_instance;
  function SuperPropertyUsageKind_getInstance() {
    if (SuperPropertyUsageKind_instance == null)
      new SuperPropertyUsageKind();
    return SuperPropertyUsageKind_instance;
  }
  function InversePropertyUsageKind() {
    InversePropertyUsageKind_instance = this;
    UsageKind.call(this, 'inversePropertyUsageKind');
  }
  var InversePropertyUsageKind_instance;
  function InversePropertyUsageKind_getInstance() {
    if (InversePropertyUsageKind_instance == null)
      new InversePropertyUsageKind();
    return InversePropertyUsageKind_instance;
  }
  function PublishedSourceUsageKind() {
    PublishedSourceUsageKind_instance = this;
    UsageKind.call(this, 'publishedSourceUsageKind');
  }
  var PublishedSourceUsageKind_instance;
  function PublishedSourceUsageKind_getInstance() {
    if (PublishedSourceUsageKind_instance == null)
      new PublishedSourceUsageKind();
    return PublishedSourceUsageKind_instance;
  }
  function ObjectPropertyUsageByAnotherPropertyKind_SUPER_PROPERTY_getInstance() {
    ObjectPropertyUsageByAnotherPropertyKind_initEntries();
    return ObjectPropertyUsageByAnotherPropertyKind_SUPER_PROPERTY_instance;
  }
  function ObjectPropertyUsageByAnotherPropertyKind_INVERSE_PROPERTY_getInstance() {
    ObjectPropertyUsageByAnotherPropertyKind_initEntries();
    return ObjectPropertyUsageByAnotherPropertyKind_INVERSE_PROPERTY_instance;
  }
  function OntologyTargetKind_ELEMENT_getInstance() {
    OntologyTargetKind_initEntries();
    return OntologyTargetKind_ELEMENT_instance;
  }
  function OntologyTargetKind_ONTOLOGY_getInstance() {
    OntologyTargetKind_initEntries();
    return OntologyTargetKind_ONTOLOGY_instance;
  }
  function btbFindUsages(_this__u8e3s4) {
    findUsages(_this__u8e3s4, btbFindUsages$lambda);
  }
  function btbFindUsages$lambda($this$findUsages) {
    usageKinds($this$findUsages, [SuperElementUsageKind_getInstance(), OntologyInSuperElementUsageKind_getInstance(), PartOfElementUsageKind_getInstance(), OntologyInPartOfElementUsageKind_getInstance(), ElementsTaxonUsageKind_getInstance(), OntologyInElementsTaxonUsageKind_getInstance()]);
    usageKinds($this$findUsages, [OntologyInCategoryUsageKind_getInstance(), ElementInCategoryUsageKind_getInstance(), ElementInFactSetContextUsageKind_getInstance(), OntologyInFactSetContextUsageKind_getInstance()]);
    usageKinds($this$findUsages, [AnythingInsideFactUsageKind_getInstance(), SomethingAsVariableSpecUsageKind_getInstance()]);
    usageKinds($this$findUsages, [ProcessKindUsageKind_getInstance(), ExtendedProcessUsageKind_getInstance(), InheritedProcessUsageKind_getInstance()]);
    usageKinds($this$findUsages, [FunctionReturnTypeOntologyUsageKind_getInstance(), FunctionReturnTypeOntologyElementUsageKind_getInstance()]);
    usageKinds($this$findUsages, [AnythingInsideCustomEditorUsageKind_getInstance(), OntologyElementInAbstractBindingElementsUsageKind_getInstance(), OntologyInAbstractBindingElementsUsageKind_getInstance(), AliasedPropertyUsageKind_getInstance(), PropertyTypeOntologyUsageKind_getInstance(), PropertyTypeOntologyElementUsageKind_getInstance(), PropertyTypeNotionUsageKind_getInstance(), OldPropertyTypeNotionUsageKind_getInstance(), OldImportedPropertyUsageKind_getInstance(), OldLinkOntologyUsageKind_getInstance(), OldLinkOntologyElementUsageKind_getInstance(), OldImportedLinkUsageKind_getInstance(), OldLinkSpecializesLinkUsageKind_getInstance()]);
    usageKinds($this$findUsages, [InOntologyImportForOntologyUsageKind_getInstance(), InOntologyImportForOntologyElementUsageKind_getInstance(), InOntologyImportOntologyToUseUsageKind_getInstance()]);
    usageKinds($this$findUsages, [ExtensionTypeOntologyUsageKind_getInstance(), ExtensionTypeOntologyElementUsageKind_getInstance(), ExtensionFieldOntologyUsageKind_getInstance(), ExtensionFieldOntologyElementUsageKind_getInstance()]);
    $this$findUsages.g85(ImportOntologyImportRootUsageKind_getInstance());
    usageKinds($this$findUsages, [TypeOfOldPropertyNotionUsageKind_getInstance(), TypeOfOldLinkOntologyUsageKind_getInstance(), TypeOfOldLinkOntologyElementUsageKind_getInstance()]);
    usageKinds($this$findUsages, [SuperPropertyUsageKind_getInstance(), InversePropertyUsageKind_getInstance()]);
    // Inline function 'jetbrains.ocelot.langDef.usages.ruleFor' call
    var body = btbFindUsages$lambda$lambda;
    $this$findUsages.t85(getKClass(OntologyElement_1), body);
    // Inline function 'jetbrains.ocelot.langDef.usages.ruleFor' call
    var body_0 = btbFindUsages$lambda$lambda_0;
    $this$findUsages.t85(getKClass(Category_1), body_0);
    // Inline function 'jetbrains.ocelot.langDef.usages.ruleFor' call
    var body_1 = btbFindUsages$lambda$lambda_1;
    $this$findUsages.t85(getKClass(FactSet_1), body_1);
    // Inline function 'jetbrains.ocelot.langDef.usages.ruleFor' call
    var body_2 = btbFindUsages$lambda$lambda_2;
    $this$findUsages.t85(getKClass(Fact_1), body_2);
    // Inline function 'jetbrains.ocelot.langDef.usages.ruleFor' call
    var body_3 = btbFindUsages$lambda$lambda_3;
    $this$findUsages.t85(getKClass(VariableDeclaration_1), body_3);
    // Inline function 'jetbrains.ocelot.langDef.usages.ruleFor' call
    var body_4 = btbFindUsages$lambda$lambda_4;
    $this$findUsages.t85(getKClass(ObjectPropertyDeclaration_1), body_4);
    // Inline function 'jetbrains.ocelot.langDef.usages.ruleFor' call
    var body_5 = btbFindUsages$lambda$lambda_5;
    $this$findUsages.t85(getKClass(ProcessDeclaration_1), body_5);
    // Inline function 'jetbrains.ocelot.langDef.usages.ruleFor' call
    var body_6 = btbFindUsages$lambda$lambda_6;
    $this$findUsages.t85(getKClass(FunctionDeclaration_1), body_6);
    // Inline function 'jetbrains.ocelot.langDef.usages.ruleFor' call
    var body_7 = btbFindUsages$lambda$lambda_7;
    $this$findUsages.t85(getKClass(OntologyImport_1), body_7);
    // Inline function 'jetbrains.ocelot.langDef.usages.ruleFor' call
    var body_8 = btbFindUsages$lambda$lambda_8;
    $this$findUsages.t85(getKClass(ExtensionDeclaration_1), body_8);
    // Inline function 'jetbrains.ocelot.langDef.usages.ruleFor' call
    var body_9 = btbFindUsages$lambda$lambda_9;
    $this$findUsages.t85(getKClass(OntologyImportRootReference_1), body_9);
    // Inline function 'jetbrains.ocelot.langDef.usages.ruleFor' call
    var body_10 = btbFindUsages$lambda$lambda_10;
    $this$findUsages.t85(getKClass(PropertyDeclaration_1), body_10);
    // Inline function 'jetbrains.ocelot.langDef.usages.ruleFor' call
    var body_11 = btbFindUsages$lambda$lambda_11;
    $this$findUsages.t85(getKClass(LinkDeclaration_1), body_11);
    var tmp = SuperElementUsageKind_getInstance();
    $this$findUsages.v85(tmp, btbFindUsages$lambda$lambda_12);
    var tmp_0 = OntologyInSuperElementUsageKind_getInstance();
    $this$findUsages.v85(tmp_0, btbFindUsages$lambda$lambda_13);
    var tmp_1 = PartOfElementUsageKind_getInstance();
    $this$findUsages.v85(tmp_1, btbFindUsages$lambda$lambda_14);
    var tmp_2 = OntologyInPartOfElementUsageKind_getInstance();
    $this$findUsages.v85(tmp_2, btbFindUsages$lambda$lambda_15);
    var tmp_3 = ElementsTaxonUsageKind_getInstance();
    $this$findUsages.v85(tmp_3, btbFindUsages$lambda$lambda_16);
    var tmp_4 = OntologyInElementsTaxonUsageKind_getInstance();
    $this$findUsages.v85(tmp_4, btbFindUsages$lambda$lambda_17);
    var tmp_5 = ElementInCategoryUsageKind_getInstance();
    $this$findUsages.v85(tmp_5, btbFindUsages$lambda$lambda_18);
    var tmp_6 = OntologyInCategoryUsageKind_getInstance();
    $this$findUsages.v85(tmp_6, btbFindUsages$lambda$lambda_19);
    var tmp_7 = ElementInFactSetContextUsageKind_getInstance();
    $this$findUsages.v85(tmp_7, btbFindUsages$lambda$lambda_20);
    var tmp_8 = OntologyInFactSetContextUsageKind_getInstance();
    $this$findUsages.v85(tmp_8, btbFindUsages$lambda$lambda_21);
    var tmp_9 = SomethingAsVariableSpecUsageKind_getInstance();
    $this$findUsages.v85(tmp_9, btbFindUsages$lambda$lambda_22);
    var tmp_10 = AnythingInsideFactUsageKind_getInstance();
    $this$findUsages.v85(tmp_10, btbFindUsages$lambda$lambda_23);
    var tmp_11 = ProcessKindUsageKind_getInstance();
    $this$findUsages.v85(tmp_11, btbFindUsages$lambda$lambda_24);
    var tmp_12 = ExtendedProcessUsageKind_getInstance();
    $this$findUsages.v85(tmp_12, btbFindUsages$lambda$lambda_25);
    var tmp_13 = InheritedProcessUsageKind_getInstance();
    $this$findUsages.v85(tmp_13, btbFindUsages$lambda$lambda_26);
    var tmp_14 = OntologyElementInAbstractBindingElementsUsageKind_getInstance();
    $this$findUsages.v85(tmp_14, btbFindUsages$lambda$lambda_27);
    var tmp_15 = OntologyInAbstractBindingElementsUsageKind_getInstance();
    $this$findUsages.v85(tmp_15, btbFindUsages$lambda$lambda_28);
    var tmp_16 = AnythingInsideCustomEditorUsageKind_getInstance();
    $this$findUsages.v85(tmp_16, btbFindUsages$lambda$lambda_29);
    var tmp_17 = AliasedPropertyUsageKind_getInstance();
    $this$findUsages.v85(tmp_17, btbFindUsages$lambda$lambda_30);
    var tmp_18 = PropertyTypeOntologyUsageKind_getInstance();
    $this$findUsages.v85(tmp_18, btbFindUsages$lambda$lambda_31);
    var tmp_19 = PropertyTypeOntologyElementUsageKind_getInstance();
    $this$findUsages.v85(tmp_19, btbFindUsages$lambda$lambda_32);
    var tmp_20 = PropertyTypeNotionUsageKind_getInstance();
    $this$findUsages.v85(tmp_20, btbFindUsages$lambda$lambda_33);
    var tmp_21 = OldPropertyTypeNotionUsageKind_getInstance();
    $this$findUsages.v85(tmp_21, btbFindUsages$lambda$lambda_34);
    var tmp_22 = OldImportedPropertyUsageKind_getInstance();
    $this$findUsages.v85(tmp_22, btbFindUsages$lambda$lambda_35);
    var tmp_23 = OldLinkOntologyUsageKind_getInstance();
    $this$findUsages.v85(tmp_23, btbFindUsages$lambda$lambda_36);
    var tmp_24 = OldLinkOntologyElementUsageKind_getInstance();
    $this$findUsages.v85(tmp_24, btbFindUsages$lambda$lambda_37);
    var tmp_25 = OldImportedLinkUsageKind_getInstance();
    $this$findUsages.v85(tmp_25, btbFindUsages$lambda$lambda_38);
    var tmp_26 = OldLinkSpecializesLinkUsageKind_getInstance();
    $this$findUsages.v85(tmp_26, btbFindUsages$lambda$lambda_39);
    var tmp_27 = FunctionReturnTypeOntologyUsageKind_getInstance();
    $this$findUsages.v85(tmp_27, btbFindUsages$lambda$lambda_40);
    var tmp_28 = FunctionReturnTypeOntologyElementUsageKind_getInstance();
    $this$findUsages.v85(tmp_28, btbFindUsages$lambda$lambda_41);
    var tmp_29 = InOntologyImportForOntologyUsageKind_getInstance();
    $this$findUsages.v85(tmp_29, btbFindUsages$lambda$lambda_42);
    var tmp_30 = InOntologyImportForOntologyElementUsageKind_getInstance();
    $this$findUsages.v85(tmp_30, btbFindUsages$lambda$lambda_43);
    var tmp_31 = InOntologyImportOntologyToUseUsageKind_getInstance();
    $this$findUsages.v85(tmp_31, btbFindUsages$lambda$lambda_44);
    var tmp_32 = ExtensionTypeOntologyUsageKind_getInstance();
    $this$findUsages.v85(tmp_32, btbFindUsages$lambda$lambda_45);
    var tmp_33 = ExtensionTypeOntologyElementUsageKind_getInstance();
    $this$findUsages.v85(tmp_33, btbFindUsages$lambda$lambda_46);
    var tmp_34 = ExtensionFieldOntologyUsageKind_getInstance();
    $this$findUsages.v85(tmp_34, btbFindUsages$lambda$lambda_47);
    var tmp_35 = ExtensionFieldOntologyElementUsageKind_getInstance();
    $this$findUsages.v85(tmp_35, btbFindUsages$lambda$lambda_48);
    var tmp_36 = ImportOntologyImportRootUsageKind_getInstance();
    $this$findUsages.v85(tmp_36, btbFindUsages$lambda$lambda_49);
    var tmp_37 = PublishedSourceUsageKind_getInstance();
    $this$findUsages.v85(tmp_37, btbFindUsages$lambda$lambda_50);
    var tmp_38 = TypeOfOldPropertyNotionUsageKind_getInstance();
    $this$findUsages.v85(tmp_38, btbFindUsages$lambda$lambda_51);
    var tmp_39 = TypeOfOldLinkOntologyUsageKind_getInstance();
    $this$findUsages.v85(tmp_39, btbFindUsages$lambda$lambda_52);
    var tmp_40 = TypeOfOldLinkOntologyElementUsageKind_getInstance();
    $this$findUsages.v85(tmp_40, btbFindUsages$lambda$lambda_53);
    var tmp_41 = SuperPropertyUsageKind_getInstance();
    $this$findUsages.v85(tmp_41, btbFindUsages$lambda$lambda_54);
    var tmp_42 = InversePropertyUsageKind_getInstance();
    $this$findUsages.v85(tmp_42, btbFindUsages$lambda$lambda_55);
    return Unit_instance;
  }
  function invoke$handleAbstractBindingDeclaration(_this__u8e3s4) {
    var tmp0_safe_receiver = _this__u8e3s4.cme();
    var tmp1_subject = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.q6q();
    var tmp;
    var tmp_0 = KProperty1;
    if (equals(tmp1_subject, getPropertyCallableRef('properties', 1, tmp_0, AbstractBindingDeclaration$_get_properties_$ref_4foxw4_1(), null))) {
      var tmp2_subject = get_targetConcept(_this__u8e3s4);
      tmp = tmp2_subject.equals(getKClass(ProcessProperty_1)) ? new ProperUsage(AliasedPropertyUsageKind_getInstance()) : tmp2_subject.equals(getKClass(OntologyElement_1)) ? new ProperUsage(PropertyTypeOntologyElementUsageKind_getInstance()) : tmp2_subject.equals(getKClass(OntologyLibrary_1)) ? new ProperUsage(PropertyTypeOntologyUsageKind_getInstance()) : tmp2_subject.equals(getKClass(AbstractNotion)) ? new ProperUsage(PropertyTypeNotionUsageKind_getInstance()) : DontKnow_getInstance();
    } else {
      var tmp_1 = KProperty1;
      if (equals(tmp1_subject, getPropertyCallableRef('entries', 1, tmp_1, AbstractBindingDeclaration$_get_entries_$ref_fnlsrh_1(), null))) {
        // Inline function 'kotlin.run' call
        var tmp_2;
        var tmp_3 = _this__u8e3s4.j85().i85_1.q6k_1;
        var tmp_4 = KProperty1;
        if (equals(tmp_3, getPropertyCallableRef('specializes', 1, tmp_4, AbstractLink$_get_specializes_$ref_yv3dpc_1(), null))) {
          tmp_2 = new ProperUsage(OldLinkSpecializesLinkUsageKind_getInstance());
        } else {
          var tmp0_subject = get_targetConcept(_this__u8e3s4);
          tmp_2 = tmp0_subject.equals(getKClass(OntologyElement_1)) ? new ProperUsage(OldLinkOntologyElementUsageKind_getInstance()) : tmp0_subject.equals(getKClass(OntologyLibrary_1)) ? new ProperUsage(OldLinkOntologyUsageKind_getInstance()) : tmp0_subject.equals(getKClass(AbstractNotion)) ? new ProperUsage(OldPropertyTypeNotionUsageKind_getInstance()) : tmp0_subject.equals(getKClass(PropertyDeclaration_1)) ? new ProperUsage(OldImportedPropertyUsageKind_getInstance()) : tmp0_subject.equals(getKClass(LinkDeclaration_1)) ? new ProperUsage(OldImportedLinkUsageKind_getInstance()) : DontKnow_getInstance();
        }
        tmp = tmp_2;
      } else {
        var tmp_5 = KProperty1;
        if (equals(tmp1_subject, getPropertyCallableRef('ontologyElements', 1, tmp_5, AbstractBindingDeclaration$_get_ontologyElements_$ref_egks01_1(), null))) {
          var tmp3_subject = get_targetConcept(_this__u8e3s4);
          tmp = tmp3_subject.equals(getKClass(OntologyLibrary_1)) ? new ProperUsage(OntologyElementInAbstractBindingElementsUsageKind_getInstance()) : tmp3_subject.equals(getKClass(OntologyElement_1)) ? new ProperUsage(OntologyInAbstractBindingElementsUsageKind_getInstance()) : DontKnow_getInstance();
        } else {
          var tmp_6 = KProperty1;
          if (equals(tmp1_subject, getPropertyCallableRef('customEditor', 1, tmp_6, AbstractBindingDeclaration$_get_customEditor_$ref_6c7l07_1(), null))) {
            tmp = new ProperUsage(AnythingInsideCustomEditorUsageKind_getInstance());
          } else {
            tmp = DontKnow_getInstance();
          }
        }
      }
    }
    return tmp;
  }
  function btbFindUsages$lambda$lambda($this$ruleFor) {
    var tmp0_safe_receiver = $this$ruleFor.cme();
    var tmp1_subject = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.q6q();
    var tmp;
    var tmp_0 = KProperty1;
    if (equals(tmp1_subject, getPropertyCallableRef('superElements', 1, tmp_0, OntologyElement$_get_superElements_$ref_eb9rkn_1(), null))) {
      var tmp2_subject = get_targetConcept($this$ruleFor);
      tmp = tmp2_subject.equals(getKClass(OntologyElement_1)) ? new ProperUsage(SuperElementUsageKind_getInstance()) : tmp2_subject.equals(getKClass(OntologyLibrary_1)) ? new ProperUsage(OntologyInSuperElementUsageKind_getInstance()) : DontKnow_getInstance();
    } else {
      var tmp_1 = KProperty1;
      if (equals(tmp1_subject, getPropertyCallableRef('enclosingElements', 1, tmp_1, OntologyElement$_get_enclosingElements_$ref_uplwca_1(), null))) {
        var tmp3_subject = get_targetConcept($this$ruleFor);
        tmp = tmp3_subject.equals(getKClass(OntologyElement_1)) ? new ProperUsage(PartOfElementUsageKind_getInstance()) : tmp3_subject.equals(getKClass(OntologyLibrary_1)) ? new ProperUsage(OntologyInPartOfElementUsageKind_getInstance()) : DontKnow_getInstance();
      } else {
        var tmp_2 = KProperty1;
        if (equals(tmp1_subject, getPropertyCallableRef('taxon', 1, tmp_2, OntologyElement$_get_taxon_$ref_my9s4f_1(), null))) {
          var tmp4_subject = get_targetConcept($this$ruleFor);
          tmp = tmp4_subject.equals(getKClass(OntologyElement_1)) ? new ProperUsage(ElementsTaxonUsageKind_getInstance()) : tmp4_subject.equals(getKClass(OntologyLibrary_1)) ? new ProperUsage(OntologyInElementsTaxonUsageKind_getInstance()) : DontKnow_getInstance();
        } else {
          tmp = new ProperUsage(DefaultUsageKind_getInstance());
        }
      }
    }
    return tmp;
  }
  function OntologyElement$_get_superElements_$ref_eb9rkn_1() {
    return function (p0) {
      return p0.nfs();
    };
  }
  function OntologyElement$_get_enclosingElements_$ref_uplwca_1() {
    return function (p0) {
      return p0.ofs();
    };
  }
  function OntologyElement$_get_taxon_$ref_my9s4f_1() {
    return function (p0) {
      return p0.pfs();
    };
  }
  function btbFindUsages$lambda$lambda_0($this$ruleFor) {
    var tmp0_subject = get_targetConcept($this$ruleFor);
    return tmp0_subject.equals(getKClass(OntologyLibrary_1)) ? new ProperUsage(OntologyInCategoryUsageKind_getInstance()) : tmp0_subject.equals(getKClass(OntologyElement_1)) ? new ProperUsage(ElementInCategoryUsageKind_getInstance()) : DontKnow_getInstance();
  }
  function btbFindUsages$lambda$lambda_1($this$ruleFor) {
    var tmp;
    var tmp_0;
    var tmp1_safe_receiver = $this$ruleFor.cme();
    var tmp_1 = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.q6q();
    var tmp_2 = KProperty1;
    if (equals(tmp_1, getPropertyCallableRef('factsContext', 1, tmp_2, FactSet$_get_factsContext_$ref_cvizsw_1(), null))) {
      tmp_0 = true;
    } else {
      var tmp2_safe_receiver = $this$ruleFor.cme();
      var tmp_3 = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.q6q();
      var tmp_4 = KProperty1;
      tmp_0 = equals(tmp_3, getPropertyCallableRef('contexts', 1, tmp_4, FactSet$_get_contexts_$ref_i2luf8_1(), null));
    }
    if (tmp_0) {
      var tmp0_subject = get_targetConcept($this$ruleFor);
      tmp = tmp0_subject.equals(getKClass(OntologyLibrary_1)) ? new ProperUsage(OntologyInFactSetContextUsageKind_getInstance()) : tmp0_subject.equals(getKClass(OntologyElement_1)) ? new ProperUsage(ElementInFactSetContextUsageKind_getInstance()) : DontKnow_getInstance();
    } else {
      tmp = DontKnow_getInstance();
    }
    return tmp;
  }
  function FactSet$_get_factsContext_$ref_cvizsw_1() {
    return function (p0) {
      return p0.afr();
    };
  }
  function FactSet$_get_contexts_$ref_i2luf8_1() {
    return function (p0) {
      return p0.bfr();
    };
  }
  function btbFindUsages$lambda$lambda_2($this$ruleFor) {
    return new ProperUsage(AnythingInsideFactUsageKind_getInstance());
  }
  function btbFindUsages$lambda$lambda_3($this$ruleFor) {
    var tmp;
    var tmp0_safe_receiver = $this$ruleFor.cme();
    var tmp_0 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.q6q();
    var tmp_1 = KProperty1;
    if (equals(tmp_0, getPropertyCallableRef('spec', 1, tmp_1, VariableDeclaration$_get_spec_$ref_h7083f_1(), null))) {
      tmp = new ProperUsage(SomethingAsVariableSpecUsageKind_getInstance());
    } else {
      tmp = DontKnow_getInstance();
    }
    return tmp;
  }
  function VariableDeclaration$_get_spec_$ref_h7083f_1() {
    return function (p0) {
      return p0.ofu();
    };
  }
  function btbFindUsages$lambda$lambda_4($this$ruleFor) {
    var tmp0_subject = $this$ruleFor.j85().i85_1;
    var tmp;
    var tmp_0 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var this_0 = getPropertyCallableRef('superProperty', 1, tmp_0, ObjectPropertyDeclaration$_get_superProperty_$ref_32i1ji_1(), null);
    var tmp$ret$0 = new ReferenceLink(getKClass(ObjectPropertyDeclaration_1), this_0, getKClass(ObjectPropertyDeclaration_1), getKClass(QualifiedReferenceContent));
    if (tmp0_subject.equals(tmp$ret$0)) {
      tmp = new ProperUsage(SuperPropertyUsageKind_getInstance());
    } else {
      var tmp_1 = KProperty1;
      // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
      var this_1 = getPropertyCallableRef('inverse', 1, tmp_1, ObjectPropertyDeclaration$_get_inverse_$ref_tftvf2_1(), null);
      var tmp$ret$1 = new ReferenceLink(getKClass(ObjectPropertyDeclaration_1), this_1, getKClass(ObjectPropertyDeclaration_1), getKClass(QualifiedReferenceContent));
      if (tmp0_subject.equals(tmp$ret$1)) {
        tmp = new ProperUsage(InversePropertyUsageKind_getInstance());
      } else {
        tmp = DontKnow_getInstance();
      }
    }
    return tmp;
  }
  function ObjectPropertyDeclaration$_get_superProperty_$ref_32i1ji_1() {
    return function (p0) {
      return p0.gfs();
    };
  }
  function ObjectPropertyDeclaration$_get_inverse_$ref_tftvf2_1() {
    return function (p0) {
      return p0.ifs();
    };
  }
  function btbFindUsages$lambda$lambda_5($this$ruleFor) {
    var tmp0_subject = $this$ruleFor.j85().i85_1.q6k_1;
    var tmp;
    var tmp_0 = KProperty1;
    if (equals(tmp0_subject, getPropertyCallableRef('extends', 1, tmp_0, ProcessDeclaration$_get_extends_$ref_8vc9n2_1(), null))) {
      tmp = new ProperUsage(ExtendedProcessUsageKind_getInstance());
    } else {
      var tmp_1 = KProperty1;
      if (equals(tmp0_subject, getPropertyCallableRef('kind', 1, tmp_1, ProcessDeclaration$_get_kind_$ref_2xm341_1(), null))) {
        tmp = new ProperUsage(ProcessKindUsageKind_getInstance());
      } else {
        var tmp1_safe_receiver = $this$ruleFor.cme();
        var tmp2_subject = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.q6q();
        var tmp_2;
        var tmp_3 = KProperty1;
        if (equals(tmp2_subject, getPropertyCallableRef('inherited', 1, tmp_3, ProcessDeclaration$_get_inherited_$ref_wglzfx_1(), null))) {
          var tmp_4;
          if (get_targetConcept($this$ruleFor).equals(getKClass(ProcessDeclaration_1))) {
            tmp_4 = new ProperUsage(InheritedProcessUsageKind_getInstance());
          } else {
            tmp_4 = DontKnow_getInstance();
          }
          tmp_2 = tmp_4;
        } else {
          tmp_2 = invoke$handleAbstractBindingDeclaration($this$ruleFor);
        }
        tmp = tmp_2;
      }
    }
    return tmp;
  }
  function ProcessDeclaration$_get_extends_$ref_8vc9n2_1() {
    return function (p0) {
      return p0.pft();
    };
  }
  function ProcessDeclaration$_get_kind_$ref_2xm341_1() {
    return function (p0) {
      return p0.r5a();
    };
  }
  function ProcessDeclaration$_get_inherited_$ref_wglzfx_1() {
    return function (p0) {
      return p0.qft();
    };
  }
  function btbFindUsages$lambda$lambda_6($this$ruleFor) {
    var tmp0_safe_receiver = $this$ruleFor.cme();
    var tmp1_subject = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.q6q();
    var tmp;
    var tmp_0 = KProperty1;
    if (equals(tmp1_subject, getPropertyCallableRef('returnType', 1, tmp_0, FunctionDeclaration$_get_returnType_$ref_ypk7g2_1(), null))) {
      var tmp2_subject = get_targetConcept($this$ruleFor);
      tmp = tmp2_subject.equals(getKClass(OntologyElement_1)) ? new ProperUsage(FunctionReturnTypeOntologyElementUsageKind_getInstance()) : tmp2_subject.equals(getKClass(OntologyLibrary_1)) ? new ProperUsage(FunctionReturnTypeOntologyUsageKind_getInstance()) : DontKnow_getInstance();
    } else {
      tmp = invoke$handleAbstractBindingDeclaration($this$ruleFor);
    }
    return tmp;
  }
  function FunctionDeclaration$_get_returnType_$ref_ypk7g2_1() {
    return function (p0) {
      return p0.gfr();
    };
  }
  function btbFindUsages$lambda$lambda_7($this$ruleFor) {
    var tmp0_safe_receiver = $this$ruleFor.cme();
    var tmp1_subject = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.q6q();
    var tmp;
    var tmp_0 = KProperty1;
    if (equals(tmp1_subject, getPropertyCallableRef('ontology', 1, tmp_0, OntologyImport$_get_ontology_$ref_5t3sat_1(), null))) {
      tmp = new ProperUsage(InOntologyImportForOntologyUsageKind_getInstance());
    } else {
      var tmp_1 = KProperty1;
      if (equals(tmp1_subject, getPropertyCallableRef('element', 1, tmp_1, OntologyImport$_get_element_$ref_7h70ks_1(), null))) {
        tmp = new ProperUsage(InOntologyImportForOntologyElementUsageKind_getInstance());
      } else {
        var tmp_2 = KProperty1;
        if (equals(tmp1_subject, getPropertyCallableRef('libraryToUse', 1, tmp_2, OntologyImport$_get_libraryToUse_$ref_z1ihvd_1(), null))) {
          tmp = new ProperUsage(InOntologyImportOntologyToUseUsageKind_getInstance());
        } else {
          tmp = DontKnow_getInstance();
        }
      }
    }
    return tmp;
  }
  function OntologyImport$_get_ontology_$ref_5t3sat_1() {
    return function (p0) {
      return p0.xfs();
    };
  }
  function OntologyImport$_get_element_$ref_7h70ks_1() {
    return function (p0) {
      return p0.gfq();
    };
  }
  function OntologyImport$_get_libraryToUse_$ref_z1ihvd_1() {
    return function (p0) {
      return p0.yfs();
    };
  }
  function btbFindUsages$lambda$lambda_8($this$ruleFor) {
    var tmp0_safe_receiver = $this$ruleFor.cme();
    var tmp1_subject = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.q6q();
    var tmp;
    var tmp_0 = KProperty1;
    if (equals(tmp1_subject, getPropertyCallableRef('type', 1, tmp_0, ExtensionDeclaration$_get_type_$ref_2sz2on_1(), null))) {
      var tmp2_subject = get_targetConcept($this$ruleFor);
      tmp = tmp2_subject.equals(getKClass(OntologyLibrary_1)) ? new ProperUsage(ExtensionTypeOntologyUsageKind_getInstance()) : tmp2_subject.equals(getKClass(OntologyElement_1)) ? new ProperUsage(ExtensionTypeOntologyElementUsageKind_getInstance()) : DontKnow_getInstance();
    } else {
      var tmp_1 = KProperty1;
      if (equals(tmp1_subject, getPropertyCallableRef('fields', 1, tmp_1, ExtensionDeclaration$_get_fields_$ref_y00c96_1(), null))) {
        var tmp3_subject = get_targetConcept($this$ruleFor);
        tmp = tmp3_subject.equals(getKClass(OntologyLibrary_1)) ? new ProperUsage(ExtensionFieldOntologyUsageKind_getInstance()) : tmp3_subject.equals(getKClass(OntologyElement_1)) ? new ProperUsage(ExtensionFieldOntologyElementUsageKind_getInstance()) : DontKnow_getInstance();
      } else {
        tmp = DontKnow_getInstance();
      }
    }
    return tmp;
  }
  function ExtensionDeclaration$_get_type_$ref_2sz2on_1() {
    return function (p0) {
      return p0.sfq();
    };
  }
  function ExtensionDeclaration$_get_fields_$ref_y00c96_1() {
    return function (p0) {
      return p0.rfq();
    };
  }
  function btbFindUsages$lambda$lambda_9($this$ruleFor) {
    return new ProperUsage(ImportOntologyImportRootUsageKind_getInstance());
  }
  function btbFindUsages$lambda$lambda_10($this$ruleFor) {
    var tmp;
    // Inline function 'jetbrains.biokb.lang.model.findUsages.ancestor' call
    // Inline function 'jetbrains.ocelot.langDef.structure.ancestorOrSelf' call
    var this_0 = $this$ruleFor.j85().h85_1;
    var tmp$ret$0 = ancestorOrSelf(this_0, getKClass(PropertyLibrary_1));
    if (execute_0(tmp$ret$0) == null) {
      tmp = DontKnow_getInstance();
    } else {
      tmp = new ProperUsage(TypeOfOldPropertyNotionUsageKind_getInstance());
    }
    return tmp;
  }
  function btbFindUsages$lambda$lambda_11($this$ruleFor) {
    var tmp;
    // Inline function 'jetbrains.biokb.lang.model.findUsages.ancestor' call
    // Inline function 'jetbrains.ocelot.langDef.structure.ancestorOrSelf' call
    var this_0 = $this$ruleFor.j85().h85_1;
    var tmp$ret$0 = ancestorOrSelf(this_0, getKClass(LinkLibrary_1));
    if (execute_0(tmp$ret$0) == null) {
      tmp = DontKnow_getInstance();
    } else {
      var tmp0_subject = get_targetConcept($this$ruleFor);
      tmp = tmp0_subject.equals(getKClass(OntologyLibrary_1)) ? new ProperUsage(TypeOfOldLinkOntologyUsageKind_getInstance()) : tmp0_subject.equals(getKClass(OntologyElement_1)) ? new ProperUsage(TypeOfOldLinkOntologyElementUsageKind_getInstance()) : DontKnow_getInstance();
    }
    return tmp;
  }
  function btbFindUsages$lambda$lambda_12(element, referenceContext) {
    // Inline function 'jetbrains.biokb.lang.model.findUsages.ancestor' call
    // Inline function 'jetbrains.ocelot.langDef.structure.ancestorOrSelf' call
    var this_0 = referenceContext.h85_1;
    var tmp$ret$0 = ancestorOrSelf(this_0, getKClass(OntologyIsRelation_1));
    var tmp$ret$1 = execute_0(tmp$ret$0);
    return new SuperElementUsage(element, ensureNotNull(tmp$ret$1), OntologyTargetKind_ELEMENT_getInstance());
  }
  function btbFindUsages$lambda$lambda_13(element, referenceContext) {
    // Inline function 'jetbrains.biokb.lang.model.findUsages.ancestor' call
    // Inline function 'jetbrains.ocelot.langDef.structure.ancestorOrSelf' call
    var this_0 = referenceContext.h85_1;
    var tmp$ret$0 = ancestorOrSelf(this_0, getKClass(OntologyIsRelation_1));
    var tmp$ret$1 = execute_0(tmp$ret$0);
    return new SuperElementUsage(element, ensureNotNull(tmp$ret$1), OntologyTargetKind_ONTOLOGY_getInstance());
  }
  function btbFindUsages$lambda$lambda_14(element, referenceContext) {
    // Inline function 'jetbrains.biokb.lang.model.findUsages.ancestor' call
    // Inline function 'jetbrains.ocelot.langDef.structure.ancestorOrSelf' call
    var this_0 = referenceContext.h85_1;
    var tmp$ret$0 = ancestorOrSelf(this_0, getKClass(OntologyCardinalityRelation_1));
    var tmp$ret$1 = execute_0(tmp$ret$0);
    return new PartOfElementUsage(element, ensureNotNull(tmp$ret$1), OntologyTargetKind_ELEMENT_getInstance());
  }
  function btbFindUsages$lambda$lambda_15(element, referenceContext) {
    // Inline function 'jetbrains.biokb.lang.model.findUsages.ancestor' call
    // Inline function 'jetbrains.ocelot.langDef.structure.ancestorOrSelf' call
    var this_0 = referenceContext.h85_1;
    var tmp$ret$0 = ancestorOrSelf(this_0, getKClass(OntologyCardinalityRelation_1));
    var tmp$ret$1 = execute_0(tmp$ret$0);
    return new PartOfElementUsage(element, ensureNotNull(tmp$ret$1), OntologyTargetKind_ONTOLOGY_getInstance());
  }
  function btbFindUsages$lambda$lambda_16(element, referenceContext) {
    // Inline function 'jetbrains.biokb.lang.model.findUsages.ancestor' call
    // Inline function 'jetbrains.ocelot.langDef.structure.ancestorOrSelf' call
    var this_0 = referenceContext.h85_1;
    var tmp$ret$0 = ancestorOrSelf(this_0, getKClass(QualifiedOntologyElementReference_1));
    var tmp$ret$1 = execute_0(tmp$ret$0);
    return new ElementsTaxonUsage(element, ensureNotNull(tmp$ret$1), OntologyTargetKind_ELEMENT_getInstance());
  }
  function btbFindUsages$lambda$lambda_17(element, referenceContext) {
    // Inline function 'jetbrains.biokb.lang.model.findUsages.ancestor' call
    // Inline function 'jetbrains.ocelot.langDef.structure.ancestorOrSelf' call
    var this_0 = referenceContext.h85_1;
    var tmp$ret$0 = ancestorOrSelf(this_0, getKClass(QualifiedOntologyElementReference_1));
    var tmp$ret$1 = execute_0(tmp$ret$0);
    return new ElementsTaxonUsage(element, ensureNotNull(tmp$ret$1), OntologyTargetKind_ONTOLOGY_getInstance());
  }
  function btbFindUsages$lambda$lambda_18(category, _unused_var__etf5q3) {
    return new CategoryOntologyUsage(category, OntologyTargetKind_ELEMENT_getInstance());
  }
  function btbFindUsages$lambda$lambda_19(category, _unused_var__etf5q3) {
    return new CategoryOntologyUsage(category, OntologyTargetKind_ONTOLOGY_getInstance());
  }
  function btbFindUsages$lambda$lambda_20(factSet, referenceContext) {
    // Inline function 'jetbrains.biokb.lang.model.findUsages.ancestor' call
    // Inline function 'jetbrains.ocelot.langDef.structure.ancestorOrSelf' call
    var this_0 = referenceContext.h85_1;
    var tmp$ret$0 = ancestorOrSelf(this_0, getKClass(Context_2));
    var tmp$ret$1 = execute_0(tmp$ret$0);
    return new FactSetContextOntologyUsage(factSet, ensureNotNull(tmp$ret$1));
  }
  function btbFindUsages$lambda$lambda_21(factSet, referenceContext) {
    // Inline function 'jetbrains.biokb.lang.model.findUsages.ancestor' call
    // Inline function 'jetbrains.ocelot.langDef.structure.ancestorOrSelf' call
    var this_0 = referenceContext.h85_1;
    var tmp$ret$0 = ancestorOrSelf(this_0, getKClass(Context_2));
    var tmp$ret$1 = execute_0(tmp$ret$0);
    return new FactSetContextOntologyUsage(factSet, ensureNotNull(tmp$ret$1));
  }
  function btbFindUsages$lambda$lambda_22(variable, _unused_var__etf5q3) {
    return new SomethingAsVariableSpecUsage(variable);
  }
  function btbFindUsages$lambda$lambda_23(fact, _unused_var__etf5q3) {
    return new AnyUsageInFact(fact);
  }
  function btbFindUsages$lambda$lambda_24(process, _unused_var__etf5q3) {
    return new ProcessKindUsage(process);
  }
  function btbFindUsages$lambda$lambda_25(process, _unused_var__etf5q3) {
    return new ExtendedProcessUsage(process);
  }
  function btbFindUsages$lambda$lambda_26(process, referenceContext) {
    // Inline function 'jetbrains.biokb.lang.model.findUsages.ancestor' call
    // Inline function 'jetbrains.ocelot.langDef.structure.ancestorOrSelf' call
    var this_0 = referenceContext.h85_1;
    var tmp$ret$0 = ancestorOrSelf(this_0, getKClass(ProcessReference_1));
    var tmp$ret$1 = execute_0(tmp$ret$0);
    return new InheritedProcessUsage(process, ensureNotNull(tmp$ret$1));
  }
  function btbFindUsages$lambda$lambda_27(process, referenceContext) {
    // Inline function 'jetbrains.biokb.lang.model.findUsages.ancestor' call
    // Inline function 'jetbrains.ocelot.langDef.structure.ancestorOrSelf' call
    var this_0 = referenceContext.h85_1;
    var tmp$ret$0 = ancestorOrSelf(this_0, getKClass(OntologyElementType_1));
    var tmp$ret$1 = execute_0(tmp$ret$0);
    return new OntologyElementInBindingDeclarationUsage(process, ensureNotNull(tmp$ret$1), OntologyTargetKind_ELEMENT_getInstance());
  }
  function btbFindUsages$lambda$lambda_28(process, referenceContext) {
    // Inline function 'jetbrains.biokb.lang.model.findUsages.ancestor' call
    // Inline function 'jetbrains.ocelot.langDef.structure.ancestorOrSelf' call
    var this_0 = referenceContext.h85_1;
    var tmp$ret$0 = ancestorOrSelf(this_0, getKClass(OntologyElementType_1));
    var tmp$ret$1 = execute_0(tmp$ret$0);
    return new OntologyElementInBindingDeclarationUsage(process, ensureNotNull(tmp$ret$1), OntologyTargetKind_ONTOLOGY_getInstance());
  }
  function btbFindUsages$lambda$lambda_29(process, referenceContext) {
    // Inline function 'jetbrains.biokb.lang.model.findUsages.ancestor' call
    // Inline function 'jetbrains.ocelot.langDef.structure.ancestorOrSelf' call
    var this_0 = referenceContext.h85_1;
    var tmp$ret$0 = ancestorOrSelf(this_0, getKClass(CustomCell));
    var tmp$ret$1 = execute_0(tmp$ret$0);
    return new AnythingInsideCustomEditorUsage(process, ensureNotNull(tmp$ret$1));
  }
  function btbFindUsages$lambda$lambda_30(element, referenceContext) {
    // Inline function 'jetbrains.biokb.lang.model.findUsages.ancestor' call
    // Inline function 'jetbrains.ocelot.langDef.structure.ancestorOrSelf' call
    var this_0 = referenceContext.h85_1;
    var tmp$ret$0 = ancestorOrSelf(this_0, getKClass(ProcessProperty_1));
    var tmp$ret$1 = execute_0(tmp$ret$0);
    var tmp = ensureNotNull(tmp$ret$1);
    // Inline function 'jetbrains.biokb.lang.model.findUsages.ancestor' call
    // Inline function 'jetbrains.ocelot.langDef.structure.ancestorOrSelf' call
    var this_1 = referenceContext.h85_1;
    var tmp$ret$2 = ancestorOrSelf(this_1, getKClass(ProcessPropertyReference));
    var tmp$ret$3 = execute_0(tmp$ret$2);
    return new AliasedBindingPropertyUsage(element, tmp, ensureNotNull(tmp$ret$3));
  }
  function btbFindUsages$lambda$lambda_31(node, referenceContext) {
    // Inline function 'jetbrains.biokb.lang.model.findUsages.ancestor' call
    // Inline function 'jetbrains.ocelot.langDef.structure.ancestorOrSelf' call
    var this_0 = referenceContext.h85_1;
    var tmp$ret$0 = ancestorOrSelf(this_0, getKClass(ProcessProperty_1));
    var tmp$ret$1 = execute_0(tmp$ret$0);
    return new PropertyTypeUsage(node, ensureNotNull(tmp$ret$1));
  }
  function btbFindUsages$lambda$lambda_32(node, referenceContext) {
    // Inline function 'jetbrains.biokb.lang.model.findUsages.ancestor' call
    // Inline function 'jetbrains.ocelot.langDef.structure.ancestorOrSelf' call
    var this_0 = referenceContext.h85_1;
    var tmp$ret$0 = ancestorOrSelf(this_0, getKClass(ProcessProperty_1));
    var tmp$ret$1 = execute_0(tmp$ret$0);
    return new PropertyTypeUsage(node, ensureNotNull(tmp$ret$1));
  }
  function btbFindUsages$lambda$lambda_33(node, referenceContext) {
    // Inline function 'jetbrains.biokb.lang.model.findUsages.ancestor' call
    // Inline function 'jetbrains.ocelot.langDef.structure.ancestorOrSelf' call
    var this_0 = referenceContext.h85_1;
    var tmp$ret$0 = ancestorOrSelf(this_0, getKClass(ProcessProperty_1));
    var tmp$ret$1 = execute_0(tmp$ret$0);
    return new PropertyTypeUsage(node, ensureNotNull(tmp$ret$1));
  }
  function btbFindUsages$lambda$lambda_34(node, referenceContext) {
    // Inline function 'jetbrains.biokb.lang.model.findUsages.ancestor' call
    // Inline function 'jetbrains.ocelot.langDef.structure.ancestorOrSelf' call
    var this_0 = referenceContext.h85_1;
    var tmp$ret$0 = ancestorOrSelf(this_0, getKClass(PropertyDeclaration_1));
    var tmp$ret$1 = execute_0(tmp$ret$0);
    return new OldPropertyTypeNotionUsage(node, ensureNotNull(tmp$ret$1));
  }
  function btbFindUsages$lambda$lambda_35(node, referenceContext) {
    // Inline function 'jetbrains.biokb.lang.model.findUsages.ancestor' call
    // Inline function 'jetbrains.ocelot.langDef.structure.ancestorOrSelf' call
    var this_0 = referenceContext.h85_1;
    var tmp$ret$0 = ancestorOrSelf(this_0, getKClass(ImportedProperty_1));
    var tmp$ret$1 = execute_0(tmp$ret$0);
    return new OldImportedPropertyUsage(node, ensureNotNull(tmp$ret$1));
  }
  function btbFindUsages$lambda$lambda_36(node, referenceContext) {
    // Inline function 'jetbrains.biokb.lang.model.findUsages.ancestor' call
    // Inline function 'jetbrains.ocelot.langDef.structure.ancestorOrSelf' call
    var this_0 = referenceContext.h85_1;
    var tmp$ret$0 = ancestorOrSelf(this_0, getKClass(LinkDeclaration_1));
    var tmp$ret$1 = execute_0(tmp$ret$0);
    return new OldLinkOntologyUsage(node, ensureNotNull(tmp$ret$1));
  }
  function btbFindUsages$lambda$lambda_37(node, referenceContext) {
    // Inline function 'jetbrains.biokb.lang.model.findUsages.ancestor' call
    // Inline function 'jetbrains.ocelot.langDef.structure.ancestorOrSelf' call
    var this_0 = referenceContext.h85_1;
    var tmp$ret$0 = ancestorOrSelf(this_0, getKClass(LinkDeclaration_1));
    var tmp$ret$1 = execute_0(tmp$ret$0);
    return new OldLinkOntologyUsage(node, ensureNotNull(tmp$ret$1));
  }
  function btbFindUsages$lambda$lambda_38(node, referenceContext) {
    // Inline function 'jetbrains.biokb.lang.model.findUsages.ancestor' call
    // Inline function 'jetbrains.ocelot.langDef.structure.ancestorOrSelf' call
    var this_0 = referenceContext.h85_1;
    var tmp$ret$0 = ancestorOrSelf(this_0, getKClass(ImportedLink_1));
    var tmp$ret$1 = execute_0(tmp$ret$0);
    return new OldImportedLinkUsage(node, ensureNotNull(tmp$ret$1));
  }
  function btbFindUsages$lambda$lambda_39(node, referenceContext) {
    // Inline function 'jetbrains.biokb.lang.model.findUsages.ancestor' call
    // Inline function 'jetbrains.ocelot.langDef.structure.ancestorOrSelf' call
    var this_0 = referenceContext.h85_1;
    var tmp$ret$0 = ancestorOrSelf(this_0, getKClass(AbstractLink));
    var tmp$ret$1 = execute_0(tmp$ret$0);
    return new OldLinkSpecializesLinkUsage(node, ensureNotNull(tmp$ret$1));
  }
  function btbFindUsages$lambda$lambda_40(node, _unused_var__etf5q3) {
    return new OntologyInFunctionReturnTypeUsage(node, OntologyTargetKind_ONTOLOGY_getInstance());
  }
  function btbFindUsages$lambda$lambda_41(node, _unused_var__etf5q3) {
    return new OntologyInFunctionReturnTypeUsage(node, OntologyTargetKind_ELEMENT_getInstance());
  }
  function btbFindUsages$lambda$lambda_42(import_0, _unused_var__etf5q3) {
    return new InOntologyImportForOntologyUsage(import_0, OntologyTargetKind_ONTOLOGY_getInstance());
  }
  function btbFindUsages$lambda$lambda_43(import_0, _unused_var__etf5q3) {
    return new InOntologyImportForOntologyUsage(import_0, OntologyTargetKind_ELEMENT_getInstance());
  }
  function btbFindUsages$lambda$lambda_44(import_0, _unused_var__etf5q3) {
    return new InOntologyImportOntologyToUseUsage(import_0);
  }
  function btbFindUsages$lambda$lambda_45(node, _unused_var__etf5q3) {
    return new OntologyInExtensionTypeUsage(node, OntologyTargetKind_ONTOLOGY_getInstance());
  }
  function btbFindUsages$lambda$lambda_46(node, _unused_var__etf5q3) {
    return new OntologyInExtensionTypeUsage(node, OntologyTargetKind_ELEMENT_getInstance());
  }
  function btbFindUsages$lambda$lambda_47(node, referenceContext) {
    // Inline function 'jetbrains.biokb.lang.model.findUsages.ancestor' call
    // Inline function 'jetbrains.ocelot.langDef.structure.ancestorOrSelf' call
    var this_0 = referenceContext.h85_1;
    var tmp$ret$0 = ancestorOrSelf(this_0, getKClass(FieldDeclaration_1));
    var tmp$ret$1 = execute_0(tmp$ret$0);
    return new OntologyInExtensionFieldUsage(node, ensureNotNull(tmp$ret$1), OntologyTargetKind_ONTOLOGY_getInstance());
  }
  function btbFindUsages$lambda$lambda_48(node, referenceContext) {
    // Inline function 'jetbrains.biokb.lang.model.findUsages.ancestor' call
    // Inline function 'jetbrains.ocelot.langDef.structure.ancestorOrSelf' call
    var this_0 = referenceContext.h85_1;
    var tmp$ret$0 = ancestorOrSelf(this_0, getKClass(FieldDeclaration_1));
    var tmp$ret$1 = execute_0(tmp$ret$0);
    return new OntologyInExtensionFieldUsage(node, ensureNotNull(tmp$ret$1), OntologyTargetKind_ELEMENT_getInstance());
  }
  function btbFindUsages$lambda$lambda_49(node, _unused_var__etf5q3) {
    return new ImportOntologyImportRootUsage(node);
  }
  function btbFindUsages$lambda$lambda_50(node, _unused_var__etf5q3) {
    return new PublishedSourceUsage(node);
  }
  function btbFindUsages$lambda$lambda_51(node, _unused_var__etf5q3) {
    return new TypeOfOldPropertyDeclarationUsage(node);
  }
  function btbFindUsages$lambda$lambda_52(node, _unused_var__etf5q3) {
    return new TypeOfOldLinkDeclarationUsage(node, OntologyTargetKind_ONTOLOGY_getInstance());
  }
  function btbFindUsages$lambda$lambda_53(node, _unused_var__etf5q3) {
    return new TypeOfOldLinkDeclarationUsage(node, OntologyTargetKind_ELEMENT_getInstance());
  }
  function btbFindUsages$lambda$lambda_54(node, _unused_var__etf5q3) {
    return new ObjectPropertyUsageByAnotherProperty(node, ObjectPropertyUsageByAnotherPropertyKind_SUPER_PROPERTY_getInstance());
  }
  function btbFindUsages$lambda$lambda_55(node, _unused_var__etf5q3) {
    return new ObjectPropertyUsageByAnotherProperty(node, ObjectPropertyUsageByAnotherPropertyKind_INVERSE_PROPERTY_getInstance());
  }
  function AbstractBindingDeclaration$_get_properties_$ref_4foxw4_1() {
    return function (p0) {
      return p0.rfp();
    };
  }
  function AbstractBindingDeclaration$_get_entries_$ref_fnlsrh_1() {
    return function (p0) {
      return p0.y();
    };
  }
  function AbstractLink$_get_specializes_$ref_yv3dpc_1() {
    return function (p0) {
      return p0.ufp();
    };
  }
  function AbstractBindingDeclaration$_get_ontologyElements_$ref_egks01_1() {
    return function (p0) {
      return p0.qfp();
    };
  }
  function AbstractBindingDeclaration$_get_customEditor_$ref_6c7l07_1() {
    return function (p0) {
      return p0.sfp();
    };
  }
  function BTBNodeImpl(context, node) {
    BaseNodeGen.call(this, context.s6l_1, node);
  }
  function TypedBTBNodeImpl(context, nodeConceptId, nodeId) {
    BaseTypedOtNode.call(this, context, nodeConceptId, nodeId);
  }
  protoOf(TypedBTBNodeImpl).x6i = function () {
    var tmp = protoOf(BaseTypedOtNode).x6i.call(this);
    return isInterface(tmp, ReadableProperty) ? tmp : THROW_CCE();
  };
  protoOf(TypedBTBNodeImpl).bp = function () {
    var tmp = protoOf(BaseTypedOtNode).bp.call(this);
    return (!(tmp == null) ? isInterface(tmp, BTBNode) : false) ? tmp : null;
  };
  protoOf(TypedBTBNodeImpl).f6j = function () {
    var tmp = protoOf(BaseTypedOtNode).f6j.call(this);
    return isInterface(tmp, BTBNode) ? tmp : THROW_CCE();
  };
  function get_elementTypeAndTaxon() {
    _init_properties_BTBResolvers_kt__y423vn();
    return elementTypeAndTaxon;
  }
  var elementTypeAndTaxon;
  function get_onlyOntologyVars() {
    _init_properties_BTBResolvers_kt__y423vn();
    return onlyOntologyVars;
  }
  var onlyOntologyVars;
  function get_libraries() {
    _init_properties_BTBResolvers_kt__y423vn();
    return libraries;
  }
  var libraries;
  function get_ONTOLOGIES_WITH_SPECIES() {
    _init_properties_BTBResolvers_kt__y423vn();
    return ONTOLOGIES_WITH_SPECIES;
  }
  var ONTOLOGIES_WITH_SPECIES;
  function get_btbLanguageWithRemoteResolve() {
    _init_properties_BTBResolvers_kt__y423vn();
    return btbLanguageWithRemoteResolve;
  }
  var btbLanguageWithRemoteResolve;
  function get_btbLanguageWithPrecalculatedResolve() {
    _init_properties_BTBResolvers_kt__y423vn();
    return btbLanguageWithPrecalculatedResolve;
  }
  var btbLanguageWithPrecalculatedResolve;
  function get_btbLanguageWithLocalResolve() {
    _init_properties_BTBResolvers_kt__y423vn();
    return btbLanguageWithLocalResolve;
  }
  var btbLanguageWithLocalResolve;
  function btbRemoteResolve(_this__u8e3s4) {
    _init_properties_BTBResolvers_kt__y423vn();
    referenceFactories(_this__u8e3s4, btbRemoteResolve$lambda);
    referenceTargetsSuppliers(_this__u8e3s4, btbRemoteResolve$lambda_0);
    referenceTargetPresentationProviders(_this__u8e3s4, btbRemoteResolve$lambda_1);
  }
  function btbPrecalculatedResolve(_this__u8e3s4) {
    _init_properties_BTBResolvers_kt__y423vn();
    referenceFactories(_this__u8e3s4, btbPrecalculatedResolve$lambda);
    referenceTargetPresentationProviders(_this__u8e3s4, btbPrecalculatedResolve$lambda_0);
  }
  function btbLocalResolve(_this__u8e3s4) {
    _init_properties_BTBResolvers_kt__y423vn();
    referenceFactories(_this__u8e3s4, btbLocalResolve$lambda);
    referenceTargetsSuppliers(_this__u8e3s4, btbLocalResolve$lambda_0);
    referenceTargetPresentationProviders(_this__u8e3s4, btbLocalResolve$lambda_1);
  }
  function btbScopes(_this__u8e3s4) {
    _init_properties_BTBResolvers_kt__y423vn();
    scopes(_this__u8e3s4, btbScopes$lambda);
  }
  function isSameOntologyDocumentAs(_this__u8e3s4, other) {
    _init_properties_BTBResolvers_kt__y423vn();
    if (other == null)
      return false;
    if (_this__u8e3s4.z3n().equals(other.z3n()))
      return true;
    var tmp0_safe_receiver = get_pointer(_this__u8e3s4);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.documentId;
    var tmp;
    if (tmp1_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp1_elvis_lhs;
    }
    var documentId = tmp;
    var tmp2_safe_receiver = get_pointer(other);
    return documentId === (tmp2_safe_receiver == null ? null : tmp2_safe_receiver.documentId);
  }
  function librariesScope(_this__u8e3s4, librariesScopeProvider, library, $completion) {
    var elements = get_asObservable(toList_2(_this__u8e3s4.l60(librariesScopeProvider.z6u().h6v(library))));
    var taggedElements = new AnnotatedDocumentsList(library.j6n_1, elements);
    return _this__u8e3s4.u77(get_forQueries_1(taggedElements), $completion);
  }
  function importOntologyLibrary(_this__u8e3s4, reference, $completion) {
    return _this__u8e3s4.w77(reference.yfq(), $completion);
  }
  function importOntologyLibraries(_this__u8e3s4, libraryReferences, $completion) {
    var tmp = new $importOntologyLibrariesCOROUTINE$(_this__u8e3s4, libraryReferences, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  }
  function propertyTypeElements(propertyValue) {
    _init_properties_BTBResolvers_kt__y423vn();
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    // Inline function 'jetbrains.ocelot.langDef.query.flatMap' call
    var this_0 = new propertyTypeElements$$inlined$suspendingQuery$1(propertyValue);
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new propertyTypeElements$$inlined$flatMap$1(this_0);
  }
  function typeElements(type) {
    _init_properties_BTBResolvers_kt__y423vn();
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new typeElements$$inlined$suspendingQuery$1(type);
  }
  function filterOntologyElementsByPropertyRange(property, subtypes) {
    _init_properties_BTBResolvers_kt__y423vn();
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new filterOntologyElementsByPropertyRange$$inlined$suspendingQuery$1(property, subtypes);
  }
  function processPropertyElements(_this__u8e3s4, processProperty, $completion) {
    var tmp = new $processPropertyElementsCOROUTINE$(_this__u8e3s4, processProperty, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  }
  function filterByPropertyRange(property, service, variablesTrace) {
    variablesTrace = variablesTrace === VOID ? emptySet() : variablesTrace;
    _init_properties_BTBResolvers_kt__y423vn();
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new filterByPropertyRange$$inlined$suspendingQuery$1(property, service, variablesTrace);
  }
  function filterByValueType(value, service, variablesTrace) {
    variablesTrace = variablesTrace === VOID ? emptySet() : variablesTrace;
    _init_properties_BTBResolvers_kt__y423vn();
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new filterByValueType$$inlined$suspendingQuery$1(value, variablesTrace, service);
  }
  function getCustomEditorPropertiesScope(_this__u8e3s4, customEditor, $completion) {
    var tmp = new $getCustomEditorPropertiesScopeCOROUTINE$(_this__u8e3s4, customEditor, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  }
  function filterInstanceRelations(elements) {
    _init_properties_BTBResolvers_kt__y423vn();
    var tmp = Companion_instance_120;
    return tmp.f73(filterInstanceRelations$slambda_0(elements, null));
  }
  function filterInstanceRelations_0(typeNotion) {
    _init_properties_BTBResolvers_kt__y423vn();
    var tmp = Companion_instance_120;
    return tmp.f73(filterInstanceRelations$slambda_2(typeNotion, null));
  }
  function filterByVariableSpecification(variable, objectPropertyDomainFilters, variablesTrace) {
    variablesTrace = variablesTrace === VOID ? emptySet() : variablesTrace;
    _init_properties_BTBResolvers_kt__y423vn();
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new filterByVariableSpecification$$inlined$suspendingQuery$1(variable, objectPropertyDomainFilters, variablesTrace);
  }
  function libraryElementsScope(_this__u8e3s4, librariesScopeProvider, library, $completion) {
    var tmp = new $libraryElementsScopeCOROUTINE$(_this__u8e3s4, librariesScopeProvider, library, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  }
  function filterByDomainType(type, service, variablesTrace) {
    _init_properties_BTBResolvers_kt__y423vn();
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new filterByDomainType$$inlined$suspendingQuery$1(type, service, variablesTrace);
  }
  function filterByProcessPropertyType(property, service) {
    _init_properties_BTBResolvers_kt__y423vn();
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new filterByProcessPropertyType$$inlined$suspendingQuery$1(property, service);
  }
  function filterByFactExpressionType(factExpression, service, variablesTrace) {
    _init_properties_BTBResolvers_kt__y423vn();
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new filterByFactExpressionType$$inlined$suspendingQuery$1(factExpression, service, variablesTrace);
  }
  function btbLanguageWithRemoteResolve$lambda($this$language) {
    _init_properties_BTBResolvers_kt__y423vn();
    btbStructure($this$language);
    btbRemoteResolve($this$language);
    return Unit_instance;
  }
  function btbLanguageWithPrecalculatedResolve$lambda($this$language) {
    _init_properties_BTBResolvers_kt__y423vn();
    btbStructure($this$language);
    btbPrecalculatedResolve($this$language);
    btbFindUsages($this$language);
    return Unit_instance;
  }
  function btbLanguageWithLocalResolve$lambda($this$language) {
    _init_properties_BTBResolvers_kt__y423vn();
    btbStructure($this$language);
    btbLocalResolve($this$language);
    btbScopes($this$language);
    scopes($this$language, btbLanguageWithLocalResolve$lambda$lambda);
    btbFindUsages($this$language);
    return Unit_instance;
  }
  function btbLanguageWithLocalResolve$lambda$lambda($this$scopes) {
    _init_properties_BTBResolvers_kt__y423vn();
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideCommonScope' call
    var builder = btbLanguageWithLocalResolve$lambda$lambda$slambda_0(null);
    var evaluationStrategy = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(OntologyLibrary_1)), getKClass(OntologyElement_1), evaluationStrategy, Any_getInstance(), builder));
    return Unit_instance;
  }
  function btbLanguageWithLocalResolve$lambda$lambda$slambda(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbLanguageWithLocalResolve$lambda$lambda$slambda).kmg = function ($this$provideCommonScope, library, $completion) {
    var tmp = this.lmg($this$provideCommonScope, library, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbLanguageWithLocalResolve$lambda$lambda$slambda).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.kmg(tmp, (!(p2 == null) ? isInterface(p2, OntologyLibrary_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbLanguageWithLocalResolve$lambda$lambda$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.img_1.u77(this.jmg_1.ifq(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbLanguageWithLocalResolve$lambda$lambda$slambda).lmg = function ($this$provideCommonScope, library, completion) {
    var i = new btbLanguageWithLocalResolve$lambda$lambda$slambda(completion);
    i.img_1 = $this$provideCommonScope;
    i.jmg_1 = library;
    return i;
  };
  function btbLanguageWithLocalResolve$lambda$lambda$slambda_0(resultContinuation) {
    var i = new btbLanguageWithLocalResolve$lambda$lambda$slambda(resultContinuation);
    var l = function ($this$provideCommonScope, library, $completion) {
      return i.kmg($this$provideCommonScope, library, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbRemoteResolve$lambda($this$referenceFactories) {
    _init_properties_BTBResolvers_kt__y423vn();
    remote($this$referenceFactories, get_refTags($this$referenceFactories));
    return Unit_instance;
  }
  function btbRemoteResolve$lambda_0($this$referenceTargetsSuppliers) {
    _init_properties_BTBResolvers_kt__y423vn();
    remote_0($this$referenceTargetsSuppliers, get_refTags($this$referenceTargetsSuppliers));
    return Unit_instance;
  }
  function btbRemoteResolve$lambda_1($this$referenceTargetPresentationProviders) {
    _init_properties_BTBResolvers_kt__y423vn();
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = minus_1(get_refTags($this$referenceTargetPresentationProviders), Companion_getInstance_328().hhn_1).m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      $this$referenceTargetPresentationProviders.t6t(element);
    }
    var tmp = Companion_getInstance_328().hhn_1;
    var tmp_0 = btbRemoteResolve$lambda$lambda;
    $this$referenceTargetPresentationProviders.s6t(tmp, new sam$jetbrains_ocelot_langDef_references_TargetPresentationProvider$0_1(tmp_0));
    return Unit_instance;
  }
  function sam$jetbrains_ocelot_langDef_references_TargetPresentationProvider$0_1(function_0) {
    this.mmg_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_langDef_references_TargetPresentationProvider$0_1).w6q = function (target) {
    return this.mmg_1(target);
  };
  protoOf(sam$jetbrains_ocelot_langDef_references_TargetPresentationProvider$0_1).f3 = function () {
    return this.mmg_1;
  };
  protoOf(sam$jetbrains_ocelot_langDef_references_TargetPresentationProvider$0_1).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, TargetPresentationProvider) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_langDef_references_TargetPresentationProvider$0_1).hashCode = function () {
    return hashCode(this.f3());
  };
  function btbRemoteResolve$lambda$lambda(it) {
    _init_properties_BTBResolvers_kt__y423vn();
    return it.li1();
  }
  function btbPrecalculatedResolve$lambda($this$referenceFactories) {
    _init_properties_BTBResolvers_kt__y423vn();
    precalculated($this$referenceFactories, get_refTags($this$referenceFactories));
    return Unit_instance;
  }
  function btbPrecalculatedResolve$lambda_0($this$referenceTargetPresentationProviders) {
    _init_properties_BTBResolvers_kt__y423vn();
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = minus_1(get_refTags($this$referenceTargetPresentationProviders), Companion_getInstance_328().hhn_1).m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      $this$referenceTargetPresentationProviders.t6t(element);
    }
    var tmp = Companion_getInstance_328().hhn_1;
    var tmp_0 = btbPrecalculatedResolve$lambda$lambda;
    $this$referenceTargetPresentationProviders.s6t(tmp, new sam$jetbrains_ocelot_langDef_references_TargetPresentationProvider$0_2(tmp_0));
    return Unit_instance;
  }
  function sam$jetbrains_ocelot_langDef_references_TargetPresentationProvider$0_2(function_0) {
    this.nmg_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_langDef_references_TargetPresentationProvider$0_2).w6q = function (target) {
    return this.nmg_1(target);
  };
  protoOf(sam$jetbrains_ocelot_langDef_references_TargetPresentationProvider$0_2).f3 = function () {
    return this.nmg_1;
  };
  protoOf(sam$jetbrains_ocelot_langDef_references_TargetPresentationProvider$0_2).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, TargetPresentationProvider) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_langDef_references_TargetPresentationProvider$0_2).hashCode = function () {
    return hashCode(this.f3());
  };
  function btbPrecalculatedResolve$lambda$lambda(it) {
    _init_properties_BTBResolvers_kt__y423vn();
    return it.li1();
  }
  function btbLocalResolve$lambda($this$referenceFactories) {
    _init_properties_BTBResolvers_kt__y423vn();
    scoped($this$referenceFactories, minus_1(minus_1(get_refTags($this$referenceFactories), Companion_getInstance_328().hhn_1), Companion_getInstance_335().dh6_1));
    var publishedWorkReferenceResolver = new PublishedWorkReferenceResolver(Companion_instance_88.e3b($this$referenceFactories));
    $this$referenceFactories.j6t(Companion_getInstance_328().hhn_1, Companion_instance_102.a6t(publishedWorkReferenceResolver));
    var ontologyLibraryReferenceResolver = new ScopedReferenceResolver(Companion_getInstance_335().dh6_1, ScopeConfigService_instance.e3b($this$referenceFactories), new DocumentNodeFinder(Companion_instance_107.e3b($this$referenceFactories)));
    $this$referenceFactories.j6t(Companion_getInstance_335().dh6_1, Companion_instance_102.a6t(ontologyLibraryReferenceResolver));
    return Unit_instance;
  }
  function btbLocalResolve$lambda_0($this$referenceTargetsSuppliers) {
    _init_properties_BTBResolvers_kt__y423vn();
    scoped_2($this$referenceTargetsSuppliers, minus_1(get_refTags($this$referenceTargetsSuppliers), Companion_getInstance_328().hhn_1));
    var publishedWorkReferenceTargetsSupplier = new PublishedWorkReferenceTargetsSupplier(Companion_instance_109.e3b($this$referenceTargetsSuppliers));
    $this$referenceTargetsSuppliers.b6u(Companion_getInstance_328().hhn_1, publishedWorkReferenceTargetsSupplier);
    return Unit_instance;
  }
  function btbLocalResolve$lambda_1($this$referenceTargetPresentationProviders) {
    _init_properties_BTBResolvers_kt__y423vn();
    scoped_1($this$referenceTargetPresentationProviders, minus_1(get_refTags($this$referenceTargetPresentationProviders), Companion_getInstance_328().hhn_1));
    $this$referenceTargetPresentationProviders.s6t(Companion_getInstance_328().hhn_1, new PublishedWorkReferenceTargetPresentationProvider());
    return Unit_instance;
  }
  function btbScopes$lambda($this$scopes) {
    _init_properties_BTBResolvers_kt__y423vn();
    var librariesScopeProvider$delegate = Companion_instance_109.w2w();
    var subtypeScopeFilters$delegate = Companion_getInstance_360().w2w();
    var taxonScopeFilters$delegate = Companion_getInstance_361().w2w();
    var objectPropertyDomainFilters$delegate = Companion_getInstance_359().w2w();
    var nonGroupingFilters$delegate = Companion_getInstance_358().w2w();
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder = btbScopes$lambda$slambda_0(null);
    var evaluationStrategy = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp;
    if (null == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs = tmp;
    var origin = tmp1_elvis_lhs == null ? Lexical_getInstance() : tmp1_elvis_lhs;
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(FactSet_1)), getKClass(Fact_1), evaluationStrategy, origin, builder));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_0 = btbScopes$lambda$slambda_2(null);
    var evaluationStrategy_0 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_0;
    if (null == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_0 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_0 = tmp_0;
    var origin_0 = tmp1_elvis_lhs_0 == null ? Lexical_getInstance() : tmp1_elvis_lhs_0;
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(FactSet_1)), getKClass(VariableDeclaration_1), evaluationStrategy_0, origin_0, builder_0));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_1 = btbScopes$lambda$slambda_4(null);
    var evaluationStrategy_1 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_1;
    if (null == null) {
      tmp_1 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_1 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_1 = tmp_1;
    var origin_1 = tmp1_elvis_lhs_1 == null ? Lexical_getInstance() : tmp1_elvis_lhs_1;
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(FindNewConnectionCommand_1)), getKClass(VariableDeclaration_1), evaluationStrategy_1, origin_1, builder_1));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_2 = btbScopes$lambda$slambda_6(null);
    var evaluationStrategy_2 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_2;
    if (null == null) {
      tmp_2 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_2 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_2 = tmp_2;
    var origin_2 = tmp1_elvis_lhs_2 == null ? Lexical_getInstance() : tmp1_elvis_lhs_2;
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(Fact_1)), getKClass(Fact_1), evaluationStrategy_2, origin_2, builder_2));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_3 = btbScopes$lambda$slambda_8(null);
    var evaluationStrategy_3 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_3;
    if (null == null) {
      tmp_3 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_3 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_3 = tmp_3;
    var origin_3 = tmp1_elvis_lhs_3 == null ? Lexical_getInstance() : tmp1_elvis_lhs_3;
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(FactSet_1)), getKClass(NewFact), evaluationStrategy_3, origin_3, builder_3));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_4 = btbScopes$lambda$slambda_10(null);
    var evaluationStrategy_4 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_4;
    if (null == null) {
      tmp_4 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_4 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_4 = tmp_4;
    var origin_4 = tmp1_elvis_lhs_4 == null ? Lexical_getInstance() : tmp1_elvis_lhs_4;
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(NewFact)), getKClass(NewFact), evaluationStrategy_4, origin_4, builder_4));
    var tmp2 = get_elementTypeAndTaxon();
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.constrainScope' call
    var builder_5 = btbScopes$lambda$slambda_12($this$scopes, taxonScopeFilters$delegate, null);
    var tmp_5;
    if (null == null) {
      tmp_5 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_5 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_5 = tmp_5;
    var origin_5 = tmp1_elvis_lhs_5 == null ? Lexical_getInstance() : tmp1_elvis_lhs_5;
    $this$scopes.b75(new ConstrainScope($this$scopes.a75(getKClass(FactSet_1)), tmp2, origin_5, builder_5));
    var tmp_6 = $this$scopes.t74($this$scopes.o75(getKClass(FindConnectionCommand_1), getKClass(OntologyElement_1)), get_elementTypeAndTaxon());
    $this$scopes.n75(tmp_6, btbScopes$lambda$slambda_14($this$scopes, taxonScopeFilters$delegate, null));
    var tmp_7 = $this$scopes.t74($this$scopes.o75(getKClass(FindNewConnectionCommand_1), getKClass(OntologyElement_1)), get_elementTypeAndTaxon());
    $this$scopes.n75(tmp_7, btbScopes$lambda$slambda_16($this$scopes, taxonScopeFilters$delegate, null));
    var tmp2_0 = get_elementTypeAndTaxon();
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.constrainScope' call
    var builder_6 = btbScopes$lambda$slambda_18(null);
    var tmp_8;
    if (null == null) {
      tmp_8 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_8 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_6 = tmp_8;
    var origin_6 = tmp1_elvis_lhs_6 == null ? Lexical_getInstance() : tmp1_elvis_lhs_6;
    $this$scopes.b75(new ConstrainScope($this$scopes.a75(getKClass(OntologyIsRelation_1)), tmp2_0, origin_6, builder_6));
    var tmp2_1 = OntologyElementConcept_getInstance().igz_1.r6i_1;
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_7 = btbScopes$lambda$slambda_20(null);
    var evaluationStrategy_5 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_9;
    if (tmp2_1 == null) {
      tmp_9 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_9 = new LexicalWithRole(tmp2_1);
    }
    var tmp1_elvis_lhs_7 = tmp_9;
    var origin_7 = tmp1_elvis_lhs_7 == null ? Lexical_getInstance() : tmp1_elvis_lhs_7;
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(OntologyElement_1)), getKClass(OntologyLibrary_1), evaluationStrategy_5, origin_7, builder_7));
    var tmp2_2 = OntologyElementConcept_getInstance().igz_1.r6i_1;
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_8 = btbScopes$lambda$slambda_22(null);
    var evaluationStrategy_6 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_10;
    if (tmp2_2 == null) {
      tmp_10 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_10 = new LexicalWithRole(tmp2_2);
    }
    var tmp1_elvis_lhs_8 = tmp_10;
    var origin_8 = tmp1_elvis_lhs_8 == null ? Lexical_getInstance() : tmp1_elvis_lhs_8;
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(OntologyElement_1)), getKClass(OntologyElement_1), evaluationStrategy_6, origin_8, builder_8));
    var tmp2_3 = OntologyElementConcept_getInstance().jgz_1.r6i_1;
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_9 = btbScopes$lambda$slambda_24(null);
    var evaluationStrategy_7 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_11;
    if (tmp2_3 == null) {
      tmp_11 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_11 = new LexicalWithRole(tmp2_3);
    }
    var tmp1_elvis_lhs_9 = tmp_11;
    var origin_9 = tmp1_elvis_lhs_9 == null ? Lexical_getInstance() : tmp1_elvis_lhs_9;
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(OntologyElement_1)), getKClass(OntologyLibrary_1), evaluationStrategy_7, origin_9, builder_9));
    var tmp2_4 = OntologyElementConcept_getInstance().rgz_1.r6i_1;
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_10 = btbScopes$lambda$slambda_26(null);
    var evaluationStrategy_8 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_12;
    if (tmp2_4 == null) {
      tmp_12 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_12 = new LexicalWithRole(tmp2_4);
    }
    var tmp1_elvis_lhs_10 = tmp_12;
    var origin_10 = tmp1_elvis_lhs_10 == null ? Lexical_getInstance() : tmp1_elvis_lhs_10;
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(OntologyElement_1)), getKClass(OntologyLibrary_1), evaluationStrategy_8, origin_10, builder_10));
    var tmp2_5 = OntologyElementConcept_getInstance().kgz_1.r6i_1;
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_11 = btbScopes$lambda$slambda_28(null);
    var evaluationStrategy_9 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_13;
    if (tmp2_5 == null) {
      tmp_13 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_13 = new LexicalWithRole(tmp2_5);
    }
    var tmp1_elvis_lhs_11 = tmp_13;
    var origin_11 = tmp1_elvis_lhs_11 == null ? Lexical_getInstance() : tmp1_elvis_lhs_11;
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(OntologyElement_1)), getKClass(OntologyLibrary_1), evaluationStrategy_9, origin_11, builder_11));
    var tmp2_6 = OntologyElementConcept_getInstance().kgz_1.r6i_1;
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_12 = btbScopes$lambda$slambda_30(null);
    var evaluationStrategy_10 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_14;
    if (tmp2_6 == null) {
      tmp_14 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_14 = new LexicalWithRole(tmp2_6);
    }
    var tmp1_elvis_lhs_12 = tmp_14;
    var origin_12 = tmp1_elvis_lhs_12 == null ? Lexical_getInstance() : tmp1_elvis_lhs_12;
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(OntologyElement_1)), getKClass(OntologyElement_1), evaluationStrategy_10, origin_12, builder_12));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_13 = btbScopes$lambda$slambda_32($this$scopes, librariesScopeProvider$delegate, null);
    var evaluationStrategy_11 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_15;
    if (null == null) {
      tmp_15 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_15 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_13 = tmp_15;
    var origin_13 = tmp1_elvis_lhs_13 == null ? Lexical_getInstance() : tmp1_elvis_lhs_13;
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(OntologyLibrary_1)), getKClass(OntologyLibrary_1), evaluationStrategy_11, origin_13, builder_13));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.defaultScope' call
    var builder_14 = btbScopes$lambda$slambda_34($this$scopes, librariesScopeProvider$delegate, null);
    $this$scopes.b75(new DefaultScope(getKClass(OntologyLibrary_1), builder_14));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_15 = btbScopes$lambda$slambda_36(null);
    var evaluationStrategy_12 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_16;
    if (null == null) {
      tmp_16 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_16 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_14 = tmp_16;
    var origin_14 = tmp1_elvis_lhs_14 == null ? Lexical_getInstance() : tmp1_elvis_lhs_14;
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(Context_2)), getKClass(OntologyElement_1), evaluationStrategy_12, origin_14, builder_15));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_16 = btbScopes$lambda$slambda_38(null);
    var evaluationStrategy_13 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_17;
    if (null == null) {
      tmp_17 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_17 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_15 = tmp_17;
    var origin_15 = tmp1_elvis_lhs_15 == null ? Lexical_getInstance() : tmp1_elvis_lhs_15;
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(ContextQuery_1)), getKClass(OntologyElement_1), evaluationStrategy_13, origin_15, builder_16));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_17 = btbScopes$lambda$slambda_40(null);
    var evaluationStrategy_14 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_18;
    if (null == null) {
      tmp_18 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_18 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_16 = tmp_18;
    var origin_16 = tmp1_elvis_lhs_16 == null ? Lexical_getInstance() : tmp1_elvis_lhs_16;
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(QualifiedOntologyElementReference_1)), getKClass(OntologyElement_1), evaluationStrategy_14, origin_16, builder_17));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_18 = btbScopes$lambda$slambda_42(null);
    var evaluationStrategy_15 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_19;
    if (null == null) {
      tmp_19 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_19 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_17 = tmp_19;
    var origin_17 = tmp1_elvis_lhs_17 == null ? Lexical_getInstance() : tmp1_elvis_lhs_17;
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(Category_1)), getKClass(OntologyElement_1), evaluationStrategy_15, origin_17, builder_18));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_19 = btbScopes$lambda$slambda_44(null);
    var evaluationStrategy_16 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_20;
    if (null == null) {
      tmp_20 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_20 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_18 = tmp_20;
    var origin_18 = tmp1_elvis_lhs_18 == null ? Lexical_getInstance() : tmp1_elvis_lhs_18;
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(OntologyImport_1)), getKClass(OntologyElement_1), evaluationStrategy_16, origin_18, builder_19));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_20 = btbScopes$lambda$slambda_46(null);
    var evaluationStrategy_17 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_21;
    if (null == null) {
      tmp_21 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_21 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_19 = tmp_21;
    var origin_19 = tmp1_elvis_lhs_19 == null ? Lexical_getInstance() : tmp1_elvis_lhs_19;
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(OntologyElementType_1)), getKClass(OntologyElement_1), evaluationStrategy_17, origin_19, builder_20));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_21 = btbScopes$lambda$slambda_48(null);
    var evaluationStrategy_18 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_22;
    if (null == null) {
      tmp_22 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_22 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_20 = tmp_22;
    var origin_20 = tmp1_elvis_lhs_20 == null ? Lexical_getInstance() : tmp1_elvis_lhs_20;
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(OntologyElementPropertyType_1)), getKClass(OntologyElement_1), evaluationStrategy_18, origin_20, builder_21));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_22 = btbScopes$lambda$slambda_50(null);
    var evaluationStrategy_19 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_23;
    if (null == null) {
      tmp_23 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_23 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_21 = tmp_23;
    var origin_21 = tmp1_elvis_lhs_21 == null ? Lexical_getInstance() : tmp1_elvis_lhs_21;
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(QueryParametersBlackList)), getKClass(OntologyElement_1), evaluationStrategy_19, origin_21, builder_22));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_23 = btbScopes$lambda$slambda_52(null);
    var evaluationStrategy_20 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_24;
    if (null == null) {
      tmp_24 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_24 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_22 = tmp_24;
    var origin_22 = tmp1_elvis_lhs_22 == null ? Lexical_getInstance() : tmp1_elvis_lhs_22;
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(ObjectPropertyDeclaration_1)), getKClass(ObjectPropertyDeclaration_1), evaluationStrategy_20, origin_22, builder_23));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_24 = btbScopes$lambda$slambda_54($this$scopes, librariesScopeProvider$delegate, null);
    var evaluationStrategy_21 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_25;
    if (null == null) {
      tmp_25 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_25 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_23 = tmp_25;
    var origin_23 = tmp1_elvis_lhs_23 == null ? Lexical_getInstance() : tmp1_elvis_lhs_23;
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(PartValue)), getKClass(FieldDeclaration_1), evaluationStrategy_21, origin_23, builder_24));
    var tmp2_7 = get_elementTypeAndTaxon();
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.constrainScope' call
    var builder_25 = btbScopes$lambda$slambda_56($this$scopes, subtypeScopeFilters$delegate, null);
    var tmp_26;
    if (null == null) {
      tmp_26 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_26 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_24 = tmp_26;
    var origin_24 = tmp1_elvis_lhs_24 == null ? Lexical_getInstance() : tmp1_elvis_lhs_24;
    $this$scopes.b75(new ConstrainScope($this$scopes.a75(getKClass(OntologyLinkValue_1)), tmp2_7, origin_24, builder_25));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_26 = btbScopes$lambda$slambda_58(null);
    var evaluationStrategy_22 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_27;
    if (null == null) {
      tmp_27 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_27 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_25 = tmp_27;
    var origin_25 = tmp1_elvis_lhs_25 == null ? Lexical_getInstance() : tmp1_elvis_lhs_25;
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(OntologyLinkValue_1)), getKClass(OntologyElement_1), evaluationStrategy_22, origin_25, builder_26));
    var tmp2_8 = get_elementTypeAndTaxon();
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.constrainScope' call
    var builder_27 = btbScopes$lambda$slambda_60($this$scopes, subtypeScopeFilters$delegate, null);
    var tmp_28;
    if (null == null) {
      tmp_28 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_28 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_26 = tmp_28;
    var origin_26 = tmp1_elvis_lhs_26 == null ? Lexical_getInstance() : tmp1_elvis_lhs_26;
    $this$scopes.b75(new ConstrainScope($this$scopes.a75(getKClass(ProcessPropertyValue_1)), tmp2_8, origin_26, builder_27));
    var tmp2_9 = get_elementTypeAndTaxon();
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.constrainScope' call
    var builder_28 = btbScopes$lambda$slambda_62($this$scopes, subtypeScopeFilters$delegate, null);
    var tmp_29;
    if (null == null) {
      tmp_29 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_29 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_27 = tmp_29;
    var origin_27 = tmp1_elvis_lhs_27 == null ? Lexical_getInstance() : tmp1_elvis_lhs_27;
    $this$scopes.b75(new ConstrainScope($this$scopes.a75(getKClass(InstanceRelationValue)), tmp2_9, origin_27, builder_28));
    var tmp2_10 = get_elementTypeAndTaxon();
    var tmp_30 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_0 = getPropertyCallableRef('value', 1, tmp_30, PropertyConstraint$_get_value_$ref_f1oxa5_1(), null);
    var tmp4 = new SingleChildLink(getKClass(PropertyConstraint_1), this_0);
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.constrainScope' call
    var builder_29 = btbScopes$lambda$slambda_64($this$scopes, subtypeScopeFilters$delegate, null);
    var tmp_31;
    if (tmp4 == null) {
      tmp_31 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_31 = new LexicalWithRole(tmp4);
    }
    var tmp1_elvis_lhs_28 = tmp_31;
    var origin_28 = tmp1_elvis_lhs_28 == null ? Lexical_getInstance() : tmp1_elvis_lhs_28;
    $this$scopes.b75(new ConstrainScope($this$scopes.a75(getKClass(PropertyConstraint_1)), tmp2_10, origin_28, builder_29));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_30 = btbScopes$lambda$slambda_66(null);
    var evaluationStrategy_23 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_32;
    if (null == null) {
      tmp_32 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_32 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_29 = tmp_32;
    var origin_29 = tmp1_elvis_lhs_29 == null ? Lexical_getInstance() : tmp1_elvis_lhs_29;
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(PropertyConstraint_1)), getKClass(OntologyLibrary_1), evaluationStrategy_23, origin_29, builder_30));
    var tmp2_11 = get_elementTypeAndTaxon();
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.constrainScope' call
    var builder_31 = btbScopes$lambda$slambda_68($this$scopes, subtypeScopeFilters$delegate, null);
    var tmp_33;
    if (null == null) {
      tmp_33 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_33 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_30 = tmp_33;
    var origin_30 = tmp1_elvis_lhs_30 == null ? Lexical_getInstance() : tmp1_elvis_lhs_30;
    $this$scopes.b75(new ConstrainScope($this$scopes.a75(getKClass(IsExpression_1)), tmp2_11, origin_30, builder_31));
    var tmp2_12 = get_elementTypeAndTaxon();
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.constrainScope' call
    var builder_32 = btbScopes$lambda$slambda_70($this$scopes, subtypeScopeFilters$delegate, null);
    var tmp_34;
    if (null == null) {
      tmp_34 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_34 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_31 = tmp_34;
    var origin_31 = tmp1_elvis_lhs_31 == null ? Lexical_getInstance() : tmp1_elvis_lhs_31;
    $this$scopes.b75(new ConstrainScope($this$scopes.a75(getKClass(ProcessPropertyDefault_1)), tmp2_12, origin_31, builder_32));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_33 = btbScopes$lambda$slambda_72(null);
    var evaluationStrategy_24 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_35;
    if (null == null) {
      tmp_35 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_35 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_32 = tmp_35;
    var origin_32 = tmp1_elvis_lhs_32 == null ? Lexical_getInstance() : tmp1_elvis_lhs_32;
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(ProcessPropertyValue_1)), getKClass(OntologyElement_1), evaluationStrategy_24, origin_32, builder_33));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_34 = btbScopes$lambda$slambda_74(null);
    var evaluationStrategy_25 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_36;
    if (null == null) {
      tmp_36 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_36 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_33 = tmp_36;
    var origin_33 = tmp1_elvis_lhs_33 == null ? Lexical_getInstance() : tmp1_elvis_lhs_33;
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(IsExpression_1)), getKClass(OntologyElement_1), evaluationStrategy_25, origin_33, builder_34));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_35 = btbScopes$lambda$slambda_76(null);
    var evaluationStrategy_26 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_37;
    if (null == null) {
      tmp_37 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_37 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_34 = tmp_37;
    var origin_34 = tmp1_elvis_lhs_34 == null ? Lexical_getInstance() : tmp1_elvis_lhs_34;
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(OntologyElementReferenceValueLibrary_1)), getKClass(OntologyElement_1), evaluationStrategy_26, origin_34, builder_35));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideImportScope' call
    var builder_36 = btbScopes$lambda$slambda_78(null);
    var evaluationStrategy_27 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(EnumerableNotion_1)), getKClass(EnumerationConstant_1), evaluationStrategy_27, Import_getInstance(), builder_36));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideImportScope' call
    var builder_37 = btbScopes$lambda$slambda_80(null);
    var evaluationStrategy_28 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(MeasurableNotion_1)), getKClass(MeasurementUnit_1), evaluationStrategy_28, Import_getInstance(), builder_37));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideImportScope' call
    var builder_38 = btbScopes$lambda$slambda_82(null);
    var evaluationStrategy_29 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(PropertyDeclaration_1)), getKClass(MeasurementUnit_1), evaluationStrategy_29, Import_getInstance(), builder_38));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideCommonScope' call
    var builder_39 = btbScopes$lambda$slambda_84(null);
    var evaluationStrategy_30 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(ProcessProperty_1)), getKClass(MeasurementUnit_1), evaluationStrategy_30, Any_getInstance(), builder_39));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideImportScope' call
    var builder_40 = btbScopes$lambda$slambda_86(null);
    var evaluationStrategy_31 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(InstanceRelationDeclaration)), getKClass(MeasurementUnit_1), evaluationStrategy_31, Import_getInstance(), builder_40));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideImportScope' call
    var builder_41 = btbScopes$lambda$slambda_88(null);
    var evaluationStrategy_32 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(ObjectPropertyDeclaration_1)), getKClass(MeasurementUnit_1), evaluationStrategy_32, Import_getInstance(), builder_41));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideImportScope' call
    var builder_42 = btbScopes$lambda$slambda_90(null);
    var evaluationStrategy_33 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(PropertyDeclaration_1)), getKClass(EnumerationConstant_1), evaluationStrategy_33, Import_getInstance(), builder_42));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideCommonScope' call
    var builder_43 = btbScopes$lambda$slambda_92(null);
    var evaluationStrategy_34 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(ProcessProperty_1)), getKClass(EnumerationConstant_1), evaluationStrategy_34, Any_getInstance(), builder_43));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideImportScope' call
    var builder_44 = btbScopes$lambda$slambda_94(null);
    var evaluationStrategy_35 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(InstanceRelationDeclaration)), getKClass(EnumerationConstant_1), evaluationStrategy_35, Import_getInstance(), builder_44));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideImportScope' call
    var builder_45 = btbScopes$lambda$slambda_96(null);
    var evaluationStrategy_36 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(ObjectPropertyDeclaration_1)), getKClass(EnumerationConstant_1), evaluationStrategy_36, Import_getInstance(), builder_45));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideImportScope' call
    var builder_46 = btbScopes$lambda$slambda_98(null);
    var evaluationStrategy_37 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(PropertyDeclaration_1)), getKClass(ComplexNotion_1), evaluationStrategy_37, Import_getInstance(), builder_46));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideImportScope' call
    var builder_47 = btbScopes$lambda$slambda_100(null);
    var evaluationStrategy_38 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(InstanceRelationDeclaration)), getKClass(ComplexNotion_1), evaluationStrategy_38, Import_getInstance(), builder_47));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideImportScope' call
    var builder_48 = btbScopes$lambda$slambda_102(null);
    var evaluationStrategy_39 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(ObjectPropertyDeclaration_1)), getKClass(ComplexNotion_1), evaluationStrategy_39, Import_getInstance(), builder_48));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_49 = btbScopes$lambda$slambda_104(null);
    var evaluationStrategy_40 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_38;
    if (null == null) {
      tmp_38 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_38 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_35 = tmp_38;
    var origin_35 = tmp1_elvis_lhs_35 == null ? Lexical_getInstance() : tmp1_elvis_lhs_35;
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(PropertyValue_1)), getKClass(ComplexNotion_1), evaluationStrategy_40, origin_35, builder_49));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_50 = btbScopes$lambda$slambda_106(null);
    var evaluationStrategy_41 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_39;
    if (null == null) {
      tmp_39 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_39 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_36 = tmp_39;
    var origin_36 = tmp1_elvis_lhs_36 == null ? Lexical_getInstance() : tmp1_elvis_lhs_36;
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(ProcessPropertyValue_1)), getKClass(ComplexNotion_1), evaluationStrategy_41, origin_36, builder_50));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_51 = btbScopes$lambda$slambda_108(null);
    var evaluationStrategy_42 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_40;
    if (null == null) {
      tmp_40 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_40 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_37 = tmp_40;
    var origin_37 = tmp1_elvis_lhs_37 == null ? Lexical_getInstance() : tmp1_elvis_lhs_37;
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(InstanceRelationValue)), getKClass(ComplexNotion_1), evaluationStrategy_42, origin_37, builder_51));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_52 = btbScopes$lambda$slambda_110(null);
    var evaluationStrategy_43 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_41;
    if (null == null) {
      tmp_41 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_41 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_38 = tmp_41;
    var origin_38 = tmp1_elvis_lhs_38 == null ? Lexical_getInstance() : tmp1_elvis_lhs_38;
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(PropertyConstraint_1)), getKClass(ComplexNotion_1), evaluationStrategy_43, origin_38, builder_52));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_53 = btbScopes$lambda$slambda_112(null);
    var evaluationStrategy_44 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_42;
    if (null == null) {
      tmp_42 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_42 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_39 = tmp_42;
    var origin_39 = tmp1_elvis_lhs_39 == null ? Lexical_getInstance() : tmp1_elvis_lhs_39;
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(IsExpression_1)), getKClass(ComplexNotion_1), evaluationStrategy_44, origin_39, builder_53));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideCommonScope' call
    var builder_54 = btbScopes$lambda$slambda_114(null);
    var evaluationStrategy_45 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(ProcessProperty_1)), getKClass(ComplexNotion_1), evaluationStrategy_45, Any_getInstance(), builder_54));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideCommonScope' call
    var builder_55 = btbScopes$lambda$slambda_116(null);
    var evaluationStrategy_46 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(ComplexNotion_1)), getKClass(ComplexNotionElement_1), evaluationStrategy_46, Any_getInstance(), builder_55));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_56 = btbScopes$lambda$slambda_118(null);
    var evaluationStrategy_47 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_43;
    if (null == null) {
      tmp_43 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_43 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_40 = tmp_43;
    var origin_40 = tmp1_elvis_lhs_40 == null ? Lexical_getInstance() : tmp1_elvis_lhs_40;
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(ComplexNotionValue_1)), getKClass(ComplexNotionElement_1), evaluationStrategy_47, origin_40, builder_56));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_57 = btbScopes$lambda$slambda_120(null);
    var evaluationStrategy_48 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_44;
    if (null == null) {
      tmp_44 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_44 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_41 = tmp_44;
    var origin_41 = tmp1_elvis_lhs_41 == null ? Lexical_getInstance() : tmp1_elvis_lhs_41;
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(ComplexNotionElementValue_1)), getKClass(ComplexNotion_1), evaluationStrategy_48, origin_41, builder_57));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_58 = btbScopes$lambda$slambda_122(null);
    var evaluationStrategy_49 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_45;
    if (null == null) {
      tmp_45 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_45 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_42 = tmp_45;
    var origin_42 = tmp1_elvis_lhs_42 == null ? Lexical_getInstance() : tmp1_elvis_lhs_42;
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(ComplexNotionElementValue_1)), getKClass(EnumerationConstant_1), evaluationStrategy_49, origin_42, builder_58));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_59 = btbScopes$lambda$slambda_124(null);
    var evaluationStrategy_50 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_46;
    if (null == null) {
      tmp_46 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_46 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_43 = tmp_46;
    var origin_43 = tmp1_elvis_lhs_43 == null ? Lexical_getInstance() : tmp1_elvis_lhs_43;
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(ComplexNotionElementValue_1)), getKClass(MeasurementUnit_1), evaluationStrategy_50, origin_43, builder_59));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_60 = btbScopes$lambda$slambda_126(null);
    var evaluationStrategy_51 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_47;
    if (null == null) {
      tmp_47 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_47 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_44 = tmp_47;
    var origin_44 = tmp1_elvis_lhs_44 == null ? Lexical_getInstance() : tmp1_elvis_lhs_44;
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(ComplexNotionElement_1)), getKClass(AbstractNotion), evaluationStrategy_51, origin_44, builder_60));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideImportScope' call
    var builder_61 = btbScopes$lambda$slambda_128($this$scopes, objectPropertyDomainFilters$delegate, null);
    var evaluationStrategy_52 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(ObjectPropertyDeclaration_1)), getKClass(ObjectPropertyDeclaration_1), evaluationStrategy_52, Import_getInstance(), builder_61));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_62 = btbScopes$lambda$slambda_130(null);
    var evaluationStrategy_53 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_48;
    if (null == null) {
      tmp_48 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_48 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_45 = tmp_48;
    var origin_45 = tmp1_elvis_lhs_45 == null ? Lexical_getInstance() : tmp1_elvis_lhs_45;
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(ProcessPropertyValue_1)), getKClass(MeasurementUnit_1), evaluationStrategy_53, origin_45, builder_62));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_63 = btbScopes$lambda$slambda_132(null);
    var evaluationStrategy_54 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_49;
    if (null == null) {
      tmp_49 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_49 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_46 = tmp_49;
    var origin_46 = tmp1_elvis_lhs_46 == null ? Lexical_getInstance() : tmp1_elvis_lhs_46;
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(PropertyValue_1)), getKClass(MeasurementUnit_1), evaluationStrategy_54, origin_46, builder_63));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_64 = btbScopes$lambda$slambda_134(null);
    var evaluationStrategy_55 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_50;
    if (null == null) {
      tmp_50 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_50 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_47 = tmp_50;
    var origin_47 = tmp1_elvis_lhs_47 == null ? Lexical_getInstance() : tmp1_elvis_lhs_47;
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(InstanceRelationValue)), getKClass(MeasurementUnit_1), evaluationStrategy_55, origin_47, builder_64));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_65 = btbScopes$lambda$slambda_136(null);
    var evaluationStrategy_56 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_51;
    if (null == null) {
      tmp_51 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_51 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_48 = tmp_51;
    var origin_48 = tmp1_elvis_lhs_48 == null ? Lexical_getInstance() : tmp1_elvis_lhs_48;
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(PropertyConstraint_1)), getKClass(MeasurementUnit_1), evaluationStrategy_56, origin_48, builder_65));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_66 = btbScopes$lambda$slambda_138(null);
    var evaluationStrategy_57 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_52;
    if (null == null) {
      tmp_52 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_52 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_49 = tmp_52;
    var origin_49 = tmp1_elvis_lhs_49 == null ? Lexical_getInstance() : tmp1_elvis_lhs_49;
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(IsExpression_1)), getKClass(MeasurementUnit_1), evaluationStrategy_57, origin_49, builder_66));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_67 = btbScopes$lambda$slambda_140(null);
    var evaluationStrategy_58 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_53;
    if (null == null) {
      tmp_53 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_53 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_50 = tmp_53;
    var origin_50 = tmp1_elvis_lhs_50 == null ? Lexical_getInstance() : tmp1_elvis_lhs_50;
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(PropertyDeclarationValueQuery_1)), getKClass(MeasurementUnit_1), evaluationStrategy_58, origin_50, builder_67));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_68 = btbScopes$lambda$slambda_142(null);
    var evaluationStrategy_59 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_54;
    if (null == null) {
      tmp_54 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_54 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_51 = tmp_54;
    var origin_51 = tmp1_elvis_lhs_51 == null ? Lexical_getInstance() : tmp1_elvis_lhs_51;
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(PropertyValue_1)), getKClass(EnumerationConstant_1), evaluationStrategy_59, origin_51, builder_68));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_69 = btbScopes$lambda$slambda_144(null);
    var evaluationStrategy_60 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_55;
    if (null == null) {
      tmp_55 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_55 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_52 = tmp_55;
    var origin_52 = tmp1_elvis_lhs_52 == null ? Lexical_getInstance() : tmp1_elvis_lhs_52;
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(ProcessPropertyValue_1)), getKClass(EnumerationConstant_1), evaluationStrategy_60, origin_52, builder_69));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_70 = btbScopes$lambda$slambda_146(null);
    var evaluationStrategy_61 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_56;
    if (null == null) {
      tmp_56 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_56 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_53 = tmp_56;
    var origin_53 = tmp1_elvis_lhs_53 == null ? Lexical_getInstance() : tmp1_elvis_lhs_53;
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(InstanceRelationValue)), getKClass(EnumerationConstant_1), evaluationStrategy_61, origin_53, builder_70));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_71 = btbScopes$lambda$slambda_148(null);
    var evaluationStrategy_62 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_57;
    if (null == null) {
      tmp_57 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_57 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_54 = tmp_57;
    var origin_54 = tmp1_elvis_lhs_54 == null ? Lexical_getInstance() : tmp1_elvis_lhs_54;
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(PropertyConstraint_1)), getKClass(EnumerationConstant_1), evaluationStrategy_62, origin_54, builder_71));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_72 = btbScopes$lambda$slambda_150(null);
    var evaluationStrategy_63 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_58;
    if (null == null) {
      tmp_58 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_58 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_55 = tmp_58;
    var origin_55 = tmp1_elvis_lhs_55 == null ? Lexical_getInstance() : tmp1_elvis_lhs_55;
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(IsExpression_1)), getKClass(EnumerationConstant_1), evaluationStrategy_63, origin_55, builder_72));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_73 = btbScopes$lambda$slambda_152(null);
    var evaluationStrategy_64 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_59;
    if (null == null) {
      tmp_59 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_59 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_56 = tmp_59;
    var origin_56 = tmp1_elvis_lhs_56 == null ? Lexical_getInstance() : tmp1_elvis_lhs_56;
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(ProcessPropertyValue_1)), getKClass(ProcessRelationDeclaration_1), evaluationStrategy_64, origin_56, builder_73));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_74 = btbScopes$lambda$slambda_154(null);
    var evaluationStrategy_65 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_60;
    if (null == null) {
      tmp_60 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_60 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_57 = tmp_60;
    var origin_57 = tmp1_elvis_lhs_57 == null ? Lexical_getInstance() : tmp1_elvis_lhs_57;
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(ProcessPropertyValue_1)), getKClass(NewFact), evaluationStrategy_65, origin_57, builder_74));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_75 = btbScopes$lambda$slambda_156(null);
    var evaluationStrategy_66 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_61;
    if (null == null) {
      tmp_61 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_61 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_58 = tmp_61;
    var origin_58 = tmp1_elvis_lhs_58 == null ? Lexical_getInstance() : tmp1_elvis_lhs_58;
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(ProcessPropertyValue_1)), getKClass(ProcessDeclaration_1), evaluationStrategy_66, origin_58, builder_75));
    var tmp_62 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_1 = getPropertyCallableRef('value', 1, tmp_62, ProcessPropertyValue$_get_value_$ref_tp5tnc_1(), null);
    var tmp2_13 = new SingleChildLink(getKClass(ProcessPropertyValue_1), this_1);
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_76 = btbScopes$lambda$slambda_158(null);
    var evaluationStrategy_67 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_63;
    if (tmp2_13 == null) {
      tmp_63 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_63 = new LexicalWithRole(tmp2_13);
    }
    var tmp1_elvis_lhs_59 = tmp_63;
    var origin_59 = tmp1_elvis_lhs_59 == null ? Lexical_getInstance() : tmp1_elvis_lhs_59;
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(ProcessPropertyValue_1)), getKClass(ProcessProperty_1), evaluationStrategy_67, origin_59, builder_76));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_77 = btbScopes$lambda$slambda_160(null);
    var evaluationStrategy_68 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_64;
    if (null == null) {
      tmp_64 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_64 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_60 = tmp_64;
    var origin_60 = tmp1_elvis_lhs_60 == null ? Lexical_getInstance() : tmp1_elvis_lhs_60;
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(PropertyConstraint_1)), getKClass(ProcessRelationDeclaration_1), evaluationStrategy_68, origin_60, builder_77));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_78 = btbScopes$lambda$slambda_162(null);
    var evaluationStrategy_69 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_65;
    if (null == null) {
      tmp_65 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_65 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_61 = tmp_65;
    var origin_61 = tmp1_elvis_lhs_61 == null ? Lexical_getInstance() : tmp1_elvis_lhs_61;
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(PropertyConstraint_1)), getKClass(NewFact), evaluationStrategy_69, origin_61, builder_78));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_79 = btbScopes$lambda$slambda_164(null);
    var evaluationStrategy_70 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_66;
    if (null == null) {
      tmp_66 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_66 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_62 = tmp_66;
    var origin_62 = tmp1_elvis_lhs_62 == null ? Lexical_getInstance() : tmp1_elvis_lhs_62;
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(PropertyConstraint_1)), getKClass(ProcessDeclaration_1), evaluationStrategy_70, origin_62, builder_79));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_80 = btbScopes$lambda$slambda_166(null);
    var evaluationStrategy_71 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_67;
    if (null == null) {
      tmp_67 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_67 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_63 = tmp_67;
    var origin_63 = tmp1_elvis_lhs_63 == null ? Lexical_getInstance() : tmp1_elvis_lhs_63;
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(IsExpression_1)), getKClass(ProcessRelationDeclaration_1), evaluationStrategy_71, origin_63, builder_80));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_81 = btbScopes$lambda$slambda_168(null);
    var evaluationStrategy_72 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_68;
    if (null == null) {
      tmp_68 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_68 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_64 = tmp_68;
    var origin_64 = tmp1_elvis_lhs_64 == null ? Lexical_getInstance() : tmp1_elvis_lhs_64;
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(IsExpression_1)), getKClass(NewFact), evaluationStrategy_72, origin_64, builder_81));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_82 = btbScopes$lambda$slambda_170(null);
    var evaluationStrategy_73 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_69;
    if (null == null) {
      tmp_69 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_69 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_65 = tmp_69;
    var origin_65 = tmp1_elvis_lhs_65 == null ? Lexical_getInstance() : tmp1_elvis_lhs_65;
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(IsExpression_1)), getKClass(ProcessDeclaration_1), evaluationStrategy_73, origin_65, builder_82));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_83 = btbScopes$lambda$slambda_172(null);
    var evaluationStrategy_74 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_70;
    if (null == null) {
      tmp_70 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_70 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_66 = tmp_70;
    var origin_66 = tmp1_elvis_lhs_66 == null ? Lexical_getInstance() : tmp1_elvis_lhs_66;
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(OneOf_1)), getKClass(ProcessRelationDeclaration_1), evaluationStrategy_74, origin_66, builder_83));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_84 = btbScopes$lambda$slambda_174(null);
    var evaluationStrategy_75 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_71;
    if (null == null) {
      tmp_71 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_71 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_67 = tmp_71;
    var origin_67 = tmp1_elvis_lhs_67 == null ? Lexical_getInstance() : tmp1_elvis_lhs_67;
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(OneOf_1)), getKClass(NewFact), evaluationStrategy_75, origin_67, builder_84));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_85 = btbScopes$lambda$slambda_176(null);
    var evaluationStrategy_76 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_72;
    if (null == null) {
      tmp_72 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_72 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_68 = tmp_72;
    var origin_68 = tmp1_elvis_lhs_68 == null ? Lexical_getInstance() : tmp1_elvis_lhs_68;
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(OneOf_1)), getKClass(ProcessDeclaration_1), evaluationStrategy_76, origin_68, builder_85));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_86 = btbScopes$lambda$slambda_178(null);
    var evaluationStrategy_77 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_73;
    if (null == null) {
      tmp_73 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_73 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_69 = tmp_73;
    var origin_69 = tmp1_elvis_lhs_69 == null ? Lexical_getInstance() : tmp1_elvis_lhs_69;
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(OneOf_1)), getKClass(OntologyLibrary_1), evaluationStrategy_77, origin_69, builder_86));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_87 = btbScopes$lambda$slambda_180(null);
    var evaluationStrategy_78 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_74;
    if (null == null) {
      tmp_74 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_74 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_70 = tmp_74;
    var origin_70 = tmp1_elvis_lhs_70 == null ? Lexical_getInstance() : tmp1_elvis_lhs_70;
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(OneOf_1)), getKClass(ModifierDeclaration), evaluationStrategy_78, origin_70, builder_87));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_88 = btbScopes$lambda$slambda_182(null);
    var evaluationStrategy_79 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_75;
    if (null == null) {
      tmp_75 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_75 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_71 = tmp_75;
    var origin_71 = tmp1_elvis_lhs_71 == null ? Lexical_getInstance() : tmp1_elvis_lhs_71;
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(PropertyDeclarationValueQuery_1)), getKClass(EnumerationConstant_1), evaluationStrategy_79, origin_71, builder_88));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_89 = btbScopes$lambda$slambda_184(null);
    var evaluationStrategy_80 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_76;
    if (null == null) {
      tmp_76 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_76 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_72 = tmp_76;
    var origin_72 = tmp1_elvis_lhs_72 == null ? Lexical_getInstance() : tmp1_elvis_lhs_72;
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(PropertyDeclarationValueQuery_1)), getKClass(EnumerationConstant_1), evaluationStrategy_80, origin_72, builder_89));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_90 = btbScopes$lambda$slambda_186($this$scopes, objectPropertyDomainFilters$delegate, nonGroupingFilters$delegate, null);
    var evaluationStrategy_81 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_77;
    if (null == null) {
      tmp_77 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_77 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_73 = tmp_77;
    var origin_73 = tmp1_elvis_lhs_73 == null ? Lexical_getInstance() : tmp1_elvis_lhs_73;
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(ObjectPropertyReferenceValue_1)), getKClass(ObjectPropertyDeclaration_1), evaluationStrategy_81, origin_73, builder_90));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_91 = btbScopes$lambda$slambda_188($this$scopes, objectPropertyDomainFilters$delegate, null);
    var evaluationStrategy_82 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_78;
    if (null == null) {
      tmp_78 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_78 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_74 = tmp_78;
    var origin_74 = tmp1_elvis_lhs_74 == null ? Lexical_getInstance() : tmp1_elvis_lhs_74;
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(OntologyElement_1)), getKClass(ObjectPropertyDeclaration_1), evaluationStrategy_82, origin_74, builder_91));
    var tmp2_14 = get_onlyOntologyVars();
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.constrainScope' call
    var builder_92 = btbScopes$lambda$slambda_190(null);
    var tmp_79;
    if (null == null) {
      tmp_79 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_79 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_75 = tmp_79;
    var origin_75 = tmp1_elvis_lhs_75 == null ? Lexical_getInstance() : tmp1_elvis_lhs_75;
    $this$scopes.b75(new ConstrainScope($this$scopes.a75(getKClass(FactSet_1)), tmp2_14, origin_75, builder_92));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_93 = btbScopes$lambda$slambda_192(null);
    var evaluationStrategy_83 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_80;
    if (null == null) {
      tmp_80 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_80 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_76 = tmp_80;
    var origin_76 = tmp1_elvis_lhs_76 == null ? Lexical_getInstance() : tmp1_elvis_lhs_76;
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(LibraryProcessSpecification_1)), getKClass(VariableDeclaration_1), evaluationStrategy_83, origin_76, builder_93));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_94 = btbScopes$lambda$slambda_194(null);
    var evaluationStrategy_84 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_81;
    if (null == null) {
      tmp_81 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_81 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_77 = tmp_81;
    var origin_77 = tmp1_elvis_lhs_77 == null ? Lexical_getInstance() : tmp1_elvis_lhs_77;
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(InstanceRelationValue)), getKClass(FunctionDeclaration_1), evaluationStrategy_84, origin_77, builder_94));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_95 = btbScopes$lambda$slambda_196(null);
    var evaluationStrategy_85 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_82;
    if (null == null) {
      tmp_82 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_82 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_78 = tmp_82;
    var origin_78 = tmp1_elvis_lhs_78 == null ? Lexical_getInstance() : tmp1_elvis_lhs_78;
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(InstanceRelationValue)), getKClass(VariableDeclaration_1), evaluationStrategy_85, origin_78, builder_95));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_96 = btbScopes$lambda$slambda_198(null);
    var evaluationStrategy_86 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_83;
    if (null == null) {
      tmp_83 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_83 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_79 = tmp_83;
    var origin_79 = tmp1_elvis_lhs_79 == null ? Lexical_getInstance() : tmp1_elvis_lhs_79;
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(ProcessPropertyValue_1)), getKClass(OntologyLibrary_1), evaluationStrategy_86, origin_79, builder_96));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_97 = btbScopes$lambda$slambda_200(null);
    var evaluationStrategy_87 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_84;
    if (null == null) {
      tmp_84 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_84 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_80 = tmp_84;
    var origin_80 = tmp1_elvis_lhs_80 == null ? Lexical_getInstance() : tmp1_elvis_lhs_80;
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(IsExpression_1)), getKClass(OntologyLibrary_1), evaluationStrategy_87, origin_80, builder_97));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_98 = btbScopes$lambda$slambda_202(null);
    var evaluationStrategy_88 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_85;
    if (null == null) {
      tmp_85 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_85 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_81 = tmp_85;
    var origin_81 = tmp1_elvis_lhs_81 == null ? Lexical_getInstance() : tmp1_elvis_lhs_81;
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(InstanceRelationValue)), getKClass(OntologyLibrary_1), evaluationStrategy_88, origin_81, builder_98));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideCommonScope' call
    var builder_99 = btbScopes$lambda$slambda_204(null);
    var evaluationStrategy_89 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(ProcessDeclaration_1)), getKClass(AbstractLink), evaluationStrategy_89, Any_getInstance(), builder_99));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideCommonScope' call
    var builder_100 = btbScopes$lambda$slambda_206(null);
    var evaluationStrategy_90 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(ProcessDeclaration_1)), getKClass(AbstractProperty), evaluationStrategy_90, Any_getInstance(), builder_100));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideCommonScope' call
    var builder_101 = btbScopes$lambda$slambda_208(null);
    var evaluationStrategy_91 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(ProcessDeclaration_1)), getKClass(ProcessProperty_1), evaluationStrategy_91, Any_getInstance(), builder_101));
    var tmp_86 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_2 = getPropertyCallableRef('aliasedProperties', 1, tmp_86, ProcessProperty$_get_aliasedProperties_$ref_lzqazi_1(), null);
    var tmp2_15 = new MultipleChildLink(getKClass(ProcessProperty_1), this_2);
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_102 = btbScopes$lambda$slambda_210(null);
    var evaluationStrategy_92 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_87;
    if (tmp2_15 == null) {
      tmp_87 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_87 = new LexicalWithRole(tmp2_15);
    }
    var tmp1_elvis_lhs_82 = tmp_87;
    var origin_82 = tmp1_elvis_lhs_82 == null ? Lexical_getInstance() : tmp1_elvis_lhs_82;
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(ProcessProperty_1)), getKClass(ProcessProperty_1), evaluationStrategy_92, origin_82, builder_102));
    var tmp_88 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_3 = getPropertyCallableRef('default', 1, tmp_88, ProcessProperty$_get_default_$ref_tilfgf_1(), null);
    var tmp2_16 = new SingleChildLink(getKClass(ProcessProperty_1), this_3);
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_103 = btbScopes$lambda$slambda_212(null);
    var evaluationStrategy_93 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_89;
    if (tmp2_16 == null) {
      tmp_89 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_89 = new LexicalWithRole(tmp2_16);
    }
    var tmp1_elvis_lhs_83 = tmp_89;
    var origin_83 = tmp1_elvis_lhs_83 == null ? Lexical_getInstance() : tmp1_elvis_lhs_83;
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(ProcessProperty_1)), getKClass(ProcessProperty_1), evaluationStrategy_93, origin_83, builder_103));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_104 = btbScopes$lambda$slambda_214(null);
    var evaluationStrategy_94 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_90;
    if (null == null) {
      tmp_90 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_90 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_84 = tmp_90;
    var origin_84 = tmp1_elvis_lhs_84 == null ? Lexical_getInstance() : tmp1_elvis_lhs_84;
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(ProcessDeclaration_1)), getKClass(VariableDeclaration_1), evaluationStrategy_94, origin_84, builder_104));
    var tmp_91 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_4 = getPropertyCallableRef('inherited', 1, tmp_91, ProcessDeclaration$_get_inherited_$ref_wglzfx_2(), null);
    var tmp2_17 = new MultipleChildLink(getKClass(ProcessDeclaration_1), this_4);
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_105 = btbScopes$lambda$slambda_216(null);
    var evaluationStrategy_95 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_92;
    if (tmp2_17 == null) {
      tmp_92 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_92 = new LexicalWithRole(tmp2_17);
    }
    var tmp1_elvis_lhs_85 = tmp_92;
    var origin_85 = tmp1_elvis_lhs_85 == null ? Lexical_getInstance() : tmp1_elvis_lhs_85;
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(ProcessDeclaration_1)), getKClass(ProcessDeclaration_1), evaluationStrategy_95, origin_85, builder_105));
    var tmp_93 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_5 = getPropertyCallableRef('prerequisites', 1, tmp_93, ProcessDeclaration$_get_prerequisites_$ref_h8hogm_1(), null);
    var tmp2_18 = new MultipleChildLink(getKClass(ProcessDeclaration_1), this_5);
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_106 = btbScopes$lambda$slambda_218(null);
    var evaluationStrategy_96 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_94;
    if (tmp2_18 == null) {
      tmp_94 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_94 = new LexicalWithRole(tmp2_18);
    }
    var tmp1_elvis_lhs_86 = tmp_94;
    var origin_86 = tmp1_elvis_lhs_86 == null ? Lexical_getInstance() : tmp1_elvis_lhs_86;
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(ProcessDeclaration_1)), getKClass(ProcessDeclaration_1), evaluationStrategy_96, origin_86, builder_106));
    var tmp_95 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_6 = getPropertyCallableRef('effects', 1, tmp_95, ProcessDeclaration$_get_effects_$ref_9vh0jp_1(), null);
    var tmp2_19 = new MultipleChildLink(getKClass(ProcessDeclaration_1), this_6);
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_107 = btbScopes$lambda$slambda_220(null);
    var evaluationStrategy_97 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_96;
    if (tmp2_19 == null) {
      tmp_96 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_96 = new LexicalWithRole(tmp2_19);
    }
    var tmp1_elvis_lhs_87 = tmp_96;
    var origin_87 = tmp1_elvis_lhs_87 == null ? Lexical_getInstance() : tmp1_elvis_lhs_87;
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(ProcessDeclaration_1)), getKClass(ProcessDeclaration_1), evaluationStrategy_97, origin_87, builder_107));
    var tmp_97 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_7 = getPropertyCallableRef('variables', 1, tmp_97, HasVariables$_get_variables_$ref_6jdr2_1(), null);
    var tmp2_20 = new MultipleChildLink(getKClass(HasVariables), this_7);
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_108 = btbScopes$lambda$slambda_222(null);
    var evaluationStrategy_98 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_98;
    if (tmp2_20 == null) {
      tmp_98 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_98 = new LexicalWithRole(tmp2_20);
    }
    var tmp1_elvis_lhs_88 = tmp_98;
    var origin_88 = tmp1_elvis_lhs_88 == null ? Lexical_getInstance() : tmp1_elvis_lhs_88;
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(ProcessDeclaration_1)), getKClass(ProcessDeclaration_1), evaluationStrategy_98, origin_88, builder_108));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_109 = btbScopes$lambda$slambda_224(null);
    var evaluationStrategy_99 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_99;
    if (null == null) {
      tmp_99 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_99 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_89 = tmp_99;
    var origin_89 = tmp1_elvis_lhs_89 == null ? Lexical_getInstance() : tmp1_elvis_lhs_89;
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(LibraryProcessSpecification_1)), getKClass(AbstractLink), evaluationStrategy_99, origin_89, builder_109));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_110 = btbScopes$lambda$slambda_226(null);
    var evaluationStrategy_100 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_100;
    if (null == null) {
      tmp_100 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_100 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_90 = tmp_100;
    var origin_90 = tmp1_elvis_lhs_90 == null ? Lexical_getInstance() : tmp1_elvis_lhs_90;
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(LibraryProcessSpecification_1)), getKClass(ProcessProperty_1), evaluationStrategy_100, origin_90, builder_110));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_111 = btbScopes$lambda$slambda_228(null);
    var evaluationStrategy_101 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_101;
    if (null == null) {
      tmp_101 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_101 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_91 = tmp_101;
    var origin_91 = tmp1_elvis_lhs_91 == null ? Lexical_getInstance() : tmp1_elvis_lhs_91;
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(LibraryProcessSpecification_1)), getKClass(AbstractProperty), evaluationStrategy_101, origin_91, builder_111));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_112 = btbScopes$lambda$slambda_230(null);
    var evaluationStrategy_102 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_102;
    if (null == null) {
      tmp_102 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_102 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_92 = tmp_102;
    var origin_92 = tmp1_elvis_lhs_92 == null ? Lexical_getInstance() : tmp1_elvis_lhs_92;
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(LibraryProcessSpecificationQuery_1)), getKClass(AbstractLink), evaluationStrategy_102, origin_92, builder_112));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_113 = btbScopes$lambda$slambda_232(null);
    var evaluationStrategy_103 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_103;
    if (null == null) {
      tmp_103 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_103 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_93 = tmp_103;
    var origin_93 = tmp1_elvis_lhs_93 == null ? Lexical_getInstance() : tmp1_elvis_lhs_93;
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(LibraryProcessSpecificationQuery_1)), getKClass(AbstractProperty), evaluationStrategy_103, origin_93, builder_113));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_114 = btbScopes$lambda$slambda_234(null);
    var evaluationStrategy_104 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_104;
    if (null == null) {
      tmp_104 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_104 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_94 = tmp_104;
    var origin_94 = tmp1_elvis_lhs_94 == null ? Lexical_getInstance() : tmp1_elvis_lhs_94;
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(LibraryProcessSpecificationQuery_1)), getKClass(ProcessProperty_1), evaluationStrategy_104, origin_94, builder_114));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_115 = btbScopes$lambda$slambda_236(null);
    var evaluationStrategy_105 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_105;
    if (null == null) {
      tmp_105 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_105 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_95 = tmp_105;
    var origin_95 = tmp1_elvis_lhs_95 == null ? Lexical_getInstance() : tmp1_elvis_lhs_95;
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(FunctionTerm_1)), getKClass(AbstractLink), evaluationStrategy_105, origin_95, builder_115));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_116 = btbScopes$lambda$slambda_238(null);
    var evaluationStrategy_106 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_106;
    if (null == null) {
      tmp_106 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_106 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_96 = tmp_106;
    var origin_96 = tmp1_elvis_lhs_96 == null ? Lexical_getInstance() : tmp1_elvis_lhs_96;
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(FunctionTerm_1)), getKClass(AbstractProperty), evaluationStrategy_106, origin_96, builder_116));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_117 = btbScopes$lambda$slambda_240(null);
    var evaluationStrategy_107 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_107;
    if (null == null) {
      tmp_107 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_107 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_97 = tmp_107;
    var origin_97 = tmp1_elvis_lhs_97 == null ? Lexical_getInstance() : tmp1_elvis_lhs_97;
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(FunctionTerm_1)), getKClass(ProcessProperty_1), evaluationStrategy_107, origin_97, builder_117));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideImportScope' call
    var builder_118 = btbScopes$lambda$slambda_242(null);
    var evaluationStrategy_108 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(FunctionDeclaration_1)), getKClass(ProcessProperty_1), evaluationStrategy_108, Import_getInstance(), builder_118));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_119 = btbScopes$lambda$slambda_244(null);
    var evaluationStrategy_109 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_108;
    if (null == null) {
      tmp_108 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_108 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_98 = tmp_108;
    var origin_98 = tmp1_elvis_lhs_98 == null ? Lexical_getInstance() : tmp1_elvis_lhs_98;
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(CustomEditor)), getKClass(ProcessProperty_1), evaluationStrategy_109, origin_98, builder_119));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_120 = btbScopes$lambda$slambda_246(null);
    var evaluationStrategy_110 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_109;
    if (null == null) {
      tmp_109 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_109 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_99 = tmp_109;
    var origin_99 = tmp1_elvis_lhs_99 == null ? Lexical_getInstance() : tmp1_elvis_lhs_99;
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(CustomEditor)), getKClass(AbstractLink), evaluationStrategy_110, origin_99, builder_120));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_121 = btbScopes$lambda$slambda_248(null);
    var evaluationStrategy_111 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_110;
    if (null == null) {
      tmp_110 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_110 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_100 = tmp_110;
    var origin_100 = tmp1_elvis_lhs_100 == null ? Lexical_getInstance() : tmp1_elvis_lhs_100;
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(CustomEditor)), getKClass(AbstractProperty), evaluationStrategy_111, origin_100, builder_121));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_122 = btbScopes$lambda$slambda_250($this$scopes, librariesScopeProvider$delegate, null);
    var evaluationStrategy_112 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_111;
    if (null == null) {
      tmp_111 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_111 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_101 = tmp_111;
    var origin_101 = tmp1_elvis_lhs_101 == null ? Lexical_getInstance() : tmp1_elvis_lhs_101;
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(LibraryProcessSpecificationQuery_1)), getKClass(LinkDeclaration_1), evaluationStrategy_112, origin_101, builder_122));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_123 = btbScopes$lambda$slambda_252($this$scopes, librariesScopeProvider$delegate, null);
    var evaluationStrategy_113 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_112;
    if (null == null) {
      tmp_112 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_112 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_102 = tmp_112;
    var origin_102 = tmp1_elvis_lhs_102 == null ? Lexical_getInstance() : tmp1_elvis_lhs_102;
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(LibraryProcessSpecificationQuery_1)), getKClass(PropertyDeclaration_1), evaluationStrategy_113, origin_102, builder_123));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_124 = btbScopes$lambda$slambda_254(null);
    var evaluationStrategy_114 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_113;
    if (null == null) {
      tmp_113 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_113 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_103 = tmp_113;
    var origin_103 = tmp1_elvis_lhs_103 == null ? Lexical_getInstance() : tmp1_elvis_lhs_103;
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(VariableDeclaration_1)), getKClass(InstanceRelationDeclaration), evaluationStrategy_114, origin_103, builder_124));
    var tmp_114 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_8 = getPropertyCallableRef('constraints', 1, tmp_114, HasPropertyConstraints$_get_constraints_$ref_5lfcib_1(), null);
    var tmp2_21 = new MultipleChildLink(getKClass(HasPropertyConstraints), this_8);
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_125 = btbScopes$lambda$slambda_256($this$scopes, objectPropertyDomainFilters$delegate, nonGroupingFilters$delegate, null);
    var evaluationStrategy_115 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_115;
    if (tmp2_21 == null) {
      tmp_115 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_115 = new LexicalWithRole(tmp2_21);
    }
    var tmp1_elvis_lhs_104 = tmp_115;
    var origin_104 = tmp1_elvis_lhs_104 == null ? Lexical_getInstance() : tmp1_elvis_lhs_104;
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(VariableDeclaration_1)), getKClass(ObjectPropertyDeclaration_1), evaluationStrategy_115, origin_104, builder_125));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_126 = btbScopes$lambda$slambda_258(null);
    var evaluationStrategy_116 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_116;
    if (null == null) {
      tmp_116 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_116 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_105 = tmp_116;
    var origin_105 = tmp1_elvis_lhs_105 == null ? Lexical_getInstance() : tmp1_elvis_lhs_105;
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(VariableDeclaration_1)), getKClass(VariableDeclaration_1), evaluationStrategy_116, origin_105, builder_126));
    var tmp_117 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_9 = getPropertyCallableRef('constraints', 1, tmp_117, HasPropertyConstraints$_get_constraints_$ref_5lfcib_2(), null);
    var tmp2_22 = new MultipleChildLink(getKClass(HasPropertyConstraints), this_9);
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_127 = btbScopes$lambda$slambda_260($this$scopes, objectPropertyDomainFilters$delegate, nonGroupingFilters$delegate, null);
    var evaluationStrategy_117 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_118;
    if (tmp2_22 == null) {
      tmp_118 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_118 = new LexicalWithRole(tmp2_22);
    }
    var tmp1_elvis_lhs_106 = tmp_118;
    var origin_106 = tmp1_elvis_lhs_106 == null ? Lexical_getInstance() : tmp1_elvis_lhs_106;
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(PropertyConstraint_1)), getKClass(ObjectPropertyDeclaration_1), evaluationStrategy_117, origin_106, builder_127));
    var tmp_119 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_10 = getPropertyCallableRef('constraints', 1, tmp_119, HasPropertyConstraints$_get_constraints_$ref_5lfcib_3(), null);
    var tmp2_23 = new MultipleChildLink(getKClass(HasPropertyConstraints), this_10);
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_128 = btbScopes$lambda$slambda_262($this$scopes, nonGroupingFilters$delegate, objectPropertyDomainFilters$delegate, null);
    var evaluationStrategy_118 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_120;
    if (tmp2_23 == null) {
      tmp_120 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_120 = new LexicalWithRole(tmp2_23);
    }
    var tmp1_elvis_lhs_107 = tmp_120;
    var origin_107 = tmp1_elvis_lhs_107 == null ? Lexical_getInstance() : tmp1_elvis_lhs_107;
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(OntologyElementDefinition_1)), getKClass(ObjectPropertyDeclaration_1), evaluationStrategy_118, origin_107, builder_128));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_129 = btbScopes$lambda$slambda_264(null);
    var evaluationStrategy_119 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_121;
    if (null == null) {
      tmp_121 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_121 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_108 = tmp_121;
    var origin_108 = tmp1_elvis_lhs_108 == null ? Lexical_getInstance() : tmp1_elvis_lhs_108;
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(ValueWithRelations)), getKClass(InstanceRelationDeclaration), evaluationStrategy_119, origin_108, builder_129));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideImportScope' call
    var builder_130 = btbScopes$lambda$slambda_266(null);
    var evaluationStrategy_120 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(ProcessLibrary_1)), getKClass(ProcessDeclaration_1), evaluationStrategy_120, Import_getInstance(), builder_130));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideImportScope' call
    var builder_131 = btbScopes$lambda$slambda_268(null);
    var evaluationStrategy_121 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(ObjectPropertiesLibrary)), getKClass(ObjectPropertyDeclaration_1), evaluationStrategy_121, Import_getInstance(), builder_131));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideImportScope' call
    var builder_132 = btbScopes$lambda$slambda_270(null);
    var evaluationStrategy_122 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(RelationContainer_1)), getKClass(ProcessRelationDeclaration_1), evaluationStrategy_122, Import_getInstance(), builder_132));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideImportScope' call
    var builder_133 = btbScopes$lambda$slambda_272(null);
    var evaluationStrategy_123 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(RelationContainer_1)), getKClass(InstanceRelationDeclaration), evaluationStrategy_123, Import_getInstance(), builder_133));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideImportScope' call
    var builder_134 = btbScopes$lambda$slambda_274(null);
    var evaluationStrategy_124 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(ModifierContainer)), getKClass(ModifierDeclaration), evaluationStrategy_124, Import_getInstance(), builder_134));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideImportScope' call
    var builder_135 = btbScopes$lambda$slambda_276(null);
    var evaluationStrategy_125 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(FunctionLibrary_1)), getKClass(FunctionDeclaration_1), evaluationStrategy_125, Import_getInstance(), builder_135));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideImportScope' call
    var builder_136 = btbScopes$lambda$slambda_278(null);
    var evaluationStrategy_126 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(ProcessKindContainer_1)), getKClass(ProcessKind_1), evaluationStrategy_126, Import_getInstance(), builder_136));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideImportScope' call
    var builder_137 = btbScopes$lambda$slambda_280(null);
    var evaluationStrategy_127 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(LinkLibrary_1)), getKClass(LinkDeclaration_1), evaluationStrategy_127, Import_getInstance(), builder_137));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideImportScope' call
    var builder_138 = btbScopes$lambda$slambda_282(null);
    var evaluationStrategy_128 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(PropertyLibrary_1)), getKClass(PropertyDeclaration_1), evaluationStrategy_128, Import_getInstance(), builder_138));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideImportScope' call
    var builder_139 = btbScopes$lambda$slambda_284(null);
    var evaluationStrategy_129 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(NotionLibrary_1)), getKClass(AbstractNotion), evaluationStrategy_129, Import_getInstance(), builder_139));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideImportScope' call
    var builder_140 = btbScopes$lambda$slambda_286(null);
    var evaluationStrategy_130 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    $this$scopes.b75(new ProvideScope($this$scopes.a75(getKClass(PublishedSourcesLibrary_1)), getKClass(LibraryItem), evaluationStrategy_130, Import_getInstance(), builder_140));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.defaultScope' call
    var builder_141 = btbScopes$lambda$slambda_288($this$scopes, librariesScopeProvider$delegate, null);
    $this$scopes.b75(new DefaultScope(getKClass(ProcessDeclaration_1), builder_141));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.defaultScope' call
    var builder_142 = btbScopes$lambda$slambda_290($this$scopes, librariesScopeProvider$delegate, null);
    $this$scopes.b75(new DefaultScope(getKClass(ObjectPropertyDeclaration_1), builder_142));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.defaultScope' call
    var builder_143 = btbScopes$lambda$slambda_292($this$scopes, librariesScopeProvider$delegate, null);
    $this$scopes.b75(new DefaultScope(getKClass(ProcessRelationDeclaration_1), builder_143));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.defaultScope' call
    var builder_144 = btbScopes$lambda$slambda_294($this$scopes, librariesScopeProvider$delegate, null);
    $this$scopes.b75(new DefaultScope(getKClass(InstanceRelationDeclaration), builder_144));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.defaultScope' call
    var builder_145 = btbScopes$lambda$slambda_296($this$scopes, librariesScopeProvider$delegate, null);
    $this$scopes.b75(new DefaultScope(getKClass(ModifierDeclaration), builder_145));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.defaultScope' call
    var builder_146 = btbScopes$lambda$slambda_298($this$scopes, librariesScopeProvider$delegate, null);
    $this$scopes.b75(new DefaultScope(getKClass(FunctionDeclaration_1), builder_146));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.defaultScope' call
    var builder_147 = btbScopes$lambda$slambda_300($this$scopes, librariesScopeProvider$delegate, null);
    $this$scopes.b75(new DefaultScope(getKClass(ProcessKind_1), builder_147));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.defaultScope' call
    var builder_148 = btbScopes$lambda$slambda_302($this$scopes, librariesScopeProvider$delegate, null);
    $this$scopes.b75(new DefaultScope(getKClass(LinkDeclaration_1), builder_148));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.defaultScope' call
    var builder_149 = btbScopes$lambda$slambda_304($this$scopes, librariesScopeProvider$delegate, null);
    $this$scopes.b75(new DefaultScope(getKClass(PropertyDeclaration_1), builder_149));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.defaultScope' call
    var builder_150 = btbScopes$lambda$slambda_306($this$scopes, librariesScopeProvider$delegate, null);
    $this$scopes.b75(new DefaultScope(getKClass(AbstractNotion), builder_150));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.defaultScope' call
    var builder_151 = btbScopes$lambda$slambda_308($this$scopes, librariesScopeProvider$delegate, null);
    $this$scopes.b75(new DefaultScope(getKClass(LibraryItem), builder_151));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.defaultScope' call
    var builder_152 = btbScopes$lambda$slambda_310($this$scopes, librariesScopeProvider$delegate, null);
    $this$scopes.b75(new DefaultScope(getKClass(OntologyImportRoot_1), builder_152));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.names' call
    var body = btbScopes$lambda$lambda;
    $this$scopes.b75(new ProvideName(getKClass(OntologyElement_1), body));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.names' call
    var body_0 = btbScopes$lambda$lambda_0;
    $this$scopes.b75(new ProvideName(getKClass(ProcessRelationDeclaration_1), body_0));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.name' call
    var body_1 = btbScopes$lambda$lambda_1;
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.names' call
    var body_2 = btbScopes$lambda$lambda_2(body_1);
    $this$scopes.b75(new ProvideName(getKClass(Named), body_2));
    return Unit_instance;
  }
  function sam$kotlinx_coroutines_flow_FlowCollector$0_19(function_0) {
    this.omg_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_19).x18 = function (value, $completion) {
    return this.omg_1(value, $completion);
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_19).f3 = function () {
    return this.omg_1;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_19).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, FlowCollector) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_19).hashCode = function () {
    return hashCode(this.f3());
  };
  function invoke$lambda($this_scopes, $librariesScopeProvider$delegate) {
    _init_properties_BTBResolvers_kt__y423vn();
    return $this_scopes.e3c($librariesScopeProvider$delegate, null, getLocalDelegateReference('librariesScopeProvider', KProperty0, false));
  }
  function invoke$lambda_0($this_scopes, $subtypeScopeFilters$delegate) {
    _init_properties_BTBResolvers_kt__y423vn();
    return $this_scopes.e3c($subtypeScopeFilters$delegate, null, getLocalDelegateReference('subtypeScopeFilters', KProperty0, false));
  }
  function invoke$lambda_1($this_scopes, $taxonScopeFilters$delegate) {
    _init_properties_BTBResolvers_kt__y423vn();
    return $this_scopes.e3c($taxonScopeFilters$delegate, null, getLocalDelegateReference('taxonScopeFilters', KProperty0, false));
  }
  function invoke$lambda_2($this_scopes, $objectPropertyDomainFilters$delegate) {
    _init_properties_BTBResolvers_kt__y423vn();
    return $this_scopes.e3c($objectPropertyDomainFilters$delegate, null, getLocalDelegateReference('objectPropertyDomainFilters', KProperty0, false));
  }
  function invoke$lambda_3($this_scopes, $nonGroupingFilters$delegate) {
    _init_properties_BTBResolvers_kt__y423vn();
    return $this_scopes.e3c($nonGroupingFilters$delegate, null, getLocalDelegateReference('nonGroupingFilters', KProperty0, false));
  }
  function btbScopes$lambda$slambda(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda).zmg = function ($this$provideLexicalScope, factSet, $completion) {
    var tmp = this.amh($this$provideLexicalScope, factSet, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.zmg(tmp, (!(p2 == null) ? isInterface(p2, FactSet_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.xmg_1.u77(this.ymg_1.wfq(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda).amh = function ($this$provideLexicalScope, factSet, completion) {
    var i = new btbScopes$lambda$slambda(completion);
    i.xmg_1 = $this$provideLexicalScope;
    i.ymg_1 = factSet;
    return i;
  };
  function btbScopes$lambda$slambda_0(resultContinuation) {
    var i = new btbScopes$lambda$slambda(resultContinuation);
    var l = function ($this$provideLexicalScope, factSet, $completion) {
      return i.zmg($this$provideLexicalScope, factSet, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_1(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_1).lmh = function ($this$provideLexicalScope, factSet, $completion) {
    var tmp = this.mmh($this$provideLexicalScope, factSet, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_1).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.lmh(tmp, (!(p2 == null) ? isInterface(p2, FactSet_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_1).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.jmh_1.u77(this.kmh_1.rfr(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_1).mmh = function ($this$provideLexicalScope, factSet, completion) {
    var i = new btbScopes$lambda$slambda_1(completion);
    i.jmh_1 = $this$provideLexicalScope;
    i.kmh_1 = factSet;
    return i;
  };
  function btbScopes$lambda$slambda_2(resultContinuation) {
    var i = new btbScopes$lambda$slambda_1(resultContinuation);
    var l = function ($this$provideLexicalScope, factSet, $completion) {
      return i.lmh($this$provideLexicalScope, factSet, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_3(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_3).xmh = function ($this$provideLexicalScope, cmd, $completion) {
    var tmp = this.ymh($this$provideLexicalScope, cmd, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_3).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.xmh(tmp, (!(p2 == null) ? isInterface(p2, FindNewConnectionCommand_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_3).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.vmh_1.u77(this.wmh_1.rfr(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_3).ymh = function ($this$provideLexicalScope, cmd, completion) {
    var i = new btbScopes$lambda$slambda_3(completion);
    i.vmh_1 = $this$provideLexicalScope;
    i.wmh_1 = cmd;
    return i;
  };
  function btbScopes$lambda$slambda_4(resultContinuation) {
    var i = new btbScopes$lambda$slambda_3(resultContinuation);
    var l = function ($this$provideLexicalScope, cmd, $completion) {
      return i.xmh($this$provideLexicalScope, cmd, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda$slambda($fact, resultContinuation) {
    this.hmi_1 = $fact;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda$slambda).kmi = function ($this$filter, it, $completion) {
    var tmp = this.lmi($this$filter, it, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda$slambda).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof QueryBuilder ? p1 : THROW_CCE();
    return this.kmi(tmp, (!(p2 == null) ? isInterface(p2, Fact_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        if (tmp === 0) {
          this.g9_1 = 1;
          return !equals(this.jmi_1, this.hmi_1);
        } else if (tmp === 1) {
          throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda$slambda).lmi = function ($this$filter, it, completion) {
    var i = new btbScopes$lambda$slambda$slambda(this.hmi_1, completion);
    i.imi_1 = $this$filter;
    i.jmi_1 = it;
    return i;
  };
  function btbScopes$lambda$slambda$slambda_0($fact, resultContinuation) {
    var i = new btbScopes$lambda$slambda$slambda($fact, resultContinuation);
    var l = function ($this$filter, it, $completion) {
      return i.kmi($this$filter, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_5(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_5).wmi = function ($this$provideLexicalScope, fact, $completion) {
    var tmp = this.xmi($this$provideLexicalScope, fact, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_5).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.wmi(tmp, (!(p2 == null) ? isInterface(p2, Fact_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_5).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.umi_1.r77(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            return filter_0(ARGUMENT, btbScopes$lambda$slambda$slambda_0(this.vmi_1, null));
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_5).xmi = function ($this$provideLexicalScope, fact, completion) {
    var i = new btbScopes$lambda$slambda_5(completion);
    i.umi_1 = $this$provideLexicalScope;
    i.vmi_1 = fact;
    return i;
  };
  function btbScopes$lambda$slambda_6(resultContinuation) {
    var i = new btbScopes$lambda$slambda_5(resultContinuation);
    var l = function ($this$provideLexicalScope, fact, $completion) {
      return i.wmi($this$provideLexicalScope, fact, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_7(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_7).imj = function ($this$provideLexicalScope, factSet, $completion) {
    var tmp = this.jmj($this$provideLexicalScope, factSet, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_7).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.imj(tmp, (!(p2 == null) ? isInterface(p2, FactSet_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_7).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.gmj_1.u77(this.hmj_1.cfr(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_7).jmj = function ($this$provideLexicalScope, factSet, completion) {
    var i = new btbScopes$lambda$slambda_7(completion);
    i.gmj_1 = $this$provideLexicalScope;
    i.hmj_1 = factSet;
    return i;
  };
  function btbScopes$lambda$slambda_8(resultContinuation) {
    var i = new btbScopes$lambda$slambda_7(resultContinuation);
    var l = function ($this$provideLexicalScope, factSet, $completion) {
      return i.imj($this$provideLexicalScope, factSet, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda$slambda_1($fact, resultContinuation) {
    this.smj_1 = $fact;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda$slambda_1).vmj = function ($this$filter, it, $completion) {
    var tmp = this.wmj($this$filter, it, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda$slambda_1).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof QueryBuilder ? p1 : THROW_CCE();
    return this.vmj(tmp, (!(p2 == null) ? isInterface(p2, NewFact) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda$slambda_1).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        if (tmp === 0) {
          this.g9_1 = 1;
          return !equals(this.umj_1, this.smj_1);
        } else if (tmp === 1) {
          throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda$slambda_1).wmj = function ($this$filter, it, completion) {
    var i = new btbScopes$lambda$slambda$slambda_1(this.smj_1, completion);
    i.tmj_1 = $this$filter;
    i.umj_1 = it;
    return i;
  };
  function btbScopes$lambda$slambda$slambda_2($fact, resultContinuation) {
    var i = new btbScopes$lambda$slambda$slambda_1($fact, resultContinuation);
    var l = function ($this$filter, it, $completion) {
      return i.vmj($this$filter, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_9(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_9).hmk = function ($this$provideLexicalScope, fact, $completion) {
    var tmp = this.imk($this$provideLexicalScope, fact, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_9).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.hmk(tmp, (!(p2 == null) ? isInterface(p2, NewFact) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_9).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.fmk_1.r77(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            return filter_0(ARGUMENT, btbScopes$lambda$slambda$slambda_2(this.gmk_1, null));
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_9).imk = function ($this$provideLexicalScope, fact, completion) {
    var i = new btbScopes$lambda$slambda_9(completion);
    i.fmk_1 = $this$provideLexicalScope;
    i.gmk_1 = fact;
    return i;
  };
  function btbScopes$lambda$slambda_10(resultContinuation) {
    var i = new btbScopes$lambda$slambda_9(resultContinuation);
    var l = function ($this$provideLexicalScope, fact, $completion) {
      return i.hmk($this$provideLexicalScope, fact, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_11($this_scopes, $taxonScopeFilters$delegate, resultContinuation) {
    this.rmk_1 = $this_scopes;
    this.smk_1 = $taxonScopeFilters$delegate;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_11).aml = function ($this$constrainScope, factSet, $completion) {
    var tmp = this.bml($this$constrainScope, factSet, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_11).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeConstraintBuilder ? p1 : THROW_CCE();
    return this.aml(tmp, (!(p2 == null) ? isInterface(p2, FactSet_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_11).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 8;
            var tmp0 = this.tmk_1.l60(this.umk_1.bfr());
            this.xmk_1 = ArrayList_init_$Create$();
            this.zmk_1 = tmp0.m();
            this.f9_1 = 1;
            continue $sm;
          case 1:
            if (!this.zmk_1.n()) {
              this.f9_1 = 4;
              continue $sm;
            }

            var element = this.zmk_1.o();
            var tmp0_safe_receiver = this.tmk_1.l60(element.gfq());
            var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.gfq();
            if (tmp1_safe_receiver == null) {
              this.ymk_1 = null;
              this.f9_1 = 3;
              continue $sm;
            } else {
              this.f9_1 = 2;
              suspendResult = this.tmk_1.k60(tmp1_safe_receiver, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 2:
            this.ymk_1 = suspendResult;
            this.f9_1 = 3;
            continue $sm;
          case 3:
            var tmp0_safe_receiver_0 = this.ymk_1;
            if (tmp0_safe_receiver_0 == null)
              null;
            else {
              this.xmk_1.j(tmp0_safe_receiver_0);
            }

            this.f9_1 = 1;
            continue $sm;
          case 4:
            var newTaxons = this.xmk_1;
            if (!newTaxons.s()) {
              var tmp_0 = this;
              tmp_0.vmk_1 = invoke$lambda_1(this.rmk_1, this.smk_1).cml(newTaxons);
              this.f9_1 = 7;
              continue $sm;
            } else {
              var tmp0_safe_receiver_1 = this.tmk_1.l60(this.umk_1.afr());
              var tmp1_safe_receiver_0 = tmp0_safe_receiver_1 == null ? null : tmp0_safe_receiver_1.gfq();
              var tmp2_safe_receiver = tmp1_safe_receiver_0 == null ? null : this.tmk_1.l60(tmp1_safe_receiver_0);
              var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.gfq();
              if (tmp3_safe_receiver == null) {
                this.wmk_1 = null;
                this.f9_1 = 6;
                continue $sm;
              } else {
                this.f9_1 = 5;
                suspendResult = this.tmk_1.k60(tmp3_safe_receiver, this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              }
            }

          case 5:
            this.wmk_1 = suspendResult;
            this.f9_1 = 6;
            continue $sm;
          case 6:
            var tmp4_elvis_lhs = this.wmk_1;
            var tmp_1;
            if (tmp4_elvis_lhs == null) {
              return this.tmk_1.r78_1;
            } else {
              tmp_1 = tmp4_elvis_lhs;
            }

            var contextTaxon = tmp_1;
            this.vmk_1 = invoke$lambda_1(this.rmk_1, this.smk_1).dml(contextTaxon);
            this.f9_1 = 7;
            continue $sm;
          case 7:
            return this.vmk_1;
          case 8:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 8) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_11).bml = function ($this$constrainScope, factSet, completion) {
    var i = new btbScopes$lambda$slambda_11(this.rmk_1, this.smk_1, completion);
    i.tmk_1 = $this$constrainScope;
    i.umk_1 = factSet;
    return i;
  };
  function btbScopes$lambda$slambda_12($this_scopes, $taxonScopeFilters$delegate, resultContinuation) {
    var i = new btbScopes$lambda$slambda_11($this_scopes, $taxonScopeFilters$delegate, resultContinuation);
    var l = function ($this$constrainScope, factSet, $completion) {
      return i.aml($this$constrainScope, factSet, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_13($this_scopes, $taxonScopeFilters$delegate, resultContinuation) {
    this.mml_1 = $this_scopes;
    this.nml_1 = $taxonScopeFilters$delegate;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_13).rml = function ($this$by, command, $completion) {
    var tmp = this.sml($this$by, command, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_13).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeConstraintBuilder ? p1 : THROW_CCE();
    return this.rml(tmp, (!(p2 == null) ? isInterface(p2, FindConnectionCommand_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_13).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 3;
            var tmp0_safe_receiver = this.oml_1.l60(this.pml_1.efr());
            var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.gfq();
            var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : this.oml_1.l60(tmp1_safe_receiver);
            var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.gfq();
            if (tmp3_safe_receiver == null) {
              this.qml_1 = null;
              this.f9_1 = 2;
              continue $sm;
            } else {
              this.f9_1 = 1;
              suspendResult = this.oml_1.k60(tmp3_safe_receiver, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            this.qml_1 = suspendResult;
            this.f9_1 = 2;
            continue $sm;
          case 2:
            var tmp4_elvis_lhs = this.qml_1;
            var tmp_0;
            if (tmp4_elvis_lhs == null) {
              return this.oml_1.r78_1;
            } else {
              tmp_0 = tmp4_elvis_lhs;
            }

            var contextTaxon = tmp_0;
            return invoke$lambda_1(this.mml_1, this.nml_1).dml(contextTaxon);
          case 3:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 3) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_13).sml = function ($this$by, command, completion) {
    var i = new btbScopes$lambda$slambda_13(this.mml_1, this.nml_1, completion);
    i.oml_1 = $this$by;
    i.pml_1 = command;
    return i;
  };
  function btbScopes$lambda$slambda_14($this_scopes, $taxonScopeFilters$delegate, resultContinuation) {
    var i = new btbScopes$lambda$slambda_13($this_scopes, $taxonScopeFilters$delegate, resultContinuation);
    var l = function ($this$by, command, $completion) {
      return i.rml($this$by, command, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_15($this_scopes, $taxonScopeFilters$delegate, resultContinuation) {
    this.bmm_1 = $this_scopes;
    this.cmm_1 = $taxonScopeFilters$delegate;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_15).imm = function ($this$by, command, $completion) {
    var tmp = this.jmm($this$by, command, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_15).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeConstraintBuilder ? p1 : THROW_CCE();
    return this.imm(tmp, (!(p2 == null) ? isInterface(p2, FindNewConnectionCommand_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_15).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 5;
            var tmp0 = this.dmm_1.l60(this.emm_1.ffr());
            this.fmm_1 = ArrayList_init_$Create$();
            this.hmm_1 = tmp0.m();
            this.f9_1 = 1;
            continue $sm;
          case 1:
            if (!this.hmm_1.n()) {
              this.f9_1 = 4;
              continue $sm;
            }

            var element = this.hmm_1.o();
            var tmp0_safe_receiver = this.dmm_1.l60(element.gfq());
            var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.gfq();
            if (tmp1_safe_receiver == null) {
              this.gmm_1 = null;
              this.f9_1 = 3;
              continue $sm;
            } else {
              this.f9_1 = 2;
              suspendResult = this.dmm_1.k60(tmp1_safe_receiver, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 2:
            this.gmm_1 = suspendResult;
            this.f9_1 = 3;
            continue $sm;
          case 3:
            var tmp0_safe_receiver_0 = this.gmm_1;
            if (tmp0_safe_receiver_0 == null)
              null;
            else {
              this.fmm_1.j(tmp0_safe_receiver_0);
            }

            this.f9_1 = 1;
            continue $sm;
          case 4:
            var contextTaxons = this.fmm_1;
            if (contextTaxons.s())
              return this.dmm_1.r78_1;
            return invoke$lambda_1(this.bmm_1, this.cmm_1).cml(contextTaxons);
          case 5:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 5) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_15).jmm = function ($this$by, command, completion) {
    var i = new btbScopes$lambda$slambda_15(this.bmm_1, this.cmm_1, completion);
    i.dmm_1 = $this$by;
    i.emm_1 = command;
    return i;
  };
  function btbScopes$lambda$slambda_16($this_scopes, $taxonScopeFilters$delegate, resultContinuation) {
    var i = new btbScopes$lambda$slambda_15($this_scopes, $taxonScopeFilters$delegate, resultContinuation);
    var l = function ($this$by, command, $completion) {
      return i.imm($this$by, command, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda$slambda_3($ontologyHierarchy, resultContinuation) {
    this.smm_1 = $ontologyHierarchy;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda$slambda_3).vmm = function ($this$query, it, $completion) {
    var tmp = this.wmm($this$query, it, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda$slambda_3).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof QueryBuilder ? p1 : THROW_CCE();
    return this.vmm(tmp, (!(p2 == null) ? isInterface(p2, OntologyElement_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda$slambda_3).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.tmm_1.k60(isNatural_0(this.smm_1, this.umm_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda$slambda_3).wmm = function ($this$query, it, completion) {
    var i = new btbScopes$lambda$slambda$slambda_3(this.smm_1, completion);
    i.tmm_1 = $this$query;
    i.umm_1 = it;
    return i;
  };
  function btbScopes$lambda$slambda$slambda_4($ontologyHierarchy, resultContinuation) {
    var i = new btbScopes$lambda$slambda$slambda_3($ontologyHierarchy, resultContinuation);
    var l = function ($this$query, it, $completion) {
      return i.vmm($this$query, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_17(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_17).hmn = function ($this$constrainScope, _unused_var__etf5q3, $completion) {
    var tmp = this.imn($this$constrainScope, _unused_var__etf5q3, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_17).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeConstraintBuilder ? p1 : THROW_CCE();
    return this.hmn(tmp, (!(p2 == null) ? isInterface(p2, OntologyIsRelation_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_17).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        if (tmp === 0) {
          this.g9_1 = 1;
          var ontologyHierarchy = ontologyElementHierarchy();
          var tmp_0 = Companion_instance_120;
          return tmp_0.f73(btbScopes$lambda$slambda$slambda_4(ontologyHierarchy, null));
        } else if (tmp === 1) {
          throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_17).imn = function ($this$constrainScope, _unused_var__etf5q3, completion) {
    var i = new btbScopes$lambda$slambda_17(completion);
    i.fmn_1 = $this$constrainScope;
    i.gmn_1 = _unused_var__etf5q3;
    return i;
  };
  function btbScopes$lambda$slambda_18(resultContinuation) {
    var i = new btbScopes$lambda$slambda_17(resultContinuation);
    var l = function ($this$constrainScope, _unused_var__etf5q3, $completion) {
      return i.hmn($this$constrainScope, _unused_var__etf5q3, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda$slambda_5($currentOntology, resultContinuation) {
    this.rmn_1 = $currentOntology;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda$slambda_5).umn = function ($this$filter, it, $completion) {
    var tmp = this.vmn($this$filter, it, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda$slambda_5).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof QueryBuilder ? p1 : THROW_CCE();
    return this.umn(tmp, (!(p2 == null) ? isInterface(p2, OntologyLibrary_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda$slambda_5).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        if (tmp === 0) {
          this.g9_1 = 1;
          return !isSameOntologyDocumentAs(this.tmn_1, this.rmn_1);
        } else if (tmp === 1) {
          throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda$slambda_5).vmn = function ($this$filter, it, completion) {
    var i = new btbScopes$lambda$slambda$slambda_5(this.rmn_1, completion);
    i.smn_1 = $this$filter;
    i.tmn_1 = it;
    return i;
  };
  function btbScopes$lambda$slambda$slambda_6($currentOntology, resultContinuation) {
    var i = new btbScopes$lambda$slambda$slambda_5($currentOntology, resultContinuation);
    var l = function ($this$filter, it, $completion) {
      return i.umn($this$filter, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_19(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_19).hmo = function ($this$provideLexicalScope, ontologyElement, $completion) {
    var tmp = this.imo($this$provideLexicalScope, ontologyElement, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_19).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.hmo(tmp, (!(p2 == null) ? isInterface(p2, OntologyElement_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_19).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            var tmp_0 = this;
            var this_0 = this.fmo_1;
            tmp_0.gmo_1 = this.emo_1.l60(ancestorOrSelf(this_0, getKClass(OntologyLibrary_1)));
            var tmp0_safe_receiver = this.gmo_1;
            if ((tmp0_safe_receiver == null ? null : this.emo_1.l60(tmp0_safe_receiver.y2())) === 'metaOntology') {
              return Scopes_getInstance().u7b();
            }

            this.f9_1 = 1;
            suspendResult = this.emo_1.r77(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            return filter_0(ARGUMENT, btbScopes$lambda$slambda$slambda_6(this.gmo_1, null));
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_19).imo = function ($this$provideLexicalScope, ontologyElement, completion) {
    var i = new btbScopes$lambda$slambda_19(completion);
    i.emo_1 = $this$provideLexicalScope;
    i.fmo_1 = ontologyElement;
    return i;
  };
  function btbScopes$lambda$slambda_20(resultContinuation) {
    var i = new btbScopes$lambda$slambda_19(resultContinuation);
    var l = function ($this$provideLexicalScope, ontologyElement, $completion) {
      return i.hmo($this$provideLexicalScope, ontologyElement, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda$slambda_7($ontologyHierarchy, resultContinuation) {
    this.rmo_1 = $ontologyHierarchy;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda$slambda_7).vmm = function ($this$filter, it, $completion) {
    var tmp = this.wmm($this$filter, it, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda$slambda_7).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof QueryBuilder ? p1 : THROW_CCE();
    return this.vmm(tmp, (!(p2 == null) ? isInterface(p2, OntologyElement_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda$slambda_7).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.smo_1.k60(isNatural_0(this.rmo_1, this.tmo_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda$slambda_7).wmm = function ($this$filter, it, completion) {
    var i = new btbScopes$lambda$slambda$slambda_7(this.rmo_1, completion);
    i.smo_1 = $this$filter;
    i.tmo_1 = it;
    return i;
  };
  function btbScopes$lambda$slambda$slambda_8($ontologyHierarchy, resultContinuation) {
    var i = new btbScopes$lambda$slambda$slambda_7($ontologyHierarchy, resultContinuation);
    var l = function ($this$filter, it, $completion) {
      return i.vmm($this$filter, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_21(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_21).fmp = function ($this$provideLexicalScope, _unused_var__etf5q3, $completion) {
    var tmp = this.gmp($this$provideLexicalScope, _unused_var__etf5q3, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_21).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.fmp(tmp, (!(p2 == null) ? isInterface(p2, OntologyElement_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_21).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.emp_1 = ontologyElementHierarchy();
            this.f9_1 = 1;
            suspendResult = this.cmp_1.r77(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            return filter_0(ARGUMENT, btbScopes$lambda$slambda$slambda_8(this.emp_1, null));
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_21).gmp = function ($this$provideLexicalScope, _unused_var__etf5q3, completion) {
    var i = new btbScopes$lambda$slambda_21(completion);
    i.cmp_1 = $this$provideLexicalScope;
    i.dmp_1 = _unused_var__etf5q3;
    return i;
  };
  function btbScopes$lambda$slambda_22(resultContinuation) {
    var i = new btbScopes$lambda$slambda_21(resultContinuation);
    var l = function ($this$provideLexicalScope, _unused_var__etf5q3, $completion) {
      return i.fmp($this$provideLexicalScope, _unused_var__etf5q3, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda$slambda_9(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda$slambda_9).umn = function ($this$filter, it, $completion) {
    var tmp = this.vmn($this$filter, it, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda$slambda_9).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof QueryBuilder ? p1 : THROW_CCE();
    return this.umn(tmp, (!(p2 == null) ? isInterface(p2, OntologyLibrary_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda$slambda_9).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        if (tmp === 0) {
          this.g9_1 = 1;
          return this.pmp_1.l60(this.qmp_1.y2()) === 'metaOntology';
        } else if (tmp === 1) {
          throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda$slambda_9).vmn = function ($this$filter, it, completion) {
    var i = new btbScopes$lambda$slambda$slambda_9(completion);
    i.pmp_1 = $this$filter;
    i.qmp_1 = it;
    return i;
  };
  function btbScopes$lambda$slambda$slambda_10(resultContinuation) {
    var i = new btbScopes$lambda$slambda$slambda_9(resultContinuation);
    var l = function ($this$filter, it, $completion) {
      return i.umn($this$filter, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_23(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_23).hmo = function ($this$provideLexicalScope, _unused_var__etf5q3, $completion) {
    var tmp = this.imo($this$provideLexicalScope, _unused_var__etf5q3, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_23).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.hmo(tmp, (!(p2 == null) ? isInterface(p2, OntologyElement_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_23).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.zmp_1.r77(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            return filter_0(ARGUMENT, btbScopes$lambda$slambda$slambda_10(null));
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_23).imo = function ($this$provideLexicalScope, _unused_var__etf5q3, completion) {
    var i = new btbScopes$lambda$slambda_23(completion);
    i.zmp_1 = $this$provideLexicalScope;
    i.amq_1 = _unused_var__etf5q3;
    return i;
  };
  function btbScopes$lambda$slambda_24(resultContinuation) {
    var i = new btbScopes$lambda$slambda_23(resultContinuation);
    var l = function ($this$provideLexicalScope, _unused_var__etf5q3, $completion) {
      return i.hmo($this$provideLexicalScope, _unused_var__etf5q3, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_25(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_25).hmo = function ($this$provideLexicalScope, ontologyElement, $completion) {
    var tmp = this.imo($this$provideLexicalScope, ontologyElement, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_25).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.hmo(tmp, (!(p2 == null) ? isInterface(p2, OntologyElement_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_25).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            var this_0 = this.kmq_1;
            var tmp0_safe_receiver = this.jmq_1.l60(ancestorOrSelf(this_0, getKClass(OntologyLibrary_1)));
            if (tmp0_safe_receiver == null)
              null;
            else {
              if (this.jmq_1.l60(tmp0_safe_receiver.y2()) === 'metaOntology') {
                return Scopes_getInstance().u7b();
              }
            }

            this.f9_1 = 1;
            suspendResult = this.jmq_1.r77(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_25).imo = function ($this$provideLexicalScope, ontologyElement, completion) {
    var i = new btbScopes$lambda$slambda_25(completion);
    i.jmq_1 = $this$provideLexicalScope;
    i.kmq_1 = ontologyElement;
    return i;
  };
  function btbScopes$lambda$slambda_26(resultContinuation) {
    var i = new btbScopes$lambda$slambda_25(resultContinuation);
    var l = function ($this$provideLexicalScope, ontologyElement, $completion) {
      return i.hmo($this$provideLexicalScope, ontologyElement, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda$slambda_11(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda$slambda_11).umn = function ($this$filter, it, $completion) {
    var tmp = this.vmn($this$filter, it, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda$slambda_11).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof QueryBuilder ? p1 : THROW_CCE();
    return this.umn(tmp, (!(p2 == null) ? isInterface(p2, OntologyLibrary_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda$slambda_11).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        if (tmp === 0) {
          this.g9_1 = 1;
          return contains_8(this.tmq_1.l60(this.umq_1.y2()), 'NCBI Taxonomy');
        } else if (tmp === 1) {
          throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda$slambda_11).vmn = function ($this$filter, it, completion) {
    var i = new btbScopes$lambda$slambda$slambda_11(completion);
    i.tmq_1 = $this$filter;
    i.umq_1 = it;
    return i;
  };
  function btbScopes$lambda$slambda$slambda_12(resultContinuation) {
    var i = new btbScopes$lambda$slambda$slambda_11(resultContinuation);
    var l = function ($this$filter, it, $completion) {
      return i.umn($this$filter, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_27(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_27).hmo = function ($this$provideLexicalScope, _unused_var__etf5q3, $completion) {
    var tmp = this.imo($this$provideLexicalScope, _unused_var__etf5q3, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_27).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.hmo(tmp, (!(p2 == null) ? isInterface(p2, OntologyElement_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_27).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.dmr_1.r77(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            return filter_0(ARGUMENT, btbScopes$lambda$slambda$slambda_12(null));
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_27).imo = function ($this$provideLexicalScope, _unused_var__etf5q3, completion) {
    var i = new btbScopes$lambda$slambda_27(completion);
    i.dmr_1 = $this$provideLexicalScope;
    i.emr_1 = _unused_var__etf5q3;
    return i;
  };
  function btbScopes$lambda$slambda_28(resultContinuation) {
    var i = new btbScopes$lambda$slambda_27(resultContinuation);
    var l = function ($this$provideLexicalScope, _unused_var__etf5q3, $completion) {
      return i.hmo($this$provideLexicalScope, _unused_var__etf5q3, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_29(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_29).fmp = function ($this$provideLexicalScope, _unused_var__etf5q3, $completion) {
    var tmp = this.gmp($this$provideLexicalScope, _unused_var__etf5q3, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_29).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.fmp(tmp, (!(p2 == null) ? isInterface(p2, OntologyElement_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_29).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        if (tmp === 0) {
          this.g9_1 = 1;
          return Scopes_getInstance().u7b();
        } else if (tmp === 1) {
          throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_29).gmp = function ($this$provideLexicalScope, _unused_var__etf5q3, completion) {
    var i = new btbScopes$lambda$slambda_29(completion);
    i.nmr_1 = $this$provideLexicalScope;
    i.omr_1 = _unused_var__etf5q3;
    return i;
  };
  function btbScopes$lambda$slambda_30(resultContinuation) {
    var i = new btbScopes$lambda$slambda_29(resultContinuation);
    var l = function ($this$provideLexicalScope, _unused_var__etf5q3, $completion) {
      return i.fmp($this$provideLexicalScope, _unused_var__etf5q3, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_31($this_scopes, $librariesScopeProvider$delegate, resultContinuation) {
    this.xmr_1 = $this_scopes;
    this.ymr_1 = $librariesScopeProvider$delegate;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_31).bms = function ($this$provideLexicalScope, library, $completion) {
    var tmp = this.cms($this$provideLexicalScope, library, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_31).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.bms(tmp, (!(p2 == null) ? isInterface(p2, OntologyLibrary_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_31).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            var ontologyLibraries = toList_2(this.zmr_1.l60(this.zmr_1.l60(invoke$lambda(this.xmr_1, this.ymr_1).a6v(this.ams_1)).h6v(OntologyLibraryConcept_getInstance())));
            this.f9_1 = 1;
            suspendResult = this.zmr_1.v77(ontologyLibraries, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_31).cms = function ($this$provideLexicalScope, library, completion) {
    var i = new btbScopes$lambda$slambda_31(this.xmr_1, this.ymr_1, completion);
    i.zmr_1 = $this$provideLexicalScope;
    i.ams_1 = library;
    return i;
  };
  function btbScopes$lambda$slambda_32($this_scopes, $librariesScopeProvider$delegate, resultContinuation) {
    var i = new btbScopes$lambda$slambda_31($this_scopes, $librariesScopeProvider$delegate, resultContinuation);
    var l = function ($this$provideLexicalScope, library, $completion) {
      return i.bms($this$provideLexicalScope, library, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_33($this_scopes, $librariesScopeProvider$delegate, resultContinuation) {
    this.lms_1 = $this_scopes;
    this.mms_1 = $librariesScopeProvider$delegate;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_33).oms = function ($this$defaultScope, $completion) {
    var tmp = this.pms($this$defaultScope, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_33).v9 = function (p1, $completion) {
    return this.oms(p1 instanceof ScopeBuilder ? p1 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_33).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = librariesScope(this.nms_1, invoke$lambda(this.lms_1, this.mms_1), OntologyLibraryConcept_getInstance(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_33).pms = function ($this$defaultScope, completion) {
    var i = new btbScopes$lambda$slambda_33(this.lms_1, this.mms_1, completion);
    i.nms_1 = $this$defaultScope;
    return i;
  };
  function btbScopes$lambda$slambda_34($this_scopes, $librariesScopeProvider$delegate, resultContinuation) {
    var i = new btbScopes$lambda$slambda_33($this_scopes, $librariesScopeProvider$delegate, resultContinuation);
    var l = function ($this$defaultScope, $completion) {
      return i.oms($this$defaultScope, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function btbScopes$lambda$slambda_35(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_35).amt = function ($this$provideLexicalScope, contextNode, $completion) {
    var tmp = this.bmt($this$provideLexicalScope, contextNode, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_35).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.amt(tmp, (!(p2 == null) ? isInterface(p2, Context_2) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_35).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            var tmp0_elvis_lhs = this.yms_1.l60(this.zms_1.ffq());
            var tmp_0;
            if (tmp0_elvis_lhs == null) {
              return new EmptyScope();
            } else {
              tmp_0 = tmp0_elvis_lhs;
            }

            var libraryReference = tmp_0;
            this.f9_1 = 1;
            suspendResult = importOntologyLibrary(this.yms_1, libraryReference, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_35).bmt = function ($this$provideLexicalScope, contextNode, completion) {
    var i = new btbScopes$lambda$slambda_35(completion);
    i.yms_1 = $this$provideLexicalScope;
    i.zms_1 = contextNode;
    return i;
  };
  function btbScopes$lambda$slambda_36(resultContinuation) {
    var i = new btbScopes$lambda$slambda_35(resultContinuation);
    var l = function ($this$provideLexicalScope, contextNode, $completion) {
      return i.amt($this$provideLexicalScope, contextNode, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_37(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_37).mmt = function ($this$provideLexicalScope, contextNode, $completion) {
    var tmp = this.nmt($this$provideLexicalScope, contextNode, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_37).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.mmt(tmp, (!(p2 == null) ? isInterface(p2, ContextQuery_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_37).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            var tmp0_elvis_lhs = this.kmt_1.l60(this.lmt_1.ffq());
            var tmp_0;
            if (tmp0_elvis_lhs == null) {
              return new EmptyScope();
            } else {
              tmp_0 = tmp0_elvis_lhs;
            }

            var libraryReference = tmp_0;
            this.f9_1 = 1;
            suspendResult = importOntologyLibrary(this.kmt_1, libraryReference, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_37).nmt = function ($this$provideLexicalScope, contextNode, completion) {
    var i = new btbScopes$lambda$slambda_37(completion);
    i.kmt_1 = $this$provideLexicalScope;
    i.lmt_1 = contextNode;
    return i;
  };
  function btbScopes$lambda$slambda_38(resultContinuation) {
    var i = new btbScopes$lambda$slambda_37(resultContinuation);
    var l = function ($this$provideLexicalScope, contextNode, $completion) {
      return i.mmt($this$provideLexicalScope, contextNode, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_39(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_39).ymt = function ($this$provideLexicalScope, contextNode, $completion) {
    var tmp = this.zmt($this$provideLexicalScope, contextNode, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_39).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.ymt(tmp, (!(p2 == null) ? isInterface(p2, QualifiedOntologyElementReference_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_39).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 3;
            var tmp0_elvis_lhs = this.wmt_1.l60(this.xmt_1.hfu());
            var tmp_0;
            if (tmp0_elvis_lhs == null) {
              return new EmptyScope();
            } else {
              tmp_0 = tmp0_elvis_lhs;
            }

            var libraryReference = tmp_0;
            this.f9_1 = 1;
            suspendResult = importOntologyLibrary(this.wmt_1, libraryReference, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            this.f9_1 = 2;
            suspendResult = this.wmt_1.t77(ARGUMENT, get_elementTypeAndTaxon(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return suspendResult;
          case 3:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 3) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_39).zmt = function ($this$provideLexicalScope, contextNode, completion) {
    var i = new btbScopes$lambda$slambda_39(completion);
    i.wmt_1 = $this$provideLexicalScope;
    i.xmt_1 = contextNode;
    return i;
  };
  function btbScopes$lambda$slambda_40(resultContinuation) {
    var i = new btbScopes$lambda$slambda_39(resultContinuation);
    var l = function ($this$provideLexicalScope, contextNode, $completion) {
      return i.ymt($this$provideLexicalScope, contextNode, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_41(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_41).kmu = function ($this$provideLexicalScope, category, $completion) {
    var tmp = this.lmu($this$provideLexicalScope, category, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_41).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.kmu(tmp, (!(p2 == null) ? isInterface(p2, Category_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_41).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            var tmp0_elvis_lhs = this.imu_1.l60(this.jmu_1.ffq());
            var tmp_0;
            if (tmp0_elvis_lhs == null) {
              return new EmptyScope();
            } else {
              tmp_0 = tmp0_elvis_lhs;
            }

            var libraryReference = tmp_0;
            this.f9_1 = 1;
            suspendResult = importOntologyLibrary(this.imu_1, libraryReference, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_41).lmu = function ($this$provideLexicalScope, category, completion) {
    var i = new btbScopes$lambda$slambda_41(completion);
    i.imu_1 = $this$provideLexicalScope;
    i.jmu_1 = category;
    return i;
  };
  function btbScopes$lambda$slambda_42(resultContinuation) {
    var i = new btbScopes$lambda$slambda_41(resultContinuation);
    var l = function ($this$provideLexicalScope, category, $completion) {
      return i.kmu($this$provideLexicalScope, category, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_43(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_43).wmu = function ($this$provideLexicalScope, importNode, $completion) {
    var tmp = this.xmu($this$provideLexicalScope, importNode, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_43).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.wmu(tmp, (!(p2 == null) ? isInterface(p2, OntologyImport_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_43).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            var tmp0_elvis_lhs = this.umu_1.l60(this.vmu_1.xfs());
            var tmp_0;
            if (tmp0_elvis_lhs == null) {
              return new EmptyScope();
            } else {
              tmp_0 = tmp0_elvis_lhs;
            }

            var libraryReference = tmp_0;
            this.f9_1 = 1;
            suspendResult = importOntologyLibrary(this.umu_1, libraryReference, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_43).xmu = function ($this$provideLexicalScope, importNode, completion) {
    var i = new btbScopes$lambda$slambda_43(completion);
    i.umu_1 = $this$provideLexicalScope;
    i.vmu_1 = importNode;
    return i;
  };
  function btbScopes$lambda$slambda_44(resultContinuation) {
    var i = new btbScopes$lambda$slambda_43(resultContinuation);
    var l = function ($this$provideLexicalScope, importNode, $completion) {
      return i.wmu($this$provideLexicalScope, importNode, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_45(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_45).imv = function ($this$provideLexicalScope, typeNode, $completion) {
    var tmp = this.jmv($this$provideLexicalScope, typeNode, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_45).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.imv(tmp, (!(p2 == null) ? isInterface(p2, OntologyElementType_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_45).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 3;
            var tmp0_elvis_lhs = this.gmv_1.l60(this.hmv_1.ffq());
            var tmp_0;
            if (tmp0_elvis_lhs == null) {
              return new EmptyScope();
            } else {
              tmp_0 = tmp0_elvis_lhs;
            }

            var libraryReference = tmp_0;
            this.f9_1 = 1;
            suspendResult = importOntologyLibrary(this.gmv_1, libraryReference, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            this.f9_1 = 2;
            suspendResult = this.gmv_1.t77(ARGUMENT, get_elementTypeAndTaxon(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return suspendResult;
          case 3:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 3) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_45).jmv = function ($this$provideLexicalScope, typeNode, completion) {
    var i = new btbScopes$lambda$slambda_45(completion);
    i.gmv_1 = $this$provideLexicalScope;
    i.hmv_1 = typeNode;
    return i;
  };
  function btbScopes$lambda$slambda_46(resultContinuation) {
    var i = new btbScopes$lambda$slambda_45(resultContinuation);
    var l = function ($this$provideLexicalScope, typeNode, $completion) {
      return i.imv($this$provideLexicalScope, typeNode, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_47(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_47).umv = function ($this$provideLexicalScope, typeNode, $completion) {
    var tmp = this.vmv($this$provideLexicalScope, typeNode, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_47).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.umv(tmp, (!(p2 == null) ? isInterface(p2, OntologyElementPropertyType_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_47).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            var tmp0_elvis_lhs = this.smv_1.l60(this.tmv_1.ffq());
            var tmp_0;
            if (tmp0_elvis_lhs == null) {
              return new EmptyScope();
            } else {
              tmp_0 = tmp0_elvis_lhs;
            }

            var libraryReference = tmp_0;
            this.f9_1 = 1;
            suspendResult = importOntologyLibrary(this.smv_1, libraryReference, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_47).vmv = function ($this$provideLexicalScope, typeNode, completion) {
    var i = new btbScopes$lambda$slambda_47(completion);
    i.smv_1 = $this$provideLexicalScope;
    i.tmv_1 = typeNode;
    return i;
  };
  function btbScopes$lambda$slambda_48(resultContinuation) {
    var i = new btbScopes$lambda$slambda_47(resultContinuation);
    var l = function ($this$provideLexicalScope, typeNode, $completion) {
      return i.umv($this$provideLexicalScope, typeNode, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_49(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_49).gmw = function ($this$provideLexicalScope, contextNode, $completion) {
    var tmp = this.hmw($this$provideLexicalScope, contextNode, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_49).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.gmw(tmp, (!(p2 == null) ? isInterface(p2, QueryParametersBlackList) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_49).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.emw_1.w77(this.fmw_1.ffq(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_49).hmw = function ($this$provideLexicalScope, contextNode, completion) {
    var i = new btbScopes$lambda$slambda_49(completion);
    i.emw_1 = $this$provideLexicalScope;
    i.fmw_1 = contextNode;
    return i;
  };
  function btbScopes$lambda$slambda_50(resultContinuation) {
    var i = new btbScopes$lambda$slambda_49(resultContinuation);
    var l = function ($this$provideLexicalScope, contextNode, $completion) {
      return i.gmw($this$provideLexicalScope, contextNode, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda$slambda_13($property, resultContinuation) {
    this.qmw_1 = $property;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda$slambda_13).tmw = function ($this$filter, it, $completion) {
    var tmp = this.umw($this$filter, it, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda$slambda_13).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof QueryBuilder ? p1 : THROW_CCE();
    return this.tmw(tmp, (!(p2 == null) ? isInterface(p2, ObjectPropertyDeclaration_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda$slambda_13).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        if (tmp === 0) {
          this.g9_1 = 1;
          return !equals(this.smw_1, this.qmw_1);
        } else if (tmp === 1) {
          throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda$slambda_13).umw = function ($this$filter, it, completion) {
    var i = new btbScopes$lambda$slambda$slambda_13(this.qmw_1, completion);
    i.rmw_1 = $this$filter;
    i.smw_1 = it;
    return i;
  };
  function btbScopes$lambda$slambda$slambda_14($property, resultContinuation) {
    var i = new btbScopes$lambda$slambda$slambda_13($property, resultContinuation);
    var l = function ($this$filter, it, $completion) {
      return i.tmw($this$filter, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_51(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_51).fmx = function ($this$provideLexicalScope, property, $completion) {
    var tmp = this.gmx($this$provideLexicalScope, property, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_51).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.fmx(tmp, (!(p2 == null) ? isInterface(p2, ObjectPropertyDeclaration_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_51).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.dmx_1.r77(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            return filter_0(ARGUMENT, btbScopes$lambda$slambda$slambda_14(this.emx_1, null));
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_51).gmx = function ($this$provideLexicalScope, property, completion) {
    var i = new btbScopes$lambda$slambda_51(completion);
    i.dmx_1 = $this$provideLexicalScope;
    i.emx_1 = property;
    return i;
  };
  function btbScopes$lambda$slambda_52(resultContinuation) {
    var i = new btbScopes$lambda$slambda_51(resultContinuation);
    var l = function ($this$provideLexicalScope, property, $completion) {
      return i.fmx($this$provideLexicalScope, property, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda$o$collect$slambda($$this$unsafeFlow, $this_provideLexicalScope, $ontologyElementHierarchy, $type, resultContinuation) {
    this.pmx_1 = $$this$unsafeFlow;
    this.qmx_1 = $this_provideLexicalScope;
    this.rmx_1 = $ontologyElementHierarchy;
    this.smx_1 = $type;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda$o$collect$slambda).f1q = function (value, $completion) {
    var tmp = this.g1q(value, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda$o$collect$slambda).v9 = function (p1, $completion) {
    return this.f1q((p1 == null ? true : !(p1 == null)) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda$o$collect$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 12;
            var tmp_0 = this;
            tmp_0.cmy_1 = this.pmx_1;
            var tmp_1 = this;
            tmp_1.bmy_1 = this.tmx_1;
            this.f9_1 = 1;
            continue $sm;
          case 1:
            this.vmx_1 = this.cmy_1;
            this.umx_1 = this.bmy_1;
            var tmp_2 = this;
            tmp_2.amy_1 = this.umx_1;
            this.f9_1 = 2;
            continue $sm;
          case 2:
            var it = this.amy_1;
            var tmp0_elvis_lhs = this.qmx_1.l60(it.sfq());
            if (tmp0_elvis_lhs == null) {
              this.wmx_1 = false;
              this.f9_1 = 8;
              var tmp_3 = this;
              continue $sm;
            } else {
              this.zmx_1 = tmp0_elvis_lhs;
              this.f9_1 = 3;
              continue $sm;
            }

          case 3:
            var t = this.zmx_1;
            var tmp1_elvis_lhs = this.qmx_1.l60(t.gfq());
            if (tmp1_elvis_lhs == null) {
              this.wmx_1 = false;
              this.f9_1 = 8;
              var tmp_4 = this;
              continue $sm;
            } else {
              this.ymx_1 = tmp1_elvis_lhs;
              this.f9_1 = 4;
              continue $sm;
            }

          case 4:
            var er = this.ymx_1;
            this.f9_1 = 5;
            suspendResult = this.qmx_1.k60(er.gfq(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 5:
            var tmp2_elvis_lhs = suspendResult;
            if (tmp2_elvis_lhs == null) {
              this.wmx_1 = false;
              this.f9_1 = 8;
              var tmp_5 = this;
              continue $sm;
            } else {
              this.xmx_1 = tmp2_elvis_lhs;
              this.f9_1 = 6;
              continue $sm;
            }

          case 6:
            var fieldType = this.xmx_1;
            this.f9_1 = 7;
            suspendResult = this.qmx_1.k60(isSubtypeOf(this.rmx_1, this.smx_1, fieldType), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 7:
            this.wmx_1 = suspendResult;
            if (false) {
              this.f9_1 = 2;
              continue $sm;
            }

            this.f9_1 = 8;
            continue $sm;
          case 8:
            if (this.wmx_1) {
              this.f9_1 = 10;
              suspendResult = this.vmx_1.x18(this.umx_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.f9_1 = 9;
              continue $sm;
            }

          case 9:
            if (false) {
              this.f9_1 = 1;
              continue $sm;
            }

            this.f9_1 = 11;
            continue $sm;
          case 10:
            this.f9_1 = 11;
            continue $sm;
          case 11:
            return Unit_instance;
          case 12:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 12) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda$o$collect$slambda).g1q = function (value, completion) {
    var i = new btbScopes$lambda$slambda$o$collect$slambda(this.pmx_1, this.qmx_1, this.rmx_1, this.smx_1, completion);
    i.tmx_1 = value;
    return i;
  };
  function btbScopes$lambda$slambda$o$collect$slambda_0($$this$unsafeFlow, $this_provideLexicalScope, $ontologyElementHierarchy, $type, resultContinuation) {
    var i = new btbScopes$lambda$slambda$o$collect$slambda($$this$unsafeFlow, $this_provideLexicalScope, $ontologyElementHierarchy, $type, resultContinuation);
    var l = function (value, $completion) {
      return i.f1q(value, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function $collectCOROUTINE$_20(_this__u8e3s4, collector, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.lmy_1 = _this__u8e3s4;
    this.mmy_1 = collector;
  }
  protoOf($collectCOROUTINE$_20).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            var $this$unsafeFlow = this.mmy_1;
            this.f9_1 = 1;
            var tmp_0 = btbScopes$lambda$slambda$o$collect$slambda_0($this$unsafeFlow, this.lmy_1.omy_1, this.lmy_1.pmy_1, this.lmy_1.qmy_1, null);
            suspendResult = this.lmy_1.nmy_1.f18(new sam$kotlinx_coroutines_flow_FlowCollector$0_19(tmp_0), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function btbScopes$lambda$slambda$lambda($this_provideLexicalScope) {
    return function (it) {
      return $this_provideLexicalScope.l60(it.ue2());
    };
  }
  function btbScopes$lambda$slambda$lambda_0($this_provideLexicalScope) {
    return function (it) {
      return $this_provideLexicalScope.l60(it.rfq());
    };
  }
  function btbScopes$2$56$$inlined$filter$1($this, $this_provideLexicalScope, $ontologyElementHierarchy, $type) {
    this.nmy_1 = $this;
    this.omy_1 = $this_provideLexicalScope;
    this.pmy_1 = $ontologyElementHierarchy;
    this.qmy_1 = $type;
  }
  protoOf(btbScopes$2$56$$inlined$filter$1).y18 = function (collector, $completion) {
    var tmp = new $collectCOROUTINE$_20(this, collector, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$2$56$$inlined$filter$1).f18 = function (collector, $completion) {
    return this.y18(collector, $completion);
  };
  function btbScopes$lambda$slambda_53($this_scopes, $librariesScopeProvider$delegate, resultContinuation) {
    this.zmy_1 = $this_scopes;
    this.amz_1 = $librariesScopeProvider$delegate;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_53).fmz = function ($this$provideLexicalScope, partValue, $completion) {
    var tmp = this.gmz($this$provideLexicalScope, partValue, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_53).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.fmz(tmp, (!(p2 == null) ? isInterface(p2, PartValue) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_53).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 7;
            var tmp0_safe_receiver = this.bmz_1.l60(this.cmz_1.jfs());
            var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.pfu();
            if (tmp1_safe_receiver == null) {
              this.emz_1 = null;
              this.f9_1 = 2;
              continue $sm;
            } else {
              this.f9_1 = 1;
              suspendResult = this.bmz_1.k60(tmp1_safe_receiver, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            this.emz_1 = suspendResult;
            this.f9_1 = 2;
            continue $sm;
          case 2:
            var tmp2_elvis_lhs = this.emz_1;
            var tmp_0;
            if (tmp2_elvis_lhs == null) {
              return new EmptyScope();
            } else {
              tmp_0 = tmp2_elvis_lhs;
            }

            var variable = tmp_0;
            var tmp3_elvis_lhs = this.bmz_1.l60(variable.ofu());
            var tmp_1;
            if (tmp3_elvis_lhs == null) {
              return new EmptyScope();
            } else {
              tmp_1 = tmp3_elvis_lhs;
            }

            var varType = tmp_1;
            var tmp4_elvis_lhs = isInterface(varType, OntologyElementType_1) ? varType : null;
            var tmp_2;
            if (tmp4_elvis_lhs == null) {
              return new EmptyScope();
            } else {
              tmp_2 = tmp4_elvis_lhs;
            }

            var ontologyElementType = tmp_2;
            var tmp5_safe_receiver = this.bmz_1.l60(ontologyElementType.gfq());
            var tmp6_safe_receiver = tmp5_safe_receiver == null ? null : tmp5_safe_receiver.gfq();
            if (tmp6_safe_receiver == null) {
              this.dmz_1 = null;
              this.f9_1 = 4;
              continue $sm;
            } else {
              this.f9_1 = 3;
              suspendResult = this.bmz_1.k60(tmp6_safe_receiver, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 3:
            this.dmz_1 = suspendResult;
            this.f9_1 = 4;
            continue $sm;
          case 4:
            var tmp7_elvis_lhs = this.dmz_1;
            var tmp_3;
            if (tmp7_elvis_lhs == null) {
              return new EmptyScope();
            } else {
              tmp_3 = tmp7_elvis_lhs;
            }

            var type = tmp_3;
            var ontologyElementHierarchy_0 = ontologyElementHierarchy();
            this.f9_1 = 5;
            var tmp_4 = this.bmz_1.l60(this.bmz_1.l60(invoke$lambda(this.zmy_1, this.amz_1).a6v(this.cmz_1)).h6v(ExtensionLibraryConcept_getInstance()));
            var tmp_5 = flatMap(tmp_4, btbScopes$lambda$slambda$lambda(this.bmz_1));
            var this_0 = asFlow(flatMap(tmp_5, btbScopes$lambda$slambda$lambda_0(this.bmz_1)));
            suspendResult = toList_3(new btbScopes$2$56$$inlined$filter$1(this_0, this.bmz_1, ontologyElementHierarchy_0, type), VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 5:
            var extensionFields = suspendResult;
            this.f9_1 = 6;
            suspendResult = this.bmz_1.v77(extensionFields, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 6:
            return suspendResult;
          case 7:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 7) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_53).gmz = function ($this$provideLexicalScope, partValue, completion) {
    var i = new btbScopes$lambda$slambda_53(this.zmy_1, this.amz_1, completion);
    i.bmz_1 = $this$provideLexicalScope;
    i.cmz_1 = partValue;
    return i;
  };
  function btbScopes$lambda$slambda_54($this_scopes, $librariesScopeProvider$delegate, resultContinuation) {
    var i = new btbScopes$lambda$slambda_53($this_scopes, $librariesScopeProvider$delegate, resultContinuation);
    var l = function ($this$provideLexicalScope, partValue, $completion) {
      return i.fmz($this$provideLexicalScope, partValue, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_55($this_scopes, $subtypeScopeFilters$delegate, resultContinuation) {
    this.pmz_1 = $this_scopes;
    this.qmz_1 = $subtypeScopeFilters$delegate;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_55).wmz = function ($this$constrainScope, linkValue, $completion) {
    var tmp = this.xmz($this$constrainScope, linkValue, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_55).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeConstraintBuilder ? p1 : THROW_CCE();
    return this.wmz(tmp, (!(p2 == null) ? isInterface(p2, OntologyLinkValue_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_55).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 6;
            this.f9_1 = 1;
            suspendResult = this.rmz_1.k60(this.smz_1.cft(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp0_safe_receiver = suspendResult;
            if (tmp0_safe_receiver == null) {
              this.tmz_1 = null;
              this.f9_1 = 5;
              continue $sm;
            } else {
              this.vmz_1 = tmp0_safe_receiver;
              this.f9_1 = 2;
              suspendResult = this.rmz_1.k60(this.vmz_1.jfr(), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 2:
            var ARGUMENT = suspendResult;
            if (!equals(ARGUMENT, LinkTypeSpecificator_TYPE_OF_getInstance())) {
              var tmp_0 = this;
              tmp_0.umz_1 = null;
              this.f9_1 = 4;
              continue $sm;
            } else {
              this.f9_1 = 3;
              suspendResult = this.rmz_1.k60(this.vmz_1.gfq(), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 3:
            this.umz_1 = suspendResult;
            this.f9_1 = 4;
            continue $sm;
          case 4:
            this.tmz_1 = this.umz_1;
            this.f9_1 = 5;
            continue $sm;
          case 5:
            var upperElement = this.tmz_1;
            return upperElement == null ? this.rmz_1.r78_1 : invoke$lambda_0(this.pmz_1, this.qmz_1).dml(upperElement);
          case 6:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 6) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_55).xmz = function ($this$constrainScope, linkValue, completion) {
    var i = new btbScopes$lambda$slambda_55(this.pmz_1, this.qmz_1, completion);
    i.rmz_1 = $this$constrainScope;
    i.smz_1 = linkValue;
    return i;
  };
  function btbScopes$lambda$slambda_56($this_scopes, $subtypeScopeFilters$delegate, resultContinuation) {
    var i = new btbScopes$lambda$slambda_55($this_scopes, $subtypeScopeFilters$delegate, resultContinuation);
    var l = function ($this$constrainScope, linkValue, $completion) {
      return i.wmz($this$constrainScope, linkValue, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_57(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_57).kn0 = function ($this$provideLexicalScope, linkValue, $completion) {
    var tmp = this.ln0($this$provideLexicalScope, linkValue, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_57).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.kn0(tmp, (!(p2 == null) ? isInterface(p2, OntologyLinkValue_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_57).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 7;
            this.f9_1 = 1;
            suspendResult = this.gn0_1.k60(this.hn0_1.cft(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp0_elvis_lhs = suspendResult;
            var tmp_0 = this;
            var tmp_1;
            if (tmp0_elvis_lhs == null) {
              return new EmptyScope();
            } else {
              tmp_1 = tmp0_elvis_lhs;
            }

            tmp_0.jn0_1 = tmp_1;
            this.f9_1 = 2;
            suspendResult = this.gn0_1.k60(this.jn0_1.jfr(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var ARGUMENT = suspendResult;
            if (!equals(ARGUMENT, LinkTypeSpecificator_TYPE_OF_getInstance())) {
              return Scopes_getInstance().u7b();
            } else {
              this.f9_1 = 3;
              continue $sm;
            }

          case 3:
            var defaultLibraryReference = this.gn0_1.l60(this.jn0_1.aft());
            var tmp_2;
            if (defaultLibraryReference == null) {
              tmp_2 = null;
            } else {
              tmp_2 = listOf(defaultLibraryReference);
            }

            var tmp2_elvis_lhs = tmp_2;
            if (tmp2_elvis_lhs == null) {
              this.f9_1 = 4;
              suspendResult = this.gn0_1.k60(this.hn0_1.fij(), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.in0_1 = tmp2_elvis_lhs;
              this.f9_1 = 5;
              continue $sm;
            }

          case 4:
            this.in0_1 = suspendResult;
            this.f9_1 = 5;
            continue $sm;
          case 5:
            var librariesToUse = this.in0_1;
            this.f9_1 = 6;
            suspendResult = importOntologyLibraries(this.gn0_1, librariesToUse, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 6:
            return suspendResult;
          case 7:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 7) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_57).ln0 = function ($this$provideLexicalScope, linkValue, completion) {
    var i = new btbScopes$lambda$slambda_57(completion);
    i.gn0_1 = $this$provideLexicalScope;
    i.hn0_1 = linkValue;
    return i;
  };
  function btbScopes$lambda$slambda_58(resultContinuation) {
    var i = new btbScopes$lambda$slambda_57(resultContinuation);
    var l = function ($this$provideLexicalScope, linkValue, $completion) {
      return i.kn0($this$provideLexicalScope, linkValue, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_59($this_scopes, $subtypeScopeFilters$delegate, resultContinuation) {
    this.un0_1 = $this_scopes;
    this.vn0_1 = $subtypeScopeFilters$delegate;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_59).yn0 = function ($this$constrainScope, propertyValue, $completion) {
    var tmp = this.zn0($this$constrainScope, propertyValue, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_59).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeConstraintBuilder ? p1 : THROW_CCE();
    return this.yn0(tmp, (!(p2 == null) ? isInterface(p2, ProcessPropertyValue_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_59).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.wn0_1.k60(propertyTypeElements(this.xn0_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp0_elvis_lhs = suspendResult;
            var tmp_0;
            if (tmp0_elvis_lhs == null) {
              return this.wn0_1.r78_1;
            } else {
              tmp_0 = tmp0_elvis_lhs;
            }

            var baseTypeElements = tmp_0;
            return invoke$lambda_0(this.un0_1, this.vn0_1).cml(baseTypeElements);
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_59).zn0 = function ($this$constrainScope, propertyValue, completion) {
    var i = new btbScopes$lambda$slambda_59(this.un0_1, this.vn0_1, completion);
    i.wn0_1 = $this$constrainScope;
    i.xn0_1 = propertyValue;
    return i;
  };
  function btbScopes$lambda$slambda_60($this_scopes, $subtypeScopeFilters$delegate, resultContinuation) {
    var i = new btbScopes$lambda$slambda_59($this_scopes, $subtypeScopeFilters$delegate, resultContinuation);
    var l = function ($this$constrainScope, propertyValue, $completion) {
      return i.yn0($this$constrainScope, propertyValue, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_61($this_scopes, $subtypeScopeFilters$delegate, resultContinuation) {
    this.in1_1 = $this_scopes;
    this.jn1_1 = $subtypeScopeFilters$delegate;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_61).mn1 = function ($this$constrainScope, relationValue, $completion) {
    var tmp = this.nn1($this$constrainScope, relationValue, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_61).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeConstraintBuilder ? p1 : THROW_CCE();
    return this.mn1(tmp, (!(p2 == null) ? isInterface(p2, InstanceRelationValue) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_61).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 3;
            this.f9_1 = 1;
            suspendResult = this.kn1_1.k60(this.ln1_1.xfq(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp0_safe_receiver = suspendResult;
            var ARGUMENT = tmp0_safe_receiver == null ? null : this.kn1_1.l60(tmp0_safe_receiver.hd());
            var ARGUMENT_0 = typeElements(ARGUMENT);
            this.f9_1 = 2;
            suspendResult = this.kn1_1.k60(ARGUMENT_0, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var tmp1_elvis_lhs = suspendResult;
            var tmp_0;
            if (tmp1_elvis_lhs == null) {
              return this.kn1_1.r78_1;
            } else {
              tmp_0 = tmp1_elvis_lhs;
            }

            var ontologyElementRangeType = tmp_0;
            return invoke$lambda_0(this.in1_1, this.jn1_1).cml(ontologyElementRangeType);
          case 3:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 3) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_61).nn1 = function ($this$constrainScope, relationValue, completion) {
    var i = new btbScopes$lambda$slambda_61(this.in1_1, this.jn1_1, completion);
    i.kn1_1 = $this$constrainScope;
    i.ln1_1 = relationValue;
    return i;
  };
  function btbScopes$lambda$slambda_62($this_scopes, $subtypeScopeFilters$delegate, resultContinuation) {
    var i = new btbScopes$lambda$slambda_61($this_scopes, $subtypeScopeFilters$delegate, resultContinuation);
    var l = function ($this$constrainScope, relationValue, $completion) {
      return i.mn1($this$constrainScope, relationValue, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function PropertyConstraint$_get_value_$ref_f1oxa5_1() {
    return function (p0) {
      return p0.a1();
    };
  }
  function btbScopes$lambda$slambda_63($this_scopes, $subtypeScopeFilters$delegate, resultContinuation) {
    this.wn1_1 = $this_scopes;
    this.xn1_1 = $subtypeScopeFilters$delegate;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_63).an2 = function ($this$constrainScope, propertyConstraint, $completion) {
    var tmp = this.bn2($this$constrainScope, propertyConstraint, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_63).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeConstraintBuilder ? p1 : THROW_CCE();
    return this.an2(tmp, (!(p2 == null) ? isInterface(p2, PropertyConstraint_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_63).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 3;
            this.f9_1 = 1;
            suspendResult = this.yn1_1.k60(this.zn1_1.q6q().x6o(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp0_elvis_lhs = suspendResult;
            var tmp_0;
            if (tmp0_elvis_lhs == null) {
              return this.yn1_1.r78_1;
            } else {
              tmp_0 = tmp0_elvis_lhs;
            }

            var property = tmp_0;
            this.f9_1 = 2;
            suspendResult = this.yn1_1.k60(filterOntologyElementsByPropertyRange(property, invoke$lambda_0(this.wn1_1, this.xn1_1)), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var tmp1_elvis_lhs = suspendResult;
            var tmp_1;
            if (tmp1_elvis_lhs == null) {
              return this.yn1_1.r78_1;
            } else {
              tmp_1 = tmp1_elvis_lhs;
            }

            return tmp_1;
          case 3:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 3) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_63).bn2 = function ($this$constrainScope, propertyConstraint, completion) {
    var i = new btbScopes$lambda$slambda_63(this.wn1_1, this.xn1_1, completion);
    i.yn1_1 = $this$constrainScope;
    i.zn1_1 = propertyConstraint;
    return i;
  };
  function btbScopes$lambda$slambda_64($this_scopes, $subtypeScopeFilters$delegate, resultContinuation) {
    var i = new btbScopes$lambda$slambda_63($this_scopes, $subtypeScopeFilters$delegate, resultContinuation);
    var l = function ($this$constrainScope, propertyConstraint, $completion) {
      return i.an2($this$constrainScope, propertyConstraint, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_65(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_65).rn2 = function ($this$provideLexicalScope, constraint, $completion) {
    var tmp = this.sn2($this$provideLexicalScope, constraint, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_65).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.rn2(tmp, (!(p2 == null) ? isInterface(p2, PropertyConstraint_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_65).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 10;
            this.f9_1 = 1;
            suspendResult = this.kn2_1.k60(this.ln2_1.q6q().x6o(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp0_safe_receiver = suspendResult;
            var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : this.kn2_1.l60(tmp0_safe_receiver.hd());
            var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : this.kn2_1.l60(tmp1_safe_receiver.cfs());
            if (tmp2_safe_receiver == null) {
              this.on2_1 = null;
              this.f9_1 = 5;
              continue $sm;
            } else {
              this.pn2_1 = ArrayList_init_$Create$();
              this.qn2_1 = tmp2_safe_receiver.m();
              this.f9_1 = 2;
              continue $sm;
            }

          case 2:
            if (!this.qn2_1.n()) {
              this.f9_1 = 4;
              continue $sm;
            }

            var element = this.qn2_1.o();
            this.f9_1 = 3;
            suspendResult = this.kn2_1.k60(typeElements(element), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            var tmp0_safe_receiver_0 = suspendResult;
            if (tmp0_safe_receiver_0 == null)
              null;
            else {
              this.pn2_1.j(tmp0_safe_receiver_0);
            }

            this.f9_1 = 2;
            continue $sm;
          case 4:
            this.on2_1 = this.pn2_1;
            this.f9_1 = 5;
            continue $sm;
          case 5:
            var tmp3_safe_receiver = this.on2_1;
            var tmp4_safe_receiver = tmp3_safe_receiver == null ? null : flatten(tmp3_safe_receiver);
            var tmp5_elvis_lhs = tmp4_safe_receiver == null ? null : toSet_0(tmp4_safe_receiver);
            if (tmp5_elvis_lhs == null) {
              this.f9_1 = 6;
              suspendResult = this.kn2_1.y77(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.nn2_1 = tmp5_elvis_lhs;
              this.f9_1 = 7;
              continue $sm;
            }

          case 6:
            var tmp_0 = this;
            return suspendResult;
          case 7:
            var ontologyElementRangeTypes = this.nn2_1;
            if (!ontologyElementRangeTypes.s()) {
              this.f9_1 = 8;
              suspendResult = this.kn2_1.y77(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.mn2_1 = Scopes_getInstance().u7b();
              this.f9_1 = 9;
              continue $sm;
            }

          case 8:
            this.mn2_1 = suspendResult;
            this.f9_1 = 9;
            continue $sm;
          case 9:
            return this.mn2_1;
          case 10:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 10) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_65).sn2 = function ($this$provideLexicalScope, constraint, completion) {
    var i = new btbScopes$lambda$slambda_65(completion);
    i.kn2_1 = $this$provideLexicalScope;
    i.ln2_1 = constraint;
    return i;
  };
  function btbScopes$lambda$slambda_66(resultContinuation) {
    var i = new btbScopes$lambda$slambda_65(resultContinuation);
    var l = function ($this$provideLexicalScope, constraint, $completion) {
      return i.rn2($this$provideLexicalScope, constraint, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_67($this_scopes, $subtypeScopeFilters$delegate, resultContinuation) {
    this.bn3_1 = $this_scopes;
    this.cn3_1 = $subtypeScopeFilters$delegate;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_67).in3 = function ($this$constrainScope, expression, $completion) {
    var tmp = this.jn3($this$constrainScope, expression, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_67).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeConstraintBuilder ? p1 : THROW_CCE();
    return this.in3(tmp, (!(p2 == null) ? isInterface(p2, IsExpression_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_67).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 6;
            var tmp0_safe_receiver = this.dn3_1.l60(this.en3_1.mdy());
            var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : this.dn3_1.l60(tmp0_safe_receiver.q6q());
            if (tmp1_safe_receiver == null) {
              this.hn3_1 = null;
              this.f9_1 = 2;
              continue $sm;
            } else {
              this.f9_1 = 1;
              suspendResult = this.dn3_1.k60(tmp1_safe_receiver.q6q(), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            this.hn3_1 = suspendResult;
            this.f9_1 = 2;
            continue $sm;
          case 2:
            var tmp2_safe_receiver = this.hn3_1;
            var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : this.dn3_1.l60(tmp2_safe_receiver.hd());
            var tmp4_elvis_lhs = tmp3_safe_receiver == null ? null : this.dn3_1.l60(tmp3_safe_receiver.cfs());
            var types = tmp4_elvis_lhs == null ? emptyList() : tmp4_elvis_lhs;
            this.fn3_1 = ArrayList_init_$Create$();
            this.gn3_1 = types.m();
            this.f9_1 = 3;
            continue $sm;
          case 3:
            if (!this.gn3_1.n()) {
              this.f9_1 = 5;
              continue $sm;
            }

            var element = this.gn3_1.o();
            this.f9_1 = 4;
            suspendResult = this.dn3_1.k60(typeElements(element), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            var tmp0_safe_receiver_0 = suspendResult;
            if (tmp0_safe_receiver_0 == null)
              null;
            else {
              this.fn3_1.j(tmp0_safe_receiver_0);
            }

            this.f9_1 = 3;
            continue $sm;
          case 5:
            var ARGUMENT = this.fn3_1;
            var baseTypeElements = flatten(ARGUMENT);
            return invoke$lambda_0(this.bn3_1, this.cn3_1).cml(baseTypeElements);
          case 6:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 6) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_67).jn3 = function ($this$constrainScope, expression, completion) {
    var i = new btbScopes$lambda$slambda_67(this.bn3_1, this.cn3_1, completion);
    i.dn3_1 = $this$constrainScope;
    i.en3_1 = expression;
    return i;
  };
  function btbScopes$lambda$slambda_68($this_scopes, $subtypeScopeFilters$delegate, resultContinuation) {
    var i = new btbScopes$lambda$slambda_67($this_scopes, $subtypeScopeFilters$delegate, resultContinuation);
    var l = function ($this$constrainScope, expression, $completion) {
      return i.in3($this$constrainScope, expression, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_69($this_scopes, $subtypeScopeFilters$delegate, resultContinuation) {
    this.sn3_1 = $this_scopes;
    this.tn3_1 = $subtypeScopeFilters$delegate;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_69).wn3 = function ($this$constrainScope, processPropertyDefault, $completion) {
    var tmp = this.xn3($this$constrainScope, processPropertyDefault, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_69).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeConstraintBuilder ? p1 : THROW_CCE();
    return this.wn3(tmp, (!(p2 == null) ? isInterface(p2, ProcessPropertyDefault_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_69).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            var tmp0_elvis_lhs = this.un3_1.l60(ancestorOrSelf(this.vn3_1, getKClass(ProcessProperty_1)));
            var tmp_0;
            if (tmp0_elvis_lhs == null) {
              return this.un3_1.r78_1;
            } else {
              tmp_0 = tmp0_elvis_lhs;
            }

            var processProperty = tmp_0;
            this.f9_1 = 1;
            suspendResult = processPropertyElements(this.un3_1, processProperty, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp1_elvis_lhs = suspendResult;
            var tmp_1;
            if (tmp1_elvis_lhs == null) {
              return this.un3_1.r78_1;
            } else {
              tmp_1 = tmp1_elvis_lhs;
            }

            var baseTypeElements = tmp_1;
            return invoke$lambda_0(this.sn3_1, this.tn3_1).cml(baseTypeElements);
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_69).xn3 = function ($this$constrainScope, processPropertyDefault, completion) {
    var i = new btbScopes$lambda$slambda_69(this.sn3_1, this.tn3_1, completion);
    i.un3_1 = $this$constrainScope;
    i.vn3_1 = processPropertyDefault;
    return i;
  };
  function btbScopes$lambda$slambda_70($this_scopes, $subtypeScopeFilters$delegate, resultContinuation) {
    var i = new btbScopes$lambda$slambda_69($this_scopes, $subtypeScopeFilters$delegate, resultContinuation);
    var l = function ($this$constrainScope, processPropertyDefault, $completion) {
      return i.wn3($this$constrainScope, processPropertyDefault, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_71(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_71).in4 = function ($this$provideLexicalScope, propertyValue, $completion) {
    var tmp = this.jn4($this$provideLexicalScope, propertyValue, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_71).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.in4(tmp, (!(p2 == null) ? isInterface(p2, ProcessPropertyValue_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_71).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 4;
            this.f9_1 = 1;
            suspendResult = this.gn4_1.k60(propertyTypeElements(this.hn4_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp0_elvis_lhs = suspendResult;
            var tmp_0;
            if (tmp0_elvis_lhs == null) {
              return new EmptyScope();
            } else {
              tmp_0 = tmp0_elvis_lhs;
            }

            var elements = tmp_0;
            if (!(elements.p() === 1))
              return new EmptyScope();
            var this_0 = this.hn4_1;
            var tmp1_elvis_lhs = this.gn4_1.l60(ancestorOrSelf(this_0, getKClass(BTBDocument_1)));
            var tmp_1;
            if (tmp1_elvis_lhs == null) {
              return new EmptyScope();
            } else {
              tmp_1 = tmp1_elvis_lhs;
            }

            var doc = tmp_1;
            this.f9_1 = 2;
            suspendResult = this.gn4_1.k60(doc.li0(first_0(elements)), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var ARGUMENT = suspendResult;
            this.f9_1 = 3;
            suspendResult = importOntologyLibraries(this.gn4_1, ARGUMENT, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            return suspendResult;
          case 4:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 4) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_71).jn4 = function ($this$provideLexicalScope, propertyValue, completion) {
    var i = new btbScopes$lambda$slambda_71(completion);
    i.gn4_1 = $this$provideLexicalScope;
    i.hn4_1 = propertyValue;
    return i;
  };
  function btbScopes$lambda$slambda_72(resultContinuation) {
    var i = new btbScopes$lambda$slambda_71(resultContinuation);
    var l = function ($this$provideLexicalScope, propertyValue, $completion) {
      return i.in4($this$provideLexicalScope, propertyValue, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_73(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_73).xn4 = function ($this$provideLexicalScope, expression, $completion) {
    var tmp = this.yn4($this$provideLexicalScope, expression, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_73).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.xn4(tmp, (!(p2 == null) ? isInterface(p2, IsExpression_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_73).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 8;
            var tmp0_safe_receiver = this.sn4_1.l60(this.tn4_1.mdy());
            var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : this.sn4_1.l60(tmp0_safe_receiver.q6q());
            if (tmp1_safe_receiver == null) {
              this.wn4_1 = null;
              this.f9_1 = 2;
              continue $sm;
            } else {
              this.f9_1 = 1;
              suspendResult = this.sn4_1.k60(tmp1_safe_receiver.q6q(), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            this.wn4_1 = suspendResult;
            this.f9_1 = 2;
            continue $sm;
          case 2:
            var tmp2_safe_receiver = this.wn4_1;
            var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : this.sn4_1.l60(tmp2_safe_receiver.hd());
            var tmp4_elvis_lhs = tmp3_safe_receiver == null ? null : this.sn4_1.l60(tmp3_safe_receiver.cfs());
            var types = tmp4_elvis_lhs == null ? emptyList() : tmp4_elvis_lhs;
            this.un4_1 = ArrayList_init_$Create$();
            this.vn4_1 = types.m();
            this.f9_1 = 3;
            continue $sm;
          case 3:
            if (!this.vn4_1.n()) {
              this.f9_1 = 5;
              continue $sm;
            }

            var element = this.vn4_1.o();
            this.f9_1 = 4;
            suspendResult = this.sn4_1.k60(typeElements(element), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            var tmp0_safe_receiver_0 = suspendResult;
            if (tmp0_safe_receiver_0 == null)
              null;
            else {
              this.un4_1.j(tmp0_safe_receiver_0);
            }

            this.f9_1 = 3;
            continue $sm;
          case 5:
            var ARGUMENT = this.un4_1;
            var elements = flatten(ARGUMENT);
            if (!(elements.p() === 1))
              return new EmptyScope();
            var this_0 = this.tn4_1;
            var tmp5_elvis_lhs = this.sn4_1.l60(ancestorOrSelf(this_0, getKClass(BTBDocument_1)));
            var tmp_0;
            if (tmp5_elvis_lhs == null) {
              return new EmptyScope();
            } else {
              tmp_0 = tmp5_elvis_lhs;
            }

            var doc = tmp_0;
            this.f9_1 = 6;
            suspendResult = this.sn4_1.k60(doc.li0(first(elements)), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 6:
            var ARGUMENT_0 = suspendResult;
            this.f9_1 = 7;
            suspendResult = importOntologyLibraries(this.sn4_1, ARGUMENT_0, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 7:
            return suspendResult;
          case 8:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 8) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_73).yn4 = function ($this$provideLexicalScope, expression, completion) {
    var i = new btbScopes$lambda$slambda_73(completion);
    i.sn4_1 = $this$provideLexicalScope;
    i.tn4_1 = expression;
    return i;
  };
  function btbScopes$lambda$slambda_74(resultContinuation) {
    var i = new btbScopes$lambda$slambda_73(resultContinuation);
    var l = function ($this$provideLexicalScope, expression, $completion) {
      return i.xn4($this$provideLexicalScope, expression, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_75(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_75).jn5 = function ($this$provideLexicalScope, elementReferenceValue, $completion) {
    var tmp = this.kn5($this$provideLexicalScope, elementReferenceValue, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_75).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.jn5(tmp, (!(p2 == null) ? isInterface(p2, OntologyElementReferenceValueLibrary_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_75).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 3;
            var tmp0_elvis_lhs = this.hn5_1.l60(this.in5_1.ffq());
            var tmp_0;
            if (tmp0_elvis_lhs == null) {
              return new EmptyScope();
            } else {
              tmp_0 = tmp0_elvis_lhs;
            }

            var libraryReference = tmp_0;
            this.f9_1 = 1;
            suspendResult = importOntologyLibrary(this.hn5_1, libraryReference, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            this.f9_1 = 2;
            suspendResult = this.hn5_1.t77(ARGUMENT, get_elementTypeAndTaxon(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return suspendResult;
          case 3:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 3) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_75).kn5 = function ($this$provideLexicalScope, elementReferenceValue, completion) {
    var i = new btbScopes$lambda$slambda_75(completion);
    i.hn5_1 = $this$provideLexicalScope;
    i.in5_1 = elementReferenceValue;
    return i;
  };
  function btbScopes$lambda$slambda_76(resultContinuation) {
    var i = new btbScopes$lambda$slambda_75(resultContinuation);
    var l = function ($this$provideLexicalScope, elementReferenceValue, $completion) {
      return i.jn5($this$provideLexicalScope, elementReferenceValue, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_77(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_77).vn5 = function ($this$provideImportScope, notion, $completion) {
    var tmp = this.wn5($this$provideImportScope, notion, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_77).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.vn5(tmp, (!(p2 == null) ? isInterface(p2, EnumerableNotion_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_77).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.tn5_1.u77(this.un5_1.qfq(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_77).wn5 = function ($this$provideImportScope, notion, completion) {
    var i = new btbScopes$lambda$slambda_77(completion);
    i.tn5_1 = $this$provideImportScope;
    i.un5_1 = notion;
    return i;
  };
  function btbScopes$lambda$slambda_78(resultContinuation) {
    var i = new btbScopes$lambda$slambda_77(resultContinuation);
    var l = function ($this$provideImportScope, notion, $completion) {
      return i.vn5($this$provideImportScope, notion, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_79(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_79).hn6 = function ($this$provideImportScope, notion, $completion) {
    var tmp = this.in6($this$provideImportScope, notion, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_79).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.hn6(tmp, (!(p2 == null) ? isInterface(p2, MeasurableNotion_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_79).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.fn6_1.u77(this.gn6_1.xfr(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_79).in6 = function ($this$provideImportScope, notion, completion) {
    var i = new btbScopes$lambda$slambda_79(completion);
    i.fn6_1 = $this$provideImportScope;
    i.gn6_1 = notion;
    return i;
  };
  function btbScopes$lambda$slambda_80(resultContinuation) {
    var i = new btbScopes$lambda$slambda_79(resultContinuation);
    var l = function ($this$provideImportScope, notion, $completion) {
      return i.hn6($this$provideImportScope, notion, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_81(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_81).tn6 = function ($this$provideImportScope, property, $completion) {
    var tmp = this.un6($this$provideImportScope, property, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_81).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.tn6(tmp, (!(p2 == null) ? isInterface(p2, PropertyDeclaration_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_81).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            var tmp0_elvis_lhs = this.rn6_1.l60(this.sn6_1.sfq());
            var tmp_0;
            if (tmp0_elvis_lhs == null) {
              return new EmptyScope();
            } else {
              tmp_0 = tmp0_elvis_lhs;
            }

            var type = tmp_0;
            this.f9_1 = 1;
            suspendResult = this.rn6_1.w77(type.mfq(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_81).un6 = function ($this$provideImportScope, property, completion) {
    var i = new btbScopes$lambda$slambda_81(completion);
    i.rn6_1 = $this$provideImportScope;
    i.sn6_1 = property;
    return i;
  };
  function btbScopes$lambda$slambda_82(resultContinuation) {
    var i = new btbScopes$lambda$slambda_81(resultContinuation);
    var l = function ($this$provideImportScope, property, $completion) {
      return i.tn6($this$provideImportScope, property, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_83(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_83).fn7 = function ($this$provideCommonScope, property, $completion) {
    var tmp = this.gn7($this$provideCommonScope, property, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_83).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.fn7(tmp, (!(p2 == null) ? isInterface(p2, ProcessProperty_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_83).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            var tmp0_safe_receiver = this.dn7_1.l60(this.en7_1.sfq());
            var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : this.dn7_1.l60(tmp0_safe_receiver.sfq());
            var tmp_0;
            if (tmp1_elvis_lhs == null) {
              return new EmptyScope();
            } else {
              tmp_0 = tmp1_elvis_lhs;
            }

            var type = tmp_0;
            if (!isInterface(type, SimplePropertyType))
              return new EmptyScope();
            this.f9_1 = 1;
            suspendResult = this.dn7_1.w77(type.mfq(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_83).gn7 = function ($this$provideCommonScope, property, completion) {
    var i = new btbScopes$lambda$slambda_83(completion);
    i.dn7_1 = $this$provideCommonScope;
    i.en7_1 = property;
    return i;
  };
  function btbScopes$lambda$slambda_84(resultContinuation) {
    var i = new btbScopes$lambda$slambda_83(resultContinuation);
    var l = function ($this$provideCommonScope, property, $completion) {
      return i.fn7($this$provideCommonScope, property, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_85(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_85).rn7 = function ($this$provideImportScope, property, $completion) {
    var tmp = this.sn7($this$provideImportScope, property, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_85).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.rn7(tmp, (!(p2 == null) ? isInterface(p2, InstanceRelationDeclaration) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_85).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            var tmp0_elvis_lhs = this.pn7_1.l60(this.qn7_1.hd());
            var tmp_0;
            if (tmp0_elvis_lhs == null) {
              return new EmptyScope();
            } else {
              tmp_0 = tmp0_elvis_lhs;
            }

            var type = tmp_0;
            if (!isInterface(type, NotionType_0))
              return new EmptyScope();
            this.f9_1 = 1;
            suspendResult = this.pn7_1.w77(type.mfq(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_85).sn7 = function ($this$provideImportScope, property, completion) {
    var i = new btbScopes$lambda$slambda_85(completion);
    i.pn7_1 = $this$provideImportScope;
    i.qn7_1 = property;
    return i;
  };
  function btbScopes$lambda$slambda_86(resultContinuation) {
    var i = new btbScopes$lambda$slambda_85(resultContinuation);
    var l = function ($this$provideImportScope, property, $completion) {
      return i.rn7($this$provideImportScope, property, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_87(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_87).fn8 = function ($this$s, property, $completion) {
    var tmp = this.gn8($this$s, property, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_87).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.fn8(tmp, (!(p2 == null) ? isInterface(p2, ObjectPropertyDeclaration_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_87).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 4;
            var tmp0_safe_receiver = this.bn8_1.l60(this.cn8_1.hd());
            var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : this.bn8_1.l60(tmp0_safe_receiver.cfs());
            var tmp_0;
            if (tmp1_elvis_lhs == null) {
              return new EmptyScope();
            } else {
              tmp_0 = tmp1_elvis_lhs;
            }

            var types = tmp_0;
            var destination = ArrayList_init_$Create$();
            var _iterator__ex2g4s = types.m();
            while (_iterator__ex2g4s.n()) {
              var element = _iterator__ex2g4s.o();
              if (!(element == null) ? isInterface(element, NotionType_0) : false) {
                destination.j(element);
              }
            }

            this.dn8_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(destination, 10));
            this.en8_1 = destination.m();
            this.f9_1 = 1;
            continue $sm;
          case 1:
            if (!this.en8_1.n()) {
              this.f9_1 = 3;
              continue $sm;
            }

            var item = this.en8_1.o();
            this.f9_1 = 2;
            suspendResult = this.bn8_1.w77(item.mfq(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var ARGUMENT = suspendResult;
            this.dn8_1.j(ARGUMENT);
            this.f9_1 = 1;
            continue $sm;
          case 3:
            var tmp0 = this.dn8_1;
            var accumulator = new EmptyScope();
            var _iterator__ex2g4s_0 = tmp0.m();
            while (_iterator__ex2g4s_0.n()) {
              var element_0 = _iterator__ex2g4s_0.o();
              var p0 = accumulator;
              accumulator = new UniqueSumScope(p0, element_0);
            }

            return accumulator;
          case 4:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 4) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_87).gn8 = function ($this$s, property, completion) {
    var i = new btbScopes$lambda$slambda_87(completion);
    i.bn8_1 = $this$s;
    i.cn8_1 = property;
    return i;
  };
  function btbScopes$lambda$slambda_88(resultContinuation) {
    var i = new btbScopes$lambda$slambda_87(resultContinuation);
    var l = function ($this$s, property, $completion) {
      return i.fn8($this$s, property, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_89(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_89).rn8 = function ($this$provideImportScope, property, $completion) {
    var tmp = this.sn8($this$provideImportScope, property, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_89).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.rn8(tmp, (!(p2 == null) ? isInterface(p2, PropertyDeclaration_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_89).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            var tmp0_elvis_lhs = this.pn8_1.l60(this.qn8_1.sfq());
            var tmp_0;
            if (tmp0_elvis_lhs == null) {
              return new EmptyScope();
            } else {
              tmp_0 = tmp0_elvis_lhs;
            }

            var type = tmp_0;
            this.f9_1 = 1;
            suspendResult = this.pn8_1.w77(type.mfq(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_89).sn8 = function ($this$provideImportScope, property, completion) {
    var i = new btbScopes$lambda$slambda_89(completion);
    i.pn8_1 = $this$provideImportScope;
    i.qn8_1 = property;
    return i;
  };
  function btbScopes$lambda$slambda_90(resultContinuation) {
    var i = new btbScopes$lambda$slambda_89(resultContinuation);
    var l = function ($this$provideImportScope, property, $completion) {
      return i.rn8($this$provideImportScope, property, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_91(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_91).dn9 = function ($this$provideCommonScope, property, $completion) {
    var tmp = this.en9($this$provideCommonScope, property, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_91).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.dn9(tmp, (!(p2 == null) ? isInterface(p2, ProcessProperty_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_91).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            var tmp0_safe_receiver = this.bn9_1.l60(this.cn9_1.sfq());
            var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : this.bn9_1.l60(tmp0_safe_receiver.sfq());
            var tmp_0;
            if (tmp1_elvis_lhs == null) {
              return new EmptyScope();
            } else {
              tmp_0 = tmp1_elvis_lhs;
            }

            var type = tmp_0;
            if (!isInterface(type, SimplePropertyType))
              return new EmptyScope();
            this.f9_1 = 1;
            suspendResult = this.bn9_1.w77(type.mfq(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_91).en9 = function ($this$provideCommonScope, property, completion) {
    var i = new btbScopes$lambda$slambda_91(completion);
    i.bn9_1 = $this$provideCommonScope;
    i.cn9_1 = property;
    return i;
  };
  function btbScopes$lambda$slambda_92(resultContinuation) {
    var i = new btbScopes$lambda$slambda_91(resultContinuation);
    var l = function ($this$provideCommonScope, property, $completion) {
      return i.dn9($this$provideCommonScope, property, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_93(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_93).pn9 = function ($this$provideImportScope, property, $completion) {
    var tmp = this.qn9($this$provideImportScope, property, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_93).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.pn9(tmp, (!(p2 == null) ? isInterface(p2, InstanceRelationDeclaration) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_93).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            var tmp0_elvis_lhs = this.nn9_1.l60(this.on9_1.hd());
            var tmp_0;
            if (tmp0_elvis_lhs == null) {
              return new EmptyScope();
            } else {
              tmp_0 = tmp0_elvis_lhs;
            }

            var type = tmp_0;
            if (!isInterface(type, NotionType_0))
              return new EmptyScope();
            this.f9_1 = 1;
            suspendResult = this.nn9_1.w77(type.mfq(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_93).qn9 = function ($this$provideImportScope, property, completion) {
    var i = new btbScopes$lambda$slambda_93(completion);
    i.nn9_1 = $this$provideImportScope;
    i.on9_1 = property;
    return i;
  };
  function btbScopes$lambda$slambda_94(resultContinuation) {
    var i = new btbScopes$lambda$slambda_93(resultContinuation);
    var l = function ($this$provideImportScope, property, $completion) {
      return i.pn9($this$provideImportScope, property, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_95(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_95).dna = function ($this$s, property, $completion) {
    var tmp = this.ena($this$s, property, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_95).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.dna(tmp, (!(p2 == null) ? isInterface(p2, ObjectPropertyDeclaration_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_95).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 4;
            var tmp0_safe_receiver = this.zn9_1.l60(this.ana_1.hd());
            var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : this.zn9_1.l60(tmp0_safe_receiver.cfs());
            var tmp_0;
            if (tmp1_elvis_lhs == null) {
              return new EmptyScope();
            } else {
              tmp_0 = tmp1_elvis_lhs;
            }

            var types = tmp_0;
            var destination = ArrayList_init_$Create$();
            var _iterator__ex2g4s = types.m();
            while (_iterator__ex2g4s.n()) {
              var element = _iterator__ex2g4s.o();
              if (!(element == null) ? isInterface(element, NotionType_0) : false) {
                destination.j(element);
              }
            }

            this.bna_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(destination, 10));
            this.cna_1 = destination.m();
            this.f9_1 = 1;
            continue $sm;
          case 1:
            if (!this.cna_1.n()) {
              this.f9_1 = 3;
              continue $sm;
            }

            var item = this.cna_1.o();
            this.f9_1 = 2;
            suspendResult = this.zn9_1.w77(item.mfq(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var ARGUMENT = suspendResult;
            this.bna_1.j(ARGUMENT);
            this.f9_1 = 1;
            continue $sm;
          case 3:
            var tmp0 = this.bna_1;
            var accumulator = new EmptyScope();
            var _iterator__ex2g4s_0 = tmp0.m();
            while (_iterator__ex2g4s_0.n()) {
              var element_0 = _iterator__ex2g4s_0.o();
              var p0 = accumulator;
              accumulator = new UniqueSumScope(p0, element_0);
            }

            return accumulator;
          case 4:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 4) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_95).ena = function ($this$s, property, completion) {
    var i = new btbScopes$lambda$slambda_95(completion);
    i.zn9_1 = $this$s;
    i.ana_1 = property;
    return i;
  };
  function btbScopes$lambda$slambda_96(resultContinuation) {
    var i = new btbScopes$lambda$slambda_95(resultContinuation);
    var l = function ($this$s, property, $completion) {
      return i.dna($this$s, property, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_97(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_97).sna = function ($this$provideImportScope, property, $completion) {
    var tmp = this.tna($this$provideImportScope, property, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_97).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.sna(tmp, (!(p2 == null) ? isInterface(p2, PropertyDeclaration_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_97).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 6;
            var tmp0_safe_receiver = this.nna_1.l60(this.ona_1.sfq());
            if (tmp0_safe_receiver == null) {
              this.rna_1 = null;
              this.f9_1 = 2;
              continue $sm;
            } else {
              this.f9_1 = 1;
              suspendResult = this.nna_1.k60(tmp0_safe_receiver.mfq(), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            this.rna_1 = suspendResult;
            this.f9_1 = 2;
            continue $sm;
          case 2:
            var tmp1_safe_receiver = this.rna_1;
            if (tmp1_safe_receiver == null) {
              this.pna_1 = null;
              this.f9_1 = 5;
              continue $sm;
            } else {
              var tmp0_safe_receiver_0 = isInterface(tmp1_safe_receiver, ComplexNotion_1) ? tmp1_safe_receiver : null;
              if (tmp0_safe_receiver_0 == null) {
                this.qna_1 = null;
                this.f9_1 = 4;
                continue $sm;
              } else {
                this.f9_1 = 3;
                suspendResult = this.nna_1.v77(listOf(tmp0_safe_receiver_0), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              }
            }

          case 3:
            this.qna_1 = suspendResult;
            this.f9_1 = 4;
            continue $sm;
          case 4:
            this.pna_1 = this.qna_1;
            this.f9_1 = 5;
            continue $sm;
          case 5:
            var tmp2_elvis_lhs = this.pna_1;
            return tmp2_elvis_lhs == null ? Scopes_getInstance().u7b() : tmp2_elvis_lhs;
          case 6:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 6) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_97).tna = function ($this$provideImportScope, property, completion) {
    var i = new btbScopes$lambda$slambda_97(completion);
    i.nna_1 = $this$provideImportScope;
    i.ona_1 = property;
    return i;
  };
  function btbScopes$lambda$slambda_98(resultContinuation) {
    var i = new btbScopes$lambda$slambda_97(resultContinuation);
    var l = function ($this$provideImportScope, property, $completion) {
      return i.sna($this$provideImportScope, property, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_99(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_99).hnb = function ($this$provideImportScope, relation, $completion) {
    var tmp = this.inb($this$provideImportScope, relation, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_99).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.hnb(tmp, (!(p2 == null) ? isInterface(p2, InstanceRelationDeclaration) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_99).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 6;
            var tmp_0 = this.cnb_1.l60(this.dnb_1.hd());
            var tmp0_safe_receiver = (!(tmp_0 == null) ? isInterface(tmp_0, NotionType_0) : false) ? tmp_0 : null;
            if (tmp0_safe_receiver == null) {
              this.gnb_1 = null;
              this.f9_1 = 2;
              continue $sm;
            } else {
              this.f9_1 = 1;
              suspendResult = this.cnb_1.k60(tmp0_safe_receiver.mfq(), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            this.gnb_1 = suspendResult;
            this.f9_1 = 2;
            continue $sm;
          case 2:
            var tmp1_safe_receiver = this.gnb_1;
            if (tmp1_safe_receiver == null) {
              this.enb_1 = null;
              this.f9_1 = 5;
              continue $sm;
            } else {
              var tmp0_safe_receiver_0 = isInterface(tmp1_safe_receiver, ComplexNotion_1) ? tmp1_safe_receiver : null;
              if (tmp0_safe_receiver_0 == null) {
                this.fnb_1 = null;
                this.f9_1 = 4;
                continue $sm;
              } else {
                this.f9_1 = 3;
                suspendResult = this.cnb_1.v77(listOf(tmp0_safe_receiver_0), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              }
            }

          case 3:
            this.fnb_1 = suspendResult;
            this.f9_1 = 4;
            continue $sm;
          case 4:
            this.enb_1 = this.fnb_1;
            this.f9_1 = 5;
            continue $sm;
          case 5:
            var tmp2_elvis_lhs = this.enb_1;
            return tmp2_elvis_lhs == null ? Scopes_getInstance().u7b() : tmp2_elvis_lhs;
          case 6:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 6) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_99).inb = function ($this$provideImportScope, relation, completion) {
    var i = new btbScopes$lambda$slambda_99(completion);
    i.cnb_1 = $this$provideImportScope;
    i.dnb_1 = relation;
    return i;
  };
  function btbScopes$lambda$slambda_100(resultContinuation) {
    var i = new btbScopes$lambda$slambda_99(resultContinuation);
    var l = function ($this$provideImportScope, relation, $completion) {
      return i.hnb($this$provideImportScope, relation, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_101(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_101).xnb = function ($this$provideImportScope, property, $completion) {
    var tmp = this.ynb($this$provideImportScope, property, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_101).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.xnb(tmp, (!(p2 == null) ? isInterface(p2, ObjectPropertyDeclaration_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_101).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 7;
            var tmp0_safe_receiver = this.rnb_1.l60(this.snb_1.hd());
            var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : this.rnb_1.l60(tmp0_safe_receiver.cfs());
            var tmp_0;
            if (tmp1_safe_receiver == null) {
              tmp_0 = null;
            } else {
              var destination = ArrayList_init_$Create$();
              var _iterator__ex2g4s = tmp1_safe_receiver.m();
              while (_iterator__ex2g4s.n()) {
                var element = _iterator__ex2g4s.o();
                if (!(element == null) ? isInterface(element, NotionType_0) : false) {
                  destination.j(element);
                }
              }
              tmp_0 = destination;
            }

            var tmp2_safe_receiver = tmp_0;
            if (tmp2_safe_receiver == null) {
              this.unb_1 = null;
              this.f9_1 = 4;
              continue $sm;
            } else {
              this.vnb_1 = ArrayList_init_$Create$();
              this.wnb_1 = tmp2_safe_receiver.m();
              this.f9_1 = 1;
              continue $sm;
            }

          case 1:
            if (!this.wnb_1.n()) {
              this.f9_1 = 3;
              continue $sm;
            }

            var element_0 = this.wnb_1.o();
            this.f9_1 = 2;
            suspendResult = this.rnb_1.k60(element_0.mfq(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var tmp0_safe_receiver_0 = (!(suspendResult == null) ? isInterface(suspendResult, ComplexNotion_1) : false) ? suspendResult : null;
            if (tmp0_safe_receiver_0 == null)
              null;
            else {
              this.vnb_1.j(tmp0_safe_receiver_0);
            }

            this.f9_1 = 1;
            continue $sm;
          case 3:
            this.unb_1 = this.vnb_1;
            this.f9_1 = 4;
            continue $sm;
          case 4:
            var tmp3_elvis_lhs = this.unb_1;
            var tmp_1;
            if (tmp3_elvis_lhs == null) {
              return Scopes_getInstance().u7b();
            } else {
              tmp_1 = tmp3_elvis_lhs;
            }

            var complexNotions = tmp_1;
            if (!complexNotions.s()) {
              this.f9_1 = 5;
              suspendResult = this.rnb_1.v77(complexNotions, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              var tmp_2 = this;
              tmp_2.tnb_1 = Scopes_getInstance().u7b();
              this.f9_1 = 6;
              continue $sm;
            }

          case 5:
            this.tnb_1 = suspendResult;
            this.f9_1 = 6;
            continue $sm;
          case 6:
            return this.tnb_1;
          case 7:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 7) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_101).ynb = function ($this$provideImportScope, property, completion) {
    var i = new btbScopes$lambda$slambda_101(completion);
    i.rnb_1 = $this$provideImportScope;
    i.snb_1 = property;
    return i;
  };
  function btbScopes$lambda$slambda_102(resultContinuation) {
    var i = new btbScopes$lambda$slambda_101(resultContinuation);
    var l = function ($this$provideImportScope, property, $completion) {
      return i.xnb($this$provideImportScope, property, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_103(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_103).jnc = function ($this$provideLexicalScope, it, $completion) {
    var tmp = this.knc($this$provideLexicalScope, it, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_103).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.jnc(tmp, (!(p2 == null) ? isInterface(p2, PropertyValue_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_103).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.hnc_1.w77(this.inc_1.q6q(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_103).knc = function ($this$provideLexicalScope, it, completion) {
    var i = new btbScopes$lambda$slambda_103(completion);
    i.hnc_1 = $this$provideLexicalScope;
    i.inc_1 = it;
    return i;
  };
  function btbScopes$lambda$slambda_104(resultContinuation) {
    var i = new btbScopes$lambda$slambda_103(resultContinuation);
    var l = function ($this$provideLexicalScope, it, $completion) {
      return i.jnc($this$provideLexicalScope, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_105(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_105).vnc = function ($this$provideLexicalScope, it, $completion) {
    var tmp = this.wnc($this$provideLexicalScope, it, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_105).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.vnc(tmp, (!(p2 == null) ? isInterface(p2, ProcessPropertyValue_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_105).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.tnc_1.w77(this.unc_1.q6q(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_105).wnc = function ($this$provideLexicalScope, it, completion) {
    var i = new btbScopes$lambda$slambda_105(completion);
    i.tnc_1 = $this$provideLexicalScope;
    i.unc_1 = it;
    return i;
  };
  function btbScopes$lambda$slambda_106(resultContinuation) {
    var i = new btbScopes$lambda$slambda_105(resultContinuation);
    var l = function ($this$provideLexicalScope, it, $completion) {
      return i.vnc($this$provideLexicalScope, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_107(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_107).hnd = function ($this$provideLexicalScope, it, $completion) {
    var tmp = this.ind($this$provideLexicalScope, it, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_107).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.hnd(tmp, (!(p2 == null) ? isInterface(p2, InstanceRelationValue) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_107).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.fnd_1.w77(this.gnd_1.xfq(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_107).ind = function ($this$provideLexicalScope, it, completion) {
    var i = new btbScopes$lambda$slambda_107(completion);
    i.fnd_1 = $this$provideLexicalScope;
    i.gnd_1 = it;
    return i;
  };
  function btbScopes$lambda$slambda_108(resultContinuation) {
    var i = new btbScopes$lambda$slambda_107(resultContinuation);
    var l = function ($this$provideLexicalScope, it, $completion) {
      return i.hnd($this$provideLexicalScope, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_109(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_109).tnd = function ($this$provideLexicalScope, it, $completion) {
    var tmp = this.und($this$provideLexicalScope, it, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_109).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.tnd(tmp, (!(p2 == null) ? isInterface(p2, PropertyConstraint_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_109).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.rnd_1.w77(this.snd_1.q6q(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_109).und = function ($this$provideLexicalScope, it, completion) {
    var i = new btbScopes$lambda$slambda_109(completion);
    i.rnd_1 = $this$provideLexicalScope;
    i.snd_1 = it;
    return i;
  };
  function btbScopes$lambda$slambda_110(resultContinuation) {
    var i = new btbScopes$lambda$slambda_109(resultContinuation);
    var l = function ($this$provideLexicalScope, it, $completion) {
      return i.tnd($this$provideLexicalScope, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_111(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_111).gne = function ($this$provideLexicalScope, it, $completion) {
    var tmp = this.hne($this$provideLexicalScope, it, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_111).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.gne(tmp, (!(p2 == null) ? isInterface(p2, IsExpression_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_111).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 3;
            var tmp0_safe_receiver = this.dne_1.l60(this.ene_1.mdy());
            var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : this.dne_1.l60(tmp0_safe_receiver.q6q());
            var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.q6q();
            if (tmp2_safe_receiver == null) {
              this.fne_1 = null;
              this.f9_1 = 2;
              continue $sm;
            } else {
              this.f9_1 = 1;
              suspendResult = this.dne_1.w77(tmp2_safe_receiver, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            this.fne_1 = suspendResult;
            this.f9_1 = 2;
            continue $sm;
          case 2:
            var tmp3_elvis_lhs = this.fne_1;
            return tmp3_elvis_lhs == null ? Scopes_getInstance().u7b() : tmp3_elvis_lhs;
          case 3:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 3) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_111).hne = function ($this$provideLexicalScope, it, completion) {
    var i = new btbScopes$lambda$slambda_111(completion);
    i.dne_1 = $this$provideLexicalScope;
    i.ene_1 = it;
    return i;
  };
  function btbScopes$lambda$slambda_112(resultContinuation) {
    var i = new btbScopes$lambda$slambda_111(resultContinuation);
    var l = function ($this$provideLexicalScope, it, $completion) {
      return i.gne($this$provideLexicalScope, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_113(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_113).vne = function ($this$provideCommonScope, property, $completion) {
    var tmp = this.wne($this$provideCommonScope, property, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_113).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.vne(tmp, (!(p2 == null) ? isInterface(p2, ProcessProperty_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_113).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 6;
            var tmp0_safe_receiver = this.qne_1.l60(this.rne_1.sfq());
            var tmp_0 = tmp0_safe_receiver == null ? null : this.qne_1.l60(tmp0_safe_receiver.sfq());
            var tmp1_safe_receiver = (!(tmp_0 == null) ? isInterface(tmp_0, SimplePropertyType) : false) ? tmp_0 : null;
            if (tmp1_safe_receiver == null) {
              this.une_1 = null;
              this.f9_1 = 2;
              continue $sm;
            } else {
              this.f9_1 = 1;
              suspendResult = this.qne_1.k60(tmp1_safe_receiver.mfq(), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            this.une_1 = suspendResult;
            this.f9_1 = 2;
            continue $sm;
          case 2:
            var tmp2_safe_receiver = this.une_1;
            if (tmp2_safe_receiver == null) {
              this.sne_1 = null;
              this.f9_1 = 5;
              continue $sm;
            } else {
              var tmp0_safe_receiver_0 = isInterface(tmp2_safe_receiver, ComplexNotion_1) ? tmp2_safe_receiver : null;
              if (tmp0_safe_receiver_0 == null) {
                this.tne_1 = null;
                this.f9_1 = 4;
                continue $sm;
              } else {
                this.f9_1 = 3;
                suspendResult = this.qne_1.v77(listOf(tmp0_safe_receiver_0), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              }
            }

          case 3:
            this.tne_1 = suspendResult;
            this.f9_1 = 4;
            continue $sm;
          case 4:
            this.sne_1 = this.tne_1;
            this.f9_1 = 5;
            continue $sm;
          case 5:
            var tmp3_elvis_lhs = this.sne_1;
            return tmp3_elvis_lhs == null ? Scopes_getInstance().u7b() : tmp3_elvis_lhs;
          case 6:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 6) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_113).wne = function ($this$provideCommonScope, property, completion) {
    var i = new btbScopes$lambda$slambda_113(completion);
    i.qne_1 = $this$provideCommonScope;
    i.rne_1 = property;
    return i;
  };
  function btbScopes$lambda$slambda_114(resultContinuation) {
    var i = new btbScopes$lambda$slambda_113(resultContinuation);
    var l = function ($this$provideCommonScope, property, $completion) {
      return i.vne($this$provideCommonScope, property, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_115(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_115).hnf = function ($this$provideCommonScope, it, $completion) {
    var tmp = this.inf($this$provideCommonScope, it, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_115).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.hnf(tmp, (!(p2 == null) ? isInterface(p2, ComplexNotion_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_115).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.fnf_1.u77(this.gnf_1.ifq(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_115).inf = function ($this$provideCommonScope, it, completion) {
    var i = new btbScopes$lambda$slambda_115(completion);
    i.fnf_1 = $this$provideCommonScope;
    i.gnf_1 = it;
    return i;
  };
  function btbScopes$lambda$slambda_116(resultContinuation) {
    var i = new btbScopes$lambda$slambda_115(resultContinuation);
    var l = function ($this$provideCommonScope, it, $completion) {
      return i.hnf($this$provideCommonScope, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_117(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_117).tnf = function ($this$provideLexicalScope, it, $completion) {
    var tmp = this.unf($this$provideLexicalScope, it, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_117).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.tnf(tmp, (!(p2 == null) ? isInterface(p2, ComplexNotionValue_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_117).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.rnf_1.w77(this.snf_1.mfq(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_117).unf = function ($this$provideLexicalScope, it, completion) {
    var i = new btbScopes$lambda$slambda_117(completion);
    i.rnf_1 = $this$provideLexicalScope;
    i.snf_1 = it;
    return i;
  };
  function btbScopes$lambda$slambda_118(resultContinuation) {
    var i = new btbScopes$lambda$slambda_117(resultContinuation);
    var l = function ($this$provideLexicalScope, it, $completion) {
      return i.tnf($this$provideLexicalScope, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_119(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_119).fng = function ($this$provideLexicalScope, it, $completion) {
    var tmp = this.gng($this$provideLexicalScope, it, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_119).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.fng(tmp, (!(p2 == null) ? isInterface(p2, ComplexNotionElementValue_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_119).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        if (tmp === 0) {
          this.g9_1 = 1;
          return Scopes_getInstance().u7b();
        } else if (tmp === 1) {
          throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_119).gng = function ($this$provideLexicalScope, it, completion) {
    var i = new btbScopes$lambda$slambda_119(completion);
    i.dng_1 = $this$provideLexicalScope;
    i.eng_1 = it;
    return i;
  };
  function btbScopes$lambda$slambda_120(resultContinuation) {
    var i = new btbScopes$lambda$slambda_119(resultContinuation);
    var l = function ($this$provideLexicalScope, it, $completion) {
      return i.fng($this$provideLexicalScope, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_121(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_121).tng = function ($this$provideLexicalScope, value, $completion) {
    var tmp = this.ung($this$provideLexicalScope, value, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_121).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.tng(tmp, (!(p2 == null) ? isInterface(p2, ComplexNotionElementValue_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_121).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 5;
            this.f9_1 = 1;
            suspendResult = this.png_1.k60(this.qng_1.gfq(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp0_safe_receiver = suspendResult;
            var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : this.png_1.l60(tmp0_safe_receiver.kfq());
            if (tmp1_safe_receiver == null) {
              this.rng_1 = null;
              this.f9_1 = 4;
              continue $sm;
            } else {
              var tmp0_safe_receiver_0 = isInterface(tmp1_safe_receiver, NotionType_0) ? tmp1_safe_receiver : null;
              if (tmp0_safe_receiver_0 == null) {
                this.sng_1 = null;
                this.f9_1 = 3;
                continue $sm;
              } else {
                this.f9_1 = 2;
                suspendResult = this.png_1.w77(tmp0_safe_receiver_0.mfq(), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              }
            }

          case 2:
            this.sng_1 = suspendResult;
            this.f9_1 = 3;
            continue $sm;
          case 3:
            this.rng_1 = this.sng_1;
            this.f9_1 = 4;
            continue $sm;
          case 4:
            var tmp2_elvis_lhs = this.rng_1;
            return tmp2_elvis_lhs == null ? Scopes_getInstance().u7b() : tmp2_elvis_lhs;
          case 5:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 5) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_121).ung = function ($this$provideLexicalScope, value, completion) {
    var i = new btbScopes$lambda$slambda_121(completion);
    i.png_1 = $this$provideLexicalScope;
    i.qng_1 = value;
    return i;
  };
  function btbScopes$lambda$slambda_122(resultContinuation) {
    var i = new btbScopes$lambda$slambda_121(resultContinuation);
    var l = function ($this$provideLexicalScope, value, $completion) {
      return i.tng($this$provideLexicalScope, value, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_123(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_123).hnh = function ($this$provideLexicalScope, value, $completion) {
    var tmp = this.inh($this$provideLexicalScope, value, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_123).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.hnh(tmp, (!(p2 == null) ? isInterface(p2, ComplexNotionElementValue_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_123).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 5;
            this.f9_1 = 1;
            suspendResult = this.dnh_1.k60(this.enh_1.gfq(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp0_safe_receiver = suspendResult;
            var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : this.dnh_1.l60(tmp0_safe_receiver.kfq());
            if (tmp1_safe_receiver == null) {
              this.fnh_1 = null;
              this.f9_1 = 4;
              continue $sm;
            } else {
              var tmp0_safe_receiver_0 = isInterface(tmp1_safe_receiver, NotionType_0) ? tmp1_safe_receiver : null;
              if (tmp0_safe_receiver_0 == null) {
                this.gnh_1 = null;
                this.f9_1 = 3;
                continue $sm;
              } else {
                this.f9_1 = 2;
                suspendResult = this.dnh_1.w77(tmp0_safe_receiver_0.mfq(), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              }
            }

          case 2:
            this.gnh_1 = suspendResult;
            this.f9_1 = 3;
            continue $sm;
          case 3:
            this.fnh_1 = this.gnh_1;
            this.f9_1 = 4;
            continue $sm;
          case 4:
            var tmp2_elvis_lhs = this.fnh_1;
            return tmp2_elvis_lhs == null ? Scopes_getInstance().u7b() : tmp2_elvis_lhs;
          case 5:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 5) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_123).inh = function ($this$provideLexicalScope, value, completion) {
    var i = new btbScopes$lambda$slambda_123(completion);
    i.dnh_1 = $this$provideLexicalScope;
    i.enh_1 = value;
    return i;
  };
  function btbScopes$lambda$slambda_124(resultContinuation) {
    var i = new btbScopes$lambda$slambda_123(resultContinuation);
    var l = function ($this$provideLexicalScope, value, $completion) {
      return i.hnh($this$provideLexicalScope, value, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda$slambda_15(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda$slambda_15).tnh = function ($this$query, it, $completion) {
    var tmp = this.unh($this$query, it, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda$slambda_15).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof QueryBuilder ? p1 : THROW_CCE();
    return this.tnh(tmp, (!(p2 == null) ? isInterface(p2, AbstractNotion) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda$slambda_15).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        if (tmp === 0) {
          this.g9_1 = 1;
          var tmp_0;
          var tmp_1 = this.snh_1;
          if (isInterface(tmp_1, EnumerableNotion_1)) {
            tmp_0 = true;
          } else {
            var tmp_2 = this.snh_1;
            tmp_0 = isInterface(tmp_2, MeasurableNotion_1);
          }
          return tmp_0;
        } else if (tmp === 1) {
          throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda$slambda_15).unh = function ($this$query, it, completion) {
    var i = new btbScopes$lambda$slambda$slambda_15(completion);
    i.rnh_1 = $this$query;
    i.snh_1 = it;
    return i;
  };
  function btbScopes$lambda$slambda$slambda_16(resultContinuation) {
    var i = new btbScopes$lambda$slambda$slambda_15(resultContinuation);
    var l = function ($this$query, it, $completion) {
      return i.tnh($this$query, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_125(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_125).gni = function ($this$provideLexicalScope, _unused_var__etf5q3, $completion) {
    var tmp = this.hni($this$provideLexicalScope, _unused_var__etf5q3, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_125).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.gni(tmp, (!(p2 == null) ? isInterface(p2, ComplexNotionElement_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_125).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            var tmp_0 = this;
            var tmp_1 = Companion_instance_120;
            tmp_0.fni_1 = tmp_1.f73(btbScopes$lambda$slambda$slambda_16(null));
            this.f9_1 = 1;
            suspendResult = this.dni_1.r77(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            return filter_1(ARGUMENT, this.fni_1);
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_125).hni = function ($this$provideLexicalScope, _unused_var__etf5q3, completion) {
    var i = new btbScopes$lambda$slambda_125(completion);
    i.dni_1 = $this$provideLexicalScope;
    i.eni_1 = _unused_var__etf5q3;
    return i;
  };
  function btbScopes$lambda$slambda_126(resultContinuation) {
    var i = new btbScopes$lambda$slambda_125(resultContinuation);
    var l = function ($this$provideLexicalScope, _unused_var__etf5q3, $completion) {
      return i.gni($this$provideLexicalScope, _unused_var__etf5q3, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_127($this_scopes, $objectPropertyDomainFilters$delegate, resultContinuation) {
    this.qni_1 = $this_scopes;
    this.rni_1 = $objectPropertyDomainFilters$delegate;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_127).fmx = function ($this$s, property, $completion) {
    var tmp = this.gmx($this$s, property, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_127).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.fmx(tmp, (!(p2 == null) ? isInterface(p2, ObjectPropertyDeclaration_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_127).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 3;
            this.f9_1 = 1;
            suspendResult = this.sni_1.k60(filterByPropertyRange(this.tni_1, invoke$lambda_2(this.qni_1, this.rni_1)), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp0_elvis_lhs = suspendResult;
            var tmp_0 = this;
            var tmp_1;
            if (tmp0_elvis_lhs == null) {
              return Scopes_getInstance().u7b();
            } else {
              tmp_1 = tmp0_elvis_lhs;
            }

            tmp_0.uni_1 = tmp_1;
            this.f9_1 = 2;
            suspendResult = this.sni_1.y77(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var ARGUMENT = suspendResult;
            return filter_1(ARGUMENT, this.uni_1);
          case 3:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 3) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_127).gmx = function ($this$s, property, completion) {
    var i = new btbScopes$lambda$slambda_127(this.qni_1, this.rni_1, completion);
    i.sni_1 = $this$s;
    i.tni_1 = property;
    return i;
  };
  function btbScopes$lambda$slambda_128($this_scopes, $objectPropertyDomainFilters$delegate, resultContinuation) {
    var i = new btbScopes$lambda$slambda_127($this_scopes, $objectPropertyDomainFilters$delegate, resultContinuation);
    var l = function ($this$s, property, $completion) {
      return i.fmx($this$s, property, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_129(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_129).fnj = function ($this$provideLexicalScope, propertyValue, $completion) {
    var tmp = this.gnj($this$provideLexicalScope, propertyValue, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_129).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.fnj(tmp, (!(p2 == null) ? isInterface(p2, ProcessPropertyValue_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_129).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.dnj_1.w77(this.enj_1.q6q(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_129).gnj = function ($this$provideLexicalScope, propertyValue, completion) {
    var i = new btbScopes$lambda$slambda_129(completion);
    i.dnj_1 = $this$provideLexicalScope;
    i.enj_1 = propertyValue;
    return i;
  };
  function btbScopes$lambda$slambda_130(resultContinuation) {
    var i = new btbScopes$lambda$slambda_129(resultContinuation);
    var l = function ($this$provideLexicalScope, propertyValue, $completion) {
      return i.fnj($this$provideLexicalScope, propertyValue, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_131(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_131).rnj = function ($this$provideLexicalScope, propertyValue, $completion) {
    var tmp = this.snj($this$provideLexicalScope, propertyValue, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_131).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.rnj(tmp, (!(p2 == null) ? isInterface(p2, PropertyValue_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_131).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.pnj_1.w77(this.qnj_1.q6q(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_131).snj = function ($this$provideLexicalScope, propertyValue, completion) {
    var i = new btbScopes$lambda$slambda_131(completion);
    i.pnj_1 = $this$provideLexicalScope;
    i.qnj_1 = propertyValue;
    return i;
  };
  function btbScopes$lambda$slambda_132(resultContinuation) {
    var i = new btbScopes$lambda$slambda_131(resultContinuation);
    var l = function ($this$provideLexicalScope, propertyValue, $completion) {
      return i.rnj($this$provideLexicalScope, propertyValue, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_133(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_133).dnk = function ($this$provideLexicalScope, value, $completion) {
    var tmp = this.enk($this$provideLexicalScope, value, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_133).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.dnk(tmp, (!(p2 == null) ? isInterface(p2, InstanceRelationValue) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_133).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.bnk_1.w77(this.cnk_1.xfq(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_133).enk = function ($this$provideLexicalScope, value, completion) {
    var i = new btbScopes$lambda$slambda_133(completion);
    i.bnk_1 = $this$provideLexicalScope;
    i.cnk_1 = value;
    return i;
  };
  function btbScopes$lambda$slambda_134(resultContinuation) {
    var i = new btbScopes$lambda$slambda_133(resultContinuation);
    var l = function ($this$provideLexicalScope, value, $completion) {
      return i.dnk($this$provideLexicalScope, value, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_135(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_135).pnk = function ($this$s, constraint, $completion) {
    var tmp = this.qnk($this$s, constraint, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_135).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.pnk(tmp, (!(p2 == null) ? isInterface(p2, PropertyConstraint_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_135).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.nnk_1.w77(this.onk_1.q6q(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_135).qnk = function ($this$s, constraint, completion) {
    var i = new btbScopes$lambda$slambda_135(completion);
    i.nnk_1 = $this$s;
    i.onk_1 = constraint;
    return i;
  };
  function btbScopes$lambda$slambda_136(resultContinuation) {
    var i = new btbScopes$lambda$slambda_135(resultContinuation);
    var l = function ($this$s, constraint, $completion) {
      return i.pnk($this$s, constraint, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_137(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_137).bnl = function ($this$s, expression, $completion) {
    var tmp = this.cnl($this$s, expression, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_137).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.bnl(tmp, (!(p2 == null) ? isInterface(p2, IsExpression_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_137).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            var tmp0_safe_receiver = this.znk_1.l60(this.anl_1.mdy());
            var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : this.znk_1.l60(tmp0_safe_receiver.q6q());
            var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.q6q();
            var tmp_0;
            if (tmp2_elvis_lhs == null) {
              return Scopes_getInstance().u7b();
            } else {
              tmp_0 = tmp2_elvis_lhs;
            }

            var propertyRef = tmp_0;
            this.f9_1 = 1;
            suspendResult = this.znk_1.w77(propertyRef, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_137).cnl = function ($this$s, expression, completion) {
    var i = new btbScopes$lambda$slambda_137(completion);
    i.znk_1 = $this$s;
    i.anl_1 = expression;
    return i;
  };
  function btbScopes$lambda$slambda_138(resultContinuation) {
    var i = new btbScopes$lambda$slambda_137(resultContinuation);
    var l = function ($this$s, expression, $completion) {
      return i.bnl($this$s, expression, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_139(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_139).nnl = function ($this$provideLexicalScope, propertyValue, $completion) {
    var tmp = this.onl($this$provideLexicalScope, propertyValue, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_139).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.nnl(tmp, (!(p2 == null) ? isInterface(p2, PropertyDeclarationValueQuery_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_139).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.lnl_1.w77(this.mnl_1.cfu(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_139).onl = function ($this$provideLexicalScope, propertyValue, completion) {
    var i = new btbScopes$lambda$slambda_139(completion);
    i.lnl_1 = $this$provideLexicalScope;
    i.mnl_1 = propertyValue;
    return i;
  };
  function btbScopes$lambda$slambda_140(resultContinuation) {
    var i = new btbScopes$lambda$slambda_139(resultContinuation);
    var l = function ($this$provideLexicalScope, propertyValue, $completion) {
      return i.nnl($this$provideLexicalScope, propertyValue, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_141(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_141).znl = function ($this$provideLexicalScope, propertyValue, $completion) {
    var tmp = this.anm($this$provideLexicalScope, propertyValue, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_141).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.znl(tmp, (!(p2 == null) ? isInterface(p2, PropertyValue_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_141).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.xnl_1.w77(this.ynl_1.q6q(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_141).anm = function ($this$provideLexicalScope, propertyValue, completion) {
    var i = new btbScopes$lambda$slambda_141(completion);
    i.xnl_1 = $this$provideLexicalScope;
    i.ynl_1 = propertyValue;
    return i;
  };
  function btbScopes$lambda$slambda_142(resultContinuation) {
    var i = new btbScopes$lambda$slambda_141(resultContinuation);
    var l = function ($this$provideLexicalScope, propertyValue, $completion) {
      return i.znl($this$provideLexicalScope, propertyValue, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_143(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_143).lnm = function ($this$provideLexicalScope, propertyValue, $completion) {
    var tmp = this.mnm($this$provideLexicalScope, propertyValue, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_143).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.lnm(tmp, (!(p2 == null) ? isInterface(p2, ProcessPropertyValue_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_143).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.jnm_1.w77(this.knm_1.q6q(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_143).mnm = function ($this$provideLexicalScope, propertyValue, completion) {
    var i = new btbScopes$lambda$slambda_143(completion);
    i.jnm_1 = $this$provideLexicalScope;
    i.knm_1 = propertyValue;
    return i;
  };
  function btbScopes$lambda$slambda_144(resultContinuation) {
    var i = new btbScopes$lambda$slambda_143(resultContinuation);
    var l = function ($this$provideLexicalScope, propertyValue, $completion) {
      return i.lnm($this$provideLexicalScope, propertyValue, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_145(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_145).xnm = function ($this$provideLexicalScope, value, $completion) {
    var tmp = this.ynm($this$provideLexicalScope, value, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_145).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.xnm(tmp, (!(p2 == null) ? isInterface(p2, InstanceRelationValue) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_145).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.vnm_1.w77(this.wnm_1.xfq(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_145).ynm = function ($this$provideLexicalScope, value, completion) {
    var i = new btbScopes$lambda$slambda_145(completion);
    i.vnm_1 = $this$provideLexicalScope;
    i.wnm_1 = value;
    return i;
  };
  function btbScopes$lambda$slambda_146(resultContinuation) {
    var i = new btbScopes$lambda$slambda_145(resultContinuation);
    var l = function ($this$provideLexicalScope, value, $completion) {
      return i.xnm($this$provideLexicalScope, value, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_147(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_147).jnn = function ($this$provideLexicalScope, constraint, $completion) {
    var tmp = this.knn($this$provideLexicalScope, constraint, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_147).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.jnn(tmp, (!(p2 == null) ? isInterface(p2, PropertyConstraint_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_147).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.hnn_1.w77(this.inn_1.q6q(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_147).knn = function ($this$provideLexicalScope, constraint, completion) {
    var i = new btbScopes$lambda$slambda_147(completion);
    i.hnn_1 = $this$provideLexicalScope;
    i.inn_1 = constraint;
    return i;
  };
  function btbScopes$lambda$slambda_148(resultContinuation) {
    var i = new btbScopes$lambda$slambda_147(resultContinuation);
    var l = function ($this$provideLexicalScope, constraint, $completion) {
      return i.jnn($this$provideLexicalScope, constraint, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_149(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_149).vnn = function ($this$s, expression, $completion) {
    var tmp = this.wnn($this$s, expression, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_149).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.vnn(tmp, (!(p2 == null) ? isInterface(p2, IsExpression_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_149).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            var tmp0_safe_receiver = this.tnn_1.l60(this.unn_1.mdy());
            var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : this.tnn_1.l60(tmp0_safe_receiver.q6q());
            var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.q6q();
            var tmp_0;
            if (tmp2_elvis_lhs == null) {
              return Scopes_getInstance().u7b();
            } else {
              tmp_0 = tmp2_elvis_lhs;
            }

            var propertyRef = tmp_0;
            this.f9_1 = 1;
            suspendResult = this.tnn_1.w77(propertyRef, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_149).wnn = function ($this$s, expression, completion) {
    var i = new btbScopes$lambda$slambda_149(completion);
    i.tnn_1 = $this$s;
    i.unn_1 = expression;
    return i;
  };
  function btbScopes$lambda$slambda_150(resultContinuation) {
    var i = new btbScopes$lambda$slambda_149(resultContinuation);
    var l = function ($this$s, expression, $completion) {
      return i.vnn($this$s, expression, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_151(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_151).hno = function ($this$provideLexicalScope, _unused_var__etf5q3, $completion) {
    var tmp = this.ino($this$provideLexicalScope, _unused_var__etf5q3, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_151).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.hno(tmp, (!(p2 == null) ? isInterface(p2, ProcessPropertyValue_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_151).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        if (tmp === 0) {
          this.g9_1 = 1;
          return Scopes_getInstance().u7b();
        } else if (tmp === 1) {
          throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_151).ino = function ($this$provideLexicalScope, _unused_var__etf5q3, completion) {
    var i = new btbScopes$lambda$slambda_151(completion);
    i.fno_1 = $this$provideLexicalScope;
    i.gno_1 = _unused_var__etf5q3;
    return i;
  };
  function btbScopes$lambda$slambda_152(resultContinuation) {
    var i = new btbScopes$lambda$slambda_151(resultContinuation);
    var l = function ($this$provideLexicalScope, _unused_var__etf5q3, $completion) {
      return i.hno($this$provideLexicalScope, _unused_var__etf5q3, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_153(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_153).tno = function ($this$provideLexicalScope, _unused_var__etf5q3, $completion) {
    var tmp = this.uno($this$provideLexicalScope, _unused_var__etf5q3, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_153).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.tno(tmp, (!(p2 == null) ? isInterface(p2, ProcessPropertyValue_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_153).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        if (tmp === 0) {
          this.g9_1 = 1;
          return Scopes_getInstance().u7b();
        } else if (tmp === 1) {
          throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_153).uno = function ($this$provideLexicalScope, _unused_var__etf5q3, completion) {
    var i = new btbScopes$lambda$slambda_153(completion);
    i.rno_1 = $this$provideLexicalScope;
    i.sno_1 = _unused_var__etf5q3;
    return i;
  };
  function btbScopes$lambda$slambda_154(resultContinuation) {
    var i = new btbScopes$lambda$slambda_153(resultContinuation);
    var l = function ($this$provideLexicalScope, _unused_var__etf5q3, $completion) {
      return i.tno($this$provideLexicalScope, _unused_var__etf5q3, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_155(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_155).fnp = function ($this$provideLexicalScope, _unused_var__etf5q3, $completion) {
    var tmp = this.gnp($this$provideLexicalScope, _unused_var__etf5q3, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_155).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.fnp(tmp, (!(p2 == null) ? isInterface(p2, ProcessPropertyValue_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_155).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        if (tmp === 0) {
          this.g9_1 = 1;
          return Scopes_getInstance().u7b();
        } else if (tmp === 1) {
          throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_155).gnp = function ($this$provideLexicalScope, _unused_var__etf5q3, completion) {
    var i = new btbScopes$lambda$slambda_155(completion);
    i.dnp_1 = $this$provideLexicalScope;
    i.enp_1 = _unused_var__etf5q3;
    return i;
  };
  function btbScopes$lambda$slambda_156(resultContinuation) {
    var i = new btbScopes$lambda$slambda_155(resultContinuation);
    var l = function ($this$provideLexicalScope, _unused_var__etf5q3, $completion) {
      return i.fnp($this$provideLexicalScope, _unused_var__etf5q3, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function ProcessPropertyValue$_get_value_$ref_tp5tnc_1() {
    return function (p0) {
      return p0.a1();
    };
  }
  function btbScopes$lambda$slambda_157(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_157).rnp = function ($this$provideLexicalScope, it, $completion) {
    var tmp = this.snp($this$provideLexicalScope, it, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_157).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.rnp(tmp, (!(p2 == null) ? isInterface(p2, ProcessPropertyValue_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_157).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        if (tmp === 0) {
          this.g9_1 = 1;
          return Scopes_getInstance().u7b();
        } else if (tmp === 1) {
          throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_157).snp = function ($this$provideLexicalScope, it, completion) {
    var i = new btbScopes$lambda$slambda_157(completion);
    i.pnp_1 = $this$provideLexicalScope;
    i.qnp_1 = it;
    return i;
  };
  function btbScopes$lambda$slambda_158(resultContinuation) {
    var i = new btbScopes$lambda$slambda_157(resultContinuation);
    var l = function ($this$provideLexicalScope, it, $completion) {
      return i.rnp($this$provideLexicalScope, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_159(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_159).dnq = function ($this$provideLexicalScope, _unused_var__etf5q3, $completion) {
    var tmp = this.enq($this$provideLexicalScope, _unused_var__etf5q3, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_159).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.dnq(tmp, (!(p2 == null) ? isInterface(p2, PropertyConstraint_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_159).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        if (tmp === 0) {
          this.g9_1 = 1;
          return Scopes_getInstance().u7b();
        } else if (tmp === 1) {
          throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_159).enq = function ($this$provideLexicalScope, _unused_var__etf5q3, completion) {
    var i = new btbScopes$lambda$slambda_159(completion);
    i.bnq_1 = $this$provideLexicalScope;
    i.cnq_1 = _unused_var__etf5q3;
    return i;
  };
  function btbScopes$lambda$slambda_160(resultContinuation) {
    var i = new btbScopes$lambda$slambda_159(resultContinuation);
    var l = function ($this$provideLexicalScope, _unused_var__etf5q3, $completion) {
      return i.dnq($this$provideLexicalScope, _unused_var__etf5q3, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_161(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_161).pnq = function ($this$provideLexicalScope, _unused_var__etf5q3, $completion) {
    var tmp = this.qnq($this$provideLexicalScope, _unused_var__etf5q3, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_161).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.pnq(tmp, (!(p2 == null) ? isInterface(p2, PropertyConstraint_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_161).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        if (tmp === 0) {
          this.g9_1 = 1;
          return Scopes_getInstance().u7b();
        } else if (tmp === 1) {
          throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_161).qnq = function ($this$provideLexicalScope, _unused_var__etf5q3, completion) {
    var i = new btbScopes$lambda$slambda_161(completion);
    i.nnq_1 = $this$provideLexicalScope;
    i.onq_1 = _unused_var__etf5q3;
    return i;
  };
  function btbScopes$lambda$slambda_162(resultContinuation) {
    var i = new btbScopes$lambda$slambda_161(resultContinuation);
    var l = function ($this$provideLexicalScope, _unused_var__etf5q3, $completion) {
      return i.pnq($this$provideLexicalScope, _unused_var__etf5q3, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_163(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_163).bnr = function ($this$provideLexicalScope, _unused_var__etf5q3, $completion) {
    var tmp = this.cnr($this$provideLexicalScope, _unused_var__etf5q3, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_163).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.bnr(tmp, (!(p2 == null) ? isInterface(p2, PropertyConstraint_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_163).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        if (tmp === 0) {
          this.g9_1 = 1;
          return Scopes_getInstance().u7b();
        } else if (tmp === 1) {
          throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_163).cnr = function ($this$provideLexicalScope, _unused_var__etf5q3, completion) {
    var i = new btbScopes$lambda$slambda_163(completion);
    i.znq_1 = $this$provideLexicalScope;
    i.anr_1 = _unused_var__etf5q3;
    return i;
  };
  function btbScopes$lambda$slambda_164(resultContinuation) {
    var i = new btbScopes$lambda$slambda_163(resultContinuation);
    var l = function ($this$provideLexicalScope, _unused_var__etf5q3, $completion) {
      return i.bnr($this$provideLexicalScope, _unused_var__etf5q3, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_165(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_165).nnr = function ($this$provideLexicalScope, _unused_var__etf5q3, $completion) {
    var tmp = this.onr($this$provideLexicalScope, _unused_var__etf5q3, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_165).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.nnr(tmp, (!(p2 == null) ? isInterface(p2, IsExpression_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_165).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        if (tmp === 0) {
          this.g9_1 = 1;
          return Scopes_getInstance().u7b();
        } else if (tmp === 1) {
          throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_165).onr = function ($this$provideLexicalScope, _unused_var__etf5q3, completion) {
    var i = new btbScopes$lambda$slambda_165(completion);
    i.lnr_1 = $this$provideLexicalScope;
    i.mnr_1 = _unused_var__etf5q3;
    return i;
  };
  function btbScopes$lambda$slambda_166(resultContinuation) {
    var i = new btbScopes$lambda$slambda_165(resultContinuation);
    var l = function ($this$provideLexicalScope, _unused_var__etf5q3, $completion) {
      return i.nnr($this$provideLexicalScope, _unused_var__etf5q3, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_167(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_167).znr = function ($this$provideLexicalScope, _unused_var__etf5q3, $completion) {
    var tmp = this.ans($this$provideLexicalScope, _unused_var__etf5q3, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_167).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.znr(tmp, (!(p2 == null) ? isInterface(p2, IsExpression_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_167).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        if (tmp === 0) {
          this.g9_1 = 1;
          return Scopes_getInstance().u7b();
        } else if (tmp === 1) {
          throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_167).ans = function ($this$provideLexicalScope, _unused_var__etf5q3, completion) {
    var i = new btbScopes$lambda$slambda_167(completion);
    i.xnr_1 = $this$provideLexicalScope;
    i.ynr_1 = _unused_var__etf5q3;
    return i;
  };
  function btbScopes$lambda$slambda_168(resultContinuation) {
    var i = new btbScopes$lambda$slambda_167(resultContinuation);
    var l = function ($this$provideLexicalScope, _unused_var__etf5q3, $completion) {
      return i.znr($this$provideLexicalScope, _unused_var__etf5q3, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_169(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_169).lns = function ($this$provideLexicalScope, _unused_var__etf5q3, $completion) {
    var tmp = this.mns($this$provideLexicalScope, _unused_var__etf5q3, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_169).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.lns(tmp, (!(p2 == null) ? isInterface(p2, IsExpression_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_169).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        if (tmp === 0) {
          this.g9_1 = 1;
          return Scopes_getInstance().u7b();
        } else if (tmp === 1) {
          throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_169).mns = function ($this$provideLexicalScope, _unused_var__etf5q3, completion) {
    var i = new btbScopes$lambda$slambda_169(completion);
    i.jns_1 = $this$provideLexicalScope;
    i.kns_1 = _unused_var__etf5q3;
    return i;
  };
  function btbScopes$lambda$slambda_170(resultContinuation) {
    var i = new btbScopes$lambda$slambda_169(resultContinuation);
    var l = function ($this$provideLexicalScope, _unused_var__etf5q3, $completion) {
      return i.lns($this$provideLexicalScope, _unused_var__etf5q3, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_171(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_171).xns = function ($this$provideLexicalScope, _unused_var__etf5q3, $completion) {
    var tmp = this.yns($this$provideLexicalScope, _unused_var__etf5q3, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_171).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.xns(tmp, (!(p2 == null) ? isInterface(p2, OneOf_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_171).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        if (tmp === 0) {
          this.g9_1 = 1;
          return Scopes_getInstance().u7b();
        } else if (tmp === 1) {
          throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_171).yns = function ($this$provideLexicalScope, _unused_var__etf5q3, completion) {
    var i = new btbScopes$lambda$slambda_171(completion);
    i.vns_1 = $this$provideLexicalScope;
    i.wns_1 = _unused_var__etf5q3;
    return i;
  };
  function btbScopes$lambda$slambda_172(resultContinuation) {
    var i = new btbScopes$lambda$slambda_171(resultContinuation);
    var l = function ($this$provideLexicalScope, _unused_var__etf5q3, $completion) {
      return i.xns($this$provideLexicalScope, _unused_var__etf5q3, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_173(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_173).jnt = function ($this$provideLexicalScope, _unused_var__etf5q3, $completion) {
    var tmp = this.knt($this$provideLexicalScope, _unused_var__etf5q3, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_173).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.jnt(tmp, (!(p2 == null) ? isInterface(p2, OneOf_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_173).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        if (tmp === 0) {
          this.g9_1 = 1;
          return Scopes_getInstance().u7b();
        } else if (tmp === 1) {
          throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_173).knt = function ($this$provideLexicalScope, _unused_var__etf5q3, completion) {
    var i = new btbScopes$lambda$slambda_173(completion);
    i.hnt_1 = $this$provideLexicalScope;
    i.int_1 = _unused_var__etf5q3;
    return i;
  };
  function btbScopes$lambda$slambda_174(resultContinuation) {
    var i = new btbScopes$lambda$slambda_173(resultContinuation);
    var l = function ($this$provideLexicalScope, _unused_var__etf5q3, $completion) {
      return i.jnt($this$provideLexicalScope, _unused_var__etf5q3, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_175(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_175).vnt = function ($this$provideLexicalScope, _unused_var__etf5q3, $completion) {
    var tmp = this.wnt($this$provideLexicalScope, _unused_var__etf5q3, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_175).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.vnt(tmp, (!(p2 == null) ? isInterface(p2, OneOf_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_175).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        if (tmp === 0) {
          this.g9_1 = 1;
          return Scopes_getInstance().u7b();
        } else if (tmp === 1) {
          throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_175).wnt = function ($this$provideLexicalScope, _unused_var__etf5q3, completion) {
    var i = new btbScopes$lambda$slambda_175(completion);
    i.tnt_1 = $this$provideLexicalScope;
    i.unt_1 = _unused_var__etf5q3;
    return i;
  };
  function btbScopes$lambda$slambda_176(resultContinuation) {
    var i = new btbScopes$lambda$slambda_175(resultContinuation);
    var l = function ($this$provideLexicalScope, _unused_var__etf5q3, $completion) {
      return i.vnt($this$provideLexicalScope, _unused_var__etf5q3, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_177(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_177).hnu = function ($this$provideLexicalScope, _unused_var__etf5q3, $completion) {
    var tmp = this.inu($this$provideLexicalScope, _unused_var__etf5q3, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_177).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.hnu(tmp, (!(p2 == null) ? isInterface(p2, OneOf_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_177).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        if (tmp === 0) {
          this.g9_1 = 1;
          return Scopes_getInstance().u7b();
        } else if (tmp === 1) {
          throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_177).inu = function ($this$provideLexicalScope, _unused_var__etf5q3, completion) {
    var i = new btbScopes$lambda$slambda_177(completion);
    i.fnu_1 = $this$provideLexicalScope;
    i.gnu_1 = _unused_var__etf5q3;
    return i;
  };
  function btbScopes$lambda$slambda_178(resultContinuation) {
    var i = new btbScopes$lambda$slambda_177(resultContinuation);
    var l = function ($this$provideLexicalScope, _unused_var__etf5q3, $completion) {
      return i.hnu($this$provideLexicalScope, _unused_var__etf5q3, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_179(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_179).tnu = function ($this$provideLexicalScope, _unused_var__etf5q3, $completion) {
    var tmp = this.unu($this$provideLexicalScope, _unused_var__etf5q3, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_179).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.tnu(tmp, (!(p2 == null) ? isInterface(p2, OneOf_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_179).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        if (tmp === 0) {
          this.g9_1 = 1;
          return Scopes_getInstance().u7b();
        } else if (tmp === 1) {
          throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_179).unu = function ($this$provideLexicalScope, _unused_var__etf5q3, completion) {
    var i = new btbScopes$lambda$slambda_179(completion);
    i.rnu_1 = $this$provideLexicalScope;
    i.snu_1 = _unused_var__etf5q3;
    return i;
  };
  function btbScopes$lambda$slambda_180(resultContinuation) {
    var i = new btbScopes$lambda$slambda_179(resultContinuation);
    var l = function ($this$provideLexicalScope, _unused_var__etf5q3, $completion) {
      return i.tnu($this$provideLexicalScope, _unused_var__etf5q3, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_181(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_181).fnv = function ($this$provideLexicalScope, propertyValue, $completion) {
    var tmp = this.gnv($this$provideLexicalScope, propertyValue, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_181).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.fnv(tmp, (!(p2 == null) ? isInterface(p2, PropertyDeclarationValueQuery_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_181).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.dnv_1.w77(this.env_1.cfu(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_181).gnv = function ($this$provideLexicalScope, propertyValue, completion) {
    var i = new btbScopes$lambda$slambda_181(completion);
    i.dnv_1 = $this$provideLexicalScope;
    i.env_1 = propertyValue;
    return i;
  };
  function btbScopes$lambda$slambda_182(resultContinuation) {
    var i = new btbScopes$lambda$slambda_181(resultContinuation);
    var l = function ($this$provideLexicalScope, propertyValue, $completion) {
      return i.fnv($this$provideLexicalScope, propertyValue, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_183(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_183).fnv = function ($this$provideLexicalScope, propertyValue, $completion) {
    var tmp = this.gnv($this$provideLexicalScope, propertyValue, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_183).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.fnv(tmp, (!(p2 == null) ? isInterface(p2, PropertyDeclarationValueQuery_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_183).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.pnv_1.w77(this.qnv_1.cfu(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_183).gnv = function ($this$provideLexicalScope, propertyValue, completion) {
    var i = new btbScopes$lambda$slambda_183(completion);
    i.pnv_1 = $this$provideLexicalScope;
    i.qnv_1 = propertyValue;
    return i;
  };
  function btbScopes$lambda$slambda_184(resultContinuation) {
    var i = new btbScopes$lambda$slambda_183(resultContinuation);
    var l = function ($this$provideLexicalScope, propertyValue, $completion) {
      return i.fnv($this$provideLexicalScope, propertyValue, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_185($this_scopes, $objectPropertyDomainFilters$delegate, $nonGroupingFilters$delegate, resultContinuation) {
    this.znv_1 = $this_scopes;
    this.anw_1 = $objectPropertyDomainFilters$delegate;
    this.bnw_1 = $nonGroupingFilters$delegate;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_185).hnw = function ($this$s, refValue, $completion) {
    var tmp = this.inw($this$s, refValue, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_185).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.hnw(tmp, (!(p2 == null) ? isInterface(p2, ObjectPropertyReferenceValue_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_185).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 7;
            var tmp0_elvis_lhs = this.cnw_1.l60(this.dnw_1.jfs());
            if (tmp0_elvis_lhs == null) {
              this.f9_1 = 1;
              suspendResult = this.cnw_1.y77(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.gnw_1 = tmp0_elvis_lhs;
              this.f9_1 = 2;
              continue $sm;
            }

          case 1:
            var tmp_0 = this;
            return suspendResult;
          case 2:
            var value = this.gnw_1;
            this.f9_1 = 3;
            suspendResult = this.cnw_1.k60(filterByValueType(value, invoke$lambda_2(this.znv_1, this.anw_1)), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            var tmp1_elvis_lhs = suspendResult;
            if (tmp1_elvis_lhs == null) {
              this.f9_1 = 4;
              suspendResult = this.cnw_1.y77(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.fnw_1 = tmp1_elvis_lhs;
              this.f9_1 = 5;
              continue $sm;
            }

          case 4:
            var tmp_1 = this;
            return suspendResult;
          case 5:
            var typeFilter = this.fnw_1;
            this.enw_1 = new CompositeScopeFilter(listOf_0([invoke$lambda_3(this.znv_1, this.bnw_1).jnw(), typeFilter]));
            this.f9_1 = 6;
            suspendResult = this.cnw_1.y77(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 6:
            var ARGUMENT = suspendResult;
            return filter_1(ARGUMENT, this.enw_1);
          case 7:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 7) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_185).inw = function ($this$s, refValue, completion) {
    var i = new btbScopes$lambda$slambda_185(this.znv_1, this.anw_1, this.bnw_1, completion);
    i.cnw_1 = $this$s;
    i.dnw_1 = refValue;
    return i;
  };
  function btbScopes$lambda$slambda_186($this_scopes, $objectPropertyDomainFilters$delegate, $nonGroupingFilters$delegate, resultContinuation) {
    var i = new btbScopes$lambda$slambda_185($this_scopes, $objectPropertyDomainFilters$delegate, $nonGroupingFilters$delegate, resultContinuation);
    var l = function ($this$s, refValue, $completion) {
      return i.hnw($this$s, refValue, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_187($this_scopes, $objectPropertyDomainFilters$delegate, resultContinuation) {
    this.snw_1 = $this_scopes;
    this.tnw_1 = $objectPropertyDomainFilters$delegate;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_187).wnw = function ($this$s, element, $completion) {
    var tmp = this.xnw($this$s, element, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_187).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.wnw(tmp, (!(p2 == null) ? isInterface(p2, OntologyElement_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_187).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.unw_1.y77(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            return filter_1(ARGUMENT, invoke$lambda_2(this.snw_1, this.tnw_1).cml(setOf(this.vnw_1)));
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_187).xnw = function ($this$s, element, completion) {
    var i = new btbScopes$lambda$slambda_187(this.snw_1, this.tnw_1, completion);
    i.unw_1 = $this$s;
    i.vnw_1 = element;
    return i;
  };
  function btbScopes$lambda$slambda_188($this_scopes, $objectPropertyDomainFilters$delegate, resultContinuation) {
    var i = new btbScopes$lambda$slambda_187($this_scopes, $objectPropertyDomainFilters$delegate, resultContinuation);
    var l = function ($this$s, element, $completion) {
      return i.wnw($this$s, element, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda$slambda_17(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda$slambda_17).inx = function ($this$query, it, $completion) {
    var tmp = this.jnx($this$query, it, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda$slambda_17).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof QueryBuilder ? p1 : THROW_CCE();
    return this.inx(tmp, (!(p2 == null) ? isInterface(p2, VariableDeclaration_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda$slambda_17).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        if (tmp === 0) {
          this.g9_1 = 1;
          var variableType = this.gnx_1.l60(this.hnx_1.ofu());
          return !(!(variableType == null) ? isInterface(variableType, ProcessType_1) : false);
        } else if (tmp === 1) {
          throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda$slambda_17).jnx = function ($this$query, it, completion) {
    var i = new btbScopes$lambda$slambda$slambda_17(completion);
    i.gnx_1 = $this$query;
    i.hnx_1 = it;
    return i;
  };
  function btbScopes$lambda$slambda$slambda_18(resultContinuation) {
    var i = new btbScopes$lambda$slambda$slambda_17(resultContinuation);
    var l = function ($this$query, it, $completion) {
      return i.inx($this$query, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_189(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_189).unx = function ($this$constrainScope, _unused_var__etf5q3, $completion) {
    var tmp = this.vnx($this$constrainScope, _unused_var__etf5q3, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_189).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeConstraintBuilder ? p1 : THROW_CCE();
    return this.unx(tmp, (!(p2 == null) ? isInterface(p2, FactSet_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_189).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        if (tmp === 0) {
          this.g9_1 = 1;
          var tmp_0 = Companion_instance_120;
          return tmp_0.f73(btbScopes$lambda$slambda$slambda_18(null));
        } else if (tmp === 1) {
          throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_189).vnx = function ($this$constrainScope, _unused_var__etf5q3, completion) {
    var i = new btbScopes$lambda$slambda_189(completion);
    i.snx_1 = $this$constrainScope;
    i.tnx_1 = _unused_var__etf5q3;
    return i;
  };
  function btbScopes$lambda$slambda_190(resultContinuation) {
    var i = new btbScopes$lambda$slambda_189(resultContinuation);
    var l = function ($this$constrainScope, _unused_var__etf5q3, $completion) {
      return i.unx($this$constrainScope, _unused_var__etf5q3, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_191(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_191).gny = function ($this$provideLexicalScope, _unused_var__etf5q3, $completion) {
    var tmp = this.hny($this$provideLexicalScope, _unused_var__etf5q3, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_191).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.gny(tmp, (!(p2 == null) ? isInterface(p2, LibraryProcessSpecification_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_191).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 3;
            this.f9_1 = 1;
            suspendResult = this.eny_1.r77(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            this.f9_1 = 2;
            suspendResult = this.eny_1.t77(ARGUMENT, get_onlyOntologyVars(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return suspendResult;
          case 3:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 3) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_191).hny = function ($this$provideLexicalScope, _unused_var__etf5q3, completion) {
    var i = new btbScopes$lambda$slambda_191(completion);
    i.eny_1 = $this$provideLexicalScope;
    i.fny_1 = _unused_var__etf5q3;
    return i;
  };
  function btbScopes$lambda$slambda_192(resultContinuation) {
    var i = new btbScopes$lambda$slambda_191(resultContinuation);
    var l = function ($this$provideLexicalScope, _unused_var__etf5q3, $completion) {
      return i.gny($this$provideLexicalScope, _unused_var__etf5q3, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_193(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_193).sny = function ($this$provideLexicalScope, it, $completion) {
    var tmp = this.tny($this$provideLexicalScope, it, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_193).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.sny(tmp, (!(p2 == null) ? isInterface(p2, InstanceRelationValue) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_193).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        if (tmp === 0) {
          this.g9_1 = 1;
          return Scopes_getInstance().u7b();
        } else if (tmp === 1) {
          throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_193).tny = function ($this$provideLexicalScope, it, completion) {
    var i = new btbScopes$lambda$slambda_193(completion);
    i.qny_1 = $this$provideLexicalScope;
    i.rny_1 = it;
    return i;
  };
  function btbScopes$lambda$slambda_194(resultContinuation) {
    var i = new btbScopes$lambda$slambda_193(resultContinuation);
    var l = function ($this$provideLexicalScope, it, $completion) {
      return i.sny($this$provideLexicalScope, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda$slambda_19($typeElements, resultContinuation) {
    this.cnz_1 = $typeElements;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda$slambda_19).inx = function ($this$query, it, $completion) {
    var tmp = this.jnx($this$query, it, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda$slambda_19).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof QueryBuilder ? p1 : THROW_CCE();
    return this.inx(tmp, (!(p2 == null) ? isInterface(p2, VariableDeclaration_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda$slambda_19).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 4;
            if (this.cnz_1 == null) {
              return false;
            }

            var variableType = this.dnz_1.l60(this.enz_1.ofu());
            this.f9_1 = 1;
            suspendResult = this.dnz_1.k60(typeElements(variableType), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var variableTypeElements = suspendResult;
            if (!(variableTypeElements == null)) {
              this.f9_1 = 2;
              suspendResult = this.dnz_1.k60(isSubtypeOf_0(ontologyElementHierarchy(), variableTypeElements, this.cnz_1), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.fnz_1 = false;
              this.f9_1 = 3;
              continue $sm;
            }

          case 2:
            this.fnz_1 = suspendResult;
            this.f9_1 = 3;
            continue $sm;
          case 3:
            return this.fnz_1;
          case 4:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 4) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda$slambda_19).jnx = function ($this$query, it, completion) {
    var i = new btbScopes$lambda$slambda$slambda_19(this.cnz_1, completion);
    i.dnz_1 = $this$query;
    i.enz_1 = it;
    return i;
  };
  function btbScopes$lambda$slambda$slambda_20($typeElements, resultContinuation) {
    var i = new btbScopes$lambda$slambda$slambda_19($typeElements, resultContinuation);
    var l = function ($this$query, it, $completion) {
      return i.inx($this$query, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda$slambda_21($typeNotion, resultContinuation) {
    this.onz_1 = $typeNotion;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda$slambda_21).inx = function ($this$query, it, $completion) {
    var tmp = this.jnx($this$query, it, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda$slambda_21).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof QueryBuilder ? p1 : THROW_CCE();
    return this.inx(tmp, (!(p2 == null) ? isInterface(p2, VariableDeclaration_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda$slambda_21).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            var variableType = this.pnz_1.l60(this.qnz_1.ofu());
            if (!(!(variableType == null) ? isInterface(variableType, NotionType_0) : false))
              return false;
            this.f9_1 = 1;
            suspendResult = this.pnz_1.k60(variableType.mfq(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            return equals(this.onz_1, ARGUMENT);
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda$slambda_21).jnx = function ($this$query, it, completion) {
    var i = new btbScopes$lambda$slambda$slambda_21(this.onz_1, completion);
    i.pnz_1 = $this$query;
    i.qnz_1 = it;
    return i;
  };
  function btbScopes$lambda$slambda$slambda_22($typeNotion, resultContinuation) {
    var i = new btbScopes$lambda$slambda$slambda_21($typeNotion, resultContinuation);
    var l = function ($this$query, it, $completion) {
      return i.inx($this$query, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_195(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_195).fo0 = function ($this$provideLexicalScope, relationValue, $completion) {
    var tmp = this.go0($this$provideLexicalScope, relationValue, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_195).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.fo0(tmp, (!(p2 == null) ? isInterface(p2, InstanceRelationValue) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_195).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 10;
            this.f9_1 = 1;
            suspendResult = this.znz_1.k60(this.ao0_1.xfq(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp0_elvis_lhs = suspendResult;
            if (tmp0_elvis_lhs == null) {
              this.f9_1 = 2;
              suspendResult = this.znz_1.r77(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.eo0_1 = tmp0_elvis_lhs;
              this.f9_1 = 3;
              continue $sm;
            }

          case 2:
            var tmp_0 = this;
            return suspendResult;
          case 3:
            var property = this.eo0_1;
            var tmp1_elvis_lhs = this.znz_1.l60(property.hd());
            if (tmp1_elvis_lhs == null) {
              this.f9_1 = 4;
              suspendResult = this.znz_1.r77(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.do0_1 = tmp1_elvis_lhs;
              this.f9_1 = 5;
              continue $sm;
            }

          case 4:
            var tmp_1 = this;
            return suspendResult;
          case 5:
            var type = this.do0_1;
            var tmp_2;
            if (isInterface(type, OntologyElementType_1)) {
              tmp_2 = true;
            } else {
              tmp_2 = isInterface(type, ClassExpressionType_1);
            }

            if (tmp_2) {
              this.f9_1 = 7;
              suspendResult = this.znz_1.k60(typeElements(type), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              if (isInterface(type, NotionType_0)) {
                this.f9_1 = 6;
                suspendResult = this.znz_1.k60(type.mfq(), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                this.co0_1 = NoopScopeFilter_instance;
                this.f9_1 = 8;
                continue $sm;
              }
            }

          case 6:
            var typeNotion = suspendResult;
            var tmp_3 = this;
            var tmp_4 = Companion_instance_120;
            tmp_3.co0_1 = tmp_4.f73(btbScopes$lambda$slambda$slambda_22(typeNotion, null));
            this.f9_1 = 8;
            continue $sm;
          case 7:
            var typeElements_0 = suspendResult;
            var tmp_5 = this;
            var tmp_6 = Companion_instance_120;
            tmp_5.co0_1 = tmp_6.f73(btbScopes$lambda$slambda$slambda_20(typeElements_0, null));
            this.f9_1 = 8;
            continue $sm;
          case 8:
            this.bo0_1 = this.co0_1;
            this.f9_1 = 9;
            suspendResult = this.znz_1.r77(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 9:
            var ARGUMENT = suspendResult;
            return filter_1(ARGUMENT, this.bo0_1);
          case 10:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 10) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_195).go0 = function ($this$provideLexicalScope, relationValue, completion) {
    var i = new btbScopes$lambda$slambda_195(completion);
    i.znz_1 = $this$provideLexicalScope;
    i.ao0_1 = relationValue;
    return i;
  };
  function btbScopes$lambda$slambda_196(resultContinuation) {
    var i = new btbScopes$lambda$slambda_195(resultContinuation);
    var l = function ($this$provideLexicalScope, relationValue, $completion) {
      return i.fo0($this$provideLexicalScope, relationValue, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_197(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_197).so0 = function ($this$provideLexicalScope, propertyValue, $completion) {
    var tmp = this.to0($this$provideLexicalScope, propertyValue, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_197).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.so0(tmp, (!(p2 == null) ? isInterface(p2, ProcessPropertyValue_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_197).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 4;
            this.f9_1 = 1;
            suspendResult = this.po0_1.k60(this.qo0_1.q6q(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp0_safe_receiver = suspendResult;
            var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : this.po0_1.l60(tmp0_safe_receiver.sfq());
            var type = tmp1_safe_receiver == null ? null : this.po0_1.l60(tmp1_safe_receiver.sfq());
            var tmp_0;
            if (!(type == null) ? isInterface(type, SimplePropertyType) : false) {
              tmp_0 = true;
            } else {
              tmp_0 = !(type == null) ? isInterface(type, PrimitivePropertyType_1) : false;
            }

            if (tmp_0) {
              var tmp_1 = this;
              return Scopes_getInstance().u7b();
            } else {
              this.f9_1 = 2;
              suspendResult = this.po0_1.r77(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 2:
            var tmp_2 = this;
            return suspendResult;
          case 3:
            return this.ro0_1;
          case 4:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 4) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_197).to0 = function ($this$provideLexicalScope, propertyValue, completion) {
    var i = new btbScopes$lambda$slambda_197(completion);
    i.po0_1 = $this$provideLexicalScope;
    i.qo0_1 = propertyValue;
    return i;
  };
  function btbScopes$lambda$slambda_198(resultContinuation) {
    var i = new btbScopes$lambda$slambda_197(resultContinuation);
    var l = function ($this$provideLexicalScope, propertyValue, $completion) {
      return i.so0($this$provideLexicalScope, propertyValue, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_199(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_199).go1 = function ($this$provideLexicalScope, expression, $completion) {
    var tmp = this.ho1($this$provideLexicalScope, expression, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_199).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.go1(tmp, (!(p2 == null) ? isInterface(p2, IsExpression_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_199).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 5;
            var tmp0_safe_receiver = this.co1_1.l60(this.do1_1.mdy());
            var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : this.co1_1.l60(tmp0_safe_receiver.q6q());
            if (tmp1_safe_receiver == null) {
              this.fo1_1 = null;
              this.f9_1 = 2;
              continue $sm;
            } else {
              this.f9_1 = 1;
              suspendResult = this.co1_1.k60(tmp1_safe_receiver.q6q(), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            this.fo1_1 = suspendResult;
            this.f9_1 = 2;
            continue $sm;
          case 2:
            var tmp2_safe_receiver = this.fo1_1;
            var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : this.co1_1.l60(tmp2_safe_receiver.hd());
            var types = tmp3_safe_receiver == null ? null : this.co1_1.l60(tmp3_safe_receiver.cfs());
            var tmp_0;
            if (types == null || types.s()) {
              tmp_0 = true;
            } else {
              var tmp$ret$0;
              l$ret$1: do {
                var tmp_1;
                if (isInterface(types, Collection)) {
                  tmp_1 = types.s();
                } else {
                  tmp_1 = false;
                }
                if (tmp_1) {
                  tmp$ret$0 = false;
                  break l$ret$1;
                }
                var _iterator__ex2g4s = types.m();
                while (_iterator__ex2g4s.n()) {
                  var element = _iterator__ex2g4s.o();
                  if (isInterface(element, OntologyElementType_1)) {
                    tmp$ret$0 = true;
                    break l$ret$1;
                  }
                }
                tmp$ret$0 = false;
              }
               while (false);
              tmp_0 = tmp$ret$0;
            }

            if (tmp_0) {
              this.f9_1 = 3;
              suspendResult = this.co1_1.r77(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              var tmp_2 = this;
              return Scopes_getInstance().u7b();
            }

          case 3:
            var tmp_3 = this;
            return suspendResult;
          case 4:
            return this.eo1_1;
          case 5:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 5) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_199).ho1 = function ($this$provideLexicalScope, expression, completion) {
    var i = new btbScopes$lambda$slambda_199(completion);
    i.co1_1 = $this$provideLexicalScope;
    i.do1_1 = expression;
    return i;
  };
  function btbScopes$lambda$slambda_200(resultContinuation) {
    var i = new btbScopes$lambda$slambda_199(resultContinuation);
    var l = function ($this$provideLexicalScope, expression, $completion) {
      return i.go1($this$provideLexicalScope, expression, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_201(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_201).to1 = function ($this$provideLexicalScope, value, $completion) {
    var tmp = this.uo1($this$provideLexicalScope, value, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_201).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.to1(tmp, (!(p2 == null) ? isInterface(p2, InstanceRelationValue) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_201).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 4;
            this.f9_1 = 1;
            suspendResult = this.qo1_1.k60(this.ro1_1.xfq(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp0_safe_receiver = suspendResult;
            var range = tmp0_safe_receiver == null ? null : this.qo1_1.l60(tmp0_safe_receiver.hd());
            var tmp_0;
            if (!(range == null) ? isInterface(range, NotionType_0) : false) {
              tmp_0 = true;
            } else {
              tmp_0 = !(range == null) ? isInterface(range, PrimitiveNotionType_1) : false;
            }

            if (tmp_0) {
              var tmp_1 = this;
              return Scopes_getInstance().u7b();
            } else {
              this.f9_1 = 2;
              suspendResult = this.qo1_1.r77(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 2:
            var tmp_2 = this;
            return suspendResult;
          case 3:
            return this.so1_1;
          case 4:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 4) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_201).uo1 = function ($this$provideLexicalScope, value, completion) {
    var i = new btbScopes$lambda$slambda_201(completion);
    i.qo1_1 = $this$provideLexicalScope;
    i.ro1_1 = value;
    return i;
  };
  function btbScopes$lambda$slambda_202(resultContinuation) {
    var i = new btbScopes$lambda$slambda_201(resultContinuation);
    var l = function ($this$provideLexicalScope, value, $completion) {
      return i.to1($this$provideLexicalScope, value, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda$slambda_23(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda$slambda_23).fo2 = function ($this$filter, it, $completion) {
    var tmp = this.go2($this$filter, it, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda$slambda_23).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof QueryBuilder ? p1 : THROW_CCE();
    return this.fo2(tmp, !(p2 == null) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda$slambda_23).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        if (tmp === 0) {
          this.g9_1 = 1;
          var tmp_0 = this.eo2_1;
          return isInterface(tmp_0, AbstractLink);
        } else if (tmp === 1) {
          throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda$slambda_23).go2 = function ($this$filter, it, completion) {
    var i = new btbScopes$lambda$slambda$slambda_23(completion);
    i.do2_1 = $this$filter;
    i.eo2_1 = it;
    return i;
  };
  function btbScopes$lambda$slambda$slambda_24(resultContinuation) {
    var i = new btbScopes$lambda$slambda$slambda_23(resultContinuation);
    var l = function ($this$filter, it, $completion) {
      return i.fo2($this$filter, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_203(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_203).so2 = function ($this$provideCommonScope, process, $completion) {
    var tmp = this.to2($this$provideCommonScope, process, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_203).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.so2(tmp, (!(p2 == null) ? isInterface(p2, ProcessDeclaration_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_203).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 3;
            this.f9_1 = 1;
            suspendResult = this.po2_1.u77(this.qo2_1.y(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp_0 = this;
            var this_0 = suspendResult;
            var tmp_1 = filter_0(this_0, btbScopes$lambda$slambda$slambda_24(null));
            tmp_0.ro2_1 = isInterface(tmp_1, Scope) ? tmp_1 : THROW_CCE();
            this.f9_1 = 2;
            suspendResult = this.po2_1.w77(this.qo2_1.pft(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var ARGUMENT = suspendResult;
            return new UniqueSumScope(this.ro2_1, ARGUMENT);
          case 3:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 3) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_203).to2 = function ($this$provideCommonScope, process, completion) {
    var i = new btbScopes$lambda$slambda_203(completion);
    i.po2_1 = $this$provideCommonScope;
    i.qo2_1 = process;
    return i;
  };
  function btbScopes$lambda$slambda_204(resultContinuation) {
    var i = new btbScopes$lambda$slambda_203(resultContinuation);
    var l = function ($this$provideCommonScope, process, $completion) {
      return i.so2($this$provideCommonScope, process, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda$slambda_25(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda$slambda_25).fo2 = function ($this$filter, it, $completion) {
    var tmp = this.go2($this$filter, it, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda$slambda_25).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof QueryBuilder ? p1 : THROW_CCE();
    return this.fo2(tmp, !(p2 == null) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda$slambda_25).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        if (tmp === 0) {
          this.g9_1 = 1;
          var tmp_0 = this.do3_1;
          return isInterface(tmp_0, AbstractProperty);
        } else if (tmp === 1) {
          throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda$slambda_25).go2 = function ($this$filter, it, completion) {
    var i = new btbScopes$lambda$slambda$slambda_25(completion);
    i.co3_1 = $this$filter;
    i.do3_1 = it;
    return i;
  };
  function btbScopes$lambda$slambda$slambda_26(resultContinuation) {
    var i = new btbScopes$lambda$slambda$slambda_25(resultContinuation);
    var l = function ($this$filter, it, $completion) {
      return i.fo2($this$filter, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_205(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_205).po3 = function ($this$provideCommonScope, process, $completion) {
    var tmp = this.qo3($this$provideCommonScope, process, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_205).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.po3(tmp, (!(p2 == null) ? isInterface(p2, ProcessDeclaration_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_205).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 3;
            this.f9_1 = 1;
            suspendResult = this.mo3_1.u77(this.no3_1.y(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp_0 = this;
            var this_0 = suspendResult;
            var tmp_1 = filter_0(this_0, btbScopes$lambda$slambda$slambda_26(null));
            tmp_0.oo3_1 = isInterface(tmp_1, Scope) ? tmp_1 : THROW_CCE();
            this.f9_1 = 2;
            suspendResult = this.mo3_1.w77(this.no3_1.pft(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var ARGUMENT = suspendResult;
            return new UniqueSumScope(this.oo3_1, ARGUMENT);
          case 3:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 3) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_205).qo3 = function ($this$provideCommonScope, process, completion) {
    var i = new btbScopes$lambda$slambda_205(completion);
    i.mo3_1 = $this$provideCommonScope;
    i.no3_1 = process;
    return i;
  };
  function btbScopes$lambda$slambda_206(resultContinuation) {
    var i = new btbScopes$lambda$slambda_205(resultContinuation);
    var l = function ($this$provideCommonScope, process, $completion) {
      return i.po3($this$provideCommonScope, process, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_207(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_207).bo4 = function ($this$provideCommonScope, process, $completion) {
    var tmp = this.co4($this$provideCommonScope, process, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_207).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.bo4(tmp, (!(p2 == null) ? isInterface(p2, ProcessDeclaration_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_207).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 3;
            this.f9_1 = 1;
            suspendResult = this.zo3_1.k60(this.ao4_1.sil(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            this.f9_1 = 2;
            suspendResult = this.zo3_1.v77(ARGUMENT, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return suspendResult;
          case 3:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 3) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_207).co4 = function ($this$provideCommonScope, process, completion) {
    var i = new btbScopes$lambda$slambda_207(completion);
    i.zo3_1 = $this$provideCommonScope;
    i.ao4_1 = process;
    return i;
  };
  function btbScopes$lambda$slambda_208(resultContinuation) {
    var i = new btbScopes$lambda$slambda_207(resultContinuation);
    var l = function ($this$provideCommonScope, process, $completion) {
      return i.bo4($this$provideCommonScope, process, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function ProcessProperty$_get_aliasedProperties_$ref_lzqazi_1() {
    return function (p0) {
      return p0.yft();
    };
  }
  function btbScopes$lambda$slambda_209(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_209).oo4 = function ($this$provideLexicalScope, processProperty, $completion) {
    var tmp = this.po4($this$provideLexicalScope, processProperty, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_209).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.oo4(tmp, (!(p2 == null) ? isInterface(p2, ProcessProperty_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_209).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 4;
            var processDeclaration = ancestorOrSelf(this.mo4_1, getKClass(ProcessDeclaration_1));
            var tmp0_safe_receiver = this.lo4_1.l60(processDeclaration);
            if (tmp0_safe_receiver == null) {
              this.no4_1 = null;
              this.f9_1 = 2;
              continue $sm;
            } else {
              this.f9_1 = 1;
              suspendResult = this.lo4_1.k60(tmp0_safe_receiver.til(), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            this.no4_1 = suspendResult;
            this.f9_1 = 2;
            continue $sm;
          case 2:
            var tmp1_elvis_lhs = this.no4_1;
            var ARGUMENT = tmp1_elvis_lhs == null ? emptyList() : tmp1_elvis_lhs;
            this.f9_1 = 3;
            suspendResult = this.lo4_1.v77(ARGUMENT, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            return suspendResult;
          case 4:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 4) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_209).po4 = function ($this$provideLexicalScope, processProperty, completion) {
    var i = new btbScopes$lambda$slambda_209(completion);
    i.lo4_1 = $this$provideLexicalScope;
    i.mo4_1 = processProperty;
    return i;
  };
  function btbScopes$lambda$slambda_210(resultContinuation) {
    var i = new btbScopes$lambda$slambda_209(resultContinuation);
    var l = function ($this$provideLexicalScope, processProperty, $completion) {
      return i.oo4($this$provideLexicalScope, processProperty, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function ProcessProperty$_get_default_$ref_tilfgf_1() {
    return function (p0) {
      return p0.g3b();
    };
  }
  function btbScopes$lambda$slambda$slambda_27($processProperty, resultContinuation) {
    this.yo4_1 = $processProperty;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda$slambda_27).bo5 = function ($this$filter, it, $completion) {
    var tmp = this.co5($this$filter, it, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda$slambda_27).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof QueryBuilder ? p1 : THROW_CCE();
    return this.bo5(tmp, (!(p2 == null) ? isInterface(p2, ProcessProperty_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda$slambda_27).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        if (tmp === 0) {
          this.g9_1 = 1;
          return !equals(this.ao5_1, this.yo4_1);
        } else if (tmp === 1) {
          throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda$slambda_27).co5 = function ($this$filter, it, completion) {
    var i = new btbScopes$lambda$slambda$slambda_27(this.yo4_1, completion);
    i.zo4_1 = $this$filter;
    i.ao5_1 = it;
    return i;
  };
  function btbScopes$lambda$slambda$slambda_28($processProperty, resultContinuation) {
    var i = new btbScopes$lambda$slambda$slambda_27($processProperty, resultContinuation);
    var l = function ($this$filter, it, $completion) {
      return i.bo5($this$filter, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_211(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_211).oo4 = function ($this$provideLexicalScope, processProperty, $completion) {
    var tmp = this.po4($this$provideLexicalScope, processProperty, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_211).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.oo4(tmp, (!(p2 == null) ? isInterface(p2, ProcessProperty_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_211).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.lo5_1.r77(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            return filter_0(ARGUMENT, btbScopes$lambda$slambda$slambda_28(this.mo5_1, null));
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_211).po4 = function ($this$provideLexicalScope, processProperty, completion) {
    var i = new btbScopes$lambda$slambda_211(completion);
    i.lo5_1 = $this$provideLexicalScope;
    i.mo5_1 = processProperty;
    return i;
  };
  function btbScopes$lambda$slambda_212(resultContinuation) {
    var i = new btbScopes$lambda$slambda_211(resultContinuation);
    var l = function ($this$provideLexicalScope, processProperty, $completion) {
      return i.oo4($this$provideLexicalScope, processProperty, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_213(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_213).xo5 = function ($this$provideLexicalScope, process, $completion) {
    var tmp = this.yo5($this$provideLexicalScope, process, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_213).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.xo5(tmp, (!(p2 == null) ? isInterface(p2, ProcessDeclaration_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_213).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.vo5_1.u77(this.wo5_1.rfr(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_213).yo5 = function ($this$provideLexicalScope, process, completion) {
    var i = new btbScopes$lambda$slambda_213(completion);
    i.vo5_1 = $this$provideLexicalScope;
    i.wo5_1 = process;
    return i;
  };
  function btbScopes$lambda$slambda_214(resultContinuation) {
    var i = new btbScopes$lambda$slambda_213(resultContinuation);
    var l = function ($this$provideLexicalScope, process, $completion) {
      return i.xo5($this$provideLexicalScope, process, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function ProcessDeclaration$_get_inherited_$ref_wglzfx_2() {
    return function (p0) {
      return p0.qft();
    };
  }
  function btbScopes$lambda$slambda$slambda_29($process, resultContinuation) {
    this.ho6_1 = $process;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda$slambda_29).ko6 = function ($this$filter, it, $completion) {
    var tmp = this.lo6($this$filter, it, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda$slambda_29).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof QueryBuilder ? p1 : THROW_CCE();
    return this.ko6(tmp, (!(p2 == null) ? isInterface(p2, ProcessDeclaration_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda$slambda_29).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        if (tmp === 0) {
          this.g9_1 = 1;
          return !equals(this.jo6_1, this.ho6_1);
        } else if (tmp === 1) {
          throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda$slambda_29).lo6 = function ($this$filter, it, completion) {
    var i = new btbScopes$lambda$slambda$slambda_29(this.ho6_1, completion);
    i.io6_1 = $this$filter;
    i.jo6_1 = it;
    return i;
  };
  function btbScopes$lambda$slambda$slambda_30($process, resultContinuation) {
    var i = new btbScopes$lambda$slambda$slambda_29($process, resultContinuation);
    var l = function ($this$filter, it, $completion) {
      return i.ko6($this$filter, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_215(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_215).wo6 = function ($this$provideLexicalScope, process, $completion) {
    var tmp = this.xo6($this$provideLexicalScope, process, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_215).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.wo6(tmp, (!(p2 == null) ? isInterface(p2, ProcessDeclaration_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_215).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.uo6_1.r77(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            return filter_0(ARGUMENT, btbScopes$lambda$slambda$slambda_30(this.vo6_1, null));
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_215).xo6 = function ($this$provideLexicalScope, process, completion) {
    var i = new btbScopes$lambda$slambda_215(completion);
    i.uo6_1 = $this$provideLexicalScope;
    i.vo6_1 = process;
    return i;
  };
  function btbScopes$lambda$slambda_216(resultContinuation) {
    var i = new btbScopes$lambda$slambda_215(resultContinuation);
    var l = function ($this$provideLexicalScope, process, $completion) {
      return i.wo6($this$provideLexicalScope, process, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function ProcessDeclaration$_get_prerequisites_$ref_h8hogm_1() {
    return function (p0) {
      return p0.rft();
    };
  }
  function btbScopes$lambda$slambda_217(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_217).wo6 = function ($this$provideLexicalScope, it, $completion) {
    var tmp = this.xo6($this$provideLexicalScope, it, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_217).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.wo6(tmp, (!(p2 == null) ? isInterface(p2, ProcessDeclaration_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_217).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        if (tmp === 0) {
          this.g9_1 = 1;
          return Scopes_getInstance().u7b();
        } else if (tmp === 1) {
          throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_217).xo6 = function ($this$provideLexicalScope, it, completion) {
    var i = new btbScopes$lambda$slambda_217(completion);
    i.go7_1 = $this$provideLexicalScope;
    i.ho7_1 = it;
    return i;
  };
  function btbScopes$lambda$slambda_218(resultContinuation) {
    var i = new btbScopes$lambda$slambda_217(resultContinuation);
    var l = function ($this$provideLexicalScope, it, $completion) {
      return i.wo6($this$provideLexicalScope, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function ProcessDeclaration$_get_effects_$ref_9vh0jp_1() {
    return function (p0) {
      return p0.sft();
    };
  }
  function btbScopes$lambda$slambda_219(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_219).wo6 = function ($this$provideLexicalScope, it, $completion) {
    var tmp = this.xo6($this$provideLexicalScope, it, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_219).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.wo6(tmp, (!(p2 == null) ? isInterface(p2, ProcessDeclaration_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_219).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        if (tmp === 0) {
          this.g9_1 = 1;
          return Scopes_getInstance().u7b();
        } else if (tmp === 1) {
          throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_219).xo6 = function ($this$provideLexicalScope, it, completion) {
    var i = new btbScopes$lambda$slambda_219(completion);
    i.qo7_1 = $this$provideLexicalScope;
    i.ro7_1 = it;
    return i;
  };
  function btbScopes$lambda$slambda_220(resultContinuation) {
    var i = new btbScopes$lambda$slambda_219(resultContinuation);
    var l = function ($this$provideLexicalScope, it, $completion) {
      return i.wo6($this$provideLexicalScope, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function HasVariables$_get_variables_$ref_6jdr2_1() {
    return function (p0) {
      return p0.rfr();
    };
  }
  function btbScopes$lambda$slambda_221(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_221).wo6 = function ($this$provideLexicalScope, it, $completion) {
    var tmp = this.xo6($this$provideLexicalScope, it, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_221).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.wo6(tmp, (!(p2 == null) ? isInterface(p2, ProcessDeclaration_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_221).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        if (tmp === 0) {
          this.g9_1 = 1;
          return Scopes_getInstance().u7b();
        } else if (tmp === 1) {
          throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_221).xo6 = function ($this$provideLexicalScope, it, completion) {
    var i = new btbScopes$lambda$slambda_221(completion);
    i.ao8_1 = $this$provideLexicalScope;
    i.bo8_1 = it;
    return i;
  };
  function btbScopes$lambda$slambda_222(resultContinuation) {
    var i = new btbScopes$lambda$slambda_221(resultContinuation);
    var l = function ($this$provideLexicalScope, it, $completion) {
      return i.wo6($this$provideLexicalScope, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_223(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_223).mo8 = function ($this$provideLexicalScope, process, $completion) {
    var tmp = this.no8($this$provideLexicalScope, process, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_223).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.mo8(tmp, (!(p2 == null) ? isInterface(p2, LibraryProcessSpecification_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_223).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.ko8_1.w77(this.lo8_1.vfr(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_223).no8 = function ($this$provideLexicalScope, process, completion) {
    var i = new btbScopes$lambda$slambda_223(completion);
    i.ko8_1 = $this$provideLexicalScope;
    i.lo8_1 = process;
    return i;
  };
  function btbScopes$lambda$slambda_224(resultContinuation) {
    var i = new btbScopes$lambda$slambda_223(resultContinuation);
    var l = function ($this$provideLexicalScope, process, $completion) {
      return i.mo8($this$provideLexicalScope, process, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_225(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_225).yo8 = function ($this$provideLexicalScope, process, $completion) {
    var tmp = this.zo8($this$provideLexicalScope, process, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_225).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.yo8(tmp, (!(p2 == null) ? isInterface(p2, LibraryProcessSpecification_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_225).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.wo8_1.w77(this.xo8_1.vfr(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_225).zo8 = function ($this$provideLexicalScope, process, completion) {
    var i = new btbScopes$lambda$slambda_225(completion);
    i.wo8_1 = $this$provideLexicalScope;
    i.xo8_1 = process;
    return i;
  };
  function btbScopes$lambda$slambda_226(resultContinuation) {
    var i = new btbScopes$lambda$slambda_225(resultContinuation);
    var l = function ($this$provideLexicalScope, process, $completion) {
      return i.yo8($this$provideLexicalScope, process, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_227(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_227).ko9 = function ($this$provideLexicalScope, process, $completion) {
    var tmp = this.lo9($this$provideLexicalScope, process, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_227).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.ko9(tmp, (!(p2 == null) ? isInterface(p2, LibraryProcessSpecification_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_227).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.io9_1.w77(this.jo9_1.vfr(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_227).lo9 = function ($this$provideLexicalScope, process, completion) {
    var i = new btbScopes$lambda$slambda_227(completion);
    i.io9_1 = $this$provideLexicalScope;
    i.jo9_1 = process;
    return i;
  };
  function btbScopes$lambda$slambda_228(resultContinuation) {
    var i = new btbScopes$lambda$slambda_227(resultContinuation);
    var l = function ($this$provideLexicalScope, process, $completion) {
      return i.ko9($this$provideLexicalScope, process, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_229(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_229).wo9 = function ($this$provideLexicalScope, process, $completion) {
    var tmp = this.xo9($this$provideLexicalScope, process, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_229).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.wo9(tmp, (!(p2 == null) ? isInterface(p2, LibraryProcessSpecificationQuery_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_229).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.uo9_1.w77(this.vo9_1.vfr(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_229).xo9 = function ($this$provideLexicalScope, process, completion) {
    var i = new btbScopes$lambda$slambda_229(completion);
    i.uo9_1 = $this$provideLexicalScope;
    i.vo9_1 = process;
    return i;
  };
  function btbScopes$lambda$slambda_230(resultContinuation) {
    var i = new btbScopes$lambda$slambda_229(resultContinuation);
    var l = function ($this$provideLexicalScope, process, $completion) {
      return i.wo9($this$provideLexicalScope, process, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_231(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_231).ioa = function ($this$provideLexicalScope, process, $completion) {
    var tmp = this.joa($this$provideLexicalScope, process, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_231).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.ioa(tmp, (!(p2 == null) ? isInterface(p2, LibraryProcessSpecificationQuery_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_231).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.goa_1.w77(this.hoa_1.vfr(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_231).joa = function ($this$provideLexicalScope, process, completion) {
    var i = new btbScopes$lambda$slambda_231(completion);
    i.goa_1 = $this$provideLexicalScope;
    i.hoa_1 = process;
    return i;
  };
  function btbScopes$lambda$slambda_232(resultContinuation) {
    var i = new btbScopes$lambda$slambda_231(resultContinuation);
    var l = function ($this$provideLexicalScope, process, $completion) {
      return i.ioa($this$provideLexicalScope, process, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_233(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_233).uoa = function ($this$provideLexicalScope, process, $completion) {
    var tmp = this.voa($this$provideLexicalScope, process, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_233).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.uoa(tmp, (!(p2 == null) ? isInterface(p2, LibraryProcessSpecificationQuery_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_233).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.soa_1.w77(this.toa_1.vfr(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_233).voa = function ($this$provideLexicalScope, process, completion) {
    var i = new btbScopes$lambda$slambda_233(completion);
    i.soa_1 = $this$provideLexicalScope;
    i.toa_1 = process;
    return i;
  };
  function btbScopes$lambda$slambda_234(resultContinuation) {
    var i = new btbScopes$lambda$slambda_233(resultContinuation);
    var l = function ($this$provideLexicalScope, process, $completion) {
      return i.uoa($this$provideLexicalScope, process, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_235(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_235).iob = function ($this$provideLexicalScope, term, $completion) {
    var tmp = this.job($this$provideLexicalScope, term, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_235).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.iob(tmp, (!(p2 == null) ? isInterface(p2, FunctionTerm_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_235).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 4;
            var tmp0 = this.eob_1;
            var tmp2 = this.fob_1;
            this.hob_1 = tmp0;
            this.f9_1 = 1;
            suspendResult = this.hob_1.k60(tmp2.ifr().w6o(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var functionDeclaration = suspendResult;
            var this_0 = this.hob_1;
            if (functionDeclaration == null) {
              var tmp_0 = this;
              tmp_0.gob_1 = new EmptyScope();
              this.f9_1 = 3;
              continue $sm;
            } else {
              var tmp0_0 = this_0.l60(functionDeclaration.y());
              var destination = ArrayList_init_$Create$();
              var _iterator__ex2g4s = tmp0_0.m();
              while (_iterator__ex2g4s.n()) {
                var element = _iterator__ex2g4s.o();
                if (!(element == null) ? isInterface(element, AbstractLink) : false) {
                  destination.j(element);
                }
              }
              var entries = destination;
              this.f9_1 = 2;
              suspendResult = this_0.v77(entries, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 2:
            this.gob_1 = suspendResult;
            this.f9_1 = 3;
            continue $sm;
          case 3:
            return this.gob_1;
          case 4:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 4) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_235).job = function ($this$provideLexicalScope, term, completion) {
    var i = new btbScopes$lambda$slambda_235(completion);
    i.eob_1 = $this$provideLexicalScope;
    i.fob_1 = term;
    return i;
  };
  function btbScopes$lambda$slambda_236(resultContinuation) {
    var i = new btbScopes$lambda$slambda_235(resultContinuation);
    var l = function ($this$provideLexicalScope, term, $completion) {
      return i.iob($this$provideLexicalScope, term, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_237(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_237).wob = function ($this$provideLexicalScope, term, $completion) {
    var tmp = this.xob($this$provideLexicalScope, term, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_237).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.wob(tmp, (!(p2 == null) ? isInterface(p2, FunctionTerm_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_237).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 4;
            var tmp0 = this.sob_1;
            var tmp2 = this.tob_1;
            this.vob_1 = tmp0;
            this.f9_1 = 1;
            suspendResult = this.vob_1.k60(tmp2.ifr().w6o(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var functionDeclaration = suspendResult;
            var this_0 = this.vob_1;
            if (functionDeclaration == null) {
              var tmp_0 = this;
              tmp_0.uob_1 = new EmptyScope();
              this.f9_1 = 3;
              continue $sm;
            } else {
              var tmp0_0 = this_0.l60(functionDeclaration.y());
              var destination = ArrayList_init_$Create$();
              var _iterator__ex2g4s = tmp0_0.m();
              while (_iterator__ex2g4s.n()) {
                var element = _iterator__ex2g4s.o();
                if (!(element == null) ? isInterface(element, AbstractProperty) : false) {
                  destination.j(element);
                }
              }
              var entries = destination;
              this.f9_1 = 2;
              suspendResult = this_0.v77(entries, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 2:
            this.uob_1 = suspendResult;
            this.f9_1 = 3;
            continue $sm;
          case 3:
            return this.uob_1;
          case 4:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 4) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_237).xob = function ($this$provideLexicalScope, term, completion) {
    var i = new btbScopes$lambda$slambda_237(completion);
    i.sob_1 = $this$provideLexicalScope;
    i.tob_1 = term;
    return i;
  };
  function btbScopes$lambda$slambda_238(resultContinuation) {
    var i = new btbScopes$lambda$slambda_237(resultContinuation);
    var l = function ($this$provideLexicalScope, term, $completion) {
      return i.wob($this$provideLexicalScope, term, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_239(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_239).ioc = function ($this$provideLexicalScope, term, $completion) {
    var tmp = this.joc($this$provideLexicalScope, term, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_239).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.ioc(tmp, (!(p2 == null) ? isInterface(p2, FunctionTerm_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_239).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.goc_1.w77(this.hoc_1.ifr(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_239).joc = function ($this$provideLexicalScope, term, completion) {
    var i = new btbScopes$lambda$slambda_239(completion);
    i.goc_1 = $this$provideLexicalScope;
    i.hoc_1 = term;
    return i;
  };
  function btbScopes$lambda$slambda_240(resultContinuation) {
    var i = new btbScopes$lambda$slambda_239(resultContinuation);
    var l = function ($this$provideLexicalScope, term, $completion) {
      return i.ioc($this$provideLexicalScope, term, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_241(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_241).uoc = function ($this$provideImportScope, function_0, $completion) {
    var tmp = this.voc($this$provideImportScope, function_0, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_241).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.uoc(tmp, (!(p2 == null) ? isInterface(p2, FunctionDeclaration_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_241).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.soc_1.u77(this.toc_1.rfp(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_241).voc = function ($this$provideImportScope, function_0, completion) {
    var i = new btbScopes$lambda$slambda_241(completion);
    i.soc_1 = $this$provideImportScope;
    i.toc_1 = function_0;
    return i;
  };
  function btbScopes$lambda$slambda_242(resultContinuation) {
    var i = new btbScopes$lambda$slambda_241(resultContinuation);
    var l = function ($this$provideImportScope, function_0, $completion) {
      return i.uoc($this$provideImportScope, function_0, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_243(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_243).god = function ($this$provideLexicalScope, customEditor, $completion) {
    var tmp = this.hod($this$provideLexicalScope, customEditor, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_243).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.god(tmp, (!(p2 == null) ? isInterface(p2, CustomEditor) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_243).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = getCustomEditorPropertiesScope(this.eod_1, this.fod_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_243).hod = function ($this$provideLexicalScope, customEditor, completion) {
    var i = new btbScopes$lambda$slambda_243(completion);
    i.eod_1 = $this$provideLexicalScope;
    i.fod_1 = customEditor;
    return i;
  };
  function btbScopes$lambda$slambda_244(resultContinuation) {
    var i = new btbScopes$lambda$slambda_243(resultContinuation);
    var l = function ($this$provideLexicalScope, customEditor, $completion) {
      return i.god($this$provideLexicalScope, customEditor, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_245(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_245).vod = function ($this$provideLexicalScope, customEditor, $completion) {
    var tmp = this.wod($this$provideLexicalScope, customEditor, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_245).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.vod(tmp, (!(p2 == null) ? isInterface(p2, CustomEditor) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_245).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 6;
            var tmp0 = this.qod_1;
            var tmp2 = this.rod_1;
            this.tod_1 = tmp0;
            var tmp_0 = tmp2.bp();
            var bindingDeclaration = (tmp_0 == null ? true : isInterface(tmp_0, AbstractBindingDeclaration)) ? tmp_0 : THROW_CCE();
            if (!(bindingDeclaration == null) ? isInterface(bindingDeclaration, ProcessDeclaration_1) : false) {
              this.f9_1 = 3;
              suspendResult = this.tod_1.k60(bindingDeclaration.ril(), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              if (!(bindingDeclaration == null) ? isInterface(bindingDeclaration, FunctionDeclaration_1) : false) {
                var this_0 = this.tod_1;
                if (bindingDeclaration == null) {
                  var tmp_1 = this;
                  tmp_1.uod_1 = new EmptyScope();
                  this.f9_1 = 2;
                  continue $sm;
                } else {
                  var tmp0_0 = this_0.l60(bindingDeclaration.y());
                  var destination = ArrayList_init_$Create$();
                  var _iterator__ex2g4s = tmp0_0.m();
                  while (_iterator__ex2g4s.n()) {
                    var element = _iterator__ex2g4s.o();
                    if (!(element == null) ? isInterface(element, AbstractLink) : false) {
                      destination.j(element);
                    }
                  }
                  var entries = destination;
                  this.f9_1 = 1;
                  suspendResult = this_0.v77(entries, this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  continue $sm;
                }
              } else {
                if (bindingDeclaration == null) {
                  var tmp_2 = this;
                  throw NullPointerException_init_$Create$_0('null parent for custom editor');
                } else {
                  var tmp_3 = this;
                  throw UnsupportedOperationException_init_$Create$_0('unknown class: ' + toString_1(getKClassFromExpression(bindingDeclaration)));
                }
              }
            }

          case 1:
            this.uod_1 = suspendResult;
            this.f9_1 = 2;
            continue $sm;
          case 2:
            this.sod_1 = this.uod_1;
            this.f9_1 = 5;
            continue $sm;
          case 3:
            var tmp0_1 = suspendResult;
            var destination_0 = ArrayList_init_$Create$();
            var _iterator__ex2g4s_0 = tmp0_1.m();
            while (_iterator__ex2g4s_0.n()) {
              var element_0 = _iterator__ex2g4s_0.o();
              if (!(element_0 == null) ? isInterface(element_0, AbstractLink) : false) {
                destination_0.j(element_0);
              }
            }

            var links = destination_0;
            this.f9_1 = 4;
            suspendResult = this.tod_1.v77(links, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            this.sod_1 = suspendResult;
            this.f9_1 = 5;
            continue $sm;
          case 5:
            return this.sod_1;
          case 6:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 6) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_245).wod = function ($this$provideLexicalScope, customEditor, completion) {
    var i = new btbScopes$lambda$slambda_245(completion);
    i.qod_1 = $this$provideLexicalScope;
    i.rod_1 = customEditor;
    return i;
  };
  function btbScopes$lambda$slambda_246(resultContinuation) {
    var i = new btbScopes$lambda$slambda_245(resultContinuation);
    var l = function ($this$provideLexicalScope, customEditor, $completion) {
      return i.vod($this$provideLexicalScope, customEditor, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_247(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_247).koe = function ($this$provideLexicalScope, customEditor, $completion) {
    var tmp = this.loe($this$provideLexicalScope, customEditor, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_247).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.koe(tmp, (!(p2 == null) ? isInterface(p2, CustomEditor) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_247).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 6;
            var tmp0 = this.foe_1;
            var tmp2 = this.goe_1;
            this.ioe_1 = tmp0;
            var tmp_0 = tmp2.bp();
            var bindingDeclaration = (tmp_0 == null ? true : isInterface(tmp_0, AbstractBindingDeclaration)) ? tmp_0 : THROW_CCE();
            if (!(bindingDeclaration == null) ? isInterface(bindingDeclaration, ProcessDeclaration_1) : false) {
              this.f9_1 = 3;
              suspendResult = this.ioe_1.k60(bindingDeclaration.ril(), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              if (!(bindingDeclaration == null) ? isInterface(bindingDeclaration, FunctionDeclaration_1) : false) {
                var this_0 = this.ioe_1;
                if (bindingDeclaration == null) {
                  var tmp_1 = this;
                  tmp_1.joe_1 = new EmptyScope();
                  this.f9_1 = 2;
                  continue $sm;
                } else {
                  var tmp0_0 = this_0.l60(bindingDeclaration.y());
                  var destination = ArrayList_init_$Create$();
                  var _iterator__ex2g4s = tmp0_0.m();
                  while (_iterator__ex2g4s.n()) {
                    var element = _iterator__ex2g4s.o();
                    if (!(element == null) ? isInterface(element, AbstractProperty) : false) {
                      destination.j(element);
                    }
                  }
                  var entries = destination;
                  this.f9_1 = 1;
                  suspendResult = this_0.v77(entries, this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  continue $sm;
                }
              } else {
                if (bindingDeclaration == null) {
                  var tmp_2 = this;
                  throw NullPointerException_init_$Create$_0('null parent for custom editor');
                } else {
                  var tmp_3 = this;
                  throw UnsupportedOperationException_init_$Create$_0('unknown class: ' + toString_1(getKClassFromExpression(bindingDeclaration)));
                }
              }
            }

          case 1:
            this.joe_1 = suspendResult;
            this.f9_1 = 2;
            continue $sm;
          case 2:
            this.hoe_1 = this.joe_1;
            this.f9_1 = 5;
            continue $sm;
          case 3:
            var tmp0_1 = suspendResult;
            var destination_0 = ArrayList_init_$Create$();
            var _iterator__ex2g4s_0 = tmp0_1.m();
            while (_iterator__ex2g4s_0.n()) {
              var element_0 = _iterator__ex2g4s_0.o();
              if (!(element_0 == null) ? isInterface(element_0, AbstractProperty) : false) {
                destination_0.j(element_0);
              }
            }

            var links = destination_0;
            this.f9_1 = 4;
            suspendResult = this.ioe_1.v77(links, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            this.hoe_1 = suspendResult;
            this.f9_1 = 5;
            continue $sm;
          case 5:
            return this.hoe_1;
          case 6:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 6) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_247).loe = function ($this$provideLexicalScope, customEditor, completion) {
    var i = new btbScopes$lambda$slambda_247(completion);
    i.foe_1 = $this$provideLexicalScope;
    i.goe_1 = customEditor;
    return i;
  };
  function btbScopes$lambda$slambda_248(resultContinuation) {
    var i = new btbScopes$lambda$slambda_247(resultContinuation);
    var l = function ($this$provideLexicalScope, customEditor, $completion) {
      return i.koe($this$provideLexicalScope, customEditor, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda$lambda_1($this_provideLexicalScope) {
    return function (it) {
      return $this_provideLexicalScope.l60(it.wfr());
    };
  }
  function btbScopes$lambda$slambda_249($this_scopes, $librariesScopeProvider$delegate, resultContinuation) {
    this.uoe_1 = $this_scopes;
    this.voe_1 = $librariesScopeProvider$delegate;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_249).zoe = function ($this$provideLexicalScope, query, $completion) {
    var tmp = this.aof($this$provideLexicalScope, query, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_249).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.zoe(tmp, (!(p2 == null) ? isInterface(p2, LibraryProcessSpecificationQuery_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_249).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 4;
            this.f9_1 = 1;
            suspendResult = this.woe_1.k60(this.xoe_1.vfr(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var processDeclaration = suspendResult;
            if (processDeclaration == null) {
              var tmp_0 = this.woe_1.l60(this.woe_1.l60(invoke$lambda(this.uoe_1, this.voe_1).a6v(this.xoe_1)).h6v(LinkLibraryConcept_getInstance()));
              var links = toList_2(flatMap(tmp_0, btbScopes$lambda$slambda$lambda_1(this.woe_1)));
              this.f9_1 = 2;
              suspendResult = this.woe_1.v77(links, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              var tmp_1 = this;
              tmp_1.yoe_1 = new EmptyScope();
              this.f9_1 = 3;
              continue $sm;
            }

          case 2:
            this.yoe_1 = suspendResult;
            this.f9_1 = 3;
            continue $sm;
          case 3:
            return this.yoe_1;
          case 4:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 4) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_249).aof = function ($this$provideLexicalScope, query, completion) {
    var i = new btbScopes$lambda$slambda_249(this.uoe_1, this.voe_1, completion);
    i.woe_1 = $this$provideLexicalScope;
    i.xoe_1 = query;
    return i;
  };
  function btbScopes$lambda$slambda_250($this_scopes, $librariesScopeProvider$delegate, resultContinuation) {
    var i = new btbScopes$lambda$slambda_249($this_scopes, $librariesScopeProvider$delegate, resultContinuation);
    var l = function ($this$provideLexicalScope, query, $completion) {
      return i.zoe($this$provideLexicalScope, query, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda$lambda_2($this_provideLexicalScope) {
    return function (it) {
      return $this_provideLexicalScope.l60(it.rfp());
    };
  }
  function btbScopes$lambda$slambda_251($this_scopes, $librariesScopeProvider$delegate, resultContinuation) {
    this.jof_1 = $this_scopes;
    this.kof_1 = $librariesScopeProvider$delegate;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_251).oof = function ($this$provideLexicalScope, query, $completion) {
    var tmp = this.pof($this$provideLexicalScope, query, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_251).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.oof(tmp, (!(p2 == null) ? isInterface(p2, LibraryProcessSpecificationQuery_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_251).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 4;
            this.f9_1 = 1;
            suspendResult = this.lof_1.k60(this.mof_1.vfr(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var processDeclaration = suspendResult;
            if (processDeclaration == null) {
              var tmp_0 = this.lof_1.l60(this.lof_1.l60(invoke$lambda(this.jof_1, this.kof_1).a6v(this.mof_1)).h6v(PropertyLibraryConcept_getInstance()));
              var properties = toList_2(flatMap(tmp_0, btbScopes$lambda$slambda$lambda_2(this.lof_1)));
              this.f9_1 = 2;
              suspendResult = this.lof_1.v77(properties, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              var tmp_1 = this;
              tmp_1.nof_1 = new EmptyScope();
              this.f9_1 = 3;
              continue $sm;
            }

          case 2:
            this.nof_1 = suspendResult;
            this.f9_1 = 3;
            continue $sm;
          case 3:
            return this.nof_1;
          case 4:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 4) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_251).pof = function ($this$provideLexicalScope, query, completion) {
    var i = new btbScopes$lambda$slambda_251(this.jof_1, this.kof_1, completion);
    i.lof_1 = $this$provideLexicalScope;
    i.mof_1 = query;
    return i;
  };
  function btbScopes$lambda$slambda_252($this_scopes, $librariesScopeProvider$delegate, resultContinuation) {
    var i = new btbScopes$lambda$slambda_251($this_scopes, $librariesScopeProvider$delegate, resultContinuation);
    var l = function ($this$provideLexicalScope, query, $completion) {
      return i.oof($this$provideLexicalScope, query, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda$slambda_31(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda$slambda_31).aog = function ($this$query, it, $completion) {
    var tmp = this.bog($this$query, it, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda$slambda_31).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof QueryBuilder ? p1 : THROW_CCE();
    return this.aog(tmp, (!(p2 == null) ? isInterface(p2, InstanceRelationDeclaration) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda$slambda_31).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        if (tmp === 0) {
          this.g9_1 = 1;
          return false;
        } else if (tmp === 1) {
          throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda$slambda_31).bog = function ($this$query, it, completion) {
    var i = new btbScopes$lambda$slambda$slambda_31(completion);
    i.yof_1 = $this$query;
    i.zof_1 = it;
    return i;
  };
  function btbScopes$lambda$slambda$slambda_32(resultContinuation) {
    var i = new btbScopes$lambda$slambda$slambda_31(resultContinuation);
    var l = function ($this$query, it, $completion) {
      return i.aog($this$query, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda$slambda_33(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda$slambda_33).aog = function ($this$query, it, $completion) {
    var tmp = this.bog($this$query, it, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda$slambda_33).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof QueryBuilder ? p1 : THROW_CCE();
    return this.aog(tmp, (!(p2 == null) ? isInterface(p2, InstanceRelationDeclaration) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda$slambda_33).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        if (tmp === 0) {
          this.g9_1 = 1;
          return false;
        } else if (tmp === 1) {
          throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda$slambda_33).bog = function ($this$query, it, completion) {
    var i = new btbScopes$lambda$slambda$slambda_33(completion);
    i.kog_1 = $this$query;
    i.log_1 = it;
    return i;
  };
  function btbScopes$lambda$slambda$slambda_34(resultContinuation) {
    var i = new btbScopes$lambda$slambda$slambda_33(resultContinuation);
    var l = function ($this$query, it, $completion) {
      return i.aog($this$query, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_253(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_253).yog = function ($this$provideLexicalScope, variable, $completion) {
    var tmp = this.zog($this$provideLexicalScope, variable, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_253).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.yog(tmp, (!(p2 == null) ? isInterface(p2, VariableDeclaration_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_253).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 5;
            var type = this.uog_1.l60(this.vog_1.ofu());
            var tmp_0;
            if (!(type == null) ? isInterface(type, OntologyElementType_1) : false) {
              tmp_0 = true;
            } else {
              tmp_0 = !(type == null) ? isInterface(type, ClassExpressionType_1) : false;
            }

            if (tmp_0) {
              this.f9_1 = 2;
              suspendResult = this.uog_1.k60(typeElements(type), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              if (!(type == null) ? isInterface(type, NotionType_0) : false) {
                this.f9_1 = 1;
                suspendResult = this.uog_1.k60(type.mfq(), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                if (!(type == null) ? isInterface(type, PrimitiveNotionType_1) : false) {
                  var tmp_1 = this;
                  var tmp_2 = Companion_instance_120;
                  tmp_1.xog_1 = tmp_2.f73(btbScopes$lambda$slambda$slambda_32(null));
                  this.f9_1 = 3;
                  continue $sm;
                } else {
                  if (!(type == null) ? isInterface(type, ProcessType_1) : false) {
                    var tmp_3 = this;
                    var tmp_4 = Companion_instance_120;
                    tmp_3.xog_1 = tmp_4.f73(btbScopes$lambda$slambda$slambda_34(null));
                    this.f9_1 = 3;
                    continue $sm;
                  } else {
                    this.xog_1 = null;
                    this.f9_1 = 3;
                    continue $sm;
                  }
                }
              }
            }

          case 1:
            var tmp1_safe_receiver = suspendResult;
            var tmp_5 = this;
            var tmp_6;
            if (tmp1_safe_receiver == null) {
              tmp_6 = null;
            } else {
              tmp_6 = filterInstanceRelations_0(tmp1_safe_receiver);
            }

            tmp_5.xog_1 = tmp_6;
            this.f9_1 = 3;
            continue $sm;
          case 2:
            var tmp0_safe_receiver = suspendResult;
            var tmp_7 = this;
            var tmp_8;
            if (tmp0_safe_receiver == null) {
              tmp_8 = null;
            } else {
              tmp_8 = filterInstanceRelations(tmp0_safe_receiver);
            }

            tmp_7.xog_1 = tmp_8;
            this.f9_1 = 3;
            continue $sm;
          case 3:
            this.wog_1 = this.xog_1;
            this.f9_1 = 4;
            suspendResult = this.uog_1.r77(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            var ARGUMENT = suspendResult;
            var tmp2_elvis_lhs = this.wog_1;
            return filter_1(ARGUMENT, tmp2_elvis_lhs == null ? NoopScopeFilter_instance : tmp2_elvis_lhs);
          case 5:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 5) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_253).zog = function ($this$provideLexicalScope, variable, completion) {
    var i = new btbScopes$lambda$slambda_253(completion);
    i.uog_1 = $this$provideLexicalScope;
    i.vog_1 = variable;
    return i;
  };
  function btbScopes$lambda$slambda_254(resultContinuation) {
    var i = new btbScopes$lambda$slambda_253(resultContinuation);
    var l = function ($this$provideLexicalScope, variable, $completion) {
      return i.yog($this$provideLexicalScope, variable, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function HasPropertyConstraints$_get_constraints_$ref_5lfcib_1() {
    return function (p0) {
      return p0.ofr();
    };
  }
  function btbScopes$lambda$slambda_255($this_scopes, $objectPropertyDomainFilters$delegate, $nonGroupingFilters$delegate, resultContinuation) {
    this.ioh_1 = $this_scopes;
    this.joh_1 = $objectPropertyDomainFilters$delegate;
    this.koh_1 = $nonGroupingFilters$delegate;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_255).ooh = function ($this$provideLexicalScope, variable, $completion) {
    var tmp = this.poh($this$provideLexicalScope, variable, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_255).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.ooh(tmp, (!(p2 == null) ? isInterface(p2, VariableDeclaration_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_255).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 3;
            this.f9_1 = 1;
            suspendResult = this.loh_1.k60(filterByVariableSpecification(this.moh_1, invoke$lambda_2(this.ioh_1, this.joh_1)), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var typeFilter = suspendResult;
            var tmp_0 = this;
            var tmp_1;
            if (!(typeFilter == null)) {
              tmp_1 = new CompositeScopeFilter(listOf_0([typeFilter, invoke$lambda_3(this.ioh_1, this.koh_1).jnw()]));
            } else {
              tmp_1 = invoke$lambda_3(this.ioh_1, this.koh_1).jnw();
            }

            tmp_0.noh_1 = tmp_1;
            this.f9_1 = 2;
            suspendResult = this.loh_1.y77(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var ARGUMENT = suspendResult;
            return filter_1(ARGUMENT, this.noh_1);
          case 3:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 3) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_255).poh = function ($this$provideLexicalScope, variable, completion) {
    var i = new btbScopes$lambda$slambda_255(this.ioh_1, this.joh_1, this.koh_1, completion);
    i.loh_1 = $this$provideLexicalScope;
    i.moh_1 = variable;
    return i;
  };
  function btbScopes$lambda$slambda_256($this_scopes, $objectPropertyDomainFilters$delegate, $nonGroupingFilters$delegate, resultContinuation) {
    var i = new btbScopes$lambda$slambda_255($this_scopes, $objectPropertyDomainFilters$delegate, $nonGroupingFilters$delegate, resultContinuation);
    var l = function ($this$provideLexicalScope, variable, $completion) {
      return i.ooh($this$provideLexicalScope, variable, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda$slambda_35($variable, resultContinuation) {
    this.yoh_1 = $variable;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda$slambda_35).inx = function ($this$filter, it, $completion) {
    var tmp = this.jnx($this$filter, it, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda$slambda_35).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof QueryBuilder ? p1 : THROW_CCE();
    return this.inx(tmp, (!(p2 == null) ? isInterface(p2, VariableDeclaration_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda$slambda_35).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        if (tmp === 0) {
          this.g9_1 = 1;
          return !equals(this.aoi_1, this.yoh_1);
        } else if (tmp === 1) {
          throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda$slambda_35).jnx = function ($this$filter, it, completion) {
    var i = new btbScopes$lambda$slambda$slambda_35(this.yoh_1, completion);
    i.zoh_1 = $this$filter;
    i.aoi_1 = it;
    return i;
  };
  function btbScopes$lambda$slambda$slambda_36($variable, resultContinuation) {
    var i = new btbScopes$lambda$slambda$slambda_35($variable, resultContinuation);
    var l = function ($this$filter, it, $completion) {
      return i.inx($this$filter, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_257(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_257).loi = function ($this$provideLexicalScope, variable, $completion) {
    var tmp = this.moi($this$provideLexicalScope, variable, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_257).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.loi(tmp, (!(p2 == null) ? isInterface(p2, VariableDeclaration_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_257).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.joi_1.r77(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            return filter_0(ARGUMENT, btbScopes$lambda$slambda$slambda_36(this.koi_1, null));
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_257).moi = function ($this$provideLexicalScope, variable, completion) {
    var i = new btbScopes$lambda$slambda_257(completion);
    i.joi_1 = $this$provideLexicalScope;
    i.koi_1 = variable;
    return i;
  };
  function btbScopes$lambda$slambda_258(resultContinuation) {
    var i = new btbScopes$lambda$slambda_257(resultContinuation);
    var l = function ($this$provideLexicalScope, variable, $completion) {
      return i.loi($this$provideLexicalScope, variable, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function HasPropertyConstraints$_get_constraints_$ref_5lfcib_2() {
    return function (p0) {
      return p0.ofr();
    };
  }
  function btbScopes$lambda$slambda_259($this_scopes, $objectPropertyDomainFilters$delegate, $nonGroupingFilters$delegate, resultContinuation) {
    this.voi_1 = $this_scopes;
    this.woi_1 = $objectPropertyDomainFilters$delegate;
    this.xoi_1 = $nonGroupingFilters$delegate;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_259).eoj = function ($this$provideLexicalScope, constraint, $completion) {
    var tmp = this.foj($this$provideLexicalScope, constraint, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_259).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.eoj(tmp, (!(p2 == null) ? isInterface(p2, PropertyConstraint_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_259).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 10;
            if (!(this.yoi_1.l60(this.zoi_1.a1()) == null)) {
              var value = this.yoi_1.l60(this.zoi_1.a1());
              if (!(value == null) ? isInterface(value, OntologyElementReferenceValue_1) : false) {
                var tmp0_safe_receiver = this.yoi_1.l60(value.gfq());
                if (tmp0_safe_receiver == null) {
                  this.doj_1 = null;
                  this.f9_1 = 6;
                  continue $sm;
                } else {
                  this.f9_1 = 5;
                  suspendResult = this.yoi_1.k60(tmp0_safe_receiver.gfq(), this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  continue $sm;
                }
              } else {
                if (!(value == null) ? isInterface(value, MeasurableValue_1) : false) {
                  this.f9_1 = 4;
                  suspendResult = this.yoi_1.k60(value.zfr().x6o(), this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  continue $sm;
                } else {
                  if (!(value == null) ? isInterface(value, EnumValue_1) : false) {
                    this.f9_1 = 3;
                    suspendResult = this.yoi_1.k60(value.pfq().x6o(), this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) {
                      return suspendResult;
                    }
                    continue $sm;
                  } else {
                    this.coj_1 = null;
                    this.f9_1 = 7;
                    continue $sm;
                  }
                }
              }
            } else {
              if (!(this.yoi_1.l60(this.zoi_1.q6q().z6o()) == null)) {
                this.f9_1 = 2;
                suspendResult = this.yoi_1.w77(this.zoi_1.q6q(), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                this.f9_1 = 1;
                suspendResult = this.yoi_1.y77(this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              }
            }

          case 1:
            this.aoj_1 = suspendResult;
            this.f9_1 = 9;
            continue $sm;
          case 2:
            this.aoj_1 = suspendResult;
            this.f9_1 = 9;
            continue $sm;
          case 3:
            var tmp3_safe_receiver = suspendResult;
            var tmp_0;
            if (tmp3_safe_receiver == null) {
              tmp_0 = null;
            } else {
              tmp_0 = ancestorOrSelf(tmp3_safe_receiver, getKClass(EnumerableNotion_1));
            }

            var tmp4_safe_receiver = tmp_0;
            var notion = tmp4_safe_receiver == null ? null : this.yoi_1.l60(tmp4_safe_receiver);
            this.coj_1 = !(notion == null) ? invoke$lambda_2(this.voi_1, this.woi_1).goj(notion) : null;
            this.f9_1 = 7;
            continue $sm;
          case 4:
            var tmp1_safe_receiver = suspendResult;
            var tmp_1;
            if (tmp1_safe_receiver == null) {
              tmp_1 = null;
            } else {
              tmp_1 = ancestorOrSelf(tmp1_safe_receiver, getKClass(MeasurableNotion_1));
            }

            var tmp2_safe_receiver = tmp_1;
            var notion_0 = tmp2_safe_receiver == null ? null : this.yoi_1.l60(tmp2_safe_receiver);
            this.coj_1 = !(notion_0 == null) ? invoke$lambda_2(this.voi_1, this.woi_1).goj(notion_0) : null;
            this.f9_1 = 7;
            continue $sm;
          case 5:
            this.doj_1 = suspendResult;
            this.f9_1 = 6;
            continue $sm;
          case 6:
            var ontologyElement = this.doj_1;
            this.coj_1 = !(ontologyElement == null) ? invoke$lambda_2(this.voi_1, this.woi_1).cml(setOf(ontologyElement)) : null;
            this.f9_1 = 7;
            continue $sm;
          case 7:
            this.boj_1 = this.coj_1;
            this.f9_1 = 8;
            suspendResult = this.yoi_1.y77(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 8:
            var ARGUMENT = suspendResult;
            var tmp_2 = this;
            var tmp5_elvis_lhs = this.boj_1;
            tmp_2.aoj_1 = filter_1(ARGUMENT, tmp5_elvis_lhs == null ? NoopScopeFilter_instance : tmp5_elvis_lhs);
            this.f9_1 = 9;
            continue $sm;
          case 9:
            var scope = this.aoj_1;
            return filter_1(scope, invoke$lambda_3(this.voi_1, this.xoi_1).jnw());
          case 10:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 10) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_259).foj = function ($this$provideLexicalScope, constraint, completion) {
    var i = new btbScopes$lambda$slambda_259(this.voi_1, this.woi_1, this.xoi_1, completion);
    i.yoi_1 = $this$provideLexicalScope;
    i.zoi_1 = constraint;
    return i;
  };
  function btbScopes$lambda$slambda_260($this_scopes, $objectPropertyDomainFilters$delegate, $nonGroupingFilters$delegate, resultContinuation) {
    var i = new btbScopes$lambda$slambda_259($this_scopes, $objectPropertyDomainFilters$delegate, $nonGroupingFilters$delegate, resultContinuation);
    var l = function ($this$provideLexicalScope, constraint, $completion) {
      return i.eoj($this$provideLexicalScope, constraint, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function HasPropertyConstraints$_get_constraints_$ref_5lfcib_3() {
    return function (p0) {
      return p0.ofr();
    };
  }
  function btbScopes$lambda$slambda_261($this_scopes, $nonGroupingFilters$delegate, $objectPropertyDomainFilters$delegate, resultContinuation) {
    this.poj_1 = $this_scopes;
    this.qoj_1 = $nonGroupingFilters$delegate;
    this.roj_1 = $objectPropertyDomainFilters$delegate;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_261).yoj = function ($this$provideLexicalScope, definition, $completion) {
    var tmp = this.zoj($this$provideLexicalScope, definition, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_261).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.yoj(tmp, (!(p2 == null) ? isInterface(p2, OntologyElementDefinition_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_261).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 7;
            var tmp0_safe_receiver = this.soj_1.l60(this.toj_1.hfq());
            var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.eib();
            if (tmp1_safe_receiver == null) {
              this.xoj_1 = null;
              this.f9_1 = 2;
              continue $sm;
            } else {
              this.f9_1 = 1;
              suspendResult = this.soj_1.k60(tmp1_safe_receiver, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            this.xoj_1 = suspendResult;
            this.f9_1 = 2;
            continue $sm;
          case 2:
            var tmp2_safe_receiver = this.xoj_1;
            if (tmp2_safe_receiver == null) {
              this.voj_1 = null;
              this.f9_1 = 5;
              continue $sm;
            } else {
              if (isInterface(tmp2_safe_receiver, UnionClass_1)) {
                this.f9_1 = 3;
                suspendResult = this.soj_1.k60(getAssertedDefinitionElements_0(ontologyElementHierarchy(), tmp2_safe_receiver), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                if (isInterface(tmp2_safe_receiver, OntologyElement_1)) {
                  this.woj_1 = setOf(tmp2_safe_receiver);
                  this.f9_1 = 4;
                  continue $sm;
                } else {
                  var tmp_0 = this;
                  noWhenBranchMatchedException();
                }
              }
            }

            break;
          case 3:
            this.woj_1 = suspendResult;
            this.f9_1 = 4;
            continue $sm;
          case 4:
            var elements = this.woj_1;
            this.voj_1 = new CompositeScopeFilter(listOf_0([invoke$lambda_3(this.poj_1, this.qoj_1).jnw(), invoke$lambda_2(this.poj_1, this.roj_1).cml(elements)]));
            this.f9_1 = 5;
            continue $sm;
          case 5:
            var tmp3_elvis_lhs = this.voj_1;
            this.uoj_1 = tmp3_elvis_lhs == null ? invoke$lambda_3(this.poj_1, this.qoj_1).jnw() : tmp3_elvis_lhs;
            this.f9_1 = 6;
            suspendResult = this.soj_1.y77(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 6:
            var ARGUMENT = suspendResult;
            return filter_1(ARGUMENT, this.uoj_1);
          case 7:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 7) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_261).zoj = function ($this$provideLexicalScope, definition, completion) {
    var i = new btbScopes$lambda$slambda_261(this.poj_1, this.qoj_1, this.roj_1, completion);
    i.soj_1 = $this$provideLexicalScope;
    i.toj_1 = definition;
    return i;
  };
  function btbScopes$lambda$slambda_262($this_scopes, $nonGroupingFilters$delegate, $objectPropertyDomainFilters$delegate, resultContinuation) {
    var i = new btbScopes$lambda$slambda_261($this_scopes, $nonGroupingFilters$delegate, $objectPropertyDomainFilters$delegate, resultContinuation);
    var l = function ($this$provideLexicalScope, definition, $completion) {
      return i.yoj($this$provideLexicalScope, definition, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_263(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_263).pok = function ($this$provideLexicalScope, valueWithProperties, $completion) {
    var tmp = this.qok($this$provideLexicalScope, valueWithProperties, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_263).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.pok(tmp, (!(p2 == null) ? isInterface(p2, ValueWithRelations) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_263).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 9;
            var value = this.iok_1.l60(this.jok_1.a1());
            if (!(value == null) ? isInterface(value, OntologyElementReferenceValueLibrary_1) : false) {
              var tmp0_safe_receiver = this.iok_1.l60(value.gfq());
              if (tmp0_safe_receiver == null) {
                this.mok_1 = null;
                this.f9_1 = 6;
                continue $sm;
              } else {
                this.f9_1 = 5;
                suspendResult = this.iok_1.k60(tmp0_safe_receiver.gfq(), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              }
            } else {
              var tmp_0;
              if (!(value == null) ? isInterface(value, MeasurableValue_1) : false) {
                tmp_0 = true;
              } else {
                tmp_0 = !(value == null) ? isInterface(value, EnumValue_1) : false;
              }
              if (tmp_0) {
                var this_0 = this.jok_1;
                var tmp2_safe_receiver = this.iok_1.l60(ancestorOrSelf(this_0, getKClass(ProcessPropertyValue_1)));
                if (tmp2_safe_receiver == null) {
                  this.ook_1 = null;
                  this.f9_1 = 2;
                  continue $sm;
                } else {
                  this.f9_1 = 1;
                  suspendResult = this.iok_1.k60(tmp2_safe_receiver.q6q(), this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  continue $sm;
                }
              } else {
                this.lok_1 = null;
                this.f9_1 = 7;
                continue $sm;
              }
            }

          case 1:
            this.ook_1 = suspendResult;
            this.f9_1 = 2;
            continue $sm;
          case 2:
            var tmp3_safe_receiver = this.ook_1;
            var tmp4_safe_receiver = tmp3_safe_receiver == null ? null : this.iok_1.l60(tmp3_safe_receiver.sfq());
            var tmp_1 = tmp4_safe_receiver == null ? null : this.iok_1.l60(tmp4_safe_receiver.sfq());
            var type = (!(tmp_1 == null) ? isInterface(tmp_1, SimplePropertyType) : false) ? tmp_1 : null;
            if (type == null) {
              this.nok_1 = null;
              this.f9_1 = 4;
              continue $sm;
            } else {
              this.f9_1 = 3;
              suspendResult = this.iok_1.k60(type.mfq(), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 3:
            this.nok_1 = suspendResult;
            this.f9_1 = 4;
            continue $sm;
          case 4:
            var tmp6_safe_receiver = this.nok_1;
            var tmp_2 = this;
            var tmp_3;
            if (tmp6_safe_receiver == null) {
              tmp_3 = null;
            } else {
              tmp_3 = filterInstanceRelations_0(tmp6_safe_receiver);
            }

            tmp_2.lok_1 = tmp_3;
            this.f9_1 = 7;
            continue $sm;
          case 5:
            this.mok_1 = suspendResult;
            this.f9_1 = 6;
            continue $sm;
          case 6:
            var tmp1_safe_receiver = this.mok_1;
            var tmp_4 = this;
            var tmp_5;
            if (tmp1_safe_receiver == null) {
              tmp_5 = null;
            } else {
              tmp_5 = filterInstanceRelations(setOf(tmp1_safe_receiver));
            }

            tmp_4.lok_1 = tmp_5;
            this.f9_1 = 7;
            continue $sm;
          case 7:
            this.kok_1 = this.lok_1;
            this.f9_1 = 8;
            suspendResult = this.iok_1.r77(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 8:
            var ARGUMENT = suspendResult;
            var tmp7_elvis_lhs = this.kok_1;
            return filter_1(ARGUMENT, tmp7_elvis_lhs == null ? NoopScopeFilter_instance : tmp7_elvis_lhs);
          case 9:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 9) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_263).qok = function ($this$provideLexicalScope, valueWithProperties, completion) {
    var i = new btbScopes$lambda$slambda_263(completion);
    i.iok_1 = $this$provideLexicalScope;
    i.jok_1 = valueWithProperties;
    return i;
  };
  function btbScopes$lambda$slambda_264(resultContinuation) {
    var i = new btbScopes$lambda$slambda_263(resultContinuation);
    var l = function ($this$provideLexicalScope, valueWithProperties, $completion) {
      return i.pok($this$provideLexicalScope, valueWithProperties, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_265(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_265).bol = function ($this$provideImportScope, it, $completion) {
    var tmp = this.col($this$provideImportScope, it, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_265).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.bol(tmp, (!(p2 == null) ? isInterface(p2, ProcessLibrary_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_265).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.zok_1.u77(this.aol_1.xft(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_265).col = function ($this$provideImportScope, it, completion) {
    var i = new btbScopes$lambda$slambda_265(completion);
    i.zok_1 = $this$provideImportScope;
    i.aol_1 = it;
    return i;
  };
  function btbScopes$lambda$slambda_266(resultContinuation) {
    var i = new btbScopes$lambda$slambda_265(resultContinuation);
    var l = function ($this$provideImportScope, it, $completion) {
      return i.bol($this$provideImportScope, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda$slambda_37(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda$slambda_37).fo2 = function ($this$filter, it, $completion) {
    var tmp = this.go2($this$filter, it, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda$slambda_37).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof QueryBuilder ? p1 : THROW_CCE();
    return this.fo2(tmp, !(p2 == null) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda$slambda_37).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        if (tmp === 0) {
          this.g9_1 = 1;
          var tmp_0 = this.mol_1;
          return isInterface(tmp_0, ObjectPropertyDeclaration_1);
        } else if (tmp === 1) {
          throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda$slambda_37).go2 = function ($this$filter, it, completion) {
    var i = new btbScopes$lambda$slambda$slambda_37(completion);
    i.lol_1 = $this$filter;
    i.mol_1 = it;
    return i;
  };
  function btbScopes$lambda$slambda$slambda_38(resultContinuation) {
    var i = new btbScopes$lambda$slambda$slambda_37(resultContinuation);
    var l = function ($this$filter, it, $completion) {
      return i.fo2($this$filter, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_267(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_267).xol = function ($this$provideImportScope, it, $completion) {
    var tmp = this.yol($this$provideImportScope, it, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_267).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.xol(tmp, (!(p2 == null) ? isInterface(p2, ObjectPropertiesLibrary) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_267).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.vol_1.u77(this.wol_1.rfp(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var this_0 = suspendResult;
            var tmp_0 = filter_0(this_0, btbScopes$lambda$slambda$slambda_38(null));
            return isInterface(tmp_0, Scope) ? tmp_0 : THROW_CCE();
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_267).yol = function ($this$provideImportScope, it, completion) {
    var i = new btbScopes$lambda$slambda_267(completion);
    i.vol_1 = $this$provideImportScope;
    i.wol_1 = it;
    return i;
  };
  function btbScopes$lambda$slambda_268(resultContinuation) {
    var i = new btbScopes$lambda$slambda_267(resultContinuation);
    var l = function ($this$provideImportScope, it, $completion) {
      return i.xol($this$provideImportScope, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_269(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_269).jom = function ($this$provideImportScope, it, $completion) {
    var tmp = this.kom($this$provideImportScope, it, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_269).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.jom(tmp, (!(p2 == null) ? isInterface(p2, RelationContainer_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_269).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.hom_1.u77(this.iom_1.jfu(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_269).kom = function ($this$provideImportScope, it, completion) {
    var i = new btbScopes$lambda$slambda_269(completion);
    i.hom_1 = $this$provideImportScope;
    i.iom_1 = it;
    return i;
  };
  function btbScopes$lambda$slambda_270(resultContinuation) {
    var i = new btbScopes$lambda$slambda_269(resultContinuation);
    var l = function ($this$provideImportScope, it, $completion) {
      return i.jom($this$provideImportScope, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_271(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_271).vom = function ($this$provideImportScope, it, $completion) {
    var tmp = this.wom($this$provideImportScope, it, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_271).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.vom(tmp, (!(p2 == null) ? isInterface(p2, RelationContainer_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_271).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.tom_1.u77(this.uom_1.kfu(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_271).wom = function ($this$provideImportScope, it, completion) {
    var i = new btbScopes$lambda$slambda_271(completion);
    i.tom_1 = $this$provideImportScope;
    i.uom_1 = it;
    return i;
  };
  function btbScopes$lambda$slambda_272(resultContinuation) {
    var i = new btbScopes$lambda$slambda_271(resultContinuation);
    var l = function ($this$provideImportScope, it, $completion) {
      return i.vom($this$provideImportScope, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_273(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_273).hon = function ($this$provideImportScope, it, $completion) {
    var tmp = this.ion($this$provideImportScope, it, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_273).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.hon(tmp, (!(p2 == null) ? isInterface(p2, ModifierContainer) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_273).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.fon_1.u77(this.gon_1.l8j(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_273).ion = function ($this$provideImportScope, it, completion) {
    var i = new btbScopes$lambda$slambda_273(completion);
    i.fon_1 = $this$provideImportScope;
    i.gon_1 = it;
    return i;
  };
  function btbScopes$lambda$slambda_274(resultContinuation) {
    var i = new btbScopes$lambda$slambda_273(resultContinuation);
    var l = function ($this$provideImportScope, it, $completion) {
      return i.hon($this$provideImportScope, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_275(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_275).ton = function ($this$provideImportScope, it, $completion) {
    var tmp = this.uon($this$provideImportScope, it, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_275).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.ton(tmp, (!(p2 == null) ? isInterface(p2, FunctionLibrary_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_275).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.ron_1.u77(this.son_1.hfr(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_275).uon = function ($this$provideImportScope, it, completion) {
    var i = new btbScopes$lambda$slambda_275(completion);
    i.ron_1 = $this$provideImportScope;
    i.son_1 = it;
    return i;
  };
  function btbScopes$lambda$slambda_276(resultContinuation) {
    var i = new btbScopes$lambda$slambda_275(resultContinuation);
    var l = function ($this$provideImportScope, it, $completion) {
      return i.ton($this$provideImportScope, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_277(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_277).foo = function ($this$provideImportScope, it, $completion) {
    var tmp = this.goo($this$provideImportScope, it, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_277).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.foo(tmp, (!(p2 == null) ? isInterface(p2, ProcessKindContainer_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_277).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.doo_1.u77(this.eoo_1.wft(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_277).goo = function ($this$provideImportScope, it, completion) {
    var i = new btbScopes$lambda$slambda_277(completion);
    i.doo_1 = $this$provideImportScope;
    i.eoo_1 = it;
    return i;
  };
  function btbScopes$lambda$slambda_278(resultContinuation) {
    var i = new btbScopes$lambda$slambda_277(resultContinuation);
    var l = function ($this$provideImportScope, it, $completion) {
      return i.foo($this$provideImportScope, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_279(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_279).roo = function ($this$provideImportScope, it, $completion) {
    var tmp = this.soo($this$provideImportScope, it, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_279).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.roo(tmp, (!(p2 == null) ? isInterface(p2, LinkLibrary_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_279).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.poo_1.u77(this.qoo_1.wfr(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_279).soo = function ($this$provideImportScope, it, completion) {
    var i = new btbScopes$lambda$slambda_279(completion);
    i.poo_1 = $this$provideImportScope;
    i.qoo_1 = it;
    return i;
  };
  function btbScopes$lambda$slambda_280(resultContinuation) {
    var i = new btbScopes$lambda$slambda_279(resultContinuation);
    var l = function ($this$provideImportScope, it, $completion) {
      return i.roo($this$provideImportScope, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda$slambda_39(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda$slambda_39).fo2 = function ($this$filter, it, $completion) {
    var tmp = this.go2($this$filter, it, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda$slambda_39).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof QueryBuilder ? p1 : THROW_CCE();
    return this.fo2(tmp, !(p2 == null) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda$slambda_39).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        if (tmp === 0) {
          this.g9_1 = 1;
          var tmp_0 = this.cop_1;
          return isInterface(tmp_0, PropertyDeclaration_1);
        } else if (tmp === 1) {
          throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda$slambda_39).go2 = function ($this$filter, it, completion) {
    var i = new btbScopes$lambda$slambda$slambda_39(completion);
    i.bop_1 = $this$filter;
    i.cop_1 = it;
    return i;
  };
  function btbScopes$lambda$slambda$slambda_40(resultContinuation) {
    var i = new btbScopes$lambda$slambda$slambda_39(resultContinuation);
    var l = function ($this$filter, it, $completion) {
      return i.fo2($this$filter, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_281(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_281).nop = function ($this$provideImportScope, it, $completion) {
    var tmp = this.oop($this$provideImportScope, it, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_281).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.nop(tmp, (!(p2 == null) ? isInterface(p2, PropertyLibrary_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_281).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.lop_1.u77(this.mop_1.ifq(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var this_0 = suspendResult;
            var tmp_0 = filter_0(this_0, btbScopes$lambda$slambda$slambda_40(null));
            return isInterface(tmp_0, Scope) ? tmp_0 : THROW_CCE();
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_281).oop = function ($this$provideImportScope, it, completion) {
    var i = new btbScopes$lambda$slambda_281(completion);
    i.lop_1 = $this$provideImportScope;
    i.mop_1 = it;
    return i;
  };
  function btbScopes$lambda$slambda_282(resultContinuation) {
    var i = new btbScopes$lambda$slambda_281(resultContinuation);
    var l = function ($this$provideImportScope, it, $completion) {
      return i.nop($this$provideImportScope, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_283(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_283).zop = function ($this$provideImportScope, it, $completion) {
    var tmp = this.aoq($this$provideImportScope, it, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_283).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.zop(tmp, (!(p2 == null) ? isInterface(p2, NotionLibrary_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_283).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.xop_1.u77(this.yop_1.efs(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_283).aoq = function ($this$provideImportScope, it, completion) {
    var i = new btbScopes$lambda$slambda_283(completion);
    i.xop_1 = $this$provideImportScope;
    i.yop_1 = it;
    return i;
  };
  function btbScopes$lambda$slambda_284(resultContinuation) {
    var i = new btbScopes$lambda$slambda_283(resultContinuation);
    var l = function ($this$provideImportScope, it, $completion) {
      return i.zop($this$provideImportScope, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_285(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_285).loq = function ($this$provideImportScope, it, $completion) {
    var tmp = this.moq($this$provideImportScope, it, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_285).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.loq(tmp, (!(p2 == null) ? isInterface(p2, PublishedSourcesLibrary_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_285).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.joq_1.u77(this.koq_1.l2n(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_285).moq = function ($this$provideImportScope, it, completion) {
    var i = new btbScopes$lambda$slambda_285(completion);
    i.joq_1 = $this$provideImportScope;
    i.koq_1 = it;
    return i;
  };
  function btbScopes$lambda$slambda_286(resultContinuation) {
    var i = new btbScopes$lambda$slambda_285(resultContinuation);
    var l = function ($this$provideImportScope, it, $completion) {
      return i.loq($this$provideImportScope, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_287($this_scopes, $librariesScopeProvider$delegate, resultContinuation) {
    this.voq_1 = $this_scopes;
    this.woq_1 = $librariesScopeProvider$delegate;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_287).yoq = function ($this$defaultScope, $completion) {
    var tmp = this.zoq($this$defaultScope, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_287).v9 = function (p1, $completion) {
    return this.yoq(p1 instanceof ScopeBuilder ? p1 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_287).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = libraryElementsScope(this.xoq_1, invoke$lambda(this.voq_1, this.woq_1), ProcessLibraryConcept_getInstance(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_287).zoq = function ($this$defaultScope, completion) {
    var i = new btbScopes$lambda$slambda_287(this.voq_1, this.woq_1, completion);
    i.xoq_1 = $this$defaultScope;
    return i;
  };
  function btbScopes$lambda$slambda_288($this_scopes, $librariesScopeProvider$delegate, resultContinuation) {
    var i = new btbScopes$lambda$slambda_287($this_scopes, $librariesScopeProvider$delegate, resultContinuation);
    var l = function ($this$defaultScope, $completion) {
      return i.yoq($this$defaultScope, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function btbScopes$lambda$slambda_289($this_scopes, $librariesScopeProvider$delegate, resultContinuation) {
    this.ior_1 = $this_scopes;
    this.jor_1 = $librariesScopeProvider$delegate;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_289).lor = function ($this$defaultScope, $completion) {
    var tmp = this.mor($this$defaultScope, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_289).v9 = function (p1, $completion) {
    return this.lor(p1 instanceof ScopeBuilder ? p1 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_289).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = libraryElementsScope(this.kor_1, invoke$lambda(this.ior_1, this.jor_1), ObjectPropertiesLibraryConcept_getInstance(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_289).mor = function ($this$defaultScope, completion) {
    var i = new btbScopes$lambda$slambda_289(this.ior_1, this.jor_1, completion);
    i.kor_1 = $this$defaultScope;
    return i;
  };
  function btbScopes$lambda$slambda_290($this_scopes, $librariesScopeProvider$delegate, resultContinuation) {
    var i = new btbScopes$lambda$slambda_289($this_scopes, $librariesScopeProvider$delegate, resultContinuation);
    var l = function ($this$defaultScope, $completion) {
      return i.lor($this$defaultScope, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function btbScopes$lambda$slambda_291($this_scopes, $librariesScopeProvider$delegate, resultContinuation) {
    this.vor_1 = $this_scopes;
    this.wor_1 = $librariesScopeProvider$delegate;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_291).yor = function ($this$defaultScope, $completion) {
    var tmp = this.zor($this$defaultScope, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_291).v9 = function (p1, $completion) {
    return this.yor(p1 instanceof ScopeBuilder ? p1 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_291).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = libraryElementsScope(this.xor_1, invoke$lambda(this.vor_1, this.wor_1), RelationContainerConcept_getInstance(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_291).zor = function ($this$defaultScope, completion) {
    var i = new btbScopes$lambda$slambda_291(this.vor_1, this.wor_1, completion);
    i.xor_1 = $this$defaultScope;
    return i;
  };
  function btbScopes$lambda$slambda_292($this_scopes, $librariesScopeProvider$delegate, resultContinuation) {
    var i = new btbScopes$lambda$slambda_291($this_scopes, $librariesScopeProvider$delegate, resultContinuation);
    var l = function ($this$defaultScope, $completion) {
      return i.yor($this$defaultScope, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function btbScopes$lambda$slambda_293($this_scopes, $librariesScopeProvider$delegate, resultContinuation) {
    this.ios_1 = $this_scopes;
    this.jos_1 = $librariesScopeProvider$delegate;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_293).los = function ($this$defaultScope, $completion) {
    var tmp = this.mos($this$defaultScope, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_293).v9 = function (p1, $completion) {
    return this.los(p1 instanceof ScopeBuilder ? p1 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_293).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = libraryElementsScope(this.kos_1, invoke$lambda(this.ios_1, this.jos_1), RelationContainerConcept_getInstance(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_293).mos = function ($this$defaultScope, completion) {
    var i = new btbScopes$lambda$slambda_293(this.ios_1, this.jos_1, completion);
    i.kos_1 = $this$defaultScope;
    return i;
  };
  function btbScopes$lambda$slambda_294($this_scopes, $librariesScopeProvider$delegate, resultContinuation) {
    var i = new btbScopes$lambda$slambda_293($this_scopes, $librariesScopeProvider$delegate, resultContinuation);
    var l = function ($this$defaultScope, $completion) {
      return i.los($this$defaultScope, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function btbScopes$lambda$slambda_295($this_scopes, $librariesScopeProvider$delegate, resultContinuation) {
    this.vos_1 = $this_scopes;
    this.wos_1 = $librariesScopeProvider$delegate;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_295).yos = function ($this$defaultScope, $completion) {
    var tmp = this.zos($this$defaultScope, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_295).v9 = function (p1, $completion) {
    return this.yos(p1 instanceof ScopeBuilder ? p1 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_295).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = libraryElementsScope(this.xos_1, invoke$lambda(this.vos_1, this.wos_1), ModifierContainerConcept_getInstance(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_295).zos = function ($this$defaultScope, completion) {
    var i = new btbScopes$lambda$slambda_295(this.vos_1, this.wos_1, completion);
    i.xos_1 = $this$defaultScope;
    return i;
  };
  function btbScopes$lambda$slambda_296($this_scopes, $librariesScopeProvider$delegate, resultContinuation) {
    var i = new btbScopes$lambda$slambda_295($this_scopes, $librariesScopeProvider$delegate, resultContinuation);
    var l = function ($this$defaultScope, $completion) {
      return i.yos($this$defaultScope, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function btbScopes$lambda$slambda_297($this_scopes, $librariesScopeProvider$delegate, resultContinuation) {
    this.iot_1 = $this_scopes;
    this.jot_1 = $librariesScopeProvider$delegate;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_297).lot = function ($this$defaultScope, $completion) {
    var tmp = this.mot($this$defaultScope, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_297).v9 = function (p1, $completion) {
    return this.lot(p1 instanceof ScopeBuilder ? p1 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_297).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = libraryElementsScope(this.kot_1, invoke$lambda(this.iot_1, this.jot_1), FunctionLibraryConcept_getInstance(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_297).mot = function ($this$defaultScope, completion) {
    var i = new btbScopes$lambda$slambda_297(this.iot_1, this.jot_1, completion);
    i.kot_1 = $this$defaultScope;
    return i;
  };
  function btbScopes$lambda$slambda_298($this_scopes, $librariesScopeProvider$delegate, resultContinuation) {
    var i = new btbScopes$lambda$slambda_297($this_scopes, $librariesScopeProvider$delegate, resultContinuation);
    var l = function ($this$defaultScope, $completion) {
      return i.lot($this$defaultScope, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function btbScopes$lambda$slambda_299($this_scopes, $librariesScopeProvider$delegate, resultContinuation) {
    this.vot_1 = $this_scopes;
    this.wot_1 = $librariesScopeProvider$delegate;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_299).yot = function ($this$defaultScope, $completion) {
    var tmp = this.zot($this$defaultScope, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_299).v9 = function (p1, $completion) {
    return this.yot(p1 instanceof ScopeBuilder ? p1 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_299).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = libraryElementsScope(this.xot_1, invoke$lambda(this.vot_1, this.wot_1), ProcessKindContainerConcept_getInstance(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_299).zot = function ($this$defaultScope, completion) {
    var i = new btbScopes$lambda$slambda_299(this.vot_1, this.wot_1, completion);
    i.xot_1 = $this$defaultScope;
    return i;
  };
  function btbScopes$lambda$slambda_300($this_scopes, $librariesScopeProvider$delegate, resultContinuation) {
    var i = new btbScopes$lambda$slambda_299($this_scopes, $librariesScopeProvider$delegate, resultContinuation);
    var l = function ($this$defaultScope, $completion) {
      return i.yot($this$defaultScope, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function btbScopes$lambda$slambda_301($this_scopes, $librariesScopeProvider$delegate, resultContinuation) {
    this.iou_1 = $this_scopes;
    this.jou_1 = $librariesScopeProvider$delegate;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_301).lou = function ($this$defaultScope, $completion) {
    var tmp = this.mou($this$defaultScope, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_301).v9 = function (p1, $completion) {
    return this.lou(p1 instanceof ScopeBuilder ? p1 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_301).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = libraryElementsScope(this.kou_1, invoke$lambda(this.iou_1, this.jou_1), LinkLibraryConcept_getInstance(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_301).mou = function ($this$defaultScope, completion) {
    var i = new btbScopes$lambda$slambda_301(this.iou_1, this.jou_1, completion);
    i.kou_1 = $this$defaultScope;
    return i;
  };
  function btbScopes$lambda$slambda_302($this_scopes, $librariesScopeProvider$delegate, resultContinuation) {
    var i = new btbScopes$lambda$slambda_301($this_scopes, $librariesScopeProvider$delegate, resultContinuation);
    var l = function ($this$defaultScope, $completion) {
      return i.lou($this$defaultScope, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function btbScopes$lambda$slambda_303($this_scopes, $librariesScopeProvider$delegate, resultContinuation) {
    this.vou_1 = $this_scopes;
    this.wou_1 = $librariesScopeProvider$delegate;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_303).you = function ($this$defaultScope, $completion) {
    var tmp = this.zou($this$defaultScope, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_303).v9 = function (p1, $completion) {
    return this.you(p1 instanceof ScopeBuilder ? p1 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_303).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = libraryElementsScope(this.xou_1, invoke$lambda(this.vou_1, this.wou_1), PropertyLibraryConcept_getInstance(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_303).zou = function ($this$defaultScope, completion) {
    var i = new btbScopes$lambda$slambda_303(this.vou_1, this.wou_1, completion);
    i.xou_1 = $this$defaultScope;
    return i;
  };
  function btbScopes$lambda$slambda_304($this_scopes, $librariesScopeProvider$delegate, resultContinuation) {
    var i = new btbScopes$lambda$slambda_303($this_scopes, $librariesScopeProvider$delegate, resultContinuation);
    var l = function ($this$defaultScope, $completion) {
      return i.you($this$defaultScope, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function btbScopes$lambda$slambda_305($this_scopes, $librariesScopeProvider$delegate, resultContinuation) {
    this.iov_1 = $this_scopes;
    this.jov_1 = $librariesScopeProvider$delegate;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_305).lov = function ($this$defaultScope, $completion) {
    var tmp = this.mov($this$defaultScope, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_305).v9 = function (p1, $completion) {
    return this.lov(p1 instanceof ScopeBuilder ? p1 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_305).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = libraryElementsScope(this.kov_1, invoke$lambda(this.iov_1, this.jov_1), NotionLibraryConcept_getInstance(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_305).mov = function ($this$defaultScope, completion) {
    var i = new btbScopes$lambda$slambda_305(this.iov_1, this.jov_1, completion);
    i.kov_1 = $this$defaultScope;
    return i;
  };
  function btbScopes$lambda$slambda_306($this_scopes, $librariesScopeProvider$delegate, resultContinuation) {
    var i = new btbScopes$lambda$slambda_305($this_scopes, $librariesScopeProvider$delegate, resultContinuation);
    var l = function ($this$defaultScope, $completion) {
      return i.lov($this$defaultScope, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function btbScopes$lambda$slambda_307($this_scopes, $librariesScopeProvider$delegate, resultContinuation) {
    this.vov_1 = $this_scopes;
    this.wov_1 = $librariesScopeProvider$delegate;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_307).yov = function ($this$defaultScope, $completion) {
    var tmp = this.zov($this$defaultScope, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_307).v9 = function (p1, $completion) {
    return this.yov(p1 instanceof ScopeBuilder ? p1 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_307).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = libraryElementsScope(this.xov_1, invoke$lambda(this.vov_1, this.wov_1), PublishedSourcesLibraryConcept_getInstance(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_307).zov = function ($this$defaultScope, completion) {
    var i = new btbScopes$lambda$slambda_307(this.vov_1, this.wov_1, completion);
    i.xov_1 = $this$defaultScope;
    return i;
  };
  function btbScopes$lambda$slambda_308($this_scopes, $librariesScopeProvider$delegate, resultContinuation) {
    var i = new btbScopes$lambda$slambda_307($this_scopes, $librariesScopeProvider$delegate, resultContinuation);
    var l = function ($this$defaultScope, $completion) {
      return i.yov($this$defaultScope, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function btbScopes$lambda$slambda_309($this_scopes, $librariesScopeProvider$delegate, resultContinuation) {
    this.iow_1 = $this_scopes;
    this.jow_1 = $librariesScopeProvider$delegate;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_309).low = function ($this$defaultScope, $completion) {
    var tmp = this.mow($this$defaultScope, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$lambda$slambda_309).v9 = function (p1, $completion) {
    return this.low(p1 instanceof ScopeBuilder ? p1 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_309).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = librariesScope(this.kow_1, invoke$lambda(this.iow_1, this.jow_1), OntologyImportRootConcept_getInstance(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_309).mow = function ($this$defaultScope, completion) {
    var i = new btbScopes$lambda$slambda_309(this.iow_1, this.jow_1, completion);
    i.kow_1 = $this$defaultScope;
    return i;
  };
  function btbScopes$lambda$slambda_310($this_scopes, $librariesScopeProvider$delegate, resultContinuation) {
    var i = new btbScopes$lambda$slambda_309($this_scopes, $librariesScopeProvider$delegate, resultContinuation);
    var l = function ($this$defaultScope, $completion) {
      return i.low($this$defaultScope, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function btbScopes$lambda$lambda(element) {
    _init_properties_BTBResolvers_kt__y423vn();
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new btbScopes$2$336$$inlined$suspendingQuery$1(element);
  }
  function $runSuspendCOROUTINE$_74(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.vow_1 = _this__u8e3s4;
    this.wow_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_74).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            var $this$suspendingQuery = this.wow_1;
            var tmp_0 = this;
            tmp_0.xow_1 = $this$suspendingQuery;
            this.f9_1 = 1;
            suspendResult = $this$suspendingQuery.k60(this.vow_1.yow_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp2 = suspendResult;
            var $this$flatMap = this.xow_1;
            var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp2, 10));
            var _iterator__ex2g4s = tmp2.m();
            while (_iterator__ex2g4s.n()) {
              var item = _iterator__ex2g4s.o();
              destination.j($this$flatMap.l60(item.y2()));
            }

            return destination;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function btbScopes$2$336$$inlined$suspendingQuery$1$runSuspend$2($this) {
    this.yow_1 = $this;
  }
  protoOf(btbScopes$2$336$$inlined$suspendingQuery$1$runSuspend$2).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_74(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$2$336$$inlined$suspendingQuery$1$runSuspend$2).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function $runSuspendCOROUTINE$_75(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.hox_1 = _this__u8e3s4;
    this.iox_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_75).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 8;
            this.kox_1 = this.iox_1;
            var this_0 = this.kox_1.l60(this.hox_1.qox_1.rfs());
            var tmp_0;
            if (isBlank(this_0)) {
              tmp_0 = null;
            } else {
              tmp_0 = this_0;
            }

            var tmp0_elvis_lhs = tmp_0;
            if (tmp0_elvis_lhs == null) {
              var tmp_1 = this;
              tmp_1.pox_1 = this.kox_1;
              this.mox_1 = Unit_instance;
              this.f9_1 = 1;
              continue $sm;
            } else {
              this.lox_1 = tmp0_elvis_lhs;
              this.f9_1 = 6;
              continue $sm;
            }

          case 1:
            this.nox_1 = this.pox_1;
            var tmp_2 = get_ONTOLOGIES_WITH_SPECIES();
            var tmp_3 = this.hox_1.qox_1.t42();
            var tmp0_safe_receiver = (!(tmp_3 == null) ? isInterface(tmp_3, OntologyLibrary_1) : false) ? tmp_3 : null;
            if (!contains_5(tmp_2, tmp0_safe_receiver == null ? null : this.nox_1.l60(tmp0_safe_receiver.y2()))) {
              this.mox_1 = null;
              this.f9_1 = 5;
              continue $sm;
            } else {
              this.f9_1 = 2;
              continue $sm;
            }

          case 2:
            var taxon = this.nox_1.l60(this.hox_1.qox_1.pfs());
            var tmp_4;
            if (!(taxon == null) ? isInterface(taxon, UnionClass_1) : false) {
              var tmp0 = this.nox_1.l60(taxon.mfu());
              var destination = ArrayList_init_$Create$();
              var _iterator__ex2g4s = tmp0.m();
              while (_iterator__ex2g4s.n()) {
                var element = _iterator__ex2g4s.o();
                if (!(element == null) ? isInterface(element, OntologyElementReferenceProvider) : false) {
                  destination.j(element);
                }
              }
              tmp_4 = firstOrNull_1(destination);
            } else {
              if (!(taxon == null) ? isInterface(taxon, OntologyElementReferenceProvider) : false) {
                tmp_4 = taxon;
              } else {
                tmp_4 = null;
              }
            }

            var tmp1_safe_receiver = tmp_4;
            var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.gfq();
            if (tmp2_safe_receiver == null) {
              this.oox_1 = null;
              this.f9_1 = 4;
              continue $sm;
            } else {
              this.f9_1 = 3;
              suspendResult = this.nox_1.k60(tmp2_safe_receiver, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 3:
            this.oox_1 = suspendResult;
            this.f9_1 = 4;
            continue $sm;
          case 4:
            var tmp3_safe_receiver = this.oox_1;
            this.mox_1 = tmp3_safe_receiver == null ? null : this.nox_1.l60(tmp3_safe_receiver.y2());
            if (false) {
              this.f9_1 = 1;
              continue $sm;
            }

            this.f9_1 = 5;
            continue $sm;
          case 5:
            this.lox_1 = this.mox_1;
            this.f9_1 = 6;
            continue $sm;
          case 6:
            this.jox_1 = this.lox_1;
            this.f9_1 = 7;
            var this_1 = this.hox_1.qox_1.tfs();
            suspendResult = this.kox_1.k60(new btbScopes$2$336$$inlined$suspendingQuery$1$runSuspend$2(this_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 7:
            var synonyms = suspendResult;
            return new NamingInfo(this.kox_1.l60(this.hox_1.qox_1.y2()), toSet_0(synonyms), this.jox_1);
          case 8:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 8) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function btbScopes$2$336$$inlined$suspendingQuery$1($element) {
    this.qox_1 = $element;
  }
  protoOf(btbScopes$2$336$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_75(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbScopes$2$336$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function btbScopes$lambda$lambda_0(relation) {
    _init_properties_BTBResolvers_kt__y423vn();
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new btbScopes$2$338$$inlined$suspendingQuery$1(relation);
  }
  function btbScopes$2$338$$inlined$suspendingQuery$1($relation) {
    this.rox_1 = $relation;
  }
  protoOf(btbScopes$2$338$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var name = builder.l60(this.rox_1.y2());
    var symbol = builder.l60(this.rox_1.zft());
    var tmp;
    var tmp_0;
    // Inline function 'kotlin.text.isNotBlank' call
    if (!isBlank(name)) {
      // Inline function 'kotlin.text.isNotBlank' call
      tmp_0 = !isBlank(symbol);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = new NamingInfo(name, setOf(symbol), name);
    } else {
      // Inline function 'kotlin.text.isNotBlank' call
      if (!isBlank(symbol)) {
        tmp = new NamingInfo(symbol);
      } else {
        tmp = new NamingInfo(name);
      }
    }
    return tmp;
  };
  protoOf(btbScopes$2$338$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function btbScopes$lambda$lambda_1(it) {
    _init_properties_BTBResolvers_kt__y423vn();
    return it.y2();
  }
  function $runSuspendCOROUTINE$_76(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.aoy_1 = _this__u8e3s4;
    this.boy_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_76).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            var $this$suspendingQuery = this.boy_1;
            this.f9_1 = 1;
            suspendResult = $this$suspendingQuery.k60(this.aoy_1.coy_1(this.aoy_1.doy_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var singleName = suspendResult;
            return new NamingInfo(singleName);
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function _no_name_provided__qut3iv_4($body, $target) {
    this.coy_1 = $body;
    this.doy_1 = $target;
  }
  protoOf(_no_name_provided__qut3iv_4).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_76(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(_no_name_provided__qut3iv_4).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function btbScopes$lambda$lambda_2($body) {
    return function (target) {
      // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
      return new _no_name_provided__qut3iv_4($body, target);
    };
  }
  function $runSuspendCOROUTINE$_77(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.moy_1 = _this__u8e3s4;
    this.noy_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_77).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            var $this$suspendingQuery = this.noy_1;
            this.f9_1 = 1;
            suspendResult = $this$suspendingQuery.k60(this.moy_1.ooy_1.q6q(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function propertyTypeElements$$inlined$suspendingQuery$1($propertyValue) {
    this.ooy_1 = $propertyValue;
  }
  protoOf(propertyTypeElements$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_77(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(propertyTypeElements$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function $runSuspendCOROUTINE$_78(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.xoy_1 = _this__u8e3s4;
    this.yoy_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_78).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 4;
            var $this$suspendingQuery = this.yoy_1;
            var tmp_0 = this;
            tmp_0.aoz_1 = $this$suspendingQuery;
            this.f9_1 = 1;
            suspendResult = $this$suspendingQuery.k60(this.xoy_1.boz_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp2 = suspendResult;
            var $this$flatMap = this.aoz_1;
            if (tmp2 == null) {
              this.zoy_1 = null;
              this.f9_1 = 3;
              continue $sm;
            } else {
              this.f9_1 = 2;
              suspendResult = processPropertyElements($this$flatMap, tmp2, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 2:
            this.zoy_1 = suspendResult;
            this.f9_1 = 3;
            continue $sm;
          case 3:
            return this.zoy_1;
          case 4:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 4) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function propertyTypeElements$$inlined$flatMap$1($this) {
    this.boz_1 = $this;
  }
  protoOf(propertyTypeElements$$inlined$flatMap$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_78(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(propertyTypeElements$$inlined$flatMap$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function $runSuspendCOROUTINE$_79(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.koz_1 = _this__u8e3s4;
    this.loz_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_79).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 9;
            var $this$q = this.loz_1;
            var tmp0_subject = this.koz_1.roz_1;
            if (!(tmp0_subject == null) ? isInterface(tmp0_subject, OntologyElementType_1) : false) {
              var tmp1_safe_receiver = $this$q.l60(this.koz_1.roz_1.gfq());
              if (tmp1_safe_receiver == null) {
                this.noz_1 = null;
                this.f9_1 = 7;
                continue $sm;
              } else {
                this.f9_1 = 6;
                suspendResult = $this$q.k60(tmp1_safe_receiver.gfq(), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              }
            } else {
              if (!(tmp0_subject == null) ? isInterface(tmp0_subject, OntologyElementPropertyType_1) : false) {
                if (!equals($this$q.l60(this.koz_1.roz_1.jfr()), LinkTypeSpecificator_TYPE_OF_getInstance())) {
                  var tmp3_safe_receiver = $this$q.l60(this.koz_1.roz_1.gfq());
                  if (tmp3_safe_receiver == null) {
                    this.poz_1 = null;
                    this.f9_1 = 4;
                    continue $sm;
                  } else {
                    this.f9_1 = 3;
                    suspendResult = $this$q.k60(tmp3_safe_receiver.gfq(), this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) {
                      return suspendResult;
                    }
                    continue $sm;
                  }
                } else {
                  this.ooz_1 = emptySet();
                  this.f9_1 = 5;
                  continue $sm;
                }
              } else {
                if (!(tmp0_subject == null) ? isInterface(tmp0_subject, ClassExpressionType_1) : false) {
                  var tmp5_safe_receiver = $this$q.l60(this.koz_1.roz_1.hfq());
                  if (tmp5_safe_receiver == null) {
                    this.qoz_1 = null;
                    this.f9_1 = 2;
                    continue $sm;
                  } else {
                    this.f9_1 = 1;
                    suspendResult = $this$q.k60(getAssertedDefinitionElements_0(ontologyElementHierarchy(), tmp5_safe_receiver), this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) {
                      return suspendResult;
                    }
                    continue $sm;
                  }
                } else {
                  this.moz_1 = null;
                  this.f9_1 = 8;
                  continue $sm;
                }
              }
            }

          case 1:
            this.qoz_1 = suspendResult;
            this.f9_1 = 2;
            continue $sm;
          case 2:
            this.moz_1 = this.qoz_1;
            this.f9_1 = 8;
            continue $sm;
          case 3:
            this.poz_1 = suspendResult;
            this.f9_1 = 4;
            continue $sm;
          case 4:
            var tmp4_safe_receiver = this.poz_1;
            var tmp_0 = this;
            var tmp_1;
            if (tmp4_safe_receiver == null) {
              tmp_1 = null;
            } else {
              tmp_1 = setOf(tmp4_safe_receiver);
            }

            tmp_0.ooz_1 = tmp_1;
            this.f9_1 = 5;
            continue $sm;
          case 5:
            this.moz_1 = this.ooz_1;
            this.f9_1 = 8;
            continue $sm;
          case 6:
            this.noz_1 = suspendResult;
            this.f9_1 = 7;
            continue $sm;
          case 7:
            var tmp2_safe_receiver = this.noz_1;
            var tmp_2 = this;
            var tmp_3;
            if (tmp2_safe_receiver == null) {
              tmp_3 = null;
            } else {
              tmp_3 = setOf(tmp2_safe_receiver);
            }

            tmp_2.moz_1 = tmp_3;
            this.f9_1 = 8;
            continue $sm;
          case 8:
            return this.moz_1;
          case 9:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 9) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function typeElements$$inlined$suspendingQuery$1($type) {
    this.roz_1 = $type;
  }
  protoOf(typeElements$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_79(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(typeElements$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function filterOntologyElementsByPropertyRange$o$runSuspend$slambda(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(filterOntologyElementsByPropertyRange$o$runSuspend$slambda).vmm = function ($this$query, it, $completion) {
    var tmp = this.wmm($this$query, it, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(filterOntologyElementsByPropertyRange$o$runSuspend$slambda).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof QueryBuilder ? p1 : THROW_CCE();
    return this.vmm(tmp, (!(p2 == null) ? isInterface(p2, OntologyElement_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(filterOntologyElementsByPropertyRange$o$runSuspend$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        if (tmp === 0) {
          this.g9_1 = 1;
          return false;
        } else if (tmp === 1) {
          throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(filterOntologyElementsByPropertyRange$o$runSuspend$slambda).wmm = function ($this$query, it, completion) {
    var i = new filterOntologyElementsByPropertyRange$o$runSuspend$slambda(completion);
    i.ap0_1 = $this$query;
    i.bp0_1 = it;
    return i;
  };
  function filterOntologyElementsByPropertyRange$o$runSuspend$slambda_0(resultContinuation) {
    var i = new filterOntologyElementsByPropertyRange$o$runSuspend$slambda(resultContinuation);
    var l = function ($this$query, it, $completion) {
      return i.vmm($this$query, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function $runSuspendCOROUTINE$_80(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.kp0_1 = _this__u8e3s4;
    this.lp0_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_80).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 5;
            this.op0_1 = this.lp0_1;
            var range = this.op0_1.l60(this.kp0_1.qp0_1.hd());
            if (range == null) {
              this.mp0_1 = null;
              this.f9_1 = 4;
              continue $sm;
            } else {
              if (isInterface(range, NoValues_1)) {
                var tmp_0 = this;
                var tmp_1 = Companion_instance_120;
                tmp_0.mp0_1 = tmp_1.f73(filterOntologyElementsByPropertyRange$o$runSuspend$slambda_0(null));
                this.f9_1 = 4;
                continue $sm;
              } else {
                var tmp0 = this.op0_1.l60(range.cfs());
                this.np0_1 = ArrayList_init_$Create$();
                this.pp0_1 = tmp0.m();
                this.f9_1 = 1;
                continue $sm;
              }
            }

          case 1:
            if (!this.pp0_1.n()) {
              this.f9_1 = 3;
              continue $sm;
            }

            var element = this.pp0_1.o();
            this.f9_1 = 2;
            suspendResult = this.op0_1.k60(typeElements(element), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var tmp0_safe_receiver = suspendResult;
            if (tmp0_safe_receiver == null)
              null;
            else {
              this.np0_1.j(tmp0_safe_receiver);
            }

            this.f9_1 = 1;
            continue $sm;
          case 3:
            var tmp0_0 = this.np0_1;
            var destination = ArrayList_init_$Create$();
            var _iterator__ex2g4s = tmp0_0.m();
            while (_iterator__ex2g4s.n()) {
              var element_0 = _iterator__ex2g4s.o();
              if (!element_0.s()) {
                destination.j(element_0);
              }
            }

            var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(destination, 10));
            var _iterator__ex2g4s_0 = destination.m();
            while (_iterator__ex2g4s_0.n()) {
              var item = _iterator__ex2g4s_0.o();
              destination_0.j(this.kp0_1.rp0_1.cml(item));
            }

            var filters = destination_0;
            var tmp_2 = this;
            switch (filters.p()) {
              case 0:
                tmp_2.mp0_1 = null;
                break;
              case 1:
                tmp_2.mp0_1 = single_0(filters);
                break;
              default:
                tmp_2.mp0_1 = anyOf(filters);
                break;
            }

            this.f9_1 = 4;
            continue $sm;
          case 4:
            return this.mp0_1;
          case 5:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 5) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function filterOntologyElementsByPropertyRange$$inlined$suspendingQuery$1($property, $subtypes) {
    this.qp0_1 = $property;
    this.rp0_1 = $subtypes;
  }
  protoOf(filterOntologyElementsByPropertyRange$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_80(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(filterOntologyElementsByPropertyRange$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function filterByPropertyRange$o$runSuspend$slambda(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(filterByPropertyRange$o$runSuspend$slambda).tmw = function ($this$query, it, $completion) {
    var tmp = this.umw($this$query, it, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(filterByPropertyRange$o$runSuspend$slambda).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof QueryBuilder ? p1 : THROW_CCE();
    return this.tmw(tmp, (!(p2 == null) ? isInterface(p2, ObjectPropertyDeclaration_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(filterByPropertyRange$o$runSuspend$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        if (tmp === 0) {
          this.g9_1 = 1;
          return false;
        } else if (tmp === 1) {
          throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(filterByPropertyRange$o$runSuspend$slambda).umw = function ($this$query, it, completion) {
    var i = new filterByPropertyRange$o$runSuspend$slambda(completion);
    i.ap1_1 = $this$query;
    i.bp1_1 = it;
    return i;
  };
  function filterByPropertyRange$o$runSuspend$slambda_0(resultContinuation) {
    var i = new filterByPropertyRange$o$runSuspend$slambda(resultContinuation);
    var l = function ($this$query, it, $completion) {
      return i.tmw($this$query, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function $runSuspendCOROUTINE$_81(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.kp1_1 = _this__u8e3s4;
    this.lp1_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_81).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 5;
            this.op1_1 = this.lp1_1;
            var range = this.op1_1.l60(this.kp1_1.qp1_1.hd());
            if (range == null) {
              this.mp1_1 = null;
              this.f9_1 = 4;
              continue $sm;
            } else {
              if (isInterface(range, NoValues_1)) {
                var tmp_0 = this;
                var tmp_1 = Companion_instance_120;
                tmp_0.mp1_1 = tmp_1.f73(filterByPropertyRange$o$runSuspend$slambda_0(null));
                this.f9_1 = 4;
                continue $sm;
              } else {
                var tmp0 = this.op1_1.l60(range.cfs());
                this.np1_1 = ArrayList_init_$Create$();
                this.pp1_1 = tmp0.m();
                this.f9_1 = 1;
                continue $sm;
              }
            }

          case 1:
            if (!this.pp1_1.n()) {
              this.f9_1 = 3;
              continue $sm;
            }

            var element = this.pp1_1.o();
            this.f9_1 = 2;
            suspendResult = this.op1_1.k60(filterByDomainType(element, this.kp1_1.rp1_1, this.kp1_1.sp1_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var tmp0_safe_receiver = suspendResult;
            if (tmp0_safe_receiver == null)
              null;
            else {
              this.np1_1.j(tmp0_safe_receiver);
            }

            this.f9_1 = 1;
            continue $sm;
          case 3:
            var filters = this.np1_1;
            var tmp_2 = this;
            switch (filters.p()) {
              case 0:
                tmp_2.mp1_1 = null;
                break;
              case 1:
                tmp_2.mp1_1 = single_0(filters);
                break;
              default:
                tmp_2.mp1_1 = anyOf(filters);
                break;
            }

            this.f9_1 = 4;
            continue $sm;
          case 4:
            return this.mp1_1;
          case 5:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 5) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function filterByPropertyRange$$inlined$suspendingQuery$1($property, $service, $variablesTrace) {
    this.qp1_1 = $property;
    this.rp1_1 = $service;
    this.sp1_1 = $variablesTrace;
  }
  protoOf(filterByPropertyRange$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_81(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(filterByPropertyRange$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function $runSuspendCOROUTINE$_82(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.bp2_1 = _this__u8e3s4;
    this.cp2_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_82).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 15;
            var tmp_0 = this;
            tmp_0.kp2_1 = this.cp2_1;
            this.dp2_1 = Unit_instance;
            this.f9_1 = 1;
            continue $sm;
          case 1:
            this.fp2_1 = this.kp2_1;
            var tmp0_subject = this.bp2_1.lp2_1;
            if (isInterface(tmp0_subject, VariableReferenceValue_1)) {
              if (this.bp2_1.mp2_1.t(this.bp2_1.lp2_1)) {
                this.dp2_1 = null;
                this.f9_1 = 14;
                continue $sm;
              } else {
                this.f9_1 = 9;
                continue $sm;
              }
            } else {
              if (isInterface(tmp0_subject, ProcessPropertyReference)) {
                this.f9_1 = 6;
                suspendResult = this.fp2_1.k60(this.bp2_1.lp2_1.q6q(), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                if (isInterface(tmp0_subject, ObjectPropertyReferenceValue_1)) {
                  var tmp3_safe_receiver = this.fp2_1.l60(this.bp2_1.lp2_1.q6q());
                  var tmp4_safe_receiver = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.q6q();
                  if (tmp4_safe_receiver == null) {
                    this.jp2_1 = null;
                    this.f9_1 = 3;
                    continue $sm;
                  } else {
                    this.f9_1 = 2;
                    suspendResult = this.fp2_1.k60(tmp4_safe_receiver.w6o(), this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) {
                      return suspendResult;
                    }
                    continue $sm;
                  }
                } else {
                  this.ep2_1 = null;
                  this.f9_1 = 13;
                  continue $sm;
                }
              }
            }

          case 2:
            this.jp2_1 = suspendResult;
            this.f9_1 = 3;
            continue $sm;
          case 3:
            var tmp5_elvis_lhs = this.jp2_1;
            if (tmp5_elvis_lhs == null) {
              this.dp2_1 = null;
              this.f9_1 = 14;
              var tmp_1 = this;
              continue $sm;
            } else {
              this.ip2_1 = tmp5_elvis_lhs;
              this.f9_1 = 4;
              continue $sm;
            }

          case 4:
            var property = this.ip2_1;
            this.f9_1 = 5;
            suspendResult = this.fp2_1.k60(filterByPropertyRange(property, this.bp2_1.np2_1, this.bp2_1.mp2_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 5:
            this.ep2_1 = suspendResult;
            this.f9_1 = 13;
            continue $sm;
          case 6:
            var tmp2_elvis_lhs = suspendResult;
            if (tmp2_elvis_lhs == null) {
              this.dp2_1 = null;
              this.f9_1 = 14;
              var tmp_2 = this;
              continue $sm;
            } else {
              this.hp2_1 = tmp2_elvis_lhs;
              this.f9_1 = 7;
              continue $sm;
            }

          case 7:
            var property_0 = this.hp2_1;
            this.f9_1 = 8;
            suspendResult = this.fp2_1.k60(filterByProcessPropertyType(property_0, this.bp2_1.np2_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 8:
            this.ep2_1 = suspendResult;
            this.f9_1 = 13;
            continue $sm;
          case 9:
            this.f9_1 = 10;
            suspendResult = this.fp2_1.k60(this.bp2_1.lp2_1.pfu(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 10:
            var tmp1_elvis_lhs = suspendResult;
            if (tmp1_elvis_lhs == null) {
              this.dp2_1 = null;
              this.f9_1 = 14;
              var tmp_3 = this;
              continue $sm;
            } else {
              this.gp2_1 = tmp1_elvis_lhs;
              this.f9_1 = 11;
              continue $sm;
            }

          case 11:
            var variable = this.gp2_1;
            this.f9_1 = 12;
            suspendResult = this.fp2_1.k60(filterByVariableSpecification(variable, this.bp2_1.np2_1, plus_11(this.bp2_1.mp2_1, this.bp2_1.lp2_1)), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 12:
            this.ep2_1 = suspendResult;
            this.f9_1 = 13;
            continue $sm;
          case 13:
            this.dp2_1 = this.ep2_1;
            if (false) {
              this.f9_1 = 1;
              continue $sm;
            }

            this.f9_1 = 14;
            continue $sm;
          case 14:
            return this.dp2_1;
          case 15:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 15) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function filterByValueType$$inlined$suspendingQuery$1($value, $variablesTrace, $service) {
    this.lp2_1 = $value;
    this.mp2_1 = $variablesTrace;
    this.np2_1 = $service;
  }
  protoOf(filterByValueType$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_82(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(filterByValueType$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function filterInstanceRelations$slambda($elements, resultContinuation) {
    this.wp2_1 = $elements;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(filterInstanceRelations$slambda).aog = function ($this$query, it, $completion) {
    var tmp = this.bog($this$query, it, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(filterInstanceRelations$slambda).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof QueryBuilder ? p1 : THROW_CCE();
    return this.aog(tmp, (!(p2 == null) ? isInterface(p2, InstanceRelationDeclaration) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(filterInstanceRelations$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 4;
            var domainType = this.xp2_1.l60(this.yp2_1.ufr());
            this.f9_1 = 1;
            suspendResult = this.xp2_1.k60(typeElements(domainType), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var domainElements = suspendResult;
            if (!(domainElements == null)) {
              this.f9_1 = 2;
              suspendResult = this.xp2_1.k60(isSubtypeOf_0(ontologyElementHierarchy(), this.wp2_1, domainElements), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.zp2_1 = false;
              this.f9_1 = 3;
              continue $sm;
            }

          case 2:
            this.zp2_1 = suspendResult;
            this.f9_1 = 3;
            continue $sm;
          case 3:
            return this.zp2_1;
          case 4:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 4) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(filterInstanceRelations$slambda).bog = function ($this$query, it, completion) {
    var i = new filterInstanceRelations$slambda(this.wp2_1, completion);
    i.xp2_1 = $this$query;
    i.yp2_1 = it;
    return i;
  };
  function filterInstanceRelations$slambda_0($elements, resultContinuation) {
    var i = new filterInstanceRelations$slambda($elements, resultContinuation);
    var l = function ($this$query, it, $completion) {
      return i.aog($this$query, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function filterInstanceRelations$slambda_1($typeNotion, resultContinuation) {
    this.ip3_1 = $typeNotion;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(filterInstanceRelations$slambda_1).aog = function ($this$query, it, $completion) {
    var tmp = this.bog($this$query, it, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(filterInstanceRelations$slambda_1).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof QueryBuilder ? p1 : THROW_CCE();
    return this.aog(tmp, (!(p2 == null) ? isInterface(p2, InstanceRelationDeclaration) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(filterInstanceRelations$slambda_1).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 3;
            var tmp_0 = this.jp3_1.l60(this.kp3_1.ufr());
            var tmp0_safe_receiver = (!(tmp_0 == null) ? isInterface(tmp_0, NotionType_0) : false) ? tmp_0 : null;
            if (tmp0_safe_receiver == null) {
              this.lp3_1 = null;
              this.f9_1 = 2;
              continue $sm;
            } else {
              this.f9_1 = 1;
              suspendResult = this.jp3_1.k60(tmp0_safe_receiver.mfq(), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            this.lp3_1 = suspendResult;
            this.f9_1 = 2;
            continue $sm;
          case 2:
            var domainNotion = this.lp3_1;
            return equals(domainNotion, this.ip3_1);
          case 3:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 3) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(filterInstanceRelations$slambda_1).bog = function ($this$query, it, completion) {
    var i = new filterInstanceRelations$slambda_1(this.ip3_1, completion);
    i.jp3_1 = $this$query;
    i.kp3_1 = it;
    return i;
  };
  function filterInstanceRelations$slambda_2($typeNotion, resultContinuation) {
    var i = new filterInstanceRelations$slambda_1($typeNotion, resultContinuation);
    var l = function ($this$query, it, $completion) {
      return i.aog($this$query, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function $runSuspendCOROUTINE$_83(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.up3_1 = _this__u8e3s4;
    this.vp3_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_83).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 7;
            var tmp_0 = this;
            tmp_0.ap4_1 = this.vp3_1;
            this.wp3_1 = Unit_instance;
            this.f9_1 = 1;
            continue $sm;
          case 1:
            this.yp3_1 = this.ap4_1;
            var tmp0_elvis_lhs = this.yp3_1.l60(this.up3_1.bp4_1.ofu());
            if (tmp0_elvis_lhs == null) {
              this.wp3_1 = null;
              this.f9_1 = 6;
              var tmp_1 = this;
              continue $sm;
            } else {
              this.zp3_1 = tmp0_elvis_lhs;
              this.f9_1 = 2;
              continue $sm;
            }

          case 2:
            var specification = this.zp3_1;
            if (isInterface(specification, Type)) {
              this.f9_1 = 4;
              suspendResult = this.yp3_1.k60(filterByDomainType(specification, this.up3_1.cp4_1, this.up3_1.dp4_1), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              if (isInterface(specification, AbstractValue)) {
                this.f9_1 = 3;
                suspendResult = this.yp3_1.k60(filterByValueType(specification, this.up3_1.cp4_1, this.up3_1.dp4_1), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                this.xp3_1 = null;
                this.f9_1 = 5;
                continue $sm;
              }
            }

          case 3:
            this.xp3_1 = suspendResult;
            this.f9_1 = 5;
            continue $sm;
          case 4:
            this.xp3_1 = suspendResult;
            this.f9_1 = 5;
            continue $sm;
          case 5:
            this.wp3_1 = this.xp3_1;
            if (false) {
              this.f9_1 = 1;
              continue $sm;
            }

            this.f9_1 = 6;
            continue $sm;
          case 6:
            return this.wp3_1;
          case 7:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 7) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function filterByVariableSpecification$$inlined$suspendingQuery$1($variable, $objectPropertyDomainFilters, $variablesTrace) {
    this.bp4_1 = $variable;
    this.cp4_1 = $objectPropertyDomainFilters;
    this.dp4_1 = $variablesTrace;
  }
  protoOf(filterByVariableSpecification$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_83(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(filterByVariableSpecification$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function $runSuspendCOROUTINE$_84(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.mp4_1 = _this__u8e3s4;
    this.np4_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_84).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 7;
            this.qp4_1 = this.np4_1;
            var tmp0_subject = this.mp4_1.sp4_1;
            var tmp_0;
            if (isInterface(tmp0_subject, OntologyElementType_1)) {
              tmp_0 = true;
            } else {
              tmp_0 = isInterface(tmp0_subject, ClassExpressionType_1);
            }

            if (tmp_0) {
              this.f9_1 = 5;
              suspendResult = this.qp4_1.k60(typeElements(this.mp4_1.sp4_1), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              if (isInterface(tmp0_subject, NotionType_0)) {
                this.f9_1 = 4;
                suspendResult = this.qp4_1.k60(this.mp4_1.sp4_1.mfq(), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                if (isInterface(tmp0_subject, PrimitiveNotionType_1)) {
                  this.op4_1 = null;
                  this.f9_1 = 6;
                  continue $sm;
                } else {
                  if (isInterface(tmp0_subject, ProcessType_1)) {
                    this.op4_1 = null;
                    this.f9_1 = 6;
                    continue $sm;
                  } else {
                    if (isInterface(tmp0_subject, OneOf_1)) {
                      var tmp0 = this.qp4_1.l60(this.mp4_1.sp4_1.mfs());
                      this.pp4_1 = ArrayList_init_$Create$();
                      this.rp4_1 = tmp0.m();
                      this.f9_1 = 1;
                      continue $sm;
                    } else {
                      this.op4_1 = null;
                      this.f9_1 = 6;
                      continue $sm;
                    }
                  }
                }
              }
            }

          case 1:
            if (!this.rp4_1.n()) {
              this.f9_1 = 3;
              continue $sm;
            }

            var element = this.rp4_1.o();
            this.f9_1 = 2;
            suspendResult = this.qp4_1.k60(filterByFactExpressionType(element, this.mp4_1.tp4_1, this.mp4_1.up4_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var tmp0_safe_receiver = suspendResult;
            if (tmp0_safe_receiver == null)
              null;
            else {
              this.pp4_1.j(tmp0_safe_receiver);
            }

            this.f9_1 = 1;
            continue $sm;
          case 3:
            var filters = this.pp4_1;
            this.op4_1 = anyOf(filters);
            this.f9_1 = 6;
            continue $sm;
          case 4:
            var tmp2_safe_receiver = suspendResult;
            var tmp_1 = this;
            var tmp_2;
            if (tmp2_safe_receiver == null) {
              tmp_2 = null;
            } else {
              tmp_2 = this.mp4_1.tp4_1.goj(tmp2_safe_receiver);
            }

            tmp_1.op4_1 = tmp_2;
            this.f9_1 = 6;
            continue $sm;
          case 5:
            var tmp1_safe_receiver = suspendResult;
            var tmp_3 = this;
            var tmp_4;
            if (tmp1_safe_receiver == null) {
              tmp_4 = null;
            } else {
              tmp_4 = this.mp4_1.tp4_1.cml(tmp1_safe_receiver);
            }

            tmp_3.op4_1 = tmp_4;
            this.f9_1 = 6;
            continue $sm;
          case 6:
            return this.op4_1;
          case 7:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 7) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function filterByDomainType$$inlined$suspendingQuery$1($type, $service, $variablesTrace) {
    this.sp4_1 = $type;
    this.tp4_1 = $service;
    this.up4_1 = $variablesTrace;
  }
  protoOf(filterByDomainType$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_84(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(filterByDomainType$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function $runSuspendCOROUTINE$_85(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.dp5_1 = _this__u8e3s4;
    this.ep5_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_85).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 7;
            var tmp_0 = this;
            tmp_0.jp5_1 = this.ep5_1;
            this.fp5_1 = Unit_instance;
            this.f9_1 = 1;
            continue $sm;
          case 1:
            this.hp5_1 = this.jp5_1;
            var tmp0_safe_receiver = this.hp5_1.l60(this.dp5_1.kp5_1.sfq());
            var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : this.hp5_1.l60(tmp0_safe_receiver.sfq());
            if (tmp1_elvis_lhs == null) {
              this.fp5_1 = null;
              this.f9_1 = 6;
              var tmp_1 = this;
              continue $sm;
            } else {
              this.ip5_1 = tmp1_elvis_lhs;
              this.f9_1 = 2;
              continue $sm;
            }

          case 2:
            var processPropertyType = this.ip5_1;
            if (isInterface(processPropertyType, SimplePropertyType)) {
              this.f9_1 = 4;
              suspendResult = this.hp5_1.k60(processPropertyType.mfq(), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              var tmp_2;
              if (isInterface(processPropertyType, OntologyElementPropertyType_1)) {
                tmp_2 = true;
              } else {
                tmp_2 = isInterface(processPropertyType, ClassExpressionType_1);
              }
              if (tmp_2) {
                this.f9_1 = 3;
                suspendResult = this.hp5_1.k60(typeElements(processPropertyType), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                if (isInterface(processPropertyType, PrimitiveNotionType_1)) {
                  this.gp5_1 = null;
                  this.f9_1 = 5;
                  continue $sm;
                } else {
                  this.gp5_1 = null;
                  this.f9_1 = 5;
                  continue $sm;
                }
              }
            }

          case 3:
            var tmp4_safe_receiver = suspendResult;
            var tmp_3 = this;
            var tmp_4;
            if (tmp4_safe_receiver == null) {
              tmp_4 = null;
            } else {
              tmp_4 = this.dp5_1.lp5_1.cml(tmp4_safe_receiver);
            }

            tmp_3.gp5_1 = tmp_4;
            this.f9_1 = 5;
            continue $sm;
          case 4:
            var tmp3_safe_receiver = suspendResult;
            var tmp_5 = this;
            var tmp_6;
            if (tmp3_safe_receiver == null) {
              tmp_6 = null;
            } else {
              tmp_6 = this.dp5_1.lp5_1.goj(tmp3_safe_receiver);
            }

            tmp_5.gp5_1 = tmp_6;
            this.f9_1 = 5;
            continue $sm;
          case 5:
            this.fp5_1 = this.gp5_1;
            if (false) {
              this.f9_1 = 1;
              continue $sm;
            }

            this.f9_1 = 6;
            continue $sm;
          case 6:
            return this.fp5_1;
          case 7:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 7) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function filterByProcessPropertyType$$inlined$suspendingQuery$1($property, $service) {
    this.kp5_1 = $property;
    this.lp5_1 = $service;
  }
  protoOf(filterByProcessPropertyType$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_85(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(filterByProcessPropertyType$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function $runSuspendCOROUTINE$_86(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.up5_1 = _this__u8e3s4;
    this.vp5_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_86).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 3;
            var $this$suspendingQuery = this.vp5_1;
            var tmp0_subject = this.up5_1.xp5_1;
            if (isInterface(tmp0_subject, AbstractValue)) {
              this.f9_1 = 1;
              suspendResult = $this$suspendingQuery.k60(filterByValueType(this.up5_1.xp5_1, this.up5_1.yp5_1, this.up5_1.zp5_1), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.wp5_1 = null;
              this.f9_1 = 2;
              continue $sm;
            }

          case 1:
            this.wp5_1 = suspendResult;
            this.f9_1 = 2;
            continue $sm;
          case 2:
            return this.wp5_1;
          case 3:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 3) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function filterByFactExpressionType$$inlined$suspendingQuery$1($factExpression, $service, $variablesTrace) {
    this.xp5_1 = $factExpression;
    this.yp5_1 = $service;
    this.zp5_1 = $variablesTrace;
  }
  protoOf(filterByFactExpressionType$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_86(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(filterByFactExpressionType$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function $importOntologyLibrariesCOROUTINE$(_this__u8e3s4, libraryReferences, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.lme_1 = _this__u8e3s4;
    this.mme_1 = libraryReferences;
  }
  protoOf($importOntologyLibrariesCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 5;
            var this_0 = this.mme_1;
            this.nme_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
            this.ome_1 = this_0.m();
            this.f9_1 = 1;
            continue $sm;
          case 1:
            if (!this.ome_1.n()) {
              this.f9_1 = 3;
              continue $sm;
            }

            var item = this.ome_1.o();
            this.f9_1 = 2;
            suspendResult = importOntologyLibrary(this.lme_1, item, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var ARGUMENT = suspendResult;
            this.nme_1.j(ARGUMENT);
            this.f9_1 = 1;
            continue $sm;
          case 3:
            var tmp0 = this.nme_1;
            var accumulator = new EmptyScope();
            var _iterator__ex2g4s = tmp0.m();
            while (_iterator__ex2g4s.n()) {
              var element = _iterator__ex2g4s.o();
              var p0 = accumulator;
              accumulator = new UniqueSumScope(p0, element);
            }

            var ARGUMENT_0 = accumulator;
            this.f9_1 = 4;
            suspendResult = this.lme_1.t77(ARGUMENT_0, get_elementTypeAndTaxon(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            return suspendResult;
          case 5:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 5) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function $processPropertyElementsCOROUTINE$(_this__u8e3s4, processProperty, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.xme_1 = _this__u8e3s4;
    this.yme_1 = processProperty;
  }
  protoOf($processPropertyElementsCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 6;
            var tmp0_safe_receiver = this.xme_1.l60(this.yme_1.sfq());
            var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : this.xme_1.l60(tmp0_safe_receiver.sfq());
            var tmp_0;
            if (tmp1_elvis_lhs == null) {
              return null;
            } else {
              tmp_0 = tmp1_elvis_lhs;
            }

            var propertyType = tmp_0;
            if (isInterface(propertyType, OntologyElementPropertyType_1)) {
              var tmp3_safe_receiver = this.xme_1.l60(propertyType.gfq());
              if (tmp3_safe_receiver == null) {
                this.amf_1 = null;
                this.f9_1 = 4;
                continue $sm;
              } else {
                this.f9_1 = 3;
                suspendResult = this.xme_1.k60(tmp3_safe_receiver.gfq(), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              }
            } else {
              if (isInterface(propertyType, ClassExpressionType_1)) {
                var tmp5_safe_receiver = this.xme_1.l60(propertyType.hfq());
                if (tmp5_safe_receiver == null) {
                  this.bmf_1 = null;
                  this.f9_1 = 2;
                  continue $sm;
                } else {
                  this.f9_1 = 1;
                  suspendResult = this.xme_1.k60(getAssertedDefinitionElements_0(ontologyElementHierarchy(), tmp5_safe_receiver), this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  continue $sm;
                }
              } else {
                this.zme_1 = null;
                this.f9_1 = 5;
                continue $sm;
              }
            }

          case 1:
            this.bmf_1 = suspendResult;
            this.f9_1 = 2;
            continue $sm;
          case 2:
            this.zme_1 = this.bmf_1;
            this.f9_1 = 5;
            continue $sm;
          case 3:
            this.amf_1 = suspendResult;
            this.f9_1 = 4;
            continue $sm;
          case 4:
            var tmp4_safe_receiver = this.amf_1;
            var tmp_1 = this;
            var tmp_2;
            if (tmp4_safe_receiver == null) {
              tmp_2 = null;
            } else {
              tmp_2 = setOf(tmp4_safe_receiver);
            }

            tmp_1.zme_1 = tmp_2;
            this.f9_1 = 5;
            continue $sm;
          case 5:
            return this.zme_1;
          case 6:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 6) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function $getCustomEditorPropertiesScopeCOROUTINE$(_this__u8e3s4, customEditor, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.kmf_1 = _this__u8e3s4;
    this.lmf_1 = customEditor;
  }
  protoOf($getCustomEditorPropertiesScopeCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 5;
            var tmp_0 = this.lmf_1.bp();
            var bindingDeclaration = (tmp_0 == null ? true : isInterface(tmp_0, AbstractBindingDeclaration)) ? tmp_0 : THROW_CCE();
            if (!(bindingDeclaration == null) ? isInterface(bindingDeclaration, ProcessDeclaration_1) : false) {
              this.f9_1 = 2;
              suspendResult = this.kmf_1.k60(bindingDeclaration.sil(), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              if (!(bindingDeclaration == null) ? isInterface(bindingDeclaration, FunctionDeclaration_1) : false) {
                var properties = this.kmf_1.l60(bindingDeclaration.rfp());
                this.f9_1 = 1;
                suspendResult = this.kmf_1.v77(properties, this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                if (bindingDeclaration == null) {
                  var tmp_1 = this;
                  throw NullPointerException_init_$Create$_0('null parent for custom editor');
                } else {
                  var tmp_2 = this;
                  throw UnsupportedOperationException_init_$Create$_0('unknown class: ' + toString_1(getKClassFromExpression(bindingDeclaration)));
                }
              }
            }

          case 1:
            this.mmf_1 = suspendResult;
            this.f9_1 = 4;
            continue $sm;
          case 2:
            var properties_0 = suspendResult;
            this.f9_1 = 3;
            suspendResult = this.kmf_1.v77(properties_0, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            this.mmf_1 = suspendResult;
            this.f9_1 = 4;
            continue $sm;
          case 4:
            return this.mmf_1;
          case 5:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 5) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function $libraryElementsScopeCOROUTINE$(_this__u8e3s4, librariesScopeProvider, library, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.vmf_1 = _this__u8e3s4;
    this.wmf_1 = librariesScopeProvider;
    this.xmf_1 = library;
  }
  protoOf($libraryElementsScopeCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 4;
            var this_0 = toList_2(this.vmf_1.l60(this.wmf_1.z6u().h6v(this.xmf_1)));
            this.ymf_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
            this.zmf_1 = this_0.m();
            this.f9_1 = 1;
            continue $sm;
          case 1:
            if (!this.zmf_1.n()) {
              this.f9_1 = 3;
              continue $sm;
            }

            var item = this.zmf_1.o();
            this.f9_1 = 2;
            suspendResult = this.vmf_1.x77(item, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var ARGUMENT = suspendResult;
            this.ymf_1.j(ARGUMENT);
            this.f9_1 = 1;
            continue $sm;
          case 3:
            var ARGUMENT_0 = this.ymf_1;
            return new CompositeScope(ARGUMENT_0);
          case 4:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 4) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  var properties_initialized_BTBResolvers_kt_kedsbj;
  function _init_properties_BTBResolvers_kt__y423vn() {
    if (!properties_initialized_BTBResolvers_kt_kedsbj) {
      properties_initialized_BTBResolvers_kt_kedsbj = true;
      elementTypeAndTaxon = new ScopeConstraintId();
      onlyOntologyVars = new ScopeConstraintId();
      libraries = listOf_0([ProcessLibraryConcept_getInstance(), ObjectPropertiesLibraryConcept_getInstance(), LinkLibraryConcept_getInstance(), PropertyLibraryConcept_getInstance(), OntologyLibraryConcept_getInstance(), FunctionLibraryConcept_getInstance(), NotionLibraryConcept_getInstance(), ProcessKindContainerConcept_getInstance(), ExtensionLibraryConcept_getInstance(), RelationContainerConcept_getInstance(), ModifierContainerConcept_getInstance(), OntologyImportRootConcept_getInstance(), QueryParametersBlackListConcept_getInstance(), PublishedSourcesLibraryConcept_getInstance()]);
      ONTOLOGIES_WITH_SPECIES = setOf_0(['Uniprot', 'MirBase Dictionary']);
      btbLanguageWithRemoteResolve = language(btbLanguageWithRemoteResolve$lambda);
      btbLanguageWithPrecalculatedResolve = language(btbLanguageWithPrecalculatedResolve$lambda);
      btbLanguageWithLocalResolve = language(btbLanguageWithLocalResolve$lambda);
    }
  }
  function DocumentNodeFinder$find$$inlined$query$1($refContents, this$0) {
    this.ap6_1 = $refContents;
    this.bp6_1 = this$0;
  }
  protoOf(DocumentNodeFinder$find$$inlined$query$1).n5w = function (builder) {
    var documentId = this.ap6_1.d6g();
    return builder.l60(this.bp6_1.cp6_1.c6g(documentId));
  };
  function DocumentNodeFinder(documentRepository) {
    this.cp6_1 = documentRepository;
  }
  protoOf(DocumentNodeFinder).q6p = function (source, refContents) {
    // Inline function 'jetbrains.ocelot.langDef.query.query' call
    return new DocumentNodeFinder$find$$inlined$query$1(refContents, this);
  };
  protoOf(DocumentNodeFinder).j6i = function (source, refContents) {
    return this.q6p(source, refContents instanceof QualifiedReferenceContent ? refContents : THROW_CCE());
  };
  function NonGroupingFilter$apply$$inlined$suspendingQuery$1($target) {
    this.dp6_1 = $target;
  }
  protoOf(NonGroupingFilter$apply$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    return !builder.l60(this.dp6_1.ffs());
  };
  protoOf(NonGroupingFilter$apply$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function NonGroupingFilter() {
  }
  protoOf(NonGroupingFilter).ep6 = function (target) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new NonGroupingFilter$apply$$inlined$suspendingQuery$1(target);
  };
  protoOf(NonGroupingFilter).j71 = function (target) {
    return this.ep6(isInterface(target, ObjectPropertyDeclaration_1) ? target : THROW_CCE());
  };
  function sam$jetbrains_biokb_lang_model_resolve_NonGroupingFilterService$0(function_0) {
    this.fp6_1 = function_0;
  }
  protoOf(sam$jetbrains_biokb_lang_model_resolve_NonGroupingFilterService$0).jnw = function () {
    return this.fp6_1();
  };
  protoOf(sam$jetbrains_biokb_lang_model_resolve_NonGroupingFilterService$0).f3 = function () {
    return this.fp6_1;
  };
  protoOf(sam$jetbrains_biokb_lang_model_resolve_NonGroupingFilterService$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, NonGroupingFilterService) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_biokb_lang_model_resolve_NonGroupingFilterService$0).hashCode = function () {
    return hashCode(this.f3());
  };
  function NonGroupingFilterService$Companion$default$lambda() {
    return new NonGroupingFilter();
  }
  function Companion_358() {
    Companion_instance_358 = this;
    var tmp = this;
    var tmp_0 = NonGroupingFilterService$Companion$default$lambda;
    tmp.gp6_1 = new sam$jetbrains_biokb_lang_model_resolve_NonGroupingFilterService$0(tmp_0);
  }
  protoOf(Companion_358).g3b = function () {
    return this.gp6_1;
  };
  var Companion_instance_358;
  function Companion_getInstance_358() {
    if (Companion_instance_358 == null)
      new Companion_358();
    return Companion_instance_358;
  }
  function NonGroupingFilterService() {
  }
  function $runSuspendCOROUTINE$_87(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.pp6_1 = _this__u8e3s4;
    this.qp6_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_87).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 4;
            this.sp6_1 = this.qp6_1;
            var tmp0 = this.sp6_1.l60(this.pp6_1.up6_1.ufr());
            var destination = ArrayList_init_$Create$();
            var _iterator__ex2g4s = tmp0.m();
            while (_iterator__ex2g4s.n()) {
              var element = _iterator__ex2g4s.o();
              if (!(element == null) ? isInterface(element, NotionType_0) : false) {
                destination.j(element);
              }
            }

            this.rp6_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(destination, 10));
            this.tp6_1 = destination.m();
            this.f9_1 = 1;
            continue $sm;
          case 1:
            if (!this.tp6_1.n()) {
              this.f9_1 = 3;
              continue $sm;
            }

            var item = this.tp6_1.o();
            this.f9_1 = 2;
            suspendResult = this.sp6_1.k60(item.mfq(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var ARGUMENT = suspendResult;
            this.rp6_1.j(ARGUMENT);
            this.f9_1 = 1;
            continue $sm;
          case 3:
            var domainNotions = this.rp6_1;
            return domainNotions.t(this.pp6_1.vp6_1.wp6_1);
          case 4:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 4) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function ObjectPropertyDomainNotionFilter$apply$$inlined$suspendingQuery$1($target, this$0) {
    this.up6_1 = $target;
    this.vp6_1 = this$0;
  }
  protoOf(ObjectPropertyDomainNotionFilter$apply$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_87(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(ObjectPropertyDomainNotionFilter$apply$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function ObjectPropertyDomainNotionFilter(typeNotion) {
    this.wp6_1 = typeNotion;
  }
  protoOf(ObjectPropertyDomainNotionFilter).ep6 = function (target) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new ObjectPropertyDomainNotionFilter$apply$$inlined$suspendingQuery$1(target, this);
  };
  protoOf(ObjectPropertyDomainNotionFilter).j71 = function (target) {
    return this.ep6(isInterface(target, ObjectPropertyDeclaration_1) ? target : THROW_CCE());
  };
  function $runSuspendCOROUTINE$_88(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.fp7_1 = _this__u8e3s4;
    this.gp7_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_88).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 13;
            var tmp_0 = this;
            tmp_0.pp7_1 = this.gp7_1;
            this.hp7_1 = Unit_instance;
            this.f9_1 = 1;
            continue $sm;
          case 1:
            this.jp7_1 = this.pp7_1;
            if (this.fp7_1.sp7_1.qp7_1.s()) {
              this.hp7_1 = false;
              this.f9_1 = 12;
              continue $sm;
            } else {
              this.f9_1 = 2;
              continue $sm;
            }

          case 2:
            var tmp0 = this.jp7_1.l60(this.fp7_1.tp7_1.ufr());
            var destination = ArrayList_init_$Create$();
            var _iterator__ex2g4s = tmp0.m();
            while (_iterator__ex2g4s.n()) {
              var element = _iterator__ex2g4s.o();
              var tmp_1;
              if (isInterface(element, OntologyElementType_1)) {
                tmp_1 = true;
              } else {
                tmp_1 = isInterface(element, ClassExpressionType_1);
              }
              if (tmp_1) {
                destination.j(element);
              }
            }

            this.kp7_1 = ArrayList_init_$Create$();
            this.op7_1 = destination.m();
            this.f9_1 = 3;
            continue $sm;
          case 3:
            if (!this.op7_1.n()) {
              this.f9_1 = 9;
              continue $sm;
            }

            var element_0 = this.op7_1.o();
            if (isInterface(element_0, OntologyElementType_1)) {
              var tmp1_safe_receiver = this.jp7_1.l60(element_0.gfq());
              if (tmp1_safe_receiver == null) {
                this.mp7_1 = null;
                this.f9_1 = 7;
                continue $sm;
              } else {
                this.f9_1 = 6;
                suspendResult = this.jp7_1.k60(tmp1_safe_receiver.gfq(), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              }
            } else {
              if (isInterface(element_0, ClassExpressionType_1)) {
                var tmp3_safe_receiver = this.jp7_1.l60(element_0.hfq());
                if (tmp3_safe_receiver == null) {
                  this.np7_1 = null;
                  this.f9_1 = 5;
                  continue $sm;
                } else {
                  this.f9_1 = 4;
                  suspendResult = this.jp7_1.k60(getAssertedDefinitionElements_0(this.fp7_1.sp7_1.rp7_1, tmp3_safe_receiver), this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  continue $sm;
                }
              } else {
                this.lp7_1 = null;
                this.f9_1 = 8;
                continue $sm;
              }
            }

          case 4:
            this.np7_1 = suspendResult;
            this.f9_1 = 5;
            continue $sm;
          case 5:
            this.lp7_1 = this.np7_1;
            this.f9_1 = 8;
            continue $sm;
          case 6:
            this.mp7_1 = suspendResult;
            this.f9_1 = 7;
            continue $sm;
          case 7:
            var tmp2_safe_receiver = this.mp7_1;
            var tmp_2 = this;
            var tmp_3;
            if (tmp2_safe_receiver == null) {
              tmp_3 = null;
            } else {
              tmp_3 = setOf(tmp2_safe_receiver);
            }

            tmp_2.lp7_1 = tmp_3;
            this.f9_1 = 8;
            continue $sm;
          case 8:
            var tmp0_safe_receiver = this.lp7_1;
            if (tmp0_safe_receiver == null)
              null;
            else {
              this.kp7_1.j(tmp0_safe_receiver);
            }

            this.f9_1 = 3;
            continue $sm;
          case 9:
            var tmp0_0 = this.kp7_1;
            var accumulator = emptySet();
            var _iterator__ex2g4s_0 = tmp0_0.m();
            while (_iterator__ex2g4s_0.n()) {
              var element_1 = _iterator__ex2g4s_0.o();
              var p0 = accumulator;
              accumulator = plus_10(p0, element_1);
            }

            var domainElements = accumulator;
            if (!domainElements.s()) {
              this.f9_1 = 10;
              suspendResult = this.jp7_1.k60(isSubtypeOf_0(this.fp7_1.sp7_1.rp7_1, this.fp7_1.sp7_1.qp7_1, domainElements), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              var tmp_4 = this;
              tmp_4.ip7_1 = false;
              this.f9_1 = 11;
              continue $sm;
            }

          case 10:
            this.ip7_1 = suspendResult;
            this.f9_1 = 11;
            continue $sm;
          case 11:
            this.hp7_1 = this.ip7_1;
            if (false) {
              this.f9_1 = 1;
              continue $sm;
            }

            this.f9_1 = 12;
            continue $sm;
          case 12:
            return this.hp7_1;
          case 13:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 13) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function ObjectPropertyDomainElementsFilter$apply$$inlined$suspendingQuery$1(this$0, $target) {
    this.sp7_1 = this$0;
    this.tp7_1 = $target;
  }
  protoOf(ObjectPropertyDomainElementsFilter$apply$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_88(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(ObjectPropertyDomainElementsFilter$apply$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function ObjectPropertyDomainElementsFilter(elements) {
    this.qp7_1 = elements;
    this.rp7_1 = ontologyElementHierarchy();
  }
  protoOf(ObjectPropertyDomainElementsFilter).ep6 = function (target) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new ObjectPropertyDomainElementsFilter$apply$$inlined$suspendingQuery$1(this, target);
  };
  protoOf(ObjectPropertyDomainElementsFilter).j71 = function (target) {
    return this.ep6(isInterface(target, ObjectPropertyDeclaration_1) ? target : THROW_CCE());
  };
  function ObjectPropertyDomainFilterService$Companion$default$1() {
  }
  protoOf(ObjectPropertyDomainFilterService$Companion$default$1).goj = function (typeNotion) {
    return new ObjectPropertyDomainNotionFilter(typeNotion);
  };
  protoOf(ObjectPropertyDomainFilterService$Companion$default$1).cml = function (elements) {
    return new ObjectPropertyDomainElementsFilter(elements);
  };
  function Companion_359() {
    Companion_instance_359 = this;
    var tmp = this;
    tmp.up7_1 = new ObjectPropertyDomainFilterService$Companion$default$1();
  }
  protoOf(Companion_359).g3b = function () {
    return this.up7_1;
  };
  var Companion_instance_359;
  function Companion_getInstance_359() {
    if (Companion_instance_359 == null)
      new Companion_359();
    return Companion_instance_359;
  }
  function PublishedWorkReferenceResolver$resolve$$inlined$map$1($this) {
    this.vp7_1 = $this;
  }
  protoOf(PublishedWorkReferenceResolver$resolve$$inlined$map$1).n5w = function (builder) {
    var it = builder.l60(this.vp7_1);
    return (it == null ? true : isInterface(it, PublishedWork)) ? it : THROW_CCE();
  };
  function PublishedWorkReferenceResolver(nodePointers) {
    this.wp7_1 = nodePointers;
  }
  protoOf(PublishedWorkReferenceResolver).xp7 = function (source, refContent) {
    var nodePointerSupport = this.wp7_1.p6g();
    // Inline function 'jetbrains.ocelot.langDef.query.map' call
    var this_0 = nodePointerSupport.i6g(refContent.r6p_1);
    // Inline function 'jetbrains.ocelot.langDef.query.query' call
    return new PublishedWorkReferenceResolver$resolve$$inlined$map$1(this_0);
  };
  protoOf(PublishedWorkReferenceResolver).i6q = function (source, refContent) {
    var tmp = isInterface(source, PublishedSourceReference_1) ? source : THROW_CCE();
    return this.xp7(tmp, refContent instanceof QualifiedReferenceContent ? refContent : THROW_CCE());
  };
  function PublishedWorkReferenceTargetPresentationProvider() {
  }
  protoOf(PublishedWorkReferenceTargetPresentationProvider).yp7 = function (target) {
    return target.li1();
  };
  protoOf(PublishedWorkReferenceTargetPresentationProvider).w6q = function (target) {
    return this.yp7(isInterface(target, PublishedWork) ? target : THROW_CCE());
  };
  function PublishedWorkReferenceTargetsSupplier$getElements$slambda$o$runSuspend$o$collect$slambda($$this$unsafeFlow, this$0, resultContinuation) {
    this.hp8_1 = $$this$unsafeFlow;
    this.ip8_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(PublishedWorkReferenceTargetsSupplier$getElements$slambda$o$runSuspend$o$collect$slambda).f1q = function (value, $completion) {
    var tmp = this.g1q(value, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(PublishedWorkReferenceTargetsSupplier$getElements$slambda$o$runSuspend$o$collect$slambda).v9 = function (p1, $completion) {
    return this.f1q((p1 == null ? true : !(p1 == null)) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(PublishedWorkReferenceTargetsSupplier$getElements$slambda$o$runSuspend$o$collect$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            var tmp0 = this.hp8_1;
            var value = this.jp8_1;
            this.f9_1 = 1;
            suspendResult = tmp0.x18(targetItem(this.ip8_1, value), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(PublishedWorkReferenceTargetsSupplier$getElements$slambda$o$runSuspend$o$collect$slambda).g1q = function (value, completion) {
    var i = new PublishedWorkReferenceTargetsSupplier$getElements$slambda$o$runSuspend$o$collect$slambda(this.hp8_1, this.ip8_1, completion);
    i.jp8_1 = value;
    return i;
  };
  function PublishedWorkReferenceTargetsSupplier$getElements$slambda$o$runSuspend$o$collect$slambda_0($$this$unsafeFlow, this$0, resultContinuation) {
    var i = new PublishedWorkReferenceTargetsSupplier$getElements$slambda$o$runSuspend$o$collect$slambda($$this$unsafeFlow, this$0, resultContinuation);
    var l = function (value, $completion) {
      return i.f1q(value, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function $collectCOROUTINE$_21(_this__u8e3s4, collector, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.sp8_1 = _this__u8e3s4;
    this.tp8_1 = collector;
  }
  protoOf($collectCOROUTINE$_21).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            var $this$unsafeFlow = this.tp8_1;
            this.f9_1 = 1;
            var tmp_0 = PublishedWorkReferenceTargetsSupplier$getElements$slambda$o$runSuspend$o$collect$slambda_0($this$unsafeFlow, this.sp8_1.vp8_1, null);
            suspendResult = this.sp8_1.up8_1.f18(new sam$kotlinx_coroutines_flow_FlowCollector$0_20(tmp_0), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function PublishedWorkReferenceTargetsSupplier$getElements$slambda$o$runSuspend$o$collect$slambda_1($$this$unsafeFlow, resultContinuation) {
    this.ep9_1 = $$this$unsafeFlow;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(PublishedWorkReferenceTargetsSupplier$getElements$slambda$o$runSuspend$o$collect$slambda_1).f1q = function (value, $completion) {
    var tmp = this.g1q(value, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(PublishedWorkReferenceTargetsSupplier$getElements$slambda$o$runSuspend$o$collect$slambda_1).v9 = function (p1, $completion) {
    return this.f1q((p1 == null ? true : !(p1 == null)) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(PublishedWorkReferenceTargetsSupplier$getElements$slambda$o$runSuspend$o$collect$slambda_1).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 5;
            var tmp_0 = this;
            tmp_0.hp9_1 = this.ep9_1;
            var tmp_1 = this;
            tmp_1.gp9_1 = this.fp9_1;
            this.f9_1 = 1;
            continue $sm;
          case 1:
            var $this$unsafeTransform = this.hp9_1;
            var value = this.gp9_1;
            var this_0 = value.l6q_1;
            if (!isBlank(this_0)) {
              this.f9_1 = 3;
              suspendResult = $this$unsafeTransform.x18(value, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.f9_1 = 2;
              continue $sm;
            }

          case 2:
            if (false) {
              this.f9_1 = 1;
              continue $sm;
            }

            this.f9_1 = 4;
            continue $sm;
          case 3:
            this.f9_1 = 4;
            continue $sm;
          case 4:
            return Unit_instance;
          case 5:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 5) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(PublishedWorkReferenceTargetsSupplier$getElements$slambda$o$runSuspend$o$collect$slambda_1).g1q = function (value, completion) {
    var i = new PublishedWorkReferenceTargetsSupplier$getElements$slambda$o$runSuspend$o$collect$slambda_1(this.ep9_1, completion);
    i.fp9_1 = value;
    return i;
  };
  function PublishedWorkReferenceTargetsSupplier$getElements$slambda$o$runSuspend$o$collect$slambda_2($$this$unsafeFlow, resultContinuation) {
    var i = new PublishedWorkReferenceTargetsSupplier$getElements$slambda$o$runSuspend$o$collect$slambda_1($$this$unsafeFlow, resultContinuation);
    var l = function (value, $completion) {
      return i.f1q(value, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function $collectCOROUTINE$_22(_this__u8e3s4, collector, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.qp9_1 = _this__u8e3s4;
    this.rp9_1 = collector;
  }
  protoOf($collectCOROUTINE$_22).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            var $this$unsafeFlow = this.rp9_1;
            this.f9_1 = 1;
            var tmp_0 = PublishedWorkReferenceTargetsSupplier$getElements$slambda$o$runSuspend$o$collect$slambda_2($this$unsafeFlow, null);
            suspendResult = this.qp9_1.sp9_1.f18(new sam$kotlinx_coroutines_flow_FlowCollector$0_20(tmp_0), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function PublishedWorkReferenceTargetsSupplier$getElements$slambda$o$runSuspend$slambda($$this$suspendingQuery, resultContinuation) {
    this.bpa_1 = $$this$suspendingQuery;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(PublishedWorkReferenceTargetsSupplier$getElements$slambda$o$runSuspend$slambda).dpa = function (it, $completion) {
    var tmp = this.epa(it, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(PublishedWorkReferenceTargetsSupplier$getElements$slambda$o$runSuspend$slambda).v9 = function (p1, $completion) {
    return this.dpa((!(p1 == null) ? isInterface(p1, PublishedSourcesLibrary_1) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(PublishedWorkReferenceTargetsSupplier$getElements$slambda$o$runSuspend$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        if (tmp === 0) {
          this.g9_1 = 1;
          var tmp0 = this.bpa_1.l60(this.cpa_1.l2n());
          var destination = ArrayList_init_$Create$();
          var _iterator__ex2g4s = tmp0.m();
          while (_iterator__ex2g4s.n()) {
            var element = _iterator__ex2g4s.o();
            if (!(element == null) ? isInterface(element, PublishedWork) : false) {
              destination.j(element);
            }
          }
          return asFlow_0(destination);
        } else if (tmp === 1) {
          throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(PublishedWorkReferenceTargetsSupplier$getElements$slambda$o$runSuspend$slambda).epa = function (it, completion) {
    var i = new PublishedWorkReferenceTargetsSupplier$getElements$slambda$o$runSuspend$slambda(this.bpa_1, completion);
    i.cpa_1 = it;
    return i;
  };
  function PublishedWorkReferenceTargetsSupplier$getElements$slambda$o$runSuspend$slambda_0($$this$suspendingQuery, resultContinuation) {
    var i = new PublishedWorkReferenceTargetsSupplier$getElements$slambda$o$runSuspend$slambda($$this$suspendingQuery, resultContinuation);
    var l = function (it, $completion) {
      return i.dpa(it, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function PublishedWorkReferenceTargetsSupplier$getElements$2$$inlined$suspendingQuery$1$runSuspend$2($this, this$0) {
    this.up8_1 = $this;
    this.vp8_1 = this$0;
  }
  protoOf(PublishedWorkReferenceTargetsSupplier$getElements$2$$inlined$suspendingQuery$1$runSuspend$2).y18 = function (collector, $completion) {
    var tmp = new $collectCOROUTINE$_21(this, collector, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(PublishedWorkReferenceTargetsSupplier$getElements$2$$inlined$suspendingQuery$1$runSuspend$2).f18 = function (collector, $completion) {
    return this.y18(collector, $completion);
  };
  function PublishedWorkReferenceTargetsSupplier$getElements$2$$inlined$suspendingQuery$1$runSuspend$3($this) {
    this.sp9_1 = $this;
  }
  protoOf(PublishedWorkReferenceTargetsSupplier$getElements$2$$inlined$suspendingQuery$1$runSuspend$3).y18 = function (collector, $completion) {
    var tmp = new $collectCOROUTINE$_22(this, collector, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(PublishedWorkReferenceTargetsSupplier$getElements$2$$inlined$suspendingQuery$1$runSuspend$3).f18 = function (collector, $completion) {
    return this.y18(collector, $completion);
  };
  function PublishedWorkReferenceTargetsSupplier$getElements$slambda$o$runSuspend$slambda_1($this_channelFlow, resultContinuation) {
    this.npa_1 = $this_channelFlow;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(PublishedWorkReferenceTargetsSupplier$getElements$slambda$o$runSuspend$slambda_1).ppa = function (it, $completion) {
    var tmp = this.qpa(it, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(PublishedWorkReferenceTargetsSupplier$getElements$slambda$o$runSuspend$slambda_1).v9 = function (p1, $completion) {
    return this.ppa(p1 instanceof ReferenceTargetItem ? p1 : THROW_CCE(), $completion);
  };
  protoOf(PublishedWorkReferenceTargetsSupplier$getElements$slambda$o$runSuspend$slambda_1).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.npa_1.d11().z15(this.opa_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(PublishedWorkReferenceTargetsSupplier$getElements$slambda$o$runSuspend$slambda_1).qpa = function (it, completion) {
    var i = new PublishedWorkReferenceTargetsSupplier$getElements$slambda$o$runSuspend$slambda_1(this.npa_1, completion);
    i.opa_1 = it;
    return i;
  };
  function PublishedWorkReferenceTargetsSupplier$getElements$slambda$o$runSuspend$slambda_2($this_channelFlow, resultContinuation) {
    var i = new PublishedWorkReferenceTargetsSupplier$getElements$slambda$o$runSuspend$slambda_1($this_channelFlow, resultContinuation);
    var l = function (it, $completion) {
      return i.ppa(it, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function $runSuspendCOROUTINE$_89(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.zpa_1 = _this__u8e3s4;
    this.apb_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_89).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            var $this$suspendingQuery = this.apb_1;
            this.f9_1 = 1;
            var tmp_0 = asFlow($this$suspendingQuery.l60(this.zpa_1.cpb_1.bpb_1.z6u().h6v(PublishedSourcesLibraryConcept_getInstance())));
            var this_0 = flatMapConcat(tmp_0, PublishedWorkReferenceTargetsSupplier$getElements$slambda$o$runSuspend$slambda_0($this$suspendingQuery, null));
            var this_1 = new PublishedWorkReferenceTargetsSupplier$getElements$2$$inlined$suspendingQuery$1$runSuspend$2(this_0, this.zpa_1.cpb_1);
            var tmp_1 = new PublishedWorkReferenceTargetsSupplier$getElements$2$$inlined$suspendingQuery$1$runSuspend$3(this_1);
            var tmp_2 = PublishedWorkReferenceTargetsSupplier$getElements$slambda$o$runSuspend$slambda_2(this.zpa_1.dpb_1, null);
            suspendResult = tmp_1.f18(new sam$kotlinx_coroutines_flow_FlowCollector$0_20(tmp_2), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function PublishedWorkReferenceTargetsSupplier$getElements$2$$inlined$suspendingQuery$1(this$0, $this_channelFlow) {
    this.cpb_1 = this$0;
    this.dpb_1 = $this_channelFlow;
  }
  protoOf(PublishedWorkReferenceTargetsSupplier$getElements$2$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_89(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(PublishedWorkReferenceTargetsSupplier$getElements$2$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function targetItem($this, _this__u8e3s4) {
    return new ReferenceTargetItem(new QualifiedReferenceContent(ensureNotNull(get_pointer(_this__u8e3s4))), execute_0(_this__u8e3s4.li1()));
  }
  function sam$kotlinx_coroutines_flow_FlowCollector$0_20(function_0) {
    this.epb_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_20).x18 = function (value, $completion) {
    return this.epb_1(value, $completion);
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_20).f3 = function () {
    return this.epb_1;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_20).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, FlowCollector) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_20).hashCode = function () {
    return hashCode(this.f3());
  };
  function PublishedWorkReferenceTargetsSupplier$getElements$slambda(this$0, resultContinuation) {
    this.npb_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(PublishedWorkReferenceTargetsSupplier$getElements$slambda).ppb = function ($this$channelFlow, $completion) {
    var tmp = this.qpb($this$channelFlow, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(PublishedWorkReferenceTargetsSupplier$getElements$slambda).v9 = function (p1, $completion) {
    return this.ppb((!(p1 == null) ? isInterface(p1, ProducerScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(PublishedWorkReferenceTargetsSupplier$getElements$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = execute_1(new PublishedWorkReferenceTargetsSupplier$getElements$2$$inlined$suspendingQuery$1(this.npb_1, this.opb_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(PublishedWorkReferenceTargetsSupplier$getElements$slambda).qpb = function ($this$channelFlow, completion) {
    var i = new PublishedWorkReferenceTargetsSupplier$getElements$slambda(this.npb_1, completion);
    i.opb_1 = $this$channelFlow;
    return i;
  };
  function PublishedWorkReferenceTargetsSupplier$getElements$slambda_0(this$0, resultContinuation) {
    var i = new PublishedWorkReferenceTargetsSupplier$getElements$slambda(this$0, resultContinuation);
    var l = function ($this$channelFlow, $completion) {
      return i.ppb($this$channelFlow, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function PublishedWorkReferenceTargetsSupplier(libraryScopeProvider) {
    this.bpb_1 = libraryScopeProvider;
  }
  protoOf(PublishedWorkReferenceTargetsSupplier).rpb = function (context, filter) {
    return channelFlow(PublishedWorkReferenceTargetsSupplier$getElements$slambda_0(this, null));
  };
  protoOf(PublishedWorkReferenceTargetsSupplier).o6q = function (context, filter) {
    return this.rpb(context, filter);
  };
  function SubtypeScopeFilter(supertypeElements) {
    this.spb_1 = supertypeElements;
    this.tpb_1 = ontologyElementHierarchy();
  }
  protoOf(SubtypeScopeFilter).upb = function (target) {
    return isSubtypeOf_0(this.tpb_1, listOf(target), this.spb_1);
  };
  protoOf(SubtypeScopeFilter).j71 = function (target) {
    return this.upb(isInterface(target, OntologyElement_1) ? target : THROW_CCE());
  };
  function SubtypeScopeFilterService$Companion$default$1() {
  }
  protoOf(SubtypeScopeFilterService$Companion$default$1).cml = function (elements) {
    return new SubtypeScopeFilter(elements);
  };
  function Companion_360() {
    Companion_instance_360 = this;
    var tmp = this;
    tmp.vpb_1 = new SubtypeScopeFilterService$Companion$default$1();
  }
  protoOf(Companion_360).g3b = function () {
    return this.vpb_1;
  };
  var Companion_instance_360;
  function Companion_getInstance_360() {
    if (Companion_instance_360 == null)
      new Companion_360();
    return Companion_instance_360;
  }
  function SubtypeScopeFilterService() {
  }
  function $runSuspendCOROUTINE$_90(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.epc_1 = _this__u8e3s4;
    this.fpc_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_90).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 15;
            var tmp_0 = this;
            tmp_0.qpc_1 = this.fpc_1;
            this.gpc_1 = Unit_instance;
            this.f9_1 = 1;
            continue $sm;
          case 1:
            this.lpc_1 = this.qpc_1;
            if (this.epc_1.tpc_1.rpc_1.s()) {
              this.gpc_1 = true;
              this.f9_1 = 14;
              continue $sm;
            } else {
              this.f9_1 = 2;
              continue $sm;
            }

          case 2:
            this.f9_1 = 3;
            suspendResult = this.lpc_1.k60(this.epc_1.upc_1.hig(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            this.ppc_1 = suspendResult;
            if (this.ppc_1.s()) {
              this.gpc_1 = true;
              this.f9_1 = 14;
              continue $sm;
            } else {
              this.f9_1 = 4;
              continue $sm;
            }

          case 4:
            this.jpc_1 = toAdapter_1(this.ppc_1);
            var tmp_1 = this;
            tmp_1.opc_1 = this.epc_1.tpc_1.rpc_1;
            this.f9_1 = 5;
            continue $sm;
          case 5:
            this.npc_1 = this.opc_1;
            var tmp_2;
            var tmp_3 = this.npc_1;
            if (isInterface(tmp_3, Collection)) {
              tmp_2 = this.npc_1.s();
            } else {
              tmp_2 = false;
            }

            if (tmp_2) {
              this.hpc_1 = false;
              this.f9_1 = 13;
              continue $sm;
            } else {
              this.f9_1 = 6;
              continue $sm;
            }

          case 6:
            this.mpc_1 = this.npc_1.m();
            this.f9_1 = 7;
            continue $sm;
          case 7:
            if (!this.mpc_1.n()) {
              this.f9_1 = 12;
              continue $sm;
            }

            var element = this.mpc_1.o();
            this.kpc_1 = toAdapter_0(element);
            this.f9_1 = 8;
            suspendResult = this.lpc_1.k60(this.epc_1.tpc_1.spc_1.vpc(this.jpc_1, this.kpc_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 8:
            if (suspendResult) {
              this.ipc_1 = true;
              this.f9_1 = 10;
              continue $sm;
            } else {
              this.f9_1 = 9;
              suspendResult = this.lpc_1.k60(this.epc_1.tpc_1.spc_1.vpc(this.kpc_1, this.jpc_1), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 9:
            this.ipc_1 = suspendResult;
            this.f9_1 = 10;
            continue $sm;
          case 10:
            if (this.ipc_1) {
              this.hpc_1 = true;
              this.f9_1 = 13;
              continue $sm;
            } else {
              this.f9_1 = 11;
              continue $sm;
            }

          case 11:
            this.f9_1 = 7;
            continue $sm;
          case 12:
            this.hpc_1 = false;
            if (false) {
              this.f9_1 = 5;
              continue $sm;
            }

            this.f9_1 = 13;
            continue $sm;
          case 13:
            this.gpc_1 = this.hpc_1;
            if (false) {
              this.f9_1 = 1;
              continue $sm;
            }

            this.f9_1 = 14;
            continue $sm;
          case 14:
            return this.gpc_1;
          case 15:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 15) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function TaxonScopeFilter$apply$$inlined$suspendingQuery$1(this$0, $target) {
    this.tpc_1 = this$0;
    this.upc_1 = $target;
  }
  protoOf(TaxonScopeFilter$apply$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_90(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(TaxonScopeFilter$apply$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function TaxonScopeFilter(taxons) {
    this.rpc_1 = taxons;
    this.spc_1 = ontologyElementHierarchy();
  }
  protoOf(TaxonScopeFilter).upb = function (target) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new TaxonScopeFilter$apply$$inlined$suspendingQuery$1(this, target);
  };
  protoOf(TaxonScopeFilter).j71 = function (target) {
    return this.upb(isInterface(target, OntologyElement_1) ? target : THROW_CCE());
  };
  function TaxonScopeFilterService$Companion$default$1() {
  }
  protoOf(TaxonScopeFilterService$Companion$default$1).cml = function (elements) {
    return new TaxonScopeFilter(elements);
  };
  function Companion_361() {
    Companion_instance_361 = this;
    var tmp = this;
    tmp.wpc_1 = new TaxonScopeFilterService$Companion$default$1();
  }
  protoOf(Companion_361).g3b = function () {
    return this.wpc_1;
  };
  var Companion_instance_361;
  function Companion_getInstance_361() {
    if (Companion_instance_361 == null)
      new Companion_361();
    return Companion_instance_361;
  }
  function TaxonScopeFilterService() {
  }
  function InheritedPropertiesCalculator$PropertiesUpdate$Companion$$childSerializers$_anonymous__dt8se1() {
    return new ArrayListSerializer($serializer_getInstance());
  }
  function Companion_362() {
    Companion_instance_362 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.xpc_1 = [null, lazy_0(tmp_0, InheritedPropertiesCalculator$PropertiesUpdate$Companion$$childSerializers$_anonymous__dt8se1)];
  }
  protoOf(Companion_362).i63 = function () {
    return $serializer_getInstance_33();
  };
  var Companion_instance_362;
  function Companion_getInstance_362() {
    if (Companion_instance_362 == null)
      new Companion_362();
    return Companion_instance_362;
  }
  function $serializer_35() {
    $serializer_instance_33 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('jetbrains.biokb.lang.model.services.InheritedPropertiesCalculator.PropertiesUpdate', this, 2);
    tmp0_serialDesc.q5j('processPointer', false);
    tmp0_serialDesc.q5j('inheritedProperties', false);
    this.ypc_1 = tmp0_serialDesc;
  }
  protoOf($serializer_35).zpc = function (encoder, value) {
    var tmp0_desc = this.ypc_1;
    var tmp1_output = encoder.g5c(tmp0_desc);
    var tmp2_cached = Companion_getInstance_362().xpc_1;
    tmp1_output.w5d(tmp0_desc, 0, NodePointerSerializer_getInstance(), value.apd_1);
    tmp1_output.w5d(tmp0_desc, 1, tmp2_cached[1].a1(), value.bpd_1);
    tmp1_output.h5c(tmp0_desc);
  };
  protoOf($serializer_35).i59 = function (encoder, value) {
    return this.zpc(encoder, value instanceof PropertiesUpdate ? value : THROW_CCE());
  };
  protoOf($serializer_35).j59 = function (decoder) {
    var tmp0_desc = this.ypc_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.g5c(tmp0_desc);
    var tmp7_cached = Companion_getInstance_362().xpc_1;
    if (tmp6_input.v5c()) {
      tmp4_local0 = tmp6_input.s5c(tmp0_desc, 0, NodePointerSerializer_getInstance(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.s5c(tmp0_desc, 1, tmp7_cached[1].a1(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.w5c(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.s5c(tmp0_desc, 0, NodePointerSerializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.s5c(tmp0_desc, 1, tmp7_cached[1].a1(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.h5c(tmp0_desc);
    return PropertiesUpdate_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_35).v58 = function () {
    return this.ypc_1;
  };
  protoOf($serializer_35).f5k = function () {
    var tmp0_cached = Companion_getInstance_362().xpc_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [NodePointerSerializer_getInstance(), tmp0_cached[1].a1()];
  };
  var $serializer_instance_33;
  function $serializer_getInstance_33() {
    if ($serializer_instance_33 == null)
      new $serializer_35();
    return $serializer_instance_33;
  }
  function PropertiesUpdate_init_$Init$(seen0, processPointer, inheritedProperties, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_33().ypc_1);
    }
    $this.apd_1 = processPointer;
    $this.bpd_1 = inheritedProperties;
    return $this;
  }
  function PropertiesUpdate_init_$Create$(seen0, processPointer, inheritedProperties, serializationConstructorMarker) {
    return PropertiesUpdate_init_$Init$(seen0, processPointer, inheritedProperties, serializationConstructorMarker, objectCreate(protoOf(PropertiesUpdate)));
  }
  function PropertiesUpdate() {
  }
  protoOf(PropertiesUpdate).toString = function () {
    return 'PropertiesUpdate(processPointer=' + this.apd_1.toString() + ', inheritedProperties=' + toString_1(this.bpd_1) + ')';
  };
  protoOf(PropertiesUpdate).hashCode = function () {
    var result = this.apd_1.hashCode();
    result = imul(result, 31) + hashCode(this.bpd_1) | 0;
    return result;
  };
  protoOf(PropertiesUpdate).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PropertiesUpdate))
      return false;
    if (!this.apd_1.equals(other.apd_1))
      return false;
    if (!equals(this.bpd_1, other.bpd_1))
      return false;
    return true;
  };
  function sam$kotlinx_coroutines_flow_FlowCollector$0_21(function_0) {
    this.cpd_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_21).x18 = function (value, $completion) {
    return this.cpd_1(value, $completion);
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_21).f3 = function () {
    return this.cpd_1;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_21).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, FlowCollector) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_21).hashCode = function () {
    return hashCode(this.f3());
  };
  function InheritedPropertiesCalculator$applyPropertiesFromFlow$slambda($processLibrary, $deserialize, $model, resultContinuation) {
    this.lpd_1 = $processLibrary;
    this.mpd_1 = $deserialize;
    this.npd_1 = $model;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(InheritedPropertiesCalculator$applyPropertiesFromFlow$slambda).ppd = function (update, $completion) {
    var tmp = this.qpd(update, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(InheritedPropertiesCalculator$applyPropertiesFromFlow$slambda).v9 = function (p1, $completion) {
    return this.ppd(p1 instanceof PropertiesUpdate ? p1 : THROW_CCE(), $completion);
  };
  protoOf(InheritedPropertiesCalculator$applyPropertiesFromFlow$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        if (tmp === 0) {
          this.g9_1 = 1;
          var processes = this.lpd_1.xft().m5y();
          var tmp$ret$0 = Unit_instance;
          l$ret$1: do {
            var _iterator__ex2g4s = processes.m();
            while (_iterator__ex2g4s.n()) {
              var element = _iterator__ex2g4s.o();
              if (element.z3n().equals(this.opd_1.apd_1.nodeId)) {
                tmp$ret$0 = element;
                break l$ret$1;
              }
            }
            tmp$ret$0 = null;
          }
           while (false);
          var target = tmp$ret$0;
          if (target == null)
            null;
          else {
            target.uft().k2();
            var _iterator__ex2g4s_0 = this.opd_1.bpd_1.m();
            while (_iterator__ex2g4s_0.n()) {
              var element_0 = _iterator__ex2g4s_0.o();
              var otNode = this.mpd_1(element_0.content).h3o();
              var domainNode = toDomainNode(otNode, get_wrapperContext(this.npd_1));
              if (isInterface(domainNode, InheritedProcessProperty)) {
                target.uft().j(domainNode);
              }
            }
          }
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(InheritedPropertiesCalculator$applyPropertiesFromFlow$slambda).qpd = function (update, completion) {
    var i = new InheritedPropertiesCalculator$applyPropertiesFromFlow$slambda(this.lpd_1, this.mpd_1, this.npd_1, completion);
    i.opd_1 = update;
    return i;
  };
  function InheritedPropertiesCalculator$applyPropertiesFromFlow$slambda_0($processLibrary, $deserialize, $model, resultContinuation) {
    var i = new InheritedPropertiesCalculator$applyPropertiesFromFlow$slambda($processLibrary, $deserialize, $model, resultContinuation);
    var l = function (update, $completion) {
      return i.ppd(update, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function InheritedPropertiesCalculator() {
    InheritedPropertiesCalculator_instance = this;
    this.rpd_1 = getLogger_0(getKClass(InheritedPropertiesCalculator));
  }
  protoOf(InheritedPropertiesCalculator).spd = function (flow, processLibrary, model, deserialize, $completion) {
    var tmp = InheritedPropertiesCalculator$applyPropertiesFromFlow$slambda_0(processLibrary, deserialize, model, null);
    return flow.f18(new sam$kotlinx_coroutines_flow_FlowCollector$0_21(tmp), $completion);
  };
  var InheritedPropertiesCalculator_instance;
  function InheritedPropertiesCalculator_getInstance() {
    if (InheritedPropertiesCalculator_instance == null)
      new InheritedPropertiesCalculator();
    return InheritedPropertiesCalculator_instance;
  }
  function LinkStub() {
  }
  function NotionStub() {
  }
  function PropertyStub() {
  }
  function _Capacity___init__impl__rwzzif(rawValue) {
    return rawValue;
  }
  function _get_rawValue__5zfu4e_0($this) {
    return $this;
  }
  function Companion_363() {
    Companion_instance_363 = this;
    this.tpd_1 = _Capacity___init__impl__rwzzif(-1);
  }
  protoOf(Companion_363).upd = function (value) {
    // Inline function 'kotlin.require' call
    if (!(value >= 0)) {
      var message = 'Capacity cannot be negative, got ' + value;
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    return _Capacity___init__impl__rwzzif(value);
  };
  var Companion_instance_363;
  function Companion_getInstance_363() {
    if (Companion_instance_363 == null)
      new Companion_363();
    return Companion_instance_363;
  }
  function Capacity__raw_impl_v7sf8h($this) {
    return _get_rawValue__5zfu4e_0($this);
  }
  function Capacity__canHold_impl_waeqig($this, amount) {
    return $this === Companion_getInstance_363().tpd_1 || _get_rawValue__5zfu4e_0($this) >= amount;
  }
  function Capacity__knownValueOrNull_impl_1u0da3($this) {
    return $this === Companion_getInstance_363().tpd_1 ? null : _get_rawValue__5zfu4e_0($this);
  }
  function Capacity__toString_impl_ss2o7t($this) {
    return $this === Companion_getInstance_363().tpd_1 ? 'UNKNOWN' : _get_rawValue__5zfu4e_0($this).toString();
  }
  function Capacity__hashCode_impl_khvgyg($this) {
    return $this;
  }
  function Companion_364() {
    Companion_instance_364 = this;
    this.vpd_1 = new FlowBounds(1, Companion_getInstance_363().tpd_1);
  }
  protoOf(Companion_364).wpd = function (count) {
    return new FlowBounds(count, Companion_getInstance_363().upd(count));
  };
  var Companion_instance_364;
  function Companion_getInstance_364() {
    if (Companion_instance_364 == null)
      new Companion_364();
    return Companion_instance_364;
  }
  function FlowBounds(min, max) {
    Companion_getInstance_364();
    this.xpd_1 = min;
    this.ypd_1 = max;
    // Inline function 'kotlin.require' call
    if (!(this.xpd_1 >= 0)) {
      var message = 'Lower bound cannot be negative, got ' + this.xpd_1;
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    // Inline function 'kotlin.require' call
    if (!Capacity__canHold_impl_waeqig(this.ypd_1, this.xpd_1)) {
      var message_0 = 'Upper bound ' + Capacity__toString_impl_ss2o7t(this.ypd_1) + ' is below the lower bound ' + this.xpd_1;
      throw IllegalArgumentException_init_$Create$_0(toString_1(message_0));
    }
  }
  protoOf(FlowBounds).toString = function () {
    return 'FlowBounds(min=' + this.xpd_1 + ', max=' + Capacity__toString_impl_ss2o7t(this.ypd_1) + ')';
  };
  protoOf(FlowBounds).hashCode = function () {
    var result = this.xpd_1;
    result = imul(result, 31) + Capacity__hashCode_impl_khvgyg(this.ypd_1) | 0;
    return result;
  };
  protoOf(FlowBounds).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof FlowBounds))
      return false;
    if (!(this.xpd_1 === other.xpd_1))
      return false;
    if (!(this.ypd_1 === other.ypd_1))
      return false;
    return true;
  };
  function consumeRaw(capacityRaw, amount) {
    return capacityRaw === -1 ? -1 : capacityRaw - amount | 0;
  }
  function isAvailableRaw(capacityRaw) {
    return capacityRaw === -1 || capacityRaw > 0;
  }
  function limitRaw(capacityRaw, requested) {
    var tmp;
    if (capacityRaw === -1) {
      tmp = requested;
    } else {
      // Inline function 'kotlin.comparisons.minOf' call
      tmp = Math.min(capacityRaw, requested);
    }
    return tmp;
  }
  function restoreRaw(capacityRaw, amount) {
    return capacityRaw === -1 ? -1 : capacityRaw + amount | 0;
  }
  function get_noopTraverseCycleHandler() {
    _init_properties_GraphByClosure_kt__tlbrze();
    return noopTraverseCycleHandler;
  }
  var noopTraverseCycleHandler;
  function get_noopReachableCycleHandler() {
    _init_properties_GraphByClosure_kt__tlbrze();
    return noopReachableCycleHandler;
  }
  var noopReachableCycleHandler;
  function getFrames($this) {
    return asSequence_2(new TraversalContext$getFrames$1($this));
  }
  function TraversalContext$pathNodesAndEdges$delegate$lambda$lambda(it) {
    return to(it.glr_1, it.cpe_1);
  }
  function TraversalContext$pathNodesAndEdges$delegate$lambda(this$0) {
    return function () {
      var tmp = getFrames(this$0);
      return reversed(toList_2(map(tmp, TraversalContext$pathNodesAndEdges$delegate$lambda$lambda)));
    };
  }
  function TraversalContext$pathNodes$delegate$lambda$lambda(it) {
    return it.glr_1;
  }
  function TraversalContext$pathNodes$delegate$lambda(this$0) {
    return function () {
      var tmp = getFrames(this$0);
      return reversed(toList_2(map(tmp, TraversalContext$pathNodes$delegate$lambda$lambda)));
    };
  }
  function TraversalContext$_get_pathNodes_$ref_o1ieo1() {
    return function (p0) {
      return p0.cm6();
    };
  }
  function TraversalContext$getFrames$1(this$0) {
    this.dpe_1 = this$0.ilr_1.hlr_1;
  }
  protoOf(TraversalContext$getFrames$1).n = function () {
    return !(this.dpe_1 == null);
  };
  protoOf(TraversalContext$getFrames$1).o = function () {
    if (this.dpe_1 == null) {
      throw NoSuchElementException_init_$Create$();
    }
    var result = ensureNotNull(this.dpe_1);
    this.dpe_1 = result.hlr_1;
    return result;
  };
  function TraversalContext(frame) {
    this.ilr_1 = frame;
    this.jlr_1 = false;
    var tmp = this;
    tmp.klr_1 = lazy(TraversalContext$pathNodesAndEdges$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.llr_1 = lazy(TraversalContext$pathNodes$delegate$lambda(this));
  }
  protoOf(TraversalContext).nlr = function () {
    return this.jlr_1;
  };
  protoOf(TraversalContext).w85 = function () {
    return this.ilr_1.glr_1;
  };
  protoOf(TraversalContext).mlr = function (node) {
    var tmp0 = getFrames(this);
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.sequences.any' call
      var _iterator__ex2g4s = tmp0.m();
      while (_iterator__ex2g4s.n()) {
        var element = _iterator__ex2g4s.o();
        if (equals(element.glr_1, node)) {
          tmp$ret$1 = true;
          break $l$block;
        }
      }
      tmp$ret$1 = false;
    }
    return tmp$ret$1;
  };
  protoOf(TraversalContext).cm6 = function () {
    var tmp0 = this.llr_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('pathNodes', 1, tmp, TraversalContext$_get_pathNodes_$ref_o1ieo1(), null);
    return tmp0.a1();
  };
  function asTraverse(_this__u8e3s4) {
    _init_properties_GraphByClosure_kt__tlbrze();
    var tmp;
    if (isNoOp(_this__u8e3s4)) {
      tmp = getNoopTraverseCycleHandler();
    } else {
      tmp = asTraverse$lambda(_this__u8e3s4);
    }
    return tmp;
  }
  function Frame_0(node, prevFrame) {
    this.glr_1 = node;
    this.hlr_1 = prevFrame;
  }
  function PostProcessChildNodeFrame(node, prevFrame, edges, edge) {
    Frame_0.call(this, node, prevFrame);
    this.bpe_1 = edges;
    this.cpe_1 = edge;
  }
  function getNoopTraverseCycleHandler() {
    _init_properties_GraphByClosure_kt__tlbrze();
    return get_noopTraverseCycleHandler();
  }
  function PreProcessNodeFrame(node, prevFrame) {
    Frame_0.call(this, node, prevFrame);
  }
  function isNoop(_this__u8e3s4) {
    _init_properties_GraphByClosure_kt__tlbrze();
    return equals(_this__u8e3s4, get_noopTraverseCycleHandler());
  }
  function createChildProcessingFrame(_this__u8e3s4, edges) {
    _init_properties_GraphByClosure_kt__tlbrze();
    return createChildProcessingFrame_0(_this__u8e3s4.glr_1, _this__u8e3s4.hlr_1, edges);
  }
  function createNextChildProcessingFrame(_this__u8e3s4) {
    _init_properties_GraphByClosure_kt__tlbrze();
    return createChildProcessingFrame_0(_this__u8e3s4.glr_1, _this__u8e3s4.hlr_1, _this__u8e3s4.bpe_1);
  }
  function PostProcessNodeFrame(node, prevFrame) {
    Frame_0.call(this, node, prevFrame);
  }
  function isNoOp(_this__u8e3s4) {
    _init_properties_GraphByClosure_kt__tlbrze();
    return equals(_this__u8e3s4, get_noopReachableCycleHandler());
  }
  function createChildProcessingFrame_0(node, prevFrame, edges) {
    _init_properties_GraphByClosure_kt__tlbrze();
    var tmp;
    if (edges.n()) {
      var _destruct__k2r9zo = edges.o();
      var nextNode = _destruct__k2r9zo.fg();
      var nextEdge = _destruct__k2r9zo.gg();
      var postChildNodeFrame = new PostProcessChildNodeFrame(node, prevFrame, edges, nextEdge);
      tmp = new PreProcessNodeFrame(nextNode, postChildNodeFrame);
    } else {
      tmp = new PostProcessNodeFrame(node, prevFrame);
    }
    return tmp;
  }
  function noopTraverseCycleHandler$lambda(_this__u8e3s4) {
    _init_properties_GraphByClosure_kt__tlbrze();
    return Unit_instance;
  }
  function noopReachableCycleHandler$lambda(_unused_var__etf5q3, _unused_var__etf5q3_0) {
    _init_properties_GraphByClosure_kt__tlbrze();
    return Unit_instance;
  }
  function asTraverse$lambda($this_asTraverse) {
    return function (_this__u8e3s4) {
      $this_asTraverse(_this__u8e3s4.w85(), _this__u8e3s4.cm6());
      return Unit_instance;
    };
  }
  var properties_initialized_GraphByClosure_kt_8c6fzs;
  function _init_properties_GraphByClosure_kt__tlbrze() {
    if (!properties_initialized_GraphByClosure_kt_8c6fzs) {
      properties_initialized_GraphByClosure_kt_8c6fzs = true;
      noopTraverseCycleHandler = noopTraverseCycleHandler$lambda;
      noopReachableCycleHandler = noopReachableCycleHandler$lambda;
    }
  }
  function Companion_365() {
    this.epe_1 = 64;
  }
  var Companion_instance_365;
  function Companion_getInstance_365() {
    return Companion_instance_365;
  }
  function findShortestHopPath($this, source, sink, limit) {
    if ($this.mpe_1 === 2147483647) {
      fill($this.ipe_1, 0);
      $this.mpe_1 = 0;
    }
    $this.mpe_1 = $this.mpe_1 + 1 | 0;
    var generation = $this.mpe_1;
    $this.ipe_1[source] = generation;
    $this.kpe_1[source] = limit;
    var queueHead = 0;
    var queueTail = 0;
    var _unary__edvuaz = queueTail;
    queueTail = _unary__edvuaz + 1 | 0;
    $this.lpe_1[_unary__edvuaz] = source;
    while (queueHead < queueTail) {
      var _unary__edvuaz_0 = queueHead;
      queueHead = _unary__edvuaz_0 + 1 | 0;
      var node = $this.lpe_1[_unary__edvuaz_0];
      var edgeId = $this.gpe_1[node];
      while (!(edgeId === -1)) {
        var nextNode = $this.ppe_1[edgeId];
        if (!($this.ipe_1[nextNode] === generation) && isAvailableRaw($this.rpe_1[edgeId])) {
          $this.ipe_1[nextNode] = generation;
          $this.jpe_1[nextNode] = edgeId;
          $this.kpe_1[nextNode] = limitRaw($this.rpe_1[edgeId], $this.kpe_1[node]);
          if (nextNode === sink)
            return $this.kpe_1[nextNode];
          var _unary__edvuaz_1 = queueTail;
          queueTail = _unary__edvuaz_1 + 1 | 0;
          $this.lpe_1[_unary__edvuaz_1] = nextNode;
        }
        edgeId = $this.qpe_1[edgeId];
      }
    }
    return 0;
  }
  function augmentPath($this, source, sink, amount) {
    var node = sink;
    while (!(node === source)) {
      var edgeId = $this.jpe_1[node];
      var reverseEdgeId = edgeId ^ 1;
      $this.rpe_1[edgeId] = consumeRaw($this.rpe_1[edgeId], amount);
      $this.rpe_1[reverseEdgeId] = restoreRaw($this.rpe_1[reverseEdgeId], amount);
      var _array__4zh2yp = $this.spe_1;
      _array__4zh2yp[edgeId] = _array__4zh2yp[edgeId] + amount | 0;
      var _array__4zh2yp_0 = $this.spe_1;
      _array__4zh2yp_0[reverseEdgeId] = _array__4zh2yp_0[reverseEdgeId] - amount | 0;
      node = $this.ope_1[edgeId];
    }
  }
  function addResidualEdge($this, edgeId, from, to, capacityRaw) {
    $this.ope_1[edgeId] = from;
    $this.ppe_1[edgeId] = to;
    $this.rpe_1[edgeId] = capacityRaw;
    $this.qpe_1[edgeId] = -1;
    if ($this.gpe_1[from] === -1) {
      $this.gpe_1[from] = edgeId;
    } else {
      $this.qpe_1[$this.hpe_1[from]] = edgeId;
    }
    $this.hpe_1[from] = edgeId;
  }
  function ensureEdgeCapacity($this, required) {
    if ($this.ope_1.length >= required)
      return Unit_instance;
    // Inline function 'kotlin.comparisons.maxOf' call
    var b = imul($this.ope_1.length, 2);
    var newCapacity = Math.max(required, b);
    $this.ope_1 = copyOf($this.ope_1, newCapacity);
    $this.ppe_1 = copyOf($this.ppe_1, newCapacity);
    $this.qpe_1 = copyOf($this.qpe_1, newCapacity);
    $this.rpe_1 = copyOf($this.rpe_1, newCapacity);
    $this.spe_1 = copyOf($this.spe_1, newCapacity);
  }
  function requireNode($this, node, name) {
    // Inline function 'kotlin.require' call
    if (!(0 <= node ? node < $this.fpe_1 : false)) {
      var message = name + ' node ' + node + ' out of range [0, ' + $this.fpe_1 + ')';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
  }
  function MaxFlowGraph(nodeCount, initialEdgeCapacity) {
    initialEdgeCapacity = initialEdgeCapacity === VOID ? 64 : initialEdgeCapacity;
    this.fpe_1 = nodeCount;
    var tmp = this;
    var tmp_0 = 0;
    var tmp_1 = this.fpe_1;
    var tmp_2 = new Int32Array(tmp_1);
    while (tmp_0 < tmp_1) {
      tmp_2[tmp_0] = -1;
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp.gpe_1 = tmp_2;
    var tmp_3 = this;
    var tmp_4 = 0;
    var tmp_5 = this.fpe_1;
    var tmp_6 = new Int32Array(tmp_5);
    while (tmp_4 < tmp_5) {
      tmp_6[tmp_4] = -1;
      tmp_4 = tmp_4 + 1 | 0;
    }
    tmp_3.hpe_1 = tmp_6;
    this.ipe_1 = new Int32Array(this.fpe_1);
    this.jpe_1 = new Int32Array(this.fpe_1);
    this.kpe_1 = new Int32Array(this.fpe_1);
    this.lpe_1 = new Int32Array(this.fpe_1);
    this.mpe_1 = 0;
    this.npe_1 = 0;
    this.ope_1 = new Int32Array(initialEdgeCapacity);
    this.ppe_1 = new Int32Array(initialEdgeCapacity);
    this.qpe_1 = new Int32Array(initialEdgeCapacity);
    this.rpe_1 = new Int32Array(initialEdgeCapacity);
    this.spe_1 = new Int32Array(initialEdgeCapacity);
    // Inline function 'kotlin.require' call
    if (!(this.fpe_1 >= 0)) {
      var message = 'nodeCount cannot be negative, got ' + this.fpe_1;
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
  }
  protoOf(MaxFlowGraph).tpe = function (from, to, capacityRaw) {
    requireNode(this, from, 'from');
    requireNode(this, to, 'to');
    // Inline function 'kotlin.require' call
    if (!(capacityRaw === -1 || capacityRaw >= 0)) {
      var message = 'Capacity cannot be negative, got ' + capacityRaw;
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    ensureEdgeCapacity(this, this.npe_1 + 2 | 0);
    var forwardEdgeId = this.npe_1;
    this.npe_1 = this.npe_1 + 2 | 0;
    addResidualEdge(this, forwardEdgeId, from, to, capacityRaw);
    addResidualEdge(this, forwardEdgeId ^ 1, to, from, 0);
    return forwardEdgeId;
  };
  protoOf(MaxFlowGraph).upe = function (source, sink, limit) {
    requireNode(this, source, 'source');
    requireNode(this, sink, 'sink');
    if (source === sink || limit <= 0)
      return 0;
    var totalFlow = 0;
    $l$loop: while (totalFlow < limit) {
      var pushed = findShortestHopPath(this, source, sink, limit - totalFlow | 0);
      if (pushed === 0)
        break $l$loop;
      augmentPath(this, source, sink, pushed);
      totalFlow = totalFlow + pushed | 0;
    }
    return totalFlow;
  };
  var MatchingMode_EXACT_instance;
  var MatchingMode_COVER_RIGHT_instance;
  var MatchingMode_entriesInitialized;
  function MatchingMode_initEntries() {
    if (MatchingMode_entriesInitialized)
      return Unit_instance;
    MatchingMode_entriesInitialized = true;
    MatchingMode_EXACT_instance = new MatchingMode('EXACT', 0);
    MatchingMode_COVER_RIGHT_instance = new MatchingMode('COVER_RIGHT', 1);
  }
  function LeftNode(ordinal, value) {
    this.vpe_1 = ordinal;
    this.wpe_1 = value;
  }
  function RightNode(ordinal, value) {
    this.xpe_1 = ordinal;
    this.ype_1 = value;
  }
  function hasFeasibleMatch($this, mode, leftBounds, rightBounds, leftEndpoints, rightEndpoints) {
    if (isObviouslyInfeasible(leftBounds, rightBounds) || (mode.equals(MatchingMode_EXACT_getInstance()) && isObviouslyInfeasible(rightBounds, leftBounds))) {
      return false;
    }
    // Inline function 'jetbrains.biokb.lang.model.util.MultisetMatching.buildNetwork' call
    var network = new FeasibleFlowNetwork(nodeCount($this, leftBounds, rightBounds));
    var inductionVariable = 0;
    var last = leftBounds.p() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var left = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var min = mode.equals(MatchingMode_COVER_RIGHT_getInstance()) ? 0 : leftBounds.r(left).xpd_1;
        network.apf(2, leftNode($this, left), min, Capacity__raw_impl_v7sf8h(leftBounds.r(left).ypd_1));
      }
       while (inductionVariable <= last);
    var inductionVariable_0 = 0;
    var last_0 = rightBounds.p() - 1 | 0;
    if (inductionVariable_0 <= last_0)
      do {
        var right = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        network.apf(rightNode($this, right, leftBounds.p()), 3, rightBounds.r(right).xpd_1, Capacity__raw_impl_v7sf8h(rightBounds.r(right).ypd_1));
      }
       while (inductionVariable_0 <= last_0);
    var inductionVariable_1 = 0;
    var last_1 = $this.hpf_1;
    if (inductionVariable_1 < last_1)
      do {
        var edge = inductionVariable_1;
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        var tmp4 = leftNode($this, leftEndpoints[edge]);
        var to = rightNode($this, rightEndpoints[edge], leftBounds.p());
        network.ipf(tmp4, to);
      }
       while (inductionVariable_1 < last_1);
    network.ipf(3, 2);
    var network_0 = network;
    return network_0.lpf(0, 1);
  }
  function hasFeasibleMatch$default($this, mode, leftBounds, rightBounds, leftEndpoints, rightEndpoints, $super) {
    leftBounds = leftBounds === VOID ? $this.bpf_1 : leftBounds;
    rightBounds = rightBounds === VOID ? $this.cpf_1 : rightBounds;
    leftEndpoints = leftEndpoints === VOID ? $this.fpf_1 : leftEndpoints;
    rightEndpoints = rightEndpoints === VOID ? $this.gpf_1 : rightEndpoints;
    return hasFeasibleMatch($this, mode, leftBounds, rightBounds, leftEndpoints, rightEndpoints);
  }
  function nodeCount($this, leftBounds, rightBounds) {
    return (4 + leftBounds.p() | 0) + rightBounds.p() | 0;
  }
  function leftNode($this, index) {
    return 4 + index | 0;
  }
  function rightNode($this, index, leftCount) {
    return (4 + leftCount | 0) + index | 0;
  }
  function MatchingMode(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function Companion_366() {
    this.mpf_1 = 0;
    this.npf_1 = 1;
    this.opf_1 = 2;
    this.ppf_1 = 3;
    this.qpf_1 = 4;
    this.rpf_1 = 16;
  }
  var Companion_instance_366;
  function Companion_getInstance_366() {
    return Companion_instance_366;
  }
  function MatchingMode_EXACT_getInstance() {
    MatchingMode_initEntries();
    return MatchingMode_EXACT_instance;
  }
  function MatchingMode_COVER_RIGHT_getInstance() {
    MatchingMode_initEntries();
    return MatchingMode_COVER_RIGHT_instance;
  }
  function MultisetMatching(left, right) {
    var tmp = this;
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(left, 10));
    var _iterator__ex2g4s = left.m();
    while (_iterator__ex2g4s.n()) {
      var item = _iterator__ex2g4s.o();
      var tmp$ret$0 = item.tpf_1;
      destination.j(tmp$ret$0);
    }
    tmp.bpf_1 = destination;
    var tmp_0 = this;
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(right, 10));
    var _iterator__ex2g4s_0 = right.m();
    while (_iterator__ex2g4s_0.n()) {
      var item_0 = _iterator__ex2g4s_0.o();
      var tmp$ret$3 = item_0.tpf_1;
      destination_0.j(tmp$ret$3);
    }
    tmp_0.cpf_1 = destination_0;
    var tmp_1 = this;
    // Inline function 'kotlin.collections.mapIndexed' call
    // Inline function 'kotlin.collections.mapIndexedTo' call
    var destination_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(left, 10));
    var index = 0;
    var _iterator__ex2g4s_1 = left.m();
    while (_iterator__ex2g4s_1.n()) {
      var item_1 = _iterator__ex2g4s_1.o();
      var _unary__edvuaz = index;
      index = _unary__edvuaz + 1 | 0;
      var index_0 = checkIndexOverflow(_unary__edvuaz);
      var tmp$ret$6 = new LeftNode(index_0, item_1.spf_1);
      destination_1.j(tmp$ret$6);
    }
    tmp_1.dpf_1 = destination_1;
    var tmp_2 = this;
    // Inline function 'kotlin.collections.mapIndexed' call
    // Inline function 'kotlin.collections.mapIndexedTo' call
    var destination_2 = ArrayList_init_$Create$_0(collectionSizeOrDefault(right, 10));
    var index_1 = 0;
    var _iterator__ex2g4s_2 = right.m();
    while (_iterator__ex2g4s_2.n()) {
      var item_2 = _iterator__ex2g4s_2.o();
      var _unary__edvuaz_0 = index_1;
      index_1 = _unary__edvuaz_0 + 1 | 0;
      var index_2 = checkIndexOverflow(_unary__edvuaz_0);
      var tmp$ret$9 = new RightNode(index_2, item_2.spf_1);
      destination_2.j(tmp$ret$9);
    }
    tmp_2.epf_1 = destination_2;
    this.fpf_1 = new Int32Array(16);
    this.gpf_1 = new Int32Array(16);
    this.hpf_1 = 0;
  }
  protoOf(MultisetMatching).upf = function () {
    return !isObviouslyInfeasible(this.bpf_1, this.cpf_1) && !isObviouslyInfeasible(this.cpf_1, this.bpf_1);
  };
  protoOf(MultisetMatching).vpf = function () {
    return !isObviouslyInfeasible(this.bpf_1, this.cpf_1);
  };
  protoOf(MultisetMatching).wpf = function (left, right) {
    if (this.hpf_1 === this.fpf_1.length) {
      this.fpf_1 = copyOf(this.fpf_1, imul(this.hpf_1, 2));
      this.gpf_1 = copyOf(this.gpf_1, imul(this.hpf_1, 2));
    }
    this.fpf_1[this.hpf_1] = left.vpe_1;
    this.gpf_1[this.hpf_1] = right.xpe_1;
    this.hpf_1 = this.hpf_1 + 1 | 0;
  };
  protoOf(MultisetMatching).xpf = function () {
    return hasFeasibleMatch$default(this, MatchingMode_EXACT_getInstance());
  };
  protoOf(MultisetMatching).ypf = function () {
    return hasFeasibleMatch$default(this, MatchingMode_COVER_RIGHT_getInstance());
  };
  function MultisetElement(value, bounds) {
    this.spf_1 = value;
    this.tpf_1 = bounds;
  }
  protoOf(MultisetElement).toString = function () {
    return 'MultisetElement(value=' + toString_0(this.spf_1) + ', bounds=' + this.tpf_1.toString() + ')';
  };
  protoOf(MultisetElement).hashCode = function () {
    var result = this.spf_1 == null ? 0 : hashCode(this.spf_1);
    result = imul(result, 31) + this.tpf_1.hashCode() | 0;
    return result;
  };
  protoOf(MultisetElement).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof MultisetElement))
      return false;
    if (!equals(this.spf_1, other.spf_1))
      return false;
    if (!this.tpf_1.equals(other.tpf_1))
      return false;
    return true;
  };
  function isObviouslyInfeasible(left, right) {
    var leftUpperBound = 0;
    var _iterator__ex2g4s = left.m();
    while (_iterator__ex2g4s.n()) {
      var bounds = _iterator__ex2g4s.o();
      var tmp = leftUpperBound;
      var tmp0_elvis_lhs = Capacity__knownValueOrNull_impl_1u0da3(bounds.ypd_1);
      var tmp_0;
      if (tmp0_elvis_lhs == null) {
        return false;
      } else {
        tmp_0 = tmp0_elvis_lhs;
      }
      leftUpperBound = tmp + tmp_0 | 0;
    }
    // Inline function 'kotlin.collections.sumOf' call
    var sum = 0;
    var _iterator__ex2g4s_0 = right.m();
    while (_iterator__ex2g4s_0.n()) {
      var element = _iterator__ex2g4s_0.o();
      var tmp_1 = sum;
      sum = tmp_1 + element.xpd_1 | 0;
    }
    return sum > leftUpperBound;
  }
  function FeasibleFlowNetwork(nodeCount) {
    LowerBoundFlowNetwork.call(this, nodeCount);
    this.kpf_1 = new MaxFlowGraph(nodeCount);
  }
  protoOf(FeasibleFlowNetwork).tpe = function (from, to, capacityRaw) {
    return this.kpf_1.tpe(from, to, capacityRaw);
  };
  protoOf(FeasibleFlowNetwork).lpf = function (superSource, superSink) {
    var mandatoryFlow = this.zpf(superSource, superSink);
    return this.kpf_1.upe(superSource, superSink, mandatoryFlow) === mandatoryFlow;
  };
  function LowerBoundFlowNetwork(nodeCount) {
    this.zpe_1 = new Int32Array(nodeCount);
  }
  protoOf(LowerBoundFlowNetwork).apf = function (from, to, min, maxRaw) {
    // Inline function 'kotlin.require' call
    if (!(min >= 0)) {
      var message = 'Lower bound cannot be negative, got ' + min;
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    // Inline function 'kotlin.require' call
    if (!(maxRaw === -1 || maxRaw >= min)) {
      var message_0 = 'Upper bound ' + maxRaw + ' is below lower bound ' + min;
      throw IllegalArgumentException_init_$Create$_0(toString_1(message_0));
    }
    var _array__4zh2yp = this.zpe_1;
    _array__4zh2yp[to] = _array__4zh2yp[to] + min | 0;
    var _array__4zh2yp_0 = this.zpe_1;
    _array__4zh2yp_0[from] = _array__4zh2yp_0[from] - min | 0;
    var slackRaw = consumeRaw(maxRaw, min);
    return isAvailableRaw(slackRaw) ? this.tpe(from, to, slackRaw) : null;
  };
  protoOf(LowerBoundFlowNetwork).ipf = function (from, to) {
    return this.tpe(from, to, -1);
  };
  protoOf(LowerBoundFlowNetwork).zpf = function (superSource, superSink) {
    var mandatoryFlow = 0;
    var inductionVariable = 0;
    var last = this.zpe_1.length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var node = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var nodeExcess = this.zpe_1[node];
        if (1 <= nodeExcess ? nodeExcess <= 2147483647 : false) {
          mandatoryFlow = mandatoryFlow + nodeExcess | 0;
          this.tpe(superSource, node, nodeExcess);
        } else if (-2147483648 <= nodeExcess ? nodeExcess <= -1 : false) {
          this.tpe(node, superSink, -nodeExcess | 0);
        }
      }
       while (inductionVariable <= last);
    return mandatoryFlow;
  };
  function AbstractOntologyElement() {
  }
  function AbstractClassReference() {
  }
  function AbstractElementDefinition() {
  }
  var SetType_OPEN_instance;
  var SetType_CLOSED_instance;
  var SetType_entriesInitialized;
  function SetType_initEntries() {
    if (SetType_entriesInitialized)
      return Unit_instance;
    SetType_entriesInitialized = true;
    SetType_OPEN_instance = new SetType('OPEN', 0);
    SetType_CLOSED_instance = new SetType('CLOSED', 1);
  }
  function Unknown_0() {
  }
  protoOf(Unknown_0).toString = function () {
    return 'Unknown';
  };
  protoOf(Unknown_0).hashCode = function () {
    return 450020612;
  };
  protoOf(Unknown_0).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Unknown_0))
      return false;
    return true;
  };
  var Unknown_instance_0;
  function Unknown_getInstance_0() {
    return Unknown_instance_0;
  }
  function Known(value) {
    this.cpg_1 = value;
    // Inline function 'kotlin.require' call
    if (!(this.cpg_1 > 0)) {
      var message = 'Multiplier must be positive, got ' + this.cpg_1;
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
  }
  protoOf(Known).toString = function () {
    return 'Known(value=' + this.cpg_1 + ')';
  };
  protoOf(Known).hashCode = function () {
    return this.cpg_1;
  };
  protoOf(Known).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Known))
      return false;
    if (!(this.cpg_1 === other.cpg_1))
      return false;
    return true;
  };
  function Constrainable() {
  }
  function None_0() {
  }
  protoOf(None_0).toString = function () {
    return 'None';
  };
  protoOf(None_0).hashCode = function () {
    return 1994162797;
  };
  protoOf(None_0).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof None_0))
      return false;
    return true;
  };
  var None_instance_0;
  function None_getInstance_0() {
    return None_instance_0;
  }
  function Enum_0(id) {
    this.dpg_1 = id;
  }
  protoOf(Enum_0).toString = function () {
    return 'Enum(id=' + this.dpg_1 + ')';
  };
  protoOf(Enum_0).hashCode = function () {
    return getStringHashCode(this.dpg_1);
  };
  protoOf(Enum_0).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Enum_0))
      return false;
    if (!(this.dpg_1 === other.dpg_1))
      return false;
    return true;
  };
  function Measurable(unitId, amount) {
    this.epg_1 = unitId;
    this.fpg_1 = amount;
  }
  protoOf(Measurable).toString = function () {
    return 'Measurable(unitId=' + this.epg_1 + ', amount=' + this.fpg_1.toString() + ')';
  };
  protoOf(Measurable).hashCode = function () {
    var result = getStringHashCode(this.epg_1);
    result = imul(result, 31) + this.fpg_1.hashCode() | 0;
    return result;
  };
  protoOf(Measurable).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Measurable))
      return false;
    if (!(this.epg_1 === other.epg_1))
      return false;
    if (!this.fpg_1.equals(other.fpg_1))
      return false;
    return true;
  };
  function StringVal(value) {
    this.gpg_1 = value;
  }
  protoOf(StringVal).toString = function () {
    return 'StringVal(value=' + this.gpg_1 + ')';
  };
  protoOf(StringVal).hashCode = function () {
    return getStringHashCode(this.gpg_1);
  };
  protoOf(StringVal).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof StringVal))
      return false;
    if (!(this.gpg_1 === other.gpg_1))
      return false;
    return true;
  };
  function IntegerVal(value) {
    this.hpg_1 = value;
  }
  protoOf(IntegerVal).toString = function () {
    return 'IntegerVal(value=' + this.hpg_1 + ')';
  };
  protoOf(IntegerVal).hashCode = function () {
    return this.hpg_1;
  };
  protoOf(IntegerVal).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof IntegerVal))
      return false;
    if (!(this.hpg_1 === other.hpg_1))
      return false;
    return true;
  };
  function ComplexNotion_2(notionId, elements) {
    this.ipg_1 = notionId;
    this.jpg_1 = elements;
  }
  protoOf(ComplexNotion_2).toString = function () {
    return 'ComplexNotion(notionId=' + this.ipg_1 + ', elements=' + toString_1(this.jpg_1) + ')';
  };
  protoOf(ComplexNotion_2).hashCode = function () {
    var result = getStringHashCode(this.ipg_1);
    result = imul(result, 31) + hashCode(this.jpg_1) | 0;
    return result;
  };
  protoOf(ComplexNotion_2).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ComplexNotion_2))
      return false;
    if (!(this.ipg_1 === other.ipg_1))
      return false;
    if (!equals(this.jpg_1, other.jpg_1))
      return false;
    return true;
  };
  function ClassValue(value) {
    this.ym4_1 = value;
  }
  protoOf(ClassValue).toString = function () {
    return 'ClassValue(value=' + toString_1(this.ym4_1) + ')';
  };
  protoOf(ClassValue).hashCode = function () {
    return hashCode(this.ym4_1);
  };
  protoOf(ClassValue).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ClassValue))
      return false;
    if (!equals(this.ym4_1, other.ym4_1))
      return false;
    return true;
  };
  function SetValue(elements, type) {
    this.kpg_1 = elements;
    this.lpg_1 = type;
  }
  protoOf(SetValue).mpg = function (elements, type) {
    return new SetValue(elements, type);
  };
  protoOf(SetValue).npg = function (elements, type, $super) {
    elements = elements === VOID ? this.kpg_1 : elements;
    type = type === VOID ? this.lpg_1 : type;
    return $super === VOID ? this.mpg(elements, type) : $super.mpg.call(this, elements, type);
  };
  protoOf(SetValue).toString = function () {
    return 'SetValue(elements=' + toString_1(this.kpg_1) + ', type=' + this.lpg_1.toString() + ')';
  };
  protoOf(SetValue).hashCode = function () {
    var result = hashCode(this.kpg_1);
    result = imul(result, 31) + this.lpg_1.hashCode() | 0;
    return result;
  };
  protoOf(SetValue).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SetValue))
      return false;
    if (!equals(this.kpg_1, other.kpg_1))
      return false;
    if (!this.lpg_1.equals(other.lpg_1))
      return false;
    return true;
  };
  function SetType(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function Constraint(property, value, operation) {
    operation = operation === VOID ? null : operation;
    this.opg_1 = property;
    this.ppg_1 = value;
    this.qpg_1 = operation;
  }
  protoOf(Constraint).toString = function () {
    return 'Constraint(property=' + toString_1(this.opg_1) + ', value=' + toString_1(this.ppg_1) + ', operation=' + toString_0(this.qpg_1) + ')';
  };
  protoOf(Constraint).hashCode = function () {
    var result = hashCode(this.opg_1);
    result = imul(result, 31) + hashCode(this.ppg_1) | 0;
    result = imul(result, 31) + (this.qpg_1 == null ? 0 : this.qpg_1.hashCode()) | 0;
    return result;
  };
  protoOf(Constraint).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Constraint))
      return false;
    if (!equals(this.opg_1, other.opg_1))
      return false;
    if (!equals(this.ppg_1, other.ppg_1))
      return false;
    if (!equals(this.qpg_1, other.qpg_1))
      return false;
    return true;
  };
  function ConstrainedValue(base, constraints) {
    this.rpg_1 = base;
    this.spg_1 = constraints;
  }
  protoOf(ConstrainedValue).toString = function () {
    return 'ConstrainedValue(base=' + toString_1(this.rpg_1) + ', constraints=' + toString_1(this.spg_1) + ')';
  };
  protoOf(ConstrainedValue).hashCode = function () {
    var result = hashCode(this.rpg_1);
    result = imul(result, 31) + hashCode(this.spg_1) | 0;
    return result;
  };
  protoOf(ConstrainedValue).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ConstrainedValue))
      return false;
    if (!equals(this.rpg_1, other.rpg_1))
      return false;
    if (!equals(this.spg_1, other.spg_1))
      return false;
    return true;
  };
  function RelationFactExpressionDescriptor(left, relation, right) {
    this.tpg_1 = left;
    this.upg_1 = relation;
    this.vpg_1 = right;
  }
  protoOf(RelationFactExpressionDescriptor).toString = function () {
    return 'RelationFactExpressionDescriptor(left=' + toString_1(this.tpg_1) + ', relation=' + toString_1(this.upg_1) + ', right=' + toString_1(this.vpg_1) + ')';
  };
  protoOf(RelationFactExpressionDescriptor).hashCode = function () {
    var result = hashCode(this.tpg_1);
    result = imul(result, 31) + hashCode(this.upg_1) | 0;
    result = imul(result, 31) + hashCode(this.vpg_1) | 0;
    return result;
  };
  protoOf(RelationFactExpressionDescriptor).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RelationFactExpressionDescriptor))
      return false;
    if (!equals(this.tpg_1, other.tpg_1))
      return false;
    if (!equals(this.upg_1, other.upg_1))
      return false;
    if (!equals(this.vpg_1, other.vpg_1))
      return false;
    return true;
  };
  function LibraryProcessSpecificationDescriptor() {
  }
  function SetType_OPEN_getInstance() {
    SetType_initEntries();
    return SetType_OPEN_instance;
  }
  function SetType_CLOSED_getInstance() {
    SetType_initEntries();
    return SetType_CLOSED_instance;
  }
  function ParameterBinding(aliasRoots, value) {
    this.xpg_1 = aliasRoots;
    this.ypg_1 = value;
  }
  protoOf(ParameterBinding).toString = function () {
    return 'ParameterBinding(aliasRoots=' + toString_1(this.xpg_1) + ', value=' + toString_1(this.ypg_1) + ')';
  };
  protoOf(ParameterBinding).hashCode = function () {
    var result = hashCode(this.xpg_1);
    result = imul(result, 31) + hashCode(this.ypg_1) | 0;
    return result;
  };
  protoOf(ParameterBinding).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ParameterBinding))
      return false;
    if (!equals(this.xpg_1, other.xpg_1))
      return false;
    if (!equals(this.ypg_1, other.ypg_1))
      return false;
    return true;
  };
  function PropertyConstraintValue(value, nestedConstraints) {
    this.zpg_1 = value;
    this.aph_1 = nestedConstraints;
  }
  protoOf(PropertyConstraintValue).toString = function () {
    return 'PropertyConstraintValue(value=' + toString_1(this.zpg_1) + ', nestedConstraints=' + toString_1(this.aph_1) + ')';
  };
  protoOf(PropertyConstraintValue).hashCode = function () {
    var result = hashCode(this.zpg_1);
    result = imul(result, 31) + hashCode(this.aph_1) | 0;
    return result;
  };
  protoOf(PropertyConstraintValue).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PropertyConstraintValue))
      return false;
    if (!equals(this.zpg_1, other.zpg_1))
      return false;
    if (!equals(this.aph_1, other.aph_1))
      return false;
    return true;
  };
  function toPropertyConstraintValue(_this__u8e3s4) {
    var tmp;
    if (_this__u8e3s4 instanceof ConstrainedValue) {
      // Inline function 'kotlin.collections.map' call
      var this_0 = _this__u8e3s4.spg_1;
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
      var _iterator__ex2g4s = this_0.m();
      while (_iterator__ex2g4s.n()) {
        var item = _iterator__ex2g4s.o();
        var tmp$ret$0 = toPropertyConstraintDescriptor(item);
        destination.j(tmp$ret$0);
      }
      tmp = new PropertyConstraintValue(_this__u8e3s4.rpg_1, destination);
    } else {
      if (isInterface(_this__u8e3s4, Constrainable)) {
        tmp = new PropertyConstraintValue(_this__u8e3s4, emptyList());
      } else {
        if (_this__u8e3s4 instanceof RelationFactExpressionDescriptor) {
          tmp = new PropertyConstraintValue(None_instance_0, emptyList());
        } else {
          noWhenBranchMatchedException();
        }
      }
    }
    return tmp;
  }
  function AbstractNotionDescriptor() {
  }
  function toPropertyConstraintDescriptor(_this__u8e3s4) {
    var constraintValue = toPropertyConstraintValue(_this__u8e3s4.ppg_1);
    return new ValueConstraintDescriptor(_this__u8e3s4.opg_1, constraintValue.zpg_1, constraintValue.aph_1, _this__u8e3s4.qpg_1);
  }
  function ValueConstraintDescriptor$property$$inlined$suspendingQuery$1(this$0) {
    this.bph_1 = this$0;
  }
  protoOf(ValueConstraintDescriptor$property$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    return this.bph_1.cph_1;
  };
  protoOf(ValueConstraintDescriptor$property$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function ValueConstraintDescriptor$value$$inlined$suspendingQuery$1(this$0) {
    this.gph_1 = this$0;
  }
  protoOf(ValueConstraintDescriptor$value$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    return this.gph_1.dph_1;
  };
  protoOf(ValueConstraintDescriptor$value$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function ValueConstraintDescriptor$constraints$$inlined$suspendingQuery$1(this$0) {
    this.hph_1 = this$0;
  }
  protoOf(ValueConstraintDescriptor$constraints$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    return this.hph_1.eph_1;
  };
  protoOf(ValueConstraintDescriptor$constraints$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function ValueConstraintDescriptor$operation$$inlined$suspendingQuery$1(this$0) {
    this.iph_1 = this$0;
  }
  protoOf(ValueConstraintDescriptor$operation$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    return this.iph_1.fph_1;
  };
  protoOf(ValueConstraintDescriptor$operation$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function ValueConstraintDescriptor(propertyDescriptor, constraintValue, nestedConstraints, constraintOperation) {
    constraintOperation = constraintOperation === VOID ? null : constraintOperation;
    this.cph_1 = propertyDescriptor;
    this.dph_1 = constraintValue;
    this.eph_1 = nestedConstraints;
    this.fph_1 = constraintOperation;
  }
  protoOf(ValueConstraintDescriptor).q6q = function () {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new ValueConstraintDescriptor$property$$inlined$suspendingQuery$1(this);
  };
  protoOf(ValueConstraintDescriptor).a1 = function () {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new ValueConstraintDescriptor$value$$inlined$suspendingQuery$1(this);
  };
  protoOf(ValueConstraintDescriptor).ofr = function () {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new ValueConstraintDescriptor$constraints$$inlined$suspendingQuery$1(this);
  };
  protoOf(ValueConstraintDescriptor).s3z = function () {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new ValueConstraintDescriptor$operation$$inlined$suspendingQuery$1(this);
  };
  protoOf(ValueConstraintDescriptor).toString = function () {
    return 'ValueConstraintDescriptor(propertyDescriptor=' + toString_1(this.cph_1) + ', constraintValue=' + toString_1(this.dph_1) + ', nestedConstraints=' + toString_1(this.eph_1) + ', constraintOperation=' + toString_0(this.fph_1) + ')';
  };
  protoOf(ValueConstraintDescriptor).hashCode = function () {
    var result = hashCode(this.cph_1);
    result = imul(result, 31) + hashCode(this.dph_1) | 0;
    result = imul(result, 31) + hashCode(this.eph_1) | 0;
    result = imul(result, 31) + (this.fph_1 == null ? 0 : this.fph_1.hashCode()) | 0;
    return result;
  };
  protoOf(ValueConstraintDescriptor).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ValueConstraintDescriptor))
      return false;
    if (!equals(this.cph_1, other.cph_1))
      return false;
    if (!equals(this.dph_1, other.dph_1))
      return false;
    if (!equals(this.eph_1, other.eph_1))
      return false;
    if (!equals(this.fph_1, other.fph_1))
      return false;
    return true;
  };
  function AdapterCache() {
    this.jph_1 = HashMap_init_$Create$();
    this.kph_1 = HashMap_init_$Create$();
    this.lph_1 = HashMap_init_$Create$();
  }
  protoOf(AdapterCache).mph = function (origin) {
    // Inline function 'kotlin.collections.getOrPut' call
    var this_0 = this.jph_1;
    var value = this_0.q2(origin);
    var tmp;
    if (value == null) {
      var answer = new OntologyElementAdapter(origin, this);
      this_0.t2(origin, answer);
      tmp = answer;
    } else {
      tmp = value;
    }
    return tmp;
  };
  protoOf(AdapterCache).nph = function (definition) {
    // Inline function 'kotlin.collections.getOrPut' call
    var this_0 = this.kph_1;
    var value = this_0.q2(definition);
    var tmp;
    if (value == null) {
      var answer = new OntologyElementDefinitionAdapter(definition, this);
      this_0.t2(definition, answer);
      tmp = answer;
    } else {
      tmp = value;
    }
    return tmp;
  };
  protoOf(AdapterCache).oph = function (origin, create) {
    // Inline function 'kotlin.collections.getOrPut' call
    var this_0 = this.lph_1;
    var value = this_0.q2(origin);
    var tmp;
    if (value == null) {
      var answer = create();
      this_0.t2(origin, answer);
      tmp = answer;
    } else {
      tmp = value;
    }
    return tmp;
  };
  function toAdapter(_this__u8e3s4, cache) {
    cache = cache === VOID ? new AdapterCache() : cache;
    var tmp;
    if (isInterface(_this__u8e3s4, OntologyElement_1)) {
      tmp = cache.mph(_this__u8e3s4);
    } else {
      if (isInterface(_this__u8e3s4, UnionClass_1)) {
        tmp = new UnionClassAdapter(_this__u8e3s4, cache);
      } else {
        noWhenBranchMatchedException();
      }
    }
    return tmp;
  }
  function toAdapter_0(_this__u8e3s4, cache) {
    cache = cache === VOID ? new AdapterCache() : cache;
    return cache.mph(_this__u8e3s4);
  }
  function toAdapter_1(_this__u8e3s4, cache) {
    cache = cache === VOID ? new AdapterCache() : cache;
    return _this__u8e3s4.p() === 1 ? toAdapter(first_0(_this__u8e3s4), cache) : new ClassDeclarationSetAdapter(toSet_0(_this__u8e3s4), cache);
  }
  function OntologyElementAdapter$superElements$$inlined$cachedSuspendingQuery$1($isCached, $cachedValue, this$0) {
    this.pph_1 = $isCached;
    this.qph_1 = $cachedValue;
    this.rph_1 = this$0;
  }
  protoOf(OntologyElementAdapter$superElements$$inlined$cachedSuspendingQuery$1).b61 = function (builder, $completion) {
    if (!this.pph_1._v) {
      // Inline function 'kotlin.collections.mapNotNull' call
      var tmp0 = builder.l60(this.rph_1.sph_1.nfs());
      // Inline function 'kotlin.collections.mapNotNullTo' call
      var destination = ArrayList_init_$Create$();
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s = tmp0.m();
      while (_iterator__ex2g4s.n()) {
        var element = _iterator__ex2g4s.o();
        var tmp0_safe_receiver = element.eii();
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          destination.j(tmp0_safe_receiver);
        }
      }
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(destination, 10));
      var _iterator__ex2g4s_0 = destination.m();
      while (_iterator__ex2g4s_0.n()) {
        var item = _iterator__ex2g4s_0.o();
        var tmp$ret$7 = new OntologyElementReferenceAdapter(item, this.rph_1.tph_1);
        destination_0.j(tmp$ret$7);
      }
      this.qph_1._v = destination_0;
      this.pph_1._v = true;
    }
    var tmp = this.qph_1._v;
    return (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
  };
  protoOf(OntologyElementAdapter$superElements$$inlined$cachedSuspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function OntologyElementAdapter$definition$$inlined$cachedSuspendingQuery$1($isCached, $cachedValue, this$0) {
    this.xph_1 = $isCached;
    this.yph_1 = $cachedValue;
    this.zph_1 = this$0;
  }
  protoOf(OntologyElementAdapter$definition$$inlined$cachedSuspendingQuery$1).b61 = function (builder, $completion) {
    if (!this.xph_1._v) {
      var tmp0_safe_receiver = builder.l60(this.zph_1.sph_1.wfs());
      var tmp;
      if (tmp0_safe_receiver == null) {
        tmp = null;
      } else {
        // Inline function 'kotlin.let' call
        tmp = this.zph_1.tph_1.nph(tmp0_safe_receiver);
      }
      var tmp$ret$2 = tmp;
      this.yph_1._v = tmp$ret$2;
      this.xph_1._v = true;
    }
    var tmp_0 = this.yph_1._v;
    return (tmp_0 == null ? true : !(tmp_0 == null)) ? tmp_0 : THROW_CCE();
  };
  protoOf(OntologyElementAdapter$definition$$inlined$cachedSuspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function OntologyElementAdapter$ownProperties$$inlined$cachedSuspendingQuery$1($isCached, $cachedValue, this$0) {
    this.api_1 = $isCached;
    this.bpi_1 = $cachedValue;
    this.cpi_1 = this$0;
  }
  protoOf(OntologyElementAdapter$ownProperties$$inlined$cachedSuspendingQuery$1).b61 = function (builder, $completion) {
    if (!this.api_1._v) {
      var tmp$ret$0 = toAdapters(builder.l60(this.cpi_1.sph_1.ofr()), VOID, this.cpi_1.tph_1);
      this.bpi_1._v = tmp$ret$0;
      this.api_1._v = true;
    }
    var tmp = this.bpi_1._v;
    return (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
  };
  protoOf(OntologyElementAdapter$ownProperties$$inlined$cachedSuspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function OntologyElementAdapter(origin, cache) {
    this.sph_1 = origin;
    this.tph_1 = cache;
    var tmp = this;
    // Inline function 'jetbrains.biokb.lang.model.util.hierarchy.cachedSuspendingQuery' call
    var cachedValue = {_v: null};
    var isCached = {_v: false};
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    tmp.uph_1 = new OntologyElementAdapter$superElements$$inlined$cachedSuspendingQuery$1(isCached, cachedValue, this);
    var tmp_0 = this;
    // Inline function 'jetbrains.biokb.lang.model.util.hierarchy.cachedSuspendingQuery' call
    var cachedValue_0 = {_v: null};
    var isCached_0 = {_v: false};
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    tmp_0.vph_1 = new OntologyElementAdapter$definition$$inlined$cachedSuspendingQuery$1(isCached_0, cachedValue_0, this);
    var tmp_1 = this;
    // Inline function 'jetbrains.biokb.lang.model.util.hierarchy.cachedSuspendingQuery' call
    var cachedValue_1 = {_v: null};
    var isCached_1 = {_v: false};
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    tmp_1.wph_1 = new OntologyElementAdapter$ownProperties$$inlined$cachedSuspendingQuery$1(isCached_1, cachedValue_1, this);
  }
  protoOf(OntologyElementAdapter).cma = function () {
    return this.sph_1;
  };
  protoOf(OntologyElementAdapter).nfs = function () {
    return this.uph_1;
  };
  protoOf(OntologyElementAdapter).wfs = function () {
    return this.vph_1;
  };
  protoOf(OntologyElementAdapter).apg = function () {
    return this.wph_1;
  };
  protoOf(OntologyElementAdapter).equals = function (other) {
    var tmp;
    if (other instanceof OntologyElementAdapter) {
      tmp = equals(this.sph_1, other.sph_1);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(OntologyElementAdapter).hashCode = function () {
    return hashCode(this.sph_1);
  };
  protoOf(OntologyElementAdapter).toString = function () {
    return 'OntologyElementAdapter(origin=' + toString_1(this.sph_1) + ', cache=' + toString_1(this.tph_1) + ')';
  };
  function UnionClassAdapter$constraints$$inlined$suspendingQuery$1() {
  }
  protoOf(UnionClassAdapter$constraints$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    return emptyList();
  };
  protoOf(UnionClassAdapter$constraints$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function UnionClassAdapter(union, cache) {
    this.dpi_1 = union;
    this.epi_1 = cache;
  }
  protoOf(UnionClassAdapter).mfu = function () {
    return extractClassAdapters(this.dpi_1, this.epi_1);
  };
  protoOf(UnionClassAdapter).ofr = function () {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new UnionClassAdapter$constraints$$inlined$suspendingQuery$1();
  };
  protoOf(UnionClassAdapter).equals = function (other) {
    var tmp;
    if (other instanceof UnionClassAdapter) {
      tmp = equals(this.dpi_1, other.dpi_1);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(UnionClassAdapter).hashCode = function () {
    return hashCode(this.dpi_1);
  };
  protoOf(UnionClassAdapter).toString = function () {
    return 'UnionClassAdapter(union=' + toString_1(this.dpi_1) + ', cache=' + toString_1(this.epi_1) + ')';
  };
  function ClassDeclarationSetAdapter$classes$$inlined$suspendingQuery$1(this$0) {
    this.fpi_1 = this$0;
  }
  protoOf(ClassDeclarationSetAdapter$classes$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.fpi_1.gpi_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.m();
    while (_iterator__ex2g4s.n()) {
      var item = _iterator__ex2g4s.o();
      var tmp$ret$0 = toAdapter(item, this.fpi_1.hpi_1);
      destination.j(tmp$ret$0);
    }
    return destination;
  };
  protoOf(ClassDeclarationSetAdapter$classes$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function ClassDeclarationSetAdapter$constraints$$inlined$suspendingQuery$1() {
  }
  protoOf(ClassDeclarationSetAdapter$constraints$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    return emptyList();
  };
  protoOf(ClassDeclarationSetAdapter$constraints$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function ClassDeclarationSetAdapter(elements, cache) {
    this.gpi_1 = elements;
    this.hpi_1 = cache;
  }
  protoOf(ClassDeclarationSetAdapter).mfu = function () {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new ClassDeclarationSetAdapter$classes$$inlined$suspendingQuery$1(this);
  };
  protoOf(ClassDeclarationSetAdapter).ofr = function () {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new ClassDeclarationSetAdapter$constraints$$inlined$suspendingQuery$1();
  };
  protoOf(ClassDeclarationSetAdapter).equals = function (other) {
    var tmp;
    if (other instanceof ClassDeclarationSetAdapter) {
      tmp = equals(this.gpi_1, other.gpi_1);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(ClassDeclarationSetAdapter).hashCode = function () {
    return hashCode(this.gpi_1);
  };
  protoOf(ClassDeclarationSetAdapter).toString = function () {
    return 'ClassDeclarationSetAdapter(elements=' + toString_1(this.gpi_1) + ', cache=' + toString_1(this.hpi_1) + ')';
  };
  function $runSuspendCOROUTINE$_91(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.qpi_1 = _this__u8e3s4;
    this.rpi_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_91).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            var $this$suspendingQuery = this.rpi_1;
            this.f9_1 = 1;
            suspendResult = $this$suspendingQuery.k60(this.qpi_1.upi_1.spi_1.x6o(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp0_safe_receiver = suspendResult;
            var tmp_0;
            if (tmp0_safe_receiver == null) {
              tmp_0 = null;
            } else {
              tmp_0 = this.qpi_1.upi_1.tpi_1.mph(tmp0_safe_receiver);
            }

            return tmp_0;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function OntologyElementReferenceAdapter$element$$inlined$suspendingQuery$1(this$0) {
    this.upi_1 = this$0;
  }
  protoOf(OntologyElementReferenceAdapter$element$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_91(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(OntologyElementReferenceAdapter$element$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function OntologyElementReferenceAdapter(reference, cache) {
    this.spi_1 = reference;
    this.tpi_1 = cache;
  }
  protoOf(OntologyElementReferenceAdapter).gfq = function () {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new OntologyElementReferenceAdapter$element$$inlined$suspendingQuery$1(this);
  };
  function $runSuspendCOROUTINE$_92(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.dpj_1 = _this__u8e3s4;
    this.epj_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_92).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 6;
            var $this$suspendingQuery = this.epj_1;
            if (!this.dpj_1.mpj_1._v) {
              this.gpj_1 = $this$suspendingQuery;
              var tmp0_safe_receiver = this.gpj_1.l60(this.dpj_1.opj_1.ipj_1.hfq());
              if (tmp0_safe_receiver == null) {
                this.hpj_1 = null;
                this.f9_1 = 2;
                continue $sm;
              } else {
                this.f9_1 = 1;
                suspendResult = this.gpj_1.k60(tmp0_safe_receiver.eib(), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              }
            } else {
              this.f9_1 = 5;
              continue $sm;
            }

          case 1:
            this.hpj_1 = suspendResult;
            this.f9_1 = 2;
            continue $sm;
          case 2:
            var declaration = this.hpj_1;
            if (declaration == null) {
              this.fpj_1 = emptyList();
              this.f9_1 = 4;
              continue $sm;
            } else {
              if (isInterface(declaration, OntologyElement_1)) {
                this.fpj_1 = listOf(this.dpj_1.opj_1.jpj_1.mph(declaration));
                this.f9_1 = 4;
                continue $sm;
              } else {
                if (isInterface(declaration, UnionClass_1)) {
                  this.f9_1 = 3;
                  suspendResult = this.gpj_1.k60(extractClassAdapters(declaration, this.dpj_1.opj_1.jpj_1), this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  continue $sm;
                } else {
                  var tmp_0 = this;
                  noWhenBranchMatchedException();
                }
              }
            }

            break;
          case 3:
            this.fpj_1 = suspendResult;
            this.f9_1 = 4;
            continue $sm;
          case 4:
            var ARGUMENT = this.fpj_1;
            this.dpj_1.npj_1._v = ARGUMENT;
            this.dpj_1.mpj_1._v = true;
            this.f9_1 = 5;
            continue $sm;
          case 5:
            var tmp_1 = this.dpj_1.npj_1._v;
            return (tmp_1 == null ? true : !(tmp_1 == null)) ? tmp_1 : THROW_CCE();
          case 6:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 6) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function OntologyElementDefinitionAdapter$classes$$inlined$cachedSuspendingQuery$1($isCached, $cachedValue, this$0) {
    this.mpj_1 = $isCached;
    this.npj_1 = $cachedValue;
    this.opj_1 = this$0;
  }
  protoOf(OntologyElementDefinitionAdapter$classes$$inlined$cachedSuspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_92(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(OntologyElementDefinitionAdapter$classes$$inlined$cachedSuspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function OntologyElementDefinitionAdapter$constraints$$inlined$cachedSuspendingQuery$1($isCached, $cachedValue, this$0) {
    this.ppj_1 = $isCached;
    this.qpj_1 = $cachedValue;
    this.rpj_1 = this$0;
  }
  protoOf(OntologyElementDefinitionAdapter$constraints$$inlined$cachedSuspendingQuery$1).b61 = function (builder, $completion) {
    if (!this.ppj_1._v) {
      var tmp$ret$0 = toAdapters(builder.l60(this.rpj_1.ipj_1.ofr()), VOID, this.rpj_1.jpj_1);
      this.qpj_1._v = tmp$ret$0;
      this.ppj_1._v = true;
    }
    var tmp = this.qpj_1._v;
    return (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
  };
  protoOf(OntologyElementDefinitionAdapter$constraints$$inlined$cachedSuspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function OntologyElementDefinitionAdapter(definition, cache) {
    this.ipj_1 = definition;
    this.jpj_1 = cache;
    var tmp = this;
    // Inline function 'jetbrains.biokb.lang.model.util.hierarchy.cachedSuspendingQuery' call
    var cachedValue = {_v: null};
    var isCached = {_v: false};
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    tmp.kpj_1 = new OntologyElementDefinitionAdapter$classes$$inlined$cachedSuspendingQuery$1(isCached, cachedValue, this);
    var tmp_0 = this;
    // Inline function 'jetbrains.biokb.lang.model.util.hierarchy.cachedSuspendingQuery' call
    var cachedValue_0 = {_v: null};
    var isCached_0 = {_v: false};
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    tmp_0.lpj_1 = new OntologyElementDefinitionAdapter$constraints$$inlined$cachedSuspendingQuery$1(isCached_0, cachedValue_0, this);
  }
  protoOf(OntologyElementDefinitionAdapter).mfu = function () {
    return this.kpj_1;
  };
  protoOf(OntologyElementDefinitionAdapter).ofr = function () {
    return this.lpj_1;
  };
  protoOf(OntologyElementDefinitionAdapter).equals = function (other) {
    var tmp;
    if (other instanceof OntologyElementDefinitionAdapter) {
      tmp = equals(this.ipj_1, other.ipj_1);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(OntologyElementDefinitionAdapter).hashCode = function () {
    return hashCode(this.ipj_1);
  };
  protoOf(OntologyElementDefinitionAdapter).toString = function () {
    return 'OntologyElementDefinitionAdapter(definition=' + toString_1(this.ipj_1) + ', cache=' + toString_1(this.jpj_1) + ')';
  };
  function toAdapters(_this__u8e3s4, context, cache) {
    context = context === VOID ? DomainFactExpressionAdapterContext_instance : context;
    cache = cache === VOID ? new AdapterCache() : cache;
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(_this__u8e3s4, 10));
    var _iterator__ex2g4s = _this__u8e3s4.m();
    while (_iterator__ex2g4s.n()) {
      var item = _iterator__ex2g4s.o();
      var tmp$ret$0 = new DomainPropertyConstraintAdapter(item, context, cache);
      destination.j(tmp$ret$0);
    }
    return destination;
  }
  function extractClassAdapters(_this__u8e3s4, cache) {
    cache = cache === VOID ? new AdapterCache() : cache;
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new extractClassAdapters$$inlined$suspendingQuery$1(_this__u8e3s4, cache);
  }
  function $runSuspendCOROUTINE$_93(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.apk_1 = _this__u8e3s4;
    this.bpk_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_93).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 4;
            var $this$suspendingQuery = this.bpk_1;
            if (!this.apk_1.ipk_1._v) {
              var tmp0_safe_receiver = $this$suspendingQuery.l60(this.apk_1.kpk_1.dpk_1.a1());
              var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : toAdapter_2(tmp0_safe_receiver, this.apk_1.kpk_1.epk_1, this.apk_1.kpk_1.fpk_1);
              if (tmp1_safe_receiver == null) {
                this.cpk_1 = null;
                this.f9_1 = 2;
                continue $sm;
              } else {
                this.f9_1 = 1;
                suspendResult = $this$suspendingQuery.k60(tmp1_safe_receiver, this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              }
            } else {
              this.f9_1 = 3;
              continue $sm;
            }

          case 1:
            this.cpk_1 = suspendResult;
            this.f9_1 = 2;
            continue $sm;
          case 2:
            var tmp2_elvis_lhs = this.cpk_1;
            var descriptor = tmp2_elvis_lhs == null ? None_instance_0 : tmp2_elvis_lhs;
            var ARGUMENT = toPropertyConstraintValue(descriptor);
            this.apk_1.jpk_1._v = ARGUMENT;
            this.apk_1.ipk_1._v = true;
            this.f9_1 = 3;
            continue $sm;
          case 3:
            var tmp_0 = this.apk_1.jpk_1._v;
            return (tmp_0 == null ? true : !(tmp_0 == null)) ? tmp_0 : THROW_CCE();
          case 4:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 4) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function $runSuspendCOROUTINE$_94(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.tpk_1 = _this__u8e3s4;
    this.upk_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_94).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            var $this$suspendingQuery = this.upk_1;
            this.f9_1 = 1;
            suspendResult = $this$suspendingQuery.k60(this.tpk_1.vpk_1.hpk_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult.zpg_1;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function $runSuspendCOROUTINE$_95(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.epl_1 = _this__u8e3s4;
    this.fpl_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_95).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.gpl_1 = this.fpl_1;
            this.f9_1 = 1;
            suspendResult = this.gpl_1.k60(this.epl_1.hpl_1.hpk_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult.aph_1;
            return plus_5(ARGUMENT, toAdapters(this.gpl_1.l60(this.epl_1.hpl_1.dpk_1.ofr()), this.epl_1.hpl_1.epk_1, this.epl_1.hpl_1.fpk_1));
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function DomainPropertyConstraintAdapter$property$$inlined$cachedSuspendingQuery$1($isCached, $cachedValue, this$0) {
    this.ipl_1 = $isCached;
    this.jpl_1 = $cachedValue;
    this.kpl_1 = this$0;
  }
  protoOf(DomainPropertyConstraintAdapter$property$$inlined$cachedSuspendingQuery$1).b61 = function (builder, $completion) {
    if (!this.ipl_1._v) {
      var tmp$ret$0 = new DomainPropertyDeclAdapter(this.kpl_1.dpk_1.q6q());
      this.jpl_1._v = tmp$ret$0;
      this.ipl_1._v = true;
    }
    var tmp = this.jpl_1._v;
    return (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
  };
  protoOf(DomainPropertyConstraintAdapter$property$$inlined$cachedSuspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function DomainPropertyConstraintAdapter$normalizedValue$$inlined$cachedSuspendingQuery$1($isCached, $cachedValue, this$0) {
    this.ipk_1 = $isCached;
    this.jpk_1 = $cachedValue;
    this.kpk_1 = this$0;
  }
  protoOf(DomainPropertyConstraintAdapter$normalizedValue$$inlined$cachedSuspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_93(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(DomainPropertyConstraintAdapter$normalizedValue$$inlined$cachedSuspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function DomainPropertyConstraintAdapter$value$$inlined$suspendingQuery$1(this$0) {
    this.vpk_1 = this$0;
  }
  protoOf(DomainPropertyConstraintAdapter$value$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_94(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(DomainPropertyConstraintAdapter$value$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function DomainPropertyConstraintAdapter$constraints$$inlined$suspendingQuery$1(this$0) {
    this.hpl_1 = this$0;
  }
  protoOf(DomainPropertyConstraintAdapter$constraints$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_95(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(DomainPropertyConstraintAdapter$constraints$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function DomainPropertyConstraintAdapter(origin, context, cache) {
    this.dpk_1 = origin;
    this.epk_1 = context;
    this.fpk_1 = cache;
    var tmp = this;
    // Inline function 'jetbrains.biokb.lang.model.util.hierarchy.cachedSuspendingQuery' call
    var cachedValue = {_v: null};
    var isCached = {_v: false};
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    tmp.gpk_1 = new DomainPropertyConstraintAdapter$property$$inlined$cachedSuspendingQuery$1(isCached, cachedValue, this);
    var tmp_0 = this;
    // Inline function 'jetbrains.biokb.lang.model.util.hierarchy.cachedSuspendingQuery' call
    var cachedValue_0 = {_v: null};
    var isCached_0 = {_v: false};
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    tmp_0.hpk_1 = new DomainPropertyConstraintAdapter$normalizedValue$$inlined$cachedSuspendingQuery$1(isCached_0, cachedValue_0, this);
  }
  protoOf(DomainPropertyConstraintAdapter).q6q = function () {
    return this.gpk_1;
  };
  protoOf(DomainPropertyConstraintAdapter).a1 = function () {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new DomainPropertyConstraintAdapter$value$$inlined$suspendingQuery$1(this);
  };
  protoOf(DomainPropertyConstraintAdapter).ofr = function () {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new DomainPropertyConstraintAdapter$constraints$$inlined$suspendingQuery$1(this);
  };
  protoOf(DomainPropertyConstraintAdapter).s3z = function () {
    return this.dpk_1.s3z();
  };
  function $runSuspendCOROUTINE$_96(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.tpl_1 = _this__u8e3s4;
    this.upl_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_96).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 3;
            var $this$suspendingQuery = this.upl_1;
            if (!this.tpl_1.zpl_1._v) {
              this.f9_1 = 1;
              suspendResult = $this$suspendingQuery.k60(this.tpl_1.bpm_1.vpl_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.f9_1 = 2;
              continue $sm;
            }

          case 1:
            var tmp0_safe_receiver = suspendResult;
            var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.gfs();
            var tmp_0;
            if (tmp1_safe_receiver == null) {
              tmp_0 = null;
            } else {
              tmp_0 = new DomainPropertyDeclAdapter(tmp1_safe_receiver);
            }

            var ARGUMENT = tmp_0;
            this.tpl_1.apm_1._v = ARGUMENT;
            this.tpl_1.zpl_1._v = true;
            this.f9_1 = 2;
            continue $sm;
          case 2:
            var tmp_1 = this.tpl_1.apm_1._v;
            return (tmp_1 == null ? true : !(tmp_1 == null)) ? tmp_1 : THROW_CCE();
          case 3:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 3) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function DomainPropertyDeclAdapter$superProperty$$inlined$cachedSuspendingQuery$1($isCached, $cachedValue, this$0) {
    this.zpl_1 = $isCached;
    this.apm_1 = $cachedValue;
    this.bpm_1 = this$0;
  }
  protoOf(DomainPropertyDeclAdapter$superProperty$$inlined$cachedSuspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_96(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(DomainPropertyDeclAdapter$superProperty$$inlined$cachedSuspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function DomainPropertyDeclAdapter(origin) {
    this.vpl_1 = origin;
    this.wpl_1 = this.vpl_1.c6p().w2w();
    var tmp = this;
    // Inline function 'kotlin.hashCode' call
    var tmp0_safe_receiver = this.wpl_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    tmp.xpl_1 = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    var tmp_0 = this;
    // Inline function 'jetbrains.biokb.lang.model.util.hierarchy.cachedSuspendingQuery' call
    var cachedValue = {_v: null};
    var isCached = {_v: false};
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    tmp_0.ypl_1 = new DomainPropertyDeclAdapter$superProperty$$inlined$cachedSuspendingQuery$1(isCached, cachedValue, this);
  }
  protoOf(DomainPropertyDeclAdapter).gfs = function () {
    return this.ypl_1;
  };
  protoOf(DomainPropertyDeclAdapter).equals = function (other) {
    var tmp;
    var tmp_0;
    if (other instanceof DomainPropertyDeclAdapter) {
      tmp_0 = this.xpl_1 === other.xpl_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = equals(this.wpl_1, other.wpl_1);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(DomainPropertyDeclAdapter).hashCode = function () {
    return this.xpl_1;
  };
  function $runSuspendCOROUTINE$_97(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.kpm_1 = _this__u8e3s4;
    this.lpm_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_97).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 5;
            this.opm_1 = this.lpm_1;
            var tmp0 = this.opm_1.l60(this.kpm_1.qpm_1.mfu());
            this.mpm_1 = ArrayList_init_$Create$();
            this.ppm_1 = tmp0.m();
            this.f9_1 = 1;
            continue $sm;
          case 1:
            if (!this.ppm_1.n()) {
              this.f9_1 = 4;
              continue $sm;
            }

            var element = this.ppm_1.o();
            var tmp0_safe_receiver = isInterface(element, ClassExpression) ? element : null;
            var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.eib();
            if (tmp1_safe_receiver == null) {
              this.npm_1 = null;
              this.f9_1 = 3;
              continue $sm;
            } else {
              this.f9_1 = 2;
              suspendResult = this.opm_1.k60(tmp1_safe_receiver, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 2:
            this.npm_1 = suspendResult;
            this.f9_1 = 3;
            continue $sm;
          case 3:
            var tmp2_safe_receiver = this.npm_1;
            var tmp0_safe_receiver_0 = tmp2_safe_receiver == null ? null : toAdapter(tmp2_safe_receiver, this.kpm_1.rpm_1);
            if (tmp0_safe_receiver_0 == null)
              null;
            else {
              this.mpm_1.j(tmp0_safe_receiver_0);
            }

            this.f9_1 = 1;
            continue $sm;
          case 4:
            return this.mpm_1;
          case 5:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 5) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function extractClassAdapters$$inlined$suspendingQuery$1($this_extractClassAdapters, $cache) {
    this.qpm_1 = $this_extractClassAdapters;
    this.rpm_1 = $cache;
  }
  protoOf(extractClassAdapters$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_97(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(extractClassAdapters$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function DomainFactExpressionAdapterContext$adaptProcessProperty$$inlined$suspendingQuery$1() {
  }
  protoOf(DomainFactExpressionAdapterContext$adaptProcessProperty$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    return None_instance_0;
  };
  protoOf(DomainFactExpressionAdapterContext$adaptProcessProperty$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function DomainFactExpressionAdapterContext() {
  }
  protoOf(DomainFactExpressionAdapterContext).spm = function (property, cache) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new DomainFactExpressionAdapterContext$adaptProcessProperty$$inlined$suspendingQuery$1();
  };
  var DomainFactExpressionAdapterContext_instance;
  function DomainFactExpressionAdapterContext_getInstance() {
    return DomainFactExpressionAdapterContext_instance;
  }
  function toAdapter_2(_this__u8e3s4, context, cache) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new toAdapter$$inlined$suspendingQuery$1(context, cache, _this__u8e3s4);
  }
  function adaptNewFactReference($this, _this__u8e3s4, reference, visitedRefs, $completion) {
    var tmp = new $adaptNewFactReferenceCOROUTINE$($this, _this__u8e3s4, reference, visitedRefs, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  }
  function adaptRelationFactExpression($this, _this__u8e3s4, expression, visitedRefs, $completion) {
    var tmp = new $adaptRelationFactExpressionCOROUTINE$($this, _this__u8e3s4, expression, visitedRefs, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  }
  function mapSimpleValue($this, _this__u8e3s4, value) {
    var tmp;
    if (isInterface(value, EnumValue_1)) {
      tmp = new Enum_0(toString_0(_this__u8e3s4.l60(value.pfq().z6o())));
    } else {
      if (isInterface(value, MeasurableValue_1)) {
        tmp = new Measurable(toString_0(_this__u8e3s4.l60(value.zfr().z6o())), _this__u8e3s4.l60(value.yfr()));
      } else {
        if (isInterface(value, StringValue_1)) {
          tmp = new StringVal(_this__u8e3s4.l60(value.a1()));
        } else {
          if (isInterface(value, IntegerValue_1)) {
            tmp = new IntegerVal(_this__u8e3s4.l60(value.a1()));
          } else {
            tmp = None_instance_0;
          }
        }
      }
    }
    return tmp;
  }
  function mapComplexNotion($this, _this__u8e3s4, value) {
    var notionId = toString_0(_this__u8e3s4.l60(value.mfq().z6o()));
    // Inline function 'kotlin.collections.associate' call
    var this_0 = _this__u8e3s4.l60(value.nfq());
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
    // Inline function 'kotlin.collections.associateTo' call
    var destination = LinkedHashMap_init_$Create$_0(capacity);
    var _iterator__ex2g4s = this_0.m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      var elementId = toString_0(_this__u8e3s4.l60(element.gfq().z6o()));
      var tmp0_safe_receiver = _this__u8e3s4.l60(element.a1());
      var tmp;
      if (tmp0_safe_receiver == null) {
        tmp = null;
      } else {
        // Inline function 'kotlin.let' call
        var tmp_0;
        var tmp_1;
        var tmp_2;
        if (isInterface(tmp0_safe_receiver, EnumValue_1)) {
          tmp_2 = true;
        } else {
          tmp_2 = isInterface(tmp0_safe_receiver, MeasurableValue_1);
        }
        if (tmp_2) {
          tmp_1 = true;
        } else {
          var tmp_3;
          if (isInterface(tmp0_safe_receiver, StringValue_1)) {
            tmp_3 = true;
          } else {
            tmp_3 = isInterface(tmp0_safe_receiver, IntegerValue_1);
          }
          tmp_1 = tmp_3;
        }
        if (tmp_1) {
          tmp_0 = mapSimpleValue($this, _this__u8e3s4, tmp0_safe_receiver);
        } else {
          if (isInterface(tmp0_safe_receiver, UnknownComplexNotionValue_1)) {
            tmp_0 = None_instance_0;
          } else {
            tmp_0 = None_instance_0;
          }
        }
        tmp = tmp_0;
      }
      var tmp1_elvis_lhs = tmp;
      var mapped = tmp1_elvis_lhs == null ? None_instance_0 : tmp1_elvis_lhs;
      // Inline function 'kotlin.collections.plusAssign' call
      var pair = to(elementId, mapped);
      destination.t2(pair.pg_1, pair.qg_1);
    }
    var elements = destination;
    return new ComplexNotion_2(notionId, elements);
  }
  function Companion_367() {
    Companion_instance_367 = this;
    this.wpn_1 = getLogger_0(getKClass(FactExpressionToAdapterConverter));
  }
  var Companion_instance_367;
  function Companion_getInstance_367() {
    if (Companion_instance_367 == null)
      new Companion_367();
    return Companion_instance_367;
  }
  function FactExpressionToAdapterConverter$adaptAbstractValue$slambda(this$0, $visitedRefs, resultContinuation) {
    this.fpo_1 = this$0;
    this.gpo_1 = $visitedRefs;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(FactExpressionToAdapterConverter$adaptAbstractValue$slambda).jpo = function ($this$buildSetValueDescriptor, it, $completion) {
    var tmp = this.kpo($this$buildSetValueDescriptor, it, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(FactExpressionToAdapterConverter$adaptAbstractValue$slambda).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof QueryBuilder ? p1 : THROW_CCE();
    return this.jpo(tmp, (!(p2 == null) ? isInterface(p2, FactExpression) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(FactExpressionToAdapterConverter$adaptAbstractValue$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.fpo_1.npo(this.hpo_1, this.ipo_1, this.gpo_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(FactExpressionToAdapterConverter$adaptAbstractValue$slambda).kpo = function ($this$buildSetValueDescriptor, it, completion) {
    var i = new FactExpressionToAdapterConverter$adaptAbstractValue$slambda(this.fpo_1, this.gpo_1, completion);
    i.hpo_1 = $this$buildSetValueDescriptor;
    i.ipo_1 = it;
    return i;
  };
  function FactExpressionToAdapterConverter$adaptAbstractValue$slambda_0(this$0, $visitedRefs, resultContinuation) {
    var i = new FactExpressionToAdapterConverter$adaptAbstractValue$slambda(this$0, $visitedRefs, resultContinuation);
    var l = function ($this$buildSetValueDescriptor, it, $completion) {
      return i.jpo($this$buildSetValueDescriptor, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function $adaptFactExpressionCOROUTINE$(_this__u8e3s4, _this__u8e3s4_0, expression, visitedRefs, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.wpo_1 = _this__u8e3s4;
    this.xpo_1 = _this__u8e3s4_0;
    this.ypo_1 = expression;
    this.zpo_1 = visitedRefs;
  }
  protoOf($adaptFactExpressionCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 9;
            var tmp0_subject = this.ypo_1;
            if (!(tmp0_subject == null) ? isInterface(tmp0_subject, LibraryProcessSpecification_1) : false) {
              this.f9_1 = 7;
              suspendResult = this.xpo_1.k60(toAdapter_5(this.ypo_1, this.wpo_1.mpo_1), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              if (!(tmp0_subject == null) ? isInterface(tmp0_subject, ModifierFactExpression_0) : false) {
                this.f9_1 = 6;
                suspendResult = this.wpo_1.npo(this.xpo_1, this.xpo_1.l60(this.ypo_1.mfr()), this.zpo_1, this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                if (!(tmp0_subject == null) ? isInterface(tmp0_subject, RelationFactExpression_1) : false) {
                  this.f9_1 = 5;
                  suspendResult = adaptRelationFactExpression(this.wpo_1, this.xpo_1, this.ypo_1, this.zpo_1, this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  continue $sm;
                } else {
                  if (!(tmp0_subject == null) ? isInterface(tmp0_subject, IsExpression_1) : false) {
                    this.f9_1 = 4;
                    suspendResult = this.xpo_1.k60(toAdapter_4(this.ypo_1, this.wpo_1.mpo_1), this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) {
                      return suspendResult;
                    }
                    continue $sm;
                  } else {
                    if (!(tmp0_subject == null) ? isInterface(tmp0_subject, NewFactReference_0) : false) {
                      this.f9_1 = 3;
                      suspendResult = adaptNewFactReference(this.wpo_1, this.xpo_1, this.ypo_1, this.zpo_1, this);
                      if (suspendResult === get_COROUTINE_SUSPENDED()) {
                        return suspendResult;
                      }
                      continue $sm;
                    } else {
                      if (!(tmp0_subject == null) ? isInterface(tmp0_subject, ObjectPropertyReferenceValue_1) : false) {
                        this.f9_1 = 2;
                        suspendResult = this.wpo_1.bpp(this.xpo_1, this.xpo_1.l60(this.ypo_1.jfs()), this.zpo_1, this);
                        if (suspendResult === get_COROUTINE_SUSPENDED()) {
                          return suspendResult;
                        }
                        continue $sm;
                      } else {
                        if (!(tmp0_subject == null) ? isInterface(tmp0_subject, AbstractValue) : false) {
                          this.f9_1 = 1;
                          suspendResult = this.wpo_1.bpp(this.xpo_1, this.ypo_1, this.zpo_1, this);
                          if (suspendResult === get_COROUTINE_SUSPENDED()) {
                            return suspendResult;
                          }
                          continue $sm;
                        } else {
                          this.app_1 = None_instance_0;
                          this.f9_1 = 8;
                          continue $sm;
                        }
                      }
                    }
                  }
                }
              }
            }

          case 1:
            this.app_1 = suspendResult;
            this.f9_1 = 8;
            continue $sm;
          case 2:
            this.app_1 = suspendResult;
            this.f9_1 = 8;
            continue $sm;
          case 3:
            this.app_1 = suspendResult;
            this.f9_1 = 8;
            continue $sm;
          case 4:
            this.app_1 = suspendResult;
            this.f9_1 = 8;
            continue $sm;
          case 5:
            this.app_1 = suspendResult;
            this.f9_1 = 8;
            continue $sm;
          case 6:
            this.app_1 = suspendResult;
            this.f9_1 = 8;
            continue $sm;
          case 7:
            this.app_1 = suspendResult;
            this.f9_1 = 8;
            continue $sm;
          case 8:
            return this.app_1;
          case 9:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 9) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function $adaptNewFactReferenceCOROUTINE$(_this__u8e3s4, _this__u8e3s4_0, reference, visitedRefs, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.bpn_1 = _this__u8e3s4;
    this.cpn_1 = _this__u8e3s4_0;
    this.dpn_1 = reference;
    this.epn_1 = visitedRefs;
  }
  protoOf($adaptNewFactReferenceCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 7;
            if (!this.epn_1.j(this.dpn_1))
              return None_instance_0;
            this.f9_1 = 1;
            continue $sm;
          case 1:
            this.g9_1 = 6;
            this.f9_1 = 2;
            suspendResult = this.cpn_1.k60(this.dpn_1.yfq().x6o(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var tmp0_safe_receiver = suspendResult;
            var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : this.cpn_1.l60(tmp0_safe_receiver.mfr());
            if (tmp1_safe_receiver == null) {
              this.gpn_1 = null;
              this.f9_1 = 4;
              continue $sm;
            } else {
              this.f9_1 = 3;
              suspendResult = this.bpn_1.npo(this.cpn_1, tmp1_safe_receiver, this.epn_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 3:
            this.gpn_1 = suspendResult;
            this.f9_1 = 4;
            continue $sm;
          case 4:
            var tmp2_elvis_lhs = this.gpn_1;
            this.fpn_1 = tmp2_elvis_lhs == null ? None_instance_0 : tmp2_elvis_lhs;
            this.g9_1 = 7;
            this.f9_1 = 5;
            continue $sm;
          case 5:
            var tmp_0 = this.fpn_1;
            this.g9_1 = 7;
            this.epn_1.h2(this.dpn_1);
            return tmp_0;
          case 6:
            this.g9_1 = 7;
            var t = this.i9_1;
            this.epn_1.h2(this.dpn_1);
            throw t;
          case 7:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 7) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function $adaptAbstractValueCOROUTINE$(_this__u8e3s4, _this__u8e3s4_0, value, visitedRefs, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.kpp_1 = _this__u8e3s4;
    this.lpp_1 = _this__u8e3s4_0;
    this.mpp_1 = value;
    this.npp_1 = visitedRefs;
  }
  protoOf($adaptAbstractValueCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 10;
            var tmp0_subject = this.mpp_1;
            if (tmp0_subject == null) {
              this.opp_1 = None_instance_0;
              this.f9_1 = 9;
              continue $sm;
            } else {
              var tmp_0;
              var tmp_1;
              if (isInterface(tmp0_subject, EnumValue_1)) {
                tmp_1 = true;
              } else {
                tmp_1 = isInterface(tmp0_subject, MeasurableValue_1);
              }
              if (tmp_1) {
                tmp_0 = true;
              } else {
                var tmp_2;
                if (isInterface(tmp0_subject, StringValue_1)) {
                  tmp_2 = true;
                } else {
                  tmp_2 = isInterface(tmp0_subject, IntegerValue_1);
                }
                tmp_0 = tmp_2;
              }
              if (tmp_0) {
                this.opp_1 = mapSimpleValue(this.kpp_1, this.lpp_1, this.mpp_1);
                this.f9_1 = 9;
                continue $sm;
              } else {
                if (isInterface(tmp0_subject, ComplexNotionValue_1)) {
                  this.opp_1 = mapComplexNotion(this.kpp_1, this.lpp_1, this.mpp_1);
                  this.f9_1 = 9;
                  continue $sm;
                } else {
                  if (isInterface(tmp0_subject, OntologyElementReferenceValue_1)) {
                    var tmp_3 = this;
                    var tmp1_safe_receiver = this.lpp_1.l60(this.mpp_1.gfq());
                    tmp_3.ppp_1 = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.gfq();
                    var tmp2_safe_receiver = this.ppp_1;
                    if (tmp2_safe_receiver == null) {
                      this.qpp_1 = null;
                      this.f9_1 = 8;
                      continue $sm;
                    } else {
                      this.f9_1 = 7;
                      suspendResult = this.lpp_1.k60(tmp2_safe_receiver.x6o(), this);
                      if (suspendResult === get_COROUTINE_SUSPENDED()) {
                        return suspendResult;
                      }
                      continue $sm;
                    }
                  } else {
                    if (isInterface(tmp0_subject, UnionClass_1)) {
                      var tmp_4 = this;
                      var tmp_5 = this.mpp_1;
                      tmp_4.opp_1 = new ClassValue(toAdapter(isInterface(tmp_5, ClassDeclaration) ? tmp_5 : THROW_CCE(), this.kpp_1.mpo_1));
                      this.f9_1 = 9;
                      continue $sm;
                    } else {
                      if (isInterface(tmp0_subject, VariableReferenceValue_1)) {
                        this.f9_1 = 4;
                        suspendResult = this.lpp_1.k60(this.mpp_1.pfu().x6o(), this);
                        if (suspendResult === get_COROUTINE_SUSPENDED()) {
                          return suspendResult;
                        }
                        continue $sm;
                      } else {
                        if (isInterface(tmp0_subject, ProcessPropertyReference)) {
                          this.spp_1 = this.kpp_1.lpo_1;
                          this.f9_1 = 2;
                          suspendResult = this.lpp_1.k60(this.mpp_1.q6q().x6o(), this);
                          if (suspendResult === get_COROUTINE_SUSPENDED()) {
                            return suspendResult;
                          }
                          continue $sm;
                        } else {
                          if (isInterface(tmp0_subject, SetExpression_1)) {
                            this.f9_1 = 1;
                            suspendResult = buildSetValueDescriptor(this.lpp_1, this.mpp_1, FactExpressionToAdapterConverter$adaptAbstractValue$slambda_0(this.kpp_1, this.npp_1, null), this);
                            if (suspendResult === get_COROUTINE_SUSPENDED()) {
                              return suspendResult;
                            }
                            continue $sm;
                          } else {
                            this.opp_1 = None_instance_0;
                            this.f9_1 = 9;
                            continue $sm;
                          }
                        }
                      }
                    }
                  }
                }
              }
            }

          case 1:
            this.opp_1 = suspendResult;
            this.f9_1 = 9;
            continue $sm;
          case 2:
            var ARGUMENT = suspendResult;
            var ARGUMENT_0 = this.spp_1.spm(ARGUMENT, this.kpp_1.mpo_1);
            this.f9_1 = 3;
            suspendResult = this.lpp_1.k60(ARGUMENT_0, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            this.opp_1 = suspendResult;
            this.f9_1 = 9;
            continue $sm;
          case 4:
            var tmp4_safe_receiver = suspendResult;
            if (tmp4_safe_receiver == null) {
              this.rpp_1 = null;
              this.f9_1 = 6;
              continue $sm;
            } else {
              this.f9_1 = 5;
              suspendResult = this.lpp_1.k60(toAdapter_6(tmp4_safe_receiver, this.kpp_1.lpo_1, this.kpp_1.mpo_1), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 5:
            this.rpp_1 = suspendResult;
            this.f9_1 = 6;
            continue $sm;
          case 6:
            var tmp5_elvis_lhs = this.rpp_1;
            this.opp_1 = tmp5_elvis_lhs == null ? None_instance_0 : tmp5_elvis_lhs;
            this.f9_1 = 9;
            continue $sm;
          case 7:
            this.qpp_1 = suspendResult;
            this.f9_1 = 8;
            continue $sm;
          case 8:
            var element = this.qpp_1;
            var tmp_6 = this;
            var tmp_7;
            if (!(element == null)) {
              tmp_7 = new ClassValue(toAdapter_0(element, this.kpp_1.mpo_1));
            } else {
              var tmp_8 = Companion_getInstance_367().wpn_1;
              var tmp3_safe_receiver = this.ppp_1;
              tmp_8.xde('Unresolved element, falling back to ValueDescriptor.None: reference=' + toString_0(tmp3_safe_receiver == null ? null : this.lpp_1.l60(tmp3_safe_receiver.z6o())));
              tmp_7 = None_instance_0;
            }

            tmp_6.opp_1 = tmp_7;
            this.f9_1 = 9;
            continue $sm;
          case 9:
            return this.opp_1;
          case 10:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 10) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function $adaptRelationFactExpressionCOROUTINE$(_this__u8e3s4, _this__u8e3s4_0, expression, visitedRefs, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.ppn_1 = _this__u8e3s4;
    this.qpn_1 = _this__u8e3s4_0;
    this.rpn_1 = expression;
    this.spn_1 = visitedRefs;
  }
  protoOf($adaptRelationFactExpressionCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 4;
            this.f9_1 = 1;
            suspendResult = this.qpn_1.k60(this.rpn_1.xfq().x6o(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp0_elvis_lhs = suspendResult;
            var tmp_0 = this;
            var tmp_1;
            if (tmp0_elvis_lhs == null) {
              return None_instance_0;
            } else {
              tmp_1 = tmp0_elvis_lhs;
            }

            tmp_0.vpn_1 = tmp_1;
            this.f9_1 = 2;
            var tmp1_safe_receiver = this.qpn_1.l60(this.rpn_1.dft());
            suspendResult = this.ppn_1.npo(this.qpn_1, tmp1_safe_receiver == null ? null : this.qpn_1.l60(tmp1_safe_receiver.mfr()), this.spn_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.upn_1 = suspendResult;
            this.tpn_1 = new RelationAdapter(this.vpn_1);
            this.f9_1 = 3;
            var tmp2_safe_receiver = this.qpn_1.l60(this.rpn_1.eft());
            suspendResult = this.ppn_1.npo(this.qpn_1, tmp2_safe_receiver == null ? null : this.qpn_1.l60(tmp2_safe_receiver.mfr()), this.spn_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            var ARGUMENT = suspendResult;
            return new RelationFactExpressionDescriptor(this.upn_1, this.tpn_1, ARGUMENT);
          case 4:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 4) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function FactExpressionToAdapterConverter(context, cache) {
    Companion_getInstance_367();
    this.lpo_1 = context;
    this.mpo_1 = cache;
  }
  protoOf(FactExpressionToAdapterConverter).npo = function (_this__u8e3s4, expression, visitedRefs, $completion) {
    var tmp = new $adaptFactExpressionCOROUTINE$(this, _this__u8e3s4, expression, visitedRefs, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(FactExpressionToAdapterConverter).tpp = function (_this__u8e3s4, expression, visitedRefs, $completion, $super) {
    var tmp;
    if (visitedRefs === VOID) {
      tmp = LinkedHashSet_init_$Create$();
    } else {
      tmp = visitedRefs;
    }
    visitedRefs = tmp;
    return $super === VOID ? this.npo(_this__u8e3s4, expression, visitedRefs, $completion) : $super.npo.call(this, _this__u8e3s4, expression, visitedRefs, $completion);
  };
  protoOf(FactExpressionToAdapterConverter).bpp = function (_this__u8e3s4, value, visitedRefs, $completion) {
    var tmp = new $adaptAbstractValueCOROUTINE$(this, _this__u8e3s4, value, visitedRefs, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(FactExpressionToAdapterConverter).upp = function (_this__u8e3s4, value, visitedRefs, $completion, $super) {
    var tmp;
    if (visitedRefs === VOID) {
      tmp = LinkedHashSet_init_$Create$();
    } else {
      tmp = visitedRefs;
    }
    visitedRefs = tmp;
    return $super === VOID ? this.bpp(_this__u8e3s4, value, visitedRefs, $completion) : $super.bpp.call(this, _this__u8e3s4, value, visitedRefs, $completion);
  };
  function buildSetValueDescriptor(_this__u8e3s4, setExpression, mapMember, $completion) {
    var tmp = new $buildSetValueDescriptorCOROUTINE$(_this__u8e3s4, setExpression, mapMember, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  }
  function RelationAdapter$direction$$inlined$cachedSuspendingQuery$1($isCached, $cachedValue, this$0) {
    this.lpq_1 = $isCached;
    this.mpq_1 = $cachedValue;
    this.npq_1 = this$0;
  }
  protoOf(RelationAdapter$direction$$inlined$cachedSuspendingQuery$1).b61 = function (builder, $completion) {
    if (!this.lpq_1._v) {
      var tmp$ret$0 = builder.l60(this.npq_1.opq_1.afu());
      this.mpq_1._v = tmp$ret$0;
      this.lpq_1._v = true;
    }
    var tmp = this.mpq_1._v;
    return (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
  };
  protoOf(RelationAdapter$direction$$inlined$cachedSuspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function RelationAdapter(origin) {
    this.opq_1 = origin;
    var tmp = this;
    // Inline function 'jetbrains.biokb.lang.model.util.hierarchy.cachedSuspendingQuery' call
    var cachedValue = {_v: null};
    var isCached = {_v: false};
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    tmp.ppq_1 = new RelationAdapter$direction$$inlined$cachedSuspendingQuery$1(isCached, cachedValue, this);
  }
  protoOf(RelationAdapter).toString = function () {
    return 'RelationAdapter(origin=' + toString_1(this.opq_1) + ')';
  };
  protoOf(RelationAdapter).hashCode = function () {
    return hashCode(this.opq_1);
  };
  protoOf(RelationAdapter).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RelationAdapter))
      return false;
    if (!equals(this.opq_1, other.opq_1))
      return false;
    return true;
  };
  function toAdapter_3(_this__u8e3s4, context, cache) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new toAdapter$$inlined$suspendingQuery$2(context, cache, _this__u8e3s4);
  }
  function $runSuspendCOROUTINE$_98(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.ypq_1 = _this__u8e3s4;
    this.zpq_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_98).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            var $this$suspendingQuery = this.zpq_1;
            var $this$run = new FactExpressionToAdapterConverter(this.ypq_1.apr_1, this.ypq_1.bpr_1);
            this.f9_1 = 1;
            suspendResult = $this$run.upp($this$suspendingQuery, this.ypq_1.cpr_1, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function toAdapter$$inlined$suspendingQuery$1($context, $cache, $this_toAdapter) {
    this.apr_1 = $context;
    this.bpr_1 = $cache;
    this.cpr_1 = $this_toAdapter;
  }
  protoOf(toAdapter$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_98(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(toAdapter$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function buildSetValueDescriptor$$inlined$groupingBy$1($this) {
    this.dpr_1 = $this;
  }
  protoOf(buildSetValueDescriptor$$inlined$groupingBy$1).e4 = function () {
    return this.dpr_1.m();
  };
  protoOf(buildSetValueDescriptor$$inlined$groupingBy$1).y59 = function (element) {
    return element.pg_1;
  };
  protoOf(buildSetValueDescriptor$$inlined$groupingBy$1).f4 = function (element) {
    return this.y59((element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  function $runSuspendCOROUTINE$_99(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.mpr_1 = _this__u8e3s4;
    this.npr_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_99).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            var $this$suspendingQuery = this.npr_1;
            var $this$run = new FactExpressionToAdapterConverter(this.mpr_1.opr_1, this.mpr_1.ppr_1);
            this.f9_1 = 1;
            suspendResult = $this$run.tpp($this$suspendingQuery, this.mpr_1.qpr_1, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function toAdapter$$inlined$suspendingQuery$2($context, $cache, $this_toAdapter) {
    this.opr_1 = $context;
    this.ppr_1 = $cache;
    this.qpr_1 = $this_toAdapter;
  }
  protoOf(toAdapter$$inlined$suspendingQuery$2).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_99(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(toAdapter$$inlined$suspendingQuery$2).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function $buildSetValueDescriptorCOROUTINE$(_this__u8e3s4, setExpression, mapMember, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.dpq_1 = _this__u8e3s4;
    this.epq_1 = setExpression;
    this.fpq_1 = mapMember;
  }
  protoOf($buildSetValueDescriptorCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 6;
            var tmp_0 = this;
            tmp_0.gpq_1 = ArrayList_init_$Create$();
            this.kpq_1 = this.dpq_1.l60(this.epq_1.mfs()).m();
            this.f9_1 = 1;
            continue $sm;
          case 1:
            if (!this.kpq_1.n()) {
              this.f9_1 = 5;
              continue $sm;
            }

            var expression = this.kpq_1.o();
            var tmp_1;
            if (isInterface(expression, MultipliedExpression_1)) {
              var base = this.dpq_1.l60(expression.mfr());
              var multiplier = this.dpq_1.l60(expression.bid());
              var tmp_2;
              if (equals(multiplier, ImplicitOne_instance)) {
                tmp_2 = new Known(1);
              } else {
                if (equals(multiplier, Unknown_instance)) {
                  tmp_2 = Unknown_instance_0;
                } else {
                  if (multiplier instanceof Exact) {
                    var this_0 = multiplier.hlv_1;
                    var tmp_3;
                    if (this_0 > 0) {
                      tmp_3 = this_0;
                    } else {
                      tmp_3 = null;
                    }
                    var tmp1_safe_receiver = tmp_3;
                    var tmp_4;
                    if (tmp1_safe_receiver == null) {
                      tmp_4 = null;
                    } else {
                      tmp_4 = new Known(tmp1_safe_receiver);
                    }
                    tmp_2 = tmp_4;
                  } else {
                    noWhenBranchMatchedException();
                  }
                }
              }
              var effectiveMultiplier = tmp_2;
              var tmp_5;
              if (!(base == null) && !(effectiveMultiplier == null)) {
                tmp_5 = to(base, effectiveMultiplier);
              } else {
                tmp_5 = null;
              }
              tmp_1 = tmp_5;
            } else {
              tmp_1 = to(expression, new Known(1));
            }

            var tmp2_elvis_lhs = tmp_1;
            if (tmp2_elvis_lhs == null) {
              this.f9_1 = 1;
              var tmp_6 = this;
              continue $sm;
            } else {
              this.jpq_1 = tmp2_elvis_lhs;
              this.f9_1 = 2;
              continue $sm;
            }

          case 2:
            this.hpq_1 = this.jpq_1;
            var tmp_7 = this.hpq_1.pg_1;
            var tmp3_safe_receiver = isInterface(tmp_7, FactExpression) ? tmp_7 : null;
            if (tmp3_safe_receiver == null) {
              this.ipq_1 = null;
              this.f9_1 = 4;
              continue $sm;
            } else {
              this.f9_1 = 3;
              suspendResult = this.fpq_1(this.dpq_1, tmp3_safe_receiver, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 3:
            this.ipq_1 = suspendResult;
            this.f9_1 = 4;
            continue $sm;
          case 4:
            var tmp4_elvis_lhs = this.ipq_1;
            var descriptor = tmp4_elvis_lhs == null ? None_instance_0 : tmp4_elvis_lhs;
            var tmp0 = this.gpq_1;
            var element = to(descriptor, this.hpq_1.qg_1);
            tmp0.j(element);
            this.f9_1 = 1;
            continue $sm;
          case 5:
            var this_1 = this.gpq_1;
            var tmp0_0 = new buildSetValueDescriptor$$inlined$groupingBy$1(this_1);
            var destination = LinkedHashMap_init_$Create$();
            var _iterator__ex2g4s = tmp0_0.e4();
            while (_iterator__ex2g4s.n()) {
              var e = _iterator__ex2g4s.o();
              var key = tmp0_0.f4(e);
              var accumulator = destination.q2(key);
              accumulator == null && !destination.o2(key);
              var count = e.gg();
              var tmp1_elvis_lhs = accumulator == null ? null : combine_1(accumulator, count);
              var value = tmp1_elvis_lhs == null ? count : tmp1_elvis_lhs;
              destination.t2(key, value);
            }

            var counts = destination;
            var type = this.dpq_1.l60(this.epq_1.lfu()) ? SetType_OPEN_getInstance() : SetType_CLOSED_getInstance();
            return new SetValue(counts, type);
          case 6:
            throw this.i9_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.g9_1 === 6) {
          throw e_0;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e_0;
        }
      }
     while (true);
  };
  function toAdapter_4(_this__u8e3s4, cache) {
    cache = cache === VOID ? new AdapterCache() : cache;
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new toAdapter$$inlined$suspendingQuery$1_0(_this__u8e3s4, cache);
  }
  function $toConstraintCOROUTINE$(_this__u8e3s4, queryBuilder, terminalValue, parameterValue, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.zpr_1 = _this__u8e3s4;
    this.aps_1 = queryBuilder;
    this.bps_1 = terminalValue;
    this.cps_1 = parameterValue;
  }
  protoOf($toConstraintCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 6;
            var tmp0 = this.zpr_1.jps_1;
            this.dps_1 = emptyList();
            if (!tmp0.s()) {
              this.hps_1 = tmp0.u(tmp0.p());
              this.f9_1 = 1;
              continue $sm;
            } else {
              this.f9_1 = 5;
              continue $sm;
            }

          case 1:
            if (!this.hps_1.r4()) {
              this.f9_1 = 4;
              continue $sm;
            }

            var tmp0_0 = this.hps_1.t4();
            var tmp2 = this.dps_1;
            this.fps_1 = tmp0_0;
            this.eps_1 = tmp2;
            if (this.eps_1.s()) {
              this.gps_1 = this.bps_1;
              this.f9_1 = 3;
              continue $sm;
            } else {
              if (!(this.fps_1.lps_1 == null)) {
                this.f9_1 = 2;
                suspendResult = this.cps_1(this.aps_1, this.fps_1.lps_1, this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                this.gps_1 = None_instance_0;
                this.f9_1 = 3;
                continue $sm;
              }
            }

          case 2:
            this.gps_1 = suspendResult;
            this.f9_1 = 3;
            continue $sm;
          case 3:
            var value = this.gps_1;
            var constraintValue = toPropertyConstraintValue(value);
            this.dps_1 = listOf(new IsExpressionConstraintAdapter(this.fps_1.kps_1, plus_5(constraintValue.aph_1, this.eps_1), constraintValue.zpg_1));
            this.f9_1 = 1;
            continue $sm;
          case 4:
            this.f9_1 = 5;
            continue $sm;
          case 5:
            var ARGUMENT = this.dps_1;
            var tmp0_elvis_lhs = singleOrNull(ARGUMENT);
            var tmp_0;
            if (tmp0_elvis_lhs == null) {
              var message = 'An is expression subject must contain a property';
              throw IllegalStateException_init_$Create$_0(toString_1(message));
            } else {
              tmp_0 = tmp0_elvis_lhs;
            }

            return tmp_0;
          case 6:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 6) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function IsExpressionSubject(rootOperand, properties) {
    this.ips_1 = rootOperand;
    this.jps_1 = properties;
  }
  protoOf(IsExpressionSubject).mps = function (queryBuilder, terminalValue, parameterValue, $completion) {
    var tmp = new $toConstraintCOROUTINE$(this, queryBuilder, terminalValue, parameterValue, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(IsExpressionSubject).toString = function () {
    return 'IsExpressionSubject(rootOperand=' + toString_1(this.ips_1) + ', properties=' + toString_1(this.jps_1) + ')';
  };
  protoOf(IsExpressionSubject).hashCode = function () {
    var result = hashCode(this.ips_1);
    result = imul(result, 31) + hashCode(this.jps_1) | 0;
    return result;
  };
  protoOf(IsExpressionSubject).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof IsExpressionSubject))
      return false;
    if (!equals(this.ips_1, other.ips_1))
      return false;
    if (!equals(this.jps_1, other.jps_1))
      return false;
    return true;
  };
  function parseSubject(_this__u8e3s4, expression) {
    // Inline function 'kotlin.collections.mutableListOf' call
    var properties = ArrayList_init_$Create$();
    var tmp0_elvis_lhs = _this__u8e3s4.l60(expression.mdy());
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var current = tmp;
    while (true) {
      var tmp1_elvis_lhs = _this__u8e3s4.l60(current.q6q());
      var tmp_0;
      if (tmp1_elvis_lhs == null) {
        return null;
      } else {
        tmp_0 = tmp1_elvis_lhs;
      }
      var property = tmp_0;
      var tmp_1 = new DomainPropertyDeclAdapter(property.q6q());
      var tmp2_safe_receiver = _this__u8e3s4.l60(property.dfu());
      // Inline function 'kotlin.collections.plusAssign' call
      var element = new PropertyReference(tmp_1, tmp2_safe_receiver == null ? null : _this__u8e3s4.l60(tmp2_safe_receiver.a1()));
      properties.j(element);
      var tmp3_elvis_lhs = _this__u8e3s4.l60(current.jfs());
      var tmp_2;
      if (tmp3_elvis_lhs == null) {
        return null;
      } else {
        tmp_2 = tmp3_elvis_lhs;
      }
      var operand = tmp_2;
      if (!isInterface(operand, ObjectPropertyReferenceValue_1)) {
        return new IsExpressionSubject(operand, asReversed(properties));
      }
      current = operand;
    }
  }
  function classAdapter(_this__u8e3s4, value, cache, $completion) {
    var tmp = new $classAdapterCOROUTINE$(_this__u8e3s4, value, cache, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  }
  function IsExpressionAdapter$classes$$inlined$suspendingQuery$1(this$0) {
    this.yps_1 = this$0;
  }
  protoOf(IsExpressionAdapter$classes$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    return listOf(this.yps_1.apt_1);
  };
  protoOf(IsExpressionAdapter$classes$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function IsExpressionAdapter$constraints$$inlined$suspendingQuery$1(this$0) {
    this.ept_1 = this$0;
  }
  protoOf(IsExpressionAdapter$constraints$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    return listOf(this.ept_1.bpt_1);
  };
  protoOf(IsExpressionAdapter$constraints$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function IsExpressionAdapter(expression, baseClass, constraint) {
    this.zps_1 = expression;
    this.apt_1 = baseClass;
    this.bpt_1 = constraint;
    var tmp = this;
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    tmp.cpt_1 = new IsExpressionAdapter$classes$$inlined$suspendingQuery$1(this);
    var tmp_0 = this;
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    tmp_0.dpt_1 = new IsExpressionAdapter$constraints$$inlined$suspendingQuery$1(this);
  }
  protoOf(IsExpressionAdapter).mfu = function () {
    return this.cpt_1;
  };
  protoOf(IsExpressionAdapter).ofr = function () {
    return this.dpt_1;
  };
  protoOf(IsExpressionAdapter).equals = function (other) {
    var tmp;
    if (other instanceof IsExpressionAdapter) {
      tmp = equals(this.zps_1, other.zps_1);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(IsExpressionAdapter).hashCode = function () {
    return hashCode(this.zps_1);
  };
  function PropertyReference(descriptor, parameter) {
    this.kps_1 = descriptor;
    this.lps_1 = parameter;
  }
  protoOf(PropertyReference).toString = function () {
    return 'PropertyReference(descriptor=' + toString_1(this.kps_1) + ', parameter=' + toString_0(this.lps_1) + ')';
  };
  protoOf(PropertyReference).hashCode = function () {
    var result = hashCode(this.kps_1);
    result = imul(result, 31) + (this.lps_1 == null ? 0 : hashCode(this.lps_1)) | 0;
    return result;
  };
  protoOf(PropertyReference).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PropertyReference))
      return false;
    if (!equals(this.kps_1, other.kps_1))
      return false;
    if (!equals(this.lps_1, other.lps_1))
      return false;
    return true;
  };
  function IsExpressionConstraintAdapter$property$$inlined$suspendingQuery$1(this$0) {
    this.fpt_1 = this$0;
  }
  protoOf(IsExpressionConstraintAdapter$property$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    return this.fpt_1.gpt_1;
  };
  protoOf(IsExpressionConstraintAdapter$property$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function IsExpressionConstraintAdapter$constraints$$inlined$suspendingQuery$1(this$0) {
    this.npt_1 = this$0;
  }
  protoOf(IsExpressionConstraintAdapter$constraints$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    return this.npt_1.hpt_1;
  };
  protoOf(IsExpressionConstraintAdapter$constraints$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function IsExpressionConstraintAdapter$operation$$inlined$suspendingQuery$1() {
  }
  protoOf(IsExpressionConstraintAdapter$operation$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    return null;
  };
  protoOf(IsExpressionConstraintAdapter$operation$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function IsExpressionConstraintAdapter$value$$inlined$suspendingQuery$1(this$0) {
    this.opt_1 = this$0;
  }
  protoOf(IsExpressionConstraintAdapter$value$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    return this.opt_1.ipt_1;
  };
  protoOf(IsExpressionConstraintAdapter$value$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function IsExpressionConstraintAdapter(propertyDescriptor, nestedConstraints, constraintValue) {
    this.gpt_1 = propertyDescriptor;
    this.hpt_1 = nestedConstraints;
    this.ipt_1 = constraintValue;
    var tmp = this;
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    tmp.jpt_1 = new IsExpressionConstraintAdapter$property$$inlined$suspendingQuery$1(this);
    var tmp_0 = this;
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    tmp_0.kpt_1 = new IsExpressionConstraintAdapter$constraints$$inlined$suspendingQuery$1(this);
    var tmp_1 = this;
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    tmp_1.lpt_1 = new IsExpressionConstraintAdapter$operation$$inlined$suspendingQuery$1();
    var tmp_2 = this;
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    tmp_2.mpt_1 = new IsExpressionConstraintAdapter$value$$inlined$suspendingQuery$1(this);
  }
  protoOf(IsExpressionConstraintAdapter).q6q = function () {
    return this.jpt_1;
  };
  protoOf(IsExpressionConstraintAdapter).ofr = function () {
    return this.kpt_1;
  };
  protoOf(IsExpressionConstraintAdapter).s3z = function () {
    return this.lpt_1;
  };
  protoOf(IsExpressionConstraintAdapter).a1 = function () {
    return this.mpt_1;
  };
  function toAdapter$o$runSuspend$slambda($cache, resultContinuation) {
    this.xpt_1 = $cache;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(toAdapter$o$runSuspend$slambda).apu = function ($this$toConstraint, parameter, $completion) {
    var tmp = this.bpu($this$toConstraint, parameter, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(toAdapter$o$runSuspend$slambda).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof QueryBuilder ? p1 : THROW_CCE();
    return this.apu(tmp, (!(p2 == null) ? isInterface(p2, AbstractValue) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(toAdapter$o$runSuspend$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.ypt_1.k60(toAdapter_2(this.zpt_1, DomainFactExpressionAdapterContext_instance, this.xpt_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(toAdapter$o$runSuspend$slambda).bpu = function ($this$toConstraint, parameter, completion) {
    var i = new toAdapter$o$runSuspend$slambda(this.xpt_1, completion);
    i.ypt_1 = $this$toConstraint;
    i.zpt_1 = parameter;
    return i;
  };
  function toAdapter$o$runSuspend$slambda_0($cache, resultContinuation) {
    var i = new toAdapter$o$runSuspend$slambda($cache, resultContinuation);
    var l = function ($this$toConstraint, parameter, $completion) {
      return i.apu($this$toConstraint, parameter, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function $runSuspendCOROUTINE$_100(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.kpu_1 = _this__u8e3s4;
    this.lpu_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_100).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 9;
            var tmp_0 = this;
            tmp_0.upu_1 = this.lpu_1;
            this.mpu_1 = Unit_instance;
            this.f9_1 = 1;
            continue $sm;
          case 1:
            this.opu_1 = this.upu_1;
            var tmp0_elvis_lhs = parseSubject(this.opu_1, this.kpu_1.vpu_1);
            if (tmp0_elvis_lhs == null) {
              this.mpu_1 = None_instance_0;
              this.f9_1 = 8;
              var tmp_1 = this;
              continue $sm;
            } else {
              this.tpu_1 = tmp0_elvis_lhs;
              this.f9_1 = 2;
              continue $sm;
            }

          case 2:
            this.ppu_1 = this.tpu_1;
            var tmp1_elvis_lhs = this.opu_1.l60(this.kpu_1.vpu_1.a1());
            if (tmp1_elvis_lhs == null) {
              this.mpu_1 = None_instance_0;
              this.f9_1 = 8;
              var tmp_2 = this;
              continue $sm;
            } else {
              this.spu_1 = tmp1_elvis_lhs;
              this.f9_1 = 3;
              continue $sm;
            }

          case 3:
            this.qpu_1 = this.spu_1;
            this.f9_1 = 4;
            suspendResult = classAdapter(this.opu_1, this.ppu_1.ips_1, this.kpu_1.wpu_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            var tmp2_elvis_lhs = suspendResult;
            if (tmp2_elvis_lhs == null) {
              this.mpu_1 = None_instance_0;
              this.f9_1 = 8;
              var tmp_3 = this;
              continue $sm;
            } else {
              this.rpu_1 = tmp2_elvis_lhs;
              this.f9_1 = 5;
              continue $sm;
            }

          case 5:
            this.npu_1 = this.rpu_1;
            this.f9_1 = 6;
            suspendResult = this.opu_1.k60(toAdapter_2(this.qpu_1, DomainFactExpressionAdapterContext_instance, this.kpu_1.wpu_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 6:
            var ARGUMENT = suspendResult;
            this.f9_1 = 7;
            suspendResult = this.ppu_1.mps(this.opu_1, ARGUMENT, toAdapter$o$runSuspend$slambda_0(this.kpu_1.wpu_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 7:
            var ARGUMENT_0 = suspendResult;
            var ARGUMENT_1 = new IsExpressionAdapter(this.kpu_1.vpu_1, this.npu_1, ARGUMENT_0);
            this.mpu_1 = new ClassValue(ARGUMENT_1);
            if (false) {
              this.f9_1 = 1;
              continue $sm;
            }

            this.f9_1 = 8;
            continue $sm;
          case 8:
            return this.mpu_1;
          case 9:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 9) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function toAdapter$$inlined$suspendingQuery$1_0($this_toAdapter, $cache) {
    this.vpu_1 = $this_toAdapter;
    this.wpu_1 = $cache;
  }
  protoOf(toAdapter$$inlined$suspendingQuery$1_0).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_100(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(toAdapter$$inlined$suspendingQuery$1_0).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function $classAdapterCOROUTINE$(_this__u8e3s4, value, cache, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.vps_1 = _this__u8e3s4;
    this.wps_1 = value;
    this.xps_1 = cache;
  }
  protoOf($classAdapterCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.vps_1.k60(toAdapter_2(this.wps_1, DomainFactExpressionAdapterContext_instance, this.xps_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var descriptor = suspendResult;
            var tmp0_safe_receiver = descriptor instanceof ClassValue ? descriptor : null;
            return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.ym4_1;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function toAdapter_5(_this__u8e3s4, cache) {
    cache = cache === VOID ? new AdapterCache() : cache;
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new toAdapter$$inlined$suspendingQuery$1_1(_this__u8e3s4, cache);
  }
  function $runSuspendCOROUTINE$_101(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.fpv_1 = _this__u8e3s4;
    this.gpv_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_101).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 8;
            var tmp_0 = this;
            tmp_0.jpv_1 = this.gpv_1;
            this.hpv_1 = Unit_instance;
            this.f9_1 = 1;
            continue $sm;
          case 1:
            this.ipv_1 = this.jpv_1;
            if (this.fpv_1.kpv_1 == null) {
              this.hpv_1 = None_instance_0;
              this.f9_1 = 7;
              continue $sm;
            } else {
              this.f9_1 = 2;
              continue $sm;
            }

          case 2:
            var specifiedValues = this.fpv_1.lpv_1.qpv_1.q2(this.fpv_1.kpv_1);
            if (!(specifiedValues == null)) {
              this.f9_1 = 6;
              suspendResult = foldSpecifiedValues(this.fpv_1.mpv_1, this.ipv_1, specifiedValues, this.fpv_1.npv_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.f9_1 = 3;
              continue $sm;
            }

          case 3:
            this.f9_1 = 4;
            suspendResult = defaultValue(this.fpv_1.mpv_1, this.ipv_1, this.fpv_1.kpv_1, this.fpv_1.npv_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            var defaultValue_0 = suspendResult;
            if (!(defaultValue_0 == null)) {
              this.hpv_1 = defaultValue_0;
              this.f9_1 = 7;
              continue $sm;
            } else {
              this.f9_1 = 5;
              continue $sm;
            }

          case 5:
            this.hpv_1 = None_instance_0;
            if (false) {
              this.f9_1 = 1;
              continue $sm;
            }

            this.f9_1 = 7;
            continue $sm;
          case 6:
            this.hpv_1 = suspendResult;
            this.f9_1 = 7;
            continue $sm;
          case 7:
            return this.hpv_1;
          case 8:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 8) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function foldSpecifiedValues($this, _this__u8e3s4, values, cache, $completion) {
    var tmp = new $foldSpecifiedValuesCOROUTINE$($this, _this__u8e3s4, values, cache, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  }
  function defaultValue($this, _this__u8e3s4, property, cache, $completion) {
    var tmp0_safe_receiver = _this__u8e3s4.l60(property.g3b());
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : _this__u8e3s4.l60(tmp0_safe_receiver.a1());
    var tmp;
    if (tmp1_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp1_elvis_lhs;
    }
    var default_0 = tmp;
    return _this__u8e3s4.k60(toAdapter_2(default_0, $this, cache), $completion);
  }
  function LibraryProcessSpecificationAdapter$LibraryProcessSpecificationContext$adaptProcessProperty$$inlined$suspendingQuery$1($property, this$0, this$1, $cache) {
    this.kpv_1 = $property;
    this.lpv_1 = this$0;
    this.mpv_1 = this$1;
    this.npv_1 = $cache;
  }
  protoOf(LibraryProcessSpecificationAdapter$LibraryProcessSpecificationContext$adaptProcessProperty$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_101(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(LibraryProcessSpecificationAdapter$LibraryProcessSpecificationContext$adaptProcessProperty$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function LibraryProcessSpecificationAdapter$LibraryProcessSpecificationContext$foldSpecifiedValues$$inlined$groupingBy$1($this) {
    this.ipw_1 = $this;
  }
  protoOf(LibraryProcessSpecificationAdapter$LibraryProcessSpecificationContext$foldSpecifiedValues$$inlined$groupingBy$1).e4 = function () {
    return this.ipw_1.m();
  };
  protoOf(LibraryProcessSpecificationAdapter$LibraryProcessSpecificationContext$foldSpecifiedValues$$inlined$groupingBy$1).y59 = function (element) {
    return element;
  };
  protoOf(LibraryProcessSpecificationAdapter$LibraryProcessSpecificationContext$foldSpecifiedValues$$inlined$groupingBy$1).f4 = function (element) {
    return this.y59((element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  function $foldSpecifiedValuesCOROUTINE$(_this__u8e3s4, _this__u8e3s4_0, values, cache, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.cpw_1 = _this__u8e3s4;
    this.dpw_1 = _this__u8e3s4_0;
    this.epw_1 = values;
    this.fpw_1 = cache;
  }
  protoOf($foldSpecifiedValuesCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 4;
            var this_0 = this.epw_1;
            this.gpw_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
            this.hpw_1 = this_0.m();
            this.f9_1 = 1;
            continue $sm;
          case 1:
            if (!this.hpw_1.n()) {
              this.f9_1 = 3;
              continue $sm;
            }

            var item = this.hpw_1.o();
            this.f9_1 = 2;
            suspendResult = this.dpw_1.k60(toAdapter_2(item, this.cpw_1, this.fpw_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var ARGUMENT = suspendResult;
            this.gpw_1.j(ARGUMENT);
            this.f9_1 = 1;
            continue $sm;
          case 3:
            var adapted = this.gpw_1;
            if (adapted.p() <= 1) {
              var tmp0_elvis_lhs = singleOrNull(adapted);
              return tmp0_elvis_lhs == null ? None_instance_0 : tmp0_elvis_lhs;
            }

            var this_1 = eachCount(new LibraryProcessSpecificationAdapter$LibraryProcessSpecificationContext$foldSpecifiedValues$$inlined$groupingBy$1(adapted));
            var destination = LinkedHashMap_init_$Create$_0(mapCapacity(this_1.p()));
            var _iterator__ex2g4s = this_1.y().m();
            while (_iterator__ex2g4s.n()) {
              var element = _iterator__ex2g4s.o();
              var tmp_0 = element.z();
              var count = element.a1();
              destination.t2(tmp_0, new Known(count));
            }

            var elementMultipliers = destination;
            return new SetValue(elementMultipliers, SetType_OPEN_getInstance());
          case 4:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 4) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function $runSuspendCOROUTINE$_102(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.rpw_1 = _this__u8e3s4;
    this.spw_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_102).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 10;
            var $this$suspendingQuery = this.spw_1;
            if (!this.rpw_1.apx_1._v) {
              this.xpw_1 = $this$suspendingQuery;
              this.f9_1 = 1;
              suspendResult = this.xpw_1.k60(this.rpw_1.cpx_1.ppv_1.sil(), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.f9_1 = 9;
              continue $sm;
            }

          case 1:
            var ARGUMENT = suspendResult;
            var tmp0 = distinct(ARGUMENT);
            this.tpw_1 = ArrayList_init_$Create$();
            this.zpw_1 = tmp0.m();
            this.f9_1 = 2;
            continue $sm;
          case 2:
            if (!this.zpw_1.n()) {
              this.f9_1 = 8;
              continue $sm;
            }

            var element = this.zpw_1.o();
            var tmp_0 = this;
            tmp_0.ypw_1 = element;
            this.upw_1 = Unit_instance;
            this.f9_1 = 3;
            continue $sm;
          case 3:
            this.wpw_1 = this.ypw_1;
            this.f9_1 = 4;
            suspendResult = this.xpw_1.k60((new LibraryProcessSpecificationContext(this.rpw_1.cpx_1)).spm(this.wpw_1, this.rpw_1.cpx_1.rpv_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            this.vpw_1 = suspendResult;
            var tmp_1 = this.vpw_1;
            if (tmp_1 instanceof None_0) {
              this.upw_1 = null;
              this.f9_1 = 7;
              continue $sm;
            } else {
              this.f9_1 = 5;
              continue $sm;
            }

          case 5:
            this.f9_1 = 6;
            suspendResult = aliasRoots(this.xpw_1, this.wpw_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 6:
            var tmp0_0 = suspendResult;
            var destination = LinkedHashSet_init_$Create$();
            var _iterator__ex2g4s = tmp0_0.m();
            while (_iterator__ex2g4s.n()) {
              var item = _iterator__ex2g4s.o();
              destination.j(new ProcessParameterAdapter(item));
            }

            this.upw_1 = new ParameterBinding(destination, this.vpw_1);
            if (false) {
              this.f9_1 = 3;
              continue $sm;
            }

            this.f9_1 = 7;
            continue $sm;
          case 7:
            var tmp0_safe_receiver = this.upw_1;
            if (tmp0_safe_receiver == null)
              null;
            else {
              this.tpw_1.j(tmp0_safe_receiver);
            }

            this.f9_1 = 2;
            continue $sm;
          case 8:
            var ARGUMENT_0 = this.tpw_1;
            this.rpw_1.bpx_1._v = ARGUMENT_0;
            this.rpw_1.apx_1._v = true;
            this.f9_1 = 9;
            continue $sm;
          case 9:
            var tmp_2 = this.rpw_1.bpx_1._v;
            return (tmp_2 == null ? true : !(tmp_2 == null)) ? tmp_2 : THROW_CCE();
          case 10:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 10) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function LibraryProcessSpecificationContext($outer) {
    this.dpx_1 = $outer;
  }
  protoOf(LibraryProcessSpecificationContext).spm = function (property, cache) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new LibraryProcessSpecificationAdapter$LibraryProcessSpecificationContext$adaptProcessProperty$$inlined$suspendingQuery$1(property, this.dpx_1, this, cache);
  };
  function LibraryProcessSpecificationAdapter$parameters$$inlined$cachedSuspendingQuery$1($isCached, $cachedValue, this$0) {
    this.apx_1 = $isCached;
    this.bpx_1 = $cachedValue;
    this.cpx_1 = this$0;
  }
  protoOf(LibraryProcessSpecificationAdapter$parameters$$inlined$cachedSuspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_102(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(LibraryProcessSpecificationAdapter$parameters$$inlined$cachedSuspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function LibraryProcessSpecificationAdapter(origin, process, propToSpecifiedValues, cache) {
    this.opv_1 = origin;
    this.ppv_1 = process;
    this.qpv_1 = propToSpecifiedValues;
    this.rpv_1 = cache;
    this.spv_1 = new ProcessDeclarationAdapter(this.ppv_1);
    var tmp = this;
    // Inline function 'jetbrains.biokb.lang.model.util.hierarchy.cachedSuspendingQuery' call
    var cachedValue = {_v: null};
    var isCached = {_v: false};
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    tmp.tpv_1 = new LibraryProcessSpecificationAdapter$parameters$$inlined$cachedSuspendingQuery$1(isCached, cachedValue, this);
  }
  protoOf(LibraryProcessSpecificationAdapter).wpg = function () {
    return this.spv_1;
  };
  protoOf(LibraryProcessSpecificationAdapter).kfr = function () {
    return this.tpv_1;
  };
  protoOf(LibraryProcessSpecificationAdapter).equals = function (other) {
    var tmp;
    if (other instanceof LibraryProcessSpecificationAdapter) {
      tmp = equals(this.opv_1, other.opv_1);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(LibraryProcessSpecificationAdapter).hashCode = function () {
    return hashCode(this.opv_1);
  };
  function $runSuspendCOROUTINE$_103(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.mpx_1 = _this__u8e3s4;
    this.npx_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_103).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 3;
            var $this$suspendingQuery = this.npx_1;
            if (!this.mpx_1.qpx_1._v) {
              this.f9_1 = 1;
              suspendResult = $this$suspendingQuery.k60(this.mpx_1.spx_1.opx_1.uil(), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.f9_1 = 2;
              continue $sm;
            }

          case 1:
            var tmp0 = suspendResult;
            var destination = LinkedHashSet_init_$Create$();
            var _iterator__ex2g4s = tmp0.m();
            while (_iterator__ex2g4s.n()) {
              var item = _iterator__ex2g4s.o();
              destination.j(new ProcessDeclarationAdapter(item));
            }

            this.mpx_1.rpx_1._v = destination;
            this.mpx_1.qpx_1._v = true;
            this.f9_1 = 2;
            continue $sm;
          case 2:
            var tmp_0 = this.mpx_1.rpx_1._v;
            return (tmp_0 == null ? true : !(tmp_0 == null)) ? tmp_0 : THROW_CCE();
          case 3:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 3) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function ProcessDeclarationAdapter$selfAndAncestors$$inlined$cachedSuspendingQuery$1($isCached, $cachedValue, this$0) {
    this.qpx_1 = $isCached;
    this.rpx_1 = $cachedValue;
    this.spx_1 = this$0;
  }
  protoOf(ProcessDeclarationAdapter$selfAndAncestors$$inlined$cachedSuspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_103(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(ProcessDeclarationAdapter$selfAndAncestors$$inlined$cachedSuspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function ProcessDeclarationAdapter(origin) {
    this.opx_1 = origin;
    var tmp = this;
    // Inline function 'jetbrains.biokb.lang.model.util.hierarchy.cachedSuspendingQuery' call
    var cachedValue = {_v: null};
    var isCached = {_v: false};
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    tmp.ppx_1 = new ProcessDeclarationAdapter$selfAndAncestors$$inlined$cachedSuspendingQuery$1(isCached, cachedValue, this);
  }
  protoOf(ProcessDeclarationAdapter).tpx = function () {
    return this.ppx_1;
  };
  protoOf(ProcessDeclarationAdapter).toString = function () {
    return 'ProcessDeclarationAdapter(origin=' + toString_1(this.opx_1) + ')';
  };
  protoOf(ProcessDeclarationAdapter).hashCode = function () {
    return hashCode(this.opx_1);
  };
  protoOf(ProcessDeclarationAdapter).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ProcessDeclarationAdapter))
      return false;
    if (!equals(this.opx_1, other.opx_1))
      return false;
    return true;
  };
  function ProcessParameterAdapter(origin) {
    this.upx_1 = origin;
  }
  protoOf(ProcessParameterAdapter).toString = function () {
    return 'ProcessParameterAdapter(origin=' + toString_1(this.upx_1) + ')';
  };
  protoOf(ProcessParameterAdapter).hashCode = function () {
    return hashCode(this.upx_1);
  };
  protoOf(ProcessParameterAdapter).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ProcessParameterAdapter))
      return false;
    if (!equals(this.upx_1, other.upx_1))
      return false;
    return true;
  };
  function toAdapter$o$runSuspend$lambda($this_toAdapter, $processDeclaration, $propToSpecifiedValues, $cache) {
    return function () {
      return new LibraryProcessSpecificationAdapter($this_toAdapter, $processDeclaration, $propToSpecifiedValues, $cache);
    };
  }
  function $runSuspendCOROUTINE$_104(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.dpy_1 = _this__u8e3s4;
    this.epy_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_104).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 12;
            var tmp_0 = this;
            tmp_0.rpy_1 = this.epy_1;
            this.fpy_1 = Unit_instance;
            this.f9_1 = 1;
            continue $sm;
          case 1:
            this.mpy_1 = this.rpy_1;
            this.f9_1 = 2;
            suspendResult = this.mpy_1.k60(this.dpy_1.spy_1.vfr(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var tmp0_elvis_lhs = suspendResult;
            if (tmp0_elvis_lhs == null) {
              this.fpy_1 = None_instance_0;
              this.f9_1 = 11;
              var tmp_1 = this;
              continue $sm;
            } else {
              this.qpy_1 = tmp0_elvis_lhs;
              this.f9_1 = 3;
              continue $sm;
            }

          case 3:
            this.gpy_1 = this.qpy_1;
            var tmp0 = this.dpy_1.spy_1.dia();
            this.hpy_1 = ArrayList_init_$Create$();
            this.ppy_1 = tmp0.m();
            this.f9_1 = 4;
            continue $sm;
          case 4:
            if (!this.ppy_1.n()) {
              this.f9_1 = 10;
              continue $sm;
            }

            var element = this.ppy_1.o();
            var tmp_2 = this;
            tmp_2.opy_1 = element;
            this.ipy_1 = Unit_instance;
            this.f9_1 = 5;
            continue $sm;
          case 5:
            this.lpy_1 = this.opy_1;
            this.f9_1 = 6;
            suspendResult = this.mpy_1.k60(this.lpy_1.q6q(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 6:
            var tmp0_elvis_lhs_0 = suspendResult;
            if (tmp0_elvis_lhs_0 == null) {
              this.ipy_1 = null;
              this.f9_1 = 9;
              var tmp_3 = this;
              continue $sm;
            } else {
              this.npy_1 = tmp0_elvis_lhs_0;
              this.f9_1 = 7;
              continue $sm;
            }

          case 7:
            this.jpy_1 = this.npy_1;
            var tmp1_elvis_lhs = this.mpy_1.l60(this.lpy_1.a1());
            if (tmp1_elvis_lhs == null) {
              this.ipy_1 = null;
              this.f9_1 = 9;
              var tmp_4 = this;
              continue $sm;
            } else {
              this.kpy_1 = tmp1_elvis_lhs;
              this.f9_1 = 8;
              continue $sm;
            }

          case 8:
            var value = this.kpy_1;
            this.ipy_1 = to(this.jpy_1, value);
            if (false) {
              this.f9_1 = 5;
              continue $sm;
            }

            this.f9_1 = 9;
            continue $sm;
          case 9:
            var tmp0_safe_receiver = this.ipy_1;
            if (tmp0_safe_receiver == null)
              null;
            else {
              this.hpy_1.j(tmp0_safe_receiver);
            }

            this.f9_1 = 4;
            continue $sm;
          case 10:
            var tmp0_0 = this.hpy_1;
            var destination = LinkedHashMap_init_$Create$();
            var _iterator__ex2g4s = tmp0_0.m();
            while (_iterator__ex2g4s.n()) {
              var element_0 = _iterator__ex2g4s.o();
              var key = element_0.pg_1;
              var value_0 = destination.q2(key);
              var tmp_5;
              if (value_0 == null) {
                var answer = ArrayList_init_$Create$();
                destination.t2(key, answer);
                tmp_5 = answer;
              } else {
                tmp_5 = value_0;
              }
              var list = tmp_5;
              list.j(element_0.qg_1);
            }

            var propToSpecifiedValues = destination;
            var tmp_6 = this;
            tmp_6.fpy_1 = this.dpy_1.tpy_1.oph(this.dpy_1.spy_1, toAdapter$o$runSuspend$lambda(this.dpy_1.spy_1, this.gpy_1, propToSpecifiedValues, this.dpy_1.tpy_1));
            if (false) {
              this.f9_1 = 1;
              continue $sm;
            }

            this.f9_1 = 11;
            continue $sm;
          case 11:
            return this.fpy_1;
          case 12:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 12) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function toAdapter$$inlined$suspendingQuery$1_1($this_toAdapter, $cache) {
    this.spy_1 = $this_toAdapter;
    this.tpy_1 = $cache;
  }
  protoOf(toAdapter$$inlined$suspendingQuery$1_1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_104(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(toAdapter$$inlined$suspendingQuery$1_1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function toAdapter_6(_this__u8e3s4, context, cache) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new toAdapter$$inlined$suspendingQuery$1_2(_this__u8e3s4, context, cache);
  }
  function $runSuspendCOROUTINE$_105(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.cpz_1 = _this__u8e3s4;
    this.dpz_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_105).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 13;
            var $this$suspendingQuery = this.dpz_1;
            if (!this.cpz_1.ppz_1._v) {
              this.ipz_1 = $this$suspendingQuery;
              var specification = this.ipz_1.l60(this.cpz_1.rpz_1.kpz_1.ofu());
              if (!(specification == null) ? isInterface(specification, NotionType_0) : false) {
                this.f9_1 = 10;
                suspendResult = this.ipz_1.k60(specification.mfq(), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                if (!(specification == null) ? isInterface(specification, PrimitiveNotionType_1) : false) {
                  var tmp_0 = this;
                  var tmp1_safe_receiver = this.ipz_1.l60(specification.oft());
                  var tmp_1;
                  if (tmp1_safe_receiver == null) {
                    tmp_1 = null;
                  } else {
                    tmp_1 = new PrimitiveNotionDescriptorAdapter(tmp1_safe_receiver);
                  }
                  tmp_0.epz_1 = listOfNotNull(tmp_1);
                  this.f9_1 = 11;
                  continue $sm;
                } else {
                  if (!(specification == null) ? isInterface(specification, OntologyElementType_1) : false) {
                    var tmp2_safe_receiver = this.ipz_1.l60(specification.gfq());
                    var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.gfq();
                    if (tmp3_safe_receiver == null) {
                      this.fpz_1 = null;
                      this.f9_1 = 9;
                      continue $sm;
                    } else {
                      this.f9_1 = 8;
                      suspendResult = this.ipz_1.k60(tmp3_safe_receiver.x6o(), this);
                      if (suspendResult === get_COROUTINE_SUSPENDED()) {
                        return suspendResult;
                      }
                      continue $sm;
                    }
                  } else {
                    if (!(specification == null) ? isInterface(specification, ClassExpressionType_1) : false) {
                      var tmp5_safe_receiver = this.ipz_1.l60(specification.hfq());
                      var tmp6_safe_receiver = tmp5_safe_receiver == null ? null : extractClassAdapters(tmp5_safe_receiver, this.cpz_1.rpz_1.mpz_1);
                      if (tmp6_safe_receiver == null) {
                        this.gpz_1 = null;
                        this.f9_1 = 7;
                        continue $sm;
                      } else {
                        this.f9_1 = 6;
                        suspendResult = this.ipz_1.k60(tmp6_safe_receiver, this);
                        if (suspendResult === get_COROUTINE_SUSPENDED()) {
                          return suspendResult;
                        }
                        continue $sm;
                      }
                    } else {
                      if (!(specification == null) ? isInterface(specification, VariableReferenceValue_1) : false) {
                        this.f9_1 = 3;
                        suspendResult = this.ipz_1.k60(specification.pfu().x6o(), this);
                        if (suspendResult === get_COROUTINE_SUSPENDED()) {
                          return suspendResult;
                        }
                        continue $sm;
                      } else {
                        if (!(specification == null) ? isInterface(specification, OneOf_1) : false) {
                          this.epz_1 = listOf(new OneOfAdapter(specification, this.cpz_1.rpz_1.lpz_1, this.cpz_1.rpz_1.mpz_1));
                          this.f9_1 = 11;
                          continue $sm;
                        } else {
                          if (!(specification == null) ? isInterface(specification, ProcessPropertyReference) : false) {
                            this.jpz_1 = this.cpz_1.rpz_1.lpz_1;
                            this.f9_1 = 1;
                            suspendResult = this.ipz_1.k60(specification.q6q().x6o(), this);
                            if (suspendResult === get_COROUTINE_SUSPENDED()) {
                              return suspendResult;
                            }
                            continue $sm;
                          } else {
                            this.epz_1 = emptyList();
                            this.f9_1 = 11;
                            continue $sm;
                          }
                        }
                      }
                    }
                  }
                }
              }
            } else {
              this.f9_1 = 12;
              continue $sm;
            }

          case 1:
            var ARGUMENT = suspendResult;
            var ARGUMENT_0 = this.jpz_1.spm(ARGUMENT, this.cpz_1.rpz_1.mpz_1);
            this.f9_1 = 2;
            suspendResult = this.ipz_1.k60(ARGUMENT_0, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var adapter = suspendResult;
            var tmp_2 = this;
            var tmp_3;
            if (adapter instanceof ClassValue) {
              tmp_3 = listOf(adapter.ym4_1);
            } else {
              tmp_3 = emptyList();
            }

            tmp_2.epz_1 = tmp_3;
            this.f9_1 = 11;
            continue $sm;
          case 3:
            var tmp7_safe_receiver = suspendResult;
            if (tmp7_safe_receiver == null) {
              this.hpz_1 = null;
              this.f9_1 = 5;
              continue $sm;
            } else {
              this.f9_1 = 4;
              suspendResult = this.ipz_1.k60(toAdapter_6(tmp7_safe_receiver, this.cpz_1.rpz_1.lpz_1, this.cpz_1.rpz_1.mpz_1), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 4:
            this.hpz_1 = suspendResult;
            this.f9_1 = 5;
            continue $sm;
          case 5:
            var adapter_0 = this.hpz_1;
            var tmp_4 = this;
            var tmp8_safe_receiver = adapter_0 instanceof ClassValue ? adapter_0 : null;
            var tmp_5;
            if (tmp8_safe_receiver == null) {
              tmp_5 = null;
            } else {
              tmp_5 = listOf(tmp8_safe_receiver.ym4_1);
            }

            var tmp0_elvis_lhs = tmp_5;
            tmp_4.epz_1 = tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
            this.f9_1 = 11;
            continue $sm;
          case 6:
            this.gpz_1 = suspendResult;
            this.f9_1 = 7;
            continue $sm;
          case 7:
            var tmp_6 = this;
            var tmp0_elvis_lhs_0 = this.gpz_1;
            tmp_6.epz_1 = tmp0_elvis_lhs_0 == null ? emptyList() : tmp0_elvis_lhs_0;
            this.f9_1 = 11;
            continue $sm;
          case 8:
            this.fpz_1 = suspendResult;
            this.f9_1 = 9;
            continue $sm;
          case 9:
            var tmp4_safe_receiver = this.fpz_1;
            var adapter_1 = tmp4_safe_receiver == null ? null : toAdapter_0(tmp4_safe_receiver, this.cpz_1.rpz_1.mpz_1);
            this.epz_1 = listOfNotNull(adapter_1);
            this.f9_1 = 11;
            continue $sm;
          case 10:
            var tmp0_safe_receiver = suspendResult;
            var tmp_7;
            if (tmp0_safe_receiver == null) {
              tmp_7 = null;
            } else {
              tmp_7 = new NotionDescriptorAdapter(tmp0_safe_receiver);
            }

            var ARGUMENT_1 = tmp_7;
            this.epz_1 = listOfNotNull(ARGUMENT_1);
            this.f9_1 = 11;
            continue $sm;
          case 11:
            var ARGUMENT_2 = this.epz_1;
            this.cpz_1.qpz_1._v = ARGUMENT_2;
            this.cpz_1.ppz_1._v = true;
            this.f9_1 = 12;
            continue $sm;
          case 12:
            var tmp_8 = this.cpz_1.qpz_1._v;
            return (tmp_8 == null ? true : !(tmp_8 == null)) ? tmp_8 : THROW_CCE();
          case 13:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 13) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function VariableDeclarationAdapter$classes$$inlined$cachedSuspendingQuery$1($isCached, $cachedValue, this$0) {
    this.ppz_1 = $isCached;
    this.qpz_1 = $cachedValue;
    this.rpz_1 = this$0;
  }
  protoOf(VariableDeclarationAdapter$classes$$inlined$cachedSuspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_105(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(VariableDeclarationAdapter$classes$$inlined$cachedSuspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function VariableDeclarationAdapter$constraints$$inlined$cachedSuspendingQuery$1($isCached, $cachedValue, this$0) {
    this.spz_1 = $isCached;
    this.tpz_1 = $cachedValue;
    this.upz_1 = this$0;
  }
  protoOf(VariableDeclarationAdapter$constraints$$inlined$cachedSuspendingQuery$1).b61 = function (builder, $completion) {
    if (!this.spz_1._v) {
      var tmp$ret$0 = toAdapters(builder.l60(this.upz_1.kpz_1.ofr()), this.upz_1.lpz_1, this.upz_1.mpz_1);
      this.tpz_1._v = tmp$ret$0;
      this.spz_1._v = true;
    }
    var tmp = this.tpz_1._v;
    return (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
  };
  protoOf(VariableDeclarationAdapter$constraints$$inlined$cachedSuspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function VariableDeclarationAdapter(origin, context, cache) {
    this.kpz_1 = origin;
    this.lpz_1 = context;
    this.mpz_1 = cache;
    var tmp = this;
    // Inline function 'jetbrains.biokb.lang.model.util.hierarchy.cachedSuspendingQuery' call
    var cachedValue = {_v: null};
    var isCached = {_v: false};
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    tmp.npz_1 = new VariableDeclarationAdapter$classes$$inlined$cachedSuspendingQuery$1(isCached, cachedValue, this);
    var tmp_0 = this;
    // Inline function 'jetbrains.biokb.lang.model.util.hierarchy.cachedSuspendingQuery' call
    var cachedValue_0 = {_v: null};
    var isCached_0 = {_v: false};
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    tmp_0.opz_1 = new VariableDeclarationAdapter$constraints$$inlined$cachedSuspendingQuery$1(isCached_0, cachedValue_0, this);
  }
  protoOf(VariableDeclarationAdapter).mfu = function () {
    return this.npz_1;
  };
  protoOf(VariableDeclarationAdapter).ofr = function () {
    return this.opz_1;
  };
  protoOf(VariableDeclarationAdapter).equals = function (other) {
    var tmp;
    var tmp_0;
    if (other instanceof VariableDeclarationAdapter) {
      tmp_0 = equals(this.kpz_1, other.kpz_1);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = equals(this.lpz_1, other.lpz_1);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(VariableDeclarationAdapter).hashCode = function () {
    return imul(31, hashCode(this.kpz_1)) + hashCode(this.lpz_1) | 0;
  };
  protoOf(VariableDeclarationAdapter).toString = function () {
    return 'VariableDeclarationAdapter(origin=' + toString_1(this.kpz_1) + ', context=' + toString_1(this.lpz_1) + ', cache=' + toString_1(this.mpz_1) + ')';
  };
  function unwrap_1(_this__u8e3s4, reference, visitedRefs, $completion) {
    var tmp;
    if (visitedRefs === VOID) {
      tmp = LinkedHashSet_init_$Create$();
    } else {
      tmp = visitedRefs;
    }
    visitedRefs = tmp;
    var tmp_0 = new $unwrapCOROUTINE$(_this__u8e3s4, reference, visitedRefs, $completion);
    tmp_0.h9_1 = Unit_instance;
    tmp_0.i9_1 = null;
    return tmp_0.n9();
  }
  function adaptProcessPropertyReference(_this__u8e3s4, variable, specification, context, cache, $completion) {
    var tmp = new $adaptProcessPropertyReferenceCOROUTINE$(_this__u8e3s4, variable, specification, context, cache, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  }
  function NotionDescriptorAdapter(origin) {
    this.zq0_1 = origin;
  }
  protoOf(NotionDescriptorAdapter).cma = function () {
    return this.zq0_1;
  };
  protoOf(NotionDescriptorAdapter).toString = function () {
    return 'NotionDescriptorAdapter(origin=' + toString_1(this.zq0_1) + ')';
  };
  protoOf(NotionDescriptorAdapter).hashCode = function () {
    return hashCode(this.zq0_1);
  };
  protoOf(NotionDescriptorAdapter).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof NotionDescriptorAdapter))
      return false;
    if (!equals(this.zq0_1, other.zq0_1))
      return false;
    return true;
  };
  function PrimitiveNotionDescriptorAdapter(origin) {
    this.aq1_1 = origin;
  }
  protoOf(PrimitiveNotionDescriptorAdapter).cma = function () {
    return this.aq1_1;
  };
  protoOf(PrimitiveNotionDescriptorAdapter).toString = function () {
    return 'PrimitiveNotionDescriptorAdapter(origin=' + this.aq1_1.toString() + ')';
  };
  protoOf(PrimitiveNotionDescriptorAdapter).hashCode = function () {
    return this.aq1_1.hashCode();
  };
  protoOf(PrimitiveNotionDescriptorAdapter).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PrimitiveNotionDescriptorAdapter))
      return false;
    if (!this.aq1_1.equals(other.aq1_1))
      return false;
    return true;
  };
  function $runSuspendCOROUTINE$_106(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.jq1_1 = _this__u8e3s4;
    this.kq1_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_106).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 7;
            this.nq1_1 = this.kq1_1;
            var tmp0 = this.nq1_1.l60(this.jq1_1.uq1_1.rq1_1.mfs());
            this.lq1_1 = ArrayList_init_$Create$();
            this.qq1_1 = tmp0.m();
            this.f9_1 = 1;
            continue $sm;
          case 1:
            if (!this.qq1_1.n()) {
              this.f9_1 = 6;
              continue $sm;
            }

            var element = this.qq1_1.o();
            var tmp_0 = this;
            tmp_0.pq1_1 = element;
            this.mq1_1 = Unit_instance;
            this.f9_1 = 2;
            continue $sm;
          case 2:
            var expression = this.pq1_1;
            var tmp0_elvis_lhs = isInterface(expression, FactExpression) ? expression : null;
            if (tmp0_elvis_lhs == null) {
              this.mq1_1 = null;
              this.f9_1 = 5;
              var tmp_1 = this;
              continue $sm;
            } else {
              this.oq1_1 = tmp0_elvis_lhs;
              this.f9_1 = 3;
              continue $sm;
            }

          case 3:
            var factExpression = this.oq1_1;
            this.f9_1 = 4;
            suspendResult = this.nq1_1.k60(toAdapter_3(factExpression, this.jq1_1.uq1_1.sq1_1, this.jq1_1.uq1_1.tq1_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            var adapter = suspendResult;
            var tmp_2 = this;
            var tmp_3;
            if (adapter instanceof ClassValue) {
              tmp_3 = adapter.ym4_1;
            } else {
              tmp_3 = null;
            }

            tmp_2.mq1_1 = tmp_3;
            if (false) {
              this.f9_1 = 2;
              continue $sm;
            }

            this.f9_1 = 5;
            continue $sm;
          case 5:
            var tmp0_safe_receiver = this.mq1_1;
            if (tmp0_safe_receiver == null)
              null;
            else {
              this.lq1_1.j(tmp0_safe_receiver);
            }

            this.f9_1 = 1;
            continue $sm;
          case 6:
            return this.lq1_1;
          case 7:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 7) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function OneOfAdapter$classes$$inlined$suspendingQuery$1(this$0) {
    this.uq1_1 = this$0;
  }
  protoOf(OneOfAdapter$classes$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_106(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(OneOfAdapter$classes$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function OneOfAdapter$constraints$$inlined$suspendingQuery$1() {
  }
  protoOf(OneOfAdapter$constraints$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    return emptyList();
  };
  protoOf(OneOfAdapter$constraints$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function OneOfAdapter(origin, context, cache) {
    this.rq1_1 = origin;
    this.sq1_1 = context;
    this.tq1_1 = cache;
  }
  protoOf(OneOfAdapter).mfu = function () {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new OneOfAdapter$classes$$inlined$suspendingQuery$1(this);
  };
  protoOf(OneOfAdapter).ofr = function () {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new OneOfAdapter$constraints$$inlined$suspendingQuery$1();
  };
  protoOf(OneOfAdapter).equals = function (other) {
    var tmp;
    var tmp_0;
    if (other instanceof OneOfAdapter) {
      tmp_0 = equals(this.rq1_1, other.rq1_1);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = equals(this.sq1_1, other.sq1_1);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(OneOfAdapter).hashCode = function () {
    return imul(31, hashCode(this.rq1_1)) + hashCode(this.sq1_1) | 0;
  };
  protoOf(OneOfAdapter).toString = function () {
    return 'OneOfAdapter(origin=' + toString_1(this.rq1_1) + ', context=' + toString_1(this.sq1_1) + ', cache=' + toString_1(this.tq1_1) + ')';
  };
  function $runSuspendCOROUTINE$_107(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.dq2_1 = _this__u8e3s4;
    this.eq2_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_107).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 8;
            var tmp_0 = this;
            tmp_0.kq2_1 = this.eq2_1;
            this.fq2_1 = Unit_instance;
            this.f9_1 = 1;
            continue $sm;
          case 1:
            this.hq2_1 = this.kq2_1;
            var specification = this.hq2_1.l60(this.dq2_1.lq2_1.ofu());
            var tmp_1;
            var tmp_2;
            if (!(specification == null) ? isInterface(specification, NotionType_0) : false) {
              tmp_2 = true;
            } else {
              tmp_2 = !(specification == null) ? isInterface(specification, PrimitiveNotionType_1) : false;
            }

            if (tmp_2) {
              tmp_1 = true;
            } else {
              var tmp_3;
              if (!(specification == null) ? isInterface(specification, OntologyElementType_1) : false) {
                tmp_3 = true;
              } else {
                var tmp_4;
                if (!(specification == null) ? isInterface(specification, ClassExpressionType_1) : false) {
                  tmp_4 = true;
                } else {
                  tmp_4 = !(specification == null) ? isInterface(specification, OneOf_1) : false;
                }
                tmp_3 = tmp_4;
              }
              tmp_1 = tmp_3;
            }

            if (tmp_1) {
              this.gq2_1 = new ClassValue(new VariableDeclarationAdapter(this.dq2_1.lq2_1, this.dq2_1.mq2_1, this.dq2_1.nq2_1));
              this.f9_1 = 9;
              continue $sm;
            } else {
              if (!(specification == null) ? isInterface(specification, VariableReferenceValue_1) : false) {
                this.f9_1 = 5;
                suspendResult = unwrap_1(this.hq2_1, specification, VOID, this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                if (!(specification == null) ? isInterface(specification, ProcessType_1) : false) {
                  var tmp2_safe_receiver = this.hq2_1.l60(specification.vfq());
                  var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : toAdapter_5(tmp2_safe_receiver, this.dq2_1.nq2_1);
                  if (tmp3_safe_receiver == null) {
                    this.jq2_1 = null;
                    this.f9_1 = 4;
                    continue $sm;
                  } else {
                    this.f9_1 = 3;
                    suspendResult = this.hq2_1.k60(tmp3_safe_receiver, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) {
                      return suspendResult;
                    }
                    continue $sm;
                  }
                } else {
                  if (!(specification == null) ? isInterface(specification, ProcessPropertyReference) : false) {
                    this.f9_1 = 2;
                    suspendResult = adaptProcessPropertyReference(this.hq2_1, this.dq2_1.lq2_1, specification, this.dq2_1.mq2_1, this.dq2_1.nq2_1, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) {
                      return suspendResult;
                    }
                    continue $sm;
                  } else {
                    this.gq2_1 = None_instance_0;
                    this.f9_1 = 9;
                    continue $sm;
                  }
                }
              }
            }

          case 2:
            this.gq2_1 = suspendResult;
            this.f9_1 = 9;
            continue $sm;
          case 3:
            this.jq2_1 = suspendResult;
            this.f9_1 = 4;
            continue $sm;
          case 4:
            var tmp4_elvis_lhs = this.jq2_1;
            this.gq2_1 = tmp4_elvis_lhs == null ? None_instance_0 : tmp4_elvis_lhs;
            this.f9_1 = 9;
            continue $sm;
          case 5:
            var tmp0_elvis_lhs = suspendResult;
            if (tmp0_elvis_lhs == null) {
              this.fq2_1 = None_instance_0;
              this.f9_1 = 10;
              var tmp_5 = this;
              continue $sm;
            } else {
              this.iq2_1 = tmp0_elvis_lhs;
              this.f9_1 = 6;
              continue $sm;
            }

          case 6:
            var target = this.iq2_1;
            this.f9_1 = 7;
            suspendResult = this.hq2_1.k60(toAdapter_6(target, this.dq2_1.mq2_1, this.dq2_1.nq2_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 7:
            var targetAdapter = suspendResult;
            var tmp_6 = this;
            var tmp_7;
            if (targetAdapter instanceof ClassValue) {
              tmp_7 = new ClassValue(new VariableDeclarationAdapter(this.dq2_1.lq2_1, this.dq2_1.mq2_1, this.dq2_1.nq2_1));
            } else {
              tmp_7 = targetAdapter;
            }

            tmp_6.gq2_1 = tmp_7;
            this.f9_1 = 9;
            continue $sm;
          case 8:
            throw this.i9_1;
          case 9:
            this.fq2_1 = this.gq2_1;
            if (false) {
              this.f9_1 = 1;
              continue $sm;
            }

            this.f9_1 = 10;
            continue $sm;
          case 10:
            return this.fq2_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 8) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function toAdapter$$inlined$suspendingQuery$1_2($this_toAdapter, $context, $cache) {
    this.lq2_1 = $this_toAdapter;
    this.mq2_1 = $context;
    this.nq2_1 = $cache;
  }
  protoOf(toAdapter$$inlined$suspendingQuery$1_2).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_107(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(toAdapter$$inlined$suspendingQuery$1_2).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function $unwrapCOROUTINE$(_this__u8e3s4, reference, visitedRefs, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.dq0_1 = _this__u8e3s4;
    this.eq0_1 = reference;
    this.fq0_1 = visitedRefs;
  }
  protoOf($unwrapCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 10;
            if (!this.fq0_1.j(this.eq0_1))
              return null;
            this.f9_1 = 1;
            continue $sm;
          case 1:
            this.f9_1 = 2;
            continue $sm;
          case 2:
            this.g9_1 = 9;
            this.f9_1 = 3;
            suspendResult = this.dq0_1.k60(this.eq0_1.pfu().x6o(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            var tmp0_elvis_lhs = suspendResult;
            if (tmp0_elvis_lhs == null) {
              this.hq0_1 = null;
              this.g9_1 = 10;
              this.f9_1 = 7;
              var tmp_0 = this;
              continue $sm;
            } else {
              this.jq0_1 = tmp0_elvis_lhs;
              this.f9_1 = 4;
              continue $sm;
            }

          case 4:
            var variable = this.jq0_1;
            var tmp_1 = this.dq0_1.l60(variable.ofu());
            var tmp1_elvis_lhs = (!(tmp_1 == null) ? isInterface(tmp_1, VariableReferenceValue_1) : false) ? tmp_1 : null;
            if (tmp1_elvis_lhs == null) {
              this.hq0_1 = variable;
              this.g9_1 = 10;
              this.f9_1 = 7;
              var tmp_2 = this;
              continue $sm;
            } else {
              this.iq0_1 = tmp1_elvis_lhs;
              this.f9_1 = 5;
              continue $sm;
            }

          case 5:
            var specification = this.iq0_1;
            this.f9_1 = 6;
            suspendResult = unwrap_1(this.dq0_1, specification, this.fq0_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 6:
            this.gq0_1 = suspendResult;
            this.g9_1 = 10;
            this.f9_1 = 8;
            continue $sm;
          case 7:
            var tmp_3 = this.hq0_1;
            this.g9_1 = 10;
            this.fq0_1.h2(this.eq0_1);
            var tmp_4 = this;
            return tmp_3;
          case 8:
            var tmp_5 = this.gq0_1;
            this.g9_1 = 10;
            this.fq0_1.h2(this.eq0_1);
            return tmp_5;
          case 9:
            this.g9_1 = 10;
            var t = this.i9_1;
            this.fq0_1.h2(this.eq0_1);
            throw t;
          case 10:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 10) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function $adaptProcessPropertyReferenceCOROUTINE$(_this__u8e3s4, variable, specification, context, cache, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.sq0_1 = _this__u8e3s4;
    this.tq0_1 = variable;
    this.uq0_1 = specification;
    this.vq0_1 = context;
    this.wq0_1 = cache;
  }
  protoOf($adaptProcessPropertyReferenceCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 5;
            this.f9_1 = 1;
            suspendResult = this.sq0_1.k60(this.uq0_1.q6q().x6o(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            var ARGUMENT_0 = this.vq0_1.spm(ARGUMENT, this.wq0_1);
            this.f9_1 = 2;
            suspendResult = this.sq0_1.k60(ARGUMENT_0, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.yq0_1 = suspendResult;
            var tmp0_subject = this.yq0_1;
            if (tmp0_subject instanceof ClassValue) {
              this.xq0_1 = new ClassValue(new VariableDeclarationAdapter(this.tq0_1, this.vq0_1, this.wq0_1));
              this.f9_1 = 4;
              continue $sm;
            } else {
              if (tmp0_subject instanceof RelationFactExpressionDescriptor) {
                this.xq0_1 = None_instance_0;
                this.f9_1 = 4;
                continue $sm;
              } else {
                var tmp_0;
                var tmp_1;
                var tmp_2;
                if (equals(tmp0_subject, None_instance_0)) {
                  tmp_2 = true;
                } else {
                  tmp_2 = tmp0_subject instanceof Enum_0;
                }
                if (tmp_2) {
                  tmp_1 = true;
                } else {
                  var tmp_3;
                  if (tmp0_subject instanceof Measurable) {
                    tmp_3 = true;
                  } else {
                    tmp_3 = tmp0_subject instanceof StringVal;
                  }
                  tmp_1 = tmp_3;
                }
                if (tmp_1) {
                  tmp_0 = true;
                } else {
                  var tmp_4;
                  var tmp_5;
                  if (tmp0_subject instanceof IntegerVal) {
                    tmp_5 = true;
                  } else {
                    tmp_5 = tmp0_subject instanceof ComplexNotion_2;
                  }
                  if (tmp_5) {
                    tmp_4 = true;
                  } else {
                    var tmp_6;
                    if (tmp0_subject instanceof SetValue) {
                      tmp_6 = true;
                    } else {
                      var tmp_7;
                      if (tmp0_subject instanceof ConstrainedValue) {
                        tmp_7 = true;
                      } else {
                        tmp_7 = isInterface(tmp0_subject, LibraryProcessSpecificationDescriptor);
                      }
                      tmp_6 = tmp_7;
                    }
                    tmp_4 = tmp_6;
                  }
                  tmp_0 = tmp_4;
                }
                if (tmp_0) {
                  this.f9_1 = 3;
                  suspendResult = this.sq0_1.k60((new TypeExpressionConverter()).oq2(toAdapters(this.sq0_1.l60(this.tq0_1.ofr()), this.vq0_1, this.wq0_1)), this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  continue $sm;
                } else {
                  var tmp_8 = this;
                  noWhenBranchMatchedException();
                }
              }
            }

            break;
          case 3:
            var constraints = suspendResult;
            this.xq0_1 = ConstraintOperations_getInstance().qq2(this.yq0_1, constraints);
            this.f9_1 = 4;
            continue $sm;
          case 4:
            return this.xq0_1;
          case 5:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 5) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function ConstraintOperations() {
    ConstraintOperations_instance = this;
    this.pq2_1 = new SetValue(emptyMap(), SetType_OPEN_getInstance());
  }
  protoOf(ConstraintOperations).rq2 = function (constraints) {
    // Inline function 'kotlin.collections.mutableMapOf' call
    var effectiveValues = LinkedHashMap_init_$Create$();
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = constraints.m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      var property = element.opg_1;
      var current = effectiveValues.q2(property);
      var updated = ValueDescriptorOperations_instance.sq2(element.qpg_1, current, element.ppg_1);
      // Inline function 'kotlin.collections.set' call
      effectiveValues.t2(property, updated);
    }
    return effectiveValues;
  };
  protoOf(ConstraintOperations).tq2 = function (constraints) {
    // Inline function 'kotlin.collections.groupBy' call
    // Inline function 'kotlin.collections.groupByTo' call
    var destination = LinkedHashMap_init_$Create$();
    var _iterator__ex2g4s = constraints.m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      var key = element.opg_1;
      // Inline function 'kotlin.collections.getOrPut' call
      var value = destination.q2(key);
      var tmp;
      if (value == null) {
        var answer = ArrayList_init_$Create$();
        destination.t2(key, answer);
        tmp = answer;
      } else {
        tmp = value;
      }
      var list = tmp;
      list.j(element);
    }
    var byProperty = destination;
    // Inline function 'kotlin.collections.flatMap' call
    // Inline function 'kotlin.collections.flatMapTo' call
    var destination_0 = ArrayList_init_$Create$();
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s_0 = byProperty.y().m();
    while (_iterator__ex2g4s_0.n()) {
      var element_0 = _iterator__ex2g4s_0.o();
      // Inline function 'kotlin.collections.component1' call
      var property = element_0.z();
      // Inline function 'kotlin.collections.component2' call
      var group = element_0.a1();
      var tmp_0;
      switch (group.p()) {
        case 0:
          tmp_0 = emptyList();
          break;
        case 1:
          tmp_0 = listOf(first(group));
          break;
        default:
          // Inline function 'kotlin.collections.fold' call

          var accumulator = ConstraintOperations_getInstance().pq2_1;
          var _iterator__ex2g4s_1 = group.m();
          while (_iterator__ex2g4s_1.n()) {
            var element_1 = _iterator__ex2g4s_1.o();
            var acc = accumulator;
            accumulator = ValueDescriptorOperations_instance.uq2(acc, element_1.ppg_1);
          }

          var merged = accumulator;
          tmp_0 = listOf(new Constraint(property, merged.npg(VOID, SetType_OPEN_getInstance()), null));
          break;
      }
      var list_0 = tmp_0;
      addAll_1(destination_0, list_0);
    }
    return destination_0;
  };
  protoOf(ConstraintOperations).qq2 = function (element, setConstraints) {
    var tmp;
    if (element instanceof ConstrainedValue) {
      tmp = to(element.rpg_1, element.spg_1);
    } else {
      if (isInterface(element, Constrainable)) {
        tmp = to(element, emptyList());
      } else {
        if (element instanceof RelationFactExpressionDescriptor) {
          tmp = to(None_instance_0, emptyList());
        } else {
          noWhenBranchMatchedException();
        }
      }
    }
    var _destruct__k2r9zo = tmp;
    var base = _destruct__k2r9zo.fg();
    var existing = _destruct__k2r9zo.gg();
    var all = plus_5(existing, setConstraints);
    if (base instanceof SetValue) {
      // Inline function 'kotlin.collections.mapKeys' call
      var this_0 = base.kpg_1;
      // Inline function 'kotlin.collections.mapKeysTo' call
      var destination = LinkedHashMap_init_$Create$_0(mapCapacity(this_0.p()));
      // Inline function 'kotlin.collections.associateByTo' call
      var _iterator__ex2g4s = this_0.y().m();
      while (_iterator__ex2g4s.n()) {
        var element_0 = _iterator__ex2g4s.o();
        // Inline function 'kotlin.collections.component1' call
        var inner = element_0.z();
        var tmp_0 = ConstraintOperations_getInstance().qq2(inner, all);
        var tmp$ret$2 = element_0.a1();
        destination.t2(tmp_0, tmp$ret$2);
      }
      var redistributed = destination;
      return new SetValue(redistributed, base.lpg_1);
    }
    var effective = this.rq2(all);
    if (effective.s())
      return base;
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList_init_$Create$_0(effective.p());
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s_0 = effective.y().m();
    while (_iterator__ex2g4s_0.n()) {
      var item = _iterator__ex2g4s_0.o();
      // Inline function 'kotlin.collections.component1' call
      var p = item.z();
      // Inline function 'kotlin.collections.component2' call
      var v = item.a1();
      var tmp$ret$9 = new Constraint(p, v, null);
      destination_0.j(tmp$ret$9);
    }
    return new ConstrainedValue(base, destination_0);
  };
  var ConstraintOperations_instance;
  function ConstraintOperations_getInstance() {
    if (ConstraintOperations_instance == null)
      new ConstraintOperations();
    return ConstraintOperations_instance;
  }
  function DnfNormalizer() {
  }
  protoOf(DnfNormalizer).vq2 = function (expression) {
    var tmp;
    if (expression instanceof Clause) {
      tmp = new NormalizedType(setOf(new ConjTerm(expression.bq3_1, expression.cq3_1)));
    } else {
      if (expression instanceof Union) {
        var tmp_0;
        if (expression.wq2_1.t(Companion_getInstance_369().zq2_1)) {
          tmp_0 = Companion_getInstance_368().xq2_1;
        } else {
          // Inline function 'kotlin.collections.map' call
          var this_0 = expression.wq2_1;
          // Inline function 'kotlin.collections.mapTo' call
          var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
          var _iterator__ex2g4s = this_0.m();
          while (_iterator__ex2g4s.n()) {
            var item = _iterator__ex2g4s.o();
            var tmp$ret$0 = this.vq2(item);
            destination.j(tmp$ret$0);
          }
          // Inline function 'kotlin.collections.fold' call
          var accumulator = Companion_getInstance_368().yq2_1;
          var _iterator__ex2g4s_0 = destination.m();
          while (_iterator__ex2g4s_0.n()) {
            var element = _iterator__ex2g4s_0.o();
            var acc = accumulator;
            accumulator = or(acc, element);
          }
          tmp_0 = accumulator;
        }
        tmp = tmp_0;
      } else {
        noWhenBranchMatchedException();
      }
    }
    return tmp;
  };
  function or(_this__u8e3s4, other) {
    return new NormalizedType(plus_10(_this__u8e3s4.dq3_1, other.dq3_1));
  }
  function combine_1(_this__u8e3s4, other) {
    var tmp;
    var tmp_0;
    if (_this__u8e3s4 instanceof Known) {
      tmp_0 = other instanceof Known;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = new Known(_this__u8e3s4.cpg_1 + other.cpg_1 | 0);
    } else {
      tmp = Unknown_instance_0;
    }
    return tmp;
  }
  function matchingBounds(_this__u8e3s4) {
    // Inline function 'kotlin.collections.mapValues' call
    // Inline function 'kotlin.collections.mapValuesTo' call
    var destination = LinkedHashMap_init_$Create$_0(mapCapacity(_this__u8e3s4.p()));
    // Inline function 'kotlin.collections.associateByTo' call
    var _iterator__ex2g4s = _this__u8e3s4.y().m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      var tmp = element.z();
      // Inline function 'kotlin.collections.component2' call
      var multiplier = element.a1();
      var tmp$ret$2 = matchingBounds_0(multiplier);
      destination.t2(tmp, tmp$ret$2);
    }
    return destination;
  }
  function matchingBounds_0(_this__u8e3s4) {
    var tmp;
    if (equals(_this__u8e3s4, Unknown_instance_0)) {
      tmp = Companion_getInstance_364().vpd_1;
    } else {
      if (_this__u8e3s4 instanceof Known) {
        tmp = Companion_getInstance_364().wpd(_this__u8e3s4.cpg_1);
      } else {
        noWhenBranchMatchedException();
      }
    }
    return tmp;
  }
  function subtract_2(_this__u8e3s4, other) {
    var tmp;
    var tmp_0;
    if (_this__u8e3s4 instanceof Known) {
      tmp_0 = other instanceof Known;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      // Inline function 'kotlin.takeIf' call
      var this_0 = _this__u8e3s4.cpg_1 - other.cpg_1 | 0;
      var tmp_1;
      if (this_0 > 0) {
        tmp_1 = this_0;
      } else {
        tmp_1 = null;
      }
      var tmp0_safe_receiver = tmp_1;
      var tmp_2;
      if (tmp0_safe_receiver == null) {
        tmp_2 = null;
      } else {
        // Inline function 'kotlin.let' call
        tmp_2 = new Known(tmp0_safe_receiver);
      }
      tmp = tmp_2;
    } else {
      tmp = Unknown_instance_0;
    }
    return tmp;
  }
  function ConjTerm(base, props) {
    base = base === VOID ? null : base;
    props = props === VOID ? emptySet() : props;
    this.eq3_1 = base;
    this.fq3_1 = props;
    var tmp = this;
    // Inline function 'kotlin.collections.groupBy' call
    var tmp0 = this.fq3_1;
    // Inline function 'kotlin.collections.groupByTo' call
    var destination = LinkedHashMap_init_$Create$();
    var _iterator__ex2g4s = tmp0.m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      var key = element.iq3_1;
      // Inline function 'kotlin.collections.getOrPut' call
      var value = destination.q2(key);
      var tmp_0;
      if (value == null) {
        var answer = ArrayList_init_$Create$();
        destination.t2(key, answer);
        tmp_0 = answer;
      } else {
        tmp_0 = value;
      }
      var list = tmp_0;
      list.j(element);
    }
    // Inline function 'kotlin.collections.mapValues' call
    // Inline function 'kotlin.collections.mapValuesTo' call
    var destination_0 = LinkedHashMap_init_$Create$_0(mapCapacity(destination.p()));
    // Inline function 'kotlin.collections.associateByTo' call
    var _iterator__ex2g4s_0 = destination.y().m();
    while (_iterator__ex2g4s_0.n()) {
      var element_0 = _iterator__ex2g4s_0.o();
      var tmp_1 = element_0.z();
      // Inline function 'kotlin.collections.component2' call
      var properties = element_0.a1();
      var tmp$ret$8;
      $l$block: {
        // Inline function 'kotlin.collections.firstOrNull' call
        var _iterator__ex2g4s_1 = properties.m();
        while (_iterator__ex2g4s_1.n()) {
          var element_1 = _iterator__ex2g4s_1.o();
          if (element_1.kq3_1.equals(Source_DEFINITIONAL_getInstance())) {
            tmp$ret$8 = element_1;
            break $l$block;
          }
        }
        tmp$ret$8 = null;
      }
      var definitional = tmp$ret$8;
      var tmp$ret$9 = definitional == null ? first(properties) : definitional;
      destination_0.t2(tmp_1, tmp$ret$9);
    }
    tmp.gq3_1 = destination_0;
    var tmp_2 = this;
    // Inline function 'kotlin.collections.filter' call
    var tmp0_0 = this.fq3_1;
    // Inline function 'kotlin.collections.filterTo' call
    var destination_1 = ArrayList_init_$Create$();
    var _iterator__ex2g4s_2 = tmp0_0.m();
    while (_iterator__ex2g4s_2.n()) {
      var element_2 = _iterator__ex2g4s_2.o();
      if (element_2.kq3_1.equals(Source_DEFINITIONAL_getInstance())) {
        destination_1.j(element_2);
      }
    }
    tmp_2.hq3_1 = toSet_0(destination_1);
  }
  protoOf(ConjTerm).toString = function () {
    return 'ConjTerm(base=' + toString_0(this.eq3_1) + ', props=' + toString_1(this.fq3_1) + ')';
  };
  protoOf(ConjTerm).hashCode = function () {
    var result = this.eq3_1 == null ? 0 : hashCode(this.eq3_1);
    result = imul(result, 31) + hashCode(this.fq3_1) | 0;
    return result;
  };
  protoOf(ConjTerm).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ConjTerm))
      return false;
    if (!equals(this.eq3_1, other.eq3_1))
      return false;
    if (!equals(this.fq3_1, other.fq3_1))
      return false;
    return true;
  };
  function Companion_368() {
    Companion_instance_368 = this;
    this.xq2_1 = new NormalizedType(setOf(new ConjTerm()));
    this.yq2_1 = new NormalizedType(emptySet());
  }
  var Companion_instance_368;
  function Companion_getInstance_368() {
    if (Companion_instance_368 == null)
      new Companion_368();
    return Companion_instance_368;
  }
  function NormalizedType(clauses) {
    Companion_getInstance_368();
    this.dq3_1 = clauses;
  }
  protoOf(NormalizedType).toString = function () {
    return 'NormalizedType(clauses=' + toString_1(this.dq3_1) + ')';
  };
  protoOf(NormalizedType).hashCode = function () {
    return hashCode(this.dq3_1);
  };
  protoOf(NormalizedType).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof NormalizedType))
      return false;
    if (!equals(this.dq3_1, other.dq3_1))
      return false;
    return true;
  };
  var Source_INHERENT_instance;
  var Source_DEFINITIONAL_instance;
  var Source_entriesInitialized;
  function Source_initEntries() {
    if (Source_entriesInitialized)
      return Unit_instance;
    Source_entriesInitialized = true;
    Source_INHERENT_instance = new Source('INHERENT', 0);
    Source_DEFINITIONAL_instance = new Source('DEFINITIONAL', 1);
  }
  function Source(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function Source_INHERENT_getInstance() {
    Source_initEntries();
    return Source_INHERENT_instance;
  }
  function Source_DEFINITIONAL_getInstance() {
    Source_initEntries();
    return Source_DEFINITIONAL_instance;
  }
  function HasProperty(p, v, source) {
    this.iq3_1 = p;
    this.jq3_1 = v;
    this.kq3_1 = source;
  }
  protoOf(HasProperty).fg = function () {
    return this.iq3_1;
  };
  protoOf(HasProperty).gg = function () {
    return this.jq3_1;
  };
  protoOf(HasProperty).toString = function () {
    return 'HasProperty(p=' + toString_1(this.iq3_1) + ', v=' + toString_1(this.jq3_1) + ', source=' + this.kq3_1.toString() + ')';
  };
  protoOf(HasProperty).hashCode = function () {
    var result = hashCode(this.iq3_1);
    result = imul(result, 31) + hashCode(this.jq3_1) | 0;
    result = imul(result, 31) + this.kq3_1.hashCode() | 0;
    return result;
  };
  protoOf(HasProperty).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof HasProperty))
      return false;
    if (!equals(this.iq3_1, other.iq3_1))
      return false;
    if (!equals(this.jq3_1, other.jq3_1))
      return false;
    if (!this.kq3_1.equals(other.kq3_1))
      return false;
    return true;
  };
  function Clause(element, properties) {
    element = element === VOID ? null : element;
    properties = properties === VOID ? emptySet() : properties;
    this.bq3_1 = element;
    this.cq3_1 = properties;
  }
  protoOf(Clause).toString = function () {
    return 'Clause(element=' + toString_0(this.bq3_1) + ', properties=' + toString_1(this.cq3_1) + ')';
  };
  protoOf(Clause).hashCode = function () {
    var result = this.bq3_1 == null ? 0 : hashCode(this.bq3_1);
    result = imul(result, 31) + hashCode(this.cq3_1) | 0;
    return result;
  };
  protoOf(Clause).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Clause))
      return false;
    if (!equals(this.bq3_1, other.bq3_1))
      return false;
    if (!equals(this.cq3_1, other.cq3_1))
      return false;
    return true;
  };
  function Union(operands) {
    this.wq2_1 = operands;
  }
  protoOf(Union).toString = function () {
    return 'Union(operands=' + toString_1(this.wq2_1) + ')';
  };
  protoOf(Union).hashCode = function () {
    return hashCode(this.wq2_1);
  };
  protoOf(Union).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Union))
      return false;
    if (!equals(this.wq2_1, other.wq2_1))
      return false;
    return true;
  };
  function Companion_369() {
    Companion_instance_369 = this;
    this.zq2_1 = new Clause();
    this.aq3_1 = new Union(emptySet());
  }
  var Companion_instance_369;
  function Companion_getInstance_369() {
    if (Companion_instance_369 == null)
      new Companion_369();
    return Companion_instance_369;
  }
  function NormalizedValueOperands(firstBase, secondBase, firstConstraints, secondConstraints) {
    this.lq3_1 = firstBase;
    this.mq3_1 = secondBase;
    this.nq3_1 = firstConstraints;
    this.oq3_1 = secondConstraints;
  }
  protoOf(NormalizedValueOperands).toString = function () {
    return 'NormalizedValueOperands(firstBase=' + toString_1(this.lq3_1) + ', secondBase=' + toString_1(this.mq3_1) + ', firstConstraints=' + toString_1(this.nq3_1) + ', secondConstraints=' + toString_1(this.oq3_1) + ')';
  };
  protoOf(NormalizedValueOperands).hashCode = function () {
    var result = hashCode(this.lq3_1);
    result = imul(result, 31) + hashCode(this.mq3_1) | 0;
    result = imul(result, 31) + hashCode(this.nq3_1) | 0;
    result = imul(result, 31) + hashCode(this.oq3_1) | 0;
    return result;
  };
  protoOf(NormalizedValueOperands).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof NormalizedValueOperands))
      return false;
    if (!equals(this.lq3_1, other.lq3_1))
      return false;
    if (!equals(this.mq3_1, other.mq3_1))
      return false;
    if (!equals(this.nq3_1, other.nq3_1))
      return false;
    if (!equals(this.oq3_1, other.oq3_1))
      return false;
    return true;
  };
  function normalizeValueOperands(first, second) {
    var firstConstrained = normalizeValueOperands$wrapInConstrainedValue(first);
    var secondConstrained = normalizeValueOperands$wrapInConstrainedValue(second);
    var tmp;
    var tmp_0;
    var tmp_1 = firstConstrained.rpg_1;
    if (tmp_1 instanceof SetValue) {
      var tmp_2 = secondConstrained.rpg_1;
      tmp_0 = !(tmp_2 instanceof SetValue);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = new NormalizedValueOperands(firstConstrained.rpg_1, normalizeValueOperands$wrapInOpenSet(secondConstrained), firstConstrained.spg_1, emptyList());
    } else {
      var tmp_3;
      var tmp_4 = firstConstrained.rpg_1;
      if (!(tmp_4 instanceof SetValue)) {
        var tmp_5 = secondConstrained.rpg_1;
        tmp_3 = tmp_5 instanceof SetValue;
      } else {
        tmp_3 = false;
      }
      if (tmp_3) {
        tmp = new NormalizedValueOperands(normalizeValueOperands$wrapInOpenSet(firstConstrained), secondConstrained.rpg_1, emptyList(), secondConstrained.spg_1);
      } else {
        tmp = new NormalizedValueOperands(firstConstrained.rpg_1, secondConstrained.rpg_1, firstConstrained.spg_1, secondConstrained.spg_1);
      }
    }
    return tmp;
  }
  function normalizeValueOperands$wrapInConstrainedValue(value) {
    var tmp;
    if (value instanceof ConstrainedValue) {
      tmp = value;
    } else {
      if (isInterface(value, Constrainable)) {
        tmp = new ConstrainedValue(value, emptyList());
      } else {
        if (value instanceof RelationFactExpressionDescriptor) {
          tmp = new ConstrainedValue(None_instance_0, emptyList());
        } else {
          noWhenBranchMatchedException();
        }
      }
    }
    return tmp;
  }
  function normalizeValueOperands$wrapInOpenSet(value) {
    return new SetValue(mapOf(to(value, new Known(1))), SetType_OPEN_getInstance());
  }
  function OntologyHierarchyImpl$Companion$defaultCycleStrategy$lambda(path) {
    Companion_getInstance_370().pq3_1.tde('There is a cycle in ontology: ' + toString_1(path));
    return Unit_instance;
  }
  function $runSuspendCOROUTINE$_108(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.yq3_1 = _this__u8e3s4;
    this.zq3_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_108).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            var $this$suspendingQuery = this.zq3_1;
            this.f9_1 = 1;
            suspendResult = isNatural(this.yq3_1.aq4_1, $this$suspendingQuery, this.yq3_1.bq4_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function $runSuspendCOROUTINE$_109(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.kq4_1 = _this__u8e3s4;
    this.lq4_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_109).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            var $this$suspendingQuery = this.lq4_1;
            this.f9_1 = 1;
            suspendResult = getAssertedDefinitionElements(this.kq4_1.mq4_1, $this$suspendingQuery, this.kq4_1.nq4_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function $runSuspendCOROUTINE$_110(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.wq4_1 = _this__u8e3s4;
    this.xq4_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_110).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            var $this$suspendingQuery = this.xq4_1;
            this.f9_1 = 1;
            suspendResult = getAllNaturalDefinitions(this.wq4_1.yq4_1, $this$suspendingQuery, this.wq4_1.zq4_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function $runSuspendCOROUTINE$_111(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.iq5_1 = _this__u8e3s4;
    this.jq5_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_111).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            var $this$suspendingQuery = this.jq5_1;
            this.f9_1 = 1;
            suspendResult = this.iq5_1.kq5_1.sq5($this$suspendingQuery, this.iq5_1.lq5_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function isNatural($this, queryBuilder, element, $completion) {
    var tmp = new $isNaturalCOROUTINE$($this, queryBuilder, element, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  }
  function getAssertedDefinitionElements($this, _this__u8e3s4, classDeclaration, $completion) {
    var tmp = new $getAssertedDefinitionElementsCOROUTINE$($this, _this__u8e3s4, classDeclaration, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  }
  function collectExternalElements($this, _this__u8e3s4, classDeclaration, $completion) {
    var tmp = new $collectExternalElementsCOROUTINE$($this, _this__u8e3s4, classDeclaration, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  }
  function calculateElementsToAllNaturalDefinitions($this, _this__u8e3s4, classDeclaration, $completion) {
    var tmp = new $calculateElementsToAllNaturalDefinitionsCOROUTINE$($this, _this__u8e3s4, classDeclaration, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  }
  function getAllNaturalDefinitions($this, _this__u8e3s4, classDeclaration, $completion) {
    var tmp = new $getAllNaturalDefinitionsCOROUTINE$($this, _this__u8e3s4, classDeclaration, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  }
  function getAssertedSuperElements($this, _this__u8e3s4, ontologyElement, $completion) {
    var tmp = new $getAssertedSuperElementsCOROUTINE$($this, _this__u8e3s4, ontologyElement, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  }
  function calculateElementToAllSuperElements($this, _this__u8e3s4, element, $completion) {
    var tmp = new $calculateElementToAllSuperElementsCOROUTINE$($this, _this__u8e3s4, element, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  }
  function Companion_370() {
    Companion_instance_370 = this;
    this.pq3_1 = getLogger_0(getKClass(OntologyHierarchyImpl));
  }
  protoOf(Companion_370).tqa = function () {
    return OntologyHierarchyImpl$Companion$defaultCycleStrategy$lambda;
  };
  var Companion_instance_370;
  function Companion_getInstance_370() {
    if (Companion_instance_370 == null)
      new Companion_370();
    return Companion_instance_370;
  }
  function OntologyHierarchyImpl$isNatural$$inlined$suspendingQuery$1(this$0, $element) {
    this.aq4_1 = this$0;
    this.bq4_1 = $element;
  }
  protoOf(OntologyHierarchyImpl$isNatural$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_108(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(OntologyHierarchyImpl$isNatural$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function OntologyHierarchyImpl$getAssertedDefinitionElements$$inlined$suspendingQuery$1(this$0, $classDeclaration) {
    this.mq4_1 = this$0;
    this.nq4_1 = $classDeclaration;
  }
  protoOf(OntologyHierarchyImpl$getAssertedDefinitionElements$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_109(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(OntologyHierarchyImpl$getAssertedDefinitionElements$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function OntologyHierarchyImpl$getAllNaturalDefinitionElements$$inlined$suspendingQuery$1(this$0, $classDeclaration) {
    this.yq4_1 = this$0;
    this.zq4_1 = $classDeclaration;
  }
  protoOf(OntologyHierarchyImpl$getAllNaturalDefinitionElements$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_110(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(OntologyHierarchyImpl$getAllNaturalDefinitionElements$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function OntologyHierarchyImpl$getAllSuperElements$$inlined$suspendingQuery$1(this$0, $element) {
    this.kq5_1 = this$0;
    this.lq5_1 = $element;
  }
  protoOf(OntologyHierarchyImpl$getAllSuperElements$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_111(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(OntologyHierarchyImpl$getAllSuperElements$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function OntologyHierarchyImpl$collectExternalElements$lambda(this$0) {
    return function ($this$traverseDepthFirst) {
      // Inline function 'kotlin.collections.filterIsInstance' call
      var tmp0 = plus_6($this$traverseDepthFirst.cm6(), $this$traverseDepthFirst.w85());
      // Inline function 'kotlin.collections.filterIsInstanceTo' call
      var destination = ArrayList_init_$Create$();
      var _iterator__ex2g4s = tmp0.m();
      while (_iterator__ex2g4s.n()) {
        var element = _iterator__ex2g4s.o();
        if (!(element == null) ? isInterface(element, AbstractOntologyElement) : false) {
          destination.j(element);
        }
      }
      this$0.mq5_1(destination);
      return Unit_instance;
    };
  }
  function OntologyHierarchyImpl$collectExternalElements$lambda_0(it) {
    return !(it == null) ? isInterface(it, AbstractOntologyElement) : false;
  }
  function OntologyHierarchyImpl$calculateElementsToAllNaturalDefinitions$lambda($isValid, this$0) {
    return function ($this$traverseDepthFirst) {
      $isValid._v = false;
      // Inline function 'kotlin.collections.filterIsInstance' call
      var tmp0 = plus_6($this$traverseDepthFirst.cm6(), $this$traverseDepthFirst.w85());
      // Inline function 'kotlin.collections.filterIsInstanceTo' call
      var destination = ArrayList_init_$Create$();
      var _iterator__ex2g4s = tmp0.m();
      while (_iterator__ex2g4s.n()) {
        var element = _iterator__ex2g4s.o();
        if (!(element == null) ? isInterface(element, AbstractOntologyElement) : false) {
          destination.j(element);
        }
      }
      this$0.mq5_1(destination);
      return Unit_instance;
    };
  }
  function OntologyHierarchyImpl$calculateElementToAllSuperElements$lambda($isValid, this$0) {
    return function ($this$traverseDepthFirst) {
      $isValid._v = false;
      this$0.mq5_1(plus_6($this$traverseDepthFirst.cm6(), $this$traverseDepthFirst.w85()));
      return Unit_instance;
    };
  }
  function $getAllSuperElementsCOROUTINE$(_this__u8e3s4, queryBuilder, element, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.cqb_1 = _this__u8e3s4;
    this.dqb_1 = queryBuilder;
    this.eqb_1 = element;
  }
  protoOf($getAllSuperElementsCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 4;
            var tmp0 = this.cqb_1.qq5_1;
            var key = this.eqb_1;
            var tmp0_elvis_lhs = tmp0.q2(key);
            if (tmp0_elvis_lhs == null) {
              this.gqb_1 = this.dqb_1;
              this.f9_1 = 1;
              suspendResult = isNatural(this.cqb_1, this.dqb_1, this.eqb_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.fqb_1 = tmp0_elvis_lhs;
              this.f9_1 = 3;
              continue $sm;
            }

          case 1:
            if (!suspendResult) {
              var message = toString_1(this.eqb_1) + ' is supposed to be natural, but has definition';
              throw IllegalArgumentException_init_$Create$_0(toString_1(message));
            }

            this.f9_1 = 2;
            suspendResult = calculateElementToAllSuperElements(this.cqb_1, this.gqb_1, this.eqb_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var _destruct__k2r9zo = suspendResult;
            var elementToAllSuperElements = _destruct__k2r9zo.fg();
            var isValid = _destruct__k2r9zo.gg();
            if (isValid) {
              this.cqb_1.qq5_1.v2(elementToAllSuperElements);
            }

            this.fqb_1 = getValue_0(elementToAllSuperElements, this.eqb_1);
            this.f9_1 = 3;
            continue $sm;
          case 3:
            return this.fqb_1;
          case 4:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 4) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function $isNaturalCOROUTINE$(_this__u8e3s4, queryBuilder, element, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.bq6_1 = _this__u8e3s4;
    this.cq6_1 = queryBuilder;
    this.dq6_1 = element;
  }
  protoOf($isNaturalCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            var tmp0_subject = this.dq6_1;
            if (isInterface(tmp0_subject, AbstractElementDefinition)) {
              this.eq6_1 = false;
              this.f9_1 = 3;
              continue $sm;
            } else {
              if (isInterface(tmp0_subject, AbstractNotionDescriptor)) {
                this.eq6_1 = false;
                this.f9_1 = 3;
                continue $sm;
              } else {
                if (isInterface(tmp0_subject, AbstractOntologyElement)) {
                  var $this$with = this.cq6_1;
                  this.f9_1 = 1;
                  suspendResult = $this$with.k60(this.dq6_1.wfs(), this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  continue $sm;
                } else {
                  var tmp_0 = this;
                  noWhenBranchMatchedException();
                }
              }
            }

            break;
          case 1:
            this.eq6_1 = suspendResult == null;
            this.f9_1 = 3;
            continue $sm;
          case 2:
            throw this.i9_1;
          case 3:
            return this.eq6_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function $getAssertedDefinitionElementsCOROUTINE$(_this__u8e3s4, _this__u8e3s4_0, classDeclaration, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.nq6_1 = _this__u8e3s4;
    this.oq6_1 = _this__u8e3s4_0;
    this.pq6_1 = classDeclaration;
  }
  protoOf($getAssertedDefinitionElementsCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 8;
            var tmp0 = this.nq6_1.nq5_1;
            var tmp2 = this.pq6_1;
            this.sq6_1 = tmp0;
            this.rq6_1 = tmp2;
            var value = this.sq6_1.q2(this.rq6_1);
            if (value == null) {
              this.tq6_1 = Unit_instance;
              this.f9_1 = 1;
              continue $sm;
            } else {
              var tmp_0 = this;
              tmp_0.qq6_1 = value;
              this.f9_1 = 7;
              continue $sm;
            }

          case 1:
            var tmp0_subject = this.pq6_1;
            if (isInterface(tmp0_subject, AbstractOntologyElement)) {
              this.f9_1 = 2;
              suspendResult = this.oq6_1.k60(this.pq6_1.wfs(), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              if (isInterface(tmp0_subject, AbstractNotionDescriptor)) {
                this.vq6_1 = null;
                this.f9_1 = 3;
                continue $sm;
              } else {
                if (isInterface(tmp0_subject, AbstractElementDefinition)) {
                  this.vq6_1 = this.pq6_1;
                  this.f9_1 = 3;
                  continue $sm;
                } else {
                  var tmp_1 = this;
                  noWhenBranchMatchedException();
                }
              }
            }

            break;
          case 2:
            this.vq6_1 = suspendResult;
            this.f9_1 = 3;
            continue $sm;
          case 3:
            var tmp1_elvis_lhs = this.vq6_1;
            if (tmp1_elvis_lhs == null) {
              this.tq6_1 = emptySet();
              this.f9_1 = 6;
              var tmp_2 = this;
              continue $sm;
            } else {
              this.uq6_1 = tmp1_elvis_lhs;
              this.f9_1 = 4;
              continue $sm;
            }

          case 4:
            var union = this.uq6_1;
            this.f9_1 = 5;
            suspendResult = collectExternalElements(this.nq6_1, this.oq6_1, union, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 5:
            this.tq6_1 = suspendResult;
            if (false) {
              this.f9_1 = 1;
              continue $sm;
            }

            this.f9_1 = 6;
            continue $sm;
          case 6:
            var answer = this.tq6_1;
            this.sq6_1.t2(this.rq6_1, answer);
            this.qq6_1 = answer;
            this.f9_1 = 7;
            continue $sm;
          case 7:
            return this.qq6_1;
          case 8:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 8) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function $collectExternalElementsCOROUTINE$(_this__u8e3s4, _this__u8e3s4_0, classDeclaration, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.eq7_1 = _this__u8e3s4;
    this.fq7_1 = _this__u8e3s4_0;
    this.gq7_1 = classDeclaration;
  }
  protoOf($collectExternalElementsCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 11;
            var tmp_0 = this;
            tmp_0.rq7_1 = this.gq7_1;
            var tmp_1 = this;
            tmp_1.qq7_1 = OntologyHierarchyImpl$collectExternalElements$lambda(this.eq7_1);
            this.f9_1 = 1;
            continue $sm;
          case 1:
            var this_0 = this.rq7_1;
            this.pq7_1 = this.qq7_1;
            this.kq7_1 = new PreProcessNodeFrame(this_0, null);
            this.iq7_1 = HashSet_init_$Create$();
            this.f9_1 = 2;
            continue $sm;
          case 2:
            if (!!(this.kq7_1 == null)) {
              this.f9_1 = 9;
              continue $sm;
            }

            this.jq7_1 = new TraversalContext(this.kq7_1);
            var tmp0_subject = this.kq7_1;
            if (tmp0_subject instanceof PreProcessNodeFrame) {
              if (this.iq7_1.t(this.jq7_1.w85())) {
                var tmp_2 = this;
                if (!isNoop(this.pq7_1) && this.jq7_1.mlr(this.jq7_1.w85())) {
                  this.pq7_1(this.jq7_1);
                }
                tmp_2.mq7_1 = this.kq7_1.hlr_1;
                this.f9_1 = 6;
                continue $sm;
              } else {
                this.jq7_1;
                var tmp0 = this.iq7_1;
                var element = this.jq7_1.w85();
                tmp0.j(element);
                var it = this.jq7_1.w85();
                if (isInterface(it, AbstractOntologyElement)) {
                  this.oq7_1 = emptyList();
                  this.f9_1 = 4;
                  continue $sm;
                } else {
                  if (isInterface(it, AbstractNotionDescriptor)) {
                    this.oq7_1 = emptyList();
                    this.f9_1 = 4;
                    continue $sm;
                  } else {
                    if (isInterface(it, AbstractElementDefinition)) {
                      this.f9_1 = 3;
                      suspendResult = this.fq7_1.k60(it.mfu(), this);
                      if (suspendResult === get_COROUTINE_SUSPENDED()) {
                        return suspendResult;
                      }
                      continue $sm;
                    } else {
                      var tmp_3 = this;
                      noWhenBranchMatchedException();
                    }
                  }
                }
              }
            } else {
              if (tmp0_subject instanceof PostProcessChildNodeFrame) {
                this.lq7_1 = createNextChildProcessingFrame(this.kq7_1);
                this.f9_1 = 7;
                continue $sm;
              } else {
                if (tmp0_subject instanceof PostProcessNodeFrame) {
                  var tmp_4 = this;
                  this.jq7_1;
                  tmp_4.lq7_1 = this.kq7_1.hlr_1;
                  this.f9_1 = 7;
                  continue $sm;
                } else {
                  var tmp_5 = this;
                  noWhenBranchMatchedException();
                }
              }
            }

            break;
          case 3:
            var tmp_6 = this;
            var this_1 = suspendResult;
            var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_1, 10));
            var _iterator__ex2g4s = this_1.m();
            while (_iterator__ex2g4s.n()) {
              var item = _iterator__ex2g4s.o();
              destination.j(to(item, Unit_instance));
            }

            tmp_6.oq7_1 = destination;
            this.f9_1 = 4;
            continue $sm;
          case 4:
            this.nq7_1 = this.oq7_1;
            this.f9_1 = 5;
            continue $sm;
          case 5:
            var edges = this.nq7_1;
            this.mq7_1 = createChildProcessingFrame(this.kq7_1, edges.m());
            this.f9_1 = 6;
            continue $sm;
          case 6:
            this.lq7_1 = this.mq7_1;
            this.f9_1 = 7;
            continue $sm;
          case 7:
            this.kq7_1 = this.lq7_1;
            if (this.jq7_1.nlr()) {
              this.hq7_1 = null;
              this.f9_1 = 10;
              continue $sm;
            } else {
              this.f9_1 = 8;
              continue $sm;
            }

          case 8:
            this.f9_1 = 2;
            continue $sm;
          case 9:
            this.hq7_1 = this.iq7_1;
            if (false) {
              this.f9_1 = 1;
              continue $sm;
            }

            this.f9_1 = 10;
            continue $sm;
          case 10:
            var tmp0_elvis_lhs = this.hq7_1;
            var ARGUMENT = tmp0_elvis_lhs == null ? emptySet() : tmp0_elvis_lhs;
            var this_2 = asSequence_0(ARGUMENT);
            var tmp_7 = filter(this_2, OntologyHierarchyImpl$collectExternalElements$lambda_0);
            var ARGUMENT_0 = isInterface(tmp_7, Sequence) ? tmp_7 : THROW_CCE();
            return toSet_1(ARGUMENT_0);
          case 11:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 11) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function $calculateElementsToAllNaturalDefinitionsCOROUTINE$(_this__u8e3s4, _this__u8e3s4_0, classDeclaration, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.aq8_1 = _this__u8e3s4;
    this.bq8_1 = _this__u8e3s4_0;
    this.cq8_1 = classDeclaration;
  }
  protoOf($calculateElementsToAllNaturalDefinitionsCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 13;
            this.eq8_1 = HashMap_init_$Create$();
            this.dq8_1 = {_v: true};
            var tmp_0 = this;
            tmp_0.rq8_1 = this.cq8_1;
            var tmp_1 = this;
            tmp_1.qq8_1 = OntologyHierarchyImpl$calculateElementsToAllNaturalDefinitions$lambda(this.dq8_1, this.aq8_1);
            this.f9_1 = 1;
            continue $sm;
          case 1:
            var this_0 = this.rq8_1;
            this.pq8_1 = this.qq8_1;
            this.iq8_1 = new PreProcessNodeFrame(this_0, null);
            this.gq8_1 = HashSet_init_$Create$();
            this.f9_1 = 2;
            continue $sm;
          case 2:
            if (!!(this.iq8_1 == null)) {
              this.f9_1 = 11;
              continue $sm;
            }

            this.hq8_1 = new TraversalContext(this.iq8_1);
            var tmp0_subject = this.iq8_1;
            if (tmp0_subject instanceof PreProcessNodeFrame) {
              if (this.gq8_1.t(this.hq8_1.w85())) {
                var tmp_2 = this;
                if (!isNoop(this.pq8_1) && this.hq8_1.mlr(this.hq8_1.w85())) {
                  this.pq8_1(this.hq8_1);
                }
                tmp_2.kq8_1 = this.iq8_1.hlr_1;
                this.f9_1 = 8;
                continue $sm;
              } else {
                var $this$traverseDepthFirst = this.hq8_1;
                var tmp_3;
                var tmp0 = this.aq8_1.oq5_1;
                var key = $this$traverseDepthFirst.w85();
                if ((isInterface(tmp0, KtMap) ? tmp0 : THROW_CCE()).o2(key)) {
                  tmp_3 = true;
                } else {
                  var tmp0_0 = this.eq8_1;
                  var key_0 = $this$traverseDepthFirst.w85();
                  tmp_3 = (isInterface(tmp0_0, KtMap) ? tmp0_0 : THROW_CCE()).o2(key_0);
                }
                if (!tmp_3) {
                  var tmp0_1 = this.gq8_1;
                  var element = this.hq8_1.w85();
                  tmp0_1.j(element);
                  var it = this.hq8_1.w85();
                  this.f9_1 = 6;
                  suspendResult = getAssertedDefinitionElements(this.aq8_1, this.bq8_1, it, this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  continue $sm;
                } else {
                  var tmp_4 = this;
                  tmp_4.lq8_1 = emptyList();
                  this.f9_1 = 7;
                  continue $sm;
                }
              }
            } else {
              if (tmp0_subject instanceof PostProcessChildNodeFrame) {
                this.jq8_1 = createNextChildProcessingFrame(this.iq8_1);
                this.f9_1 = 9;
                continue $sm;
              } else {
                if (tmp0_subject instanceof PostProcessNodeFrame) {
                  this.nq8_1 = this.hq8_1.w85();
                  var tmp_5;
                  var tmp0_2 = this.aq8_1.oq5_1;
                  var key_1 = this.nq8_1;
                  if ((isInterface(tmp0_2, KtMap) ? tmp0_2 : THROW_CCE()).o2(key_1)) {
                    tmp_5 = true;
                  } else {
                    var tmp0_3 = this.eq8_1;
                    var key_2 = this.nq8_1;
                    tmp_5 = (isInterface(tmp0_3, KtMap) ? tmp0_3 : THROW_CCE()).o2(key_2);
                  }
                  if (!tmp_5) {
                    this.mq8_1 = HashSet_init_$Create$();
                    this.f9_1 = 3;
                    suspendResult = isNatural(this.aq8_1, this.bq8_1, this.nq8_1, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) {
                      return suspendResult;
                    }
                    continue $sm;
                  } else {
                    this.f9_1 = 5;
                    continue $sm;
                  }
                } else {
                  var tmp_6 = this;
                  noWhenBranchMatchedException();
                }
              }
            }

            break;
          case 3:
            if (suspendResult) {
              var tmp_7 = this;
              var tmp_8 = this.nq8_1;
              if (!isInterface(tmp_8, AbstractOntologyElement)) {
                throw IllegalStateException_init_$Create$_0('Check failed.');
              }
              var tmp_9 = this.nq8_1;
              tmp_7.oq8_1 = this.mq8_1.j(isInterface(tmp_9, AbstractOntologyElement) ? tmp_9 : THROW_CCE());
              this.f9_1 = 4;
              continue $sm;
            } else {
              var tmp_10 = this;
              var assertedDefinitions = getValue_0(this.aq8_1.nq5_1, this.nq8_1);
              var destination = this.mq8_1;
              var _iterator__ex2g4s = assertedDefinitions.m();
              while (_iterator__ex2g4s.n()) {
                var element_0 = _iterator__ex2g4s.o();
                var tmp0_elvis_lhs = this.aq8_1.oq5_1.q2(element_0);
                var tmp_11 = tmp0_elvis_lhs == null ? emptySet() : tmp0_elvis_lhs;
                var tmp0_elvis_lhs_0 = this.eq8_1.q2(element_0);
                var list = plus_10(tmp_11, tmp0_elvis_lhs_0 == null ? emptySet() : tmp0_elvis_lhs_0);
                addAll_1(destination, list);
              }
              tmp_10.oq8_1 = destination;
              this.f9_1 = 4;
              continue $sm;
            }

          case 4:
            var tmp0_4 = this.eq8_1;
            var tmp2 = this.nq8_1;
            var value = this.mq8_1;
            tmp0_4.t2(tmp2, value);
            this.f9_1 = 5;
            continue $sm;
          case 5:
            this.jq8_1 = this.iq8_1.hlr_1;
            this.f9_1 = 9;
            continue $sm;
          case 6:
            var tmp_12 = this;
            var this_1 = suspendResult;
            var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_1, 10));
            var _iterator__ex2g4s_0 = this_1.m();
            while (_iterator__ex2g4s_0.n()) {
              var item = _iterator__ex2g4s_0.o();
              destination_0.j(to(item, Unit_instance));
            }

            tmp_12.lq8_1 = destination_0;
            this.f9_1 = 7;
            continue $sm;
          case 7:
            var edges = this.lq8_1;
            this.kq8_1 = createChildProcessingFrame(this.iq8_1, edges.m());
            this.f9_1 = 8;
            continue $sm;
          case 8:
            this.jq8_1 = this.kq8_1;
            this.f9_1 = 9;
            continue $sm;
          case 9:
            this.iq8_1 = this.jq8_1;
            if (this.hq8_1.nlr()) {
              this.fq8_1 = null;
              this.f9_1 = 12;
              continue $sm;
            } else {
              this.f9_1 = 10;
              continue $sm;
            }

          case 10:
            this.f9_1 = 2;
            continue $sm;
          case 11:
            this.fq8_1 = this.gq8_1;
            if (false) {
              this.f9_1 = 1;
              continue $sm;
            }

            this.f9_1 = 12;
            continue $sm;
          case 12:
            return to(this.eq8_1, this.dq8_1._v);
          case 13:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 13) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function $getAllNaturalDefinitionsCOROUTINE$(_this__u8e3s4, _this__u8e3s4_0, classDeclaration, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.aq9_1 = _this__u8e3s4;
    this.bq9_1 = _this__u8e3s4_0;
    this.cq9_1 = classDeclaration;
  }
  protoOf($getAllNaturalDefinitionsCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            var result = this.aq9_1.oq5_1.q2(this.cq9_1);
            if (!(result == null)) {
              return result;
            }

            this.f9_1 = 1;
            suspendResult = calculateElementsToAllNaturalDefinitions(this.aq9_1, this.bq9_1, this.cq9_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var _destruct__k2r9zo = suspendResult;
            var elementToAllNaturalDefinitions = _destruct__k2r9zo.fg();
            var isValid = _destruct__k2r9zo.gg();
            result = getValue_0(elementToAllNaturalDefinitions, this.cq9_1);
            if (isValid) {
              this.aq9_1.oq5_1.v2(elementToAllNaturalDefinitions);
            }

            return result;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function $getAssertedSuperElementsCOROUTINE$(_this__u8e3s4, _this__u8e3s4_0, ontologyElement, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.lq9_1 = _this__u8e3s4;
    this.mq9_1 = _this__u8e3s4_0;
    this.nq9_1 = ontologyElement;
  }
  protoOf($getAssertedSuperElementsCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 11;
            var tmp0 = this.lq9_1.pq5_1;
            var tmp2 = this.nq9_1;
            this.qq9_1 = tmp0;
            this.pq9_1 = tmp2;
            var value = this.qq9_1.q2(this.pq9_1);
            if (value == null) {
              this.f9_1 = 1;
              suspendResult = isNatural(this.lq9_1, this.mq9_1, this.nq9_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              var tmp_0 = this;
              tmp_0.oq9_1 = value;
              this.f9_1 = 10;
              continue $sm;
            }

          case 1:
            if (!suspendResult) {
              var message = toString_1(this.nq9_1) + ' is supposed to be natural, but has definition';
              throw IllegalArgumentException_init_$Create$_0(toString_1(message));
            }

            this.f9_1 = 2;
            suspendResult = this.mq9_1.k60(this.nq9_1.nfs(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var tmp0_0 = suspendResult;
            this.uq9_1 = ArrayList_init_$Create$();
            this.vq9_1 = tmp0_0.m();
            this.f9_1 = 3;
            continue $sm;
          case 3:
            if (!this.vq9_1.n()) {
              this.f9_1 = 5;
              continue $sm;
            }

            var element = this.vq9_1.o();
            this.f9_1 = 4;
            suspendResult = element.bpg(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            var tmp0_safe_receiver = suspendResult;
            if (tmp0_safe_receiver == null)
              null;
            else {
              this.uq9_1.j(tmp0_safe_receiver);
            }

            this.f9_1 = 3;
            continue $sm;
          case 5:
            var tmp0_1 = this.uq9_1;
            this.rq9_1 = ArrayList_init_$Create$();
            this.tq9_1 = tmp0_1.m();
            this.f9_1 = 6;
            continue $sm;
          case 6:
            if (!this.tq9_1.n()) {
              this.f9_1 = 9;
              continue $sm;
            }

            this.sq9_1 = this.tq9_1.o();
            var it = this.sq9_1;
            this.f9_1 = 7;
            suspendResult = isNatural(this.lq9_1, this.mq9_1, it, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 7:
            if (suspendResult) {
              this.rq9_1.j(this.sq9_1);
              this.f9_1 = 8;
              continue $sm;
            } else {
              this.f9_1 = 8;
              continue $sm;
            }

          case 8:
            this.f9_1 = 6;
            continue $sm;
          case 9:
            var ARGUMENT = this.rq9_1;
            var answer = toSet_0(ARGUMENT);
            this.qq9_1.t2(this.pq9_1, answer);
            this.oq9_1 = answer;
            this.f9_1 = 10;
            continue $sm;
          case 10:
            return this.oq9_1;
          case 11:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 11) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function $calculateElementToAllSuperElementsCOROUTINE$(_this__u8e3s4, _this__u8e3s4_0, element, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.eqa_1 = _this__u8e3s4;
    this.fqa_1 = _this__u8e3s4_0;
    this.gqa_1 = element;
  }
  protoOf($calculateElementToAllSuperElementsCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 10;
            this.iqa_1 = HashMap_init_$Create$();
            this.hqa_1 = {_v: true};
            var tmp_0 = this;
            tmp_0.sqa_1 = this.gqa_1;
            var tmp_1 = this;
            tmp_1.rqa_1 = OntologyHierarchyImpl$calculateElementToAllSuperElements$lambda(this.hqa_1, this.eqa_1);
            this.f9_1 = 1;
            continue $sm;
          case 1:
            var this_0 = this.sqa_1;
            this.qqa_1 = this.rqa_1;
            this.mqa_1 = new PreProcessNodeFrame(this_0, null);
            this.kqa_1 = HashSet_init_$Create$();
            this.f9_1 = 2;
            continue $sm;
          case 2:
            if (!!(this.mqa_1 == null)) {
              this.f9_1 = 8;
              continue $sm;
            }

            this.lqa_1 = new TraversalContext(this.mqa_1);
            var tmp0_subject = this.mqa_1;
            if (tmp0_subject instanceof PreProcessNodeFrame) {
              if (this.kqa_1.t(this.lqa_1.w85())) {
                var tmp_2 = this;
                if (!isNoop(this.qqa_1) && this.lqa_1.mlr(this.lqa_1.w85())) {
                  this.qqa_1(this.lqa_1);
                }
                tmp_2.oqa_1 = this.mqa_1.hlr_1;
                this.f9_1 = 5;
                continue $sm;
              } else {
                var $this$traverseDepthFirst = this.lqa_1;
                var tmp_3;
                var tmp0 = this.eqa_1.qq5_1;
                var key = $this$traverseDepthFirst.w85();
                if ((isInterface(tmp0, KtMap) ? tmp0 : THROW_CCE()).o2(key)) {
                  tmp_3 = true;
                } else {
                  var tmp0_0 = this.iqa_1;
                  var key_0 = $this$traverseDepthFirst.w85();
                  tmp_3 = (isInterface(tmp0_0, KtMap) ? tmp0_0 : THROW_CCE()).o2(key_0);
                }
                if (!tmp_3) {
                  var tmp0_1 = this.kqa_1;
                  var element = this.lqa_1.w85();
                  tmp0_1.j(element);
                  var it = this.lqa_1.w85();
                  this.f9_1 = 3;
                  suspendResult = getAssertedSuperElements(this.eqa_1, this.fqa_1, it, this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  continue $sm;
                } else {
                  var tmp_4 = this;
                  tmp_4.pqa_1 = emptyList();
                  this.f9_1 = 4;
                  continue $sm;
                }
              }
            } else {
              if (tmp0_subject instanceof PostProcessChildNodeFrame) {
                this.nqa_1 = createNextChildProcessingFrame(this.mqa_1);
                this.f9_1 = 6;
                continue $sm;
              } else {
                if (tmp0_subject instanceof PostProcessNodeFrame) {
                  var tmp_5 = this;
                  var currentNode = this.lqa_1.w85();
                  var tmp_6;
                  var this_1 = this.eqa_1.qq5_1;
                  if ((isInterface(this_1, KtMap) ? this_1 : THROW_CCE()).o2(currentNode)) {
                    tmp_6 = true;
                  } else {
                    var this_2 = this.iqa_1;
                    tmp_6 = (isInterface(this_2, KtMap) ? this_2 : THROW_CCE()).o2(currentNode);
                  }
                  if (!tmp_6) {
                    var allSuperElements = HashSet_init_$Create$();
                    allSuperElements.j(currentNode);
                    var _iterator__ex2g4s = getValue_0(this.eqa_1.pq5_1, currentNode).m();
                    while (_iterator__ex2g4s.n()) {
                      var element_0 = _iterator__ex2g4s.o();
                      var tmp0_elvis_lhs = this.eqa_1.qq5_1.q2(element_0);
                      var tmp_7 = tmp0_elvis_lhs == null ? emptySet() : tmp0_elvis_lhs;
                      var tmp0_elvis_lhs_0 = this.iqa_1.q2(element_0);
                      var list = plus_10(tmp_7, tmp0_elvis_lhs_0 == null ? emptySet() : tmp0_elvis_lhs_0);
                      addAll_1(allSuperElements, list);
                    }
                    var tmp0_2 = this.iqa_1;
                    var value = toSet_0(allSuperElements);
                    tmp0_2.t2(currentNode, value);
                  }
                  tmp_5.nqa_1 = this.mqa_1.hlr_1;
                  this.f9_1 = 6;
                  continue $sm;
                } else {
                  var tmp_8 = this;
                  noWhenBranchMatchedException();
                }
              }
            }

            break;
          case 3:
            var tmp_9 = this;
            var this_3 = suspendResult;
            var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_3, 10));
            var _iterator__ex2g4s_0 = this_3.m();
            while (_iterator__ex2g4s_0.n()) {
              var item = _iterator__ex2g4s_0.o();
              destination.j(to(item, Unit_instance));
            }

            tmp_9.pqa_1 = destination;
            this.f9_1 = 4;
            continue $sm;
          case 4:
            var edges = this.pqa_1;
            this.oqa_1 = createChildProcessingFrame(this.mqa_1, edges.m());
            this.f9_1 = 5;
            continue $sm;
          case 5:
            this.nqa_1 = this.oqa_1;
            this.f9_1 = 6;
            continue $sm;
          case 6:
            this.mqa_1 = this.nqa_1;
            if (this.lqa_1.nlr()) {
              this.jqa_1 = null;
              this.f9_1 = 9;
              continue $sm;
            } else {
              this.f9_1 = 7;
              continue $sm;
            }

          case 7:
            this.f9_1 = 2;
            continue $sm;
          case 8:
            this.jqa_1 = this.kqa_1;
            if (false) {
              this.f9_1 = 1;
              continue $sm;
            }

            this.f9_1 = 9;
            continue $sm;
          case 9:
            return to(this.iqa_1, this.hqa_1._v);
          case 10:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 10) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function OntologyHierarchyImpl(cycleStrategy) {
    Companion_getInstance_370();
    this.mq5_1 = cycleStrategy;
    this.nq5_1 = HashMap_init_$Create$();
    this.oq5_1 = HashMap_init_$Create$();
    this.pq5_1 = HashMap_init_$Create$();
    this.qq5_1 = HashMap_init_$Create$();
    this.rq5_1 = new TypeComparer(new TypeNormalizer(), this);
  }
  protoOf(OntologyHierarchyImpl).vpc = function (one, other) {
    if (equals(one, other))
      return Companion_getInstance_81().i60_1;
    return this.rq5_1.bm5(one, other);
  };
  protoOf(OntologyHierarchyImpl).hqb = function (element) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new OntologyHierarchyImpl$isNatural$$inlined$suspendingQuery$1(this, element);
  };
  protoOf(OntologyHierarchyImpl).iqb = function (classDeclaration) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new OntologyHierarchyImpl$getAssertedDefinitionElements$$inlined$suspendingQuery$1(this, classDeclaration);
  };
  protoOf(OntologyHierarchyImpl).bm9 = function (classDeclaration) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new OntologyHierarchyImpl$getAllNaturalDefinitionElements$$inlined$suspendingQuery$1(this, classDeclaration);
  };
  protoOf(OntologyHierarchyImpl).jqb = function (element) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new OntologyHierarchyImpl$getAllSuperElements$$inlined$suspendingQuery$1(this, element);
  };
  protoOf(OntologyHierarchyImpl).sq5 = function (queryBuilder, element, $completion) {
    var tmp = new $getAllSuperElementsCOROUTINE$(this, queryBuilder, element, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  function getAllNaturalDefinitionElements(_this__u8e3s4, classDeclaration) {
    // Inline function 'jetbrains.ocelot.langDef.query.map' call
    var this_0 = _this__u8e3s4.bm9(toAdapter(classDeclaration));
    var tmp;
    if (isInterface(this_0, Query)) {
      // Inline function 'jetbrains.ocelot.langDef.query.map' call
      // Inline function 'jetbrains.ocelot.langDef.query.query' call
      tmp = new getAllNaturalDefinitionElements$$inlined$map$1(this_0);
    } else {
      // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
      tmp = new getAllNaturalDefinitionElements$$inlined$map$2(this_0);
    }
    return tmp;
  }
  function ontologyElementHierarchy() {
    return createOntologyHierarchy();
  }
  function isNatural_0(_this__u8e3s4, ontologyElement) {
    return _this__u8e3s4.hqb(toAdapter_0(ontologyElement));
  }
  function isSubtypeOf(_this__u8e3s4, one, other) {
    return _this__u8e3s4.vpc(toAdapter(one), toAdapter(other));
  }
  function isSubtypeOf_0(_this__u8e3s4, one, other) {
    return _this__u8e3s4.vpc(toAdapter_1(one), toAdapter_1(other));
  }
  function getAssertedDefinitionElements_0(_this__u8e3s4, classDeclaration) {
    // Inline function 'jetbrains.ocelot.langDef.query.map' call
    var this_0 = _this__u8e3s4.iqb(toAdapter(classDeclaration));
    var tmp;
    if (isInterface(this_0, Query)) {
      // Inline function 'jetbrains.ocelot.langDef.query.map' call
      // Inline function 'jetbrains.ocelot.langDef.query.query' call
      tmp = new getAssertedDefinitionElements$$inlined$map$1(this_0);
    } else {
      // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
      tmp = new getAssertedDefinitionElements$$inlined$map$2(this_0);
    }
    return tmp;
  }
  function createOntologyHierarchy(cycleStrategy) {
    cycleStrategy = cycleStrategy === VOID ? Companion_getInstance_370().tqa() : cycleStrategy;
    return new OntologyHierarchyImpl(cycleStrategy);
  }
  function getAllNaturalDefinitionElements$$inlined$map$1($this) {
    this.kqb_1 = $this;
  }
  protoOf(getAllNaturalDefinitionElements$$inlined$map$1).n5w = function (builder) {
    // Inline function 'kotlin.collections.map' call
    var this_0 = builder.l60(this.kqb_1);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.m();
    while (_iterator__ex2g4s.n()) {
      var item = _iterator__ex2g4s.o();
      var tmp$ret$0 = item.cma();
      destination.j(tmp$ret$0);
    }
    return toSet_0(destination);
  };
  function $runSuspendCOROUTINE$_112(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.tqb_1 = _this__u8e3s4;
    this.uqb_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_112).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            var $this$suspendingQuery = this.uqb_1;
            this.f9_1 = 1;
            suspendResult = $this$suspendingQuery.k60(this.tqb_1.vqb_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var this_0 = suspendResult;
            var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
            var _iterator__ex2g4s = this_0.m();
            while (_iterator__ex2g4s.n()) {
              var item = _iterator__ex2g4s.o();
              destination.j(item.cma());
            }

            return toSet_0(destination);
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function getAllNaturalDefinitionElements$$inlined$map$2($this) {
    this.vqb_1 = $this;
  }
  protoOf(getAllNaturalDefinitionElements$$inlined$map$2).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_112(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(getAllNaturalDefinitionElements$$inlined$map$2).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function getAssertedDefinitionElements$$inlined$map$1($this) {
    this.wqb_1 = $this;
  }
  protoOf(getAssertedDefinitionElements$$inlined$map$1).n5w = function (builder) {
    // Inline function 'kotlin.collections.map' call
    var this_0 = builder.l60(this.wqb_1);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.m();
    while (_iterator__ex2g4s.n()) {
      var item = _iterator__ex2g4s.o();
      var tmp$ret$0 = item.cma();
      destination.j(tmp$ret$0);
    }
    return toSet_0(destination);
  };
  function $runSuspendCOROUTINE$_113(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.fqc_1 = _this__u8e3s4;
    this.gqc_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_113).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            var $this$suspendingQuery = this.gqc_1;
            this.f9_1 = 1;
            suspendResult = $this$suspendingQuery.k60(this.fqc_1.hqc_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var this_0 = suspendResult;
            var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
            var _iterator__ex2g4s = this_0.m();
            while (_iterator__ex2g4s.n()) {
              var item = _iterator__ex2g4s.o();
              destination.j(item.cma());
            }

            return toSet_0(destination);
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function getAssertedDefinitionElements$$inlined$map$2($this) {
    this.hqc_1 = $this;
  }
  protoOf(getAssertedDefinitionElements$$inlined$map$2).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_113(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(getAssertedDefinitionElements$$inlined$map$2).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function get_LOG_6() {
    _init_properties_ProcessPropertyAliases_kt__wh7c62();
    return LOG_6;
  }
  var LOG_6;
  function aliasRoots(_this__u8e3s4, property, $completion) {
    var tmp = new $aliasRootsCOROUTINE$(_this__u8e3s4, property, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  }
  function aliasRoots$aliasedProperties($this_aliasRoots, property, $completion) {
    var tmp = new $aliasRoots$aliasedPropertiesCOROUTINE$($this_aliasRoots, property, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  }
  function aliasRoots$lambda($cyclic) {
    return function (_unused_var__etf5q3, _unused_var__etf5q3_0) {
      $cyclic._v = true;
      return Unit_instance;
    };
  }
  function $aliasRootsCOROUTINE$(_this__u8e3s4, property, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.qqc_1 = _this__u8e3s4;
    this.rqc_1 = property;
  }
  protoOf($aliasRootsCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 14;
            this.vqc_1 = {_v: false};
            var tmp0 = this.rqc_1;
            var cycleHandler = aliasRoots$lambda(this.vqc_1);
            var tmp_0 = this;
            tmp_0.fqd_1 = tmp0;
            var tmp_1 = this;
            tmp_1.eqd_1 = asTraverse(cycleHandler);
            this.f9_1 = 1;
            continue $sm;
          case 1:
            var this_0 = this.fqd_1;
            this.dqd_1 = this.eqd_1;
            this.zqc_1 = new PreProcessNodeFrame(this_0, null);
            this.xqc_1 = HashSet_init_$Create$();
            this.f9_1 = 2;
            continue $sm;
          case 2:
            if (!!(this.zqc_1 == null)) {
              this.f9_1 = 8;
              continue $sm;
            }

            this.yqc_1 = new TraversalContext(this.zqc_1);
            var tmp0_subject = this.zqc_1;
            if (tmp0_subject instanceof PreProcessNodeFrame) {
              if (this.xqc_1.t(this.yqc_1.w85())) {
                var tmp_2 = this;
                if (!isNoop(this.dqd_1) && this.yqc_1.mlr(this.yqc_1.w85())) {
                  this.dqd_1(this.yqc_1);
                }
                tmp_2.bqd_1 = this.zqc_1.hlr_1;
                this.f9_1 = 5;
                continue $sm;
              } else {
                this.yqc_1;
                var tmp0_0 = this.xqc_1;
                var element = this.yqc_1.w85();
                tmp0_0.j(element);
                var aliasing = this.yqc_1.w85();
                this.f9_1 = 3;
                suspendResult = aliasRoots$aliasedProperties(this.qqc_1, aliasing, this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              }
            } else {
              if (tmp0_subject instanceof PostProcessChildNodeFrame) {
                this.aqd_1 = createNextChildProcessingFrame(this.zqc_1);
                this.f9_1 = 6;
                continue $sm;
              } else {
                if (tmp0_subject instanceof PostProcessNodeFrame) {
                  var tmp_3 = this;
                  this.yqc_1;
                  tmp_3.aqd_1 = this.zqc_1.hlr_1;
                  this.f9_1 = 6;
                  continue $sm;
                } else {
                  var tmp_4 = this;
                  noWhenBranchMatchedException();
                }
              }
            }

            break;
          case 3:
            var tmp_5 = this;
            var this_1 = suspendResult;
            var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_1, 10));
            var _iterator__ex2g4s = this_1.m();
            while (_iterator__ex2g4s.n()) {
              var item = _iterator__ex2g4s.o();
              destination.j(new Pair(item, Unit_instance));
            }

            tmp_5.cqd_1 = destination;
            this.f9_1 = 4;
            continue $sm;
          case 4:
            var edges = this.cqd_1;
            this.bqd_1 = createChildProcessingFrame(this.zqc_1, edges.m());
            this.f9_1 = 5;
            continue $sm;
          case 5:
            this.aqd_1 = this.bqd_1;
            this.f9_1 = 6;
            continue $sm;
          case 6:
            this.zqc_1 = this.aqd_1;
            if (this.yqc_1.nlr()) {
              this.wqc_1 = null;
              this.f9_1 = 9;
              continue $sm;
            } else {
              this.f9_1 = 7;
              continue $sm;
            }

          case 7:
            this.f9_1 = 2;
            continue $sm;
          case 8:
            this.wqc_1 = this.xqc_1;
            if (false) {
              this.f9_1 = 1;
              continue $sm;
            }

            this.f9_1 = 9;
            continue $sm;
          case 9:
            var ARGUMENT = this.wqc_1;
            var closure = ensureNotNull(ARGUMENT);
            if (this.vqc_1._v) {
              get_LOG_6().vde('There is a cycle in the `as` chain of a ProcessProperty: ' + this.qqc_1.l60(this.rqc_1.y2()));
              return setOf(this.rqc_1);
            }

            this.sqc_1 = LinkedHashSet_init_$Create$();
            this.uqc_1 = closure.m();
            this.f9_1 = 10;
            continue $sm;
          case 10:
            if (!this.uqc_1.n()) {
              this.f9_1 = 13;
              continue $sm;
            }

            this.tqc_1 = this.uqc_1.o();
            var it = this.tqc_1;
            this.f9_1 = 11;
            suspendResult = aliasRoots$aliasedProperties(this.qqc_1, it, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 11:
            if (suspendResult.s()) {
              this.sqc_1.j(this.tqc_1);
              this.f9_1 = 12;
              continue $sm;
            } else {
              this.f9_1 = 12;
              continue $sm;
            }

          case 12:
            this.f9_1 = 10;
            continue $sm;
          case 13:
            return this.sqc_1;
          case 14:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 14) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function $aliasRoots$aliasedPropertiesCOROUTINE$($this_aliasRoots, property, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.oqd_1 = $this_aliasRoots;
    this.pqd_1 = property;
  }
  protoOf($aliasRoots$aliasedPropertiesCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 4;
            var tmp0 = this.oqd_1.l60(this.pqd_1.yft());
            this.qqd_1 = ArrayList_init_$Create$();
            this.rqd_1 = tmp0.m();
            this.f9_1 = 1;
            continue $sm;
          case 1:
            if (!this.rqd_1.n()) {
              this.f9_1 = 3;
              continue $sm;
            }

            var element = this.rqd_1.o();
            this.f9_1 = 2;
            suspendResult = this.oqd_1.k60(element.q6q(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var tmp0_safe_receiver = suspendResult;
            if (tmp0_safe_receiver == null)
              null;
            else {
              this.qqd_1.j(tmp0_safe_receiver);
            }

            this.f9_1 = 1;
            continue $sm;
          case 3:
            return this.qqd_1;
          case 4:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 4) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  var properties_initialized_ProcessPropertyAliases_kt_av522k;
  function _init_properties_ProcessPropertyAliases_kt__wh7c62() {
    if (!properties_initialized_ProcessPropertyAliases_kt_av522k) {
      properties_initialized_ProcessPropertyAliases_kt_av522k = true;
      LOG_6 = getLogger_0(getKClass(ProcessProperty_1));
    }
  }
  function expectedClass(_this__u8e3s4, cache) {
    cache = cache === VOID ? new AdapterCache() : cache;
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new expectedClass$$inlined$suspendingQuery$1(_this__u8e3s4, cache);
  }
  function expectedClassesForValue(_this__u8e3s4, cache) {
    cache = cache === VOID ? new AdapterCache() : cache;
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new expectedClassesForValue$$inlined$suspendingQuery$1(_this__u8e3s4, cache);
  }
  function expectedClass_0(_this__u8e3s4, cache) {
    cache = cache === VOID ? new AdapterCache() : cache;
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new expectedClass$$inlined$suspendingQuery$2(_this__u8e3s4, cache);
  }
  function $runSuspendCOROUTINE$_114(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.aqe_1 = _this__u8e3s4;
    this.bqe_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_114).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 8;
            var tmp_0 = this;
            tmp_0.hqe_1 = this.bqe_1;
            this.cqe_1 = Unit_instance;
            this.f9_1 = 1;
            continue $sm;
          case 1:
            this.fqe_1 = this.hqe_1;
            var tmp0_safe_receiver = this.fqe_1.l60(this.aqe_1.iqe_1.sfq());
            var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : this.fqe_1.l60(tmp0_safe_receiver.sfq());
            if (tmp1_elvis_lhs == null) {
              this.cqe_1 = null;
              this.f9_1 = 7;
              var tmp_1 = this;
              continue $sm;
            } else {
              this.gqe_1 = tmp1_elvis_lhs;
              this.f9_1 = 2;
              continue $sm;
            }

          case 2:
            var propertyType = this.gqe_1;
            if (isInterface(propertyType, OntologyElementPropertyType_1)) {
              var tmp3_safe_receiver = this.fqe_1.l60(propertyType.gfq());
              var tmp4_safe_receiver = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.gfq();
              if (tmp4_safe_receiver == null) {
                this.eqe_1 = null;
                this.f9_1 = 5;
                continue $sm;
              } else {
                this.f9_1 = 4;
                suspendResult = this.fqe_1.k60(tmp4_safe_receiver.x6o(), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              }
            } else {
              if (isInterface(propertyType, ClassExpressionType_1)) {
                var tmp_2 = this;
                var tmp6_safe_receiver = this.fqe_1.l60(propertyType.hfq());
                var tmp_3;
                if (tmp6_safe_receiver == null) {
                  tmp_3 = null;
                } else {
                  tmp_3 = toAdapter(tmp6_safe_receiver, this.aqe_1.jqe_1);
                }
                tmp_2.dqe_1 = tmp_3;
                this.f9_1 = 6;
                continue $sm;
              } else {
                if (isInterface(propertyType, SimplePropertyType)) {
                  this.f9_1 = 3;
                  suspendResult = this.fqe_1.k60(propertyType.mfq().x6o(), this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  continue $sm;
                } else {
                  if (isInterface(propertyType, PrimitivePropertyType_1)) {
                    var tmp_4 = this;
                    var tmp8_safe_receiver = this.fqe_1.l60(propertyType.oft());
                    var tmp_5;
                    if (tmp8_safe_receiver == null) {
                      tmp_5 = null;
                    } else {
                      tmp_5 = new PrimitiveNotionDescriptorAdapter(tmp8_safe_receiver);
                    }
                    tmp_4.dqe_1 = tmp_5;
                    this.f9_1 = 6;
                    continue $sm;
                  } else {
                    this.dqe_1 = null;
                    this.f9_1 = 6;
                    continue $sm;
                  }
                }
              }
            }

          case 3:
            var tmp7_safe_receiver = suspendResult;
            var tmp_6 = this;
            var tmp_7;
            if (tmp7_safe_receiver == null) {
              tmp_7 = null;
            } else {
              tmp_7 = new NotionDescriptorAdapter(tmp7_safe_receiver);
            }

            tmp_6.dqe_1 = tmp_7;
            this.f9_1 = 6;
            continue $sm;
          case 4:
            this.eqe_1 = suspendResult;
            this.f9_1 = 5;
            continue $sm;
          case 5:
            var tmp5_safe_receiver = this.eqe_1;
            this.dqe_1 = tmp5_safe_receiver == null ? null : toAdapter_0(tmp5_safe_receiver, this.aqe_1.jqe_1);
            this.f9_1 = 6;
            continue $sm;
          case 6:
            this.cqe_1 = this.dqe_1;
            if (false) {
              this.f9_1 = 1;
              continue $sm;
            }

            this.f9_1 = 7;
            continue $sm;
          case 7:
            return this.cqe_1;
          case 8:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 8) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function expectedClass$$inlined$suspendingQuery$1($this_expectedClass, $cache) {
    this.iqe_1 = $this_expectedClass;
    this.jqe_1 = $cache;
  }
  protoOf(expectedClass$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_114(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(expectedClass$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function $runSuspendCOROUTINE$_115(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.sqe_1 = _this__u8e3s4;
    this.tqe_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_115).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 5;
            this.wqe_1 = this.tqe_1;
            var tmp0_safe_receiver = this.wqe_1.l60(this.sqe_1.yqe_1.hd());
            var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : this.wqe_1.l60(tmp0_safe_receiver.cfs());
            if (tmp1_safe_receiver == null) {
              this.uqe_1 = null;
              this.f9_1 = 4;
              continue $sm;
            } else {
              this.vqe_1 = ArrayList_init_$Create$();
              this.xqe_1 = tmp1_safe_receiver.m();
              this.f9_1 = 1;
              continue $sm;
            }

          case 1:
            if (!this.xqe_1.n()) {
              this.f9_1 = 3;
              continue $sm;
            }

            var element = this.xqe_1.o();
            this.f9_1 = 2;
            suspendResult = this.wqe_1.k60(expectedClass_0(element, this.sqe_1.zqe_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var tmp0_safe_receiver_0 = suspendResult;
            if (tmp0_safe_receiver_0 == null)
              null;
            else {
              this.vqe_1.j(tmp0_safe_receiver_0);
            }

            this.f9_1 = 1;
            continue $sm;
          case 3:
            this.uqe_1 = this.vqe_1;
            this.f9_1 = 4;
            continue $sm;
          case 4:
            var tmp2_elvis_lhs = this.uqe_1;
            return tmp2_elvis_lhs == null ? emptyList() : tmp2_elvis_lhs;
          case 5:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 5) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function expectedClassesForValue$$inlined$suspendingQuery$1($this_expectedClassesForValue, $cache) {
    this.yqe_1 = $this_expectedClassesForValue;
    this.zqe_1 = $cache;
  }
  protoOf(expectedClassesForValue$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_115(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(expectedClassesForValue$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function $runSuspendCOROUTINE$_116(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.iqf_1 = _this__u8e3s4;
    this.jqf_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_116).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 5;
            var $this$suspendingQuery = this.jqf_1;
            var tmp0_subject = this.iqf_1.mqf_1;
            if (isInterface(tmp0_subject, OntologyElementType_1)) {
              var tmp1_safe_receiver = $this$suspendingQuery.l60(this.iqf_1.mqf_1.gfq());
              var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.gfq();
              if (tmp2_safe_receiver == null) {
                this.lqf_1 = null;
                this.f9_1 = 3;
                continue $sm;
              } else {
                this.f9_1 = 2;
                suspendResult = $this$suspendingQuery.k60(tmp2_safe_receiver.x6o(), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              }
            } else {
              if (isInterface(tmp0_subject, ClassExpressionType_1)) {
                var tmp_0 = this;
                var tmp4_safe_receiver = $this$suspendingQuery.l60(this.iqf_1.mqf_1.hfq());
                var tmp_1;
                if (tmp4_safe_receiver == null) {
                  tmp_1 = null;
                } else {
                  tmp_1 = toAdapter(tmp4_safe_receiver, this.iqf_1.nqf_1);
                }
                tmp_0.kqf_1 = tmp_1;
                this.f9_1 = 4;
                continue $sm;
              } else {
                if (isInterface(tmp0_subject, NotionType_0)) {
                  this.f9_1 = 1;
                  suspendResult = $this$suspendingQuery.k60(this.iqf_1.mqf_1.mfq().x6o(), this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  continue $sm;
                } else {
                  if (isInterface(tmp0_subject, PrimitiveNotionType_1)) {
                    var tmp_2 = this;
                    var tmp6_safe_receiver = $this$suspendingQuery.l60(this.iqf_1.mqf_1.oft());
                    var tmp_3;
                    if (tmp6_safe_receiver == null) {
                      tmp_3 = null;
                    } else {
                      tmp_3 = new PrimitiveNotionDescriptorAdapter(tmp6_safe_receiver);
                    }
                    tmp_2.kqf_1 = tmp_3;
                    this.f9_1 = 4;
                    continue $sm;
                  } else {
                    this.kqf_1 = null;
                    this.f9_1 = 4;
                    continue $sm;
                  }
                }
              }
            }

          case 1:
            var tmp5_safe_receiver = suspendResult;
            var tmp_4 = this;
            var tmp_5;
            if (tmp5_safe_receiver == null) {
              tmp_5 = null;
            } else {
              tmp_5 = new NotionDescriptorAdapter(tmp5_safe_receiver);
            }

            tmp_4.kqf_1 = tmp_5;
            this.f9_1 = 4;
            continue $sm;
          case 2:
            this.lqf_1 = suspendResult;
            this.f9_1 = 3;
            continue $sm;
          case 3:
            var tmp3_safe_receiver = this.lqf_1;
            this.kqf_1 = tmp3_safe_receiver == null ? null : toAdapter_0(tmp3_safe_receiver, this.iqf_1.nqf_1);
            this.f9_1 = 4;
            continue $sm;
          case 4:
            return this.kqf_1;
          case 5:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 5) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function expectedClass$$inlined$suspendingQuery$2($this_expectedClass, $cache) {
    this.mqf_1 = $this_expectedClass;
    this.nqf_1 = $cache;
  }
  protoOf(expectedClass$$inlined$suspendingQuery$2).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_116(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(expectedClass$$inlined$suspendingQuery$2).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function $runSuspendCOROUTINE$_117(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.wqf_1 = _this__u8e3s4;
    this.xqf_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_117).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 11;
            this.bqg_1 = this.xqf_1;
            this.zqf_1 = to(this.wqf_1.dqg_1, this.wqf_1.eqg_1);
            if (this.wqf_1.fqg_1.jqg_1.t(this.zqf_1)) {
              var tmp_0 = this;
              tmp_0.yqf_1 = true;
              this.f9_1 = 10;
              continue $sm;
            } else {
              this.wqf_1.fqg_1.jqg_1.j(this.zqf_1);
              this.f9_1 = 1;
              continue $sm;
            }

          case 1:
            this.g9_1 = 9;
            this.f9_1 = 2;
            suspendResult = this.wqf_1.gqg_1.zm4_1.pqg(this.wqf_1.dqg_1, toList_0(this.wqf_1.hqg_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var ARGUMENT = suspendResult;
            this.f9_1 = 3;
            suspendResult = this.bqg_1.k60(ARGUMENT, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            this.cqg_1 = suspendResult;
            this.f9_1 = 4;
            suspendResult = this.wqf_1.gqg_1.zm4_1.pqg(this.wqf_1.eqg_1, toList_0(this.wqf_1.iqg_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            var ARGUMENT_0 = suspendResult;
            this.f9_1 = 5;
            suspendResult = this.bqg_1.k60(ARGUMENT_0, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 5:
            var ARGUMENT_1 = suspendResult;
            this.f9_1 = 6;
            suspendResult = isA(this.wqf_1.fqg_1, this.cqg_1, ARGUMENT_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 6:
            var ARGUMENT_2 = suspendResult;
            this.f9_1 = 7;
            suspendResult = this.bqg_1.k60(ARGUMENT_2, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 7:
            this.aqg_1 = suspendResult;
            this.g9_1 = 11;
            this.f9_1 = 8;
            continue $sm;
          case 8:
            var tmp_1 = this.aqg_1;
            this.g9_1 = 11;
            this.wqf_1.fqg_1.jqg_1.h2(this.zqf_1);
            this.yqf_1 = tmp_1;
            this.f9_1 = 10;
            continue $sm;
          case 9:
            this.g9_1 = 11;
            var t = this.i9_1;
            this.wqf_1.fqg_1.jqg_1.h2(this.zqf_1);
            throw t;
          case 10:
            return this.yqf_1;
          case 11:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 11) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function $runSuspendCOROUTINE$_118(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.yqg_1 = _this__u8e3s4;
    this.zqg_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_118).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 14;
            this.cqh_1 = this.zqg_1;
            var tmp_0 = this;
            tmp_0.jqh_1 = this.yqg_1.kqh_1.dq3_1;
            this.f9_1 = 1;
            continue $sm;
          case 1:
            this.iqh_1 = this.jqh_1;
            var tmp_1;
            var tmp_2 = this.iqh_1;
            if (isInterface(tmp_2, Collection)) {
              tmp_1 = this.iqh_1.s();
            } else {
              tmp_1 = false;
            }

            if (tmp_1) {
              this.aqh_1 = true;
              this.f9_1 = 15;
              continue $sm;
            } else {
              this.f9_1 = 2;
              continue $sm;
            }

          case 2:
            this.hqh_1 = this.iqh_1.m();
            this.f9_1 = 3;
            continue $sm;
          case 3:
            if (!this.hqh_1.n()) {
              this.f9_1 = 13;
              continue $sm;
            }

            var element = this.hqh_1.o();
            this.dqh_1 = element;
            var tmp_3 = this;
            tmp_3.gqh_1 = this.yqg_1.lqh_1.dq3_1;
            this.f9_1 = 4;
            continue $sm;
          case 4:
            this.fqh_1 = this.gqh_1;
            var tmp_4;
            var tmp_5 = this.fqh_1;
            if (isInterface(tmp_5, Collection)) {
              tmp_4 = this.fqh_1.s();
            } else {
              tmp_4 = false;
            }

            if (tmp_4) {
              this.bqh_1 = false;
              this.f9_1 = 11;
              continue $sm;
            } else {
              this.f9_1 = 5;
              continue $sm;
            }

          case 5:
            this.eqh_1 = this.fqh_1.m();
            this.f9_1 = 6;
            continue $sm;
          case 6:
            if (!this.eqh_1.n()) {
              this.f9_1 = 10;
              continue $sm;
            }

            var element_0 = this.eqh_1.o();
            this.f9_1 = 7;
            suspendResult = isA_0(this.yqg_1.mqh_1, this.dqh_1, element_0, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 7:
            var ARGUMENT = suspendResult;
            this.f9_1 = 8;
            suspendResult = this.cqh_1.k60(ARGUMENT, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 8:
            if (suspendResult) {
              this.bqh_1 = true;
              this.f9_1 = 11;
              continue $sm;
            } else {
              this.f9_1 = 9;
              continue $sm;
            }

          case 9:
            this.f9_1 = 6;
            continue $sm;
          case 10:
            this.bqh_1 = false;
            if (false) {
              this.f9_1 = 4;
              continue $sm;
            }

            this.f9_1 = 11;
            continue $sm;
          case 11:
            if (!this.bqh_1) {
              this.aqh_1 = false;
              this.f9_1 = 15;
              continue $sm;
            } else {
              this.f9_1 = 12;
              continue $sm;
            }

          case 12:
            this.f9_1 = 3;
            continue $sm;
          case 13:
            this.aqh_1 = true;
            if (false) {
              this.f9_1 = 1;
              continue $sm;
            }

            this.f9_1 = 15;
            continue $sm;
          case 14:
            throw this.i9_1;
          case 15:
            return this.aqh_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 14) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function $runSuspendCOROUTINE$_119(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.vqh_1 = _this__u8e3s4;
    this.wqh_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_119).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 6;
            this.yqh_1 = this.wqh_1;
            this.f9_1 = 1;
            suspendResult = satisfyBase(this.vqh_1.zqh_1, this.vqh_1.aqi_1, this.vqh_1.bqi_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            this.f9_1 = 2;
            suspendResult = this.yqh_1.k60(ARGUMENT, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            if (!suspendResult) {
              var tmp_0 = this;
              tmp_0.xqh_1 = false;
              this.f9_1 = 5;
              continue $sm;
            } else {
              this.f9_1 = 3;
              suspendResult = satisfyAllProperties(this.vqh_1.zqh_1, this.vqh_1.aqi_1.fq3_1, this.vqh_1.bqi_1.hq3_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 3:
            var ARGUMENT_0 = suspendResult;
            this.f9_1 = 4;
            suspendResult = this.yqh_1.k60(ARGUMENT_0, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            this.xqh_1 = suspendResult;
            this.f9_1 = 5;
            continue $sm;
          case 5:
            return this.xqh_1;
          case 6:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 6) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function $runSuspendCOROUTINE$_120(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.kqi_1 = _this__u8e3s4;
    this.lqi_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_120).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 3;
            var $this$suspendingQuery = this.lqi_1;
            if (this.kqi_1.nqi_1.eq3_1 == null) {
              this.mqi_1 = true;
              this.f9_1 = 2;
              continue $sm;
            } else {
              if (this.kqi_1.oqi_1.eq3_1 == null) {
                this.mqi_1 = false;
                this.f9_1 = 2;
                continue $sm;
              } else {
                if (hasSameOrigin(this.kqi_1.pqi_1, this.kqi_1.oqi_1.eq3_1, this.kqi_1.nqi_1.eq3_1)) {
                  this.mqi_1 = true;
                  this.f9_1 = 2;
                  continue $sm;
                } else {
                  var tmp_0;
                  var tmp_1 = this.kqi_1.oqi_1.eq3_1;
                  if (isInterface(tmp_1, AbstractOntologyElement)) {
                    var tmp_2 = this.kqi_1.nqi_1.eq3_1;
                    tmp_0 = isInterface(tmp_2, AbstractOntologyElement);
                  } else {
                    tmp_0 = false;
                  }
                  if (tmp_0) {
                    this.f9_1 = 1;
                    suspendResult = $this$suspendingQuery.k60(isSubtypeOf_1(this.kqi_1.pqi_1, this.kqi_1.oqi_1.eq3_1, this.kqi_1.nqi_1.eq3_1), this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) {
                      return suspendResult;
                    }
                    continue $sm;
                  } else {
                    this.mqi_1 = false;
                    this.f9_1 = 2;
                    continue $sm;
                  }
                }
              }
            }

          case 1:
            this.mqi_1 = suspendResult;
            this.f9_1 = 2;
            continue $sm;
          case 2:
            return this.mqi_1;
          case 3:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 3) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function $runSuspendCOROUTINE$_121(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.yqi_1 = _this__u8e3s4;
    this.zqi_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_121).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 15;
            this.fqj_1 = this.zqi_1;
            var tmp_0 = this;
            tmp_0.mqj_1 = this.yqi_1.nqj_1;
            this.f9_1 = 1;
            continue $sm;
          case 1:
            this.lqj_1 = this.mqj_1;
            var tmp_1;
            var tmp_2 = this.lqj_1;
            if (isInterface(tmp_2, Collection)) {
              tmp_1 = this.lqj_1.s();
            } else {
              tmp_1 = false;
            }

            if (tmp_1) {
              this.aqj_1 = true;
              this.f9_1 = 16;
              continue $sm;
            } else {
              this.f9_1 = 2;
              continue $sm;
            }

          case 2:
            this.kqj_1 = this.lqj_1.m();
            this.f9_1 = 3;
            continue $sm;
          case 3:
            if (!this.kqj_1.n()) {
              this.f9_1 = 14;
              continue $sm;
            }

            var element = this.kqj_1.o();
            this.gqj_1 = element.fg();
            this.dqj_1 = element.gg();
            var tmp_3 = this;
            tmp_3.jqj_1 = this.yqi_1.oqj_1;
            this.f9_1 = 4;
            continue $sm;
          case 4:
            this.iqj_1 = this.jqj_1;
            var tmp_4;
            var tmp_5 = this.iqj_1;
            if (isInterface(tmp_5, Collection)) {
              tmp_4 = this.iqj_1.s();
            } else {
              tmp_4 = false;
            }

            if (tmp_4) {
              this.bqj_1 = false;
              this.f9_1 = 12;
              continue $sm;
            } else {
              this.f9_1 = 5;
              continue $sm;
            }

          case 5:
            this.hqj_1 = this.iqj_1.m();
            this.f9_1 = 6;
            continue $sm;
          case 6:
            if (!this.hqj_1.n()) {
              this.f9_1 = 11;
              continue $sm;
            }

            var element_0 = this.hqj_1.o();
            var pA = element_0.fg();
            this.eqj_1 = element_0.gg();
            this.f9_1 = 7;
            suspendResult = this.fqj_1.k60(isSubPropertyOf(this.yqi_1.pqj_1, pA, this.gqj_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 7:
            if (suspendResult) {
              this.f9_1 = 8;
              suspendResult = this.fqj_1.k60(this.yqi_1.pqj_1.qqj(this.eqj_1, this.dqj_1), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.cqj_1 = false;
              this.f9_1 = 9;
              continue $sm;
            }

          case 8:
            this.cqj_1 = suspendResult;
            this.f9_1 = 9;
            continue $sm;
          case 9:
            if (this.cqj_1) {
              this.bqj_1 = true;
              this.f9_1 = 12;
              continue $sm;
            } else {
              this.f9_1 = 10;
              continue $sm;
            }

          case 10:
            this.f9_1 = 6;
            continue $sm;
          case 11:
            this.bqj_1 = false;
            if (false) {
              this.f9_1 = 4;
              continue $sm;
            }

            this.f9_1 = 12;
            continue $sm;
          case 12:
            if (!this.bqj_1) {
              this.aqj_1 = false;
              this.f9_1 = 16;
              continue $sm;
            } else {
              this.f9_1 = 13;
              continue $sm;
            }

          case 13:
            this.f9_1 = 3;
            continue $sm;
          case 14:
            this.aqj_1 = true;
            if (false) {
              this.f9_1 = 1;
              continue $sm;
            }

            this.f9_1 = 16;
            continue $sm;
          case 15:
            throw this.i9_1;
          case 16:
            return this.aqj_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 15) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function $runSuspendCOROUTINE$_122(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.zqj_1 = _this__u8e3s4;
    this.aqk_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_122).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 6;
            var tmp_0 = this;
            tmp_0.fqk_1 = this.aqk_1;
            this.bqk_1 = Unit_instance;
            this.f9_1 = 1;
            continue $sm;
          case 1:
            this.dqk_1 = this.fqk_1;
            this.cqk_1 = to(this.zqj_1.gqk_1, this.zqj_1.hqk_1);
            var tmp0_safe_receiver = this.zqj_1.iqk_1.kqg_1.q2(this.cqk_1);
            if (tmp0_safe_receiver == null) {
              this.eqk_1 = null;
              this.f9_1 = 2;
              continue $sm;
            } else {
              this.bqk_1 = tmp0_safe_receiver;
              this.f9_1 = 5;
              var tmp_1 = this;
              continue $sm;
            }

          case 2:
            var normalizedPair = normalizeValueOperands(this.zqj_1.gqk_1, this.zqj_1.hqk_1);
            this.f9_1 = 3;
            suspendResult = compareNormalizedPair(this.zqj_1.iqk_1, normalizedPair, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            var ARGUMENT = suspendResult;
            this.f9_1 = 4;
            suspendResult = this.dqk_1.k60(ARGUMENT, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            var result = suspendResult;
            var tmp0 = this.zqj_1.iqk_1.kqg_1;
            var key = this.cqk_1;
            tmp0.t2(key, result);
            this.bqk_1 = result;
            if (false) {
              this.f9_1 = 1;
              continue $sm;
            }

            this.f9_1 = 5;
            continue $sm;
          case 5:
            return this.bqk_1;
          case 6:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 6) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function $runSuspendCOROUTINE$_123(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.rqk_1 = _this__u8e3s4;
    this.sqk_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_123).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 16;
            this.vqk_1 = this.sqk_1;
            var sub = this.rqk_1.aql_1.lq3_1;
            var sup = this.rqk_1.aql_1.mq3_1;
            this.xqk_1 = this.rqk_1.aql_1.nq3_1;
            this.wqk_1 = this.rqk_1.aql_1.oq3_1;
            var tmp_0;
            if (sub instanceof ClassValue) {
              tmp_0 = sup instanceof ClassValue;
            } else {
              tmp_0 = false;
            }

            if (tmp_0) {
              this.f9_1 = 14;
              suspendResult = this.vqk_1.k60(this.rqk_1.bql_1.cql(sub.ym4_1, sup.ym4_1, this.xqk_1, this.wqk_1), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              var tmp_1;
              if (sub instanceof SetValue) {
                tmp_1 = sup instanceof SetValue;
              } else {
                tmp_1 = false;
              }
              if (tmp_1) {
                this.f9_1 = 9;
                suspendResult = compareSetValues(this.rqk_1.bql_1, sub, sup, this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                var tmp_2;
                if (isInterface(sub, LibraryProcessSpecificationDescriptor)) {
                  tmp_2 = isInterface(sup, LibraryProcessSpecificationDescriptor);
                } else {
                  tmp_2 = false;
                }
                if (tmp_2) {
                  this.f9_1 = 4;
                  suspendResult = processIsA(this.rqk_1.bql_1, sub, sup, this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  continue $sm;
                } else {
                  if (equals(sub, sup)) {
                    this.f9_1 = 1;
                    suspendResult = checkConstraints(this.rqk_1.bql_1, this.xqk_1, this.wqk_1, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) {
                      return suspendResult;
                    }
                    continue $sm;
                  } else {
                    this.zqk_1 = false;
                    this.f9_1 = 3;
                    continue $sm;
                  }
                }
              }
            }

          case 1:
            var ARGUMENT = suspendResult;
            this.f9_1 = 2;
            suspendResult = this.vqk_1.k60(ARGUMENT, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.zqk_1 = suspendResult;
            this.f9_1 = 3;
            continue $sm;
          case 3:
            this.tqk_1 = this.zqk_1;
            this.f9_1 = 15;
            continue $sm;
          case 4:
            var ARGUMENT_0 = suspendResult;
            this.f9_1 = 5;
            suspendResult = this.vqk_1.k60(ARGUMENT_0, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 5:
            if (suspendResult) {
              this.f9_1 = 6;
              suspendResult = checkConstraints(this.rqk_1.bql_1, this.xqk_1, this.wqk_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.yqk_1 = false;
              this.f9_1 = 8;
              continue $sm;
            }

          case 6:
            var ARGUMENT_1 = suspendResult;
            this.f9_1 = 7;
            suspendResult = this.vqk_1.k60(ARGUMENT_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 7:
            this.yqk_1 = suspendResult;
            this.f9_1 = 8;
            continue $sm;
          case 8:
            this.tqk_1 = this.yqk_1;
            this.f9_1 = 15;
            continue $sm;
          case 9:
            var ARGUMENT_2 = suspendResult;
            this.f9_1 = 10;
            suspendResult = this.vqk_1.k60(ARGUMENT_2, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 10:
            if (suspendResult) {
              this.f9_1 = 11;
              suspendResult = checkConstraints(this.rqk_1.bql_1, this.xqk_1, this.wqk_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.uqk_1 = false;
              this.f9_1 = 13;
              continue $sm;
            }

          case 11:
            var ARGUMENT_3 = suspendResult;
            this.f9_1 = 12;
            suspendResult = this.vqk_1.k60(ARGUMENT_3, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 12:
            this.uqk_1 = suspendResult;
            this.f9_1 = 13;
            continue $sm;
          case 13:
            this.tqk_1 = this.uqk_1;
            this.f9_1 = 15;
            continue $sm;
          case 14:
            this.tqk_1 = suspendResult;
            this.f9_1 = 15;
            continue $sm;
          case 15:
            return this.tqk_1;
          case 16:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 16) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function $runSuspendCOROUTINE$_124(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.lql_1 = _this__u8e3s4;
    this.mql_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_124).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 16;
            this.sql_1 = this.mql_1;
            this.xql_1 = ConstraintOperations_getInstance().rq2(this.lql_1.bqm_1);
            var supEffectiveConstraints = ConstraintOperations_getInstance().rq2(this.lql_1.cqm_1);
            var tmp_0 = this;
            tmp_0.aqm_1 = supEffectiveConstraints;
            this.f9_1 = 1;
            continue $sm;
          case 1:
            this.zql_1 = this.aqm_1;
            if (this.zql_1.s()) {
              this.nql_1 = true;
              this.f9_1 = 15;
              continue $sm;
            } else {
              this.f9_1 = 2;
              continue $sm;
            }

          case 2:
            var tmp_1 = this;
            tmp_1.yql_1 = this.zql_1.y().m();
            this.f9_1 = 3;
            continue $sm;
          case 3:
            if (!this.yql_1.n()) {
              this.f9_1 = 14;
              continue $sm;
            }

            var element = this.yql_1.o();
            var tmp_2 = this;
            tmp_2.tql_1 = element.z();
            var tmp_3 = this;
            tmp_3.qql_1 = element.a1();
            var tmp_4 = this;
            tmp_4.wql_1 = this.xql_1;
            this.f9_1 = 4;
            continue $sm;
          case 4:
            this.vql_1 = this.wql_1;
            if (this.vql_1.s()) {
              this.oql_1 = false;
              this.f9_1 = 12;
              continue $sm;
            } else {
              this.f9_1 = 5;
              continue $sm;
            }

          case 5:
            var tmp_5 = this;
            tmp_5.uql_1 = this.vql_1.y().m();
            this.f9_1 = 6;
            continue $sm;
          case 6:
            if (!this.uql_1.n()) {
              this.f9_1 = 11;
              continue $sm;
            }

            var element_0 = this.uql_1.o();
            var pA = element_0.z();
            var tmp_6 = this;
            tmp_6.rql_1 = element_0.a1();
            this.f9_1 = 7;
            suspendResult = this.sql_1.k60(isSubPropertyOf(this.lql_1.dqm_1, pA, this.tql_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 7:
            if (suspendResult) {
              this.f9_1 = 8;
              suspendResult = this.sql_1.k60(this.lql_1.dqm_1.qqj(this.rql_1, this.qql_1), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.pql_1 = false;
              this.f9_1 = 9;
              continue $sm;
            }

          case 8:
            this.pql_1 = suspendResult;
            this.f9_1 = 9;
            continue $sm;
          case 9:
            if (this.pql_1) {
              this.oql_1 = true;
              this.f9_1 = 12;
              continue $sm;
            } else {
              this.f9_1 = 10;
              continue $sm;
            }

          case 10:
            this.f9_1 = 6;
            continue $sm;
          case 11:
            this.oql_1 = false;
            if (false) {
              this.f9_1 = 4;
              continue $sm;
            }

            this.f9_1 = 12;
            continue $sm;
          case 12:
            if (!this.oql_1) {
              this.nql_1 = false;
              this.f9_1 = 15;
              continue $sm;
            } else {
              this.f9_1 = 13;
              continue $sm;
            }

          case 13:
            this.f9_1 = 3;
            continue $sm;
          case 14:
            this.nql_1 = true;
            if (false) {
              this.f9_1 = 1;
              continue $sm;
            }

            this.f9_1 = 15;
            continue $sm;
          case 15:
            return this.nql_1;
          case 16:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 16) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function MultisetMatching$canPossiblyMatchExactly$ref() {
    var l = function (p0) {
      return p0.upf();
    };
    l.callableName = 'canPossiblyMatchExactly';
    return l;
  }
  function MultisetMatching$canPossiblyCoverRight$ref() {
    var l = function (p0) {
      return p0.vpf();
    };
    l.callableName = 'canPossiblyCoverRight';
    return l;
  }
  function $runSuspendCOROUTINE$_125(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.mqm_1 = _this__u8e3s4;
    this.nqm_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_125).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 4;
            var $this$suspendingQuery = this.nqm_1;
            var subGroups = matchingBounds(this.mqm_1.pqm_1.kpg_1);
            var supGroups = matchingBounds(this.mqm_1.qqm_1.kpg_1);
            var tmp0_subject = to(this.mqm_1.pqm_1.lpg_1, this.mqm_1.qqm_1.lpg_1);
            if (tmp0_subject.equals(to(SetType_CLOSED_getInstance(), SetType_CLOSED_getInstance())) || tmp0_subject.equals(to(SetType_CLOSED_getInstance(), SetType_OPEN_getInstance()))) {
              this.f9_1 = 2;
              suspendResult = $this$suspendingQuery.k60(compatibleMatching(this.mqm_1.rqm_1, subGroups, supGroups, MultisetMatching$canPossiblyMatchExactly$ref()), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              if (tmp0_subject.equals(to(SetType_OPEN_getInstance(), SetType_OPEN_getInstance()))) {
                this.f9_1 = 1;
                suspendResult = $this$suspendingQuery.k60(compatibleMatching(this.mqm_1.rqm_1, subGroups, supGroups, MultisetMatching$canPossiblyCoverRight$ref()), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                if (tmp0_subject.equals(to(SetType_OPEN_getInstance(), SetType_CLOSED_getInstance()))) {
                  this.oqm_1 = false;
                  this.f9_1 = 3;
                  continue $sm;
                } else {
                  this.oqm_1 = false;
                  this.f9_1 = 3;
                  continue $sm;
                }
              }
            }

          case 1:
            this.oqm_1 = suspendResult.ypf();
            this.f9_1 = 3;
            continue $sm;
          case 2:
            this.oqm_1 = suspendResult.xpf();
            this.f9_1 = 3;
            continue $sm;
          case 3:
            return this.oqm_1;
          case 4:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 4) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function $runSuspendCOROUTINE$_126(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.aqn_1 = _this__u8e3s4;
    this.bqn_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_126).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 19;
            this.hqn_1 = this.bqn_1;
            this.f9_1 = 1;
            suspendResult = this.hqn_1.k60(this.aqn_1.pqn_1.wpg().tpx(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            if (!suspendResult.t(this.aqn_1.qqn_1.wpg())) {
              var tmp_0 = this;
              tmp_0.cqn_1 = false;
              this.f9_1 = 18;
              continue $sm;
            } else {
              this.f9_1 = 2;
              suspendResult = this.hqn_1.k60(this.aqn_1.pqn_1.kfr(), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 2:
            this.lqn_1 = suspendResult;
            this.f9_1 = 3;
            suspendResult = this.hqn_1.k60(this.aqn_1.qqn_1.kfr(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            this.oqn_1 = suspendResult;
            this.f9_1 = 4;
            continue $sm;
          case 4:
            this.nqn_1 = this.oqn_1;
            var tmp_1;
            var tmp_2 = this.nqn_1;
            if (isInterface(tmp_2, Collection)) {
              tmp_1 = this.nqn_1.s();
            } else {
              tmp_1 = false;
            }

            if (tmp_1) {
              this.dqn_1 = true;
              this.f9_1 = 17;
              continue $sm;
            } else {
              this.f9_1 = 5;
              continue $sm;
            }

          case 5:
            this.mqn_1 = this.nqn_1.m();
            this.f9_1 = 6;
            continue $sm;
          case 6:
            if (!this.mqn_1.n()) {
              this.f9_1 = 16;
              continue $sm;
            }

            var element = this.mqn_1.o();
            this.gqn_1 = element;
            var tmp_3 = this;
            tmp_3.kqn_1 = this.lqn_1;
            this.f9_1 = 7;
            continue $sm;
          case 7:
            this.jqn_1 = this.kqn_1;
            var tmp_4;
            var tmp_5 = this.jqn_1;
            if (isInterface(tmp_5, Collection)) {
              tmp_4 = this.jqn_1.s();
            } else {
              tmp_4 = false;
            }

            if (tmp_4) {
              this.eqn_1 = false;
              this.f9_1 = 14;
              continue $sm;
            } else {
              this.f9_1 = 8;
              continue $sm;
            }

          case 8:
            this.iqn_1 = this.jqn_1.m();
            this.f9_1 = 9;
            continue $sm;
          case 9:
            if (!this.iqn_1.n()) {
              this.f9_1 = 13;
              continue $sm;
            }

            var element_0 = this.iqn_1.o();
            var tmp0 = element_0.xpg_1;
            var tmp$ret$4;
            l$ret$5: do {
              var tmp_6;
              if (isInterface(tmp0, Collection)) {
                tmp_6 = tmp0.s();
              } else {
                tmp_6 = false;
              }
              if (tmp_6) {
                tmp$ret$4 = false;
                break l$ret$5;
              }
              var _iterator__ex2g4s = tmp0.m();
              while (_iterator__ex2g4s.n()) {
                var element_1 = _iterator__ex2g4s.o();
                if (this.gqn_1.xpg_1.t(element_1)) {
                  tmp$ret$4 = true;
                  break l$ret$5;
                }
              }
              tmp$ret$4 = false;
            }
             while (false);
            if (tmp$ret$4) {
              this.f9_1 = 10;
              suspendResult = this.hqn_1.k60(this.aqn_1.rqn_1.qqj(element_0.ypg_1, this.gqn_1.ypg_1), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.fqn_1 = false;
              this.f9_1 = 11;
              continue $sm;
            }

          case 10:
            this.fqn_1 = suspendResult;
            this.f9_1 = 11;
            continue $sm;
          case 11:
            if (this.fqn_1) {
              this.eqn_1 = true;
              this.f9_1 = 14;
              continue $sm;
            } else {
              this.f9_1 = 12;
              continue $sm;
            }

          case 12:
            this.f9_1 = 9;
            continue $sm;
          case 13:
            this.eqn_1 = false;
            if (false) {
              this.f9_1 = 7;
              continue $sm;
            }

            this.f9_1 = 14;
            continue $sm;
          case 14:
            if (!this.eqn_1) {
              this.dqn_1 = false;
              this.f9_1 = 17;
              continue $sm;
            } else {
              this.f9_1 = 15;
              continue $sm;
            }

          case 15:
            this.f9_1 = 6;
            continue $sm;
          case 16:
            this.dqn_1 = true;
            if (false) {
              this.f9_1 = 4;
              continue $sm;
            }

            this.f9_1 = 17;
            continue $sm;
          case 17:
            this.cqn_1 = this.dqn_1;
            this.f9_1 = 18;
            continue $sm;
          case 18:
            return this.cqn_1;
          case 19:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 19) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function $runSuspendCOROUTINE$_127(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.aqo_1 = _this__u8e3s4;
    this.bqo_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_127).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 8;
            this.fqo_1 = this.bqo_1;
            var tmp_0 = this;
            var this_0 = this.aqo_1.iqo_1;
            var destination = ArrayList_init_$Create$_0(this_0.p());
            var _iterator__ex2g4s = this_0.y().m();
            while (_iterator__ex2g4s.n()) {
              var item = _iterator__ex2g4s.o();
              destination.j(new MultisetElement(item.z(), item.a1()));
            }

            var this_1 = this.aqo_1.jqo_1;
            var destination_0 = ArrayList_init_$Create$_0(this_1.p());
            var _iterator__ex2g4s_0 = this_1.y().m();
            while (_iterator__ex2g4s_0.n()) {
              var item_0 = _iterator__ex2g4s_0.o();
              destination_0.j(new MultisetElement(item_0.z(), item_0.a1()));
            }

            tmp_0.cqo_1 = new MultisetMatching(destination, destination_0);
            if (this.aqo_1.kqo_1(this.cqo_1)) {
              this.hqo_1 = this.cqo_1.dpf_1.m();
              this.f9_1 = 1;
              continue $sm;
            } else {
              this.f9_1 = 7;
              continue $sm;
            }

          case 1:
            if (!this.hqo_1.n()) {
              this.f9_1 = 6;
              continue $sm;
            }

            this.eqo_1 = this.hqo_1.o();
            this.gqo_1 = this.cqo_1.epf_1.m();
            this.f9_1 = 2;
            continue $sm;
          case 2:
            if (!this.gqo_1.n()) {
              this.f9_1 = 5;
              continue $sm;
            }

            this.dqo_1 = this.gqo_1.o();
            this.f9_1 = 3;
            suspendResult = this.fqo_1.k60(this.aqo_1.lqo_1.qqj(this.eqo_1.wpe_1, this.dqo_1.ype_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            if (suspendResult) {
              this.cqo_1.wpf(this.eqo_1, this.dqo_1);
              this.f9_1 = 4;
              continue $sm;
            } else {
              this.f9_1 = 4;
              continue $sm;
            }

          case 4:
            this.f9_1 = 2;
            continue $sm;
          case 5:
            this.f9_1 = 1;
            continue $sm;
          case 6:
            this.f9_1 = 7;
            continue $sm;
          case 7:
            return this.cqo_1;
          case 8:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 8) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function $runSuspendCOROUTINE$_128(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.uqo_1 = _this__u8e3s4;
    this.vqo_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_128).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            var $this$suspendingQuery = this.vqo_1;
            var tmp_0 = this.uqo_1.wqo_1;
            var elementOfT = isInterface(tmp_0, AbstractOntologyElement) ? tmp_0 : THROW_CCE();
            this.f9_1 = 1;
            suspendResult = $this$suspendingQuery.k60(this.uqo_1.xqo_1.am5_1.jqb(elementOfT), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var allSuperElements = suspendResult;
            return contains_5(allSuperElements, this.uqo_1.yqo_1);
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function $runSuspendCOROUTINE$_129(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.hqp_1 = _this__u8e3s4;
    this.iqp_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_129).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 4;
            this.lqp_1 = this.iqp_1;
            this.jqp_1 = false;
            this.kqp_1 = this.hqp_1.mqp_1;
            this.f9_1 = 1;
            continue $sm;
          case 1:
            if (!(!(this.kqp_1 == null) && !this.jqp_1)) {
              this.f9_1 = 5;
              continue $sm;
            }

            if (equals(this.kqp_1, this.hqp_1.nqp_1)) {
              this.jqp_1 = true;
              this.f9_1 = 3;
              continue $sm;
            } else {
              this.f9_1 = 2;
              suspendResult = this.lqp_1.k60(this.kqp_1.gfs(), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 2:
            this.kqp_1 = suspendResult;
            this.f9_1 = 3;
            continue $sm;
          case 3:
            this.f9_1 = 1;
            continue $sm;
          case 4:
            throw this.i9_1;
          case 5:
            return this.jqp_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 4) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function isA($this, _this__u8e3s4, other, $completion) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new TypeComparer$StatefulComparer$isA$$inlined$suspendingQuery$1(_this__u8e3s4, other, $this);
  }
  function isA_0($this, _this__u8e3s4, other, $completion) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new TypeComparer$StatefulComparer$isA$$inlined$suspendingQuery$2($this, _this__u8e3s4, other);
  }
  function satisfyBase($this, _this__u8e3s4, other, $completion) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new TypeComparer$StatefulComparer$satisfyBase$$inlined$suspendingQuery$1(other, _this__u8e3s4, $this);
  }
  function satisfyAllProperties($this, _this__u8e3s4, expectedProps, $completion) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new TypeComparer$StatefulComparer$satisfyAllProperties$$inlined$suspendingQuery$1(expectedProps, _this__u8e3s4, $this);
  }
  function compareNormalizedPair($this, normalized, $completion) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new TypeComparer$StatefulComparer$compareNormalizedPair$$inlined$suspendingQuery$1(normalized, $this);
  }
  function checkConstraints($this, subConstraints, supConstraints, $completion) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new TypeComparer$StatefulComparer$checkConstraints$$inlined$suspendingQuery$1(subConstraints, supConstraints, $this);
  }
  function compareSetValues($this, subSet, supSet, $completion) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new TypeComparer$StatefulComparer$compareSetValues$$inlined$suspendingQuery$1(subSet, supSet, $this);
  }
  function processIsA($this, sub, sup, $completion) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new TypeComparer$StatefulComparer$processIsA$$inlined$suspendingQuery$1(sub, sup, $this);
  }
  function compatibleMatching($this, subGroups, supGroups, canBuild) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new TypeComparer$StatefulComparer$compatibleMatching$$inlined$suspendingQuery$1(subGroups, supGroups, canBuild, $this);
  }
  function isSubtypeOf_1($this, _this__u8e3s4, parent) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new TypeComparer$StatefulComparer$isSubtypeOf$$inlined$suspendingQuery$1(_this__u8e3s4, $this.lqg_1, parent);
  }
  function hasSameOrigin($this, _this__u8e3s4, other) {
    var tmp;
    var tmp_0;
    if (isInterface(_this__u8e3s4, AbstractOntologyElement)) {
      tmp_0 = isInterface(other, AbstractOntologyElement);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = equals(_this__u8e3s4.cma(), other.cma());
    } else {
      var tmp_1;
      if (isInterface(_this__u8e3s4, AbstractNotionDescriptor)) {
        tmp_1 = isInterface(other, AbstractNotionDescriptor);
      } else {
        tmp_1 = false;
      }
      if (tmp_1) {
        tmp = equals(_this__u8e3s4.cma(), other.cma());
      } else {
        tmp = equals(_this__u8e3s4, other);
      }
    }
    return tmp;
  }
  function isSubPropertyOf($this, _this__u8e3s4, superP) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new TypeComparer$StatefulComparer$isSubPropertyOf$$inlined$suspendingQuery$1(_this__u8e3s4, superP);
  }
  function TypeComparer$StatefulComparer$descriptorIsA$$inlined$suspendingQuery$1($sub, $sup, this$0, this$1, $subConstraints, $supConstraints) {
    this.dqg_1 = $sub;
    this.eqg_1 = $sup;
    this.fqg_1 = this$0;
    this.gqg_1 = this$1;
    this.hqg_1 = $subConstraints;
    this.iqg_1 = $supConstraints;
  }
  protoOf(TypeComparer$StatefulComparer$descriptorIsA$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_117(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(TypeComparer$StatefulComparer$descriptorIsA$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function TypeComparer$StatefulComparer$isA$$inlined$suspendingQuery$1($this_isA, $other, this$0) {
    this.kqh_1 = $this_isA;
    this.lqh_1 = $other;
    this.mqh_1 = this$0;
  }
  protoOf(TypeComparer$StatefulComparer$isA$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_118(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(TypeComparer$StatefulComparer$isA$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function TypeComparer$StatefulComparer$isA$$inlined$suspendingQuery$2(this$0, $this_isA, $other) {
    this.zqh_1 = this$0;
    this.aqi_1 = $this_isA;
    this.bqi_1 = $other;
  }
  protoOf(TypeComparer$StatefulComparer$isA$$inlined$suspendingQuery$2).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_119(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(TypeComparer$StatefulComparer$isA$$inlined$suspendingQuery$2).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function TypeComparer$StatefulComparer$satisfyBase$$inlined$suspendingQuery$1($other, $this_satisfyBase, this$0) {
    this.nqi_1 = $other;
    this.oqi_1 = $this_satisfyBase;
    this.pqi_1 = this$0;
  }
  protoOf(TypeComparer$StatefulComparer$satisfyBase$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_120(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(TypeComparer$StatefulComparer$satisfyBase$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function TypeComparer$StatefulComparer$satisfyAllProperties$$inlined$suspendingQuery$1($expectedProps, $this_satisfyAllProperties, this$0) {
    this.nqj_1 = $expectedProps;
    this.oqj_1 = $this_satisfyAllProperties;
    this.pqj_1 = this$0;
  }
  protoOf(TypeComparer$StatefulComparer$satisfyAllProperties$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_121(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(TypeComparer$StatefulComparer$satisfyAllProperties$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function TypeComparer$StatefulComparer$valueIsA$$inlined$suspendingQuery$1($sub, $sup, this$0) {
    this.gqk_1 = $sub;
    this.hqk_1 = $sup;
    this.iqk_1 = this$0;
  }
  protoOf(TypeComparer$StatefulComparer$valueIsA$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_122(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(TypeComparer$StatefulComparer$valueIsA$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function TypeComparer$StatefulComparer$compareNormalizedPair$$inlined$suspendingQuery$1($normalized, this$0) {
    this.aql_1 = $normalized;
    this.bql_1 = this$0;
  }
  protoOf(TypeComparer$StatefulComparer$compareNormalizedPair$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_123(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(TypeComparer$StatefulComparer$compareNormalizedPair$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function TypeComparer$StatefulComparer$checkConstraints$$inlined$suspendingQuery$1($subConstraints, $supConstraints, this$0) {
    this.bqm_1 = $subConstraints;
    this.cqm_1 = $supConstraints;
    this.dqm_1 = this$0;
  }
  protoOf(TypeComparer$StatefulComparer$checkConstraints$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_124(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(TypeComparer$StatefulComparer$checkConstraints$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function TypeComparer$StatefulComparer$compareSetValues$$inlined$suspendingQuery$1($subSet, $supSet, this$0) {
    this.pqm_1 = $subSet;
    this.qqm_1 = $supSet;
    this.rqm_1 = this$0;
  }
  protoOf(TypeComparer$StatefulComparer$compareSetValues$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_125(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(TypeComparer$StatefulComparer$compareSetValues$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function TypeComparer$StatefulComparer$processIsA$$inlined$suspendingQuery$1($sub, $sup, this$0) {
    this.pqn_1 = $sub;
    this.qqn_1 = $sup;
    this.rqn_1 = this$0;
  }
  protoOf(TypeComparer$StatefulComparer$processIsA$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_126(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(TypeComparer$StatefulComparer$processIsA$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function TypeComparer$StatefulComparer$compatibleMatching$$inlined$suspendingQuery$1($subGroups, $supGroups, $canBuild, this$0) {
    this.iqo_1 = $subGroups;
    this.jqo_1 = $supGroups;
    this.kqo_1 = $canBuild;
    this.lqo_1 = this$0;
  }
  protoOf(TypeComparer$StatefulComparer$compatibleMatching$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_127(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(TypeComparer$StatefulComparer$compatibleMatching$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function TypeComparer$StatefulComparer$isSubtypeOf$$inlined$suspendingQuery$1($this_isSubtypeOf, this$0, $parent) {
    this.wqo_1 = $this_isSubtypeOf;
    this.xqo_1 = this$0;
    this.yqo_1 = $parent;
  }
  protoOf(TypeComparer$StatefulComparer$isSubtypeOf$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_128(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(TypeComparer$StatefulComparer$isSubtypeOf$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function TypeComparer$StatefulComparer$isSubPropertyOf$$inlined$suspendingQuery$1($this_isSubPropertyOf, $superP) {
    this.mqp_1 = $this_isSubPropertyOf;
    this.nqp_1 = $superP;
  }
  protoOf(TypeComparer$StatefulComparer$isSubPropertyOf$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_129(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(TypeComparer$StatefulComparer$isSubPropertyOf$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function StatefulComparer($outer) {
    this.lqg_1 = $outer;
    var tmp = this;
    // Inline function 'kotlin.collections.mutableSetOf' call
    tmp.jqg_1 = LinkedHashSet_init_$Create$();
    var tmp_0 = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp_0.kqg_1 = LinkedHashMap_init_$Create$();
  }
  protoOf(StatefulComparer).cql = function (sub, sup, subConstraints, supConstraints) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new TypeComparer$StatefulComparer$descriptorIsA$$inlined$suspendingQuery$1(sub, sup, this, this.lqg_1, subConstraints, supConstraints);
  };
  protoOf(StatefulComparer).oqp = function (sub, sup, subConstraints, supConstraints, $super) {
    subConstraints = subConstraints === VOID ? emptyList() : subConstraints;
    supConstraints = supConstraints === VOID ? emptyList() : supConstraints;
    return $super === VOID ? this.cql(sub, sup, subConstraints, supConstraints) : $super.cql.call(this, sub, sup, subConstraints, supConstraints);
  };
  protoOf(StatefulComparer).qqj = function (sub, sup) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new TypeComparer$StatefulComparer$valueIsA$$inlined$suspendingQuery$1(sub, sup, this);
  };
  function TypeComparer(normalizer, superElementsFinder) {
    this.zm4_1 = normalizer;
    this.am5_1 = superElementsFinder;
  }
  protoOf(TypeComparer).bm5 = function (sub, sup) {
    return (new StatefulComparer(this)).oqp(sub, sup);
  };
  function $runSuspendCOROUTINE$_130(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.xqp_1 = _this__u8e3s4;
    this.yqp_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_130).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 7;
            var tmp_0 = this;
            tmp_0.cqq_1 = this.yqp_1;
            this.zqp_1 = Unit_instance;
            this.f9_1 = 1;
            continue $sm;
          case 1:
            this.bqq_1 = this.cqq_1;
            if (this.xqp_1.dqq_1.t(this.xqp_1.eqq_1)) {
              this.zqp_1 = Companion_getInstance_369().aq3_1;
              this.f9_1 = 6;
              continue $sm;
            } else {
              this.f9_1 = 2;
              continue $sm;
            }

          case 2:
            var updatedCurrentlyProcessing = plus_11(this.xqp_1.dqq_1, this.xqp_1.eqq_1);
            var tmp0_subject = this.xqp_1.eqq_1;
            if (isInterface(tmp0_subject, AbstractElementDefinition)) {
              this.f9_1 = 4;
              suspendResult = this.bqq_1.k60(normalizeDefinedType(this.xqp_1.fqq_1, this.xqp_1.eqq_1, this.xqp_1.gqq_1, updatedCurrentlyProcessing), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              if (isInterface(tmp0_subject, AbstractOntologyElement)) {
                this.f9_1 = 3;
                suspendResult = this.bqq_1.k60(elementToTypeExpression(this.xqp_1.fqq_1, this.xqp_1.eqq_1, this.xqp_1.gqq_1, updatedCurrentlyProcessing), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                if (isInterface(tmp0_subject, AbstractNotionDescriptor)) {
                  this.aqq_1 = new Clause(this.xqp_1.eqq_1);
                  this.f9_1 = 5;
                  continue $sm;
                } else {
                  var tmp_1 = this;
                  noWhenBranchMatchedException();
                }
              }
            }

            break;
          case 3:
            this.aqq_1 = suspendResult;
            this.f9_1 = 5;
            continue $sm;
          case 4:
            this.aqq_1 = suspendResult;
            this.f9_1 = 5;
            continue $sm;
          case 5:
            this.zqp_1 = this.aqq_1;
            if (false) {
              this.f9_1 = 1;
              continue $sm;
            }

            this.f9_1 = 6;
            continue $sm;
          case 6:
            return this.zqp_1;
          case 7:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 7) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function $runSuspendCOROUTINE$_131(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.pqq_1 = _this__u8e3s4;
    this.qqq_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_131).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 5;
            this.sqq_1 = this.qqq_1;
            this.f9_1 = 1;
            suspendResult = this.sqq_1.k60(this.pqq_1.tqq_1.wfs(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var definition = suspendResult;
            if (definition == null) {
              this.f9_1 = 3;
              suspendResult = this.sqq_1.k60(normalizeNaturalType(this.pqq_1.uqq_1, this.pqq_1.tqq_1, this.pqq_1.vqq_1), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.f9_1 = 2;
              suspendResult = this.sqq_1.k60(normalizeDefinedType(this.pqq_1.uqq_1, definition, this.pqq_1.vqq_1, this.pqq_1.wqq_1), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 2:
            this.rqq_1 = suspendResult;
            this.f9_1 = 4;
            continue $sm;
          case 3:
            this.rqq_1 = suspendResult;
            this.f9_1 = 4;
            continue $sm;
          case 4:
            return this.rqq_1;
          case 5:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 5) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function $runSuspendCOROUTINE$_132(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.fqr_1 = _this__u8e3s4;
    this.gqr_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_132).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 8;
            this.kqr_1 = this.gqr_1;
            this.f9_1 = 1;
            suspendResult = this.kqr_1.k60(this.fqr_1.nqr_1.ofr(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            var ARGUMENT_0 = this.fqr_1.mqr_1.oq2(ARGUMENT);
            this.f9_1 = 2;
            suspendResult = this.kqr_1.k60(ARGUMENT_0, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var definitionalConstraints = suspendResult;
            this.jqr_1 = plus_5(definitionalConstraints, this.fqr_1.oqr_1);
            this.f9_1 = 3;
            suspendResult = this.kqr_1.k60(this.fqr_1.nqr_1.mfu(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            var components = suspendResult;
            if (components.s()) {
              var tmp_0 = this;
              var effective = ConstraintOperations_getInstance().rq2(this.jqr_1);
              var destination = ArrayList_init_$Create$_0(effective.p());
              var _iterator__ex2g4s = effective.y().m();
              while (_iterator__ex2g4s.n()) {
                var item = _iterator__ex2g4s.o();
                var prop = item.z();
                var value = item.a1();
                destination.j(new HasProperty(prop, value, Source_DEFINITIONAL_getInstance()));
              }
              var props = destination;
              tmp_0.hqr_1 = new Clause(VOID, toSet_0(props));
              this.f9_1 = 7;
              continue $sm;
            } else {
              this.iqr_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(components, 10));
              this.lqr_1 = components.m();
              this.f9_1 = 4;
              continue $sm;
            }

          case 4:
            if (!this.lqr_1.n()) {
              this.f9_1 = 6;
              continue $sm;
            }

            var item_0 = this.lqr_1.o();
            this.f9_1 = 5;
            suspendResult = this.kqr_1.k60(toTypeExpression(this.fqr_1.mqr_1, item_0, this.jqr_1, this.fqr_1.pqr_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 5:
            var ARGUMENT_1 = suspendResult;
            this.iqr_1.j(ARGUMENT_1);
            this.f9_1 = 4;
            continue $sm;
          case 6:
            var ARGUMENT_2 = this.iqr_1;
            var clauses = toSet_0(ARGUMENT_2);
            this.hqr_1 = new Union(clauses);
            this.f9_1 = 7;
            continue $sm;
          case 7:
            return this.hqr_1;
          case 8:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 8) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function $runSuspendCOROUTINE$_133(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.yqr_1 = _this__u8e3s4;
    this.zqr_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_133).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            var $this$suspendingQuery = this.zqr_1;
            this.f9_1 = 1;
            suspendResult = $this$suspendingQuery.k60(getAllInherentProperties$default(this.yqr_1.aqs_1, this.yqr_1.bqs_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var inherent = suspendResult;
            var effectiveInherent = ConstraintOperations_getInstance().rq2(inherent);
            var destination = ArrayList_init_$Create$_0(effectiveInherent.p());
            var _iterator__ex2g4s = effectiveInherent.y().m();
            while (_iterator__ex2g4s.n()) {
              var item = _iterator__ex2g4s.o();
              var prop = item.z();
              var value = item.a1();
              destination.j(new HasProperty(prop, value, Source_INHERENT_getInstance()));
            }

            var inherentProps = destination;
            var effectiveDef = ConstraintOperations_getInstance().rq2(this.yqr_1.cqs_1);
            var destination_0 = ArrayList_init_$Create$_0(effectiveDef.p());
            var _iterator__ex2g4s_0 = effectiveDef.y().m();
            while (_iterator__ex2g4s_0.n()) {
              var item_0 = _iterator__ex2g4s_0.o();
              var prop_0 = item_0.z();
              var value_0 = item_0.a1();
              destination_0.j(new HasProperty(prop_0, value_0, Source_DEFINITIONAL_getInstance()));
            }

            var definitionalProps = destination_0;
            return new Clause(this.yqr_1.bqs_1, toSet_0(plus_5(inherentProps, definitionalProps)));
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function $runSuspendCOROUTINE$_134(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.lqs_1 = _this__u8e3s4;
    this.mqs_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_134).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 9;
            this.qqs_1 = this.mqs_1;
            this.f9_1 = 1;
            suspendResult = this.qqs_1.k60(this.lqs_1.tqs_1.apg(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            var ARGUMENT_0 = this.lqs_1.sqs_1.oq2(ARGUMENT);
            this.f9_1 = 2;
            suspendResult = this.qqs_1.k60(ARGUMENT_0, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.nqs_1 = suspendResult;
            this.f9_1 = 3;
            suspendResult = this.qqs_1.k60(this.lqs_1.tqs_1.nfs(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            var tmp0 = suspendResult;
            this.oqs_1 = ArrayList_init_$Create$();
            this.rqs_1 = tmp0.m();
            this.f9_1 = 4;
            continue $sm;
          case 4:
            if (!this.rqs_1.n()) {
              this.f9_1 = 8;
              continue $sm;
            }

            var element = this.rqs_1.o();
            this.f9_1 = 5;
            suspendResult = this.qqs_1.k60(element.gfq(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 5:
            var tmp0_safe_receiver = suspendResult;
            if (tmp0_safe_receiver == null) {
              this.pqs_1 = null;
              this.f9_1 = 7;
              continue $sm;
            } else {
              this.f9_1 = 6;
              suspendResult = this.qqs_1.k60(getAllInherentProperties(this.lqs_1.sqs_1, tmp0_safe_receiver, plus_11(this.lqs_1.uqs_1, this.lqs_1.tqs_1)), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 6:
            var parentProps = suspendResult;
            var effective = ConstraintOperations_getInstance().rq2(parentProps);
            var tmp_0 = this;
            var destination = ArrayList_init_$Create$_0(effective.p());
            var _iterator__ex2g4s = effective.y().m();
            while (_iterator__ex2g4s.n()) {
              var item = _iterator__ex2g4s.o();
              var prop = item.z();
              var value = item.a1();
              destination.j(new Constraint(prop, value, null));
            }

            tmp_0.pqs_1 = destination;
            this.f9_1 = 7;
            continue $sm;
          case 7:
            var tmp1_elvis_lhs = this.pqs_1;
            var list = tmp1_elvis_lhs == null ? emptyList() : tmp1_elvis_lhs;
            addAll_1(this.oqs_1, list);
            this.f9_1 = 4;
            continue $sm;
          case 8:
            var inheritedConstraints = this.oqs_1;
            var mergedInheritedConstraints = ConstraintOperations_getInstance().tq2(inheritedConstraints);
            return plus_5(mergedInheritedConstraints, this.nqs_1);
          case 9:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 9) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function $runSuspendCOROUTINE$_135(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.dqt_1 = _this__u8e3s4;
    this.eqt_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_135).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 7;
            var tmp_0 = this;
            tmp_0.lqt_1 = this.eqt_1;
            this.fqt_1 = Unit_instance;
            this.f9_1 = 1;
            continue $sm;
          case 1:
            this.kqt_1 = this.lqt_1;
            if (this.dqt_1.mqt_1.s()) {
              this.fqt_1 = this.dqt_1.nqt_1;
              this.f9_1 = 6;
              continue $sm;
            } else {
              this.f9_1 = 2;
              continue $sm;
            }

          case 2:
            var tmp0_subject = this.dqt_1.nqt_1;
            if (tmp0_subject instanceof ClassValue) {
              this.gqt_1 = new ClassValue(new ConstrainedElementDefinition(listOf(this.dqt_1.nqt_1.ym4_1), this.dqt_1.mqt_1));
              this.f9_1 = 5;
              continue $sm;
            } else {
              if (tmp0_subject instanceof SetValue) {
                this.iqt_1 = ConstraintOperations_getInstance();
                this.hqt_1 = this.dqt_1.nqt_1;
                this.f9_1 = 4;
                suspendResult = this.kqt_1.k60(resolveConstraints(this.dqt_1.oqt_1, this.dqt_1.mqt_1), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                this.jqt_1 = ConstraintOperations_getInstance();
                this.f9_1 = 3;
                suspendResult = this.kqt_1.k60(resolveConstraints(this.dqt_1.oqt_1, this.dqt_1.mqt_1), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              }
            }

          case 3:
            var ARGUMENT = suspendResult;
            this.gqt_1 = this.jqt_1.qq2(this.dqt_1.nqt_1, ARGUMENT);
            this.f9_1 = 5;
            continue $sm;
          case 4:
            var ARGUMENT_0 = suspendResult;
            this.gqt_1 = this.iqt_1.qq2(this.hqt_1, ARGUMENT_0);
            this.f9_1 = 5;
            continue $sm;
          case 5:
            this.fqt_1 = this.gqt_1;
            if (false) {
              this.f9_1 = 1;
              continue $sm;
            }

            this.f9_1 = 6;
            continue $sm;
          case 6:
            return this.fqt_1;
          case 7:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 7) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function $runSuspendCOROUTINE$_136(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.xqt_1 = _this__u8e3s4;
    this.yqt_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_136).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 8;
            this.dqu_1 = this.yqt_1;
            var this_0 = this.xqt_1.gqu_1;
            this.zqt_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
            this.fqu_1 = this_0.m();
            this.f9_1 = 1;
            continue $sm;
          case 1:
            if (!this.fqu_1.n()) {
              this.f9_1 = 7;
              continue $sm;
            }

            var item = this.fqu_1.o();
            this.cqu_1 = item;
            this.f9_1 = 2;
            suspendResult = this.dqu_1.k60(this.cqu_1.q6q(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.bqu_1 = suspendResult;
            this.f9_1 = 3;
            suspendResult = this.dqu_1.k60(this.cqu_1.a1(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            this.equ_1 = suspendResult;
            this.f9_1 = 4;
            suspendResult = this.dqu_1.k60(this.cqu_1.ofr(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            var ARGUMENT = suspendResult;
            var ARGUMENT_0 = convertToDescriptor(this.xqt_1.hqu_1, this.equ_1, ARGUMENT);
            this.f9_1 = 5;
            suspendResult = this.dqu_1.k60(ARGUMENT_0, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 5:
            this.aqu_1 = suspendResult;
            this.f9_1 = 6;
            suspendResult = this.dqu_1.k60(this.cqu_1.s3z(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 6:
            var ARGUMENT_1 = suspendResult;
            var ARGUMENT_2 = new Constraint(this.bqu_1, this.aqu_1, ARGUMENT_1);
            this.zqt_1.j(ARGUMENT_2);
            this.f9_1 = 1;
            continue $sm;
          case 7:
            return this.zqt_1;
          case 8:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 8) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function $runSuspendCOROUTINE$_137(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.qqu_1 = _this__u8e3s4;
    this.rqu_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_137).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 12;
            this.xqu_1 = this.rqu_1;
            var tmp0 = this.qqu_1.eqv_1;
            this.bqv_1 = LinkedHashMap_init_$Create$();
            this.dqv_1 = tmp0.m();
            this.f9_1 = 1;
            continue $sm;
          case 1:
            if (!this.dqv_1.n()) {
              this.f9_1 = 3;
              continue $sm;
            }

            this.cqv_1 = this.dqv_1.o();
            var it = this.cqv_1;
            this.f9_1 = 2;
            suspendResult = this.xqu_1.k60(it.q6q(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var key = suspendResult;
            var this_0 = this.bqv_1;
            var value = this_0.q2(key);
            var tmp_0;
            if (value == null) {
              var answer = ArrayList_init_$Create$();
              this_0.t2(key, answer);
              tmp_0 = answer;
            } else {
              tmp_0 = value;
            }

            var list = tmp_0;
            list.j(this.cqv_1);
            this.f9_1 = 1;
            continue $sm;
          case 3:
            var tmp0_0 = this.bqv_1;
            this.squ_1 = ArrayList_init_$Create$();
            var tmp_1 = this;
            tmp_1.aqv_1 = tmp0_0.y().m();
            this.f9_1 = 4;
            continue $sm;
          case 4:
            if (!this.aqv_1.n()) {
              this.f9_1 = 11;
              continue $sm;
            }

            var element = this.aqv_1.o();
            var tmp_2 = this;
            tmp_2.vqu_1 = element.z();
            var constraints = element.a1();
            this.tqu_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(constraints, 10));
            this.zqu_1 = constraints.m();
            this.f9_1 = 5;
            continue $sm;
          case 5:
            if (!this.zqu_1.n()) {
              this.f9_1 = 10;
              continue $sm;
            }

            var item = this.zqu_1.o();
            this.wqu_1 = item;
            this.f9_1 = 6;
            suspendResult = this.xqu_1.k60(this.wqu_1.a1(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 6:
            this.yqu_1 = suspendResult;
            this.f9_1 = 7;
            suspendResult = this.xqu_1.k60(this.wqu_1.ofr(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 7:
            var ARGUMENT = suspendResult;
            var ARGUMENT_0 = convertToDescriptor(this.qqu_1.fqv_1, this.yqu_1, ARGUMENT);
            this.f9_1 = 8;
            suspendResult = this.xqu_1.k60(ARGUMENT_0, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 8:
            this.uqu_1 = suspendResult;
            this.f9_1 = 9;
            suspendResult = this.xqu_1.k60(this.wqu_1.s3z(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 9:
            var ARGUMENT_1 = suspendResult;
            var ARGUMENT_2 = new Constraint(this.vqu_1, this.uqu_1, ARGUMENT_1);
            this.tqu_1.j(ARGUMENT_2);
            this.f9_1 = 5;
            continue $sm;
          case 10:
            var list_0 = this.tqu_1;
            addAll_1(this.squ_1, list_0);
            this.f9_1 = 4;
            continue $sm;
          case 11:
            return this.squ_1;
          case 12:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 12) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function toTypeExpression($this, def, collectedConstraints, currentlyProcessing) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new TypeExpressionConverter$toTypeExpression$$inlined$suspendingQuery$1(currentlyProcessing, def, $this, collectedConstraints);
  }
  function elementToTypeExpression($this, cls, collectedConstraints, currentlyProcessing) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new TypeExpressionConverter$elementToTypeExpression$$inlined$suspendingQuery$1(cls, $this, collectedConstraints, currentlyProcessing);
  }
  function normalizeDefinedType($this, definition, collectedConstraints, currentlyProcessing) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new TypeExpressionConverter$normalizeDefinedType$$inlined$suspendingQuery$1($this, definition, collectedConstraints, currentlyProcessing);
  }
  function normalizeNaturalType($this, cls, collectedConstraints) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new TypeExpressionConverter$normalizeNaturalType$$inlined$suspendingQuery$1($this, cls, collectedConstraints);
  }
  function getAllInherentProperties($this, cls, visitedParents) {
    if (visitedParents.t(cls)) {
      // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
      return new TypeExpressionConverter$getAllInherentProperties$$inlined$suspendingQuery$1();
    }
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new TypeExpressionConverter$getAllInherentProperties$$inlined$suspendingQuery$2($this, cls, visitedParents);
  }
  function getAllInherentProperties$default($this, cls, visitedParents, $super) {
    visitedParents = visitedParents === VOID ? emptySet() : visitedParents;
    return getAllInherentProperties($this, cls, visitedParents);
  }
  function convertToDescriptor($this, baseDescriptor, propertyConstraints) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new TypeExpressionConverter$convertToDescriptor$$inlined$suspendingQuery$1(propertyConstraints, baseDescriptor, $this);
  }
  function resolveConstraints($this, propertyConstraints) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new TypeExpressionConverter$resolveConstraints$$inlined$suspendingQuery$1(propertyConstraints, $this);
  }
  function TypeExpressionConverter$toTypeExpression$$inlined$suspendingQuery$1($currentlyProcessing, $def, this$0, $collectedConstraints) {
    this.dqq_1 = $currentlyProcessing;
    this.eqq_1 = $def;
    this.fqq_1 = this$0;
    this.gqq_1 = $collectedConstraints;
  }
  protoOf(TypeExpressionConverter$toTypeExpression$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_130(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(TypeExpressionConverter$toTypeExpression$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function TypeExpressionConverter$elementToTypeExpression$$inlined$suspendingQuery$1($cls, this$0, $collectedConstraints, $currentlyProcessing) {
    this.tqq_1 = $cls;
    this.uqq_1 = this$0;
    this.vqq_1 = $collectedConstraints;
    this.wqq_1 = $currentlyProcessing;
  }
  protoOf(TypeExpressionConverter$elementToTypeExpression$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_131(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(TypeExpressionConverter$elementToTypeExpression$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function TypeExpressionConverter$normalizeDefinedType$$inlined$suspendingQuery$1(this$0, $definition, $collectedConstraints, $currentlyProcessing) {
    this.mqr_1 = this$0;
    this.nqr_1 = $definition;
    this.oqr_1 = $collectedConstraints;
    this.pqr_1 = $currentlyProcessing;
  }
  protoOf(TypeExpressionConverter$normalizeDefinedType$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_132(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(TypeExpressionConverter$normalizeDefinedType$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function TypeExpressionConverter$normalizeNaturalType$$inlined$suspendingQuery$1(this$0, $cls, $collectedConstraints) {
    this.aqs_1 = this$0;
    this.bqs_1 = $cls;
    this.cqs_1 = $collectedConstraints;
  }
  protoOf(TypeExpressionConverter$normalizeNaturalType$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_133(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(TypeExpressionConverter$normalizeNaturalType$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function TypeExpressionConverter$getAllInherentProperties$$inlined$suspendingQuery$1() {
  }
  protoOf(TypeExpressionConverter$getAllInherentProperties$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    return emptyList();
  };
  protoOf(TypeExpressionConverter$getAllInherentProperties$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function TypeExpressionConverter$getAllInherentProperties$$inlined$suspendingQuery$2(this$0, $cls, $visitedParents) {
    this.sqs_1 = this$0;
    this.tqs_1 = $cls;
    this.uqs_1 = $visitedParents;
  }
  protoOf(TypeExpressionConverter$getAllInherentProperties$$inlined$suspendingQuery$2).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_134(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(TypeExpressionConverter$getAllInherentProperties$$inlined$suspendingQuery$2).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function TypeExpressionConverter$convertToDescriptor$$inlined$suspendingQuery$1($propertyConstraints, $baseDescriptor, this$0) {
    this.mqt_1 = $propertyConstraints;
    this.nqt_1 = $baseDescriptor;
    this.oqt_1 = this$0;
  }
  protoOf(TypeExpressionConverter$convertToDescriptor$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_135(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(TypeExpressionConverter$convertToDescriptor$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function TypeExpressionConverter$resolveConstraints$$inlined$suspendingQuery$1($propertyConstraints, this$0) {
    this.gqu_1 = $propertyConstraints;
    this.hqu_1 = this$0;
  }
  protoOf(TypeExpressionConverter$resolveConstraints$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_136(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(TypeExpressionConverter$resolveConstraints$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function TypeExpressionConverter$convertToValueConstraints$$inlined$suspendingQuery$1($constraints, this$0) {
    this.eqv_1 = $constraints;
    this.fqv_1 = this$0;
  }
  protoOf(TypeExpressionConverter$convertToValueConstraints$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_137(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(TypeExpressionConverter$convertToValueConstraints$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function TypeExpressionConverter() {
  }
  protoOf(TypeExpressionConverter).gqv = function (def, initialConstraints) {
    return toTypeExpression(this, def, initialConstraints, emptySet());
  };
  protoOf(TypeExpressionConverter).oq2 = function (constraints) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new TypeExpressionConverter$convertToValueConstraints$$inlined$suspendingQuery$1(constraints, this);
  };
  function ConstrainedElementDefinition$classes$$inlined$suspendingQuery$1(this$0) {
    this.hqv_1 = this$0;
  }
  protoOf(ConstrainedElementDefinition$classes$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    return this.hqv_1.iqv_1;
  };
  protoOf(ConstrainedElementDefinition$classes$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function ConstrainedElementDefinition$constraints$$inlined$suspendingQuery$1(this$0) {
    this.kqv_1 = this$0;
  }
  protoOf(ConstrainedElementDefinition$constraints$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    return this.kqv_1.jqv_1;
  };
  protoOf(ConstrainedElementDefinition$constraints$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function ConstrainedElementDefinition(componentClasses, propertyConstraints) {
    this.iqv_1 = componentClasses;
    this.jqv_1 = propertyConstraints;
  }
  protoOf(ConstrainedElementDefinition).mfu = function () {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new ConstrainedElementDefinition$classes$$inlined$suspendingQuery$1(this);
  };
  protoOf(ConstrainedElementDefinition).ofr = function () {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new ConstrainedElementDefinition$constraints$$inlined$suspendingQuery$1(this);
  };
  protoOf(ConstrainedElementDefinition).toString = function () {
    return 'ConstrainedElementDefinition(componentClasses=' + toString_1(this.iqv_1) + ', propertyConstraints=' + toString_1(this.jqv_1) + ')';
  };
  protoOf(ConstrainedElementDefinition).hashCode = function () {
    var result = hashCode(this.iqv_1);
    result = imul(result, 31) + hashCode(this.jqv_1) | 0;
    return result;
  };
  protoOf(ConstrainedElementDefinition).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ConstrainedElementDefinition))
      return false;
    if (!equals(this.iqv_1, other.iqv_1))
      return false;
    if (!equals(this.jqv_1, other.jqv_1))
      return false;
    return true;
  };
  function $runSuspendCOROUTINE$_138(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.tqv_1 = _this__u8e3s4;
    this.uqv_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_138).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 3;
            var $this$suspendingQuery = this.uqv_1;
            var cacheKey = to(this.tqv_1.yqv_1, this.tqv_1.zqv_1);
            this.xqv_1 = this.tqv_1.aqw_1.oqg_1;
            this.wqv_1 = cacheKey;
            var value = this.xqv_1.q2(this.wqv_1);
            if (value == null) {
              this.f9_1 = 1;
              suspendResult = $this$suspendingQuery.k60(this.tqv_1.aqw_1.nqg_1.gqv(this.tqv_1.yqv_1, this.tqv_1.zqv_1), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              var tmp_0 = this;
              tmp_0.vqv_1 = value;
              this.f9_1 = 2;
              continue $sm;
            }

          case 1:
            var typeExpression = suspendResult;
            var answer = this.tqv_1.aqw_1.mqg_1.vq2(typeExpression);
            this.xqv_1.t2(this.wqv_1, answer);
            this.vqv_1 = answer;
            this.f9_1 = 2;
            continue $sm;
          case 2:
            return this.vqv_1;
          case 3:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 3) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function TypeNormalizer$normalize$$inlined$suspendingQuery$1($descriptor, $initialConstraints, this$0) {
    this.yqv_1 = $descriptor;
    this.zqv_1 = $initialConstraints;
    this.aqw_1 = this$0;
  }
  protoOf(TypeNormalizer$normalize$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_138(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(TypeNormalizer$normalize$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function TypeNormalizer() {
    this.mqg_1 = new DnfNormalizer();
    this.nqg_1 = new TypeExpressionConverter();
    var tmp = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp.oqg_1 = LinkedHashMap_init_$Create$();
  }
  protoOf(TypeNormalizer).pqg = function (descriptor, initialConstraints, $completion) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new TypeNormalizer$normalize$$inlined$suspendingQuery$1(descriptor, initialConstraints, this);
  };
  function asSet($this, value) {
    var tmp;
    if (value instanceof SetValue) {
      tmp = value;
    } else {
      tmp = new SetValue(mapOf(to(value, new Known(1))), SetType_OPEN_getInstance());
    }
    return tmp;
  }
  function resultType($this, first, second) {
    var tmp;
    if (first.lpg_1.equals(SetType_CLOSED_getInstance()) && second.lpg_1.equals(SetType_CLOSED_getInstance())) {
      tmp = SetType_CLOSED_getInstance();
    } else {
      tmp = SetType_OPEN_getInstance();
    }
    return tmp;
  }
  function ValueDescriptorOperations() {
  }
  protoOf(ValueDescriptorOperations).uq2 = function (value1, value2) {
    if (value1 == null)
      return asSet(this, value2);
    var first = asSet(this, value1);
    var second = asSet(this, value2);
    var a = toMutableMap(first.kpg_1);
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s = second.kpg_1.y().m();
    while (_iterator__ex2g4s.n()) {
      var _destruct__k2r9zo = _iterator__ex2g4s.o();
      // Inline function 'kotlin.collections.component1' call
      var elem = _destruct__k2r9zo.z();
      // Inline function 'kotlin.collections.component2' call
      var cnt = _destruct__k2r9zo.a1();
      var tmp0_safe_receiver = a.q2(elem);
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : combine_1(tmp0_safe_receiver, cnt);
      // Inline function 'kotlin.collections.set' call
      var value = tmp1_elvis_lhs == null ? cnt : tmp1_elvis_lhs;
      a.t2(elem, value);
    }
    return new SetValue(a, resultType(this, first, second));
  };
  protoOf(ValueDescriptorOperations).bqw = function (value1, value2) {
    if (value1 == null)
      return new SetValue(emptyMap(), SetType_OPEN_getInstance());
    var first = asSet(this, value1);
    var second = asSet(this, value2);
    var a = toMutableMap(first.kpg_1);
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s = second.kpg_1.y().m();
    while (_iterator__ex2g4s.n()) {
      var _destruct__k2r9zo = _iterator__ex2g4s.o();
      // Inline function 'kotlin.collections.component1' call
      var elem = _destruct__k2r9zo.z();
      // Inline function 'kotlin.collections.component2' call
      var cnt = _destruct__k2r9zo.a1();
      var tmp0_safe_receiver = a.q2(elem);
      var newCnt = tmp0_safe_receiver == null ? null : subtract_2(tmp0_safe_receiver, cnt);
      if (!(newCnt == null)) {
        // Inline function 'kotlin.collections.set' call
        a.t2(elem, newCnt);
      } else
        a.u2(elem);
    }
    return new SetValue(a, resultType(this, first, second));
  };
  protoOf(ValueDescriptorOperations).sq2 = function (operation, baseValue, operationValue) {
    var tmp;
    switch (operation == null ? -1 : operation.x2_1) {
      case 0:
        tmp = this.uq2(baseValue, operationValue);
        break;
      case 1:
        tmp = this.bqw(baseValue, operationValue);
        break;
      case -1:
        tmp = operationValue;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  };
  var ValueDescriptorOperations_instance;
  function ValueDescriptorOperations_getInstance() {
    return ValueDescriptorOperations_instance;
  }
  function Companion_371() {
  }
  protoOf(Companion_371).i63 = function () {
    return $serializer_getInstance_34();
  };
  var Companion_instance_371;
  function Companion_getInstance_371() {
    return Companion_instance_371;
  }
  function $serializer_36() {
    $serializer_instance_34 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('jetbrains.biokb.findUsages.UsageDto', this, 4);
    tmp0_serialDesc.q5j('kind', false);
    tmp0_serialDesc.q5j('node', false);
    tmp0_serialDesc.q5j('referenceSourceNodeId', false);
    tmp0_serialDesc.q5j('propertyId', false);
    this.cqw_1 = tmp0_serialDesc;
  }
  protoOf($serializer_36).dqw = function (encoder, value) {
    var tmp0_desc = this.cqw_1;
    var tmp1_output = encoder.g5c(tmp0_desc);
    tmp1_output.u5d(tmp0_desc, 0, value.kind);
    tmp1_output.w5d(tmp0_desc, 1, $serializer_getInstance_30(), value.node);
    tmp1_output.u5d(tmp0_desc, 2, value.referenceSourceNodeId);
    tmp1_output.u5d(tmp0_desc, 3, value.propertyId);
    tmp1_output.h5c(tmp0_desc);
  };
  protoOf($serializer_36).i59 = function (encoder, value) {
    return this.dqw(encoder, value instanceof UsageDto ? value : THROW_CCE());
  };
  protoOf($serializer_36).j59 = function (decoder) {
    var tmp0_desc = this.cqw_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_input = decoder.g5c(tmp0_desc);
    if (tmp8_input.v5c()) {
      tmp4_local0 = tmp8_input.q5c(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.s5c(tmp0_desc, 1, $serializer_getInstance_30(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.q5c(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.q5c(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.w5c(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.q5c(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.s5c(tmp0_desc, 1, $serializer_getInstance_30(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.q5c(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.q5c(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp8_input.h5c(tmp0_desc);
    return UsageDto_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  };
  protoOf($serializer_36).v58 = function () {
    return this.cqw_1;
  };
  protoOf($serializer_36).f5k = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), $serializer_getInstance_30(), StringSerializer_getInstance(), StringSerializer_getInstance()];
  };
  var $serializer_instance_34;
  function $serializer_getInstance_34() {
    if ($serializer_instance_34 == null)
      new $serializer_36();
    return $serializer_instance_34;
  }
  function UsageDto_init_$Init$(seen0, kind, node, referenceSourceNodeId, propertyId, serializationConstructorMarker, $this) {
    if (!(15 === (15 & seen0))) {
      throwMissingFieldException(seen0, 15, $serializer_getInstance_34().cqw_1);
    }
    $this.kind = kind;
    $this.node = node;
    $this.referenceSourceNodeId = referenceSourceNodeId;
    $this.propertyId = propertyId;
    return $this;
  }
  function UsageDto_init_$Create$(seen0, kind, node, referenceSourceNodeId, propertyId, serializationConstructorMarker) {
    return UsageDto_init_$Init$(seen0, kind, node, referenceSourceNodeId, propertyId, serializationConstructorMarker, objectCreate(protoOf(UsageDto)));
  }
  function UsageDto(kind, node, referenceSourceNodeId, propertyId) {
    this.kind = kind;
    this.node = node;
    this.referenceSourceNodeId = referenceSourceNodeId;
    this.propertyId = propertyId;
  }
  protoOf(UsageDto).r5a = function () {
    return this.kind;
  };
  protoOf(UsageDto).w85 = function () {
    return this.node;
  };
  protoOf(UsageDto).eqw = function () {
    return this.referenceSourceNodeId;
  };
  protoOf(UsageDto).j3n = function () {
    return this.propertyId;
  };
  protoOf(UsageDto).fg = function () {
    return this.kind;
  };
  protoOf(UsageDto).gg = function () {
    return this.node;
  };
  protoOf(UsageDto).zl = function () {
    return this.referenceSourceNodeId;
  };
  protoOf(UsageDto).b2d = function () {
    return this.propertyId;
  };
  protoOf(UsageDto).fqw = function (kind, node, referenceSourceNodeId, propertyId) {
    return new UsageDto(kind, node, referenceSourceNodeId, propertyId);
  };
  protoOf(UsageDto).copy = function (kind, node, referenceSourceNodeId, propertyId, $super) {
    kind = kind === VOID ? this.kind : kind;
    node = node === VOID ? this.node : node;
    referenceSourceNodeId = referenceSourceNodeId === VOID ? this.referenceSourceNodeId : referenceSourceNodeId;
    propertyId = propertyId === VOID ? this.propertyId : propertyId;
    return $super === VOID ? this.fqw(kind, node, referenceSourceNodeId, propertyId) : $super.fqw.call(this, kind, node, referenceSourceNodeId, propertyId);
  };
  protoOf(UsageDto).toString = function () {
    return 'UsageDto(kind=' + this.kind + ', node=' + this.node.toString() + ', referenceSourceNodeId=' + this.referenceSourceNodeId + ', propertyId=' + this.propertyId + ')';
  };
  protoOf(UsageDto).hashCode = function () {
    var result = getStringHashCode(this.kind);
    result = imul(result, 31) + this.node.hashCode() | 0;
    result = imul(result, 31) + getStringHashCode(this.referenceSourceNodeId) | 0;
    result = imul(result, 31) + getStringHashCode(this.propertyId) | 0;
    return result;
  };
  protoOf(UsageDto).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof UsageDto))
      return false;
    if (!(this.kind === other.kind))
      return false;
    if (!this.node.equals(other.node))
      return false;
    if (!(this.referenceSourceNodeId === other.referenceSourceNodeId))
      return false;
    if (!(this.propertyId === other.propertyId))
      return false;
    return true;
  };
  function Companion_372() {
  }
  var Companion_instance_372;
  function Companion_getInstance_372() {
    return Companion_instance_372;
  }
  function $serializer_37() {
    $serializer_instance_35 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('jetbrains.biokb.pubMedImport.PubMedPaperLoadResultDto', this, 2);
    tmp0_serialDesc.q5j('referenceValue', false);
    tmp0_serialDesc.q5j('errorMessage', false);
    this.gqw_1 = tmp0_serialDesc;
  }
  protoOf($serializer_37).hqw = function (encoder, value) {
    var tmp0_desc = this.gqw_1;
    var tmp1_output = encoder.g5c(tmp0_desc);
    tmp1_output.x5d(tmp0_desc, 0, $serializer_getInstance_2(), value.iqw_1);
    tmp1_output.x5d(tmp0_desc, 1, StringSerializer_getInstance(), value.jqw_1);
    tmp1_output.h5c(tmp0_desc);
  };
  protoOf($serializer_37).i59 = function (encoder, value) {
    return this.hqw(encoder, value instanceof PubMedPaperLoadResultDto ? value : THROW_CCE());
  };
  protoOf($serializer_37).j59 = function (decoder) {
    var tmp0_desc = this.gqw_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.g5c(tmp0_desc);
    if (tmp6_input.v5c()) {
      tmp4_local0 = tmp6_input.u5c(tmp0_desc, 0, $serializer_getInstance_2(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.u5c(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.w5c(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.u5c(tmp0_desc, 0, $serializer_getInstance_2(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.u5c(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.h5c(tmp0_desc);
    return PubMedPaperLoadResultDto_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_37).v58 = function () {
    return this.gqw_1;
  };
  protoOf($serializer_37).f5k = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable($serializer_getInstance_2()), get_nullable(StringSerializer_getInstance())];
  };
  var $serializer_instance_35;
  function $serializer_getInstance_35() {
    if ($serializer_instance_35 == null)
      new $serializer_37();
    return $serializer_instance_35;
  }
  function PubMedPaperLoadResultDto_init_$Init$(seen0, referenceValue, errorMessage, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_35().gqw_1);
    }
    $this.iqw_1 = referenceValue;
    $this.jqw_1 = errorMessage;
    return $this;
  }
  function PubMedPaperLoadResultDto_init_$Create$(seen0, referenceValue, errorMessage, serializationConstructorMarker) {
    return PubMedPaperLoadResultDto_init_$Init$(seen0, referenceValue, errorMessage, serializationConstructorMarker, objectCreate(protoOf(PubMedPaperLoadResultDto)));
  }
  function PubMedPaperLoadResultDto(referenceValue, errorMessage) {
    this.iqw_1 = referenceValue;
    this.jqw_1 = errorMessage;
  }
  function DocPersistence(nodeFactory) {
    this.kqw_1 = new Json2NodeConverter(new NodeIdPersistenceContext(), nodeFactory);
  }
  protoOf(DocPersistence).lqw = function (doc) {
    return (new Node2JsonConverter(new NodeIdPersistenceContext())).b3n(doc).toString();
  };
  protoOf(DocPersistence).mqw = function (jsonString, attach) {
    var jsonBytes = encodeToByteArray(jsonString);
    var tmp = CommonJsonStreamIterSupport_instance.h2l(jsonBytes);
    var jsonArrayReader = isInterface(tmp, JsonArrayReader) ? tmp : THROW_CCE();
    // Inline function 'kotlin.also' call
    var this_0 = this.kqw_1.w3l(jsonArrayReader);
    if (attach) {
      new Model(this_0);
    }
    return this_0;
  };
  protoOf(DocPersistence).nqw = function (jsonString, attach, $super) {
    attach = attach === VOID ? true : attach;
    return $super === VOID ? this.mqw(jsonString, attach) : $super.mqw.call(this, jsonString, attach);
  };
  function get_docPersistence(_this__u8e3s4) {
    return _this__u8e3s4.zde_1.c6y() ? new DocPersistence(_this__u8e3s4.hdf_1) : RawDocPersistence_getInstance();
  }
  function RawDocPersistence() {
    RawDocPersistence_instance = this;
    DocPersistence.call(this, RawNodeFactory_instance);
  }
  var RawDocPersistence_instance;
  function RawDocPersistence_getInstance() {
    if (RawDocPersistence_instance == null)
      new RawDocPersistence();
    return RawDocPersistence_instance;
  }
  function HandlerRegistration() {
  }
  function Events() {
    this.oqw_1 = new CopyOnWriteHashMap();
  }
  protoOf(Events).pqw = function (definition, value) {
    var exception = null;
    var tmp0_safe_receiver = this.oqw_1.zdw(definition);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'io.ktor.util.internal.LockFreeLinkedListHead.forEach' call
      var tmp = tmp0_safe_receiver.h12();
      var cur = tmp instanceof LockFreeLinkedListNode ? tmp : THROW_CCE();
      while (!equals(cur, tmp0_safe_receiver)) {
        if (cur instanceof HandlerRegistration) {
          var registration = cur;
          try {
            var tmp_0 = registration.rqw_1;
            (typeof tmp_0 === 'function' ? tmp_0 : THROW_CCE())(value);
          } catch ($p) {
            if ($p instanceof Error) {
              var e = $p;
              var tmp0_safe_receiver_0 = exception;
              var tmp_1;
              if (tmp0_safe_receiver_0 == null) {
                tmp_1 = null;
              } else {
                addSuppressed(tmp0_safe_receiver_0, e);
                tmp_1 = Unit_instance;
              }
              if (tmp_1 == null) {
                // Inline function 'kotlin.run' call
                exception = e;
              }
            } else {
              throw $p;
            }
          }
        }
        cur = cur.tdx();
      }
    }
    var tmp1_safe_receiver = exception;
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      throw tmp1_safe_receiver;
    }
  };
  function EventDefinition() {
  }
  function get_URL_ALPHABET() {
    _init_properties_Codecs_kt__fudxxf();
    return URL_ALPHABET;
  }
  var URL_ALPHABET;
  function get_URL_ALPHABET_CHARS() {
    _init_properties_Codecs_kt__fudxxf();
    return URL_ALPHABET_CHARS;
  }
  var URL_ALPHABET_CHARS;
  function get_HEX_ALPHABET() {
    _init_properties_Codecs_kt__fudxxf();
    return HEX_ALPHABET;
  }
  var HEX_ALPHABET;
  function get_URL_PROTOCOL_PART() {
    _init_properties_Codecs_kt__fudxxf();
    return URL_PROTOCOL_PART;
  }
  var URL_PROTOCOL_PART;
  function get_VALID_PATH_PART() {
    _init_properties_Codecs_kt__fudxxf();
    return VALID_PATH_PART;
  }
  var VALID_PATH_PART;
  var ATTRIBUTE_CHARACTERS;
  function get_SPECIAL_SYMBOLS() {
    _init_properties_Codecs_kt__fudxxf();
    return SPECIAL_SYMBOLS;
  }
  var SPECIAL_SYMBOLS;
  function encodeURLParameter(_this__u8e3s4, spaceToPlus) {
    spaceToPlus = spaceToPlus === VOID ? false : spaceToPlus;
    _init_properties_Codecs_kt__fudxxf();
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder_init_$Create$_1();
    var content = encode(Charsets_getInstance().udq_1.ydq(), _this__u8e3s4);
    forEach_0(content, encodeURLParameter$lambda(this_0, spaceToPlus));
    return this_0.toString();
  }
  function decodeURLPart(_this__u8e3s4, start, end, charset) {
    start = start === VOID ? 0 : start;
    end = end === VOID ? _this__u8e3s4.length : end;
    charset = charset === VOID ? Charsets_getInstance().udq_1 : charset;
    _init_properties_Codecs_kt__fudxxf();
    return decodeScan(_this__u8e3s4, start, end, false, charset);
  }
  function encodeURLQueryComponent(_this__u8e3s4, encodeFull, spaceToPlus, charset) {
    encodeFull = encodeFull === VOID ? false : encodeFull;
    spaceToPlus = spaceToPlus === VOID ? false : spaceToPlus;
    charset = charset === VOID ? Charsets_getInstance().udq_1 : charset;
    _init_properties_Codecs_kt__fudxxf();
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder_init_$Create$_1();
    var content = encode(charset.ydq(), _this__u8e3s4);
    forEach_0(content, encodeURLQueryComponent$lambda(spaceToPlus, this_0, encodeFull));
    return this_0.toString();
  }
  function decodeURLQueryComponent(_this__u8e3s4, start, end, plusIsSpace, charset) {
    start = start === VOID ? 0 : start;
    end = end === VOID ? _this__u8e3s4.length : end;
    plusIsSpace = plusIsSpace === VOID ? false : plusIsSpace;
    charset = charset === VOID ? Charsets_getInstance().udq_1 : charset;
    _init_properties_Codecs_kt__fudxxf();
    return decodeScan(_this__u8e3s4, start, end, plusIsSpace, charset);
  }
  function encodeURLPathPart(_this__u8e3s4) {
    _init_properties_Codecs_kt__fudxxf();
    return encodeURLPath(_this__u8e3s4, true);
  }
  function encodeURLParameterValue(_this__u8e3s4) {
    _init_properties_Codecs_kt__fudxxf();
    return encodeURLParameter(_this__u8e3s4, true);
  }
  function forEach_0(_this__u8e3s4, block) {
    _init_properties_Codecs_kt__fudxxf();
    $l$block: {
      // Inline function 'io.ktor.utils.io.core.takeWhile' call
      var release = true;
      var tmp0_elvis_lhs = prepareReadFirstHead(_this__u8e3s4, 1);
      var tmp;
      if (tmp0_elvis_lhs == null) {
        break $l$block;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var current = tmp;
      try {
        $l$loop_1: do {
          var buffer = current;
          $l$loop: while (true) {
            // Inline function 'io.ktor.utils.io.core.canRead' call
            if (!(buffer.pdi_1 > buffer.odi_1)) {
              break $l$loop;
            }
            block(buffer.zdn());
          }
          if (!true) {
            break $l$loop_1;
          }
          release = false;
          var tmp1_elvis_lhs = prepareReadNextHead(_this__u8e3s4, current);
          var tmp_0;
          if (tmp1_elvis_lhs == null) {
            break $l$loop_1;
          } else {
            tmp_0 = tmp1_elvis_lhs;
          }
          var next = tmp_0;
          current = next;
          release = true;
        }
         while (true);
      }finally {
        if (release) {
          completeReadHead(_this__u8e3s4, current);
        }
      }
    }
  }
  function percentEncode(_this__u8e3s4) {
    _init_properties_Codecs_kt__fudxxf();
    var code = _this__u8e3s4 & 255;
    var array = charArray(3);
    array[0] = _Char___init__impl__6a9atx(37);
    array[1] = hexDigitToChar(code >> 4);
    array[2] = hexDigitToChar(code & 15);
    return concatToString(array);
  }
  function decodeScan(_this__u8e3s4, start, end, plusIsSpace, charset) {
    _init_properties_Codecs_kt__fudxxf();
    var inductionVariable = start;
    if (inductionVariable < end)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var ch = charCodeAt(_this__u8e3s4, index);
        if (ch === _Char___init__impl__6a9atx(37) || (plusIsSpace && ch === _Char___init__impl__6a9atx(43))) {
          return decodeImpl(_this__u8e3s4, start, end, index, plusIsSpace, charset);
        }
      }
       while (inductionVariable < end);
    return start === 0 && end === _this__u8e3s4.length ? toString_1(_this__u8e3s4) : substring(_this__u8e3s4, start, end);
  }
  function encodeURLPath(_this__u8e3s4, encodeSlash) {
    _init_properties_Codecs_kt__fudxxf();
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder_init_$Create$_1();
    var charset = Charsets_getInstance().udq_1;
    var index = 0;
    $l$loop_0: while (index < _this__u8e3s4.length) {
      var current = charCodeAt(_this__u8e3s4, index);
      if (!encodeSlash && current === _Char___init__impl__6a9atx(47) || get_URL_ALPHABET_CHARS().t(new Char(current)) || get_VALID_PATH_PART().t(new Char(current))) {
        this_0.k8(current);
        index = index + 1 | 0;
        continue $l$loop_0;
      }
      if (current === _Char___init__impl__6a9atx(37) && (index + 2 | 0) < _this__u8e3s4.length && get_HEX_ALPHABET().t(new Char(charCodeAt(_this__u8e3s4, index + 1 | 0))) && get_HEX_ALPHABET().t(new Char(charCodeAt(_this__u8e3s4, index + 2 | 0)))) {
        this_0.k8(current);
        this_0.k8(charCodeAt(_this__u8e3s4, index + 1 | 0));
        this_0.k8(charCodeAt(_this__u8e3s4, index + 2 | 0));
        index = index + 3 | 0;
        continue $l$loop_0;
      }
      var symbolSize = isSurrogate(current) ? 2 : 1;
      var tmp = encode(charset.ydq(), _this__u8e3s4, index, index + symbolSize | 0);
      forEach_0(tmp, encodeURLPath$lambda(this_0));
      index = index + symbolSize | 0;
    }
    return this_0.toString();
  }
  function hexDigitToChar(digit) {
    _init_properties_Codecs_kt__fudxxf();
    return (0 <= digit ? digit <= 9 : false) ? Char__plus_impl_qi7pgj(_Char___init__impl__6a9atx(48), digit) : Char__minus_impl_a2frrh_0(Char__plus_impl_qi7pgj(_Char___init__impl__6a9atx(65), digit), 10);
  }
  function decodeImpl(_this__u8e3s4, start, end, prefixEnd, plusIsSpace, charset) {
    _init_properties_Codecs_kt__fudxxf();
    var length = end - start | 0;
    var sbSize = length > 255 ? length / 3 | 0 : length;
    var sb = StringBuilder_init_$Create$(sbSize);
    if (prefixEnd > start) {
      sb.ec(_this__u8e3s4, start, prefixEnd);
    }
    var index = prefixEnd;
    var bytes = null;
    while (index < end) {
      var c = charSequenceGet(_this__u8e3s4, index);
      if (plusIsSpace && c === _Char___init__impl__6a9atx(43)) {
        sb.k8(_Char___init__impl__6a9atx(32));
        index = index + 1 | 0;
      } else if (c === _Char___init__impl__6a9atx(37)) {
        if (bytes == null) {
          bytes = new Int8Array((end - index | 0) / 3 | 0);
        }
        var count = 0;
        while (index < end && charSequenceGet(_this__u8e3s4, index) === _Char___init__impl__6a9atx(37)) {
          if ((index + 2 | 0) >= end) {
            // Inline function 'kotlin.text.substring' call
            var startIndex = index;
            var endIndex = charSequenceLength(_this__u8e3s4);
            var tmp$ret$0 = toString_1(charSequenceSubSequence(_this__u8e3s4, startIndex, endIndex));
            throw new URLDecodeException('Incomplete trailing HEX escape: ' + tmp$ret$0 + ', in ' + toString_1(_this__u8e3s4) + ' at ' + index);
          }
          var digit1 = charToHexDigit(charSequenceGet(_this__u8e3s4, index + 1 | 0));
          var digit2 = charToHexDigit(charSequenceGet(_this__u8e3s4, index + 2 | 0));
          if (digit1 === -1 || digit2 === -1) {
            throw new URLDecodeException('Wrong HEX escape: %' + toString(charSequenceGet(_this__u8e3s4, index + 1 | 0)) + toString(charSequenceGet(_this__u8e3s4, index + 2 | 0)) + ', in ' + toString_1(_this__u8e3s4) + ', at ' + index);
          }
          var tmp = bytes;
          var tmp1 = count;
          count = tmp1 + 1 | 0;
          tmp[tmp1] = toByte(imul(digit1, 16) + digit2 | 0);
          index = index + 3 | 0;
        }
        sb.j8(String_0(bytes, 0, count, charset));
      } else {
        sb.k8(c);
        index = index + 1 | 0;
      }
    }
    return sb.toString();
  }
  function URLDecodeException(message) {
    Exception_init_$Init$_0(message, this);
    captureStack(this, URLDecodeException);
  }
  function charToHexDigit(c2) {
    _init_properties_Codecs_kt__fudxxf();
    return (_Char___init__impl__6a9atx(48) <= c2 ? c2 <= _Char___init__impl__6a9atx(57) : false) ? Char__minus_impl_a2frrh(c2, _Char___init__impl__6a9atx(48)) : (_Char___init__impl__6a9atx(65) <= c2 ? c2 <= _Char___init__impl__6a9atx(70) : false) ? Char__minus_impl_a2frrh(c2, _Char___init__impl__6a9atx(65)) + 10 | 0 : (_Char___init__impl__6a9atx(97) <= c2 ? c2 <= _Char___init__impl__6a9atx(102) : false) ? Char__minus_impl_a2frrh(c2, _Char___init__impl__6a9atx(97)) + 10 | 0 : -1;
  }
  function encodeURLParameter$lambda($$this$buildString, $spaceToPlus) {
    return function (it) {
      var tmp;
      if (get_URL_ALPHABET().t(it) || get_SPECIAL_SYMBOLS().t(it)) {
        $$this$buildString.k8(numberToChar(it));
        tmp = Unit_instance;
      } else {
        var tmp_0;
        if ($spaceToPlus) {
          var tmp_1 = it;
          // Inline function 'kotlin.code' call
          var this_0 = _Char___init__impl__6a9atx(32);
          var tmp$ret$0 = Char__toInt_impl_vasixd(this_0);
          tmp_0 = tmp_1 === toByte(tmp$ret$0);
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          $$this$buildString.k8(_Char___init__impl__6a9atx(43));
          tmp = Unit_instance;
        } else {
          $$this$buildString.j8(percentEncode(it));
          tmp = Unit_instance;
        }
      }
      return Unit_instance;
    };
  }
  function encodeURLQueryComponent$lambda($spaceToPlus, $$this$buildString, $encodeFull) {
    return function (it) {
      var tmp;
      var tmp_0 = it;
      // Inline function 'kotlin.code' call
      var this_0 = _Char___init__impl__6a9atx(32);
      var tmp$ret$0 = Char__toInt_impl_vasixd(this_0);
      if (tmp_0 === toByte(tmp$ret$0)) {
        var tmp_1;
        if ($spaceToPlus) {
          $$this$buildString.k8(_Char___init__impl__6a9atx(43));
          tmp_1 = Unit_instance;
        } else {
          $$this$buildString.j8('%20');
          tmp_1 = Unit_instance;
        }
        tmp = tmp_1;
      } else {
        if (get_URL_ALPHABET().t(it) || (!$encodeFull && get_URL_PROTOCOL_PART().t(it))) {
          $$this$buildString.k8(numberToChar(it));
          tmp = Unit_instance;
        } else {
          $$this$buildString.j8(percentEncode(it));
          tmp = Unit_instance;
        }
      }
      return Unit_instance;
    };
  }
  function encodeURLPath$lambda($$this$buildString) {
    return function (it) {
      $$this$buildString.j8(percentEncode(it));
      return Unit_instance;
    };
  }
  var properties_initialized_Codecs_kt_hkj9s1;
  function _init_properties_Codecs_kt__fudxxf() {
    if (!properties_initialized_Codecs_kt_hkj9s1) {
      properties_initialized_Codecs_kt_hkj9s1 = true;
      // Inline function 'kotlin.collections.map' call
      var this_0 = plus_5(plus_8(Char__rangeTo_impl_tkncvp(_Char___init__impl__6a9atx(97), _Char___init__impl__6a9atx(122)), Char__rangeTo_impl_tkncvp(_Char___init__impl__6a9atx(65), _Char___init__impl__6a9atx(90))), Char__rangeTo_impl_tkncvp(_Char___init__impl__6a9atx(48), _Char___init__impl__6a9atx(57)));
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
      var _iterator__ex2g4s = this_0.m();
      while (_iterator__ex2g4s.n()) {
        var item = _iterator__ex2g4s.o();
        // Inline function 'kotlin.code' call
        var this_1 = item.s1_1;
        var tmp$ret$0 = Char__toInt_impl_vasixd(this_1);
        var tmp$ret$1 = toByte(tmp$ret$0);
        destination.j(tmp$ret$1);
      }
      URL_ALPHABET = toSet_0(destination);
      URL_ALPHABET_CHARS = toSet_0(plus_5(plus_8(Char__rangeTo_impl_tkncvp(_Char___init__impl__6a9atx(97), _Char___init__impl__6a9atx(122)), Char__rangeTo_impl_tkncvp(_Char___init__impl__6a9atx(65), _Char___init__impl__6a9atx(90))), Char__rangeTo_impl_tkncvp(_Char___init__impl__6a9atx(48), _Char___init__impl__6a9atx(57))));
      HEX_ALPHABET = toSet_0(plus_5(plus_8(Char__rangeTo_impl_tkncvp(_Char___init__impl__6a9atx(97), _Char___init__impl__6a9atx(102)), Char__rangeTo_impl_tkncvp(_Char___init__impl__6a9atx(65), _Char___init__impl__6a9atx(70))), Char__rangeTo_impl_tkncvp(_Char___init__impl__6a9atx(48), _Char___init__impl__6a9atx(57))));
      // Inline function 'kotlin.collections.map' call
      var this_2 = setOf_0([new Char(_Char___init__impl__6a9atx(58)), new Char(_Char___init__impl__6a9atx(47)), new Char(_Char___init__impl__6a9atx(63)), new Char(_Char___init__impl__6a9atx(35)), new Char(_Char___init__impl__6a9atx(91)), new Char(_Char___init__impl__6a9atx(93)), new Char(_Char___init__impl__6a9atx(64)), new Char(_Char___init__impl__6a9atx(33)), new Char(_Char___init__impl__6a9atx(36)), new Char(_Char___init__impl__6a9atx(38)), new Char(_Char___init__impl__6a9atx(39)), new Char(_Char___init__impl__6a9atx(40)), new Char(_Char___init__impl__6a9atx(41)), new Char(_Char___init__impl__6a9atx(42)), new Char(_Char___init__impl__6a9atx(44)), new Char(_Char___init__impl__6a9atx(59)), new Char(_Char___init__impl__6a9atx(61)), new Char(_Char___init__impl__6a9atx(45)), new Char(_Char___init__impl__6a9atx(46)), new Char(_Char___init__impl__6a9atx(95)), new Char(_Char___init__impl__6a9atx(126)), new Char(_Char___init__impl__6a9atx(43))]);
      // Inline function 'kotlin.collections.mapTo' call
      var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_2, 10));
      var _iterator__ex2g4s_0 = this_2.m();
      while (_iterator__ex2g4s_0.n()) {
        var item_0 = _iterator__ex2g4s_0.o();
        // Inline function 'kotlin.code' call
        var this_3 = item_0.s1_1;
        var tmp$ret$0_0 = Char__toInt_impl_vasixd(this_3);
        var tmp$ret$1_0 = toByte(tmp$ret$0_0);
        destination_0.j(tmp$ret$1_0);
      }
      URL_PROTOCOL_PART = destination_0;
      VALID_PATH_PART = setOf_0([new Char(_Char___init__impl__6a9atx(58)), new Char(_Char___init__impl__6a9atx(64)), new Char(_Char___init__impl__6a9atx(33)), new Char(_Char___init__impl__6a9atx(36)), new Char(_Char___init__impl__6a9atx(38)), new Char(_Char___init__impl__6a9atx(39)), new Char(_Char___init__impl__6a9atx(40)), new Char(_Char___init__impl__6a9atx(41)), new Char(_Char___init__impl__6a9atx(42)), new Char(_Char___init__impl__6a9atx(43)), new Char(_Char___init__impl__6a9atx(44)), new Char(_Char___init__impl__6a9atx(59)), new Char(_Char___init__impl__6a9atx(61)), new Char(_Char___init__impl__6a9atx(45)), new Char(_Char___init__impl__6a9atx(46)), new Char(_Char___init__impl__6a9atx(95)), new Char(_Char___init__impl__6a9atx(126))]);
      ATTRIBUTE_CHARACTERS = plus_10(get_URL_ALPHABET_CHARS(), setOf_0([new Char(_Char___init__impl__6a9atx(33)), new Char(_Char___init__impl__6a9atx(35)), new Char(_Char___init__impl__6a9atx(36)), new Char(_Char___init__impl__6a9atx(38)), new Char(_Char___init__impl__6a9atx(43)), new Char(_Char___init__impl__6a9atx(45)), new Char(_Char___init__impl__6a9atx(46)), new Char(_Char___init__impl__6a9atx(94)), new Char(_Char___init__impl__6a9atx(95)), new Char(_Char___init__impl__6a9atx(96)), new Char(_Char___init__impl__6a9atx(124)), new Char(_Char___init__impl__6a9atx(126))]));
      // Inline function 'kotlin.collections.map' call
      var this_4 = listOf_0([new Char(_Char___init__impl__6a9atx(45)), new Char(_Char___init__impl__6a9atx(46)), new Char(_Char___init__impl__6a9atx(95)), new Char(_Char___init__impl__6a9atx(126))]);
      // Inline function 'kotlin.collections.mapTo' call
      var destination_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_4, 10));
      var _iterator__ex2g4s_1 = this_4.m();
      while (_iterator__ex2g4s_1.n()) {
        var item_1 = _iterator__ex2g4s_1.o();
        // Inline function 'kotlin.code' call
        var this_5 = item_1.s1_1;
        var tmp$ret$0_1 = Char__toInt_impl_vasixd(this_5);
        var tmp$ret$1_1 = toByte(tmp$ret$0_1);
        destination_1.j(tmp$ret$1_1);
      }
      SPECIAL_SYMBOLS = destination_1;
    }
  }
  function ContentType_init_$Init$(contentType, contentSubtype, parameters, $this) {
    parameters = parameters === VOID ? emptyList() : parameters;
    ContentType.call($this, contentType, contentSubtype, contentType + '/' + contentSubtype, parameters);
    return $this;
  }
  function ContentType_init_$Create$(contentType, contentSubtype, parameters) {
    return ContentType_init_$Init$(contentType, contentSubtype, parameters, objectCreate(protoOf(ContentType)));
  }
  function hasParameter($this, name, value) {
    var tmp;
    switch ($this.tqw_1.p()) {
      case 0:
        tmp = false;
        break;
      case 1:
        // Inline function 'kotlin.let' call

        var it = $this.tqw_1.r(0);
        tmp = (equals_0(it.uqw_1, name, true) && equals_0(it.vqw_1, value, true));
        break;
      default:
        var tmp0 = $this.tqw_1;
        var tmp$ret$2;
        $l$block_0: {
          // Inline function 'kotlin.collections.any' call
          var tmp_0;
          if (isInterface(tmp0, Collection)) {
            tmp_0 = tmp0.s();
          } else {
            tmp_0 = false;
          }
          if (tmp_0) {
            tmp$ret$2 = false;
            break $l$block_0;
          }
          var _iterator__ex2g4s = tmp0.m();
          while (_iterator__ex2g4s.n()) {
            var element = _iterator__ex2g4s.o();
            if (equals_0(element.uqw_1, name, true) && equals_0(element.vqw_1, value, true)) {
              tmp$ret$2 = true;
              break $l$block_0;
            }
          }
          tmp$ret$2 = false;
        }

        tmp = tmp$ret$2;
        break;
    }
    return tmp;
  }
  function Companion_373() {
    Companion_instance_373 = this;
    this.xqw_1 = ContentType_init_$Create$('*', '*');
  }
  protoOf(Companion_373).z2g = function (value) {
    if (isBlank(value))
      return this.xqw_1;
    // Inline function 'io.ktor.http.Companion.parse' call
    var headerValue = last(parseHeaderValue(value));
    var tmp0 = headerValue.yqw_1;
    var parameters = headerValue.zqw_1;
    var slash = indexOf_8(tmp0, _Char___init__impl__6a9atx(47));
    if (slash === -1) {
      // Inline function 'kotlin.text.trim' call
      if (toString_1(trim(isCharSequence(tmp0) ? tmp0 : THROW_CCE())) === '*')
        return Companion_getInstance_373().xqw_1;
      throw new BadContentTypeFormatException(value);
    }
    // Inline function 'kotlin.text.trim' call
    var this_0 = substring(tmp0, 0, slash);
    var type = toString_1(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(type) === 0) {
      throw new BadContentTypeFormatException(value);
    }
    // Inline function 'kotlin.text.trim' call
    var this_1 = substring_0(tmp0, slash + 1 | 0);
    var subtype = toString_1(trim(isCharSequence(this_1) ? this_1 : THROW_CCE()));
    if (contains_9(type, _Char___init__impl__6a9atx(32)) || contains_9(subtype, _Char___init__impl__6a9atx(32))) {
      throw new BadContentTypeFormatException(value);
    }
    var tmp;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(subtype) === 0) {
      tmp = true;
    } else {
      tmp = contains_9(subtype, _Char___init__impl__6a9atx(47));
    }
    if (tmp) {
      throw new BadContentTypeFormatException(value);
    }
    return ContentType_init_$Create$(type, subtype, parameters);
  };
  var Companion_instance_373;
  function Companion_getInstance_373() {
    if (Companion_instance_373 == null)
      new Companion_373();
    return Companion_instance_373;
  }
  function Application() {
    Application_instance = this;
    this.bqx_1 = ContentType_init_$Create$('application', '*');
    this.cqx_1 = ContentType_init_$Create$('application', 'atom+xml');
    this.dqx_1 = ContentType_init_$Create$('application', 'cbor');
    this.eqx_1 = ContentType_init_$Create$('application', 'json');
    this.fqx_1 = ContentType_init_$Create$('application', 'hal+json');
    this.gqx_1 = ContentType_init_$Create$('application', 'javascript');
    this.hqx_1 = ContentType_init_$Create$('application', 'octet-stream');
    this.iqx_1 = ContentType_init_$Create$('application', 'rss+xml');
    this.jqx_1 = ContentType_init_$Create$('application', 'xml');
    this.kqx_1 = ContentType_init_$Create$('application', 'xml-dtd');
    this.lqx_1 = ContentType_init_$Create$('application', 'zip');
    this.mqx_1 = ContentType_init_$Create$('application', 'gzip');
    this.nqx_1 = ContentType_init_$Create$('application', 'x-www-form-urlencoded');
    this.oqx_1 = ContentType_init_$Create$('application', 'pdf');
    this.pqx_1 = ContentType_init_$Create$('application', 'vnd.openxmlformats-officedocument.spreadsheetml.sheet');
    this.qqx_1 = ContentType_init_$Create$('application', 'vnd.openxmlformats-officedocument.wordprocessingml.document');
    this.rqx_1 = ContentType_init_$Create$('application', 'vnd.openxmlformats-officedocument.presentationml.presentation');
    this.sqx_1 = ContentType_init_$Create$('application', 'protobuf');
    this.tqx_1 = ContentType_init_$Create$('application', 'wasm');
    this.uqx_1 = ContentType_init_$Create$('application', 'problem+json');
    this.vqx_1 = ContentType_init_$Create$('application', 'problem+xml');
  }
  var Application_instance;
  function Application_getInstance() {
    if (Application_instance == null)
      new Application();
    return Application_instance;
  }
  function Text_0() {
    Text_instance = this;
    this.wqx_1 = ContentType_init_$Create$('text', '*');
    this.xqx_1 = ContentType_init_$Create$('text', 'plain');
    this.yqx_1 = ContentType_init_$Create$('text', 'css');
    this.zqx_1 = ContentType_init_$Create$('text', 'csv');
    this.aqy_1 = ContentType_init_$Create$('text', 'html');
    this.bqy_1 = ContentType_init_$Create$('text', 'javascript');
    this.cqy_1 = ContentType_init_$Create$('text', 'vcard');
    this.dqy_1 = ContentType_init_$Create$('text', 'xml');
    this.eqy_1 = ContentType_init_$Create$('text', 'event-stream');
  }
  var Text_instance;
  function Text_getInstance() {
    if (Text_instance == null)
      new Text_0();
    return Text_instance;
  }
  function ContentType(contentType, contentSubtype, existingContent, parameters) {
    Companion_getInstance_373();
    parameters = parameters === VOID ? emptyList() : parameters;
    HeaderValueWithParameters.call(this, existingContent, parameters);
    this.hqy_1 = contentType;
    this.iqy_1 = contentSubtype;
  }
  protoOf(ContentType).jqy = function (name, value) {
    if (hasParameter(this, name, value))
      return this;
    return new ContentType(this.hqy_1, this.iqy_1, this.sqw_1, plus_6(this.tqw_1, HeaderValueParam_init_$Create$(name, value)));
  };
  protoOf(ContentType).kqy = function () {
    return this.tqw_1.s() ? this : ContentType_init_$Create$(this.hqy_1, this.iqy_1);
  };
  protoOf(ContentType).lqy = function (pattern) {
    if (!(pattern.hqy_1 === '*') && !equals_0(pattern.hqy_1, this.hqy_1, true)) {
      return false;
    }
    if (!(pattern.iqy_1 === '*') && !equals_0(pattern.iqy_1, this.iqy_1, true)) {
      return false;
    }
    var tmp0_iterator = pattern.tqw_1.m();
    while (tmp0_iterator.n()) {
      var tmp1_loop_parameter = tmp0_iterator.o();
      var patternName = tmp1_loop_parameter.fg();
      var patternValue = tmp1_loop_parameter.gg();
      var tmp;
      if (patternName === '*') {
        var tmp_0;
        if (patternValue === '*') {
          tmp_0 = true;
        } else {
          var tmp0 = this.tqw_1;
          var tmp$ret$0;
          $l$block_0: {
            // Inline function 'kotlin.collections.any' call
            var tmp_1;
            if (isInterface(tmp0, Collection)) {
              tmp_1 = tmp0.s();
            } else {
              tmp_1 = false;
            }
            if (tmp_1) {
              tmp$ret$0 = false;
              break $l$block_0;
            }
            var _iterator__ex2g4s = tmp0.m();
            while (_iterator__ex2g4s.n()) {
              var element = _iterator__ex2g4s.o();
              if (equals_0(element.vqw_1, patternValue, true)) {
                tmp$ret$0 = true;
                break $l$block_0;
              }
            }
            tmp$ret$0 = false;
          }
          tmp_0 = tmp$ret$0;
        }
        tmp = tmp_0;
      } else {
        var value = this.mqy(patternName);
        tmp = patternValue === '*' ? !(value == null) : equals_0(value, patternValue, true);
      }
      var matches = tmp;
      if (!matches) {
        return false;
      }
    }
    return true;
  };
  protoOf(ContentType).equals = function (other) {
    var tmp;
    var tmp_0;
    var tmp_1;
    if (other instanceof ContentType) {
      tmp_1 = equals_0(this.hqy_1, other.hqy_1, true);
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = equals_0(this.iqy_1, other.iqy_1, true);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = equals(this.tqw_1, other.tqw_1);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(ContentType).hashCode = function () {
    // Inline function 'kotlin.text.lowercase' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = this.hqy_1.toLowerCase();
    var result = getStringHashCode(tmp$ret$1);
    var tmp = result;
    var tmp_0 = imul(31, result);
    // Inline function 'kotlin.text.lowercase' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = this.iqy_1.toLowerCase();
    result = tmp + (tmp_0 + getStringHashCode(tmp$ret$3) | 0) | 0;
    result = result + imul(31, hashCode(this.tqw_1)) | 0;
    return result;
  };
  function charset(_this__u8e3s4) {
    var tmp0_safe_receiver = _this__u8e3s4.mqy('charset');
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      var tmp_0;
      try {
        tmp_0 = Companion_instance_259.h9z(tmp0_safe_receiver);
      } catch ($p) {
        var tmp_1;
        if ($p instanceof IllegalArgumentException) {
          var exception = $p;
          tmp_1 = null;
        } else {
          throw $p;
        }
        tmp_0 = tmp_1;
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  function withCharset(_this__u8e3s4, charset) {
    return _this__u8e3s4.jqy('charset', get_name_6(charset));
  }
  function BadContentTypeFormatException(value) {
    Exception_init_$Init$_0('Bad Content-Type format: ' + value, this);
    captureStack(this, BadContentTypeFormatException);
  }
  function withCharsetIfNeeded(_this__u8e3s4, charset) {
    var tmp;
    // Inline function 'kotlin.text.lowercase' call
    // Inline function 'kotlin.js.asDynamic' call
    if (!(_this__u8e3s4.hqy_1.toLowerCase() === 'text')) {
      tmp = _this__u8e3s4;
    } else {
      tmp = _this__u8e3s4.jqy('charset', get_name_6(charset));
    }
    return tmp;
  }
  function get_HeaderFieldValueSeparators() {
    _init_properties_HeaderValueWithParameters_kt__z6luvy();
    return HeaderFieldValueSeparators;
  }
  var HeaderFieldValueSeparators;
  function Companion_374() {
  }
  var Companion_instance_374;
  function Companion_getInstance_374() {
    return Companion_instance_374;
  }
  function HeaderValueWithParameters(content, parameters) {
    parameters = parameters === VOID ? emptyList() : parameters;
    this.sqw_1 = content;
    this.tqw_1 = parameters;
  }
  protoOf(HeaderValueWithParameters).mqy = function (name) {
    var inductionVariable = 0;
    var last = get_lastIndex_2(this.tqw_1);
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var parameter = this.tqw_1.r(index);
        if (equals_0(parameter.uqw_1, name, true)) {
          return parameter.vqw_1;
        }
      }
       while (!(index === last));
    return null;
  };
  protoOf(HeaderValueWithParameters).toString = function () {
    var tmp;
    if (this.tqw_1.s()) {
      tmp = this.sqw_1;
    } else {
      var tmp_0 = this.sqw_1.length;
      // Inline function 'kotlin.collections.sumOf' call
      var sum = 0;
      var _iterator__ex2g4s = this.tqw_1.m();
      while (_iterator__ex2g4s.n()) {
        var element = _iterator__ex2g4s.o();
        var tmp_1 = sum;
        sum = tmp_1 + ((element.uqw_1.length + element.vqw_1.length | 0) + 3 | 0) | 0;
      }
      var size = tmp_0 + sum | 0;
      // Inline function 'kotlin.apply' call
      var this_0 = StringBuilder_init_$Create$(size);
      this_0.j8(this.sqw_1);
      var inductionVariable = 0;
      var last = get_lastIndex_2(this.tqw_1);
      if (inductionVariable <= last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var element_0 = this.tqw_1.r(index);
          this_0.j8('; ');
          this_0.j8(element_0.uqw_1);
          this_0.j8('=');
          // Inline function 'io.ktor.http.escapeIfNeededTo' call
          var this_1 = element_0.vqw_1;
          if (needQuotes(this_1)) {
            this_0.j8(quote(this_1));
          } else {
            this_0.j8(this_1);
          }
        }
         while (!(index === last));
      tmp = this_0.toString();
    }
    return tmp;
  };
  function needQuotes(_this__u8e3s4) {
    _init_properties_HeaderValueWithParameters_kt__z6luvy();
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0)
      return true;
    if (isQuoted(_this__u8e3s4))
      return false;
    var inductionVariable = 0;
    var last = _this__u8e3s4.length;
    if (inductionVariable < last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (get_HeaderFieldValueSeparators().t(new Char(charCodeAt(_this__u8e3s4, index))))
          return true;
      }
       while (inductionVariable < last);
    return false;
  }
  function quote(_this__u8e3s4) {
    _init_properties_HeaderValueWithParameters_kt__z6luvy();
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder_init_$Create$_1();
    quoteTo(_this__u8e3s4, this_0);
    return this_0.toString();
  }
  function isQuoted(_this__u8e3s4) {
    _init_properties_HeaderValueWithParameters_kt__z6luvy();
    if (_this__u8e3s4.length < 2) {
      return false;
    }
    if (!(first_2(_this__u8e3s4) === _Char___init__impl__6a9atx(34)) || !(last_2(_this__u8e3s4) === _Char___init__impl__6a9atx(34))) {
      return false;
    }
    var startIndex = 1;
    $l$loop: do {
      var index = indexOf_8(_this__u8e3s4, _Char___init__impl__6a9atx(34), startIndex);
      if (index === get_lastIndex_3(_this__u8e3s4)) {
        break $l$loop;
      }
      var slashesCount = 0;
      var slashIndex = index - 1 | 0;
      while (charCodeAt(_this__u8e3s4, slashIndex) === _Char___init__impl__6a9atx(92)) {
        slashesCount = slashesCount + 1 | 0;
        slashIndex = slashIndex - 1 | 0;
      }
      if ((slashesCount % 2 | 0) === 0) {
        return false;
      }
      startIndex = index + 1 | 0;
    }
     while (startIndex < _this__u8e3s4.length);
    return true;
  }
  function quoteTo(_this__u8e3s4, out) {
    _init_properties_HeaderValueWithParameters_kt__z6luvy();
    out.j8('"');
    var inductionVariable = 0;
    var last = _this__u8e3s4.length;
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var ch = charCodeAt(_this__u8e3s4, i);
        if (ch === _Char___init__impl__6a9atx(92)) {
          out.j8('\\\\');
        } else if (ch === _Char___init__impl__6a9atx(10)) {
          out.j8('\\n');
        } else if (ch === _Char___init__impl__6a9atx(13)) {
          out.j8('\\r');
        } else if (ch === _Char___init__impl__6a9atx(9)) {
          out.j8('\\t');
        } else if (ch === _Char___init__impl__6a9atx(34)) {
          out.j8('\\"');
        } else {
          out.k8(ch);
        }
      }
       while (inductionVariable < last);
    out.j8('"');
  }
  var properties_initialized_HeaderValueWithParameters_kt_yu5xg;
  function _init_properties_HeaderValueWithParameters_kt__z6luvy() {
    if (!properties_initialized_HeaderValueWithParameters_kt_yu5xg) {
      properties_initialized_HeaderValueWithParameters_kt_yu5xg = true;
      HeaderFieldValueSeparators = setOf_0([new Char(_Char___init__impl__6a9atx(40)), new Char(_Char___init__impl__6a9atx(41)), new Char(_Char___init__impl__6a9atx(60)), new Char(_Char___init__impl__6a9atx(62)), new Char(_Char___init__impl__6a9atx(64)), new Char(_Char___init__impl__6a9atx(44)), new Char(_Char___init__impl__6a9atx(59)), new Char(_Char___init__impl__6a9atx(58)), new Char(_Char___init__impl__6a9atx(92)), new Char(_Char___init__impl__6a9atx(34)), new Char(_Char___init__impl__6a9atx(47)), new Char(_Char___init__impl__6a9atx(91)), new Char(_Char___init__impl__6a9atx(93)), new Char(_Char___init__impl__6a9atx(63)), new Char(_Char___init__impl__6a9atx(61)), new Char(_Char___init__impl__6a9atx(123)), new Char(_Char___init__impl__6a9atx(125)), new Char(_Char___init__impl__6a9atx(32)), new Char(_Char___init__impl__6a9atx(9)), new Char(_Char___init__impl__6a9atx(10)), new Char(_Char___init__impl__6a9atx(13))]);
    }
  }
  function Companion_375() {
    Companion_instance_375 = this;
    this.nqy_1 = EmptyHeaders_instance;
  }
  var Companion_instance_375;
  function Companion_getInstance_375() {
    if (Companion_instance_375 == null)
      new Companion_375();
    return Companion_instance_375;
  }
  function HeadersBuilder(size) {
    size = size === VOID ? 8 : size;
    StringValuesBuilderImpl.call(this, true, size);
  }
  protoOf(HeadersBuilder).f40 = function () {
    return new HeadersImpl(this.odw_1);
  };
  protoOf(HeadersBuilder).pdw = function (name) {
    protoOf(StringValuesBuilderImpl).pdw.call(this, name);
    HttpHeaders_getInstance().mr2(name);
  };
  protoOf(HeadersBuilder).sdw = function (value) {
    protoOf(StringValuesBuilderImpl).sdw.call(this, value);
    HttpHeaders_getInstance().nr2(value);
  };
  function EmptyHeaders() {
  }
  protoOf(EmptyHeaders).jdw = function () {
    return true;
  };
  protoOf(EmptyHeaders).kdw = function (name) {
    return null;
  };
  protoOf(EmptyHeaders).ldw = function () {
    return emptySet();
  };
  protoOf(EmptyHeaders).hdw = function () {
    return emptySet();
  };
  protoOf(EmptyHeaders).s = function () {
    return true;
  };
  protoOf(EmptyHeaders).toString = function () {
    return 'Headers ' + toString_1(this.hdw());
  };
  var EmptyHeaders_instance;
  function EmptyHeaders_getInstance() {
    return EmptyHeaders_instance;
  }
  function HeadersImpl(values) {
    values = values === VOID ? emptyMap() : values;
    StringValuesImpl.call(this, true, values);
  }
  protoOf(HeadersImpl).toString = function () {
    return 'Headers ' + toString_1(this.hdw());
  };
  function HeaderValueParam_init_$Init$(name, value, $this) {
    HeaderValueParam.call($this, name, value, false);
    return $this;
  }
  function HeaderValueParam_init_$Create$(name, value) {
    return HeaderValueParam_init_$Init$(name, value, objectCreate(protoOf(HeaderValueParam)));
  }
  function HeaderValueParam(name, value, escapeValue) {
    this.uqw_1 = name;
    this.vqw_1 = value;
    this.wqw_1 = escapeValue;
  }
  protoOf(HeaderValueParam).equals = function (other) {
    var tmp;
    var tmp_0;
    if (other instanceof HeaderValueParam) {
      tmp_0 = equals_0(other.uqw_1, this.uqw_1, true);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = equals_0(other.vqw_1, this.vqw_1, true);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(HeaderValueParam).hashCode = function () {
    // Inline function 'kotlin.text.lowercase' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = this.uqw_1.toLowerCase();
    var result = getStringHashCode(tmp$ret$1);
    var tmp = result;
    var tmp_0 = imul(31, result);
    // Inline function 'kotlin.text.lowercase' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = this.vqw_1.toLowerCase();
    result = tmp + (tmp_0 + getStringHashCode(tmp$ret$3) | 0) | 0;
    return result;
  };
  protoOf(HeaderValueParam).fg = function () {
    return this.uqw_1;
  };
  protoOf(HeaderValueParam).gg = function () {
    return this.vqw_1;
  };
  protoOf(HeaderValueParam).toString = function () {
    return 'HeaderValueParam(name=' + this.uqw_1 + ', value=' + this.vqw_1 + ', escapeValue=' + this.wqw_1 + ')';
  };
  function HeaderValue(value, params) {
    params = params === VOID ? emptyList() : params;
    this.yqw_1 = value;
    this.zqw_1 = params;
    var tmp = this;
    var tmp0 = this.zqw_1;
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var _iterator__ex2g4s = tmp0.m();
      while (_iterator__ex2g4s.n()) {
        var element = _iterator__ex2g4s.o();
        if (element.uqw_1 === 'q') {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    var tmp0_safe_receiver = tmp$ret$1;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.vqw_1;
    var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : toDoubleOrNull(tmp1_safe_receiver);
    var tmp_0;
    if (tmp2_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.takeIf' call
      var tmp_1;
      if (0.0 <= tmp2_safe_receiver ? tmp2_safe_receiver <= 1.0 : false) {
        tmp_1 = tmp2_safe_receiver;
      } else {
        tmp_1 = null;
      }
      tmp_0 = tmp_1;
    }
    var tmp3_elvis_lhs = tmp_0;
    tmp.aqx_1 = tmp3_elvis_lhs == null ? 1.0 : tmp3_elvis_lhs;
  }
  protoOf(HeaderValue).fg = function () {
    return this.yqw_1;
  };
  protoOf(HeaderValue).toString = function () {
    return 'HeaderValue(value=' + this.yqw_1 + ', params=' + toString_1(this.zqw_1) + ')';
  };
  protoOf(HeaderValue).hashCode = function () {
    var result = getStringHashCode(this.yqw_1);
    result = imul(result, 31) + hashCode(this.zqw_1) | 0;
    return result;
  };
  protoOf(HeaderValue).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof HeaderValue))
      return false;
    var tmp0_other_with_cast = other instanceof HeaderValue ? other : THROW_CCE();
    if (!(this.yqw_1 === tmp0_other_with_cast.yqw_1))
      return false;
    if (!equals(this.zqw_1, tmp0_other_with_cast.zqw_1))
      return false;
    return true;
  };
  function parseHeaderValue(text) {
    return parseHeaderValue_0(text, false);
  }
  function parseHeaderValue_0(text, parametersOnly) {
    if (text == null) {
      return emptyList();
    }
    var position = 0;
    var tmp = LazyThreadSafetyMode_NONE_getInstance();
    var items = lazy_0(tmp, parseHeaderValue$lambda);
    while (position <= get_lastIndex_3(text)) {
      position = parseHeaderValueItem(text, position, items, parametersOnly);
    }
    return valueOrEmpty(items);
  }
  function parseHeaderValueItem(text, start, items, parametersOnly) {
    var position = start;
    var tmp = LazyThreadSafetyMode_NONE_getInstance();
    var parameters = lazy_0(tmp, parseHeaderValueItem$lambda);
    var valueEnd = parametersOnly ? position : null;
    while (position <= get_lastIndex_3(text)) {
      var tmp0_subject = charCodeAt(text, position);
      if (tmp0_subject === _Char___init__impl__6a9atx(44)) {
        var tmp_0 = items.a1();
        var tmp1_elvis_lhs = valueEnd;
        tmp_0.j(new HeaderValue(subtrim(text, start, tmp1_elvis_lhs == null ? position : tmp1_elvis_lhs), valueOrEmpty(parameters)));
        return position + 1 | 0;
      } else if (tmp0_subject === _Char___init__impl__6a9atx(59)) {
        if (valueEnd == null)
          valueEnd = position;
        position = parseHeaderValueParameter(text, position + 1 | 0, parameters);
      } else {
        var tmp_1;
        if (parametersOnly) {
          tmp_1 = parseHeaderValueParameter(text, position, parameters);
        } else {
          tmp_1 = position + 1 | 0;
        }
        position = tmp_1;
      }
    }
    var tmp_2 = items.a1();
    var tmp2_elvis_lhs = valueEnd;
    tmp_2.j(new HeaderValue(subtrim(text, start, tmp2_elvis_lhs == null ? position : tmp2_elvis_lhs), valueOrEmpty(parameters)));
    return position;
  }
  function valueOrEmpty(_this__u8e3s4) {
    return _this__u8e3s4.tl() ? _this__u8e3s4.a1() : emptyList();
  }
  function subtrim(_this__u8e3s4, start, end) {
    // Inline function 'kotlin.text.trim' call
    var this_0 = substring(_this__u8e3s4, start, end);
    return toString_1(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
  }
  function parseHeaderValueParameter(text, start, parameters) {
    var position = start;
    while (position <= get_lastIndex_3(text)) {
      var tmp0_subject = charCodeAt(text, position);
      if (tmp0_subject === _Char___init__impl__6a9atx(61)) {
        var tmp1_container = parseHeaderValueParameterValue(text, position + 1 | 0);
        var paramEnd = tmp1_container.fg();
        var paramValue = tmp1_container.gg();
        parseHeaderValueParameter$addParam(parameters, text, start, position, paramValue);
        return paramEnd;
      } else if (tmp0_subject === _Char___init__impl__6a9atx(59) ? true : tmp0_subject === _Char___init__impl__6a9atx(44)) {
        parseHeaderValueParameter$addParam(parameters, text, start, position, '');
        return position;
      } else {
        position = position + 1 | 0;
      }
    }
    parseHeaderValueParameter$addParam(parameters, text, start, position, '');
    return position;
  }
  function parseHeaderValueParameterValue(value, start) {
    if (value.length === start) {
      return to(start, '');
    }
    var position = start;
    if (charCodeAt(value, start) === _Char___init__impl__6a9atx(34)) {
      return parseHeaderValueParameterValueQuoted(value, position + 1 | 0);
    }
    while (position <= get_lastIndex_3(value)) {
      var tmp0_subject = charCodeAt(value, position);
      if (tmp0_subject === _Char___init__impl__6a9atx(59) ? true : tmp0_subject === _Char___init__impl__6a9atx(44))
        return to(position, subtrim(value, start, position));
      else {
        position = position + 1 | 0;
      }
    }
    return to(position, subtrim(value, start, position));
  }
  function parseHeaderValueParameterValueQuoted(value, start) {
    var position = start;
    var builder = StringBuilder_init_$Create$_1();
    loop: while (position <= get_lastIndex_3(value)) {
      var currentChar = charCodeAt(value, position);
      if (currentChar === _Char___init__impl__6a9atx(34) && nextIsSemicolonOrEnd(value, position)) {
        return to(position + 1 | 0, builder.toString());
      } else if (currentChar === _Char___init__impl__6a9atx(92) && position < (get_lastIndex_3(value) - 2 | 0)) {
        builder.k8(charCodeAt(value, position + 1 | 0));
        position = position + 2 | 0;
        continue loop;
      }
      builder.k8(currentChar);
      position = position + 1 | 0;
    }
    var tmp = position;
    var tmp0 = _Char___init__impl__6a9atx(34);
    // Inline function 'kotlin.text.plus' call
    var other = builder.toString();
    var tmp$ret$0 = toString(tmp0) + other;
    return to(tmp, tmp$ret$0);
  }
  function nextIsSemicolonOrEnd(_this__u8e3s4, start) {
    var position = start + 1 | 0;
    loop: while (position < _this__u8e3s4.length && charCodeAt(_this__u8e3s4, position) === _Char___init__impl__6a9atx(32)) {
      position = position + 1 | 0;
    }
    return position === _this__u8e3s4.length || charCodeAt(_this__u8e3s4, position) === _Char___init__impl__6a9atx(59);
  }
  function parseAndSortHeader(header) {
    // Inline function 'kotlin.collections.sortedByDescending' call
    var this_0 = parseHeaderValue(header);
    // Inline function 'kotlin.comparisons.compareByDescending' call
    var tmp = parseAndSortHeader$lambda;
    var tmp$ret$0 = new sam$kotlin_Comparator$0_3(tmp);
    return sortedWith(this_0, tmp$ret$0);
  }
  function sam$kotlin_Comparator$0_3(function_0) {
    this.or2_1 = function_0;
  }
  protoOf(sam$kotlin_Comparator$0_3).zd = function (a, b) {
    return this.or2_1(a, b);
  };
  protoOf(sam$kotlin_Comparator$0_3).compare = function (a, b) {
    return this.zd(a, b);
  };
  protoOf(sam$kotlin_Comparator$0_3).f3 = function () {
    return this.or2_1;
  };
  protoOf(sam$kotlin_Comparator$0_3).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Comparator) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlin_Comparator$0_3).hashCode = function () {
    return hashCode(this.f3());
  };
  function parseHeaderValueParameter$addParam($parameters, text, start, end, value) {
    var name = subtrim(text, start, end);
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(name) === 0) {
      return Unit_instance;
    }
    $parameters.a1().j(HeaderValueParam_init_$Create$(name, value));
  }
  function parseHeaderValue$lambda() {
    // Inline function 'kotlin.collections.arrayListOf' call
    return ArrayList_init_$Create$();
  }
  function parseHeaderValueItem$lambda() {
    // Inline function 'kotlin.collections.arrayListOf' call
    return ArrayList_init_$Create$();
  }
  function parseAndSortHeader$lambda(a, b) {
    // Inline function 'kotlin.comparisons.compareValuesBy' call
    var tmp = b.aqx_1;
    var tmp$ret$1 = a.aqx_1;
    return compareValues(tmp, tmp$ret$1);
  }
  function HttpHeaders() {
    HttpHeaders_instance = this;
    this.qqy_1 = 'Accept';
    this.rqy_1 = 'Accept-Charset';
    this.sqy_1 = 'Accept-Encoding';
    this.tqy_1 = 'Accept-Language';
    this.uqy_1 = 'Accept-Ranges';
    this.vqy_1 = 'Age';
    this.wqy_1 = 'Allow';
    this.xqy_1 = 'ALPN';
    this.yqy_1 = 'Authentication-Info';
    this.zqy_1 = 'Authorization';
    this.aqz_1 = 'Cache-Control';
    this.bqz_1 = 'Connection';
    this.cqz_1 = 'Content-Disposition';
    this.dqz_1 = 'Content-Encoding';
    this.eqz_1 = 'Content-Language';
    this.fqz_1 = 'Content-Length';
    this.gqz_1 = 'Content-Location';
    this.hqz_1 = 'Content-Range';
    this.iqz_1 = 'Content-Type';
    this.jqz_1 = 'Cookie';
    this.kqz_1 = 'DASL';
    this.lqz_1 = 'Date';
    this.mqz_1 = 'DAV';
    this.nqz_1 = 'Depth';
    this.oqz_1 = 'Destination';
    this.pqz_1 = 'ETag';
    this.qqz_1 = 'Expect';
    this.rqz_1 = 'Expires';
    this.sqz_1 = 'From';
    this.tqz_1 = 'Forwarded';
    this.uqz_1 = 'Host';
    this.vqz_1 = 'HTTP2-Settings';
    this.wqz_1 = 'If';
    this.xqz_1 = 'If-Match';
    this.yqz_1 = 'If-Modified-Since';
    this.zqz_1 = 'If-None-Match';
    this.ar0_1 = 'If-Range';
    this.br0_1 = 'If-Schedule-Tag-Match';
    this.cr0_1 = 'If-Unmodified-Since';
    this.dr0_1 = 'Last-Modified';
    this.er0_1 = 'Location';
    this.fr0_1 = 'Lock-Token';
    this.gr0_1 = 'Link';
    this.hr0_1 = 'Max-Forwards';
    this.ir0_1 = 'MIME-Version';
    this.jr0_1 = 'Ordering-Type';
    this.kr0_1 = 'Origin';
    this.lr0_1 = 'Overwrite';
    this.mr0_1 = 'Position';
    this.nr0_1 = 'Pragma';
    this.or0_1 = 'Prefer';
    this.pr0_1 = 'Preference-Applied';
    this.qr0_1 = 'Proxy-Authenticate';
    this.rr0_1 = 'Proxy-Authentication-Info';
    this.sr0_1 = 'Proxy-Authorization';
    this.tr0_1 = 'Public-Key-Pins';
    this.ur0_1 = 'Public-Key-Pins-Report-Only';
    this.vr0_1 = 'Range';
    this.wr0_1 = 'Referer';
    this.xr0_1 = 'Retry-After';
    this.yr0_1 = 'Schedule-Reply';
    this.zr0_1 = 'Schedule-Tag';
    this.ar1_1 = 'Sec-WebSocket-Accept';
    this.br1_1 = 'Sec-WebSocket-Extensions';
    this.cr1_1 = 'Sec-WebSocket-Key';
    this.dr1_1 = 'Sec-WebSocket-Protocol';
    this.er1_1 = 'Sec-WebSocket-Version';
    this.fr1_1 = 'Server';
    this.gr1_1 = 'Set-Cookie';
    this.hr1_1 = 'SLUG';
    this.ir1_1 = 'Strict-Transport-Security';
    this.jr1_1 = 'TE';
    this.kr1_1 = 'Timeout';
    this.lr1_1 = 'Trailer';
    this.mr1_1 = 'Transfer-Encoding';
    this.nr1_1 = 'Upgrade';
    this.or1_1 = 'User-Agent';
    this.pr1_1 = 'Vary';
    this.qr1_1 = 'Via';
    this.rr1_1 = 'Warning';
    this.sr1_1 = 'WWW-Authenticate';
    this.tr1_1 = 'Access-Control-Allow-Origin';
    this.ur1_1 = 'Access-Control-Allow-Methods';
    this.vr1_1 = 'Access-Control-Allow-Credentials';
    this.wr1_1 = 'Access-Control-Allow-Headers';
    this.xr1_1 = 'Access-Control-Request-Method';
    this.yr1_1 = 'Access-Control-Request-Headers';
    this.zr1_1 = 'Access-Control-Expose-Headers';
    this.ar2_1 = 'Access-Control-Max-Age';
    this.br2_1 = 'X-Http-Method-Override';
    this.cr2_1 = 'X-Forwarded-Host';
    this.dr2_1 = 'X-Forwarded-Server';
    this.er2_1 = 'X-Forwarded-Proto';
    this.fr2_1 = 'X-Forwarded-For';
    this.gr2_1 = 'X-Forwarded-Port';
    this.hr2_1 = 'X-Request-ID';
    this.ir2_1 = 'X-Correlation-ID';
    this.jr2_1 = 'X-Total-Count';
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.kr2_1 = [this.mr1_1, this.nr1_1];
    this.lr2_1 = asList(this.kr2_1);
  }
  protoOf(HttpHeaders).mr2 = function (name) {
    // Inline function 'kotlin.text.forEachIndexed' call
    var index = 0;
    var inductionVariable = 0;
    while (inductionVariable < charSequenceLength(name)) {
      var item = charSequenceGet(name, inductionVariable);
      inductionVariable = inductionVariable + 1 | 0;
      var _unary__edvuaz = index;
      index = _unary__edvuaz + 1 | 0;
      if (Char__compareTo_impl_ypi4mb(item, _Char___init__impl__6a9atx(32)) <= 0 || isDelimiter(item)) {
        throw new IllegalHeaderNameException(name, _unary__edvuaz);
      }
    }
  };
  protoOf(HttpHeaders).nr2 = function (value) {
    // Inline function 'kotlin.text.forEachIndexed' call
    var index = 0;
    var inductionVariable = 0;
    while (inductionVariable < charSequenceLength(value)) {
      var item = charSequenceGet(value, inductionVariable);
      inductionVariable = inductionVariable + 1 | 0;
      var _unary__edvuaz = index;
      index = _unary__edvuaz + 1 | 0;
      if (Char__compareTo_impl_ypi4mb(item, _Char___init__impl__6a9atx(32)) < 0 && !(item === _Char___init__impl__6a9atx(9))) {
        throw new IllegalHeaderValueException(value, _unary__edvuaz);
      }
    }
  };
  var HttpHeaders_instance;
  function HttpHeaders_getInstance() {
    if (HttpHeaders_instance == null)
      new HttpHeaders();
    return HttpHeaders_instance;
  }
  function UnsafeHeaderException(header) {
    IllegalArgumentException_init_$Init$_0('Header(s) ' + header + ' are controlled by the engine and ' + 'cannot be set explicitly', this);
    captureStack(this, UnsafeHeaderException);
  }
  function isDelimiter(ch) {
    return contains_9('"(),/:;<=>?@[\\]{}', ch);
  }
  function IllegalHeaderNameException(headerName, position) {
    var tmp = "Header name '" + headerName + "' contains illegal character '" + toString(charCodeAt(headerName, position)) + "'";
    // Inline function 'kotlin.code' call
    var this_0 = charCodeAt(headerName, position);
    var tmp$ret$0 = Char__toInt_impl_vasixd(this_0);
    IllegalArgumentException_init_$Init$_0(tmp + (' (code ' + (tmp$ret$0 & 255) + ')'), this);
    captureStack(this, IllegalHeaderNameException);
    this.pr2_1 = headerName;
    this.qr2_1 = position;
  }
  function IllegalHeaderValueException(headerValue, position) {
    var tmp = "Header value '" + headerValue + "' contains illegal character '" + toString(charCodeAt(headerValue, position)) + "'";
    // Inline function 'kotlin.code' call
    var this_0 = charCodeAt(headerValue, position);
    var tmp$ret$0 = Char__toInt_impl_vasixd(this_0);
    IllegalArgumentException_init_$Init$_0(tmp + (' (code ' + (tmp$ret$0 & 255) + ')'), this);
    captureStack(this, IllegalHeaderValueException);
    this.rr2_1 = headerValue;
    this.sr2_1 = position;
  }
  function contentLength(_this__u8e3s4) {
    var tmp0_safe_receiver = _this__u8e3s4.tr2().ld(HttpHeaders_getInstance().fqz_1);
    return tmp0_safe_receiver == null ? null : toLong(tmp0_safe_receiver);
  }
  function contentType(_this__u8e3s4) {
    var tmp0_safe_receiver = _this__u8e3s4.tr2().ld(HttpHeaders_getInstance().iqz_1);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp = Companion_getInstance_373().z2g(tmp0_safe_receiver);
    }
    return tmp;
  }
  function charset_0(_this__u8e3s4) {
    var tmp0_safe_receiver = contentType_0(_this__u8e3s4);
    return tmp0_safe_receiver == null ? null : charset(tmp0_safe_receiver);
  }
  function contentType_0(_this__u8e3s4) {
    var tmp0_safe_receiver = _this__u8e3s4.tr2().ld(HttpHeaders_getInstance().iqz_1);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp = Companion_getInstance_373().z2g(tmp0_safe_receiver);
    }
    return tmp;
  }
  function contentType_1(_this__u8e3s4, type) {
    return _this__u8e3s4.tr2().rdw(HttpHeaders_getInstance().iqz_1, type.toString());
  }
  function Companion_376() {
    Companion_instance_376 = this;
    this.ur2_1 = new HttpMethod('GET');
    this.vr2_1 = new HttpMethod('POST');
    this.wr2_1 = new HttpMethod('PUT');
    this.xr2_1 = new HttpMethod('PATCH');
    this.yr2_1 = new HttpMethod('DELETE');
    this.zr2_1 = new HttpMethod('HEAD');
    this.ar3_1 = new HttpMethod('OPTIONS');
    this.br3_1 = listOf_0([this.ur2_1, this.vr2_1, this.wr2_1, this.xr2_1, this.yr2_1, this.zr2_1, this.ar3_1]);
  }
  var Companion_instance_376;
  function Companion_getInstance_376() {
    if (Companion_instance_376 == null)
      new Companion_376();
    return Companion_instance_376;
  }
  function HttpMethod(value) {
    Companion_getInstance_376();
    this.cr3_1 = value;
  }
  protoOf(HttpMethod).toString = function () {
    return 'HttpMethod(value=' + this.cr3_1 + ')';
  };
  protoOf(HttpMethod).hashCode = function () {
    return getStringHashCode(this.cr3_1);
  };
  protoOf(HttpMethod).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof HttpMethod))
      return false;
    var tmp0_other_with_cast = other instanceof HttpMethod ? other : THROW_CCE();
    if (!(this.cr3_1 === tmp0_other_with_cast.cr3_1))
      return false;
    return true;
  };
  function Companion_377() {
    Companion_instance_377 = this;
    this.dr3_1 = new HttpProtocolVersion('HTTP', 2, 0);
    this.er3_1 = new HttpProtocolVersion('HTTP', 1, 1);
    this.fr3_1 = new HttpProtocolVersion('HTTP', 1, 0);
    this.gr3_1 = new HttpProtocolVersion('SPDY', 3, 0);
    this.hr3_1 = new HttpProtocolVersion('QUIC', 1, 0);
  }
  var Companion_instance_377;
  function Companion_getInstance_377() {
    if (Companion_instance_377 == null)
      new Companion_377();
    return Companion_instance_377;
  }
  function HttpProtocolVersion(name, major, minor) {
    Companion_getInstance_377();
    this.ir3_1 = name;
    this.jr3_1 = major;
    this.kr3_1 = minor;
  }
  protoOf(HttpProtocolVersion).toString = function () {
    return this.ir3_1 + '/' + this.jr3_1 + '.' + this.kr3_1;
  };
  protoOf(HttpProtocolVersion).hashCode = function () {
    var result = getStringHashCode(this.ir3_1);
    result = imul(result, 31) + this.jr3_1 | 0;
    result = imul(result, 31) + this.kr3_1 | 0;
    return result;
  };
  protoOf(HttpProtocolVersion).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof HttpProtocolVersion))
      return false;
    var tmp0_other_with_cast = other instanceof HttpProtocolVersion ? other : THROW_CCE();
    if (!(this.ir3_1 === tmp0_other_with_cast.ir3_1))
      return false;
    if (!(this.jr3_1 === tmp0_other_with_cast.jr3_1))
      return false;
    if (!(this.kr3_1 === tmp0_other_with_cast.kr3_1))
      return false;
    return true;
  };
  function Companion_378() {
    Companion_instance_378 = this;
    this.lr3_1 = new HttpStatusCode(100, 'Continue');
    this.mr3_1 = new HttpStatusCode(101, 'Switching Protocols');
    this.nr3_1 = new HttpStatusCode(102, 'Processing');
    this.or3_1 = new HttpStatusCode(200, 'OK');
    this.pr3_1 = new HttpStatusCode(201, 'Created');
    this.qr3_1 = new HttpStatusCode(202, 'Accepted');
    this.rr3_1 = new HttpStatusCode(203, 'Non-Authoritative Information');
    this.sr3_1 = new HttpStatusCode(204, 'No Content');
    this.tr3_1 = new HttpStatusCode(205, 'Reset Content');
    this.ur3_1 = new HttpStatusCode(206, 'Partial Content');
    this.vr3_1 = new HttpStatusCode(207, 'Multi-Status');
    this.wr3_1 = new HttpStatusCode(300, 'Multiple Choices');
    this.xr3_1 = new HttpStatusCode(301, 'Moved Permanently');
    this.yr3_1 = new HttpStatusCode(302, 'Found');
    this.zr3_1 = new HttpStatusCode(303, 'See Other');
    this.ar4_1 = new HttpStatusCode(304, 'Not Modified');
    this.br4_1 = new HttpStatusCode(305, 'Use Proxy');
    this.cr4_1 = new HttpStatusCode(306, 'Switch Proxy');
    this.dr4_1 = new HttpStatusCode(307, 'Temporary Redirect');
    this.er4_1 = new HttpStatusCode(308, 'Permanent Redirect');
    this.fr4_1 = new HttpStatusCode(400, 'Bad Request');
    this.gr4_1 = new HttpStatusCode(401, 'Unauthorized');
    this.hr4_1 = new HttpStatusCode(402, 'Payment Required');
    this.ir4_1 = new HttpStatusCode(403, 'Forbidden');
    this.jr4_1 = new HttpStatusCode(404, 'Not Found');
    this.kr4_1 = new HttpStatusCode(405, 'Method Not Allowed');
    this.lr4_1 = new HttpStatusCode(406, 'Not Acceptable');
    this.mr4_1 = new HttpStatusCode(407, 'Proxy Authentication Required');
    this.nr4_1 = new HttpStatusCode(408, 'Request Timeout');
    this.or4_1 = new HttpStatusCode(409, 'Conflict');
    this.pr4_1 = new HttpStatusCode(410, 'Gone');
    this.qr4_1 = new HttpStatusCode(411, 'Length Required');
    this.rr4_1 = new HttpStatusCode(412, 'Precondition Failed');
    this.sr4_1 = new HttpStatusCode(413, 'Payload Too Large');
    this.tr4_1 = new HttpStatusCode(414, 'Request-URI Too Long');
    this.ur4_1 = new HttpStatusCode(415, 'Unsupported Media Type');
    this.vr4_1 = new HttpStatusCode(416, 'Requested Range Not Satisfiable');
    this.wr4_1 = new HttpStatusCode(417, 'Expectation Failed');
    this.xr4_1 = new HttpStatusCode(422, 'Unprocessable Entity');
    this.yr4_1 = new HttpStatusCode(423, 'Locked');
    this.zr4_1 = new HttpStatusCode(424, 'Failed Dependency');
    this.ar5_1 = new HttpStatusCode(425, 'Too Early');
    this.br5_1 = new HttpStatusCode(426, 'Upgrade Required');
    this.cr5_1 = new HttpStatusCode(429, 'Too Many Requests');
    this.dr5_1 = new HttpStatusCode(431, 'Request Header Fields Too Large');
    this.er5_1 = new HttpStatusCode(500, 'Internal Server Error');
    this.fr5_1 = new HttpStatusCode(501, 'Not Implemented');
    this.gr5_1 = new HttpStatusCode(502, 'Bad Gateway');
    this.hr5_1 = new HttpStatusCode(503, 'Service Unavailable');
    this.ir5_1 = new HttpStatusCode(504, 'Gateway Timeout');
    this.jr5_1 = new HttpStatusCode(505, 'HTTP Version Not Supported');
    this.kr5_1 = new HttpStatusCode(506, 'Variant Also Negotiates');
    this.lr5_1 = new HttpStatusCode(507, 'Insufficient Storage');
    this.mr5_1 = allStatusCodes();
    var tmp = this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = this.mr5_1;
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap_init_$Create$_0(capacity);
    var _iterator__ex2g4s = this_0.m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      var tmp$ret$0 = element.or5_1;
      destination.t2(tmp$ret$0, element);
    }
    tmp.nr5_1 = destination;
  }
  var Companion_instance_378;
  function Companion_getInstance_378() {
    if (Companion_instance_378 == null)
      new Companion_378();
    return Companion_instance_378;
  }
  function HttpStatusCode(value, description) {
    Companion_getInstance_378();
    this.or5_1 = value;
    this.pr5_1 = description;
  }
  protoOf(HttpStatusCode).toString = function () {
    return '' + this.or5_1 + ' ' + this.pr5_1;
  };
  protoOf(HttpStatusCode).equals = function (other) {
    var tmp;
    if (other instanceof HttpStatusCode) {
      tmp = other.or5_1 === this.or5_1;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(HttpStatusCode).hashCode = function () {
    return this.or5_1;
  };
  protoOf(HttpStatusCode).qr5 = function (other) {
    return this.or5_1 - other.or5_1 | 0;
  };
  protoOf(HttpStatusCode).d = function (other) {
    return this.qr5(other instanceof HttpStatusCode ? other : THROW_CCE());
  };
  function allStatusCodes() {
    return listOf_0([Companion_getInstance_378().lr3_1, Companion_getInstance_378().mr3_1, Companion_getInstance_378().nr3_1, Companion_getInstance_378().or3_1, Companion_getInstance_378().pr3_1, Companion_getInstance_378().qr3_1, Companion_getInstance_378().rr3_1, Companion_getInstance_378().sr3_1, Companion_getInstance_378().tr3_1, Companion_getInstance_378().ur3_1, Companion_getInstance_378().vr3_1, Companion_getInstance_378().wr3_1, Companion_getInstance_378().xr3_1, Companion_getInstance_378().yr3_1, Companion_getInstance_378().zr3_1, Companion_getInstance_378().ar4_1, Companion_getInstance_378().br4_1, Companion_getInstance_378().cr4_1, Companion_getInstance_378().dr4_1, Companion_getInstance_378().er4_1, Companion_getInstance_378().fr4_1, Companion_getInstance_378().gr4_1, Companion_getInstance_378().hr4_1, Companion_getInstance_378().ir4_1, Companion_getInstance_378().jr4_1, Companion_getInstance_378().kr4_1, Companion_getInstance_378().lr4_1, Companion_getInstance_378().mr4_1, Companion_getInstance_378().nr4_1, Companion_getInstance_378().or4_1, Companion_getInstance_378().pr4_1, Companion_getInstance_378().qr4_1, Companion_getInstance_378().rr4_1, Companion_getInstance_378().sr4_1, Companion_getInstance_378().tr4_1, Companion_getInstance_378().ur4_1, Companion_getInstance_378().vr4_1, Companion_getInstance_378().wr4_1, Companion_getInstance_378().xr4_1, Companion_getInstance_378().yr4_1, Companion_getInstance_378().zr4_1, Companion_getInstance_378().ar5_1, Companion_getInstance_378().br5_1, Companion_getInstance_378().cr5_1, Companion_getInstance_378().dr5_1, Companion_getInstance_378().er5_1, Companion_getInstance_378().fr5_1, Companion_getInstance_378().gr5_1, Companion_getInstance_378().hr5_1, Companion_getInstance_378().ir5_1, Companion_getInstance_378().jr5_1, Companion_getInstance_378().kr5_1, Companion_getInstance_378().lr5_1]);
  }
  function Companion_379() {
    Companion_instance_379 = this;
    this.rr5_1 = EmptyParameters_instance;
  }
  var Companion_instance_379;
  function Companion_getInstance_379() {
    if (Companion_instance_379 == null)
      new Companion_379();
    return Companion_instance_379;
  }
  function Parameters() {
  }
  function EmptyParameters() {
  }
  protoOf(EmptyParameters).jdw = function () {
    return true;
  };
  protoOf(EmptyParameters).kdw = function (name) {
    return null;
  };
  protoOf(EmptyParameters).ldw = function () {
    return emptySet();
  };
  protoOf(EmptyParameters).hdw = function () {
    return emptySet();
  };
  protoOf(EmptyParameters).s = function () {
    return true;
  };
  protoOf(EmptyParameters).toString = function () {
    return 'Parameters ' + toString_1(this.hdw());
  };
  protoOf(EmptyParameters).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Parameters) : false) {
      tmp = other.s();
    } else {
      tmp = false;
    }
    return tmp;
  };
  var EmptyParameters_instance;
  function EmptyParameters_getInstance() {
    return EmptyParameters_instance;
  }
  function ParametersBuilder(size) {
    size = size === VOID ? 8 : size;
    return new ParametersBuilderImpl(size);
  }
  function ParametersBuilderImpl(size) {
    size = size === VOID ? 8 : size;
    StringValuesBuilderImpl.call(this, true, size);
  }
  protoOf(ParametersBuilderImpl).f40 = function () {
    return new ParametersImpl(this.odw_1);
  };
  function ParametersImpl(values) {
    values = values === VOID ? emptyMap() : values;
    StringValuesImpl.call(this, true, values);
  }
  protoOf(ParametersImpl).toString = function () {
    return 'Parameters ' + toString_1(this.hdw());
  };
  function parseQueryString(query, startIndex, limit, decode) {
    startIndex = startIndex === VOID ? 0 : startIndex;
    limit = limit === VOID ? 1000 : limit;
    decode = decode === VOID ? true : decode;
    var tmp;
    if (startIndex > get_lastIndex_3(query)) {
      tmp = Companion_getInstance_379().rr5_1;
    } else {
      // Inline function 'io.ktor.http.Companion.build' call
      Companion_getInstance_379();
      // Inline function 'kotlin.apply' call
      var this_0 = ParametersBuilder();
      parse_1(this_0, query, startIndex, limit, decode);
      tmp = this_0.f40();
    }
    return tmp;
  }
  function parse_1(_this__u8e3s4, query, startIndex, limit, decode) {
    var count = 0;
    var nameIndex = startIndex;
    var equalIndex = -1;
    var inductionVariable = startIndex;
    var last = get_lastIndex_3(query);
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (count === limit) {
          return Unit_instance;
        }
        var tmp1_subject = charCodeAt(query, index);
        if (tmp1_subject === _Char___init__impl__6a9atx(38)) {
          appendParam(_this__u8e3s4, query, nameIndex, equalIndex, index, decode);
          nameIndex = index + 1 | 0;
          equalIndex = -1;
          count = count + 1 | 0;
        } else if (tmp1_subject === _Char___init__impl__6a9atx(61)) {
          if (equalIndex === -1) {
            equalIndex = index;
          }
        }
      }
       while (!(index === last));
    if (count === limit) {
      return Unit_instance;
    }
    appendParam(_this__u8e3s4, query, nameIndex, equalIndex, query.length, decode);
  }
  function appendParam(_this__u8e3s4, query, nameIndex, equalIndex, endIndex, decode) {
    if (equalIndex === -1) {
      var spaceNameIndex = trimStart(nameIndex, endIndex, query);
      var spaceEndIndex = trimEnd_0(spaceNameIndex, endIndex, query);
      if (spaceEndIndex > spaceNameIndex) {
        var name = decode ? decodeURLQueryComponent(query, spaceNameIndex, spaceEndIndex) : substring(query, spaceNameIndex, spaceEndIndex);
        _this__u8e3s4.idw(name, emptyList());
      }
      return Unit_instance;
    }
    var spaceNameIndex_0 = trimStart(nameIndex, equalIndex, query);
    var spaceEqualIndex = trimEnd_0(spaceNameIndex_0, equalIndex, query);
    if (spaceEqualIndex > spaceNameIndex_0) {
      var name_0 = decode ? decodeURLQueryComponent(query, spaceNameIndex_0, spaceEqualIndex) : substring(query, spaceNameIndex_0, spaceEqualIndex);
      var spaceValueIndex = trimStart(equalIndex + 1 | 0, endIndex, query);
      var spaceEndIndex_0 = trimEnd_0(spaceValueIndex, endIndex, query);
      var value = decode ? decodeURLQueryComponent(query, spaceValueIndex, spaceEndIndex_0, true) : substring(query, spaceValueIndex, spaceEndIndex_0);
      _this__u8e3s4.tdw(name_0, value);
    }
  }
  function trimStart(start, end, query) {
    var spaceIndex = start;
    while (spaceIndex < end && isWhitespace(charSequenceGet(query, spaceIndex))) {
      spaceIndex = spaceIndex + 1 | 0;
    }
    return spaceIndex;
  }
  function trimEnd_0(start, end, text) {
    var spaceIndex = end;
    while (spaceIndex > start && isWhitespace(charSequenceGet(text, spaceIndex - 1 | 0))) {
      spaceIndex = spaceIndex - 1 | 0;
    }
    return spaceIndex;
  }
  function applyOrigin($this) {
    var tmp;
    // Inline function 'kotlin.text.isNotEmpty' call
    var this_0 = $this.vr5_1;
    if (charSequenceLength(this_0) > 0) {
      tmp = true;
    } else {
      tmp = $this.ur5_1.er6_1 === 'file';
    }
    if (tmp)
      return Unit_instance;
    $this.vr5_1 = Companion_getInstance_380().wr6_1.hr6_1;
    if ($this.ur5_1.equals(Companion_getInstance_381().xr6_1))
      $this.ur5_1 = Companion_getInstance_380().wr6_1.gr6_1;
    if ($this.wr5_1 === 0)
      $this.wr5_1 = Companion_getInstance_380().wr6_1.ir6_1;
  }
  function Companion_380() {
    Companion_instance_380 = this;
    this.wr6_1 = Url_2(get_origin_0(this));
  }
  var Companion_instance_380;
  function Companion_getInstance_380() {
    if (Companion_instance_380 == null)
      new Companion_380();
    return Companion_instance_380;
  }
  function URLBuilder(protocol, host, port, user, password, pathSegments, parameters, fragment, trailingQuery) {
    Companion_getInstance_380();
    protocol = protocol === VOID ? Companion_getInstance_381().xr6_1 : protocol;
    host = host === VOID ? '' : host;
    port = port === VOID ? 0 : port;
    user = user === VOID ? null : user;
    password = password === VOID ? null : password;
    pathSegments = pathSegments === VOID ? emptyList() : pathSegments;
    parameters = parameters === VOID ? Companion_getInstance_379().rr5_1 : parameters;
    fragment = fragment === VOID ? '' : fragment;
    trailingQuery = trailingQuery === VOID ? false : trailingQuery;
    this.ur5_1 = protocol;
    this.vr5_1 = host;
    this.wr5_1 = port;
    this.xr5_1 = trailingQuery;
    var tmp = this;
    tmp.yr5_1 = user == null ? null : encodeURLParameter(user);
    var tmp_0 = this;
    tmp_0.zr5_1 = password == null ? null : encodeURLParameter(password);
    this.ar6_1 = encodeURLQueryComponent(fragment);
    var tmp_1 = this;
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(pathSegments, 10));
    var _iterator__ex2g4s = pathSegments.m();
    while (_iterator__ex2g4s.n()) {
      var item = _iterator__ex2g4s.o();
      var tmp$ret$0 = encodeURLPathPart(item);
      destination.j(tmp$ret$0);
    }
    tmp_1.br6_1 = destination;
    this.cr6_1 = encodeParameters(parameters);
    this.dr6_1 = new UrlDecodedParametersBuilder(this.cr6_1);
  }
  protoOf(URLBuilder).dr7 = function (value) {
    var tmp = this;
    tmp.yr5_1 = value == null ? null : encodeURLParameter(value);
  };
  protoOf(URLBuilder).er7 = function () {
    var tmp0_safe_receiver = this.yr5_1;
    return tmp0_safe_receiver == null ? null : decodeURLPart(tmp0_safe_receiver);
  };
  protoOf(URLBuilder).fr7 = function () {
    var tmp0_safe_receiver = this.zr5_1;
    return tmp0_safe_receiver == null ? null : decodeURLPart(tmp0_safe_receiver);
  };
  protoOf(URLBuilder).gr7 = function () {
    return decodeURLQueryComponent(this.ar6_1);
  };
  protoOf(URLBuilder).hr7 = function () {
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.br6_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.m();
    while (_iterator__ex2g4s.n()) {
      var item = _iterator__ex2g4s.o();
      var tmp$ret$0 = decodeURLPart(item);
      destination.j(tmp$ret$0);
    }
    return destination;
  };
  protoOf(URLBuilder).ir7 = function (value) {
    this.cr6_1 = value;
    this.dr6_1 = new UrlDecodedParametersBuilder(value);
  };
  protoOf(URLBuilder).jr7 = function () {
    applyOrigin(this);
    return appendTo(this, StringBuilder_init_$Create$(256)).toString();
  };
  protoOf(URLBuilder).toString = function () {
    return appendTo(this, StringBuilder_init_$Create$(256)).toString();
  };
  protoOf(URLBuilder).f40 = function () {
    applyOrigin(this);
    return new Url_3(this.ur5_1, this.vr5_1, this.wr5_1, this.hr7(), this.dr6_1.f40(), this.gr7(), this.er7(), this.fr7(), this.xr5_1, this.jr7());
  };
  function get_authority(_this__u8e3s4) {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder_init_$Create$_1();
    this_0.j8(get_encodedUserAndPassword(_this__u8e3s4));
    this_0.j8(_this__u8e3s4.vr5_1);
    if (!(_this__u8e3s4.wr5_1 === 0) && !(_this__u8e3s4.wr5_1 === _this__u8e3s4.ur5_1.fr6_1)) {
      this_0.j8(':');
      this_0.j8(_this__u8e3s4.wr5_1.toString());
    }
    return this_0.toString();
  }
  function appendTo(_this__u8e3s4, out) {
    out.k(_this__u8e3s4.ur5_1.er6_1);
    var tmp0_subject = _this__u8e3s4.ur5_1.er6_1;
    if (tmp0_subject === 'file') {
      appendFile(out, _this__u8e3s4.vr5_1, get_encodedPath(_this__u8e3s4));
      return out;
    } else if (tmp0_subject === 'mailto') {
      appendMailto(out, get_encodedUserAndPassword(_this__u8e3s4), _this__u8e3s4.vr5_1);
      return out;
    }
    out.k('://');
    out.k(get_authority(_this__u8e3s4));
    appendUrlFullPath(out, get_encodedPath(_this__u8e3s4), _this__u8e3s4.cr6_1, _this__u8e3s4.xr5_1);
    // Inline function 'kotlin.text.isNotEmpty' call
    var this_0 = _this__u8e3s4.ar6_1;
    if (charSequenceLength(this_0) > 0) {
      out.k8(_Char___init__impl__6a9atx(35));
      out.k(_this__u8e3s4.ar6_1);
    }
    return out;
  }
  function get_encodedUserAndPassword(_this__u8e3s4) {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder_init_$Create$_1();
    appendUserAndPassword(this_0, _this__u8e3s4.yr5_1, _this__u8e3s4.zr5_1);
    return this_0.toString();
  }
  function appendFile(_this__u8e3s4, host, encodedPath) {
    _this__u8e3s4.k('://');
    _this__u8e3s4.k(host);
    if (!startsWith_1(encodedPath, _Char___init__impl__6a9atx(47))) {
      _this__u8e3s4.k8(_Char___init__impl__6a9atx(47));
    }
    _this__u8e3s4.k(encodedPath);
  }
  function set_encodedPath(_this__u8e3s4, value) {
    _this__u8e3s4.br6_1 = isBlank(value) ? emptyList() : value === '/' ? get_ROOT_PATH() : toMutableList_0(split(value, charArrayOf([_Char___init__impl__6a9atx(47)])));
  }
  function get_encodedPath(_this__u8e3s4) {
    return joinPath(_this__u8e3s4.br6_1);
  }
  function appendMailto(_this__u8e3s4, encodedUser, host) {
    _this__u8e3s4.k(':');
    _this__u8e3s4.k(encodedUser);
    _this__u8e3s4.k(host);
  }
  function joinPath(_this__u8e3s4) {
    if (_this__u8e3s4.s())
      return '';
    if (_this__u8e3s4.p() === 1) {
      // Inline function 'kotlin.text.isEmpty' call
      var this_0 = first(_this__u8e3s4);
      if (charSequenceLength(this_0) === 0)
        return '/';
      return first(_this__u8e3s4);
    }
    return joinToString_0(_this__u8e3s4, '/');
  }
  function set_2(_this__u8e3s4, scheme, host, port, path, block) {
    scheme = scheme === VOID ? null : scheme;
    host = host === VOID ? null : host;
    port = port === VOID ? null : port;
    path = path === VOID ? null : path;
    var tmp;
    if (block === VOID) {
      tmp = set$lambda;
    } else {
      tmp = block;
    }
    block = tmp;
    if (!(scheme == null))
      _this__u8e3s4.ur5_1 = Companion_getInstance_381().kr7(scheme);
    if (!(host == null))
      _this__u8e3s4.vr5_1 = host;
    if (!(port == null))
      _this__u8e3s4.wr5_1 = port;
    if (!(path == null)) {
      set_encodedPath(_this__u8e3s4, path);
    }
    block(_this__u8e3s4);
  }
  function set$lambda($this$null) {
    return Unit_instance;
  }
  function get_ROOT_PATH() {
    _init_properties_URLParser_kt__sf11to();
    return ROOT_PATH;
  }
  var ROOT_PATH;
  function takeFrom(_this__u8e3s4, urlString) {
    _init_properties_URLParser_kt__sf11to();
    if (isBlank(urlString))
      return _this__u8e3s4;
    var tmp;
    try {
      tmp = takeFromUnsafe(_this__u8e3s4, urlString);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var cause = $p;
        throw new URLParserException(urlString, cause);
      } else {
        throw $p;
      }
    }
    return tmp;
  }
  function takeFromUnsafe(_this__u8e3s4, urlString) {
    _init_properties_URLParser_kt__sf11to();
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.text.indexOfFirst' call
      var inductionVariable = 0;
      var last = charSequenceLength(urlString) - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var it = charSequenceGet(urlString, index);
          if (!isWhitespace(it)) {
            tmp$ret$1 = index;
            break $l$block;
          }
        }
         while (inductionVariable <= last);
      tmp$ret$1 = -1;
    }
    var startIndex = tmp$ret$1;
    var tmp$ret$3;
    $l$block_0: {
      // Inline function 'kotlin.text.indexOfLast' call
      var inductionVariable_0 = charSequenceLength(urlString) - 1 | 0;
      if (0 <= inductionVariable_0)
        do {
          var index_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + -1 | 0;
          var it_0 = charSequenceGet(urlString, index_0);
          if (!isWhitespace(it_0)) {
            tmp$ret$3 = index_0;
            break $l$block_0;
          }
        }
         while (0 <= inductionVariable_0);
      tmp$ret$3 = -1;
    }
    var endIndex = tmp$ret$3 + 1 | 0;
    var schemeLength = findScheme(urlString, startIndex, endIndex);
    if (schemeLength > 0) {
      var scheme = substring(urlString, startIndex, startIndex + schemeLength | 0);
      _this__u8e3s4.ur5_1 = Companion_getInstance_381().kr7(scheme);
      startIndex = startIndex + (schemeLength + 1 | 0) | 0;
    }
    var slashCount = count(urlString, startIndex, endIndex, _Char___init__impl__6a9atx(47));
    startIndex = startIndex + slashCount | 0;
    if (_this__u8e3s4.ur5_1.er6_1 === 'file') {
      parseFile(_this__u8e3s4, urlString, startIndex, endIndex, slashCount);
      return _this__u8e3s4;
    }
    if (_this__u8e3s4.ur5_1.er6_1 === 'mailto') {
      // Inline function 'kotlin.require' call
      // Inline function 'kotlin.require' call
      if (!(slashCount === 0)) {
        var message = 'Failed requirement.';
        throw IllegalArgumentException_init_$Create$_0(toString_1(message));
      }
      parseMailto(_this__u8e3s4, urlString, startIndex, endIndex);
      return _this__u8e3s4;
    }
    if (slashCount >= 2) {
      loop: while (true) {
        // Inline function 'kotlin.takeIf' call
        var this_0 = indexOfAny(urlString, toCharArray('@/\\?#'), startIndex);
        var tmp;
        if (this_0 > 0) {
          tmp = this_0;
        } else {
          tmp = null;
        }
        var tmp0_elvis_lhs = tmp;
        var delimiter = tmp0_elvis_lhs == null ? endIndex : tmp0_elvis_lhs;
        if (delimiter < endIndex && charCodeAt(urlString, delimiter) === _Char___init__impl__6a9atx(64)) {
          var passwordIndex = indexOfColonInHostPort(urlString, startIndex, delimiter);
          if (!(passwordIndex === -1)) {
            _this__u8e3s4.yr5_1 = substring(urlString, startIndex, passwordIndex);
            _this__u8e3s4.zr5_1 = substring(urlString, passwordIndex + 1 | 0, delimiter);
          } else {
            _this__u8e3s4.yr5_1 = substring(urlString, startIndex, delimiter);
          }
          startIndex = delimiter + 1 | 0;
        } else {
          fillHost(_this__u8e3s4, urlString, startIndex, delimiter);
          startIndex = delimiter;
          break loop;
        }
      }
    }
    if (startIndex >= endIndex) {
      _this__u8e3s4.br6_1 = charCodeAt(urlString, endIndex - 1 | 0) === _Char___init__impl__6a9atx(47) ? get_ROOT_PATH() : emptyList();
      return _this__u8e3s4;
    }
    var tmp_0 = _this__u8e3s4;
    var tmp_1;
    if (slashCount === 0) {
      tmp_1 = dropLast(_this__u8e3s4.br6_1, 1);
    } else {
      tmp_1 = emptyList();
    }
    tmp_0.br6_1 = tmp_1;
    // Inline function 'kotlin.takeIf' call
    var this_1 = indexOfAny(urlString, toCharArray('?#'), startIndex);
    var tmp_2;
    if (this_1 > 0) {
      tmp_2 = this_1;
    } else {
      tmp_2 = null;
    }
    var tmp1_elvis_lhs = tmp_2;
    var pathEnd = tmp1_elvis_lhs == null ? endIndex : tmp1_elvis_lhs;
    if (pathEnd > startIndex) {
      var rawPath = substring(urlString, startIndex, pathEnd);
      var tmp_3;
      var tmp_4;
      if (_this__u8e3s4.br6_1.p() === 1) {
        // Inline function 'kotlin.text.isEmpty' call
        var this_2 = first(_this__u8e3s4.br6_1);
        tmp_4 = charSequenceLength(this_2) === 0;
      } else {
        tmp_4 = false;
      }
      if (tmp_4) {
        tmp_3 = emptyList();
      } else {
        tmp_3 = _this__u8e3s4.br6_1;
      }
      var basePath = tmp_3;
      var rawChunks = rawPath === '/' ? get_ROOT_PATH() : split(rawPath, charArrayOf([_Char___init__impl__6a9atx(47)]));
      var relativePath = plus_5(slashCount === 1 ? get_ROOT_PATH() : emptyList(), rawChunks);
      _this__u8e3s4.br6_1 = plus_5(basePath, relativePath);
      startIndex = pathEnd;
    }
    if (startIndex < endIndex && charCodeAt(urlString, startIndex) === _Char___init__impl__6a9atx(63)) {
      startIndex = parseQuery(_this__u8e3s4, urlString, startIndex, endIndex);
    }
    parseFragment(_this__u8e3s4, urlString, startIndex, endIndex);
    return _this__u8e3s4;
  }
  function URLParserException(urlString, cause) {
    IllegalStateException_init_$Init$_1('Fail to parse url: ' + urlString, cause, this);
    captureStack(this, URLParserException);
  }
  function findScheme(urlString, startIndex, endIndex) {
    _init_properties_URLParser_kt__sf11to();
    var current = startIndex;
    var incorrectSchemePosition = -1;
    var firstChar = charCodeAt(urlString, current);
    if (!(_Char___init__impl__6a9atx(97) <= firstChar ? firstChar <= _Char___init__impl__6a9atx(122) : false) && !(_Char___init__impl__6a9atx(65) <= firstChar ? firstChar <= _Char___init__impl__6a9atx(90) : false)) {
      incorrectSchemePosition = current;
    }
    while (current < endIndex) {
      var char = charCodeAt(urlString, current);
      if (char === _Char___init__impl__6a9atx(58)) {
        if (!(incorrectSchemePosition === -1)) {
          throw IllegalArgumentException_init_$Create$_0('Illegal character in scheme at position ' + incorrectSchemePosition);
        }
        return current - startIndex | 0;
      }
      if (char === _Char___init__impl__6a9atx(47) || char === _Char___init__impl__6a9atx(63) || char === _Char___init__impl__6a9atx(35))
        return -1;
      if (incorrectSchemePosition === -1 && !(_Char___init__impl__6a9atx(97) <= char ? char <= _Char___init__impl__6a9atx(122) : false) && !(_Char___init__impl__6a9atx(65) <= char ? char <= _Char___init__impl__6a9atx(90) : false) && !(_Char___init__impl__6a9atx(48) <= char ? char <= _Char___init__impl__6a9atx(57) : false) && !(char === _Char___init__impl__6a9atx(46)) && !(char === _Char___init__impl__6a9atx(43)) && !(char === _Char___init__impl__6a9atx(45))) {
        incorrectSchemePosition = current;
      }
      current = current + 1 | 0;
    }
    return -1;
  }
  function count(urlString, startIndex, endIndex, char) {
    _init_properties_URLParser_kt__sf11to();
    var result = 0;
    $l$loop: while ((startIndex + result | 0) < endIndex && charCodeAt(urlString, startIndex + result | 0) === char) {
      result = result + 1 | 0;
    }
    return result;
  }
  function parseFile(_this__u8e3s4, urlString, startIndex, endIndex, slashCount) {
    _init_properties_URLParser_kt__sf11to();
    switch (slashCount) {
      case 2:
        var nextSlash = indexOf_8(urlString, _Char___init__impl__6a9atx(47), startIndex);
        if (nextSlash === -1 || nextSlash === endIndex) {
          _this__u8e3s4.vr5_1 = substring(urlString, startIndex, endIndex);
          return Unit_instance;
        }

        _this__u8e3s4.vr5_1 = substring(urlString, startIndex, nextSlash);
        set_encodedPath(_this__u8e3s4, substring(urlString, nextSlash, endIndex));
        break;
      case 3:
        _this__u8e3s4.vr5_1 = '';
        set_encodedPath(_this__u8e3s4, '/' + substring(urlString, startIndex, endIndex));
        break;
      default:
        throw IllegalArgumentException_init_$Create$_0('Invalid file url: ' + urlString);
    }
  }
  function parseMailto(_this__u8e3s4, urlString, startIndex, endIndex) {
    _init_properties_URLParser_kt__sf11to();
    var delimiter = indexOf_9(urlString, '@', startIndex);
    if (delimiter === -1) {
      throw IllegalArgumentException_init_$Create$_0('Invalid mailto url: ' + urlString + ", it should contain '@'.");
    }
    _this__u8e3s4.dr7(decodeURLPart(substring(urlString, startIndex, delimiter)));
    _this__u8e3s4.vr5_1 = substring(urlString, delimiter + 1 | 0, endIndex);
  }
  function indexOfColonInHostPort(_this__u8e3s4, startIndex, endIndex) {
    _init_properties_URLParser_kt__sf11to();
    var skip = false;
    var inductionVariable = startIndex;
    if (inductionVariable < endIndex)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp1_subject = charCodeAt(_this__u8e3s4, index);
        if (tmp1_subject === _Char___init__impl__6a9atx(91))
          skip = true;
        else if (tmp1_subject === _Char___init__impl__6a9atx(93))
          skip = false;
        else if (tmp1_subject === _Char___init__impl__6a9atx(58))
          if (!skip)
            return index;
      }
       while (inductionVariable < endIndex);
    return -1;
  }
  function fillHost(_this__u8e3s4, urlString, startIndex, endIndex) {
    _init_properties_URLParser_kt__sf11to();
    // Inline function 'kotlin.takeIf' call
    var this_0 = indexOfColonInHostPort(urlString, startIndex, endIndex);
    var tmp;
    if (this_0 > 0) {
      tmp = this_0;
    } else {
      tmp = null;
    }
    var tmp0_elvis_lhs = tmp;
    var colonIndex = tmp0_elvis_lhs == null ? endIndex : tmp0_elvis_lhs;
    _this__u8e3s4.vr5_1 = substring(urlString, startIndex, colonIndex);
    if ((colonIndex + 1 | 0) < endIndex) {
      _this__u8e3s4.wr5_1 = toInt(substring(urlString, colonIndex + 1 | 0, endIndex));
    } else {
      _this__u8e3s4.wr5_1 = 0;
    }
  }
  function parseQuery(_this__u8e3s4, urlString, startIndex, endIndex) {
    _init_properties_URLParser_kt__sf11to();
    if ((startIndex + 1 | 0) === endIndex) {
      _this__u8e3s4.xr5_1 = true;
      return endIndex;
    }
    // Inline function 'kotlin.takeIf' call
    var this_0 = indexOf_8(urlString, _Char___init__impl__6a9atx(35), startIndex + 1 | 0);
    var tmp;
    if (this_0 > 0) {
      tmp = this_0;
    } else {
      tmp = null;
    }
    var tmp0_elvis_lhs = tmp;
    var fragmentStart = tmp0_elvis_lhs == null ? endIndex : tmp0_elvis_lhs;
    var rawParameters = parseQueryString(substring(urlString, startIndex + 1 | 0, fragmentStart), VOID, VOID, false);
    rawParameters.mdw(parseQuery$lambda(_this__u8e3s4));
    return fragmentStart;
  }
  function parseFragment(_this__u8e3s4, urlString, startIndex, endIndex) {
    _init_properties_URLParser_kt__sf11to();
    if (startIndex < endIndex && charCodeAt(urlString, startIndex) === _Char___init__impl__6a9atx(35)) {
      _this__u8e3s4.ar6_1 = substring(urlString, startIndex + 1 | 0, endIndex);
    }
  }
  function parseQuery$lambda($this_parseQuery) {
    return function (key, values) {
      $this_parseQuery.cr6_1.idw(key, values);
      return Unit_instance;
    };
  }
  var properties_initialized_URLParser_kt_hd1g6a;
  function _init_properties_URLParser_kt__sf11to() {
    if (!properties_initialized_URLParser_kt_hd1g6a) {
      properties_initialized_URLParser_kt_hd1g6a = true;
      ROOT_PATH = listOf('');
    }
  }
  function Companion_381() {
    Companion_instance_381 = this;
    this.xr6_1 = new URLProtocol('http', 80);
    this.yr6_1 = new URLProtocol('https', 443);
    this.zr6_1 = new URLProtocol('ws', 80);
    this.ar7_1 = new URLProtocol('wss', 443);
    this.br7_1 = new URLProtocol('socks', 1080);
    var tmp = this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = listOf_0([this.xr6_1, this.yr6_1, this.zr6_1, this.ar7_1, this.br7_1]);
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap_init_$Create$_0(capacity);
    var _iterator__ex2g4s = this_0.m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      var tmp$ret$0 = element.er6_1;
      destination.t2(tmp$ret$0, element);
    }
    tmp.cr7_1 = destination;
  }
  protoOf(Companion_381).kr7 = function (name) {
    // Inline function 'kotlin.let' call
    var it = toLowerCasePreservingASCIIRules(name);
    var tmp0_elvis_lhs = Companion_getInstance_381().cr7_1.q2(it);
    return tmp0_elvis_lhs == null ? new URLProtocol(it, 0) : tmp0_elvis_lhs;
  };
  var Companion_instance_381;
  function Companion_getInstance_381() {
    if (Companion_instance_381 == null)
      new Companion_381();
    return Companion_instance_381;
  }
  function URLProtocol(name, defaultPort) {
    Companion_getInstance_381();
    this.er6_1 = name;
    this.fr6_1 = defaultPort;
    var tmp0 = this.er6_1;
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.text.all' call
      var inductionVariable = 0;
      while (inductionVariable < charSequenceLength(tmp0)) {
        var element = charSequenceGet(tmp0, inductionVariable);
        inductionVariable = inductionVariable + 1 | 0;
        if (!isLowerCase_0(element)) {
          tmp$ret$1 = false;
          break $l$block;
        }
      }
      tmp$ret$1 = true;
    }
    // Inline function 'kotlin.require' call
    if (!tmp$ret$1) {
      var message = 'All characters should be lower case';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
  }
  protoOf(URLProtocol).toString = function () {
    return 'URLProtocol(name=' + this.er6_1 + ', defaultPort=' + this.fr6_1 + ')';
  };
  protoOf(URLProtocol).hashCode = function () {
    var result = getStringHashCode(this.er6_1);
    result = imul(result, 31) + this.fr6_1 | 0;
    return result;
  };
  protoOf(URLProtocol).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof URLProtocol))
      return false;
    var tmp0_other_with_cast = other instanceof URLProtocol ? other : THROW_CCE();
    if (!(this.er6_1 === tmp0_other_with_cast.er6_1))
      return false;
    if (!(this.fr6_1 === tmp0_other_with_cast.fr6_1))
      return false;
    return true;
  };
  function isSecure(_this__u8e3s4) {
    return _this__u8e3s4.er6_1 === 'https' || _this__u8e3s4.er6_1 === 'wss';
  }
  function isWebsocket(_this__u8e3s4) {
    return _this__u8e3s4.er6_1 === 'ws' || _this__u8e3s4.er6_1 === 'wss';
  }
  function takeFrom_0(_this__u8e3s4, url) {
    _this__u8e3s4.ur5_1 = url.ur5_1;
    _this__u8e3s4.vr5_1 = url.vr5_1;
    _this__u8e3s4.wr5_1 = url.wr5_1;
    _this__u8e3s4.br6_1 = url.br6_1;
    _this__u8e3s4.yr5_1 = url.yr5_1;
    _this__u8e3s4.zr5_1 = url.zr5_1;
    // Inline function 'kotlin.apply' call
    var this_0 = ParametersBuilder();
    appendAll(this_0, url.cr6_1);
    _this__u8e3s4.ir7(this_0);
    _this__u8e3s4.ar6_1 = url.ar6_1;
    _this__u8e3s4.xr5_1 = url.xr5_1;
    return _this__u8e3s4;
  }
  function Url_2(urlString) {
    return URLBuilder_0(urlString).f40();
  }
  function appendUrlFullPath(_this__u8e3s4, encodedPath, encodedQueryParameters, trailingQuery) {
    var tmp;
    // Inline function 'kotlin.text.isNotBlank' call
    if (!isBlank(encodedPath)) {
      tmp = !startsWith(encodedPath, '/');
    } else {
      tmp = false;
    }
    if (tmp) {
      _this__u8e3s4.k8(_Char___init__impl__6a9atx(47));
    }
    _this__u8e3s4.k(encodedPath);
    if (!encodedQueryParameters.s() || trailingQuery) {
      _this__u8e3s4.k('?');
    }
    // Inline function 'kotlin.collections.flatMap' call
    var tmp0 = encodedQueryParameters.hdw();
    // Inline function 'kotlin.collections.flatMapTo' call
    var destination = ArrayList_init_$Create$();
    var _iterator__ex2g4s = tmp0.m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      // Inline function 'kotlin.collections.component1' call
      var key = element.z();
      // Inline function 'kotlin.collections.component2' call
      var value = element.a1();
      var tmp_0;
      if (value.s()) {
        tmp_0 = listOf(to(key, null));
      } else {
        // Inline function 'kotlin.collections.map' call
        // Inline function 'kotlin.collections.mapTo' call
        var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(value, 10));
        var _iterator__ex2g4s_0 = value.m();
        while (_iterator__ex2g4s_0.n()) {
          var item = _iterator__ex2g4s_0.o();
          var tmp$ret$3 = to(key, item);
          destination_0.j(tmp$ret$3);
        }
        tmp_0 = destination_0;
      }
      var list = tmp_0;
      addAll_1(destination, list);
    }
    var tmp_1 = destination;
    joinTo_0(tmp_1, _this__u8e3s4, '&', VOID, VOID, VOID, VOID, appendUrlFullPath$lambda);
  }
  function appendUserAndPassword(_this__u8e3s4, encodedUser, encodedPassword) {
    if (encodedUser == null) {
      return Unit_instance;
    }
    _this__u8e3s4.j8(encodedUser);
    if (!(encodedPassword == null)) {
      _this__u8e3s4.k8(_Char___init__impl__6a9atx(58));
      _this__u8e3s4.j8(encodedPassword);
    }
    _this__u8e3s4.j8('@');
  }
  function URLBuilder_0(urlString) {
    return takeFrom(new URLBuilder(), urlString);
  }
  function get_hostWithPort(_this__u8e3s4) {
    return _this__u8e3s4.hr6_1 + ':' + _this__u8e3s4.lr7();
  }
  function appendUrlFullPath$lambda(it) {
    var key = it.pg_1;
    var tmp;
    if (it.qg_1 == null) {
      tmp = key;
    } else {
      var value = toString_0(it.qg_1);
      tmp = key + '=' + value;
    }
    return tmp;
  }
  function Companion_382() {
  }
  var Companion_instance_382;
  function Companion_getInstance_382() {
    return Companion_instance_382;
  }
  function Url$encodedPath$delegate$lambda(this$0) {
    return function () {
      var tmp;
      if (this$0.jr6_1.s()) {
        return '';
      }
      var pathStartIndex = indexOf_8(this$0.pr6_1, _Char___init__impl__6a9atx(47), this$0.gr6_1.er6_1.length + 3 | 0);
      var tmp_0;
      if (pathStartIndex === -1) {
        return '';
      }
      // Inline function 'kotlin.charArrayOf' call
      var tmp$ret$0 = charArrayOf([_Char___init__impl__6a9atx(63), _Char___init__impl__6a9atx(35)]);
      var pathEndIndex = indexOfAny(this$0.pr6_1, tmp$ret$0, pathStartIndex);
      var tmp_1;
      if (pathEndIndex === -1) {
        return substring_0(this$0.pr6_1, pathStartIndex);
      }
      return substring(this$0.pr6_1, pathStartIndex, pathEndIndex);
    };
  }
  function Url$encodedQuery$delegate$lambda(this$0) {
    return function () {
      var queryStart = indexOf_8(this$0.pr6_1, _Char___init__impl__6a9atx(63)) + 1 | 0;
      var tmp;
      if (queryStart === 0) {
        return '';
      }
      var queryEnd = indexOf_8(this$0.pr6_1, _Char___init__impl__6a9atx(35), queryStart);
      var tmp_0;
      if (queryEnd === -1) {
        return substring_0(this$0.pr6_1, queryStart);
      }
      return substring(this$0.pr6_1, queryStart, queryEnd);
    };
  }
  function Url$encodedPathAndQuery$delegate$lambda(this$0) {
    return function () {
      var pathStart = indexOf_8(this$0.pr6_1, _Char___init__impl__6a9atx(47), this$0.gr6_1.er6_1.length + 3 | 0);
      var tmp;
      if (pathStart === -1) {
        return '';
      }
      var queryEnd = indexOf_8(this$0.pr6_1, _Char___init__impl__6a9atx(35), pathStart);
      var tmp_0;
      if (queryEnd === -1) {
        return substring_0(this$0.pr6_1, pathStart);
      }
      return substring(this$0.pr6_1, pathStart, queryEnd);
    };
  }
  function Url$encodedUser$delegate$lambda(this$0) {
    return function () {
      var tmp;
      if (this$0.mr6_1 == null) {
        return null;
      }
      var tmp_0;
      // Inline function 'kotlin.text.isEmpty' call
      var this_0 = this$0.mr6_1;
      if (charSequenceLength(this_0) === 0) {
        return '';
      }
      var usernameStart = this$0.gr6_1.er6_1.length + 3 | 0;
      // Inline function 'kotlin.charArrayOf' call
      var tmp$ret$1 = charArrayOf([_Char___init__impl__6a9atx(58), _Char___init__impl__6a9atx(64)]);
      var usernameEnd = indexOfAny(this$0.pr6_1, tmp$ret$1, usernameStart);
      return substring(this$0.pr6_1, usernameStart, usernameEnd);
    };
  }
  function Url$_get_encodedUser_$ref_3lb9bi() {
    return function (p0) {
      return p0.mr7();
    };
  }
  function Url$encodedPassword$delegate$lambda(this$0) {
    return function () {
      var tmp;
      if (this$0.nr6_1 == null) {
        return null;
      }
      var tmp_0;
      // Inline function 'kotlin.text.isEmpty' call
      var this_0 = this$0.nr6_1;
      if (charSequenceLength(this_0) === 0) {
        return '';
      }
      var passwordStart = indexOf_8(this$0.pr6_1, _Char___init__impl__6a9atx(58), this$0.gr6_1.er6_1.length + 3 | 0) + 1 | 0;
      var passwordEnd = indexOf_8(this$0.pr6_1, _Char___init__impl__6a9atx(64));
      return substring(this$0.pr6_1, passwordStart, passwordEnd);
    };
  }
  function Url$_get_encodedPassword_$ref_25ixc2() {
    return function (p0) {
      return p0.nr7();
    };
  }
  function Url$encodedFragment$delegate$lambda(this$0) {
    return function () {
      var fragmentStart = indexOf_8(this$0.pr6_1, _Char___init__impl__6a9atx(35)) + 1 | 0;
      var tmp;
      if (fragmentStart === 0) {
        return '';
      }
      return substring_0(this$0.pr6_1, fragmentStart);
    };
  }
  function Url_3(protocol, host, specifiedPort, pathSegments, parameters, fragment, user, password, trailingQuery, urlString) {
    this.gr6_1 = protocol;
    this.hr6_1 = host;
    this.ir6_1 = specifiedPort;
    this.jr6_1 = pathSegments;
    this.kr6_1 = parameters;
    this.lr6_1 = fragment;
    this.mr6_1 = user;
    this.nr6_1 = password;
    this.or6_1 = trailingQuery;
    this.pr6_1 = urlString;
    var tmp;
    var containsArg = this.ir6_1;
    if (0 <= containsArg ? containsArg <= 65535 : false) {
      tmp = true;
    } else {
      tmp = this.ir6_1 === 0;
    }
    // Inline function 'kotlin.require' call
    if (!tmp) {
      var message = 'port must be between 0 and 65535, or 0 if not set';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    var tmp_0 = this;
    tmp_0.qr6_1 = lazy(Url$encodedPath$delegate$lambda(this));
    var tmp_1 = this;
    tmp_1.rr6_1 = lazy(Url$encodedQuery$delegate$lambda(this));
    var tmp_2 = this;
    tmp_2.sr6_1 = lazy(Url$encodedPathAndQuery$delegate$lambda(this));
    var tmp_3 = this;
    tmp_3.tr6_1 = lazy(Url$encodedUser$delegate$lambda(this));
    var tmp_4 = this;
    tmp_4.ur6_1 = lazy(Url$encodedPassword$delegate$lambda(this));
    var tmp_5 = this;
    tmp_5.vr6_1 = lazy(Url$encodedFragment$delegate$lambda(this));
  }
  protoOf(Url_3).lr7 = function () {
    // Inline function 'kotlin.takeUnless' call
    var this_0 = this.ir6_1;
    var tmp;
    if (!(this_0 === 0)) {
      tmp = this_0;
    } else {
      tmp = null;
    }
    var tmp0_elvis_lhs = tmp;
    return tmp0_elvis_lhs == null ? this.gr6_1.fr6_1 : tmp0_elvis_lhs;
  };
  protoOf(Url_3).mr7 = function () {
    var tmp0 = this.tr6_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('encodedUser', 1, tmp, Url$_get_encodedUser_$ref_3lb9bi(), null);
    return tmp0.a1();
  };
  protoOf(Url_3).nr7 = function () {
    var tmp0 = this.ur6_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('encodedPassword', 1, tmp, Url$_get_encodedPassword_$ref_25ixc2(), null);
    return tmp0.a1();
  };
  protoOf(Url_3).toString = function () {
    return this.pr6_1;
  };
  protoOf(Url_3).equals = function (other) {
    if (this === other)
      return true;
    if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    if (!(other instanceof Url_3))
      THROW_CCE();
    if (!(this.pr6_1 === other.pr6_1))
      return false;
    return true;
  };
  protoOf(Url_3).hashCode = function () {
    return getStringHashCode(this.pr6_1);
  };
  function get_authority_0(_this__u8e3s4) {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder_init_$Create$_1();
    this_0.j8(get_encodedUserAndPassword_0(_this__u8e3s4));
    if (_this__u8e3s4.ir6_1 === 0 || _this__u8e3s4.ir6_1 === _this__u8e3s4.gr6_1.fr6_1) {
      this_0.j8(_this__u8e3s4.hr6_1);
    } else {
      this_0.j8(get_hostWithPort(_this__u8e3s4));
    }
    return this_0.toString();
  }
  function get_encodedUserAndPassword_0(_this__u8e3s4) {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder_init_$Create$_1();
    appendUserAndPassword(this_0, _this__u8e3s4.mr7(), _this__u8e3s4.nr7());
    return this_0.toString();
  }
  function UrlDecodedParametersBuilder(encodedParametersBuilder) {
    this.or7_1 = encodedParametersBuilder;
    this.pr7_1 = this.or7_1.jdw();
  }
  protoOf(UrlDecodedParametersBuilder).f40 = function () {
    return decodeParameters(this.or7_1);
  };
  protoOf(UrlDecodedParametersBuilder).jdw = function () {
    return this.pr7_1;
  };
  protoOf(UrlDecodedParametersBuilder).kdw = function (name) {
    var tmp0_safe_receiver = this.or7_1.kdw(encodeURLParameter(name));
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp0_safe_receiver, 10));
      var _iterator__ex2g4s = tmp0_safe_receiver.m();
      while (_iterator__ex2g4s.n()) {
        var item = _iterator__ex2g4s.o();
        var tmp$ret$0 = decodeURLQueryComponent(item, VOID, VOID, true);
        destination.j(tmp$ret$0);
      }
      tmp = destination;
    }
    return tmp;
  };
  protoOf(UrlDecodedParametersBuilder).ldw = function () {
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.or7_1.ldw();
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.m();
    while (_iterator__ex2g4s.n()) {
      var item = _iterator__ex2g4s.o();
      var tmp$ret$0 = decodeURLQueryComponent(item);
      destination.j(tmp$ret$0);
    }
    return toSet_0(destination);
  };
  protoOf(UrlDecodedParametersBuilder).s = function () {
    return this.or7_1.s();
  };
  protoOf(UrlDecodedParametersBuilder).hdw = function () {
    return decodeParameters(this.or7_1).hdw();
  };
  protoOf(UrlDecodedParametersBuilder).tdw = function (name, value) {
    return this.or7_1.tdw(encodeURLParameter(name), encodeURLParameterValue(value));
  };
  protoOf(UrlDecodedParametersBuilder).idw = function (name, values) {
    var tmp = encodeURLParameter(name);
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(values, 10));
    var _iterator__ex2g4s = values.m();
    while (_iterator__ex2g4s.n()) {
      var item = _iterator__ex2g4s.o();
      var tmp$ret$0 = encodeURLParameterValue(item);
      destination.j(tmp$ret$0);
    }
    return this.or7_1.idw(tmp, destination);
  };
  protoOf(UrlDecodedParametersBuilder).k2 = function () {
    return this.or7_1.k2();
  };
  function encodeParameters(parameters) {
    // Inline function 'kotlin.apply' call
    var this_0 = ParametersBuilder();
    appendAllEncoded(this_0, parameters);
    return this_0;
  }
  function decodeParameters(parameters) {
    // Inline function 'kotlin.apply' call
    var this_0 = ParametersBuilder();
    appendAllDecoded(this_0, parameters);
    return this_0.f40();
  }
  function appendAllEncoded(_this__u8e3s4, parameters) {
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = parameters.ldw().m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      var tmp0_elvis_lhs = parameters.kdw(element);
      var values = tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
      var tmp = encodeURLParameter(element);
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(values, 10));
      var _iterator__ex2g4s_0 = values.m();
      while (_iterator__ex2g4s_0.n()) {
        var item = _iterator__ex2g4s_0.o();
        var tmp$ret$0 = encodeURLParameterValue(item);
        destination.j(tmp$ret$0);
      }
      _this__u8e3s4.idw(tmp, destination);
    }
  }
  function appendAllDecoded(_this__u8e3s4, parameters) {
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = parameters.ldw().m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      var tmp0_elvis_lhs = parameters.kdw(element);
      var values = tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
      var tmp = decodeURLQueryComponent(element);
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(values, 10));
      var _iterator__ex2g4s_0 = values.m();
      while (_iterator__ex2g4s_0.n()) {
        var item = _iterator__ex2g4s_0.o();
        var tmp$ret$0 = decodeURLQueryComponent(item, VOID, VOID, true);
        destination.j(tmp$ret$0);
      }
      _this__u8e3s4.idw(tmp, destination);
    }
  }
  function ByteArrayContent(bytes, contentType, status) {
    contentType = contentType === VOID ? null : contentType;
    status = status === VOID ? null : status;
    ByteArrayContent_0.call(this);
    this.rr7_1 = bytes;
    this.sr7_1 = contentType;
    this.tr7_1 = status;
  }
  protoOf(ByteArrayContent).ur7 = function () {
    return this.sr7_1;
  };
  protoOf(ByteArrayContent).vr7 = function () {
    return fromInt_0(this.rr7_1.length);
  };
  protoOf(ByteArrayContent).wr7 = function () {
    return this.rr7_1;
  };
  function NoContent() {
    OutgoingContent.call(this);
  }
  function ReadChannelContent() {
    OutgoingContent.call(this);
  }
  function WriteChannelContent() {
  }
  function ByteArrayContent_0() {
    OutgoingContent.call(this);
  }
  function ProtocolUpgrade() {
  }
  function OutgoingContent() {
    this.xr7_1 = null;
  }
  protoOf(OutgoingContent).ur7 = function () {
    return null;
  };
  protoOf(OutgoingContent).vr7 = function () {
    return null;
  };
  protoOf(OutgoingContent).tr2 = function () {
    return Companion_getInstance_375().nqy_1;
  };
  function NullBody() {
  }
  var NullBody_instance;
  function NullBody_getInstance() {
    return NullBody_instance;
  }
  function TextContent(text, contentType, status) {
    status = status === VOID ? null : status;
    ByteArrayContent_0.call(this);
    this.er8_1 = text;
    this.fr8_1 = contentType;
    this.gr8_1 = status;
    var tmp = this;
    var tmp0 = this.er8_1;
    var tmp0_elvis_lhs = charset(this.fr8_1);
    var tmp2 = tmp0_elvis_lhs == null ? Charsets_getInstance().udq_1 : tmp0_elvis_lhs;
    var tmp$ret$0;
    $l$block: {
      // Inline function 'io.ktor.utils.io.core.toByteArray' call
      if (tmp2.equals(Charsets_getInstance().udq_1)) {
        tmp$ret$0 = encodeToByteArray(tmp0);
        break $l$block;
      }
      tmp$ret$0 = encodeToByteArray_0(tmp2.ydq(), tmp0, 0, tmp0.length);
    }
    tmp.hr8_1 = tmp$ret$0;
  }
  protoOf(TextContent).ur7 = function () {
    return this.fr8_1;
  };
  protoOf(TextContent).vr7 = function () {
    return fromInt_0(this.hr8_1.length);
  };
  protoOf(TextContent).wr7 = function () {
    return this.hr8_1;
  };
  protoOf(TextContent).toString = function () {
    return 'TextContent[' + this.fr8_1.toString() + '] "' + take_1(this.er8_1, 30) + '"';
  };
  function get_origin_0(_this__u8e3s4) {
    var tmp;
    if (get_platform(PlatformUtils_getInstance()).x2_1 === 2) {
      var tmp_0 = function () {
        var tmpLocation = null;
        if (typeof window !== 'undefined') {
          tmpLocation = window.location;
        } else if (typeof self !== 'undefined') {
          tmpLocation = self.location;
        }
        var origin = '';
        if (tmpLocation) {
          origin = tmpLocation.origin;
        }
        return origin && origin != 'null' ? origin : 'http://localhost';
      }();
      tmp = (!(tmp_0 == null) ? typeof tmp_0 === 'string' : false) ? tmp_0 : THROW_CCE();
    } else {
      tmp = 'http://localhost';
    }
    return tmp;
  }
  function ContentConvertException(message, cause) {
    cause = cause === VOID ? null : cause;
    Exception_init_$Init$_1(message, cause, this);
    captureStack(this, ContentConvertException);
  }
  function JsonConvertException(message, cause) {
    cause = cause === VOID ? null : cause;
    ContentConvertException.call(this, message, cause);
    captureStack(this, JsonConvertException);
  }
  function Configuration$register$lambda($this$null) {
    return Unit_instance;
  }
  function Configuration_0() {
  }
  function ContentConverter() {
  }
  function deserialize_1(_this__u8e3s4, body, typeInfo, charset, $completion) {
    var tmp = new $deserializeCOROUTINE$(_this__u8e3s4, body, typeInfo, charset, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  }
  function suitableCharset(_this__u8e3s4, defaultCharset) {
    defaultCharset = defaultCharset === VOID ? Charsets_getInstance().udq_1 : defaultCharset;
    var tmp0_elvis_lhs = suitableCharsetOrNull(_this__u8e3s4, defaultCharset);
    return tmp0_elvis_lhs == null ? defaultCharset : tmp0_elvis_lhs;
  }
  function suitableCharsetOrNull(_this__u8e3s4, defaultCharset) {
    defaultCharset = defaultCharset === VOID ? Charsets_getInstance().udq_1 : defaultCharset;
    var tmp0_iterator = parseAndSortHeader(_this__u8e3s4.ld(HttpHeaders_getInstance().rqy_1)).m();
    while (tmp0_iterator.n()) {
      var charset = tmp0_iterator.o().fg();
      if (charset === '*')
        return defaultCharset;
      else if (Companion_instance_259.vdt(charset))
        return Companion_instance_259.h9z(charset);
    }
    return null;
  }
  function sam$kotlinx_coroutines_flow_FlowCollector$0_22(function_0) {
    this.zr8_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_22).x18 = function (value, $completion) {
    return this.zr8_1(value, $completion);
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_22).f3 = function () {
    return this.zr8_1;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_22).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, FlowCollector) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_22).hashCode = function () {
    return hashCode(this.f3());
  };
  function deserialize$o$collect$slambda($$this$unsafeFlow, $charset, $typeInfo, $body, resultContinuation) {
    this.ir9_1 = $$this$unsafeFlow;
    this.jr9_1 = $charset;
    this.kr9_1 = $typeInfo;
    this.lr9_1 = $body;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(deserialize$o$collect$slambda).f1q = function (value, $completion) {
    var tmp = this.g1q(value, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(deserialize$o$collect$slambda).v9 = function (p1, $completion) {
    return this.f1q((p1 == null ? true : !(p1 == null)) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(deserialize$o$collect$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 3;
            var tmp0 = this.ir9_1;
            var tmp2 = this.mr9_1;
            this.nr9_1 = tmp0;
            this.f9_1 = 1;
            suspendResult = tmp2.mr8(this.jr9_1, this.kr9_1, this.lr9_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            this.f9_1 = 2;
            suspendResult = this.nr9_1.x18(ARGUMENT, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 3) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(deserialize$o$collect$slambda).g1q = function (value, completion) {
    var i = new deserialize$o$collect$slambda(this.ir9_1, this.jr9_1, this.kr9_1, this.lr9_1, completion);
    i.mr9_1 = value;
    return i;
  };
  function deserialize$o$collect$slambda_0($$this$unsafeFlow, $charset, $typeInfo, $body, resultContinuation) {
    var i = new deserialize$o$collect$slambda($$this$unsafeFlow, $charset, $typeInfo, $body, resultContinuation);
    var l = function (value, $completion) {
      return i.f1q(value, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function $collectCOROUTINE$_23(_this__u8e3s4, collector, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.wr9_1 = _this__u8e3s4;
    this.xr9_1 = collector;
  }
  protoOf($collectCOROUTINE$_23).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            var $this$unsafeFlow = this.xr9_1;
            this.f9_1 = 1;
            var tmp_0 = deserialize$o$collect$slambda_0($this$unsafeFlow, this.wr9_1.zr9_1, this.wr9_1.ara_1, this.wr9_1.bra_1, null);
            suspendResult = this.wr9_1.yr9_1.f18(new sam$kotlinx_coroutines_flow_FlowCollector$0_22(tmp_0), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function deserialize$$inlined$map$1($this, $charset, $typeInfo, $body) {
    this.yr9_1 = $this;
    this.zr9_1 = $charset;
    this.ara_1 = $typeInfo;
    this.bra_1 = $body;
  }
  protoOf(deserialize$$inlined$map$1).y18 = function (collector, $completion) {
    var tmp = new $collectCOROUTINE$_23(this, collector, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(deserialize$$inlined$map$1).f18 = function (collector, $completion) {
    return this.y18(collector, $completion);
  };
  function deserialize$slambda($body, resultContinuation) {
    this.kra_1 = $body;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(deserialize$slambda).mra = function (it, $completion) {
    var tmp = this.g1q(it, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(deserialize$slambda).v9 = function (p1, $completion) {
    return this.mra((p1 == null ? true : !(p1 == null)) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(deserialize$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        if (tmp === 0) {
          this.g9_1 = 1;
          return !(this.lra_1 == null) || this.kra_1.gdh();
        } else if (tmp === 1) {
          throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(deserialize$slambda).g1q = function (it, completion) {
    var i = new deserialize$slambda(this.kra_1, completion);
    i.lra_1 = it;
    return i;
  };
  function deserialize$slambda_0($body, resultContinuation) {
    var i = new deserialize$slambda($body, resultContinuation);
    var l = function (it, $completion) {
      return i.mra(it, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function $deserializeCOROUTINE$(_this__u8e3s4, body, typeInfo, charset, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.vr8_1 = _this__u8e3s4;
    this.wr8_1 = body;
    this.xr8_1 = typeInfo;
    this.yr8_1 = charset;
  }
  protoOf($deserializeCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            var this_0 = asFlow_0(this.vr8_1);
            var tmp_0 = new deserialize$$inlined$map$1(this_0, this.yr8_1, this.xr8_1, this.wr8_1);
            suspendResult = firstOrNull_4(tmp_0, deserialize$slambda_0(this.wr8_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var result = suspendResult;
            var tmp_1;
            if (!(result == null)) {
              tmp_1 = result;
            } else {
              if (!this.wr8_1.gdh()) {
                tmp_1 = this.wr8_1;
              } else {
                var tmp0_safe_receiver = this.xr8_1.ce0_1;
                if ((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.hb()) === true) {
                  tmp_1 = NullBody_instance;
                } else {
                  throw new ContentConvertException('No suitable converter found for ' + this.xr8_1.toString());
                }
              }
            }

            return tmp_1;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function HttpClient_init_$Init$(engine, userConfig, manageEngine, $this) {
    HttpClient.call($this, engine, userConfig);
    $this.pra_1 = manageEngine;
    return $this;
  }
  function HttpClient_init_$Create$(engine, userConfig, manageEngine) {
    return HttpClient_init_$Init$(engine, userConfig, manageEngine, objectCreate(protoOf(HttpClient)));
  }
  function HttpClient$lambda(this$0) {
    return function (it) {
      var tmp;
      if (!(it == null)) {
        cancel(this$0.nra_1);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function HttpClient$slambda(this$0, resultContinuation) {
    this.jrb_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(HttpClient$slambda).mrb = function ($this$intercept, call, $completion) {
    var tmp = this.nrb($this$intercept, call, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(HttpClient$slambda).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof PipelineContext ? p1 : THROW_CCE();
    return this.mrb(tmp, !(p2 == null) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(HttpClient$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 3;
            var tmp_0 = this.lrb_1;
            if (!(tmp_0 instanceof HttpClientCall)) {
              var message = 'Error: HttpClientCall expected, but found ' + toString_1(this.lrb_1) + '(' + toString_1(getKClassFromExpression(this.lrb_1)) + ').';
              throw IllegalStateException_init_$Create$_0(toString_1(message));
            }

            this.f9_1 = 1;
            suspendResult = this.jrb_1.wra_1.idz(Unit_instance, this.lrb_1.trb(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var response = suspendResult;
            this.lrb_1.urb(response);
            this.f9_1 = 2;
            suspendResult = this.krb_1.ndy(this.lrb_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 3) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(HttpClient$slambda).nrb = function ($this$intercept, call, completion) {
    var i = new HttpClient$slambda(this.jrb_1, completion);
    i.krb_1 = $this$intercept;
    i.lrb_1 = call;
    return i;
  };
  function HttpClient$slambda_0(this$0, resultContinuation) {
    var i = new HttpClient$slambda(this$0, resultContinuation);
    var l = function ($this$intercept, call, $completion) {
      return i.mrb($this$intercept, call, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function HttpClient$lambda_0($this$install) {
    defaultTransformers($this$install);
    return Unit_instance;
  }
  function HttpClient$slambda_1(this$0, resultContinuation) {
    this.drc_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(HttpClient$slambda_1).grc = function ($this$intercept, it, $completion) {
    var tmp = this.hrc($this$intercept, it, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(HttpClient$slambda_1).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof PipelineContext ? p1 : THROW_CCE();
    return this.grc(tmp, p2 instanceof HttpResponseContainer ? p2 : THROW_CCE(), $completion);
  };
  protoOf(HttpClient$slambda_1).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 3;
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.erc_1.ody(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.g9_1 = 3;
            this.f9_1 = 4;
            continue $sm;
          case 2:
            this.g9_1 = 3;
            var tmp_0 = this.i9_1;
            if (tmp_0 instanceof Error) {
              var cause = this.i9_1;
              this.drc_1.zra_1.pqw(get_HttpResponseReceiveFailed(), new HttpResponseReceiveFail(this.erc_1.jdz_1.trb(), cause));
              throw cause;
            } else {
              throw this.i9_1;
            }

          case 3:
            throw this.i9_1;
          case 4:
            this.g9_1 = 3;
            return Unit_instance;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 3) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(HttpClient$slambda_1).hrc = function ($this$intercept, it, completion) {
    var i = new HttpClient$slambda_1(this.drc_1, completion);
    i.erc_1 = $this$intercept;
    i.frc_1 = it;
    return i;
  };
  function HttpClient$slambda_2(this$0, resultContinuation) {
    var i = new HttpClient$slambda_1(this$0, resultContinuation);
    var l = function ($this$intercept, it, $completion) {
      return i.grc($this$intercept, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function $executeCOROUTINE$_0(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.qrc_1 = _this__u8e3s4;
    this.rrc_1 = builder;
  }
  protoOf($executeCOROUTINE$_0).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.qrc_1.zra_1.pqw(get_HttpRequestCreated(), this.rrc_1);
            this.f9_1 = 1;
            suspendResult = this.qrc_1.tra_1.idz(this.rrc_1, this.rrc_1.vrc_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult instanceof HttpClientCall ? suspendResult : THROW_CCE();
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function HttpClient(engine, userConfig) {
    userConfig = userConfig === VOID ? new HttpClientConfig() : userConfig;
    this.nra_1 = engine;
    this.ora_1 = userConfig;
    this.pra_1 = false;
    this.qra_1 = atomic$boolean$1(false);
    this.rra_1 = Job_0(this.nra_1.ho().s9(Key_instance_3));
    this.sra_1 = this.nra_1.ho().wi(this.rra_1);
    this.tra_1 = new HttpRequestPipeline(this.ora_1.frd_1);
    this.ura_1 = new HttpResponsePipeline(this.ora_1.frd_1);
    this.vra_1 = new HttpSendPipeline(this.ora_1.frd_1);
    this.wra_1 = new HttpReceivePipeline(this.ora_1.frd_1);
    this.xra_1 = AttributesJsFn(true);
    this.yra_1 = this.nra_1.ld0();
    this.zra_1 = new Events();
    this.arb_1 = new HttpClientConfig();
    if (this.pra_1) {
      this.rra_1.kp(HttpClient$lambda(this));
    }
    this.nra_1.grd(this);
    var tmp = Phases_getInstance_0().lrd_1;
    this.vra_1.ndz(tmp, HttpClient$slambda_0(this, null));
    // Inline function 'kotlin.with' call
    var $this$with = this.ora_1;
    this.arb_1.mrd(Plugin_getInstance_2());
    this.arb_1.mrd(Plugin_getInstance());
    if ($this$with.drd_1) {
      this.arb_1.nrd('DefaultTransformers', HttpClient$lambda_0);
    }
    this.arb_1.mrd(Plugin_getInstance_3());
    this.arb_1.mrd(Companion_getInstance_385());
    if ($this$with.crd_1) {
      this.arb_1.mrd(Plugin_getInstance_1());
    }
    this.arb_1.ord($this$with);
    if ($this$with.drd_1) {
      this.arb_1.mrd(Plugin_getInstance_0());
    }
    addDefaultResponseValidation(this.arb_1);
    this.arb_1.grd(this);
    var tmp_0 = Phases_getInstance_1().prd_1;
    this.ura_1.ndz(tmp_0, HttpClient$slambda_2(this, null));
  }
  protoOf(HttpClient).ho = function () {
    return this.sra_1;
  };
  protoOf(HttpClient).urd = function (builder, $completion) {
    var tmp = new $executeCOROUTINE$_0(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(HttpClient).d2n = function () {
    var success = this.qra_1.atomicfu$compareAndSet(false, true);
    if (!success)
      return Unit_instance;
    var installedFeatures = this.xra_1.ldu(get_PLUGIN_INSTALLED_LIST());
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = installedFeatures.rdu().m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      var plugin = installedFeatures.ldu(element instanceof AttributeKey ? element : THROW_CCE());
      if (isInterface(plugin, Closeable)) {
        plugin.d2n();
      }
    }
    this.rra_1.su();
    if (this.pra_1) {
      this.nra_1.d2n();
    }
  };
  protoOf(HttpClient).toString = function () {
    return 'HttpClient[' + toString_1(this.nra_1) + ']';
  };
  function HttpClient_0(engineFactory, block) {
    var tmp;
    if (block === VOID) {
      tmp = HttpClient$lambda_1;
    } else {
      tmp = block;
    }
    block = tmp;
    // Inline function 'kotlin.apply' call
    var this_0 = new HttpClientConfig();
    block(this_0);
    var config = this_0;
    var engine = engineFactory.vrd(config.brd_1);
    var client = HttpClient_init_$Create$(engine, config, true);
    var tmp_0 = ensureNotNull(client.sra_1.s9(Key_instance_3));
    tmp_0.kp(HttpClient$lambda_2(engine));
    return client;
  }
  function HttpClient$lambda_1($this$null) {
    return Unit_instance;
  }
  function HttpClient$lambda_2($engine) {
    return function (it) {
      $engine.d2n();
      return Unit_instance;
    };
  }
  function HttpClientConfig$engineConfig$lambda($this$null) {
    return Unit_instance;
  }
  function HttpClientConfig$install$lambda($this$null) {
    return Unit_instance;
  }
  function HttpClientConfig$install$lambda_0($previousConfigBlock, $configure) {
    return function ($this$null) {
      var tmp0_safe_receiver = $previousConfigBlock;
      if (tmp0_safe_receiver == null)
        null;
      else
        tmp0_safe_receiver($this$null);
      $configure(!($this$null == null) ? $this$null : THROW_CCE());
      return Unit_instance;
    };
  }
  function HttpClientConfig$install$lambda$lambda() {
    return AttributesJsFn(true);
  }
  function HttpClientConfig$install$lambda_1($plugin) {
    return function (scope) {
      var tmp = get_PLUGIN_INSTALLED_LIST();
      var attributes = scope.xra_1.qdu(tmp, HttpClientConfig$install$lambda$lambda);
      var config = ensureNotNull(scope.arb_1.zrc_1.q2($plugin.z()));
      var pluginData = $plugin.wrd(config);
      $plugin.xrd(pluginData, scope);
      attributes.odu($plugin.z(), pluginData);
      return Unit_instance;
    };
  }
  function HttpClientConfig() {
    var tmp = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp.yrc_1 = LinkedHashMap_init_$Create$();
    var tmp_0 = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp_0.zrc_1 = LinkedHashMap_init_$Create$();
    var tmp_1 = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp_1.ard_1 = LinkedHashMap_init_$Create$();
    var tmp_2 = this;
    tmp_2.brd_1 = HttpClientConfig$engineConfig$lambda;
    this.crd_1 = true;
    this.drd_1 = true;
    this.erd_1 = false;
    this.frd_1 = PlatformUtils_getInstance().fdw_1;
  }
  protoOf(HttpClientConfig).yrd = function (plugin, configure) {
    var previousConfigBlock = this.zrc_1.q2(plugin.z());
    var tmp0 = this.zrc_1;
    var tmp2 = plugin.z();
    // Inline function 'kotlin.collections.set' call
    var value = HttpClientConfig$install$lambda_0(previousConfigBlock, configure);
    tmp0.t2(tmp2, value);
    if (this.yrc_1.o2(plugin.z()))
      return Unit_instance;
    var tmp0_0 = this.yrc_1;
    var tmp2_0 = plugin.z();
    // Inline function 'kotlin.collections.set' call
    var value_0 = HttpClientConfig$install$lambda_1(plugin);
    tmp0_0.t2(tmp2_0, value_0);
  };
  protoOf(HttpClientConfig).mrd = function (plugin, configure, $super) {
    var tmp;
    if (configure === VOID) {
      tmp = HttpClientConfig$install$lambda;
    } else {
      tmp = configure;
    }
    configure = tmp;
    var tmp_0;
    if ($super === VOID) {
      this.yrd(plugin, configure);
      tmp_0 = Unit_instance;
    } else {
      tmp_0 = $super.yrd.call(this, plugin, configure);
    }
    return tmp_0;
  };
  protoOf(HttpClientConfig).nrd = function (key, block) {
    // Inline function 'kotlin.collections.set' call
    this.ard_1.t2(key, block);
  };
  protoOf(HttpClientConfig).grd = function (client) {
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = this.yrc_1.s2().m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      // Inline function 'kotlin.apply' call
      element(client);
    }
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s_0 = this.ard_1.s2().m();
    while (_iterator__ex2g4s_0.n()) {
      var element_0 = _iterator__ex2g4s_0.o();
      // Inline function 'kotlin.apply' call
      element_0(client);
    }
  };
  protoOf(HttpClientConfig).ord = function (other) {
    this.crd_1 = other.crd_1;
    this.drd_1 = other.drd_1;
    this.erd_1 = other.erd_1;
    var tmp0 = this.yrc_1;
    // Inline function 'kotlin.collections.plusAssign' call
    var map = other.yrc_1;
    tmp0.v2(map);
    var tmp0_0 = this.zrc_1;
    // Inline function 'kotlin.collections.plusAssign' call
    var map_0 = other.zrc_1;
    tmp0_0.v2(map_0);
    var tmp0_1 = this.ard_1;
    // Inline function 'kotlin.collections.plusAssign' call
    var map_1 = other.ard_1;
    tmp0_1.v2(map_1);
  };
  function HttpClientCall_init_$Init$(client, requestData, responseData, $this) {
    HttpClientCall.call($this, client);
    $this.qrb_1 = new DefaultHttpRequest($this, requestData);
    $this.rrb_1 = new DefaultHttpResponse($this, responseData);
    var tmp = responseData.dre_1;
    if (!isInterface(tmp, ByteReadChannel_1)) {
      $this.gre().odu(Companion_getInstance_383().hre_1, responseData.dre_1);
    }
    return $this;
  }
  function HttpClientCall_init_$Create$(client, requestData, responseData) {
    return HttpClientCall_init_$Init$(client, requestData, responseData, objectCreate(protoOf(HttpClientCall)));
  }
  function Companion_383() {
    Companion_instance_383 = this;
    this.hre_1 = new AttributeKey('CustomResponse');
  }
  var Companion_instance_383;
  function Companion_getInstance_383() {
    if (Companion_instance_383 == null)
      new Companion_383();
    return Companion_instance_383;
  }
  function $bodyNullableCOROUTINE$(_this__u8e3s4, info, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.qre_1 = _this__u8e3s4;
    this.rre_1 = info;
  }
  protoOf($bodyNullableCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 10;
            this.f9_1 = 1;
            continue $sm;
          case 1:
            this.sre_1 = Unit_instance;
            this.f9_1 = 2;
            continue $sm;
          case 2:
            this.g9_1 = 9;
            this.g9_1 = 8;
            if (instanceOf(this.qre_1.trb(), this.rre_1.ae0_1)) {
              this.sre_1 = this.qre_1.trb();
              this.g9_1 = 10;
              this.f9_1 = 7;
              continue $sm;
            } else {
              this.f9_1 = 3;
              continue $sm;
            }

          case 3:
            if (!this.qre_1.ure() && !this.qre_1.prb_1.atomicfu$compareAndSet(false, true)) {
              throw new DoubleReceiveException(this.qre_1);
            }

            var tmp0_elvis_lhs = this.qre_1.gre().mdu(Companion_getInstance_383().hre_1);
            if (tmp0_elvis_lhs == null) {
              this.f9_1 = 4;
              suspendResult = this.qre_1.vre(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.tre_1 = tmp0_elvis_lhs;
              this.f9_1 = 5;
              continue $sm;
            }

          case 4:
            this.tre_1 = suspendResult;
            this.f9_1 = 5;
            continue $sm;
          case 5:
            var responseData = this.tre_1;
            var subject = new HttpResponseContainer(this.rre_1, responseData);
            this.f9_1 = 6;
            suspendResult = this.qre_1.orb_1.ura_1.idz(this.qre_1, subject, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 6:
            var this_0 = suspendResult.xre_1;
            var tmp_0;
            if (!equals(this_0, NullBody_instance)) {
              tmp_0 = this_0;
            } else {
              tmp_0 = null;
            }

            var result = tmp_0;
            if (!(result == null) && !instanceOf(result, this.rre_1.ae0_1)) {
              var from = getKClassFromExpression(result);
              var to = this.rre_1.ae0_1;
              throw new NoTransformationFoundException(this.qre_1.trb(), from, to);
            }

            this.sre_1 = result;
            this.g9_1 = 10;
            this.f9_1 = 7;
            continue $sm;
          case 7:
            var tmp_1 = this.sre_1;
            this.g9_1 = 10;
            complete_0(this.qre_1.trb());
            return tmp_1;
          case 8:
            this.g9_1 = 9;
            var tmp_2 = this.i9_1;
            if (tmp_2 instanceof Error) {
              var cause = this.i9_1;
              cancel_0(this.qre_1.trb(), 'Receive failed', cause);
              throw cause;
            } else {
              throw this.i9_1;
            }

          case 9:
            this.g9_1 = 10;
            var t = this.i9_1;
            complete_0(this.qre_1.trb());
            throw t;
          case 10:
            throw this.i9_1;
          case 11:
            this.g9_1 = 10;
            complete_0(this.qre_1.trb());
            return Unit_instance;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 10) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function HttpClientCall(client) {
    Companion_getInstance_383();
    this.orb_1 = client;
    this.prb_1 = atomic$boolean$1(false);
    this.srb_1 = false;
  }
  protoOf(HttpClientCall).ho = function () {
    return this.trb().ho();
  };
  protoOf(HttpClientCall).gre = function () {
    return this.yre().gre();
  };
  protoOf(HttpClientCall).yre = function () {
    var tmp = this.qrb_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('request');
    }
  };
  protoOf(HttpClientCall).trb = function () {
    var tmp = this.rrb_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('response');
    }
  };
  protoOf(HttpClientCall).ure = function () {
    return this.srb_1;
  };
  protoOf(HttpClientCall).vre = function ($completion) {
    return this.trb().h63();
  };
  protoOf(HttpClientCall).zre = function (info, $completion) {
    var tmp = new $bodyNullableCOROUTINE$(this, info, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(HttpClientCall).toString = function () {
    return 'HttpClientCall[' + this.yre().qfs().toString() + ', ' + this.trb().arf().toString() + ']';
  };
  protoOf(HttpClientCall).urb = function (response) {
    this.rrb_1 = response;
  };
  function DoubleReceiveException(call) {
    IllegalStateException_init_$Init$(this);
    captureStack(this, DoubleReceiveException);
    this.brf_1 = 'Response already received: ' + call.toString();
    delete this.message;
  }
  protoOf(DoubleReceiveException).e = function () {
    return this.brf_1;
  };
  function NoTransformationFoundException(response, from, to) {
    UnsupportedOperationException_init_$Init$(this);
    captureStack(this, NoTransformationFoundException);
    this.crf_1 = trimIndent("\n        Expected response body of the type '" + toString_1(to) + "' but was '" + toString_1(from) + "'\n        In response from `" + get_request(response).qfs().toString() + '`\n        Response status `' + response.arf().toString() + '`\n        Response header `ContentType: ' + response.tr2().ld(HttpHeaders_getInstance().iqz_1) + '` \n        Request header `Accept: ' + get_request(response).tr2().ld(HttpHeaders_getInstance().qqy_1) + '`\n        \n        You can read how to resolve NoTransformationFoundException at FAQ: \n        https://ktor.io/docs/faq.html#no-transformation-found-exception\n    ');
    delete this.message;
  }
  protoOf(NoTransformationFoundException).e = function () {
    return this.crf_1;
  };
  function save(_this__u8e3s4, $completion) {
    var tmp = new $saveCOROUTINE$(_this__u8e3s4, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  }
  function SavedHttpCall(client, request, response, responseBody) {
    HttpClientCall.call(this, client);
    this.rrf_1 = responseBody;
    this.qrb_1 = new SavedHttpRequest(this, request);
    this.rrb_1 = new SavedHttpResponse(this, this.rrf_1, response);
    this.srf_1 = true;
  }
  protoOf(SavedHttpCall).vre = function ($completion) {
    return ByteReadChannel(this.rrf_1);
  };
  protoOf(SavedHttpCall).ure = function () {
    return this.srf_1;
  };
  function SavedHttpRequest(call, origin) {
    this.trf_1 = call;
    this.urf_1 = origin;
  }
  protoOf(SavedHttpRequest).vrf = function () {
    return this.trf_1;
  };
  protoOf(SavedHttpRequest).gre = function () {
    return this.urf_1.gre();
  };
  protoOf(SavedHttpRequest).h63 = function () {
    return this.urf_1.h63();
  };
  protoOf(SavedHttpRequest).ho = function () {
    return this.urf_1.ho();
  };
  protoOf(SavedHttpRequest).tr2 = function () {
    return this.urf_1.tr2();
  };
  protoOf(SavedHttpRequest).wrf = function () {
    return this.urf_1.wrf();
  };
  protoOf(SavedHttpRequest).qfs = function () {
    return this.urf_1.qfs();
  };
  function SavedHttpResponse(call, body, origin) {
    HttpResponse.call(this);
    this.xrf_1 = call;
    this.yrf_1 = Job_0();
    this.zrf_1 = origin.arf();
    this.arg_1 = origin.grg();
    this.brg_1 = origin.hrg();
    this.crg_1 = origin.irg();
    this.drg_1 = origin.tr2();
    this.erg_1 = origin.ho().wi(this.yrf_1);
    this.frg_1 = ByteReadChannel(body);
  }
  protoOf(SavedHttpResponse).vrf = function () {
    return this.xrf_1;
  };
  protoOf(SavedHttpResponse).arf = function () {
    return this.zrf_1;
  };
  protoOf(SavedHttpResponse).grg = function () {
    return this.arg_1;
  };
  protoOf(SavedHttpResponse).hrg = function () {
    return this.brg_1;
  };
  protoOf(SavedHttpResponse).irg = function () {
    return this.crg_1;
  };
  protoOf(SavedHttpResponse).tr2 = function () {
    return this.drg_1;
  };
  protoOf(SavedHttpResponse).ho = function () {
    return this.erg_1;
  };
  protoOf(SavedHttpResponse).h63 = function () {
    return this.frg_1;
  };
  function $saveCOROUTINE$(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.lrf_1 = _this__u8e3s4;
  }
  protoOf($saveCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.lrf_1.trb().h63().hdm(VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            var responseBody = readBytes(ARGUMENT);
            return new SavedHttpCall(this.lrf_1.orb_1, this.lrf_1.yre(), this.lrf_1.trb(), responseBody);
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function UnsupportedContentTypeException(content) {
    IllegalStateException_init_$Init$_0('Failed to write body: ' + toString_1(getKClassFromExpression(content)), this);
    captureStack(this, UnsupportedContentTypeException);
  }
  function ObservableContent$content$slambda(this$0, resultContinuation) {
    this.rrg_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ObservableContent$content$slambda).trg = function ($this$writer, $completion) {
    var tmp = this.urg($this$writer, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(ObservableContent$content$slambda).v9 = function (p1, $completion) {
    return this.trg((!(p1 == null) ? isInterface(p1, WriterScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ObservableContent$content$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.rrg_1.wrg_1.br8(this.srg_1.d11(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(ObservableContent$content$slambda).urg = function ($this$writer, completion) {
    var i = new ObservableContent$content$slambda(this.rrg_1, completion);
    i.srg_1 = $this$writer;
    return i;
  };
  function ObservableContent$content$slambda_0(this$0, resultContinuation) {
    var i = new ObservableContent$content$slambda(this$0, resultContinuation);
    var l = function ($this$writer, $completion) {
      return i.trg($this$writer, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function ObservableContent(delegate, callContext, listener) {
    ReadChannelContent.call(this);
    this.wrg_1 = delegate;
    this.xrg_1 = callContext;
    this.yrg_1 = listener;
    var tmp = this;
    var tmp0_subject = this.wrg_1;
    var tmp_0;
    if (tmp0_subject instanceof ByteArrayContent_0) {
      tmp_0 = ByteReadChannel(this.wrg_1.wr7());
    } else {
      if (tmp0_subject instanceof ProtocolUpgrade) {
        throw new UnsupportedContentTypeException(this.wrg_1);
      } else {
        if (tmp0_subject instanceof NoContent) {
          tmp_0 = Companion_getInstance_257().jdn();
        } else {
          if (tmp0_subject instanceof ReadChannelContent) {
            tmp_0 = this.wrg_1.zr7();
          } else {
            if (tmp0_subject instanceof WriteChannelContent) {
              var tmp_1 = GlobalScope_instance;
              tmp_0 = writer(tmp_1, this.xrg_1, true, ObservableContent$content$slambda_0(this, null)).d11();
            } else {
              noWhenBranchMatchedException();
            }
          }
        }
      }
    }
    tmp.zrg_1 = tmp_0;
  }
  protoOf(ObservableContent).ur7 = function () {
    return this.wrg_1.ur7();
  };
  protoOf(ObservableContent).vr7 = function () {
    return this.wrg_1.vr7();
  };
  protoOf(ObservableContent).tr2 = function () {
    return this.wrg_1.tr2();
  };
  protoOf(ObservableContent).zr7 = function () {
    return observable(this.zrg_1, this.xrg_1, this.vr7(), this.yrg_1);
  };
  function get_CALL_COROUTINE() {
    _init_properties_HttpClientEngine_kt__h91z5h();
    return CALL_COROUTINE;
  }
  var CALL_COROUTINE;
  function get_CLIENT_CONFIG() {
    _init_properties_HttpClientEngine_kt__h91z5h();
    return CLIENT_CONFIG;
  }
  var CLIENT_CONFIG;
  function HttpClientEngine$install$slambda$lambda($client, $response) {
    return function (it) {
      var tmp;
      if (!(it == null)) {
        $client.zra_1.pqw(get_HttpResponseCancelled(), $response);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function _get_closed__iwkfs1($this) {
    var tmp0_safe_receiver = $this.ho().s9(Key_instance_3);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.io();
    return !(tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs);
  }
  function executeWithinCallContext($this, requestData, $completion) {
    var tmp = new $executeWithinCallContextCOROUTINE$($this, requestData, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  }
  function checkExtensions($this, requestData) {
    var tmp0_iterator = requestData.qrh_1.m();
    while (tmp0_iterator.n()) {
      var requestedExtension = tmp0_iterator.o();
      // Inline function 'kotlin.require' call
      if (!$this.rrh().t(requestedExtension)) {
        var message = "Engine doesn't support " + toString_1(requestedExtension);
        throw IllegalArgumentException_init_$Create$_0(toString_1(message));
      }
    }
  }
  function HttpClientEngine$install$slambda($client, this$0, resultContinuation) {
    this.ari_1 = $client;
    this.bri_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(HttpClientEngine$install$slambda).mrb = function ($this$intercept, content, $completion) {
    var tmp = this.nrb($this$intercept, content, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(HttpClientEngine$install$slambda).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof PipelineContext ? p1 : THROW_CCE();
    return this.mrb(tmp, !(p2 == null) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(HttpClientEngine$install$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 3;
            var this_0 = new HttpRequestBuilder();
            this_0.fri(this.cri_1.jdz_1);
            var body = this.dri_1;
            if (body == null) {
              this_0.vrc_1 = NullBody_instance;
              var tmp_0 = JsType_instance;
              var tmp_1 = PrimitiveClasses_getInstance().ib();
              var tmp_2;
              try {
                tmp_2 = createKType(PrimitiveClasses_getInstance().ib(), arrayOf([]), false);
              } catch ($p) {
                var tmp_3;
                if ($p instanceof Error) {
                  var cause = $p;
                  tmp_3 = null;
                } else {
                  throw $p;
                }
                tmp_2 = tmp_3;
              }
              this_0.gri(typeInfoImpl(tmp_0, tmp_1, tmp_2));
            } else {
              if (body instanceof OutgoingContent) {
                this_0.vrc_1 = body;
                this_0.gri(null);
              } else {
                this_0.vrc_1 = body;
                var tmp_4 = JsType_instance;
                var tmp_5 = PrimitiveClasses_getInstance().ib();
                var tmp_6;
                try {
                  tmp_6 = createKType(PrimitiveClasses_getInstance().ib(), arrayOf([]), false);
                } catch ($p) {
                  var tmp_7;
                  if ($p instanceof Error) {
                    var cause_0 = $p;
                    tmp_7 = null;
                  } else {
                    throw $p;
                  }
                  tmp_6 = tmp_7;
                }
                this_0.gri(typeInfoImpl(tmp_4, tmp_5, tmp_6));
              }
            }

            var builder = this_0;
            this.ari_1.zra_1.pqw(get_HttpRequestIsReadyForSending(), builder);
            var tmp_8 = this;
            var this_1 = builder.f40();
            this_1.prh_1.odu(get_CLIENT_CONFIG(), this.ari_1.arb_1);
            tmp_8.eri_1 = this_1;
            validateHeaders(this.eri_1);
            checkExtensions(this.bri_1, this.eri_1);
            this.f9_1 = 1;
            suspendResult = executeWithinCallContext(this.bri_1, this.eri_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var responseData = suspendResult;
            var call = HttpClientCall_init_$Create$(this.ari_1, this.eri_1, responseData);
            var response = call.trb();
            this.ari_1.zra_1.pqw(get_HttpResponseReceived(), response);
            var tmp_9 = get_job(response.ho());
            tmp_9.kp(HttpClientEngine$install$slambda$lambda(this.ari_1, response));
            this.f9_1 = 2;
            suspendResult = this.cri_1.ndy(call, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 3) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(HttpClientEngine$install$slambda).nrb = function ($this$intercept, content, completion) {
    var i = new HttpClientEngine$install$slambda(this.ari_1, this.bri_1, completion);
    i.cri_1 = $this$intercept;
    i.dri_1 = content;
    return i;
  };
  function HttpClientEngine$install$slambda_0($client, this$0, resultContinuation) {
    var i = new HttpClientEngine$install$slambda($client, this$0, resultContinuation);
    var l = function ($this$intercept, content, $completion) {
      return i.mrb($this$intercept, content, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function HttpClientEngine$executeWithinCallContext$slambda(this$0, $requestData, resultContinuation) {
    this.pri_1 = this$0;
    this.qri_1 = $requestData;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(HttpClientEngine$executeWithinCallContext$slambda).sri = function ($this$async, $completion) {
    var tmp = this.f1h($this$async, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(HttpClientEngine$executeWithinCallContext$slambda).v9 = function (p1, $completion) {
    return this.sri((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(HttpClientEngine$executeWithinCallContext$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            if (_get_closed__iwkfs1(this.pri_1)) {
              throw new ClientEngineClosedException();
            }

            this.f9_1 = 1;
            suspendResult = this.pri_1.tri(this.qri_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(HttpClientEngine$executeWithinCallContext$slambda).f1h = function ($this$async, completion) {
    var i = new HttpClientEngine$executeWithinCallContext$slambda(this.pri_1, this.qri_1, completion);
    i.rri_1 = $this$async;
    return i;
  };
  function HttpClientEngine$executeWithinCallContext$slambda_0(this$0, $requestData, resultContinuation) {
    var i = new HttpClientEngine$executeWithinCallContext$slambda(this$0, $requestData, resultContinuation);
    var l = function ($this$async, $completion) {
      return i.sri($this$async, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function $executeWithinCallContextCOROUTINE$(_this__u8e3s4, requestData, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.irh_1 = _this__u8e3s4;
    this.jrh_1 = requestData;
  }
  protoOf($executeWithinCallContextCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 3;
            this.f9_1 = 1;
            suspendResult = createCallContext(this.irh_1, this.jrh_1.orh_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var callContext = suspendResult;
            var context = callContext.wi(new KtorCallContextElement(callContext));
            this.f9_1 = 2;
            suspendResult = async(this.irh_1, context, VOID, HttpClientEngine$executeWithinCallContext$slambda_0(this.irh_1, this.jrh_1, null)).nr(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return suspendResult;
          case 3:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 3) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function HttpClientEngine() {
  }
  function validateHeaders(request) {
    _init_properties_HttpClientEngine_kt__h91z5h();
    var requestHeaders = request.mrh_1;
    // Inline function 'kotlin.collections.filter' call
    var tmp0 = requestHeaders.ldw();
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList_init_$Create$();
    var _iterator__ex2g4s = tmp0.m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      if (HttpHeaders_getInstance().lr2_1.t(element)) {
        destination.j(element);
      }
    }
    var unsafeRequestHeaders = destination;
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!unsafeRequestHeaders.s()) {
      throw new UnsafeHeaderException(toString_1(unsafeRequestHeaders));
    }
  }
  function createCallContext(_this__u8e3s4, parentJob, $completion) {
    var callJob = Job_0(parentJob);
    var callContext = _this__u8e3s4.ho().wi(callJob).wi(get_CALL_COROUTINE());
    $l$block: {
      // Inline function 'io.ktor.client.engine.attachToUserJob' call
      // Inline function 'kotlin.js.getCoroutineContext' call
      var tmp0_elvis_lhs = $completion.l9().s9(Key_instance_3);
      var tmp;
      if (tmp0_elvis_lhs == null) {
        break $l$block;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var userJob = tmp;
      var cleanupHandler = userJob.mp(true, VOID, createCallContext$lambda(callJob));
      callJob.kp(createCallContext$lambda_0(cleanupHandler));
    }
    return callContext;
  }
  function createCallContext$lambda($callJob) {
    return function (cause) {
      if (cause == null)
        return Unit_instance;
      $callJob.rp(CancellationException_init_$Create$_0(cause.message));
      return Unit_instance;
    };
  }
  function createCallContext$lambda_0($cleanupHandler) {
    return function (it) {
      $cleanupHandler.zr();
      return Unit_instance;
    };
  }
  var properties_initialized_HttpClientEngine_kt_5uiebb;
  function _init_properties_HttpClientEngine_kt__h91z5h() {
    if (!properties_initialized_HttpClientEngine_kt_5uiebb) {
      properties_initialized_HttpClientEngine_kt_5uiebb = true;
      CALL_COROUTINE = new CoroutineName('call-context');
      CLIENT_CONFIG = new AttributeKey('client-config');
    }
  }
  function ClientEngineClosedException(cause) {
    cause = cause === VOID ? null : cause;
    IllegalStateException_init_$Init$_0('Client already closed', this);
    captureStack(this, ClientEngineClosedException);
    this.uri_1 = cause;
    delete this.cause;
  }
  protoOf(ClientEngineClosedException).f = function () {
    return this.uri_1;
  };
  function HttpClientEngineBase$coroutineContext$delegate$lambda(this$0) {
    return function () {
      return SilentSupervisor().wi(this$0.zri()).wi(new CoroutineName(this$0.vri_1 + '-context'));
    };
  }
  function HttpClientEngineBase$_get_coroutineContext_$ref_p82ehr() {
    return function (p0) {
      return p0.ho();
    };
  }
  function HttpClientEngineBase(engineName) {
    this.vri_1 = engineName;
    this.wri_1 = atomic$boolean$1(false);
    this.xri_1 = ioDispatcher();
    var tmp = this;
    tmp.yri_1 = lazy(HttpClientEngineBase$coroutineContext$delegate$lambda(this));
  }
  protoOf(HttpClientEngineBase).zri = function () {
    return this.xri_1;
  };
  protoOf(HttpClientEngineBase).ho = function () {
    var tmp0 = this.yri_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('coroutineContext', 1, tmp, HttpClientEngineBase$_get_coroutineContext_$ref_p82ehr(), null);
    return tmp0.a1();
  };
  protoOf(HttpClientEngineBase).d2n = function () {
    if (!this.wri_1.atomicfu$compareAndSet(false, true))
      return Unit_instance;
    var tmp = this.ho().s9(Key_instance_3);
    var tmp0_elvis_lhs = (!(tmp == null) ? isInterface(tmp, CompletableJob) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var requestJob = tmp_0;
    requestJob.su();
  };
  function get_ENGINE_CAPABILITIES_KEY() {
    _init_properties_HttpClientEngineCapability_kt__ifvyst();
    return ENGINE_CAPABILITIES_KEY;
  }
  var ENGINE_CAPABILITIES_KEY;
  var DEFAULT_CAPABILITIES;
  var properties_initialized_HttpClientEngineCapability_kt_qarzcf;
  function _init_properties_HttpClientEngineCapability_kt__ifvyst() {
    if (!properties_initialized_HttpClientEngineCapability_kt_qarzcf) {
      properties_initialized_HttpClientEngineCapability_kt_qarzcf = true;
      ENGINE_CAPABILITIES_KEY = new AttributeKey('EngineCapabilities');
      DEFAULT_CAPABILITIES = setOf(Plugin_getInstance_4());
    }
  }
  function HttpClientEngineConfig() {
    this.arj_1 = 4;
    this.brj_1 = false;
    this.crj_1 = null;
  }
  function get_KTOR_DEFAULT_USER_AGENT() {
    _init_properties_Utils_kt__jo07cx();
    return KTOR_DEFAULT_USER_AGENT;
  }
  var KTOR_DEFAULT_USER_AGENT;
  function get_DATE_HEADERS() {
    _init_properties_Utils_kt__jo07cx();
    return DATE_HEADERS;
  }
  var DATE_HEADERS;
  function Companion_384() {
  }
  var Companion_instance_384;
  function Companion_getInstance_384() {
    return Companion_instance_384;
  }
  function KtorCallContextElement(callContext) {
    this.drj_1 = callContext;
  }
  protoOf(KtorCallContextElement).z = function () {
    return Companion_instance_384;
  };
  function callContext($completion) {
    // Inline function 'kotlin.js.getCoroutineContext' call
    var tmp$ret$0 = $completion.l9();
    return ensureNotNull(tmp$ret$0.s9(Companion_instance_384)).drj_1;
  }
  function mergeHeaders(requestHeaders, content, block) {
    _init_properties_Utils_kt__jo07cx();
    var tmp = buildHeaders(mergeHeaders$lambda(requestHeaders, content));
    tmp.mdw(mergeHeaders$lambda_0(block));
    var missingAgent = requestHeaders.ld(HttpHeaders_getInstance().or1_1) == null && content.tr2().ld(HttpHeaders_getInstance().or1_1) == null;
    if (missingAgent && needUserAgent()) {
      block(HttpHeaders_getInstance().or1_1, get_KTOR_DEFAULT_USER_AGENT());
    }
    var tmp0_safe_receiver = content.ur7();
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.toString();
    var tmp2_elvis_lhs = tmp1_elvis_lhs == null ? content.tr2().ld(HttpHeaders_getInstance().iqz_1) : tmp1_elvis_lhs;
    var type = tmp2_elvis_lhs == null ? requestHeaders.ld(HttpHeaders_getInstance().iqz_1) : tmp2_elvis_lhs;
    var tmp3_safe_receiver = content.vr7();
    var tmp4_elvis_lhs = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.toString();
    var tmp5_elvis_lhs = tmp4_elvis_lhs == null ? content.tr2().ld(HttpHeaders_getInstance().fqz_1) : tmp4_elvis_lhs;
    var length = tmp5_elvis_lhs == null ? requestHeaders.ld(HttpHeaders_getInstance().fqz_1) : tmp5_elvis_lhs;
    if (type == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      block(HttpHeaders_getInstance().iqz_1, type);
    }
    if (length == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      block(HttpHeaders_getInstance().fqz_1, length);
    }
  }
  function needUserAgent() {
    _init_properties_Utils_kt__jo07cx();
    return !PlatformUtils_getInstance().bdw_1;
  }
  function mergeHeaders$lambda($requestHeaders, $content) {
    return function ($this$buildHeaders) {
      $this$buildHeaders.udw($requestHeaders);
      $this$buildHeaders.udw($content.tr2());
      return Unit_instance;
    };
  }
  function mergeHeaders$lambda_0($block) {
    return function (key, values) {
      var tmp;
      if (HttpHeaders_getInstance().fqz_1 === key) {
        return Unit_instance;
      }
      var tmp_0;
      if (HttpHeaders_getInstance().iqz_1 === key) {
        return Unit_instance;
      }
      var tmp_1;
      if (get_DATE_HEADERS().t(key)) {
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s = values.m();
        while (_iterator__ex2g4s.n()) {
          var element = _iterator__ex2g4s.o();
          $block(key, element);
        }
        tmp_1 = Unit_instance;
      } else {
        var separator = HttpHeaders_getInstance().jqz_1 === key ? '; ' : ',';
        tmp_1 = $block(key, joinToString_0(values, separator));
      }
      return Unit_instance;
    };
  }
  var properties_initialized_Utils_kt_xvi83j;
  function _init_properties_Utils_kt__jo07cx() {
    if (!properties_initialized_Utils_kt_xvi83j) {
      properties_initialized_Utils_kt_xvi83j = true;
      KTOR_DEFAULT_USER_AGENT = 'Ktor client';
      DATE_HEADERS = setOf_0([HttpHeaders_getInstance().lqz_1, HttpHeaders_getInstance().rqz_1, HttpHeaders_getInstance().dr0_1, HttpHeaders_getInstance().yqz_1, HttpHeaders_getInstance().cr0_1]);
    }
  }
  function get_UploadProgressListenerAttributeKey() {
    _init_properties_BodyProgress_kt__s0v569();
    return UploadProgressListenerAttributeKey;
  }
  var UploadProgressListenerAttributeKey;
  function get_DownloadProgressListenerAttributeKey() {
    _init_properties_BodyProgress_kt__s0v569();
    return DownloadProgressListenerAttributeKey;
  }
  var DownloadProgressListenerAttributeKey;
  function handle_0($this, scope) {
    var observableContentPhase = new PipelinePhase('ObservableContent');
    scope.tra_1.kdz(Phases_getInstance().hrj_1, observableContentPhase);
    scope.tra_1.ndz(observableContentPhase, BodyProgress$handle$slambda_0(null));
    var tmp = Phases_getInstance_2().lrj_1;
    scope.wra_1.ndz(tmp, BodyProgress$handle$slambda_2(null));
  }
  function Plugin() {
    Plugin_instance = this;
    this.mrj_1 = new AttributeKey('BodyProgress');
  }
  protoOf(Plugin).z = function () {
    return this.mrj_1;
  };
  protoOf(Plugin).nrj = function (block) {
    return new BodyProgress();
  };
  protoOf(Plugin).wrd = function (block) {
    return this.nrj(block);
  };
  protoOf(Plugin).orj = function (plugin, scope) {
    handle_0(plugin, scope);
  };
  protoOf(Plugin).xrd = function (plugin, scope) {
    return this.orj(plugin instanceof BodyProgress ? plugin : THROW_CCE(), scope);
  };
  var Plugin_instance;
  function Plugin_getInstance() {
    if (Plugin_instance == null)
      new Plugin();
    return Plugin_instance;
  }
  function BodyProgress$handle$slambda(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(BodyProgress$handle$slambda).mrb = function ($this$intercept, content, $completion) {
    var tmp = this.nrb($this$intercept, content, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(BodyProgress$handle$slambda).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof PipelineContext ? p1 : THROW_CCE();
    return this.mrb(tmp, !(p2 == null) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(BodyProgress$handle$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            var tmp0_elvis_lhs = this.xrj_1.jdz_1.xrc_1.mdu(get_UploadProgressListenerAttributeKey());
            var tmp_0;
            if (tmp0_elvis_lhs == null) {
              return Unit_instance;
            } else {
              tmp_0 = tmp0_elvis_lhs;
            }

            var listener = tmp_0;
            var tmp_1 = this.yrj_1;
            var observableContent = new ObservableContent(tmp_1 instanceof OutgoingContent ? tmp_1 : THROW_CCE(), this.xrj_1.jdz_1.wrc_1, listener);
            this.f9_1 = 1;
            suspendResult = this.xrj_1.ndy(observableContent, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(BodyProgress$handle$slambda).nrb = function ($this$intercept, content, completion) {
    var i = new BodyProgress$handle$slambda(completion);
    i.xrj_1 = $this$intercept;
    i.yrj_1 = content;
    return i;
  };
  function BodyProgress$handle$slambda_0(resultContinuation) {
    var i = new BodyProgress$handle$slambda(resultContinuation);
    var l = function ($this$intercept, content, $completion) {
      return i.mrb($this$intercept, content, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function BodyProgress$handle$slambda_1(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(BodyProgress$handle$slambda_1).jrk = function ($this$intercept, response, $completion) {
    var tmp = this.krk($this$intercept, response, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(BodyProgress$handle$slambda_1).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof PipelineContext ? p1 : THROW_CCE();
    return this.jrk(tmp, p2 instanceof HttpResponse ? p2 : THROW_CCE(), $completion);
  };
  protoOf(BodyProgress$handle$slambda_1).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            var tmp0_elvis_lhs = this.irk_1.vrf().yre().gre().mdu(get_DownloadProgressListenerAttributeKey());
            var tmp_0;
            if (tmp0_elvis_lhs == null) {
              return Unit_instance;
            } else {
              tmp_0 = tmp0_elvis_lhs;
            }

            var listener = tmp_0;
            var observableResponse = withObservableDownload(this.irk_1, listener);
            this.f9_1 = 1;
            suspendResult = this.hrk_1.ndy(observableResponse, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(BodyProgress$handle$slambda_1).krk = function ($this$intercept, response, completion) {
    var i = new BodyProgress$handle$slambda_1(completion);
    i.hrk_1 = $this$intercept;
    i.irk_1 = response;
    return i;
  };
  function BodyProgress$handle$slambda_2(resultContinuation) {
    var i = new BodyProgress$handle$slambda_1(resultContinuation);
    var l = function ($this$intercept, response, $completion) {
      return i.jrk($this$intercept, response, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function BodyProgress() {
    Plugin_getInstance();
  }
  function withObservableDownload(_this__u8e3s4, listener) {
    _init_properties_BodyProgress_kt__s0v569();
    var observableByteChannel = observable(_this__u8e3s4.h63(), _this__u8e3s4.ho(), contentLength(_this__u8e3s4), listener);
    return wrapWithContent(_this__u8e3s4.vrf(), observableByteChannel).trb();
  }
  var properties_initialized_BodyProgress_kt_pmfrhr;
  function _init_properties_BodyProgress_kt__s0v569() {
    if (!properties_initialized_BodyProgress_kt_pmfrhr) {
      properties_initialized_BodyProgress_kt_pmfrhr = true;
      UploadProgressListenerAttributeKey = new AttributeKey('UploadProgressListenerAttributeKey');
      DownloadProgressListenerAttributeKey = new AttributeKey('DownloadProgressListenerAttributeKey');
    }
  }
  function get_ValidateMark() {
    _init_properties_DefaultResponseValidation_kt__wcn8vr();
    return ValidateMark;
  }
  var ValidateMark;
  function get_LOGGER_0() {
    _init_properties_DefaultResponseValidation_kt__wcn8vr();
    return LOGGER_0;
  }
  var LOGGER_0;
  function addDefaultResponseValidation(_this__u8e3s4) {
    _init_properties_DefaultResponseValidation_kt__wcn8vr();
    HttpResponseValidator(_this__u8e3s4, addDefaultResponseValidation$lambda(_this__u8e3s4));
  }
  function ResponseException(response, cachedResponseText) {
    IllegalStateException_init_$Init$_0('Bad response: ' + response.toString() + '. Text: "' + cachedResponseText + '"', this);
    captureStack(this, ResponseException);
    this.lrk_1 = response;
  }
  function RedirectResponseException(response, cachedResponseText) {
    ResponseException.call(this, response, cachedResponseText);
    captureStack(this, RedirectResponseException);
    this.nrk_1 = 'Unhandled redirect: ' + response.vrf().yre().wrf().cr3_1 + ' ' + response.vrf().yre().qfs().toString() + '. ' + ('Status: ' + response.arf().toString() + '. Text: "' + cachedResponseText + '"');
    delete this.message;
  }
  protoOf(RedirectResponseException).e = function () {
    return this.nrk_1;
  };
  function ClientRequestException(response, cachedResponseText) {
    ResponseException.call(this, response, cachedResponseText);
    captureStack(this, ClientRequestException);
    this.prk_1 = 'Client request(' + response.vrf().yre().wrf().cr3_1 + ' ' + response.vrf().yre().qfs().toString() + ') ' + ('invalid: ' + response.arf().toString() + '. Text: "' + cachedResponseText + '"');
    delete this.message;
  }
  protoOf(ClientRequestException).e = function () {
    return this.prk_1;
  };
  function ServerResponseException(response, cachedResponseText) {
    ResponseException.call(this, response, cachedResponseText);
    captureStack(this, ServerResponseException);
    this.rrk_1 = 'Server error(' + response.vrf().yre().wrf().cr3_1 + ' ' + response.vrf().yre().qfs().toString() + ': ' + (response.arf().toString() + '. Text: "' + cachedResponseText + '"');
    delete this.message;
  }
  protoOf(ServerResponseException).e = function () {
    return this.rrk_1;
  };
  function addDefaultResponseValidation$lambda$slambda(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(addDefaultResponseValidation$lambda$slambda).erl = function (response, $completion) {
    var tmp = this.frl(response, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(addDefaultResponseValidation$lambda$slambda).v9 = function (p1, $completion) {
    return this.erl(p1 instanceof HttpResponse ? p1 : THROW_CCE(), $completion);
  };
  protoOf(addDefaultResponseValidation$lambda$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 5;
            var expectSuccess = this.arl_1.vrf().gre().ldu(get_ExpectSuccessAttributeKey());
            if (!expectSuccess) {
              get_LOGGER_0().fe0('Skipping default response validation for ' + this.arl_1.vrf().yre().qfs().toString());
              return Unit_instance;
            }

            this.crl_1 = this.arl_1.arf().or5_1;
            var originCall = this.arl_1.vrf();
            if (this.crl_1 < 300 || originCall.gre().ndu(get_ValidateMark())) {
              return Unit_instance;
            }

            this.f9_1 = 1;
            suspendResult = save(originCall, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var this_0 = suspendResult;
            this_0.gre().odu(get_ValidateMark(), Unit_instance);
            var exceptionCall = this_0;
            this.brl_1 = exceptionCall.trb();
            this.g9_1 = 3;
            this.f9_1 = 2;
            suspendResult = bodyAsText(this.brl_1, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.drl_1 = suspendResult;
            this.g9_1 = 5;
            this.f9_1 = 4;
            continue $sm;
          case 3:
            this.g9_1 = 5;
            var tmp_0 = this.i9_1;
            if (tmp_0 instanceof MalformedInputException) {
              var _ = this.i9_1;
              var tmp_1 = this;
              tmp_1.drl_1 = '<body failed decoding>';
              this.f9_1 = 4;
              continue $sm;
            } else {
              throw this.i9_1;
            }

          case 4:
            this.g9_1 = 5;
            var exceptionResponseText = this.drl_1;
            var tmp0_subject = this.crl_1;
            var exception = (300 <= tmp0_subject ? tmp0_subject <= 399 : false) ? new RedirectResponseException(this.brl_1, exceptionResponseText) : (400 <= tmp0_subject ? tmp0_subject <= 499 : false) ? new ClientRequestException(this.brl_1, exceptionResponseText) : (500 <= tmp0_subject ? tmp0_subject <= 599 : false) ? new ServerResponseException(this.brl_1, exceptionResponseText) : new ResponseException(this.brl_1, exceptionResponseText);
            get_LOGGER_0().fe0('Default response validation for ' + this.arl_1.vrf().yre().qfs().toString() + ' failed with ' + exception.toString());
            throw exception;
          case 5:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 5) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(addDefaultResponseValidation$lambda$slambda).frl = function (response, completion) {
    var i = new addDefaultResponseValidation$lambda$slambda(completion);
    i.arl_1 = response;
    return i;
  };
  function addDefaultResponseValidation$lambda$slambda_0(resultContinuation) {
    var i = new addDefaultResponseValidation$lambda$slambda(resultContinuation);
    var l = function (response, $completion) {
      return i.erl(response, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function addDefaultResponseValidation$lambda($this_addDefaultResponseValidation) {
    return function ($this$HttpResponseValidator) {
      $this$HttpResponseValidator.irl_1 = $this_addDefaultResponseValidation.erd_1;
      $this$HttpResponseValidator.jrl(addDefaultResponseValidation$lambda$slambda_0(null));
      return Unit_instance;
    };
  }
  var properties_initialized_DefaultResponseValidation_kt_akvzqt;
  function _init_properties_DefaultResponseValidation_kt__wcn8vr() {
    if (!properties_initialized_DefaultResponseValidation_kt_akvzqt) {
      properties_initialized_DefaultResponseValidation_kt_akvzqt = true;
      ValidateMark = new AttributeKey('ValidateMark');
      LOGGER_0 = KtorSimpleLogger('io.ktor.client.plugins.DefaultResponseValidation');
    }
  }
  function get_LOGGER_1() {
    _init_properties_DefaultTransform_kt__20knxx();
    return LOGGER_1;
  }
  var LOGGER_1;
  function defaultTransformers(_this__u8e3s4) {
    _init_properties_DefaultTransform_kt__20knxx();
    var tmp = Phases_getInstance().hrj_1;
    _this__u8e3s4.tra_1.ndz(tmp, defaultTransformers$slambda_0(null));
    var tmp_0 = Phases_getInstance_1().qrd_1;
    _this__u8e3s4.ura_1.ndz(tmp_0, defaultTransformers$slambda_2(null));
    platformResponseDefaultTransformers(_this__u8e3s4);
  }
  function defaultTransformers$2$content$1($contentType, $body) {
    this.nrl_1 = $body;
    ByteArrayContent_0.call(this);
    var tmp = this;
    tmp.lrl_1 = $contentType == null ? Application_getInstance().hqx_1 : $contentType;
    this.mrl_1 = fromInt_0($body.length);
  }
  protoOf(defaultTransformers$2$content$1).ur7 = function () {
    return this.lrl_1;
  };
  protoOf(defaultTransformers$2$content$1).vr7 = function () {
    return this.mrl_1;
  };
  protoOf(defaultTransformers$2$content$1).wr7 = function () {
    return this.nrl_1;
  };
  function defaultTransformers$2$content$2($this_intercept, $contentType, $body) {
    this.rrl_1 = $body;
    ReadChannelContent.call(this);
    var tmp = this;
    var tmp0_safe_receiver = $this_intercept.jdz_1.urc_1.ld(HttpHeaders_getInstance().fqz_1);
    tmp.prl_1 = tmp0_safe_receiver == null ? null : toLong(tmp0_safe_receiver);
    var tmp_0 = this;
    tmp_0.qrl_1 = $contentType == null ? Application_getInstance().hqx_1 : $contentType;
  }
  protoOf(defaultTransformers$2$content$2).vr7 = function () {
    return this.prl_1;
  };
  protoOf(defaultTransformers$2$content$2).ur7 = function () {
    return this.qrl_1;
  };
  protoOf(defaultTransformers$2$content$2).zr7 = function () {
    return this.rrl_1;
  };
  function defaultTransformers$slambda(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(defaultTransformers$slambda).mrb = function ($this$intercept, body, $completion) {
    var tmp = this.nrb($this$intercept, body, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(defaultTransformers$slambda).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof PipelineContext ? p1 : THROW_CCE();
    return this.mrb(tmp, !(p2 == null) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(defaultTransformers$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 3;
            if (this.arm_1.jdz_1.urc_1.ld(HttpHeaders_getInstance().qqy_1) == null) {
              this.arm_1.jdz_1.urc_1.tdw(HttpHeaders_getInstance().qqy_1, '*/*');
            }

            var contentType_0 = contentType(this.arm_1.jdz_1);
            var tmp0_subject = this.brm_1;
            var tmp_0;
            if (typeof tmp0_subject === 'string') {
              tmp_0 = new TextContent(this.brm_1, contentType_0 == null ? Text_getInstance().xqx_1 : contentType_0);
            } else {
              if (isByteArray(tmp0_subject)) {
                tmp_0 = new defaultTransformers$2$content$1(contentType_0, this.brm_1);
              } else {
                if (isInterface(tmp0_subject, ByteReadChannel_1)) {
                  tmp_0 = new defaultTransformers$2$content$2(this.arm_1, contentType_0, this.brm_1);
                } else {
                  if (tmp0_subject instanceof OutgoingContent) {
                    tmp_0 = this.brm_1;
                  } else {
                    tmp_0 = platformRequestDefaultTransform(contentType_0, this.arm_1.jdz_1, this.brm_1);
                  }
                }
              }
            }

            var content = tmp_0;
            if (!((content == null ? null : content.ur7()) == null)) {
              this.arm_1.jdz_1.urc_1.vdw(HttpHeaders_getInstance().iqz_1);
              get_LOGGER_1().fe0('Transformed with default transformers request body for ' + this.arm_1.jdz_1.src_1.toString() + ' from ' + toString_1(getKClassFromExpression(this.brm_1)));
              this.f9_1 = 1;
              suspendResult = this.arm_1.ndy(content, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.f9_1 = 2;
              continue $sm;
            }

          case 1:
            this.f9_1 = 2;
            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 3) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(defaultTransformers$slambda).nrb = function ($this$intercept, body, completion) {
    var i = new defaultTransformers$slambda(completion);
    i.arm_1 = $this$intercept;
    i.brm_1 = body;
    return i;
  };
  function defaultTransformers$slambda_0(resultContinuation) {
    var i = new defaultTransformers$slambda(resultContinuation);
    var l = function ($this$intercept, body, $completion) {
      return i.mrb($this$intercept, body, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function defaultTransformers$slambda$slambda($body, $response, resultContinuation) {
    this.krm_1 = $body;
    this.lrm_1 = $response;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(defaultTransformers$slambda$slambda).trg = function ($this$writer, $completion) {
    var tmp = this.urg($this$writer, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(defaultTransformers$slambda$slambda).v9 = function (p1, $completion) {
    return this.trg((!(p1 == null) ? isInterface(p1, WriterScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(defaultTransformers$slambda$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 5;
            this.f9_1 = 1;
            continue $sm;
          case 1:
            this.g9_1 = 4;
            this.g9_1 = 3;
            this.f9_1 = 2;
            suspendResult = copyTo(this.krm_1, this.mrm_1.d11(), 9223372036854775807n, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.g9_1 = 5;
            this.f9_1 = 6;
            continue $sm;
          case 3:
            this.g9_1 = 4;
            var tmp_0 = this.i9_1;
            if (tmp_0 instanceof CancellationException) {
              var cause = this.i9_1;
              cancel(this.lrm_1, cause);
              throw cause;
            } else {
              var tmp_1 = this.i9_1;
              if (tmp_1 instanceof Error) {
                var cause_0 = this.i9_1;
                cancel_0(this.lrm_1, 'Receive failed', cause_0);
                throw cause_0;
              } else {
                throw this.i9_1;
              }
            }

          case 4:
            this.g9_1 = 5;
            var t = this.i9_1;
            complete_0(this.lrm_1);
            throw t;
          case 5:
            throw this.i9_1;
          case 6:
            this.g9_1 = 5;
            complete_0(this.lrm_1);
            return Unit_instance;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 5) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(defaultTransformers$slambda$slambda).urg = function ($this$writer, completion) {
    var i = new defaultTransformers$slambda$slambda(this.krm_1, this.lrm_1, completion);
    i.mrm_1 = $this$writer;
    return i;
  };
  function defaultTransformers$slambda$slambda_0($body, $response, resultContinuation) {
    var i = new defaultTransformers$slambda$slambda($body, $response, resultContinuation);
    var l = function ($this$writer, $completion) {
      return i.trg($this$writer, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function defaultTransformers$slambda$lambda($responseJobHolder) {
    return function (it) {
      $responseJobHolder.su();
      return Unit_instance;
    };
  }
  function defaultTransformers$slambda_1(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(defaultTransformers$slambda_1).grc = function ($this$intercept, _name_for_destructuring_parameter_0__wldtmu, $completion) {
    var tmp = this.hrc($this$intercept, _name_for_destructuring_parameter_0__wldtmu, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(defaultTransformers$slambda_1).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof PipelineContext ? p1 : THROW_CCE();
    return this.grc(tmp, p2 instanceof HttpResponseContainer ? p2 : THROW_CCE(), $completion);
  };
  protoOf(defaultTransformers$slambda_1).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 11;
            this.xrm_1 = this.wrm_1.fg();
            var body = this.wrm_1.gg();
            if (!isInterface(body, ByteReadChannel_1))
              return Unit_instance;
            this.zrm_1 = this.vrm_1.jdz_1.trb();
            var tmp0_subject = this.xrm_1.ae0_1;
            if (tmp0_subject.equals(getKClass(Unit))) {
              cancel_3(body);
              this.f9_1 = 9;
              suspendResult = this.vrm_1.ndy(new HttpResponseContainer(this.xrm_1, Unit_instance), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              if (tmp0_subject.equals(PrimitiveClasses_getInstance().ob())) {
                this.f9_1 = 7;
                suspendResult = body.hdm(VOID, this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                if (tmp0_subject.equals(getKClass(ByteReadPacket)) ? true : tmp0_subject.equals(getKClass(Input))) {
                  this.f9_1 = 5;
                  suspendResult = body.hdm(VOID, this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  continue $sm;
                } else {
                  if (tmp0_subject.equals(PrimitiveClasses_getInstance().xb())) {
                    this.f9_1 = 3;
                    suspendResult = toByteArray(body, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) {
                      return suspendResult;
                    }
                    continue $sm;
                  } else {
                    if (tmp0_subject.equals(getKClass(ByteReadChannel_1))) {
                      var responseJobHolder = Job_0(this.zrm_1.ho().s9(Key_instance_3));
                      var tmp_0 = this.zrm_1.ho();
                      var this_0 = writer(this.vrm_1, tmp_0, VOID, defaultTransformers$slambda$slambda_0(body, this.zrm_1, null));
                      this_0.kp(defaultTransformers$slambda$lambda(responseJobHolder));
                      var channel = this_0.d11();
                      this.f9_1 = 2;
                      suspendResult = this.vrm_1.ndy(new HttpResponseContainer(this.xrm_1, channel), this);
                      if (suspendResult === get_COROUTINE_SUSPENDED()) {
                        return suspendResult;
                      }
                      continue $sm;
                    } else {
                      if (tmp0_subject.equals(getKClass(HttpStatusCode))) {
                        cancel_3(body);
                        this.f9_1 = 1;
                        suspendResult = this.vrm_1.ndy(new HttpResponseContainer(this.xrm_1, this.zrm_1.arf()), this);
                        if (suspendResult === get_COROUTINE_SUSPENDED()) {
                          return suspendResult;
                        }
                        continue $sm;
                      } else {
                        this.yrm_1 = null;
                        this.f9_1 = 10;
                        continue $sm;
                      }
                    }
                  }
                }
              }
            }

          case 1:
            this.yrm_1 = suspendResult;
            this.f9_1 = 10;
            continue $sm;
          case 2:
            this.yrm_1 = suspendResult;
            this.f9_1 = 10;
            continue $sm;
          case 3:
            var bytes = suspendResult;
            var contentLength_0 = contentLength(this.zrm_1);
            var notEncoded = !PlatformUtils_getInstance().bdw_1 && this.zrm_1.tr2().ld(HttpHeaders_getInstance().dqz_1) == null;
            var notHead = !this.vrm_1.jdz_1.yre().wrf().equals(Companion_getInstance_376().zr2_1);
            if (notEncoded && notHead && !(contentLength_0 == null) && contentLength_0 > 0n) {
              if (!(bytes.length === convertToInt(contentLength_0))) {
                var message = 'Expected ' + toString_0(contentLength_0) + ', actual ' + bytes.length;
                throw IllegalStateException_init_$Create$_0(toString_1(message));
              }
            }

            this.f9_1 = 4;
            suspendResult = this.vrm_1.ndy(new HttpResponseContainer(this.xrm_1, bytes), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            this.yrm_1 = suspendResult;
            this.f9_1 = 10;
            continue $sm;
          case 5:
            var ARGUMENT = suspendResult;
            var ARGUMENT_0 = new HttpResponseContainer(this.xrm_1, ARGUMENT);
            this.f9_1 = 6;
            suspendResult = this.vrm_1.ndy(ARGUMENT_0, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 6:
            this.yrm_1 = suspendResult;
            this.f9_1 = 10;
            continue $sm;
          case 7:
            var ARGUMENT_1 = suspendResult.ldq();
            var ARGUMENT_2 = toInt(ARGUMENT_1);
            var ARGUMENT_3 = new HttpResponseContainer(this.xrm_1, ARGUMENT_2);
            this.f9_1 = 8;
            suspendResult = this.vrm_1.ndy(ARGUMENT_3, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 8:
            this.yrm_1 = suspendResult;
            this.f9_1 = 10;
            continue $sm;
          case 9:
            this.yrm_1 = suspendResult;
            this.f9_1 = 10;
            continue $sm;
          case 10:
            var result = this.yrm_1;
            if (!(result == null)) {
              get_LOGGER_1().fe0('Transformed with default transformers response body ' + ('for ' + this.vrm_1.jdz_1.yre().qfs().toString() + ' to ' + toString_1(this.xrm_1.ae0_1)));
            }

            return Unit_instance;
          case 11:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 11) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(defaultTransformers$slambda_1).hrc = function ($this$intercept, _name_for_destructuring_parameter_0__wldtmu, completion) {
    var i = new defaultTransformers$slambda_1(completion);
    i.vrm_1 = $this$intercept;
    i.wrm_1 = _name_for_destructuring_parameter_0__wldtmu;
    return i;
  };
  function defaultTransformers$slambda_2(resultContinuation) {
    var i = new defaultTransformers$slambda_1(resultContinuation);
    var l = function ($this$intercept, _name_for_destructuring_parameter_0__wldtmu, $completion) {
      return i.grc($this$intercept, _name_for_destructuring_parameter_0__wldtmu, $completion);
    };
    l.$arity = 2;
    return l;
  }
  var properties_initialized_DefaultTransform_kt_ossax9;
  function _init_properties_DefaultTransform_kt__20knxx() {
    if (!properties_initialized_DefaultTransform_kt_ossax9) {
      properties_initialized_DefaultTransform_kt_ossax9 = true;
      LOGGER_1 = KtorSimpleLogger('io.ktor.client.plugins.defaultTransformers');
    }
  }
  function get_LOGGER_2() {
    _init_properties_HttpCallValidator_kt__r6yh2y();
    return LOGGER_2;
  }
  var LOGGER_2;
  function get_ExpectSuccessAttributeKey() {
    _init_properties_HttpCallValidator_kt__r6yh2y();
    return ExpectSuccessAttributeKey;
  }
  var ExpectSuccessAttributeKey;
  function HttpCallValidator$Companion$install$slambda$lambda($plugin) {
    return function () {
      return $plugin.crn_1;
    };
  }
  function HttpCallValidator$Companion$install$slambda($plugin, resultContinuation) {
    this.lrn_1 = $plugin;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(HttpCallValidator$Companion$install$slambda).mrb = function ($this$intercept, it, $completion) {
    var tmp = this.nrb($this$intercept, it, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(HttpCallValidator$Companion$install$slambda).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof PipelineContext ? p1 : THROW_CCE();
    return this.mrb(tmp, !(p2 == null) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(HttpCallValidator$Companion$install$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 5;
            this.g9_1 = 3;
            var tmp_0 = get_ExpectSuccessAttributeKey();
            this.mrn_1.jdz_1.xrc_1.qdu(tmp_0, HttpCallValidator$Companion$install$slambda$lambda(this.lrn_1));
            this.f9_1 = 1;
            suspendResult = this.mrn_1.ndy(this.nrn_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.g9_1 = 5;
            this.f9_1 = 2;
            continue $sm;
          case 2:
            this.g9_1 = 5;
            return Unit_instance;
          case 3:
            this.g9_1 = 5;
            var tmp_1 = this.i9_1;
            if (tmp_1 instanceof Error) {
              var cause = this.i9_1;
              this.orn_1 = unwrapCancellationException_0(cause);
              this.f9_1 = 4;
              suspendResult = processException(this.lrn_1, this.orn_1, HttpRequest(this.mrn_1.jdz_1), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              throw this.i9_1;
            }

          case 4:
            throw this.orn_1;
          case 5:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 5) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(HttpCallValidator$Companion$install$slambda).nrb = function ($this$intercept, it, completion) {
    var i = new HttpCallValidator$Companion$install$slambda(this.lrn_1, completion);
    i.mrn_1 = $this$intercept;
    i.nrn_1 = it;
    return i;
  };
  function HttpCallValidator$Companion$install$slambda_0($plugin, resultContinuation) {
    var i = new HttpCallValidator$Companion$install$slambda($plugin, resultContinuation);
    var l = function ($this$intercept, it, $completion) {
      return i.mrb($this$intercept, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function HttpCallValidator$Companion$install$slambda_1($plugin, resultContinuation) {
    this.xrn_1 = $plugin;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(HttpCallValidator$Companion$install$slambda_1).grc = function ($this$intercept, container, $completion) {
    var tmp = this.hrc($this$intercept, container, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(HttpCallValidator$Companion$install$slambda_1).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof PipelineContext ? p1 : THROW_CCE();
    return this.grc(tmp, p2 instanceof HttpResponseContainer ? p2 : THROW_CCE(), $completion);
  };
  protoOf(HttpCallValidator$Companion$install$slambda_1).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 5;
            this.g9_1 = 3;
            this.f9_1 = 1;
            suspendResult = this.yrn_1.ndy(this.zrn_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.g9_1 = 5;
            this.f9_1 = 2;
            continue $sm;
          case 2:
            this.g9_1 = 5;
            return Unit_instance;
          case 3:
            this.g9_1 = 5;
            var tmp_0 = this.i9_1;
            if (tmp_0 instanceof Error) {
              var cause = this.i9_1;
              this.aro_1 = unwrapCancellationException_0(cause);
              this.f9_1 = 4;
              suspendResult = processException(this.xrn_1, this.aro_1, this.yrn_1.jdz_1.yre(), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              throw this.i9_1;
            }

          case 4:
            throw this.aro_1;
          case 5:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 5) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(HttpCallValidator$Companion$install$slambda_1).hrc = function ($this$intercept, container, completion) {
    var i = new HttpCallValidator$Companion$install$slambda_1(this.xrn_1, completion);
    i.yrn_1 = $this$intercept;
    i.zrn_1 = container;
    return i;
  };
  function HttpCallValidator$Companion$install$slambda_2($plugin, resultContinuation) {
    var i = new HttpCallValidator$Companion$install$slambda_1($plugin, resultContinuation);
    var l = function ($this$intercept, container, $completion) {
      return i.grc($this$intercept, container, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function HttpCallValidator$Companion$install$slambda_3($plugin, resultContinuation) {
    this.jro_1 = $plugin;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(HttpCallValidator$Companion$install$slambda_3).nro = function ($this$intercept, request, $completion) {
    var tmp = this.oro($this$intercept, request, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(HttpCallValidator$Companion$install$slambda_3).w9 = function (p1, p2, $completion) {
    var tmp = (!(p1 == null) ? isInterface(p1, Sender) : false) ? p1 : THROW_CCE();
    return this.nro(tmp, p2 instanceof HttpRequestBuilder ? p2 : THROW_CCE(), $completion);
  };
  protoOf(HttpCallValidator$Companion$install$slambda_3).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 3;
            this.f9_1 = 1;
            suspendResult = this.kro_1.pro(this.lro_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.mro_1 = suspendResult;
            this.f9_1 = 2;
            suspendResult = validateResponse(this.jro_1, this.mro_1.trb(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return this.mro_1;
          case 3:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 3) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(HttpCallValidator$Companion$install$slambda_3).oro = function ($this$intercept, request, completion) {
    var i = new HttpCallValidator$Companion$install$slambda_3(this.jro_1, completion);
    i.kro_1 = $this$intercept;
    i.lro_1 = request;
    return i;
  };
  function HttpCallValidator$Companion$install$slambda_4($plugin, resultContinuation) {
    var i = new HttpCallValidator$Companion$install$slambda_3($plugin, resultContinuation);
    var l = function ($this$intercept, request, $completion) {
      return i.nro($this$intercept, request, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function validateResponse($this, response, $completion) {
    var tmp = new $validateResponseCOROUTINE$($this, response, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  }
  function processException($this, cause, request, $completion) {
    var tmp = new $processExceptionCOROUTINE$($this, cause, request, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  }
  function Config() {
    var tmp = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp.grl_1 = ArrayList_init_$Create$();
    var tmp_0 = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp_0.hrl_1 = ArrayList_init_$Create$();
    this.irl_1 = true;
  }
  protoOf(Config).jrl = function (block) {
    // Inline function 'kotlin.collections.plusAssign' call
    this.grl_1.j(block);
  };
  function Companion_385() {
    Companion_instance_385 = this;
    this.nrp_1 = new AttributeKey('HttpResponseValidator');
  }
  protoOf(Companion_385).z = function () {
    return this.nrp_1;
  };
  protoOf(Companion_385).orp = function (block) {
    // Inline function 'kotlin.apply' call
    var this_0 = new Config();
    block(this_0);
    var config = this_0;
    return new HttpCallValidator(reversed(config.grl_1), reversed(config.hrl_1), config.irl_1);
  };
  protoOf(Companion_385).wrd = function (block) {
    return this.orp(block);
  };
  protoOf(Companion_385).prp = function (plugin_0, scope) {
    var tmp = Phases_getInstance().erj_1;
    scope.tra_1.ndz(tmp, HttpCallValidator$Companion$install$slambda_0(plugin_0, null));
    var BeforeReceive = new PipelinePhase('BeforeReceive');
    scope.ura_1.mdz(Phases_getInstance_1().prd_1, BeforeReceive);
    scope.ura_1.ndz(BeforeReceive, HttpCallValidator$Companion$install$slambda_2(plugin_0, null));
    var tmp_0 = plugin(scope, Plugin_getInstance_3());
    tmp_0.srp(HttpCallValidator$Companion$install$slambda_4(plugin_0, null));
  };
  protoOf(Companion_385).xrd = function (plugin, scope) {
    return this.prp(plugin instanceof HttpCallValidator ? plugin : THROW_CCE(), scope);
  };
  var Companion_instance_385;
  function Companion_getInstance_385() {
    if (Companion_instance_385 == null)
      new Companion_385();
    return Companion_instance_385;
  }
  function $validateResponseCOROUTINE$(_this__u8e3s4, response, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.yro_1 = _this__u8e3s4;
    this.zro_1 = response;
  }
  protoOf($validateResponseCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 4;
            get_LOGGER_2().fe0('Validating response for request ' + this.zro_1.vrf().yre().qfs().toString());
            this.arp_1 = this.yro_1.arn_1.m();
            this.f9_1 = 1;
            continue $sm;
          case 1:
            if (!this.arp_1.n()) {
              this.f9_1 = 3;
              continue $sm;
            }

            var element = this.arp_1.o();
            this.f9_1 = 2;
            suspendResult = element(this.zro_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.f9_1 = 1;
            continue $sm;
          case 3:
            return Unit_instance;
          case 4:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 4) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function $processExceptionCOROUTINE$(_this__u8e3s4, cause, request, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.jrp_1 = _this__u8e3s4;
    this.krp_1 = cause;
    this.lrp_1 = request;
  }
  protoOf($processExceptionCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 6;
            get_LOGGER_2().fe0('Processing exception ' + this.krp_1.toString() + ' for request ' + this.lrp_1.qfs().toString());
            this.mrp_1 = this.jrp_1.brn_1.m();
            this.f9_1 = 1;
            continue $sm;
          case 1:
            if (!this.mrp_1.n()) {
              this.f9_1 = 5;
              continue $sm;
            }

            var element = this.mrp_1.o();
            if (element instanceof ExceptionHandlerWrapper) {
              this.f9_1 = 3;
              suspendResult = element.urp_1(this.krp_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              if (element instanceof RequestExceptionHandlerWrapper) {
                this.f9_1 = 2;
                suspendResult = element.trp_1(this.krp_1, this.lrp_1, this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                this.f9_1 = 4;
                continue $sm;
              }
            }

          case 2:
            this.f9_1 = 4;
            continue $sm;
          case 3:
            this.f9_1 = 4;
            continue $sm;
          case 4:
            this.f9_1 = 1;
            continue $sm;
          case 5:
            return Unit_instance;
          case 6:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 6) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function HttpCallValidator(responseValidators, callExceptionHandlers, expectSuccess) {
    Companion_getInstance_385();
    this.arn_1 = responseValidators;
    this.brn_1 = callExceptionHandlers;
    this.crn_1 = expectSuccess;
  }
  function HttpResponseValidator(_this__u8e3s4, block) {
    _init_properties_HttpCallValidator_kt__r6yh2y();
    _this__u8e3s4.yrd(Companion_getInstance_385(), block);
  }
  function ExceptionHandlerWrapper() {
  }
  function RequestExceptionHandlerWrapper() {
  }
  function HttpRequest(builder) {
    _init_properties_HttpCallValidator_kt__r6yh2y();
    return new HttpRequest$1(builder);
  }
  function HttpRequest$1($builder) {
    this.zrp_1 = $builder;
    this.vrp_1 = $builder.trc_1;
    this.wrp_1 = $builder.src_1.f40();
    this.xrp_1 = $builder.xrc_1;
    this.yrp_1 = $builder.urc_1.f40();
  }
  protoOf(HttpRequest$1).vrf = function () {
    var message = 'Call is not initialized';
    throw IllegalStateException_init_$Create$_0(toString_1(message));
  };
  protoOf(HttpRequest$1).wrf = function () {
    return this.vrp_1;
  };
  protoOf(HttpRequest$1).qfs = function () {
    return this.wrp_1;
  };
  protoOf(HttpRequest$1).gre = function () {
    return this.xrp_1;
  };
  protoOf(HttpRequest$1).tr2 = function () {
    return this.yrp_1;
  };
  protoOf(HttpRequest$1).h63 = function () {
    var tmp = this.zrp_1.vrc_1;
    var tmp0_elvis_lhs = tmp instanceof OutgoingContent ? tmp : null;
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      var message = 'Content was not transformed to OutgoingContent yet. Current body is ' + toString_1(this.zrp_1.vrc_1);
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    return tmp_0;
  };
  var properties_initialized_HttpCallValidator_kt_xrx49w;
  function _init_properties_HttpCallValidator_kt__r6yh2y() {
    if (!properties_initialized_HttpCallValidator_kt_xrx49w) {
      properties_initialized_HttpCallValidator_kt_xrx49w = true;
      LOGGER_2 = KtorSimpleLogger('io.ktor.client.plugins.HttpCallValidator');
      ExpectSuccessAttributeKey = new AttributeKey('ExpectSuccessAttributeKey');
    }
  }
  function get_PLUGIN_INSTALLED_LIST() {
    _init_properties_HttpClientPlugin_kt__cypu1m();
    return PLUGIN_INSTALLED_LIST;
  }
  var PLUGIN_INSTALLED_LIST;
  function HttpClientPlugin() {
  }
  function plugin(_this__u8e3s4, plugin) {
    _init_properties_HttpClientPlugin_kt__cypu1m();
    var tmp0_elvis_lhs = pluginOrNull(_this__u8e3s4, plugin);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalStateException_init_$Create$_0('Plugin ' + toString_1(plugin) + ' is not installed. Consider using `install(' + plugin.z().toString() + ')` in client config first.');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function pluginOrNull(_this__u8e3s4, plugin) {
    _init_properties_HttpClientPlugin_kt__cypu1m();
    var tmp0_safe_receiver = _this__u8e3s4.xra_1.mdu(get_PLUGIN_INSTALLED_LIST());
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.mdu(plugin.z());
  }
  var properties_initialized_HttpClientPlugin_kt_p98320;
  function _init_properties_HttpClientPlugin_kt__cypu1m() {
    if (!properties_initialized_HttpClientPlugin_kt_p98320) {
      properties_initialized_HttpClientPlugin_kt_p98320 = true;
      PLUGIN_INSTALLED_LIST = new AttributeKey('ApplicationPluginRegistry');
    }
  }
  function get_LOGGER_3() {
    _init_properties_HttpPlainText_kt__iy89z1();
    return LOGGER_3;
  }
  var LOGGER_3;
  function HttpPlainText$Plugin$install$slambda($plugin, resultContinuation) {
    this.irq_1 = $plugin;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(HttpPlainText$Plugin$install$slambda).mrb = function ($this$intercept, content, $completion) {
    var tmp = this.nrb($this$intercept, content, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(HttpPlainText$Plugin$install$slambda).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof PipelineContext ? p1 : THROW_CCE();
    return this.mrb(tmp, !(p2 == null) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(HttpPlainText$Plugin$install$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.irq_1.orq(this.jrq_1.jdz_1);
            var tmp_0 = this.krq_1;
            if (!(typeof tmp_0 === 'string'))
              return Unit_instance;
            var contentType_0 = contentType(this.jrq_1.jdz_1);
            if (!(contentType_0 == null) && !(contentType_0.hqy_1 === Text_getInstance().xqx_1.hqy_1)) {
              return Unit_instance;
            }

            this.f9_1 = 1;
            suspendResult = this.jrq_1.ndy(wrapContent(this.irq_1, this.jrq_1.jdz_1, this.krq_1, contentType_0), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(HttpPlainText$Plugin$install$slambda).nrb = function ($this$intercept, content, completion) {
    var i = new HttpPlainText$Plugin$install$slambda(this.irq_1, completion);
    i.jrq_1 = $this$intercept;
    i.krq_1 = content;
    return i;
  };
  function HttpPlainText$Plugin$install$slambda_0($plugin, resultContinuation) {
    var i = new HttpPlainText$Plugin$install$slambda($plugin, resultContinuation);
    var l = function ($this$intercept, content, $completion) {
      return i.mrb($this$intercept, content, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function HttpPlainText$Plugin$install$slambda_1($plugin, resultContinuation) {
    this.xrq_1 = $plugin;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(HttpPlainText$Plugin$install$slambda_1).grc = function ($this$intercept, _name_for_destructuring_parameter_0__wldtmu, $completion) {
    var tmp = this.hrc($this$intercept, _name_for_destructuring_parameter_0__wldtmu, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(HttpPlainText$Plugin$install$slambda_1).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof PipelineContext ? p1 : THROW_CCE();
    return this.grc(tmp, p2 instanceof HttpResponseContainer ? p2 : THROW_CCE(), $completion);
  };
  protoOf(HttpPlainText$Plugin$install$slambda_1).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 3;
            this.arr_1 = this.zrq_1.fg();
            var body = this.zrq_1.gg();
            var tmp_0;
            if (!this.arr_1.ae0_1.equals(PrimitiveClasses_getInstance().tb())) {
              tmp_0 = true;
            } else {
              tmp_0 = !isInterface(body, ByteReadChannel_1);
            }

            if (tmp_0)
              return Unit_instance;
            this.f9_1 = 1;
            suspendResult = body.hdm(VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var bodyBytes = suspendResult;
            var content = this.xrq_1.brr(this.yrq_1.jdz_1, bodyBytes);
            this.f9_1 = 2;
            suspendResult = this.yrq_1.ndy(new HttpResponseContainer(this.arr_1, content), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 3) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(HttpPlainText$Plugin$install$slambda_1).hrc = function ($this$intercept, _name_for_destructuring_parameter_0__wldtmu, completion) {
    var i = new HttpPlainText$Plugin$install$slambda_1(this.xrq_1, completion);
    i.yrq_1 = $this$intercept;
    i.zrq_1 = _name_for_destructuring_parameter_0__wldtmu;
    return i;
  };
  function HttpPlainText$Plugin$install$slambda_2($plugin, resultContinuation) {
    var i = new HttpPlainText$Plugin$install$slambda_1($plugin, resultContinuation);
    var l = function ($this$intercept, _name_for_destructuring_parameter_0__wldtmu, $completion) {
      return i.grc($this$intercept, _name_for_destructuring_parameter_0__wldtmu, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function Config_0() {
    var tmp = this;
    // Inline function 'kotlin.collections.mutableSetOf' call
    tmp.crr_1 = LinkedHashSet_init_$Create$();
    var tmp_0 = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp_0.drr_1 = LinkedHashMap_init_$Create$();
    this.err_1 = null;
    this.frr_1 = Charsets_getInstance().udq_1;
  }
  function Plugin_0() {
    Plugin_instance_0 = this;
    this.grr_1 = new AttributeKey('HttpPlainText');
  }
  protoOf(Plugin_0).z = function () {
    return this.grr_1;
  };
  protoOf(Plugin_0).hrr = function (block) {
    // Inline function 'kotlin.apply' call
    var this_0 = new Config_0();
    block(this_0);
    var config = this_0;
    // Inline function 'kotlin.with' call
    return new HttpPlainText(config.crr_1, config.drr_1, config.err_1, config.frr_1);
  };
  protoOf(Plugin_0).wrd = function (block) {
    return this.hrr(block);
  };
  protoOf(Plugin_0).irr = function (plugin, scope) {
    var tmp = Phases_getInstance().hrj_1;
    scope.tra_1.ndz(tmp, HttpPlainText$Plugin$install$slambda_0(plugin, null));
    var tmp_0 = Phases_getInstance_1().rrd_1;
    scope.ura_1.ndz(tmp_0, HttpPlainText$Plugin$install$slambda_2(plugin, null));
  };
  protoOf(Plugin_0).xrd = function (plugin, scope) {
    return this.irr(plugin instanceof HttpPlainText ? plugin : THROW_CCE(), scope);
  };
  var Plugin_instance_0;
  function Plugin_getInstance_0() {
    if (Plugin_instance_0 == null)
      new Plugin_0();
    return Plugin_instance_0;
  }
  function wrapContent($this, request, content, requestContentType) {
    var contentType = requestContentType == null ? Text_getInstance().xqx_1 : requestContentType;
    var tmp2_elvis_lhs = requestContentType == null ? null : charset(requestContentType);
    var charset_0 = tmp2_elvis_lhs == null ? $this.mrq_1 : tmp2_elvis_lhs;
    get_LOGGER_3().fe0('Sending request body to ' + request.src_1.toString() + ' as text/plain with charset ' + charset_0.toString());
    return new TextContent(content, withCharset(contentType, charset_0));
  }
  function sam$kotlin_Comparator$0_4(function_0) {
    this.jrr_1 = function_0;
  }
  protoOf(sam$kotlin_Comparator$0_4).zd = function (a, b) {
    return this.jrr_1(a, b);
  };
  protoOf(sam$kotlin_Comparator$0_4).compare = function (a, b) {
    return this.zd(a, b);
  };
  protoOf(sam$kotlin_Comparator$0_4).f3 = function () {
    return this.jrr_1;
  };
  protoOf(sam$kotlin_Comparator$0_4).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Comparator) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlin_Comparator$0_4).hashCode = function () {
    return hashCode(this.f3());
  };
  function HttpPlainText$lambda(a, b) {
    // Inline function 'kotlin.comparisons.compareValuesBy' call
    var tmp = b.qg_1;
    var tmp$ret$1 = a.qg_1;
    return compareValues(tmp, tmp$ret$1);
  }
  function HttpPlainText$lambda_0(a, b) {
    // Inline function 'kotlin.comparisons.compareValuesBy' call
    var tmp = get_name_6(a);
    var tmp$ret$1 = get_name_6(b);
    return compareValues(tmp, tmp$ret$1);
  }
  function HttpPlainText(charsets, charsetQuality, sendCharset, responseCharsetFallback) {
    Plugin_getInstance_0();
    this.lrq_1 = responseCharsetFallback;
    // Inline function 'kotlin.collections.sortedByDescending' call
    var this_0 = toList_1(charsetQuality);
    // Inline function 'kotlin.comparisons.compareByDescending' call
    var tmp = HttpPlainText$lambda;
    var tmp$ret$0 = new sam$kotlin_Comparator$0_4(tmp);
    var withQuality = sortedWith(this_0, tmp$ret$0);
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList_init_$Create$();
    var _iterator__ex2g4s = charsets.m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      if (!charsetQuality.o2(element)) {
        destination.j(element);
      }
    }
    // Inline function 'kotlin.collections.sortedBy' call
    // Inline function 'kotlin.comparisons.compareBy' call
    var tmp_0 = HttpPlainText$lambda_0;
    var tmp$ret$5 = new sam$kotlin_Comparator$0_4(tmp_0);
    var withoutQuality = sortedWith(destination, tmp$ret$5);
    var tmp_1 = this;
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.apply' call
    var this_1 = StringBuilder_init_$Create$_1();
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s_0 = withoutQuality.m();
    while (_iterator__ex2g4s_0.n()) {
      var element_0 = _iterator__ex2g4s_0.o();
      // Inline function 'kotlin.text.isNotEmpty' call
      if (charSequenceLength(this_1) > 0) {
        this_1.j8(',');
      }
      this_1.j8(get_name_6(element_0));
    }
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s_1 = withQuality.m();
    while (_iterator__ex2g4s_1.n()) {
      var element_1 = _iterator__ex2g4s_1.o();
      var charset = element_1.fg();
      var quality = element_1.gg();
      // Inline function 'kotlin.text.isNotEmpty' call
      if (charSequenceLength(this_1) > 0) {
        this_1.j8(',');
      }
      // Inline function 'kotlin.check' call
      if (!(0.0 <= quality ? quality <= 1.0 : false)) {
        throw IllegalStateException_init_$Create$_0('Check failed.');
      }
      // Inline function 'kotlin.math.roundToInt' call
      var this_2 = 100 * quality;
      var truncatedQuality = roundToInt(this_2) / 100.0;
      this_1.j8(get_name_6(charset) + ';q=' + truncatedQuality);
    }
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(this_1) === 0) {
      this_1.j8(get_name_6(this.lrq_1));
    }
    tmp_1.nrq_1 = this_1.toString();
    var tmp_2 = this;
    var tmp2_elvis_lhs = sendCharset == null ? firstOrNull_1(withoutQuality) : sendCharset;
    var tmp_3;
    if (tmp2_elvis_lhs == null) {
      var tmp1_safe_receiver = firstOrNull_1(withQuality);
      tmp_3 = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.pg_1;
    } else {
      tmp_3 = tmp2_elvis_lhs;
    }
    var tmp3_elvis_lhs = tmp_3;
    tmp_2.mrq_1 = tmp3_elvis_lhs == null ? Charsets_getInstance().udq_1 : tmp3_elvis_lhs;
  }
  protoOf(HttpPlainText).brr = function (call, body) {
    var tmp0_elvis_lhs = charset_0(call.trb());
    var actualCharset = tmp0_elvis_lhs == null ? this.lrq_1 : tmp0_elvis_lhs;
    get_LOGGER_3().fe0('Reading response body for ' + call.yre().qfs().toString() + ' as String with charset ' + actualCharset.toString());
    return readText(body, actualCharset);
  };
  protoOf(HttpPlainText).orq = function (context) {
    if (!(context.urc_1.ld(HttpHeaders_getInstance().rqy_1) == null))
      return Unit_instance;
    get_LOGGER_3().fe0('Adding Accept-Charset=' + this.nrq_1 + ' to ' + context.src_1.toString());
    context.urc_1.rdw(HttpHeaders_getInstance().rqy_1, this.nrq_1);
  };
  var properties_initialized_HttpPlainText_kt_2nx4ox;
  function _init_properties_HttpPlainText_kt__iy89z1() {
    if (!properties_initialized_HttpPlainText_kt_2nx4ox) {
      properties_initialized_HttpPlainText_kt_2nx4ox = true;
      LOGGER_3 = KtorSimpleLogger('io.ktor.client.plugins.HttpPlainText');
    }
  }
  function get_ALLOWED_FOR_REDIRECT() {
    _init_properties_HttpRedirect_kt__ure7fo();
    return ALLOWED_FOR_REDIRECT;
  }
  var ALLOWED_FOR_REDIRECT;
  function get_LOGGER_4() {
    _init_properties_HttpRedirect_kt__ure7fo();
    return LOGGER_4;
  }
  var LOGGER_4;
  function handleCall($this, _this__u8e3s4, context, origin, allowHttpsDowngrade, client, $completion) {
    var tmp = new $handleCallCOROUTINE$($this, _this__u8e3s4, context, origin, allowHttpsDowngrade, client, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  }
  function HttpRedirect$Plugin$install$slambda($plugin, $scope, resultContinuation) {
    this.krs_1 = $plugin;
    this.lrs_1 = $scope;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(HttpRedirect$Plugin$install$slambda).nro = function ($this$intercept, context, $completion) {
    var tmp = this.oro($this$intercept, context, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(HttpRedirect$Plugin$install$slambda).w9 = function (p1, p2, $completion) {
    var tmp = (!(p1 == null) ? isInterface(p1, Sender) : false) ? p1 : THROW_CCE();
    return this.nro(tmp, p2 instanceof HttpRequestBuilder ? p2 : THROW_CCE(), $completion);
  };
  protoOf(HttpRedirect$Plugin$install$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 3;
            this.f9_1 = 1;
            suspendResult = this.mrs_1.pro(this.nrs_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var origin = suspendResult;
            if (this.krs_1.ors_1 && !get_ALLOWED_FOR_REDIRECT().t(origin.yre().wrf())) {
              return origin;
            }

            this.f9_1 = 2;
            suspendResult = handleCall(Plugin_getInstance_1(), this.mrs_1, this.nrs_1, origin, this.krs_1.prs_1, this.lrs_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return suspendResult;
          case 3:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 3) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(HttpRedirect$Plugin$install$slambda).oro = function ($this$intercept, context, completion) {
    var i = new HttpRedirect$Plugin$install$slambda(this.krs_1, this.lrs_1, completion);
    i.mrs_1 = $this$intercept;
    i.nrs_1 = context;
    return i;
  };
  function HttpRedirect$Plugin$install$slambda_0($plugin, $scope, resultContinuation) {
    var i = new HttpRedirect$Plugin$install$slambda($plugin, $scope, resultContinuation);
    var l = function ($this$intercept, context, $completion) {
      return i.nro($this$intercept, context, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function $handleCallCOROUTINE$(_this__u8e3s4, _this__u8e3s4_0, context, origin, allowHttpsDowngrade, client, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.srr_1 = _this__u8e3s4;
    this.trr_1 = _this__u8e3s4_0;
    this.urr_1 = context;
    this.vrr_1 = origin;
    this.wrr_1 = allowHttpsDowngrade;
    this.xrr_1 = client;
  }
  protoOf($handleCallCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 3;
            if (!isRedirect(this.vrr_1.trb().arf()))
              return this.vrr_1;
            this.yrr_1 = this.vrr_1;
            this.zrr_1 = this.urr_1;
            this.brs_1 = this.vrr_1.yre().qfs().gr6_1;
            this.ars_1 = get_authority_0(this.vrr_1.yre().qfs());
            this.f9_1 = 1;
            continue $sm;
          case 1:
            if (!true) {
              this.f9_1 = 4;
              continue $sm;
            }

            this.xrr_1.zra_1.pqw(this.srr_1.rrs_1, this.yrr_1.trb());
            var location = this.yrr_1.trb().tr2().ld(HttpHeaders_getInstance().er0_1);
            get_LOGGER_4().fe0('Received redirect response to ' + location + ' for request ' + this.urr_1.src_1.toString());
            var tmp_0 = this;
            var this_0 = new HttpRequestBuilder();
            this_0.fri(this.zrr_1);
            this_0.src_1.dr6_1.k2();
            if (location == null)
              null;
            else {
              takeFrom(this_0.src_1, location);
            }

            if (!this.wrr_1 && isSecure(this.brs_1) && !isSecure(this_0.src_1.ur5_1)) {
              get_LOGGER_4().fe0('Can not redirect ' + this.urr_1.src_1.toString() + ' because of security downgrade');
              return this.yrr_1;
            }

            if (!(this.ars_1 === get_authority(this_0.src_1))) {
              this_0.urc_1.vdw(HttpHeaders_getInstance().zqy_1);
              get_LOGGER_4().fe0('Removing Authorization header from redirect for ' + this.urr_1.src_1.toString());
            }

            tmp_0.zrr_1 = this_0;
            this.f9_1 = 2;
            suspendResult = this.trr_1.pro(this.zrr_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.yrr_1 = suspendResult;
            if (!isRedirect(this.yrr_1.trb().arf()))
              return this.yrr_1;
            this.f9_1 = 1;
            continue $sm;
          case 3:
            throw this.i9_1;
          case 4:
            return Unit_instance;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 3) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function Config_1() {
    this.srs_1 = true;
    this.trs_1 = false;
  }
  function Plugin_1() {
    Plugin_instance_1 = this;
    this.qrs_1 = new AttributeKey('HttpRedirect');
    this.rrs_1 = new EventDefinition();
  }
  protoOf(Plugin_1).z = function () {
    return this.qrs_1;
  };
  protoOf(Plugin_1).urs = function (block) {
    // Inline function 'kotlin.apply' call
    var this_0 = new Config_1();
    block(this_0);
    var config = this_0;
    return new HttpRedirect(config.srs_1, config.trs_1);
  };
  protoOf(Plugin_1).wrd = function (block) {
    return this.urs(block);
  };
  protoOf(Plugin_1).vrs = function (plugin_0, scope) {
    var tmp = plugin(scope, Plugin_getInstance_3());
    tmp.srp(HttpRedirect$Plugin$install$slambda_0(plugin_0, scope, null));
  };
  protoOf(Plugin_1).xrd = function (plugin, scope) {
    return this.vrs(plugin instanceof HttpRedirect ? plugin : THROW_CCE(), scope);
  };
  var Plugin_instance_1;
  function Plugin_getInstance_1() {
    if (Plugin_instance_1 == null)
      new Plugin_1();
    return Plugin_instance_1;
  }
  function HttpRedirect(checkHttpMethod, allowHttpsDowngrade) {
    Plugin_getInstance_1();
    this.ors_1 = checkHttpMethod;
    this.prs_1 = allowHttpsDowngrade;
  }
  function isRedirect(_this__u8e3s4) {
    _init_properties_HttpRedirect_kt__ure7fo();
    var tmp0_subject = _this__u8e3s4.or5_1;
    return ((((tmp0_subject === Companion_getInstance_378().xr3_1.or5_1 ? true : tmp0_subject === Companion_getInstance_378().yr3_1.or5_1) ? true : tmp0_subject === Companion_getInstance_378().dr4_1.or5_1) ? true : tmp0_subject === Companion_getInstance_378().er4_1.or5_1) ? true : tmp0_subject === Companion_getInstance_378().zr3_1.or5_1) ? true : false;
  }
  var properties_initialized_HttpRedirect_kt_klj746;
  function _init_properties_HttpRedirect_kt__ure7fo() {
    if (!properties_initialized_HttpRedirect_kt_klj746) {
      properties_initialized_HttpRedirect_kt_klj746 = true;
      ALLOWED_FOR_REDIRECT = setOf_0([Companion_getInstance_376().ur2_1, Companion_getInstance_376().zr2_1]);
      LOGGER_4 = KtorSimpleLogger('io.ktor.client.plugins.HttpRedirect');
    }
  }
  function get_LOGGER_5() {
    _init_properties_HttpRequestLifecycle_kt__jgkmfx();
    return LOGGER_5;
  }
  var LOGGER_5;
  function HttpRequestLifecycle$Plugin$install$slambda($scope, resultContinuation) {
    this.ert_1 = $scope;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(HttpRequestLifecycle$Plugin$install$slambda).mrb = function ($this$intercept, it, $completion) {
    var tmp = this.nrb($this$intercept, it, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(HttpRequestLifecycle$Plugin$install$slambda).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof PipelineContext ? p1 : THROW_CCE();
    return this.mrb(tmp, !(p2 == null) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(HttpRequestLifecycle$Plugin$install$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 6;
            this.hrt_1 = SupervisorJob(this.frt_1.jdz_1.wrc_1);
            attachToClientEngineJob(this.hrt_1, ensureNotNull(this.ert_1.sra_1.s9(Key_instance_3)));
            this.f9_1 = 1;
            continue $sm;
          case 1:
            this.g9_1 = 4;
            this.g9_1 = 3;
            this.frt_1.jdz_1.wrc_1 = this.hrt_1;
            this.f9_1 = 2;
            suspendResult = this.frt_1.ody(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.g9_1 = 6;
            this.f9_1 = 5;
            continue $sm;
          case 3:
            this.g9_1 = 4;
            var tmp_0 = this.i9_1;
            if (tmp_0 instanceof Error) {
              var cause = this.i9_1;
              this.hrt_1.ru(cause);
              throw cause;
            } else {
              throw this.i9_1;
            }

          case 4:
            this.g9_1 = 6;
            var t = this.i9_1;
            this.hrt_1.su();
            throw t;
          case 5:
            this.g9_1 = 6;
            this.hrt_1.su();
            return Unit_instance;
          case 6:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 6) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(HttpRequestLifecycle$Plugin$install$slambda).nrb = function ($this$intercept, it, completion) {
    var i = new HttpRequestLifecycle$Plugin$install$slambda(this.ert_1, completion);
    i.frt_1 = $this$intercept;
    i.grt_1 = it;
    return i;
  };
  function HttpRequestLifecycle$Plugin$install$slambda_0($scope, resultContinuation) {
    var i = new HttpRequestLifecycle$Plugin$install$slambda($scope, resultContinuation);
    var l = function ($this$intercept, it, $completion) {
      return i.mrb($this$intercept, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function Plugin_2() {
    Plugin_instance_2 = this;
    this.irt_1 = new AttributeKey('RequestLifecycle');
  }
  protoOf(Plugin_2).z = function () {
    return this.irt_1;
  };
  protoOf(Plugin_2).nrj = function (block) {
    return new HttpRequestLifecycle();
  };
  protoOf(Plugin_2).wrd = function (block) {
    return this.nrj(block);
  };
  protoOf(Plugin_2).jrt = function (plugin, scope) {
    var tmp = Phases_getInstance().erj_1;
    scope.tra_1.ndz(tmp, HttpRequestLifecycle$Plugin$install$slambda_0(scope, null));
  };
  protoOf(Plugin_2).xrd = function (plugin, scope) {
    return this.jrt(plugin instanceof HttpRequestLifecycle ? plugin : THROW_CCE(), scope);
  };
  var Plugin_instance_2;
  function Plugin_getInstance_2() {
    if (Plugin_instance_2 == null)
      new Plugin_2();
    return Plugin_instance_2;
  }
  function HttpRequestLifecycle() {
    Plugin_getInstance_2();
  }
  function attachToClientEngineJob(requestJob, clientEngineJob) {
    _init_properties_HttpRequestLifecycle_kt__jgkmfx();
    var handler = clientEngineJob.kp(attachToClientEngineJob$lambda(requestJob));
    requestJob.kp(attachToClientEngineJob$lambda_0(handler));
  }
  function attachToClientEngineJob$lambda($requestJob) {
    return function (cause) {
      var tmp;
      if (!(cause == null)) {
        get_LOGGER_5().fe0('Cancelling request because engine Job failed with error: ' + toString_0(cause));
        cancel_2($requestJob, 'Engine failed', cause);
        tmp = Unit_instance;
      } else {
        get_LOGGER_5().fe0('Cancelling request because engine Job completed');
        $requestJob.su();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function attachToClientEngineJob$lambda_0($handler) {
    return function (it) {
      $handler.zr();
      return Unit_instance;
    };
  }
  var properties_initialized_HttpRequestLifecycle_kt_3hmcrf;
  function _init_properties_HttpRequestLifecycle_kt__jgkmfx() {
    if (!properties_initialized_HttpRequestLifecycle_kt_3hmcrf) {
      properties_initialized_HttpRequestLifecycle_kt_3hmcrf = true;
      LOGGER_5 = KtorSimpleLogger('io.ktor.client.plugins.HttpRequestLifecycle');
    }
  }
  function HttpSend$Plugin$install$slambda($plugin, $scope, resultContinuation) {
    this.srt_1 = $plugin;
    this.trt_1 = $scope;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(HttpSend$Plugin$install$slambda).mrb = function ($this$intercept, content, $completion) {
    var tmp = this.nrb($this$intercept, content, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(HttpSend$Plugin$install$slambda).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof PipelineContext ? p1 : THROW_CCE();
    return this.mrb(tmp, !(p2 == null) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(HttpSend$Plugin$install$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 3;
            var tmp_0 = this.vrt_1;
            if (!(tmp_0 instanceof OutgoingContent)) {
              var message = trimMargin('\n|Fail to prepare request body for sending. \n|The body type is: ' + toString_1(getKClassFromExpression(this.vrt_1)) + ', with Content-Type: ' + toString_0(contentType(this.urt_1.jdz_1)) + '.\n|\n|If you expect serialized body, please check that you have installed the corresponding plugin(like `ContentNegotiation`) and set `Content-Type` header.');
              throw IllegalStateException_init_$Create$_0(toString_1(message));
            }

            var tmp0 = this.urt_1.jdz_1;
            var body = this.vrt_1;
            if (body == null) {
              tmp0.vrc_1 = NullBody_instance;
              var tmp_1 = JsType_instance;
              var tmp_2 = getKClass(OutgoingContent);
              var tmp_3;
              try {
                tmp_3 = createKType(getKClass(OutgoingContent), arrayOf([]), false);
              } catch ($p) {
                var tmp_4;
                if ($p instanceof Error) {
                  var cause = $p;
                  tmp_4 = null;
                } else {
                  throw $p;
                }
                tmp_3 = tmp_4;
              }
              tmp0.gri(typeInfoImpl(tmp_1, tmp_2, tmp_3));
            } else {
              if (body instanceof OutgoingContent) {
                tmp0.vrc_1 = body;
                tmp0.gri(null);
              } else {
                tmp0.vrc_1 = body;
                var tmp_5 = JsType_instance;
                var tmp_6 = getKClass(OutgoingContent);
                var tmp_7;
                try {
                  tmp_7 = createKType(getKClass(OutgoingContent), arrayOf([]), false);
                } catch ($p) {
                  var tmp_8;
                  if ($p instanceof Error) {
                    var cause_0 = $p;
                    tmp_8 = null;
                  } else {
                    throw $p;
                  }
                  tmp_7 = tmp_8;
                }
                tmp0.gri(typeInfoImpl(tmp_5, tmp_6, tmp_7));
              }
            }

            var realSender = new DefaultSender(this.srt_1.qrp_1, this.trt_1);
            var interceptedSender = realSender;
            var progression = downTo(get_lastIndex_2(this.srt_1.rrp_1), 0);
            var inductionVariable = progression.c1_1;
            var last = progression.d1_1;
            var step = progression.e1_1;
            if (step > 0 && inductionVariable <= last || (step < 0 && last <= inductionVariable))
              do {
                var element = inductionVariable;
                inductionVariable = inductionVariable + step | 0;
                var it = element;
                var interceptor = this.srt_1.rrp_1.r(it);
                interceptedSender = new InterceptedSender(interceptor, interceptedSender);
              }
               while (!(element === last));
            this.f9_1 = 1;
            suspendResult = interceptedSender.pro(this.urt_1.jdz_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var call = suspendResult;
            this.f9_1 = 2;
            suspendResult = this.urt_1.ndy(call, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 3) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(HttpSend$Plugin$install$slambda).nrb = function ($this$intercept, content, completion) {
    var i = new HttpSend$Plugin$install$slambda(this.srt_1, this.trt_1, completion);
    i.urt_1 = $this$intercept;
    i.vrt_1 = content;
    return i;
  };
  function HttpSend$Plugin$install$slambda_0($plugin, $scope, resultContinuation) {
    var i = new HttpSend$Plugin$install$slambda($plugin, $scope, resultContinuation);
    var l = function ($this$intercept, content, $completion) {
      return i.mrb($this$intercept, content, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function $executeCOROUTINE$_1(_this__u8e3s4, requestBuilder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.eru_1 = _this__u8e3s4;
    this.fru_1 = requestBuilder;
  }
  protoOf($executeCOROUTINE$_1).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            var tmp0_safe_receiver = this.eru_1.jru_1;
            if (tmp0_safe_receiver == null)
              null;
            else {
              cancel(tmp0_safe_receiver);
            }

            if (this.eru_1.iru_1 >= this.eru_1.gru_1) {
              throw new SendCountExceedException('Max send count ' + this.eru_1.gru_1 + ' exceeded. Consider increasing the property ' + 'maxSendCount if more is required.');
            }

            var tmp1_this = this.eru_1;
            tmp1_this.iru_1 = tmp1_this.iru_1 + 1 | 0;
            this.f9_1 = 1;
            suspendResult = this.eru_1.hru_1.vra_1.idz(this.fru_1, this.fru_1.vrc_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var sendResult = suspendResult;
            var tmp3_elvis_lhs = sendResult instanceof HttpClientCall ? sendResult : null;
            var tmp_0;
            if (tmp3_elvis_lhs == null) {
              var message = 'Failed to execute send pipeline. Expected [HttpClientCall], but received ' + toString_1(sendResult);
              throw IllegalStateException_init_$Create$_0(toString_1(message));
            } else {
              tmp_0 = tmp3_elvis_lhs;
            }

            var call = tmp_0;
            this.eru_1.jru_1 = call;
            return call;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function Config_2() {
    this.kru_1 = 20;
  }
  function Plugin_3() {
    Plugin_instance_3 = this;
    this.lru_1 = new AttributeKey('HttpSend');
  }
  protoOf(Plugin_3).z = function () {
    return this.lru_1;
  };
  protoOf(Plugin_3).mru = function (block) {
    // Inline function 'kotlin.apply' call
    var this_0 = new Config_2();
    block(this_0);
    var config = this_0;
    return new HttpSend(config.kru_1);
  };
  protoOf(Plugin_3).wrd = function (block) {
    return this.mru(block);
  };
  protoOf(Plugin_3).nru = function (plugin, scope) {
    var tmp = Phases_getInstance().irj_1;
    scope.tra_1.ndz(tmp, HttpSend$Plugin$install$slambda_0(plugin, scope, null));
  };
  protoOf(Plugin_3).xrd = function (plugin, scope) {
    return this.nru(plugin instanceof HttpSend ? plugin : THROW_CCE(), scope);
  };
  var Plugin_instance_3;
  function Plugin_getInstance_3() {
    if (Plugin_instance_3 == null)
      new Plugin_3();
    return Plugin_instance_3;
  }
  function InterceptedSender(interceptor, nextSender) {
    this.oru_1 = interceptor;
    this.pru_1 = nextSender;
  }
  protoOf(InterceptedSender).pro = function (requestBuilder, $completion) {
    return this.oru_1(this.pru_1, requestBuilder, $completion);
  };
  function DefaultSender(maxSendCount, client) {
    this.gru_1 = maxSendCount;
    this.hru_1 = client;
    this.iru_1 = 0;
    this.jru_1 = null;
  }
  protoOf(DefaultSender).pro = function (requestBuilder, $completion) {
    var tmp = new $executeCOROUTINE$_1(this, requestBuilder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  function HttpSend(maxSendCount) {
    Plugin_getInstance_3();
    maxSendCount = maxSendCount === VOID ? 20 : maxSendCount;
    this.qrp_1 = maxSendCount;
    var tmp = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp.rrp_1 = ArrayList_init_$Create$();
  }
  protoOf(HttpSend).srp = function (block) {
    // Inline function 'kotlin.collections.plusAssign' call
    this.rrp_1.j(block);
  };
  function Sender() {
  }
  function SendCountExceedException(message) {
    IllegalStateException_init_$Init$_0(message, this);
    captureStack(this, SendCountExceedException);
  }
  function get_LOGGER_6() {
    _init_properties_HttpTimeout_kt__pucqrr();
    return LOGGER_6;
  }
  var LOGGER_6;
  function HttpTimeoutCapabilityConfiguration_init_$Init$(requestTimeoutMillis, connectTimeoutMillis, socketTimeoutMillis, $this) {
    requestTimeoutMillis = requestTimeoutMillis === VOID ? null : requestTimeoutMillis;
    connectTimeoutMillis = connectTimeoutMillis === VOID ? null : connectTimeoutMillis;
    socketTimeoutMillis = socketTimeoutMillis === VOID ? null : socketTimeoutMillis;
    HttpTimeoutCapabilityConfiguration.call($this);
    $this.tru(requestTimeoutMillis);
    $this.uru(connectTimeoutMillis);
    $this.vru(socketTimeoutMillis);
    return $this;
  }
  function HttpTimeoutCapabilityConfiguration_init_$Create$(requestTimeoutMillis, connectTimeoutMillis, socketTimeoutMillis) {
    return HttpTimeoutCapabilityConfiguration_init_$Init$(requestTimeoutMillis, connectTimeoutMillis, socketTimeoutMillis, objectCreate(protoOf(HttpTimeoutCapabilityConfiguration)));
  }
  function checkTimeoutValue($this, value) {
    // Inline function 'kotlin.require' call
    if (!(value == null || value > 0n)) {
      var message = 'Only positive timeout values are allowed, for infinite timeout use HttpTimeout.INFINITE_TIMEOUT_MS';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    return value;
  }
  function Companion_386() {
    Companion_instance_386 = this;
    this.wru_1 = new AttributeKey('TimeoutConfiguration');
  }
  var Companion_instance_386;
  function Companion_getInstance_386() {
    if (Companion_instance_386 == null)
      new Companion_386();
    return Companion_instance_386;
  }
  function HttpTimeout$Plugin$install$slambda$slambda($requestTimeout, $request, $executionContext, resultContinuation) {
    this.frv_1 = $requestTimeout;
    this.grv_1 = $request;
    this.hrv_1 = $executionContext;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(HttpTimeout$Plugin$install$slambda$slambda).e1h = function ($this$launch, $completion) {
    var tmp = this.f1h($this$launch, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(HttpTimeout$Plugin$install$slambda$slambda).v9 = function (p1, $completion) {
    return this.e1h((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(HttpTimeout$Plugin$install$slambda$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = delay_0(this.frv_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var cause = HttpRequestTimeoutException_init_$Create$(this.grv_1);
            get_LOGGER_6().fe0('Request timeout: ' + this.grv_1.src_1.toString());
            cancel_2(this.hrv_1, ensureNotNull(cause.message), cause);
            return Unit_instance;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(HttpTimeout$Plugin$install$slambda$slambda).f1h = function ($this$launch, completion) {
    var i = new HttpTimeout$Plugin$install$slambda$slambda(this.frv_1, this.grv_1, this.hrv_1, completion);
    i.irv_1 = $this$launch;
    return i;
  };
  function HttpTimeout$Plugin$install$slambda$slambda_0($requestTimeout, $request, $executionContext, resultContinuation) {
    var i = new HttpTimeout$Plugin$install$slambda$slambda($requestTimeout, $request, $executionContext, resultContinuation);
    var l = function ($this$launch, $completion) {
      return i.e1h($this$launch, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function HttpTimeout$Plugin$install$slambda$lambda($killer) {
    return function (it) {
      $killer.sp();
      return Unit_instance;
    };
  }
  function HttpTimeout$Plugin$install$slambda($plugin, $scope, resultContinuation) {
    this.rrv_1 = $plugin;
    this.srv_1 = $scope;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(HttpTimeout$Plugin$install$slambda).nro = function ($this$intercept, request, $completion) {
    var tmp = this.oro($this$intercept, request, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(HttpTimeout$Plugin$install$slambda).w9 = function (p1, p2, $completion) {
    var tmp = (!(p1 == null) ? isInterface(p1, Sender) : false) ? p1 : THROW_CCE();
    return this.nro(tmp, p2 instanceof HttpRequestBuilder ? p2 : THROW_CCE(), $completion);
  };
  protoOf(HttpTimeout$Plugin$install$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 4;
            var isWebSocket = isWebsocket(this.urv_1.src_1.ur5_1);
            var tmp_0;
            if (isWebSocket) {
              tmp_0 = true;
            } else {
              var tmp_1 = this.urv_1.vrc_1;
              tmp_0 = tmp_1 instanceof ClientUpgradeContent;
            }

            if (tmp_0) {
              this.f9_1 = 3;
              suspendResult = this.trv_1.pro(this.urv_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.f9_1 = 1;
              continue $sm;
            }

          case 1:
            var configuration = this.urv_1.vrv(Plugin_getInstance_4());
            if (configuration == null && hasNotNullTimeouts(this.rrv_1)) {
              configuration = HttpTimeoutCapabilityConfiguration_init_$Create$();
              this.urv_1.wrv(Plugin_getInstance_4(), configuration);
            }

            var tmp0_safe_receiver = configuration;
            if (tmp0_safe_receiver == null)
              null;
            else {
              l$ret$1: do {
                var tmp0_elvis_lhs = tmp0_safe_receiver.xrv();
                tmp0_safe_receiver.uru(tmp0_elvis_lhs == null ? this.rrv_1.zrv_1 : tmp0_elvis_lhs);
                var tmp1_elvis_lhs = tmp0_safe_receiver.brw();
                tmp0_safe_receiver.vru(tmp1_elvis_lhs == null ? this.rrv_1.arw_1 : tmp1_elvis_lhs);
                var tmp2_elvis_lhs = tmp0_safe_receiver.crw();
                tmp0_safe_receiver.tru(tmp2_elvis_lhs == null ? this.rrv_1.yrv_1 : tmp2_elvis_lhs);
                var tmp3_elvis_lhs = tmp0_safe_receiver.crw();
                var requestTimeout = tmp3_elvis_lhs == null ? this.rrv_1.yrv_1 : tmp3_elvis_lhs;
                if (requestTimeout == null || requestTimeout === 9223372036854775807n) {
                  break l$ret$1;
                }
                var executionContext = this.urv_1.wrc_1;
                var killer = launch(this.srv_1, VOID, VOID, HttpTimeout$Plugin$install$slambda$slambda_0(requestTimeout, this.urv_1, executionContext, null));
                var tmp_2 = this.urv_1.wrc_1;
                tmp_2.kp(HttpTimeout$Plugin$install$slambda$lambda(killer));
              }
               while (false);
            }

            this.f9_1 = 2;
            suspendResult = this.trv_1.pro(this.urv_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return suspendResult;
          case 3:
            return suspendResult;
          case 4:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 4) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(HttpTimeout$Plugin$install$slambda).oro = function ($this$intercept, request, completion) {
    var i = new HttpTimeout$Plugin$install$slambda(this.rrv_1, this.srv_1, completion);
    i.trv_1 = $this$intercept;
    i.urv_1 = request;
    return i;
  };
  function HttpTimeout$Plugin$install$slambda_0($plugin, $scope, resultContinuation) {
    var i = new HttpTimeout$Plugin$install$slambda($plugin, $scope, resultContinuation);
    var l = function ($this$intercept, request, $completion) {
      return i.nro($this$intercept, request, $completion);
    };
    l.$arity = 2;
    return l;
  }
  protoOf(HttpTimeoutCapabilityConfiguration).tru = function (value) {
    this.qru_1 = checkTimeoutValue(this, value);
  };
  protoOf(HttpTimeoutCapabilityConfiguration).crw = function () {
    return this.qru_1;
  };
  protoOf(HttpTimeoutCapabilityConfiguration).uru = function (value) {
    this.rru_1 = checkTimeoutValue(this, value);
  };
  protoOf(HttpTimeoutCapabilityConfiguration).xrv = function () {
    return this.rru_1;
  };
  protoOf(HttpTimeoutCapabilityConfiguration).vru = function (value) {
    this.sru_1 = checkTimeoutValue(this, value);
  };
  protoOf(HttpTimeoutCapabilityConfiguration).brw = function () {
    return this.sru_1;
  };
  protoOf(HttpTimeoutCapabilityConfiguration).drw = function () {
    return new HttpTimeout(this.crw(), this.xrv(), this.brw());
  };
  protoOf(HttpTimeoutCapabilityConfiguration).equals = function (other) {
    if (this === other)
      return true;
    if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    if (!(other instanceof HttpTimeoutCapabilityConfiguration))
      THROW_CCE();
    if (!(this.qru_1 == other.qru_1))
      return false;
    if (!(this.rru_1 == other.rru_1))
      return false;
    if (!(this.sru_1 == other.sru_1))
      return false;
    return true;
  };
  protoOf(HttpTimeoutCapabilityConfiguration).hashCode = function () {
    var tmp0_safe_receiver = this.qru_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : getBigIntHashCode(tmp0_safe_receiver);
    var result = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    var tmp = imul(31, result);
    var tmp2_safe_receiver = this.rru_1;
    var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : getBigIntHashCode(tmp2_safe_receiver);
    result = tmp + (tmp3_elvis_lhs == null ? 0 : tmp3_elvis_lhs) | 0;
    var tmp_0 = imul(31, result);
    var tmp4_safe_receiver = this.sru_1;
    var tmp5_elvis_lhs = tmp4_safe_receiver == null ? null : getBigIntHashCode(tmp4_safe_receiver);
    result = tmp_0 + (tmp5_elvis_lhs == null ? 0 : tmp5_elvis_lhs) | 0;
    return result;
  };
  function HttpTimeoutCapabilityConfiguration() {
    Companion_getInstance_386();
    this.qru_1 = 0n;
    this.rru_1 = 0n;
    this.sru_1 = 0n;
  }
  function hasNotNullTimeouts($this) {
    return !($this.yrv_1 == null) || !($this.zrv_1 == null) || !($this.arw_1 == null);
  }
  function Plugin_4() {
    Plugin_instance_4 = this;
    this.erw_1 = new AttributeKey('TimeoutPlugin');
    this.frw_1 = 9223372036854775807n;
  }
  protoOf(Plugin_4).z = function () {
    return this.erw_1;
  };
  protoOf(Plugin_4).grw = function (block) {
    // Inline function 'kotlin.apply' call
    var this_0 = HttpTimeoutCapabilityConfiguration_init_$Create$();
    block(this_0);
    return this_0.drw();
  };
  protoOf(Plugin_4).wrd = function (block) {
    return this.grw(block);
  };
  protoOf(Plugin_4).hrw = function (plugin_0, scope) {
    var tmp = plugin(scope, Plugin_getInstance_3());
    tmp.srp(HttpTimeout$Plugin$install$slambda_0(plugin_0, scope, null));
  };
  protoOf(Plugin_4).xrd = function (plugin, scope) {
    return this.hrw(plugin instanceof HttpTimeout ? plugin : THROW_CCE(), scope);
  };
  var Plugin_instance_4;
  function Plugin_getInstance_4() {
    if (Plugin_instance_4 == null)
      new Plugin_4();
    return Plugin_instance_4;
  }
  function HttpTimeout(requestTimeoutMillis, connectTimeoutMillis, socketTimeoutMillis) {
    Plugin_getInstance_4();
    this.yrv_1 = requestTimeoutMillis;
    this.zrv_1 = connectTimeoutMillis;
    this.arw_1 = socketTimeoutMillis;
  }
  function HttpRequestTimeoutException_init_$Init$(request, $this) {
    var tmp = request.src_1.jr7();
    var tmp0_safe_receiver = request.vrv(Plugin_getInstance_4());
    HttpRequestTimeoutException.call($this, tmp, tmp0_safe_receiver == null ? null : tmp0_safe_receiver.crw());
    return $this;
  }
  function HttpRequestTimeoutException_init_$Create$(request) {
    var tmp = HttpRequestTimeoutException_init_$Init$(request, objectCreate(protoOf(HttpRequestTimeoutException)));
    captureStack(tmp, HttpRequestTimeoutException_init_$Create$);
    return tmp;
  }
  function HttpRequestTimeoutException(url, timeoutMillis) {
    IOException_init_$Init$('Request timeout has expired [url=' + url + ', request_timeout=' + toString_1(timeoutMillis == null ? 'unknown' : timeoutMillis) + ' ms]', this);
    captureStack(this, HttpRequestTimeoutException);
  }
  var properties_initialized_HttpTimeout_kt_9oyjbd;
  function _init_properties_HttpTimeout_kt__pucqrr() {
    if (!properties_initialized_HttpTimeout_kt_9oyjbd) {
      properties_initialized_HttpTimeout_kt_9oyjbd = true;
      LOGGER_6 = KtorSimpleLogger('io.ktor.client.plugins.HttpTimeout');
    }
  }
  function wrapWithContent(_this__u8e3s4, content) {
    return new DelegatedCall(_this__u8e3s4.orb_1, content, _this__u8e3s4);
  }
  function DelegatedCall(client, content, originCall) {
    HttpClientCall.call(this, client);
    this.qrb_1 = new DelegatedRequest(this, originCall.yre());
    this.rrb_1 = new DelegatedResponse(this, content, originCall.trb());
  }
  function DelegatedRequest(call, origin) {
    this.irw_1 = call;
    this.jrw_1 = origin;
  }
  protoOf(DelegatedRequest).vrf = function () {
    return this.irw_1;
  };
  protoOf(DelegatedRequest).gre = function () {
    return this.jrw_1.gre();
  };
  protoOf(DelegatedRequest).h63 = function () {
    return this.jrw_1.h63();
  };
  protoOf(DelegatedRequest).ho = function () {
    return this.jrw_1.ho();
  };
  protoOf(DelegatedRequest).tr2 = function () {
    return this.jrw_1.tr2();
  };
  protoOf(DelegatedRequest).wrf = function () {
    return this.jrw_1.wrf();
  };
  protoOf(DelegatedRequest).qfs = function () {
    return this.jrw_1.qfs();
  };
  function DelegatedResponse(call, content, origin) {
    HttpResponse.call(this);
    this.krw_1 = call;
    this.lrw_1 = content;
    this.mrw_1 = origin;
    this.nrw_1 = this.mrw_1.ho();
  }
  protoOf(DelegatedResponse).vrf = function () {
    return this.krw_1;
  };
  protoOf(DelegatedResponse).h63 = function () {
    return this.lrw_1;
  };
  protoOf(DelegatedResponse).ho = function () {
    return this.nrw_1;
  };
  protoOf(DelegatedResponse).arf = function () {
    return this.mrw_1.arf();
  };
  protoOf(DelegatedResponse).grg = function () {
    return this.mrw_1.grg();
  };
  protoOf(DelegatedResponse).hrg = function () {
    return this.mrw_1.hrg();
  };
  protoOf(DelegatedResponse).irg = function () {
    return this.mrw_1.irg();
  };
  protoOf(DelegatedResponse).tr2 = function () {
    return this.mrw_1.tr2();
  };
  function DefaultClientWebSocketSession(call, delegate) {
    this.orw_1 = call;
    this.prw_1 = delegate;
  }
  protoOf(DefaultClientWebSocketSession).pe0 = function () {
    return this.prw_1.pe0();
  };
  protoOf(DefaultClientWebSocketSession).ho = function () {
    return this.prw_1.ho();
  };
  protoOf(DefaultClientWebSocketSession).te0 = function () {
    return this.prw_1.te0();
  };
  protoOf(DefaultClientWebSocketSession).re0 = function (_set____db54di) {
    this.prw_1.re0(_set____db54di);
  };
  protoOf(DefaultClientWebSocketSession).se0 = function () {
    return this.prw_1.se0();
  };
  protoOf(DefaultClientWebSocketSession).ue0 = function () {
    return this.prw_1.ue0();
  };
  protoOf(DefaultClientWebSocketSession).we0 = function ($completion) {
    return this.prw_1.we0($completion);
  };
  protoOf(DefaultClientWebSocketSession).ve0 = function (frame, $completion) {
    return this.prw_1.ve0(frame, $completion);
  };
  protoOf(DefaultClientWebSocketSession).qe0 = function (negotiatedExtensions) {
    this.prw_1.qe0(negotiatedExtensions);
  };
  function DelegatingClientWebSocketSession(call, session) {
    this.qrw_1 = call;
    this.rrw_1 = session;
  }
  protoOf(DelegatingClientWebSocketSession).ho = function () {
    return this.rrw_1.ho();
  };
  protoOf(DelegatingClientWebSocketSession).te0 = function () {
    return this.rrw_1.te0();
  };
  protoOf(DelegatingClientWebSocketSession).re0 = function (_set____db54di) {
    this.rrw_1.re0(_set____db54di);
  };
  protoOf(DelegatingClientWebSocketSession).se0 = function () {
    return this.rrw_1.se0();
  };
  protoOf(DelegatingClientWebSocketSession).ue0 = function () {
    return this.rrw_1.ue0();
  };
  protoOf(DelegatingClientWebSocketSession).we0 = function ($completion) {
    return this.rrw_1.we0($completion);
  };
  protoOf(DelegatingClientWebSocketSession).ve0 = function (frame, $completion) {
    return this.rrw_1.ve0(frame, $completion);
  };
  function WebSocketContent() {
    ClientUpgradeContent.call(this);
    var tmp = this;
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder_init_$Create$_1();
    var nonce = generateNonce(16);
    this_0.j8(encodeBase64(nonce));
    tmp.urw_1 = this_0.toString();
    var tmp_0 = this;
    // Inline function 'kotlin.apply' call
    var this_1 = new HeadersBuilder();
    this_1.tdw(HttpHeaders_getInstance().nr1_1, 'websocket');
    this_1.tdw(HttpHeaders_getInstance().bqz_1, 'Upgrade');
    this_1.tdw(HttpHeaders_getInstance().cr1_1, this.urw_1);
    this_1.tdw(HttpHeaders_getInstance().er1_1, '13');
    tmp_0.vrw_1 = this_1.f40();
  }
  protoOf(WebSocketContent).tr2 = function () {
    return this.vrw_1;
  };
  protoOf(WebSocketContent).toString = function () {
    return 'WebSocketContent';
  };
  function get_REQUEST_EXTENSIONS_KEY() {
    _init_properties_WebSockets_kt__jaqpbo();
    return REQUEST_EXTENSIONS_KEY;
  }
  var REQUEST_EXTENSIONS_KEY;
  function get_LOGGER_7() {
    _init_properties_WebSockets_kt__jaqpbo();
    return LOGGER_7;
  }
  var LOGGER_7;
  function WebSockets$Plugin$install$slambda($extensionsSupported, $plugin, resultContinuation) {
    this.erx_1 = $extensionsSupported;
    this.frx_1 = $plugin;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(WebSockets$Plugin$install$slambda).mrb = function ($this$intercept, it, $completion) {
    var tmp = this.nrb($this$intercept, it, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(WebSockets$Plugin$install$slambda).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof PipelineContext ? p1 : THROW_CCE();
    return this.mrb(tmp, !(p2 == null) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(WebSockets$Plugin$install$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            if (!isWebsocket(this.grx_1.jdz_1.src_1.ur5_1)) {
              get_LOGGER_7().fe0('Skipping WebSocket plugin for non-websocket request: ' + this.grx_1.jdz_1.src_1.toString());
              return Unit_instance;
            }

            get_LOGGER_7().fe0('Sending WebSocket request ' + this.grx_1.jdz_1.src_1.toString());
            this.grx_1.jdz_1.wrv(WebSocketCapability_instance, Unit_instance);
            if (this.erx_1) {
              installExtensions(this.frx_1, this.grx_1.jdz_1);
            }

            this.f9_1 = 1;
            suspendResult = this.grx_1.ndy(new WebSocketContent(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(WebSockets$Plugin$install$slambda).nrb = function ($this$intercept, it, completion) {
    var i = new WebSockets$Plugin$install$slambda(this.erx_1, this.frx_1, completion);
    i.grx_1 = $this$intercept;
    i.hrx_1 = it;
    return i;
  };
  function WebSockets$Plugin$install$slambda_0($extensionsSupported, $plugin, resultContinuation) {
    var i = new WebSockets$Plugin$install$slambda($extensionsSupported, $plugin, resultContinuation);
    var l = function ($this$intercept, it, $completion) {
      return i.mrb($this$intercept, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function WebSockets$Plugin$install$slambda_1($plugin, $extensionsSupported, resultContinuation) {
    this.qrx_1 = $plugin;
    this.rrx_1 = $extensionsSupported;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(WebSockets$Plugin$install$slambda_1).grc = function ($this$intercept, _name_for_destructuring_parameter_0__wldtmu, $completion) {
    var tmp = this.hrc($this$intercept, _name_for_destructuring_parameter_0__wldtmu, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(WebSockets$Plugin$install$slambda_1).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof PipelineContext ? p1 : THROW_CCE();
    return this.grc(tmp, p2 instanceof HttpResponseContainer ? p2 : THROW_CCE(), $completion);
  };
  protoOf(WebSockets$Plugin$install$slambda_1).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            var info = this.trx_1.fg();
            var session = this.trx_1.gg();
            var response = this.srx_1.jdz_1.trb();
            var status = response.arf();
            var requestContent = get_request(response).h63();
            if (!(requestContent instanceof WebSocketContent)) {
              get_LOGGER_7().fe0('Skipping non-websocket response from ' + this.srx_1.jdz_1.yre().qfs().toString() + ': ' + toString_1(session));
              return Unit_instance;
            }

            if (!status.equals(Companion_getInstance_378().mr3_1)) {
              throw WebSocketException_init_$Create$('Handshake exception, expected status code ' + Companion_getInstance_378().mr3_1.or5_1 + ' but was ' + status.or5_1);
            }

            if (!isInterface(session, WebSocketSession)) {
              throw WebSocketException_init_$Create$('Handshake exception, expected `WebSocketSession` content but was ' + toString_1(session));
            }

            get_LOGGER_7().fe0('Receive websocket session from ' + this.srx_1.jdz_1.yre().qfs().toString() + ': ' + toString_1(session));
            var tmp_0;
            if (info.ae0_1.equals(getKClass(DefaultClientWebSocketSession))) {
              var defaultSession = this.qrx_1.yrx(session);
              var clientSession = new DefaultClientWebSocketSession(this.srx_1.jdz_1, defaultSession);
              var tmp_1;
              if (this.rrx_1) {
                tmp_1 = completeNegotiation(this.qrx_1, this.srx_1.jdz_1);
              } else {
                tmp_1 = emptyList();
              }
              var negotiated = tmp_1;
              clientSession.qe0(negotiated);
              tmp_0 = clientSession;
            } else {
              tmp_0 = new DelegatingClientWebSocketSession(this.srx_1.jdz_1, session);
            }

            var clientSession_0 = tmp_0;
            this.f9_1 = 1;
            suspendResult = this.srx_1.ndy(new HttpResponseContainer(info, clientSession_0), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(WebSockets$Plugin$install$slambda_1).hrc = function ($this$intercept, _name_for_destructuring_parameter_0__wldtmu, completion) {
    var i = new WebSockets$Plugin$install$slambda_1(this.qrx_1, this.rrx_1, completion);
    i.srx_1 = $this$intercept;
    i.trx_1 = _name_for_destructuring_parameter_0__wldtmu;
    return i;
  };
  function WebSockets$Plugin$install$slambda_2($plugin, $extensionsSupported, resultContinuation) {
    var i = new WebSockets$Plugin$install$slambda_1($plugin, $extensionsSupported, resultContinuation);
    var l = function ($this$intercept, _name_for_destructuring_parameter_0__wldtmu, $completion) {
      return i.grc($this$intercept, _name_for_destructuring_parameter_0__wldtmu, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function installExtensions($this, context) {
    var installed = $this.wrx_1.f40();
    context.xrc_1.odu(get_REQUEST_EXTENSIONS_KEY(), installed);
    // Inline function 'kotlin.collections.flatMap' call
    // Inline function 'kotlin.collections.flatMapTo' call
    var destination = ArrayList_init_$Create$();
    var _iterator__ex2g4s = installed.m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      var list = element.zrx();
      addAll_1(destination, list);
    }
    var protocols = destination;
    addNegotiatedProtocols($this, context, protocols);
  }
  function completeNegotiation($this, call) {
    var tmp0_safe_receiver = call.trb().tr2().ld(HttpHeaders_getInstance().br1_1);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp = parseWebSocketExtensions(tmp0_safe_receiver);
    }
    var tmp1_elvis_lhs = tmp;
    var serverExtensions = tmp1_elvis_lhs == null ? emptyList() : tmp1_elvis_lhs;
    var clientExtensions = call.gre().ldu(get_REQUEST_EXTENSIONS_KEY());
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList_init_$Create$();
    var _iterator__ex2g4s = clientExtensions.m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      if (element.ary(serverExtensions)) {
        destination.j(element);
      }
    }
    return destination;
  }
  function addNegotiatedProtocols($this, context, protocols) {
    if (protocols.s())
      return Unit_instance;
    var headerValue = joinToString_0(protocols, ';');
    header(context, HttpHeaders_getInstance().br1_1, headerValue);
  }
  function Config_3() {
    this.bry_1 = new WebSocketExtensionsConfig();
    this.cry_1 = -1n;
    this.dry_1 = 2147483647n;
    this.ery_1 = null;
  }
  function Plugin_5() {
    Plugin_instance_5 = this;
    this.fry_1 = new AttributeKey('Websocket');
  }
  protoOf(Plugin_5).z = function () {
    return this.fry_1;
  };
  protoOf(Plugin_5).gry = function (block) {
    // Inline function 'kotlin.apply' call
    var this_0 = new Config_3();
    block(this_0);
    var config = this_0;
    return new WebSockets(config.cry_1, config.dry_1, config.bry_1, config.ery_1);
  };
  protoOf(Plugin_5).wrd = function (block) {
    return this.gry(block);
  };
  protoOf(Plugin_5).hry = function (plugin, scope) {
    var extensionsSupported = scope.nra_1.rrh().t(WebSocketExtensionsCapability_instance);
    var tmp = Phases_getInstance().hrj_1;
    scope.tra_1.ndz(tmp, WebSockets$Plugin$install$slambda_0(extensionsSupported, plugin, null));
    var tmp_0 = Phases_getInstance_1().rrd_1;
    scope.ura_1.ndz(tmp_0, WebSockets$Plugin$install$slambda_2(plugin, extensionsSupported, null));
  };
  protoOf(Plugin_5).xrd = function (plugin, scope) {
    return this.hry(plugin instanceof WebSockets ? plugin : THROW_CCE(), scope);
  };
  var Plugin_instance_5;
  function Plugin_getInstance_5() {
    if (Plugin_instance_5 == null)
      new Plugin_5();
    return Plugin_instance_5;
  }
  function WebSockets(pingInterval, maxFrameSize, extensionsConfig, contentConverter) {
    Plugin_getInstance_5();
    contentConverter = contentConverter === VOID ? null : contentConverter;
    this.urx_1 = pingInterval;
    this.vrx_1 = maxFrameSize;
    this.wrx_1 = extensionsConfig;
    this.xrx_1 = contentConverter;
  }
  protoOf(WebSockets).yrx = function (session) {
    if (isInterface(session, DefaultWebSocketSession))
      return session;
    // Inline function 'kotlin.Long.times' call
    var this_0 = this.urx_1;
    var tmp$ret$0 = multiply_0(this_0, fromInt_0(2));
    // Inline function 'kotlin.also' call
    var this_1 = DefaultWebSocketSession_0(session, this.urx_1, tmp$ret$0);
    this_1.re0(this.vrx_1);
    return this_1;
  };
  function WebSocketExtensionsCapability() {
  }
  protoOf(WebSocketExtensionsCapability).toString = function () {
    return 'WebSocketExtensionsCapability';
  };
  var WebSocketExtensionsCapability_instance;
  function WebSocketExtensionsCapability_getInstance() {
    return WebSocketExtensionsCapability_instance;
  }
  function WebSocketCapability() {
  }
  protoOf(WebSocketCapability).toString = function () {
    return 'WebSocketCapability';
  };
  var WebSocketCapability_instance;
  function WebSocketCapability_getInstance() {
    return WebSocketCapability_instance;
  }
  function WebSocketException_init_$Init$(message, $this) {
    WebSocketException.call($this, message, null);
    return $this;
  }
  function WebSocketException_init_$Create$(message) {
    var tmp = WebSocketException_init_$Init$(message, objectCreate(protoOf(WebSocketException)));
    captureStack(tmp, WebSocketException_init_$Create$);
    return tmp;
  }
  function WebSocketException(message, cause) {
    IllegalStateException_init_$Init$_1(message, cause, this);
    captureStack(this, WebSocketException);
  }
  var properties_initialized_WebSockets_kt_2t2hw2;
  function _init_properties_WebSockets_kt__jaqpbo() {
    if (!properties_initialized_WebSockets_kt_2t2hw2) {
      properties_initialized_WebSockets_kt_2t2hw2 = true;
      REQUEST_EXTENSIONS_KEY = new AttributeKey('Websocket extensions');
      LOGGER_7 = KtorSimpleLogger('io.ktor.client.plugins.websocket.WebSockets');
    }
  }
  function WebSockets_0(_this__u8e3s4, config) {
    var tmp = Plugin_getInstance_5();
    _this__u8e3s4.yrd(tmp, WebSockets$lambda(config));
  }
  function webSocket(_this__u8e3s4, urlString, request, block, $completion) {
    var tmp;
    if (request === VOID) {
      tmp = webSocket$lambda;
    } else {
      tmp = request;
    }
    request = tmp;
    var tmp_0 = Companion_getInstance_376().ur2_1;
    return webSocket_0(_this__u8e3s4, tmp_0, null, null, null, webSocket$lambda_0(urlString, request), block, $completion);
  }
  function webSocket_0(_this__u8e3s4, method, host, port, path, request, block, $completion) {
    method = method === VOID ? Companion_getInstance_376().ur2_1 : method;
    host = host === VOID ? null : host;
    port = port === VOID ? null : port;
    path = path === VOID ? null : path;
    var tmp;
    if (request === VOID) {
      tmp = webSocket$lambda_1;
    } else {
      tmp = request;
    }
    request = tmp;
    return webSocket_1(_this__u8e3s4, webSocket$lambda_2(method, host, port, path, request), block, $completion);
  }
  function webSocket_1(_this__u8e3s4, request, block, $completion) {
    var tmp = new $webSocketCOROUTINE$(_this__u8e3s4, request, block, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  }
  function WebSockets$lambda($config) {
    return function ($this$install) {
      $config($this$install);
      return Unit_instance;
    };
  }
  function webSocket$lambda($this$null) {
    return Unit_instance;
  }
  function webSocket$lambda_0($urlString, $request) {
    return function ($this$webSocket) {
      $this$webSocket.src_1.ur5_1 = Companion_getInstance_381().zr6_1;
      $this$webSocket.src_1.wr5_1 = get_port($this$webSocket);
      takeFrom($this$webSocket.src_1, $urlString);
      $request($this$webSocket);
      return Unit_instance;
    };
  }
  function webSocket$lambda_1($this$null) {
    return Unit_instance;
  }
  function webSocket$lambda_2($method, $host, $port, $path, $request) {
    return function ($this$webSocket) {
      $this$webSocket.trc_1 = $method;
      url_0($this$webSocket, 'ws', $host, $port, $path);
      $request($this$webSocket);
      return Unit_instance;
    };
  }
  function webSocket$lambda_3($this$url, it) {
    $this$url.ur5_1 = Companion_getInstance_381().zr6_1;
    return Unit_instance;
  }
  function $webSocketCOROUTINE$(_this__u8e3s4, request, block, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.qry_1 = _this__u8e3s4;
    this.rry_1 = request;
    this.sry_1 = block;
  }
  protoOf($webSocketCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 20;
            plugin(this.qry_1, Plugin_getInstance_5());
            var tmp0 = this.qry_1;
            var this_0 = new HttpRequestBuilder();
            this_0.arz(webSocket$lambda_3);
            this.rry_1(this_0);
            var session = new HttpStatement(this_0, tmp0);
            var tmp_0 = this;
            tmp_0.zry_1 = session;
            this.f9_1 = 1;
            continue $sm;
          case 1:
            this.wry_1 = this.zry_1;
            this.f9_1 = 2;
            continue $sm;
          case 2:
            this.g9_1 = 19;
            this.f9_1 = 3;
            suspendResult = this.wry_1.drz(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            this.vry_1 = suspendResult;
            this.f9_1 = 4;
            continue $sm;
          case 4:
            this.f9_1 = 5;
            continue $sm;
          case 5:
            this.g9_1 = 17;
            var this_1 = this.vry_1;
            this.f9_1 = 6;
            var tmp_1 = this_1.vrf();
            var tmp_2 = JsType_instance;
            var tmp_3 = getKClass(DefaultClientWebSocketSession);
            var tmp_4;
            try {
              tmp_4 = createKType(getKClass(DefaultClientWebSocketSession), arrayOf([]), false);
            } catch ($p) {
              var tmp_5;
              if ($p instanceof Error) {
                var cause = $p;
                tmp_5 = null;
              } else {
                throw $p;
              }
              tmp_4 = tmp_5;
            }

            suspendResult = tmp_1.zre(typeInfoImpl(tmp_2, tmp_3, tmp_4), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 6:
            var result = suspendResult instanceof DefaultClientWebSocketSession ? suspendResult : THROW_CCE();
            this.yry_1 = result;
            this.f9_1 = 7;
            continue $sm;
          case 7:
            this.g9_1 = 15;
            this.f9_1 = 8;
            suspendResult = this.sry_1(this.yry_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 8:
            this.f9_1 = 9;
            continue $sm;
          case 9:
            this.g9_1 = 17;
            this.f9_1 = 10;
            suspendResult = close_2(this.yry_1, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 10:
            this.yry_1.te0().k16();
            this.f9_1 = 11;
            var tmp_6 = this;
            continue $sm;
          case 11:
            this.g9_1 = 19;
            this.f9_1 = 12;
            suspendResult = this.wry_1.erz(this.vry_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 12:
            this.g9_1 = 20;
            this.f9_1 = 23;
            continue $sm;
          case 13:
            this.g9_1 = 19;
            this.f9_1 = 14;
            suspendResult = this.wry_1.erz(this.vry_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 14:
            var tmp_7 = this;
            tmp_7.try_1 = Unit_instance;
            this.g9_1 = 20;
            this.f9_1 = 22;
            continue $sm;
          case 15:
            this.g9_1 = 17;
            this.xry_1 = this.i9_1;
            this.f9_1 = 16;
            suspendResult = close_2(this.yry_1, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 16:
            this.yry_1.te0().k16();
            throw this.xry_1;
          case 17:
            this.g9_1 = 19;
            this.ury_1 = this.i9_1;
            this.f9_1 = 18;
            suspendResult = this.wry_1.erz(this.vry_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 18:
            throw this.ury_1;
          case 19:
            this.g9_1 = 20;
            var tmp_8 = this.i9_1;
            if (tmp_8 instanceof CancellationException) {
              var cause_0 = this.i9_1;
              throw unwrapCancellationException_0(cause_0);
            } else {
              throw this.i9_1;
            }

          case 20:
            throw this.i9_1;
          case 21:
            this.g9_1 = 20;
            if (false) {
              this.f9_1 = 2;
              continue $sm;
            }

            this.f9_1 = 22;
            continue $sm;
          case 22:
            this.try_1;
            if (false) {
              this.f9_1 = 1;
              continue $sm;
            }

            this.f9_1 = 23;
            continue $sm;
          case 23:
            return Unit_instance;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 20) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function ClientUpgradeContent$content$delegate$lambda() {
    return ByteChannel();
  }
  function ClientUpgradeContent() {
    NoContent.call(this);
    var tmp = this;
    tmp.grz_1 = lazy(ClientUpgradeContent$content$delegate$lambda);
  }
  function DefaultHttpRequest(call, data) {
    this.hrz_1 = call;
    this.irz_1 = data.lrh_1;
    this.jrz_1 = data.krh_1;
    this.krz_1 = data.nrh_1;
    this.lrz_1 = data.mrh_1;
    this.mrz_1 = data.prh_1;
  }
  protoOf(DefaultHttpRequest).vrf = function () {
    return this.hrz_1;
  };
  protoOf(DefaultHttpRequest).ho = function () {
    return this.vrf().ho();
  };
  protoOf(DefaultHttpRequest).wrf = function () {
    return this.irz_1;
  };
  protoOf(DefaultHttpRequest).qfs = function () {
    return this.jrz_1;
  };
  protoOf(DefaultHttpRequest).h63 = function () {
    return this.krz_1;
  };
  protoOf(DefaultHttpRequest).tr2 = function () {
    return this.lrz_1;
  };
  protoOf(DefaultHttpRequest).gre = function () {
    return this.mrz_1;
  };
  function Companion_387() {
  }
  var Companion_instance_387;
  function Companion_getInstance_387() {
    return Companion_instance_387;
  }
  function HttpRequestBuilder$setCapability$lambda() {
    // Inline function 'kotlin.collections.mutableMapOf' call
    return LinkedHashMap_init_$Create$();
  }
  function HttpRequestBuilder() {
    this.src_1 = new URLBuilder();
    this.trc_1 = Companion_getInstance_376().ur2_1;
    this.urc_1 = new HeadersBuilder();
    this.vrc_1 = EmptyContent_getInstance();
    this.wrc_1 = SupervisorJob();
    this.xrc_1 = AttributesJsFn(true);
  }
  protoOf(HttpRequestBuilder).tr2 = function () {
    return this.urc_1;
  };
  protoOf(HttpRequestBuilder).gri = function (value) {
    if (!(value == null)) {
      this.xrc_1.odu(get_BodyTypeAttributeKey(), value);
    } else {
      this.xrc_1.pdu(get_BodyTypeAttributeKey());
    }
  };
  protoOf(HttpRequestBuilder).nrz = function () {
    return this.xrc_1.mdu(get_BodyTypeAttributeKey());
  };
  protoOf(HttpRequestBuilder).arz = function (block) {
    return block(this.src_1, this.src_1);
  };
  protoOf(HttpRequestBuilder).f40 = function () {
    var tmp = this.src_1.f40();
    var tmp_0 = this.trc_1;
    var tmp_1 = this.urc_1.f40();
    var tmp_2 = this.vrc_1;
    var tmp0_elvis_lhs = tmp_2 instanceof OutgoingContent ? tmp_2 : null;
    var tmp_3;
    if (tmp0_elvis_lhs == null) {
      var message = 'No request transformation found: ' + toString_1(this.vrc_1);
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    } else {
      tmp_3 = tmp0_elvis_lhs;
    }
    return new HttpRequestData(tmp, tmp_0, tmp_1, tmp_3, this.wrc_1, this.xrc_1);
  };
  protoOf(HttpRequestBuilder).fri = function (builder) {
    this.wrc_1 = builder.wrc_1;
    return this.orz(builder);
  };
  protoOf(HttpRequestBuilder).orz = function (builder) {
    this.trc_1 = builder.trc_1;
    this.vrc_1 = builder.vrc_1;
    this.gri(builder.nrz());
    takeFrom_0(this.src_1, builder.src_1);
    this.src_1.br6_1 = this.src_1.br6_1;
    appendAll(this.urc_1, builder.urc_1);
    putAll_1(this.xrc_1, builder.xrc_1);
    return this;
  };
  protoOf(HttpRequestBuilder).wrv = function (key, capability) {
    var tmp = get_ENGINE_CAPABILITIES_KEY();
    var capabilities = this.xrc_1.qdu(tmp, HttpRequestBuilder$setCapability$lambda);
    // Inline function 'kotlin.collections.set' call
    capabilities.t2(key, capability);
  };
  protoOf(HttpRequestBuilder).vrv = function (key) {
    var tmp0_safe_receiver = this.xrc_1.mdu(get_ENGINE_CAPABILITIES_KEY());
    var tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.q2(key);
    return (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
  };
  function HttpRequest_0() {
  }
  function HttpRequestData(url, method, headers, body, executionContext, attributes) {
    this.krh_1 = url;
    this.lrh_1 = method;
    this.mrh_1 = headers;
    this.nrh_1 = body;
    this.orh_1 = executionContext;
    this.prh_1 = attributes;
    var tmp = this;
    var tmp0_safe_receiver = this.prh_1.mdu(get_ENGINE_CAPABILITIES_KEY());
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.r2();
    tmp.qrh_1 = tmp1_elvis_lhs == null ? emptySet() : tmp1_elvis_lhs;
  }
  protoOf(HttpRequestData).toString = function () {
    return 'HttpRequestData(url=' + this.krh_1.toString() + ', method=' + this.lrh_1.toString() + ')';
  };
  function HttpResponseData(statusCode, requestTime, headers, version, body, callContext) {
    this.zrd_1 = statusCode;
    this.are_1 = requestTime;
    this.bre_1 = headers;
    this.cre_1 = version;
    this.dre_1 = body;
    this.ere_1 = callContext;
    this.fre_1 = GMTDate_0();
  }
  protoOf(HttpResponseData).toString = function () {
    return 'HttpResponseData=(statusCode=' + this.zrd_1.toString() + ')';
  };
  function url(_this__u8e3s4, urlString) {
    takeFrom(_this__u8e3s4.src_1, urlString);
  }
  function url_0(_this__u8e3s4, scheme, host, port, path, block) {
    scheme = scheme === VOID ? null : scheme;
    host = host === VOID ? null : host;
    port = port === VOID ? null : port;
    path = path === VOID ? null : path;
    var tmp;
    if (block === VOID) {
      tmp = url$lambda;
    } else {
      tmp = block;
    }
    block = tmp;
    set_2(_this__u8e3s4.src_1, scheme, host, port, path, block);
  }
  function isUpgradeRequest(_this__u8e3s4) {
    var tmp = _this__u8e3s4.nrh_1;
    return tmp instanceof ClientUpgradeContent;
  }
  function url$lambda($this$null) {
    return Unit_instance;
  }
  function Phases() {
    Phases_instance = this;
    this.erj_1 = new PipelinePhase('Before');
    this.frj_1 = new PipelinePhase('State');
    this.grj_1 = new PipelinePhase('Transform');
    this.hrj_1 = new PipelinePhase('Render');
    this.irj_1 = new PipelinePhase('Send');
  }
  var Phases_instance;
  function Phases_getInstance() {
    if (Phases_instance == null)
      new Phases();
    return Phases_instance;
  }
  function HttpRequestPipeline(developmentMode) {
    Phases_getInstance();
    developmentMode = developmentMode === VOID ? false : developmentMode;
    Pipeline.call(this, [Phases_getInstance().erj_1, Phases_getInstance().frj_1, Phases_getInstance().grj_1, Phases_getInstance().hrj_1, Phases_getInstance().irj_1]);
    this.wrz_1 = developmentMode;
  }
  protoOf(HttpRequestPipeline).hdz = function () {
    return this.wrz_1;
  };
  function Phases_0() {
    Phases_instance_0 = this;
    this.hrd_1 = new PipelinePhase('Before');
    this.ird_1 = new PipelinePhase('State');
    this.jrd_1 = new PipelinePhase('Monitoring');
    this.krd_1 = new PipelinePhase('Engine');
    this.lrd_1 = new PipelinePhase('Receive');
  }
  var Phases_instance_0;
  function Phases_getInstance_0() {
    if (Phases_instance_0 == null)
      new Phases_0();
    return Phases_instance_0;
  }
  function HttpSendPipeline(developmentMode) {
    Phases_getInstance_0();
    developmentMode = developmentMode === VOID ? false : developmentMode;
    Pipeline.call(this, [Phases_getInstance_0().hrd_1, Phases_getInstance_0().ird_1, Phases_getInstance_0().jrd_1, Phases_getInstance_0().krd_1, Phases_getInstance_0().lrd_1]);
    this.es0_1 = developmentMode;
  }
  protoOf(HttpSendPipeline).hdz = function () {
    return this.es0_1;
  };
  function get_BodyTypeAttributeKey() {
    _init_properties_RequestBody_kt__bo3lwf();
    return BodyTypeAttributeKey;
  }
  var BodyTypeAttributeKey;
  var properties_initialized_RequestBody_kt_agyv1b;
  function _init_properties_RequestBody_kt__bo3lwf() {
    if (!properties_initialized_RequestBody_kt_agyv1b) {
      properties_initialized_RequestBody_kt_agyv1b = true;
      BodyTypeAttributeKey = new AttributeKey('BodyTypeAttributeKey');
    }
  }
  function parameter(_this__u8e3s4, key, value) {
    var tmp;
    if (value == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      _this__u8e3s4.src_1.dr6_1.tdw(key, toString_1(value));
      tmp = Unit_instance;
    }
    var tmp_0;
    if (tmp == null) {
      tmp_0 = Unit_instance;
    } else {
      tmp_0 = Unit_instance;
    }
    return tmp_0;
  }
  function accept(_this__u8e3s4, contentType) {
    return _this__u8e3s4.tr2().tdw(HttpHeaders_getInstance().qqy_1, contentType.toString());
  }
  function get_port(_this__u8e3s4) {
    return _this__u8e3s4.src_1.wr5_1;
  }
  function header(_this__u8e3s4, key, value) {
    var tmp;
    if (value == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      _this__u8e3s4.tr2().tdw(key, toString_1(value));
      tmp = Unit_instance;
    }
    var tmp_0;
    if (tmp == null) {
      tmp_0 = Unit_instance;
    } else {
      tmp_0 = Unit_instance;
    }
    return tmp_0;
  }
  function DefaultHttpResponse(call, responseData) {
    HttpResponse.call(this);
    this.fs0_1 = call;
    this.gs0_1 = responseData.ere_1;
    this.hs0_1 = responseData.zrd_1;
    this.is0_1 = responseData.cre_1;
    this.js0_1 = responseData.are_1;
    this.ks0_1 = responseData.fre_1;
    var tmp = this;
    var tmp_0 = responseData.dre_1;
    var tmp0_elvis_lhs = isInterface(tmp_0, ByteReadChannel_1) ? tmp_0 : null;
    tmp.ls0_1 = tmp0_elvis_lhs == null ? Companion_getInstance_257().jdn() : tmp0_elvis_lhs;
    this.ms0_1 = responseData.bre_1;
  }
  protoOf(DefaultHttpResponse).vrf = function () {
    return this.fs0_1;
  };
  protoOf(DefaultHttpResponse).ho = function () {
    return this.gs0_1;
  };
  protoOf(DefaultHttpResponse).arf = function () {
    return this.hs0_1;
  };
  protoOf(DefaultHttpResponse).grg = function () {
    return this.is0_1;
  };
  protoOf(DefaultHttpResponse).hrg = function () {
    return this.js0_1;
  };
  protoOf(DefaultHttpResponse).irg = function () {
    return this.ks0_1;
  };
  protoOf(DefaultHttpResponse).h63 = function () {
    return this.ls0_1;
  };
  protoOf(DefaultHttpResponse).tr2 = function () {
    return this.ms0_1;
  };
  function HttpResponse() {
  }
  protoOf(HttpResponse).toString = function () {
    return 'HttpResponse[' + get_request(this).qfs().toString() + ', ' + this.arf().toString() + ']';
  };
  function complete_0(_this__u8e3s4) {
    var tmp = ensureNotNull(_this__u8e3s4.ho().s9(Key_instance_3));
    var job = isInterface(tmp, CompletableJob) ? tmp : THROW_CCE();
    job.su();
  }
  function get_request(_this__u8e3s4) {
    return _this__u8e3s4.vrf().yre();
  }
  function bodyAsText(_this__u8e3s4, fallbackCharset, $completion) {
    fallbackCharset = fallbackCharset === VOID ? Charsets_getInstance().udq_1 : fallbackCharset;
    var tmp = new $bodyAsTextCOROUTINE$(_this__u8e3s4, fallbackCharset, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  }
  function $bodyAsTextCOROUTINE$(_this__u8e3s4, fallbackCharset, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.vs0_1 = _this__u8e3s4;
    this.ws0_1 = fallbackCharset;
  }
  protoOf($bodyAsTextCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            var tmp0_elvis_lhs = charset_0(this.vs0_1);
            var originCharset = tmp0_elvis_lhs == null ? this.ws0_1 : tmp0_elvis_lhs;
            this.xs0_1 = originCharset.xdq();
            var this_0 = this.vs0_1;
            this.f9_1 = 1;
            var tmp_0 = this_0.vrf();
            var tmp_1 = JsType_instance;
            var tmp_2 = getKClass(ByteReadPacket);
            var tmp_3;
            try {
              tmp_3 = createKType(getKClass(ByteReadPacket), arrayOf([]), false);
            } catch ($p) {
              var tmp_4;
              if ($p instanceof Error) {
                var cause = $p;
                tmp_4 = null;
              } else {
                throw $p;
              }
              tmp_3 = tmp_4;
            }

            suspendResult = tmp_0.zre(typeInfoImpl(tmp_1, tmp_2, tmp_3), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var input = suspendResult instanceof ByteReadPacket ? suspendResult : THROW_CCE();
            return decode(this.xs0_1, input);
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function Phases_1() {
    Phases_instance_1 = this;
    this.prd_1 = new PipelinePhase('Receive');
    this.qrd_1 = new PipelinePhase('Parse');
    this.rrd_1 = new PipelinePhase('Transform');
    this.srd_1 = new PipelinePhase('State');
    this.trd_1 = new PipelinePhase('After');
  }
  var Phases_instance_1;
  function Phases_getInstance_1() {
    if (Phases_instance_1 == null)
      new Phases_1();
    return Phases_instance_1;
  }
  function HttpResponsePipeline(developmentMode) {
    Phases_getInstance_1();
    developmentMode = developmentMode === VOID ? false : developmentMode;
    Pipeline.call(this, [Phases_getInstance_1().prd_1, Phases_getInstance_1().qrd_1, Phases_getInstance_1().rrd_1, Phases_getInstance_1().srd_1, Phases_getInstance_1().trd_1]);
    this.fs1_1 = developmentMode;
  }
  protoOf(HttpResponsePipeline).hdz = function () {
    return this.fs1_1;
  };
  function Phases_2() {
    Phases_instance_2 = this;
    this.jrj_1 = new PipelinePhase('Before');
    this.krj_1 = new PipelinePhase('State');
    this.lrj_1 = new PipelinePhase('After');
  }
  var Phases_instance_2;
  function Phases_getInstance_2() {
    if (Phases_instance_2 == null)
      new Phases_2();
    return Phases_instance_2;
  }
  function HttpReceivePipeline(developmentMode) {
    Phases_getInstance_2();
    developmentMode = developmentMode === VOID ? false : developmentMode;
    Pipeline.call(this, [Phases_getInstance_2().jrj_1, Phases_getInstance_2().krj_1, Phases_getInstance_2().lrj_1]);
    this.ns1_1 = developmentMode;
  }
  protoOf(HttpReceivePipeline).hdz = function () {
    return this.ns1_1;
  };
  function HttpResponseContainer(expectedType, response) {
    this.wre_1 = expectedType;
    this.xre_1 = response;
  }
  protoOf(HttpResponseContainer).fg = function () {
    return this.wre_1;
  };
  protoOf(HttpResponseContainer).gg = function () {
    return this.xre_1;
  };
  protoOf(HttpResponseContainer).toString = function () {
    return 'HttpResponseContainer(expectedType=' + this.wre_1.toString() + ', response=' + toString_1(this.xre_1) + ')';
  };
  protoOf(HttpResponseContainer).hashCode = function () {
    var result = this.wre_1.hashCode();
    result = imul(result, 31) + hashCode(this.xre_1) | 0;
    return result;
  };
  protoOf(HttpResponseContainer).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof HttpResponseContainer))
      return false;
    var tmp0_other_with_cast = other instanceof HttpResponseContainer ? other : THROW_CCE();
    if (!this.wre_1.equals(tmp0_other_with_cast.wre_1))
      return false;
    if (!equals(this.xre_1, tmp0_other_with_cast.xre_1))
      return false;
    return true;
  };
  function checkCapabilities($this) {
    var tmp0_safe_receiver = $this.brz_1.xrc_1.mdu(get_ENGINE_CAPABILITIES_KEY());
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.r2();
    var tmp;
    if (tmp1_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.collections.filterIsInstance' call
      // Inline function 'kotlin.collections.filterIsInstanceTo' call
      var destination = ArrayList_init_$Create$();
      var _iterator__ex2g4s = tmp1_safe_receiver.m();
      while (_iterator__ex2g4s.n()) {
        var element = _iterator__ex2g4s.o();
        if (!(element == null) ? isInterface(element, HttpClientPlugin) : false) {
          destination.j(element);
        }
      }
      tmp = destination;
    }
    var tmp2_safe_receiver = tmp;
    if (tmp2_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s_0 = tmp2_safe_receiver.m();
      while (_iterator__ex2g4s_0.n()) {
        var element_0 = _iterator__ex2g4s_0.o();
        var tmp0 = pluginOrNull($this.crz_1, element_0);
        $l$block: {
          // Inline function 'kotlin.requireNotNull' call
          if (tmp0 == null) {
            var message = 'Consider installing ' + toString_1(element_0) + ' plugin because the request requires it to be installed';
            throw IllegalArgumentException_init_$Create$_0(toString_1(message));
          } else {
            break $l$block;
          }
        }
      }
    }
  }
  function HttpStatement$execute$slambda(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(HttpStatement$execute$slambda).xs1 = function (it, $completion) {
    var tmp = this.frl(it, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(HttpStatement$execute$slambda).v9 = function (p1, $completion) {
    return this.xs1(p1 instanceof HttpResponse ? p1 : THROW_CCE(), $completion);
  };
  protoOf(HttpStatement$execute$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = save(this.ws1_1.vrf(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var savedCall = suspendResult;
            return savedCall.trb();
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(HttpStatement$execute$slambda).frl = function (it, completion) {
    var i = new HttpStatement$execute$slambda(completion);
    i.ws1_1 = it;
    return i;
  };
  function HttpStatement$execute$slambda_0(resultContinuation) {
    var i = new HttpStatement$execute$slambda(resultContinuation);
    var l = function (it, $completion) {
      return i.xs1(it, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function $executeCOROUTINE$_2(_this__u8e3s4, block, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.gs2_1 = _this__u8e3s4;
    this.hs2_1 = block;
  }
  protoOf($executeCOROUTINE$_2).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 13;
            this.f9_1 = 1;
            continue $sm;
          case 1:
            this.g9_1 = 12;
            this.f9_1 = 2;
            suspendResult = this.gs2_1.drz(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.ks2_1 = suspendResult;
            this.f9_1 = 3;
            continue $sm;
          case 3:
            this.f9_1 = 4;
            continue $sm;
          case 4:
            this.g9_1 = 10;
            this.f9_1 = 5;
            suspendResult = this.hs2_1(this.ks2_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 5:
            this.ms2_1 = suspendResult;
            this.f9_1 = 6;
            var tmp_0 = this;
            continue $sm;
          case 6:
            this.ls2_1 = this.ms2_1;
            this.g9_1 = 12;
            this.f9_1 = 7;
            suspendResult = this.gs2_1.erz(this.ks2_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 7:
            return this.ls2_1;
          case 8:
            this.g9_1 = 12;
            this.f9_1 = 9;
            suspendResult = this.gs2_1.erz(this.ks2_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 9:
            var tmp_1 = this;
            tmp_1.is2_1 = Unit_instance;
            this.g9_1 = 13;
            this.f9_1 = 15;
            continue $sm;
          case 10:
            this.g9_1 = 12;
            this.js2_1 = this.i9_1;
            this.f9_1 = 11;
            suspendResult = this.gs2_1.erz(this.ks2_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 11:
            throw this.js2_1;
          case 12:
            this.g9_1 = 13;
            var tmp_2 = this.i9_1;
            if (tmp_2 instanceof CancellationException) {
              var cause = this.i9_1;
              throw unwrapCancellationException_0(cause);
            } else {
              throw this.i9_1;
            }

          case 13:
            throw this.i9_1;
          case 14:
            this.g9_1 = 13;
            if (false) {
              this.f9_1 = 1;
              continue $sm;
            }

            this.f9_1 = 15;
            continue $sm;
          case 15:
            return this.is2_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 13) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function $executeUnsafeCOROUTINE$(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.vs2_1 = _this__u8e3s4;
  }
  protoOf($executeUnsafeCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 4;
            this.f9_1 = 1;
            continue $sm;
          case 1:
            this.g9_1 = 3;
            var builder = (new HttpRequestBuilder()).fri(this.vs2_1.brz_1);
            this.f9_1 = 2;
            suspendResult = this.vs2_1.crz_1.urd(builder, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var call = suspendResult;
            var tmp_0 = this;
            return call.trb();
          case 3:
            this.g9_1 = 4;
            var tmp_1 = this.i9_1;
            if (tmp_1 instanceof CancellationException) {
              var cause = this.i9_1;
              throw unwrapCancellationException_0(cause);
            } else {
              throw this.i9_1;
            }

          case 4:
            throw this.i9_1;
          case 5:
            this.g9_1 = 4;
            if (false) {
              this.f9_1 = 1;
              continue $sm;
            }

            this.f9_1 = 6;
            continue $sm;
          case 6:
            return this.ws2_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 4) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function $cleanupCOROUTINE$(_this__u8e3s4, _this__u8e3s4_0, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.fs3_1 = _this__u8e3s4;
    this.gs3_1 = _this__u8e3s4_0;
  }
  protoOf($cleanupCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 4;
            var tmp_0 = ensureNotNull(this.gs3_1.ho().s9(Key_instance_3));
            var job = isInterface(tmp_0, CompletableJob) ? tmp_0 : THROW_CCE();
            this.hs3_1 = job;
            this.is3_1 = this.hs3_1;
            this.is3_1.su();
            this.g9_1 = 1;
            cancel_3(this.gs3_1.h63());
            this.g9_1 = 4;
            this.f9_1 = 2;
            continue $sm;
          case 1:
            this.g9_1 = 4;
            var tmp_1 = this.i9_1;
            if (tmp_1 instanceof Error) {
              var _ = this.i9_1;
              this.f9_1 = 2;
              continue $sm;
            } else {
              throw this.i9_1;
            }

          case 2:
            this.g9_1 = 4;
            this.f9_1 = 3;
            suspendResult = this.is3_1.np(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            return Unit_instance;
          case 4:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 4) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function HttpStatement(builder, client) {
    this.brz_1 = builder;
    this.crz_1 = client;
    checkCapabilities(this);
  }
  protoOf(HttpStatement).js3 = function (block, $completion) {
    var tmp = new $executeCOROUTINE$_2(this, block, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(HttpStatement).ks3 = function ($completion) {
    return this.js3(HttpStatement$execute$slambda_0(null), $completion);
  };
  protoOf(HttpStatement).drz = function ($completion) {
    var tmp = new $executeUnsafeCOROUTINE$(this, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(HttpStatement).erz = function (_this__u8e3s4, $completion) {
    var tmp = new $cleanupCOROUTINE$(this, _this__u8e3s4, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(HttpStatement).toString = function () {
    return 'HttpStatement[' + this.brz_1.src_1.toString() + ']';
  };
  function observable(_this__u8e3s4, context, contentLength, listener) {
    var tmp = GlobalScope_instance;
    return writer(tmp, context, true, observable$slambda_0(contentLength, _this__u8e3s4, listener, null)).d11();
  }
  function observable$slambda($contentLength, $this_observable, $listener, resultContinuation) {
    this.ts3_1 = $contentLength;
    this.us3_1 = $this_observable;
    this.vs3_1 = $listener;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(observable$slambda).trg = function ($this$writer, $completion) {
    var tmp = this.urg($this$writer, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(observable$slambda).v9 = function (p1, $completion) {
    return this.trg((!(p1 == null) ? isInterface(p1, WriterScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(observable$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 15;
            var tmp_0 = this;
            tmp_0.ds4_1 = get_ByteArrayPool();
            this.f9_1 = 1;
            continue $sm;
          case 1:
            this.ys3_1 = this.ds4_1;
            this.xs3_1 = this.ys3_1.gdp();
            this.f9_1 = 2;
            continue $sm;
          case 2:
            this.f9_1 = 3;
            continue $sm;
          case 3:
            this.g9_1 = 14;
            this.cs4_1 = this.xs3_1;
            var tmp_1 = this;
            var tmp0_elvis_lhs = this.ts3_1;
            tmp_1.zs3_1 = tmp0_elvis_lhs == null ? -1n : tmp0_elvis_lhs;
            this.as4_1 = 0n;
            this.f9_1 = 4;
            continue $sm;
          case 4:
            if (!!this.us3_1.gdh()) {
              this.f9_1 = 8;
              continue $sm;
            }

            this.f9_1 = 5;
            suspendResult = readAvailable(this.us3_1, this.cs4_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 5:
            this.bs4_1 = suspendResult;
            this.f9_1 = 6;
            suspendResult = this.ws3_1.d11().fdm(this.cs4_1, 0, this.bs4_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 6:
            var tmp_2 = this;
            var tmp0 = this.as4_1;
            var other = this.bs4_1;
            tmp_2.as4_1 = add_2(tmp0, fromInt_0(other));
            this.f9_1 = 7;
            suspendResult = this.vs3_1(this.as4_1, this.zs3_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 7:
            this.f9_1 = 4;
            continue $sm;
          case 8:
            var closedCause = this.us3_1.rdg();
            this.ws3_1.d11().g16(closedCause);
            if (closedCause == null && this.as4_1 === 0n) {
              this.f9_1 = 9;
              suspendResult = this.vs3_1(this.as4_1, this.zs3_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.f9_1 = 10;
              continue $sm;
            }

          case 9:
            this.f9_1 = 10;
            continue $sm;
          case 10:
            this.g9_1 = 15;
            this.f9_1 = 11;
            continue $sm;
          case 11:
            this.g9_1 = 15;
            this.ys3_1.hdp(this.xs3_1);
            this.f9_1 = 13;
            continue $sm;
          case 12:
            this.g9_1 = 15;
            this.ys3_1.hdp(this.xs3_1);
            if (false) {
              this.f9_1 = 1;
              continue $sm;
            }

            this.f9_1 = 13;
            continue $sm;
          case 13:
            return Unit_instance;
          case 14:
            this.g9_1 = 15;
            var t = this.i9_1;
            this.ys3_1.hdp(this.xs3_1);
            throw t;
          case 15:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 15) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(observable$slambda).urg = function ($this$writer, completion) {
    var i = new observable$slambda(this.ts3_1, this.us3_1, this.vs3_1, completion);
    i.ws3_1 = $this$writer;
    return i;
  };
  function observable$slambda_0($contentLength, $this_observable, $listener, resultContinuation) {
    var i = new observable$slambda($contentLength, $this_observable, $listener, resultContinuation);
    var l = function ($this$writer, $completion) {
      return i.trg($this$writer, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function get_HttpRequestCreated() {
    _init_properties_ClientEvents_kt__xuvbz8();
    return HttpRequestCreated;
  }
  var HttpRequestCreated;
  function get_HttpRequestIsReadyForSending() {
    _init_properties_ClientEvents_kt__xuvbz8();
    return HttpRequestIsReadyForSending;
  }
  var HttpRequestIsReadyForSending;
  function get_HttpResponseReceived() {
    _init_properties_ClientEvents_kt__xuvbz8();
    return HttpResponseReceived;
  }
  var HttpResponseReceived;
  function get_HttpResponseReceiveFailed() {
    _init_properties_ClientEvents_kt__xuvbz8();
    return HttpResponseReceiveFailed;
  }
  var HttpResponseReceiveFailed;
  function get_HttpResponseCancelled() {
    _init_properties_ClientEvents_kt__xuvbz8();
    return HttpResponseCancelled;
  }
  var HttpResponseCancelled;
  function HttpResponseReceiveFail(response, cause) {
    this.es4_1 = response;
    this.fs4_1 = cause;
  }
  var properties_initialized_ClientEvents_kt_rdee4m;
  function _init_properties_ClientEvents_kt__xuvbz8() {
    if (!properties_initialized_ClientEvents_kt_rdee4m) {
      properties_initialized_ClientEvents_kt_rdee4m = true;
      HttpRequestCreated = new EventDefinition();
      HttpRequestIsReadyForSending = new EventDefinition();
      HttpResponseReceived = new EventDefinition();
      HttpResponseReceiveFailed = new EventDefinition();
      HttpResponseCancelled = new EventDefinition();
    }
  }
  function EmptyContent() {
    EmptyContent_instance = this;
    NoContent.call(this);
    this.hs4_1 = 0n;
  }
  protoOf(EmptyContent).vr7 = function () {
    return this.hs4_1;
  };
  protoOf(EmptyContent).toString = function () {
    return 'EmptyContent';
  };
  var EmptyContent_instance;
  function EmptyContent_getInstance() {
    if (EmptyContent_instance == null)
      new EmptyContent();
    return EmptyContent_instance;
  }
  function buildHeaders(block) {
    var tmp;
    if (block === VOID) {
      tmp = buildHeaders$lambda;
    } else {
      tmp = block;
    }
    block = tmp;
    // Inline function 'kotlin.apply' call
    var this_0 = new HeadersBuilder();
    block(this_0);
    return this_0.f40();
  }
  function buildHeaders$lambda($this$null) {
    return Unit_instance;
  }
  function HttpClient_1(block) {
    var tmp;
    if (block === VOID) {
      tmp = HttpClient$lambda_3;
    } else {
      tmp = block;
    }
    block = tmp;
    return HttpClient_0(JsClient(), block);
  }
  function HttpClient$lambda_3($this$null) {
    return Unit_instance;
  }
  function ioDispatcher() {
    return Dispatchers_getInstance().uz_1;
  }
  function JsClient() {
    return Js_instance;
  }
  function Js() {
  }
  protoOf(Js).is4 = function (block) {
    // Inline function 'kotlin.apply' call
    var this_0 = new HttpClientEngineConfig();
    block(this_0);
    return new JsClientEngine(this_0);
  };
  protoOf(Js).vrd = function (block) {
    return this.is4(block);
  };
  var Js_instance;
  function Js_getInstance() {
    return Js_instance;
  }
  function createWebSocket($this, urlString_capturingHack, headers) {
    // Inline function 'kotlin.collections.filter' call
    var tmp0 = headers.ldw();
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList_init_$Create$();
    var _iterator__ex2g4s = tmp0.m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      if (equals_0(element, 'sec-websocket-protocol', true)) {
        destination.j(element);
      }
    }
    var protocolHeaderNames = destination;
    // Inline function 'kotlin.collections.mapNotNull' call
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var destination_0 = ArrayList_init_$Create$();
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s_0 = protocolHeaderNames.m();
    while (_iterator__ex2g4s_0.n()) {
      var element_0 = _iterator__ex2g4s_0.o();
      var tmp0_safe_receiver = headers.kdw(element_0);
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        destination_0.j(tmp0_safe_receiver);
      }
    }
    // Inline function 'kotlin.collections.toTypedArray' call
    var this_0 = flatten(destination_0);
    var protocols = copyToArray(this_0);
    var tmp;
    if (get_platform(PlatformUtils_getInstance()).x2_1 === 2) {
      tmp = new WebSocket(urlString_capturingHack, protocols);
    } else {
      var ws_capturingHack = eval('require')('ws');
      var headers_capturingHack = new JsClientEngine$createWebSocket$headers_capturingHack$1();
      headers.mdw(JsClientEngine$createWebSocket$lambda(headers_capturingHack));
      tmp = new ws_capturingHack(urlString_capturingHack, protocols, {headers: headers_capturingHack});
    }
    return tmp;
  }
  function executeWebSocketRequest($this, request, callContext, $completion) {
    var tmp = new $executeWebSocketRequestCOROUTINE$($this, request, callContext, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  }
  function JsClientEngine$createWebSocket$headers_capturingHack$1() {
  }
  function JsClientEngine$createWebSocket$lambda($headers_capturingHack) {
    return function (name, values) {
      $headers_capturingHack[name] = joinToString_0(values, ',');
      return Unit_instance;
    };
  }
  function $executeCOROUTINE$_3(_this__u8e3s4, data, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.fs5_1 = _this__u8e3s4;
    this.gs5_1 = data;
  }
  protoOf($executeCOROUTINE$_3).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 6;
            this.f9_1 = 1;
            suspendResult = callContext(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.hs5_1 = suspendResult;
            this.js5_1 = this.gs5_1.prh_1.ldu(get_CLIENT_CONFIG());
            if (isUpgradeRequest(this.gs5_1)) {
              this.f9_1 = 5;
              suspendResult = executeWebSocketRequest(this.fs5_1, this.gs5_1, this.hs5_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.f9_1 = 2;
              continue $sm;
            }

          case 2:
            this.is5_1 = GMTDate_0();
            this.f9_1 = 3;
            suspendResult = toRaw(this.gs5_1, this.js5_1, this.hs5_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            var rawRequest = suspendResult;
            this.f9_1 = 4;
            suspendResult = commonFetch(this.gs5_1.krh_1.toString(), rawRequest, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            var rawResponse = suspendResult;
            var status = new HttpStatusCode(rawResponse.status, rawResponse.statusText);
            var headers = mapToKtor(rawResponse.headers);
            var version = Companion_getInstance_377().er3_1;
            var body = readBody(CoroutineScope_0(this.hs5_1), rawResponse);
            return new HttpResponseData(status, this.is5_1, headers, version, body, this.hs5_1);
          case 5:
            return suspendResult;
          case 6:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 6) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function $executeWebSocketRequestCOROUTINE$(_this__u8e3s4, request, callContext, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.rs4_1 = _this__u8e3s4;
    this.ss4_1 = request;
    this.ts4_1 = callContext;
  }
  protoOf($executeWebSocketRequestCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 4;
            this.vs4_1 = GMTDate_0();
            this.ws4_1 = this.ss4_1.krh_1.toString();
            var socket = createWebSocket(this.rs4_1, this.ws4_1, this.ss4_1.mrh_1);
            this.us4_1 = new JsWebSocketSession(this.ts4_1, socket);
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = awaitConnection(socket, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.g9_1 = 4;
            this.f9_1 = 3;
            continue $sm;
          case 2:
            this.g9_1 = 4;
            var tmp_0 = this.i9_1;
            if (tmp_0 instanceof Error) {
              var cause = this.i9_1;
              cancel_1(this.ts4_1, CancellationException_init_$Create$_1('Failed to connect to ' + this.ws4_1, cause));
              throw cause;
            } else {
              throw this.i9_1;
            }

          case 3:
            this.g9_1 = 4;
            return new HttpResponseData(Companion_getInstance_378().mr3_1, this.vs4_1, Companion_getInstance_375().nqy_1, Companion_getInstance_377().er3_1, this.us4_1, this.ts4_1);
          case 4:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 4) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function JsClientEngine(config) {
    HttpClientEngineBase.call(this, 'ktor-js');
    this.os5_1 = config;
    this.ps5_1 = setOf_0([Plugin_getInstance_4(), WebSocketCapability_instance]);
    // Inline function 'kotlin.check' call
    if (!(this.os5_1.crj_1 == null)) {
      var message = 'Proxy unsupported in Js engine.';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
  }
  protoOf(JsClientEngine).ld0 = function () {
    return this.os5_1;
  };
  protoOf(JsClientEngine).rrh = function () {
    return this.ps5_1;
  };
  protoOf(JsClientEngine).tri = function (data, $completion) {
    var tmp = new $executeCOROUTINE$_3(this, data, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  function mapToKtor(_this__u8e3s4) {
    return buildHeaders(mapToKtor$lambda(_this__u8e3s4));
  }
  function awaitConnection(_this__u8e3s4, $completion) {
    var cancellable = new CancellableContinuationImpl(intercepted($completion), 1);
    cancellable.mt();
    $l$block: {
      if (cancellable.ep()) {
        break $l$block;
      }
      var eventListener = awaitConnection$lambda(cancellable, _this__u8e3s4);
      _this__u8e3s4.addEventListener('open', eventListener);
      _this__u8e3s4.addEventListener('error', eventListener);
      cancellable.ur(awaitConnection$lambda_0(_this__u8e3s4, eventListener));
    }
    return cancellable.tt();
  }
  function asString(_this__u8e3s4) {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder_init_$Create$_1();
    var tmp = JSON;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$2 = ['message', 'target', 'type', 'isTrusted'];
    this_0.j8(tmp.stringify(_this__u8e3s4, tmp$ret$2));
    return this_0.toString();
  }
  function JsError(origin) {
    extendThrowable(this, 'Error from javascript[' + origin + '].');
    captureStack(this, JsError);
    this.qs5_1 = origin;
  }
  function mapToKtor$lambda$lambda($this_buildHeaders) {
    return function (value, key) {
      $this_buildHeaders.tdw(key, value);
      return Unit_instance;
    };
  }
  function mapToKtor$lambda($this_mapToKtor) {
    return function ($this$buildHeaders) {
      // Inline function 'kotlin.js.asDynamic' call
      $this_mapToKtor.forEach(mapToKtor$lambda$lambda($this$buildHeaders));
      return Unit_instance;
    };
  }
  function awaitConnection$lambda($continuation, $this_awaitConnection) {
    return function (event) {
      var tmp0_subject = event.type;
      var tmp;
      if (tmp0_subject === 'open') {
        var tmp0 = $continuation;
        // Inline function 'kotlin.coroutines.resume' call
        // Inline function 'kotlin.Companion.success' call
        var value = $this_awaitConnection;
        var tmp$ret$0 = _Result___init__impl__xyqfz8(value);
        tmp0.q9(tmp$ret$0);
        tmp = Unit_instance;
      } else if (tmp0_subject === 'error') {
        var tmp0_0 = $continuation;
        // Inline function 'kotlin.coroutines.resumeWithException' call
        // Inline function 'kotlin.Companion.failure' call
        var exception = WebSocketException_init_$Create$(asString(event));
        var tmp$ret$2 = _Result___init__impl__xyqfz8(createFailure(exception));
        tmp0_0.q9(tmp$ret$2);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function awaitConnection$lambda_0($this_awaitConnection, $eventListener) {
    return function (it) {
      $this_awaitConnection.removeEventListener('open', $eventListener);
      $this_awaitConnection.removeEventListener('error', $eventListener);
      var tmp;
      if (!(it == null)) {
        $this_awaitConnection.close();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function toRaw(_this__u8e3s4, clientConfig, callContext, $completion) {
    var tmp = new $toRawCOROUTINE$(_this__u8e3s4, clientConfig, callContext, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  }
  function buildObject(block) {
    var tmp = {};
    // Inline function 'kotlin.apply' call
    var this_0 = (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
    block(this_0);
    return this_0;
  }
  function toRaw$lambda($jsHeaders) {
    return function (key, value) {
      $jsHeaders[key] = value;
      return Unit_instance;
    };
  }
  function toRaw$slambda($content, resultContinuation) {
    this.ms6_1 = $content;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(toRaw$slambda).trg = function ($this$writer, $completion) {
    var tmp = this.urg($this$writer, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(toRaw$slambda).v9 = function (p1, $completion) {
    return this.trg((!(p1 == null) ? isInterface(p1, WriterScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(toRaw$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.ms6_1.br8(this.ns6_1.d11(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(toRaw$slambda).urg = function ($this$writer, completion) {
    var i = new toRaw$slambda(this.ms6_1, completion);
    i.ns6_1 = $this$writer;
    return i;
  };
  function toRaw$slambda_0($content, resultContinuation) {
    var i = new toRaw$slambda($content, resultContinuation);
    var l = function ($this$writer, $completion) {
      return i.trg($this$writer, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function toRaw$lambda_0($this_toRaw, $jsHeaders, $clientConfig, $bodyBytes) {
    return function ($this$buildObject) {
      $this$buildObject.method = $this_toRaw.lrh_1.cr3_1;
      $this$buildObject.headers = $jsHeaders;
      var tmp;
      if ($clientConfig.crd_1) {
        // Inline function 'org.w3c.fetch.FOLLOW' call
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.unsafeCast' call
        tmp = 'follow';
      } else {
        // Inline function 'org.w3c.fetch.MANUAL' call
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.unsafeCast' call
        tmp = 'manual';
      }
      $this$buildObject.redirect = tmp;
      var tmp0_safe_receiver = $bodyBytes;
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        $this$buildObject.body = new Uint8Array(toTypedArray(tmp0_safe_receiver));
      }
      return Unit_instance;
    };
  }
  function $toRawCOROUTINE$(_this__u8e3s4, clientConfig, callContext, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.zs5_1 = _this__u8e3s4;
    this.as6_1 = clientConfig;
    this.bs6_1 = callContext;
  }
  protoOf($toRawCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 4;
            this.cs6_1 = {};
            mergeHeaders(this.zs5_1.mrh_1, this.zs5_1.nrh_1, toRaw$lambda(this.cs6_1));
            var content = this.zs5_1.nrh_1;
            if (content instanceof ByteArrayContent_0) {
              this.ds6_1 = content.wr7();
              this.f9_1 = 3;
              continue $sm;
            } else {
              if (content instanceof ReadChannelContent) {
                this.f9_1 = 2;
                suspendResult = content.zr7().hdm(VOID, this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                if (content instanceof WriteChannelContent) {
                  this.f9_1 = 1;
                  var tmp_0 = GlobalScope_instance;
                  suspendResult = writer(tmp_0, this.bs6_1, VOID, toRaw$slambda_0(content, null)).d11().hdm(VOID, this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  continue $sm;
                } else {
                  this.ds6_1 = null;
                  this.f9_1 = 3;
                  continue $sm;
                }
              }
            }

          case 1:
            var ARGUMENT = suspendResult;
            this.ds6_1 = readBytes(ARGUMENT);
            this.f9_1 = 3;
            continue $sm;
          case 2:
            var ARGUMENT_0 = suspendResult;
            this.ds6_1 = readBytes(ARGUMENT_0);
            this.f9_1 = 3;
            continue $sm;
          case 3:
            var bodyBytes = this.ds6_1;
            return buildObject(toRaw$lambda_0(this.zs5_1, this.cs6_1, this.as6_1, bodyBytes));
          case 4:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 4) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function asByteArray(_this__u8e3s4) {
    // Inline function 'kotlin.js.asDynamic' call
    return new Int8Array(_this__u8e3s4.buffer, _this__u8e3s4.byteOffset, _this__u8e3s4.length);
  }
  function readBodyBrowser(_this__u8e3s4, response) {
    var tmp0_elvis_lhs = response.body;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Companion_getInstance_257().jdn();
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var stream = tmp;
    return channelFromStream(_this__u8e3s4, stream);
  }
  function channelFromStream(_this__u8e3s4, stream) {
    return writer(_this__u8e3s4, VOID, VOID, channelFromStream$slambda_0(stream, null)).d11();
  }
  function readChunk(_this__u8e3s4, $completion) {
    var cancellable = new CancellableContinuationImpl(intercepted($completion), 1);
    cancellable.mt();
    var tmp = _this__u8e3s4.read();
    var tmp_0 = tmp.then(readChunk$lambda(cancellable));
    tmp_0.catch(readChunk$lambda_0(cancellable));
    return cancellable.tt();
  }
  function channelFromStream$slambda($stream, resultContinuation) {
    this.ws6_1 = $stream;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(channelFromStream$slambda).trg = function ($this$writer, $completion) {
    var tmp = this.urg($this$writer, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(channelFromStream$slambda).v9 = function (p1, $completion) {
    return this.trg((!(p1 == null) ? isInterface(p1, WriterScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(channelFromStream$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 6;
            this.ys6_1 = this.ws6_1.getReader();
            this.f9_1 = 1;
            continue $sm;
          case 1:
            if (!true) {
              this.f9_1 = 8;
              continue $sm;
            }

            this.g9_1 = 5;
            this.f9_1 = 2;
            suspendResult = readChunk(this.ys6_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var tmp0_elvis_lhs = suspendResult;
            if (tmp0_elvis_lhs == null) {
              this.g9_1 = 6;
              this.f9_1 = 8;
              var tmp_0 = this;
              continue $sm;
            } else {
              this.zs6_1 = tmp0_elvis_lhs;
              this.f9_1 = 3;
              continue $sm;
            }

          case 3:
            var chunk = this.zs6_1;
            this.f9_1 = 4;
            suspendResult = writeFully(this.xs6_1.d11(), asByteArray(chunk), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            this.xs6_1.d11().c9();
            this.g9_1 = 6;
            this.f9_1 = 7;
            continue $sm;
          case 5:
            this.g9_1 = 6;
            var tmp_1 = this.i9_1;
            if (tmp_1 instanceof Error) {
              var cause = this.i9_1;
              this.ys6_1.cancel(cause);
              throw cause;
            } else {
              throw this.i9_1;
            }

          case 6:
            throw this.i9_1;
          case 7:
            this.g9_1 = 6;
            this.f9_1 = 1;
            continue $sm;
          case 8:
            return Unit_instance;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 6) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(channelFromStream$slambda).urg = function ($this$writer, completion) {
    var i = new channelFromStream$slambda(this.ws6_1, completion);
    i.xs6_1 = $this$writer;
    return i;
  };
  function channelFromStream$slambda_0($stream, resultContinuation) {
    var i = new channelFromStream$slambda($stream, resultContinuation);
    var l = function ($this$writer, $completion) {
      return i.trg($this$writer, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function readChunk$lambda($continuation) {
    return function (it) {
      var chunk = it.value;
      var result = it.done || chunk == null ? null : chunk;
      // Inline function 'kotlin.Companion.success' call
      var tmp$ret$0 = _Result___init__impl__xyqfz8(result);
      $continuation.q9(tmp$ret$0);
      return Unit_instance;
    };
  }
  function readChunk$lambda_0($continuation) {
    return function (cause) {
      // Inline function 'kotlin.coroutines.resumeWithException' call
      var this_0 = $continuation;
      // Inline function 'kotlin.Companion.failure' call
      var tmp$ret$0 = _Result___init__impl__xyqfz8(createFailure(cause));
      this_0.q9(tmp$ret$0);
      return Unit_instance;
    };
  }
  function commonFetch(input, init, $completion) {
    var cancellable = new CancellableContinuationImpl(intercepted($completion), 1);
    cancellable.mt();
    var controller = AbortController_0();
    init.signal = controller.signal;
    cancellable.ur(commonFetch$lambda(controller));
    var promise = get_platform(PlatformUtils_getInstance()).x2_1 === 2 ? fetch(input, init) : jsRequireNodeFetch()(input, init);
    var tmp = commonFetch$lambda_0(cancellable);
    promise.then(tmp, commonFetch$lambda_1(cancellable));
    return cancellable.tt();
  }
  function readBody(_this__u8e3s4, response) {
    return get_platform(PlatformUtils_getInstance()).x2_1 === 3 ? readBodyNode(_this__u8e3s4, response) : readBodyBrowser(_this__u8e3s4, response);
  }
  function AbortController_0() {
    var tmp;
    if (get_platform(PlatformUtils_getInstance()).x2_1 === 2) {
      tmp = new AbortController();
    } else {
      var controller = eval('require')('abort-controller');
      tmp = new controller();
    }
    return tmp;
  }
  function jsRequireNodeFetch() {
    var tmp;
    try {
      tmp = eval('require')('node-fetch');
    } catch ($p) {
      var tmp_0;
      var cause = $p;
      throw Error_init_$Create$_0("Error loading module 'node-fetch': " + cause);
    }
    return tmp;
  }
  function commonFetch$lambda($controller) {
    return function (it) {
      $controller.abort();
      return Unit_instance;
    };
  }
  function commonFetch$lambda_0($continuation) {
    return function (it) {
      // Inline function 'kotlin.Companion.success' call
      var tmp$ret$0 = _Result___init__impl__xyqfz8(it);
      $continuation.q9(tmp$ret$0);
      return Unit_instance;
    };
  }
  function commonFetch$lambda_1($continuation) {
    return function (it) {
      // Inline function 'kotlin.Companion.failure' call
      var exception = Error_init_$Create$_1('Fail to fetch', it);
      var tmp$ret$0 = _Result___init__impl__xyqfz8(createFailure(exception));
      $continuation.q9(tmp$ret$0);
      return Unit_instance;
    };
  }
  function readBodyNode(_this__u8e3s4, response) {
    return writer(_this__u8e3s4, VOID, VOID, readBodyNode$slambda_0(response, null)).d11();
  }
  function readBodyNode$slambda$lambda($responseData, $body) {
    return function (chunk) {
      _ChannelResult___get_isSuccess__impl__odq1z9($responseData.a16(asByteArray(new Uint8Array(chunk))));
      return $body.pause();
    };
  }
  function readBodyNode$slambda$lambda_0($responseData, $this_writer) {
    return function (error) {
      var cause = new JsError(error);
      $responseData.g16(cause);
      return $this_writer.d11().g16(cause);
    };
  }
  function readBodyNode$slambda$lambda_1($responseData) {
    return function () {
      return $responseData.i16();
    };
  }
  function readBodyNode$slambda($response, resultContinuation) {
    this.is7_1 = $response;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(readBodyNode$slambda).trg = function ($this$writer, $completion) {
    var tmp = this.urg($this$writer, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(readBodyNode$slambda).v9 = function (p1, $completion) {
    return this.trg((!(p1 == null) ? isInterface(p1, WriterScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(readBodyNode$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 6;
            var tmp_0 = this;
            var tmp0_elvis_lhs = this.is7_1.body;
            var tmp_1;
            if (tmp0_elvis_lhs == null) {
              var message = 'Fail to get body';
              throw IllegalStateException_init_$Create$_0(toString_1(message));
            } else {
              tmp_1 = tmp0_elvis_lhs;
            }

            tmp_0.ks7_1 = tmp_1;
            var responseData = Channel(1);
            this.ks7_1.on('data', readBodyNode$slambda$lambda(responseData, this.ks7_1));
            this.ks7_1.on('error', readBodyNode$slambda$lambda_0(responseData, this.js7_1));
            this.ks7_1.on('end', readBodyNode$slambda$lambda_1(responseData));
            this.g9_1 = 5;
            this.ls7_1 = responseData.m();
            this.f9_1 = 1;
            continue $sm;
          case 1:
            this.f9_1 = 2;
            suspendResult = this.ls7_1.d14(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            if (!suspendResult) {
              this.f9_1 = 4;
              continue $sm;
            }

            var chunk = this.ls7_1.o();
            this.f9_1 = 3;
            suspendResult = writeFully(this.js7_1.d11(), chunk, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            this.js7_1.d11().c9();
            this.ks7_1.resume();
            this.f9_1 = 1;
            continue $sm;
          case 4:
            this.g9_1 = 6;
            this.f9_1 = 7;
            continue $sm;
          case 5:
            this.g9_1 = 6;
            var tmp_2 = this.i9_1;
            if (tmp_2 instanceof Error) {
              var cause = this.i9_1;
              this.ks7_1.destroy(cause);
              throw cause;
            } else {
              throw this.i9_1;
            }

          case 6:
            throw this.i9_1;
          case 7:
            this.g9_1 = 6;
            return Unit_instance;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 6) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(readBodyNode$slambda).urg = function ($this$writer, completion) {
    var i = new readBodyNode$slambda(this.is7_1, completion);
    i.js7_1 = $this$writer;
    return i;
  };
  function readBodyNode$slambda_0($response, resultContinuation) {
    var i = new readBodyNode$slambda($response, resultContinuation);
    var l = function ($this$writer, $completion) {
      return i.trg($this$writer, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function platformRequestDefaultTransform(contentType, context, body) {
    return null;
  }
  function platformResponseDefaultTransformers(_this__u8e3s4) {
  }
  function isReservedStatusCode($this, _this__u8e3s4) {
    // Inline function 'kotlin.let' call
    var resolved = Companion_getInstance_264().le0(_this__u8e3s4);
    return resolved == null || equals(resolved, Codes_CLOSED_ABNORMALLY_getInstance());
  }
  function JsWebSocketSession$lambda(this$0) {
    return function (it) {
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var event = it;
      var data = event.data;
      var tmp;
      if (data instanceof ArrayBuffer) {
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$3 = new Int8Array(data);
        tmp = Binary_init_$Create$(false, tmp$ret$3);
      } else {
        if (!(data == null) ? typeof data === 'string' : false) {
          tmp = Text_init_$Create$(data);
        } else {
          var error = IllegalStateException_init_$Create$_0('Unknown frame type: ' + event.type);
          this$0.os7_1.ru(error);
          throw error;
        }
      }
      var frame = tmp;
      this$0.ps7_1.a16(frame);
      return Unit_instance;
    };
  }
  function JsWebSocketSession$lambda_0(this$0) {
    return function (it) {
      var cause = WebSocketException_init_$Create$(toString_1(it));
      this$0.os7_1.ru(cause);
      this$0.ps7_1.g16(cause);
      this$0.qs7_1.k16();
      return Unit_instance;
    };
  }
  function JsWebSocketSession$lambda_1(this$0) {
    return function (event) {
      var tmp = event.code;
      var tmp_0 = (!(tmp == null) ? typeof tmp === 'number' : false) ? tmp : THROW_CCE();
      var tmp_1 = event.reason;
      var reason = new CloseReason(tmp_0, (!(tmp_1 == null) ? typeof tmp_1 === 'string' : false) ? tmp_1 : THROW_CCE());
      this$0.os7_1.pu(reason);
      this$0.ps7_1.a16(Close_init_$Create$(reason));
      this$0.ps7_1.i16();
      this$0.qs7_1.k16();
      return Unit_instance;
    };
  }
  function JsWebSocketSession$slambda(this$0, resultContinuation) {
    this.cs8_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(JsWebSocketSession$slambda).e1h = function ($this$launch, $completion) {
    var tmp = this.f1h($this$launch, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(JsWebSocketSession$slambda).v9 = function (p1, $completion) {
    return this.e1h((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(JsWebSocketSession$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 10;
            var tmp_0 = this;
            tmp_0.hs8_1 = this.cs8_1.qs7_1;
            this.f9_1 = 1;
            continue $sm;
          case 1:
            this.fs8_1 = this.hs8_1;
            this.es8_1 = null;
            this.f9_1 = 2;
            continue $sm;
          case 2:
            this.f9_1 = 3;
            continue $sm;
          case 3:
            this.g9_1 = 9;
            this.g9_1 = 8;
            this.gs8_1 = this.fs8_1.m();
            this.f9_1 = 4;
            continue $sm;
          case 4:
            this.f9_1 = 5;
            suspendResult = this.gs8_1.d14(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 5:
            if (!suspendResult) {
              this.f9_1 = 6;
              continue $sm;
            }

            var e = this.gs8_1.o();
            switch (e.ue3_1.x2_1) {
              case 0:
                var text = e.ve3_1;
                this.cs8_1.ns7_1.send(String_0(text));
                break;
              case 1:
                var tmp_1 = e.ve3_1;
                var source = tmp_1 instanceof Int8Array ? tmp_1 : THROW_CCE();
                var frameData = source.buffer.slice(source.byteOffset, source.byteOffset + source.byteLength | 0);
                this.cs8_1.ns7_1.send(frameData);
                break;
              case 2:
                var tmp$ret$0;
                l$ret$1: do {
                  var builder = new BytePacketBuilder();
                  try {
                    writeFully_3(builder, e.ve3_1);
                    tmp$ret$0 = builder.f40();
                    break l$ret$1;
                  } catch ($p) {
                    if ($p instanceof Error) {
                      var t = $p;
                      builder.zu();
                      throw t;
                    } else {
                      throw $p;
                    }
                  }
                }
                 while (false);
                var data = tmp$ret$0;
                var code = readShort_0(data);
                var reason = data.ldq();
                this.cs8_1.os7_1.pu(new CloseReason(code, reason));
                if (isReservedStatusCode(this.cs8_1, code)) {
                  this.cs8_1.ns7_1.close();
                } else {
                  this.cs8_1.ns7_1.close(code, reason);
                }

                break;
              case 3:
              case 4:
                break;
            }

            this.f9_1 = 4;
            continue $sm;
          case 6:
            this.g9_1 = 10;
            this.f9_1 = 7;
            continue $sm;
          case 7:
            this.g9_1 = 10;
            cancelConsumed(this.fs8_1, this.es8_1);
            this.f9_1 = 12;
            continue $sm;
          case 8:
            this.g9_1 = 9;
            var tmp_2 = this.i9_1;
            if (tmp_2 instanceof Error) {
              var e_0 = this.i9_1;
              this.es8_1 = e_0;
              throw e_0;
            } else {
              throw this.i9_1;
            }

          case 9:
            this.g9_1 = 10;
            var t_0 = this.i9_1;
            cancelConsumed(this.fs8_1, this.es8_1);
            throw t_0;
          case 10:
            throw this.i9_1;
          case 11:
            this.g9_1 = 10;
            cancelConsumed(this.fs8_1, this.es8_1);
            if (false) {
              this.f9_1 = 1;
              continue $sm;
            }

            this.f9_1 = 12;
            continue $sm;
          case 12:
            return Unit_instance;
        }
      } catch ($p) {
        var e_1 = $p;
        if (this.g9_1 === 10) {
          throw e_1;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e_1;
        }
      }
     while (true);
  };
  protoOf(JsWebSocketSession$slambda).f1h = function ($this$launch, completion) {
    var i = new JsWebSocketSession$slambda(this.cs8_1, completion);
    i.ds8_1 = $this$launch;
    return i;
  };
  function JsWebSocketSession$slambda_0(this$0, resultContinuation) {
    var i = new JsWebSocketSession$slambda(this$0, resultContinuation);
    var l = function ($this$launch, $completion) {
      return i.e1h($this$launch, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function JsWebSocketSession$lambda_2(this$0) {
    return function (cause) {
      var tmp;
      if (cause == null) {
        this$0.ns7_1.close();
        tmp = Unit_instance;
      } else {
        this$0.ns7_1.close(Codes_NORMAL_getInstance().ie0_1, 'Client failed');
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function JsWebSocketSession(coroutineContext, websocket) {
    this.ms7_1 = coroutineContext;
    this.ns7_1 = websocket;
    this.os7_1 = CompletableDeferred();
    this.ps7_1 = Channel(2147483647);
    this.qs7_1 = Channel(2147483647);
    this.rs7_1 = this.ps7_1;
    this.ss7_1 = this.qs7_1;
    this.ts7_1 = this.os7_1;
    // Inline function 'org.w3c.dom.ARRAYBUFFER' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp$ret$2 = 'arraybuffer';
    this.ns7_1.binaryType = tmp$ret$2;
    this.ns7_1.addEventListener('message', JsWebSocketSession$lambda(this));
    this.ns7_1.addEventListener('error', JsWebSocketSession$lambda_0(this));
    this.ns7_1.addEventListener('close', JsWebSocketSession$lambda_1(this));
    launch(this, VOID, VOID, JsWebSocketSession$slambda_0(this, null));
    var tmp0_safe_receiver = this.ms7_1.s9(Key_instance_3);
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.kp(JsWebSocketSession$lambda_2(this));
    }
  }
  protoOf(JsWebSocketSession).ho = function () {
    return this.ms7_1;
  };
  protoOf(JsWebSocketSession).te0 = function () {
    return this.rs7_1;
  };
  protoOf(JsWebSocketSession).ue0 = function () {
    return this.ss7_1;
  };
  protoOf(JsWebSocketSession).pe0 = function () {
    return this.ts7_1;
  };
  protoOf(JsWebSocketSession).re0 = function (_anonymous_parameter_0__qggqh8) {
    throw WebSocketException_init_$Create$('Max frame size switch is not supported in Js engine.');
  };
  protoOf(JsWebSocketSession).se0 = function () {
    return 9223372036854775807n;
  };
  protoOf(JsWebSocketSession).qe0 = function (negotiatedExtensions) {
    // Inline function 'kotlin.require' call
    if (!negotiatedExtensions.s()) {
      var message = 'Extensions are not supported.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
  };
  protoOf(JsWebSocketSession).we0 = function ($completion) {
    return Unit_instance;
  };
  function unwrapCancellationException_0(_this__u8e3s4) {
    var exception = _this__u8e3s4;
    $l$loop: while (exception instanceof CancellationException) {
      if (equals(exception, exception.cause)) {
        return _this__u8e3s4;
      }
      exception = exception.cause;
    }
    var tmp0_elvis_lhs = exception;
    return tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  }
  function Companion_388() {
  }
  protoOf(Companion_388).i63 = function () {
    return $serializer_getInstance_36();
  };
  var Companion_instance_388;
  function Companion_getInstance_388() {
    return Companion_instance_388;
  }
  function $serializer_38() {
    $serializer_instance_36 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('jetbrains.biokb.editor.service.findUsages.UsageEntryDocumentDto', this, 6);
    tmp0_serialDesc.q5j('accession', false);
    tmp0_serialDesc.q5j('name', false);
    tmp0_serialDesc.q5j('type', false);
    tmp0_serialDesc.q5j('status', false);
    tmp0_serialDesc.q5j('readOnly', false);
    tmp0_serialDesc.q5j('editedByCurrentUser', false);
    this.is8_1 = tmp0_serialDesc;
  }
  protoOf($serializer_38).js8 = function (encoder, value) {
    var tmp0_desc = this.is8_1;
    var tmp1_output = encoder.g5c(tmp0_desc);
    tmp1_output.u5d(tmp0_desc, 0, value.accession);
    tmp1_output.u5d(tmp0_desc, 1, value.name);
    tmp1_output.u5d(tmp0_desc, 2, value.type);
    tmp1_output.u5d(tmp0_desc, 3, value.status);
    tmp1_output.m5d(tmp0_desc, 4, value.readOnly);
    tmp1_output.m5d(tmp0_desc, 5, value.editedByCurrentUser);
    tmp1_output.h5c(tmp0_desc);
  };
  protoOf($serializer_38).i59 = function (encoder, value) {
    return this.js8(encoder, value instanceof UsageEntryDocumentDto ? value : THROW_CCE());
  };
  protoOf($serializer_38).j59 = function (decoder) {
    var tmp0_desc = this.is8_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = false;
    var tmp9_local5 = false;
    var tmp10_input = decoder.g5c(tmp0_desc);
    if (tmp10_input.v5c()) {
      tmp4_local0 = tmp10_input.q5c(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp10_input.q5c(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp10_input.q5c(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp10_input.q5c(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp10_input.i5c(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp10_input.i5c(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp10_input.w5c(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp10_input.q5c(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp10_input.q5c(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp10_input.q5c(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp10_input.q5c(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp10_input.i5c(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp10_input.i5c(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp10_input.h5c(tmp0_desc);
    return UsageEntryDocumentDto_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, null);
  };
  protoOf($serializer_38).v58 = function () {
    return this.is8_1;
  };
  protoOf($serializer_38).f5k = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), BooleanSerializer_getInstance(), BooleanSerializer_getInstance()];
  };
  var $serializer_instance_36;
  function $serializer_getInstance_36() {
    if ($serializer_instance_36 == null)
      new $serializer_38();
    return $serializer_instance_36;
  }
  function UsageEntryDocumentDto_init_$Init$(seen0, accession, name, type, status, readOnly, editedByCurrentUser, serializationConstructorMarker, $this) {
    if (!(63 === (63 & seen0))) {
      throwMissingFieldException(seen0, 63, $serializer_getInstance_36().is8_1);
    }
    $this.accession = accession;
    $this.name = name;
    $this.type = type;
    $this.status = status;
    $this.readOnly = readOnly;
    $this.editedByCurrentUser = editedByCurrentUser;
    return $this;
  }
  function UsageEntryDocumentDto_init_$Create$(seen0, accession, name, type, status, readOnly, editedByCurrentUser, serializationConstructorMarker) {
    return UsageEntryDocumentDto_init_$Init$(seen0, accession, name, type, status, readOnly, editedByCurrentUser, serializationConstructorMarker, objectCreate(protoOf(UsageEntryDocumentDto)));
  }
  function UsageEntryDocumentDto(accession, name, type, status, readOnly, editedByCurrentUser) {
    this.accession = accession;
    this.name = name;
    this.type = type;
    this.status = status;
    this.readOnly = readOnly;
    this.editedByCurrentUser = editedByCurrentUser;
  }
  protoOf(UsageEntryDocumentDto).ks8 = function () {
    return this.accession;
  };
  protoOf(UsageEntryDocumentDto).y2 = function () {
    return this.name;
  };
  protoOf(UsageEntryDocumentDto).sfq = function () {
    return this.type;
  };
  protoOf(UsageEntryDocumentDto).arf = function () {
    return this.status;
  };
  protoOf(UsageEntryDocumentDto).acu = function () {
    return this.readOnly;
  };
  protoOf(UsageEntryDocumentDto).ls8 = function () {
    return this.editedByCurrentUser;
  };
  protoOf(UsageEntryDocumentDto).fg = function () {
    return this.accession;
  };
  protoOf(UsageEntryDocumentDto).gg = function () {
    return this.name;
  };
  protoOf(UsageEntryDocumentDto).zl = function () {
    return this.type;
  };
  protoOf(UsageEntryDocumentDto).b2d = function () {
    return this.status;
  };
  protoOf(UsageEntryDocumentDto).c2d = function () {
    return this.readOnly;
  };
  protoOf(UsageEntryDocumentDto).d2d = function () {
    return this.editedByCurrentUser;
  };
  protoOf(UsageEntryDocumentDto).ms8 = function (accession, name, type, status, readOnly, editedByCurrentUser) {
    return new UsageEntryDocumentDto(accession, name, type, status, readOnly, editedByCurrentUser);
  };
  protoOf(UsageEntryDocumentDto).copy = function (accession, name, type, status, readOnly, editedByCurrentUser, $super) {
    accession = accession === VOID ? this.accession : accession;
    name = name === VOID ? this.name : name;
    type = type === VOID ? this.type : type;
    status = status === VOID ? this.status : status;
    readOnly = readOnly === VOID ? this.readOnly : readOnly;
    editedByCurrentUser = editedByCurrentUser === VOID ? this.editedByCurrentUser : editedByCurrentUser;
    return $super === VOID ? this.ms8(accession, name, type, status, readOnly, editedByCurrentUser) : $super.ms8.call(this, accession, name, type, status, readOnly, editedByCurrentUser);
  };
  protoOf(UsageEntryDocumentDto).toString = function () {
    return 'UsageEntryDocumentDto(accession=' + this.accession + ', name=' + this.name + ', type=' + this.type + ', status=' + this.status + ', readOnly=' + this.readOnly + ', editedByCurrentUser=' + this.editedByCurrentUser + ')';
  };
  protoOf(UsageEntryDocumentDto).hashCode = function () {
    var result = getStringHashCode(this.accession);
    result = imul(result, 31) + getStringHashCode(this.name) | 0;
    result = imul(result, 31) + getStringHashCode(this.type) | 0;
    result = imul(result, 31) + getStringHashCode(this.status) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.readOnly) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.editedByCurrentUser) | 0;
    return result;
  };
  protoOf(UsageEntryDocumentDto).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof UsageEntryDocumentDto))
      return false;
    if (!(this.accession === other.accession))
      return false;
    if (!(this.name === other.name))
      return false;
    if (!(this.type === other.type))
      return false;
    if (!(this.status === other.status))
      return false;
    if (!(this.readOnly === other.readOnly))
      return false;
    if (!(this.editedByCurrentUser === other.editedByCurrentUser))
      return false;
    return true;
  };
  function Companion_389() {
  }
  protoOf(Companion_389).i63 = function () {
    return $serializer_getInstance_37();
  };
  var Companion_instance_389;
  function Companion_getInstance_389() {
    return Companion_instance_389;
  }
  function $serializer_39() {
    $serializer_instance_37 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('jetbrains.biokb.editor.service.findUsages.FindUsageServiceRequest', this, 3);
    tmp0_serialDesc.q5j('declaration', false);
    tmp0_serialDesc.q5j('docsPageSize', false);
    tmp0_serialDesc.q5j('nodesPageSize', false);
    this.ns8_1 = tmp0_serialDesc;
  }
  protoOf($serializer_39).os8 = function (encoder, value) {
    var tmp0_desc = this.ns8_1;
    var tmp1_output = encoder.g5c(tmp0_desc);
    tmp1_output.w5d(tmp0_desc, 0, NodePointerSerializer_getInstance(), value.declaration);
    tmp1_output.p5d(tmp0_desc, 1, value.docsPageSize);
    tmp1_output.p5d(tmp0_desc, 2, value.nodesPageSize);
    tmp1_output.h5c(tmp0_desc);
  };
  protoOf($serializer_39).i59 = function (encoder, value) {
    return this.os8(encoder, value instanceof FindUsageServiceRequest ? value : THROW_CCE());
  };
  protoOf($serializer_39).j59 = function (decoder) {
    var tmp0_desc = this.ns8_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = 0;
    var tmp6_local2 = 0;
    var tmp7_input = decoder.g5c(tmp0_desc);
    if (tmp7_input.v5c()) {
      tmp4_local0 = tmp7_input.s5c(tmp0_desc, 0, NodePointerSerializer_getInstance(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.l5c(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.l5c(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.w5c(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.s5c(tmp0_desc, 0, NodePointerSerializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.l5c(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.l5c(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.h5c(tmp0_desc);
    return FindUsageServiceRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_39).v58 = function () {
    return this.ns8_1;
  };
  protoOf($serializer_39).f5k = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [NodePointerSerializer_getInstance(), IntSerializer_getInstance(), IntSerializer_getInstance()];
  };
  var $serializer_instance_37;
  function $serializer_getInstance_37() {
    if ($serializer_instance_37 == null)
      new $serializer_39();
    return $serializer_instance_37;
  }
  function FindUsageServiceRequest_init_$Init$(seen0, declaration, docsPageSize, nodesPageSize, serializationConstructorMarker, $this) {
    if (!(7 === (7 & seen0))) {
      throwMissingFieldException(seen0, 7, $serializer_getInstance_37().ns8_1);
    }
    $this.declaration = declaration;
    $this.docsPageSize = docsPageSize;
    $this.nodesPageSize = nodesPageSize;
    return $this;
  }
  function FindUsageServiceRequest_init_$Create$(seen0, declaration, docsPageSize, nodesPageSize, serializationConstructorMarker) {
    return FindUsageServiceRequest_init_$Init$(seen0, declaration, docsPageSize, nodesPageSize, serializationConstructorMarker, objectCreate(protoOf(FindUsageServiceRequest)));
  }
  function FindUsageServiceRequest(declaration, docsPageSize, nodesPageSize) {
    this.declaration = declaration;
    this.docsPageSize = docsPageSize;
    this.nodesPageSize = nodesPageSize;
  }
  protoOf(FindUsageServiceRequest).sfr = function () {
    return this.declaration;
  };
  protoOf(FindUsageServiceRequest).ps8 = function () {
    return this.docsPageSize;
  };
  protoOf(FindUsageServiceRequest).qs8 = function () {
    return this.nodesPageSize;
  };
  protoOf(FindUsageServiceRequest).fg = function () {
    return this.declaration;
  };
  protoOf(FindUsageServiceRequest).gg = function () {
    return this.docsPageSize;
  };
  protoOf(FindUsageServiceRequest).zl = function () {
    return this.nodesPageSize;
  };
  protoOf(FindUsageServiceRequest).rs8 = function (declaration, docsPageSize, nodesPageSize) {
    return new FindUsageServiceRequest(declaration, docsPageSize, nodesPageSize);
  };
  protoOf(FindUsageServiceRequest).copy = function (declaration, docsPageSize, nodesPageSize, $super) {
    declaration = declaration === VOID ? this.declaration : declaration;
    docsPageSize = docsPageSize === VOID ? this.docsPageSize : docsPageSize;
    nodesPageSize = nodesPageSize === VOID ? this.nodesPageSize : nodesPageSize;
    return $super === VOID ? this.rs8(declaration, docsPageSize, nodesPageSize) : $super.rs8.call(this, declaration, docsPageSize, nodesPageSize);
  };
  protoOf(FindUsageServiceRequest).toString = function () {
    return 'FindUsageServiceRequest(declaration=' + this.declaration.toString() + ', docsPageSize=' + this.docsPageSize + ', nodesPageSize=' + this.nodesPageSize + ')';
  };
  protoOf(FindUsageServiceRequest).hashCode = function () {
    var result = this.declaration.hashCode();
    result = imul(result, 31) + this.docsPageSize | 0;
    result = imul(result, 31) + this.nodesPageSize | 0;
    return result;
  };
  protoOf(FindUsageServiceRequest).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof FindUsageServiceRequest))
      return false;
    if (!this.declaration.equals(other.declaration))
      return false;
    if (!(this.docsPageSize === other.docsPageSize))
      return false;
    if (!(this.nodesPageSize === other.nodesPageSize))
      return false;
    return true;
  };
  function FindUsageDocumentInfo$Companion$$childSerializers$_anonymous__mn2cu1() {
    return $serializer_init_$Create$_1($serializer_getInstance_34());
  }
  function Companion_390() {
    Companion_instance_390 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.ss8_1 = [null, null, lazy_0(tmp_0, FindUsageDocumentInfo$Companion$$childSerializers$_anonymous__mn2cu1)];
  }
  protoOf(Companion_390).i63 = function () {
    return $serializer_getInstance_38();
  };
  var Companion_instance_390;
  function Companion_getInstance_390() {
    if (Companion_instance_390 == null)
      new Companion_390();
    return Companion_instance_390;
  }
  function $serializer_40() {
    $serializer_instance_38 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('jetbrains.biokb.editor.service.findUsages.FindUsageDocumentInfo', this, 3);
    tmp0_serialDesc.q5j('document', false);
    tmp0_serialDesc.q5j('totalNodes', false);
    tmp0_serialDesc.q5j('initial', false);
    this.ts8_1 = tmp0_serialDesc;
  }
  protoOf($serializer_40).us8 = function (encoder, value) {
    var tmp0_desc = this.ts8_1;
    var tmp1_output = encoder.g5c(tmp0_desc);
    var tmp2_cached = Companion_getInstance_390().ss8_1;
    tmp1_output.w5d(tmp0_desc, 0, $serializer_getInstance_36(), value.document);
    tmp1_output.p5d(tmp0_desc, 1, value.totalNodes);
    tmp1_output.w5d(tmp0_desc, 2, tmp2_cached[2].a1(), value.initial);
    tmp1_output.h5c(tmp0_desc);
  };
  protoOf($serializer_40).i59 = function (encoder, value) {
    return this.us8(encoder, value instanceof FindUsageDocumentInfo ? value : THROW_CCE());
  };
  protoOf($serializer_40).j59 = function (decoder) {
    var tmp0_desc = this.ts8_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = 0;
    var tmp6_local2 = null;
    var tmp7_input = decoder.g5c(tmp0_desc);
    var tmp8_cached = Companion_getInstance_390().ss8_1;
    if (tmp7_input.v5c()) {
      tmp4_local0 = tmp7_input.s5c(tmp0_desc, 0, $serializer_getInstance_36(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.l5c(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.s5c(tmp0_desc, 2, tmp8_cached[2].a1(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.w5c(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.s5c(tmp0_desc, 0, $serializer_getInstance_36(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.l5c(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.s5c(tmp0_desc, 2, tmp8_cached[2].a1(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.h5c(tmp0_desc);
    return FindUsageDocumentInfo_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_40).v58 = function () {
    return this.ts8_1;
  };
  protoOf($serializer_40).f5k = function () {
    var tmp0_cached = Companion_getInstance_390().ss8_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_36(), IntSerializer_getInstance(), tmp0_cached[2].a1()];
  };
  var $serializer_instance_38;
  function $serializer_getInstance_38() {
    if ($serializer_instance_38 == null)
      new $serializer_40();
    return $serializer_instance_38;
  }
  function FindUsageDocumentInfo_init_$Init$(seen0, document, totalNodes, initial, serializationConstructorMarker, $this) {
    if (!(7 === (7 & seen0))) {
      throwMissingFieldException(seen0, 7, $serializer_getInstance_38().ts8_1);
    }
    $this.document = document;
    $this.totalNodes = totalNodes;
    $this.initial = initial;
    return $this;
  }
  function FindUsageDocumentInfo_init_$Create$(seen0, document, totalNodes, initial, serializationConstructorMarker) {
    return FindUsageDocumentInfo_init_$Init$(seen0, document, totalNodes, initial, serializationConstructorMarker, objectCreate(protoOf(FindUsageDocumentInfo)));
  }
  function FindUsageDocumentInfo(document, totalNodes, initial) {
    Companion_getInstance_390();
    this.document = document;
    this.totalNodes = totalNodes;
    this.initial = initial;
  }
  protoOf(FindUsageDocumentInfo).k8f = function () {
    return this.document;
  };
  protoOf(FindUsageDocumentInfo).vs8 = function () {
    return this.totalNodes;
  };
  protoOf(FindUsageDocumentInfo).ws8 = function () {
    return this.initial;
  };
  protoOf(FindUsageDocumentInfo).fg = function () {
    return this.document;
  };
  protoOf(FindUsageDocumentInfo).gg = function () {
    return this.totalNodes;
  };
  protoOf(FindUsageDocumentInfo).zl = function () {
    return this.initial;
  };
  protoOf(FindUsageDocumentInfo).xs8 = function (document, totalNodes, initial) {
    return new FindUsageDocumentInfo(document, totalNodes, initial);
  };
  protoOf(FindUsageDocumentInfo).copy = function (document, totalNodes, initial, $super) {
    document = document === VOID ? this.document : document;
    totalNodes = totalNodes === VOID ? this.totalNodes : totalNodes;
    initial = initial === VOID ? this.initial : initial;
    return $super === VOID ? this.xs8(document, totalNodes, initial) : $super.xs8.call(this, document, totalNodes, initial);
  };
  protoOf(FindUsageDocumentInfo).toString = function () {
    return 'FindUsageDocumentInfo(document=' + this.document.toString() + ', totalNodes=' + this.totalNodes + ', initial=' + this.initial.toString() + ')';
  };
  protoOf(FindUsageDocumentInfo).hashCode = function () {
    var result = this.document.hashCode();
    result = imul(result, 31) + this.totalNodes | 0;
    result = imul(result, 31) + this.initial.hashCode() | 0;
    return result;
  };
  protoOf(FindUsageDocumentInfo).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof FindUsageDocumentInfo))
      return false;
    if (!this.document.equals(other.document))
      return false;
    if (!(this.totalNodes === other.totalNodes))
      return false;
    if (!this.initial.equals(other.initial))
      return false;
    return true;
  };
  function FindUsagePageEntry(document, nodes) {
    this.document = document;
    this.nodes = nodes;
  }
  protoOf(FindUsagePageEntry).k8f = function () {
    return this.document;
  };
  protoOf(FindUsagePageEntry).f3o = function () {
    return this.nodes;
  };
  protoOf(FindUsagePageEntry).fg = function () {
    return this.document;
  };
  protoOf(FindUsagePageEntry).gg = function () {
    return this.nodes;
  };
  protoOf(FindUsagePageEntry).ys8 = function (document, nodes) {
    return new FindUsagePageEntry(document, nodes);
  };
  protoOf(FindUsagePageEntry).copy = function (document, nodes, $super) {
    document = document === VOID ? this.document : document;
    nodes = nodes === VOID ? this.nodes : nodes;
    return $super === VOID ? this.ys8(document, nodes) : $super.ys8.call(this, document, nodes);
  };
  protoOf(FindUsagePageEntry).toString = function () {
    return 'FindUsagePageEntry(document=' + this.document.toString() + ', nodes=' + toString_1(this.nodes) + ')';
  };
  protoOf(FindUsagePageEntry).hashCode = function () {
    var result = this.document.hashCode();
    result = imul(result, 31) + hashCode(this.nodes) | 0;
    return result;
  };
  protoOf(FindUsagePageEntry).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof FindUsagePageEntry))
      return false;
    if (!this.document.equals(other.document))
      return false;
    if (!equals(this.nodes, other.nodes))
      return false;
    return true;
  };
  function FindUsageRequestController() {
  }
  function Companion_391() {
  }
  protoOf(Companion_391).i63 = function () {
    return $serializer_getInstance_39();
  };
  var Companion_instance_391;
  function Companion_getInstance_391() {
    return Companion_instance_391;
  }
  function $serializer_41() {
    $serializer_instance_39 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('jetbrains.biokb.editor.service.findUsages.FindUsageResultTotals', this, 2);
    tmp0_serialDesc.q5j('totalDocs', false);
    tmp0_serialDesc.q5j('totalNodes', false);
    this.cs9_1 = tmp0_serialDesc;
  }
  protoOf($serializer_41).ds9 = function (encoder, value) {
    var tmp0_desc = this.cs9_1;
    var tmp1_output = encoder.g5c(tmp0_desc);
    tmp1_output.p5d(tmp0_desc, 0, value.es9_1);
    tmp1_output.p5d(tmp0_desc, 1, value.fs9_1);
    tmp1_output.h5c(tmp0_desc);
  };
  protoOf($serializer_41).i59 = function (encoder, value) {
    return this.ds9(encoder, value instanceof FindUsageResultTotals ? value : THROW_CCE());
  };
  protoOf($serializer_41).j59 = function (decoder) {
    var tmp0_desc = this.cs9_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_local1 = 0;
    var tmp6_input = decoder.g5c(tmp0_desc);
    if (tmp6_input.v5c()) {
      tmp4_local0 = tmp6_input.l5c(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.l5c(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.w5c(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.l5c(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.l5c(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.h5c(tmp0_desc);
    return FindUsageResultTotals_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_41).v58 = function () {
    return this.cs9_1;
  };
  protoOf($serializer_41).f5k = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance(), IntSerializer_getInstance()];
  };
  var $serializer_instance_39;
  function $serializer_getInstance_39() {
    if ($serializer_instance_39 == null)
      new $serializer_41();
    return $serializer_instance_39;
  }
  function FindUsageResultTotals_init_$Init$(seen0, totalDocs, totalNodes, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_39().cs9_1);
    }
    $this.es9_1 = totalDocs;
    $this.fs9_1 = totalNodes;
    return $this;
  }
  function FindUsageResultTotals_init_$Create$(seen0, totalDocs, totalNodes, serializationConstructorMarker) {
    return FindUsageResultTotals_init_$Init$(seen0, totalDocs, totalNodes, serializationConstructorMarker, objectCreate(protoOf(FindUsageResultTotals)));
  }
  function FindUsageResultTotals() {
  }
  protoOf(FindUsageResultTotals).toString = function () {
    return 'FindUsageResultTotals(totalDocs=' + this.es9_1 + ', totalNodes=' + this.fs9_1 + ')';
  };
  protoOf(FindUsageResultTotals).hashCode = function () {
    var result = this.es9_1;
    result = imul(result, 31) + this.fs9_1 | 0;
    return result;
  };
  protoOf(FindUsageResultTotals).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof FindUsageResultTotals))
      return false;
    if (!(this.es9_1 === other.es9_1))
      return false;
    if (!(this.fs9_1 === other.fs9_1))
      return false;
    return true;
  };
  function FindUsageResultsPaged(totalNodes, delegate) {
    this.gs9_1 = delegate;
    this.totalNodes = totalNodes;
  }
  protoOf(FindUsageResultsPaged).vs8 = function () {
    return this.totalNodes;
  };
  protoOf(FindUsageResultsPaged).hs9 = function ($completion) {
    return this.gs9_1.hs9($completion);
  };
  protoOf(FindUsageResultsPaged).z2h = function () {
    return this.gs9_1.z2h();
  };
  protoOf(FindUsageResultsPaged).is9 = function ($completion) {
    return this.gs9_1.is9($completion);
  };
  function createFindUsageResultsPaged(controller, $completion) {
    var tmp = new $createFindUsageResultsPagedCOROUTINE$(controller, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  }
  function findUsagePageEntry(controller, info) {
    var paged = createFindUsageNodesPaged(controller, info.document.accession, info.initial, info.totalNodes);
    return new FindUsagePageEntry(info.document, paged);
  }
  function createFindUsageNodesPaged(controller, accession, initial, totalNodes) {
    var tmp = Companion_instance_393;
    var tmp_0 = createFindUsageNodesPaged$slambda_0(totalNodes, null);
    return tmp.ss9(initial, tmp_0, createFindUsageNodesPaged$slambda_2(controller, accession, null));
  }
  function createFindUsageResultsPaged$slambda($controller, resultContinuation) {
    this.bsa_1 = $controller;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(createFindUsageResultsPaged$slambda).dsa = function ($this$async, $completion) {
    var tmp = this.f1h($this$async, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(createFindUsageResultsPaged$slambda).v9 = function (p1, $completion) {
    return this.dsa((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(createFindUsageResultsPaged$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.bsa_1.zs8(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(createFindUsageResultsPaged$slambda).f1h = function ($this$async, completion) {
    var i = new createFindUsageResultsPaged$slambda(this.bsa_1, completion);
    i.csa_1 = $this$async;
    return i;
  };
  function createFindUsageResultsPaged$slambda_0($controller, resultContinuation) {
    var i = new createFindUsageResultsPaged$slambda($controller, resultContinuation);
    var l = function ($this$async, $completion) {
      return i.dsa($this$async, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function createFindUsageResultsPaged$slambda_1($totals, resultContinuation) {
    this.msa_1 = $totals;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(createFindUsageResultsPaged$slambda_1).nsa = function ($completion) {
    var tmp = this.y9e($completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(createFindUsageResultsPaged$slambda_1).z9e = function ($completion) {
    return this.nsa($completion);
  };
  protoOf(createFindUsageResultsPaged$slambda_1).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.msa_1.nr(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult.fs9_1;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(createFindUsageResultsPaged$slambda_1).y9e = function (completion) {
    return new createFindUsageResultsPaged$slambda_1(this.msa_1, completion);
  };
  function createFindUsageResultsPaged$slambda_2($totals, resultContinuation) {
    var i = new createFindUsageResultsPaged$slambda_1($totals, resultContinuation);
    var l = function ($completion) {
      return i.nsa($completion);
    };
    l.$arity = 0;
    return l;
  }
  function createFindUsageResultsPaged$slambda_3($totals, resultContinuation) {
    this.wsa_1 = $totals;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(createFindUsageResultsPaged$slambda_3).nsa = function ($completion) {
    var tmp = this.y9e($completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(createFindUsageResultsPaged$slambda_3).z9e = function ($completion) {
    return this.nsa($completion);
  };
  protoOf(createFindUsageResultsPaged$slambda_3).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.wsa_1.nr(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult.es9_1;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(createFindUsageResultsPaged$slambda_3).y9e = function (completion) {
    return new createFindUsageResultsPaged$slambda_3(this.wsa_1, completion);
  };
  function createFindUsageResultsPaged$slambda_4($totals, resultContinuation) {
    var i = new createFindUsageResultsPaged$slambda_3($totals, resultContinuation);
    var l = function ($completion) {
      return i.nsa($completion);
    };
    l.$arity = 0;
    return l;
  }
  function createFindUsageResultsPaged$slambda_5($controller, resultContinuation) {
    this.fsb_1 = $controller;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(createFindUsageResultsPaged$slambda_5).gsb = function ($completion) {
    var tmp = this.y9e($completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(createFindUsageResultsPaged$slambda_5).z9e = function ($completion) {
    return this.gsb($completion);
  };
  protoOf(createFindUsageResultsPaged$slambda_5).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.fsb_1.as9(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(createFindUsageResultsPaged$slambda_5).y9e = function (completion) {
    return new createFindUsageResultsPaged$slambda_5(this.fsb_1, completion);
  };
  function createFindUsageResultsPaged$slambda_6($controller, resultContinuation) {
    var i = new createFindUsageResultsPaged$slambda_5($controller, resultContinuation);
    var l = function ($completion) {
      return i.gsb($completion);
    };
    l.$arity = 0;
    return l;
  }
  function createFindUsageResultsPaged$lambda($controller) {
    return function (it) {
      return findUsagePageEntry($controller, it);
    };
  }
  function createFindUsageNodesPaged$slambda($totalNodes, resultContinuation) {
    this.psb_1 = $totalNodes;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(createFindUsageNodesPaged$slambda).nsa = function ($completion) {
    var tmp = this.y9e($completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(createFindUsageNodesPaged$slambda).z9e = function ($completion) {
    return this.nsa($completion);
  };
  protoOf(createFindUsageNodesPaged$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        if (tmp === 0) {
          this.g9_1 = 1;
          return this.psb_1;
        } else if (tmp === 1) {
          throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(createFindUsageNodesPaged$slambda).y9e = function (completion) {
    return new createFindUsageNodesPaged$slambda(this.psb_1, completion);
  };
  function createFindUsageNodesPaged$slambda_0($totalNodes, resultContinuation) {
    var i = new createFindUsageNodesPaged$slambda($totalNodes, resultContinuation);
    var l = function ($completion) {
      return i.nsa($completion);
    };
    l.$arity = 0;
    return l;
  }
  function createFindUsageNodesPaged$slambda_1($controller, $accession, resultContinuation) {
    this.ysb_1 = $controller;
    this.zsb_1 = $accession;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(createFindUsageNodesPaged$slambda_1).asc = function ($completion) {
    var tmp = this.y9e($completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(createFindUsageNodesPaged$slambda_1).z9e = function ($completion) {
    return this.asc($completion);
  };
  protoOf(createFindUsageNodesPaged$slambda_1).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.ysb_1.bs9(this.zsb_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(createFindUsageNodesPaged$slambda_1).y9e = function (completion) {
    return new createFindUsageNodesPaged$slambda_1(this.ysb_1, this.zsb_1, completion);
  };
  function createFindUsageNodesPaged$slambda_2($controller, $accession, resultContinuation) {
    var i = new createFindUsageNodesPaged$slambda_1($controller, $accession, resultContinuation);
    var l = function ($completion) {
      return i.asc($completion);
    };
    l.$arity = 0;
    return l;
  }
  function $createFindUsageResultsPagedCOROUTINE$(controller, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.rs9_1 = controller;
  }
  protoOf($createFindUsageResultsPagedCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.rs9_1.as9(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var initial = suspendResult;
            var tmp_0 = CoroutineScope_0(Dispatchers_getInstance().uz_1);
            var tmp_1 = CoroutineStart_LAZY_getInstance();
            var totals = async(tmp_0, VOID, tmp_1, createFindUsageResultsPaged$slambda_0(this.rs9_1, null));
            var tmp_2 = createFindUsageResultsPaged$slambda_2(totals, null);
            var tmp_3 = Companion_instance_393;
            var tmp_4 = createFindUsageResultsPaged$slambda_4(totals, null);
            var tmp_5 = tmp_3.ss9(initial, tmp_4, createFindUsageResultsPaged$slambda_6(this.rs9_1, null));
            return new FindUsageResultsPaged(tmp_2, map_4(tmp_5, createFindUsageResultsPaged$lambda(this.rs9_1)));
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function $serializer_init_$Init$_1(typeSerial0, $this) {
    $serializer_42.call($this);
    $this.csc_1 = typeSerial0;
    return $this;
  }
  function $serializer_init_$Create$_1(typeSerial0) {
    return $serializer_init_$Init$_1(typeSerial0, objectCreate(protoOf($serializer_42)));
  }
  function Companion_392() {
    Companion_instance_392 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('jetbrains.biokb.editor.service.findUsages.Page', null, 2);
    tmp0_serialDesc.q5j('data', true);
    tmp0_serialDesc.q5j('hasNextPage', false);
    this.dsc_1 = tmp0_serialDesc;
  }
  protoOf(Companion_392).empty = function () {
    return new Page_2(VOID, false);
  };
  protoOf(Companion_392).bel = function (typeSerial0) {
    return $serializer_init_$Create$_1(typeSerial0);
  };
  protoOf(Companion_392).q5k = function (typeParamsSerializers) {
    return this.bel(typeParamsSerializers[0]);
  };
  protoOf(Companion_392).esc = function () {
    return this.dsc_1;
  };
  var Companion_instance_392;
  function Companion_getInstance_392() {
    if (Companion_instance_392 == null)
      new Companion_392();
    return Companion_instance_392;
  }
  function $serializer_42() {
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('jetbrains.biokb.editor.service.findUsages.Page', this, 2);
    tmp0_serialDesc.q5j('data', true);
    tmp0_serialDesc.q5j('hasNextPage', false);
    this.bsc_1 = tmp0_serialDesc;
  }
  protoOf($serializer_42).fsc = function (encoder, value) {
    var tmp0_desc = this.bsc_1;
    var tmp1_output = encoder.g5c(tmp0_desc);
    if (tmp1_output.b5e(tmp0_desc, 0) ? true : !equals(value.data, emptyList())) {
      tmp1_output.w5d(tmp0_desc, 0, new ArrayListSerializer(this.csc_1), value.data);
    }
    tmp1_output.m5d(tmp0_desc, 1, value.hasNextPage);
    tmp1_output.h5c(tmp0_desc);
  };
  protoOf($serializer_42).i59 = function (encoder, value) {
    return this.fsc(encoder, value instanceof Page_2 ? value : THROW_CCE());
  };
  protoOf($serializer_42).j59 = function (decoder) {
    var tmp0_desc = this.bsc_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = false;
    var tmp6_input = decoder.g5c(tmp0_desc);
    if (tmp6_input.v5c()) {
      tmp4_local0 = tmp6_input.s5c(tmp0_desc, 0, new ArrayListSerializer(this.csc_1), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.i5c(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.w5c(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.s5c(tmp0_desc, 0, new ArrayListSerializer(this.csc_1), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.i5c(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.h5c(tmp0_desc);
    return Page_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_42).v58 = function () {
    return this.bsc_1;
  };
  protoOf($serializer_42).f5k = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [new ArrayListSerializer(this.csc_1), BooleanSerializer_getInstance()];
  };
  protoOf($serializer_42).g5k = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [this.csc_1];
  };
  function Page_init_$Init$(seen0, data, hasNextPage, serializationConstructorMarker, $this) {
    if (!(2 === (2 & seen0))) {
      throwMissingFieldException(seen0, 2, Companion_getInstance_392().dsc_1);
    }
    if (0 === (seen0 & 1))
      $this.data = emptyList();
    else
      $this.data = data;
    $this.hasNextPage = hasNextPage;
    return $this;
  }
  function Page_init_$Create$(seen0, data, hasNextPage, serializationConstructorMarker) {
    return Page_init_$Init$(seen0, data, hasNextPage, serializationConstructorMarker, objectCreate(protoOf(Page_2)));
  }
  function Page_2(data, hasNextPage) {
    Companion_getInstance_392();
    data = data === VOID ? emptyList() : data;
    this.data = data;
    this.hasNextPage = hasNextPage;
  }
  protoOf(Page_2).lfs = function () {
    return this.data;
  };
  protoOf(Page_2).gsc = function () {
    return this.hasNextPage;
  };
  protoOf(Page_2).fg = function () {
    return this.data;
  };
  protoOf(Page_2).gg = function () {
    return this.hasNextPage;
  };
  protoOf(Page_2).hsc = function (data, hasNextPage) {
    return new Page_2(data, hasNextPage);
  };
  protoOf(Page_2).copy = function (data, hasNextPage, $super) {
    data = data === VOID ? this.data : data;
    hasNextPage = hasNextPage === VOID ? this.hasNextPage : hasNextPage;
    return $super === VOID ? this.hsc(data, hasNextPage) : $super.hsc.call(this, data, hasNextPage);
  };
  protoOf(Page_2).toString = function () {
    return 'Page(data=' + toString_1(this.data) + ', hasNextPage=' + this.hasNextPage + ')';
  };
  protoOf(Page_2).hashCode = function () {
    var result = hashCode(this.data);
    result = imul(result, 31) + getBooleanHashCode(this.hasNextPage) | 0;
    return result;
  };
  protoOf(Page_2).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Page_2))
      return false;
    if (!equals(this.data, other.data))
      return false;
    if (!(this.hasNextPage === other.hasNextPage))
      return false;
    return true;
  };
  function $toNextPageCOROUTINE$(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.qsc_1 = _this__u8e3s4;
  }
  protoOf($toNextPageCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            if (!this.qsc_1.rsc_1.hasNextPage) {
              var message = 'This paged has no next page';
              throw IllegalStateException_init_$Create$_0(toString_1(message));
            }

            this.f9_1 = 1;
            suspendResult = this.qsc_1.tsc_1(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            this.qsc_1.rsc_1 = ARGUMENT;
            return Unit_instance;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function Paged$Companion$invoke$1($initial, $total, $next) {
    this.ssc_1 = $total;
    this.tsc_1 = $next;
    this.rsc_1 = $initial;
  }
  protoOf(Paged$Companion$invoke$1).hs9 = function ($completion) {
    return this.ssc_1($completion);
  };
  protoOf(Paged$Companion$invoke$1).z2h = function () {
    return this.rsc_1;
  };
  protoOf(Paged$Companion$invoke$1).is9 = function ($completion) {
    var tmp = new $toNextPageCOROUTINE$(this, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  function Companion_393() {
  }
  protoOf(Companion_393).ss9 = function (initial, total, next) {
    return new Paged$Companion$invoke$1(initial, total, next);
  };
  var Companion_instance_393;
  function Companion_getInstance_393() {
    return Companion_instance_393;
  }
  function map_4(_this__u8e3s4, func) {
    var tmp = Companion_instance_393;
    // Inline function 'jetbrains.biokb.editor.service.findUsages.map' call
    var this_0 = _this__u8e3s4.z2h();
    // Inline function 'kotlin.collections.map' call
    var this_1 = this_0.data;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_1, 10));
    var _iterator__ex2g4s = this_1.m();
    while (_iterator__ex2g4s.n()) {
      var item = _iterator__ex2g4s.o();
      destination.j(func(item));
    }
    var tmp_0 = new Page_2(destination, this_0.hasNextPage);
    var tmp_1 = Paged$total$ref_0(_this__u8e3s4);
    return tmp.ss9(tmp_0, tmp_1, map$slambda_0(_this__u8e3s4, func, null));
  }
  function nextPage(_this__u8e3s4, $completion) {
    var tmp = new $nextPageCOROUTINE$(_this__u8e3s4, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  }
  function Paged$total$ref(p0) {
    this.dsd_1 = p0;
  }
  protoOf(Paged$total$ref).nsa = function ($completion) {
    return this.dsd_1.hs9($completion);
  };
  protoOf(Paged$total$ref).z9e = function ($completion) {
    return this.nsa($completion);
  };
  function Paged$total$ref_0(p0) {
    var i = new Paged$total$ref(p0);
    var l = function ($completion) {
      return i.nsa($completion);
    };
    l.callableName = 'total';
    l.$arity = 0;
    return l;
  }
  function map$slambda($this_map, $func, resultContinuation) {
    this.msd_1 = $this_map;
    this.nsd_1 = $func;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(map$slambda).osd = function ($completion) {
    var tmp = this.y9e($completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(map$slambda).z9e = function ($completion) {
    return this.osd($completion);
  };
  protoOf(map$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = nextPage(this.msd_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp0 = suspendResult;
            var func = this.nsd_1;
            var this_0 = tmp0.data;
            var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
            var _iterator__ex2g4s = this_0.m();
            while (_iterator__ex2g4s.n()) {
              var item = _iterator__ex2g4s.o();
              destination.j(func(item));
            }

            return new Page_2(destination, tmp0.hasNextPage);
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(map$slambda).y9e = function (completion) {
    return new map$slambda(this.msd_1, this.nsd_1, completion);
  };
  function map$slambda_0($this_map, $func, resultContinuation) {
    var i = new map$slambda($this_map, $func, resultContinuation);
    var l = function ($completion) {
      return i.osd($completion);
    };
    l.$arity = 0;
    return l;
  }
  function $nextPageCOROUTINE$(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.csd_1 = _this__u8e3s4;
  }
  protoOf($nextPageCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.csd_1.is9(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return this.csd_1.z2h();
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function PublishedFindUsageRequestControllerSerializer() {
    PublishedFindUsageRequestControllerSerializer_instance = this;
    InstancePublicationSerializer.call(this, Companion_getInstance_394());
  }
  var PublishedFindUsageRequestControllerSerializer_instance;
  function PublishedFindUsageRequestControllerSerializer_getInstance() {
    if (PublishedFindUsageRequestControllerSerializer_instance == null)
      new PublishedFindUsageRequestControllerSerializer();
    return PublishedFindUsageRequestControllerSerializer_instance;
  }
  function RemoteFindUsageRequestController$Companion$nextDocuments$slambda(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(RemoteFindUsageRequestController$Companion$nextDocuments$slambda).zsd = function (controller, _unused_var__etf5q3, $completion) {
    var tmp = this.ase(controller, _unused_var__etf5q3, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(RemoteFindUsageRequestController$Companion$nextDocuments$slambda).w9 = function (p1, p2, $completion) {
    var tmp = (!(p1 == null) ? isInterface(p1, FindUsageRequestController) : false) ? p1 : THROW_CCE();
    return this.zsd(tmp, p2 instanceof Unit ? p2 : THROW_CCE(), $completion);
  };
  protoOf(RemoteFindUsageRequestController$Companion$nextDocuments$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.xsd_1.as9(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(RemoteFindUsageRequestController$Companion$nextDocuments$slambda).ase = function (controller, _unused_var__etf5q3, completion) {
    var i = new RemoteFindUsageRequestController$Companion$nextDocuments$slambda(completion);
    i.xsd_1 = controller;
    i.ysd_1 = _unused_var__etf5q3;
    return i;
  };
  function RemoteFindUsageRequestController$Companion$nextDocuments$slambda_0(resultContinuation) {
    var i = new RemoteFindUsageRequestController$Companion$nextDocuments$slambda(resultContinuation);
    var l = function (controller, _unused_var__etf5q3, $completion) {
      return i.zsd(controller, _unused_var__etf5q3, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function RemoteFindUsageRequestController$Companion$nextNodeEntries$slambda(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(RemoteFindUsageRequestController$Companion$nextNodeEntries$slambda).lse = function (controller, acc, $completion) {
    var tmp = this.mse(controller, acc, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(RemoteFindUsageRequestController$Companion$nextNodeEntries$slambda).w9 = function (p1, p2, $completion) {
    var tmp = (!(p1 == null) ? isInterface(p1, FindUsageRequestController) : false) ? p1 : THROW_CCE();
    return this.lse(tmp, p2 instanceof AccessionDto ? p2 : THROW_CCE(), $completion);
  };
  protoOf(RemoteFindUsageRequestController$Companion$nextNodeEntries$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.jse_1.bs9(this.kse_1.nse_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(RemoteFindUsageRequestController$Companion$nextNodeEntries$slambda).mse = function (controller, acc, completion) {
    var i = new RemoteFindUsageRequestController$Companion$nextNodeEntries$slambda(completion);
    i.jse_1 = controller;
    i.kse_1 = acc;
    return i;
  };
  function RemoteFindUsageRequestController$Companion$nextNodeEntries$slambda_0(resultContinuation) {
    var i = new RemoteFindUsageRequestController$Companion$nextNodeEntries$slambda(resultContinuation);
    var l = function (controller, acc, $completion) {
      return i.lse(controller, acc, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function RemoteFindUsageRequestController$Companion$totals$slambda(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(RemoteFindUsageRequestController$Companion$totals$slambda).yse = function (controller, _unused_var__etf5q3, $completion) {
    var tmp = this.ase(controller, _unused_var__etf5q3, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(RemoteFindUsageRequestController$Companion$totals$slambda).w9 = function (p1, p2, $completion) {
    var tmp = (!(p1 == null) ? isInterface(p1, FindUsageRequestController) : false) ? p1 : THROW_CCE();
    return this.yse(tmp, p2 instanceof Unit ? p2 : THROW_CCE(), $completion);
  };
  protoOf(RemoteFindUsageRequestController$Companion$totals$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.wse_1.zs8(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(RemoteFindUsageRequestController$Companion$totals$slambda).ase = function (controller, _unused_var__etf5q3, completion) {
    var i = new RemoteFindUsageRequestController$Companion$totals$slambda(completion);
    i.wse_1 = controller;
    i.xse_1 = _unused_var__etf5q3;
    return i;
  };
  function RemoteFindUsageRequestController$Companion$totals$slambda_0(resultContinuation) {
    var i = new RemoteFindUsageRequestController$Companion$totals$slambda(resultContinuation);
    var l = function (controller, _unused_var__etf5q3, $completion) {
      return i.yse(controller, _unused_var__etf5q3, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function Companion_394() {
    Companion_instance_394 = this;
    InstanceDescriptor.call(this);
    this.asf_1 = Companion_getInstance_392().bel(Companion_getInstance_390().i63());
    this.bsf_1 = Companion_getInstance_392().bel(Companion_instance_371.i63());
    var tmp = this;
    var tmp_0 = serializer_3(Unit_instance);
    tmp.csf_1 = method(this, 'nextDocuments', tmp_0, this.asf_1, RemoteFindUsageRequestController$Companion$nextDocuments$slambda_0(null));
    var tmp_1 = this;
    var tmp_2 = Companion_instance_396.i63();
    tmp_1.dsf_1 = method(this, 'nextNodeEntries', tmp_2, this.bsf_1, RemoteFindUsageRequestController$Companion$nextNodeEntries$slambda_0(null));
    var tmp_3 = this;
    var tmp_4 = serializer_3(Unit_instance);
    var tmp_5 = Companion_instance_391.i63();
    tmp_3.esf_1 = method(this, 'totals', tmp_4, tmp_5, RemoteFindUsageRequestController$Companion$totals$slambda_0(null));
  }
  protoOf(Companion_394).fsf = function (endpoint) {
    return new RemoteFindUsageRequestController(endpoint);
  };
  protoOf(Companion_394).kef = function (endpoint) {
    return this.fsf(endpoint);
  };
  var Companion_instance_394;
  function Companion_getInstance_394() {
    if (Companion_instance_394 == null)
      new Companion_394();
    return Companion_instance_394;
  }
  function RemoteFindUsageRequestController(endpoint) {
    Companion_getInstance_394();
    this.gsf_1 = endpoint;
  }
  protoOf(RemoteFindUsageRequestController).zs8 = function ($completion) {
    return Companion_getInstance_394().esf_1.oeg(this.gsf_1, Unit_instance, $completion);
  };
  protoOf(RemoteFindUsageRequestController).as9 = function ($completion) {
    return Companion_getInstance_394().csf_1.oeg(this.gsf_1, Unit_instance, $completion);
  };
  protoOf(RemoteFindUsageRequestController).bs9 = function (accession, $completion) {
    return Companion_getInstance_394().dsf_1.oeg(this.gsf_1, new AccessionDto(accession), $completion);
  };
  protoOf(RemoteFindUsageRequestController).zr = function () {
    this.gsf_1.zr();
  };
  function PerformanceMonitoringClient$job$slambda(this$0, resultContinuation) {
    this.psf_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(PerformanceMonitoringClient$job$slambda).e1h = function ($this$launch, $completion) {
    var tmp = this.f1h($this$launch, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(PerformanceMonitoringClient$job$slambda).v9 = function (p1, $completion) {
    return this.e1h((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(PerformanceMonitoringClient$job$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 9;
            this.f9_1 = 1;
            continue $sm;
          case 1:
            this.g9_1 = 8;
            this.ssf_1 = this.psf_1.usf_1.m();
            this.f9_1 = 2;
            continue $sm;
          case 2:
            this.f9_1 = 3;
            suspendResult = this.ssf_1.d14(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            if (!suspendResult) {
              this.f9_1 = 6;
              continue $sm;
            }

            var metric = this.ssf_1.o();
            this.rsf_1 = arrayListOf([metric]);
            this.f9_1 = 4;
            Companion_getInstance_16();
            suspendResult = delay(toDuration_0(1, DurationUnit_SECONDS_getInstance()), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            var additionalMetric = ChannelResult__getOrNull_impl_f5e07h(this.psf_1.usf_1.e16());
            while (!(additionalMetric == null)) {
              var tmp0 = this.rsf_1;
              var element = additionalMetric;
              tmp0.j(element);
              additionalMetric = ChannelResult__getOrNull_impl_f5e07h(this.psf_1.usf_1.e16());
            }

            this.f9_1 = 5;
            suspendResult = this.psf_1.tsf_1(this.rsf_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 5:
            this.f9_1 = 2;
            continue $sm;
          case 6:
            this.g9_1 = 9;
            this.f9_1 = 7;
            continue $sm;
          case 7:
            this.g9_1 = 9;
            this.psf_1.usf_1.i16();
            return Unit_instance;
          case 8:
            this.g9_1 = 9;
            var t = this.i9_1;
            this.psf_1.usf_1.i16();
            throw t;
          case 9:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 9) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(PerformanceMonitoringClient$job$slambda).f1h = function ($this$launch, completion) {
    var i = new PerformanceMonitoringClient$job$slambda(this.psf_1, completion);
    i.qsf_1 = $this$launch;
    return i;
  };
  function PerformanceMonitoringClient$job$slambda_0(this$0, resultContinuation) {
    var i = new PerformanceMonitoringClient$job$slambda(this$0, resultContinuation);
    var l = function ($this$launch, $completion) {
      return i.e1h($this$launch, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function PerformanceMonitoringClient(coroutineScope, metricsConsumer) {
    this.tsf_1 = metricsConsumer;
    this.usf_1 = Channel(2147483647);
    var tmp = this;
    tmp.vsf_1 = launch(coroutineScope, VOID, VOID, PerformanceMonitoringClient$job$slambda_0(this, null));
  }
  protoOf(PerformanceMonitoringClient).wsf = function (metric) {
    // Inline function 'kotlin.check' call
    if (!_ChannelResult___get_isSuccess__impl__odq1z9(this.usf_1.a16(metric))) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
  };
  var MetricKind_OpenEditor_instance;
  var MetricKind_Resolve_instance;
  var MetricKind_Find_instance;
  var MetricKind_Presentation_instance;
  function values_19() {
    return [MetricKind_OpenEditor_getInstance(), MetricKind_Resolve_getInstance(), MetricKind_Find_getInstance(), MetricKind_Presentation_getInstance()];
  }
  var MetricKind_entriesInitialized;
  function MetricKind_initEntries() {
    if (MetricKind_entriesInitialized)
      return Unit_instance;
    MetricKind_entriesInitialized = true;
    MetricKind_OpenEditor_instance = new MetricKind('OpenEditor', 0);
    MetricKind_Resolve_instance = new MetricKind('Resolve', 1);
    MetricKind_Find_instance = new MetricKind('Find', 2);
    MetricKind_Presentation_instance = new MetricKind('Presentation', 3);
  }
  function PerformanceMonitoringMetric$Companion$$childSerializers$_anonymous__pzjgua() {
    return new EnumSerializer('jetbrains.biokb.editor.service.performance.PerformanceMonitoringMetric.MetricKind', values_19());
  }
  function MetricKind(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function Companion_395() {
    Companion_instance_395 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.xsf_1 = [null, lazy_0(tmp_0, PerformanceMonitoringMetric$Companion$$childSerializers$_anonymous__pzjgua)];
  }
  var Companion_instance_395;
  function Companion_getInstance_395() {
    if (Companion_instance_395 == null)
      new Companion_395();
    return Companion_instance_395;
  }
  function $serializer_43() {
    $serializer_instance_40 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('jetbrains.biokb.editor.service.performance.PerformanceMonitoringMetric', this, 2);
    tmp0_serialDesc.q5j('durationInMs', false);
    tmp0_serialDesc.q5j('kind', false);
    this.ysf_1 = tmp0_serialDesc;
  }
  protoOf($serializer_43).zsf = function (encoder, value) {
    var tmp0_desc = this.ysf_1;
    var tmp1_output = encoder.g5c(tmp0_desc);
    var tmp2_cached = Companion_getInstance_395().xsf_1;
    tmp1_output.q5d(tmp0_desc, 0, value.asg_1);
    tmp1_output.w5d(tmp0_desc, 1, tmp2_cached[1].a1(), value.bsg_1);
    tmp1_output.h5c(tmp0_desc);
  };
  protoOf($serializer_43).i59 = function (encoder, value) {
    return this.zsf(encoder, value instanceof PerformanceMonitoringMetric ? value : THROW_CCE());
  };
  protoOf($serializer_43).j59 = function (decoder) {
    var tmp0_desc = this.ysf_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0n;
    var tmp5_local1 = null;
    var tmp6_input = decoder.g5c(tmp0_desc);
    var tmp7_cached = Companion_getInstance_395().xsf_1;
    if (tmp6_input.v5c()) {
      tmp4_local0 = tmp6_input.m5c(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.s5c(tmp0_desc, 1, tmp7_cached[1].a1(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.w5c(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.m5c(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.s5c(tmp0_desc, 1, tmp7_cached[1].a1(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.h5c(tmp0_desc);
    return PerformanceMonitoringMetric_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_43).v58 = function () {
    return this.ysf_1;
  };
  protoOf($serializer_43).f5k = function () {
    var tmp0_cached = Companion_getInstance_395().xsf_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [LongSerializer_getInstance(), tmp0_cached[1].a1()];
  };
  var $serializer_instance_40;
  function $serializer_getInstance_40() {
    if ($serializer_instance_40 == null)
      new $serializer_43();
    return $serializer_instance_40;
  }
  function PerformanceMonitoringMetric_init_$Init$(seen0, durationInMs, kind, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_40().ysf_1);
    }
    $this.asg_1 = durationInMs;
    $this.bsg_1 = kind;
    return $this;
  }
  function PerformanceMonitoringMetric_init_$Create$(seen0, durationInMs, kind, serializationConstructorMarker) {
    return PerformanceMonitoringMetric_init_$Init$(seen0, durationInMs, kind, serializationConstructorMarker, objectCreate(protoOf(PerformanceMonitoringMetric)));
  }
  function MetricKind_OpenEditor_getInstance() {
    MetricKind_initEntries();
    return MetricKind_OpenEditor_instance;
  }
  function MetricKind_Resolve_getInstance() {
    MetricKind_initEntries();
    return MetricKind_Resolve_instance;
  }
  function MetricKind_Find_getInstance() {
    MetricKind_initEntries();
    return MetricKind_Find_instance;
  }
  function MetricKind_Presentation_getInstance() {
    MetricKind_initEntries();
    return MetricKind_Presentation_instance;
  }
  function PerformanceMonitoringMetric(durationInMs, kind) {
    Companion_getInstance_395();
    this.asg_1 = durationInMs;
    this.bsg_1 = kind;
  }
  function Companion_396() {
  }
  protoOf(Companion_396).i63 = function () {
    return $serializer_getInstance_41();
  };
  var Companion_instance_396;
  function Companion_getInstance_396() {
    return Companion_instance_396;
  }
  function $serializer_44() {
    $serializer_instance_41 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('jetbrains.biokb.editor.service.rpc.AccessionDto', this, 1);
    tmp0_serialDesc.q5j('accession', false);
    this.csg_1 = tmp0_serialDesc;
  }
  protoOf($serializer_44).dsg = function (encoder, value) {
    var tmp0_desc = this.csg_1;
    var tmp1_output = encoder.g5c(tmp0_desc);
    tmp1_output.u5d(tmp0_desc, 0, value.nse_1);
    tmp1_output.h5c(tmp0_desc);
  };
  protoOf($serializer_44).i59 = function (encoder, value) {
    return this.dsg(encoder, value instanceof AccessionDto ? value : THROW_CCE());
  };
  protoOf($serializer_44).j59 = function (decoder) {
    var tmp0_desc = this.csg_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.g5c(tmp0_desc);
    if (tmp5_input.v5c()) {
      tmp4_local0 = tmp5_input.q5c(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.w5c(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.q5c(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.h5c(tmp0_desc);
    return AccessionDto_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_44).v58 = function () {
    return this.csg_1;
  };
  protoOf($serializer_44).f5k = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance()];
  };
  var $serializer_instance_41;
  function $serializer_getInstance_41() {
    if ($serializer_instance_41 == null)
      new $serializer_44();
    return $serializer_instance_41;
  }
  function AccessionDto_init_$Init$(seen0, accession, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_41().csg_1);
    }
    $this.nse_1 = accession;
    return $this;
  }
  function AccessionDto_init_$Create$(seen0, accession, serializationConstructorMarker) {
    return AccessionDto_init_$Init$(seen0, accession, serializationConstructorMarker, objectCreate(protoOf(AccessionDto)));
  }
  function AccessionDto(accession) {
    this.nse_1 = accession;
  }
  protoOf(AccessionDto).fg = function () {
    return this.nse_1;
  };
  protoOf(AccessionDto).toString = function () {
    return 'AccessionDto(accession=' + this.nse_1 + ')';
  };
  protoOf(AccessionDto).hashCode = function () {
    return getStringHashCode(this.nse_1);
  };
  protoOf(AccessionDto).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof AccessionDto))
      return false;
    if (!(this.nse_1 === other.nse_1))
      return false;
    return true;
  };
  function Companion_397() {
  }
  protoOf(Companion_397).i63 = function () {
    return $serializer_getInstance_42();
  };
  var Companion_instance_397;
  function Companion_getInstance_397() {
    return Companion_instance_397;
  }
  function $serializer_45() {
    $serializer_instance_42 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('jetbrains.biokb.editor.service.rpc.DraftQueryCoordinates', this, 2);
    tmp0_serialDesc.q5j('accession', false);
    tmp0_serialDesc.q5j('globalVersion', false);
    this.esg_1 = tmp0_serialDesc;
  }
  protoOf($serializer_45).fsg = function (encoder, value) {
    var tmp0_desc = this.esg_1;
    var tmp1_output = encoder.g5c(tmp0_desc);
    tmp1_output.u5d(tmp0_desc, 0, value.gsg_1);
    tmp1_output.q5d(tmp0_desc, 1, value.hsg_1);
    tmp1_output.h5c(tmp0_desc);
  };
  protoOf($serializer_45).i59 = function (encoder, value) {
    return this.fsg(encoder, value instanceof DraftQueryCoordinates ? value : THROW_CCE());
  };
  protoOf($serializer_45).j59 = function (decoder) {
    var tmp0_desc = this.esg_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = 0n;
    var tmp6_input = decoder.g5c(tmp0_desc);
    if (tmp6_input.v5c()) {
      tmp4_local0 = tmp6_input.q5c(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.m5c(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.w5c(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.q5c(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.m5c(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.h5c(tmp0_desc);
    return DraftQueryCoordinates_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_45).v58 = function () {
    return this.esg_1;
  };
  protoOf($serializer_45).f5k = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), LongSerializer_getInstance()];
  };
  var $serializer_instance_42;
  function $serializer_getInstance_42() {
    if ($serializer_instance_42 == null)
      new $serializer_45();
    return $serializer_instance_42;
  }
  function DraftQueryCoordinates_init_$Init$(seen0, accession, globalVersion, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_42().esg_1);
    }
    $this.gsg_1 = accession;
    $this.hsg_1 = globalVersion;
    return $this;
  }
  function DraftQueryCoordinates_init_$Create$(seen0, accession, globalVersion, serializationConstructorMarker) {
    return DraftQueryCoordinates_init_$Init$(seen0, accession, globalVersion, serializationConstructorMarker, objectCreate(protoOf(DraftQueryCoordinates)));
  }
  function DraftQueryCoordinates(accession, globalVersion) {
    this.gsg_1 = accession;
    this.hsg_1 = globalVersion;
  }
  protoOf(DraftQueryCoordinates).fg = function () {
    return this.gsg_1;
  };
  protoOf(DraftQueryCoordinates).gg = function () {
    return this.hsg_1;
  };
  protoOf(DraftQueryCoordinates).toString = function () {
    return 'DraftQueryCoordinates(accession=' + this.gsg_1 + ', globalVersion=' + this.hsg_1.toString() + ')';
  };
  protoOf(DraftQueryCoordinates).hashCode = function () {
    var result = getStringHashCode(this.gsg_1);
    result = imul(result, 31) + getBigIntHashCode(this.hsg_1) | 0;
    return result;
  };
  protoOf(DraftQueryCoordinates).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof DraftQueryCoordinates))
      return false;
    if (!(this.gsg_1 === other.gsg_1))
      return false;
    if (!(this.hsg_1 === other.hsg_1))
      return false;
    return true;
  };
  function EditorService$Companion$openDocument$slambda(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(EditorService$Companion$openDocument$slambda).ssg = function (instance, _destruct__k2r9zo, $completion) {
    var tmp = this.tsg(instance, _destruct__k2r9zo, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(EditorService$Companion$openDocument$slambda).w9 = function (p1, p2, $completion) {
    var tmp = (!(p1 == null) ? isInterface(p1, EditorService) : false) ? p1 : THROW_CCE();
    return this.ssg(tmp, p2 instanceof AccessionDto ? p2 : THROW_CCE(), $completion);
  };
  protoOf(EditorService$Companion$openDocument$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            var accession = this.rsg_1.fg();
            this.f9_1 = 1;
            suspendResult = this.qsg_1.usg(accession, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(EditorService$Companion$openDocument$slambda).tsg = function (instance, _destruct__k2r9zo, completion) {
    var i = new EditorService$Companion$openDocument$slambda(completion);
    i.qsg_1 = instance;
    i.rsg_1 = _destruct__k2r9zo;
    return i;
  };
  function EditorService$Companion$openDocument$slambda_0(resultContinuation) {
    var i = new EditorService$Companion$openDocument$slambda(resultContinuation);
    var l = function (instance, _destruct__k2r9zo, $completion) {
      return i.ssg(instance, _destruct__k2r9zo, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function EditorService$Companion$getInheritedPropertiesFlow$lambda(instance, _destruct__k2r9zo) {
    var accession = _destruct__k2r9zo.fg();
    return instance.vsg(accession);
  }
  function EditorService$Companion$findUsages$slambda(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(EditorService$Companion$findUsages$slambda).gsh = function (instance, request, $completion) {
    var tmp = this.hsh(instance, request, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(EditorService$Companion$findUsages$slambda).w9 = function (p1, p2, $completion) {
    var tmp = (!(p1 == null) ? isInterface(p1, EditorService) : false) ? p1 : THROW_CCE();
    return this.gsh(tmp, p2 instanceof FindUsageServiceRequest ? p2 : THROW_CCE(), $completion);
  };
  protoOf(EditorService$Companion$findUsages$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.esh_1.ish(this.fsh_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(EditorService$Companion$findUsages$slambda).hsh = function (instance, request, completion) {
    var i = new EditorService$Companion$findUsages$slambda(completion);
    i.esh_1 = instance;
    i.fsh_1 = request;
    return i;
  };
  function EditorService$Companion$findUsages$slambda_0(resultContinuation) {
    var i = new EditorService$Companion$findUsages$slambda(resultContinuation);
    var l = function (instance, request, $completion) {
      return i.gsh(instance, request, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function EditorService$Companion$openDraftQuery$slambda(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(EditorService$Companion$openDraftQuery$slambda).tsh = function (instance, _destruct__k2r9zo, $completion) {
    var tmp = this.ush(instance, _destruct__k2r9zo, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(EditorService$Companion$openDraftQuery$slambda).w9 = function (p1, p2, $completion) {
    var tmp = (!(p1 == null) ? isInterface(p1, EditorService) : false) ? p1 : THROW_CCE();
    return this.tsh(tmp, p2 instanceof DraftQueryCoordinates ? p2 : THROW_CCE(), $completion);
  };
  protoOf(EditorService$Companion$openDraftQuery$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            var accession = this.ssh_1.fg();
            var globalVersion = this.ssh_1.gg();
            this.f9_1 = 1;
            suspendResult = this.rsh_1.vsh(accession, globalVersion, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(EditorService$Companion$openDraftQuery$slambda).ush = function (instance, _destruct__k2r9zo, completion) {
    var i = new EditorService$Companion$openDraftQuery$slambda(completion);
    i.rsh_1 = instance;
    i.ssh_1 = _destruct__k2r9zo;
    return i;
  };
  function EditorService$Companion$openDraftQuery$slambda_0(resultContinuation) {
    var i = new EditorService$Companion$openDraftQuery$slambda(resultContinuation);
    var l = function (instance, _destruct__k2r9zo, $completion) {
      return i.tsh(instance, _destruct__k2r9zo, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function Remote_0(endpoint) {
    this.wsh_1 = CoroutineScope_0(endpoint.mef().gw());
    this.xsh_1 = endpoint;
  }
  protoOf(Remote_0).usg = function (accession, $completion) {
    return Companion_getInstance_398().zsh_1.oeg(this.xsh_1, new AccessionDto(accession), $completion);
  };
  protoOf(Remote_0).vsg = function (accession) {
    return Companion_getInstance_398().asi_1.ief(this.xsh_1, new AccessionDto(accession));
  };
  protoOf(Remote_0).ish = function (request, $completion) {
    return Companion_getInstance_398().bsi_1.oeg(this.xsh_1, request, $completion);
  };
  protoOf(Remote_0).vsh = function (accession, globalVersion, $completion) {
    return Companion_getInstance_398().csi_1.oeg(this.xsh_1, new DraftQueryCoordinates(accession, globalVersion), $completion);
  };
  protoOf(Remote_0).ho = function () {
    return this.wsh_1.ho();
  };
  function Companion_398() {
    Companion_instance_398 = this;
    InstanceDescriptor.call(this);
    var tmp = this;
    var tmp_0 = Companion_instance_396.i63();
    tmp.zsh_1 = derivedDataMethod(this, 'openDocument', tmp_0, EditorService$Companion$openDocument$slambda_0(null));
    var tmp_1 = this;
    var tmp_2 = Companion_instance_396.i63();
    var tmp_3 = Companion_getInstance_362().i63();
    tmp_1.asi_1 = flowMethod(this, 'getInheritedPropertiesFlow', tmp_2, tmp_3, EditorService$Companion$getInheritedPropertiesFlow$lambda);
    var tmp_4 = this;
    var tmp_5 = Companion_instance_389.i63();
    var tmp_6 = PublishedFindUsageRequestControllerSerializer_getInstance();
    tmp_4.bsi_1 = method(this, 'findUsages', tmp_5, tmp_6, EditorService$Companion$findUsages$slambda_0(null));
    var tmp_7 = this;
    var tmp_8 = Companion_instance_397.i63();
    tmp_7.csi_1 = derivedDataMethod(this, 'openDraftQuery', tmp_8, EditorService$Companion$openDraftQuery$slambda_0(null));
    this.dsi_1 = new RpcSchema(this);
  }
  protoOf(Companion_398).esi = function (endpoint) {
    return new Remote_0(endpoint);
  };
  protoOf(Companion_398).kef = function (endpoint) {
    return this.esi(endpoint);
  };
  var Companion_instance_398;
  function Companion_getInstance_398() {
    if (Companion_instance_398 == null)
      new Companion_398();
    return Companion_instance_398;
  }
  function EditorService() {
  }
  function EditorServiceClient$openDocument$o$collect$slambda($$this$unsafeFlow, $accession, resultContinuation) {
    this.nsi_1 = $$this$unsafeFlow;
    this.osi_1 = $accession;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(EditorServiceClient$openDocument$o$collect$slambda).f1q = function (value, $completion) {
    var tmp = this.g1q(value, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(EditorServiceClient$openDocument$o$collect$slambda).v9 = function (p1, $completion) {
    return this.f1q((p1 == null ? true : !(p1 == null)) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(EditorServiceClient$openDocument$o$collect$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 3;
            var tmp0 = this.nsi_1;
            var tmp2 = this.psi_1;
            this.qsi_1 = tmp0;
            this.f9_1 = 1;
            suspendResult = tmp2.usg(this.osi_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            this.f9_1 = 2;
            suspendResult = this.qsi_1.x18(ARGUMENT, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 3) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(EditorServiceClient$openDocument$o$collect$slambda).g1q = function (value, completion) {
    var i = new EditorServiceClient$openDocument$o$collect$slambda(this.nsi_1, this.osi_1, completion);
    i.psi_1 = value;
    return i;
  };
  function EditorServiceClient$openDocument$o$collect$slambda_0($$this$unsafeFlow, $accession, resultContinuation) {
    var i = new EditorServiceClient$openDocument$o$collect$slambda($$this$unsafeFlow, $accession, resultContinuation);
    var l = function (value, $completion) {
      return i.f1q(value, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function $collectCOROUTINE$_24(_this__u8e3s4, collector, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.zsi_1 = _this__u8e3s4;
    this.asj_1 = collector;
  }
  protoOf($collectCOROUTINE$_24).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            var $this$unsafeFlow = this.asj_1;
            this.f9_1 = 1;
            var tmp_0 = EditorServiceClient$openDocument$o$collect$slambda_0($this$unsafeFlow, this.zsi_1.csj_1, null);
            suspendResult = this.zsi_1.bsj_1.f18(new sam$kotlinx_coroutines_flow_FlowCollector$0_23(tmp_0), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function EditorServiceClient$openDraftQuery$o$collect$slambda($$this$unsafeFlow, $accession, $globalVersion, resultContinuation) {
    this.lsj_1 = $$this$unsafeFlow;
    this.msj_1 = $accession;
    this.nsj_1 = $globalVersion;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(EditorServiceClient$openDraftQuery$o$collect$slambda).f1q = function (value, $completion) {
    var tmp = this.g1q(value, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(EditorServiceClient$openDraftQuery$o$collect$slambda).v9 = function (p1, $completion) {
    return this.f1q((p1 == null ? true : !(p1 == null)) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(EditorServiceClient$openDraftQuery$o$collect$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 3;
            var tmp0 = this.lsj_1;
            var tmp2 = this.osj_1;
            this.psj_1 = tmp0;
            this.f9_1 = 1;
            suspendResult = tmp2.vsh(this.msj_1, this.nsj_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            this.f9_1 = 2;
            suspendResult = this.psj_1.x18(ARGUMENT, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 3) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(EditorServiceClient$openDraftQuery$o$collect$slambda).g1q = function (value, completion) {
    var i = new EditorServiceClient$openDraftQuery$o$collect$slambda(this.lsj_1, this.msj_1, this.nsj_1, completion);
    i.osj_1 = value;
    return i;
  };
  function EditorServiceClient$openDraftQuery$o$collect$slambda_0($$this$unsafeFlow, $accession, $globalVersion, resultContinuation) {
    var i = new EditorServiceClient$openDraftQuery$o$collect$slambda($$this$unsafeFlow, $accession, $globalVersion, resultContinuation);
    var l = function (value, $completion) {
      return i.f1q(value, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function $collectCOROUTINE$_25(_this__u8e3s4, collector, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.ysj_1 = _this__u8e3s4;
    this.zsj_1 = collector;
  }
  protoOf($collectCOROUTINE$_25).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            var $this$unsafeFlow = this.zsj_1;
            this.f9_1 = 1;
            var tmp_0 = EditorServiceClient$openDraftQuery$o$collect$slambda_0($this$unsafeFlow, this.ysj_1.bsk_1, this.ysj_1.csk_1, null);
            suspendResult = this.ysj_1.ask_1.f18(new sam$kotlinx_coroutines_flow_FlowCollector$0_24(tmp_0), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function sam$kotlinx_coroutines_flow_FlowCollector$0_23(function_0) {
    this.dsk_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_23).x18 = function (value, $completion) {
    return this.dsk_1(value, $completion);
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_23).f3 = function () {
    return this.dsk_1;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_23).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, FlowCollector) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_23).hashCode = function () {
    return hashCode(this.f3());
  };
  function sam$kotlinx_coroutines_flow_FlowCollector$0_24(function_0) {
    this.esk_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_24).x18 = function (value, $completion) {
    return this.esk_1(value, $completion);
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_24).f3 = function () {
    return this.esk_1;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_24).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, FlowCollector) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_24).hashCode = function () {
    return hashCode(this.f3());
  };
  function EditorServiceClient$openDocument$$inlined$map$1($this, $accession) {
    this.bsj_1 = $this;
    this.csj_1 = $accession;
  }
  protoOf(EditorServiceClient$openDocument$$inlined$map$1).y18 = function (collector, $completion) {
    var tmp = new $collectCOROUTINE$_24(this, collector, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(EditorServiceClient$openDocument$$inlined$map$1).f18 = function (collector, $completion) {
    return this.y18(collector, $completion);
  };
  function EditorServiceClient$openDraftQuery$$inlined$map$1($this, $accession, $globalVersion) {
    this.ask_1 = $this;
    this.bsk_1 = $accession;
    this.csk_1 = $globalVersion;
  }
  protoOf(EditorServiceClient$openDraftQuery$$inlined$map$1).y18 = function (collector, $completion) {
    var tmp = new $collectCOROUTINE$_25(this, collector, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(EditorServiceClient$openDraftQuery$$inlined$map$1).f18 = function (collector, $completion) {
    return this.y18(collector, $completion);
  };
  function $findUsagesCOROUTINE$(_this__u8e3s4, request, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.nsk_1 = _this__u8e3s4;
    this.osk_1 = request;
  }
  protoOf($findUsagesCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.nsk_1.psk_1.a1().ish(this.osk_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult.b3c();
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function EditorServiceClient(services) {
    this.psk_1 = services;
  }
  protoOf(EditorServiceClient).qsk = function (accession, $completion) {
    // Inline function 'kotlinx.coroutines.flow.map' call
    // Inline function 'kotlinx.coroutines.flow.unsafeTransform' call
    var this_0 = this.psk_1;
    // Inline function 'kotlinx.coroutines.flow.internal.unsafeFlow' call
    var providers = new EditorServiceClient$openDocument$$inlined$map$1(this_0, accession);
    return new RemoteDocumentClient(accession, providers);
  };
  protoOf(EditorServiceClient).vsg = function (accession) {
    return this.psk_1.a1().vsg(accession);
  };
  protoOf(EditorServiceClient).rsk = function (request, $completion) {
    var tmp = new $findUsagesCOROUTINE$(this, request, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(EditorServiceClient).ssk = function (accession, globalVersion, $completion) {
    // Inline function 'kotlinx.coroutines.flow.map' call
    // Inline function 'kotlinx.coroutines.flow.unsafeTransform' call
    var this_0 = this.psk_1;
    // Inline function 'kotlinx.coroutines.flow.internal.unsafeFlow' call
    var providers = new EditorServiceClient$openDraftQuery$$inlined$map$1(this_0, accession, globalVersion);
    return new RemoteDocumentClient(accession, providers);
  };
  function editorServiceClient(_this__u8e3s4, session) {
    var sessions = WsSessionProvider(_this__u8e3s4, editorServiceClient$slambda_0(session, null));
    var rpcClient = wsRpcClient(_this__u8e3s4, Companion_getInstance_398().dsi_1, sessions);
    return createEditorServiceClient(_this__u8e3s4, rpcClient);
  }
  function createEditorServiceClient(_this__u8e3s4, rpcClient) {
    return async(_this__u8e3s4, VOID, VOID, createEditorServiceClient$slambda_0(rpcClient, null));
  }
  function editorServiceClient$slambda($session, resultContinuation) {
    this.bsl_1 = $session;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(editorServiceClient$slambda).dsl = function ($this$WsSessionProvider, $completion) {
    var tmp = this.esl($this$WsSessionProvider, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(editorServiceClient$slambda).v9 = function (p1, $completion) {
    return this.dsl(p1 instanceof WsSessionScope ? p1 : THROW_CCE(), $completion);
  };
  protoOf(editorServiceClient$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.bsl_1(this.csl_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(editorServiceClient$slambda).esl = function ($this$WsSessionProvider, completion) {
    var i = new editorServiceClient$slambda(this.bsl_1, completion);
    i.csl_1 = $this$WsSessionProvider;
    return i;
  };
  function editorServiceClient$slambda_0($session, resultContinuation) {
    var i = new editorServiceClient$slambda($session, resultContinuation);
    var l = function ($this$WsSessionProvider, $completion) {
      return i.dsl($this$WsSessionProvider, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function createEditorServiceClient$slambda($rpcClient, resultContinuation) {
    this.nsl_1 = $rpcClient;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(createEditorServiceClient$slambda).psl = function ($this$async, $completion) {
    var tmp = this.f1h($this$async, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(createEditorServiceClient$slambda).v9 = function (p1, $completion) {
    return this.psl((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(createEditorServiceClient$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = stateIn(this.nsl_1.df0_1, this.nsl_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            return new EditorServiceClient(ARGUMENT);
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(createEditorServiceClient$slambda).f1h = function ($this$async, completion) {
    var i = new createEditorServiceClient$slambda(this.nsl_1, completion);
    i.osl_1 = $this$async;
    return i;
  };
  function createEditorServiceClient$slambda_0($rpcClient, resultContinuation) {
    var i = new createEditorServiceClient$slambda($rpcClient, resultContinuation);
    var l = function ($this$async, $completion) {
      return i.psl($this$async, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function WebsocketEditorServiceProvider$client$slambda$slambda($this_editorServiceClient, resultContinuation) {
    this.ysl_1 = $this_editorServiceClient;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(WebsocketEditorServiceProvider$client$slambda$slambda).asm = function ($this$webSocket, $completion) {
    var tmp = this.bsm($this$webSocket, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(WebsocketEditorServiceProvider$client$slambda$slambda).v9 = function (p1, $completion) {
    return this.asm(p1 instanceof DefaultClientWebSocketSession ? p1 : THROW_CCE(), $completion);
  };
  protoOf(WebsocketEditorServiceProvider$client$slambda$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.ysl_1.hf8(this.zsl_1.te0(), this.zsl_1.ue0(), this.zsl_1.pe0(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(WebsocketEditorServiceProvider$client$slambda$slambda).bsm = function ($this$webSocket, completion) {
    var i = new WebsocketEditorServiceProvider$client$slambda$slambda(this.ysl_1, completion);
    i.zsl_1 = $this$webSocket;
    return i;
  };
  function WebsocketEditorServiceProvider$client$slambda$slambda_0($this_editorServiceClient, resultContinuation) {
    var i = new WebsocketEditorServiceProvider$client$slambda$slambda($this_editorServiceClient, resultContinuation);
    var l = function ($this$webSocket, $completion) {
      return i.asm($this$webSocket, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function WebsocketEditorServiceProvider$client$slambda(this$0, $url, resultContinuation) {
    this.ksm_1 = this$0;
    this.lsm_1 = $url;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(WebsocketEditorServiceProvider$client$slambda).dsl = function ($this$editorServiceClient, $completion) {
    var tmp = this.esl($this$editorServiceClient, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(WebsocketEditorServiceProvider$client$slambda).v9 = function (p1, $completion) {
    return this.dsl(p1 instanceof WsSessionScope ? p1 : THROW_CCE(), $completion);
  };
  protoOf(WebsocketEditorServiceProvider$client$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = webSocket(this.ksm_1.nsm_1, this.lsm_1, VOID, WebsocketEditorServiceProvider$client$slambda$slambda_0(this.msm_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(WebsocketEditorServiceProvider$client$slambda).esl = function ($this$editorServiceClient, completion) {
    var i = new WebsocketEditorServiceProvider$client$slambda(this.ksm_1, this.lsm_1, completion);
    i.msm_1 = $this$editorServiceClient;
    return i;
  };
  function WebsocketEditorServiceProvider$client$slambda_0(this$0, $url, resultContinuation) {
    var i = new WebsocketEditorServiceProvider$client$slambda(this$0, $url, resultContinuation);
    var l = function ($this$editorServiceClient, $completion) {
      return i.dsl($this$editorServiceClient, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function WebsocketEditorServiceProvider(httpClient, url, context) {
    context = context === VOID ? EmptyCoroutineContext_instance : context;
    this.nsm_1 = httpClient;
    this.osm_1 = CoroutineScope_0(context);
    var tmp = this;
    tmp.psm_1 = editorServiceClient(this.osm_1, WebsocketEditorServiceProvider$client$slambda_0(this, url, null));
  }
  protoOf(WebsocketEditorServiceProvider).qsm = function ($completion) {
    return this.psm_1.nr($completion);
  };
  protoOf(WebsocketEditorServiceProvider).zr = function () {
    cancel(this.osm_1);
  };
  function ClientId_init_$Init$($this) {
    BaseId.call($this);
    ClientId.call($this);
    return $this;
  }
  function ClientId_init_$Create$() {
    return ClientId_init_$Init$(objectCreate(protoOf(ClientId)));
  }
  function Companion_399() {
    this.rsm_1 = 'client_id';
  }
  var Companion_instance_399;
  function Companion_getInstance_399() {
    return Companion_instance_399;
  }
  function ClientId() {
  }
  function ConnectionId_init_$Init$($this) {
    BaseId.call($this);
    ConnectionId.call($this);
    return $this;
  }
  function ConnectionId_init_$Create$() {
    return ConnectionId_init_$Init$(objectCreate(protoOf(ConnectionId)));
  }
  function Companion_400() {
    this.ssm_1 = 'connection_id';
  }
  var Companion_instance_400;
  function Companion_getInstance_400() {
    return Companion_instance_400;
  }
  function ConnectionId() {
  }
  function StringChannel() {
  }
  function JsonChannel() {
  }
  function JsonService$Companion$toStringPort$1$setOutput$$inlined$jsonChannel$1($output) {
    this.usm_1 = $output;
  }
  protoOf(JsonService$Companion$toStringPort$1$setOutput$$inlined$jsonChannel$1).vsm = function (message) {
    this.usm_1.tsm(message.toString());
    return Unit_instance;
  };
  protoOf(JsonService$Companion$toStringPort$1$setOutput$$inlined$jsonChannel$1).tsm = function (message) {
    return this.vsm(message instanceof JsonArray ? message : THROW_CCE());
  };
  function JsonService$Companion$toStringPort$$inlined$stringChannel$1($port) {
    this.wsm_1 = $port;
  }
  protoOf(JsonService$Companion$toStringPort$$inlined$stringChannel$1).xsm = function (message) {
    var tmp = this.wsm_1.ysm();
    var tmp_0 = Json_getInstance().z2g(message);
    tmp.tsm(tmp_0 instanceof JsonArray ? tmp_0 : THROW_CCE());
    return Unit_instance;
  };
  protoOf(JsonService$Companion$toStringPort$$inlined$stringChannel$1).tsm = function (message) {
    return this.xsm((!(message == null) ? typeof message === 'string' : false) ? message : THROW_CCE());
  };
  function JsonService$Companion$toStringPort$1($inputChannel, $port) {
    this.zsm_1 = $inputChannel;
    this.asn_1 = $port;
  }
  protoOf(JsonService$Companion$toStringPort$1).ysm = function () {
    return this.zsm_1;
  };
  protoOf(JsonService$Companion$toStringPort$1).bsn = function (output, internalErrorHandler) {
    // Inline function 'jetbrains.ocelot.ot.commons.protocol.json.jsonChannel' call
    var outputJsonChannel = new JsonService$Companion$toStringPort$1$setOutput$$inlined$jsonChannel$1(output);
    this.asn_1.csn(outputJsonChannel, internalErrorHandler);
  };
  protoOf(JsonService$Companion$toStringPort$1).csn = function (output, internalErrorHandler) {
    return this.bsn((!(output == null) ? isInterface(output, StringChannel) : false) ? output : THROW_CCE(), internalErrorHandler);
  };
  protoOf(JsonService$Companion$toStringPort$1).zr = function () {
    this.asn_1.zr();
  };
  function Companion_401() {
  }
  protoOf(Companion_401).dsn = function (port) {
    // Inline function 'jetbrains.ocelot.ot.commons.protocol.stringChannel' call
    var inputChannel = new JsonService$Companion$toStringPort$$inlined$stringChannel$1(port);
    return new JsonService$Companion$toStringPort$1(inputChannel, port);
  };
  var Companion_instance_401;
  function Companion_getInstance_401() {
    return Companion_instance_401;
  }
  function JsonServiceEndpoint() {
  }
  protoOf(JsonServiceEndpoint).esn = function () {
    return Companion_instance_401.dsn(this.fsn());
  };
  function hasAsyncs($this) {
    // Inline function 'kotlin.collections.isNotEmpty' call
    return !$this.hsn_1.s();
  }
  function call($this, caller) {
    if (hasAsyncs($this)) {
      try {
        var _iterator__ex2g4s = $this.hsn_1.m();
        while (_iterator__ex2g4s.n()) {
          var a = _iterator__ex2g4s.o();
          try {
            caller(a);
          } catch ($p) {
            if ($p instanceof Error) {
              var t = $p;
              ThrowableHandlers_getInstance().k2r_1.j2r(t);
            } else {
              throw $p;
            }
          }
        }
      }finally {
        $this.hsn_1.k2();
      }
    }
  }
  function AsyncsListHandler$succeed$lambda($item) {
    return function (async) {
      async.w37($item);
      return Unit_instance;
    };
  }
  function AsyncsListHandler$fail$lambda($reason) {
    return function (async) {
      async.x37(new OtRejectionException($reason));
      return Unit_instance;
    };
  }
  function AsyncsListHandler() {
    this.hsn_1 = ArrayList_init_$Create$();
  }
  protoOf(AsyncsListHandler).x2g = function () {
    return this.hsn_1.p();
  };
  protoOf(AsyncsListHandler).isn = function (async) {
    return contains_5(this.hsn_1, async);
  };
  protoOf(AsyncsListHandler).jsn = function (async) {
    // Inline function 'kotlin.collections.remove' call
    var this_0 = this.hsn_1;
    return (isInterface(this_0, MutableCollection) ? this_0 : THROW_CCE()).h2(async);
  };
  protoOf(AsyncsListHandler).ksn = function () {
    var async = new SimpleAsync();
    this.hsn_1.j(async);
    return async;
  };
  protoOf(AsyncsListHandler).lsn = function (item) {
    call(this, AsyncsListHandler$succeed$lambda(item));
  };
  protoOf(AsyncsListHandler).msn = function (reason) {
    call(this, AsyncsListHandler$fail$lambda(reason));
  };
  function isInLoadedSubtree($this, path) {
    var iterator = path.u(path.p());
    while (iterator.r4()) {
      if ($this.psn(iterator.t4())) {
        return true;
      }
    }
    return false;
  }
  function markLoaded($this, pathToLeaf) {
    // Inline function 'kotlin.check' call
    if (!!isInLoadedSubtree($this, pathToLeaf)) {
      var message = 'Entity is in loaded subtree, entityId=' + last(pathToLeaf).toString();
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    var iterator = pathToLeaf.m();
    var rootId = iterator.o();
    var element = getOrCreateRoot($this, rootId);
    if (!iterator.n()) {
      element.usn();
      return Unit_instance;
    }
    while (iterator.n()) {
      var id = iterator.o();
      element = addChild_0($this, element, id, !iterator.n());
    }
  }
  function containsRoot($this, rootId) {
    return $this.i3j(rootId) && ensureNotNull($this.nsn_1.q2(rootId)).vsn();
  }
  function getPath($this, entity) {
    var tmp = ancestorsFrom(entity);
    return asReversed_0(toList_2(map(tmp, LoadedEntitiesTree$getPath$lambda)));
  }
  function setupFullRoot($this, rootId) {
    return getOrCreateRoot($this, rootId).usn();
  }
  function getOrCreateRoot($this, rootId) {
    if ($this.i3j(rootId)) {
      // Inline function 'kotlin.check' call
      if (!ensureNotNull($this.nsn_1.q2(rootId)).vsn()) {
        throw IllegalStateException_init_$Create$_0('Check failed.');
      }
    } else {
      createRoot($this, rootId);
    }
    return ensureNotNull($this.nsn_1.q2(rootId));
  }
  function createRoot($this, rootId) {
    var rootElement = new LoadedEntitiesTreeElement(rootId);
    $this.wsn(rootId, rootElement);
    return rootElement;
  }
  function addChild_0($this, parent, childId, isLeaf) {
    var child = parent.xsn(childId);
    if (!(child == null)) {
      if (isLeaf) {
        child.usn();
      }
    } else {
      child = parent.ysn(childId);
      $this.wsn(childId, child);
    }
    return child;
  }
  function LoadedEntitiesTree$getPath$lambda(e) {
    return e.n3d_1;
  }
  function LoadedEntitiesTree() {
    this.nsn_1 = HashMap_init_$Create$();
    this.osn_1 = HashSet_init_$Create$();
  }
  protoOf(LoadedEntitiesTree).i3j = function (id) {
    return this.nsn_1.o2(id);
  };
  protoOf(LoadedEntitiesTree).psn = function (id) {
    return this.nsn_1.o2(id) && ensureNotNull(this.nsn_1.q2(id)).q90();
  };
  protoOf(LoadedEntitiesTree).zsn = function (id) {
    return this.nsn_1.o2(id) && !ensureNotNull(this.nsn_1.q2(id)).q90();
  };
  protoOf(LoadedEntitiesTree).aso = function (entity) {
    if (this.psn(entity.n3d_1))
      return true;
    var currentEntity = entity.bp();
    while (!(currentEntity == null)) {
      if (this.psn(currentEntity.n3d_1))
        return true;
      currentEntity = currentEntity.bp();
    }
    return false;
  };
  protoOf(LoadedEntitiesTree).bso = function (rootId) {
    // Inline function 'kotlin.check' call
    if (!!this.psn(rootId)) {
      var message = 'Already loaded, root id=' + rootId.toString();
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    setupFullRoot(this, rootId);
  };
  protoOf(LoadedEntitiesTree).cso = function (entity) {
    return markLoaded(this, getPath(this, entity));
  };
  protoOf(LoadedEntitiesTree).dso = function (id) {
    if (!this.i3j(id))
      return false;
    ensureNotNull(this.nsn_1.q2(id)).eso();
    return true;
  };
  protoOf(LoadedEntitiesTree).fso = function (rootId) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.require' call
    if (!containsRoot(this, rootId)) {
      var message = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    return ensureNotNull(this.nsn_1.q2(rootId));
  };
  protoOf(LoadedEntitiesTree).wsn = function (id, element) {
    // Inline function 'kotlin.collections.set' call
    this.nsn_1.t2(id, element);
    if (element.vsn()) {
      this.osn_1.j(id);
    }
    element.gso(this);
  };
  protoOf(LoadedEntitiesTree).hso = function (element) {
    this.nsn_1.u2(element.qsn_1);
    this.osn_1.h2(element.qsn_1);
  };
  protoOf(LoadedEntitiesTree).toString = function () {
    var sb = new StringBuilder('LoadedEntitiesTree: [');
    var _iterator__ex2g4s = this.osn_1.m();
    while (_iterator__ex2g4s.n()) {
      var rootId = _iterator__ex2g4s.o();
      sb.i8(this.nsn_1.q2(rootId)).j8('; ');
    }
    sb.k8(_Char___init__impl__6a9atx(93));
    return sb.toString();
  };
  function unregister($this) {
    if (!($this.tsn_1 == null)) {
      ensureNotNull($this.tsn_1).hso($this);
      $this.tsn_1 = null;
    }
  }
  function copyChildren($this, copy) {
    if ($this.q90())
      return Unit_instance;
    var _iterator__ex2g4s = ensureNotNull($this.ssn_1).r2().m();
    while (_iterator__ex2g4s.n()) {
      var id = _iterator__ex2g4s.o();
      var childCopy = copy.ysn(id);
      copyChildren(ensureNotNull($this.xsn(id)), childCopy);
    }
  }
  function Companion_402() {
  }
  var Companion_instance_402;
  function Companion_getInstance_402() {
    return Companion_instance_402;
  }
  function LoadedEntitiesTreeElement(id, parent) {
    parent = parent === VOID ? null : parent;
    this.qsn_1 = id;
    this.rsn_1 = parent;
    this.ssn_1 = null;
    this.tsn_1 = null;
  }
  protoOf(LoadedEntitiesTreeElement).vsn = function () {
    return this.rsn_1 == null;
  };
  protoOf(LoadedEntitiesTreeElement).q90 = function () {
    return this.ssn_1 == null;
  };
  protoOf(LoadedEntitiesTreeElement).iso = function () {
    return this.q90() ? null : ensureNotNull(this.ssn_1).s2();
  };
  protoOf(LoadedEntitiesTreeElement).xsn = function (id) {
    return this.q90() ? null : ensureNotNull(this.ssn_1).q2(id);
  };
  protoOf(LoadedEntitiesTreeElement).ysn = function (childId) {
    if (this.ssn_1 == null) {
      this.ssn_1 = HashMap_init_$Create$();
    }
    var child = new LoadedEntitiesTreeElement(childId, this);
    // Inline function 'kotlin.collections.set' call
    ensureNotNull(this.ssn_1).t2(childId, child);
    return child;
  };
  protoOf(LoadedEntitiesTreeElement).jso = function (id) {
    ensureNotNull(this.ssn_1).u2(id);
    if (ensureNotNull(this.ssn_1).s()) {
      this.ssn_1 = null;
    }
  };
  protoOf(LoadedEntitiesTreeElement).eso = function () {
    this.usn();
    if (!this.vsn()) {
      ensureNotNull(this.rsn_1).jso(this.qsn_1);
      if (this.rsn_1.q90()) {
        unregister(this);
        this.rsn_1.eso();
        return Unit_instance;
      }
    }
    unregister(this);
  };
  protoOf(LoadedEntitiesTreeElement).usn = function () {
    if (this.q90())
      return Unit_instance;
    var _iterator__ex2g4s = ensureNotNull(this.ssn_1).s2().m();
    while (_iterator__ex2g4s.n()) {
      var child = _iterator__ex2g4s.o();
      child.usn();
      unregister(child);
    }
    this.ssn_1 = null;
  };
  protoOf(LoadedEntitiesTreeElement).gso = function (tree) {
    // Inline function 'kotlin.check' call
    if (!(this.tsn_1 == null)) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    this.tsn_1 = tree;
  };
  protoOf(LoadedEntitiesTreeElement).kso = function () {
    // Inline function 'kotlin.check' call
    if (!this.vsn()) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    var copy = new LoadedEntitiesTreeElement(this.qsn_1);
    copyChildren(this, copy);
    return copy;
  };
  protoOf(LoadedEntitiesTreeElement).toString = function () {
    return this.qsn_1.toString() + (this.ssn_1 == null ? '' : '-' + toString_0(this.ssn_1));
  };
  function LoadedEntitiesTreeReconnectHelper(tree) {
    this.lso_1 = tree;
  }
  protoOf(LoadedEntitiesTreeReconnectHelper).mso = function (rootId, version) {
    return new RootReconnectData(this.lso_1.fso(rootId).kso(), version);
  };
  function OtChannel() {
  }
  function OtChannelAdapter() {
  }
  protoOf(OtChannelAdapter).nso = function (command) {
    throw UnsupportedOperationException_init_$Create$();
  };
  protoOf(OtChannelAdapter).oso = function (id, baseVersion, resultVersion) {
    throw UnsupportedOperationException_init_$Create$();
  };
  protoOf(OtChannelAdapter).pso = function (id, reason) {
    throw UnsupportedOperationException_init_$Create$();
  };
  protoOf(OtChannelAdapter).qso = function (id) {
    throw UnsupportedOperationException_init_$Create$();
  };
  protoOf(OtChannelAdapter).rso = function (id, rootsToLoad) {
    throw UnsupportedOperationException_init_$Create$();
  };
  protoOf(OtChannelAdapter).sso = function (id) {
    throw UnsupportedOperationException_init_$Create$();
  };
  protoOf(OtChannelAdapter).tso = function (id, reason) {
    throw UnsupportedOperationException_init_$Create$();
  };
  protoOf(OtChannelAdapter).uso = function (id) {
    throw UnsupportedOperationException_init_$Create$();
  };
  protoOf(OtChannelAdapter).vso = function (id) {
    throw UnsupportedOperationException_init_$Create$();
  };
  protoOf(OtChannelAdapter).wso = function (id, reason) {
    throw UnsupportedOperationException_init_$Create$();
  };
  protoOf(OtChannelAdapter).xso = function (id, from, to) {
    throw UnsupportedOperationException_init_$Create$();
  };
  protoOf(OtChannelAdapter).yso = function (id, history) {
    throw UnsupportedOperationException_init_$Create$();
  };
  protoOf(OtChannelAdapter).zso = function (id, reason) {
    throw UnsupportedOperationException_init_$Create$();
  };
  protoOf(OtChannelAdapter).asp = function (id, rootIds) {
    throw UnsupportedOperationException_init_$Create$();
  };
  protoOf(OtChannelAdapter).bsp = function (id, rootIds) {
    throw UnsupportedOperationException_init_$Create$();
  };
  protoOf(OtChannelAdapter).csp = function (commandId) {
    throw UnsupportedOperationException_init_$Create$();
  };
  function OtChannelDelegate(source) {
    this.dsp_1 = source;
  }
  protoOf(OtChannelDelegate).nso = function (command) {
    this.dsp_1.nso(command);
  };
  protoOf(OtChannelDelegate).oso = function (id, baseVersion, resultVersion) {
    this.dsp_1.oso(id, baseVersion, resultVersion);
  };
  protoOf(OtChannelDelegate).pso = function (id, reason) {
    this.dsp_1.pso(id, reason);
  };
  protoOf(OtChannelDelegate).qso = function (id) {
    this.dsp_1.qso(id);
  };
  protoOf(OtChannelDelegate).rso = function (id, rootsToLoad) {
    this.dsp_1.rso(id, rootsToLoad);
  };
  protoOf(OtChannelDelegate).sso = function (id) {
    this.dsp_1.sso(id);
  };
  protoOf(OtChannelDelegate).tso = function (id, reason) {
    this.dsp_1.tso(id, reason);
  };
  protoOf(OtChannelDelegate).uso = function (id) {
    this.dsp_1.uso(id);
  };
  protoOf(OtChannelDelegate).vso = function (id) {
    this.dsp_1.vso(id);
  };
  protoOf(OtChannelDelegate).wso = function (id, reason) {
    this.dsp_1.wso(id, reason);
  };
  protoOf(OtChannelDelegate).xso = function (id, from, to) {
    this.dsp_1.xso(id, from, to);
  };
  protoOf(OtChannelDelegate).yso = function (id, history) {
    this.dsp_1.yso(id, history);
  };
  protoOf(OtChannelDelegate).zso = function (id, reason) {
    this.dsp_1.zso(id, reason);
  };
  protoOf(OtChannelDelegate).asp = function (id, rootIds) {
    this.dsp_1.asp(id, rootIds);
  };
  protoOf(OtChannelDelegate).bsp = function (id, rootIds) {
    this.dsp_1.bsp(id, rootIds);
  };
  protoOf(OtChannelDelegate).csp = function (commandId) {
    this.dsp_1.csp(commandId);
  };
  function _get_isPortOpened__9rr51l($this) {
    return !($this.gsp_1 == null);
  }
  function closeInternally($this) {
    if (_get_isPortOpened__9rr51l($this)) {
      ensureNotNull($this.gsp_1).zr();
      $this.gsp_1 = null;
    }
  }
  function lazyInit($this) {
    if ($this.hsp_1 == null) {
      $this.ksp(PortExecutingDelegate$lazyInit$lambda($this));
      $this.hsp_1 = createInput($this);
    }
  }
  function createInput($this) {
    return $this.lsp(PortExecutingDelegate$createInput$lambda($this));
  }
  function sam$jetbrains_ocelot_base_edt_EdtTask$0_17(function_0) {
    this.msp_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_17).au = function () {
    return this.msp_1();
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_17).f3 = function () {
    return this.msp_1;
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_17).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, EdtTask) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_17).hashCode = function () {
    return hashCode(this.f3());
  };
  function PortExecutingDelegate$setOutput$lambda$lambda(this$0) {
    return function (item) {
      closeInternally(this$0);
      var tmp;
      if (this$0.isp_1 == null) {
        this$0.isp_1 = item;
        tmp = ensureNotNull(this$0.jsp_1)(item);
      }
      return Unit_instance;
    };
  }
  function PortExecutingDelegate$setOutput$lambda(this$0, $output) {
    return function () {
      var tmp = ensureNotNull(this$0.gsp_1);
      tmp.csn($output, PortExecutingDelegate$setOutput$lambda$lambda(this$0));
      return Unit_instance;
    };
  }
  function PortExecutingDelegate$closeInternally$ref(p0) {
    var l = function () {
      var tmp0 = p0;
      closeInternally(tmp0);
      return Unit_instance;
    };
    l.callableName = 'closeInternally';
    return l;
  }
  function PortExecutingDelegate$lazyInit$lambda(this$0) {
    return function () {
      this$0.gsp_1 = this$0.esp_1();
      return Unit_instance;
    };
  }
  function PortExecutingDelegate$createInput$lambda(this$0) {
    return function () {
      return ensureNotNull(this$0.gsp_1).ysm();
    };
  }
  function PortExecutingDelegate(portSupplier, edt) {
    this.esp_1 = portSupplier;
    this.fsp_1 = edt;
    this.gsp_1 = null;
    this.hsp_1 = null;
    this.isp_1 = null;
    this.jsp_1 = null;
  }
  protoOf(PortExecutingDelegate).ysm = function () {
    lazyInit(this);
    return ensureNotNull(this.hsp_1);
  };
  protoOf(PortExecutingDelegate).ksp = function (r) {
    if (this.isp_1 == null) {
      try {
        this.fsp_1.u39(new sam$jetbrains_ocelot_base_edt_EdtTask$0_17(r));
      } catch ($p) {
        if ($p instanceof EdtException) {
          var e = $p;
          this.isp_1 = e;
          if (!(this.jsp_1 == null)) {
            ensureNotNull(this.jsp_1)(e);
          }
        } else {
          throw $p;
        }
      }
    }
  };
  protoOf(PortExecutingDelegate).nsp = function (output, internalErrorHandler) {
    lazyInit(this);
    if (!(this.isp_1 == null)) {
      internalErrorHandler(ensureNotNull(this.isp_1));
      return Unit_instance;
    }
    this.jsp_1 = internalErrorHandler;
    this.ksp(PortExecutingDelegate$setOutput$lambda(this, output));
  };
  protoOf(PortExecutingDelegate).csn = function (output, internalErrorHandler) {
    return this.nsp((output == null ? true : !(output == null)) ? output : THROW_CCE(), internalErrorHandler);
  };
  protoOf(PortExecutingDelegate).zr = function () {
    if (this.hsp_1 == null || !(this.isp_1 == null)) {
      return Unit_instance;
    }
    this.ksp(PortExecutingDelegate$closeInternally$ref(this));
  };
  function unwrap_2($this, operation) {
    var $this_0 = $this;
    var operation_0 = operation;
    $l$1: do {
      $l$0: do {
        var tmp;
        if (isInterface(operation_0, OperationContainer)) {
          tmp = !(operation_0 instanceof TargetedOperation);
        } else {
          tmp = false;
        }
        if (tmp) {
          var operationContainer = isInterface(operation_0, OperationContainer) ? operation_0 : THROW_CCE();
          var wrappedOps = operationContainer.j3w();
          if (wrappedOps.s())
            return null;
          var tmp_0;
          if (wrappedOps.p() === 1) {
            var tmp0 = $this_0;
            var tmp1 = wrappedOps.r(0);
            $this_0 = tmp0;
            operation_0 = tmp1;
            continue $l$0;
          } else {
            tmp_0 = wrappedOps;
          }
          return tmp_0;
        }
        return listOf(operation_0);
      }
       while (false);
    }
     while (true);
  }
  function RootOperationsUtil() {
  }
  protoOf(RootOperationsUtil).osp = function (id, op) {
    var operation = this.psp(op);
    var tmp;
    if (operation instanceof AddRootOperation) {
      tmp = id.equals(operation.m3w());
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(RootOperationsUtil).qsp = function (id, op) {
    var tmp0_elvis_lhs = this.psp(op);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var operation = tmp;
    var tmp_0;
    if (operation instanceof AddRootOperation) {
      tmp_0 = id.equals(operation.m3w());
    } else {
      tmp_0 = false;
    }
    var isAddOp = tmp_0;
    var tmp_1;
    if (operation instanceof BuildRootOperation) {
      tmp_1 = id.equals(operation.m3w());
    } else {
      tmp_1 = false;
    }
    var isBuildOp = tmp_1;
    return isAddOp || isBuildOp;
  };
  protoOf(RootOperationsUtil).psp = function (op) {
    var unwrapped = unwrap_2(this, op);
    return unwrapped == null ? null : unwrapped.r(0);
  };
  var RootOperationsUtil_instance;
  function RootOperationsUtil_getInstance() {
    return RootOperationsUtil_instance;
  }
  function RootReconnectData(treeElement, version) {
    this.rsp_1 = treeElement;
    this.ssp_1 = version;
  }
  protoOf(RootReconnectData).toString = function () {
    return '[v=' + this.ssp_1 + ', root=' + this.rsp_1.toString() + ']';
  };
  function ThrottlingJsonPort$Companion$LOG$lambda() {
    return Unit_instance;
  }
  function _get_wrappedInput__vocaje($this) {
    if ($this.esq_1 == null) {
      $this.esq_1 = ensureNotNull($this.fsq_1)();
    }
    return ensureNotNull($this.esq_1);
  }
  function process_0($this) {
    $this.hsq();
    var start = $this.fsp_1.t39();
    while (!$this.csq_1.s() && subtract_1($this.fsp_1.t39(), start) <= fromInt_0($this.zsp_1)) {
      var array = $this.csq_1.qf();
      _get_wrappedInput__vocaje($this).tsm(array);
    }
    var elapsedTime = subtract_1($this.fsp_1.t39(), start);
    var shouldWarn = elapsedTime > fromInt_0($this.bsq_1);
    if (elapsedTime > fromInt_0($this.zsp_1)) {
      var tmp = Companion_getInstance_403().isq_1;
      tmp.a2q(ThrottlingJsonPort$process$lambda($this));
      if (shouldWarn) {
        var tmp_0 = Companion_getInstance_403().isq_1;
        tmp_0.c2q(ThrottlingJsonPort$process$lambda_0(elapsedTime));
      }
      if ($this.gsq_1 == null) {
        var tmp_1 = $this;
        var tmp_2 = ThrottlingJsonPort$process$lambda_1($this);
        tmp_1.gsq_1 = $this.fsp_1.v39($this.asq_1, new sam$jetbrains_ocelot_base_edt_EdtTask$0_18(tmp_2));
      }
    }
    $this.jsq(shouldWarn);
  }
  function Companion_403() {
    Companion_instance_403 = this;
    var tmp = this;
    var tmp_0 = KotlinLogging_getInstance();
    tmp.isq_1 = tmp_0.i2q(ThrottlingJsonPort$Companion$LOG$lambda);
  }
  var Companion_instance_403;
  function Companion_getInstance_403() {
    if (Companion_instance_403 == null)
      new Companion_403();
    return Companion_instance_403;
  }
  function sam$jetbrains_ocelot_base_edt_EdtTask$0_18(function_0) {
    this.ksq_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_18).au = function () {
    return this.ksq_1();
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_18).f3 = function () {
    return this.ksq_1;
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_18).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, EdtTask) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_18).hashCode = function () {
    return hashCode(this.f3());
  };
  function ThrottlingJsonPort$createChannelDelegate$$inlined$jsonChannel$1(this$0) {
    this.lsq_1 = this$0;
  }
  protoOf(ThrottlingJsonPort$createChannelDelegate$$inlined$jsonChannel$1).vsm = function (message) {
    this.lsq_1.csq_1.j(message);
    if (this.lsq_1.gsq_1 == null) {
      process_0(this.lsq_1);
    }
    return Unit_instance;
  };
  protoOf(ThrottlingJsonPort$createChannelDelegate$$inlined$jsonChannel$1).tsm = function (message) {
    return this.vsm(message instanceof JsonArray ? message : THROW_CCE());
  };
  function ThrottlingJsonPort$process$lambda(this$0) {
    return function () {
      return 'OT Messages handling took more than ' + this$0.zsp_1 + ' ms, the next messages handling is delayed ' + ('for ' + this$0.asq_1 + ' ms');
    };
  }
  function ThrottlingJsonPort$process$lambda_0($elapsedTime) {
    return function () {
      return 'OT Messages handling took ' + $elapsedTime.toString() + ' ms, consider profiling and optimizing your code';
    };
  }
  function ThrottlingJsonPort$process$lambda_1(this$0) {
    return function () {
      this$0.gsq_1 = null;
      process_0(this$0);
      return Unit_instance;
    };
  }
  function ThrottlingJsonPort(portSupplier, edt, runLimit, runDelay, warnLimit) {
    Companion_getInstance_403();
    warnLimit = warnLimit === VOID ? runLimit : warnLimit;
    PortExecutingDelegate.call(this, portSupplier, edt);
    this.zsp_1 = runLimit;
    this.asq_1 = runDelay;
    this.bsq_1 = warnLimit;
    this.csq_1 = ArrayDeque_init_$Create$();
    this.dsq_1 = Companion_getInstance_29().m2l_1;
    this.esq_1 = null;
    this.fsq_1 = null;
    this.gsq_1 = null;
  }
  protoOf(ThrottlingJsonPort).msq = function (channelSupplier) {
    this.fsq_1 = channelSupplier;
    // Inline function 'jetbrains.ocelot.ot.commons.protocol.json.jsonChannel' call
    return new ThrottlingJsonPort$createChannelDelegate$$inlined$jsonChannel$1(this);
  };
  protoOf(ThrottlingJsonPort).lsp = function (channelSupplier) {
    return this.msq(channelSupplier);
  };
  protoOf(ThrottlingJsonPort).hsq = function () {
  };
  protoOf(ThrottlingJsonPort).jsq = function (longRun) {
  };
  protoOf(ThrottlingJsonPort).zr = function () {
    this.dsq_1.zr();
    if (!(this.gsq_1 == null)) {
      ensureNotNull(this.gsq_1).zr();
    }
    protoOf(PortExecutingDelegate).zr.call(this);
  };
  function ProtocolPersistentParameter(tag, persister) {
    this.nsq_1 = tag;
    this.osq_1 = persister;
  }
  protoOf(ProtocolPersistentParameter).t3c = function () {
    return this.nsq_1;
  };
  protoOf(ProtocolPersistentParameter).q3c = function () {
    return this.osq_1;
  };
  protoOf(ProtocolPersistentParameter).m3c = function () {
    return true;
  };
  function BooleanPersistentParameter(key) {
    ProtocolPersistentParameter.call(this, key, Persisters_getInstance().k25());
  }
  function LongPersistentParameter(key) {
    ProtocolPersistentParameter.call(this, key, Persisters_getInstance().j25());
  }
  function StringPersistentParameter(key) {
    ProtocolPersistentParameter.call(this, key, Persisters_getInstance().z25());
  }
  function ProtocolParameters$RECONNECT_ENABLED$1() {
    BooleanPersistentParameter.call(this, 'r');
  }
  protoOf(ProtocolParameters$RECONNECT_ENABLED$1).k3c = function () {
    return true;
  };
  protoOf(ProtocolParameters$RECONNECT_ENABLED$1).toString = function () {
    return 'reconnect protocol parameter';
  };
  function ProtocolParameters$PING_TIMEOUT_MS$1() {
    LongPersistentParameter.call(this, 'pt');
  }
  protoOf(ProtocolParameters$PING_TIMEOUT_MS$1).k3c = function () {
    return 30000n;
  };
  protoOf(ProtocolParameters$PING_TIMEOUT_MS$1).toString = function () {
    return 'ping timeout in milliseconds protocol parameter';
  };
  function ProtocolParameters$ID_COMPRESSION_ENABLED$1() {
    BooleanPersistentParameter.call(this, 'i');
  }
  protoOf(ProtocolParameters$ID_COMPRESSION_ENABLED$1).k3c = function () {
    return true;
  };
  protoOf(ProtocolParameters$ID_COMPRESSION_ENABLED$1).toString = function () {
    return 'id compression protocol parameter';
  };
  function ProtocolParameters$PARTIAL_LOADING_ENABLED$1() {
    BooleanPersistentParameter.call(this, 'p');
  }
  protoOf(ProtocolParameters$PARTIAL_LOADING_ENABLED$1).k3c = function () {
    return false;
  };
  protoOf(ProtocolParameters$PARTIAL_LOADING_ENABLED$1).toString = function () {
    return 'partial loading protocol parameter';
  };
  function ProtocolParameters$OT_VERSION$1() {
    StringPersistentParameter.call(this, 'otv');
  }
  protoOf(ProtocolParameters$OT_VERSION$1).k3c = function () {
    return '6';
  };
  protoOf(ProtocolParameters$OT_VERSION$1).toString = function () {
    return 'ot version protocol parameter';
  };
  function ProtocolParameters() {
    ProtocolParameters_instance = this;
    var tmp = this;
    tmp.zsq_1 = new ProtocolParameters$RECONNECT_ENABLED$1();
    var tmp_0 = this;
    tmp_0.asr_1 = new ProtocolParameters$PING_TIMEOUT_MS$1();
    var tmp_1 = this;
    tmp_1.bsr_1 = new ProtocolParameters$ID_COMPRESSION_ENABLED$1();
    var tmp_2 = this;
    tmp_2.csr_1 = new ProtocolParameters$PARTIAL_LOADING_ENABLED$1();
    var tmp_3 = this;
    tmp_3.dsr_1 = new ProtocolParameters$OT_VERSION$1();
  }
  var ProtocolParameters_instance;
  function ProtocolParameters_getInstance() {
    if (ProtocolParameters_instance == null)
      new ProtocolParameters();
    return ProtocolParameters_instance;
  }
  function ProtocolPersistentContext() {
    ConfigurationPersistentContext.call(this);
    this.s3c(ProtocolParameters_getInstance().zsq_1);
    this.s3c(ProtocolParameters_getInstance().asr_1);
    this.s3c(ProtocolParameters_getInstance().bsr_1);
    this.s3c(ProtocolParameters_getInstance().csr_1);
    this.s3c(ProtocolParameters_getInstance().dsr_1);
  }
  function Companion_404() {
  }
  protoOf(Companion_404).esr = function (array, shift) {
    var commandId = CommandId_init_$Create$_0(array.s2h(shift));
    var rootId = EntityId_init_$Create$_0(array.s2h(shift + 1 | 0));
    return new RootCommandId(commandId, rootId);
  };
  var Companion_instance_404;
  function Companion_getInstance_404() {
    return Companion_instance_404;
  }
  function CommandDeserializer(context) {
    this.fsr_1 = new DictionaryAwareOperationDeserializer(context);
  }
  protoOf(CommandDeserializer).n4r = function (json) {
    var index = 0;
    var id = Companion_instance_404.esr(json, index);
    index = index + 2 | 0;
    var _unary__edvuaz = index;
    index = _unary__edvuaz + 1 | 0;
    var baseVersion = json.u2h(_unary__edvuaz);
    var _unary__edvuaz_0 = index;
    index = _unary__edvuaz_0 + 1 | 0;
    var resultVersion = json.u2h(_unary__edvuaz_0);
    var operation = this.fsr_1.n4r(json.r2h(index));
    return new Command(id, baseVersion, resultVersion, operation);
  };
  protoOf(CommandDeserializer).zr = function () {
  };
  function Companion_405() {
  }
  protoOf(Companion_405).gsr = function (array, commandId, rootId) {
    array.m2h(commandId.q36_1);
    array.m2h(rootId.q36_1);
  };
  var Companion_instance_405;
  function Companion_getInstance_405() {
    return Companion_instance_405;
  }
  function CommandSerializer(context) {
    this.hsr_1 = new DictionaryAwareOperationSerializer(context);
  }
  protoOf(CommandSerializer).isr = function (command) {
    var message = new JsonArray();
    Companion_instance_405.gsr(message, command.b55_1.f55_1, command.b55_1.g55_1);
    message.p2h(command.c55_1);
    message.p2h(command.d55_1);
    message.y2g(this.hsr_1.t4r(command.e55_1));
    return message;
  };
  function DictionaryAwareOperationDeserializer(context) {
    DictionaryAwareDeserializer.call(this, context.l4q_1.j4u());
    this.lsr_1 = context;
  }
  protoOf(DictionaryAwareOperationDeserializer).m4r = function (json) {
    return this.lsr_1.d4w(json instanceof JsonArray ? json : THROW_CCE());
  };
  function DictionaryAwareOperationSerializer(context) {
    DictionaryAwareSerializer.call(this, context.l4q_1.j4u());
    this.osr_1 = context;
  }
  protoOf(DictionaryAwareOperationSerializer).psr = function (value) {
    return this.osr_1.c4w(value);
  };
  protoOf(DictionaryAwareOperationSerializer).s4r = function (value) {
    return this.psr((!(value == null) ? isInterface(value, Operation) : false) ? value : THROW_CCE());
  };
  function getFullSerializerFactory($this) {
    // Inline function 'jetbrains.ocelot.ot.model.protocol.json.commandSerializerFactory' call
    return new Json2OtChannelAdapter$Companion$getFullSerializerFactory$$inlined$commandSerializerFactory$1();
  }
  function Json2OtChannelAdapter$Companion$getFullSerializerFactory$$inlined$commandSerializerFactory$1() {
  }
  protoOf(Json2OtChannelAdapter$Companion$getFullSerializerFactory$$inlined$commandSerializerFactory$1).qsr = function (idCompressor, persistenceContextFactory, nodeFactory) {
    var context = persistenceContextFactory.rsr(idCompressor, nodeFactory);
    return new CommandSerializer(context);
  };
  function Json2OtChannelAdapter_init_$Init$(idCompressor, channel, nodeFactory, $this) {
    nodeFactory = nodeFactory === VOID ? RawNodeFactory_instance : nodeFactory;
    Json2OtChannelAdapter.call($this, idCompressor, null, null, null, channel, nodeFactory);
    return $this;
  }
  function Json2OtChannelAdapter_init_$Create$(idCompressor, channel, nodeFactory) {
    return Json2OtChannelAdapter_init_$Init$(idCompressor, channel, nodeFactory, objectCreate(protoOf(Json2OtChannelAdapter)));
  }
  function sendMessage($this, commandKind, id, additional) {
    var message = createMessage($this, commandKind, id.f55_1, id.g55_1, additional);
    $this.ssr_1.tsm(message);
  }
  function createMessage($this, commandKind, commandId, rootId, additional) {
    var message = new JsonArray();
    message.m2h(commandKind);
    Companion_instance_405.gsr(message, commandId, rootId);
    var inductionVariable = 0;
    var last = additional.length;
    while (inductionVariable < last) {
      var integer = additional[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      message.o2h(integer);
    }
    return message;
  }
  function sendLoadMessage($this, commandKind, commandId, additional) {
    var message = createMessage($this, commandKind, commandId.i55_1, commandId.m3w(), additional);
    if (!commandId.k55()) {
      message.m2h(commandId.p3w().q36_1);
    }
    $this.ssr_1.tsm(message);
  }
  function toMessage($this, rootIds) {
    var tmp;
    if (rootIds.p() === 1) {
      tmp = new JsonString(first_0(rootIds).q36_1);
    } else {
      var array = new JsonArray();
      var _iterator__ex2g4s = rootIds.m();
      while (_iterator__ex2g4s.n()) {
        var entityId = _iterator__ex2g4s.o();
        array.m2h(entityId.q36_1);
      }
      tmp = array;
    }
    return tmp;
  }
  function Companion_406() {
  }
  var Companion_instance_406;
  function Companion_getInstance_406() {
    return Companion_instance_406;
  }
  function Json2OtChannelAdapter$$inlined$entityOperationPersistenceContextFactory$1() {
  }
  protoOf(Json2OtChannelAdapter$$inlined$entityOperationPersistenceContextFactory$1).rsr = function (idCompressor, nodeFactory) {
    return EntityOperationPersistenceContext_init_$Create$(idCompressor, nodeFactory);
  };
  function Json2OtChannelAdapter$1() {
    JsonReconnectHelper.call(this);
  }
  protoOf(Json2OtChannelAdapter$1).wsr = function () {
    return new RootReconnectDataPersister();
  };
  function Json2OtChannelAdapter(idCompressor, commandSerializerFactory, persistenceContextFactory, reconnectHelper, channel, nodeFactory) {
    nodeFactory = nodeFactory === VOID ? RawNodeFactory_instance : nodeFactory;
    this.ssr_1 = channel;
    var serializerFactory = commandSerializerFactory;
    var contextFactory = persistenceContextFactory;
    if (contextFactory == null) {
      // Inline function 'jetbrains.ocelot.ot.model.ot.persistence.entity.operationContext.entityOperationPersistenceContextFactory' call
      contextFactory = new Json2OtChannelAdapter$$inlined$entityOperationPersistenceContextFactory$1();
    }
    var fullSerializerFactory = getFullSerializerFactory(Companion_instance_406);
    if (serializerFactory == null) {
      serializerFactory = fullSerializerFactory;
    }
    var tmp = this;
    var tmp_0;
    if (reconnectHelper == null) {
      tmp_0 = new Json2OtChannelAdapter$1();
    } else {
      tmp_0 = reconnectHelper;
    }
    tmp.vsr_1 = tmp_0;
    this.tsr_1 = serializerFactory.qsr(idCompressor, contextFactory, nodeFactory);
    this.usr_1 = fullSerializerFactory.qsr(idCompressor, contextFactory, nodeFactory);
  }
  protoOf(Json2OtChannelAdapter).nso = function (command) {
    var message = new JsonArray();
    message.m2h('cr');
    message.y2g(this.tsr_1.isr(command));
    this.ssr_1.tsm(message);
  };
  protoOf(Json2OtChannelAdapter).oso = function (id, baseVersion, resultVersion) {
    sendMessage(this, 'ca', id, new Int32Array([baseVersion, resultVersion]));
  };
  protoOf(Json2OtChannelAdapter).pso = function (id, reason) {
    sendMessage(this, 'cj', id, new Int32Array([reason.x2_1]));
  };
  protoOf(Json2OtChannelAdapter).qso = function (id) {
    sendMessage(this, 'rh', id, new Int32Array([]));
  };
  protoOf(Json2OtChannelAdapter).rso = function (id, rootsToLoad) {
    this.ssr_1.tsm(this.vsr_1.xsr(id, rootsToLoad));
  };
  protoOf(Json2OtChannelAdapter).sso = function (id) {
    sendMessage(this, 'ra', id, new Int32Array([]));
  };
  protoOf(Json2OtChannelAdapter).tso = function (id, reason) {
    sendLoadMessage(this, 'rr', id, new Int32Array([reason.x2_1]));
  };
  protoOf(Json2OtChannelAdapter).uso = function (id) {
    sendLoadMessage(this, 'lf', id, new Int32Array([]));
  };
  protoOf(Json2OtChannelAdapter).vso = function (id) {
    sendLoadMessage(this, 'lfa', id, new Int32Array([]));
  };
  protoOf(Json2OtChannelAdapter).wso = function (id, reason) {
    sendLoadMessage(this, 'lfr', id, new Int32Array([reason.x2_1]));
  };
  protoOf(Json2OtChannelAdapter).xso = function (id, from, to) {
    sendMessage(this, 'lh', id, new Int32Array([from, to]));
  };
  protoOf(Json2OtChannelAdapter).yso = function (id, history) {
    var message = new JsonArray();
    message.m2h('lha');
    Companion_instance_405.gsr(message, id.f55_1, id.g55_1);
    var commandsArray = new JsonArray();
    var _iterator__ex2g4s = history.m();
    while (_iterator__ex2g4s.n()) {
      var otOperationRecord = _iterator__ex2g4s.o();
      var operationJson = this.usr_1.isr(new Command(otOperationRecord.m55_1, otOperationRecord.o55_1, otOperationRecord.p55_1, otOperationRecord.n55_1));
      commandsArray.y2g(operationJson);
    }
    message.y2g(commandsArray);
    this.ssr_1.tsm(message);
  };
  protoOf(Json2OtChannelAdapter).zso = function (id, reason) {
    sendMessage(this, 'lhr', id, new Int32Array([reason.x2_1]));
  };
  protoOf(Json2OtChannelAdapter).asp = function (id, rootIds) {
    var message = new JsonArray();
    message.m2h('u');
    message.m2h(id.q36_1);
    message.y2g(toMessage(this, rootIds));
    this.ssr_1.tsm(message);
  };
  protoOf(Json2OtChannelAdapter).bsp = function (id, rootIds) {
    var message = new JsonArray();
    message.m2h('uh');
    message.m2h(id.q36_1);
    message.y2g(toMessage(this, rootIds));
    this.ssr_1.tsm(message);
  };
  protoOf(Json2OtChannelAdapter).csp = function (commandId) {
    sendMessage(this, 'sa', commandId, new Int32Array([]));
  };
  function toJson($this, data) {
    var array = new JsonArray();
    var persister = $this.wsr();
    var _iterator__ex2g4s = data.m();
    while (_iterator__ex2g4s.n()) {
      var d = _iterator__ex2g4s.o();
      array.y2g(persister.ass(d));
    }
    return array;
  }
  function readRootLoadData($this, array) {
    var data = ArrayList_init_$Create$();
    var persister = $this.wsr();
    var inductionVariable = 0;
    var last = array.x2g();
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        data.j(persister.n4r(array.r2h(i)));
      }
       while (inductionVariable < last);
    return data;
  }
  function Data(commandId, rootsToLoad) {
    this.bss_1 = commandId;
    this.css_1 = rootsToLoad;
  }
  function JsonReconnectHelper() {
  }
  protoOf(JsonReconnectHelper).xsr = function (commandId, rootsToLoad) {
    var json = new JsonArray();
    json.m2h('rc');
    json.m2h(commandId.q36_1);
    json.y2g(toJson(this, rootsToLoad));
    return json;
  };
  protoOf(JsonReconnectHelper).ysr = function (json) {
    var index = 1;
    var _unary__edvuaz = index;
    index = _unary__edvuaz + 1 | 0;
    var id = CommandId_init_$Create$_0(json.s2h(_unary__edvuaz));
    var rootsToLoad = readRootLoadData(this, json.r2h(index));
    return new Data(id, rootsToLoad);
  };
  function deserialize_2($this, json, parent) {
    if (json instanceof JsonString) {
      return createTreeElement($this, EntityId_init_$Create$_0(json.t2h_1), parent);
    }
    var i = (json instanceof JsonArray ? json : THROW_CCE()).m();
    var tmp = i.o();
    var element = createTreeElement($this, EntityId_init_$Create$_0((tmp instanceof JsonString ? tmp : THROW_CCE()).t2h_1), parent);
    while (i.n()) {
      deserialize_2($this, i.o(), element);
    }
    return element;
  }
  function createTreeElement($this, id, parent) {
    var tmp1_elvis_lhs = parent == null ? null : parent.ysn(id);
    return tmp1_elvis_lhs == null ? new LoadedEntitiesTreeElement(id) : tmp1_elvis_lhs;
  }
  function LoadedEntitiesTreeElementPersister() {
  }
  protoOf(LoadedEntitiesTreeElementPersister).dss = function (element) {
    if (element.q90()) {
      return new JsonString(element.qsn_1.q36_1);
    }
    var json = new JsonArray();
    json.m2h(element.qsn_1.q36_1);
    var _iterator__ex2g4s = ensureNotNull(element.iso()).m();
    while (_iterator__ex2g4s.n()) {
      var child = _iterator__ex2g4s.o();
      json.y2g(this.dss(child));
    }
    return json;
  };
  protoOf(LoadedEntitiesTreeElementPersister).ess = function (json) {
    return deserialize_2(this, json, null);
  };
  function Ot2JsonChannelAdapter_init_$Init$(idCompressor, channel, nodeFactory, $this) {
    nodeFactory = nodeFactory === VOID ? RawNodeFactory_instance : nodeFactory;
    Ot2JsonChannelAdapter.call($this, idCompressor, null, null, channel, nodeFactory);
    return $this;
  }
  function Ot2JsonChannelAdapter_init_$Create$(idCompressor, channel, nodeFactory) {
    return Ot2JsonChannelAdapter_init_$Init$(idCompressor, channel, nodeFactory, objectCreate(protoOf(Ot2JsonChannelAdapter)));
  }
  function getLoadingEntityId($this, json, pos) {
    return json.x2g() <= pos ? null : EntityId_init_$Create$_0(json.s2h(pos));
  }
  function connected($this) {
    return !($this.kss_1 == null);
  }
  function readEntityIds($this, json) {
    var tmp;
    if (json instanceof JsonArray) {
      var set = HashSet_init_$Create$();
      var inductionVariable = 0;
      var last = json.x2g();
      if (inductionVariable < last)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          set.j(EntityId_init_$Create$_0(json.s2h(i)));
        }
         while (inductionVariable < last);
      tmp = set;
    } else {
      tmp = setOf(EntityId_init_$Create$_0((json instanceof JsonString ? json : THROW_CCE()).t2h_1));
    }
    return tmp;
  }
  function readData($this, json) {
    var index = 1;
    var _unary__edvuaz = index;
    index = _unary__edvuaz + 1 | 0;
    var commandId = CommandId_init_$Create$_0(json.s2h(_unary__edvuaz));
    var _unary__edvuaz_0 = index;
    index = _unary__edvuaz_0 + 1 | 0;
    var rootId = EntityId_init_$Create$_0(json.s2h(_unary__edvuaz_0));
    return new MyRootCommandData(commandId, rootId, json.u2h(index));
  }
  function getRootCommandId($this, jsonCommand) {
    return Companion_instance_404.esr(jsonCommand, 1);
  }
  function getLoadCommandId($this, json) {
    var index = 1;
    var _unary__edvuaz = index;
    index = _unary__edvuaz + 1 | 0;
    var commandId = CommandId_init_$Create$_0(json.s2h(_unary__edvuaz));
    var _unary__edvuaz_0 = index;
    index = _unary__edvuaz_0 + 1 | 0;
    var rootId = EntityId_init_$Create$_0(json.s2h(_unary__edvuaz_0));
    var entityId = getLoadingEntityId($this, json, index);
    return LoadCommandId_init_$Create$_0(commandId, rootId, entityId);
  }
  function MyRootCommandData(commandId, rootId, value) {
    this.lss_1 = commandId;
    this.mss_1 = rootId;
    this.nss_1 = value;
  }
  protoOf(MyRootCommandData).oss = function () {
    return new RootCommandId(this.lss_1, this.mss_1);
  };
  protoOf(MyRootCommandData).pss = function () {
    return values()[this.nss_1];
  };
  function Ot2JsonChannelAdapter$persistenceContextFactory$$inlined$entityOperationPersistenceContextFactory$1() {
  }
  protoOf(Ot2JsonChannelAdapter$persistenceContextFactory$$inlined$entityOperationPersistenceContextFactory$1).rsr = function (idCompressor, nodeFactory) {
    return EntityOperationPersistenceContext_init_$Create$(idCompressor, nodeFactory);
  };
  function Ot2JsonChannelAdapter$reconnectHelper$1() {
    JsonReconnectHelper.call(this);
  }
  protoOf(Ot2JsonChannelAdapter$reconnectHelper$1).wsr = function () {
    return new RootReconnectDataPersister();
  };
  function Ot2JsonChannelAdapter(idCompressor, persistenceContextFactory, reconnectHelper, channel, nodeFactory) {
    nodeFactory = nodeFactory === VOID ? RawNodeFactory_instance : nodeFactory;
    this.fss_1 = idCompressor;
    this.gss_1 = channel;
    this.hss_1 = nodeFactory;
    var tmp = this;
    var tmp_0;
    if (persistenceContextFactory == null) {
      // Inline function 'jetbrains.ocelot.ot.model.ot.persistence.entity.operationContext.entityOperationPersistenceContextFactory' call
      tmp_0 = new Ot2JsonChannelAdapter$persistenceContextFactory$$inlined$entityOperationPersistenceContextFactory$1();
    } else {
      tmp_0 = persistenceContextFactory;
    }
    tmp.iss_1 = tmp_0;
    var tmp_1 = this;
    var tmp_2;
    if (reconnectHelper == null) {
      tmp_2 = new Ot2JsonChannelAdapter$reconnectHelper$1();
    } else {
      tmp_2 = reconnectHelper;
    }
    tmp_1.jss_1 = tmp_2;
    this.kss_1 = null;
  }
  protoOf(Ot2JsonChannelAdapter).qss = function () {
    // Inline function 'kotlin.check' call
    if (!!connected(this)) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    var tmp0_safe_receiver = this.fss_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.k2();
    }
    var context = this.iss_1.rsr(this.fss_1, this.hss_1);
    this.kss_1 = new CommandDeserializer(context);
  };
  protoOf(Ot2JsonChannelAdapter).vsm = function (message) {
    var op = message.s2h(0);
    switch (op) {
      case 'cr':
        this.gss_1.nso(ensureNotNull(this.kss_1).n4r(message.r2h(1)));
        break;
      case 'ca':
        this.gss_1.oso(getRootCommandId(this, message), message.u2h(3), message.u2h(4));
        break;
      case 'lfa':
        this.gss_1.vso(getLoadCommandId(this, message));
        break;
      case 'lfr':
        var data = readData(this, message);
        var entityId = getLoadingEntityId(this, message, 4);
        this.gss_1.wso(LoadCommandId_init_$Create$_0(data.lss_1, data.mss_1, entityId), data.pss());
        break;
      case 'lf':
        var rootCommandId = getRootCommandId(this, message);
        var entityId_0 = getLoadingEntityId(this, message, 3);
        this.gss_1.uso(LoadCommandId_init_$Create$_0(rootCommandId.f55_1, rootCommandId.g55_1, entityId_0));
        break;
      case 'lh':
        this.gss_1.xso(getRootCommandId(this, message), message.u2h(3), message.u2h(4));
        break;
      case 'lha':
        var commandsArray = message.r2h(3);
        var history = ArrayList_init_$Create$();
        var _iterator__ex2g4s = commandsArray.m();
        while (_iterator__ex2g4s.n()) {
          var commandJson = _iterator__ex2g4s.o();
          var tmp = ensureNotNull(this.kss_1);
          history.j(OtOperationRecord_init_$Create$(tmp.n4r(commandJson instanceof JsonArray ? commandJson : THROW_CCE())));
        }

        this.gss_1.yso(getRootCommandId(this, message), history);
        break;
      case 'lhr':
        var data_0 = readData(this, message);
        this.gss_1.zso(data_0.oss(), data_0.pss());
        break;
      case 'ra':
        this.gss_1.sso(getRootCommandId(this, message));
        break;
      case 'rr':
        var d = readData(this, message);
        var entityId_1 = getLoadingEntityId(this, message, 4);
        this.gss_1.tso(LoadCommandId_init_$Create$_0(d.lss_1, d.mss_1, entityId_1), d.pss());
        break;
      case 'rc':
        var d_0 = this.jss_1.ysr(message);
        this.gss_1.rso(d_0.bss_1, d_0.css_1);
        break;
      case 'uh':
        this.gss_1.bsp(CommandId_init_$Create$_0(message.s2h(1)), readEntityIds(this, message.r(2)));
        break;
      case 'u':
        this.gss_1.asp(CommandId_init_$Create$_0(message.s2h(1)), readEntityIds(this, message.r(2)));
        break;
      case 'cj':
        var d_1 = readData(this, message);
        this.gss_1.pso(d_1.oss(), d_1.pss());
        break;
      case 'rh':
        this.gss_1.qso(getRootCommandId(this, message));
        break;
      case 'sa':
        this.gss_1.csp(getRootCommandId(this, message));
        break;
      default:
        throw RuntimeException_init_$Create$_0(op);
    }
  };
  protoOf(Ot2JsonChannelAdapter).tsm = function (message) {
    return this.vsm(message instanceof JsonArray ? message : THROW_CCE());
  };
  protoOf(Ot2JsonChannelAdapter).zr = function () {
    ensureNotNull(this.kss_1).zr();
    this.kss_1 = null;
  };
  function RootReconnectDataPersister() {
    this.zsr_1 = new LoadedEntitiesTreeElementPersister();
  }
  protoOf(RootReconnectDataPersister).ass = function (data) {
    var json = new JsonArray();
    json.o2h(data.ssp_1);
    json.y2g(this.zsr_1.dss(data.rsp_1));
    return json;
  };
  protoOf(RootReconnectDataPersister).n4r = function (json) {
    var version = json.u2h(0);
    var treeElement = this.zsr_1.ess(json.r(1));
    return new RootReconnectData(treeElement, version);
  };
  function defaultClientIdCompressorSupplier() {
    return defaultClientIdCompressorSupplier$lambda;
  }
  function defaultClientIdCompressorSupplier$lambda() {
    return DefaultSelfUpdatingIdCompressor_init_$Create$();
  }
  function EndpointMultiplexPort$ServiceEndpointPort$setOutput$$inlined$stringChannel$1(this$0, $output, this$1) {
    this.rss_1 = this$0;
    this.sss_1 = $output;
    this.tss_1 = this$1;
  }
  protoOf(EndpointMultiplexPort$ServiceEndpointPort$setOutput$$inlined$stringChannel$1).xsm = function (message) {
    if (!(this.rss_1.cst_1.uv() === EndpointMultiplexPortState_CLOSED_getInstance())) {
      this.sss_1.tsm(new ServiceContainerMessage(this.tss_1.vss_1, this.tss_1.wss_1, message));
    }
    return Unit_instance;
  };
  protoOf(EndpointMultiplexPort$ServiceEndpointPort$setOutput$$inlined$stringChannel$1).tsm = function (message) {
    return this.xsm((!(message == null) ? typeof message === 'string' : false) ? message : THROW_CCE());
  };
  function EndpointMultiplexPort$Companion$LOG$lambda() {
    return Unit_instance;
  }
  function onServiceContainerMessage($this, message) {
    var serviceName = message.gst_1;
    if ('sercnt' === serviceName) {
      onSystemMessage($this, message.ist_1);
      return Unit_instance;
    }
    var port = $this.zss_1.q2(serviceName);
    $l$block: {
      // Inline function 'kotlin.checkNotNull' call
      if (port == null) {
        var message_0 = 'No port for service ' + serviceName;
        throw IllegalStateException_init_$Create$_0(toString_1(message_0));
      } else {
        break $l$block;
      }
    }
    if (!(message.hst_1 === port.wss_1)) {
      var tmp = Companion_getInstance_407().jst_1;
      tmp.c2q(EndpointMultiplexPort$onServiceContainerMessage$lambda(port, message));
    }
    port.ysm().tsm(message.ist_1);
  }
  function onSystemMessage($this, rawMessage) {
    var systemMessage;
    try {
      systemMessage = ServiceContainerMessageUtil_instance.kst(rawMessage);
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        handle_1($this, e);
        return Unit_instance;
      } else {
        throw $p;
      }
    }
    var serviceAndPort = systemMessage.nst();
    switch (systemMessage.lst_1) {
      case 'cl':
        if (serviceAndPort == null) {
          handle_1($this, IllegalArgumentException_init_$Create$_0('Wrong close port message format: ' + rawMessage));
          return Unit_instance;
        }

        onSystemClosePortMessage($this, serviceAndPort.pg_1, serviceAndPort.qg_1);
        break;
      case 'op':
        if (serviceAndPort == null) {
          handle_1($this, IllegalArgumentException_init_$Create$_0('Wrong open port message format: ' + rawMessage));
          return Unit_instance;
        }

        onSystemOpenPortMessage($this, serviceAndPort.pg_1, serviceAndPort.qg_1);
        break;
      case 'cfg':
        var payload = systemMessage.mst_1;
        var tmp = Json_getInstance().z2g(payload);
        var json = tmp instanceof JsonObject ? tmp : THROW_CCE();
        var configurationPersister = new ConfigurationPersister($this.yss_1.ost_1);
        var configuration = configurationPersister.w3c(json);
        onSystemConfigurationMessage($this, configuration);
        break;
      default:
        handle_1($this, IllegalArgumentException_init_$Create$_0('Unexpected action type=' + systemMessage.lst_1 + ', message=' + rawMessage));
        break;
    }
  }
  function onSystemConfigurationMessage($this, configuration) {
    var tmp0 = $this.ast_1;
    $l$block: {
      // Inline function 'kotlin.checkNotNull' call
      if (tmp0 == null) {
        var message = 'Output is null';
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      } else {
        break $l$block;
      }
    }
    $this.yss_1.ust(configuration);
    doSendMessage($this, ServiceContainerConstants_instance.csu($this.yss_1.vst().r2()));
  }
  function onSystemOpenPortMessage($this, serviceName, portId) {
    var service = $this.yss_1.vst().q2(serviceName);
    if (service == null) {
      handle_1($this, IllegalArgumentException_init_$Create$_0('Unknown service ' + serviceName));
      return Unit_instance;
    }
    var port = null;
    if (portId < 0) {
      handle_1($this, IllegalArgumentException_init_$Create$_0('Received incorrect port id ' + portId));
      return Unit_instance;
    }
    if (!$this.zss_1.o2(serviceName)) {
      port = new ServiceEndpointPort($this, service.esn(), serviceName, portId);
      var tmp0 = $this.zss_1;
      // Inline function 'kotlin.collections.set' call
      var value = port;
      tmp0.t2(serviceName, value);
    }
    if (port == null) {
      handle_1($this, IllegalStateException_init_$Create$_0('Port for service ' + serviceName + ' is already opened'));
      return Unit_instance;
    }
    port.dsu(outputChannel($this), ensureNotNull($this.bst_1));
    var tmp = Companion_getInstance_407().jst_1;
    tmp.a2q(EndpointMultiplexPort$onSystemOpenPortMessage$lambda(serviceName));
  }
  function onSystemClosePortMessage($this, serviceName, portId) {
    var port = $this.zss_1.u2(serviceName);
    if (port == null) {
      handle_1($this, RuntimeException_init_$Create$_0('No port to close for service ' + serviceName));
      return Unit_instance;
    }
    if (!(port.wss_1 === portId)) {
      var tmp = Companion_getInstance_407().jst_1;
      tmp.f2q(EndpointMultiplexPort$onSystemClosePortMessage$lambda(port, portId, serviceName));
    }
    port.zr();
    var tmp_0 = Companion_getInstance_407().jst_1;
    tmp_0.a2q(EndpointMultiplexPort$onSystemClosePortMessage$lambda_0(serviceName));
  }
  function handle_1($this, t) {
    var errorHandler = $this.bst_1;
    if (errorHandler == null) {
      var tmp = Companion_getInstance_407().jst_1;
      tmp.e2q(t, EndpointMultiplexPort$handle$lambda);
    } else {
      errorHandler(t);
    }
  }
  function outputChannel($this) {
    // Inline function 'jetbrains.ocelot.ot.model.protocol.service.serviceContainerChannel' call
    return new EndpointMultiplexPort$outputChannel$$inlined$serviceContainerChannel$1($this);
  }
  function doSendMessage($this, message) {
    if ($this.ast_1 == null) {
      return Unit_instance;
    }
    try {
      ensureNotNull($this.ast_1).tsm(message);
    } catch ($p) {
      if ($p instanceof Error) {
        var t = $p;
        handle_1($this, t);
      } else {
        throw $p;
      }
    }
  }
  function ServiceEndpointPort($outer, port, serviceName, id) {
    this.xss_1 = $outer;
    this.uss_1 = port;
    this.vss_1 = serviceName;
    this.wss_1 = id;
  }
  protoOf(ServiceEndpointPort).ysm = function () {
    return this.uss_1.ysm();
  };
  protoOf(ServiceEndpointPort).zr = function () {
    return this.uss_1.zr();
  };
  protoOf(ServiceEndpointPort).dsu = function (output, internalErrorHandler) {
    // Inline function 'jetbrains.ocelot.ot.commons.protocol.stringChannel' call
    var tmp$ret$0 = new EndpointMultiplexPort$ServiceEndpointPort$setOutput$$inlined$stringChannel$1(this.xss_1, output, this);
    this.uss_1.csn(tmp$ret$0, internalErrorHandler);
  };
  protoOf(ServiceEndpointPort).csn = function (output, internalErrorHandler) {
    return this.dsu((!(output == null) ? isInterface(output, ServiceContainerChannel) : false) ? output : THROW_CCE(), internalErrorHandler);
  };
  function Companion_407() {
    Companion_instance_407 = this;
    var tmp = this;
    var tmp_0 = KotlinLogging_getInstance();
    tmp.jst_1 = tmp_0.i2q(EndpointMultiplexPort$Companion$LOG$lambda);
  }
  var Companion_instance_407;
  function Companion_getInstance_407() {
    if (Companion_instance_407 == null)
      new Companion_407();
    return Companion_instance_407;
  }
  function EndpointMultiplexPort$input$$inlined$serviceContainerChannel$1(this$0) {
    this.esu_1 = this$0;
  }
  protoOf(EndpointMultiplexPort$input$$inlined$serviceContainerChannel$1).fsu = function (message) {
    var this_0 = this.esu_1;
    onServiceContainerMessage(this_0, message);
    return Unit_instance;
  };
  protoOf(EndpointMultiplexPort$input$$inlined$serviceContainerChannel$1).tsm = function (message) {
    return this.fsu(message instanceof ServiceContainerMessage ? message : THROW_CCE());
  };
  function EndpointMultiplexPort$onServiceContainerMessage$lambda($port, $message) {
    return function () {
      return 'Message with incorrect portId received. Expected: ' + $port.wss_1 + '. Actual: ' + $message.hst_1 + ". Message: '" + $message.toString() + "'";
    };
  }
  function EndpointMultiplexPort$onSystemOpenPortMessage$lambda($serviceName) {
    return function () {
      return 'Port opened for service ' + $serviceName;
    };
  }
  function EndpointMultiplexPort$onSystemClosePortMessage$lambda($port, $portId, $serviceName) {
    return function () {
      return 'Receive close port message with incorrect port id. Expected ' + $port.wss_1 + ', actual ' + $portId + ". Service is '" + $serviceName + "'";
    };
  }
  function EndpointMultiplexPort$onSystemClosePortMessage$lambda_0($serviceName) {
    return function () {
      return 'Port closed for service ' + $serviceName;
    };
  }
  function EndpointMultiplexPort$handle$lambda() {
    return 'Exception happened';
  }
  function EndpointMultiplexPort$outputChannel$$inlined$serviceContainerChannel$1(this$0) {
    this.gsu_1 = this$0;
  }
  protoOf(EndpointMultiplexPort$outputChannel$$inlined$serviceContainerChannel$1).fsu = function (message) {
    var this_0 = this.gsu_1;
    doSendMessage(this_0, message);
    return Unit_instance;
  };
  protoOf(EndpointMultiplexPort$outputChannel$$inlined$serviceContainerChannel$1).tsm = function (message) {
    return this.fsu(message instanceof ServiceContainerMessage ? message : THROW_CCE());
  };
  function EndpointMultiplexPort(container) {
    Companion_getInstance_407();
    this.yss_1 = container;
    this.zss_1 = newConcurrentHashMap();
    this.ast_1 = null;
    this.bst_1 = null;
    this.cst_1 = new SynchronizedAtomicReference(EndpointMultiplexPortState_INIT_getInstance());
    var tmp = this;
    // Inline function 'jetbrains.ocelot.ot.model.protocol.service.serviceContainerChannel' call
    tmp.dst_1 = new EndpointMultiplexPort$input$$inlined$serviceContainerChannel$1(this);
  }
  protoOf(EndpointMultiplexPort).ysm = function () {
    return this.dst_1;
  };
  protoOf(EndpointMultiplexPort).dsu = function (output, internalErrorHandler) {
    // Inline function 'kotlin.check' call
    if (!this.cst_1.hsu(EndpointMultiplexPortState_INIT_getInstance(), EndpointMultiplexPortState_OPENING_getInstance())) {
      var message = 'Cannot set output for multiplex endpoint port in state ' + toString_1(this.cst_1);
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    this.ast_1 = output;
    this.bst_1 = internalErrorHandler;
    // Inline function 'kotlin.check' call
    if (!this.cst_1.hsu(EndpointMultiplexPortState_OPENING_getInstance(), EndpointMultiplexPortState_OPENED_getInstance())) {
      var message_0 = 'Cannot set output for multiplex endpoint port in state ' + toString_1(this.cst_1);
      throw IllegalStateException_init_$Create$_0(toString_1(message_0));
    }
  };
  protoOf(EndpointMultiplexPort).csn = function (output, internalErrorHandler) {
    return this.dsu((!(output == null) ? isInterface(output, ServiceContainerChannel) : false) ? output : THROW_CCE(), internalErrorHandler);
  };
  protoOf(EndpointMultiplexPort).zr = function () {
    // Inline function 'kotlin.check' call
    if (!!(this.cst_1.isu(EndpointMultiplexPortState_CLOSED_getInstance()) === EndpointMultiplexPortState_CLOSED_getInstance())) {
      var message = 'The port is already disposed';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    var _iterator__ex2g4s = this.zss_1.s2().m();
    while (_iterator__ex2g4s.n()) {
      var port = _iterator__ex2g4s.o();
      port.zr();
    }
    this.ast_1 = null;
    this.bst_1 = null;
    this.yss_1.jsu();
  };
  var EndpointMultiplexPortState_INIT_instance;
  var EndpointMultiplexPortState_OPENING_instance;
  var EndpointMultiplexPortState_OPENED_instance;
  var EndpointMultiplexPortState_CLOSED_instance;
  var EndpointMultiplexPortState_entriesInitialized;
  function EndpointMultiplexPortState_initEntries() {
    if (EndpointMultiplexPortState_entriesInitialized)
      return Unit_instance;
    EndpointMultiplexPortState_entriesInitialized = true;
    EndpointMultiplexPortState_INIT_instance = new EndpointMultiplexPortState('INIT', 0);
    EndpointMultiplexPortState_OPENING_instance = new EndpointMultiplexPortState('OPENING', 1);
    EndpointMultiplexPortState_OPENED_instance = new EndpointMultiplexPortState('OPENED', 2);
    EndpointMultiplexPortState_CLOSED_instance = new EndpointMultiplexPortState('CLOSED', 3);
  }
  function EndpointMultiplexPortState(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function EndpointMultiplexPortState_INIT_getInstance() {
    EndpointMultiplexPortState_initEntries();
    return EndpointMultiplexPortState_INIT_instance;
  }
  function EndpointMultiplexPortState_OPENING_getInstance() {
    EndpointMultiplexPortState_initEntries();
    return EndpointMultiplexPortState_OPENING_instance;
  }
  function EndpointMultiplexPortState_OPENED_getInstance() {
    EndpointMultiplexPortState_initEntries();
    return EndpointMultiplexPortState_OPENED_instance;
  }
  function EndpointMultiplexPortState_CLOSED_getInstance() {
    EndpointMultiplexPortState_initEntries();
    return EndpointMultiplexPortState_CLOSED_instance;
  }
  function FatalEndpointException_init_$Init$($this) {
    RuntimeException_init_$Init$($this);
    FatalEndpointException.call($this);
    return $this;
  }
  function FatalEndpointException_init_$Create$() {
    var tmp = FatalEndpointException_init_$Init$(objectCreate(protoOf(FatalEndpointException)));
    captureStack(tmp, FatalEndpointException_init_$Create$);
    return tmp;
  }
  function FatalEndpointException_init_$Init$_0(message, cause, $this) {
    RuntimeException_init_$Init$_1(message, cause, $this);
    FatalEndpointException.call($this);
    return $this;
  }
  function FatalEndpointException_init_$Create$_0(message, cause) {
    var tmp = FatalEndpointException_init_$Init$_0(message, cause, objectCreate(protoOf(FatalEndpointException)));
    captureStack(tmp, FatalEndpointException_init_$Create$_0);
    return tmp;
  }
  function FatalEndpointException() {
    captureStack(this, FatalEndpointException);
  }
  function getSource_0($this) {
    if ($this.msu_1 == null) {
      $this.msu_1 = $this.ksu_1();
    }
    return ensureNotNull($this.msu_1);
  }
  function sam$jetbrains_ocelot_base_edt_EdtTask$0_19(function_0) {
    this.nsu_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_19).au = function () {
    return this.nsu_1();
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_19).f3 = function () {
    return this.nsu_1;
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_19).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, EdtTask) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_19).hashCode = function () {
    return hashCode(this.f3());
  };
  function JsonPortExecutingDelegate$JsonChannelExecutingDelegate$messageReceived$lambda(this$0, $message) {
    return function () {
      getSource_0(this$0).tsm($message);
      return Unit_instance;
    };
  }
  function JsonChannelExecutingDelegate(sourceSupplier, edt) {
    this.ksu_1 = sourceSupplier;
    this.lsu_1 = edt;
    this.msu_1 = null;
  }
  protoOf(JsonChannelExecutingDelegate).vsm = function (message) {
    var tmp = JsonPortExecutingDelegate$JsonChannelExecutingDelegate$messageReceived$lambda(this, message);
    this.lsu_1.u39(new sam$jetbrains_ocelot_base_edt_EdtTask$0_19(tmp));
  };
  protoOf(JsonChannelExecutingDelegate).tsm = function (message) {
    return this.vsm(message instanceof JsonArray ? message : THROW_CCE());
  };
  function JsonPortExecutingDelegate$setOutput$$inlined$jsonChannel$1(this$0, $output) {
    this.osu_1 = this$0;
    this.psu_1 = $output;
  }
  protoOf(JsonPortExecutingDelegate$setOutput$$inlined$jsonChannel$1).vsm = function (message) {
    if (!this.osu_1.wsu_1) {
      this.psu_1.tsm(message);
    }
    return Unit_instance;
  };
  protoOf(JsonPortExecutingDelegate$setOutput$$inlined$jsonChannel$1).tsm = function (message) {
    return this.vsm(message instanceof JsonArray ? message : THROW_CCE());
  };
  function JsonPortExecutingDelegate(portSupplier, edt) {
    PortExecutingDelegate.call(this, portSupplier, edt);
    this.wsu_1 = false;
  }
  protoOf(JsonPortExecutingDelegate).msq = function (channelSupplier) {
    return new JsonChannelExecutingDelegate(channelSupplier, this.fsp_1);
  };
  protoOf(JsonPortExecutingDelegate).lsp = function (channelSupplier) {
    return this.msq(channelSupplier);
  };
  protoOf(JsonPortExecutingDelegate).xsu = function (output, internalErrorHandler) {
    // Inline function 'jetbrains.ocelot.ot.commons.protocol.json.jsonChannel' call
    var outputJsonChannel = new JsonPortExecutingDelegate$setOutput$$inlined$jsonChannel$1(this, output);
    protoOf(PortExecutingDelegate).nsp.call(this, outputJsonChannel, internalErrorHandler);
  };
  protoOf(JsonPortExecutingDelegate).csn = function (output, internalErrorHandler) {
    return this.xsu((!(output == null) ? isInterface(output, JsonChannel) : false) ? output : THROW_CCE(), internalErrorHandler);
  };
  protoOf(JsonPortExecutingDelegate).nsp = function (output, internalErrorHandler) {
    return this.xsu((!(output == null) ? isInterface(output, JsonChannel) : false) ? output : THROW_CCE(), internalErrorHandler);
  };
  protoOf(JsonPortExecutingDelegate).zr = function () {
    this.wsu_1 = true;
    protoOf(PortExecutingDelegate).zr.call(this);
  };
  function PingPongServiceConstants() {
    this.ysu_1 = 'pp';
  }
  var PingPongServiceConstants_instance;
  function PingPongServiceConstants_getInstance() {
    return PingPongServiceConstants_instance;
  }
  function PingPongServiceEndpoint$MyPort$_get_input_$o$messageReceived$lambda_a96ayw() {
    return 'Receive pong';
  }
  function sam$jetbrains_ocelot_base_edt_EdtTask$0_20(function_0) {
    this.zsu_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_20).au = function () {
    return this.zsu_1();
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_20).f3 = function () {
    return this.zsu_1;
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_20).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, EdtTask) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_20).hashCode = function () {
    return hashCode(this.f3());
  };
  function PingPongServiceEndpoint$MyPort$input$$inlined$jsonChannel$1(this$0) {
    this.asv_1 = this$0;
  }
  protoOf(PingPongServiceEndpoint$MyPort$input$$inlined$jsonChannel$1).vsm = function (message) {
    if (!(message == null)) {
      var tmp = Companion_getInstance_408().bsv_1;
      tmp.x2p(PingPongServiceEndpoint$MyPort$_get_input_$o$messageReceived$lambda_a96ayw);
      this.asv_1.csv_1 = false;
    }
    return Unit_instance;
  };
  protoOf(PingPongServiceEndpoint$MyPort$input$$inlined$jsonChannel$1).tsm = function (message) {
    return this.vsm(message instanceof JsonArray ? message : THROW_CCE());
  };
  function PingPongServiceEndpoint$MyPort$setOutput$lambda$lambda() {
    return 'Sending ping';
  }
  function PingPongServiceEndpoint$MyPort$setOutput$lambda(this$0, $output) {
    return function () {
      var tmp;
      if (!this$0.csv_1) {
        var tmp_0 = Companion_getInstance_408().bsv_1;
        tmp_0.x2p(PingPongServiceEndpoint$MyPort$setOutput$lambda$lambda);
        this$0.csv_1 = true;
        $output.tsm(new JsonArray());
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function PingPongServiceEndpoint$Companion$LOG$lambda() {
    return Unit_instance;
  }
  function MyPort($outer) {
    this.fsv_1 = $outer;
    this.csv_1 = false;
    this.dsv_1 = false;
    this.esv_1 = Companion_getInstance_29().m2l_1;
  }
  protoOf(MyPort).ysm = function () {
    // Inline function 'jetbrains.ocelot.ot.commons.protocol.json.jsonChannel' call
    return new PingPongServiceEndpoint$MyPort$input$$inlined$jsonChannel$1(this);
  };
  protoOf(MyPort).xsu = function (output, internalErrorHandler) {
    if (this.dsv_1) {
      throw IllegalStateException_init_$Create$_0('Port is already connected');
    }
    this.dsv_1 = true;
    var tmp = this;
    var tmp_0 = convertToInt(this.fsv_1.hsv_1);
    var tmp_1 = PingPongServiceEndpoint$MyPort$setOutput$lambda(this, output);
    tmp.esv_1 = this.fsv_1.gsv_1.w39(tmp_0, new sam$jetbrains_ocelot_base_edt_EdtTask$0_20(tmp_1));
  };
  protoOf(MyPort).csn = function (output, internalErrorHandler) {
    return this.xsu((!(output == null) ? isInterface(output, JsonChannel) : false) ? output : THROW_CCE(), internalErrorHandler);
  };
  protoOf(MyPort).zr = function () {
    this.fsv_1.isv_1 = false;
    this.esv_1.zr();
  };
  function Companion_408() {
    Companion_instance_408 = this;
    var tmp = this;
    var tmp_0 = KotlinLogging_getInstance();
    tmp.bsv_1 = tmp_0.i2q(PingPongServiceEndpoint$Companion$LOG$lambda);
  }
  var Companion_instance_408;
  function Companion_getInstance_408() {
    if (Companion_instance_408 == null)
      new Companion_408();
    return Companion_instance_408;
  }
  function PingPongServiceEndpoint(edt, periodMs) {
    Companion_getInstance_408();
    JsonServiceEndpoint.call(this);
    this.gsv_1 = edt;
    this.hsv_1 = periodMs;
    this.isv_1 = false;
  }
  protoOf(PingPongServiceEndpoint).gsn = function () {
    return PingPongServiceConstants_instance.ysu_1;
  };
  protoOf(PingPongServiceEndpoint).fsn = function () {
    if (this.isv_1) {
      throw IllegalArgumentException_init_$Create$_0('Port is already opened');
    }
    this.isv_1 = true;
    return new MyPort(this);
  };
  protoOf(PingPongServiceEndpoint).zr = function () {
  };
  function ServiceContainerChannel() {
  }
  function ServiceContainerConstants() {
    this.wst_1 = 'sercnt';
    this.xst_1 = 'op';
    this.yst_1 = 'cl';
    this.zst_1 = 'cfg';
    this.asu_1 = 'sl';
    this.bsu_1 = ':';
  }
  protoOf(ServiceContainerConstants).jsv = function (name) {
    // Inline function 'kotlin.require' call
    if (!!('sercnt' === name)) {
      var message = 'Service cannot have short name sercnt. The name is reserved';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
  };
  protoOf(ServiceContainerConstants).csu = function (serviceNames) {
    var serviceNamesString = joinToString_0(serviceNames, ':');
    var payload = StringBuilder_init_$Create$_1().j8('sl').j8(':').j8(serviceNamesString).toString();
    return new ServiceContainerMessage('sercnt', 0, payload);
  };
  var ServiceContainerConstants_instance;
  function ServiceContainerConstants_getInstance() {
    return ServiceContainerConstants_instance;
  }
  function ServiceContainerMessage(serviceName, portId, payload) {
    this.gst_1 = serviceName;
    this.hst_1 = portId;
    this.ist_1 = payload;
  }
  protoOf(ServiceContainerMessage).toString = function () {
    return 'ServiceContainerMessage(serviceName=' + this.gst_1 + ', portId=' + this.hst_1 + ', payload=' + this.ist_1 + ')';
  };
  protoOf(ServiceContainerMessage).hashCode = function () {
    var result = getStringHashCode(this.gst_1);
    result = imul(result, 31) + this.hst_1 | 0;
    result = imul(result, 31) + getStringHashCode(this.ist_1) | 0;
    return result;
  };
  protoOf(ServiceContainerMessage).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ServiceContainerMessage))
      return false;
    if (!(this.gst_1 === other.gst_1))
      return false;
    if (!(this.hst_1 === other.hst_1))
      return false;
    if (!(this.ist_1 === other.ist_1))
      return false;
    return true;
  };
  function ServiceContainerMessagePersister() {
  }
  protoOf(ServiceContainerMessagePersister).v24 = function (value) {
    // Inline function 'kotlin.text.toRegex' call
    // Inline function 'kotlin.text.split' call
    // Inline function 'kotlin.collections.toTypedArray' call
    var this_0 = Regex_init_$Create$(':').id(value, 3);
    var parts = copyToArray(this_0);
    // Inline function 'kotlin.require' call
    if (!(parts.length === 3)) {
      var message = 'Wrong ServiceContainerMessage format: ' + value;
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    return new ServiceContainerMessage(parts[0], toInt(parts[1]), parts[2]);
  };
  protoOf(ServiceContainerMessagePersister).ksv = function (value) {
    return StringBuilder_init_$Create$_1().j8(value.gst_1).j8(':').gc(value.hst_1).j8(':').j8(value.ist_1).toString();
  };
  protoOf(ServiceContainerMessagePersister).w24 = function (value) {
    return this.ksv(value instanceof ServiceContainerMessage ? value : THROW_CCE());
  };
  function ServiceContainerMessageUtil() {
  }
  protoOf(ServiceContainerMessageUtil).kst = function (rawMessage) {
    // Inline function 'kotlin.text.toRegex' call
    // Inline function 'kotlin.text.split' call
    // Inline function 'kotlin.collections.toTypedArray' call
    var this_0 = Regex_init_$Create$(':').id(rawMessage, 2);
    var parts = copyToArray(this_0);
    // Inline function 'kotlin.require' call
    if (!(parts.length === 2)) {
      var message = 'Wrong container message format: ' + rawMessage;
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    return new ServiceContainerSystemMessage(parts[0], parts[1]);
  };
  var ServiceContainerMessageUtil_instance;
  function ServiceContainerMessageUtil_getInstance() {
    return ServiceContainerMessageUtil_instance;
  }
  function ServiceContainerSystemMessage(actionType, payload) {
    this.lst_1 = actionType;
    this.mst_1 = payload;
  }
  protoOf(ServiceContainerSystemMessage).nst = function () {
    var tmp0 = this.mst_1;
    // Inline function 'kotlin.text.toRegex' call
    // Inline function 'kotlin.text.split' call
    var tmp0_0 = Regex_init_$Create$(':').id(tmp0, 0);
    var tmp$ret$4;
    $l$block: {
      // Inline function 'kotlin.collections.dropLastWhile' call
      if (!tmp0_0.s()) {
        var iterator = tmp0_0.u(tmp0_0.p());
        while (iterator.r4()) {
          // Inline function 'kotlin.text.isEmpty' call
          var this_0 = iterator.t4();
          if (!(charSequenceLength(this_0) === 0)) {
            tmp$ret$4 = take(tmp0_0, iterator.s4() + 1 | 0);
            break $l$block;
          }
        }
      }
      tmp$ret$4 = emptyList();
    }
    // Inline function 'kotlin.collections.toTypedArray' call
    var this_1 = tmp$ret$4;
    var parts = copyToArray(this_1);
    if (!(parts.length === 2)) {
      return null;
    }
    var tmp;
    try {
      tmp = new Pair(parts[0], toInt(parts[1]));
    } catch ($p) {
      var tmp_0;
      if ($p instanceof NumberFormatException) {
        var e = $p;
        tmp_0 = null;
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  function ServiceEndpointContainer$Companion$LOG$lambda() {
    return Unit_instance;
  }
  function initConfigurableServices($this, protocolConfiguration) {
    var _iterator__ex2g4s = $this.rst_1.m();
    while (_iterator__ex2g4s.n()) {
      var configurationService = _iterator__ex2g4s.o();
      var serviceEndpoint = configurationService.lsv(protocolConfiguration);
      if (serviceEndpoint == null) {
        var tmp = Companion_getInstance_409().nsv_1;
        tmp.x2p(ServiceEndpointContainer$initConfigurableServices$lambda(configurationService));
      } else {
        $this.msv(serviceEndpoint);
      }
    }
  }
  function Companion_409() {
    Companion_instance_409 = this;
    var tmp = this;
    var tmp_0 = KotlinLogging_getInstance();
    tmp.nsv_1 = tmp_0.i2q(ServiceEndpointContainer$Companion$LOG$lambda);
  }
  var Companion_instance_409;
  function Companion_getInstance_409() {
    if (Companion_instance_409 == null)
      new Companion_409();
    return Companion_instance_409;
  }
  function ServiceEndpointContainer$addConfigurableService$configurableService$1($serviceEndpointFunction) {
    this.osv_1 = $serviceEndpointFunction;
  }
  protoOf(ServiceEndpointContainer$addConfigurableService$configurableService$1).lsv = function (configuration) {
    return this.osv_1(configuration);
  };
  function ServiceEndpointContainer$initConfigurableServices$lambda($configurationService) {
    return function () {
      return 'Service endpoint from ' + toString_1($configurationService) + " hasn't been initialized";
    };
  }
  function ServiceEndpointContainer$checkConfiguration$lambda($otVersion) {
    return function () {
      return 'OT version is ' + $otVersion;
    };
  }
  function ServiceEndpointContainer(configContext) {
    Companion_getInstance_409();
    configContext = configContext === VOID ? new ProtocolPersistentContext() : configContext;
    this.ost_1 = configContext;
    this.pst_1 = new ValueProperty(null);
    this.qst_1 = newConcurrentHashMap();
    this.rst_1 = newConcurrentHashSet();
    this.sst_1 = newAtomicBoolean(false);
    this.tst_1 = new SynchronizedAtomicReference(ServiceEndpointContainerState_INIT_getInstance());
  }
  protoOf(ServiceEndpointContainer).vst = function () {
    return this.qst_1;
  };
  protoOf(ServiceEndpointContainer).msv = function (service) {
    var name = service.gsn();
    // Inline function 'kotlin.text.isNotEmpty' call
    // Inline function 'kotlin.check' call
    if (!(charSequenceLength(name) > 0)) {
      var message = 'No name for service ' + toString_1(service);
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    var state = this.tst_1.uv();
    // Inline function 'kotlin.check' call
    if (!(state === ServiceEndpointContainerState_INIT_getInstance() || state === ServiceEndpointContainerState_CONFIGURING_getInstance())) {
      var message_0 = 'Cannot add service ' + name + ' to ServiceEndpointContainer in state ' + state.toString();
      throw IllegalStateException_init_$Create$_0(toString_1(message_0));
    }
    ServiceContainerConstants_instance.jsv(name);
    var prevEndpoint = this.qst_1.t2(name, service);
    // Inline function 'kotlin.check' call
    if (!(prevEndpoint == null)) {
      var message_1 = "Service '" + name + "' has already been added";
      throw IllegalStateException_init_$Create$_0(toString_1(message_1));
    }
  };
  protoOf(ServiceEndpointContainer).psv = function (serviceEndpointFunction) {
    var state = this.tst_1.uv();
    // Inline function 'kotlin.check' call
    if (!(state === ServiceEndpointContainerState_INIT_getInstance())) {
      var message = 'Cannot add configurable service to ServiceEndpointContainer in state ' + state.toString();
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    var configurableService = new ServiceEndpointContainer$addConfigurableService$configurableService$1(serviceEndpointFunction);
    this.rst_1.j(configurableService);
  };
  protoOf(ServiceEndpointContainer).esn = function () {
    // Inline function 'kotlin.check' call
    if (!!(this.tst_1.uv() === ServiceEndpointContainerState_CLOSED_getInstance())) {
      var message = "Can't open port for closed ServiceEndpointContainer";
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    var successful = this.sst_1.y2o(false, true);
    // Inline function 'kotlin.check' call
    if (!successful) {
      var message_0 = 'The port is already opened';
      throw IllegalStateException_init_$Create$_0(toString_1(message_0));
    }
    return new EndpointMultiplexPort(this);
  };
  protoOf(ServiceEndpointContainer).zr = function () {
    var prevState = this.tst_1.isu(ServiceEndpointContainerState_CLOSED_getInstance());
    // Inline function 'kotlin.check' call
    if (!!(prevState === ServiceEndpointContainerState_CLOSED_getInstance())) {
      var message = 'ServiceEndpointContainer is already disposed';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    var _iterator__ex2g4s = this.qst_1.s2().m();
    while (_iterator__ex2g4s.n()) {
      var serviceEndpoint = _iterator__ex2g4s.o();
      serviceEndpoint.zr();
    }
  };
  protoOf(ServiceEndpointContainer).qsv = function (configuration) {
    var otVersion = configuration.j3c(ProtocolParameters_getInstance().dsr_1);
    if (!('6' === otVersion)) {
      throw VersionMismatchException_init_$Create$_0(otVersion);
    }
    var tmp = Companion_getInstance_409().nsv_1;
    tmp.a2q(ServiceEndpointContainer$checkConfiguration$lambda(otVersion));
  };
  protoOf(ServiceEndpointContainer).ust = function (configuration) {
    this.qsv(configuration);
    if (this.tst_1.hsu(ServiceEndpointContainerState_INIT_getInstance(), ServiceEndpointContainerState_CONFIGURING_getInstance())) {
      initConfigurableServices(this, configuration);
      this.pst_1.d2x(configuration);
    } else if (this.tst_1.hsu(ServiceEndpointContainerState_CONFIGURED_getInstance(), ServiceEndpointContainerState_CONFIGURING_getInstance())) {
      var currentConfig = ensureNotNull(this.pst_1.uv());
      var parameter = currentConfig.n3c(configuration);
      // Inline function 'kotlin.check' call
      if (!(parameter == null)) {
        var message = 'Received different configuration (differs in key ' + parameter + '). ' + 'Initial value: ' + currentConfig.j3c(ensureNotNull(parameter)) + '. New value: ' + toString_0(configuration.j3c(parameter));
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      }
    } else
      throw IllegalStateException_init_$Create$_0('Endpoint container in state ' + this.tst_1.uv().toString() + " can't be configured");
    this.tst_1.rsv(ServiceEndpointContainerState_CONFIGURED_getInstance());
  };
  protoOf(ServiceEndpointContainer).jsu = function () {
    return this.sst_1.z2o(false);
  };
  var ServiceEndpointContainerState_INIT_instance;
  var ServiceEndpointContainerState_CONFIGURING_instance;
  var ServiceEndpointContainerState_CONFIGURED_instance;
  var ServiceEndpointContainerState_CLOSED_instance;
  var ServiceEndpointContainerState_entriesInitialized;
  function ServiceEndpointContainerState_initEntries() {
    if (ServiceEndpointContainerState_entriesInitialized)
      return Unit_instance;
    ServiceEndpointContainerState_entriesInitialized = true;
    ServiceEndpointContainerState_INIT_instance = new ServiceEndpointContainerState('INIT', 0);
    ServiceEndpointContainerState_CONFIGURING_instance = new ServiceEndpointContainerState('CONFIGURING', 1);
    ServiceEndpointContainerState_CONFIGURED_instance = new ServiceEndpointContainerState('CONFIGURED', 2);
    ServiceEndpointContainerState_CLOSED_instance = new ServiceEndpointContainerState('CLOSED', 3);
  }
  function ServiceEndpointContainerState(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function ServiceEndpointContainerState_INIT_getInstance() {
    ServiceEndpointContainerState_initEntries();
    return ServiceEndpointContainerState_INIT_instance;
  }
  function ServiceEndpointContainerState_CONFIGURING_getInstance() {
    ServiceEndpointContainerState_initEntries();
    return ServiceEndpointContainerState_CONFIGURING_instance;
  }
  function ServiceEndpointContainerState_CONFIGURED_getInstance() {
    ServiceEndpointContainerState_initEntries();
    return ServiceEndpointContainerState_CONFIGURED_instance;
  }
  function ServiceEndpointContainerState_CLOSED_getInstance() {
    ServiceEndpointContainerState_initEntries();
    return ServiceEndpointContainerState_CLOSED_instance;
  }
  function SynchronizedAtomicReference$get$lambda(this$0) {
    return function () {
      return this$0.est_1;
    };
  }
  function SynchronizedAtomicReference$set$lambda(this$0, $newValue) {
    return function () {
      this$0.est_1 = $newValue;
      return Unit_instance;
    };
  }
  function SynchronizedAtomicReference$getAndSet$lambda(this$0, $newValue) {
    return function () {
      var prevValue = this$0.est_1;
      this$0.est_1 = $newValue;
      return prevValue;
    };
  }
  function SynchronizedAtomicReference$compareAndSet$lambda(this$0, $expect, $update) {
    return function () {
      var isSuccess = this$0.est_1 === $expect;
      var tmp;
      if (isSuccess) {
        this$0.est_1 = $update;
        tmp = Unit_instance;
      }
      return isSuccess;
    };
  }
  function SynchronizedAtomicReference(value) {
    this.est_1 = value;
    this.fst_1 = newLock();
  }
  protoOf(SynchronizedAtomicReference).uv = function () {
    return this.fst_1.t2o(SynchronizedAtomicReference$get$lambda(this));
  };
  protoOf(SynchronizedAtomicReference).rsv = function (newValue) {
    return this.fst_1.t2o(SynchronizedAtomicReference$set$lambda(this, newValue));
  };
  protoOf(SynchronizedAtomicReference).isu = function (newValue) {
    return this.fst_1.t2o(SynchronizedAtomicReference$getAndSet$lambda(this, newValue));
  };
  protoOf(SynchronizedAtomicReference).hsu = function (expect, update) {
    return this.fst_1.t2o(SynchronizedAtomicReference$compareAndSet$lambda(this, expect, update));
  };
  function VersionMismatchException_init_$Init$($this) {
    RuntimeException_init_$Init$($this);
    VersionMismatchException.call($this);
    return $this;
  }
  function VersionMismatchException_init_$Create$() {
    var tmp = VersionMismatchException_init_$Init$(objectCreate(protoOf(VersionMismatchException)));
    captureStack(tmp, VersionMismatchException_init_$Create$);
    return tmp;
  }
  function VersionMismatchException_init_$Init$_0(differentVersion, $this) {
    RuntimeException_init_$Init$_0('actual is 6 but received ' + differentVersion, $this);
    VersionMismatchException.call($this);
    return $this;
  }
  function VersionMismatchException_init_$Create$_0(differentVersion) {
    var tmp = VersionMismatchException_init_$Init$_0(differentVersion, objectCreate(protoOf(VersionMismatchException)));
    captureStack(tmp, VersionMismatchException_init_$Create$_0);
    return tmp;
  }
  function VersionMismatchException() {
    captureStack(this, VersionMismatchException);
  }
  function SocketConnection$Companion$LOG$lambda() {
    return Unit_instance;
  }
  var State_OPENING_instance;
  var State_OPENED_instance;
  var State_CLOSED_instance;
  var State_entriesInitialized_1;
  function State_initEntries_1() {
    if (State_entriesInitialized_1)
      return Unit_instance;
    State_entriesInitialized_1 = true;
    State_OPENING_instance = new State_2('OPENING', 0);
    State_OPENED_instance = new State_2('OPENED', 1);
    State_CLOSED_instance = new State_2('CLOSED', 2);
  }
  function Companion_410() {
    Companion_instance_410 = this;
    this.ssv_1 = new EmptyListener();
  }
  var Companion_instance_410;
  function Companion_getInstance_410() {
    if (Companion_instance_410 == null)
      new Companion_410();
    return Companion_instance_410;
  }
  function SocketConnection$connect$o$doOnClose$lambda($url, $code, $reason) {
    return function () {
      return 'Disposing connection due to close event url=' + $url + ', code=' + $code + ', reason=' + $reason;
    };
  }
  function SocketConnection$connect$o$doOnError$lambda($url) {
    return function () {
      return 'Disposing connection due to error event url=' + $url;
    };
  }
  function SocketConnection$connect$lambda$o$messageReceived$lambda(this$0, $msg) {
    return function () {
      ensureNotNull(this$0.vsv_1).bsw(Companion_getInstance_411().asw_1.ksv($msg));
      return Unit_instance;
    };
  }
  function connect_0($this, container) {
    $this.tsv_1.t2o(SocketConnection$connect$lambda_1($this, container));
    fireOpened($this);
  }
  function receive($this, message) {
    var t = {_v: null};
    $this.tsv_1.t2o(SocketConnection$receive$lambda($this, message, t));
    if (!(t._v == null)) {
      fireError($this, ensureNotNull(t._v), true);
    }
  }
  function fireDisconnectEvent($this, code, reason) {
    var old = {_v: null};
    $this.xsv_1.t2o(SocketConnection$fireDisconnectEvent$lambda(old, $this));
    ensureNotNull(old._v).csw(code, reason);
  }
  function fireOpened($this) {
    var listener = {_v: null};
    $this.xsv_1.t2o(SocketConnection$fireOpened$lambda(listener, $this));
    ensureNotNull(listener._v).dsw();
  }
  function fireError($this, t, fatal) {
    var listener = {_v: null};
    $this.xsv_1.t2o(SocketConnection$fireError$lambda(listener, $this));
    ensureNotNull(listener._v).esw(t, fatal);
  }
  function Companion_411() {
    Companion_instance_411 = this;
    var tmp = this;
    var tmp_0 = KotlinLogging_getInstance();
    tmp.zsv_1 = tmp_0.i2q(SocketConnection$Companion$LOG$lambda);
    this.asw_1 = new ServiceContainerMessagePersister();
  }
  var Companion_instance_411;
  function Companion_getInstance_411() {
    if (Companion_instance_411 == null)
      new Companion_411();
    return Companion_instance_411;
  }
  function State_2(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function EmptyListener() {
    Companion_getInstance_410();
  }
  protoOf(EmptyListener).dsw = function () {
  };
  protoOf(EmptyListener).csw = function (code, reason) {
  };
  protoOf(EmptyListener).esw = function (t, fatal) {
  };
  function SocketConnection$lambda(this$0, $listener) {
    return function () {
      this$0.ysv_1 = $listener;
      return Unit_instance;
    };
  }
  function SocketConnection$connect$lambda(this$0) {
    return function () {
      // Inline function 'kotlin.check' call
      if (!(this$0.usv_1 == null)) {
        var message = "Socket 'init' when socket is " + ensureNotNull(this$0.usv_1).toString();
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      }
      this$0.usv_1 = State_OPENING_getInstance();
      return Unit_instance;
    };
  }
  function SocketConnection$connect$socketHandler$1(this$0, $url, $container) {
    this.fsw_1 = this$0;
    this.gsw_1 = $url;
    this.hsw_1 = $container;
    SocketHandler.call(this);
  }
  protoOf(SocketConnection$connect$socketHandler$1).isw = function (code, reason) {
    var tmp = Companion_getInstance_411().zsv_1;
    tmp.a2q(SocketConnection$connect$o$doOnClose$lambda(this.gsw_1, code, reason));
    this.fsw_1.zr();
    fireDisconnectEvent(this.fsw_1, code, reason == null ? '' : reason);
  };
  protoOf(SocketConnection$connect$socketHandler$1).jsw = function () {
    var tmp = Companion_getInstance_411().zsv_1;
    tmp.a2q(SocketConnection$connect$o$doOnError$lambda(this.gsw_1));
    this.fsw_1.zr();
    fireDisconnectEvent(this.fsw_1, 1006, '');
  };
  protoOf(SocketConnection$connect$socketHandler$1).ksw = function (message) {
    return receive(this.fsw_1, message);
  };
  protoOf(SocketConnection$connect$socketHandler$1).lsw = function () {
    return connect_0(this.fsw_1, this.hsw_1);
  };
  function SocketConnection$connect$lambda_0(this$0, $socket) {
    return function () {
      this$0.vsv_1 = $socket;
      return Unit_instance;
    };
  }
  function SocketConnection$connect$6$$inlined$serviceContainerChannel$1(this$0) {
    this.qsw_1 = this$0;
  }
  protoOf(SocketConnection$connect$6$$inlined$serviceContainerChannel$1).fsu = function (message) {
    this.qsw_1.tsv_1.t2o(SocketConnection$connect$lambda$o$messageReceived$lambda(this.qsw_1, message));
    return Unit_instance;
  };
  protoOf(SocketConnection$connect$6$$inlined$serviceContainerChannel$1).tsm = function (message) {
    return this.fsu(message instanceof ServiceContainerMessage ? message : THROW_CCE());
  };
  function SocketConnection$connect$lambda$lambda(this$0) {
    return function (item) {
      var tmp = ensureNotNull(item);
      fireError(this$0, tmp, item instanceof FatalEndpointException);
      return Unit_instance;
    };
  }
  function SocketConnection$connect$lambda_1(this$0, $container) {
    return function () {
      // Inline function 'kotlin.check' call
      if (!equals(this$0.usv_1, State_OPENING_getInstance())) {
        var message = "Socket 'onOpen' when socket is " + ensureNotNull(this$0.usv_1).toString();
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      }
      this$0.wsv_1 = $container.esn();
      var tmp = ensureNotNull(this$0.wsv_1);
      // Inline function 'jetbrains.ocelot.ot.model.protocol.service.serviceContainerChannel' call
      var tmp_0 = new SocketConnection$connect$6$$inlined$serviceContainerChannel$1(this$0);
      tmp.csn(tmp_0, SocketConnection$connect$lambda$lambda(this$0));
      this$0.usv_1 = State_OPENED_getInstance();
      return Unit_instance;
    };
  }
  function SocketConnection$receive$lambda(this$0, $message, $t) {
    return function () {
      var tmp;
      if (!equals(this$0.usv_1, State_CLOSED_getInstance())) {
        // Inline function 'kotlin.check' call
        if (!equals(this$0.usv_1, State_OPENED_getInstance())) {
          var message = 'Message received when socket is ' + toString_0(this$0.usv_1) + '\nmessage=' + $message;
          throw IllegalStateException_init_$Create$_0(toString_1(message));
        }
        var tmp_0;
        try {
          ensureNotNull(this$0.wsv_1).ysm().tsm(Companion_getInstance_411().asw_1.v24($message));
          tmp_0 = Unit_instance;
        } catch ($p) {
          var tmp_1;
          if ($p instanceof Error) {
            var th = $p;
            $t._v = th;
            tmp_1 = Unit_instance;
          } else {
            throw $p;
          }
          tmp_0 = tmp_1;
        }
        tmp = tmp_0;
      }
      return Unit_instance;
    };
  }
  function SocketConnection$dispose$lambda(this$0, $port, $socket) {
    return function () {
      var tmp;
      if (!equals(this$0.usv_1, State_CLOSED_getInstance())) {
        this$0.usv_1 = State_CLOSED_getInstance();
        $port._v = this$0.wsv_1;
        this$0.wsv_1 = null;
        $socket._v = this$0.vsv_1;
        this$0.vsv_1 = null;
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function SocketConnection$dispose$lambda_0() {
    return 'Exception while disposing socket connection:';
  }
  function SocketConnection$fireDisconnectEvent$lambda($old, this$0) {
    return function () {
      $old._v = this$0.ysv_1;
      this$0.ysv_1 = Companion_getInstance_410().ssv_1;
      return Unit_instance;
    };
  }
  function SocketConnection$fireOpened$lambda($listener, this$0) {
    return function () {
      $listener._v = this$0.ysv_1;
      return Unit_instance;
    };
  }
  function SocketConnection$fireError$lambda($listener, this$0) {
    return function () {
      $listener._v = this$0.ysv_1;
      return Unit_instance;
    };
  }
  function State_OPENING_getInstance() {
    State_initEntries_1();
    return State_OPENING_instance;
  }
  function State_OPENED_getInstance() {
    State_initEntries_1();
    return State_OPENED_instance;
  }
  function State_CLOSED_getInstance() {
    State_initEntries_1();
    return State_CLOSED_instance;
  }
  function SocketConnection(listener) {
    Companion_getInstance_411();
    this.tsv_1 = newLock();
    this.usv_1 = null;
    this.vsv_1 = null;
    this.wsv_1 = null;
    this.xsv_1 = newLock();
    this.ysv_1 = null;
    this.xsv_1.t2o(SocketConnection$lambda(this, listener));
  }
  protoOf(SocketConnection).rsw = function (url, socketFactory, container) {
    this.tsv_1.t2o(SocketConnection$connect$lambda(this));
    var socket;
    try {
      var socketHandler = new SocketConnection$connect$socketHandler$1(this, url, container);
      socket = socketFactory.ssw(url, socketHandler);
    } catch ($p) {
      if ($p instanceof Error) {
        var t = $p;
        fireError(this, t, true);
        return Unit_instance;
      } else {
        throw $p;
      }
    }
    this.tsv_1.t2o(SocketConnection$connect$lambda_0(this, socket));
    try {
      socket.tsw();
    } catch ($p) {
      if ($p instanceof Error) {
        var t_0 = $p;
        fireError(this, t_0, false);
      } else {
        throw $p;
      }
    }
  };
  protoOf(SocketConnection).zr = function () {
    var port = {_v: null};
    var socket = {_v: null};
    this.tsv_1.t2o(SocketConnection$dispose$lambda(this, port, socket));
    try {
      var tmp0_safe_receiver = port._v;
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.zr();
      }
      var tmp1_safe_receiver = socket._v;
      if (tmp1_safe_receiver == null)
        null;
      else {
        tmp1_safe_receiver.d2n();
      }
    } catch ($p) {
      if ($p instanceof RuntimeException) {
        var e = $p;
        var tmp = Companion_getInstance_411().zsv_1;
        tmp.h2q(e, SocketConnection$dispose$lambda_0);
      } else {
        throw $p;
      }
    }
  };
  function SocketHandler() {
  }
  protoOf(SocketHandler).msw = function (code, reason) {
    try {
      this.isw(code, reason);
    } catch ($p) {
      if ($p instanceof Error) {
        var t = $p;
        ThrowableHandlers_getInstance().k2r_1.j2r(t);
      } else {
        throw $p;
      }
    }
  };
  protoOf(SocketHandler).nsw = function () {
    try {
      this.jsw();
    } catch ($p) {
      if ($p instanceof Error) {
        var t = $p;
        ThrowableHandlers_getInstance().k2r_1.j2r(t);
      } else {
        throw $p;
      }
    }
  };
  protoOf(SocketHandler).osw = function (message) {
    try {
      this.ksw(message);
    } catch ($p) {
      if ($p instanceof Error) {
        var t = $p;
        ThrowableHandlers_getInstance().k2r_1.j2r(t);
      } else {
        throw $p;
      }
    }
  };
  protoOf(SocketHandler).psw = function () {
    try {
      this.lsw();
    } catch ($p) {
      if ($p instanceof Error) {
        var t = $p;
        ThrowableHandlers_getInstance().k2r_1.j2r(t);
      } else {
        throw $p;
      }
    }
  };
  function SocketManager$Companion$LOG$lambda() {
    return Unit_instance;
  }
  function SocketManager$o$onOpened$lambda(this$0) {
    return function () {
      return 'Socket connection opened: ' + _get_url__e6i4g2(this$0);
    };
  }
  function SocketManager$o$onDisconnect$lambda($code, this$0, $reason) {
    return function () {
      return 'Socket connection closed with code ' + $code + ': ' + _get_url__e6i4g2(this$0) + '. Reason: ' + $reason;
    };
  }
  function SocketManager$o$onDisconnect$lambda_0(this$0) {
    return function () {
      this$0.isx_1 = null;
      return Unit_instance;
    };
  }
  function SocketManager$o$onDisconnect$lambda$lambda($delay) {
    return function () {
      return 'reconnect in ' + $delay + ' ms';
    };
  }
  function SocketManager$initSocket$ref(p0) {
    var l = function () {
      var tmp0 = p0;
      initSocket(tmp0);
      return Unit_instance;
    };
    l.callableName = 'initSocket';
    return l;
  }
  function SocketManager$o$onDisconnect$lambda_1(this$0) {
    return function () {
      var delay = convertToInt(this$0.dsx_1.rsx());
      var tmp;
      if (this$0.wsx()) {
        var tmp_0 = Companion_getInstance_412().ssx_1;
        tmp_0.a2q(SocketManager$o$onDisconnect$lambda$lambda(delay));
        var tmp_1 = this$0;
        var tmp_2 = SocketManager$initSocket$ref(this$0);
        tmp_1.fsx_1 = this$0.xsw_1.v39(delay, new sam$jetbrains_ocelot_base_edt_EdtTask$0_21(tmp_2));
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function _set_isStarted__srcka6($this, value) {
    return $this.asx_1.t2o(SocketManager$_set_isStarted_$lambda_vah29z($this, value));
  }
  function _get_url__e6i4g2($this) {
    return $this.vsw_1 + (contains_8($this.vsw_1, '?') ? '&' : '?') + 'connection_id' + '=' + ensureNotNull($this.xsx()).q36_1 + '&' + 'client_id' + '=' + $this.ysw_1.q36_1;
  }
  function SocketManager_init_$Init$(container, url, socketFactory, edt, clientId, isReconnectEnabled, $this) {
    clientId = clientId === VOID ? ClientId_init_$Create$() : clientId;
    isReconnectEnabled = isReconnectEnabled === VOID ? true : isReconnectEnabled;
    SocketManager.call($this, container, url, socketFactory, edt, clientId, isReconnectEnabled, Companion_getInstance_412().usx_1);
    return $this;
  }
  function SocketManager_init_$Create$(container, url, socketFactory, edt, clientId, isReconnectEnabled) {
    return SocketManager_init_$Init$(container, url, socketFactory, edt, clientId, isReconnectEnabled, objectCreate(protoOf(SocketManager)));
  }
  function initSocket($this) {
    $this.ksx_1.d2x(ConnectionId_init_$Create$());
    var tmp = $this.ysx();
    var tmp_0 = SocketManager$initSocket$lambda($this);
    tmp.t37(tmp_0, SocketManager$initSocket$lambda_0($this));
  }
  function doInitSocket($this) {
    var connection = {_v: null};
    $this.hsx_1.t2o(SocketManager$doInitSocket$lambda($this, connection));
    ensureNotNull(connection._v).rsw(_get_url__e6i4g2($this), $this.wsw_1, $this.usw_1);
  }
  function onError($this, t, fatal) {
    if (fatal) {
      $this.csx_1.c2x(t);
    }
    try {
      ThrowableHandlers_getInstance().k2r_1.j2r(t);
    }finally {
      disposeConnection($this);
      if (fatal) {
        $this.csx_1.c9();
      }
    }
  }
  function disposeConnection($this) {
    $this.hsx_1.t2o(SocketManager$disposeConnection$lambda($this));
  }
  function Companion_412() {
    Companion_instance_412 = this;
    var tmp = this;
    var tmp_0 = KotlinLogging_getInstance();
    tmp.ssx_1 = tmp_0.i2q(SocketManager$Companion$LOG$lambda);
    this.tsx_1 = 5000n;
    this.usx_1 = new UniformDelays(5000n, DurationUnit_MILLISECONDS_getInstance());
    this.vsx_1 = 10000;
  }
  var Companion_instance_412;
  function Companion_getInstance_412() {
    if (Companion_instance_412 == null)
      new Companion_412();
    return Companion_instance_412;
  }
  function sam$jetbrains_ocelot_base_edt_EdtTask$0_21(function_0) {
    this.zsx_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_21).au = function () {
    return this.zsx_1();
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_21).f3 = function () {
    return this.zsx_1;
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_21).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, EdtTask) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_21).hashCode = function () {
    return hashCode(this.f3());
  };
  function SocketManager$_get_isStarted_$lambda_aniqmd(this$0) {
    return function () {
      return this$0.bsx_1;
    };
  }
  function SocketManager$_set_isStarted_$lambda_vah29z(this$0, $value) {
    return function () {
      // Inline function 'kotlin.check' call
      if (!!(this$0.bsx_1 === $value)) {
        var message = this$0.toString() + ' has ' + ($value ? 'already' : 'not') + ' been started';
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      }
      this$0.bsx_1 = $value;
      return Unit_instance;
    };
  }
  function SocketManager$1(this$0) {
    this.asy_1 = this$0;
  }
  protoOf(SocketManager$1).dsw = function () {
    var tmp = Companion_getInstance_412().ssx_1;
    tmp.a2q(SocketManager$o$onOpened$lambda(this.asy_1));
    if (this.asy_1.zsw_1) {
      this.asy_1.dsx_1.bsy();
    }
    this.asy_1.jsx_1.d2x(true);
  };
  protoOf(SocketManager$1).csw = function (code, reason) {
    var tmp = Companion_getInstance_412().ssx_1;
    tmp.a2q(SocketManager$o$onDisconnect$lambda(code, this.asy_1, reason));
    this.asy_1.hsx_1.t2o(SocketManager$o$onDisconnect$lambda_0(this.asy_1));
    if (this.asy_1.csx_1.uv() == null && this.asy_1.zsw_1 && !(code === 4403)) {
      this.asy_1.esx_1.t2o(SocketManager$o$onDisconnect$lambda_1(this.asy_1));
    }
    this.asy_1.jsx_1.d2x(false);
  };
  protoOf(SocketManager$1).esw = function (t, fatal) {
    onError(this.asy_1, t, fatal);
  };
  function SocketManager$start$lambda(this$0) {
    return function () {
      return 'Starting socket manager: url=' + this$0.vsw_1 + ', clientId=' + this$0.ysw_1.toString();
    };
  }
  function SocketManager$stop$lambda(this$0) {
    return function () {
      return 'Stopping socket manager: url=' + this$0.vsw_1 + ', clientId=' + this$0.ysw_1.toString();
    };
  }
  function Disposable$dispose$ref(p0) {
    var l = function () {
      p0.zr();
      return Unit_instance;
    };
    l.callableName = 'dispose';
    return l;
  }
  function SocketManager$initSocket$lambda$lambda($started, this$0) {
    return function () {
      $started._v = this$0.bsx_1;
      return Unit_instance;
    };
  }
  function SocketManager$initSocket$lambda(this$0) {
    return function (it) {
      var started = {_v: false};
      this$0.asx_1.t2o(SocketManager$initSocket$lambda$lambda(started, this$0));
      var tmp;
      if (started._v) {
        doInitSocket(this$0);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function SocketManager$initSocket$lambda_0(this$0) {
    return function (t) {
      onError(this$0, t, true);
      return Unit_instance;
    };
  }
  function SocketManager$doInitSocket$lambda(this$0, $connection) {
    return function () {
      // Inline function 'kotlin.check' call
      if (!(this$0.isx_1 == null)) {
        throw IllegalStateException_init_$Create$_0('Check failed.');
      }
      $connection._v = new SocketConnection(this$0.gsx_1);
      this$0.isx_1 = $connection._v;
      return Unit_instance;
    };
  }
  function SocketManager$disposeConnection$lambda(this$0) {
    return function () {
      var tmp0_safe_receiver = this$0.isx_1;
      var tmp;
      if (tmp0_safe_receiver == null) {
        tmp = null;
      } else {
        tmp0_safe_receiver.zr();
        tmp = Unit_instance;
      }
      return tmp;
    };
  }
  function SocketManager(container, _url, socketFactory, edt, clientId, isReconnectEnabled, waitStrategy) {
    Companion_getInstance_412();
    clientId = clientId === VOID ? ClientId_init_$Create$() : clientId;
    isReconnectEnabled = isReconnectEnabled === VOID ? true : isReconnectEnabled;
    waitStrategy = waitStrategy === VOID ? Companion_getInstance_412().usx_1 : waitStrategy;
    this.usw_1 = container;
    this.vsw_1 = _url;
    this.wsw_1 = socketFactory;
    this.xsw_1 = edt;
    this.ysw_1 = clientId;
    this.zsw_1 = isReconnectEnabled;
    this.asx_1 = newLock();
    this.bsx_1 = false;
    this.csx_1 = new DelayedValueProperty();
    this.esx_1 = newLock();
    this.fsx_1 = Companion_getInstance_29().m2l_1;
    this.hsx_1 = newLock();
    this.isx_1 = null;
    this.jsx_1 = new ThreadSafeProperty(false);
    this.ksx_1 = new ThreadSafeProperty(null);
    this.dsx_1 = new ReconnectStrategy(this.xsw_1, waitStrategy, 10000);
    var tmp = this;
    tmp.gsx_1 = new SocketManager$1(this);
  }
  protoOf(SocketManager).xsx = function () {
    return this.ksx_1.uv();
  };
  protoOf(SocketManager).wsx = function () {
    return this.asx_1.t2o(SocketManager$_get_isStarted_$lambda_aniqmd(this));
  };
  protoOf(SocketManager).csy = function () {
    var tmp = Companion_getInstance_412().ssx_1;
    tmp.a2q(SocketManager$start$lambda(this));
    _set_isStarted__srcka6(this, true);
    initSocket(this);
  };
  protoOf(SocketManager).zeu = function () {
    var tmp = Companion_getInstance_412().ssx_1;
    tmp.a2q(SocketManager$stop$lambda(this));
    _set_isStarted__srcka6(this, false);
    disposeConnection(this);
    this.esx_1.t2o(Disposable$dispose$ref(this.fsx_1));
    this.dsx_1.zr();
  };
  protoOf(SocketManager).ysx = function () {
    return Asyncs_instance.a38();
  };
  protoOf(SocketManager).toString = function () {
    var cl = getKClassFromExpression(this).ra();
    return plus_12(cl, toString(_Char___init__impl__6a9atx(64))) + toString_3(hashCode(this), 16);
  };
  function sam$jetbrains_ocelot_base_edt_EdtTask$0_22(function_0) {
    this.dsy_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_22).au = function () {
    return this.dsy_1();
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_22).f3 = function () {
    return this.dsy_1;
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_22).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, EdtTask) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_22).hashCode = function () {
    return hashCode(this.f3());
  };
  function ReconnectStrategy$nextDelay$lambda(this$0) {
    return function () {
      this$0.zr();
      return this$0.psx_1.o();
    };
  }
  function ReconnectStrategy$onSuccessfulReconnect$lambda$lambda$lambda(this$0) {
    return function () {
      this$0.psx_1 = this$0.msx_1.esy();
      return Unit_instance;
    };
  }
  function ReconnectStrategy$onSuccessfulReconnect$lambda$lambda(this$0) {
    return function () {
      this$0.osx_1.t2o(ReconnectStrategy$onSuccessfulReconnect$lambda$lambda$lambda(this$0));
      return Unit_instance;
    };
  }
  function ReconnectStrategy$onSuccessfulReconnect$lambda(this$0) {
    return function () {
      var tmp;
      if (this$0.qsx_1 === Companion_getInstance_29().m2l_1) {
        var tmp_0 = this$0;
        var tmp_1 = ReconnectStrategy$onSuccessfulReconnect$lambda$lambda(this$0);
        tmp_0.qsx_1 = this$0.lsx_1.v39(this$0.nsx_1, new sam$jetbrains_ocelot_base_edt_EdtTask$0_22(tmp_1));
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ReconnectStrategy(edt, waitStrategy, resetDelayMs) {
    this.lsx_1 = edt;
    this.msx_1 = waitStrategy;
    this.nsx_1 = resetDelayMs;
    this.osx_1 = newLock();
    this.psx_1 = this.msx_1.esy();
    this.qsx_1 = Companion_getInstance_29().m2l_1;
  }
  protoOf(ReconnectStrategy).rsx = function () {
    return this.osx_1.t2o(ReconnectStrategy$nextDelay$lambda(this));
  };
  protoOf(ReconnectStrategy).bsy = function () {
    return this.osx_1.t2o(ReconnectStrategy$onSuccessfulReconnect$lambda(this));
  };
  protoOf(ReconnectStrategy).zr = function () {
    this.qsx_1.zr();
    this.qsx_1 = Companion_getInstance_29().m2l_1;
  };
  function UniformDelays$delays$1(this$0) {
    this.fsy_1 = this$0;
  }
  protoOf(UniformDelays$delays$1).n = function () {
    return true;
  };
  protoOf(UniformDelays$delays$1).o = function () {
    return this.fsy_1.gsy_1;
  };
  function UniformDelays(delay, unit) {
    this.gsy_1 = _Duration___get_inWholeMilliseconds__impl__msfiry(toDuration(delay, unit));
  }
  protoOf(UniformDelays).esy = function () {
    return new UniformDelays$delays$1(this);
  };
  function JsWebsocket$lambda(this$0) {
    return function (_unused_var__etf5q3) {
      this$0.hsy_1.psw();
      return Unit_instance;
    };
  }
  function JsWebsocket$lambda_0(this$0) {
    return function (event) {
      // Inline function 'kotlin.with' call
      var $this$with = event instanceof CloseEvent ? event : THROW_CCE();
      this$0.hsy_1.msw($this$with.code, $this$with.reason);
      return Unit_instance;
    };
  }
  function JsWebsocket$lambda_1(this$0) {
    return function (_unused_var__etf5q3) {
      this$0.hsy_1.nsw();
      return Unit_instance;
    };
  }
  function JsWebsocket$lambda_2(this$0) {
    return function (event) {
      var tmp = event.data;
      this$0.hsy_1.osw((!(tmp == null) ? typeof tmp === 'string' : false) ? tmp : THROW_CCE());
      return Unit_instance;
    };
  }
  function JsWebsocket(url, socketHandler) {
    this.hsy_1 = socketHandler;
    this.isy_1 = new WebSocket(url);
    var tmp = this.isy_1;
    tmp.onopen = JsWebsocket$lambda(this);
    var tmp_0 = this.isy_1;
    tmp_0.onclose = JsWebsocket$lambda_0(this);
    var tmp_1 = this.isy_1;
    tmp_1.onerror = JsWebsocket$lambda_1(this);
    var tmp_2 = this.isy_1;
    tmp_2.onmessage = JsWebsocket$lambda_2(this);
  }
  protoOf(JsWebsocket).tsw = function () {
  };
  protoOf(JsWebsocket).d2n = function () {
    return this.isy_1.close();
  };
  protoOf(JsWebsocket).bsw = function (msg) {
    return this.isy_1.send(msg);
  };
  function JsWebsocketFactory() {
  }
  protoOf(JsWebsocketFactory).ssw = function (url, socketHandler) {
    return new JsWebsocket(url, socketHandler);
  };
  function Companion_413() {
  }
  var Companion_instance_413;
  function Companion_getInstance_413() {
    return Companion_instance_413;
  }
  function AsyncWithDisposable(async, disposable) {
    disposable = disposable === VOID ? Companion_getInstance_29().m2l_1 : disposable;
    this.jsy_1 = async;
    this.ksy_1 = disposable;
  }
  protoOf(AsyncWithDisposable).lsy = function () {
    return this.ksy_1 == null;
  };
  protoOf(AsyncWithDisposable).msy = function (source) {
    // Inline function 'kotlin.check' call
    if (!!this.lsy()) {
      var message = 'Async, delegating to, is already cancelled';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    // Inline function 'kotlin.check' call
    if (!!source.lsy()) {
      var message_0 = 'Async, delegating from, is already cancelled';
      throw IllegalStateException_init_$Create$_0(toString_1(message_0));
    }
    // Inline function 'kotlin.check' call
    if (!(this.ksy_1 === Companion_getInstance_29().m2l_1)) {
      var message_1 = 'Async, delegating to, has not empty registration';
      throw IllegalStateException_init_$Create$_0(toString_1(message_1));
    }
    var tmp = Asyncs_instance;
    var tmp_0 = this.jsy_1;
    tmp.b38(source.jsy_1, tmp_0 instanceof SimpleAsync ? tmp_0 : THROW_CCE());
    this.ksy_1 = source.ksy_1;
    return this;
  };
  function shouldProcess($this, clientRoot) {
    return !clientRoot.nsy();
  }
  function Client$MyPort$o$commandAccepted$lambda($id) {
    return function (listener) {
      listener.osy($id);
      return Unit_instance;
    };
  }
  function Client$MyPort$o$loadAccepted$lambda($id) {
    return function (listener) {
      listener.psy($id.j55_1);
      return Unit_instance;
    };
  }
  function Client$MyPort$o$loadHistoryAccepted$lambda($id, $history) {
    return function (listener) {
      listener.qsy($id, $history);
      return Unit_instance;
    };
  }
  function Client$MyPort$o$loadHistoryRejected$lambda($id, $reason) {
    return function (listener) {
      listener.rsy($id, $reason);
      return Unit_instance;
    };
  }
  function Client$MyPort$o$reconnectRejected$lambda($id, $reason) {
    return function (listener) {
      listener.ssy($id, $reason);
      return Unit_instance;
    };
  }
  function Client$MyPort$o$loadRejected$lambda($id, $reason) {
    return function (listener) {
      listener.tsy($id.j55_1, $reason);
      return Unit_instance;
    };
  }
  function Client$MyPort$o$unloadHandled$lambda($id, $rootIds) {
    return function (listener) {
      listener.usy($id, $rootIds);
      return Unit_instance;
    };
  }
  function Client$MyPort$setOutput$o$load$lambda($ref) {
    return function (listener) {
      listener.vsy($ref);
      return Unit_instance;
    };
  }
  function _get_isConnected__klcexa($this) {
    return !($this.lsz_1.jsz_1 == null);
  }
  function Client$MyPort$1(this$0, this$1) {
    this.msz_1 = this$0;
    this.nsz_1 = this$1;
    OtChannelAdapter.call(this);
  }
  protoOf(Client$MyPort$1).csp = function (commandId) {
    fireCommandUnprocessed(this.msz_1, commandId);
  };
  protoOf(Client$MyPort$1).nso = function (command) {
    if (_get_isConnected__klcexa(this.nsz_1)) {
      var clientRoot = getRoot(this.msz_1, command.b55_1.g55_1);
      if (shouldProcess(this, clientRoot)) {
        (new IncomingRequest()).rsz(clientRoot.psz(command));
      } else {
        this.msz_1.osz(command.b55_1, command.c55_1, command.d55_1);
      }
    }
  };
  protoOf(Client$MyPort$1).oso = function (id, baseVersion, resultVersion) {
    this.msz_1.hsz_1.k2s(Client$MyPort$o$commandAccepted$lambda(id));
    var clientRoot = getRoot(this.msz_1, id.g55_1);
    if (clientRoot.xsz() && shouldProcess(this, clientRoot)) {
      IncomingAcceptance_init_$Create$(id.f55_1, baseVersion, resultVersion).rsz(clientRoot.ssz());
    }
  };
  protoOf(Client$MyPort$1).sso = function (id) {
    (new IncomingAcceptance(id.f55_1)).rsz(getRoot(this.msz_1, id.g55_1).ysz());
  };
  protoOf(Client$MyPort$1).vso = function (id) {
    assertRootCommand(this.msz_1, id);
    this.msz_1.hsz_1.k2s(Client$MyPort$o$loadAccepted$lambda(id));
    (new IncomingAcceptance(id.i55_1, id.p3w(), null, null)).rsz(getRoot(this.msz_1, id.m3w()).zsz());
  };
  protoOf(Client$MyPort$1).yso = function (id, history) {
    var request = this.msz_1.gsz_1.u2(id);
    if (request == null)
      null;
    else {
      request.w37(history);
    }
    this.msz_1.hsz_1.k2s(Client$MyPort$o$loadHistoryAccepted$lambda(id, history));
  };
  protoOf(Client$MyPort$1).zso = function (id, reason) {
    var request = this.msz_1.gsz_1.u2(id);
    if (request == null)
      null;
    else {
      request.x37(new OtRejectionException(reason));
    }
    this.msz_1.hsz_1.k2s(Client$MyPort$o$loadHistoryRejected$lambda(id, reason));
  };
  protoOf(Client$MyPort$1).pso = function (id, reason) {
    if (_get_isConnected__klcexa(this.nsz_1)) {
      var clientRoot = getRoot(this.msz_1, id.g55_1);
      if (clientRoot.xsz() && shouldProcess(this, clientRoot)) {
        IncomingRejection_init_$Create$(id.f55_1, reason).rsz(clientRoot.ssz());
      } else {
        this.msz_1.at0(id, reason);
      }
    }
  };
  protoOf(Client$MyPort$1).tso = function (id, reason) {
    assertRootCommand(this.msz_1, id);
    this.msz_1.hsz_1.k2s(Client$MyPort$o$reconnectRejected$lambda(id, reason));
    IncomingRejection_init_$Create$(id.i55_1, reason).rsz(getRoot(this.msz_1, id.m3w()).ysz());
  };
  protoOf(Client$MyPort$1).wso = function (id, reason) {
    assertRootCommand(this.msz_1, id);
    this.msz_1.hsz_1.k2s(Client$MyPort$o$loadRejected$lambda(id, reason));
    (new IncomingRejection(id.i55_1, id.p3w(), reason)).rsz(getRoot(this.msz_1, id.m3w()).zsz());
  };
  protoOf(Client$MyPort$1).bsp = function (id, rootIds) {
    var _iterator__ex2g4s = rootIds.m();
    while (_iterator__ex2g4s.n()) {
      var rootId = _iterator__ex2g4s.o();
      getRoot(this.msz_1, rootId).et0();
    }
    this.msz_1.hsz_1.k2s(Client$MyPort$o$unloadHandled$lambda(id, rootIds));
  };
  function Client$MyPort$setOutput$1($output, this$0) {
    this.gt0_1 = this$0;
    OtChannelDelegate.call(this, $output);
  }
  protoOf(Client$MyPort$setOutput$1).uso = function (id) {
    assertRootCommand(this.gt0_1, id);
    var ref = new EntityReference(id.m3w(), id.p3w());
    this.gt0_1.hsz_1.k2s(Client$MyPort$setOutput$o$load$lambda(ref));
    protoOf(OtChannelDelegate).uso.call(this, id);
  };
  function Client$Companion$LOG$lambda() {
    return Unit_instance;
  }
  function runCallbacks($this) {
    if ($this.ht0_1.isz_1.s())
      return Unit_instance;
    var iterator = $this.ht0_1.isz_1.m();
    while (iterator.n()) {
      var callback = iterator.o();
      iterator.h4();
      try {
        callback();
      } catch ($p) {
        if ($p instanceof Error) {
          var t = $p;
          ThrowableHandlers_getInstance().k2r_1.j2r(t);
        } else {
          throw $p;
        }
      }
    }
    // Inline function 'kotlin.check' call
    if (!$this.ht0_1.isz_1.s()) {
      var message = '' + $this.ht0_1.isz_1.p() + ' callbacks are left';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
  }
  function Client$init$o$onCommandCommitted$lambda($cmd) {
    return function (listener) {
      listener.it0($cmd);
      return Unit_instance;
    };
  }
  function fireProcessingRestored($this) {
    var _iterator__ex2g4s = $this.asz_1.m();
    while (_iterator__ex2g4s.n()) {
      var rootId = _iterator__ex2g4s.o();
      $this.bsz_1.k2s(Client$fireProcessingRestored$lambda(rootId));
    }
    $this.asz_1.k2();
  }
  function doLoadEntity($this, reference) {
    // Inline function 'kotlin.check' call
    if (!!commandInProgress($this)) {
      var message = 'Invalid internal loadEntity() call, ' + reference.toString();
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    if ($this.wsy_1) {
      var tmp = Companion_getInstance_414().jt0_1;
      tmp.x2p(Client$doLoadEntity$lambda(reference));
    }
    var entityId = reference.k3j_1;
    var status = $this.kt0(reference);
    if ($this.wsy_1) {
      var tmp_0 = Companion_getInstance_414().jt0_1;
      tmp_0.x2p(Client$doLoadEntity$lambda_0(reference, status));
    }
    switch (status.x2_1) {
      case 1:
        return new AsyncWithDisposable(Asyncs_instance.y37(ensureNotNull($this.g3t().a3j().a3h(entityId))));
      case 2:
        return new AsyncWithDisposable(Asyncs_instance.z37(new OtRejectionException(RejectionReason_NOT_FOUND_getInstance())));
      case 0:
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    checkLoadRestrictions($this, reference);
    var rootId = reference.j3j_1;
    var clientRoot = getRoot($this, rootId);
    var shouldLoadEntity = !$this.fsz_1.mt0(reference);
    if ($this.wsy_1 && !shouldLoadEntity) {
      var tmp_1 = Companion_getInstance_414().jt0_1;
      tmp_1.x2p(Client$doLoadEntity$lambda_1(reference));
    }
    var result = clientRoot.nt0(entityId);
    $this.fsz_1.ot0(rootId, entityId, clientRoot);
    if ($this.wsy_1 && clientRoot.pt0()) {
      var tmp_2 = Companion_getInstance_414().jt0_1;
      tmp_2.x2p(Client$doLoadEntity$lambda_2(reference));
    }
    if ($this.wsy_1 && !$this.qt0().uv()) {
      var tmp_3 = Companion_getInstance_414().jt0_1;
      tmp_3.x2p(Client$doLoadEntity$lambda_3(reference));
    }
    if (shouldLoadEntity && !clientRoot.pt0() && $this.qt0().uv()) {
      $this.rt0(rootId, entityId);
    }
    return result;
  }
  function commandInProgress($this) {
    return $this.zsy_1.l3x_1 || $this.zsy_1.m3x_1;
  }
  function checkLoadRestrictions($this, reference) {
    // Inline function 'kotlin.check' call
    if (!reference.l3j()) {
      var message = 'Trying to load not root ' + reference.toString();
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
  }
  function getRoot($this, rootId) {
    var clientRoot = $this.dsz_1.q2(rootId);
    if (clientRoot == null) {
      clientRoot = $this.fsz_1.st0(rootId);
      if (clientRoot == null) {
        clientRoot = new ClientRootImpl(rootId, $this, VOID, $this.xsy_1);
      }
    }
    return clientRoot;
  }
  function checkCanBeUnloaded($this, rootId) {
    var root = getRoot($this, rootId);
    // Inline function 'kotlin.check' call
    if (!(root.xsz() && !root.nsy())) {
      var message = "Can't unload root, id=" + rootId.toString() + ', state=' + root.tt0();
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
  }
  function doConnect($this) {
    // Inline function 'kotlin.check' call
    if (!!$this.ysy_1.uv()) {
      var message = 'Client is already connected';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    onConnectionEstablished_0($this);
    $this.ysy_1.d2x(true);
    fireProcessingRestored($this);
    $this.hsz_1.k2s(ProtocolListener$onConnectionEstablished$ref());
  }
  function onConnectionEstablished_0($this) {
    var rootsToLoad = ArrayList_init_$Create$();
    var reconnectHelper = new LoadedEntitiesTreeReconnectHelper($this.esz_1);
    var _iterator__ex2g4s = $this.dsz_1.s2().m();
    while (_iterator__ex2g4s.n()) {
      var root = _iterator__ex2g4s.o();
      // Inline function 'kotlin.check' call
      if (!root.xsz()) {
        var message = 'Nonexistent root in collection, ' + toString_1(root);
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      }
      (new OutgoingRequest()).rsz(root.ysz());
      rootsToLoad.j(reconnectHelper.mso(root.m3w(), root.grg()));
    }
    if (!rootsToLoad.s()) {
      ensureNotNull($this.jsz_1).rso(CommandId_init_$Create$(), rootsToLoad);
    }
    var _iterator__ex2g4s_0 = $this.fsz_1.vt0().m();
    while (_iterator__ex2g4s_0.n()) {
      var root_0 = _iterator__ex2g4s_0.o();
      if (!root_0.xsz()) {
        (new OutgoingRequest()).rsz(root_0.ysz());
      }
    }
  }
  function onConnectionBroken_0($this) {
    $this.ysy_1.d2x(false);
    var _iterator__ex2g4s = HashSet_init_$Create$_0($this.dsz_1.s2()).m();
    while (_iterator__ex2g4s.n()) {
      var clientRoot = _iterator__ex2g4s.o();
      (new IncomingRequest()).rsz(clientRoot.ysz());
    }
    $this.hsz_1.k2s(ProtocolListener$onConnectionBroken$ref());
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s_0 = $this.gsz_1.y().m();
    while (_iterator__ex2g4s_0.n()) {
      // Inline function 'kotlin.collections.component2' call
      var value = _iterator__ex2g4s_0.o().a1();
      value.x37(new OtRejectionException(RejectionReason_DISCONNECTED_getInstance()));
    }
    $this.gsz_1.k2();
  }
  function applyHighLevelRemovals($this, rootId, highLevelRemovals) {
    if (highLevelRemovals.t(rootId)) {
      var root = $this.g3t().g3f_1.a3h(rootId);
      if (root == null) {
        getRoot($this, rootId).n9f();
        return Unit_instance;
      }
      if ($this.fsz_1.wt0(rootId)) {
        getRoot($this, rootId).n9f();
        var destroyRootOperation = OperationBuilder_instance.k3z(root);
        $this.zsy_1.h3z(destroyRootOperation);
        return Unit_instance;
      }
      if (!getRoot($this, rootId).pt0()) {
        $this.xt0(rootId);
      }
      return Unit_instance;
    }
    var updateOps = ArrayList_init_$Create$();
    var _iterator__ex2g4s = highLevelRemovals.m();
    while (_iterator__ex2g4s.n()) {
      var id = _iterator__ex2g4s.o();
      var entity = $this.g3t().a3j().a3h(id);
      if (!(entity == null)) {
        updateOps.j(OperationConverter_instance.m3z(ensureNotNull(entity.bp()), OperationBuilder_instance.n3z(entity, ensureNotNull(entity.p3d_1))));
      }
    }
    $this.zsy_1.h3z(Companion_instance_68.b40(updateOps));
  }
  function cleanup_1($this, entity, redundantIds) {
    if (!$this.esz_1.i3j(entity.n3d_1)) {
      redundantIds.j(entity.n3d_1);
      return Unit_instance;
    }
    if ($this.yt0(entity.n3d_1)) {
      var _iterator__ex2g4s = entity.z3d().m();
      while (_iterator__ex2g4s.n()) {
        var childId = _iterator__ex2g4s.o();
        var _iterator__ex2g4s_0 = entity.a3e(childId).m();
        while (_iterator__ex2g4s_0.n()) {
          var child = _iterator__ex2g4s_0.o();
          cleanup_1($this, child, redundantIds);
        }
      }
    }
  }
  function isNotRegisteredInTree($this, rootId) {
    return !$this.esz_1.i3j(rootId);
  }
  function assertRootCommand($this, loadCommandId) {
    // Inline function 'kotlin.check' call
    if (!loadCommandId.k55()) {
      var message = 'Expected root load command: ' + loadCommandId.toString();
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
  }
  function fireCommandUnprocessed($this, commandId) {
    $this.hsz_1.k2s(Client$fireCommandUnprocessed$lambda(commandId));
    fireEntityUnprocessed($this, commandId.g55_1);
  }
  function fireEntityUnprocessed($this, rootId) {
    if ($this.asz_1.t(rootId)) {
      return Unit_instance;
    }
    $this.asz_1.j(rootId);
    $this.bsz_1.k2s(Client$fireEntityUnprocessed$lambda(rootId));
  }
  function MyPort_0($outer) {
    this.lsz_1 = $outer;
    var tmp = this;
    tmp.ksz_1 = new Client$MyPort$1(this.lsz_1, this);
  }
  protoOf(MyPort_0).ysm = function () {
    return this.ksz_1;
  };
  protoOf(MyPort_0).zt0 = function (output, internalErrorHandler) {
    // Inline function 'kotlin.check' call
    if (!(this.lsz_1.jsz_1 == null)) {
      var message = 'Output is already set';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    var tmp = this.lsz_1;
    tmp.jsz_1 = new Client$MyPort$setOutput$1(output, this.lsz_1);
    doConnect(this.lsz_1);
  };
  protoOf(MyPort_0).csn = function (output, internalErrorHandler) {
    return this.zt0((!(output == null) ? isInterface(output, OtChannel) : false) ? output : THROW_CCE(), internalErrorHandler);
  };
  protoOf(MyPort_0).zr = function () {
    var tmp0 = this.lsz_1.jsz_1;
    $l$block: {
      // Inline function 'kotlin.checkNotNull' call
      if (tmp0 == null) {
        var message = 'Connection has already been broken';
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      } else {
        break $l$block;
      }
    }
    this.lsz_1.jsz_1 = null;
    this.lsz_1.csz_1 = false;
    onConnectionBroken_0(this.lsz_1);
  };
  function Companion_414() {
    Companion_instance_414 = this;
    var tmp = this;
    var tmp_0 = KotlinLogging_getInstance();
    tmp.jt0_1 = tmp_0.i2q(Client$Companion$LOG$lambda);
  }
  var Companion_instance_414;
  function Companion_getInstance_414() {
    if (Companion_instance_414 == null)
      new Companion_414();
    return Companion_instance_414;
  }
  function Client$init$validator$1(this$0) {
    this.at1_1 = this$0;
  }
  protoOf(Client$init$validator$1).x3w = function (operationRootId, op) {
    var clientRoot = getRoot(this.at1_1, operationRootId);
    // Inline function 'kotlin.check' call
    if (!(!clientRoot.xsz() || clientRoot.io() || clientRoot.pt0())) {
      var message = '[operation on ' + clientRoot.tt0() + ' root]';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
  };
  function Client$init$listener$1(this$0) {
    this.ht0_1 = this$0;
  }
  protoOf(Client$init$listener$1).bt1 = function (op) {
    if (!(op == null)) {
      var operationRootId = ensureNotNull(OperationRootIdInfo_init_$Create$_0(op).v3x_1);
      var root = getRoot(this.ht0_1, operationRootId);
      root.jc8(op);
      var cmd = Command_init_$Create$(new RootCommandId(CommandId_init_$Create$(), operationRootId), root.grg(), op);
      this.ht0_1.hsz_1.k2s(Client$init$o$onCommandCommitted$lambda(cmd));
      (new OutgoingRequest()).rsz(root.psz(cmd));
      if (!this.ht0_1.qt0().uv()) {
        fireEntityUnprocessed(this.ht0_1, operationRootId);
      }
    }
    runCallbacks(this);
  };
  protoOf(Client$init$listener$1).v3y = function (op) {
    return this.bt1(op);
  };
  protoOf(Client$init$listener$1).gc7 = function (op) {
    if (!this.ht0_1.zsy_1.l3x_1) {
      runCallbacks(this);
    }
  };
  protoOf(Client$init$listener$1).x3y = function (op) {
    return this.gc7(op);
  };
  protoOf(Client$init$listener$1).y3y = function () {
    if (!this.ht0_1.zsy_1.l3x_1) {
      runCallbacks(this);
    }
  };
  function Client$fireProcessingRestored$lambda($rootId) {
    return function (listener) {
      listener.ct1($rootId);
      return Unit_instance;
    };
  }
  function Client$loadEntity$lambda($reference) {
    return function () {
      return 'postpone load ' + $reference.toString();
    };
  }
  function Client$loadEntity$lambda_0($result, this$0, $reference) {
    return function () {
      var tmp;
      if (!$result.lsy()) {
        $result.msy(doLoadEntity(this$0, $reference));
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function Client$doLoadEntity$lambda($reference) {
    return function () {
      return 'loading reference: ' + $reference.toString();
    };
  }
  function Client$doLoadEntity$lambda_0($reference, $status) {
    return function () {
      return 'status for reference ' + $reference.toString() + ' is ' + $status.toString();
    };
  }
  function Client$doLoadEntity$lambda_1($reference) {
    return function () {
      return 'reference ' + $reference.toString() + ' is being loaded';
    };
  }
  function Client$doLoadEntity$lambda_2($reference) {
    return function () {
      return 'root is being reconnecting, skipping message for ' + $reference.toString();
    };
  }
  function Client$doLoadEntity$lambda_3($reference) {
    return function () {
      return 'client is disconnected, skipping loading message for ' + $reference.toString();
    };
  }
  function Client$sendCommand$lambda($cmd) {
    return function (listener) {
      listener.dt1($cmd);
      return Unit_instance;
    };
  }
  function Client$commandRejected$lambda($rootCommandId, $reason) {
    return function (listener) {
      listener.et1($rootCommandId, $reason);
      return Unit_instance;
    };
  }
  function ProtocolListener$onConnectionEstablished$ref() {
    var l = function (p0) {
      p0.ft1();
      return Unit_instance;
    };
    l.callableName = 'onConnectionEstablished';
    return l;
  }
  function ProtocolListener$onConnectionBroken$ref() {
    var l = function (p0) {
      p0.gt1();
      return Unit_instance;
    };
    l.callableName = 'onConnectionBroken';
    return l;
  }
  function Client$getReferenceStatus$lambda($reference, $refRoot, $entity) {
    return function () {
      return 'Broken reference ' + $reference.toString() + ': actual root=' + $refRoot.toString() + ', entity=' + $entity.toString();
    };
  }
  function Client$fireAlreadyProcessed$lambda($receivedCommand) {
    return function (listener) {
      listener.ht1($receivedCommand);
      return Unit_instance;
    };
  }
  function Client$fireCommandReceived$lambda($receivedCommand) {
    return function (listener) {
      listener.it1($receivedCommand);
      return Unit_instance;
    };
  }
  function Client$fireCommandUnprocessed$lambda($commandId) {
    return function (listener) {
      listener.jt1($commandId);
      return Unit_instance;
    };
  }
  function Client$fireEntityUnprocessed$lambda($rootId) {
    return function (listener) {
      listener.kt1($rootId);
      return Unit_instance;
    };
  }
  function Client(context, merger, noModel, verboseLog, enableAddRemoveValidator, nodeFactory) {
    Companion_getInstance_414();
    nodeFactory = nodeFactory === VOID ? RawNodeFactory_instance : nodeFactory;
    this.wsy_1 = verboseLog;
    this.xsy_1 = nodeFactory;
    this.ysy_1 = new ValueProperty(false);
    this.asz_1 = HashSet_init_$Create$();
    this.bsz_1 = new Listeners();
    this.csz_1 = false;
    this.dsz_1 = HashMap_init_$Create$();
    this.esz_1 = new LoadedEntitiesTree();
    this.fsz_1 = new LoadingReferences();
    this.gsz_1 = HashMap_init_$Create$();
    this.hsz_1 = new Listeners();
    this.isz_1 = ArrayList_init_$Create$_0(0);
    this.jsz_1 = null;
    // Inline function 'kotlin.require' call
    if (!(!noModel || context.a3j().s())) {
      var message = 'To create client with state, use ' + toString_1(getKClass(Memento));
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    this.zsy_1 = newCommandProcessor(context, merger, true, enableAddRemoveValidator, this.xsy_1);
  }
  protoOf(Client).qt0 = function () {
    return this.ysy_1;
  };
  protoOf(Client).g3t = function () {
    return this.zsy_1.b3x_1;
  };
  protoOf(Client).lr7 = function () {
    // Inline function 'kotlin.check' call
    if (!!this.csz_1) {
      var message = 'Port is already opened';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    this.csz_1 = true;
    return new MyPort_0(this);
  };
  protoOf(Client).lt1 = function () {
    var validator = new Client$init$validator$1(this);
    this.zsy_1.b3z(validator);
    var listener = new Client$init$listener$1(this);
    this.zsy_1.d3z(listener);
  };
  protoOf(Client).mt1 = function (wrapperContext, edt) {
    // Inline function 'kotlin.check' call
    if (!equals(this.g3t(), wrapperContext.c56_1)) {
      var message = "Client can't be bound to WrapperContext with not same EntityContext";
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    // Inline function 'kotlin.check' call
    if (!(wrapperContext.n58(get_COMMAND_PROCESSOR_KEY()) == null)) {
      var message_0 = 'WrapperContext already has CommandProcessor';
      throw IllegalStateException_init_$Create$_0(toString_1(message_0));
    }
    wrapperContext.o58(get_COMMAND_PROCESSOR_KEY(), this.zsy_1);
    wrapperContext.u56_1 = new ClientLoadingPeer(this, edt);
  };
  protoOf(Client).zr = function () {
    return this.zsy_1.zr();
  };
  protoOf(Client).nt1 = function (reference) {
    return this.ot1(reference).jsy_1;
  };
  protoOf(Client).ot1 = function (reference) {
    var tmp;
    if (commandInProgress(this)) {
      if (this.wsy_1) {
        var tmp_0 = Companion_getInstance_414().jt0_1;
        tmp_0.x2p(Client$loadEntity$lambda(reference));
      }
      var result = new AsyncWithDisposable(new SimpleAsync());
      this.isz_1.j(Client$loadEntity$lambda_0(result, this, reference));
      tmp = result;
    } else {
      tmp = doLoadEntity(this, reference);
    }
    return tmp;
  };
  protoOf(Client).pt1 = function (memento) {
    // Inline function 'kotlin.check' call
    if (!this.dsz_1.s()) {
      var message = 'Client already has internal state';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    if (!(memento.st1_1 == null)) {
      this.esz_1 = ensureNotNull(memento.st1_1);
    }
    var restored = memento.rt1_1;
    var _iterator__ex2g4s = this.g3t().g3f_1.m();
    while (_iterator__ex2g4s.n()) {
      var root = _iterator__ex2g4s.o();
      var rootId = root.n3d_1;
      var m = ensureNotNull(restored).u2(rootId);
      new ClientRootImpl(rootId, this, ensureNotNull(m), this.xsy_1);
    }
    // Inline function 'kotlin.check' call
    if (!ensureNotNull(restored).s()) {
      var message_0 = 'Roots set mismatch';
      throw IllegalStateException_init_$Create$_0(toString_1(message_0));
    }
    memento.k2();
  };
  protoOf(Client).rt0 = function (rootId, entityId) {
    ensureNotNull(this.jsz_1).uso(LoadCommandId_init_$Create$(rootId, entityId));
  };
  protoOf(Client).tt1 = function (cmd) {
    ensureNotNull(this.jsz_1).nso(cmd);
    this.hsz_1.k2s(Client$sendCommand$lambda(cmd));
  };
  protoOf(Client).at0 = function (rootCommandId, reason) {
    ensureNotNull(this.jsz_1).qso(rootCommandId);
    this.hsz_1.k2s(Client$commandRejected$lambda(rootCommandId, reason));
  };
  protoOf(Client).xt0 = function (rootId) {
    this.ut1(setOf(rootId));
  };
  protoOf(Client).ut1 = function (rootIds) {
    var _iterator__ex2g4s = rootIds.m();
    while (_iterator__ex2g4s.n()) {
      var rootId = _iterator__ex2g4s.o();
      checkCanBeUnloaded(this, rootId);
    }
    if (!rootIds.s() && this.qt0().uv()) {
      ensureNotNull(this.jsz_1).asp(CommandId_init_$Create$(), rootIds);
    }
    var _iterator__ex2g4s_0 = rootIds.m();
    while (_iterator__ex2g4s_0.n()) {
      var rootId_0 = _iterator__ex2g4s_0.o();
      getRoot(this, rootId_0).vt1();
    }
  };
  protoOf(Client).wt1 = function (rootId) {
    var root = this.g3t().g3f_1.a3h(rootId);
    if (root == null) {
      // Inline function 'kotlin.check' call
      if (!!this.esz_1.i3j(rootId)) {
        var message = rootId.toString() + ' is not in loaded entities';
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      }
    } else {
      var redundantIds = HashSet_init_$Create$();
      cleanup_1(this, root, redundantIds);
      applyHighLevelRemovals(this, rootId, redundantIds);
    }
  };
  protoOf(Client).kt0 = function (reference) {
    var tmp0_elvis_lhs = this.g3t().a3j().a3h(reference.k3j_1);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return ReferenceStatus_NOT_LOADED_getInstance();
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var entity = tmp;
    var refRoot = ensureNotNull(Entities_getInstance().t3e(entity));
    var tmp_0;
    if (reference.j3j_1.equals(refRoot.n3d_1)) {
      var tmp_1;
      if (this.esz_1.aso(entity)) {
        tmp_1 = ReferenceStatus_LOADED_getInstance();
      } else {
        tmp_1 = ReferenceStatus_NOT_LOADED_getInstance();
      }
      tmp_0 = tmp_1;
    } else {
      var tmp_2 = Companion_getInstance_414().jt0_1;
      tmp_2.c2q(Client$getReferenceStatus$lambda(reference, refRoot, entity));
      tmp_0 = ReferenceStatus_ERROR_getInstance();
    }
    return tmp_0;
  };
  protoOf(Client).yt0 = function (id) {
    return this.esz_1.zsn(id);
  };
  protoOf(Client).xt1 = function (entity) {
    if (!this.esz_1.aso(entity)) {
      this.esz_1.cso(entity);
    }
  };
  protoOf(Client).yt1 = function (rootId) {
    return this.dsz_1.o2(rootId) && !isNotRegisteredInTree(this, rootId);
  };
  protoOf(Client).zt1 = function (root) {
    var rootId = root.m3w();
    // Inline function 'kotlin.collections.set' call
    this.dsz_1.t2(rootId, root);
    if (isNotRegisteredInTree(this, rootId) && !this.fsz_1.wt0(rootId)) {
      this.esz_1.bso(rootId);
    }
  };
  protoOf(Client).at2 = function (rootId) {
    this.esz_1.dso(rootId);
    this.dsz_1.u2(rootId);
  };
  protoOf(Client).osz = function (commandId, baseVersion, resultVersion) {
    ensureNotNull(this.jsz_1).oso(commandId, baseVersion, resultVersion);
  };
  protoOf(Client).bt2 = function (receivedCommand) {
    this.hsz_1.k2s(Client$fireAlreadyProcessed$lambda(receivedCommand));
  };
  protoOf(Client).ct2 = function (receivedCommand) {
    this.hsz_1.k2s(Client$fireCommandReceived$lambda(receivedCommand));
  };
  protoOf(Client).dt2 = function (rootId, buildOperation) {
    var root = this.g3t().g3f_1.a3h(rootId);
    var info = OperationRootIdInfo_init_$Create$_0(buildOperation);
    // Inline function 'kotlin.check' call
    if (!info.x3x()) {
      var message = ensureNotNull(info.w3x_1);
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    // Inline function 'kotlin.check' call
    if (!equals(info.v3x_1, rootId)) {
      var message_0 = 'Command for different root: expected ' + rootId + ', got ' + toString_0(info.v3x_1);
      throw IllegalStateException_init_$Create$_0(toString_1(message_0));
    }
    // Inline function 'kotlin.check' call
    if (!RootOperationsUtil_instance.qsp(rootId, buildOperation)) {
      var message_1 = 'Invalid build operation for ' + toString_0(root) + ': ' + toString_1(buildOperation);
      throw IllegalStateException_init_$Create$_0(toString_1(message_1));
    }
    var context = new EntityContext();
    buildOperation.y3x(context, this.xsy_1);
    var target = context.g3f_1.a3h(rootId);
    // Inline function 'kotlin.collections.remove' call
    var this_0 = context.g3f_1;
    (isInterface(this_0, MutableCollection) ? this_0 : THROW_CCE()).h2(target);
    this.zsy_1.i3z(rootId);
    var entityDiffBuilder = new EntityDiffBuilder(ensureNotNull(root), ensureNotNull(target));
    return entityDiffBuilder.u47();
  };
  function defaultMerger($this) {
    return new AccumulatorBasedMerger();
  }
  function withEmptyModel($this, context) {
    return build($this, context, true);
  }
  function fromMemento($this) {
    var currentMemento = $this.it2_1;
    var noModel = ensureNotNull(currentMemento).w2m();
    var entityContext = noModel ? new EntityContext() : ensureNotNull(currentMemento.qt1_1);
    var client = build($this, entityContext, noModel);
    if (!noModel) {
      client.pt1(currentMemento);
    }
    return client;
  }
  function build($this, context, noModel) {
    var merger = $this.ht2_1;
    if (merger == null) {
      merger = defaultMerger($this);
      $this.ht2_1 = merger;
    }
    var client = new Client(context, merger, noModel, $this.ft2_1, $this.gt2_1, $this.et2_1);
    client.lt1();
    return client;
  }
  function ClientBuilder(nodeFactory) {
    nodeFactory = nodeFactory === VOID ? RawNodeFactory_instance : nodeFactory;
    this.et2_1 = nodeFactory;
    this.ft2_1 = false;
    this.gt2_1 = true;
    this.ht2_1 = null;
    this.it2_1 = null;
    this.jt2_1 = null;
  }
  protoOf(ClientBuilder).f40 = function () {
    var tmp;
    if (this.it2_1 == null) {
      var tmp0_elvis_lhs = this.jt2_1;
      tmp = withEmptyModel(this, tmp0_elvis_lhs == null ? new EntityContext() : tmp0_elvis_lhs);
    } else {
      tmp = fromMemento(this);
    }
    return tmp;
  };
  protoOf(ClientBuilder).kt2 = function (context) {
    // Inline function 'kotlin.check' call
    if (!(this.it2_1 == null)) {
      var message = 'Either memento or entity context should be used to configure client';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    // Inline function 'kotlin.check' call
    if (!(this.jt2_1 == null)) {
      var message_0 = 'EntityContext is already set';
      throw IllegalStateException_init_$Create$_0(toString_1(message_0));
    }
    this.jt2_1 = context;
    return this;
  };
  function ClientLoadingPeer$Companion$LOG$lambda() {
    return Unit_instance;
  }
  function Companion_415() {
    Companion_instance_415 = this;
    var tmp = this;
    var tmp_0 = KotlinLogging_getInstance();
    tmp.lt2_1 = tmp_0.i2q(ClientLoadingPeer$Companion$LOG$lambda);
  }
  var Companion_instance_415;
  function Companion_getInstance_415() {
    if (Companion_instance_415 == null)
      new Companion_415();
    return Companion_instance_415;
  }
  function ClientLoadingPeer(client, edt) {
    Companion_getInstance_415();
    this.mt2_1 = client;
    this.nt2_1 = edt;
  }
  var State_NONE_instance;
  var State_RECONNECTING_instance;
  var State_ACTIVE_instance;
  var State_UNLOADING_instance;
  var State_entriesInitialized_2;
  function State_initEntries_2() {
    if (State_entriesInitialized_2)
      return Unit_instance;
    State_entriesInitialized_2 = true;
    State_NONE_instance = new State_3('NONE', 0);
    State_RECONNECTING_instance = new State_3('RECONNECTING', 1);
    State_ACTIVE_instance = new State_3('ACTIVE', 2);
    State_UNLOADING_instance = new State_3('UNLOADING', 3);
  }
  function _get_isNonExistent__5hkdae($this) {
    return $this.st2_1.equals(State_NONE_getInstance());
  }
  function _get_isAlive__mwnani($this) {
    return $this.xsz() && !$this.nsy();
  }
  function _get_root__dd8asp($this) {
    return $this.pt2_1.g3t().g3f_1.a3h($this.ot2_1);
  }
  function _get_loadingIdsWithoutAsyncs__8u76oe($this) {
    var loadingEntityIds = HashSet_init_$Create$_0($this.pt2_1.fsz_1.ut2($this.ot2_1));
    loadingEntityIds.j1($this.tt2_1.r2());
    return loadingEntityIds;
  }
  function _get_isZeroVersionRoot__ff8urt($this) {
    var tmp;
    if (_get_isNonExistent__5hkdae($this)) {
      tmp = false;
    } else {
      tmp = (!($this.rt2_1 == null) && ensureNotNull($this.rt2_1).wt2_1 === 0 && !ensureNotNull($this.rt2_1).w2m());
    }
    return tmp;
  }
  function _get_idStateMessage__ekeloa($this) {
    return 'rootId=' + $this.ot2_1.toString() + ', state=' + $this.st2_1.toString();
  }
  function activate($this, operation) {
    setupCommandQueue_0($this, operation);
    doActivate($this);
  }
  function doActivate($this) {
    $this.st2_1 = State_ACTIVE_getInstance();
    $this.pt2_1.zt1($this);
  }
  function setActive($this) {
    $this.st2_1 = State_ACTIVE_getInstance();
    // Inline function 'kotlin.check' call
    if (!!(!(_get_root__dd8asp($this) == null) && !$this.pt2_1.yt1($this.ot2_1))) {
      var message = _get_idStateMessage__ekeloa($this);
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
  }
  function getAsyncsHandler($this, id) {
    // Inline function 'kotlin.collections.getOrPut' call
    var this_0 = $this.tt2_1;
    var value = this_0.q2(id);
    var tmp;
    if (value == null) {
      var answer = new AsyncsListHandler();
      this_0.t2(id, answer);
      tmp = answer;
    } else {
      tmp = value;
    }
    return tmp;
  }
  function failLoadAsyncs($this, entityId, reason) {
    var loadingReferences = $this.pt2_1.fsz_1;
    if (loadingReferences.zt2($this.ot2_1, entityId)) {
      loadingReferences.yt2($this.ot2_1, entityId);
    }
    if ($this.tt2_1.o2(entityId)) {
      ensureNotNull($this.tt2_1.u2(entityId)).msn(reason);
    }
  }
  function succeedLoadAsyncs($this, entityId) {
    if ($this.ot2_1.equals(entityId)) {
      handleAllLoadAsyncs($this);
    } else {
      // Inline function 'kotlin.collections.containsKey' call
      var this_0 = $this.tt2_1;
      if ((isInterface(this_0, KtMap) ? this_0 : THROW_CCE()).o2(entityId)) {
        handleEntityLoadAsyncs($this, ensureNotNull(entityId));
      }
    }
  }
  function handleAllLoadAsyncs($this) {
    updateLoadingRefsStates($this, $this.tt2_1.r2());
    var _iterator__ex2g4s = LinkedHashSet_init_$Create$_0($this.tt2_1.r2()).m();
    while (_iterator__ex2g4s.n()) {
      var id = _iterator__ex2g4s.o();
      var entity = getEntity($this, id);
      if (entity == null) {
        ensureNotNull($this.tt2_1.u2(id)).msn(RejectionReason_NOT_FOUND_getInstance());
      } else {
        ensureNotNull($this.tt2_1.u2(id)).lsn(entity);
      }
    }
  }
  function updateLoadingRefsStates($this, toRemoveFromLoadingRefs) {
    var _iterator__ex2g4s = toRemoveFromLoadingRefs.m();
    while (_iterator__ex2g4s.n()) {
      var id = _iterator__ex2g4s.o();
      $this.pt2_1.fsz_1.yt2($this.ot2_1, id);
    }
    var _iterator__ex2g4s_0 = $this.tt2_1.r2().m();
    while (_iterator__ex2g4s_0.n()) {
      var id_0 = _iterator__ex2g4s_0.o();
      var entity = getEntity($this, id_0);
      if (!(entity == null)) {
        $this.pt2_1.xt1(entity);
      }
    }
    $this.pt2_1.wt1($this.ot2_1);
  }
  function handleEntityLoadAsyncs($this, id) {
    $this.pt2_1.fsz_1.yt2($this.ot2_1, id);
    var entity = getEntity($this, id);
    if (entity == null) {
      $this.pt2_1.wt1($this.ot2_1);
      ensureNotNull($this.tt2_1.u2(id)).msn(RejectionReason_NOT_FOUND_getInstance());
    } else {
      $this.pt2_1.xt1(entity);
      ensureNotNull($this.tt2_1.u2(id)).lsn(entity);
    }
  }
  function getEntity($this, entityId) {
    return $this.pt2_1.g3t().a3j().a3h(entityId);
  }
  function onLoadAccepted_0($this, entityId) {
    var isLoading = $this.pt2_1.fsz_1.zt2($this.ot2_1, entityId);
    if (isLoading && !$this.tt2_1.o2(entityId)) {
      $this.pt2_1.fsz_1.yt2($this.ot2_1, entityId);
      if (!$this.pt2_1.fsz_1.wt0($this.ot2_1) && !$this.pt2_1.esz_1.i3j($this.ot2_1)) {
        $this.pt2_1.xt0($this.ot2_1);
      }
    } else {
      onRootBecameActive($this);
      succeedLoadAsyncs($this, entityId);
    }
  }
  function onLoadRejected_0($this, entityId, reason) {
    if (!(getEntity($this, entityId) == null) && !$this.pt2_1.yt0(entityId)) {
      succeedLoadAsyncs($this, entityId);
      return Unit_instance;
    }
    failLoadAsyncs($this, entityId, reason);
    if ($this.ot2_1.equals(entityId) && !$this.pt2_1.yt0($this.ot2_1)) {
      remove_0($this);
    }
  }
  function reconnect($this) {
    switch ($this.st2_1.x2_1) {
      case 0:
        processPendingLoadingAsyncs($this);
        break;
      case 2:
        $this.st2_1 = State_RECONNECTING_getInstance();
        break;
      default:
        throw IllegalStateException_init_$Create$_0(_get_idStateMessage__ekeloa($this));
    }
  }
  function processPendingLoadingAsyncs($this) {
    cleanupLoadingEntitiesWithoutAsyncs($this);
    var _iterator__ex2g4s = LinkedHashSet_init_$Create$_0($this.tt2_1.r2()).m();
    while (_iterator__ex2g4s.n()) {
      var id = _iterator__ex2g4s.o();
      var status = $this.pt2_1.kt0(new EntityReference($this.ot2_1, id));
      if (!(status === ReferenceStatus_NOT_LOADED_getInstance())) {
        $this.pt2_1.fsz_1.yt2($this.ot2_1, id);
        if (status === ReferenceStatus_LOADED_getInstance()) {
          ensureNotNull($this.tt2_1.u2(id)).lsn(ensureNotNull(getEntity($this, id)));
        } else {
          ensureNotNull($this.tt2_1.u2(id)).msn(RejectionReason_NOT_FOUND_getInstance());
        }
      }
    }
    var _iterator__ex2g4s_0 = $this.tt2_1.r2().m();
    while (_iterator__ex2g4s_0.n()) {
      var id_0 = _iterator__ex2g4s_0.o();
      $this.pt2_1.rt0($this.ot2_1, id_0);
    }
  }
  function cleanupLoadingEntitiesWithoutAsyncs($this) {
    var _iterator__ex2g4s = _get_loadingIdsWithoutAsyncs__8u76oe($this).m();
    while (_iterator__ex2g4s.n()) {
      var loadingIdWithoutAsyncs = _iterator__ex2g4s.o();
      if (!($this.pt2_1.g3t().a3j().a3h(loadingIdWithoutAsyncs) == null)) {
        throw RuntimeException_init_$Create$();
      }
      $this.pt2_1.fsz_1.yt2($this.ot2_1, loadingIdWithoutAsyncs);
    }
  }
  function remove_0($this) {
    if ($this.xsz()) {
      if (!(_get_root__dd8asp($this) == null)) {
        doRemoveRoot($this);
      }
      $this.n9f();
    }
  }
  function doRemoveRoot($this) {
    var op = OperationBuilder_instance.k3z(ensureNotNull(_get_root__dd8asp($this)));
    $this.pt2_1.zsy_1.h3z(op);
  }
  function commitNewRoot($this) {
    // Inline function 'kotlin.check' call
    if (!RootOperationsUtil_instance.osp($this.ot2_1, ensureNotNull($this.rt2_1).at3().e55_1)) {
      var message = 'Root operations without root creation, id=' + $this.ot2_1.toString();
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    commitQueue($this);
  }
  function onReconnectAccepted($this) {
    // Inline function 'kotlin.check' call
    if (!$this.pt0()) {
      var message = _get_idStateMessage__ekeloa($this);
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    onRootBecameActive($this);
    processPendingLoadingAsyncs($this);
  }
  function onReconnectRejected_0($this, reason) {
    processPendingLoadingAsyncs($this);
    if (_get_isNonExistent__5hkdae($this))
      return Unit_instance;
    // Inline function 'kotlin.check' call
    if (!$this.pt0()) {
      var message = _get_idStateMessage__ekeloa($this);
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    switch (reason.x2_1) {
      case 0:
        if (_get_isZeroVersionRoot__ff8urt($this)) {
          commitNewRoot($this);
          setActive($this);
        } else {
          remove_0($this);
        }

        break;
      case 1:
        remove_0($this);
        break;
      case 2:
        throw IllegalStateException_init_$Create$_0(reconnectRejectedMessage($this, "Possible reasons are: entity '" + $this.ot2_1.toString() + "' is not a root or reconnect command contains invalid data"));
      case 3:
        throw IllegalStateException_init_$Create$_0(reconnectRejectedMessage($this, 'Server internal error occurred'));
      default:
        throw IllegalStateException_init_$Create$_0('Unknown rejection reason: ' + reason.toString());
    }
  }
  function reconnectRejectedMessage($this, details) {
    var r = $this.pt2_1.g3t().d3j($this.ot2_1);
    var root = r == null ? 'rootId=' + $this.ot2_1.q36_1 : 'root=' + r.toString();
    return 'Reconnect rejected for ' + root + '. ' + details + '. See server log for details.';
  }
  function onConnectionBroken_1($this) {
    switch ($this.st2_1.x2_1) {
      case 0:
        throw IllegalStateException_init_$Create$();
      case 1:
        setActive($this);
        break;
      case 3:
        $this.et0();
        break;
      case 2:
        updateLoadingRefsStates($this, _get_loadingIdsWithoutAsyncs__8u76oe($this));
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
  }
  function onCommandCommitted_0($this, commandId, operation) {
    // Inline function 'kotlin.check' call
    if (!_get_isAlive__mwnani($this)) {
      var message = _get_idStateMessage__ekeloa($this);
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    var toTransit = addCommand($this, commandId, operation);
    if ($this.pt2_1.qt0().uv() && !$this.pt0()) {
      transitCommand($this, toTransit);
    }
  }
  function addCommand($this, id, op) {
    var cmd = Command_init_$Create$(new RootCommandId(id, $this.ot2_1), ensureNotNull($this.rt2_1).wt2_1, op);
    ensureNotNull($this.rt2_1).bt3(cmd);
    return cmd;
  }
  function transitCommand($this, command) {
    $this.pt2_1.tt1(command);
  }
  function commitQueue($this) {
    var _iterator__ex2g4s = ensureNotNull($this.rt2_1).ct3().m();
    while (_iterator__ex2g4s.n()) {
      var cmd = _iterator__ex2g4s.o();
      transitCommand($this, cmd);
    }
  }
  function onCommandReceived_0($this, command) {
    if (_get_isNonExistent__5hkdae($this)) {
      activate($this, command.e55_1);
    }
    if (ensureNotNull($this.rt2_1).dt3(command.b55_1)) {
      poll($this, command.b55_1, true);
      updateVersion($this, command.b55_1, command.c55_1, command.d55_1);
      $this.pt2_1.osz(command.b55_1, command.c55_1, command.d55_1);
      $this.pt2_1.bt2(command);
      return Unit_instance;
    }
    if ($this.pt0() && $this.grg() > 0 && command.c55_1 === 0) {
      var newOperation = $this.pt2_1.dt2($this.ot2_1, command.e55_1);
      invalidateCommandQueue($this);
      doExecuteExternalCommand($this, command.b55_1, command.c55_1, command.d55_1, newOperation);
      $this.pt2_1.ct2(command);
    } else {
      doExecuteExternalCommand($this, command.b55_1, command.c55_1, command.d55_1, transform_0($this, command).e55_1);
      $this.pt2_1.ct2(command);
    }
  }
  function doExecuteExternalCommand($this, id, baseV, resultV, op) {
    $this.pt2_1.osz(id, baseV, resultV);
    doExecuteExternalOp($this, op);
    updateVersion($this, id, baseV, resultV);
  }
  function doExecuteExternalOp($this, op) {
    $this.pt2_1.zsy_1.h3z(op);
    cleanUpCommandQueue($this);
  }
  function updateVersion($this, id, baseV, resultV) {
    if ($this.rt2_1 == null)
      return Unit_instance;
    // Inline function 'kotlin.check' call
    if (!(baseV === ensureNotNull($this.rt2_1).wt2_1)) {
      var message = toString_1($this.pt2_1) + ' model version is ' + ensureNotNull($this.rt2_1).wt2_1 + '; received command ' + id.toString() + ', ' + baseV + '->' + resultV;
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    ensureNotNull($this.rt2_1).wt2_1 = resultV;
  }
  function onCommandAccepted_0($this, id, baseVersion, resultVersion) {
    var cmd = poll($this, id, true);
    var commandQueue = $this.rt2_1;
    if (!(commandQueue == null)) {
      // Inline function 'kotlin.check' call
      if (!(commandQueue.wt2_1 === baseVersion || RootOperationsUtil_instance.osp(id.g55_1, cmd.e55_1))) {
        var message = 'Versions mismatch for accepted command';
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      }
      commandQueue.wt2_1 = resultVersion;
    }
  }
  function onCommandRejected_0($this, id, reason) {
    if (!$this.io()) {
      var tmp = _get_idStateMessage__ekeloa($this) + ' reason=' + reason.toString();
      var tmp_0;
      if ($this.rt2_1 == null) {
        tmp_0 = ' message queue is null';
      } else {
        tmp_0 = ' last command=' + toString_0(ensureNotNull($this.rt2_1).et3());
      }
      var msg = tmp + tmp_0;
      throw IllegalStateException_init_$Create$_0(msg);
    }
    var command = poll($this, id, false);
    var inverse = command.e55_1.q3z();
    var inverseCommand = new Command(command.b55_1, 0, 0, inverse);
    var toApply = transform_0($this, inverseCommand);
    doExecuteExternalOp($this, toApply.e55_1);
    $this.pt2_1.at0(id, reason);
    resendCommands($this);
  }
  function transform_0($this, command) {
    var commandQueue = $this.rt2_1;
    var tmp;
    if (commandQueue == null) {
      tmp = command;
    } else {
      var newCommand = commandQueue.ft3(command);
      commandQueue.gt3(command);
      tmp = newCommand;
    }
    return tmp;
  }
  function poll($this, toVerify, cleanup) {
    var cmd = ensureNotNull($this.rt2_1).ht3();
    if (cleanup) {
      cleanUpCommandQueue($this);
    }
    // Inline function 'kotlin.check' call
    if (!cmd.b55_1.equals(toVerify)) {
      var message = 'Invalid command, expected: ' + cmd.b55_1.toString() + '; actual: ' + toVerify.toString();
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    return cmd;
  }
  function cleanUpCommandQueue($this) {
    var commandQueue = $this.rt2_1;
    if (!(commandQueue == null) && commandQueue.w2m() && _get_root__dd8asp($this) == null) {
      $this.n9f();
    }
  }
  function onRootBecameActive($this) {
    if ($this.io() || $this.nsy())
      return Unit_instance;
    setActive($this);
    resendCommands($this);
  }
  function resendCommands($this) {
    var commandQueue = $this.rt2_1;
    if (!(commandQueue == null)) {
      commandQueue.it3();
      commitQueue($this);
    }
  }
  function setupCommandQueue($this, baseVersion) {
    // Inline function 'kotlin.check' call
    if (!($this.rt2_1 == null)) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    $this.rt2_1 = new CommandQueue($this.ot2_1);
    ensureNotNull($this.rt2_1).wt2_1 = baseVersion;
  }
  function setupCommandQueue_0($this, op) {
    if ($this.rt2_1 == null) {
      // Inline function 'kotlin.check' call
      if (!RootOperationsUtil_instance.qsp($this.ot2_1, op)) {
        var message = 'Invalid root operation: ' + toString_1(op);
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      }
      setupCommandQueue($this, 0);
    }
  }
  function invalidateCommandQueue($this) {
    // Inline function 'kotlin.checkNotNull' call
    var tmp0 = $this.rt2_1;
    $l$block: {
      // Inline function 'kotlin.checkNotNull' call
      if (tmp0 == null) {
        var message = 'Required value was null.';
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      } else {
        break $l$block;
      }
    }
    $this.rt2_1 = new CommandQueue($this.ot2_1);
    ensureNotNull($this.rt2_1).wt2_1 = 0;
  }
  function State_3(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function LoadHandler($outer) {
    this.jt3_1 = $outer;
  }
  protoOf(LoadHandler).kt3 = function (acceptance) {
    onLoadAccepted_0(this.jt3_1, ensureNotNull(acceptance.usz_1));
  };
  protoOf(LoadHandler).lt3 = function (rejection) {
    onLoadRejected_0(this.jt3_1, ensureNotNull(rejection.ct0_1), rejection.dt0_1);
  };
  protoOf(LoadHandler).mt3 = function (request) {
    throw UnsupportedOperationException_init_$Create$();
  };
  protoOf(LoadHandler).nt3 = function (request) {
    throw UnsupportedOperationException_init_$Create$();
  };
  function ReconnectHandler($outer) {
    this.ot3_1 = $outer;
  }
  protoOf(ReconnectHandler).kt3 = function (acceptance) {
    return onReconnectAccepted(this.ot3_1);
  };
  protoOf(ReconnectHandler).lt3 = function (rejection) {
    return onReconnectRejected_0(this.ot3_1, rejection.dt0_1);
  };
  protoOf(ReconnectHandler).mt3 = function (request) {
    return onConnectionBroken_1(this.ot3_1);
  };
  protoOf(ReconnectHandler).nt3 = function (request) {
    return reconnect(this.ot3_1);
  };
  function EventHandler($outer) {
    this.pt3_1 = $outer;
  }
  protoOf(EventHandler).mt3 = function (request) {
    throw UnsupportedOperationException_init_$Create$();
  };
  protoOf(EventHandler).nt3 = function (request) {
    throw UnsupportedOperationException_init_$Create$();
  };
  protoOf(EventHandler).kt3 = function (acceptance) {
    onCommandAccepted_0(this.pt3_1, new RootCommandId(acceptance.tsz_1, this.pt3_1.ot2_1), ensureNotNull(acceptance.vsz_1), ensureNotNull(acceptance.wsz_1));
  };
  protoOf(EventHandler).lt3 = function (rejection) {
    onCommandRejected_0(this.pt3_1, new RootCommandId(rejection.bt0_1, this.pt3_1.ot2_1), rejection.dt0_1);
  };
  function CommandEventHandler($outer, command) {
    this.st3_1 = $outer;
    EventHandler.call(this, $outer);
    this.rt3_1 = command;
  }
  protoOf(CommandEventHandler).mt3 = function (request) {
    return onCommandReceived_0(this.st3_1, this.rt3_1);
  };
  protoOf(CommandEventHandler).nt3 = function (request) {
    onCommandCommitted_0(this.st3_1, this.rt3_1.b55_1.f55_1, this.rt3_1.e55_1);
  };
  function ClientRootImpl$load$$inlined$toDisposable$1(this$0, $entityId, $async) {
    this.tt3_1 = this$0;
    this.ut3_1 = $entityId;
    this.vt3_1 = $async;
  }
  protoOf(ClientRootImpl$load$$inlined$toDisposable$1).zr = function () {
    var asyncsHandler = this.tt3_1.tt2_1.q2(this.ut3_1);
    if (!(asyncsHandler == null) && asyncsHandler.isn(this.vt3_1)) {
      asyncsHandler.jsn(this.vt3_1);
      if (asyncsHandler.x2g() === 0) {
        this.tt3_1.tt2_1.u2(this.ut3_1);
      }
    }
    return Unit_instance;
  };
  function State_NONE_getInstance() {
    State_initEntries_2();
    return State_NONE_instance;
  }
  function State_RECONNECTING_getInstance() {
    State_initEntries_2();
    return State_RECONNECTING_instance;
  }
  function State_ACTIVE_getInstance() {
    State_initEntries_2();
    return State_ACTIVE_instance;
  }
  function State_UNLOADING_getInstance() {
    State_initEntries_2();
    return State_UNLOADING_instance;
  }
  function ClientRootImpl(rootId, client, memento, nodeFactory) {
    memento = memento === VOID ? null : memento;
    nodeFactory = nodeFactory === VOID ? RawNodeFactory_instance : nodeFactory;
    this.ot2_1 = rootId;
    this.pt2_1 = client;
    this.qt2_1 = nodeFactory;
    this.rt2_1 = null;
    this.st2_1 = State_NONE_getInstance();
    this.tt2_1 = LinkedHashMap_init_$Create$();
    if (!(memento == null)) {
      setupCommandQueue(this, memento.wt3_1);
      var _iterator__ex2g4s = memento.xt3_1.m();
      while (_iterator__ex2g4s.n()) {
        var command = _iterator__ex2g4s.o();
        ensureNotNull(this.rt2_1).bt3(command);
      }
      doActivate(this);
    }
  }
  protoOf(ClientRootImpl).m3w = function () {
    return this.ot2_1;
  };
  protoOf(ClientRootImpl).grg = function () {
    // Inline function 'kotlin.check' call
    if (!_get_isAlive__mwnani(this)) {
      var message = _get_idStateMessage__ekeloa(this);
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    return ensureNotNull(this.rt2_1).wt2_1;
  };
  protoOf(ClientRootImpl).tt0 = function () {
    var tmp;
    if (!this.tt2_1.s()) {
      tmp = 'loading';
    } else {
      // Inline function 'kotlin.text.lowercase' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = this.st2_1.w2_1.toLowerCase();
    }
    return tmp;
  };
  protoOf(ClientRootImpl).pt0 = function () {
    return this.st2_1.equals(State_RECONNECTING_getInstance());
  };
  protoOf(ClientRootImpl).nsy = function () {
    return this.st2_1.equals(State_UNLOADING_getInstance());
  };
  protoOf(ClientRootImpl).io = function () {
    return this.st2_1.equals(State_ACTIVE_getInstance());
  };
  protoOf(ClientRootImpl).xsz = function () {
    return !this.st2_1.equals(State_NONE_getInstance());
  };
  protoOf(ClientRootImpl).zsz = function () {
    return new LoadHandler(this);
  };
  protoOf(ClientRootImpl).ysz = function () {
    return new ReconnectHandler(this);
  };
  protoOf(ClientRootImpl).toString = function () {
    return this.ot2_1.q36_1 + '(' + this.st2_1.toString() + ')';
  };
  protoOf(ClientRootImpl).nt0 = function (entityId) {
    var loadRoot = this.ot2_1.equals(entityId);
    // Inline function 'kotlin.check' call
    if (!!(loadRoot && _get_isZeroVersionRoot__ff8urt(this))) {
      var message = 'Loading root with history, ' + _get_idStateMessage__ekeloa(this);
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    var async = getAsyncsHandler(this, entityId).ksn();
    // Inline function 'jetbrains.ocelot.base.disposable.toDisposable' call
    var tmp$ret$2 = new ClientRootImpl$load$$inlined$toDisposable$1(this, entityId, async);
    return new AsyncWithDisposable(async, tmp$ret$2);
  };
  protoOf(ClientRootImpl).vt1 = function () {
    doRemoveRoot(this);
    if (this.pt2_1.qt0().uv()) {
      this.st2_1 = State_UNLOADING_getInstance();
      this.rt2_1 = null;
    } else {
      this.n9f();
    }
  };
  protoOf(ClientRootImpl).et0 = function () {
    // Inline function 'kotlin.check' call
    if (!this.nsy()) {
      var message = _get_idStateMessage__ekeloa(this);
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    this.n9f();
  };
  protoOf(ClientRootImpl).jc8 = function (operation) {
    if (_get_isNonExistent__5hkdae(this)) {
      activate(this, operation);
    }
  };
  protoOf(ClientRootImpl).n9f = function () {
    this.pt2_1.at2(this.ot2_1);
    this.st2_1 = State_NONE_getInstance();
    this.rt2_1 = null;
  };
  protoOf(ClientRootImpl).psz = function (command) {
    return new CommandEventHandler(this, command);
  };
  protoOf(ClientRootImpl).ssz = function () {
    return new EventHandler(this);
  };
  function getIndex($this, id) {
    var tmp0 = $this.xt2_1;
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.indexOfFirst' call
      var index = 0;
      var _iterator__ex2g4s = tmp0.m();
      while (_iterator__ex2g4s.n()) {
        var item = _iterator__ex2g4s.o();
        if (item.b55_1.equals(id)) {
          tmp$ret$1 = index;
          break $l$block;
        }
        index = index + 1 | 0;
      }
      tmp$ret$1 = -1;
    }
    return tmp$ret$1;
  }
  function CommandQueue(rootId) {
    this.vt2_1 = rootId;
    this.wt2_1 = 0;
    this.xt2_1 = ArrayDeque_init_$Create$();
  }
  protoOf(CommandQueue).w2m = function () {
    return this.xt2_1.s();
  };
  protoOf(CommandQueue).ct3 = function () {
    return this.xt2_1;
  };
  protoOf(CommandQueue).ft3 = function (command) {
    var result = command;
    var _iterator__ex2g4s = this.xt2_1.m();
    while (_iterator__ex2g4s.n()) {
      var cmd = _iterator__ex2g4s.o();
      result = cmd.h55(result, false);
    }
    return result;
  };
  protoOf(CommandQueue).gt3 = function (cmd) {
    var newQueue = ArrayDeque_init_$Create$();
    var currentCmd = cmd;
    var _iterator__ex2g4s = this.xt2_1.m();
    while (_iterator__ex2g4s.n()) {
      var c = _iterator__ex2g4s.o();
      var newCmd = c.h55(currentCmd, false);
      newQueue.j(currentCmd.h55(c, true));
      currentCmd = newCmd;
    }
    this.xt2_1 = newQueue;
  };
  protoOf(CommandQueue).bt3 = function (command) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.require' call
    if (!this.vt2_1.equals(command.b55_1.g55_1)) {
      var message = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    this.xt2_1.pf(command);
  };
  protoOf(CommandQueue).ht3 = function () {
    return this.xt2_1.qf();
  };
  protoOf(CommandQueue).et3 = function () {
    return this.xt2_1.nf();
  };
  protoOf(CommandQueue).at3 = function () {
    return this.xt2_1.mf();
  };
  protoOf(CommandQueue).dt3 = function (id) {
    var tmp0_elvis_lhs = this.et3();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var cmd = tmp;
    if (cmd.b55_1.equals(id)) {
      return true;
    }
    if (getIndex(this, id) === -1)
      return false;
    throw IllegalStateException_init_$Create$();
  };
  protoOf(CommandQueue).it3 = function () {
    var replacedCommands = ArrayDeque_init_$Create$();
    var _iterator__ex2g4s = this.xt2_1.m();
    while (_iterator__ex2g4s.n()) {
      var command = _iterator__ex2g4s.o();
      replacedCommands.j(new Command(RootCommandId_init_$Create$(command.b55_1.g55_1), command.c55_1, command.d55_1, command.e55_1));
    }
    this.xt2_1 = replacedCommands;
  };
  function LoadingReferences$LoadingRootData$loadingEntities$delegate$lambda() {
    return HashSet_init_$Create$();
  }
  function LoadingReferences$LoadingRootData$_get_loadingEntities_$ref_dtlg61() {
    return function (p0) {
      return p0.at4();
    };
  }
  function LoadingRootData(clientRoot) {
    this.yt3_1 = clientRoot;
    var tmp = this;
    tmp.zt3_1 = lazy(LoadingReferences$LoadingRootData$loadingEntities$delegate$lambda);
  }
  protoOf(LoadingRootData).at4 = function () {
    var tmp0 = this.zt3_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('loadingEntities', 1, tmp, LoadingReferences$LoadingRootData$_get_loadingEntities_$ref_dtlg61(), null);
    return tmp0.a1();
  };
  protoOf(LoadingRootData).bt4 = function () {
    // Inline function 'kotlin.collections.isNotEmpty' call
    return !this.at4().s();
  };
  protoOf(LoadingRootData).ct4 = function (entityId) {
    return contains_5(this.at4(), entityId);
  };
  protoOf(LoadingRootData).dt4 = function (entityId) {
    this.at4().j(entityId);
  };
  protoOf(LoadingRootData).et4 = function (entityId) {
    var removed = this.at4().h2(entityId);
    // Inline function 'kotlin.check' call
    if (!removed) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
  };
  function LoadingReferences() {
    this.lt0_1 = HashMap_init_$Create$();
  }
  protoOf(LoadingReferences).vt0 = function () {
    var loadingRoots = HashSet_init_$Create$_1(this.lt0_1.p());
    var _iterator__ex2g4s = this.lt0_1.s2().m();
    while (_iterator__ex2g4s.n()) {
      var data = _iterator__ex2g4s.o();
      loadingRoots.j(data.yt3_1);
    }
    return loadingRoots;
  };
  protoOf(LoadingReferences).wt0 = function (rootId) {
    return this.lt0_1.o2(rootId);
  };
  protoOf(LoadingReferences).mt0 = function (reference) {
    return this.zt2(reference.j3j_1, reference.k3j_1);
  };
  protoOf(LoadingReferences).zt2 = function (rootId, entityId) {
    var tmp0_safe_receiver = this.lt0_1.q2(rootId);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.ct4(entityId);
    return tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
  };
  protoOf(LoadingReferences).ut2 = function (rootId) {
    var tmp0_safe_receiver = this.lt0_1.q2(rootId);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.at4();
    return tmp1_elvis_lhs == null ? emptySet() : tmp1_elvis_lhs;
  };
  protoOf(LoadingReferences).st0 = function (rootId) {
    var tmp0_safe_receiver = this.lt0_1.q2(rootId);
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.yt3_1;
  };
  protoOf(LoadingReferences).ot0 = function (rootId, entityId, clientRoot) {
    // Inline function 'kotlin.collections.getOrPut' call
    var this_0 = this.lt0_1;
    var value = this_0.q2(rootId);
    var tmp;
    if (value == null) {
      var answer = new LoadingRootData(clientRoot);
      this_0.t2(rootId, answer);
      tmp = answer;
    } else {
      tmp = value;
    }
    var data = tmp;
    // Inline function 'kotlin.check' call
    if (!equals(clientRoot, data.yt3_1)) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    data.dt4(entityId);
  };
  protoOf(LoadingReferences).yt2 = function (rootId, entityId) {
    var data = this.lt0_1.q2(rootId);
    // Inline function 'kotlin.check' call
    if (!!(data == null)) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    data.et4(entityId);
    if (!data.bt4()) {
      this.lt0_1.u2(rootId);
    }
  };
  function Memento_init_$Init$($this) {
    Memento.call($this);
    return $this;
  }
  function Memento_init_$Create$() {
    return Memento_init_$Init$(objectCreate(protoOf(Memento)));
  }
  protoOf(Memento).w2m = function () {
    if (!(this.st1_1 == null))
      return false;
    if (!!(this.qt1_1 == null ^ this.rt1_1 == null))
      return false;
    return this.qt1_1 == null ? true : ensureNotNull(this.qt1_1).a3j().s() && ensureNotNull(this.rt1_1).s();
  };
  protoOf(Memento).k2 = function () {
    this.qt1_1 = null;
    this.rt1_1 = null;
    this.st1_1 = null;
  };
  function Memento() {
    this.qt1_1 = null;
    this.rt1_1 = null;
    this.st1_1 = null;
  }
  function OtServiceEndpoint$ExecutingJsonPort$_init_$lambda_574k41(this$0) {
    return function () {
      return new CommonJsonPort(this$0.kt4_1, this$0.gt4_1.lr7(), this$0.jt4_1);
    };
  }
  function OtServiceEndpoint$MyThrottlingJsonPort$_init_$lambda$o$_get_input_$o$commandAccepted$lambda_jrtxmc($id) {
    return function () {
      return 'command accepted: ' + $id.toString();
    };
  }
  function OtServiceEndpoint$MyThrottlingJsonPort$2$wrappedClientPort$1$input$1($clientPort, $operations) {
    this.nt4_1 = $operations;
    OtChannelDelegate.call(this, $clientPort.ysm());
  }
  protoOf(OtServiceEndpoint$MyThrottlingJsonPort$2$wrappedClientPort$1$input$1).nso = function (command) {
    this.nt4_1.j(command.e55_1);
    protoOf(OtChannelDelegate).nso.call(this, command);
  };
  protoOf(OtServiceEndpoint$MyThrottlingJsonPort$2$wrappedClientPort$1$input$1).oso = function (id, baseVersion, resultVersion) {
    var tmp = Companion_getInstance_416().ot4_1;
    tmp.a2q(OtServiceEndpoint$MyThrottlingJsonPort$_init_$lambda$o$_get_input_$o$commandAccepted$lambda_jrtxmc(id));
    protoOf(OtChannelDelegate).oso.call(this, id, baseVersion, resultVersion);
  };
  function getLogCaption($this, n) {
    return n.toString() + (n === 1 ? ' OT command was executed during long run:' : ' OT commands were executed during long run:');
  }
  function OtServiceEndpoint$MyThrottlingJsonPort$2$wrappedClientPort$1($clientPort, $operations) {
    this.st4_1 = $clientPort;
    this.tt4_1 = $operations;
  }
  protoOf(OtServiceEndpoint$MyThrottlingJsonPort$2$wrappedClientPort$1).ysm = function () {
    return new OtServiceEndpoint$MyThrottlingJsonPort$2$wrappedClientPort$1$input$1(this.st4_1, this.tt4_1);
  };
  protoOf(OtServiceEndpoint$MyThrottlingJsonPort$2$wrappedClientPort$1).zr = function () {
    this.st4_1.zr();
  };
  protoOf(OtServiceEndpoint$MyThrottlingJsonPort$2$wrappedClientPort$1).zt0 = function (output, internalErrorHandler) {
    this.st4_1.csn(output, internalErrorHandler);
  };
  protoOf(OtServiceEndpoint$MyThrottlingJsonPort$2$wrappedClientPort$1).csn = function (output, internalErrorHandler) {
    return this.zt0((!(output == null) ? isInterface(output, OtChannel) : false) ? output : THROW_CCE(), internalErrorHandler);
  };
  function OtServiceEndpoint$MyThrottlingJsonPort$_init_$lambda_bvoohc(this$0, $operations) {
    return function () {
      var clientPort = this$0.gt4_1.lr7();
      var wrappedClientPort = new OtServiceEndpoint$MyThrottlingJsonPort$2$wrappedClientPort$1(clientPort, $operations);
      return new CommonJsonPort(this$0.kt4_1, wrappedClientPort, this$0.jt4_1);
    };
  }
  function OtServiceEndpoint$MyThrottlingJsonPort$afterProcess$lambda(this$0) {
    return function () {
      return getLogCaption(this$0, this$0.it5_1.p());
    };
  }
  function OtServiceEndpoint$MyThrottlingJsonPort$afterProcess$lambda_0($index, $operation) {
    return function () {
      return 'operation ' + $index + ': ' + Companion_instance_53.h40($operation).toString();
    };
  }
  function OtServiceEndpoint$MyThrottlingJsonPort$afterProcess$lambda_1() {
    return 'exception caught during collecting operation statistics';
  }
  function OtServiceEndpoint$CommonJsonPort$$inlined$jsonChannel$1(this$0) {
    this.kt5_1 = this$0;
  }
  protoOf(OtServiceEndpoint$CommonJsonPort$$inlined$jsonChannel$1).vsm = function (message) {
    this.kt5_1.rt5(message);
    return Unit_instance;
  };
  protoOf(OtServiceEndpoint$CommonJsonPort$$inlined$jsonChannel$1).tsm = function (message) {
    return this.vsm(message instanceof JsonArray ? message : THROW_CCE());
  };
  function OtServiceEndpoint$Companion$LOG$lambda() {
    return Unit_instance;
  }
  function OtServiceEndpoint_init_$Init$(client, protocolConfiguration, clientEdt, isThrottlingEnabled, nodeFactory, $this) {
    isThrottlingEnabled = isThrottlingEnabled === VOID ? false : isThrottlingEnabled;
    nodeFactory = nodeFactory === VOID ? RawNodeFactory_instance : nodeFactory;
    OtServiceEndpoint.call($this, 'ot', client, protocolConfiguration, clientEdt, isThrottlingEnabled, nodeFactory);
    return $this;
  }
  function OtServiceEndpoint_init_$Create$(client, protocolConfiguration, clientEdt, isThrottlingEnabled, nodeFactory) {
    return OtServiceEndpoint_init_$Init$(client, protocolConfiguration, clientEdt, isThrottlingEnabled, nodeFactory, objectCreate(protoOf(OtServiceEndpoint)));
  }
  function doOpenPort($this) {
    var tmp;
    if ($this.it4_1) {
      tmp = new MyThrottlingJsonPort($this, ArrayList_init_$Create$());
    } else {
      tmp = new ExecutingJsonPort($this);
    }
    return tmp;
  }
  function ExecutingJsonPort($outer) {
    this.zt5_1 = $outer;
    JsonPortExecutingDelegate.call(this, OtServiceEndpoint$ExecutingJsonPort$_init_$lambda_574k41($outer), $outer.ht4_1);
  }
  protoOf(ExecutingJsonPort).zr = function () {
    this.zt5_1.lt4_1 = false;
    protoOf(JsonPortExecutingDelegate).zr.call(this);
  };
  function MyThrottlingJsonPort($outer, operations) {
    this.jt5_1 = $outer;
    ThrottlingJsonPort.call(this, OtServiceEndpoint$MyThrottlingJsonPort$_init_$lambda_bvoohc($outer, operations), $outer.ht4_1, 150, 400, numberToInt(2.0 * 150));
    this.it5_1 = operations;
  }
  protoOf(MyThrottlingJsonPort).hsq = function () {
    this.it5_1.k2();
  };
  protoOf(MyThrottlingJsonPort).jsq = function (longRun) {
    if (longRun) {
      try {
        var tmp = Companion_getInstance_416().ot4_1;
        tmp.c2q(OtServiceEndpoint$MyThrottlingJsonPort$afterProcess$lambda(this));
        var iterator = this.it5_1.m();
        var index = 0;
        while (iterator.n()) {
          var index_0 = index;
          index = index + 1 | 0;
          var operation = iterator.o();
          var tmp_0 = Companion_getInstance_416().ot4_1;
          tmp_0.a2q(OtServiceEndpoint$MyThrottlingJsonPort$afterProcess$lambda_0(index_0, operation));
        }
      } catch ($p) {
        if ($p instanceof Error) {
          var throwable = $p;
          var tmp_1 = Companion_getInstance_416().ot4_1;
          tmp_1.h2q(throwable, OtServiceEndpoint$MyThrottlingJsonPort$afterProcess$lambda_1);
        } else {
          throw $p;
        }
      }
    }
  };
  protoOf(MyThrottlingJsonPort).zr = function () {
    this.jt5_1.lt4_1 = false;
    protoOf(ThrottlingJsonPort).zr.call(this);
  };
  function CommonJsonPort(idCompressor, port, nodeFactory) {
    this.lt5_1 = idCompressor;
    this.mt5_1 = port;
    this.nt5_1 = nodeFactory;
    this.ot5_1 = Ot2JsonChannelAdapter_init_$Create$(this.lt5_1, this.mt5_1.ysm(), this.nt5_1);
    this.qt5_1 = null;
    var tmp = this;
    // Inline function 'jetbrains.ocelot.ot.commons.protocol.json.jsonChannel' call
    tmp.pt5_1 = new OtServiceEndpoint$CommonJsonPort$$inlined$jsonChannel$1(this);
  }
  protoOf(CommonJsonPort).ysm = function () {
    return this.pt5_1;
  };
  protoOf(CommonJsonPort).rt5 = function (msg) {
    try {
      this.ot5_1.vsm(msg);
    } catch ($p) {
      if ($p instanceof Error) {
        var t = $p;
        if (this.qt5_1 == null) {
          throw IllegalStateException_init_$Create$_1('internal error handler is null during processing error in message ' + msg.toString(), t);
        }
        ensureNotNull(this.qt5_1)(FatalEndpointException_init_$Create$_0('OT service failed', t));
      } else {
        throw $p;
      }
    }
  };
  protoOf(CommonJsonPort).xsu = function (output, internalErrorHandler) {
    this.qt5_1 = internalErrorHandler;
    this.ot5_1.qss();
    var json2OtChannelAdapter = Json2OtChannelAdapter_init_$Create$(this.lt5_1, output, this.nt5_1);
    this.mt5_1.csn(json2OtChannelAdapter, internalErrorHandler);
  };
  protoOf(CommonJsonPort).csn = function (output, internalErrorHandler) {
    return this.xsu((!(output == null) ? isInterface(output, JsonChannel) : false) ? output : THROW_CCE(), internalErrorHandler);
  };
  protoOf(CommonJsonPort).zr = function () {
    this.mt5_1.zr();
    this.ot5_1.zr();
  };
  function Companion_416() {
    Companion_instance_416 = this;
    var tmp = this;
    var tmp_0 = KotlinLogging_getInstance();
    tmp.ot4_1 = tmp_0.i2q(OtServiceEndpoint$Companion$LOG$lambda);
    this.pt4_1 = 150;
    this.qt4_1 = 400;
    this.rt4_1 = 2.0;
  }
  var Companion_instance_416;
  function Companion_getInstance_416() {
    if (Companion_instance_416 == null)
      new Companion_416();
    return Companion_instance_416;
  }
  function OtServiceEndpoint(shortName, client, protocolConfiguration, clientEdt, isThrottlingEnabled, nodeFactory) {
    Companion_getInstance_416();
    isThrottlingEnabled = isThrottlingEnabled === VOID ? false : isThrottlingEnabled;
    nodeFactory = nodeFactory === VOID ? RawNodeFactory_instance : nodeFactory;
    JsonServiceEndpoint.call(this);
    this.ft4_1 = shortName;
    this.gt4_1 = client;
    this.ht4_1 = clientEdt;
    this.it4_1 = isThrottlingEnabled;
    this.jt4_1 = nodeFactory;
    this.lt4_1 = false;
    var tmp;
    if (protocolConfiguration.j3c(ProtocolParameters_getInstance().bsr_1)) {
      tmp = defaultClientIdCompressorSupplier();
    } else {
      tmp = nullIdCompressorSupplier();
    }
    var idCompressorSupplier = tmp;
    this.kt4_1 = idCompressorSupplier();
  }
  protoOf(OtServiceEndpoint).gsn = function () {
    return this.ft4_1;
  };
  protoOf(OtServiceEndpoint).fsn = function () {
    // Inline function 'kotlin.check' call
    if (!!this.lt4_1) {
      var message = 'port is already opened';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    var port = doOpenPort(this);
    this.lt4_1 = true;
    return port;
  };
  protoOf(OtServiceEndpoint).zr = function () {
    this.gt4_1.zr();
  };
  function ProtocolListener() {
  }
  function IncomingAcceptance_init_$Init$(commandId, baseVersion, resultVersion, $this) {
    IncomingAcceptance.call($this, commandId, null, baseVersion, resultVersion);
    return $this;
  }
  function IncomingAcceptance_init_$Create$(commandId, baseVersion, resultVersion) {
    return IncomingAcceptance_init_$Init$(commandId, baseVersion, resultVersion, objectCreate(protoOf(IncomingAcceptance)));
  }
  function IncomingAcceptance(commandId, entityId, baseVersion, resultVersion) {
    entityId = entityId === VOID ? null : entityId;
    baseVersion = baseVersion === VOID ? null : baseVersion;
    resultVersion = resultVersion === VOID ? null : resultVersion;
    this.tsz_1 = commandId;
    this.usz_1 = entityId;
    this.vsz_1 = baseVersion;
    this.wsz_1 = resultVersion;
  }
  protoOf(IncomingAcceptance).rsz = function (handler) {
    handler.kt3(this);
  };
  function IncomingRejection_init_$Init$(commandId, reason, $this) {
    IncomingRejection.call($this, commandId, null, reason);
    return $this;
  }
  function IncomingRejection_init_$Create$(commandId, reason) {
    return IncomingRejection_init_$Init$(commandId, reason, objectCreate(protoOf(IncomingRejection)));
  }
  function IncomingRejection(commandId, entityId, reason) {
    this.bt0_1 = commandId;
    this.ct0_1 = entityId;
    this.dt0_1 = reason;
  }
  protoOf(IncomingRejection).rsz = function (handler) {
    handler.lt3(this);
  };
  function IncomingRequest(commandId) {
    commandId = commandId === VOID ? null : commandId;
    this.qsz_1 = commandId;
  }
  protoOf(IncomingRequest).rsz = function (handler) {
    handler.mt3(this);
  };
  function OutgoingRequest(entityId) {
    entityId = entityId === VOID ? null : entityId;
    this.ut0_1 = entityId;
  }
  protoOf(OutgoingRequest).rsz = function (handler) {
    handler.nt3(this);
  };
  function $runSuspendCOROUTINE$_139(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.it6_1 = _this__u8e3s4;
    this.jt6_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_139).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 3;
            var $this$suspendingQuery = this.jt6_1;
            var tmp0_safe_receiver = $this$suspendingQuery.l60(this.it6_1.lt6_1.gfq());
            var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.gfq();
            var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.x6o();
            if (tmp2_safe_receiver == null) {
              this.kt6_1 = null;
              this.f9_1 = 2;
              continue $sm;
            } else {
              this.f9_1 = 1;
              suspendResult = $this$suspendingQuery.k60(tmp2_safe_receiver, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            this.kt6_1 = suspendResult;
            this.f9_1 = 2;
            continue $sm;
          case 2:
            return this.kt6_1;
          case 3:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 3) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function ResolveResult(element, initial) {
    this.mt6_1 = element;
    this.nt6_1 = initial;
  }
  protoOf(ResolveResult).toString = function () {
    return 'ResolveResult(element=' + toString_1(this.mt6_1) + ', initial=' + this.nt6_1 + ')';
  };
  protoOf(ResolveResult).hashCode = function () {
    var result = hashCode(this.mt6_1);
    result = imul(result, 31) + getBooleanHashCode(this.nt6_1) | 0;
    return result;
  };
  protoOf(ResolveResult).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ResolveResult))
      return false;
    if (!equals(this.mt6_1, other.mt6_1))
      return false;
    if (!(this.nt6_1 === other.nt6_1))
      return false;
    return true;
  };
  function _get_categoryInfo__ynw1r($this, _this__u8e3s4) {
    return new CategoryInfo(_get_accession__uiy019($this, _this__u8e3s4), get_stringId(_this__u8e3s4), _this__u8e3s4.y2().m5y().w2w());
  }
  function _get_accession__uiy019($this, _this__u8e3s4) {
    var tmp0_safe_receiver = _this__u8e3s4.t42();
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.d6g();
    var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.m5y();
    var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.w2w();
    return tmp3_elvis_lhs == null ? '' : tmp3_elvis_lhs;
  }
  function sam$jetbrains_ocelot_base_disposable_Disposable$0_8(function_0) {
    this.ot6_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0_8).zr = function () {
    return this.ot6_1();
  };
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0_8).f3 = function () {
    return this.ot6_1;
  };
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0_8).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Disposable) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0_8).hashCode = function () {
    return hashCode(this.f3());
  };
  function BTBCategoriesWatcher$watch$2$$inlined$suspendingQuery$1($category) {
    this.lt6_1 = $category;
  }
  protoOf(BTBCategoriesWatcher$watch$2$$inlined$suspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_139(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(BTBCategoriesWatcher$watch$2$$inlined$suspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function BTBCategoriesWatcher$watch$lambda$lambda($initialResolve) {
    return function (it) {
      var tmp;
      if (it == null) {
        tmp = null;
      } else {
        // Inline function 'kotlin.let' call
        tmp = new ResolveResult(it, $initialResolve);
      }
      return tmp;
    };
  }
  function BTBCategoriesWatcher$watch$lambda($initialCategories, $watcherScope) {
    return function (category) {
      var initialResolve = $initialCategories.h2(category);
      // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
      var query = new BTBCategoriesWatcher$watch$2$$inlined$suspendingQuery$1(category);
      var tmp = asNullableProperty(new LoopingQuery($watcherScope.ho(), query));
      return map_0(tmp, BTBCategoriesWatcher$watch$lambda$lambda(initialResolve));
    };
  }
  function BTBCategoriesWatcher$watch$lambda_0($resolveProperty) {
    return function (category) {
      return $resolveProperty(category);
    };
  }
  function BTBCategoriesWatcher$watch$lambda_1(this$0) {
    return function (event) {
      var tmp;
      if (!event.r2r_1.equals(EventType_REMOVE_getInstance())) {
        var resolveResult = event.u2r();
        var tmp_0;
        if (!resolveResult.nt6_1) {
          this$0.qt6_1.ut6(_get_categoryInfo__ynw1r(this$0, resolveResult.mt6_1));
          tmp_0 = Unit_instance;
        }
        tmp = tmp_0;
      }
      var tmp_1;
      if (!event.r2r_1.equals(EventType_ADD_getInstance())) {
        this$0.qt6_1.vt6(_get_categoryInfo__ynw1r(this$0, event.s2r().mt6_1));
        tmp_1 = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function BTBCategoriesWatcher$watch$lambda_2($watcherScope) {
    return function () {
      cancel($watcherScope);
      return Unit_instance;
    };
  }
  function BTBCategoriesWatcher(document, notifier, coroutineContext) {
    this.pt6_1 = document;
    this.qt6_1 = notifier;
    this.rt6_1 = coroutineContext;
  }
  protoOf(BTBCategoriesWatcher).wt6 = function () {
    var watcherScope = CoroutineScope_0(this.rt6_1.wi(Job_0(this.rt6_1.s9(Key_instance_3))));
    var initialCategories = toMutableSet(this.pt6_1.yfp().m5y());
    var resolveProperty = BTBCategoriesWatcher$watch$lambda(initialCategories, watcherScope);
    var tmp = Transformers_instance;
    var resolveProperties = tmp.k35(BTBCategoriesWatcher$watch$lambda_0(resolveProperty)).t32(this.pt6_1.yfp().m5y());
    var resolvedCategories = Transformers_instance.l35(Transformers_instance.n35()).t32(resolveProperties.q33());
    var tmp_0 = resolvedCategories.q33();
    var listListener = tmp_0.z2r(BTBCategoriesWatcher$watch$lambda_1(this));
    var tmp_1 = resolveProperties.j2l(resolvedCategories).j2l(listListener);
    var tmp_2 = BTBCategoriesWatcher$watch$lambda_2(watcherScope);
    return tmp_1.j2l(new sam$jetbrains_ocelot_base_disposable_Disposable$0_8(tmp_2));
  };
  function CachingNodeEditor() {
  }
  function CachingNodeEditorImpl$EditorCache$clear$lambda(it) {
    return true;
  }
  function EditorCache(maxSize) {
    this.dt7_1 = maxSize;
    // Inline function 'kotlin.require' call
    if (!(this.dt7_1 > 1)) {
      var message = 'Editor cache size must be greater than one';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    this.et7_1 = LinkedHashMap_init_$Create$();
  }
  protoOf(EditorCache).ft7 = function (descriptor, component) {
    // Inline function 'kotlin.check' call
    if (!!this.et7_1.o2(descriptor)) {
      var message = 'Editor cache already has an entry at key ' + descriptor.toString();
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    if (this.et7_1.p() === this.dt7_1) {
      var oldestDescriptor = first_0(this.et7_1.r2());
      var removedComponent = ensureNotNull(this.et7_1.u2(oldestDescriptor));
      removedComponent.zr();
    }
    // Inline function 'kotlin.collections.set' call
    this.et7_1.t2(descriptor, component);
  };
  protoOf(EditorCache).nt7 = function (key) {
    // Inline function 'kotlin.collections.get' call
    var this_0 = this.et7_1;
    return (isInterface(this_0, KtMap) ? this_0 : THROW_CCE()).q2(key);
  };
  protoOf(EditorCache).k2 = function () {
    this.ot7(CachingNodeEditorImpl$EditorCache$clear$lambda);
  };
  protoOf(EditorCache).ot7 = function (descriptorFilter) {
    // Inline function 'kotlin.collections.iterator' call
    var iterator = this.et7_1.y().m();
    while (iterator.n()) {
      var _destruct__k2r9zo = iterator.o();
      // Inline function 'kotlin.collections.component1' call
      var documentSourceDescriptor = _destruct__k2r9zo.z();
      // Inline function 'kotlin.collections.component2' call
      var editorComponent = _destruct__k2r9zo.a1();
      if (descriptorFilter(documentSourceDescriptor)) {
        editorComponent.zr();
        iterator.h4();
      }
    }
  };
  function CachingNodeEditorImpl$open$slambda($source, this$0, resultContinuation) {
    this.xt7_1 = $source;
    this.yt7_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CachingNodeEditorImpl$open$slambda).e1h = function ($this$singleOpenTask, $completion) {
    var tmp = this.f1h($this$singleOpenTask, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(CachingNodeEditorImpl$open$slambda).v9 = function (p1, $completion) {
    return this.e1h((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CachingNodeEditorImpl$open$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 3;
            this.f9_1 = 1;
            suspendResult = this.xt7_1.bt8(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.at8_1 = suspendResult;
            this.f9_1 = 2;
            suspendResult = this.yt7_1.mt8(this.at8_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var editorComponent = suspendResult;
            if (this.at8_1.et9_1) {
              this.yt7_1.xt8_1.ft7(this.xt7_1.descriptor, editorComponent);
            }

            return Unit_instance;
          case 3:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 3) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(CachingNodeEditorImpl$open$slambda).f1h = function ($this$singleOpenTask, completion) {
    var i = new CachingNodeEditorImpl$open$slambda(this.xt7_1, this.yt7_1, completion);
    i.zt7_1 = $this$singleOpenTask;
    return i;
  };
  function CachingNodeEditorImpl$open$slambda_0($source, this$0, resultContinuation) {
    var i = new CachingNodeEditorImpl$open$slambda($source, this$0, resultContinuation);
    var l = function ($this$singleOpenTask, $completion) {
      return i.e1h($this$singleOpenTask, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function $openCOROUTINE$(_this__u8e3s4, source, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.nt9_1 = _this__u8e3s4;
    this.ot9_1 = source;
  }
  protoOf($openCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 3;
            var component = this.nt9_1.xt8_1.nt7(this.ot9_1.descriptor);
            if (!(component == null)) {
              this.nt9_1.qt9(component);
              this.f9_1 = 2;
              continue $sm;
            } else {
              this.f9_1 = 1;
              suspendResult = this.nt9_1.pt9(CachingNodeEditorImpl$open$slambda_0(this.ot9_1, this.nt9_1, null), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            this.f9_1 = 2;
            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 3) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function CachingNodeEditorImpl(cacheSize, coroutineContext, view, editorOpeningMonitoring) {
    NodeEditorBase.call(this, coroutineContext, view, editorOpeningMonitoring);
    this.xt8_1 = new EditorCache(cacheSize);
  }
  protoOf(CachingNodeEditorImpl).rt9 = function (source, $completion) {
    var tmp = new $openCOROUTINE$(this, source, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(CachingNodeEditorImpl).zr = function () {
    protoOf(NodeEditorBase).zr.call(this);
    this.st9();
  };
  protoOf(CachingNodeEditorImpl).st9 = function () {
    return this.xt8_1.k2();
  };
  protoOf(CachingNodeEditorImpl).xt6 = function (descriptorFilter) {
    return this.xt8_1.ot7(descriptorFilter);
  };
  function serializeProjectionalContentKind(_this__u8e3s4, nodePersister) {
    _this__u8e3s4.w8o(new serializeProjectionalContentKind$1(nodePersister));
  }
  function serializeProjectionalContentKind$1$persister$1($nodePersister) {
    this.vt9_1 = $nodePersister;
  }
  protoOf(serializeProjectionalContentKind$1$persister$1).m25 = function () {
    return new ExceptionNullPersister();
  };
  protoOf(serializeProjectionalContentKind$1$persister$1).wt9 = function (value) {
    return this.vt9_1.n25(value.oct_1);
  };
  protoOf(serializeProjectionalContentKind$1$persister$1).n25 = function (value) {
    return this.wt9(value instanceof EditorNode ? value : THROW_CCE());
  };
  protoOf(serializeProjectionalContentKind$1$persister$1).o25 = function (value) {
    return new EditorNode(this.vt9_1.o25(value));
  };
  function serializeProjectionalContentKind$1($nodePersister) {
    ProjectionalClipboardContentSerializationAsHtml.call(this);
    var tmp = this;
    tmp.yt9_1 = new serializeProjectionalContentKind$1$persister$1($nodePersister);
  }
  protoOf(serializeProjectionalContentKind$1).tav = function (contentKind) {
    return contentKind instanceof NodeContentKind;
  };
  protoOf(serializeProjectionalContentKind$1).jav = function (contentKind) {
    if (!(contentKind instanceof NodeContentKind))
      THROW_CCE();
    var tmp = this.yt9_1;
    return isInterface(tmp, Persister) ? tmp : THROW_CCE();
  };
  function select_1($this, editable, selection) {
    var mappers = $this.lt7_1.b88().f8a(editable.zt9_1);
    var _iterator__ex2g4s = mappers.m();
    while (_iterator__ex2g4s.n()) {
      var mapper = _iterator__ex2g4s.o();
      var target = mapper.f86_1;
      if (!(target == null) ? isInterface(target, Cell) : false) {
        return selection.ock(target);
      }
    }
    throw IllegalArgumentException_init_$Create$_0('could not find mapper for node ' + toString_1(editable));
  }
  function navigateTo($this, node) {
    var tmp0_elvis_lhs = get_pointer(node);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.run' call
      Companion_getInstance_417().dta_1.wde('could not get enclosing document for node: ' + toString_1(node));
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var _destruct__k2r9zo = tmp;
    var accession = _destruct__k2r9zo.fg();
    var nodeId = _destruct__k2r9zo.gg();
    var tmp_0;
    if (isInterface(node, DocumentNode_0)) {
      tmp_0 = null;
    } else {
      tmp_0 = nodeId.q36_1;
    }
    var nodeIdIfNotRoot = tmp_0;
    $this.mt7_1.eta(accession, nodeIdIfNotRoot);
  }
  function _get_part__dbvu0o($this, _this__u8e3s4) {
    var tmp0 = $this.jt7_1;
    $l$block: {
      // Inline function 'kotlin.checkNotNull' call
      if (tmp0 == null) {
        var message = 'Select operation cannot be performed if model is null';
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      } else {
        break $l$block;
      }
    }
    var tmp0_elvis_lhs = $this.jt7_1.g3o(new NodeId(_this__u8e3s4.nodeId));
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalArgumentException_init_$Create$_0('could not find node with id ' + _this__u8e3s4.nodeId);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var otNode = tmp;
    var tmp_0 = toDomainNode(otNode, $this.ht7_1);
    var domainNode = isInterface(tmp_0, BTBNode) ? tmp_0 : THROW_CCE();
    var tmp1_safe_receiver = _this__u8e3s4.propertyId;
    var tmp_1;
    if (tmp1_safe_receiver == null) {
      tmp_1 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_1 = $this.it7_1.q6v(getKClass(DomainNode)).l6h(tmp1_safe_receiver);
    }
    var link = tmp_1;
    return new EditableNodePart(domainNode, link);
  }
  function EditableNodePart(node, link) {
    this.zt9_1 = node;
    this.ata_1 = link;
  }
  function Companion_417() {
    Companion_instance_417 = this;
    this.dta_1 = getLogger_0(getKClass(EditorComponent));
  }
  var Companion_instance_417;
  function Companion_getInstance_417() {
    if (Companion_instance_417 == null)
      new Companion_417();
    return Companion_instance_417;
  }
  function EditorComponent$findUsagesOfCurrentNode$lambda(it) {
    return !(it == null) ? isInterface(it, BTBNode) : false;
  }
  function $findUsagesOfCurrentNodeCOROUTINE$(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.nta_1 = _this__u8e3s4;
  }
  protoOf($findUsagesOfCurrentNodeCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 5;
            var tmp0_elvis_lhs = this.nta_1.kt7_1.z92().w2w();
            var tmp_0;
            if (tmp0_elvis_lhs == null) {
              return Unit_instance;
            } else {
              tmp_0 = tmp0_elvis_lhs;
            }

            var focusedCell = tmp_0;
            var resolve = focusedCell.c93(get_GET_TARGET());
            if (!(resolve == null)) {
              this.f9_1 = 1;
              suspendResult = resolve(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              var tmp_1 = this;
              var tmp_2 = getCellProviderFromMapper(this.nta_1.lt7_1);
              var tmp_3 = tmp_2.pah(focusedCell, EditorComponent$findUsagesOfCurrentNode$lambda);
              var tmp2_elvis_lhs = (!(tmp_3 == null) ? isInterface(tmp_3, BTBNode) : false) ? tmp_3 : null;
              var tmp_4;
              if (tmp2_elvis_lhs == null) {
                throw IllegalStateException_init_$Create$_0('could not find node whose cell is ' + toString_1(focusedCell));
              } else {
                tmp_4 = tmp2_elvis_lhs;
              }
              tmp_1.rta_1 = tmp_4;
              this.f9_1 = 2;
              continue $sm;
            }

          case 1:
            var tmp1_elvis_lhs = (!(suspendResult == null) ? isInterface(suspendResult, BTBNode) : false) ? suspendResult : null;
            var tmp_5 = this;
            var tmp_6;
            if (tmp1_elvis_lhs == null) {
              return Unit_instance;
            } else {
              tmp_6 = tmp1_elvis_lhs;
            }

            tmp_5.rta_1 = tmp_6;
            this.f9_1 = 2;
            continue $sm;
          case 2:
            this.pta_1 = this.rta_1;
            this.ota_1 = get_pointer(this.pta_1);
            if (this.ota_1 == null) {
              Companion_getInstance_417().dta_1.wde('could not get enclosing document for node: ' + toString_1(this.pta_1));
              return Unit_instance;
            }

            var tmp_7 = this.pta_1;
            if (isInterface(tmp_7, Named)) {
              this.f9_1 = 3;
              suspendResult = execute_1(this.pta_1.y2(), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.qta_1 = '';
              this.f9_1 = 4;
              continue $sm;
            }

          case 3:
            this.qta_1 = suspendResult;
            this.f9_1 = 4;
            continue $sm;
          case 4:
            var name = this.qta_1;
            var type = get_searchableNodeType(this.pta_1);
            this.nta_1.mt7_1.sta(this.ota_1.documentId, this.ota_1.nodeId.q36_1, name, type);
            return Unit_instance;
          case 5:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 5) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function $navigateCOROUTINE$(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.btb_1 = _this__u8e3s4;
  }
  protoOf($navigateCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            var tmp0_elvis_lhs = this.btb_1.kt7_1.z92().w2w();
            var tmp_0;
            if (tmp0_elvis_lhs == null) {
              return Unit_instance;
            } else {
              tmp_0 = tmp0_elvis_lhs;
            }

            var focusedCell = tmp_0;
            var tmp1_elvis_lhs = focusedCell.c93(get_GET_TARGET());
            var tmp_1;
            if (tmp1_elvis_lhs == null) {
              return Unit_instance;
            } else {
              tmp_1 = tmp1_elvis_lhs;
            }

            var resolve = tmp_1;
            this.f9_1 = 1;
            suspendResult = resolve(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var target = suspendResult;
            if (!(target == null)) {
              navigateTo(this.btb_1, isInterface(target, BTBNode) ? target : THROW_CCE());
            }

            return Unit_instance;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function EditorComponent(wrapperContext, serializationConfig, model, cellContainer, mapper, notifier, disposable) {
    Companion_getInstance_417();
    this.gt7_1 = disposable;
    this.ht7_1 = wrapperContext;
    this.it7_1 = serializationConfig;
    this.jt7_1 = model;
    this.kt7_1 = cellContainer;
    this.lt7_1 = mapper;
    this.mt7_1 = notifier;
  }
  protoOf(EditorComponent).ctb = function (nodeEditorPart, selection) {
    return select_1(this, _get_part__dbvu0o(this, nodeEditorPart), selection);
  };
  protoOf(EditorComponent).dtb = function ($completion) {
    var tmp = new $findUsagesOfCurrentNodeCOROUTINE$(this, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(EditorComponent).etb = function ($completion) {
    var tmp = new $navigateCOROUTINE$(this, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(EditorComponent).zr = function () {
    this.gt7_1.zr();
  };
  protoOf(EditorComponent).j2l = function (disposable) {
    return this.gt7_1.j2l(disposable);
  };
  function sam$jetbrains_biokb_editor_EditorOpeningMonitoring$0(function_0) {
    this.ftb_1 = function_0;
  }
  protoOf(sam$jetbrains_biokb_editor_EditorOpeningMonitoring$0).gtb = function (duration) {
    return this.ftb_1(new Duration(duration));
  };
  protoOf(sam$jetbrains_biokb_editor_EditorOpeningMonitoring$0).f3 = function () {
    return this.ftb_1;
  };
  protoOf(sam$jetbrains_biokb_editor_EditorOpeningMonitoring$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, EditorOpeningMonitoring) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_biokb_editor_EditorOpeningMonitoring$0).hashCode = function () {
    return hashCode(this.f3());
  };
  function EditorOpeningMonitoring$Companion$NoOp$lambda(it) {
    return Unit_instance;
  }
  function Companion_418() {
    Companion_instance_418 = this;
    var tmp = this;
    var tmp_0 = EditorOpeningMonitoring$Companion$NoOp$lambda;
    tmp.htb_1 = new sam$jetbrains_biokb_editor_EditorOpeningMonitoring$0(tmp_0);
  }
  var Companion_instance_418;
  function Companion_getInstance_418() {
    if (Companion_instance_418 == null)
      new Companion_418();
    return Companion_instance_418;
  }
  function ByEditorService(client) {
    this.itb_1 = client;
  }
  protoOf(ByEditorService).gtb = function (duration) {
    var metric = new PerformanceMonitoringMetric(_Duration___get_inWholeMilliseconds__impl__msfiry(duration), MetricKind_OpenEditor_getInstance());
    this.itb_1.wsf(metric);
  };
  function EditorOpeningMonitoring() {
  }
  function NodeEditorBase$findUsagesOfCurrentNode$slambda$slambda(this$0, resultContinuation) {
    this.rtb_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(NodeEditorBase$findUsagesOfCurrentNode$slambda$slambda).e1h = function ($this$run, $completion) {
    var tmp = this.f1h($this$run, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(NodeEditorBase$findUsagesOfCurrentNode$slambda$slambda).v9 = function (p1, $completion) {
    return this.e1h((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(NodeEditorBase$findUsagesOfCurrentNode$slambda$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = _get_component__t10gzw(this.rtb_1).dtb(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(NodeEditorBase$findUsagesOfCurrentNode$slambda$slambda).f1h = function ($this$run, completion) {
    var i = new NodeEditorBase$findUsagesOfCurrentNode$slambda$slambda(this.rtb_1, completion);
    i.stb_1 = $this$run;
    return i;
  };
  function NodeEditorBase$findUsagesOfCurrentNode$slambda$slambda_0(this$0, resultContinuation) {
    var i = new NodeEditorBase$findUsagesOfCurrentNode$slambda$slambda(this$0, resultContinuation);
    var l = function ($this$run, $completion) {
      return i.e1h($this$run, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function NodeEditorBase$navigate$slambda$slambda(this$0, resultContinuation) {
    this.btc_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(NodeEditorBase$navigate$slambda$slambda).e1h = function ($this$run, $completion) {
    var tmp = this.f1h($this$run, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(NodeEditorBase$navigate$slambda$slambda).v9 = function (p1, $completion) {
    return this.e1h((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(NodeEditorBase$navigate$slambda$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = _get_component__t10gzw(this.btc_1).etb(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(NodeEditorBase$navigate$slambda$slambda).f1h = function ($this$run, completion) {
    var i = new NodeEditorBase$navigate$slambda$slambda(this.btc_1, completion);
    i.ctc_1 = $this$run;
    return i;
  };
  function NodeEditorBase$navigate$slambda$slambda_0(this$0, resultContinuation) {
    var i = new NodeEditorBase$navigate$slambda$slambda(this$0, resultContinuation);
    var l = function ($this$run, $completion) {
      return i.e1h($this$run, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function NodeEditorBase$singleOpenTask$slambda$slambda($block, resultContinuation) {
    this.ltc_1 = $block;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(NodeEditorBase$singleOpenTask$slambda$slambda).e1h = function ($this$run, $completion) {
    var tmp = this.f1h($this$run, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(NodeEditorBase$singleOpenTask$slambda$slambda).v9 = function (p1, $completion) {
    return this.e1h((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(NodeEditorBase$singleOpenTask$slambda$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.ltc_1(this.mtc_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(NodeEditorBase$singleOpenTask$slambda$slambda).f1h = function ($this$run, completion) {
    var i = new NodeEditorBase$singleOpenTask$slambda$slambda(this.ltc_1, completion);
    i.mtc_1 = $this$run;
    return i;
  };
  function NodeEditorBase$singleOpenTask$slambda$slambda_0($block, resultContinuation) {
    var i = new NodeEditorBase$singleOpenTask$slambda$slambda($block, resultContinuation);
    var l = function ($this$run, $completion) {
      return i.e1h($this$run, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function _get_component__t10gzw($this) {
    var tmp = $this.kt8_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('component');
    }
  }
  function attachEditor($this, cellContainer, objectToShow, editorConfig) {
    var mapper = getEditorMapperFactory(editorConfig)(objectToShow);
    installRootFromMapper(mapper, cellContainer);
    ErrorHighlightingController_instance.nai(cellContainer);
    return mapper;
  }
  function registerActions($this, cellContainer, followReferences) {
    if (followReferences) {
      var tmp = cellContainer.t42();
      tmp.w92(new NodeEditorBase$registerActions$1($this));
    }
  }
  function setScrollParameters($this, cellContainer) {
    cellContainer.t42().g93(CellScrolling_getInstance().wa4_1, Companion_getInstance_419().stc_1);
  }
  function attachOtSupport($this, cellContainer, mapper, node) {
    var entityId = get_pointer_0(node.zt8_1.descriptor);
    var tmp;
    if (entityId == null) {
      tmp = Companion_getInstance_29().m2l_1;
    } else {
      tmp = node.atd_1.d3z(new ContentChangeListener($this, entityId));
    }
    var commandListening = tmp;
    var tmp_0 = (new OtSupportBuilder()).bca(cellContainer).cca(node.atd_1);
    var tmp_1;
    var tmp_2 = mapper.e86_1;
    if (tmp_2 instanceof NodeWrapper) {
      tmp_1 = getNodeWrapperCellProviderFromMapper(mapper instanceof Mapper ? mapper : THROW_CCE(), get_wrapperContext(node.bt9_1));
    } else {
      tmp_1 = getNodeCellProviderFromMapper(mapper);
    }
    var otSupport = tmp_0.dca(tmp_1).eca(node.btd_1).f40();
    return otSupport.j2l(commandListening);
  }
  function watchCategories($this, document) {
    return (new BTBCategoriesWatcher(document, $this.ft8_1, $this.ct8_1)).wt6();
  }
  function ContentChangeListener($outer, entityId) {
    this.etd_1 = $outer;
    this.ctd_1 = entityId;
    this.dtd_1 = false;
  }
  protoOf(ContentChangeListener).jc8 = function (op) {
    if (this.dtd_1)
      return Unit_instance;
    var info = OperationRootIdInfo_init_$Create$_0(op);
    var commandEntityId = info.v3x_1;
    if (!equals(commandEntityId, this.ctd_1))
      return Unit_instance;
    this.etd_1.ft8_1.ftd();
    this.dtd_1 = true;
  };
  protoOf(ContentChangeListener).r3y = function (op) {
    return this.jc8(op);
  };
  function guarded($this, _this__u8e3s4) {
    var tmp = NodeEditorBase$guarded$lambda(_this__u8e3s4);
    return new sam$jetbrains_ocelot_base_disposable_Disposable$0_9(tmp);
  }
  function Companion_419() {
    Companion_instance_419 = this;
    this.ntc_1 = getLogger_0(getKClass(NodeEditorBase));
    this.otc_1 = KeyStroke_init_$Create$(Key_U_getInstance(), [ModifierKey_CONTROL_getInstance()]);
    this.ptc_1 = KeyStroke_init_$Create$(Key_B_getInstance(), [ModifierKey_CONTROL_getInstance()]);
    this.qtc_1 = CellTraitPropertySpec_init_$Create$('editorDocumentsApi', null);
    this.rtc_1 = CellTraitPropertySpec_init_$Create$('eventNotifier', null);
    this.stc_1 = Companion_instance_194.c5f().tae(18).uae(1).vae(3).wae(18).f40();
  }
  var Companion_instance_419;
  function Companion_getInstance_419() {
    if (Companion_instance_419 == null)
      new Companion_419();
    return Companion_instance_419;
  }
  function sam$jetbrains_ocelot_base_disposable_Disposable$0_9(function_0) {
    this.gtd_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0_9).zr = function () {
    return this.gtd_1();
  };
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0_9).f3 = function () {
    return this.gtd_1;
  };
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0_9).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Disposable) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0_9).hashCode = function () {
    return hashCode(this.f3());
  };
  function NodeEditorBase$findUsagesOfCurrentNode$slambda(this$0, resultContinuation) {
    this.ptd_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(NodeEditorBase$findUsagesOfCurrentNode$slambda).e1h = function ($this$launch, $completion) {
    var tmp = this.f1h($this$launch, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(NodeEditorBase$findUsagesOfCurrentNode$slambda).v9 = function (p1, $completion) {
    return this.e1h((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(NodeEditorBase$findUsagesOfCurrentNode$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.ptd_1.ht8_1.std(NodeEditorBase$findUsagesOfCurrentNode$slambda$slambda_0(this.ptd_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(NodeEditorBase$findUsagesOfCurrentNode$slambda).f1h = function ($this$launch, completion) {
    var i = new NodeEditorBase$findUsagesOfCurrentNode$slambda(this.ptd_1, completion);
    i.qtd_1 = $this$launch;
    return i;
  };
  function NodeEditorBase$findUsagesOfCurrentNode$slambda_0(this$0, resultContinuation) {
    var i = new NodeEditorBase$findUsagesOfCurrentNode$slambda(this$0, resultContinuation);
    var l = function ($this$launch, $completion) {
      return i.e1h($this$launch, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function NodeEditorBase$navigate$slambda(this$0, resultContinuation) {
    this.bte_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(NodeEditorBase$navigate$slambda).e1h = function ($this$launch, $completion) {
    var tmp = this.f1h($this$launch, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(NodeEditorBase$navigate$slambda).v9 = function (p1, $completion) {
    return this.e1h((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(NodeEditorBase$navigate$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.bte_1.ht8_1.std(NodeEditorBase$navigate$slambda$slambda_0(this.bte_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(NodeEditorBase$navigate$slambda).f1h = function ($this$launch, completion) {
    var i = new NodeEditorBase$navigate$slambda(this.bte_1, completion);
    i.cte_1 = $this$launch;
    return i;
  };
  function NodeEditorBase$navigate$slambda_0(this$0, resultContinuation) {
    var i = new NodeEditorBase$navigate$slambda(this$0, resultContinuation);
    var l = function ($this$launch, $completion) {
      return i.e1h($this$launch, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function NodeEditorBase$registerActions$1(this$0) {
    this.dte_1 = this$0;
    CellTrait.call(this);
  }
  protoOf(NodeEditorBase$registerActions$1).s8z = function (cell, event) {
    if (event.r8j([Companion_getInstance_419().otc_1])) {
      event.n8i();
      this.dte_1.tt9();
    } else if (event.r8j([Companion_getInstance_419().ptc_1])) {
      event.n8i();
      this.dte_1.ut9();
    } else {
      protoOf(CellTrait).s8z.call(this, cell, event);
    }
  };
  function NodeEditorBase$singleOpenTask$slambda(this$0, $block, resultContinuation) {
    this.mte_1 = this$0;
    this.nte_1 = $block;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(NodeEditorBase$singleOpenTask$slambda).e1h = function ($this$withContext, $completion) {
    var tmp = this.f1h($this$withContext, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(NodeEditorBase$singleOpenTask$slambda).v9 = function (p1, $completion) {
    return this.e1h((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(NodeEditorBase$singleOpenTask$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.mte_1.gt8_1.std(NodeEditorBase$singleOpenTask$slambda$slambda_0(this.nte_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(NodeEditorBase$singleOpenTask$slambda).f1h = function ($this$withContext, completion) {
    var i = new NodeEditorBase$singleOpenTask$slambda(this.mte_1, this.nte_1, completion);
    i.ote_1 = $this$withContext;
    return i;
  };
  function NodeEditorBase$singleOpenTask$slambda_0(this$0, $block, resultContinuation) {
    var i = new NodeEditorBase$singleOpenTask$slambda(this$0, $block, resultContinuation);
    var l = function ($this$withContext, $completion) {
      return i.e1h($this$withContext, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function NodeEditorBase$doOpen$lambda($nodePersister) {
    return function ($this$build) {
      serializeProjectionalContentKind($this$build, $nodePersister);
      $this$build.w8o(TextClipboardSerialization_instance);
      $this$build.x8o();
      return Unit_instance;
    };
  }
  function NodeEditorBase$doOpen$slambda(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(NodeEditorBase$doOpen$slambda).yte = function (it, $completion) {
    var tmp = this.rfm(it, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(NodeEditorBase$doOpen$slambda).v9 = function (p1, $completion) {
    return this.yte((!(p1 == null) ? typeof p1 === 'boolean' : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(NodeEditorBase$doOpen$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        if (tmp === 0) {
          this.g9_1 = 1;
          return this.xte_1;
        } else if (tmp === 1) {
          throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(NodeEditorBase$doOpen$slambda).rfm = function (it, completion) {
    var i = new NodeEditorBase$doOpen$slambda(completion);
    i.xte_1 = it;
    return i;
  };
  function NodeEditorBase$doOpen$slambda_0(resultContinuation) {
    var i = new NodeEditorBase$doOpen$slambda(resultContinuation);
    var l = function (it, $completion) {
      return i.yte(it, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function NodeEditorBase$guarded$lambda($this_guarded) {
    return function () {
      var tmp;
      try {
        $this_guarded.zr();
        tmp = Unit_instance;
      } catch ($p) {
        var tmp_0;
        if ($p instanceof Error) {
          var e = $p;
          Companion_getInstance_419().ntc_1.sde('error during dispose:', e);
          tmp_0 = Unit_instance;
        } else {
          throw $p;
        }
        tmp = tmp_0;
      }
      return Unit_instance;
    };
  }
  function $doOpenCOROUTINE$(_this__u8e3s4, nodeInfo, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.htf_1 = _this__u8e3s4;
    this.itf_1 = nodeInfo;
  }
  protoOf($doOpenCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 5;
            this.jtf_1 = Monotonic_instance.je();
            this.ltf_1 = CellContainer();
            resetEdt(this.ltf_1, this.itf_1.dt9_1);
            this.ltf_1.t42().g93(Companion_getInstance_419().rtc_1, this.htf_1.ft8_1);
            var domainModel = this.itf_1.bt9_1;
            var serializationConfig = ensureNotNull(domainModel.ddf_1.h3b(Companion_instance_110));
            var nodePersister = serializationConfig.q6v(getKClass(DomainNode));
            var tmp_0 = Companion_instance_144;
            var clipboardAdapter = tmp_0.q8o(NodeEditorBase$doOpen$lambda(nodePersister));
            this.ltf_1.g9v(clipboardAdapter);
            var editorConfig = createBTBEditorConfiguration(domainModel, this.itf_1.ct9_1);
            var disposable = new CompositeDisposable([]);
            disposable.k2l(guarded(this.htf_1, this.itf_1));
            var mapper = attachEditor(this.htf_1, this.ltf_1, this.itf_1.at9_1, editorConfig);
            this.htf_1.lt8_1 = mapper;
            if (this.itf_1.ct9_1.ntf_1.vct_1) {
              registerActions(this.htf_1, this.ltf_1, this.itf_1.ct9_1.ntf_1.xct_1);
              setScrollParameters(this.htf_1, this.ltf_1);
              var tmp_1 = this.itf_1.zt8_1;
              if (tmp_1 instanceof EditedWorkingCopySource) {
                this.ltf_1.t42().g93(Companion_getInstance_419().qtc_1, this.itf_1.zt8_1.rtf_1);
              }
              var tmp_2 = this.itf_1;
              if (tmp_2 instanceof EditableNodeInfo) {
                disposable.k2l(attachOtSupport(this.htf_1, this.ltf_1, mapper, this.itf_1));
              }
              var tmp_3 = this.itf_1.at9_1;
              if (isInterface(tmp_3, BTBDocument_1)) {
                disposable.k2l(watchCategories(this.htf_1, this.itf_1.at9_1));
              }
            }

            var tmp_4 = this;
            var tmp_5 = get_wrapperContext(domainModel);
            var tmp_6 = this.itf_1.at9_1;
            var tmp0_safe_receiver = isInterface(tmp_6, TypedOtNode) ? tmp_6 : null;
            tmp_4.ktf_1 = new EditorComponent(tmp_5, serializationConfig, tmp0_safe_receiver == null ? null : tmp0_safe_receiver.g3t(), this.ltf_1, mapper, this.htf_1.ft8_1, disposable);
            this.htf_1.qt9(this.ktf_1);
            if (this.itf_1.ct9_1.ntf_1.vct_1) {
              var tmp1_safe_receiver = domainModel.ddf_1.h3b(Companion_instance_310);
              var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.gfg_1;
              if (tmp2_safe_receiver == null) {
                this.mtf_1 = null;
                this.f9_1 = 2;
                continue $sm;
              } else {
                this.f9_1 = 1;
                suspendResult = first_3(tmp2_safe_receiver, NodeEditorBase$doOpen$slambda_0(null), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              }
            } else {
              this.f9_1 = 3;
              continue $sm;
            }

          case 1:
            this.mtf_1 = suspendResult;
            this.f9_1 = 2;
            continue $sm;
          case 2:
            this.f9_1 = 3;
            continue $sm;
          case 3:
            this.f9_1 = 4;
            suspendResult = waitForAsyncWork(this.ltf_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            var result = this.ktf_1;
            var _destruct__k2r9zo = new TimedValue(result, ValueTimeMark__elapsedNow_impl_eonqvs(this.jtf_1));
            var component = _destruct__k2r9zo.fg();
            var duration = _destruct__k2r9zo.il();
            this.htf_1.et8_1.gtb(duration);
            return component;
          case 5:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 5) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function NodeEditorBase(coroutineContext, view, editorOpeningMonitoring) {
    Companion_getInstance_419();
    this.ct8_1 = coroutineContext;
    this.dt8_1 = view;
    this.et8_1 = editorOpeningMonitoring;
    this.ft8_1 = new Notifier();
    this.gt8_1 = new OneJobRunner();
    this.ht8_1 = new OneJobRunner();
    this.it8_1 = Companion_getInstance_29().m2l_1;
    this.jt8_1 = false;
    this.lt8_1 = null;
  }
  protoOf(NodeEditorBase).qt9 = function (newComponent) {
    this.kt8_1 = newComponent;
    this.it8_1.zr();
    this.it8_1 = this.dt8_1.xtf(newComponent.kt7_1);
  };
  protoOf(NodeEditorBase).zr = function () {
    // Inline function 'kotlin.check' call
    if (!!this.jt8_1) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    this.it8_1.zr();
    this.jt8_1 = true;
  };
  protoOf(NodeEditorBase).yt6 = function (nodeId) {
    _get_component__t10gzw(this).ctb(new NodeEditorPart(nodeId, null), NodeSelection_CARET_getInstance());
  };
  protoOf(NodeEditorBase).zt6 = function (part) {
    return _get_component__t10gzw(this).ctb(part, NodeSelection_BACKGROUND_getInstance());
  };
  protoOf(NodeEditorBase).at7 = function () {
    Companion_instance_423.ytf(ensureNotNull(_get_component__t10gzw(this).kt7_1.t42().y35()));
  };
  protoOf(NodeEditorBase).tt9 = function () {
    var tmp = CoroutineScope_0(this.ct8_1);
    launch(tmp, VOID, VOID, NodeEditorBase$findUsagesOfCurrentNode$slambda_0(this, null));
  };
  protoOf(NodeEditorBase).ut9 = function () {
    var tmp = CoroutineScope_0(this.ct8_1);
    launch(tmp, VOID, VOID, NodeEditorBase$navigate$slambda_0(this, null));
  };
  protoOf(NodeEditorBase).bt7 = function (type, listener) {
    return this.ft8_1.bt7(type, listener);
  };
  protoOf(NodeEditorBase).ct7 = function (part, listener) {
    return Companion_getInstance_29().m2l_1;
  };
  protoOf(NodeEditorBase).pt9 = function (block, $completion) {
    return withContext(this.ct8_1, NodeEditorBase$singleOpenTask$slambda_0(this, block, null), $completion);
  };
  protoOf(NodeEditorBase).mt8 = function (nodeInfo, $completion) {
    var tmp = new $doOpenCOROUTINE$(this, nodeInfo, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  function NodeEditorPart(nodeId, propertyId) {
    this.nodeId = nodeId;
    this.propertyId = propertyId;
  }
  protoOf(NodeEditorPart).v3w = function () {
    return this.nodeId;
  };
  protoOf(NodeEditorPart).j3n = function () {
    return this.propertyId;
  };
  protoOf(NodeEditorPart).fg = function () {
    return this.nodeId;
  };
  protoOf(NodeEditorPart).gg = function () {
    return this.propertyId;
  };
  protoOf(NodeEditorPart).ztf = function (nodeId, propertyId) {
    return new NodeEditorPart(nodeId, propertyId);
  };
  protoOf(NodeEditorPart).copy = function (nodeId, propertyId, $super) {
    nodeId = nodeId === VOID ? this.nodeId : nodeId;
    propertyId = propertyId === VOID ? this.propertyId : propertyId;
    return $super === VOID ? this.ztf(nodeId, propertyId) : $super.ztf.call(this, nodeId, propertyId);
  };
  protoOf(NodeEditorPart).toString = function () {
    return 'NodeEditorPart(nodeId=' + this.nodeId + ', propertyId=' + this.propertyId + ')';
  };
  protoOf(NodeEditorPart).hashCode = function () {
    var result = getStringHashCode(this.nodeId);
    result = imul(result, 31) + (this.propertyId == null ? 0 : getStringHashCode(this.propertyId)) | 0;
    return result;
  };
  protoOf(NodeEditorPart).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof NodeEditorPart))
      return false;
    if (!(this.nodeId === other.nodeId))
      return false;
    if (!(this.propertyId == other.propertyId))
      return false;
    return true;
  };
  function sam$jetbrains_ocelot_base_edt_EdtTask$0_23(function_0) {
    this.atg_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_23).au = function () {
    return this.atg_1();
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_23).f3 = function () {
    return this.atg_1;
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_23).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, EdtTask) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_23).hashCode = function () {
    return hashCode(this.f3());
  };
  function NodeSelection$CARET$invoke$lambda($cell) {
    return function () {
      CellScrolling_getInstance().xa4($cell);
      toFirstFocusable($cell)();
      return Unit_instance;
    };
  }
  function NodeSelection$CARET() {
    NodeSelection.call(this, 'CARET', 0);
    NodeSelection_CARET_instance = this;
  }
  protoOf(NodeSelection$CARET).ock = function (cell) {
    var tmp0_safe_receiver = cell.s8x();
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.m93();
    if (tmp1_safe_receiver == null)
      null;
    else {
      var tmp = NodeSelection$CARET$invoke$lambda(cell);
      tmp1_safe_receiver.u39(new sam$jetbrains_ocelot_base_edt_EdtTask$0_23(tmp));
    }
    return Companion_getInstance_29().m2l_1;
  };
  var NodeSelection_CARET_instance;
  function NodeSelection$BACKGROUND() {
    NodeSelection.call(this, 'BACKGROUND', 1);
    NodeSelection_BACKGROUND_instance = this;
  }
  protoOf(NodeSelection$BACKGROUND).ock = function (cell) {
    return cell.i90(get_BACKGROUND(), Companion_getInstance_210().i96_1);
  };
  var NodeSelection_BACKGROUND_instance;
  var NodeSelection_entriesInitialized;
  function NodeSelection_initEntries() {
    if (NodeSelection_entriesInitialized)
      return Unit_instance;
    NodeSelection_entriesInitialized = true;
    NodeSelection_CARET_instance = new NodeSelection$CARET();
    NodeSelection_BACKGROUND_instance = new NodeSelection$BACKGROUND();
  }
  function NodeSelection(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function NodeSelection_CARET_getInstance() {
    NodeSelection_initEntries();
    return NodeSelection_CARET_instance;
  }
  function NodeSelection_BACKGROUND_getInstance() {
    NodeSelection_initEntries();
    return NodeSelection_BACKGROUND_instance;
  }
  function NonCachingNodeEditor$open$slambda(this$0, $source, resultContinuation) {
    this.ntg_1 = this$0;
    this.otg_1 = $source;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(NonCachingNodeEditor$open$slambda).e1h = function ($this$singleOpenTask, $completion) {
    var tmp = this.f1h($this$singleOpenTask, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(NonCachingNodeEditor$open$slambda).v9 = function (p1, $completion) {
    return this.e1h((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(NonCachingNodeEditor$open$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 3;
            this.f9_1 = 1;
            suspendResult = this.otg_1.bt8(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            this.f9_1 = 2;
            suspendResult = this.ntg_1.mt8(ARGUMENT, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 3) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(NonCachingNodeEditor$open$slambda).f1h = function ($this$singleOpenTask, completion) {
    var i = new NonCachingNodeEditor$open$slambda(this.ntg_1, this.otg_1, completion);
    i.ptg_1 = $this$singleOpenTask;
    return i;
  };
  function NonCachingNodeEditor$open$slambda_0(this$0, $source, resultContinuation) {
    var i = new NonCachingNodeEditor$open$slambda(this$0, $source, resultContinuation);
    var l = function ($this$singleOpenTask, $completion) {
      return i.e1h($this$singleOpenTask, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function $doOpenCOROUTINE$_0(_this__u8e3s4, nodeInfo, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.jth_1 = _this__u8e3s4;
    this.kth_1 = nodeInfo;
  }
  protoOf($doOpenCOROUTINE$_0).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = protoOf(NodeEditorBase).mt8.call(this.jth_1, this.kth_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var newComponent = suspendResult;
            this.jth_1.ath_1.zr();
            this.jth_1.ath_1 = newComponent;
            return newComponent;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function NonCachingNodeEditor(coroutineContext, view, editorOpeningMonitoring) {
    editorOpeningMonitoring = editorOpeningMonitoring === VOID ? Companion_getInstance_418().htb_1 : editorOpeningMonitoring;
    NodeEditorBase.call(this, coroutineContext, view, editorOpeningMonitoring);
    this.ath_1 = Companion_getInstance_29().m2l_1;
  }
  protoOf(NonCachingNodeEditor).rt9 = function (source, $completion) {
    return this.pt9(NonCachingNodeEditor$open$slambda_0(this, source, null), $completion);
  };
  protoOf(NonCachingNodeEditor).mt8 = function (nodeInfo, $completion) {
    var tmp = new $doOpenCOROUTINE$_0(this, nodeInfo, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(NonCachingNodeEditor).zr = function () {
    protoOf(NodeEditorBase).zr.call(this);
    this.ath_1.zr();
  };
  function OneJobRunner$run$slambda$slambda($block, resultContinuation) {
    this.tth_1 = $block;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(OneJobRunner$run$slambda$slambda).e1h = function ($this$launch, $completion) {
    var tmp = this.f1h($this$launch, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(OneJobRunner$run$slambda$slambda).v9 = function (p1, $completion) {
    return this.e1h((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(OneJobRunner$run$slambda$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.tth_1(this.uth_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(OneJobRunner$run$slambda$slambda).f1h = function ($this$launch, completion) {
    var i = new OneJobRunner$run$slambda$slambda(this.tth_1, completion);
    i.uth_1 = $this$launch;
    return i;
  };
  function OneJobRunner$run$slambda$slambda_0($block, resultContinuation) {
    var i = new OneJobRunner$run$slambda$slambda($block, resultContinuation);
    var l = function ($this$launch, $completion) {
      return i.e1h($this$launch, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function OneJobRunner$run$slambda(this$0, $block, resultContinuation) {
    this.dti_1 = this$0;
    this.eti_1 = $block;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(OneJobRunner$run$slambda).e1h = function ($this$coroutineScope, $completion) {
    var tmp = this.f1h($this$coroutineScope, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(OneJobRunner$run$slambda).v9 = function (p1, $completion) {
    return this.e1h((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(OneJobRunner$run$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        if (tmp === 0) {
          this.g9_1 = 1;
          var tmp0_safe_receiver = this.dti_1.rtd_1;
          if (tmp0_safe_receiver == null)
            null;
          else {
            tmp0_safe_receiver.sp();
          }
          var tmp_0 = this.dti_1;
          tmp_0.rtd_1 = launch(this.fti_1, VOID, VOID, OneJobRunner$run$slambda$slambda_0(this.eti_1, null));
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(OneJobRunner$run$slambda).f1h = function ($this$coroutineScope, completion) {
    var i = new OneJobRunner$run$slambda(this.dti_1, this.eti_1, completion);
    i.fti_1 = $this$coroutineScope;
    return i;
  };
  function OneJobRunner$run$slambda_0(this$0, $block, resultContinuation) {
    var i = new OneJobRunner$run$slambda(this$0, $block, resultContinuation);
    var l = function ($this$coroutineScope, $completion) {
      return i.e1h($this$coroutineScope, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function OneJobRunner() {
    this.rtd_1 = null;
  }
  protoOf(OneJobRunner).std = function (block, $completion) {
    return coroutineScope(OneJobRunner$run$slambda_0(this, block, null), $completion);
  };
  function readOnlyBlock(_this__u8e3s4, editorDefinitions, init) {
    editorDefinitions = editorDefinitions === VOID ? get_btbEditorDefinitions() : editorDefinitions;
    return indent_0(_this__u8e3s4, VOID, VOID, readOnlyBlock$lambda(editorDefinitions, init));
  }
  function createReadOnlyBuilder(delegate, readOnlyConfig) {
    return new createReadOnlyBuilder$1(delegate, readOnlyConfig);
  }
  function readOnlyBlock$2$readOnlyConfig$1($parentConfig, $readOnlyRegistry) {
    this.hti_1 = $readOnlyRegistry;
    this.gti_1 = $parentConfig;
  }
  protoOf(readOnlyBlock$2$readOnlyConfig$1).acu = function () {
    return true;
  };
  protoOf(readOnlyBlock$2$readOnlyConfig$1).nd5 = function () {
    return false;
  };
  protoOf(readOnlyBlock$2$readOnlyConfig$1).gd1 = function () {
    return this.hti_1;
  };
  protoOf(readOnlyBlock$2$readOnlyConfig$1).l6z = function () {
    return this.gti_1.l6z();
  };
  protoOf(readOnlyBlock$2$readOnlyConfig$1).ud0 = function () {
    return this.gti_1.ud0();
  };
  protoOf(readOnlyBlock$2$readOnlyConfig$1).gd3 = function () {
    return this.gti_1.gd3();
  };
  protoOf(readOnlyBlock$2$readOnlyConfig$1).kd5 = function () {
    return this.gti_1.kd5();
  };
  protoOf(readOnlyBlock$2$readOnlyConfig$1).ld5 = function () {
    return this.gti_1.ld5();
  };
  protoOf(readOnlyBlock$2$readOnlyConfig$1).hd3 = function () {
    return this.gti_1.hd3();
  };
  protoOf(readOnlyBlock$2$readOnlyConfig$1).nd0 = function () {
    return this.gti_1.nd0();
  };
  protoOf(readOnlyBlock$2$readOnlyConfig$1).md5 = function () {
    return this.gti_1.md5();
  };
  protoOf(readOnlyBlock$2$readOnlyConfig$1).md0 = function () {
    return this.gti_1.md0();
  };
  protoOf(readOnlyBlock$2$readOnlyConfig$1).ad2 = function () {
    return this.gti_1.ad2();
  };
  function readOnlyBlock$lambda($editorDefinitions, $init) {
    return function ($this$indent) {
      var tmp = asInternalEditorBuilder($this$indent);
      var parentBuilder = isInterface(tmp, InternalEditorBuilder) ? tmp : THROW_CCE();
      var tmp_0 = $this$indent.ld0();
      var parentConfig = isInterface(tmp_0, InternalEditorBuilderConfig) ? tmp_0 : THROW_CCE();
      var readOnlyRegistry = new EditorRegistryImpl($editorDefinitions, parentConfig.gd3());
      var readOnlyConfig = new readOnlyBlock$2$readOnlyConfig$1(parentConfig, readOnlyRegistry);
      readOnlyRegistry.zd2(readOnlyConfig);
      var readOnlyBuilder = createReadOnlyBuilder(parentBuilder, readOnlyConfig);
      $init(readOnlyBuilder);
      return Unit_instance;
    };
  }
  function createReadOnlyBuilder$1($delegate, $readOnlyConfig) {
    this.jti_1 = $delegate;
    this.kti_1 = $readOnlyConfig;
    this.iti_1 = $delegate;
  }
  protoOf(createReadOnlyBuilder$1).ld0 = function () {
    return this.kti_1;
  };
  protoOf(createReadOnlyBuilder$1).lti = function (cell) {
    var tmp = asInternalEditorBuilder(this.jti_1.pd0(cell));
    var originalChildBuilder = isInterface(tmp, InternalEditorBuilder) ? tmp : THROW_CCE();
    var tmp_0 = createReadOnlyBuilder(originalChildBuilder, this.kti_1);
    return isInterface(tmp_0, EditorBuilder) ? tmp_0 : THROW_CCE();
  };
  protoOf(createReadOnlyBuilder$1).pd0 = function (cell) {
    return this.lti(isInterface(cell, Cell) ? cell : THROW_CCE());
  };
  protoOf(createReadOnlyBuilder$1).od0 = function (cell) {
    this.iti_1.od0(cell);
  };
  protoOf(createReadOnlyBuilder$1).td5 = function (disposable) {
    this.iti_1.td5(disposable);
  };
  protoOf(createReadOnlyBuilder$1).l8b = function (synchronizer) {
    this.iti_1.l8b(synchronizer);
  };
  protoOf(createReadOnlyBuilder$1).td3 = function (handler) {
    this.iti_1.td3(handler);
  };
  protoOf(createReadOnlyBuilder$1).ud3 = function (invalidationContext) {
    return this.iti_1.ud3(invalidationContext);
  };
  protoOf(createReadOnlyBuilder$1).vd3 = function (body) {
    this.iti_1.vd3(body);
  };
  protoOf(createReadOnlyBuilder$1).m6d = function () {
    return this.iti_1.m6d();
  };
  protoOf(createReadOnlyBuilder$1).qd0 = function () {
    return this.iti_1.qd0();
  };
  function implyHttpProtocol($this, _this__u8e3s4) {
    return _get_protocol__elfktv($this, _this__u8e3s4) == null ? 'http://' + _this__u8e3s4 : _this__u8e3s4;
  }
  function _get_protocol__elfktv($this, _this__u8e3s4) {
    var tmp0_safe_receiver = $this.nti_1.cd(_this__u8e3s4);
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.a1();
  }
  function URLHandler() {
    URLHandler_instance = this;
    URLCellTrait.call(this, [Companion_getInstance_419().ptc_1]);
    var tmp = this;
    // Inline function 'kotlin.text.toRegex' call
    var this_0 = '^([a-z][a-z0-9+\\-.]*)://';
    tmp.nti_1 = Regex_init_$Create$(this_0);
  }
  protoOf(URLHandler).zaf = function (url) {
    navigateToUrl(implyHttpProtocol(this, url));
  };
  var URLHandler_instance;
  function URLHandler_getInstance() {
    if (URLHandler_instance == null)
      new URLHandler();
    return URLHandler_instance;
  }
  function $getDocumentContentCOROUTINE$(_this__u8e3s4, accession, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.wti_1 = _this__u8e3s4;
    this.xti_1 = accession;
  }
  protoOf($getDocumentContentCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 3;
            var tmp0 = this.wti_1.yti_1;
            var urlString = this.wti_1.zti_1 + '/documents/' + this.xti_1 + '/content';
            var this_0 = new HttpRequestBuilder();
            url(this_0, urlString);
            this_0.trc_1 = Companion_getInstance_376().ur2_1;
            this.f9_1 = 1;
            suspendResult = (new HttpStatement(this_0, tmp0)).ks3(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var this_1 = suspendResult;
            this.f9_1 = 2;
            var tmp_0 = this_1.vrf();
            var tmp_1 = JsType_instance;
            var tmp_2 = PrimitiveClasses_getInstance().tb();
            var tmp_3;
            try {
              tmp_3 = createKType(PrimitiveClasses_getInstance().tb(), arrayOf([]), false);
            } catch ($p) {
              var tmp_4;
              if ($p instanceof Error) {
                var cause = $p;
                tmp_4 = null;
              } else {
                throw $p;
              }
              tmp_3 = tmp_4;
            }

            suspendResult = tmp_0.zre(typeInfoImpl(tmp_1, tmp_2, tmp_3), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return (!(suspendResult == null) ? typeof suspendResult === 'string' : false) ? suspendResult : THROW_CCE();
          case 3:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 3) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function $getReferenceToPaperCOROUTINE$(_this__u8e3s4, pubMedId, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.itj_1 = _this__u8e3s4;
    this.jtj_1 = pubMedId;
  }
  protoOf($getReferenceToPaperCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 3;
            var tmp0 = this.itj_1.yti_1;
            var urlString = this.itj_1.zti_1 + '/documents/paper-reference/' + this.jtj_1;
            var this_0 = new HttpRequestBuilder();
            url(this_0, urlString);
            this_0.trc_1 = Companion_getInstance_376().ur2_1;
            this.f9_1 = 1;
            suspendResult = (new HttpStatement(this_0, tmp0)).ks3(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var this_1 = suspendResult;
            this.f9_1 = 2;
            var tmp_0 = this_1.vrf();
            var tmp_1 = JsType_instance;
            var tmp_2 = getKClass(PubMedPaperLoadResultDto);
            var tmp_3;
            try {
              tmp_3 = createKType(getKClass(PubMedPaperLoadResultDto), arrayOf([]), false);
            } catch ($p) {
              var tmp_4;
              if ($p instanceof Error) {
                var cause = $p;
                tmp_4 = null;
              } else {
                throw $p;
              }
              tmp_3 = tmp_4;
            }

            suspendResult = tmp_0.zre(typeInfoImpl(tmp_1, tmp_2, tmp_3), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return suspendResult instanceof PubMedPaperLoadResultDto ? suspendResult : THROW_CCE();
          case 3:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 3) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function EditorDocumentsApi(client, editorServiceRestRoute) {
    this.yti_1 = client;
    this.zti_1 = editorServiceRestRoute;
  }
  protoOf(EditorDocumentsApi).ktj = function (accession, $completion) {
    var tmp = new $getDocumentContentCOROUTINE$(this, accession, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(EditorDocumentsApi).ltj = function (pubMedId, $completion) {
    var tmp = new $getReferenceToPaperCOROUTINE$(this, pubMedId, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  function $calculateResolversCOROUTINE$(_this__u8e3s4, accession, nodeId, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.utj_1 = _this__u8e3s4;
    this.vtj_1 = accession;
    this.wtj_1 = nodeId;
  }
  protoOf($calculateResolversCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 3;
            var tmp0 = this.utj_1.xtj_1;
            var urlString = this.utj_1.ytj_1 + '/resolver/' + this.vtj_1;
            var this_0 = new HttpRequestBuilder();
            url(this_0, urlString);
            parameter(this_0, 'nodeId', this.wtj_1);
            this_0.trc_1 = Companion_getInstance_376().ur2_1;
            this.f9_1 = 1;
            suspendResult = (new HttpStatement(this_0, tmp0)).ks3(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var this_1 = suspendResult;
            this.f9_1 = 2;
            var tmp_0 = this_1.vrf();
            var tmp_1 = JsType_instance;
            var tmp_2 = getKClass(NodeResolveInfo);
            var tmp_3;
            try {
              tmp_3 = createKType(getKClass(NodeResolveInfo), arrayOf([]), false);
            } catch ($p) {
              var tmp_4;
              if ($p instanceof Error) {
                var cause = $p;
                tmp_4 = null;
              } else {
                throw $p;
              }
              tmp_3 = tmp_4;
            }

            suspendResult = tmp_0.zre(typeInfoImpl(tmp_1, tmp_2, tmp_3), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return suspendResult instanceof NodeResolveInfo ? suspendResult : THROW_CCE();
          case 3:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 3) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function $measureMetricsCOROUTINE$(_this__u8e3s4, metrics, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.htk_1 = _this__u8e3s4;
    this.itk_1 = metrics;
  }
  protoOf($measureMetricsCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            var tmp0 = this.htk_1.xtj_1;
            var urlString = this.htk_1.ytj_1 + '/perf';
            var this_0 = new HttpRequestBuilder();
            url(this_0, urlString);
            contentType_1(this_0, Application_getInstance().eqx_1);
            var body = this.itk_1;
            if (body == null) {
              this_0.vrc_1 = NullBody_instance;
              var tmp_0 = JsType_instance;
              var tmp_1 = getKClass(KtList);
              var tmp_2;
              try {
                tmp_2 = createKType(getKClass(KtList), arrayOf([createInvariantKTypeProjection(createKType(getKClass(PerformanceMonitoringMetric), arrayOf([]), false))]), false);
              } catch ($p) {
                var tmp_3;
                if ($p instanceof Error) {
                  var cause = $p;
                  tmp_3 = null;
                } else {
                  throw $p;
                }
                tmp_2 = tmp_3;
              }
              this_0.gri(typeInfoImpl(tmp_0, tmp_1, tmp_2));
            } else {
              if (body instanceof OutgoingContent) {
                this_0.vrc_1 = body;
                this_0.gri(null);
              } else {
                this_0.vrc_1 = body;
                var tmp_4 = JsType_instance;
                var tmp_5 = getKClass(KtList);
                var tmp_6;
                try {
                  tmp_6 = createKType(getKClass(KtList), arrayOf([createInvariantKTypeProjection(createKType(getKClass(PerformanceMonitoringMetric), arrayOf([]), false))]), false);
                } catch ($p) {
                  var tmp_7;
                  if ($p instanceof Error) {
                    var cause_0 = $p;
                    tmp_7 = null;
                  } else {
                    throw $p;
                  }
                  tmp_6 = tmp_7;
                }
                this_0.gri(typeInfoImpl(tmp_4, tmp_5, tmp_6));
              }
            }

            this_0.trc_1 = Companion_getInstance_376().vr2_1;
            this.f9_1 = 1;
            suspendResult = (new HttpStatement(this_0, tmp0)).ks3(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function EditorsApi(client, editorServiceRestRoute) {
    this.xtj_1 = client;
    this.ytj_1 = editorServiceRestRoute;
  }
  protoOf(EditorsApi).jtk = function (accession, nodeId, $completion) {
    var tmp = new $calculateResolversCOROUTINE$(this, accession, nodeId, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(EditorsApi).ktk = function (metrics, $completion) {
    var tmp = new $measureMetricsCOROUTINE$(this, metrics, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  function $getDocumentResolvedCOROUTINE$(_this__u8e3s4, accession, globalVersionId, nodeId, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.ttk_1 = _this__u8e3s4;
    this.utk_1 = accession;
    this.vtk_1 = globalVersionId;
    this.wtk_1 = nodeId;
  }
  protoOf($getDocumentResolvedCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 3;
            var tmp0 = this.ttk_1.xtk_1;
            var urlString = this.ttk_1.ytk_1 + '/viewer/documents/' + this.utk_1 + '/resolved';
            var this_0 = new HttpRequestBuilder();
            url(this_0, urlString);
            parameter(this_0, 'global-version', this.vtk_1);
            if (!(this.wtk_1 == null)) {
              parameter(this_0, 'node-id', this.wtk_1);
            }

            this.f9_1 = 1;
            suspendResult = (new HttpStatement(this_0, tmp0)).ks3(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var this_1 = suspendResult;
            this.f9_1 = 2;
            var tmp_0 = this_1.vrf();
            var tmp_1 = JsType_instance;
            var tmp_2 = getKClass(SerializedResolvedNode);
            var tmp_3;
            try {
              tmp_3 = createKType(getKClass(SerializedResolvedNode), arrayOf([]), false);
            } catch ($p) {
              var tmp_4;
              if ($p instanceof Error) {
                var cause = $p;
                tmp_4 = null;
              } else {
                throw $p;
              }
              tmp_3 = tmp_4;
            }

            suspendResult = tmp_0.zre(typeInfoImpl(tmp_1, tmp_2, tmp_3), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return suspendResult instanceof SerializedResolvedNode ? suspendResult : THROW_CCE();
          case 3:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 3) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function $getDocumentResolvedCOROUTINE$_0(_this__u8e3s4, accession, revision, nodeId, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.htl_1 = _this__u8e3s4;
    this.itl_1 = accession;
    this.jtl_1 = revision;
    this.ktl_1 = nodeId;
  }
  protoOf($getDocumentResolvedCOROUTINE$_0).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 3;
            var tmp0 = this.htl_1.xtk_1;
            var urlString = this.htl_1.ytk_1 + '/viewer/documents/' + this.itl_1 + '/resolved';
            var this_0 = new HttpRequestBuilder();
            url(this_0, urlString);
            parameter(this_0, 'revision', this.jtl_1);
            if (!(this.ktl_1 == null)) {
              parameter(this_0, 'node-id', this.ktl_1);
            }

            this.f9_1 = 1;
            suspendResult = (new HttpStatement(this_0, tmp0)).ks3(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var this_1 = suspendResult;
            this.f9_1 = 2;
            var tmp_0 = this_1.vrf();
            var tmp_1 = JsType_instance;
            var tmp_2 = getKClass(SerializedResolvedNode);
            var tmp_3;
            try {
              tmp_3 = createKType(getKClass(SerializedResolvedNode), arrayOf([]), false);
            } catch ($p) {
              var tmp_4;
              if ($p instanceof Error) {
                var cause = $p;
                tmp_4 = null;
              } else {
                throw $p;
              }
              tmp_3 = tmp_4;
            }

            suspendResult = tmp_0.zre(typeInfoImpl(tmp_1, tmp_2, tmp_3), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return suspendResult instanceof SerializedResolvedNode ? suspendResult : THROW_CCE();
          case 3:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 3) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function ExplorerApi(client, documentServiceRestRoute) {
    this.xtk_1 = client;
    this.ytk_1 = documentServiceRestRoute;
  }
  protoOf(ExplorerApi).ltl = function (accession, globalVersionId, nodeId, $completion) {
    var tmp = new $getDocumentResolvedCOROUTINE$(this, accession, globalVersionId, nodeId, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(ExplorerApi).mtl = function (accession, globalVersionId, nodeId, $completion, $super) {
    nodeId = nodeId === VOID ? null : nodeId;
    return $super === VOID ? this.ltl(accession, globalVersionId, nodeId, $completion) : $super.ltl.call(this, accession, globalVersionId, nodeId, $completion);
  };
  protoOf(ExplorerApi).ntl = function (accession, revision, nodeId, $completion) {
    var tmp = new $getDocumentResolvedCOROUTINE$_0(this, accession, revision, nodeId, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(ExplorerApi).otl = function (accession, revision, nodeId, $completion, $super) {
    nodeId = nodeId === VOID ? null : nodeId;
    return $super === VOID ? this.ntl(accession, revision, nodeId, $completion) : $super.ntl.call(this, accession, revision, nodeId, $completion);
  };
  function $getQueryResolvedCOROUTINE$(_this__u8e3s4, id, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.xtl_1 = _this__u8e3s4;
    this.ytl_1 = id;
  }
  protoOf($getQueryResolvedCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 3;
            var tmp0 = this.xtl_1.ztl_1;
            var urlString = this.xtl_1.atm_1 + '/queries/' + this.ytl_1.toString() + '/resolved';
            var this_0 = new HttpRequestBuilder();
            url(this_0, urlString);
            this.f9_1 = 1;
            suspendResult = (new HttpStatement(this_0, tmp0)).ks3(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var this_1 = suspendResult;
            this.f9_1 = 2;
            var tmp_0 = this_1.vrf();
            var tmp_1 = JsType_instance;
            var tmp_2 = getKClass(SerializedResolvedNode);
            var tmp_3;
            try {
              tmp_3 = createKType(getKClass(SerializedResolvedNode), arrayOf([]), false);
            } catch ($p) {
              var tmp_4;
              if ($p instanceof Error) {
                var cause = $p;
                tmp_4 = null;
              } else {
                throw $p;
              }
              tmp_3 = tmp_4;
            }

            suspendResult = tmp_0.zre(typeInfoImpl(tmp_1, tmp_2, tmp_3), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return suspendResult instanceof SerializedResolvedNode ? suspendResult : THROW_CCE();
          case 3:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 3) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function QueriesApi(client, documentServiceRestRoute) {
    this.ztl_1 = client;
    this.atm_1 = documentServiceRestRoute;
  }
  protoOf(QueriesApi).btm = function (id, $completion) {
    var tmp = new $getQueryResolvedCOROUTINE$(this, id, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  function get_FIRST_EDIT() {
    _init_properties_Events_kt__8ewmpl();
    return FIRST_EDIT;
  }
  var FIRST_EDIT;
  function get_NAVIGATE() {
    _init_properties_Events_kt__8ewmpl();
    return NAVIGATE;
  }
  var NAVIGATE;
  function get_FIND_USAGES() {
    _init_properties_Events_kt__8ewmpl();
    return FIND_USAGES;
  }
  var FIND_USAGES;
  function get_BTB_CATEGORY_EVENT() {
    _init_properties_Events_kt__8ewmpl();
    return BTB_CATEGORY_EVENT;
  }
  var BTB_CATEGORY_EVENT;
  function get_FACT_SELECTION_EVENT() {
    _init_properties_Events_kt__8ewmpl();
    return FACT_SELECTION_EVENT;
  }
  var FACT_SELECTION_EVENT;
  function get_ERROR_EVENT() {
    _init_properties_Events_kt__8ewmpl();
    return ERROR_EVENT;
  }
  var ERROR_EVENT;
  function EventType_0() {
  }
  function Event_1() {
  }
  function NodePointerEvent(accession, nodeId) {
    Event_1.call(this);
    this.accession = accession;
    this.nodeId = nodeId;
  }
  protoOf(NodePointerEvent).ks8 = function () {
    return this.accession;
  };
  protoOf(NodePointerEvent).v3w = function () {
    return this.nodeId;
  };
  function FindUsagesEvent(accession, nodeId, name, type) {
    NodePointerEvent.call(this, accession, nodeId);
    this.name = name;
    this.type = type;
  }
  protoOf(FindUsagesEvent).y2 = function () {
    return this.name;
  };
  protoOf(FindUsagesEvent).sfq = function () {
    return this.type;
  };
  function CategoryInfo(accession, nodeId, name) {
    this.accession = accession;
    this.nodeId = nodeId;
    this.name = name;
  }
  protoOf(CategoryInfo).ks8 = function () {
    return this.accession;
  };
  protoOf(CategoryInfo).v3w = function () {
    return this.nodeId;
  };
  protoOf(CategoryInfo).y2 = function () {
    return this.name;
  };
  protoOf(CategoryInfo).fg = function () {
    return this.accession;
  };
  protoOf(CategoryInfo).gg = function () {
    return this.nodeId;
  };
  protoOf(CategoryInfo).zl = function () {
    return this.name;
  };
  protoOf(CategoryInfo).ctm = function (accession, nodeId, name) {
    return new CategoryInfo(accession, nodeId, name);
  };
  protoOf(CategoryInfo).copy = function (accession, nodeId, name, $super) {
    accession = accession === VOID ? this.accession : accession;
    nodeId = nodeId === VOID ? this.nodeId : nodeId;
    name = name === VOID ? this.name : name;
    return $super === VOID ? this.ctm(accession, nodeId, name) : $super.ctm.call(this, accession, nodeId, name);
  };
  protoOf(CategoryInfo).toString = function () {
    return 'CategoryInfo(accession=' + this.accession + ', nodeId=' + this.nodeId + ', name=' + this.name + ')';
  };
  protoOf(CategoryInfo).hashCode = function () {
    var result = getStringHashCode(this.accession);
    result = imul(result, 31) + getStringHashCode(this.nodeId) | 0;
    result = imul(result, 31) + getStringHashCode(this.name) | 0;
    return result;
  };
  protoOf(CategoryInfo).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CategoryInfo))
      return false;
    if (!(this.accession === other.accession))
      return false;
    if (!(this.nodeId === other.nodeId))
      return false;
    if (!(this.name === other.name))
      return false;
    return true;
  };
  function BTBCategoryEvent(categoryInfo, kind) {
    Event_1.call(this);
    this.categoryInfo = categoryInfo;
    this.kind = kind;
  }
  protoOf(BTBCategoryEvent).dtm = function () {
    return this.categoryInfo;
  };
  protoOf(BTBCategoryEvent).r5a = function () {
    return this.kind;
  };
  function FactSelectionEvent(factIds) {
    Event_1.call(this);
    this.factIds = factIds;
  }
  protoOf(FactSelectionEvent).etm = function () {
    return this.factIds;
  };
  function ErrorEvent(area, message, description) {
    Event_1.call(this);
    this.area = area;
    this.message = message;
    this.description = description;
  }
  protoOf(ErrorEvent).ftm = function () {
    return this.area;
  };
  protoOf(ErrorEvent).e = function () {
    return this.message;
  };
  protoOf(ErrorEvent).mmd = function () {
    return this.description;
  };
  var BTBCategoryEventKind_ADD_instance;
  var BTBCategoryEventKind_REMOVE_instance;
  function values_20() {
    return [BTBCategoryEventKind_ADD_getInstance(), BTBCategoryEventKind_REMOVE_getInstance()];
  }
  function valueOf(value) {
    switch (value) {
      case 'ADD':
        return BTBCategoryEventKind_ADD_getInstance();
      case 'REMOVE':
        return BTBCategoryEventKind_REMOVE_getInstance();
      default:
        BTBCategoryEventKind_initEntries();
        THROW_IAE('No enum constant jetbrains.biokb.editor.event.BTBCategoryEventKind.' + value);
        break;
    }
  }
  var BTBCategoryEventKind_entriesInitialized;
  function BTBCategoryEventKind_initEntries() {
    if (BTBCategoryEventKind_entriesInitialized)
      return Unit_instance;
    BTBCategoryEventKind_entriesInitialized = true;
    BTBCategoryEventKind_ADD_instance = new BTBCategoryEventKind('ADD', 0);
    BTBCategoryEventKind_REMOVE_instance = new BTBCategoryEventKind('REMOVE', 1);
  }
  function BTBCategoryEventKind(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function FIRST_EDIT$1() {
    EventType_0.call(this);
  }
  function NAVIGATE$1() {
    EventType_0.call(this);
  }
  function FIND_USAGES$1() {
    EventType_0.call(this);
  }
  function BTB_CATEGORY_EVENT$1() {
    EventType_0.call(this);
  }
  function FACT_SELECTION_EVENT$1() {
    EventType_0.call(this);
  }
  function ERROR_EVENT$1() {
    EventType_0.call(this);
  }
  function BTBCategoryEventKind_ADD_getInstance() {
    BTBCategoryEventKind_initEntries();
    return BTBCategoryEventKind_ADD_instance;
  }
  function BTBCategoryEventKind_REMOVE_getInstance() {
    BTBCategoryEventKind_initEntries();
    return BTBCategoryEventKind_REMOVE_instance;
  }
  var properties_initialized_Events_kt_yci8fv;
  function _init_properties_Events_kt__8ewmpl() {
    if (!properties_initialized_Events_kt_yci8fv) {
      properties_initialized_Events_kt_yci8fv = true;
      FIRST_EDIT = new FIRST_EDIT$1();
      NAVIGATE = new NAVIGATE$1();
      FIND_USAGES = new FIND_USAGES$1();
      BTB_CATEGORY_EVENT = new BTB_CATEGORY_EVENT$1();
      FACT_SELECTION_EVENT = new FACT_SELECTION_EVENT$1();
      ERROR_EVENT = new ERROR_EVENT$1();
    }
  }
  function fire_4($this, type, event) {
    var tmp0_safe_receiver = $this.st6_1.q2(type);
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.k2s(Notifier$fire$lambda(event));
    }
  }
  function Notifier$subscribe$$inlined$toDisposable$1(this$0, $type, $listener) {
    this.itm_1 = this$0;
    this.jtm_1 = $type;
    this.ktm_1 = $listener;
  }
  protoOf(Notifier$subscribe$$inlined$toDisposable$1).zr = function () {
    var tmp0_safe_receiver = this.itm_1.tt6_1.u2(new Pair(this.jtm_1, this.ktm_1));
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.zr();
    }
    return Unit_instance;
  };
  function Notifier$fire$lambda($event) {
    return function (it) {
      it($event);
      return Unit_instance;
    };
  }
  function Notifier() {
    this.st6_1 = HashMap_init_$Create$();
    this.tt6_1 = HashMap_init_$Create$();
  }
  protoOf(Notifier).bt7 = function (type, listener) {
    // Inline function 'kotlin.collections.getOrPut' call
    var this_0 = this.st6_1;
    var value = this_0.q2(type);
    var tmp;
    if (value == null) {
      var answer = new Listeners();
      this_0.t2(type, answer);
      tmp = answer;
    } else {
      tmp = value;
    }
    var reg = tmp.j2s(listener);
    var tmp0 = this.tt6_1;
    // Inline function 'kotlin.collections.set' call
    var key = new Pair(type, listener);
    tmp0.t2(key, reg);
    // Inline function 'jetbrains.ocelot.base.disposable.toDisposable' call
    return new Notifier$subscribe$$inlined$toDisposable$1(this, type, listener);
  };
  protoOf(Notifier).ftd = function () {
    fire_4(this, get_FIRST_EDIT(), new Event_1());
  };
  protoOf(Notifier).eta = function (accession, nodeId) {
    fire_4(this, get_NAVIGATE(), new NodePointerEvent(accession, nodeId));
  };
  protoOf(Notifier).sta = function (accession, nodeId, name, type) {
    fire_4(this, get_FIND_USAGES(), new FindUsagesEvent(accession, nodeId, name, type));
  };
  protoOf(Notifier).ut6 = function (info) {
    fire_4(this, get_BTB_CATEGORY_EVENT(), new BTBCategoryEvent(info, BTBCategoryEventKind_ADD_getInstance()));
  };
  protoOf(Notifier).vt6 = function (info) {
    fire_4(this, get_BTB_CATEGORY_EVENT(), new BTBCategoryEvent(info, BTBCategoryEventKind_REMOVE_getInstance()));
  };
  protoOf(Notifier).ltm = function (factIds) {
    var tmp = get_FACT_SELECTION_EVENT();
    // Inline function 'kotlin.collections.toTypedArray' call
    var tmp$ret$0 = copyToArray(factIds);
    fire_4(this, tmp, new FactSelectionEvent(tmp$ret$0));
  };
  protoOf(Notifier).mtm = function (area, message, description) {
    fire_4(this, get_ERROR_EVENT(), new ErrorEvent(area, message, description));
  };
  function EditableNodeInfo(documentSource, node, model, presentation, commandProcessor, operationProvider, edt, environmentDisposal) {
    ExplorableNodeInfo.call(this, documentSource, node, model, presentation, edt, environmentDisposal);
    this.atd_1 = commandProcessor;
    this.btd_1 = operationProvider;
  }
  function ExplorableNodeInfo(source, explorable, model, presentation, edt, environmentDisposal, cacheable) {
    cacheable = cacheable === VOID ? true : cacheable;
    this.yt8_1 = environmentDisposal;
    this.zt8_1 = source;
    this.at9_1 = explorable;
    this.bt9_1 = model;
    this.ct9_1 = presentation;
    this.dt9_1 = edt;
    this.et9_1 = cacheable;
  }
  protoOf(ExplorableNodeInfo).zr = function () {
    this.yt8_1.zr();
  };
  protoOf(ExplorableNodeInfo).j2l = function (disposable) {
    return this.yt8_1.j2l(disposable);
  };
  function initializeLocalDocument(entity, otNode, accession, name, model) {
    get_btbEntityNodeLayout().p6z(otNode, entity);
    var tmp = toDomainNode(otNode, get_wrapperContext(model));
    var node = isInterface(tmp, DocumentNode_0) ? tmp : THROW_CCE();
    node.y2().d2x(name);
    node.d6g().d2x(accession);
    return node;
  }
  function OtDocumentInfo(node, commandProcessor, operationProvider, connection) {
    this.ntm_1 = node;
    this.otm_1 = commandProcessor;
    this.ptm_1 = operationProvider;
    this.qtm_1 = connection;
  }
  protoOf(OtDocumentInfo).fg = function () {
    return this.ntm_1;
  };
  protoOf(OtDocumentInfo).gg = function () {
    return this.otm_1;
  };
  protoOf(OtDocumentInfo).zl = function () {
    return this.ptm_1;
  };
  protoOf(OtDocumentInfo).b2d = function () {
    return this.qtm_1;
  };
  protoOf(OtDocumentInfo).toString = function () {
    return 'OtDocumentInfo(node=' + toString_1(this.ntm_1) + ', commandProcessor=' + toString_1(this.otm_1) + ', operationProvider=' + toString_1(this.ptm_1) + ', connection=' + toString_1(this.qtm_1) + ')';
  };
  protoOf(OtDocumentInfo).hashCode = function () {
    var result = hashCode(this.ntm_1);
    result = imul(result, 31) + hashCode(this.otm_1) | 0;
    result = imul(result, 31) + hashCode(this.ptm_1) | 0;
    result = imul(result, 31) + hashCode(this.qtm_1) | 0;
    return result;
  };
  protoOf(OtDocumentInfo).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof OtDocumentInfo))
      return false;
    if (!equals(this.ntm_1, other.ntm_1))
      return false;
    if (!equals(this.otm_1, other.otm_1))
      return false;
    if (!equals(this.ptm_1, other.ptm_1))
      return false;
    if (!equals(this.qtm_1, other.qtm_1))
      return false;
    return true;
  };
  function initializeRemoteDocument(otEnvironment, entity, accession, name, model) {
    var processor = otEnvironment.wtm(get_wrapperContext(model));
    var node = getNode_0(entity, get_wrapperContext(model));
    node.y2().d2x(name);
    node.d6g().d2x(accession);
    var tmp = getOperationProvider(entity);
    var tmp_0 = initializeRemoteDocument$lambda(otEnvironment, entity);
    return new OtDocumentInfo(node, processor, tmp, new sam$jetbrains_ocelot_base_disposable_Disposable$0_10(tmp_0));
  }
  function getNode_0(entity, wrapperContext) {
    var tmp0_safe_receiver = entity.i3e(get_btbEntityNodeLayout().n6z_1);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.k3e_1;
    var tmp;
    if (tmp1_elvis_lhs == null) {
      throw IllegalStateException_init_$Create$();
    } else {
      tmp = tmp1_elvis_lhs;
    }
    var node = tmp;
    var tmp_0 = toDomainNode(node, wrapperContext);
    return isInterface(tmp_0, DocumentNode_0) ? tmp_0 : THROW_CCE();
  }
  function getOperationProvider(entity) {
    return new DefaultOperationProvider(entity, get_btbEntityNodeLayout().n6z_1);
  }
  function initializeDetachedNode(entity, otNode, accession, model) {
    get_btbEntityNodeLayout().p6z(otNode, entity);
    var tmp = toDomainNode(otNode, get_wrapperContext(model));
    var node = isInterface(tmp, BTBNode) ? tmp : THROW_CCE();
    DocumentIdUtil_getInstance().w6f(node, accession);
    return node;
  }
  function sam$jetbrains_ocelot_base_disposable_Disposable$0_10(function_0) {
    this.xtm_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0_10).zr = function () {
    return this.xtm_1();
  };
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0_10).f3 = function () {
    return this.xtm_1;
  };
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0_10).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Disposable) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0_10).hashCode = function () {
    return hashCode(this.f3());
  };
  function initializeRemoteDocument$lambda($otEnvironment, $entity) {
    return function () {
      $otEnvironment.ytm($entity.n3d_1);
      return Unit_instance;
    };
  }
  function ClientConnection(client, socketManager) {
    this.ztm_1 = client;
    this.atn_1 = socketManager;
  }
  protoOf(ClientConnection).toString = function () {
    return 'ClientConnection(client=' + toString_1(this.ztm_1) + ', socketManager=' + this.atn_1.toString() + ')';
  };
  protoOf(ClientConnection).hashCode = function () {
    var result = hashCode(this.ztm_1);
    result = imul(result, 31) + hashCode(this.atn_1) | 0;
    return result;
  };
  protoOf(ClientConnection).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ClientConnection))
      return false;
    if (!equals(this.ztm_1, other.ztm_1))
      return false;
    if (!equals(this.atn_1, other.atn_1))
      return false;
    return true;
  };
  function _get_clientConnection__d8cw0u($this) {
    return $this.vtm_1.a1();
  }
  function Companion_420() {
    Companion_instance_420 = this;
    this.btn_1 = getLogger_0(getKClass(OtEnvironment));
  }
  var Companion_instance_420;
  function Companion_getInstance_420() {
    if (Companion_instance_420 == null)
      new Companion_420();
    return Companion_instance_420;
  }
  function OtEnvironment$clientConnectionLazy$2$1() {
  }
  protoOf(OtEnvironment$clientConnectionLazy$2$1).ctn = function (event) {
    Companion_getInstance_420().btn_1.wde(event.t2y_1 ? 'connected!' : 'disconnected :(');
  };
  protoOf(OtEnvironment$clientConnectionLazy$2$1).n2s = function (event) {
    return this.ctn(event instanceof PropertyChangeEvent ? event : THROW_CCE());
  };
  function OtEnvironment$clientConnectionLazy$lambda$lambda($client, this$0, $nodeFactory) {
    return function (configuration) {
      return OtServiceEndpoint_init_$Create$($client, configuration, this$0.ttm_1, VOID, $nodeFactory);
    };
  }
  function OtEnvironment$clientConnectionLazy$lambda$lambda_0(this$0) {
    return function (configuration) {
      return new PingPongServiceEndpoint(this$0.ttm_1, configuration.j3c(ProtocolParameters_getInstance().asr_1));
    };
  }
  function OtEnvironment$clientConnectionLazy$lambda($nodeFactory, this$0) {
    return function () {
      var client = (new ClientBuilder($nodeFactory)).kt2(this$0.utm_1).f40();
      var tmp = client.qt0();
      tmp.y2r(new OtEnvironment$clientConnectionLazy$2$1());
      // Inline function 'kotlin.apply' call
      var this_0 = new ServiceEndpointContainer();
      this_0.psv(OtEnvironment$clientConnectionLazy$lambda$lambda(client, this$0, $nodeFactory));
      this_0.psv(OtEnvironment$clientConnectionLazy$lambda$lambda_0(this$0));
      var container = this_0;
      var socketManager = SocketManager_init_$Create$(container, this$0.rtm_1, this$0.stm_1, this$0.ttm_1);
      socketManager.csy();
      return new ClientConnection(client, socketManager);
    };
  }
  function OtEnvironment(url, socketFactory, edt, nodeFactory) {
    Companion_getInstance_420();
    this.rtm_1 = url;
    this.stm_1 = socketFactory;
    this.ttm_1 = edt;
    this.utm_1 = new EntityContext();
    var tmp = this;
    tmp.vtm_1 = lazy(OtEnvironment$clientConnectionLazy$lambda(nodeFactory, this));
  }
  protoOf(OtEnvironment).wtm = function (wrapperContext) {
    _get_clientConnection__d8cw0u(this).ztm_1.mt1(wrapperContext, this.ttm_1);
    return wrapperContext.m58(get_COMMAND_PROCESSOR_KEY());
  };
  protoOf(OtEnvironment).dtn = function (entityId, $completion) {
    return await_1(_get_clientConnection__d8cw0u(this).ztm_1.nt1(new EntityReference(entityId)), $completion);
  };
  protoOf(OtEnvironment).ytm = function (entityId) {
    if (this.utm_1.i3j(entityId)) {
      _get_clientConnection__d8cw0u(this).ztm_1.xt0(entityId);
    }
  };
  protoOf(OtEnvironment).zr = function () {
    if (this.vtm_1.tl()) {
      _get_clientConnection__d8cw0u(this).atn_1.zeu();
    }
  };
  function DocumentSource() {
  }
  function DocumentSourceDescriptor(accession, rawPointer, revision, globalVersion, rawNodeId) {
    rawPointer = rawPointer === VOID ? null : rawPointer;
    revision = revision === VOID ? null : revision;
    globalVersion = globalVersion === VOID ? null : globalVersion;
    rawNodeId = rawNodeId === VOID ? null : rawNodeId;
    this.accession = accession;
    this.rawPointer = rawPointer;
    this.revision = revision;
    this.globalVersion = globalVersion;
    this.rawNodeId = rawNodeId;
  }
  protoOf(DocumentSourceDescriptor).ks8 = function () {
    return this.accession;
  };
  protoOf(DocumentSourceDescriptor).etn = function () {
    return this.rawPointer;
  };
  protoOf(DocumentSourceDescriptor).ftn = function () {
    return this.revision;
  };
  protoOf(DocumentSourceDescriptor).gtn = function () {
    return this.globalVersion;
  };
  protoOf(DocumentSourceDescriptor).htn = function () {
    return this.rawNodeId;
  };
  protoOf(DocumentSourceDescriptor).fg = function () {
    return this.accession;
  };
  protoOf(DocumentSourceDescriptor).gg = function () {
    return this.rawPointer;
  };
  protoOf(DocumentSourceDescriptor).zl = function () {
    return this.revision;
  };
  protoOf(DocumentSourceDescriptor).b2d = function () {
    return this.globalVersion;
  };
  protoOf(DocumentSourceDescriptor).c2d = function () {
    return this.rawNodeId;
  };
  protoOf(DocumentSourceDescriptor).itn = function (accession, rawPointer, revision, globalVersion, rawNodeId) {
    return new DocumentSourceDescriptor(accession, rawPointer, revision, globalVersion, rawNodeId);
  };
  protoOf(DocumentSourceDescriptor).copy = function (accession, rawPointer, revision, globalVersion, rawNodeId, $super) {
    accession = accession === VOID ? this.accession : accession;
    rawPointer = rawPointer === VOID ? this.rawPointer : rawPointer;
    revision = revision === VOID ? this.revision : revision;
    globalVersion = globalVersion === VOID ? this.globalVersion : globalVersion;
    rawNodeId = rawNodeId === VOID ? this.rawNodeId : rawNodeId;
    return $super === VOID ? this.itn(accession, rawPointer, revision, globalVersion, rawNodeId) : $super.itn.call(this, accession, rawPointer, revision, globalVersion, rawNodeId);
  };
  protoOf(DocumentSourceDescriptor).toString = function () {
    return 'DocumentSourceDescriptor(accession=' + this.accession + ', rawPointer=' + this.rawPointer + ', revision=' + this.revision + ', globalVersion=' + toString_0(this.globalVersion) + ', rawNodeId=' + this.rawNodeId + ')';
  };
  protoOf(DocumentSourceDescriptor).hashCode = function () {
    var result = getStringHashCode(this.accession);
    result = imul(result, 31) + (this.rawPointer == null ? 0 : getStringHashCode(this.rawPointer)) | 0;
    result = imul(result, 31) + (this.revision == null ? 0 : getStringHashCode(this.revision)) | 0;
    result = imul(result, 31) + (this.globalVersion == null ? 0 : getBigIntHashCode(this.globalVersion)) | 0;
    result = imul(result, 31) + (this.rawNodeId == null ? 0 : getStringHashCode(this.rawNodeId)) | 0;
    return result;
  };
  protoOf(DocumentSourceDescriptor).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof DocumentSourceDescriptor))
      return false;
    if (!(this.accession === other.accession))
      return false;
    if (!(this.rawPointer == other.rawPointer))
      return false;
    if (!(this.revision == other.revision))
      return false;
    if (!(this.globalVersion == other.globalVersion))
      return false;
    if (!(this.rawNodeId == other.rawNodeId))
      return false;
    return true;
  };
  function get_pointer_0(_this__u8e3s4) {
    var tmp0_safe_receiver = _this__u8e3s4.rawPointer;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp = EntityId_init_$Create$_0(tmp0_safe_receiver);
    }
    return tmp;
  }
  function DraftQuerySource$load$slambda$slambda(this$0, resultContinuation) {
    this.rtn_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(DraftQuerySource$load$slambda$slambda).ttn = function ($this$async, $completion) {
    var tmp = this.f1h($this$async, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(DraftQuerySource$load$slambda$slambda).v9 = function (p1, $completion) {
    return this.ttn((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(DraftQuerySource$load$slambda$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 3;
            this.f9_1 = 1;
            suspendResult = this.rtn_1.vtn_1.qsm(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            this.f9_1 = 2;
            suspendResult = ARGUMENT.ssk(_get_accession__uiy019_0(this.rtn_1), this.rtn_1.ato_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return suspendResult;
          case 3:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 3) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(DraftQuerySource$load$slambda$slambda).f1h = function ($this$async, completion) {
    var i = new DraftQuerySource$load$slambda$slambda(this.rtn_1, completion);
    i.stn_1 = $this$async;
    return i;
  };
  function DraftQuerySource$load$slambda$slambda_0(this$0, resultContinuation) {
    var i = new DraftQuerySource$load$slambda$slambda(this$0, resultContinuation);
    var l = function ($this$async, $completion) {
      return i.ttn($this$async, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function _get_accession__uiy019_0($this) {
    return 'QUERY' + $this.ytn_1.toString();
  }
  function DraftQuerySource$load$slambda(this$0, resultContinuation) {
    this.kto_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(DraftQuerySource$load$slambda).pto = function ($this$coroutineScope, $completion) {
    var tmp = this.f1h($this$coroutineScope, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(DraftQuerySource$load$slambda).v9 = function (p1, $completion) {
    return this.pto((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(DraftQuerySource$load$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 3;
            var tmp_0 = this;
            tmp_0.oto_1 = async(this.lto_1, VOID, VOID, DraftQuerySource$load$slambda$slambda_0(this.kto_1, null));
            this.f9_1 = 1;
            suspendResult = this.kto_1.utn_1.dtn(this.kto_1.xtn_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.mto_1 = suspendResult;
            this.nto_1 = get_asCoroutineDispatcher(this.kto_1.wtn_1);
            this.f9_1 = 2;
            suspendResult = this.oto_1.nr(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var ARGUMENT = suspendResult;
            var model = createQueryFrontendDomainModel(this.nto_1, ARGUMENT, this.mto_1, this.kto_1.utn_1.utm_1);
            var _destruct__k2r9zo = initializeRemoteDocument(this.kto_1.utn_1, this.mto_1, _get_accession__uiy019_0(this.kto_1), this.kto_1.ztn_1, model);
            var node = _destruct__k2r9zo.fg();
            var processor = _destruct__k2r9zo.gg();
            var provider = _destruct__k2r9zo.zl();
            var connection = _destruct__k2r9zo.b2d();
            return new EditableNodeInfo(this.kto_1, node, model, this.kto_1.bto_1, processor, provider, this.kto_1.wtn_1, connection.j2l(model));
          case 3:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 3) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(DraftQuerySource$load$slambda).f1h = function ($this$coroutineScope, completion) {
    var i = new DraftQuerySource$load$slambda(this.kto_1, completion);
    i.lto_1 = $this$coroutineScope;
    return i;
  };
  function DraftQuerySource$load$slambda_0(this$0, resultContinuation) {
    var i = new DraftQuerySource$load$slambda(this$0, resultContinuation);
    var l = function ($this$coroutineScope, $completion) {
      return i.pto($this$coroutineScope, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function DraftQuerySource(otEnvironment, editorServiceProvider, edt, entityId, queryId, name, globalVersion) {
    this.utn_1 = otEnvironment;
    this.vtn_1 = editorServiceProvider;
    this.wtn_1 = edt;
    this.xtn_1 = entityId;
    this.ytn_1 = queryId;
    this.ztn_1 = name;
    this.ato_1 = globalVersion;
    this.bto_1 = Companion_getInstance_422().qto_1;
  }
  protoOf(DraftQuerySource).v58 = function () {
    return new DocumentSourceDescriptor(_get_accession__uiy019_0(this), this.xtn_1.q36_1, VOID, this.ato_1);
  };
  protoOf(DraftQuerySource).bt8 = function ($completion) {
    return coroutineScope(DraftQuerySource$load$slambda_0(this, null), $completion);
  };
  function EditedDocumentSource$load$slambda$slambda(this$0, resultContinuation) {
    this.dtp_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(EditedDocumentSource$load$slambda$slambda).psl = function ($this$async, $completion) {
    var tmp = this.f1h($this$async, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(EditedDocumentSource$load$slambda$slambda).v9 = function (p1, $completion) {
    return this.psl((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(EditedDocumentSource$load$slambda$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.dtp_1.gtp_1.qsm(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(EditedDocumentSource$load$slambda$slambda).f1h = function ($this$async, completion) {
    var i = new EditedDocumentSource$load$slambda$slambda(this.dtp_1, completion);
    i.etp_1 = $this$async;
    return i;
  };
  function EditedDocumentSource$load$slambda$slambda_0(this$0, resultContinuation) {
    var i = new EditedDocumentSource$load$slambda$slambda(this$0, resultContinuation);
    var l = function ($this$async, $completion) {
      return i.psl($this$async, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function EditedDocumentSource$load$slambda$slambda_1($editorServiceClient, this$0, resultContinuation) {
    this.stp_1 = $editorServiceClient;
    this.ttp_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(EditedDocumentSource$load$slambda$slambda_1).ttn = function ($this$async, $completion) {
    var tmp = this.f1h($this$async, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(EditedDocumentSource$load$slambda$slambda_1).v9 = function (p1, $completion) {
    return this.ttn((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(EditedDocumentSource$load$slambda$slambda_1).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 3;
            this.f9_1 = 1;
            suspendResult = this.stp_1.nr(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            this.f9_1 = 2;
            suspendResult = ARGUMENT.qsk(this.ttp_1.itp_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return suspendResult;
          case 3:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 3) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(EditedDocumentSource$load$slambda$slambda_1).f1h = function ($this$async, completion) {
    var i = new EditedDocumentSource$load$slambda$slambda_1(this.stp_1, this.ttp_1, completion);
    i.utp_1 = $this$async;
    return i;
  };
  function EditedDocumentSource$load$slambda$slambda_2($editorServiceClient, this$0, resultContinuation) {
    var i = new EditedDocumentSource$load$slambda$slambda_1($editorServiceClient, this$0, resultContinuation);
    var l = function ($this$async, $completion) {
      return i.ttn($this$async, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function DocPersistence$deserialize$ref(p0) {
    return function (receiver) {
      return p0.nqw(receiver);
    };
  }
  function launchPropertiesSync($this, _this__u8e3s4, documentNode, model, editorServiceClient) {
    if (!isInterface(documentNode, ProcessLibrary_1)) {
      var tmp = EditedDocumentSource$launchPropertiesSync$lambda;
      return new sam$jetbrains_ocelot_base_disposable_Disposable$0_11(tmp);
    }
    var flowJob = launch(_this__u8e3s4, model.cdf_1, VOID, EditedDocumentSource$launchPropertiesSync$slambda_0(editorServiceClient, $this, documentNode, model, null));
    var tmp_0 = EditedDocumentSource$launchPropertiesSync$lambda_0(flowJob);
    return new sam$jetbrains_ocelot_base_disposable_Disposable$0_11(tmp_0);
  }
  function Companion_421() {
    Companion_instance_421 = this;
    this.vtp_1 = getLogger_0(getKClass(EditedDocumentSource));
  }
  var Companion_instance_421;
  function Companion_getInstance_421() {
    if (Companion_instance_421 == null)
      new Companion_421();
    return Companion_instance_421;
  }
  function sam$jetbrains_ocelot_base_disposable_Disposable$0_11(function_0) {
    this.wtp_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0_11).zr = function () {
    return this.wtp_1();
  };
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0_11).f3 = function () {
    return this.wtp_1;
  };
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0_11).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Disposable) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0_11).hashCode = function () {
    return hashCode(this.f3());
  };
  function EditedDocumentSource$load$slambda(this$0, resultContinuation) {
    this.ftq_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(EditedDocumentSource$load$slambda).ntq = function ($this$coroutineScope, $completion) {
    var tmp = this.f1h($this$coroutineScope, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(EditedDocumentSource$load$slambda).v9 = function (p1, $completion) {
    return this.ntq((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(EditedDocumentSource$load$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 4;
            var tmp_0 = this;
            tmp_0.jtq_1 = async(this.gtq_1, VOID, VOID, EditedDocumentSource$load$slambda$slambda_0(this.ftq_1, null));
            var tmp_1 = this;
            tmp_1.mtq_1 = async(this.gtq_1, VOID, VOID, EditedDocumentSource$load$slambda$slambda_2(this.jtq_1, this.ftq_1, null));
            this.f9_1 = 1;
            suspendResult = this.ftq_1.ftp_1.ktj(this.ftq_1.itp_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.ltq_1 = suspendResult;
            this.ktq_1 = get_btbEntityNodeLayout().r6z();
            this.f9_1 = 2;
            suspendResult = this.mtq_1.nr(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var remoteDocumentClient = suspendResult;
            this.itq_1 = createFrontendDomainModel(get_asCoroutineDispatcher(this.ftq_1.htp_1), remoteDocumentClient, this.ktq_1);
            var node = get_docPersistence(this.itq_1).nqw(this.ltq_1).h3o();
            this.htq_1 = initializeLocalDocument(this.ktq_1, node, this.ftq_1.itp_1, this.ftq_1.jtp_1, this.itq_1);
            this.f9_1 = 3;
            suspendResult = this.jtq_1.nr(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            var ARGUMENT = suspendResult;
            var inheritedPropertiesDisposable = launchPropertiesSync(this.ftq_1, this.gtq_1, this.htq_1, this.itq_1, ARGUMENT);
            var tmp_2 = Companion_getInstance_422().rto_1;
            var tmp_3 = this.itq_1.j2l(inheritedPropertiesDisposable);
            var tmp_4 = this.htq_1;
            return new ExplorableNodeInfo(this.ftq_1, this.htq_1, this.itq_1, tmp_2, this.ftq_1.htp_1, tmp_3, !isInterface(tmp_4, ProcessLibrary_1));
          case 4:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 4) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(EditedDocumentSource$load$slambda).f1h = function ($this$coroutineScope, completion) {
    var i = new EditedDocumentSource$load$slambda(this.ftq_1, completion);
    i.gtq_1 = $this$coroutineScope;
    return i;
  };
  function EditedDocumentSource$load$slambda_0(this$0, resultContinuation) {
    var i = new EditedDocumentSource$load$slambda(this$0, resultContinuation);
    var l = function ($this$coroutineScope, $completion) {
      return i.ntq($this$coroutineScope, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function EditedDocumentSource$launchPropertiesSync$lambda() {
    return Unit_instance;
  }
  function EditedDocumentSource$launchPropertiesSync$slambda($editorServiceClient, this$0, $documentNode, $model, resultContinuation) {
    this.wtq_1 = $editorServiceClient;
    this.xtq_1 = this$0;
    this.ytq_1 = $documentNode;
    this.ztq_1 = $model;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(EditedDocumentSource$launchPropertiesSync$slambda).e1h = function ($this$launch, $completion) {
    var tmp = this.f1h($this$launch, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(EditedDocumentSource$launchPropertiesSync$slambda).v9 = function (p1, $completion) {
    return this.e1h((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(EditedDocumentSource$launchPropertiesSync$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 3;
            this.g9_1 = 2;
            this.f9_1 = 1;
            var tmp_0 = InheritedPropertiesCalculator_getInstance();
            var tmp_1 = this.wtq_1.vsg(this.xtq_1.itp_1);
            suspendResult = tmp_0.spd(tmp_1, this.ytq_1, this.ztq_1, DocPersistence$deserialize$ref(get_docPersistence(this.ztq_1)), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.g9_1 = 3;
            this.f9_1 = 4;
            continue $sm;
          case 2:
            this.g9_1 = 3;
            var tmp_2 = this.i9_1;
            if (tmp_2 instanceof Exception) {
              var e = this.i9_1;
              Companion_getInstance_421().vtp_1.ude('Error syncing inherited properties for document ' + this.ytq_1.z3n().toString(), e);
              this.f9_1 = 4;
              continue $sm;
            } else {
              throw this.i9_1;
            }

          case 3:
            throw this.i9_1;
          case 4:
            this.g9_1 = 3;
            return Unit_instance;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.g9_1 === 3) {
          throw e_0;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(EditedDocumentSource$launchPropertiesSync$slambda).f1h = function ($this$launch, completion) {
    var i = new EditedDocumentSource$launchPropertiesSync$slambda(this.wtq_1, this.xtq_1, this.ytq_1, this.ztq_1, completion);
    i.atr_1 = $this$launch;
    return i;
  };
  function EditedDocumentSource$launchPropertiesSync$slambda_0($editorServiceClient, this$0, $documentNode, $model, resultContinuation) {
    var i = new EditedDocumentSource$launchPropertiesSync$slambda($editorServiceClient, this$0, $documentNode, $model, resultContinuation);
    var l = function ($this$launch, $completion) {
      return i.e1h($this$launch, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function EditedDocumentSource$launchPropertiesSync$lambda_0($flowJob) {
    return function () {
      $flowJob.sp();
      return Unit_instance;
    };
  }
  function EditedDocumentSource(editorDocumentsApi, editorServiceProvider, edt, accession, name) {
    Companion_getInstance_421();
    this.ftp_1 = editorDocumentsApi;
    this.gtp_1 = editorServiceProvider;
    this.htp_1 = edt;
    this.itp_1 = accession;
    this.jtp_1 = name;
  }
  protoOf(EditedDocumentSource).v58 = function () {
    return new DocumentSourceDescriptor(this.itp_1);
  };
  protoOf(EditedDocumentSource).bt8 = function ($completion) {
    return coroutineScope(EditedDocumentSource$load$slambda_0(this, null), $completion);
  };
  function $loadSerializedResolvedNodeCOROUTINE$(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.jtr_1 = _this__u8e3s4;
  }
  protoOf($loadSerializedResolvedNodeCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.ktr_1 = new SerializedNode(this.jtr_1.qtr_1, NodePointerConstructor(this.jtr_1.rtr_1, this.jtr_1.ptr_1));
            this.f9_1 = 1;
            suspendResult = this.jtr_1.otr_1.jtk(this.jtr_1.rtr_1, new NodeId(this.jtr_1.ptr_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            return new SerializedResolvedNode(this.ktr_1, ARGUMENT);
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function EditedOntologyBrowserSource(editorsApi, accession, nodeId, content) {
    PrecalculatedResolversDocumentSource.call(this, accession);
    this.otr_1 = editorsApi;
    this.ptr_1 = nodeId;
    this.qtr_1 = content;
  }
  protoOf(EditedOntologyBrowserSource).v58 = function () {
    return new DocumentSourceDescriptor(this.rtr_1, VOID, VOID, VOID, this.ptr_1);
  };
  protoOf(EditedOntologyBrowserSource).utr = function ($completion) {
    var tmp = new $loadSerializedResolvedNodeCOROUTINE$(this, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(EditedOntologyBrowserSource).vtr = function () {
    return false;
  };
  function EditedWorkingCopySource$load$slambda$slambda(this$0, resultContinuation) {
    this.fts_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(EditedWorkingCopySource$load$slambda$slambda).ttn = function ($this$async, $completion) {
    var tmp = this.f1h($this$async, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(EditedWorkingCopySource$load$slambda$slambda).v9 = function (p1, $completion) {
    return this.ttn((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(EditedWorkingCopySource$load$slambda$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 3;
            this.f9_1 = 1;
            suspendResult = this.fts_1.qtf_1.qsm(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            this.f9_1 = 2;
            suspendResult = ARGUMENT.qsk(this.fts_1.utf_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return suspendResult;
          case 3:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 3) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(EditedWorkingCopySource$load$slambda$slambda).f1h = function ($this$async, completion) {
    var i = new EditedWorkingCopySource$load$slambda$slambda(this.fts_1, completion);
    i.gts_1 = $this$async;
    return i;
  };
  function EditedWorkingCopySource$load$slambda$slambda_0(this$0, resultContinuation) {
    var i = new EditedWorkingCopySource$load$slambda$slambda(this$0, resultContinuation);
    var l = function ($this$async, $completion) {
      return i.ttn($this$async, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function EditedWorkingCopySource$load$slambda(this$0, resultContinuation) {
    this.pts_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(EditedWorkingCopySource$load$slambda).pto = function ($this$coroutineScope, $completion) {
    var tmp = this.f1h($this$coroutineScope, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(EditedWorkingCopySource$load$slambda).v9 = function (p1, $completion) {
    return this.pto((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(EditedWorkingCopySource$load$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 3;
            var tmp_0 = this;
            tmp_0.tts_1 = async(this.qts_1, VOID, VOID, EditedWorkingCopySource$load$slambda$slambda_0(this.pts_1, null));
            this.f9_1 = 1;
            suspendResult = this.pts_1.ptf_1.dtn(this.pts_1.ttf_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.rts_1 = suspendResult;
            this.sts_1 = get_asCoroutineDispatcher(this.pts_1.stf_1);
            this.f9_1 = 2;
            suspendResult = this.tts_1.nr(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var ARGUMENT = suspendResult;
            var model = createFrontendDomainModel(this.sts_1, ARGUMENT, this.rts_1, this.pts_1.ptf_1.utm_1);
            var _destruct__k2r9zo = initializeRemoteDocument(this.pts_1.ptf_1, this.rts_1, this.pts_1.utf_1, this.pts_1.vtf_1, model);
            var node = _destruct__k2r9zo.fg();
            var processor = _destruct__k2r9zo.gg();
            var provider = _destruct__k2r9zo.zl();
            var connection = _destruct__k2r9zo.b2d();
            return new EditableNodeInfo(this.pts_1, node, model, this.pts_1.wtf_1, processor, provider, this.pts_1.stf_1, connection.j2l(model));
          case 3:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 3) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(EditedWorkingCopySource$load$slambda).f1h = function ($this$coroutineScope, completion) {
    var i = new EditedWorkingCopySource$load$slambda(this.pts_1, completion);
    i.qts_1 = $this$coroutineScope;
    return i;
  };
  function EditedWorkingCopySource$load$slambda_0(this$0, resultContinuation) {
    var i = new EditedWorkingCopySource$load$slambda(this$0, resultContinuation);
    var l = function ($this$coroutineScope, $completion) {
      return i.pto($this$coroutineScope, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function EditedWorkingCopySource(otEnvironment, editorServiceProvider, editorDocumentsApi, edt, entityId, accession, name, readonly) {
    this.ptf_1 = otEnvironment;
    this.qtf_1 = editorServiceProvider;
    this.rtf_1 = editorDocumentsApi;
    this.stf_1 = edt;
    this.ttf_1 = entityId;
    this.utf_1 = accession;
    this.vtf_1 = name;
    this.wtf_1 = readonly ? Companion_getInstance_422().rto_1 : Companion_getInstance_422().qto_1;
  }
  protoOf(EditedWorkingCopySource).v58 = function () {
    return new DocumentSourceDescriptor(this.utf_1, this.ttf_1.q36_1);
  };
  protoOf(EditedWorkingCopySource).bt8 = function ($completion) {
    return coroutineScope(EditedWorkingCopySource$load$slambda_0(this, null), $completion);
  };
  function ExploredDocumentSource(explorerApi, accession, globalVersion) {
    PrecalculatedResolversDocumentSource.call(this, accession);
    this.xts_1 = explorerApi;
    this.yts_1 = globalVersion;
    this.zts_1 = Companion_getInstance_422().sto_1;
  }
  protoOf(ExploredDocumentSource).v58 = function () {
    return new DocumentSourceDescriptor(this.rtr_1, VOID, VOID, this.yts_1);
  };
  protoOf(ExploredDocumentSource).wtr = function () {
    return this.zts_1;
  };
  protoOf(ExploredDocumentSource).utr = function ($completion) {
    return this.xts_1.mtl(this.rtr_1, this.yts_1, VOID, $completion);
  };
  function $loadSerializedResolvedNodeCOROUTINE$_0(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.itt_1 = _this__u8e3s4;
  }
  protoOf($loadSerializedResolvedNodeCOROUTINE$_0).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.jtt_1 = new SerializedNode(this.itt_1.ptt_1, NodePointerConstructor(this.itt_1.qtt_1.toString(), this.itt_1.ott_1));
            this.f9_1 = 1;
            suspendResult = this.itt_1.ntt_1.ltl(this.itt_1.rtr_1, this.itt_1.qtt_1, this.itt_1.ott_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult.resolveInfo;
            return new SerializedResolvedNode(this.jtt_1, ARGUMENT);
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function ExploredOntologyBrowserSource(explorerApi, accession, nodeId, content, globalVersion) {
    PrecalculatedResolversDocumentSource.call(this, accession);
    this.ntt_1 = explorerApi;
    this.ott_1 = nodeId;
    this.ptt_1 = content;
    this.qtt_1 = globalVersion;
  }
  protoOf(ExploredOntologyBrowserSource).v58 = function () {
    return new DocumentSourceDescriptor(this.rtr_1, VOID, VOID, this.qtt_1, this.ott_1);
  };
  protoOf(ExploredOntologyBrowserSource).utr = function ($completion) {
    var tmp = new $loadSerializedResolvedNodeCOROUTINE$_0(this, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(ExploredOntologyBrowserSource).vtr = function () {
    return false;
  };
  function HistoryPanelDocumentSource(explorerApi, accession, revision) {
    PrecalculatedResolversDocumentSource.call(this, accession);
    this.utt_1 = explorerApi;
    this.vtt_1 = revision;
    this.wtt_1 = Companion_getInstance_422().sto_1;
  }
  protoOf(HistoryPanelDocumentSource).v58 = function () {
    return new DocumentSourceDescriptor(this.rtr_1, VOID, this.vtt_1);
  };
  protoOf(HistoryPanelDocumentSource).utr = function ($completion) {
    return this.utt_1.otl(this.rtr_1, this.vtt_1, VOID, $completion);
  };
  protoOf(HistoryPanelDocumentSource).wtr = function () {
    return this.wtt_1;
  };
  function PathEntrySource(accession, serializedResolvedNode) {
    PrecalculatedResolversDocumentSource.call(this, accession);
    this.atu_1 = serializedResolvedNode;
  }
  protoOf(PathEntrySource).v58 = function () {
    return new DocumentSourceDescriptor(this.rtr_1, VOID, VOID, VOID, this.atu_1.node.pointer.nodeId.q36_1);
  };
  protoOf(PathEntrySource).utr = function ($completion) {
    return this.atu_1;
  };
  function $loadCOROUTINE$(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.jtu_1 = _this__u8e3s4;
  }
  protoOf($loadCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.jtu_1.utr(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var _destruct__k2r9zo = suspendResult;
            var serializedNode = _destruct__k2r9zo.fg();
            var resolveInfo = _destruct__k2r9zo.gg();
            var entity = get_btbEntityNodeLayout().r6z();
            var model = createDomainModelWithPrecalculatedResolve(get_asCoroutineDispatcher(this.jtu_1.str_1), resolveInfo, entity);
            var tmp_0;
            if (this.jtu_1.vtr()) {
              var btbOtNodePersister = new BtbOtNodePersister(model.hdf_1);
              tmp_0 = btbOtNodePersister.p25(serializedNode.content).zlk_1;
            } else {
              var docPersistence = get_docPersistence(model);
              tmp_0 = docPersistence.nqw(serializedNode.content).h3o();
            }

            var node = tmp_0;
            var btbNode = initializeDetachedNode(entity, node, this.jtu_1.rtr_1, model);
            ensureNotNull(model.ddf_1.h3b(Companion_instance_309)).jfn();
            return new ExplorableNodeInfo(this.jtu_1, btbNode, model, this.jtu_1.wtr(), this.jtu_1.str_1, model);
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function PrecalculatedResolversDocumentSource(accession, edt) {
    edt = edt === VOID ? get_platformEdt() : edt;
    this.rtr_1 = accession;
    this.str_1 = edt;
    this.ttr_1 = Companion_getInstance_422().tto_1;
  }
  protoOf(PrecalculatedResolversDocumentSource).wtr = function () {
    return this.ttr_1;
  };
  protoOf(PrecalculatedResolversDocumentSource).bt8 = function ($completion) {
    var tmp = new $loadCOROUTINE$(this, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(PrecalculatedResolversDocumentSource).vtr = function () {
    return true;
  };
  function PublishedQuerySource(queriesApi, queryId) {
    PrecalculatedResolversDocumentSource.call(this, 'QUERY' + queryId.toString());
    this.ntu_1 = queriesApi;
    this.otu_1 = queryId;
  }
  protoOf(PublishedQuerySource).v58 = function () {
    return new DocumentSourceDescriptor(this.rtr_1);
  };
  protoOf(PublishedQuerySource).utr = function ($completion) {
    return this.ntu_1.btm(this.otu_1, $completion);
  };
  function UsageEntrySource(accession, usageDto, edt) {
    edt = edt === VOID ? get_platformEdt() : edt;
    this.ptu_1 = accession;
    this.qtu_1 = usageDto;
    this.rtu_1 = edt;
  }
  protoOf(UsageEntrySource).v58 = function () {
    return new DocumentSourceDescriptor(this.ptu_1, VOID, VOID, VOID, this.qtu_1.node.node.pointer.nodeId.q36_1);
  };
  protoOf(UsageEntrySource).bt8 = function ($completion) {
    var entity = get_btbEntityNodeLayout().r6z();
    var model = createDomainModelWithPrecalculatedResolve(get_asCoroutineDispatcher(this.rtu_1), this.qtu_1.node.resolveInfo, entity);
    var findUsagesConfig = ensureNotNull(model.ddf_1.h3b(FindUsagesConfigService_instance));
    var usage = get_btbUsageDeserializer(model).stu(this.qtu_1);
    var usagePresentationData = findUsagesConfig.n85(usage);
    var otNode = toOtNode(usage.p85_1);
    initializeDetachedNode(entity, otNode, this.ptu_1, model);
    ensureNotNull(model.ddf_1.h3b(Companion_instance_309)).jfn();
    return new ExplorableNodeInfo(this, usagePresentationData, model, Companion_getInstance_422().uto_1, this.rtu_1, model);
  };
  function get_btbUsageDeserializer(_this__u8e3s4) {
    return new BTBUsageDeserializerImpl(ensureNotNull(_this__u8e3s4.ddf_1.h3b(WrapperContextService_instance)), ensureNotNull(_this__u8e3s4.ddf_1.h3b(FindUsagesConfigService_instance)), _this__u8e3s4.hdf_1);
  }
  function createUsage($this, usageKind, node, refSourceNode, link) {
    var tmp = usageKind instanceof UsageKind ? usageKind : THROW_CCE();
    return new Usage(tmp, node, new ReferenceContext(refSourceNode, link instanceof ReferenceLink ? link : THROW_CCE()));
  }
  function findDescendantById($this, _this__u8e3s4, nodeId) {
    // Inline function 'kotlin.sequences.find' call
    var tmp0 = toOtNode(_this__u8e3s4).s3p(true);
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.sequences.firstOrNull' call
      var _iterator__ex2g4s = tmp0.m();
      while (_iterator__ex2g4s.n()) {
        var element = _iterator__ex2g4s.o();
        if (element.z3n().equals(nodeId)) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    var tmp0_safe_receiver = tmp$ret$1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : toDomainNode(tmp0_safe_receiver, get_wrapperContextOrNull(_this__u8e3s4));
    var tmp;
    if (tmp1_elvis_lhs == null) {
      throw IllegalStateException_init_$Create$_0('Descendant node with id ' + nodeId.toString() + ' not found inside node ' + toString_1(_this__u8e3s4));
    } else {
      tmp = tmp1_elvis_lhs;
    }
    return tmp;
  }
  function BTBUsageDeserializerImpl(wrapperContext, usagesConfig, nodeFactory) {
    this.ttu_1 = wrapperContext;
    this.utu_1 = usagesConfig;
    this.vtu_1 = nodeFactory;
  }
  protoOf(BTBUsageDeserializerImpl).stu = function (usageDto) {
    var node = (new BTBNodePersister(this.ttu_1, this.vtu_1)).o25(usageDto.node.node.content);
    var tmp = this.utu_1.m85(usageDto.kind);
    var usageKind = tmp instanceof UsageKind ? tmp : THROW_CCE();
    var referenceSourceNode = findDescendantById(this, node, new NodeId(usageDto.referenceSourceNodeId));
    var tmp_0;
    // Inline function 'kotlin.text.isNotEmpty' call
    var this_0 = usageDto.propertyId;
    if (charSequenceLength(this_0) > 0) {
      tmp_0 = NodePropertyIdFactory_getInstance().b3r(usageDto.propertyId);
    } else {
      tmp_0 = first(ReferenceAspects_getInstance().vmb(referenceSourceNode.f3t()));
    }
    var propertyId = tmp_0;
    var referenceLink = getReferenceLink(otConceptRegistry(this.ttu_1).t6i(referenceSourceNode.f3t()), propertyId);
    $l$block: {
      // Inline function 'kotlin.checkNotNull' call
      if (referenceLink == null) {
        var message = 'BTBUsageDeserializer could not get deserialize reference link by concept id ' + ('and property id (' + referenceSourceNode.f3t().toString() + ', ' + propertyId.toString() + ')');
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      } else {
        break $l$block;
      }
    }
    return createUsage(this, usageKind, node, isInterface(referenceSourceNode, BTBNode) ? referenceSourceNode : THROW_CCE(), referenceLink);
  };
  function BTBEditor() {
    BTBEditor_instance = this;
    EditorScope.call(this);
    btbProgramBuilders(this);
    extensionLibraryBuilders(this);
    factBuilders(this);
    functionLibraryBuilders(this);
    linkLibraryBuilders(this);
    notionLibraryBuilders(this);
    ontologyLibraryBuilders(this);
    processLibraryBuilders(this);
    queryCommandBuilders(this);
    relationLibraryBuilders(this);
    notionTypeBuilders(this);
    ontologyImportRootBuilders(this);
  }
  protoOf(BTBEditor).xtu = function (configuration) {
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.builder' call
    var sourceType = getKClass(DomainNode);
    var tmp$ret$0 = this.xcr(sourceType);
    return buildFactory(tmp$ret$0, configuration);
  };
  protoOf(BTBEditor).ytu = function (_this__u8e3s4) {
    return get_highlighted(_this__u8e3s4);
  };
  protoOf(BTBEditor).ycr = function (_this__u8e3s4) {
    return this.ytu(_this__u8e3s4);
  };
  var BTBEditor_instance;
  function BTBEditor_getInstance() {
    if (BTBEditor_instance == null)
      new BTBEditor();
    return BTBEditor_instance;
  }
  function btbProgramBuilders(_this__u8e3s4) {
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder = new LazyMapperBuilder(btbProgramBuilders$lambda(_this__u8e3s4, _this__u8e3s4));
    _this__u8e3s4.vcr(builder);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_0 = new LazyMapperBuilder(btbProgramBuilders$lambda_0(_this__u8e3s4, _this__u8e3s4));
    _this__u8e3s4.vcr(builder_0);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_1 = new LazyMapperBuilder(btbProgramBuilders$lambda_1(_this__u8e3s4, _this__u8e3s4));
    _this__u8e3s4.vcr(builder_1);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_2 = new LazyMapperBuilder(btbProgramBuilders$lambda_2(_this__u8e3s4));
    _this__u8e3s4.vcr(builder_2);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_3 = new LazyMapperBuilder(btbProgramBuilders$lambda_3(_this__u8e3s4));
    _this__u8e3s4.vcr(builder_3);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_4 = new LazyMapperBuilder(btbProgramBuilders$lambda_4(_this__u8e3s4));
    _this__u8e3s4.vcr(builder_4);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_5 = new LazyMapperBuilder(btbProgramBuilders$lambda_5(_this__u8e3s4));
    _this__u8e3s4.vcr(builder_5);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_6 = new LazyMapperBuilder(btbProgramBuilders$lambda_6(_this__u8e3s4));
    _this__u8e3s4.vcr(builder_6);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_7 = new LazyMapperBuilder(btbProgramBuilders$lambda_7(_this__u8e3s4));
    _this__u8e3s4.vcr(builder_7);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_8 = new LazyMapperBuilder(btbProgramBuilders$lambda_8(_this__u8e3s4, _this__u8e3s4));
    _this__u8e3s4.vcr(builder_8);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_9 = new LazyMapperBuilder(btbProgramBuilders$lambda_9(_this__u8e3s4));
    _this__u8e3s4.vcr(builder_9);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_10 = new LazyMapperBuilder(btbProgramBuilders$lambda_10(_this__u8e3s4));
    _this__u8e3s4.vcr(builder_10);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_11 = new LazyMapperBuilder(btbProgramBuilders$lambda_11(_this__u8e3s4));
    _this__u8e3s4.vcr(builder_11);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_12 = new LazyMapperBuilder(btbProgramBuilders$lambda_12(_this__u8e3s4, _this__u8e3s4));
    _this__u8e3s4.vcr(builder_12);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_13 = new LazyMapperBuilder(btbProgramBuilders$lambda_13(_this__u8e3s4, _this__u8e3s4));
    _this__u8e3s4.vcr(builder_13);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_14 = new LazyMapperBuilder(btbProgramBuilders$lambda_14(_this__u8e3s4, _this__u8e3s4));
    _this__u8e3s4.vcr(builder_14);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_15 = new LazyMapperBuilder(btbProgramBuilders$lambda_15(_this__u8e3s4, _this__u8e3s4));
    _this__u8e3s4.vcr(builder_15);
  }
  function get_category(_this__u8e3s4) {
    // Inline function 'jetbrains.biokb.lang.builders.nodeRole' call
    // Inline function 'jetbrains.ocelot.langDef.editor.role' call
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.builder' call
    var sourceType = getKClass(Category_1);
    var tmp$ret$0 = _this__u8e3s4.xcr(sourceType);
    var builder = new ChildBuilder(tmp$ret$0);
    builder.hd0(_get_category_$lambda_8otj26);
    builder.id0(', ');
    var simpleClassName = ensureNotNull(getKClass(Category_1).ra());
    builder.kd0(simpleClassName, _get_category_$lambda_8otj26_0);
    return builder;
  }
  function get_imports(_this__u8e3s4) {
    // Inline function 'jetbrains.biokb.lang.builders.nodeRole' call
    // Inline function 'jetbrains.ocelot.langDef.editor.role' call
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.builder' call
    var sourceType = getKClass(OntologyImportRootReference_1);
    var tmp$ret$0 = _this__u8e3s4.xcr(sourceType);
    var builder = new ChildBuilder(tmp$ret$0);
    builder.gd0('<imports>');
    builder.hd0(_get_imports_$lambda_vd27mw);
    builder.jd0();
    var simpleClassName = ensureNotNull(getKClass(OntologyImportRootReference_1).ra());
    builder.kd0(simpleClassName, _get_imports_$lambda_vd27mw_0);
    return builder;
  }
  function get_factSetRole(_this__u8e3s4) {
    // Inline function 'jetbrains.biokb.lang.builders.nodeRole' call
    // Inline function 'jetbrains.ocelot.langDef.editor.role' call
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.builder' call
    var sourceType = getKClass(FactSet_1);
    var tmp$ret$0 = _this__u8e3s4.xcr(sourceType);
    var builder = new ChildBuilder(tmp$ret$0);
    builder.hd0(_get_factSetRole_$lambda_yaiexy);
    builder.jd0();
    var simpleClassName = ensureNotNull(getKClass(FactSet_1).ra());
    builder.kd0(simpleClassName, _get_factSetRole_$lambda_yaiexy_0);
    return builder;
  }
  function get_ontologyLibraryReferenceRole(_this__u8e3s4) {
    // Inline function 'jetbrains.biokb.lang.builders.nodeRole' call
    // Inline function 'jetbrains.ocelot.langDef.editor.role' call
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.builder' call
    var sourceType = getKClass(OntologyLibraryReference_1);
    var tmp$ret$0 = _this__u8e3s4.xcr(sourceType);
    var builder = new ChildBuilder(tmp$ret$0);
    builder.hd0(_get_ontologyLibraryReferenceRole_$lambda_x2j4ob);
    var simpleClassName = ensureNotNull(getKClass(OntologyLibraryReference_1).ra());
    builder.kd0(simpleClassName, _get_ontologyLibraryReferenceRole_$lambda_x2j4ob_0);
    return builder;
  }
  function get_ontologyElementReferenceRole(_this__u8e3s4) {
    // Inline function 'jetbrains.biokb.lang.builders.nodeRole' call
    // Inline function 'jetbrains.ocelot.langDef.editor.role' call
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.builder' call
    var sourceType = getKClass(OntologyElementReference_1);
    var tmp$ret$0 = _this__u8e3s4.xcr(sourceType);
    var builder = new ChildBuilder(tmp$ret$0);
    builder.hd0(_get_ontologyElementReferenceRole_$lambda_f29iic);
    builder.fd0(_get_ontologyElementReferenceRole_$lambda_f29iic_0);
    var simpleClassName = ensureNotNull(getKClass(OntologyElementReference_1).ra());
    builder.kd0(simpleClassName, _get_ontologyElementReferenceRole_$lambda_f29iic_1);
    return builder;
  }
  function get_contextRole(_this__u8e3s4) {
    // Inline function 'jetbrains.biokb.lang.builders.nodeRole' call
    // Inline function 'jetbrains.ocelot.langDef.editor.role' call
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.builder' call
    var sourceType = getKClass(Context_2);
    var tmp$ret$0 = _this__u8e3s4.xcr(sourceType);
    var builder = new ChildBuilder(tmp$ret$0);
    builder.gd0('<context>');
    builder.hd0(_get_contextRole_$lambda_qaiv3z);
    var simpleClassName = ensureNotNull(getKClass(Context_2).ra());
    builder.kd0(simpleClassName, _get_contextRole_$lambda_qaiv3z_0);
    return builder;
  }
  function get_variableDeclarationRole(_this__u8e3s4) {
    // Inline function 'jetbrains.biokb.lang.builders.nodeRole' call
    // Inline function 'jetbrains.ocelot.langDef.editor.role' call
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.builder' call
    var sourceType = getKClass(VariableDeclaration_1);
    var tmp$ret$0 = _this__u8e3s4.xcr(sourceType);
    var builder = new ChildBuilder(tmp$ret$0);
    builder.hd0(_get_variableDeclarationRole_$lambda_d4qi0e);
    var simpleClassName = ensureNotNull(getKClass(VariableDeclaration_1).ra());
    builder.kd0(simpleClassName, _get_variableDeclarationRole_$lambda_d4qi0e_0);
    return builder;
  }
  function get_factRole(_this__u8e3s4) {
    // Inline function 'jetbrains.biokb.lang.builders.nodeRole' call
    // Inline function 'jetbrains.ocelot.langDef.editor.role' call
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.builder' call
    var sourceType = getKClass(Fact_1);
    var tmp$ret$0 = _this__u8e3s4.xcr(sourceType);
    var builder = new ChildBuilder(tmp$ret$0);
    builder.gd0('<facts>');
    builder.hd0(_get_factRole_$lambda_e22khq);
    builder.jd0();
    var simpleClassName = ensureNotNull(getKClass(Fact_1).ra());
    builder.kd0(simpleClassName, _get_factRole_$lambda_e22khq_0);
    return builder;
  }
  function btbProgramBuilders$lambda$lambda$lambda(it) {
    return it.yfp();
  }
  function btbProgramBuilders$lambda$lambda$lambda_0(it) {
    return it.zfp();
  }
  function btbProgramBuilders$lambda$lambda$lambda_1(it) {
    return it.xfp();
  }
  function btbProgramBuilders$lambda$lambda($this_btbProgramBuilders) {
    return function ($this$rootIndent) {
      keyword($this$rootIndent, 'categories:');
      space($this$rootIndent);
      var tmp = get_category($this_btbProgramBuilders);
      children_1($this$rootIndent, tmp, btbProgramBuilders$lambda$lambda$lambda);
      newLine($this$rootIndent);
      space($this$rootIndent);
      newLine($this$rootIndent);
      var tmp_0 = get_imports($this_btbProgramBuilders);
      children_1($this$rootIndent, tmp_0, btbProgramBuilders$lambda$lambda$lambda_0);
      newLine($this$rootIndent);
      space($this$rootIndent);
      newLine($this$rootIndent);
      var tmp_1 = get_factSetRole($this_btbProgramBuilders);
      children_1($this$rootIndent, tmp_1, btbProgramBuilders$lambda$lambda$lambda_1);
      return Unit_instance;
    };
  }
  function btbProgramBuilders$lambda($this, $this_btbProgramBuilders) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(BTBDocument_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      rootIndent(result, btbProgramBuilders$lambda$lambda($this_btbProgramBuilders));
      return this_0;
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda_2(it) {
    return it.y2();
  }
  function btbProgramBuilders$lambda$lambda$lambda_3(it) {
    return it.ffq();
  }
  function btbProgramBuilders$lambda$lambda$lambda_4(it) {
    return it.gfq();
  }
  function btbProgramBuilders$lambda$lambda_0($this_btbProgramBuilders) {
    return function ($this$rootIndent) {
      textProperty($this$rootIndent, '<name>', btbProgramBuilders$lambda$lambda$lambda_2);
      indentLabel($this$rootIndent, ':');
      var tmp = get_ontologyLibraryReferenceRole($this_btbProgramBuilders);
      child_0($this$rootIndent, tmp, btbProgramBuilders$lambda$lambda$lambda_3);
      indentLabel($this$rootIndent, '/');
      var tmp_0 = get_ontologyElementReferenceRole($this_btbProgramBuilders);
      child_0($this$rootIndent, tmp_0, btbProgramBuilders$lambda$lambda$lambda_4);
      return Unit_instance;
    };
  }
  function btbProgramBuilders$lambda_0($this, $this_btbProgramBuilders) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(Context_2));
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      rootIndent(result, btbProgramBuilders$lambda$lambda_0($this_btbProgramBuilders));
      return this_0;
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda_5(it) {
    return it.ffq();
  }
  function btbProgramBuilders$lambda$lambda$lambda_6(it) {
    return it.gfq();
  }
  function btbProgramBuilders$lambda$lambda_1($this_btbProgramBuilders) {
    return function ($this$rootIndent) {
      var tmp = get_ontologyLibraryReferenceRole($this_btbProgramBuilders);
      child_0($this$rootIndent, tmp, btbProgramBuilders$lambda$lambda$lambda_5);
      indentLabel($this$rootIndent, '/');
      var tmp_0 = get_ontologyElementReferenceRole($this_btbProgramBuilders);
      child_0($this$rootIndent, tmp_0, btbProgramBuilders$lambda$lambda$lambda_6);
      return Unit_instance;
    };
  }
  function btbProgramBuilders$lambda_1($this, $this_btbProgramBuilders) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(Category_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      rootIndent(result, btbProgramBuilders$lambda$lambda_1($this_btbProgramBuilders));
      return this_0;
    };
  }
  function btbProgramBuilders$lambda$lambda_2($this$rootIndent) {
    keyword($this$rootIndent, 'import');
    space($this$rootIndent);
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget' call
    var referenceTag = Companion_getInstance_327().sh4_1;
    var refCompletion = btbProgramBuilders$lambda$lambda$lambda_7(referenceTag);
    var completionTrait = btbProgramBuilders$lambda$lambda$lambda_8(refCompletion);
    // Inline function 'kotlin.also' call
    var this_0 = new SimpleMapperBuilder($this$rootIndent.fcq(), getKClass(OntologyImportRoot_1));
    // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
    var result = new RootCellBuilderImpl(this_0);
    rootIndent(result, btbProgramBuilders$lambda$lambda$lambda_9(refCompletion));
    var mapperBuilder = this_0;
    var tmp0_cellFactory = new NamedCellFactory('referenceData', btbProgramBuilders$lambda$lambda$lambda_10);
    var tmp = btbProgramBuilders$lambda$lambda$lambda_11;
    // Inline function 'kotlin.apply' call
    var this_1 = projectionalChild($this$rootIndent, tmp, tmp0_cellFactory, mapperBuilder, '<root>', btbProgramBuilders$lambda$lambda$lambda_12(completionTrait));
    this_1.xcp(btbProgramBuilders$lambda$lambda$lambda_13);
    this_1.ycp(btbProgramBuilders$lambda$lambda$lambda_14);
    this_1.ycp(btbProgramBuilders$lambda$lambda$lambda_15);
    return Unit_instance;
  }
  function btbProgramBuilders$lambda$lambda$lambda_7($referenceTag) {
    return function (_this__u8e3s4, src, cell, cellAction) {
      var tmp = _this__u8e3s4.d6u($referenceTag);
      var tmp$ret$0 = src.yfq();
      return completion(_this__u8e3s4, tmp, src, tmp$ret$0, cell, VOID, cellAction);
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda$o$get$lambda($cell) {
    return function (it) {
      return signalCompletionHappened($cell, false, it);
    };
  }
  function _no_name_provided__qut3iv_5($refCompletion, $this, $source) {
    this.ztu_1 = $refCompletion;
    this.atv_1 = $this;
    this.btv_1 = $source;
    CellTrait.call(this);
  }
  protoOf(_no_name_provided__qut3iv_5).n91 = function (cell, spec) {
    var tmp;
    if (equals(spec, Completion_getInstance().u9d_1)) {
      tmp = this.ztu_1(this.atv_1, this.btv_1, cell, btbProgramBuilders$lambda$lambda$lambda$o$get$lambda(cell));
    } else {
      tmp = protoOf(CellTrait).n91.call(this, cell, spec);
    }
    return tmp;
  };
  function btbProgramBuilders$lambda$lambda$lambda_8($refCompletion) {
    return function (_this__u8e3s4, source) {
      return new _no_name_provided__qut3iv_5($refCompletion, _this__u8e3s4, source);
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda$lambda(s) {
    return s.yfq();
  }
  function btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda($property) {
    return function ($this$setup, source, textCell) {
      var referenceTextPropSupplier = getLoopQuerySupplier($property);
      var loopQuery = referenceTextPropSupplier(source, $this$setup.gcq(), textCell);
      $this$setup.l8b(syncOneWay(loopQuery, textCell.o8w()));
      var tmp = getKClass(QualifiedReferenceContent);
      connectWithRefSupport(textCell, loopQuery, tmp, btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda$lambda);
      return Unit_instance;
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_0($refCompletion) {
    return function ($this$completion, _unused_var__etf5q3, textCell, _unused_var__etf5q3_0) {
      var refCompletionArgs = getRefCompletionArgs(textCell);
      var source = refCompletionArgs.gdb_1;
      var cellAction = refCompletionArgs.hdb_1;
      return $refCompletion($this$completion, source, textCell, cellAction);
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda($property, $refCompletion) {
    return function ($this$editableText) {
      $this$editableText.xcp(btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda($property));
      completion_1($this$editableText, btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_0($refCompletion));
      return Unit_instance;
    };
  }
  function _no_name_provided__qut3iv_6($cellBuilder, $refCompletion) {
    this.dtv_1 = $refCompletion;
    this.ctv_1 = $cellBuilder;
  }
  protoOf(_no_name_provided__qut3iv_6).etv = function (placeholderText, validator, property) {
    return editableText(this, validator, VOID, placeholderText, btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda(property, this.dtv_1));
  };
  protoOf(_no_name_provided__qut3iv_6).jcs = function (placeholderText, validator, property) {
    return this.etv(placeholderText, validator, property);
  };
  protoOf(_no_name_provided__qut3iv_6).fcq = function () {
    return this.ctv_1.fcq();
  };
  protoOf(_no_name_provided__qut3iv_6).ftv = function (child) {
    this.ctv_1.wcp(child);
  };
  protoOf(_no_name_provided__qut3iv_6).wcp = function (child) {
    return this.ftv(child);
  };
  protoOf(_no_name_provided__qut3iv_6).gtv = function (init) {
    this.ctv_1.xcp(init);
  };
  protoOf(_no_name_provided__qut3iv_6).xcp = function (init) {
    return this.gtv(init);
  };
  protoOf(_no_name_provided__qut3iv_6).htv = function (init) {
    this.ctv_1.ycp(init);
  };
  protoOf(_no_name_provided__qut3iv_6).ycp = function (init) {
    return this.htv(init);
  };
  protoOf(_no_name_provided__qut3iv_6).itv = function (source, cellMap, context) {
    return this.ctv_1.acq(source, cellMap, context);
  };
  protoOf(_no_name_provided__qut3iv_6).acq = function (source, cellMap, context) {
    return this.itv((!(source == null) ? isInterface(source, DomainNode) : false) ? source : THROW_CCE(), cellMap, context);
  };
  function btbProgramBuilders$lambda$lambda$lambda$lambda(it) {
    return it.y2();
  }
  function btbProgramBuilders$lambda$lambda$lambda_9($refCompletion) {
    return function ($this$rootIndent) {
      var cellBuilder = $this$rootIndent;
      // Inline function 'jetbrains.ocelot.langDef.editor.getReferenceCellBuilder' call
      var refCompletion = $refCompletion;
      var refCellBuilder = new _no_name_provided__qut3iv_6(cellBuilder, refCompletion);
      refCellBuilder.kcs('<root>', VOID, btbProgramBuilders$lambda$lambda$lambda$lambda);
      return Unit_instance;
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda_10() {
    // Inline function 'kotlin.also' call
    var this_0 = new IndentCell();
    Companion_getInstance_251().vda(this_0);
    return this_0;
  }
  function btbProgramBuilders$lambda$lambda$lambda_11(_unused_var__etf5q3, cell) {
    return get_forQueries(referenceData(cell).jda_1);
  }
  function btbProgramBuilders$lambda$lambda$lambda_12($completionTrait) {
    return function ($this$lambda, source, trait) {
      return CompositeCellTraits_instance.ra6([$completionTrait($this$lambda, source), trait]);
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda_13($this$setup, source, cell) {
    var referenceData_0 = referenceData(cell);
    var tmp$ret$0 = source.yfq();
    referenceData_0.wda(source, tmp$ret$0);
    return Unit_instance;
  }
  function btbProgramBuilders$lambda$lambda$lambda_14($this$setupSynchronizers, source, cell) {
    var tmp0 = $this$setupSynchronizers.gcq();
    // Inline function 'jetbrains.ocelot.langDef.references.synchronizers.getReferenceTargetSync' call
    var asyncTracker = new CellAsyncTracker(cell);
    var referenceData_0 = referenceData(cell);
    var tmp = ReferenceSynchronizers_instance;
    var tmp$ret$0 = source.yfq();
    var tmp$ret$1 = tmp.bdb(tmp0, tmp$ret$0, referenceData_0.jda_1, ResolveKind_LOOSE_getInstance(), null, asyncTracker);
    $this$setupSynchronizers.l8b(tmp$ret$1);
    $this$setupSynchronizers.l8b(getReferenceDataMonitorSynchronizer(cell));
    return Unit_instance;
  }
  function btbProgramBuilders$lambda$lambda$lambda_15($this$setupSynchronizers, source, cell) {
    if ($this$setupSynchronizers.gcq().nd5()) {
      var tmp = $this$setupSynchronizers.gcq();
      var tmp$ret$0 = source.yfq();
      $this$setupSynchronizers.l8b(referenceOutOfScopeSynchronizer(tmp, cell, tmp$ret$0));
      $this$setupSynchronizers.l8b(highlightReferenceTargetOutOfSync(cell, cell.n92(ReferenceCells_getInstance().cdb_1)));
    }
    return Unit_instance;
  }
  function btbProgramBuilders$lambda_2($this) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(OntologyImportRootReference_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      rootIndent(result, btbProgramBuilders$lambda$lambda_2);
      return this_0;
    };
  }
  function btbProgramBuilders$lambda$lambda_3($this$rootIndent) {
    var tmp2 = '<variable>';
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget' call
    var referenceTag = Companion_getInstance_352().mhx_1;
    var refCompletion = btbProgramBuilders$lambda$lambda$lambda_16(referenceTag);
    var completionTrait = btbProgramBuilders$lambda$lambda$lambda_17(refCompletion);
    // Inline function 'kotlin.also' call
    var this_0 = new SimpleMapperBuilder($this$rootIndent.fcq(), getKClass(VariableDeclaration_1));
    // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
    var result = new RootCellBuilderImpl(this_0);
    rootIndent(result, btbProgramBuilders$lambda$lambda$lambda_18(refCompletion));
    var mapperBuilder = this_0;
    var tmp0_cellFactory = new NamedCellFactory('referenceData', btbProgramBuilders$lambda$lambda$lambda_19);
    var tmp = btbProgramBuilders$lambda$lambda$lambda_20;
    // Inline function 'kotlin.apply' call
    var this_1 = projectionalChild($this$rootIndent, tmp, tmp0_cellFactory, mapperBuilder, tmp2, btbProgramBuilders$lambda$lambda$lambda_21(completionTrait));
    this_1.xcp(btbProgramBuilders$lambda$lambda$lambda_22);
    this_1.ycp(btbProgramBuilders$lambda$lambda$lambda_23);
    this_1.ycp(btbProgramBuilders$lambda$lambda$lambda_24);
    return Unit_instance;
  }
  function btbProgramBuilders$lambda$lambda$lambda_16($referenceTag) {
    return function (_this__u8e3s4, src, cell, cellAction) {
      var tmp = _this__u8e3s4.d6u($referenceTag);
      var tmp$ret$0 = src.pfu();
      return completion(_this__u8e3s4, tmp, src, tmp$ret$0, cell, VOID, cellAction);
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda$o$get$lambda_0($cell) {
    return function (it) {
      return signalCompletionHappened($cell, false, it);
    };
  }
  function _no_name_provided__qut3iv_7($refCompletion, $this, $source) {
    this.jtv_1 = $refCompletion;
    this.ktv_1 = $this;
    this.ltv_1 = $source;
    CellTrait.call(this);
  }
  protoOf(_no_name_provided__qut3iv_7).n91 = function (cell, spec) {
    var tmp;
    if (equals(spec, Completion_getInstance().u9d_1)) {
      tmp = this.jtv_1(this.ktv_1, this.ltv_1, cell, btbProgramBuilders$lambda$lambda$lambda$o$get$lambda_0(cell));
    } else {
      tmp = protoOf(CellTrait).n91.call(this, cell, spec);
    }
    return tmp;
  };
  function btbProgramBuilders$lambda$lambda$lambda_17($refCompletion) {
    return function (_this__u8e3s4, source) {
      return new _no_name_provided__qut3iv_7($refCompletion, _this__u8e3s4, source);
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda$lambda_0(s) {
    return s.pfu();
  }
  function btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_1($property) {
    return function ($this$setup, source, textCell) {
      var referenceTextPropSupplier = getLoopQuerySupplier($property);
      var loopQuery = referenceTextPropSupplier(source, $this$setup.gcq(), textCell);
      $this$setup.l8b(syncOneWay(loopQuery, textCell.o8w()));
      var tmp = getKClass(LocalReferenceContent);
      connectWithRefSupport(textCell, loopQuery, tmp, btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda$lambda_0);
      return Unit_instance;
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_2($refCompletion) {
    return function ($this$completion, _unused_var__etf5q3, textCell, _unused_var__etf5q3_0) {
      var refCompletionArgs = getRefCompletionArgs(textCell);
      var source = refCompletionArgs.gdb_1;
      var cellAction = refCompletionArgs.hdb_1;
      return $refCompletion($this$completion, source, textCell, cellAction);
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda_0($property, $refCompletion) {
    return function ($this$editableText) {
      $this$editableText.xcp(btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_1($property));
      completion_1($this$editableText, btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_2($refCompletion));
      return Unit_instance;
    };
  }
  function _no_name_provided__qut3iv_8($cellBuilder, $refCompletion) {
    this.ntv_1 = $refCompletion;
    this.mtv_1 = $cellBuilder;
  }
  protoOf(_no_name_provided__qut3iv_8).etv = function (placeholderText, validator, property) {
    return editableText(this, validator, VOID, placeholderText, btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda_0(property, this.ntv_1));
  };
  protoOf(_no_name_provided__qut3iv_8).jcs = function (placeholderText, validator, property) {
    return this.etv(placeholderText, validator, property);
  };
  protoOf(_no_name_provided__qut3iv_8).fcq = function () {
    return this.mtv_1.fcq();
  };
  protoOf(_no_name_provided__qut3iv_8).ftv = function (child) {
    this.mtv_1.wcp(child);
  };
  protoOf(_no_name_provided__qut3iv_8).wcp = function (child) {
    return this.ftv(child);
  };
  protoOf(_no_name_provided__qut3iv_8).gtv = function (init) {
    this.mtv_1.xcp(init);
  };
  protoOf(_no_name_provided__qut3iv_8).xcp = function (init) {
    return this.gtv(init);
  };
  protoOf(_no_name_provided__qut3iv_8).htv = function (init) {
    this.mtv_1.ycp(init);
  };
  protoOf(_no_name_provided__qut3iv_8).ycp = function (init) {
    return this.htv(init);
  };
  protoOf(_no_name_provided__qut3iv_8).itv = function (source, cellMap, context) {
    return this.mtv_1.acq(source, cellMap, context);
  };
  protoOf(_no_name_provided__qut3iv_8).acq = function (source, cellMap, context) {
    return this.itv((!(source == null) ? isInterface(source, DomainNode) : false) ? source : THROW_CCE(), cellMap, context);
  };
  function btbProgramBuilders$lambda$lambda$lambda$lambda_0(it) {
    return it.y2();
  }
  function btbProgramBuilders$lambda$lambda$lambda$lambda_1($this$rightTransform, _unused_var__etf5q3, cell, cellFinder) {
    var tmp = CompletionSupplement_instance;
    return tmp.o9p([completes('.', btbProgramBuilders$lambda$lambda$lambda$lambda$lambda(cell, $this$rightTransform, cellFinder))]);
  }
  function btbProgramBuilders$lambda$lambda$lambda$lambda$lambda($cell, $this_rightTransform, $cellFinder) {
    return function () {
      var tmp = get_enclosingRefData($cell).ida_1;
      var referenceSource = (!(tmp == null) ? isInterface(tmp, VariableReferenceValue_1) : false) ? tmp : THROW_CCE();
      // Inline function 'kotlin.run' call
      // Inline function 'kotlin.let' call
      var it = referenceSource.ri3($this_rightTransform.l6z());
      var tmp0_safe_receiver = firstOrNull_0($cellFinder.lah(it));
      var tmp0_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.c93(ProjectionalSynchronizers_getInstance().d99_1);
      return tmp0_elvis_lhs == null ? get_EMPTY_CELL_ACTION() : tmp0_elvis_lhs;
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda_18($refCompletion) {
    return function ($this$rootIndent) {
      var cellBuilder = $this$rootIndent;
      // Inline function 'jetbrains.ocelot.langDef.editor.getReferenceCellBuilder' call
      var refCompletion = $refCompletion;
      var refCellBuilder = new _no_name_provided__qut3iv_8(cellBuilder, refCompletion);
      var tmp = get_IdentifierValidator();
      // Inline function 'kotlin.apply' call
      var this_0 = refCellBuilder.jcs('<variable>', tmp, btbProgramBuilders$lambda$lambda$lambda$lambda_0);
      rightTransform(this_0, btbProgramBuilders$lambda$lambda$lambda$lambda_1);
      return Unit_instance;
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda_19() {
    // Inline function 'kotlin.also' call
    var this_0 = new IndentCell();
    Companion_getInstance_251().vda(this_0);
    return this_0;
  }
  function btbProgramBuilders$lambda$lambda$lambda_20(_unused_var__etf5q3, cell) {
    return get_forQueries(referenceData(cell).jda_1);
  }
  function btbProgramBuilders$lambda$lambda$lambda_21($completionTrait) {
    return function ($this$lambda, source, trait) {
      return CompositeCellTraits_instance.ra6([$completionTrait($this$lambda, source), trait]);
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda_22($this$setup, source, cell) {
    var referenceData_0 = referenceData(cell);
    var tmp$ret$0 = source.pfu();
    referenceData_0.wda(source, tmp$ret$0);
    return Unit_instance;
  }
  function btbProgramBuilders$lambda$lambda$lambda_23($this$setupSynchronizers, source, cell) {
    var tmp0 = $this$setupSynchronizers.gcq();
    // Inline function 'jetbrains.ocelot.langDef.references.synchronizers.getReferenceTargetSync' call
    var asyncTracker = new CellAsyncTracker(cell);
    var referenceData_0 = referenceData(cell);
    var tmp = ReferenceSynchronizers_instance;
    var tmp$ret$0 = source.pfu();
    var tmp$ret$1 = tmp.bdb(tmp0, tmp$ret$0, referenceData_0.jda_1, ResolveKind_LOOSE_getInstance(), null, asyncTracker);
    $this$setupSynchronizers.l8b(tmp$ret$1);
    $this$setupSynchronizers.l8b(getReferenceDataMonitorSynchronizer(cell));
    return Unit_instance;
  }
  function btbProgramBuilders$lambda$lambda$lambda_24($this$setupSynchronizers, source, cell) {
    if ($this$setupSynchronizers.gcq().nd5()) {
      var tmp = $this$setupSynchronizers.gcq();
      var tmp$ret$0 = source.pfu();
      $this$setupSynchronizers.l8b(referenceOutOfScopeSynchronizer(tmp, cell, tmp$ret$0));
      $this$setupSynchronizers.l8b(highlightReferenceTargetOutOfSync(cell, cell.n92(ReferenceCells_getInstance().cdb_1)));
    }
    return Unit_instance;
  }
  function btbProgramBuilders$lambda_3($this) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(VariableReferenceValue_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      rootIndent(result, btbProgramBuilders$lambda$lambda_3);
      return this_0;
    };
  }
  function btbProgramBuilders$lambda$lambda_4($this$rootIndent) {
    decimalProperty($this$rootIndent, '<amount>', btbProgramBuilders$lambda$lambda$lambda_25);
    space($this$rootIndent);
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget' call
    var referenceTag = Companion_getInstance_353().cgq_1;
    var refCompletion = btbProgramBuilders$lambda$lambda$lambda_26(referenceTag);
    var completionTrait = btbProgramBuilders$lambda$lambda$lambda_27(refCompletion);
    // Inline function 'kotlin.also' call
    var this_0 = new SimpleMapperBuilder($this$rootIndent.fcq(), getKClass(MeasurementUnit_1));
    // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
    var result = new RootCellBuilderImpl(this_0);
    rootIndent(result, btbProgramBuilders$lambda$lambda$lambda_28(refCompletion));
    var mapperBuilder = this_0;
    var tmp0_cellFactory = new NamedCellFactory('referenceData', btbProgramBuilders$lambda$lambda$lambda_29);
    var tmp = btbProgramBuilders$lambda$lambda$lambda_30;
    // Inline function 'kotlin.apply' call
    var this_1 = projectionalChild($this$rootIndent, tmp, tmp0_cellFactory, mapperBuilder, '<unit>', btbProgramBuilders$lambda$lambda$lambda_31(completionTrait));
    this_1.xcp(btbProgramBuilders$lambda$lambda$lambda_32);
    this_1.ycp(btbProgramBuilders$lambda$lambda$lambda_33);
    this_1.ycp(btbProgramBuilders$lambda$lambda$lambda_34);
    return Unit_instance;
  }
  function btbProgramBuilders$lambda$lambda$lambda_25(it) {
    return it.yfr();
  }
  function btbProgramBuilders$lambda$lambda$lambda_26($referenceTag) {
    return function (_this__u8e3s4, src, cell, cellAction) {
      var tmp = _this__u8e3s4.d6u($referenceTag);
      var tmp$ret$0 = src.zfr();
      return completion(_this__u8e3s4, tmp, src, tmp$ret$0, cell, VOID, cellAction);
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda$o$get$lambda_1($cell) {
    return function (it) {
      return signalCompletionHappened($cell, false, it);
    };
  }
  function _no_name_provided__qut3iv_9($refCompletion, $this, $source) {
    this.otv_1 = $refCompletion;
    this.ptv_1 = $this;
    this.qtv_1 = $source;
    CellTrait.call(this);
  }
  protoOf(_no_name_provided__qut3iv_9).n91 = function (cell, spec) {
    var tmp;
    if (equals(spec, Completion_getInstance().u9d_1)) {
      tmp = this.otv_1(this.ptv_1, this.qtv_1, cell, btbProgramBuilders$lambda$lambda$lambda$o$get$lambda_1(cell));
    } else {
      tmp = protoOf(CellTrait).n91.call(this, cell, spec);
    }
    return tmp;
  };
  function btbProgramBuilders$lambda$lambda$lambda_27($refCompletion) {
    return function (_this__u8e3s4, source) {
      return new _no_name_provided__qut3iv_9($refCompletion, _this__u8e3s4, source);
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda$lambda_1(s) {
    return s.zfr();
  }
  function btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_3($property) {
    return function ($this$setup, source, textCell) {
      var referenceTextPropSupplier = getLoopQuerySupplier($property);
      var loopQuery = referenceTextPropSupplier(source, $this$setup.gcq(), textCell);
      $this$setup.l8b(syncOneWay(loopQuery, textCell.o8w()));
      var tmp = getKClass(QualifiedReferenceContent);
      connectWithRefSupport(textCell, loopQuery, tmp, btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda$lambda_1);
      return Unit_instance;
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_4($refCompletion) {
    return function ($this$completion, _unused_var__etf5q3, textCell, _unused_var__etf5q3_0) {
      var refCompletionArgs = getRefCompletionArgs(textCell);
      var source = refCompletionArgs.gdb_1;
      var cellAction = refCompletionArgs.hdb_1;
      return $refCompletion($this$completion, source, textCell, cellAction);
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda_1($property, $refCompletion) {
    return function ($this$editableText) {
      $this$editableText.xcp(btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_3($property));
      completion_1($this$editableText, btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_4($refCompletion));
      return Unit_instance;
    };
  }
  function _no_name_provided__qut3iv_10($cellBuilder, $refCompletion) {
    this.stv_1 = $refCompletion;
    this.rtv_1 = $cellBuilder;
  }
  protoOf(_no_name_provided__qut3iv_10).etv = function (placeholderText, validator, property) {
    return editableText(this, validator, VOID, placeholderText, btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda_1(property, this.stv_1));
  };
  protoOf(_no_name_provided__qut3iv_10).jcs = function (placeholderText, validator, property) {
    return this.etv(placeholderText, validator, property);
  };
  protoOf(_no_name_provided__qut3iv_10).fcq = function () {
    return this.rtv_1.fcq();
  };
  protoOf(_no_name_provided__qut3iv_10).ftv = function (child) {
    this.rtv_1.wcp(child);
  };
  protoOf(_no_name_provided__qut3iv_10).wcp = function (child) {
    return this.ftv(child);
  };
  protoOf(_no_name_provided__qut3iv_10).gtv = function (init) {
    this.rtv_1.xcp(init);
  };
  protoOf(_no_name_provided__qut3iv_10).xcp = function (init) {
    return this.gtv(init);
  };
  protoOf(_no_name_provided__qut3iv_10).htv = function (init) {
    this.rtv_1.ycp(init);
  };
  protoOf(_no_name_provided__qut3iv_10).ycp = function (init) {
    return this.htv(init);
  };
  protoOf(_no_name_provided__qut3iv_10).itv = function (source, cellMap, context) {
    return this.rtv_1.acq(source, cellMap, context);
  };
  protoOf(_no_name_provided__qut3iv_10).acq = function (source, cellMap, context) {
    return this.itv((!(source == null) ? isInterface(source, DomainNode) : false) ? source : THROW_CCE(), cellMap, context);
  };
  function btbProgramBuilders$lambda$lambda$lambda$lambda_2(it) {
    return it.y2();
  }
  function btbProgramBuilders$lambda$lambda$lambda_28($refCompletion) {
    return function ($this$rootIndent) {
      var cellBuilder = $this$rootIndent;
      // Inline function 'jetbrains.ocelot.langDef.editor.getReferenceCellBuilder' call
      var refCompletion = $refCompletion;
      var refCellBuilder = new _no_name_provided__qut3iv_10(cellBuilder, refCompletion);
      refCellBuilder.kcs('<unit>', VOID, btbProgramBuilders$lambda$lambda$lambda$lambda_2);
      return Unit_instance;
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda_29() {
    // Inline function 'kotlin.also' call
    var this_0 = new IndentCell();
    Companion_getInstance_251().vda(this_0);
    return this_0;
  }
  function btbProgramBuilders$lambda$lambda$lambda_30(_unused_var__etf5q3, cell) {
    return get_forQueries(referenceData(cell).jda_1);
  }
  function btbProgramBuilders$lambda$lambda$lambda_31($completionTrait) {
    return function ($this$lambda, source, trait) {
      return CompositeCellTraits_instance.ra6([$completionTrait($this$lambda, source), trait]);
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda_32($this$setup, source, cell) {
    var referenceData_0 = referenceData(cell);
    var tmp$ret$0 = source.zfr();
    referenceData_0.wda(source, tmp$ret$0);
    return Unit_instance;
  }
  function btbProgramBuilders$lambda$lambda$lambda_33($this$setupSynchronizers, source, cell) {
    var tmp0 = $this$setupSynchronizers.gcq();
    // Inline function 'jetbrains.ocelot.langDef.references.synchronizers.getReferenceTargetSync' call
    var asyncTracker = new CellAsyncTracker(cell);
    var referenceData_0 = referenceData(cell);
    var tmp = ReferenceSynchronizers_instance;
    var tmp$ret$0 = source.zfr();
    var tmp$ret$1 = tmp.bdb(tmp0, tmp$ret$0, referenceData_0.jda_1, ResolveKind_LOOSE_getInstance(), null, asyncTracker);
    $this$setupSynchronizers.l8b(tmp$ret$1);
    $this$setupSynchronizers.l8b(getReferenceDataMonitorSynchronizer(cell));
    return Unit_instance;
  }
  function btbProgramBuilders$lambda$lambda$lambda_34($this$setupSynchronizers, source, cell) {
    if ($this$setupSynchronizers.gcq().nd5()) {
      var tmp = $this$setupSynchronizers.gcq();
      var tmp$ret$0 = source.zfr();
      $this$setupSynchronizers.l8b(referenceOutOfScopeSynchronizer(tmp, cell, tmp$ret$0));
      $this$setupSynchronizers.l8b(highlightReferenceTargetOutOfSync(cell, cell.n92(ReferenceCells_getInstance().cdb_1)));
    }
    return Unit_instance;
  }
  function btbProgramBuilders$lambda_4($this) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(MeasurableValue_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      rootIndent(result, btbProgramBuilders$lambda$lambda_4);
      return this_0;
    };
  }
  function btbProgramBuilders$lambda$lambda_5($this$rootIndent) {
    var tmp2 = '<constant>';
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget' call
    var referenceTag = Companion_getInstance_354().tg7_1;
    var refCompletion = btbProgramBuilders$lambda$lambda$lambda_35(referenceTag);
    var completionTrait = btbProgramBuilders$lambda$lambda$lambda_36(refCompletion);
    // Inline function 'kotlin.also' call
    var this_0 = new SimpleMapperBuilder($this$rootIndent.fcq(), getKClass(EnumerationConstant_1));
    // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
    var result = new RootCellBuilderImpl(this_0);
    rootIndent(result, btbProgramBuilders$lambda$lambda$lambda_37(refCompletion));
    var mapperBuilder = this_0;
    var tmp0_cellFactory = new NamedCellFactory('referenceData', btbProgramBuilders$lambda$lambda$lambda_38);
    var tmp = btbProgramBuilders$lambda$lambda$lambda_39;
    // Inline function 'kotlin.apply' call
    var this_1 = projectionalChild($this$rootIndent, tmp, tmp0_cellFactory, mapperBuilder, tmp2, btbProgramBuilders$lambda$lambda$lambda_40(completionTrait));
    this_1.xcp(btbProgramBuilders$lambda$lambda$lambda_41);
    this_1.ycp(btbProgramBuilders$lambda$lambda$lambda_42);
    this_1.ycp(btbProgramBuilders$lambda$lambda$lambda_43);
    return Unit_instance;
  }
  function btbProgramBuilders$lambda$lambda$lambda_35($referenceTag) {
    return function (_this__u8e3s4, src, cell, cellAction) {
      var tmp = _this__u8e3s4.d6u($referenceTag);
      var tmp$ret$0 = src.pfq();
      return completion(_this__u8e3s4, tmp, src, tmp$ret$0, cell, VOID, cellAction);
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda$o$get$lambda_2($cell) {
    return function (it) {
      return signalCompletionHappened($cell, false, it);
    };
  }
  function _no_name_provided__qut3iv_11($refCompletion, $this, $source) {
    this.ttv_1 = $refCompletion;
    this.utv_1 = $this;
    this.vtv_1 = $source;
    CellTrait.call(this);
  }
  protoOf(_no_name_provided__qut3iv_11).n91 = function (cell, spec) {
    var tmp;
    if (equals(spec, Completion_getInstance().u9d_1)) {
      tmp = this.ttv_1(this.utv_1, this.vtv_1, cell, btbProgramBuilders$lambda$lambda$lambda$o$get$lambda_2(cell));
    } else {
      tmp = protoOf(CellTrait).n91.call(this, cell, spec);
    }
    return tmp;
  };
  function btbProgramBuilders$lambda$lambda$lambda_36($refCompletion) {
    return function (_this__u8e3s4, source) {
      return new _no_name_provided__qut3iv_11($refCompletion, _this__u8e3s4, source);
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda$lambda_2(s) {
    return s.pfq();
  }
  function btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_5($property) {
    return function ($this$setup, source, textCell) {
      var referenceTextPropSupplier = getLoopQuerySupplier($property);
      var loopQuery = referenceTextPropSupplier(source, $this$setup.gcq(), textCell);
      $this$setup.l8b(syncOneWay(loopQuery, textCell.o8w()));
      var tmp = getKClass(QualifiedReferenceContent);
      connectWithRefSupport(textCell, loopQuery, tmp, btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda$lambda_2);
      return Unit_instance;
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_6($refCompletion) {
    return function ($this$completion, _unused_var__etf5q3, textCell, _unused_var__etf5q3_0) {
      var refCompletionArgs = getRefCompletionArgs(textCell);
      var source = refCompletionArgs.gdb_1;
      var cellAction = refCompletionArgs.hdb_1;
      return $refCompletion($this$completion, source, textCell, cellAction);
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda_2($property, $refCompletion) {
    return function ($this$editableText) {
      $this$editableText.xcp(btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_5($property));
      completion_1($this$editableText, btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_6($refCompletion));
      return Unit_instance;
    };
  }
  function _no_name_provided__qut3iv_12($cellBuilder, $refCompletion) {
    this.xtv_1 = $refCompletion;
    this.wtv_1 = $cellBuilder;
  }
  protoOf(_no_name_provided__qut3iv_12).etv = function (placeholderText, validator, property) {
    return editableText(this, validator, VOID, placeholderText, btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda_2(property, this.xtv_1));
  };
  protoOf(_no_name_provided__qut3iv_12).jcs = function (placeholderText, validator, property) {
    return this.etv(placeholderText, validator, property);
  };
  protoOf(_no_name_provided__qut3iv_12).fcq = function () {
    return this.wtv_1.fcq();
  };
  protoOf(_no_name_provided__qut3iv_12).ftv = function (child) {
    this.wtv_1.wcp(child);
  };
  protoOf(_no_name_provided__qut3iv_12).wcp = function (child) {
    return this.ftv(child);
  };
  protoOf(_no_name_provided__qut3iv_12).gtv = function (init) {
    this.wtv_1.xcp(init);
  };
  protoOf(_no_name_provided__qut3iv_12).xcp = function (init) {
    return this.gtv(init);
  };
  protoOf(_no_name_provided__qut3iv_12).htv = function (init) {
    this.wtv_1.ycp(init);
  };
  protoOf(_no_name_provided__qut3iv_12).ycp = function (init) {
    return this.htv(init);
  };
  protoOf(_no_name_provided__qut3iv_12).itv = function (source, cellMap, context) {
    return this.wtv_1.acq(source, cellMap, context);
  };
  protoOf(_no_name_provided__qut3iv_12).acq = function (source, cellMap, context) {
    return this.itv((!(source == null) ? isInterface(source, DomainNode) : false) ? source : THROW_CCE(), cellMap, context);
  };
  function btbProgramBuilders$lambda$lambda$lambda$lambda_3(it) {
    return it.y2();
  }
  function btbProgramBuilders$lambda$lambda$lambda_37($refCompletion) {
    return function ($this$rootIndent) {
      var cellBuilder = $this$rootIndent;
      // Inline function 'jetbrains.ocelot.langDef.editor.getReferenceCellBuilder' call
      var refCompletion = $refCompletion;
      var refCellBuilder = new _no_name_provided__qut3iv_12(cellBuilder, refCompletion);
      refCellBuilder.kcs('<constant>', VOID, btbProgramBuilders$lambda$lambda$lambda$lambda_3);
      return Unit_instance;
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda_38() {
    // Inline function 'kotlin.also' call
    var this_0 = new IndentCell();
    Companion_getInstance_251().vda(this_0);
    return this_0;
  }
  function btbProgramBuilders$lambda$lambda$lambda_39(_unused_var__etf5q3, cell) {
    return get_forQueries(referenceData(cell).jda_1);
  }
  function btbProgramBuilders$lambda$lambda$lambda_40($completionTrait) {
    return function ($this$lambda, source, trait) {
      return CompositeCellTraits_instance.ra6([$completionTrait($this$lambda, source), trait]);
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda_41($this$setup, source, cell) {
    var referenceData_0 = referenceData(cell);
    var tmp$ret$0 = source.pfq();
    referenceData_0.wda(source, tmp$ret$0);
    return Unit_instance;
  }
  function btbProgramBuilders$lambda$lambda$lambda_42($this$setupSynchronizers, source, cell) {
    var tmp0 = $this$setupSynchronizers.gcq();
    // Inline function 'jetbrains.ocelot.langDef.references.synchronizers.getReferenceTargetSync' call
    var asyncTracker = new CellAsyncTracker(cell);
    var referenceData_0 = referenceData(cell);
    var tmp = ReferenceSynchronizers_instance;
    var tmp$ret$0 = source.pfq();
    var tmp$ret$1 = tmp.bdb(tmp0, tmp$ret$0, referenceData_0.jda_1, ResolveKind_LOOSE_getInstance(), null, asyncTracker);
    $this$setupSynchronizers.l8b(tmp$ret$1);
    $this$setupSynchronizers.l8b(getReferenceDataMonitorSynchronizer(cell));
    return Unit_instance;
  }
  function btbProgramBuilders$lambda$lambda$lambda_43($this$setupSynchronizers, source, cell) {
    if ($this$setupSynchronizers.gcq().nd5()) {
      var tmp = $this$setupSynchronizers.gcq();
      var tmp$ret$0 = source.pfq();
      $this$setupSynchronizers.l8b(referenceOutOfScopeSynchronizer(tmp, cell, tmp$ret$0));
      $this$setupSynchronizers.l8b(highlightReferenceTargetOutOfSync(cell, cell.n92(ReferenceCells_getInstance().cdb_1)));
    }
    return Unit_instance;
  }
  function btbProgramBuilders$lambda_5($this) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(EnumValue_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      rootIndent(result, btbProgramBuilders$lambda$lambda_5);
      return this_0;
    };
  }
  function btbProgramBuilders$lambda$lambda_6($this$rootIndent) {
    // Inline function 'jetbrains.ocelot.langDef.editor.indentChild' call
    var role = btbProgramBuilders$lambda$lambda$lambda_44;
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.builder' call
    var this_0 = $this$rootIndent.fcq();
    var sourceType = getKClass(VariableReferenceValue_1);
    var tmp$ret$0 = this_0.xcr(sourceType);
    indentChild($this$rootIndent, role, tmp$ret$0, null, null);
    indentLabel($this$rootIndent, '.');
    indent($this$rootIndent, VOID, btbProgramBuilders$lambda$lambda$lambda_45);
    return Unit_instance;
  }
  function btbProgramBuilders$lambda$lambda$lambda_44(it) {
    return it.jfs();
  }
  function btbProgramBuilders$lambda$lambda$lambda_45($this$indent) {
    var tmp2 = btbProgramBuilders$lambda$lambda$lambda$lambda_4;
    // Inline function 'jetbrains.ocelot.langDef.editor.indentChild' call
    var init = btbProgramBuilders$lambda$lambda$lambda$lambda_5;
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.builder' call
    var this_0 = $this$indent.fcq();
    var sourceType = getKClass(PartReferenceOperation);
    var tmp$ret$0 = this_0.xcr(sourceType);
    indentChild($this$indent, tmp2, tmp$ret$0, null, init);
    addTraitOnAttach($this$indent, btbProgramBuilders$lambda$lambda$lambda$lambda_6);
    return Unit_instance;
  }
  function btbProgramBuilders$lambda$lambda$lambda$lambda_4(it) {
    return it.s3z();
  }
  function btbProgramBuilders$lambda$lambda$lambda$lambda_5($this$indentChild) {
    $this$indentChild.mct(btbProgramBuilders$lambda$lambda$lambda$lambda$lambda_0);
    defaultItem($this$indentChild, btbProgramBuilders$lambda$lambda$lambda$lambda$lambda_1);
    return Unit_instance;
  }
  function btbProgramBuilders$lambda$lambda$lambda$lambda$lambda_0($this$completion) {
    return partReferenceOperationCompletion($this$completion);
  }
  function btbProgramBuilders$lambda$lambda$lambda$lambda$lambda_1($this$defaultItem) {
    return ExtensionFieldReference($this$defaultItem.l6z());
  }
  function btbProgramBuilders$lambda$lambda$lambda$lambda_6($this$addTraitOnAttach, source, _unused_var__etf5q3, cellFinder) {
    return getDeleteTransformTrait(source, cellFinder);
  }
  function btbProgramBuilders$lambda_6($this) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(PartValue));
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      rootIndent(result, btbProgramBuilders$lambda$lambda_6);
      return this_0;
    };
  }
  function btbProgramBuilders$lambda$lambda_7($this$rootIndent) {
    var tmp2 = '<function>';
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget' call
    var referenceTag = Companion_getInstance_326().kgf_1;
    var refCompletion = btbProgramBuilders$lambda$lambda$lambda_46(referenceTag);
    var completionTrait = btbProgramBuilders$lambda$lambda$lambda_47(refCompletion);
    // Inline function 'kotlin.also' call
    var this_0 = new SimpleMapperBuilder($this$rootIndent.fcq(), getKClass(FunctionDeclaration_1));
    // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
    var result = new RootCellBuilderImpl(this_0);
    rootIndent(result, btbProgramBuilders$lambda$lambda$lambda_48(refCompletion));
    var mapperBuilder = this_0;
    var tmp0_cellFactory = new NamedCellFactory('referenceData', btbProgramBuilders$lambda$lambda$lambda_49);
    var tmp = btbProgramBuilders$lambda$lambda$lambda_50;
    // Inline function 'kotlin.apply' call
    var this_1 = projectionalChild($this$rootIndent, tmp, tmp0_cellFactory, mapperBuilder, tmp2, btbProgramBuilders$lambda$lambda$lambda_51(completionTrait));
    this_1.xcp(btbProgramBuilders$lambda$lambda$lambda_52);
    this_1.ycp(btbProgramBuilders$lambda$lambda$lambda_53);
    this_1.ycp(btbProgramBuilders$lambda$lambda$lambda_54);
    indentLabel($this$rootIndent, '(');
    var tmp2_0 = btbProgramBuilders$lambda$lambda$lambda_55;
    var tmp4 = '<parameters>';
    var tmp6 = btbProgramBuilders$lambda$lambda$lambda_56;
    // Inline function 'jetbrains.ocelot.langDef.editor.indentChildren' call
    var init = btbProgramBuilders$lambda$lambda$lambda_57;
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.builder' call
    var this_2 = $this$rootIndent.fcq();
    var sourceType = getKClass(BindingValuePlaceholder_1);
    var tmp$ret$7 = this_2.xcr(sourceType);
    indentChildren($this$rootIndent, tmp2_0, tmp$ret$7, tmp4, tmp6, init);
    indentLabel($this$rootIndent, ')');
    return Unit_instance;
  }
  function btbProgramBuilders$lambda$lambda$lambda_46($referenceTag) {
    return function (_this__u8e3s4, src, cell, cellAction) {
      var tmp = _this__u8e3s4.d6u($referenceTag);
      var tmp$ret$0 = src.ifr();
      return completion(_this__u8e3s4, tmp, src, tmp$ret$0, cell, VOID, cellAction);
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda$o$get$lambda_3($cell) {
    return function (it) {
      return signalCompletionHappened($cell, false, it);
    };
  }
  function _no_name_provided__qut3iv_13($refCompletion, $this, $source) {
    this.ytv_1 = $refCompletion;
    this.ztv_1 = $this;
    this.atw_1 = $source;
    CellTrait.call(this);
  }
  protoOf(_no_name_provided__qut3iv_13).n91 = function (cell, spec) {
    var tmp;
    if (equals(spec, Completion_getInstance().u9d_1)) {
      tmp = this.ytv_1(this.ztv_1, this.atw_1, cell, btbProgramBuilders$lambda$lambda$lambda$o$get$lambda_3(cell));
    } else {
      tmp = protoOf(CellTrait).n91.call(this, cell, spec);
    }
    return tmp;
  };
  function btbProgramBuilders$lambda$lambda$lambda_47($refCompletion) {
    return function (_this__u8e3s4, source) {
      return new _no_name_provided__qut3iv_13($refCompletion, _this__u8e3s4, source);
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda$lambda_3(s) {
    return s.ifr();
  }
  function btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_7($property) {
    return function ($this$setup, source, textCell) {
      var referenceTextPropSupplier = getLoopQuerySupplier($property);
      var loopQuery = referenceTextPropSupplier(source, $this$setup.gcq(), textCell);
      $this$setup.l8b(syncOneWay(loopQuery, textCell.o8w()));
      var tmp = getKClass(QualifiedReferenceContent);
      connectWithRefSupport(textCell, loopQuery, tmp, btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda$lambda_3);
      return Unit_instance;
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_8($refCompletion) {
    return function ($this$completion, _unused_var__etf5q3, textCell, _unused_var__etf5q3_0) {
      var refCompletionArgs = getRefCompletionArgs(textCell);
      var source = refCompletionArgs.gdb_1;
      var cellAction = refCompletionArgs.hdb_1;
      return $refCompletion($this$completion, source, textCell, cellAction);
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda_3($property, $refCompletion) {
    return function ($this$editableText) {
      $this$editableText.xcp(btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_7($property));
      completion_1($this$editableText, btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_8($refCompletion));
      return Unit_instance;
    };
  }
  function _no_name_provided__qut3iv_14($cellBuilder, $refCompletion) {
    this.ctw_1 = $refCompletion;
    this.btw_1 = $cellBuilder;
  }
  protoOf(_no_name_provided__qut3iv_14).etv = function (placeholderText, validator, property) {
    return editableText(this, validator, VOID, placeholderText, btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda_3(property, this.ctw_1));
  };
  protoOf(_no_name_provided__qut3iv_14).jcs = function (placeholderText, validator, property) {
    return this.etv(placeholderText, validator, property);
  };
  protoOf(_no_name_provided__qut3iv_14).fcq = function () {
    return this.btw_1.fcq();
  };
  protoOf(_no_name_provided__qut3iv_14).ftv = function (child) {
    this.btw_1.wcp(child);
  };
  protoOf(_no_name_provided__qut3iv_14).wcp = function (child) {
    return this.ftv(child);
  };
  protoOf(_no_name_provided__qut3iv_14).gtv = function (init) {
    this.btw_1.xcp(init);
  };
  protoOf(_no_name_provided__qut3iv_14).xcp = function (init) {
    return this.gtv(init);
  };
  protoOf(_no_name_provided__qut3iv_14).htv = function (init) {
    this.btw_1.ycp(init);
  };
  protoOf(_no_name_provided__qut3iv_14).ycp = function (init) {
    return this.htv(init);
  };
  protoOf(_no_name_provided__qut3iv_14).itv = function (source, cellMap, context) {
    return this.btw_1.acq(source, cellMap, context);
  };
  protoOf(_no_name_provided__qut3iv_14).acq = function (source, cellMap, context) {
    return this.itv((!(source == null) ? isInterface(source, DomainNode) : false) ? source : THROW_CCE(), cellMap, context);
  };
  function btbProgramBuilders$lambda$lambda$lambda$lambda_7(it) {
    return it.y2();
  }
  function btbProgramBuilders$lambda$lambda$lambda_48($refCompletion) {
    return function ($this$rootIndent) {
      var cellBuilder = $this$rootIndent;
      // Inline function 'jetbrains.ocelot.langDef.editor.getReferenceCellBuilder' call
      var refCompletion = $refCompletion;
      var refCellBuilder = new _no_name_provided__qut3iv_14(cellBuilder, refCompletion);
      refCellBuilder.kcs('<function>', VOID, btbProgramBuilders$lambda$lambda$lambda$lambda_7);
      return Unit_instance;
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda_49() {
    // Inline function 'kotlin.also' call
    var this_0 = new IndentCell();
    Companion_getInstance_251().vda(this_0);
    return this_0;
  }
  function btbProgramBuilders$lambda$lambda$lambda_50(_unused_var__etf5q3, cell) {
    return get_forQueries(referenceData(cell).jda_1);
  }
  function btbProgramBuilders$lambda$lambda$lambda_51($completionTrait) {
    return function ($this$lambda, source, trait) {
      return CompositeCellTraits_instance.ra6([$completionTrait($this$lambda, source), trait]);
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda_52($this$setup, source, cell) {
    var referenceData_0 = referenceData(cell);
    var tmp$ret$0 = source.ifr();
    referenceData_0.wda(source, tmp$ret$0);
    return Unit_instance;
  }
  function btbProgramBuilders$lambda$lambda$lambda_53($this$setupSynchronizers, source, cell) {
    var tmp0 = $this$setupSynchronizers.gcq();
    // Inline function 'jetbrains.ocelot.langDef.references.synchronizers.getReferenceTargetSync' call
    var asyncTracker = new CellAsyncTracker(cell);
    var referenceData_0 = referenceData(cell);
    var tmp = ReferenceSynchronizers_instance;
    var tmp$ret$0 = source.ifr();
    var tmp$ret$1 = tmp.bdb(tmp0, tmp$ret$0, referenceData_0.jda_1, ResolveKind_LOOSE_getInstance(), null, asyncTracker);
    $this$setupSynchronizers.l8b(tmp$ret$1);
    $this$setupSynchronizers.l8b(getReferenceDataMonitorSynchronizer(cell));
    return Unit_instance;
  }
  function btbProgramBuilders$lambda$lambda$lambda_54($this$setupSynchronizers, source, cell) {
    if ($this$setupSynchronizers.gcq().nd5()) {
      var tmp = $this$setupSynchronizers.gcq();
      var tmp$ret$0 = source.ifr();
      $this$setupSynchronizers.l8b(referenceOutOfScopeSynchronizer(tmp, cell, tmp$ret$0));
      $this$setupSynchronizers.l8b(highlightReferenceTargetOutOfSync(cell, cell.n92(ReferenceCells_getInstance().cdb_1)));
    }
    return Unit_instance;
  }
  function btbProgramBuilders$lambda$lambda$lambda_55(it) {
    return it.kfr();
  }
  function btbProgramBuilders$lambda$lambda$lambda_56(it) {
    return CellLists_instance.saa(it, ', ');
  }
  function btbProgramBuilders$lambda$lambda$lambda_57($this$indentChildren) {
    $this$indentChildren.mct(btbProgramBuilders$lambda$lambda$lambda$lambda_8);
    $this$indentChildren.ics(btbProgramBuilders$lambda$lambda$lambda$lambda_9);
    return Unit_instance;
  }
  function btbProgramBuilders$lambda$lambda$lambda$lambda_8($this$completion) {
    return bindingValueCompletion($this$completion);
  }
  function btbProgramBuilders$lambda$lambda$lambda$lambda_9($this$default) {
    var tmp = Companion_instance_200;
    return tmp.vap(btbProgramBuilders$lambda$lambda$lambda$lambda$lambda_2($this$default));
  }
  function btbProgramBuilders$lambda$lambda$lambda$lambda$lambda_2($this_default) {
    return function () {
      return BindingValuePlaceholder($this_default.l6z());
    };
  }
  function btbProgramBuilders$lambda_7($this) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(FunctionTerm_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      rootIndent(result, btbProgramBuilders$lambda$lambda_7);
      return this_0;
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda_58(it) {
    return it.y2();
  }
  function btbProgramBuilders$lambda$lambda$lambda_59(it) {
    return it.afr();
  }
  function btbProgramBuilders$lambda$lambda$lambda$lambda$lambda_3(it) {
    return it.rfr();
  }
  function btbProgramBuilders$lambda$lambda$lambda$lambda_10($this_btbProgramBuilders) {
    return function ($this$indent) {
      newLine($this$indent);
      // Inline function 'jetbrains.ocelot.langDef.editor.ChildBuilder.invoke' call
      // Inline function 'kotlin.also' call
      var this_0 = get_variableDeclarationRole($this_btbProgramBuilders).s3e();
      this_0.gd0('<variables>');
      this_0.jd0();
      var tmp = this_0;
      children_1($this$indent, tmp, btbProgramBuilders$lambda$lambda$lambda$lambda$lambda_3);
      return Unit_instance;
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda$lambda$lambda_4(it) {
    return it.wfq();
  }
  function btbProgramBuilders$lambda$lambda$lambda$lambda_11($this_btbProgramBuilders) {
    return function ($this$indent) {
      newLine($this$indent);
      var tmp = get_factRole($this_btbProgramBuilders);
      children_1($this$indent, tmp, btbProgramBuilders$lambda$lambda$lambda$lambda$lambda_4);
      return Unit_instance;
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda_60($this_btbProgramBuilders) {
    return function ($this$indent) {
      newLine($this$indent);
      keyword($this$indent, 'variables:');
      indent($this$indent, true, btbProgramBuilders$lambda$lambda$lambda$lambda_10($this_btbProgramBuilders));
      newLine($this$indent);
      keyword($this$indent, 'facts:');
      indent($this$indent, true, btbProgramBuilders$lambda$lambda$lambda$lambda_11($this_btbProgramBuilders));
      return Unit_instance;
    };
  }
  function btbProgramBuilders$lambda$lambda_8($this_btbProgramBuilders) {
    return function ($this$rootIndent) {
      textProperty($this$rootIndent, '<name>', btbProgramBuilders$lambda$lambda$lambda_58);
      newLine($this$rootIndent);
      keyword($this$rootIndent, 'with');
      indentLabel($this$rootIndent, '(');
      var tmp = get_contextRole($this_btbProgramBuilders);
      child_0($this$rootIndent, tmp, btbProgramBuilders$lambda$lambda$lambda_59);
      indentLabel($this$rootIndent, ')', true);
      indent($this$rootIndent, true, btbProgramBuilders$lambda$lambda$lambda_60($this_btbProgramBuilders));
      newLine($this$rootIndent);
      label($this$rootIndent, '_');
      return Unit_instance;
    };
  }
  function btbProgramBuilders$lambda_8($this, $this_btbProgramBuilders) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(FactSet_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      rootIndent(result, btbProgramBuilders$lambda$lambda_8($this_btbProgramBuilders));
      return this_0;
    };
  }
  function btbProgramBuilders$lambda$lambda_9($this$rootIndent) {
    var tmp2 = '<library>';
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget' call
    var referenceTag = Companion_getInstance_335().dh6_1;
    var refCompletion = btbProgramBuilders$lambda$lambda$lambda_61(referenceTag);
    var completionTrait = btbProgramBuilders$lambda$lambda$lambda_62(refCompletion);
    // Inline function 'kotlin.also' call
    var this_0 = new SimpleMapperBuilder($this$rootIndent.fcq(), getKClass(OntologyLibrary_1));
    // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
    var result = new RootCellBuilderImpl(this_0);
    rootIndent(result, btbProgramBuilders$lambda$lambda$lambda_63(refCompletion));
    var mapperBuilder = this_0;
    var tmp0_cellFactory = new NamedCellFactory('referenceData', btbProgramBuilders$lambda$lambda$lambda_64);
    var tmp = btbProgramBuilders$lambda$lambda$lambda_65;
    // Inline function 'kotlin.apply' call
    var this_1 = projectionalChild($this$rootIndent, tmp, tmp0_cellFactory, mapperBuilder, tmp2, btbProgramBuilders$lambda$lambda$lambda_66(completionTrait));
    this_1.xcp(btbProgramBuilders$lambda$lambda$lambda_67);
    this_1.ycp(btbProgramBuilders$lambda$lambda$lambda_68);
    this_1.ycp(btbProgramBuilders$lambda$lambda$lambda_69);
    return Unit_instance;
  }
  function btbProgramBuilders$lambda$lambda$lambda_61($referenceTag) {
    return function (_this__u8e3s4, src, cell, cellAction) {
      var tmp = _this__u8e3s4.d6u($referenceTag);
      var tmp$ret$0 = src.yfq();
      return completion(_this__u8e3s4, tmp, src, tmp$ret$0, cell, VOID, cellAction);
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda$o$get$lambda_4($cell) {
    return function (it) {
      return signalCompletionHappened($cell, false, it);
    };
  }
  function _no_name_provided__qut3iv_15($refCompletion, $this, $source) {
    this.dtw_1 = $refCompletion;
    this.etw_1 = $this;
    this.ftw_1 = $source;
    CellTrait.call(this);
  }
  protoOf(_no_name_provided__qut3iv_15).n91 = function (cell, spec) {
    var tmp;
    if (equals(spec, Completion_getInstance().u9d_1)) {
      tmp = this.dtw_1(this.etw_1, this.ftw_1, cell, btbProgramBuilders$lambda$lambda$lambda$o$get$lambda_4(cell));
    } else {
      tmp = protoOf(CellTrait).n91.call(this, cell, spec);
    }
    return tmp;
  };
  function btbProgramBuilders$lambda$lambda$lambda_62($refCompletion) {
    return function (_this__u8e3s4, source) {
      return new _no_name_provided__qut3iv_15($refCompletion, _this__u8e3s4, source);
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda$lambda_4(s) {
    return s.yfq();
  }
  function btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_9($property) {
    return function ($this$setup, source, textCell) {
      var referenceTextPropSupplier = getLoopQuerySupplier($property);
      var loopQuery = referenceTextPropSupplier(source, $this$setup.gcq(), textCell);
      $this$setup.l8b(syncOneWay(loopQuery, textCell.o8w()));
      var tmp = getKClass(QualifiedReferenceContent);
      connectWithRefSupport(textCell, loopQuery, tmp, btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda$lambda_4);
      return Unit_instance;
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_10($refCompletion) {
    return function ($this$completion, _unused_var__etf5q3, textCell, _unused_var__etf5q3_0) {
      var refCompletionArgs = getRefCompletionArgs(textCell);
      var source = refCompletionArgs.gdb_1;
      var cellAction = refCompletionArgs.hdb_1;
      return $refCompletion($this$completion, source, textCell, cellAction);
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda_4($property, $refCompletion) {
    return function ($this$editableText) {
      $this$editableText.xcp(btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_9($property));
      completion_1($this$editableText, btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_10($refCompletion));
      return Unit_instance;
    };
  }
  function _no_name_provided__qut3iv_16($cellBuilder, $refCompletion) {
    this.htw_1 = $refCompletion;
    this.gtw_1 = $cellBuilder;
  }
  protoOf(_no_name_provided__qut3iv_16).etv = function (placeholderText, validator, property) {
    return editableText(this, validator, VOID, placeholderText, btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda_4(property, this.htw_1));
  };
  protoOf(_no_name_provided__qut3iv_16).jcs = function (placeholderText, validator, property) {
    return this.etv(placeholderText, validator, property);
  };
  protoOf(_no_name_provided__qut3iv_16).fcq = function () {
    return this.gtw_1.fcq();
  };
  protoOf(_no_name_provided__qut3iv_16).ftv = function (child) {
    this.gtw_1.wcp(child);
  };
  protoOf(_no_name_provided__qut3iv_16).wcp = function (child) {
    return this.ftv(child);
  };
  protoOf(_no_name_provided__qut3iv_16).gtv = function (init) {
    this.gtw_1.xcp(init);
  };
  protoOf(_no_name_provided__qut3iv_16).xcp = function (init) {
    return this.gtv(init);
  };
  protoOf(_no_name_provided__qut3iv_16).htv = function (init) {
    this.gtw_1.ycp(init);
  };
  protoOf(_no_name_provided__qut3iv_16).ycp = function (init) {
    return this.htv(init);
  };
  protoOf(_no_name_provided__qut3iv_16).itv = function (source, cellMap, context) {
    return this.gtw_1.acq(source, cellMap, context);
  };
  protoOf(_no_name_provided__qut3iv_16).acq = function (source, cellMap, context) {
    return this.itv((!(source == null) ? isInterface(source, DomainNode) : false) ? source : THROW_CCE(), cellMap, context);
  };
  function btbProgramBuilders$lambda$lambda$lambda$lambda_12(it) {
    return it.y2();
  }
  function btbProgramBuilders$lambda$lambda$lambda_63($refCompletion) {
    return function ($this$rootIndent) {
      var cellBuilder = $this$rootIndent;
      // Inline function 'jetbrains.ocelot.langDef.editor.getReferenceCellBuilder' call
      var refCompletion = $refCompletion;
      var refCellBuilder = new _no_name_provided__qut3iv_16(cellBuilder, refCompletion);
      refCellBuilder.kcs('<library>', VOID, btbProgramBuilders$lambda$lambda$lambda$lambda_12);
      return Unit_instance;
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda_64() {
    // Inline function 'kotlin.also' call
    var this_0 = new IndentCell();
    Companion_getInstance_251().vda(this_0);
    return this_0;
  }
  function btbProgramBuilders$lambda$lambda$lambda_65(_unused_var__etf5q3, cell) {
    return get_forQueries(referenceData(cell).jda_1);
  }
  function btbProgramBuilders$lambda$lambda$lambda_66($completionTrait) {
    return function ($this$lambda, source, trait) {
      return CompositeCellTraits_instance.ra6([$completionTrait($this$lambda, source), trait]);
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda_67($this$setup, source, cell) {
    var referenceData_0 = referenceData(cell);
    var tmp$ret$0 = source.yfq();
    referenceData_0.wda(source, tmp$ret$0);
    return Unit_instance;
  }
  function btbProgramBuilders$lambda$lambda$lambda_68($this$setupSynchronizers, source, cell) {
    var tmp0 = $this$setupSynchronizers.gcq();
    // Inline function 'jetbrains.ocelot.langDef.references.synchronizers.getReferenceTargetSync' call
    var asyncTracker = new CellAsyncTracker(cell);
    var referenceData_0 = referenceData(cell);
    var tmp = ReferenceSynchronizers_instance;
    var tmp$ret$0 = source.yfq();
    var tmp$ret$1 = tmp.bdb(tmp0, tmp$ret$0, referenceData_0.jda_1, ResolveKind_LOOSE_getInstance(), null, asyncTracker);
    $this$setupSynchronizers.l8b(tmp$ret$1);
    $this$setupSynchronizers.l8b(getReferenceDataMonitorSynchronizer(cell));
    return Unit_instance;
  }
  function btbProgramBuilders$lambda$lambda$lambda_69($this$setupSynchronizers, source, cell) {
    if ($this$setupSynchronizers.gcq().nd5()) {
      var tmp = $this$setupSynchronizers.gcq();
      var tmp$ret$0 = source.yfq();
      $this$setupSynchronizers.l8b(referenceOutOfScopeSynchronizer(tmp, cell, tmp$ret$0));
      $this$setupSynchronizers.l8b(highlightReferenceTargetOutOfSync(cell, cell.n92(ReferenceCells_getInstance().cdb_1)));
    }
    return Unit_instance;
  }
  function btbProgramBuilders$lambda_9($this) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(OntologyLibraryReference_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      rootIndent(result, btbProgramBuilders$lambda$lambda_9);
      return this_0;
    };
  }
  function btbProgramBuilders$lambda$lambda_10($this$rootIndent) {
    var tmp2 = '<element>';
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget' call
    var referenceTag = Companion_getInstance_336().fh1_1;
    var refCompletion = btbProgramBuilders$lambda$lambda$lambda_70(referenceTag);
    var completionTrait = btbProgramBuilders$lambda$lambda$lambda_71(refCompletion);
    // Inline function 'kotlin.also' call
    var this_0 = new SimpleMapperBuilder($this$rootIndent.fcq(), getKClass(OntologyElement_1));
    // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
    var result = new RootCellBuilderImpl(this_0);
    rootIndent(result, btbProgramBuilders$lambda$lambda$lambda_72(refCompletion));
    var mapperBuilder = this_0;
    var tmp0_cellFactory = new NamedCellFactory('referenceData', btbProgramBuilders$lambda$lambda$lambda_73);
    var tmp = btbProgramBuilders$lambda$lambda$lambda_74;
    // Inline function 'kotlin.apply' call
    var this_1 = projectionalChild($this$rootIndent, tmp, tmp0_cellFactory, mapperBuilder, tmp2, btbProgramBuilders$lambda$lambda$lambda_75(completionTrait));
    this_1.xcp(btbProgramBuilders$lambda$lambda$lambda_76);
    this_1.ycp(btbProgramBuilders$lambda$lambda$lambda_77);
    this_1.ycp(btbProgramBuilders$lambda$lambda$lambda_78);
    return Unit_instance;
  }
  function btbProgramBuilders$lambda$lambda$lambda_70($referenceTag) {
    return function (_this__u8e3s4, src, cell, cellAction) {
      var tmp = _this__u8e3s4.d6u($referenceTag);
      var tmp$ret$0 = src.gfq();
      return completion(_this__u8e3s4, tmp, src, tmp$ret$0, cell, VOID, cellAction);
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda$o$get$lambda_5($cell) {
    return function (it) {
      return signalCompletionHappened($cell, false, it);
    };
  }
  function _no_name_provided__qut3iv_17($refCompletion, $this, $source) {
    this.itw_1 = $refCompletion;
    this.jtw_1 = $this;
    this.ktw_1 = $source;
    CellTrait.call(this);
  }
  protoOf(_no_name_provided__qut3iv_17).n91 = function (cell, spec) {
    var tmp;
    if (equals(spec, Completion_getInstance().u9d_1)) {
      tmp = this.itw_1(this.jtw_1, this.ktw_1, cell, btbProgramBuilders$lambda$lambda$lambda$o$get$lambda_5(cell));
    } else {
      tmp = protoOf(CellTrait).n91.call(this, cell, spec);
    }
    return tmp;
  };
  function btbProgramBuilders$lambda$lambda$lambda_71($refCompletion) {
    return function (_this__u8e3s4, source) {
      return new _no_name_provided__qut3iv_17($refCompletion, _this__u8e3s4, source);
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda$lambda_5(s) {
    return s.gfq();
  }
  function btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_11($property) {
    return function ($this$setup, source, textCell) {
      var referenceTextPropSupplier = getLoopQuerySupplier($property);
      var loopQuery = referenceTextPropSupplier(source, $this$setup.gcq(), textCell);
      $this$setup.l8b(syncOneWay(loopQuery, textCell.o8w()));
      var tmp = getKClass(QualifiedReferenceContent);
      connectWithRefSupport(textCell, loopQuery, tmp, btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda$lambda_5);
      return Unit_instance;
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_12($refCompletion) {
    return function ($this$completion, _unused_var__etf5q3, textCell, _unused_var__etf5q3_0) {
      var refCompletionArgs = getRefCompletionArgs(textCell);
      var source = refCompletionArgs.gdb_1;
      var cellAction = refCompletionArgs.hdb_1;
      return $refCompletion($this$completion, source, textCell, cellAction);
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda_5($property, $refCompletion) {
    return function ($this$editableText) {
      $this$editableText.xcp(btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_11($property));
      completion_1($this$editableText, btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_12($refCompletion));
      return Unit_instance;
    };
  }
  function _no_name_provided__qut3iv_18($cellBuilder, $refCompletion) {
    this.mtw_1 = $refCompletion;
    this.ltw_1 = $cellBuilder;
  }
  protoOf(_no_name_provided__qut3iv_18).etv = function (placeholderText, validator, property) {
    return editableText(this, validator, VOID, placeholderText, btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda_5(property, this.mtw_1));
  };
  protoOf(_no_name_provided__qut3iv_18).jcs = function (placeholderText, validator, property) {
    return this.etv(placeholderText, validator, property);
  };
  protoOf(_no_name_provided__qut3iv_18).fcq = function () {
    return this.ltw_1.fcq();
  };
  protoOf(_no_name_provided__qut3iv_18).ftv = function (child) {
    this.ltw_1.wcp(child);
  };
  protoOf(_no_name_provided__qut3iv_18).wcp = function (child) {
    return this.ftv(child);
  };
  protoOf(_no_name_provided__qut3iv_18).gtv = function (init) {
    this.ltw_1.xcp(init);
  };
  protoOf(_no_name_provided__qut3iv_18).xcp = function (init) {
    return this.gtv(init);
  };
  protoOf(_no_name_provided__qut3iv_18).htv = function (init) {
    this.ltw_1.ycp(init);
  };
  protoOf(_no_name_provided__qut3iv_18).ycp = function (init) {
    return this.htv(init);
  };
  protoOf(_no_name_provided__qut3iv_18).itv = function (source, cellMap, context) {
    return this.ltw_1.acq(source, cellMap, context);
  };
  protoOf(_no_name_provided__qut3iv_18).acq = function (source, cellMap, context) {
    return this.itv((!(source == null) ? isInterface(source, DomainNode) : false) ? source : THROW_CCE(), cellMap, context);
  };
  function btbProgramBuilders$lambda$lambda$lambda$lambda_13(it) {
    return it.y2();
  }
  function btbProgramBuilders$lambda$lambda$lambda_72($refCompletion) {
    return function ($this$rootIndent) {
      var cellBuilder = $this$rootIndent;
      // Inline function 'jetbrains.ocelot.langDef.editor.getReferenceCellBuilder' call
      var refCompletion = $refCompletion;
      var refCellBuilder = new _no_name_provided__qut3iv_18(cellBuilder, refCompletion);
      refCellBuilder.kcs('<element>', VOID, btbProgramBuilders$lambda$lambda$lambda$lambda_13);
      return Unit_instance;
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda_73() {
    // Inline function 'kotlin.also' call
    var this_0 = new IndentCell();
    Companion_getInstance_251().vda(this_0);
    return this_0;
  }
  function btbProgramBuilders$lambda$lambda$lambda_74(_unused_var__etf5q3, cell) {
    return get_forQueries(referenceData(cell).jda_1);
  }
  function btbProgramBuilders$lambda$lambda$lambda_75($completionTrait) {
    return function ($this$lambda, source, trait) {
      return CompositeCellTraits_instance.ra6([$completionTrait($this$lambda, source), trait]);
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda_76($this$setup, source, cell) {
    var referenceData_0 = referenceData(cell);
    var tmp$ret$0 = source.gfq();
    referenceData_0.wda(source, tmp$ret$0);
    return Unit_instance;
  }
  function btbProgramBuilders$lambda$lambda$lambda_77($this$setupSynchronizers, source, cell) {
    var tmp0 = $this$setupSynchronizers.gcq();
    // Inline function 'jetbrains.ocelot.langDef.references.synchronizers.getReferenceTargetSync' call
    var asyncTracker = new CellAsyncTracker(cell);
    var referenceData_0 = referenceData(cell);
    var tmp = ReferenceSynchronizers_instance;
    var tmp$ret$0 = source.gfq();
    var tmp$ret$1 = tmp.bdb(tmp0, tmp$ret$0, referenceData_0.jda_1, ResolveKind_LOOSE_getInstance(), null, asyncTracker);
    $this$setupSynchronizers.l8b(tmp$ret$1);
    $this$setupSynchronizers.l8b(getReferenceDataMonitorSynchronizer(cell));
    return Unit_instance;
  }
  function btbProgramBuilders$lambda$lambda$lambda_78($this$setupSynchronizers, source, cell) {
    if ($this$setupSynchronizers.gcq().nd5()) {
      var tmp = $this$setupSynchronizers.gcq();
      var tmp$ret$0 = source.gfq();
      $this$setupSynchronizers.l8b(referenceOutOfScopeSynchronizer(tmp, cell, tmp$ret$0));
      $this$setupSynchronizers.l8b(highlightReferenceTargetOutOfSync(cell, cell.n92(ReferenceCells_getInstance().cdb_1)));
    }
    return Unit_instance;
  }
  function btbProgramBuilders$lambda_10($this) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(OntologyElementReference_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      rootIndent(result, btbProgramBuilders$lambda$lambda_10);
      return this_0;
    };
  }
  function btbProgramBuilders$lambda$lambda_11($this$rootIndent) {
    var tmp2 = '<element>';
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget' call
    var referenceTag = Companion_getInstance_337().pgo_1;
    var refCompletion = btbProgramBuilders$lambda$lambda$lambda_79(referenceTag);
    var completionTrait = btbProgramBuilders$lambda$lambda$lambda_80(refCompletion);
    // Inline function 'kotlin.also' call
    var this_0 = new SimpleMapperBuilder($this$rootIndent.fcq(), getKClass(OntologyElement_1));
    // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
    var result = new RootCellBuilderImpl(this_0);
    rootIndent(result, btbProgramBuilders$lambda$lambda$lambda_81(refCompletion));
    var mapperBuilder = this_0;
    var tmp0_cellFactory = new NamedCellFactory('referenceData', btbProgramBuilders$lambda$lambda$lambda_82);
    var tmp = btbProgramBuilders$lambda$lambda$lambda_83;
    // Inline function 'kotlin.apply' call
    var this_1 = projectionalChild($this$rootIndent, tmp, tmp0_cellFactory, mapperBuilder, tmp2, btbProgramBuilders$lambda$lambda$lambda_84(completionTrait));
    this_1.xcp(btbProgramBuilders$lambda$lambda$lambda_85);
    this_1.ycp(btbProgramBuilders$lambda$lambda$lambda_86);
    this_1.ycp(btbProgramBuilders$lambda$lambda$lambda_87);
    return Unit_instance;
  }
  function btbProgramBuilders$lambda$lambda$lambda_79($referenceTag) {
    return function (_this__u8e3s4, src, cell, cellAction) {
      var tmp = _this__u8e3s4.d6u($referenceTag);
      var tmp$ret$0 = src.gfq();
      return completion(_this__u8e3s4, tmp, src, tmp$ret$0, cell, VOID, cellAction);
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda$o$get$lambda_6($cell) {
    return function (it) {
      return signalCompletionHappened($cell, false, it);
    };
  }
  function _no_name_provided__qut3iv_19($refCompletion, $this, $source) {
    this.ntw_1 = $refCompletion;
    this.otw_1 = $this;
    this.ptw_1 = $source;
    CellTrait.call(this);
  }
  protoOf(_no_name_provided__qut3iv_19).n91 = function (cell, spec) {
    var tmp;
    if (equals(spec, Completion_getInstance().u9d_1)) {
      tmp = this.ntw_1(this.otw_1, this.ptw_1, cell, btbProgramBuilders$lambda$lambda$lambda$o$get$lambda_6(cell));
    } else {
      tmp = protoOf(CellTrait).n91.call(this, cell, spec);
    }
    return tmp;
  };
  function btbProgramBuilders$lambda$lambda$lambda_80($refCompletion) {
    return function (_this__u8e3s4, source) {
      return new _no_name_provided__qut3iv_19($refCompletion, _this__u8e3s4, source);
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda$lambda_6(s) {
    return s.gfq();
  }
  function btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_13($property) {
    return function ($this$setup, source, textCell) {
      var referenceTextPropSupplier = getLoopQuerySupplier($property);
      var loopQuery = referenceTextPropSupplier(source, $this$setup.gcq(), textCell);
      $this$setup.l8b(syncOneWay(loopQuery, textCell.o8w()));
      var tmp = getKClass(LocalReferenceContent);
      connectWithRefSupport(textCell, loopQuery, tmp, btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda$lambda_6);
      return Unit_instance;
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_14($refCompletion) {
    return function ($this$completion, _unused_var__etf5q3, textCell, _unused_var__etf5q3_0) {
      var refCompletionArgs = getRefCompletionArgs(textCell);
      var source = refCompletionArgs.gdb_1;
      var cellAction = refCompletionArgs.hdb_1;
      return $refCompletion($this$completion, source, textCell, cellAction);
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda_6($property, $refCompletion) {
    return function ($this$editableText) {
      $this$editableText.xcp(btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_13($property));
      completion_1($this$editableText, btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_14($refCompletion));
      return Unit_instance;
    };
  }
  function _no_name_provided__qut3iv_20($cellBuilder, $refCompletion) {
    this.rtw_1 = $refCompletion;
    this.qtw_1 = $cellBuilder;
  }
  protoOf(_no_name_provided__qut3iv_20).etv = function (placeholderText, validator, property) {
    return editableText(this, validator, VOID, placeholderText, btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda_6(property, this.rtw_1));
  };
  protoOf(_no_name_provided__qut3iv_20).jcs = function (placeholderText, validator, property) {
    return this.etv(placeholderText, validator, property);
  };
  protoOf(_no_name_provided__qut3iv_20).fcq = function () {
    return this.qtw_1.fcq();
  };
  protoOf(_no_name_provided__qut3iv_20).ftv = function (child) {
    this.qtw_1.wcp(child);
  };
  protoOf(_no_name_provided__qut3iv_20).wcp = function (child) {
    return this.ftv(child);
  };
  protoOf(_no_name_provided__qut3iv_20).gtv = function (init) {
    this.qtw_1.xcp(init);
  };
  protoOf(_no_name_provided__qut3iv_20).xcp = function (init) {
    return this.gtv(init);
  };
  protoOf(_no_name_provided__qut3iv_20).htv = function (init) {
    this.qtw_1.ycp(init);
  };
  protoOf(_no_name_provided__qut3iv_20).ycp = function (init) {
    return this.htv(init);
  };
  protoOf(_no_name_provided__qut3iv_20).itv = function (source, cellMap, context) {
    return this.qtw_1.acq(source, cellMap, context);
  };
  protoOf(_no_name_provided__qut3iv_20).acq = function (source, cellMap, context) {
    return this.itv((!(source == null) ? isInterface(source, DomainNode) : false) ? source : THROW_CCE(), cellMap, context);
  };
  function btbProgramBuilders$lambda$lambda$lambda$lambda_14(it) {
    return it.y2();
  }
  function btbProgramBuilders$lambda$lambda$lambda_81($refCompletion) {
    return function ($this$rootIndent) {
      var cellBuilder = $this$rootIndent;
      // Inline function 'jetbrains.ocelot.langDef.editor.getReferenceCellBuilder' call
      var refCompletion = $refCompletion;
      var refCellBuilder = new _no_name_provided__qut3iv_20(cellBuilder, refCompletion);
      refCellBuilder.kcs('<element>', VOID, btbProgramBuilders$lambda$lambda$lambda$lambda_14);
      return Unit_instance;
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda_82() {
    // Inline function 'kotlin.also' call
    var this_0 = new IndentCell();
    Companion_getInstance_251().vda(this_0);
    return this_0;
  }
  function btbProgramBuilders$lambda$lambda$lambda_83(_unused_var__etf5q3, cell) {
    return get_forQueries(referenceData(cell).jda_1);
  }
  function btbProgramBuilders$lambda$lambda$lambda_84($completionTrait) {
    return function ($this$lambda, source, trait) {
      return CompositeCellTraits_instance.ra6([$completionTrait($this$lambda, source), trait]);
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda_85($this$setup, source, cell) {
    var referenceData_0 = referenceData(cell);
    var tmp$ret$0 = source.gfq();
    referenceData_0.wda(source, tmp$ret$0);
    return Unit_instance;
  }
  function btbProgramBuilders$lambda$lambda$lambda_86($this$setupSynchronizers, source, cell) {
    var tmp0 = $this$setupSynchronizers.gcq();
    // Inline function 'jetbrains.ocelot.langDef.references.synchronizers.getReferenceTargetSync' call
    var asyncTracker = new CellAsyncTracker(cell);
    var referenceData_0 = referenceData(cell);
    var tmp = ReferenceSynchronizers_instance;
    var tmp$ret$0 = source.gfq();
    var tmp$ret$1 = tmp.bdb(tmp0, tmp$ret$0, referenceData_0.jda_1, ResolveKind_LOOSE_getInstance(), null, asyncTracker);
    $this$setupSynchronizers.l8b(tmp$ret$1);
    $this$setupSynchronizers.l8b(getReferenceDataMonitorSynchronizer(cell));
    return Unit_instance;
  }
  function btbProgramBuilders$lambda$lambda$lambda_87($this$setupSynchronizers, source, cell) {
    if ($this$setupSynchronizers.gcq().nd5()) {
      var tmp = $this$setupSynchronizers.gcq();
      var tmp$ret$0 = source.gfq();
      $this$setupSynchronizers.l8b(referenceOutOfScopeSynchronizer(tmp, cell, tmp$ret$0));
      $this$setupSynchronizers.l8b(highlightReferenceTargetOutOfSync(cell, cell.n92(ReferenceCells_getInstance().cdb_1)));
    }
    return Unit_instance;
  }
  function btbProgramBuilders$lambda_11($this) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(LocalOntologyElementReference_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      rootIndent(result, btbProgramBuilders$lambda$lambda_11);
      return this_0;
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda_88(it) {
    return it.hfu();
  }
  function btbProgramBuilders$lambda$lambda$lambda_89(it) {
    return it.ifu();
  }
  function btbProgramBuilders$lambda$lambda_12($this_btbProgramBuilders) {
    return function ($this$indent) {
      var tmp = get_ontologyLibraryReferenceRole($this_btbProgramBuilders);
      child_0($this$indent, tmp, btbProgramBuilders$lambda$lambda$lambda_88);
      indentLabel($this$indent, '/');
      var tmp_0 = get_ontologyElementReferenceRole($this_btbProgramBuilders);
      child_0($this$indent, tmp_0, btbProgramBuilders$lambda$lambda$lambda_89);
      return Unit_instance;
    };
  }
  function btbProgramBuilders$lambda_12($this, $this_btbProgramBuilders) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(QualifiedOntologyElementReference_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      indent(result, VOID, btbProgramBuilders$lambda$lambda_12($this_btbProgramBuilders));
      return this_0;
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda_90(it) {
    return it.ffq();
  }
  function btbProgramBuilders$lambda$lambda$lambda_91(it) {
    return it.gfq();
  }
  function btbProgramBuilders$lambda$lambda_13($this_btbProgramBuilders) {
    return function ($this$indent) {
      var tmp = get_ontologyLibraryReferenceRole($this_btbProgramBuilders);
      child_0($this$indent, tmp, btbProgramBuilders$lambda$lambda$lambda_90);
      label($this$indent, '/');
      var tmp_0 = get_ontologyElementReferenceRole($this_btbProgramBuilders);
      child_0($this$indent, tmp_0, btbProgramBuilders$lambda$lambda$lambda_91);
      return Unit_instance;
    };
  }
  function btbProgramBuilders$lambda_13($this, $this_btbProgramBuilders) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(OntologyElementReferenceValueLibrary_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      indent(result, VOID, btbProgramBuilders$lambda$lambda_13($this_btbProgramBuilders));
      return this_0;
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda_92(it) {
    return it.gfq();
  }
  function btbProgramBuilders$lambda$lambda_14($this_btbProgramBuilders) {
    return function ($this$indent) {
      var tmp = get_ontologyElementReferenceRole($this_btbProgramBuilders);
      child_0($this$indent, tmp, btbProgramBuilders$lambda$lambda$lambda_92);
      return Unit_instance;
    };
  }
  function btbProgramBuilders$lambda_14($this, $this_btbProgramBuilders) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(OntologyElementReferenceValue_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      indent(result, VOID, btbProgramBuilders$lambda$lambda_14($this_btbProgramBuilders));
      return this_0;
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda_93(it) {
    return it.y2();
  }
  function btbProgramBuilders$lambda$lambda$lambda_94(it) {
    return it.ofu();
  }
  function btbProgramBuilders$lambda$lambda_15($this_btbProgramBuilders) {
    return function ($this$rootIndent) {
      textProperty($this$rootIndent, '<no name>', btbProgramBuilders$lambda$lambda$lambda_93);
      space($this$rootIndent);
      label($this$rootIndent, ':');
      space($this$rootIndent);
      var tmp = get_typeRole($this_btbProgramBuilders);
      child_0($this$rootIndent, tmp, btbProgramBuilders$lambda$lambda$lambda_94);
      return Unit_instance;
    };
  }
  function btbProgramBuilders$lambda_15($this, $this_btbProgramBuilders) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(VariableDeclaration_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      rootIndent(result, btbProgramBuilders$lambda$lambda_15($this_btbProgramBuilders));
      return this_0;
    };
  }
  function _get_category_$lambda_8otj26($this$default) {
    return Category($this$default.l6z());
  }
  function _get_category_$lambda_8otj26_0($this$clipboardParametersByCloner) {
    var tmp = new BaseNodeCloneSupport($this$clipboardParametersByCloner.gd3(), get_nodeFactory($this$clipboardParametersByCloner.l6z()));
    return isInterface(tmp, ClonerSupport) ? tmp : THROW_CCE();
  }
  function _get_imports_$lambda_vd27mw($this$default) {
    return OntologyImportRootReference($this$default.l6z());
  }
  function _get_imports_$lambda_vd27mw_0($this$clipboardParametersByCloner) {
    var tmp = new BaseNodeCloneSupport($this$clipboardParametersByCloner.gd3(), get_nodeFactory($this$clipboardParametersByCloner.l6z()));
    return isInterface(tmp, ClonerSupport) ? tmp : THROW_CCE();
  }
  function _get_factSetRole_$lambda_yaiexy($this$default) {
    return FactSet($this$default.l6z());
  }
  function _get_factSetRole_$lambda_yaiexy_0($this$clipboardParametersByCloner) {
    var tmp = new BaseNodeCloneSupport($this$clipboardParametersByCloner.gd3(), get_nodeFactory($this$clipboardParametersByCloner.l6z()));
    return isInterface(tmp, ClonerSupport) ? tmp : THROW_CCE();
  }
  function _get_ontologyLibraryReferenceRole_$lambda_x2j4ob($this$default) {
    return OntologyLibraryReference($this$default.l6z());
  }
  function _get_ontologyLibraryReferenceRole_$lambda_x2j4ob_0($this$clipboardParametersByCloner) {
    var tmp = new BaseNodeCloneSupport($this$clipboardParametersByCloner.gd3(), get_nodeFactory($this$clipboardParametersByCloner.l6z()));
    return isInterface(tmp, ClonerSupport) ? tmp : THROW_CCE();
  }
  function _get_ontologyElementReferenceRole_$lambda_f29iic($this$default) {
    return OntologyElementReference($this$default.l6z());
  }
  function _get_ontologyElementReferenceRole_$lambda_f29iic_0($this$completion) {
    var tmp = nodeRefCompletion($this$completion, Companion_getInstance_336().fh1_1);
    return map_2(tmp, _get_ontologyElementReferenceRole_$lambda$lambda_saqyd3($this$completion));
  }
  function _get_ontologyElementReferenceRole_$lambda$lambda_saqyd3($this_completion) {
    return function (it) {
      // Inline function 'kotlin.apply' call
      var this_0 = OntologyElementReference($this_completion.l6z());
      this_0.gfq().f2x(it);
      return this_0;
    };
  }
  function _get_ontologyElementReferenceRole_$lambda_f29iic_1($this$clipboardParametersByCloner) {
    var tmp = new BaseNodeCloneSupport($this$clipboardParametersByCloner.gd3(), get_nodeFactory($this$clipboardParametersByCloner.l6z()));
    return isInterface(tmp, ClonerSupport) ? tmp : THROW_CCE();
  }
  function _get_contextRole_$lambda_qaiv3z($this$default) {
    return Context_0($this$default.l6z());
  }
  function _get_contextRole_$lambda_qaiv3z_0($this$clipboardParametersByCloner) {
    var tmp = new BaseNodeCloneSupport($this$clipboardParametersByCloner.gd3(), get_nodeFactory($this$clipboardParametersByCloner.l6z()));
    return isInterface(tmp, ClonerSupport) ? tmp : THROW_CCE();
  }
  function _get_variableDeclarationRole_$lambda_d4qi0e($this$default) {
    return VariableDeclaration($this$default.l6z());
  }
  function _get_variableDeclarationRole_$lambda_d4qi0e_0($this$clipboardParametersByCloner) {
    var tmp = new BaseNodeCloneSupport($this$clipboardParametersByCloner.gd3(), get_nodeFactory($this$clipboardParametersByCloner.l6z()));
    return isInterface(tmp, ClonerSupport) ? tmp : THROW_CCE();
  }
  function _get_factRole_$lambda_e22khq($this$default) {
    return Fact($this$default.l6z());
  }
  function _get_factRole_$lambda_e22khq_0($this$clipboardParametersByCloner) {
    var tmp = new BaseNodeCloneSupport($this$clipboardParametersByCloner.gd3(), get_nodeFactory($this$clipboardParametersByCloner.l6z()));
    return isInterface(tmp, ClonerSupport) ? tmp : THROW_CCE();
  }
  function extensionLibraryBuilders(_this__u8e3s4) {
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder = new LazyMapperBuilder(extensionLibraryBuilders$lambda(_this__u8e3s4));
    _this__u8e3s4.vcr(builder);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_0 = new LazyMapperBuilder(extensionLibraryBuilders$lambda_0(_this__u8e3s4, _this__u8e3s4));
    _this__u8e3s4.vcr(builder_0);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_1 = new LazyMapperBuilder(extensionLibraryBuilders$lambda_1(_this__u8e3s4, _this__u8e3s4));
    _this__u8e3s4.vcr(builder_1);
  }
  function extensionFieldReferenceCompletion(_this__u8e3s4) {
    var tmp = nodeRefCompletion(_this__u8e3s4, Companion_getInstance_325().gg9_1);
    return map_2(tmp, extensionFieldReferenceCompletion$lambda(_this__u8e3s4));
  }
  function extensionLibraryBuilders$lambda$lambda(it) {
    return it.ue2();
  }
  function extensionLibraryBuilders$lambda$lambda_0(it) {
    return CellLists_instance.taa(it);
  }
  function extensionLibraryBuilders$lambda$lambda_1($this$indentChildren) {
    defaultItem($this$indentChildren, extensionLibraryBuilders$lambda$lambda$lambda);
    return Unit_instance;
  }
  function extensionLibraryBuilders$lambda$lambda$lambda($this$defaultItem) {
    return ExtensionDeclaration($this$defaultItem.l6z());
  }
  function extensionLibraryBuilders$lambda($this) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(ExtensionLibrary_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      var tmp2 = extensionLibraryBuilders$lambda$lambda;
      var tmp4 = extensionLibraryBuilders$lambda$lambda_0;
      // Inline function 'jetbrains.ocelot.langDef.editor.indentChildren' call
      var init = extensionLibraryBuilders$lambda$lambda_1;
      // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.builder' call
      var this_1 = result.fcq();
      var sourceType = getKClass(ExtensionDeclaration_1);
      var tmp$ret$0 = this_1.xcr(sourceType);
      indentChildren(result, tmp2, tmp$ret$0, null, tmp4, init);
      return this_0;
    };
  }
  function extensionLibraryBuilders$lambda$lambda$lambda_0(it) {
    return it.y2();
  }
  function extensionLibraryBuilders$lambda$lambda$lambda_1(it) {
    return it.sfq();
  }
  function extensionLibraryBuilders$lambda$lambda$lambda_2($this$indent) {
    newLine($this$indent);
    var tmp2 = extensionLibraryBuilders$lambda$lambda$lambda$lambda;
    var tmp4 = '<fields>';
    var tmp6 = extensionLibraryBuilders$lambda$lambda$lambda$lambda_0;
    // Inline function 'jetbrains.ocelot.langDef.editor.indentChildren' call
    var init = extensionLibraryBuilders$lambda$lambda$lambda$lambda_1;
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.builder' call
    var this_0 = $this$indent.fcq();
    var sourceType = getKClass(FieldDeclaration_1);
    var tmp$ret$0 = this_0.xcr(sourceType);
    indentChildren($this$indent, tmp2, tmp$ret$0, tmp4, tmp6, init);
    return Unit_instance;
  }
  function extensionLibraryBuilders$lambda$lambda$lambda$lambda(it) {
    return it.rfq();
  }
  function extensionLibraryBuilders$lambda$lambda$lambda$lambda_0(it) {
    return CellLists_instance.taa(it);
  }
  function extensionLibraryBuilders$lambda$lambda$lambda$lambda_1($this$indentChildren) {
    defaultItem($this$indentChildren, extensionLibraryBuilders$lambda$lambda$lambda$lambda$lambda);
    return Unit_instance;
  }
  function extensionLibraryBuilders$lambda$lambda$lambda$lambda$lambda($this$defaultItem) {
    return FieldDeclaration($this$defaultItem.l6z());
  }
  function extensionLibraryBuilders$lambda$lambda_2($this_extensionLibraryBuilders) {
    return function ($this$rootIndent) {
      keyword($this$rootIndent, 'extension');
      space($this$rootIndent);
      textProperty($this$rootIndent, '<name>', extensionLibraryBuilders$lambda$lambda$lambda_0);
      space($this$rootIndent);
      keyword($this$rootIndent, 'for');
      space($this$rootIndent);
      var tmp = get_ontologyElementTypeRole($this_extensionLibraryBuilders);
      child_0($this$rootIndent, tmp, extensionLibraryBuilders$lambda$lambda$lambda_1);
      indent($this$rootIndent, true, extensionLibraryBuilders$lambda$lambda$lambda_2);
      return Unit_instance;
    };
  }
  function extensionLibraryBuilders$lambda_0($this, $this_extensionLibraryBuilders) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(ExtensionDeclaration_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      rootIndent(result, extensionLibraryBuilders$lambda$lambda_2($this_extensionLibraryBuilders));
      return this_0;
    };
  }
  function extensionLibraryBuilders$lambda$lambda$lambda_3(it) {
    return it.y2();
  }
  function extensionLibraryBuilders$lambda$lambda$lambda_4(it) {
    return it.sfq();
  }
  function extensionLibraryBuilders$lambda$lambda$lambda_5(it) {
    return it.dfr();
  }
  function extensionLibraryBuilders$lambda$lambda_3($this_extensionLibraryBuilders) {
    return function ($this$rootIndent) {
      textProperty($this$rootIndent, '<name>', extensionLibraryBuilders$lambda$lambda$lambda_3);
      indentLabel($this$rootIndent, ':', true);
      space($this$rootIndent);
      var tmp = get_ontologyElementTypeRole($this_extensionLibraryBuilders);
      child_0($this$rootIndent, tmp, extensionLibraryBuilders$lambda$lambda$lambda_4);
      space($this$rootIndent);
      var tmp_0 = get_cardinality($this_extensionLibraryBuilders);
      child_0($this$rootIndent, tmp_0, extensionLibraryBuilders$lambda$lambda$lambda_5);
      return Unit_instance;
    };
  }
  function extensionLibraryBuilders$lambda_1($this, $this_extensionLibraryBuilders) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(FieldDeclaration_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      rootIndent(result, extensionLibraryBuilders$lambda$lambda_3($this_extensionLibraryBuilders));
      return this_0;
    };
  }
  function extensionFieldReferenceCompletion$lambda($this_extensionFieldReferenceCompletion) {
    return function (it) {
      return ExtensionFieldReference_2($this_extensionFieldReferenceCompletion.l6z(), it);
    };
  }
  function factBuilders(_this__u8e3s4) {
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder = new LazyMapperBuilder(factBuilders$lambda(_this__u8e3s4));
    _this__u8e3s4.vcr(builder);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_0 = new LazyMapperBuilder(factBuilders$lambda_0(_this__u8e3s4));
    _this__u8e3s4.vcr(builder_0);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_1 = new LazyMapperBuilder(factBuilders$lambda_1(_this__u8e3s4));
    _this__u8e3s4.vcr(builder_1);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_2 = new LazyMapperBuilder(factBuilders$lambda_2(_this__u8e3s4, _this__u8e3s4));
    _this__u8e3s4.vcr(builder_2);
  }
  function get_preconditionCompletion(_this__u8e3s4) {
    return plus_14(get_constantPreconditionCompletion(_this__u8e3s4), get_factsPreconditionCompletion(_this__u8e3s4));
  }
  function processSpecificationCompletion(_this__u8e3s4) {
    return libraryProcessSpecification(_this__u8e3s4);
  }
  function get_factRefRole(_this__u8e3s4) {
    // Inline function 'jetbrains.biokb.lang.builders.nodeRole' call
    // Inline function 'jetbrains.ocelot.langDef.editor.role' call
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.builder' call
    var sourceType = getKClass(FactReference_1);
    var tmp$ret$0 = _this__u8e3s4.xcr(sourceType);
    var builder = new ChildBuilder(tmp$ret$0);
    builder.fd0(_get_factRefRole_$lambda_69fbh3);
    builder.hd0(_get_factRefRole_$lambda_69fbh3_0);
    var simpleClassName = ensureNotNull(getKClass(FactReference_1).ra());
    builder.kd0(simpleClassName, _get_factRefRole_$lambda_69fbh3_1);
    return builder;
  }
  function get_constantPreconditionCompletion(_this__u8e3s4) {
    var tmp = produces('ALWAYS', _get_constantPreconditionCompletion_$lambda_vvyei0(_this__u8e3s4));
    return simpleCompletion(listOf_0([tmp, produces('NEVER', _get_constantPreconditionCompletion_$lambda_vvyei0_0(_this__u8e3s4))]));
  }
  function get_factsPreconditionCompletion(_this__u8e3s4) {
    var tmp = get_factReferenceCompletion(_this__u8e3s4);
    return map_2(tmp, _get_factsPreconditionCompletion_$lambda_dmc8zv(_this__u8e3s4));
  }
  function libraryProcessSpecification(_this__u8e3s4) {
    var tmp = nodeRefCompletion(_this__u8e3s4, Companion_getInstance_338().ihc_1);
    return map_2(tmp, libraryProcessSpecification$lambda(_this__u8e3s4));
  }
  function get_factReferenceCompletion(_this__u8e3s4) {
    var tmp = nodeRefCompletion(_this__u8e3s4, Companion_getInstance_313().igb_1);
    return map_2(tmp, _get_factReferenceCompletion_$lambda_zifg0b(_this__u8e3s4));
  }
  function factBuilders$lambda$lambda($this$rootIndent) {
    var tmp2 = factBuilders$lambda$lambda$lambda;
    var tmp4 = '<precondition>';
    // Inline function 'jetbrains.ocelot.langDef.editor.indentChild' call
    var init = factBuilders$lambda$lambda$lambda_0;
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.builder' call
    var this_0 = $this$rootIndent.fcq();
    var sourceType = getKClass(Precondition);
    var tmp$ret$0 = this_0.xcr(sourceType);
    indentChild($this$rootIndent, tmp2, tmp$ret$0, tmp4, init);
    space($this$rootIndent);
    textProperty($this$rootIndent, '<no name>', factBuilders$lambda$lambda$lambda_1);
    space($this$rootIndent);
    var tmp2_0 = factBuilders$lambda$lambda$lambda_2;
    // Inline function 'jetbrains.ocelot.langDef.editor.indentChild' call
    var init_0 = factBuilders$lambda$lambda$lambda_3;
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.builder' call
    var this_1 = $this$rootIndent.fcq();
    var sourceType_0 = getKClass(AbstractProcessSpecification);
    var tmp$ret$2 = this_1.xcr(sourceType_0);
    indentChild($this$rootIndent, tmp2_0, tmp$ret$2, '<spec>', init_0);
    return Unit_instance;
  }
  function factBuilders$lambda$lambda$lambda(it) {
    return it.ufq();
  }
  function factBuilders$lambda$lambda$lambda_0($this$indentChild) {
    defaultItem($this$indentChild, factBuilders$lambda$lambda$lambda$lambda);
    $this$indentChild.mct(factBuilders$lambda$lambda$lambda$lambda_0);
    return Unit_instance;
  }
  function factBuilders$lambda$lambda$lambda$lambda($this$defaultItem) {
    return ConstantPrecondition_1($this$defaultItem.l6z(), When_ALWAYS_getInstance());
  }
  function factBuilders$lambda$lambda$lambda$lambda_0($this$completion) {
    return get_preconditionCompletion($this$completion);
  }
  function factBuilders$lambda$lambda$lambda_1(it) {
    return it.y2();
  }
  function factBuilders$lambda$lambda$lambda_2(it) {
    return it.vfq();
  }
  function factBuilders$lambda$lambda$lambda_3($this$indentChild) {
    $this$indentChild.mct(factBuilders$lambda$lambda$lambda$lambda_1);
    defaultItem($this$indentChild, factBuilders$lambda$lambda$lambda$lambda_2);
    return Unit_instance;
  }
  function factBuilders$lambda$lambda$lambda$lambda_1($this$completion) {
    return processSpecificationCompletion($this$completion);
  }
  function factBuilders$lambda$lambda$lambda$lambda_2($this$defaultItem) {
    return LibraryProcessSpecification($this$defaultItem.l6z());
  }
  function factBuilders$lambda($this) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(Fact_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      rootIndent(result, factBuilders$lambda$lambda);
      return this_0;
    };
  }
  function factBuilders$lambda$lambda_0($this$rootIndent) {
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget' call
    var referenceTag = Companion_getInstance_313().igb_1;
    var refCompletion = factBuilders$lambda$lambda$lambda_4(referenceTag);
    var completionTrait = factBuilders$lambda$lambda$lambda_5(refCompletion);
    // Inline function 'kotlin.also' call
    var this_0 = new SimpleMapperBuilder($this$rootIndent.fcq(), getKClass(Fact_1));
    // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
    var result = new RootCellBuilderImpl(this_0);
    rootIndent(result, factBuilders$lambda$lambda$lambda_6(refCompletion));
    var mapperBuilder = this_0;
    var tmp0_cellFactory = new NamedCellFactory('referenceData', factBuilders$lambda$lambda$lambda_7);
    var tmp = factBuilders$lambda$lambda$lambda_8;
    // Inline function 'kotlin.apply' call
    var this_1 = projectionalChild($this$rootIndent, tmp, tmp0_cellFactory, mapperBuilder, '<fact>', factBuilders$lambda$lambda$lambda_9(completionTrait));
    this_1.xcp(factBuilders$lambda$lambda$lambda_10);
    this_1.ycp(factBuilders$lambda$lambda$lambda_11);
    this_1.ycp(factBuilders$lambda$lambda$lambda_12);
    return Unit_instance;
  }
  function factBuilders$lambda$lambda$lambda_4($referenceTag) {
    return function (_this__u8e3s4, src, cell, cellAction) {
      var tmp = _this__u8e3s4.d6u($referenceTag);
      var tmp$ret$0 = src.yfq();
      return completion(_this__u8e3s4, tmp, src, tmp$ret$0, cell, VOID, cellAction);
    };
  }
  function factBuilders$lambda$lambda$lambda$o$get$lambda($cell) {
    return function (it) {
      return signalCompletionHappened($cell, false, it);
    };
  }
  function _no_name_provided__qut3iv_21($refCompletion, $this, $source) {
    this.stw_1 = $refCompletion;
    this.ttw_1 = $this;
    this.utw_1 = $source;
    CellTrait.call(this);
  }
  protoOf(_no_name_provided__qut3iv_21).n91 = function (cell, spec) {
    var tmp;
    if (equals(spec, Completion_getInstance().u9d_1)) {
      tmp = this.stw_1(this.ttw_1, this.utw_1, cell, factBuilders$lambda$lambda$lambda$o$get$lambda(cell));
    } else {
      tmp = protoOf(CellTrait).n91.call(this, cell, spec);
    }
    return tmp;
  };
  function factBuilders$lambda$lambda$lambda_5($refCompletion) {
    return function (_this__u8e3s4, source) {
      return new _no_name_provided__qut3iv_21($refCompletion, _this__u8e3s4, source);
    };
  }
  function factBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda$lambda(s) {
    return s.yfq();
  }
  function factBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda($property) {
    return function ($this$setup, source, textCell) {
      var referenceTextPropSupplier = getLoopQuerySupplier($property);
      var loopQuery = referenceTextPropSupplier(source, $this$setup.gcq(), textCell);
      $this$setup.l8b(syncOneWay(loopQuery, textCell.o8w()));
      var tmp = getKClass(LocalReferenceContent);
      connectWithRefSupport(textCell, loopQuery, tmp, factBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda$lambda);
      return Unit_instance;
    };
  }
  function factBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_0($refCompletion) {
    return function ($this$completion, _unused_var__etf5q3, textCell, _unused_var__etf5q3_0) {
      var refCompletionArgs = getRefCompletionArgs(textCell);
      var source = refCompletionArgs.gdb_1;
      var cellAction = refCompletionArgs.hdb_1;
      return $refCompletion($this$completion, source, textCell, cellAction);
    };
  }
  function factBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda($property, $refCompletion) {
    return function ($this$editableText) {
      $this$editableText.xcp(factBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda($property));
      completion_1($this$editableText, factBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_0($refCompletion));
      return Unit_instance;
    };
  }
  function _no_name_provided__qut3iv_22($cellBuilder, $refCompletion) {
    this.wtw_1 = $refCompletion;
    this.vtw_1 = $cellBuilder;
  }
  protoOf(_no_name_provided__qut3iv_22).etv = function (placeholderText, validator, property) {
    return editableText(this, validator, VOID, placeholderText, factBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda(property, this.wtw_1));
  };
  protoOf(_no_name_provided__qut3iv_22).jcs = function (placeholderText, validator, property) {
    return this.etv(placeholderText, validator, property);
  };
  protoOf(_no_name_provided__qut3iv_22).fcq = function () {
    return this.vtw_1.fcq();
  };
  protoOf(_no_name_provided__qut3iv_22).ftv = function (child) {
    this.vtw_1.wcp(child);
  };
  protoOf(_no_name_provided__qut3iv_22).wcp = function (child) {
    return this.ftv(child);
  };
  protoOf(_no_name_provided__qut3iv_22).gtv = function (init) {
    this.vtw_1.xcp(init);
  };
  protoOf(_no_name_provided__qut3iv_22).xcp = function (init) {
    return this.gtv(init);
  };
  protoOf(_no_name_provided__qut3iv_22).htv = function (init) {
    this.vtw_1.ycp(init);
  };
  protoOf(_no_name_provided__qut3iv_22).ycp = function (init) {
    return this.htv(init);
  };
  protoOf(_no_name_provided__qut3iv_22).itv = function (source, cellMap, context) {
    return this.vtw_1.acq(source, cellMap, context);
  };
  protoOf(_no_name_provided__qut3iv_22).acq = function (source, cellMap, context) {
    return this.itv((!(source == null) ? isInterface(source, DomainNode) : false) ? source : THROW_CCE(), cellMap, context);
  };
  function factBuilders$lambda$lambda$lambda$lambda_3(it) {
    return it.y2();
  }
  function factBuilders$lambda$lambda$lambda_6($refCompletion) {
    return function ($this$rootIndent) {
      var cellBuilder = $this$rootIndent;
      // Inline function 'jetbrains.ocelot.langDef.editor.getReferenceCellBuilder' call
      var refCompletion = $refCompletion;
      var refCellBuilder = new _no_name_provided__qut3iv_22(cellBuilder, refCompletion);
      refCellBuilder.kcs('<factRef>', VOID, factBuilders$lambda$lambda$lambda$lambda_3);
      return Unit_instance;
    };
  }
  function factBuilders$lambda$lambda$lambda_7() {
    // Inline function 'kotlin.also' call
    var this_0 = new IndentCell();
    Companion_getInstance_251().vda(this_0);
    return this_0;
  }
  function factBuilders$lambda$lambda$lambda_8(_unused_var__etf5q3, cell) {
    return get_forQueries(referenceData(cell).jda_1);
  }
  function factBuilders$lambda$lambda$lambda_9($completionTrait) {
    return function ($this$lambda, source, trait) {
      return CompositeCellTraits_instance.ra6([$completionTrait($this$lambda, source), trait]);
    };
  }
  function factBuilders$lambda$lambda$lambda_10($this$setup, source, cell) {
    var referenceData_0 = referenceData(cell);
    var tmp$ret$0 = source.yfq();
    referenceData_0.wda(source, tmp$ret$0);
    return Unit_instance;
  }
  function factBuilders$lambda$lambda$lambda_11($this$setupSynchronizers, source, cell) {
    var tmp0 = $this$setupSynchronizers.gcq();
    // Inline function 'jetbrains.ocelot.langDef.references.synchronizers.getReferenceTargetSync' call
    var asyncTracker = new CellAsyncTracker(cell);
    var referenceData_0 = referenceData(cell);
    var tmp = ReferenceSynchronizers_instance;
    var tmp$ret$0 = source.yfq();
    var tmp$ret$1 = tmp.bdb(tmp0, tmp$ret$0, referenceData_0.jda_1, ResolveKind_LOOSE_getInstance(), null, asyncTracker);
    $this$setupSynchronizers.l8b(tmp$ret$1);
    $this$setupSynchronizers.l8b(getReferenceDataMonitorSynchronizer(cell));
    return Unit_instance;
  }
  function factBuilders$lambda$lambda$lambda_12($this$setupSynchronizers, source, cell) {
    if ($this$setupSynchronizers.gcq().nd5()) {
      var tmp = $this$setupSynchronizers.gcq();
      var tmp$ret$0 = source.yfq();
      $this$setupSynchronizers.l8b(referenceOutOfScopeSynchronizer(tmp, cell, tmp$ret$0));
      $this$setupSynchronizers.l8b(highlightReferenceTargetOutOfSync(cell, cell.n92(ReferenceCells_getInstance().cdb_1)));
    }
    return Unit_instance;
  }
  function factBuilders$lambda_0($this) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(FactReference_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      rootIndent(result, factBuilders$lambda$lambda_0);
      return this_0;
    };
  }
  function factBuilders$lambda$lambda_1($this$rootIndent) {
    // Inline function 'jetbrains.ocelot.langDef.editor.enumProperty' call
    var placeholder = '<no kind>';
    editableText($this$rootIndent, VOID, VOID, placeholder, factBuilders$lambda$lambda$lambda_13);
    return Unit_instance;
  }
  function factBuilders$lambda$lambda$lambda_13($this$editableText) {
    // Inline function 'jetbrains.ocelot.langDef.editor.enumSyncTwoWay' call
    var targetPropFactory = factBuilders$lambda$lambda$lambda$lambda_4;
    // Inline function 'jetbrains.ocelot.langDef.editor.textCellSyncTwoWay' call
    $this$editableText.xcp(factBuilders$lambda$lambda$lambda$lambda_5(targetPropFactory));
    return Unit_instance;
  }
  function factBuilders$lambda$lambda$lambda$lambda_4(textCell) {
    // Inline function 'jetbrains.ocelot.base.enums.EnumInfoFactory.createEnumInfo' call
    // Inline function 'kotlin.enumValues' call
    var tmp$ret$0 = values_12();
    var enumInfo = new EnumInfoImpl(tmp$ret$0);
    return ValueEditors_instance.uag(textCell, enumInfo);
  }
  function factBuilders$lambda$lambda$lambda$lambda_5($targetPropFactory) {
    return function ($this$setup, source, textCell) {
      var sourceProp = source.r5a();
      var targetProp = $targetPropFactory(textCell);
      $this$setup.l8b(syncTwoWay(sourceProp.m5y(), targetProp));
      return Unit_instance;
    };
  }
  function factBuilders$lambda_1($this) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(ConstantPrecondition_0));
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      rootIndent(result, factBuilders$lambda$lambda_1);
      return this_0;
    };
  }
  function factBuilders$lambda$lambda$lambda$lambda_6(it) {
    return it.wfq();
  }
  function factBuilders$lambda$lambda$lambda$lambda_7($referenceTag) {
    return function (_this__u8e3s4, src, cell, cellAction) {
      var tmp = _this__u8e3s4.d6u($referenceTag);
      var tmp$ret$0 = src.xfq();
      return completion(_this__u8e3s4, tmp, src, tmp$ret$0, cell, VOID, cellAction);
    };
  }
  function factBuilders$lambda$lambda$lambda$lambda$o$get$lambda($cell) {
    return function (it) {
      return signalCompletionHappened($cell, false, it);
    };
  }
  function _no_name_provided__qut3iv_23($refCompletion, $this, $source) {
    this.xtw_1 = $refCompletion;
    this.ytw_1 = $this;
    this.ztw_1 = $source;
    CellTrait.call(this);
  }
  protoOf(_no_name_provided__qut3iv_23).n91 = function (cell, spec) {
    var tmp;
    if (equals(spec, Completion_getInstance().u9d_1)) {
      tmp = this.xtw_1(this.ytw_1, this.ztw_1, cell, factBuilders$lambda$lambda$lambda$lambda$o$get$lambda(cell));
    } else {
      tmp = protoOf(CellTrait).n91.call(this, cell, spec);
    }
    return tmp;
  };
  function factBuilders$lambda$lambda$lambda$lambda_8($refCompletion) {
    return function (_this__u8e3s4, source) {
      return new _no_name_provided__qut3iv_23($refCompletion, _this__u8e3s4, source);
    };
  }
  function factBuilders$lambda$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda$lambda(s) {
    return s.xfq();
  }
  function factBuilders$lambda$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda($property) {
    return function ($this$setup, source, textCell) {
      var referenceTextPropSupplier = getLoopQuerySupplier($property);
      var loopQuery = referenceTextPropSupplier(source, $this$setup.gcq(), textCell);
      $this$setup.l8b(syncOneWay(loopQuery, textCell.o8w()));
      var tmp = getKClass(QualifiedReferenceContent);
      connectWithRefSupport(textCell, loopQuery, tmp, factBuilders$lambda$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda$lambda);
      return Unit_instance;
    };
  }
  function factBuilders$lambda$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_0($refCompletion) {
    return function ($this$completion, _unused_var__etf5q3, textCell, _unused_var__etf5q3_0) {
      var refCompletionArgs = getRefCompletionArgs(textCell);
      var source = refCompletionArgs.gdb_1;
      var cellAction = refCompletionArgs.hdb_1;
      return $refCompletion($this$completion, source, textCell, cellAction);
    };
  }
  function factBuilders$lambda$lambda$lambda$lambda$o$referenceTextProperty$lambda($property, $refCompletion) {
    return function ($this$editableText) {
      $this$editableText.xcp(factBuilders$lambda$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda($property));
      completion_1($this$editableText, factBuilders$lambda$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_0($refCompletion));
      return Unit_instance;
    };
  }
  function _no_name_provided__qut3iv_24($cellBuilder, $refCompletion) {
    this.btx_1 = $refCompletion;
    this.atx_1 = $cellBuilder;
  }
  protoOf(_no_name_provided__qut3iv_24).etv = function (placeholderText, validator, property) {
    return editableText(this, validator, VOID, placeholderText, factBuilders$lambda$lambda$lambda$lambda$o$referenceTextProperty$lambda(property, this.btx_1));
  };
  protoOf(_no_name_provided__qut3iv_24).jcs = function (placeholderText, validator, property) {
    return this.etv(placeholderText, validator, property);
  };
  protoOf(_no_name_provided__qut3iv_24).fcq = function () {
    return this.atx_1.fcq();
  };
  protoOf(_no_name_provided__qut3iv_24).ftv = function (child) {
    this.atx_1.wcp(child);
  };
  protoOf(_no_name_provided__qut3iv_24).wcp = function (child) {
    return this.ftv(child);
  };
  protoOf(_no_name_provided__qut3iv_24).gtv = function (init) {
    this.atx_1.xcp(init);
  };
  protoOf(_no_name_provided__qut3iv_24).xcp = function (init) {
    return this.gtv(init);
  };
  protoOf(_no_name_provided__qut3iv_24).htv = function (init) {
    this.atx_1.ycp(init);
  };
  protoOf(_no_name_provided__qut3iv_24).ycp = function (init) {
    return this.htv(init);
  };
  protoOf(_no_name_provided__qut3iv_24).itv = function (source, cellMap, context) {
    return this.atx_1.acq(source, cellMap, context);
  };
  protoOf(_no_name_provided__qut3iv_24).acq = function (source, cellMap, context) {
    return this.itv((!(source == null) ? isInterface(source, DomainNode) : false) ? source : THROW_CCE(), cellMap, context);
  };
  function factBuilders$lambda$lambda$lambda$lambda$lambda(it) {
    return it.zft();
  }
  function factBuilders$lambda$lambda$lambda$lambda_9($refCompletion) {
    return function ($this$rootIndent) {
      var cellBuilder = $this$rootIndent;
      // Inline function 'jetbrains.ocelot.langDef.editor.getReferenceCellBuilder' call
      var refCompletion = $refCompletion;
      var refCellBuilder = new _no_name_provided__qut3iv_24(cellBuilder, refCompletion);
      refCellBuilder.kcs('<...>', VOID, factBuilders$lambda$lambda$lambda$lambda$lambda);
      return Unit_instance;
    };
  }
  function factBuilders$lambda$lambda$lambda$lambda_10() {
    // Inline function 'kotlin.also' call
    var this_0 = new IndentCell();
    Companion_getInstance_251().vda(this_0);
    return this_0;
  }
  function factBuilders$lambda$lambda$lambda$lambda_11(_unused_var__etf5q3, cell) {
    return get_forQueries(referenceData(cell).jda_1);
  }
  function factBuilders$lambda$lambda$lambda$lambda_12($completionTrait) {
    return function ($this$lambda, source, trait) {
      return CompositeCellTraits_instance.ra6([$completionTrait($this$lambda, source), trait]);
    };
  }
  function factBuilders$lambda$lambda$lambda$lambda_13($this$setup, source, cell) {
    var referenceData_0 = referenceData(cell);
    var tmp$ret$0 = source.xfq();
    referenceData_0.wda(source, tmp$ret$0);
    return Unit_instance;
  }
  function factBuilders$lambda$lambda$lambda$lambda_14($this$setupSynchronizers, source, cell) {
    var tmp0 = $this$setupSynchronizers.gcq();
    // Inline function 'jetbrains.ocelot.langDef.references.synchronizers.getReferenceTargetSync' call
    var asyncTracker = new CellAsyncTracker(cell);
    var referenceData_0 = referenceData(cell);
    var tmp = ReferenceSynchronizers_instance;
    var tmp$ret$0 = source.xfq();
    var tmp$ret$1 = tmp.bdb(tmp0, tmp$ret$0, referenceData_0.jda_1, ResolveKind_LOOSE_getInstance(), null, asyncTracker);
    $this$setupSynchronizers.l8b(tmp$ret$1);
    $this$setupSynchronizers.l8b(getReferenceDataMonitorSynchronizer(cell));
    return Unit_instance;
  }
  function factBuilders$lambda$lambda$lambda$lambda_15($this$setupSynchronizers, source, cell) {
    if ($this$setupSynchronizers.gcq().nd5()) {
      var tmp = $this$setupSynchronizers.gcq();
      var tmp$ret$0 = source.xfq();
      $this$setupSynchronizers.l8b(referenceOutOfScopeSynchronizer(tmp, cell, tmp$ret$0));
      $this$setupSynchronizers.l8b(highlightReferenceTargetOutOfSync(cell, cell.n92(ReferenceCells_getInstance().cdb_1)));
    }
    return Unit_instance;
  }
  function factBuilders$lambda$lambda$lambda_14($this_factBuilders) {
    return function ($this$indent) {
      // Inline function 'jetbrains.ocelot.langDef.editor.ChildBuilder.invoke' call
      // Inline function 'kotlin.also' call
      var this_0 = get_factRefRole($this_factBuilders).s3e();
      this_0.id0(' & ');
      var tmp = this_0;
      children_1($this$indent, tmp, factBuilders$lambda$lambda$lambda$lambda_6);
      space($this$indent);
      // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget' call
      var referenceTag = Companion_getInstance_314().hgb_1;
      var refCompletion = factBuilders$lambda$lambda$lambda$lambda_7(referenceTag);
      var completionTrait = factBuilders$lambda$lambda$lambda$lambda_8(refCompletion);
      // Inline function 'kotlin.also' call
      var this_1 = new SimpleMapperBuilder($this$indent.fcq(), getKClass(ProcessRelationDeclaration_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_1);
      rootIndent(result, factBuilders$lambda$lambda$lambda$lambda_9(refCompletion));
      var mapperBuilder = this_1;
      var tmp0_cellFactory = new NamedCellFactory('referenceData', factBuilders$lambda$lambda$lambda$lambda_10);
      var tmp_0 = factBuilders$lambda$lambda$lambda$lambda_11;
      // Inline function 'kotlin.apply' call
      var this_2 = projectionalChild($this$indent, tmp_0, tmp0_cellFactory, mapperBuilder, '<rel>', factBuilders$lambda$lambda$lambda$lambda_12(completionTrait));
      this_2.xcp(factBuilders$lambda$lambda$lambda$lambda_13);
      this_2.ycp(factBuilders$lambda$lambda$lambda$lambda_14);
      this_2.ycp(factBuilders$lambda$lambda$lambda$lambda_15);
      return Unit_instance;
    };
  }
  function factBuilders$lambda$lambda_2($this_factBuilders) {
    return function ($this$rootIndent) {
      indent($this$rootIndent, VOID, factBuilders$lambda$lambda$lambda_14($this_factBuilders));
      return Unit_instance;
    };
  }
  function factBuilders$lambda_2($this, $this_factBuilders) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(FactPrecondition_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      rootIndent(result, factBuilders$lambda$lambda_2($this_factBuilders));
      return this_0;
    };
  }
  function _get_factRefRole_$lambda_69fbh3($this$completion) {
    return get_factReferenceCompletion($this$completion);
  }
  function _get_factRefRole_$lambda_69fbh3_0($this$default) {
    return FactReference($this$default.l6z());
  }
  function _get_factRefRole_$lambda_69fbh3_1($this$clipboardParametersByCloner) {
    var tmp = new BaseNodeCloneSupport($this$clipboardParametersByCloner.gd3(), get_nodeFactory($this$clipboardParametersByCloner.l6z()));
    return isInterface(tmp, ClonerSupport) ? tmp : THROW_CCE();
  }
  function _get_constantPreconditionCompletion_$lambda_vvyei0($this_constantPreconditionCompletion) {
    return function (it) {
      return ConstantPrecondition_1($this_constantPreconditionCompletion.l6z(), When_ALWAYS_getInstance());
    };
  }
  function _get_constantPreconditionCompletion_$lambda_vvyei0_0($this_constantPreconditionCompletion) {
    return function (it) {
      return ConstantPrecondition_1($this_constantPreconditionCompletion.l6z(), When_NEVER_getInstance());
    };
  }
  function _get_factsPreconditionCompletion_$lambda_dmc8zv($this_factsPreconditionCompletion) {
    return function (it) {
      // Inline function 'kotlin.apply' call
      var this_0 = FactPrecondition($this_factsPreconditionCompletion.l6z());
      this_0.wfq().j(it);
      return this_0;
    };
  }
  function libraryProcessSpecification$lambda($this_libraryProcessSpecification) {
    return function (it) {
      // Inline function 'kotlin.apply' call
      var this_0 = LibraryProcessSpecification($this_libraryProcessSpecification.l6z());
      this_0.vfr().f2x(it);
      return this_0;
    };
  }
  function _get_factReferenceCompletion_$lambda_zifg0b($this_factReferenceCompletion) {
    return function (it) {
      return FactReference_2($this_factReferenceCompletion.l6z(), it);
    };
  }
  function functionLibraryBuilders(_this__u8e3s4) {
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder = new LazyMapperBuilder(functionLibraryBuilders$lambda(_this__u8e3s4));
    _this__u8e3s4.vcr(builder);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_0 = new LazyMapperBuilder(functionLibraryBuilders$lambda_0(_this__u8e3s4, _this__u8e3s4));
    _this__u8e3s4.vcr(builder_0);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_1 = new LazyMapperBuilder(functionLibraryBuilders$lambda_1(_this__u8e3s4));
    _this__u8e3s4.vcr(builder_1);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_2 = new LazyMapperBuilder(functionLibraryBuilders$lambda_2(_this__u8e3s4));
    _this__u8e3s4.vcr(builder_2);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_3 = new LazyMapperBuilder(functionLibraryBuilders$lambda_3(_this__u8e3s4));
    _this__u8e3s4.vcr(builder_3);
  }
  function get_cardinality(_this__u8e3s4) {
    // Inline function 'jetbrains.biokb.lang.builders.nodeRole' call
    // Inline function 'jetbrains.ocelot.langDef.editor.role' call
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.builder' call
    var sourceType = getKClass(Cardinality_1);
    var tmp$ret$0 = _this__u8e3s4.xcr(sourceType);
    var builder = new ChildBuilder(tmp$ret$0);
    builder.gd0('<cardinality>');
    builder.hd0(_get_cardinality_$lambda_c4byyw);
    var simpleClassName = ensureNotNull(getKClass(Cardinality_1).ra());
    builder.kd0(simpleClassName, _get_cardinality_$lambda_c4byyw_0);
    return builder;
  }
  function cardinalityConstantCompletion(_this__u8e3s4) {
    var tmp = intRoleCompletion();
    return map_2(tmp, cardinalityConstantCompletion$lambda(_this__u8e3s4));
  }
  function cardinalityBoundCompletion(_this__u8e3s4) {
    return plus_14(cardinalityConstantCompletion(_this__u8e3s4), cardinalityNCompletion(_this__u8e3s4));
  }
  function cardinalityNCompletion(_this__u8e3s4) {
    return simpleCompletion(listOf(produces('n', cardinalityNCompletion$lambda(_this__u8e3s4))));
  }
  function functionTermCompletion(_this__u8e3s4) {
    var tmp = nodeRefCompletion(_this__u8e3s4, Companion_getInstance_326().kgf_1);
    return map_2(tmp, functionTermCompletion$lambda(_this__u8e3s4));
  }
  function functionLibraryBuilders$lambda$lambda(it) {
    return it.hfr();
  }
  function functionLibraryBuilders$lambda$lambda_0(it) {
    return CellLists_instance.taa(it);
  }
  function functionLibraryBuilders$lambda$lambda_1($this$indentChildren) {
    defaultItem($this$indentChildren, functionLibraryBuilders$lambda$lambda$lambda);
    return Unit_instance;
  }
  function functionLibraryBuilders$lambda$lambda$lambda($this$defaultItem) {
    return FunctionDeclaration($this$defaultItem.l6z());
  }
  function functionLibraryBuilders$lambda($this) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(FunctionLibrary_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      var tmp2 = functionLibraryBuilders$lambda$lambda;
      var tmp4 = functionLibraryBuilders$lambda$lambda_0;
      // Inline function 'jetbrains.ocelot.langDef.editor.indentChildren' call
      var init = functionLibraryBuilders$lambda$lambda_1;
      // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.builder' call
      var this_1 = result.fcq();
      var sourceType = getKClass(FunctionDeclaration_1);
      var tmp$ret$0 = this_1.xcr(sourceType);
      indentChildren(result, tmp2, tmp$ret$0, null, tmp4, init);
      return this_0;
    };
  }
  function functionLibraryBuilders$lambda$lambda$lambda_0(it) {
    return it.y2();
  }
  function functionLibraryBuilders$lambda$lambda$lambda$lambda($this$horizontal) {
    bindingEntries($this$horizontal, VOID, functionLibraryBuilders$lambda$lambda$lambda$lambda$lambda);
    return Unit_instance;
  }
  function functionLibraryBuilders$lambda$lambda$lambda$lambda$lambda(it) {
    return it.y();
  }
  function functionLibraryBuilders$lambda$lambda$lambda$lambda_0(it) {
    return it.gfr();
  }
  function functionLibraryBuilders$lambda$lambda$lambda$lambda_1(it) {
    return it.dfr();
  }
  function functionLibraryBuilders$lambda$lambda$lambda_1($this_functionLibraryBuilders) {
    return function ($this$indent) {
      newLine($this$indent);
      keyword($this$indent, 'parameters');
      space($this$indent);
      horizontal($this$indent, functionLibraryBuilders$lambda$lambda$lambda$lambda);
      newLine($this$indent);
      keyword($this$indent, 'returns');
      space($this$indent);
      var tmp = get_ontologyElementTypeRole($this_functionLibraryBuilders);
      child_0($this$indent, tmp, functionLibraryBuilders$lambda$lambda$lambda$lambda_0);
      space($this$indent);
      var tmp_0 = get_cardinality($this_functionLibraryBuilders);
      child_0($this$indent, tmp_0, functionLibraryBuilders$lambda$lambda$lambda$lambda_1);
      return Unit_instance;
    };
  }
  function functionLibraryBuilders$lambda$lambda_2($this_functionLibraryBuilders) {
    return function ($this$rootIndent) {
      keyword($this$rootIndent, 'function');
      space($this$rootIndent);
      textProperty($this$rootIndent, '<name>', functionLibraryBuilders$lambda$lambda$lambda_0);
      indent($this$rootIndent, true, functionLibraryBuilders$lambda$lambda$lambda_1($this_functionLibraryBuilders));
      return Unit_instance;
    };
  }
  function functionLibraryBuilders$lambda_0($this, $this_functionLibraryBuilders) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(FunctionDeclaration_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      rootIndent(result, functionLibraryBuilders$lambda$lambda_2($this_functionLibraryBuilders));
      return this_0;
    };
  }
  function functionLibraryBuilders$lambda$lambda_3($this$rootIndent) {
    indentLabel($this$rootIndent, '[');
    var tmp2 = functionLibraryBuilders$lambda$lambda$lambda_2;
    // Inline function 'jetbrains.ocelot.langDef.editor.indentChild' call
    var init = functionLibraryBuilders$lambda$lambda$lambda_3;
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.builder' call
    var this_0 = $this$rootIndent.fcq();
    var sourceType = getKClass(CardinalityBoundConstant_1);
    var tmp$ret$0 = this_0.xcr(sourceType);
    indentChild($this$rootIndent, tmp2, tmp$ret$0, '<bound>', init);
    indentLabel($this$rootIndent, '..');
    var tmp2_0 = functionLibraryBuilders$lambda$lambda$lambda_4;
    // Inline function 'jetbrains.ocelot.langDef.editor.indentChild' call
    var init_0 = functionLibraryBuilders$lambda$lambda$lambda_5;
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.builder' call
    var this_1 = $this$rootIndent.fcq();
    var sourceType_0 = getKClass(CardinalityBoundPlaceholder_1);
    var tmp$ret$2 = this_1.xcr(sourceType_0);
    indentChild($this$rootIndent, tmp2_0, tmp$ret$2, '<bound>', init_0);
    indentLabel($this$rootIndent, ']', true);
    return Unit_instance;
  }
  function functionLibraryBuilders$lambda$lambda$lambda_2(it) {
    return it.bfq();
  }
  function functionLibraryBuilders$lambda$lambda$lambda_3($this$indentChild) {
    $this$indentChild.mct(functionLibraryBuilders$lambda$lambda$lambda$lambda_2);
    return Unit_instance;
  }
  function functionLibraryBuilders$lambda$lambda$lambda$lambda_2($this$completion) {
    return cardinalityConstantCompletion($this$completion);
  }
  function functionLibraryBuilders$lambda$lambda$lambda_4(it) {
    return it.cfq();
  }
  function functionLibraryBuilders$lambda$lambda$lambda_5($this$indentChild) {
    $this$indentChild.mct(functionLibraryBuilders$lambda$lambda$lambda$lambda_3);
    return Unit_instance;
  }
  function functionLibraryBuilders$lambda$lambda$lambda$lambda_3($this$completion) {
    var tmp = cardinalityBoundCompletion($this$completion);
    return map_2(tmp, functionLibraryBuilders$lambda$lambda$lambda$lambda$lambda_0($this$completion));
  }
  function functionLibraryBuilders$lambda$lambda$lambda$lambda$lambda_0($this_completion) {
    return function (it) {
      // Inline function 'kotlin.apply' call
      var this_0 = CardinalityBoundPlaceholder($this_completion.l6z());
      this_0.efq().f2x(it);
      return this_0;
    };
  }
  function functionLibraryBuilders$lambda_1($this) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(Cardinality_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      rootIndent(result, functionLibraryBuilders$lambda$lambda_3);
      return this_0;
    };
  }
  function functionLibraryBuilders$lambda$lambda_4($this$rootIndent) {
    integerProperty($this$rootIndent, '<...>', functionLibraryBuilders$lambda$lambda$lambda_6);
    return Unit_instance;
  }
  function functionLibraryBuilders$lambda$lambda$lambda_6(it) {
    return it.a1();
  }
  function functionLibraryBuilders$lambda_2($this) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(CardinalityBoundConstant_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      rootIndent(result, functionLibraryBuilders$lambda$lambda_4);
      return this_0;
    };
  }
  function functionLibraryBuilders$lambda_3($this) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(CardinalityBoundN_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      keyword(result, 'n');
      return this_0;
    };
  }
  function _get_cardinality_$lambda_c4byyw($this$default) {
    return Cardinality($this$default.l6z());
  }
  function _get_cardinality_$lambda_c4byyw_0($this$clipboardParametersByCloner) {
    var tmp = new BaseNodeCloneSupport($this$clipboardParametersByCloner.gd3(), get_nodeFactory($this$clipboardParametersByCloner.l6z()));
    return isInterface(tmp, ClonerSupport) ? tmp : THROW_CCE();
  }
  function cardinalityConstantCompletion$lambda($this_cardinalityConstantCompletion) {
    return function (it) {
      // Inline function 'kotlin.apply' call
      var this_0 = CardinalityBoundConstant($this_cardinalityConstantCompletion.l6z());
      this_0.a1().f2x(it);
      return this_0;
    };
  }
  function cardinalityNCompletion$lambda($this_cardinalityNCompletion) {
    return function (it) {
      return CardinalityBoundN($this_cardinalityNCompletion.l6z());
    };
  }
  function functionTermCompletion$lambda($this_functionTermCompletion) {
    return function (it) {
      // Inline function 'kotlin.apply' call
      var this_0 = FunctionTerm($this_functionTermCompletion.l6z());
      this_0.ifr().f2x(it);
      return this_0;
    };
  }
  function ontologyImportRootBuilders(_this__u8e3s4) {
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder = new LazyMapperBuilder(ontologyImportRootBuilders$lambda(_this__u8e3s4));
    _this__u8e3s4.vcr(builder);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_0 = new LazyMapperBuilder(ontologyImportRootBuilders$lambda_0(_this__u8e3s4));
    _this__u8e3s4.vcr(builder_0);
  }
  function ontologyImportRootBuilders$lambda$lambda(it) {
    return it.zfp();
  }
  function ontologyImportRootBuilders$lambda$lambda_0(it) {
    return CellLists_instance.taa(it);
  }
  function ontologyImportRootBuilders$lambda$lambda_1($this$indentChildren) {
    defaultItem($this$indentChildren, ontologyImportRootBuilders$lambda$lambda$lambda);
    return Unit_instance;
  }
  function ontologyImportRootBuilders$lambda$lambda$lambda($this$defaultItem) {
    return OntologyImport($this$defaultItem.l6z());
  }
  function ontologyImportRootBuilders$lambda($this) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(OntologyImportRoot_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      var tmp2 = ontologyImportRootBuilders$lambda$lambda;
      var tmp4 = '<imports>';
      var tmp6 = ontologyImportRootBuilders$lambda$lambda_0;
      // Inline function 'jetbrains.ocelot.langDef.editor.indentChildren' call
      var init = ontologyImportRootBuilders$lambda$lambda_1;
      // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.builder' call
      var this_1 = result.fcq();
      var sourceType = getKClass(OntologyImport_1);
      var tmp$ret$0 = this_1.xcr(sourceType);
      indentChildren(result, tmp2, tmp$ret$0, tmp4, tmp6, init);
      return this_0;
    };
  }
  function ontologyImportRootBuilders$lambda$lambda_2($this$rootIndent) {
    keyword($this$rootIndent, 'for');
    space($this$rootIndent);
    var tmp2 = ontologyImportRootBuilders$lambda$lambda$lambda_0;
    var tmp4 = '<ontology>';
    // Inline function 'jetbrains.ocelot.langDef.editor.indentChild' call
    var init = ontologyImportRootBuilders$lambda$lambda$lambda_1;
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.builder' call
    var this_0 = $this$rootIndent.fcq();
    var sourceType = getKClass(OntologyLibraryReference_1);
    var tmp$ret$0 = this_0.xcr(sourceType);
    indentChild($this$rootIndent, tmp2, tmp$ret$0, tmp4, init);
    indentLabel($this$rootIndent, '/');
    var tmp2_0 = ontologyImportRootBuilders$lambda$lambda$lambda_2;
    var tmp4_0 = '<element>';
    // Inline function 'jetbrains.ocelot.langDef.editor.indentChild' call
    var init_0 = ontologyImportRootBuilders$lambda$lambda$lambda_3;
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.builder' call
    var this_1 = $this$rootIndent.fcq();
    var sourceType_0 = getKClass(OntologyElementReference_1);
    var tmp$ret$2 = this_1.xcr(sourceType_0);
    indentChild($this$rootIndent, tmp2_0, tmp$ret$2, tmp4_0, init_0);
    space($this$rootIndent);
    keyword($this$rootIndent, 'use');
    space($this$rootIndent);
    var tmp2_1 = ontologyImportRootBuilders$lambda$lambda$lambda_4;
    var tmp4_1 = '<library to use>';
    // Inline function 'jetbrains.ocelot.langDef.editor.indentChild' call
    var init_1 = ontologyImportRootBuilders$lambda$lambda$lambda_5;
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.builder' call
    var this_2 = $this$rootIndent.fcq();
    var sourceType_1 = getKClass(OntologyLibraryReference_1);
    var tmp$ret$4 = this_2.xcr(sourceType_1);
    indentChild($this$rootIndent, tmp2_1, tmp$ret$4, tmp4_1, init_1);
    return Unit_instance;
  }
  function ontologyImportRootBuilders$lambda$lambda$lambda_0(it) {
    return it.xfs();
  }
  function ontologyImportRootBuilders$lambda$lambda$lambda_1($this$indentChild) {
    $this$indentChild.mct(ontologyImportRootBuilders$lambda$lambda$lambda$lambda);
    return Unit_instance;
  }
  function ontologyImportRootBuilders$lambda$lambda$lambda$lambda($this$completion) {
    var tmp = nodeRefCompletion($this$completion, Companion_getInstance_335().dh6_1);
    return map_2(tmp, ontologyImportRootBuilders$lambda$lambda$lambda$lambda$lambda($this$completion));
  }
  function ontologyImportRootBuilders$lambda$lambda$lambda$lambda$lambda($this_completion) {
    return function (it) {
      // Inline function 'kotlin.apply' call
      var this_0 = OntologyLibraryReference($this_completion.l6z());
      this_0.yfq().f2x(it);
      return this_0;
    };
  }
  function ontologyImportRootBuilders$lambda$lambda$lambda_2(it) {
    return it.gfq();
  }
  function ontologyImportRootBuilders$lambda$lambda$lambda_3($this$indentChild) {
    $this$indentChild.mct(ontologyImportRootBuilders$lambda$lambda$lambda$lambda_0);
    return Unit_instance;
  }
  function ontologyImportRootBuilders$lambda$lambda$lambda$lambda_0($this$completion) {
    var tmp = nodeRefCompletion($this$completion, Companion_getInstance_336().fh1_1);
    return map_2(tmp, ontologyImportRootBuilders$lambda$lambda$lambda$lambda$lambda_0($this$completion));
  }
  function ontologyImportRootBuilders$lambda$lambda$lambda$lambda$lambda_0($this_completion) {
    return function (it) {
      // Inline function 'kotlin.apply' call
      var this_0 = OntologyElementReference($this_completion.l6z());
      this_0.gfq().f2x(it);
      return this_0;
    };
  }
  function ontologyImportRootBuilders$lambda$lambda$lambda_4(it) {
    return it.yfs();
  }
  function ontologyImportRootBuilders$lambda$lambda$lambda_5($this$indentChild) {
    $this$indentChild.mct(ontologyImportRootBuilders$lambda$lambda$lambda$lambda_1);
    return Unit_instance;
  }
  function ontologyImportRootBuilders$lambda$lambda$lambda$lambda_1($this$completion) {
    var tmp = nodeRefCompletion($this$completion, Companion_getInstance_335().dh6_1);
    return map_2(tmp, ontologyImportRootBuilders$lambda$lambda$lambda$lambda$lambda_1($this$completion));
  }
  function ontologyImportRootBuilders$lambda$lambda$lambda$lambda$lambda_1($this_completion) {
    return function (it) {
      // Inline function 'kotlin.apply' call
      var this_0 = OntologyLibraryReference($this_completion.l6z());
      this_0.yfq().f2x(it);
      return this_0;
    };
  }
  function ontologyImportRootBuilders$lambda_0($this) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(OntologyImport_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      rootIndent(result, ontologyImportRootBuilders$lambda$lambda_2);
      return this_0;
    };
  }
  function linkLibraryBuilders(_this__u8e3s4) {
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder = new LazyMapperBuilder(linkLibraryBuilders$lambda(_this__u8e3s4));
    _this__u8e3s4.vcr(builder);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_0 = new LazyMapperBuilder(linkLibraryBuilders$lambda_0(_this__u8e3s4, _this__u8e3s4));
    _this__u8e3s4.vcr(builder_0);
  }
  function linkLibraryBuilders$lambda$lambda(it) {
    return it.wfr();
  }
  function linkLibraryBuilders$lambda$lambda_0(it) {
    return CellLists_instance.taa(it);
  }
  function linkLibraryBuilders$lambda$lambda_1($this$indentChildren) {
    defaultItem($this$indentChildren, linkLibraryBuilders$lambda$lambda$lambda);
    return Unit_instance;
  }
  function linkLibraryBuilders$lambda$lambda$lambda($this$defaultItem) {
    return LinkDeclaration($this$defaultItem.l6z());
  }
  function linkLibraryBuilders$lambda($this) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(LinkLibrary_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      var tmp2 = linkLibraryBuilders$lambda$lambda;
      var tmp4 = linkLibraryBuilders$lambda$lambda_0;
      // Inline function 'jetbrains.ocelot.langDef.editor.indentChildren' call
      var init = linkLibraryBuilders$lambda$lambda_1;
      // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.builder' call
      var this_1 = result.fcq();
      var sourceType = getKClass(LinkDeclaration_1);
      var tmp$ret$0 = this_1.xcr(sourceType);
      indentChildren(result, tmp2, tmp$ret$0, null, tmp4, init);
      return this_0;
    };
  }
  function linkLibraryBuilders$lambda$lambda$lambda_0(it) {
    return it.y2();
  }
  function linkLibraryBuilders$lambda$lambda$lambda_1($this$editableText) {
    // Inline function 'jetbrains.ocelot.langDef.editor.enumSyncTwoWay' call
    var targetPropFactory = linkLibraryBuilders$lambda$lambda$lambda$lambda;
    // Inline function 'jetbrains.ocelot.langDef.editor.textCellSyncTwoWay' call
    $this$editableText.xcp(linkLibraryBuilders$lambda$lambda$lambda$lambda_0(targetPropFactory));
    return Unit_instance;
  }
  function linkLibraryBuilders$lambda$lambda$lambda$lambda(textCell) {
    // Inline function 'jetbrains.ocelot.base.enums.EnumInfoFactory.createEnumInfo' call
    // Inline function 'kotlin.enumValues' call
    var tmp$ret$0 = values_14();
    var enumInfo = new EnumInfoImpl(tmp$ret$0);
    return ValueEditors_instance.uag(textCell, enumInfo);
  }
  function linkLibraryBuilders$lambda$lambda$lambda$lambda_0($targetPropFactory) {
    return function ($this$setup, source, textCell) {
      var sourceProp = source.jfr();
      var targetProp = $targetPropFactory(textCell);
      $this$setup.l8b(syncTwoWay(sourceProp.m5y(), targetProp));
      return Unit_instance;
    };
  }
  function linkLibraryBuilders$lambda$lambda$lambda_2(it) {
    return it.sfq();
  }
  function linkLibraryBuilders$lambda$lambda_2($this_linkLibraryBuilders) {
    return function ($this$rootIndent) {
      textProperty($this$rootIndent, '<name>', linkLibraryBuilders$lambda$lambda$lambda_0);
      space($this$rootIndent);
      label($this$rootIndent, ':');
      space($this$rootIndent);
      // Inline function 'jetbrains.ocelot.langDef.editor.enumProperty' call
      editableText($this$rootIndent, VOID, VOID, '<spec>', linkLibraryBuilders$lambda$lambda$lambda_1);
      indentLabel($this$rootIndent, '(');
      var tmp = get_ontologyElementTypeRole($this_linkLibraryBuilders);
      child_0($this$rootIndent, tmp, linkLibraryBuilders$lambda$lambda$lambda_2);
      indentLabel($this$rootIndent, ')', true);
      return Unit_instance;
    };
  }
  function linkLibraryBuilders$lambda_0($this, $this_linkLibraryBuilders) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(LinkDeclaration_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      rootIndent(result, linkLibraryBuilders$lambda$lambda_2($this_linkLibraryBuilders));
      return this_0;
    };
  }
  function notionLibraryBuilders(_this__u8e3s4) {
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder = new LazyMapperBuilder(notionLibraryBuilders$lambda(_this__u8e3s4, _this__u8e3s4));
    _this__u8e3s4.vcr(builder);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_0 = new LazyMapperBuilder(notionLibraryBuilders$lambda_0(_this__u8e3s4));
    _this__u8e3s4.vcr(builder_0);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_1 = new LazyMapperBuilder(notionLibraryBuilders$lambda_1(_this__u8e3s4));
    _this__u8e3s4.vcr(builder_1);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_2 = new LazyMapperBuilder(notionLibraryBuilders$lambda_2(_this__u8e3s4));
    _this__u8e3s4.vcr(builder_2);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_3 = new LazyMapperBuilder(notionLibraryBuilders$lambda_3(_this__u8e3s4));
    _this__u8e3s4.vcr(builder_3);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_4 = new LazyMapperBuilder(notionLibraryBuilders$lambda_4(_this__u8e3s4));
    _this__u8e3s4.vcr(builder_4);
  }
  function get_notionsRole(_this__u8e3s4) {
    // Inline function 'jetbrains.biokb.lang.builders.nodeRole' call
    // Inline function 'jetbrains.ocelot.langDef.editor.role' call
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.builder' call
    var sourceType = getKClass(AbstractNotion);
    var tmp$ret$0 = _this__u8e3s4.xcr(sourceType);
    var builder = new ChildBuilder(tmp$ret$0);
    builder.jd0();
    builder.gd0('<notions>');
    builder.fd0(_get_notionsRole_$lambda_bffgy6);
    builder.hd0(_get_notionsRole_$lambda_bffgy6_0);
    var simpleClassName = ensureNotNull(getKClass(AbstractNotion).ra());
    builder.kd0(simpleClassName, _get_notionsRole_$lambda_bffgy6_1);
    return builder;
  }
  function notionLibraryBuilders$lambda$lambda$lambda(it) {
    return it.efs();
  }
  function notionLibraryBuilders$lambda$lambda($this_notionLibraryBuilders) {
    return function ($this$indent) {
      var tmp = get_notionsRole($this_notionLibraryBuilders);
      children_1($this$indent, tmp, notionLibraryBuilders$lambda$lambda$lambda);
      return Unit_instance;
    };
  }
  function notionLibraryBuilders$lambda($this, $this_notionLibraryBuilders) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(NotionLibrary_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      indent(result, VOID, notionLibraryBuilders$lambda$lambda($this_notionLibraryBuilders));
      return this_0;
    };
  }
  function notionLibraryBuilders$lambda$lambda_0($this$rootIndent) {
    keyword($this$rootIndent, 'enumerable notion');
    space($this$rootIndent);
    textProperty($this$rootIndent, '<name>', notionLibraryBuilders$lambda$lambda$lambda_0);
    indent($this$rootIndent, true, notionLibraryBuilders$lambda$lambda$lambda_1);
    return Unit_instance;
  }
  function notionLibraryBuilders$lambda$lambda$lambda_0(it) {
    return it.y2();
  }
  function notionLibraryBuilders$lambda$lambda$lambda_1($this$indent) {
    newLine($this$indent);
    keyword($this$indent, 'values:');
    space($this$indent);
    var tmp2 = notionLibraryBuilders$lambda$lambda$lambda$lambda;
    var tmp6 = notionLibraryBuilders$lambda$lambda$lambda$lambda_0;
    // Inline function 'jetbrains.ocelot.langDef.editor.indentChildren' call
    var init = notionLibraryBuilders$lambda$lambda$lambda$lambda_1;
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.builder' call
    var this_0 = $this$indent.fcq();
    var sourceType = getKClass(EnumerationConstant_1);
    var tmp$ret$0 = this_0.xcr(sourceType);
    indentChildren($this$indent, tmp2, tmp$ret$0, '<units>', tmp6, init);
    return Unit_instance;
  }
  function notionLibraryBuilders$lambda$lambda$lambda$lambda(it) {
    return it.qfq();
  }
  function notionLibraryBuilders$lambda$lambda$lambda$lambda_0(it) {
    return CellLists_instance.saa(it, ', ');
  }
  function notionLibraryBuilders$lambda$lambda$lambda$lambda_1($this$indentChildren) {
    defaultItem($this$indentChildren, notionLibraryBuilders$lambda$lambda$lambda$lambda$lambda);
    return Unit_instance;
  }
  function notionLibraryBuilders$lambda$lambda$lambda$lambda$lambda($this$defaultItem) {
    return EnumerationConstant($this$defaultItem.l6z());
  }
  function notionLibraryBuilders$lambda_0($this) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(EnumerableNotion_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      rootIndent(result, notionLibraryBuilders$lambda$lambda_0);
      return this_0;
    };
  }
  function notionLibraryBuilders$lambda$lambda_1($this$rootIndent) {
    keyword($this$rootIndent, 'measurable notion');
    space($this$rootIndent);
    textProperty($this$rootIndent, '<name>', notionLibraryBuilders$lambda$lambda$lambda_2);
    indent($this$rootIndent, true, notionLibraryBuilders$lambda$lambda$lambda_3);
    return Unit_instance;
  }
  function notionLibraryBuilders$lambda$lambda$lambda_2(it) {
    return it.y2();
  }
  function notionLibraryBuilders$lambda$lambda$lambda_3($this$indent) {
    newLine($this$indent);
    keyword($this$indent, 'measured in:');
    space($this$indent);
    var tmp2 = notionLibraryBuilders$lambda$lambda$lambda$lambda_2;
    var tmp6 = notionLibraryBuilders$lambda$lambda$lambda$lambda_3;
    // Inline function 'jetbrains.ocelot.langDef.editor.indentChildren' call
    var init = notionLibraryBuilders$lambda$lambda$lambda$lambda_4;
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.builder' call
    var this_0 = $this$indent.fcq();
    var sourceType = getKClass(MeasurementUnit_1);
    var tmp$ret$0 = this_0.xcr(sourceType);
    indentChildren($this$indent, tmp2, tmp$ret$0, '<units>', tmp6, init);
    return Unit_instance;
  }
  function notionLibraryBuilders$lambda$lambda$lambda$lambda_2(it) {
    return it.xfr();
  }
  function notionLibraryBuilders$lambda$lambda$lambda$lambda_3(it) {
    return CellLists_instance.saa(it, ', ');
  }
  function notionLibraryBuilders$lambda$lambda$lambda$lambda_4($this$indentChildren) {
    defaultItem($this$indentChildren, notionLibraryBuilders$lambda$lambda$lambda$lambda$lambda_0);
    return Unit_instance;
  }
  function notionLibraryBuilders$lambda$lambda$lambda$lambda$lambda_0($this$defaultItem) {
    return MeasurementUnit($this$defaultItem.l6z());
  }
  function notionLibraryBuilders$lambda_1($this) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(MeasurableNotion_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      rootIndent(result, notionLibraryBuilders$lambda$lambda_1);
      return this_0;
    };
  }
  function notionLibraryBuilders$lambda$lambda_2($this$rootIndent) {
    textProperty($this$rootIndent, '<name>', notionLibraryBuilders$lambda$lambda$lambda_4);
    return Unit_instance;
  }
  function notionLibraryBuilders$lambda$lambda$lambda_4(it) {
    return it.y2();
  }
  function notionLibraryBuilders$lambda_2($this) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(MeasurementUnit_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      rootIndent(result, notionLibraryBuilders$lambda$lambda_2);
      return this_0;
    };
  }
  function notionLibraryBuilders$lambda$lambda_3($this$rootIndent) {
    textProperty($this$rootIndent, '<name>', notionLibraryBuilders$lambda$lambda$lambda_5);
    return Unit_instance;
  }
  function notionLibraryBuilders$lambda$lambda$lambda_5(it) {
    return it.y2();
  }
  function notionLibraryBuilders$lambda_3($this) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(EnumerationConstant_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      rootIndent(result, notionLibraryBuilders$lambda$lambda_3);
      return this_0;
    };
  }
  function notionLibraryBuilders$lambda$lambda_4($this$rootIndent) {
    label($this$rootIndent, '');
    return Unit_instance;
  }
  function notionLibraryBuilders$lambda_4($this) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(NotionPlaceholder_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      rootIndent(result, notionLibraryBuilders$lambda$lambda_4);
      return this_0;
    };
  }
  function _get_notionsRole_$lambda_bffgy6($this$completion) {
    var tmp = produces('enumerable notion', _get_notionsRole_$lambda$lambda_h77l2b($this$completion));
    return simpleCompletion(listOf_0([tmp, produces('measurable notion', _get_notionsRole_$lambda$lambda_h77l2b_0($this$completion))]));
  }
  function _get_notionsRole_$lambda$lambda_h77l2b($this_completion) {
    return function (it) {
      return EnumerableNotion($this_completion.l6z());
    };
  }
  function _get_notionsRole_$lambda$lambda_h77l2b_0($this_completion) {
    return function (it) {
      return MeasurableNotion($this_completion.l6z());
    };
  }
  function _get_notionsRole_$lambda_bffgy6_0($this$default) {
    return NotionPlaceholder($this$default.l6z());
  }
  function _get_notionsRole_$lambda_bffgy6_1($this$clipboardParametersByCloner) {
    var tmp = new BaseNodeCloneSupport($this$clipboardParametersByCloner.gd3(), get_nodeFactory($this$clipboardParametersByCloner.l6z()));
    return isInterface(tmp, ClonerSupport) ? tmp : THROW_CCE();
  }
  function ontologyLibraryBuilders(_this__u8e3s4) {
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder = new LazyMapperBuilder(ontologyLibraryBuilders$lambda(_this__u8e3s4, _this__u8e3s4));
    _this__u8e3s4.vcr(builder);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_0 = new LazyMapperBuilder(ontologyLibraryBuilders$lambda_0(_this__u8e3s4, _this__u8e3s4));
    _this__u8e3s4.vcr(builder_0);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_1 = new LazyMapperBuilder(ontologyLibraryBuilders$lambda_1(_this__u8e3s4, _this__u8e3s4));
    _this__u8e3s4.vcr(builder_1);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_2 = new LazyMapperBuilder(ontologyLibraryBuilders$lambda_2(_this__u8e3s4, _this__u8e3s4));
    _this__u8e3s4.vcr(builder_2);
  }
  function get_ontologyElements(_this__u8e3s4) {
    // Inline function 'jetbrains.biokb.lang.builders.nodeRole' call
    // Inline function 'jetbrains.ocelot.langDef.editor.role' call
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.builder' call
    var sourceType = getKClass(OntologyElement_1);
    var tmp$ret$0 = _this__u8e3s4.xcr(sourceType);
    var builder = new ChildBuilder(tmp$ret$0);
    builder.jd0();
    builder.hd0(_get_ontologyElements_$lambda_30svkq);
    var simpleClassName = ensureNotNull(getKClass(OntologyElement_1).ra());
    builder.kd0(simpleClassName, _get_ontologyElements_$lambda_30svkq_0);
    return builder;
  }
  function get_ontologyIsRelations(_this__u8e3s4) {
    // Inline function 'jetbrains.biokb.lang.builders.nodeRole' call
    // Inline function 'jetbrains.ocelot.langDef.editor.role' call
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.builder' call
    var sourceType = getKClass(OntologyIsRelation_1);
    var tmp$ret$0 = _this__u8e3s4.xcr(sourceType);
    var builder = new ChildBuilder(tmp$ret$0);
    builder.fd0(_get_ontologyIsRelations_$lambda_reypwo);
    builder.hd0(_get_ontologyIsRelations_$lambda_reypwo_0);
    var simpleClassName = ensureNotNull(getKClass(OntologyIsRelation_1).ra());
    builder.kd0(simpleClassName, _get_ontologyIsRelations_$lambda_reypwo_1);
    return builder;
  }
  function get_ontologyCardinalityRelations(_this__u8e3s4) {
    // Inline function 'jetbrains.biokb.lang.builders.nodeRole' call
    // Inline function 'jetbrains.ocelot.langDef.editor.role' call
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.builder' call
    var sourceType = getKClass(OntologyCardinalityRelation_1);
    var tmp$ret$0 = _this__u8e3s4.xcr(sourceType);
    var builder = new ChildBuilder(tmp$ret$0);
    builder.fd0(_get_ontologyCardinalityRelations_$lambda_6r4c08);
    builder.hd0(_get_ontologyCardinalityRelations_$lambda_6r4c08_0);
    var simpleClassName = ensureNotNull(getKClass(OntologyCardinalityRelation_1).ra());
    builder.kd0(simpleClassName, _get_ontologyCardinalityRelations_$lambda_6r4c08_1);
    return builder;
  }
  function get_localOntologyElementReferenceProvider(_this__u8e3s4) {
    // Inline function 'jetbrains.biokb.lang.builders.nodeRole' call
    // Inline function 'jetbrains.ocelot.langDef.editor.role' call
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.builder' call
    var sourceType = getKClass(OntologyElementReferenceProvider);
    var tmp$ret$0 = _this__u8e3s4.xcr(sourceType);
    var builder = new ChildBuilder(tmp$ret$0);
    builder.gd0('<element reference>');
    builder.hd0(_get_localOntologyElementReferenceProvider_$lambda_89ybp0);
    var simpleClassName = ensureNotNull(getKClass(OntologyElementReferenceProvider).ra());
    builder.kd0(simpleClassName, _get_localOntologyElementReferenceProvider_$lambda_89ybp0_0);
    return builder;
  }
  function get_classExpressionProvider(_this__u8e3s4) {
    // Inline function 'jetbrains.biokb.lang.builders.nodeRole' call
    // Inline function 'jetbrains.ocelot.langDef.editor.role' call
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.builder' call
    var sourceType = getKClass(ClassExpression);
    var tmp$ret$0 = _this__u8e3s4.xcr(sourceType);
    var builder = new ChildBuilder(tmp$ret$0);
    builder.gd0('<element reference>');
    builder.hd0(_get_classExpressionProvider_$lambda_8nvv2d);
    var simpleClassName = ensureNotNull(getKClass(ClassExpression).ra());
    builder.kd0(simpleClassName, _get_classExpressionProvider_$lambda_8nvv2d_0);
    return builder;
  }
  function relationCompletion(_this__u8e3s4, factory) {
    var tmp = nodeRefCompletion(_this__u8e3s4, Companion_getInstance_337().pgo_1);
    var tmp_0 = map_2(tmp, relationCompletion$lambda(factory, _this__u8e3s4));
    var tmp_1 = nodeRefCompletion(_this__u8e3s4, Companion_getInstance_335().dh6_1);
    return plus_14(tmp_0, map_2(tmp_1, relationCompletion$lambda_0(factory, _this__u8e3s4)));
  }
  function ontologyLibraryBuilders$lambda$lambda$lambda(it) {
    return it.ifq();
  }
  function ontologyLibraryBuilders$lambda$lambda($this_ontologyLibraryBuilders) {
    return function ($this$indent) {
      // Inline function 'jetbrains.ocelot.langDef.editor.ChildBuilder.invoke' call
      // Inline function 'kotlin.also' call
      var this_0 = get_ontologyElements($this_ontologyLibraryBuilders).s3e();
      this_0.gd0('<elements>');
      var tmp = this_0;
      children_1($this$indent, tmp, ontologyLibraryBuilders$lambda$lambda$lambda);
      return Unit_instance;
    };
  }
  function ontologyLibraryBuilders$lambda($this, $this_ontologyLibraryBuilders) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(OntologyLibrary_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      indent(result, VOID, ontologyLibraryBuilders$lambda$lambda($this_ontologyLibraryBuilders));
      return this_0;
    };
  }
  function ontologyLibraryBuilders$lambda$lambda$lambda_0(it) {
    return it.y2();
  }
  function ontologyLibraryBuilders$lambda$lambda$lambda$lambda(it) {
    return it.nfs();
  }
  function ontologyLibraryBuilders$lambda$lambda$lambda_1($this_ontologyLibraryBuilders) {
    return function ($this$indent) {
      newLine($this$indent);
      keyword($this$indent, 'super types:');
      space($this$indent);
      // Inline function 'jetbrains.ocelot.langDef.editor.ChildBuilder.invoke' call
      // Inline function 'kotlin.also' call
      var this_0 = get_ontologyIsRelations($this_ontologyLibraryBuilders).s3e();
      this_0.gd0('<super elements>');
      this_0.id0(', ');
      var tmp = this_0;
      children_1($this$indent, tmp, ontologyLibraryBuilders$lambda$lambda$lambda$lambda);
      return Unit_instance;
    };
  }
  function ontologyLibraryBuilders$lambda$lambda$lambda$lambda_0(it) {
    return it.ofs();
  }
  function ontologyLibraryBuilders$lambda$lambda$lambda_2($this_ontologyLibraryBuilders) {
    return function ($this$indent) {
      newLine($this$indent);
      keyword($this$indent, 'is part of:');
      space($this$indent);
      // Inline function 'jetbrains.ocelot.langDef.editor.ChildBuilder.invoke' call
      // Inline function 'kotlin.also' call
      var this_0 = get_ontologyCardinalityRelations($this_ontologyLibraryBuilders).s3e();
      this_0.gd0('<enclosing elements>');
      this_0.id0(', ');
      var tmp = this_0;
      children_1($this$indent, tmp, ontologyLibraryBuilders$lambda$lambda$lambda$lambda_0);
      return Unit_instance;
    };
  }
  function ontologyLibraryBuilders$lambda$lambda_0($this_ontologyLibraryBuilders) {
    return function ($this$rootIndent) {
      keyword($this$rootIndent, 'ontology type:');
      space($this$rootIndent);
      textProperty($this$rootIndent, '<name>', ontologyLibraryBuilders$lambda$lambda$lambda_0);
      indent($this$rootIndent, true, ontologyLibraryBuilders$lambda$lambda$lambda_1($this_ontologyLibraryBuilders));
      indent($this$rootIndent, true, ontologyLibraryBuilders$lambda$lambda$lambda_2($this_ontologyLibraryBuilders));
      return Unit_instance;
    };
  }
  function ontologyLibraryBuilders$lambda_0($this, $this_ontologyLibraryBuilders) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(OntologyElement_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      rootIndent(result, ontologyLibraryBuilders$lambda$lambda_0($this_ontologyLibraryBuilders));
      return this_0;
    };
  }
  function ontologyLibraryBuilders$lambda$lambda$lambda_3(it) {
    return it.zfs();
  }
  function ontologyLibraryBuilders$lambda$lambda_1($this_ontologyLibraryBuilders) {
    return function ($this$rootIndent) {
      var tmp = get_localOntologyElementReferenceProvider($this_ontologyLibraryBuilders);
      child_0($this$rootIndent, tmp, ontologyLibraryBuilders$lambda$lambda$lambda_3);
      return Unit_instance;
    };
  }
  function ontologyLibraryBuilders$lambda_1($this, $this_ontologyLibraryBuilders) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(OntologyIsRelation_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      rootIndent(result, ontologyLibraryBuilders$lambda$lambda_1($this_ontologyLibraryBuilders));
      return this_0;
    };
  }
  function ontologyLibraryBuilders$lambda$lambda$lambda_4(it) {
    return it.hfq();
  }
  function ontologyLibraryBuilders$lambda$lambda_2($this_ontologyLibraryBuilders) {
    return function ($this$rootIndent) {
      var tmp = get_classExpressionProvider($this_ontologyLibraryBuilders);
      child_0($this$rootIndent, tmp, ontologyLibraryBuilders$lambda$lambda$lambda_4);
      return Unit_instance;
    };
  }
  function ontologyLibraryBuilders$lambda_2($this, $this_ontologyLibraryBuilders) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(OntologyCardinalityRelation_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      rootIndent(result, ontologyLibraryBuilders$lambda$lambda_2($this_ontologyLibraryBuilders));
      return this_0;
    };
  }
  function _get_ontologyElements_$lambda_30svkq($this$default) {
    return OntologyElement($this$default.l6z());
  }
  function _get_ontologyElements_$lambda_30svkq_0($this$clipboardParametersByCloner) {
    var tmp = new BaseNodeCloneSupport($this$clipboardParametersByCloner.gd3(), get_nodeFactory($this$clipboardParametersByCloner.l6z()));
    return isInterface(tmp, ClonerSupport) ? tmp : THROW_CCE();
  }
  function _get_ontologyIsRelations_$lambda_reypwo($this$completion) {
    return relationCompletion($this$completion, _get_ontologyIsRelations_$lambda$lambda_l9jael($this$completion));
  }
  function _get_ontologyIsRelations_$lambda$lambda_l9jael($this_completion) {
    return function () {
      return OntologyIsRelation($this_completion.l6z());
    };
  }
  function _get_ontologyIsRelations_$lambda_reypwo_0($this$default) {
    return OntologyIsRelation($this$default.l6z());
  }
  function _get_ontologyIsRelations_$lambda_reypwo_1($this$clipboardParametersByCloner) {
    var tmp = new BaseNodeCloneSupport($this$clipboardParametersByCloner.gd3(), get_nodeFactory($this$clipboardParametersByCloner.l6z()));
    return isInterface(tmp, ClonerSupport) ? tmp : THROW_CCE();
  }
  function _get_ontologyCardinalityRelations_$lambda_6r4c08($this$completion) {
    return relationCompletion($this$completion, _get_ontologyCardinalityRelations_$lambda$lambda_1gt74d($this$completion));
  }
  function _get_ontologyCardinalityRelations_$lambda$lambda_1gt74d($this_completion) {
    return function () {
      return OntologyCardinalityRelation($this_completion.l6z());
    };
  }
  function _get_ontologyCardinalityRelations_$lambda_6r4c08_0($this$default) {
    return OntologyCardinalityRelation($this$default.l6z());
  }
  function _get_ontologyCardinalityRelations_$lambda_6r4c08_1($this$clipboardParametersByCloner) {
    var tmp = new BaseNodeCloneSupport($this$clipboardParametersByCloner.gd3(), get_nodeFactory($this$clipboardParametersByCloner.l6z()));
    return isInterface(tmp, ClonerSupport) ? tmp : THROW_CCE();
  }
  function _get_localOntologyElementReferenceProvider_$lambda_89ybp0($this$default) {
    return LocalOntologyElementReference($this$default.l6z());
  }
  function _get_localOntologyElementReferenceProvider_$lambda_89ybp0_0($this$clipboardParametersByCloner) {
    var tmp = new BaseNodeCloneSupport($this$clipboardParametersByCloner.gd3(), get_nodeFactory($this$clipboardParametersByCloner.l6z()));
    return isInterface(tmp, ClonerSupport) ? tmp : THROW_CCE();
  }
  function _get_classExpressionProvider_$lambda_8nvv2d($this$default) {
    return LocalOntologyElementReference($this$default.l6z());
  }
  function _get_classExpressionProvider_$lambda_8nvv2d_0($this$clipboardParametersByCloner) {
    var tmp = new BaseNodeCloneSupport($this$clipboardParametersByCloner.gd3(), get_nodeFactory($this$clipboardParametersByCloner.l6z()));
    return isInterface(tmp, ClonerSupport) ? tmp : THROW_CCE();
  }
  function relationCompletion$lambda($factory, $this_relationCompletion) {
    return function (it) {
      // Inline function 'kotlin.apply' call
      var this_0 = $factory();
      LocalOntologyElementReference_2($this_relationCompletion.l6z(), it);
      return this_0;
    };
  }
  function relationCompletion$lambda_0($factory, $this_relationCompletion) {
    return function (it) {
      // Inline function 'kotlin.apply' call
      var this_0 = $factory();
      // Inline function 'kotlin.apply' call
      var tmp = QualifiedOntologyElementReference($this_relationCompletion.l6z()).hfu();
      // Inline function 'kotlin.apply' call
      var this_1 = OntologyLibraryReference($this_relationCompletion.l6z());
      this_1.yfq().f2x(it);
      tmp.f2x(this_1);
      return this_0;
    };
  }
  function processLibraryBuilders(_this__u8e3s4) {
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder = new LazyMapperBuilder(processLibraryBuilders$lambda(_this__u8e3s4, _this__u8e3s4));
    _this__u8e3s4.vcr(builder);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_0 = new LazyMapperBuilder(processLibraryBuilders$lambda_0(_this__u8e3s4, _this__u8e3s4));
    _this__u8e3s4.vcr(builder_0);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_1 = new LazyMapperBuilder(processLibraryBuilders$lambda_1(_this__u8e3s4));
    _this__u8e3s4.vcr(builder_1);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_2 = new LazyMapperBuilder(processLibraryBuilders$lambda_2(_this__u8e3s4, _this__u8e3s4));
    _this__u8e3s4.vcr(builder_2);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_3 = new LazyMapperBuilder(processLibraryBuilders$lambda_3(_this__u8e3s4));
    _this__u8e3s4.vcr(builder_3);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_4 = new LazyMapperBuilder(processLibraryBuilders$lambda_4(_this__u8e3s4));
    _this__u8e3s4.vcr(builder_4);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_5 = new LazyMapperBuilder(processLibraryBuilders$lambda_5(_this__u8e3s4));
    _this__u8e3s4.vcr(builder_5);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_6 = new LazyMapperBuilder(processLibraryBuilders$lambda_6(_this__u8e3s4));
    _this__u8e3s4.vcr(builder_6);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_7 = new LazyMapperBuilder(processLibraryBuilders$lambda_7(_this__u8e3s4));
    _this__u8e3s4.vcr(builder_7);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_8 = new LazyMapperBuilder(processLibraryBuilders$lambda_8(_this__u8e3s4));
    _this__u8e3s4.vcr(builder_8);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_9 = new LazyMapperBuilder(processLibraryBuilders$lambda_9(_this__u8e3s4));
    _this__u8e3s4.vcr(builder_9);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_10 = new LazyMapperBuilder(processLibraryBuilders$lambda_10(_this__u8e3s4));
    _this__u8e3s4.vcr(builder_10);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_11 = new LazyMapperBuilder(processLibraryBuilders$lambda_11(_this__u8e3s4));
    _this__u8e3s4.vcr(builder_11);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_12 = new LazyMapperBuilder(processLibraryBuilders$lambda_12(_this__u8e3s4));
    _this__u8e3s4.vcr(builder_12);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_13 = new LazyMapperBuilder(processLibraryBuilders$lambda_13(_this__u8e3s4));
    _this__u8e3s4.vcr(builder_13);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_14 = new LazyMapperBuilder(processLibraryBuilders$lambda_14(_this__u8e3s4));
    _this__u8e3s4.vcr(builder_14);
  }
  function partReferenceOperationCompletion(_this__u8e3s4) {
    return extensionFieldReferenceCompletion(_this__u8e3s4);
  }
  function bindingValueCompletion(_this__u8e3s4) {
    return plus_14(propertyValueCompletion(_this__u8e3s4), linkValueCompletion(_this__u8e3s4));
  }
  function bindingEntries(_this__u8e3s4, placeholderText, list) {
    placeholderText = placeholderText === VOID ? '<entries>' : placeholderText;
    var tmp6 = bindingEntries$lambda;
    // Inline function 'jetbrains.ocelot.langDef.editor.indentChildren' call
    var init = bindingEntries$lambda_0;
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.builder' call
    var this_0 = _this__u8e3s4.fcq();
    var sourceType = getKClass(AbstractBindingEntry);
    var tmp$ret$0 = this_0.xcr(sourceType);
    return indentChildren(_this__u8e3s4, list, tmp$ret$0, placeholderText, tmp6, init);
  }
  function get_ontologyElementsRole(_this__u8e3s4) {
    // Inline function 'jetbrains.ocelot.langDef.editor.ChildBuilder.invoke' call
    // Inline function 'kotlin.also' call
    var this_0 = get_ontologyElementTypeRole(_this__u8e3s4).s3e();
    this_0.jd0();
    return this_0;
  }
  function abstractBindingEntryCompletion(_this__u8e3s4) {
    return plus_14(inplaceBindingEntryCompletion(_this__u8e3s4), importedBindingEntryCompletion(_this__u8e3s4));
  }
  function abstractValueCompletion(_this__u8e3s4) {
    return plus_14(plus_14(plus_14(plus_14(plus_14(measurableValueCompletion(_this__u8e3s4), enumValueCompletion(_this__u8e3s4)), variableRefCompletion(_this__u8e3s4)), functionTermCompletion(_this__u8e3s4)), ontologyReferenceValueLibraryCompletion(_this__u8e3s4)), ontologyReferenceValueCompletion(_this__u8e3s4));
  }
  function propertyValueCompletion(_this__u8e3s4) {
    var tmp = nodeRefCompletion(_this__u8e3s4, Companion_getInstance_343().rlt_1);
    return map_2(tmp, propertyValueCompletion$lambda(_this__u8e3s4));
  }
  function linkValueCompletion(_this__u8e3s4) {
    var tmp = nodeRefCompletion(_this__u8e3s4, Companion_getInstance_329().rfv_1);
    return map_2(tmp, linkValueCompletion$lambda(_this__u8e3s4));
  }
  function inplaceBindingEntryCompletion(_this__u8e3s4) {
    var tmp = produces('link', inplaceBindingEntryCompletion$lambda(_this__u8e3s4));
    return simpleCompletion(listOf_0([tmp, produces('property', inplaceBindingEntryCompletion$lambda_0(_this__u8e3s4))]));
  }
  function importedBindingEntryCompletion(_this__u8e3s4) {
    var tmp = nodeRefCompletion(_this__u8e3s4, Companion_getInstance_330().agi_1);
    var tmp_0 = map_2(tmp, importedBindingEntryCompletion$lambda(_this__u8e3s4));
    var tmp_1 = nodeRefCompletion(_this__u8e3s4, Companion_getInstance_344().ngi_1);
    return plus_14(tmp_0, map_2(tmp_1, importedBindingEntryCompletion$lambda_0(_this__u8e3s4)));
  }
  function measurableValueCompletion(_this__u8e3s4) {
    var tmp = intRoleCompletion();
    return map_2(tmp, measurableValueCompletion$lambda(_this__u8e3s4));
  }
  function enumValueCompletion(_this__u8e3s4) {
    var tmp = nodeRefCompletion(_this__u8e3s4, Companion_getInstance_354().tg7_1);
    return map_2(tmp, enumValueCompletion$lambda(_this__u8e3s4));
  }
  function variableRefCompletion(_this__u8e3s4) {
    var tmp = nodeRefCompletion(_this__u8e3s4, Companion_getInstance_352().mhx_1);
    return map_2(tmp, variableRefCompletion$lambda(_this__u8e3s4));
  }
  function ontologyReferenceValueLibraryCompletion(_this__u8e3s4) {
    var tmp = nodeRefCompletion(_this__u8e3s4, Companion_getInstance_335().dh6_1);
    return map_2(tmp, ontologyReferenceValueLibraryCompletion$lambda(_this__u8e3s4));
  }
  function ontologyReferenceValueCompletion(_this__u8e3s4) {
    var tmp = nodeRefCompletion(_this__u8e3s4, Companion_getInstance_336().fh1_1);
    return map_2(tmp, ontologyReferenceValueCompletion$lambda(_this__u8e3s4));
  }
  function processLibraryBuilders$lambda$lambda($this$default) {
    return ProcessDeclaration($this$default.l6z());
  }
  function processLibraryBuilders$lambda$lambda_0($this$clipboardParametersByCloner) {
    var tmp = new BaseNodeCloneSupport($this$clipboardParametersByCloner.gd3(), get_nodeFactory($this$clipboardParametersByCloner.l6z()));
    return isInterface(tmp, ClonerSupport) ? tmp : THROW_CCE();
  }
  function processLibraryBuilders$lambda$lambda_1(it) {
    return it.xft();
  }
  function processLibraryBuilders$lambda($this, $this_processLibraryBuilders) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(ProcessLibrary_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      // Inline function 'jetbrains.biokb.lang.builders.nodeRole' call
      // Inline function 'jetbrains.ocelot.langDef.editor.role' call
      // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.builder' call
      var this_1 = $this_processLibraryBuilders;
      var sourceType = getKClass(ProcessDeclaration_1);
      var tmp$ret$0 = this_1.xcr(sourceType);
      var builder = new ChildBuilder(tmp$ret$0);
      builder.jd0();
      builder.hd0(processLibraryBuilders$lambda$lambda);
      var simpleClassName = ensureNotNull(getKClass(ProcessDeclaration_1).ra());
      builder.kd0(simpleClassName, processLibraryBuilders$lambda$lambda_0);
      var tmp = builder;
      children_1(result, tmp, processLibraryBuilders$lambda$lambda_1);
      return this_0;
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda($referenceTag) {
    return function (_this__u8e3s4, src, cell, cellAction) {
      var tmp = _this__u8e3s4.d6u($referenceTag);
      var tmp$ret$0 = src.r5a();
      return completion(_this__u8e3s4, tmp, src, tmp$ret$0, cell, VOID, cellAction);
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda$o$get$lambda($cell) {
    return function (it) {
      return signalCompletionHappened($cell, false, it);
    };
  }
  function _no_name_provided__qut3iv_25($refCompletion, $this, $source) {
    this.ctx_1 = $refCompletion;
    this.dtx_1 = $this;
    this.etx_1 = $source;
    CellTrait.call(this);
  }
  protoOf(_no_name_provided__qut3iv_25).n91 = function (cell, spec) {
    var tmp;
    if (equals(spec, Completion_getInstance().u9d_1)) {
      tmp = this.ctx_1(this.dtx_1, this.etx_1, cell, processLibraryBuilders$lambda$lambda$lambda$o$get$lambda(cell));
    } else {
      tmp = protoOf(CellTrait).n91.call(this, cell, spec);
    }
    return tmp;
  };
  function processLibraryBuilders$lambda$lambda$lambda_0($refCompletion) {
    return function (_this__u8e3s4, source) {
      return new _no_name_provided__qut3iv_25($refCompletion, _this__u8e3s4, source);
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda$lambda(s) {
    return s.r5a();
  }
  function processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda($property) {
    return function ($this$setup, source, textCell) {
      var referenceTextPropSupplier = getLoopQuerySupplier($property);
      var loopQuery = referenceTextPropSupplier(source, $this$setup.gcq(), textCell);
      $this$setup.l8b(syncOneWay(loopQuery, textCell.o8w()));
      var tmp = getKClass(QualifiedReferenceContent);
      connectWithRefSupport(textCell, loopQuery, tmp, processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda$lambda);
      return Unit_instance;
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_0($refCompletion) {
    return function ($this$completion, _unused_var__etf5q3, textCell, _unused_var__etf5q3_0) {
      var refCompletionArgs = getRefCompletionArgs(textCell);
      var source = refCompletionArgs.gdb_1;
      var cellAction = refCompletionArgs.hdb_1;
      return $refCompletion($this$completion, source, textCell, cellAction);
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda($property, $refCompletion) {
    return function ($this$editableText) {
      $this$editableText.xcp(processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda($property));
      completion_1($this$editableText, processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_0($refCompletion));
      return Unit_instance;
    };
  }
  function _no_name_provided__qut3iv_26($cellBuilder, $refCompletion) {
    this.gtx_1 = $refCompletion;
    this.ftx_1 = $cellBuilder;
  }
  protoOf(_no_name_provided__qut3iv_26).etv = function (placeholderText, validator, property) {
    return editableText(this, validator, VOID, placeholderText, processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda(property, this.gtx_1));
  };
  protoOf(_no_name_provided__qut3iv_26).jcs = function (placeholderText, validator, property) {
    return this.etv(placeholderText, validator, property);
  };
  protoOf(_no_name_provided__qut3iv_26).fcq = function () {
    return this.ftx_1.fcq();
  };
  protoOf(_no_name_provided__qut3iv_26).ftv = function (child) {
    this.ftx_1.wcp(child);
  };
  protoOf(_no_name_provided__qut3iv_26).wcp = function (child) {
    return this.ftv(child);
  };
  protoOf(_no_name_provided__qut3iv_26).gtv = function (init) {
    this.ftx_1.xcp(init);
  };
  protoOf(_no_name_provided__qut3iv_26).xcp = function (init) {
    return this.gtv(init);
  };
  protoOf(_no_name_provided__qut3iv_26).htv = function (init) {
    this.ftx_1.ycp(init);
  };
  protoOf(_no_name_provided__qut3iv_26).ycp = function (init) {
    return this.htv(init);
  };
  protoOf(_no_name_provided__qut3iv_26).itv = function (source, cellMap, context) {
    return this.ftx_1.acq(source, cellMap, context);
  };
  protoOf(_no_name_provided__qut3iv_26).acq = function (source, cellMap, context) {
    return this.itv((!(source == null) ? isInterface(source, DomainNode) : false) ? source : THROW_CCE(), cellMap, context);
  };
  function processLibraryBuilders$lambda$lambda$lambda$lambda(it) {
    return it.y2();
  }
  function processLibraryBuilders$lambda$lambda$lambda_1($refCompletion) {
    return function ($this$rootIndent) {
      var cellBuilder = $this$rootIndent;
      // Inline function 'jetbrains.ocelot.langDef.editor.getReferenceCellBuilder' call
      var refCompletion = $refCompletion;
      var refCellBuilder = new _no_name_provided__qut3iv_26(cellBuilder, refCompletion);
      refCellBuilder.kcs('<kind>', VOID, processLibraryBuilders$lambda$lambda$lambda$lambda);
      return Unit_instance;
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda_2() {
    // Inline function 'kotlin.also' call
    var this_0 = new IndentCell();
    Companion_getInstance_251().vda(this_0);
    return this_0;
  }
  function processLibraryBuilders$lambda$lambda$lambda_3(_unused_var__etf5q3, cell) {
    return get_forQueries(referenceData(cell).jda_1);
  }
  function processLibraryBuilders$lambda$lambda$lambda_4($completionTrait) {
    return function ($this$lambda, source, trait) {
      return CompositeCellTraits_instance.ra6([$completionTrait($this$lambda, source), trait]);
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda_5($this$setup, source, cell) {
    var referenceData_0 = referenceData(cell);
    var tmp$ret$0 = source.r5a();
    referenceData_0.wda(source, tmp$ret$0);
    return Unit_instance;
  }
  function processLibraryBuilders$lambda$lambda$lambda_6($this$setupSynchronizers, source, cell) {
    var tmp0 = $this$setupSynchronizers.gcq();
    // Inline function 'jetbrains.ocelot.langDef.references.synchronizers.getReferenceTargetSync' call
    var asyncTracker = new CellAsyncTracker(cell);
    var referenceData_0 = referenceData(cell);
    var tmp = ReferenceSynchronizers_instance;
    var tmp$ret$0 = source.r5a();
    var tmp$ret$1 = tmp.bdb(tmp0, tmp$ret$0, referenceData_0.jda_1, ResolveKind_LOOSE_getInstance(), null, asyncTracker);
    $this$setupSynchronizers.l8b(tmp$ret$1);
    $this$setupSynchronizers.l8b(getReferenceDataMonitorSynchronizer(cell));
    return Unit_instance;
  }
  function processLibraryBuilders$lambda$lambda$lambda_7($this$setupSynchronizers, source, cell) {
    if ($this$setupSynchronizers.gcq().nd5()) {
      var tmp = $this$setupSynchronizers.gcq();
      var tmp$ret$0 = source.r5a();
      $this$setupSynchronizers.l8b(referenceOutOfScopeSynchronizer(tmp, cell, tmp$ret$0));
      $this$setupSynchronizers.l8b(highlightReferenceTargetOutOfSync(cell, cell.n92(ReferenceCells_getInstance().cdb_1)));
    }
    return Unit_instance;
  }
  function processLibraryBuilders$lambda$lambda$lambda_8(it) {
    return it.y2();
  }
  function processLibraryBuilders$lambda$lambda$lambda_9($referenceTag) {
    return function (_this__u8e3s4, src, cell, cellAction) {
      var tmp = _this__u8e3s4.d6u($referenceTag);
      var tmp$ret$0 = src.pft();
      return completion(_this__u8e3s4, tmp, src, tmp$ret$0, cell, VOID, cellAction);
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda$o$get$lambda_0($cell) {
    return function (it) {
      return signalCompletionHappened($cell, false, it);
    };
  }
  function _no_name_provided__qut3iv_27($refCompletion, $this, $source) {
    this.htx_1 = $refCompletion;
    this.itx_1 = $this;
    this.jtx_1 = $source;
    CellTrait.call(this);
  }
  protoOf(_no_name_provided__qut3iv_27).n91 = function (cell, spec) {
    var tmp;
    if (equals(spec, Completion_getInstance().u9d_1)) {
      tmp = this.htx_1(this.itx_1, this.jtx_1, cell, processLibraryBuilders$lambda$lambda$lambda$o$get$lambda_0(cell));
    } else {
      tmp = protoOf(CellTrait).n91.call(this, cell, spec);
    }
    return tmp;
  };
  function processLibraryBuilders$lambda$lambda$lambda_10($refCompletion) {
    return function (_this__u8e3s4, source) {
      return new _no_name_provided__qut3iv_27($refCompletion, _this__u8e3s4, source);
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda$lambda_0(s) {
    return s.pft();
  }
  function processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_1($property) {
    return function ($this$setup, source, textCell) {
      var referenceTextPropSupplier = getLoopQuerySupplier($property);
      var loopQuery = referenceTextPropSupplier(source, $this$setup.gcq(), textCell);
      $this$setup.l8b(syncOneWay(loopQuery, textCell.o8w()));
      var tmp = getKClass(QualifiedReferenceContent);
      connectWithRefSupport(textCell, loopQuery, tmp, processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda$lambda_0);
      return Unit_instance;
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_2($refCompletion) {
    return function ($this$completion, _unused_var__etf5q3, textCell, _unused_var__etf5q3_0) {
      var refCompletionArgs = getRefCompletionArgs(textCell);
      var source = refCompletionArgs.gdb_1;
      var cellAction = refCompletionArgs.hdb_1;
      return $refCompletion($this$completion, source, textCell, cellAction);
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda_0($property, $refCompletion) {
    return function ($this$editableText) {
      $this$editableText.xcp(processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_1($property));
      completion_1($this$editableText, processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_2($refCompletion));
      return Unit_instance;
    };
  }
  function _no_name_provided__qut3iv_28($cellBuilder, $refCompletion) {
    this.ltx_1 = $refCompletion;
    this.ktx_1 = $cellBuilder;
  }
  protoOf(_no_name_provided__qut3iv_28).etv = function (placeholderText, validator, property) {
    return editableText(this, validator, VOID, placeholderText, processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda_0(property, this.ltx_1));
  };
  protoOf(_no_name_provided__qut3iv_28).jcs = function (placeholderText, validator, property) {
    return this.etv(placeholderText, validator, property);
  };
  protoOf(_no_name_provided__qut3iv_28).fcq = function () {
    return this.ktx_1.fcq();
  };
  protoOf(_no_name_provided__qut3iv_28).ftv = function (child) {
    this.ktx_1.wcp(child);
  };
  protoOf(_no_name_provided__qut3iv_28).wcp = function (child) {
    return this.ftv(child);
  };
  protoOf(_no_name_provided__qut3iv_28).gtv = function (init) {
    this.ktx_1.xcp(init);
  };
  protoOf(_no_name_provided__qut3iv_28).xcp = function (init) {
    return this.gtv(init);
  };
  protoOf(_no_name_provided__qut3iv_28).htv = function (init) {
    this.ktx_1.ycp(init);
  };
  protoOf(_no_name_provided__qut3iv_28).ycp = function (init) {
    return this.htv(init);
  };
  protoOf(_no_name_provided__qut3iv_28).itv = function (source, cellMap, context) {
    return this.ktx_1.acq(source, cellMap, context);
  };
  protoOf(_no_name_provided__qut3iv_28).acq = function (source, cellMap, context) {
    return this.itv((!(source == null) ? isInterface(source, DomainNode) : false) ? source : THROW_CCE(), cellMap, context);
  };
  function processLibraryBuilders$lambda$lambda$lambda$lambda_0(it) {
    return it.y2();
  }
  function processLibraryBuilders$lambda$lambda$lambda_11($refCompletion) {
    return function ($this$rootIndent) {
      var cellBuilder = $this$rootIndent;
      // Inline function 'jetbrains.ocelot.langDef.editor.getReferenceCellBuilder' call
      var refCompletion = $refCompletion;
      var refCellBuilder = new _no_name_provided__qut3iv_28(cellBuilder, refCompletion);
      refCellBuilder.kcs('<process>', VOID, processLibraryBuilders$lambda$lambda$lambda$lambda_0);
      return Unit_instance;
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda_12() {
    // Inline function 'kotlin.also' call
    var this_0 = new IndentCell();
    Companion_getInstance_251().vda(this_0);
    return this_0;
  }
  function processLibraryBuilders$lambda$lambda$lambda_13(_unused_var__etf5q3, cell) {
    return get_forQueries(referenceData(cell).jda_1);
  }
  function processLibraryBuilders$lambda$lambda$lambda_14($completionTrait) {
    return function ($this$lambda, source, trait) {
      return CompositeCellTraits_instance.ra6([$completionTrait($this$lambda, source), trait]);
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda_15($this$setup, source, cell) {
    var referenceData_0 = referenceData(cell);
    var tmp$ret$0 = source.pft();
    referenceData_0.wda(source, tmp$ret$0);
    return Unit_instance;
  }
  function processLibraryBuilders$lambda$lambda$lambda_16($this$setupSynchronizers, source, cell) {
    var tmp0 = $this$setupSynchronizers.gcq();
    // Inline function 'jetbrains.ocelot.langDef.references.synchronizers.getReferenceTargetSync' call
    var asyncTracker = new CellAsyncTracker(cell);
    var referenceData_0 = referenceData(cell);
    var tmp = ReferenceSynchronizers_instance;
    var tmp$ret$0 = source.pft();
    var tmp$ret$1 = tmp.bdb(tmp0, tmp$ret$0, referenceData_0.jda_1, ResolveKind_LOOSE_getInstance(), null, asyncTracker);
    $this$setupSynchronizers.l8b(tmp$ret$1);
    $this$setupSynchronizers.l8b(getReferenceDataMonitorSynchronizer(cell));
    return Unit_instance;
  }
  function processLibraryBuilders$lambda$lambda$lambda_17($this$setupSynchronizers, source, cell) {
    if ($this$setupSynchronizers.gcq().nd5()) {
      var tmp = $this$setupSynchronizers.gcq();
      var tmp$ret$0 = source.pft();
      $this$setupSynchronizers.l8b(referenceOutOfScopeSynchronizer(tmp, cell, tmp$ret$0));
      $this$setupSynchronizers.l8b(highlightReferenceTargetOutOfSync(cell, cell.n92(ReferenceCells_getInstance().cdb_1)));
    }
    return Unit_instance;
  }
  function processLibraryBuilders$lambda$lambda$lambda$lambda$lambda(it) {
    return it.qfp();
  }
  function processLibraryBuilders$lambda$lambda$lambda$lambda_1($this_processLibraryBuilders) {
    return function ($this$horizontal) {
      var tmp = get_ontologyElementsRole($this_processLibraryBuilders);
      children_1($this$horizontal, tmp, processLibraryBuilders$lambda$lambda$lambda$lambda$lambda);
      return Unit_instance;
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda$lambda_2($this$horizontal) {
    bindingEntries($this$horizontal, VOID, processLibraryBuilders$lambda$lambda$lambda$lambda$lambda_0);
    return Unit_instance;
  }
  function processLibraryBuilders$lambda$lambda$lambda$lambda$lambda_0(it) {
    return it.y();
  }
  function processLibraryBuilders$lambda$lambda$lambda_18($this_processLibraryBuilders) {
    return function ($this$indent) {
      newLine($this$indent);
      keyword($this$indent, 'ontology elements:');
      space($this$indent);
      horizontal($this$indent, processLibraryBuilders$lambda$lambda$lambda$lambda_1($this_processLibraryBuilders));
      newLine($this$indent);
      keyword($this$indent, 'properties:');
      space($this$indent);
      horizontal($this$indent, processLibraryBuilders$lambda$lambda$lambda$lambda_2);
      return Unit_instance;
    };
  }
  function processLibraryBuilders$lambda$lambda_2($this_processLibraryBuilders) {
    return function ($this$rootIndent) {
      // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget' call
      var referenceTag = Companion_getInstance_338().hhc_1;
      var refCompletion = processLibraryBuilders$lambda$lambda$lambda(referenceTag);
      var completionTrait = processLibraryBuilders$lambda$lambda$lambda_0(refCompletion);
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this$rootIndent.fcq(), getKClass(ProcessKind_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      rootIndent(result, processLibraryBuilders$lambda$lambda$lambda_1(refCompletion));
      var mapperBuilder = this_0;
      var tmp0_cellFactory = new NamedCellFactory('referenceData', processLibraryBuilders$lambda$lambda$lambda_2);
      var tmp = processLibraryBuilders$lambda$lambda$lambda_3;
      // Inline function 'kotlin.apply' call
      var this_1 = projectionalChild($this$rootIndent, tmp, tmp0_cellFactory, mapperBuilder, '<kind>', processLibraryBuilders$lambda$lambda$lambda_4(completionTrait));
      this_1.xcp(processLibraryBuilders$lambda$lambda$lambda_5);
      this_1.ycp(processLibraryBuilders$lambda$lambda$lambda_6);
      this_1.ycp(processLibraryBuilders$lambda$lambda$lambda_7);
      space($this$rootIndent);
      textProperty($this$rootIndent, '<name>', processLibraryBuilders$lambda$lambda$lambda_8);
      space($this$rootIndent);
      keyword($this$rootIndent, 'extends');
      space($this$rootIndent);
      var tmp2 = '<nothing>';
      // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget' call
      var referenceTag_0 = Companion_getInstance_338().ihc_1;
      var refCompletion_0 = processLibraryBuilders$lambda$lambda$lambda_9(referenceTag_0);
      var completionTrait_0 = processLibraryBuilders$lambda$lambda$lambda_10(refCompletion_0);
      // Inline function 'kotlin.also' call
      var this_2 = new SimpleMapperBuilder($this$rootIndent.fcq(), getKClass(ProcessDeclaration_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result_0 = new RootCellBuilderImpl(this_2);
      rootIndent(result_0, processLibraryBuilders$lambda$lambda$lambda_11(refCompletion_0));
      var mapperBuilder_0 = this_2;
      var tmp0_cellFactory_0 = new NamedCellFactory('referenceData', processLibraryBuilders$lambda$lambda$lambda_12);
      var tmp_0 = processLibraryBuilders$lambda$lambda$lambda_13;
      // Inline function 'kotlin.apply' call
      var this_3 = projectionalChild($this$rootIndent, tmp_0, tmp0_cellFactory_0, mapperBuilder_0, tmp2, processLibraryBuilders$lambda$lambda$lambda_14(completionTrait_0));
      this_3.xcp(processLibraryBuilders$lambda$lambda$lambda_15);
      this_3.ycp(processLibraryBuilders$lambda$lambda$lambda_16);
      this_3.ycp(processLibraryBuilders$lambda$lambda$lambda_17);
      indent($this$rootIndent, true, processLibraryBuilders$lambda$lambda$lambda_18($this_processLibraryBuilders));
      return Unit_instance;
    };
  }
  function processLibraryBuilders$lambda_0($this, $this_processLibraryBuilders) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(ProcessDeclaration_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      rootIndent(result, processLibraryBuilders$lambda$lambda_2($this_processLibraryBuilders));
      return this_0;
    };
  }
  function processLibraryBuilders$lambda$lambda_3(it) {
    return it.q6q();
  }
  function processLibraryBuilders$lambda$lambda_4($this$indentChild) {
    defaultItem($this$indentChild, processLibraryBuilders$lambda$lambda$lambda_19);
    return Unit_instance;
  }
  function processLibraryBuilders$lambda$lambda$lambda_19($this$defaultItem) {
    return PropertyDeclaration($this$defaultItem.l6z());
  }
  function processLibraryBuilders$lambda_1($this) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(BindingProperty_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      var tmp2 = processLibraryBuilders$lambda$lambda_3;
      // Inline function 'jetbrains.ocelot.langDef.editor.indentChild' call
      var init = processLibraryBuilders$lambda$lambda_4;
      // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.builder' call
      var this_1 = result.fcq();
      var sourceType = getKClass(PropertyDeclaration_1);
      var tmp$ret$0 = this_1.xcr(sourceType);
      indentChild(result, tmp2, tmp$ret$0, null, init);
      return this_0;
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda_20(it) {
    return it.xa1();
  }
  function processLibraryBuilders$lambda$lambda$lambda_21(it) {
    return it.aft();
  }
  function processLibraryBuilders$lambda$lambda$lambda_22($referenceTag) {
    return function (_this__u8e3s4, src, cell, cellAction) {
      var tmp = _this__u8e3s4.d6u($referenceTag);
      var tmp$ret$0 = src.ufp();
      return completion(_this__u8e3s4, tmp, src, tmp$ret$0, cell, VOID, cellAction);
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda$o$get$lambda_1($cell) {
    return function (it) {
      return signalCompletionHappened($cell, false, it);
    };
  }
  function _no_name_provided__qut3iv_29($refCompletion, $this, $source) {
    this.mtx_1 = $refCompletion;
    this.ntx_1 = $this;
    this.otx_1 = $source;
    CellTrait.call(this);
  }
  protoOf(_no_name_provided__qut3iv_29).n91 = function (cell, spec) {
    var tmp;
    if (equals(spec, Completion_getInstance().u9d_1)) {
      tmp = this.mtx_1(this.ntx_1, this.otx_1, cell, processLibraryBuilders$lambda$lambda$lambda$o$get$lambda_1(cell));
    } else {
      tmp = protoOf(CellTrait).n91.call(this, cell, spec);
    }
    return tmp;
  };
  function processLibraryBuilders$lambda$lambda$lambda_23($refCompletion) {
    return function (_this__u8e3s4, source) {
      return new _no_name_provided__qut3iv_29($refCompletion, _this__u8e3s4, source);
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda$lambda_1(s) {
    return s.ufp();
  }
  function processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_3($property) {
    return function ($this$setup, source, textCell) {
      var referenceTextPropSupplier = getLoopQuerySupplier($property);
      var loopQuery = referenceTextPropSupplier(source, $this$setup.gcq(), textCell);
      $this$setup.l8b(syncOneWay(loopQuery, textCell.o8w()));
      var tmp = getKClass(QualifiedReferenceContent);
      connectWithRefSupport(textCell, loopQuery, tmp, processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda$lambda_1);
      return Unit_instance;
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_4($refCompletion) {
    return function ($this$completion, _unused_var__etf5q3, textCell, _unused_var__etf5q3_0) {
      var refCompletionArgs = getRefCompletionArgs(textCell);
      var source = refCompletionArgs.gdb_1;
      var cellAction = refCompletionArgs.hdb_1;
      return $refCompletion($this$completion, source, textCell, cellAction);
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda_1($property, $refCompletion) {
    return function ($this$editableText) {
      $this$editableText.xcp(processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_3($property));
      completion_1($this$editableText, processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_4($refCompletion));
      return Unit_instance;
    };
  }
  function _no_name_provided__qut3iv_30($cellBuilder, $refCompletion) {
    this.qtx_1 = $refCompletion;
    this.ptx_1 = $cellBuilder;
  }
  protoOf(_no_name_provided__qut3iv_30).etv = function (placeholderText, validator, property) {
    return editableText(this, validator, VOID, placeholderText, processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda_1(property, this.qtx_1));
  };
  protoOf(_no_name_provided__qut3iv_30).jcs = function (placeholderText, validator, property) {
    return this.etv(placeholderText, validator, property);
  };
  protoOf(_no_name_provided__qut3iv_30).fcq = function () {
    return this.ptx_1.fcq();
  };
  protoOf(_no_name_provided__qut3iv_30).ftv = function (child) {
    this.ptx_1.wcp(child);
  };
  protoOf(_no_name_provided__qut3iv_30).wcp = function (child) {
    return this.ftv(child);
  };
  protoOf(_no_name_provided__qut3iv_30).gtv = function (init) {
    this.ptx_1.xcp(init);
  };
  protoOf(_no_name_provided__qut3iv_30).xcp = function (init) {
    return this.gtv(init);
  };
  protoOf(_no_name_provided__qut3iv_30).htv = function (init) {
    this.ptx_1.ycp(init);
  };
  protoOf(_no_name_provided__qut3iv_30).ycp = function (init) {
    return this.htv(init);
  };
  protoOf(_no_name_provided__qut3iv_30).itv = function (source, cellMap, context) {
    return this.ptx_1.acq(source, cellMap, context);
  };
  protoOf(_no_name_provided__qut3iv_30).acq = function (source, cellMap, context) {
    return this.itv((!(source == null) ? isInterface(source, DomainNode) : false) ? source : THROW_CCE(), cellMap, context);
  };
  function processLibraryBuilders$lambda$lambda$lambda$lambda_3(it) {
    return it.y2();
  }
  function processLibraryBuilders$lambda$lambda$lambda_24($refCompletion) {
    return function ($this$rootIndent) {
      var cellBuilder = $this$rootIndent;
      // Inline function 'jetbrains.ocelot.langDef.editor.getReferenceCellBuilder' call
      var refCompletion = $refCompletion;
      var refCellBuilder = new _no_name_provided__qut3iv_30(cellBuilder, refCompletion);
      refCellBuilder.kcs('<process>', VOID, processLibraryBuilders$lambda$lambda$lambda$lambda_3);
      return Unit_instance;
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda_25() {
    // Inline function 'kotlin.also' call
    var this_0 = new IndentCell();
    Companion_getInstance_251().vda(this_0);
    return this_0;
  }
  function processLibraryBuilders$lambda$lambda$lambda_26(_unused_var__etf5q3, cell) {
    return get_forQueries(referenceData(cell).jda_1);
  }
  function processLibraryBuilders$lambda$lambda$lambda_27($completionTrait) {
    return function ($this$lambda, source, trait) {
      return CompositeCellTraits_instance.ra6([$completionTrait($this$lambda, source), trait]);
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda_28($this$setup, source, cell) {
    var referenceData_0 = referenceData(cell);
    var tmp$ret$0 = source.ufp();
    referenceData_0.wda(source, tmp$ret$0);
    return Unit_instance;
  }
  function processLibraryBuilders$lambda$lambda$lambda_29($this$setupSynchronizers, source, cell) {
    var tmp0 = $this$setupSynchronizers.gcq();
    // Inline function 'jetbrains.ocelot.langDef.references.synchronizers.getReferenceTargetSync' call
    var asyncTracker = new CellAsyncTracker(cell);
    var referenceData_0 = referenceData(cell);
    var tmp = ReferenceSynchronizers_instance;
    var tmp$ret$0 = source.ufp();
    var tmp$ret$1 = tmp.bdb(tmp0, tmp$ret$0, referenceData_0.jda_1, ResolveKind_LOOSE_getInstance(), null, asyncTracker);
    $this$setupSynchronizers.l8b(tmp$ret$1);
    $this$setupSynchronizers.l8b(getReferenceDataMonitorSynchronizer(cell));
    return Unit_instance;
  }
  function processLibraryBuilders$lambda$lambda$lambda_30($this$setupSynchronizers, source, cell) {
    if ($this$setupSynchronizers.gcq().nd5()) {
      var tmp = $this$setupSynchronizers.gcq();
      var tmp$ret$0 = source.ufp();
      $this$setupSynchronizers.l8b(referenceOutOfScopeSynchronizer(tmp, cell, tmp$ret$0));
      $this$setupSynchronizers.l8b(highlightReferenceTargetOutOfSync(cell, cell.n92(ReferenceCells_getInstance().cdb_1)));
    }
    return Unit_instance;
  }
  function processLibraryBuilders$lambda$lambda_5($this_processLibraryBuilders) {
    return function ($this$rootIndent) {
      // Inline function 'jetbrains.ocelot.langDef.editor.indentChild' call
      var role = processLibraryBuilders$lambda$lambda$lambda_20;
      // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.builder' call
      var this_0 = $this$rootIndent.fcq();
      var sourceType = getKClass(LinkDeclaration_1);
      var tmp$ret$0 = this_0.xcr(sourceType);
      indentChild($this$rootIndent, role, tmp$ret$0, null, null);
      space($this$rootIndent);
      keyword($this$rootIndent, 'from');
      space($this$rootIndent);
      // Inline function 'jetbrains.ocelot.langDef.editor.ChildBuilder.invoke' call
      // Inline function 'kotlin.also' call
      var this_1 = get_ontologyLibraryReferenceRole($this_processLibraryBuilders).s3e();
      this_1.gd0('<default>');
      var tmp = this_1;
      child_0($this$rootIndent, tmp, processLibraryBuilders$lambda$lambda$lambda_21);
      space($this$rootIndent);
      keyword($this$rootIndent, 'specializes');
      space($this$rootIndent);
      var tmp2 = '<nothing>';
      // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget' call
      var referenceTag = Companion_getInstance_329().rfv_1;
      var refCompletion = processLibraryBuilders$lambda$lambda$lambda_22(referenceTag);
      var completionTrait = processLibraryBuilders$lambda$lambda$lambda_23(refCompletion);
      // Inline function 'kotlin.also' call
      var this_2 = new SimpleMapperBuilder($this$rootIndent.fcq(), getKClass(AbstractLink));
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_2);
      rootIndent(result, processLibraryBuilders$lambda$lambda$lambda_24(refCompletion));
      var mapperBuilder = this_2;
      var tmp0_cellFactory = new NamedCellFactory('referenceData', processLibraryBuilders$lambda$lambda$lambda_25);
      var tmp_0 = processLibraryBuilders$lambda$lambda$lambda_26;
      // Inline function 'kotlin.apply' call
      var this_3 = projectionalChild($this$rootIndent, tmp_0, tmp0_cellFactory, mapperBuilder, tmp2, processLibraryBuilders$lambda$lambda$lambda_27(completionTrait));
      this_3.xcp(processLibraryBuilders$lambda$lambda$lambda_28);
      this_3.ycp(processLibraryBuilders$lambda$lambda$lambda_29);
      this_3.ycp(processLibraryBuilders$lambda$lambda$lambda_30);
      return Unit_instance;
    };
  }
  function processLibraryBuilders$lambda_2($this, $this_processLibraryBuilders) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(OntologyLink_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      rootIndent(result, processLibraryBuilders$lambda$lambda_5($this_processLibraryBuilders));
      return this_0;
    };
  }
  function processLibraryBuilders$lambda$lambda_6($this$rootIndent) {
    var tmp2 = '<property>';
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget' call
    var referenceTag = Companion_getInstance_344().ngi_1;
    var refCompletion = processLibraryBuilders$lambda$lambda$lambda_31(referenceTag);
    var completionTrait = processLibraryBuilders$lambda$lambda$lambda_32(refCompletion);
    // Inline function 'kotlin.also' call
    var this_0 = new SimpleMapperBuilder($this$rootIndent.fcq(), getKClass(PropertyDeclaration_1));
    // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
    var result = new RootCellBuilderImpl(this_0);
    rootIndent(result, processLibraryBuilders$lambda$lambda$lambda_33(refCompletion));
    var mapperBuilder = this_0;
    var tmp0_cellFactory = new NamedCellFactory('referenceData', processLibraryBuilders$lambda$lambda$lambda_34);
    var tmp = processLibraryBuilders$lambda$lambda$lambda_35;
    // Inline function 'kotlin.apply' call
    var this_1 = projectionalChild($this$rootIndent, tmp, tmp0_cellFactory, mapperBuilder, tmp2, processLibraryBuilders$lambda$lambda$lambda_36(completionTrait));
    this_1.xcp(processLibraryBuilders$lambda$lambda$lambda_37);
    this_1.ycp(processLibraryBuilders$lambda$lambda$lambda_38);
    this_1.ycp(processLibraryBuilders$lambda$lambda$lambda_39);
    return Unit_instance;
  }
  function processLibraryBuilders$lambda$lambda$lambda_31($referenceTag) {
    return function (_this__u8e3s4, src, cell, cellAction) {
      var tmp = _this__u8e3s4.d6u($referenceTag);
      var tmp$ret$0 = src.sfr();
      return completion(_this__u8e3s4, tmp, src, tmp$ret$0, cell, VOID, cellAction);
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda$o$get$lambda_2($cell) {
    return function (it) {
      return signalCompletionHappened($cell, false, it);
    };
  }
  function _no_name_provided__qut3iv_31($refCompletion, $this, $source) {
    this.rtx_1 = $refCompletion;
    this.stx_1 = $this;
    this.ttx_1 = $source;
    CellTrait.call(this);
  }
  protoOf(_no_name_provided__qut3iv_31).n91 = function (cell, spec) {
    var tmp;
    if (equals(spec, Completion_getInstance().u9d_1)) {
      tmp = this.rtx_1(this.stx_1, this.ttx_1, cell, processLibraryBuilders$lambda$lambda$lambda$o$get$lambda_2(cell));
    } else {
      tmp = protoOf(CellTrait).n91.call(this, cell, spec);
    }
    return tmp;
  };
  function processLibraryBuilders$lambda$lambda$lambda_32($refCompletion) {
    return function (_this__u8e3s4, source) {
      return new _no_name_provided__qut3iv_31($refCompletion, _this__u8e3s4, source);
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda$lambda_2(s) {
    return s.sfr();
  }
  function processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_5($property) {
    return function ($this$setup, source, textCell) {
      var referenceTextPropSupplier = getLoopQuerySupplier($property);
      var loopQuery = referenceTextPropSupplier(source, $this$setup.gcq(), textCell);
      $this$setup.l8b(syncOneWay(loopQuery, textCell.o8w()));
      var tmp = getKClass(QualifiedReferenceContent);
      connectWithRefSupport(textCell, loopQuery, tmp, processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda$lambda_2);
      return Unit_instance;
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_6($refCompletion) {
    return function ($this$completion, _unused_var__etf5q3, textCell, _unused_var__etf5q3_0) {
      var refCompletionArgs = getRefCompletionArgs(textCell);
      var source = refCompletionArgs.gdb_1;
      var cellAction = refCompletionArgs.hdb_1;
      return $refCompletion($this$completion, source, textCell, cellAction);
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda_2($property, $refCompletion) {
    return function ($this$editableText) {
      $this$editableText.xcp(processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_5($property));
      completion_1($this$editableText, processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_6($refCompletion));
      return Unit_instance;
    };
  }
  function _no_name_provided__qut3iv_32($cellBuilder, $refCompletion) {
    this.vtx_1 = $refCompletion;
    this.utx_1 = $cellBuilder;
  }
  protoOf(_no_name_provided__qut3iv_32).etv = function (placeholderText, validator, property) {
    return editableText(this, validator, VOID, placeholderText, processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda_2(property, this.vtx_1));
  };
  protoOf(_no_name_provided__qut3iv_32).jcs = function (placeholderText, validator, property) {
    return this.etv(placeholderText, validator, property);
  };
  protoOf(_no_name_provided__qut3iv_32).fcq = function () {
    return this.utx_1.fcq();
  };
  protoOf(_no_name_provided__qut3iv_32).ftv = function (child) {
    this.utx_1.wcp(child);
  };
  protoOf(_no_name_provided__qut3iv_32).wcp = function (child) {
    return this.ftv(child);
  };
  protoOf(_no_name_provided__qut3iv_32).gtv = function (init) {
    this.utx_1.xcp(init);
  };
  protoOf(_no_name_provided__qut3iv_32).xcp = function (init) {
    return this.gtv(init);
  };
  protoOf(_no_name_provided__qut3iv_32).htv = function (init) {
    this.utx_1.ycp(init);
  };
  protoOf(_no_name_provided__qut3iv_32).ycp = function (init) {
    return this.htv(init);
  };
  protoOf(_no_name_provided__qut3iv_32).itv = function (source, cellMap, context) {
    return this.utx_1.acq(source, cellMap, context);
  };
  protoOf(_no_name_provided__qut3iv_32).acq = function (source, cellMap, context) {
    return this.itv((!(source == null) ? isInterface(source, DomainNode) : false) ? source : THROW_CCE(), cellMap, context);
  };
  function processLibraryBuilders$lambda$lambda$lambda$lambda_4(it) {
    return it.y2();
  }
  function processLibraryBuilders$lambda$lambda$lambda_33($refCompletion) {
    return function ($this$rootIndent) {
      var cellBuilder = $this$rootIndent;
      // Inline function 'jetbrains.ocelot.langDef.editor.getReferenceCellBuilder' call
      var refCompletion = $refCompletion;
      var refCellBuilder = new _no_name_provided__qut3iv_32(cellBuilder, refCompletion);
      refCellBuilder.kcs('<property>', VOID, processLibraryBuilders$lambda$lambda$lambda$lambda_4);
      return Unit_instance;
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda_34() {
    // Inline function 'kotlin.also' call
    var this_0 = new IndentCell();
    Companion_getInstance_251().vda(this_0);
    return this_0;
  }
  function processLibraryBuilders$lambda$lambda$lambda_35(_unused_var__etf5q3, cell) {
    return get_forQueries(referenceData(cell).jda_1);
  }
  function processLibraryBuilders$lambda$lambda$lambda_36($completionTrait) {
    return function ($this$lambda, source, trait) {
      return CompositeCellTraits_instance.ra6([$completionTrait($this$lambda, source), trait]);
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda_37($this$setup, source, cell) {
    var referenceData_0 = referenceData(cell);
    var tmp$ret$0 = source.sfr();
    referenceData_0.wda(source, tmp$ret$0);
    return Unit_instance;
  }
  function processLibraryBuilders$lambda$lambda$lambda_38($this$setupSynchronizers, source, cell) {
    var tmp0 = $this$setupSynchronizers.gcq();
    // Inline function 'jetbrains.ocelot.langDef.references.synchronizers.getReferenceTargetSync' call
    var asyncTracker = new CellAsyncTracker(cell);
    var referenceData_0 = referenceData(cell);
    var tmp = ReferenceSynchronizers_instance;
    var tmp$ret$0 = source.sfr();
    var tmp$ret$1 = tmp.bdb(tmp0, tmp$ret$0, referenceData_0.jda_1, ResolveKind_LOOSE_getInstance(), null, asyncTracker);
    $this$setupSynchronizers.l8b(tmp$ret$1);
    $this$setupSynchronizers.l8b(getReferenceDataMonitorSynchronizer(cell));
    return Unit_instance;
  }
  function processLibraryBuilders$lambda$lambda$lambda_39($this$setupSynchronizers, source, cell) {
    if ($this$setupSynchronizers.gcq().nd5()) {
      var tmp = $this$setupSynchronizers.gcq();
      var tmp$ret$0 = source.sfr();
      $this$setupSynchronizers.l8b(referenceOutOfScopeSynchronizer(tmp, cell, tmp$ret$0));
      $this$setupSynchronizers.l8b(highlightReferenceTargetOutOfSync(cell, cell.n92(ReferenceCells_getInstance().cdb_1)));
    }
    return Unit_instance;
  }
  function processLibraryBuilders$lambda_3($this) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(ImportedProperty_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      rootIndent(result, processLibraryBuilders$lambda$lambda_6);
      return this_0;
    };
  }
  function processLibraryBuilders$lambda$lambda_7($this$rootIndent) {
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget' call
    var referenceTag = Companion_getInstance_330().agi_1;
    var refCompletion = processLibraryBuilders$lambda$lambda$lambda_40(referenceTag);
    var completionTrait = processLibraryBuilders$lambda$lambda$lambda_41(refCompletion);
    // Inline function 'kotlin.also' call
    var this_0 = new SimpleMapperBuilder($this$rootIndent.fcq(), getKClass(LinkDeclaration_1));
    // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
    var result = new RootCellBuilderImpl(this_0);
    rootIndent(result, processLibraryBuilders$lambda$lambda$lambda_42(refCompletion));
    var mapperBuilder = this_0;
    var tmp0_cellFactory = new NamedCellFactory('referenceData', processLibraryBuilders$lambda$lambda$lambda_43);
    var tmp = processLibraryBuilders$lambda$lambda$lambda_44;
    // Inline function 'kotlin.apply' call
    var this_1 = projectionalChild($this$rootIndent, tmp, tmp0_cellFactory, mapperBuilder, '<link>', processLibraryBuilders$lambda$lambda$lambda_45(completionTrait));
    this_1.xcp(processLibraryBuilders$lambda$lambda$lambda_46);
    this_1.ycp(processLibraryBuilders$lambda$lambda$lambda_47);
    this_1.ycp(processLibraryBuilders$lambda$lambda$lambda_48);
    space($this$rootIndent);
    keyword($this$rootIndent, 'specializes');
    space($this$rootIndent);
    var tmp2 = '<nothing>';
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget' call
    var referenceTag_0 = Companion_getInstance_329().rfv_1;
    var refCompletion_0 = processLibraryBuilders$lambda$lambda$lambda_49(referenceTag_0);
    var completionTrait_0 = processLibraryBuilders$lambda$lambda$lambda_50(refCompletion_0);
    // Inline function 'kotlin.also' call
    var this_2 = new SimpleMapperBuilder($this$rootIndent.fcq(), getKClass(AbstractLink));
    // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
    var result_0 = new RootCellBuilderImpl(this_2);
    rootIndent(result_0, processLibraryBuilders$lambda$lambda$lambda_51(refCompletion_0));
    var mapperBuilder_0 = this_2;
    var tmp0_cellFactory_0 = new NamedCellFactory('referenceData', processLibraryBuilders$lambda$lambda$lambda_52);
    var tmp_0 = processLibraryBuilders$lambda$lambda$lambda_53;
    // Inline function 'kotlin.apply' call
    var this_3 = projectionalChild($this$rootIndent, tmp_0, tmp0_cellFactory_0, mapperBuilder_0, tmp2, processLibraryBuilders$lambda$lambda$lambda_54(completionTrait_0));
    this_3.xcp(processLibraryBuilders$lambda$lambda$lambda_55);
    this_3.ycp(processLibraryBuilders$lambda$lambda$lambda_56);
    this_3.ycp(processLibraryBuilders$lambda$lambda$lambda_57);
    return Unit_instance;
  }
  function processLibraryBuilders$lambda$lambda$lambda_40($referenceTag) {
    return function (_this__u8e3s4, src, cell, cellAction) {
      var tmp = _this__u8e3s4.d6u($referenceTag);
      var tmp$ret$0 = src.sfr();
      return completion(_this__u8e3s4, tmp, src, tmp$ret$0, cell, VOID, cellAction);
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda$o$get$lambda_3($cell) {
    return function (it) {
      return signalCompletionHappened($cell, false, it);
    };
  }
  function _no_name_provided__qut3iv_33($refCompletion, $this, $source) {
    this.wtx_1 = $refCompletion;
    this.xtx_1 = $this;
    this.ytx_1 = $source;
    CellTrait.call(this);
  }
  protoOf(_no_name_provided__qut3iv_33).n91 = function (cell, spec) {
    var tmp;
    if (equals(spec, Completion_getInstance().u9d_1)) {
      tmp = this.wtx_1(this.xtx_1, this.ytx_1, cell, processLibraryBuilders$lambda$lambda$lambda$o$get$lambda_3(cell));
    } else {
      tmp = protoOf(CellTrait).n91.call(this, cell, spec);
    }
    return tmp;
  };
  function processLibraryBuilders$lambda$lambda$lambda_41($refCompletion) {
    return function (_this__u8e3s4, source) {
      return new _no_name_provided__qut3iv_33($refCompletion, _this__u8e3s4, source);
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda$lambda_3(s) {
    return s.sfr();
  }
  function processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_7($property) {
    return function ($this$setup, source, textCell) {
      var referenceTextPropSupplier = getLoopQuerySupplier($property);
      var loopQuery = referenceTextPropSupplier(source, $this$setup.gcq(), textCell);
      $this$setup.l8b(syncOneWay(loopQuery, textCell.o8w()));
      var tmp = getKClass(QualifiedReferenceContent);
      connectWithRefSupport(textCell, loopQuery, tmp, processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda$lambda_3);
      return Unit_instance;
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_8($refCompletion) {
    return function ($this$completion, _unused_var__etf5q3, textCell, _unused_var__etf5q3_0) {
      var refCompletionArgs = getRefCompletionArgs(textCell);
      var source = refCompletionArgs.gdb_1;
      var cellAction = refCompletionArgs.hdb_1;
      return $refCompletion($this$completion, source, textCell, cellAction);
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda_3($property, $refCompletion) {
    return function ($this$editableText) {
      $this$editableText.xcp(processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_7($property));
      completion_1($this$editableText, processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_8($refCompletion));
      return Unit_instance;
    };
  }
  function _no_name_provided__qut3iv_34($cellBuilder, $refCompletion) {
    this.aty_1 = $refCompletion;
    this.ztx_1 = $cellBuilder;
  }
  protoOf(_no_name_provided__qut3iv_34).etv = function (placeholderText, validator, property) {
    return editableText(this, validator, VOID, placeholderText, processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda_3(property, this.aty_1));
  };
  protoOf(_no_name_provided__qut3iv_34).jcs = function (placeholderText, validator, property) {
    return this.etv(placeholderText, validator, property);
  };
  protoOf(_no_name_provided__qut3iv_34).fcq = function () {
    return this.ztx_1.fcq();
  };
  protoOf(_no_name_provided__qut3iv_34).ftv = function (child) {
    this.ztx_1.wcp(child);
  };
  protoOf(_no_name_provided__qut3iv_34).wcp = function (child) {
    return this.ftv(child);
  };
  protoOf(_no_name_provided__qut3iv_34).gtv = function (init) {
    this.ztx_1.xcp(init);
  };
  protoOf(_no_name_provided__qut3iv_34).xcp = function (init) {
    return this.gtv(init);
  };
  protoOf(_no_name_provided__qut3iv_34).htv = function (init) {
    this.ztx_1.ycp(init);
  };
  protoOf(_no_name_provided__qut3iv_34).ycp = function (init) {
    return this.htv(init);
  };
  protoOf(_no_name_provided__qut3iv_34).itv = function (source, cellMap, context) {
    return this.ztx_1.acq(source, cellMap, context);
  };
  protoOf(_no_name_provided__qut3iv_34).acq = function (source, cellMap, context) {
    return this.itv((!(source == null) ? isInterface(source, DomainNode) : false) ? source : THROW_CCE(), cellMap, context);
  };
  function processLibraryBuilders$lambda$lambda$lambda$lambda_5(it) {
    return it.y2();
  }
  function processLibraryBuilders$lambda$lambda$lambda_42($refCompletion) {
    return function ($this$rootIndent) {
      var cellBuilder = $this$rootIndent;
      // Inline function 'jetbrains.ocelot.langDef.editor.getReferenceCellBuilder' call
      var refCompletion = $refCompletion;
      var refCellBuilder = new _no_name_provided__qut3iv_34(cellBuilder, refCompletion);
      refCellBuilder.kcs('<link>', VOID, processLibraryBuilders$lambda$lambda$lambda$lambda_5);
      return Unit_instance;
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda_43() {
    // Inline function 'kotlin.also' call
    var this_0 = new IndentCell();
    Companion_getInstance_251().vda(this_0);
    return this_0;
  }
  function processLibraryBuilders$lambda$lambda$lambda_44(_unused_var__etf5q3, cell) {
    return get_forQueries(referenceData(cell).jda_1);
  }
  function processLibraryBuilders$lambda$lambda$lambda_45($completionTrait) {
    return function ($this$lambda, source, trait) {
      return CompositeCellTraits_instance.ra6([$completionTrait($this$lambda, source), trait]);
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda_46($this$setup, source, cell) {
    var referenceData_0 = referenceData(cell);
    var tmp$ret$0 = source.sfr();
    referenceData_0.wda(source, tmp$ret$0);
    return Unit_instance;
  }
  function processLibraryBuilders$lambda$lambda$lambda_47($this$setupSynchronizers, source, cell) {
    var tmp0 = $this$setupSynchronizers.gcq();
    // Inline function 'jetbrains.ocelot.langDef.references.synchronizers.getReferenceTargetSync' call
    var asyncTracker = new CellAsyncTracker(cell);
    var referenceData_0 = referenceData(cell);
    var tmp = ReferenceSynchronizers_instance;
    var tmp$ret$0 = source.sfr();
    var tmp$ret$1 = tmp.bdb(tmp0, tmp$ret$0, referenceData_0.jda_1, ResolveKind_LOOSE_getInstance(), null, asyncTracker);
    $this$setupSynchronizers.l8b(tmp$ret$1);
    $this$setupSynchronizers.l8b(getReferenceDataMonitorSynchronizer(cell));
    return Unit_instance;
  }
  function processLibraryBuilders$lambda$lambda$lambda_48($this$setupSynchronizers, source, cell) {
    if ($this$setupSynchronizers.gcq().nd5()) {
      var tmp = $this$setupSynchronizers.gcq();
      var tmp$ret$0 = source.sfr();
      $this$setupSynchronizers.l8b(referenceOutOfScopeSynchronizer(tmp, cell, tmp$ret$0));
      $this$setupSynchronizers.l8b(highlightReferenceTargetOutOfSync(cell, cell.n92(ReferenceCells_getInstance().cdb_1)));
    }
    return Unit_instance;
  }
  function processLibraryBuilders$lambda$lambda$lambda_49($referenceTag) {
    return function (_this__u8e3s4, src, cell, cellAction) {
      var tmp = _this__u8e3s4.d6u($referenceTag);
      var tmp$ret$0 = src.ufp();
      return completion(_this__u8e3s4, tmp, src, tmp$ret$0, cell, VOID, cellAction);
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda$o$get$lambda_4($cell) {
    return function (it) {
      return signalCompletionHappened($cell, false, it);
    };
  }
  function _no_name_provided__qut3iv_35($refCompletion, $this, $source) {
    this.bty_1 = $refCompletion;
    this.cty_1 = $this;
    this.dty_1 = $source;
    CellTrait.call(this);
  }
  protoOf(_no_name_provided__qut3iv_35).n91 = function (cell, spec) {
    var tmp;
    if (equals(spec, Completion_getInstance().u9d_1)) {
      tmp = this.bty_1(this.cty_1, this.dty_1, cell, processLibraryBuilders$lambda$lambda$lambda$o$get$lambda_4(cell));
    } else {
      tmp = protoOf(CellTrait).n91.call(this, cell, spec);
    }
    return tmp;
  };
  function processLibraryBuilders$lambda$lambda$lambda_50($refCompletion) {
    return function (_this__u8e3s4, source) {
      return new _no_name_provided__qut3iv_35($refCompletion, _this__u8e3s4, source);
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda$lambda_4(s) {
    return s.ufp();
  }
  function processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_9($property) {
    return function ($this$setup, source, textCell) {
      var referenceTextPropSupplier = getLoopQuerySupplier($property);
      var loopQuery = referenceTextPropSupplier(source, $this$setup.gcq(), textCell);
      $this$setup.l8b(syncOneWay(loopQuery, textCell.o8w()));
      var tmp = getKClass(QualifiedReferenceContent);
      connectWithRefSupport(textCell, loopQuery, tmp, processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda$lambda_4);
      return Unit_instance;
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_10($refCompletion) {
    return function ($this$completion, _unused_var__etf5q3, textCell, _unused_var__etf5q3_0) {
      var refCompletionArgs = getRefCompletionArgs(textCell);
      var source = refCompletionArgs.gdb_1;
      var cellAction = refCompletionArgs.hdb_1;
      return $refCompletion($this$completion, source, textCell, cellAction);
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda_4($property, $refCompletion) {
    return function ($this$editableText) {
      $this$editableText.xcp(processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_9($property));
      completion_1($this$editableText, processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_10($refCompletion));
      return Unit_instance;
    };
  }
  function _no_name_provided__qut3iv_36($cellBuilder, $refCompletion) {
    this.fty_1 = $refCompletion;
    this.ety_1 = $cellBuilder;
  }
  protoOf(_no_name_provided__qut3iv_36).etv = function (placeholderText, validator, property) {
    return editableText(this, validator, VOID, placeholderText, processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda_4(property, this.fty_1));
  };
  protoOf(_no_name_provided__qut3iv_36).jcs = function (placeholderText, validator, property) {
    return this.etv(placeholderText, validator, property);
  };
  protoOf(_no_name_provided__qut3iv_36).fcq = function () {
    return this.ety_1.fcq();
  };
  protoOf(_no_name_provided__qut3iv_36).ftv = function (child) {
    this.ety_1.wcp(child);
  };
  protoOf(_no_name_provided__qut3iv_36).wcp = function (child) {
    return this.ftv(child);
  };
  protoOf(_no_name_provided__qut3iv_36).gtv = function (init) {
    this.ety_1.xcp(init);
  };
  protoOf(_no_name_provided__qut3iv_36).xcp = function (init) {
    return this.gtv(init);
  };
  protoOf(_no_name_provided__qut3iv_36).htv = function (init) {
    this.ety_1.ycp(init);
  };
  protoOf(_no_name_provided__qut3iv_36).ycp = function (init) {
    return this.htv(init);
  };
  protoOf(_no_name_provided__qut3iv_36).itv = function (source, cellMap, context) {
    return this.ety_1.acq(source, cellMap, context);
  };
  protoOf(_no_name_provided__qut3iv_36).acq = function (source, cellMap, context) {
    return this.itv((!(source == null) ? isInterface(source, DomainNode) : false) ? source : THROW_CCE(), cellMap, context);
  };
  function processLibraryBuilders$lambda$lambda$lambda$lambda_6(it) {
    return it.y2();
  }
  function processLibraryBuilders$lambda$lambda$lambda_51($refCompletion) {
    return function ($this$rootIndent) {
      var cellBuilder = $this$rootIndent;
      // Inline function 'jetbrains.ocelot.langDef.editor.getReferenceCellBuilder' call
      var refCompletion = $refCompletion;
      var refCellBuilder = new _no_name_provided__qut3iv_36(cellBuilder, refCompletion);
      refCellBuilder.kcs('<process>', VOID, processLibraryBuilders$lambda$lambda$lambda$lambda_6);
      return Unit_instance;
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda_52() {
    // Inline function 'kotlin.also' call
    var this_0 = new IndentCell();
    Companion_getInstance_251().vda(this_0);
    return this_0;
  }
  function processLibraryBuilders$lambda$lambda$lambda_53(_unused_var__etf5q3, cell) {
    return get_forQueries(referenceData(cell).jda_1);
  }
  function processLibraryBuilders$lambda$lambda$lambda_54($completionTrait) {
    return function ($this$lambda, source, trait) {
      return CompositeCellTraits_instance.ra6([$completionTrait($this$lambda, source), trait]);
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda_55($this$setup, source, cell) {
    var referenceData_0 = referenceData(cell);
    var tmp$ret$0 = source.ufp();
    referenceData_0.wda(source, tmp$ret$0);
    return Unit_instance;
  }
  function processLibraryBuilders$lambda$lambda$lambda_56($this$setupSynchronizers, source, cell) {
    var tmp0 = $this$setupSynchronizers.gcq();
    // Inline function 'jetbrains.ocelot.langDef.references.synchronizers.getReferenceTargetSync' call
    var asyncTracker = new CellAsyncTracker(cell);
    var referenceData_0 = referenceData(cell);
    var tmp = ReferenceSynchronizers_instance;
    var tmp$ret$0 = source.ufp();
    var tmp$ret$1 = tmp.bdb(tmp0, tmp$ret$0, referenceData_0.jda_1, ResolveKind_LOOSE_getInstance(), null, asyncTracker);
    $this$setupSynchronizers.l8b(tmp$ret$1);
    $this$setupSynchronizers.l8b(getReferenceDataMonitorSynchronizer(cell));
    return Unit_instance;
  }
  function processLibraryBuilders$lambda$lambda$lambda_57($this$setupSynchronizers, source, cell) {
    if ($this$setupSynchronizers.gcq().nd5()) {
      var tmp = $this$setupSynchronizers.gcq();
      var tmp$ret$0 = source.ufp();
      $this$setupSynchronizers.l8b(referenceOutOfScopeSynchronizer(tmp, cell, tmp$ret$0));
      $this$setupSynchronizers.l8b(highlightReferenceTargetOutOfSync(cell, cell.n92(ReferenceCells_getInstance().cdb_1)));
    }
    return Unit_instance;
  }
  function processLibraryBuilders$lambda_4($this) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(ImportedLink_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      rootIndent(result, processLibraryBuilders$lambda$lambda_7);
      return this_0;
    };
  }
  function processLibraryBuilders$lambda$lambda_8($this$rootIndent) {
    placeholderInCollection($this$rootIndent, VOID, processLibraryBuilders$lambda$lambda$lambda_58);
    return Unit_instance;
  }
  function processLibraryBuilders$lambda$lambda$lambda_58($this$placeholderInCollection) {
    return abstractBindingEntryCompletion($this$placeholderInCollection);
  }
  function processLibraryBuilders$lambda_5($this) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(EmptyBindingEntry_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      rootIndent(result, processLibraryBuilders$lambda$lambda_8);
      return this_0;
    };
  }
  function processLibraryBuilders$lambda$lambda_9($this$rootIndent) {
    textProperty($this$rootIndent, '<name>', processLibraryBuilders$lambda$lambda$lambda_59);
    space($this$rootIndent);
    var tmp2 = processLibraryBuilders$lambda$lambda$lambda_60;
    // Inline function 'jetbrains.ocelot.langDef.editor.indentChild' call
    var init = processLibraryBuilders$lambda$lambda$lambda_61;
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.builder' call
    var this_0 = $this$rootIndent.fcq();
    var sourceType = getKClass(NotionType_0);
    var tmp$ret$0 = this_0.xcr(sourceType);
    indentChild($this$rootIndent, tmp2, tmp$ret$0, null, init);
    return Unit_instance;
  }
  function processLibraryBuilders$lambda$lambda$lambda_59(it) {
    return it.y2();
  }
  function processLibraryBuilders$lambda$lambda$lambda_60(it) {
    return it.sfq();
  }
  function processLibraryBuilders$lambda$lambda$lambda_61($this$indentChild) {
    $this$indentChild.mct(processLibraryBuilders$lambda$lambda$lambda$lambda_7);
    return Unit_instance;
  }
  function processLibraryBuilders$lambda$lambda$lambda$lambda_7($this$completion) {
    return notionTypeCompletion($this$completion);
  }
  function processLibraryBuilders$lambda_6($this) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(PropertyDeclaration_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      rootIndent(result, processLibraryBuilders$lambda$lambda_9);
      return this_0;
    };
  }
  function processLibraryBuilders$lambda$lambda_10($this$rootIndent) {
    var tmp2 = '<process>';
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget' call
    var referenceTag = Companion_getInstance_338().ihc_1;
    var refCompletion = processLibraryBuilders$lambda$lambda$lambda_62(referenceTag);
    var completionTrait = processLibraryBuilders$lambda$lambda$lambda_63(refCompletion);
    // Inline function 'kotlin.also' call
    var this_0 = new SimpleMapperBuilder($this$rootIndent.fcq(), getKClass(ProcessDeclaration_1));
    // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
    var result = new RootCellBuilderImpl(this_0);
    rootIndent(result, processLibraryBuilders$lambda$lambda$lambda_64(refCompletion));
    var mapperBuilder = this_0;
    var tmp0_cellFactory = new NamedCellFactory('referenceData', processLibraryBuilders$lambda$lambda$lambda_65);
    var tmp = processLibraryBuilders$lambda$lambda$lambda_66;
    // Inline function 'kotlin.apply' call
    var this_1 = projectionalChild($this$rootIndent, tmp, tmp0_cellFactory, mapperBuilder, tmp2, processLibraryBuilders$lambda$lambda$lambda_67(completionTrait));
    this_1.xcp(processLibraryBuilders$lambda$lambda$lambda_68);
    this_1.ycp(processLibraryBuilders$lambda$lambda$lambda_69);
    this_1.ycp(processLibraryBuilders$lambda$lambda$lambda_70);
    indentLabel($this$rootIndent, '(');
    var tmp2_0 = processLibraryBuilders$lambda$lambda$lambda_71;
    var tmp4 = '<parameters>';
    var tmp6 = processLibraryBuilders$lambda$lambda$lambda_72;
    // Inline function 'jetbrains.ocelot.langDef.editor.indentChildren' call
    var init = processLibraryBuilders$lambda$lambda$lambda_73;
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.builder' call
    var this_2 = $this$rootIndent.fcq();
    var sourceType = getKClass(BindingValuePlaceholder_1);
    var tmp$ret$7 = this_2.xcr(sourceType);
    indentChildren($this$rootIndent, tmp2_0, tmp$ret$7, tmp4, tmp6, init);
    indentLabel($this$rootIndent, ')', true);
    focusable($this$rootIndent, true);
    return Unit_instance;
  }
  function processLibraryBuilders$lambda$lambda$lambda_62($referenceTag) {
    return function (_this__u8e3s4, src, cell, cellAction) {
      var tmp = _this__u8e3s4.d6u($referenceTag);
      var tmp$ret$0 = src.vfr();
      return completion(_this__u8e3s4, tmp, src, tmp$ret$0, cell, VOID, cellAction);
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda$o$get$lambda_5($cell) {
    return function (it) {
      return signalCompletionHappened($cell, false, it);
    };
  }
  function _no_name_provided__qut3iv_37($refCompletion, $this, $source) {
    this.gty_1 = $refCompletion;
    this.hty_1 = $this;
    this.ity_1 = $source;
    CellTrait.call(this);
  }
  protoOf(_no_name_provided__qut3iv_37).n91 = function (cell, spec) {
    var tmp;
    if (equals(spec, Completion_getInstance().u9d_1)) {
      tmp = this.gty_1(this.hty_1, this.ity_1, cell, processLibraryBuilders$lambda$lambda$lambda$o$get$lambda_5(cell));
    } else {
      tmp = protoOf(CellTrait).n91.call(this, cell, spec);
    }
    return tmp;
  };
  function processLibraryBuilders$lambda$lambda$lambda_63($refCompletion) {
    return function (_this__u8e3s4, source) {
      return new _no_name_provided__qut3iv_37($refCompletion, _this__u8e3s4, source);
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda$lambda_5(s) {
    return s.vfr();
  }
  function processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_11($property) {
    return function ($this$setup, source, textCell) {
      var referenceTextPropSupplier = getLoopQuerySupplier($property);
      var loopQuery = referenceTextPropSupplier(source, $this$setup.gcq(), textCell);
      $this$setup.l8b(syncOneWay(loopQuery, textCell.o8w()));
      var tmp = getKClass(QualifiedReferenceContent);
      connectWithRefSupport(textCell, loopQuery, tmp, processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda$lambda_5);
      return Unit_instance;
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_12($refCompletion) {
    return function ($this$completion, _unused_var__etf5q3, textCell, _unused_var__etf5q3_0) {
      var refCompletionArgs = getRefCompletionArgs(textCell);
      var source = refCompletionArgs.gdb_1;
      var cellAction = refCompletionArgs.hdb_1;
      return $refCompletion($this$completion, source, textCell, cellAction);
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda_5($property, $refCompletion) {
    return function ($this$editableText) {
      $this$editableText.xcp(processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_11($property));
      completion_1($this$editableText, processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_12($refCompletion));
      return Unit_instance;
    };
  }
  function _no_name_provided__qut3iv_38($cellBuilder, $refCompletion) {
    this.kty_1 = $refCompletion;
    this.jty_1 = $cellBuilder;
  }
  protoOf(_no_name_provided__qut3iv_38).etv = function (placeholderText, validator, property) {
    return editableText(this, validator, VOID, placeholderText, processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda_5(property, this.kty_1));
  };
  protoOf(_no_name_provided__qut3iv_38).jcs = function (placeholderText, validator, property) {
    return this.etv(placeholderText, validator, property);
  };
  protoOf(_no_name_provided__qut3iv_38).fcq = function () {
    return this.jty_1.fcq();
  };
  protoOf(_no_name_provided__qut3iv_38).ftv = function (child) {
    this.jty_1.wcp(child);
  };
  protoOf(_no_name_provided__qut3iv_38).wcp = function (child) {
    return this.ftv(child);
  };
  protoOf(_no_name_provided__qut3iv_38).gtv = function (init) {
    this.jty_1.xcp(init);
  };
  protoOf(_no_name_provided__qut3iv_38).xcp = function (init) {
    return this.gtv(init);
  };
  protoOf(_no_name_provided__qut3iv_38).htv = function (init) {
    this.jty_1.ycp(init);
  };
  protoOf(_no_name_provided__qut3iv_38).ycp = function (init) {
    return this.htv(init);
  };
  protoOf(_no_name_provided__qut3iv_38).itv = function (source, cellMap, context) {
    return this.jty_1.acq(source, cellMap, context);
  };
  protoOf(_no_name_provided__qut3iv_38).acq = function (source, cellMap, context) {
    return this.itv((!(source == null) ? isInterface(source, DomainNode) : false) ? source : THROW_CCE(), cellMap, context);
  };
  function processLibraryBuilders$lambda$lambda$lambda$lambda_8(it) {
    return it.y2();
  }
  function processLibraryBuilders$lambda$lambda$lambda_64($refCompletion) {
    return function ($this$rootIndent) {
      var cellBuilder = $this$rootIndent;
      // Inline function 'jetbrains.ocelot.langDef.editor.getReferenceCellBuilder' call
      var refCompletion = $refCompletion;
      var refCellBuilder = new _no_name_provided__qut3iv_38(cellBuilder, refCompletion);
      refCellBuilder.kcs('<name>', VOID, processLibraryBuilders$lambda$lambda$lambda$lambda_8);
      return Unit_instance;
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda_65() {
    // Inline function 'kotlin.also' call
    var this_0 = new IndentCell();
    Companion_getInstance_251().vda(this_0);
    return this_0;
  }
  function processLibraryBuilders$lambda$lambda$lambda_66(_unused_var__etf5q3, cell) {
    return get_forQueries(referenceData(cell).jda_1);
  }
  function processLibraryBuilders$lambda$lambda$lambda_67($completionTrait) {
    return function ($this$lambda, source, trait) {
      return CompositeCellTraits_instance.ra6([$completionTrait($this$lambda, source), trait]);
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda_68($this$setup, source, cell) {
    var referenceData_0 = referenceData(cell);
    var tmp$ret$0 = source.vfr();
    referenceData_0.wda(source, tmp$ret$0);
    return Unit_instance;
  }
  function processLibraryBuilders$lambda$lambda$lambda_69($this$setupSynchronizers, source, cell) {
    var tmp0 = $this$setupSynchronizers.gcq();
    // Inline function 'jetbrains.ocelot.langDef.references.synchronizers.getReferenceTargetSync' call
    var asyncTracker = new CellAsyncTracker(cell);
    var referenceData_0 = referenceData(cell);
    var tmp = ReferenceSynchronizers_instance;
    var tmp$ret$0 = source.vfr();
    var tmp$ret$1 = tmp.bdb(tmp0, tmp$ret$0, referenceData_0.jda_1, ResolveKind_LOOSE_getInstance(), null, asyncTracker);
    $this$setupSynchronizers.l8b(tmp$ret$1);
    $this$setupSynchronizers.l8b(getReferenceDataMonitorSynchronizer(cell));
    return Unit_instance;
  }
  function processLibraryBuilders$lambda$lambda$lambda_70($this$setupSynchronizers, source, cell) {
    if ($this$setupSynchronizers.gcq().nd5()) {
      var tmp = $this$setupSynchronizers.gcq();
      var tmp$ret$0 = source.vfr();
      $this$setupSynchronizers.l8b(referenceOutOfScopeSynchronizer(tmp, cell, tmp$ret$0));
      $this$setupSynchronizers.l8b(highlightReferenceTargetOutOfSync(cell, cell.n92(ReferenceCells_getInstance().cdb_1)));
    }
    return Unit_instance;
  }
  function processLibraryBuilders$lambda$lambda$lambda_71(it) {
    return it.kfr();
  }
  function processLibraryBuilders$lambda$lambda$lambda_72(it) {
    return CellLists_instance.saa(it, ', ');
  }
  function processLibraryBuilders$lambda$lambda$lambda_73($this$indentChildren) {
    defaultItem($this$indentChildren, processLibraryBuilders$lambda$lambda$lambda$lambda_9);
    $this$indentChildren.mct(processLibraryBuilders$lambda$lambda$lambda$lambda_10);
    return Unit_instance;
  }
  function processLibraryBuilders$lambda$lambda$lambda$lambda_9($this$defaultItem) {
    return BindingValuePlaceholder($this$defaultItem.l6z());
  }
  function processLibraryBuilders$lambda$lambda$lambda$lambda_10($this$completion) {
    return bindingValueCompletion($this$completion);
  }
  function processLibraryBuilders$lambda_7($this) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(LibraryProcessSpecification_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      rootIndent(result, processLibraryBuilders$lambda$lambda_10);
      return this_0;
    };
  }
  function processLibraryBuilders$lambda$lambda_11($this$rootIndent) {
    var tmp2 = '<property>';
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget' call
    var referenceTag = Companion_getInstance_343().rlt_1;
    var refCompletion = processLibraryBuilders$lambda$lambda$lambda_74(referenceTag);
    var completionTrait = processLibraryBuilders$lambda$lambda$lambda_75(refCompletion);
    // Inline function 'kotlin.also' call
    var this_0 = new SimpleMapperBuilder($this$rootIndent.fcq(), getKClass(AbstractProperty));
    // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
    var result = new RootCellBuilderImpl(this_0);
    rootIndent(result, processLibraryBuilders$lambda$lambda$lambda_76(refCompletion));
    var mapperBuilder = this_0;
    var tmp0_cellFactory = new NamedCellFactory('referenceData', processLibraryBuilders$lambda$lambda$lambda_77);
    var tmp = processLibraryBuilders$lambda$lambda$lambda_78;
    // Inline function 'kotlin.apply' call
    var this_1 = projectionalChild($this$rootIndent, tmp, tmp0_cellFactory, mapperBuilder, tmp2, processLibraryBuilders$lambda$lambda$lambda_79(completionTrait));
    this_1.xcp(processLibraryBuilders$lambda$lambda$lambda_80);
    this_1.ycp(processLibraryBuilders$lambda$lambda$lambda_81);
    this_1.ycp(processLibraryBuilders$lambda$lambda$lambda_82);
    space($this$rootIndent);
    label($this$rootIndent, '=');
    space($this$rootIndent);
    var tmp2_0 = processLibraryBuilders$lambda$lambda$lambda_83;
    // Inline function 'jetbrains.ocelot.langDef.editor.indentChild' call
    var init = processLibraryBuilders$lambda$lambda$lambda_84;
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.builder' call
    var this_2 = $this$rootIndent.fcq();
    var sourceType = getKClass(AbstractValue);
    var tmp$ret$7 = this_2.xcr(sourceType);
    indentChild($this$rootIndent, tmp2_0, tmp$ret$7, '<value>', init);
    return Unit_instance;
  }
  function processLibraryBuilders$lambda$lambda$lambda_74($referenceTag) {
    return function (_this__u8e3s4, src, cell, cellAction) {
      var tmp = _this__u8e3s4.d6u($referenceTag);
      var tmp$ret$0 = src.q6q();
      return completion(_this__u8e3s4, tmp, src, tmp$ret$0, cell, VOID, cellAction);
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda$o$get$lambda_6($cell) {
    return function (it) {
      return signalCompletionHappened($cell, false, it);
    };
  }
  function _no_name_provided__qut3iv_39($refCompletion, $this, $source) {
    this.lty_1 = $refCompletion;
    this.mty_1 = $this;
    this.nty_1 = $source;
    CellTrait.call(this);
  }
  protoOf(_no_name_provided__qut3iv_39).n91 = function (cell, spec) {
    var tmp;
    if (equals(spec, Completion_getInstance().u9d_1)) {
      tmp = this.lty_1(this.mty_1, this.nty_1, cell, processLibraryBuilders$lambda$lambda$lambda$o$get$lambda_6(cell));
    } else {
      tmp = protoOf(CellTrait).n91.call(this, cell, spec);
    }
    return tmp;
  };
  function processLibraryBuilders$lambda$lambda$lambda_75($refCompletion) {
    return function (_this__u8e3s4, source) {
      return new _no_name_provided__qut3iv_39($refCompletion, _this__u8e3s4, source);
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda$lambda_6(s) {
    return s.q6q();
  }
  function processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_13($property) {
    return function ($this$setup, source, textCell) {
      var referenceTextPropSupplier = getLoopQuerySupplier($property);
      var loopQuery = referenceTextPropSupplier(source, $this$setup.gcq(), textCell);
      $this$setup.l8b(syncOneWay(loopQuery, textCell.o8w()));
      var tmp = getKClass(QualifiedReferenceContent);
      connectWithRefSupport(textCell, loopQuery, tmp, processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda$lambda_6);
      return Unit_instance;
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_14($refCompletion) {
    return function ($this$completion, _unused_var__etf5q3, textCell, _unused_var__etf5q3_0) {
      var refCompletionArgs = getRefCompletionArgs(textCell);
      var source = refCompletionArgs.gdb_1;
      var cellAction = refCompletionArgs.hdb_1;
      return $refCompletion($this$completion, source, textCell, cellAction);
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda_6($property, $refCompletion) {
    return function ($this$editableText) {
      $this$editableText.xcp(processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_13($property));
      completion_1($this$editableText, processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_14($refCompletion));
      return Unit_instance;
    };
  }
  function _no_name_provided__qut3iv_40($cellBuilder, $refCompletion) {
    this.pty_1 = $refCompletion;
    this.oty_1 = $cellBuilder;
  }
  protoOf(_no_name_provided__qut3iv_40).etv = function (placeholderText, validator, property) {
    return editableText(this, validator, VOID, placeholderText, processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda_6(property, this.pty_1));
  };
  protoOf(_no_name_provided__qut3iv_40).jcs = function (placeholderText, validator, property) {
    return this.etv(placeholderText, validator, property);
  };
  protoOf(_no_name_provided__qut3iv_40).fcq = function () {
    return this.oty_1.fcq();
  };
  protoOf(_no_name_provided__qut3iv_40).ftv = function (child) {
    this.oty_1.wcp(child);
  };
  protoOf(_no_name_provided__qut3iv_40).wcp = function (child) {
    return this.ftv(child);
  };
  protoOf(_no_name_provided__qut3iv_40).gtv = function (init) {
    this.oty_1.xcp(init);
  };
  protoOf(_no_name_provided__qut3iv_40).xcp = function (init) {
    return this.gtv(init);
  };
  protoOf(_no_name_provided__qut3iv_40).htv = function (init) {
    this.oty_1.ycp(init);
  };
  protoOf(_no_name_provided__qut3iv_40).ycp = function (init) {
    return this.htv(init);
  };
  protoOf(_no_name_provided__qut3iv_40).itv = function (source, cellMap, context) {
    return this.oty_1.acq(source, cellMap, context);
  };
  protoOf(_no_name_provided__qut3iv_40).acq = function (source, cellMap, context) {
    return this.itv((!(source == null) ? isInterface(source, DomainNode) : false) ? source : THROW_CCE(), cellMap, context);
  };
  function processLibraryBuilders$lambda$lambda$lambda$lambda_11(it) {
    return it.y2();
  }
  function processLibraryBuilders$lambda$lambda$lambda_76($refCompletion) {
    return function ($this$rootIndent) {
      var cellBuilder = $this$rootIndent;
      // Inline function 'jetbrains.ocelot.langDef.editor.getReferenceCellBuilder' call
      var refCompletion = $refCompletion;
      var refCellBuilder = new _no_name_provided__qut3iv_40(cellBuilder, refCompletion);
      refCellBuilder.kcs('<property>', VOID, processLibraryBuilders$lambda$lambda$lambda$lambda_11);
      return Unit_instance;
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda_77() {
    // Inline function 'kotlin.also' call
    var this_0 = new IndentCell();
    Companion_getInstance_251().vda(this_0);
    return this_0;
  }
  function processLibraryBuilders$lambda$lambda$lambda_78(_unused_var__etf5q3, cell) {
    return get_forQueries(referenceData(cell).jda_1);
  }
  function processLibraryBuilders$lambda$lambda$lambda_79($completionTrait) {
    return function ($this$lambda, source, trait) {
      return CompositeCellTraits_instance.ra6([$completionTrait($this$lambda, source), trait]);
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda_80($this$setup, source, cell) {
    var referenceData_0 = referenceData(cell);
    var tmp$ret$0 = source.q6q();
    referenceData_0.wda(source, tmp$ret$0);
    return Unit_instance;
  }
  function processLibraryBuilders$lambda$lambda$lambda_81($this$setupSynchronizers, source, cell) {
    var tmp0 = $this$setupSynchronizers.gcq();
    // Inline function 'jetbrains.ocelot.langDef.references.synchronizers.getReferenceTargetSync' call
    var asyncTracker = new CellAsyncTracker(cell);
    var referenceData_0 = referenceData(cell);
    var tmp = ReferenceSynchronizers_instance;
    var tmp$ret$0 = source.q6q();
    var tmp$ret$1 = tmp.bdb(tmp0, tmp$ret$0, referenceData_0.jda_1, ResolveKind_LOOSE_getInstance(), null, asyncTracker);
    $this$setupSynchronizers.l8b(tmp$ret$1);
    $this$setupSynchronizers.l8b(getReferenceDataMonitorSynchronizer(cell));
    return Unit_instance;
  }
  function processLibraryBuilders$lambda$lambda$lambda_82($this$setupSynchronizers, source, cell) {
    if ($this$setupSynchronizers.gcq().nd5()) {
      var tmp = $this$setupSynchronizers.gcq();
      var tmp$ret$0 = source.q6q();
      $this$setupSynchronizers.l8b(referenceOutOfScopeSynchronizer(tmp, cell, tmp$ret$0));
      $this$setupSynchronizers.l8b(highlightReferenceTargetOutOfSync(cell, cell.n92(ReferenceCells_getInstance().cdb_1)));
    }
    return Unit_instance;
  }
  function processLibraryBuilders$lambda$lambda$lambda_83(it) {
    return it.a1();
  }
  function processLibraryBuilders$lambda$lambda$lambda_84($this$indentChild) {
    defaultItem($this$indentChild, processLibraryBuilders$lambda$lambda$lambda$lambda_12);
    $this$indentChild.mct(processLibraryBuilders$lambda$lambda$lambda$lambda_13);
    return Unit_instance;
  }
  function processLibraryBuilders$lambda$lambda$lambda$lambda_12($this$defaultItem) {
    // Inline function 'kotlin.apply' call
    var this_0 = MeasurableValue($this$defaultItem.l6z());
    this_0.pib(0);
    return this_0;
  }
  function processLibraryBuilders$lambda$lambda$lambda$lambda_13($this$completion) {
    return abstractValueCompletion($this$completion);
  }
  function processLibraryBuilders$lambda_8($this) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(PropertyValue_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      rootIndent(result, processLibraryBuilders$lambda$lambda_11);
      return this_0;
    };
  }
  function processLibraryBuilders$lambda$lambda_12($this$rootIndent) {
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget' call
    var referenceTag = Companion_getInstance_329().rfv_1;
    var refCompletion = processLibraryBuilders$lambda$lambda$lambda_85(referenceTag);
    var completionTrait = processLibraryBuilders$lambda$lambda$lambda_86(refCompletion);
    // Inline function 'kotlin.also' call
    var this_0 = new SimpleMapperBuilder($this$rootIndent.fcq(), getKClass(AbstractLink));
    // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
    var result = new RootCellBuilderImpl(this_0);
    rootIndent(result, processLibraryBuilders$lambda$lambda$lambda_87(refCompletion));
    var mapperBuilder = this_0;
    var tmp0_cellFactory = new NamedCellFactory('referenceData', processLibraryBuilders$lambda$lambda$lambda_88);
    var tmp = processLibraryBuilders$lambda$lambda$lambda_89;
    // Inline function 'kotlin.apply' call
    var this_1 = projectionalChild($this$rootIndent, tmp, tmp0_cellFactory, mapperBuilder, '<link>', processLibraryBuilders$lambda$lambda$lambda_90(completionTrait));
    this_1.xcp(processLibraryBuilders$lambda$lambda$lambda_91);
    this_1.ycp(processLibraryBuilders$lambda$lambda$lambda_92);
    this_1.ycp(processLibraryBuilders$lambda$lambda$lambda_93);
    space($this$rootIndent);
    label($this$rootIndent, '=');
    space($this$rootIndent);
    var tmp2 = processLibraryBuilders$lambda$lambda$lambda_94;
    // Inline function 'jetbrains.ocelot.langDef.editor.indentChild' call
    var init = processLibraryBuilders$lambda$lambda$lambda_95;
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.builder' call
    var this_2 = $this$rootIndent.fcq();
    var sourceType = getKClass(AbstractValue);
    var tmp$ret$7 = this_2.xcr(sourceType);
    indentChild($this$rootIndent, tmp2, tmp$ret$7, '<value>', init);
    return Unit_instance;
  }
  function processLibraryBuilders$lambda$lambda$lambda_85($referenceTag) {
    return function (_this__u8e3s4, src, cell, cellAction) {
      var tmp = _this__u8e3s4.d6u($referenceTag);
      var tmp$ret$0 = src.cft();
      return completion(_this__u8e3s4, tmp, src, tmp$ret$0, cell, VOID, cellAction);
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda$o$get$lambda_7($cell) {
    return function (it) {
      return signalCompletionHappened($cell, false, it);
    };
  }
  function _no_name_provided__qut3iv_41($refCompletion, $this, $source) {
    this.qty_1 = $refCompletion;
    this.rty_1 = $this;
    this.sty_1 = $source;
    CellTrait.call(this);
  }
  protoOf(_no_name_provided__qut3iv_41).n91 = function (cell, spec) {
    var tmp;
    if (equals(spec, Completion_getInstance().u9d_1)) {
      tmp = this.qty_1(this.rty_1, this.sty_1, cell, processLibraryBuilders$lambda$lambda$lambda$o$get$lambda_7(cell));
    } else {
      tmp = protoOf(CellTrait).n91.call(this, cell, spec);
    }
    return tmp;
  };
  function processLibraryBuilders$lambda$lambda$lambda_86($refCompletion) {
    return function (_this__u8e3s4, source) {
      return new _no_name_provided__qut3iv_41($refCompletion, _this__u8e3s4, source);
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda$lambda_7(s) {
    return s.cft();
  }
  function processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_15($property) {
    return function ($this$setup, source, textCell) {
      var referenceTextPropSupplier = getLoopQuerySupplier($property);
      var loopQuery = referenceTextPropSupplier(source, $this$setup.gcq(), textCell);
      $this$setup.l8b(syncOneWay(loopQuery, textCell.o8w()));
      var tmp = getKClass(QualifiedReferenceContent);
      connectWithRefSupport(textCell, loopQuery, tmp, processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda$lambda_7);
      return Unit_instance;
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_16($refCompletion) {
    return function ($this$completion, _unused_var__etf5q3, textCell, _unused_var__etf5q3_0) {
      var refCompletionArgs = getRefCompletionArgs(textCell);
      var source = refCompletionArgs.gdb_1;
      var cellAction = refCompletionArgs.hdb_1;
      return $refCompletion($this$completion, source, textCell, cellAction);
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda_7($property, $refCompletion) {
    return function ($this$editableText) {
      $this$editableText.xcp(processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_15($property));
      completion_1($this$editableText, processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_16($refCompletion));
      return Unit_instance;
    };
  }
  function _no_name_provided__qut3iv_42($cellBuilder, $refCompletion) {
    this.uty_1 = $refCompletion;
    this.tty_1 = $cellBuilder;
  }
  protoOf(_no_name_provided__qut3iv_42).etv = function (placeholderText, validator, property) {
    return editableText(this, validator, VOID, placeholderText, processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda_7(property, this.uty_1));
  };
  protoOf(_no_name_provided__qut3iv_42).jcs = function (placeholderText, validator, property) {
    return this.etv(placeholderText, validator, property);
  };
  protoOf(_no_name_provided__qut3iv_42).fcq = function () {
    return this.tty_1.fcq();
  };
  protoOf(_no_name_provided__qut3iv_42).ftv = function (child) {
    this.tty_1.wcp(child);
  };
  protoOf(_no_name_provided__qut3iv_42).wcp = function (child) {
    return this.ftv(child);
  };
  protoOf(_no_name_provided__qut3iv_42).gtv = function (init) {
    this.tty_1.xcp(init);
  };
  protoOf(_no_name_provided__qut3iv_42).xcp = function (init) {
    return this.gtv(init);
  };
  protoOf(_no_name_provided__qut3iv_42).htv = function (init) {
    this.tty_1.ycp(init);
  };
  protoOf(_no_name_provided__qut3iv_42).ycp = function (init) {
    return this.htv(init);
  };
  protoOf(_no_name_provided__qut3iv_42).itv = function (source, cellMap, context) {
    return this.tty_1.acq(source, cellMap, context);
  };
  protoOf(_no_name_provided__qut3iv_42).acq = function (source, cellMap, context) {
    return this.itv((!(source == null) ? isInterface(source, DomainNode) : false) ? source : THROW_CCE(), cellMap, context);
  };
  function processLibraryBuilders$lambda$lambda$lambda$lambda_14(it) {
    return it.y2();
  }
  function processLibraryBuilders$lambda$lambda$lambda_87($refCompletion) {
    return function ($this$rootIndent) {
      var cellBuilder = $this$rootIndent;
      // Inline function 'jetbrains.ocelot.langDef.editor.getReferenceCellBuilder' call
      var refCompletion = $refCompletion;
      var refCellBuilder = new _no_name_provided__qut3iv_42(cellBuilder, refCompletion);
      refCellBuilder.kcs('<link>', VOID, processLibraryBuilders$lambda$lambda$lambda$lambda_14);
      return Unit_instance;
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda_88() {
    // Inline function 'kotlin.also' call
    var this_0 = new IndentCell();
    Companion_getInstance_251().vda(this_0);
    return this_0;
  }
  function processLibraryBuilders$lambda$lambda$lambda_89(_unused_var__etf5q3, cell) {
    return get_forQueries(referenceData(cell).jda_1);
  }
  function processLibraryBuilders$lambda$lambda$lambda_90($completionTrait) {
    return function ($this$lambda, source, trait) {
      return CompositeCellTraits_instance.ra6([$completionTrait($this$lambda, source), trait]);
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda_91($this$setup, source, cell) {
    var referenceData_0 = referenceData(cell);
    var tmp$ret$0 = source.cft();
    referenceData_0.wda(source, tmp$ret$0);
    return Unit_instance;
  }
  function processLibraryBuilders$lambda$lambda$lambda_92($this$setupSynchronizers, source, cell) {
    var tmp0 = $this$setupSynchronizers.gcq();
    // Inline function 'jetbrains.ocelot.langDef.references.synchronizers.getReferenceTargetSync' call
    var asyncTracker = new CellAsyncTracker(cell);
    var referenceData_0 = referenceData(cell);
    var tmp = ReferenceSynchronizers_instance;
    var tmp$ret$0 = source.cft();
    var tmp$ret$1 = tmp.bdb(tmp0, tmp$ret$0, referenceData_0.jda_1, ResolveKind_LOOSE_getInstance(), null, asyncTracker);
    $this$setupSynchronizers.l8b(tmp$ret$1);
    $this$setupSynchronizers.l8b(getReferenceDataMonitorSynchronizer(cell));
    return Unit_instance;
  }
  function processLibraryBuilders$lambda$lambda$lambda_93($this$setupSynchronizers, source, cell) {
    if ($this$setupSynchronizers.gcq().nd5()) {
      var tmp = $this$setupSynchronizers.gcq();
      var tmp$ret$0 = source.cft();
      $this$setupSynchronizers.l8b(referenceOutOfScopeSynchronizer(tmp, cell, tmp$ret$0));
      $this$setupSynchronizers.l8b(highlightReferenceTargetOutOfSync(cell, cell.n92(ReferenceCells_getInstance().cdb_1)));
    }
    return Unit_instance;
  }
  function processLibraryBuilders$lambda$lambda$lambda_94(it) {
    return it.a1();
  }
  function processLibraryBuilders$lambda$lambda$lambda_95($this$indentChild) {
    $this$indentChild.mct(processLibraryBuilders$lambda$lambda$lambda$lambda_15);
    return Unit_instance;
  }
  function processLibraryBuilders$lambda$lambda$lambda$lambda_15($this$completion) {
    return abstractValueCompletion($this$completion);
  }
  function processLibraryBuilders$lambda_9($this) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(OntologyLinkValue_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      rootIndent(result, processLibraryBuilders$lambda$lambda_12);
      return this_0;
    };
  }
  function processLibraryBuilders$lambda$lambda_13($this$rootIndent) {
    placeholderInCollection($this$rootIndent, '<argument>', processLibraryBuilders$lambda$lambda$lambda_96);
    return Unit_instance;
  }
  function processLibraryBuilders$lambda$lambda$lambda_96($this$placeholderInCollection) {
    return bindingValueCompletion($this$placeholderInCollection);
  }
  function processLibraryBuilders$lambda_10($this) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(BindingValuePlaceholder_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      rootIndent(result, processLibraryBuilders$lambda$lambda_13);
      return this_0;
    };
  }
  function processLibraryBuilders$lambda$lambda_14(it) {
    return it.ifq();
  }
  function processLibraryBuilders$lambda$lambda_15(it) {
    return CellLists_instance.taa(it);
  }
  function processLibraryBuilders$lambda$lambda_16($this$indentChildren) {
    defaultItem($this$indentChildren, processLibraryBuilders$lambda$lambda$lambda_97);
    return Unit_instance;
  }
  function processLibraryBuilders$lambda$lambda$lambda_97($this$defaultItem) {
    return PropertyDeclaration($this$defaultItem.l6z());
  }
  function processLibraryBuilders$lambda_11($this) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(PropertyLibrary_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      var tmp2 = processLibraryBuilders$lambda$lambda_14;
      var tmp4 = processLibraryBuilders$lambda$lambda_15;
      // Inline function 'jetbrains.ocelot.langDef.editor.indentChildren' call
      var init = processLibraryBuilders$lambda$lambda_16;
      // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.builder' call
      var this_1 = result.fcq();
      var sourceType = getKClass(PropertyLibraryElement);
      var tmp$ret$0 = this_1.xcr(sourceType);
      indentChildren(result, tmp2, tmp$ret$0, null, tmp4, init);
      return this_0;
    };
  }
  function processLibraryBuilders$lambda$lambda_17(it) {
    return it.wft();
  }
  function processLibraryBuilders$lambda$lambda_18(it) {
    return CellLists_instance.taa(it);
  }
  function processLibraryBuilders$lambda$lambda_19($this$indentChildren) {
    defaultItem($this$indentChildren, processLibraryBuilders$lambda$lambda$lambda_98);
    return Unit_instance;
  }
  function processLibraryBuilders$lambda$lambda$lambda_98($this$defaultItem) {
    return ProcessKind($this$defaultItem.l6z());
  }
  function processLibraryBuilders$lambda_12($this) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(ProcessKindContainer_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      var tmp2 = processLibraryBuilders$lambda$lambda_17;
      var tmp4 = processLibraryBuilders$lambda$lambda_18;
      // Inline function 'jetbrains.ocelot.langDef.editor.indentChildren' call
      var init = processLibraryBuilders$lambda$lambda_19;
      // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.builder' call
      var this_1 = result.fcq();
      var sourceType = getKClass(ProcessKind_1);
      var tmp$ret$0 = this_1.xcr(sourceType);
      indentChildren(result, tmp2, tmp$ret$0, null, tmp4, init);
      return this_0;
    };
  }
  function processLibraryBuilders$lambda$lambda_20($this$rootIndent) {
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget' call
    var referenceTag = Companion_getInstance_325().gg9_1;
    var refCompletion = processLibraryBuilders$lambda$lambda$lambda_99(referenceTag);
    var completionTrait = processLibraryBuilders$lambda$lambda$lambda_100(refCompletion);
    // Inline function 'kotlin.also' call
    var this_0 = new SimpleMapperBuilder($this$rootIndent.fcq(), getKClass(FieldDeclaration_1));
    // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
    var result = new RootCellBuilderImpl(this_0);
    rootIndent(result, processLibraryBuilders$lambda$lambda$lambda_101(refCompletion));
    var mapperBuilder = this_0;
    var tmp0_cellFactory = new NamedCellFactory('referenceData', processLibraryBuilders$lambda$lambda$lambda_102);
    var tmp = processLibraryBuilders$lambda$lambda$lambda_103;
    // Inline function 'kotlin.apply' call
    var this_1 = projectionalChild($this$rootIndent, tmp, tmp0_cellFactory, mapperBuilder, '<field>', processLibraryBuilders$lambda$lambda$lambda_104(completionTrait));
    this_1.xcp(processLibraryBuilders$lambda$lambda$lambda_105);
    this_1.ycp(processLibraryBuilders$lambda$lambda$lambda_106);
    this_1.ycp(processLibraryBuilders$lambda$lambda$lambda_107);
    return Unit_instance;
  }
  function processLibraryBuilders$lambda$lambda$lambda_99($referenceTag) {
    return function (_this__u8e3s4, src, cell, cellAction) {
      var tmp = _this__u8e3s4.d6u($referenceTag);
      var tmp$ret$0 = src.tfq();
      return completion(_this__u8e3s4, tmp, src, tmp$ret$0, cell, VOID, cellAction);
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda$o$get$lambda_8($cell) {
    return function (it) {
      return signalCompletionHappened($cell, false, it);
    };
  }
  function _no_name_provided__qut3iv_43($refCompletion, $this, $source) {
    this.vty_1 = $refCompletion;
    this.wty_1 = $this;
    this.xty_1 = $source;
    CellTrait.call(this);
  }
  protoOf(_no_name_provided__qut3iv_43).n91 = function (cell, spec) {
    var tmp;
    if (equals(spec, Completion_getInstance().u9d_1)) {
      tmp = this.vty_1(this.wty_1, this.xty_1, cell, processLibraryBuilders$lambda$lambda$lambda$o$get$lambda_8(cell));
    } else {
      tmp = protoOf(CellTrait).n91.call(this, cell, spec);
    }
    return tmp;
  };
  function processLibraryBuilders$lambda$lambda$lambda_100($refCompletion) {
    return function (_this__u8e3s4, source) {
      return new _no_name_provided__qut3iv_43($refCompletion, _this__u8e3s4, source);
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda$lambda_8(s) {
    return s.tfq();
  }
  function processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_17($property) {
    return function ($this$setup, source, textCell) {
      var referenceTextPropSupplier = getLoopQuerySupplier($property);
      var loopQuery = referenceTextPropSupplier(source, $this$setup.gcq(), textCell);
      $this$setup.l8b(syncOneWay(loopQuery, textCell.o8w()));
      var tmp = getKClass(QualifiedReferenceContent);
      connectWithRefSupport(textCell, loopQuery, tmp, processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda$lambda_8);
      return Unit_instance;
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_18($refCompletion) {
    return function ($this$completion, _unused_var__etf5q3, textCell, _unused_var__etf5q3_0) {
      var refCompletionArgs = getRefCompletionArgs(textCell);
      var source = refCompletionArgs.gdb_1;
      var cellAction = refCompletionArgs.hdb_1;
      return $refCompletion($this$completion, source, textCell, cellAction);
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda_8($property, $refCompletion) {
    return function ($this$editableText) {
      $this$editableText.xcp(processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_17($property));
      completion_1($this$editableText, processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_18($refCompletion));
      return Unit_instance;
    };
  }
  function _no_name_provided__qut3iv_44($cellBuilder, $refCompletion) {
    this.zty_1 = $refCompletion;
    this.yty_1 = $cellBuilder;
  }
  protoOf(_no_name_provided__qut3iv_44).etv = function (placeholderText, validator, property) {
    return editableText(this, validator, VOID, placeholderText, processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda_8(property, this.zty_1));
  };
  protoOf(_no_name_provided__qut3iv_44).jcs = function (placeholderText, validator, property) {
    return this.etv(placeholderText, validator, property);
  };
  protoOf(_no_name_provided__qut3iv_44).fcq = function () {
    return this.yty_1.fcq();
  };
  protoOf(_no_name_provided__qut3iv_44).ftv = function (child) {
    this.yty_1.wcp(child);
  };
  protoOf(_no_name_provided__qut3iv_44).wcp = function (child) {
    return this.ftv(child);
  };
  protoOf(_no_name_provided__qut3iv_44).gtv = function (init) {
    this.yty_1.xcp(init);
  };
  protoOf(_no_name_provided__qut3iv_44).xcp = function (init) {
    return this.gtv(init);
  };
  protoOf(_no_name_provided__qut3iv_44).htv = function (init) {
    this.yty_1.ycp(init);
  };
  protoOf(_no_name_provided__qut3iv_44).ycp = function (init) {
    return this.htv(init);
  };
  protoOf(_no_name_provided__qut3iv_44).itv = function (source, cellMap, context) {
    return this.yty_1.acq(source, cellMap, context);
  };
  protoOf(_no_name_provided__qut3iv_44).acq = function (source, cellMap, context) {
    return this.itv((!(source == null) ? isInterface(source, DomainNode) : false) ? source : THROW_CCE(), cellMap, context);
  };
  function processLibraryBuilders$lambda$lambda$lambda$lambda_16(it) {
    return it.y2();
  }
  function processLibraryBuilders$lambda$lambda$lambda_101($refCompletion) {
    return function ($this$rootIndent) {
      var cellBuilder = $this$rootIndent;
      // Inline function 'jetbrains.ocelot.langDef.editor.getReferenceCellBuilder' call
      var refCompletion = $refCompletion;
      var refCellBuilder = new _no_name_provided__qut3iv_44(cellBuilder, refCompletion);
      refCellBuilder.kcs('<field>', VOID, processLibraryBuilders$lambda$lambda$lambda$lambda_16);
      return Unit_instance;
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda_102() {
    // Inline function 'kotlin.also' call
    var this_0 = new IndentCell();
    Companion_getInstance_251().vda(this_0);
    return this_0;
  }
  function processLibraryBuilders$lambda$lambda$lambda_103(_unused_var__etf5q3, cell) {
    return get_forQueries(referenceData(cell).jda_1);
  }
  function processLibraryBuilders$lambda$lambda$lambda_104($completionTrait) {
    return function ($this$lambda, source, trait) {
      return CompositeCellTraits_instance.ra6([$completionTrait($this$lambda, source), trait]);
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda_105($this$setup, source, cell) {
    var referenceData_0 = referenceData(cell);
    var tmp$ret$0 = source.tfq();
    referenceData_0.wda(source, tmp$ret$0);
    return Unit_instance;
  }
  function processLibraryBuilders$lambda$lambda$lambda_106($this$setupSynchronizers, source, cell) {
    var tmp0 = $this$setupSynchronizers.gcq();
    // Inline function 'jetbrains.ocelot.langDef.references.synchronizers.getReferenceTargetSync' call
    var asyncTracker = new CellAsyncTracker(cell);
    var referenceData_0 = referenceData(cell);
    var tmp = ReferenceSynchronizers_instance;
    var tmp$ret$0 = source.tfq();
    var tmp$ret$1 = tmp.bdb(tmp0, tmp$ret$0, referenceData_0.jda_1, ResolveKind_LOOSE_getInstance(), null, asyncTracker);
    $this$setupSynchronizers.l8b(tmp$ret$1);
    $this$setupSynchronizers.l8b(getReferenceDataMonitorSynchronizer(cell));
    return Unit_instance;
  }
  function processLibraryBuilders$lambda$lambda$lambda_107($this$setupSynchronizers, source, cell) {
    if ($this$setupSynchronizers.gcq().nd5()) {
      var tmp = $this$setupSynchronizers.gcq();
      var tmp$ret$0 = source.tfq();
      $this$setupSynchronizers.l8b(referenceOutOfScopeSynchronizer(tmp, cell, tmp$ret$0));
      $this$setupSynchronizers.l8b(highlightReferenceTargetOutOfSync(cell, cell.n92(ReferenceCells_getInstance().cdb_1)));
    }
    return Unit_instance;
  }
  function processLibraryBuilders$lambda_13($this) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(ExtensionFieldReference_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      rootIndent(result, processLibraryBuilders$lambda$lambda_20);
      return this_0;
    };
  }
  function processLibraryBuilders$lambda$lambda_21($this$rootIndent) {
    textProperty($this$rootIndent, '<name>', processLibraryBuilders$lambda$lambda$lambda_108);
    return Unit_instance;
  }
  function processLibraryBuilders$lambda$lambda$lambda_108(it) {
    return it.y2();
  }
  function processLibraryBuilders$lambda_14($this) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(ProcessKind_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      rootIndent(result, processLibraryBuilders$lambda$lambda_21);
      return this_0;
    };
  }
  function bindingEntries$lambda(it) {
    return CellLists_instance.taa(it);
  }
  function bindingEntries$lambda_0($this$indentChildren) {
    defaultItem($this$indentChildren, bindingEntries$lambda$lambda);
    $this$indentChildren.mct(bindingEntries$lambda$lambda_0);
    return Unit_instance;
  }
  function bindingEntries$lambda$lambda($this$defaultItem) {
    return EmptyBindingEntry($this$defaultItem.l6z());
  }
  function bindingEntries$lambda$lambda_0($this$completion) {
    return abstractBindingEntryCompletion($this$completion);
  }
  function propertyValueCompletion$lambda($this_propertyValueCompletion) {
    return function (it) {
      // Inline function 'kotlin.apply' call
      var this_0 = PropertyValue($this_propertyValueCompletion.l6z());
      this_0.q6q().b6p(it);
      return this_0;
    };
  }
  function linkValueCompletion$lambda($this_linkValueCompletion) {
    return function (it) {
      // Inline function 'kotlin.apply' call
      var this_0 = OntologyLinkValue($this_linkValueCompletion.l6z());
      this_0.cft().f2x(it);
      return this_0;
    };
  }
  function inplaceBindingEntryCompletion$lambda($this_inplaceBindingEntryCompletion) {
    return function (it) {
      // Inline function 'kotlin.apply' call
      var this_0 = OntologyLink($this_inplaceBindingEntryCompletion.l6z());
      this_0.xa1().f2x(LinkDeclaration($this_inplaceBindingEntryCompletion.l6z()));
      return this_0;
    };
  }
  function inplaceBindingEntryCompletion$lambda_0($this_inplaceBindingEntryCompletion) {
    return function (it) {
      // Inline function 'kotlin.apply' call
      var this_0 = BindingProperty($this_inplaceBindingEntryCompletion.l6z());
      this_0.q6q().f2x(PropertyDeclaration($this_inplaceBindingEntryCompletion.l6z()));
      return this_0;
    };
  }
  function importedBindingEntryCompletion$lambda($this_importedBindingEntryCompletion) {
    return function (it) {
      // Inline function 'kotlin.apply' call
      var this_0 = ImportedLink($this_importedBindingEntryCompletion.l6z());
      this_0.sfr().f2x(it);
      return this_0;
    };
  }
  function importedBindingEntryCompletion$lambda_0($this_importedBindingEntryCompletion) {
    return function (it) {
      // Inline function 'kotlin.apply' call
      var this_0 = ImportedProperty($this_importedBindingEntryCompletion.l6z());
      this_0.sfr().f2x(it);
      return this_0;
    };
  }
  function measurableValueCompletion$lambda($this_measurableValueCompletion) {
    return function (it) {
      // Inline function 'kotlin.apply' call
      var this_0 = MeasurableValue($this_measurableValueCompletion.l6z());
      this_0.pib(it);
      return this_0;
    };
  }
  function enumValueCompletion$lambda($this_enumValueCompletion) {
    return function (it) {
      // Inline function 'kotlin.apply' call
      var this_0 = EnumValue($this_enumValueCompletion.l6z());
      this_0.pfq().f2x(it);
      return this_0;
    };
  }
  function variableRefCompletion$lambda($this_variableRefCompletion) {
    return function (it) {
      // Inline function 'kotlin.apply' call
      var this_0 = VariableReferenceValue($this_variableRefCompletion.l6z());
      this_0.pfu().f2x(it);
      return this_0;
    };
  }
  function ontologyReferenceValueLibraryCompletion$lambda($this_ontologyReferenceValueLibraryCompletion) {
    return function (libraryName) {
      // Inline function 'kotlin.apply' call
      var this_0 = OntologyElementReferenceValueLibrary($this_ontologyReferenceValueLibraryCompletion.l6z());
      this_0.ffq().f2x(OntologyLibraryReference_2($this_ontologyReferenceValueLibraryCompletion.l6z(), libraryName));
      return this_0;
    };
  }
  function ontologyReferenceValueCompletion$lambda($this_ontologyReferenceValueCompletion) {
    return function (elementName) {
      // Inline function 'kotlin.apply' call
      var this_0 = OntologyElementReferenceValue($this_ontologyReferenceValueCompletion.l6z());
      this_0.gfq().f2x(OntologyElementReference_2($this_ontologyReferenceValueCompletion.l6z(), elementName));
      return this_0;
    };
  }
  function queryCommandBuilders(_this__u8e3s4) {
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder = new LazyMapperBuilder(queryCommandBuilders$lambda(_this__u8e3s4, _this__u8e3s4));
    _this__u8e3s4.vcr(builder);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_0 = new LazyMapperBuilder(queryCommandBuilders$lambda_0(_this__u8e3s4, _this__u8e3s4));
    _this__u8e3s4.vcr(builder_0);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_1 = new LazyMapperBuilder(queryCommandBuilders$lambda_1(_this__u8e3s4, _this__u8e3s4));
    _this__u8e3s4.vcr(builder_1);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_2 = new LazyMapperBuilder(queryCommandBuilders$lambda_2(_this__u8e3s4, _this__u8e3s4));
    _this__u8e3s4.vcr(builder_2);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_3 = new LazyMapperBuilder(queryCommandBuilders$lambda_3(_this__u8e3s4, _this__u8e3s4));
    _this__u8e3s4.vcr(builder_3);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_4 = new LazyMapperBuilder(queryCommandBuilders$lambda_4(_this__u8e3s4));
    _this__u8e3s4.vcr(builder_4);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_5 = new LazyMapperBuilder(queryCommandBuilders$lambda_5(_this__u8e3s4));
    _this__u8e3s4.vcr(builder_5);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_6 = new LazyMapperBuilder(queryCommandBuilders$lambda_6(_this__u8e3s4));
    _this__u8e3s4.vcr(builder_6);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_7 = new LazyMapperBuilder(queryCommandBuilders$lambda_7(_this__u8e3s4));
    _this__u8e3s4.vcr(builder_7);
  }
  function get_contextQueryRole(_this__u8e3s4) {
    // Inline function 'jetbrains.biokb.lang.builders.nodeRole' call
    // Inline function 'jetbrains.ocelot.langDef.editor.role' call
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.builder' call
    var sourceType = getKClass(ContextQuery_1);
    var tmp$ret$0 = _this__u8e3s4.xcr(sourceType);
    var builder = new ChildBuilder(tmp$ret$0);
    builder.gd0('<context>');
    builder.hd0(_get_contextQueryRole_$lambda_vdc7o1);
    var simpleClassName = ensureNotNull(getKClass(ContextQuery_1).ra());
    builder.kd0(simpleClassName, _get_contextQueryRole_$lambda_vdc7o1_0);
    return builder;
  }
  function libraryProcessSpecificationQueryChild(_this__u8e3s4, placeholder, role) {
    // Inline function 'jetbrains.ocelot.langDef.editor.indentChild' call
    var init = libraryProcessSpecificationQueryChild$lambda;
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.builder' call
    var this_0 = _this__u8e3s4.fcq();
    var sourceType = getKClass(LibraryProcessSpecificationQuery_1);
    var tmp$ret$0 = this_0.xcr(sourceType);
    indentChild(_this__u8e3s4, role, tmp$ret$0, placeholder, init);
  }
  function bindingValueQueryCompletion(_this__u8e3s4) {
    return plus_14(plus_14(bindingValueMaskCompletion(_this__u8e3s4), linkDeclarationValueQueryCompletion(_this__u8e3s4)), propertyDeclarationValueQueryCompletion(_this__u8e3s4));
  }
  function valueChild(_this__u8e3s4) {
    var tmp2 = valueChild$lambda;
    // Inline function 'jetbrains.ocelot.langDef.editor.indentChild' call
    var init = valueChild$lambda_0;
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.builder' call
    var this_0 = _this__u8e3s4.fcq();
    var sourceType = getKClass(AbstractValue);
    var tmp$ret$0 = this_0.xcr(sourceType);
    indentChild(_this__u8e3s4, tmp2, tmp$ret$0, '<value>', init);
  }
  function libraryProcessSpecificationQueryCompletion(_this__u8e3s4) {
    var tmp = nodeRefCompletion(_this__u8e3s4, Companion_getInstance_338().ihc_1);
    return map_2(tmp, libraryProcessSpecificationQueryCompletion$lambda(_this__u8e3s4));
  }
  function bindingValueMaskCompletion(_this__u8e3s4) {
    var tmp = bindingValueCompletion(_this__u8e3s4);
    return map_2(tmp, bindingValueMaskCompletion$lambda(_this__u8e3s4));
  }
  function linkDeclarationValueQueryCompletion(_this__u8e3s4) {
    var tmp = nodeRefCompletion(_this__u8e3s4, Companion_getInstance_347().eh7_1);
    return map_2(tmp, linkDeclarationValueQueryCompletion$lambda(_this__u8e3s4));
  }
  function propertyDeclarationValueQueryCompletion(_this__u8e3s4) {
    var tmp = nodeRefCompletion(_this__u8e3s4, Companion_getInstance_348().uhk_1);
    return map_2(tmp, propertyDeclarationValueQueryCompletion$lambda(_this__u8e3s4));
  }
  function queryCommandBuilders$lambda$lambda$lambda($this$default) {
    // Inline function 'kotlin.apply' call
    var this_0 = FindConnectionCommand($this$default.l6z());
    this_0.f4b().f2x(LibraryProcessSpecificationQuery($this$default.l6z()));
    this_0.g4b().f2x(LibraryProcessSpecificationQuery($this$default.l6z()));
    return this_0;
  }
  function queryCommandBuilders$lambda$lambda$lambda_0($this$clipboardParametersByCloner) {
    var tmp = new BaseNodeCloneSupport($this$clipboardParametersByCloner.gd3(), get_nodeFactory($this$clipboardParametersByCloner.l6z()));
    return isInterface(tmp, ClonerSupport) ? tmp : THROW_CCE();
  }
  function queryCommandBuilders$lambda$lambda$lambda_1(it) {
    return it.u51();
  }
  function queryCommandBuilders$lambda$lambda($this_queryCommandBuilders) {
    return function ($this$indent) {
      // Inline function 'jetbrains.biokb.lang.builders.nodeRole' call
      // Inline function 'jetbrains.ocelot.langDef.editor.role' call
      // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.builder' call
      var this_0 = $this_queryCommandBuilders;
      var sourceType = getKClass(Command_0);
      var tmp$ret$0 = this_0.xcr(sourceType);
      var builder = new ChildBuilder(tmp$ret$0);
      builder.gd0('<commands>');
      builder.jd0();
      builder.hd0(queryCommandBuilders$lambda$lambda$lambda);
      var simpleClassName = ensureNotNull(getKClass(Command_0).ra());
      builder.kd0(simpleClassName, queryCommandBuilders$lambda$lambda$lambda_0);
      var tmp = builder;
      children_1($this$indent, tmp, queryCommandBuilders$lambda$lambda$lambda_1);
      return Unit_instance;
    };
  }
  function queryCommandBuilders$lambda($this, $this_queryCommandBuilders) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(QueryCommands_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      indent(result, VOID, queryCommandBuilders$lambda$lambda($this_queryCommandBuilders));
      return this_0;
    };
  }
  function queryCommandBuilders$lambda$lambda$lambda_2(it) {
    return it.efr();
  }
  function queryCommandBuilders$lambda$lambda$lambda_3($this$indent) {
    newLine($this$indent);
    keyword($this$indent, 'from');
    space($this$indent);
    libraryProcessSpecificationQueryChild($this$indent, '<from>', queryCommandBuilders$lambda$lambda$lambda$lambda);
    return Unit_instance;
  }
  function queryCommandBuilders$lambda$lambda$lambda$lambda(it) {
    return it.f4b();
  }
  function queryCommandBuilders$lambda$lambda$lambda_4($this$indent) {
    newLine($this$indent);
    keyword($this$indent, 'to');
    space($this$indent);
    libraryProcessSpecificationQueryChild($this$indent, '<to>', queryCommandBuilders$lambda$lambda$lambda$lambda_0);
    return Unit_instance;
  }
  function queryCommandBuilders$lambda$lambda$lambda$lambda_0(it) {
    return it.g4b();
  }
  function queryCommandBuilders$lambda$lambda_0($this_queryCommandBuilders) {
    return function ($this$rootIndent) {
      keyword($this$rootIndent, 'find connection');
      newLine($this$rootIndent);
      keyword($this$rootIndent, 'with');
      space($this$rootIndent);
      var tmp = get_contextQueryRole($this_queryCommandBuilders);
      child_0($this$rootIndent, tmp, queryCommandBuilders$lambda$lambda$lambda_2);
      indent($this$rootIndent, true, queryCommandBuilders$lambda$lambda$lambda_3);
      indent($this$rootIndent, true, queryCommandBuilders$lambda$lambda$lambda_4);
      return Unit_instance;
    };
  }
  function queryCommandBuilders$lambda_0($this, $this_queryCommandBuilders) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(FindConnectionCommand_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      rootIndent(result, queryCommandBuilders$lambda$lambda_0($this_queryCommandBuilders));
      return this_0;
    };
  }
  function queryCommandBuilders$lambda$lambda$lambda_5(it) {
    return it.ffq();
  }
  function queryCommandBuilders$lambda$lambda$lambda_6(it) {
    return it.gfq();
  }
  function queryCommandBuilders$lambda$lambda_1($this_queryCommandBuilders) {
    return function ($this$rootIndent) {
      var tmp = get_ontologyLibraryReferenceRole($this_queryCommandBuilders);
      child_0($this$rootIndent, tmp, queryCommandBuilders$lambda$lambda$lambda_5);
      indentLabel($this$rootIndent, '/');
      var tmp_0 = get_ontologyElementReferenceRole($this_queryCommandBuilders);
      child_0($this$rootIndent, tmp_0, queryCommandBuilders$lambda$lambda$lambda_6);
      return Unit_instance;
    };
  }
  function queryCommandBuilders$lambda_1($this, $this_queryCommandBuilders) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(ContextQuery_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      rootIndent(result, queryCommandBuilders$lambda$lambda_1($this_queryCommandBuilders));
      return this_0;
    };
  }
  function queryCommandBuilders$lambda$lambda$lambda_7($referenceTag) {
    return function (_this__u8e3s4, src, cell, cellAction) {
      var tmp = _this__u8e3s4.d6u($referenceTag);
      var tmp$ret$0 = src.vfr();
      return completion(_this__u8e3s4, tmp, src, tmp$ret$0, cell, VOID, cellAction);
    };
  }
  function queryCommandBuilders$lambda$lambda$lambda$o$get$lambda($cell) {
    return function (it) {
      return signalCompletionHappened($cell, false, it);
    };
  }
  function _no_name_provided__qut3iv_45($refCompletion, $this, $source) {
    this.atz_1 = $refCompletion;
    this.btz_1 = $this;
    this.ctz_1 = $source;
    CellTrait.call(this);
  }
  protoOf(_no_name_provided__qut3iv_45).n91 = function (cell, spec) {
    var tmp;
    if (equals(spec, Completion_getInstance().u9d_1)) {
      tmp = this.atz_1(this.btz_1, this.ctz_1, cell, queryCommandBuilders$lambda$lambda$lambda$o$get$lambda(cell));
    } else {
      tmp = protoOf(CellTrait).n91.call(this, cell, spec);
    }
    return tmp;
  };
  function queryCommandBuilders$lambda$lambda$lambda_8($refCompletion) {
    return function (_this__u8e3s4, source) {
      return new _no_name_provided__qut3iv_45($refCompletion, _this__u8e3s4, source);
    };
  }
  function queryCommandBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda$lambda(s) {
    return s.vfr();
  }
  function queryCommandBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda($property) {
    return function ($this$setup, source, textCell) {
      var referenceTextPropSupplier = getLoopQuerySupplier($property);
      var loopQuery = referenceTextPropSupplier(source, $this$setup.gcq(), textCell);
      $this$setup.l8b(syncOneWay(loopQuery, textCell.o8w()));
      var tmp = getKClass(QualifiedReferenceContent);
      connectWithRefSupport(textCell, loopQuery, tmp, queryCommandBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda$lambda);
      return Unit_instance;
    };
  }
  function queryCommandBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_0($refCompletion) {
    return function ($this$completion, _unused_var__etf5q3, textCell, _unused_var__etf5q3_0) {
      var refCompletionArgs = getRefCompletionArgs(textCell);
      var source = refCompletionArgs.gdb_1;
      var cellAction = refCompletionArgs.hdb_1;
      return $refCompletion($this$completion, source, textCell, cellAction);
    };
  }
  function queryCommandBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda($property, $refCompletion) {
    return function ($this$editableText) {
      $this$editableText.xcp(queryCommandBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda($property));
      completion_1($this$editableText, queryCommandBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_0($refCompletion));
      return Unit_instance;
    };
  }
  function _no_name_provided__qut3iv_46($cellBuilder, $refCompletion) {
    this.etz_1 = $refCompletion;
    this.dtz_1 = $cellBuilder;
  }
  protoOf(_no_name_provided__qut3iv_46).etv = function (placeholderText, validator, property) {
    return editableText(this, validator, VOID, placeholderText, queryCommandBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda(property, this.etz_1));
  };
  protoOf(_no_name_provided__qut3iv_46).jcs = function (placeholderText, validator, property) {
    return this.etv(placeholderText, validator, property);
  };
  protoOf(_no_name_provided__qut3iv_46).fcq = function () {
    return this.dtz_1.fcq();
  };
  protoOf(_no_name_provided__qut3iv_46).ftv = function (child) {
    this.dtz_1.wcp(child);
  };
  protoOf(_no_name_provided__qut3iv_46).wcp = function (child) {
    return this.ftv(child);
  };
  protoOf(_no_name_provided__qut3iv_46).gtv = function (init) {
    this.dtz_1.xcp(init);
  };
  protoOf(_no_name_provided__qut3iv_46).xcp = function (init) {
    return this.gtv(init);
  };
  protoOf(_no_name_provided__qut3iv_46).htv = function (init) {
    this.dtz_1.ycp(init);
  };
  protoOf(_no_name_provided__qut3iv_46).ycp = function (init) {
    return this.htv(init);
  };
  protoOf(_no_name_provided__qut3iv_46).itv = function (source, cellMap, context) {
    return this.dtz_1.acq(source, cellMap, context);
  };
  protoOf(_no_name_provided__qut3iv_46).acq = function (source, cellMap, context) {
    return this.itv((!(source == null) ? isInterface(source, DomainNode) : false) ? source : THROW_CCE(), cellMap, context);
  };
  function queryCommandBuilders$lambda$lambda$lambda$lambda_1(it) {
    return it.y2();
  }
  function queryCommandBuilders$lambda$lambda$lambda_9($refCompletion) {
    return function ($this$rootIndent) {
      var cellBuilder = $this$rootIndent;
      // Inline function 'jetbrains.ocelot.langDef.editor.getReferenceCellBuilder' call
      var refCompletion = $refCompletion;
      var refCellBuilder = new _no_name_provided__qut3iv_46(cellBuilder, refCompletion);
      refCellBuilder.kcs('<process>', VOID, queryCommandBuilders$lambda$lambda$lambda$lambda_1);
      return Unit_instance;
    };
  }
  function queryCommandBuilders$lambda$lambda$lambda_10() {
    // Inline function 'kotlin.also' call
    var this_0 = new IndentCell();
    Companion_getInstance_251().vda(this_0);
    return this_0;
  }
  function queryCommandBuilders$lambda$lambda$lambda_11(_unused_var__etf5q3, cell) {
    return get_forQueries(referenceData(cell).jda_1);
  }
  function queryCommandBuilders$lambda$lambda$lambda_12($completionTrait) {
    return function ($this$lambda, source, trait) {
      return CompositeCellTraits_instance.ra6([$completionTrait($this$lambda, source), trait]);
    };
  }
  function queryCommandBuilders$lambda$lambda$lambda_13($this$setup, source, cell) {
    var referenceData_0 = referenceData(cell);
    var tmp$ret$0 = source.vfr();
    referenceData_0.wda(source, tmp$ret$0);
    return Unit_instance;
  }
  function queryCommandBuilders$lambda$lambda$lambda_14($this$setupSynchronizers, source, cell) {
    var tmp0 = $this$setupSynchronizers.gcq();
    // Inline function 'jetbrains.ocelot.langDef.references.synchronizers.getReferenceTargetSync' call
    var asyncTracker = new CellAsyncTracker(cell);
    var referenceData_0 = referenceData(cell);
    var tmp = ReferenceSynchronizers_instance;
    var tmp$ret$0 = source.vfr();
    var tmp$ret$1 = tmp.bdb(tmp0, tmp$ret$0, referenceData_0.jda_1, ResolveKind_LOOSE_getInstance(), null, asyncTracker);
    $this$setupSynchronizers.l8b(tmp$ret$1);
    $this$setupSynchronizers.l8b(getReferenceDataMonitorSynchronizer(cell));
    return Unit_instance;
  }
  function queryCommandBuilders$lambda$lambda$lambda_15($this$setupSynchronizers, source, cell) {
    if ($this$setupSynchronizers.gcq().nd5()) {
      var tmp = $this$setupSynchronizers.gcq();
      var tmp$ret$0 = source.vfr();
      $this$setupSynchronizers.l8b(referenceOutOfScopeSynchronizer(tmp, cell, tmp$ret$0));
      $this$setupSynchronizers.l8b(highlightReferenceTargetOutOfSync(cell, cell.n92(ReferenceCells_getInstance().cdb_1)));
    }
    return Unit_instance;
  }
  function queryCommandBuilders$lambda$lambda$lambda_16($this$completion) {
    return bindingValueQueryCompletion($this$completion);
  }
  function queryCommandBuilders$lambda$lambda$lambda_17($this$default) {
    return BindingValuePlaceholderQuery($this$default.l6z());
  }
  function queryCommandBuilders$lambda$lambda$lambda_18($this$clipboardParametersByCloner) {
    var tmp = new BaseNodeCloneSupport($this$clipboardParametersByCloner.gd3(), get_nodeFactory($this$clipboardParametersByCloner.l6z()));
    return isInterface(tmp, ClonerSupport) ? tmp : THROW_CCE();
  }
  function queryCommandBuilders$lambda$lambda$lambda_19(it) {
    return it.kfr();
  }
  function queryCommandBuilders$lambda$lambda_2($this_queryCommandBuilders) {
    return function ($this$rootIndent) {
      var tmp2 = '<process>';
      // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget' call
      var referenceTag = Companion_getInstance_338().ihc_1;
      var refCompletion = queryCommandBuilders$lambda$lambda$lambda_7(referenceTag);
      var completionTrait = queryCommandBuilders$lambda$lambda$lambda_8(refCompletion);
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this$rootIndent.fcq(), getKClass(ProcessDeclaration_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      rootIndent(result, queryCommandBuilders$lambda$lambda$lambda_9(refCompletion));
      var mapperBuilder = this_0;
      var tmp0_cellFactory = new NamedCellFactory('referenceData', queryCommandBuilders$lambda$lambda$lambda_10);
      var tmp = queryCommandBuilders$lambda$lambda$lambda_11;
      // Inline function 'kotlin.apply' call
      var this_1 = projectionalChild($this$rootIndent, tmp, tmp0_cellFactory, mapperBuilder, tmp2, queryCommandBuilders$lambda$lambda$lambda_12(completionTrait));
      this_1.xcp(queryCommandBuilders$lambda$lambda$lambda_13);
      this_1.ycp(queryCommandBuilders$lambda$lambda$lambda_14);
      this_1.ycp(queryCommandBuilders$lambda$lambda$lambda_15);
      indentLabel($this$rootIndent, '(');
      // Inline function 'jetbrains.biokb.lang.builders.nodeRole' call
      // Inline function 'jetbrains.ocelot.langDef.editor.role' call
      // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.builder' call
      var this_2 = $this_queryCommandBuilders;
      var sourceType = getKClass(BindingValuePlaceholderQuery_1);
      var tmp$ret$7 = this_2.xcr(sourceType);
      var builder = new ChildBuilder(tmp$ret$7);
      builder.fd0(queryCommandBuilders$lambda$lambda$lambda_16);
      builder.id0(', ');
      builder.hd0(queryCommandBuilders$lambda$lambda$lambda_17);
      var simpleClassName = ensureNotNull(getKClass(BindingValuePlaceholderQuery_1).ra());
      builder.kd0(simpleClassName, queryCommandBuilders$lambda$lambda$lambda_18);
      var tmp_0 = builder;
      children_1($this$rootIndent, tmp_0, queryCommandBuilders$lambda$lambda$lambda_19);
      indentLabel($this$rootIndent, ')', true);
      return Unit_instance;
    };
  }
  function queryCommandBuilders$lambda_2($this, $this_queryCommandBuilders) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(LibraryProcessSpecificationQuery_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      rootIndent(result, queryCommandBuilders$lambda$lambda_2($this_queryCommandBuilders));
      return this_0;
    };
  }
  function queryCommandBuilders$lambda$lambda$lambda_20($this$completion) {
    return bindingValueQueryCompletion($this$completion);
  }
  function queryCommandBuilders$lambda$lambda$lambda_21($this$clipboardParametersByCloner) {
    var tmp = new BaseNodeCloneSupport($this$clipboardParametersByCloner.gd3(), get_nodeFactory($this$clipboardParametersByCloner.l6z()));
    return isInterface(tmp, ClonerSupport) ? tmp : THROW_CCE();
  }
  function queryCommandBuilders$lambda$lambda$lambda_22(it) {
    return it.dft();
  }
  function queryCommandBuilders$lambda$lambda$lambda$lambda_2($this$completion) {
    return bindingValueQueryCompletion($this$completion);
  }
  function queryCommandBuilders$lambda$lambda$lambda$lambda_3($this$clipboardParametersByCloner) {
    var tmp = new BaseNodeCloneSupport($this$clipboardParametersByCloner.gd3(), get_nodeFactory($this$clipboardParametersByCloner.l6z()));
    return isInterface(tmp, ClonerSupport) ? tmp : THROW_CCE();
  }
  function queryCommandBuilders$lambda$lambda$lambda$lambda_4(it) {
    return it.eft();
  }
  function queryCommandBuilders$lambda$lambda$lambda$lambda_5($this$addTraitOnAttach, source, _unused_var__etf5q3, cellFinder) {
    return getDeleteTransformTrait_0(source, cellFinder);
  }
  function queryCommandBuilders$lambda$lambda$lambda_23($this_queryCommandBuilders) {
    return function ($this$indent) {
      // Inline function 'jetbrains.biokb.lang.builders.nodeRole' call
      // Inline function 'jetbrains.ocelot.langDef.editor.role' call
      // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.builder' call
      var this_0 = $this_queryCommandBuilders;
      var sourceType = getKClass(AbstractBindingValueQuery);
      var tmp$ret$0 = this_0.xcr(sourceType);
      var builder = new ChildBuilder(tmp$ret$0);
      builder.fd0(queryCommandBuilders$lambda$lambda$lambda$lambda_2);
      builder.gd0('<right>');
      var simpleClassName = ensureNotNull(getKClass(AbstractBindingValueQuery).ra());
      builder.kd0(simpleClassName, queryCommandBuilders$lambda$lambda$lambda$lambda_3);
      var tmp = builder;
      child_0($this$indent, tmp, queryCommandBuilders$lambda$lambda$lambda$lambda_4);
      addTraitOnAttach($this$indent, queryCommandBuilders$lambda$lambda$lambda$lambda_5);
      return Unit_instance;
    };
  }
  function queryCommandBuilders$lambda$lambda_3($this_queryCommandBuilders) {
    return function ($this$rootIndent) {
      // Inline function 'jetbrains.biokb.lang.builders.nodeRole' call
      // Inline function 'jetbrains.ocelot.langDef.editor.role' call
      // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.builder' call
      var this_0 = $this_queryCommandBuilders;
      var sourceType = getKClass(AbstractBindingValueQuery);
      var tmp$ret$0 = this_0.xcr(sourceType);
      var builder = new ChildBuilder(tmp$ret$0);
      builder.fd0(queryCommandBuilders$lambda$lambda$lambda_20);
      builder.gd0('<left>');
      var simpleClassName = ensureNotNull(getKClass(AbstractBindingValueQuery).ra());
      builder.kd0(simpleClassName, queryCommandBuilders$lambda$lambda$lambda_21);
      var tmp = builder;
      child_0($this$rootIndent, tmp, queryCommandBuilders$lambda$lambda$lambda_22);
      space($this$rootIndent);
      label($this$rootIndent, '||');
      space($this$rootIndent);
      indent($this$rootIndent, VOID, queryCommandBuilders$lambda$lambda$lambda_23($this_queryCommandBuilders));
      return Unit_instance;
    };
  }
  function queryCommandBuilders$lambda_3($this, $this_queryCommandBuilders) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(OrValueQuery_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      rootIndent(result, queryCommandBuilders$lambda$lambda_3($this_queryCommandBuilders));
      return this_0;
    };
  }
  function queryCommandBuilders$lambda$lambda_4($this$rootIndent) {
    var tmp2 = queryCommandBuilders$lambda$lambda$lambda_24;
    // Inline function 'jetbrains.ocelot.langDef.editor.indentChild' call
    var init = queryCommandBuilders$lambda$lambda$lambda_25;
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.builder' call
    var this_0 = $this$rootIndent.fcq();
    var sourceType = getKClass(BindingValuePlaceholder_1);
    var tmp$ret$0 = this_0.xcr(sourceType);
    indentChild($this$rootIndent, tmp2, tmp$ret$0, '<value>', init);
    // Inline function 'kotlin.apply' call
    var this_1 = editableText($this$rootIndent, isEmpty$ref_2(), '');
    rightTransform(this_1, queryCommandBuilders$lambda$lambda$lambda_26);
    return Unit_instance;
  }
  function queryCommandBuilders$lambda$lambda$lambda_24(it) {
    return it.a1();
  }
  function queryCommandBuilders$lambda$lambda$lambda_25($this$indentChild) {
    $this$indentChild.mct(queryCommandBuilders$lambda$lambda$lambda$lambda_6);
    return Unit_instance;
  }
  function queryCommandBuilders$lambda$lambda$lambda$lambda_6($this$completion) {
    return bindingValueCompletion($this$completion);
  }
  function isEmpty$ref_2() {
    var l = function (p0) {
      // Inline function 'kotlin.text.isEmpty' call
      return charSequenceLength(p0) === 0;
    };
    l.callableName = 'isEmpty';
    return l;
  }
  function queryCommandBuilders$lambda$lambda$lambda_26($this$rightTransform, source, _unused_var__etf5q3, cellFinder) {
    var tmp = CompletionSupplement_instance;
    return tmp.o9p([completes('||', queryCommandBuilders$lambda$lambda$lambda$lambda_7($this$rightTransform, source, cellFinder))]);
  }
  function _no_name_provided__qut3iv_47($this_rightTransform, $source, $cellFinder) {
    this.ftz_1 = $this_rightTransform;
    this.gtz_1 = $source;
    this.htz_1 = $cellFinder;
  }
  protoOf(_no_name_provided__qut3iv_47).n5w = function (builder) {
    // Inline function 'kotlin.let' call
    var it = OrValueQuery(this.ftz_1.l6z());
    var tmp = this.gtz_1.bp();
    var parentOr = (!(tmp == null) ? isInterface(tmp, OrValueQuery_1) : false) ? tmp : null;
    if (parentOr == null || equals(builder.l60(parentOr.eft()), this.gtz_1)) {
      var tmp_0 = it.dft();
      var tmp_1 = this.gtz_1.f6j();
      tmp_0.f2x(isInterface(tmp_1, BindingValueMask_1) ? tmp_1 : THROW_CCE());
      this.gtz_1.d6j(it);
    } else {
      var tmp_2 = it.eft();
      var tmp0_safe_receiver = builder.l60(parentOr.eft());
      var tmp_3 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.f6j();
      tmp_2.f2x((!(tmp_3 == null) ? isInterface(tmp_3, AbstractBindingValueQuery) : false) ? tmp_3 : null);
      parentOr.eft().f2x(it);
    }
    var tmp1_safe_receiver = firstOrNull_0(this.htz_1.lah(it));
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.c93(ProjectionalSynchronizers_getInstance().d99_1);
    return tmp2_elvis_lhs == null ? get_EMPTY_CELL_ACTION() : tmp2_elvis_lhs;
  };
  function queryCommandBuilders$lambda$lambda$lambda$lambda_7($this_rightTransform, $source, $cellFinder) {
    return function () {
      // Inline function 'jetbrains.ocelot.langDef.query.executeQuery' call
      // Inline function 'jetbrains.ocelot.langDef.query.query' call
      var tmp$ret$0 = new _no_name_provided__qut3iv_47($this_rightTransform, $source, $cellFinder);
      return execute_0(tmp$ret$0);
    };
  }
  function queryCommandBuilders$lambda_4($this) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(BindingValueMask_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      rootIndent(result, queryCommandBuilders$lambda$lambda_4);
      return this_0;
    };
  }
  function queryCommandBuilders$lambda$lambda_5($this$rootIndent) {
    var tmp2 = '<linkDeclaration>';
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget' call
    var referenceTag = Companion_getInstance_347().eh7_1;
    var refCompletion = queryCommandBuilders$lambda$lambda$lambda_27(referenceTag);
    var completionTrait = queryCommandBuilders$lambda$lambda$lambda_28(refCompletion);
    // Inline function 'kotlin.also' call
    var this_0 = new SimpleMapperBuilder($this$rootIndent.fcq(), getKClass(LinkDeclaration_1));
    // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
    var result = new RootCellBuilderImpl(this_0);
    rootIndent(result, queryCommandBuilders$lambda$lambda$lambda_29(refCompletion));
    var mapperBuilder = this_0;
    var tmp0_cellFactory = new NamedCellFactory('referenceData', queryCommandBuilders$lambda$lambda$lambda_30);
    var tmp = queryCommandBuilders$lambda$lambda$lambda_31;
    // Inline function 'kotlin.apply' call
    var this_1 = projectionalChild($this$rootIndent, tmp, tmp0_cellFactory, mapperBuilder, tmp2, queryCommandBuilders$lambda$lambda$lambda_32(completionTrait));
    this_1.xcp(queryCommandBuilders$lambda$lambda$lambda_33);
    this_1.ycp(queryCommandBuilders$lambda$lambda$lambda_34);
    this_1.ycp(queryCommandBuilders$lambda$lambda$lambda_35);
    space($this$rootIndent);
    label($this$rootIndent, '=');
    space($this$rootIndent);
    valueChild($this$rootIndent);
    return Unit_instance;
  }
  function queryCommandBuilders$lambda$lambda$lambda_27($referenceTag) {
    return function (_this__u8e3s4, src, cell, cellAction) {
      var tmp = _this__u8e3s4.d6u($referenceTag);
      var tmp$ret$0 = src.bft();
      return completion(_this__u8e3s4, tmp, src, tmp$ret$0, cell, VOID, cellAction);
    };
  }
  function queryCommandBuilders$lambda$lambda$lambda$o$get$lambda_0($cell) {
    return function (it) {
      return signalCompletionHappened($cell, false, it);
    };
  }
  function _no_name_provided__qut3iv_48($refCompletion, $this, $source) {
    this.itz_1 = $refCompletion;
    this.jtz_1 = $this;
    this.ktz_1 = $source;
    CellTrait.call(this);
  }
  protoOf(_no_name_provided__qut3iv_48).n91 = function (cell, spec) {
    var tmp;
    if (equals(spec, Completion_getInstance().u9d_1)) {
      tmp = this.itz_1(this.jtz_1, this.ktz_1, cell, queryCommandBuilders$lambda$lambda$lambda$o$get$lambda_0(cell));
    } else {
      tmp = protoOf(CellTrait).n91.call(this, cell, spec);
    }
    return tmp;
  };
  function queryCommandBuilders$lambda$lambda$lambda_28($refCompletion) {
    return function (_this__u8e3s4, source) {
      return new _no_name_provided__qut3iv_48($refCompletion, _this__u8e3s4, source);
    };
  }
  function queryCommandBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda$lambda_0(s) {
    return s.bft();
  }
  function queryCommandBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_1($property) {
    return function ($this$setup, source, textCell) {
      var referenceTextPropSupplier = getLoopQuerySupplier($property);
      var loopQuery = referenceTextPropSupplier(source, $this$setup.gcq(), textCell);
      $this$setup.l8b(syncOneWay(loopQuery, textCell.o8w()));
      var tmp = getKClass(QualifiedReferenceContent);
      connectWithRefSupport(textCell, loopQuery, tmp, queryCommandBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda$lambda_0);
      return Unit_instance;
    };
  }
  function queryCommandBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_2($refCompletion) {
    return function ($this$completion, _unused_var__etf5q3, textCell, _unused_var__etf5q3_0) {
      var refCompletionArgs = getRefCompletionArgs(textCell);
      var source = refCompletionArgs.gdb_1;
      var cellAction = refCompletionArgs.hdb_1;
      return $refCompletion($this$completion, source, textCell, cellAction);
    };
  }
  function queryCommandBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda_0($property, $refCompletion) {
    return function ($this$editableText) {
      $this$editableText.xcp(queryCommandBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_1($property));
      completion_1($this$editableText, queryCommandBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_2($refCompletion));
      return Unit_instance;
    };
  }
  function _no_name_provided__qut3iv_49($cellBuilder, $refCompletion) {
    this.mtz_1 = $refCompletion;
    this.ltz_1 = $cellBuilder;
  }
  protoOf(_no_name_provided__qut3iv_49).etv = function (placeholderText, validator, property) {
    return editableText(this, validator, VOID, placeholderText, queryCommandBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda_0(property, this.mtz_1));
  };
  protoOf(_no_name_provided__qut3iv_49).jcs = function (placeholderText, validator, property) {
    return this.etv(placeholderText, validator, property);
  };
  protoOf(_no_name_provided__qut3iv_49).fcq = function () {
    return this.ltz_1.fcq();
  };
  protoOf(_no_name_provided__qut3iv_49).ftv = function (child) {
    this.ltz_1.wcp(child);
  };
  protoOf(_no_name_provided__qut3iv_49).wcp = function (child) {
    return this.ftv(child);
  };
  protoOf(_no_name_provided__qut3iv_49).gtv = function (init) {
    this.ltz_1.xcp(init);
  };
  protoOf(_no_name_provided__qut3iv_49).xcp = function (init) {
    return this.gtv(init);
  };
  protoOf(_no_name_provided__qut3iv_49).htv = function (init) {
    this.ltz_1.ycp(init);
  };
  protoOf(_no_name_provided__qut3iv_49).ycp = function (init) {
    return this.htv(init);
  };
  protoOf(_no_name_provided__qut3iv_49).itv = function (source, cellMap, context) {
    return this.ltz_1.acq(source, cellMap, context);
  };
  protoOf(_no_name_provided__qut3iv_49).acq = function (source, cellMap, context) {
    return this.itv((!(source == null) ? isInterface(source, DomainNode) : false) ? source : THROW_CCE(), cellMap, context);
  };
  function queryCommandBuilders$lambda$lambda$lambda$lambda_8(it) {
    return it.y2();
  }
  function queryCommandBuilders$lambda$lambda$lambda_29($refCompletion) {
    return function ($this$rootIndent) {
      var cellBuilder = $this$rootIndent;
      // Inline function 'jetbrains.ocelot.langDef.editor.getReferenceCellBuilder' call
      var refCompletion = $refCompletion;
      var refCellBuilder = new _no_name_provided__qut3iv_49(cellBuilder, refCompletion);
      refCellBuilder.kcs('<linkDeclaration>', VOID, queryCommandBuilders$lambda$lambda$lambda$lambda_8);
      return Unit_instance;
    };
  }
  function queryCommandBuilders$lambda$lambda$lambda_30() {
    // Inline function 'kotlin.also' call
    var this_0 = new IndentCell();
    Companion_getInstance_251().vda(this_0);
    return this_0;
  }
  function queryCommandBuilders$lambda$lambda$lambda_31(_unused_var__etf5q3, cell) {
    return get_forQueries(referenceData(cell).jda_1);
  }
  function queryCommandBuilders$lambda$lambda$lambda_32($completionTrait) {
    return function ($this$lambda, source, trait) {
      return CompositeCellTraits_instance.ra6([$completionTrait($this$lambda, source), trait]);
    };
  }
  function queryCommandBuilders$lambda$lambda$lambda_33($this$setup, source, cell) {
    var referenceData_0 = referenceData(cell);
    var tmp$ret$0 = source.bft();
    referenceData_0.wda(source, tmp$ret$0);
    return Unit_instance;
  }
  function queryCommandBuilders$lambda$lambda$lambda_34($this$setupSynchronizers, source, cell) {
    var tmp0 = $this$setupSynchronizers.gcq();
    // Inline function 'jetbrains.ocelot.langDef.references.synchronizers.getReferenceTargetSync' call
    var asyncTracker = new CellAsyncTracker(cell);
    var referenceData_0 = referenceData(cell);
    var tmp = ReferenceSynchronizers_instance;
    var tmp$ret$0 = source.bft();
    var tmp$ret$1 = tmp.bdb(tmp0, tmp$ret$0, referenceData_0.jda_1, ResolveKind_LOOSE_getInstance(), null, asyncTracker);
    $this$setupSynchronizers.l8b(tmp$ret$1);
    $this$setupSynchronizers.l8b(getReferenceDataMonitorSynchronizer(cell));
    return Unit_instance;
  }
  function queryCommandBuilders$lambda$lambda$lambda_35($this$setupSynchronizers, source, cell) {
    if ($this$setupSynchronizers.gcq().nd5()) {
      var tmp = $this$setupSynchronizers.gcq();
      var tmp$ret$0 = source.bft();
      $this$setupSynchronizers.l8b(referenceOutOfScopeSynchronizer(tmp, cell, tmp$ret$0));
      $this$setupSynchronizers.l8b(highlightReferenceTargetOutOfSync(cell, cell.n92(ReferenceCells_getInstance().cdb_1)));
    }
    return Unit_instance;
  }
  function queryCommandBuilders$lambda_5($this) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(OntologyLinkDeclarationValueQuery_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      rootIndent(result, queryCommandBuilders$lambda$lambda_5);
      return this_0;
    };
  }
  function queryCommandBuilders$lambda$lambda_6($this$rootIndent) {
    var tmp2 = '<propertyDeclaration>';
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget' call
    var referenceTag = Companion_getInstance_348().uhk_1;
    var refCompletion = queryCommandBuilders$lambda$lambda$lambda_36(referenceTag);
    var completionTrait = queryCommandBuilders$lambda$lambda$lambda_37(refCompletion);
    // Inline function 'kotlin.also' call
    var this_0 = new SimpleMapperBuilder($this$rootIndent.fcq(), getKClass(PropertyDeclaration_1));
    // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
    var result = new RootCellBuilderImpl(this_0);
    rootIndent(result, queryCommandBuilders$lambda$lambda$lambda_38(refCompletion));
    var mapperBuilder = this_0;
    var tmp0_cellFactory = new NamedCellFactory('referenceData', queryCommandBuilders$lambda$lambda$lambda_39);
    var tmp = queryCommandBuilders$lambda$lambda$lambda_40;
    // Inline function 'kotlin.apply' call
    var this_1 = projectionalChild($this$rootIndent, tmp, tmp0_cellFactory, mapperBuilder, tmp2, queryCommandBuilders$lambda$lambda$lambda_41(completionTrait));
    this_1.xcp(queryCommandBuilders$lambda$lambda$lambda_42);
    this_1.ycp(queryCommandBuilders$lambda$lambda$lambda_43);
    this_1.ycp(queryCommandBuilders$lambda$lambda$lambda_44);
    space($this$rootIndent);
    label($this$rootIndent, '=');
    space($this$rootIndent);
    valueChild($this$rootIndent);
    return Unit_instance;
  }
  function queryCommandBuilders$lambda$lambda$lambda_36($referenceTag) {
    return function (_this__u8e3s4, src, cell, cellAction) {
      var tmp = _this__u8e3s4.d6u($referenceTag);
      var tmp$ret$0 = src.cfu();
      return completion(_this__u8e3s4, tmp, src, tmp$ret$0, cell, VOID, cellAction);
    };
  }
  function queryCommandBuilders$lambda$lambda$lambda$o$get$lambda_1($cell) {
    return function (it) {
      return signalCompletionHappened($cell, false, it);
    };
  }
  function _no_name_provided__qut3iv_50($refCompletion, $this, $source) {
    this.ntz_1 = $refCompletion;
    this.otz_1 = $this;
    this.ptz_1 = $source;
    CellTrait.call(this);
  }
  protoOf(_no_name_provided__qut3iv_50).n91 = function (cell, spec) {
    var tmp;
    if (equals(spec, Completion_getInstance().u9d_1)) {
      tmp = this.ntz_1(this.otz_1, this.ptz_1, cell, queryCommandBuilders$lambda$lambda$lambda$o$get$lambda_1(cell));
    } else {
      tmp = protoOf(CellTrait).n91.call(this, cell, spec);
    }
    return tmp;
  };
  function queryCommandBuilders$lambda$lambda$lambda_37($refCompletion) {
    return function (_this__u8e3s4, source) {
      return new _no_name_provided__qut3iv_50($refCompletion, _this__u8e3s4, source);
    };
  }
  function queryCommandBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda$lambda_1(s) {
    return s.cfu();
  }
  function queryCommandBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_3($property) {
    return function ($this$setup, source, textCell) {
      var referenceTextPropSupplier = getLoopQuerySupplier($property);
      var loopQuery = referenceTextPropSupplier(source, $this$setup.gcq(), textCell);
      $this$setup.l8b(syncOneWay(loopQuery, textCell.o8w()));
      var tmp = getKClass(QualifiedReferenceContent);
      connectWithRefSupport(textCell, loopQuery, tmp, queryCommandBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda$lambda_1);
      return Unit_instance;
    };
  }
  function queryCommandBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_4($refCompletion) {
    return function ($this$completion, _unused_var__etf5q3, textCell, _unused_var__etf5q3_0) {
      var refCompletionArgs = getRefCompletionArgs(textCell);
      var source = refCompletionArgs.gdb_1;
      var cellAction = refCompletionArgs.hdb_1;
      return $refCompletion($this$completion, source, textCell, cellAction);
    };
  }
  function queryCommandBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda_1($property, $refCompletion) {
    return function ($this$editableText) {
      $this$editableText.xcp(queryCommandBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_3($property));
      completion_1($this$editableText, queryCommandBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_4($refCompletion));
      return Unit_instance;
    };
  }
  function _no_name_provided__qut3iv_51($cellBuilder, $refCompletion) {
    this.rtz_1 = $refCompletion;
    this.qtz_1 = $cellBuilder;
  }
  protoOf(_no_name_provided__qut3iv_51).etv = function (placeholderText, validator, property) {
    return editableText(this, validator, VOID, placeholderText, queryCommandBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda_1(property, this.rtz_1));
  };
  protoOf(_no_name_provided__qut3iv_51).jcs = function (placeholderText, validator, property) {
    return this.etv(placeholderText, validator, property);
  };
  protoOf(_no_name_provided__qut3iv_51).fcq = function () {
    return this.qtz_1.fcq();
  };
  protoOf(_no_name_provided__qut3iv_51).ftv = function (child) {
    this.qtz_1.wcp(child);
  };
  protoOf(_no_name_provided__qut3iv_51).wcp = function (child) {
    return this.ftv(child);
  };
  protoOf(_no_name_provided__qut3iv_51).gtv = function (init) {
    this.qtz_1.xcp(init);
  };
  protoOf(_no_name_provided__qut3iv_51).xcp = function (init) {
    return this.gtv(init);
  };
  protoOf(_no_name_provided__qut3iv_51).htv = function (init) {
    this.qtz_1.ycp(init);
  };
  protoOf(_no_name_provided__qut3iv_51).ycp = function (init) {
    return this.htv(init);
  };
  protoOf(_no_name_provided__qut3iv_51).itv = function (source, cellMap, context) {
    return this.qtz_1.acq(source, cellMap, context);
  };
  protoOf(_no_name_provided__qut3iv_51).acq = function (source, cellMap, context) {
    return this.itv((!(source == null) ? isInterface(source, DomainNode) : false) ? source : THROW_CCE(), cellMap, context);
  };
  function queryCommandBuilders$lambda$lambda$lambda$lambda_9(it) {
    return it.y2();
  }
  function queryCommandBuilders$lambda$lambda$lambda_38($refCompletion) {
    return function ($this$rootIndent) {
      var cellBuilder = $this$rootIndent;
      // Inline function 'jetbrains.ocelot.langDef.editor.getReferenceCellBuilder' call
      var refCompletion = $refCompletion;
      var refCellBuilder = new _no_name_provided__qut3iv_51(cellBuilder, refCompletion);
      refCellBuilder.kcs('<propertyDeclaration>', VOID, queryCommandBuilders$lambda$lambda$lambda$lambda_9);
      return Unit_instance;
    };
  }
  function queryCommandBuilders$lambda$lambda$lambda_39() {
    // Inline function 'kotlin.also' call
    var this_0 = new IndentCell();
    Companion_getInstance_251().vda(this_0);
    return this_0;
  }
  function queryCommandBuilders$lambda$lambda$lambda_40(_unused_var__etf5q3, cell) {
    return get_forQueries(referenceData(cell).jda_1);
  }
  function queryCommandBuilders$lambda$lambda$lambda_41($completionTrait) {
    return function ($this$lambda, source, trait) {
      return CompositeCellTraits_instance.ra6([$completionTrait($this$lambda, source), trait]);
    };
  }
  function queryCommandBuilders$lambda$lambda$lambda_42($this$setup, source, cell) {
    var referenceData_0 = referenceData(cell);
    var tmp$ret$0 = source.cfu();
    referenceData_0.wda(source, tmp$ret$0);
    return Unit_instance;
  }
  function queryCommandBuilders$lambda$lambda$lambda_43($this$setupSynchronizers, source, cell) {
    var tmp0 = $this$setupSynchronizers.gcq();
    // Inline function 'jetbrains.ocelot.langDef.references.synchronizers.getReferenceTargetSync' call
    var asyncTracker = new CellAsyncTracker(cell);
    var referenceData_0 = referenceData(cell);
    var tmp = ReferenceSynchronizers_instance;
    var tmp$ret$0 = source.cfu();
    var tmp$ret$1 = tmp.bdb(tmp0, tmp$ret$0, referenceData_0.jda_1, ResolveKind_LOOSE_getInstance(), null, asyncTracker);
    $this$setupSynchronizers.l8b(tmp$ret$1);
    $this$setupSynchronizers.l8b(getReferenceDataMonitorSynchronizer(cell));
    return Unit_instance;
  }
  function queryCommandBuilders$lambda$lambda$lambda_44($this$setupSynchronizers, source, cell) {
    if ($this$setupSynchronizers.gcq().nd5()) {
      var tmp = $this$setupSynchronizers.gcq();
      var tmp$ret$0 = source.cfu();
      $this$setupSynchronizers.l8b(referenceOutOfScopeSynchronizer(tmp, cell, tmp$ret$0));
      $this$setupSynchronizers.l8b(highlightReferenceTargetOutOfSync(cell, cell.n92(ReferenceCells_getInstance().cdb_1)));
    }
    return Unit_instance;
  }
  function queryCommandBuilders$lambda_6($this) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(PropertyDeclarationValueQuery_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      rootIndent(result, queryCommandBuilders$lambda$lambda_6);
      return this_0;
    };
  }
  function queryCommandBuilders$lambda$lambda_7($this$rootIndent) {
    label($this$rootIndent, '<argument>');
    return Unit_instance;
  }
  function queryCommandBuilders$lambda_7($this) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(BindingValuePlaceholderQuery_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      rootIndent(result, queryCommandBuilders$lambda$lambda_7);
      return this_0;
    };
  }
  function _get_contextQueryRole_$lambda_vdc7o1($this$default) {
    return ContextQuery($this$default.l6z());
  }
  function _get_contextQueryRole_$lambda_vdc7o1_0($this$clipboardParametersByCloner) {
    var tmp = new BaseNodeCloneSupport($this$clipboardParametersByCloner.gd3(), get_nodeFactory($this$clipboardParametersByCloner.l6z()));
    return isInterface(tmp, ClonerSupport) ? tmp : THROW_CCE();
  }
  function libraryProcessSpecificationQueryChild$lambda($this$indentChild) {
    defaultItem($this$indentChild, libraryProcessSpecificationQueryChild$lambda$lambda);
    $this$indentChild.mct(libraryProcessSpecificationQueryChild$lambda$lambda_0);
    return Unit_instance;
  }
  function libraryProcessSpecificationQueryChild$lambda$lambda($this$defaultItem) {
    return LibraryProcessSpecificationQuery($this$defaultItem.l6z());
  }
  function libraryProcessSpecificationQueryChild$lambda$lambda_0($this$completion) {
    return libraryProcessSpecificationQueryCompletion($this$completion);
  }
  function valueChild$lambda(it) {
    return it.a1();
  }
  function valueChild$lambda_0($this$indentChild) {
    $this$indentChild.mct(valueChild$lambda$lambda);
    return Unit_instance;
  }
  function valueChild$lambda$lambda($this$completion) {
    return abstractValueCompletion($this$completion);
  }
  function libraryProcessSpecificationQueryCompletion$lambda($this_libraryProcessSpecificationQueryCompletion) {
    return function (it) {
      // Inline function 'kotlin.apply' call
      var this_0 = LibraryProcessSpecificationQuery($this_libraryProcessSpecificationQueryCompletion.l6z());
      this_0.vfr().f2x(it);
      return this_0;
    };
  }
  function bindingValueMaskCompletion$lambda($this_bindingValueMaskCompletion) {
    return function (it) {
      // Inline function 'kotlin.apply' call
      var this_0 = BindingValueMask($this_bindingValueMaskCompletion.l6z());
      this_0.a1().f2x(it);
      return this_0;
    };
  }
  function linkDeclarationValueQueryCompletion$lambda($this_linkDeclarationValueQueryCompletion) {
    return function (it) {
      // Inline function 'kotlin.apply' call
      var this_0 = OntologyLinkDeclarationValueQuery($this_linkDeclarationValueQueryCompletion.l6z());
      this_0.bft().f2x(it);
      return this_0;
    };
  }
  function propertyDeclarationValueQueryCompletion$lambda($this_propertyDeclarationValueQueryCompletion) {
    return function (it) {
      // Inline function 'kotlin.apply' call
      var this_0 = PropertyDeclarationValueQuery($this_propertyDeclarationValueQueryCompletion.l6z());
      this_0.cfu().f2x(it);
      return this_0;
    };
  }
  function relationLibraryBuilders(_this__u8e3s4) {
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder = new LazyMapperBuilder(relationLibraryBuilders$lambda(_this__u8e3s4, _this__u8e3s4));
    _this__u8e3s4.vcr(builder);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_0 = new LazyMapperBuilder(relationLibraryBuilders$lambda_0(_this__u8e3s4));
    _this__u8e3s4.vcr(builder_0);
  }
  function relationLibraryBuilders$lambda$lambda$lambda($this$default) {
    return ProcessRelationDeclaration($this$default.l6z());
  }
  function relationLibraryBuilders$lambda$lambda$lambda_0($this$clipboardParametersByCloner) {
    var tmp = new BaseNodeCloneSupport($this$clipboardParametersByCloner.gd3(), get_nodeFactory($this$clipboardParametersByCloner.l6z()));
    return isInterface(tmp, ClonerSupport) ? tmp : THROW_CCE();
  }
  function relationLibraryBuilders$lambda$lambda$lambda_1(it) {
    return it.jfu();
  }
  function relationLibraryBuilders$lambda$lambda($this_relationLibraryBuilders) {
    return function ($this$indent) {
      // Inline function 'jetbrains.biokb.lang.builders.nodeRole' call
      // Inline function 'jetbrains.ocelot.langDef.editor.role' call
      // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.builder' call
      var this_0 = $this_relationLibraryBuilders;
      var sourceType = getKClass(ProcessRelationDeclaration_1);
      var tmp$ret$0 = this_0.xcr(sourceType);
      var builder = new ChildBuilder(tmp$ret$0);
      builder.jd0();
      builder.hd0(relationLibraryBuilders$lambda$lambda$lambda);
      var simpleClassName = ensureNotNull(getKClass(ProcessRelationDeclaration_1).ra());
      builder.kd0(simpleClassName, relationLibraryBuilders$lambda$lambda$lambda_0);
      var tmp = builder;
      children_1($this$indent, tmp, relationLibraryBuilders$lambda$lambda$lambda_1);
      return Unit_instance;
    };
  }
  function relationLibraryBuilders$lambda($this, $this_relationLibraryBuilders) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(RelationContainer_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      indent(result, VOID, relationLibraryBuilders$lambda$lambda($this_relationLibraryBuilders));
      return this_0;
    };
  }
  function relationLibraryBuilders$lambda$lambda_0($this$rootIndent) {
    textProperty($this$rootIndent, '<name>', relationLibraryBuilders$lambda$lambda$lambda_2);
    space($this$rootIndent);
    textProperty($this$rootIndent, '<symbol>', relationLibraryBuilders$lambda$lambda$lambda_3);
    return Unit_instance;
  }
  function relationLibraryBuilders$lambda$lambda$lambda_2(it) {
    return it.y2();
  }
  function relationLibraryBuilders$lambda$lambda$lambda_3(it) {
    return it.zft();
  }
  function relationLibraryBuilders$lambda_0($this) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(ProcessRelationDeclaration_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      rootIndent(result, relationLibraryBuilders$lambda$lambda_0);
      return this_0;
    };
  }
  function notionTypeBuilders(_this__u8e3s4) {
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder = new LazyMapperBuilder(notionTypeBuilders$lambda(_this__u8e3s4));
    _this__u8e3s4.vcr(builder);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_0 = new LazyMapperBuilder(notionTypeBuilders$lambda_0(_this__u8e3s4, _this__u8e3s4));
    _this__u8e3s4.vcr(builder_0);
  }
  function get_typeRole(_this__u8e3s4) {
    // Inline function 'jetbrains.biokb.lang.builders.nodeRole' call
    // Inline function 'jetbrains.ocelot.langDef.editor.role' call
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.builder' call
    var sourceType = getKClass(VariableSpecification);
    var tmp$ret$0 = _this__u8e3s4.xcr(sourceType);
    var builder = new ChildBuilder(tmp$ret$0);
    builder.fd0(_get_typeRole_$lambda_40iqa8);
    var simpleClassName = ensureNotNull(getKClass(VariableSpecification).ra());
    builder.kd0(simpleClassName, _get_typeRole_$lambda_40iqa8_0);
    return builder;
  }
  function get_ontologyElementTypeRole(_this__u8e3s4) {
    // Inline function 'jetbrains.biokb.lang.builders.nodeRole' call
    // Inline function 'jetbrains.ocelot.langDef.editor.role' call
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.builder' call
    var sourceType = getKClass(OntologyElementType_1);
    var tmp$ret$0 = _this__u8e3s4.xcr(sourceType);
    var builder = new ChildBuilder(tmp$ret$0);
    builder.fd0(_get_ontologyElementTypeRole_$lambda_kwqmvr);
    builder.hd0(_get_ontologyElementTypeRole_$lambda_kwqmvr_0);
    var simpleClassName = ensureNotNull(getKClass(OntologyElementType_1).ra());
    builder.kd0(simpleClassName, _get_ontologyElementTypeRole_$lambda_kwqmvr_1);
    return builder;
  }
  function notionTypeCompletion(_this__u8e3s4) {
    var tmp = nodeRefCompletion(_this__u8e3s4, Companion_getInstance_351().zgu_1);
    return map_2(tmp, notionTypeCompletion$lambda(_this__u8e3s4));
  }
  function typeCompletion(_this__u8e3s4) {
    return plus_14(notionTypeCompletion(_this__u8e3s4), ontologyElementTypeCompletion(_this__u8e3s4));
  }
  function ontologyElementTypeCompletion(_this__u8e3s4) {
    var tmp = nodeRefCompletion(_this__u8e3s4, Companion_getInstance_335().dh6_1);
    return map_2(tmp, ontologyElementTypeCompletion$lambda(_this__u8e3s4));
  }
  function notionTypeBuilders$lambda$lambda($this$rootIndent) {
    var tmp2 = '<notion>';
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget' call
    var referenceTag = Companion_getInstance_351().zgu_1;
    var refCompletion = notionTypeBuilders$lambda$lambda$lambda(referenceTag);
    var completionTrait = notionTypeBuilders$lambda$lambda$lambda_0(refCompletion);
    // Inline function 'kotlin.also' call
    var this_0 = new SimpleMapperBuilder($this$rootIndent.fcq(), getKClass(AbstractNotion));
    // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
    var result = new RootCellBuilderImpl(this_0);
    rootIndent(result, notionTypeBuilders$lambda$lambda$lambda_1(refCompletion));
    var mapperBuilder = this_0;
    var tmp0_cellFactory = new NamedCellFactory('referenceData', notionTypeBuilders$lambda$lambda$lambda_2);
    var tmp = notionTypeBuilders$lambda$lambda$lambda_3;
    // Inline function 'kotlin.apply' call
    var this_1 = projectionalChild($this$rootIndent, tmp, tmp0_cellFactory, mapperBuilder, tmp2, notionTypeBuilders$lambda$lambda$lambda_4(completionTrait));
    this_1.xcp(notionTypeBuilders$lambda$lambda$lambda_5);
    this_1.ycp(notionTypeBuilders$lambda$lambda$lambda_6);
    this_1.ycp(notionTypeBuilders$lambda$lambda$lambda_7);
    return Unit_instance;
  }
  function notionTypeBuilders$lambda$lambda$lambda($referenceTag) {
    return function (_this__u8e3s4, src, cell, cellAction) {
      var tmp = _this__u8e3s4.d6u($referenceTag);
      var tmp$ret$0 = src.mfq();
      return completion(_this__u8e3s4, tmp, src, tmp$ret$0, cell, VOID, cellAction);
    };
  }
  function notionTypeBuilders$lambda$lambda$lambda$o$get$lambda($cell) {
    return function (it) {
      return signalCompletionHappened($cell, false, it);
    };
  }
  function _no_name_provided__qut3iv_52($refCompletion, $this, $source) {
    this.stz_1 = $refCompletion;
    this.ttz_1 = $this;
    this.utz_1 = $source;
    CellTrait.call(this);
  }
  protoOf(_no_name_provided__qut3iv_52).n91 = function (cell, spec) {
    var tmp;
    if (equals(spec, Completion_getInstance().u9d_1)) {
      tmp = this.stz_1(this.ttz_1, this.utz_1, cell, notionTypeBuilders$lambda$lambda$lambda$o$get$lambda(cell));
    } else {
      tmp = protoOf(CellTrait).n91.call(this, cell, spec);
    }
    return tmp;
  };
  function notionTypeBuilders$lambda$lambda$lambda_0($refCompletion) {
    return function (_this__u8e3s4, source) {
      return new _no_name_provided__qut3iv_52($refCompletion, _this__u8e3s4, source);
    };
  }
  function notionTypeBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda$lambda(s) {
    return s.mfq();
  }
  function notionTypeBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda($property) {
    return function ($this$setup, source, textCell) {
      var referenceTextPropSupplier = getLoopQuerySupplier($property);
      var loopQuery = referenceTextPropSupplier(source, $this$setup.gcq(), textCell);
      $this$setup.l8b(syncOneWay(loopQuery, textCell.o8w()));
      var tmp = getKClass(QualifiedReferenceContent);
      connectWithRefSupport(textCell, loopQuery, tmp, notionTypeBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda$lambda);
      return Unit_instance;
    };
  }
  function notionTypeBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_0($refCompletion) {
    return function ($this$completion, _unused_var__etf5q3, textCell, _unused_var__etf5q3_0) {
      var refCompletionArgs = getRefCompletionArgs(textCell);
      var source = refCompletionArgs.gdb_1;
      var cellAction = refCompletionArgs.hdb_1;
      return $refCompletion($this$completion, source, textCell, cellAction);
    };
  }
  function notionTypeBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda($property, $refCompletion) {
    return function ($this$editableText) {
      $this$editableText.xcp(notionTypeBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda($property));
      completion_1($this$editableText, notionTypeBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_0($refCompletion));
      return Unit_instance;
    };
  }
  function _no_name_provided__qut3iv_53($cellBuilder, $refCompletion) {
    this.wtz_1 = $refCompletion;
    this.vtz_1 = $cellBuilder;
  }
  protoOf(_no_name_provided__qut3iv_53).etv = function (placeholderText, validator, property) {
    return editableText(this, validator, VOID, placeholderText, notionTypeBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda(property, this.wtz_1));
  };
  protoOf(_no_name_provided__qut3iv_53).jcs = function (placeholderText, validator, property) {
    return this.etv(placeholderText, validator, property);
  };
  protoOf(_no_name_provided__qut3iv_53).fcq = function () {
    return this.vtz_1.fcq();
  };
  protoOf(_no_name_provided__qut3iv_53).ftv = function (child) {
    this.vtz_1.wcp(child);
  };
  protoOf(_no_name_provided__qut3iv_53).wcp = function (child) {
    return this.ftv(child);
  };
  protoOf(_no_name_provided__qut3iv_53).gtv = function (init) {
    this.vtz_1.xcp(init);
  };
  protoOf(_no_name_provided__qut3iv_53).xcp = function (init) {
    return this.gtv(init);
  };
  protoOf(_no_name_provided__qut3iv_53).htv = function (init) {
    this.vtz_1.ycp(init);
  };
  protoOf(_no_name_provided__qut3iv_53).ycp = function (init) {
    return this.htv(init);
  };
  protoOf(_no_name_provided__qut3iv_53).itv = function (source, cellMap, context) {
    return this.vtz_1.acq(source, cellMap, context);
  };
  protoOf(_no_name_provided__qut3iv_53).acq = function (source, cellMap, context) {
    return this.itv((!(source == null) ? isInterface(source, DomainNode) : false) ? source : THROW_CCE(), cellMap, context);
  };
  function notionTypeBuilders$lambda$lambda$lambda$lambda(it) {
    return it.y2();
  }
  function notionTypeBuilders$lambda$lambda$lambda_1($refCompletion) {
    return function ($this$rootIndent) {
      var cellBuilder = $this$rootIndent;
      // Inline function 'jetbrains.ocelot.langDef.editor.getReferenceCellBuilder' call
      var refCompletion = $refCompletion;
      var refCellBuilder = new _no_name_provided__qut3iv_53(cellBuilder, refCompletion);
      refCellBuilder.kcs('<notion>', VOID, notionTypeBuilders$lambda$lambda$lambda$lambda);
      return Unit_instance;
    };
  }
  function notionTypeBuilders$lambda$lambda$lambda_2() {
    // Inline function 'kotlin.also' call
    var this_0 = new IndentCell();
    Companion_getInstance_251().vda(this_0);
    return this_0;
  }
  function notionTypeBuilders$lambda$lambda$lambda_3(_unused_var__etf5q3, cell) {
    return get_forQueries(referenceData(cell).jda_1);
  }
  function notionTypeBuilders$lambda$lambda$lambda_4($completionTrait) {
    return function ($this$lambda, source, trait) {
      return CompositeCellTraits_instance.ra6([$completionTrait($this$lambda, source), trait]);
    };
  }
  function notionTypeBuilders$lambda$lambda$lambda_5($this$setup, source, cell) {
    var referenceData_0 = referenceData(cell);
    var tmp$ret$0 = source.mfq();
    referenceData_0.wda(source, tmp$ret$0);
    return Unit_instance;
  }
  function notionTypeBuilders$lambda$lambda$lambda_6($this$setupSynchronizers, source, cell) {
    var tmp0 = $this$setupSynchronizers.gcq();
    // Inline function 'jetbrains.ocelot.langDef.references.synchronizers.getReferenceTargetSync' call
    var asyncTracker = new CellAsyncTracker(cell);
    var referenceData_0 = referenceData(cell);
    var tmp = ReferenceSynchronizers_instance;
    var tmp$ret$0 = source.mfq();
    var tmp$ret$1 = tmp.bdb(tmp0, tmp$ret$0, referenceData_0.jda_1, ResolveKind_LOOSE_getInstance(), null, asyncTracker);
    $this$setupSynchronizers.l8b(tmp$ret$1);
    $this$setupSynchronizers.l8b(getReferenceDataMonitorSynchronizer(cell));
    return Unit_instance;
  }
  function notionTypeBuilders$lambda$lambda$lambda_7($this$setupSynchronizers, source, cell) {
    if ($this$setupSynchronizers.gcq().nd5()) {
      var tmp = $this$setupSynchronizers.gcq();
      var tmp$ret$0 = source.mfq();
      $this$setupSynchronizers.l8b(referenceOutOfScopeSynchronizer(tmp, cell, tmp$ret$0));
      $this$setupSynchronizers.l8b(highlightReferenceTargetOutOfSync(cell, cell.n92(ReferenceCells_getInstance().cdb_1)));
    }
    return Unit_instance;
  }
  function notionTypeBuilders$lambda($this) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(NotionType_0));
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      rootIndent(result, notionTypeBuilders$lambda$lambda);
      return this_0;
    };
  }
  function notionTypeBuilders$lambda$lambda$lambda_8(it) {
    return it.ffq();
  }
  function notionTypeBuilders$lambda$lambda$lambda_9(it) {
    return it.gfq();
  }
  function notionTypeBuilders$lambda$lambda_0($this_notionTypeBuilders) {
    return function ($this$rootIndent) {
      var tmp = get_ontologyLibraryReferenceRole($this_notionTypeBuilders);
      child_0($this$rootIndent, tmp, notionTypeBuilders$lambda$lambda$lambda_8);
      indentLabel($this$rootIndent, '/');
      var tmp_0 = get_ontologyElementReferenceRole($this_notionTypeBuilders);
      child_0($this$rootIndent, tmp_0, notionTypeBuilders$lambda$lambda$lambda_9);
      return Unit_instance;
    };
  }
  function notionTypeBuilders$lambda_0($this, $this_notionTypeBuilders) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(OntologyElementType_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      rootIndent(result, notionTypeBuilders$lambda$lambda_0($this_notionTypeBuilders));
      return this_0;
    };
  }
  function _get_typeRole_$lambda_40iqa8($this$completion) {
    return typeCompletion($this$completion);
  }
  function _get_typeRole_$lambda_40iqa8_0($this$clipboardParametersByCloner) {
    var tmp = new BaseNodeCloneSupport($this$clipboardParametersByCloner.gd3(), get_nodeFactory($this$clipboardParametersByCloner.l6z()));
    return isInterface(tmp, ClonerSupport) ? tmp : THROW_CCE();
  }
  function _get_ontologyElementTypeRole_$lambda_kwqmvr($this$completion) {
    return ontologyElementTypeCompletion($this$completion);
  }
  function _get_ontologyElementTypeRole_$lambda_kwqmvr_0($this$default) {
    return OntologyElementType($this$default.l6z());
  }
  function _get_ontologyElementTypeRole_$lambda_kwqmvr_1($this$clipboardParametersByCloner) {
    var tmp = new BaseNodeCloneSupport($this$clipboardParametersByCloner.gd3(), get_nodeFactory($this$clipboardParametersByCloner.l6z()));
    return isInterface(tmp, ClonerSupport) ? tmp : THROW_CCE();
  }
  function notionTypeCompletion$lambda($this_notionTypeCompletion) {
    return function (it) {
      return NotionType_1($this_notionTypeCompletion.l6z(), it);
    };
  }
  function ontologyElementTypeCompletion$lambda($this_ontologyElementTypeCompletion) {
    return function (it) {
      // Inline function 'kotlin.apply' call
      var this_0 = OntologyElementType($this_ontologyElementTypeCompletion.l6z());
      this_0.ffq().d2x(OntologyLibraryReference_2($this_ontologyElementTypeCompletion.l6z(), it));
      return this_0;
    };
  }
  function get_supportFactSelection(_this__u8e3s4) {
    var tmp = _this__u8e3s4.ld0();
    var tmp0_safe_receiver = isInterface(tmp, BTBEditorBuilderConfig) ? tmp : null;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.wtr();
    return (tmp1_safe_receiver == null ? null : tmp1_safe_receiver.otf_1) === true;
  }
  function BTBEditorBuilderConfig() {
  }
  function get_uiConfig(_this__u8e3s4) {
    var tmp = _this__u8e3s4.ld0();
    return (isInterface(tmp, BTBEditorBuilderConfig) ? tmp : THROW_CCE()).xtz();
  }
  function BTBEditorBuilderConfigImpl(wrapperContext, conceptRegistry, nodeFactory, nodeAdaptationSupport, splitMergeSupportFactory, editorRegistry, commonConfig, presentation, errorCheckConfig, indentNumSpaces, spaceClosesCompletion, nodePointerSupport, uiConfig) {
    EditorBuilderConfigImpl.call(this, wrapperContext, conceptRegistry, nodeFactory, nodeAdaptationSupport, splitMergeSupportFactory, editorRegistry, commonConfig, errorCheckConfig, presentation.ntf_1, indentNumSpaces, spaceClosesCompletion);
    this.ju0_1 = presentation;
    this.ku0_1 = nodePointerSupport;
    this.lu0_1 = uiConfig;
  }
  protoOf(BTBEditorBuilderConfigImpl).wtr = function () {
    return this.ju0_1;
  };
  protoOf(BTBEditorBuilderConfigImpl).xtz = function () {
    return this.lu0_1;
  };
  function BTBEditorConfiguration() {
  }
  function createBTBEditorConfiguration(domainModel, presentation) {
    var services = domainModel.ddf_1;
    var coroutineScope = CoroutineScope_0(ensureNotNull(services.h3b(CoroutineContextService_getInstance())));
    var resolveConfig = domainModel.fdf_1;
    var tmp0_elvis_lhs = services.h3b(Companion_instance_118);
    var errorCheckConfig = tmp0_elvis_lhs == null ? Empty_instance_0 : tmp0_elvis_lhs;
    return new createBTBEditorConfiguration$1(coroutineScope, resolveConfig, errorCheckConfig, domainModel, presentation);
  }
  function createBTBEditorConfiguration$1($coroutineScope, $resolveConfig, $errorCheckConfig, $domainModel, $presentation) {
    this.mu0_1 = $coroutineScope;
    this.nu0_1 = $resolveConfig;
    this.ou0_1 = $errorCheckConfig;
    this.pu0_1 = get_nodePointerSupport($domainModel);
    this.qu0_1 = get_wrapperContext($domainModel);
    this.ru0_1 = $domainModel.edf_1;
    this.su0_1 = new OTSplitMergeSupportFactory(this.ru0_1);
    this.tu0_1 = $presentation;
  }
  protoOf(createBTBEditorConfiguration$1).p6g = function () {
    return this.pu0_1;
  };
  protoOf(createBTBEditorConfiguration$1).l6z = function () {
    return this.qu0_1;
  };
  protoOf(createBTBEditorConfiguration$1).gd3 = function () {
    return this.ru0_1;
  };
  protoOf(createBTBEditorConfiguration$1).hd3 = function () {
    return this.su0_1;
  };
  protoOf(createBTBEditorConfiguration$1).wtr = function () {
    return this.tu0_1;
  };
  protoOf(createBTBEditorConfiguration$1).ho = function () {
    return this.mu0_1.ho();
  };
  protoOf(createBTBEditorConfiguration$1).m6t = function (tag) {
    return this.nu0_1.m6t(tag);
  };
  protoOf(createBTBEditorConfiguration$1).d6u = function (tag) {
    return this.nu0_1.d6u(tag);
  };
  protoOf(createBTBEditorConfiguration$1).v6t = function (tag) {
    return this.nu0_1.v6t(tag);
  };
  protoOf(createBTBEditorConfiguration$1).j70 = function (concept) {
    return this.ou0_1.j70(concept);
  };
  function BTBEditorUIConfig(factSelectionColor, factSelectionIcon, blankImage) {
    this.uu0_1 = factSelectionColor;
    this.vu0_1 = factSelectionIcon;
    this.wu0_1 = blankImage;
  }
  function Companion_422() {
    Companion_instance_422 = this;
    this.qto_1 = new BTBPresentation(Companion_getInstance_244().pct_1);
    this.rto_1 = new BTBPresentation(Companion_getInstance_244().qct_1);
    this.sto_1 = new BTBPresentation(Companion_getInstance_244().rct_1, true);
    this.tto_1 = new BTBPresentation(Companion_getInstance_244().sct_1);
    this.uto_1 = new BTBPresentation(Companion_getInstance_244().tct_1);
  }
  var Companion_instance_422;
  function Companion_getInstance_422() {
    if (Companion_instance_422 == null)
      new Companion_422();
    return Companion_instance_422;
  }
  function BTBPresentation(mode, factSelection) {
    Companion_getInstance_422();
    factSelection = factSelection === VOID ? false : factSelection;
    this.ntf_1 = mode;
    this.otf_1 = factSelection;
    // Inline function 'kotlin.require' call
    if (!(!this.otf_1 || this.ntf_1.vct_1)) {
      var message = 'fact selection attaches behaviour to fact cells; the editor must be interactive';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
  }
  protoOf(BTBPresentation).toString = function () {
    return 'BTBPresentation(mode=' + this.ntf_1.toString() + ', factSelection=' + this.otf_1 + ')';
  };
  protoOf(BTBPresentation).hashCode = function () {
    var result = this.ntf_1.hashCode();
    result = imul(result, 31) + getBooleanHashCode(this.otf_1) | 0;
    return result;
  };
  protoOf(BTBPresentation).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof BTBPresentation))
      return false;
    if (!this.ntf_1.equals(other.ntf_1))
      return false;
    if (!(this.otf_1 === other.otf_1))
      return false;
    return true;
  };
  function get_btbEditorDefinitions() {
    _init_properties_BTBEditorBuildersMapperFactory_kt__kpj5x0();
    var tmp0 = btbEditorDefinitions$delegate;
    var tmp = KProperty0;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('btbEditorDefinitions', 0, tmp, _get_btbEditorDefinitions_$ref_updflj(), null);
    return tmp0.a1();
  }
  var btbEditorDefinitions$delegate;
  function get_btbUiConfig() {
    _init_properties_BTBEditorBuildersMapperFactory_kt__kpj5x0();
    return btbUiConfig;
  }
  var btbUiConfig;
  function getEditorBuildersRootMapperFactory() {
    _init_properties_BTBEditorBuildersMapperFactory_kt__kpj5x0();
    return new getEditorBuildersRootMapperFactory$1();
  }
  function get_btbNodeAdapters(_this__u8e3s4) {
    _init_properties_BTBEditorBuildersMapperFactory_kt__kpj5x0();
    var tmp = implyEmptyQueryLabelsOnFact(_this__u8e3s4);
    var tmp_0 = KProperty1;
    var tmp2 = getPropertyCallableRef('library', 1, tmp_0, OntologyElementType$_get_library_$ref_qnafmw_1(), null);
    var tmp_1 = KProperty1;
    // Inline function 'jetbrains.biokb.lang.editorBuilders.adaptToQualifiedOntologyElementReference' call
    var element = getPropertyCallableRef('element', 1, tmp_1, OntologyElementType$_get_element_$ref_pl8d15_1(), null);
    // Inline function 'jetbrains.ocelot.langDef.structure.adaptation.Companion.turnsInto' call
    var adapt = _get_btbNodeAdapters_$lambda_gbwmz4(_this__u8e3s4, tmp2, element);
    var tmp_2 = wrapsOrTurnsInto(getKClass(OntologyElementType_1), getKClass(QualifiedOntologyElementReference_1), false, adapt);
    // Inline function 'jetbrains.ocelot.langDef.structure.adaptation.Companion.turnsInto' call
    var adapt_0 = _get_btbNodeAdapters_$lambda_gbwmz4_0(_this__u8e3s4, tmp2, element);
    var tmp$ret$1 = wrapsOrTurnsInto(getKClass(QualifiedOntologyElementReference_1), getKClass(OntologyElementType_1), false, adapt_0);
    var tmp$ret$2 = listOf_0([tmp_2, tmp$ret$1]);
    var tmp_3 = plus_5(tmp, tmp$ret$2);
    var tmp_4 = KProperty1;
    var tmp2_0 = getPropertyCallableRef('library', 1, tmp_4, Context$_get_library_$ref_4eq8r4_1(), null);
    var tmp_5 = KProperty1;
    // Inline function 'jetbrains.biokb.lang.editorBuilders.adaptToQualifiedOntologyElementReference' call
    var element_0 = getPropertyCallableRef('element', 1, tmp_5, Context$_get_element_$ref_n7bi27_1(), null);
    // Inline function 'jetbrains.ocelot.langDef.structure.adaptation.Companion.turnsInto' call
    var adapt_1 = _get_btbNodeAdapters_$lambda_gbwmz4_1(_this__u8e3s4, tmp2_0, element_0);
    var tmp_6 = wrapsOrTurnsInto(getKClass(Context_2), getKClass(QualifiedOntologyElementReference_1), false, adapt_1);
    // Inline function 'jetbrains.ocelot.langDef.structure.adaptation.Companion.turnsInto' call
    var adapt_2 = _get_btbNodeAdapters_$lambda_gbwmz4_2(_this__u8e3s4, tmp2_0, element_0);
    var tmp$ret$4 = wrapsOrTurnsInto(getKClass(QualifiedOntologyElementReference_1), getKClass(Context_2), false, adapt_2);
    var tmp$ret$5 = listOf_0([tmp_6, tmp$ret$4]);
    var tmp_7 = plus_5(tmp_3, tmp$ret$5);
    var tmp_8 = KProperty1;
    var tmp2_1 = getPropertyCallableRef('library', 1, tmp_8, OntologyElementReferenceValueLibrary$_get_library_$ref_ni4dih_1(), null);
    var tmp_9 = KProperty1;
    // Inline function 'jetbrains.biokb.lang.editorBuilders.adaptToQualifiedOntologyElementReference' call
    var element_1 = getPropertyCallableRef('element', 1, tmp_9, OntologyElementReferenceValueLibrary$_get_element_$ref_sqef5k(), null);
    // Inline function 'jetbrains.ocelot.langDef.structure.adaptation.Companion.turnsInto' call
    var adapt_3 = _get_btbNodeAdapters_$lambda_gbwmz4_3(_this__u8e3s4, tmp2_1, element_1);
    var tmp_10 = wrapsOrTurnsInto(getKClass(OntologyElementReferenceValueLibrary_1), getKClass(QualifiedOntologyElementReference_1), false, adapt_3);
    // Inline function 'jetbrains.ocelot.langDef.structure.adaptation.Companion.turnsInto' call
    var adapt_4 = _get_btbNodeAdapters_$lambda_gbwmz4_4(_this__u8e3s4, tmp2_1, element_1);
    var tmp$ret$7 = wrapsOrTurnsInto(getKClass(QualifiedOntologyElementReference_1), getKClass(OntologyElementReferenceValueLibrary_1), false, adapt_4);
    var tmp$ret$8 = listOf_0([tmp_10, tmp$ret$7]);
    var tmp_11 = plus_5(tmp_7, tmp$ret$8);
    var tmp_12 = KProperty1;
    var tmp2_2 = getPropertyCallableRef('library', 1, tmp_12, Category$_get_library_$ref_sghxsx_1(), null);
    var tmp_13 = KProperty1;
    // Inline function 'jetbrains.biokb.lang.editorBuilders.adaptToQualifiedOntologyElementReference' call
    var element_2 = getPropertyCallableRef('element', 1, tmp_13, Category$_get_element_$ref_9nwohu_1(), null);
    // Inline function 'jetbrains.ocelot.langDef.structure.adaptation.Companion.turnsInto' call
    var adapt_5 = _get_btbNodeAdapters_$lambda_gbwmz4_5(_this__u8e3s4, tmp2_2, element_2);
    var tmp_14 = wrapsOrTurnsInto(getKClass(Category_1), getKClass(QualifiedOntologyElementReference_1), false, adapt_5);
    // Inline function 'jetbrains.ocelot.langDef.structure.adaptation.Companion.turnsInto' call
    var adapt_6 = _get_btbNodeAdapters_$lambda_gbwmz4_6(_this__u8e3s4, tmp2_2, element_2);
    var tmp$ret$10 = wrapsOrTurnsInto(getKClass(QualifiedOntologyElementReference_1), getKClass(Category_1), false, adapt_6);
    var tmp$ret$11 = listOf_0([tmp_14, tmp$ret$10]);
    return plus_5(plus_5(tmp_11, tmp$ret$11), get_partsOfQualifiedOntologyReference(_this__u8e3s4));
  }
  function btbEditorDefinitions$delegate$lambda() {
    _init_properties_BTBEditorBuildersMapperFactory_kt__kpj5x0();
    return plus_5(plus_5(plus_5(plus_5(plus_5(plus_5(plus_5(plus_5(plus_5(plus_5(plus_5(plus_5(plus_5(plus_5(plus_5(plus_5(plus_5(plus_5(get_btbProgramEditors(), get_extensionEditors()), get_factEditors()), get_newFactEditors()), get_functionLibraryEditors()), get_linkLibraryEditors()), get_notionLibraryEditors()), get_urlEditors()), get_ontologyLibraryEditors()), get_processLibraryEditors()), get_objectPropertyEditors()), get_queryCommandEditors()), get_modifierContainerEditors()), get_relationLibraryEditors()), get_ontologyImportRootEditors()), get_customCellEditors()), get_knowledgeSourceReferenceEditors()), get_knowledgeSourceEditors()), get_btbFindUsagesViews().qde());
  }
  function _get_btbEditorDefinitions_$ref_updflj() {
    return function () {
      return get_btbEditorDefinitions();
    };
  }
  function getEditorBuildersRootMapperFactory$1$createRootMapper$commonConfig$1($configuration) {
    this.xu0_1 = $configuration;
    this.yu0_1 = $configuration;
  }
  protoOf(getEditorBuildersRootMapperFactory$1$createRootMapper$commonConfig$1).m6t = function (tag) {
    return this.yu0_1.m6t(tag);
  };
  protoOf(getEditorBuildersRootMapperFactory$1$createRootMapper$commonConfig$1).d6u = function (tag) {
    return this.yu0_1.d6u(tag);
  };
  protoOf(getEditorBuildersRootMapperFactory$1$createRootMapper$commonConfig$1).v6t = function (tag) {
    return this.yu0_1.v6t(tag);
  };
  protoOf(getEditorBuildersRootMapperFactory$1$createRootMapper$commonConfig$1).ho = function () {
    return this.xu0_1.ho();
  };
  function getEditorBuildersRootMapperFactory$o$createRootMapper$lambda($nodeFactory, $conceptRegistry, $pasteNodeAdapters, $configuration, $wrapperContext, $splitMergeSupportFactory, $commonConfig, $nodePointerSupport) {
    return function (editorRegistry) {
      var tmp0_nodeAdaptationSupport = new NodeAdaptationSupportImpl(get_btbMetaModel(), $nodeFactory, $conceptRegistry, VOID, $pasteNodeAdapters);
      var tmp1_presentation = $configuration.wtr();
      var tmp2_uiConfig = get_btbUiConfig();
      return new BTBEditorBuilderConfigImpl($wrapperContext, $conceptRegistry, $nodeFactory, tmp0_nodeAdaptationSupport, $splitMergeSupportFactory, editorRegistry, $commonConfig, tmp1_presentation, $configuration, 2, false, $nodePointerSupport, tmp2_uiConfig);
    };
  }
  function getEditorBuildersRootMapperFactory$1() {
  }
  protoOf(getEditorBuildersRootMapperFactory$1).zu0 = function (configuration) {
    var commonConfig = new getEditorBuildersRootMapperFactory$1$createRootMapper$commonConfig$1(configuration);
    var conceptRegistry = configuration.gd3();
    var splitMergeSupportFactory = configuration.hd3();
    var wrapperContext = configuration.l6z();
    var nodePointerSupport = configuration.p6g();
    var nodeFactory = new ConceptRegistryBasedNodeFactory(conceptRegistry, wrapperContext);
    var pasteNodeAdapters = get_btbNodeAdapters(nodeFactory);
    var tmp = get_btbEditorDefinitions();
    return editorSetup(tmp, conceptRegistry, getEditorBuildersRootMapperFactory$o$createRootMapper$lambda(nodeFactory, conceptRegistry, pasteNodeAdapters, configuration, wrapperContext, splitMergeSupportFactory, commonConfig, nodePointerSupport));
  };
  protoOf(getEditorBuildersRootMapperFactory$1).au1 = function (configuration) {
    return this.zu0((!(configuration == null) ? isInterface(configuration, BTBEditorConfiguration) : false) ? configuration : THROW_CCE());
  };
  function OntologyElementType$_get_library_$ref_qnafmw_1() {
    return function (p0) {
      return p0.ffq();
    };
  }
  function OntologyElementType$_get_element_$ref_pl8d15_1() {
    return function (p0) {
      return p0.gfq();
    };
  }
  function _get_btbNodeAdapters_$lambda_gbwmz4($this, $ontology, $element) {
    return function (node) {
      // Inline function 'jetbrains.ocelot.langDef.structure.NodeFactory.create' call
      // Inline function 'kotlin.also' call
      var this_0 = $this.t6v(getKClass(QualifiedOntologyElementReference_1));
      var tmp = this_0.hfu();
      var tmp0_safe_receiver = $ontology(node).m5y().w2w();
      var tmp_0 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.f6j();
      tmp.d2x((tmp_0 == null ? true : isInterface(tmp_0, OntologyLibraryReference_1)) ? tmp_0 : THROW_CCE());
      var tmp_1 = this_0.ifu();
      var tmp1_safe_receiver = $element(node).m5y().w2w();
      var tmp_2 = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.f6j();
      tmp_1.d2x((tmp_2 == null ? true : isInterface(tmp_2, OntologyElementReference_1)) ? tmp_2 : THROW_CCE());
      return this_0;
    };
  }
  function _get_btbNodeAdapters_$lambda_gbwmz4_0($this, $ontology, $element) {
    return function (node) {
      // Inline function 'jetbrains.ocelot.langDef.structure.NodeFactory.create' call
      // Inline function 'kotlin.also' call
      var this_0 = $this.t6v(getKClass(OntologyElementType_1));
      var tmp = $ontology(this_0);
      var tmp0_safe_receiver = node.hfu().m5y().w2w();
      var tmp_0 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.f6j();
      tmp.d2x((tmp_0 == null ? true : isInterface(tmp_0, OntologyLibraryReference_1)) ? tmp_0 : THROW_CCE());
      var tmp_1 = $element(this_0);
      var tmp1_safe_receiver = node.ifu().m5y().w2w();
      var tmp_2 = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.f6j();
      tmp_1.d2x((tmp_2 == null ? true : isInterface(tmp_2, OntologyElementReference_1)) ? tmp_2 : THROW_CCE());
      return this_0;
    };
  }
  function Context$_get_library_$ref_4eq8r4_1() {
    return function (p0) {
      return p0.ffq();
    };
  }
  function Context$_get_element_$ref_n7bi27_1() {
    return function (p0) {
      return p0.gfq();
    };
  }
  function _get_btbNodeAdapters_$lambda_gbwmz4_1($this, $ontology, $element) {
    return function (node) {
      // Inline function 'jetbrains.ocelot.langDef.structure.NodeFactory.create' call
      // Inline function 'kotlin.also' call
      var this_0 = $this.t6v(getKClass(QualifiedOntologyElementReference_1));
      var tmp = this_0.hfu();
      var tmp0_safe_receiver = $ontology(node).m5y().w2w();
      var tmp_0 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.f6j();
      tmp.d2x((tmp_0 == null ? true : isInterface(tmp_0, OntologyLibraryReference_1)) ? tmp_0 : THROW_CCE());
      var tmp_1 = this_0.ifu();
      var tmp1_safe_receiver = $element(node).m5y().w2w();
      var tmp_2 = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.f6j();
      tmp_1.d2x((tmp_2 == null ? true : isInterface(tmp_2, OntologyElementReference_1)) ? tmp_2 : THROW_CCE());
      return this_0;
    };
  }
  function _get_btbNodeAdapters_$lambda_gbwmz4_2($this, $ontology, $element) {
    return function (node) {
      // Inline function 'jetbrains.ocelot.langDef.structure.NodeFactory.create' call
      // Inline function 'kotlin.also' call
      var this_0 = $this.t6v(getKClass(Context_2));
      var tmp = $ontology(this_0);
      var tmp0_safe_receiver = node.hfu().m5y().w2w();
      var tmp_0 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.f6j();
      tmp.d2x((tmp_0 == null ? true : isInterface(tmp_0, OntologyLibraryReference_1)) ? tmp_0 : THROW_CCE());
      var tmp_1 = $element(this_0);
      var tmp1_safe_receiver = node.ifu().m5y().w2w();
      var tmp_2 = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.f6j();
      tmp_1.d2x((tmp_2 == null ? true : isInterface(tmp_2, OntologyElementReference_1)) ? tmp_2 : THROW_CCE());
      return this_0;
    };
  }
  function OntologyElementReferenceValueLibrary$_get_library_$ref_ni4dih_1() {
    return function (p0) {
      return p0.ffq();
    };
  }
  function OntologyElementReferenceValueLibrary$_get_element_$ref_sqef5k() {
    return function (p0) {
      return p0.gfq();
    };
  }
  function _get_btbNodeAdapters_$lambda_gbwmz4_3($this, $ontology, $element) {
    return function (node) {
      // Inline function 'jetbrains.ocelot.langDef.structure.NodeFactory.create' call
      // Inline function 'kotlin.also' call
      var this_0 = $this.t6v(getKClass(QualifiedOntologyElementReference_1));
      var tmp = this_0.hfu();
      var tmp0_safe_receiver = $ontology(node).m5y().w2w();
      var tmp_0 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.f6j();
      tmp.d2x((tmp_0 == null ? true : isInterface(tmp_0, OntologyLibraryReference_1)) ? tmp_0 : THROW_CCE());
      var tmp_1 = this_0.ifu();
      var tmp1_safe_receiver = $element(node).m5y().w2w();
      var tmp_2 = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.f6j();
      tmp_1.d2x((tmp_2 == null ? true : isInterface(tmp_2, OntologyElementReference_1)) ? tmp_2 : THROW_CCE());
      return this_0;
    };
  }
  function _get_btbNodeAdapters_$lambda_gbwmz4_4($this, $ontology, $element) {
    return function (node) {
      // Inline function 'jetbrains.ocelot.langDef.structure.NodeFactory.create' call
      // Inline function 'kotlin.also' call
      var this_0 = $this.t6v(getKClass(OntologyElementReferenceValueLibrary_1));
      var tmp = $ontology(this_0);
      var tmp0_safe_receiver = node.hfu().m5y().w2w();
      var tmp_0 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.f6j();
      tmp.d2x((tmp_0 == null ? true : isInterface(tmp_0, OntologyLibraryReference_1)) ? tmp_0 : THROW_CCE());
      var tmp_1 = $element(this_0);
      var tmp1_safe_receiver = node.ifu().m5y().w2w();
      var tmp_2 = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.f6j();
      tmp_1.d2x((tmp_2 == null ? true : isInterface(tmp_2, OntologyElementReference_1)) ? tmp_2 : THROW_CCE());
      return this_0;
    };
  }
  function Category$_get_library_$ref_sghxsx_1() {
    return function (p0) {
      return p0.ffq();
    };
  }
  function Category$_get_element_$ref_9nwohu_1() {
    return function (p0) {
      return p0.gfq();
    };
  }
  function _get_btbNodeAdapters_$lambda_gbwmz4_5($this, $ontology, $element) {
    return function (node) {
      // Inline function 'jetbrains.ocelot.langDef.structure.NodeFactory.create' call
      // Inline function 'kotlin.also' call
      var this_0 = $this.t6v(getKClass(QualifiedOntologyElementReference_1));
      var tmp = this_0.hfu();
      var tmp0_safe_receiver = $ontology(node).m5y().w2w();
      var tmp_0 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.f6j();
      tmp.d2x((tmp_0 == null ? true : isInterface(tmp_0, OntologyLibraryReference_1)) ? tmp_0 : THROW_CCE());
      var tmp_1 = this_0.ifu();
      var tmp1_safe_receiver = $element(node).m5y().w2w();
      var tmp_2 = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.f6j();
      tmp_1.d2x((tmp_2 == null ? true : isInterface(tmp_2, OntologyElementReference_1)) ? tmp_2 : THROW_CCE());
      return this_0;
    };
  }
  function _get_btbNodeAdapters_$lambda_gbwmz4_6($this, $ontology, $element) {
    return function (node) {
      // Inline function 'jetbrains.ocelot.langDef.structure.NodeFactory.create' call
      // Inline function 'kotlin.also' call
      var this_0 = $this.t6v(getKClass(Category_1));
      var tmp = $ontology(this_0);
      var tmp0_safe_receiver = node.hfu().m5y().w2w();
      var tmp_0 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.f6j();
      tmp.d2x((tmp_0 == null ? true : isInterface(tmp_0, OntologyLibraryReference_1)) ? tmp_0 : THROW_CCE());
      var tmp_1 = $element(this_0);
      var tmp1_safe_receiver = node.ifu().m5y().w2w();
      var tmp_2 = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.f6j();
      tmp_1.d2x((tmp_2 == null ? true : isInterface(tmp_2, OntologyElementReference_1)) ? tmp_2 : THROW_CCE());
      return this_0;
    };
  }
  var properties_initialized_BTBEditorBuildersMapperFactory_kt_thro0m;
  function _init_properties_BTBEditorBuildersMapperFactory_kt__kpj5x0() {
    if (!properties_initialized_BTBEditorBuildersMapperFactory_kt_thro0m) {
      properties_initialized_BTBEditorBuildersMapperFactory_kt_thro0m = true;
      btbEditorDefinitions$delegate = lazy(btbEditorDefinitions$delegate$lambda);
      btbUiConfig = new BTBEditorUIConfig(Companion_getInstance_210().y95_1, Companion_instance_212.eb0(new Vector(16, 16), 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAAOVBMVEUAAABVgKptbbZmgKprfadqfqZpf6drfqdqfqdqfaZqfqZqfqdqfqdrfqdpfqhpfqdqfqZqfqf////7jhcjAAAAD3RSTlMABgceeoSFhrq78vP0+f5yU80mAAAAAWJLR0QSe7xsAAAAAEhJREFUGNNjYCALsPOwoQpwC/IxCgrycjLDBNgEWYEkIwsHXAkjmGTihQsIolDYBBhRKKC1/GBr2QXY4NZyIVEga7lZkSjSAQDl5wGwiZoItAAAAABJRU5ErkJggg=='), Companion_instance_212.eb0(new Vector(16, 16), 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII='));
    }
  }
  function get_btbProgramEditors() {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return btbProgramEditors;
  }
  var btbProgramEditors;
  function getAbstractValueCompletion(_this__u8e3s4) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    measurableValueWithDefaultUnitCompletion(_this__u8e3s4);
    enumValueCompletion_0(_this__u8e3s4);
    complexNotionValueCompletion(_this__u8e3s4);
    stringValueCompletion(_this__u8e3s4);
    integerValueCompletion(_this__u8e3s4);
    variableReferenceValueCompletion(_this__u8e3s4);
    setExpressionCompletion(_this__u8e3s4);
    anonymousClassCompletion(_this__u8e3s4);
    var tmp = _this__u8e3s4.jcg(Companion_getInstance_326().kgf_1);
    _this__u8e3s4.gck(tmp, getAbstractValueCompletion$lambda(_this__u8e3s4));
    ontologyElementReferenceValueLibraryCompletion(_this__u8e3s4);
    ontologyElementReferenceValueCompletion(_this__u8e3s4);
    processPropertyReferenceCompletion(_this__u8e3s4);
  }
  function variableReferenceValueEditor(withDotRightTransform) {
    withDotRightTransform = withDotRightTransform === VOID ? true : withDotRightTransform;
    _init_properties_BTBProgramEditors_kt__cfv01s();
    var tmp0 = childRoleDefaults();
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
    var init = variableReferenceValueEditor$lambda(withDotRightTransform);
    var triggerDependencies = emptyList();
    var tmp = getKClass(VariableReferenceValue_1);
    return new EditorDefinition(tmp, tmp0, null, true, true, triggerDependencies, variableReferenceValueEditor$lambda_0(init));
  }
  function setExpressionEditor() {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    var tmp0 = childRoleDefaults();
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
    var init = setExpressionEditor$lambda;
    var triggerDependencies = emptyList();
    var tmp = getKClass(SetExpression_1);
    return new EditorDefinition(tmp, tmp0, null, false, true, triggerDependencies, setExpressionEditor$lambda_0(init));
  }
  function measurableValueEditor() {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
    var init = measurableValueEditor$lambda;
    var triggerDependencies = emptyList();
    var tmp = getKClass(MeasurableValue_1);
    return new EditorDefinition(tmp, null, null, false, true, triggerDependencies, measurableValueEditor$lambda_0(init));
  }
  function enumValueEditor() {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
    var init = enumValueEditor$lambda;
    var triggerDependencies = emptyList();
    var tmp = getKClass(EnumValue_1);
    return new EditorDefinition(tmp, null, null, true, true, triggerDependencies, enumValueEditor$lambda_0(init));
  }
  function stringValueEditor() {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
    var init = stringValueEditor$lambda;
    var triggerDependencies = emptyList();
    var tmp = getKClass(StringValue_1);
    return new EditorDefinition(tmp, null, null, false, true, triggerDependencies, stringValueEditor$lambda_0(init));
  }
  function integerValueEditor() {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
    var init = integerValueEditor$lambda;
    var triggerDependencies = emptyList();
    var tmp = getKClass(IntegerValue_1);
    return new EditorDefinition(tmp, null, null, false, true, triggerDependencies, integerValueEditor$lambda_0(init));
  }
  function unionEditor() {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
    var init = unionEditor$lambda;
    var triggerDependencies = emptyList();
    var tmp = getKClass(UnionClass_1);
    return new EditorDefinition(tmp, null, null, false, true, triggerDependencies, unionEditor$lambda_0(init));
  }
  function propertyReferenceValueEditor() {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
    var init = propertyReferenceValueEditor$lambda;
    var triggerDependencies = emptyList();
    var tmp = getKClass(ObjectPropertyReferenceValue_1);
    return new EditorDefinition(tmp, null, null, false, true, triggerDependencies, propertyReferenceValueEditor$lambda_0(init));
  }
  function ontologyElementReferenceValueLibraryEditor() {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
    var init = ontologyElementReferenceValueLibraryEditor$lambda;
    var triggerDependencies = emptyList();
    var tmp = getKClass(OntologyElementReferenceValueLibrary_1);
    return new EditorDefinition(tmp, null, null, false, true, triggerDependencies, ontologyElementReferenceValueLibraryEditor$lambda_0(init));
  }
  function ontologyElementReferenceValueEditor() {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
    var init = ontologyElementReferenceValueEditor$lambda;
    var triggerDependencies = emptyList();
    var tmp = getKClass(OntologyElementReferenceValue_1);
    return new EditorDefinition(tmp, null, null, false, true, triggerDependencies, ontologyElementReferenceValueEditor$lambda_0(init));
  }
  function notionTypeEditor() {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    var tmp0 = childRoleDefaults('<notion type>', notionTypeEditor$lambda);
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
    var init = notionTypeEditor$lambda_0;
    var triggerDependencies = emptyList();
    var tmp = getKClass(NotionType_0);
    return new EditorDefinition(tmp, tmp0, null, false, true, triggerDependencies, notionTypeEditor$lambda_1(init));
  }
  function primitiveNotionTypeEditor() {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
    var init = primitiveNotionTypeEditor$lambda;
    var triggerDependencies = emptyList();
    var tmp = getKClass(PrimitiveNotionType_1);
    return new EditorDefinition(tmp, null, null, false, true, triggerDependencies, primitiveNotionTypeEditor$lambda_0(init));
  }
  function transformValueToPropertyReference(_this__u8e3s4, cellFinder, value) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    var wrapperContext = get_internalConfig(_this__u8e3s4).l6z();
    var propertyReferenceValue = value.ri3(wrapperContext);
    var operation = ensureNotNull(propertyReferenceValue.q6q().m5y().w2w());
    var tmp0_safe_receiver = firstOrNull_0(cellFinder.lah(operation));
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.c93(ProjectionalSynchronizers_getInstance().d99_1);
    return tmp1_elvis_lhs == null ? get_EMPTY_CELL_ACTION() : tmp1_elvis_lhs;
  }
  function variablesEditor(_this__u8e3s4) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    var variablesRoot = {_v: null};
    var tmp = keyword_0(_this__u8e3s4, 'variables:');
    // Inline function 'jetbrains.ocelot.projectional.cell.trait.keyPressedCellTrait' call
    var tmp$ret$0 = new variablesEditor$$inlined$keyPressedCellTrait$1(_this__u8e3s4, variablesRoot);
    tmp.w92(tmp$ret$0);
    indent_0(_this__u8e3s4, true, VOID, variablesEditor$lambda(variablesRoot));
  }
  function measurableValueWithDefaultUnitCompletion(_this__u8e3s4) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return _this__u8e3s4.lck(measurableValueWithDefaultUnitCompletion$slambda_0(null));
  }
  function enumValueCompletion_0(_this__u8e3s4) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    var tmp = _this__u8e3s4.jcg(Companion_getInstance_354().tg7_1);
    _this__u8e3s4.gck(tmp, enumValueCompletion$lambda_0(_this__u8e3s4));
  }
  function stringValueCompletion(_this__u8e3s4) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return _this__u8e3s4.lck(stringValueCompletion$slambda_0(null));
  }
  function integerValueCompletion(_this__u8e3s4) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return _this__u8e3s4.lck(integerValueCompletion$slambda_0(null));
  }
  function variableReferenceValueCompletion(_this__u8e3s4) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    var tmp = _this__u8e3s4.jcg(Companion_getInstance_352().mhx_1);
    _this__u8e3s4.gck(tmp, variableReferenceValueCompletion$lambda(_this__u8e3s4));
  }
  function setExpressionCompletion(_this__u8e3s4) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    _this__u8e3s4.bck('{', setExpressionCompletion$lambda(_this__u8e3s4));
    _this__u8e3s4.bck('[', setExpressionCompletion$lambda_0(_this__u8e3s4));
  }
  function ontologyElementReferenceValueLibraryCompletion(_this__u8e3s4) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    var tmp = _this__u8e3s4.jcg(Companion_getInstance_335().dh6_1);
    _this__u8e3s4.gck(tmp, ontologyElementReferenceValueLibraryCompletion$lambda(_this__u8e3s4));
  }
  function ontologyElementReferenceValueCompletion(_this__u8e3s4) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    var tmp = _this__u8e3s4.jcg(Companion_getInstance_336().fh1_1);
    _this__u8e3s4.gck(tmp, ontologyElementReferenceValueCompletion$lambda(_this__u8e3s4));
  }
  function toList_4(_this__u8e3s4) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    var tmp;
    if (_this__u8e3s4 == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp = listOf(_this__u8e3s4);
    }
    var tmp1_elvis_lhs = tmp;
    return tmp1_elvis_lhs == null ? emptyList() : tmp1_elvis_lhs;
  }
  function getExpectedPrimitiveKind(_this__u8e3s4, $completion) {
    var tmp = new $getExpectedPrimitiveKindCOROUTINE$(_this__u8e3s4, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  }
  function getExpectedPrimitiveKind$isValueProvider(_this__u8e3s4) {
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    var tmp_3;
    var tmp_4;
    if (!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, PropertyValue_1) : false) {
      tmp_4 = true;
    } else {
      tmp_4 = !(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, ProcessPropertyValue_1) : false;
    }
    if (tmp_4) {
      tmp_3 = true;
    } else {
      tmp_3 = !(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, InstanceRelationValue) : false;
    }
    if (tmp_3) {
      tmp_2 = true;
    } else {
      tmp_2 = !(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, PropertyConstraint_1) : false;
    }
    if (tmp_2) {
      tmp_1 = true;
    } else {
      tmp_1 = !(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, IsExpression_1) : false;
    }
    if (tmp_1) {
      tmp_0 = true;
    } else {
      tmp_0 = !(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, ProcessProperty_1) : false;
    }
    if (tmp_0) {
      tmp = true;
    } else {
      tmp = !(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, ComplexNotionElementValue_1) : false;
    }
    return tmp;
  }
  function btbProgramEditors$lambda($this$editor) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    keyword_0($this$editor, 'categories:');
    space_0($this$editor);
    var tmp = getKClass(Category_1);
    children_2($this$editor, tmp, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, btbProgramEditors$lambda$lambda);
    newLine_0($this$editor);
    space_0($this$editor);
    newLine_0($this$editor);
    var tmp_0 = getKClass(OntologyImportRootReference_1);
    var tmp_1 = Layout_VERTICAL_getInstance();
    children_2($this$editor, tmp_0, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp_1, btbProgramEditors$lambda$lambda_0);
    newLine_0($this$editor);
    space_0($this$editor);
    newLine_0($this$editor);
    var factSetIdManager = new FactSetIdManager($this$editor.m6d());
    var tmp0_layout = Layout_VERTICAL_getInstance();
    var tmp1_itemFactory = factSetIdManager.nu1();
    var tmp2_pasteHandler = factSetIdManager.ou1();
    var tmp_2 = getKClass(FactSet_1);
    var factSets = children_2($this$editor, tmp_2, VOID, VOID, VOID, VOID, tmp1_itemFactory, tmp2_pasteHandler, VOID, tmp0_layout, btbProgramEditors$lambda$lambda_1);
    if (get_supportFactSelection($this$editor)) {
      $this$editor.qd0().w92(new BTBDocumentFactSelectionTrait(factSets.o35()));
    }
    return Unit_instance;
  }
  function btbProgramEditors$lambda$lambda(document) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return document.yfp();
  }
  function btbProgramEditors$lambda$lambda_0(document) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return document.zfp();
  }
  function btbProgramEditors$lambda$lambda_1(document) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return document.xfp();
  }
  function btbProgramEditors$lambda_0($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function btbProgramEditors$lambda_1(wrapperContext) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    // Inline function 'kotlin.apply' call
    var this_0 = Context_0(wrapperContext);
    this_0.ffq().f2x(OntologyLibraryReference(wrapperContext));
    this_0.gfq().f2x(OntologyElementReference(wrapperContext));
    return this_0;
  }
  function btbProgramEditors$lambda_2($this$editor) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    // Inline function 'kotlin.apply' call
    var this_0 = textProperty_0($this$editor, '<name>', btbProgramEditors$lambda$lambda_2);
    mark_0(this_0, BTBEditorParts_getInstance().pu1_1);
    indentLabel_0($this$editor, ':');
    var tmp = getKClass(OntologyLibraryReference_1);
    var tmp_0 = btbProgramEditors$lambda$lambda_3;
    child_1($this$editor, tmp, tmp_0, VOID, VOID, VOID, VOID, VOID, VOID, VOID, btbProgramEditors$lambda$lambda_4);
    indentLabel_0($this$editor, '/');
    var tmp_1 = getKClass(OntologyElementReference_1);
    child_1($this$editor, tmp_1, btbProgramEditors$lambda$lambda_5);
    return Unit_instance;
  }
  function btbProgramEditors$lambda$lambda_2(context) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return context.y2();
  }
  function btbProgramEditors$lambda$lambda_3(context) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return context.ffq();
  }
  function btbProgramEditors$lambda$lambda_4($this$child) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    var tmp = $this$child.jcg(Companion_getInstance_335().dh6_1);
    $this$child.gck(tmp, btbProgramEditors$lambda$lambda$lambda($this$child));
    return Unit_instance;
  }
  function btbProgramEditors$lambda$lambda$lambda($this_child) {
    return function (reference) {
      // Inline function 'kotlin.apply' call
      var this_0 = OntologyLibraryReference($this_child.l6z());
      this_0.yfq().f2x(reference);
      return this_0;
    };
  }
  function btbProgramEditors$lambda$lambda_5(context) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return context.gfq();
  }
  function btbProgramEditors$lambda_3($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function btbProgramEditors$lambda_4(wc) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    // Inline function 'kotlin.apply' call
    var this_0 = Category(wc);
    this_0.ffq().f2x(OntologyLibraryReference(wc));
    this_0.gfq().f2x(OntologyElementReference(wc));
    return this_0;
  }
  function btbProgramEditors$lambda_5($this$childrenRoleDefaults) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    var tmp = $this$childrenRoleDefaults.jcg(Companion_getInstance_335().dh6_1);
    $this$childrenRoleDefaults.gck(tmp, btbProgramEditors$lambda$lambda_6($this$childrenRoleDefaults));
    return Unit_instance;
  }
  function btbProgramEditors$lambda$lambda_6($this_childrenRoleDefaults) {
    return function (reference) {
      // Inline function 'kotlin.apply' call
      var this_0 = Category($this_childrenRoleDefaults.l6z());
      this_0.ffq().f2x(OntologyLibraryReference_2($this_childrenRoleDefaults.l6z(), reference));
      this_0.gfq().f2x(OntologyElementReference($this_childrenRoleDefaults.l6z()));
      return this_0;
    };
  }
  function btbProgramEditors$lambda_6($this$editor) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    var tmp = getKClass(OntologyLibraryReference_1);
    var tmp_0 = btbProgramEditors$lambda$lambda_7;
    child_1($this$editor, tmp, tmp_0, VOID, VOID, VOID, VOID, VOID, VOID, VOID, btbProgramEditors$lambda$lambda_8);
    indentLabel_0($this$editor, '/');
    var tmp_1 = getKClass(OntologyElementReference_1);
    child_1($this$editor, tmp_1, btbProgramEditors$lambda$lambda_9);
    return Unit_instance;
  }
  function btbProgramEditors$lambda$lambda_7(category) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return category.ffq();
  }
  function btbProgramEditors$lambda$lambda_8($this$child) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    var tmp = $this$child.jcg(Companion_getInstance_335().dh6_1);
    $this$child.gck(tmp, btbProgramEditors$lambda$lambda$lambda_0($this$child));
    return Unit_instance;
  }
  function btbProgramEditors$lambda$lambda$lambda_0($this_child) {
    return function (reference) {
      // Inline function 'kotlin.apply' call
      var this_0 = OntologyLibraryReference($this_child.l6z());
      this_0.yfq().f2x(reference);
      return this_0;
    };
  }
  function btbProgramEditors$lambda$lambda_9(category) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return category.gfq();
  }
  function btbProgramEditors$lambda_7($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function btbProgramEditors$lambda_8($this$childrenRoleDefaults) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    $this$childrenRoleDefaults.bck('import', btbProgramEditors$lambda$lambda_10($this$childrenRoleDefaults));
    return Unit_instance;
  }
  function btbProgramEditors$lambda$lambda_10($this_childrenRoleDefaults) {
    return function () {
      return OntologyImportRootReference($this_childrenRoleDefaults.l6z());
    };
  }
  function btbProgramEditors$lambda_9($this$editor) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    keyword_0($this$editor, 'import');
    space_0($this$editor);
    var tmp4 = Companion_getInstance_327().sh4_1;
    // Inline function 'jetbrains.biokb.lang.editorBuilders.btbReferenceTarget' call
    var referenceProvider = btbProgramEditors$lambda$lambda_11;
    var options = new CompletionOptions();
    var containerInit = btbProgramEditors$lambda$lambda_12;
    var textCellInit = btbProgramEditors$lambda$lambda_13;
    var tmp;
    if (null == null) {
      tmp = btbProgramEditors$lambda$lambda_14;
    } else {
      tmp = null;
    }
    var tmp10 = tmp;
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.references.referenceTarget' call
    var textCellInit_0 = btbProgramEditors$lambda$lambda_15(textCellInit);
    var targetClass = getKClass(OntologyImportRoot_1);
    referenceTarget($this$editor, targetClass, '<root>', tmp4, referenceProvider, null, tmp10, options, containerInit, textCellInit_0);
    ensureLastCaretPosition($this$editor);
    return Unit_instance;
  }
  function btbProgramEditors$lambda$lambda_11(rootReference) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return rootReference.yfq();
  }
  function btbProgramEditors$lambda$lambda_12(_this__u8e3s4) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return Unit_instance;
  }
  function btbProgramEditors$lambda$lambda_13(_this__u8e3s4) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return Unit_instance;
  }
  function btbProgramEditors$lambda$lambda_14(it) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return true;
  }
  function btbProgramEditors$lambda$lambda_15($textCellInit) {
    return function ($this$referenceTarget) {
      $textCellInit($this$referenceTarget);
      enableEagerCompletion($this$referenceTarget);
      return Unit_instance;
    };
  }
  function btbProgramEditors$lambda_10($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function btbProgramEditors$lambda_11($this$childRoleDefaults) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    getAbstractValueCompletion($this$childRoleDefaults);
    return Unit_instance;
  }
  function btbProgramEditors$lambda_12($this$editor) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    var tmp = getKClass(VariableReferenceValue_1);
    child_1($this$editor, tmp, btbProgramEditors$lambda$lambda_16);
    indentLabel_0($this$editor, '.');
    indent_0($this$editor, VOID, VOID, btbProgramEditors$lambda$lambda_17);
    return Unit_instance;
  }
  function btbProgramEditors$lambda$lambda_16(partValue) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return partValue.jfs();
  }
  function btbProgramEditors$lambda$lambda_17($this$indent) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    var tmp = getKClass(PartReferenceOperation);
    child_1($this$indent, tmp, btbProgramEditors$lambda$lambda$lambda_1);
    addTraitOnAttach_0($this$indent, btbProgramEditors$lambda$lambda$lambda_2);
    return Unit_instance;
  }
  function btbProgramEditors$lambda$lambda$lambda_1(partValue) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return partValue.s3z();
  }
  function btbProgramEditors$lambda$lambda$lambda_2(source, _unused_var__etf5q3, cellFinder) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return getDeleteTransformTrait(source, cellFinder);
  }
  function btbProgramEditors$lambda_13($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function btbProgramEditors$lambda_14($this$editor) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    var tmp = getKClass(AbstractValue);
    child_1($this$editor, tmp, btbProgramEditors$lambda$lambda_18);
    label_0($this$editor, '[', VOID, VOID, btbProgramEditors$lambda$lambda_19);
    var tmp_0 = getKClass(InstanceRelationValuePlaceholder);
    children_2($this$editor, tmp_0, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, btbProgramEditors$lambda$lambda_20);
    label_0($this$editor, ']', VOID, VOID, btbProgramEditors$lambda$lambda_21);
    return Unit_instance;
  }
  function invoke$addTraitDeleteRelations(_this__u8e3s4) {
    return addTraitOnAttach_0(_this__u8e3s4, btbProgramEditors$lambda$addTraitDeleteRelations$lambda(_this__u8e3s4));
  }
  function btbProgramEditors$lambda$lambda_18(valueWithProperties) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return valueWithProperties.a1();
  }
  function btbProgramEditors$lambda$lambda_19($this$label) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    invoke$addTraitDeleteRelations($this$label);
    return Unit_instance;
  }
  function btbProgramEditors$lambda$lambda_20(valueWithProperties) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return valueWithProperties.nfu();
  }
  function btbProgramEditors$lambda$lambda_21($this$label) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    invoke$addTraitDeleteRelations($this$label);
    return Unit_instance;
  }
  function btbProgramEditors$22$addTraitDeleteRelations$2$$inlined$createDeleteTransformTrait$1$doWork$1($this_addTraitDeleteRelations) {
    this.ru1_1 = $this_addTraitDeleteRelations;
  }
  protoOf(btbProgramEditors$22$addTraitDeleteRelations$2$$inlined$createDeleteTransformTrait$1$doWork$1).n5w = function (builder) {
    var tmp0_safe_receiver = builder.l60(this.ru1_1.m6d().a1());
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      tmp0_safe_receiver.e6j();
      this.ru1_1.m6d().d6j(tmp0_safe_receiver);
    }
    return Unit_instance;
  };
  function btbProgramEditors$22$addTraitDeleteRelations$2$$inlined$createDeleteTransformTrait$1($this_addTraitDeleteRelations) {
    this.su1_1 = $this_addTraitDeleteRelations;
    DeleteTransformTrait.call(this);
  }
  protoOf(btbProgramEditors$22$addTraitDeleteRelations$2$$inlined$createDeleteTransformTrait$1).tu1 = function (cell) {
    // Inline function 'jetbrains.ocelot.langDef.query.executeQuery' call
    // Inline function 'jetbrains.ocelot.langDef.query.query' call
    var tmp$ret$0 = new btbProgramEditors$22$addTraitDeleteRelations$2$$inlined$createDeleteTransformTrait$1$doWork$1(this.su1_1);
    execute_0(tmp$ret$0);
    return Unit_instance;
  };
  function btbProgramEditors$lambda$addTraitDeleteRelations$lambda($this_addTraitDeleteRelations) {
    return function (_unused_var__etf5q3, _unused_var__etf5q3_0, _unused_var__etf5q3_1) {
      // Inline function 'jetbrains.biokb.lang.traits.createDeleteTransformTrait' call
      return new btbProgramEditors$22$addTraitDeleteRelations$2$$inlined$createDeleteTransformTrait$1($this_addTraitDeleteRelations);
    };
  }
  function btbProgramEditors$lambda_15($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function btbProgramEditors$slambda$lambda(functionTerm) {
    return functionTerm.ifr();
  }
  function btbProgramEditors$slambda$lambda_0(_this__u8e3s4) {
    return Unit_instance;
  }
  function btbProgramEditors$slambda$lambda_1(_this__u8e3s4) {
    return Unit_instance;
  }
  function btbProgramEditors$slambda$lambda_2(it) {
    return true;
  }
  function btbProgramEditors$slambda$lambda_3($textCellInit) {
    return function ($this$referenceTarget) {
      $textCellInit($this$referenceTarget);
      enableEagerCompletion($this$referenceTarget);
      return Unit_instance;
    };
  }
  function btbProgramEditors$slambda$lambda_4(functionTerm) {
    return functionTerm.kfr();
  }
  function btbProgramEditors$slambda(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbProgramEditors$slambda).eu2 = function ($this$asyncInvalidatingEditor, $completion) {
    var tmp = this.fu2($this$asyncInvalidatingEditor, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbProgramEditors$slambda).v9 = function (p1, $completion) {
    return this.eu2(p1 instanceof InvalidatingEditorBuilder ? p1 : THROW_CCE(), $completion);
  };
  protoOf(btbProgramEditors$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 4;
            this.du2_1 = false;
            this.f9_1 = 1;
            suspendResult = this.cu2_1.k60(this.cu2_1.m6d().ifr().w6o(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var resolvedFunctionDeclaration = suspendResult;
            if (!(resolvedFunctionDeclaration == null)) {
              this.f9_1 = 2;
              suspendResult = showCustomEditor(this.cu2_1, resolvedFunctionDeclaration, this.cu2_1.m6d().kfr(), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.f9_1 = 3;
              continue $sm;
            }

          case 2:
            this.du2_1 = suspendResult;
            this.f9_1 = 3;
            continue $sm;
          case 3:
            if (!this.du2_1) {
              var tmp0 = this.cu2_1;
              var tmp2 = '<function>';
              var tmp4 = Companion_getInstance_326().kgf_1;
              var referenceProvider = btbProgramEditors$slambda$lambda;
              var options = new CompletionOptions();
              var containerInit = btbProgramEditors$slambda$lambda_0;
              var textCellInit = btbProgramEditors$slambda$lambda_1;
              var tmp_0;
              if (null == null) {
                tmp_0 = btbProgramEditors$slambda$lambda_2;
              } else {
                tmp_0 = null;
              }
              var tmp10 = tmp_0;
              var textCellInit_0 = btbProgramEditors$slambda$lambda_3(textCellInit);
              var targetClass = getKClass(FunctionDeclaration_1);
              referenceTarget(tmp0, targetClass, tmp2, tmp4, referenceProvider, null, tmp10, options, containerInit, textCellInit_0);
              indentLabel_0(this.cu2_1, '(');
              var tmp_1 = getKClass(BindingValuePlaceholder_1);
              var tmp_2 = Layout_HORIZONTAL_getInstance();
              children_2(this.cu2_1, tmp_1, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp_2, btbProgramEditors$slambda$lambda_4);
              indentLabel_0(this.cu2_1, ')');
            }

            return Unit_instance;
          case 4:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 4) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbProgramEditors$slambda).fu2 = function ($this$asyncInvalidatingEditor, completion) {
    var i = new btbProgramEditors$slambda(completion);
    i.cu2_1 = $this$asyncInvalidatingEditor;
    return i;
  };
  function btbProgramEditors$slambda_0(resultContinuation) {
    var i = new btbProgramEditors$slambda(resultContinuation);
    var l = function ($this$asyncInvalidatingEditor, $completion) {
      return i.eu2($this$asyncInvalidatingEditor, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function btbProgramEditors$lambda$slambda($this_EditorDefinition, $init, $invalidator, $invalidated, resultContinuation) {
    this.ou2_1 = $this_EditorDefinition;
    this.pu2_1 = $init;
    this.qu2_1 = $invalidator;
    this.ru2_1 = $invalidated;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbProgramEditors$lambda$slambda).x9e = function ($completion) {
    var tmp = this.y9e($completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(btbProgramEditors$lambda$slambda).z9e = function ($completion) {
    return this.x9e($completion);
  };
  protoOf(btbProgramEditors$lambda$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 6;
            this.g9_1 = 5;
            this.su2_1 = new Invalidator();
            this.tu2_1 = this.ou2_1.ud3(this.su2_1);
            this.f9_1 = 1;
            continue $sm;
          case 1:
            this.g9_1 = 4;
            this.f9_1 = 2;
            suspendResult = this.pu2_1(this.tu2_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.f9_1 = 3;
            continue $sm;
          case 3:
            this.g9_1 = 5;
            affects(this.su2_1.z5v(Unit_instance), this.qu2_1);
            this.g9_1 = 6;
            this.f9_1 = 7;
            continue $sm;
          case 4:
            this.g9_1 = 5;
            var t = this.i9_1;
            affects(this.su2_1.z5v(Unit_instance), this.qu2_1);
            throw t;
          case 5:
            this.g9_1 = 6;
            var tmp_0 = this.i9_1;
            if (tmp_0 instanceof AlreadyInvalidException) {
              var e = this.i9_1;
              this.ru2_1.d2x(true);
              this.f9_1 = 7;
              continue $sm;
            } else {
              throw this.i9_1;
            }

          case 6:
            throw this.i9_1;
          case 7:
            this.g9_1 = 6;
            return Unit_instance;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.g9_1 === 6) {
          throw e_0;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(btbProgramEditors$lambda$slambda).y9e = function (completion) {
    return new btbProgramEditors$lambda$slambda(this.ou2_1, this.pu2_1, this.qu2_1, this.ru2_1, completion);
  };
  function btbProgramEditors$lambda$slambda_0($this_EditorDefinition, $init, $invalidator, $invalidated, resultContinuation) {
    var i = new btbProgramEditors$lambda$slambda($this_EditorDefinition, $init, $invalidator, $invalidated, resultContinuation);
    var l = function ($completion) {
      return i.x9e($completion);
    };
    l.$arity = 0;
    return l;
  }
  function btbProgramEditors$lambda_16($init) {
    return function ($this$EditorDefinition) {
      var invalidator = new Invalidator();
      var invalidated = new ValueProperty(false);
      depend(invalidator, invalidated);
      $this$EditorDefinition.vd3(btbProgramEditors$lambda$slambda_0($this$EditorDefinition, $init, invalidator, invalidated, null));
      return invalidator.z5v(Unit_instance);
    };
  }
  function btbProgramEditors$lambda_17(wc) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return TypePlaceholder(wc);
  }
  function btbProgramEditors$lambda_18($this$editor) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    placeholderInCollection_0($this$editor, '<type>', get_objectTypeCompletion());
    return Unit_instance;
  }
  function btbProgramEditors$lambda_19($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function btbProgramEditors$lambda_20(wrapperContext) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    // Inline function 'kotlin.apply' call
    var this_0 = OntologyElementType(wrapperContext);
    this_0.ffq().f2x(OntologyLibraryReference(wrapperContext));
    this_0.gfq().f2x(OntologyElementReference(wrapperContext));
    return this_0;
  }
  function btbProgramEditors$lambda_21($this$childrenRoleDefaults) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    ontologyElementTypeCompletion_0($this$childrenRoleDefaults);
    return Unit_instance;
  }
  function btbProgramEditors$lambda_22($this$editor) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    var tmp = getKClass(OntologyLibraryReference_1);
    child_1($this$editor, tmp, btbProgramEditors$lambda$lambda_22);
    indentLabel_0($this$editor, '/');
    var tmp_0 = getKClass(OntologyElementReference_1);
    child_1($this$editor, tmp_0, btbProgramEditors$lambda$lambda_23);
    return Unit_instance;
  }
  function btbProgramEditors$lambda$lambda_22(elementType) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return elementType.ffq();
  }
  function btbProgramEditors$lambda$lambda_23(elementType) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return elementType.gfq();
  }
  function btbProgramEditors$lambda_23($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function btbProgramEditors$lambda_24(wrapperContext) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    // Inline function 'kotlin.apply' call
    var this_0 = ProcessType(wrapperContext);
    this_0.vfq().f2x(LibraryProcessSpecification(wrapperContext));
    return this_0;
  }
  function btbProgramEditors$lambda_25($this$childrenRoleDefaults) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    processTypeCompletion($this$childrenRoleDefaults);
    return Unit_instance;
  }
  function btbProgramEditors$lambda_26($this$editor) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    var tmp = getKClass(LibraryProcessSpecification_1);
    var specificationCell = child_1($this$editor, tmp, btbProgramEditors$lambda$lambda_24);
    considerEmptyBy($this$editor, specificationCell);
    deleteIfEmpty($this$editor);
    return Unit_instance;
  }
  function btbProgramEditors$lambda$lambda_24(it) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return it.vfq();
  }
  function btbProgramEditors$lambda_27($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function btbProgramEditors$lambda_28($this$editor) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
    var completionSupplier = btbProgramEditors$lambda$lambda_25;
    var separator = get_defaultChildrenSeparator();
    new ChildrenRoleDefaults(getKClass(OneOf_1), '<empty>', null, separator, completionSupplier, true);
    keyword_0($this$editor, 'one of <');
    var tmp = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_0 = getPropertyCallableRef('expressions', 1, tmp, OneOf$_get_expressions_$ref_t8u9ia_1(), null);
    var tmp0_contextLink = new MultipleChildLink(getKClass(OneOf_1), this_0);
    var tmp1_layout = Layout_INDENT_getInstance();
    var tmp2_separator = new StringSeparator(',', false, true);
    var tmp_0 = getKClass(FactExpressionPlaceholder);
    children_2($this$editor, tmp_0, tmp0_contextLink, '<empty>', VOID, tmp2_separator, VOID, VOID, VOID, tmp1_layout, btbProgramEditors$lambda$lambda_26);
    keyword_0($this$editor, '>');
    return Unit_instance;
  }
  function btbProgramEditors$lambda$lambda_25($this$childrenRoleDefaults) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    $this$childrenRoleDefaults.bck('one of', btbProgramEditors$lambda$lambda$lambda_3($this$childrenRoleDefaults));
    return Unit_instance;
  }
  function btbProgramEditors$lambda$lambda$lambda_3($this_childrenRoleDefaults) {
    return function () {
      return OneOf($this_childrenRoleDefaults.l6z());
    };
  }
  function OneOf$_get_expressions_$ref_t8u9ia_1() {
    return function (p0) {
      return p0.mfs();
    };
  }
  function btbProgramEditors$lambda$lambda_26(oneOfExpression) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return oneOfExpression.mfs();
  }
  function btbProgramEditors$lambda_29($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function btbProgramEditors$lambda_30($this$childRoleDefaults) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    var tmp = $this$childRoleDefaults.jcg(Companion_getInstance_355().thl_1);
    $this$childRoleDefaults.gck(tmp, btbProgramEditors$lambda$lambda_27($this$childRoleDefaults));
    return Unit_instance;
  }
  function btbProgramEditors$lambda$lambda_27($this_childRoleDefaults) {
    return function (content) {
      // Inline function 'kotlin.apply' call
      var this_0 = PropertyReferenceOperation($this_childRoleDefaults.l6z());
      this_0.q6q().b6p(content);
      return this_0;
    };
  }
  function btbProgramEditors$lambda_31($this$editor) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    var propertyRefOperation = $this$editor.m6d();
    var parameterCell = {_v: null};
    var tmp2 = '<property>';
    var tmp4 = Companion_getInstance_355().thl_1;
    var tmp6 = btbProgramEditors$lambda$lambda_28;
    var tmp8 = btbProgramEditors$lambda$lambda_29;
    // Inline function 'jetbrains.biokb.lang.editorBuilders.btbReferenceTarget' call
    var textCellInit = btbProgramEditors$lambda$lambda_30(propertyRefOperation, parameterCell, $this$editor);
    var options = new CompletionOptions();
    var containerInit = btbProgramEditors$lambda$lambda_31;
    var tmp;
    if (tmp8 == null) {
      tmp = btbProgramEditors$lambda$lambda_32;
    } else {
      tmp = tmp8;
    }
    var tmp10 = tmp;
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.references.referenceTarget' call
    var textCellInit_0 = btbProgramEditors$lambda$lambda_33(textCellInit);
    var targetClass = getKClass(ObjectPropertyDeclaration_1);
    var referenceCell = referenceTarget($this$editor, targetClass, tmp2, tmp4, tmp6, null, tmp10, options, containerInit, textCellInit_0);
    var tmp_0 = getKClass(SetValuedPropertyParameter_1);
    var tmp_1 = btbProgramEditors$lambda$lambda_34;
    parameterCell._v = child_1($this$editor, tmp_0, tmp_1, VOID, VOID, VOID, VOID, btbProgramEditors$lambda$lambda_35(referenceCell));
    var tmp_2 = Synchronizers_instance;
    var tmp_3 = PropertyBinding_instance;
    var tmp_4 = notNull($this$editor.m6d().dfu().m5y());
    var tmp_5;
    if (parameterCell._v == null) {
      throwUninitializedPropertyAccessException('parameterCell');
    } else {
      tmp_5 = parameterCell._v;
    }
    $this$editor.l8b(tmp_2.g8b([tmp_3.n30(tmp_4, tmp_5.m92())]));
    return Unit_instance;
  }
  function btbProgramEditors$lambda$lambda_28(it) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return it.q6q();
  }
  function btbProgramEditors$lambda$lambda_29(it) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return !contains_8(it, '(') && !contains_8(it, '.');
  }
  function btbProgramEditors$lambda$lambda$lambda$lambda($parameterCell, $this_btbReferenceTarget, $propertyRefOperation, $cellFinder) {
    return function () {
      var tmp;
      var tmp_0;
      if ($parameterCell._v == null) {
        throwUninitializedPropertyAccessException('parameterCell');
      } else {
        tmp_0 = $parameterCell._v;
      }
      if (tmp_0.m92().w2w()) {
        tmp = get_EMPTY_CELL_ACTION();
      } else {
        var newNode = SetValuedPropertyParameter(get_internalConfig($this_btbReferenceTarget).l6z());
        $propertyRefOperation.dfu().d2x(newNode);
        var tmp0_safe_receiver = firstOrNull_0($cellFinder.lah(newNode));
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.c93(ProjectionalSynchronizers_getInstance().d99_1);
        tmp = tmp1_elvis_lhs == null ? get_EMPTY_CELL_ACTION() : tmp1_elvis_lhs;
      }
      return tmp;
    };
  }
  function btbProgramEditors$lambda$lambda$lambda$lambda_0($parameterCell, $this_btbReferenceTarget, $cellFinder, $currentPropertyRefValue) {
    return function () {
      var tmp;
      var tmp_0;
      if ($parameterCell._v == null) {
        throwUninitializedPropertyAccessException('parameterCell');
      } else {
        tmp_0 = $parameterCell._v;
      }
      if (tmp_0.m92().w2w()) {
        tmp = get_EMPTY_CELL_ACTION();
      } else {
        tmp = transformValueToPropertyReference($this_btbReferenceTarget, $cellFinder, $currentPropertyRefValue);
      }
      return tmp;
    };
  }
  function btbProgramEditors$46$6$2$6$$inlined$executeQuery$1($this_editor) {
    this.uu2_1 = $this_editor;
  }
  protoOf(btbProgramEditors$46$6$2$6$$inlined$executeQuery$1).n5w = function (builder) {
    var tmp;
    // Inline function 'jetbrains.ocelot.langDef.structure.ancestorOrSelf' call
    var this_0 = this.uu2_1.m6d();
    var tmp$ret$0 = ancestorOrSelf(this_0, getKClass(ProcessPropertyValue_1));
    if (!(builder.l60(tmp$ret$0) == null)) {
      tmp = true;
    } else {
      // Inline function 'jetbrains.ocelot.langDef.structure.ancestorOrSelf' call
      var this_1 = this.uu2_1.m6d();
      var tmp$ret$1 = ancestorOrSelf(this_1, getKClass(ModifierFactExpression_0));
      tmp = !(builder.l60(tmp$ret$1) == null);
    }
    return tmp;
  };
  function btbProgramEditors$lambda$lambda$lambda$lambda_1($parameterCell, $this_btbReferenceTarget, $currentPropertyRefValue, $cellFinder, $this_editor) {
    return function () {
      var tmp;
      var tmp_0;
      var tmp_1;
      if ($parameterCell._v == null) {
        throwUninitializedPropertyAccessException('parameterCell');
      } else {
        tmp_1 = $parameterCell._v;
      }
      if (tmp_1.m92().w2w()) {
        tmp_0 = true;
      } else {
        // Inline function 'jetbrains.ocelot.langDef.query.executeQuery' call
        // Inline function 'jetbrains.ocelot.langDef.query.query' call
        var tmp$ret$0 = new btbProgramEditors$46$6$2$6$$inlined$executeQuery$1($this_editor);
        tmp_0 = execute_0(tmp$ret$0);
      }
      if (tmp_0) {
        tmp = get_EMPTY_CELL_ACTION();
      } else {
        // Inline function 'kotlin.apply' call
        var this_0 = IsExpression(get_internalConfig($this_btbReferenceTarget).l6z());
        var tmp_2 = this_0.mdy();
        var tmp_3 = $currentPropertyRefValue.f6j();
        tmp_2.f2x(isInterface(tmp_3, ObjectPropertyReferenceValue_1) ? tmp_3 : THROW_CCE());
        var newNode = this_0;
        $currentPropertyRefValue.d6j(newNode);
        var tmp0_safe_receiver = firstOrNull_0($cellFinder.lah(newNode));
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.c93(ProjectionalSynchronizers_getInstance().d99_1);
        tmp = tmp1_elvis_lhs == null ? get_EMPTY_CELL_ACTION() : tmp1_elvis_lhs;
      }
      return tmp;
    };
  }
  function btbProgramEditors$lambda$lambda$lambda_4($propertyRefOperation, $parameterCell, $this_btbReferenceTarget, $this_editor) {
    return function ($this$rightTransform, _unused_var__etf5q3, _unused_var__etf5q3_0, cellFinder) {
      $this$rightTransform.gcg('(', btbProgramEditors$lambda$lambda$lambda$lambda($parameterCell, $this_btbReferenceTarget, $propertyRefOperation, cellFinder));
      var tmp = $propertyRefOperation.bp();
      var currentPropertyRefValue = (!(tmp == null) ? isInterface(tmp, ObjectPropertyReferenceValue_1) : false) ? tmp : THROW_CCE();
      $this$rightTransform.gcg('.', btbProgramEditors$lambda$lambda$lambda$lambda_0($parameterCell, $this_btbReferenceTarget, cellFinder, currentPropertyRefValue));
      $this$rightTransform.gcg('is', btbProgramEditors$lambda$lambda$lambda$lambda_1($parameterCell, $this_btbReferenceTarget, currentPropertyRefValue, cellFinder, $this_editor));
      return Unit_instance;
    };
  }
  function btbProgramEditors$lambda$lambda_30($propertyRefOperation, $parameterCell, $this_editor) {
    return function ($this$btbReferenceTarget) {
      rightTransform_0($this$btbReferenceTarget, btbProgramEditors$lambda$lambda$lambda_4($propertyRefOperation, $parameterCell, $this$btbReferenceTarget, $this_editor));
      return Unit_instance;
    };
  }
  function btbProgramEditors$lambda$lambda_31(_this__u8e3s4) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return Unit_instance;
  }
  function btbProgramEditors$lambda$lambda_32(it) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return true;
  }
  function btbProgramEditors$lambda$lambda_33($textCellInit) {
    return function ($this$referenceTarget) {
      $textCellInit($this$referenceTarget);
      enableEagerCompletion($this$referenceTarget);
      return Unit_instance;
    };
  }
  function btbProgramEditors$lambda$lambda_34(it) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return it.dfu();
  }
  function btbProgramEditors$lambda$lambda_35($referenceCell) {
    return function () {
      var tmp0_safe_receiver = firstFocusable($referenceCell);
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : toEnd_0(tmp0_safe_receiver);
      (tmp1_elvis_lhs == null ? get_EMPTY_CELL_ACTION() : tmp1_elvis_lhs)();
      return Unit_instance;
    };
  }
  function btbProgramEditors$lambda_32($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function btbProgramEditors$lambda_33($this$editor) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    var tmp = $this$editor.m6d().bp();
    var propertyRefOperation = (!(tmp == null) ? isInterface(tmp, PropertyReferenceOperation_1) : false) ? tmp : THROW_CCE();
    indentLabel_0($this$editor, '(', false);
    var tmp_0 = getKClass(AbstractValue);
    child_1($this$editor, tmp_0, btbProgramEditors$lambda$lambda_36, '<parameter>');
    // Inline function 'kotlin.apply' call
    var this_0 = indentLabel_0($this$editor, ')', true);
    rightTransform_1($this$editor, this_0, btbProgramEditors$lambda$lambda_37(propertyRefOperation, $this$editor));
    return Unit_instance;
  }
  function btbProgramEditors$lambda$lambda_36(it) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return it.a1();
  }
  function btbProgramEditors$lambda$lambda$lambda_5($propertyRefOperation, $this_editor, $cellFinder) {
    return function () {
      var tmp = $propertyRefOperation.bp();
      var currentPropertyRefValue = (!(tmp == null) ? isInterface(tmp, ObjectPropertyReferenceValue_1) : false) ? tmp : THROW_CCE();
      return transformValueToPropertyReference($this_editor, $cellFinder, currentPropertyRefValue);
    };
  }
  function btbProgramEditors$lambda$lambda_37($propertyRefOperation, $this_editor) {
    return function ($this$rightTransform, _unused_var__etf5q3, _unused_var__etf5q3_0, cellFinder) {
      $this$rightTransform.gcg('.', btbProgramEditors$lambda$lambda$lambda_5($propertyRefOperation, $this_editor, cellFinder));
      return Unit_instance;
    };
  }
  function btbProgramEditors$lambda_34($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function btbProgramEditors$lambda_35($this$editor) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    indentLabel_0($this$editor, 'id:');
    space_0($this$editor);
    textProperty_0($this$editor, '<no id>', btbProgramEditors$lambda$lambda_38);
    newLine_0($this$editor);
    knowledgeSources($this$editor);
    newLine_0($this$editor);
    var tmp = btbProgramEditors$lambda$lambda_39;
    textProperty_0($this$editor, '<name>', tmp, btbProgramEditors$lambda$lambda_40);
    newLine_0($this$editor);
    commentEditor($this$editor);
    newLine_0($this$editor);
    var withKeyword = keyword_0($this$editor, 'with');
    indentLabel_0($this$editor, '(');
    var oldContextCell = indent_0($this$editor, VOID, VOID, btbProgramEditors$lambda$lambda_41);
    // Inline function 'jetbrains.ocelot.mapper.core.Synchronizers.forDisposable' call
    var tmp$ret$0 = new btbProgramEditors$50$$inlined$forDisposable$1($this$editor, oldContextCell);
    $this$editor.l8b(tmp$ret$0);
    var tmp0_layout = Layout_HORIZONTAL_getInstance();
    var tmp2 = getKClass(Context_2);
    var tmp_0 = KProperty1;
    var tmp4 = getPropertyCallableRef('contexts', 1, tmp_0, FactSet$_get_contexts_$ref_i2luf8_2(), null);
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.children' call
    var placeholderText = '<contexts>';
    var placeholderTraitFactory = btbProgramEditors$lambda$lambda_42;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp_1 = new MultipleChildLink(getKClass(FactSet_1), tmp4);
    children_2($this$editor, tmp2, tmp_1, placeholderText, placeholderTraitFactory, null, null, null, null, tmp0_layout, btbProgramEditors$lambda$lambda_43(tmp4));
    indentLabel_0($this$editor, ')', true);
    var newFacts = {_v: null};
    indent_0($this$editor, true, VOID, btbProgramEditors$lambda$lambda_44(newFacts));
    if (get_supportFactSelection($this$editor)) {
      var tmp_2 = $this$editor.qd0();
      var tmp_3;
      if (newFacts._v == null) {
        throwUninitializedPropertyAccessException('newFacts');
      } else {
        tmp_3 = newFacts._v;
      }
      tmp_2.w92(new FactSetFactSelectionTrait(tmp_3.o35()));
    }
    newLine_0($this$editor);
    var lastUnderscore = closingFor(label_0($this$editor, '_'), withKeyword);
    $this$editor.td3(btbProgramEditors$lambda$lambda_45(lastUnderscore));
    return Unit_instance;
  }
  function btbProgramEditors$lambda$lambda_38(it) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return it.zfq();
  }
  function btbProgramEditors$lambda$lambda_39(factSet) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return factSet.y2();
  }
  function btbProgramEditors$lambda$lambda_40($this$textProperty) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    $this$textProperty.qd0().w92(TextEditing_getInstance().ua6());
    return Unit_instance;
  }
  function btbProgramEditors$lambda$lambda_41($this$indent) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    // Inline function 'kotlin.also' call
    label_0($this$indent, '[old: ').d97().f2x(true);
    var tmp = getKClass(Context_2);
    var tmp_0 = btbProgramEditors$lambda$lambda$lambda_6;
    child_1($this$indent, tmp, tmp_0, VOID, VOID, VOID, VOID, VOID, VOID, VOID, btbProgramEditors$lambda$lambda$lambda_7);
    // Inline function 'kotlin.also' call
    label_0($this$indent, '], new: ').d97().f2x(true);
    return Unit_instance;
  }
  function btbProgramEditors$lambda$lambda$lambda_6(factSet) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return factSet.afr();
  }
  function btbProgramEditors$lambda$lambda$lambda_7($this$child) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    var tmp = editorString($this$child, BTBEditorParts_getInstance().pu1_1);
    $this$child.hck(tmp, btbProgramEditors$lambda$lambda$lambda$lambda_2($this$child));
    var tmp_0 = $this$child.jcg(Companion_getInstance_335().dh6_1);
    $this$child.gck(tmp_0, btbProgramEditors$lambda$lambda$lambda$lambda_3($this$child));
    return Unit_instance;
  }
  function btbProgramEditors$lambda$lambda$lambda$lambda_2($this_child) {
    return function (name) {
      // Inline function 'kotlin.apply' call
      var this_0 = Context_0($this_child.l6z());
      this_0.y2().f2x(name);
      this_0.gfq().f2x(OntologyElementReference($this_child.l6z()));
      this_0.ffq().f2x(OntologyLibraryReference($this_child.l6z()));
      return this_0;
    };
  }
  function btbProgramEditors$lambda$lambda$lambda$lambda_3($this_child) {
    return function (reference) {
      // Inline function 'kotlin.apply' call
      var this_0 = Context_0($this_child.l6z());
      this_0.gfq().f2x(OntologyElementReference($this_child.l6z()));
      var tmp = this_0.ffq();
      // Inline function 'kotlin.apply' call
      var this_1 = OntologyLibraryReference($this_child.l6z());
      this_1.yfq().f2x(reference);
      tmp.f2x(this_1);
      return this_0;
    };
  }
  function btbProgramEditors$50$$inlined$forDisposable$1($this_editor, $oldContextCell) {
    this.wu2_1 = $this_editor;
    this.xu2_1 = $oldContextCell;
    DisposableSynchronizer.call(this);
  }
  protoOf(btbProgramEditors$50$$inlined$forDisposable$1).s87 = function (ctx) {
    return PropertyBinding_instance.n30(not(isNull(this.wu2_1.m6d().afr().m5y())), this.xu2_1.m92());
  };
  function FactSet$_get_contexts_$ref_i2luf8_2() {
    return function (p0) {
      return p0.bfr();
    };
  }
  function btbProgramEditors$lambda$lambda_42(_unused_var__etf5q3, trait) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return trait;
  }
  function btbProgramEditors$lambda$lambda_43($childrenProperty) {
    return function (it) {
      return $childrenProperty(it);
    };
  }
  function btbProgramEditors$lambda$lambda$lambda_8($this$indent) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    newLine_0($this$indent);
    var tmp = getKClass(Fact_1);
    var tmp_0 = Layout_VERTICAL_getInstance();
    children_2($this$indent, tmp, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp_0, btbProgramEditors$lambda$lambda$lambda$lambda_4);
    return Unit_instance;
  }
  function btbProgramEditors$lambda$lambda$lambda$lambda_4(factSet) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return factSet.wfq();
  }
  function btbProgramEditors$lambda$lambda$lambda$lambda_5(factSet) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return factSet.cfr();
  }
  function btbProgramEditors$lambda$lambda$lambda_9($newFacts) {
    return function ($this$indent) {
      newLine_0($this$indent);
      var tmp = getKClass(NewFact);
      var tmp_0 = Layout_VERTICAL_getInstance();
      $newFacts._v = children_2($this$indent, tmp, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp_0, btbProgramEditors$lambda$lambda$lambda$lambda_5);
      return Unit_instance;
    };
  }
  function btbProgramEditors$lambda$lambda_44($newFacts) {
    return function ($this$indent) {
      newLine_0($this$indent);
      variablesEditor($this$indent);
      newLine_0($this$indent);
      keyword_0($this$indent, 'facts:');
      indent_0($this$indent, true, VOID, btbProgramEditors$lambda$lambda$lambda_8);
      newLine_0($this$indent);
      keyword_0($this$indent, 'new facts:');
      var tmp = !get_supportFactSelection($this$indent);
      indent_0($this$indent, tmp, VOID, btbProgramEditors$lambda$lambda$lambda_9($newFacts));
      return Unit_instance;
    };
  }
  function btbProgramEditors$lambda$lambda_45($lastUnderscore) {
    return function (cell, event) {
      var tmp;
      if (event.m8j(Key_ENTER_getInstance(), []) && !comes(event, $lastUnderscore, cell)) {
        event.n8i();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function btbProgramEditors$lambda_36($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function btbProgramEditors$lambda_37($this$editor) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    indent_0($this$editor, VOID, VOID, btbProgramEditors$lambda$lambda_46);
    return Unit_instance;
  }
  function btbProgramEditors$lambda$lambda_46($this$indent) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    var tmp2 = '<library>';
    var tmp4 = Companion_getInstance_335().dh6_1;
    // Inline function 'jetbrains.biokb.lang.editorBuilders.btbReferenceTarget' call
    var referenceProvider = btbProgramEditors$lambda$lambda$lambda_10;
    var options = new CompletionOptions();
    var containerInit = btbProgramEditors$lambda$lambda$lambda_11;
    var textCellInit = btbProgramEditors$lambda$lambda$lambda_12;
    var tmp;
    if (null == null) {
      tmp = btbProgramEditors$lambda$lambda$lambda_13;
    } else {
      tmp = null;
    }
    var tmp10 = tmp;
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.references.referenceTarget' call
    var textCellInit_0 = btbProgramEditors$lambda$lambda$lambda_14(textCellInit);
    var targetClass = getKClass(OntologyLibrary_1);
    referenceTarget($this$indent, targetClass, tmp2, tmp4, referenceProvider, null, tmp10, options, containerInit, textCellInit_0);
    return Unit_instance;
  }
  function btbProgramEditors$lambda$lambda$lambda_10(libraryReference) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return libraryReference.yfq();
  }
  function btbProgramEditors$lambda$lambda$lambda_11(_this__u8e3s4) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return Unit_instance;
  }
  function btbProgramEditors$lambda$lambda$lambda_12(_this__u8e3s4) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return Unit_instance;
  }
  function btbProgramEditors$lambda$lambda$lambda_13(it) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return true;
  }
  function btbProgramEditors$lambda$lambda$lambda_14($textCellInit) {
    return function ($this$referenceTarget) {
      $textCellInit($this$referenceTarget);
      enableEagerCompletion($this$referenceTarget);
      return Unit_instance;
    };
  }
  function btbProgramEditors$lambda_38($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function btbProgramEditors$lambda_39(wrapperContext) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return ClassExpressionPlaceholder(wrapperContext);
  }
  function btbProgramEditors$lambda_40($this$childrenRoleDefaults) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    excludingClassExpressionCompletion($this$childrenRoleDefaults, $this$childrenRoleDefaults.ack());
    return Unit_instance;
  }
  function btbProgramEditors$lambda_41($this$childRoleDefaults) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    var tmp = $this$childRoleDefaults.jcg(Companion_getInstance_336().fh1_1);
    $this$childRoleDefaults.gck(tmp, btbProgramEditors$lambda$lambda_47($this$childRoleDefaults));
    return Unit_instance;
  }
  function btbProgramEditors$lambda$lambda_47($this_childRoleDefaults) {
    return function (reference) {
      // Inline function 'kotlin.apply' call
      var this_0 = OntologyElementReference($this_childRoleDefaults.l6z());
      this_0.gfq().b6p(reference);
      return this_0;
    };
  }
  function btbProgramEditors$lambda_42($this$editor) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    indent_0($this$editor, VOID, VOID, btbProgramEditors$lambda$lambda_48);
    return Unit_instance;
  }
  function btbProgramEditors$lambda$lambda_48($this$indent) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    var tmp2 = '<element>';
    var tmp4 = Companion_getInstance_336().fh1_1;
    // Inline function 'jetbrains.biokb.lang.editorBuilders.btbReferenceTarget' call
    var referenceProvider = btbProgramEditors$lambda$lambda$lambda_15;
    var options = new CompletionOptions();
    var containerInit = btbProgramEditors$lambda$lambda$lambda_16;
    var textCellInit = btbProgramEditors$lambda$lambda$lambda_17;
    var tmp;
    if (null == null) {
      tmp = btbProgramEditors$lambda$lambda$lambda_18;
    } else {
      tmp = null;
    }
    var tmp10 = tmp;
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.references.referenceTarget' call
    var textCellInit_0 = btbProgramEditors$lambda$lambda$lambda_19(textCellInit);
    var targetClass = getKClass(OntologyElement_1);
    // Inline function 'kotlin.apply' call
    referenceTarget($this$indent, targetClass, tmp2, tmp4, referenceProvider, null, tmp10, options, containerInit, textCellInit_0).w92(get_spaceDoesntCloseCompletion());
    return Unit_instance;
  }
  function btbProgramEditors$lambda$lambda$lambda_15(elementReference) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return elementReference.gfq();
  }
  function btbProgramEditors$lambda$lambda$lambda_16(_this__u8e3s4) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return Unit_instance;
  }
  function btbProgramEditors$lambda$lambda$lambda_17(_this__u8e3s4) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return Unit_instance;
  }
  function btbProgramEditors$lambda$lambda$lambda_18(it) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return true;
  }
  function btbProgramEditors$lambda$lambda$lambda_19($textCellInit) {
    return function ($this$referenceTarget) {
      $textCellInit($this$referenceTarget);
      enableEagerCompletion($this$referenceTarget);
      return Unit_instance;
    };
  }
  function btbProgramEditors$lambda_43($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function btbProgramEditors$lambda_44($this$childRoleDefaults) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    var tmp = $this$childRoleDefaults.jcg(Companion_getInstance_337().pgo_1);
    $this$childRoleDefaults.gck(tmp, btbProgramEditors$lambda$lambda_49($this$childRoleDefaults));
    return Unit_instance;
  }
  function btbProgramEditors$lambda$lambda_49($this_childRoleDefaults) {
    return function (reference) {
      return LocalOntologyElementReference_2($this_childRoleDefaults.l6z(), reference);
    };
  }
  function btbProgramEditors$lambda_45($this$editor) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    deleteIfEmpty($this$editor);
    var refCell = {_v: null};
    indent_0($this$editor, VOID, VOID, btbProgramEditors$lambda$lambda_50(refCell));
    var tmp;
    if (refCell._v == null) {
      throwUninitializedPropertyAccessException('refCell');
    } else {
      tmp = refCell._v;
    }
    considerEmptyBy($this$editor, tmp);
    return Unit_instance;
  }
  function btbProgramEditors$lambda$lambda$lambda_20(elementReference) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return elementReference.gfq();
  }
  function btbProgramEditors$lambda$lambda$lambda_21(_this__u8e3s4) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return Unit_instance;
  }
  function btbProgramEditors$lambda$lambda$lambda_22(_this__u8e3s4) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return Unit_instance;
  }
  function btbProgramEditors$lambda$lambda$lambda_23(it) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return true;
  }
  function btbProgramEditors$lambda$lambda$lambda_24($textCellInit) {
    return function ($this$referenceTarget) {
      $textCellInit($this$referenceTarget);
      enableEagerCompletion($this$referenceTarget);
      return Unit_instance;
    };
  }
  function btbProgramEditors$lambda$lambda_50($refCell) {
    return function ($this$indent) {
      var tmp2 = '<no reference target>';
      var tmp4 = Companion_getInstance_337().pgo_1;
      // Inline function 'jetbrains.biokb.lang.editorBuilders.btbReferenceTarget' call
      var referenceProvider = btbProgramEditors$lambda$lambda$lambda_20;
      var options = new CompletionOptions();
      var containerInit = btbProgramEditors$lambda$lambda$lambda_21;
      var textCellInit = btbProgramEditors$lambda$lambda$lambda_22;
      var tmp;
      if (null == null) {
        tmp = btbProgramEditors$lambda$lambda$lambda_23;
      } else {
        tmp = null;
      }
      var tmp10 = tmp;
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.references.referenceTarget' call
      var textCellInit_0 = btbProgramEditors$lambda$lambda$lambda_24(textCellInit);
      var targetClass = getKClass(OntologyElement_1);
      var tmp$ret$1 = referenceTarget($this$indent, targetClass, tmp2, tmp4, referenceProvider, null, tmp10, options, containerInit, textCellInit_0);
      $refCell._v = tmp$ret$1;
      return Unit_instance;
    };
  }
  function btbProgramEditors$lambda_46($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function btbProgramEditors$lambda_47(wc) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    // Inline function 'kotlin.apply' call
    var this_0 = QualifiedOntologyElementReference(wc);
    this_0.hfu().f2x(OntologyLibraryReference(wc));
    this_0.ifu().f2x(OntologyElementReference(wc));
    return this_0;
  }
  function btbProgramEditors$lambda_48($this$editor) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    indent_0($this$editor, true, VOID, btbProgramEditors$lambda$lambda_51);
    return Unit_instance;
  }
  function btbProgramEditors$lambda$lambda_51($this$indent) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    var tmp = getKClass(OntologyLibraryReference_1);
    child_1($this$indent, tmp, btbProgramEditors$lambda$lambda$lambda_25);
    label_0($this$indent, '/');
    var tmp_0 = getKClass(OntologyElementReference_1);
    child_1($this$indent, tmp_0, btbProgramEditors$lambda$lambda$lambda_26);
    return Unit_instance;
  }
  function btbProgramEditors$lambda$lambda$lambda_25(reference) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return reference.hfu();
  }
  function btbProgramEditors$lambda$lambda$lambda_26(reference) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return reference.ifu();
  }
  function btbProgramEditors$lambda_49($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function btbProgramEditors$lambda_50(it) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return UnionClass(it);
  }
  function btbProgramEditors$lambda_51($this$editor) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    indent_0($this$editor, VOID, VOID, btbProgramEditors$lambda$lambda_52($this$editor));
    return Unit_instance;
  }
  function btbProgramEditors$lambda$lambda$lambda_27($this_editor) {
    return function ($this$placeholderInCollection) {
      excludingClassExpressionCompletion($this$placeholderInCollection, $this_editor.m6d());
      return Unit_instance;
    };
  }
  function btbProgramEditors$lambda$lambda_52($this_editor) {
    return function ($this$indent) {
      placeholderInCollection_0($this$indent, '<class>', btbProgramEditors$lambda$lambda$lambda_27($this_editor));
      return Unit_instance;
    };
  }
  function btbProgramEditors$lambda_52($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function btbProgramEditors$lambda_53($this$childrenRoleDefaults) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    var tmp = editorString($this$childrenRoleDefaults, BTBEditorParts_getInstance().pu1_1);
    $this$childrenRoleDefaults.hck(tmp, btbProgramEditors$lambda$lambda_53($this$childrenRoleDefaults));
    return Unit_instance;
  }
  function btbProgramEditors$lambda$lambda_53($this_childrenRoleDefaults) {
    return function (name) {
      // Inline function 'kotlin.apply' call
      var this_0 = VariableDeclaration($this_childrenRoleDefaults.l6z());
      this_0.y2().f2x(name);
      return this_0;
    };
  }
  function btbProgramEditors$lambda_54($this$editor) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    // Inline function 'kotlin.apply' call
    var this_0 = textProperty_0($this$editor, '<no name>', btbProgramEditors$lambda$lambda_54);
    mark_0(this_0, BTBEditorParts_getInstance().pu1_1);
    space_0($this$editor);
    var indent = indent_0($this$editor, VOID, VOID, btbProgramEditors$lambda$lambda_55);
    mark_0(indent, get_QUERY_LABELS_CONTAINER_MARK());
    space_0($this$editor);
    var tmp0_layout = Layout_HORIZONTAL_getInstance();
    var tmp1_separator = new StringSeparator(',', false, true);
    var tmp = getKClass(InstanceRelationValuePlaceholder);
    var oldRelationsCell = children_2($this$editor, tmp, VOID, VOID, VOID, tmp1_separator, VOID, VOID, VOID, tmp0_layout, btbProgramEditors$lambda$lambda_56);
    // Inline function 'jetbrains.ocelot.mapper.core.Synchronizers.forDisposable' call
    var tmp$ret$2 = new btbProgramEditors$76$$inlined$forDisposable$1($this$editor, oldRelationsCell);
    $this$editor.l8b(tmp$ret$2);
    propertyConstraints($this$editor);
    return Unit_instance;
  }
  function btbProgramEditors$lambda$lambda_54(variableDeclaration) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return variableDeclaration.y2();
  }
  function btbProgramEditors$lambda$lambda_55($this$indent) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    var operationLabel = label_0($this$indent, ':');
    // Inline function 'jetbrains.ocelot.mapper.core.Synchronizers.forDisposable' call
    var tmp$ret$0 = new btbProgramEditors$76$2$$inlined$forDisposable$1($this$indent, operationLabel);
    $this$indent.l8b(tmp$ret$0);
    space_0($this$indent);
    queryLabelsCell($this$indent);
    var tmp = getKClass(VariableSpecification);
    var type = child_1($this$indent, tmp, btbProgramEditors$lambda$lambda$lambda_28, VOID, VOID, VOID, VOID, VOID, VOID, VOID, get_variableSpecificationCompletion());
    var setQueriesLabelRightTransform = setQueryLabelRightTransform($this$indent.m6d());
    rightTransform_1($this$indent, operationLabel, setQueriesLabelRightTransform);
    rightTransform_1($this$indent, type, setQueriesLabelRightTransform);
    return Unit_instance;
  }
  function btbProgramEditors$lambda$lambda$o$doAttach$lambda(it) {
    return !(it == null) ? isInterface(it, VariableInitializer) : false;
  }
  function btbProgramEditors$76$2$$inlined$forDisposable$1($this_indent, $operationLabel) {
    this.zu2_1 = $this_indent;
    this.au3_1 = $operationLabel;
    DisposableSynchronizer.call(this);
  }
  protoOf(btbProgramEditors$76$2$$inlined$forDisposable$1).s87 = function (ctx) {
    var spec = this.zu2_1.m6d().ofu().m5y();
    var tmp = PropertyBinding_instance;
    return tmp.n30(ifProp(map_0(spec, btbProgramEditors$lambda$lambda$o$doAttach$lambda), '=', ':'), this.au3_1.o8w());
  };
  function btbProgramEditors$lambda$lambda$lambda_28(variableDeclaration) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return variableDeclaration.ofu();
  }
  function btbProgramEditors$lambda$lambda_56(variableDeclaration) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return variableDeclaration.nfu();
  }
  function btbProgramEditors$76$$inlined$forDisposable$1($this_editor, $oldRelationsCell) {
    this.cu3_1 = $this_editor;
    this.du3_1 = $oldRelationsCell;
    DisposableSynchronizer.call(this);
  }
  protoOf(btbProgramEditors$76$$inlined$forDisposable$1).s87 = function (ctx) {
    return PropertyBinding_instance.n30(notEmptyProp(this.cu3_1.m6d().nfu().m5y()), this.du3_1.m92());
  };
  function btbProgramEditors$lambda_55($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function getAbstractValueCompletion$lambda($this_getAbstractValueCompletion) {
    return function (reference) {
      // Inline function 'kotlin.apply' call
      var this_0 = FunctionTerm($this_getAbstractValueCompletion.l6z());
      this_0.ifr().f2x(reference);
      return this_0;
    };
  }
  function variableReferenceValueEditor$lambda$lambda(variableReferenceValue) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return variableReferenceValue.pfu();
  }
  function variableReferenceValueEditor$lambda$lambda_0(it) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return !contains_8(it, '.') && !contains_8(it, ',');
  }
  function variableReferenceValueEditor$lambda$lambda$lambda$lambda($this_btbReferenceTarget, $cellFinder, $cell) {
    return function () {
      var tmp = get_enclosingRefData($cell).ida_1;
      return transformValueToPropertyReference($this_btbReferenceTarget, $cellFinder, (!(tmp == null) ? isInterface(tmp, VariableReferenceValue_1) : false) ? tmp : THROW_CCE());
    };
  }
  function variableReferenceValueEditor$lambda$lambda$lambda($this_btbReferenceTarget) {
    return function ($this$rightTransform, _unused_var__etf5q3, cell, cellFinder) {
      $this$rightTransform.gcg('.', variableReferenceValueEditor$lambda$lambda$lambda$lambda($this_btbReferenceTarget, cellFinder, cell));
      return Unit_instance;
    };
  }
  function variableReferenceValueEditor$lambda$lambda_1($withDotRightTransform) {
    return function ($this$btbReferenceTarget) {
      var tmp;
      if ($withDotRightTransform) {
        rightTransform_0($this$btbReferenceTarget, variableReferenceValueEditor$lambda$lambda$lambda($this$btbReferenceTarget));
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function variableReferenceValueEditor$lambda$lambda_2(_this__u8e3s4) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return Unit_instance;
  }
  function variableReferenceValueEditor$lambda$lambda_3(it) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return true;
  }
  function variableReferenceValueEditor$lambda$lambda_4($textCellInit) {
    return function ($this$referenceTarget) {
      $textCellInit($this$referenceTarget);
      enableEagerCompletion($this$referenceTarget);
      return Unit_instance;
    };
  }
  function variableReferenceValueEditor$lambda($withDotRightTransform) {
    return function ($this$editor) {
      var tmp2 = '<variable>';
      var tmp4 = Companion_getInstance_352().mhx_1;
      var tmp6 = variableReferenceValueEditor$lambda$lambda;
      var tmp8 = variableReferenceValueEditor$lambda$lambda_0;
      // Inline function 'jetbrains.biokb.lang.editorBuilders.btbReferenceTarget' call
      var textCellInit = variableReferenceValueEditor$lambda$lambda_1($withDotRightTransform);
      var options = new CompletionOptions();
      var containerInit = variableReferenceValueEditor$lambda$lambda_2;
      var tmp;
      if (tmp8 == null) {
        tmp = variableReferenceValueEditor$lambda$lambda_3;
      } else {
        tmp = tmp8;
      }
      var tmp10 = tmp;
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.references.referenceTarget' call
      var textCellInit_0 = variableReferenceValueEditor$lambda$lambda_4(textCellInit);
      var targetClass = getKClass(VariableDeclaration_1);
      var refCell = referenceTarget($this$editor, targetClass, tmp2, tmp4, tmp6, null, tmp10, options, containerInit, textCellInit_0);
      considerEmptyBy($this$editor, refCell);
      deleteIfEmpty($this$editor);
      return Unit_instance;
    };
  }
  function variableReferenceValueEditor$lambda_0($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function setExpressionEditor$lambda($this$editor) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    var tmp;
    // Inline function 'jetbrains.ocelot.langDef.query.executeQuery' call
    // Inline function 'jetbrains.ocelot.langDef.query.query' call
    var tmp$ret$0 = new setExpressionEditor$2$$inlined$executeQuery$1($this$editor);
    if (execute_0(tmp$ret$0)) {
      tmp = '{';
    } else {
      tmp = '[';
    }
    label_0($this$editor, tmp);
    var tmp0_layout = Layout_HORIZONTAL_getInstance();
    var tmp1_separator = new StringSeparator(',', false, true);
    var tmp_0 = getKClass(FactExpressionPlaceholder);
    children_2($this$editor, tmp_0, VOID, '<expressions>', VOID, tmp1_separator, VOID, VOID, VOID, tmp0_layout, setExpressionEditor$lambda$lambda);
    var tmp_1;
    // Inline function 'jetbrains.ocelot.langDef.query.executeQuery' call
    // Inline function 'jetbrains.ocelot.langDef.query.query' call
    var tmp$ret$2 = new setExpressionEditor$2$$inlined$executeQuery$2($this$editor);
    if (execute_0(tmp$ret$2)) {
      tmp_1 = '}';
    } else {
      tmp_1 = ']';
    }
    label_0($this$editor, tmp_1);
    return Unit_instance;
  }
  function setExpressionEditor$2$$inlined$executeQuery$1($this_editor) {
    this.eu3_1 = $this_editor;
  }
  protoOf(setExpressionEditor$2$$inlined$executeQuery$1).n5w = function (builder) {
    return builder.l60(this.eu3_1.m6d().lfu());
  };
  function setExpressionEditor$lambda$lambda(set) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return set.mfs();
  }
  function setExpressionEditor$2$$inlined$executeQuery$2($this_editor) {
    this.fu3_1 = $this_editor;
  }
  protoOf(setExpressionEditor$2$$inlined$executeQuery$2).n5w = function (builder) {
    return builder.l60(this.fu3_1.m6d().lfu());
  };
  function setExpressionEditor$lambda_0($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function measurableValueEditor$lambda($this$editor) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    // Inline function 'kotlin.also' call
    var this_0 = decimalProperty_1($this$editor, '<amount>', measurableValueEditor$lambda$lambda);
    mark_0(this_0, BTBEditorParts_getInstance().qu1_1);
    space_0($this$editor);
    var tmp4 = Companion_getInstance_353().cgq_1;
    // Inline function 'jetbrains.biokb.lang.editorBuilders.btbReferenceTarget' call
    var referenceProvider = measurableValueEditor$lambda$lambda_0;
    var options = new CompletionOptions();
    var containerInit = measurableValueEditor$lambda$lambda_1;
    var textCellInit = measurableValueEditor$lambda$lambda_2;
    var tmp;
    if (null == null) {
      tmp = measurableValueEditor$lambda$lambda_3;
    } else {
      tmp = null;
    }
    var tmp10 = tmp;
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.references.referenceTarget' call
    var textCellInit_0 = measurableValueEditor$lambda$lambda_4(textCellInit);
    var targetClass = getKClass(MeasurementUnit_1);
    referenceTarget($this$editor, targetClass, '<unit>', tmp4, referenceProvider, null, tmp10, options, containerInit, textCellInit_0);
    return Unit_instance;
  }
  function measurableValueEditor$lambda$lambda(measurableValue) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return measurableValue.yfr();
  }
  function measurableValueEditor$lambda$lambda_0(measurableValue) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return measurableValue.zfr();
  }
  function measurableValueEditor$lambda$lambda_1(_this__u8e3s4) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return Unit_instance;
  }
  function measurableValueEditor$lambda$lambda_2(_this__u8e3s4) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return Unit_instance;
  }
  function measurableValueEditor$lambda$lambda_3(it) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return true;
  }
  function measurableValueEditor$lambda$lambda_4($textCellInit) {
    return function ($this$referenceTarget) {
      $textCellInit($this$referenceTarget);
      enableEagerCompletion($this$referenceTarget);
      return Unit_instance;
    };
  }
  function measurableValueEditor$lambda_0($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function enumValueEditor$lambda($this$editor) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    indent_0($this$editor, VOID, VOID, enumValueEditor$lambda$lambda);
    return Unit_instance;
  }
  function enumValueEditor$lambda$lambda($this$indent) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    var tmp2 = '<constant>';
    var tmp4 = Companion_getInstance_354().tg7_1;
    // Inline function 'jetbrains.biokb.lang.editorBuilders.btbReferenceTarget' call
    var referenceProvider = enumValueEditor$lambda$lambda$lambda;
    var options = new CompletionOptions();
    var containerInit = enumValueEditor$lambda$lambda$lambda_0;
    var textCellInit = enumValueEditor$lambda$lambda$lambda_1;
    var tmp;
    if (null == null) {
      tmp = enumValueEditor$lambda$lambda$lambda_2;
    } else {
      tmp = null;
    }
    var tmp10 = tmp;
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.references.referenceTarget' call
    var textCellInit_0 = enumValueEditor$lambda$lambda$lambda_3(textCellInit);
    var targetClass = getKClass(EnumerationConstant_1);
    referenceTarget($this$indent, targetClass, tmp2, tmp4, referenceProvider, null, tmp10, options, containerInit, textCellInit_0);
    return Unit_instance;
  }
  function enumValueEditor$lambda$lambda$lambda(enumValue) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return enumValue.pfq();
  }
  function enumValueEditor$lambda$lambda$lambda_0(_this__u8e3s4) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return Unit_instance;
  }
  function enumValueEditor$lambda$lambda$lambda_1(_this__u8e3s4) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return Unit_instance;
  }
  function enumValueEditor$lambda$lambda$lambda_2(it) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return true;
  }
  function enumValueEditor$lambda$lambda$lambda_3($textCellInit) {
    return function ($this$referenceTarget) {
      $textCellInit($this$referenceTarget);
      enableEagerCompletion($this$referenceTarget);
      return Unit_instance;
    };
  }
  function enumValueEditor$lambda_0($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function stringValueEditor$lambda($this$editor) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    var tmp = KProperty1;
    var cell = textProperty_0($this$editor, '<string>', getPropertyCallableRef('value', 1, tmp, StringValue$_get_value_$ref_2kxcol_1(), null));
    cell.b97().f2x(Companion_getInstance_210().v95_1);
    considerEmptyBy($this$editor, cell);
    deleteIfEmpty($this$editor);
    return Unit_instance;
  }
  function StringValue$_get_value_$ref_2kxcol_1() {
    return function (p0) {
      return p0.a1();
    };
  }
  function stringValueEditor$lambda_0($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function integerValueEditor$lambda($this$editor) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    var tmp = KProperty1;
    var cell = integerProperty_0($this$editor, '<integer>', getPropertyCallableRef('value', 1, tmp, IntegerValue$_get_value_$ref_c1etoe_1(), null));
    considerEmptyBy($this$editor, cell);
    deleteIfEmpty($this$editor);
    return Unit_instance;
  }
  function IntegerValue$_get_value_$ref_c1etoe_1() {
    return function (p0) {
      return p0.a1();
    };
  }
  function integerValueEditor$lambda_0($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function unionEditor$lambda($this$editor) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    keyword_0($this$editor, 'union of <');
    var tmp = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_0 = getPropertyCallableRef('classes', 1, tmp, UnionClass$_get_classes_$ref_qbevup_1(), null);
    var tmp0_contextLink = new MultipleChildLink(getKClass(UnionClass_1), this_0);
    var tmp1_layout = Layout_INDENT_getInstance();
    var tmp2_separator = new StringSeparator(',', false, true);
    var tmp_0 = getKClass(ClassExpressionPlaceholder_1);
    children_2($this$editor, tmp_0, tmp0_contextLink, VOID, VOID, tmp2_separator, VOID, VOID, VOID, tmp1_layout, unionEditor$lambda$lambda);
    keyword_0($this$editor, '>');
    return Unit_instance;
  }
  function UnionClass$_get_classes_$ref_qbevup_1() {
    return function (p0) {
      return p0.mfu();
    };
  }
  function unionEditor$lambda$lambda(unionExpression) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return unionExpression.mfu();
  }
  function unionEditor$lambda_0($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function propertyReferenceValueEditor$lambda($this$editor) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    var tmp = getKClass(AbstractValue);
    child_1($this$editor, tmp, propertyReferenceValueEditor$lambda$lambda);
    indentLabel_0($this$editor, '.');
    indent_0($this$editor, VOID, VOID, propertyReferenceValueEditor$lambda$lambda_0);
    $this$editor.l8b(new propertyReferenceValueEditor$2$5($this$editor));
    return Unit_instance;
  }
  function sam$jetbrains_ocelot_base_edt_EdtTask$0_24(function_0) {
    this.gu3_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_24).au = function () {
    return this.gu3_1();
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_24).f3 = function () {
    return this.gu3_1;
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_24).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, EdtTask) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_24).hashCode = function () {
    return hashCode(this.f3());
  };
  function propertyReferenceValueEditor$lambda$lambda(partValue) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return partValue.jfs();
  }
  function propertyReferenceValueEditor$lambda$lambda_0($this$indent) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    var tmp = getKClass(PropertyReferenceOperation_1);
    child_1($this$indent, tmp, propertyReferenceValueEditor$lambda$lambda$lambda);
    return Unit_instance;
  }
  function propertyReferenceValueEditor$lambda$lambda$lambda(partValue) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return partValue.q6q();
  }
  function propertyReferenceValueEditor$2$5$doAttach$2$$inlined$executeQuery$1($this_editor) {
    this.hu3_1 = $this_editor;
  }
  protoOf(propertyReferenceValueEditor$2$5$doAttach$2$$inlined$executeQuery$1).n5w = function (builder) {
    var tmp = builder.l60(this.hu3_1.m6d().jfs());
    return !(!(tmp == null) ? isInterface(tmp, ObjectPropertyReferenceValue_1) : false);
  };
  function propertyReferenceValueEditor$lambda$o$doAttach$lambda$lambda$lambda($this_editor, $cellFinder) {
    return function () {
      removePropertyReferenceAndSelectValue($this_editor.m6d(), $cellFinder);
      return Unit_instance;
    };
  }
  function propertyReferenceValueEditor$lambda$o$doAttach$lambda$lambda($cellContainer, $this_editor, $cellFinder) {
    return function () {
      $cellContainer.d9m(propertyReferenceValueEditor$lambda$o$doAttach$lambda$lambda$lambda($this_editor, $cellFinder));
      return Unit_instance;
    };
  }
  function propertyReferenceValueEditor$lambda$o$doAttach$lambda($this_editor, $cellFinder) {
    return function (event) {
      var tmp;
      var tmp_0 = $this_editor.m6d().bp();
      if (!(tmp_0 == null) ? isInterface(tmp_0, IsExpression_1) : false) {
        // Inline function 'jetbrains.ocelot.langDef.query.executeQuery' call
        // Inline function 'jetbrains.ocelot.langDef.query.query' call
        var tmp$ret$0 = new propertyReferenceValueEditor$2$5$doAttach$2$$inlined$executeQuery$1($this_editor);
        tmp = execute_0(tmp$ret$0);
      } else {
        tmp = false;
      }
      var forbidReplace = tmp;
      var tmp_1;
      if (event.t2y_1 && !forbidReplace) {
        var cellContainer = ensureNotNull($this_editor.qd0().x92().w2w());
        var tmp_2 = cellContainer.m93();
        var tmp_3 = propertyReferenceValueEditor$lambda$o$doAttach$lambda$lambda(cellContainer, $this_editor, $cellFinder);
        tmp_2.u39(new sam$jetbrains_ocelot_base_edt_EdtTask$0_24(tmp_3));
        tmp_1 = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function propertyReferenceValueEditor$2$5($this_editor) {
    this.ju3_1 = $this_editor;
    DisposableSynchronizer.call(this);
  }
  protoOf(propertyReferenceValueEditor$2$5).s87 = function (ctx) {
    var cellFinder = getMapperCellFinder(ctx.b88());
    var tmp = isNull(this.ju3_1.m6d().q6q().m5y());
    return tmp.z2r(propertyReferenceValueEditor$lambda$o$doAttach$lambda(this.ju3_1, cellFinder));
  };
  function propertyReferenceValueEditor$lambda_0($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function ontologyElementReferenceValueLibraryEditor$lambda($this$editor) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    indent_0($this$editor, VOID, VOID, ontologyElementReferenceValueLibraryEditor$lambda$lambda);
    return Unit_instance;
  }
  function ontologyElementReferenceValueLibraryEditor$lambda$lambda($this$indent) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    var tmp = getKClass(OntologyLibraryReference_1);
    child_1($this$indent, tmp, ontologyElementReferenceValueLibraryEditor$lambda$lambda$lambda);
    indentLabel_0($this$indent, '/');
    var tmp_0 = getKClass(OntologyElementReference_1);
    child_1($this$indent, tmp_0, ontologyElementReferenceValueLibraryEditor$lambda$lambda$lambda_0);
    return Unit_instance;
  }
  function ontologyElementReferenceValueLibraryEditor$lambda$lambda$lambda(elementReferenceValueLibrary) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return elementReferenceValueLibrary.ffq();
  }
  function ontologyElementReferenceValueLibraryEditor$lambda$lambda$lambda_0(elementReferenceValueLibrary) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return elementReferenceValueLibrary.gfq();
  }
  function ontologyElementReferenceValueLibraryEditor$lambda_0($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function ontologyElementReferenceValueEditor$lambda($this$editor) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    indent_0($this$editor, VOID, VOID, ontologyElementReferenceValueEditor$lambda$lambda);
    return Unit_instance;
  }
  function ontologyElementReferenceValueEditor$lambda$lambda($this$indent) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    var tmp = getKClass(OntologyElementReference_1);
    child_1($this$indent, tmp, ontologyElementReferenceValueEditor$lambda$lambda$lambda);
    return Unit_instance;
  }
  function ontologyElementReferenceValueEditor$lambda$lambda$lambda(elementReferenceValue) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return elementReferenceValue.gfq();
  }
  function ontologyElementReferenceValueEditor$lambda_0($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function notionTypeEditor$lambda($this$childRoleDefaults) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    getNotionTypeCompletion($this$childRoleDefaults);
    return Unit_instance;
  }
  function notionTypeEditor$lambda_0($this$editor) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    var tmp2 = '<notion>';
    var tmp4 = Companion_getInstance_351().zgu_1;
    var tmp6 = notionTypeEditor$lambda$lambda;
    // Inline function 'jetbrains.biokb.lang.editorBuilders.btbReferenceTarget' call
    var textCellInit = notionTypeEditor$lambda$lambda_0;
    var options = new CompletionOptions();
    var containerInit = notionTypeEditor$lambda$lambda_1;
    var tmp;
    if (null == null) {
      tmp = notionTypeEditor$lambda$lambda_2;
    } else {
      tmp = null;
    }
    var tmp10 = tmp;
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.references.referenceTarget' call
    var textCellInit_0 = notionTypeEditor$lambda$lambda_3(textCellInit);
    var targetClass = getKClass(AbstractNotion);
    var refCell = referenceTarget($this$editor, targetClass, tmp2, tmp4, tmp6, null, tmp10, options, containerInit, textCellInit_0);
    considerEmptyBy($this$editor, refCell);
    deleteIfEmpty($this$editor);
    return Unit_instance;
  }
  function notionTypeEditor$lambda$lambda(notionType) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return notionType.mfq();
  }
  function notionTypeEditor$lambda$lambda_0($this$btbReferenceTarget) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    $this$btbReferenceTarget.qd0().d97().f2x(true);
    return Unit_instance;
  }
  function notionTypeEditor$lambda$lambda_1(_this__u8e3s4) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return Unit_instance;
  }
  function notionTypeEditor$lambda$lambda_2(it) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return true;
  }
  function notionTypeEditor$lambda$lambda_3($textCellInit) {
    return function ($this$referenceTarget) {
      $textCellInit($this$referenceTarget);
      enableEagerCompletion($this$referenceTarget);
      return Unit_instance;
    };
  }
  function notionTypeEditor$lambda_1($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function primitiveNotionTypeEditor$lambda($this$editor) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.enumProperty' call
    var placeholder = '<primitive>';
    // Inline function 'kotlin.apply' call
    var this_0 = editableText_0($this$editor, VOID, placeholder, VOID, VOID, primitiveNotionTypeEditor$lambda$lambda);
    this_0.d97().f2x(true);
    var cell = this_0;
    considerEmptyBy($this$editor, cell);
    deleteIfEmpty($this$editor);
    return Unit_instance;
  }
  function primitiveNotionTypeEditor$lambda$lambda($this$editableText) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    switch (get_internalConfig($this$editableText).nd0().uct_1.x2_1) {
      case 0:
        // Inline function 'jetbrains.ocelot.langDef.editorBuilder.enumSyncTwoWay' call

        var targetPropFactory = primitiveNotionTypeEditor$lambda$lambda$lambda;
        // Inline function 'jetbrains.ocelot.langDef.editorBuilder.textCellSyncTwoWay' call

        var sourceProp = $this$editableText.m6d().oft();
        var targetProp = targetPropFactory($this$editableText.qd0());
        $this$editableText.l8b(syncTwoWay(sourceProp.m5y(), targetProp));
        break;
      case 1:
        // Inline function 'jetbrains.ocelot.langDef.editorBuilder.enumSyncTwoWay' call

        var targetPropFactory_0 = primitiveNotionTypeEditor$lambda$lambda$lambda_0;
        // Inline function 'jetbrains.ocelot.langDef.editorBuilder.textCellSyncTwoWay' call

        var sourceProp_0 = $this$editableText.m6d().oft();
        var targetProp_0 = targetPropFactory_0($this$editableText.qd0());
        $this$editableText.l8b(syncTwoWay(sourceProp_0.m5y(), targetProp_0));
        break;
      default:
        var tmp = $this$editableText.qd0().o8w();
        var tmp1_safe_receiver = $this$editableText.m6d().oft().m5y().w2w();
        var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.toString();
        tmp.f2x(tmp2_elvis_lhs == null ? '' : tmp2_elvis_lhs);
        break;
    }
    return Unit_instance;
  }
  function primitiveNotionTypeEditor$lambda$lambda$lambda(textCell) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    // Inline function 'jetbrains.ocelot.base.enums.EnumInfoFactory.createEnumInfo' call
    // Inline function 'kotlin.enumValues' call
    var tmp$ret$0 = values_18();
    var enumInfo = new EnumInfoImpl(tmp$ret$0);
    return ValueEditors_instance.uag(textCell, enumInfo);
  }
  function primitiveNotionTypeEditor$lambda$lambda$lambda_0(textCell) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    // Inline function 'jetbrains.ocelot.base.enums.EnumInfoFactory.createEnumInfo' call
    // Inline function 'kotlin.enumValues' call
    var tmp$ret$0 = values_18();
    var enumInfo = new EnumInfoImpl(tmp$ret$0);
    return ValueEditors_instance.uag(textCell, enumInfo);
  }
  function primitiveNotionTypeEditor$lambda_0($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function variablesEditor$$inlined$keyPressedCellTrait$1($this_variablesEditor, $variablesRoot) {
    this.ku3_1 = $this_variablesEditor;
    this.lu3_1 = $variablesRoot;
    CellTrait.call(this);
  }
  protoOf(variablesEditor$$inlined$keyPressedCellTrait$1).s8z = function (cell, event) {
    var tmp;
    if (event.z().equals(Key_ENTER_getInstance())) {
      tmp = (cell instanceof TextCell ? cell : THROW_CCE()).v96();
    } else {
      tmp = false;
    }
    if (tmp) {
      // Inline function 'jetbrains.ocelot.langDef.structure.NodeFactory.create' call
      var variableDeclaration = get_internalConfig(this.ku3_1).kd5().t6v(getKClass(VariableDeclaration_1));
      this.ku3_1.m6d().rfr().m2(0, variableDeclaration);
      var tmp_0;
      if (this.lu3_1._v == null) {
        throwUninitializedPropertyAccessException('variablesRoot');
      } else {
        tmp_0 = this.lu3_1._v;
      }
      var tmp0_safe_receiver = tmp_0.y35();
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.c93(ProjectionalSynchronizers_getInstance().d99_1);
      if (tmp1_safe_receiver == null)
        null;
      else
        tmp1_safe_receiver();
      event.n8i();
    }
    return Unit_instance;
  };
  function HasVariables$_get_variables_$ref_6jdr2_2() {
    return function (p0) {
      return p0.rfr();
    };
  }
  function variablesEditor$lambda$lambda(factSet) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return factSet.rfr();
  }
  function variablesEditor$lambda($variablesRoot) {
    return function ($this$indent) {
      newLine_0($this$indent);
      var tmp0_layout = Layout_VERTICAL_getInstance();
      var tmp = KProperty1;
      // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
      var this_0 = getPropertyCallableRef('variables', 1, tmp, HasVariables$_get_variables_$ref_6jdr2_2(), null);
      var tmp1_contextLink = new MultipleChildLink(getKClass(HasVariables), this_0);
      var tmp_0 = getKClass(VariableDeclaration_1);
      $variablesRoot._v = children_2($this$indent, tmp_0, tmp1_contextLink, VOID, VOID, VOID, VOID, VOID, VOID, tmp0_layout, variablesEditor$lambda$lambda);
      return Unit_instance;
    };
  }
  function $runSuspendCOROUTINE$_140(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.uu3_1 = _this__u8e3s4;
    this.vu3_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_140).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 29;
            this.yu3_1 = this.vu3_1;
            var tmp0_subject = this.uu3_1.lu4_1._v;
            if (!(tmp0_subject == null) ? isInterface(tmp0_subject, PropertyValue_1) : false) {
              this.f9_1 = 23;
              suspendResult = this.yu3_1.k60(this.uu3_1.lu4_1._v.q6q().w6o(), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              if (!(tmp0_subject == null) ? isInterface(tmp0_subject, ProcessPropertyValue_1) : false) {
                this.f9_1 = 20;
                suspendResult = this.yu3_1.k60(this.uu3_1.lu4_1._v.q6q(), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                if (!(tmp0_subject == null) ? isInterface(tmp0_subject, InstanceRelationValue) : false) {
                  this.f9_1 = 17;
                  suspendResult = this.yu3_1.k60(this.uu3_1.lu4_1._v.xfq(), this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  continue $sm;
                } else {
                  if (!(tmp0_subject == null) ? isInterface(tmp0_subject, PropertyConstraint_1) : false) {
                    this.f9_1 = 12;
                    suspendResult = this.yu3_1.k60(this.uu3_1.lu4_1._v.q6q(), this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) {
                      return suspendResult;
                    }
                    continue $sm;
                  } else {
                    if (!(tmp0_subject == null) ? isInterface(tmp0_subject, IsExpression_1) : false) {
                      var tmp13_safe_receiver = this.yu3_1.l60(this.uu3_1.lu4_1._v.mdy());
                      var tmp14_safe_receiver = tmp13_safe_receiver == null ? null : this.yu3_1.l60(tmp13_safe_receiver.q6q());
                      if (tmp14_safe_receiver == null) {
                        this.iu4_1 = null;
                        this.f9_1 = 7;
                        continue $sm;
                      } else {
                        this.f9_1 = 6;
                        suspendResult = this.yu3_1.k60(tmp14_safe_receiver.q6q(), this);
                        if (suspendResult === get_COROUTINE_SUSPENDED()) {
                          return suspendResult;
                        }
                        continue $sm;
                      }
                    } else {
                      if (!(tmp0_subject == null) ? isInterface(tmp0_subject, ProcessProperty_1) : false) {
                        var tmp20_safe_receiver = this.yu3_1.l60(this.uu3_1.lu4_1._v.sfq());
                        var tmp_0 = tmp20_safe_receiver == null ? null : this.yu3_1.l60(tmp20_safe_receiver.sfq());
                        var tmp21_safe_receiver = (!(tmp_0 == null) ? isInterface(tmp_0, SimplePropertyType) : false) ? tmp_0 : null;
                        if (tmp21_safe_receiver == null) {
                          this.ju4_1 = null;
                          this.f9_1 = 5;
                          continue $sm;
                        } else {
                          this.f9_1 = 4;
                          suspendResult = this.yu3_1.k60(tmp21_safe_receiver.mfq(), this);
                          if (suspendResult === get_COROUTINE_SUSPENDED()) {
                            return suspendResult;
                          }
                          continue $sm;
                        }
                      } else {
                        if (!(tmp0_subject == null) ? isInterface(tmp0_subject, ComplexNotionElementValue_1) : false) {
                          this.f9_1 = 1;
                          suspendResult = this.yu3_1.k60(this.uu3_1.lu4_1._v.gfq(), this);
                          if (suspendResult === get_COROUTINE_SUSPENDED()) {
                            return suspendResult;
                          }
                          continue $sm;
                        } else {
                          this.wu3_1 = emptyList();
                          this.f9_1 = 28;
                          continue $sm;
                        }
                      }
                    }
                  }
                }
              }
            }

          case 1:
            var tmp22_safe_receiver = suspendResult;
            var tmp_1 = tmp22_safe_receiver == null ? null : this.yu3_1.l60(tmp22_safe_receiver.kfq());
            var tmp23_safe_receiver = (!(tmp_1 == null) ? isInterface(tmp_1, NotionType_0) : false) ? tmp_1 : null;
            if (tmp23_safe_receiver == null) {
              this.ku4_1 = null;
              this.f9_1 = 3;
              continue $sm;
            } else {
              this.f9_1 = 2;
              suspendResult = this.yu3_1.k60(tmp23_safe_receiver.mfq(), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 2:
            this.ku4_1 = suspendResult;
            this.f9_1 = 3;
            continue $sm;
          case 3:
            var ARGUMENT = this.ku4_1;
            this.wu3_1 = toList_4(ARGUMENT);
            this.f9_1 = 28;
            continue $sm;
          case 4:
            this.ju4_1 = suspendResult;
            this.f9_1 = 5;
            continue $sm;
          case 5:
            var ARGUMENT_0 = this.ju4_1;
            this.wu3_1 = toList_4(ARGUMENT_0);
            this.f9_1 = 28;
            continue $sm;
          case 6:
            this.iu4_1 = suspendResult;
            this.f9_1 = 7;
            continue $sm;
          case 7:
            var tmp15_safe_receiver = this.iu4_1;
            var tmp16_safe_receiver = tmp15_safe_receiver == null ? null : this.yu3_1.l60(tmp15_safe_receiver.hd());
            var tmp17_safe_receiver = tmp16_safe_receiver == null ? null : this.yu3_1.l60(tmp16_safe_receiver.cfs());
            var tmp_2;
            if (tmp17_safe_receiver == null) {
              tmp_2 = null;
            } else {
              var destination = ArrayList_init_$Create$();
              var _iterator__ex2g4s = tmp17_safe_receiver.m();
              while (_iterator__ex2g4s.n()) {
                var element = _iterator__ex2g4s.o();
                if (!(element == null) ? isInterface(element, NotionType_0) : false) {
                  destination.j(element);
                }
              }
              tmp_2 = destination;
            }

            var tmp18_safe_receiver = tmp_2;
            if (tmp18_safe_receiver == null) {
              this.fu4_1 = null;
              this.f9_1 = 11;
              continue $sm;
            } else {
              this.gu4_1 = ArrayList_init_$Create$();
              this.hu4_1 = tmp18_safe_receiver.m();
              this.f9_1 = 8;
              continue $sm;
            }

          case 8:
            if (!this.hu4_1.n()) {
              this.f9_1 = 10;
              continue $sm;
            }

            var element_0 = this.hu4_1.o();
            this.f9_1 = 9;
            suspendResult = this.yu3_1.k60(element_0.mfq(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 9:
            var tmp0_safe_receiver = suspendResult;
            if (tmp0_safe_receiver == null)
              null;
            else {
              this.gu4_1.j(tmp0_safe_receiver);
            }

            this.f9_1 = 8;
            continue $sm;
          case 10:
            this.fu4_1 = this.gu4_1;
            this.f9_1 = 11;
            continue $sm;
          case 11:
            var tmp19_elvis_lhs = this.fu4_1;
            this.wu3_1 = tmp19_elvis_lhs == null ? emptyList() : tmp19_elvis_lhs;
            this.f9_1 = 28;
            continue $sm;
          case 12:
            var tmp8_safe_receiver = suspendResult;
            var tmp9_safe_receiver = tmp8_safe_receiver == null ? null : this.yu3_1.l60(tmp8_safe_receiver.hd());
            var tmp10_safe_receiver = tmp9_safe_receiver == null ? null : this.yu3_1.l60(tmp9_safe_receiver.cfs());
            var tmp_3;
            if (tmp10_safe_receiver == null) {
              tmp_3 = null;
            } else {
              var destination_0 = ArrayList_init_$Create$();
              var _iterator__ex2g4s_0 = tmp10_safe_receiver.m();
              while (_iterator__ex2g4s_0.n()) {
                var element_1 = _iterator__ex2g4s_0.o();
                if (!(element_1 == null) ? isInterface(element_1, NotionType_0) : false) {
                  destination_0.j(element_1);
                }
              }
              tmp_3 = destination_0;
            }

            var tmp11_safe_receiver = tmp_3;
            if (tmp11_safe_receiver == null) {
              this.cu4_1 = null;
              this.f9_1 = 16;
              continue $sm;
            } else {
              this.du4_1 = ArrayList_init_$Create$();
              this.eu4_1 = tmp11_safe_receiver.m();
              this.f9_1 = 13;
              continue $sm;
            }

          case 13:
            if (!this.eu4_1.n()) {
              this.f9_1 = 15;
              continue $sm;
            }

            var element_2 = this.eu4_1.o();
            this.f9_1 = 14;
            suspendResult = this.yu3_1.k60(element_2.mfq(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 14:
            var tmp0_safe_receiver_0 = suspendResult;
            if (tmp0_safe_receiver_0 == null)
              null;
            else {
              this.du4_1.j(tmp0_safe_receiver_0);
            }

            this.f9_1 = 13;
            continue $sm;
          case 15:
            this.cu4_1 = this.du4_1;
            this.f9_1 = 16;
            continue $sm;
          case 16:
            var tmp12_elvis_lhs = this.cu4_1;
            this.wu3_1 = tmp12_elvis_lhs == null ? emptyList() : tmp12_elvis_lhs;
            this.f9_1 = 28;
            continue $sm;
          case 17:
            var tmp6_safe_receiver = suspendResult;
            var tmp_4 = tmp6_safe_receiver == null ? null : this.yu3_1.l60(tmp6_safe_receiver.hd());
            var tmp7_safe_receiver = (!(tmp_4 == null) ? isInterface(tmp_4, NotionType_0) : false) ? tmp_4 : null;
            if (tmp7_safe_receiver == null) {
              this.bu4_1 = null;
              this.f9_1 = 19;
              continue $sm;
            } else {
              this.f9_1 = 18;
              suspendResult = this.yu3_1.k60(tmp7_safe_receiver.mfq(), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 18:
            this.bu4_1 = suspendResult;
            this.f9_1 = 19;
            continue $sm;
          case 19:
            var ARGUMENT_1 = this.bu4_1;
            this.wu3_1 = toList_4(ARGUMENT_1);
            this.f9_1 = 28;
            continue $sm;
          case 20:
            var tmp3_safe_receiver = suspendResult;
            var tmp4_safe_receiver = tmp3_safe_receiver == null ? null : this.yu3_1.l60(tmp3_safe_receiver.sfq());
            var tmp_5 = tmp4_safe_receiver == null ? null : this.yu3_1.l60(tmp4_safe_receiver.sfq());
            var tmp5_safe_receiver = (!(tmp_5 == null) ? isInterface(tmp_5, SimplePropertyType) : false) ? tmp_5 : null;
            if (tmp5_safe_receiver == null) {
              this.au4_1 = null;
              this.f9_1 = 22;
              continue $sm;
            } else {
              this.f9_1 = 21;
              suspendResult = this.yu3_1.k60(tmp5_safe_receiver.mfq(), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 21:
            this.au4_1 = suspendResult;
            this.f9_1 = 22;
            continue $sm;
          case 22:
            var ARGUMENT_2 = this.au4_1;
            this.wu3_1 = toList_4(ARGUMENT_2);
            this.f9_1 = 28;
            continue $sm;
          case 23:
            var tmp1_safe_receiver = suspendResult;
            if (tmp1_safe_receiver == null) {
              this.zu3_1 = null;
              this.f9_1 = 25;
              continue $sm;
            } else {
              this.f9_1 = 24;
              suspendResult = this.yu3_1.k60(tmp1_safe_receiver.sfq(), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 24:
            this.zu3_1 = suspendResult;
            this.f9_1 = 25;
            continue $sm;
          case 25:
            var tmp2_safe_receiver = this.zu3_1;
            if (tmp2_safe_receiver == null) {
              this.xu3_1 = null;
              this.f9_1 = 27;
              continue $sm;
            } else {
              this.f9_1 = 26;
              suspendResult = this.yu3_1.k60(tmp2_safe_receiver.mfq(), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 26:
            this.xu3_1 = suspendResult;
            this.f9_1 = 27;
            continue $sm;
          case 27:
            var ARGUMENT_3 = this.xu3_1;
            this.wu3_1 = toList_4(ARGUMENT_3);
            this.f9_1 = 28;
            continue $sm;
          case 28:
            return this.wu3_1;
          case 29:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 29) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function sam$jetbrains_ocelot_langDef_completion_ActionOnCell$0_1(function_0) {
    this.mu4_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_langDef_completion_ActionOnCell$0_1).ock = function (cell) {
    return this.mu4_1(cell);
  };
  protoOf(sam$jetbrains_ocelot_langDef_completion_ActionOnCell$0_1).f3 = function () {
    return this.mu4_1;
  };
  protoOf(sam$jetbrains_ocelot_langDef_completion_ActionOnCell$0_1).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, ActionOnCell) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_langDef_completion_ActionOnCell$0_1).hashCode = function () {
    return hashCode(this.f3());
  };
  function invoke$isValueProvider(_this__u8e3s4) {
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    var tmp_3;
    var tmp_4;
    if (!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, PropertyValue_1) : false) {
      tmp_4 = true;
    } else {
      tmp_4 = !(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, ProcessPropertyValue_1) : false;
    }
    if (tmp_4) {
      tmp_3 = true;
    } else {
      tmp_3 = !(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, InstanceRelationValue) : false;
    }
    if (tmp_3) {
      tmp_2 = true;
    } else {
      tmp_2 = !(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, PropertyConstraint_1) : false;
    }
    if (tmp_2) {
      tmp_1 = true;
    } else {
      tmp_1 = !(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, IsExpression_1) : false;
    }
    if (tmp_1) {
      tmp_0 = true;
    } else {
      tmp_0 = !(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, ProcessProperty_1) : false;
    }
    if (tmp_0) {
      tmp = true;
    } else {
      tmp = !(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, ComplexNotionElementValue_1) : false;
    }
    return tmp;
  }
  function measurableValueWithDefaultUnitCompletion$2$$inlined$executeSuspendingQuery$1($contextNode) {
    this.lu4_1 = $contextNode;
  }
  protoOf(measurableValueWithDefaultUnitCompletion$2$$inlined$executeSuspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_140(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(measurableValueWithDefaultUnitCompletion$2$$inlined$executeSuspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function measurableValueWithDefaultUnitCompletion$2$$inlined$executeQuery$1($measurableNotions) {
    this.nu4_1 = $measurableNotions;
  }
  protoOf(measurableValueWithDefaultUnitCompletion$2$$inlined$executeQuery$1).n5w = function (builder) {
    // Inline function 'kotlin.collections.find' call
    var tmp0 = builder.l60(first(this.nu4_1).xfr());
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var _iterator__ex2g4s = tmp0.m();
      while (_iterator__ex2g4s.n()) {
        var element = _iterator__ex2g4s.o();
        if (builder.l60(element.afs())) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    return tmp$ret$1;
  };
  function measurableValueWithDefaultUnitCompletion$slambda$lambda$lambda(it) {
    var tmp0_safe_receiver = find_2(it, BTBEditorParts_getInstance().qu1_1);
    return tmp0_safe_receiver == null ? null : toEnd_0(tmp0_safe_receiver);
  }
  function measurableValueWithDefaultUnitCompletion$slambda$lambda($this_async, $default) {
    return function ($this$does, number) {
      // Inline function 'kotlin.apply' call
      var this_0 = MeasurableValue($this_async.l6z());
      this_0.pib(number);
      if (!($default == null)) {
        this_0.zfr().d6p($default);
      }
      $this$does.mck(this_0);
      var tmp = measurableValueWithDefaultUnitCompletion$slambda$lambda$lambda;
      return $this$does.nck(new sam$jetbrains_ocelot_langDef_completion_ActionOnCell$0_1(tmp));
    };
  }
  function measurableValueWithDefaultUnitCompletion$slambda(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(measurableValueWithDefaultUnitCompletion$slambda).xu4 = function ($this$async, $completion) {
    var tmp = this.yu4($this$async, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(measurableValueWithDefaultUnitCompletion$slambda).v9 = function (p1, $completion) {
    return this.xu4(p1 instanceof NodeCompletionBuilder ? p1 : THROW_CCE(), $completion);
  };
  protoOf(measurableValueWithDefaultUnitCompletion$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            var contextNode = {_v: ensureNotNull(this.wu4_1.ack())};
            while (!(contextNode._v == null) && !invoke$isValueProvider(contextNode._v)) {
              contextNode._v = contextNode._v.bp();
            }

            this.f9_1 = 1;
            suspendResult = execute_1(new measurableValueWithDefaultUnitCompletion$2$$inlined$executeSuspendingQuery$1(contextNode), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var notions = suspendResult;
            var destination = ArrayList_init_$Create$();
            var _iterator__ex2g4s = notions.m();
            while (_iterator__ex2g4s.n()) {
              var element = _iterator__ex2g4s.o();
              if (!(element == null) ? isInterface(element, MeasurableNotion_1) : false) {
                destination.j(element);
              }
            }

            var measurableNotions = destination;
            if (!measurableNotions.s()) {
              var tmp_0;
              if (measurableNotions.p() === 1) {
                tmp_0 = execute_0(new measurableValueWithDefaultUnitCompletion$2$$inlined$executeQuery$1(measurableNotions));
              } else {
                tmp_0 = null;
              }
              var default_0 = tmp_0;
              var tmp_1 = this.wu4_1.rci();
              this.wu4_1.eck(tmp_1, measurableValueWithDefaultUnitCompletion$slambda$lambda(this.wu4_1, default_0));
            }

            return Unit_instance;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(measurableValueWithDefaultUnitCompletion$slambda).yu4 = function ($this$async, completion) {
    var i = new measurableValueWithDefaultUnitCompletion$slambda(completion);
    i.wu4_1 = $this$async;
    return i;
  };
  function measurableValueWithDefaultUnitCompletion$slambda_0(resultContinuation) {
    var i = new measurableValueWithDefaultUnitCompletion$slambda(resultContinuation);
    var l = function ($this$async, $completion) {
      return i.xu4($this$async, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function enumValueCompletion$lambda_0($this_enumValueCompletion) {
    return function (reference) {
      // Inline function 'kotlin.apply' call
      var this_0 = EnumValue($this_enumValueCompletion.l6z());
      this_0.pfq().f2x(reference);
      return this_0;
    };
  }
  function stringValueCompletion$slambda$lambda($this_async) {
    return function (text) {
      // Inline function 'kotlin.apply' call
      var this_0 = StringValue($this_async.l6z());
      this_0.a1().f2x(text);
      return this_0;
    };
  }
  function stringValueCompletion$slambda(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(stringValueCompletion$slambda).iu5 = function ($this$async, $completion) {
    var tmp = this.ju5($this$async, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(stringValueCompletion$slambda).v9 = function (p1, $completion) {
    return this.iu5(p1 instanceof NodeCompletionBuilder ? p1 : THROW_CCE(), $completion);
  };
  protoOf(stringValueCompletion$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 3;
            this.f9_1 = 1;
            suspendResult = getExpectedPrimitiveKind(this.hu5_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            if (equals(ARGUMENT, PrimitiveKind_STRING_getInstance())) {
              var tmp_0 = this.hu5_1.qci();
              this.hu5_1.dck(tmp_0, stringValueCompletion$slambda$lambda(this.hu5_1));
              this.f9_1 = 2;
              continue $sm;
            } else {
              this.f9_1 = 2;
              continue $sm;
            }

          case 2:
            return Unit_instance;
          case 3:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 3) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(stringValueCompletion$slambda).ju5 = function ($this$async, completion) {
    var i = new stringValueCompletion$slambda(completion);
    i.hu5_1 = $this$async;
    return i;
  };
  function stringValueCompletion$slambda_0(resultContinuation) {
    var i = new stringValueCompletion$slambda(resultContinuation);
    var l = function ($this$async, $completion) {
      return i.iu5($this$async, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function integerValueCompletion$slambda$lambda($this_async) {
    return function (num) {
      // Inline function 'kotlin.apply' call
      var this_0 = IntegerValue($this_async.l6z());
      this_0.a1().f2x(num);
      return this_0;
    };
  }
  function integerValueCompletion$slambda(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(integerValueCompletion$slambda).tu5 = function ($this$async, $completion) {
    var tmp = this.uu5($this$async, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(integerValueCompletion$slambda).v9 = function (p1, $completion) {
    return this.tu5(p1 instanceof NodeCompletionBuilder ? p1 : THROW_CCE(), $completion);
  };
  protoOf(integerValueCompletion$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 3;
            this.f9_1 = 1;
            suspendResult = getExpectedPrimitiveKind(this.su5_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            if (equals(ARGUMENT, PrimitiveKind_INTEGER_getInstance())) {
              var tmp_0 = this.su5_1.rci();
              this.su5_1.fck(tmp_0, integerValueCompletion$slambda$lambda(this.su5_1));
              this.f9_1 = 2;
              continue $sm;
            } else {
              this.f9_1 = 2;
              continue $sm;
            }

          case 2:
            return Unit_instance;
          case 3:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 3) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(integerValueCompletion$slambda).uu5 = function ($this$async, completion) {
    var i = new integerValueCompletion$slambda(completion);
    i.su5_1 = $this$async;
    return i;
  };
  function integerValueCompletion$slambda_0(resultContinuation) {
    var i = new integerValueCompletion$slambda(resultContinuation);
    var l = function ($this$async, $completion) {
      return i.tu5($this$async, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function variableReferenceValueCompletion$lambda($this_variableReferenceValueCompletion) {
    return function (reference) {
      // Inline function 'kotlin.apply' call
      var this_0 = VariableReferenceValue($this_variableReferenceValueCompletion.l6z());
      this_0.pfu().f2x(reference);
      return this_0;
    };
  }
  function setExpressionCompletion$lambda($this_setExpressionCompletion) {
    return function () {
      // Inline function 'kotlin.apply' call
      var this_0 = SetExpression($this_setExpressionCompletion.l6z());
      this_0.lfu().f2x(true);
      return this_0;
    };
  }
  function setExpressionCompletion$lambda_0($this_setExpressionCompletion) {
    return function () {
      // Inline function 'kotlin.apply' call
      var this_0 = SetExpression($this_setExpressionCompletion.l6z());
      this_0.lfu().f2x(false);
      return this_0;
    };
  }
  function ontologyElementReferenceValueLibraryCompletion$lambda($this_ontologyElementReferenceValueLibraryCompletion) {
    return function (reference) {
      // Inline function 'kotlin.apply' call
      var this_0 = OntologyElementReferenceValueLibrary($this_ontologyElementReferenceValueLibraryCompletion.l6z());
      this_0.ffq().f2x(OntologyLibraryReference_2($this_ontologyElementReferenceValueLibraryCompletion.l6z(), reference));
      this_0.gfq().f2x(OntologyElementReference($this_ontologyElementReferenceValueLibraryCompletion.l6z()));
      return this_0;
    };
  }
  function ontologyElementReferenceValueCompletion$lambda($this_ontologyElementReferenceValueCompletion) {
    return function (reference) {
      // Inline function 'kotlin.apply' call
      var this_0 = OntologyElementReferenceValue($this_ontologyElementReferenceValueCompletion.l6z());
      this_0.gfq().f2x(OntologyElementReference_2($this_ontologyElementReferenceValueCompletion.l6z(), reference));
      return this_0;
    };
  }
  function $runSuspendCOROUTINE$_141(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.du6_1 = _this__u8e3s4;
    this.eu6_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_141).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 13;
            this.hu6_1 = this.eu6_1;
            var tmp0_subject = this.du6_1.ku6_1._v;
            if (!(tmp0_subject == null) ? isInterface(tmp0_subject, PropertyValue_1) : false) {
              this.f9_1 = 7;
              suspendResult = this.hu6_1.k60(this.du6_1.ku6_1._v.q6q().w6o(), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              if (!(tmp0_subject == null) ? isInterface(tmp0_subject, ProcessPropertyValue_1) : false) {
                this.f9_1 = 6;
                suspendResult = this.hu6_1.k60(this.du6_1.ku6_1._v.q6q(), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                if (!(tmp0_subject == null) ? isInterface(tmp0_subject, InstanceRelationValue) : false) {
                  this.f9_1 = 5;
                  suspendResult = this.hu6_1.k60(this.du6_1.ku6_1._v.xfq(), this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  continue $sm;
                } else {
                  if (!(tmp0_subject == null) ? isInterface(tmp0_subject, PropertyConstraint_1) : false) {
                    this.f9_1 = 4;
                    suspendResult = this.hu6_1.k60(this.du6_1.ku6_1._v.q6q(), this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) {
                      return suspendResult;
                    }
                    continue $sm;
                  } else {
                    if (!(tmp0_subject == null) ? isInterface(tmp0_subject, IsExpression_1) : false) {
                      var tmp9_safe_receiver = this.hu6_1.l60(this.du6_1.ku6_1._v.mdy());
                      var tmp10_safe_receiver = tmp9_safe_receiver == null ? null : this.hu6_1.l60(tmp9_safe_receiver.q6q());
                      if (tmp10_safe_receiver == null) {
                        this.ju6_1 = null;
                        this.f9_1 = 3;
                        continue $sm;
                      } else {
                        this.f9_1 = 2;
                        suspendResult = this.hu6_1.k60(tmp10_safe_receiver.q6q(), this);
                        if (suspendResult === get_COROUTINE_SUSPENDED()) {
                          return suspendResult;
                        }
                        continue $sm;
                      }
                    } else {
                      if (!(tmp0_subject == null) ? isInterface(tmp0_subject, ProcessProperty_1) : false) {
                        var tmp_0 = this;
                        var tmp14_safe_receiver = this.hu6_1.l60(this.du6_1.ku6_1._v.sfq());
                        tmp_0.fu6_1 = tmp14_safe_receiver == null ? null : this.hu6_1.l60(tmp14_safe_receiver.sfq());
                        this.f9_1 = 12;
                        continue $sm;
                      } else {
                        if (!(tmp0_subject == null) ? isInterface(tmp0_subject, ComplexNotionElementValue_1) : false) {
                          this.f9_1 = 1;
                          suspendResult = this.hu6_1.k60(this.du6_1.ku6_1._v.gfq(), this);
                          if (suspendResult === get_COROUTINE_SUSPENDED()) {
                            return suspendResult;
                          }
                          continue $sm;
                        } else {
                          this.fu6_1 = null;
                          this.f9_1 = 12;
                          continue $sm;
                        }
                      }
                    }
                  }
                }
              }
            }

          case 1:
            var tmp15_safe_receiver = suspendResult;
            this.fu6_1 = tmp15_safe_receiver == null ? null : this.hu6_1.l60(tmp15_safe_receiver.kfq());
            this.f9_1 = 12;
            continue $sm;
          case 2:
            this.ju6_1 = suspendResult;
            this.f9_1 = 3;
            continue $sm;
          case 3:
            var tmp11_safe_receiver = this.ju6_1;
            var tmp12_safe_receiver = tmp11_safe_receiver == null ? null : this.hu6_1.l60(tmp11_safe_receiver.hd());
            var tmp13_safe_receiver = tmp12_safe_receiver == null ? null : this.hu6_1.l60(tmp12_safe_receiver.cfs());
            this.fu6_1 = tmp13_safe_receiver == null ? null : firstOrNull_1(tmp13_safe_receiver);
            this.f9_1 = 12;
            continue $sm;
          case 4:
            var tmp6_safe_receiver = suspendResult;
            var tmp7_safe_receiver = tmp6_safe_receiver == null ? null : this.hu6_1.l60(tmp6_safe_receiver.hd());
            var tmp8_safe_receiver = tmp7_safe_receiver == null ? null : this.hu6_1.l60(tmp7_safe_receiver.cfs());
            this.fu6_1 = tmp8_safe_receiver == null ? null : firstOrNull_1(tmp8_safe_receiver);
            this.f9_1 = 12;
            continue $sm;
          case 5:
            var tmp5_safe_receiver = suspendResult;
            this.fu6_1 = tmp5_safe_receiver == null ? null : this.hu6_1.l60(tmp5_safe_receiver.hd());
            this.f9_1 = 12;
            continue $sm;
          case 6:
            var tmp3_safe_receiver = suspendResult;
            var tmp4_safe_receiver = tmp3_safe_receiver == null ? null : this.hu6_1.l60(tmp3_safe_receiver.sfq());
            this.fu6_1 = tmp4_safe_receiver == null ? null : this.hu6_1.l60(tmp4_safe_receiver.sfq());
            this.f9_1 = 12;
            continue $sm;
          case 7:
            var tmp1_safe_receiver = suspendResult;
            if (tmp1_safe_receiver == null) {
              this.iu6_1 = null;
              this.f9_1 = 9;
              continue $sm;
            } else {
              this.f9_1 = 8;
              suspendResult = this.hu6_1.k60(tmp1_safe_receiver.sfq(), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 8:
            this.iu6_1 = suspendResult;
            this.f9_1 = 9;
            continue $sm;
          case 9:
            var tmp2_safe_receiver = this.iu6_1;
            if (tmp2_safe_receiver == null) {
              this.gu6_1 = null;
              this.f9_1 = 11;
              continue $sm;
            } else {
              this.f9_1 = 10;
              suspendResult = this.hu6_1.k60(tmp2_safe_receiver.mfq(), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 10:
            this.gu6_1 = suspendResult;
            this.f9_1 = 11;
            continue $sm;
          case 11:
            this.fu6_1 = this.gu6_1;
            this.f9_1 = 12;
            continue $sm;
          case 12:
            return this.fu6_1;
          case 13:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 13) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function getExpectedPrimitiveKind$$inlined$executeSuspendingQuery$1($contextNode) {
    this.ku6_1 = $contextNode;
  }
  protoOf(getExpectedPrimitiveKind$$inlined$executeSuspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_141(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(getExpectedPrimitiveKind$$inlined$executeSuspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function getExpectedPrimitiveKind$$inlined$executeSuspendingQuery$2($expectedType) {
    this.lu6_1 = $expectedType;
  }
  protoOf(getExpectedPrimitiveKind$$inlined$executeSuspendingQuery$2).b61 = function (builder, $completion) {
    return builder.l60(this.lu6_1.oft());
  };
  protoOf(getExpectedPrimitiveKind$$inlined$executeSuspendingQuery$2).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function getExpectedPrimitiveKind$$inlined$executeSuspendingQuery$3($expectedType) {
    this.mu6_1 = $expectedType;
  }
  protoOf(getExpectedPrimitiveKind$$inlined$executeSuspendingQuery$3).b61 = function (builder, $completion) {
    return builder.l60(this.mu6_1.oft());
  };
  protoOf(getExpectedPrimitiveKind$$inlined$executeSuspendingQuery$3).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function $getExpectedPrimitiveKindCOROUTINE$(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.ju1_1 = _this__u8e3s4;
  }
  protoOf($getExpectedPrimitiveKindCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 5;
            var contextNode = {_v: ensureNotNull(this.ju1_1.ack())};
            while (!(contextNode._v == null) && !getExpectedPrimitiveKind$isValueProvider(contextNode._v)) {
              contextNode._v = contextNode._v.bp();
            }

            this.f9_1 = 1;
            suspendResult = execute_1(new getExpectedPrimitiveKind$$inlined$executeSuspendingQuery$1(contextNode), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var expectedType = suspendResult;
            if (!(expectedType == null) ? isInterface(expectedType, PrimitiveNotionType_1) : false) {
              this.f9_1 = 3;
              suspendResult = execute_1(new getExpectedPrimitiveKind$$inlined$executeSuspendingQuery$2(expectedType), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              if (!(expectedType == null) ? isInterface(expectedType, PrimitivePropertyType_1) : false) {
                this.f9_1 = 2;
                suspendResult = execute_1(new getExpectedPrimitiveKind$$inlined$executeSuspendingQuery$3(expectedType), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                this.ku1_1 = null;
                this.f9_1 = 4;
                continue $sm;
              }
            }

          case 2:
            this.ku1_1 = suspendResult;
            this.f9_1 = 4;
            continue $sm;
          case 3:
            this.ku1_1 = suspendResult;
            this.f9_1 = 4;
            continue $sm;
          case 4:
            return this.ku1_1;
          case 5:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 5) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  var properties_initialized_BTBProgramEditors_kt_ysdpum;
  function _init_properties_BTBProgramEditors_kt__cfv01s() {
    if (!properties_initialized_BTBProgramEditors_kt_ysdpum) {
      properties_initialized_BTBProgramEditors_kt_ysdpum = true;
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init = btbProgramEditors$lambda;
      var triggerDependencies = emptyList();
      var tmp = getKClass(BTBDocument_1);
      var tmp_0 = new EditorDefinition(tmp, null, null, false, true, triggerDependencies, btbProgramEditors$lambda_0(init));
      var tmp0 = '<context>';
      var tmp2 = btbProgramEditors$lambda_1;
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
      var separator_0 = separator(',');
      var tmp0_0 = new ChildrenRoleDefaults(getKClass(Context_2), tmp0, tmp2, separator_0, null, true);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_0 = btbProgramEditors$lambda_2;
      var triggerDependencies_0 = emptyList();
      var tmp_1 = getKClass(Context_2);
      var tmp_2 = new EditorDefinition(tmp_1, tmp0_0, null, false, true, triggerDependencies_0, btbProgramEditors$lambda_3(init_0));
      var tmp0_separator = separator(',');
      var tmp0_1 = '<categories>';
      var tmp2_0 = btbProgramEditors$lambda_4;
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
      var completionSupplier = btbProgramEditors$lambda_5;
      var tmp0_2 = new ChildrenRoleDefaults(getKClass(Category_1), tmp0_1, tmp2_0, tmp0_separator, completionSupplier, true);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_1 = btbProgramEditors$lambda_6;
      var triggerDependencies_1 = emptyList();
      var tmp_3 = getKClass(Category_1);
      var tmp_4 = new EditorDefinition(tmp_3, tmp0_2, null, false, true, triggerDependencies_1, btbProgramEditors$lambda_7(init_1));
      var tmp0_3 = '<imports>';
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
      var completionSupplier_0 = btbProgramEditors$lambda_8;
      var separator_1 = get_defaultChildrenSeparator();
      var tmp0_4 = new ChildrenRoleDefaults(getKClass(OntologyImportRootReference_1), tmp0_3, null, separator_1, completionSupplier_0, true);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_2 = btbProgramEditors$lambda_9;
      var triggerDependencies_2 = emptyList();
      var tmp_5 = getKClass(OntologyImportRootReference_1);
      var tmp_6 = new EditorDefinition(tmp_5, tmp0_4, null, true, true, triggerDependencies_2, btbProgramEditors$lambda_10(init_2));
      var tmp0_5 = childRoleDefaults('<value>', btbProgramEditors$lambda_11, VOID, false);
      var tmp_7 = variableReferenceValueEditor();
      var tmp_8 = setExpressionEditor();
      var tmp_9 = measurableValueEditor();
      var tmp_10 = enumValueEditor();
      var tmp_11 = complexNotionValueEditor();
      var tmp_12 = stringValueEditor();
      var tmp_13 = integerValueEditor();
      var tmp_14 = unionEditor();
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_3 = btbProgramEditors$lambda_12;
      var triggerDependencies_3 = emptyList();
      var tmp_15 = getKClass(PartValue);
      var tmp_16 = new EditorDefinition(tmp_15, null, null, false, true, triggerDependencies_3, btbProgramEditors$lambda_13(init_3));
      var tmp_17 = propertyReferenceValueEditor();
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_4 = btbProgramEditors$lambda_14;
      var triggerDependencies_4 = emptyList();
      var tmp_18 = getKClass(ValueWithRelations);
      var tmp_19 = new EditorDefinition(tmp_18, null, null, false, true, triggerDependencies_4, btbProgramEditors$lambda_15(init_4));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.asyncInvalidatingEditor' call
      var init_5 = btbProgramEditors$slambda_0(null);
      var triggerDependencies_5 = emptyList();
      var tmp_20 = getKClass(FunctionTerm_1);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.hierarchyEditor' call
      var editorDefinitions = [tmp_7, tmp_8, tmp_9, tmp_10, tmp_11, tmp_12, tmp_13, tmp_14, tmp_16, tmp_17, tmp_19, new EditorDefinition(tmp_20, null, null, false, true, triggerDependencies_5, btbProgramEditors$lambda_16(init_5)), ontologyElementReferenceValueLibraryEditor(), ontologyElementReferenceValueEditor(), processPropertyReferenceEditor()];
      var tmp_21 = new HierarchyEditorDefinition(getKClass(AbstractValue), tmp0_5, toList(editorDefinitions));
      var tmp_22 = complexNotionElementValueEditor();
      var tmp0_6 = childRoleDefaults('<spec>', VOID, VOID, false);
      var tmp_23 = variableReferenceValueEditor(false);
      var tmp_24 = processPropertyReferenceEditor(false);
      var tmp1_completionSupplier = get_objectTypeCompletion();
      var tmp0_7 = childRoleDefaults('<no type>', tmp1_completionSupplier, btbProgramEditors$lambda_17);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_6 = btbProgramEditors$lambda_18;
      var triggerDependencies_6 = emptyList();
      var tmp_25 = getKClass(TypePlaceholder_1);
      var tmp_26 = new EditorDefinition(tmp_25, null, null, false, true, triggerDependencies_6, btbProgramEditors$lambda_19(init_6));
      var tmp_27 = notionTypeEditor();
      var tmp_28 = primitiveNotionTypeEditor();
      var tmp0_8 = btbProgramEditors$lambda_20;
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
      var completionSupplier_1 = btbProgramEditors$lambda_21;
      var separator_2 = get_defaultChildrenSeparator();
      var tmp0_9 = new ChildrenRoleDefaults(getKClass(OntologyElementType_1), '<empty>', tmp0_8, separator_2, completionSupplier_1, true);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_7 = btbProgramEditors$lambda_22;
      var triggerDependencies_7 = emptyList();
      var tmp_29 = getKClass(OntologyElementType_1);
      var tmp_30 = new EditorDefinition(tmp_29, tmp0_9, null, false, true, triggerDependencies_7, btbProgramEditors$lambda_23(init_7));
      var tmp0_10 = btbProgramEditors$lambda_24;
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
      var completionSupplier_2 = btbProgramEditors$lambda_25;
      var separator_3 = get_defaultChildrenSeparator();
      var tmp0_11 = new ChildrenRoleDefaults(getKClass(ProcessType_1), '<empty>', tmp0_10, separator_3, completionSupplier_2, true);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_8 = btbProgramEditors$lambda_26;
      var triggerDependencies_8 = emptyList();
      var tmp_31 = getKClass(ProcessType_1);
      var tmp_32 = new EditorDefinition(tmp_31, tmp0_11, null, false, true, triggerDependencies_8, btbProgramEditors$lambda_27(init_8));
      var tmp_33 = classExpressionTypeEditor();
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_9 = btbProgramEditors$lambda_28;
      var triggerDependencies_9 = emptyList();
      var tmp_34 = getKClass(OneOf_1);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.hierarchyEditor' call
      var editorDefinitions_0 = [tmp_26, tmp_27, tmp_28, tmp_30, tmp_32, tmp_33, new EditorDefinition(tmp_34, null, null, false, true, triggerDependencies_9, btbProgramEditors$lambda_29(init_9))];
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.hierarchyEditor' call
      var editorDefinitions_1 = [tmp_23, tmp_24, new HierarchyEditorDefinition(getKClass(Type), tmp0_7, toList(editorDefinitions_0))];
      var tmp_35 = new HierarchyEditorDefinition(getKClass(VariableSpecification), tmp0_6, toList(editorDefinitions_1));
      var tmp0_12 = childRoleDefaults(VOID, btbProgramEditors$lambda_30);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_10 = btbProgramEditors$lambda_31;
      var triggerDependencies_10 = emptyList();
      var tmp_36 = getKClass(PropertyReferenceOperation_1);
      var tmp_37 = new EditorDefinition(tmp_36, tmp0_12, null, false, true, triggerDependencies_10, btbProgramEditors$lambda_32(init_10));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_11 = btbProgramEditors$lambda_33;
      var triggerDependencies_11 = emptyList();
      var tmp_38 = getKClass(SetValuedPropertyParameter_1);
      var tmp_39 = new EditorDefinition(tmp_38, null, null, false, true, triggerDependencies_11, btbProgramEditors$lambda_34(init_11));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
      var placeholderText = '<fact sets>';
      var separator_4 = get_defaultChildrenSeparator();
      var tmp0_13 = new ChildrenRoleDefaults(getKClass(FactSet_1), placeholderText, null, separator_4, null, true);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_12 = btbProgramEditors$lambda_35;
      var triggerDependencies_12 = emptyList();
      var tmp_40 = getKClass(FactSet_1);
      var tmp_41 = new EditorDefinition(tmp_40, tmp0_13, null, false, true, triggerDependencies_12, btbProgramEditors$lambda_36(init_12));
      var tmp0_14 = childRoleDefaults('<empty (wrong state, please press enter)>', VOID, VOID, VOID, false);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_13 = btbProgramEditors$lambda_37;
      var triggerDependencies_13 = emptyList();
      var tmp_42 = getKClass(OntologyLibraryReference_1);
      var tmp_43 = new EditorDefinition(tmp_42, tmp0_14, null, true, true, triggerDependencies_13, btbProgramEditors$lambda_38(init_13));
      var tmp0_15 = btbProgramEditors$lambda_39;
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
      var completionSupplier_3 = btbProgramEditors$lambda_40;
      var separator_5 = get_defaultChildrenSeparator();
      var tmp0_16 = new ChildrenRoleDefaults(getKClass(ClassExpressionPlaceholder_1), '<empty>', tmp0_15, separator_5, completionSupplier_3, true);
      var tmp0_17 = childRoleDefaults(VOID, VOID, VOID, false);
      var tmp0_18 = childRoleDefaults(VOID, VOID, VOID, false);
      var tmp0_19 = childRoleDefaults('<no element references, press Enter to create one>', btbProgramEditors$lambda_41, VOID, VOID, false);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_14 = btbProgramEditors$lambda_42;
      var triggerDependencies_14 = emptyList();
      var tmp_44 = getKClass(OntologyElementReference_1);
      var tmp_45 = new EditorDefinition(tmp_44, tmp0_19, null, true, true, triggerDependencies_14, btbProgramEditors$lambda_43(init_14));
      var tmp0_20 = childRoleDefaults('<element>', btbProgramEditors$lambda_44);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_15 = btbProgramEditors$lambda_45;
      var triggerDependencies_15 = emptyList();
      var tmp_46 = getKClass(LocalOntologyElementReference_1);
      var tmp_47 = new EditorDefinition(tmp_46, tmp0_20, null, true, true, triggerDependencies_15, btbProgramEditors$lambda_46(init_15));
      var tmp0_21 = childRoleDefaults(VOID, VOID, btbProgramEditors$lambda_47);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_16 = btbProgramEditors$lambda_48;
      var triggerDependencies_16 = emptyList();
      var tmp_48 = getKClass(QualifiedOntologyElementReference_1);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.hierarchyEditor' call
      var editorDefinitions_2 = [tmp_45, tmp_47, new EditorDefinition(tmp_48, tmp0_21, null, false, true, triggerDependencies_16, btbProgramEditors$lambda_49(init_16))];
      var tmp_49 = new HierarchyEditorDefinition(getKClass(OntologyElementReferenceProvider), tmp0_18, toList(editorDefinitions_2));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
      var itemFactory = btbProgramEditors$lambda_50;
      var separator_6 = get_defaultChildrenSeparator();
      var tmp0_22 = new ChildrenRoleDefaults(getKClass(UnionClass_1), '<empty>', itemFactory, separator_6, null, true);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.hierarchyEditor' call
      var editorDefinitions_3 = [unionEditor()];
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.hierarchyEditor' call
      var editorDefinitions_4 = [tmp_49, new HierarchyEditorDefinition(getKClass(AnonymousClass), tmp0_22, toList(editorDefinitions_3))];
      var tmp_50 = new HierarchyEditorDefinition(getKClass(ClassExpression), tmp0_17, toList(editorDefinitions_4));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_17 = btbProgramEditors$lambda_51;
      var triggerDependencies_17 = emptyList();
      var tmp_51 = getKClass(ClassExpressionPlaceholder_1);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.hierarchyEditor' call
      var editorDefinitions_5 = [tmp_50, new EditorDefinition(tmp_51, null, null, false, true, triggerDependencies_17, btbProgramEditors$lambda_52(init_17))];
      var tmp_52 = new HierarchyEditorDefinition(getKClass(ClassExpressionPlaceholder_1), tmp0_16, toList(editorDefinitions_5));
      var tmp0_23 = '<variables>';
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
      var completionSupplier_4 = btbProgramEditors$lambda_53;
      var separator_7 = get_defaultChildrenSeparator();
      var tmp0_24 = new ChildrenRoleDefaults(getKClass(VariableDeclaration_1), tmp0_23, null, separator_7, completionSupplier_4, true);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_18 = btbProgramEditors$lambda_54;
      var triggerDependencies_18 = emptyList();
      var tmp_53 = getKClass(VariableDeclaration_1);
      var tmp$ret$35 = new EditorDefinition(tmp_53, tmp0_24, null, false, true, triggerDependencies_18, btbProgramEditors$lambda_55(init_18));
      btbProgramEditors = listOf_0([tmp_0, tmp_2, tmp_4, tmp_6, tmp_21, tmp_22, tmp_35, tmp_37, tmp_39, tmp_41, tmp_43, tmp_52, tmp$ret$35]);
    }
  }
  function enableEagerCompletion(_this__u8e3s4) {
    _this__u8e3s4.qd0().g93(TextEditing_getInstance().c9a_1, true);
  }
  function commentEditor(_this__u8e3s4) {
    var tmp = KProperty1;
    var tmp0 = getPropertyCallableRef('lines', 1, tmp, MultilineText$_get_lines_$ref_okds4p_1(), null);
    var tmp_0 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.textSpecification' call
    var textProperty = getPropertyCallableRef('text', 1, tmp_0, TextLine$_get_text_$ref_oszt1s_1(), null);
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp_1 = new MultipleChildLink(getKClass(MultilineText), tmp0);
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$1 = new TextAttributeLink(getKClass(TextLine), textProperty);
    var tmp_2 = new TextSpecification(tmp_1, tmp$ret$1);
    var tmp_3 = commentEditor$lambda;
    multilineText(_this__u8e3s4, '<description>', tmp_2, tmp_3, commentEditor$lambda_0);
  }
  function MultilineText$_get_lines_$ref_okds4p_1() {
    return function (p0) {
      return p0.qcv();
    };
  }
  function TextLine$_get_text_$ref_oszt1s_1() {
    return function (p0) {
      return p0.o8w();
    };
  }
  function commentEditor$lambda(source) {
    return source.lfr();
  }
  function commentEditor$lambda_0(it) {
    it.i90(Companion_getInstance_154().h8x_1, true);
    it.i90(Companion_getInstance_154().g8x_1, true);
    it.i90(Companion_getInstance_154().c8x_1, new Color(90, 90, 90));
    return Unit_instance;
  }
  function get_preventBackspaceAtBeginningTrait() {
    _init_properties_ComplexNotionEditors_kt__n53bvl();
    return preventBackspaceAtBeginningTrait;
  }
  var preventBackspaceAtBeginningTrait;
  function complexNotionValueEditor() {
    _init_properties_ComplexNotionEditors_kt__n53bvl();
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.asyncInvalidatingEditor' call
    var init = complexNotionValueEditor$slambda_0(null);
    var triggerDependencies = emptyList();
    var tmp = getKClass(ComplexNotionValue_1);
    return new EditorDefinition(tmp, null, null, true, true, triggerDependencies, complexNotionValueEditor$lambda(init));
  }
  function complexNotionElementValueEditor() {
    _init_properties_ComplexNotionEditors_kt__n53bvl();
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
    var separator = get_defaultChildrenSeparator();
    var tmp0 = new ChildrenRoleDefaults(getKClass(ComplexNotionElementValue_1), '<empty>', null, separator, null, true);
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.asyncInvalidatingEditor' call
    var init = complexNotionElementValueEditor$slambda_0(null);
    var triggerDependencies = emptyList();
    var tmp = getKClass(ComplexNotionElementValue_1);
    return new EditorDefinition(tmp, tmp0, null, false, true, triggerDependencies, complexNotionElementValueEditor$lambda(init));
  }
  function complexNotionValueCompletion(_this__u8e3s4) {
    _init_properties_ComplexNotionEditors_kt__n53bvl();
    var tmp = _this__u8e3s4.jcg(Companion_getInstance_319().eg4_1);
    _this__u8e3s4.gck(tmp, complexNotionValueCompletion$lambda(_this__u8e3s4));
  }
  function syncValuesWithDefinition(_this__u8e3s4, elementDefinitions, elementValues) {
    _init_properties_ComplexNotionEditors_kt__n53bvl();
    if (get_internalConfig(_this__u8e3s4).acu()) {
      return false;
    }
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList_init_$Create$();
    var _iterator__ex2g4s = elementValues.m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      var valueRef = _this__u8e3s4.l60(element.gfq().z6o());
      var tmp$ret$0;
      $l$block_0: {
        // Inline function 'kotlin.collections.none' call
        var tmp;
        if (isInterface(elementDefinitions, Collection)) {
          tmp = elementDefinitions.s();
        } else {
          tmp = false;
        }
        if (tmp) {
          tmp$ret$0 = true;
          break $l$block_0;
        }
        var _iterator__ex2g4s_0 = elementDefinitions.m();
        while (_iterator__ex2g4s_0.n()) {
          var element_0 = _iterator__ex2g4s_0.o();
          var tmp0_safe_receiver = get_pointer(element_0);
          var tmp_0;
          if (tmp0_safe_receiver == null) {
            tmp_0 = null;
          } else {
            // Inline function 'kotlin.let' call
            tmp_0 = new QualifiedReferenceContent(tmp0_safe_receiver);
          }
          if (equals(tmp_0, valueRef)) {
            tmp$ret$0 = false;
            break $l$block_0;
          }
        }
        tmp$ret$0 = true;
      }
      if (tmp$ret$0) {
        destination.j(element);
      }
    }
    var orphanedValues = destination;
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination_0 = ArrayList_init_$Create$();
    var _iterator__ex2g4s_1 = elementDefinitions.m();
    while (_iterator__ex2g4s_1.n()) {
      var element_1 = _iterator__ex2g4s_1.o();
      var tmp0_safe_receiver_0 = get_pointer(element_1);
      var tmp_1;
      if (tmp0_safe_receiver_0 == null) {
        tmp_1 = null;
      } else {
        // Inline function 'kotlin.let' call
        var ref = new QualifiedReferenceContent(tmp0_safe_receiver_0);
        var tmp$ret$7;
        $l$block_2: {
          // Inline function 'kotlin.collections.none' call
          var tmp_2;
          if (isInterface(elementValues, Collection)) {
            tmp_2 = elementValues.s();
          } else {
            tmp_2 = false;
          }
          if (tmp_2) {
            tmp$ret$7 = true;
            break $l$block_2;
          }
          var _iterator__ex2g4s_2 = elementValues.m();
          while (_iterator__ex2g4s_2.n()) {
            var element_2 = _iterator__ex2g4s_2.o();
            if (equals(_this__u8e3s4.l60(element_2.gfq().z6o()), ref)) {
              tmp$ret$7 = false;
              break $l$block_2;
            }
          }
          tmp$ret$7 = true;
        }
        tmp_1 = tmp$ret$7;
      }
      var tmp1_elvis_lhs = tmp_1;
      if (tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs) {
        destination_0.j(element_1);
      }
    }
    var missingElements = destination_0;
    var tmp_3;
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!orphanedValues.s()) {
      tmp_3 = true;
    } else {
      // Inline function 'kotlin.collections.isNotEmpty' call
      tmp_3 = !missingElements.s();
    }
    if (tmp_3) {
      var tmp_4 = ensureNotNull(_this__u8e3s4.qd0().s8x());
      tmp_4.d9m(syncValuesWithDefinition$lambda(orphanedValues, _this__u8e3s4, missingElements));
      return true;
    }
    return false;
  }
  function findElementValue(_this__u8e3s4, element, existingElementValues) {
    _init_properties_ComplexNotionEditors_kt__n53bvl();
    if (element == null)
      return null;
    var tmp0_safe_receiver = get_pointer(element);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp = new QualifiedReferenceContent(tmp0_safe_receiver);
    }
    var tmp1_safe_receiver = tmp;
    var tmp_0;
    if (tmp1_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      var tmp$ret$3;
      $l$block: {
        // Inline function 'kotlin.collections.firstOrNull' call
        var _iterator__ex2g4s = existingElementValues.m();
        while (_iterator__ex2g4s.n()) {
          var element_0 = _iterator__ex2g4s.o();
          if (equals(_this__u8e3s4.l60(element_0.gfq().z6o()), tmp1_safe_receiver)) {
            tmp$ret$3 = element_0;
            break $l$block;
          }
        }
        tmp$ret$3 = null;
      }
      tmp_0 = tmp$ret$3;
    }
    return tmp_0;
  }
  function renderElementValue(_this__u8e3s4, elementValue, elementName, $completion) {
    var tmp = new $renderElementValueCOROUTINE$(_this__u8e3s4, elementValue, elementName, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  }
  function unknownValueCompletion(_this__u8e3s4) {
    _init_properties_ComplexNotionEditors_kt__n53bvl();
    return _this__u8e3s4.lck(unknownValueCompletion$slambda_0(null));
  }
  function sharedElementValueId(value, element) {
    _init_properties_ComplexNotionEditors_kt__n53bvl();
    return new NodeId('cnev' + value.z3n().q36_1 + element.nodeId.q36_1);
  }
  function complexNotionEditor() {
    _init_properties_ComplexNotionEditors_kt__n53bvl();
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
    var init = complexNotionEditor$lambda;
    var triggerDependencies = emptyList();
    var tmp = getKClass(ComplexNotion_1);
    return new EditorDefinition(tmp, null, null, false, true, triggerDependencies, complexNotionEditor$lambda_0(init));
  }
  function complexNotionElementEditor() {
    _init_properties_ComplexNotionEditors_kt__n53bvl();
    var tmp0 = '<elements>';
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
    var completionSupplier = complexNotionElementEditor$lambda;
    var separator = get_defaultChildrenSeparator();
    var tmp0_0 = new ChildrenRoleDefaults(getKClass(ComplexNotionElement_1), tmp0, null, separator, completionSupplier, true);
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
    var init = complexNotionElementEditor$lambda_0;
    var triggerDependencies = emptyList();
    var tmp = getKClass(ComplexNotionElement_1);
    return new EditorDefinition(tmp, tmp0_0, null, false, true, triggerDependencies, complexNotionElementEditor$lambda_1(init));
  }
  function allowedComplexNotionTypeEditor() {
    _init_properties_ComplexNotionEditors_kt__n53bvl();
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.hierarchyEditor' call
    var editorDefinitions = [notionTypeEditor(), primitiveNotionTypeEditor()];
    return new HierarchyEditorDefinition(getKClass(AllowedComplexNotionType), null, toList(editorDefinitions));
  }
  function allowedComplexNotionValueEditor() {
    _init_properties_ComplexNotionEditors_kt__n53bvl();
    var tmp = measurableValueEditor();
    var tmp_0 = enumValueEditor();
    var tmp_1 = stringValueEditor();
    var tmp_2 = integerValueEditor();
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
    var init = allowedComplexNotionValueEditor$lambda;
    var triggerDependencies = emptyList();
    var tmp_3 = getKClass(UnknownComplexNotionValue_1);
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.hierarchyEditor' call
    var editorDefinitions = [tmp, tmp_0, tmp_1, tmp_2, new EditorDefinition(tmp_3, null, null, false, true, triggerDependencies, allowedComplexNotionValueEditor$lambda_0(init))];
    return new HierarchyEditorDefinition(getKClass(AllowedComplexNotionValue), null, toList(editorDefinitions));
  }
  function complexNotionTemplateEditor() {
    _init_properties_ComplexNotionEditors_kt__n53bvl();
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
    var init = complexNotionTemplateEditor$lambda;
    var triggerDependencies = emptyList();
    var tmp = getKClass(ComplexNotionTemplate_1);
    return new EditorDefinition(tmp, null, null, false, true, triggerDependencies, complexNotionTemplateEditor$lambda_0(init));
  }
  function complexNotionTemplateElementEditor() {
    _init_properties_ComplexNotionEditors_kt__n53bvl();
    var tmp2 = complexNotionTemplateElementEditor$lambda;
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
    var completionSupplier = complexNotionTemplateElementEditor$lambda_0;
    var separator = get_defaultChildrenSeparator();
    var tmp0 = new ChildrenRoleDefaults(getKClass(ComplexNotionTemplateElement), '<empty>', tmp2, separator, completionSupplier, true);
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
    var init = complexNotionTemplateElementEditor$lambda_1;
    var triggerDependencies = emptyList();
    var tmp = getKClass(ComplexNotionTemplatePlaceholder_1);
    var tmp_0 = new EditorDefinition(tmp, null, null, false, true, triggerDependencies, complexNotionTemplateElementEditor$lambda_2(init));
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
    var init_0 = complexNotionTemplateElementEditor$lambda_3;
    var triggerDependencies_0 = emptyList();
    var tmp_1 = getKClass(ComplexNotionTemplateTextElement_1);
    var tmp_2 = new EditorDefinition(tmp_1, null, null, false, true, triggerDependencies_0, complexNotionTemplateElementEditor$lambda_4(init_0));
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
    var init_1 = complexNotionTemplateElementEditor$lambda_5;
    var triggerDependencies_1 = emptyList();
    var tmp_3 = getKClass(ComplexNotionTemplateRefElement_1);
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.hierarchyEditor' call
    var editorDefinitions = [tmp_0, tmp_2, new EditorDefinition(tmp_3, null, null, false, true, triggerDependencies_1, complexNotionTemplateElementEditor$lambda_6(init_1))];
    return new HierarchyEditorDefinition(getKClass(ComplexNotionTemplateElement), tmp0, toList(editorDefinitions));
  }
  function complexNotionCompletion(_this__u8e3s4) {
    _init_properties_ComplexNotionEditors_kt__n53bvl();
    _this__u8e3s4.bck('complex notion', complexNotionCompletion$lambda(_this__u8e3s4));
  }
  function unknownValueMode(_this__u8e3s4) {
    _init_properties_ComplexNotionEditors_kt__n53bvl();
    var openParen = indentLabel_0(_this__u8e3s4, '(');
    var tmp = unknownValueMode$lambda;
    var unknownValueMode = editableText_0(_this__u8e3s4, VOID, '<? allowed|? not allowed>', tmp, VOID, unknownValueMode$lambda_0);
    // Inline function 'kotlin.apply' call
    var this_0 = indentLabel_0(_this__u8e3s4, ')', true);
    closingFor(this_0, openParen);
    var closeParen = this_0;
    var unknownValueColor = ifProp(_this__u8e3s4.m6d().lfq().m5y(), Companion_getInstance_210().o95_1, Companion_getInstance_210().r95_1);
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = listOf_0([openParen, unknownValueMode, closeParen]).m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      // Inline function 'jetbrains.ocelot.mapper.core.Synchronizers.forDisposable' call
      var tmp$ret$2 = new unknownValueMode$$inlined$forEach$1(unknownValueColor, element);
      _this__u8e3s4.l8b(tmp$ret$2);
    }
  }
  function complexNotionTemplateCompletion(_this__u8e3s4) {
    _init_properties_ComplexNotionEditors_kt__n53bvl();
    _this__u8e3s4.bck('text', complexNotionTemplateCompletion$lambda(_this__u8e3s4));
    _this__u8e3s4.bck('simple notion', complexNotionTemplateCompletion$lambda_0(_this__u8e3s4));
  }
  function unknownValueModeText(unknownValueAllowed) {
    _init_properties_ComplexNotionEditors_kt__n53bvl();
    return unknownValueAllowed ? '? allowed' : '? not allowed';
  }
  function unknownValueModeItem(cell, mode, hint) {
    _init_properties_ComplexNotionEditors_kt__n53bvl();
    return new unknownValueModeItem$1(mode, hint, cell);
  }
  function preventBackspaceAtBeginningTrait$1() {
    CellTrait.call(this);
  }
  protoOf(preventBackspaceAtBeginningTrait$1).s8z = function (cell, event) {
    var tc = cell instanceof TextCell ? cell : null;
    if (!(tc == null) && event.m8j(Key_BACKSPACE_getInstance(), []) && tc.t96().w2w() === 0) {
      event.n8i();
    } else {
      protoOf(CellTrait).s8z.call(this, cell, event);
    }
  };
  function complexNotionValueEditor$slambda$lambda($this$indent) {
    var tmp = getKClass(ComplexNotionElementValue_1);
    var tmp_0 = Layout_HORIZONTAL_getInstance();
    children_2($this$indent, tmp, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp_0, complexNotionValueEditor$slambda$lambda$lambda);
    $this$indent.l8b(referenceOutOfScopeSynchronizer(get_internalConfig($this$indent).ud0(), $this$indent.qd0(), $this$indent.m6d().mfq()));
    return Unit_instance;
  }
  function complexNotionValueEditor$slambda$lambda$lambda(it) {
    return it.nfq();
  }
  function complexNotionValueEditor$slambda(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(complexNotionValueEditor$slambda).lu7 = function ($this$asyncInvalidatingEditor, $completion) {
    var tmp = this.mu7($this$asyncInvalidatingEditor, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(complexNotionValueEditor$slambda).v9 = function (p1, $completion) {
    return this.lu7(p1 instanceof InvalidatingEditorBuilder ? p1 : THROW_CCE(), $completion);
  };
  protoOf(complexNotionValueEditor$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 12;
            this.f9_1 = 1;
            suspendResult = this.hu7_1.k60(this.hu7_1.m6d().mfq(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var resolvedNotion = suspendResult;
            if (resolvedNotion == null) {
              indent_0(this.hu7_1, VOID, VOID, complexNotionValueEditor$slambda$lambda);
              return Unit_instance;
            }

            var elementDefinitions = this.hu7_1.l60(resolvedNotion.ifq());
            this.iu7_1 = this.hu7_1.l60(this.hu7_1.m6d().nfq());
            var needsRebuild = syncValuesWithDefinition(this.hu7_1, elementDefinitions, this.iu7_1);
            if (needsRebuild) {
              return Unit_instance;
            }

            var template = this.hu7_1.l60(resolvedNotion.jfq());
            if (!(template == null)) {
              this.ju7_1 = this.hu7_1.l60(template.ifq()).m();
              this.f9_1 = 5;
              continue $sm;
            } else {
              this.ku7_1 = elementDefinitions.m();
              this.f9_1 = 2;
              continue $sm;
            }

          case 2:
            if (!this.ku7_1.n()) {
              this.f9_1 = 4;
              continue $sm;
            }

            var element = this.ku7_1.o();
            var elementValue = findElementValue(this.hu7_1, element, this.iu7_1);
            this.f9_1 = 3;
            suspendResult = renderElementValue(this.hu7_1, elementValue, this.hu7_1.l60(element.y2()), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            this.f9_1 = 2;
            continue $sm;
          case 4:
            this.f9_1 = 11;
            continue $sm;
          case 5:
            if (!this.ju7_1.n()) {
              this.f9_1 = 10;
              continue $sm;
            }

            var element_0 = this.ju7_1.o();
            if (isInterface(element_0, ComplexNotionTemplateTextElement_1)) {
              var cell = TextCell_init_$Create$_0(this.hu7_1.l60(element_0.o8w()));
              asInternalEditorBuilder(this.hu7_1).od0(cell);
              this.f9_1 = 9;
              continue $sm;
            } else {
              if (isInterface(element_0, ComplexNotionTemplateRefElement_1)) {
                var referenceContent = this.hu7_1.l60(element_0.gfq().z6o());
                if (!(referenceContent == null)) {
                  this.f9_1 = 6;
                  suspendResult = this.hu7_1.k60(element_0.gfq(), this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  continue $sm;
                } else {
                  this.f9_1 = 8;
                  continue $sm;
                }
              } else {
                this.f9_1 = 9;
                continue $sm;
              }
            }

          case 6:
            var referencedElement = suspendResult;
            var elementValue_0 = findElementValue(this.hu7_1, referencedElement, this.iu7_1);
            var tmp2_elvis_lhs = referencedElement == null ? null : this.hu7_1.l60(referencedElement.y2());
            var elementName = tmp2_elvis_lhs == null ? 'unknown' : tmp2_elvis_lhs;
            this.f9_1 = 7;
            suspendResult = renderElementValue(this.hu7_1, elementValue_0, elementName, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 7:
            this.f9_1 = 8;
            continue $sm;
          case 8:
            this.f9_1 = 9;
            continue $sm;
          case 9:
            this.f9_1 = 5;
            continue $sm;
          case 10:
            this.f9_1 = 11;
            continue $sm;
          case 11:
            return Unit_instance;
          case 12:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 12) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(complexNotionValueEditor$slambda).mu7 = function ($this$asyncInvalidatingEditor, completion) {
    var i = new complexNotionValueEditor$slambda(completion);
    i.hu7_1 = $this$asyncInvalidatingEditor;
    return i;
  };
  function complexNotionValueEditor$slambda_0(resultContinuation) {
    var i = new complexNotionValueEditor$slambda(resultContinuation);
    var l = function ($this$asyncInvalidatingEditor, $completion) {
      return i.lu7($this$asyncInvalidatingEditor, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function complexNotionValueEditor$lambda$slambda($this_EditorDefinition, $init, $invalidator, $invalidated, resultContinuation) {
    this.vu7_1 = $this_EditorDefinition;
    this.wu7_1 = $init;
    this.xu7_1 = $invalidator;
    this.yu7_1 = $invalidated;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(complexNotionValueEditor$lambda$slambda).x9e = function ($completion) {
    var tmp = this.y9e($completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(complexNotionValueEditor$lambda$slambda).z9e = function ($completion) {
    return this.x9e($completion);
  };
  protoOf(complexNotionValueEditor$lambda$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 6;
            this.g9_1 = 5;
            this.zu7_1 = new Invalidator();
            this.au8_1 = this.vu7_1.ud3(this.zu7_1);
            this.f9_1 = 1;
            continue $sm;
          case 1:
            this.g9_1 = 4;
            this.f9_1 = 2;
            suspendResult = this.wu7_1(this.au8_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.f9_1 = 3;
            continue $sm;
          case 3:
            this.g9_1 = 5;
            affects(this.zu7_1.z5v(Unit_instance), this.xu7_1);
            this.g9_1 = 6;
            this.f9_1 = 7;
            continue $sm;
          case 4:
            this.g9_1 = 5;
            var t = this.i9_1;
            affects(this.zu7_1.z5v(Unit_instance), this.xu7_1);
            throw t;
          case 5:
            this.g9_1 = 6;
            var tmp_0 = this.i9_1;
            if (tmp_0 instanceof AlreadyInvalidException) {
              var e = this.i9_1;
              this.yu7_1.d2x(true);
              this.f9_1 = 7;
              continue $sm;
            } else {
              throw this.i9_1;
            }

          case 6:
            throw this.i9_1;
          case 7:
            this.g9_1 = 6;
            return Unit_instance;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.g9_1 === 6) {
          throw e_0;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(complexNotionValueEditor$lambda$slambda).y9e = function (completion) {
    return new complexNotionValueEditor$lambda$slambda(this.vu7_1, this.wu7_1, this.xu7_1, this.yu7_1, completion);
  };
  function complexNotionValueEditor$lambda$slambda_0($this_EditorDefinition, $init, $invalidator, $invalidated, resultContinuation) {
    var i = new complexNotionValueEditor$lambda$slambda($this_EditorDefinition, $init, $invalidator, $invalidated, resultContinuation);
    var l = function ($completion) {
      return i.x9e($completion);
    };
    l.$arity = 0;
    return l;
  }
  function complexNotionValueEditor$lambda($init) {
    return function ($this$EditorDefinition) {
      var invalidator = new Invalidator();
      var invalidated = new ValueProperty(false);
      depend(invalidator, invalidated);
      $this$EditorDefinition.vd3(complexNotionValueEditor$lambda$slambda_0($this$EditorDefinition, $init, invalidator, invalidated, null));
      return invalidator.z5v(Unit_instance);
    };
  }
  function $runSuspendCOROUTINE$_142(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.ju8_1 = _this__u8e3s4;
    this.ku8_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_142).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.lu8_1 = this.ku8_1;
            this.f9_1 = 1;
            suspendResult = this.lu8_1.k60(this.ju8_1.mu8_1.m6d().gfq(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp0_safe_receiver = suspendResult;
            var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : this.lu8_1.l60(tmp0_safe_receiver.y2());
            return tmp1_elvis_lhs == null ? 'unknown' : tmp1_elvis_lhs;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function complexNotionElementValueEditor$2$$inlined$executeSuspendingQuery$1($this_asyncInvalidatingEditor) {
    this.mu8_1 = $this_asyncInvalidatingEditor;
  }
  protoOf(complexNotionElementValueEditor$2$$inlined$executeSuspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_142(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(complexNotionElementValueEditor$2$$inlined$executeSuspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function complexNotionElementValueEditor$slambda$lambda(it) {
    return it.a1();
  }
  function complexNotionElementValueEditor$slambda$lambda_0($this$child) {
    measurableValueWithDefaultUnitCompletion($this$child);
    enumValueCompletion_0($this$child);
    stringValueCompletion($this$child);
    integerValueCompletion($this$child);
    unknownValueCompletion($this$child);
    return Unit_instance;
  }
  function complexNotionElementValueEditor$slambda(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(complexNotionElementValueEditor$slambda).wu8 = function ($this$asyncInvalidatingEditor, $completion) {
    var tmp = this.xu8($this$asyncInvalidatingEditor, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(complexNotionElementValueEditor$slambda).v9 = function (p1, $completion) {
    return this.wu8(p1 instanceof InvalidatingEditorBuilder ? p1 : THROW_CCE(), $completion);
  };
  protoOf(complexNotionElementValueEditor$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = execute_1(new complexNotionElementValueEditor$2$$inlined$executeSuspendingQuery$1(this.vu8_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var elementName = suspendResult;
            var tmp0_placeholderText = '<' + elementName + '>';
            var tmp_0 = getKClass(AllowedComplexNotionValue);
            var tmp_1 = complexNotionElementValueEditor$slambda$lambda;
            child_1(this.vu8_1, tmp_0, tmp_1, tmp0_placeholderText, VOID, VOID, VOID, VOID, VOID, VOID, complexNotionElementValueEditor$slambda$lambda_0);
            return Unit_instance;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(complexNotionElementValueEditor$slambda).xu8 = function ($this$asyncInvalidatingEditor, completion) {
    var i = new complexNotionElementValueEditor$slambda(completion);
    i.vu8_1 = $this$asyncInvalidatingEditor;
    return i;
  };
  function complexNotionElementValueEditor$slambda_0(resultContinuation) {
    var i = new complexNotionElementValueEditor$slambda(resultContinuation);
    var l = function ($this$asyncInvalidatingEditor, $completion) {
      return i.wu8($this$asyncInvalidatingEditor, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function complexNotionElementValueEditor$lambda$slambda($this_EditorDefinition, $init, $invalidator, $invalidated, resultContinuation) {
    this.gu9_1 = $this_EditorDefinition;
    this.hu9_1 = $init;
    this.iu9_1 = $invalidator;
    this.ju9_1 = $invalidated;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(complexNotionElementValueEditor$lambda$slambda).x9e = function ($completion) {
    var tmp = this.y9e($completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(complexNotionElementValueEditor$lambda$slambda).z9e = function ($completion) {
    return this.x9e($completion);
  };
  protoOf(complexNotionElementValueEditor$lambda$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 6;
            this.g9_1 = 5;
            this.ku9_1 = new Invalidator();
            this.lu9_1 = this.gu9_1.ud3(this.ku9_1);
            this.f9_1 = 1;
            continue $sm;
          case 1:
            this.g9_1 = 4;
            this.f9_1 = 2;
            suspendResult = this.hu9_1(this.lu9_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.f9_1 = 3;
            continue $sm;
          case 3:
            this.g9_1 = 5;
            affects(this.ku9_1.z5v(Unit_instance), this.iu9_1);
            this.g9_1 = 6;
            this.f9_1 = 7;
            continue $sm;
          case 4:
            this.g9_1 = 5;
            var t = this.i9_1;
            affects(this.ku9_1.z5v(Unit_instance), this.iu9_1);
            throw t;
          case 5:
            this.g9_1 = 6;
            var tmp_0 = this.i9_1;
            if (tmp_0 instanceof AlreadyInvalidException) {
              var e = this.i9_1;
              this.ju9_1.d2x(true);
              this.f9_1 = 7;
              continue $sm;
            } else {
              throw this.i9_1;
            }

          case 6:
            throw this.i9_1;
          case 7:
            this.g9_1 = 6;
            return Unit_instance;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.g9_1 === 6) {
          throw e_0;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(complexNotionElementValueEditor$lambda$slambda).y9e = function (completion) {
    return new complexNotionElementValueEditor$lambda$slambda(this.gu9_1, this.hu9_1, this.iu9_1, this.ju9_1, completion);
  };
  function complexNotionElementValueEditor$lambda$slambda_0($this_EditorDefinition, $init, $invalidator, $invalidated, resultContinuation) {
    var i = new complexNotionElementValueEditor$lambda$slambda($this_EditorDefinition, $init, $invalidator, $invalidated, resultContinuation);
    var l = function ($completion) {
      return i.x9e($completion);
    };
    l.$arity = 0;
    return l;
  }
  function complexNotionElementValueEditor$lambda($init) {
    return function ($this$EditorDefinition) {
      var invalidator = new Invalidator();
      var invalidated = new ValueProperty(false);
      depend(invalidator, invalidated);
      $this$EditorDefinition.vd3(complexNotionElementValueEditor$lambda$slambda_0($this$EditorDefinition, $init, invalidator, invalidated, null));
      return invalidator.z5v(Unit_instance);
    };
  }
  function complexNotionValueCompletion$lambda($this_complexNotionValueCompletion) {
    return function (reference) {
      // Inline function 'kotlin.apply' call
      var this_0 = ComplexNotionValue($this_complexNotionValueCompletion.l6z());
      this_0.mfq().f2x(reference);
      return this_0;
    };
  }
  function syncValuesWithDefinition$lambda($orphanedValues, $this_syncValuesWithDefinition, $missingElements) {
    return function () {
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s = $orphanedValues.m();
      while (_iterator__ex2g4s.n()) {
        var element = _iterator__ex2g4s.o();
        $this_syncValuesWithDefinition.m6d().nfq().h2(element);
      }
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s_0 = $missingElements.m();
      while (_iterator__ex2g4s_0.n()) {
        var element_0 = _iterator__ex2g4s_0.o();
        // Inline function 'kotlin.requireNotNull' call
        var tmp0 = get_pointer(element_0);
        var tmp$ret$3;
        $l$block: {
          // Inline function 'kotlin.requireNotNull' call
          if (tmp0 == null) {
            var message = 'Required value was null.';
            throw IllegalArgumentException_init_$Create$_0(toString_1(message));
          } else {
            tmp$ret$3 = tmp0;
            break $l$block;
          }
        }
        var pointer = tmp$ret$3;
        var elementDefRef = new QualifiedReferenceContent(pointer);
        var tmp = $this_syncValuesWithDefinition.m6d().nfq();
        // Inline function 'kotlin.apply' call
        var this_0 = ComplexNotionElementValue(get_internalConfig($this_syncValuesWithDefinition).l6z(), sharedElementValueId($this_syncValuesWithDefinition.m6d(), pointer));
        this_0.gfq().b6p(elementDefRef);
        tmp.j(this_0);
      }
      return Unit_instance;
    };
  }
  function renderElementValue$lambda($elementValue) {
    return function (it) {
      return get_forQueries(new ValueProperty(isInterface($elementValue, ComplexNotionElementValue_1) ? $elementValue : THROW_CCE()));
    };
  }
  function $runSuspendCOROUTINE$_143(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.uu9_1 = _this__u8e3s4;
    this.vu9_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_143).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 3;
            this.wu9_1 = this.vu9_1;
            var tmp0_safe_receiver = this.uu9_1.yu9_1._v;
            if (tmp0_safe_receiver == null) {
              this.xu9_1 = null;
              this.f9_1 = 2;
              continue $sm;
            } else {
              this.f9_1 = 1;
              suspendResult = this.wu9_1.k60(tmp0_safe_receiver.gfq(), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            this.xu9_1 = suspendResult;
            this.f9_1 = 2;
            continue $sm;
          case 2:
            var tmp1_safe_receiver = this.xu9_1;
            return (tmp1_safe_receiver == null ? null : this.wu9_1.l60(tmp1_safe_receiver.lfq())) === true;
          case 3:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 3) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function unknownValueCompletion$2$$inlined$executeSuspendingQuery$1($contextNode) {
    this.yu9_1 = $contextNode;
  }
  protoOf(unknownValueCompletion$2$$inlined$executeSuspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_143(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(unknownValueCompletion$2$$inlined$executeSuspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function unknownValueCompletion$slambda$lambda($this_async) {
    return function () {
      return UnknownComplexNotionValue($this_async.l6z());
    };
  }
  function unknownValueCompletion$slambda(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(unknownValueCompletion$slambda).iua = function ($this$async, $completion) {
    var tmp = this.jua($this$async, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(unknownValueCompletion$slambda).v9 = function (p1, $completion) {
    return this.iua(p1 instanceof NodeCompletionBuilder ? p1 : THROW_CCE(), $completion);
  };
  protoOf(unknownValueCompletion$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            var contextNode = {_v: this.hua_1.ack()};
            $l$loop: while (true) {
              var tmp_0;
              if (!(contextNode._v == null)) {
                var tmp_1 = contextNode._v;
                tmp_0 = !isInterface(tmp_1, ComplexNotionElementValue_1);
              } else {
                tmp_0 = false;
              }
              if (!tmp_0) {
                break $l$loop;
              }
              contextNode._v = contextNode._v.bp();
            }

            this.f9_1 = 1;
            suspendResult = execute_1(new unknownValueCompletion$2$$inlined$executeSuspendingQuery$1(contextNode), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var unknownValueAllowed = suspendResult;
            if (unknownValueAllowed) {
              this.hua_1.bck('?', unknownValueCompletion$slambda$lambda(this.hua_1));
            }

            return Unit_instance;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(unknownValueCompletion$slambda).jua = function ($this$async, completion) {
    var i = new unknownValueCompletion$slambda(completion);
    i.hua_1 = $this$async;
    return i;
  };
  function unknownValueCompletion$slambda_0(resultContinuation) {
    var i = new unknownValueCompletion$slambda(resultContinuation);
    var l = function ($this$async, $completion) {
      return i.iua($this$async, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function complexNotionEditor$lambda($this$editor) {
    _init_properties_ComplexNotionEditors_kt__n53bvl();
    keyword_0($this$editor, 'complex notion');
    space_0($this$editor);
    textProperty_0($this$editor, '<name>', complexNotionEditor$lambda$lambda);
    indent_0($this$editor, true, VOID, complexNotionEditor$lambda$lambda_0);
    return Unit_instance;
  }
  function complexNotionEditor$lambda$lambda(complexNotion) {
    _init_properties_ComplexNotionEditors_kt__n53bvl();
    return complexNotion.y2();
  }
  function complexNotionEditor$lambda$lambda_0($this$indent) {
    _init_properties_ComplexNotionEditors_kt__n53bvl();
    newLine_0($this$indent);
    keyword_0($this$indent, 'elements:');
    indent_0($this$indent, true, VOID, complexNotionEditor$lambda$lambda$lambda);
    newLine_0($this$indent);
    keyword_0($this$indent, 'template:');
    indent_0($this$indent, true, VOID, complexNotionEditor$lambda$lambda$lambda_0);
    return Unit_instance;
  }
  function complexNotionEditor$lambda$lambda$lambda($this$indent) {
    _init_properties_ComplexNotionEditors_kt__n53bvl();
    newLine_0($this$indent);
    var tmp2 = getKClass(ComplexNotionElement_1);
    var tmp = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.children' call
    var childrenProperty = getPropertyCallableRef('elements', 1, tmp, ComplexNotion$_get_elements_$ref_mrhdwi_1(), null);
    var placeholderTraitFactory = complexNotionEditor$lambda$lambda$lambda$lambda;
    var layout = Layout_INDENT_getInstance();
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp_0 = new MultipleChildLink(getKClass(ComplexNotion_1), childrenProperty);
    children_2($this$indent, tmp2, tmp_0, null, placeholderTraitFactory, null, null, null, null, layout, complexNotionEditor$lambda$lambda$lambda$lambda_0(childrenProperty));
    ensureLastCaretPosition($this$indent);
    return Unit_instance;
  }
  function ComplexNotion$_get_elements_$ref_mrhdwi_1() {
    return function (p0) {
      return p0.ifq();
    };
  }
  function complexNotionEditor$lambda$lambda$lambda$lambda(_unused_var__etf5q3, trait) {
    _init_properties_ComplexNotionEditors_kt__n53bvl();
    return trait;
  }
  function complexNotionEditor$lambda$lambda$lambda$lambda_0($childrenProperty) {
    return function (it) {
      return $childrenProperty(it);
    };
  }
  function complexNotionEditor$lambda$lambda$lambda_0($this$indent) {
    _init_properties_ComplexNotionEditors_kt__n53bvl();
    newLine_0($this$indent);
    var tmp2 = getKClass(ComplexNotionTemplate_1);
    var tmp = KProperty1;
    var tmp4 = getPropertyCallableRef('template', 1, tmp, ComplexNotion$_get_template_$ref_kdbfun_1(), null);
    var tmp6 = '<template>';
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.child' call
    var itemFactory = complexNotionEditor$lambda$lambda$lambda$lambda_1;
    var placeholderTraitFactory = complexNotionEditor$lambda$lambda$lambda$lambda_2;
    var tmp_0 = complexNotionEditor$lambda$lambda$lambda$lambda_3(tmp4);
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$0 = new SingleChildLink(getKClass(ComplexNotion_1), tmp4);
    child_1($this$indent, tmp2, tmp_0, tmp6, placeholderTraitFactory, itemFactory, null, null, null, tmp$ret$0, null);
    return Unit_instance;
  }
  function ComplexNotion$_get_template_$ref_kdbfun_1() {
    return function (p0) {
      return p0.jfq();
    };
  }
  function complexNotionEditor$lambda$lambda$lambda$lambda_1(wrapperContext) {
    _init_properties_ComplexNotionEditors_kt__n53bvl();
    // Inline function 'kotlin.apply' call
    var this_0 = ComplexNotionTemplate(wrapperContext);
    this_0.ifq().j(ComplexNotionTemplatePlaceholder(wrapperContext));
    return this_0;
  }
  function complexNotionEditor$lambda$lambda$lambda$lambda_2(_unused_var__etf5q3, trait) {
    _init_properties_ComplexNotionEditors_kt__n53bvl();
    return trait;
  }
  function complexNotionEditor$lambda$lambda$lambda$lambda_3($childProperty) {
    return function (it) {
      return $childProperty(it);
    };
  }
  function complexNotionEditor$lambda_0($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function complexNotionElementEditor$lambda($this$childrenRoleDefaults) {
    _init_properties_ComplexNotionEditors_kt__n53bvl();
    var tmp = editorString($this$childrenRoleDefaults, BTBEditorParts_getInstance().pu1_1);
    $this$childrenRoleDefaults.hck(tmp, complexNotionElementEditor$lambda$lambda($this$childrenRoleDefaults));
    return Unit_instance;
  }
  function complexNotionElementEditor$lambda$lambda($this_childrenRoleDefaults) {
    return function (name) {
      // Inline function 'kotlin.apply' call
      var this_0 = ComplexNotionElement($this_childrenRoleDefaults.l6z());
      this_0.y2().f2x(name);
      return this_0;
    };
  }
  function complexNotionElementEditor$lambda_0($this$editor) {
    _init_properties_ComplexNotionEditors_kt__n53bvl();
    var tmp = complexNotionElementEditor$lambda$lambda_0;
    // Inline function 'kotlin.apply' call
    var this_0 = textProperty_0($this$editor, '<element name>', tmp, complexNotionElementEditor$lambda$lambda_1);
    mark_0(this_0, BTBEditorParts_getInstance().pu1_1);
    space_0($this$editor);
    indentLabel_0($this$editor, ':');
    space_0($this$editor);
    var tmp2 = getKClass(AllowedComplexNotionType);
    var tmp_0 = KProperty1;
    var tmp4 = getPropertyCallableRef('elementType', 1, tmp_0, ComplexNotionElement$_get_elementType_$ref_czuq0z_1(), null);
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.child' call
    var completionSupplier = complexNotionElementEditor$lambda$lambda_2;
    var placeholderTraitFactory = complexNotionElementEditor$lambda$lambda_3;
    var tmp_1 = complexNotionElementEditor$lambda$lambda_4(tmp4);
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$2 = new SingleChildLink(getKClass(ComplexNotionElement_1), tmp4);
    child_1($this$editor, tmp2, tmp_1, null, placeholderTraitFactory, null, null, null, null, tmp$ret$2, completionSupplier);
    space_0($this$editor);
    unknownValueMode($this$editor);
    return Unit_instance;
  }
  function complexNotionElementEditor$lambda$lambda_0(complexNotionElement) {
    _init_properties_ComplexNotionEditors_kt__n53bvl();
    return complexNotionElement.y2();
  }
  function complexNotionElementEditor$lambda$lambda_1($this$textProperty) {
    _init_properties_ComplexNotionEditors_kt__n53bvl();
    addTraitOnAttach_0($this$textProperty, complexNotionElementEditor$lambda$lambda$lambda);
    return Unit_instance;
  }
  function complexNotionElementEditor$lambda$lambda$lambda(_unused_var__etf5q3, _unused_var__etf5q3_0, _unused_var__etf5q3_1) {
    _init_properties_ComplexNotionEditors_kt__n53bvl();
    return get_preventBackspaceAtBeginningTrait();
  }
  function ComplexNotionElement$_get_elementType_$ref_czuq0z_1() {
    return function (p0) {
      return p0.kfq();
    };
  }
  function complexNotionElementEditor$lambda$lambda_2($this$child) {
    _init_properties_ComplexNotionEditors_kt__n53bvl();
    getNotionTypeCompletion($this$child);
    getPrimitiveNotionTypeCompletion($this$child);
    return Unit_instance;
  }
  function complexNotionElementEditor$lambda$lambda_3(_unused_var__etf5q3, trait) {
    _init_properties_ComplexNotionEditors_kt__n53bvl();
    return trait;
  }
  function complexNotionElementEditor$lambda$lambda_4($childProperty) {
    return function (it) {
      return $childProperty(it);
    };
  }
  function complexNotionElementEditor$lambda_1($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function allowedComplexNotionValueEditor$lambda($this$editor) {
    _init_properties_ComplexNotionEditors_kt__n53bvl();
    keyword_0($this$editor, '?');
    return Unit_instance;
  }
  function allowedComplexNotionValueEditor$lambda_0($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function complexNotionTemplateEditor$lambda($this$editor) {
    _init_properties_ComplexNotionEditors_kt__n53bvl();
    var tmp0_layout = Layout_HORIZONTAL_getInstance();
    var tmp1_separator = separator('');
    var tmp = getKClass(ComplexNotionTemplateElement);
    children_2($this$editor, tmp, VOID, VOID, VOID, tmp1_separator, VOID, VOID, VOID, tmp0_layout, complexNotionTemplateEditor$lambda$lambda);
    return Unit_instance;
  }
  function complexNotionTemplateEditor$lambda$lambda(it) {
    _init_properties_ComplexNotionEditors_kt__n53bvl();
    return it.ifq();
  }
  function complexNotionTemplateEditor$lambda_0($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function complexNotionTemplateElementEditor$lambda(wrapperContext) {
    _init_properties_ComplexNotionEditors_kt__n53bvl();
    return ComplexNotionTemplatePlaceholder(wrapperContext);
  }
  function complexNotionTemplateElementEditor$lambda_0($this$childrenRoleDefaults) {
    _init_properties_ComplexNotionEditors_kt__n53bvl();
    complexNotionTemplateCompletion($this$childrenRoleDefaults);
    return Unit_instance;
  }
  function complexNotionTemplateElementEditor$lambda_1($this$editor) {
    _init_properties_ComplexNotionEditors_kt__n53bvl();
    placeholderInCollection_0($this$editor, '<empty>', complexNotionTemplateElementEditor$lambda$lambda);
    ensureLastCaretPosition($this$editor);
    return Unit_instance;
  }
  function complexNotionTemplateElementEditor$lambda$lambda($this$placeholderInCollection) {
    _init_properties_ComplexNotionEditors_kt__n53bvl();
    complexNotionTemplateCompletion($this$placeholderInCollection);
    return Unit_instance;
  }
  function complexNotionTemplateElementEditor$lambda_2($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function complexNotionTemplateElementEditor$lambda_3($this$editor) {
    _init_properties_ComplexNotionEditors_kt__n53bvl();
    // Inline function 'kotlin.apply' call
    textProperty_0($this$editor, '<text>', complexNotionTemplateElementEditor$lambda$lambda_0).b97().f2x(Companion_getInstance_210().v95_1);
    return Unit_instance;
  }
  function complexNotionTemplateElementEditor$lambda$lambda_0(it) {
    _init_properties_ComplexNotionEditors_kt__n53bvl();
    return it.o8w();
  }
  function complexNotionTemplateElementEditor$lambda_4($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function complexNotionTemplateElementEditor$lambda_5($this$editor) {
    _init_properties_ComplexNotionEditors_kt__n53bvl();
    var tmp2 = '<simple notion>';
    var tmp4 = Companion_getInstance_321().fg3_1;
    // Inline function 'jetbrains.biokb.lang.editorBuilders.btbReferenceTarget' call
    var referenceProvider = complexNotionTemplateElementEditor$lambda$lambda_1;
    var options = new CompletionOptions();
    var containerInit = complexNotionTemplateElementEditor$lambda$lambda_2;
    var textCellInit = complexNotionTemplateElementEditor$lambda$lambda_3;
    var tmp;
    if (null == null) {
      tmp = complexNotionTemplateElementEditor$lambda$lambda_4;
    } else {
      tmp = null;
    }
    var tmp10 = tmp;
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.references.referenceTarget' call
    var textCellInit_0 = complexNotionTemplateElementEditor$lambda$lambda_5(textCellInit);
    var targetClass = getKClass(ComplexNotionElement_1);
    referenceTarget($this$editor, targetClass, tmp2, tmp4, referenceProvider, null, tmp10, options, containerInit, textCellInit_0);
    return Unit_instance;
  }
  function complexNotionTemplateElementEditor$lambda$lambda_1(it) {
    _init_properties_ComplexNotionEditors_kt__n53bvl();
    return it.gfq();
  }
  function complexNotionTemplateElementEditor$lambda$lambda_2(_this__u8e3s4) {
    _init_properties_ComplexNotionEditors_kt__n53bvl();
    return Unit_instance;
  }
  function complexNotionTemplateElementEditor$lambda$lambda_3(_this__u8e3s4) {
    _init_properties_ComplexNotionEditors_kt__n53bvl();
    return Unit_instance;
  }
  function complexNotionTemplateElementEditor$lambda$lambda_4(it) {
    _init_properties_ComplexNotionEditors_kt__n53bvl();
    return true;
  }
  function complexNotionTemplateElementEditor$lambda$lambda_5($textCellInit) {
    return function ($this$referenceTarget) {
      $textCellInit($this$referenceTarget);
      enableEagerCompletion($this$referenceTarget);
      return Unit_instance;
    };
  }
  function complexNotionTemplateElementEditor$lambda_6($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function complexNotionCompletion$lambda($this_complexNotionCompletion) {
    return function () {
      return ComplexNotion($this_complexNotionCompletion.l6z());
    };
  }
  function unknownValueMode$lambda(it) {
    _init_properties_ComplexNotionEditors_kt__n53bvl();
    return it === '? allowed' || it === '? not allowed';
  }
  function unknownValueMode$lambda_0($this$editableText) {
    _init_properties_ComplexNotionEditors_kt__n53bvl();
    if (get_internalConfig($this$editableText).acu()) {
      var tmp = $this$editableText.m6d().lfq().m5y();
      $this$editableText.l8b(syncOneWay(map_0(tmp, unknownValueModeText$ref()), $this$editableText.qd0().o8w()));
    } else {
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.textCellSyncTwoWay' call
      var sourceProp = $this$editableText.m6d().lfq();
      var tmp_0 = $this$editableText.qd0().o8w();
      var tmp_1 = unknownValueMode$lambda$lambda;
      var targetProp = map_1(tmp_0, tmp_1, unknownValueModeText$ref_0());
      $this$editableText.l8b(syncTwoWay(sourceProp.m5y(), targetProp));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.attachCompletion' call
      addTraitOnAttach_0($this$editableText, unknownValueMode$lambda$lambda_0);
    }
    return Unit_instance;
  }
  function unknownValueModeText$ref() {
    var l = function (p0) {
      return unknownValueModeText(p0);
    };
    l.callableName = 'unknownValueModeText';
    return l;
  }
  function unknownValueMode$lambda$lambda(it) {
    _init_properties_ComplexNotionEditors_kt__n53bvl();
    return it === '? allowed';
  }
  function unknownValueModeText$ref_0() {
    var l = function (p0) {
      return unknownValueModeText(p0);
    };
    l.callableName = 'unknownValueModeText';
    return l;
  }
  function unknownValueMode$lambda$lambda_0(source, cell, cellFinder) {
    _init_properties_ComplexNotionEditors_kt__n53bvl();
    // Inline function 'jetbrains.ocelot.projectional.cell.trait.propertyTrait' call
    var propSpec = Completion_getInstance().u9d_1;
    return new _no_name_provided__qut3iv_54(propSpec, source, cell, cellFinder);
  }
  function _no_name_provided__qut3iv_54($propSpec, $source, $cell, $cellFinder) {
    this.kua_1 = $propSpec;
    this.lua_1 = $source;
    this.mua_1 = $cell;
    this.nua_1 = $cellFinder;
    CellTrait.call(this);
  }
  protoOf(_no_name_provided__qut3iv_54).n91 = function (cell, spec) {
    var tmp;
    if (spec === this.kua_1) {
      this.lua_1;
      var tmp2 = this.mua_1;
      this.nua_1;
      tmp = CompletionSupplement_instance.o9p([unknownValueModeItem(tmp2, '? allowed', 'values may be written as ?'), unknownValueModeItem(tmp2, '? not allowed', 'only concrete values')]);
    } else {
      tmp = protoOf(CellTrait).n91.call(this, cell, spec);
    }
    return tmp;
  };
  function unknownValueMode$$inlined$forEach$1($unknownValueColor, $cell) {
    this.pua_1 = $unknownValueColor;
    this.qua_1 = $cell;
    DisposableSynchronizer.call(this);
  }
  protoOf(unknownValueMode$$inlined$forEach$1).s87 = function (ctx) {
    return PropertyBinding_instance.n30(this.pua_1, this.qua_1.b97());
  };
  function complexNotionTemplateCompletion$lambda($this_complexNotionTemplateCompletion) {
    return function () {
      return ComplexNotionTemplateTextElement($this_complexNotionTemplateCompletion.l6z());
    };
  }
  function complexNotionTemplateCompletion$lambda_0($this_complexNotionTemplateCompletion) {
    return function () {
      return ComplexNotionTemplateRefElement($this_complexNotionTemplateCompletion.l6z());
    };
  }
  function unknownValueModeItem$o$complete$lambda($cell, $mode) {
    return function () {
      $cell.o8w().d2x($mode);
      return Unit_instance;
    };
  }
  function unknownValueModeItem$1($mode, $hint, $cell) {
    this.vua_1 = $mode;
    this.wua_1 = $hint;
    this.xua_1 = $cell;
    SimpleCompletionItem.call(this, $mode);
  }
  protoOf(unknownValueModeItem$1).d9k = function () {
    return this.wua_1;
  };
  protoOf(unknownValueModeItem$1).s9m = function (text) {
    return unknownValueModeItem$o$complete$lambda(this.xua_1, this.vua_1);
  };
  function $renderElementValueCOROUTINE$(_this__u8e3s4, elementValue, elementName, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.vu6_1 = _this__u8e3s4;
    this.wu6_1 = elementValue;
    this.xu6_1 = elementName;
  }
  protoOf($renderElementValueCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 3;
            var tmp0_safe_receiver = this.wu6_1;
            if (tmp0_safe_receiver == null) {
              this.yu6_1 = null;
              this.f9_1 = 2;
              continue $sm;
            } else {
              this.f9_1 = 1;
              suspendResult = this.vu6_1.k60(tmp0_safe_receiver.gfq(), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            this.yu6_1 = suspendResult;
            this.f9_1 = 2;
            continue $sm;
          case 2:
            var tmp1_safe_receiver = this.yu6_1;
            if (tmp1_safe_receiver == null)
              null;
            else
              this.vu6_1.l60(tmp1_safe_receiver.y2());
            if (!(this.wu6_1 == null)) {
              var tmp_0 = getKClass(ComplexNotionElementValue_1);
              child_1(this.vu6_1, tmp_0, renderElementValue$lambda(this.wu6_1), VOID, VOID, VOID, VOID, VOID, false);
            } else {
              label_0(this.vu6_1, '<' + this.xu6_1 + '>').b97().f2x(Companion_getInstance_210().r95_1);
            }

            return Unit_instance;
          case 3:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 3) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  var properties_initialized_ComplexNotionEditors_kt_8vtwyr;
  function _init_properties_ComplexNotionEditors_kt__n53bvl() {
    if (!properties_initialized_ComplexNotionEditors_kt_8vtwyr) {
      properties_initialized_ComplexNotionEditors_kt_8vtwyr = true;
      preventBackspaceAtBeginningTrait = new preventBackspaceAtBeginningTrait$1();
    }
  }
  function get_customCellEditors() {
    _init_properties_CustomCellEditors_kt__adyc75();
    return customCellEditors;
  }
  var customCellEditors;
  function constantCustomCellStyle(_this__u8e3s4) {
    _init_properties_CustomCellEditors_kt__adyc75();
    // Inline function 'kotlin.apply' call
    _this__u8e3s4.d97().d2x(true);
    _this__u8e3s4.e97().d2x(true);
    return _this__u8e3s4;
  }
  function customCellEditors$lambda($this$editor) {
    _init_properties_CustomCellEditors_kt__adyc75();
    var tmp = getKClass(CustomCell);
    var tmp_0 = KProperty1;
    children_2($this$editor, tmp, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, getPropertyCallableRef('cells', 1, tmp_0, CustomEditor$_get_cells_$ref_phh77b_1(), null));
    return Unit_instance;
  }
  function CustomEditor$_get_cells_$ref_phh77b_1() {
    return function (p0) {
      return p0.ofq();
    };
  }
  function customCellEditors$lambda_0($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function customCellEditors$lambda_1(wrapperContext) {
    _init_properties_CustomCellEditors_kt__adyc75();
    return ConstantCustomCell(wrapperContext);
  }
  function customCellEditors$lambda_2($this$childrenRoleDefaults) {
    _init_properties_CustomCellEditors_kt__adyc75();
    var tmp = $this$childrenRoleDefaults.jcg(Companion_getInstance_322().ihf_1);
    $this$childrenRoleDefaults.gck(tmp, customCellEditors$lambda$lambda($this$childrenRoleDefaults));
    var tmp_0 = $this$childrenRoleDefaults.jcg(Companion_getInstance_323().vhj_1);
    $this$childrenRoleDefaults.gck(tmp_0, customCellEditors$lambda$lambda_0($this$childrenRoleDefaults));
    var tmp_1 = $this$childrenRoleDefaults.jcg(Companion_getInstance_324().agn_1);
    $this$childrenRoleDefaults.gck(tmp_1, customCellEditors$lambda$lambda_1($this$childrenRoleDefaults));
    $this$childrenRoleDefaults.bck('ConstantCustomCell', customCellEditors$lambda$lambda_2($this$childrenRoleDefaults));
    var tmp_2 = $this$childrenRoleDefaults.ack();
    var baseNode = (!(tmp_2 == null) ? isInterface(tmp_2, BTBNode) : false) ? tmp_2 : THROW_CCE();
    var parent = baseNode.bp();
    if (!(parent == null) ? isInterface(parent, ProcessDeclaration_1) : false) {
      $this$childrenRoleDefaults.bck('kind', customCellEditors$lambda$lambda_3($this$childrenRoleDefaults));
    } else {
      if (!(parent == null) ? isInterface(parent, FunctionDeclaration_1) : false) {
        $this$childrenRoleDefaults.bck('returnType', customCellEditors$lambda$lambda_4($this$childrenRoleDefaults));
        $this$childrenRoleDefaults.bck('cardinality', customCellEditors$lambda$lambda_5($this$childrenRoleDefaults));
      } else {
        throw IllegalStateException_init_$Create$_0('unknown: ' + toString_0(parent));
      }
    }
    if (isInterface(parent, DirectlyNamed)) {
      $this$childrenRoleDefaults.bck('name', customCellEditors$lambda$lambda_6($this$childrenRoleDefaults));
    }
    $this$childrenRoleDefaults.bck('properties', customCellEditors$lambda$lambda_7($this$childrenRoleDefaults));
    return Unit_instance;
  }
  function customCellEditors$lambda$lambda($this_childrenRoleDefaults) {
    return function (reference) {
      // Inline function 'kotlin.apply' call
      var this_0 = ProcessPropertyCustomCell($this_childrenRoleDefaults.l6z());
      this_0.q6q().b6p(reference);
      return this_0;
    };
  }
  function customCellEditors$lambda$lambda_0($this_childrenRoleDefaults) {
    return function (reference) {
      // Inline function 'kotlin.apply' call
      var this_0 = PropertyCustomCell($this_childrenRoleDefaults.l6z());
      this_0.q6q().b6p(reference);
      return this_0;
    };
  }
  function customCellEditors$lambda$lambda_1($this_childrenRoleDefaults) {
    return function (reference) {
      // Inline function 'kotlin.apply' call
      var this_0 = LinkCustomCell($this_childrenRoleDefaults.l6z());
      this_0.xa1().b6p(reference);
      return this_0;
    };
  }
  function customCellEditors$lambda$lambda_2($this_childrenRoleDefaults) {
    return function () {
      return ConstantCustomCell($this_childrenRoleDefaults.l6z());
    };
  }
  function customCellEditors$lambda$lambda_3($this_childrenRoleDefaults) {
    return function () {
      return KindCustomCell($this_childrenRoleDefaults.l6z());
    };
  }
  function customCellEditors$lambda$lambda_4($this_childrenRoleDefaults) {
    return function () {
      return ReturnTypeCustomCell($this_childrenRoleDefaults.l6z());
    };
  }
  function customCellEditors$lambda$lambda_5($this_childrenRoleDefaults) {
    return function () {
      return CardinalityCustomCell($this_childrenRoleDefaults.l6z());
    };
  }
  function customCellEditors$lambda$lambda_6($this_childrenRoleDefaults) {
    return function () {
      return DeclarationNameCustomCell($this_childrenRoleDefaults.l6z());
    };
  }
  function customCellEditors$lambda$lambda_7($this_childrenRoleDefaults) {
    return function () {
      return PropertiesCustomCell($this_childrenRoleDefaults.l6z());
    };
  }
  function customCellEditors$lambda_3($this$editor) {
    _init_properties_CustomCellEditors_kt__adyc75();
    var tmp = KProperty1;
    var tmp_0 = getPropertyCallableRef('text', 1, tmp, ConstantCustomCell$_get_text_$ref_as957e_1(), null);
    textProperty_0($this$editor, '<no text>', tmp_0, customCellEditors$lambda$lambda_8);
    return Unit_instance;
  }
  function ConstantCustomCell$_get_text_$ref_as957e_1() {
    return function (p0) {
      return p0.o8w();
    };
  }
  function customCellEditors$lambda$lambda_8($this$textProperty) {
    _init_properties_CustomCellEditors_kt__adyc75();
    constantCustomCellStyle($this$textProperty.qd0());
    return Unit_instance;
  }
  function customCellEditors$lambda_4($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function customCellEditors$lambda_5($this$editor) {
    _init_properties_CustomCellEditors_kt__adyc75();
    var tmp2 = '<property ref>';
    var tmp4 = Companion_getInstance_322().ihf_1;
    // Inline function 'jetbrains.biokb.lang.editorBuilders.btbReferenceTarget' call
    var referenceProvider = customCellEditors$lambda$lambda_9;
    var options = new CompletionOptions();
    var containerInit = customCellEditors$lambda$lambda_10;
    var textCellInit = customCellEditors$lambda$lambda_11;
    var tmp;
    if (null == null) {
      tmp = customCellEditors$lambda$lambda_12;
    } else {
      tmp = null;
    }
    var tmp10 = tmp;
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.references.referenceTarget' call
    var textCellInit_0 = customCellEditors$lambda$lambda_13(textCellInit);
    var targetClass = getKClass(ProcessProperty_1);
    referenceTarget($this$editor, targetClass, tmp2, tmp4, referenceProvider, null, tmp10, options, containerInit, textCellInit_0);
    return Unit_instance;
  }
  function customCellEditors$lambda$lambda_9(cell) {
    _init_properties_CustomCellEditors_kt__adyc75();
    return cell.q6q();
  }
  function customCellEditors$lambda$lambda_10(_this__u8e3s4) {
    _init_properties_CustomCellEditors_kt__adyc75();
    return Unit_instance;
  }
  function customCellEditors$lambda$lambda_11(_this__u8e3s4) {
    _init_properties_CustomCellEditors_kt__adyc75();
    return Unit_instance;
  }
  function customCellEditors$lambda$lambda_12(it) {
    _init_properties_CustomCellEditors_kt__adyc75();
    return true;
  }
  function customCellEditors$lambda$lambda_13($textCellInit) {
    return function ($this$referenceTarget) {
      $textCellInit($this$referenceTarget);
      enableEagerCompletion($this$referenceTarget);
      return Unit_instance;
    };
  }
  function customCellEditors$lambda_6($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function customCellEditors$lambda_7($this$editor) {
    _init_properties_CustomCellEditors_kt__adyc75();
    var tmp2 = '<property ref>';
    var tmp4 = Companion_getInstance_323().vhj_1;
    // Inline function 'jetbrains.biokb.lang.editorBuilders.btbReferenceTarget' call
    var referenceProvider = customCellEditors$lambda$lambda_14;
    var options = new CompletionOptions();
    var containerInit = customCellEditors$lambda$lambda_15;
    var textCellInit = customCellEditors$lambda$lambda_16;
    var tmp;
    if (null == null) {
      tmp = customCellEditors$lambda$lambda_17;
    } else {
      tmp = null;
    }
    var tmp10 = tmp;
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.references.referenceTarget' call
    var textCellInit_0 = customCellEditors$lambda$lambda_18(textCellInit);
    var targetClass = getKClass(AbstractProperty);
    referenceTarget($this$editor, targetClass, tmp2, tmp4, referenceProvider, null, tmp10, options, containerInit, textCellInit_0);
    return Unit_instance;
  }
  function customCellEditors$lambda$lambda_14(cell) {
    _init_properties_CustomCellEditors_kt__adyc75();
    return cell.q6q();
  }
  function customCellEditors$lambda$lambda_15(_this__u8e3s4) {
    _init_properties_CustomCellEditors_kt__adyc75();
    return Unit_instance;
  }
  function customCellEditors$lambda$lambda_16(_this__u8e3s4) {
    _init_properties_CustomCellEditors_kt__adyc75();
    return Unit_instance;
  }
  function customCellEditors$lambda$lambda_17(it) {
    _init_properties_CustomCellEditors_kt__adyc75();
    return true;
  }
  function customCellEditors$lambda$lambda_18($textCellInit) {
    return function ($this$referenceTarget) {
      $textCellInit($this$referenceTarget);
      enableEagerCompletion($this$referenceTarget);
      return Unit_instance;
    };
  }
  function customCellEditors$lambda_8($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function customCellEditors$lambda_9($this$editor) {
    _init_properties_CustomCellEditors_kt__adyc75();
    var tmp2 = '<link ref>';
    var tmp4 = Companion_getInstance_324().agn_1;
    // Inline function 'jetbrains.biokb.lang.editorBuilders.btbReferenceTarget' call
    var referenceProvider = customCellEditors$lambda$lambda_19;
    var options = new CompletionOptions();
    var containerInit = customCellEditors$lambda$lambda_20;
    var textCellInit = customCellEditors$lambda$lambda_21;
    var tmp;
    if (null == null) {
      tmp = customCellEditors$lambda$lambda_22;
    } else {
      tmp = null;
    }
    var tmp10 = tmp;
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.references.referenceTarget' call
    var textCellInit_0 = customCellEditors$lambda$lambda_23(textCellInit);
    var targetClass = getKClass(AbstractLink);
    referenceTarget($this$editor, targetClass, tmp2, tmp4, referenceProvider, null, tmp10, options, containerInit, textCellInit_0);
    return Unit_instance;
  }
  function customCellEditors$lambda$lambda_19(cell) {
    _init_properties_CustomCellEditors_kt__adyc75();
    return cell.xa1();
  }
  function customCellEditors$lambda$lambda_20(_this__u8e3s4) {
    _init_properties_CustomCellEditors_kt__adyc75();
    return Unit_instance;
  }
  function customCellEditors$lambda$lambda_21(_this__u8e3s4) {
    _init_properties_CustomCellEditors_kt__adyc75();
    return Unit_instance;
  }
  function customCellEditors$lambda$lambda_22(it) {
    _init_properties_CustomCellEditors_kt__adyc75();
    return true;
  }
  function customCellEditors$lambda$lambda_23($textCellInit) {
    return function ($this$referenceTarget) {
      $textCellInit($this$referenceTarget);
      enableEagerCompletion($this$referenceTarget);
      return Unit_instance;
    };
  }
  function customCellEditors$lambda_10($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function customCellEditors$lambda_11($this$editor) {
    _init_properties_CustomCellEditors_kt__adyc75();
    keyword_0($this$editor, 'return type');
    return Unit_instance;
  }
  function customCellEditors$lambda_12($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function customCellEditors$lambda_13($this$editor) {
    _init_properties_CustomCellEditors_kt__adyc75();
    keyword_0($this$editor, 'cardinality');
    return Unit_instance;
  }
  function customCellEditors$lambda_14($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function customCellEditors$lambda_15($this$editor) {
    _init_properties_CustomCellEditors_kt__adyc75();
    keyword_0($this$editor, 'kind');
    return Unit_instance;
  }
  function customCellEditors$lambda_16($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function customCellEditors$lambda_17($this$editor) {
    _init_properties_CustomCellEditors_kt__adyc75();
    keyword_0($this$editor, 'name');
    return Unit_instance;
  }
  function customCellEditors$lambda_18($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function customCellEditors$lambda_19($this$editor) {
    _init_properties_CustomCellEditors_kt__adyc75();
    keyword_0($this$editor, 'properties');
    return Unit_instance;
  }
  function customCellEditors$lambda_20($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  var properties_initialized_CustomCellEditors_kt_snfflp;
  function _init_properties_CustomCellEditors_kt__adyc75() {
    if (!properties_initialized_CustomCellEditors_kt_snfflp) {
      properties_initialized_CustomCellEditors_kt_snfflp = true;
      var tmp0 = childRoleDefaults('<editor>');
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init = customCellEditors$lambda;
      var triggerDependencies = emptyList();
      var tmp = getKClass(CustomEditor);
      var tmp_0 = new EditorDefinition(tmp, tmp0, null, false, true, triggerDependencies, customCellEditors$lambda_0(init));
      var tmp0_separator = separator(' ');
      var tmp2 = customCellEditors$lambda_1;
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
      var completionSupplier = customCellEditors$lambda_2;
      var tmp0_0 = new ChildrenRoleDefaults(getKClass(CustomCell), '<cells>', tmp2, tmp0_separator, completionSupplier, true);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_0 = customCellEditors$lambda_3;
      var triggerDependencies_0 = emptyList();
      var tmp_1 = getKClass(ConstantCustomCell_1);
      var tmp_2 = new EditorDefinition(tmp_1, null, null, false, true, triggerDependencies_0, customCellEditors$lambda_4(init_0));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_1 = customCellEditors$lambda_5;
      var triggerDependencies_1 = emptyList();
      var tmp_3 = getKClass(ProcessPropertyCustomCell_1);
      var tmp_4 = new EditorDefinition(tmp_3, null, null, false, true, triggerDependencies_1, customCellEditors$lambda_6(init_1));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_2 = customCellEditors$lambda_7;
      var triggerDependencies_2 = emptyList();
      var tmp_5 = getKClass(PropertyCustomCell_1);
      var tmp_6 = new EditorDefinition(tmp_5, null, null, false, true, triggerDependencies_2, customCellEditors$lambda_8(init_2));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_3 = customCellEditors$lambda_9;
      var triggerDependencies_3 = emptyList();
      var tmp_7 = getKClass(LinkCustomCell_1);
      var tmp_8 = new EditorDefinition(tmp_7, null, null, false, true, triggerDependencies_3, customCellEditors$lambda_10(init_3));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_4 = customCellEditors$lambda_11;
      var triggerDependencies_4 = emptyList();
      var tmp_9 = getKClass(ReturnTypeCustomCell_1);
      var tmp_10 = new EditorDefinition(tmp_9, null, null, false, true, triggerDependencies_4, customCellEditors$lambda_12(init_4));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_5 = customCellEditors$lambda_13;
      var triggerDependencies_5 = emptyList();
      var tmp_11 = getKClass(CardinalityCustomCell_1);
      var tmp_12 = new EditorDefinition(tmp_11, null, null, false, true, triggerDependencies_5, customCellEditors$lambda_14(init_5));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_6 = customCellEditors$lambda_15;
      var triggerDependencies_6 = emptyList();
      var tmp_13 = getKClass(KindCustomCell_1);
      var tmp_14 = new EditorDefinition(tmp_13, null, null, false, true, triggerDependencies_6, customCellEditors$lambda_16(init_6));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_7 = customCellEditors$lambda_17;
      var triggerDependencies_7 = emptyList();
      var tmp_15 = getKClass(DeclarationNameCustomCell_1);
      var tmp_16 = new EditorDefinition(tmp_15, null, null, false, true, triggerDependencies_7, customCellEditors$lambda_18(init_7));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_8 = customCellEditors$lambda_19;
      var triggerDependencies_8 = emptyList();
      var tmp_17 = getKClass(PropertiesCustomCell_1);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.hierarchyEditor' call
      var editorDefinitions = [tmp_2, tmp_4, tmp_6, tmp_8, tmp_10, tmp_12, tmp_14, tmp_16, new EditorDefinition(tmp_17, null, null, false, true, triggerDependencies_8, customCellEditors$lambda_20(init_8))];
      var tmp$ret$11 = new HierarchyEditorDefinition(getKClass(CustomCell), tmp0_0, toList(editorDefinitions));
      customCellEditors = listOf_0([tmp_0, tmp$ret$11]);
    }
  }
  function customEditor(_this__u8e3s4) {
    newLine_0(_this__u8e3s4);
    keyword_0(_this__u8e3s4, 'editor:');
    space_0(_this__u8e3s4);
    horizontal_0(_this__u8e3s4, customEditor$lambda);
    newLine_0(_this__u8e3s4);
    keyword_0(_this__u8e3s4, 'editor enabled:');
    space_0(_this__u8e3s4);
    booleanProperty(_this__u8e3s4, '<no>', customEditor$lambda_0);
  }
  function customEditor$lambda($this$horizontal) {
    var tmp = getKClass(CustomEditor);
    child_1($this$horizontal, tmp, customEditor$lambda$lambda);
    return Unit_instance;
  }
  function customEditor$lambda$lambda(bindingDeclaration) {
    return bindingDeclaration.sfp();
  }
  function customEditor$lambda_0(bindingDeclaration) {
    return bindingDeclaration.tfp();
  }
  function BTBEditorParts() {
    BTBEditorParts_instance = this;
    this.pu1_1 = new CellMark();
    this.qu1_1 = new CellMark();
  }
  var BTBEditorParts_instance;
  function BTBEditorParts_getInstance() {
    if (BTBEditorParts_instance == null)
      new BTBEditorParts();
    return BTBEditorParts_instance;
  }
  function get_extensionEditors() {
    _init_properties_ExtensionEditors_kt__buxyih();
    return extensionEditors;
  }
  var extensionEditors;
  function extensionEditors$lambda($this$editor) {
    _init_properties_ExtensionEditors_kt__buxyih();
    var tmp = getKClass(ExtensionDeclaration_1);
    children_2($this$editor, tmp, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, extensionEditors$lambda$lambda);
    return Unit_instance;
  }
  function extensionEditors$lambda$lambda(extensionLibrary) {
    _init_properties_ExtensionEditors_kt__buxyih();
    return extensionLibrary.ue2();
  }
  function extensionEditors$lambda_0($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function extensionEditors$lambda_1($this$editor) {
    _init_properties_ExtensionEditors_kt__buxyih();
    keyword_0($this$editor, 'extension');
    space_0($this$editor);
    textProperty_0($this$editor, '<name>', extensionEditors$lambda$lambda_0);
    space_0($this$editor);
    keyword_0($this$editor, 'for');
    space_0($this$editor);
    var tmp = getKClass(OntologyElementType_1);
    child_1($this$editor, tmp, extensionEditors$lambda$lambda_1);
    indent_0($this$editor, true, VOID, extensionEditors$lambda$lambda_2);
    return Unit_instance;
  }
  function extensionEditors$lambda$lambda_0(extensionDeclaration) {
    _init_properties_ExtensionEditors_kt__buxyih();
    return extensionDeclaration.y2();
  }
  function extensionEditors$lambda$lambda_1(extensionDeclaration) {
    _init_properties_ExtensionEditors_kt__buxyih();
    return extensionDeclaration.sfq();
  }
  function extensionEditors$lambda$lambda_2($this$indent) {
    _init_properties_ExtensionEditors_kt__buxyih();
    newLine_0($this$indent);
    var tmp = getKClass(FieldDeclaration_1);
    var tmp_0 = Layout_VERTICAL_getInstance();
    children_2($this$indent, tmp, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp_0, extensionEditors$lambda$lambda$lambda);
    return Unit_instance;
  }
  function extensionEditors$lambda$lambda$lambda(extensionDeclaration) {
    _init_properties_ExtensionEditors_kt__buxyih();
    return extensionDeclaration.rfq();
  }
  function extensionEditors$lambda_2($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function extensionEditors$lambda_3($this$childrenRoleDefaults) {
    _init_properties_ExtensionEditors_kt__buxyih();
    var tmp = editorString($this$childrenRoleDefaults, BTBEditorParts_getInstance().pu1_1);
    $this$childrenRoleDefaults.hck(tmp, extensionEditors$lambda$lambda_3($this$childrenRoleDefaults));
    return Unit_instance;
  }
  function extensionEditors$lambda$lambda_3($this_childrenRoleDefaults) {
    return function (name) {
      // Inline function 'kotlin.apply' call
      var this_0 = FieldDeclaration($this_childrenRoleDefaults.l6z());
      this_0.y2().f2x(name);
      return this_0;
    };
  }
  function extensionEditors$lambda_4($this$editor) {
    _init_properties_ExtensionEditors_kt__buxyih();
    // Inline function 'kotlin.apply' call
    var this_0 = textProperty_0($this$editor, '<name>', extensionEditors$lambda$lambda_4);
    mark_0(this_0, BTBEditorParts_getInstance().pu1_1);
    indentLabel_0($this$editor, ':', true);
    space_0($this$editor);
    var tmp = getKClass(OntologyElementType_1);
    child_1($this$editor, tmp, extensionEditors$lambda$lambda_5);
    space_0($this$editor);
    var tmp_0 = getKClass(Cardinality_1);
    child_1($this$editor, tmp_0, extensionEditors$lambda$lambda_6);
    ensureLastCaretPosition($this$editor);
    return Unit_instance;
  }
  function extensionEditors$lambda$lambda_4(fieldDeclaration) {
    _init_properties_ExtensionEditors_kt__buxyih();
    return fieldDeclaration.y2();
  }
  function extensionEditors$lambda$lambda_5(fieldDeclaration) {
    _init_properties_ExtensionEditors_kt__buxyih();
    return fieldDeclaration.sfq();
  }
  function extensionEditors$lambda$lambda_6(fieldDeclaration) {
    _init_properties_ExtensionEditors_kt__buxyih();
    return fieldDeclaration.dfr();
  }
  function extensionEditors$lambda_5($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  var properties_initialized_ExtensionEditors_kt_if1mgn;
  function _init_properties_ExtensionEditors_kt__buxyih() {
    if (!properties_initialized_ExtensionEditors_kt_if1mgn) {
      properties_initialized_ExtensionEditors_kt_if1mgn = true;
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init = extensionEditors$lambda;
      var triggerDependencies = emptyList();
      var tmp = getKClass(ExtensionLibrary_1);
      var tmp_0 = new EditorDefinition(tmp, null, null, false, true, triggerDependencies, extensionEditors$lambda_0(init));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
      var placeholderText = '<extension declarations>';
      var separator = get_defaultChildrenSeparator();
      var tmp0 = new ChildrenRoleDefaults(getKClass(ExtensionDeclaration_1), placeholderText, null, separator, null, true);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_0 = extensionEditors$lambda_1;
      var triggerDependencies_0 = emptyList();
      var tmp_1 = getKClass(ExtensionDeclaration_1);
      var tmp_2 = new EditorDefinition(tmp_1, tmp0, null, false, true, triggerDependencies_0, extensionEditors$lambda_2(init_0));
      var tmp0_0 = '<fields>';
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
      var completionSupplier = extensionEditors$lambda_3;
      var separator_0 = get_defaultChildrenSeparator();
      var tmp0_1 = new ChildrenRoleDefaults(getKClass(FieldDeclaration_1), tmp0_0, null, separator_0, completionSupplier, true);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_1 = extensionEditors$lambda_4;
      var triggerDependencies_1 = emptyList();
      var tmp_3 = getKClass(FieldDeclaration_1);
      var tmp$ret$4 = new EditorDefinition(tmp_3, tmp0_1, null, false, true, triggerDependencies_1, extensionEditors$lambda_5(init_1));
      extensionEditors = listOf_0([tmp_0, tmp_2, tmp$ret$4]);
    }
  }
  function get_factEditors() {
    _init_properties_FactEditors_kt__uuayug();
    return factEditors;
  }
  var factEditors;
  function factReferenceCompletion(_this__u8e3s4) {
    _init_properties_FactEditors_kt__uuayug();
    var tmp = _this__u8e3s4.jcg(Companion_getInstance_313().igb_1);
    _this__u8e3s4.gck(tmp, factReferenceCompletion$lambda(_this__u8e3s4));
  }
  function factEditors$lambda($this$editor) {
    _init_properties_FactEditors_kt__uuayug();
    var tmp = getKClass(Precondition);
    child_1($this$editor, tmp, factEditors$lambda$lambda);
    space_0($this$editor);
    textProperty_0($this$editor, '<no name>', factEditors$lambda$lambda_0);
    space_0($this$editor);
    var tmp_0 = getKClass(AbstractProcessSpecification);
    child_1($this$editor, tmp_0, factEditors$lambda$lambda_1);
    ensureLastCaretPosition($this$editor);
    return Unit_instance;
  }
  function factEditors$lambda$lambda(fact) {
    _init_properties_FactEditors_kt__uuayug();
    return fact.ufq();
  }
  function factEditors$lambda$lambda_0(fact) {
    _init_properties_FactEditors_kt__uuayug();
    return fact.y2();
  }
  function factEditors$lambda$lambda_1(fact) {
    _init_properties_FactEditors_kt__uuayug();
    return fact.vfq();
  }
  function factEditors$lambda_0($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function factEditors$lambda_1($this$childrenRoleDefaults) {
    _init_properties_FactEditors_kt__uuayug();
    factReferenceCompletion($this$childrenRoleDefaults);
    return Unit_instance;
  }
  function factEditors$lambda_2($this$editor) {
    _init_properties_FactEditors_kt__uuayug();
    var tmp4 = Companion_getInstance_313().igb_1;
    var tmp = KProperty1;
    var tmp6 = getPropertyCallableRef('ref', 1, tmp, FactReference$_get_ref_$ref_yrgsjs_1(), null);
    // Inline function 'jetbrains.biokb.lang.editorBuilders.btbReferenceTarget' call
    var options = new CompletionOptions(VOID, false);
    var containerInit = factEditors$lambda$lambda_2;
    var textCellInit = factEditors$lambda$lambda_3;
    var tmp_0;
    if (null == null) {
      tmp_0 = factEditors$lambda$lambda_4;
    } else {
      tmp_0 = null;
    }
    var tmp10 = tmp_0;
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.references.referenceTarget' call
    var textCellInit_0 = factEditors$lambda$lambda_5(textCellInit);
    var targetClass = getKClass(Fact_1);
    var refCell = referenceTarget($this$editor, targetClass, '<fact>', tmp4, tmp6, null, tmp10, options, containerInit, textCellInit_0);
    considerEmptyBy($this$editor, refCell);
    deleteIfEmpty($this$editor);
    return Unit_instance;
  }
  function FactReference$_get_ref_$ref_yrgsjs_1() {
    return function (p0) {
      return p0.yfq();
    };
  }
  function factEditors$lambda$lambda_2(_this__u8e3s4) {
    _init_properties_FactEditors_kt__uuayug();
    return Unit_instance;
  }
  function factEditors$lambda$lambda_3(_this__u8e3s4) {
    _init_properties_FactEditors_kt__uuayug();
    return Unit_instance;
  }
  function factEditors$lambda$lambda_4(it) {
    _init_properties_FactEditors_kt__uuayug();
    return true;
  }
  function factEditors$lambda$lambda_5($textCellInit) {
    return function ($this$referenceTarget) {
      $textCellInit($this$referenceTarget);
      enableEagerCompletion($this$referenceTarget);
      return Unit_instance;
    };
  }
  function factEditors$lambda_3($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function factEditors$lambda_4($this$childRoleDefaults) {
    _init_properties_FactEditors_kt__uuayug();
    $this$childRoleDefaults.bck('ALWAYS', factEditors$lambda$lambda_6($this$childRoleDefaults));
    $this$childRoleDefaults.bck('NEVER', factEditors$lambda$lambda_7($this$childRoleDefaults));
    var tmp = $this$childRoleDefaults.ick(factEditors$lambda$lambda_8);
    $this$childRoleDefaults.jck(tmp, factEditors$lambda$lambda_9($this$childRoleDefaults));
    return Unit_instance;
  }
  function factEditors$lambda$lambda_6($this_childRoleDefaults) {
    return function () {
      return ConstantPrecondition_1($this_childRoleDefaults.l6z(), When_ALWAYS_getInstance());
    };
  }
  function factEditors$lambda$lambda_7($this_childRoleDefaults) {
    return function () {
      return ConstantPrecondition_1($this_childRoleDefaults.l6z(), When_NEVER_getInstance());
    };
  }
  function factEditors$lambda$lambda_8($this$using) {
    _init_properties_FactEditors_kt__uuayug();
    factReferenceCompletion($this$using);
    return Unit_instance;
  }
  function factEditors$lambda$lambda_9($this_childRoleDefaults) {
    return function (factReference) {
      // Inline function 'kotlin.apply' call
      var this_0 = FactPrecondition($this_childRoleDefaults.l6z());
      this_0.wfq().j(factReference);
      return this_0;
    };
  }
  function factEditors$lambda_5(wrapperContext) {
    _init_properties_FactEditors_kt__uuayug();
    return ConstantPrecondition_1(wrapperContext, When_ALWAYS_getInstance());
  }
  function factEditors$lambda_6($this$editor) {
    _init_properties_FactEditors_kt__uuayug();
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.enumProperty' call
    var placeholder = '<no kind>';
    var enumCell = editableText_0($this$editor, VOID, placeholder, VOID, VOID, factEditors$lambda$lambda_10);
    considerEmptyBy($this$editor, enumCell);
    deleteIfEmpty($this$editor);
    return Unit_instance;
  }
  function factEditors$lambda$lambda_10($this$editableText) {
    _init_properties_FactEditors_kt__uuayug();
    switch (get_internalConfig($this$editableText).nd0().uct_1.x2_1) {
      case 0:
        // Inline function 'jetbrains.ocelot.langDef.editorBuilder.enumSyncTwoWay' call

        var targetPropFactory = factEditors$lambda$lambda$lambda;
        // Inline function 'jetbrains.ocelot.langDef.editorBuilder.textCellSyncTwoWay' call

        var sourceProp = $this$editableText.m6d().r5a();
        var targetProp = targetPropFactory($this$editableText.qd0());
        $this$editableText.l8b(syncTwoWay(sourceProp.m5y(), targetProp));
        break;
      case 1:
        // Inline function 'jetbrains.ocelot.langDef.editorBuilder.enumSyncTwoWay' call

        var targetPropFactory_0 = factEditors$lambda$lambda$lambda_0;
        // Inline function 'jetbrains.ocelot.langDef.editorBuilder.textCellSyncTwoWay' call

        var sourceProp_0 = $this$editableText.m6d().r5a();
        var targetProp_0 = targetPropFactory_0($this$editableText.qd0());
        $this$editableText.l8b(syncTwoWay(sourceProp_0.m5y(), targetProp_0));
        break;
      default:
        var tmp = $this$editableText.qd0().o8w();
        var tmp1_safe_receiver = $this$editableText.m6d().r5a().m5y().w2w();
        var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.toString();
        tmp.f2x(tmp2_elvis_lhs == null ? '' : tmp2_elvis_lhs);
        break;
    }
    return Unit_instance;
  }
  function factEditors$lambda$lambda$lambda(textCell) {
    _init_properties_FactEditors_kt__uuayug();
    // Inline function 'jetbrains.ocelot.base.enums.EnumInfoFactory.createEnumInfo' call
    // Inline function 'kotlin.enumValues' call
    var tmp$ret$0 = values_12();
    var enumInfo = new EnumInfoImpl(tmp$ret$0);
    return ValueEditors_instance.uag(textCell, enumInfo);
  }
  function factEditors$lambda$lambda$lambda_0(textCell) {
    _init_properties_FactEditors_kt__uuayug();
    // Inline function 'jetbrains.ocelot.base.enums.EnumInfoFactory.createEnumInfo' call
    // Inline function 'kotlin.enumValues' call
    var tmp$ret$0 = values_12();
    var enumInfo = new EnumInfoImpl(tmp$ret$0);
    return ValueEditors_instance.uag(textCell, enumInfo);
  }
  function factEditors$lambda_7($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function factEditors$lambda_8($this$editor) {
    _init_properties_FactEditors_kt__uuayug();
    indent_0($this$editor, VOID, VOID, factEditors$lambda$lambda_11);
    return Unit_instance;
  }
  function factEditors$lambda$lambda_11($this$indent) {
    _init_properties_FactEditors_kt__uuayug();
    var tmp = getKClass(FactReference_1);
    var tmp_0 = separator('&', true);
    children_2($this$indent, tmp, VOID, VOID, VOID, tmp_0, VOID, VOID, VOID, VOID, factEditors$lambda$lambda$lambda_1);
    space_0($this$indent);
    var tmp4 = Companion_getInstance_314().hgb_1;
    var tmp_1 = KProperty1;
    var tmp6 = getPropertyCallableRef('relation', 1, tmp_1, FactPrecondition$_get_relation_$ref_m111b2_1(), null);
    var tmp_2 = KProperty1;
    // Inline function 'jetbrains.biokb.lang.editorBuilders.btbReferenceTarget' call
    var referencedPropertySupplier = getPropertyCallableRef('symbol', 1, tmp_2, ProcessRelationDeclaration$_get_symbol_$ref_emzgvd_1(), null);
    var options = new CompletionOptions();
    var containerInit = factEditors$lambda$lambda$lambda_2;
    var textCellInit = factEditors$lambda$lambda$lambda_3;
    var tmp_3;
    if (null == null) {
      tmp_3 = factEditors$lambda$lambda$lambda_4;
    } else {
      tmp_3 = null;
    }
    var tmp10 = tmp_3;
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.references.referenceTarget' call
    var textCellInit_0 = factEditors$lambda$lambda$lambda_5(textCellInit);
    var targetClass = getKClass(ProcessRelationDeclaration_1);
    referenceTarget($this$indent, targetClass, '?->', tmp4, tmp6, referencedPropertySupplier, tmp10, options, containerInit, textCellInit_0);
    return Unit_instance;
  }
  function factEditors$lambda$lambda$lambda_1(factPrecondition) {
    _init_properties_FactEditors_kt__uuayug();
    return factPrecondition.wfq();
  }
  function FactPrecondition$_get_relation_$ref_m111b2_1() {
    return function (p0) {
      return p0.xfq();
    };
  }
  function ProcessRelationDeclaration$_get_symbol_$ref_emzgvd_1() {
    return function (p0) {
      return p0.zft();
    };
  }
  function factEditors$lambda$lambda$lambda_2(_this__u8e3s4) {
    _init_properties_FactEditors_kt__uuayug();
    return Unit_instance;
  }
  function factEditors$lambda$lambda$lambda_3(_this__u8e3s4) {
    _init_properties_FactEditors_kt__uuayug();
    return Unit_instance;
  }
  function factEditors$lambda$lambda$lambda_4(it) {
    _init_properties_FactEditors_kt__uuayug();
    return true;
  }
  function factEditors$lambda$lambda$lambda_5($textCellInit) {
    return function ($this$referenceTarget) {
      $textCellInit($this$referenceTarget);
      enableEagerCompletion($this$referenceTarget);
      return Unit_instance;
    };
  }
  function factEditors$lambda_9($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function factReferenceCompletion$lambda($this_factReferenceCompletion) {
    return function (reference) {
      return FactReference_2($this_factReferenceCompletion.l6z(), reference);
    };
  }
  var properties_initialized_FactEditors_kt_y03w3a;
  function _init_properties_FactEditors_kt__uuayug() {
    if (!properties_initialized_FactEditors_kt_y03w3a) {
      properties_initialized_FactEditors_kt_y03w3a = true;
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
      var separator = get_defaultChildrenSeparator();
      var tmp0 = new ChildrenRoleDefaults(getKClass(Fact_1), '<facts>', null, separator, null, true);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init = factEditors$lambda;
      var triggerDependencies = emptyList();
      var tmp = getKClass(Fact_1);
      var tmp_0 = new EditorDefinition(tmp, tmp0, null, false, true, triggerDependencies, factEditors$lambda_0(init));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
      var completionSupplier = factEditors$lambda_1;
      var separator_0 = get_defaultChildrenSeparator();
      var tmp0_0 = new ChildrenRoleDefaults(getKClass(FactReference_1), '<facts>', null, separator_0, completionSupplier, true);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_0 = factEditors$lambda_2;
      var triggerDependencies_0 = emptyList();
      var tmp_1 = getKClass(FactReference_1);
      var tmp_2 = new EditorDefinition(tmp_1, tmp0_0, null, false, true, triggerDependencies_0, factEditors$lambda_3(init_0));
      var tmp_3 = factEditors$lambda_4;
      var tmp0_1 = childRoleDefaults('_', tmp_3, factEditors$lambda_5);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_1 = factEditors$lambda_6;
      var triggerDependencies_1 = emptyList();
      var tmp_4 = getKClass(ConstantPrecondition_0);
      var tmp_5 = new EditorDefinition(tmp_4, null, null, false, true, triggerDependencies_1, factEditors$lambda_7(init_1));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_2 = factEditors$lambda_8;
      var triggerDependencies_2 = emptyList();
      var tmp_6 = getKClass(FactPrecondition_1);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.hierarchyEditor' call
      var editorDefinitions = [tmp_5, new EditorDefinition(tmp_6, null, null, false, true, triggerDependencies_2, factEditors$lambda_9(init_2))];
      var tmp$ret$6 = new HierarchyEditorDefinition(getKClass(Precondition), tmp0_1, toList(editorDefinitions));
      factEditors = listOf_0([tmp_0, tmp_2, tmp$ret$6]);
    }
  }
  function addFactSelection(_this__u8e3s4) {
    if (!get_supportFactSelection(_this__u8e3s4))
      return Unit_instance;
    var hover = new ValueProperty(false);
    var selected = new ValueProperty(false);
    var factSelection = new FactSelectionToggle(get_stringId(_this__u8e3s4.m6d()), hover, selected);
    _this__u8e3s4.qd0().w92(factSelection.cub_1);
    var showIcon = Properties_getInstance().c2y([hover, selected]);
    var img = map_0(showIcon, addFactSelection$lambda(_this__u8e3s4));
    var imageCell = image(_this__u8e3s4, img);
    imageCell.w92(factSelection.bub_1);
    var tmp = PropertyBinding_instance;
    tmp.n30(map_0(selected, addFactSelection$lambda_0(_this__u8e3s4)), get_background(_this__u8e3s4.qd0()));
    space_0(_this__u8e3s4);
  }
  function addFactSelection$lambda($this_addFactSelection) {
    return function (it) {
      return it ? get_uiConfig($this_addFactSelection).vu0_1 : get_uiConfig($this_addFactSelection).wu0_1;
    };
  }
  function addFactSelection$lambda_0($this_addFactSelection) {
    return function (it) {
      return it ? get_uiConfig($this_addFactSelection).uu0_1 : null;
    };
  }
  function get_functionLibraryEditors() {
    _init_properties_FunctionLibraryEditors_kt__fllry5();
    return functionLibraryEditors;
  }
  var functionLibraryEditors;
  function cardinalityConstantCompletion_0(_this__u8e3s4) {
    _init_properties_FunctionLibraryEditors_kt__fllry5();
    var tmp = _this__u8e3s4.rci();
    _this__u8e3s4.fck(tmp, cardinalityConstantCompletion$lambda_0(_this__u8e3s4));
  }
  function functionLibraryEditors$lambda($this$editor) {
    _init_properties_FunctionLibraryEditors_kt__fllry5();
    var tmp = getKClass(FunctionDeclaration_1);
    children_2($this$editor, tmp, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, functionLibraryEditors$lambda$lambda);
    return Unit_instance;
  }
  function functionLibraryEditors$lambda$lambda(functionLibrary) {
    _init_properties_FunctionLibraryEditors_kt__fllry5();
    return functionLibrary.hfr();
  }
  function functionLibraryEditors$lambda_0($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function functionLibraryEditors$lambda_1($this$editor) {
    _init_properties_FunctionLibraryEditors_kt__fllry5();
    commentEditor($this$editor);
    newLine_0($this$editor);
    keyword_0($this$editor, 'function');
    space_0($this$editor);
    textProperty_0($this$editor, '<name>', functionLibraryEditors$lambda$lambda_0);
    indent_0($this$editor, true, VOID, functionLibraryEditors$lambda$lambda_1);
    return Unit_instance;
  }
  function functionLibraryEditors$lambda$lambda_0(functionDeclaration) {
    _init_properties_FunctionLibraryEditors_kt__fllry5();
    return functionDeclaration.y2();
  }
  function functionLibraryEditors$lambda$lambda_1($this$indent) {
    _init_properties_FunctionLibraryEditors_kt__fllry5();
    newLine_0($this$indent);
    keyword_0($this$indent, 'parameters:');
    space_0($this$indent);
    horizontal_0($this$indent, functionLibraryEditors$lambda$lambda$lambda);
    newLine_0($this$indent);
    newLine_0($this$indent);
    get_background(keyword_0($this$indent, 'old parameters:')).f2x(Companion_getInstance_210().q95_1);
    space_0($this$indent);
    get_background(horizontal_0($this$indent, functionLibraryEditors$lambda$lambda$lambda_0)).f2x(Companion_getInstance_210().q95_1);
    newLine_0($this$indent);
    newLine_0($this$indent);
    keyword_0($this$indent, 'returns');
    space_0($this$indent);
    var tmp = getKClass(OntologyElementType_1);
    child_1($this$indent, tmp, functionLibraryEditors$lambda$lambda$lambda_1);
    space_0($this$indent);
    var tmp_0 = getKClass(Cardinality_1);
    child_1($this$indent, tmp_0, functionLibraryEditors$lambda$lambda$lambda_2);
    newLine_0($this$indent);
    customEditor($this$indent);
    return Unit_instance;
  }
  function functionLibraryEditors$lambda$lambda$lambda($this$horizontal) {
    _init_properties_FunctionLibraryEditors_kt__fllry5();
    var tmp = getKClass(ProcessProperty_1);
    var tmp_0 = Layout_VERTICAL_getInstance();
    children_2($this$horizontal, tmp, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp_0, functionLibraryEditors$lambda$lambda$lambda$lambda);
    return Unit_instance;
  }
  function functionLibraryEditors$lambda$lambda$lambda$lambda(functionDeclaration) {
    _init_properties_FunctionLibraryEditors_kt__fllry5();
    return functionDeclaration.rfp();
  }
  function functionLibraryEditors$lambda$lambda$lambda_0($this$horizontal) {
    _init_properties_FunctionLibraryEditors_kt__fllry5();
    var tmp = getKClass(AbstractBindingEntry);
    var tmp_0 = Layout_VERTICAL_getInstance();
    children_2($this$horizontal, tmp, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp_0, functionLibraryEditors$lambda$lambda$lambda$lambda_0);
    return Unit_instance;
  }
  function functionLibraryEditors$lambda$lambda$lambda$lambda_0(functionDeclaration) {
    _init_properties_FunctionLibraryEditors_kt__fllry5();
    return functionDeclaration.y();
  }
  function functionLibraryEditors$lambda$lambda$lambda_1(functionDeclaration) {
    _init_properties_FunctionLibraryEditors_kt__fllry5();
    return functionDeclaration.gfr();
  }
  function functionLibraryEditors$lambda$lambda$lambda_2(functionDeclaration) {
    _init_properties_FunctionLibraryEditors_kt__fllry5();
    return functionDeclaration.dfr();
  }
  function functionLibraryEditors$lambda_2($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function functionLibraryEditors$lambda_3($this$editor) {
    _init_properties_FunctionLibraryEditors_kt__fllry5();
    var tmp = getKClass(CardinalityBound);
    child_1($this$editor, tmp, functionLibraryEditors$lambda$lambda_2);
    return Unit_instance;
  }
  function functionLibraryEditors$lambda$lambda_2(it) {
    _init_properties_FunctionLibraryEditors_kt__fllry5();
    return it.efq();
  }
  function functionLibraryEditors$lambda_4($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function functionLibraryEditors$lambda_5($this$childRoleDefaults) {
    _init_properties_FunctionLibraryEditors_kt__fllry5();
    $this$childRoleDefaults.bck('[', functionLibraryEditors$lambda$lambda_3($this$childRoleDefaults));
    return Unit_instance;
  }
  function functionLibraryEditors$lambda$lambda_3($this_childRoleDefaults) {
    return function () {
      return Cardinality($this_childRoleDefaults.l6z());
    };
  }
  function functionLibraryEditors$lambda_6($this$editor) {
    _init_properties_FunctionLibraryEditors_kt__fllry5();
    indentLabel_0($this$editor, '[');
    var tmp = getKClass(CardinalityBoundConstant_1);
    var lowerBoundCell = child_1($this$editor, tmp, functionLibraryEditors$lambda$lambda_4);
    var opt = indent_0($this$editor, VOID, VOID, functionLibraryEditors$lambda$lambda_5(lowerBoundCell));
    // Inline function 'jetbrains.ocelot.mapper.core.Synchronizers.forDisposable' call
    var tmp$ret$0 = new functionLibraryEditors$10$$inlined$forDisposable$1($this$editor, opt);
    $this$editor.l8b(tmp$ret$0);
    indentLabel_0($this$editor, ']', true);
    return Unit_instance;
  }
  function functionLibraryEditors$lambda$lambda_4(cardinality) {
    _init_properties_FunctionLibraryEditors_kt__fllry5();
    return cardinality.bfq();
  }
  function functionLibraryEditors$lambda$lambda$lambda_3(cardinality) {
    _init_properties_FunctionLibraryEditors_kt__fllry5();
    return cardinality.cfq();
  }
  function functionLibraryEditors$lambda$lambda_5($lowerBoundCell) {
    return function ($this$indent) {
      indentLabel_0($this$indent, '..');
      var tmp = getKClass(CardinalityBoundPlaceholder_1);
      child_1($this$indent, tmp, functionLibraryEditors$lambda$lambda$lambda_3, VOID, VOID, VOID, VOID, toLastFocusable($lowerBoundCell));
      return Unit_instance;
    };
  }
  function functionLibraryEditors$10$$inlined$forDisposable$1($this_editor, $opt) {
    this.eub_1 = $this_editor;
    this.fub_1 = $opt;
    DisposableSynchronizer.call(this);
  }
  protoOf(functionLibraryEditors$10$$inlined$forDisposable$1).s87 = function (ctx) {
    return PropertyBinding_instance.n30(not(isNull(this.eub_1.m6d().cfq().m5y())), this.fub_1.m92());
  };
  function functionLibraryEditors$lambda_7($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function functionLibraryEditors$lambda_8($this$childRoleDefaults) {
    _init_properties_FunctionLibraryEditors_kt__fllry5();
    $this$childRoleDefaults.bck('n', functionLibraryEditors$lambda$lambda_6($this$childRoleDefaults));
    cardinalityConstantCompletion_0($this$childRoleDefaults);
    return Unit_instance;
  }
  function functionLibraryEditors$lambda$lambda_6($this_childRoleDefaults) {
    return function () {
      return CardinalityBoundN($this_childRoleDefaults.l6z());
    };
  }
  function functionLibraryEditors$lambda_9($this$childRoleDefaults) {
    _init_properties_FunctionLibraryEditors_kt__fllry5();
    cardinalityConstantCompletion_0($this$childRoleDefaults);
    return Unit_instance;
  }
  function functionLibraryEditors$lambda_10($this$editor) {
    _init_properties_FunctionLibraryEditors_kt__fllry5();
    indent_0($this$editor, VOID, VOID, functionLibraryEditors$lambda$lambda_7);
    return Unit_instance;
  }
  function functionLibraryEditors$lambda$lambda_7($this$indent) {
    _init_properties_FunctionLibraryEditors_kt__fllry5();
    var boundCell = integerProperty_0($this$indent, '<...>', functionLibraryEditors$lambda$lambda$lambda_4);
    rightTransform_1($this$indent, boundCell, functionLibraryEditors$lambda$lambda$lambda_5($this$indent));
    return Unit_instance;
  }
  function functionLibraryEditors$lambda$lambda$lambda_4(boundConstant) {
    _init_properties_FunctionLibraryEditors_kt__fllry5();
    return boundConstant.a1();
  }
  function functionLibraryEditors$lambda$lambda$lambda$lambda_1($this_indent, $cardinality, $cellFinder) {
    return function () {
      var upperBound = CardinalityBoundPlaceholder(get_internalConfig($this_indent).l6z());
      $cardinality.cfq().d2x(upperBound);
      var tmp0_safe_receiver = firstOrNull_0($cellFinder.lah(upperBound));
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.c93(ProjectionalSynchronizers_getInstance().d99_1);
      return tmp1_elvis_lhs == null ? get_EMPTY_CELL_ACTION() : tmp1_elvis_lhs;
    };
  }
  function functionLibraryEditors$lambda$lambda$lambda_5($this_indent) {
    return function ($this$completion, boundNode, _unused_var__etf5q3, cellFinder) {
      var tmp = boundNode.bp();
      var tmp0_elvis_lhs = (!(tmp == null) ? isInterface(tmp, Cardinality_1) : false) ? tmp : null;
      var tmp_0;
      if (tmp0_elvis_lhs == null) {
        return Unit_instance;
      } else {
        tmp_0 = tmp0_elvis_lhs;
      }
      var cardinality = tmp_0;
      var tmp_1;
      if (boundNode === cardinality.bfq().m5y().w2w() && cardinality.cfq().m5y().w2w() == null) {
        $this$completion.gcg('..', functionLibraryEditors$lambda$lambda$lambda$lambda_1($this_indent, cardinality, cellFinder));
        tmp_1 = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function functionLibraryEditors$lambda_11($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function functionLibraryEditors$lambda_12($this$editor) {
    _init_properties_FunctionLibraryEditors_kt__fllry5();
    keyword_0($this$editor, 'n');
    return Unit_instance;
  }
  function functionLibraryEditors$lambda_13($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function cardinalityConstantCompletion$lambda_0($this_cardinalityConstantCompletion) {
    return function (number) {
      // Inline function 'kotlin.apply' call
      var this_0 = CardinalityBoundConstant($this_cardinalityConstantCompletion.l6z());
      this_0.a1().d2x(number);
      return this_0;
    };
  }
  var properties_initialized_FunctionLibraryEditors_kt_o8truj;
  function _init_properties_FunctionLibraryEditors_kt__fllry5() {
    if (!properties_initialized_FunctionLibraryEditors_kt_o8truj) {
      properties_initialized_FunctionLibraryEditors_kt_o8truj = true;
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init = functionLibraryEditors$lambda;
      var triggerDependencies = emptyList();
      var tmp = getKClass(FunctionLibrary_1);
      var tmp_0 = new EditorDefinition(tmp, null, null, false, true, triggerDependencies, functionLibraryEditors$lambda_0(init));
      var tmp0 = '<function declarations>';
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
      var separator = blankLine();
      var tmp0_0 = new ChildrenRoleDefaults(getKClass(FunctionDeclaration_1), tmp0, null, separator, null, true);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_0 = functionLibraryEditors$lambda_1;
      var triggerDependencies_0 = emptyList();
      var tmp_1 = getKClass(FunctionDeclaration_1);
      var tmp_2 = new EditorDefinition(tmp_1, tmp0_0, null, false, true, triggerDependencies_0, functionLibraryEditors$lambda_2(init_0));
      var tmp0_1 = childRoleDefaults();
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_1 = functionLibraryEditors$lambda_3;
      var triggerDependencies_1 = emptyList();
      var tmp_3 = getKClass(CardinalityBoundPlaceholder_1);
      var tmp_4 = new EditorDefinition(tmp_3, tmp0_1, null, false, true, triggerDependencies_1, functionLibraryEditors$lambda_4(init_1));
      var tmp0_2 = childRoleDefaults('<cardinality>', functionLibraryEditors$lambda_5);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_2 = functionLibraryEditors$lambda_6;
      var triggerDependencies_2 = emptyList();
      var tmp_5 = getKClass(Cardinality_1);
      var tmp_6 = new EditorDefinition(tmp_5, tmp0_2, null, false, true, triggerDependencies_2, functionLibraryEditors$lambda_7(init_2));
      var tmp0_3 = childRoleDefaults('<bound>', functionLibraryEditors$lambda_8);
      var tmp0_4 = childRoleDefaults('<bound>', functionLibraryEditors$lambda_9);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_3 = functionLibraryEditors$lambda_10;
      var triggerDependencies_3 = emptyList();
      var tmp_7 = getKClass(CardinalityBoundConstant_1);
      var tmp_8 = new EditorDefinition(tmp_7, tmp0_4, null, false, true, triggerDependencies_3, functionLibraryEditors$lambda_11(init_3));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_4 = functionLibraryEditors$lambda_12;
      var triggerDependencies_4 = emptyList();
      var tmp_9 = getKClass(CardinalityBoundN_1);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.hierarchyEditor' call
      var editorDefinitions = [tmp_8, new EditorDefinition(tmp_9, null, null, false, true, triggerDependencies_4, functionLibraryEditors$lambda_13(init_4))];
      var tmp$ret$7 = new HierarchyEditorDefinition(getKClass(CardinalityBound), tmp0_3, toList(editorDefinitions));
      functionLibraryEditors = listOf_0([tmp_0, tmp_2, tmp_4, tmp_6, tmp$ret$7]);
    }
  }
  function get_knowledgeSourceReferenceEditors() {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    return knowledgeSourceReferenceEditors;
  }
  var knowledgeSourceReferenceEditors;
  function get_knowledgeSourceEditors() {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    return knowledgeSourceEditors;
  }
  var knowledgeSourceEditors;
  function get_PubMedIdUrlHandler() {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    return PubMedIdUrlHandler;
  }
  var PubMedIdUrlHandler;
  function get_PMCIdUrlHandler() {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    return PMCIdUrlHandler;
  }
  var PMCIdUrlHandler;
  function knowledgeSources(_this__u8e3s4) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    var tmp2 = getKClass(KnowledgeSourceReference);
    var tmp = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.children' call
    var childrenProperty = getPropertyCallableRef('sources', 1, tmp, HasKnowledgeSources$_get_sources_$ref_6mibyw_1(), null);
    var placeholderTraitFactory = knowledgeSources$lambda;
    var layout = Layout_INDENT_getInstance();
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp_0 = new MultipleChildLink(getKClass(HasKnowledgeSources), childrenProperty);
    children_2(_this__u8e3s4, tmp2, tmp_0, null, placeholderTraitFactory, null, null, null, null, layout, knowledgeSources$lambda_0(childrenProperty));
  }
  function knowledgeSourceReferenceCompletion(_this__u8e3s4) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    _this__u8e3s4.bck('url', knowledgeSourceReferenceCompletion$lambda(_this__u8e3s4));
    _this__u8e3s4.bck('PubMed', knowledgeSourceReferenceCompletion$lambda_0(_this__u8e3s4));
    _this__u8e3s4.bck('published', knowledgeSourceReferenceCompletion$lambda_1(_this__u8e3s4));
  }
  function PrefixedURLTrait(urlPrefix) {
    BaseDerivedCellTrait.call(this, URLHandler_getInstance());
    this.hub_1 = urlPrefix;
  }
  protoOf(PrefixedURLTrait).n91 = function (cell, spec) {
    var tmp;
    var tmp_0;
    if (cell instanceof TextCell) {
      tmp_0 = equals(spec, Companion_getInstance_196().xaf_1);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.hub_1 + cell.o8w().w2w();
    } else {
      tmp = protoOf(BaseDerivedCellTrait).n91.call(this, cell, spec);
    }
    return tmp;
  };
  function addImportFromPubMedAction(_this__u8e3s4) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    addTraitOnAttach_0(_this__u8e3s4, addImportFromPubMedAction$lambda(_this__u8e3s4));
  }
  function pageSpecificationCompletion(_this__u8e3s4, wrapperContext) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    _this__u8e3s4.bck('range', pageSpecificationCompletion$lambda(wrapperContext));
    var tmp = _this__u8e3s4.rci();
    _this__u8e3s4.fck(tmp, pageSpecificationCompletion$lambda_0(wrapperContext));
  }
  function libraryItemCompletion(_this__u8e3s4, wrapperContext) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    _this__u8e3s4.bck('book', libraryItemCompletion$lambda(wrapperContext));
    _this__u8e3s4.bck('paper', libraryItemCompletion$lambda_0(wrapperContext));
  }
  function publishedBy(_this__u8e3s4) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    label_0(_this__u8e3s4, 'published by');
    space_0(_this__u8e3s4);
    textProperty_0(_this__u8e3s4, '<publisher>', publishedBy$lambda);
    space_0(_this__u8e3s4);
    label_0(_this__u8e3s4, 'at');
    space_0(_this__u8e3s4);
    textProperty_0(_this__u8e3s4, '<date>', publishedBy$lambda_0);
  }
  function KnowledgeSourceReferencePlaceholder$ref() {
    return function (p0) {
      return KnowledgeSourceReferencePlaceholder(p0);
    };
  }
  function knowledgeSourceReferenceEditors$lambda($this$childrenRoleDefaults) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    knowledgeSourceReferenceCompletion($this$childrenRoleDefaults);
    return Unit_instance;
  }
  function knowledgeSourceReferenceEditors$lambda_0($this$editor) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    placeholderInCollection_0($this$editor, '<enter source>', knowledgeSourceReferenceEditors$lambda$lambda);
    return Unit_instance;
  }
  function knowledgeSourceReferenceEditors$lambda$lambda($this$placeholderInCollection) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    knowledgeSourceReferenceCompletion($this$placeholderInCollection);
    return Unit_instance;
  }
  function knowledgeSourceReferenceEditors$lambda_1($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function knowledgeSourceReferenceEditors$lambda_2($this$editor) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    label_0($this$editor, 'source url:');
    space_0($this$editor);
    textProperty_0($this$editor, '<url>', knowledgeSourceReferenceEditors$lambda$lambda_0).w92(URLHandler_getInstance());
    ensureLastCaretPosition($this$editor);
    return Unit_instance;
  }
  function knowledgeSourceReferenceEditors$lambda$lambda_0(it) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    return it.qfs();
  }
  function knowledgeSourceReferenceEditors$lambda_3($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function knowledgeSourceReferenceEditors$lambda_4($this$editor) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    label_0($this$editor, 'PubMed id:');
    space_0($this$editor);
    textProperty_0($this$editor, '<id>', knowledgeSourceReferenceEditors$lambda$lambda_1).w92(get_PubMedIdUrlHandler());
    ensureLastCaretPosition($this$editor);
    var tmp = $this$editor.ld0();
    if (!(isInterface(tmp, InternalEditorBuilderConfig) ? tmp : THROW_CCE()).acu()) {
      addImportFromPubMedAction($this$editor);
    }
    return Unit_instance;
  }
  function knowledgeSourceReferenceEditors$lambda$lambda_1(it) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    return it.kft();
  }
  function knowledgeSourceReferenceEditors$lambda_5($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function knowledgeSourceReferenceEditors$lambda_6($this$editor) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    label_0($this$editor, 'source:');
    space_0($this$editor);
    var tmp4 = Companion_getInstance_328().hhn_1;
    var tmp6 = knowledgeSourceReferenceEditors$lambda$lambda_2;
    // Inline function 'jetbrains.biokb.lang.editorBuilders.btbReferenceTarget' call
    var containerInit = knowledgeSourceReferenceEditors$lambda$lambda_3;
    var options = new CompletionOptions();
    var textCellInit = knowledgeSourceReferenceEditors$lambda$lambda_4;
    var tmp;
    if (null == null) {
      tmp = knowledgeSourceReferenceEditors$lambda$lambda_5;
    } else {
      tmp = null;
    }
    var tmp10 = tmp;
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.references.referenceTarget' call
    var textCellInit_0 = knowledgeSourceReferenceEditors$lambda$lambda_6(textCellInit);
    var targetClass = getKClass(PublishedWork);
    referenceTarget($this$editor, targetClass, '<...>', tmp4, tmp6, null, tmp10, options, containerInit, textCellInit_0);
    space_0($this$editor);
    var tmp2 = getKClass(PageSpecification);
    var tmp_0 = KProperty1;
    var tmp4_0 = getPropertyCallableRef('pageSpecification', 1, tmp_0, PublishedSourceReference$_get_pageSpecification_$ref_qx42i2_1(), null);
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.child' call
    var placeholderText = '<no pages>';
    var placeholderTraitFactory = knowledgeSourceReferenceEditors$lambda$lambda_7;
    var tmp_1 = knowledgeSourceReferenceEditors$lambda$lambda_8(tmp4_0);
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$2 = new SingleChildLink(getKClass(PublishedSourceReference_1), tmp4_0);
    child_1($this$editor, tmp2, tmp_1, placeholderText, placeholderTraitFactory, null, null, null, null, tmp$ret$2, null);
    ensureLastCaretPosition($this$editor);
    return Unit_instance;
  }
  function knowledgeSourceReferenceEditors$lambda$lambda_2(it) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    return it.m6d();
  }
  function knowledgeSourceReferenceEditors$lambda$lambda_3($this$btbReferenceTarget) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    var work = $this$btbReferenceTarget.m6d();
    var tmp;
    if (isInterface(work, Paper_1)) {
      // Inline function 'kotlin.text.isNotBlank' call
      var this_0 = work.kft().m5y().w2w();
      tmp = !isBlank(this_0);
    } else {
      tmp = false;
    }
    if (tmp) {
      space_0($this$btbReferenceTarget);
      label_0($this$btbReferenceTarget, '(', VOID, false);
      label_0($this$btbReferenceTarget, 'PubMed:');
      space_0($this$btbReferenceTarget);
      textProperty_0($this$btbReferenceTarget, '<id>', knowledgeSourceReferenceEditors$lambda$lambda$lambda(work)).w92(get_PubMedIdUrlHandler());
      label_0($this$btbReferenceTarget, ')', false);
    }
    return Unit_instance;
  }
  function knowledgeSourceReferenceEditors$lambda$lambda$lambda($work) {
    return function (it) {
      return $work.kft();
    };
  }
  function knowledgeSourceReferenceEditors$lambda$lambda_4(_this__u8e3s4) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    return Unit_instance;
  }
  function knowledgeSourceReferenceEditors$lambda$lambda_5(it) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    return true;
  }
  function knowledgeSourceReferenceEditors$lambda$lambda_6($textCellInit) {
    return function ($this$referenceTarget) {
      $textCellInit($this$referenceTarget);
      enableEagerCompletion($this$referenceTarget);
      return Unit_instance;
    };
  }
  function PublishedSourceReference$_get_pageSpecification_$ref_qx42i2_1() {
    return function (p0) {
      return p0.efu();
    };
  }
  function knowledgeSourceReferenceEditors$lambda$lambda_7(_unused_var__etf5q3, trait) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    return trait;
  }
  function knowledgeSourceReferenceEditors$lambda$lambda_8($childProperty) {
    return function (it) {
      return $childProperty(it);
    };
  }
  function knowledgeSourceReferenceEditors$lambda_7($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function knowledgeSourceReferenceEditors$lambda_8(wrapperContext) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    // Inline function 'kotlin.apply' call
    var this_0 = Page(wrapperContext);
    this_0.fft().d2x(0);
    return this_0;
  }
  function knowledgeSourceReferenceEditors$lambda_9($this$childrenRoleDefaults) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    pageSpecificationCompletion($this$childrenRoleDefaults, $this$childrenRoleDefaults.l6z());
    return Unit_instance;
  }
  function knowledgeSourceReferenceEditors$lambda_10($this$editor) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    label_0($this$editor, 'pp.', VOID, false);
    integerProperty_0($this$editor, '<start>', knowledgeSourceReferenceEditors$lambda$lambda_9);
    label_0($this$editor, '-', false, false);
    integerProperty_0($this$editor, '<end>', knowledgeSourceReferenceEditors$lambda$lambda_10);
    return Unit_instance;
  }
  function knowledgeSourceReferenceEditors$lambda$lambda_9(it) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    return it.p1();
  }
  function knowledgeSourceReferenceEditors$lambda$lambda_10(it) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    return it.lb4();
  }
  function knowledgeSourceReferenceEditors$lambda_11($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function knowledgeSourceReferenceEditors$lambda_12($this$editor) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    label_0($this$editor, 'p.', VOID, false);
    integerProperty_0($this$editor, '<page>', knowledgeSourceReferenceEditors$lambda$lambda_11);
    return Unit_instance;
  }
  function knowledgeSourceReferenceEditors$lambda$lambda_11(it) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    return it.fft();
  }
  function knowledgeSourceReferenceEditors$lambda_13($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function knowledgeSourceEditors$lambda($this$editor) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    label_0($this$editor, 'Published sources:');
    // Inline function 'kotlin.repeat' call
    var inductionVariable = 0;
    if (inductionVariable < 2)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        newLine_0($this$editor);
      }
       while (inductionVariable < 2);
    indent_0($this$editor, true, VOID, knowledgeSourceEditors$lambda$lambda);
    return Unit_instance;
  }
  function knowledgeSourceEditors$lambda$lambda($this$indent) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    newLine_0($this$indent);
    var tmp2 = getKClass(LibraryItem);
    var tmp = KProperty1;
    var tmp4 = getPropertyCallableRef('items', 1, tmp, PublishedSourcesLibrary$_get_items_$ref_b4kv1p_1(), null);
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.children' call
    var layout = Layout_VERTICAL_getInstance();
    var placeholderTraitFactory = knowledgeSourceEditors$lambda$lambda$lambda;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp_0 = new MultipleChildLink(getKClass(PublishedSourcesLibrary_1), tmp4);
    children_2($this$indent, tmp2, tmp_0, null, placeholderTraitFactory, null, null, null, null, layout, knowledgeSourceEditors$lambda$lambda$lambda_0(tmp4));
    return Unit_instance;
  }
  function PublishedSourcesLibrary$_get_items_$ref_b4kv1p_1() {
    return function (p0) {
      return p0.l2n();
    };
  }
  function knowledgeSourceEditors$lambda$lambda$lambda(_unused_var__etf5q3, trait) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    return trait;
  }
  function knowledgeSourceEditors$lambda$lambda$lambda_0($childrenProperty) {
    return function (it) {
      return $childrenProperty(it);
    };
  }
  function knowledgeSourceEditors$lambda_0($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function knowledgeSourceEditors$lambda_1($this$childrenRoleDefaults) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    var tmp = $this$childrenRoleDefaults.qci();
    $this$childrenRoleDefaults.dck(tmp, knowledgeSourceEditors$lambda$lambda_0($this$childrenRoleDefaults));
    return Unit_instance;
  }
  function knowledgeSourceEditors$lambda$lambda_0($this_childrenRoleDefaults) {
    return function (it) {
      // Inline function 'kotlin.apply' call
      var this_0 = Author($this_childrenRoleDefaults.l6z());
      this_0.y2().f2x(it);
      return this_0;
    };
  }
  function knowledgeSourceEditors$lambda_2($this$editor) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    var tmp = knowledgeSourceEditors$lambda$lambda_1;
    editableText_0($this$editor, VOID, '<name>', tmp, VOID, knowledgeSourceEditors$lambda$lambda_2);
    return Unit_instance;
  }
  function knowledgeSourceEditors$lambda$lambda_1(it) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    return !contains_8(it, ',');
  }
  function knowledgeSourceEditors$lambda$lambda_2($this$editableText) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.textSyncTwoWay' call
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.textCellSyncTwoWay' call
    var sourceProp = $this$editableText.m6d().y2();
    var targetProp = $this$editableText.qd0().o8w();
    $this$editableText.l8b(syncTwoWay(sourceProp.m5y(), targetProp));
    return Unit_instance;
  }
  function knowledgeSourceEditors$lambda_3($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function knowledgeSourceEditors$lambda_4(context) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    return LibraryItemPlaceholder(context);
  }
  function knowledgeSourceEditors$lambda_5($this$childrenRoleDefaults) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    libraryItemCompletion($this$childrenRoleDefaults, $this$childrenRoleDefaults.l6z());
    return Unit_instance;
  }
  function knowledgeSourceEditors$lambda_6($this$editor) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    placeholderInCollection_0($this$editor, VOID, knowledgeSourceEditors$lambda$lambda_3);
    return Unit_instance;
  }
  function knowledgeSourceEditors$lambda$lambda_3($this$placeholderInCollection) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    libraryItemCompletion($this$placeholderInCollection, $this$placeholderInCollection.l6z());
    return Unit_instance;
  }
  function knowledgeSourceEditors$lambda_7($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function knowledgeSourceEditors$lambda_8($this$editor) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    label_0($this$editor, 'Book');
    space_0($this$editor);
    label_0($this$editor, '"', VOID, false);
    textProperty_0($this$editor, '<title>', knowledgeSourceEditors$lambda$lambda_4);
    label_0($this$editor, '"', false);
    space_0($this$editor);
    textProperty_0($this$editor, '<no edition>', knowledgeSourceEditors$lambda$lambda_5);
    newLine_0($this$editor);
    newLine_0($this$editor);
    indent_0($this$editor, true, VOID, knowledgeSourceEditors$lambda$lambda_6);
    return Unit_instance;
  }
  function knowledgeSourceEditors$lambda$lambda_4(it) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    return it.wfp();
  }
  function knowledgeSourceEditors$lambda$lambda_5(it) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    return it.afq();
  }
  function knowledgeSourceEditors$lambda$lambda_6($this$indent) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    newLine_0($this$indent);
    label_0($this$indent, 'by');
    space_0($this$indent);
    var tmp2 = getKClass(Author_1);
    var tmp = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.children' call
    var childrenProperty = getPropertyCallableRef('authors', 1, tmp, Book$_get_authors_$ref_bmlw2r(), null);
    var placeholderTraitFactory = knowledgeSourceEditors$lambda$lambda$lambda_1;
    var layout = Layout_INDENT_getInstance();
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp_0 = new MultipleChildLink(getKClass(Book_1), childrenProperty);
    children_2($this$indent, tmp2, tmp_0, null, placeholderTraitFactory, null, null, null, null, layout, knowledgeSourceEditors$lambda$lambda$lambda_2(childrenProperty));
    newLine_0($this$indent);
    publishedBy($this$indent);
    return Unit_instance;
  }
  function Book$_get_authors_$ref_bmlw2r() {
    return function (p0) {
      return p0.vfp();
    };
  }
  function knowledgeSourceEditors$lambda$lambda$lambda_1(_unused_var__etf5q3, trait) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    return trait;
  }
  function knowledgeSourceEditors$lambda$lambda$lambda_2($childrenProperty) {
    return function (it) {
      return $childrenProperty(it);
    };
  }
  function knowledgeSourceEditors$lambda_9($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function knowledgeSourceEditors$lambda_10($this$editor) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    label_0($this$editor, 'Paper');
    space_0($this$editor);
    label_0($this$editor, '"', VOID, false);
    textProperty_0($this$editor, '<title>', knowledgeSourceEditors$lambda$lambda_7);
    label_0($this$editor, '"', false);
    newLine_0($this$editor);
    indent_0($this$editor, true, VOID, knowledgeSourceEditors$lambda$lambda_8);
    newLine_0($this$editor);
    return Unit_instance;
  }
  function knowledgeSourceEditors$lambda$lambda_7(it) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    return it.wfp();
  }
  function knowledgeSourceEditors$lambda$lambda_8($this$indent) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    newLine_0($this$indent);
    label_0($this$indent, 'in');
    space_0($this$indent);
    textProperty_0($this$indent, '<source title>', knowledgeSourceEditors$lambda$lambda$lambda_3);
    space_0($this$indent);
    label_0($this$indent, '(', VOID, false);
    textProperty_0($this$indent, '<short title>', knowledgeSourceEditors$lambda$lambda$lambda_4);
    label_0($this$indent, ')', false);
    space_0($this$indent);
    textProperty_0($this$indent, '<no volume>', knowledgeSourceEditors$lambda$lambda$lambda_5);
    space_0($this$indent);
    textProperty_0($this$indent, '<no issue>', knowledgeSourceEditors$lambda$lambda$lambda_6);
    newLine_0($this$indent);
    label_0($this$indent, 'by');
    space_0($this$indent);
    var tmp2 = getKClass(Author_1);
    var tmp = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.children' call
    var childrenProperty = getPropertyCallableRef('authors', 1, tmp, Paper$_get_authors_$ref_4im8sg(), null);
    var placeholderTraitFactory = knowledgeSourceEditors$lambda$lambda$lambda_7;
    var layout = Layout_INDENT_getInstance();
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp_0 = new MultipleChildLink(getKClass(Paper_1), childrenProperty);
    children_2($this$indent, tmp2, tmp_0, null, placeholderTraitFactory, null, null, null, null, layout, knowledgeSourceEditors$lambda$lambda$lambda_8(childrenProperty));
    newLine_0($this$indent);
    publishedBy($this$indent);
    newLine_0($this$indent);
    label_0($this$indent, 'pages');
    space_0($this$indent);
    var tmp2_0 = getKClass(PageSpecification);
    var tmp_1 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.child' call
    var childProperty = getPropertyCallableRef('pages', 1, tmp_1, Paper$_get_pages_$ref_56726c_1(), null);
    var placeholderTraitFactory_0 = knowledgeSourceEditors$lambda$lambda$lambda_9;
    var tmp_2 = knowledgeSourceEditors$lambda$lambda$lambda_10(childProperty);
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$2 = new SingleChildLink(getKClass(Paper_1), childProperty);
    child_1($this$indent, tmp2_0, tmp_2, null, placeholderTraitFactory_0, null, null, null, null, tmp$ret$2, null);
    newLine_0($this$indent);
    newLine_0($this$indent);
    label_0($this$indent, 'PubMed:');
    space_0($this$indent);
    textProperty_0($this$indent, '<id>', knowledgeSourceEditors$lambda$lambda$lambda_11).w92(get_PubMedIdUrlHandler());
    newLine_0($this$indent);
    label_0($this$indent, 'PMC:');
    space_0($this$indent);
    textProperty_0($this$indent, '<id>', knowledgeSourceEditors$lambda$lambda$lambda_12).w92(get_PMCIdUrlHandler());
    newLine_0($this$indent);
    label_0($this$indent, 'DOI:');
    space_0($this$indent);
    textProperty_0($this$indent, '<id>', knowledgeSourceEditors$lambda$lambda$lambda_13);
    return Unit_instance;
  }
  function knowledgeSourceEditors$lambda$lambda$lambda_3(it) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    return it.hft();
  }
  function knowledgeSourceEditors$lambda$lambda$lambda_4(it) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    return it.gft();
  }
  function knowledgeSourceEditors$lambda$lambda$lambda_5(it) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    return it.ift();
  }
  function knowledgeSourceEditors$lambda$lambda$lambda_6(it) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    return it.jft();
  }
  function Paper$_get_authors_$ref_4im8sg() {
    return function (p0) {
      return p0.vfp();
    };
  }
  function knowledgeSourceEditors$lambda$lambda$lambda_7(_unused_var__etf5q3, trait) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    return trait;
  }
  function knowledgeSourceEditors$lambda$lambda$lambda_8($childrenProperty) {
    return function (it) {
      return $childrenProperty(it);
    };
  }
  function Paper$_get_pages_$ref_56726c_1() {
    return function (p0) {
      return p0.nft();
    };
  }
  function knowledgeSourceEditors$lambda$lambda$lambda_9(_unused_var__etf5q3, trait) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    return trait;
  }
  function knowledgeSourceEditors$lambda$lambda$lambda_10($childProperty) {
    return function (it) {
      return $childProperty(it);
    };
  }
  function knowledgeSourceEditors$lambda$lambda$lambda_11(it) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    return it.kft();
  }
  function knowledgeSourceEditors$lambda$lambda$lambda_12(it) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    return it.lft();
  }
  function knowledgeSourceEditors$lambda$lambda$lambda_13(it) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    return it.mft();
  }
  function knowledgeSourceEditors$lambda_11($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function knowledgeSourceEditors$lambda_12($this$editor) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    label_0($this$editor, 'data:');
    space_0($this$editor);
    textProperty_0($this$editor, '<data>', knowledgeSourceEditors$lambda$lambda_9);
    newLine_0($this$editor);
    label_0($this$editor, 'authors:');
    space_0($this$editor);
    textProperty_0($this$editor, '<authors>', knowledgeSourceEditors$lambda$lambda_10);
    return Unit_instance;
  }
  function knowledgeSourceEditors$lambda$lambda_9(it) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    return it.lfs();
  }
  function knowledgeSourceEditors$lambda$lambda_10(it) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    return it.kfs();
  }
  function knowledgeSourceEditors$lambda_13($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function HasKnowledgeSources$_get_sources_$ref_6mibyw_1() {
    return function (p0) {
      return p0.nfr();
    };
  }
  function knowledgeSources$lambda(_unused_var__etf5q3, trait) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    return trait;
  }
  function knowledgeSources$lambda_0($childrenProperty) {
    return function (it) {
      return $childrenProperty(it);
    };
  }
  function knowledgeSourceReferenceCompletion$lambda($this_knowledgeSourceReferenceCompletion) {
    return function () {
      return UrlKnowledgeSourceReference($this_knowledgeSourceReferenceCompletion.l6z());
    };
  }
  function knowledgeSourceReferenceCompletion$lambda_0($this_knowledgeSourceReferenceCompletion) {
    return function () {
      return PubMedSourceReference($this_knowledgeSourceReferenceCompletion.l6z());
    };
  }
  function knowledgeSourceReferenceCompletion$lambda_1($this_knowledgeSourceReferenceCompletion) {
    return function () {
      return PublishedSourceReference($this_knowledgeSourceReferenceCompletion.l6z());
    };
  }
  function addImportFromPubMedAction$lambda$o$onKeyPressed$slambda$lambda($this_addImportFromPubMedAction, $publishedSourceReference) {
    return function () {
      $this_addImportFromPubMedAction.m6d().d6j($publishedSourceReference);
      return Unit_instance;
    };
  }
  function addImportFromPubMedAction$lambda$o$onKeyPressed$slambda($editorDocumentsApi, $pubMedId, $container, this$0, $this_addImportFromPubMedAction, $cellFinder, resultContinuation) {
    this.qub_1 = $editorDocumentsApi;
    this.rub_1 = $pubMedId;
    this.sub_1 = $container;
    this.tub_1 = this$0;
    this.uub_1 = $this_addImportFromPubMedAction;
    this.vub_1 = $cellFinder;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(addImportFromPubMedAction$lambda$o$onKeyPressed$slambda).e1h = function ($this$launch, $completion) {
    var tmp = this.f1h($this$launch, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(addImportFromPubMedAction$lambda$o$onKeyPressed$slambda).v9 = function (p1, $completion) {
    return this.e1h((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(addImportFromPubMedAction$lambda$o$onKeyPressed$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.qub_1.ltj(this.rub_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var result = suspendResult;
            if (!(result.jqw_1 == null)) {
              var tmp0_safe_receiver = this.sub_1.t42().c93(Companion_getInstance_419().rtc_1);
              var tmp_0;
              if (tmp0_safe_receiver == null) {
                tmp_0 = null;
              } else {
                var tmp1_elvis_lhs = result.jqw_1;
                tmp0_safe_receiver.mtm('Import from PubMed', 'Could not import paper data from PubMed', tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs);
                tmp_0 = Unit_instance;
              }
              if (tmp_0 == null) {
                this.tub_1.xub_1.tde('PubMed import error: ' + result.jqw_1);
              }
              return Unit_instance;
            }

            var paperRefText = ensureNotNull(result.iqw_1);
            var publishedSourceReference = get_internalConfig(this.uub_1).kd5().t6v(getKClass(PublishedSourceReference_1));
            publishedSourceReference.m6d().f2x(paperRefText);
            this.sub_1.d9m(addImportFromPubMedAction$lambda$o$onKeyPressed$slambda$lambda(this.uub_1, publishedSourceReference));
            var tmp3_safe_receiver = firstOrNull_0(this.vub_1.lah(publishedSourceReference));
            var tmp4_safe_receiver = tmp3_safe_receiver == null ? null : lastFocusable(tmp3_safe_receiver);
            if (tmp4_safe_receiver == null)
              null;
            else {
              tmp4_safe_receiver.s8n();
            }

            return Unit_instance;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(addImportFromPubMedAction$lambda$o$onKeyPressed$slambda).f1h = function ($this$launch, completion) {
    var i = new addImportFromPubMedAction$lambda$o$onKeyPressed$slambda(this.qub_1, this.rub_1, this.sub_1, this.tub_1, this.uub_1, this.vub_1, completion);
    i.wub_1 = $this$launch;
    return i;
  };
  function addImportFromPubMedAction$lambda$o$onKeyPressed$slambda_0($editorDocumentsApi, $pubMedId, $container, this$0, $this_addImportFromPubMedAction, $cellFinder, resultContinuation) {
    var i = new addImportFromPubMedAction$lambda$o$onKeyPressed$slambda($editorDocumentsApi, $pubMedId, $container, this$0, $this_addImportFromPubMedAction, $cellFinder, resultContinuation);
    var l = function ($this$launch, $completion) {
      return i.e1h($this$launch, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function addImportFromPubMedAction$2$1($this_addImportFromPubMedAction, $cellFinder) {
    this.yub_1 = $this_addImportFromPubMedAction;
    this.zub_1 = $cellFinder;
    CellTrait.call(this);
    this.xub_1 = getLogger('PubMedImportAction');
  }
  protoOf(addImportFromPubMedAction$2$1).s8z = function (cell, event) {
    if (event.r8j([KeyStroke_init_$Create$(Key_P_getInstance(), [ModifierKey_CONTROL_getInstance()])])) {
      event.n8i();
      var tmp0_elvis_lhs = cell.s8x();
      var tmp;
      if (tmp0_elvis_lhs == null) {
        return Unit_instance;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var container = tmp;
      var pubMedId = this.yub_1.m6d().kft().m5y().w2w();
      if (isBlank(pubMedId))
        return Unit_instance;
      // Inline function 'kotlin.checkNotNull' call
      var tmp0 = container.t42().c93(Companion_getInstance_419().qtc_1);
      var tmp$ret$1;
      $l$block: {
        // Inline function 'kotlin.checkNotNull' call
        if (tmp0 == null) {
          var message = 'Required value was null.';
          throw IllegalStateException_init_$Create$_0(toString_1(message));
        } else {
          tmp$ret$1 = tmp0;
          break $l$block;
        }
      }
      var editorDocumentsApi = tmp$ret$1;
      var tmp_0 = coroutineScope_0(container);
      launch(tmp_0, VOID, VOID, addImportFromPubMedAction$lambda$o$onKeyPressed$slambda_0(editorDocumentsApi, pubMedId, container, this, this.yub_1, this.zub_1, null));
    }
  };
  function addImportFromPubMedAction$lambda($this_addImportFromPubMedAction) {
    return function (_unused_var__etf5q3, _unused_var__etf5q3_0, cellFinder) {
      return new addImportFromPubMedAction$2$1($this_addImportFromPubMedAction, cellFinder);
    };
  }
  function pageSpecificationCompletion$lambda($wrapperContext) {
    return function () {
      // Inline function 'kotlin.apply' call
      var this_0 = PageRange($wrapperContext);
      this_0.p1().d2x(0);
      this_0.lb4().d2x(0);
      return this_0;
    };
  }
  function pageSpecificationCompletion$lambda_0($wrapperContext) {
    return function (number) {
      // Inline function 'kotlin.apply' call
      var this_0 = Page($wrapperContext);
      this_0.fft().d2x(number);
      return this_0;
    };
  }
  function libraryItemCompletion$lambda($wrapperContext) {
    return function () {
      return Book($wrapperContext);
    };
  }
  function libraryItemCompletion$lambda_0($wrapperContext) {
    return function () {
      return Paper($wrapperContext);
    };
  }
  function publishedBy$lambda(it) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    return it.ffu();
  }
  function publishedBy$lambda_0(it) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    return it.gfu();
  }
  var properties_initialized_KnowledgeSourceEditors_kt_4l1wdt;
  function _init_properties_KnowledgeSourceEditors_kt__e7emfh() {
    if (!properties_initialized_KnowledgeSourceEditors_kt_4l1wdt) {
      properties_initialized_KnowledgeSourceEditors_kt_4l1wdt = true;
      var tmp0 = '<no sources specified>';
      var tmp2 = KnowledgeSourceReferencePlaceholder$ref();
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
      var completionSupplier = knowledgeSourceReferenceEditors$lambda;
      var separator_0 = get_defaultChildrenSeparator();
      var tmp0_0 = new ChildrenRoleDefaults(getKClass(KnowledgeSourceReference), tmp0, tmp2, separator_0, completionSupplier, true);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init = knowledgeSourceReferenceEditors$lambda_0;
      var triggerDependencies = emptyList();
      var tmp = getKClass(KnowledgeSourceReferencePlaceholder_1);
      var tmp_0 = new EditorDefinition(tmp, null, null, false, true, triggerDependencies, knowledgeSourceReferenceEditors$lambda_1(init));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_0 = knowledgeSourceReferenceEditors$lambda_2;
      var triggerDependencies_0 = emptyList();
      var tmp_1 = getKClass(UrlKnowledgeSourceReference_1);
      var tmp_2 = new EditorDefinition(tmp_1, null, null, false, true, triggerDependencies_0, knowledgeSourceReferenceEditors$lambda_3(init_0));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_1 = knowledgeSourceReferenceEditors$lambda_4;
      var triggerDependencies_1 = emptyList();
      var tmp_3 = getKClass(PubMedSourceReference_1);
      var tmp_4 = new EditorDefinition(tmp_3, null, null, false, true, triggerDependencies_1, knowledgeSourceReferenceEditors$lambda_5(init_1));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_2 = knowledgeSourceReferenceEditors$lambda_6;
      var triggerDependencies_2 = emptyList();
      var tmp_5 = getKClass(PublishedSourceReference_1);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.hierarchyEditor' call
      var editorDefinitions = [tmp_0, tmp_2, tmp_4, new EditorDefinition(tmp_5, null, null, false, true, triggerDependencies_2, knowledgeSourceReferenceEditors$lambda_7(init_2))];
      var tmp_6 = new HierarchyEditorDefinition(getKClass(KnowledgeSourceReference), tmp0_0, toList(editorDefinitions));
      var tmp0_1 = '<no pages>';
      var tmp2_0 = knowledgeSourceReferenceEditors$lambda_8;
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
      var completionSupplier_0 = knowledgeSourceReferenceEditors$lambda_9;
      var separator_1 = get_defaultChildrenSeparator();
      var tmp0_2 = new ChildrenRoleDefaults(getKClass(PageSpecification), tmp0_1, tmp2_0, separator_1, completionSupplier_0, true);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_3 = knowledgeSourceReferenceEditors$lambda_10;
      var triggerDependencies_3 = emptyList();
      var tmp_7 = getKClass(PageRange_1);
      var tmp_8 = new EditorDefinition(tmp_7, null, null, false, true, triggerDependencies_3, knowledgeSourceReferenceEditors$lambda_11(init_3));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_4 = knowledgeSourceReferenceEditors$lambda_12;
      var triggerDependencies_4 = emptyList();
      var tmp_9 = getKClass(Page_1);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.hierarchyEditor' call
      var editorDefinitions_0 = [tmp_8, new EditorDefinition(tmp_9, null, null, false, true, triggerDependencies_4, knowledgeSourceReferenceEditors$lambda_13(init_4))];
      var tmp$ret$9 = new HierarchyEditorDefinition(getKClass(PageSpecification), tmp0_2, toList(editorDefinitions_0));
      knowledgeSourceReferenceEditors = listOf_0([tmp_6, tmp$ret$9]);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_5 = knowledgeSourceEditors$lambda;
      var triggerDependencies_5 = emptyList();
      var tmp_10 = getKClass(PublishedSourcesLibrary_1);
      var tmp_11 = new EditorDefinition(tmp_10, null, null, false, true, triggerDependencies_5, knowledgeSourceEditors$lambda_0(init_5));
      var tmp0_3 = '<authors>';
      var tmp2_1 = separator(',');
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
      var completionSupplier_1 = knowledgeSourceEditors$lambda_1;
      var tmp0_4 = new ChildrenRoleDefaults(getKClass(Author_1), tmp0_3, null, tmp2_1, completionSupplier_1, true);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_6 = knowledgeSourceEditors$lambda_2;
      var triggerDependencies_6 = emptyList();
      var tmp_12 = getKClass(Author_1);
      var tmp_13 = new EditorDefinition(tmp_12, tmp0_4, null, false, true, triggerDependencies_6, knowledgeSourceEditors$lambda_3(init_6));
      var tmp0_separator = blankLine();
      var tmp0_5 = '<editions>';
      var tmp2_2 = knowledgeSourceEditors$lambda_4;
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
      var completionSupplier_2 = knowledgeSourceEditors$lambda_5;
      var tmp0_6 = new ChildrenRoleDefaults(getKClass(LibraryItem), tmp0_5, tmp2_2, tmp0_separator, completionSupplier_2, true);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_7 = knowledgeSourceEditors$lambda_6;
      var triggerDependencies_7 = emptyList();
      var tmp_14 = getKClass(LibraryItemPlaceholder_1);
      var tmp_15 = new EditorDefinition(tmp_14, null, null, false, true, triggerDependencies_7, knowledgeSourceEditors$lambda_7(init_7));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_8 = knowledgeSourceEditors$lambda_8;
      var triggerDependencies_8 = emptyList();
      var tmp_16 = getKClass(Book_1);
      var tmp_17 = new EditorDefinition(tmp_16, null, null, false, true, triggerDependencies_8, knowledgeSourceEditors$lambda_9(init_8));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_9 = knowledgeSourceEditors$lambda_10;
      var triggerDependencies_9 = emptyList();
      var tmp_18 = getKClass(Paper_1);
      var tmp_19 = new EditorDefinition(tmp_18, null, null, false, true, triggerDependencies_9, knowledgeSourceEditors$lambda_11(init_9));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_10 = knowledgeSourceEditors$lambda_12;
      var triggerDependencies_10 = emptyList();
      var tmp_20 = getKClass(OldPublishedSource);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.hierarchyEditor' call
      var editorDefinitions_1 = [tmp_15, tmp_17, tmp_19, new EditorDefinition(tmp_20, null, null, false, true, triggerDependencies_10, knowledgeSourceEditors$lambda_13(init_10))];
      var tmp$ret$8 = new HierarchyEditorDefinition(getKClass(LibraryItem), tmp0_6, toList(editorDefinitions_1));
      knowledgeSourceEditors = listOf_0([tmp_11, tmp_13, tmp$ret$8]);
      PubMedIdUrlHandler = new PrefixedURLTrait('https://pubmed.ncbi.nlm.nih.gov/');
      PMCIdUrlHandler = new PrefixedURLTrait('https://www.ncbi.nlm.nih.gov/pmc/articles/');
    }
  }
  function get_linkLibraryEditors() {
    _init_properties_LinkLibraryEditors_kt__p2wlet();
    return linkLibraryEditors;
  }
  var linkLibraryEditors;
  function linkLibraryEditors$lambda($this$editor) {
    _init_properties_LinkLibraryEditors_kt__p2wlet();
    var tmp = getKClass(LinkDeclaration_1);
    var tmp_0 = Layout_VERTICAL_getInstance();
    children_2($this$editor, tmp, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp_0, linkLibraryEditors$lambda$lambda);
    return Unit_instance;
  }
  function linkLibraryEditors$lambda$lambda(linkLibrary) {
    _init_properties_LinkLibraryEditors_kt__p2wlet();
    return linkLibrary.wfr();
  }
  function linkLibraryEditors$lambda_0($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function linkLibraryEditors$lambda_1($this$childrenRoleDefaults) {
    _init_properties_LinkLibraryEditors_kt__p2wlet();
    var tmp = editorString($this$childrenRoleDefaults, BTBEditorParts_getInstance().pu1_1);
    $this$childrenRoleDefaults.hck(tmp, linkLibraryEditors$lambda$lambda_0($this$childrenRoleDefaults));
    return Unit_instance;
  }
  function linkLibraryEditors$lambda$lambda_0($this_childrenRoleDefaults) {
    return function (name) {
      // Inline function 'kotlin.apply' call
      var this_0 = LinkDeclaration($this_childrenRoleDefaults.l6z());
      this_0.y2().f2x(name);
      return this_0;
    };
  }
  function linkLibraryEditors$lambda_2($this$editor) {
    _init_properties_LinkLibraryEditors_kt__p2wlet();
    // Inline function 'kotlin.apply' call
    var this_0 = textProperty_0($this$editor, '<name>', linkLibraryEditors$lambda$lambda_1);
    mark_0(this_0, BTBEditorParts_getInstance().pu1_1);
    space_0($this$editor);
    label_0($this$editor, ':');
    space_0($this$editor);
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.enumProperty' call
    editableText_0($this$editor, VOID, '<spec>', VOID, VOID, linkLibraryEditors$lambda$lambda_2);
    indentLabel_0($this$editor, '(');
    var tmp = getKClass(OntologyElementType_1);
    child_1($this$editor, tmp, linkLibraryEditors$lambda$lambda_3);
    indentLabel_0($this$editor, ')', true);
    return Unit_instance;
  }
  function linkLibraryEditors$lambda$lambda_1(linkDeclaration) {
    _init_properties_LinkLibraryEditors_kt__p2wlet();
    return linkDeclaration.y2();
  }
  function linkLibraryEditors$lambda$lambda_2($this$editableText) {
    _init_properties_LinkLibraryEditors_kt__p2wlet();
    switch (get_internalConfig($this$editableText).nd0().uct_1.x2_1) {
      case 0:
        // Inline function 'jetbrains.ocelot.langDef.editorBuilder.enumSyncTwoWay' call

        var targetPropFactory = linkLibraryEditors$lambda$lambda$lambda;
        // Inline function 'jetbrains.ocelot.langDef.editorBuilder.textCellSyncTwoWay' call

        var sourceProp = $this$editableText.m6d().jfr();
        var targetProp = targetPropFactory($this$editableText.qd0());
        $this$editableText.l8b(syncTwoWay(sourceProp.m5y(), targetProp));
        break;
      case 1:
        // Inline function 'jetbrains.ocelot.langDef.editorBuilder.enumSyncTwoWay' call

        var targetPropFactory_0 = linkLibraryEditors$lambda$lambda$lambda_0;
        // Inline function 'jetbrains.ocelot.langDef.editorBuilder.textCellSyncTwoWay' call

        var sourceProp_0 = $this$editableText.m6d().jfr();
        var targetProp_0 = targetPropFactory_0($this$editableText.qd0());
        $this$editableText.l8b(syncTwoWay(sourceProp_0.m5y(), targetProp_0));
        break;
      default:
        var tmp = $this$editableText.qd0().o8w();
        var tmp1_safe_receiver = $this$editableText.m6d().jfr().m5y().w2w();
        var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.toString();
        tmp.f2x(tmp2_elvis_lhs == null ? '' : tmp2_elvis_lhs);
        break;
    }
    return Unit_instance;
  }
  function linkLibraryEditors$lambda$lambda$lambda(textCell) {
    _init_properties_LinkLibraryEditors_kt__p2wlet();
    // Inline function 'jetbrains.ocelot.base.enums.EnumInfoFactory.createEnumInfo' call
    // Inline function 'kotlin.enumValues' call
    var tmp$ret$0 = values_14();
    var enumInfo = new EnumInfoImpl(tmp$ret$0);
    return ValueEditors_instance.uag(textCell, enumInfo);
  }
  function linkLibraryEditors$lambda$lambda$lambda_0(textCell) {
    _init_properties_LinkLibraryEditors_kt__p2wlet();
    // Inline function 'jetbrains.ocelot.base.enums.EnumInfoFactory.createEnumInfo' call
    // Inline function 'kotlin.enumValues' call
    var tmp$ret$0 = values_14();
    var enumInfo = new EnumInfoImpl(tmp$ret$0);
    return ValueEditors_instance.uag(textCell, enumInfo);
  }
  function linkLibraryEditors$lambda$lambda_3(linkDeclaration) {
    _init_properties_LinkLibraryEditors_kt__p2wlet();
    return linkDeclaration.sfq();
  }
  function linkLibraryEditors$lambda_3($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  var properties_initialized_LinkLibraryEditors_kt_ero82h;
  function _init_properties_LinkLibraryEditors_kt__p2wlet() {
    if (!properties_initialized_LinkLibraryEditors_kt_ero82h) {
      properties_initialized_LinkLibraryEditors_kt_ero82h = true;
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init = linkLibraryEditors$lambda;
      var triggerDependencies = emptyList();
      var tmp = getKClass(LinkLibrary_1);
      var tmp_0 = new EditorDefinition(tmp, null, null, false, true, triggerDependencies, linkLibraryEditors$lambda_0(init));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
      var completionSupplier = linkLibraryEditors$lambda_1;
      var separator = get_defaultChildrenSeparator();
      var tmp0 = new ChildrenRoleDefaults(getKClass(LinkDeclaration_1), '<empty>', null, separator, completionSupplier, true);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_0 = linkLibraryEditors$lambda_2;
      var triggerDependencies_0 = emptyList();
      var tmp_1 = getKClass(LinkDeclaration_1);
      var tmp$ret$2 = new EditorDefinition(tmp_1, tmp0, null, false, true, triggerDependencies_0, linkLibraryEditors$lambda_3(init_0));
      linkLibraryEditors = listOf_0([tmp_0, tmp$ret$2]);
    }
  }
  function get_modifierContainerEditors() {
    _init_properties_ModifierEditors_kt__26pejn();
    return modifierContainerEditors;
  }
  var modifierContainerEditors;
  function modifierContainerEditors$lambda($this$editor) {
    _init_properties_ModifierEditors_kt__26pejn();
    var tmp = getKClass(ModifierDeclaration);
    var tmp_0 = Layout_VERTICAL_getInstance();
    children_2($this$editor, tmp, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp_0, modifierContainerEditors$lambda$lambda);
    return Unit_instance;
  }
  function modifierContainerEditors$lambda$lambda(it) {
    _init_properties_ModifierEditors_kt__26pejn();
    return it.l8j();
  }
  function modifierContainerEditors$lambda_0($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function modifierContainerEditors$lambda_1($this$editor) {
    _init_properties_ModifierEditors_kt__26pejn();
    textProperty_0($this$editor, '<name>', modifierContainerEditors$lambda$lambda_0);
    ensureLastCaretPosition($this$editor);
    return Unit_instance;
  }
  function modifierContainerEditors$lambda$lambda_0(relationDeclaration) {
    _init_properties_ModifierEditors_kt__26pejn();
    return relationDeclaration.y2();
  }
  function modifierContainerEditors$lambda_2($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  var properties_initialized_ModifierEditors_kt_p1dfhb;
  function _init_properties_ModifierEditors_kt__26pejn() {
    if (!properties_initialized_ModifierEditors_kt_p1dfhb) {
      properties_initialized_ModifierEditors_kt_p1dfhb = true;
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init = modifierContainerEditors$lambda;
      var triggerDependencies = emptyList();
      var tmp = getKClass(ModifierContainer);
      var tmp_0 = new EditorDefinition(tmp, null, null, false, true, triggerDependencies, modifierContainerEditors$lambda_0(init));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
      var placeholderText = '<modifier declarations>';
      var separator = get_defaultChildrenSeparator();
      var tmp0 = new ChildrenRoleDefaults(getKClass(ModifierDeclaration), placeholderText, null, separator, null, true);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_0 = modifierContainerEditors$lambda_1;
      var triggerDependencies_0 = emptyList();
      var tmp_1 = getKClass(ModifierDeclaration);
      var tmp$ret$2 = new EditorDefinition(tmp_1, tmp0, null, false, true, triggerDependencies_0, modifierContainerEditors$lambda_2(init_0));
      modifierContainerEditors = listOf_0([tmp_0, tmp$ret$2]);
    }
  }
  function multipliedExpressionEditor() {
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
    var init = multipliedExpressionEditor$lambda;
    var triggerDependencies = emptyList();
    var tmp = getKClass(MultipliedExpression_1);
    return new EditorDefinition(tmp, null, null, false, true, triggerDependencies, multipliedExpressionEditor$lambda_0(init));
  }
  function multiplierTextSynchronizer(expression, cell) {
    return new multiplierTextSynchronizer$1(cell, expression);
  }
  function multiplierCompletion(cell) {
    return CompletionSupplement_instance.o9p([multiplierCompletionItem(cell, Unknown_instance.klv(), 'unknown number of components', 1), multiplierCompletionItem(cell, '2', 'exact count (example)'), multiplierCompletionItem(cell, '3', 'exact count (example)')]);
  }
  function multiplierSeparatorText(_this__u8e3s4, readOnly) {
    var tmp0_subject = _this__u8e3s4.bid().m5y().w2w();
    var tmp;
    if (equals(tmp0_subject, Unknown_instance)) {
      tmp = ' \xD7 ';
    } else {
      if (equals(tmp0_subject, ImplicitOne_instance)) {
        tmp = readOnly ? '' : ' ';
      } else {
        if (tmp0_subject instanceof Exact) {
          tmp = ' \xD7 ';
        } else {
          noWhenBranchMatchedException();
        }
      }
    }
    return tmp;
  }
  function multiplierText(_this__u8e3s4) {
    return _this__u8e3s4.bid().m5y().w2w().klv();
  }
  function multiplierCompletionItem(cell, value, hint, sortPriority) {
    sortPriority = sortPriority === VOID ? 0 : sortPriority;
    return new multiplierCompletionItem$1(value, sortPriority, hint, cell);
  }
  function multipliedExpressionEditor$lambda($this$editor) {
    var tmp = get_internalConfig($this$editor).acu() ? '' : '1 \xD7';
    var tmp_0 = MultiplierValue$Companion$isValidText$ref(Companion_instance_357);
    editableText_0($this$editor, VOID, tmp, tmp_0, VOID, multipliedExpressionEditor$lambda$lambda);
    label_0($this$editor, '', VOID, VOID, multipliedExpressionEditor$lambda$lambda_0);
    var tmp2 = getKClass(FactExpressionPlaceholder);
    var tmp_1 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.child' call
    var childProperty = getPropertyCallableRef('expression', 1, tmp_1, MultipliedExpression$_get_expression_$ref_l608dh_1(), null);
    var placeholderTraitFactory = multipliedExpressionEditor$lambda$lambda_1;
    var tmp_2 = multipliedExpressionEditor$lambda$lambda_2(childProperty);
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$0 = new SingleChildLink(getKClass(MultipliedExpression_1), childProperty);
    var expressionCell = child_1($this$editor, tmp2, tmp_2, null, placeholderTraitFactory, null, null, null, null, tmp$ret$0, null);
    var tmp_3 = $this$editor.qd0();
    var tmp_4 = ProjectionalSynchronizers_getInstance().d99_1;
    tmp_3.g93(tmp_4, multipliedExpressionEditor$lambda$lambda_3(expressionCell));
    return Unit_instance;
  }
  function MultiplierValue$Companion$isValidText$ref(p0) {
    var l = function (_this__u8e3s4) {
      return p0.nlv(_this__u8e3s4);
    };
    l.callableName = 'isValidText';
    return l;
  }
  function multipliedExpressionEditor$lambda$lambda($this$editableText) {
    $this$editableText.l8b(multiplierTextSynchronizer($this$editableText.m6d(), $this$editableText.qd0()));
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.attachCompletion' call
    addTraitOnAttach_0($this$editableText, multipliedExpressionEditor$lambda$lambda$lambda);
    return Unit_instance;
  }
  function multipliedExpressionEditor$lambda$lambda$lambda(source, cell, cellFinder) {
    // Inline function 'jetbrains.ocelot.projectional.cell.trait.propertyTrait' call
    var propSpec = Completion_getInstance().u9d_1;
    return new _no_name_provided__qut3iv_55(propSpec, source, cell, cellFinder);
  }
  function _no_name_provided__qut3iv_55($propSpec, $source, $cell, $cellFinder) {
    this.auc_1 = $propSpec;
    this.buc_1 = $source;
    this.cuc_1 = $cell;
    this.duc_1 = $cellFinder;
    CellTrait.call(this);
  }
  protoOf(_no_name_provided__qut3iv_55).n91 = function (cell, spec) {
    var tmp;
    if (spec === this.auc_1) {
      this.buc_1;
      var tmp2 = this.cuc_1;
      this.duc_1;
      tmp = multiplierCompletion(tmp2);
    } else {
      tmp = protoOf(CellTrait).n91.call(this, cell, spec);
    }
    return tmp;
  };
  function multipliedExpressionEditor$lambda$lambda_0($this$label) {
    var updateLabel = multipliedExpressionEditor$lambda$lambda$lambda_0($this$label);
    $this$label.l8b(Synchronizers_instance.f8b($this$label.m6d().bid().m5y(), updateLabel));
    return Unit_instance;
  }
  function multipliedExpressionEditor$lambda$lambda$lambda_0($this_label) {
    return function () {
      $this_label.qd0().o8w().d2x(multiplierSeparatorText($this_label.m6d(), get_internalConfig($this_label).acu()));
      return Unit_instance;
    };
  }
  function MultipliedExpression$_get_expression_$ref_l608dh_1() {
    return function (p0) {
      return p0.mfr();
    };
  }
  function multipliedExpressionEditor$lambda$lambda_1(_unused_var__etf5q3, trait) {
    return trait;
  }
  function multipliedExpressionEditor$lambda$lambda_2($childProperty) {
    return function (it) {
      return $childProperty(it);
    };
  }
  function multipliedExpressionEditor$lambda$lambda$lambda_1(it) {
    return lastFocusable(it);
  }
  function multipliedExpressionEditor$lambda$lambda_3($expressionCell) {
    return function () {
      toEndWhenSettled($expressionCell, multipliedExpressionEditor$lambda$lambda$lambda_1);
      return Unit_instance;
    };
  }
  function multipliedExpressionEditor$lambda_0($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function syncCellFromSource($this) {
    if ($this.guc_1)
      return Unit_instance;
    var text = multiplierText($this.iuc_1);
    if ($this.huc_1.o8w().w2w() === text)
      return Unit_instance;
    $this.fuc_1 = true;
    try {
      $this.huc_1.o8w().d2x(text);
    }finally {
      $this.fuc_1 = false;
    }
  }
  function multiplierTextSynchronizer$o$doAttach$lambda(this$0, $expression) {
    return function (event) {
      var tmp;
      if (this$0.fuc_1) {
        return Unit_instance;
      }
      var tmp0_elvis_lhs = Companion_instance_357.mlv(event.t2y_1);
      var tmp_0;
      if (tmp0_elvis_lhs == null) {
        return Unit_instance;
      } else {
        tmp_0 = tmp0_elvis_lhs;
      }
      var input = tmp_0;
      this$0.guc_1 = true;
      var tmp_1;
      try {
        $expression.bid().d2x(input);
        tmp_1 = Unit_instance;
      }finally {
        this$0.guc_1 = false;
      }
      var tmp_2;
      if (equals(input, Unknown_instance) && !(event.t2y_1 === Unknown_instance.klv())) {
        syncCellFromSource(this$0);
        tmp_2 = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function multiplierTextSynchronizer$o$doAttach$lambda_0(this$0) {
    return function (it) {
      syncCellFromSource(this$0);
      return Unit_instance;
    };
  }
  function multiplierTextSynchronizer$1($cell, $expression) {
    this.huc_1 = $cell;
    this.iuc_1 = $expression;
    DisposableSynchronizer.call(this);
    this.fuc_1 = false;
    this.guc_1 = false;
  }
  protoOf(multiplierTextSynchronizer$1).s87 = function (ctx) {
    syncCellFromSource(this);
    var tmp = this.huc_1.o8w();
    var tmp_0 = tmp.z2r(multiplierTextSynchronizer$o$doAttach$lambda(this, this.iuc_1));
    var tmp_1 = this.iuc_1.bid().m5y();
    return tmp_0.j2l(tmp_1.z2r(multiplierTextSynchronizer$o$doAttach$lambda_0(this)));
  };
  function multiplierCompletionItem$o$complete$lambda($cell, $value) {
    return function () {
      $cell.o8w().d2x($value);
      return Unit_instance;
    };
  }
  function multiplierCompletionItem$1($value, $sortPriority, $hint, $cell) {
    this.nuc_1 = $value;
    this.ouc_1 = $hint;
    this.puc_1 = $cell;
    SimpleCompletionItem.call(this, $value, VOID, $sortPriority, false);
  }
  protoOf(multiplierCompletionItem$1).d9k = function () {
    return this.ouc_1;
  };
  protoOf(multiplierCompletionItem$1).s9m = function (text) {
    return multiplierCompletionItem$o$complete$lambda(this.puc_1, this.nuc_1);
  };
  function get_RELATION_CELL() {
    _init_properties_NewFactEditors_kt__ah0zlm();
    return RELATION_CELL;
  }
  var RELATION_CELL;
  function get_newFactEditors() {
    _init_properties_NewFactEditors_kt__ah0zlm();
    return newFactEditors;
  }
  var newFactEditors;
  function get_QUERY_LABELS_CONTAINER_MARK() {
    _init_properties_NewFactEditors_kt__ah0zlm();
    return QUERY_LABELS_CONTAINER_MARK;
  }
  var QUERY_LABELS_CONTAINER_MARK;
  function processPropertyReferenceEditor(withDotRightTransform) {
    withDotRightTransform = withDotRightTransform === VOID ? true : withDotRightTransform;
    _init_properties_NewFactEditors_kt__ah0zlm();
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
    var completionSupplier = processPropertyReferenceEditor$lambda;
    var separator = get_defaultChildrenSeparator();
    var tmp0 = new ChildrenRoleDefaults(getKClass(ProcessPropertyReference), '<empty>', null, separator, completionSupplier, true);
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
    var init = processPropertyReferenceEditor$lambda_0(withDotRightTransform);
    var triggerDependencies = emptyList();
    var tmp = getKClass(ProcessPropertyReference);
    return new EditorDefinition(tmp, tmp0, null, false, true, triggerDependencies, processPropertyReferenceEditor$lambda_1(init));
  }
  function queryLabelsCell(_this__u8e3s4, labels) {
    labels = labels === VOID ? get_entries_0() : labels;
    _init_properties_NewFactEditors_kt__ah0zlm();
    var _iterator__ex2g4s = labels.m();
    while (_iterator__ex2g4s.n()) {
      var label = _iterator__ex2g4s.o();
      // Inline function 'kotlin.apply' call
      var this_0 = label_0(_this__u8e3s4, '[' + label.quc() + ']');
      this_0.d97().f2x(true);
      var cell = this_0;
      // Inline function 'jetbrains.ocelot.mapper.core.Synchronizers.forDisposable' call
      var tmp$ret$2 = new queryLabelsCell$$inlined$forDisposable$1(label, _this__u8e3s4, cell);
      _this__u8e3s4.l8b(tmp$ret$2);
      cell.w92(new QueryLabelDeleteTrait(_this__u8e3s4.m6d(), label));
    }
  }
  function setQueryLabelRightTransform(source, selectFirst, labels) {
    selectFirst = selectFirst === VOID ? true : selectFirst;
    labels = labels === VOID ? get_entries_0() : labels;
    _init_properties_NewFactEditors_kt__ah0zlm();
    return setQueryLabelRightTransform$lambda(labels, source, selectFirst);
  }
  function processPropertyReferenceCompletion(_this__u8e3s4) {
    _init_properties_NewFactEditors_kt__ah0zlm();
    var tmp = _this__u8e3s4.jcg(Companion_getInstance_340().hhg_1);
    _this__u8e3s4.gck(tmp, processPropertyReferenceCompletion$lambda(_this__u8e3s4));
  }
  function factExpressionCompletionFor(_this__u8e3s4, node) {
    _init_properties_NewFactEditors_kt__ah0zlm();
    if (!(node == null) ? isInterface(node, NewFact) : false) {
      topLevelFactExpressionCompletion(_this__u8e3s4);
    } else {
      if (!(node == null) ? isInterface(node, SetExpression_1) : false) {
        wrapWithMultiplier(_this__u8e3s4, factExpressionCompletionFor$lambda);
      } else {
        factExpressionCompletion(_this__u8e3s4);
      }
    }
  }
  function newFactReferenceCompletion(_this__u8e3s4) {
    _init_properties_NewFactEditors_kt__ah0zlm();
    var tmp = _this__u8e3s4.jcg(Companion_getInstance_315().agu_1);
    _this__u8e3s4.gck(tmp, newFactReferenceCompletion$lambda(_this__u8e3s4));
  }
  function relationFactExpressionCompletion(_this__u8e3s4) {
    _init_properties_NewFactEditors_kt__ah0zlm();
    var tmp = _this__u8e3s4.jcg(Companion_getInstance_316().phr_1);
    _this__u8e3s4.gck(tmp, relationFactExpressionCompletion$lambda(_this__u8e3s4));
  }
  function labeledFactExpressionCompletion(_this__u8e3s4) {
    _init_properties_NewFactEditors_kt__ah0zlm();
    var tmp = _this__u8e3s4.ick(labeledFactExpressionCompletion$lambda);
    _this__u8e3s4.jck(tmp, labeledFactExpressionCompletion$lambda_0(_this__u8e3s4));
  }
  function factExpressionCompletion(_this__u8e3s4, includeModifiers, includeRelations) {
    includeModifiers = includeModifiers === VOID ? true : includeModifiers;
    includeRelations = includeRelations === VOID ? false : includeRelations;
    _init_properties_NewFactEditors_kt__ah0zlm();
    newFactReferenceCompletion(_this__u8e3s4);
    variableReferenceValueCompletion(_this__u8e3s4);
    measurableValueWithDefaultUnitCompletion(_this__u8e3s4);
    enumValueCompletion_0(_this__u8e3s4);
    complexNotionValueCompletion(_this__u8e3s4);
    libraryProcessSpecificationCompletion(_this__u8e3s4);
    ontologyElementReferenceValueLibraryCompletion(_this__u8e3s4);
    ontologyElementReferenceValueCompletion(_this__u8e3s4);
    setExpressionCompletion(_this__u8e3s4);
    anonymousClassCompletion(_this__u8e3s4);
    processPropertyReferenceCompletion(_this__u8e3s4);
    if (includeModifiers) {
      modifierCompletion(_this__u8e3s4);
    }
    if (includeRelations) {
      relationFactExpressionCompletion(_this__u8e3s4);
    }
  }
  function topLevelFactExpressionCompletion(_this__u8e3s4) {
    _init_properties_NewFactEditors_kt__ah0zlm();
    factExpressionCompletion(_this__u8e3s4, true, true);
  }
  var CommonQueryLabel_NO_ENTRY_instance;
  var CommonQueryLabel_NO_EXIT_instance;
  function values_21() {
    return [CommonQueryLabel_NO_ENTRY_getInstance(), CommonQueryLabel_NO_EXIT_getInstance()];
  }
  function get_entries_0() {
    if ($ENTRIES_0 == null)
      $ENTRIES_0 = enumEntries(values_21());
    return $ENTRIES_0;
  }
  function HasQueryLabels$_get_noEntry_$ref_215uy0_1() {
    return function (p0) {
      return p0.pfr();
    };
  }
  function HasQueryLabels$_get_noExit_$ref_pxrte_1() {
    return function (p0) {
      return p0.qfr();
    };
  }
  var CommonQueryLabel_entriesInitialized;
  function CommonQueryLabel_initEntries() {
    if (CommonQueryLabel_entriesInitialized)
      return Unit_instance;
    CommonQueryLabel_entriesInitialized = true;
    var tmp = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_0 = getPropertyCallableRef('noEntry', 1, tmp, HasQueryLabels$_get_noEntry_$ref_215uy0_1(), null);
    var tmp$ret$0 = new ValueAttributeLink(getKClass(HasQueryLabels), this_0, createKType(PrimitiveClasses_getInstance().lb(), arrayOf([]), false));
    CommonQueryLabel_NO_ENTRY_instance = new CommonQueryLabel('NO_ENTRY', 0, 'noentry', tmp$ret$0.v6v_1);
    var tmp_0 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_1 = getPropertyCallableRef('noExit', 1, tmp_0, HasQueryLabels$_get_noExit_$ref_pxrte_1(), null);
    var tmp$ret$1 = new ValueAttributeLink(getKClass(HasQueryLabels), this_1, createKType(PrimitiveClasses_getInstance().lb(), arrayOf([]), false));
    CommonQueryLabel_NO_EXIT_instance = new CommonQueryLabel('NO_EXIT', 1, 'noexit', tmp$ret$1.v6v_1);
  }
  var $ENTRIES_0;
  function CommonQueryLabel(name, ordinal, label, property) {
    Enum.call(this, name, ordinal);
    this.tuc_1 = label;
    this.uuc_1 = property;
  }
  protoOf(CommonQueryLabel).quc = function () {
    return this.tuc_1;
  };
  protoOf(CommonQueryLabel).q6q = function () {
    return this.uuc_1;
  };
  function QueryLabelDeleteTrait$onKeyPressed$$inlined$executeQuery$1(this$0) {
    this.vuc_1 = this$0;
  }
  protoOf(QueryLabelDeleteTrait$onKeyPressed$$inlined$executeQuery$1).n5w = function (builder) {
    return builder.l60(this.vuc_1.xuc_1.q6q()(this.vuc_1.wuc_1));
  };
  function QueryLabelDeleteTrait(source, label) {
    CellTrait.call(this);
    this.wuc_1 = source;
    this.xuc_1 = label;
  }
  protoOf(QueryLabelDeleteTrait).s8z = function (cell, event) {
    if (event.m8j(Key_BACKSPACE_getInstance(), []) || event.m8j(Key_DELETE_getInstance(), [])) {
      // Inline function 'jetbrains.ocelot.langDef.query.executeQuery' call
      // Inline function 'jetbrains.ocelot.langDef.query.query' call
      var tmp$ret$0 = new QueryLabelDeleteTrait$onKeyPressed$$inlined$executeQuery$1(this);
      var labelState = execute_0(tmp$ret$0);
      if (labelState) {
        // Inline function 'kotlin.sequences.find' call
        var tmp0 = ancestors(cell);
        var tmp$ret$3;
        $l$block: {
          // Inline function 'kotlin.sequences.firstOrNull' call
          var _iterator__ex2g4s = tmp0.m();
          while (_iterator__ex2g4s.n()) {
            var element = _iterator__ex2g4s.o();
            if (get_QUERY_LABELS_CONTAINER_MARK().fd1(element)) {
              tmp$ret$3 = element;
              break $l$block;
            }
          }
          tmp$ret$3 = null;
        }
        var parentCell = tmp$ret$3;
        this.xuc_1.q6q()(this.wuc_1).f2x(false);
        var tmp1_safe_receiver = parentCell == null ? null : firstFocusable(parentCell);
        if (tmp1_safe_receiver == null)
          null;
        else {
          tmp1_safe_receiver.s8n();
        }
        event.n8i();
        return Unit_instance;
      }
    }
    protoOf(CellTrait).s8z.call(this, cell, event);
  };
  function wrapWithMultiplier(_this__u8e3s4, completionBlock) {
    _init_properties_NewFactEditors_kt__ah0zlm();
    var tmp = _this__u8e3s4.ick(wrapWithMultiplier$lambda(completionBlock));
    _this__u8e3s4.jck(tmp, wrapWithMultiplier$lambda_0(_this__u8e3s4));
  }
  function modifierCompletion(_this__u8e3s4) {
    _init_properties_NewFactEditors_kt__ah0zlm();
    var tmp = _this__u8e3s4.jcg(Companion_getInstance_312().bgr_1);
    _this__u8e3s4.gck(tmp, modifierCompletion$lambda(_this__u8e3s4));
  }
  function ProcessEffect$_get_entry_$ref_q4qg2e_1() {
    return function (p0) {
      return p0.vft();
    };
  }
  function EntryQueryLabel() {
    EntryQueryLabel_instance = this;
    this.yuc_1 = 'entry';
    var tmp = this;
    var tmp_0 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_0 = getPropertyCallableRef('entry', 1, tmp_0, ProcessEffect$_get_entry_$ref_q4qg2e_1(), null);
    tmp.zuc_1 = (new ValueAttributeLink(getKClass(ProcessEffect_0), this_0, createKType(PrimitiveClasses_getInstance().lb(), arrayOf([]), false))).v6v_1;
  }
  protoOf(EntryQueryLabel).quc = function () {
    return this.yuc_1;
  };
  protoOf(EntryQueryLabel).q6q = function () {
    return this.zuc_1;
  };
  var EntryQueryLabel_instance;
  function EntryQueryLabel_getInstance() {
    if (EntryQueryLabel_instance == null)
      new EntryQueryLabel();
    return EntryQueryLabel_instance;
  }
  function implyEmptyQueryLabelsOnFact(_this__u8e3s4) {
    _init_properties_NewFactEditors_kt__ah0zlm();
    // Inline function 'jetbrains.ocelot.langDef.structure.adaptation.Companion.wraps' call
    var adapt = implyEmptyQueryLabelsOnFact$lambda(_this__u8e3s4);
    var tmp = wrapsOrTurnsInto(getKClass(FactExpression), getKClass(QueryLabelsFactExpressionContainer_0), true, adapt);
    // Inline function 'jetbrains.ocelot.langDef.structure.adaptation.Companion.unwraps' call
    var adapt_0 = implyEmptyQueryLabelsOnFact$lambda_0;
    var tmp$ret$1 = unwraps(getKClass(QueryLabelsFactExpressionContainer_0), adapt_0);
    return listOf_0([tmp, tmp$ret$1]);
  }
  function newFactEditors$lambda($this$childRoleDefaults) {
    _init_properties_NewFactEditors_kt__ah0zlm();
    factExpressionCompletionFor($this$childRoleDefaults, $this$childRoleDefaults.ack());
    return Unit_instance;
  }
  function newFactEditors$lambda_0($this$childrenRoleDefaults) {
    _init_properties_NewFactEditors_kt__ah0zlm();
    newFactReferenceCompletion($this$childrenRoleDefaults);
    return Unit_instance;
  }
  function newFactEditors$lambda_1($this$editor) {
    _init_properties_NewFactEditors_kt__ah0zlm();
    var tmp4 = Companion_getInstance_315().agu_1;
    var tmp = KProperty1;
    var tmp6 = getPropertyCallableRef('ref', 1, tmp, NewFactReference$_get_ref_$ref_4jyz94_1(), null);
    // Inline function 'jetbrains.biokb.lang.editorBuilders.btbReferenceTarget' call
    var options = new CompletionOptions(VOID, false);
    var containerInit = newFactEditors$lambda$lambda;
    var textCellInit = newFactEditors$lambda$lambda_0;
    var tmp_0;
    if (null == null) {
      tmp_0 = newFactEditors$lambda$lambda_1;
    } else {
      tmp_0 = null;
    }
    var tmp10 = tmp_0;
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.references.referenceTarget' call
    var textCellInit_0 = newFactEditors$lambda$lambda_2(textCellInit);
    var targetClass = getKClass(NewFact);
    var refCell = referenceTarget($this$editor, targetClass, '<fact>', tmp4, tmp6, null, tmp10, options, containerInit, textCellInit_0);
    considerEmptyBy($this$editor, refCell);
    deleteIfEmpty($this$editor);
    return Unit_instance;
  }
  function NewFactReference$_get_ref_$ref_4jyz94_1() {
    return function (p0) {
      return p0.yfq();
    };
  }
  function newFactEditors$lambda$lambda(_this__u8e3s4) {
    _init_properties_NewFactEditors_kt__ah0zlm();
    return Unit_instance;
  }
  function newFactEditors$lambda$lambda_0(_this__u8e3s4) {
    _init_properties_NewFactEditors_kt__ah0zlm();
    return Unit_instance;
  }
  function newFactEditors$lambda$lambda_1(it) {
    _init_properties_NewFactEditors_kt__ah0zlm();
    return true;
  }
  function newFactEditors$lambda$lambda_2($textCellInit) {
    return function ($this$referenceTarget) {
      $textCellInit($this$referenceTarget);
      enableEagerCompletion($this$referenceTarget);
      return Unit_instance;
    };
  }
  function newFactEditors$lambda_2($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function newFactEditors$lambda_3($this$childrenRoleDefaults) {
    _init_properties_NewFactEditors_kt__ah0zlm();
    relationFactExpressionCompletion($this$childrenRoleDefaults);
    return Unit_instance;
  }
  function newFactEditors$lambda_4($this$editor) {
    _init_properties_NewFactEditors_kt__ah0zlm();
    var tmp = getKClass(QueryLabelsFactExpressionContainer_0);
    var tmp_0 = newFactEditors$lambda$lambda_3;
    child_1($this$editor, tmp, tmp_0, VOID, VOID, VOID, VOID, VOID, VOID, VOID, newFactEditors$lambda$lambda_4);
    space_0($this$editor);
    var tmp2 = '<relation>';
    var tmp4 = Companion_getInstance_316().phr_1;
    var tmp_1 = KProperty1;
    var tmp6 = getPropertyCallableRef('relation', 1, tmp_1, RelationFactExpression$_get_relation_$ref_nkh94u_1(), null);
    var tmp_2 = KProperty1;
    var tmp8 = getPropertyCallableRef('symbol', 1, tmp_2, ProcessRelationDeclaration$_get_symbol_$ref_emzgvd_2(), null);
    // Inline function 'jetbrains.biokb.lang.editorBuilders.btbReferenceTarget' call
    var textCellInit = newFactEditors$lambda$lambda_5;
    var options = new CompletionOptions();
    var containerInit = newFactEditors$lambda$lambda_6;
    var tmp_3;
    if (null == null) {
      tmp_3 = newFactEditors$lambda$lambda_7;
    } else {
      tmp_3 = null;
    }
    var tmp10 = tmp_3;
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.references.referenceTarget' call
    var textCellInit_0 = newFactEditors$lambda$lambda_8(textCellInit);
    var targetClass = getKClass(ProcessRelationDeclaration_1);
    // Inline function 'kotlin.apply' call
    var this_0 = referenceTarget($this$editor, targetClass, tmp2, tmp4, tmp6, tmp8, tmp10, options, containerInit, textCellInit_0);
    mark_0(this_0, get_RELATION_CELL());
    space_0($this$editor);
    var tmp_4 = getKClass(QueryLabelsFactExpressionContainer_0);
    var tmp_5 = newFactEditors$lambda$lambda_9;
    child_1($this$editor, tmp_4, tmp_5, VOID, VOID, VOID, VOID, VOID, VOID, VOID, newFactEditors$lambda$lambda_10);
    return Unit_instance;
  }
  function newFactEditors$lambda$lambda_3(it) {
    _init_properties_NewFactEditors_kt__ah0zlm();
    return it.dft();
  }
  function newFactEditors$lambda$lambda_4($this$child) {
    _init_properties_NewFactEditors_kt__ah0zlm();
    labeledFactExpressionCompletion($this$child);
    return Unit_instance;
  }
  function RelationFactExpression$_get_relation_$ref_nkh94u_1() {
    return function (p0) {
      return p0.xfq();
    };
  }
  function ProcessRelationDeclaration$_get_symbol_$ref_emzgvd_2() {
    return function (p0) {
      return p0.zft();
    };
  }
  function newFactEditors$lambda$lambda_5($this$btbReferenceTarget) {
    _init_properties_NewFactEditors_kt__ah0zlm();
    $this$btbReferenceTarget.qd0().d97().f2x(true);
    return Unit_instance;
  }
  function newFactEditors$lambda$lambda_6(_this__u8e3s4) {
    _init_properties_NewFactEditors_kt__ah0zlm();
    return Unit_instance;
  }
  function newFactEditors$lambda$lambda_7(it) {
    _init_properties_NewFactEditors_kt__ah0zlm();
    return true;
  }
  function newFactEditors$lambda$lambda_8($textCellInit) {
    return function ($this$referenceTarget) {
      $textCellInit($this$referenceTarget);
      enableEagerCompletion($this$referenceTarget);
      return Unit_instance;
    };
  }
  function newFactEditors$lambda$lambda_9(it) {
    _init_properties_NewFactEditors_kt__ah0zlm();
    return it.eft();
  }
  function newFactEditors$lambda$lambda_10($this$child) {
    _init_properties_NewFactEditors_kt__ah0zlm();
    labeledFactExpressionCompletion($this$child);
    return Unit_instance;
  }
  function newFactEditors$lambda_5($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function newFactEditors$lambda_6($this$editor) {
    _init_properties_NewFactEditors_kt__ah0zlm();
    var tmp2 = '<modifier>';
    var tmp4 = Companion_getInstance_312().bgr_1;
    var tmp = KProperty1;
    var tmp6 = getPropertyCallableRef('modifier', 1, tmp, ModifierFactExpression$_get_modifier_$ref_tzyw3w_1(), null);
    // Inline function 'jetbrains.biokb.lang.editorBuilders.btbReferenceTarget' call
    var options = new CompletionOptions(VOID, false);
    var containerInit = newFactEditors$lambda$lambda_11;
    var textCellInit = newFactEditors$lambda$lambda_12;
    var tmp_0;
    if (null == null) {
      tmp_0 = newFactEditors$lambda$lambda_13;
    } else {
      tmp_0 = null;
    }
    var tmp10 = tmp_0;
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.references.referenceTarget' call
    var textCellInit_0 = newFactEditors$lambda$lambda_14(textCellInit);
    var targetClass = getKClass(ModifierDeclaration);
    referenceTarget($this$editor, targetClass, tmp2, tmp4, tmp6, null, tmp10, options, containerInit, textCellInit_0);
    space_0($this$editor);
    var tmp_1 = getKClass(FactExpression);
    var tmp_2 = newFactEditors$lambda$lambda_15;
    child_1($this$editor, tmp_1, tmp_2, VOID, VOID, VOID, VOID, VOID, VOID, VOID, newFactEditors$lambda$lambda_16);
    return Unit_instance;
  }
  function ModifierFactExpression$_get_modifier_$ref_tzyw3w_1() {
    return function (p0) {
      return p0.bfs();
    };
  }
  function newFactEditors$lambda$lambda_11(_this__u8e3s4) {
    _init_properties_NewFactEditors_kt__ah0zlm();
    return Unit_instance;
  }
  function newFactEditors$lambda$lambda_12(_this__u8e3s4) {
    _init_properties_NewFactEditors_kt__ah0zlm();
    return Unit_instance;
  }
  function newFactEditors$lambda$lambda_13(it) {
    _init_properties_NewFactEditors_kt__ah0zlm();
    return true;
  }
  function newFactEditors$lambda$lambda_14($textCellInit) {
    return function ($this$referenceTarget) {
      $textCellInit($this$referenceTarget);
      enableEagerCompletion($this$referenceTarget);
      return Unit_instance;
    };
  }
  function newFactEditors$lambda$lambda_15(it) {
    _init_properties_NewFactEditors_kt__ah0zlm();
    return it.mfr();
  }
  function newFactEditors$lambda$lambda_16($this$child) {
    _init_properties_NewFactEditors_kt__ah0zlm();
    factExpressionCompletion($this$child, false);
    return Unit_instance;
  }
  function newFactEditors$lambda_7($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function newFactEditors$lambda_8($this$editor) {
    _init_properties_NewFactEditors_kt__ah0zlm();
    var rootCellMark = new CellMark();
    // Inline function 'kotlin.apply' call
    var this_0 = indent_0($this$editor, VOID, VOID, newFactEditors$lambda$lambda_17(rootCellMark));
    mark_0(this_0, rootCellMark);
    return Unit_instance;
  }
  function newFactEditors$lambda$lambda$lambda(it) {
    _init_properties_NewFactEditors_kt__ah0zlm();
    return it.mdy();
  }
  function newFactEditors$lambda$lambda$lambda_0(it) {
    _init_properties_NewFactEditors_kt__ah0zlm();
    return it.a1();
  }
  function newFactEditors$lambda$lambda$lambda_1($this$child) {
    _init_properties_NewFactEditors_kt__ah0zlm();
    getAbstractValueCompletion($this$child);
    return Unit_instance;
  }
  function newFactEditors$14$2$ReplaceWithLeftTrait$onKeyPressed$$inlined$executeQuery$1($this_indent) {
    this.aud_1 = $this_indent;
  }
  protoOf(newFactEditors$14$2$ReplaceWithLeftTrait$onKeyPressed$$inlined$executeQuery$1).n5w = function (builder) {
    return builder.l60(this.aud_1.m6d().a1());
  };
  function newFactEditors$14$2$ReplaceWithLeftTrait$onKeyPressed$$inlined$executeQuery$2($this_indent) {
    this.bud_1 = $this_indent;
  }
  protoOf(newFactEditors$14$2$ReplaceWithLeftTrait$onKeyPressed$$inlined$executeQuery$2).n5w = function (builder) {
    return builder.l60(this.bud_1.m6d().mdy());
  };
  function newFactEditors$14$2$ReplaceWithLeftTrait($rootCellMark, $this_indent, checkIsEmpty) {
    this.dud_1 = $rootCellMark;
    this.eud_1 = $this_indent;
    CellTrait.call(this);
    this.cud_1 = checkIsEmpty;
  }
  protoOf(newFactEditors$14$2$ReplaceWithLeftTrait).s8z = function (cell, event) {
    if (event.m8j(Key_BACKSPACE_getInstance(), []) || event.m8j(Key_DELETE_getInstance(), [])) {
      var tmp;
      if (!this.cud_1) {
        tmp = true;
      } else {
        var tmp_0;
        if (this.cud_1) {
          // Inline function 'jetbrains.ocelot.langDef.query.executeQuery' call
          // Inline function 'jetbrains.ocelot.langDef.query.query' call
          var tmp$ret$0 = new newFactEditors$14$2$ReplaceWithLeftTrait$onKeyPressed$$inlined$executeQuery$1(this.eud_1);
          tmp_0 = execute_0(tmp$ret$0) == null;
        } else {
          tmp_0 = false;
        }
        tmp = tmp_0;
      }
      if (tmp) {
        // Inline function 'jetbrains.ocelot.langDef.query.executeQuery' call
        // Inline function 'jetbrains.ocelot.langDef.query.query' call
        var tmp$ret$2 = new newFactEditors$14$2$ReplaceWithLeftTrait$onKeyPressed$$inlined$executeQuery$2(this.eud_1);
        var left = execute_0(tmp$ret$2);
        if (!(left == null)) {
          // Inline function 'kotlin.sequences.find' call
          var tmp0 = ancestors(cell);
          var tmp$ret$5;
          $l$block: {
            // Inline function 'kotlin.sequences.firstOrNull' call
            var _iterator__ex2g4s = tmp0.m();
            while (_iterator__ex2g4s.n()) {
              var element = _iterator__ex2g4s.o();
              if (this.dud_1.fd1(element)) {
                tmp$ret$5 = element;
                break $l$block;
              }
            }
            tmp$ret$5 = null;
          }
          var tmp0_safe_receiver = tmp$ret$5;
          var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.bp();
          var parentCell = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.bp();
          var newExpression = left.f6j();
          this.eud_1.m6d().d6j(newExpression);
          var tmp3_safe_receiver = parentCell == null ? null : lastFocusable(parentCell);
          if (tmp3_safe_receiver == null)
            null;
          else {
            tmp3_safe_receiver.s8n();
          }
          event.n8i();
          return Unit_instance;
        }
      }
    }
    protoOf(CellTrait).s8z.call(this, cell, event);
  };
  function newFactEditors$lambda$lambda_17($rootCellMark) {
    return function ($this$indent) {
      var tmp = getKClass(ObjectPropertyReferenceValue_1);
      child_1($this$indent, tmp, newFactEditors$lambda$lambda$lambda);
      space_0($this$indent);
      var isLabel = label_0($this$indent, 'is');
      space_0($this$indent);
      var tmp_0 = getKClass(AbstractValue);
      var tmp_1 = newFactEditors$lambda$lambda$lambda_0;
      var valueChild = child_1($this$indent, tmp_0, tmp_1, VOID, VOID, VOID, VOID, VOID, VOID, VOID, newFactEditors$lambda$lambda$lambda_1);
      isLabel.w92(new newFactEditors$14$2$ReplaceWithLeftTrait($rootCellMark, $this$indent, false));
      valueChild.w92(new newFactEditors$14$2$ReplaceWithLeftTrait($rootCellMark, $this$indent, true));
      return Unit_instance;
    };
  }
  function newFactEditors$lambda_9($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function newFactEditors$lambda_10($this$editor) {
    _init_properties_NewFactEditors_kt__ah0zlm();
    indent_0($this$editor, VOID, VOID, newFactEditors$lambda$lambda_18($this$editor));
    return Unit_instance;
  }
  function newFactEditors$lambda$lambda$lambda_2($this_editor) {
    return function ($this$placeholderInCollection) {
      factExpressionCompletionFor($this$placeholderInCollection, $this_editor.m6d().bp());
      return Unit_instance;
    };
  }
  function newFactEditors$lambda$lambda_18($this_editor) {
    return function ($this$indent) {
      placeholderInCollection_0($this$indent, '<expression>', newFactEditors$lambda$lambda$lambda_2($this_editor));
      return Unit_instance;
    };
  }
  function newFactEditors$lambda_11($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function newFactEditors$lambda_12($this$childRoleDefaults) {
    _init_properties_NewFactEditors_kt__ah0zlm();
    labeledFactExpressionCompletion($this$childRoleDefaults);
    return Unit_instance;
  }
  function newFactEditors$lambda_13($this$editor) {
    _init_properties_NewFactEditors_kt__ah0zlm();
    var indent = indent_0($this$editor, VOID, VOID, newFactEditors$lambda$lambda_19);
    mark_0(indent, get_QUERY_LABELS_CONTAINER_MARK());
    return Unit_instance;
  }
  function newFactEditors$lambda$lambda_19($this$indent) {
    _init_properties_NewFactEditors_kt__ah0zlm();
    queryLabelsCell($this$indent);
    var tmp = getKClass(FactExpression);
    var tmp_0 = newFactEditors$lambda$lambda$lambda_3;
    var expressionCell = child_1($this$indent, tmp, tmp_0, VOID, VOID, VOID, VOID, VOID, VOID, VOID, newFactEditors$lambda$lambda$lambda_4);
    var setQueriesLabelRightTransform = setQueryLabelRightTransform($this$indent.m6d(), false);
    rightTransform_1($this$indent, expressionCell, setQueriesLabelRightTransform);
    return Unit_instance;
  }
  function newFactEditors$lambda$lambda$lambda_3(it) {
    _init_properties_NewFactEditors_kt__ah0zlm();
    return it.mfr();
  }
  function newFactEditors$lambda$lambda$lambda_4($this$child) {
    _init_properties_NewFactEditors_kt__ah0zlm();
    factExpressionCompletion($this$child);
    return Unit_instance;
  }
  function newFactEditors$lambda_14($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function newFactEditors$lambda_15($this$editor) {
    _init_properties_NewFactEditors_kt__ah0zlm();
    addFactSelection($this$editor);
    textProperty_0($this$editor, '<no name>', newFactEditors$lambda$lambda_20);
    space_0($this$editor);
    label_0($this$editor, ':');
    space_0($this$editor);
    var tmp = getKClass(FactExpression);
    var tmp_0 = newFactEditors$lambda$lambda_21;
    child_1($this$editor, tmp, tmp_0, VOID, VOID, VOID, VOID, VOID, VOID, VOID, newFactEditors$lambda$lambda_22);
    space_0($this$editor);
    var relationPlaceholder = indent_0($this$editor, VOID, VOID, newFactEditors$lambda$lambda_23);
    // Inline function 'jetbrains.ocelot.mapper.core.Synchronizers.forDisposable' call
    var tmp$ret$0 = new newFactEditors$22$$inlined$forDisposable$1($this$editor, relationPlaceholder);
    $this$editor.l8b(tmp$ret$0);
    return Unit_instance;
  }
  function newFactEditors$lambda$lambda_20(fact) {
    _init_properties_NewFactEditors_kt__ah0zlm();
    return fact.y2();
  }
  function newFactEditors$lambda$lambda_21(fact) {
    _init_properties_NewFactEditors_kt__ah0zlm();
    return fact.mfr();
  }
  function newFactEditors$lambda$lambda_22($this$child) {
    _init_properties_NewFactEditors_kt__ah0zlm();
    topLevelFactExpressionCompletion($this$child);
    return Unit_instance;
  }
  function newFactEditors$lambda$lambda_23($this$indent) {
    _init_properties_NewFactEditors_kt__ah0zlm();
    editableText_0($this$indent, '', '-?->', VOID, true, newFactEditors$lambda$lambda$lambda_5);
    return Unit_instance;
  }
  function newFactEditors$lambda$lambda$lambda_5($this$editableText) {
    _init_properties_NewFactEditors_kt__ah0zlm();
    rightTransform_0($this$editableText, newFactEditors$lambda$lambda$lambda$lambda($this$editableText));
    return Unit_instance;
  }
  function newFactEditors$lambda$lambda$lambda$lambda$lambda$lambda($cellFinder, $relationExpression) {
    return function () {
      var tmp0_safe_receiver = firstOrNull_0($cellFinder.lah($relationExpression));
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : find_2(tmp0_safe_receiver, get_RELATION_CELL());
      var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : firstFocusable(tmp1_safe_receiver);
      if (tmp2_safe_receiver == null)
        null;
      else {
        tmp2_safe_receiver.s8n();
      }
      return Unit_instance;
    };
  }
  function newFactEditors$lambda$lambda$lambda$lambda$lambda($this_editableText, $cellFinder) {
    return function () {
      var expression = ensureNotNull($this_editableText.m6d().mfr().m5y().uv());
      // Inline function 'kotlin.apply' call
      var this_0 = RelationFactExpression(get_internalConfig($this_editableText).l6z());
      var tmp = this_0.dft();
      var tmp_0 = get_internalConfig($this_editableText).l6z();
      var tmp_1 = expression.f6j();
      tmp.f2x(QueryLabelsFactExpressionContainer_1(tmp_0, isInterface(tmp_1, FactExpression) ? tmp_1 : THROW_CCE()));
      var relationExpression = this_0;
      expression.d6j(relationExpression);
      return newFactEditors$lambda$lambda$lambda$lambda$lambda$lambda($cellFinder, relationExpression);
    };
  }
  function newFactEditors$lambda$lambda$lambda$lambda($this_editableText) {
    return function ($this$rightTransform, _unused_var__etf5q3, _unused_var__etf5q3_0, cellFinder) {
      $this$rightTransform.gcg('->', newFactEditors$lambda$lambda$lambda$lambda$lambda($this_editableText, cellFinder));
      return Unit_instance;
    };
  }
  function newFactEditors$lambda$o$doAttach$lambda(it) {
    var tmp;
    if (!(it == null)) {
      tmp = !isInterface(it, RelationFactExpression_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
  function newFactEditors$22$$inlined$forDisposable$1($this_editor, $relationPlaceholder) {
    this.gud_1 = $this_editor;
    this.hud_1 = $relationPlaceholder;
    DisposableSynchronizer.call(this);
  }
  protoOf(newFactEditors$22$$inlined$forDisposable$1).s87 = function (ctx) {
    var expression = this.gud_1.m6d().mfr().m5y();
    var tmp = PropertyBinding_instance;
    return tmp.n30(map_0(expression, newFactEditors$lambda$o$doAttach$lambda), this.hud_1.m92());
  };
  function newFactEditors$lambda_16($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function processPropertyReferenceEditor$lambda($this$childrenRoleDefaults) {
    _init_properties_NewFactEditors_kt__ah0zlm();
    var tmp = $this$childrenRoleDefaults.jcg(Companion_getInstance_340().hhg_1);
    $this$childrenRoleDefaults.gck(tmp, processPropertyReferenceEditor$lambda$lambda($this$childrenRoleDefaults));
    return Unit_instance;
  }
  function processPropertyReferenceEditor$lambda$lambda($this_childrenRoleDefaults) {
    return function (reference) {
      return ProcessPropertyReference_0($this_childrenRoleDefaults.l6z(), reference);
    };
  }
  function processPropertyReferenceEditor$lambda$lambda$lambda(it) {
    _init_properties_NewFactEditors_kt__ah0zlm();
    return it.q6q();
  }
  function processPropertyReferenceEditor$lambda$lambda$lambda$lambda$lambda($this_btbReferenceTarget, $cellFinder, $cell) {
    return function () {
      var tmp = get_enclosingRefData($cell).ida_1;
      return transformValueToPropertyReference($this_btbReferenceTarget, $cellFinder, (!(tmp == null) ? isInterface(tmp, ProcessPropertyReference) : false) ? tmp : THROW_CCE());
    };
  }
  function processPropertyReferenceEditor$lambda$lambda$lambda$lambda($this_btbReferenceTarget) {
    return function ($this$rightTransform, _unused_var__etf5q3, cell, cellFinder) {
      $this$rightTransform.gcg('.', processPropertyReferenceEditor$lambda$lambda$lambda$lambda$lambda($this_btbReferenceTarget, cellFinder, cell));
      return Unit_instance;
    };
  }
  function processPropertyReferenceEditor$lambda$lambda$lambda_0($withDotRightTransform) {
    return function ($this$btbReferenceTarget) {
      var tmp;
      if ($withDotRightTransform) {
        rightTransform_0($this$btbReferenceTarget, processPropertyReferenceEditor$lambda$lambda$lambda$lambda($this$btbReferenceTarget));
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function processPropertyReferenceEditor$lambda$lambda$lambda_1(_this__u8e3s4) {
    _init_properties_NewFactEditors_kt__ah0zlm();
    return Unit_instance;
  }
  function processPropertyReferenceEditor$lambda$lambda$lambda_2(it) {
    _init_properties_NewFactEditors_kt__ah0zlm();
    return true;
  }
  function processPropertyReferenceEditor$lambda$lambda$lambda_3($textCellInit) {
    return function ($this$referenceTarget) {
      $textCellInit($this$referenceTarget);
      enableEagerCompletion($this$referenceTarget);
      return Unit_instance;
    };
  }
  function processPropertyReferenceEditor$lambda$lambda_0($withDotRightTransform) {
    return function ($this$indent) {
      var tmp2 = '<property>';
      var tmp4 = Companion_getInstance_340().hhg_1;
      var tmp6 = processPropertyReferenceEditor$lambda$lambda$lambda;
      // Inline function 'jetbrains.biokb.lang.editorBuilders.btbReferenceTarget' call
      var textCellInit = processPropertyReferenceEditor$lambda$lambda$lambda_0($withDotRightTransform);
      var options = new CompletionOptions();
      var containerInit = processPropertyReferenceEditor$lambda$lambda$lambda_1;
      var tmp;
      if (null == null) {
        tmp = processPropertyReferenceEditor$lambda$lambda$lambda_2;
      } else {
        tmp = null;
      }
      var tmp10 = tmp;
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.references.referenceTarget' call
      var textCellInit_0 = processPropertyReferenceEditor$lambda$lambda$lambda_3(textCellInit);
      var targetClass = getKClass(ProcessProperty_1);
      var refCell = referenceTarget($this$indent, targetClass, tmp2, tmp4, tmp6, null, tmp10, options, containerInit, textCellInit_0);
      considerEmptyBy($this$indent, refCell);
      deleteIfEmpty($this$indent);
      return Unit_instance;
    };
  }
  function processPropertyReferenceEditor$lambda_0($withDotRightTransform) {
    return function ($this$editor) {
      indent_0($this$editor, VOID, VOID, processPropertyReferenceEditor$lambda$lambda_0($withDotRightTransform));
      return Unit_instance;
    };
  }
  function processPropertyReferenceEditor$lambda_1($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function queryLabelsCell$$inlined$forDisposable$1($label, $this_queryLabelsCell, $cell) {
    this.jud_1 = $label;
    this.kud_1 = $this_queryLabelsCell;
    this.lud_1 = $cell;
    DisposableSynchronizer.call(this);
  }
  protoOf(queryLabelsCell$$inlined$forDisposable$1).s87 = function (ctx) {
    return PropertyBinding_instance.n30(get_asProperty(this.jud_1.q6q()(this.kud_1.m6d())), this.lud_1.m92());
  };
  function setQueryLabelRightTransform$2$$inlined$executeQuery$1($label, $source) {
    this.mud_1 = $label;
    this.nud_1 = $source;
  }
  protoOf(setQueryLabelRightTransform$2$$inlined$executeQuery$1).n5w = function (builder) {
    return builder.l60(this.mud_1.q6q()(this.nud_1));
  };
  function setQueryLabelRightTransform$lambda$lambda$lambda($selectFirst, $cell) {
    return function () {
      if ($selectFirst) {
        var tmp0_safe_receiver = firstFocusable($cell);
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.s8n();
        }
      } else {
        var tmp1_safe_receiver = lastFocusable($cell);
        if (tmp1_safe_receiver == null)
          null;
        else {
          tmp1_safe_receiver.s8n();
        }
      }
      return Unit_instance;
    };
  }
  function setQueryLabelRightTransform$lambda$lambda($label, $source, $selectFirst, $cell) {
    return function () {
      $label.q6q()($source).f2x(true);
      return setQueryLabelRightTransform$lambda$lambda$lambda($selectFirst, $cell);
    };
  }
  function setQueryLabelRightTransform$lambda($labels, $source, $selectFirst) {
    return function (_this__u8e3s4, _unused_var__etf5q3, cell, _unused_var__etf5q3_0) {
      var _iterator__ex2g4s = $labels.m();
      while (_iterator__ex2g4s.n()) {
        var label = _iterator__ex2g4s.o();
        // Inline function 'jetbrains.ocelot.langDef.query.executeQuery' call
        // Inline function 'jetbrains.ocelot.langDef.query.query' call
        var tmp$ret$0 = new setQueryLabelRightTransform$2$$inlined$executeQuery$1(label, $source);
        if (!execute_0(tmp$ret$0)) {
          var tmp = label.quc();
          _this__u8e3s4.gcg(tmp, setQueryLabelRightTransform$lambda$lambda(label, $source, $selectFirst, cell));
        }
      }
      return Unit_instance;
    };
  }
  function processPropertyReferenceCompletion$lambda($this_processPropertyReferenceCompletion) {
    return function (reference) {
      return ProcessPropertyReference_0($this_processPropertyReferenceCompletion.l6z(), reference);
    };
  }
  function factExpressionCompletionFor$lambda($this$wrapWithMultiplier) {
    _init_properties_NewFactEditors_kt__ah0zlm();
    factExpressionCompletion($this$wrapWithMultiplier);
    return Unit_instance;
  }
  function newFactReferenceCompletion$lambda($this_newFactReferenceCompletion) {
    return function (reference) {
      return NewFactReference_1($this_newFactReferenceCompletion.l6z(), reference);
    };
  }
  function relationFactExpressionCompletion$lambda($this_relationFactExpressionCompletion) {
    return function (reference) {
      return RelationFactExpression_2($this_relationFactExpressionCompletion.l6z(), reference);
    };
  }
  function labeledFactExpressionCompletion$lambda($this$using) {
    _init_properties_NewFactEditors_kt__ah0zlm();
    factExpressionCompletion($this$using);
    return Unit_instance;
  }
  function labeledFactExpressionCompletion$lambda_0($this_labeledFactExpressionCompletion) {
    return function (expression) {
      return QueryLabelsFactExpressionContainer_1($this_labeledFactExpressionCompletion.l6z(), expression);
    };
  }
  function wrapWithMultiplier$lambda($completionBlock) {
    return function ($this$using) {
      $completionBlock($this$using);
      return Unit_instance;
    };
  }
  function wrapWithMultiplier$lambda_0($this_wrapWithMultiplier) {
    return function (expression) {
      // Inline function 'kotlin.apply' call
      var this_0 = MultipliedExpression($this_wrapWithMultiplier.l6z());
      this_0.bid().d2x(ImplicitOne_instance);
      this_0.mfr().f2x(expression);
      return this_0;
    };
  }
  function modifierCompletion$lambda($this_modifierCompletion) {
    return function (reference) {
      return ModifierFactExpression_1($this_modifierCompletion.l6z(), reference);
    };
  }
  function implyEmptyQueryLabelsOnFact$lambda($this_implyEmptyQueryLabelsOnFact) {
    return function (fact) {
      // Inline function 'jetbrains.ocelot.langDef.structure.NodeFactory.create' call
      // Inline function 'kotlin.also' call
      var this_0 = $this_implyEmptyQueryLabelsOnFact.t6v(getKClass(QueryLabelsFactExpressionContainer_0));
      var tmp = this_0.mfr();
      var tmp_0 = fact.f6j();
      tmp.d2x(isInterface(tmp_0, FactExpression) ? tmp_0 : THROW_CCE());
      return this_0;
    };
  }
  function implyEmptyQueryLabelsOnFact$lambda_0(container) {
    _init_properties_NewFactEditors_kt__ah0zlm();
    return container.mfr().m5y().w2w();
  }
  function CommonQueryLabel_NO_ENTRY_getInstance() {
    CommonQueryLabel_initEntries();
    return CommonQueryLabel_NO_ENTRY_instance;
  }
  function CommonQueryLabel_NO_EXIT_getInstance() {
    CommonQueryLabel_initEntries();
    return CommonQueryLabel_NO_EXIT_instance;
  }
  var properties_initialized_NewFactEditors_kt_9c502k;
  function _init_properties_NewFactEditors_kt__ah0zlm() {
    if (!properties_initialized_NewFactEditors_kt_9c502k) {
      properties_initialized_NewFactEditors_kt_9c502k = true;
      RELATION_CELL = new CellMark();
      var tmp0 = childRoleDefaults('<fact>', newFactEditors$lambda, VOID, true);
      var tmp0_0 = childRoleDefaults(VOID, VOID, VOID, false);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
      var completionSupplier = newFactEditors$lambda_0;
      var separator = get_defaultChildrenSeparator();
      var tmp0_1 = new ChildrenRoleDefaults(getKClass(NewFactReference_0), '<facts>', null, separator, completionSupplier, true);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init = newFactEditors$lambda_1;
      var triggerDependencies = emptyList();
      var tmp = getKClass(NewFactReference_0);
      var tmp_0 = new EditorDefinition(tmp, tmp0_1, null, false, true, triggerDependencies, newFactEditors$lambda_2(init));
      var tmp0_2 = '<relation>';
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
      var completionSupplier_0 = newFactEditors$lambda_3;
      var separator_0 = get_defaultChildrenSeparator();
      var tmp0_3 = new ChildrenRoleDefaults(getKClass(RelationFactExpression_1), tmp0_2, null, separator_0, completionSupplier_0, true);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_0 = newFactEditors$lambda_4;
      var triggerDependencies_0 = emptyList();
      var tmp_1 = getKClass(RelationFactExpression_1);
      var tmp_2 = new EditorDefinition(tmp_1, tmp0_3, null, false, true, triggerDependencies_0, newFactEditors$lambda_5(init_0));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_1 = newFactEditors$lambda_6;
      var triggerDependencies_1 = emptyList();
      var tmp_3 = getKClass(ModifierFactExpression_0);
      var tmp_4 = new EditorDefinition(tmp_3, null, null, false, true, triggerDependencies_1, newFactEditors$lambda_7(init_1));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_2 = newFactEditors$lambda_8;
      var triggerDependencies_2 = emptyList();
      var tmp_5 = getKClass(IsExpression_1);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.hierarchyEditor' call
      var editorDefinitions = [tmp_0, tmp_2, tmp_4, new EditorDefinition(tmp_5, null, null, false, true, triggerDependencies_2, newFactEditors$lambda_9(init_2)), processPropertyReferenceEditor(), variableReferenceValueEditor(), propertyReferenceValueEditor(), setExpressionEditor(), multipliedExpressionEditor(), libraryProcessSpecificationEditor(), ontologyElementReferenceValueLibraryEditor(), ontologyElementReferenceValueEditor(), measurableValueEditor(), enumValueEditor(), complexNotionValueEditor(), unionEditor()];
      var tmp_6 = new HierarchyEditorDefinition(getKClass(FactExpression), tmp0_0, toList(editorDefinitions));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
      var placeholderText = '<expressions>';
      var separator_1 = get_defaultChildrenSeparator();
      var tmp0_4 = new ChildrenRoleDefaults(getKClass(FactExpressionPlaceholder), placeholderText, null, separator_1, null, true);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_3 = newFactEditors$lambda_10;
      var triggerDependencies_3 = emptyList();
      var tmp_7 = getKClass(FactExpressionPlaceholder);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.hierarchyEditor' call
      var editorDefinitions_0 = [tmp_6, new EditorDefinition(tmp_7, tmp0_4, null, false, true, triggerDependencies_3, newFactEditors$lambda_11(init_3))];
      var tmp_8 = new HierarchyEditorDefinition(getKClass(FactExpressionPlaceholder), tmp0, toList(editorDefinitions_0));
      var tmp0_5 = childRoleDefaults('<expression>', newFactEditors$lambda_12, VOID, false);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_4 = newFactEditors$lambda_13;
      var triggerDependencies_4 = emptyList();
      var tmp_9 = getKClass(QueryLabelsFactExpressionContainer_0);
      var tmp_10 = new EditorDefinition(tmp_9, tmp0_5, null, false, true, triggerDependencies_4, newFactEditors$lambda_14(init_4));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
      var separator_2 = get_defaultChildrenSeparator();
      var tmp0_6 = new ChildrenRoleDefaults(getKClass(NewFact), '<facts>', null, separator_2, null, true);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_5 = newFactEditors$lambda_15;
      var triggerDependencies_5 = emptyList();
      var tmp_11 = getKClass(NewFact);
      var tmp$ret$12 = new EditorDefinition(tmp_11, tmp0_6, null, false, true, triggerDependencies_5, newFactEditors$lambda_16(init_5));
      newFactEditors = listOf_0([tmp_8, tmp_10, tmp$ret$12]);
      QUERY_LABELS_CONTAINER_MARK = new CellMark();
    }
  }
  function get_notionLibraryEditors() {
    _init_properties_NotionLibraryEditors_kt__4npby8();
    return notionLibraryEditors;
  }
  var notionLibraryEditors;
  function notionCompletion(_this__u8e3s4) {
    _init_properties_NotionLibraryEditors_kt__4npby8();
    _this__u8e3s4.bck('enumerable notion', notionCompletion$lambda(_this__u8e3s4));
    _this__u8e3s4.bck('measurable notion', notionCompletion$lambda_0(_this__u8e3s4));
    complexNotionCompletion(_this__u8e3s4);
  }
  function notionLibraryEditors$lambda($this$editor) {
    _init_properties_NotionLibraryEditors_kt__4npby8();
    indent_0($this$editor, VOID, VOID, notionLibraryEditors$lambda$lambda);
    return Unit_instance;
  }
  function notionLibraryEditors$lambda$lambda($this$indent) {
    _init_properties_NotionLibraryEditors_kt__4npby8();
    var tmp = getKClass(AbstractNotion);
    var tmp_0 = Layout_VERTICAL_getInstance();
    children_2($this$indent, tmp, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp_0, notionLibraryEditors$lambda$lambda$lambda);
    return Unit_instance;
  }
  function notionLibraryEditors$lambda$lambda$lambda(notionLibrary) {
    _init_properties_NotionLibraryEditors_kt__4npby8();
    return notionLibrary.efs();
  }
  function notionLibraryEditors$lambda_0($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function notionLibraryEditors$lambda_1(wrapperContext) {
    _init_properties_NotionLibraryEditors_kt__4npby8();
    return NotionPlaceholder(wrapperContext);
  }
  function notionLibraryEditors$lambda_2($this$childrenRoleDefaults) {
    _init_properties_NotionLibraryEditors_kt__4npby8();
    notionCompletion($this$childrenRoleDefaults);
    return Unit_instance;
  }
  function notionLibraryEditors$lambda_3($this$editor) {
    _init_properties_NotionLibraryEditors_kt__4npby8();
    keyword_0($this$editor, 'enumerable notion');
    space_0($this$editor);
    textProperty_0($this$editor, '<name>', notionLibraryEditors$lambda$lambda_0);
    indent_0($this$editor, true, VOID, notionLibraryEditors$lambda$lambda_1);
    return Unit_instance;
  }
  function notionLibraryEditors$lambda$lambda_0(it) {
    _init_properties_NotionLibraryEditors_kt__4npby8();
    return it.y2();
  }
  function notionLibraryEditors$lambda$lambda_1($this$indent) {
    _init_properties_NotionLibraryEditors_kt__4npby8();
    newLine_0($this$indent);
    keyword_0($this$indent, 'values:');
    space_0($this$indent);
    var valuesList;
    var tmp = getKClass(EnumerationConstant_1);
    // Inline function 'kotlin.also' call
    valuesList = children_2($this$indent, tmp, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, notionLibraryEditors$lambda$lambda$lambda_0);
    ensureLastCaretPosition($this$indent);
    disambiguateBy($this$indent, valuesList);
    return Unit_instance;
  }
  function notionLibraryEditors$lambda$lambda$lambda_0(enumerableNotion) {
    _init_properties_NotionLibraryEditors_kt__4npby8();
    return enumerableNotion.qfq();
  }
  function notionLibraryEditors$lambda_4($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function notionLibraryEditors$lambda_5($this$editor) {
    _init_properties_NotionLibraryEditors_kt__4npby8();
    keyword_0($this$editor, 'measurable notion');
    space_0($this$editor);
    textProperty_0($this$editor, '<name>', notionLibraryEditors$lambda$lambda_2);
    indent_0($this$editor, true, VOID, notionLibraryEditors$lambda$lambda_3);
    return Unit_instance;
  }
  function notionLibraryEditors$lambda$lambda_2(measurableNotion) {
    _init_properties_NotionLibraryEditors_kt__4npby8();
    return measurableNotion.y2();
  }
  function notionLibraryEditors$lambda$lambda_3($this$indent) {
    _init_properties_NotionLibraryEditors_kt__4npby8();
    newLine_0($this$indent);
    keyword_0($this$indent, 'measured in:');
    space_0($this$indent);
    var unitList;
    var tmp = getKClass(MeasurementUnit_1);
    // Inline function 'kotlin.also' call
    unitList = children_2($this$indent, tmp, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, notionLibraryEditors$lambda$lambda$lambda_1);
    ensureLastCaretPosition($this$indent);
    disambiguateBy($this$indent, unitList);
    return Unit_instance;
  }
  function notionLibraryEditors$lambda$lambda$lambda_1(measurableNotion) {
    _init_properties_NotionLibraryEditors_kt__4npby8();
    return measurableNotion.xfr();
  }
  function notionLibraryEditors$lambda_6($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function notionLibraryEditors$lambda_7($this$editor) {
    _init_properties_NotionLibraryEditors_kt__4npby8();
    placeholderInCollection_0($this$editor, VOID, notionLibraryEditors$lambda$lambda_4);
    return Unit_instance;
  }
  function notionLibraryEditors$lambda$lambda_4($this$placeholderInCollection) {
    _init_properties_NotionLibraryEditors_kt__4npby8();
    notionCompletion($this$placeholderInCollection);
    return Unit_instance;
  }
  function notionLibraryEditors$lambda_8($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function notionLibraryEditors$lambda_9($this$childrenRoleDefaults) {
    _init_properties_NotionLibraryEditors_kt__4npby8();
    var tmp = $this$childrenRoleDefaults.qci();
    $this$childrenRoleDefaults.dck(tmp, notionLibraryEditors$lambda$lambda_5($this$childrenRoleDefaults));
    return Unit_instance;
  }
  function notionLibraryEditors$lambda$lambda_5($this_childrenRoleDefaults) {
    return function (name) {
      // Inline function 'kotlin.apply' call
      var this_0 = MeasurementUnit($this_childrenRoleDefaults.l6z());
      this_0.y2().f2x(name);
      return this_0;
    };
  }
  function notionLibraryEditors$lambda_10($this$editor) {
    _init_properties_NotionLibraryEditors_kt__4npby8();
    indent_0($this$editor, VOID, VOID, notionLibraryEditors$lambda$lambda_6);
    return Unit_instance;
  }
  function notionLibraryEditors$lambda$lambda_6($this$indent) {
    _init_properties_NotionLibraryEditors_kt__4npby8();
    var tmp = notionLibraryEditors$lambda$lambda$lambda_2;
    var text = editableText_0($this$indent, VOID, '<unit>', tmp, VOID, notionLibraryEditors$lambda$lambda$lambda_3);
    var defaultMarker = indent_0($this$indent, VOID, VOID, notionLibraryEditors$lambda$lambda$lambda_4(text));
    // Inline function 'jetbrains.ocelot.mapper.core.Synchronizers.forDisposable' call
    var tmp$ret$0 = new notionLibraryEditors$16$2$$inlined$forDisposable$1($this$indent, defaultMarker);
    $this$indent.l8b(tmp$ret$0);
    return Unit_instance;
  }
  function notionLibraryEditors$lambda$lambda$lambda_2(it) {
    _init_properties_NotionLibraryEditors_kt__4npby8();
    return !contains_8(it, ',') && !contains_8(it, ' ');
  }
  function notionLibraryEditors$lambda$lambda$lambda_3($this$editableText) {
    _init_properties_NotionLibraryEditors_kt__4npby8();
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.textSyncTwoWay' call
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.textCellSyncTwoWay' call
    var sourceProp = $this$editableText.m6d().y2();
    var targetProp = $this$editableText.qd0().o8w();
    $this$editableText.l8b(syncTwoWay(sourceProp.m5y(), targetProp));
    rightTransform_0($this$editableText, notionLibraryEditors$lambda$lambda$lambda$lambda($this$editableText));
    return Unit_instance;
  }
  function notionLibraryEditors$lambda$lambda$lambda$lambda$lambda($this_editableText) {
    return function () {
      $this_editableText.m6d().afs().d2x(true);
      return toEnd_0($this_editableText.qd0());
    };
  }
  function notionLibraryEditors$lambda$lambda$lambda$lambda($this_editableText) {
    return function ($this$rightTransform, _unused_var__etf5q3, _unused_var__etf5q3_0, _unused_var__etf5q3_1) {
      var tmp;
      if (!$this_editableText.m6d().afs().m5y().w2w()) {
        $this$rightTransform.gcg('default', notionLibraryEditors$lambda$lambda$lambda$lambda$lambda($this_editableText));
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function notionLibraryEditors$16$2$2$2$2$$inlined$createDeleteTransformTrait$1($this_keyword, $text) {
    this.oud_1 = $this_keyword;
    this.pud_1 = $text;
    DeleteTransformTrait.call(this);
  }
  protoOf(notionLibraryEditors$16$2$2$2$2$$inlined$createDeleteTransformTrait$1).tu1 = function (cell) {
    this.oud_1.m6d().afs().d2x(false);
    toEnd_0(this.pud_1)();
    return Unit_instance;
  };
  function notionLibraryEditors$lambda$lambda$lambda$lambda$lambda_0($this_keyword, $text) {
    return function (_unused_var__etf5q3, _unused_var__etf5q3_0, _unused_var__etf5q3_1) {
      // Inline function 'jetbrains.biokb.lang.traits.createDeleteTransformTrait' call
      return new notionLibraryEditors$16$2$2$2$2$$inlined$createDeleteTransformTrait$1($this_keyword, $text);
    };
  }
  function notionLibraryEditors$lambda$lambda$lambda$lambda_0($text) {
    return function ($this$keyword) {
      addTraitOnAttach_0($this$keyword, notionLibraryEditors$lambda$lambda$lambda$lambda$lambda_0($this$keyword, $text));
      return Unit_instance;
    };
  }
  function notionLibraryEditors$lambda$lambda$lambda_4($text) {
    return function ($this$indent) {
      space_0($this$indent);
      var openParen = indentLabel_0($this$indent, '(');
      keyword_0($this$indent, 'default', notionLibraryEditors$lambda$lambda$lambda$lambda_0($text));
      closingFor(indentLabel_0($this$indent, ')', true), openParen);
      return Unit_instance;
    };
  }
  function notionLibraryEditors$16$2$$inlined$forDisposable$1($this_indent, $defaultMarker) {
    this.rud_1 = $this_indent;
    this.sud_1 = $defaultMarker;
    DisposableSynchronizer.call(this);
  }
  protoOf(notionLibraryEditors$16$2$$inlined$forDisposable$1).s87 = function (ctx) {
    return PropertyBinding_instance.n30(this.rud_1.m6d().afs().m5y(), this.sud_1.m92());
  };
  function notionLibraryEditors$lambda_11($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function notionLibraryEditors$lambda_12($this$childrenRoleDefaults) {
    _init_properties_NotionLibraryEditors_kt__4npby8();
    var tmp = $this$childrenRoleDefaults.qci();
    $this$childrenRoleDefaults.dck(tmp, notionLibraryEditors$lambda$lambda_7($this$childrenRoleDefaults));
    return Unit_instance;
  }
  function notionLibraryEditors$lambda$lambda_7($this_childrenRoleDefaults) {
    return function (name) {
      // Inline function 'kotlin.apply' call
      var this_0 = EnumerationConstant($this_childrenRoleDefaults.l6z());
      this_0.y2().f2x(name);
      return this_0;
    };
  }
  function notionLibraryEditors$lambda_13($this$editor) {
    _init_properties_NotionLibraryEditors_kt__4npby8();
    indent_0($this$editor, VOID, VOID, notionLibraryEditors$lambda$lambda_8);
    return Unit_instance;
  }
  function notionLibraryEditors$lambda$lambda_8($this$indent) {
    _init_properties_NotionLibraryEditors_kt__4npby8();
    var tmp = notionLibraryEditors$lambda$lambda$lambda_5;
    editableText_0($this$indent, VOID, '<name>', tmp, VOID, notionLibraryEditors$lambda$lambda$lambda_6);
    return Unit_instance;
  }
  function notionLibraryEditors$lambda$lambda$lambda_5(it) {
    _init_properties_NotionLibraryEditors_kt__4npby8();
    return !contains_8(it, ',');
  }
  function notionLibraryEditors$lambda$lambda$lambda_6($this$editableText) {
    _init_properties_NotionLibraryEditors_kt__4npby8();
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.textSyncTwoWay' call
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.textCellSyncTwoWay' call
    var sourceProp = $this$editableText.m6d().y2();
    var targetProp = $this$editableText.qd0().o8w();
    $this$editableText.l8b(syncTwoWay(sourceProp.m5y(), targetProp));
    return Unit_instance;
  }
  function notionLibraryEditors$lambda_14($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function notionCompletion$lambda($this_notionCompletion) {
    return function () {
      return EnumerableNotion($this_notionCompletion.l6z());
    };
  }
  function notionCompletion$lambda_0($this_notionCompletion) {
    return function () {
      return MeasurableNotion($this_notionCompletion.l6z());
    };
  }
  var properties_initialized_NotionLibraryEditors_kt_1z54im;
  function _init_properties_NotionLibraryEditors_kt__4npby8() {
    if (!properties_initialized_NotionLibraryEditors_kt_1z54im) {
      properties_initialized_NotionLibraryEditors_kt_1z54im = true;
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init = notionLibraryEditors$lambda;
      var triggerDependencies = emptyList();
      var tmp = getKClass(NotionLibrary_1);
      var tmp_0 = new EditorDefinition(tmp, null, null, false, true, triggerDependencies, notionLibraryEditors$lambda_0(init));
      var tmp0 = '<notions>';
      var tmp2 = notionLibraryEditors$lambda_1;
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
      var completionSupplier = notionLibraryEditors$lambda_2;
      var separator_0 = get_defaultChildrenSeparator();
      var tmp0_0 = new ChildrenRoleDefaults(getKClass(AbstractNotion), tmp0, tmp2, separator_0, completionSupplier, true);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_0 = notionLibraryEditors$lambda_3;
      var triggerDependencies_0 = emptyList();
      var tmp_1 = getKClass(EnumerableNotion_1);
      var tmp_2 = new EditorDefinition(tmp_1, null, null, false, true, triggerDependencies_0, notionLibraryEditors$lambda_4(init_0));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_1 = notionLibraryEditors$lambda_5;
      var triggerDependencies_1 = emptyList();
      var tmp_3 = getKClass(MeasurableNotion_1);
      var tmp_4 = new EditorDefinition(tmp_3, null, null, false, true, triggerDependencies_1, notionLibraryEditors$lambda_6(init_1));
      var tmp_5 = complexNotionEditor();
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_2 = notionLibraryEditors$lambda_7;
      var triggerDependencies_2 = emptyList();
      var tmp_6 = getKClass(NotionPlaceholder_1);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.hierarchyEditor' call
      var editorDefinitions = [tmp_2, tmp_4, tmp_5, new EditorDefinition(tmp_6, null, null, false, true, triggerDependencies_2, notionLibraryEditors$lambda_8(init_2))];
      var tmp_7 = new HierarchyEditorDefinition(getKClass(AbstractNotion), tmp0_0, toList(editorDefinitions));
      var tmp2_0 = separator(',');
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
      var completionSupplier_0 = notionLibraryEditors$lambda_9;
      var tmp0_1 = new ChildrenRoleDefaults(getKClass(MeasurementUnit_1), '<units>', null, tmp2_0, completionSupplier_0, true);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_3 = notionLibraryEditors$lambda_10;
      var triggerDependencies_3 = emptyList();
      var tmp_8 = getKClass(MeasurementUnit_1);
      var tmp_9 = new EditorDefinition(tmp_8, tmp0_1, null, false, true, triggerDependencies_3, notionLibraryEditors$lambda_11(init_3));
      var tmp0_2 = '<constants>';
      var tmp2_1 = separator(',');
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
      var completionSupplier_1 = notionLibraryEditors$lambda_12;
      var tmp0_3 = new ChildrenRoleDefaults(getKClass(EnumerationConstant_1), tmp0_2, null, tmp2_1, completionSupplier_1, true);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_4 = notionLibraryEditors$lambda_13;
      var triggerDependencies_4 = emptyList();
      var tmp_10 = getKClass(EnumerationConstant_1);
      var tmp$ret$9 = new EditorDefinition(tmp_10, tmp0_3, null, false, true, triggerDependencies_4, notionLibraryEditors$lambda_14(init_4));
      notionLibraryEditors = listOf_0([tmp_0, tmp_7, tmp_9, tmp$ret$9, complexNotionElementEditor(), allowedComplexNotionTypeEditor(), allowedComplexNotionValueEditor(), complexNotionTemplateEditor(), complexNotionTemplateElementEditor()]);
    }
  }
  function get_completion() {
    _init_properties_ObjectProperties_kt__dw6gpa();
    return completion_2;
  }
  var completion_2;
  function get_objectPropertyEditors() {
    _init_properties_ObjectProperties_kt__dw6gpa();
    return objectPropertyEditors;
  }
  var objectPropertyEditors;
  function propertyConstraints(_this__u8e3s4, showUnderscore) {
    showUnderscore = showUnderscore === VOID ? true : showUnderscore;
    _init_properties_ObjectProperties_kt__dw6gpa();
    var constraintsCell = {_v: null};
    var tmp = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_0 = getPropertyCallableRef('constraints', 1, tmp, HasPropertyConstraints$_get_constraints_$ref_5lfcib_4(), null);
    var link = new MultipleChildLink(getKClass(HasPropertyConstraints), this_0);
    var tmp_0;
    if (!get_internalConfig(_this__u8e3s4).acu()) {
      label_0(_this__u8e3s4, '[', VOID, false);
      // Inline function 'kotlin.apply' call
      var this_1 = label_0(_this__u8e3s4, '+');
      PropertyBinding_instance.n30(ifProp(this_1.y92(), Companion_getInstance_210().w95_1, Companion_getInstance_210().r95_1), this_1.b97());
      // Inline function 'jetbrains.ocelot.projectional.cell.trait.keyPressedCellTrait' call
      var tmp$ret$1 = new propertyConstraints$$inlined$apply$1(constraintsCell);
      this_1.w92(tmp$ret$1);
      var button = this_1;
      label_0(_this__u8e3s4, ']', false);
      tmp_0 = button;
    } else {
      tmp_0 = null;
    }
    var constraintButton = tmp_0;
    constraintsCell._v = indent_0(_this__u8e3s4, true, VOID, propertyConstraints$lambda(constraintButton, link, showUnderscore, constraintsCell));
    // Inline function 'jetbrains.ocelot.mapper.core.Synchronizers.forDisposable' call
    var visibleSync = new propertyConstraints$$inlined$forDisposable$1(link, _this__u8e3s4, constraintsCell);
    _this__u8e3s4.l8b(visibleSync);
  }
  function completion$lambda_1(_this__u8e3s4) {
    _init_properties_ObjectProperties_kt__dw6gpa();
    _this__u8e3s4.bck('property', completion$lambda$lambda(_this__u8e3s4));
    return Unit_instance;
  }
  function completion$lambda$lambda($this) {
    return function () {
      return ObjectPropertyDeclaration($this.l6z());
    };
  }
  function objectPropertyEditors$lambda($this$editor) {
    _init_properties_ObjectProperties_kt__dw6gpa();
    indent_0($this$editor, VOID, VOID, objectPropertyEditors$lambda$lambda);
    return Unit_instance;
  }
  function objectPropertyEditors$lambda$lambda($this$indent) {
    _init_properties_ObjectProperties_kt__dw6gpa();
    var tmp = getKClass(ObjectPropertyDeclaration_1);
    var tmp_0 = Layout_VERTICAL_getInstance();
    children_2($this$indent, tmp, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp_0, objectPropertyEditors$lambda$lambda$lambda);
    return Unit_instance;
  }
  function objectPropertyEditors$lambda$lambda$lambda(it) {
    _init_properties_ObjectProperties_kt__dw6gpa();
    return it.rfp();
  }
  function objectPropertyEditors$lambda_0($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function objectPropertyEditors$lambda_1($this$editor) {
    _init_properties_ObjectProperties_kt__dw6gpa();
    commentEditor($this$editor);
    newLine_0($this$editor);
    keyword_0($this$editor, 'property');
    space_0($this$editor);
    textProperty_0($this$editor, '<name>', objectPropertyEditors$lambda$lambda_0);
    indent_0($this$editor, true, VOID, objectPropertyEditors$lambda$lambda_1);
    newLine_0($this$editor);
    return Unit_instance;
  }
  function objectPropertyEditors$lambda$lambda_0(it) {
    _init_properties_ObjectProperties_kt__dw6gpa();
    return it.y2();
  }
  function objectPropertyEditors$lambda$lambda_1($this$indent) {
    _init_properties_ObjectProperties_kt__dw6gpa();
    newLine_0($this$indent);
    keyword_0($this$indent, 'grouping:');
    space_0($this$indent);
    booleanProperty($this$indent, '<true|false>', objectPropertyEditors$lambda$lambda$lambda_0);
    newLine_0($this$indent);
    keyword_0($this$indent, 'super property:');
    space_0($this$indent);
    var tmp4 = Companion_getInstance_332().ugw_1;
    // Inline function 'jetbrains.biokb.lang.editorBuilders.btbReferenceTarget' call
    var referenceProvider = objectPropertyEditors$lambda$lambda$lambda_1;
    var options = new CompletionOptions();
    var containerInit = objectPropertyEditors$lambda$lambda$lambda_2;
    var textCellInit = objectPropertyEditors$lambda$lambda$lambda_3;
    var tmp;
    if (null == null) {
      tmp = objectPropertyEditors$lambda$lambda$lambda_4;
    } else {
      tmp = null;
    }
    var tmp10 = tmp;
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.references.referenceTarget' call
    var textCellInit_0 = objectPropertyEditors$lambda$lambda$lambda_5(textCellInit);
    var targetClass = getKClass(ObjectPropertyDeclaration_1);
    referenceTarget($this$indent, targetClass, '<none>', tmp4, referenceProvider, null, tmp10, options, containerInit, textCellInit_0);
    newLine_0($this$indent);
    keyword_0($this$indent, 'domain:');
    space_0($this$indent);
    var tmp_0 = getKClass(Type);
    var tmp_1 = separator(',');
    children_2($this$indent, tmp_0, VOID, VOID, VOID, tmp_1, VOID, VOID, VOID, VOID, objectPropertyEditors$lambda$lambda$lambda_6);
    newLine_0($this$indent);
    keyword_0($this$indent, 'range:');
    space_0($this$indent);
    var tmp2 = getKClass(PropertyValueRange);
    var tmp_2 = KProperty1;
    var tmp4_0 = getPropertyCallableRef('range', 1, tmp_2, ObjectPropertyDeclaration$_get_range_$ref_rc2nln_1(), null);
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.child' call
    var placeholderText = '<no range>';
    var placeholderTraitFactory = objectPropertyEditors$lambda$lambda$lambda_7;
    var tmp_3 = objectPropertyEditors$lambda$lambda$lambda_8(tmp4_0);
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$2 = new SingleChildLink(getKClass(ObjectPropertyDeclaration_1), tmp4_0);
    child_1($this$indent, tmp2, tmp_3, placeholderText, placeholderTraitFactory, null, null, null, null, tmp$ret$2, null);
    newLine_0($this$indent);
    keyword_0($this$indent, 'dependent:');
    space_0($this$indent);
    booleanProperty($this$indent, '<true|false>', objectPropertyEditors$lambda$lambda$lambda_9);
    newLine_0($this$indent);
    keyword_0($this$indent, 'inverse:');
    space_0($this$indent);
    var tmp4_1 = Companion_getInstance_332().vgw_1;
    // Inline function 'jetbrains.biokb.lang.editorBuilders.btbReferenceTarget' call
    var referenceProvider_0 = objectPropertyEditors$lambda$lambda$lambda_10;
    var options_0 = new CompletionOptions();
    var containerInit_0 = objectPropertyEditors$lambda$lambda$lambda_11;
    var textCellInit_1 = objectPropertyEditors$lambda$lambda$lambda_12;
    var tmp_4;
    if (null == null) {
      tmp_4 = objectPropertyEditors$lambda$lambda$lambda_13;
    } else {
      tmp_4 = null;
    }
    var tmp10_0 = tmp_4;
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.references.referenceTarget' call
    var textCellInit_2 = objectPropertyEditors$lambda$lambda$lambda_14(textCellInit_1);
    var targetClass_0 = getKClass(ObjectPropertyDeclaration_1);
    referenceTarget($this$indent, targetClass_0, '<none>', tmp4_1, referenceProvider_0, null, tmp10_0, options_0, containerInit_0, textCellInit_2);
    newLine_0($this$indent);
    return Unit_instance;
  }
  function objectPropertyEditors$lambda$lambda$lambda_0(it) {
    _init_properties_ObjectProperties_kt__dw6gpa();
    return it.ffs();
  }
  function objectPropertyEditors$lambda$lambda$lambda_1(it) {
    _init_properties_ObjectProperties_kt__dw6gpa();
    return it.gfs();
  }
  function objectPropertyEditors$lambda$lambda$lambda_2(_this__u8e3s4) {
    _init_properties_ObjectProperties_kt__dw6gpa();
    return Unit_instance;
  }
  function objectPropertyEditors$lambda$lambda$lambda_3(_this__u8e3s4) {
    _init_properties_ObjectProperties_kt__dw6gpa();
    return Unit_instance;
  }
  function objectPropertyEditors$lambda$lambda$lambda_4(it) {
    _init_properties_ObjectProperties_kt__dw6gpa();
    return true;
  }
  function objectPropertyEditors$lambda$lambda$lambda_5($textCellInit) {
    return function ($this$referenceTarget) {
      $textCellInit($this$referenceTarget);
      enableEagerCompletion($this$referenceTarget);
      return Unit_instance;
    };
  }
  function objectPropertyEditors$lambda$lambda$lambda_6(it) {
    _init_properties_ObjectProperties_kt__dw6gpa();
    return it.ufr();
  }
  function ObjectPropertyDeclaration$_get_range_$ref_rc2nln_1() {
    return function (p0) {
      return p0.hd();
    };
  }
  function objectPropertyEditors$lambda$lambda$lambda_7(_unused_var__etf5q3, trait) {
    _init_properties_ObjectProperties_kt__dw6gpa();
    return trait;
  }
  function objectPropertyEditors$lambda$lambda$lambda_8($childProperty) {
    return function (it) {
      return $childProperty(it);
    };
  }
  function objectPropertyEditors$lambda$lambda$lambda_9(it) {
    _init_properties_ObjectProperties_kt__dw6gpa();
    return it.hfs();
  }
  function objectPropertyEditors$lambda$lambda$lambda_10(it) {
    _init_properties_ObjectProperties_kt__dw6gpa();
    return it.ifs();
  }
  function objectPropertyEditors$lambda$lambda$lambda_11(_this__u8e3s4) {
    _init_properties_ObjectProperties_kt__dw6gpa();
    return Unit_instance;
  }
  function objectPropertyEditors$lambda$lambda$lambda_12(_this__u8e3s4) {
    _init_properties_ObjectProperties_kt__dw6gpa();
    return Unit_instance;
  }
  function objectPropertyEditors$lambda$lambda$lambda_13(it) {
    _init_properties_ObjectProperties_kt__dw6gpa();
    return true;
  }
  function objectPropertyEditors$lambda$lambda$lambda_14($textCellInit) {
    return function ($this$referenceTarget) {
      $textCellInit($this$referenceTarget);
      enableEagerCompletion($this$referenceTarget);
      return Unit_instance;
    };
  }
  function objectPropertyEditors$lambda_2($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function objectPropertyEditors$lambda_3($this$childrenRoleDefaults) {
    _init_properties_ObjectProperties_kt__dw6gpa();
    $this$childrenRoleDefaults.bck('abstract', objectPropertyEditors$lambda$lambda_2($this$childrenRoleDefaults));
    $this$childrenRoleDefaults.bck('{', objectPropertyEditors$lambda$lambda_3($this$childrenRoleDefaults));
    var tmp = $this$childrenRoleDefaults.ick(get_objectTypeCompletion());
    $this$childrenRoleDefaults.jck(tmp, objectPropertyEditors$lambda$lambda_4($this$childrenRoleDefaults));
    return Unit_instance;
  }
  function objectPropertyEditors$lambda$lambda_2($this_childrenRoleDefaults) {
    return function () {
      return NoValues($this_childrenRoleDefaults.l6z());
    };
  }
  function objectPropertyEditors$lambda$lambda_3($this_childrenRoleDefaults) {
    return function () {
      return MultiplePropertyValueRange($this_childrenRoleDefaults.l6z());
    };
  }
  function objectPropertyEditors$lambda$lambda_4($this_childrenRoleDefaults) {
    return function (type) {
      // Inline function 'kotlin.apply' call
      var this_0 = SinglePropertyValueRange($this_childrenRoleDefaults.l6z());
      this_0.cfs().j(type);
      return this_0;
    };
  }
  function objectPropertyEditors$lambda_4($this$editor) {
    _init_properties_ObjectProperties_kt__dw6gpa();
    keyword_0($this$editor, 'abstract');
    return Unit_instance;
  }
  function objectPropertyEditors$lambda_5($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function objectPropertyEditors$lambda_6($this$editor) {
    _init_properties_ObjectProperties_kt__dw6gpa();
    var c = {_v: null};
    var tmp = getKClass(Type);
    var tmp_0 = separator(',');
    var tmp_1 = objectPropertyEditors$lambda$lambda_5(c);
    c._v = children_2($this$editor, tmp, VOID, VOID, VOID, tmp_0, VOID, VOID, tmp_1, VOID, objectPropertyEditors$lambda$lambda_6);
    var tmp_2;
    if (c._v == null) {
      throwUninitializedPropertyAccessException('c');
    } else {
      tmp_2 = c._v;
    }
    considerEmptyBy($this$editor, tmp_2);
    deleteIfEmpty($this$editor);
    return Unit_instance;
  }
  function objectPropertyEditors$lambda$lambda_5($c) {
    return function () {
      var tmp;
      if ($c._v == null) {
        throwUninitializedPropertyAccessException('c');
      } else {
        tmp = $c._v;
      }
      sendBecameEmpty(tmp);
      return Unit_instance;
    };
  }
  function objectPropertyEditors$lambda$lambda_6(it) {
    _init_properties_ObjectProperties_kt__dw6gpa();
    return it.cfs();
  }
  function objectPropertyEditors$lambda_7($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function objectPropertyEditors$lambda_8($this$editor) {
    _init_properties_ObjectProperties_kt__dw6gpa();
    // Inline function 'kotlin.apply' call
    label_0($this$editor, '{').d97().f2x(true);
    space_0($this$editor);
    var tmp = getKClass(Type);
    var tmp_0 = separator(',');
    children_2($this$editor, tmp, VOID, VOID, VOID, tmp_0, VOID, VOID, VOID, VOID, objectPropertyEditors$lambda$lambda_7);
    space_0($this$editor);
    // Inline function 'kotlin.apply' call
    label_0($this$editor, '}').d97().f2x(true);
    return Unit_instance;
  }
  function objectPropertyEditors$lambda$lambda_7(it) {
    _init_properties_ObjectProperties_kt__dw6gpa();
    return it.cfs();
  }
  function objectPropertyEditors$lambda_9($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function objectPropertyEditors$lambda_10($this$childrenRoleDefaults) {
    _init_properties_ObjectProperties_kt__dw6gpa();
    var tmp = $this$childrenRoleDefaults.jcg(Companion_getInstance_333().uhj_1);
    $this$childrenRoleDefaults.gck(tmp, objectPropertyEditors$lambda$lambda_8($this$childrenRoleDefaults));
    return Unit_instance;
  }
  function objectPropertyEditors$lambda$lambda_8($this_childrenRoleDefaults) {
    return function (content) {
      // Inline function 'kotlin.apply' call
      var this_0 = PropertyConstraint($this_childrenRoleDefaults.l6z());
      this_0.q6q().b6p(content);
      return this_0;
    };
  }
  function objectPropertyEditors$lambda_11($this$editor) {
    _init_properties_ObjectProperties_kt__dw6gpa();
    var tmp2 = '<property>';
    var tmp4 = Companion_getInstance_333().uhj_1;
    // Inline function 'jetbrains.biokb.lang.editorBuilders.btbReferenceTarget' call
    var referenceProvider = objectPropertyEditors$lambda$lambda_9;
    var options = new CompletionOptions();
    var containerInit = objectPropertyEditors$lambda$lambda_10;
    var textCellInit = objectPropertyEditors$lambda$lambda_11;
    var tmp;
    if (null == null) {
      tmp = objectPropertyEditors$lambda$lambda_12;
    } else {
      tmp = null;
    }
    var tmp10 = tmp;
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.references.referenceTarget' call
    var textCellInit_0 = objectPropertyEditors$lambda$lambda_13(textCellInit);
    var targetClass = getKClass(ObjectPropertyDeclaration_1);
    referenceTarget($this$editor, targetClass, tmp2, tmp4, referenceProvider, null, tmp10, options, containerInit, textCellInit_0);
    space_0($this$editor);
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.enumProperty' call
    editableText_0($this$editor, VOID, '=', VOID, VOID, objectPropertyEditors$lambda$lambda_14);
    space_0($this$editor);
    var tmp2_0 = getKClass(AbstractValue);
    var tmp_0 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.child' call
    var childProperty = getPropertyCallableRef('value', 1, tmp_0, PropertyConstraint$_get_value_$ref_f1oxa5_2(), null);
    var placeholderTraitFactory = objectPropertyEditors$lambda$lambda_15;
    var tmp_1 = objectPropertyEditors$lambda$lambda_16(childProperty);
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$3 = new SingleChildLink(getKClass(PropertyConstraint_1), childProperty);
    child_1($this$editor, tmp2_0, tmp_1, null, placeholderTraitFactory, null, null, null, null, tmp$ret$3, null);
    propertyConstraints($this$editor);
    return Unit_instance;
  }
  function objectPropertyEditors$lambda$lambda_9(it) {
    _init_properties_ObjectProperties_kt__dw6gpa();
    return it.q6q();
  }
  function objectPropertyEditors$lambda$lambda_10(_this__u8e3s4) {
    _init_properties_ObjectProperties_kt__dw6gpa();
    return Unit_instance;
  }
  function objectPropertyEditors$lambda$lambda_11(_this__u8e3s4) {
    _init_properties_ObjectProperties_kt__dw6gpa();
    return Unit_instance;
  }
  function objectPropertyEditors$lambda$lambda_12(it) {
    _init_properties_ObjectProperties_kt__dw6gpa();
    return true;
  }
  function objectPropertyEditors$lambda$lambda_13($textCellInit) {
    return function ($this$referenceTarget) {
      $textCellInit($this$referenceTarget);
      enableEagerCompletion($this$referenceTarget);
      return Unit_instance;
    };
  }
  function objectPropertyEditors$lambda$lambda_14($this$editableText) {
    _init_properties_ObjectProperties_kt__dw6gpa();
    switch (get_internalConfig($this$editableText).nd0().uct_1.x2_1) {
      case 0:
        // Inline function 'jetbrains.ocelot.langDef.editorBuilder.enumSyncTwoWay' call

        var targetPropFactory = objectPropertyEditors$lambda$lambda$lambda_15;
        // Inline function 'jetbrains.ocelot.langDef.editorBuilder.textCellSyncTwoWay' call

        var sourceProp = $this$editableText.m6d().s3z();
        var targetProp = targetPropFactory($this$editableText.qd0());
        $this$editableText.l8b(syncTwoWay(sourceProp.m5y(), targetProp));
        break;
      case 1:
        // Inline function 'jetbrains.ocelot.langDef.editorBuilder.enumSyncTwoWay' call

        var targetPropFactory_0 = objectPropertyEditors$lambda$lambda$lambda_16;
        // Inline function 'jetbrains.ocelot.langDef.editorBuilder.textCellSyncTwoWay' call

        var sourceProp_0 = $this$editableText.m6d().s3z();
        var targetProp_0 = targetPropFactory_0($this$editableText.qd0());
        $this$editableText.l8b(syncTwoWay(sourceProp_0.m5y(), targetProp_0));
        break;
      default:
        var tmp = $this$editableText.qd0().o8w();
        var tmp1_safe_receiver = $this$editableText.m6d().s3z().m5y().w2w();
        var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.toString();
        tmp.f2x(tmp2_elvis_lhs == null ? '' : tmp2_elvis_lhs);
        break;
    }
    return Unit_instance;
  }
  function objectPropertyEditors$lambda$lambda$lambda_15(textCell) {
    _init_properties_ObjectProperties_kt__dw6gpa();
    // Inline function 'jetbrains.ocelot.base.enums.EnumInfoFactory.createEnumInfo' call
    // Inline function 'kotlin.enumValues' call
    var tmp$ret$0 = values_15();
    var enumInfo = new EnumInfoImpl(tmp$ret$0);
    return ValueEditors_instance.uag(textCell, enumInfo);
  }
  function objectPropertyEditors$lambda$lambda$lambda_16(textCell) {
    _init_properties_ObjectProperties_kt__dw6gpa();
    // Inline function 'jetbrains.ocelot.base.enums.EnumInfoFactory.createEnumInfo' call
    // Inline function 'kotlin.enumValues' call
    var tmp$ret$0 = values_15();
    var enumInfo = new EnumInfoImpl(tmp$ret$0);
    return ValueEditors_instance.uag(textCell, enumInfo);
  }
  function PropertyConstraint$_get_value_$ref_f1oxa5_2() {
    return function (p0) {
      return p0.a1();
    };
  }
  function objectPropertyEditors$lambda$lambda_15(_unused_var__etf5q3, trait) {
    _init_properties_ObjectProperties_kt__dw6gpa();
    return trait;
  }
  function objectPropertyEditors$lambda$lambda_16($childProperty) {
    return function (it) {
      return $childProperty(it);
    };
  }
  function objectPropertyEditors$lambda_12($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function HasPropertyConstraints$_get_constraints_$ref_5lfcib_4() {
    return function (p0) {
      return p0.ofr();
    };
  }
  function propertyConstraints$$inlined$apply$1($constraintsCell) {
    this.tud_1 = $constraintsCell;
    CellTrait.call(this);
  }
  protoOf(propertyConstraints$$inlined$apply$1).s8z = function (cell, event) {
    if (!(cell instanceof TextCell))
      THROW_CCE();
    if (event.m8j(Key_ENTER_getInstance(), [])) {
      var tmp;
      if (this.tud_1._v == null) {
        throwUninitializedPropertyAccessException('constraintsCell');
      } else {
        tmp = this.tud_1._v;
      }
      tmp.m92().f2x(true);
      var tmp_0;
      if (this.tud_1._v == null) {
        throwUninitializedPropertyAccessException('constraintsCell');
      } else {
        tmp_0 = this.tud_1._v;
      }
      var tmp0_safe_receiver = firstFocusable(tmp_0);
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.s8n();
      }
      event.n8i();
    }
    return Unit_instance;
  };
  function propertyConstraints$2$2$$inlined$keyPressedCellTrait$1($constraintButton, $constraintsCell) {
    this.uud_1 = $constraintButton;
    this.vud_1 = $constraintsCell;
    CellTrait.call(this);
  }
  protoOf(propertyConstraints$2$2$$inlined$keyPressedCellTrait$1).s8z = function (cell, event) {
    if (!(this.uud_1 == null) && (event.m8j(Key_DELETE_getInstance(), []) || event.m8j(Key_BACKSPACE_getInstance(), []))) {
      this.uud_1.s8n();
      var tmp;
      if (this.vud_1._v == null) {
        throwUninitializedPropertyAccessException('constraintsCell');
      } else {
        tmp = this.vud_1._v;
      }
      tmp.m92().f2x(false);
      event.n8i();
    }
    return Unit_instance;
  };
  function propertyConstraints$lambda$lambda($constraintButton, $constraintsCell) {
    return function (_unused_var__etf5q3, trait) {
      // Inline function 'jetbrains.ocelot.projectional.cell.trait.keyPressedCellTrait' call
      var deleteTrait = new propertyConstraints$2$2$$inlined$keyPressedCellTrait$1($constraintButton, $constraintsCell);
      return CompositeCellTraits_instance.ra6([trait, deleteTrait]);
    };
  }
  function propertyConstraints$lambda$lambda_0($link) {
    return function (it) {
      return $link.h6h_1(it);
    };
  }
  function propertyConstraints$lambda($constraintButton, $link, $showUnderscore, $constraintsCell) {
    return function ($this$indent) {
      newLine_0($this$indent);
      var tmp1_layout = Layout_VERTICAL_getInstance();
      var tmp0_safe_receiver = $constraintButton;
      var tmp2_onLastItemDeleted = tmp0_safe_receiver == null ? null : toHome(tmp0_safe_receiver);
      var tmp = getKClass(PropertyConstraint_1);
      var tmp_0 = propertyConstraints$lambda$lambda($constraintButton, $constraintsCell);
      children_2($this$indent, tmp, $link, VOID, tmp_0, VOID, VOID, VOID, tmp2_onLastItemDeleted, tmp1_layout, propertyConstraints$lambda$lambda_0($link));
      var tmp_1;
      if ($showUnderscore) {
        newLine_0($this$indent);
        label_0($this$indent, '_');
        tmp_1 = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function propertyConstraints$$inlined$forDisposable$1($link, $this_propertyConstraints, $constraintsCell) {
    this.xud_1 = $link;
    this.yud_1 = $this_propertyConstraints;
    this.zud_1 = $constraintsCell;
    DisposableSynchronizer.call(this);
  }
  protoOf(propertyConstraints$$inlined$forDisposable$1).s87 = function (ctx) {
    var tmp = PropertyBinding_instance;
    var tmp_0 = notEmptyProp(this.xud_1.h6h_1(this.yud_1.m6d()).m5y());
    var tmp_1;
    if (this.zud_1._v == null) {
      throwUninitializedPropertyAccessException('constraintsCell');
    } else {
      tmp_1 = this.zud_1._v;
    }
    return tmp.n30(tmp_0, tmp_1.m92());
  };
  var properties_initialized_ObjectProperties_kt_9560yc;
  function _init_properties_ObjectProperties_kt__dw6gpa() {
    if (!properties_initialized_ObjectProperties_kt_9560yc) {
      properties_initialized_ObjectProperties_kt_9560yc = true;
      completion_2 = completion$lambda_1;
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init = objectPropertyEditors$lambda;
      var triggerDependencies = emptyList();
      var tmp = getKClass(ObjectPropertiesLibrary);
      var tmp_0 = new EditorDefinition(tmp, null, null, false, true, triggerDependencies, objectPropertyEditors$lambda_0(init));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
      var completionSupplier = get_completion();
      var separator = get_defaultChildrenSeparator();
      var tmp0 = new ChildrenRoleDefaults(getKClass(ObjectPropertyDeclaration_1), '<empty>', null, separator, completionSupplier, true);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_0 = objectPropertyEditors$lambda_1;
      var triggerDependencies_0 = emptyList();
      var tmp_1 = getKClass(ObjectPropertyDeclaration_1);
      var tmp_2 = new EditorDefinition(tmp_1, tmp0, null, false, true, triggerDependencies_0, objectPropertyEditors$lambda_2(init_0));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
      var completionSupplier_0 = objectPropertyEditors$lambda_3;
      var separator_0 = get_defaultChildrenSeparator();
      var tmp0_0 = new ChildrenRoleDefaults(getKClass(PropertyValueRange), '<empty>', null, separator_0, completionSupplier_0, false);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_1 = objectPropertyEditors$lambda_4;
      var triggerDependencies_1 = emptyList();
      var tmp_3 = getKClass(NoValues_1);
      var tmp_4 = new EditorDefinition(tmp_3, null, null, false, true, triggerDependencies_1, objectPropertyEditors$lambda_5(init_1));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_2 = objectPropertyEditors$lambda_6;
      var triggerDependencies_2 = emptyList();
      var tmp_5 = getKClass(SinglePropertyValueRange_1);
      var tmp_6 = new EditorDefinition(tmp_5, null, null, false, true, triggerDependencies_2, objectPropertyEditors$lambda_7(init_2));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_3 = objectPropertyEditors$lambda_8;
      var triggerDependencies_3 = emptyList();
      var tmp_7 = getKClass(MultiplePropertyValueRange_1);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.hierarchyEditor' call
      var editorDefinitions = [tmp_4, tmp_6, new EditorDefinition(tmp_7, null, null, false, true, triggerDependencies_3, objectPropertyEditors$lambda_9(init_3))];
      var tmp_8 = new HierarchyEditorDefinition(getKClass(PropertyValueRange), tmp0_0, toList(editorDefinitions));
      var tmp0_1 = '<constraints>';
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
      var completionSupplier_1 = objectPropertyEditors$lambda_10;
      var separator_1 = get_defaultChildrenSeparator();
      var tmp0_2 = new ChildrenRoleDefaults(getKClass(PropertyConstraint_1), tmp0_1, null, separator_1, completionSupplier_1, true);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_4 = objectPropertyEditors$lambda_11;
      var triggerDependencies_4 = emptyList();
      var tmp_9 = getKClass(PropertyConstraint_1);
      var tmp$ret$9 = new EditorDefinition(tmp_9, tmp0_2, null, false, true, triggerDependencies_4, objectPropertyEditors$lambda_12(init_4));
      objectPropertyEditors = listOf_0([tmp_0, tmp_2, tmp_8, tmp$ret$9]);
    }
  }
  function get_ontologyImportRootEditors() {
    _init_properties_OntologyImportRootEditors_kt__16c5by();
    return ontologyImportRootEditors;
  }
  var ontologyImportRootEditors;
  function getOntologyLibraryReferenceCompletion(_this__u8e3s4) {
    _init_properties_OntologyImportRootEditors_kt__16c5by();
    var tmp = _this__u8e3s4.jcg(Companion_getInstance_335().dh6_1);
    _this__u8e3s4.gck(tmp, getOntologyLibraryReferenceCompletion$lambda(_this__u8e3s4));
  }
  function ontologyImportRootEditors$lambda($this$editor) {
    _init_properties_OntologyImportRootEditors_kt__16c5by();
    var tmp = getKClass(OntologyImport_1);
    var tmp_0 = Layout_VERTICAL_getInstance();
    children_2($this$editor, tmp, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp_0, ontologyImportRootEditors$lambda$lambda);
    return Unit_instance;
  }
  function ontologyImportRootEditors$lambda$lambda(importRoot) {
    _init_properties_OntologyImportRootEditors_kt__16c5by();
    return importRoot.zfp();
  }
  function ontologyImportRootEditors$lambda_0($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function ontologyImportRootEditors$lambda_1($this$editor) {
    _init_properties_OntologyImportRootEditors_kt__16c5by();
    keyword_0($this$editor, 'for');
    space_0($this$editor);
    var tmp = getKClass(OntologyLibraryReference_1);
    var tmp_0 = ontologyImportRootEditors$lambda$lambda_0;
    child_1($this$editor, tmp, tmp_0, '<ontology>', VOID, VOID, VOID, VOID, VOID, VOID, ontologyImportRootEditors$lambda$lambda_1);
    indentLabel_0($this$editor, '/');
    var tmp_1 = getKClass(OntologyElementReference_1);
    child_1($this$editor, tmp_1, ontologyImportRootEditors$lambda$lambda_2);
    space_0($this$editor);
    keyword_0($this$editor, 'use');
    space_0($this$editor);
    var tmp_2 = getKClass(OntologyLibraryReference_1);
    var tmp_3 = ontologyImportRootEditors$lambda$lambda_3;
    child_1($this$editor, tmp_2, tmp_3, '<library to use>', VOID, VOID, VOID, VOID, VOID, VOID, ontologyImportRootEditors$lambda$lambda_4);
    return Unit_instance;
  }
  function ontologyImportRootEditors$lambda$lambda_0(ontologyImport) {
    _init_properties_OntologyImportRootEditors_kt__16c5by();
    return ontologyImport.xfs();
  }
  function ontologyImportRootEditors$lambda$lambda_1($this$child) {
    _init_properties_OntologyImportRootEditors_kt__16c5by();
    getOntologyLibraryReferenceCompletion($this$child);
    return Unit_instance;
  }
  function ontologyImportRootEditors$lambda$lambda_2(ontologyImport) {
    _init_properties_OntologyImportRootEditors_kt__16c5by();
    return ontologyImport.gfq();
  }
  function ontologyImportRootEditors$lambda$lambda_3(ontologyImport) {
    _init_properties_OntologyImportRootEditors_kt__16c5by();
    return ontologyImport.yfs();
  }
  function ontologyImportRootEditors$lambda$lambda_4($this$child) {
    _init_properties_OntologyImportRootEditors_kt__16c5by();
    getOntologyLibraryReferenceCompletion($this$child);
    return Unit_instance;
  }
  function ontologyImportRootEditors$lambda_2($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function getOntologyLibraryReferenceCompletion$lambda($this_getOntologyLibraryReferenceCompletion) {
    return function (reference) {
      // Inline function 'kotlin.apply' call
      var this_0 = OntologyLibraryReference($this_getOntologyLibraryReferenceCompletion.l6z());
      this_0.yfq().b6p(reference);
      return this_0;
    };
  }
  var properties_initialized_OntologyImportRootEditors_kt_dyb78g;
  function _init_properties_OntologyImportRootEditors_kt__16c5by() {
    if (!properties_initialized_OntologyImportRootEditors_kt_dyb78g) {
      properties_initialized_OntologyImportRootEditors_kt_dyb78g = true;
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init = ontologyImportRootEditors$lambda;
      var triggerDependencies = emptyList();
      var tmp = getKClass(OntologyImportRoot_1);
      var tmp_0 = new EditorDefinition(tmp, null, null, false, true, triggerDependencies, ontologyImportRootEditors$lambda_0(init));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
      var placeholderText = '<imports>';
      var separator = get_defaultChildrenSeparator();
      var tmp0 = new ChildrenRoleDefaults(getKClass(OntologyImport_1), placeholderText, null, separator, null, true);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_0 = ontologyImportRootEditors$lambda_1;
      var triggerDependencies_0 = emptyList();
      var tmp_1 = getKClass(OntologyImport_1);
      var tmp$ret$2 = new EditorDefinition(tmp_1, tmp0, null, false, true, triggerDependencies_0, ontologyImportRootEditors$lambda_2(init_0));
      ontologyImportRootEditors = listOf_0([tmp_0, tmp$ret$2]);
    }
  }
  function get_ontologyLibraryEditors() {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    return ontologyLibraryEditors;
  }
  var ontologyLibraryEditors;
  function excludingClassExpressionCompletion(_this__u8e3s4, node) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    // Inline function 'jetbrains.ocelot.langDef.query.executeQuery' call
    // Inline function 'jetbrains.ocelot.langDef.query.query' call
    var tmp$ret$0 = new excludingClassExpressionCompletion$$inlined$executeQuery$1(node);
    var anonymousClassAncestor = execute_0(tmp$ret$0);
    if (anonymousClassAncestor == null) {
      anonymousClassCompletion(_this__u8e3s4);
    } else {
      ontologyElementReferenceProviderCompletion(_this__u8e3s4);
    }
  }
  function anonymousClassCompletion(_this__u8e3s4) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    _this__u8e3s4.bck('union of', anonymousClassCompletion$lambda(_this__u8e3s4));
  }
  function classExpressionCompletion(_this__u8e3s4) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    anonymousClassCompletion(_this__u8e3s4);
    ontologyElementReferenceProviderCompletion(_this__u8e3s4);
  }
  function ontologyElementDefinitionCompletion(_this__u8e3s4) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    var tmp = _this__u8e3s4.ick(ontologyElementDefinitionCompletion$lambda);
    _this__u8e3s4.jck(tmp, ontologyElementDefinitionCompletion$lambda_0(_this__u8e3s4));
  }
  function ontologyIsRelationCompletion(_this__u8e3s4) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    var tmp = _this__u8e3s4.ick(ontologyIsRelationCompletion$lambda);
    _this__u8e3s4.jck(tmp, ontologyIsRelationCompletion$lambda_0(_this__u8e3s4));
  }
  function ontologyElementReferenceProviderCompletion(_this__u8e3s4) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    localOntologyElementReferenceCompletion(_this__u8e3s4);
    qualifiedElementReferenceCompletion(_this__u8e3s4);
  }
  function ontologyRelationCompletion(_this__u8e3s4) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    var tmp = _this__u8e3s4.ick(ontologyRelationCompletion$lambda);
    _this__u8e3s4.jck(tmp, ontologyRelationCompletion$lambda_0(_this__u8e3s4));
  }
  function localOntologyElementReferenceCompletion(_this__u8e3s4) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    var tmp = _this__u8e3s4.jcg(Companion_getInstance_337().pgo_1);
    _this__u8e3s4.gck(tmp, localOntologyElementReferenceCompletion$lambda(_this__u8e3s4));
  }
  function qualifiedElementReferenceCompletion(_this__u8e3s4) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    var tmp = _this__u8e3s4.jcg(Companion_getInstance_335().dh6_1);
    _this__u8e3s4.gck(tmp, qualifiedElementReferenceCompletion$lambda(_this__u8e3s4));
  }
  function get_partsOfQualifiedOntologyReference(_this__u8e3s4) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    // Inline function 'jetbrains.ocelot.langDef.structure.adaptation.Companion.wraps' call
    var adapt = _get_partsOfQualifiedOntologyReference_$lambda_ts1u7l(_this__u8e3s4);
    var tmp = wrapsOrTurnsInto(getKClass(OntologyLibraryReference_1), getKClass(QualifiedOntologyElementReference_1), true, adapt);
    // Inline function 'jetbrains.ocelot.langDef.structure.adaptation.Companion.wraps' call
    var adapt_0 = _get_partsOfQualifiedOntologyReference_$lambda_ts1u7l_0(_this__u8e3s4);
    var tmp$ret$1 = wrapsOrTurnsInto(getKClass(OntologyElementReference_1), getKClass(QualifiedOntologyElementReference_1), true, adapt_0);
    return listOf_0([tmp, tmp$ret$1]);
  }
  function ontologyLibraryEditors$lambda($this$editor) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    indent_0($this$editor, VOID, VOID, ontologyLibraryEditors$lambda$lambda);
    return Unit_instance;
  }
  function ontologyLibraryEditors$lambda$lambda($this$indent) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    var tmp = getKClass(OntologyElement_1);
    var tmp_0 = Layout_VERTICAL_getInstance();
    children_2($this$indent, tmp, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp_0, ontologyLibraryEditors$lambda$lambda$lambda);
    return Unit_instance;
  }
  function ontologyLibraryEditors$lambda$lambda$lambda(ontologyLibrary) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    return ontologyLibrary.ifq();
  }
  function ontologyLibraryEditors$lambda_0($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function ontologyLibraryEditors$lambda_1($this$editor) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    commentEditor($this$editor);
    newLine_0($this$editor);
    keyword_0($this$editor, 'ontology type:');
    space_0($this$editor);
    textProperty_0($this$editor, '<name>', ontologyLibraryEditors$lambda$lambda_0);
    indent_0($this$editor, true, VOID, ontologyLibraryEditors$lambda$lambda_1);
    indent_0($this$editor, true, VOID, ontologyLibraryEditors$lambda$lambda_2);
    indent_0($this$editor, true, VOID, ontologyLibraryEditors$lambda$lambda_3);
    indent_0($this$editor, true, VOID, ontologyLibraryEditors$lambda$lambda_4);
    indent_0($this$editor, true, VOID, ontologyLibraryEditors$lambda$lambda_5);
    indent_0($this$editor, true, VOID, ontologyLibraryEditors$lambda$lambda_6);
    indent_0($this$editor, true, VOID, ontologyLibraryEditors$lambda$lambda_7);
    indent_0($this$editor, true, VOID, ontologyLibraryEditors$lambda$lambda_8);
    indent_0($this$editor, true, VOID, ontologyLibraryEditors$lambda$lambda_9);
    return Unit_instance;
  }
  function ontologyLibraryEditors$lambda$lambda_0(ontologyElement) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    return ontologyElement.y2();
  }
  function ontologyLibraryEditors$lambda$lambda_1($this$indent) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    newLine_0($this$indent);
    keyword_0($this$indent, 'super types:');
    space_0($this$indent);
    var tmp2 = getKClass(OntologyIsRelation_1);
    var tmp = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.children' call
    var childrenProperty = getPropertyCallableRef('superElements', 1, tmp, OntologyElement$_get_superElements_$ref_eb9rkn_2(), null);
    var placeholderTraitFactory = ontologyLibraryEditors$lambda$lambda$lambda_0;
    var layout = Layout_INDENT_getInstance();
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp_0 = new MultipleChildLink(getKClass(OntologyElement_1), childrenProperty);
    children_2($this$indent, tmp2, tmp_0, null, placeholderTraitFactory, null, null, null, null, layout, ontologyLibraryEditors$lambda$lambda$lambda_1(childrenProperty));
    return Unit_instance;
  }
  function OntologyElement$_get_superElements_$ref_eb9rkn_2() {
    return function (p0) {
      return p0.nfs();
    };
  }
  function ontologyLibraryEditors$lambda$lambda$lambda_0(_unused_var__etf5q3, trait) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    return trait;
  }
  function ontologyLibraryEditors$lambda$lambda$lambda_1($childrenProperty) {
    return function (it) {
      return $childrenProperty(it);
    };
  }
  function ontologyLibraryEditors$lambda$lambda_2($this$indent) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    newLine_0($this$indent);
    keyword_0($this$indent, 'is part of:');
    space_0($this$indent);
    var tmp2 = getKClass(OntologyCardinalityRelation_1);
    var tmp = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.children' call
    var childrenProperty = getPropertyCallableRef('enclosingElements', 1, tmp, OntologyElement$_get_enclosingElements_$ref_uplwca_2(), null);
    var placeholderTraitFactory = ontologyLibraryEditors$lambda$lambda$lambda_2;
    var layout = Layout_INDENT_getInstance();
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp_0 = new MultipleChildLink(getKClass(OntologyElement_1), childrenProperty);
    children_2($this$indent, tmp2, tmp_0, null, placeholderTraitFactory, null, null, null, null, layout, ontologyLibraryEditors$lambda$lambda$lambda_3(childrenProperty));
    return Unit_instance;
  }
  function OntologyElement$_get_enclosingElements_$ref_uplwca_2() {
    return function (p0) {
      return p0.ofs();
    };
  }
  function ontologyLibraryEditors$lambda$lambda$lambda_2(_unused_var__etf5q3, trait) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    return trait;
  }
  function ontologyLibraryEditors$lambda$lambda$lambda_3($childrenProperty) {
    return function (it) {
      return $childrenProperty(it);
    };
  }
  function ontologyLibraryEditors$lambda$lambda_3($this$indent) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    newLine_0($this$indent);
    keyword_0($this$indent, 'only in taxon:');
    space_0($this$indent);
    var tmp2 = getKClass(ClassExpression);
    var tmp = KProperty1;
    var tmp4 = getPropertyCallableRef('taxon', 1, tmp, OntologyElement$_get_taxon_$ref_my9s4f_2(), null);
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.child' call
    var completionSupplier = ontologyLibraryEditors$lambda$lambda$lambda_4;
    var placeholderTraitFactory = ontologyLibraryEditors$lambda$lambda$lambda_5;
    var tmp_0 = ontologyLibraryEditors$lambda$lambda$lambda_6(tmp4);
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$0 = new SingleChildLink(getKClass(OntologyElement_1), tmp4);
    child_1($this$indent, tmp2, tmp_0, '<taxon>', placeholderTraitFactory, null, null, null, null, tmp$ret$0, completionSupplier);
    return Unit_instance;
  }
  function OntologyElement$_get_taxon_$ref_my9s4f_2() {
    return function (p0) {
      return p0.pfs();
    };
  }
  function ontologyLibraryEditors$lambda$lambda$lambda_4($this$child) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    classExpressionCompletion($this$child);
    return Unit_instance;
  }
  function ontologyLibraryEditors$lambda$lambda$lambda_5(_unused_var__etf5q3, trait) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    return trait;
  }
  function ontologyLibraryEditors$lambda$lambda$lambda_6($childProperty) {
    return function (it) {
      return $childProperty(it);
    };
  }
  function ontologyLibraryEditors$lambda$lambda_4($this$indent) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    newLine_0($this$indent);
    get_background(gray(keyword_0($this$indent, 'old definition:'))).f2x(Companion_getInstance_210().q95_1);
    space_0($this$indent);
    var tmp2 = getKClass(AnonymousClass);
    var tmp = KProperty1;
    var tmp4 = getPropertyCallableRef('oldDefinition', 1, tmp, OntologyElement$_get_oldDefinition_$ref_nndimn_1(), null);
    var tmp6 = '<use definition below instead>';
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.child' call
    var completionSupplier = ontologyLibraryEditors$lambda$lambda$lambda_7;
    var placeholderTraitFactory = ontologyLibraryEditors$lambda$lambda$lambda_8;
    var tmp_0 = ontologyLibraryEditors$lambda$lambda$lambda_9(tmp4);
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$0 = new SingleChildLink(getKClass(OntologyElement_1), tmp4);
    child_1($this$indent, tmp2, tmp_0, tmp6, placeholderTraitFactory, null, null, null, null, tmp$ret$0, completionSupplier);
    return Unit_instance;
  }
  function OntologyElement$_get_oldDefinition_$ref_nndimn_1() {
    return function (p0) {
      return p0.vfs();
    };
  }
  function ontologyLibraryEditors$lambda$lambda$lambda_7($this$child) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    anonymousClassCompletion($this$child);
    return Unit_instance;
  }
  function ontologyLibraryEditors$lambda$lambda$lambda_8(_unused_var__etf5q3, trait) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    return trait;
  }
  function ontologyLibraryEditors$lambda$lambda$lambda_9($childProperty) {
    return function (it) {
      return $childProperty(it);
    };
  }
  function ontologyLibraryEditors$lambda$lambda_5($this$indent) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    newLine_0($this$indent);
    keyword_0($this$indent, 'definition:');
    space_0($this$indent);
    var tmp2 = getKClass(OntologyElementDefinition_1);
    var tmp = KProperty1;
    var tmp4 = getPropertyCallableRef('definition', 1, tmp, OntologyElement$_get_definition_$ref_ra1mma_1(), null);
    var tmp6 = '<definition>';
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.child' call
    var completionSupplier = ontologyLibraryEditors$lambda$lambda$lambda_10;
    var placeholderTraitFactory = ontologyLibraryEditors$lambda$lambda$lambda_11;
    var tmp_0 = ontologyLibraryEditors$lambda$lambda$lambda_12(tmp4);
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$0 = new SingleChildLink(getKClass(OntologyElement_1), tmp4);
    child_1($this$indent, tmp2, tmp_0, tmp6, placeholderTraitFactory, null, null, null, null, tmp$ret$0, completionSupplier);
    return Unit_instance;
  }
  function OntologyElement$_get_definition_$ref_ra1mma_1() {
    return function (p0) {
      return p0.wfs();
    };
  }
  function ontologyLibraryEditors$lambda$lambda$lambda_10($this$child) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    ontologyElementDefinitionCompletion($this$child);
    return Unit_instance;
  }
  function ontologyLibraryEditors$lambda$lambda$lambda_11(_unused_var__etf5q3, trait) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    return trait;
  }
  function ontologyLibraryEditors$lambda$lambda$lambda_12($childProperty) {
    return function (it) {
      return $childProperty(it);
    };
  }
  function ontologyLibraryEditors$lambda$lambda_6($this$indent) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    newLine_0($this$indent);
    keyword_0($this$indent, 'properties:');
    space_0($this$indent);
    propertyConstraints($this$indent, false);
    return Unit_instance;
  }
  function ontologyLibraryEditors$lambda$lambda_7($this$indent) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    newLine_0($this$indent);
    keyword_0($this$indent, 'synonyms:');
    space_0($this$indent);
    var tmp2 = getKClass(OntologyElementSynonym_1);
    var tmp = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.children' call
    var childrenProperty = getPropertyCallableRef('synonyms', 1, tmp, OntologyElement$_get_synonyms_$ref_j21l21_1(), null);
    var placeholderTraitFactory = ontologyLibraryEditors$lambda$lambda$lambda_13;
    var layout = Layout_INDENT_getInstance();
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp_0 = new MultipleChildLink(getKClass(OntologyElement_1), childrenProperty);
    children_2($this$indent, tmp2, tmp_0, null, placeholderTraitFactory, null, null, null, null, layout, ontologyLibraryEditors$lambda$lambda$lambda_14(childrenProperty));
    return Unit_instance;
  }
  function OntologyElement$_get_synonyms_$ref_j21l21_1() {
    return function (p0) {
      return p0.tfs();
    };
  }
  function ontologyLibraryEditors$lambda$lambda$lambda_13(_unused_var__etf5q3, trait) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    return trait;
  }
  function ontologyLibraryEditors$lambda$lambda$lambda_14($childrenProperty) {
    return function (it) {
      return $childrenProperty(it);
    };
  }
  function ontologyLibraryEditors$lambda$lambda_8($this$indent) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    newLine_0($this$indent);
    keyword_0($this$indent, 'url:');
    space_0($this$indent);
    var tmp = ontologyLibraryEditors$lambda$lambda$lambda_15;
    textProperty_0($this$indent, '<none>', tmp, ontologyLibraryEditors$lambda$lambda$lambda_16);
    return Unit_instance;
  }
  function ontologyLibraryEditors$lambda$lambda$lambda_15(ontologyElement) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    return ontologyElement.qfs();
  }
  function ontologyLibraryEditors$lambda$lambda$lambda_16($this$textProperty) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    $this$textProperty.qd0().w92(URLHandler_getInstance());
    return Unit_instance;
  }
  function ontologyLibraryEditors$lambda$lambda_9($this$indent) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    newLine_0($this$indent);
    keyword_0($this$indent, 'additional urls:');
    space_0($this$indent);
    var tmp0_layout = Layout_VERTICAL_getInstance();
    var tmp = getKClass(Url_1);
    var tmp_0 = ontologyLibraryEditors$lambda$lambda$lambda_17($this$indent);
    children_2($this$indent, tmp, VOID, VOID, tmp_0, VOID, VOID, VOID, VOID, tmp0_layout, ontologyLibraryEditors$lambda$lambda$lambda_18);
    return Unit_instance;
  }
  function ontologyLibraryEditors$lambda$lambda$lambda_17($this_indent) {
    return function (ontologyElement, trait) {
      return urlPlaceholderPasteTrait(trait, ontologyElement.sfs(), get_internalConfig($this_indent).l6z());
    };
  }
  function ontologyLibraryEditors$lambda$lambda$lambda_18(ontologyElement) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    return ontologyElement.sfs();
  }
  function ontologyLibraryEditors$lambda_2($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function ontologyLibraryEditors$lambda_3($this$childrenRoleDefaults) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    var tmp = $this$childrenRoleDefaults.qci();
    $this$childrenRoleDefaults.dck(tmp, ontologyLibraryEditors$lambda$lambda_10($this$childrenRoleDefaults));
    return Unit_instance;
  }
  function ontologyLibraryEditors$lambda$lambda_10($this_childrenRoleDefaults) {
    return function (name) {
      // Inline function 'kotlin.apply' call
      var this_0 = OntologyElementSynonym($this_childrenRoleDefaults.l6z());
      this_0.y2().f2x(name);
      return this_0;
    };
  }
  function ontologyLibraryEditors$lambda_4($this$editor) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    var tmp = ontologyLibraryEditors$lambda$lambda_11;
    editableText_0($this$editor, VOID, '<synonym>', tmp, VOID, ontologyLibraryEditors$lambda$lambda_12);
    return Unit_instance;
  }
  function ontologyLibraryEditors$lambda$lambda_11(it) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    return !contains_8(it, ',');
  }
  function ontologyLibraryEditors$lambda$lambda_12($this$editableText) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.textSyncTwoWay' call
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.textCellSyncTwoWay' call
    var sourceProp = $this$editableText.m6d().y2();
    var targetProp = $this$editableText.qd0().o8w();
    $this$editableText.l8b(syncTwoWay(sourceProp.m5y(), targetProp));
    return Unit_instance;
  }
  function ontologyLibraryEditors$lambda_5($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function ontologyLibraryEditors$lambda_6($this$childrenRoleDefaults) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    ontologyIsRelationCompletion($this$childrenRoleDefaults);
    return Unit_instance;
  }
  function ontologyLibraryEditors$lambda_7($this$editor) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    indent_0($this$editor, VOID, VOID, ontologyLibraryEditors$lambda$lambda_13);
    return Unit_instance;
  }
  function ontologyLibraryEditors$lambda$lambda_13($this$indent) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    var tmp = getKClass(OntologyElementReferenceProvider);
    var tmp_0 = ontologyLibraryEditors$lambda$lambda$lambda_19;
    child_1($this$indent, tmp, tmp_0, '<ontology element>', VOID, VOID, VOID, VOID, VOID, VOID, ontologyLibraryEditors$lambda$lambda$lambda_20);
    return Unit_instance;
  }
  function ontologyLibraryEditors$lambda$lambda$lambda_19(relation) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    return relation.zfs();
  }
  function ontologyLibraryEditors$lambda$lambda$lambda_20($this$child) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    ontologyElementReferenceProviderCompletion($this$child);
    return Unit_instance;
  }
  function ontologyLibraryEditors$lambda_8($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function ontologyLibraryEditors$lambda_9($this$childrenRoleDefaults) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    ontologyRelationCompletion($this$childrenRoleDefaults);
    return Unit_instance;
  }
  function ontologyLibraryEditors$lambda_10($this$editor) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    var tmp = getKClass(ClassExpression);
    var tmp_0 = ontologyLibraryEditors$lambda$lambda_14;
    child_1($this$editor, tmp, tmp_0, '<class>', VOID, VOID, VOID, VOID, VOID, VOID, ontologyLibraryEditors$lambda$lambda_15);
    var tmp_1 = getKClass(Cardinality_1);
    child_1($this$editor, tmp_1, ontologyLibraryEditors$lambda$lambda_16);
    return Unit_instance;
  }
  function ontologyLibraryEditors$lambda$lambda_14(relation) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    return relation.hfq();
  }
  function ontologyLibraryEditors$lambda$lambda_15($this$child) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    classExpressionCompletion($this$child);
    return Unit_instance;
  }
  function ontologyLibraryEditors$lambda$lambda_16(cardinalityRelation) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    return cardinalityRelation.dfr();
  }
  function ontologyLibraryEditors$lambda_11($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function ontologyLibraryEditors$lambda_12($this$editor) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    var tmp2 = getKClass(ClassExpression);
    var tmp = KProperty1;
    var tmp4 = getPropertyCallableRef('classExpression', 1, tmp, OntologyElementDefinition$_get_classExpression_$ref_7q14es_1(), null);
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.child' call
    var completionSupplier = ontologyLibraryEditors$lambda$lambda_17;
    var placeholderTraitFactory = ontologyLibraryEditors$lambda$lambda_18;
    var tmp_0 = ontologyLibraryEditors$lambda$lambda_19(tmp4);
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$0 = new SingleChildLink(getKClass(OntologyElementDefinition_1), tmp4);
    child_1($this$editor, tmp2, tmp_0, '<class>', placeholderTraitFactory, null, null, null, null, tmp$ret$0, completionSupplier);
    propertyConstraints($this$editor, true);
    return Unit_instance;
  }
  function OntologyElementDefinition$_get_classExpression_$ref_7q14es_1() {
    return function (p0) {
      return p0.hfq();
    };
  }
  function ontologyLibraryEditors$lambda$lambda_17($this$child) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    classExpressionCompletion($this$child);
    return Unit_instance;
  }
  function ontologyLibraryEditors$lambda$lambda_18(_unused_var__etf5q3, trait) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    return trait;
  }
  function ontologyLibraryEditors$lambda$lambda_19($childProperty) {
    return function (it) {
      return $childProperty(it);
    };
  }
  function ontologyLibraryEditors$lambda_13($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function excludingClassExpressionCompletion$$inlined$executeQuery$1($node) {
    this.aue_1 = $node;
  }
  protoOf(excludingClassExpressionCompletion$$inlined$executeQuery$1).n5w = function (builder) {
    var tmp = this.aue_1;
    // Inline function 'jetbrains.ocelot.langDef.structure.ancestorOrSelf' call
    var this_0 = (!(tmp == null) ? isInterface(tmp, BTBNode) : false) ? tmp : null;
    var tmp$ret$0 = ancestorOrSelf(this_0, getKClass(AnonymousClass));
    return builder.l60(tmp$ret$0);
  };
  function anonymousClassCompletion$lambda($this_anonymousClassCompletion) {
    return function () {
      return UnionClass($this_anonymousClassCompletion.l6z());
    };
  }
  function ontologyElementDefinitionCompletion$lambda($this$using) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    classExpressionCompletion($this$using);
    return Unit_instance;
  }
  function ontologyElementDefinitionCompletion$lambda_0($this_ontologyElementDefinitionCompletion) {
    return function (it) {
      // Inline function 'kotlin.apply' call
      var this_0 = OntologyElementDefinition($this_ontologyElementDefinitionCompletion.l6z());
      this_0.hfq().f2x(it);
      return this_0;
    };
  }
  function ontologyIsRelationCompletion$lambda($this$using) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    ontologyElementReferenceProviderCompletion($this$using);
    return Unit_instance;
  }
  function ontologyIsRelationCompletion$lambda_0($this_ontologyIsRelationCompletion) {
    return function (it) {
      // Inline function 'kotlin.apply' call
      var this_0 = OntologyIsRelation($this_ontologyIsRelationCompletion.l6z());
      this_0.zfs().f2x(it);
      return this_0;
    };
  }
  function ontologyRelationCompletion$lambda($this$using) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    classExpressionCompletion($this$using);
    return Unit_instance;
  }
  function ontologyRelationCompletion$lambda_0($this_ontologyRelationCompletion) {
    return function (it) {
      // Inline function 'kotlin.apply' call
      var this_0 = OntologyCardinalityRelation($this_ontologyRelationCompletion.l6z());
      this_0.hfq().f2x(it);
      return this_0;
    };
  }
  function localOntologyElementReferenceCompletion$lambda($this_localOntologyElementReferenceCompletion) {
    return function (reference) {
      return LocalOntologyElementReference_2($this_localOntologyElementReferenceCompletion.l6z(), reference);
    };
  }
  function qualifiedElementReferenceCompletion$lambda($this_qualifiedElementReferenceCompletion) {
    return function (reference) {
      // Inline function 'kotlin.apply' call
      var this_0 = QualifiedOntologyElementReference($this_qualifiedElementReferenceCompletion.l6z());
      this_0.hfu().f2x(OntologyLibraryReference_2($this_qualifiedElementReferenceCompletion.l6z(), reference));
      this_0.ifu().f2x(OntologyElementReference($this_qualifiedElementReferenceCompletion.l6z()));
      return this_0;
    };
  }
  function _get_partsOfQualifiedOntologyReference_$lambda_ts1u7l($this_partsOfQualifiedOntologyReference) {
    return function (library) {
      // Inline function 'jetbrains.ocelot.langDef.structure.NodeFactory.create' call
      // Inline function 'kotlin.apply' call
      var this_0 = $this_partsOfQualifiedOntologyReference.t6v(getKClass(QualifiedOntologyElementReference_1));
      var tmp = this_0.hfu();
      var tmp_0 = library.f6j();
      tmp.f2x(isInterface(tmp_0, OntologyLibraryReference_1) ? tmp_0 : THROW_CCE());
      var tmp_1 = this_0.ifu();
      // Inline function 'jetbrains.ocelot.langDef.structure.NodeFactory.create' call
      var tmp$ret$1 = $this_partsOfQualifiedOntologyReference.t6v(getKClass(OntologyElementReference_1));
      tmp_1.f2x(tmp$ret$1);
      return this_0;
    };
  }
  function _get_partsOfQualifiedOntologyReference_$lambda_ts1u7l_0($this_partsOfQualifiedOntologyReference) {
    return function (element) {
      // Inline function 'jetbrains.ocelot.langDef.structure.NodeFactory.create' call
      // Inline function 'kotlin.apply' call
      var this_0 = $this_partsOfQualifiedOntologyReference.t6v(getKClass(QualifiedOntologyElementReference_1));
      var tmp = this_0.ifu();
      var tmp_0 = element.f6j();
      tmp.f2x(isInterface(tmp_0, OntologyElementReference_1) ? tmp_0 : THROW_CCE());
      var tmp_1 = this_0.hfu();
      // Inline function 'jetbrains.ocelot.langDef.structure.NodeFactory.create' call
      var tmp$ret$1 = $this_partsOfQualifiedOntologyReference.t6v(getKClass(OntologyLibraryReference_1));
      tmp_1.f2x(tmp$ret$1);
      return this_0;
    };
  }
  var properties_initialized_OntologyLibraryEditors_kt_dzogpw;
  function _init_properties_OntologyLibraryEditors_kt__lodwxm() {
    if (!properties_initialized_OntologyLibraryEditors_kt_dzogpw) {
      properties_initialized_OntologyLibraryEditors_kt_dzogpw = true;
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init = ontologyLibraryEditors$lambda;
      var triggerDependencies = emptyList();
      var tmp = getKClass(OntologyLibrary_1);
      var tmp_0 = new EditorDefinition(tmp, null, null, false, true, triggerDependencies, ontologyLibraryEditors$lambda_0(init));
      var tmp0 = '<elements>';
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
      var separator_0 = blankLine();
      var tmp0_0 = new ChildrenRoleDefaults(getKClass(OntologyElement_1), tmp0, null, separator_0, null, true);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_0 = ontologyLibraryEditors$lambda_1;
      var triggerDependencies_0 = emptyList();
      var tmp_1 = getKClass(OntologyElement_1);
      var tmp_2 = new EditorDefinition(tmp_1, tmp0_0, null, false, true, triggerDependencies_0, ontologyLibraryEditors$lambda_2(init_0));
      var tmp0_1 = '<synonyms>';
      var tmp2 = separator(',');
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
      var completionSupplier = ontologyLibraryEditors$lambda_3;
      var tmp0_2 = new ChildrenRoleDefaults(getKClass(OntologyElementSynonym_1), tmp0_1, null, tmp2, completionSupplier, true);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_1 = ontologyLibraryEditors$lambda_4;
      var triggerDependencies_1 = emptyList();
      var tmp_3 = getKClass(OntologyElementSynonym_1);
      var tmp_4 = new EditorDefinition(tmp_3, tmp0_2, null, false, true, triggerDependencies_1, ontologyLibraryEditors$lambda_5(init_1));
      var tmp0_3 = '<super elements>';
      var tmp2_0 = separator(',');
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
      var completionSupplier_0 = ontologyLibraryEditors$lambda_6;
      var tmp0_4 = new ChildrenRoleDefaults(getKClass(OntologyIsRelation_1), tmp0_3, null, tmp2_0, completionSupplier_0, true);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_2 = ontologyLibraryEditors$lambda_7;
      var triggerDependencies_2 = emptyList();
      var tmp_5 = getKClass(OntologyIsRelation_1);
      var tmp_6 = new EditorDefinition(tmp_5, tmp0_4, null, false, true, triggerDependencies_2, ontologyLibraryEditors$lambda_8(init_2));
      var tmp0_5 = '<enclosing elements>';
      var tmp2_1 = separator(',');
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
      var completionSupplier_1 = ontologyLibraryEditors$lambda_9;
      var tmp0_6 = new ChildrenRoleDefaults(getKClass(OntologyCardinalityRelation_1), tmp0_5, null, tmp2_1, completionSupplier_1, true);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_3 = ontologyLibraryEditors$lambda_10;
      var triggerDependencies_3 = emptyList();
      var tmp_7 = getKClass(OntologyCardinalityRelation_1);
      var tmp_8 = new EditorDefinition(tmp_7, tmp0_6, null, false, true, triggerDependencies_3, ontologyLibraryEditors$lambda_11(init_3));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_4 = ontologyLibraryEditors$lambda_12;
      var triggerDependencies_4 = emptyList();
      var tmp_9 = getKClass(OntologyElementDefinition_1);
      var tmp$ret$9 = new EditorDefinition(tmp_9, null, null, false, true, triggerDependencies_4, ontologyLibraryEditors$lambda_13(init_4));
      ontologyLibraryEditors = listOf_0([tmp_0, tmp_2, tmp_4, tmp_6, tmp_8, tmp$ret$9]);
    }
  }
  function get_processLibraryEditors() {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return processLibraryEditors;
  }
  var processLibraryEditors;
  function get_RANGE_CELL_MARK() {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return RANGE_CELL_MARK;
  }
  var RANGE_CELL_MARK;
  function get_PROCESS_PROPERTY_CELL_MARK() {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return PROCESS_PROPERTY_CELL_MARK;
  }
  var PROCESS_PROPERTY_CELL_MARK;
  function libraryProcessSpecificationEditor() {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.asyncInvalidatingEditor' call
    var init = libraryProcessSpecificationEditor$slambda_0(null);
    var triggerDependencies = emptyList();
    var tmp = getKClass(LibraryProcessSpecification_1);
    return new EditorDefinition(tmp, null, null, false, true, triggerDependencies, libraryProcessSpecificationEditor$lambda(init));
  }
  function libraryProcessSpecificationCompletion(_this__u8e3s4) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    var tmp = _this__u8e3s4.jcg(Companion_getInstance_338().ihc_1);
    _this__u8e3s4.gck(tmp, libraryProcessSpecificationCompletion$lambda(_this__u8e3s4));
  }
  function gray(_this__u8e3s4) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    _this__u8e3s4.i90(Companion_getInstance_154().c8x_1, Companion_getInstance_210().r95_1);
    return _this__u8e3s4;
  }
  function processPropertyTypeCompletion(_this__u8e3s4) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    simplePropertyTypeCompletion(_this__u8e3s4);
    primitivePropertyTypeCompletion(_this__u8e3s4);
    ontologyElementPropertyTypeCompletion(_this__u8e3s4);
    anonymousClassTypeCompletion(_this__u8e3s4);
  }
  function getAbstractBindingEntryCompletion(_this__u8e3s4) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    var tmp = _this__u8e3s4.ick(getAbstractBindingEntryCompletion$lambda);
    _this__u8e3s4.jck(tmp, getAbstractBindingEntryCompletion$lambda_0(_this__u8e3s4));
    var tmp_0 = _this__u8e3s4.ick(getAbstractBindingEntryCompletion$lambda_1);
    _this__u8e3s4.jck(tmp_0, getAbstractBindingEntryCompletion$lambda_2(_this__u8e3s4));
    var tmp_1 = _this__u8e3s4.jcg(Companion_getInstance_330().agi_1);
    _this__u8e3s4.gck(tmp_1, getAbstractBindingEntryCompletion$lambda_3(_this__u8e3s4));
    var tmp_2 = _this__u8e3s4.jcg(Companion_getInstance_344().ngi_1);
    _this__u8e3s4.gck(tmp_2, getAbstractBindingEntryCompletion$lambda_4(_this__u8e3s4));
  }
  function optionalSpecializedLink(_this__u8e3s4) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    var specializedCell = indent_0(_this__u8e3s4, VOID, VOID, optionalSpecializedLink$lambda);
    // Inline function 'jetbrains.ocelot.mapper.core.Synchronizers.forDisposable' call
    var tmp$ret$0 = new optionalSpecializedLink$$inlined$forDisposable$1(_this__u8e3s4, specializedCell);
    _this__u8e3s4.l8b(tmp$ret$0);
  }
  function get_propertyDeclarationEditor() {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
    var placeholderText = '<property declaration>';
    var separator = get_defaultChildrenSeparator();
    var tmp0 = new ChildrenRoleDefaults(getKClass(PropertyDeclaration_1), placeholderText, null, separator, null, true);
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
    var init = _get_propertyDeclarationEditor_$lambda_j0iclw;
    var triggerDependencies = emptyList();
    var tmp = getKClass(PropertyDeclaration_1);
    return new EditorDefinition(tmp, tmp0, null, false, true, triggerDependencies, _get_propertyDeclarationEditor_$lambda_j0iclw_0(init));
  }
  function getBindingValueCompletion(_this__u8e3s4) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    var tmp = _this__u8e3s4.jcg(Companion_getInstance_343().rlt_1);
    _this__u8e3s4.gck(tmp, getBindingValueCompletion$lambda(_this__u8e3s4));
    var tmp_0 = _this__u8e3s4.jcg(Companion_getInstance_329().rfv_1);
    _this__u8e3s4.gck(tmp_0, getBindingValueCompletion$lambda_0(_this__u8e3s4));
    var tmp_1 = _this__u8e3s4.jcg(Companion_getInstance_318().uhg_1);
    _this__u8e3s4.gck(tmp_1, getBindingValueCompletion$lambda_1(_this__u8e3s4));
  }
  function propertyDeclarationByNotionCompletion(_this__u8e3s4) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    var tmp = _this__u8e3s4.ick(propertyDeclarationByNotionCompletion$lambda);
    _this__u8e3s4.jck(tmp, propertyDeclarationByNotionCompletion$lambda_0(_this__u8e3s4));
  }
  function processPrerequisiteCompletion(_this__u8e3s4) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    var tmp = _this__u8e3s4.ick(processPrerequisiteCompletion$lambda);
    _this__u8e3s4.jck(tmp, processPrerequisiteCompletion$lambda_0(_this__u8e3s4));
  }
  function processEffectCompletion(_this__u8e3s4) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    var tmp = _this__u8e3s4.ick(processEffectCompletion$lambda);
    _this__u8e3s4.jck(tmp, processEffectCompletion$lambda_0(_this__u8e3s4));
  }
  function simplePropertyTypeCompletion(_this__u8e3s4) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    var tmp = _this__u8e3s4.jcg(Companion_getInstance_341().qhs_1);
    _this__u8e3s4.gck(tmp, simplePropertyTypeCompletion$lambda(_this__u8e3s4));
  }
  function primitivePropertyTypeCompletion(_this__u8e3s4) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = get_entries().m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      _this__u8e3s4.bck(element.elv_1, primitivePropertyTypeCompletion$lambda(_this__u8e3s4, element));
    }
  }
  function ontologyElementPropertyTypeCompletion(_this__u8e3s4) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    var createPropertyTypeNode = ontologyElementPropertyTypeCompletion$lambda(_this__u8e3s4);
    _this__u8e3s4.bck('TYPE_OF', ontologyElementPropertyTypeCompletion$lambda_0(createPropertyTypeNode));
    _this__u8e3s4.bck('INSTANCE_OF', ontologyElementPropertyTypeCompletion$lambda_1(createPropertyTypeNode));
  }
  function shouldShowSpecialized(_this__u8e3s4) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    // Inline function 'jetbrains.ocelot.langDef.query.query' call
    return new shouldShowSpecialized$$inlined$query$1(_this__u8e3s4);
  }
  function processLibraryEditors$lambda($this$editor) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    var tmp = getKClass(ProcessDeclaration_1);
    var tmp_0 = Layout_VERTICAL_getInstance();
    children_2($this$editor, tmp, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp_0, processLibraryEditors$lambda$lambda);
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda(processLibrary) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return processLibrary.xft();
  }
  function processLibraryEditors$lambda_0($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function processLibraryEditors$lambda_1($this$editor) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    commentEditor($this$editor);
    newLine_0($this$editor);
    var tmp4 = Companion_getInstance_338().hhc_1;
    // Inline function 'jetbrains.biokb.lang.editorBuilders.btbReferenceTarget' call
    var referenceProvider = processLibraryEditors$lambda$lambda_0;
    var options = new CompletionOptions();
    var containerInit = processLibraryEditors$lambda$lambda_1;
    var textCellInit = processLibraryEditors$lambda$lambda_2;
    var tmp;
    if (null == null) {
      tmp = processLibraryEditors$lambda$lambda_3;
    } else {
      tmp = null;
    }
    var tmp10 = tmp;
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.references.referenceTarget' call
    var textCellInit_0 = processLibraryEditors$lambda$lambda_4(textCellInit);
    var targetClass = getKClass(ProcessKind_1);
    referenceTarget($this$editor, targetClass, '<kind>', tmp4, referenceProvider, null, tmp10, options, containerInit, textCellInit_0);
    space_0($this$editor);
    textProperty_0($this$editor, '<name>', processLibraryEditors$lambda$lambda_5);
    space_0($this$editor);
    horizontal_0($this$editor, processLibraryEditors$lambda$lambda_6);
    indent_0($this$editor, true, VOID, processLibraryEditors$lambda$lambda_7);
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda_0(processDeclaration) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return processDeclaration.r5a();
  }
  function processLibraryEditors$lambda$lambda_1(_this__u8e3s4) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda_2(_this__u8e3s4) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda_3(it) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return true;
  }
  function processLibraryEditors$lambda$lambda_4($textCellInit) {
    return function ($this$referenceTarget) {
      $textCellInit($this$referenceTarget);
      enableEagerCompletion($this$referenceTarget);
      return Unit_instance;
    };
  }
  function processLibraryEditors$lambda$lambda_5(processDeclaration) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return processDeclaration.y2();
  }
  function processLibraryEditors$lambda$lambda_6($this$horizontal) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    indent_0($this$horizontal, VOID, VOID, processLibraryEditors$lambda$lambda$lambda);
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda$lambda($this$indent) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    keyword_0($this$indent, 'inherits');
    space_0($this$indent);
    var tmp = getKClass(ProcessReference_1);
    var tmp_0 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_0 = getPropertyCallableRef('inherited', 1, tmp_0, ProcessDeclaration$_get_inherited_$ref_wglzfx_3(), null);
    var tmp_1 = new MultipleChildLink(getKClass(ProcessDeclaration_1), this_0);
    children_2($this$indent, tmp, tmp_1, VOID, VOID, VOID, VOID, VOID, VOID, VOID, processLibraryEditors$lambda$lambda$lambda$lambda);
    newLine_0($this$indent);
    get_background(gray(keyword_0($this$indent, 'extends'))).f2x(Companion_getInstance_210().q95_1);
    space_0($this$indent);
    var tmp2 = '<process>';
    var tmp4 = Companion_getInstance_338().ihc_1;
    // Inline function 'jetbrains.biokb.lang.editorBuilders.btbReferenceTarget' call
    var referenceProvider = processLibraryEditors$lambda$lambda$lambda$lambda_0;
    var options = new CompletionOptions();
    var containerInit = processLibraryEditors$lambda$lambda$lambda$lambda_1;
    var textCellInit = processLibraryEditors$lambda$lambda$lambda$lambda_2;
    var tmp_2;
    if (null == null) {
      tmp_2 = processLibraryEditors$lambda$lambda$lambda$lambda_3;
    } else {
      tmp_2 = null;
    }
    var tmp10 = tmp_2;
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.references.referenceTarget' call
    var textCellInit_0 = processLibraryEditors$lambda$lambda$lambda$lambda_4(textCellInit);
    var targetClass = getKClass(ProcessDeclaration_1);
    var tmp$ret$2 = referenceTarget($this$indent, targetClass, tmp2, tmp4, referenceProvider, null, tmp10, options, containerInit, textCellInit_0);
    get_background(tmp$ret$2).f2x(Companion_getInstance_210().q95_1);
    return Unit_instance;
  }
  function ProcessDeclaration$_get_inherited_$ref_wglzfx_3() {
    return function (p0) {
      return p0.qft();
    };
  }
  function processLibraryEditors$lambda$lambda$lambda$lambda(it) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return it.qft();
  }
  function processLibraryEditors$lambda$lambda$lambda$lambda_0(processDeclaration) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return processDeclaration.pft();
  }
  function processLibraryEditors$lambda$lambda$lambda$lambda_1(_this__u8e3s4) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda$lambda$lambda_2(_this__u8e3s4) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda$lambda$lambda_3(it) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return true;
  }
  function processLibraryEditors$lambda$lambda$lambda$lambda_4($textCellInit) {
    return function ($this$referenceTarget) {
      $textCellInit($this$referenceTarget);
      enableEagerCompletion($this$referenceTarget);
      return Unit_instance;
    };
  }
  function processLibraryEditors$lambda$lambda_7($this$indent) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    newLine_0($this$indent);
    newLine_0($this$indent);
    keyword_0($this$indent, 'ontology elements:');
    space_0($this$indent);
    horizontal_0($this$indent, processLibraryEditors$lambda$lambda$lambda_0);
    newLine_0($this$indent);
    keyword_0($this$indent, 'parameters:');
    space_0($this$indent);
    horizontal_0($this$indent, processLibraryEditors$lambda$lambda$lambda_1);
    newLine_0($this$indent);
    // Inline function 'kotlin.apply' call
    var this_0 = label_0($this$indent, 'inherited:');
    this_0.i90(Companion_getInstance_154().h8x_1, true);
    this_0.i90(Companion_getInstance_154().g8x_1, true);
    this_0.i90(Companion_getInstance_154().c8x_1, Companion_getInstance_210().x95_1);
    space_0($this$indent);
    space_0($this$indent);
    readOnlyBlock($this$indent, VOID, processLibraryEditors$lambda$lambda$lambda_2);
    newLine_0($this$indent);
    newLine_0($this$indent);
    get_background(gray(keyword_0($this$indent, 'old properties:'))).f2x(Companion_getInstance_210().q95_1);
    space_0($this$indent);
    get_background(horizontal_0($this$indent, processLibraryEditors$lambda$lambda$lambda_3)).f2x(Companion_getInstance_210().q95_1);
    newLine_0($this$indent);
    newLine_0($this$indent);
    variablesEditor($this$indent);
    newLine_0($this$indent);
    newLine_0($this$indent);
    keyword_0($this$indent, 'prerequisites:');
    space_0($this$indent);
    horizontal_0($this$indent, processLibraryEditors$lambda$lambda$lambda_4);
    newLine_0($this$indent);
    newLine_0($this$indent);
    keyword_0($this$indent, 'effects:');
    space_0($this$indent);
    horizontal_0($this$indent, processLibraryEditors$lambda$lambda$lambda_5);
    newLine_0($this$indent);
    newLine_0($this$indent);
    keyword_0($this$indent, 'url:');
    space_0($this$indent);
    horizontal_0($this$indent, processLibraryEditors$lambda$lambda$lambda_6);
    newLine_0($this$indent);
    customEditor($this$indent);
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda$lambda_0($this$horizontal) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    var tmp = getKClass(OntologyElementType_1);
    var tmp_0 = Layout_VERTICAL_getInstance();
    children_2($this$horizontal, tmp, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp_0, processLibraryEditors$lambda$lambda$lambda$lambda_5);
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda$lambda$lambda_5(processDeclaration) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return processDeclaration.qfp();
  }
  function processLibraryEditors$lambda$lambda$lambda_1($this$horizontal) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    var tmp = getKClass(ProcessProperty_1);
    var tmp_0 = Layout_VERTICAL_getInstance();
    children_2($this$horizontal, tmp, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp_0, processLibraryEditors$lambda$lambda$lambda$lambda_6);
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda$lambda$lambda_6(processDeclaration) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return processDeclaration.rfp();
  }
  function processLibraryEditors$lambda$lambda$lambda_2($this$readOnlyBlock) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    var tmp = getKClass(InheritedProcessProperty);
    var tmp_0 = Layout_VERTICAL_getInstance();
    children_2($this$readOnlyBlock, tmp, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp_0, processLibraryEditors$lambda$lambda$lambda$lambda_7);
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda$lambda$lambda_7(processDeclaration) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return processDeclaration.uft();
  }
  function processLibraryEditors$lambda$lambda$lambda_3($this$horizontal) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    var tmp = getKClass(AbstractBindingEntry);
    var tmp_0 = Layout_VERTICAL_getInstance();
    children_2($this$horizontal, tmp, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp_0, processLibraryEditors$lambda$lambda$lambda$lambda_8);
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda$lambda$lambda_8(processDeclaration) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return processDeclaration.y();
  }
  function processLibraryEditors$lambda$lambda$lambda_4($this$horizontal) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    var tmp0_layout = Layout_HORIZONTAL_getInstance();
    var tmp = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_0 = getPropertyCallableRef('prerequisites', 1, tmp, ProcessDeclaration$_get_prerequisites_$ref_h8hogm_2(), null);
    var tmp1_contextLink = new MultipleChildLink(getKClass(ProcessDeclaration_1), this_0);
    var tmp2_separator = separator(',');
    var tmp_0 = getKClass(ProcessPrerequisite_0);
    children_2($this$horizontal, tmp_0, tmp1_contextLink, VOID, VOID, tmp2_separator, VOID, VOID, VOID, tmp0_layout, processLibraryEditors$lambda$lambda$lambda$lambda_9);
    return Unit_instance;
  }
  function ProcessDeclaration$_get_prerequisites_$ref_h8hogm_2() {
    return function (p0) {
      return p0.rft();
    };
  }
  function processLibraryEditors$lambda$lambda$lambda$lambda_9(processDeclaration) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return processDeclaration.rft();
  }
  function processLibraryEditors$lambda$lambda$lambda_5($this$horizontal) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    var tmp0_layout = Layout_HORIZONTAL_getInstance();
    var tmp = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_0 = getPropertyCallableRef('effects', 1, tmp, ProcessDeclaration$_get_effects_$ref_9vh0jp_2(), null);
    var tmp1_contextLink = new MultipleChildLink(getKClass(ProcessDeclaration_1), this_0);
    var tmp2_separator = separator(',');
    var tmp_0 = getKClass(ProcessEffect_0);
    children_2($this$horizontal, tmp_0, tmp1_contextLink, VOID, VOID, tmp2_separator, VOID, VOID, VOID, tmp0_layout, processLibraryEditors$lambda$lambda$lambda$lambda_10);
    return Unit_instance;
  }
  function ProcessDeclaration$_get_effects_$ref_9vh0jp_2() {
    return function (p0) {
      return p0.sft();
    };
  }
  function processLibraryEditors$lambda$lambda$lambda$lambda_10(processDeclaration) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return processDeclaration.sft();
  }
  function processLibraryEditors$lambda$lambda$lambda_6($this$horizontal) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    var tmp0_layout = Layout_VERTICAL_getInstance();
    var tmp = getKClass(Url_1);
    var tmp_0 = processLibraryEditors$lambda$lambda$lambda$lambda_11($this$horizontal);
    children_2($this$horizontal, tmp, VOID, VOID, tmp_0, VOID, VOID, VOID, VOID, tmp0_layout, processLibraryEditors$lambda$lambda$lambda$lambda_12);
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda$lambda$lambda_11($this_horizontal) {
    return function (processDeclaration, trait) {
      return urlPlaceholderPasteTrait(trait, processDeclaration.tft(), get_internalConfig($this_horizontal).l6z());
    };
  }
  function processLibraryEditors$lambda$lambda$lambda$lambda_12(processDeclaration) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return processDeclaration.tft();
  }
  function processLibraryEditors$lambda_2($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function processLibraryEditors$lambda_3($this$childrenRoleDefaults) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    var tmp = $this$childrenRoleDefaults.jcg(Companion_getInstance_339().jhh_1);
    $this$childrenRoleDefaults.gck(tmp, processLibraryEditors$lambda$lambda_8($this$childrenRoleDefaults));
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda_8($this_childrenRoleDefaults) {
    return function (reference) {
      // Inline function 'kotlin.apply' call
      var this_0 = ProcessReference($this_childrenRoleDefaults.l6z());
      this_0.vfr().f2x(reference);
      return this_0;
    };
  }
  function processLibraryEditors$lambda_4($this$editor) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    var tmp2 = '<process>';
    var tmp4 = Companion_getInstance_339().jhh_1;
    var tmp6 = processLibraryEditors$lambda$lambda_9;
    var tmp8 = processLibraryEditors$lambda$lambda_10;
    // Inline function 'jetbrains.biokb.lang.editorBuilders.btbReferenceTarget' call
    var options = new CompletionOptions(VOID, false);
    var containerInit = processLibraryEditors$lambda$lambda_11;
    var textCellInit = processLibraryEditors$lambda$lambda_12;
    var tmp;
    if (tmp8 == null) {
      tmp = processLibraryEditors$lambda$lambda_13;
    } else {
      tmp = tmp8;
    }
    var tmp10 = tmp;
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.references.referenceTarget' call
    var textCellInit_0 = processLibraryEditors$lambda$lambda_14(textCellInit);
    var targetClass = getKClass(ProcessDeclaration_1);
    var refCell = referenceTarget($this$editor, targetClass, tmp2, tmp4, tmp6, null, tmp10, options, containerInit, textCellInit_0);
    considerEmptyBy($this$editor, refCell);
    deleteIfEmpty($this$editor);
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda_9(it) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return it.vfr();
  }
  function processLibraryEditors$lambda$lambda_10(it) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return !contains_8(it, ',');
  }
  function processLibraryEditors$lambda$lambda_11(_this__u8e3s4) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda_12(_this__u8e3s4) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda_13(it) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return true;
  }
  function processLibraryEditors$lambda$lambda_14($textCellInit) {
    return function ($this$referenceTarget) {
      $textCellInit($this$referenceTarget);
      enableEagerCompletion($this$referenceTarget);
      return Unit_instance;
    };
  }
  function processLibraryEditors$lambda_5($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function processLibraryEditors$lambda_6(context) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return ProcessProperty(context);
  }
  function processLibraryEditors$lambda_7($this$childrenRoleDefaults) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    var tmp = editorString($this$childrenRoleDefaults, BTBEditorParts_getInstance().pu1_1);
    $this$childrenRoleDefaults.hck(tmp, processLibraryEditors$lambda$lambda_15($this$childrenRoleDefaults));
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda_15($this_childrenRoleDefaults) {
    return function (name) {
      // Inline function 'kotlin.apply' call
      var this_0 = ProcessProperty($this_childrenRoleDefaults.l6z());
      this_0.y2().f2x(name);
      return this_0;
    };
  }
  function processLibraryEditors$lambda_8($this$editor) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    // Inline function 'kotlin.apply' call
    var this_0 = indent_0($this$editor, VOID, VOID, processLibraryEditors$lambda$lambda_16);
    mark_0(this_0, get_PROCESS_PROPERTY_CELL_MARK());
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda_16($this$indent) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    // Inline function 'kotlin.apply' call
    var this_0 = textProperty_0($this$indent, '<name>', processLibraryEditors$lambda$lambda$lambda_7);
    mark_0(this_0, BTBEditorParts_getInstance().pu1_1);
    var colon = label_0($this$indent, ':', false);
    space_0($this$indent);
    var tmp = getKClass(ProcessPropertyValueRange);
    // Inline function 'kotlin.apply' call
    var this_1 = child_1($this$indent, tmp, processLibraryEditors$lambda$lambda$lambda_8);
    mark_0(this_1, get_RANGE_CELL_MARK());
    var rangeCell = this_1;
    rightTransform_1($this$indent, colon, processLibraryEditors$lambda$lambda$lambda_9($this$indent, rangeCell));
    space_0($this$indent);
    var tmp2 = getKClass(ProcessPropertyDefault_1);
    var tmp_0 = KProperty1;
    var tmp4 = getPropertyCallableRef('default', 1, tmp_0, ProcessProperty$_get_default_$ref_tilfgf_2(), null);
    var tmp6 = '<default>';
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.child' call
    var completionSupplier = processLibraryEditors$lambda$lambda$lambda_10;
    var placeholderTraitFactory = processLibraryEditors$lambda$lambda$lambda_11;
    var tmp_1 = processLibraryEditors$lambda$lambda$lambda_12(tmp4);
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$4 = new SingleChildLink(getKClass(ProcessProperty_1), tmp4);
    child_1($this$indent, tmp2, tmp_1, tmp6, placeholderTraitFactory, null, null, null, null, tmp$ret$4, completionSupplier);
    space_0($this$indent);
    label_0($this$indent, 'as');
    space_0($this$indent);
    var aliased;
    var tmp2_0 = getKClass(ProcessPropertyReference);
    var tmp_2 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.children' call
    var childrenProperty = getPropertyCallableRef('aliasedProperties', 1, tmp_2, ProcessProperty$_get_aliasedProperties_$ref_lzqazi_2(), null);
    var placeholderTraitFactory_0 = processLibraryEditors$lambda$lambda$lambda_13;
    var layout = Layout_INDENT_getInstance();
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp_3 = new MultipleChildLink(getKClass(ProcessProperty_1), childrenProperty);
    // Inline function 'kotlin.also' call
    aliased = children_2($this$indent, tmp2_0, tmp_3, null, placeholderTraitFactory_0, null, null, null, null, layout, processLibraryEditors$lambda$lambda$lambda_14(childrenProperty));
    ensureLastCaretPosition($this$indent);
    disambiguateBy($this$indent, aliased);
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda$lambda_7(it) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return it.y2();
  }
  function processLibraryEditors$lambda$lambda$lambda_8(it) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return it.sfq();
  }
  function processLibraryEditors$14$2$4$$inlined$executeQuery$1($this_indent) {
    this.bue_1 = $this_indent;
  }
  protoOf(processLibraryEditors$14$2$4$$inlined$executeQuery$1).n5w = function (builder) {
    return builder.l60(this.bue_1.m6d().sfq());
  };
  function processLibraryEditors$14$2$4$2$$inlined$executeQuery$1($currentType) {
    this.cue_1 = $currentType;
  }
  protoOf(processLibraryEditors$14$2$4$2$$inlined$executeQuery$1).n5w = function (builder) {
    var tmp0_safe_receiver = this.cue_1;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      var tmp_0 = tmp0_safe_receiver.f6j();
      tmp = isInterface(tmp_0, ProcessPropertyType) ? tmp_0 : THROW_CCE();
    }
    return tmp;
  };
  function processLibraryEditors$lambda$lambda$lambda$lambda$lambda($rangeCell) {
    return function () {
      ensureNotNull(firstFocusable($rangeCell)).s8n();
      return Unit_instance;
    };
  }
  function processLibraryEditors$lambda$lambda$lambda$lambda_13($this_indent, $currentType, $rangeCell) {
    return function () {
      // Inline function 'jetbrains.ocelot.langDef.query.executeQuery' call
      // Inline function 'jetbrains.ocelot.langDef.query.query' call
      var tmp$ret$0 = new processLibraryEditors$14$2$4$2$$inlined$executeQuery$1($currentType);
      var type = execute_0(tmp$ret$0);
      // Inline function 'kotlin.apply' call
      var this_0 = MultipleProcessPropertyValueRange(get_internalConfig($this_indent).l6z());
      this_0.sfq().f2x(type);
      var multipleRange = this_0;
      $this_indent.m6d().sfq().f2x(multipleRange);
      return processLibraryEditors$lambda$lambda$lambda$lambda$lambda($rangeCell);
    };
  }
  function processLibraryEditors$lambda$lambda$lambda_9($this_indent, $rangeCell) {
    return function ($this$rightTransform, _unused_var__etf5q3, _unused_var__etf5q3_0, _unused_var__etf5q3_1) {
      // Inline function 'jetbrains.ocelot.langDef.query.executeQuery' call
      // Inline function 'jetbrains.ocelot.langDef.query.query' call
      var tmp$ret$0 = new processLibraryEditors$14$2$4$$inlined$executeQuery$1($this_indent);
      var currentType = execute_0(tmp$ret$0);
      var tmp;
      var tmp_0;
      if (currentType == null) {
        tmp_0 = true;
      } else {
        tmp_0 = isInterface(currentType, ProcessPropertyType);
      }
      if (tmp_0) {
        $this$rightTransform.gcg('{', processLibraryEditors$lambda$lambda$lambda$lambda_13($this_indent, currentType, $rangeCell));
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ProcessProperty$_get_default_$ref_tilfgf_2() {
    return function (p0) {
      return p0.g3b();
    };
  }
  function processLibraryEditors$lambda$lambda$lambda_10($this$child) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    var tmp = $this$child.ick(processLibraryEditors$lambda$lambda$lambda$lambda_14);
    $this$child.jck(tmp, processLibraryEditors$lambda$lambda$lambda$lambda_15($this$child));
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda$lambda$lambda_14($this$using) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    getAbstractValueCompletion($this$using);
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda$lambda$lambda_15($this_child) {
    return function (abstractValue) {
      // Inline function 'kotlin.apply' call
      var this_0 = ProcessPropertyDefault($this_child.l6z());
      this_0.a1().f2x(abstractValue);
      return this_0;
    };
  }
  function processLibraryEditors$lambda$lambda$lambda_11(_unused_var__etf5q3, trait) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return trait;
  }
  function processLibraryEditors$lambda$lambda$lambda_12($childProperty) {
    return function (it) {
      return $childProperty(it);
    };
  }
  function ProcessProperty$_get_aliasedProperties_$ref_lzqazi_2() {
    return function (p0) {
      return p0.yft();
    };
  }
  function processLibraryEditors$lambda$lambda$lambda_13(_unused_var__etf5q3, trait) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return trait;
  }
  function processLibraryEditors$lambda$lambda$lambda_14($childrenProperty) {
    return function (it) {
      return $childrenProperty(it);
    };
  }
  function processLibraryEditors$lambda_9($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function processLibraryEditors$lambda_10($this$editor) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    gray(label_0($this$editor, '[default '));
    var tmp2 = getKClass(AbstractValue);
    var tmp = KProperty1;
    var tmp4 = getPropertyCallableRef('value', 1, tmp, ProcessPropertyDefault$_get_value_$ref_p903q0_1(), null);
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.child' call
    var completionSupplier = processLibraryEditors$lambda$lambda_17;
    var placeholderTraitFactory = processLibraryEditors$lambda$lambda_18;
    var tmp_0 = processLibraryEditors$lambda$lambda_19(tmp4);
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$0 = new SingleChildLink(getKClass(ProcessPropertyDefault_1), tmp4);
    child_1($this$editor, tmp2, tmp_0, null, placeholderTraitFactory, null, null, null, null, tmp$ret$0, completionSupplier);
    gray(label_0($this$editor, ']'));
    return Unit_instance;
  }
  function ProcessPropertyDefault$_get_value_$ref_p903q0_1() {
    return function (p0) {
      return p0.a1();
    };
  }
  function processLibraryEditors$lambda$lambda_17($this$child) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    getAbstractValueCompletion($this$child);
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda_18(_unused_var__etf5q3, trait) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return trait;
  }
  function processLibraryEditors$lambda$lambda_19($childProperty) {
    return function (it) {
      return $childProperty(it);
    };
  }
  function processLibraryEditors$lambda_11($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function processLibraryEditors$lambda_12($this$childrenRoleDefaults) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    var tmp = $this$childrenRoleDefaults.jcg(Companion_getInstance_340().hhg_1);
    $this$childrenRoleDefaults.gck(tmp, processLibraryEditors$lambda$lambda_20($this$childrenRoleDefaults));
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda_20($this_childrenRoleDefaults) {
    return function (reference) {
      return ProcessPropertyReference_0($this_childrenRoleDefaults.l6z(), reference);
    };
  }
  function processLibraryEditors$lambda_13($this$editor) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    indent_0($this$editor, VOID, VOID, processLibraryEditors$lambda$lambda_21);
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda_21($this$indent) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    var tmp2 = '<property>';
    var tmp4 = Companion_getInstance_340().hhg_1;
    // Inline function 'jetbrains.biokb.lang.editorBuilders.btbReferenceTarget' call
    var referenceProvider = processLibraryEditors$lambda$lambda$lambda_15;
    var options = new CompletionOptions();
    var containerInit = processLibraryEditors$lambda$lambda$lambda_16;
    var textCellInit = processLibraryEditors$lambda$lambda$lambda_17;
    var tmp;
    if (null == null) {
      tmp = processLibraryEditors$lambda$lambda$lambda_18;
    } else {
      tmp = null;
    }
    var tmp10 = tmp;
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.references.referenceTarget' call
    var textCellInit_0 = processLibraryEditors$lambda$lambda$lambda_19(textCellInit);
    var targetClass = getKClass(ProcessProperty_1);
    referenceTarget($this$indent, targetClass, tmp2, tmp4, referenceProvider, null, tmp10, options, containerInit, textCellInit_0);
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda$lambda_15(it) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return it.q6q();
  }
  function processLibraryEditors$lambda$lambda$lambda_16(_this__u8e3s4) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda$lambda_17(_this__u8e3s4) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda$lambda_18(it) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return true;
  }
  function processLibraryEditors$lambda$lambda$lambda_19($textCellInit) {
    return function ($this$referenceTarget) {
      $textCellInit($this$referenceTarget);
      enableEagerCompletion($this$referenceTarget);
      return Unit_instance;
    };
  }
  function processLibraryEditors$lambda_14($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function processLibraryEditors$lambda_15($this$editor) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    indent_0($this$editor, VOID, VOID, processLibraryEditors$lambda$lambda_22);
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda_22($this$indent) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    textProperty_0($this$indent, '<name>', processLibraryEditors$lambda$lambda$lambda_20);
    label_0($this$indent, '(');
    var tmp = getKClass(ProcessReference_1);
    child_1($this$indent, tmp, processLibraryEditors$lambda$lambda$lambda_21);
    label_0($this$indent, ')');
    label_0($this$indent, ':');
    space_0($this$indent);
    var tmp_0 = getKClass(ProcessPropertyValueRange);
    child_1($this$indent, tmp_0, processLibraryEditors$lambda$lambda$lambda_22);
    space_0($this$indent);
    var tmp2 = getKClass(ProcessPropertyDefault_1);
    var tmp_1 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.child' call
    var childProperty = getPropertyCallableRef('default', 1, tmp_1, InheritedProcessProperty$_get_default_$ref_c5hrt1_1(), null);
    var placeholderTraitFactory = processLibraryEditors$lambda$lambda$lambda_23;
    var tmp_2 = processLibraryEditors$lambda$lambda$lambda_24(childProperty);
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$0 = new SingleChildLink(getKClass(InheritedProcessProperty), childProperty);
    child_1($this$indent, tmp2, tmp_2, '', placeholderTraitFactory, null, null, null, null, tmp$ret$0, null);
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda$lambda_20(it) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return it.y2();
  }
  function processLibraryEditors$lambda$lambda$lambda_21(it) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return it.tfr();
  }
  function processLibraryEditors$lambda$lambda$lambda_22(it) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return it.sfq();
  }
  function InheritedProcessProperty$_get_default_$ref_c5hrt1_1() {
    return function (p0) {
      return p0.g3b();
    };
  }
  function processLibraryEditors$lambda$lambda$lambda_23(_unused_var__etf5q3, trait) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return trait;
  }
  function processLibraryEditors$lambda$lambda$lambda_24($childProperty) {
    return function (it) {
      return $childProperty(it);
    };
  }
  function processLibraryEditors$lambda_16($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function processLibraryEditors$lambda_17($this$childrenRoleDefaults) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    processPropertyTypeCompletion($this$childrenRoleDefaults);
    $this$childrenRoleDefaults.bck('{', processLibraryEditors$lambda$lambda_23($this$childrenRoleDefaults));
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda_23($this_childrenRoleDefaults) {
    return function () {
      return MultipleProcessPropertyValueRange($this_childrenRoleDefaults.l6z());
    };
  }
  function processLibraryEditors$lambda_18($this$editor) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    var multipleOpenBrace = label_0($this$editor, '{ ', VOID, false);
    var tmp = getKClass(ProcessPropertyType);
    var tmp_0 = processLibraryEditors$lambda$lambda_24;
    child_1($this$editor, tmp, tmp_0, VOID, VOID, VOID, VOID, VOID, VOID, VOID, processLibraryEditors$lambda$lambda_25);
    var multipleCloseBrace = label_0($this$editor, ' }', false);
    multipleOpenBrace.w92(new processLibraryEditors$26$BraceDeleteTrait($this$editor));
    multipleCloseBrace.w92(new processLibraryEditors$26$BraceDeleteTrait($this$editor));
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda_24(it) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return it.sfq();
  }
  function processLibraryEditors$lambda$lambda_25($this$child) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    processPropertyTypeCompletion($this$child);
    return Unit_instance;
  }
  function processLibraryEditors$26$BraceDeleteTrait$onKeyPressed$$inlined$executeQuery$1($this_editor) {
    this.due_1 = $this_editor;
  }
  protoOf(processLibraryEditors$26$BraceDeleteTrait$onKeyPressed$$inlined$executeQuery$1).n5w = function (builder) {
    return builder.l60(this.due_1.m6d().sfq());
  };
  function processLibraryEditors$26$BraceDeleteTrait($this_editor) {
    this.eue_1 = $this_editor;
    CellTrait.call(this);
  }
  protoOf(processLibraryEditors$26$BraceDeleteTrait).s8z = function (cell, event) {
    if (event.m8j(Key_BACKSPACE_getInstance(), []) || event.m8j(Key_DELETE_getInstance(), [])) {
      // Inline function 'jetbrains.ocelot.langDef.query.executeQuery' call
      // Inline function 'jetbrains.ocelot.langDef.query.query' call
      var tmp$ret$0 = new processLibraryEditors$26$BraceDeleteTrait$onKeyPressed$$inlined$executeQuery$1(this.eue_1);
      var type = execute_0(tmp$ret$0);
      if (!(type == null)) {
        // Inline function 'kotlin.sequences.find' call
        var tmp0 = ancestors(cell);
        var tmp$ret$3;
        $l$block: {
          // Inline function 'kotlin.sequences.firstOrNull' call
          var _iterator__ex2g4s = tmp0.m();
          while (_iterator__ex2g4s.n()) {
            var element = _iterator__ex2g4s.o();
            if (get_PROCESS_PROPERTY_CELL_MARK().fd1(element)) {
              tmp$ret$3 = element;
              break $l$block;
            }
          }
          tmp$ret$3 = null;
        }
        var parentCell = tmp$ret$3;
        this.eue_1.m6d().d6j(type.f6j());
        var tmp1_safe_receiver = parentCell == null ? null : find_2(parentCell, get_RANGE_CELL_MARK());
        var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : firstFocusable(tmp1_safe_receiver);
        if (tmp2_safe_receiver == null)
          null;
        else {
          tmp2_safe_receiver.s8n();
        }
        event.n8i();
        return Unit_instance;
      }
    }
    protoOf(CellTrait).s8z.call(this, cell, event);
  };
  function processLibraryEditors$lambda_19($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function processLibraryEditors$lambda_20($this$childrenRoleDefaults) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    processPropertyTypeCompletion($this$childrenRoleDefaults);
    return Unit_instance;
  }
  function processLibraryEditors$lambda_21($this$editor) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    deleteIfEmpty($this$editor);
    var refCell = {_v: null};
    indent_0($this$editor, VOID, VOID, processLibraryEditors$lambda$lambda_26(refCell));
    var tmp;
    if (refCell._v == null) {
      throwUninitializedPropertyAccessException('refCell');
    } else {
      tmp = refCell._v;
    }
    considerEmptyBy($this$editor, tmp);
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda$lambda_25(it) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return it.mfq();
  }
  function processLibraryEditors$lambda$lambda$lambda_26($this$btbReferenceTarget) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    $this$btbReferenceTarget.qd0().d97().f2x(true);
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda$lambda_27(_this__u8e3s4) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda$lambda_28(it) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return true;
  }
  function processLibraryEditors$lambda$lambda$lambda_29($textCellInit) {
    return function ($this$referenceTarget) {
      $textCellInit($this$referenceTarget);
      enableEagerCompletion($this$referenceTarget);
      return Unit_instance;
    };
  }
  function processLibraryEditors$lambda$lambda_26($refCell) {
    return function ($this$indent) {
      var tmp2 = '<notion>';
      var tmp4 = Companion_getInstance_351().zgu_1;
      var tmp6 = processLibraryEditors$lambda$lambda$lambda_25;
      // Inline function 'jetbrains.biokb.lang.editorBuilders.btbReferenceTarget' call
      var textCellInit = processLibraryEditors$lambda$lambda$lambda_26;
      var options = new CompletionOptions();
      var containerInit = processLibraryEditors$lambda$lambda$lambda_27;
      var tmp;
      if (null == null) {
        tmp = processLibraryEditors$lambda$lambda$lambda_28;
      } else {
        tmp = null;
      }
      var tmp10 = tmp;
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.references.referenceTarget' call
      var textCellInit_0 = processLibraryEditors$lambda$lambda$lambda_29(textCellInit);
      var targetClass = getKClass(AbstractNotion);
      var tmp$ret$1 = referenceTarget($this$indent, targetClass, tmp2, tmp4, tmp6, null, tmp10, options, containerInit, textCellInit_0);
      $refCell._v = tmp$ret$1;
      return Unit_instance;
    };
  }
  function processLibraryEditors$lambda_22($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function processLibraryEditors$lambda_23($this$editor) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.enumProperty' call
    var placeholder = '<primitive>';
    // Inline function 'kotlin.apply' call
    var this_0 = editableText_0($this$editor, VOID, placeholder, VOID, VOID, processLibraryEditors$lambda$lambda_27);
    this_0.d97().f2x(true);
    var cell = this_0;
    considerEmptyBy($this$editor, cell);
    deleteIfEmpty($this$editor);
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda_27($this$editableText) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    switch (get_internalConfig($this$editableText).nd0().uct_1.x2_1) {
      case 0:
        // Inline function 'jetbrains.ocelot.langDef.editorBuilder.enumSyncTwoWay' call

        var targetPropFactory = processLibraryEditors$lambda$lambda$lambda_30;
        // Inline function 'jetbrains.ocelot.langDef.editorBuilder.textCellSyncTwoWay' call

        var sourceProp = $this$editableText.m6d().oft();
        var targetProp = targetPropFactory($this$editableText.qd0());
        $this$editableText.l8b(syncTwoWay(sourceProp.m5y(), targetProp));
        break;
      case 1:
        // Inline function 'jetbrains.ocelot.langDef.editorBuilder.enumSyncTwoWay' call

        var targetPropFactory_0 = processLibraryEditors$lambda$lambda$lambda_31;
        // Inline function 'jetbrains.ocelot.langDef.editorBuilder.textCellSyncTwoWay' call

        var sourceProp_0 = $this$editableText.m6d().oft();
        var targetProp_0 = targetPropFactory_0($this$editableText.qd0());
        $this$editableText.l8b(syncTwoWay(sourceProp_0.m5y(), targetProp_0));
        break;
      default:
        var tmp = $this$editableText.qd0().o8w();
        var tmp1_safe_receiver = $this$editableText.m6d().oft().m5y().w2w();
        var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.toString();
        tmp.f2x(tmp2_elvis_lhs == null ? '' : tmp2_elvis_lhs);
        break;
    }
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda$lambda_30(textCell) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    // Inline function 'jetbrains.ocelot.base.enums.EnumInfoFactory.createEnumInfo' call
    // Inline function 'kotlin.enumValues' call
    var tmp$ret$0 = values_18();
    var enumInfo = new EnumInfoImpl(tmp$ret$0);
    return ValueEditors_instance.uag(textCell, enumInfo);
  }
  function processLibraryEditors$lambda$lambda$lambda_31(textCell) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    // Inline function 'jetbrains.ocelot.base.enums.EnumInfoFactory.createEnumInfo' call
    // Inline function 'kotlin.enumValues' call
    var tmp$ret$0 = values_18();
    var enumInfo = new EnumInfoImpl(tmp$ret$0);
    return ValueEditors_instance.uag(textCell, enumInfo);
  }
  function processLibraryEditors$lambda_24($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function processLibraryEditors$lambda_25($this$editor) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.enumProperty' call
    editableText_0($this$editor, VOID, '<spec>', VOID, VOID, processLibraryEditors$lambda$lambda_28);
    var openingParen = indentLabel_0($this$editor, '(');
    var tmp = getKClass(OntologyLibraryReference_1);
    child_1($this$editor, tmp, processLibraryEditors$lambda$lambda_29);
    indentLabel_0($this$editor, '/');
    var tmp_0 = getKClass(OntologyElementReference_1);
    child_1($this$editor, tmp_0, processLibraryEditors$lambda$lambda_30);
    closingFor(indentLabel_0($this$editor, ')'), openingParen);
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda_28($this$editableText) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    switch (get_internalConfig($this$editableText).nd0().uct_1.x2_1) {
      case 0:
        // Inline function 'jetbrains.ocelot.langDef.editorBuilder.enumSyncTwoWay' call

        var targetPropFactory = processLibraryEditors$lambda$lambda$lambda_32;
        // Inline function 'jetbrains.ocelot.langDef.editorBuilder.textCellSyncTwoWay' call

        var sourceProp = $this$editableText.m6d().jfr();
        var targetProp = targetPropFactory($this$editableText.qd0());
        $this$editableText.l8b(syncTwoWay(sourceProp.m5y(), targetProp));
        break;
      case 1:
        // Inline function 'jetbrains.ocelot.langDef.editorBuilder.enumSyncTwoWay' call

        var targetPropFactory_0 = processLibraryEditors$lambda$lambda$lambda_33;
        // Inline function 'jetbrains.ocelot.langDef.editorBuilder.textCellSyncTwoWay' call

        var sourceProp_0 = $this$editableText.m6d().jfr();
        var targetProp_0 = targetPropFactory_0($this$editableText.qd0());
        $this$editableText.l8b(syncTwoWay(sourceProp_0.m5y(), targetProp_0));
        break;
      default:
        var tmp = $this$editableText.qd0().o8w();
        var tmp1_safe_receiver = $this$editableText.m6d().jfr().m5y().w2w();
        var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.toString();
        tmp.f2x(tmp2_elvis_lhs == null ? '' : tmp2_elvis_lhs);
        break;
    }
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda$lambda_32(textCell) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    // Inline function 'jetbrains.ocelot.base.enums.EnumInfoFactory.createEnumInfo' call
    // Inline function 'kotlin.enumValues' call
    var tmp$ret$0 = values_14();
    var enumInfo = new EnumInfoImpl(tmp$ret$0);
    return ValueEditors_instance.uag(textCell, enumInfo);
  }
  function processLibraryEditors$lambda$lambda$lambda_33(textCell) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    // Inline function 'jetbrains.ocelot.base.enums.EnumInfoFactory.createEnumInfo' call
    // Inline function 'kotlin.enumValues' call
    var tmp$ret$0 = values_14();
    var enumInfo = new EnumInfoImpl(tmp$ret$0);
    return ValueEditors_instance.uag(textCell, enumInfo);
  }
  function processLibraryEditors$lambda$lambda_29(elementType) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return elementType.ffq();
  }
  function processLibraryEditors$lambda$lambda_30(elementType) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return elementType.gfq();
  }
  function processLibraryEditors$lambda_26($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function processLibraryEditors$lambda_27(wrapperContext) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return EmptyBindingEntry(wrapperContext);
  }
  function processLibraryEditors$lambda_28($this$childrenRoleDefaults) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    getAbstractBindingEntryCompletion($this$childrenRoleDefaults);
    return Unit_instance;
  }
  function processLibraryEditors$lambda_29($this$editor) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    var tmp = getKClass(PropertyDeclaration_1);
    child_1($this$editor, tmp, processLibraryEditors$lambda$lambda_31);
    ensureLastCaretPosition($this$editor);
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda_31(bindingProperty) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return bindingProperty.q6q();
  }
  function processLibraryEditors$lambda_30($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function processLibraryEditors$lambda_31($this$editor) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    var tmp = getKClass(LinkDeclaration_1);
    child_1($this$editor, tmp, processLibraryEditors$lambda$lambda_32);
    space_0($this$editor);
    keyword_0($this$editor, 'from');
    space_0($this$editor);
    var tmp_0 = getKClass(OntologyLibraryReference_1);
    child_1($this$editor, tmp_0, processLibraryEditors$lambda$lambda_33, '<default>');
    optionalSpecializedLink($this$editor);
    ensureLastCaretPosition($this$editor);
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda_32(ontologyLink) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return ontologyLink.xa1();
  }
  function processLibraryEditors$lambda$lambda_33(ontologyLink) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return ontologyLink.aft();
  }
  function processLibraryEditors$lambda_32($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function processLibraryEditors$lambda_33($this$editor) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    indent_0($this$editor, VOID, VOID, processLibraryEditors$lambda$lambda_34);
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda_34($this$indent) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    var tmp2 = '<property>';
    var tmp4 = Companion_getInstance_344().ngi_1;
    var tmp6 = processLibraryEditors$lambda$lambda$lambda_34;
    // Inline function 'jetbrains.biokb.lang.editorBuilders.btbReferenceTarget' call
    var containerInit = processLibraryEditors$lambda$lambda$lambda_35;
    var options = new CompletionOptions();
    var textCellInit = processLibraryEditors$lambda$lambda$lambda_36;
    var tmp;
    if (null == null) {
      tmp = processLibraryEditors$lambda$lambda$lambda_37;
    } else {
      tmp = null;
    }
    var tmp10 = tmp;
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.references.referenceTarget' call
    var textCellInit_0 = processLibraryEditors$lambda$lambda$lambda_38(textCellInit);
    var targetClass = getKClass(PropertyDeclaration_1);
    referenceTarget($this$indent, targetClass, tmp2, tmp4, tmp6, null, tmp10, options, containerInit, textCellInit_0);
    ensureLastCaretPosition($this$indent);
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda$lambda_34(importedProperty) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return importedProperty.sfr();
  }
  function processLibraryEditors$lambda$lambda$lambda_35($this$btbReferenceTarget) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    space_0($this$btbReferenceTarget);
    gray(label_0($this$btbReferenceTarget, '('));
    gray(label_0($this$btbReferenceTarget, 'type:'));
    space_0($this$btbReferenceTarget);
    var tmp = getKClass(NotionType_0);
    child_1($this$btbReferenceTarget, tmp, processLibraryEditors$lambda$lambda$lambda$lambda_16);
    gray(label_0($this$btbReferenceTarget, ')'));
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda$lambda$lambda_16(property) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return property.sfq();
  }
  function processLibraryEditors$lambda$lambda$lambda_36(_this__u8e3s4) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda$lambda_37(it) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return true;
  }
  function processLibraryEditors$lambda$lambda$lambda_38($textCellInit) {
    return function ($this$referenceTarget) {
      $textCellInit($this$referenceTarget);
      enableEagerCompletion($this$referenceTarget);
      return Unit_instance;
    };
  }
  function processLibraryEditors$lambda_34($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function processLibraryEditors$lambda_35($this$editor) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    var tmp4 = Companion_getInstance_330().agi_1;
    var tmp6 = processLibraryEditors$lambda$lambda_35;
    // Inline function 'jetbrains.biokb.lang.editorBuilders.btbReferenceTarget' call
    var containerInit = processLibraryEditors$lambda$lambda_36;
    var options = new CompletionOptions();
    var textCellInit = processLibraryEditors$lambda$lambda_37;
    var tmp;
    if (null == null) {
      tmp = processLibraryEditors$lambda$lambda_38;
    } else {
      tmp = null;
    }
    var tmp10 = tmp;
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.references.referenceTarget' call
    var textCellInit_0 = processLibraryEditors$lambda$lambda_39(textCellInit);
    var targetClass = getKClass(LinkDeclaration_1);
    referenceTarget($this$editor, targetClass, '<link>', tmp4, tmp6, null, tmp10, options, containerInit, textCellInit_0);
    optionalSpecializedLink($this$editor);
    ensureLastCaretPosition($this$editor);
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda_35(importedLink) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return importedLink.sfr();
  }
  function processLibraryEditors$lambda$lambda_36($this$btbReferenceTarget) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    space_0($this$btbReferenceTarget);
    gray(label_0($this$btbReferenceTarget, '('));
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.enumProperty' call
    editableText_0($this$btbReferenceTarget, VOID, '<spec>', VOID, VOID, processLibraryEditors$lambda$lambda$lambda_39);
    space_0($this$btbReferenceTarget);
    var tmp = getKClass(OntologyElementType_1);
    child_1($this$btbReferenceTarget, tmp, processLibraryEditors$lambda$lambda$lambda_40);
    gray(label_0($this$btbReferenceTarget, ')'));
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda$lambda_39($this$editableText) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    switch (get_internalConfig($this$editableText).nd0().uct_1.x2_1) {
      case 0:
        // Inline function 'jetbrains.ocelot.langDef.editorBuilder.enumSyncTwoWay' call

        var targetPropFactory = processLibraryEditors$lambda$lambda$lambda$lambda_17;
        // Inline function 'jetbrains.ocelot.langDef.editorBuilder.textCellSyncTwoWay' call

        var sourceProp = $this$editableText.m6d().jfr();
        var targetProp = targetPropFactory($this$editableText.qd0());
        $this$editableText.l8b(syncTwoWay(sourceProp.m5y(), targetProp));
        break;
      case 1:
        // Inline function 'jetbrains.ocelot.langDef.editorBuilder.enumSyncTwoWay' call

        var targetPropFactory_0 = processLibraryEditors$lambda$lambda$lambda$lambda_18;
        // Inline function 'jetbrains.ocelot.langDef.editorBuilder.textCellSyncTwoWay' call

        var sourceProp_0 = $this$editableText.m6d().jfr();
        var targetProp_0 = targetPropFactory_0($this$editableText.qd0());
        $this$editableText.l8b(syncTwoWay(sourceProp_0.m5y(), targetProp_0));
        break;
      default:
        var tmp = $this$editableText.qd0().o8w();
        var tmp1_safe_receiver = $this$editableText.m6d().jfr().m5y().w2w();
        var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.toString();
        tmp.f2x(tmp2_elvis_lhs == null ? '' : tmp2_elvis_lhs);
        break;
    }
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda$lambda$lambda_17(textCell) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    // Inline function 'jetbrains.ocelot.base.enums.EnumInfoFactory.createEnumInfo' call
    // Inline function 'kotlin.enumValues' call
    var tmp$ret$0 = values_14();
    var enumInfo = new EnumInfoImpl(tmp$ret$0);
    return ValueEditors_instance.uag(textCell, enumInfo);
  }
  function processLibraryEditors$lambda$lambda$lambda$lambda_18(textCell) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    // Inline function 'jetbrains.ocelot.base.enums.EnumInfoFactory.createEnumInfo' call
    // Inline function 'kotlin.enumValues' call
    var tmp$ret$0 = values_14();
    var enumInfo = new EnumInfoImpl(tmp$ret$0);
    return ValueEditors_instance.uag(textCell, enumInfo);
  }
  function processLibraryEditors$lambda$lambda$lambda_40(linkDeclaration) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return linkDeclaration.sfq();
  }
  function processLibraryEditors$lambda$lambda_37(_this__u8e3s4) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda_38(it) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return true;
  }
  function processLibraryEditors$lambda$lambda_39($textCellInit) {
    return function ($this$referenceTarget) {
      $textCellInit($this$referenceTarget);
      enableEagerCompletion($this$referenceTarget);
      return Unit_instance;
    };
  }
  function processLibraryEditors$lambda_36($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function processLibraryEditors$lambda_37($this$editor) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    indent_0($this$editor, VOID, VOID, processLibraryEditors$lambda$lambda_40);
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda_40($this$indent) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    placeholderInCollection_0($this$indent, VOID, processLibraryEditors$lambda$lambda$lambda_41);
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda$lambda_41($this$placeholderInCollection) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    getAbstractBindingEntryCompletion($this$placeholderInCollection);
    return Unit_instance;
  }
  function processLibraryEditors$lambda_38($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function processLibraryEditors$lambda_39($this$childRoleDefaults) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    libraryProcessSpecificationCompletion($this$childRoleDefaults);
    return Unit_instance;
  }
  function processLibraryEditors$lambda_40(wrapperContext) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return LibraryProcessSpecification(wrapperContext);
  }
  function processLibraryEditors$lambda_41($this$childrenRoleDefaults) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    getBindingValueCompletion($this$childrenRoleDefaults);
    return Unit_instance;
  }
  function processLibraryEditors$lambda_42($this$childRoleDefaults) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    getBindingValueCompletion($this$childRoleDefaults);
    return Unit_instance;
  }
  function processLibraryEditors$lambda_43($this$editor) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    var tmp2 = '<property>';
    var tmp4 = Companion_getInstance_318().uhg_1;
    // Inline function 'jetbrains.biokb.lang.editorBuilders.btbReferenceTarget' call
    var referenceProvider = processLibraryEditors$lambda$lambda_41;
    var options = new CompletionOptions();
    var containerInit = processLibraryEditors$lambda$lambda_42;
    var textCellInit = processLibraryEditors$lambda$lambda_43;
    var tmp;
    if (null == null) {
      tmp = processLibraryEditors$lambda$lambda_44;
    } else {
      tmp = null;
    }
    var tmp10 = tmp;
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.references.referenceTarget' call
    var textCellInit_0 = processLibraryEditors$lambda$lambda_45(textCellInit);
    var targetClass = getKClass(ProcessProperty_1);
    referenceTarget($this$editor, targetClass, tmp2, tmp4, referenceProvider, null, tmp10, options, containerInit, textCellInit_0);
    space_0($this$editor);
    var equalsLabel = label_0($this$editor, '=');
    space_0($this$editor);
    var indent = indent_0($this$editor, VOID, VOID, processLibraryEditors$lambda$lambda_46(equalsLabel));
    mark_0(indent, get_QUERY_LABELS_CONTAINER_MARK());
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda_41(propertyValue) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return propertyValue.q6q();
  }
  function processLibraryEditors$lambda$lambda_42(_this__u8e3s4) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda_43(_this__u8e3s4) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda_44(it) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return true;
  }
  function processLibraryEditors$lambda$lambda_45($textCellInit) {
    return function ($this$referenceTarget) {
      $textCellInit($this$referenceTarget);
      enableEagerCompletion($this$referenceTarget);
      return Unit_instance;
    };
  }
  function ProcessPropertyValue$_get_value_$ref_tp5tnc_2() {
    return function (p0) {
      return p0.a1();
    };
  }
  function ProcessPropertyValue$_get_value_$ref_tp5tnc_3() {
    return function (p0) {
      return p0.a1();
    };
  }
  function processLibraryEditors$lambda$lambda$lambda_42(wrapperContext) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    // Inline function 'kotlin.apply' call
    var this_0 = MeasurableValue(wrapperContext);
    this_0.pib(0);
    return this_0;
  }
  function processLibraryEditors$lambda$lambda$lambda_43($this$child) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    getAbstractValueCompletion($this$child);
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda_46($equalsLabel) {
    return function ($this$indent) {
      queryLabelsCell($this$indent);
      var tmp = KProperty1;
      // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
      var this_0 = getPropertyCallableRef('value', 1, tmp, ProcessPropertyValue$_get_value_$ref_tp5tnc_2(), null);
      var tmp0_contextLink = new SingleChildLink(getKClass(ProcessPropertyValue_1), this_0);
      var tmp_0 = getKClass(AbstractValue);
      var tmp_1 = KProperty1;
      var tmp_2 = getPropertyCallableRef('value', 1, tmp_1, ProcessPropertyValue$_get_value_$ref_tp5tnc_3(), null);
      var tmp_3 = processLibraryEditors$lambda$lambda$lambda_42;
      var value = child_1($this$indent, tmp_0, tmp_2, VOID, VOID, tmp_3, VOID, VOID, VOID, tmp0_contextLink, processLibraryEditors$lambda$lambda$lambda_43);
      var setQueriesLabelRightTransform = setQueryLabelRightTransform($this$indent.m6d());
      rightTransform_1($this$indent, value, setQueriesLabelRightTransform);
      rightTransform_1($this$indent, $equalsLabel, setQueriesLabelRightTransform);
      return Unit_instance;
    };
  }
  function processLibraryEditors$lambda_44($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function processLibraryEditors$lambda_45($this$editor) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    var tmp2 = '<property>';
    var tmp4 = Companion_getInstance_343().rlt_1;
    // Inline function 'jetbrains.biokb.lang.editorBuilders.btbReferenceTarget' call
    var referenceProvider = processLibraryEditors$lambda$lambda_47;
    var options = new CompletionOptions();
    var containerInit = processLibraryEditors$lambda$lambda_48;
    var textCellInit = processLibraryEditors$lambda$lambda_49;
    var tmp;
    if (null == null) {
      tmp = processLibraryEditors$lambda$lambda_50;
    } else {
      tmp = null;
    }
    var tmp10 = tmp;
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.references.referenceTarget' call
    var textCellInit_0 = processLibraryEditors$lambda$lambda_51(textCellInit);
    var targetClass = getKClass(AbstractProperty);
    referenceTarget($this$editor, targetClass, tmp2, tmp4, referenceProvider, null, tmp10, options, containerInit, textCellInit_0);
    space_0($this$editor);
    label_0($this$editor, '=');
    space_0($this$editor);
    var tmp2_0 = getKClass(AbstractValue);
    var tmp_0 = KProperty1;
    var tmp4_0 = getPropertyCallableRef('value', 1, tmp_0, PropertyValue$_get_value_$ref_lja1mh(), null);
    var tmp6 = processLibraryEditors$lambda$lambda_52;
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.child' call
    var completionSupplier = processLibraryEditors$lambda$lambda_53;
    var placeholderTraitFactory = processLibraryEditors$lambda$lambda_54;
    var tmp_1 = processLibraryEditors$lambda$lambda_55(tmp4_0);
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$2 = new SingleChildLink(getKClass(PropertyValue_1), tmp4_0);
    child_1($this$editor, tmp2_0, tmp_1, null, placeholderTraitFactory, tmp6, null, null, null, tmp$ret$2, completionSupplier);
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda_47(propertyValue) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return propertyValue.q6q();
  }
  function processLibraryEditors$lambda$lambda_48(_this__u8e3s4) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda_49(_this__u8e3s4) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda_50(it) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return true;
  }
  function processLibraryEditors$lambda$lambda_51($textCellInit) {
    return function ($this$referenceTarget) {
      $textCellInit($this$referenceTarget);
      enableEagerCompletion($this$referenceTarget);
      return Unit_instance;
    };
  }
  function PropertyValue$_get_value_$ref_lja1mh() {
    return function (p0) {
      return p0.a1();
    };
  }
  function processLibraryEditors$lambda$lambda_52(wrapperContext) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    // Inline function 'kotlin.apply' call
    var this_0 = MeasurableValue(wrapperContext);
    this_0.pib(0);
    return this_0;
  }
  function processLibraryEditors$lambda$lambda_53($this$child) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    getAbstractValueCompletion($this$child);
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda_54(_unused_var__etf5q3, trait) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return trait;
  }
  function processLibraryEditors$lambda$lambda_55($childProperty) {
    return function (it) {
      return $childProperty(it);
    };
  }
  function processLibraryEditors$lambda_46($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function processLibraryEditors$lambda_47($this$editor) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    var tmp4 = Companion_getInstance_329().rfv_1;
    // Inline function 'jetbrains.biokb.lang.editorBuilders.btbReferenceTarget' call
    var referenceProvider = processLibraryEditors$lambda$lambda_56;
    var options = new CompletionOptions();
    var containerInit = processLibraryEditors$lambda$lambda_57;
    var textCellInit = processLibraryEditors$lambda$lambda_58;
    var tmp;
    if (null == null) {
      tmp = processLibraryEditors$lambda$lambda_59;
    } else {
      tmp = null;
    }
    var tmp10 = tmp;
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.references.referenceTarget' call
    var textCellInit_0 = processLibraryEditors$lambda$lambda_60(textCellInit);
    var targetClass = getKClass(AbstractLink);
    referenceTarget($this$editor, targetClass, '<link>', tmp4, referenceProvider, null, tmp10, options, containerInit, textCellInit_0);
    space_0($this$editor);
    label_0($this$editor, '=');
    space_0($this$editor);
    var tmp_0 = getKClass(AbstractValue);
    child_1($this$editor, tmp_0, processLibraryEditors$lambda$lambda_61);
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda_56(ontologyLinkValue) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return ontologyLinkValue.cft();
  }
  function processLibraryEditors$lambda$lambda_57(_this__u8e3s4) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda_58(_this__u8e3s4) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda_59(it) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return true;
  }
  function processLibraryEditors$lambda$lambda_60($textCellInit) {
    return function ($this$referenceTarget) {
      $textCellInit($this$referenceTarget);
      enableEagerCompletion($this$referenceTarget);
      return Unit_instance;
    };
  }
  function processLibraryEditors$lambda$lambda_61(ontologyLinkValue) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return ontologyLinkValue.a1();
  }
  function processLibraryEditors$lambda_48($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function processLibraryEditors$lambda_49($this$editor) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    indent_0($this$editor, VOID, VOID, processLibraryEditors$lambda$lambda_62);
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda_62($this$indent) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    placeholderInCollection_0($this$indent, '<argument>', processLibraryEditors$lambda$lambda$lambda_44);
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda$lambda_44($this$placeholderInCollection) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    getBindingValueCompletion($this$placeholderInCollection);
    return Unit_instance;
  }
  function processLibraryEditors$lambda_50($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function processLibraryEditors$lambda_51($this$editor) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    var tmp = getKClass(PropertyLibraryElement);
    var tmp_0 = Layout_VERTICAL_getInstance();
    children_2($this$editor, tmp, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp_0, processLibraryEditors$lambda$lambda_63);
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda_63(propertyLibrary) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return propertyLibrary.ifq();
  }
  function processLibraryEditors$lambda_52($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function processLibraryEditors$lambda_53(wc) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return EmptyPropertyLibraryElement(wc);
  }
  function processLibraryEditors$lambda_54($this$childrenRoleDefaults) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    propertyDeclarationByNotionCompletion($this$childrenRoleDefaults);
    return Unit_instance;
  }
  function processLibraryEditors$lambda_55($this$editor) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    placeholderInCollection_0($this$editor, VOID, processLibraryEditors$lambda$lambda_64);
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda_64($this$placeholderInCollection) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    propertyDeclarationByNotionCompletion($this$placeholderInCollection);
    return Unit_instance;
  }
  function processLibraryEditors$lambda_56($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function processLibraryEditors$lambda_57($this$editor) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    var tmp = getKClass(ProcessKind_1);
    children_2($this$editor, tmp, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, processLibraryEditors$lambda$lambda_65);
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda_65(processKindContainer) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return processKindContainer.wft();
  }
  function processLibraryEditors$lambda_58($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function processLibraryEditors$lambda_59($this$childRoleDefaults) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    var tmp = $this$childRoleDefaults.jcg(Companion_getInstance_325().gg9_1);
    $this$childRoleDefaults.gck(tmp, processLibraryEditors$lambda$lambda_66($this$childRoleDefaults));
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda_66($this_childRoleDefaults) {
    return function (reference) {
      return ExtensionFieldReference_2($this_childRoleDefaults.l6z(), reference);
    };
  }
  function processLibraryEditors$lambda_60($this$editor) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    indent_0($this$editor, VOID, VOID, processLibraryEditors$lambda$lambda_67);
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda_67($this$indent) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    var tmp4 = Companion_getInstance_325().gg9_1;
    // Inline function 'jetbrains.biokb.lang.editorBuilders.btbReferenceTarget' call
    var referenceProvider = processLibraryEditors$lambda$lambda$lambda_45;
    var options = new CompletionOptions();
    var containerInit = processLibraryEditors$lambda$lambda$lambda_46;
    var textCellInit = processLibraryEditors$lambda$lambda$lambda_47;
    var tmp;
    if (null == null) {
      tmp = processLibraryEditors$lambda$lambda$lambda_48;
    } else {
      tmp = null;
    }
    var tmp10 = tmp;
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.references.referenceTarget' call
    var textCellInit_0 = processLibraryEditors$lambda$lambda$lambda_49(textCellInit);
    var targetClass = getKClass(FieldDeclaration_1);
    referenceTarget($this$indent, targetClass, '<field>', tmp4, referenceProvider, null, tmp10, options, containerInit, textCellInit_0);
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda$lambda_45(extensionFieldReference) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return extensionFieldReference.tfq();
  }
  function processLibraryEditors$lambda$lambda$lambda_46(_this__u8e3s4) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda$lambda_47(_this__u8e3s4) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda$lambda_48(it) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return true;
  }
  function processLibraryEditors$lambda$lambda$lambda_49($textCellInit) {
    return function ($this$referenceTarget) {
      $textCellInit($this$referenceTarget);
      enableEagerCompletion($this$referenceTarget);
      return Unit_instance;
    };
  }
  function processLibraryEditors$lambda_61($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function processLibraryEditors$lambda_62($this$editor) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    indent_0($this$editor, VOID, VOID, processLibraryEditors$lambda$lambda_68);
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda_68($this$indent) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    textProperty_0($this$indent, '<name>', processLibraryEditors$lambda$lambda$lambda_50);
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda$lambda_50(processKind) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return processKind.y2();
  }
  function processLibraryEditors$lambda_63($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function processLibraryEditors$lambda_64($this$processFactorEditor) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    processPrerequisiteCompletion($this$processFactorEditor);
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda$lambda_51(it) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return it.mfr();
  }
  function processLibraryEditors$lambda$lambda$lambda_52($this$child) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    factExpressionCompletion($this$child);
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda_69($queryLabels) {
    return function ($this$indent) {
      queryLabelsCell($this$indent, $queryLabels);
      var tmp = getKClass(FactExpression);
      var tmp_0 = processLibraryEditors$lambda$lambda$lambda_51;
      var expressionCell = child_1($this$indent, tmp, tmp_0, '<expression>', VOID, VOID, VOID, VOID, VOID, VOID, processLibraryEditors$lambda$lambda$lambda_52);
      var setQueriesLabelRightTransform = setQueryLabelRightTransform($this$indent.m6d(), false, $queryLabels);
      rightTransform_1($this$indent, expressionCell, setQueriesLabelRightTransform);
      return Unit_instance;
    };
  }
  function processLibraryEditors$lambda_65($queryLabels) {
    return function ($this$editor) {
      var indent = indent_0($this$editor, VOID, VOID, processLibraryEditors$lambda$lambda_69($queryLabels));
      mark_0(indent, get_QUERY_LABELS_CONTAINER_MARK());
      return Unit_instance;
    };
  }
  function processLibraryEditors$lambda_66($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function processLibraryEditors$lambda_67($this$processFactorEditor) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    processEffectCompletion($this$processFactorEditor);
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda$lambda_53(it) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return it.mfr();
  }
  function processLibraryEditors$lambda$lambda$lambda_54($this$child) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    factExpressionCompletion($this$child);
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda_70($queryLabels) {
    return function ($this$indent) {
      queryLabelsCell($this$indent, $queryLabels);
      var tmp = getKClass(FactExpression);
      var tmp_0 = processLibraryEditors$lambda$lambda$lambda_53;
      var expressionCell = child_1($this$indent, tmp, tmp_0, '<expression>', VOID, VOID, VOID, VOID, VOID, VOID, processLibraryEditors$lambda$lambda$lambda_54);
      var setQueriesLabelRightTransform = setQueryLabelRightTransform($this$indent.m6d(), false, $queryLabels);
      rightTransform_1($this$indent, expressionCell, setQueriesLabelRightTransform);
      return Unit_instance;
    };
  }
  function processLibraryEditors$lambda_68($queryLabels) {
    return function ($this$editor) {
      var indent = indent_0($this$editor, VOID, VOID, processLibraryEditors$lambda$lambda_70($queryLabels));
      mark_0(indent, get_QUERY_LABELS_CONTAINER_MARK());
      return Unit_instance;
    };
  }
  function processLibraryEditors$lambda_69($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function libraryProcessSpecificationEditor$slambda$lambda(processSpecification) {
    return processSpecification.vfr();
  }
  function libraryProcessSpecificationEditor$slambda$lambda_0(_this__u8e3s4) {
    return Unit_instance;
  }
  function libraryProcessSpecificationEditor$slambda$lambda_1(_this__u8e3s4) {
    return Unit_instance;
  }
  function libraryProcessSpecificationEditor$slambda$lambda_2(it) {
    return true;
  }
  function libraryProcessSpecificationEditor$slambda$lambda_3($textCellInit) {
    return function ($this$referenceTarget) {
      $textCellInit($this$referenceTarget);
      enableEagerCompletion($this$referenceTarget);
      return Unit_instance;
    };
  }
  function libraryProcessSpecificationEditor$slambda$lambda_4(processSpecification) {
    return processSpecification.kfr();
  }
  function libraryProcessSpecificationEditor$slambda$lambda_5($closingParen, $this_asyncInvalidatingEditor) {
    return function (_unused_var__etf5q3, event) {
      var tmp;
      if (event.m8j(Key_ENTER_getInstance(), [])) {
        if ($closingParen.y92().w2w() && $closingParen.x96()) {
          // Inline function 'jetbrains.ocelot.langDef.structure.NodeFactory.create' call
          var bindingValuePlaceholder = get_internalConfig($this_asyncInvalidatingEditor).kd5().t6v(getKClass(BindingValuePlaceholder_1));
          $this_asyncInvalidatingEditor.m6d().kfr().j(bindingValuePlaceholder);
        }
        var tmp_0;
        if (!($closingParen.y92().w2w() && $closingParen.v96())) {
          event.n8i();
          tmp_0 = Unit_instance;
        }
        tmp = tmp_0;
      }
      var params = $this_asyncInvalidatingEditor.m6d().kfr().m5y();
      var tmp_1;
      var tmp_2;
      if (event.m8j(Key_BACKSPACE_getInstance(), []) && $closingParen.y92().w2w() && $closingParen.x96()) {
        // Inline function 'kotlin.collections.isNotEmpty' call
        tmp_2 = !params.s();
      } else {
        tmp_2 = false;
      }
      if (tmp_2) {
        params.n2(get_lastIndex_2(params));
        event.n8i();
        tmp_1 = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function libraryProcessSpecificationEditor$slambda(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(libraryProcessSpecificationEditor$slambda).pue = function ($this$asyncInvalidatingEditor, $completion) {
    var tmp = this.que($this$asyncInvalidatingEditor, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(libraryProcessSpecificationEditor$slambda).v9 = function (p1, $completion) {
    return this.pue(p1 instanceof InvalidatingEditorBuilder ? p1 : THROW_CCE(), $completion);
  };
  protoOf(libraryProcessSpecificationEditor$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 4;
            this.oue_1 = false;
            this.f9_1 = 1;
            suspendResult = this.nue_1.k60(this.nue_1.m6d().vfr().w6o(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var resolvedProcessDeclaration = suspendResult;
            if (!(resolvedProcessDeclaration == null)) {
              this.f9_1 = 2;
              suspendResult = showCustomEditor(this.nue_1, resolvedProcessDeclaration, this.nue_1.m6d().kfr(), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.f9_1 = 3;
              continue $sm;
            }

          case 2:
            this.oue_1 = suspendResult;
            this.f9_1 = 3;
            continue $sm;
          case 3:
            if (!this.oue_1) {
              var tmp0 = this.nue_1;
              var tmp2 = '<process>';
              var tmp4 = Companion_getInstance_338().ihc_1;
              var referenceProvider = libraryProcessSpecificationEditor$slambda$lambda;
              var options = new CompletionOptions();
              var containerInit = libraryProcessSpecificationEditor$slambda$lambda_0;
              var textCellInit = libraryProcessSpecificationEditor$slambda$lambda_1;
              var tmp_0;
              if (null == null) {
                tmp_0 = libraryProcessSpecificationEditor$slambda$lambda_2;
              } else {
                tmp_0 = null;
              }
              var tmp10 = tmp_0;
              var textCellInit_0 = libraryProcessSpecificationEditor$slambda$lambda_3(textCellInit);
              var targetClass = getKClass(ProcessDeclaration_1);
              referenceTarget(tmp0, targetClass, tmp2, tmp4, referenceProvider, null, tmp10, options, containerInit, textCellInit_0);
              indentLabel_0(this.nue_1, '(');
              var tmp_1 = getKClass(BindingValuePlaceholder_1);
              children_2(this.nue_1, tmp_1, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, libraryProcessSpecificationEditor$slambda$lambda_4);
              var closingParen = indentLabel_0(this.nue_1, ')', true);
              this.nue_1.td3(libraryProcessSpecificationEditor$slambda$lambda_5(closingParen, this.nue_1));
            }

            return Unit_instance;
          case 4:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 4) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(libraryProcessSpecificationEditor$slambda).que = function ($this$asyncInvalidatingEditor, completion) {
    var i = new libraryProcessSpecificationEditor$slambda(completion);
    i.nue_1 = $this$asyncInvalidatingEditor;
    return i;
  };
  function libraryProcessSpecificationEditor$slambda_0(resultContinuation) {
    var i = new libraryProcessSpecificationEditor$slambda(resultContinuation);
    var l = function ($this$asyncInvalidatingEditor, $completion) {
      return i.pue($this$asyncInvalidatingEditor, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function libraryProcessSpecificationEditor$lambda$slambda($this_EditorDefinition, $init, $invalidator, $invalidated, resultContinuation) {
    this.zue_1 = $this_EditorDefinition;
    this.auf_1 = $init;
    this.buf_1 = $invalidator;
    this.cuf_1 = $invalidated;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(libraryProcessSpecificationEditor$lambda$slambda).x9e = function ($completion) {
    var tmp = this.y9e($completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(libraryProcessSpecificationEditor$lambda$slambda).z9e = function ($completion) {
    return this.x9e($completion);
  };
  protoOf(libraryProcessSpecificationEditor$lambda$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 6;
            this.g9_1 = 5;
            this.duf_1 = new Invalidator();
            this.euf_1 = this.zue_1.ud3(this.duf_1);
            this.f9_1 = 1;
            continue $sm;
          case 1:
            this.g9_1 = 4;
            this.f9_1 = 2;
            suspendResult = this.auf_1(this.euf_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.f9_1 = 3;
            continue $sm;
          case 3:
            this.g9_1 = 5;
            affects(this.duf_1.z5v(Unit_instance), this.buf_1);
            this.g9_1 = 6;
            this.f9_1 = 7;
            continue $sm;
          case 4:
            this.g9_1 = 5;
            var t = this.i9_1;
            affects(this.duf_1.z5v(Unit_instance), this.buf_1);
            throw t;
          case 5:
            this.g9_1 = 6;
            var tmp_0 = this.i9_1;
            if (tmp_0 instanceof AlreadyInvalidException) {
              var e = this.i9_1;
              this.cuf_1.d2x(true);
              this.f9_1 = 7;
              continue $sm;
            } else {
              throw this.i9_1;
            }

          case 6:
            throw this.i9_1;
          case 7:
            this.g9_1 = 6;
            return Unit_instance;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.g9_1 === 6) {
          throw e_0;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(libraryProcessSpecificationEditor$lambda$slambda).y9e = function (completion) {
    return new libraryProcessSpecificationEditor$lambda$slambda(this.zue_1, this.auf_1, this.buf_1, this.cuf_1, completion);
  };
  function libraryProcessSpecificationEditor$lambda$slambda_0($this_EditorDefinition, $init, $invalidator, $invalidated, resultContinuation) {
    var i = new libraryProcessSpecificationEditor$lambda$slambda($this_EditorDefinition, $init, $invalidator, $invalidated, resultContinuation);
    var l = function ($completion) {
      return i.x9e($completion);
    };
    l.$arity = 0;
    return l;
  }
  function libraryProcessSpecificationEditor$lambda($init) {
    return function ($this$EditorDefinition) {
      var invalidator = new Invalidator();
      var invalidated = new ValueProperty(false);
      depend(invalidator, invalidated);
      $this$EditorDefinition.vd3(libraryProcessSpecificationEditor$lambda$slambda_0($this$EditorDefinition, $init, invalidator, invalidated, null));
      return invalidator.z5v(Unit_instance);
    };
  }
  function libraryProcessSpecificationCompletion$lambda($this_libraryProcessSpecificationCompletion) {
    return function (reference) {
      // Inline function 'kotlin.apply' call
      var this_0 = LibraryProcessSpecification($this_libraryProcessSpecificationCompletion.l6z());
      this_0.vfr().f2x(reference);
      return this_0;
    };
  }
  function getAbstractBindingEntryCompletion$lambda($this$using) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    ontologyElementTypeCompletion_0($this$using);
    return Unit_instance;
  }
  function getAbstractBindingEntryCompletion$lambda_0($this_getAbstractBindingEntryCompletion) {
    return function (elementType) {
      // Inline function 'kotlin.apply' call
      var this_0 = OntologyLink($this_getAbstractBindingEntryCompletion.l6z());
      var tmp = this_0.xa1();
      // Inline function 'kotlin.apply' call
      var this_1 = LinkDeclaration($this_getAbstractBindingEntryCompletion.l6z());
      this_1.sfq().f2x(elementType);
      tmp.f2x(this_1);
      return this_0;
    };
  }
  function getAbstractBindingEntryCompletion$lambda_1($this$using) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    propertyDeclarationByNotionCompletion($this$using);
    return Unit_instance;
  }
  function getAbstractBindingEntryCompletion$lambda_2($this_getAbstractBindingEntryCompletion) {
    return function (it) {
      // Inline function 'kotlin.apply' call
      var this_0 = BindingProperty($this_getAbstractBindingEntryCompletion.l6z());
      this_0.q6q().f2x(it);
      return this_0;
    };
  }
  function getAbstractBindingEntryCompletion$lambda_3($this_getAbstractBindingEntryCompletion) {
    return function (reference) {
      // Inline function 'kotlin.apply' call
      var this_0 = ImportedLink($this_getAbstractBindingEntryCompletion.l6z());
      this_0.sfr().f2x(reference);
      return this_0;
    };
  }
  function getAbstractBindingEntryCompletion$lambda_4($this_getAbstractBindingEntryCompletion) {
    return function (refId) {
      // Inline function 'kotlin.apply' call
      var this_0 = ImportedProperty($this_getAbstractBindingEntryCompletion.l6z());
      this_0.sfr().f2x(refId);
      return this_0;
    };
  }
  function optionalSpecializedLink$lambda($this$indent) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    space_0($this$indent);
    keyword_0($this$indent, 'specializes');
    space_0($this$indent);
    var tmp4 = Companion_getInstance_329().rfv_1;
    // Inline function 'jetbrains.biokb.lang.editorBuilders.btbReferenceTarget' call
    var referenceProvider = optionalSpecializedLink$lambda$lambda;
    var options = new CompletionOptions();
    var containerInit = optionalSpecializedLink$lambda$lambda_0;
    var textCellInit = optionalSpecializedLink$lambda$lambda_1;
    var tmp;
    if (null == null) {
      tmp = optionalSpecializedLink$lambda$lambda_2;
    } else {
      tmp = null;
    }
    var tmp10 = tmp;
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.references.referenceTarget' call
    var textCellInit_0 = optionalSpecializedLink$lambda$lambda_3(textCellInit);
    var targetClass = getKClass(AbstractLink);
    referenceTarget($this$indent, targetClass, '<link>', tmp4, referenceProvider, null, tmp10, options, containerInit, textCellInit_0);
    return Unit_instance;
  }
  function optionalSpecializedLink$lambda$lambda(importedLink) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return importedLink.ufp();
  }
  function optionalSpecializedLink$lambda$lambda_0(_this__u8e3s4) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return Unit_instance;
  }
  function optionalSpecializedLink$lambda$lambda_1(_this__u8e3s4) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return Unit_instance;
  }
  function optionalSpecializedLink$lambda$lambda_2(it) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return true;
  }
  function optionalSpecializedLink$lambda$lambda_3($textCellInit) {
    return function ($this$referenceTarget) {
      $textCellInit($this$referenceTarget);
      enableEagerCompletion($this$referenceTarget);
      return Unit_instance;
    };
  }
  function optionalSpecializedLink$$inlined$forDisposable$1($this_optionalSpecializedLink, $specializedCell) {
    this.guf_1 = $this_optionalSpecializedLink;
    this.huf_1 = $specializedCell;
    DisposableSynchronizer.call(this);
  }
  protoOf(optionalSpecializedLink$$inlined$forDisposable$1).s87 = function (ctx) {
    return PropertyBinding_instance.n30(get_asProperty(shouldShowSpecialized(this.guf_1.m6d())), this.huf_1.m92());
  };
  function _get_propertyDeclarationEditor_$lambda_j0iclw($this$editor) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    textProperty_0($this$editor, '<name>', _get_propertyDeclarationEditor_$lambda$lambda_u0vjcv);
    label_0($this$editor, ':');
    space_0($this$editor);
    var tmp = getKClass(NotionType_0);
    child_1($this$editor, tmp, _get_propertyDeclarationEditor_$lambda$lambda_u0vjcv_0);
    return Unit_instance;
  }
  function _get_propertyDeclarationEditor_$lambda$lambda_u0vjcv(propertyDeclaration) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return propertyDeclaration.y2();
  }
  function _get_propertyDeclarationEditor_$lambda$lambda_u0vjcv_0(propertyDeclaration) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return propertyDeclaration.sfq();
  }
  function _get_propertyDeclarationEditor_$lambda_j0iclw_0($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function getBindingValueCompletion$lambda($this_getBindingValueCompletion) {
    return function (refId) {
      // Inline function 'kotlin.apply' call
      var this_0 = PropertyValue($this_getBindingValueCompletion.l6z());
      this_0.q6q().b6p(refId);
      return this_0;
    };
  }
  function getBindingValueCompletion$lambda_0($this_getBindingValueCompletion) {
    return function (refId) {
      // Inline function 'kotlin.apply' call
      var this_0 = OntologyLinkValue($this_getBindingValueCompletion.l6z());
      this_0.cft().b6p(refId);
      return this_0;
    };
  }
  function getBindingValueCompletion$lambda_1($this_getBindingValueCompletion) {
    return function (reference) {
      // Inline function 'kotlin.apply' call
      var this_0 = ProcessPropertyValue($this_getBindingValueCompletion.l6z());
      this_0.q6q().b6p(reference);
      return this_0;
    };
  }
  function propertyDeclarationByNotionCompletion$lambda($this$using) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    getNotionTypeCompletion($this$using);
    return Unit_instance;
  }
  function propertyDeclarationByNotionCompletion$lambda_0($this_propertyDeclarationByNotionCompletion) {
    return function (notionType) {
      // Inline function 'kotlin.apply' call
      var this_0 = PropertyDeclaration($this_propertyDeclarationByNotionCompletion.l6z());
      this_0.sfq().f2x(notionType);
      return this_0;
    };
  }
  function processPrerequisiteCompletion$lambda($this$using) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    factExpressionCompletion($this$using);
    return Unit_instance;
  }
  function processPrerequisiteCompletion$lambda_0($this_processPrerequisiteCompletion) {
    return function (expression) {
      return ProcessPrerequisite_1($this_processPrerequisiteCompletion.l6z(), expression);
    };
  }
  function processEffectCompletion$lambda($this$using) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    factExpressionCompletion($this$using);
    return Unit_instance;
  }
  function processEffectCompletion$lambda_0($this_processEffectCompletion) {
    return function (expression) {
      return ProcessEffect_1($this_processEffectCompletion.l6z(), expression);
    };
  }
  function simplePropertyTypeCompletion$lambda($this_simplePropertyTypeCompletion) {
    return function (reference) {
      return SimplePropertyType_0($this_simplePropertyTypeCompletion.l6z(), reference);
    };
  }
  function primitivePropertyTypeCompletion$lambda($this_primitivePropertyTypeCompletion, $it) {
    return function () {
      // Inline function 'kotlin.apply' call
      var this_0 = PrimitivePropertyType($this_primitivePropertyTypeCompletion.l6z());
      this_0.oft().f2x($it);
      return this_0;
    };
  }
  function ontologyElementPropertyTypeCompletion$lambda($this_ontologyElementPropertyTypeCompletion) {
    return function (spec) {
      // Inline function 'kotlin.apply' call
      var this_0 = OntologyElementPropertyType($this_ontologyElementPropertyTypeCompletion.l6z());
      this_0.jfr().f2x(spec);
      this_0.ffq().d2x(OntologyLibraryReference($this_ontologyElementPropertyTypeCompletion.l6z()));
      this_0.gfq().d2x(OntologyElementReference($this_ontologyElementPropertyTypeCompletion.l6z()));
      return this_0;
    };
  }
  function ontologyElementPropertyTypeCompletion$lambda_0($createPropertyTypeNode) {
    return function () {
      return $createPropertyTypeNode(LinkTypeSpecificator_TYPE_OF_getInstance());
    };
  }
  function ontologyElementPropertyTypeCompletion$lambda_1($createPropertyTypeNode) {
    return function () {
      return $createPropertyTypeNode(LinkTypeSpecificator_INSTANCE_OF_getInstance());
    };
  }
  function shouldShowSpecialized$$inlined$query$1($this_shouldShowSpecialized) {
    this.iuf_1 = $this_shouldShowSpecialized;
  }
  protoOf(shouldShowSpecialized$$inlined$query$1).n5w = function (builder) {
    // Inline function 'jetbrains.ocelot.langDef.structure.ancestorOrSelf' call
    var this_0 = this.iuf_1;
    var tmp$ret$0 = ancestorOrSelf(this_0, getKClass(ProcessDeclaration_1));
    var process = builder.l60(tmp$ret$0);
    return process == null || !(builder.l60(process.pft().z6o()) == null);
  };
  var properties_initialized_ProcessLibraryEditors_kt_qj0mvq;
  function _init_properties_ProcessLibraryEditors_kt__8wzws8() {
    if (!properties_initialized_ProcessLibraryEditors_kt_qj0mvq) {
      properties_initialized_ProcessLibraryEditors_kt_qj0mvq = true;
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init = processLibraryEditors$lambda;
      var triggerDependencies = emptyList();
      var tmp = getKClass(ProcessLibrary_1);
      var tmp_0 = new EditorDefinition(tmp, null, null, false, true, triggerDependencies, processLibraryEditors$lambda_0(init));
      var tmp0 = '<process declarations>';
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
      var separator_0 = get_blankLines(3);
      var tmp0_0 = new ChildrenRoleDefaults(getKClass(ProcessDeclaration_1), tmp0, null, separator_0, null, true);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_0 = processLibraryEditors$lambda_1;
      var triggerDependencies_0 = emptyList();
      var tmp_1 = getKClass(ProcessDeclaration_1);
      var tmp_2 = new EditorDefinition(tmp_1, tmp0_0, null, false, true, triggerDependencies_0, processLibraryEditors$lambda_2(init_0));
      var tmp0_1 = separator(',');
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
      var completionSupplier = processLibraryEditors$lambda_3;
      var tmp0_2 = new ChildrenRoleDefaults(getKClass(ProcessReference_1), '<empty>', null, tmp0_1, completionSupplier, true);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_1 = processLibraryEditors$lambda_4;
      var triggerDependencies_1 = emptyList();
      var tmp_3 = getKClass(ProcessReference_1);
      var tmp_4 = new EditorDefinition(tmp_3, tmp0_2, null, false, true, triggerDependencies_1, processLibraryEditors$lambda_5(init_1));
      var tmp0_3 = '<properties>';
      var tmp2 = processLibraryEditors$lambda_6;
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
      var completionSupplier_0 = processLibraryEditors$lambda_7;
      var separator_1 = get_defaultChildrenSeparator();
      var tmp0_4 = new ChildrenRoleDefaults(getKClass(ProcessProperty_1), tmp0_3, tmp2, separator_1, completionSupplier_0, true);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_2 = processLibraryEditors$lambda_8;
      var triggerDependencies_2 = emptyList();
      var tmp_5 = getKClass(ProcessProperty_1);
      var tmp_6 = new EditorDefinition(tmp_5, tmp0_4, null, false, true, triggerDependencies_2, processLibraryEditors$lambda_9(init_2));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_3 = processLibraryEditors$lambda_10;
      var triggerDependencies_3 = emptyList();
      var tmp_7 = getKClass(ProcessPropertyDefault_1);
      var tmp_8 = new EditorDefinition(tmp_7, null, null, false, true, triggerDependencies_3, processLibraryEditors$lambda_11(init_3));
      var tmp2_0 = separator(',');
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
      var completionSupplier_1 = processLibraryEditors$lambda_12;
      var tmp0_5 = new ChildrenRoleDefaults(getKClass(ProcessPropertyReference), '<...>', null, tmp2_0, completionSupplier_1, true);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_4 = processLibraryEditors$lambda_13;
      var triggerDependencies_4 = emptyList();
      var tmp_9 = getKClass(ProcessPropertyReference);
      var tmp_10 = new EditorDefinition(tmp_9, tmp0_5, null, false, true, triggerDependencies_4, processLibraryEditors$lambda_14(init_4));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
      var placeholderText = '<no inherited parameters>';
      var separator_2 = get_defaultChildrenSeparator();
      var tmp0_6 = new ChildrenRoleDefaults(getKClass(InheritedProcessProperty), placeholderText, null, separator_2, null, true);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_5 = processLibraryEditors$lambda_15;
      var triggerDependencies_5 = emptyList();
      var tmp_11 = getKClass(InheritedProcessProperty);
      var tmp_12 = new EditorDefinition(tmp_11, tmp0_6, null, false, true, triggerDependencies_5, processLibraryEditors$lambda_16(init_5));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
      var completionSupplier_2 = processLibraryEditors$lambda_17;
      var separator_3 = get_defaultChildrenSeparator();
      var tmp0_7 = new ChildrenRoleDefaults(getKClass(ProcessPropertyValueRange), '<type>', null, separator_3, completionSupplier_2, false);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_6 = processLibraryEditors$lambda_18;
      var triggerDependencies_6 = emptyList();
      var tmp_13 = getKClass(MultipleProcessPropertyValueRange_1);
      var tmp_14 = new EditorDefinition(tmp_13, null, null, false, true, triggerDependencies_6, processLibraryEditors$lambda_19(init_6));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
      var completionSupplier_3 = processLibraryEditors$lambda_20;
      var separator_4 = get_defaultChildrenSeparator();
      var tmp0_8 = new ChildrenRoleDefaults(getKClass(ProcessPropertyType), '<type>', null, separator_4, completionSupplier_3, false);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_7 = processLibraryEditors$lambda_21;
      var triggerDependencies_7 = emptyList();
      var tmp_15 = getKClass(SimplePropertyType);
      var tmp_16 = new EditorDefinition(tmp_15, null, null, false, true, triggerDependencies_7, processLibraryEditors$lambda_22(init_7));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_8 = processLibraryEditors$lambda_23;
      var triggerDependencies_8 = emptyList();
      var tmp_17 = getKClass(PrimitivePropertyType_1);
      var tmp_18 = new EditorDefinition(tmp_17, null, null, false, true, triggerDependencies_8, processLibraryEditors$lambda_24(init_8));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_9 = processLibraryEditors$lambda_25;
      var triggerDependencies_9 = emptyList();
      var tmp_19 = getKClass(OntologyElementPropertyType_1);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.hierarchyEditor' call
      var editorDefinitions = [tmp_16, tmp_18, new EditorDefinition(tmp_19, null, null, false, true, triggerDependencies_9, processLibraryEditors$lambda_26(init_9)), classExpressionTypeEditor()];
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.hierarchyEditor' call
      var editorDefinitions_0 = [tmp_14, new HierarchyEditorDefinition(getKClass(ProcessPropertyType), tmp0_8, toList(editorDefinitions))];
      var tmp_20 = new HierarchyEditorDefinition(getKClass(ProcessPropertyValueRange), tmp0_7, toList(editorDefinitions_0));
      var tmp0_9 = '<entries>';
      var tmp2_1 = processLibraryEditors$lambda_27;
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
      var completionSupplier_4 = processLibraryEditors$lambda_28;
      var separator_5 = get_defaultChildrenSeparator();
      var tmp0_10 = new ChildrenRoleDefaults(getKClass(AbstractBindingEntry), tmp0_9, tmp2_1, separator_5, completionSupplier_4, true);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_10 = processLibraryEditors$lambda_29;
      var triggerDependencies_10 = emptyList();
      var tmp_21 = getKClass(BindingProperty_1);
      var tmp_22 = new EditorDefinition(tmp_21, null, null, false, true, triggerDependencies_10, processLibraryEditors$lambda_30(init_10));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_11 = processLibraryEditors$lambda_31;
      var triggerDependencies_11 = emptyList();
      var tmp_23 = getKClass(OntologyLink_1);
      var tmp_24 = new EditorDefinition(tmp_23, null, null, false, true, triggerDependencies_11, processLibraryEditors$lambda_32(init_11));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_12 = processLibraryEditors$lambda_33;
      var triggerDependencies_12 = emptyList();
      var tmp_25 = getKClass(ImportedProperty_1);
      var tmp_26 = new EditorDefinition(tmp_25, null, null, true, true, triggerDependencies_12, processLibraryEditors$lambda_34(init_12));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_13 = processLibraryEditors$lambda_35;
      var triggerDependencies_13 = emptyList();
      var tmp_27 = getKClass(ImportedLink_1);
      var tmp_28 = new EditorDefinition(tmp_27, null, null, true, true, triggerDependencies_13, processLibraryEditors$lambda_36(init_13));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_14 = processLibraryEditors$lambda_37;
      var triggerDependencies_14 = emptyList();
      var tmp_29 = getKClass(EmptyBindingEntry_1);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.hierarchyEditor' call
      var editorDefinitions_1 = [tmp_22, tmp_24, tmp_26, tmp_28, new EditorDefinition(tmp_29, null, null, false, true, triggerDependencies_14, processLibraryEditors$lambda_38(init_14))];
      var tmp_30 = new HierarchyEditorDefinition(getKClass(AbstractBindingEntry), tmp0_10, toList(editorDefinitions_1));
      var tmp_31 = get_propertyDeclarationEditor();
      var tmp_32 = processLibraryEditors$lambda_39;
      var tmp0_11 = childRoleDefaults('<spec>', tmp_32, processLibraryEditors$lambda_40);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.hierarchyEditor' call
      var editorDefinitions_2 = [libraryProcessSpecificationEditor()];
      var tmp_33 = new HierarchyEditorDefinition(getKClass(AbstractProcessSpecification), tmp0_11, toList(editorDefinitions_2));
      var tmp0_12 = '<parameters>';
      var tmp2_2 = separator(',');
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
      var completionSupplier_5 = processLibraryEditors$lambda_41;
      var tmp0_13 = new ChildrenRoleDefaults(getKClass(BindingValuePlaceholder_1), tmp0_12, null, tmp2_2, completionSupplier_5, true);
      var tmp0_14 = childRoleDefaults('<value>', processLibraryEditors$lambda_42);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_15 = processLibraryEditors$lambda_43;
      var triggerDependencies_15 = emptyList();
      var tmp_34 = getKClass(ProcessPropertyValue_1);
      var tmp_35 = new EditorDefinition(tmp_34, null, null, false, true, triggerDependencies_15, processLibraryEditors$lambda_44(init_15));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_16 = processLibraryEditors$lambda_45;
      var triggerDependencies_16 = emptyList();
      var tmp_36 = getKClass(PropertyValue_1);
      var tmp_37 = new EditorDefinition(tmp_36, null, null, false, true, triggerDependencies_16, processLibraryEditors$lambda_46(init_16));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_17 = processLibraryEditors$lambda_47;
      var triggerDependencies_17 = emptyList();
      var tmp_38 = getKClass(OntologyLinkValue_1);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.hierarchyEditor' call
      var editorDefinitions_3 = [tmp_35, tmp_37, new EditorDefinition(tmp_38, null, null, true, true, triggerDependencies_17, processLibraryEditors$lambda_48(init_17))];
      var tmp_39 = new HierarchyEditorDefinition(getKClass(BindingValuePlaceholder_1), tmp0_14, toList(editorDefinitions_3));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_18 = processLibraryEditors$lambda_49;
      var triggerDependencies_18 = emptyList();
      var tmp_40 = getKClass(BindingValuePlaceholder_1);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.hierarchyEditor' call
      var editorDefinitions_4 = [tmp_39, new EditorDefinition(tmp_40, null, null, false, true, triggerDependencies_18, processLibraryEditors$lambda_50(init_18))];
      var tmp_41 = new HierarchyEditorDefinition(getKClass(BindingValuePlaceholder_1), tmp0_13, toList(editorDefinitions_4));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_19 = processLibraryEditors$lambda_51;
      var triggerDependencies_19 = emptyList();
      var tmp_42 = getKClass(PropertyLibrary_1);
      var tmp_43 = new EditorDefinition(tmp_42, null, null, false, true, triggerDependencies_19, processLibraryEditors$lambda_52(init_19));
      var tmp0_15 = '<define process properties here>';
      var tmp2_3 = processLibraryEditors$lambda_53;
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
      var completionSupplier_6 = processLibraryEditors$lambda_54;
      var separator_6 = get_defaultChildrenSeparator();
      var tmp0_16 = new ChildrenRoleDefaults(getKClass(PropertyLibraryElement), tmp0_15, tmp2_3, separator_6, completionSupplier_6, true);
      var tmp_44 = get_propertyDeclarationEditor();
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_20 = processLibraryEditors$lambda_55;
      var triggerDependencies_20 = emptyList();
      var tmp_45 = getKClass(EmptyPropertyLibraryElement_1);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.hierarchyEditor' call
      var editorDefinitions_5 = [tmp_44, new EditorDefinition(tmp_45, null, null, false, true, triggerDependencies_20, processLibraryEditors$lambda_56(init_20))];
      var tmp_46 = new HierarchyEditorDefinition(getKClass(PropertyLibraryElement), tmp0_16, toList(editorDefinitions_5));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_21 = processLibraryEditors$lambda_57;
      var triggerDependencies_21 = emptyList();
      var tmp_47 = getKClass(ProcessKindContainer_1);
      var tmp_48 = new EditorDefinition(tmp_47, null, null, false, true, triggerDependencies_21, processLibraryEditors$lambda_58(init_21));
      var tmp0_17 = childRoleDefaults(VOID, processLibraryEditors$lambda_59);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_22 = processLibraryEditors$lambda_60;
      var triggerDependencies_22 = emptyList();
      var tmp_49 = getKClass(ExtensionFieldReference_1);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.hierarchyEditor' call
      var editorDefinitions_6 = [new EditorDefinition(tmp_49, null, null, true, true, triggerDependencies_22, processLibraryEditors$lambda_61(init_22))];
      var tmp_50 = new HierarchyEditorDefinition(getKClass(PartReferenceOperation), tmp0_17, toList(editorDefinitions_6));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
      var placeholderText_0 = '<process kind>';
      var separator_7 = get_defaultChildrenSeparator();
      var tmp0_18 = new ChildrenRoleDefaults(getKClass(ProcessKind_1), placeholderText_0, null, separator_7, null, true);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_23 = processLibraryEditors$lambda_62;
      var triggerDependencies_23 = emptyList();
      var tmp_51 = getKClass(ProcessKind_1);
      var tmp_52 = new EditorDefinition(tmp_51, tmp0_18, null, false, true, triggerDependencies_23, processLibraryEditors$lambda_63(init_23));
      var tmp0_19 = get_entries_0();
      // Inline function 'jetbrains.biokb.lang.editorBuilders.processFactorEditor' call
      var completion = processLibraryEditors$lambda_64;
      var tmp0_20 = childRoleDefaults('<expression>', completion, VOID, true);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_24 = processLibraryEditors$lambda_65(tmp0_19);
      var triggerDependencies_24 = emptyList();
      var tmp_53 = getKClass(ProcessPrerequisite_0);
      var tmp_54 = new EditorDefinition(tmp_53, tmp0_20, null, false, true, triggerDependencies_24, processLibraryEditors$lambda_66(init_24));
      var tmp0_21 = plus_5(listOf(EntryQueryLabel_getInstance()), get_entries_0());
      // Inline function 'jetbrains.biokb.lang.editorBuilders.processFactorEditor' call
      var completion_0 = processLibraryEditors$lambda_67;
      var tmp0_22 = childRoleDefaults('<expression>', completion_0, VOID, true);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_25 = processLibraryEditors$lambda_68(tmp0_21);
      var triggerDependencies_25 = emptyList();
      var tmp_55 = getKClass(ProcessEffect_0);
      var tmp$ret$47 = new EditorDefinition(tmp_55, tmp0_22, null, false, true, triggerDependencies_25, processLibraryEditors$lambda_69(init_25));
      processLibraryEditors = listOf_0([tmp_0, tmp_2, tmp_4, tmp_6, tmp_8, tmp_10, tmp_12, tmp_20, tmp_30, tmp_31, tmp_33, tmp_41, tmp_43, tmp_46, tmp_48, tmp_50, tmp_52, tmp_54, tmp$ret$47]);
      RANGE_CELL_MARK = new CellMark();
      PROCESS_PROPERTY_CELL_MARK = new CellMark();
    }
  }
  function get_queryCommandEditors() {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    return queryCommandEditors;
  }
  var queryCommandEditors;
  function contextQueryChild(_this__u8e3s4, role) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    var tmp = getKClass(ContextQuery_1);
    var tmp_0 = contextQueryChild$lambda;
    child_1(_this__u8e3s4, tmp, role, '<context>', VOID, tmp_0, VOID, VOID, VOID, VOID, contextQueryChild$lambda_0);
  }
  function createContextQuery(wrapperContext, libraryRef) {
    libraryRef = libraryRef === VOID ? null : libraryRef;
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    // Inline function 'kotlin.apply' call
    var this_0 = ContextQuery(wrapperContext);
    var tmp = this_0.ffq();
    // Inline function 'kotlin.apply' call
    var this_1 = OntologyLibraryReference(wrapperContext);
    if (!(libraryRef == null)) {
      this_1.yfq().f2x(libraryRef);
    }
    tmp.f2x(this_1);
    this_0.gfq().f2x(OntologyElementReference(wrapperContext));
    return this_0;
  }
  function contextQueryCompletion(_this__u8e3s4) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    var tmp = _this__u8e3s4.jcg(Companion_getInstance_335().dh6_1);
    _this__u8e3s4.gck(tmp, contextQueryCompletion$lambda(_this__u8e3s4));
  }
  function getBindingValueQueryCompletion(_this__u8e3s4) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    var tmp = _this__u8e3s4.ick(getBindingValueQueryCompletion$lambda);
    _this__u8e3s4.jck(tmp, getBindingValueQueryCompletion$lambda_0(_this__u8e3s4));
    var tmp_0 = _this__u8e3s4.jcg(Companion_getInstance_347().eh7_1);
    _this__u8e3s4.gck(tmp_0, getBindingValueQueryCompletion$lambda_1(_this__u8e3s4));
    var tmp_1 = _this__u8e3s4.jcg(Companion_getInstance_348().uhk_1);
    _this__u8e3s4.gck(tmp_1, getBindingValueQueryCompletion$lambda_2(_this__u8e3s4));
  }
  function valueChild_0(_this__u8e3s4) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    var tmp = getKClass(AbstractValue);
    child_1(_this__u8e3s4, tmp, valueChild$lambda_1);
  }
  function queryCommandEditors$lambda($this$editor) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    indent_0($this$editor, VOID, VOID, queryCommandEditors$lambda$lambda);
    return Unit_instance;
  }
  function queryCommandEditors$lambda$lambda($this$indent) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    var tmp = getKClass(Command_0);
    var tmp_0 = Layout_VERTICAL_getInstance();
    children_2($this$indent, tmp, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp_0, queryCommandEditors$lambda$lambda$lambda);
    return Unit_instance;
  }
  function queryCommandEditors$lambda$lambda$lambda(queryCommands) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    return queryCommands.u51();
  }
  function queryCommandEditors$lambda_0($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function queryCommandEditors$lambda_1(wrapperContext) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    return FindNewConnectionCommand(wrapperContext);
  }
  function queryCommandEditors$lambda_2($this$childrenRoleDefaults) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    $this$childrenRoleDefaults.bck('find connection', queryCommandEditors$lambda$lambda_0($this$childrenRoleDefaults));
    $this$childrenRoleDefaults.bck('find new connection', queryCommandEditors$lambda$lambda_1($this$childrenRoleDefaults));
    return Unit_instance;
  }
  function queryCommandEditors$lambda$lambda_0($this_childrenRoleDefaults) {
    return function () {
      // Inline function 'kotlin.apply' call
      var this_0 = FindConnectionCommand($this_childrenRoleDefaults.l6z());
      this_0.f4b().f2x(LibraryProcessSpecificationQuery($this_childrenRoleDefaults.l6z()));
      this_0.g4b().f2x(LibraryProcessSpecificationQuery($this_childrenRoleDefaults.l6z()));
      return this_0;
    };
  }
  function queryCommandEditors$lambda$lambda_1($this_childrenRoleDefaults) {
    return function () {
      return FindNewConnectionCommand($this_childrenRoleDefaults.l6z());
    };
  }
  function queryCommandEditors$lambda_3($this$editor) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    keyword_0($this$editor, 'find connection');
    newLine_0($this$editor);
    keyword_0($this$editor, 'with');
    space_0($this$editor);
    contextQueryChild($this$editor, queryCommandEditors$lambda$lambda_2);
    indent_0($this$editor, true, VOID, queryCommandEditors$lambda$lambda_3);
    indent_0($this$editor, true, VOID, queryCommandEditors$lambda$lambda_4);
    return Unit_instance;
  }
  function queryCommandEditors$lambda$lambda_2(it) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    return it.efr();
  }
  function queryCommandEditors$lambda$lambda_3($this$indent) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    newLine_0($this$indent);
    keyword_0($this$indent, 'from');
    space_0($this$indent);
    var tmp = getKClass(LibraryProcessSpecificationQuery_1);
    child_1($this$indent, tmp, queryCommandEditors$lambda$lambda$lambda_0, '<from>');
    return Unit_instance;
  }
  function queryCommandEditors$lambda$lambda$lambda_0(connectionCommand) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    return connectionCommand.f4b();
  }
  function queryCommandEditors$lambda$lambda_4($this$indent) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    newLine_0($this$indent);
    keyword_0($this$indent, 'to');
    space_0($this$indent);
    var tmp = getKClass(LibraryProcessSpecificationQuery_1);
    child_1($this$indent, tmp, queryCommandEditors$lambda$lambda$lambda_1, '<to>');
    return Unit_instance;
  }
  function queryCommandEditors$lambda$lambda$lambda_1(connectionCommand) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    return connectionCommand.g4b();
  }
  function queryCommandEditors$lambda_4($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function queryCommandEditors$lambda_5($this$editor) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    keyword_0($this$editor, 'find new connection');
    newLine_0($this$editor);
    keyword_0($this$editor, 'with');
    space_0($this$editor);
    var tmp0_layout = Layout_VERTICAL_getInstance();
    var tmp2 = getKClass(ContextQuery_1);
    var tmp = KProperty1;
    var tmp4 = getPropertyCallableRef('contextQueries', 1, tmp, FindNewConnectionCommand$_get_contextQueries_$ref_s8ua7z_1(), null);
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.children' call
    var placeholderText = '<context>';
    var placeholderTraitFactory = queryCommandEditors$lambda$lambda_5;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp_0 = new MultipleChildLink(getKClass(FindNewConnectionCommand_1), tmp4);
    children_2($this$editor, tmp2, tmp_0, placeholderText, placeholderTraitFactory, null, null, null, null, tmp0_layout, queryCommandEditors$lambda$lambda_6(tmp4));
    newLine_0($this$editor);
    newLine_0($this$editor);
    variablesEditor($this$editor);
    indent_0($this$editor, true, VOID, queryCommandEditors$lambda$lambda_7);
    indent_0($this$editor, true, VOID, queryCommandEditors$lambda$lambda_8);
    return Unit_instance;
  }
  function FindNewConnectionCommand$_get_contextQueries_$ref_s8ua7z_1() {
    return function (p0) {
      return p0.ffr();
    };
  }
  function queryCommandEditors$lambda$lambda_5(_unused_var__etf5q3, trait) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    return trait;
  }
  function queryCommandEditors$lambda$lambda_6($childrenProperty) {
    return function (it) {
      return $childrenProperty(it);
    };
  }
  function queryCommandEditors$lambda$lambda_7($this$indent) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    newLine_0($this$indent);
    newLine_0($this$indent);
    keyword_0($this$indent, 'from');
    space_0($this$indent);
    var tmp = getKClass(Pattern);
    child_1($this$indent, tmp, queryCommandEditors$lambda$lambda$lambda_2, '<from>');
    return Unit_instance;
  }
  function queryCommandEditors$lambda$lambda$lambda_2(command) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    return command.f4b();
  }
  function queryCommandEditors$lambda$lambda_8($this$indent) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    newLine_0($this$indent);
    keyword_0($this$indent, 'to');
    space_0($this$indent);
    var tmp = getKClass(Pattern);
    child_1($this$indent, tmp, queryCommandEditors$lambda$lambda$lambda_3, '<to>');
    return Unit_instance;
  }
  function queryCommandEditors$lambda$lambda$lambda_3(command) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    return command.g4b();
  }
  function queryCommandEditors$lambda_6($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function queryCommandEditors$lambda_7($this$childRoleDefaults) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    var tmp = $this$childRoleDefaults.jcg(Companion_getInstance_346().zhw_1);
    $this$childRoleDefaults.gck(tmp, queryCommandEditors$lambda$lambda_9($this$childRoleDefaults));
    return Unit_instance;
  }
  function queryCommandEditors$lambda$lambda_9($this_childRoleDefaults) {
    return function (refId) {
      // Inline function 'kotlin.apply' call
      var this_0 = VariablePattern($this_childRoleDefaults.l6z());
      this_0.pfu().f2x(refId);
      return this_0;
    };
  }
  function queryCommandEditors$lambda_8(wrapperContext) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    return VariablePattern(wrapperContext);
  }
  function queryCommandEditors$lambda_9($this$editor) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    var tmp2 = '<variable>';
    var tmp4 = Companion_getInstance_346().zhw_1;
    // Inline function 'jetbrains.biokb.lang.editorBuilders.btbReferenceTarget' call
    var referenceProvider = queryCommandEditors$lambda$lambda_10;
    var options = new CompletionOptions();
    var containerInit = queryCommandEditors$lambda$lambda_11;
    var textCellInit = queryCommandEditors$lambda$lambda_12;
    var tmp;
    if (null == null) {
      tmp = queryCommandEditors$lambda$lambda_13;
    } else {
      tmp = null;
    }
    var tmp10 = tmp;
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.references.referenceTarget' call
    var textCellInit_0 = queryCommandEditors$lambda$lambda_14(textCellInit);
    var targetClass = getKClass(VariableDeclaration_1);
    referenceTarget($this$editor, targetClass, tmp2, tmp4, referenceProvider, null, tmp10, options, containerInit, textCellInit_0);
    return Unit_instance;
  }
  function queryCommandEditors$lambda$lambda_10(variablePattern) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    return variablePattern.pfu();
  }
  function queryCommandEditors$lambda$lambda_11(_this__u8e3s4) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    return Unit_instance;
  }
  function queryCommandEditors$lambda$lambda_12(_this__u8e3s4) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    return Unit_instance;
  }
  function queryCommandEditors$lambda$lambda_13(it) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    return true;
  }
  function queryCommandEditors$lambda$lambda_14($textCellInit) {
    return function ($this$referenceTarget) {
      $textCellInit($this$referenceTarget);
      enableEagerCompletion($this$referenceTarget);
      return Unit_instance;
    };
  }
  function queryCommandEditors$lambda_10($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function queryCommandEditors$lambda_11(wrapperContext) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    return createContextQuery(wrapperContext);
  }
  function queryCommandEditors$lambda_12($this$childrenRoleDefaults) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    contextQueryCompletion($this$childrenRoleDefaults);
    return Unit_instance;
  }
  function queryCommandEditors$lambda_13($this$editor) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    var tmp = getKClass(OntologyLibraryReference_1);
    var tmp_0 = queryCommandEditors$lambda$lambda_15;
    child_1($this$editor, tmp, tmp_0, VOID, VOID, VOID, VOID, VOID, VOID, VOID, queryCommandEditors$lambda$lambda_16);
    indentLabel_0($this$editor, '/');
    var tmp_1 = getKClass(OntologyElementReference_1);
    child_1($this$editor, tmp_1, queryCommandEditors$lambda$lambda_17);
    return Unit_instance;
  }
  function queryCommandEditors$lambda$lambda_15(contextQuery) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    return contextQuery.ffq();
  }
  function queryCommandEditors$lambda$lambda_16($this$child) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    var tmp = $this$child.jcg(Companion_getInstance_335().dh6_1);
    $this$child.gck(tmp, queryCommandEditors$lambda$lambda$lambda_4($this$child));
    return Unit_instance;
  }
  function queryCommandEditors$lambda$lambda$lambda_4($this_child) {
    return function (refString) {
      // Inline function 'kotlin.apply' call
      var this_0 = OntologyLibraryReference($this_child.l6z());
      this_0.yfq().f2x(refString);
      return this_0;
    };
  }
  function queryCommandEditors$lambda$lambda_17(contextQuery) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    return contextQuery.gfq();
  }
  function queryCommandEditors$lambda_14($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function queryCommandEditors$lambda_15($this$childRoleDefaults) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    var tmp = $this$childRoleDefaults.jcg(Companion_getInstance_338().ihc_1);
    $this$childRoleDefaults.gck(tmp, queryCommandEditors$lambda$lambda_18($this$childRoleDefaults));
    return Unit_instance;
  }
  function queryCommandEditors$lambda$lambda_18($this_childRoleDefaults) {
    return function (refId) {
      // Inline function 'kotlin.apply' call
      var this_0 = LibraryProcessSpecificationQuery($this_childRoleDefaults.l6z());
      this_0.vfr().f2x(refId);
      return this_0;
    };
  }
  function queryCommandEditors$lambda_16($this$editor) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    var tmp2 = '<process>';
    var tmp4 = Companion_getInstance_338().ihc_1;
    // Inline function 'jetbrains.biokb.lang.editorBuilders.btbReferenceTarget' call
    var referenceProvider = queryCommandEditors$lambda$lambda_19;
    var options = new CompletionOptions();
    var containerInit = queryCommandEditors$lambda$lambda_20;
    var textCellInit = queryCommandEditors$lambda$lambda_21;
    var tmp;
    if (null == null) {
      tmp = queryCommandEditors$lambda$lambda_22;
    } else {
      tmp = null;
    }
    var tmp10 = tmp;
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.references.referenceTarget' call
    var textCellInit_0 = queryCommandEditors$lambda$lambda_23(textCellInit);
    var targetClass = getKClass(ProcessDeclaration_1);
    referenceTarget($this$editor, targetClass, tmp2, tmp4, referenceProvider, null, tmp10, options, containerInit, textCellInit_0);
    indentLabel_0($this$editor, '(');
    var tmp_0 = getKClass(BindingValuePlaceholderQuery_1);
    children_2($this$editor, tmp_0, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, queryCommandEditors$lambda$lambda_24);
    indentLabel_0($this$editor, ')', true);
    return Unit_instance;
  }
  function queryCommandEditors$lambda$lambda_19(processSpecificationQuery) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    return processSpecificationQuery.vfr();
  }
  function queryCommandEditors$lambda$lambda_20(_this__u8e3s4) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    return Unit_instance;
  }
  function queryCommandEditors$lambda$lambda_21(_this__u8e3s4) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    return Unit_instance;
  }
  function queryCommandEditors$lambda$lambda_22(it) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    return true;
  }
  function queryCommandEditors$lambda$lambda_23($textCellInit) {
    return function ($this$referenceTarget) {
      $textCellInit($this$referenceTarget);
      enableEagerCompletion($this$referenceTarget);
      return Unit_instance;
    };
  }
  function queryCommandEditors$lambda$lambda_24(processSpecificationQuery) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    return processSpecificationQuery.kfr();
  }
  function queryCommandEditors$lambda_17($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function queryCommandEditors$lambda_18($this$childrenRoleDefaults) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    getBindingValueQueryCompletion($this$childrenRoleDefaults);
    return Unit_instance;
  }
  function queryCommandEditors$lambda_19($this$childRoleDefaults) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    getBindingValueQueryCompletion($this$childRoleDefaults);
    return Unit_instance;
  }
  function queryCommandEditors$lambda_20($this$editor) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    var tmp = getKClass(AbstractBindingValueQuery);
    child_1($this$editor, tmp, queryCommandEditors$lambda$lambda_25, '<left>');
    space_0($this$editor);
    label_0($this$editor, '||');
    space_0($this$editor);
    indent_0($this$editor, VOID, VOID, queryCommandEditors$lambda$lambda_26);
    return Unit_instance;
  }
  function queryCommandEditors$lambda$lambda_25(orValueQuery) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    return orValueQuery.dft();
  }
  function queryCommandEditors$lambda$lambda_26($this$indent) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    var tmp = getKClass(AbstractBindingValueQuery);
    child_1($this$indent, tmp, queryCommandEditors$lambda$lambda$lambda_5, '<right>');
    addTraitOnAttach_0($this$indent, queryCommandEditors$lambda$lambda$lambda_6);
    return Unit_instance;
  }
  function queryCommandEditors$lambda$lambda$lambda_5(orValueQuery) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    return orValueQuery.eft();
  }
  function queryCommandEditors$lambda$lambda$lambda_6(source, _unused_var__etf5q3, cellFinder) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    return getDeleteTransformTrait_0(source, cellFinder);
  }
  function queryCommandEditors$lambda_21($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function queryCommandEditors$lambda_22($this$editor) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    var tmp = getKClass(BindingValuePlaceholder_1);
    child_1($this$editor, tmp, queryCommandEditors$lambda$lambda_27);
    var tmp_0 = isEmpty$ref_3();
    editableText_0($this$editor, '', VOID, tmp_0, VOID, queryCommandEditors$lambda$lambda_28);
    return Unit_instance;
  }
  function queryCommandEditors$lambda$lambda_27(bindingValueMask) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    return bindingValueMask.a1();
  }
  function isEmpty$ref_3() {
    var l = function (p0) {
      // Inline function 'kotlin.text.isEmpty' call
      return charSequenceLength(p0) === 0;
    };
    l.callableName = 'isEmpty';
    return l;
  }
  function queryCommandEditors$lambda$lambda_28($this$editableText) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    rightTransform_0($this$editableText, queryCommandEditors$lambda$lambda$lambda_7($this$editableText));
    return Unit_instance;
  }
  function queryCommandEditors$34$5$2$2$$inlined$executeQuery$1($this_editableText, $source, $cellFinder) {
    this.juf_1 = $this_editableText;
    this.kuf_1 = $source;
    this.luf_1 = $cellFinder;
  }
  protoOf(queryCommandEditors$34$5$2$2$$inlined$executeQuery$1).n5w = function (builder) {
    var wrapperContext = get_internalConfig(this.juf_1).l6z();
    // Inline function 'kotlin.let' call
    var orValueQuery = OrValueQuery(wrapperContext);
    var tmp = this.kuf_1.bp();
    var parentOr = (!(tmp == null) ? isInterface(tmp, OrValueQuery_1) : false) ? tmp : null;
    if (parentOr == null || equals(builder.l60(parentOr.eft()), this.kuf_1)) {
      var tmp_0 = orValueQuery.dft();
      var tmp_1 = this.kuf_1.f6j();
      tmp_0.f2x(isInterface(tmp_1, BindingValueMask_1) ? tmp_1 : THROW_CCE());
      this.kuf_1.d6j(orValueQuery);
    } else {
      var tmp_2 = orValueQuery.eft();
      var tmp0_safe_receiver = builder.l60(parentOr.eft());
      var tmp_3 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.f6j();
      tmp_2.f2x((!(tmp_3 == null) ? isInterface(tmp_3, AbstractBindingValueQuery) : false) ? tmp_3 : null);
      parentOr.eft().f2x(orValueQuery);
    }
    var tmp1_safe_receiver = firstOrNull_0(this.luf_1.lah(orValueQuery));
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.c93(ProjectionalSynchronizers_getInstance().d99_1);
    return tmp2_elvis_lhs == null ? get_EMPTY_CELL_ACTION() : tmp2_elvis_lhs;
  };
  function queryCommandEditors$lambda$lambda$lambda$lambda($this_editableText, $source, $cellFinder) {
    return function () {
      // Inline function 'jetbrains.ocelot.langDef.query.executeQuery' call
      // Inline function 'jetbrains.ocelot.langDef.query.query' call
      var tmp$ret$0 = new queryCommandEditors$34$5$2$2$$inlined$executeQuery$1($this_editableText, $source, $cellFinder);
      return execute_0(tmp$ret$0);
    };
  }
  function queryCommandEditors$lambda$lambda$lambda_7($this_editableText) {
    return function ($this$rightTransform, source, _unused_var__etf5q3, cellFinder) {
      $this$rightTransform.gcg('||', queryCommandEditors$lambda$lambda$lambda$lambda($this_editableText, source, cellFinder));
      return Unit_instance;
    };
  }
  function queryCommandEditors$lambda_23($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function queryCommandEditors$lambda_24($this$editor) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    var tmp2 = '<linkDeclaration>';
    var tmp4 = Companion_getInstance_347().eh7_1;
    // Inline function 'jetbrains.biokb.lang.editorBuilders.btbReferenceTarget' call
    var referenceProvider = queryCommandEditors$lambda$lambda_29;
    var options = new CompletionOptions();
    var containerInit = queryCommandEditors$lambda$lambda_30;
    var textCellInit = queryCommandEditors$lambda$lambda_31;
    var tmp;
    if (null == null) {
      tmp = queryCommandEditors$lambda$lambda_32;
    } else {
      tmp = null;
    }
    var tmp10 = tmp;
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.references.referenceTarget' call
    var textCellInit_0 = queryCommandEditors$lambda$lambda_33(textCellInit);
    var targetClass = getKClass(LinkDeclaration_1);
    referenceTarget($this$editor, targetClass, tmp2, tmp4, referenceProvider, null, tmp10, options, containerInit, textCellInit_0);
    space_0($this$editor);
    label_0($this$editor, '=');
    space_0($this$editor);
    valueChild_0($this$editor);
    return Unit_instance;
  }
  function queryCommandEditors$lambda$lambda_29(linkDeclarationValueQuery) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    return linkDeclarationValueQuery.bft();
  }
  function queryCommandEditors$lambda$lambda_30(_this__u8e3s4) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    return Unit_instance;
  }
  function queryCommandEditors$lambda$lambda_31(_this__u8e3s4) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    return Unit_instance;
  }
  function queryCommandEditors$lambda$lambda_32(it) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    return true;
  }
  function queryCommandEditors$lambda$lambda_33($textCellInit) {
    return function ($this$referenceTarget) {
      $textCellInit($this$referenceTarget);
      enableEagerCompletion($this$referenceTarget);
      return Unit_instance;
    };
  }
  function queryCommandEditors$lambda_25($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function queryCommandEditors$lambda_26($this$editor) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    var tmp2 = '<propertyDeclaration>';
    var tmp4 = Companion_getInstance_348().uhk_1;
    // Inline function 'jetbrains.biokb.lang.editorBuilders.btbReferenceTarget' call
    var referenceProvider = queryCommandEditors$lambda$lambda_34;
    var options = new CompletionOptions();
    var containerInit = queryCommandEditors$lambda$lambda_35;
    var textCellInit = queryCommandEditors$lambda$lambda_36;
    var tmp;
    if (null == null) {
      tmp = queryCommandEditors$lambda$lambda_37;
    } else {
      tmp = null;
    }
    var tmp10 = tmp;
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.references.referenceTarget' call
    var textCellInit_0 = queryCommandEditors$lambda$lambda_38(textCellInit);
    var targetClass = getKClass(PropertyDeclaration_1);
    referenceTarget($this$editor, targetClass, tmp2, tmp4, referenceProvider, null, tmp10, options, containerInit, textCellInit_0);
    space_0($this$editor);
    label_0($this$editor, '=');
    space_0($this$editor);
    valueChild_0($this$editor);
    return Unit_instance;
  }
  function queryCommandEditors$lambda$lambda_34(propertyDeclarationValueQuery) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    return propertyDeclarationValueQuery.cfu();
  }
  function queryCommandEditors$lambda$lambda_35(_this__u8e3s4) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    return Unit_instance;
  }
  function queryCommandEditors$lambda$lambda_36(_this__u8e3s4) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    return Unit_instance;
  }
  function queryCommandEditors$lambda$lambda_37(it) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    return true;
  }
  function queryCommandEditors$lambda$lambda_38($textCellInit) {
    return function ($this$referenceTarget) {
      $textCellInit($this$referenceTarget);
      enableEagerCompletion($this$referenceTarget);
      return Unit_instance;
    };
  }
  function queryCommandEditors$lambda_27($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function queryCommandEditors$lambda_28($this$editor) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    indent_0($this$editor, VOID, VOID, queryCommandEditors$lambda$lambda_39);
    return Unit_instance;
  }
  function queryCommandEditors$lambda$lambda_39($this$indent) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    placeholderInCollection_0($this$indent, '<argument>', queryCommandEditors$lambda$lambda$lambda_8);
    return Unit_instance;
  }
  function queryCommandEditors$lambda$lambda$lambda_8($this$placeholderInCollection) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    getBindingValueQueryCompletion($this$placeholderInCollection);
    return Unit_instance;
  }
  function queryCommandEditors$lambda_29($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function queryCommandEditors$lambda_30($this$editor) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    indent_0($this$editor, VOID, VOID, queryCommandEditors$lambda$lambda_40);
    return Unit_instance;
  }
  function queryCommandEditors$lambda$lambda_40($this$indent) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    keyword_0($this$indent, 'query');
    space_0($this$indent);
    keyword_0($this$indent, 'parameters');
    space_0($this$indent);
    keyword_0($this$indent, 'blacklist');
    space_0($this$indent);
    keyword_0($this$indent, 'for');
    space_0($this$indent);
    keyword_0($this$indent, 'library:');
    space_0($this$indent);
    var tmp2 = '<library>';
    var tmp4 = Companion_getInstance_349().whp_1;
    // Inline function 'jetbrains.biokb.lang.editorBuilders.btbReferenceTarget' call
    var referenceProvider = queryCommandEditors$lambda$lambda$lambda_9;
    var options = new CompletionOptions();
    var containerInit = queryCommandEditors$lambda$lambda$lambda_10;
    var textCellInit = queryCommandEditors$lambda$lambda$lambda_11;
    var tmp;
    if (null == null) {
      tmp = queryCommandEditors$lambda$lambda$lambda_12;
    } else {
      tmp = null;
    }
    var tmp10 = tmp;
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.references.referenceTarget' call
    var textCellInit_0 = queryCommandEditors$lambda$lambda$lambda_13(textCellInit);
    var targetClass = getKClass(OntologyLibrary_1);
    referenceTarget($this$indent, targetClass, tmp2, tmp4, referenceProvider, null, tmp10, options, containerInit, textCellInit_0);
    indent_0($this$indent, true, VOID, queryCommandEditors$lambda$lambda$lambda_14);
    indent_0($this$indent, true, VOID, queryCommandEditors$lambda$lambda$lambda_15);
    return Unit_instance;
  }
  function queryCommandEditors$lambda$lambda$lambda_9(libraryElements) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    return libraryElements.ffq();
  }
  function queryCommandEditors$lambda$lambda$lambda_10(_this__u8e3s4) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    return Unit_instance;
  }
  function queryCommandEditors$lambda$lambda$lambda_11(_this__u8e3s4) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    return Unit_instance;
  }
  function queryCommandEditors$lambda$lambda$lambda_12(it) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    return true;
  }
  function queryCommandEditors$lambda$lambda$lambda_13($textCellInit) {
    return function ($this$referenceTarget) {
      $textCellInit($this$referenceTarget);
      enableEagerCompletion($this$referenceTarget);
      return Unit_instance;
    };
  }
  function queryCommandEditors$lambda$lambda$lambda_14($this$indent) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    newLine_0($this$indent);
    space_0($this$indent);
    newLine_0($this$indent);
    label_0($this$indent, 'A list of OntologyElements, recognized as common side-input or side-product of many reactions.', VOID, VOID, queryCommandEditors$lambda$lambda$lambda$lambda_0);
    newLine_0($this$indent);
    label_0($this$indent, 'This list will be used by QueryEngine for recognizing such reaction participants as unnecessary', VOID, VOID, queryCommandEditors$lambda$lambda$lambda$lambda_1);
    newLine_0($this$indent);
    label_0($this$indent, 'and hide corresponding connection chains from query execution output.', VOID, VOID, queryCommandEditors$lambda$lambda$lambda$lambda_2);
    return Unit_instance;
  }
  function queryCommandEditors$lambda$lambda$lambda$lambda_0($this$label) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    $this$label.qd0().b97().d2x(Companion_getInstance_210().r95_1);
    $this$label.qd0().e97().d2x(true);
    return Unit_instance;
  }
  function queryCommandEditors$lambda$lambda$lambda$lambda_1($this$label) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    $this$label.qd0().b97().d2x(Companion_getInstance_210().r95_1);
    $this$label.qd0().e97().d2x(true);
    return Unit_instance;
  }
  function queryCommandEditors$lambda$lambda$lambda$lambda_2($this$label) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    $this$label.qd0().b97().d2x(Companion_getInstance_210().r95_1);
    $this$label.qd0().e97().d2x(true);
    return Unit_instance;
  }
  function queryCommandEditors$lambda$lambda$lambda_15($this$indent) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    newLine_0($this$indent);
    space_0($this$indent);
    newLine_0($this$indent);
    var tmp = getKClass(OntologyElementReference_1);
    children_2($this$indent, tmp, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, queryCommandEditors$lambda$lambda$lambda$lambda_3);
    return Unit_instance;
  }
  function queryCommandEditors$lambda$lambda$lambda$lambda_3(blackList) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    return blackList.ifq();
  }
  function queryCommandEditors$lambda_31($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function contextQueryChild$lambda(wrapperContext) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    return createContextQuery(wrapperContext);
  }
  function contextQueryChild$lambda_0($this$child) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    contextQueryCompletion($this$child);
    return Unit_instance;
  }
  function contextQueryCompletion$lambda($this_contextQueryCompletion) {
    return function (libraryRef) {
      return createContextQuery($this_contextQueryCompletion.l6z(), libraryRef);
    };
  }
  function getBindingValueQueryCompletion$lambda($this$using) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    getBindingValueCompletion($this$using);
    return Unit_instance;
  }
  function getBindingValueQueryCompletion$lambda_0($this_getBindingValueQueryCompletion) {
    return function (bindingValue) {
      // Inline function 'kotlin.apply' call
      var this_0 = BindingValueMask($this_getBindingValueQueryCompletion.l6z());
      this_0.a1().f2x(bindingValue);
      return this_0;
    };
  }
  function getBindingValueQueryCompletion$lambda_1($this_getBindingValueQueryCompletion) {
    return function (refId) {
      // Inline function 'kotlin.apply' call
      var this_0 = OntologyLinkDeclarationValueQuery($this_getBindingValueQueryCompletion.l6z());
      this_0.bft().f2x(refId);
      return this_0;
    };
  }
  function getBindingValueQueryCompletion$lambda_2($this_getBindingValueQueryCompletion) {
    return function (refId) {
      // Inline function 'kotlin.apply' call
      var this_0 = PropertyDeclarationValueQuery($this_getBindingValueQueryCompletion.l6z());
      this_0.cfu().f2x(refId);
      return this_0;
    };
  }
  function valueChild$lambda_1(declarationValueQuery) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    return declarationValueQuery.a1();
  }
  var properties_initialized_QueryCommandEditors_kt_3zffyr;
  function _init_properties_QueryCommandEditors_kt__s6mqoh() {
    if (!properties_initialized_QueryCommandEditors_kt_3zffyr) {
      properties_initialized_QueryCommandEditors_kt_3zffyr = true;
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init = queryCommandEditors$lambda;
      var triggerDependencies = emptyList();
      var tmp = getKClass(QueryCommands_1);
      var tmp_0 = new EditorDefinition(tmp, null, null, false, true, triggerDependencies, queryCommandEditors$lambda_0(init));
      var tmp0 = '<commands>';
      var tmp2 = queryCommandEditors$lambda_1;
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
      var completionSupplier = queryCommandEditors$lambda_2;
      var separator_0 = get_defaultChildrenSeparator();
      var tmp0_0 = new ChildrenRoleDefaults(getKClass(Command_0), tmp0, tmp2, separator_0, completionSupplier, true);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_0 = queryCommandEditors$lambda_3;
      var triggerDependencies_0 = emptyList();
      var tmp_1 = getKClass(FindConnectionCommand_1);
      var tmp_2 = new EditorDefinition(tmp_1, null, null, false, true, triggerDependencies_0, queryCommandEditors$lambda_4(init_0));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_1 = queryCommandEditors$lambda_5;
      var triggerDependencies_1 = emptyList();
      var tmp_3 = getKClass(FindNewConnectionCommand_1);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.hierarchyEditor' call
      var editorDefinitions = [tmp_2, new EditorDefinition(tmp_3, null, null, false, true, triggerDependencies_1, queryCommandEditors$lambda_6(init_1))];
      var tmp_4 = new HierarchyEditorDefinition(getKClass(Command_0), tmp0_0, toList(editorDefinitions));
      var tmp_5 = queryCommandEditors$lambda_7;
      var tmp0_1 = childRoleDefaults(VOID, tmp_5, queryCommandEditors$lambda_8);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_2 = queryCommandEditors$lambda_9;
      var triggerDependencies_2 = emptyList();
      var tmp_6 = getKClass(VariablePattern_1);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.hierarchyEditor' call
      var editorDefinitions_0 = [new EditorDefinition(tmp_6, null, null, true, true, triggerDependencies_2, queryCommandEditors$lambda_10(init_2))];
      var tmp_7 = new HierarchyEditorDefinition(getKClass(Pattern), tmp0_1, toList(editorDefinitions_0));
      var tmp0_separator = separator(',');
      var tmp0_2 = '<context>';
      var tmp2_0 = queryCommandEditors$lambda_11;
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
      var completionSupplier_0 = queryCommandEditors$lambda_12;
      var tmp0_3 = new ChildrenRoleDefaults(getKClass(ContextQuery_1), tmp0_2, tmp2_0, tmp0_separator, completionSupplier_0, true);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_3 = queryCommandEditors$lambda_13;
      var triggerDependencies_3 = emptyList();
      var tmp_8 = getKClass(ContextQuery_1);
      var tmp_9 = new EditorDefinition(tmp_8, tmp0_3, null, false, true, triggerDependencies_3, queryCommandEditors$lambda_14(init_3));
      var tmp0_4 = childRoleDefaults(VOID, queryCommandEditors$lambda_15);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_4 = queryCommandEditors$lambda_16;
      var triggerDependencies_4 = emptyList();
      var tmp_10 = getKClass(LibraryProcessSpecificationQuery_1);
      var tmp_11 = new EditorDefinition(tmp_10, tmp0_4, null, true, true, triggerDependencies_4, queryCommandEditors$lambda_17(init_4));
      var tmp0_5 = separator(',');
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
      var completionSupplier_1 = queryCommandEditors$lambda_18;
      var tmp0_6 = new ChildrenRoleDefaults(getKClass(BindingValuePlaceholderQuery_1), '<empty>', null, tmp0_5, completionSupplier_1, true);
      var tmp0_7 = childRoleDefaults(VOID, queryCommandEditors$lambda_19);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_5 = queryCommandEditors$lambda_20;
      var triggerDependencies_5 = emptyList();
      var tmp_12 = getKClass(OrValueQuery_1);
      var tmp_13 = new EditorDefinition(tmp_12, null, null, false, true, triggerDependencies_5, queryCommandEditors$lambda_21(init_5));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_6 = queryCommandEditors$lambda_22;
      var triggerDependencies_6 = emptyList();
      var tmp_14 = getKClass(BindingValueMask_1);
      var tmp_15 = new EditorDefinition(tmp_14, null, null, false, true, triggerDependencies_6, queryCommandEditors$lambda_23(init_6));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_7 = queryCommandEditors$lambda_24;
      var triggerDependencies_7 = emptyList();
      var tmp_16 = getKClass(OntologyLinkDeclarationValueQuery_1);
      var tmp_17 = new EditorDefinition(tmp_16, null, null, true, true, triggerDependencies_7, queryCommandEditors$lambda_25(init_7));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_8 = queryCommandEditors$lambda_26;
      var triggerDependencies_8 = emptyList();
      var tmp_18 = getKClass(PropertyDeclarationValueQuery_1);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.hierarchyEditor' call
      var editorDefinitions_1 = [tmp_13, tmp_15, tmp_17, new EditorDefinition(tmp_18, null, null, true, true, triggerDependencies_8, queryCommandEditors$lambda_27(init_8))];
      var tmp_19 = new HierarchyEditorDefinition(getKClass(AbstractBindingValueQuery), tmp0_7, toList(editorDefinitions_1));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_9 = queryCommandEditors$lambda_28;
      var triggerDependencies_9 = emptyList();
      var tmp_20 = getKClass(BindingValuePlaceholderQuery_1);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.hierarchyEditor' call
      var editorDefinitions_2 = [tmp_19, new EditorDefinition(tmp_20, null, null, false, true, triggerDependencies_9, queryCommandEditors$lambda_29(init_9))];
      var tmp_21 = new HierarchyEditorDefinition(getKClass(BindingValuePlaceholderQuery_1), tmp0_6, toList(editorDefinitions_2));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_10 = queryCommandEditors$lambda_30;
      var triggerDependencies_10 = emptyList();
      var tmp_22 = getKClass(QueryParametersBlackList);
      var tmp$ret$18 = new EditorDefinition(tmp_22, null, null, false, true, triggerDependencies_10, queryCommandEditors$lambda_31(init_10));
      queryCommandEditors = listOf_0([tmp_0, tmp_4, tmp_7, tmp_9, tmp_11, tmp_21, tmp$ret$18]);
    }
  }
  function get_relationLibraryEditors() {
    _init_properties_RelationLibraryEditors_kt__41a73b();
    return relationLibraryEditors;
  }
  var relationLibraryEditors;
  function instanceRelationValueCompletion(_this__u8e3s4) {
    _init_properties_RelationLibraryEditors_kt__41a73b();
    var tmp = _this__u8e3s4.jcg(Companion_getInstance_350().sgk_1);
    _this__u8e3s4.gck(tmp, instanceRelationValueCompletion$lambda(_this__u8e3s4));
  }
  function relationLibraryEditors$lambda($this$editor) {
    _init_properties_RelationLibraryEditors_kt__41a73b();
    label_0($this$editor, 'Process Relations:', VOID, VOID, relationLibraryEditors$lambda$lambda);
    indent_0($this$editor, VOID, VOID, relationLibraryEditors$lambda$lambda_0);
    newLine_0($this$editor);
    space_0($this$editor);
    newLine_0($this$editor);
    label_0($this$editor, 'Instance relations:', VOID, VOID, relationLibraryEditors$lambda$lambda_1);
    indent_0($this$editor, VOID, VOID, relationLibraryEditors$lambda$lambda_2);
    return Unit_instance;
  }
  function relationLibraryEditors$lambda$lambda($this$label) {
    _init_properties_RelationLibraryEditors_kt__41a73b();
    $this$label.qd0().d97().f2x(true);
    return Unit_instance;
  }
  function relationLibraryEditors$lambda$lambda_0($this$indent) {
    _init_properties_RelationLibraryEditors_kt__41a73b();
    newLine_0($this$indent);
    var tmp = getKClass(ProcessRelationDeclaration_1);
    var tmp_0 = Layout_VERTICAL_getInstance();
    children_2($this$indent, tmp, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp_0, relationLibraryEditors$lambda$lambda$lambda);
    return Unit_instance;
  }
  function relationLibraryEditors$lambda$lambda$lambda(relationContainer) {
    _init_properties_RelationLibraryEditors_kt__41a73b();
    return relationContainer.jfu();
  }
  function relationLibraryEditors$lambda$lambda_1($this$label) {
    _init_properties_RelationLibraryEditors_kt__41a73b();
    $this$label.qd0().d97().f2x(true);
    return Unit_instance;
  }
  function relationLibraryEditors$lambda$lambda_2($this$indent) {
    _init_properties_RelationLibraryEditors_kt__41a73b();
    newLine_0($this$indent);
    var tmp = getKClass(InstanceRelationDeclaration);
    var tmp_0 = Layout_VERTICAL_getInstance();
    children_2($this$indent, tmp, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp_0, relationLibraryEditors$lambda$lambda$lambda_0);
    return Unit_instance;
  }
  function relationLibraryEditors$lambda$lambda$lambda_0(relationContainer) {
    _init_properties_RelationLibraryEditors_kt__41a73b();
    return relationContainer.kfu();
  }
  function relationLibraryEditors$lambda_0($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function relationLibraryEditors$lambda_1($this$editor) {
    _init_properties_RelationLibraryEditors_kt__41a73b();
    keyword_0($this$editor, 'relation:');
    space_0($this$editor);
    textProperty_0($this$editor, '<name>', relationLibraryEditors$lambda$lambda_3);
    space_0($this$editor);
    textProperty_0($this$editor, '<symbol>', relationLibraryEditors$lambda$lambda_4);
    indent_0($this$editor, true, VOID, relationLibraryEditors$lambda$lambda_5);
    newLine_0($this$editor);
    return Unit_instance;
  }
  function relationLibraryEditors$lambda$lambda_3(relationDeclaration) {
    _init_properties_RelationLibraryEditors_kt__41a73b();
    return relationDeclaration.y2();
  }
  function relationLibraryEditors$lambda$lambda_4(relationDeclaration) {
    _init_properties_RelationLibraryEditors_kt__41a73b();
    return relationDeclaration.zft();
  }
  function relationLibraryEditors$lambda$lambda_5($this$indent) {
    _init_properties_RelationLibraryEditors_kt__41a73b();
    newLine_0($this$indent);
    keyword_0($this$indent, 'direction:');
    space_0($this$indent);
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.enumProperty' call
    var placeholder = '<direction>';
    editableText_0($this$indent, VOID, placeholder, VOID, VOID, relationLibraryEditors$lambda$lambda$lambda_1);
    newLine_0($this$indent);
    keyword_0($this$indent, 'effect:');
    space_0($this$indent);
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.enumProperty' call
    var placeholder_0 = '<effect>';
    editableText_0($this$indent, VOID, placeholder_0, VOID, VOID, relationLibraryEditors$lambda$lambda$lambda_2);
    newLine_0($this$indent);
    return Unit_instance;
  }
  function relationLibraryEditors$lambda$lambda$lambda_1($this$editableText) {
    _init_properties_RelationLibraryEditors_kt__41a73b();
    switch (get_internalConfig($this$editableText).nd0().uct_1.x2_1) {
      case 0:
        // Inline function 'jetbrains.ocelot.langDef.editorBuilder.enumSyncTwoWay' call

        var targetPropFactory = relationLibraryEditors$lambda$lambda$lambda$lambda;
        // Inline function 'jetbrains.ocelot.langDef.editorBuilder.textCellSyncTwoWay' call

        var sourceProp = $this$editableText.m6d().afu();
        var targetProp = targetPropFactory($this$editableText.qd0());
        $this$editableText.l8b(syncTwoWay(sourceProp.m5y(), targetProp));
        break;
      case 1:
        // Inline function 'jetbrains.ocelot.langDef.editorBuilder.enumSyncTwoWay' call

        var targetPropFactory_0 = relationLibraryEditors$lambda$lambda$lambda$lambda_0;
        // Inline function 'jetbrains.ocelot.langDef.editorBuilder.textCellSyncTwoWay' call

        var sourceProp_0 = $this$editableText.m6d().afu();
        var targetProp_0 = targetPropFactory_0($this$editableText.qd0());
        $this$editableText.l8b(syncTwoWay(sourceProp_0.m5y(), targetProp_0));
        break;
      default:
        var tmp = $this$editableText.qd0().o8w();
        var tmp1_safe_receiver = $this$editableText.m6d().afu().m5y().w2w();
        var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.toString();
        tmp.f2x(tmp2_elvis_lhs == null ? '' : tmp2_elvis_lhs);
        break;
    }
    return Unit_instance;
  }
  function relationLibraryEditors$lambda$lambda$lambda$lambda(textCell) {
    _init_properties_RelationLibraryEditors_kt__41a73b();
    // Inline function 'jetbrains.ocelot.base.enums.EnumInfoFactory.createEnumInfo' call
    // Inline function 'kotlin.enumValues' call
    var tmp$ret$0 = values_16();
    var enumInfo = new EnumInfoImpl(tmp$ret$0);
    return ValueEditors_instance.uag(textCell, enumInfo);
  }
  function relationLibraryEditors$lambda$lambda$lambda$lambda_0(textCell) {
    _init_properties_RelationLibraryEditors_kt__41a73b();
    // Inline function 'jetbrains.ocelot.base.enums.EnumInfoFactory.createEnumInfo' call
    // Inline function 'kotlin.enumValues' call
    var tmp$ret$0 = values_16();
    var enumInfo = new EnumInfoImpl(tmp$ret$0);
    return ValueEditors_instance.uag(textCell, enumInfo);
  }
  function relationLibraryEditors$lambda$lambda$lambda_2($this$editableText) {
    _init_properties_RelationLibraryEditors_kt__41a73b();
    switch (get_internalConfig($this$editableText).nd0().uct_1.x2_1) {
      case 0:
        // Inline function 'jetbrains.ocelot.langDef.editorBuilder.enumSyncTwoWay' call

        var targetPropFactory = relationLibraryEditors$lambda$lambda$lambda$lambda_1;
        // Inline function 'jetbrains.ocelot.langDef.editorBuilder.textCellSyncTwoWay' call

        var sourceProp = $this$editableText.m6d().bfu();
        var targetProp = targetPropFactory($this$editableText.qd0());
        $this$editableText.l8b(syncTwoWay(sourceProp.m5y(), targetProp));
        break;
      case 1:
        // Inline function 'jetbrains.ocelot.langDef.editorBuilder.enumSyncTwoWay' call

        var targetPropFactory_0 = relationLibraryEditors$lambda$lambda$lambda$lambda_2;
        // Inline function 'jetbrains.ocelot.langDef.editorBuilder.textCellSyncTwoWay' call

        var sourceProp_0 = $this$editableText.m6d().bfu();
        var targetProp_0 = targetPropFactory_0($this$editableText.qd0());
        $this$editableText.l8b(syncTwoWay(sourceProp_0.m5y(), targetProp_0));
        break;
      default:
        var tmp = $this$editableText.qd0().o8w();
        var tmp1_safe_receiver = $this$editableText.m6d().bfu().m5y().w2w();
        var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.toString();
        tmp.f2x(tmp2_elvis_lhs == null ? '' : tmp2_elvis_lhs);
        break;
    }
    return Unit_instance;
  }
  function relationLibraryEditors$lambda$lambda$lambda$lambda_1(textCell) {
    _init_properties_RelationLibraryEditors_kt__41a73b();
    // Inline function 'jetbrains.ocelot.base.enums.EnumInfoFactory.createEnumInfo' call
    // Inline function 'kotlin.enumValues' call
    var tmp$ret$0 = values_17();
    var enumInfo = new EnumInfoImpl(tmp$ret$0);
    return ValueEditors_instance.uag(textCell, enumInfo);
  }
  function relationLibraryEditors$lambda$lambda$lambda$lambda_2(textCell) {
    _init_properties_RelationLibraryEditors_kt__41a73b();
    // Inline function 'jetbrains.ocelot.base.enums.EnumInfoFactory.createEnumInfo' call
    // Inline function 'kotlin.enumValues' call
    var tmp$ret$0 = values_17();
    var enumInfo = new EnumInfoImpl(tmp$ret$0);
    return ValueEditors_instance.uag(textCell, enumInfo);
  }
  function relationLibraryEditors$lambda_2($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function relationLibraryEditors$lambda_3($this$editor) {
    _init_properties_RelationLibraryEditors_kt__41a73b();
    indent_0($this$editor, VOID, VOID, relationLibraryEditors$lambda$lambda_6);
    return Unit_instance;
  }
  function relationLibraryEditors$lambda$lambda_6($this$indent) {
    _init_properties_RelationLibraryEditors_kt__41a73b();
    var tmp = getKClass(Type);
    child_1($this$indent, tmp, relationLibraryEditors$lambda$lambda$lambda_3);
    space_0($this$indent);
    var tmp_0 = relationLibraryEditors$lambda$lambda$lambda_4;
    textProperty_0($this$indent, '<symbol>', tmp_0, relationLibraryEditors$lambda$lambda$lambda_5);
    space_0($this$indent);
    var tmp_1 = getKClass(Type);
    child_1($this$indent, tmp_1, relationLibraryEditors$lambda$lambda$lambda_6);
    ensureLastCaretPosition($this$indent);
    return Unit_instance;
  }
  function relationLibraryEditors$lambda$lambda$lambda_3(it) {
    _init_properties_RelationLibraryEditors_kt__41a73b();
    return it.ufr();
  }
  function relationLibraryEditors$lambda$lambda$lambda_4(propertyDeclaration) {
    _init_properties_RelationLibraryEditors_kt__41a73b();
    return propertyDeclaration.y2();
  }
  function relationLibraryEditors$lambda$lambda$lambda_5($this$textProperty) {
    _init_properties_RelationLibraryEditors_kt__41a73b();
    $this$textProperty.qd0().d97().f2x(true);
    return Unit_instance;
  }
  function relationLibraryEditors$lambda$lambda$lambda_6(it) {
    _init_properties_RelationLibraryEditors_kt__41a73b();
    return it.hd();
  }
  function relationLibraryEditors$lambda_4($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function relationLibraryEditors$lambda_5($this$childrenRoleDefaults) {
    _init_properties_RelationLibraryEditors_kt__41a73b();
    instanceRelationValueCompletion($this$childrenRoleDefaults);
    return Unit_instance;
  }
  function relationLibraryEditors$lambda_6($this$editor) {
    _init_properties_RelationLibraryEditors_kt__41a73b();
    indent_0($this$editor, VOID, VOID, relationLibraryEditors$lambda$lambda_7);
    return Unit_instance;
  }
  function relationLibraryEditors$lambda$lambda_7($this$indent) {
    _init_properties_RelationLibraryEditors_kt__41a73b();
    var tmp2 = 'relation';
    var tmp4 = Companion_getInstance_350().sgk_1;
    var tmp6 = relationLibraryEditors$lambda$lambda$lambda_7;
    // Inline function 'jetbrains.biokb.lang.editorBuilders.btbReferenceTarget' call
    var textCellInit = relationLibraryEditors$lambda$lambda$lambda_8;
    var options = new CompletionOptions();
    var containerInit = relationLibraryEditors$lambda$lambda$lambda_9;
    var tmp;
    if (null == null) {
      tmp = relationLibraryEditors$lambda$lambda$lambda_10;
    } else {
      tmp = null;
    }
    var tmp10 = tmp;
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.references.referenceTarget' call
    var textCellInit_0 = relationLibraryEditors$lambda$lambda$lambda_11(textCellInit);
    var targetClass = getKClass(InstanceRelationDeclaration);
    referenceTarget($this$indent, targetClass, tmp2, tmp4, tmp6, null, tmp10, options, containerInit, textCellInit_0);
    space_0($this$indent);
    var tmp_0 = getKClass(AbstractValue);
    var tmp_1 = KProperty1;
    var tmp_2 = getPropertyCallableRef('value', 1, tmp_1, InstanceRelationValue$_get_value_$ref_n9b6s5_1(), null);
    var tmp_3 = KProperty1;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_0 = getPropertyCallableRef('value', 1, tmp_3, InstanceRelationValue$_get_value_$ref_n9b6s5_2(), null);
    var tmp_4 = new SingleChildLink(getKClass(InstanceRelationValue), this_0);
    child_1($this$indent, tmp_0, tmp_2, VOID, VOID, VOID, VOID, VOID, VOID, tmp_4, relationLibraryEditors$lambda$lambda$lambda_12);
    return Unit_instance;
  }
  function relationLibraryEditors$lambda$lambda$lambda_7(it) {
    _init_properties_RelationLibraryEditors_kt__41a73b();
    return it.xfq();
  }
  function relationLibraryEditors$lambda$lambda$lambda_8($this$btbReferenceTarget) {
    _init_properties_RelationLibraryEditors_kt__41a73b();
    $this$btbReferenceTarget.qd0().d97().f2x(true);
    return Unit_instance;
  }
  function relationLibraryEditors$lambda$lambda$lambda_9(_this__u8e3s4) {
    _init_properties_RelationLibraryEditors_kt__41a73b();
    return Unit_instance;
  }
  function relationLibraryEditors$lambda$lambda$lambda_10(it) {
    _init_properties_RelationLibraryEditors_kt__41a73b();
    return true;
  }
  function relationLibraryEditors$lambda$lambda$lambda_11($textCellInit) {
    return function ($this$referenceTarget) {
      $textCellInit($this$referenceTarget);
      enableEagerCompletion($this$referenceTarget);
      return Unit_instance;
    };
  }
  function InstanceRelationValue$_get_value_$ref_n9b6s5_1() {
    return function (p0) {
      return p0.a1();
    };
  }
  function InstanceRelationValue$_get_value_$ref_n9b6s5_2() {
    return function (p0) {
      return p0.a1();
    };
  }
  function relationLibraryEditors$lambda$lambda$lambda_12($this$child) {
    _init_properties_RelationLibraryEditors_kt__41a73b();
    getAbstractValueCompletion($this$child);
    return Unit_instance;
  }
  function relationLibraryEditors$lambda_7($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function relationLibraryEditors$lambda_8($this$editor) {
    _init_properties_RelationLibraryEditors_kt__41a73b();
    indent_0($this$editor, VOID, VOID, relationLibraryEditors$lambda$lambda_8);
    return Unit_instance;
  }
  function relationLibraryEditors$lambda$lambda_8($this$indent) {
    _init_properties_RelationLibraryEditors_kt__41a73b();
    // Inline function 'kotlin.apply' call
    placeholderInCollection_0($this$indent, '<relation>', relationLibraryEditors$lambda$lambda$lambda_13).w92(get_spaceDoesntCloseCompletion());
    return Unit_instance;
  }
  function relationLibraryEditors$lambda$lambda$lambda_13($this$placeholderInCollection) {
    _init_properties_RelationLibraryEditors_kt__41a73b();
    instanceRelationValueCompletion($this$placeholderInCollection);
    return Unit_instance;
  }
  function relationLibraryEditors$lambda_9($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function instanceRelationValueCompletion$lambda($this_instanceRelationValueCompletion) {
    return function (refValue) {
      return InstanceRelationValue_0($this_instanceRelationValueCompletion.l6z(), refValue);
    };
  }
  var properties_initialized_RelationLibraryEditors_kt_b4pdhz;
  function _init_properties_RelationLibraryEditors_kt__41a73b() {
    if (!properties_initialized_RelationLibraryEditors_kt_b4pdhz) {
      properties_initialized_RelationLibraryEditors_kt_b4pdhz = true;
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init = relationLibraryEditors$lambda;
      var triggerDependencies = emptyList();
      var tmp = getKClass(RelationContainer_1);
      var tmp_0 = new EditorDefinition(tmp, null, null, false, true, triggerDependencies, relationLibraryEditors$lambda_0(init));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
      var placeholderText = '<relation declarations>';
      var separator = get_defaultChildrenSeparator();
      var tmp0 = new ChildrenRoleDefaults(getKClass(ProcessRelationDeclaration_1), placeholderText, null, separator, null, true);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_0 = relationLibraryEditors$lambda_1;
      var triggerDependencies_0 = emptyList();
      var tmp_1 = getKClass(ProcessRelationDeclaration_1);
      var tmp_2 = new EditorDefinition(tmp_1, tmp0, null, false, true, triggerDependencies_0, relationLibraryEditors$lambda_2(init_0));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
      var placeholderText_0 = '<relations declarations>';
      var separator_0 = get_defaultChildrenSeparator();
      var tmp0_0 = new ChildrenRoleDefaults(getKClass(InstanceRelationDeclaration), placeholderText_0, null, separator_0, null, true);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_1 = relationLibraryEditors$lambda_3;
      var triggerDependencies_1 = emptyList();
      var tmp_3 = getKClass(InstanceRelationDeclaration);
      var tmp_4 = new EditorDefinition(tmp_3, tmp0_0, null, false, true, triggerDependencies_1, relationLibraryEditors$lambda_4(init_1));
      var tmp0_1 = '<relations>';
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
      var completionSupplier = relationLibraryEditors$lambda_5;
      var separator_1 = get_defaultChildrenSeparator();
      var tmp0_2 = new ChildrenRoleDefaults(getKClass(InstanceRelationValuePlaceholder), tmp0_1, null, separator_1, completionSupplier, true);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_2 = relationLibraryEditors$lambda_6;
      var triggerDependencies_2 = emptyList();
      var tmp_5 = getKClass(InstanceRelationValue);
      var tmp_6 = new EditorDefinition(tmp_5, null, null, true, true, triggerDependencies_2, relationLibraryEditors$lambda_7(init_2));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_3 = relationLibraryEditors$lambda_8;
      var triggerDependencies_3 = emptyList();
      var tmp_7 = getKClass(InstanceRelationValuePlaceholder);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.hierarchyEditor' call
      var editorDefinitions = [tmp_6, new EditorDefinition(tmp_7, null, null, false, true, triggerDependencies_3, relationLibraryEditors$lambda_9(init_3))];
      var tmp$ret$8 = new HierarchyEditorDefinition(getKClass(InstanceRelationValuePlaceholder), tmp0_2, toList(editorDefinitions));
      relationLibraryEditors = listOf_0([tmp_0, tmp_2, tmp_4, tmp$ret$8]);
    }
  }
  function showCustomEditor(_this__u8e3s4, bindingDeclaration, parameters, $completion) {
    var tmp = new $showCustomEditorCOROUTINE$(_this__u8e3s4, bindingDeclaration, parameters, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  }
  function showCustomCell(_this__u8e3s4, customCell, parameters, bindingDeclaration, $completion) {
    var tmp = new $showCustomCellCOROUTINE$(_this__u8e3s4, customCell, parameters, bindingDeclaration, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  }
  function executeCommand_0(_this__u8e3s4, runnable) {
    return ensureNotNull(_this__u8e3s4.qd0().s8x()).d9m(runnable);
  }
  function showCustomCell$lambda($property) {
    return function (wrapperContext) {
      // Inline function 'kotlin.apply' call
      var this_0 = ProcessPropertyValue(wrapperContext);
      this_0.q6q().b6p($property);
      return this_0;
    };
  }
  function showCustomCell$lambda_0($parameters, $bindingValueFactory, $this) {
    return function () {
      $parameters.j($bindingValueFactory(get_internalConfig($this).l6z()));
      return Unit_instance;
    };
  }
  function showCustomCell$lambda_1($propertyValue) {
    return function (it) {
      return $propertyValue.a1();
    };
  }
  function ProcessPropertyValue$_get_value_$ref_tp5tnc_4() {
    return function (p0) {
      return p0.a1();
    };
  }
  function showCustomCell$lambda$lambda($this$inContextOf) {
    getAbstractValueCompletion($this$inContextOf);
    return Unit_instance;
  }
  function showCustomCell$lambda_2($propertyValue) {
    return function ($this$child) {
      var tmp2 = $propertyValue;
      var tmp = KProperty1;
      var tmp4 = getPropertyCallableRef('value', 1, tmp, ProcessPropertyValue$_get_value_$ref_tp5tnc_4(), null);
      // Inline function 'jetbrains.ocelot.langDef.completion.NodeCompletionBuilder.inContextOf' call
      var supplier = showCustomCell$lambda$lambda;
      // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
      var tmp$ret$0 = new SingleChildLink(getKClass(ProcessPropertyValue_1), tmp4);
      $this$child.kck(tmp2, tmp$ret$0, supplier);
      return Unit_instance;
    };
  }
  function showCustomCell$lambda_3($property) {
    return function (wrapperContext) {
      // Inline function 'kotlin.apply' call
      var this_0 = PropertyValue(wrapperContext);
      this_0.q6q().b6p($property);
      return this_0;
    };
  }
  function showCustomCell$lambda_4($parameters, $bindingValueFactory, $this) {
    return function () {
      $parameters.j($bindingValueFactory(get_internalConfig($this).l6z()));
      return Unit_instance;
    };
  }
  function showCustomCell$lambda_5($bindingValue) {
    return function (it) {
      return $bindingValue.a1();
    };
  }
  function AbstractBindingValue$_get_value_$ref_r1k0yv_1() {
    return function (p0) {
      return p0.a1();
    };
  }
  function showCustomCell$lambda$lambda_0($this$inContextOf) {
    getAbstractValueCompletion($this$inContextOf);
    return Unit_instance;
  }
  function showCustomCell$lambda_6($bindingValue) {
    return function ($this$child) {
      var tmp2 = $bindingValue;
      var tmp = KProperty1;
      var tmp4 = getPropertyCallableRef('value', 1, tmp, AbstractBindingValue$_get_value_$ref_r1k0yv_1(), null);
      // Inline function 'jetbrains.ocelot.langDef.completion.NodeCompletionBuilder.inContextOf' call
      var supplier = showCustomCell$lambda$lambda_0;
      // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
      var tmp$ret$0 = new SingleChildLink(getKClass(AbstractBindingValue), tmp4);
      $this$child.kck(tmp2, tmp$ret$0, supplier);
      return Unit_instance;
    };
  }
  function showCustomCell$lambda_7($link) {
    return function (wrapperContext) {
      // Inline function 'kotlin.apply' call
      var this_0 = OntologyLinkValue(wrapperContext);
      this_0.cft().b6p($link);
      return this_0;
    };
  }
  function showCustomCell$lambda_8($parameters, $bindingValueFactory, $this) {
    return function () {
      $parameters.j($bindingValueFactory(get_internalConfig($this).l6z()));
      return Unit_instance;
    };
  }
  function showCustomCell$lambda_9($bindingValue) {
    return function (it) {
      return $bindingValue.a1();
    };
  }
  function AbstractBindingValue$_get_value_$ref_r1k0yv_2() {
    return function (p0) {
      return p0.a1();
    };
  }
  function showCustomCell$lambda$lambda_1($this$inContextOf) {
    getAbstractValueCompletion($this$inContextOf);
    return Unit_instance;
  }
  function showCustomCell$lambda_10($bindingValue) {
    return function ($this$child) {
      var tmp2 = $bindingValue;
      var tmp = KProperty1;
      var tmp4 = getPropertyCallableRef('value', 1, tmp, AbstractBindingValue$_get_value_$ref_r1k0yv_2(), null);
      // Inline function 'jetbrains.ocelot.langDef.completion.NodeCompletionBuilder.inContextOf' call
      var supplier = showCustomCell$lambda$lambda_1;
      // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
      var tmp$ret$0 = new SingleChildLink(getKClass(AbstractBindingValue), tmp4);
      $this$child.kck(tmp2, tmp$ret$0, supplier);
      return Unit_instance;
    };
  }
  function showCustomCell$lambda_11($bindingDeclaration) {
    return function (it) {
      return $bindingDeclaration.gfr();
    };
  }
  function showCustomCell$lambda_12($bindingDeclaration) {
    return function (it) {
      return $bindingDeclaration.dfr();
    };
  }
  function showCustomCell$lambda_13($parameters) {
    return function (it) {
      return $parameters;
    };
  }
  function $showCustomEditorCOROUTINE$(_this__u8e3s4, bindingDeclaration, parameters, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.uuf_1 = _this__u8e3s4;
    this.vuf_1 = bindingDeclaration;
    this.wuf_1 = parameters;
  }
  protoOf($showCustomEditorCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 4;
            if (!this.uuf_1.l60(this.vuf_1.tfp())) {
              return false;
            }

            var tmp0_elvis_lhs = this.uuf_1.l60(this.vuf_1.sfp());
            var tmp_0;
            if (tmp0_elvis_lhs == null) {
              return false;
            } else {
              tmp_0 = tmp0_elvis_lhs;
            }

            var customEditor = tmp_0;
            this.xuf_1 = withIndex_0(this.uuf_1.l60(customEditor.ofq())).m();
            this.f9_1 = 1;
            continue $sm;
          case 1:
            if (!this.xuf_1.n()) {
              this.f9_1 = 3;
              continue $sm;
            }

            var _destruct__k2r9zo = this.xuf_1.o();
            var index = _destruct__k2r9zo.fg();
            var customCell = _destruct__k2r9zo.gg();
            if (index > 0) {
              space_0(this.uuf_1);
            }

            this.f9_1 = 2;
            suspendResult = showCustomCell(this.uuf_1, customCell, this.wuf_1, this.vuf_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.f9_1 = 1;
            continue $sm;
          case 3:
            return true;
          case 4:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 4) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function $showCustomCellCOROUTINE$(_this__u8e3s4, customCell, parameters, bindingDeclaration, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.gug_1 = _this__u8e3s4;
    this.hug_1 = customCell;
    this.iug_1 = parameters;
    this.jug_1 = bindingDeclaration;
  }
  protoOf($showCustomCellCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            var tmp0_subject = this.hug_1;
            if (isInterface(tmp0_subject, ConstantCustomCell_1)) {
              var tmp_0 = this;
              var text = this.gug_1.l60(this.hug_1.o8w());
              var this_0 = label_0(this.gug_1, text);
              this_0.w92(constantReferenceTrait(this.jug_1));
              constantCustomCellStyle(this_0);
              tmp_0.kug_1 = this_0;
              this.f9_1 = 3;
              continue $sm;
            } else {
              if (isInterface(tmp0_subject, ProcessPropertyCustomCell_1)) {
                var tmp_1 = this;
                var property = this.gug_1.l60(this.hug_1.q6q().z6o());
                var propertyValueFactory = showCustomCell$lambda(property);
                var tmp0 = this.gug_1;
                var tmp2 = this.iug_1;
                l$ret$3: do {
                  var tmp0_0 = tmp0.l60(tmp2);
                  var destination = ArrayList_init_$Create$();
                  var _iterator__ex2g4s = tmp0_0.m();
                  while (_iterator__ex2g4s.n()) {
                    var element = _iterator__ex2g4s.o();
                    if (!(element == null) ? isInterface(element, ProcessPropertyValue_1) : false) {
                      destination.j(element);
                    }
                  }
                  var valueParameters = destination;
                  var tmp$ret$0;
                  l$ret$1: do {
                    var _iterator__ex2g4s_0 = valueParameters.m();
                    while (_iterator__ex2g4s_0.n()) {
                      var element_0 = _iterator__ex2g4s_0.o();
                      if (equals(property, this.gug_1.l60(element_0.q6q().z6o()))) {
                        tmp$ret$0 = element_0;
                        break l$ret$1;
                      }
                    }
                    tmp$ret$0 = null;
                  }
                   while (false);
                  var propertyValue = tmp$ret$0;
                  if (propertyValue == null) {
                    executeCommand_0(tmp0, showCustomCell$lambda_0(tmp2, propertyValueFactory, tmp0));
                    break l$ret$3;
                  }
                  var tmp_2 = getKClass(AbstractValue);
                  var tmp_3 = showCustomCell$lambda_1(propertyValue);
                  child_1(tmp0, tmp_2, tmp_3, VOID, VOID, VOID, VOID, VOID, VOID, VOID, showCustomCell$lambda_2(propertyValue));
                }
                 while (false);
                tmp_1.kug_1 = Unit_instance;
                this.f9_1 = 3;
                continue $sm;
              } else {
                if (isInterface(tmp0_subject, PropertyCustomCell_1)) {
                  var tmp_4 = this;
                  var property_0 = this.gug_1.l60(this.hug_1.q6q().z6o());
                  var bindingValueFactory = showCustomCell$lambda_3(property_0);
                  var tmp0_1 = this.gug_1;
                  var tmp2_0 = this.iug_1;
                  l$ret$7: do {
                    var tmp0_2 = tmp0_1.l60(tmp2_0);
                    var destination_0 = ArrayList_init_$Create$();
                    var _iterator__ex2g4s_1 = tmp0_2.m();
                    while (_iterator__ex2g4s_1.n()) {
                      var element_1 = _iterator__ex2g4s_1.o();
                      if (!(element_1 == null) ? isInterface(element_1, PropertyValue_1) : false) {
                        destination_0.j(element_1);
                      }
                    }
                    var valueParameters_0 = destination_0;
                    var tmp$ret$4;
                    l$ret$5: do {
                      var _iterator__ex2g4s_2 = valueParameters_0.m();
                      while (_iterator__ex2g4s_2.n()) {
                        var element_2 = _iterator__ex2g4s_2.o();
                        if (equals(property_0, this.gug_1.l60(element_2.q6q().z6o()))) {
                          tmp$ret$4 = element_2;
                          break l$ret$5;
                        }
                      }
                      tmp$ret$4 = null;
                    }
                     while (false);
                    var bindingValue = tmp$ret$4;
                    if (bindingValue == null) {
                      executeCommand_0(tmp0_1, showCustomCell$lambda_4(tmp2_0, bindingValueFactory, tmp0_1));
                      break l$ret$7;
                    }
                    var tmp_5 = getKClass(AbstractValue);
                    var tmp_6 = showCustomCell$lambda_5(bindingValue);
                    child_1(tmp0_1, tmp_5, tmp_6, VOID, VOID, VOID, VOID, VOID, VOID, VOID, showCustomCell$lambda_6(bindingValue));
                  }
                   while (false);
                  tmp_4.kug_1 = Unit_instance;
                  this.f9_1 = 3;
                  continue $sm;
                } else {
                  if (isInterface(tmp0_subject, LinkCustomCell_1)) {
                    var tmp_7 = this;
                    var link = this.gug_1.l60(this.hug_1.xa1().z6o());
                    var bindingValueFactory_0 = showCustomCell$lambda_7(link);
                    var tmp0_3 = this.gug_1;
                    var tmp2_1 = this.iug_1;
                    l$ret$11: do {
                      var tmp0_4 = tmp0_3.l60(tmp2_1);
                      var destination_1 = ArrayList_init_$Create$();
                      var _iterator__ex2g4s_3 = tmp0_4.m();
                      while (_iterator__ex2g4s_3.n()) {
                        var element_3 = _iterator__ex2g4s_3.o();
                        if (!(element_3 == null) ? isInterface(element_3, OntologyLinkValue_1) : false) {
                          destination_1.j(element_3);
                        }
                      }
                      var valueParameters_1 = destination_1;
                      var tmp$ret$8;
                      l$ret$9: do {
                        var _iterator__ex2g4s_4 = valueParameters_1.m();
                        while (_iterator__ex2g4s_4.n()) {
                          var element_4 = _iterator__ex2g4s_4.o();
                          if (equals(link, this.gug_1.l60(element_4.cft().z6o()))) {
                            tmp$ret$8 = element_4;
                            break l$ret$9;
                          }
                        }
                        tmp$ret$8 = null;
                      }
                       while (false);
                      var bindingValue_0 = tmp$ret$8;
                      if (bindingValue_0 == null) {
                        executeCommand_0(tmp0_3, showCustomCell$lambda_8(tmp2_1, bindingValueFactory_0, tmp0_3));
                        break l$ret$11;
                      }
                      var tmp_8 = getKClass(AbstractValue);
                      var tmp_9 = showCustomCell$lambda_9(bindingValue_0);
                      child_1(tmp0_3, tmp_8, tmp_9, VOID, VOID, VOID, VOID, VOID, VOID, VOID, showCustomCell$lambda_10(bindingValue_0));
                    }
                     while (false);
                    tmp_7.kug_1 = Unit_instance;
                    this.f9_1 = 3;
                    continue $sm;
                  } else {
                    if (isInterface(tmp0_subject, ReturnTypeCustomCell_1)) {
                      var tmp_10 = this;
                      var tmp_11 = this.jug_1;
                      if (!isInterface(tmp_11, FunctionDeclaration_1))
                        THROW_CCE();
                      var tmp_12 = getKClass(OntologyElementType_1);
                      tmp_10.kug_1 = child_1(this.gug_1, tmp_12, showCustomCell$lambda_11(this.jug_1));
                      this.f9_1 = 3;
                      continue $sm;
                    } else {
                      if (isInterface(tmp0_subject, CardinalityCustomCell_1)) {
                        var tmp_13 = this;
                        var tmp_14 = this.jug_1;
                        if (!isInterface(tmp_14, FunctionDeclaration_1))
                          THROW_CCE();
                        var tmp_15 = getKClass(Cardinality_1);
                        tmp_13.kug_1 = child_1(this.gug_1, tmp_15, showCustomCell$lambda_12(this.jug_1));
                        this.f9_1 = 3;
                        continue $sm;
                      } else {
                        if (isInterface(tmp0_subject, KindCustomCell_1)) {
                          var tmp_16 = this.jug_1;
                          if (!isInterface(tmp_16, ProcessDeclaration_1))
                            THROW_CCE();
                          this.f9_1 = 1;
                          suspendResult = this.gug_1.k60(this.jug_1.r5a(), this);
                          if (suspendResult === get_COROUTINE_SUSPENDED()) {
                            return suspendResult;
                          }
                          continue $sm;
                        } else {
                          if (isInterface(tmp0_subject, DeclarationNameCustomCell_1)) {
                            var tmp_17 = this;
                            var this_1 = label_0(this.gug_1, this.gug_1.l60(this.jug_1.y2()));
                            this_1.w92(constantReferenceTrait(this.jug_1));
                            this_1.d97().d2x(true);
                            tmp_17.kug_1 = this_1;
                            this.f9_1 = 3;
                            continue $sm;
                          } else {
                            if (isInterface(tmp0_subject, PropertiesCustomCell_1)) {
                              var tmp_18 = this;
                              indentLabel_0(this.gug_1, '(');
                              var tmp_19 = getKClass(BindingValuePlaceholder_1);
                              children_2(this.gug_1, tmp_19, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, showCustomCell$lambda_13(this.iug_1));
                              tmp_18.kug_1 = indentLabel_0(this.gug_1, ')');
                              this.f9_1 = 3;
                              continue $sm;
                            } else {
                              var tmp_20 = this;
                              throw UnsupportedOperationException_init_$Create$_0('unknown custom cell: ' + toString_1(getKClassFromExpression(this.hug_1)));
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }

          case 1:
            var ARGUMENT = suspendResult;
            var kind = ensureNotNull(ARGUMENT);
            var tmp_21 = this;
            var this_2 = label_0(this.gug_1, this.gug_1.l60(kind.y2()));
            this_2.w92(constantReferenceTrait(kind));
            tmp_21.kug_1 = this_2;
            this.f9_1 = 3;
            continue $sm;
          case 2:
            throw this.i9_1;
          case 3:
            return Unit_instance;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function get_objectTypeCompletion() {
    _init_properties_TypeEditors_kt__d3e3bu();
    return objectTypeCompletion;
  }
  var objectTypeCompletion;
  function get_variableSpecificationCompletion() {
    _init_properties_TypeEditors_kt__d3e3bu();
    return variableSpecificationCompletion;
  }
  var variableSpecificationCompletion;
  function ontologyElementTypeCompletion_0(_this__u8e3s4) {
    _init_properties_TypeEditors_kt__d3e3bu();
    var tmp = _this__u8e3s4.jcg(Companion_getInstance_335().dh6_1);
    _this__u8e3s4.gck(tmp, ontologyElementTypeCompletion$lambda_0(_this__u8e3s4));
  }
  function processTypeCompletion(_this__u8e3s4) {
    _init_properties_TypeEditors_kt__d3e3bu();
    var tmp = _this__u8e3s4.jcg(Companion_getInstance_311().tgl_1);
    _this__u8e3s4.gck(tmp, processTypeCompletion$lambda(_this__u8e3s4));
  }
  function classExpressionTypeEditor() {
    _init_properties_TypeEditors_kt__d3e3bu();
    var tmp0 = classExpressionTypeEditor$lambda;
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
    var completionSupplier = classExpressionTypeEditor$lambda_0;
    var separator = get_defaultChildrenSeparator();
    var tmp0_0 = new ChildrenRoleDefaults(getKClass(ClassExpressionType_1), '<empty>', tmp0, separator, completionSupplier, true);
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
    var init = classExpressionTypeEditor$lambda_1;
    var triggerDependencies = emptyList();
    var tmp = getKClass(ClassExpressionType_1);
    return new EditorDefinition(tmp, tmp0_0, null, false, true, triggerDependencies, classExpressionTypeEditor$lambda_2(init));
  }
  function getNotionTypeCompletion(_this__u8e3s4) {
    _init_properties_TypeEditors_kt__d3e3bu();
    var tmp = _this__u8e3s4.jcg(Companion_getInstance_351().zgu_1);
    _this__u8e3s4.gck(tmp, getNotionTypeCompletion$lambda(_this__u8e3s4));
  }
  function anonymousClassTypeCompletion(_this__u8e3s4) {
    _init_properties_TypeEditors_kt__d3e3bu();
    var tmp = _this__u8e3s4.ick(anonymousClassTypeCompletion$lambda);
    return _this__u8e3s4.jck(tmp, anonymousClassTypeCompletion$lambda_0(_this__u8e3s4));
  }
  function getPrimitiveNotionTypeCompletion(_this__u8e3s4) {
    _init_properties_TypeEditors_kt__d3e3bu();
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = get_entries().m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      _this__u8e3s4.bck(element.elv_1, getPrimitiveNotionTypeCompletion$lambda(_this__u8e3s4, element));
    }
  }
  function objectTypeCompletion$lambda(_this__u8e3s4) {
    _init_properties_TypeEditors_kt__d3e3bu();
    getNotionTypeCompletion(_this__u8e3s4);
    getPrimitiveNotionTypeCompletion(_this__u8e3s4);
    ontologyElementTypeCompletion_0(_this__u8e3s4);
    anonymousClassTypeCompletion(_this__u8e3s4);
    _this__u8e3s4.bck('one of', objectTypeCompletion$lambda$lambda(_this__u8e3s4));
    return Unit_instance;
  }
  function objectTypeCompletion$lambda$lambda($this) {
    return function () {
      return OneOf($this.l6z());
    };
  }
  function variableSpecificationCompletion$lambda(_this__u8e3s4) {
    _init_properties_TypeEditors_kt__d3e3bu();
    get_objectTypeCompletion()(_this__u8e3s4);
    processTypeCompletion(_this__u8e3s4);
    variableReferenceValueCompletion(_this__u8e3s4);
    processPropertyReferenceCompletion(_this__u8e3s4);
    return Unit_instance;
  }
  function ontologyElementTypeCompletion$lambda_0($this_ontologyElementTypeCompletion) {
    return function (reference) {
      // Inline function 'kotlin.apply' call
      var this_0 = OntologyElementType($this_ontologyElementTypeCompletion.l6z());
      this_0.ffq().d2x(OntologyLibraryReference_2($this_ontologyElementTypeCompletion.l6z(), reference));
      this_0.gfq().d2x(OntologyElementReference($this_ontologyElementTypeCompletion.l6z()));
      return this_0;
    };
  }
  function processTypeCompletion$lambda($this_processTypeCompletion) {
    return function (reference) {
      // Inline function 'kotlin.apply' call
      var this_0 = ProcessType($this_processTypeCompletion.l6z());
      this_0.vfq().f2x(LibraryProcessSpecification_2($this_processTypeCompletion.l6z(), reference));
      return this_0;
    };
  }
  function classExpressionTypeEditor$lambda(wrapperContext) {
    _init_properties_TypeEditors_kt__d3e3bu();
    return ClassExpressionType(wrapperContext);
  }
  function classExpressionTypeEditor$lambda_0($this$childrenRoleDefaults) {
    _init_properties_TypeEditors_kt__d3e3bu();
    anonymousClassTypeCompletion($this$childrenRoleDefaults);
    return Unit_instance;
  }
  function classExpressionTypeEditor$lambda_1($this$editor) {
    _init_properties_TypeEditors_kt__d3e3bu();
    var tmp = getKClass(UnionClass_1);
    var tmp_0 = classExpressionTypeEditor$lambda$lambda;
    var expression = child_1($this$editor, tmp, tmp_0, VOID, VOID, VOID, VOID, VOID, VOID, VOID, classExpressionTypeEditor$lambda$lambda_0);
    considerEmptyBy($this$editor, expression);
    deleteIfEmpty($this$editor);
    return Unit_instance;
  }
  function classExpressionTypeEditor$lambda$lambda(type) {
    _init_properties_TypeEditors_kt__d3e3bu();
    return type.hfq();
  }
  function classExpressionTypeEditor$lambda$lambda_0($this$child) {
    _init_properties_TypeEditors_kt__d3e3bu();
    anonymousClassCompletion($this$child);
    return Unit_instance;
  }
  function classExpressionTypeEditor$lambda_2($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function getNotionTypeCompletion$lambda($this_getNotionTypeCompletion) {
    return function (reference) {
      return NotionType_1($this_getNotionTypeCompletion.l6z(), reference);
    };
  }
  function anonymousClassTypeCompletion$lambda($this$using) {
    _init_properties_TypeEditors_kt__d3e3bu();
    anonymousClassCompletion($this$using);
    return Unit_instance;
  }
  function anonymousClassTypeCompletion$lambda_0($this_anonymousClassTypeCompletion) {
    return function (it) {
      // Inline function 'kotlin.apply' call
      var this_0 = ClassExpressionType($this_anonymousClassTypeCompletion.l6z());
      this_0.hfq().f2x(it);
      return this_0;
    };
  }
  function getPrimitiveNotionTypeCompletion$lambda($this_getPrimitiveNotionTypeCompletion, $it) {
    return function () {
      // Inline function 'kotlin.apply' call
      var this_0 = PrimitiveNotionType($this_getPrimitiveNotionTypeCompletion.l6z());
      this_0.oft().f2x($it);
      return this_0;
    };
  }
  var properties_initialized_TypeEditors_kt_a3riws;
  function _init_properties_TypeEditors_kt__d3e3bu() {
    if (!properties_initialized_TypeEditors_kt_a3riws) {
      properties_initialized_TypeEditors_kt_a3riws = true;
      objectTypeCompletion = objectTypeCompletion$lambda;
      variableSpecificationCompletion = variableSpecificationCompletion$lambda;
    }
  }
  function get_urlEditors() {
    _init_properties_UrlEditors_kt__5wawkp();
    return urlEditors;
  }
  var urlEditors;
  function urlPlaceholderPasteTrait(baseTrait, urls, wrapperContext) {
    _init_properties_UrlEditors_kt__5wawkp();
    var tmp = CompositeCellTraits_instance;
    return tmp.ra6([new urlPlaceholderPasteTrait$1(urls, wrapperContext), baseTrait]);
  }
  function urlEditors$lambda($this$childrenRoleDefaults) {
    _init_properties_UrlEditors_kt__5wawkp();
    var tmp = $this$childrenRoleDefaults.qci();
    $this$childrenRoleDefaults.dck(tmp, urlEditors$lambda$lambda($this$childrenRoleDefaults));
    return Unit_instance;
  }
  function urlEditors$lambda$lambda($this_childrenRoleDefaults) {
    return function (text) {
      // Inline function 'kotlin.apply' call
      var this_0 = Url($this_childrenRoleDefaults.l6z());
      this_0.a1().f2x(text);
      return this_0;
    };
  }
  function urlEditors$lambda_0($this$editor) {
    _init_properties_UrlEditors_kt__5wawkp();
    indent_0($this$editor, VOID, VOID, urlEditors$lambda$lambda_0);
    deleteIfEmpty($this$editor);
    return Unit_instance;
  }
  function urlEditors$lambda$lambda_0($this$indent) {
    _init_properties_UrlEditors_kt__5wawkp();
    var tmp = urlEditors$lambda$lambda$lambda;
    textProperty_0($this$indent, '<url>', tmp, urlEditors$lambda$lambda$lambda_0);
    return Unit_instance;
  }
  function urlEditors$lambda$lambda$lambda(it) {
    _init_properties_UrlEditors_kt__5wawkp();
    return it.a1();
  }
  function urlEditors$lambda$lambda$lambda_0($this$textProperty) {
    _init_properties_UrlEditors_kt__5wawkp();
    $this$textProperty.qd0().w92(URLHandler_getInstance());
    return Unit_instance;
  }
  function urlEditors$lambda_1($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function urlPlaceholderPasteTrait$1($urls, $wrapperContext) {
    this.lug_1 = $urls;
    this.mug_1 = $wrapperContext;
    CellTrait.call(this);
  }
  protoOf(urlPlaceholderPasteTrait$1).h92 = function (cell, event) {
    if (!event.c8m_1.e8i(ContentKinds_getInstance().f8m_1))
      return Unit_instance;
    var pastedValue = event.c8m_1.f8i(ContentKinds_getInstance().f8m_1);
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(pastedValue) === 0)
      return Unit_instance;
    var tmp0_safe_receiver = cell.bp();
    var urlCollectionCell = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.bp();
    event.n8i();
    // Inline function 'kotlin.apply' call
    var this_0 = Url(this.mug_1);
    this_0.a1().f2x(pastedValue);
    this.lug_1.j(this_0);
    var tmp2_safe_receiver = urlCollectionCell == null ? null : firstFocusable(urlCollectionCell);
    var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : toEnd_0(tmp2_safe_receiver);
    if (tmp3_safe_receiver == null)
      null;
    else
      tmp3_safe_receiver();
  };
  var properties_initialized_UrlEditors_kt_y5753;
  function _init_properties_UrlEditors_kt__5wawkp() {
    if (!properties_initialized_UrlEditors_kt_y5753) {
      properties_initialized_UrlEditors_kt_y5753 = true;
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
      var completionSupplier = urlEditors$lambda;
      var separator = get_defaultChildrenSeparator();
      var tmp0 = new ChildrenRoleDefaults(getKClass(Url_1), '<empty>', null, separator, completionSupplier, true);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init = urlEditors$lambda_0;
      var triggerDependencies = emptyList();
      var tmp = getKClass(Url_1);
      var tmp$ret$1 = new EditorDefinition(tmp, tmp0, null, false, true, triggerDependencies, urlEditors$lambda_1(init));
      urlEditors = listOf(tmp$ret$1);
    }
  }
  function get_editorImplementation() {
    _init_properties_BTBEditorImplementation_kt__r5am6b();
    return editorImplementation;
  }
  var editorImplementation;
  var BTBEditorImplementation_EDITORS_instance;
  var BTBEditorImplementation_EDITOR_BUILDERS_instance;
  var BTBEditorImplementation_entriesInitialized;
  function BTBEditorImplementation_initEntries() {
    if (BTBEditorImplementation_entriesInitialized)
      return Unit_instance;
    BTBEditorImplementation_entriesInitialized = true;
    BTBEditorImplementation_EDITORS_instance = new BTBEditorImplementation('EDITORS', 0);
    BTBEditorImplementation_EDITOR_BUILDERS_instance = new BTBEditorImplementation('EDITOR_BUILDERS', 1);
  }
  function BTBEditorImplementation(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function BTBEditorImplementation_EDITOR_BUILDERS_getInstance() {
    BTBEditorImplementation_initEntries();
    return BTBEditorImplementation_EDITOR_BUILDERS_instance;
  }
  var properties_initialized_BTBEditorImplementation_kt_xcf64f;
  function _init_properties_BTBEditorImplementation_kt__r5am6b() {
    if (!properties_initialized_BTBEditorImplementation_kt_xcf64f) {
      properties_initialized_BTBEditorImplementation_kt_xcf64f = true;
      editorImplementation = BTBEditorImplementation_EDITOR_BUILDERS_getInstance();
    }
  }
  function getEditorMapperFactory(configuration) {
    var tmp;
    switch (get_editorImplementation().x2_1) {
      case 0:
        tmp = BTBEditor_getInstance().xtu(configuration);
        break;
      case 1:
        tmp = getEditorMapperFactory$lambda(configuration);
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  function getEditorMapperFactory$lambda($configuration) {
    return function (nodeWrapper) {
      var rootMapperFactory = getEditorBuildersRootMapperFactory();
      var editorMapperFactory = rootMapperFactory.au1($configuration);
      return editorMapperFactory.sd2(nodeWrapper);
    };
  }
  function sendBecameEmpty(_this__u8e3s4) {
    var event = new Event_0();
    event.m8i(Companion_instance_149.s92(_this__u8e3s4));
    _this__u8e3s4.v92(new DerivedEvent(event), Cells_getInstance().g9t_1);
  }
  function DeleteTransformTrait() {
    CellTrait.call(this);
  }
  protoOf(DeleteTransformTrait).s8z = function (cell, event) {
    if (event.m8j(Key_DELETE_getInstance(), []) || event.m8j(Key_BACKSPACE_getInstance(), [])) {
      this.tu1(cell);
      event.n8i();
    } else {
      protoOf(CellTrait).s8z.call(this, cell, event);
    }
  };
  function getDeleteTransformTrait(_this__u8e3s4, cellFinder) {
    // Inline function 'jetbrains.biokb.lang.traits.createDeleteTransformTrait' call
    return new getDeleteTransformTrait$$inlined$createDeleteTransformTrait$1(_this__u8e3s4, cellFinder);
  }
  function removePropertyReferenceAndSelectValue(_this__u8e3s4, cellFinder) {
    var tmp0_safe_receiver = _this__u8e3s4.rie();
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      var tmp0_safe_receiver_0 = firstOrNull_0(cellFinder.lah(tmp0_safe_receiver));
      var tmp1_safe_receiver = tmp0_safe_receiver_0 == null ? null : lastFocusable(tmp0_safe_receiver_0);
      var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : toEnd_0(tmp1_safe_receiver);
      tmp2_safe_receiver == null || tmp2_safe_receiver();
    }
  }
  function getDeleteTransformTrait$$inlined$createDeleteTransformTrait$1($this_getDeleteTransformTrait, $cellFinder) {
    this.nug_1 = $this_getDeleteTransformTrait;
    this.oug_1 = $cellFinder;
    DeleteTransformTrait.call(this);
  }
  protoOf(getDeleteTransformTrait$$inlined$createDeleteTransformTrait$1).tu1 = function (cell) {
    var tmp0_safe_receiver = this.nug_1.pik();
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      var tmp0_safe_receiver_0 = firstOrNull_0(this.oug_1.lah(tmp0_safe_receiver));
      var tmp1_safe_receiver = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.c93(ProjectionalSynchronizers_getInstance().d99_1);
      if (tmp1_safe_receiver == null)
        null;
      else
        tmp1_safe_receiver();
    }
    return Unit_instance;
  };
  function NewSingleFactSelected(factNodeId) {
    Event_0.call(this);
    this.rug_1 = factNodeId;
  }
  protoOf(NewSingleFactSelected).toString = function () {
    return 'NewSingleFactSelected(factNodeId=' + this.rug_1 + ')';
  };
  protoOf(NewSingleFactSelected).hashCode = function () {
    return getStringHashCode(this.rug_1);
  };
  protoOf(NewSingleFactSelected).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof NewSingleFactSelected))
      return false;
    if (!(this.rug_1 === other.rug_1))
      return false;
    return true;
  };
  function FactToggleEvent(factNodeId, toggle) {
    Event_0.call(this);
    this.uug_1 = factNodeId;
    this.vug_1 = toggle;
  }
  function Companion_423() {
  }
  protoOf(Companion_423).ytf = function (cell) {
    return cell.u92(new FactsClearEvent(), Companion_getInstance_424().wug_1);
  };
  var Companion_instance_423;
  function Companion_getInstance_423() {
    return Companion_instance_423;
  }
  function FactsClearEvent() {
    Event_0.call(this);
  }
  function Companion_424() {
    Companion_instance_424 = this;
    this.wug_1 = new CellTraitEventSpec('clearFactSelection', false);
    this.xug_1 = new CellTraitEventSpec('factToggleEvent', true);
    this.yug_1 = new CellTraitEventSpec('newSingleFactSelected', true);
  }
  var Companion_instance_424;
  function Companion_getInstance_424() {
    if (Companion_instance_424 == null)
      new Companion_424();
    return Companion_instance_424;
  }
  function FactSelectionToggle$imageCellTrait$1(this$0) {
    this.zug_1 = this$0;
    CellTrait.call(this);
  }
  protoOf(FactSelectionToggle$imageCellTrait$1).r91 = function (cell, event) {
    var addition = event.u8l_1.x8j_1 || event.u8l_1.y8j_1 || event.u8l_1.a8k_1;
    var wasSelected = this.zug_1.aub_1.w2w();
    var nowSelected = !wasSelected;
    if (addition || wasSelected) {
      cell.u92(new FactToggleEvent(this.zug_1.yua_1, nowSelected), Companion_getInstance_424().xug_1);
    } else {
      cell.u92(new NewSingleFactSelected(this.zug_1.yua_1), Companion_getInstance_424().yug_1);
    }
    this.zug_1.aub_1.f2x(nowSelected);
    event.n8i();
  };
  function FactSelectionToggle$factCellTrait$1(this$0) {
    this.auh_1 = this$0;
    CellTrait.call(this);
  }
  protoOf(FactSelectionToggle$factCellTrait$1).x91 = function (cell, event) {
    this.auh_1.zua_1.f2x(true);
  };
  protoOf(FactSelectionToggle$factCellTrait$1).y91 = function (cell, event) {
    this.auh_1.zua_1.f2x(false);
  };
  protoOf(FactSelectionToggle$factCellTrait$1).i8y = function (cell, spec, event) {
    if (equals(spec, Companion_getInstance_424().wug_1)) {
      this.auh_1.aub_1.f2x(false);
      event.n8i();
    } else {
      protoOf(CellTrait).i8y.call(this, cell, spec, event);
    }
  };
  function FactSelectionToggle(factId, hover, selected) {
    Companion_getInstance_424();
    this.yua_1 = factId;
    this.zua_1 = hover;
    this.aub_1 = selected;
    var tmp = this;
    tmp.bub_1 = new FactSelectionToggle$imageCellTrait$1(this);
    var tmp_0 = this;
    tmp_0.cub_1 = new FactSelectionToggle$factCellTrait$1(this);
  }
  function sendClearDown($this) {
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = $this.buh_1.m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      Companion_instance_423.ytf(element);
    }
  }
  function sendEvent_0($this, _this__u8e3s4) {
    var tmp0_safe_receiver = _this__u8e3s4.s8x();
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.t42();
    var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.c93(Companion_getInstance_419().rtc_1);
    if (tmp2_safe_receiver == null)
      null;
    else {
      tmp2_safe_receiver.ltm($this.cuh_1);
    }
  }
  function BTBDocumentFactSelectionTrait(factSetCells) {
    CellTrait.call(this);
    this.buh_1 = factSetCells;
    var tmp = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.cuh_1 = ArrayList_init_$Create$();
  }
  protoOf(BTBDocumentFactSelectionTrait).i8y = function (cell, spec, event) {
    if (event instanceof NewSingleFactSelected) {
      this.cuh_1.k2();
      this.cuh_1.j(event.rug_1);
      sendEvent_0(this, cell);
      sendClearDown(this);
      event.n8i();
    } else {
      if (event instanceof FactToggleEvent) {
        if (event.vug_1)
          this.cuh_1.j(event.uug_1);
        else
          this.cuh_1.h2(event.uug_1);
        sendEvent_0(this, cell);
        event.n8i();
      } else {
        if (event instanceof FactsClearEvent) {
          sendClearDown(this);
          this.cuh_1.k2();
          event.n8i();
        } else {
          protoOf(CellTrait).i8y.call(this, cell, spec, event);
        }
      }
    }
  };
  function sendClearDown_0($this) {
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = $this.duh_1.m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      Companion_instance_423.ytf(element);
    }
  }
  function FactSetFactSelectionTrait(cellsWithNewFacts) {
    CellTrait.call(this);
    this.duh_1 = cellsWithNewFacts;
  }
  protoOf(FactSetFactSelectionTrait).i8y = function (cell, spec, event) {
    if (equals(spec, Companion_getInstance_424().wug_1)) {
      sendClearDown_0(this);
      event.n8i();
    } else {
      protoOf(CellTrait).i8y.call(this, cell, spec, event);
    }
  };
  function OrdinalId(ordinal) {
    Id.call(this);
    this.euh_1 = ordinal;
  }
  protoOf(OrdinalId).toString = function () {
    return 'OrdinalId(ordinal=' + this.euh_1 + ')';
  };
  protoOf(OrdinalId).hashCode = function () {
    return this.euh_1;
  };
  protoOf(OrdinalId).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof OrdinalId))
      return false;
    if (!(this.euh_1 === other.euh_1))
      return false;
    return true;
  };
  function ArbitraryId(id) {
    Id.call(this);
    this.fuh_1 = id;
  }
  protoOf(ArbitraryId).toString = function () {
    return 'ArbitraryId(id=' + this.fuh_1 + ')';
  };
  protoOf(ArbitraryId).hashCode = function () {
    return getStringHashCode(this.fuh_1);
  };
  protoOf(ArbitraryId).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ArbitraryId))
      return false;
    if (!(this.fuh_1 === other.fuh_1))
      return false;
    return true;
  };
  function FactSetIdManager$pasteHandler$2$1$prepare$2(this$0, $factSet) {
    this.huh_1 = this$0;
    this.iuh_1 = $factSet;
    this.guh_1 = true;
  }
  protoOf(FactSetIdManager$pasteHandler$2$1$prepare$2).p38 = function () {
    return this.guh_1;
  };
  protoOf(FactSetIdManager$pasteHandler$2$1$prepare$2).q38 = function () {
    if (mustChangeId(this.huh_1, this.iuh_1)) {
      this.iuh_1.zfq().d2x(freshFactSetId(this.huh_1));
    }
  };
  function mustChangeId($this, factSet) {
    var tmp0_elvis_lhs = parse_2($this, factSet.zfq().m5y().w2w());
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var _destruct__k2r9zo = tmp;
    var currentDocId = _destruct__k2r9zo.fg();
    var currentId = _destruct__k2r9zo.gg();
    if (currentId instanceof ArbitraryId) {
      return true;
    }
    // Inline function 'kotlin.collections.filterNot' call
    var tmp0 = $this.lu1_1.xfp().m5y();
    // Inline function 'kotlin.collections.filterNotTo' call
    var destination = ArrayList_init_$Create$();
    var _iterator__ex2g4s = tmp0.m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      if (!equals(element, factSet)) {
        destination.j(element);
      }
    }
    // Inline function 'kotlin.collections.mapNotNull' call
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var destination_0 = ArrayList_init_$Create$();
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s_0 = destination.m();
    while (_iterator__ex2g4s_0.n()) {
      var element_0 = _iterator__ex2g4s_0.o();
      var tmp0_safe_receiver = parse_2($this, element_0.zfq().m5y().w2w());
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        destination_0.j(tmp0_safe_receiver);
      }
    }
    var tmp$ret$10;
    $l$block_0: {
      // Inline function 'kotlin.collections.any' call
      var tmp_0;
      if (isInterface(destination_0, Collection)) {
        tmp_0 = destination_0.s();
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        tmp$ret$10 = false;
        break $l$block_0;
      }
      var _iterator__ex2g4s_1 = destination_0.m();
      while (_iterator__ex2g4s_1.n()) {
        var element_1 = _iterator__ex2g4s_1.o();
        var id = element_1.gg();
        if (equals(id, currentId)) {
          tmp$ret$10 = true;
          break $l$block_0;
        }
      }
      tmp$ret$10 = false;
    }
    var idClash = tmp$ret$10;
    return idClash || !(currentDocId === $this.mu1_1);
  }
  function freshFactSetId($this) {
    // Inline function 'kotlin.collections.map' call
    var this_0 = $this.lu1_1.xfp().m5y();
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.m();
    while (_iterator__ex2g4s.n()) {
      var item = _iterator__ex2g4s.o();
      var tmp$ret$0 = item.zfq().m5y().w2w();
      destination.j(tmp$ret$0);
    }
    // Inline function 'kotlin.collections.mapNotNull' call
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var destination_0 = ArrayList_init_$Create$();
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s_0 = destination.m();
    while (_iterator__ex2g4s_0.n()) {
      var element = _iterator__ex2g4s_0.o();
      var tmp0_safe_receiver = parse_2($this, element);
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        destination_0.j(tmp0_safe_receiver);
      }
    }
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination_1 = ArrayList_init_$Create$();
    var _iterator__ex2g4s_1 = destination_0.m();
    while (_iterator__ex2g4s_1.n()) {
      var element_0 = _iterator__ex2g4s_1.o();
      var docId = element_0.fg();
      if (docId === $this.mu1_1) {
        destination_1.j(element_0);
      }
    }
    // Inline function 'kotlin.collections.mapNotNull' call
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var destination_2 = ArrayList_init_$Create$();
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s_2 = destination_1.m();
    while (_iterator__ex2g4s_2.n()) {
      var element_1 = _iterator__ex2g4s_2.o();
      var id = element_1.gg();
      var tmp0_safe_receiver_0 = id instanceof OrdinalId ? id : null;
      var tmp0_safe_receiver_1 = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.euh_1;
      if (tmp0_safe_receiver_1 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        destination_2.j(tmp0_safe_receiver_1);
      }
    }
    var tmp0_elvis_lhs = maxOrNull(destination_2);
    var max = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
    var nextId = max + 1 | 0;
    return $this.mu1_1 + '-' + nextId;
  }
  function parse_2($this, _this__u8e3s4) {
    var parts = split(_this__u8e3s4, charArrayOf([_Char___init__impl__6a9atx(45)]));
    var tmp;
    if (!(parts.p() === 2)) {
      tmp = null;
    } else {
      var idPart = last(parts);
      var tmp0_safe_receiver = toIntOrNull(idPart);
      var tmp_0;
      if (tmp0_safe_receiver == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlin.let' call
        tmp_0 = new OrdinalId(tmp0_safe_receiver);
      }
      var tmp1_elvis_lhs = tmp_0;
      var id = tmp1_elvis_lhs == null ? new ArbitraryId(idPart) : tmp1_elvis_lhs;
      tmp = new FactSetId(first(parts), id);
    }
    return tmp;
  }
  function FactSetId(docId, id) {
    this.juh_1 = docId;
    this.kuh_1 = id;
  }
  protoOf(FactSetId).fg = function () {
    return this.juh_1;
  };
  protoOf(FactSetId).gg = function () {
    return this.kuh_1;
  };
  protoOf(FactSetId).toString = function () {
    return 'FactSetId(docId=' + this.juh_1 + ', id=' + toString_1(this.kuh_1) + ')';
  };
  protoOf(FactSetId).hashCode = function () {
    var result = getStringHashCode(this.juh_1);
    result = imul(result, 31) + hashCode(this.kuh_1) | 0;
    return result;
  };
  protoOf(FactSetId).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof FactSetId))
      return false;
    if (!(this.juh_1 === other.juh_1))
      return false;
    if (!equals(this.kuh_1, other.kuh_1))
      return false;
    return true;
  };
  function Id() {
  }
  function sam$jetbrains_ocelot_projectional_editor_cell_clipboard_PasteHandler$0_0(function_0) {
    this.luh_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_projectional_editor_cell_clipboard_PasteHandler$0_0).vak = function (sourceItem) {
    return this.luh_1(sourceItem);
  };
  protoOf(sam$jetbrains_ocelot_projectional_editor_cell_clipboard_PasteHandler$0_0).f3 = function () {
    return this.luh_1;
  };
  protoOf(sam$jetbrains_ocelot_projectional_editor_cell_clipboard_PasteHandler$0_0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, PasteHandler) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_projectional_editor_cell_clipboard_PasteHandler$0_0).hashCode = function () {
    return hashCode(this.f3());
  };
  function FactSetIdManager$nodeFactory$lambda(this$0) {
    return function (wrapperContext) {
      // Inline function 'kotlin.apply' call
      var this_0 = FactSet(wrapperContext);
      this_0.zfq().d2x(freshFactSetId(this$0));
      return this_0;
    };
  }
  function FactSetIdManager$pasteHandler$2$1(this$0, $factSet) {
    this.muh_1 = this$0;
    this.nuh_1 = $factSet;
  }
  protoOf(FactSetIdManager$pasteHandler$2$1).zr = function () {
  };
  protoOf(FactSetIdManager$pasteHandler$2$1).n38 = function ($completion) {
    return new FactSetIdManager$pasteHandler$2$1$prepare$2(this.muh_1, this.nuh_1);
  };
  function FactSetIdManager$pasteHandler$lambda(this$0) {
    return function (factSet) {
      return new FactSetIdManager$pasteHandler$2$1(this$0, factSet);
    };
  }
  function FactSetIdManager(btbDocument) {
    this.lu1_1 = btbDocument;
    this.mu1_1 = this.lu1_1.d6g().m5y().w2w();
  }
  protoOf(FactSetIdManager).nu1 = function () {
    return FactSetIdManager$nodeFactory$lambda(this);
  };
  protoOf(FactSetIdManager).ou1 = function () {
    var tmp = FactSetIdManager$pasteHandler$lambda(this);
    return new sam$jetbrains_ocelot_projectional_editor_cell_clipboard_PasteHandler$0_0(tmp);
  };
  function getDeleteTransformTrait_0(_this__u8e3s4, cellFinder) {
    // Inline function 'jetbrains.biokb.lang.traits.createDeleteTransformTrait' call
    return new getDeleteTransformTrait$$inlined$createDeleteTransformTrait$1_0(_this__u8e3s4, cellFinder);
  }
  function getDeleteTransformTrait$$inlined$createDeleteTransformTrait$1$doWork$1($source, $cellFinder) {
    this.ouh_1 = $source;
    this.puh_1 = $cellFinder;
  }
  protoOf(getDeleteTransformTrait$$inlined$createDeleteTransformTrait$1$doWork$1).n5w = function (builder) {
    var tmp$ret$0;
    $l$block: {
      var tmp0_elvis_lhs = this.ouh_1.bp();
      var tmp;
      if (tmp0_elvis_lhs == null) {
        tmp$ret$0 = Unit_instance;
        break $l$block;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var context = tmp;
      var right = builder.l60(this.ouh_1.eft());
      var res;
      var toSelect;
      if (!(right == null) ? isInterface(right, OrValueQuery_1) : false) {
        var tmp1_safe_receiver = builder.l60(right.eft());
        var tmp_0 = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.f6j();
        res = (!(tmp_0 == null) ? isInterface(tmp_0, AbstractBindingValueQuery) : false) ? tmp_0 : null;
        var tmp2_safe_receiver = res;
        var tmp_1;
        if (tmp2_safe_receiver == null) {
          tmp_1 = null;
        } else {
          // Inline function 'kotlin.let' call
          right.d6j(tmp2_safe_receiver);
          tmp_1 = Unit_instance;
        }
        if (tmp_1 == null) {
          right.e6j();
        }
        var tmp4_elvis_lhs = res;
        var tmp5_elvis_lhs = tmp4_elvis_lhs == null ? builder.l60(this.ouh_1.dft()) : tmp4_elvis_lhs;
        toSelect = tmp5_elvis_lhs == null ? this.ouh_1 : tmp5_elvis_lhs;
      } else {
        var tmp6_safe_receiver = builder.l60(this.ouh_1.dft());
        var tmp_2 = tmp6_safe_receiver == null ? null : tmp6_safe_receiver.f6j();
        res = (!(tmp_2 == null) ? isInterface(tmp_2, AbstractBindingValueQuery) : false) ? tmp_2 : null;
        var tmp7_safe_receiver = res;
        var tmp_3;
        if (tmp7_safe_receiver == null) {
          tmp_3 = null;
        } else {
          // Inline function 'kotlin.let' call
          this.ouh_1.d6j(tmp7_safe_receiver);
          tmp_3 = Unit_instance;
        }
        if (tmp_3 == null) {
          this.ouh_1.e6j();
        }
        var tmp9_elvis_lhs = res;
        toSelect = tmp9_elvis_lhs == null ? context : tmp9_elvis_lhs;
      }
      var tmp10_safe_receiver = firstOrNull_0(this.puh_1.lah(toSelect));
      var tmp11_safe_receiver = tmp10_safe_receiver == null ? null : tmp10_safe_receiver.c93(ProjectionalSynchronizers_getInstance().d99_1);
      if (tmp11_safe_receiver == null)
        null;
      else
        tmp11_safe_receiver();
      tmp$ret$0 = Unit_instance;
    }
    return tmp$ret$0;
  };
  function getDeleteTransformTrait$$inlined$createDeleteTransformTrait$1_0($this_getDeleteTransformTrait, $cellFinder) {
    this.quh_1 = $this_getDeleteTransformTrait;
    this.ruh_1 = $cellFinder;
    DeleteTransformTrait.call(this);
  }
  protoOf(getDeleteTransformTrait$$inlined$createDeleteTransformTrait$1_0).tu1 = function (cell) {
    var source = this.quh_1;
    // Inline function 'jetbrains.ocelot.langDef.query.executeQuery' call
    // Inline function 'jetbrains.ocelot.langDef.query.query' call
    var tmp$ret$0 = new getDeleteTransformTrait$$inlined$createDeleteTransformTrait$1$doWork$1(source, this.ruh_1);
    execute_0(tmp$ret$0);
    return Unit_instance;
  };
  function get_btbFindUsagesViews() {
    _init_properties_UsagesView_kt__wok549();
    return btbFindUsagesViews;
  }
  var btbFindUsagesViews;
  function ontologyRelationUsagePresentation(_this__u8e3s4, klass) {
    _init_properties_UsagesView_kt__wok549();
    label_0(_this__u8e3s4, 'ontology element');
    space_0(_this__u8e3s4);
    textProperty_0(_this__u8e3s4, '<name>', ontologyRelationUsagePresentation$lambda);
    space_0(_this__u8e3s4);
    label_0(_this__u8e3s4, '(');
    var tmp0_subject = _this__u8e3s4.m6d();
    var tmp;
    if (tmp0_subject instanceof SuperElementUsage) {
      tmp = 'super type:';
    } else {
      if (tmp0_subject instanceof PartOfElementUsage) {
        tmp = 'part of:';
      } else {
        tmp = 'related to:';
      }
    }
    var relationLabel = tmp;
    label_0(_this__u8e3s4, relationLabel);
    space_0(_this__u8e3s4);
    child_1(_this__u8e3s4, klass, ontologyRelationUsagePresentation$lambda_0(_this__u8e3s4));
    label_0(_this__u8e3s4, ')');
  }
  function asQProperty(_this__u8e3s4) {
    _init_properties_UsagesView_kt__wok549();
    var observable = new ValueProperty(_this__u8e3s4);
    return get_forQueries(observable);
  }
  function targetName(_this__u8e3s4, reference) {
    _init_properties_UsagesView_kt__wok549();
    var tmp = get_internalConfig(_this__u8e3s4).ud0();
    var tmp_0 = new CellAsyncTracker(_this__u8e3s4.qd0());
    launchWith(tmp, tmp_0, targetName$slambda_0(reference, _this__u8e3s4, null));
  }
  function get_declarationKindName(_this__u8e3s4) {
    _init_properties_UsagesView_kt__wok549();
    var tmp;
    if (isInterface(_this__u8e3s4, ProcessDeclaration_1)) {
      tmp = 'process';
    } else {
      if (isInterface(_this__u8e3s4, FunctionDeclaration_1)) {
        tmp = 'function';
      } else {
        throw IllegalArgumentException_init_$Create$_0('declarationKindName not defined for ' + toString_1(getKClassFromExpression(_this__u8e3s4)));
      }
    }
    return tmp;
  }
  function ontologyImportUsage(_this__u8e3s4) {
    _init_properties_UsagesView_kt__wok549();
    label_0(_this__u8e3s4, _this__u8e3s4.m6d().mmd());
    space_0(_this__u8e3s4);
    var tmp = getKClass(OntologyImport_1);
    child_1(_this__u8e3s4, tmp, ontologyImportUsage$lambda);
  }
  function asQProperty_0(_this__u8e3s4) {
    _init_properties_UsagesView_kt__wok549();
    var observable = new ValueProperty(execute_0(_this__u8e3s4));
    return get_forQueries(observable);
  }
  function btbFindUsagesViews$lambda($this$findUsagesView) {
    _init_properties_UsagesView_kt__wok549();
    // Inline function 'jetbrains.ocelot.langDef.usages.viewFor' call
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
    var init = btbFindUsagesViews$lambda$lambda;
    var triggerDependencies = emptyList();
    var tmp = getKClass(SuperElementUsage);
    var def = new EditorDefinition(tmp, null, null, false, false, triggerDependencies, btbFindUsagesViews$lambda$lambda_0(init));
    $this$findUsagesView.ode(def);
    // Inline function 'jetbrains.ocelot.langDef.usages.viewFor' call
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
    var init_0 = btbFindUsagesViews$lambda$lambda_1;
    var triggerDependencies_0 = emptyList();
    var tmp_0 = getKClass(PartOfElementUsage);
    var def_0 = new EditorDefinition(tmp_0, null, null, false, false, triggerDependencies_0, btbFindUsagesViews$lambda$lambda_2(init_0));
    $this$findUsagesView.ode(def_0);
    // Inline function 'jetbrains.ocelot.langDef.usages.viewFor' call
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
    var init_1 = btbFindUsagesViews$lambda$lambda_3;
    var triggerDependencies_1 = emptyList();
    var tmp_1 = getKClass(ElementsTaxonUsage);
    var def_1 = new EditorDefinition(tmp_1, null, null, false, false, triggerDependencies_1, btbFindUsagesViews$lambda$lambda_4(init_1));
    $this$findUsagesView.ode(def_1);
    // Inline function 'jetbrains.ocelot.langDef.usages.viewFor' call
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
    var init_2 = btbFindUsagesViews$lambda$lambda_5;
    var triggerDependencies_2 = emptyList();
    var tmp_2 = getKClass(CategoryOntologyUsage);
    var def_2 = new EditorDefinition(tmp_2, null, null, false, false, triggerDependencies_2, btbFindUsagesViews$lambda$lambda_6(init_2));
    $this$findUsagesView.ode(def_2);
    // Inline function 'jetbrains.ocelot.langDef.usages.viewFor' call
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
    var init_3 = btbFindUsagesViews$lambda$lambda_7;
    var triggerDependencies_3 = emptyList();
    var tmp_3 = getKClass(FactSetContextOntologyUsage);
    var def_3 = new EditorDefinition(tmp_3, null, null, false, false, triggerDependencies_3, btbFindUsagesViews$lambda$lambda_8(init_3));
    $this$findUsagesView.ode(def_3);
    // Inline function 'jetbrains.ocelot.langDef.usages.viewFor' call
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
    var init_4 = btbFindUsagesViews$lambda$lambda_9;
    var triggerDependencies_4 = emptyList();
    var tmp_4 = getKClass(SomethingAsVariableSpecUsage);
    var def_4 = new EditorDefinition(tmp_4, null, null, false, false, triggerDependencies_4, btbFindUsagesViews$lambda$lambda_10(init_4));
    $this$findUsagesView.ode(def_4);
    // Inline function 'jetbrains.ocelot.langDef.usages.viewFor' call
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
    var init_5 = btbFindUsagesViews$lambda$lambda_11;
    var triggerDependencies_5 = emptyList();
    var tmp_5 = getKClass(AnyUsageInFact);
    var def_5 = new EditorDefinition(tmp_5, null, null, false, false, triggerDependencies_5, btbFindUsagesViews$lambda$lambda_12(init_5));
    $this$findUsagesView.ode(def_5);
    // Inline function 'jetbrains.ocelot.langDef.usages.viewFor' call
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
    var init_6 = btbFindUsagesViews$lambda$lambda_13;
    var triggerDependencies_6 = emptyList();
    var tmp_6 = getKClass(ProcessKindUsage);
    var def_6 = new EditorDefinition(tmp_6, null, null, false, false, triggerDependencies_6, btbFindUsagesViews$lambda$lambda_14(init_6));
    $this$findUsagesView.ode(def_6);
    // Inline function 'jetbrains.ocelot.langDef.usages.viewFor' call
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
    var init_7 = btbFindUsagesViews$lambda$lambda_15;
    var triggerDependencies_7 = emptyList();
    var tmp_7 = getKClass(ExtendedProcessUsage);
    var def_7 = new EditorDefinition(tmp_7, null, null, false, false, triggerDependencies_7, btbFindUsagesViews$lambda$lambda_16(init_7));
    $this$findUsagesView.ode(def_7);
    // Inline function 'jetbrains.ocelot.langDef.usages.viewFor' call
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
    var init_8 = btbFindUsagesViews$lambda$lambda_17;
    var triggerDependencies_8 = emptyList();
    var tmp_8 = getKClass(OntologyElementInBindingDeclarationUsage);
    var def_8 = new EditorDefinition(tmp_8, null, null, false, false, triggerDependencies_8, btbFindUsagesViews$lambda$lambda_18(init_8));
    $this$findUsagesView.ode(def_8);
    // Inline function 'jetbrains.ocelot.langDef.usages.viewFor' call
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
    var init_9 = btbFindUsagesViews$lambda$lambda_19;
    var triggerDependencies_9 = emptyList();
    var tmp_9 = getKClass(InheritedProcessUsage);
    var def_9 = new EditorDefinition(tmp_9, null, null, false, false, triggerDependencies_9, btbFindUsagesViews$lambda$lambda_20(init_9));
    $this$findUsagesView.ode(def_9);
    // Inline function 'jetbrains.ocelot.langDef.usages.viewFor' call
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
    var init_10 = btbFindUsagesViews$lambda$lambda_21;
    var triggerDependencies_10 = emptyList();
    var tmp_10 = getKClass(AnythingInsideCustomEditorUsage);
    var def_10 = new EditorDefinition(tmp_10, null, null, false, false, triggerDependencies_10, btbFindUsagesViews$lambda$lambda_22(init_10));
    $this$findUsagesView.ode(def_10);
    // Inline function 'jetbrains.ocelot.langDef.usages.viewFor' call
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
    var init_11 = btbFindUsagesViews$lambda$lambda_23;
    var triggerDependencies_11 = emptyList();
    var tmp_11 = getKClass(AliasedBindingPropertyUsage);
    var def_11 = new EditorDefinition(tmp_11, null, null, false, false, triggerDependencies_11, btbFindUsagesViews$lambda$lambda_24(init_11));
    $this$findUsagesView.ode(def_11);
    // Inline function 'jetbrains.ocelot.langDef.usages.viewFor' call
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
    var init_12 = btbFindUsagesViews$lambda$lambda_25;
    var triggerDependencies_12 = emptyList();
    var tmp_12 = getKClass(PropertyTypeUsage);
    var def_12 = new EditorDefinition(tmp_12, null, null, false, false, triggerDependencies_12, btbFindUsagesViews$lambda$lambda_26(init_12));
    $this$findUsagesView.ode(def_12);
    // Inline function 'jetbrains.ocelot.langDef.usages.viewFor' call
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
    var init_13 = btbFindUsagesViews$lambda$lambda_27;
    var triggerDependencies_13 = emptyList();
    var tmp_13 = getKClass(OldPropertyTypeNotionUsage);
    var def_13 = new EditorDefinition(tmp_13, null, null, false, false, triggerDependencies_13, btbFindUsagesViews$lambda$lambda_28(init_13));
    $this$findUsagesView.ode(def_13);
    // Inline function 'jetbrains.ocelot.langDef.usages.viewFor' call
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
    var init_14 = btbFindUsagesViews$lambda$lambda_29;
    var triggerDependencies_14 = emptyList();
    var tmp_14 = getKClass(OldLinkOntologyUsage);
    var def_14 = new EditorDefinition(tmp_14, null, null, false, false, triggerDependencies_14, btbFindUsagesViews$lambda$lambda_30(init_14));
    $this$findUsagesView.ode(def_14);
    // Inline function 'jetbrains.ocelot.langDef.usages.viewFor' call
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
    var init_15 = btbFindUsagesViews$lambda$lambda_31;
    var triggerDependencies_15 = emptyList();
    var tmp_15 = getKClass(OntologyInFunctionReturnTypeUsage);
    var def_15 = new EditorDefinition(tmp_15, null, null, false, false, triggerDependencies_15, btbFindUsagesViews$lambda$lambda_32(init_15));
    $this$findUsagesView.ode(def_15);
    // Inline function 'jetbrains.ocelot.langDef.usages.viewFor' call
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
    var init_16 = btbFindUsagesViews$lambda$lambda_33;
    var triggerDependencies_16 = emptyList();
    var tmp_16 = getKClass(OldImportedPropertyUsage);
    var def_16 = new EditorDefinition(tmp_16, null, null, false, false, triggerDependencies_16, btbFindUsagesViews$lambda$lambda_34(init_16));
    $this$findUsagesView.ode(def_16);
    // Inline function 'jetbrains.ocelot.langDef.usages.viewFor' call
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
    var init_17 = btbFindUsagesViews$lambda$lambda_35;
    var triggerDependencies_17 = emptyList();
    var tmp_17 = getKClass(OldImportedLinkUsage);
    var def_17 = new EditorDefinition(tmp_17, null, null, false, false, triggerDependencies_17, btbFindUsagesViews$lambda$lambda_36(init_17));
    $this$findUsagesView.ode(def_17);
    // Inline function 'jetbrains.ocelot.langDef.usages.viewFor' call
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
    var init_18 = btbFindUsagesViews$lambda$lambda_37;
    var triggerDependencies_18 = emptyList();
    var tmp_18 = getKClass(InOntologyImportForOntologyUsage);
    var def_18 = new EditorDefinition(tmp_18, null, null, false, false, triggerDependencies_18, btbFindUsagesViews$lambda$lambda_38(init_18));
    $this$findUsagesView.ode(def_18);
    // Inline function 'jetbrains.ocelot.langDef.usages.viewFor' call
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
    var init_19 = btbFindUsagesViews$lambda$lambda_39;
    var triggerDependencies_19 = emptyList();
    var tmp_19 = getKClass(InOntologyImportOntologyToUseUsage);
    var def_19 = new EditorDefinition(tmp_19, null, null, false, false, triggerDependencies_19, btbFindUsagesViews$lambda$lambda_40(init_19));
    $this$findUsagesView.ode(def_19);
    // Inline function 'jetbrains.ocelot.langDef.usages.viewFor' call
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
    var init_20 = btbFindUsagesViews$lambda$lambda_41;
    var triggerDependencies_20 = emptyList();
    var tmp_20 = getKClass(OntologyInExtensionTypeUsage);
    var def_20 = new EditorDefinition(tmp_20, null, null, false, false, triggerDependencies_20, btbFindUsagesViews$lambda$lambda_42(init_20));
    $this$findUsagesView.ode(def_20);
    // Inline function 'jetbrains.ocelot.langDef.usages.viewFor' call
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
    var init_21 = btbFindUsagesViews$lambda$lambda_43;
    var triggerDependencies_21 = emptyList();
    var tmp_21 = getKClass(OntologyInExtensionFieldUsage);
    var def_21 = new EditorDefinition(tmp_21, null, null, false, false, triggerDependencies_21, btbFindUsagesViews$lambda$lambda_44(init_21));
    $this$findUsagesView.ode(def_21);
    // Inline function 'jetbrains.ocelot.langDef.usages.viewFor' call
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
    var init_22 = btbFindUsagesViews$lambda$lambda_45;
    var triggerDependencies_22 = emptyList();
    var tmp_22 = getKClass(ImportOntologyImportRootUsage);
    var def_22 = new EditorDefinition(tmp_22, null, null, false, false, triggerDependencies_22, btbFindUsagesViews$lambda$lambda_46(init_22));
    $this$findUsagesView.ode(def_22);
    // Inline function 'jetbrains.ocelot.langDef.usages.viewFor' call
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
    var init_23 = btbFindUsagesViews$lambda$lambda_47;
    var triggerDependencies_23 = emptyList();
    var tmp_23 = getKClass(PublishedSourceUsage);
    var def_23 = new EditorDefinition(tmp_23, null, null, false, false, triggerDependencies_23, btbFindUsagesViews$lambda$lambda_48(init_23));
    $this$findUsagesView.ode(def_23);
    // Inline function 'jetbrains.ocelot.langDef.usages.viewFor' call
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
    var init_24 = btbFindUsagesViews$lambda$lambda_49;
    var triggerDependencies_24 = emptyList();
    var tmp_24 = getKClass(TypeOfOldPropertyDeclarationUsage);
    var def_24 = new EditorDefinition(tmp_24, null, null, false, false, triggerDependencies_24, btbFindUsagesViews$lambda$lambda_50(init_24));
    $this$findUsagesView.ode(def_24);
    // Inline function 'jetbrains.ocelot.langDef.usages.viewFor' call
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
    var init_25 = btbFindUsagesViews$lambda$lambda_51;
    var triggerDependencies_25 = emptyList();
    var tmp_25 = getKClass(TypeOfOldLinkDeclarationUsage);
    var def_25 = new EditorDefinition(tmp_25, null, null, false, false, triggerDependencies_25, btbFindUsagesViews$lambda$lambda_52(init_25));
    $this$findUsagesView.ode(def_25);
    // Inline function 'jetbrains.ocelot.langDef.usages.viewFor' call
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
    var init_26 = btbFindUsagesViews$lambda$lambda_53;
    var triggerDependencies_26 = emptyList();
    var tmp_26 = getKClass(OldLinkSpecializesLinkUsage);
    var def_26 = new EditorDefinition(tmp_26, null, null, false, false, triggerDependencies_26, btbFindUsagesViews$lambda$lambda_54(init_26));
    $this$findUsagesView.ode(def_26);
    // Inline function 'jetbrains.ocelot.langDef.usages.viewFor' call
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
    var init_27 = btbFindUsagesViews$lambda$lambda_55;
    var triggerDependencies_27 = emptyList();
    var tmp_27 = getKClass(ObjectPropertyUsageByAnotherProperty);
    var def_27 = new EditorDefinition(tmp_27, null, null, false, false, triggerDependencies_27, btbFindUsagesViews$lambda$lambda_56(init_27));
    $this$findUsagesView.ode(def_27);
    return Unit_instance;
  }
  function btbFindUsagesViews$lambda$lambda($this$viewFor) {
    _init_properties_UsagesView_kt__wok549();
    ontologyRelationUsagePresentation($this$viewFor, getKClass(OntologyIsRelation_1));
    return Unit_instance;
  }
  function btbFindUsagesViews$lambda$lambda_0($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function btbFindUsagesViews$lambda$lambda_1($this$viewFor) {
    _init_properties_UsagesView_kt__wok549();
    ontologyRelationUsagePresentation($this$viewFor, getKClass(OntologyCardinalityRelation_1));
    return Unit_instance;
  }
  function btbFindUsagesViews$lambda$lambda_2($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function btbFindUsagesViews$lambda$lambda_3($this$viewFor) {
    _init_properties_UsagesView_kt__wok549();
    label_0($this$viewFor, 'ontology element');
    space_0($this$viewFor);
    textProperty_0($this$viewFor, '<name>', btbFindUsagesViews$lambda$lambda$lambda);
    space_0($this$viewFor);
    label_0($this$viewFor, '(');
    label_0($this$viewFor, 'is for taxon:');
    space_0($this$viewFor);
    var tmp = getKClass(OntologyElementReferenceProvider);
    child_1($this$viewFor, tmp, btbFindUsagesViews$lambda$lambda$lambda_0($this$viewFor));
    label_0($this$viewFor, ')');
    return Unit_instance;
  }
  function btbFindUsagesViews$lambda$lambda$lambda(it) {
    _init_properties_UsagesView_kt__wok549();
    return it.dmc_1.y2();
  }
  function btbFindUsagesViews$lambda$lambda$lambda_0($this_viewFor) {
    return function (it) {
      return asQProperty($this_viewFor.m6d().emc_1);
    };
  }
  function btbFindUsagesViews$lambda$lambda_4($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function btbFindUsagesViews$lambda$lambda_5($this$viewFor) {
    _init_properties_UsagesView_kt__wok549();
    label_0($this$viewFor, 'category:');
    space_0($this$viewFor);
    var tmp = getKClass(Category_1);
    child_1($this$viewFor, tmp, btbFindUsagesViews$lambda$lambda$lambda_1($this$viewFor));
    return Unit_instance;
  }
  function btbFindUsagesViews$lambda$lambda$lambda_1($this_viewFor) {
    return function (it) {
      return asQProperty($this_viewFor.m6d().gmc_1);
    };
  }
  function btbFindUsagesViews$lambda$lambda_6($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function btbFindUsagesViews$lambda$lambda_7($this$viewFor) {
    _init_properties_UsagesView_kt__wok549();
    label_0($this$viewFor, 'context in fact set');
    label_0($this$viewFor, ':');
    space_0($this$viewFor);
    var tmp = getKClass(Context_2);
    child_1($this$viewFor, tmp, btbFindUsagesViews$lambda$lambda$lambda_2);
    return Unit_instance;
  }
  function btbFindUsagesViews$lambda$lambda$lambda_2(it) {
    _init_properties_UsagesView_kt__wok549();
    return asQProperty(it.jmc_1);
  }
  function btbFindUsagesViews$lambda$lambda_8($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function btbFindUsagesViews$lambda$lambda_9($this$viewFor) {
    _init_properties_UsagesView_kt__wok549();
    label_0($this$viewFor, 'specification of variable');
    space_0($this$viewFor);
    textProperty_0($this$viewFor, '<no name>', btbFindUsagesViews$lambda$lambda$lambda_3);
    label_0($this$viewFor, ':');
    space_0($this$viewFor);
    var tmp = getKClass(VariableSpecification);
    child_1($this$viewFor, tmp, btbFindUsagesViews$lambda$lambda$lambda_4);
    return Unit_instance;
  }
  function btbFindUsagesViews$lambda$lambda$lambda_3(it) {
    _init_properties_UsagesView_kt__wok549();
    return it.kmc_1.y2();
  }
  function btbFindUsagesViews$lambda$lambda$lambda_4(it) {
    _init_properties_UsagesView_kt__wok549();
    return it.kmc_1.ofu();
  }
  function btbFindUsagesViews$lambda$lambda_10($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function btbFindUsagesViews$lambda$lambda_11($this$viewFor) {
    _init_properties_UsagesView_kt__wok549();
    var tmp = getKClass(Fact_1);
    child_1($this$viewFor, tmp, btbFindUsagesViews$lambda$lambda$lambda_5);
    return Unit_instance;
  }
  function btbFindUsagesViews$lambda$lambda$lambda_5(it) {
    _init_properties_UsagesView_kt__wok549();
    return asQProperty(it.lmc_1);
  }
  function btbFindUsagesViews$lambda$lambda_12($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function btbFindUsagesViews$lambda$lambda_13($this$viewFor) {
    _init_properties_UsagesView_kt__wok549();
    label_0($this$viewFor, 'process');
    space_0($this$viewFor);
    textProperty_0($this$viewFor, '<empty>', btbFindUsagesViews$lambda$lambda$lambda_6);
    space_0($this$viewFor);
    label_0($this$viewFor, 'has kind');
    space_0($this$viewFor);
    targetName($this$viewFor, $this$viewFor.m6d().w85().r5a());
    return Unit_instance;
  }
  function btbFindUsagesViews$lambda$lambda$lambda_6(it) {
    _init_properties_UsagesView_kt__wok549();
    return it.w85().y2();
  }
  function btbFindUsagesViews$lambda$lambda_14($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function btbFindUsagesViews$lambda$lambda_15($this$viewFor) {
    _init_properties_UsagesView_kt__wok549();
    label_0($this$viewFor, 'process');
    space_0($this$viewFor);
    textProperty_0($this$viewFor, '<empty>', btbFindUsagesViews$lambda$lambda$lambda_7);
    space_0($this$viewFor);
    label_0($this$viewFor, 'extends');
    space_0($this$viewFor);
    targetName($this$viewFor, $this$viewFor.m6d().w85().pft());
    return Unit_instance;
  }
  function btbFindUsagesViews$lambda$lambda$lambda_7(it) {
    _init_properties_UsagesView_kt__wok549();
    return it.w85().y2();
  }
  function btbFindUsagesViews$lambda$lambda_16($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function btbFindUsagesViews$lambda$lambda_17($this$viewFor) {
    _init_properties_UsagesView_kt__wok549();
    label_0($this$viewFor, 'in ' + get_declarationKindName($this$viewFor.m6d().w85()));
    space_0($this$viewFor);
    textProperty_0($this$viewFor, '<empty>', btbFindUsagesViews$lambda$lambda$lambda_8);
    space_0($this$viewFor);
    label_0($this$viewFor, 'ontology:');
    space_0($this$viewFor);
    var tmp = getKClass(OntologyElementType_1);
    child_1($this$viewFor, tmp, btbFindUsagesViews$lambda$lambda$lambda_9);
    return Unit_instance;
  }
  function btbFindUsagesViews$lambda$lambda$lambda_8(it) {
    _init_properties_UsagesView_kt__wok549();
    return it.w85().y2();
  }
  function btbFindUsagesViews$lambda$lambda$lambda_9(it) {
    _init_properties_UsagesView_kt__wok549();
    return asQProperty(it.omc_1);
  }
  function btbFindUsagesViews$lambda$lambda_18($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function btbFindUsagesViews$lambda$lambda_19($this$viewFor) {
    _init_properties_UsagesView_kt__wok549();
    label_0($this$viewFor, 'process');
    space_0($this$viewFor);
    textProperty_0($this$viewFor, '<empty>', btbFindUsagesViews$lambda$lambda$lambda_10);
    space_0($this$viewFor);
    label_0($this$viewFor, 'inherits');
    space_0($this$viewFor);
    var tmp = getKClass(ProcessReference_1);
    child_1($this$viewFor, tmp, btbFindUsagesViews$lambda$lambda$lambda_11);
    return Unit_instance;
  }
  function btbFindUsagesViews$lambda$lambda$lambda_10(it) {
    _init_properties_UsagesView_kt__wok549();
    return it.w85().y2();
  }
  function btbFindUsagesViews$lambda$lambda$lambda_11(it) {
    _init_properties_UsagesView_kt__wok549();
    return asQProperty(it.smc_1);
  }
  function btbFindUsagesViews$lambda$lambda_20($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function btbFindUsagesViews$lambda$lambda_21($this$viewFor) {
    _init_properties_UsagesView_kt__wok549();
    label_0($this$viewFor, 'in custom editor of ' + get_declarationKindName($this$viewFor.m6d().w85()));
    space_0($this$viewFor);
    textProperty_0($this$viewFor, '<empty>', btbFindUsagesViews$lambda$lambda$lambda_12);
    label_0($this$viewFor, ':');
    space_0($this$viewFor);
    var tmp = getKClass(CustomCell);
    child_1($this$viewFor, tmp, btbFindUsagesViews$lambda$lambda$lambda_13);
    return Unit_instance;
  }
  function btbFindUsagesViews$lambda$lambda$lambda_12(it) {
    _init_properties_UsagesView_kt__wok549();
    return it.w85().y2();
  }
  function btbFindUsagesViews$lambda$lambda$lambda_13(it) {
    _init_properties_UsagesView_kt__wok549();
    return asQProperty(it.umc_1);
  }
  function btbFindUsagesViews$lambda$lambda_22($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function btbFindUsagesViews$lambda$lambda_23($this$viewFor) {
    _init_properties_UsagesView_kt__wok549();
    label_0($this$viewFor, 'in ' + get_declarationKindName($this$viewFor.m6d().vmc_1) + ' ');
    textProperty_0($this$viewFor, '<empty>', btbFindUsagesViews$lambda$lambda$lambda_14);
    label_0($this$viewFor, ' property ');
    textProperty_0($this$viewFor, '<empty>', btbFindUsagesViews$lambda$lambda$lambda_15);
    label_0($this$viewFor, ' aliases ');
    var tmp = getKClass(ProcessPropertyReference);
    child_1($this$viewFor, tmp, btbFindUsagesViews$lambda$lambda$lambda_16);
    return Unit_instance;
  }
  function btbFindUsagesViews$lambda$lambda$lambda_14(it) {
    _init_properties_UsagesView_kt__wok549();
    return it.vmc_1.y2();
  }
  function btbFindUsagesViews$lambda$lambda$lambda_15(it) {
    _init_properties_UsagesView_kt__wok549();
    return it.wmc_1.y2();
  }
  function btbFindUsagesViews$lambda$lambda$lambda_16(it) {
    _init_properties_UsagesView_kt__wok549();
    return asQProperty(it.xmc_1);
  }
  function btbFindUsagesViews$lambda$lambda_24($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function btbFindUsagesViews$lambda$lambda_25($this$viewFor) {
    _init_properties_UsagesView_kt__wok549();
    label_0($this$viewFor, 'in ' + get_declarationKindName($this$viewFor.m6d().ymc_1));
    space_0($this$viewFor);
    textProperty_0($this$viewFor, '<empty>', btbFindUsagesViews$lambda$lambda$lambda_17);
    space_0($this$viewFor);
    label_0($this$viewFor, 'property');
    space_0($this$viewFor);
    textProperty_0($this$viewFor, '<empty>', btbFindUsagesViews$lambda$lambda$lambda_18);
    space_0($this$viewFor);
    label_0($this$viewFor, 'has type');
    space_0($this$viewFor);
    var tmp = getKClass(ProcessPropertyValueRange);
    child_1($this$viewFor, tmp, btbFindUsagesViews$lambda$lambda$lambda_19);
    return Unit_instance;
  }
  function btbFindUsagesViews$lambda$lambda$lambda_17(it) {
    _init_properties_UsagesView_kt__wok549();
    return it.ymc_1.y2();
  }
  function btbFindUsagesViews$lambda$lambda$lambda_18(it) {
    _init_properties_UsagesView_kt__wok549();
    return it.zmc_1.y2();
  }
  function btbFindUsagesViews$lambda$lambda$lambda_19(it) {
    _init_properties_UsagesView_kt__wok549();
    return it.zmc_1.sfq();
  }
  function btbFindUsagesViews$lambda$lambda_26($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function btbFindUsagesViews$lambda$lambda_27($this$viewFor) {
    _init_properties_UsagesView_kt__wok549();
    label_0($this$viewFor, 'in ' + get_declarationKindName($this$viewFor.m6d().w85()));
    space_0($this$viewFor);
    textProperty_0($this$viewFor, '<empty>', btbFindUsagesViews$lambda$lambda$lambda_20);
    space_0($this$viewFor);
    label_0($this$viewFor, 'property');
    space_0($this$viewFor);
    textProperty_0($this$viewFor, '<empty>', btbFindUsagesViews$lambda$lambda$lambda_21);
    space_0($this$viewFor);
    label_0($this$viewFor, 'has type');
    space_0($this$viewFor);
    var tmp = getKClass(NotionType_0);
    child_1($this$viewFor, tmp, btbFindUsagesViews$lambda$lambda$lambda_22);
    return Unit_instance;
  }
  function btbFindUsagesViews$lambda$lambda$lambda_20(it) {
    _init_properties_UsagesView_kt__wok549();
    return it.w85().y2();
  }
  function btbFindUsagesViews$lambda$lambda$lambda_21(it) {
    _init_properties_UsagesView_kt__wok549();
    return it.bmd_1.y2();
  }
  function btbFindUsagesViews$lambda$lambda$lambda_22(it) {
    _init_properties_UsagesView_kt__wok549();
    return it.bmd_1.sfq();
  }
  function btbFindUsagesViews$lambda$lambda_28($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function btbFindUsagesViews$lambda$lambda_29($this$viewFor) {
    _init_properties_UsagesView_kt__wok549();
    label_0($this$viewFor, 'in ' + get_declarationKindName($this$viewFor.m6d().w85()));
    space_0($this$viewFor);
    textProperty_0($this$viewFor, '<empty>', btbFindUsagesViews$lambda$lambda$lambda_23);
    space_0($this$viewFor);
    label_0($this$viewFor, 'link');
    space_0($this$viewFor);
    textProperty_0($this$viewFor, '<empty>', btbFindUsagesViews$lambda$lambda$lambda_24);
    space_0($this$viewFor);
    label_0($this$viewFor, 'has type');
    space_0($this$viewFor);
    var tmp = getKClass(OntologyElementType_1);
    child_1($this$viewFor, tmp, btbFindUsagesViews$lambda$lambda$lambda_25);
    return Unit_instance;
  }
  function btbFindUsagesViews$lambda$lambda$lambda_23(it) {
    _init_properties_UsagesView_kt__wok549();
    return it.w85().y2();
  }
  function btbFindUsagesViews$lambda$lambda$lambda_24(it) {
    _init_properties_UsagesView_kt__wok549();
    return it.dmd_1.y2();
  }
  function btbFindUsagesViews$lambda$lambda$lambda_25(it) {
    _init_properties_UsagesView_kt__wok549();
    return it.dmd_1.sfq();
  }
  function btbFindUsagesViews$lambda$lambda_30($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function btbFindUsagesViews$lambda$lambda_31($this$viewFor) {
    _init_properties_UsagesView_kt__wok549();
    label_0($this$viewFor, 'function');
    space_0($this$viewFor);
    textProperty_0($this$viewFor, '<empty>', btbFindUsagesViews$lambda$lambda$lambda_26);
    space_0($this$viewFor);
    label_0($this$viewFor, 'has return type:');
    space_0($this$viewFor);
    var tmp = getKClass(OntologyElementType_1);
    child_1($this$viewFor, tmp, btbFindUsagesViews$lambda$lambda$lambda_27);
    return Unit_instance;
  }
  function btbFindUsagesViews$lambda$lambda$lambda_26(it) {
    _init_properties_UsagesView_kt__wok549();
    return it.emd_1.y2();
  }
  function btbFindUsagesViews$lambda$lambda$lambda_27(it) {
    _init_properties_UsagesView_kt__wok549();
    return it.emd_1.gfr();
  }
  function btbFindUsagesViews$lambda$lambda_32($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function btbFindUsagesViews$lambda$lambda_33($this$viewFor) {
    _init_properties_UsagesView_kt__wok549();
    label_0($this$viewFor, 'in ' + get_declarationKindName($this$viewFor.m6d().w85()));
    space_0($this$viewFor);
    textProperty_0($this$viewFor, '<empty>', btbFindUsagesViews$lambda$lambda$lambda_28);
    space_0($this$viewFor);
    label_0($this$viewFor, 'imported property');
    space_0($this$viewFor);
    var tmp = getKClass(ImportedProperty_1);
    child_1($this$viewFor, tmp, btbFindUsagesViews$lambda$lambda$lambda_29);
    return Unit_instance;
  }
  function btbFindUsagesViews$lambda$lambda$lambda_28(it) {
    _init_properties_UsagesView_kt__wok549();
    return it.w85().y2();
  }
  function btbFindUsagesViews$lambda$lambda$lambda_29(it) {
    _init_properties_UsagesView_kt__wok549();
    return asQProperty(it.hmd_1);
  }
  function btbFindUsagesViews$lambda$lambda_34($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function btbFindUsagesViews$lambda$lambda_35($this$viewFor) {
    _init_properties_UsagesView_kt__wok549();
    label_0($this$viewFor, 'in ' + get_declarationKindName($this$viewFor.m6d().w85()));
    space_0($this$viewFor);
    textProperty_0($this$viewFor, '<empty>', btbFindUsagesViews$lambda$lambda$lambda_30);
    space_0($this$viewFor);
    label_0($this$viewFor, 'imported link');
    space_0($this$viewFor);
    var tmp = getKClass(ImportedLink_1);
    child_1($this$viewFor, tmp, btbFindUsagesViews$lambda$lambda$lambda_31);
    return Unit_instance;
  }
  function btbFindUsagesViews$lambda$lambda$lambda_30(it) {
    _init_properties_UsagesView_kt__wok549();
    return it.w85().y2();
  }
  function btbFindUsagesViews$lambda$lambda$lambda_31(it) {
    _init_properties_UsagesView_kt__wok549();
    return asQProperty(it.jmd_1);
  }
  function btbFindUsagesViews$lambda$lambda_36($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function btbFindUsagesViews$lambda$lambda_37($this$viewFor) {
    _init_properties_UsagesView_kt__wok549();
    ontologyImportUsage($this$viewFor);
    return Unit_instance;
  }
  function btbFindUsagesViews$lambda$lambda_38($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function btbFindUsagesViews$lambda$lambda_39($this$viewFor) {
    _init_properties_UsagesView_kt__wok549();
    ontologyImportUsage($this$viewFor);
    return Unit_instance;
  }
  function btbFindUsagesViews$lambda$lambda_40($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function btbFindUsagesViews$lambda$lambda_41($this$viewFor) {
    _init_properties_UsagesView_kt__wok549();
    label_0($this$viewFor, 'extension');
    space_0($this$viewFor);
    textProperty_0($this$viewFor, '<no name>', btbFindUsagesViews$lambda$lambda$lambda_32);
    space_0($this$viewFor);
    label_0($this$viewFor, 'for');
    space_0($this$viewFor);
    var tmp = getKClass(OntologyElementType_1);
    child_1($this$viewFor, tmp, btbFindUsagesViews$lambda$lambda$lambda_33);
    return Unit_instance;
  }
  function btbFindUsagesViews$lambda$lambda$lambda_32(it) {
    _init_properties_UsagesView_kt__wok549();
    return it.pmd_1.y2();
  }
  function btbFindUsagesViews$lambda$lambda$lambda_33(it) {
    _init_properties_UsagesView_kt__wok549();
    return it.pmd_1.sfq();
  }
  function btbFindUsagesViews$lambda$lambda_42($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function btbFindUsagesViews$lambda$lambda_43($this$viewFor) {
    _init_properties_UsagesView_kt__wok549();
    label_0($this$viewFor, 'field of extension');
    space_0($this$viewFor);
    textProperty_0($this$viewFor, '<no name>', btbFindUsagesViews$lambda$lambda$lambda_34);
    label_0($this$viewFor, ': ');
    var tmp = getKClass(FieldDeclaration_1);
    child_1($this$viewFor, tmp, btbFindUsagesViews$lambda$lambda$lambda_35);
    return Unit_instance;
  }
  function btbFindUsagesViews$lambda$lambda$lambda_34(it) {
    _init_properties_UsagesView_kt__wok549();
    return it.rmd_1.y2();
  }
  function btbFindUsagesViews$lambda$lambda$lambda_35(it) {
    _init_properties_UsagesView_kt__wok549();
    return asQProperty(it.smd_1);
  }
  function btbFindUsagesViews$lambda$lambda_44($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function btbFindUsagesViews$lambda$lambda_45($this$viewFor) {
    _init_properties_UsagesView_kt__wok549();
    var tmp = getKClass(OntologyImportRootReference_1);
    child_1($this$viewFor, tmp, btbFindUsagesViews$lambda$lambda$lambda_36);
    return Unit_instance;
  }
  function btbFindUsagesViews$lambda$lambda$lambda_36(it) {
    _init_properties_UsagesView_kt__wok549();
    return asQProperty(it.umd_1);
  }
  function btbFindUsagesViews$lambda$lambda_46($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function btbFindUsagesViews$lambda$lambda_47($this$viewFor) {
    _init_properties_UsagesView_kt__wok549();
    label_0($this$viewFor, 'published source:');
    space_0($this$viewFor);
    textProperty_0($this$viewFor, '<no data>', btbFindUsagesViews$lambda$lambda$lambda_37);
    return Unit_instance;
  }
  function btbFindUsagesViews$lambda$lambda$lambda_37(it) {
    _init_properties_UsagesView_kt__wok549();
    return asQProperty_0(it.vmd_1.li1());
  }
  function btbFindUsagesViews$lambda$lambda_48($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function btbFindUsagesViews$lambda$lambda_49($this$viewFor) {
    _init_properties_UsagesView_kt__wok549();
    var tmp = getKClass(PropertyDeclaration_1);
    child_1($this$viewFor, tmp, btbFindUsagesViews$lambda$lambda$lambda_38);
    return Unit_instance;
  }
  function btbFindUsagesViews$lambda$lambda$lambda_38(it) {
    _init_properties_UsagesView_kt__wok549();
    return asQProperty(it.wmd_1);
  }
  function btbFindUsagesViews$lambda$lambda_50($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function btbFindUsagesViews$lambda$lambda_51($this$viewFor) {
    _init_properties_UsagesView_kt__wok549();
    var tmp = getKClass(LinkDeclaration_1);
    child_1($this$viewFor, tmp, btbFindUsagesViews$lambda$lambda$lambda_39);
    return Unit_instance;
  }
  function btbFindUsagesViews$lambda$lambda$lambda_39(it) {
    _init_properties_UsagesView_kt__wok549();
    return asQProperty(it.xmd_1);
  }
  function btbFindUsagesViews$lambda$lambda_52($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function btbFindUsagesViews$lambda$lambda_53($this$viewFor) {
    _init_properties_UsagesView_kt__wok549();
    label_0($this$viewFor, 'specializes:');
    space_0($this$viewFor);
    var tmp = getKClass(AbstractLink);
    child_1($this$viewFor, tmp, btbFindUsagesViews$lambda$lambda$lambda_40);
    return Unit_instance;
  }
  function btbFindUsagesViews$lambda$lambda$lambda_40(it) {
    _init_properties_UsagesView_kt__wok549();
    return asQProperty(it.zmd_1);
  }
  function btbFindUsagesViews$lambda$lambda_54($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function btbFindUsagesViews$lambda$lambda_55($this$viewFor) {
    _init_properties_UsagesView_kt__wok549();
    var tmp;
    switch ($this$viewFor.m6d().bme_1.x2_1) {
      case 0:
        tmp = 'super property of';
        break;
      case 1:
        tmp = 'inverse property of';
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    var text = tmp;
    label_0($this$viewFor, text);
    space_0($this$viewFor);
    textProperty_0($this$viewFor, '<no name>', btbFindUsagesViews$lambda$lambda$lambda_41);
    return Unit_instance;
  }
  function btbFindUsagesViews$lambda$lambda$lambda_41(it) {
    _init_properties_UsagesView_kt__wok549();
    return it.ame_1.y2();
  }
  function btbFindUsagesViews$lambda$lambda_56($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_79().u5u_1.z5v(Unit_instance);
    };
  }
  function ontologyRelationUsagePresentation$lambda(it) {
    _init_properties_UsagesView_kt__wok549();
    return it.w85().y2();
  }
  function ontologyRelationUsagePresentation$lambda_0($this_ontologyRelationUsagePresentation) {
    return function (it) {
      var tmp = $this_ontologyRelationUsagePresentation.m6d().zmb();
      return asQProperty(isInterface(tmp, AbstractOntologyRelation) ? tmp : THROW_CCE());
    };
  }
  function $runSuspendCOROUTINE$_144(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.aui_1 = _this__u8e3s4;
    this.bui_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$_144).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.cui_1 = this.bui_1;
            this.f9_1 = 1;
            suspendResult = this.cui_1.k60(this.aui_1.dui_1.w6o(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp0_safe_receiver = suspendResult;
            var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : this.cui_1.l60(tmp0_safe_receiver.y2());
            var name = tmp1_elvis_lhs == null ? '<no name>' : tmp1_elvis_lhs;
            label_0(this.aui_1.eui_1, name);
            return Unit_instance;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function targetName$2$$inlined$executeSuspendingQuery$1($reference, $this_targetName) {
    this.dui_1 = $reference;
    this.eui_1 = $this_targetName;
  }
  protoOf(targetName$2$$inlined$executeSuspendingQuery$1).b61 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$_144(this, builder, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(targetName$2$$inlined$executeSuspendingQuery$1).r5w = function (builder, $completion) {
    return this.b61(builder, $completion);
  };
  function targetName$slambda($reference, $this_targetName, resultContinuation) {
    this.nui_1 = $reference;
    this.oui_1 = $this_targetName;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(targetName$slambda).e1h = function ($this$launchWith, $completion) {
    var tmp = this.f1h($this$launchWith, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(targetName$slambda).v9 = function (p1, $completion) {
    return this.e1h((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(targetName$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = execute_1(new targetName$2$$inlined$executeSuspendingQuery$1(this.nui_1, this.oui_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(targetName$slambda).f1h = function ($this$launchWith, completion) {
    var i = new targetName$slambda(this.nui_1, this.oui_1, completion);
    i.pui_1 = $this$launchWith;
    return i;
  };
  function targetName$slambda_0($reference, $this_targetName, resultContinuation) {
    var i = new targetName$slambda($reference, $this_targetName, resultContinuation);
    var l = function ($this$launchWith, $completion) {
      return i.e1h($this$launchWith, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function ontologyImportUsage$lambda(it) {
    _init_properties_UsagesView_kt__wok549();
    return asQProperty(it.w85());
  }
  var properties_initialized_UsagesView_kt_ygco2v;
  function _init_properties_UsagesView_kt__wok549() {
    if (!properties_initialized_UsagesView_kt_ygco2v) {
      properties_initialized_UsagesView_kt_ygco2v = true;
      btbFindUsagesViews = findUsagesView(btbFindUsagesViews$lambda);
    }
  }
  function FindUsagePageEntryAdapter(entry) {
    this.document = entry.document;
    this.nodes = new PagedAdapter(entry.nodes);
  }
  protoOf(FindUsagePageEntryAdapter).k8f = function () {
    return this.document;
  };
  protoOf(FindUsagePageEntryAdapter).f3o = function () {
    return this.nodes;
  };
  function FindUsagePagedAdapter$_init_$lambda_ubivdj(it) {
    return new FindUsagePageEntryAdapter(it);
  }
  function FindUsagePagedAdapter$totalNodes$slambda($paged, resultContinuation) {
    this.yui_1 = $paged;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(FindUsagePagedAdapter$totalNodes$slambda).auj = function ($this$promise, $completion) {
    var tmp = this.f1h($this$promise, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(FindUsagePagedAdapter$totalNodes$slambda).v9 = function (p1, $completion) {
    return this.auj((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(FindUsagePagedAdapter$totalNodes$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.yui_1.totalNodes(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(FindUsagePagedAdapter$totalNodes$slambda).f1h = function ($this$promise, completion) {
    var i = new FindUsagePagedAdapter$totalNodes$slambda(this.yui_1, completion);
    i.zui_1 = $this$promise;
    return i;
  };
  function FindUsagePagedAdapter$totalNodes$slambda_0($paged, resultContinuation) {
    var i = new FindUsagePagedAdapter$totalNodes$slambda($paged, resultContinuation);
    var l = function ($this$promise, $completion) {
      return i.auj($this$promise, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function FindUsagePagedAdapter(paged) {
    PagedAdapter.call(this, map_4(paged, FindUsagePagedAdapter$_init_$lambda_ubivdj));
    var tmp = this;
    var tmp_0 = CoroutineScope_0(Dispatchers_getInstance().uz_1);
    tmp.totalNodes = promise(tmp_0, VOID, VOID, FindUsagePagedAdapter$totalNodes$slambda_0(paged, null));
  }
  protoOf(FindUsagePagedAdapter).vs8 = function () {
    return this.totalNodes;
  };
  function HtmlNodeEditorView$_init_$lambda_e3k2b0(_this__u8e3s4) {
    return Unit_instance;
  }
  function HtmlNodeEditorView$attach$$inlined$toDisposable$1($cellContainerToDomMapper) {
    this.euj_1 = $cellContainerToDomMapper;
  }
  protoOf(HtmlNodeEditorView$attach$$inlined$toDisposable$1).zr = function () {
    this.euj_1.k89();
    return Unit_instance;
  };
  function HtmlNodeEditorView(element, domConfig, highlightLine) {
    var tmp;
    if (domConfig === VOID) {
      tmp = HtmlNodeEditorView$_init_$lambda_e3k2b0;
    } else {
      tmp = domConfig;
    }
    domConfig = tmp;
    highlightLine = highlightLine === VOID ? false : highlightLine;
    this.fuj_1 = element;
    this.guj_1 = domConfig;
    this.huj_1 = highlightLine;
  }
  protoOf(HtmlNodeEditorView).xtf = function (container) {
    var config = new CellToDomConfig();
    config.abn(true);
    // Inline function 'kotlin.apply' call
    var this_0 = new CellToDomConfig();
    this.guj_1(this_0);
    if (this.huj_1) {
      this_0.cbn(new DefaultLineHighlight(container.z92()));
    }
    var cellContainerToDomMapper = new CellContainerToDomMapper(container, this.fuj_1, this_0);
    cellContainerToDomMapper.j89();
    // Inline function 'jetbrains.ocelot.base.disposable.toDisposable' call
    return new HtmlNodeEditorView$attach$$inlined$toDisposable$1(cellContainerToDomMapper);
  };
  function closeWorkingCopiesOf($this, _this__u8e3s4, accession) {
    _this__u8e3s4.xt6(NodeEditorAdapter$closeWorkingCopiesOf$lambda($this, accession));
  }
  function closeWorkingCopiesAndLatestPublishedOf($this, _this__u8e3s4, accession) {
    _this__u8e3s4.xt6(NodeEditorAdapter$closeWorkingCopiesAndLatestPublishedOf$lambda($this, accession));
  }
  function workingCopy($this, descriptor, accession) {
    return descriptor.accession === accession && !(get_pointer_0(descriptor) == null);
  }
  function latestPublished($this, descriptor, accession) {
    return descriptor.accession === accession && get_pointer_0(descriptor) == null && descriptor.revision == null && descriptor.globalVersion == null;
  }
  function NodeEditorAdapter$open$slambda(this$0, $source, resultContinuation) {
    this.quj_1 = this$0;
    this.ruj_1 = $source;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(NodeEditorAdapter$open$slambda).e1h = function ($this$promise, $completion) {
    var tmp = this.f1h($this$promise, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(NodeEditorAdapter$open$slambda).v9 = function (p1, $completion) {
    return this.e1h((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(NodeEditorAdapter$open$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            var tmp_0;
            var tmp_1 = this.quj_1.tuj_1;
            if (isInterface(tmp_1, CachingNodeEditor)) {
              var tmp_2 = this.ruj_1;
              tmp_0 = tmp_2 instanceof EditedDocumentSource;
            } else {
              tmp_0 = false;
            }

            if (tmp_0) {
              closeWorkingCopiesOf(this.quj_1, this.quj_1.tuj_1, this.ruj_1.descriptor.accession);
            }

            this.f9_1 = 1;
            suspendResult = this.quj_1.tuj_1.rt9(this.ruj_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(NodeEditorAdapter$open$slambda).f1h = function ($this$promise, completion) {
    var i = new NodeEditorAdapter$open$slambda(this.quj_1, this.ruj_1, completion);
    i.suj_1 = $this$promise;
    return i;
  };
  function NodeEditorAdapter$open$slambda_0(this$0, $source, resultContinuation) {
    var i = new NodeEditorAdapter$open$slambda(this$0, $source, resultContinuation);
    var l = function ($this$promise, $completion) {
      return i.e1h($this$promise, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function NodeEditorAdapter$closeWorkingCopiesOf$lambda(this$0, $accession) {
    return function (cacheKey) {
      return workingCopy(this$0, cacheKey, $accession);
    };
  }
  function NodeEditorAdapter$closeWorkingCopiesAndLatestPublishedOf$lambda(this$0, $accession) {
    return function (cacheKey) {
      return workingCopy(this$0, cacheKey, $accession) || latestPublished(this$0, cacheKey, $accession);
    };
  }
  function NodeEditorAdapter(editor) {
    this.tuj_1 = editor;
  }
  protoOf(NodeEditorAdapter).subscribe = function (type, listener) {
    return asUnsubscribeFn(this.tuj_1.bt7(type, listener));
  };
  protoOf(NodeEditorAdapter).onClick = function (nodeEditorPart, listener) {
    return asUnsubscribeFn(this.tuj_1.ct7(nodeEditorPart, listener));
  };
  protoOf(NodeEditorAdapter).select = function (nodeId) {
    this.tuj_1.yt6(nodeId);
  };
  protoOf(NodeEditorAdapter).deselectAllFacts = function () {
    this.tuj_1.at7();
  };
  protoOf(NodeEditorAdapter).highlight = function (nodeEditorPart) {
    return asUnsubscribeFn(this.tuj_1.zt6(nodeEditorPart));
  };
  protoOf(NodeEditorAdapter).open = function (source) {
    var tmp = CoroutineScope_0(Dispatchers_getInstance().uz_1);
    return promise(tmp, VOID, VOID, NodeEditorAdapter$open$slambda_0(this, source, null));
  };
  protoOf(NodeEditorAdapter).published = function (docAccession) {
    var tmp = this.tuj_1;
    if (isInterface(tmp, CachingNodeEditor)) {
      closeWorkingCopiesAndLatestPublishedOf(this, this.tuj_1, docAccession);
    }
  };
  protoOf(NodeEditorAdapter).dispose = function () {
    this.tuj_1.zr();
  };
  function PageAdapter(page) {
    var tmp = this;
    // Inline function 'kotlin.collections.toTypedArray' call
    var this_0 = page.data;
    tmp.data = copyToArray(this_0);
    this.hasNextPage = page.hasNextPage;
  }
  protoOf(PageAdapter).lfs = function () {
    return this.data;
  };
  protoOf(PageAdapter).gsc = function () {
    return this.hasNextPage;
  };
  function PagedAdapter$total$slambda(this$0, resultContinuation) {
    this.cuk_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(PagedAdapter$total$slambda).auj = function ($this$promise, $completion) {
    var tmp = this.f1h($this$promise, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(PagedAdapter$total$slambda).v9 = function (p1, $completion) {
    return this.auj((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(PagedAdapter$total$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = this.cuk_1.cuj_1.hs9(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(PagedAdapter$total$slambda).f1h = function ($this$promise, completion) {
    var i = new PagedAdapter$total$slambda(this.cuk_1, completion);
    i.duk_1 = $this$promise;
    return i;
  };
  function PagedAdapter$total$slambda_0(this$0, resultContinuation) {
    var i = new PagedAdapter$total$slambda(this$0, resultContinuation);
    var l = function ($this$promise, $completion) {
      return i.auj($this$promise, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function PagedAdapter$nextPage$slambda(this$0, resultContinuation) {
    this.muk_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(PagedAdapter$nextPage$slambda).ouk = function ($this$promise, $completion) {
    var tmp = this.f1h($this$promise, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(PagedAdapter$nextPage$slambda).v9 = function (p1, $completion) {
    return this.ouk((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(PagedAdapter$nextPage$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = nextPage(this.muk_1.cuj_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            return new PageAdapter(ARGUMENT);
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(PagedAdapter$nextPage$slambda).f1h = function ($this$promise, completion) {
    var i = new PagedAdapter$nextPage$slambda(this.muk_1, completion);
    i.nuk_1 = $this$promise;
    return i;
  };
  function PagedAdapter$nextPage$slambda_0(this$0, resultContinuation) {
    var i = new PagedAdapter$nextPage$slambda(this$0, resultContinuation);
    var l = function ($this$promise, $completion) {
      return i.ouk($this$promise, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function PagedAdapter(paged) {
    this.cuj_1 = paged;
    var tmp = this;
    var tmp_0 = CoroutineScope_0(Dispatchers_getInstance().uz_1);
    tmp.total = promise(tmp_0, VOID, VOID, PagedAdapter$total$slambda_0(this, null));
  }
  protoOf(PagedAdapter).duj = function () {
    return this.total;
  };
  protoOf(PagedAdapter).z2h = function () {
    return new PageAdapter(this.cuj_1.z2h());
  };
  protoOf(PagedAdapter).nextPage = function () {
    var tmp = CoroutineScope_0(Dispatchers_getInstance().uz_1);
    return promise(tmp, VOID, VOID, PagedAdapter$nextPage$slambda_0(this, null));
  };
  function navigateToUrl(url) {
    window.open(url);
  }
  function asUnsubscribeFn(_this__u8e3s4) {
    return Disposable$dispose$ref_0(_this__u8e3s4);
  }
  function Disposable$dispose$ref_0(p0) {
    var l = function () {
      p0.zr();
      return Unit_instance;
    };
    l.callableName = 'dispose';
    return l;
  }
  function get_websocketFactory() {
    _init_properties_JsPlatform_kt__dfptms();
    return websocketFactory;
  }
  var websocketFactory;
  var properties_initialized_JsPlatform_kt_vdfp0e;
  function _init_properties_JsPlatform_kt__dfptms() {
    if (!properties_initialized_JsPlatform_kt_vdfp0e) {
      properties_initialized_JsPlatform_kt_vdfp0e = true;
      websocketFactory = new JsWebsocketFactory();
    }
  }
  function extensions(format) {
    // Inline function 'kotlin.collections.mapNotNull' call
    var tmp0 = get_providers();
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var destination = ArrayList_init_$Create$();
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = tmp0.m();
    while (_iterator__ex2g4s.n()) {
      var element = _iterator__ex2g4s.o();
      var tmp0_safe_receiver = element.puk(format);
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        destination.j(tmp0_safe_receiver);
      }
    }
    return destination;
  }
  function serialization_1(_this__u8e3s4, contentType, format) {
    _this__u8e3s4.jr8(contentType, new KotlinxSerializationConverter(format));
  }
  function KotlinxSerializationConverter$serializeNullable$o$collect$slambda($$this$unsafeFlow, $contentType, $charset, $typeInfo, $value, resultContinuation) {
    this.yuk_1 = $$this$unsafeFlow;
    this.zuk_1 = $contentType;
    this.aul_1 = $charset;
    this.bul_1 = $typeInfo;
    this.cul_1 = $value;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(KotlinxSerializationConverter$serializeNullable$o$collect$slambda).f1q = function (value, $completion) {
    var tmp = this.g1q(value, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(KotlinxSerializationConverter$serializeNullable$o$collect$slambda).v9 = function (p1, $completion) {
    return this.f1q((p1 == null ? true : !(p1 == null)) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(KotlinxSerializationConverter$serializeNullable$o$collect$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 3;
            var tmp0 = this.yuk_1;
            var tmp2 = this.dul_1;
            this.eul_1 = tmp0;
            this.f9_1 = 1;
            suspendResult = tmp2.ful(this.zuk_1, this.aul_1, this.bul_1, this.cul_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            this.f9_1 = 2;
            suspendResult = this.eul_1.x18(ARGUMENT, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 3) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(KotlinxSerializationConverter$serializeNullable$o$collect$slambda).g1q = function (value, completion) {
    var i = new KotlinxSerializationConverter$serializeNullable$o$collect$slambda(this.yuk_1, this.zuk_1, this.aul_1, this.bul_1, this.cul_1, completion);
    i.dul_1 = value;
    return i;
  };
  function KotlinxSerializationConverter$serializeNullable$o$collect$slambda_0($$this$unsafeFlow, $contentType, $charset, $typeInfo, $value, resultContinuation) {
    var i = new KotlinxSerializationConverter$serializeNullable$o$collect$slambda($$this$unsafeFlow, $contentType, $charset, $typeInfo, $value, resultContinuation);
    var l = function (value, $completion) {
      return i.f1q(value, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function $collectCOROUTINE$_26(_this__u8e3s4, collector, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.oul_1 = _this__u8e3s4;
    this.pul_1 = collector;
  }
  protoOf($collectCOROUTINE$_26).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            var $this$unsafeFlow = this.pul_1;
            this.f9_1 = 1;
            var tmp_0 = KotlinxSerializationConverter$serializeNullable$o$collect$slambda_0($this$unsafeFlow, this.oul_1.rul_1, this.oul_1.sul_1, this.oul_1.tul_1, this.oul_1.uul_1, null);
            suspendResult = this.oul_1.qul_1.f18(new sam$kotlinx_coroutines_flow_FlowCollector$0_25(tmp_0), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function KotlinxSerializationConverter$deserialize$o$collect$slambda($$this$unsafeFlow, $charset, $typeInfo, $content, resultContinuation) {
    this.dum_1 = $$this$unsafeFlow;
    this.eum_1 = $charset;
    this.fum_1 = $typeInfo;
    this.gum_1 = $content;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(KotlinxSerializationConverter$deserialize$o$collect$slambda).f1q = function (value, $completion) {
    var tmp = this.g1q(value, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(KotlinxSerializationConverter$deserialize$o$collect$slambda).v9 = function (p1, $completion) {
    return this.f1q((p1 == null ? true : !(p1 == null)) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(KotlinxSerializationConverter$deserialize$o$collect$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 3;
            var tmp0 = this.dum_1;
            var tmp2 = this.hum_1;
            this.ium_1 = tmp0;
            this.f9_1 = 1;
            suspendResult = tmp2.mr8(this.eum_1, this.fum_1, this.gum_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            this.f9_1 = 2;
            suspendResult = this.ium_1.x18(ARGUMENT, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 3) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(KotlinxSerializationConverter$deserialize$o$collect$slambda).g1q = function (value, completion) {
    var i = new KotlinxSerializationConverter$deserialize$o$collect$slambda(this.dum_1, this.eum_1, this.fum_1, this.gum_1, completion);
    i.hum_1 = value;
    return i;
  };
  function KotlinxSerializationConverter$deserialize$o$collect$slambda_0($$this$unsafeFlow, $charset, $typeInfo, $content, resultContinuation) {
    var i = new KotlinxSerializationConverter$deserialize$o$collect$slambda($$this$unsafeFlow, $charset, $typeInfo, $content, resultContinuation);
    var l = function (value, $completion) {
      return i.f1q(value, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function $collectCOROUTINE$_27(_this__u8e3s4, collector, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.rum_1 = _this__u8e3s4;
    this.sum_1 = collector;
  }
  protoOf($collectCOROUTINE$_27).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            var $this$unsafeFlow = this.sum_1;
            this.f9_1 = 1;
            var tmp_0 = KotlinxSerializationConverter$deserialize$o$collect$slambda_0($this$unsafeFlow, this.rum_1.uum_1, this.rum_1.vum_1, this.rum_1.wum_1, null);
            suspendResult = this.rum_1.tum_1.f18(new sam$kotlinx_coroutines_flow_FlowCollector$0_26(tmp_0), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function serializeContent($this, serializer, format, value, contentType, charset) {
    var tmp;
    if (isInterface(format, StringFormat)) {
      var content = format.c5a(isInterface(serializer, KSerializer) ? serializer : THROW_CCE(), value);
      tmp = new TextContent(content, withCharsetIfNeeded(contentType, charset));
    } else {
      if (isInterface(format, BinaryFormat)) {
        var content_0 = format.a5a(isInterface(serializer, KSerializer) ? serializer : THROW_CCE(), value);
        tmp = new ByteArrayContent(content_0, contentType);
      } else {
        var message = 'Unsupported format ' + toString_1(format);
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      }
    }
    return tmp;
  }
  function sam$kotlinx_coroutines_flow_FlowCollector$0_25(function_0) {
    this.xum_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_25).x18 = function (value, $completion) {
    return this.xum_1(value, $completion);
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_25).f3 = function () {
    return this.xum_1;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_25).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, FlowCollector) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_25).hashCode = function () {
    return hashCode(this.f3());
  };
  function sam$kotlinx_coroutines_flow_FlowCollector$0_26(function_0) {
    this.yum_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_26).x18 = function (value, $completion) {
    return this.yum_1(value, $completion);
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_26).f3 = function () {
    return this.yum_1;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_26).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, FlowCollector) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.f3(), other.f3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_26).hashCode = function () {
    return hashCode(this.f3());
  };
  function KotlinxSerializationConverter$serializeNullable$$inlined$map$1($this, $contentType, $charset, $typeInfo, $value) {
    this.qul_1 = $this;
    this.rul_1 = $contentType;
    this.sul_1 = $charset;
    this.tul_1 = $typeInfo;
    this.uul_1 = $value;
  }
  protoOf(KotlinxSerializationConverter$serializeNullable$$inlined$map$1).y18 = function (collector, $completion) {
    var tmp = new $collectCOROUTINE$_26(this, collector, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(KotlinxSerializationConverter$serializeNullable$$inlined$map$1).f18 = function (collector, $completion) {
    return this.y18(collector, $completion);
  };
  function KotlinxSerializationConverter$serializeNullable$slambda(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(KotlinxSerializationConverter$serializeNullable$slambda).iun = function (it, $completion) {
    var tmp = this.jun(it, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(KotlinxSerializationConverter$serializeNullable$slambda).v9 = function (p1, $completion) {
    return this.iun((p1 == null ? true : p1 instanceof OutgoingContent) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(KotlinxSerializationConverter$serializeNullable$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        if (tmp === 0) {
          this.g9_1 = 1;
          return !(this.hun_1 == null);
        } else if (tmp === 1) {
          throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(KotlinxSerializationConverter$serializeNullable$slambda).jun = function (it, completion) {
    var i = new KotlinxSerializationConverter$serializeNullable$slambda(completion);
    i.hun_1 = it;
    return i;
  };
  function KotlinxSerializationConverter$serializeNullable$slambda_0(resultContinuation) {
    var i = new KotlinxSerializationConverter$serializeNullable$slambda(resultContinuation);
    var l = function (it, $completion) {
      return i.iun(it, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function KotlinxSerializationConverter$deserialize$$inlined$map$1($this, $charset, $typeInfo, $content) {
    this.tum_1 = $this;
    this.uum_1 = $charset;
    this.vum_1 = $typeInfo;
    this.wum_1 = $content;
  }
  protoOf(KotlinxSerializationConverter$deserialize$$inlined$map$1).y18 = function (collector, $completion) {
    var tmp = new $collectCOROUTINE$_27(this, collector, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(KotlinxSerializationConverter$deserialize$$inlined$map$1).f18 = function (collector, $completion) {
    return this.y18(collector, $completion);
  };
  function KotlinxSerializationConverter$deserialize$slambda($content, resultContinuation) {
    this.sun_1 = $content;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(KotlinxSerializationConverter$deserialize$slambda).mra = function (it, $completion) {
    var tmp = this.g1q(it, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(KotlinxSerializationConverter$deserialize$slambda).v9 = function (p1, $completion) {
    return this.mra((p1 == null ? true : !(p1 == null)) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(KotlinxSerializationConverter$deserialize$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        if (tmp === 0) {
          this.g9_1 = 1;
          return !(this.tun_1 == null) || this.sun_1.gdh();
        } else if (tmp === 1) {
          throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(KotlinxSerializationConverter$deserialize$slambda).g1q = function (it, completion) {
    var i = new KotlinxSerializationConverter$deserialize$slambda(this.sun_1, completion);
    i.tun_1 = it;
    return i;
  };
  function KotlinxSerializationConverter$deserialize$slambda_0($content, resultContinuation) {
    var i = new KotlinxSerializationConverter$deserialize$slambda($content, resultContinuation);
    var l = function (it, $completion) {
      return i.mra(it, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function $serializeNullableCOROUTINE$(_this__u8e3s4, contentType, charset, typeInfo, value, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.cuo_1 = _this__u8e3s4;
    this.duo_1 = contentType;
    this.euo_1 = charset;
    this.fuo_1 = typeInfo;
    this.guo_1 = value;
  }
  protoOf($serializeNullableCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            var this_0 = asFlow_0(this.cuo_1.iuo_1);
            var tmp_0 = new KotlinxSerializationConverter$serializeNullable$$inlined$map$1(this_0, this.duo_1, this.euo_1, this.fuo_1, this.guo_1);
            suspendResult = firstOrNull_4(tmp_0, KotlinxSerializationConverter$serializeNullable$slambda_0(null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var fromExtension = suspendResult;
            if (!(fromExtension == null))
              return fromExtension;
            var tmp_1;
            try {
              tmp_1 = serializerForTypeInfo(this.cuo_1.huo_1.g59(), this.fuo_1);
            } catch ($p) {
              var tmp_2;
              if ($p instanceof SerializationException) {
                var cause = $p;
                tmp_2 = guessSerializer(this.guo_1, this.cuo_1.huo_1.g59());
              } else {
                throw $p;
              }
              tmp_1 = tmp_2;
            }

            var serializer = tmp_1;
            return serializeContent(this.cuo_1, serializer, this.cuo_1.huo_1, this.guo_1, this.duo_1, this.euo_1);
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function $deserializeCOROUTINE$_0(_this__u8e3s4, charset, typeInfo, content, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.ruo_1 = _this__u8e3s4;
    this.suo_1 = charset;
    this.tuo_1 = typeInfo;
    this.uuo_1 = content;
  }
  protoOf($deserializeCOROUTINE$_0).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 5;
            this.f9_1 = 1;
            var this_0 = asFlow_0(this.ruo_1.iuo_1);
            var tmp_0 = new KotlinxSerializationConverter$deserialize$$inlined$map$1(this_0, this.suo_1, this.tuo_1, this.uuo_1);
            suspendResult = firstOrNull_4(tmp_0, KotlinxSerializationConverter$deserialize$slambda_0(this.uuo_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var fromExtension = suspendResult;
            var tmp_1;
            if (!this.ruo_1.iuo_1.s()) {
              tmp_1 = !(fromExtension == null) || this.uuo_1.gdh();
            } else {
              tmp_1 = false;
            }

            if (tmp_1)
              return fromExtension;
            this.vuo_1 = serializerForTypeInfo(this.ruo_1.huo_1.g59(), this.tuo_1);
            this.f9_1 = 2;
            suspendResult = this.uuo_1.hdm(VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var contentPacket = suspendResult;
            this.g9_1 = 3;
            var tmp0_subject = this.ruo_1.huo_1;
            var tmp_2;
            if (isInterface(tmp0_subject, StringFormat)) {
              tmp_2 = this.ruo_1.huo_1.d5a(this.vuo_1, readText(contentPacket, this.suo_1));
            } else {
              if (isInterface(tmp0_subject, BinaryFormat)) {
                tmp_2 = this.ruo_1.huo_1.b5a(this.vuo_1, readBytes(contentPacket));
              } else {
                discard(contentPacket);
                var message = 'Unsupported format ' + toString_1(this.ruo_1.huo_1);
                throw IllegalStateException_init_$Create$_0(toString_1(message));
              }
            }

            return tmp_2;
          case 3:
            this.g9_1 = 5;
            var tmp_3 = this.i9_1;
            if (tmp_3 instanceof Error) {
              var cause = this.i9_1;
              throw new JsonConvertException('Illegal input: ' + cause.message, cause);
            } else {
              throw this.i9_1;
            }

          case 4:
            this.g9_1 = 5;
            return Unit_instance;
          case 5:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 5) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function KotlinxSerializationConverter(format) {
    this.huo_1 = format;
    this.iuo_1 = extensions(this.huo_1);
    var tmp;
    var tmp_0 = this.huo_1;
    if (isInterface(tmp_0, BinaryFormat)) {
      tmp = true;
    } else {
      var tmp_1 = this.huo_1;
      tmp = isInterface(tmp_1, StringFormat);
    }
    // Inline function 'kotlin.require' call
    if (!tmp) {
      var message = 'Only binary and string formats are supported, ' + toString_1(this.huo_1) + ' is not supported.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
  }
  protoOf(KotlinxSerializationConverter).wuo = function (contentType, charset, typeInfo, value, $completion) {
    return this.xuo(contentType, charset, typeInfo, value, $completion);
  };
  protoOf(KotlinxSerializationConverter).kr8 = function (contentType, charset, typeInfo, value, $completion) {
    return this.wuo(contentType, charset, typeInfo, value, $completion);
  };
  protoOf(KotlinxSerializationConverter).xuo = function (contentType, charset, typeInfo, value, $completion) {
    var tmp = new $serializeNullableCOROUTINE$(this, contentType, charset, typeInfo, value, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(KotlinxSerializationConverter).lr8 = function (contentType, charset, typeInfo, value, $completion) {
    return this.xuo(contentType, charset, typeInfo, value, $completion);
  };
  protoOf(KotlinxSerializationConverter).mr8 = function (charset, typeInfo, content, $completion) {
    var tmp = new $deserializeCOROUTINE$_0(this, charset, typeInfo, content, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  function serializerForTypeInfo(_this__u8e3s4, typeInfo) {
    var module_0 = _this__u8e3s4;
    var tmp0_safe_receiver = typeInfo.ce0_1;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      var tmp_0;
      if (tmp0_safe_receiver.gb().s()) {
        tmp_0 = null;
      } else {
        tmp_0 = serializerOrNull_0(module_0, tmp0_safe_receiver);
      }
      tmp = tmp_0;
    }
    var tmp2_elvis_lhs = tmp;
    var tmp_1;
    if (tmp2_elvis_lhs == null) {
      var tmp1_safe_receiver = module_0.f5a(typeInfo.ae0_1);
      tmp_1 = tmp1_safe_receiver == null ? null : maybeNullable(tmp1_safe_receiver, typeInfo);
    } else {
      tmp_1 = tmp2_elvis_lhs;
    }
    var tmp3_elvis_lhs = tmp_1;
    return tmp3_elvis_lhs == null ? maybeNullable(serializer_1(typeInfo.ae0_1), typeInfo) : tmp3_elvis_lhs;
  }
  function guessSerializer(value, module_0) {
    var tmp;
    if (value == null) {
      tmp = get_nullable(serializer_5(StringCompanionObject_instance));
    } else {
      if (!(value == null) ? isInterface(value, KtList) : false) {
        tmp = ListSerializer(elementSerializer(value, module_0));
      } else {
        if (!(value == null) ? isArray(value) : false) {
          var tmp1_safe_receiver = firstOrNull(value);
          var tmp_0;
          if (tmp1_safe_receiver == null) {
            tmp_0 = null;
          } else {
            // Inline function 'kotlin.let' call
            tmp_0 = guessSerializer(tmp1_safe_receiver, module_0);
          }
          var tmp2_elvis_lhs = tmp_0;
          tmp = tmp2_elvis_lhs == null ? ListSerializer(serializer_5(StringCompanionObject_instance)) : tmp2_elvis_lhs;
        } else {
          if (!(value == null) ? isInterface(value, KtSet) : false) {
            tmp = SetSerializer(elementSerializer(value, module_0));
          } else {
            if (!(value == null) ? isInterface(value, KtMap) : false) {
              var keySerializer = elementSerializer(value.r2(), module_0);
              var valueSerializer = elementSerializer(value.s2(), module_0);
              tmp = MapSerializer(keySerializer, valueSerializer);
            } else {
              var tmp3_elvis_lhs = module_0.f5a(getKClassFromExpression(value));
              tmp = tmp3_elvis_lhs == null ? serializer_1(getKClassFromExpression(value)) : tmp3_elvis_lhs;
            }
          }
        }
      }
    }
    var tmp_1 = tmp;
    return isInterface(tmp_1, KSerializer) ? tmp_1 : THROW_CCE();
  }
  function maybeNullable(_this__u8e3s4, typeInfo) {
    var tmp;
    var tmp0_safe_receiver = typeInfo.ce0_1;
    if ((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.hb()) === true) {
      tmp = get_nullable(_this__u8e3s4);
    } else {
      tmp = _this__u8e3s4;
    }
    return tmp;
  }
  function elementSerializer(_this__u8e3s4, module_0) {
    // Inline function 'kotlin.collections.map' call
    var this_0 = filterNotNull(_this__u8e3s4);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.m();
    while (_iterator__ex2g4s.n()) {
      var item = _iterator__ex2g4s.o();
      var tmp$ret$0 = guessSerializer(item, module_0);
      destination.j(tmp$ret$0);
    }
    // Inline function 'kotlin.collections.distinctBy' call
    var set = HashSet_init_$Create$();
    var list = ArrayList_init_$Create$();
    var _iterator__ex2g4s_0 = destination.m();
    while (_iterator__ex2g4s_0.n()) {
      var e = _iterator__ex2g4s_0.o();
      var key = e.v58().z59();
      if (set.j(key)) {
        list.j(e);
      }
    }
    var serializers = list;
    if (serializers.p() > 1) {
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(serializers, 10));
      var _iterator__ex2g4s_1 = serializers.m();
      while (_iterator__ex2g4s_1.n()) {
        var item_0 = _iterator__ex2g4s_1.o();
        var tmp$ret$5 = item_0.v58().z59();
        destination_0.j(tmp$ret$5);
      }
      // Inline function 'kotlin.error' call
      var message = 'Serializing collections of different element types is not yet supported. ' + ('Selected serializers: ' + toString_1(destination_0));
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    var tmp0_elvis_lhs = singleOrNull(serializers);
    var selected = tmp0_elvis_lhs == null ? serializer_5(StringCompanionObject_instance) : tmp0_elvis_lhs;
    if (selected.v58().i5a()) {
      return selected;
    }
    if (!isInterface(selected, KSerializer))
      THROW_CCE();
    var tmp$ret$8;
    $l$block_0: {
      // Inline function 'kotlin.collections.any' call
      var tmp;
      if (isInterface(_this__u8e3s4, Collection)) {
        tmp = _this__u8e3s4.s();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$8 = false;
        break $l$block_0;
      }
      var _iterator__ex2g4s_2 = _this__u8e3s4.m();
      while (_iterator__ex2g4s_2.n()) {
        var element = _iterator__ex2g4s_2.o();
        if (element == null) {
          tmp$ret$8 = true;
          break $l$block_0;
        }
      }
      tmp$ret$8 = false;
    }
    if (tmp$ret$8) {
      return get_nullable(selected);
    }
    return selected;
  }
  function get_providers() {
    return emptyList();
  }
  function get_DefaultJson() {
    _init_properties_JsonSupport_kt__yf438r();
    return DefaultJson;
  }
  var DefaultJson;
  function json(_this__u8e3s4, json, contentType) {
    json = json === VOID ? get_DefaultJson() : json;
    contentType = contentType === VOID ? Application_getInstance().eqx_1 : contentType;
    _init_properties_JsonSupport_kt__yf438r();
    serialization_1(_this__u8e3s4, contentType, json);
  }
  function DefaultJson$lambda($this$Json) {
    _init_properties_JsonSupport_kt__yf438r();
    $this$Json.d62_1 = true;
    $this$Json.g62_1 = true;
    $this$Json.n62_1 = true;
    $this$Json.h62_1 = true;
    $this$Json.i62_1 = false;
    $this$Json.l62_1 = false;
    return Unit_instance;
  }
  var properties_initialized_JsonSupport_kt_9cgd93;
  function _init_properties_JsonSupport_kt__yf438r() {
    if (!properties_initialized_JsonSupport_kt_9cgd93) {
      properties_initialized_JsonSupport_kt_9cgd93 = true;
      DefaultJson = Json_1(VOID, DefaultJson$lambda);
    }
  }
  function get_serializersStore() {
    _init_properties_DefaultJs_kt__opfp8o();
    return serializersStore;
  }
  var serializersStore;
  var properties_initialized_DefaultJs_kt_mit67a;
  function _init_properties_DefaultJs_kt__opfp8o() {
    if (!properties_initialized_DefaultJs_kt_mit67a) {
      properties_initialized_DefaultJs_kt_mit67a = true;
      // Inline function 'kotlin.collections.mutableListOf' call
      serializersStore = ArrayList_init_$Create$();
    }
  }
  function KotlinxSerializer$Companion$DefaultJson$lambda($this$Json) {
    $this$Json.g62_1 = false;
    $this$Json.f62_1 = false;
    $this$Json.n62_1 = true;
    $this$Json.l62_1 = false;
    return Unit_instance;
  }
  function Companion_425() {
    Companion_instance_425 = this;
    var tmp = this;
    tmp.yuo_1 = Json_1(VOID, KotlinxSerializer$Companion$DefaultJson$lambda);
  }
  var Companion_instance_425;
  function Companion_getInstance_425() {
    if (Companion_instance_425 == null)
      new Companion_425();
    return Companion_instance_425;
  }
  function KotlinxSerializer(json) {
    Companion_getInstance_425();
    json = json === VOID ? Companion_getInstance_425().yuo_1 : json;
    this.zuo_1 = json;
  }
  var initializer;
  function SerializerInitializer() {
    SerializerInitializer_instance = this;
    var tmp0 = get_serializersStore();
    // Inline function 'kotlin.collections.plusAssign' call
    var element = new KotlinxSerializer();
    tmp0.j(element);
  }
  var SerializerInitializer_instance;
  function SerializerInitializer_getInstance() {
    if (SerializerInitializer_instance == null)
      new SerializerInitializer();
    return SerializerInitializer_instance;
  }
  function get_LOGGER_8() {
    _init_properties_ContentNegotiation_kt__o183go();
    return LOGGER_8;
  }
  var LOGGER_8;
  function get_DefaultCommonIgnoredTypes() {
    _init_properties_ContentNegotiation_kt__o183go();
    return DefaultCommonIgnoredTypes;
  }
  var DefaultCommonIgnoredTypes;
  function ConverterRegistration(converter, contentTypeToSend, contentTypeMatcher) {
    this.aup_1 = converter;
    this.bup_1 = contentTypeToSend;
    this.cup_1 = contentTypeMatcher;
  }
  function defaultMatcher($this, pattern) {
    return new ContentNegotiation$Config$defaultMatcher$1(pattern);
  }
  function ContentNegotiation$Config$defaultMatcher$1($pattern) {
    this.dup_1 = $pattern;
  }
  protoOf(ContentNegotiation$Config$defaultMatcher$1).eup = function (contentType) {
    return contentType.lqy(this.dup_1);
  };
  function ContentNegotiation$Plugin$install$slambda($plugin, resultContinuation) {
    this.nup_1 = $plugin;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ContentNegotiation$Plugin$install$slambda).mrb = function ($this$intercept, it, $completion) {
    var tmp = this.nrb($this$intercept, it, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(ContentNegotiation$Plugin$install$slambda).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof PipelineContext ? p1 : THROW_CCE();
    return this.mrb(tmp, !(p2 == null) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(ContentNegotiation$Plugin$install$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 3;
            this.f9_1 = 1;
            suspendResult = this.nup_1.sup(this.oup_1.jdz_1, this.oup_1.mdy(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp0_elvis_lhs = suspendResult;
            var tmp_0;
            if (tmp0_elvis_lhs == null) {
              return Unit_instance;
            } else {
              tmp_0 = tmp0_elvis_lhs;
            }

            var result = tmp_0;
            this.f9_1 = 2;
            suspendResult = this.oup_1.ndy(result, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 3) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(ContentNegotiation$Plugin$install$slambda).nrb = function ($this$intercept, it, completion) {
    var i = new ContentNegotiation$Plugin$install$slambda(this.nup_1, completion);
    i.oup_1 = $this$intercept;
    i.pup_1 = it;
    return i;
  };
  function ContentNegotiation$Plugin$install$slambda_0($plugin, resultContinuation) {
    var i = new ContentNegotiation$Plugin$install$slambda($plugin, resultContinuation);
    var l = function ($this$intercept, it, $completion) {
      return i.mrb($this$intercept, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function ContentNegotiation$Plugin$install$slambda_1($plugin, resultContinuation) {
    this.buq_1 = $plugin;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ContentNegotiation$Plugin$install$slambda_1).grc = function ($this$intercept, _name_for_destructuring_parameter_0__wldtmu, $completion) {
    var tmp = this.hrc($this$intercept, _name_for_destructuring_parameter_0__wldtmu, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(ContentNegotiation$Plugin$install$slambda_1).w9 = function (p1, p2, $completion) {
    var tmp = p1 instanceof PipelineContext ? p1 : THROW_CCE();
    return this.grc(tmp, p2 instanceof HttpResponseContainer ? p2 : THROW_CCE(), $completion);
  };
  protoOf(ContentNegotiation$Plugin$install$slambda_1).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 3;
            this.euq_1 = this.duq_1.fg();
            var body = this.duq_1.gg();
            var tmp0_elvis_lhs = contentType_0(this.cuq_1.jdz_1.trb());
            var tmp_0;
            if (tmp0_elvis_lhs == null) {
              this.cuq_1;
              get_LOGGER_8().fe0('Response doesn\'t have "Content-Type" header, skipping ContentNegotiation plugin');
              return Unit_instance;
            } else {
              tmp_0 = tmp0_elvis_lhs;
            }

            var contentType = tmp_0;
            var charset = suitableCharset(this.cuq_1.jdz_1.yre().tr2());
            this.f9_1 = 1;
            suspendResult = this.buq_1.fuq(this.cuq_1.jdz_1.yre().qfs(), this.euq_1, body, contentType, charset, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp1_elvis_lhs = suspendResult;
            var tmp_1;
            if (tmp1_elvis_lhs == null) {
              return Unit_instance;
            } else {
              tmp_1 = tmp1_elvis_lhs;
            }

            var deserializedBody = tmp_1;
            var result = new HttpResponseContainer(this.euq_1, deserializedBody);
            this.f9_1 = 2;
            suspendResult = this.cuq_1.ndy(result, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 3) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(ContentNegotiation$Plugin$install$slambda_1).hrc = function ($this$intercept, _name_for_destructuring_parameter_0__wldtmu, completion) {
    var i = new ContentNegotiation$Plugin$install$slambda_1(this.buq_1, completion);
    i.cuq_1 = $this$intercept;
    i.duq_1 = _name_for_destructuring_parameter_0__wldtmu;
    return i;
  };
  function ContentNegotiation$Plugin$install$slambda_2($plugin, resultContinuation) {
    var i = new ContentNegotiation$Plugin$install$slambda_1($plugin, resultContinuation);
    var l = function ($this$intercept, _name_for_destructuring_parameter_0__wldtmu, $completion) {
      return i.grc($this$intercept, _name_for_destructuring_parameter_0__wldtmu, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function Config_4() {
    this.guq_1 = toMutableSet(plus_10(get_DefaultIgnoredTypes(), get_DefaultCommonIgnoredTypes()));
    var tmp = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp.huq_1 = ArrayList_init_$Create$();
  }
  protoOf(Config_4).ir8 = function (contentType, converter, configuration) {
    var matcher = contentType.equals(Application_getInstance().eqx_1) ? JsonContentTypeMatcher_instance : defaultMatcher(this, contentType);
    this.iuq(contentType, converter, matcher, configuration);
  };
  protoOf(Config_4).iuq = function (contentTypeToSend, converter, contentTypeMatcher, configuration) {
    // Inline function 'kotlin.apply' call
    configuration(converter);
    var registration = new ConverterRegistration(converter, contentTypeToSend, contentTypeMatcher);
    this.huq_1.j(registration);
  };
  function Plugin_6() {
    Plugin_instance_6 = this;
    this.juq_1 = new AttributeKey('ContentNegotiation');
  }
  protoOf(Plugin_6).z = function () {
    return this.juq_1;
  };
  protoOf(Plugin_6).kuq = function (block) {
    // Inline function 'kotlin.apply' call
    var this_0 = new Config_4();
    block(this_0);
    var config = this_0;
    return new ContentNegotiation(config.huq_1, config.guq_1);
  };
  protoOf(Plugin_6).wrd = function (block) {
    return this.kuq(block);
  };
  protoOf(Plugin_6).luq = function (plugin, scope) {
    var tmp = Phases_getInstance().grj_1;
    scope.tra_1.ndz(tmp, ContentNegotiation$Plugin$install$slambda_0(plugin, null));
    var tmp_0 = Phases_getInstance_1().rrd_1;
    scope.ura_1.ndz(tmp_0, ContentNegotiation$Plugin$install$slambda_2(plugin, null));
  };
  protoOf(Plugin_6).xrd = function (plugin, scope) {
    return this.luq(plugin instanceof ContentNegotiation ? plugin : THROW_CCE(), scope);
  };
  var Plugin_instance_6;
  function Plugin_getInstance_6() {
    if (Plugin_instance_6 == null)
      new Plugin_6();
    return Plugin_instance_6;
  }
  function ContentNegotiation$convertRequest$lambda(it) {
    return toString_1(it.aup_1);
  }
  function $convertRequestCOROUTINE$(_this__u8e3s4, request, body, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.uuq_1 = _this__u8e3s4;
    this.vuq_1 = request;
    this.wuq_1 = body;
  }
  protoOf($convertRequestCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 7;
            var _iterator__ex2g4s = this.uuq_1.qup_1.m();
            while (_iterator__ex2g4s.n()) {
              var element = _iterator__ex2g4s.o();
              l$ret$1: do {
                get_LOGGER_8().fe0('Adding Accept=' + element.bup_1.hqy_1 + ' header for ' + this.vuq_1.src_1.toString());
                if (this.vuq_1.urc_1.qdw(HttpHeaders_getInstance().qqy_1, element.bup_1.toString())) {
                  break l$ret$1;
                }
                accept(this.vuq_1, element.bup_1);
              }
               while (false);
            }

            var tmp_0;
            var tmp_1 = this.wuq_1;
            if (tmp_1 instanceof OutgoingContent) {
              tmp_0 = true;
            } else {
              var tmp0 = this.uuq_1.rup_1;
              var tmp$ret$2;
              l$ret$3: do {
                var tmp_2;
                if (isInterface(tmp0, Collection)) {
                  tmp_2 = tmp0.s();
                } else {
                  tmp_2 = false;
                }
                if (tmp_2) {
                  tmp$ret$2 = false;
                  break l$ret$3;
                }
                var _iterator__ex2g4s_0 = tmp0.m();
                while (_iterator__ex2g4s_0.n()) {
                  var element_0 = _iterator__ex2g4s_0.o();
                  if (element_0.sa(this.wuq_1)) {
                    tmp$ret$2 = true;
                    break l$ret$3;
                  }
                }
                tmp$ret$2 = false;
              }
               while (false);
              tmp_0 = tmp$ret$2;
            }

            if (tmp_0) {
              get_LOGGER_8().fe0('Body type ' + toString_1(getKClassFromExpression(this.wuq_1)) + ' is in ignored types. ' + ('Skipping ContentNegotiation for ' + this.vuq_1.src_1.toString() + '.'));
              return null;
            }

            var tmp_3 = this;
            var tmp0_elvis_lhs = contentType(this.vuq_1);
            var tmp_4;
            if (tmp0_elvis_lhs == null) {
              this.uuq_1;
              get_LOGGER_8().fe0("Request doesn't have Content-Type header. Skipping ContentNegotiation for " + this.vuq_1.src_1.toString() + '.');
              return null;
            } else {
              tmp_4 = tmp0_elvis_lhs;
            }

            tmp_3.yuq_1 = tmp_4;
            var tmp_5 = this.wuq_1;
            if (tmp_5 instanceof Unit) {
              get_LOGGER_8().fe0('Sending empty body for ' + this.vuq_1.src_1.toString());
              this.vuq_1.urc_1.vdw(HttpHeaders_getInstance().iqz_1);
              return EmptyContent_getInstance();
            }

            var tmp_6 = this;
            var tmp0_0 = this.uuq_1.qup_1;
            var destination = ArrayList_init_$Create$();
            var _iterator__ex2g4s_1 = tmp0_0.m();
            while (_iterator__ex2g4s_1.n()) {
              var element_1 = _iterator__ex2g4s_1.o();
              if (element_1.cup_1.eup(this.yuq_1)) {
                destination.j(element_1);
              }
            }

            var tmp_7;
            if (!destination.s()) {
              tmp_7 = destination;
            } else {
              tmp_7 = null;
            }

            var tmp1_elvis_lhs = tmp_7;
            var tmp_8;
            if (tmp1_elvis_lhs == null) {
              this.uuq_1;
              get_LOGGER_8().fe0('None of the registered converters match request Content-Type=' + this.yuq_1.toString() + '. ' + ('Skipping ContentNegotiation for ' + this.vuq_1.src_1.toString() + '.'));
              return null;
            } else {
              tmp_8 = tmp1_elvis_lhs;
            }

            tmp_6.xuq_1 = tmp_8;
            if (this.vuq_1.nrz() == null) {
              get_LOGGER_8().fe0('Request has unknown body type. Skipping ContentNegotiation for ' + this.vuq_1.src_1.toString() + '.');
              return null;
            }

            this.vuq_1.urc_1.vdw(HttpHeaders_getInstance().iqz_1);
            var tmp_9 = this;
            tmp_9.cur_1 = this.xuq_1;
            this.f9_1 = 1;
            continue $sm;
          case 1:
            this.bur_1 = this.cur_1.m();
            this.f9_1 = 2;
            continue $sm;
          case 2:
            if (!this.bur_1.n()) {
              this.f9_1 = 5;
              continue $sm;
            }

            var element_2 = this.bur_1.o();
            this.aur_1 = element_2;
            this.f9_1 = 3;
            var tmp0_elvis_lhs_0 = charset(this.yuq_1);
            var tmp_10 = tmp0_elvis_lhs_0 == null ? Charsets_getInstance().udq_1 : tmp0_elvis_lhs_0;
            var tmp_11 = ensureNotNull(this.vuq_1.nrz());
            var this_0 = this.wuq_1;
            var tmp_12;
            if (!equals(this_0, NullBody_instance)) {
              tmp_12 = this_0;
            } else {
              tmp_12 = null;
            }

            suspendResult = this.aur_1.aup_1.lr8(this.yuq_1, tmp_10, tmp_11, tmp_12, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            var result = suspendResult;
            if (!(result == null)) {
              get_LOGGER_8().fe0('Converted request body using ' + toString_1(this.aur_1.aup_1) + ' for ' + this.vuq_1.src_1.toString());
            }

            var result_0 = result;
            if (!(result_0 == null)) {
              this.zuq_1 = result_0;
              this.f9_1 = 6;
              continue $sm;
            } else {
              this.f9_1 = 4;
              continue $sm;
            }

          case 4:
            this.f9_1 = 2;
            continue $sm;
          case 5:
            this.zuq_1 = null;
            if (false) {
              this.f9_1 = 1;
              continue $sm;
            }

            this.f9_1 = 6;
            continue $sm;
          case 6:
            var tmp2_elvis_lhs = this.zuq_1;
            var tmp_13;
            if (tmp2_elvis_lhs == null) {
              var tmp_14 = "Can't convert " + toString_1(this.wuq_1) + ' with contentType ' + this.yuq_1.toString() + ' using converters ';
              throw new ContentConverterException(tmp_14 + joinToString_0(this.xuq_1, VOID, VOID, VOID, VOID, VOID, ContentNegotiation$convertRequest$lambda));
            } else {
              tmp_13 = tmp2_elvis_lhs;
            }

            var serializedContent = tmp_13;
            return serializedContent;
          case 7:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 7) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function $convertResponseCOROUTINE$(_this__u8e3s4, requestUrl, info, body, responseContentType, charset, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.lur_1 = _this__u8e3s4;
    this.mur_1 = requestUrl;
    this.nur_1 = info;
    this.our_1 = body;
    this.pur_1 = responseContentType;
    this.qur_1 = charset;
  }
  protoOf($convertResponseCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            var tmp_0 = this.our_1;
            if (!isInterface(tmp_0, ByteReadChannel_1)) {
              get_LOGGER_8().fe0('Response body is already transformed. Skipping ContentNegotiation for ' + this.mur_1.toString() + '.');
              return null;
            }

            if (this.lur_1.rup_1.t(this.nur_1.ae0_1)) {
              get_LOGGER_8().fe0('Response body type ' + toString_1(this.nur_1.ae0_1) + ' is in ignored types. ' + ('Skipping ContentNegotiation for ' + this.mur_1.toString() + '.'));
              return null;
            }

            var tmp0 = this.lur_1.qup_1;
            var destination = ArrayList_init_$Create$();
            var _iterator__ex2g4s = tmp0.m();
            while (_iterator__ex2g4s.n()) {
              var element = _iterator__ex2g4s.o();
              if (element.cup_1.eup(this.pur_1)) {
                destination.j(element);
              }
            }

            var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(destination, 10));
            var _iterator__ex2g4s_0 = destination.m();
            while (_iterator__ex2g4s_0.n()) {
              var item = _iterator__ex2g4s_0.o();
              destination_0.j(item.aup_1);
            }

            var tmp_1;
            if (!destination_0.s()) {
              tmp_1 = destination_0;
            } else {
              tmp_1 = null;
            }

            var tmp0_elvis_lhs = tmp_1;
            var tmp_2;
            if (tmp0_elvis_lhs == null) {
              this.lur_1;
              get_LOGGER_8().fe0('None of the registered converters match response with Content-Type=' + this.pur_1.toString() + '. ' + ('Skipping ContentNegotiation for ' + this.mur_1.toString() + '.'));
              return null;
            } else {
              tmp_2 = tmp0_elvis_lhs;
            }

            var suitableConverters = tmp_2;
            this.f9_1 = 1;
            suspendResult = deserialize_1(suitableConverters, this.our_1, this.nur_1, this.qur_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var result = suspendResult;
            if (!isInterface(result, ByteReadChannel_1)) {
              get_LOGGER_8().fe0('Response body was converted to ' + toString_1(getKClassFromExpression(result)) + ' for ' + this.mur_1.toString() + '.');
            }

            return result;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function ContentNegotiation(registrations, ignoredTypes) {
    Plugin_getInstance_6();
    this.qup_1 = registrations;
    this.rup_1 = ignoredTypes;
  }
  protoOf(ContentNegotiation).sup = function (request, body, $completion) {
    var tmp = new $convertRequestCOROUTINE$(this, request, body, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(ContentNegotiation).fuq = function (requestUrl, info, body, responseContentType, charset, $completion) {
    var tmp = new $convertResponseCOROUTINE$(this, requestUrl, info, body, responseContentType, charset, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  function ContentConverterException(message) {
    Exception_init_$Init$_0(message, this);
    captureStack(this, ContentConverterException);
  }
  var properties_initialized_ContentNegotiation_kt_1ayduy;
  function _init_properties_ContentNegotiation_kt__o183go() {
    if (!properties_initialized_ContentNegotiation_kt_1ayduy) {
      properties_initialized_ContentNegotiation_kt_1ayduy = true;
      LOGGER_8 = KtorSimpleLogger('io.ktor.client.plugins.contentnegotiation.ContentNegotiation');
      DefaultCommonIgnoredTypes = setOf_0([PrimitiveClasses_getInstance().xb(), PrimitiveClasses_getInstance().tb(), getKClass(HttpStatusCode), getKClass(ByteReadChannel_1), getKClass(OutgoingContent)]);
    }
  }
  function JsonContentTypeMatcher() {
  }
  protoOf(JsonContentTypeMatcher).eup = function (contentType) {
    if (contentType.lqy(Application_getInstance().eqx_1)) {
      return true;
    }
    var value = contentType.kqy().toString();
    return startsWith(value, 'application/') && endsWith(value, '+json');
  };
  var JsonContentTypeMatcher_instance;
  function JsonContentTypeMatcher_getInstance() {
    return JsonContentTypeMatcher_instance;
  }
  function get_DefaultIgnoredTypes() {
    _init_properties_DefaultIgnoredTypesJs_kt__rjtdk1();
    return DefaultIgnoredTypes;
  }
  var DefaultIgnoredTypes;
  var properties_initialized_DefaultIgnoredTypesJs_kt_65g2xt;
  function _init_properties_DefaultIgnoredTypesJs_kt__rjtdk1() {
    if (!properties_initialized_DefaultIgnoredTypesJs_kt_65g2xt) {
      properties_initialized_DefaultIgnoredTypesJs_kt_65g2xt = true;
      // Inline function 'kotlin.collections.mutableSetOf' call
      DefaultIgnoredTypes = LinkedHashSet_init_$Create$();
    }
  }
  function cachingNodeEditorAdapter(element, monitoring) {
    monitoring = monitoring === VOID ? Companion_getInstance_418().htb_1 : monitoring;
    var view = new HtmlNodeEditorView(element, VOID, true);
    var editor = new CachingNodeEditorImpl(4, EmptyCoroutineContext_instance, view, monitoring);
    return new NodeEditorAdapter(editor);
  }
  function getEditorServiceWebsocketUrl($this) {
    // Inline function 'kotlin.let' call
    return getGatewayWebsocketUrl($this) + '/editor-service/api';
  }
  function getGatewayWebsocketUrl($this) {
    return replace(getGatewayUrl($this), 'http', 'ws');
  }
  function getGatewayUrl($this) {
    return window.location.origin;
  }
  function ApiGateway() {
  }
  protoOf(ApiGateway).getQueryServiceUrl = function () {
    // Inline function 'kotlin.let' call
    return getGatewayUrl(this) + '/queries-service/api';
  };
  protoOf(ApiGateway).getDocumentsRevisionsServiceUrl = function () {
    // Inline function 'kotlin.let' call
    return getGatewayUrl(this) + '/documents-revisions-service/api';
  };
  protoOf(ApiGateway).getEditorDocumentsServiceUrl = function () {
    // Inline function 'kotlin.let' call
    return getGatewayUrl(this) + '/editor-documents-service/api';
  };
  protoOf(ApiGateway).getEditorServiceUrl = function () {
    // Inline function 'kotlin.let' call
    return getGatewayUrl(this) + '/editor-service/api';
  };
  protoOf(ApiGateway).getEditorWebsocketUrl = function () {
    // Inline function 'kotlin.let' call
    return getEditorServiceWebsocketUrl(this) + '/resolver';
  };
  protoOf(ApiGateway).getAnalyzerWebsocketUrl = function () {
    // Inline function 'kotlin.let' call
    return getGatewayWebsocketUrl(this) + '/analyzer-service/api/resolver';
  };
  protoOf(ApiGateway).getOtWebsocketUrl = function () {
    // Inline function 'kotlin.let' call
    return getGatewayWebsocketUrl(this) + '/ot-service/api';
  };
  var ApiGateway_instance;
  function ApiGateway_getInstance() {
    return ApiGateway_instance;
  }
  function renderDocumentToDom(source, highlightedNodes, $completion) {
    var tmp;
    if (highlightedNodes === VOID) {
      tmp = [];
    } else {
      tmp = highlightedNodes;
    }
    highlightedNodes = tmp;
    var tmp_0 = new $renderDocumentToDomCOROUTINE$(source, highlightedNodes, $completion);
    tmp_0.h9_1 = Unit_instance;
    tmp_0.i9_1 = null;
    return tmp_0.n9();
  }
  function noRequestAnimationFrame(_this__u8e3s4) {
    _this__u8e3s4.bbn(false);
  }
  function CapturingView() {
    this.dus_1 = null;
  }
  protoOf(CapturingView).xtf = function (container) {
    this.dus_1 = container;
    return Companion_getInstance_29().m2l_1;
  };
  function noRequestAnimationFrame$ref() {
    var l = function (p0) {
      noRequestAnimationFrame(p0);
      return Unit_instance;
    };
    l.callableName = 'noRequestAnimationFrame';
    return l;
  }
  function $renderDocumentToDomCOROUTINE$(source, highlightedNodes, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.zur_1 = source;
    this.aus_1 = highlightedNodes;
  }
  protoOf($renderDocumentToDomCOROUTINE$).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.bus_1 = new CapturingView();
            this.cus_1 = new NonCachingNodeEditor(EmptyCoroutineContext_instance, this.bus_1);
            this.f9_1 = 1;
            suspendResult = this.cus_1.rt9(this.zur_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var indexedObject = this.aus_1;
            var inductionVariable = 0;
            var last = indexedObject.length;
            while (inductionVariable < last) {
              var element = indexedObject[inductionVariable];
              inductionVariable = inductionVariable + 1 | 0;
              this.cus_1.zt6(new NodeEditorPart(element, null));
            }

            var div = DomApi_instance.m8f();
            var htmlView = new HtmlNodeEditorView(div, noRequestAnimationFrame$ref());
            var tmp0 = this.bus_1.dus_1;
            var tmp$ret$0 = Unit_instance;
            l$ret$1: do {
              if (tmp0 == null) {
                var message = 'Required value was null.';
                throw IllegalStateException_init_$Create$_0(toString_1(message));
              } else {
                tmp$ret$0 = tmp0;
                break l$ret$1;
              }
            }
             while (false);
            htmlView.xtf(tmp$ret$0);
            return div;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  function EditorEnvironment$client$lambda($this$HttpClient) {
    var tmp = Plugin_getInstance_6();
    $this$HttpClient.yrd(tmp, EditorEnvironment$client$lambda$lambda);
    WebSockets_0($this$HttpClient, EditorEnvironment$client$lambda$lambda_0);
    return Unit_instance;
  }
  function EditorEnvironment$client$lambda$lambda($this$install) {
    json($this$install);
    return Unit_instance;
  }
  function EditorEnvironment$client$lambda$lambda_0($this$WebSockets) {
    var tmp = $this$WebSockets;
    // Inline function 'kotlin.time.Companion.seconds' call
    Companion_getInstance_16();
    var tmp$ret$0 = toDuration_0(15, DurationUnit_SECONDS_getInstance());
    tmp.cry_1 = _Duration___get_inWholeMilliseconds__impl__msfiry(tmp$ret$0);
    return Unit_instance;
  }
  function EditorEnvironment$monitoringClient$slambda(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(EditorEnvironment$monitoringClient$slambda).nus = function (metrics, $completion) {
    var tmp = this.ous(metrics, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(EditorEnvironment$monitoringClient$slambda).v9 = function (p1, $completion) {
    return this.nus((!(p1 == null) ? isInterface(p1, KtList) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(EditorEnvironment$monitoringClient$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            this.f9_1 = 1;
            suspendResult = EditorEnvironment_getInstance().editorsApi.ktk(this.mus_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(EditorEnvironment$monitoringClient$slambda).ous = function (metrics, completion) {
    var i = new EditorEnvironment$monitoringClient$slambda(completion);
    i.mus_1 = metrics;
    return i;
  };
  function EditorEnvironment$monitoringClient$slambda_0(resultContinuation) {
    var i = new EditorEnvironment$monitoringClient$slambda(resultContinuation);
    var l = function (metrics, $completion) {
      return i.nus(metrics, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function EditorEnvironment() {
    EditorEnvironment_instance = this;
    this.pus_1 = CoroutineScope_0(SupervisorJob());
    var tmp = this;
    tmp.qus_1 = HttpClient_1(EditorEnvironment$client$lambda);
    var tmp_0 = this;
    var tmp_1 = ApiGateway_instance.getOtWebsocketUrl();
    var tmp_2 = get_websocketFactory();
    var tmp_3 = get_platformEdt();
    // Inline function 'kotlin.with' call
    var $this$with = serviceContainer([Companion_instance_41.k3b(false, [UseExperimentalNodeService_instance]), ensureNotNull(get_btbLanguageWithRemoteResolve().q6f(StructureAspect_instance)), ensureNotNull(get_btbLanguageWithRemoteResolve().q6f(ReferenceFactoryRegistryAspect_instance))]);
    var tmp$ret$1 = ConceptRegistryService_instance.e3b($this$with).k6l(ReferenceFactoryRegistryService_getInstance().e3b($this$with));
    tmp_0.ot = new OtEnvironment(tmp_1, tmp_2, tmp_3, tmp$ret$1);
    this.qesApi = new QueriesApi(this.qus_1, ApiGateway_instance.getQueryServiceUrl());
    this.explorerApi = new ExplorerApi(this.qus_1, ApiGateway_instance.getDocumentsRevisionsServiceUrl());
    this.editorDocumentsApi = new EditorDocumentsApi(this.qus_1, ApiGateway_instance.getEditorDocumentsServiceUrl());
    this.editorsApi = new EditorsApi(this.qus_1, ApiGateway_instance.getEditorServiceUrl());
    var tmp_4 = this;
    tmp_4.rus_1 = new PerformanceMonitoringClient(this.pus_1, EditorEnvironment$monitoringClient$slambda_0(null));
    this.editorOpeningMonitoring = new ByEditorService(this.rus_1);
    this.editorsRpc = new WebsocketEditorServiceProvider(this.qus_1, ApiGateway_instance.getEditorWebsocketUrl());
    this.queryDraftsRpc = new WebsocketEditorServiceProvider(this.qus_1, ApiGateway_instance.getAnalyzerWebsocketUrl());
  }
  protoOf(EditorEnvironment).sus = function () {
    return this.ot;
  };
  protoOf(EditorEnvironment).tus = function () {
    return this.qesApi;
  };
  protoOf(EditorEnvironment).uus = function () {
    return this.explorerApi;
  };
  protoOf(EditorEnvironment).vus = function () {
    return this.editorDocumentsApi;
  };
  protoOf(EditorEnvironment).wus = function () {
    return this.editorsApi;
  };
  protoOf(EditorEnvironment).xus = function () {
    return this.editorOpeningMonitoring;
  };
  protoOf(EditorEnvironment).yus = function () {
    return this.editorsRpc;
  };
  protoOf(EditorEnvironment).zus = function () {
    return this.queryDraftsRpc;
  };
  var EditorEnvironment_instance;
  function EditorEnvironment_getInstance() {
    if (EditorEnvironment_instance == null)
      new EditorEnvironment();
    return EditorEnvironment_instance;
  }
  function findUsages_0(docAccession, nodeId, docsPageSize, nodesPageSize) {
    var tmp = CoroutineScope_0(Dispatchers_getInstance().uz_1);
    return promise(tmp, VOID, VOID, findUsages$slambda_0(docAccession, nodeId, docsPageSize, nodesPageSize, null));
  }
  function findUsages$slambda($docAccession, $nodeId, $docsPageSize, $nodesPageSize, resultContinuation) {
    this.iut_1 = $docAccession;
    this.jut_1 = $nodeId;
    this.kut_1 = $docsPageSize;
    this.lut_1 = $nodesPageSize;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(findUsages$slambda).nut = function ($this$promise, $completion) {
    var tmp = this.f1h($this$promise, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(findUsages$slambda).v9 = function (p1, $completion) {
    return this.nut((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(findUsages$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 4;
            this.f9_1 = 1;
            suspendResult = EditorEnvironment_getInstance().editorsRpc.qsm(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var client = suspendResult;
            var nodePointer = new NodePointer(this.iut_1, new NodeId(this.jut_1));
            var request = new FindUsageServiceRequest(nodePointer, this.kut_1, this.lut_1);
            this.f9_1 = 2;
            suspendResult = client.rsk(request, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var ARGUMENT = suspendResult;
            this.f9_1 = 3;
            suspendResult = createFindUsageResultsPaged(ARGUMENT, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            var pagedResponse = suspendResult;
            return new FindUsagePagedAdapter(pagedResponse);
          case 4:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 4) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(findUsages$slambda).f1h = function ($this$promise, completion) {
    var i = new findUsages$slambda(this.iut_1, this.jut_1, this.kut_1, this.lut_1, completion);
    i.mut_1 = $this$promise;
    return i;
  };
  function findUsages$slambda_0($docAccession, $nodeId, $docsPageSize, $nodesPageSize, resultContinuation) {
    var i = new findUsages$slambda($docAccession, $nodeId, $docsPageSize, $nodesPageSize, resultContinuation);
    var l = function ($this$promise, $completion) {
      return i.nut($this$promise, $completion);
    };
    l.$arity = 1;
    return l;
  }
  var LOG_7;
  function createEditor_0(element) {
    _init_properties_Main_kt__xi25uv();
    return cachingNodeEditorAdapter(element, EditorEnvironment_getInstance().editorOpeningMonitoring);
  }
  function editedDocumentSource(accession, name) {
    _init_properties_Main_kt__xi25uv();
    return new EditedDocumentSource(EditorEnvironment_getInstance().editorDocumentsApi, EditorEnvironment_getInstance().editorsRpc, get_platformEdt(), accession, name);
  }
  function editedWorkingCopySource(accession, name, entityId, readonly) {
    _init_properties_Main_kt__xi25uv();
    return new EditedWorkingCopySource(EditorEnvironment_getInstance().ot, EditorEnvironment_getInstance().editorsRpc, EditorEnvironment_getInstance().editorDocumentsApi, get_platformEdt(), EntityId_init_$Create$_0(entityId), accession, name, readonly);
  }
  function editedOntologyBrowserSource(accession, nodeId, content) {
    _init_properties_Main_kt__xi25uv();
    return new EditedOntologyBrowserSource(EditorEnvironment_getInstance().editorsApi, accession, nodeId, content);
  }
  function exploredDocumentSource(accession, globalVersion) {
    _init_properties_Main_kt__xi25uv();
    return new ExploredDocumentSource(EditorEnvironment_getInstance().explorerApi, accession, numberToLong(globalVersion));
  }
  function exploredOntologyBrowserSource(accession, globalVersion, nodeId, content) {
    _init_properties_Main_kt__xi25uv();
    return new ExploredOntologyBrowserSource(EditorEnvironment_getInstance().explorerApi, accession, nodeId, content, numberToLong(globalVersion));
  }
  function historyPanelDocumentSource(accession, revision) {
    _init_properties_Main_kt__xi25uv();
    return new HistoryPanelDocumentSource(EditorEnvironment_getInstance().explorerApi, accession, revision);
  }
  function publishedQuerySource(queryId) {
    _init_properties_Main_kt__xi25uv();
    return new PublishedQuerySource(EditorEnvironment_getInstance().qesApi, numberToLong(queryId));
  }
  function draftQuerySource(queryId, name, entityId, globalVersion) {
    _init_properties_Main_kt__xi25uv();
    return new DraftQuerySource(EditorEnvironment_getInstance().ot, EditorEnvironment_getInstance().queryDraftsRpc, get_platformEdt(), EntityId_init_$Create$_0(entityId), numberToLong(queryId), name, numberToLong(globalVersion));
  }
  function getHtmlForUsageJSON(accession, usageDto) {
    _init_properties_Main_kt__xi25uv();
    // Inline function 'kotlinx.serialization.json.decodeFromDynamic' call
    var this_0 = Default_getInstance_0();
    // Inline function 'kotlinx.serialization.serializer' call
    var this_1 = this_0.g59();
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_2 = serializer_2(this_1, createKType(getKClass(UsageDto), arrayOf([]), false));
    var tmp$ret$1 = isInterface(this_2, KSerializer) ? this_2 : THROW_CCE();
    var tmp$ret$2 = decodeFromDynamic(this_0, tmp$ret$1, usageDto);
    return getHtmlForUsage(accession, tmp$ret$2);
  }
  function getHtmlForUsage(accession, usageDto) {
    _init_properties_Main_kt__xi25uv();
    var tmp = CoroutineScope_0(Dispatchers_getInstance().uz_1);
    return promise(tmp, VOID, VOID, getHtmlForUsage$slambda_0(accession, usageDto, null));
  }
  function getHtmlForResolvedNode(accession, serializedResolvedNode, highlightedNodes) {
    var tmp;
    if (highlightedNodes === VOID) {
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = [];
    } else {
      tmp = highlightedNodes;
    }
    highlightedNodes = tmp;
    _init_properties_Main_kt__xi25uv();
    var tmp_0 = CoroutineScope_0(Dispatchers_getInstance().uz_1);
    return promise(tmp_0, VOID, VOID, getHtmlForResolvedNode$slambda_0(accession, serializedResolvedNode, highlightedNodes, null));
  }
  function getHtmlForResolvedNodeJSON(accession, serializedResolvedNode, highlightedNodeIds) {
    _init_properties_Main_kt__xi25uv();
    // Inline function 'kotlinx.serialization.json.decodeFromDynamic' call
    var this_0 = Default_getInstance_0();
    // Inline function 'kotlinx.serialization.serializer' call
    var this_1 = this_0.g59();
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_2 = serializer_2(this_1, createKType(getKClass(SerializedResolvedNode), arrayOf([]), false));
    var tmp$ret$1 = isInterface(this_2, KSerializer) ? this_2 : THROW_CCE();
    var tmp$ret$2 = decodeFromDynamic(this_0, tmp$ret$1, serializedResolvedNode);
    return getHtmlForResolvedNode(accession, tmp$ret$2, highlightedNodeIds);
  }
  function getNodeIdOfResolvedNode(node) {
    _init_properties_Main_kt__xi25uv();
    return Companion_instance_87.v24(toString_1(node.node.pointer)).nodeId.q36_1;
  }
  function createNode() {
    _init_properties_Main_kt__xi25uv();
    return BTBDocument(get_wrapperContext(createFreshDomainModel()));
  }
  function emptyDocJson(docType) {
    _init_properties_Main_kt__xi25uv();
    var domainModel = createFreshDomainModel();
    var ctx = get_wrapperContext(domainModel);
    var tmp;
    switch (docType) {
      case 'BTB':
        tmp = BTBDocument(ctx);
        break;
      case 'IMPORTS':
        tmp = OntologyImportRoot(ctx);
        break;
      case 'ONTOLOGY':
        tmp = OntologyLibrary(ctx);
        break;
      case 'KINDS':
        tmp = ProcessKindContainer(ctx);
        break;
      case 'PROCESSES':
        tmp = ProcessLibrary(ctx);
        break;
      case 'RELATIONS':
        tmp = RelationContainer(ctx);
        break;
      case 'NOTIONS':
        tmp = NotionLibrary(ctx);
        break;
      case 'FUNCTIONS':
        tmp = FunctionLibrary(ctx);
        break;
      case 'EXTENSIONS':
        tmp = ExtensionLibrary(ctx);
        break;
      case 'PROPERTIES':
        tmp = PropertyLibrary(ctx);
        break;
      case 'LINKS':
        tmp = LinkLibrary(ctx);
        break;
      case 'SOURCES':
        tmp = PublishedSourcesLibrary(ctx);
        break;
      case 'QUERY':
        tmp = QueryCommands(ctx);
        break;
      default:
        throw IllegalArgumentException_init_$Create$_0('emptyDocJson: unknown document type: ' + docType);
    }
    var documentNode = tmp;
    return get_docPersistence(domainModel).lqw(toOtNode(documentNode));
  }
  function getFileContents(accession, jsonCallback) {
    _init_properties_Main_kt__xi25uv();
    jsonCallback('');
  }
  function EditorEvents() {
    EditorEvents_instance = this;
    this.FIRST_EDIT = get_FIRST_EDIT();
    this.NAVIGATE = get_NAVIGATE();
    this.FIND_USAGES = get_FIND_USAGES();
    this.BTB_CATEGORY_EVENT = get_BTB_CATEGORY_EVENT();
    this.FACT_SELECTION_EVENT = get_FACT_SELECTION_EVENT();
    this.ERROR_EVENT = get_ERROR_EVENT();
  }
  protoOf(EditorEvents).out = function () {
    return this.FIRST_EDIT;
  };
  protoOf(EditorEvents).put = function () {
    return this.NAVIGATE;
  };
  protoOf(EditorEvents).qut = function () {
    return this.FIND_USAGES;
  };
  protoOf(EditorEvents).rut = function () {
    return this.BTB_CATEGORY_EVENT;
  };
  protoOf(EditorEvents).sut = function () {
    return this.FACT_SELECTION_EVENT;
  };
  protoOf(EditorEvents).tut = function () {
    return this.ERROR_EVENT;
  };
  var EditorEvents_instance;
  function EditorEvents_getInstance() {
    if (EditorEvents_instance == null)
      new EditorEvents();
    return EditorEvents_instance;
  }
  function EntryPoint() {
  }
  function getHtmlForUsage$slambda($accession, $usageDto, resultContinuation) {
    this.cuu_1 = $accession;
    this.duu_1 = $usageDto;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(getHtmlForUsage$slambda).fuu = function ($this$promise, $completion) {
    var tmp = this.f1h($this$promise, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(getHtmlForUsage$slambda).v9 = function (p1, $completion) {
    return this.fuu((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(getHtmlForUsage$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            var source = new UsageEntrySource(this.cuu_1, this.duu_1);
            this.f9_1 = 1;
            suspendResult = renderDocumentToDom(source, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(getHtmlForUsage$slambda).f1h = function ($this$promise, completion) {
    var i = new getHtmlForUsage$slambda(this.cuu_1, this.duu_1, completion);
    i.euu_1 = $this$promise;
    return i;
  };
  function getHtmlForUsage$slambda_0($accession, $usageDto, resultContinuation) {
    var i = new getHtmlForUsage$slambda($accession, $usageDto, resultContinuation);
    var l = function ($this$promise, $completion) {
      return i.fuu($this$promise, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function getHtmlForResolvedNode$slambda($accession, $serializedResolvedNode, $highlightedNodes, resultContinuation) {
    this.ouu_1 = $accession;
    this.puu_1 = $serializedResolvedNode;
    this.quu_1 = $highlightedNodes;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(getHtmlForResolvedNode$slambda).fuu = function ($this$promise, $completion) {
    var tmp = this.f1h($this$promise, $completion);
    tmp.h9_1 = Unit_instance;
    tmp.i9_1 = null;
    return tmp.n9();
  };
  protoOf(getHtmlForResolvedNode$slambda).v9 = function (p1, $completion) {
    return this.fuu((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(getHtmlForResolvedNode$slambda).n9 = function () {
    var suspendResult = this.h9_1;
    $sm: do
      try {
        var tmp = this.f9_1;
        switch (tmp) {
          case 0:
            this.g9_1 = 2;
            var source = new PathEntrySource(this.ouu_1, this.puu_1);
            this.f9_1 = 1;
            suspendResult = renderDocumentToDom(source, this.quu_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.i9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.g9_1 === 2) {
          throw e;
        } else {
          this.f9_1 = this.g9_1;
          this.i9_1 = e;
        }
      }
     while (true);
  };
  protoOf(getHtmlForResolvedNode$slambda).f1h = function ($this$promise, completion) {
    var i = new getHtmlForResolvedNode$slambda(this.ouu_1, this.puu_1, this.quu_1, completion);
    i.ruu_1 = $this$promise;
    return i;
  };
  function getHtmlForResolvedNode$slambda_0($accession, $serializedResolvedNode, $highlightedNodes, resultContinuation) {
    var i = new getHtmlForResolvedNode$slambda($accession, $serializedResolvedNode, $highlightedNodes, resultContinuation);
    var l = function ($this$promise, $completion) {
      return i.fuu($this$promise, $completion);
    };
    l.$arity = 1;
    return l;
  }
  var properties_initialized_Main_kt_gqj46d;
  function _init_properties_Main_kt__xi25uv() {
    if (!properties_initialized_Main_kt_gqj46d) {
      properties_initialized_Main_kt_gqj46d = true;
      LOG_7 = getLogger_0(getKClass(EntryPoint));
    }
  }
  //region block: post-declaration
  protoOf(AbstractList).asJsReadonlyArrayView = asJsReadonlyArrayView;
  protoOf(AbstractMutableList).asJsReadonlyArrayView = asJsReadonlyArrayView;
  protoOf(InternalHashMap).q6 = containsAllEntries;
  protoOf(EmptyList).asJsReadonlyArrayView = asJsReadonlyArrayView;
  protoOf(CombinedContext).wi = plus;
  protoOf(AbstractCoroutineContextElement).s9 = get;
  protoOf(AbstractCoroutineContextElement).vi = fold;
  protoOf(AbstractCoroutineContextElement).ui = minusKey;
  protoOf(AbstractCoroutineContextElement).wi = plus;
  protoOf(ValueTimeMark).el = compareTo;
  defineProp(protoOf(atomicfu$AtomicRefArray$ref), 'atomicfu$size', protoOf(atomicfu$AtomicRefArray$ref).vn);
  protoOf(JobSupport).mp = invokeOnCompletion$default;
  protoOf(JobSupport).sp = cancel$default;
  protoOf(JobSupport).wi = plus;
  protoOf(JobSupport).s9 = get;
  protoOf(JobSupport).vi = fold;
  protoOf(JobSupport).ui = minusKey;
  protoOf(CoroutineDispatcher).s9 = get_0;
  protoOf(CoroutineDispatcher).ui = minusKey_0;
  protoOf(BufferedChannel).i16 = close$default;
  protoOf(BufferedChannel).k16 = cancel$default_0;
  protoOf(ChannelCoroutine).i16 = close$default;
  protoOf(ChannelFlow).d18 = fuse$default;
  protoOf(SharedFlowImpl).d18 = fuse$default;
  protoOf(StateFlowImpl).d18 = fuse$default;
  protoOf(ReadonlySharedFlow).d18 = fuse$default;
  protoOf(ReadonlyStateFlow).d18 = fuse$default;
  protoOf(MessageQueue).asJsReadonlyArrayView = asJsReadonlyArrayView;
  protoOf(DefaultValueNullPersister).u24 = isNullString;
  protoOf(EmptyStringNullPersister).r24 = isNullValue;
  protoOf(ExceptionNullPersister).u24 = isNullString;
  protoOf(ExceptionNullPersister).r24 = isNullValue;
  protoOf(NullPersisterForNullable).u24 = isNullString;
  protoOf(NullPersisterForNullable).r24 = isNullValue;
  protoOf(SimplePersister).p25 = deserialize;
  protoOf(SimplePersister).w24 = serialize;
  protoOf(Companion_24).j26 = tryFromFloat$default;
  protoOf(Companion_24).l26 = tryFromDouble$default;
  protoOf(Companion_24).g26 = parseString$default;
  protoOf(BigDecimal).w26 = plus_1;
  protoOf(BigDecimal).y26 = minus_0;
  protoOf(Companion_26).g26 = parseString$default;
  protoOf(Companion_26).j26 = tryFromFloat$default;
  protoOf(Companion_26).l26 = tryFromDouble$default;
  protoOf(BigInteger).o26 = plus_0;
  protoOf(BigInteger).q26 = minus;
  protoOf(BigInteger).s26 = times;
  protoOf(BigInteger).x26 = times_0;
  protoOf(BigInteger).u26 = div;
  protoOf(BigInteger).z26 = div_0;
  protoOf(BigInteger).a27 = rem;
  protoOf(toDisposable$$inlined$toDisposable$1).j2l = plus_2;
  protoOf(newLock$1).t2o = withLock;
  protoOf(KLoggerDirect).x2p = debug;
  protoOf(KLoggerDirect).y2p = debug_0;
  protoOf(KLoggerDirect).a2q = info;
  protoOf(KLoggerDirect).b2q = info_0;
  protoOf(KLoggerDirect).c2q = warn;
  protoOf(KLoggerDirect).e2q = warn_0;
  protoOf(KLoggerDirect).d2q = warn_1;
  protoOf(KLoggerDirect).f2q = error;
  protoOf(KLoggerDirect).h2q = error_0;
  protoOf(KLoggerDirect).g2q = error_1;
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0).j2l = plus_2;
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0_0).j2l = plus_2;
  protoOf(AbstractObservableList).z2r = addHandler;
  protoOf(ConstantObservableListAdapter).z2r = addHandler;
  protoOf(AbstractObservableSet).z2r = addHandler;
  protoOf(ConstantObservableSetAdapter).z2r = addHandler;
  protoOf(ObservableListWrapper).z2r = addHandler;
  protoOf(ObservableSetWrapper).z2r = addHandler;
  protoOf(CompositeEventSource).z2r = addHandler;
  protoOf(Listeners$add$$inlined$toDisposable$1).j2l = plus_2;
  protoOf(ListenersMap$add$$inlined$toDisposable$1).j2l = plus_2;
  protoOf(BaseReadableProperty).w2w = invoke;
  protoOf(BaseReadableProperty).z2r = addHandler;
  protoOf(DelayedValueProperty).f2x = invoke_0;
  protoOf(map$2).w2w = invoke;
  protoOf(map$2).f2x = invoke_0;
  protoOf(map$2).z2r = addHandler;
  protoOf(asValidatedProp$ValidatedProperty).f2x = invoke_0;
  protoOf(ValueProperty).f2x = invoke_0;
  protoOf(toWritableProperty$1).f2x = invoke_0;
  protoOf(SingleItemCollectionProperty).w2w = invoke;
  protoOf(SingleItemCollectionProperty).f2x = invoke_0;
  protoOf(SingleItemCollectionProperty).z2r = addHandler;
  protoOf(TerminalTransformation).j2l = plus_2;
  protoOf(Transformers$listMap$1$transform$$inlined$toDisposable$1).j2l = plus_2;
  protoOf(Transformers$flattenList$5$transform$$inlined$toDisposable$1).j2l = plus_2;
  protoOf(SimpleAsync$onResult$$inlined$toDisposable$1).j2l = plus_2;
  protoOf(compound$1).o38 = plus_3;
  protoOf(compound$1).j2l = plus_2;
  protoOf(AsyncTracker$Companion$EMPTY$1).f39 = workStarted;
  protoOf(AsyncTracker$Companion$EMPTY$1).g39 = workFinished;
  protoOf(JsEventDispatchThread$timerDisposable$$inlined$toDisposable$1).j2l = plus_2;
  protoOf(AnonymousResourceServiceKey).g3b = get_default;
  protoOf(AnonymousResourceServiceKey).e3b = invoke_1;
  protoOf(ServiceInstance$$inlined$toDisposable$1).j2l = plus_2;
  protoOf(ServiceManager).e3c = getValue;
  protoOf(ServiceManager).j2l = plus_2;
  protoOf(CoroutineContextService).e3b = invoke_1;
  protoOf(Entity$modelProperty$1).w2w = invoke;
  protoOf(Entity$modelProperty$1).f2x = invoke_0;
  protoOf(Entity$modelProperty$1).z2r = addHandler;
  protoOf(BaseOtNodeProperty).f2x = invoke_0;
  protoOf(BaseOtNodeTextProperty).w2w = invoke;
  protoOf(BaseOtNodeTextProperty).z2r = addHandler;
  protoOf(MyProperty).f2x = invoke_0;
  protoOf(RawNodeFactory).h3t = createNode$default;
  protoOf(EntityContextOperationsTracker).j2l = plus_2;
  protoOf(EntityContextCommandProcessor$addOperationValidator$$inlined$toDisposable$1).j2l = plus_2;
  protoOf(EntityContextCommandProcessor).j2l = plus_2;
  protoOf(EntityContextOperationsTracker$2).x3j = onRootAdded;
  protoOf(EntityContextOperationsTracker$2).z3j = onRootRemoved;
  protoOf(EntityContextOperationsTracker$2).y3j = onEntityFeatureChanged;
  protoOf(BaseOperation).i43 = execute$default;
  protoOf(RootOperationsExecutorChecker).x3j = onRootAdded;
  protoOf(RootOperationsExecutorChecker).z3j = onRootRemoved;
  protoOf(RootOperationsExecutorChecker).p3j = onChildAdded;
  protoOf(RootOperationsExecutorChecker).w3j = onChildRemoved;
  protoOf(RootOperationsExecutorChecker).a3k = onChildMoved;
  protoOf(RootOperationsExecutorChecker).b3k = onPropertyChanged;
  protoOf(RootOperationsExecutorChecker).c3k = onReferenceAdded;
  protoOf(RootOperationsExecutorChecker).d3k = onReferenceRemoved;
  protoOf(RootOperationsExecutorChecker).e3k = onModelBlobChanged;
  protoOf(RootOperationsExecutorChecker).f3k = onNodeEvent;
  protoOf(ModelOperationsExecutorChecker).x3j = onRootAdded;
  protoOf(ModelOperationsExecutorChecker).z3j = onRootRemoved;
  protoOf(ModelOperationsExecutorChecker).p3j = onChildAdded;
  protoOf(ModelOperationsExecutorChecker).w3j = onChildRemoved;
  protoOf(ModelOperationsExecutorChecker).a3k = onChildMoved;
  protoOf(ModelOperationsExecutorChecker).b3k = onPropertyChanged;
  protoOf(ModelOperationsExecutorChecker).c3k = onReferenceAdded;
  protoOf(ModelOperationsExecutorChecker).d3k = onReferenceRemoved;
  protoOf(ModelOperationsExecutorChecker).e3k = onModelBlobChanged;
  protoOf(EntityOperationsExecutorChecker).x3j = onRootAdded;
  protoOf(EntityOperationsExecutorChecker).z3j = onRootRemoved;
  protoOf(EntityOperationsExecutorChecker).p3j = onChildAdded;
  protoOf(EntityOperationsExecutorChecker).w3j = onChildRemoved;
  protoOf(EntityOperationsExecutorChecker).a3k = onChildMoved;
  protoOf(EntityOperationsExecutorChecker).b3k = onPropertyChanged;
  protoOf(EntityOperationsExecutorChecker).c3k = onReferenceAdded;
  protoOf(EntityOperationsExecutorChecker).d3k = onReferenceRemoved;
  protoOf(EntityOperationsExecutorChecker).e3k = onModelBlobChanged;
  protoOf(EntityOperationsExecutorChecker).f3k = onNodeEvent;
  protoOf(MetaIdPersister).p25 = deserialize;
  protoOf(MetaIdPersister).w24 = serialize;
  protoOf(EntityIdPersisters$entityReferencePersister$1).p25 = deserialize;
  protoOf(EntityIdPersisters$entityReferencePersister$1).w24 = serialize;
  protoOf(DefaultIdPersister).p25 = deserialize;
  protoOf(DefaultIdPersister).w24 = serialize;
  protoOf(CompressingIdPersister).p25 = deserialize;
  protoOf(CompressingIdPersister).w24 = serialize;
  protoOf(UndoCommandListener).w3y = onExternalOperationStarted;
  protoOf(UndoCommandListener).y3y = onExternalOperationFailed;
  protoOf(BaseUndoManager$addStateProvider$$inlined$toDisposable$1).j2l = plus_2;
  protoOf(BaseUndoManager).j2l = plus_2;
  protoOf(NodeWrapper$propertyByStringProperty$1).f2x = invoke_0;
  protoOf(WrapperContext$put$$inlined$toDisposable$1).j2l = plus_2;
  protoOf(WrapperContext).j2l = plus_2;
  protoOf(WrapperContextService).g3b = get_default;
  protoOf(WrapperContextService).e3b = invoke_1;
  protoOf(SerialDescriptorImpl).i5a = get_isNullable;
  protoOf(SerialDescriptorImpl).q5a = get_isInline;
  protoOf(AbstractDecoder).t5c = decodeSerializableElement$default;
  protoOf(AbstractDecoder).k59 = decodeSerializableValue;
  protoOf(AbstractDecoder).v5c = decodeSequentially;
  protoOf(AbstractDecoder).x5c = decodeCollectionSize;
  protoOf(AbstractEncoder).z5d = encodeNotNullMark;
  protoOf(AbstractEncoder).a5e = beginCollection;
  protoOf(AbstractEncoder).h59 = encodeSerializableValue;
  protoOf(AbstractEncoder).y5d = encodeNullableSerializableValue;
  protoOf(AbstractEncoder).b5e = shouldEncodeElementDefault;
  protoOf(ListLikeDescriptor).i5a = get_isNullable;
  protoOf(ListLikeDescriptor).q5a = get_isInline;
  protoOf(ListLikeDescriptor).w58 = get_annotations;
  protoOf(MapLikeDescriptor).i5a = get_isNullable;
  protoOf(MapLikeDescriptor).q5a = get_isInline;
  protoOf(MapLikeDescriptor).w58 = get_annotations;
  protoOf(PluginGeneratedSerialDescriptor).i5a = get_isNullable;
  protoOf(PluginGeneratedSerialDescriptor).q5a = get_isInline;
  protoOf(InlinePrimitiveDescriptor$1).g5k = typeParametersSerializers;
  protoOf(NothingSerialDescriptor).i5a = get_isNullable;
  protoOf(NothingSerialDescriptor).q5a = get_isInline;
  protoOf(NothingSerialDescriptor).w58 = get_annotations;
  protoOf(PrimitiveSerialDescriptor_0).i5a = get_isNullable;
  protoOf(PrimitiveSerialDescriptor_0).q5a = get_isInline;
  protoOf(PrimitiveSerialDescriptor_0).w58 = get_annotations;
  protoOf(TaggedDecoder).t5c = decodeSerializableElement$default;
  protoOf(TaggedDecoder).k59 = decodeSerializableValue;
  protoOf(TaggedDecoder).v5c = decodeSequentially;
  protoOf(TaggedDecoder).x5c = decodeCollectionSize;
  protoOf(TaggedEncoder).a5e = beginCollection;
  protoOf(TaggedEncoder).h59 = encodeSerializableValue;
  protoOf(TaggedEncoder).y5d = encodeNullableSerializableValue;
  protoOf(TaggedEncoder).b5e = shouldEncodeElementDefault;
  protoOf(EagerInvalidatable).w2w = invoke;
  protoOf(EagerInvalidatable).z2r = addHandler;
  protoOf(InvalidationPointBase$addHandler$$inlined$toDisposable$1).j2l = plus_2;
  protoOf(InvalidationPointBase).z2r = addHandler;
  protoOf(Invalidator).j2l = plus_2;
  protoOf(NonTrackingInvalidationContext).j2l = plus_2;
  protoOf(attributeQuery$$inlined$query$1).r5w = runSuspend;
  protoOf(LoopingQuery).w2w = invoke;
  protoOf(LoopingQuery).z2r = addHandler;
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0_1).j2l = plus_2;
  protoOf(constant$$inlined$query$1).r5w = runSuspend;
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0_2).j2l = plus_2;
  protoOf(QPropertyAdapter).r5w = runSuspend;
  protoOf(QPropertyAdapter).f2x = invoke_0;
  protoOf(QMutableListAdapter).q = addAll;
  protoOf(QMutableListAdapter).m2 = add_0;
  protoOf(QMutableListAdapter).j = add;
  protoOf(QMutableListAdapter).h2 = remove;
  protoOf(QMutableListAdapter).k2 = clear;
  protoOf(QMutableListAdapter).p = get_size;
  protoOf(QMutableListAdapter).t = contains;
  protoOf(QMutableListAdapter).r5w = runSuspend;
  protoOf(QReadablePropertyAdapter).r5w = runSuspend;
  protoOf(QListAdapter).p = get_size;
  protoOf(QListAdapter).t = contains;
  protoOf(QListAdapter).r5w = runSuspend;
  protoOf(QCollectionAdapter).p = get_size;
  protoOf(QCollectionAdapter).t = contains;
  protoOf(QCollectionAdapter).r5w = runSuspend;
  protoOf(QTextPropertyAdapter).r5w = runSuspend;
  protoOf(QMutableCollectionAdapter).j = add;
  protoOf(QMutableCollectionAdapter).h2 = remove;
  protoOf(QMutableCollectionAdapter).q = addAll;
  protoOf(QMutableCollectionAdapter).k2 = clear;
  protoOf(QMutableCollectionAdapter).p = get_size;
  protoOf(QMutableCollectionAdapter).t = contains;
  protoOf(QMutableCollectionAdapter).r5w = runSuspend;
  protoOf(JsonArray_0).asJsReadonlyArrayView = asJsReadonlyArrayView;
  protoOf(defer$1).i5a = get_isNullable;
  protoOf(defer$1).q5a = get_isInline;
  protoOf(defer$1).w58 = get_annotations;
  protoOf(PolymorphismValidator).k5t = contextual;
  protoOf(LocalNodePointerSupport$node$$inlined$query$1).r5w = runSuspend;
  protoOf(LocalNodePointerSupport).j2l = plus_2;
  protoOf(Companion_88).g3b = get_default;
  protoOf(Companion_88).e3b = invoke_1;
  protoOf(Companion_89).e3b = invoke_1;
  protoOf(OtNodeFactoryService).g3b = get_default;
  protoOf(OtNodeFactoryService).e3b = invoke_1;
  protoOf($serializer).g5k = typeParametersSerializers;
  protoOf(DomainNodePersister).p25 = deserialize;
  protoOf(DomainNodePersister).w24 = serialize;
  protoOf(FindNodeQueryProvider$findNode$1).z2r = addHandler;
  protoOf(FindNodeQueryProvider$findNode$$inlined$query$1).r5w = runSuspend;
  protoOf(FindNodeQueryProvider).j2l = plus_2;
  protoOf(OTNodePersister).p25 = deserialize;
  protoOf(OTNodePersister).w24 = serialize;
  protoOf(Companion_92).g3b = get_default;
  protoOf(Companion_92).e3b = invoke_1;
  protoOf(SameModelNodeFinder$find$$inlined$map$1).r5w = runSuspend;
  protoOf(SameModelNodeFinder).k6i = pointer;
  protoOf(SameModelNodeFinder).j2l = plus_2;
  protoOf(SingleRootNodePointerSupport$node$$inlined$query$1).r5w = runSuspend;
  protoOf(SingleRootNodePointerSupport).j2l = plus_2;
  protoOf(BaseTypedOtNode).bp = get_parent;
  protoOf(NodeSetupContextService).g3b = get_default;
  protoOf(NodeSetupContextService).e3b = invoke_1;
  protoOf(OTConceptImpl).q6l = createNode$default_0;
  protoOf(DomainNodeFactoryImpl).q6l = createNode$default_0;
  protoOf(ErrorNodeFactory).q6l = createNode$default_0;
  protoOf(OTConceptWrapperImpl).q6l = createNode$default_0;
  protoOf(DomainNodeWrapperFactoryImpl).q6l = createNode$default_0;
  protoOf(UseExperimentalNodeService).g3b = get_default;
  protoOf(UseExperimentalNodeService).e3b = invoke_1;
  protoOf(BaseDomainNodeProperty).r5w = runSuspend;
  protoOf(DomainNodeChildProperty).r5w = runSuspend;
  protoOf(DomainNodeInMemoryProperty).r5w = runSuspend;
  protoOf(DomainNodeTextProperty).r5w = runSuspend;
  protoOf(PropertyBasedReference).c6p = get_regular;
  protoOf(PropertyBasedReference).b6p = set;
  protoOf(PropertyBasedReference).d6p = invoke_3;
  protoOf(PropertyBasedReference).f2x = invoke_0;
  protoOf(PropertyBasedReference).e6p = runSuspend_0;
  protoOf(Companion_95).g3b = get_default;
  protoOf(Companion_95).e3b = invoke_1;
  protoOf(GlobalNodeFinder$find$$inlined$query$1).r5w = runSuspend;
  protoOf(PrecalculatedResolutionReference$Companion$throwIfMissing$$inlined$query$1).r5w = runSuspend;
  protoOf(PrecalculatedResolutionReference$resolve$$inlined$map$1).r5w = runSuspend;
  protoOf(PrecalculatedResolutionReference$find$$inlined$map$1).r5w = runSuspend;
  protoOf($serializer_0).g5k = typeParametersSerializers;
  protoOf($serializer_1).g5k = typeParametersSerializers;
  protoOf(ReferenceFactoryRegistryService).e3b = invoke_1;
  protoOf(ReferenceTargetPresentationProvidersRegistryService).e3b = invoke_1;
  protoOf(ReferenceTargetPresentationProvidersRegistryBuilderImpl).t6t = referenceTargetPresentation$default;
  protoOf(ReferenceTargetsSuppliersRegistryService).e3b = invoke_1;
  protoOf(ResolveConfigService).g3b = get_default;
  protoOf(ResolveConfigService).e3b = invoke_1;
  protoOf($serializer_2).g5k = typeParametersSerializers;
  protoOf($serializer_3).g5k = typeParametersSerializers;
  protoOf($serializer_4).g5k = typeParametersSerializers;
  protoOf(BaseDocumentRepository).a6v = provide;
  protoOf(BaseDocumentRepository).j2l = plus_2;
  protoOf(Companion_107).g3b = get_default;
  protoOf(Companion_107).e3b = invoke_1;
  protoOf(sam$jetbrains_ocelot_base_observable_event_EventSource$0).z2r = addHandler;
  protoOf(BaseDocumentContainer$documents$$inlined$query$1).r5w = runSuspend;
  protoOf(BaseDocumentContainer$getDocumentQuery$$inlined$query$1).r5w = runSuspend;
  protoOf(BaseDocumentContainer).j2l = plus_2;
  protoOf(Companion_109).g3b = get_default;
  protoOf(Companion_109).e3b = invoke_1;
  protoOf(Companion_109).w2w = invoke_2;
  protoOf(DocumentContainerProvider$provide$$inlined$query$1).r5w = runSuspend;
  protoOf(Companion_110).g3b = get_default;
  protoOf(Companion_110).e3b = invoke_1;
  protoOf($serializer_5).g5k = typeParametersSerializers;
  protoOf(DomainNodeConceptRegistry$getNodeFactory$1).h3t = createNode$default;
  protoOf(NodeWrapperConceptRegistryImpl).k6l = getNodeFactory;
  protoOf(ConceptRegistryService).g3b = get_default;
  protoOf(ConceptRegistryService).e3b = invoke_1;
  protoOf(BaseStructureModel).j2l = plus_2;
  protoOf(Companion_117).g3b = get_default;
  protoOf(Companion_117).e3b = invoke_1;
  protoOf(ancestorOrSelf$$inlined$query$1).r5w = runSuspend;
  protoOf(Companion_118).g3b = get_default;
  protoOf(Companion_118).e3b = invoke_1;
  protoOf(ErrorCheckConfigBuilder).e3c = getValue;
  protoOf(ScopeConfigBuilderImpl).t74 = with_0;
  protoOf(ScopeConfigService).g3b = get_default;
  protoOf(ScopeConfigService).e3b = invoke_1;
  protoOf(Companion_123).g3b = get_default;
  protoOf(Companion_123).e3b = invoke_1;
  protoOf(Companion_123).i3b = optional;
  protoOf(Companion_124).e3b = invoke_1;
  protoOf(ProvidedScopesContainer).j2l = plus_2;
  protoOf(ScopeProvidersManager).j2l = plus_2;
  protoOf(Companion_127).e3b = invoke_1;
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0_3).j2l = plus_2;
  protoOf(ScopingRulesEngine$getDocumentScope$$inlined$map$1).r5w = runSuspend;
  protoOf(CollectionScope).o72 = find_0;
  protoOf(CollectionScope).r72 = applyFilter;
  protoOf(DelegatingScope).r72 = applyFilter;
  protoOf(EmptyScope).o72 = find_0;
  protoOf(sam$jetbrains_ocelot_langDef_scopes_helper_ScopeListenerAdapter$0).w7s = onTargetAdded;
  protoOf(sam$jetbrains_ocelot_langDef_scopes_helper_ScopeListenerAdapter$0).x7s = onTargetRenamed;
  protoOf(sam$jetbrains_ocelot_langDef_scopes_helper_ScopeListenerAdapter$0).y7s = onTargetRemoved;
  protoOf(IndexingScope).o72 = find_0;
  protoOf(IndexingScope).r72 = applyFilter;
  protoOf(AbstractScopedReferenceResolver).j6q = find;
  protoOf(FindUsagesConfigService).g3b = get_default;
  protoOf(FindUsagesConfigService).e3b = invoke_1;
  protoOf(UsagePresentationData).z3n = get_id;
  protoOf(UsagePresentationData).f3t = get_conceptId;
  protoOf(UsagePresentationData).t42 = get_root;
  protoOf(UsagePresentationData).x6i = get_observableParent;
  protoOf(UsagePresentationData).y6i = get_roleInParent;
  protoOf(UsagePresentationData).f6j = clone;
  protoOf(UsagePresentationData).e6j = detach;
  protoOf(UsagePresentationData).d6j = replaceWith;
  protoOf(UsagePresentationData).g6j = getDescendants;
  protoOf(UsagePresentationData).h6j = getAllChildren;
  protoOf(UsagePresentationData).bp = get_parent;
  protoOf(BaseRoleSynchronizer).zr = dispose;
  protoOf(BaseRoleSynchronizer).j2l = plus_2;
  protoOf(ByTargetIndex).j2l = plus_2;
  protoOf(DisposableSynchronizer).zr = dispose;
  protoOf(DisposableSynchronizer).j2l = plus_2;
  protoOf(syncTwoWay$1).zr = dispose;
  protoOf(syncTwoWay$1).j2l = plus_2;
  protoOf(Mappers$attachRoot$$inlined$toDisposable$1).j2l = plus_2;
  protoOf(Synchronizers$forDisposables$1).zr = dispose;
  protoOf(Synchronizers$forDisposables$1).j2l = plus_2;
  protoOf(Synchronizers$composite$1).zr = dispose;
  protoOf(Synchronizers$composite$1).j2l = plus_2;
  protoOf(ReloadableSynchronizer).zr = dispose;
  protoOf(ReloadableSynchronizer).j2l = plus_2;
  protoOf(onEvent$$inlined$toDisposable$1).j2l = plus_2;
  protoOf(MultilineTextClipboardContent).g8i = toText;
  protoOf(SingleLineTextClipboardContent).g8i = toText;
  protoOf(BaseCell$ExternalChildList$addListener$cellListener$1).a8y = onPropertyChanged_0;
  protoOf(BaseCell$ExternalChildList$addListener$cellListener$1).b8y = onParentChanged;
  protoOf(BaseCell$ExternalChildList$addListener$cellListener$1).c8y = onAttach;
  protoOf(BaseCell$ExternalChildList$addListener$cellListener$1).d8y = onDetach;
  protoOf(BaseCell$cellContainer$1$addHandler$cellListener$1).a8y = onPropertyChanged_0;
  protoOf(BaseCell$cellContainer$1$addHandler$cellListener$1).v8x = onChildAdded_0;
  protoOf(BaseCell$cellContainer$1$addHandler$cellListener$1).w8x = onChildRemoved_0;
  protoOf(BaseCell$cellContainer$1$addHandler$cellListener$1).b8y = onParentChanged;
  protoOf(BaseCell$getProp$MyProperty$addHandler$cellListener$1).v8x = onChildAdded_0;
  protoOf(BaseCell$getProp$MyProperty$addHandler$cellListener$1).w8x = onChildRemoved_0;
  protoOf(BaseCell$getProp$MyProperty$addHandler$cellListener$1).b8y = onParentChanged;
  protoOf(BaseCell$getProp$MyProperty$addHandler$cellListener$1).c8y = onAttach;
  protoOf(BaseCell$getProp$MyProperty$addHandler$cellListener$1).d8y = onDetach;
  protoOf(ExternalChildList).z2r = addHandler;
  protoOf(BaseCell$addTrait$$inlined$toDisposable$1).j2l = plus_2;
  protoOf(BaseCell$cellContainer$1).w2w = invoke;
  protoOf(BaseCell$cellContainer$1).z2r = addHandler;
  protoOf(BaseCell$set$$inlined$toDisposable$1).j2l = plus_2;
  protoOf(BaseCell$getProp$MyProperty).f2x = invoke_0;
  protoOf(ScrollPopupSpec).n94 = get_isLowPriority;
  protoOf(onAsyncWorkDone$1).f39 = workStarted;
  protoOf(CompletionMenu$CompletionMenuModelMapper$registerSynchronizers$$inlined$writableProperty$1).f2x = invoke_0;
  protoOf(CompletionMenu$CompletionItemMapper$registerSynchronizers$$inlined$writableProperty$1).f2x = invoke_0;
  protoOf(CompletionMenuSpec).n94 = get_isLowPriority;
  protoOf(CompletionMenu$createCell$$inlined$toDisposable$1).j2l = plus_2;
  protoOf(CompletionSupport$showCompletion$$inlined$toDisposable$1).j2l = plus_2;
  protoOf(CompletionSupport$showCompletion$$inlined$writableProperty$1).f2x = invoke_0;
  protoOf(CompletionSupport$showCompletion$$inlined$toDisposable$2).j2l = plus_2;
  protoOf(CompletionSupport$showCompletion$$inlined$toDisposable$3).j2l = plus_2;
  protoOf(CompletionSupport$showCompletion$$inlined$toDisposable$4).j2l = plus_2;
  protoOf(PopupCompletionEditor$$inlined$toDisposable$1).j2l = plus_2;
  protoOf(PopupCompletionEditor).j2l = plus_2;
  protoOf(SimpleCompletionEditor).j2l = plus_2;
  protoOf(MyVisibleItemsUpdater).j2l = plus_2;
  protoOf(CompletionMenuModel).j2l = plus_2;
  protoOf(TransformedCompletionResult).l2n = get_items;
  protoOf(TransformedCompletionResult).w9l = transform;
  protoOf(TransformedCompletionResult).z2r = addHandler;
  protoOf(TransformedCompletionResult).j2l = plus_2;
  protoOf(CompletionResultTransformer$add$1).w9l = transform;
  protoOf(CompletionResultTransformer$add$1).z2r = addHandler;
  protoOf(CompletionResultTransformer$add$1).j2l = plus_2;
  protoOf(ReadyCompletionResult).l2n = get_items;
  protoOf(ReadyCompletionResult).w9l = transform;
  protoOf(ReadyCompletionResult).z2r = addHandler;
  protoOf(ReadyCompletionResult).j2l = plus_2;
  protoOf(FlowBasedCompletionResult).w9l = transform;
  protoOf(FlowBasedCompletionResult).z2r = addHandler;
  protoOf(FlowBasedCompletionResult).j2l = plus_2;
  protoOf(CellContainerPeerAdapter).t93 = scrollTo;
  protoOf(IndentCell$addListener$$inlined$toDisposable$1).j2l = plus_2;
  protoOf(MessagePopupSpec).n94 = get_isLowPriority;
  protoOf(setBackingToDefault$$inlined$toDisposable$1).j2l = plus_2;
  protoOf(MessagePopupSupport$doSubscribe$$inlined$toDisposable$1).j2l = plus_2;
  protoOf(MessagePopupSupport).j2l = plus_2;
  protoOf(MessageStyler$setProp$$inlined$toDisposable$1).j2l = plus_2;
  protoOf(MessageTrait$MyHoverController$schedule$$inlined$toDisposable$1).j2l = plus_2;
  protoOf(MessageViewWithLink).ua1 = setFontStyle;
  protoOf(SimpleMessageView).ua1 = setFontStyle;
  protoOf(BasePopupManager).j2l = plus_2;
  protoOf(DefaultPositionHandler$caretOffset$1).w2w = invoke;
  protoOf(DefaultPositionHandler$caretOffset$1).f2x = invoke_0;
  protoOf(DefaultPositionHandler$caretOffset$1).z2r = addHandler;
  protoOf(TextPositionHandler$caretOffset$1).w2w = invoke;
  protoOf(TextPositionHandler$caretOffset$1).f2x = invoke_0;
  protoOf(TextPositionHandler$caretOffset$1).z2r = addHandler;
  protoOf(InputMethodEditorUtil$showComposite$$inlined$toDisposable$1).j2l = plus_2;
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0_4).j2l = plus_2;
  protoOf(ValidTextEditingTrait$validate$$inlined$toDisposable$1).j2l = plus_2;
  protoOf(CellTraits$captureTo$$inlined$toDisposable$1).j2l = plus_2;
  protoOf(CellAttachWatcher).h93 = onBeforeCommand;
  protoOf(CellAttachWatcher).i93 = onAfterCommand;
  protoOf(TraitController).j2l = plus_2;
  protoOf(whenAttached$$inlined$toDisposable$1).j2l = plus_2;
  protoOf(LastCaretPositionSupport$onPropertyChanged$$inlined$toDisposable$1).j2l = plus_2;
  protoOf(FocusedCellHandler).j2l = plus_2;
  protoOf(HighlightUtil$highlightFocused$$inlined$toDisposable$1).j2l = plus_2;
  protoOf(BaseProjectionalSynchronizer).zr = dispose;
  protoOf(BaseProjectionalSynchronizer).j2l = plus_2;
  protoOf(ReadOnlyProjectionalSynchronizers$forSingleRole$target$1).f2x = invoke_0;
  protoOf(sam$jetbrains_ocelot_projectional_editor_cell_clipboard_PasteHandler$0).fav = plus_4;
  protoOf(ProjectionalClipboardContent).g8i = toText;
  protoOf(ProjectionalClipboardContentSerializationAsHtml$doGetPersister$1).p25 = deserialize;
  protoOf(ProjectionalClipboardContentSerializationAsHtml$doGetPersister$1).w24 = serialize;
  protoOf(ProjectionalClipboardContentSerializationAsHtml$doGetListPersister$1).p25 = deserialize;
  protoOf(ProjectionalClipboardContentSerializationAsHtml$doGetListPersister$1).w24 = serialize;
  protoOf(RoleSynchronizerSelectionSupport).j2l = plus_2;
  protoOf(SelectionSupport).j2l = plus_2;
  protoOf(ExternalPasteContent).g8i = toText;
  protoOf(View$ExternalChildList$addListener$1).cb9 = onPropertySet;
  protoOf(View$ExternalChildList$addListener$1).db9 = onViewValidated;
  protoOf(View$ExternalChildList$addListener$1).eb9 = onViewInvalidated;
  protoOf(View$ExternalChildList$addListener$1).fb9 = onViewAttached;
  protoOf(View$ExternalChildList$addListener$1).gb9 = onViewDetached;
  protoOf(View$ExternalChildList$addListener$1).hb9 = onBoundsChanged;
  protoOf(View$ExternalChildList$addListener$1).ib9 = onToRootDeltaChanged;
  protoOf(View$ExternalChildList$addListener$1).yb8 = onParentChanged_0;
  protoOf(View$getProp$1$addHandler$1).db9 = onViewValidated;
  protoOf(View$getProp$1$addHandler$1).eb9 = onViewInvalidated;
  protoOf(View$getProp$1$addHandler$1).fb9 = onViewAttached;
  protoOf(View$getProp$1$addHandler$1).gb9 = onViewDetached;
  protoOf(View$getProp$1$addHandler$1).hb9 = onBoundsChanged;
  protoOf(View$getProp$1$addHandler$1).ib9 = onToRootDeltaChanged;
  protoOf(View$getProp$1$addHandler$1).rb8 = onChildAdded_2;
  protoOf(View$getProp$1$addHandler$1).sb8 = onChildRemoved_2;
  protoOf(View$getProp$1$addHandler$1).yb8 = onParentChanged_0;
  protoOf(View$customFeatureChange$1$addHandler$1).cb9 = onPropertySet;
  protoOf(View$customFeatureChange$1$addHandler$1).db9 = onViewValidated;
  protoOf(View$customFeatureChange$1$addHandler$1).eb9 = onViewInvalidated;
  protoOf(View$customFeatureChange$1$addHandler$1).fb9 = onViewAttached;
  protoOf(View$customFeatureChange$1$addHandler$1).gb9 = onViewDetached;
  protoOf(View$customFeatureChange$1$addHandler$1).hb9 = onBoundsChanged;
  protoOf(View$customFeatureChange$1$addHandler$1).ib9 = onToRootDeltaChanged;
  protoOf(View$customFeatureChange$1$addHandler$1).rb8 = onChildAdded_2;
  protoOf(View$customFeatureChange$1$addHandler$1).sb8 = onChildRemoved_2;
  protoOf(View$customFeatureChange$1$addHandler$1).yb8 = onParentChanged_0;
  protoOf(View$valid$1$addHandler$1).cb9 = onPropertySet;
  protoOf(View$valid$1$addHandler$1).fb9 = onViewAttached;
  protoOf(View$valid$1$addHandler$1).gb9 = onViewDetached;
  protoOf(View$valid$1$addHandler$1).hb9 = onBoundsChanged;
  protoOf(View$valid$1$addHandler$1).ib9 = onToRootDeltaChanged;
  protoOf(View$valid$1$addHandler$1).rb8 = onChildAdded_2;
  protoOf(View$valid$1$addHandler$1).sb8 = onChildRemoved_2;
  protoOf(View$valid$1$addHandler$1).yb8 = onParentChanged_0;
  protoOf(View$toRootDelta$1$addHandler$reg$1).cb9 = onPropertySet;
  protoOf(View$toRootDelta$1$addHandler$reg$1).db9 = onViewValidated;
  protoOf(View$toRootDelta$1$addHandler$reg$1).eb9 = onViewInvalidated;
  protoOf(View$toRootDelta$1$addHandler$reg$1).fb9 = onViewAttached;
  protoOf(View$toRootDelta$1$addHandler$reg$1).gb9 = onViewDetached;
  protoOf(View$toRootDelta$1$addHandler$reg$1).hb9 = onBoundsChanged;
  protoOf(View$toRootDelta$1$addHandler$reg$1).rb8 = onChildAdded_2;
  protoOf(View$toRootDelta$1$addHandler$reg$1).sb8 = onChildRemoved_2;
  protoOf(View$toRootDelta$1$addHandler$reg$1).yb8 = onParentChanged_0;
  protoOf(View$toRootDelta$1$addHandler$$inlined$toDisposable$1).j2l = plus_2;
  protoOf(View$boundsProp$1$addHandler$3).cb9 = onPropertySet;
  protoOf(View$boundsProp$1$addHandler$3).db9 = onViewValidated;
  protoOf(View$boundsProp$1$addHandler$3).eb9 = onViewInvalidated;
  protoOf(View$boundsProp$1$addHandler$3).fb9 = onViewAttached;
  protoOf(View$boundsProp$1$addHandler$3).gb9 = onViewDetached;
  protoOf(View$boundsProp$1$addHandler$3).ib9 = onToRootDeltaChanged;
  protoOf(View$boundsProp$1$addHandler$3).rb8 = onChildAdded_2;
  protoOf(View$boundsProp$1$addHandler$3).sb8 = onChildRemoved_2;
  protoOf(View$boundsProp$1$addHandler$3).yb8 = onParentChanged_0;
  protoOf(View$attachEvents$1$addHandler$1).cb9 = onPropertySet;
  protoOf(View$attachEvents$1$addHandler$1).db9 = onViewValidated;
  protoOf(View$attachEvents$1$addHandler$1).eb9 = onViewInvalidated;
  protoOf(View$attachEvents$1$addHandler$1).gb9 = onViewDetached;
  protoOf(View$attachEvents$1$addHandler$1).hb9 = onBoundsChanged;
  protoOf(View$attachEvents$1$addHandler$1).ib9 = onToRootDeltaChanged;
  protoOf(View$attachEvents$1$addHandler$1).rb8 = onChildAdded_2;
  protoOf(View$attachEvents$1$addHandler$1).sb8 = onChildRemoved_2;
  protoOf(View$attachEvents$1$addHandler$1).yb8 = onParentChanged_0;
  protoOf(ExternalChildList_0).z2r = addHandler;
  protoOf(ToParentOffsetProperty).f2x = invoke_0;
  protoOf(View$getProp$1).w2w = invoke;
  protoOf(View$getProp$1).f2x = invoke_0;
  protoOf(View$getProp$1).z2r = addHandler;
  protoOf(View$addListener$$inlined$toDisposable$1).j2l = plus_2;
  protoOf(View$customFeatureChange$1).z2r = addHandler;
  protoOf(View$attachEvents$1).z2r = addHandler;
  protoOf(ViewContainer$RootView$1).cb9 = onPropertySet;
  protoOf(ViewContainer$RootView$1).db9 = onViewValidated;
  protoOf(ViewContainer$RootView$1).eb9 = onViewInvalidated;
  protoOf(ViewContainer$RootView$1).fb9 = onViewAttached;
  protoOf(ViewContainer$RootView$1).gb9 = onViewDetached;
  protoOf(ViewContainer$RootView$1).hb9 = onBoundsChanged;
  protoOf(ViewContainer$RootView$1).ib9 = onToRootDeltaChanged;
  protoOf(ViewContainer$RootView$1).yb8 = onParentChanged_0;
  protoOf(AlignmentSynchronizers$bindStyle$$inlined$writableProperty$1).f2x = invoke_0;
  protoOf(CellContainerToDomMapper$registerSynchronizers$$inlined$writableProperty$1).f2x = invoke_0;
  protoOf(CellContainerToDomMapper$registerSynchronizers$2).h93 = onBeforeCommand;
  protoOf(CellContainerToDomMapper$registerSynchronizers$2).i93 = onAfterCommand;
  protoOf(CellContainerToDomMapper$createCellContainerPeer$1).t93 = scrollTo;
  protoOf(CellMapperRefresher$registerHideable$$inlined$toDisposable$1).j2l = plus_2;
  protoOf(CellToDomContext).j2l = plus_2;
  protoOf(DefaultLineHighlight).j2l = plus_2;
  protoOf(DomCellMapper$registerSynchronizers$$inlined$writableProperty$1).f2x = invoke_0;
  protoOf(DomPopupManager$setPopupUpdate$$inlined$toDisposable$1).j2l = plus_2;
  protoOf(DomTextInput).j2l = plus_2;
  protoOf(EmptyLineHighlight).j2l = plus_2;
  protoOf(ImageCellMapper$registerSynchronizers$$inlined$writableProperty$1).f2x = invoke_0;
  protoOf(TextCellMapper$refreshProperties$$inlined$toDisposable$1).j2l = plus_2;
  protoOf(TextPlaceholderCellMapper$registerSynchronizers$$inlined$writableProperty$1).f2x = invoke_0;
  protoOf(TextPlaceholderCellMapper$registerSynchronizers$$inlined$writableProperty$2).f2x = invoke_0;
  protoOf(Tooltip$injectCornerStyle$$inlined$toDisposable$1).j2l = plus_2;
  protoOf(ViewCellMapper$registerSynchronizers$$inlined$writableProperty$1).f2x = invoke_0;
  protoOf(DomUtil$scheduleDeferred$$inlined$toDisposable$1).j2l = plus_2;
  protoOf(BaseViewMapper$registerSynchronizers$$inlined$writableProperty$1).f2x = invoke_0;
  protoOf(BaseViewMapper$registerSynchronizers$$inlined$writableProperty$2).f2x = invoke_0;
  protoOf(BaseViewMapper$registerSynchronizers$$inlined$writableProperty$3).f2x = invoke_0;
  protoOf(DomViewMapper$registerSynchronizers$$inlined$writableProperty$1).f2x = invoke_0;
  protoOf(DomViewMapper$registerSynchronizers$$inlined$writableProperty$2).f2x = invoke_0;
  protoOf(DomViewSynchronizers$boundsSynchronizer$$inlined$writableProperty$1).f2x = invoke_0;
  protoOf(ImageViewMapper$registerSynchronizers$$inlined$writableProperty$1).f2x = invoke_0;
  protoOf(LineViewMapper$registerSynchronizers$$inlined$writableProperty$1).f2x = invoke_0;
  protoOf(LineViewMapper$registerSynchronizers$$inlined$writableProperty$2).f2x = invoke_0;
  protoOf(LineViewMapper$registerSynchronizers$$inlined$writableProperty$3).f2x = invoke_0;
  protoOf(LineViewMapper$registerSynchronizers$$inlined$writableProperty$4).f2x = invoke_0;
  protoOf(MultiPointViewMapper$registerSynchronizers$1).zr = dispose;
  protoOf(MultiPointViewMapper$registerSynchronizers$1).j2l = plus_2;
  protoOf(MultiPointViewMapper$registerSynchronizers$$inlined$writableProperty$1).f2x = invoke_0;
  protoOf(MultiPointViewMapper$registerSynchronizers$$inlined$writableProperty$2).f2x = invoke_0;
  protoOf(ScrollViewMapper$registerSynchronizers$$inlined$writableProperty$1).f2x = invoke_0;
  protoOf(ScrollViewMapper$registerSynchronizers$$inlined$writableProperty$2).f2x = invoke_0;
  protoOf(TextViewMapper$registerSynchronizers$$inlined$writableProperty$1).f2x = invoke_0;
  protoOf(TextViewMapper$registerSynchronizers$$inlined$writableProperty$2).f2x = invoke_0;
  protoOf(TextViewMapper$registerSynchronizers$$inlined$writableProperty$3).f2x = invoke_0;
  protoOf(TextViewMapper$registerSynchronizers$$inlined$writableProperty$4).f2x = invoke_0;
  protoOf(TextViewMapper$registerSynchronizers$$inlined$writableProperty$5).f2x = invoke_0;
  protoOf(TextViewMapper$registerSynchronizers$$inlined$writableProperty$6).f2x = invoke_0;
  protoOf(TextViewMapper$registerSynchronizers$$inlined$writableProperty$7).f2x = invoke_0;
  protoOf(TextViewMapper$registerSynchronizers$$inlined$writableProperty$8).f2x = invoke_0;
  protoOf(TextViewMapper$registerSynchronizers$$inlined$writableProperty$9).f2x = invoke_0;
  protoOf(TextViewMapper$registerSynchronizers$$inlined$writableProperty$10).f2x = invoke_0;
  protoOf(TextViewMapper$registerSynchronizers$$inlined$writableProperty$11).f2x = invoke_0;
  protoOf(VerticalViewMapper$registerSynchronizers$$inlined$writableProperty$1).f2x = invoke_0;
  protoOf(ViewContainerToElementMapper$registerSynchronizers$$inlined$writableProperty$1).f2x = invoke_0;
  protoOf(CellStateAfterExternalOpRestorer).u3y = onCommandStarted;
  protoOf(CellStateAfterExternalOpRestorer).r3y = onOperationPerformed;
  protoOf(CellStateAfterExternalOpRestorer).v3y = onCommandCommitted;
  protoOf(CellStateAfterExternalOpRestorer).y3y = onExternalOperationFailed;
  protoOf(CellStateManager$1).h93 = onBeforeCommand;
  protoOf(CellStateManager$1).i93 = onAfterCommand;
  protoOf(CellStateManager).j2l = plus_2;
  protoOf(NavigationManager$2).u3y = onCommandStarted;
  protoOf(NavigationManager$2).v3y = onCommandCommitted;
  protoOf(NavigationManager$2).w3y = onExternalOperationStarted;
  protoOf(NavigationManager$2).y3y = onExternalOperationFailed;
  protoOf(NavigationManager).j2l = plus_2;
  protoOf(CellContainerCommandWatcher).j93 = onCellPropertyChanged;
  protoOf(CellContainerCommandWatcher).k93 = onChildAdded_1;
  protoOf(CellContainerCommandWatcher).j2l = plus_2;
  protoOf(OtSupport).j2l = plus_2;
  protoOf(NodeWrapperCellProvider).nc5 = getNode$default;
  protoOf(OtNodeCellProvider).nc5 = getNode$default;
  protoOf(HighlightErrorsSynchronizer).zr = dispose;
  protoOf(HighlightErrorsSynchronizer).j2l = plus_2;
  protoOf(ErrorSupport$addError$$inlined$toDisposable$1).j2l = plus_2;
  protoOf(CheckNodeSynchronizer).zr = dispose;
  protoOf(CheckNodeSynchronizer).j2l = plus_2;
  protoOf(ErrorHighlighterBase$registerSynchronizers$1).zr = dispose;
  protoOf(ErrorHighlighterBase$registerSynchronizers$1).j2l = plus_2;
  protoOf(_no_name_provided__qut3iv_3).f2x = invoke_0;
  protoOf(projectionalChild$4$2$target$1).f2x = invoke_0;
  protoOf(SimpleMapperBuilder$build$builderContext$1).icq = getCell;
  protoOf(LineMapper$registerSynchronizers$$inlined$writableProperty$1).f2x = invoke_0;
  protoOf(indentLabel$2$$inlined$writableProperty$1).f2x = invoke_0;
  protoOf(EditorMapperFactoryImpl).sd2 = createMapper;
  protoOf(EditorBuilderConfigImpl).nd5 = get_highlightErrors;
  protoOf(EditorBuilderConfigImpl).acu = get_readOnly;
  protoOf(BaseEditor$createMapper$triggerContentUpdateSynchronizer$1).zr = dispose;
  protoOf(BaseEditor$createMapper$triggerContentUpdateSynchronizer$1).j2l = plus_2;
  protoOf(NodeWrapperReferenceAdapter$afterPaste$1).o38 = plus_3;
  protoOf(NodeWrapperReferenceAdapter$afterPaste$1).j2l = plus_2;
  protoOf(NodeWrapperReferenceAdapter).fav = plus_4;
  protoOf(BaseNodeCloneSupport).tas = copy$default;
  protoOf(BaseNodeCloneSupport).yas = copyList$default;
  protoOf(getReferenceRoleEditor$2$4$1).a8y = onPropertyChanged_0;
  protoOf(getReferenceRoleEditor$2$4$1).v8x = onChildAdded_0;
  protoOf(getReferenceRoleEditor$2$4$1).w8x = onChildRemoved_0;
  protoOf(getReferenceRoleEditor$2$4$1).b8y = onParentChanged;
  protoOf(getReferenceRoleEditor$2$4$1).d8y = onDetach;
  protoOf(focusGuarded$1).f2x = invoke_0;
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0_5).j2l = plus_2;
  protoOf(referenceOutOfScopeSynchronizer$outOfScopeMessage$1).f2x = invoke_0;
  protoOf(highlightReferenceTargetOutOfSync$visual$1).f2x = invoke_0;
  protoOf(JSLogger).tde = severe$default;
  protoOf(JSLogger).vde = warning$default;
  protoOf(DomainModel).j2l = plus_2;
  protoOf(ByteChannelSequentialBase).hdm = readRemaining$default;
  protoOf(ChannelJob).sp = cancel$default;
  protoOf(ChannelJob).mp = invokeOnCompletion$default;
  protoOf(DefaultPool).d2n = close;
  protoOf(ChunkBuffer$Companion$EmptyPool$1).d2n = close;
  protoOf(NoPoolImpl).d2n = close;
  protoOf(AttributesJs).ldu = get_1;
  protoOf(DefaultWebSocketSessionImpl).ve0 = send;
  defineProp(protoOf(FrameTooBigException), 'message', function () {
    return this.e();
  });
  protoOf(ProtobufTaggedDecoder).t5c = decodeSerializableElement$default;
  protoOf(ProtobufTaggedDecoder).k59 = decodeSerializableValue;
  protoOf(ProtobufTaggedDecoder).v5c = decodeSequentially;
  protoOf(ProtobufTaggedDecoder).x5c = decodeCollectionSize;
  protoOf(ProtobufTaggedEncoder).z5d = encodeNotNullMark;
  protoOf(ProtobufTaggedEncoder).a5e = beginCollection;
  protoOf(ProtobufTaggedEncoder).h59 = encodeSerializableValue;
  protoOf(ProtobufTaggedEncoder).y5d = encodeNullableSerializableValue;
  protoOf(ProtobufTaggedEncoder).b5e = shouldEncodeElementDefault;
  protoOf($serializer_6).g5k = typeParametersSerializers;
  protoOf($serializer_7).g5k = typeParametersSerializers;
  protoOf($serializer_8).g5k = typeParametersSerializers;
  protoOf(RemoteInstancePublication).j2l = plus_2;
  protoOf($serializer_9).g5k = typeParametersSerializers;
  protoOf(RpcEndpointMethod).sp = cancel$default;
  protoOf(RpcEndpointMethod).mp = invokeOnCompletion$default;
  protoOf(RpcEndpointImpl).j2l = plus_2;
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0_6).j2l = plus_2;
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0_7).j2l = plus_2;
  protoOf(RpcFacadeImpl).zeg = publishInstance$default;
  protoOf(RpcInstancesPublisher).j2l = plus_2;
  protoOf($serializer_11).g5k = typeParametersSerializers;
  protoOf($serializer_12).g5k = typeParametersSerializers;
  protoOf($serializer_13).g5k = typeParametersSerializers;
  protoOf($serializer_14).g5k = typeParametersSerializers;
  protoOf(Companion_280).g3b = get_default;
  protoOf(Companion_280).e3b = invoke_1;
  protoOf(flowBasedMethod$2$$inlined$toDisposable$1).j2l = plus_2;
  protoOf(RemoteDisposable).j2l = plus_2;
  protoOf($serializer_16).g5k = typeParametersSerializers;
  protoOf($serializer_17).g5k = typeParametersSerializers;
  protoOf($serializer_18).g5k = typeParametersSerializers;
  protoOf($serializer_19).g5k = typeParametersSerializers;
  protoOf($serializer_20).g5k = typeParametersSerializers;
  protoOf($serializer_21).g5k = typeParametersSerializers;
  protoOf($serializer_22).g5k = typeParametersSerializers;
  protoOf($serializer_23).g5k = typeParametersSerializers;
  protoOf($serializer_24).g5k = typeParametersSerializers;
  protoOf($serializer_25).g5k = typeParametersSerializers;
  protoOf($serializer_26).g5k = typeParametersSerializers;
  protoOf($serializer_27).g5k = typeParametersSerializers;
  protoOf($serializer_28).g5k = typeParametersSerializers;
  protoOf($serializer_29).g5k = typeParametersSerializers;
  protoOf($serializer_30).g5k = typeParametersSerializers;
  protoOf($serializer_31).g5k = typeParametersSerializers;
  protoOf($serializer_32).g5k = typeParametersSerializers;
  protoOf($serializer_33).g5k = typeParametersSerializers;
  protoOf($serializer_34).g5k = typeParametersSerializers;
  protoOf(RemoteErrorCheckConfig$checking$1$check$$inlined$query$1).r5w = runSuspend;
  protoOf(sam$jetbrains_ocelot_base_observable_event_EventSource$0_0).z2r = addHandler;
  protoOf(sam$jetbrains_ocelot_base_observable_event_EventSource$0_1).z2r = addHandler;
  protoOf(LiveResolutionClientState$findTarget$$inlined$query$1).r5w = runSuspend;
  protoOf(LiveResolutionClientState$findLocalTarget$$inlined$query$1).r5w = runSuspend;
  protoOf(Companion_309).g3b = get_default;
  protoOf(Companion_309).e3b = invoke_1;
  protoOf(Companion_310).g3b = get_default;
  protoOf(Companion_310).e3b = invoke_1;
  protoOf(AbstractLinkImpl).aft = get_defaultLibraryReference;
  protoOf(BTBDocumentImpl).li0 = librariesForElement;
  protoOf(BindingPropertyImpl).y2 = get_name;
  protoOf(BindingPropertyImpl).sfq = get_type;
  protoOf(PublishedWorkImpl).li1 = citation;
  protoOf(ClassExpressionTypeImpl).sfq = get_type_0;
  protoOf(ComplexNotionValueImpl).ri3 = transformToPropertyReferenceValue;
  protoOf(EmptyBindingEntryImpl).y2 = get_name_1;
  protoOf(EnumValueImpl).ri3 = transformToPropertyReferenceValue;
  protoOf(FunctionTermImpl).ri3 = transformToPropertyReferenceValue;
  protoOf(ImportedLinkImpl).y2 = get_name_2;
  protoOf(ImportedLinkImpl).gfq = get_element;
  protoOf(ImportedLinkImpl).jfr = get_specificator;
  protoOf(ImportedPropertyImpl).y2 = get_name_3;
  protoOf(ImportedPropertyImpl).sfq = get_type_1;
  protoOf(IntegerValueImpl).ri3 = transformToPropertyReferenceValue;
  protoOf(LibraryProcessSpecificationImpl).dia = meaningfulParametersNewStructure;
  protoOf(LocalOntologyElementReferenceImpl).eib = get_getClassDeclaration;
  protoOf(MeasurableValueImpl).pib = intAmount;
  protoOf(MeasurableValueImpl).ri3 = transformToPropertyReferenceValue;
  protoOf(MultipliedExpressionImpl).bid = get_multiplier;
  protoOf(NoValuesImpl).cfs = get_types;
  protoOf(ObjectPropertyReferenceValueImpl).rie = removePropertyReference;
  protoOf(ObjectPropertyReferenceValueImpl).ri3 = transformToPropertyReferenceValue;
  protoOf(OldPublishedSourceImpl).li1 = citation_0;
  protoOf(OntologyElementImpl).hig = allTaxonElements;
  protoOf(OntologyElementPropertyTypeImpl).sfq = get_type_0;
  protoOf(OntologyElementReferenceImpl).eib = get_getClassDeclaration;
  protoOf(OntologyElementReferenceValueImpl).ri3 = transformToPropertyReferenceValue;
  protoOf(OntologyIsRelationImpl).eii = getElementReference;
  protoOf(OntologyLinkImpl).y2 = get_name_5;
  protoOf(OntologyLinkImpl).gfq = get_element_0;
  protoOf(OntologyLinkImpl).jfr = get_specificator_0;
  protoOf(OntologyLinkValueImpl).fij = importedLibraries;
  protoOf(PartValueImpl).pik = transformToVariableReference;
  protoOf(PartValueImpl).ri3 = transformToPropertyReferenceValue;
  protoOf(PrimitivePropertyTypeImpl).sfq = get_type_0;
  protoOf(ProcessDeclarationImpl).qil = aliasedProperties;
  protoOf(ProcessDeclarationImpl).ril = allEntries;
  protoOf(ProcessDeclarationImpl).sil = allProperties;
  protoOf(ProcessDeclarationImpl).til = allSuperProperties;
  protoOf(ProcessDeclarationImpl).uil = allInheritedProcesses;
  protoOf(ProcessDeclarationImpl).vil = cycleInExtends;
  protoOf(ProcessPropertyReferenceImpl).ri3 = transformToPropertyReferenceValue;
  protoOf(ProcessRelationDeclarationImpl).kio = isValid;
  protoOf(PropertyLibraryImpl).rfp = get_properties;
  protoOf(QualifiedOntologyElementReferenceImpl).gfq = get_element_1;
  protoOf(QualifiedOntologyElementReferenceImpl).eib = get_getClassDeclaration;
  protoOf(SetExpressionImpl).ri3 = transformToPropertyReferenceValue;
  protoOf(SimplePropertyTypeImpl).sfq = get_type_0;
  protoOf(StringValueImpl).ri3 = transformToPropertyReferenceValue;
  protoOf(TypedAbstractLinkImpl).aft = get_defaultLibraryReference;
  protoOf(TypedBTBDocumentImpl).li0 = librariesForElement;
  protoOf(TypedBindingPropertyImpl).y2 = get_name;
  protoOf(TypedBindingPropertyImpl).sfq = get_type;
  protoOf(TypedPublishedWorkImpl).li1 = citation;
  protoOf(TypedClassExpressionTypeImpl).sfq = get_type_0;
  protoOf(TypedComplexNotionValueImpl).ri3 = transformToPropertyReferenceValue;
  protoOf(TypedEmptyBindingEntryImpl).y2 = get_name_1;
  protoOf(TypedEnumValueImpl).ri3 = transformToPropertyReferenceValue;
  protoOf(TypedFunctionTermImpl).ri3 = transformToPropertyReferenceValue;
  protoOf(TypedImportedLinkImpl).y2 = get_name_2;
  protoOf(TypedImportedLinkImpl).gfq = get_element;
  protoOf(TypedImportedLinkImpl).jfr = get_specificator;
  protoOf(TypedImportedPropertyImpl).y2 = get_name_3;
  protoOf(TypedImportedPropertyImpl).sfq = get_type_1;
  protoOf(TypedIntegerValueImpl).ri3 = transformToPropertyReferenceValue;
  protoOf(TypedLibraryProcessSpecificationImpl).dia = meaningfulParametersNewStructure;
  protoOf(TypedLocalOntologyElementReferenceImpl).eib = get_getClassDeclaration;
  protoOf(TypedMeasurableValueImpl).pib = intAmount;
  protoOf(TypedMeasurableValueImpl).ri3 = transformToPropertyReferenceValue;
  protoOf(TypedMultipliedExpressionImpl).bid = get_multiplier;
  protoOf(TypedNoValuesImpl).cfs = get_types;
  protoOf(TypedObjectPropertyReferenceValueImpl).rie = removePropertyReference;
  protoOf(TypedObjectPropertyReferenceValueImpl).ri3 = transformToPropertyReferenceValue;
  protoOf(TypedOldPublishedSourceImpl).li1 = citation_0;
  protoOf(TypedOntologyElementImpl).hig = allTaxonElements;
  protoOf(TypedOntologyElementPropertyTypeImpl).sfq = get_type_0;
  protoOf(TypedOntologyElementReferenceImpl).eib = get_getClassDeclaration;
  protoOf(TypedOntologyElementReferenceValueImpl).ri3 = transformToPropertyReferenceValue;
  protoOf(TypedOntologyIsRelationImpl).eii = getElementReference;
  protoOf(TypedOntologyLinkImpl).y2 = get_name_5;
  protoOf(TypedOntologyLinkImpl).gfq = get_element_0;
  protoOf(TypedOntologyLinkImpl).jfr = get_specificator_0;
  protoOf(TypedOntologyLinkValueImpl).fij = importedLibraries;
  protoOf(TypedPartValueImpl).pik = transformToVariableReference;
  protoOf(TypedPartValueImpl).ri3 = transformToPropertyReferenceValue;
  protoOf(TypedPrimitivePropertyTypeImpl).sfq = get_type_0;
  protoOf(TypedProcessDeclarationImpl).qil = aliasedProperties;
  protoOf(TypedProcessDeclarationImpl).ril = allEntries;
  protoOf(TypedProcessDeclarationImpl).sil = allProperties;
  protoOf(TypedProcessDeclarationImpl).til = allSuperProperties;
  protoOf(TypedProcessDeclarationImpl).uil = allInheritedProcesses;
  protoOf(TypedProcessDeclarationImpl).vil = cycleInExtends;
  protoOf(TypedProcessPropertyReferenceImpl).ri3 = transformToPropertyReferenceValue;
  protoOf(TypedProcessRelationDeclarationImpl).kio = isValid;
  protoOf(TypedPropertyLibraryImpl).rfp = get_properties;
  protoOf(TypedQualifiedOntologyElementReferenceImpl).gfq = get_element_1;
  protoOf(TypedQualifiedOntologyElementReferenceImpl).eib = get_getClassDeclaration;
  protoOf(TypedSetExpressionImpl).ri3 = transformToPropertyReferenceValue;
  protoOf(TypedSimplePropertyTypeImpl).sfq = get_type_0;
  protoOf(TypedStringValueImpl).ri3 = transformToPropertyReferenceValue;
  protoOf(TypedUnionClassImpl).eib = get_getClassDeclaration_0;
  protoOf(TypedUnionClassImpl).ri3 = transformToPropertyReferenceValue;
  protoOf(TypedValueWithRelationsImpl).ri3 = transformToPropertyReferenceValue;
  protoOf(TypedVariableReferenceValueImpl).ri3 = transformToPropertyReferenceValue;
  protoOf(UnionClassImpl).eib = get_getClassDeclaration_0;
  protoOf(UnionClassImpl).ri3 = transformToPropertyReferenceValue;
  protoOf(ValueWithRelationsImpl).ri3 = transformToPropertyReferenceValue;
  protoOf(VariableReferenceValueImpl).ri3 = transformToPropertyReferenceValue;
  protoOf(LinkStubImpl).gfq = get_element_2;
  protoOf(LinkStubImpl).jfr = get_specificator_1;
  protoOf(TypedLinkStubImpl).gfq = get_element_2;
  protoOf(TypedLinkStubImpl).jfr = get_specificator_1;
  protoOf(BtbOtNodePersister).p25 = deserialize;
  protoOf(BtbOtNodePersister).w24 = serialize;
  protoOf(OntologyLink$specificator$$inlined$query$1).r5w = runSuspend;
  protoOf(QualifiedOntologyElementReference$element$$inlined$executeQuery$1).r5w = runSuspend;
  protoOf(OntologyIsRelation$getElementReference$$inlined$executeQuery$1).r5w = runSuspend;
  protoOf(ProcessPropertyType$type$$inlined$query$1).r5w = runSuspend;
  protoOf(BindingProperty$name$$inlined$query$1).r5w = runSuspend;
  protoOf(PropertyLibrary$properties$$inlined$map$1).r5w = runSuspend;
  protoOf(PublishedWork$citation$$inlined$query$1).r5w = runSuspend;
  protoOf(PublishedWork$authorsPart$$inlined$query$1).r5w = runSuspend;
  protoOf(ProcessRelationDeclaration$isValid$$inlined$query$1).r5w = runSuspend;
  protoOf(PartValue$transformToVariableReference$$inlined$executeQuery$1).r5w = runSuspend;
  protoOf(ObjectPropertyReferenceValue$removePropertyReference$$inlined$executeQuery$1).r5w = runSuspend;
  protoOf(ImplicitOne).klv = toMultiplierText;
  protoOf(Unknown).klv = toMultiplierText;
  protoOf(Exact).klv = toMultiplierText;
  protoOf(btbErrorChecking$2$6$$inlined$query$1).r5w = runSuspend;
  protoOf(btbErrorChecking$2$14$$inlined$query$1).r5w = runSuspend;
  protoOf(btbErrorChecking$2$54$$inlined$query$1).r5w = runSuspend;
  protoOf(duplicatesBy$$inlined$query$1).r5w = runSuspend;
  protoOf(DocumentNodeFinder$find$$inlined$query$1).r5w = runSuspend;
  protoOf(DocumentNodeFinder).k6i = pointer;
  protoOf(Companion_358).e3b = invoke_1;
  protoOf(Companion_358).w2w = invoke_2;
  protoOf(Companion_359).e3b = invoke_1;
  protoOf(Companion_359).w2w = invoke_2;
  protoOf(PublishedWorkReferenceResolver$resolve$$inlined$map$1).r5w = runSuspend;
  protoOf(PublishedWorkReferenceResolver).j6q = find;
  protoOf(SubtypeScopeFilterService$Companion$default$1).dml = provideFilterFor;
  protoOf(Companion_360).e3b = invoke_1;
  protoOf(Companion_360).w2w = invoke_2;
  protoOf(TaxonScopeFilterService$Companion$default$1).dml = provideFilterFor_0;
  protoOf(Companion_361).e3b = invoke_1;
  protoOf(Companion_361).w2w = invoke_2;
  protoOf($serializer_35).g5k = typeParametersSerializers;
  protoOf(OntologyElementReferenceAdapter).bpg = resolve;
  protoOf(getAllNaturalDefinitionElements$$inlined$map$1).r5w = runSuspend;
  protoOf(getAssertedDefinitionElements$$inlined$map$1).r5w = runSuspend;
  protoOf($serializer_36).g5k = typeParametersSerializers;
  protoOf($serializer_37).g5k = typeParametersSerializers;
  protoOf(EmptyHeaders).ld = get_2;
  protoOf(EmptyHeaders).mdw = forEach;
  protoOf(EmptyParameters).ld = get_2;
  protoOf(EmptyParameters).mdw = forEach;
  defineProp(protoOf(DoubleReceiveException), 'message', function () {
    return this.e();
  });
  defineProp(protoOf(NoTransformationFoundException), 'message', function () {
    return this.e();
  });
  defineProp(protoOf(ClientEngineClosedException), 'cause', function () {
    return this.f();
  });
  protoOf(HttpClientEngineBase).rrh = get_supportedCapabilities;
  protoOf(HttpClientEngineBase).grd = install;
  protoOf(KtorCallContextElement).s9 = get;
  protoOf(KtorCallContextElement).vi = fold;
  protoOf(KtorCallContextElement).ui = minusKey;
  protoOf(KtorCallContextElement).wi = plus;
  defineProp(protoOf(RedirectResponseException), 'message', function () {
    return this.e();
  });
  defineProp(protoOf(ClientRequestException), 'message', function () {
    return this.e();
  });
  defineProp(protoOf(ServerResponseException), 'message', function () {
    return this.e();
  });
  protoOf(HttpRequest$1).ho = get_coroutineContext;
  protoOf(JsWebSocketSession).ve0 = send;
  protoOf($serializer_38).g5k = typeParametersSerializers;
  protoOf($serializer_39).g5k = typeParametersSerializers;
  protoOf($serializer_40).g5k = typeParametersSerializers;
  protoOf($serializer_41).g5k = typeParametersSerializers;
  defineProp(protoOf(Companion_392), '$cachedDescriptor', protoOf(Companion_392).esc);
  protoOf(RemoteFindUsageRequestController).j2l = plus_2;
  protoOf($serializer_43).g5k = typeParametersSerializers;
  protoOf($serializer_44).g5k = typeParametersSerializers;
  protoOf($serializer_45).g5k = typeParametersSerializers;
  protoOf(WebsocketEditorServiceProvider).j2l = plus_2;
  protoOf(JsonService$Companion$toStringPort$1).j2l = plus_2;
  protoOf(JsonServiceEndpoint).j2l = plus_2;
  protoOf(PortExecutingDelegate).j2l = plus_2;
  protoOf(CommandDeserializer).j2l = plus_2;
  protoOf(ServiceEndpointPort).j2l = plus_2;
  protoOf(EndpointMultiplexPort).j2l = plus_2;
  protoOf(MyPort).j2l = plus_2;
  protoOf(ServiceEndpointContainer).j2l = plus_2;
  protoOf(SocketConnection).j2l = plus_2;
  protoOf(ReconnectStrategy).j2l = plus_2;
  protoOf(MyPort_0).j2l = plus_2;
  protoOf(Client$init$validator$1).y3w = reset;
  protoOf(Client$init$listener$1).u3y = onCommandStarted;
  protoOf(Client$init$listener$1).r3y = onOperationPerformed;
  protoOf(Client$init$listener$1).w3y = onExternalOperationStarted;
  protoOf(Client).j2l = plus_2;
  protoOf(ClientRootImpl$load$$inlined$toDisposable$1).j2l = plus_2;
  protoOf(OtServiceEndpoint$MyThrottlingJsonPort$2$wrappedClientPort$1).j2l = plus_2;
  protoOf(CommonJsonPort).j2l = plus_2;
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0_8).j2l = plus_2;
  protoOf(NodeEditorBase).j2l = plus_2;
  protoOf(serializeProjectionalContentKind$1$persister$1).p25 = deserialize;
  protoOf(serializeProjectionalContentKind$1$persister$1).w24 = serialize;
  protoOf(ContentChangeListener).u3y = onCommandStarted;
  protoOf(ContentChangeListener).v3y = onCommandCommitted;
  protoOf(ContentChangeListener).w3y = onExternalOperationStarted;
  protoOf(ContentChangeListener).x3y = onExternalOperationPerformed;
  protoOf(ContentChangeListener).y3y = onExternalOperationFailed;
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0_9).j2l = plus_2;
  defineProp(protoOf(BTBCategoryEventKind), 'name', protoOf(BTBCategoryEventKind).y2);
  defineProp(protoOf(BTBCategoryEventKind), 'ordinal', protoOf(BTBCategoryEventKind).z2);
  protoOf(Notifier$subscribe$$inlined$toDisposable$1).j2l = plus_2;
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0_10).j2l = plus_2;
  protoOf(OtEnvironment).j2l = plus_2;
  defineProp(protoOf(DraftQuerySource), 'descriptor', function () {
    return this.v58();
  });
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0_11).j2l = plus_2;
  defineProp(protoOf(EditedDocumentSource), 'descriptor', function () {
    return this.v58();
  });
  defineProp(protoOf(PrecalculatedResolversDocumentSource), 'descriptor', function () {
    return this.v58();
  });
  defineProp(protoOf(EditedOntologyBrowserSource), 'descriptor', function () {
    return this.v58();
  });
  defineProp(protoOf(EditedWorkingCopySource), 'descriptor', function () {
    return this.v58();
  });
  defineProp(protoOf(ExploredDocumentSource), 'descriptor', function () {
    return this.v58();
  });
  defineProp(protoOf(ExploredOntologyBrowserSource), 'descriptor', function () {
    return this.v58();
  });
  defineProp(protoOf(HistoryPanelDocumentSource), 'descriptor', function () {
    return this.v58();
  });
  defineProp(protoOf(PathEntrySource), 'descriptor', function () {
    return this.v58();
  });
  defineProp(protoOf(PublishedQuerySource), 'descriptor', function () {
    return this.v58();
  });
  defineProp(protoOf(UsageEntrySource), 'descriptor', function () {
    return this.v58();
  });
  protoOf(_no_name_provided__qut3iv_6).kcs = referenceTextProperty$default;
  protoOf(_no_name_provided__qut3iv_8).kcs = referenceTextProperty$default;
  protoOf(_no_name_provided__qut3iv_10).kcs = referenceTextProperty$default;
  protoOf(_no_name_provided__qut3iv_12).kcs = referenceTextProperty$default;
  protoOf(_no_name_provided__qut3iv_14).kcs = referenceTextProperty$default;
  protoOf(_no_name_provided__qut3iv_16).kcs = referenceTextProperty$default;
  protoOf(_no_name_provided__qut3iv_18).kcs = referenceTextProperty$default;
  protoOf(_no_name_provided__qut3iv_20).kcs = referenceTextProperty$default;
  protoOf(_no_name_provided__qut3iv_22).kcs = referenceTextProperty$default;
  protoOf(_no_name_provided__qut3iv_24).kcs = referenceTextProperty$default;
  protoOf(_no_name_provided__qut3iv_26).kcs = referenceTextProperty$default;
  protoOf(_no_name_provided__qut3iv_28).kcs = referenceTextProperty$default;
  protoOf(_no_name_provided__qut3iv_30).kcs = referenceTextProperty$default;
  protoOf(_no_name_provided__qut3iv_32).kcs = referenceTextProperty$default;
  protoOf(_no_name_provided__qut3iv_34).kcs = referenceTextProperty$default;
  protoOf(_no_name_provided__qut3iv_36).kcs = referenceTextProperty$default;
  protoOf(_no_name_provided__qut3iv_38).kcs = referenceTextProperty$default;
  protoOf(_no_name_provided__qut3iv_40).kcs = referenceTextProperty$default;
  protoOf(_no_name_provided__qut3iv_42).kcs = referenceTextProperty$default;
  protoOf(_no_name_provided__qut3iv_44).kcs = referenceTextProperty$default;
  protoOf(_no_name_provided__qut3iv_46).kcs = referenceTextProperty$default;
  protoOf(_no_name_provided__qut3iv_47).r5w = runSuspend;
  protoOf(_no_name_provided__qut3iv_49).kcs = referenceTextProperty$default;
  protoOf(_no_name_provided__qut3iv_51).kcs = referenceTextProperty$default;
  protoOf(_no_name_provided__qut3iv_53).kcs = referenceTextProperty$default;
  protoOf(createBTBEditorConfiguration$1).scq = get_isReadOnly;
  protoOf(createBTBEditorConfiguration$1).nd5 = get_highlightErrors_0;
  protoOf(btbProgramEditors$22$addTraitDeleteRelations$2$$inlined$createDeleteTransformTrait$1$doWork$1).r5w = runSuspend;
  protoOf(btbProgramEditors$46$6$2$6$$inlined$executeQuery$1).r5w = runSuspend;
  protoOf(setExpressionEditor$2$$inlined$executeQuery$1).r5w = runSuspend;
  protoOf(setExpressionEditor$2$$inlined$executeQuery$2).r5w = runSuspend;
  protoOf(propertyReferenceValueEditor$2$5$doAttach$2$$inlined$executeQuery$1).r5w = runSuspend;
  protoOf(measurableValueWithDefaultUnitCompletion$2$$inlined$executeQuery$1).r5w = runSuspend;
  protoOf(QueryLabelDeleteTrait$onKeyPressed$$inlined$executeQuery$1).r5w = runSuspend;
  protoOf(newFactEditors$14$2$ReplaceWithLeftTrait$onKeyPressed$$inlined$executeQuery$1).r5w = runSuspend;
  protoOf(newFactEditors$14$2$ReplaceWithLeftTrait$onKeyPressed$$inlined$executeQuery$2).r5w = runSuspend;
  protoOf(setQueryLabelRightTransform$2$$inlined$executeQuery$1).r5w = runSuspend;
  protoOf(excludingClassExpressionCompletion$$inlined$executeQuery$1).r5w = runSuspend;
  protoOf(processLibraryEditors$14$2$4$$inlined$executeQuery$1).r5w = runSuspend;
  protoOf(processLibraryEditors$14$2$4$2$$inlined$executeQuery$1).r5w = runSuspend;
  protoOf(processLibraryEditors$26$BraceDeleteTrait$onKeyPressed$$inlined$executeQuery$1).r5w = runSuspend;
  protoOf(shouldShowSpecialized$$inlined$query$1).r5w = runSuspend;
  protoOf(queryCommandEditors$34$5$2$2$$inlined$executeQuery$1).r5w = runSuspend;
  protoOf(sam$jetbrains_ocelot_projectional_editor_cell_clipboard_PasteHandler$0_0).fav = plus_4;
  protoOf(FactSetIdManager$pasteHandler$2$1).o38 = plus_3;
  protoOf(FactSetIdManager$pasteHandler$2$1).j2l = plus_2;
  protoOf(getDeleteTransformTrait$$inlined$createDeleteTransformTrait$1$doWork$1).r5w = runSuspend;
  defineProp(protoOf(PagedAdapter), 'current', protoOf(PagedAdapter).z2h);
  protoOf(HtmlNodeEditorView$attach$$inlined$toDisposable$1).j2l = plus_2;
  protoOf(Config_4).jr8 = register$default;
  //endregion
  //region block: init
  Companion_instance_0 = new Companion_0();
  Companion_instance_1 = new Companion_1();
  Companion_instance_2 = new Companion_2();
  ByteCompanionObject_instance = new ByteCompanionObject();
  ShortCompanionObject_instance = new ShortCompanionObject();
  IntCompanionObject_instance = new IntCompanionObject();
  FloatCompanionObject_instance = new FloatCompanionObject();
  DoubleCompanionObject_instance = new DoubleCompanionObject();
  StringCompanionObject_instance = new StringCompanionObject();
  BooleanCompanionObject_instance = new BooleanCompanionObject();
  Unit_instance = new Unit();
  _stableSortingIsSupported = null;
  Companion_instance_4 = new Companion_4();
  CompletedContinuation_instance = new CompletedContinuation();
  DateNowTimeSource_instance = new DateNowTimeSource();
  Companion_instance_6 = new Companion_6();
  Companion_instance_7 = new Companion_7();
  Companion_instance_8 = new Companion_8();
  EmptyList_instance = new EmptyList();
  EmptyIterator_instance = new EmptyIterator();
  EmptyMap_instance = new EmptyMap();
  EmptySequence_instance = new EmptySequence();
  EmptySet_instance = new EmptySet();
  Key_instance = new Key();
  EmptyCoroutineContext_instance = new EmptyCoroutineContext();
  Companion_instance_10 = new Companion_10();
  Companion_instance_13 = new Companion_13();
  Companion_instance_14 = new Companion_14();
  State_instance = new State();
  Monotonic_instance = new Monotonic();
  UNINITIALIZED_VALUE_instance = new UNINITIALIZED_VALUE();
  Companion_instance_17 = new Companion_17();
  Active_instance = new Active();
  Key_instance_1 = new Key_1();
  Key_instance_2 = new Key_2();
  GlobalScope_instance = new GlobalScope();
  Key_instance_3 = new Key_3();
  NonDisposableHandle_instance = new NonDisposableHandle();
  Key_instance_4 = new Key_4();
  EmptyFlow_instance = new EmptyFlow();
  NopCollector_instance = new NopCollector();
  counter = 0;
  DEBUG = false;
  RECOVER_STACK_TRACES = false;
  EnumInfoFactory_instance = new EnumInfoFactory();
  Enums_instance = new Enums();
  RuntimePlatform_instance = new RuntimePlatform();
  BaseJsonReaderSupport_instance = new BaseJsonReaderSupport();
  CommonJsonIterSupport_instance = new CommonJsonIterSupport();
  Companion_instance_28 = new Companion_28();
  JsonStreamIterSupport_instance = new JsonStreamIterSupport();
  CommonJsonStreamIterSupport_instance = new CommonJsonStreamIterSupport();
  Companion_instance_31 = new Companion_31();
  Companion_instance_32 = new Companion_32();
  Present_instance = new Present();
  DirectLoggerFactory_instance = new DirectLoggerFactory();
  DefaultErrorMessageProducer_instance = new DefaultErrorMessageProducer();
  KLoggerNameResolver_instance = new KLoggerNameResolver();
  Companion_instance_34 = new Companion_34();
  Companion_instance_35 = new Companion_35();
  EventSources_instance = new EventSources();
  PropertyBinding_instance = new PropertyBinding();
  Transformers_instance = new Transformers();
  Composites_instance = new Composites();
  Companion_instance_37 = new Companion_37();
  Asyncs_instance = new Asyncs();
  EmptyRunnable_instance = new EmptyRunnable();
  Companion_instance_40 = new Companion_40();
  Companion_instance_41 = new Companion_41();
  Companion_instance_42 = new Companion_42();
  LoggingUtils_instance = new LoggingUtils();
  Companion_instance_44 = new Companion_44();
  Companion_instance_45 = new Companion_45();
  Companion_instance_46 = new Companion_46();
  MessageBundle_instance = new MessageBundle();
  Companion_instance_47 = new Companion_47();
  RawNodeFactory_instance = new RawNodeFactory();
  NodeUtil_instance = new NodeUtil();
  Nodes_instance = new Nodes();
  Companion_instance_52 = new Companion_52();
  EntityPrintOperationUtil_instance = new EntityPrintOperationUtil();
  Companion_instance_53 = new Companion_53();
  OperationBuilder_instance = new OperationBuilder();
  OperationConverter_instance = new OperationConverter();
  RootOperationsExecutorUtil_instance = new RootOperationsExecutorUtil();
  EntityMessages_instance = new EntityMessages();
  ModelBlobMessages_instance = new ModelBlobMessages();
  ModelOperationsExecutorUtil_instance = new ModelOperationsExecutorUtil();
  DestroyOperationTransformer_instance = new DestroyOperationTransformer();
  Companion_instance_54 = new Companion_54();
  PathItemUtil_instance = new PathItemUtil();
  Companion_instance_55 = new Companion_55();
  Companion_instance_56 = new Companion_56();
  Companion_instance_57 = new Companion_57();
  EntityOperationsExecutorUtil_instance = new EntityOperationsExecutorUtil();
  Companion_instance_58 = new Companion_58();
  Companion_instance_59 = new Companion_59();
  Companion_instance_60 = new Companion_60();
  OperationBuilder_instance_0 = new OperationBuilder_0();
  ChildOperationMessages_instance = new ChildOperationMessages();
  Companion_instance_61 = new Companion_61();
  NodeDiff_instance = new NodeDiff();
  Companion_instance_62 = new Companion_62();
  ModelOperationConverter_instance = new ModelOperationConverter();
  NodeOperationsExecutorUtil_instance = new NodeOperationsExecutorUtil();
  Companion_instance_64 = new Companion_64();
  Companion_instance_65 = new Companion_65();
  AssertionUtil_instance = new AssertionUtil();
  Companion_instance_66 = new Companion_66();
  Companion_instance_67 = new Companion_67();
  SplitMergeOperationsUtil_instance = new SplitMergeOperationsUtil();
  Companion_instance_68 = new Companion_68();
  PrintOperationUtil_instance = new PrintOperationUtil();
  EntityIdPersisters_instance = new EntityIdPersisters();
  PrivateEntityIdPersisters_instance = new PrivateEntityIdPersisters();
  Companion_instance_71 = new Companion_71();
  NodeIdPersisters_instance = new NodeIdPersisters();
  PrivateNodeIdPersisters_instance = new PrivateNodeIdPersisters();
  Companion_instance_73 = new Companion_73();
  TextOperationUtil_instance = new TextOperationUtil();
  Companion_instance_74 = new Companion_74();
  UndoUtils_instance = new UndoUtils();
  Companion_instance_75 = new Companion_75();
  WrapperContextService_instance = new WrapperContextService();
  Companion_instance_82 = new Companion_82();
  Companion_instance_83 = new Companion_83();
  Companion_instance_84 = new Companion_84();
  Companion_instance_85 = new Companion_85();
  Tombstone_instance = new Tombstone();
  DefaultNodeStorage_instance = new DefaultNodeStorage();
  Companion_instance_86 = new Companion_86();
  Companion_instance_87 = new Companion_87();
  Companion_instance_88 = new Companion_88();
  EmptyNodeStorage_instance = new EmptyNodeStorage();
  OtNodeFactoryService_instance = new OtNodeFactoryService();
  Companion_instance_90 = new Companion_90();
  OTLinkPersister_instance = new OTLinkPersister();
  Companion_instance_91 = new Companion_91();
  Companion_instance_92 = new Companion_92();
  NodeSetupContextService_instance = new NodeSetupContextService();
  Companion_instance_94 = new Companion_94();
  ErrorNodeFactory_instance = new ErrorNodeFactory();
  UseExperimentalNodeService_instance = new UseExperimentalNodeService();
  Companion_instance_95 = new Companion_95();
  Companion_instance_96 = new Companion_96();
  Empty_instance = new Empty_0();
  Companion_instance_101 = new Companion_101();
  Companion_instance_102 = new Companion_102();
  ReferenceFactoryRegistryAspect_instance = new ReferenceFactoryRegistryAspect();
  ReferenceTargetPresentationProvidersRegistryAspect_instance = new ReferenceTargetPresentationProvidersRegistryAspect();
  ReferenceTargetsSuppliersRegistryAspect_instance = new ReferenceTargetsSuppliersRegistryAspect();
  ResolveConfigService_instance = new ResolveConfigService();
  Companion_instance_103 = new Companion_103();
  Companion_instance_104 = new Companion_104();
  Companion_instance_106 = new Companion_106();
  Companion_instance_107 = new Companion_107();
  Companion_instance_109 = new Companion_109();
  Companion_instance_110 = new Companion_110();
  Companion_instance_112 = new Companion_112();
  Companion_instance_113 = new Companion_113();
  Companion_instance_114 = new Companion_114();
  Companion_instance_115 = new Companion_115();
  StructureAspect_instance = new StructureAspect();
  ConceptRegistryService_instance = new ConceptRegistryService();
  Companion_instance_116 = new Companion_116();
  Companion_instance_118 = new Companion_118();
  Empty_instance_0 = new Empty_1();
  EmptyErrorCheckConfig_instance = new EmptyErrorCheckConfig();
  NoopScopeFilter_instance = new NoopScopeFilter();
  Companion_instance_120 = new Companion_120();
  ScopeAspect_instance = new ScopeAspect();
  Companion_instance_122 = new Companion_122();
  ScopeConfigService_instance = new ScopeConfigService();
  Companion_instance_123 = new Companion_123();
  Empty_instance_1 = new Empty_2();
  Companion_instance_125 = new Companion_125();
  AbsentScopeOwner_instance = new AbsentScopeOwner();
  Companion_instance_129 = new Companion_129();
  FindUsagesAspect_instance = new FindUsagesAspect();
  FindUsagesConfigService_instance = new FindUsagesConfigService();
  Mappers_instance = new Mappers();
  Synchronizers_instance = new Synchronizers();
  Companion_instance_133 = new Companion_133();
  Rectangles_instance = new Rectangles();
  DomUtil_instance = new DomUtil();
  Companion_instance_137 = new Companion_137();
  Companion_instance_138 = new Companion_138();
  DomApi_instance = new DomApi();
  EmptyClipboardContent_instance = new EmptyClipboardContent();
  Companion_instance_141 = new Companion_141();
  Companion_instance_142 = new Companion_142();
  DomEventUtil_instance = new DomEventUtil();
  KeyEventUtil_instance = new KeyEventUtil();
  Companion_instance_143 = new Companion_143();
  Companion_instance_144 = new Companion_144();
  TextClipboardSerialization_instance = new TextClipboardSerialization();
  JsSystemClipboard_instance = new JsSystemClipboard();
  ListImplementation_instance = new ListImplementation();
  Companion_instance_146 = new Companion_146();
  Companion_instance_147 = new Companion_147();
  Companion_instance_148 = new Companion_148();
  Companion_instance_149 = new Companion_149();
  Companion_instance_157 = new Companion_157();
  Companion_instance_161 = new Companion_161();
  Companion_instance_163 = new Companion_163();
  CompletionSupplement_instance = new CompletionSupplement();
  Companion_instance_165 = new Companion_165();
  Companion_instance_169 = new Companion_169();
  AncestorUtil_instance = new AncestorUtil();
  CellMapperUtils_instance = new CellMapperUtils();
  IndentUtil_instance = new IndentUtil();
  Companion_instance_175 = new Companion_175();
  Companion_instance_180 = new Companion_180();
  Positions_instance = new Positions();
  TextEditorUtil_instance = new TextEditorUtil();
  CellTraits_instance = new CellTraits();
  CompositeCellTraits_instance = new CompositeCellTraits();
  CellFactory_instance = new CellFactory();
  CellLists_instance = new CellLists();
  Companion_instance_188 = new Companion_188();
  Companion_instance_194 = new Companion_194();
  ScrollingUtil_instance = new ScrollingUtil();
  Companion_instance_195 = new Companion_195();
  ValueEditors_instance = new ValueEditors();
  HighlightUtil_instance = new HighlightUtil();
  MatchingConstructs_instance = new MatchingConstructs();
  PairUtil_instance = new PairUtil();
  Companion_instance_199 = new Companion_199();
  RootController_instance = new RootController();
  Companion_instance_200 = new Companion_200();
  ReadOnlyProjectionalSynchronizers_instance = new ReadOnlyProjectionalSynchronizers();
  Companion_instance_203 = new Companion_203();
  Companion_instance_205 = new Companion_205();
  SelectionSupports_instance = new SelectionSupports();
  Companion_instance_209 = new Companion_209();
  Companion_instance_212 = new Companion_212();
  ExternalPasteContent_instance = new ExternalPasteContent();
  AlignmentSynchronizers_instance = new AlignmentSynchronizers();
  Companion_instance_221 = new Companion_221();
  Companion_instance_223 = new Companion_223();
  CellMappers_instance = new CellMappers();
  Companion_instance_224 = new Companion_224();
  Companion_instance_225 = new Companion_225();
  HiddenTextAreaHelper_instance = new HiddenTextAreaHelper();
  Companion_instance_226 = new Companion_226();
  Companion_instance_228 = new Companion_228();
  Companion_instance_229 = new Companion_229();
  Tooltip_instance = new Tooltip();
  Scrolling_instance = new Scrolling();
  DomViewSynchronizers_instance = new DomViewSynchronizers();
  Companion_instance_231 = new Companion_231();
  SvgUtil_instance = new SvgUtil();
  ViewMapperFactory_instance = new ViewMapperFactory();
  ViewToDom_instance = new ViewToDom();
  Companion_instance_233 = new Companion_233();
  ErrorHighlightingController_instance = new ErrorHighlightingController();
  Companion_instance_240 = new Companion_240();
  NodeContentKind_instance = new NodeContentKind();
  Companion_instance_245 = new Companion_245();
  Companion_instance_248 = new Companion_248();
  Companion_instance_250 = new Companion_250();
  ReferenceSynchronizers_instance = new ReferenceSynchronizers();
  JSLogger_instance = new JSLogger();
  Companion_instance_252 = new Companion_252();
  Companion_instance_253 = new Companion_253();
  Companion_instance_255 = new Companion_255();
  DefaultAllocator_instance = new DefaultAllocator();
  Companion_instance_259 = new Companion_259();
  PACKET_MAX_COPY_SIZE = 200;
  Companion_instance_261 = new Companion_261();
  Companion_instance_262 = new Companion_262();
  DISABLE_SFG = false;
  JsType_instance = new JsType();
  NonDisposableHandle_instance_0 = new NonDisposableHandle_0();
  Companion_instance_269 = new Companion_269();
  Companion_instance_271 = new Companion_271();
  Companion_instance_272 = new Companion_272();
  Companion_instance_277 = new Companion_277();
  Companion_instance_278 = new Companion_278();
  Companion_instance_287 = new Companion_287();
  Companion_instance_288 = new Companion_288();
  Companion_instance_292 = new Companion_292();
  Companion_instance_295 = new Companion_295();
  Companion_instance_296 = new Companion_296();
  Companion_instance_299 = new Companion_299();
  Empty_instance_2 = new Empty_3();
  Companion_instance_303 = new Companion_303();
  Companion_instance_307 = new Companion_307();
  Companion_instance_309 = new Companion_309();
  Companion_instance_310 = new Companion_310();
  GeneratedBioKbStuff_instance = new GeneratedBioKbStuff();
  Companion_instance_334 = new Companion_334();
  Companion_instance_356 = new Companion_356();
  ImplicitOne_instance = new ImplicitOne();
  Unknown_instance = new Unknown();
  Companion_instance_357 = new Companion_357();
  Companion_instance_365 = new Companion_365();
  Companion_instance_366 = new Companion_366();
  Unknown_instance_0 = new Unknown_0();
  None_instance_0 = new None_0();
  DomainFactExpressionAdapterContext_instance = new DomainFactExpressionAdapterContext();
  ValueDescriptorOperations_instance = new ValueDescriptorOperations();
  Companion_instance_371 = new Companion_371();
  Companion_instance_372 = new Companion_372();
  Companion_instance_374 = new Companion_374();
  EmptyHeaders_instance = new EmptyHeaders();
  EmptyParameters_instance = new EmptyParameters();
  Companion_instance_382 = new Companion_382();
  NullBody_instance = new NullBody();
  Companion_instance_384 = new Companion_384();
  WebSocketExtensionsCapability_instance = new WebSocketExtensionsCapability();
  WebSocketCapability_instance = new WebSocketCapability();
  Companion_instance_387 = new Companion_387();
  Js_instance = new Js();
  Companion_instance_388 = new Companion_388();
  Companion_instance_389 = new Companion_389();
  Companion_instance_391 = new Companion_391();
  Companion_instance_393 = new Companion_393();
  Companion_instance_396 = new Companion_396();
  Companion_instance_397 = new Companion_397();
  Companion_instance_399 = new Companion_399();
  Companion_instance_400 = new Companion_400();
  Companion_instance_401 = new Companion_401();
  Companion_instance_402 = new Companion_402();
  RootOperationsUtil_instance = new RootOperationsUtil();
  Companion_instance_404 = new Companion_404();
  Companion_instance_405 = new Companion_405();
  Companion_instance_406 = new Companion_406();
  PingPongServiceConstants_instance = new PingPongServiceConstants();
  ServiceContainerConstants_instance = new ServiceContainerConstants();
  ServiceContainerMessageUtil_instance = new ServiceContainerMessageUtil();
  Companion_instance_413 = new Companion_413();
  Companion_instance_423 = new Companion_423();
  JsonContentTypeMatcher_instance = new JsonContentTypeMatcher();
  ApiGateway_instance = new ApiGateway();
  //endregion
  //region block: eager init
  initializer = SerializerInitializer_getInstance();
  //endregion
  //region block: exports
  function $jsExportAll$(_) {
    var $kotlin = _.kotlin || (_.kotlin = {});
    var $kotlin$collections = $kotlin.collections || ($kotlin.collections = {});
    defineProp($kotlin$collections, 'KtList', Companion_getInstance_0, VOID, true);
    var $jetbrains = _.jetbrains || (_.jetbrains = {});
    var $jetbrains$ocelot = $jetbrains.ocelot || ($jetbrains.ocelot = {});
    var $jetbrains$ocelot$langDef = $jetbrains$ocelot.langDef || ($jetbrains$ocelot.langDef = {});
    var $jetbrains$ocelot$langDef$model = $jetbrains$ocelot$langDef.model || ($jetbrains$ocelot$langDef.model = {});
    $jetbrains$ocelot$langDef$model.NodePointer = NodePointer;
    $jetbrains$ocelot$langDef$model.NodePointer.NodePointerConstructor = NodePointerConstructor;
    defineProp($jetbrains$ocelot$langDef$model.NodePointer, 'Companion', Companion_getInstance_86, VOID, true);
    var $jetbrains = _.jetbrains || (_.jetbrains = {});
    var $jetbrains$ocelot = $jetbrains.ocelot || ($jetbrains.ocelot = {});
    var $jetbrains$ocelot$langDef = $jetbrains$ocelot.langDef || ($jetbrains$ocelot.langDef = {});
    var $jetbrains$ocelot$langDef$model = $jetbrains$ocelot$langDef.model || ($jetbrains$ocelot$langDef.model = {});
    $jetbrains$ocelot$langDef$model.SerializedNode = SerializedNode;
    defineProp($jetbrains$ocelot$langDef$model.SerializedNode, 'Companion', Companion_getInstance_90, VOID, true);
    var $jetbrains = _.jetbrains || (_.jetbrains = {});
    var $jetbrains$ocelot = $jetbrains.ocelot || ($jetbrains.ocelot = {});
    var $jetbrains$ocelot$langDef = $jetbrains$ocelot.langDef || ($jetbrains$ocelot.langDef = {});
    var $jetbrains$ocelot$langDef$references = $jetbrains$ocelot$langDef.references || ($jetbrains$ocelot$langDef.references = {});
    var $jetbrains$ocelot$langDef$references$remote = $jetbrains$ocelot$langDef$references.remote || ($jetbrains$ocelot$langDef$references.remote = {});
    var $jetbrains$ocelot$langDef$references$remote$precalculated = $jetbrains$ocelot$langDef$references$remote.precalculated || ($jetbrains$ocelot$langDef$references$remote.precalculated = {});
    $jetbrains$ocelot$langDef$references$remote$precalculated.SerializedResolvedNode = SerializedResolvedNode;
    defineProp($jetbrains$ocelot$langDef$references$remote$precalculated.SerializedResolvedNode, 'Companion', Companion_getInstance_303, VOID, true);
    var $jetbrains = _.jetbrains || (_.jetbrains = {});
    var $jetbrains$biokb = $jetbrains.biokb || ($jetbrains.biokb = {});
    var $jetbrains$biokb$findUsages = $jetbrains$biokb.findUsages || ($jetbrains$biokb.findUsages = {});
    $jetbrains$biokb$findUsages.UsageDto = UsageDto;
    defineProp($jetbrains$biokb$findUsages.UsageDto, 'Companion', Companion_getInstance_371, VOID, true);
    var $jetbrains = _.jetbrains || (_.jetbrains = {});
    var $jetbrains$biokb = $jetbrains.biokb || ($jetbrains.biokb = {});
    var $jetbrains$biokb$editor = $jetbrains$biokb.editor || ($jetbrains$biokb.editor = {});
    var $jetbrains$biokb$editor$service = $jetbrains$biokb$editor.service || ($jetbrains$biokb$editor.service = {});
    var $jetbrains$biokb$editor$service$findUsages = $jetbrains$biokb$editor$service.findUsages || ($jetbrains$biokb$editor$service.findUsages = {});
    $jetbrains$biokb$editor$service$findUsages.UsageEntryDocumentDto = UsageEntryDocumentDto;
    defineProp($jetbrains$biokb$editor$service$findUsages.UsageEntryDocumentDto, 'Companion', Companion_getInstance_388, VOID, true);
    $jetbrains$biokb$editor$service$findUsages.FindUsageServiceRequest = FindUsageServiceRequest;
    defineProp($jetbrains$biokb$editor$service$findUsages.FindUsageServiceRequest, 'Companion', Companion_getInstance_389, VOID, true);
    $jetbrains$biokb$editor$service$findUsages.FindUsageDocumentInfo = FindUsageDocumentInfo;
    defineProp($jetbrains$biokb$editor$service$findUsages.FindUsageDocumentInfo, 'Companion', Companion_getInstance_390, VOID, true);
    var $jetbrains = _.jetbrains || (_.jetbrains = {});
    var $jetbrains$biokb = $jetbrains.biokb || ($jetbrains.biokb = {});
    var $jetbrains$biokb$editor = $jetbrains$biokb.editor || ($jetbrains$biokb.editor = {});
    var $jetbrains$biokb$editor$service = $jetbrains$biokb$editor.service || ($jetbrains$biokb$editor.service = {});
    var $jetbrains$biokb$editor$service$findUsages = $jetbrains$biokb$editor$service.findUsages || ($jetbrains$biokb$editor$service.findUsages = {});
    $jetbrains$biokb$editor$service$findUsages.FindUsagePageEntry = FindUsagePageEntry;
    var $jetbrains = _.jetbrains || (_.jetbrains = {});
    var $jetbrains$biokb = $jetbrains.biokb || ($jetbrains.biokb = {});
    var $jetbrains$biokb$editor = $jetbrains$biokb.editor || ($jetbrains$biokb.editor = {});
    var $jetbrains$biokb$editor$service = $jetbrains$biokb$editor.service || ($jetbrains$biokb$editor.service = {});
    var $jetbrains$biokb$editor$service$findUsages = $jetbrains$biokb$editor$service.findUsages || ($jetbrains$biokb$editor$service.findUsages = {});
    $jetbrains$biokb$editor$service$findUsages.FindUsageResultsPaged = FindUsageResultsPaged;
    var $jetbrains = _.jetbrains || (_.jetbrains = {});
    var $jetbrains$biokb = $jetbrains.biokb || ($jetbrains.biokb = {});
    var $jetbrains$biokb$editor = $jetbrains$biokb.editor || ($jetbrains$biokb.editor = {});
    var $jetbrains$biokb$editor$service = $jetbrains$biokb$editor.service || ($jetbrains$biokb$editor.service = {});
    var $jetbrains$biokb$editor$service$findUsages = $jetbrains$biokb$editor$service.findUsages || ($jetbrains$biokb$editor$service.findUsages = {});
    $jetbrains$biokb$editor$service$findUsages.Page = Page_2;
    defineProp($jetbrains$biokb$editor$service$findUsages.Page, 'Companion', Companion_getInstance_392, VOID, true);
    var $jetbrains = _.jetbrains || (_.jetbrains = {});
    var $jetbrains$biokb = $jetbrains.biokb || ($jetbrains.biokb = {});
    var $jetbrains$biokb$editor = $jetbrains$biokb.editor || ($jetbrains$biokb.editor = {});
    $jetbrains$biokb$editor.NodeEditorPart = NodeEditorPart;
    var $jetbrains = _.jetbrains || (_.jetbrains = {});
    var $jetbrains$biokb = $jetbrains.biokb || ($jetbrains.biokb = {});
    var $jetbrains$biokb$editor = $jetbrains$biokb.editor || ($jetbrains$biokb.editor = {});
    var $jetbrains$biokb$editor$event = $jetbrains$biokb$editor.event || ($jetbrains$biokb$editor.event = {});
    $jetbrains$biokb$editor$event.EventType = EventType_0;
    $jetbrains$biokb$editor$event.Event = Event_1;
    $jetbrains$biokb$editor$event.NodePointerEvent = NodePointerEvent;
    $jetbrains$biokb$editor$event.FindUsagesEvent = FindUsagesEvent;
    $jetbrains$biokb$editor$event.CategoryInfo = CategoryInfo;
    $jetbrains$biokb$editor$event.BTBCategoryEvent = BTBCategoryEvent;
    $jetbrains$biokb$editor$event.FactSelectionEvent = FactSelectionEvent;
    $jetbrains$biokb$editor$event.ErrorEvent = ErrorEvent;
    $jetbrains$biokb$editor$event.BTBCategoryEventKind = BTBCategoryEventKind;
    $jetbrains$biokb$editor$event.BTBCategoryEventKind.values = values_20;
    $jetbrains$biokb$editor$event.BTBCategoryEventKind.valueOf = valueOf;
    defineProp($jetbrains$biokb$editor$event.BTBCategoryEventKind, 'ADD', BTBCategoryEventKind_ADD_getInstance, VOID, true);
    defineProp($jetbrains$biokb$editor$event.BTBCategoryEventKind, 'REMOVE', BTBCategoryEventKind_REMOVE_getInstance, VOID, true);
    var $jetbrains = _.jetbrains || (_.jetbrains = {});
    var $jetbrains$biokb = $jetbrains.biokb || ($jetbrains.biokb = {});
    var $jetbrains$biokb$editor = $jetbrains$biokb.editor || ($jetbrains$biokb.editor = {});
    var $jetbrains$biokb$editor$sources = $jetbrains$biokb$editor.sources || ($jetbrains$biokb$editor.sources = {});
    var $jetbrains = _.jetbrains || (_.jetbrains = {});
    var $jetbrains$biokb = $jetbrains.biokb || ($jetbrains.biokb = {});
    var $jetbrains$biokb$editor = $jetbrains$biokb.editor || ($jetbrains$biokb.editor = {});
    var $jetbrains$biokb$editor$sources = $jetbrains$biokb$editor.sources || ($jetbrains$biokb$editor.sources = {});
    $jetbrains$biokb$editor$sources.DocumentSourceDescriptor = DocumentSourceDescriptor;
    var $jetbrains = _.jetbrains || (_.jetbrains = {});
    var $jetbrains$biokb = $jetbrains.biokb || ($jetbrains.biokb = {});
    var $jetbrains$biokb$editor = $jetbrains$biokb.editor || ($jetbrains$biokb.editor = {});
    $jetbrains$biokb$editor.FindUsagePageEntryAdapter = FindUsagePageEntryAdapter;
    var $jetbrains = _.jetbrains || (_.jetbrains = {});
    var $jetbrains$biokb = $jetbrains.biokb || ($jetbrains.biokb = {});
    var $jetbrains$biokb$editor = $jetbrains$biokb.editor || ($jetbrains$biokb.editor = {});
    $jetbrains$biokb$editor.FindUsagePagedAdapter = FindUsagePagedAdapter;
    var $jetbrains = _.jetbrains || (_.jetbrains = {});
    var $jetbrains$biokb = $jetbrains.biokb || ($jetbrains.biokb = {});
    var $jetbrains$biokb$editor = $jetbrains$biokb.editor || ($jetbrains$biokb.editor = {});
    $jetbrains$biokb$editor.NodeEditorAdapter = NodeEditorAdapter;
    var $jetbrains = _.jetbrains || (_.jetbrains = {});
    var $jetbrains$biokb = $jetbrains.biokb || ($jetbrains.biokb = {});
    var $jetbrains$biokb$editor = $jetbrains$biokb.editor || ($jetbrains$biokb.editor = {});
    $jetbrains$biokb$editor.PageAdapter = PageAdapter;
    var $jetbrains = _.jetbrains || (_.jetbrains = {});
    var $jetbrains$biokb = $jetbrains.biokb || ($jetbrains.biokb = {});
    var $jetbrains$biokb$editor = $jetbrains$biokb.editor || ($jetbrains$biokb.editor = {});
    $jetbrains$biokb$editor.PagedAdapter = PagedAdapter;
    defineProp(_, 'ApiGateway', ApiGateway_getInstance, VOID, true);
    defineProp(_, 'EditorEnvironment', EditorEnvironment_getInstance, VOID, true);
    _.findUsages = findUsages_0;
    _.createEditor = createEditor_0;
    _.editedDocumentSource = editedDocumentSource;
    _.editedWorkingCopySource = editedWorkingCopySource;
    _.editedOntologyBrowserSource = editedOntologyBrowserSource;
    _.exploredDocumentSource = exploredDocumentSource;
    _.exploredOntologyBrowserSource = exploredOntologyBrowserSource;
    _.historyPanelDocumentSource = historyPanelDocumentSource;
    _.publishedQuerySource = publishedQuerySource;
    _.draftQuerySource = draftQuerySource;
    _.getHtmlForUsageJSON = getHtmlForUsageJSON;
    _.getHtmlForUsage = getHtmlForUsage;
    _.getHtmlForResolvedNode = getHtmlForResolvedNode;
    _.getHtmlForResolvedNodeJSON = getHtmlForResolvedNodeJSON;
    _.getNodeIdOfResolvedNode = getNodeIdOfResolvedNode;
    _.createNode = createNode;
    _.emptyDocJson = emptyDocJson;
    _.getFileContents = getFileContents;
    defineProp(_, 'EditorEvents', EditorEvents_getInstance, VOID, true);
  }
  $jsExportAll$(_);
  //endregion
  return _;
}));

//# sourceMappingURL=biokb-webeditor-editor-adapters.js.map
